/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 755);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(761);
} else {
  module.exports = require('./cjs/react.development.js');
}


/***/ }),
/* 1 */
/***/ (function(module, exports) {

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

module.exports = _interopRequireDefault;

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _pure = _interopRequireDefault(__webpack_require__(52));

var _SvgIcon = _interopRequireDefault(__webpack_require__(47));

function createSvgIcon(path, displayName) {
  var Icon = function Icon(props) {
    return _react.default.createElement(_SvgIcon.default, props, path);
  };

  Icon.displayName = displayName;
  Icon = (0, _pure.default)(Icon);
  Icon.muiName = 'SvgIcon';
  return Icon;
}

;
var _default = createSvgIcon;
exports.default = _default;

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(772)();
}


/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(832);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__colors__);
/* unused harmony reexport colors */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles__ = __webpack_require__(469);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__styles__);
/* unused harmony reexport createGenerateClassName */
/* harmony reexport (binding) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_1__styles__, "createMuiTheme")) __webpack_require__.d(__webpack_exports__, "_0", function() { return __WEBPACK_IMPORTED_MODULE_1__styles__["createMuiTheme"]; });
/* unused harmony reexport createStyles */
/* unused harmony reexport jssPreset */
/* harmony reexport (binding) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_1__styles__, "MuiThemeProvider")) __webpack_require__.d(__webpack_exports__, "H", function() { return __WEBPACK_IMPORTED_MODULE_1__styles__["MuiThemeProvider"]; });
/* harmony reexport (binding) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_1__styles__, "withStyles")) __webpack_require__.d(__webpack_exports__, "_1", function() { return __WEBPACK_IMPORTED_MODULE_1__styles__["withStyles"]; });
/* unused harmony reexport withTheme */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AppBar__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AppBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__AppBar__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__AppBar___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Avatar__ = __webpack_require__(853);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Avatar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Avatar__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_3__Avatar___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Backdrop__ = __webpack_require__(471);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Backdrop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Backdrop__);
/* unused harmony reexport Backdrop */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Badge__ = __webpack_require__(857);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Badge___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__Badge__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_5__Badge___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__BottomNavigation__ = __webpack_require__(859);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__BottomNavigation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__BottomNavigation__);
/* unused harmony reexport BottomNavigation */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__BottomNavigationAction__ = __webpack_require__(861);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__BottomNavigationAction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__BottomNavigationAction__);
/* unused harmony reexport BottomNavigationAction */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Button__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__Button__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_8__Button___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ButtonBase__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ButtonBase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__ButtonBase__);
/* unused harmony reexport ButtonBase */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Card__ = __webpack_require__(874);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__Card__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_10__Card___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__CardActions__ = __webpack_require__(876);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__CardActions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__CardActions__);
/* unused harmony reexport CardActions */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__CardContent__ = __webpack_require__(878);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__CardContent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__CardContent__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_12__CardContent___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__CardHeader__ = __webpack_require__(880);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__CardHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__CardHeader__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_13__CardHeader___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__CardMedia__ = __webpack_require__(883);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__CardMedia___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__CardMedia__);
/* unused harmony reexport CardMedia */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Checkbox__ = __webpack_require__(885);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__Checkbox__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_15__Checkbox___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Chip__ = __webpack_require__(933);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Chip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__Chip__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_16__Chip___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__CircularProgress__ = __webpack_require__(484);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__CircularProgress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__CircularProgress__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_17__CircularProgress___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__ClickAwayListener__ = __webpack_require__(485);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__ClickAwayListener___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__ClickAwayListener__);
/* unused harmony reexport ClickAwayListener */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__Collapse__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__Collapse___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__Collapse__);
/* unused harmony reexport Collapse */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__CssBaseline__ = __webpack_require__(949);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__CssBaseline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__CssBaseline__);
/* unused harmony reexport CssBaseline */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__Dialog__ = __webpack_require__(951);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__Dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__Dialog__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_21__Dialog___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__DialogActions__ = __webpack_require__(966);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__DialogActions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__DialogActions__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_22__DialogActions___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__DialogContent__ = __webpack_require__(968);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__DialogContent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__DialogContent__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_23__DialogContent___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__DialogContentText__ = __webpack_require__(970);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__DialogContentText___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__DialogContentText__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_24__DialogContentText___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__DialogTitle__ = __webpack_require__(972);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__DialogTitle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__DialogTitle__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_25__DialogTitle___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__Divider__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__Divider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__Divider__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "p", function() { return __WEBPACK_IMPORTED_MODULE_26__Divider___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__Drawer__ = __webpack_require__(492);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__Drawer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__Drawer__);
/* unused harmony reexport Drawer */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__ExpansionPanel__ = __webpack_require__(976);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__ExpansionPanel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__ExpansionPanel__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "q", function() { return __WEBPACK_IMPORTED_MODULE_28__ExpansionPanel___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__ExpansionPanelActions__ = __webpack_require__(978);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__ExpansionPanelActions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29__ExpansionPanelActions__);
/* unused harmony reexport ExpansionPanelActions */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__ExpansionPanelDetails__ = __webpack_require__(980);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__ExpansionPanelDetails___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30__ExpansionPanelDetails__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "r", function() { return __WEBPACK_IMPORTED_MODULE_30__ExpansionPanelDetails___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__ExpansionPanelSummary__ = __webpack_require__(982);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__ExpansionPanelSummary___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31__ExpansionPanelSummary__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "s", function() { return __WEBPACK_IMPORTED_MODULE_31__ExpansionPanelSummary___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__Fade__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__Fade___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32__Fade__);
/* unused harmony reexport Fade */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__FormControl__ = __webpack_require__(493);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__FormControl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33__FormControl__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "t", function() { return __WEBPACK_IMPORTED_MODULE_33__FormControl___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__FormControlLabel__ = __webpack_require__(986);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__FormControlLabel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34__FormControlLabel__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "u", function() { return __WEBPACK_IMPORTED_MODULE_34__FormControlLabel___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__FormGroup__ = __webpack_require__(494);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__FormGroup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_35__FormGroup__);
/* unused harmony reexport FormGroup */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__FormHelperText__ = __webpack_require__(495);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__FormHelperText___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_36__FormHelperText__);
/* unused harmony reexport FormHelperText */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__FormLabel__ = __webpack_require__(496);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__FormLabel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_37__FormLabel__);
/* unused harmony reexport FormLabel */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__Grid__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_38__Grid__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "v", function() { return __WEBPACK_IMPORTED_MODULE_38__Grid___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__GridList__ = __webpack_require__(993);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__GridList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_39__GridList__);
/* unused harmony reexport GridList */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__GridListTile__ = __webpack_require__(995);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__GridListTile___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_40__GridListTile__);
/* unused harmony reexport GridListTile */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__GridListTileBar__ = __webpack_require__(997);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__GridListTileBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_41__GridListTileBar__);
/* unused harmony reexport GridListTileBar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__Grow__ = __webpack_require__(497);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__Grow___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_42__Grow__);
/* unused harmony reexport Grow */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__Hidden__ = __webpack_require__(327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__Hidden___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_43__Hidden__);
/* unused harmony reexport Hidden */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__Icon__ = __webpack_require__(1004);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__Icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_44__Icon__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "w", function() { return __WEBPACK_IMPORTED_MODULE_44__Icon___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__IconButton__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__IconButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_45__IconButton__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "x", function() { return __WEBPACK_IMPORTED_MODULE_45__IconButton___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__Input__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__Input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_46__Input__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "y", function() { return __WEBPACK_IMPORTED_MODULE_46__Input___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__InputAdornment__ = __webpack_require__(1006);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__InputAdornment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_47__InputAdornment__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "z", function() { return __WEBPACK_IMPORTED_MODULE_47__InputAdornment___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__InputLabel__ = __webpack_require__(498);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__InputLabel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_48__InputLabel__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "A", function() { return __WEBPACK_IMPORTED_MODULE_48__InputLabel___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__LinearProgress__ = __webpack_require__(499);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__LinearProgress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_49__LinearProgress__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "B", function() { return __WEBPACK_IMPORTED_MODULE_49__LinearProgress___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__List__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__List___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_50__List__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "C", function() { return __WEBPACK_IMPORTED_MODULE_50__List___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__ListItem__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__ListItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_51__ListItem__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "D", function() { return __WEBPACK_IMPORTED_MODULE_51__ListItem___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__ListItemAvatar__ = __webpack_require__(1012);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__ListItemAvatar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_52__ListItemAvatar__);
/* unused harmony reexport ListItemAvatar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__ListItemIcon__ = __webpack_require__(500);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__ListItemIcon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_53__ListItemIcon__);
/* unused harmony reexport ListItemIcon */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__ListItemSecondaryAction__ = __webpack_require__(1015);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__ListItemSecondaryAction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_54__ListItemSecondaryAction__);
/* unused harmony reexport ListItemSecondaryAction */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__ListItemText__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__ListItemText___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_55__ListItemText__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "E", function() { return __WEBPACK_IMPORTED_MODULE_55__ListItemText___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__ListSubheader__ = __webpack_require__(1018);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__ListSubheader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_56__ListSubheader__);
/* unused harmony reexport ListSubheader */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__Menu__ = __webpack_require__(1020);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__Menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_57__Menu__);
/* unused harmony reexport Menu */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__MenuItem__ = __webpack_require__(504);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__MenuItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_58__MenuItem__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "F", function() { return __WEBPACK_IMPORTED_MODULE_58__MenuItem___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__MenuList__ = __webpack_require__(503);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__MenuList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_59__MenuList__);
/* unused harmony reexport MenuList */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60__MobileStepper__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60__MobileStepper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_60__MobileStepper__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "G", function() { return __WEBPACK_IMPORTED_MODULE_60__MobileStepper___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61__Modal__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61__Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_61__Modal__);
/* unused harmony reexport Modal */
/* unused harmony reexport ModalManager */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62__NativeSelect__ = __webpack_require__(1025);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62__NativeSelect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_62__NativeSelect__);
/* unused harmony reexport NativeSelect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63__Paper__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63__Paper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_63__Paper__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "I", function() { return __WEBPACK_IMPORTED_MODULE_63__Paper___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64__Popover__ = __webpack_require__(502);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64__Popover___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_64__Popover__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "J", function() { return __WEBPACK_IMPORTED_MODULE_64__Popover___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65__Portal__ = __webpack_require__(322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65__Portal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_65__Portal__);
/* unused harmony reexport Portal */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66__Radio__ = __webpack_require__(1026);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66__Radio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_66__Radio__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "K", function() { return __WEBPACK_IMPORTED_MODULE_66__Radio___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67__RadioGroup__ = __webpack_require__(1030);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67__RadioGroup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_67__RadioGroup__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "L", function() { return __WEBPACK_IMPORTED_MODULE_67__RadioGroup___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68__Select__ = __webpack_require__(329);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68__Select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_68__Select__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "M", function() { return __WEBPACK_IMPORTED_MODULE_68__Select___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69__Slide__ = __webpack_require__(325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69__Slide___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_69__Slide__);
/* unused harmony reexport Slide */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_70__Snackbar__ = __webpack_require__(508);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_70__Snackbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_70__Snackbar__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "N", function() { return __WEBPACK_IMPORTED_MODULE_70__Snackbar___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_71__SnackbarContent__ = __webpack_require__(509);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_71__SnackbarContent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_71__SnackbarContent__);
/* unused harmony reexport SnackbarContent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_72__Step__ = __webpack_require__(1036);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_72__Step___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_72__Step__);
/* unused harmony reexport Step */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_73__StepButton__ = __webpack_require__(1038);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_73__StepButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_73__StepButton__);
/* unused harmony reexport StepButton */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_74__StepConnector__ = __webpack_require__(512);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_74__StepConnector___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_74__StepConnector__);
/* unused harmony reexport StepConnector */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_75__StepContent__ = __webpack_require__(1046);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_75__StepContent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_75__StepContent__);
/* unused harmony reexport StepContent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_76__StepIcon__ = __webpack_require__(511);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_76__StepIcon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_76__StepIcon__);
/* unused harmony reexport StepIcon */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_77__StepLabel__ = __webpack_require__(510);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_77__StepLabel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_77__StepLabel__);
/* unused harmony reexport StepLabel */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_78__Stepper__ = __webpack_require__(1048);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_78__Stepper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_78__Stepper__);
/* unused harmony reexport Stepper */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_79__SvgIcon__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_79__SvgIcon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_79__SvgIcon__);
/* unused harmony reexport SvgIcon */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_80__SwipeableDrawer__ = __webpack_require__(1050);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_80__SwipeableDrawer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_80__SwipeableDrawer__);
/* unused harmony reexport SwipeableDrawer */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_81__Switch__ = __webpack_require__(1053);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_81__Switch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_81__Switch__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "O", function() { return __WEBPACK_IMPORTED_MODULE_81__Switch___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_82__Table__ = __webpack_require__(1055);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_82__Table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_82__Table__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return __WEBPACK_IMPORTED_MODULE_82__Table___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_83__TableBody__ = __webpack_require__(1057);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_83__TableBody___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_83__TableBody__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "R", function() { return __WEBPACK_IMPORTED_MODULE_83__TableBody___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_84__TableCell__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_84__TableCell___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_84__TableCell__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "S", function() { return __WEBPACK_IMPORTED_MODULE_84__TableCell___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_85__TableFooter__ = __webpack_require__(1060);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_85__TableFooter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_85__TableFooter__);
/* unused harmony reexport TableFooter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_86__TableHead__ = __webpack_require__(330);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_86__TableHead___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_86__TableHead__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "T", function() { return __WEBPACK_IMPORTED_MODULE_86__TableHead___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_87__TablePagination__ = __webpack_require__(1063);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_87__TablePagination___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_87__TablePagination__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "U", function() { return __WEBPACK_IMPORTED_MODULE_87__TablePagination___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_88__TableRow__ = __webpack_require__(332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_88__TableRow___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_88__TableRow__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "V", function() { return __WEBPACK_IMPORTED_MODULE_88__TableRow___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_89__TableSortLabel__ = __webpack_require__(333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_89__TableSortLabel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_89__TableSortLabel__);
/* unused harmony reexport TableSortLabel */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_90__Tabs__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_90__Tabs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_90__Tabs__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "W", function() { return __WEBPACK_IMPORTED_MODULE_90__Tabs___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_91__Tab__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_91__Tab___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_91__Tab__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "P", function() { return __WEBPACK_IMPORTED_MODULE_91__Tab___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_92__TextField__ = __webpack_require__(1080);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_92__TextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_92__TextField__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "X", function() { return __WEBPACK_IMPORTED_MODULE_92__TextField___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_93__Toolbar__ = __webpack_require__(331);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_93__Toolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_93__Toolbar__);
/* unused harmony reexport Toolbar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_94__Tooltip__ = __webpack_require__(334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_94__Tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_94__Tooltip__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return __WEBPACK_IMPORTED_MODULE_94__Tooltip___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_95__Typography__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_95__Typography___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_95__Typography__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return __WEBPACK_IMPORTED_MODULE_95__Typography___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_96__withMobileDialog__ = __webpack_require__(1089);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_96__withMobileDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_96__withMobileDialog__);
/* unused harmony reexport withMobileDialog */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_97__withWidth__ = __webpack_require__(328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_97__withWidth___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_97__withWidth__);
/* unused harmony reexport withWidth */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_98__Zoom__ = __webpack_require__(1091);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_98__Zoom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_98__Zoom__);
/* unused harmony reexport Zoom */
/** @license Material-UI v1.2.0
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */






































































































/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(161);

var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.sheetsManager = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(8));

var _objectSpread2 = _interopRequireDefault(__webpack_require__(23));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(18));

var _createClass2 = _interopRequireDefault(__webpack_require__(19));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(20));

var _inherits2 = _interopRequireDefault(__webpack_require__(21));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _warning = _interopRequireDefault(__webpack_require__(32));

var _hoistNonReactStatics = _interopRequireDefault(__webpack_require__(160));

var _getDisplayName = _interopRequireDefault(__webpack_require__(455));

var _wrapDisplayName = _interopRequireDefault(__webpack_require__(162));

var _contextTypes = _interopRequireDefault(__webpack_require__(789));

var _jss = __webpack_require__(457);

var ns = _interopRequireWildcard(__webpack_require__(456));

var _jssPreset = _interopRequireDefault(__webpack_require__(463));

var _createMuiTheme = _interopRequireDefault(__webpack_require__(304));

var _themeListener = _interopRequireDefault(__webpack_require__(306));

var _createGenerateClassName = _interopRequireDefault(__webpack_require__(468));

var _getStylesCreator = _interopRequireDefault(__webpack_require__(828));

var _getThemeProps = _interopRequireDefault(__webpack_require__(829));

// Default JSS instance.
var jss = (0, _jss.create)((0, _jssPreset.default)()); // Use a singleton or the provided one by the context.

var generateClassName = (0, _createGenerateClassName.default)(); // Global index counter to preserve source order.
// We create the style sheet during at the creation of the component,
// children are handled after the parents, so the order of style elements would be parent->child.
// It is a problem though when a parent passes a className
// which needs to override any childs styles.
// StyleSheet of the child has a higher specificity, because of the source order.
// So our solution is to render sheets them in the reverse order child->sheet, so
// that parent has a higher specificity.

var indexCounter = -10e10; // Exported for test purposes

var sheetsManager = new Map(); // We use the same empty object to ref count the styles that don't need a theme object.

exports.sheetsManager = sheetsManager;
var noopTheme = {}; // In order to have self-supporting components, we rely on default theme when not provided.

var defaultTheme;

function getDefaultTheme() {
  if (defaultTheme) {
    return defaultTheme;
  }

  defaultTheme = (0, _createMuiTheme.default)();
  return defaultTheme;
} // Link a style sheet with a component.
// It does not modify the component passed to it;
// instead, it returns a new component, with a `classes` property.


var withStyles = function withStyles(stylesOrCreator) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return function (Component) {
    var _options$withTheme = options.withTheme,
        withTheme = _options$withTheme === void 0 ? false : _options$withTheme,
        _options$flip = options.flip,
        flip = _options$flip === void 0 ? null : _options$flip,
        name = options.name,
        styleSheetOptions = (0, _objectWithoutProperties2.default)(options, ["withTheme", "flip", "name"]);
    var stylesCreator = (0, _getStylesCreator.default)(stylesOrCreator);
    var listenToTheme = stylesCreator.themingEnabled || withTheme || typeof name === 'string';
    indexCounter += 1;
    stylesCreator.options.index = indexCounter;
     false ? (0, _warning.default)(indexCounter < 0, ['Material-UI: you might have a memory leak.', 'The indexCounter is not supposed to grow that much.'].join(' ')) : void 0;

    var WithStyles =
    /*#__PURE__*/
    function (_React$Component) {
      (0, _inherits2.default)(WithStyles, _React$Component);

      function WithStyles(props, context) {
        var _this;

        (0, _classCallCheck2.default)(this, WithStyles);
        _this = (0, _possibleConstructorReturn2.default)(this, (WithStyles.__proto__ || Object.getPrototypeOf(WithStyles)).call(this, props, context));
        _this.state = {};
        _this.disableStylesGeneration = false;
        _this.jss = null;
        _this.sheetOptions = null;
        _this.sheetsManager = sheetsManager;
        _this.stylesCreatorSaved = null;
        _this.theme = null;
        _this.unsubscribeId = null;
        _this.jss = _this.context[ns.jss] || jss;
        var muiThemeProviderOptions = _this.context.muiThemeProviderOptions;

        if (muiThemeProviderOptions) {
          if (muiThemeProviderOptions.sheetsManager) {
            _this.sheetsManager = muiThemeProviderOptions.sheetsManager;
          }

          _this.disableStylesGeneration = muiThemeProviderOptions.disableStylesGeneration;
        } // Attach the stylesCreator to the instance of the component as in the context
        // of react-hot-loader the hooks can be executed in a different closure context:
        // https://github.com/gaearon/react-hot-loader/blob/master/src/patch.dev.js#L107


        _this.stylesCreatorSaved = stylesCreator;
        _this.sheetOptions = (0, _objectSpread2.default)({
          generateClassName: generateClassName
        }, _this.context[ns.sheetOptions]); // We use || as the function call is lazy evaluated.

        _this.theme = listenToTheme ? _themeListener.default.initial(context) || getDefaultTheme() : noopTheme;

        _this.attach(_this.theme);

        _this.cacheClasses = {
          // Cache for the finalized classes value.
          value: null,
          // Cache for the last used classes prop pointer.
          lastProp: null,
          // Cache for the last used rendered classes pointer.
          lastJSS: {}
        };
        return _this;
      }

      (0, _createClass2.default)(WithStyles, [{
        key: "componentDidMount",
        value: function componentDidMount() {
          var _this2 = this;

          if (!listenToTheme) {
            return;
          }

          this.unsubscribeId = _themeListener.default.subscribe(this.context, function (theme) {
            var oldTheme = _this2.theme;
            _this2.theme = theme;

            _this2.attach(_this2.theme); // Rerender the component so the underlying component gets the theme update.
            // By theme update we mean receiving and applying the new class names.


            _this2.setState({}, function () {
              _this2.detach(oldTheme);
            });
          });
        }
      }, {
        key: "componentDidUpdate",
        value: function componentDidUpdate() {
          // react-hot-loader specific logic
          if (this.stylesCreatorSaved === stylesCreator || "production" === 'production') {
            return;
          }

          this.detach(this.theme);
          this.stylesCreatorSaved = stylesCreator;
          this.attach(this.theme);
          this.forceUpdate();
        }
      }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
          this.detach(this.theme);

          if (this.unsubscribeId !== null) {
            _themeListener.default.unsubscribe(this.context, this.unsubscribeId);
          }
        }
      }, {
        key: "getClasses",
        value: function getClasses() {
          var _this3 = this;

          // Tracks if either the rendered classes or classes prop has changed,
          // requiring the generation of a new finalized classes object.
          var generate = false;

          if (!this.disableStylesGeneration) {
            var sheetManager = this.sheetsManager.get(this.stylesCreatorSaved);
            var sheetsManagerTheme = sheetManager.get(this.theme);

            if (sheetsManagerTheme.sheet.classes !== this.cacheClasses.lastJSS) {
              this.cacheClasses.lastJSS = sheetsManagerTheme.sheet.classes;
              generate = true;
            }
          }

          if (this.props.classes !== this.cacheClasses.lastProp) {
            this.cacheClasses.lastProp = this.props.classes;
            generate = true;
          }

          if (generate) {
            if (this.props.classes) {
              this.cacheClasses.value = (0, _objectSpread2.default)({}, this.cacheClasses.lastJSS, Object.keys(this.props.classes).reduce(function (accumulator, key) {
                 false ? (0, _warning.default)(_this3.cacheClasses.lastJSS[key] || _this3.disableStylesGeneration, ["Material-UI: the key `".concat(key, "` ") + "provided to the classes property is not implemented in ".concat((0, _getDisplayName.default)(Component), "."), "You can only override one of the following: ".concat(Object.keys(_this3.cacheClasses.lastJSS).join(','))].join('\n')) : void 0;
                 false ? (0, _warning.default)(!_this3.props.classes[key] || typeof _this3.props.classes[key] === 'string', ["Material-UI: the key `".concat(key, "` ") + "provided to the classes property is not valid for ".concat((0, _getDisplayName.default)(Component), "."), "You need to provide a non empty string instead of: ".concat(_this3.props.classes[key], ".")].join('\n')) : void 0;

                if (_this3.props.classes[key]) {
                  accumulator[key] = "".concat(_this3.cacheClasses.lastJSS[key], " ").concat(_this3.props.classes[key]);
                }

                return accumulator;
              }, {}));
            } else {
              this.cacheClasses.value = this.cacheClasses.lastJSS;
            }
          }

          return this.cacheClasses.value;
        }
      }, {
        key: "attach",
        value: function attach(theme) {
          if (this.disableStylesGeneration) {
            return;
          }

          var stylesCreatorSaved = this.stylesCreatorSaved;
          var sheetManager = this.sheetsManager.get(stylesCreatorSaved);

          if (!sheetManager) {
            sheetManager = new Map();
            this.sheetsManager.set(stylesCreatorSaved, sheetManager);
          }

          var sheetManagerTheme = sheetManager.get(theme);

          if (!sheetManagerTheme) {
            sheetManagerTheme = {
              refs: 0,
              sheet: null
            };
            sheetManager.set(theme, sheetManagerTheme);
          }

          if (sheetManagerTheme.refs === 0) {
            var styles = stylesCreatorSaved.create(theme, name);
            var meta = name;

            if (false) {
              meta = (0, _getDisplayName.default)(Component);
            }

            var sheet = this.jss.createStyleSheet(styles, (0, _objectSpread2.default)({
              meta: meta,
              classNamePrefix: meta,
              flip: typeof flip === 'boolean' ? flip : theme.direction === 'rtl',
              link: false
            }, this.sheetOptions, stylesCreatorSaved.options, {
              name: name
            }, styleSheetOptions));
            sheetManagerTheme.sheet = sheet;
            sheet.attach();
            var sheetsRegistry = this.context[ns.sheetsRegistry];

            if (sheetsRegistry) {
              sheetsRegistry.add(sheet);
            }
          }

          sheetManagerTheme.refs += 1;
        }
      }, {
        key: "detach",
        value: function detach(theme) {
          if (this.disableStylesGeneration) {
            return;
          }

          var stylesCreatorSaved = this.stylesCreatorSaved;
          var sheetManager = this.sheetsManager.get(stylesCreatorSaved);
          var sheetManagerTheme = sheetManager.get(theme);
          sheetManagerTheme.refs -= 1;

          if (sheetManagerTheme.refs === 0) {
            sheetManager.delete(theme);
            this.jss.removeStyleSheet(sheetManagerTheme.sheet);
            var sheetsRegistry = this.context[ns.sheetsRegistry];

            if (sheetsRegistry) {
              sheetsRegistry.remove(sheetManagerTheme.sheet);
            }
          }
        }
      }, {
        key: "render",
        value: function render() {
          var _props = this.props,
              classes = _props.classes,
              innerRef = _props.innerRef,
              other = (0, _objectWithoutProperties2.default)(_props, ["classes", "innerRef"]);
          var more = (0, _getThemeProps.default)({
            theme: this.theme,
            name: name
          }); // Provide the theme to the wrapped component.
          // So we don't have to use the `withTheme()` Higher-order Component.

          if (withTheme) {
            more.theme = this.theme;
          }

          return _react.default.createElement(Component, (0, _extends2.default)({}, more, {
            classes: this.getClasses(),
            ref: innerRef
          }, other));
        }
      }]);
      return WithStyles;
    }(_react.default.Component);

    WithStyles.propTypes =  false ? {
      /**
       * Override or extend the styles applied to the component.
       */
      classes: _propTypes.default.object,

      /**
       * Use that property to pass a ref callback to the decorated component.
       */
      innerRef: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.object])
    } : {};
    WithStyles.contextTypes = (0, _objectSpread2.default)({
      muiThemeProviderOptions: _propTypes.default.object
    }, _contextTypes.default, listenToTheme ? _themeListener.default.contextTypes : {});

    if (false) {
      WithStyles.displayName = (0, _wrapDisplayName.default)(Component, 'WithStyles');
    }

    (0, _hoistNonReactStatics.default)(WithStyles, Component);

    if (false) {
      // Exposed for test purposes.
      WithStyles.Naked = Component;
      WithStyles.options = options;
    }

    return WithStyles;
  };
};

var _default = withStyles;
exports.default = _default;

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2017 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg) && arg.length) {
				var inner = classNames.apply(null, arg);
				if (inner) {
					classes.push(inner);
				}
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return classNames;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

var objectWithoutPropertiesLoose = __webpack_require__(788);

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

module.exports = _objectWithoutProperties;

/***/ }),
/* 8 */
/***/ (function(module, exports) {

function _extends() {
  module.exports = _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

module.exports = _extends;

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

var getTimezoneOffsetInMilliseconds = __webpack_require__(2388)
var isDate = __webpack_require__(383)

var MILLISECONDS_IN_HOUR = 3600000
var MILLISECONDS_IN_MINUTE = 60000
var DEFAULT_ADDITIONAL_DIGITS = 2

var parseTokenDateTimeDelimeter = /[T ]/
var parseTokenPlainTime = /:/

// year tokens
var parseTokenYY = /^(\d{2})$/
var parseTokensYYY = [
  /^([+-]\d{2})$/, // 0 additional digits
  /^([+-]\d{3})$/, // 1 additional digit
  /^([+-]\d{4})$/ // 2 additional digits
]

var parseTokenYYYY = /^(\d{4})/
var parseTokensYYYYY = [
  /^([+-]\d{4})/, // 0 additional digits
  /^([+-]\d{5})/, // 1 additional digit
  /^([+-]\d{6})/ // 2 additional digits
]

// date tokens
var parseTokenMM = /^-(\d{2})$/
var parseTokenDDD = /^-?(\d{3})$/
var parseTokenMMDD = /^-?(\d{2})-?(\d{2})$/
var parseTokenWww = /^-?W(\d{2})$/
var parseTokenWwwD = /^-?W(\d{2})-?(\d{1})$/

// time tokens
var parseTokenHH = /^(\d{2}([.,]\d*)?)$/
var parseTokenHHMM = /^(\d{2}):?(\d{2}([.,]\d*)?)$/
var parseTokenHHMMSS = /^(\d{2}):?(\d{2}):?(\d{2}([.,]\d*)?)$/

// timezone tokens
var parseTokenTimezone = /([Z+-].*)$/
var parseTokenTimezoneZ = /^(Z)$/
var parseTokenTimezoneHH = /^([+-])(\d{2})$/
var parseTokenTimezoneHHMM = /^([+-])(\d{2}):?(\d{2})$/

/**
 * @category Common Helpers
 * @summary Convert the given argument to an instance of Date.
 *
 * @description
 * Convert the given argument to an instance of Date.
 *
 * If the argument is an instance of Date, the function returns its clone.
 *
 * If the argument is a number, it is treated as a timestamp.
 *
 * If an argument is a string, the function tries to parse it.
 * Function accepts complete ISO 8601 formats as well as partial implementations.
 * ISO 8601: http://en.wikipedia.org/wiki/ISO_8601
 *
 * If all above fails, the function passes the given argument to Date constructor.
 *
 * @param {Date|String|Number} argument - the value to convert
 * @param {Object} [options] - the object with options
 * @param {0 | 1 | 2} [options.additionalDigits=2] - the additional number of digits in the extended year format
 * @returns {Date} the parsed date in the local time zone
 *
 * @example
 * // Convert string '2014-02-11T11:30:30' to date:
 * var result = parse('2014-02-11T11:30:30')
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Parse string '+02014101',
 * // if the additional number of digits in the extended year format is 1:
 * var result = parse('+02014101', {additionalDigits: 1})
 * //=> Fri Apr 11 2014 00:00:00
 */
function parse (argument, dirtyOptions) {
  if (isDate(argument)) {
    // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime())
  } else if (typeof argument !== 'string') {
    return new Date(argument)
  }

  var options = dirtyOptions || {}
  var additionalDigits = options.additionalDigits
  if (additionalDigits == null) {
    additionalDigits = DEFAULT_ADDITIONAL_DIGITS
  } else {
    additionalDigits = Number(additionalDigits)
  }

  var dateStrings = splitDateString(argument)

  var parseYearResult = parseYear(dateStrings.date, additionalDigits)
  var year = parseYearResult.year
  var restDateString = parseYearResult.restDateString

  var date = parseDate(restDateString, year)

  if (date) {
    var timestamp = date.getTime()
    var time = 0
    var offset

    if (dateStrings.time) {
      time = parseTime(dateStrings.time)
    }

    if (dateStrings.timezone) {
      offset = parseTimezone(dateStrings.timezone) * MILLISECONDS_IN_MINUTE
    } else {
      var fullTime = timestamp + time
      var fullTimeDate = new Date(fullTime)

      offset = getTimezoneOffsetInMilliseconds(fullTimeDate)

      // Adjust time when it's coming from DST
      var fullTimeDateNextDay = new Date(fullTime)
      fullTimeDateNextDay.setDate(fullTimeDate.getDate() + 1)
      var offsetDiff =
        getTimezoneOffsetInMilliseconds(fullTimeDateNextDay) -
        getTimezoneOffsetInMilliseconds(fullTimeDate)
      if (offsetDiff > 0) {
        offset += offsetDiff
      }
    }

    return new Date(timestamp + time + offset)
  } else {
    return new Date(argument)
  }
}

function splitDateString (dateString) {
  var dateStrings = {}
  var array = dateString.split(parseTokenDateTimeDelimeter)
  var timeString

  if (parseTokenPlainTime.test(array[0])) {
    dateStrings.date = null
    timeString = array[0]
  } else {
    dateStrings.date = array[0]
    timeString = array[1]
  }

  if (timeString) {
    var token = parseTokenTimezone.exec(timeString)
    if (token) {
      dateStrings.time = timeString.replace(token[1], '')
      dateStrings.timezone = token[1]
    } else {
      dateStrings.time = timeString
    }
  }

  return dateStrings
}

function parseYear (dateString, additionalDigits) {
  var parseTokenYYY = parseTokensYYY[additionalDigits]
  var parseTokenYYYYY = parseTokensYYYYY[additionalDigits]

  var token

  // YYYY or ±YYYYY
  token = parseTokenYYYY.exec(dateString) || parseTokenYYYYY.exec(dateString)
  if (token) {
    var yearString = token[1]
    return {
      year: parseInt(yearString, 10),
      restDateString: dateString.slice(yearString.length)
    }
  }

  // YY or ±YYY
  token = parseTokenYY.exec(dateString) || parseTokenYYY.exec(dateString)
  if (token) {
    var centuryString = token[1]
    return {
      year: parseInt(centuryString, 10) * 100,
      restDateString: dateString.slice(centuryString.length)
    }
  }

  // Invalid ISO-formatted year
  return {
    year: null
  }
}

function parseDate (dateString, year) {
  // Invalid ISO-formatted year
  if (year === null) {
    return null
  }

  var token
  var date
  var month
  var week

  // YYYY
  if (dateString.length === 0) {
    date = new Date(0)
    date.setUTCFullYear(year)
    return date
  }

  // YYYY-MM
  token = parseTokenMM.exec(dateString)
  if (token) {
    date = new Date(0)
    month = parseInt(token[1], 10) - 1
    date.setUTCFullYear(year, month)
    return date
  }

  // YYYY-DDD or YYYYDDD
  token = parseTokenDDD.exec(dateString)
  if (token) {
    date = new Date(0)
    var dayOfYear = parseInt(token[1], 10)
    date.setUTCFullYear(year, 0, dayOfYear)
    return date
  }

  // YYYY-MM-DD or YYYYMMDD
  token = parseTokenMMDD.exec(dateString)
  if (token) {
    date = new Date(0)
    month = parseInt(token[1], 10) - 1
    var day = parseInt(token[2], 10)
    date.setUTCFullYear(year, month, day)
    return date
  }

  // YYYY-Www or YYYYWww
  token = parseTokenWww.exec(dateString)
  if (token) {
    week = parseInt(token[1], 10) - 1
    return dayOfISOYear(year, week)
  }

  // YYYY-Www-D or YYYYWwwD
  token = parseTokenWwwD.exec(dateString)
  if (token) {
    week = parseInt(token[1], 10) - 1
    var dayOfWeek = parseInt(token[2], 10) - 1
    return dayOfISOYear(year, week, dayOfWeek)
  }

  // Invalid ISO-formatted date
  return null
}

function parseTime (timeString) {
  var token
  var hours
  var minutes

  // hh
  token = parseTokenHH.exec(timeString)
  if (token) {
    hours = parseFloat(token[1].replace(',', '.'))
    return (hours % 24) * MILLISECONDS_IN_HOUR
  }

  // hh:mm or hhmm
  token = parseTokenHHMM.exec(timeString)
  if (token) {
    hours = parseInt(token[1], 10)
    minutes = parseFloat(token[2].replace(',', '.'))
    return (hours % 24) * MILLISECONDS_IN_HOUR +
      minutes * MILLISECONDS_IN_MINUTE
  }

  // hh:mm:ss or hhmmss
  token = parseTokenHHMMSS.exec(timeString)
  if (token) {
    hours = parseInt(token[1], 10)
    minutes = parseInt(token[2], 10)
    var seconds = parseFloat(token[3].replace(',', '.'))
    return (hours % 24) * MILLISECONDS_IN_HOUR +
      minutes * MILLISECONDS_IN_MINUTE +
      seconds * 1000
  }

  // Invalid ISO-formatted time
  return null
}

function parseTimezone (timezoneString) {
  var token
  var absoluteOffset

  // Z
  token = parseTokenTimezoneZ.exec(timezoneString)
  if (token) {
    return 0
  }

  // ±hh
  token = parseTokenTimezoneHH.exec(timezoneString)
  if (token) {
    absoluteOffset = parseInt(token[2], 10) * 60
    return (token[1] === '+') ? -absoluteOffset : absoluteOffset
  }

  // ±hh:mm or ±hhmm
  token = parseTokenTimezoneHHMM.exec(timezoneString)
  if (token) {
    absoluteOffset = parseInt(token[2], 10) * 60 + parseInt(token[3], 10)
    return (token[1] === '+') ? -absoluteOffset : absoluteOffset
  }

  return 0
}

function dayOfISOYear (isoYear, week, day) {
  week = week || 0
  day = day || 0
  var date = new Date(0)
  date.setUTCFullYear(isoYear, 0, 4)
  var fourthOfJanuaryDay = date.getUTCDay() || 7
  var diff = week * 7 + day + 1 - fourthOfJanuaryDay
  date.setUTCDate(date.getUTCDate() + diff)
  return date
}

module.exports = parse


/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export history */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_history_createBrowserHistory__ = __webpack_require__(440);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_history_createBrowserHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_history_createBrowserHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_redux__ = __webpack_require__(1313);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_router_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_form__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_thunk__ = __webpack_require__(1316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__reducers_OccupationsReducer__ = __webpack_require__(360);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__reducers_TasksReducer__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__reducers_LoginReducer__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__reducers_NotificationReducer__ = __webpack_require__(30);
var history=__WEBPACK_IMPORTED_MODULE_1_history_createBrowserHistory___default()();var enhancers=[];var middleware=[__WEBPACK_IMPORTED_MODULE_4_redux_thunk__["a" /* default */],Object(__WEBPACK_IMPORTED_MODULE_2_react_router_redux__["routerMiddleware"])(history)];if(false){var devToolsExtension=window.devToolsExtension;if(typeof devToolsExtension==="function"){enhancers.push(devToolsExtension());}}var composedEnhancers=__WEBPACK_IMPORTED_MODULE_0_redux__["d" /* compose */].apply(undefined,[__WEBPACK_IMPORTED_MODULE_0_redux__["a" /* applyMiddleware */].apply(undefined,middleware)].concat(enhancers));var initialState={};var store=Object(__WEBPACK_IMPORTED_MODULE_0_redux__["e" /* createStore */])(Object(__WEBPACK_IMPORTED_MODULE_0_redux__["c" /* combineReducers */])({occupations:__WEBPACK_IMPORTED_MODULE_5__reducers_OccupationsReducer__["b" /* default */],form:__WEBPACK_IMPORTED_MODULE_3_redux_form__["d" /* reducer */],tasks:__WEBPACK_IMPORTED_MODULE_6__reducers_TasksReducer__["c" /* default */],login:__WEBPACK_IMPORTED_MODULE_7__reducers_LoginReducer__["d" /* default */],alert:__WEBPACK_IMPORTED_MODULE_8__reducers_NotificationReducer__["c" /* default */]}),initialState,composedEnhancers);/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),
/* 11 */
/***/ (function(module, exports) {

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

module.exports = _defineProperty;

/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_styles_withStyles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_styles_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_styles_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid__);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}// @material-ui/core components
var style={grid:{padding:"0 15px !important"}};function GridItem(_ref){var props=_objectWithoutProperties(_ref,[]);var classes=props.classes,children=props.children,className=props.className,rest=_objectWithoutProperties(props,["classes","children","className"]);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,Object.assign({item:true},rest,{className:classes.grid+" "+className}),children);}/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1__material_ui_core_styles_withStyles___default()(style)(GridItem));

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

var parser = __webpack_require__(1094);

var parse = parser.parse;

// Strip insignificant whitespace
// Note that this could do a lot more, such as reorder fields etc.
function normalize(string) {
  return string.replace(/[\s,]+/g, ' ').trim();
}

// A map docString -> graphql document
var docCache = {};

// A map fragmentName -> [normalized source]
var fragmentSourceMap = {};

function cacheKeyFromLoc(loc) {
  return normalize(loc.source.body.substring(loc.start, loc.end));
}

// For testing.
function resetCaches() {
  docCache = {};
  fragmentSourceMap = {};
}

// Take a unstripped parsed document (query/mutation or even fragment), and
// check all fragment definitions, checking for name->source uniqueness.
// We also want to make sure only unique fragments exist in the document.
var printFragmentWarnings = true;
function processFragments(ast) {
  var astFragmentMap = {};
  var definitions = [];

  for (var i = 0; i < ast.definitions.length; i++) {
    var fragmentDefinition = ast.definitions[i];

    if (fragmentDefinition.kind === 'FragmentDefinition') {
      var fragmentName = fragmentDefinition.name.value;
      var sourceKey = cacheKeyFromLoc(fragmentDefinition.loc);

      // We know something about this fragment
      if (fragmentSourceMap.hasOwnProperty(fragmentName) && !fragmentSourceMap[fragmentName][sourceKey]) {

        // this is a problem because the app developer is trying to register another fragment with
        // the same name as one previously registered. So, we tell them about it.
        if (printFragmentWarnings) {
          console.warn("Warning: fragment with name " + fragmentName + " already exists.\n"
            + "graphql-tag enforces all fragment names across your application to be unique; read more about\n"
            + "this in the docs: http://dev.apollodata.com/core/fragments.html#unique-names");
        }

        fragmentSourceMap[fragmentName][sourceKey] = true;

      } else if (!fragmentSourceMap.hasOwnProperty(fragmentName)) {
        fragmentSourceMap[fragmentName] = {};
        fragmentSourceMap[fragmentName][sourceKey] = true;
      }

      if (!astFragmentMap[sourceKey]) {
        astFragmentMap[sourceKey] = true;
        definitions.push(fragmentDefinition);
      }
    } else {
      definitions.push(fragmentDefinition);
    }
  }

  ast.definitions = definitions;
  return ast;
}

function disableFragmentWarnings() {
  printFragmentWarnings = false;
}

function stripLoc(doc, removeLocAtThisLevel) {
  var docType = Object.prototype.toString.call(doc);

  if (docType === '[object Array]') {
    return doc.map(function (d) {
      return stripLoc(d, removeLocAtThisLevel);
    });
  }

  if (docType !== '[object Object]') {
    throw new Error('Unexpected input.');
  }

  // We don't want to remove the root loc field so we can use it
  // for fragment substitution (see below)
  if (removeLocAtThisLevel && doc.loc) {
    delete doc.loc;
  }

  // https://github.com/apollographql/graphql-tag/issues/40
  if (doc.loc) {
    delete doc.loc.startToken;
    delete doc.loc.endToken;
  }

  var keys = Object.keys(doc);
  var key;
  var value;
  var valueType;

  for (key in keys) {
    if (keys.hasOwnProperty(key)) {
      value = doc[keys[key]];
      valueType = Object.prototype.toString.call(value);

      if (valueType === '[object Object]' || valueType === '[object Array]') {
        doc[keys[key]] = stripLoc(value, true);
      }
    }
  }

  return doc;
}

var experimentalFragmentVariables = false;
function parseDocument(doc) {
  var cacheKey = normalize(doc);

  if (docCache[cacheKey]) {
    return docCache[cacheKey];
  }

  var parsed = parse(doc, { experimentalFragmentVariables: experimentalFragmentVariables });
  if (!parsed || parsed.kind !== 'Document') {
    throw new Error('Not a valid GraphQL document.');
  }

  // check that all "new" fragments inside the documents are consistent with
  // existing fragments of the same name
  parsed = processFragments(parsed);
  parsed = stripLoc(parsed, false);
  docCache[cacheKey] = parsed;

  return parsed;
}

function enableExperimentalFragmentVariables() {
  experimentalFragmentVariables = true;
}

function disableExperimentalFragmentVariables() {
  experimentalFragmentVariables = false;
}

// XXX This should eventually disallow arbitrary string interpolation, like Relay does
function gql(/* arguments */) {
  var args = Array.prototype.slice.call(arguments);

  var literals = args[0];

  // We always get literals[0] and then matching post literals for each arg given
  var result = (typeof(literals) === "string") ? literals : literals[0];

  for (var i = 1; i < args.length; i++) {
    if (args[i] && args[i].kind && args[i].kind === 'Document') {
      result += args[i].loc.source.body;
    } else {
      result += args[i];
    }

    result += literals[i];
  }

  return parseDocument(result);
}

// Support typescript, which isn't as nice as Babel about default exports
gql.default = gql;
gql.resetCaches = resetCaches;
gql.disableFragmentWarnings = disableFragmentWarnings;
gql.enableExperimentalFragmentVariables = enableExperimentalFragmentVariables;
gql.disableExperimentalFragmentVariables = disableExperimentalFragmentVariables;

module.exports = gql;


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

(function (global, factory) {
     true ? factory(exports, __webpack_require__(50), __webpack_require__(3), __webpack_require__(0)) :
    typeof define === 'function' && define.amd ? define(['exports', 'apollo-client', 'prop-types', 'react'], factory) :
    (factory((global['react-apollo'] = {}),global.apolloClient,global.PropTypes,global.React));
}(this, (function (exports,apolloClient,PropTypes,React) { 'use strict';

    var __extends = (undefined && undefined.__extends) || (function () {
        var extendStatics = function (d, b) {
            extendStatics = Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
                function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
            return extendStatics(d, b);
        };
        return function (d, b) {
            extendStatics(d, b);
            function __() { this.constructor = d; }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    })();
    var __assign = (undefined && undefined.__assign) || function () {
        __assign = Object.assign || function(t) {
            for (var s, i = 1, n = arguments.length; i < n; i++) {
                s = arguments[i];
                for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                    t[p] = s[p];
            }
            return t;
        };
        return __assign.apply(this, arguments);
    };
    var Trie = (function () {
        function Trie() {
            this.children = null;
            this.added = false;
        }
        Trie.prototype.has = function () {
            var keys = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                keys[_i] = arguments[_i];
            }
            var node = this;
            return keys.every(function (key) {
                var child = node.children && node.children.get(key);
                return !!(child && (node = child));
            }) && node.added;
        };
        Trie.prototype.add = function () {
            var keys = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                keys[_i] = arguments[_i];
            }
            var node = this;
            keys.forEach(function (key) {
                var map = node.children || (node.children = new Map);
                var child = map.get(key);
                if (child) {
                    node = child;
                }
                else {
                    map.set(key, node = new Trie());
                }
            });
            node.added = true;
        };
        return Trie;
    }());
    var RenderPromises = (function () {
        function RenderPromises() {
            this.queryPromises = new Map();
            this.queryGraveyard = new Trie();
        }
        RenderPromises.prototype.addQueryPromise = function (queryInstance, finish) {
            var _a = queryInstance.props, query = _a.query, variables = _a.variables;
            if (!this.queryGraveyard.has(query, JSON.stringify(variables))) {
                this.queryPromises.set(queryInstance, new Promise(function (resolve) {
                    resolve(queryInstance.fetchData());
                }));
                return null;
            }
            return finish();
        };
        RenderPromises.prototype.hasPromises = function () {
            return this.queryPromises.size > 0;
        };
        RenderPromises.prototype.consumeAndAwaitPromises = function () {
            var _this = this;
            var promises = [];
            this.queryPromises.forEach(function (promise, queryInstance) {
                var _a = queryInstance.props, query = _a.query, variables = _a.variables;
                _this.queryGraveyard.add(query, JSON.stringify(variables));
                promises.push(promise);
            });
            this.queryPromises.clear();
            return Promise.all(promises);
        };
        return RenderPromises;
    }());
    function getDataFromTree(tree, context) {
        if (context === void 0) { context = {}; }
        return getMarkupFromTree({
            tree: tree,
            context: context,
            renderFunction: __webpack_require__(341).renderToStaticMarkup,
        });
    }
    function getMarkupFromTree(_a) {
        var tree = _a.tree, _b = _a.context, context = _b === void 0 ? {} : _b, _c = _a.renderFunction, renderFunction = _c === void 0 ? __webpack_require__(341).renderToStaticMarkup : _c;
        var renderPromises = new RenderPromises();
        var RenderPromisesProvider = (function (_super) {
            __extends(RenderPromisesProvider, _super);
            function RenderPromisesProvider() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            RenderPromisesProvider.prototype.getChildContext = function () {
                return __assign({}, context, { renderPromises: renderPromises });
            };
            RenderPromisesProvider.prototype.render = function () {
                return tree;
            };
            RenderPromisesProvider.childContextTypes = {
                renderPromises: PropTypes.object,
            };
            return RenderPromisesProvider;
        }(React.Component));
        Object.keys(context).forEach(function (key) {
            RenderPromisesProvider.childContextTypes[key] = PropTypes.any;
        });
        function process() {
            var html = renderFunction(React.createElement(RenderPromisesProvider));
            return renderPromises.hasPromises()
                ? renderPromises.consumeAndAwaitPromises().then(process)
                : html;
        }
        return Promise.resolve().then(process);
    }

    var invariant = __webpack_require__(35);
    var ApolloConsumer = function (props, context) {
        invariant(!!context.client, "Could not find \"client\" in the context of ApolloConsumer. Wrap the root component in an <ApolloProvider>");
        return props.children(context.client);
    };
    ApolloConsumer.contextTypes = {
        client: PropTypes.object.isRequired,
    };
    ApolloConsumer.propTypes = {
        children: PropTypes.func.isRequired,
    };

    var __extends$1 = (undefined && undefined.__extends) || (function () {
        var extendStatics = function (d, b) {
            extendStatics = Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
                function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
            return extendStatics(d, b);
        };
        return function (d, b) {
            extendStatics(d, b);
            function __() { this.constructor = d; }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    })();
    var invariant$1 = __webpack_require__(35);
    var ApolloProvider = (function (_super) {
        __extends$1(ApolloProvider, _super);
        function ApolloProvider(props, context) {
            var _this = _super.call(this, props, context) || this;
            _this.operations = new Map();
            invariant$1(props.client, 'ApolloProvider was not passed a client instance. Make ' +
                'sure you pass in your client via the "client" prop.');
            if (!props.client.__operations_cache__) {
                props.client.__operations_cache__ = _this.operations;
            }
            return _this;
        }
        ApolloProvider.prototype.getChildContext = function () {
            return {
                client: this.props.client,
                operations: this.props.client.__operations_cache__,
            };
        };
        ApolloProvider.prototype.render = function () {
            return this.props.children;
        };
        ApolloProvider.propTypes = {
            client: PropTypes.object.isRequired,
            children: PropTypes.node.isRequired,
        };
        ApolloProvider.childContextTypes = {
            client: PropTypes.object.isRequired,
            operations: PropTypes.object,
        };
        return ApolloProvider;
    }(React.Component));

    var invariant$2 = __webpack_require__(35);
    var DocumentType;
    (function (DocumentType) {
        DocumentType[DocumentType["Query"] = 0] = "Query";
        DocumentType[DocumentType["Mutation"] = 1] = "Mutation";
        DocumentType[DocumentType["Subscription"] = 2] = "Subscription";
    })(DocumentType || (DocumentType = {}));
    var cache = new Map();
    function parser(document) {
        var cached = cache.get(document);
        if (cached)
            return cached;
        var variables, type, name;
        invariant$2(!!document && !!document.kind, "Argument of " + document + " passed to parser was not a valid GraphQL " +
            "DocumentNode. You may need to use 'graphql-tag' or another method " +
            "to convert your operation into a document");
        var fragments = document.definitions.filter(function (x) { return x.kind === 'FragmentDefinition'; });
        var queries = document.definitions.filter(function (x) { return x.kind === 'OperationDefinition' && x.operation === 'query'; });
        var mutations = document.definitions.filter(function (x) { return x.kind === 'OperationDefinition' && x.operation === 'mutation'; });
        var subscriptions = document.definitions.filter(function (x) { return x.kind === 'OperationDefinition' && x.operation === 'subscription'; });
        invariant$2(!fragments.length || (queries.length || mutations.length || subscriptions.length), "Passing only a fragment to 'graphql' is not yet supported. " +
            "You must include a query, subscription or mutation as well");
        invariant$2(queries.length + mutations.length + subscriptions.length <= 1, "react-apollo only supports a query, subscription, or a mutation per HOC. " +
            (document + " had " + queries.length + " queries, " + subscriptions.length + " ") +
            ("subscriptions and " + mutations.length + " mutations. ") +
            "You can use 'compose' to join multiple operation types to a component");
        type = queries.length ? DocumentType.Query : DocumentType.Mutation;
        if (!queries.length && !mutations.length)
            type = DocumentType.Subscription;
        var definitions = queries.length ? queries : mutations.length ? mutations : subscriptions;
        invariant$2(definitions.length === 1, "react-apollo only supports one defintion per HOC. " + document + " had " +
            (definitions.length + " definitions. ") +
            "You can use 'compose' to join multiple operation types to a component");
        var definition = definitions[0];
        variables = definition.variableDefinitions || [];
        if (definition.name && definition.name.kind === 'Name') {
            name = definition.name.value;
        }
        else {
            name = 'data';
        }
        var payload = { name: name, type: type, variables: variables };
        cache.set(document, payload);
        return payload;
    }

    var invariant$3 = __webpack_require__(35);
    function getClient(props, context) {
        var client = props.client || context.client;
        invariant$3(!!client, 'Could not find "client" in the context or passed in as a prop. ' +
            'Wrap the root component in an <ApolloProvider>, or pass an ' +
            'ApolloClient instance in via props.');
        return client;
    }

    var __extends$2 = (undefined && undefined.__extends) || (function () {
        var extendStatics = function (d, b) {
            extendStatics = Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
                function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
            return extendStatics(d, b);
        };
        return function (d, b) {
            extendStatics(d, b);
            function __() { this.constructor = d; }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    })();
    var __assign$1 = (undefined && undefined.__assign) || function () {
        __assign$1 = Object.assign || function(t) {
            for (var s, i = 1, n = arguments.length; i < n; i++) {
                s = arguments[i];
                for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                    t[p] = s[p];
            }
            return t;
        };
        return __assign$1.apply(this, arguments);
    };
    var __rest = (undefined && undefined.__rest) || function (s, e) {
        var t = {};
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
            t[p] = s[p];
        if (s != null && typeof Object.getOwnPropertySymbols === "function")
            for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
                t[p[i]] = s[p[i]];
        return t;
    };
    var shallowEqual = __webpack_require__(342);
    var invariant$4 = __webpack_require__(35);
    function compact(obj) {
        return Object.keys(obj).reduce(function (acc, key) {
            if (obj[key] !== undefined) {
                acc[key] = obj[key];
            }
            return acc;
        }, {});
    }
    function observableQueryFields(observable) {
        var fields = {
            variables: observable.variables,
            refetch: observable.refetch.bind(observable),
            fetchMore: observable.fetchMore.bind(observable),
            updateQuery: observable.updateQuery.bind(observable),
            startPolling: observable.startPolling.bind(observable),
            stopPolling: observable.stopPolling.bind(observable),
            subscribeToMore: observable.subscribeToMore.bind(observable),
        };
        return fields;
    }
    var Query = (function (_super) {
        __extends$2(Query, _super);
        function Query(props, context) {
            var _this = _super.call(this, props, context) || this;
            _this.previousData = {};
            _this.hasMounted = false;
            _this.startQuerySubscription = function () {
                if (_this.querySubscription)
                    return;
                var initial = _this.getQueryResult();
                _this.querySubscription = _this.queryObservable.subscribe({
                    next: function (_a) {
                        var data = _a.data;
                        if (initial && initial.networkStatus === 7 && shallowEqual(initial.data, data)) {
                            initial = undefined;
                            return;
                        }
                        initial = undefined;
                        _this.updateCurrentData();
                    },
                    error: function (error) {
                        _this.resubscribeToQuery();
                        if (!error.hasOwnProperty('graphQLErrors'))
                            throw error;
                        _this.updateCurrentData();
                    },
                });
            };
            _this.removeQuerySubscription = function () {
                if (_this.querySubscription) {
                    _this.querySubscription.unsubscribe();
                    delete _this.querySubscription;
                }
            };
            _this.updateCurrentData = function () {
                if (_this.hasMounted)
                    _this.forceUpdate();
            };
            _this.getQueryResult = function () {
                var data = { data: Object.create(null) };
                Object.assign(data, observableQueryFields(_this.queryObservable));
                if (_this.props.skip) {
                    data = __assign$1({}, data, { data: undefined, error: undefined, loading: false });
                }
                else {
                    var currentResult = _this.queryObservable.currentResult();
                    var loading = currentResult.loading, partial = currentResult.partial, networkStatus = currentResult.networkStatus, errors = currentResult.errors;
                    var error = currentResult.error;
                    if (errors && errors.length > 0) {
                        error = new apolloClient.ApolloError({ graphQLErrors: errors });
                    }
                    Object.assign(data, { loading: loading, networkStatus: networkStatus, error: error });
                    if (loading) {
                        Object.assign(data.data, _this.previousData, currentResult.data);
                    }
                    else if (error) {
                        Object.assign(data, {
                            data: (_this.queryObservable.getLastResult() || {}).data,
                        });
                    }
                    else {
                        var fetchPolicy = _this.queryObservable.options.fetchPolicy;
                        var partialRefetch = _this.props.partialRefetch;
                        if (partialRefetch &&
                            Object.keys(currentResult.data).length === 0 &&
                            partial &&
                            fetchPolicy !== 'cache-only') {
                            Object.assign(data, { loading: true, networkStatus: apolloClient.NetworkStatus.loading });
                            data.refetch();
                            return data;
                        }
                        Object.assign(data.data, currentResult.data);
                        _this.previousData = currentResult.data;
                    }
                }
                if (!_this.querySubscription) {
                    var oldRefetch_1 = data.refetch;
                    data.refetch = function (args) {
                        if (_this.querySubscription) {
                            return oldRefetch_1(args);
                        }
                        else {
                            return new Promise(function (r, f) {
                                _this.refetcherQueue = { resolve: r, reject: f, args: args };
                            });
                        }
                    };
                }
                data.client = _this.client;
                return data;
            };
            _this.client = getClient(props, context);
            _this.initializeQueryObservable(props);
            return _this;
        }
        Query.prototype.fetchData = function () {
            if (this.props.skip)
                return false;
            var _a = this.props, children = _a.children, ssr = _a.ssr, displayName = _a.displayName, skip = _a.skip, client = _a.client, onCompleted = _a.onCompleted, onError = _a.onError, partialRefetch = _a.partialRefetch, opts = __rest(_a, ["children", "ssr", "displayName", "skip", "client", "onCompleted", "onError", "partialRefetch"]);
            var fetchPolicy = opts.fetchPolicy;
            if (ssr === false)
                return false;
            if (fetchPolicy === 'network-only' || fetchPolicy === 'cache-and-network') {
                fetchPolicy = 'cache-first';
            }
            var observable = this.client.watchQuery(__assign$1({}, opts, { fetchPolicy: fetchPolicy }));
            var result = this.queryObservable.currentResult();
            return result.loading ? observable.result() : false;
        };
        Query.prototype.componentDidMount = function () {
            this.hasMounted = true;
            if (this.props.skip)
                return;
            this.startQuerySubscription();
            if (this.refetcherQueue) {
                var _a = this.refetcherQueue, args = _a.args, resolve = _a.resolve, reject = _a.reject;
                this.queryObservable.refetch(args)
                    .then(resolve)
                    .catch(reject);
            }
        };
        Query.prototype.componentWillReceiveProps = function (nextProps, nextContext) {
            if (nextProps.skip && !this.props.skip) {
                this.removeQuerySubscription();
                return;
            }
            var nextClient = getClient(nextProps, nextContext);
            if (shallowEqual(this.props, nextProps) && this.client === nextClient) {
                return;
            }
            if (this.client !== nextClient) {
                this.client = nextClient;
                this.removeQuerySubscription();
                this.queryObservable = null;
                this.previousData = {};
                this.updateQuery(nextProps);
            }
            if (this.props.query !== nextProps.query) {
                this.removeQuerySubscription();
            }
            this.updateQuery(nextProps);
            if (nextProps.skip)
                return;
            this.startQuerySubscription();
        };
        Query.prototype.componentWillUnmount = function () {
            this.removeQuerySubscription();
            this.hasMounted = false;
        };
        Query.prototype.componentDidUpdate = function () {
            var _a = this.props, onCompleted = _a.onCompleted, onError = _a.onError;
            if (onCompleted || onError) {
                var currentResult = this.queryObservable.currentResult();
                var loading = currentResult.loading, error = currentResult.error, data = currentResult.data;
                if (onCompleted && !loading && !error) {
                    onCompleted(data);
                }
                else if (onError && !loading && error) {
                    onError(error);
                }
            }
        };
        Query.prototype.render = function () {
            var _this = this;
            var context = this.context;
            var finish = function () { return _this.props.children(_this.getQueryResult()); };
            if (context && context.renderPromises) {
                return context.renderPromises.addQueryPromise(this, finish);
            }
            return finish();
        };
        Query.prototype.extractOptsFromProps = function (props) {
            var variables = props.variables, pollInterval = props.pollInterval, fetchPolicy = props.fetchPolicy, errorPolicy = props.errorPolicy, notifyOnNetworkStatusChange = props.notifyOnNetworkStatusChange, query = props.query, _a = props.displayName, displayName = _a === void 0 ? 'Query' : _a, _b = props.context, context = _b === void 0 ? {} : _b;
            this.operation = parser(query);
            invariant$4(this.operation.type === DocumentType.Query, "The <Query /> component requires a graphql query, but got a " + (this.operation.type === DocumentType.Mutation ? 'mutation' : 'subscription') + ".");
            return compact({
                variables: variables,
                pollInterval: pollInterval,
                query: query,
                fetchPolicy: fetchPolicy,
                errorPolicy: errorPolicy,
                notifyOnNetworkStatusChange: notifyOnNetworkStatusChange,
                metadata: { reactComponent: { displayName: displayName } },
                context: context,
            });
        };
        Query.prototype.initializeQueryObservable = function (props) {
            var opts = this.extractOptsFromProps(props);
            this.setOperations(opts);
            this.queryObservable = this.client.watchQuery(opts);
        };
        Query.prototype.setOperations = function (props) {
            if (this.context.operations) {
                this.context.operations.set(this.operation.name, {
                    query: props.query,
                    variables: props.variables,
                });
            }
        };
        Query.prototype.updateQuery = function (props) {
            if (!this.queryObservable) {
                this.initializeQueryObservable(props);
            }
            else {
                this.setOperations(props);
            }
            this.queryObservable.setOptions(this.extractOptsFromProps(props))
                .catch(function () { return null; });
        };
        Query.prototype.resubscribeToQuery = function () {
            this.removeQuerySubscription();
            var lastError = this.queryObservable.getLastError();
            var lastResult = this.queryObservable.getLastResult();
            this.queryObservable.resetLastResults();
            this.startQuerySubscription();
            Object.assign(this.queryObservable, { lastError: lastError, lastResult: lastResult });
        };
        Query.contextTypes = {
            client: PropTypes.object,
            operations: PropTypes.object,
            renderPromises: PropTypes.object,
        };
        Query.propTypes = {
            client: PropTypes.object,
            children: PropTypes.func.isRequired,
            fetchPolicy: PropTypes.string,
            notifyOnNetworkStatusChange: PropTypes.bool,
            onCompleted: PropTypes.func,
            onError: PropTypes.func,
            pollInterval: PropTypes.number,
            query: PropTypes.object.isRequired,
            variables: PropTypes.object,
            ssr: PropTypes.bool,
            partialRefetch: PropTypes.bool,
        };
        return Query;
    }(React.Component));

    var __extends$3 = (undefined && undefined.__extends) || (function () {
        var extendStatics = function (d, b) {
            extendStatics = Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
                function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
            return extendStatics(d, b);
        };
        return function (d, b) {
            extendStatics(d, b);
            function __() { this.constructor = d; }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    })();
    var __assign$2 = (undefined && undefined.__assign) || function () {
        __assign$2 = Object.assign || function(t) {
            for (var s, i = 1, n = arguments.length; i < n; i++) {
                s = arguments[i];
                for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                    t[p] = s[p];
            }
            return t;
        };
        return __assign$2.apply(this, arguments);
    };
    var invariant$5 = __webpack_require__(35);
    var shallowEqual$1 = __webpack_require__(342);
    var initialState = {
        loading: false,
        called: false,
        error: undefined,
        data: undefined,
    };
    var Mutation = (function (_super) {
        __extends$3(Mutation, _super);
        function Mutation(props, context) {
            var _this = _super.call(this, props, context) || this;
            _this.hasMounted = false;
            _this.runMutation = function (options) {
                if (options === void 0) { options = {}; }
                _this.onMutationStart();
                var mutationId = _this.generateNewMutationId();
                return _this.mutate(options)
                    .then(function (response) {
                    _this.onMutationCompleted(response, mutationId);
                    return response;
                })
                    .catch(function (e) {
                    _this.onMutationError(e, mutationId);
                    if (!_this.props.onError)
                        throw e;
                });
            };
            _this.mutate = function (options) {
                var _a = _this.props, mutation = _a.mutation, variables = _a.variables, optimisticResponse = _a.optimisticResponse, update = _a.update, _b = _a.context, context = _b === void 0 ? {} : _b, _c = _a.awaitRefetchQueries, awaitRefetchQueries = _c === void 0 ? false : _c, fetchPolicy = _a.fetchPolicy;
                var mutateOptions = __assign$2({}, options);
                var refetchQueries = mutateOptions.refetchQueries || _this.props.refetchQueries;
                if (refetchQueries && refetchQueries.length && Array.isArray(refetchQueries)) {
                    refetchQueries = refetchQueries.map(function (x) {
                        if (typeof x === 'string' && _this.context.operations)
                            return _this.context.operations.get(x) || x;
                        return x;
                    });
                    delete mutateOptions.refetchQueries;
                }
                var mutateVariables = Object.assign({}, variables, mutateOptions.variables);
                delete mutateOptions.variables;
                return _this.client.mutate(__assign$2({ mutation: mutation,
                    optimisticResponse: optimisticResponse,
                    refetchQueries: refetchQueries,
                    awaitRefetchQueries: awaitRefetchQueries,
                    update: update,
                    context: context,
                    fetchPolicy: fetchPolicy, variables: mutateVariables }, mutateOptions));
            };
            _this.onMutationStart = function () {
                if (!_this.state.loading && !_this.props.ignoreResults) {
                    _this.setState({
                        loading: true,
                        error: undefined,
                        data: undefined,
                        called: true,
                    });
                }
            };
            _this.onMutationCompleted = function (response, mutationId) {
                if (_this.hasMounted === false) {
                    return;
                }
                var _a = _this.props, onCompleted = _a.onCompleted, ignoreResults = _a.ignoreResults;
                var data = response.data, errors = response.errors;
                var error = errors && errors.length > 0 ? new apolloClient.ApolloError({ graphQLErrors: errors }) : undefined;
                var callOncomplete = function () { return (onCompleted ? onCompleted(data) : null); };
                if (_this.isMostRecentMutation(mutationId) && !ignoreResults) {
                    _this.setState({ loading: false, data: data, error: error }, callOncomplete);
                }
                else {
                    callOncomplete();
                }
            };
            _this.onMutationError = function (error, mutationId) {
                if (_this.hasMounted === false) {
                    return;
                }
                var onError = _this.props.onError;
                var callOnError = function () { return (onError ? onError(error) : null); };
                if (_this.isMostRecentMutation(mutationId)) {
                    _this.setState({ loading: false, error: error }, callOnError);
                }
                else {
                    callOnError();
                }
            };
            _this.generateNewMutationId = function () {
                _this.mostRecentMutationId = _this.mostRecentMutationId + 1;
                return _this.mostRecentMutationId;
            };
            _this.isMostRecentMutation = function (mutationId) {
                return _this.mostRecentMutationId === mutationId;
            };
            _this.verifyDocumentIsMutation = function (mutation) {
                var operation = parser(mutation);
                invariant$5(operation.type === DocumentType.Mutation, "The <Mutation /> component requires a graphql mutation, but got a " + (operation.type === DocumentType.Query ? 'query' : 'subscription') + ".");
            };
            _this.client = getClient(props, context);
            _this.verifyDocumentIsMutation(props.mutation);
            _this.mostRecentMutationId = 0;
            _this.state = initialState;
            return _this;
        }
        Mutation.prototype.componentDidMount = function () {
            this.hasMounted = true;
        };
        Mutation.prototype.componentWillUnmount = function () {
            this.hasMounted = false;
        };
        Mutation.prototype.componentWillReceiveProps = function (nextProps, nextContext) {
            var nextClient = getClient(nextProps, nextContext);
            if (shallowEqual$1(this.props, nextProps) && this.client === nextClient) {
                return;
            }
            if (this.props.mutation !== nextProps.mutation) {
                this.verifyDocumentIsMutation(nextProps.mutation);
            }
            if (this.client !== nextClient) {
                this.client = nextClient;
                this.setState(initialState);
            }
        };
        Mutation.prototype.render = function () {
            var children = this.props.children;
            var _a = this.state, loading = _a.loading, data = _a.data, error = _a.error, called = _a.called;
            var result = {
                called: called,
                loading: loading,
                data: data,
                error: error,
                client: this.client,
            };
            return children(this.runMutation, result);
        };
        Mutation.contextTypes = {
            client: PropTypes.object.isRequired,
            operations: PropTypes.object,
        };
        Mutation.propTypes = {
            mutation: PropTypes.object.isRequired,
            variables: PropTypes.object,
            optimisticResponse: PropTypes.object,
            refetchQueries: PropTypes.oneOfType([
                PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.object])),
                PropTypes.func,
            ]),
            awaitRefetchQueries: PropTypes.bool,
            update: PropTypes.func,
            children: PropTypes.func.isRequired,
            onCompleted: PropTypes.func,
            onError: PropTypes.func,
            fetchPolicy: PropTypes.string,
        };
        return Mutation;
    }(React.Component));

    var __extends$4 = (undefined && undefined.__extends) || (function () {
        var extendStatics = function (d, b) {
            extendStatics = Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
                function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
            return extendStatics(d, b);
        };
        return function (d, b) {
            extendStatics(d, b);
            function __() { this.constructor = d; }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    })();
    var shallowEqual$2 = __webpack_require__(342);
    var invariant$6 = __webpack_require__(35);
    var Subscription = (function (_super) {
        __extends$4(Subscription, _super);
        function Subscription(props, context) {
            var _this = _super.call(this, props, context) || this;
            _this.initialize = function (props) {
                if (_this.queryObservable)
                    return;
                _this.queryObservable = _this.client.subscribe({
                    query: props.subscription,
                    variables: props.variables,
                    fetchPolicy: props.fetchPolicy,
                });
            };
            _this.startSubscription = function () {
                if (_this.querySubscription)
                    return;
                _this.querySubscription = _this.queryObservable.subscribe({
                    next: _this.updateCurrentData,
                    error: _this.updateError,
                });
            };
            _this.getInitialState = function () { return ({
                loading: true,
                error: undefined,
                data: undefined,
            }); };
            _this.updateCurrentData = function (result) {
                var _a = _this, client = _a.client, onSubscriptionData = _a.props.onSubscriptionData;
                if (onSubscriptionData)
                    onSubscriptionData({ client: client, subscriptionData: result });
                _this.setState({
                    data: result.data,
                    loading: false,
                    error: undefined,
                });
            };
            _this.updateError = function (error) {
                _this.setState({
                    error: error,
                    loading: false,
                });
            };
            _this.endSubscription = function () {
                if (_this.querySubscription) {
                    _this.querySubscription.unsubscribe();
                    delete _this.querySubscription;
                }
            };
            _this.client = getClient(props, context);
            _this.initialize(props);
            _this.state = _this.getInitialState();
            return _this;
        }
        Subscription.prototype.componentDidMount = function () {
            this.startSubscription();
        };
        Subscription.prototype.componentWillReceiveProps = function (nextProps, nextContext) {
            var nextClient = getClient(nextProps, nextContext);
            if (shallowEqual$2(this.props.variables, nextProps.variables) &&
                this.client === nextClient &&
                this.props.subscription === nextProps.subscription) {
                return;
            }
            var shouldResubscribe = nextProps.shouldResubscribe;
            if (typeof shouldResubscribe === 'function') {
                shouldResubscribe = !!shouldResubscribe(this.props, nextProps);
            }
            var shouldNotResubscribe = shouldResubscribe === false;
            if (this.client !== nextClient) {
                this.client = nextClient;
            }
            if (!shouldNotResubscribe) {
                this.endSubscription();
                delete this.queryObservable;
                this.initialize(nextProps);
                this.startSubscription();
                this.setState(this.getInitialState());
                return;
            }
            this.initialize(nextProps);
            this.startSubscription();
        };
        Subscription.prototype.componentWillUnmount = function () {
            this.endSubscription();
        };
        Subscription.prototype.render = function () {
            var renderFn = this.props.children;
            if (!renderFn)
                return null;
            var result = Object.assign({}, this.state, {
                variables: this.props.variables,
            });
            return renderFn(result);
        };
        Subscription.contextTypes = {
            client: PropTypes.object.isRequired,
        };
        Subscription.propTypes = {
            subscription: PropTypes.object.isRequired,
            variables: PropTypes.object,
            children: PropTypes.func,
            onSubscriptionData: PropTypes.func,
            shouldResubscribe: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]),
        };
        return Subscription;
    }(React.Component));

    var __extends$5 = (undefined && undefined.__extends) || (function () {
        var extendStatics = function (d, b) {
            extendStatics = Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
                function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
            return extendStatics(d, b);
        };
        return function (d, b) {
            extendStatics(d, b);
            function __() { this.constructor = d; }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    })();
    var invariant$7 = __webpack_require__(35);
    var defaultMapPropsToOptions = function () { return ({}); };
    var defaultMapPropsToSkip = function () { return false; };
    function getDisplayName(WrappedComponent) {
        return WrappedComponent.displayName || WrappedComponent.name || 'Component';
    }
    function calculateVariablesFromProps(operation, props, graphQLDisplayName, wrapperName) {
        var variables = {};
        for (var _i = 0, _a = operation.variables; _i < _a.length; _i++) {
            var _b = _a[_i], variable = _b.variable, type = _b.type;
            if (!variable.name || !variable.name.value)
                continue;
            var variableName = variable.name.value;
            var variableProp = props[variableName];
            if (typeof variableProp !== 'undefined') {
                variables[variableName] = variableProp;
                continue;
            }
            if (type.kind !== 'NonNullType') {
                variables[variableName] = null;
                continue;
            }
            if (operation.type === DocumentType.Mutation)
                return;
            invariant$7(typeof variableProp !== 'undefined', "The operation '" + operation.name + "' wrapping '" + wrapperName + "' " +
                ("is expecting a variable: '" + variable.name.value + "' but it was not found in the props ") +
                ("passed to '" + graphQLDisplayName + "'"));
        }
        return variables;
    }
    var GraphQLBase = (function (_super) {
        __extends$5(GraphQLBase, _super);
        function GraphQLBase(props) {
            var _this = _super.call(this, props) || this;
            _this.withRef = false;
            _this.setWrappedInstance = _this.setWrappedInstance.bind(_this);
            return _this;
        }
        GraphQLBase.prototype.getWrappedInstance = function () {
            invariant$7(this.withRef, "To access the wrapped instance, you need to specify " + "{ withRef: true } in the options");
            return this.wrappedInstance;
        };
        GraphQLBase.prototype.setWrappedInstance = function (ref) {
            this.wrappedInstance = ref;
        };
        return GraphQLBase;
    }(React.Component));

    var __extends$6 = (undefined && undefined.__extends) || (function () {
        var extendStatics = function (d, b) {
            extendStatics = Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
                function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
            return extendStatics(d, b);
        };
        return function (d, b) {
            extendStatics(d, b);
            function __() { this.constructor = d; }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    })();
    var __assign$3 = (undefined && undefined.__assign) || function () {
        __assign$3 = Object.assign || function(t) {
            for (var s, i = 1, n = arguments.length; i < n; i++) {
                s = arguments[i];
                for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                    t[p] = s[p];
            }
            return t;
        };
        return __assign$3.apply(this, arguments);
    };
    var __rest$1 = (undefined && undefined.__rest) || function (s, e) {
        var t = {};
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
            t[p] = s[p];
        if (s != null && typeof Object.getOwnPropertySymbols === "function")
            for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
                t[p[i]] = s[p[i]];
        return t;
    };
    var hoistNonReactStatics = __webpack_require__(230);
    function withQuery(document, operationOptions) {
        if (operationOptions === void 0) { operationOptions = {}; }
        var operation = parser(document);
        var _a = operationOptions.options, options = _a === void 0 ? defaultMapPropsToOptions : _a, _b = operationOptions.skip, skip = _b === void 0 ? defaultMapPropsToSkip : _b, _c = operationOptions.alias, alias = _c === void 0 ? 'Apollo' : _c;
        var mapPropsToOptions = options;
        if (typeof mapPropsToOptions !== 'function') {
            mapPropsToOptions = function () { return options; };
        }
        var mapPropsToSkip = skip;
        if (typeof mapPropsToSkip !== 'function') {
            mapPropsToSkip = function () { return skip; };
        }
        var lastResultProps;
        return function (WrappedComponent) {
            var graphQLDisplayName = alias + "(" + getDisplayName(WrappedComponent) + ")";
            var GraphQL = (function (_super) {
                __extends$6(GraphQL, _super);
                function GraphQL() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                GraphQL.prototype.render = function () {
                    var _this = this;
                    var props = this.props;
                    var shouldSkip = mapPropsToSkip(props);
                    var opts = shouldSkip ? Object.create(null) : __assign$3({}, mapPropsToOptions(props));
                    if (!shouldSkip && !opts.variables && operation.variables.length > 0) {
                        opts.variables = calculateVariablesFromProps(operation, props, graphQLDisplayName, getDisplayName(WrappedComponent));
                    }
                    return (React.createElement(Query, __assign$3({}, opts, { displayName: graphQLDisplayName, skip: shouldSkip, query: document, warnUnhandledError: true }), function (_a) {
                        var _ = _a.client, data = _a.data, r = __rest$1(_a, ["client", "data"]);
                        var _b, _c;
                        if (operationOptions.withRef) {
                            _this.withRef = true;
                            props = Object.assign({}, props, {
                                ref: _this.setWrappedInstance,
                            });
                        }
                        if (shouldSkip)
                            return React.createElement(WrappedComponent, __assign$3({}, props));
                        var result = Object.assign(r, data || {});
                        var name = operationOptions.name || 'data';
                        var childProps = (_b = {}, _b[name] = result, _b);
                        if (operationOptions.props) {
                            var newResult = (_c = {},
                                _c[name] = result,
                                _c.ownProps = props,
                                _c);
                            lastResultProps = operationOptions.props(newResult, lastResultProps);
                            childProps = lastResultProps;
                        }
                        return React.createElement(WrappedComponent, __assign$3({}, props, childProps));
                    }));
                };
                GraphQL.displayName = graphQLDisplayName;
                GraphQL.WrappedComponent = WrappedComponent;
                return GraphQL;
            }(GraphQLBase));
            return hoistNonReactStatics(GraphQL, WrappedComponent, {});
        };
    }

    var __extends$7 = (undefined && undefined.__extends) || (function () {
        var extendStatics = function (d, b) {
            extendStatics = Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
                function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
            return extendStatics(d, b);
        };
        return function (d, b) {
            extendStatics(d, b);
            function __() { this.constructor = d; }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    })();
    var __assign$4 = (undefined && undefined.__assign) || function () {
        __assign$4 = Object.assign || function(t) {
            for (var s, i = 1, n = arguments.length; i < n; i++) {
                s = arguments[i];
                for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                    t[p] = s[p];
            }
            return t;
        };
        return __assign$4.apply(this, arguments);
    };
    var hoistNonReactStatics$1 = __webpack_require__(230);
    function withMutation(document, operationOptions) {
        if (operationOptions === void 0) { operationOptions = {}; }
        var operation = parser(document);
        var _a = operationOptions.options, options = _a === void 0 ? defaultMapPropsToOptions : _a, _b = operationOptions.alias, alias = _b === void 0 ? 'Apollo' : _b;
        var mapPropsToOptions = options;
        if (typeof mapPropsToOptions !== 'function')
            mapPropsToOptions = function () { return options; };
        return function (WrappedComponent) {
            var graphQLDisplayName = alias + "(" + getDisplayName(WrappedComponent) + ")";
            var GraphQL = (function (_super) {
                __extends$7(GraphQL, _super);
                function GraphQL() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                GraphQL.prototype.render = function () {
                    var props = this.props;
                    var opts = mapPropsToOptions(props);
                    if (operationOptions.withRef) {
                        this.withRef = true;
                        props = Object.assign({}, props, {
                            ref: this.setWrappedInstance,
                        });
                    }
                    if (!opts.variables && operation.variables.length > 0) {
                        opts.variables = calculateVariablesFromProps(operation, props, graphQLDisplayName, getDisplayName(WrappedComponent));
                    }
                    return (React.createElement(Mutation, __assign$4({}, opts, { mutation: document, ignoreResults: true }), function (mutate, _result) {
                        var _a, _b;
                        var name = operationOptions.name || 'mutate';
                        var childProps = (_a = {}, _a[name] = mutate, _a);
                        if (operationOptions.props) {
                            var newResult = (_b = {},
                                _b[name] = mutate,
                                _b.ownProps = props,
                                _b);
                            childProps = operationOptions.props(newResult);
                        }
                        return React.createElement(WrappedComponent, __assign$4({}, props, childProps));
                    }));
                };
                GraphQL.displayName = graphQLDisplayName;
                GraphQL.WrappedComponent = WrappedComponent;
                return GraphQL;
            }(GraphQLBase));
            return hoistNonReactStatics$1(GraphQL, WrappedComponent, {});
        };
    }

    var __extends$8 = (undefined && undefined.__extends) || (function () {
        var extendStatics = function (d, b) {
            extendStatics = Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
                function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
            return extendStatics(d, b);
        };
        return function (d, b) {
            extendStatics(d, b);
            function __() { this.constructor = d; }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    })();
    var __assign$5 = (undefined && undefined.__assign) || function () {
        __assign$5 = Object.assign || function(t) {
            for (var s, i = 1, n = arguments.length; i < n; i++) {
                s = arguments[i];
                for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                    t[p] = s[p];
            }
            return t;
        };
        return __assign$5.apply(this, arguments);
    };
    var __rest$2 = (undefined && undefined.__rest) || function (s, e) {
        var t = {};
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
            t[p] = s[p];
        if (s != null && typeof Object.getOwnPropertySymbols === "function")
            for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
                t[p[i]] = s[p[i]];
        return t;
    };
    var hoistNonReactStatics$2 = __webpack_require__(230);
    function withSubscription(document, operationOptions) {
        if (operationOptions === void 0) { operationOptions = {}; }
        var operation = parser(document);
        var _a = operationOptions.options, options = _a === void 0 ? defaultMapPropsToOptions : _a, _b = operationOptions.skip, skip = _b === void 0 ? defaultMapPropsToSkip : _b, _c = operationOptions.alias, alias = _c === void 0 ? 'Apollo' : _c, shouldResubscribe = operationOptions.shouldResubscribe;
        var mapPropsToOptions = options;
        if (typeof mapPropsToOptions !== 'function')
            mapPropsToOptions = function () { return options; };
        var mapPropsToSkip = skip;
        if (typeof mapPropsToSkip !== 'function')
            mapPropsToSkip = function () { return skip; };
        var lastResultProps;
        return function (WrappedComponent) {
            var graphQLDisplayName = alias + "(" + getDisplayName(WrappedComponent) + ")";
            var GraphQL = (function (_super) {
                __extends$8(GraphQL, _super);
                function GraphQL(props) {
                    var _this = _super.call(this, props) || this;
                    _this.state = { resubscribe: false };
                    return _this;
                }
                GraphQL.prototype.componentWillReceiveProps = function (nextProps) {
                    if (!shouldResubscribe)
                        return;
                    this.setState({
                        resubscribe: shouldResubscribe(this.props, nextProps),
                    });
                };
                GraphQL.prototype.render = function () {
                    var _this = this;
                    var props = this.props;
                    var shouldSkip = mapPropsToSkip(props);
                    var opts = shouldSkip ? Object.create(null) : mapPropsToOptions(props);
                    if (!shouldSkip && !opts.variables && operation.variables.length > 0) {
                        opts.variables = calculateVariablesFromProps(operation, props, graphQLDisplayName, getDisplayName(WrappedComponent));
                    }
                    return (React.createElement(Subscription, __assign$5({}, opts, { displayName: graphQLDisplayName, skip: shouldSkip, subscription: document, shouldResubscribe: this.state.resubscribe }), function (_a) {
                        var data = _a.data, r = __rest$2(_a, ["data"]);
                        var _b, _c;
                        if (operationOptions.withRef) {
                            _this.withRef = true;
                            props = Object.assign({}, props, {
                                ref: _this.setWrappedInstance,
                            });
                        }
                        if (shouldSkip)
                            return React.createElement(WrappedComponent, __assign$5({}, props));
                        var result = Object.assign(r, data || {});
                        var name = operationOptions.name || 'data';
                        var childProps = (_b = {}, _b[name] = result, _b);
                        if (operationOptions.props) {
                            var newResult = (_c = {},
                                _c[name] = result,
                                _c.ownProps = props,
                                _c);
                            lastResultProps = operationOptions.props(newResult, lastResultProps);
                            childProps = lastResultProps;
                        }
                        return React.createElement(WrappedComponent, __assign$5({}, props, childProps));
                    }));
                };
                GraphQL.displayName = graphQLDisplayName;
                GraphQL.WrappedComponent = WrappedComponent;
                return GraphQL;
            }(GraphQLBase));
            return hoistNonReactStatics$2(GraphQL, WrappedComponent, {});
        };
    }

    function graphql(document, operationOptions) {
        if (operationOptions === void 0) { operationOptions = {}; }
        switch (parser(document).type) {
            case DocumentType.Mutation:
                return withMutation(document, operationOptions);
            case DocumentType.Subscription:
                return withSubscription(document, operationOptions);
            case DocumentType.Query:
            default:
                return withQuery(document, operationOptions);
        }
    }

    var __extends$9 = (undefined && undefined.__extends) || (function () {
        var extendStatics = function (d, b) {
            extendStatics = Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
                function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
            return extendStatics(d, b);
        };
        return function (d, b) {
            extendStatics(d, b);
            function __() { this.constructor = d; }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    })();
    var __assign$6 = (undefined && undefined.__assign) || function () {
        __assign$6 = Object.assign || function(t) {
            for (var s, i = 1, n = arguments.length; i < n; i++) {
                s = arguments[i];
                for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                    t[p] = s[p];
            }
            return t;
        };
        return __assign$6.apply(this, arguments);
    };
    var invariant$8 = __webpack_require__(35);
    var hoistNonReactStatics$3 = __webpack_require__(230);
    function getDisplayName$1(WrappedComponent) {
        return WrappedComponent.displayName || WrappedComponent.name || 'Component';
    }
    function withApollo(WrappedComponent, operationOptions) {
        if (operationOptions === void 0) { operationOptions = {}; }
        var withDisplayName = "withApollo(" + getDisplayName$1(WrappedComponent) + ")";
        var WithApollo = (function (_super) {
            __extends$9(WithApollo, _super);
            function WithApollo(props) {
                var _this = _super.call(this, props) || this;
                _this.setWrappedInstance = _this.setWrappedInstance.bind(_this);
                return _this;
            }
            WithApollo.prototype.getWrappedInstance = function () {
                invariant$8(operationOptions.withRef, "To access the wrapped instance, you need to specify " + "{ withRef: true } in the options");
                return this.wrappedInstance;
            };
            WithApollo.prototype.setWrappedInstance = function (ref) {
                this.wrappedInstance = ref;
            };
            WithApollo.prototype.render = function () {
                var _this = this;
                return (React.createElement(ApolloConsumer, null, function (client) {
                    var props = Object.assign({}, _this.props, {
                        client: client,
                        ref: operationOptions.withRef ? _this.setWrappedInstance : undefined,
                    });
                    return React.createElement(WrappedComponent, __assign$6({}, props));
                }));
            };
            WithApollo.displayName = withDisplayName;
            WithApollo.WrappedComponent = WrappedComponent;
            return WithApollo;
        }(React.Component));
        return hoistNonReactStatics$3(WithApollo, WrappedComponent, {});
    }

    function getProps(element) {
        return element.props || element.attributes;
    }
    function isReactElement(element) {
        return !!element.type;
    }
    function isComponentClass(Comp) {
        return Comp.prototype && (Comp.prototype.render || Comp.prototype.isReactComponent);
    }
    function providesChildContext(instance) {
        return !!instance.getChildContext;
    }
    function walkTree(element, context, visitor, newContext) {
        if (newContext === void 0) { newContext = new Map(); }
        if (!element) {
            return;
        }
        if (Array.isArray(element)) {
            element.forEach(function (item) { return walkTree(item, context, visitor, newContext); });
            return;
        }
        if (isReactElement(element)) {
            if (typeof element.type === 'function') {
                var Comp = element.type;
                var props = Object.assign({}, Comp.defaultProps, getProps(element));
                var childContext_1 = context;
                var child = void 0;
                if (isComponentClass(Comp)) {
                    var instance_1 = new Comp(props, context);
                    Object.defineProperty(instance_1, 'props', {
                        value: instance_1.props || props,
                    });
                    instance_1.context = instance_1.context || context;
                    instance_1.state = instance_1.state || null;
                    instance_1.setState = function (newState) {
                        if (typeof newState === 'function') {
                            newState = newState(instance_1.state, instance_1.props, instance_1.context);
                        }
                        instance_1.state = Object.assign({}, instance_1.state, newState);
                    };
                    if (Comp.getDerivedStateFromProps) {
                        var result = Comp.getDerivedStateFromProps(instance_1.props, instance_1.state);
                        if (result !== null) {
                            instance_1.state = Object.assign({}, instance_1.state, result);
                        }
                    }
                    else if (instance_1.UNSAFE_componentWillMount) {
                        instance_1.UNSAFE_componentWillMount();
                    }
                    else if (instance_1.componentWillMount) {
                        instance_1.componentWillMount();
                    }
                    if (providesChildContext(instance_1)) {
                        childContext_1 = Object.assign({}, context, instance_1.getChildContext());
                    }
                    if (visitor(element, instance_1, newContext, context, childContext_1) === false) {
                        return;
                    }
                    child = instance_1.render();
                }
                else {
                    if (visitor(element, null, newContext, context) === false) {
                        return;
                    }
                    child = Comp(props, context);
                }
                if (child) {
                    if (Array.isArray(child)) {
                        child.forEach(function (item) { return walkTree(item, childContext_1, visitor, newContext); });
                    }
                    else {
                        walkTree(child, childContext_1, visitor, newContext);
                    }
                }
            }
            else if (element.type._context || element.type.Consumer) {
                if (visitor(element, null, newContext, context) === false) {
                    return;
                }
                var child = void 0;
                if (!!element.type._context) {
                    newContext = new Map(newContext);
                    newContext.set(element.type, element.props.value);
                    child = element.props.children;
                }
                else {
                    var value = element.type._currentValue;
                    if (newContext.has(element.type.Provider)) {
                        value = newContext.get(element.type.Provider);
                    }
                    child = element.props.children(value);
                }
                if (child) {
                    if (Array.isArray(child)) {
                        child.forEach(function (item) { return walkTree(item, context, visitor, newContext); });
                    }
                    else {
                        walkTree(child, context, visitor, newContext);
                    }
                }
            }
            else {
                if (visitor(element, null, newContext, context) === false) {
                    return;
                }
                if (element.props && element.props.children) {
                    React.Children.forEach(element.props.children, function (child) {
                        if (child) {
                            walkTree(child, context, visitor, newContext);
                        }
                    });
                }
            }
        }
        else if (typeof element === 'string' || typeof element === 'number') {
            visitor(element, null, newContext, context);
        }
    }

    var compose = __webpack_require__(1129);

    exports.compose = compose;
    exports.getDataFromTree = getDataFromTree;
    exports.ApolloConsumer = ApolloConsumer;
    exports.ApolloProvider = ApolloProvider;
    exports.Query = Query;
    exports.Mutation = Mutation;
    exports.Subscription = Subscription;
    exports.graphql = graphql;
    exports.withQuery = withQuery;
    exports.withMutation = withMutation;
    exports.withSubscription = withSubscription;
    exports.withApollo = withApollo;
    exports.RenderPromises = RenderPromises;
    exports.getMarkupFromTree = getMarkupFromTree;
    exports.walkTree = walkTree;

    Object.defineProperty(exports, '__esModule', { value: true });

})));
//# sourceMappingURL=react-apollo.browser.umd.js.map


/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export actionTypes */
/* unused harmony export arrayInsert */
/* unused harmony export arrayMove */
/* unused harmony export arrayPop */
/* unused harmony export arrayPush */
/* unused harmony export arrayRemove */
/* unused harmony export arrayRemoveAll */
/* unused harmony export arrayShift */
/* unused harmony export arraySplice */
/* unused harmony export arraySwap */
/* unused harmony export arrayUnshift */
/* unused harmony export autofill */
/* unused harmony export blur */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return change; });
/* unused harmony export clearAsyncError */
/* unused harmony export clearFields */
/* unused harmony export clearSubmitErrors */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return destroy; });
/* unused harmony export focus */
/* unused harmony export initialize */
/* unused harmony export registerField */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return reset; });
/* unused harmony export resetSection */
/* unused harmony export setSubmitFailed */
/* unused harmony export setSubmitSucceeded */
/* unused harmony export startAsyncValidation */
/* unused harmony export startSubmit */
/* unused harmony export stopAsyncValidation */
/* unused harmony export stopSubmit */
/* unused harmony export submit */
/* unused harmony export touch */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return unregisterField; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return untouch; });
/* unused harmony export updateSyncWarnings */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(529);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actionTypes__ = __webpack_require__(344);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__defaultShouldAsyncValidate__ = __webpack_require__(530);
/* unused harmony reexport defaultShouldAsyncValidate */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__defaultShouldValidate__ = __webpack_require__(531);
/* unused harmony reexport defaultShouldValidate */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__defaultShouldError__ = __webpack_require__(532);
/* unused harmony reexport defaultShouldError */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__defaultShouldWarn__ = __webpack_require__(533);
/* unused harmony reexport defaultShouldWarn */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Form__ = __webpack_require__(1130);
/* unused harmony reexport Form */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__FormName__ = __webpack_require__(1131);
/* unused harmony reexport FormName */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__FormSection__ = __webpack_require__(1132);
/* unused harmony reexport FormSection */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__SubmissionError__ = __webpack_require__(534);
/* unused harmony reexport SubmissionError */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__propTypes__ = __webpack_require__(1134);
/* unused harmony reexport propTypes */
/* unused harmony reexport fieldInputPropTypes */
/* unused harmony reexport fieldMetaPropTypes */
/* unused harmony reexport fieldPropTypes */
/* unused harmony reexport fieldArrayFieldsPropTypes */
/* unused harmony reexport fieldArrayMetaPropTypes */
/* unused harmony reexport fieldArrayPropTypes */
/* unused harmony reexport formPropTypes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Field__ = __webpack_require__(1135);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_11__Field__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Fields__ = __webpack_require__(1216);
/* unused harmony reexport Fields */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__FieldArray__ = __webpack_require__(1219);
/* unused harmony reexport FieldArray */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__formValueSelector__ = __webpack_require__(1237);
/* unused harmony reexport formValueSelector */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__formValues__ = __webpack_require__(1239);
/* unused harmony reexport formValues */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__getFormError__ = __webpack_require__(1243);
/* unused harmony reexport getFormError */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__getFormNames__ = __webpack_require__(1245);
/* unused harmony reexport getFormNames */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__getFormValues__ = __webpack_require__(1247);
/* unused harmony reexport getFormValues */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__getFormInitialValues__ = __webpack_require__(1249);
/* unused harmony reexport getFormInitialValues */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__getFormSyncErrors__ = __webpack_require__(1251);
/* unused harmony reexport getFormSyncErrors */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__getFormMeta__ = __webpack_require__(1253);
/* unused harmony reexport getFormMeta */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__getFormAsyncErrors__ = __webpack_require__(1255);
/* unused harmony reexport getFormAsyncErrors */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__getFormSyncWarnings__ = __webpack_require__(1257);
/* unused harmony reexport getFormSyncWarnings */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__getFormSubmitErrors__ = __webpack_require__(1259);
/* unused harmony reexport getFormSubmitErrors */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__isAsyncValidating__ = __webpack_require__(1261);
/* unused harmony reexport isAsyncValidating */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__isDirty__ = __webpack_require__(1263);
/* unused harmony reexport isDirty */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__isInvalid__ = __webpack_require__(1265);
/* unused harmony reexport isInvalid */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__isPristine__ = __webpack_require__(1268);
/* unused harmony reexport isPristine */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__isValid__ = __webpack_require__(1269);
/* unused harmony reexport isValid */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__isSubmitting__ = __webpack_require__(1270);
/* unused harmony reexport isSubmitting */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__hasSubmitSucceeded__ = __webpack_require__(1272);
/* unused harmony reexport hasSubmitSucceeded */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__hasSubmitFailed__ = __webpack_require__(1274);
/* unused harmony reexport hasSubmitFailed */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__reduxForm__ = __webpack_require__(1276);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_33__reduxForm__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__reducer__ = __webpack_require__(1308);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_34__reducer__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__values__ = __webpack_require__(1311);
/* unused harmony reexport values */










// alias for propTypes


























var actionTypes = __WEBPACK_IMPORTED_MODULE_1__actionTypes__;
var arrayInsert = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].arrayInsert;
var arrayMove = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].arrayMove;
var arrayPop = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].arrayPop;
var arrayPush = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].arrayPush;
var arrayRemove = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].arrayRemove;
var arrayRemoveAll = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].arrayRemoveAll;
var arrayShift = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].arrayShift;
var arraySplice = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].arraySplice;
var arraySwap = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].arraySwap;
var arrayUnshift = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].arrayUnshift;
var autofill = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].autofill;
var blur = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].blur;
var change = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].change;
var clearAsyncError = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].clearAsyncError;
var clearFields = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].clearFields;
var clearSubmitErrors = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].clearSubmitErrors;
var destroy = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].destroy;
var focus = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].focus;
var initialize = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].initialize;
var registerField = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].registerField;
var reset = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].reset;
var resetSection = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].resetSection;
var setSubmitFailed = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].setSubmitFailed;
var setSubmitSucceeded = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].setSubmitSucceeded;
var startAsyncValidation = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].startAsyncValidation;
var startSubmit = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].startSubmit;
var stopAsyncValidation = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].stopAsyncValidation;
var stopSubmit = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].stopSubmit;
var submit = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].submit;
var touch = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].touch;
var unregisterField = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].unregisterField;
var untouch = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].untouch;
var updateSyncWarnings = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].updateSyncWarnings;

/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["d"] = Logout;
/* harmony export (immutable) */ __webpack_exports__["c"] = GetUserToken;
/* harmony export (immutable) */ __webpack_exports__["a"] = GetUserId;
/* harmony export (immutable) */ __webpack_exports__["b"] = GetUserKey;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_store__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reducers_LoginReducer__ = __webpack_require__(96);
var CLEAR="sure-quote/Login/CLEAR";function Logout(){__WEBPACK_IMPORTED_MODULE_0_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_reducers_LoginReducer__["a" /* Clear */])({type:CLEAR,props:{}}));localStorage.clear();sessionStorage.clear();}function GetUserToken(){var storeToken=__WEBPACK_IMPORTED_MODULE_0_store__["a" /* default */].getState().login.token;var localToken=localStorage.getItem("token");return storeToken&&storeToken!==""?storeToken:localToken&&localToken!==""?localToken:"";}function GetUserId(){var storeUserId=__WEBPACK_IMPORTED_MODULE_0_store__["a" /* default */].getState().login.userID;var localUserId=localStorage.getItem("id");return storeUserId&&storeUserId!==""?storeUserId:localUserId&&localUserId!==""?localUserId:"";}function GetUserKey(key){var storeKey=__WEBPACK_IMPORTED_MODULE_0_store__["a" /* default */].getState().login[key];var localKey=localStorage.getItem(key);return storeKey&&storeKey!==""?storeKey:localKey&&localKey!==""?localKey:"";}

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, module) {var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright JS Foundation and other contributors <https://js.foundation/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
;(function() {

  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
  var undefined;

  /** Used as the semantic version number. */
  var VERSION = '4.17.11';

  /** Used as the size to enable large array optimizations. */
  var LARGE_ARRAY_SIZE = 200;

  /** Error message constants. */
  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
      FUNC_ERROR_TEXT = 'Expected a function';

  /** Used to stand-in for `undefined` hash values. */
  var HASH_UNDEFINED = '__lodash_hash_undefined__';

  /** Used as the maximum memoize cache size. */
  var MAX_MEMOIZE_SIZE = 500;

  /** Used as the internal argument placeholder. */
  var PLACEHOLDER = '__lodash_placeholder__';

  /** Used to compose bitmasks for cloning. */
  var CLONE_DEEP_FLAG = 1,
      CLONE_FLAT_FLAG = 2,
      CLONE_SYMBOLS_FLAG = 4;

  /** Used to compose bitmasks for value comparisons. */
  var COMPARE_PARTIAL_FLAG = 1,
      COMPARE_UNORDERED_FLAG = 2;

  /** Used to compose bitmasks for function metadata. */
  var WRAP_BIND_FLAG = 1,
      WRAP_BIND_KEY_FLAG = 2,
      WRAP_CURRY_BOUND_FLAG = 4,
      WRAP_CURRY_FLAG = 8,
      WRAP_CURRY_RIGHT_FLAG = 16,
      WRAP_PARTIAL_FLAG = 32,
      WRAP_PARTIAL_RIGHT_FLAG = 64,
      WRAP_ARY_FLAG = 128,
      WRAP_REARG_FLAG = 256,
      WRAP_FLIP_FLAG = 512;

  /** Used as default options for `_.truncate`. */
  var DEFAULT_TRUNC_LENGTH = 30,
      DEFAULT_TRUNC_OMISSION = '...';

  /** Used to detect hot functions by number of calls within a span of milliseconds. */
  var HOT_COUNT = 800,
      HOT_SPAN = 16;

  /** Used to indicate the type of lazy iteratees. */
  var LAZY_FILTER_FLAG = 1,
      LAZY_MAP_FLAG = 2,
      LAZY_WHILE_FLAG = 3;

  /** Used as references for various `Number` constants. */
  var INFINITY = 1 / 0,
      MAX_SAFE_INTEGER = 9007199254740991,
      MAX_INTEGER = 1.7976931348623157e+308,
      NAN = 0 / 0;

  /** Used as references for the maximum length and index of an array. */
  var MAX_ARRAY_LENGTH = 4294967295,
      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;

  /** Used to associate wrap methods with their bit flags. */
  var wrapFlags = [
    ['ary', WRAP_ARY_FLAG],
    ['bind', WRAP_BIND_FLAG],
    ['bindKey', WRAP_BIND_KEY_FLAG],
    ['curry', WRAP_CURRY_FLAG],
    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
    ['flip', WRAP_FLIP_FLAG],
    ['partial', WRAP_PARTIAL_FLAG],
    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
    ['rearg', WRAP_REARG_FLAG]
  ];

  /** `Object#toString` result references. */
  var argsTag = '[object Arguments]',
      arrayTag = '[object Array]',
      asyncTag = '[object AsyncFunction]',
      boolTag = '[object Boolean]',
      dateTag = '[object Date]',
      domExcTag = '[object DOMException]',
      errorTag = '[object Error]',
      funcTag = '[object Function]',
      genTag = '[object GeneratorFunction]',
      mapTag = '[object Map]',
      numberTag = '[object Number]',
      nullTag = '[object Null]',
      objectTag = '[object Object]',
      promiseTag = '[object Promise]',
      proxyTag = '[object Proxy]',
      regexpTag = '[object RegExp]',
      setTag = '[object Set]',
      stringTag = '[object String]',
      symbolTag = '[object Symbol]',
      undefinedTag = '[object Undefined]',
      weakMapTag = '[object WeakMap]',
      weakSetTag = '[object WeakSet]';

  var arrayBufferTag = '[object ArrayBuffer]',
      dataViewTag = '[object DataView]',
      float32Tag = '[object Float32Array]',
      float64Tag = '[object Float64Array]',
      int8Tag = '[object Int8Array]',
      int16Tag = '[object Int16Array]',
      int32Tag = '[object Int32Array]',
      uint8Tag = '[object Uint8Array]',
      uint8ClampedTag = '[object Uint8ClampedArray]',
      uint16Tag = '[object Uint16Array]',
      uint32Tag = '[object Uint32Array]';

  /** Used to match empty string literals in compiled template source. */
  var reEmptyStringLeading = /\b__p \+= '';/g,
      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;

  /** Used to match HTML entities and HTML characters. */
  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
      reUnescapedHtml = /[&<>"']/g,
      reHasEscapedHtml = RegExp(reEscapedHtml.source),
      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

  /** Used to match template delimiters. */
  var reEscape = /<%-([\s\S]+?)%>/g,
      reEvaluate = /<%([\s\S]+?)%>/g,
      reInterpolate = /<%=([\s\S]+?)%>/g;

  /** Used to match property names within property paths. */
  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
      reIsPlainProp = /^\w*$/,
      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

  /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */
  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
      reHasRegExpChar = RegExp(reRegExpChar.source);

  /** Used to match leading and trailing whitespace. */
  var reTrim = /^\s+|\s+$/g,
      reTrimStart = /^\s+/,
      reTrimEnd = /\s+$/;

  /** Used to match wrap detail comments. */
  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
      reSplitDetails = /,? & /;

  /** Used to match words composed of alphanumeric characters. */
  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

  /** Used to match backslashes in property paths. */
  var reEscapeChar = /\\(\\)?/g;

  /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */
  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;

  /** Used to match `RegExp` flags from their coerced string values. */
  var reFlags = /\w*$/;

  /** Used to detect bad signed hexadecimal string values. */
  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

  /** Used to detect binary string values. */
  var reIsBinary = /^0b[01]+$/i;

  /** Used to detect host constructors (Safari). */
  var reIsHostCtor = /^\[object .+?Constructor\]$/;

  /** Used to detect octal string values. */
  var reIsOctal = /^0o[0-7]+$/i;

  /** Used to detect unsigned integer values. */
  var reIsUint = /^(?:0|[1-9]\d*)$/;

  /** Used to match Latin Unicode letters (excluding mathematical operators). */
  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

  /** Used to ensure capturing order of template delimiters. */
  var reNoMatch = /($^)/;

  /** Used to match unescaped characters in compiled string literals. */
  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;

  /** Used to compose unicode character classes. */
  var rsAstralRange = '\\ud800-\\udfff',
      rsComboMarksRange = '\\u0300-\\u036f',
      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
      rsComboSymbolsRange = '\\u20d0-\\u20ff',
      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
      rsDingbatRange = '\\u2700-\\u27bf',
      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
      rsPunctuationRange = '\\u2000-\\u206f',
      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
      rsVarRange = '\\ufe0e\\ufe0f',
      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

  /** Used to compose unicode capture groups. */
  var rsApos = "['\u2019]",
      rsAstral = '[' + rsAstralRange + ']',
      rsBreak = '[' + rsBreakRange + ']',
      rsCombo = '[' + rsComboRange + ']',
      rsDigits = '\\d+',
      rsDingbat = '[' + rsDingbatRange + ']',
      rsLower = '[' + rsLowerRange + ']',
      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
      rsFitz = '\\ud83c[\\udffb-\\udfff]',
      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
      rsNonAstral = '[^' + rsAstralRange + ']',
      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
      rsUpper = '[' + rsUpperRange + ']',
      rsZWJ = '\\u200d';

  /** Used to compose unicode regexes. */
  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
      reOptMod = rsModifier + '?',
      rsOptVar = '[' + rsVarRange + ']?',
      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
      rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
      rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
      rsSeq = rsOptVar + reOptMod + rsOptJoin,
      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

  /** Used to match apostrophes. */
  var reApos = RegExp(rsApos, 'g');

  /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */
  var reComboMark = RegExp(rsCombo, 'g');

  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

  /** Used to match complex or compound words. */
  var reUnicodeWord = RegExp([
    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
    rsUpper + '+' + rsOptContrUpper,
    rsOrdUpper,
    rsOrdLower,
    rsDigits,
    rsEmoji
  ].join('|'), 'g');

  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

  /** Used to detect strings that need a more robust regexp to match words. */
  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

  /** Used to assign default `context` object properties. */
  var contextProps = [
    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
  ];

  /** Used to make template sourceURLs easier to identify. */
  var templateCounter = -1;

  /** Used to identify `toStringTag` values of typed arrays. */
  var typedArrayTags = {};
  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
  typedArrayTags[uint32Tag] = true;
  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
  typedArrayTags[setTag] = typedArrayTags[stringTag] =
  typedArrayTags[weakMapTag] = false;

  /** Used to identify `toStringTag` values supported by `_.clone`. */
  var cloneableTags = {};
  cloneableTags[argsTag] = cloneableTags[arrayTag] =
  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
  cloneableTags[boolTag] = cloneableTags[dateTag] =
  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
  cloneableTags[int32Tag] = cloneableTags[mapTag] =
  cloneableTags[numberTag] = cloneableTags[objectTag] =
  cloneableTags[regexpTag] = cloneableTags[setTag] =
  cloneableTags[stringTag] = cloneableTags[symbolTag] =
  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
  cloneableTags[errorTag] = cloneableTags[funcTag] =
  cloneableTags[weakMapTag] = false;

  /** Used to map Latin Unicode letters to basic Latin letters. */
  var deburredLetters = {
    // Latin-1 Supplement block.
    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
    '\xc7': 'C',  '\xe7': 'c',
    '\xd0': 'D',  '\xf0': 'd',
    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
    '\xd1': 'N',  '\xf1': 'n',
    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
    '\xc6': 'Ae', '\xe6': 'ae',
    '\xde': 'Th', '\xfe': 'th',
    '\xdf': 'ss',
    // Latin Extended-A block.
    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
    '\u0134': 'J',  '\u0135': 'j',
    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
    '\u0174': 'W',  '\u0175': 'w',
    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
    '\u0132': 'IJ', '\u0133': 'ij',
    '\u0152': 'Oe', '\u0153': 'oe',
    '\u0149': "'n", '\u017f': 's'
  };

  /** Used to map characters to HTML entities. */
  var htmlEscapes = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  };

  /** Used to map HTML entities to characters. */
  var htmlUnescapes = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': "'"
  };

  /** Used to escape characters for inclusion in compiled string literals. */
  var stringEscapes = {
    '\\': '\\',
    "'": "'",
    '\n': 'n',
    '\r': 'r',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  /** Built-in method references without a dependency on `root`. */
  var freeParseFloat = parseFloat,
      freeParseInt = parseInt;

  /** Detect free variable `global` from Node.js. */
  var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

  /** Detect free variable `self`. */
  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

  /** Used as a reference to the global object. */
  var root = freeGlobal || freeSelf || Function('return this')();

  /** Detect free variable `exports`. */
  var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

  /** Detect free variable `module`. */
  var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

  /** Detect the popular CommonJS extension `module.exports`. */
  var moduleExports = freeModule && freeModule.exports === freeExports;

  /** Detect free variable `process` from Node.js. */
  var freeProcess = moduleExports && freeGlobal.process;

  /** Used to access faster Node.js helpers. */
  var nodeUtil = (function() {
    try {
      // Use `util.types` for Node.js 10+.
      var types = freeModule && freeModule.require && freeModule.require('util').types;

      if (types) {
        return types;
      }

      // Legacy `process.binding('util')` for Node.js < 10.
      return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
  }());

  /* Node.js helper references. */
  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
      nodeIsDate = nodeUtil && nodeUtil.isDate,
      nodeIsMap = nodeUtil && nodeUtil.isMap,
      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
      nodeIsSet = nodeUtil && nodeUtil.isSet,
      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

  /*--------------------------------------------------------------------------*/

  /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */
  function apply(func, thisArg, args) {
    switch (args.length) {
      case 0: return func.call(thisArg);
      case 1: return func.call(thisArg, args[0]);
      case 2: return func.call(thisArg, args[0], args[1]);
      case 3: return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
  }

  /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */
  function arrayAggregator(array, setter, iteratee, accumulator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      var value = array[index];
      setter(accumulator, value, iteratee(value), array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEach(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (iteratee(array[index], index, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEachRight(array, iteratee) {
    var length = array == null ? 0 : array.length;

    while (length--) {
      if (iteratee(array[length], length, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */
  function arrayEvery(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (!predicate(array[index], index, array)) {
        return false;
      }
    }
    return true;
  }

  /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */
  function arrayFilter(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (predicate(value, index, array)) {
        result[resIndex++] = value;
      }
    }
    return result;
  }

  /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && baseIndexOf(array, value, 0) > -1;
  }

  /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludesWith(array, value, comparator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (comparator(value, array[index])) {
        return true;
      }
    }
    return false;
  }

  /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */
  function arrayMap(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length,
        result = Array(length);

    while (++index < length) {
      result[index] = iteratee(array[index], index, array);
    }
    return result;
  }

  /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */
  function arrayPush(array, values) {
    var index = -1,
        length = values.length,
        offset = array.length;

    while (++index < length) {
      array[offset + index] = values[index];
    }
    return array;
  }

  /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1,
        length = array == null ? 0 : array.length;

    if (initAccum && length) {
      accumulator = array[++index];
    }
    while (++index < length) {
      accumulator = iteratee(accumulator, array[index], index, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
    var length = array == null ? 0 : array.length;
    if (initAccum && length) {
      accumulator = array[--length];
    }
    while (length--) {
      accumulator = iteratee(accumulator, array[length], length, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */
  function arraySome(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (predicate(array[index], index, array)) {
        return true;
      }
    }
    return false;
  }

  /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  var asciiSize = baseProperty('length');

  /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function asciiToArray(string) {
    return string.split('');
  }

  /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function asciiWords(string) {
    return string.match(reAsciiWord) || [];
  }

  /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */
  function baseFindKey(collection, predicate, eachFunc) {
    var result;
    eachFunc(collection, function(value, key, collection) {
      if (predicate(value, key, collection)) {
        result = key;
        return false;
      }
    });
    return result;
  }

  /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length,
        index = fromIndex + (fromRight ? 1 : -1);

    while ((fromRight ? index-- : ++index < length)) {
      if (predicate(array[index], index, array)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOf(array, value, fromIndex) {
    return value === value
      ? strictIndexOf(array, value, fromIndex)
      : baseFindIndex(array, baseIsNaN, fromIndex);
  }

  /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOfWith(array, value, fromIndex, comparator) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (comparator(array[index], value)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */
  function baseIsNaN(value) {
    return value !== value;
  }

  /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */
  function baseMean(array, iteratee) {
    var length = array == null ? 0 : array.length;
    return length ? (baseSum(array, iteratee) / length) : NAN;
  }

  /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */
  function baseProperty(key) {
    return function(object) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */
  function basePropertyOf(object) {
    return function(key) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */
  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
    eachFunc(collection, function(value, index, collection) {
      accumulator = initAccum
        ? (initAccum = false, value)
        : iteratee(accumulator, value, index, collection);
    });
    return accumulator;
  }

  /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */
  function baseSortBy(array, comparer) {
    var length = array.length;

    array.sort(comparer);
    while (length--) {
      array[length] = array[length].value;
    }
    return array;
  }

  /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */
  function baseSum(array, iteratee) {
    var result,
        index = -1,
        length = array.length;

    while (++index < length) {
      var current = iteratee(array[index]);
      if (current !== undefined) {
        result = result === undefined ? current : (result + current);
      }
    }
    return result;
  }

  /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */
  function baseTimes(n, iteratee) {
    var index = -1,
        result = Array(n);

    while (++index < n) {
      result[index] = iteratee(index);
    }
    return result;
  }

  /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */
  function baseToPairs(object, props) {
    return arrayMap(props, function(key) {
      return [key, object[key]];
    });
  }

  /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */
  function baseUnary(func) {
    return function(value) {
      return func(value);
    };
  }

  /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */
  function baseValues(object, props) {
    return arrayMap(props, function(key) {
      return object[key];
    });
  }

  /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function cacheHas(cache, key) {
    return cache.has(key);
  }

  /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */
  function charsStartIndex(strSymbols, chrSymbols) {
    var index = -1,
        length = strSymbols.length;

    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */
  function charsEndIndex(strSymbols, chrSymbols) {
    var index = strSymbols.length;

    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */
  function countHolders(array, placeholder) {
    var length = array.length,
        result = 0;

    while (length--) {
      if (array[length] === placeholder) {
        ++result;
      }
    }
    return result;
  }

  /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */
  var deburrLetter = basePropertyOf(deburredLetters);

  /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  var escapeHtmlChar = basePropertyOf(htmlEscapes);

  /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  function escapeStringChar(chr) {
    return '\\' + stringEscapes[chr];
  }

  /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */
  function getValue(object, key) {
    return object == null ? undefined : object[key];
  }

  /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */
  function hasUnicode(string) {
    return reHasUnicode.test(string);
  }

  /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */
  function hasUnicodeWord(string) {
    return reHasUnicodeWord.test(string);
  }

  /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */
  function iteratorToArray(iterator) {
    var data,
        result = [];

    while (!(data = iterator.next()).done) {
      result.push(data.value);
    }
    return result;
  }

  /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */
  function mapToArray(map) {
    var index = -1,
        result = Array(map.size);

    map.forEach(function(value, key) {
      result[++index] = [key, value];
    });
    return result;
  }

  /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */
  function overArg(func, transform) {
    return function(arg) {
      return func(transform(arg));
    };
  }

  /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */
  function replaceHolders(array, placeholder) {
    var index = -1,
        length = array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (value === placeholder || value === PLACEHOLDER) {
        array[index] = PLACEHOLDER;
        result[resIndex++] = index;
      }
    }
    return result;
  }

  /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */
  function setToArray(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = value;
    });
    return result;
  }

  /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */
  function setToPairs(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = [value, value];
    });
    return result;
  }

  /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (array[index] === value) {
        return index;
      }
    }
    return -1;
  }

  /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictLastIndexOf(array, value, fromIndex) {
    var index = fromIndex + 1;
    while (index--) {
      if (array[index] === value) {
        return index;
      }
    }
    return index;
  }

  /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */
  function stringSize(string) {
    return hasUnicode(string)
      ? unicodeSize(string)
      : asciiSize(string);
  }

  /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function stringToArray(string) {
    return hasUnicode(string)
      ? unicodeToArray(string)
      : asciiToArray(string);
  }

  /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */
  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);

  /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  function unicodeSize(string) {
    var result = reUnicode.lastIndex = 0;
    while (reUnicode.test(string)) {
      ++result;
    }
    return result;
  }

  /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function unicodeToArray(string) {
    return string.match(reUnicode) || [];
  }

  /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function unicodeWords(string) {
    return string.match(reUnicodeWord) || [];
  }

  /*--------------------------------------------------------------------------*/

  /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */
  var runInContext = (function runInContext(context) {
    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));

    /** Built-in constructor references. */
    var Array = context.Array,
        Date = context.Date,
        Error = context.Error,
        Function = context.Function,
        Math = context.Math,
        Object = context.Object,
        RegExp = context.RegExp,
        String = context.String,
        TypeError = context.TypeError;

    /** Used for built-in method references. */
    var arrayProto = Array.prototype,
        funcProto = Function.prototype,
        objectProto = Object.prototype;

    /** Used to detect overreaching core-js shims. */
    var coreJsData = context['__core-js_shared__'];

    /** Used to resolve the decompiled source of functions. */
    var funcToString = funcProto.toString;

    /** Used to check objects for own properties. */
    var hasOwnProperty = objectProto.hasOwnProperty;

    /** Used to generate unique IDs. */
    var idCounter = 0;

    /** Used to detect methods masquerading as native. */
    var maskSrcKey = (function() {
      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
      return uid ? ('Symbol(src)_1.' + uid) : '';
    }());

    /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */
    var nativeObjectToString = objectProto.toString;

    /** Used to infer the `Object` constructor. */
    var objectCtorString = funcToString.call(Object);

    /** Used to restore the original `_` reference in `_.noConflict`. */
    var oldDash = root._;

    /** Used to detect if a method is native. */
    var reIsNative = RegExp('^' +
      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
    );

    /** Built-in value references. */
    var Buffer = moduleExports ? context.Buffer : undefined,
        Symbol = context.Symbol,
        Uint8Array = context.Uint8Array,
        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
        getPrototype = overArg(Object.getPrototypeOf, Object),
        objectCreate = Object.create,
        propertyIsEnumerable = objectProto.propertyIsEnumerable,
        splice = arrayProto.splice,
        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
        symIterator = Symbol ? Symbol.iterator : undefined,
        symToStringTag = Symbol ? Symbol.toStringTag : undefined;

    var defineProperty = (function() {
      try {
        var func = getNative(Object, 'defineProperty');
        func({}, '', {});
        return func;
      } catch (e) {}
    }());

    /** Mocked built-ins. */
    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
        ctxNow = Date && Date.now !== root.Date.now && Date.now,
        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;

    /* Built-in method references for those with the same name as other `lodash` methods. */
    var nativeCeil = Math.ceil,
        nativeFloor = Math.floor,
        nativeGetSymbols = Object.getOwnPropertySymbols,
        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
        nativeIsFinite = context.isFinite,
        nativeJoin = arrayProto.join,
        nativeKeys = overArg(Object.keys, Object),
        nativeMax = Math.max,
        nativeMin = Math.min,
        nativeNow = Date.now,
        nativeParseInt = context.parseInt,
        nativeRandom = Math.random,
        nativeReverse = arrayProto.reverse;

    /* Built-in method references that are verified to be native. */
    var DataView = getNative(context, 'DataView'),
        Map = getNative(context, 'Map'),
        Promise = getNative(context, 'Promise'),
        Set = getNative(context, 'Set'),
        WeakMap = getNative(context, 'WeakMap'),
        nativeCreate = getNative(Object, 'create');

    /** Used to store function metadata. */
    var metaMap = WeakMap && new WeakMap;

    /** Used to lookup unminified function names. */
    var realNames = {};

    /** Used to detect maps, sets, and weakmaps. */
    var dataViewCtorString = toSource(DataView),
        mapCtorString = toSource(Map),
        promiseCtorString = toSource(Promise),
        setCtorString = toSource(Set),
        weakMapCtorString = toSource(WeakMap);

    /** Used to convert symbols to primitives and strings. */
    var symbolProto = Symbol ? Symbol.prototype : undefined,
        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
        symbolToString = symbolProto ? symbolProto.toString : undefined;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */
    function lodash(value) {
      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
        if (value instanceof LodashWrapper) {
          return value;
        }
        if (hasOwnProperty.call(value, '__wrapped__')) {
          return wrapperClone(value);
        }
      }
      return new LodashWrapper(value);
    }

    /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */
    var baseCreate = (function() {
      function object() {}
      return function(proto) {
        if (!isObject(proto)) {
          return {};
        }
        if (objectCreate) {
          return objectCreate(proto);
        }
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
      };
    }());

    /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */
    function baseLodash() {
      // No operation performed.
    }

    /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */
    function LodashWrapper(value, chainAll) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__chain__ = !!chainAll;
      this.__index__ = 0;
      this.__values__ = undefined;
    }

    /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */
    lodash.templateSettings = {

      /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'escape': reEscape,

      /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'evaluate': reEvaluate,

      /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'interpolate': reInterpolate,

      /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */
      'variable': '',

      /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */
      'imports': {

        /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */
        '_': lodash
      }
    };

    // Ensure wrappers are instances of `baseLodash`.
    lodash.prototype = baseLodash.prototype;
    lodash.prototype.constructor = lodash;

    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
    LodashWrapper.prototype.constructor = LodashWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */
    function LazyWrapper(value) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__dir__ = 1;
      this.__filtered__ = false;
      this.__iteratees__ = [];
      this.__takeCount__ = MAX_ARRAY_LENGTH;
      this.__views__ = [];
    }

    /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */
    function lazyClone() {
      var result = new LazyWrapper(this.__wrapped__);
      result.__actions__ = copyArray(this.__actions__);
      result.__dir__ = this.__dir__;
      result.__filtered__ = this.__filtered__;
      result.__iteratees__ = copyArray(this.__iteratees__);
      result.__takeCount__ = this.__takeCount__;
      result.__views__ = copyArray(this.__views__);
      return result;
    }

    /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */
    function lazyReverse() {
      if (this.__filtered__) {
        var result = new LazyWrapper(this);
        result.__dir__ = -1;
        result.__filtered__ = true;
      } else {
        result = this.clone();
        result.__dir__ *= -1;
      }
      return result;
    }

    /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */
    function lazyValue() {
      var array = this.__wrapped__.value(),
          dir = this.__dir__,
          isArr = isArray(array),
          isRight = dir < 0,
          arrLength = isArr ? array.length : 0,
          view = getView(0, arrLength, this.__views__),
          start = view.start,
          end = view.end,
          length = end - start,
          index = isRight ? end : (start - 1),
          iteratees = this.__iteratees__,
          iterLength = iteratees.length,
          resIndex = 0,
          takeCount = nativeMin(length, this.__takeCount__);

      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
        return baseWrapperValue(array, this.__actions__);
      }
      var result = [];

      outer:
      while (length-- && resIndex < takeCount) {
        index += dir;

        var iterIndex = -1,
            value = array[index];

        while (++iterIndex < iterLength) {
          var data = iteratees[iterIndex],
              iteratee = data.iteratee,
              type = data.type,
              computed = iteratee(value);

          if (type == LAZY_MAP_FLAG) {
            value = computed;
          } else if (!computed) {
            if (type == LAZY_FILTER_FLAG) {
              continue outer;
            } else {
              break outer;
            }
          }
        }
        result[resIndex++] = value;
      }
      return result;
    }

    // Ensure `LazyWrapper` is an instance of `baseLodash`.
    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
    LazyWrapper.prototype.constructor = LazyWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Hash(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */
    function hashClear() {
      this.__data__ = nativeCreate ? nativeCreate(null) : {};
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function hashDelete(key) {
      var result = this.has(key) && delete this.__data__[key];
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function hashGet(key) {
      var data = this.__data__;
      if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
      }
      return hasOwnProperty.call(data, key) ? data[key] : undefined;
    }

    /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function hashHas(key) {
      var data = this.__data__;
      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
    }

    /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */
    function hashSet(key, value) {
      var data = this.__data__;
      this.size += this.has(key) ? 0 : 1;
      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
      return this;
    }

    // Add methods to `Hash`.
    Hash.prototype.clear = hashClear;
    Hash.prototype['delete'] = hashDelete;
    Hash.prototype.get = hashGet;
    Hash.prototype.has = hashHas;
    Hash.prototype.set = hashSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function ListCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */
    function listCacheClear() {
      this.__data__ = [];
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function listCacheDelete(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        return false;
      }
      var lastIndex = data.length - 1;
      if (index == lastIndex) {
        data.pop();
      } else {
        splice.call(data, index, 1);
      }
      --this.size;
      return true;
    }

    /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function listCacheGet(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      return index < 0 ? undefined : data[index][1];
    }

    /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function listCacheHas(key) {
      return assocIndexOf(this.__data__, key) > -1;
    }

    /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */
    function listCacheSet(key, value) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        ++this.size;
        data.push([key, value]);
      } else {
        data[index][1] = value;
      }
      return this;
    }

    // Add methods to `ListCache`.
    ListCache.prototype.clear = listCacheClear;
    ListCache.prototype['delete'] = listCacheDelete;
    ListCache.prototype.get = listCacheGet;
    ListCache.prototype.has = listCacheHas;
    ListCache.prototype.set = listCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function MapCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */
    function mapCacheClear() {
      this.size = 0;
      this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
      };
    }

    /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function mapCacheDelete(key) {
      var result = getMapData(this, key)['delete'](key);
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function mapCacheGet(key) {
      return getMapData(this, key).get(key);
    }

    /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function mapCacheHas(key) {
      return getMapData(this, key).has(key);
    }

    /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */
    function mapCacheSet(key, value) {
      var data = getMapData(this, key),
          size = data.size;

      data.set(key, value);
      this.size += data.size == size ? 0 : 1;
      return this;
    }

    // Add methods to `MapCache`.
    MapCache.prototype.clear = mapCacheClear;
    MapCache.prototype['delete'] = mapCacheDelete;
    MapCache.prototype.get = mapCacheGet;
    MapCache.prototype.has = mapCacheHas;
    MapCache.prototype.set = mapCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */
    function SetCache(values) {
      var index = -1,
          length = values == null ? 0 : values.length;

      this.__data__ = new MapCache;
      while (++index < length) {
        this.add(values[index]);
      }
    }

    /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */
    function setCacheAdd(value) {
      this.__data__.set(value, HASH_UNDEFINED);
      return this;
    }

    /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */
    function setCacheHas(value) {
      return this.__data__.has(value);
    }

    // Add methods to `SetCache`.
    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
    SetCache.prototype.has = setCacheHas;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Stack(entries) {
      var data = this.__data__ = new ListCache(entries);
      this.size = data.size;
    }

    /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */
    function stackClear() {
      this.__data__ = new ListCache;
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function stackDelete(key) {
      var data = this.__data__,
          result = data['delete'](key);

      this.size = data.size;
      return result;
    }

    /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function stackGet(key) {
      return this.__data__.get(key);
    }

    /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function stackHas(key) {
      return this.__data__.has(key);
    }

    /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */
    function stackSet(key, value) {
      var data = this.__data__;
      if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
          pairs.push([key, value]);
          this.size = ++data.size;
          return this;
        }
        data = this.__data__ = new MapCache(pairs);
      }
      data.set(key, value);
      this.size = data.size;
      return this;
    }

    // Add methods to `Stack`.
    Stack.prototype.clear = stackClear;
    Stack.prototype['delete'] = stackDelete;
    Stack.prototype.get = stackGet;
    Stack.prototype.has = stackHas;
    Stack.prototype.set = stackSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */
    function arrayLikeKeys(value, inherited) {
      var isArr = isArray(value),
          isArg = !isArr && isArguments(value),
          isBuff = !isArr && !isArg && isBuffer(value),
          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
          skipIndexes = isArr || isArg || isBuff || isType,
          result = skipIndexes ? baseTimes(value.length, String) : [],
          length = result.length;

      for (var key in value) {
        if ((inherited || hasOwnProperty.call(value, key)) &&
            !(skipIndexes && (
               // Safari 9 has enumerable `arguments.length` in strict mode.
               key == 'length' ||
               // Node.js 0.10 has enumerable non-index properties on buffers.
               (isBuff && (key == 'offset' || key == 'parent')) ||
               // PhantomJS 2 has enumerable non-index properties on typed arrays.
               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
               // Skip index properties.
               isIndex(key, length)
            ))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */
    function arraySample(array) {
      var length = array.length;
      return length ? array[baseRandom(0, length - 1)] : undefined;
    }

    /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function arraySampleSize(array, n) {
      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
    }

    /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function arrayShuffle(array) {
      return shuffleSelf(copyArray(array));
    }

    /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignMergeValue(object, key, value) {
      if ((value !== undefined && !eq(object[key], value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignValue(object, key, value) {
      var objValue = object[key];
      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */
    function assocIndexOf(array, key) {
      var length = array.length;
      while (length--) {
        if (eq(array[length][0], key)) {
          return length;
        }
      }
      return -1;
    }

    /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseAggregator(collection, setter, iteratee, accumulator) {
      baseEach(collection, function(value, key, collection) {
        setter(accumulator, value, iteratee(value), collection);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssign(object, source) {
      return object && copyObject(source, keys(source), object);
    }

    /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssignIn(object, source) {
      return object && copyObject(source, keysIn(source), object);
    }

    /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function baseAssignValue(object, key, value) {
      if (key == '__proto__' && defineProperty) {
        defineProperty(object, key, {
          'configurable': true,
          'enumerable': true,
          'value': value,
          'writable': true
        });
      } else {
        object[key] = value;
      }
    }

    /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */
    function baseAt(object, paths) {
      var index = -1,
          length = paths.length,
          result = Array(length),
          skip = object == null;

      while (++index < length) {
        result[index] = skip ? undefined : get(object, paths[index]);
      }
      return result;
    }

    /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */
    function baseClamp(number, lower, upper) {
      if (number === number) {
        if (upper !== undefined) {
          number = number <= upper ? number : upper;
        }
        if (lower !== undefined) {
          number = number >= lower ? number : lower;
        }
      }
      return number;
    }

    /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */
    function baseClone(value, bitmask, customizer, key, object, stack) {
      var result,
          isDeep = bitmask & CLONE_DEEP_FLAG,
          isFlat = bitmask & CLONE_FLAT_FLAG,
          isFull = bitmask & CLONE_SYMBOLS_FLAG;

      if (customizer) {
        result = object ? customizer(value, key, object, stack) : customizer(value);
      }
      if (result !== undefined) {
        return result;
      }
      if (!isObject(value)) {
        return value;
      }
      var isArr = isArray(value);
      if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) {
          return copyArray(value, result);
        }
      } else {
        var tag = getTag(value),
            isFunc = tag == funcTag || tag == genTag;

        if (isBuffer(value)) {
          return cloneBuffer(value, isDeep);
        }
        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
          result = (isFlat || isFunc) ? {} : initCloneObject(value);
          if (!isDeep) {
            return isFlat
              ? copySymbolsIn(value, baseAssignIn(result, value))
              : copySymbols(value, baseAssign(result, value));
          }
        } else {
          if (!cloneableTags[tag]) {
            return object ? value : {};
          }
          result = initCloneByTag(value, tag, isDeep);
        }
      }
      // Check for circular references and return its corresponding clone.
      stack || (stack = new Stack);
      var stacked = stack.get(value);
      if (stacked) {
        return stacked;
      }
      stack.set(value, result);

      if (isSet(value)) {
        value.forEach(function(subValue) {
          result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
        });

        return result;
      }

      if (isMap(value)) {
        value.forEach(function(subValue, key) {
          result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
        });

        return result;
      }

      var keysFunc = isFull
        ? (isFlat ? getAllKeysIn : getAllKeys)
        : (isFlat ? keysIn : keys);

      var props = isArr ? undefined : keysFunc(value);
      arrayEach(props || value, function(subValue, key) {
        if (props) {
          key = subValue;
          subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
      });
      return result;
    }

    /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */
    function baseConforms(source) {
      var props = keys(source);
      return function(object) {
        return baseConformsTo(object, source, props);
      };
    }

    /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */
    function baseConformsTo(object, source, props) {
      var length = props.length;
      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (length--) {
        var key = props[length],
            predicate = source[key],
            value = object[key];

        if ((value === undefined && !(key in object)) || !predicate(value)) {
          return false;
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    function baseDelay(func, wait, args) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return setTimeout(function() { func.apply(undefined, args); }, wait);
    }

    /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */
    function baseDifference(array, values, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          isCommon = true,
          length = array.length,
          result = [],
          valuesLength = values.length;

      if (!length) {
        return result;
      }
      if (iteratee) {
        values = arrayMap(values, baseUnary(iteratee));
      }
      if (comparator) {
        includes = arrayIncludesWith;
        isCommon = false;
      }
      else if (values.length >= LARGE_ARRAY_SIZE) {
        includes = cacheHas;
        isCommon = false;
        values = new SetCache(values);
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee == null ? value : iteratee(value);

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var valuesIndex = valuesLength;
          while (valuesIndex--) {
            if (values[valuesIndex] === computed) {
              continue outer;
            }
          }
          result.push(value);
        }
        else if (!includes(values, computed, comparator)) {
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEach = createBaseEach(baseForOwn);

    /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEachRight = createBaseEach(baseForOwnRight, true);

    /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */
    function baseEvery(collection, predicate) {
      var result = true;
      baseEach(collection, function(value, index, collection) {
        result = !!predicate(value, index, collection);
        return result;
      });
      return result;
    }

    /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */
    function baseExtremum(array, iteratee, comparator) {
      var index = -1,
          length = array.length;

      while (++index < length) {
        var value = array[index],
            current = iteratee(value);

        if (current != null && (computed === undefined
              ? (current === current && !isSymbol(current))
              : comparator(current, computed)
            )) {
          var computed = current,
              result = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */
    function baseFill(array, value, start, end) {
      var length = array.length;

      start = toInteger(start);
      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = (end === undefined || end > length) ? length : toInteger(end);
      if (end < 0) {
        end += length;
      }
      end = start > end ? 0 : toLength(end);
      while (start < end) {
        array[start++] = value;
      }
      return array;
    }

    /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */
    function baseFilter(collection, predicate) {
      var result = [];
      baseEach(collection, function(value, index, collection) {
        if (predicate(value, index, collection)) {
          result.push(value);
        }
      });
      return result;
    }

    /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */
    function baseFlatten(array, depth, predicate, isStrict, result) {
      var index = -1,
          length = array.length;

      predicate || (predicate = isFlattenable);
      result || (result = []);

      while (++index < length) {
        var value = array[index];
        if (depth > 0 && predicate(value)) {
          if (depth > 1) {
            // Recursively flatten arrays (susceptible to call stack limits).
            baseFlatten(value, depth - 1, predicate, isStrict, result);
          } else {
            arrayPush(result, value);
          }
        } else if (!isStrict) {
          result[result.length] = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseFor = createBaseFor();

    /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseForRight = createBaseFor(true);

    /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwn(object, iteratee) {
      return object && baseFor(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwnRight(object, iteratee) {
      return object && baseForRight(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */
    function baseFunctions(object, props) {
      return arrayFilter(props, function(key) {
        return isFunction(object[key]);
      });
    }

    /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */
    function baseGet(object, path) {
      path = castPath(path, object);

      var index = 0,
          length = path.length;

      while (object != null && index < length) {
        object = object[toKey(path[index++])];
      }
      return (index && index == length) ? object : undefined;
    }

    /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
      var result = keysFunc(object);
      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
    }

    /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    function baseGetTag(value) {
      if (value == null) {
        return value === undefined ? undefinedTag : nullTag;
      }
      return (symToStringTag && symToStringTag in Object(value))
        ? getRawTag(value)
        : objectToString(value);
    }

    /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */
    function baseGt(value, other) {
      return value > other;
    }

    /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHas(object, key) {
      return object != null && hasOwnProperty.call(object, key);
    }

    /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHasIn(object, key) {
      return object != null && key in Object(object);
    }

    /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */
    function baseInRange(number, start, end) {
      return number >= nativeMin(start, end) && number < nativeMax(start, end);
    }

    /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */
    function baseIntersection(arrays, iteratee, comparator) {
      var includes = comparator ? arrayIncludesWith : arrayIncludes,
          length = arrays[0].length,
          othLength = arrays.length,
          othIndex = othLength,
          caches = Array(othLength),
          maxLength = Infinity,
          result = [];

      while (othIndex--) {
        var array = arrays[othIndex];
        if (othIndex && iteratee) {
          array = arrayMap(array, baseUnary(iteratee));
        }
        maxLength = nativeMin(array.length, maxLength);
        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
          ? new SetCache(othIndex && array)
          : undefined;
      }
      array = arrays[0];

      var index = -1,
          seen = caches[0];

      outer:
      while (++index < length && result.length < maxLength) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (!(seen
              ? cacheHas(seen, computed)
              : includes(result, computed, comparator)
            )) {
          othIndex = othLength;
          while (--othIndex) {
            var cache = caches[othIndex];
            if (!(cache
                  ? cacheHas(cache, computed)
                  : includes(arrays[othIndex], computed, comparator))
                ) {
              continue outer;
            }
          }
          if (seen) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseInverter(object, setter, iteratee, accumulator) {
      baseForOwn(object, function(value, key, object) {
        setter(accumulator, iteratee(value), key, object);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */
    function baseInvoke(object, path, args) {
      path = castPath(path, object);
      object = parent(object, path);
      var func = object == null ? object : object[toKey(last(path))];
      return func == null ? undefined : apply(func, object, args);
    }

    /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */
    function baseIsArguments(value) {
      return isObjectLike(value) && baseGetTag(value) == argsTag;
    }

    /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */
    function baseIsArrayBuffer(value) {
      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
    }

    /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */
    function baseIsDate(value) {
      return isObjectLike(value) && baseGetTag(value) == dateTag;
    }

    /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */
    function baseIsEqual(value, other, bitmask, customizer, stack) {
      if (value === other) {
        return true;
      }
      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
        return value !== value && other !== other;
      }
      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
    }

    /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
      var objIsArr = isArray(object),
          othIsArr = isArray(other),
          objTag = objIsArr ? arrayTag : getTag(object),
          othTag = othIsArr ? arrayTag : getTag(other);

      objTag = objTag == argsTag ? objectTag : objTag;
      othTag = othTag == argsTag ? objectTag : othTag;

      var objIsObj = objTag == objectTag,
          othIsObj = othTag == objectTag,
          isSameTag = objTag == othTag;

      if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) {
          return false;
        }
        objIsArr = true;
        objIsObj = false;
      }
      if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return (objIsArr || isTypedArray(object))
          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
      }
      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

        if (objIsWrapped || othIsWrapped) {
          var objUnwrapped = objIsWrapped ? object.value() : object,
              othUnwrapped = othIsWrapped ? other.value() : other;

          stack || (stack = new Stack);
          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
      }
      if (!isSameTag) {
        return false;
      }
      stack || (stack = new Stack);
      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
    }

    /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */
    function baseIsMap(value) {
      return isObjectLike(value) && getTag(value) == mapTag;
    }

    /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */
    function baseIsMatch(object, source, matchData, customizer) {
      var index = matchData.length,
          length = index,
          noCustomizer = !customizer;

      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (index--) {
        var data = matchData[index];
        if ((noCustomizer && data[2])
              ? data[1] !== object[data[0]]
              : !(data[0] in object)
            ) {
          return false;
        }
      }
      while (++index < length) {
        data = matchData[index];
        var key = data[0],
            objValue = object[key],
            srcValue = data[1];

        if (noCustomizer && data[2]) {
          if (objValue === undefined && !(key in object)) {
            return false;
          }
        } else {
          var stack = new Stack;
          if (customizer) {
            var result = customizer(objValue, srcValue, key, object, source, stack);
          }
          if (!(result === undefined
                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
                : result
              )) {
            return false;
          }
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */
    function baseIsNative(value) {
      if (!isObject(value) || isMasked(value)) {
        return false;
      }
      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
      return pattern.test(toSource(value));
    }

    /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */
    function baseIsRegExp(value) {
      return isObjectLike(value) && baseGetTag(value) == regexpTag;
    }

    /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */
    function baseIsSet(value) {
      return isObjectLike(value) && getTag(value) == setTag;
    }

    /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */
    function baseIsTypedArray(value) {
      return isObjectLike(value) &&
        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
    }

    /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */
    function baseIteratee(value) {
      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
      if (typeof value == 'function') {
        return value;
      }
      if (value == null) {
        return identity;
      }
      if (typeof value == 'object') {
        return isArray(value)
          ? baseMatchesProperty(value[0], value[1])
          : baseMatches(value);
      }
      return property(value);
    }

    /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeys(object) {
      if (!isPrototype(object)) {
        return nativeKeys(object);
      }
      var result = [];
      for (var key in Object(object)) {
        if (hasOwnProperty.call(object, key) && key != 'constructor') {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeysIn(object) {
      if (!isObject(object)) {
        return nativeKeysIn(object);
      }
      var isProto = isPrototype(object),
          result = [];

      for (var key in object) {
        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */
    function baseLt(value, other) {
      return value < other;
    }

    /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */
    function baseMap(collection, iteratee) {
      var index = -1,
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
      });
      return result;
    }

    /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatches(source) {
      var matchData = getMatchData(source);
      if (matchData.length == 1 && matchData[0][2]) {
        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
      }
      return function(object) {
        return object === source || baseIsMatch(object, source, matchData);
      };
    }

    /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatchesProperty(path, srcValue) {
      if (isKey(path) && isStrictComparable(srcValue)) {
        return matchesStrictComparable(toKey(path), srcValue);
      }
      return function(object) {
        var objValue = get(object, path);
        return (objValue === undefined && objValue === srcValue)
          ? hasIn(object, path)
          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
      };
    }

    /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMerge(object, source, srcIndex, customizer, stack) {
      if (object === source) {
        return;
      }
      baseFor(source, function(srcValue, key) {
        if (isObject(srcValue)) {
          stack || (stack = new Stack);
          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
        }
        else {
          var newValue = customizer
            ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
            : undefined;

          if (newValue === undefined) {
            newValue = srcValue;
          }
          assignMergeValue(object, key, newValue);
        }
      }, keysIn);
    }

    /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
      var objValue = safeGet(object, key),
          srcValue = safeGet(source, key),
          stacked = stack.get(srcValue);

      if (stacked) {
        assignMergeValue(object, key, stacked);
        return;
      }
      var newValue = customizer
        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
        : undefined;

      var isCommon = newValue === undefined;

      if (isCommon) {
        var isArr = isArray(srcValue),
            isBuff = !isArr && isBuffer(srcValue),
            isTyped = !isArr && !isBuff && isTypedArray(srcValue);

        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
          if (isArray(objValue)) {
            newValue = objValue;
          }
          else if (isArrayLikeObject(objValue)) {
            newValue = copyArray(objValue);
          }
          else if (isBuff) {
            isCommon = false;
            newValue = cloneBuffer(srcValue, true);
          }
          else if (isTyped) {
            isCommon = false;
            newValue = cloneTypedArray(srcValue, true);
          }
          else {
            newValue = [];
          }
        }
        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
          newValue = objValue;
          if (isArguments(objValue)) {
            newValue = toPlainObject(objValue);
          }
          else if (!isObject(objValue) || isFunction(objValue)) {
            newValue = initCloneObject(srcValue);
          }
        }
        else {
          isCommon = false;
        }
      }
      if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack['delete'](srcValue);
      }
      assignMergeValue(object, key, newValue);
    }

    /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */
    function baseNth(array, n) {
      var length = array.length;
      if (!length) {
        return;
      }
      n += n < 0 ? length : 0;
      return isIndex(n, length) ? array[n] : undefined;
    }

    /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */
    function baseOrderBy(collection, iteratees, orders) {
      var index = -1;
      iteratees = arrayMap(iteratees.length ? iteratees : [identity], baseUnary(getIteratee()));

      var result = baseMap(collection, function(value, key, collection) {
        var criteria = arrayMap(iteratees, function(iteratee) {
          return iteratee(value);
        });
        return { 'criteria': criteria, 'index': ++index, 'value': value };
      });

      return baseSortBy(result, function(object, other) {
        return compareMultiple(object, other, orders);
      });
    }

    /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */
    function basePick(object, paths) {
      return basePickBy(object, paths, function(value, path) {
        return hasIn(object, path);
      });
    }

    /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */
    function basePickBy(object, paths, predicate) {
      var index = -1,
          length = paths.length,
          result = {};

      while (++index < length) {
        var path = paths[index],
            value = baseGet(object, path);

        if (predicate(value, path)) {
          baseSet(result, castPath(path, object), value);
        }
      }
      return result;
    }

    /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */
    function basePropertyDeep(path) {
      return function(object) {
        return baseGet(object, path);
      };
    }

    /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */
    function basePullAll(array, values, iteratee, comparator) {
      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
          index = -1,
          length = values.length,
          seen = array;

      if (array === values) {
        values = copyArray(values);
      }
      if (iteratee) {
        seen = arrayMap(array, baseUnary(iteratee));
      }
      while (++index < length) {
        var fromIndex = 0,
            value = values[index],
            computed = iteratee ? iteratee(value) : value;

        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
          if (seen !== array) {
            splice.call(seen, fromIndex, 1);
          }
          splice.call(array, fromIndex, 1);
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */
    function basePullAt(array, indexes) {
      var length = array ? indexes.length : 0,
          lastIndex = length - 1;

      while (length--) {
        var index = indexes[length];
        if (length == lastIndex || index !== previous) {
          var previous = index;
          if (isIndex(index)) {
            splice.call(array, index, 1);
          } else {
            baseUnset(array, index);
          }
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */
    function baseRandom(lower, upper) {
      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
    }

    /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */
    function baseRange(start, end, step, fromRight) {
      var index = -1,
          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
          result = Array(length);

      while (length--) {
        result[fromRight ? length : ++index] = start;
        start += step;
      }
      return result;
    }

    /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */
    function baseRepeat(string, n) {
      var result = '';
      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
        return result;
      }
      // Leverage the exponentiation by squaring algorithm for a faster repeat.
      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
      do {
        if (n % 2) {
          result += string;
        }
        n = nativeFloor(n / 2);
        if (n) {
          string += string;
        }
      } while (n);

      return result;
    }

    /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */
    function baseRest(func, start) {
      return setToString(overRest(func, start, identity), func + '');
    }

    /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */
    function baseSample(collection) {
      return arraySample(values(collection));
    }

    /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function baseSampleSize(collection, n) {
      var array = values(collection);
      return shuffleSelf(array, baseClamp(n, 0, array.length));
    }

    /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseSet(object, path, value, customizer) {
      if (!isObject(object)) {
        return object;
      }
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          lastIndex = length - 1,
          nested = object;

      while (nested != null && ++index < length) {
        var key = toKey(path[index]),
            newValue = value;

        if (index != lastIndex) {
          var objValue = nested[key];
          newValue = customizer ? customizer(objValue, key, nested) : undefined;
          if (newValue === undefined) {
            newValue = isObject(objValue)
              ? objValue
              : (isIndex(path[index + 1]) ? [] : {});
          }
        }
        assignValue(nested, key, newValue);
        nested = nested[key];
      }
      return object;
    }

    /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var baseSetData = !metaMap ? identity : function(func, data) {
      metaMap.set(func, data);
      return func;
    };

    /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var baseSetToString = !defineProperty ? identity : function(func, string) {
      return defineProperty(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': constant(string),
        'writable': true
      });
    };

    /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function baseShuffle(collection) {
      return shuffleSelf(values(collection));
    }

    /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseSlice(array, start, end) {
      var index = -1,
          length = array.length;

      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = end > length ? length : end;
      if (end < 0) {
        end += length;
      }
      length = start > end ? 0 : ((end - start) >>> 0);
      start >>>= 0;

      var result = Array(length);
      while (++index < length) {
        result[index] = array[index + start];
      }
      return result;
    }

    /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */
    function baseSome(collection, predicate) {
      var result;

      baseEach(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
      });
      return !!result;
    }

    /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndex(array, value, retHighest) {
      var low = 0,
          high = array == null ? low : array.length;

      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
        while (low < high) {
          var mid = (low + high) >>> 1,
              computed = array[mid];

          if (computed !== null && !isSymbol(computed) &&
              (retHighest ? (computed <= value) : (computed < value))) {
            low = mid + 1;
          } else {
            high = mid;
          }
        }
        return high;
      }
      return baseSortedIndexBy(array, value, identity, retHighest);
    }

    /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndexBy(array, value, iteratee, retHighest) {
      value = iteratee(value);

      var low = 0,
          high = array == null ? 0 : array.length,
          valIsNaN = value !== value,
          valIsNull = value === null,
          valIsSymbol = isSymbol(value),
          valIsUndefined = value === undefined;

      while (low < high) {
        var mid = nativeFloor((low + high) / 2),
            computed = iteratee(array[mid]),
            othIsDefined = computed !== undefined,
            othIsNull = computed === null,
            othIsReflexive = computed === computed,
            othIsSymbol = isSymbol(computed);

        if (valIsNaN) {
          var setLow = retHighest || othIsReflexive;
        } else if (valIsUndefined) {
          setLow = othIsReflexive && (retHighest || othIsDefined);
        } else if (valIsNull) {
          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
        } else if (valIsSymbol) {
          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
        } else if (othIsNull || othIsSymbol) {
          setLow = false;
        } else {
          setLow = retHighest ? (computed <= value) : (computed < value);
        }
        if (setLow) {
          low = mid + 1;
        } else {
          high = mid;
        }
      }
      return nativeMin(high, MAX_ARRAY_INDEX);
    }

    /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseSortedUniq(array, iteratee) {
      var index = -1,
          length = array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        if (!index || !eq(computed, seen)) {
          var seen = computed;
          result[resIndex++] = value === 0 ? 0 : value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */
    function baseToNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      return +value;
    }

    /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */
    function baseToString(value) {
      // Exit early for strings to avoid a performance hit in some environments.
      if (typeof value == 'string') {
        return value;
      }
      if (isArray(value)) {
        // Recursively convert values (susceptible to call stack limits).
        return arrayMap(value, baseToString) + '';
      }
      if (isSymbol(value)) {
        return symbolToString ? symbolToString.call(value) : '';
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseUniq(array, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          length = array.length,
          isCommon = true,
          result = [],
          seen = result;

      if (comparator) {
        isCommon = false;
        includes = arrayIncludesWith;
      }
      else if (length >= LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : createSet(array);
        if (set) {
          return setToArray(set);
        }
        isCommon = false;
        includes = cacheHas;
        seen = new SetCache;
      }
      else {
        seen = iteratee ? [] : result;
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var seenIndex = seen.length;
          while (seenIndex--) {
            if (seen[seenIndex] === computed) {
              continue outer;
            }
          }
          if (iteratee) {
            seen.push(computed);
          }
          result.push(value);
        }
        else if (!includes(seen, computed, comparator)) {
          if (seen !== result) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */
    function baseUnset(object, path) {
      path = castPath(path, object);
      object = parent(object, path);
      return object == null || delete object[toKey(last(path))];
    }

    /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseUpdate(object, path, updater, customizer) {
      return baseSet(object, path, updater(baseGet(object, path)), customizer);
    }

    /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseWhile(array, predicate, isDrop, fromRight) {
      var length = array.length,
          index = fromRight ? length : -1;

      while ((fromRight ? index-- : ++index < length) &&
        predicate(array[index], index, array)) {}

      return isDrop
        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
    }

    /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */
    function baseWrapperValue(value, actions) {
      var result = value;
      if (result instanceof LazyWrapper) {
        result = result.value();
      }
      return arrayReduce(actions, function(result, action) {
        return action.func.apply(action.thisArg, arrayPush([result], action.args));
      }, result);
    }

    /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */
    function baseXor(arrays, iteratee, comparator) {
      var length = arrays.length;
      if (length < 2) {
        return length ? baseUniq(arrays[0]) : [];
      }
      var index = -1,
          result = Array(length);

      while (++index < length) {
        var array = arrays[index],
            othIndex = -1;

        while (++othIndex < length) {
          if (othIndex != index) {
            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
          }
        }
      }
      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
    }

    /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */
    function baseZipObject(props, values, assignFunc) {
      var index = -1,
          length = props.length,
          valsLength = values.length,
          result = {};

      while (++index < length) {
        var value = index < valsLength ? values[index] : undefined;
        assignFunc(result, props[index], value);
      }
      return result;
    }

    /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */
    function castArrayLikeObject(value) {
      return isArrayLikeObject(value) ? value : [];
    }

    /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */
    function castFunction(value) {
      return typeof value == 'function' ? value : identity;
    }

    /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */
    function castPath(value, object) {
      if (isArray(value)) {
        return value;
      }
      return isKey(value, object) ? [value] : stringToPath(toString(value));
    }

    /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    var castRest = baseRest;

    /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */
    function castSlice(array, start, end) {
      var length = array.length;
      end = end === undefined ? length : end;
      return (!start && end >= length) ? array : baseSlice(array, start, end);
    }

    /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */
    var clearTimeout = ctxClearTimeout || function(id) {
      return root.clearTimeout(id);
    };

    /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */
    function cloneBuffer(buffer, isDeep) {
      if (isDeep) {
        return buffer.slice();
      }
      var length = buffer.length,
          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

      buffer.copy(result);
      return result;
    }

    /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */
    function cloneArrayBuffer(arrayBuffer) {
      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
      return result;
    }

    /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */
    function cloneDataView(dataView, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
    }

    /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */
    function cloneRegExp(regexp) {
      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
      result.lastIndex = regexp.lastIndex;
      return result;
    }

    /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */
    function cloneSymbol(symbol) {
      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
    }

    /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */
    function cloneTypedArray(typedArray, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
    }

    /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */
    function compareAscending(value, other) {
      if (value !== other) {
        var valIsDefined = value !== undefined,
            valIsNull = value === null,
            valIsReflexive = value === value,
            valIsSymbol = isSymbol(value);

        var othIsDefined = other !== undefined,
            othIsNull = other === null,
            othIsReflexive = other === other,
            othIsSymbol = isSymbol(other);

        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
            (valIsNull && othIsDefined && othIsReflexive) ||
            (!valIsDefined && othIsReflexive) ||
            !valIsReflexive) {
          return 1;
        }
        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
            (othIsNull && valIsDefined && valIsReflexive) ||
            (!othIsDefined && valIsReflexive) ||
            !othIsReflexive) {
          return -1;
        }
      }
      return 0;
    }

    /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */
    function compareMultiple(object, other, orders) {
      var index = -1,
          objCriteria = object.criteria,
          othCriteria = other.criteria,
          length = objCriteria.length,
          ordersLength = orders.length;

      while (++index < length) {
        var result = compareAscending(objCriteria[index], othCriteria[index]);
        if (result) {
          if (index >= ordersLength) {
            return result;
          }
          var order = orders[index];
          return result * (order == 'desc' ? -1 : 1);
        }
      }
      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
      // that causes it, under certain circumstances, to provide the same value for
      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
      // for more details.
      //
      // This also ensures a stable sort in V8 and other engines.
      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
      return object.index - other.index;
    }

    /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgs(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersLength = holders.length,
          leftIndex = -1,
          leftLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(leftLength + rangeLength),
          isUncurried = !isCurried;

      while (++leftIndex < leftLength) {
        result[leftIndex] = partials[leftIndex];
      }
      while (++argsIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[holders[argsIndex]] = args[argsIndex];
        }
      }
      while (rangeLength--) {
        result[leftIndex++] = args[argsIndex++];
      }
      return result;
    }

    /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgsRight(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersIndex = -1,
          holdersLength = holders.length,
          rightIndex = -1,
          rightLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(rangeLength + rightLength),
          isUncurried = !isCurried;

      while (++argsIndex < rangeLength) {
        result[argsIndex] = args[argsIndex];
      }
      var offset = argsIndex;
      while (++rightIndex < rightLength) {
        result[offset + rightIndex] = partials[rightIndex];
      }
      while (++holdersIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[offset + holders[holdersIndex]] = args[argsIndex++];
        }
      }
      return result;
    }

    /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */
    function copyArray(source, array) {
      var index = -1,
          length = source.length;

      array || (array = Array(length));
      while (++index < length) {
        array[index] = source[index];
      }
      return array;
    }

    /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */
    function copyObject(source, props, object, customizer) {
      var isNew = !object;
      object || (object = {});

      var index = -1,
          length = props.length;

      while (++index < length) {
        var key = props[index];

        var newValue = customizer
          ? customizer(object[key], source[key], key, object, source)
          : undefined;

        if (newValue === undefined) {
          newValue = source[key];
        }
        if (isNew) {
          baseAssignValue(object, key, newValue);
        } else {
          assignValue(object, key, newValue);
        }
      }
      return object;
    }

    /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbols(source, object) {
      return copyObject(source, getSymbols(source), object);
    }

    /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbolsIn(source, object) {
      return copyObject(source, getSymbolsIn(source), object);
    }

    /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */
    function createAggregator(setter, initializer) {
      return function(collection, iteratee) {
        var func = isArray(collection) ? arrayAggregator : baseAggregator,
            accumulator = initializer ? initializer() : {};

        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
      };
    }

    /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */
    function createAssigner(assigner) {
      return baseRest(function(object, sources) {
        var index = -1,
            length = sources.length,
            customizer = length > 1 ? sources[length - 1] : undefined,
            guard = length > 2 ? sources[2] : undefined;

        customizer = (assigner.length > 3 && typeof customizer == 'function')
          ? (length--, customizer)
          : undefined;

        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
          customizer = length < 3 ? undefined : customizer;
          length = 1;
        }
        object = Object(object);
        while (++index < length) {
          var source = sources[index];
          if (source) {
            assigner(object, source, index, customizer);
          }
        }
        return object;
      });
    }

    /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseEach(eachFunc, fromRight) {
      return function(collection, iteratee) {
        if (collection == null) {
          return collection;
        }
        if (!isArrayLike(collection)) {
          return eachFunc(collection, iteratee);
        }
        var length = collection.length,
            index = fromRight ? length : -1,
            iterable = Object(collection);

        while ((fromRight ? index-- : ++index < length)) {
          if (iteratee(iterable[index], index, iterable) === false) {
            break;
          }
        }
        return collection;
      };
    }

    /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseFor(fromRight) {
      return function(object, iteratee, keysFunc) {
        var index = -1,
            iterable = Object(object),
            props = keysFunc(object),
            length = props.length;

        while (length--) {
          var key = props[fromRight ? length : ++index];
          if (iteratee(iterable[key], key, iterable) === false) {
            break;
          }
        }
        return object;
      };
    }

    /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createBind(func, bitmask, thisArg) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return fn.apply(isBind ? thisArg : this, arguments);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */
    function createCaseFirst(methodName) {
      return function(string) {
        string = toString(string);

        var strSymbols = hasUnicode(string)
          ? stringToArray(string)
          : undefined;

        var chr = strSymbols
          ? strSymbols[0]
          : string.charAt(0);

        var trailing = strSymbols
          ? castSlice(strSymbols, 1).join('')
          : string.slice(1);

        return chr[methodName]() + trailing;
      };
    }

    /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */
    function createCompounder(callback) {
      return function(string) {
        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
      };
    }

    /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCtor(Ctor) {
      return function() {
        // Use a `switch` statement to work with class constructors. See
        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
        // for more details.
        var args = arguments;
        switch (args.length) {
          case 0: return new Ctor;
          case 1: return new Ctor(args[0]);
          case 2: return new Ctor(args[0], args[1]);
          case 3: return new Ctor(args[0], args[1], args[2]);
          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
        }
        var thisBinding = baseCreate(Ctor.prototype),
            result = Ctor.apply(thisBinding, args);

        // Mimic the constructor's `return` behavior.
        // See https://es5.github.io/#x13.2.2 for more details.
        return isObject(result) ? result : thisBinding;
      };
    }

    /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCurry(func, bitmask, arity) {
      var Ctor = createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length,
            placeholder = getHolder(wrapper);

        while (index--) {
          args[index] = arguments[index];
        }
        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
          ? []
          : replaceHolders(args, placeholder);

        length -= holders.length;
        if (length < arity) {
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, undefined,
            args, holders, undefined, undefined, arity - length);
        }
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return apply(fn, this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */
    function createFind(findIndexFunc) {
      return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!isArrayLike(collection)) {
          var iteratee = getIteratee(predicate, 3);
          collection = keys(collection);
          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
      };
    }

    /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */
    function createFlow(fromRight) {
      return flatRest(function(funcs) {
        var length = funcs.length,
            index = length,
            prereq = LodashWrapper.prototype.thru;

        if (fromRight) {
          funcs.reverse();
        }
        while (index--) {
          var func = funcs[index];
          if (typeof func != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }
          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
            var wrapper = new LodashWrapper([], true);
          }
        }
        index = wrapper ? index : length;
        while (++index < length) {
          func = funcs[index];

          var funcName = getFuncName(func),
              data = funcName == 'wrapper' ? getData(func) : undefined;

          if (data && isLaziable(data[0]) &&
                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
                !data[4].length && data[9] == 1
              ) {
            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
          } else {
            wrapper = (func.length == 1 && isLaziable(func))
              ? wrapper[funcName]()
              : wrapper.thru(func);
          }
        }
        return function() {
          var args = arguments,
              value = args[0];

          if (wrapper && args.length == 1 && isArray(value)) {
            return wrapper.plant(value).value();
          }
          var index = 0,
              result = length ? funcs[index].apply(this, args) : value;

          while (++index < length) {
            result = funcs[index].call(this, result);
          }
          return result;
        };
      });
    }

    /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
      var isAry = bitmask & WRAP_ARY_FLAG,
          isBind = bitmask & WRAP_BIND_FLAG,
          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
          isFlip = bitmask & WRAP_FLIP_FLAG,
          Ctor = isBindKey ? undefined : createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length;

        while (index--) {
          args[index] = arguments[index];
        }
        if (isCurried) {
          var placeholder = getHolder(wrapper),
              holdersCount = countHolders(args, placeholder);
        }
        if (partials) {
          args = composeArgs(args, partials, holders, isCurried);
        }
        if (partialsRight) {
          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
        }
        length -= holdersCount;
        if (isCurried && length < arity) {
          var newHolders = replaceHolders(args, placeholder);
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
            args, newHolders, argPos, ary, arity - length
          );
        }
        var thisBinding = isBind ? thisArg : this,
            fn = isBindKey ? thisBinding[func] : func;

        length = args.length;
        if (argPos) {
          args = reorder(args, argPos);
        } else if (isFlip && length > 1) {
          args.reverse();
        }
        if (isAry && ary < length) {
          args.length = ary;
        }
        if (this && this !== root && this instanceof wrapper) {
          fn = Ctor || createCtor(fn);
        }
        return fn.apply(thisBinding, args);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */
    function createInverter(setter, toIteratee) {
      return function(object, iteratee) {
        return baseInverter(object, setter, toIteratee(iteratee), {});
      };
    }

    /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */
    function createMathOperation(operator, defaultValue) {
      return function(value, other) {
        var result;
        if (value === undefined && other === undefined) {
          return defaultValue;
        }
        if (value !== undefined) {
          result = value;
        }
        if (other !== undefined) {
          if (result === undefined) {
            return other;
          }
          if (typeof value == 'string' || typeof other == 'string') {
            value = baseToString(value);
            other = baseToString(other);
          } else {
            value = baseToNumber(value);
            other = baseToNumber(other);
          }
          result = operator(value, other);
        }
        return result;
      };
    }

    /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */
    function createOver(arrayFunc) {
      return flatRest(function(iteratees) {
        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
        return baseRest(function(args) {
          var thisArg = this;
          return arrayFunc(iteratees, function(iteratee) {
            return apply(iteratee, thisArg, args);
          });
        });
      });
    }

    /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */
    function createPadding(length, chars) {
      chars = chars === undefined ? ' ' : baseToString(chars);

      var charsLength = chars.length;
      if (charsLength < 2) {
        return charsLength ? baseRepeat(chars, length) : chars;
      }
      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
      return hasUnicode(chars)
        ? castSlice(stringToArray(result), 0, length).join('')
        : result.slice(0, length);
    }

    /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */
    function createPartial(func, bitmask, thisArg, partials) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var argsIndex = -1,
            argsLength = arguments.length,
            leftIndex = -1,
            leftLength = partials.length,
            args = Array(leftLength + argsLength),
            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;

        while (++leftIndex < leftLength) {
          args[leftIndex] = partials[leftIndex];
        }
        while (argsLength--) {
          args[leftIndex++] = arguments[++argsIndex];
        }
        return apply(fn, isBind ? thisArg : this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */
    function createRange(fromRight) {
      return function(start, end, step) {
        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
          end = step = undefined;
        }
        // Ensure the sign of `-0` is preserved.
        start = toFinite(start);
        if (end === undefined) {
          end = start;
          start = 0;
        } else {
          end = toFinite(end);
        }
        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
        return baseRange(start, end, step, fromRight);
      };
    }

    /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */
    function createRelationalOperation(operator) {
      return function(value, other) {
        if (!(typeof value == 'string' && typeof other == 'string')) {
          value = toNumber(value);
          other = toNumber(other);
        }
        return operator(value, other);
      };
    }

    /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
      var isCurry = bitmask & WRAP_CURRY_FLAG,
          newHolders = isCurry ? holders : undefined,
          newHoldersRight = isCurry ? undefined : holders,
          newPartials = isCurry ? partials : undefined,
          newPartialsRight = isCurry ? undefined : partials;

      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);

      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
      }
      var newData = [
        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
        newHoldersRight, argPos, ary, arity
      ];

      var result = wrapFunc.apply(undefined, newData);
      if (isLaziable(func)) {
        setData(result, newData);
      }
      result.placeholder = placeholder;
      return setWrapToString(result, func, bitmask);
    }

    /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */
    function createRound(methodName) {
      var func = Math[methodName];
      return function(number, precision) {
        number = toNumber(number);
        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
        if (precision) {
          // Shift with exponential notation to avoid floating-point issues.
          // See [MDN](https://mdn.io/round#Examples) for more details.
          var pair = (toString(number) + 'e').split('e'),
              value = func(pair[0] + 'e' + (+pair[1] + precision));

          pair = (toString(value) + 'e').split('e');
          return +(pair[0] + 'e' + (+pair[1] - precision));
        }
        return func(number);
      };
    }

    /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */
    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
      return new Set(values);
    };

    /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */
    function createToPairs(keysFunc) {
      return function(object) {
        var tag = getTag(object);
        if (tag == mapTag) {
          return mapToArray(object);
        }
        if (tag == setTag) {
          return setToPairs(object);
        }
        return baseToPairs(object, keysFunc(object));
      };
    }

    /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
      if (!isBindKey && typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var length = partials ? partials.length : 0;
      if (!length) {
        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
        partials = holders = undefined;
      }
      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
      arity = arity === undefined ? arity : toInteger(arity);
      length -= holders ? holders.length : 0;

      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
        var partialsRight = partials,
            holdersRight = holders;

        partials = holders = undefined;
      }
      var data = isBindKey ? undefined : getData(func);

      var newData = [
        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
        argPos, ary, arity
      ];

      if (data) {
        mergeData(newData, data);
      }
      func = newData[0];
      bitmask = newData[1];
      thisArg = newData[2];
      partials = newData[3];
      holders = newData[4];
      arity = newData[9] = newData[9] === undefined
        ? (isBindKey ? 0 : func.length)
        : nativeMax(newData[9] - length, 0);

      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
      }
      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
        var result = createBind(func, bitmask, thisArg);
      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
        result = createCurry(func, bitmask, arity);
      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
        result = createPartial(func, bitmask, thisArg, partials);
      } else {
        result = createHybrid.apply(undefined, newData);
      }
      var setter = data ? baseSetData : setData;
      return setWrapToString(setter(result, newData), func, bitmask);
    }

    /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsAssignIn(objValue, srcValue, key, object) {
      if (objValue === undefined ||
          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
        return srcValue;
      }
      return objValue;
    }

    /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
      if (isObject(objValue) && isObject(srcValue)) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, objValue);
        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
        stack['delete'](srcValue);
      }
      return objValue;
    }

    /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */
    function customOmitClone(value) {
      return isPlainObject(value) ? undefined : value;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */
    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          arrLength = array.length,
          othLength = other.length;

      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(array);
      if (stacked && stack.get(other)) {
        return stacked == other;
      }
      var index = -1,
          result = true,
          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

      stack.set(array, other);
      stack.set(other, array);

      // Ignore non-index properties.
      while (++index < arrLength) {
        var arrValue = array[index],
            othValue = other[index];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, arrValue, index, other, array, stack)
            : customizer(arrValue, othValue, index, array, other, stack);
        }
        if (compared !== undefined) {
          if (compared) {
            continue;
          }
          result = false;
          break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
          if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) &&
                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                  return seen.push(othIndex);
                }
              })) {
            result = false;
            break;
          }
        } else if (!(
              arrValue === othValue ||
                equalFunc(arrValue, othValue, bitmask, customizer, stack)
            )) {
          result = false;
          break;
        }
      }
      stack['delete'](array);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
      switch (tag) {
        case dataViewTag:
          if ((object.byteLength != other.byteLength) ||
              (object.byteOffset != other.byteOffset)) {
            return false;
          }
          object = object.buffer;
          other = other.buffer;

        case arrayBufferTag:
          if ((object.byteLength != other.byteLength) ||
              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
            return false;
          }
          return true;

        case boolTag:
        case dateTag:
        case numberTag:
          // Coerce booleans to `1` or `0` and dates to milliseconds.
          // Invalid dates are coerced to `NaN`.
          return eq(+object, +other);

        case errorTag:
          return object.name == other.name && object.message == other.message;

        case regexpTag:
        case stringTag:
          // Coerce regexes to strings and treat strings, primitives and objects,
          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
          // for more details.
          return object == (other + '');

        case mapTag:
          var convert = mapToArray;

        case setTag:
          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
          convert || (convert = setToArray);

          if (object.size != other.size && !isPartial) {
            return false;
          }
          // Assume cyclic values are equal.
          var stacked = stack.get(object);
          if (stacked) {
            return stacked == other;
          }
          bitmask |= COMPARE_UNORDERED_FLAG;

          // Recursively compare objects (susceptible to call stack limits).
          stack.set(object, other);
          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
          stack['delete'](object);
          return result;

        case symbolTag:
          if (symbolValueOf) {
            return symbolValueOf.call(object) == symbolValueOf.call(other);
          }
      }
      return false;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          objProps = getAllKeys(object),
          objLength = objProps.length,
          othProps = getAllKeys(other),
          othLength = othProps.length;

      if (objLength != othLength && !isPartial) {
        return false;
      }
      var index = objLength;
      while (index--) {
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
          return false;
        }
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked && stack.get(other)) {
        return stacked == other;
      }
      var result = true;
      stack.set(object, other);
      stack.set(other, object);

      var skipCtor = isPartial;
      while (++index < objLength) {
        key = objProps[index];
        var objValue = object[key],
            othValue = other[key];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, objValue, key, other, object, stack)
            : customizer(objValue, othValue, key, object, other, stack);
        }
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined
              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
              : compared
            )) {
          result = false;
          break;
        }
        skipCtor || (skipCtor = key == 'constructor');
      }
      if (result && !skipCtor) {
        var objCtor = object.constructor,
            othCtor = other.constructor;

        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor &&
            ('constructor' in object && 'constructor' in other) &&
            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
          result = false;
        }
      }
      stack['delete'](object);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    function flatRest(func) {
      return setToString(overRest(func, undefined, flatten), func + '');
    }

    /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeys(object) {
      return baseGetAllKeys(object, keys, getSymbols);
    }

    /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeysIn(object) {
      return baseGetAllKeys(object, keysIn, getSymbolsIn);
    }

    /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */
    var getData = !metaMap ? noop : function(func) {
      return metaMap.get(func);
    };

    /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */
    function getFuncName(func) {
      var result = (func.name + ''),
          array = realNames[result],
          length = hasOwnProperty.call(realNames, result) ? array.length : 0;

      while (length--) {
        var data = array[length],
            otherFunc = data.func;
        if (otherFunc == null || otherFunc == func) {
          return data.name;
        }
      }
      return result;
    }

    /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */
    function getHolder(func) {
      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
      return object.placeholder;
    }

    /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */
    function getIteratee() {
      var result = lodash.iteratee || iteratee;
      result = result === iteratee ? baseIteratee : result;
      return arguments.length ? result(arguments[0], arguments[1]) : result;
    }

    /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */
    function getMapData(map, key) {
      var data = map.__data__;
      return isKeyable(key)
        ? data[typeof key == 'string' ? 'string' : 'hash']
        : data.map;
    }

    /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */
    function getMatchData(object) {
      var result = keys(object),
          length = result.length;

      while (length--) {
        var key = result[length],
            value = object[key];

        result[length] = [key, value, isStrictComparable(value)];
      }
      return result;
    }

    /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */
    function getNative(object, key) {
      var value = getValue(object, key);
      return baseIsNative(value) ? value : undefined;
    }

    /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */
    function getRawTag(value) {
      var isOwn = hasOwnProperty.call(value, symToStringTag),
          tag = value[symToStringTag];

      try {
        value[symToStringTag] = undefined;
        var unmasked = true;
      } catch (e) {}

      var result = nativeObjectToString.call(value);
      if (unmasked) {
        if (isOwn) {
          value[symToStringTag] = tag;
        } else {
          delete value[symToStringTag];
        }
      }
      return result;
    }

    /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
      if (object == null) {
        return [];
      }
      object = Object(object);
      return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
      });
    };

    /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
      var result = [];
      while (object) {
        arrayPush(result, getSymbols(object));
        object = getPrototype(object);
      }
      return result;
    };

    /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    var getTag = baseGetTag;

    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
        (Map && getTag(new Map) != mapTag) ||
        (Promise && getTag(Promise.resolve()) != promiseTag) ||
        (Set && getTag(new Set) != setTag) ||
        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
      getTag = function(value) {
        var result = baseGetTag(value),
            Ctor = result == objectTag ? value.constructor : undefined,
            ctorString = Ctor ? toSource(Ctor) : '';

        if (ctorString) {
          switch (ctorString) {
            case dataViewCtorString: return dataViewTag;
            case mapCtorString: return mapTag;
            case promiseCtorString: return promiseTag;
            case setCtorString: return setTag;
            case weakMapCtorString: return weakMapTag;
          }
        }
        return result;
      };
    }

    /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */
    function getView(start, end, transforms) {
      var index = -1,
          length = transforms.length;

      while (++index < length) {
        var data = transforms[index],
            size = data.size;

        switch (data.type) {
          case 'drop':      start += size; break;
          case 'dropRight': end -= size; break;
          case 'take':      end = nativeMin(end, start + size); break;
          case 'takeRight': start = nativeMax(start, end - size); break;
        }
      }
      return { 'start': start, 'end': end };
    }

    /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */
    function getWrapDetails(source) {
      var match = source.match(reWrapDetails);
      return match ? match[1].split(reSplitDetails) : [];
    }

    /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */
    function hasPath(object, path, hasFunc) {
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          result = false;

      while (++index < length) {
        var key = toKey(path[index]);
        if (!(result = object != null && hasFunc(object, key))) {
          break;
        }
        object = object[key];
      }
      if (result || ++index != length) {
        return result;
      }
      length = object == null ? 0 : object.length;
      return !!length && isLength(length) && isIndex(key, length) &&
        (isArray(object) || isArguments(object));
    }

    /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */
    function initCloneArray(array) {
      var length = array.length,
          result = new array.constructor(length);

      // Add properties assigned by `RegExp#exec`.
      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
      }
      return result;
    }

    /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneObject(object) {
      return (typeof object.constructor == 'function' && !isPrototype(object))
        ? baseCreate(getPrototype(object))
        : {};
    }

    /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneByTag(object, tag, isDeep) {
      var Ctor = object.constructor;
      switch (tag) {
        case arrayBufferTag:
          return cloneArrayBuffer(object);

        case boolTag:
        case dateTag:
          return new Ctor(+object);

        case dataViewTag:
          return cloneDataView(object, isDeep);

        case float32Tag: case float64Tag:
        case int8Tag: case int16Tag: case int32Tag:
        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
          return cloneTypedArray(object, isDeep);

        case mapTag:
          return new Ctor;

        case numberTag:
        case stringTag:
          return new Ctor(object);

        case regexpTag:
          return cloneRegExp(object);

        case setTag:
          return new Ctor;

        case symbolTag:
          return cloneSymbol(object);
      }
    }

    /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */
    function insertWrapDetails(source, details) {
      var length = details.length;
      if (!length) {
        return source;
      }
      var lastIndex = length - 1;
      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
      details = details.join(length > 2 ? ', ' : ' ');
      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
    }

    /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */
    function isFlattenable(value) {
      return isArray(value) || isArguments(value) ||
        !!(spreadableSymbol && value && value[spreadableSymbol]);
    }

    /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */
    function isIndex(value, length) {
      var type = typeof value;
      length = length == null ? MAX_SAFE_INTEGER : length;

      return !!length &&
        (type == 'number' ||
          (type != 'symbol' && reIsUint.test(value))) &&
            (value > -1 && value % 1 == 0 && value < length);
    }

    /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */
    function isIterateeCall(value, index, object) {
      if (!isObject(object)) {
        return false;
      }
      var type = typeof index;
      if (type == 'number'
            ? (isArrayLike(object) && isIndex(index, object.length))
            : (type == 'string' && index in object)
          ) {
        return eq(object[index], value);
      }
      return false;
    }

    /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */
    function isKey(value, object) {
      if (isArray(value)) {
        return false;
      }
      var type = typeof value;
      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
          value == null || isSymbol(value)) {
        return true;
      }
      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
        (object != null && value in Object(object));
    }

    /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */
    function isKeyable(value) {
      var type = typeof value;
      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
        ? (value !== '__proto__')
        : (value === null);
    }

    /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */
    function isLaziable(func) {
      var funcName = getFuncName(func),
          other = lodash[funcName];

      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
        return false;
      }
      if (func === other) {
        return true;
      }
      var data = getData(other);
      return !!data && func === data[0];
    }

    /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */
    function isMasked(func) {
      return !!maskSrcKey && (maskSrcKey in func);
    }

    /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */
    var isMaskable = coreJsData ? isFunction : stubFalse;

    /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */
    function isPrototype(value) {
      var Ctor = value && value.constructor,
          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

      return value === proto;
    }

    /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */
    function isStrictComparable(value) {
      return value === value && !isObject(value);
    }

    /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function matchesStrictComparable(key, srcValue) {
      return function(object) {
        if (object == null) {
          return false;
        }
        return object[key] === srcValue &&
          (srcValue !== undefined || (key in Object(object)));
      };
    }

    /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */
    function memoizeCapped(func) {
      var result = memoize(func, function(key) {
        if (cache.size === MAX_MEMOIZE_SIZE) {
          cache.clear();
        }
        return key;
      });

      var cache = result.cache;
      return result;
    }

    /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */
    function mergeData(data, source) {
      var bitmask = data[1],
          srcBitmask = source[1],
          newBitmask = bitmask | srcBitmask,
          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);

      var isCombo =
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));

      // Exit early if metadata can't be merged.
      if (!(isCommon || isCombo)) {
        return data;
      }
      // Use source `thisArg` if available.
      if (srcBitmask & WRAP_BIND_FLAG) {
        data[2] = source[2];
        // Set when currying a bound function.
        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
      }
      // Compose partial arguments.
      var value = source[3];
      if (value) {
        var partials = data[3];
        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
      }
      // Compose partial right arguments.
      value = source[5];
      if (value) {
        partials = data[5];
        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
      }
      // Use source `argPos` if available.
      value = source[7];
      if (value) {
        data[7] = value;
      }
      // Use source `ary` if it's smaller.
      if (srcBitmask & WRAP_ARY_FLAG) {
        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
      }
      // Use source `arity` if one is not provided.
      if (data[9] == null) {
        data[9] = source[9];
      }
      // Use source `func` and merge bitmasks.
      data[0] = source[0];
      data[1] = newBitmask;

      return data;
    }

    /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function nativeKeysIn(object) {
      var result = [];
      if (object != null) {
        for (var key in Object(object)) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */
    function objectToString(value) {
      return nativeObjectToString.call(value);
    }

    /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */
    function overRest(func, start, transform) {
      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
      return function() {
        var args = arguments,
            index = -1,
            length = nativeMax(args.length - start, 0),
            array = Array(length);

        while (++index < length) {
          array[index] = args[start + index];
        }
        index = -1;
        var otherArgs = Array(start + 1);
        while (++index < start) {
          otherArgs[index] = args[index];
        }
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
      };
    }

    /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */
    function parent(object, path) {
      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
    }

    /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */
    function reorder(array, indexes) {
      var arrLength = array.length,
          length = nativeMin(indexes.length, arrLength),
          oldArray = copyArray(array);

      while (length--) {
        var index = indexes[length];
        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
      }
      return array;
    }

    /**
     * Gets the value at `key`, unless `key` is "__proto__".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */
    function safeGet(object, key) {
      if (key == '__proto__') {
        return;
      }

      return object[key];
    }

    /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var setData = shortOut(baseSetData);

    /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    var setTimeout = ctxSetTimeout || function(func, wait) {
      return root.setTimeout(func, wait);
    };

    /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var setToString = shortOut(baseSetToString);

    /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */
    function setWrapToString(wrapper, reference, bitmask) {
      var source = (reference + '');
      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
    }

    /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */
    function shortOut(func) {
      var count = 0,
          lastCalled = 0;

      return function() {
        var stamp = nativeNow(),
            remaining = HOT_SPAN - (stamp - lastCalled);

        lastCalled = stamp;
        if (remaining > 0) {
          if (++count >= HOT_COUNT) {
            return arguments[0];
          }
        } else {
          count = 0;
        }
        return func.apply(undefined, arguments);
      };
    }

    /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */
    function shuffleSelf(array, size) {
      var index = -1,
          length = array.length,
          lastIndex = length - 1;

      size = size === undefined ? length : size;
      while (++index < size) {
        var rand = baseRandom(index, lastIndex),
            value = array[rand];

        array[rand] = array[index];
        array[index] = value;
      }
      array.length = size;
      return array;
    }

    /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */
    var stringToPath = memoizeCapped(function(string) {
      var result = [];
      if (string.charCodeAt(0) === 46 /* . */) {
        result.push('');
      }
      string.replace(rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
      });
      return result;
    });

    /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */
    function toKey(value) {
      if (typeof value == 'string' || isSymbol(value)) {
        return value;
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */
    function toSource(func) {
      if (func != null) {
        try {
          return funcToString.call(func);
        } catch (e) {}
        try {
          return (func + '');
        } catch (e) {}
      }
      return '';
    }

    /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */
    function updateWrapDetails(details, bitmask) {
      arrayEach(wrapFlags, function(pair) {
        var value = '_.' + pair[0];
        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
          details.push(value);
        }
      });
      return details.sort();
    }

    /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */
    function wrapperClone(wrapper) {
      if (wrapper instanceof LazyWrapper) {
        return wrapper.clone();
      }
      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
      result.__actions__ = copyArray(wrapper.__actions__);
      result.__index__  = wrapper.__index__;
      result.__values__ = wrapper.__values__;
      return result;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */
    function chunk(array, size, guard) {
      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
        size = 1;
      } else {
        size = nativeMax(toInteger(size), 0);
      }
      var length = array == null ? 0 : array.length;
      if (!length || size < 1) {
        return [];
      }
      var index = 0,
          resIndex = 0,
          result = Array(nativeCeil(length / size));

      while (index < length) {
        result[resIndex++] = baseSlice(array, index, (index += size));
      }
      return result;
    }

    /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */
    function compact(array) {
      var index = -1,
          length = array == null ? 0 : array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index];
        if (value) {
          result[resIndex++] = value;
        }
      }
      return result;
    }

    /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */
    function concat() {
      var length = arguments.length;
      if (!length) {
        return [];
      }
      var args = Array(length - 1),
          array = arguments[0],
          index = length;

      while (index--) {
        args[index - 1] = arguments[index];
      }
      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
    }

    /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */
    var difference = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var differenceBy = baseRest(function(array, values) {
      var iteratee = last(values);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */
    var differenceWith = baseRest(function(array, values) {
      var comparator = last(values);
      if (isArrayLikeObject(comparator)) {
        comparator = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
        : [];
    });

    /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function drop(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function dropRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true, true)
        : [];
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true)
        : [];
    }

    /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */
    function fill(array, value, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
        start = 0;
        end = length;
      }
      return baseFill(array, value, start, end);
    }

    /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */
    function findIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index);
    }

    /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */
    function findLastIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length - 1;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = fromIndex < 0
          ? nativeMax(length + index, 0)
          : nativeMin(index, length - 1);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
    }

    /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */
    function flatten(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, 1) : [];
    }

    /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */
    function flattenDeep(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, INFINITY) : [];
    }

    /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */
    function flattenDepth(array, depth) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(array, depth);
    }

    /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */
    function fromPairs(pairs) {
      var index = -1,
          length = pairs == null ? 0 : pairs.length,
          result = {};

      while (++index < length) {
        var pair = pairs[index];
        result[pair[0]] = pair[1];
      }
      return result;
    }

    /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */
    function head(array) {
      return (array && array.length) ? array[0] : undefined;
    }

    /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */
    function indexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseIndexOf(array, value, index);
    }

    /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */
    function initial(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 0, -1) : [];
    }

    /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */
    var intersection = baseRest(function(arrays) {
      var mapped = arrayMap(arrays, castArrayLikeObject);
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped)
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */
    var intersectionBy = baseRest(function(arrays) {
      var iteratee = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      if (iteratee === last(mapped)) {
        iteratee = undefined;
      } else {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */
    var intersectionWith = baseRest(function(arrays) {
      var comparator = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      comparator = typeof comparator == 'function' ? comparator : undefined;
      if (comparator) {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, undefined, comparator)
        : [];
    });

    /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */
    function join(array, separator) {
      return array == null ? '' : nativeJoin.call(array, separator);
    }

    /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */
    function last(array) {
      var length = array == null ? 0 : array.length;
      return length ? array[length - 1] : undefined;
    }

    /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */
    function lastIndexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
      }
      return value === value
        ? strictLastIndexOf(array, value, index)
        : baseFindIndex(array, baseIsNaN, index, true);
    }

    /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */
    function nth(array, n) {
      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
    }

    /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */
    var pull = baseRest(pullAll);

    /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */
    function pullAll(array, values) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values)
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */
    function pullAllBy(array, values, iteratee) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, getIteratee(iteratee, 2))
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */
    function pullAllWith(array, values, comparator) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, undefined, comparator)
        : array;
    }

    /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */
    var pullAt = flatRest(function(array, indexes) {
      var length = array == null ? 0 : array.length,
          result = baseAt(array, indexes);

      basePullAt(array, arrayMap(indexes, function(index) {
        return isIndex(index, length) ? +index : index;
      }).sort(compareAscending));

      return result;
    });

    /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */
    function remove(array, predicate) {
      var result = [];
      if (!(array && array.length)) {
        return result;
      }
      var index = -1,
          indexes = [],
          length = array.length;

      predicate = getIteratee(predicate, 3);
      while (++index < length) {
        var value = array[index];
        if (predicate(value, index, array)) {
          result.push(value);
          indexes.push(index);
        }
      }
      basePullAt(array, indexes);
      return result;
    }

    /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function reverse(array) {
      return array == null ? array : nativeReverse.call(array);
    }

    /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function slice(array, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
        start = 0;
        end = length;
      }
      else {
        start = start == null ? 0 : toInteger(start);
        end = end === undefined ? length : toInteger(end);
      }
      return baseSlice(array, start, end);
    }

    /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */
    function sortedIndex(array, value) {
      return baseSortedIndex(array, value);
    }

    /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */
    function sortedIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
    }

    /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */
    function sortedIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value);
        if (index < length && eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */
    function sortedLastIndex(array, value) {
      return baseSortedIndex(array, value, true);
    }

    /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */
    function sortedLastIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
    }

    /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */
    function sortedLastIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value, true) - 1;
        if (eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */
    function sortedUniq(array) {
      return (array && array.length)
        ? baseSortedUniq(array)
        : [];
    }

    /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */
    function sortedUniqBy(array, iteratee) {
      return (array && array.length)
        ? baseSortedUniq(array, getIteratee(iteratee, 2))
        : [];
    }

    /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */
    function tail(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 1, length) : [];
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */
    function take(array, n, guard) {
      if (!(array && array.length)) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */
    function takeRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */
    function takeRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), false, true)
        : [];
    }

    /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */
    function takeWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3))
        : [];
    }

    /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */
    var union = baseRest(function(arrays) {
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
    });

    /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    var unionBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var unionWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
    });

    /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */
    function uniq(array) {
      return (array && array.length) ? baseUniq(array) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    function uniqBy(array, iteratee) {
      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */
    function uniqWith(array, comparator) {
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
    }

    /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */
    function unzip(array) {
      if (!(array && array.length)) {
        return [];
      }
      var length = 0;
      array = arrayFilter(array, function(group) {
        if (isArrayLikeObject(group)) {
          length = nativeMax(group.length, length);
          return true;
        }
      });
      return baseTimes(length, function(index) {
        return arrayMap(array, baseProperty(index));
      });
    }

    /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */
    function unzipWith(array, iteratee) {
      if (!(array && array.length)) {
        return [];
      }
      var result = unzip(array);
      if (iteratee == null) {
        return result;
      }
      return arrayMap(result, function(group) {
        return apply(iteratee, undefined, group);
      });
    }

    /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */
    var without = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, values)
        : [];
    });

    /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */
    var xor = baseRest(function(arrays) {
      return baseXor(arrayFilter(arrays, isArrayLikeObject));
    });

    /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var xorBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var xorWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
    });

    /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */
    var zip = baseRest(unzip);

    /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */
    function zipObject(props, values) {
      return baseZipObject(props || [], values || [], assignValue);
    }

    /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */
    function zipObjectDeep(props, values) {
      return baseZipObject(props || [], values || [], baseSet);
    }

    /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */
    var zipWith = baseRest(function(arrays) {
      var length = arrays.length,
          iteratee = length > 1 ? arrays[length - 1] : undefined;

      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
      return unzipWith(arrays, iteratee);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */
    function chain(value) {
      var result = lodash(value);
      result.__chain__ = true;
      return result;
    }

    /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */
    function tap(value, interceptor) {
      interceptor(value);
      return value;
    }

    /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */
    function thru(value, interceptor) {
      return interceptor(value);
    }

    /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */
    var wrapperAt = flatRest(function(paths) {
      var length = paths.length,
          start = length ? paths[0] : 0,
          value = this.__wrapped__,
          interceptor = function(object) { return baseAt(object, paths); };

      if (length > 1 || this.__actions__.length ||
          !(value instanceof LazyWrapper) || !isIndex(start)) {
        return this.thru(interceptor);
      }
      value = value.slice(start, +start + (length ? 1 : 0));
      value.__actions__.push({
        'func': thru,
        'args': [interceptor],
        'thisArg': undefined
      });
      return new LodashWrapper(value, this.__chain__).thru(function(array) {
        if (length && !array.length) {
          array.push(undefined);
        }
        return array;
      });
    });

    /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */
    function wrapperChain() {
      return chain(this);
    }

    /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */
    function wrapperCommit() {
      return new LodashWrapper(this.value(), this.__chain__);
    }

    /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */
    function wrapperNext() {
      if (this.__values__ === undefined) {
        this.__values__ = toArray(this.value());
      }
      var done = this.__index__ >= this.__values__.length,
          value = done ? undefined : this.__values__[this.__index__++];

      return { 'done': done, 'value': value };
    }

    /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */
    function wrapperToIterator() {
      return this;
    }

    /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */
    function wrapperPlant(value) {
      var result,
          parent = this;

      while (parent instanceof baseLodash) {
        var clone = wrapperClone(parent);
        clone.__index__ = 0;
        clone.__values__ = undefined;
        if (result) {
          previous.__wrapped__ = clone;
        } else {
          result = clone;
        }
        var previous = clone;
        parent = parent.__wrapped__;
      }
      previous.__wrapped__ = value;
      return result;
    }

    /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function wrapperReverse() {
      var value = this.__wrapped__;
      if (value instanceof LazyWrapper) {
        var wrapped = value;
        if (this.__actions__.length) {
          wrapped = new LazyWrapper(this);
        }
        wrapped = wrapped.reverse();
        wrapped.__actions__.push({
          'func': thru,
          'args': [reverse],
          'thisArg': undefined
        });
        return new LodashWrapper(wrapped, this.__chain__);
      }
      return this.thru(reverse);
    }

    /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */
    function wrapperValue() {
      return baseWrapperValue(this.__wrapped__, this.__actions__);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */
    var countBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        ++result[key];
      } else {
        baseAssignValue(result, key, 1);
      }
    });

    /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */
    function every(collection, predicate, guard) {
      var func = isArray(collection) ? arrayEvery : baseEvery;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     */
    function filter(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */
    var find = createFind(findIndex);

    /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */
    var findLast = createFind(findLastIndex);

    /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMap(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), 1);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMapDeep(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), INFINITY);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */
    function flatMapDepth(collection, iteratee, depth) {
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(map(collection, iteratee), depth);
    }

    /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forEach(collection, iteratee) {
      var func = isArray(collection) ? arrayEach : baseEach;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */
    function forEachRight(collection, iteratee) {
      var func = isArray(collection) ? arrayEachRight : baseEachRight;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */
    var groupBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        result[key].push(value);
      } else {
        baseAssignValue(result, key, [value]);
      }
    });

    /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */
    function includes(collection, value, fromIndex, guard) {
      collection = isArrayLike(collection) ? collection : values(collection);
      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;

      var length = collection.length;
      if (fromIndex < 0) {
        fromIndex = nativeMax(length + fromIndex, 0);
      }
      return isString(collection)
        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
    }

    /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */
    var invokeMap = baseRest(function(collection, path, args) {
      var index = -1,
          isFunc = typeof path == 'function',
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value) {
        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
      });
      return result;
    });

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */
    var keyBy = createAggregator(function(result, value, key) {
      baseAssignValue(result, key, value);
    });

    /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */
    function map(collection, iteratee) {
      var func = isArray(collection) ? arrayMap : baseMap;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */
    function orderBy(collection, iteratees, orders, guard) {
      if (collection == null) {
        return [];
      }
      if (!isArray(iteratees)) {
        iteratees = iteratees == null ? [] : [iteratees];
      }
      orders = guard ? undefined : orders;
      if (!isArray(orders)) {
        orders = orders == null ? [] : [orders];
      }
      return baseOrderBy(collection, iteratees, orders);
    }

    /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */
    var partition = createAggregator(function(result, value, key) {
      result[key ? 0 : 1].push(value);
    }, function() { return [[], []]; });

    /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */
    function reduce(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduce : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
    }

    /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */
    function reduceRight(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduceRight : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
    }

    /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */
    function reject(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, negate(getIteratee(predicate, 3)));
    }

    /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */
    function sample(collection) {
      var func = isArray(collection) ? arraySample : baseSample;
      return func(collection);
    }

    /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */
    function sampleSize(collection, n, guard) {
      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
      return func(collection, n);
    }

    /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */
    function shuffle(collection) {
      var func = isArray(collection) ? arrayShuffle : baseShuffle;
      return func(collection);
    }

    /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */
    function size(collection) {
      if (collection == null) {
        return 0;
      }
      if (isArrayLike(collection)) {
        return isString(collection) ? stringSize(collection) : collection.length;
      }
      var tag = getTag(collection);
      if (tag == mapTag || tag == setTag) {
        return collection.size;
      }
      return baseKeys(collection).length;
    }

    /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */
    function some(collection, predicate, guard) {
      var func = isArray(collection) ? arraySome : baseSome;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 40], ['fred', 48]]
     */
    var sortBy = baseRest(function(collection, iteratees) {
      if (collection == null) {
        return [];
      }
      var length = iteratees.length;
      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
        iteratees = [];
      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
        iteratees = [iteratees[0]];
      }
      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */
    var now = ctxNow || function() {
      return root.Date.now();
    };

    /*------------------------------------------------------------------------*/

    /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */
    function after(n, func) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n < 1) {
          return func.apply(this, arguments);
        }
      };
    }

    /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */
    function ary(func, n, guard) {
      n = guard ? undefined : n;
      n = (func && n == null) ? func.length : n;
      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
    }

    /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */
    function before(n, func) {
      var result;
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n > 0) {
          result = func.apply(this, arguments);
        }
        if (n <= 1) {
          func = undefined;
        }
        return result;
      };
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */
    var bind = baseRest(function(func, thisArg, partials) {
      var bitmask = WRAP_BIND_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bind));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(func, bitmask, thisArg, partials, holders);
    });

    /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */
    var bindKey = baseRest(function(object, key, partials) {
      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bindKey));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(key, bitmask, object, partials, holders);
    });

    /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */
    function curry(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curry.placeholder;
      return result;
    }

    /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */
    function curryRight(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curryRight.placeholder;
      return result;
    }

    /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */
    function debounce(func, wait, options) {
      var lastArgs,
          lastThis,
          maxWait,
          result,
          timerId,
          lastCallTime,
          lastInvokeTime = 0,
          leading = false,
          maxing = false,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      wait = toNumber(wait) || 0;
      if (isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }

      function invokeFunc(time) {
        var args = lastArgs,
            thisArg = lastThis;

        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
      }

      function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
      }

      function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime,
            timeWaiting = wait - timeSinceLastCall;

        return maxing
          ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
          : timeWaiting;
      }

      function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime;

        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
      }

      function timerExpired() {
        var time = now();
        if (shouldInvoke(time)) {
          return trailingEdge(time);
        }
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
      }

      function trailingEdge(time) {
        timerId = undefined;

        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) {
          return invokeFunc(time);
        }
        lastArgs = lastThis = undefined;
        return result;
      }

      function cancel() {
        if (timerId !== undefined) {
          clearTimeout(timerId);
        }
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
      }

      function flush() {
        return timerId === undefined ? result : trailingEdge(now());
      }

      function debounced() {
        var time = now(),
            isInvoking = shouldInvoke(time);

        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;

        if (isInvoking) {
          if (timerId === undefined) {
            return leadingEdge(lastCallTime);
          }
          if (maxing) {
            // Handle invocations in a tight loop.
            timerId = setTimeout(timerExpired, wait);
            return invokeFunc(lastCallTime);
          }
        }
        if (timerId === undefined) {
          timerId = setTimeout(timerExpired, wait);
        }
        return result;
      }
      debounced.cancel = cancel;
      debounced.flush = flush;
      return debounced;
    }

    /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */
    var defer = baseRest(function(func, args) {
      return baseDelay(func, 1, args);
    });

    /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */
    var delay = baseRest(function(func, wait, args) {
      return baseDelay(func, toNumber(wait) || 0, args);
    });

    /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */
    function flip(func) {
      return createWrap(func, WRAP_FLIP_FLAG);
    }

    /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */
    function memoize(func, resolver) {
      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var memoized = function() {
        var args = arguments,
            key = resolver ? resolver.apply(this, args) : args[0],
            cache = memoized.cache;

        if (cache.has(key)) {
          return cache.get(key);
        }
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
      };
      memoized.cache = new (memoize.Cache || MapCache);
      return memoized;
    }

    // Expose `MapCache`.
    memoize.Cache = MapCache;

    /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */
    function negate(predicate) {
      if (typeof predicate != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return function() {
        var args = arguments;
        switch (args.length) {
          case 0: return !predicate.call(this);
          case 1: return !predicate.call(this, args[0]);
          case 2: return !predicate.call(this, args[0], args[1]);
          case 3: return !predicate.call(this, args[0], args[1], args[2]);
        }
        return !predicate.apply(this, args);
      };
    }

    /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */
    function once(func) {
      return before(2, func);
    }

    /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */
    var overArgs = castRest(function(func, transforms) {
      transforms = (transforms.length == 1 && isArray(transforms[0]))
        ? arrayMap(transforms[0], baseUnary(getIteratee()))
        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));

      var funcsLength = transforms.length;
      return baseRest(function(args) {
        var index = -1,
            length = nativeMin(args.length, funcsLength);

        while (++index < length) {
          args[index] = transforms[index].call(this, args[index]);
        }
        return apply(func, this, args);
      });
    });

    /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */
    var partial = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partial));
      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
    });

    /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */
    var partialRight = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partialRight));
      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
    });

    /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */
    var rearg = flatRest(function(func, indexes) {
      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
    });

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */
    function rest(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start === undefined ? start : toInteger(start);
      return baseRest(func, start);
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */
    function spread(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start == null ? 0 : nativeMax(toInteger(start), 0);
      return baseRest(function(args) {
        var array = args[start],
            otherArgs = castSlice(args, 0, start);

        if (array) {
          arrayPush(otherArgs, array);
        }
        return apply(func, this, otherArgs);
      });
    }

    /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */
    function throttle(func, wait, options) {
      var leading = true,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      if (isObject(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }
      return debounce(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
      });
    }

    /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */
    function unary(func) {
      return ary(func, 1);
    }

    /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */
    function wrap(value, wrapper) {
      return partial(castFunction(wrapper), value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */
    function castArray() {
      if (!arguments.length) {
        return [];
      }
      var value = arguments[0];
      return isArray(value) ? value : [value];
    }

    /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */
    function clone(value) {
      return baseClone(value, CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */
    function cloneWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */
    function cloneDeep(value) {
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */
    function cloneDeepWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */
    function conformsTo(object, source) {
      return source == null || baseConformsTo(object, source, keys(source));
    }

    /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */
    function eq(value, other) {
      return value === other || (value !== value && other !== other);
    }

    /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */
    var gt = createRelationalOperation(baseGt);

    /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */
    var gte = createRelationalOperation(function(value, other) {
      return value >= other;
    });

    /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */
    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
        !propertyIsEnumerable.call(value, 'callee');
    };

    /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */
    var isArray = Array.isArray;

    /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */
    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;

    /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */
    function isArrayLike(value) {
      return value != null && isLength(value.length) && !isFunction(value);
    }

    /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */
    function isArrayLikeObject(value) {
      return isObjectLike(value) && isArrayLike(value);
    }

    /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */
    function isBoolean(value) {
      return value === true || value === false ||
        (isObjectLike(value) && baseGetTag(value) == boolTag);
    }

    /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */
    var isBuffer = nativeIsBuffer || stubFalse;

    /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */
    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;

    /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */
    function isElement(value) {
      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
    }

    /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */
    function isEmpty(value) {
      if (value == null) {
        return true;
      }
      if (isArrayLike(value) &&
          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
        return !value.length;
      }
      var tag = getTag(value);
      if (tag == mapTag || tag == setTag) {
        return !value.size;
      }
      if (isPrototype(value)) {
        return !baseKeys(value).length;
      }
      for (var key in value) {
        if (hasOwnProperty.call(value, key)) {
          return false;
        }
      }
      return true;
    }

    /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */
    function isEqual(value, other) {
      return baseIsEqual(value, other);
    }

    /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */
    function isEqualWith(value, other, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      var result = customizer ? customizer(value, other) : undefined;
      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
    }

    /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */
    function isError(value) {
      if (!isObjectLike(value)) {
        return false;
      }
      var tag = baseGetTag(value);
      return tag == errorTag || tag == domExcTag ||
        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
    }

    /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */
    function isFinite(value) {
      return typeof value == 'number' && nativeIsFinite(value);
    }

    /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */
    function isFunction(value) {
      if (!isObject(value)) {
        return false;
      }
      // The use of `Object#toString` avoids issues with the `typeof` operator
      // in Safari 9 which returns 'object' for typed arrays and other constructors.
      var tag = baseGetTag(value);
      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
    }

    /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */
    function isInteger(value) {
      return typeof value == 'number' && value == toInteger(value);
    }

    /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */
    function isLength(value) {
      return typeof value == 'number' &&
        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */
    function isObject(value) {
      var type = typeof value;
      return value != null && (type == 'object' || type == 'function');
    }

    /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */
    function isObjectLike(value) {
      return value != null && typeof value == 'object';
    }

    /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */
    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

    /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */
    function isMatch(object, source) {
      return object === source || baseIsMatch(object, source, getMatchData(source));
    }

    /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */
    function isMatchWith(object, source, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseIsMatch(object, source, getMatchData(source), customizer);
    }

    /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */
    function isNaN(value) {
      // An `NaN` primitive is the only value that is not equal to itself.
      // Perform the `toStringTag` check first to avoid errors with some
      // ActiveX objects in IE.
      return isNumber(value) && value != +value;
    }

    /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */
    function isNative(value) {
      if (isMaskable(value)) {
        throw new Error(CORE_ERROR_TEXT);
      }
      return baseIsNative(value);
    }

    /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */
    function isNull(value) {
      return value === null;
    }

    /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */
    function isNil(value) {
      return value == null;
    }

    /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */
    function isNumber(value) {
      return typeof value == 'number' ||
        (isObjectLike(value) && baseGetTag(value) == numberTag);
    }

    /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */
    function isPlainObject(value) {
      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
        return false;
      }
      var proto = getPrototype(value);
      if (proto === null) {
        return true;
      }
      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
        funcToString.call(Ctor) == objectCtorString;
    }

    /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */
    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;

    /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */
    function isSafeInteger(value) {
      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */
    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

    /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */
    function isString(value) {
      return typeof value == 'string' ||
        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
    }

    /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */
    function isSymbol(value) {
      return typeof value == 'symbol' ||
        (isObjectLike(value) && baseGetTag(value) == symbolTag);
    }

    /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */
    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

    /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */
    function isUndefined(value) {
      return value === undefined;
    }

    /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */
    function isWeakMap(value) {
      return isObjectLike(value) && getTag(value) == weakMapTag;
    }

    /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */
    function isWeakSet(value) {
      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
    }

    /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */
    var lt = createRelationalOperation(baseLt);

    /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */
    var lte = createRelationalOperation(function(value, other) {
      return value <= other;
    });

    /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */
    function toArray(value) {
      if (!value) {
        return [];
      }
      if (isArrayLike(value)) {
        return isString(value) ? stringToArray(value) : copyArray(value);
      }
      if (symIterator && value[symIterator]) {
        return iteratorToArray(value[symIterator]());
      }
      var tag = getTag(value),
          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);

      return func(value);
    }

    /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */
    function toFinite(value) {
      if (!value) {
        return value === 0 ? value : 0;
      }
      value = toNumber(value);
      if (value === INFINITY || value === -INFINITY) {
        var sign = (value < 0 ? -1 : 1);
        return sign * MAX_INTEGER;
      }
      return value === value ? value : 0;
    }

    /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */
    function toInteger(value) {
      var result = toFinite(value),
          remainder = result % 1;

      return result === result ? (remainder ? result - remainder : result) : 0;
    }

    /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */
    function toLength(value) {
      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
    }

    /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */
    function toNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      if (isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = isObject(other) ? (other + '') : other;
      }
      if (typeof value != 'string') {
        return value === 0 ? value : +value;
      }
      value = value.replace(reTrim, '');
      var isBinary = reIsBinary.test(value);
      return (isBinary || reIsOctal.test(value))
        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
        : (reIsBadHex.test(value) ? NAN : +value);
    }

    /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */
    function toPlainObject(value) {
      return copyObject(value, keysIn(value));
    }

    /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */
    function toSafeInteger(value) {
      return value
        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
        : (value === 0 ? value : 0);
    }

    /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */
    function toString(value) {
      return value == null ? '' : baseToString(value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */
    var assign = createAssigner(function(object, source) {
      if (isPrototype(source) || isArrayLike(source)) {
        copyObject(source, keys(source), object);
        return;
      }
      for (var key in source) {
        if (hasOwnProperty.call(source, key)) {
          assignValue(object, key, source[key]);
        }
      }
    });

    /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */
    var assignIn = createAssigner(function(object, source) {
      copyObject(source, keysIn(source), object);
    });

    /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keysIn(source), object, customizer);
    });

    /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keys(source), object, customizer);
    });

    /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */
    var at = flatRest(baseAt);

    /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */
    function create(prototype, properties) {
      var result = baseCreate(prototype);
      return properties == null ? result : baseAssign(result, properties);
    }

    /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var defaults = baseRest(function(object, sources) {
      object = Object(object);

      var index = -1;
      var length = sources.length;
      var guard = length > 2 ? sources[2] : undefined;

      if (guard && isIterateeCall(sources[0], sources[1], guard)) {
        length = 1;
      }

      while (++index < length) {
        var source = sources[index];
        var props = keysIn(source);
        var propsIndex = -1;
        var propsLength = props.length;

        while (++propsIndex < propsLength) {
          var key = props[propsIndex];
          var value = object[key];

          if (value === undefined ||
              (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
            object[key] = source[key];
          }
        }
      }

      return object;
    });

    /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */
    var defaultsDeep = baseRest(function(args) {
      args.push(undefined, customDefaultsMerge);
      return apply(mergeWith, undefined, args);
    });

    /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */
    function findKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
    }

    /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */
    function findLastKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
    }

    /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */
    function forIn(object, iteratee) {
      return object == null
        ? object
        : baseFor(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */
    function forInRight(object, iteratee) {
      return object == null
        ? object
        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forOwn(object, iteratee) {
      return object && baseForOwn(object, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */
    function forOwnRight(object, iteratee) {
      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
    }

    /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */
    function functions(object) {
      return object == null ? [] : baseFunctions(object, keys(object));
    }

    /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */
    function functionsIn(object) {
      return object == null ? [] : baseFunctions(object, keysIn(object));
    }

    /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */
    function get(object, path, defaultValue) {
      var result = object == null ? undefined : baseGet(object, path);
      return result === undefined ? defaultValue : result;
    }

    /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */
    function has(object, path) {
      return object != null && hasPath(object, path, baseHas);
    }

    /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */
    function hasIn(object, path) {
      return object != null && hasPath(object, path, baseHasIn);
    }

    /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */
    var invert = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      result[value] = key;
    }, constant(identity));

    /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */
    var invertBy = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      if (hasOwnProperty.call(result, value)) {
        result[value].push(key);
      } else {
        result[value] = [key];
      }
    }, getIteratee);

    /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */
    var invoke = baseRest(baseInvoke);

    /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */
    function keys(object) {
      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
    }

    /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */
    function keysIn(object) {
      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
    }

    /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */
    function mapKeys(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, iteratee(value, key, object), value);
      });
      return result;
    }

    /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */
    function mapValues(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, key, iteratee(value, key, object));
      });
      return result;
    }

    /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */
    var merge = createAssigner(function(object, source, srcIndex) {
      baseMerge(object, source, srcIndex);
    });

    /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */
    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
      baseMerge(object, source, srcIndex, customizer);
    });

    /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */
    var omit = flatRest(function(object, paths) {
      var result = {};
      if (object == null) {
        return result;
      }
      var isDeep = false;
      paths = arrayMap(paths, function(path) {
        path = castPath(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
      });
      copyObject(object, getAllKeysIn(object), result);
      if (isDeep) {
        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
      }
      var length = paths.length;
      while (length--) {
        baseUnset(result, paths[length]);
      }
      return result;
    });

    /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */
    function omitBy(object, predicate) {
      return pickBy(object, negate(getIteratee(predicate)));
    }

    /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */
    var pick = flatRest(function(object, paths) {
      return object == null ? {} : basePick(object, paths);
    });

    /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */
    function pickBy(object, predicate) {
      if (object == null) {
        return {};
      }
      var props = arrayMap(getAllKeysIn(object), function(prop) {
        return [prop];
      });
      predicate = getIteratee(predicate);
      return basePickBy(object, props, function(value, path) {
        return predicate(value, path[0]);
      });
    }

    /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */
    function result(object, path, defaultValue) {
      path = castPath(path, object);

      var index = -1,
          length = path.length;

      // Ensure the loop is entered when path is empty.
      if (!length) {
        length = 1;
        object = undefined;
      }
      while (++index < length) {
        var value = object == null ? undefined : object[toKey(path[index])];
        if (value === undefined) {
          index = length;
          value = defaultValue;
        }
        object = isFunction(value) ? value.call(object) : value;
      }
      return object;
    }

    /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */
    function set(object, path, value) {
      return object == null ? object : baseSet(object, path, value);
    }

    /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */
    function setWith(object, path, value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseSet(object, path, value, customizer);
    }

    /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */
    var toPairs = createToPairs(keys);

    /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */
    var toPairsIn = createToPairs(keysIn);

    /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */
    function transform(object, iteratee, accumulator) {
      var isArr = isArray(object),
          isArrLike = isArr || isBuffer(object) || isTypedArray(object);

      iteratee = getIteratee(iteratee, 4);
      if (accumulator == null) {
        var Ctor = object && object.constructor;
        if (isArrLike) {
          accumulator = isArr ? new Ctor : [];
        }
        else if (isObject(object)) {
          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
        }
        else {
          accumulator = {};
        }
      }
      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
        return iteratee(accumulator, value, index, object);
      });
      return accumulator;
    }

    /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */
    function unset(object, path) {
      return object == null ? true : baseUnset(object, path);
    }

    /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */
    function update(object, path, updater) {
      return object == null ? object : baseUpdate(object, path, castFunction(updater));
    }

    /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */
    function updateWith(object, path, updater, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
    }

    /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */
    function values(object) {
      return object == null ? [] : baseValues(object, keys(object));
    }

    /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */
    function valuesIn(object) {
      return object == null ? [] : baseValues(object, keysIn(object));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */
    function clamp(number, lower, upper) {
      if (upper === undefined) {
        upper = lower;
        lower = undefined;
      }
      if (upper !== undefined) {
        upper = toNumber(upper);
        upper = upper === upper ? upper : 0;
      }
      if (lower !== undefined) {
        lower = toNumber(lower);
        lower = lower === lower ? lower : 0;
      }
      return baseClamp(toNumber(number), lower, upper);
    }

    /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */
    function inRange(number, start, end) {
      start = toFinite(start);
      if (end === undefined) {
        end = start;
        start = 0;
      } else {
        end = toFinite(end);
      }
      number = toNumber(number);
      return baseInRange(number, start, end);
    }

    /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */
    function random(lower, upper, floating) {
      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
        upper = floating = undefined;
      }
      if (floating === undefined) {
        if (typeof upper == 'boolean') {
          floating = upper;
          upper = undefined;
        }
        else if (typeof lower == 'boolean') {
          floating = lower;
          lower = undefined;
        }
      }
      if (lower === undefined && upper === undefined) {
        lower = 0;
        upper = 1;
      }
      else {
        lower = toFinite(lower);
        if (upper === undefined) {
          upper = lower;
          lower = 0;
        } else {
          upper = toFinite(upper);
        }
      }
      if (lower > upper) {
        var temp = lower;
        lower = upper;
        upper = temp;
      }
      if (floating || lower % 1 || upper % 1) {
        var rand = nativeRandom();
        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
      }
      return baseRandom(lower, upper);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */
    var camelCase = createCompounder(function(result, word, index) {
      word = word.toLowerCase();
      return result + (index ? capitalize(word) : word);
    });

    /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */
    function capitalize(string) {
      return upperFirst(toString(string).toLowerCase());
    }

    /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */
    function deburr(string) {
      string = toString(string);
      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
    }

    /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */
    function endsWith(string, target, position) {
      string = toString(string);
      target = baseToString(target);

      var length = string.length;
      position = position === undefined
        ? length
        : baseClamp(toInteger(position), 0, length);

      var end = position;
      position -= target.length;
      return position >= 0 && string.slice(position, end) == target;
    }

    /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */
    function escape(string) {
      string = toString(string);
      return (string && reHasUnescapedHtml.test(string))
        ? string.replace(reUnescapedHtml, escapeHtmlChar)
        : string;
    }

    /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */
    function escapeRegExp(string) {
      string = toString(string);
      return (string && reHasRegExpChar.test(string))
        ? string.replace(reRegExpChar, '\\$&')
        : string;
    }

    /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */
    var kebabCase = createCompounder(function(result, word, index) {
      return result + (index ? '-' : '') + word.toLowerCase();
    });

    /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */
    var lowerCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toLowerCase();
    });

    /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */
    var lowerFirst = createCaseFirst('toLowerCase');

    /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */
    function pad(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      if (!length || strLength >= length) {
        return string;
      }
      var mid = (length - strLength) / 2;
      return (
        createPadding(nativeFloor(mid), chars) +
        string +
        createPadding(nativeCeil(mid), chars)
      );
    }

    /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */
    function padEnd(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (string + createPadding(length - strLength, chars))
        : string;
    }

    /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */
    function padStart(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (createPadding(length - strLength, chars) + string)
        : string;
    }

    /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */
    function parseInt(string, radix, guard) {
      if (guard || radix == null) {
        radix = 0;
      } else if (radix) {
        radix = +radix;
      }
      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
    }

    /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */
    function repeat(string, n, guard) {
      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      return baseRepeat(toString(string), n);
    }

    /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */
    function replace() {
      var args = arguments,
          string = toString(args[0]);

      return args.length < 3 ? string : string.replace(args[1], args[2]);
    }

    /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */
    var snakeCase = createCompounder(function(result, word, index) {
      return result + (index ? '_' : '') + word.toLowerCase();
    });

    /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */
    function split(string, separator, limit) {
      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
        separator = limit = undefined;
      }
      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
      if (!limit) {
        return [];
      }
      string = toString(string);
      if (string && (
            typeof separator == 'string' ||
            (separator != null && !isRegExp(separator))
          )) {
        separator = baseToString(separator);
        if (!separator && hasUnicode(string)) {
          return castSlice(stringToArray(string), 0, limit);
        }
      }
      return string.split(separator, limit);
    }

    /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */
    var startCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + upperFirst(word);
    });

    /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */
    function startsWith(string, target, position) {
      string = toString(string);
      position = position == null
        ? 0
        : baseClamp(toInteger(position), 0, string.length);

      target = baseToString(target);
      return string.slice(position, position + target.length) == target;
    }

    /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */
    function template(string, options, guard) {
      // Based on John Resig's `tmpl` implementation
      // (http://ejohn.org/blog/javascript-micro-templating/)
      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
      var settings = lodash.templateSettings;

      if (guard && isIterateeCall(string, options, guard)) {
        options = undefined;
      }
      string = toString(string);
      options = assignInWith({}, options, settings, customDefaultsAssignIn);

      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
          importsKeys = keys(imports),
          importsValues = baseValues(imports, importsKeys);

      var isEscaping,
          isEvaluating,
          index = 0,
          interpolate = options.interpolate || reNoMatch,
          source = "__p += '";

      // Compile the regexp to match each delimiter.
      var reDelimiters = RegExp(
        (options.escape || reNoMatch).source + '|' +
        interpolate.source + '|' +
        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
        (options.evaluate || reNoMatch).source + '|$'
      , 'g');

      // Use a sourceURL for easier debugging.
      var sourceURL = '//# sourceURL=' +
        ('sourceURL' in options
          ? options.sourceURL
          : ('lodash.templateSources[' + (++templateCounter) + ']')
        ) + '\n';

      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
        interpolateValue || (interpolateValue = esTemplateValue);

        // Escape characters that can't be included in string literals.
        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);

        // Replace delimiters with snippets.
        if (escapeValue) {
          isEscaping = true;
          source += "' +\n__e(" + escapeValue + ") +\n'";
        }
        if (evaluateValue) {
          isEvaluating = true;
          source += "';\n" + evaluateValue + ";\n__p += '";
        }
        if (interpolateValue) {
          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
        }
        index = offset + match.length;

        // The JS engine embedded in Adobe products needs `match` returned in
        // order to produce the correct `offset` value.
        return match;
      });

      source += "';\n";

      // If `variable` is not specified wrap a with-statement around the generated
      // code to add the data object to the top of the scope chain.
      var variable = options.variable;
      if (!variable) {
        source = 'with (obj) {\n' + source + '\n}\n';
      }
      // Cleanup code by stripping empty strings.
      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
        .replace(reEmptyStringMiddle, '$1')
        .replace(reEmptyStringTrailing, '$1;');

      // Frame code as the function body.
      source = 'function(' + (variable || 'obj') + ') {\n' +
        (variable
          ? ''
          : 'obj || (obj = {});\n'
        ) +
        "var __t, __p = ''" +
        (isEscaping
           ? ', __e = _.escape'
           : ''
        ) +
        (isEvaluating
          ? ', __j = Array.prototype.join;\n' +
            "function print() { __p += __j.call(arguments, '') }\n"
          : ';\n'
        ) +
        source +
        'return __p\n}';

      var result = attempt(function() {
        return Function(importsKeys, sourceURL + 'return ' + source)
          .apply(undefined, importsValues);
      });

      // Provide the compiled function's source by its `toString` method or
      // the `source` property as a convenience for inlining compiled templates.
      result.source = source;
      if (isError(result)) {
        throw result;
      }
      return result;
    }

    /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */
    function toLower(value) {
      return toString(value).toLowerCase();
    }

    /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */
    function toUpper(value) {
      return toString(value).toUpperCase();
    }

    /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */
    function trim(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrim, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          chrSymbols = stringToArray(chars),
          start = charsStartIndex(strSymbols, chrSymbols),
          end = charsEndIndex(strSymbols, chrSymbols) + 1;

      return castSlice(strSymbols, start, end).join('');
    }

    /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */
    function trimEnd(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimEnd, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;

      return castSlice(strSymbols, 0, end).join('');
    }

    /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */
    function trimStart(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimStart, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          start = charsStartIndex(strSymbols, stringToArray(chars));

      return castSlice(strSymbols, start).join('');
    }

    /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */
    function truncate(string, options) {
      var length = DEFAULT_TRUNC_LENGTH,
          omission = DEFAULT_TRUNC_OMISSION;

      if (isObject(options)) {
        var separator = 'separator' in options ? options.separator : separator;
        length = 'length' in options ? toInteger(options.length) : length;
        omission = 'omission' in options ? baseToString(options.omission) : omission;
      }
      string = toString(string);

      var strLength = string.length;
      if (hasUnicode(string)) {
        var strSymbols = stringToArray(string);
        strLength = strSymbols.length;
      }
      if (length >= strLength) {
        return string;
      }
      var end = length - stringSize(omission);
      if (end < 1) {
        return omission;
      }
      var result = strSymbols
        ? castSlice(strSymbols, 0, end).join('')
        : string.slice(0, end);

      if (separator === undefined) {
        return result + omission;
      }
      if (strSymbols) {
        end += (result.length - end);
      }
      if (isRegExp(separator)) {
        if (string.slice(end).search(separator)) {
          var match,
              substring = result;

          if (!separator.global) {
            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
          }
          separator.lastIndex = 0;
          while ((match = separator.exec(substring))) {
            var newEnd = match.index;
          }
          result = result.slice(0, newEnd === undefined ? end : newEnd);
        }
      } else if (string.indexOf(baseToString(separator), end) != end) {
        var index = result.lastIndexOf(separator);
        if (index > -1) {
          result = result.slice(0, index);
        }
      }
      return result + omission;
    }

    /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */
    function unescape(string) {
      string = toString(string);
      return (string && reHasEscapedHtml.test(string))
        ? string.replace(reEscapedHtml, unescapeHtmlChar)
        : string;
    }

    /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */
    var upperCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toUpperCase();
    });

    /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */
    var upperFirst = createCaseFirst('toUpperCase');

    /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */
    function words(string, pattern, guard) {
      string = toString(string);
      pattern = guard ? undefined : pattern;

      if (pattern === undefined) {
        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
      }
      return string.match(pattern) || [];
    }

    /*------------------------------------------------------------------------*/

    /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */
    var attempt = baseRest(function(func, args) {
      try {
        return apply(func, undefined, args);
      } catch (e) {
        return isError(e) ? e : new Error(e);
      }
    });

    /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */
    var bindAll = flatRest(function(object, methodNames) {
      arrayEach(methodNames, function(key) {
        key = toKey(key);
        baseAssignValue(object, key, bind(object[key], object));
      });
      return object;
    });

    /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */
    function cond(pairs) {
      var length = pairs == null ? 0 : pairs.length,
          toIteratee = getIteratee();

      pairs = !length ? [] : arrayMap(pairs, function(pair) {
        if (typeof pair[1] != 'function') {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        return [toIteratee(pair[0]), pair[1]];
      });

      return baseRest(function(args) {
        var index = -1;
        while (++index < length) {
          var pair = pairs[index];
          if (apply(pair[0], this, args)) {
            return apply(pair[1], this, args);
          }
        }
      });
    }

    /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */
    function conforms(source) {
      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */
    function constant(value) {
      return function() {
        return value;
      };
    }

    /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */
    function defaultTo(value, defaultValue) {
      return (value == null || value !== value) ? defaultValue : value;
    }

    /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */
    var flow = createFlow();

    /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */
    var flowRight = createFlow(true);

    /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */
    function identity(value) {
      return value;
    }

    /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */
    function iteratee(func) {
      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matches(source) {
      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     */
    function matchesProperty(path, srcValue) {
      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */
    var method = baseRest(function(path, args) {
      return function(object) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */
    var methodOf = baseRest(function(object, args) {
      return function(path) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */
    function mixin(object, source, options) {
      var props = keys(source),
          methodNames = baseFunctions(source, props);

      if (options == null &&
          !(isObject(source) && (methodNames.length || !props.length))) {
        options = source;
        source = object;
        object = this;
        methodNames = baseFunctions(source, keys(source));
      }
      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
          isFunc = isFunction(object);

      arrayEach(methodNames, function(methodName) {
        var func = source[methodName];
        object[methodName] = func;
        if (isFunc) {
          object.prototype[methodName] = function() {
            var chainAll = this.__chain__;
            if (chain || chainAll) {
              var result = object(this.__wrapped__),
                  actions = result.__actions__ = copyArray(this.__actions__);

              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
              result.__chain__ = chainAll;
              return result;
            }
            return func.apply(object, arrayPush([this.value()], arguments));
          };
        }
      });

      return object;
    }

    /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */
    function noConflict() {
      if (root._ === this) {
        root._ = oldDash;
      }
      return this;
    }

    /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */
    function noop() {
      // No operation performed.
    }

    /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */
    function nthArg(n) {
      n = toInteger(n);
      return baseRest(function(args) {
        return baseNth(args, n);
      });
    }

    /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */
    var over = createOver(arrayMap);

    /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */
    var overEvery = createOver(arrayEvery);

    /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     */
    var overSome = createOver(arraySome);

    /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */
    function property(path) {
      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
    }

    /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */
    function propertyOf(object) {
      return function(path) {
        return object == null ? undefined : baseGet(object, path);
      };
    }

    /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */
    var range = createRange();

    /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */
    var rangeRight = createRange(true);

    /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */
    function stubArray() {
      return [];
    }

    /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */
    function stubFalse() {
      return false;
    }

    /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */
    function stubObject() {
      return {};
    }

    /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */
    function stubString() {
      return '';
    }

    /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */
    function stubTrue() {
      return true;
    }

    /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */
    function times(n, iteratee) {
      n = toInteger(n);
      if (n < 1 || n > MAX_SAFE_INTEGER) {
        return [];
      }
      var index = MAX_ARRAY_LENGTH,
          length = nativeMin(n, MAX_ARRAY_LENGTH);

      iteratee = getIteratee(iteratee);
      n -= MAX_ARRAY_LENGTH;

      var result = baseTimes(length, iteratee);
      while (++index < n) {
        iteratee(index);
      }
      return result;
    }

    /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */
    function toPath(value) {
      if (isArray(value)) {
        return arrayMap(value, toKey);
      }
      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
    }

    /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */
    function uniqueId(prefix) {
      var id = ++idCounter;
      return toString(prefix) + id;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */
    var add = createMathOperation(function(augend, addend) {
      return augend + addend;
    }, 0);

    /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */
    var ceil = createRound('ceil');

    /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */
    var divide = createMathOperation(function(dividend, divisor) {
      return dividend / divisor;
    }, 1);

    /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */
    var floor = createRound('floor');

    /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */
    function max(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseGt)
        : undefined;
    }

    /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */
    function maxBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
        : undefined;
    }

    /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */
    function mean(array) {
      return baseMean(array, identity);
    }

    /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */
    function meanBy(array, iteratee) {
      return baseMean(array, getIteratee(iteratee, 2));
    }

    /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */
    function min(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseLt)
        : undefined;
    }

    /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */
    function minBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
        : undefined;
    }

    /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */
    var multiply = createMathOperation(function(multiplier, multiplicand) {
      return multiplier * multiplicand;
    }, 1);

    /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */
    var round = createRound('round');

    /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */
    var subtract = createMathOperation(function(minuend, subtrahend) {
      return minuend - subtrahend;
    }, 0);

    /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */
    function sum(array) {
      return (array && array.length)
        ? baseSum(array, identity)
        : 0;
    }

    /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */
    function sumBy(array, iteratee) {
      return (array && array.length)
        ? baseSum(array, getIteratee(iteratee, 2))
        : 0;
    }

    /*------------------------------------------------------------------------*/

    // Add methods that return wrapped values in chain sequences.
    lodash.after = after;
    lodash.ary = ary;
    lodash.assign = assign;
    lodash.assignIn = assignIn;
    lodash.assignInWith = assignInWith;
    lodash.assignWith = assignWith;
    lodash.at = at;
    lodash.before = before;
    lodash.bind = bind;
    lodash.bindAll = bindAll;
    lodash.bindKey = bindKey;
    lodash.castArray = castArray;
    lodash.chain = chain;
    lodash.chunk = chunk;
    lodash.compact = compact;
    lodash.concat = concat;
    lodash.cond = cond;
    lodash.conforms = conforms;
    lodash.constant = constant;
    lodash.countBy = countBy;
    lodash.create = create;
    lodash.curry = curry;
    lodash.curryRight = curryRight;
    lodash.debounce = debounce;
    lodash.defaults = defaults;
    lodash.defaultsDeep = defaultsDeep;
    lodash.defer = defer;
    lodash.delay = delay;
    lodash.difference = difference;
    lodash.differenceBy = differenceBy;
    lodash.differenceWith = differenceWith;
    lodash.drop = drop;
    lodash.dropRight = dropRight;
    lodash.dropRightWhile = dropRightWhile;
    lodash.dropWhile = dropWhile;
    lodash.fill = fill;
    lodash.filter = filter;
    lodash.flatMap = flatMap;
    lodash.flatMapDeep = flatMapDeep;
    lodash.flatMapDepth = flatMapDepth;
    lodash.flatten = flatten;
    lodash.flattenDeep = flattenDeep;
    lodash.flattenDepth = flattenDepth;
    lodash.flip = flip;
    lodash.flow = flow;
    lodash.flowRight = flowRight;
    lodash.fromPairs = fromPairs;
    lodash.functions = functions;
    lodash.functionsIn = functionsIn;
    lodash.groupBy = groupBy;
    lodash.initial = initial;
    lodash.intersection = intersection;
    lodash.intersectionBy = intersectionBy;
    lodash.intersectionWith = intersectionWith;
    lodash.invert = invert;
    lodash.invertBy = invertBy;
    lodash.invokeMap = invokeMap;
    lodash.iteratee = iteratee;
    lodash.keyBy = keyBy;
    lodash.keys = keys;
    lodash.keysIn = keysIn;
    lodash.map = map;
    lodash.mapKeys = mapKeys;
    lodash.mapValues = mapValues;
    lodash.matches = matches;
    lodash.matchesProperty = matchesProperty;
    lodash.memoize = memoize;
    lodash.merge = merge;
    lodash.mergeWith = mergeWith;
    lodash.method = method;
    lodash.methodOf = methodOf;
    lodash.mixin = mixin;
    lodash.negate = negate;
    lodash.nthArg = nthArg;
    lodash.omit = omit;
    lodash.omitBy = omitBy;
    lodash.once = once;
    lodash.orderBy = orderBy;
    lodash.over = over;
    lodash.overArgs = overArgs;
    lodash.overEvery = overEvery;
    lodash.overSome = overSome;
    lodash.partial = partial;
    lodash.partialRight = partialRight;
    lodash.partition = partition;
    lodash.pick = pick;
    lodash.pickBy = pickBy;
    lodash.property = property;
    lodash.propertyOf = propertyOf;
    lodash.pull = pull;
    lodash.pullAll = pullAll;
    lodash.pullAllBy = pullAllBy;
    lodash.pullAllWith = pullAllWith;
    lodash.pullAt = pullAt;
    lodash.range = range;
    lodash.rangeRight = rangeRight;
    lodash.rearg = rearg;
    lodash.reject = reject;
    lodash.remove = remove;
    lodash.rest = rest;
    lodash.reverse = reverse;
    lodash.sampleSize = sampleSize;
    lodash.set = set;
    lodash.setWith = setWith;
    lodash.shuffle = shuffle;
    lodash.slice = slice;
    lodash.sortBy = sortBy;
    lodash.sortedUniq = sortedUniq;
    lodash.sortedUniqBy = sortedUniqBy;
    lodash.split = split;
    lodash.spread = spread;
    lodash.tail = tail;
    lodash.take = take;
    lodash.takeRight = takeRight;
    lodash.takeRightWhile = takeRightWhile;
    lodash.takeWhile = takeWhile;
    lodash.tap = tap;
    lodash.throttle = throttle;
    lodash.thru = thru;
    lodash.toArray = toArray;
    lodash.toPairs = toPairs;
    lodash.toPairsIn = toPairsIn;
    lodash.toPath = toPath;
    lodash.toPlainObject = toPlainObject;
    lodash.transform = transform;
    lodash.unary = unary;
    lodash.union = union;
    lodash.unionBy = unionBy;
    lodash.unionWith = unionWith;
    lodash.uniq = uniq;
    lodash.uniqBy = uniqBy;
    lodash.uniqWith = uniqWith;
    lodash.unset = unset;
    lodash.unzip = unzip;
    lodash.unzipWith = unzipWith;
    lodash.update = update;
    lodash.updateWith = updateWith;
    lodash.values = values;
    lodash.valuesIn = valuesIn;
    lodash.without = without;
    lodash.words = words;
    lodash.wrap = wrap;
    lodash.xor = xor;
    lodash.xorBy = xorBy;
    lodash.xorWith = xorWith;
    lodash.zip = zip;
    lodash.zipObject = zipObject;
    lodash.zipObjectDeep = zipObjectDeep;
    lodash.zipWith = zipWith;

    // Add aliases.
    lodash.entries = toPairs;
    lodash.entriesIn = toPairsIn;
    lodash.extend = assignIn;
    lodash.extendWith = assignInWith;

    // Add methods to `lodash.prototype`.
    mixin(lodash, lodash);

    /*------------------------------------------------------------------------*/

    // Add methods that return unwrapped values in chain sequences.
    lodash.add = add;
    lodash.attempt = attempt;
    lodash.camelCase = camelCase;
    lodash.capitalize = capitalize;
    lodash.ceil = ceil;
    lodash.clamp = clamp;
    lodash.clone = clone;
    lodash.cloneDeep = cloneDeep;
    lodash.cloneDeepWith = cloneDeepWith;
    lodash.cloneWith = cloneWith;
    lodash.conformsTo = conformsTo;
    lodash.deburr = deburr;
    lodash.defaultTo = defaultTo;
    lodash.divide = divide;
    lodash.endsWith = endsWith;
    lodash.eq = eq;
    lodash.escape = escape;
    lodash.escapeRegExp = escapeRegExp;
    lodash.every = every;
    lodash.find = find;
    lodash.findIndex = findIndex;
    lodash.findKey = findKey;
    lodash.findLast = findLast;
    lodash.findLastIndex = findLastIndex;
    lodash.findLastKey = findLastKey;
    lodash.floor = floor;
    lodash.forEach = forEach;
    lodash.forEachRight = forEachRight;
    lodash.forIn = forIn;
    lodash.forInRight = forInRight;
    lodash.forOwn = forOwn;
    lodash.forOwnRight = forOwnRight;
    lodash.get = get;
    lodash.gt = gt;
    lodash.gte = gte;
    lodash.has = has;
    lodash.hasIn = hasIn;
    lodash.head = head;
    lodash.identity = identity;
    lodash.includes = includes;
    lodash.indexOf = indexOf;
    lodash.inRange = inRange;
    lodash.invoke = invoke;
    lodash.isArguments = isArguments;
    lodash.isArray = isArray;
    lodash.isArrayBuffer = isArrayBuffer;
    lodash.isArrayLike = isArrayLike;
    lodash.isArrayLikeObject = isArrayLikeObject;
    lodash.isBoolean = isBoolean;
    lodash.isBuffer = isBuffer;
    lodash.isDate = isDate;
    lodash.isElement = isElement;
    lodash.isEmpty = isEmpty;
    lodash.isEqual = isEqual;
    lodash.isEqualWith = isEqualWith;
    lodash.isError = isError;
    lodash.isFinite = isFinite;
    lodash.isFunction = isFunction;
    lodash.isInteger = isInteger;
    lodash.isLength = isLength;
    lodash.isMap = isMap;
    lodash.isMatch = isMatch;
    lodash.isMatchWith = isMatchWith;
    lodash.isNaN = isNaN;
    lodash.isNative = isNative;
    lodash.isNil = isNil;
    lodash.isNull = isNull;
    lodash.isNumber = isNumber;
    lodash.isObject = isObject;
    lodash.isObjectLike = isObjectLike;
    lodash.isPlainObject = isPlainObject;
    lodash.isRegExp = isRegExp;
    lodash.isSafeInteger = isSafeInteger;
    lodash.isSet = isSet;
    lodash.isString = isString;
    lodash.isSymbol = isSymbol;
    lodash.isTypedArray = isTypedArray;
    lodash.isUndefined = isUndefined;
    lodash.isWeakMap = isWeakMap;
    lodash.isWeakSet = isWeakSet;
    lodash.join = join;
    lodash.kebabCase = kebabCase;
    lodash.last = last;
    lodash.lastIndexOf = lastIndexOf;
    lodash.lowerCase = lowerCase;
    lodash.lowerFirst = lowerFirst;
    lodash.lt = lt;
    lodash.lte = lte;
    lodash.max = max;
    lodash.maxBy = maxBy;
    lodash.mean = mean;
    lodash.meanBy = meanBy;
    lodash.min = min;
    lodash.minBy = minBy;
    lodash.stubArray = stubArray;
    lodash.stubFalse = stubFalse;
    lodash.stubObject = stubObject;
    lodash.stubString = stubString;
    lodash.stubTrue = stubTrue;
    lodash.multiply = multiply;
    lodash.nth = nth;
    lodash.noConflict = noConflict;
    lodash.noop = noop;
    lodash.now = now;
    lodash.pad = pad;
    lodash.padEnd = padEnd;
    lodash.padStart = padStart;
    lodash.parseInt = parseInt;
    lodash.random = random;
    lodash.reduce = reduce;
    lodash.reduceRight = reduceRight;
    lodash.repeat = repeat;
    lodash.replace = replace;
    lodash.result = result;
    lodash.round = round;
    lodash.runInContext = runInContext;
    lodash.sample = sample;
    lodash.size = size;
    lodash.snakeCase = snakeCase;
    lodash.some = some;
    lodash.sortedIndex = sortedIndex;
    lodash.sortedIndexBy = sortedIndexBy;
    lodash.sortedIndexOf = sortedIndexOf;
    lodash.sortedLastIndex = sortedLastIndex;
    lodash.sortedLastIndexBy = sortedLastIndexBy;
    lodash.sortedLastIndexOf = sortedLastIndexOf;
    lodash.startCase = startCase;
    lodash.startsWith = startsWith;
    lodash.subtract = subtract;
    lodash.sum = sum;
    lodash.sumBy = sumBy;
    lodash.template = template;
    lodash.times = times;
    lodash.toFinite = toFinite;
    lodash.toInteger = toInteger;
    lodash.toLength = toLength;
    lodash.toLower = toLower;
    lodash.toNumber = toNumber;
    lodash.toSafeInteger = toSafeInteger;
    lodash.toString = toString;
    lodash.toUpper = toUpper;
    lodash.trim = trim;
    lodash.trimEnd = trimEnd;
    lodash.trimStart = trimStart;
    lodash.truncate = truncate;
    lodash.unescape = unescape;
    lodash.uniqueId = uniqueId;
    lodash.upperCase = upperCase;
    lodash.upperFirst = upperFirst;

    // Add aliases.
    lodash.each = forEach;
    lodash.eachRight = forEachRight;
    lodash.first = head;

    mixin(lodash, (function() {
      var source = {};
      baseForOwn(lodash, function(func, methodName) {
        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
          source[methodName] = func;
        }
      });
      return source;
    }()), { 'chain': false });

    /*------------------------------------------------------------------------*/

    /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */
    lodash.VERSION = VERSION;

    // Assign default placeholders.
    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
      lodash[methodName].placeholder = lodash;
    });

    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
    arrayEach(['drop', 'take'], function(methodName, index) {
      LazyWrapper.prototype[methodName] = function(n) {
        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);

        var result = (this.__filtered__ && !index)
          ? new LazyWrapper(this)
          : this.clone();

        if (result.__filtered__) {
          result.__takeCount__ = nativeMin(n, result.__takeCount__);
        } else {
          result.__views__.push({
            'size': nativeMin(n, MAX_ARRAY_LENGTH),
            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
          });
        }
        return result;
      };

      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
        return this.reverse()[methodName](n).reverse();
      };
    });

    // Add `LazyWrapper` methods that accept an `iteratee` value.
    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
      var type = index + 1,
          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;

      LazyWrapper.prototype[methodName] = function(iteratee) {
        var result = this.clone();
        result.__iteratees__.push({
          'iteratee': getIteratee(iteratee, 3),
          'type': type
        });
        result.__filtered__ = result.__filtered__ || isFilter;
        return result;
      };
    });

    // Add `LazyWrapper` methods for `_.head` and `_.last`.
    arrayEach(['head', 'last'], function(methodName, index) {
      var takeName = 'take' + (index ? 'Right' : '');

      LazyWrapper.prototype[methodName] = function() {
        return this[takeName](1).value()[0];
      };
    });

    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
    arrayEach(['initial', 'tail'], function(methodName, index) {
      var dropName = 'drop' + (index ? '' : 'Right');

      LazyWrapper.prototype[methodName] = function() {
        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
      };
    });

    LazyWrapper.prototype.compact = function() {
      return this.filter(identity);
    };

    LazyWrapper.prototype.find = function(predicate) {
      return this.filter(predicate).head();
    };

    LazyWrapper.prototype.findLast = function(predicate) {
      return this.reverse().find(predicate);
    };

    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
      if (typeof path == 'function') {
        return new LazyWrapper(this);
      }
      return this.map(function(value) {
        return baseInvoke(value, path, args);
      });
    });

    LazyWrapper.prototype.reject = function(predicate) {
      return this.filter(negate(getIteratee(predicate)));
    };

    LazyWrapper.prototype.slice = function(start, end) {
      start = toInteger(start);

      var result = this;
      if (result.__filtered__ && (start > 0 || end < 0)) {
        return new LazyWrapper(result);
      }
      if (start < 0) {
        result = result.takeRight(-start);
      } else if (start) {
        result = result.drop(start);
      }
      if (end !== undefined) {
        end = toInteger(end);
        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
      }
      return result;
    };

    LazyWrapper.prototype.takeRightWhile = function(predicate) {
      return this.reverse().takeWhile(predicate).reverse();
    };

    LazyWrapper.prototype.toArray = function() {
      return this.take(MAX_ARRAY_LENGTH);
    };

    // Add `LazyWrapper` methods to `lodash.prototype`.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
          isTaker = /^(?:head|last)$/.test(methodName),
          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
          retUnwrapped = isTaker || /^find/.test(methodName);

      if (!lodashFunc) {
        return;
      }
      lodash.prototype[methodName] = function() {
        var value = this.__wrapped__,
            args = isTaker ? [1] : arguments,
            isLazy = value instanceof LazyWrapper,
            iteratee = args[0],
            useLazy = isLazy || isArray(value);

        var interceptor = function(value) {
          var result = lodashFunc.apply(lodash, arrayPush([value], args));
          return (isTaker && chainAll) ? result[0] : result;
        };

        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
          // Avoid lazy use if the iteratee has a "length" value other than `1`.
          isLazy = useLazy = false;
        }
        var chainAll = this.__chain__,
            isHybrid = !!this.__actions__.length,
            isUnwrapped = retUnwrapped && !chainAll,
            onlyLazy = isLazy && !isHybrid;

        if (!retUnwrapped && useLazy) {
          value = onlyLazy ? value : new LazyWrapper(this);
          var result = func.apply(value, args);
          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
          return new LodashWrapper(result, chainAll);
        }
        if (isUnwrapped && onlyLazy) {
          return func.apply(this, args);
        }
        result = this.thru(interceptor);
        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
      };
    });

    // Add `Array` methods to `lodash.prototype`.
    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
      var func = arrayProto[methodName],
          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
          retUnwrapped = /^(?:pop|shift)$/.test(methodName);

      lodash.prototype[methodName] = function() {
        var args = arguments;
        if (retUnwrapped && !this.__chain__) {
          var value = this.value();
          return func.apply(isArray(value) ? value : [], args);
        }
        return this[chainName](function(value) {
          return func.apply(isArray(value) ? value : [], args);
        });
      };
    });

    // Map minified method names to their real names.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var lodashFunc = lodash[methodName];
      if (lodashFunc) {
        var key = (lodashFunc.name + ''),
            names = realNames[key] || (realNames[key] = []);

        names.push({ 'name': methodName, 'func': lodashFunc });
      }
    });

    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
      'name': 'wrapper',
      'func': undefined
    }];

    // Add methods to `LazyWrapper`.
    LazyWrapper.prototype.clone = lazyClone;
    LazyWrapper.prototype.reverse = lazyReverse;
    LazyWrapper.prototype.value = lazyValue;

    // Add chain sequence methods to the `lodash` wrapper.
    lodash.prototype.at = wrapperAt;
    lodash.prototype.chain = wrapperChain;
    lodash.prototype.commit = wrapperCommit;
    lodash.prototype.next = wrapperNext;
    lodash.prototype.plant = wrapperPlant;
    lodash.prototype.reverse = wrapperReverse;
    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;

    // Add lazy aliases.
    lodash.prototype.first = lodash.prototype.head;

    if (symIterator) {
      lodash.prototype[symIterator] = wrapperToIterator;
    }
    return lodash;
  });

  /*--------------------------------------------------------------------------*/

  // Export lodash.
  var _ = runInContext();

  // Some AMD build optimizers, like r.js, check for condition patterns like:
  if (true) {
    // Expose Lodash on the global object to prevent errors when Lodash is
    // loaded by a script tag in the presence of an AMD loader.
    // See http://requirejs.org/docs/errors.html#mismatch for more details.
    // Use `_.noConflict` to remove Lodash from the global object.
    root._ = _;

    // Define as an anonymous module so, through path mapping, it can be
    // referenced as the "underscore" module.
    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
      return _;
    }.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  }
  // Check for `exports` after `define` in case a build optimizer adds it.
  else if (freeModule) {
    // Export for Node.js.
    (freeModule.exports = _)._ = _;
    // Export for CommonJS support.
    freeExports._ = _;
  }
  else {
    // Export to the global object.
    root._ = _;
  }
}.call(this));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(26), __webpack_require__(248)(module)))

/***/ }),
/* 18 */
/***/ (function(module, exports) {

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

module.exports = _classCallCheck;

/***/ }),
/* 19 */
/***/ (function(module, exports) {

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

module.exports = _createClass;

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = __webpack_require__(454);

var assertThisInitialized = __webpack_require__(127);

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return assertThisInitialized(self);
}

module.exports = _possibleConstructorReturn;

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

var setPrototypeOf = __webpack_require__(787);

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) setPrototypeOf(subClass, superClass);
}

module.exports = _inherits;

/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_append__ = __webpack_require__(2511);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__util_append__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_arabic_to_roman__ = __webpack_require__(2512);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_1__util_arabic_to_roman__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_create_promise__ = __webpack_require__(2513);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_2__util_create_promise__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_defined__ = __webpack_require__(199);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_3__util_defined__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_definition_id__ = __webpack_require__(2514);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_4__util_definition_id__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_deg__ = __webpack_require__(2515);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_5__util_deg__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_encode_base64__ = __webpack_require__(2516);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_6__util_encode_base64__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_event_coordinates__ = __webpack_require__(2517);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_7__util_event_coordinates__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util_event_element__ = __webpack_require__(2518);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_8__util_event_element__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util_is_transparent__ = __webpack_require__(2519);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return __WEBPACK_IMPORTED_MODULE_9__util_is_transparent__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util_last__ = __webpack_require__(2520);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return __WEBPACK_IMPORTED_MODULE_10__util_last__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__util_limit_value__ = __webpack_require__(2521);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return __WEBPACK_IMPORTED_MODULE_11__util_limit_value__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__util_merge_sort__ = __webpack_require__(2522);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return __WEBPACK_IMPORTED_MODULE_12__util_merge_sort__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__util_promise_all__ = __webpack_require__(2523);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return __WEBPACK_IMPORTED_MODULE_13__util_promise_all__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__util_rad__ = __webpack_require__(2524);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return __WEBPACK_IMPORTED_MODULE_14__util_rad__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__util_round__ = __webpack_require__(2525);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return __WEBPACK_IMPORTED_MODULE_15__util_round__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__util_value_or_default__ = __webpack_require__(2526);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return __WEBPACK_IMPORTED_MODULE_16__util_value_or_default__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__util_bind_events__ = __webpack_require__(2527);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_17__util_bind_events__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__util_element_offset__ = __webpack_require__(2528);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_18__util_element_offset__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__util_element_size__ = __webpack_require__(2529);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_19__util_element_size__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__util_element_styles__ = __webpack_require__(641);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_20__util_element_styles__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__util_unbind_events__ = __webpack_require__(2530);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return __WEBPACK_IMPORTED_MODULE_21__util_unbind_events__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__util_constants__ = __webpack_require__(400);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_22__util_constants__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_22__util_constants__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__text_metrics__ = __webpack_require__(642);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "s", function() { return __WEBPACK_IMPORTED_MODULE_23__text_metrics__["a"]; });


























/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

var defineProperty = __webpack_require__(11);

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      defineProperty(target, key, source[key]);
    });
  }

  return target;
}

module.exports = _objectSpread;

/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_core__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var styles=function styles(theme){return{textField:{width:'100%',marginTop:0,marginBottom:0}};};var FormInputClass=function(_React$Component){_inherits(FormInputClass,_React$Component);function FormInputClass(props){_classCallCheck(this,FormInputClass);var _this=_possibleConstructorReturn(this,(FormInputClass.__proto__||Object.getPrototypeOf(FormInputClass)).call(this,props));_this.handleChange=function(event){event.preventDefault();if(_this.props.input.onChange&&!_this.props.readOnly||_this.props.fixedValue){_this.props.input.onChange(event);_this.props.input.onBlur(event);}};_this.handleChange=_this.handleChange.bind(_this);return _this;}_createClass(FormInputClass,[{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps){var _this2=this;var comparedState=false;Object.keys(this.props).map(function(s){if(_this2.props[s]!==nextProps[s]){comparedState=true;}return s;});return comparedState;}},{key:'render',value:function render(){this.props.meta.valid=false;var trySubmit=this.props.checkValidation?true:false;var _props$meta=this.props.meta,touched=_props$meta.touched,error=_props$meta.error;var lValue=this.props.fixedValue?this.props.fixedValue:this.props.input.value;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["X" /* TextField */],{onChange:this.handleChange,id:this.props.input.name,value:lValue?lValue:'',label:this.props.label,className:this.props.classes.textField,margin:'normal',error:error&&error.length>0&&(touched||this.props.fixedValue)?true:error&&error.length>0&&trySubmit?true:false,helperText:error&&(touched||this.props.fixedValue)||error&&trySubmit?error:null,InputProps:{readOnly:this.props.readOnly?true:false},placeholder:this.props.placeholder});}}]);return FormInputClass;}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["_1" /* withStyles */])(styles)(FormInputClass));

/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core__ = __webpack_require__(4);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var styles=function styles(theme){return{dropdown:{width:'100%'}};};var FancyLabel=function FancyLabel(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{display:'flex',textAlign:'center',position:'relative'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{Typography:true,style:{width:'40%',flexFlow:'row-reverse'},className:'fancyLabelLine'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core__["Z" /* Typography */],{variant:'caption',style:{width:'20%'}},props.text),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{Typography:true,style:{width:'40%',flexFlow:'row'},className:'fancyLabelLine'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null)));};var FormDropdown=function(_React$Component){_inherits(FormDropdown,_React$Component);function FormDropdown(props){_classCallCheck(this,FormDropdown);var _this=_possibleConstructorReturn(this,(FormDropdown.__proto__||Object.getPrototypeOf(FormDropdown)).call(this,props));_this.handleChange=_this.handleChange.bind(_this);_this.state={disabled:false};return _this;}_createClass(FormDropdown,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(nextProps.meta.touched||nextProps.input.value!==this.props.input.value||nextProps.p_value!==this.props.p_value){this.forceUpdate();}this.forceUpdate();}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(){this.forceUpdate();return true;}},{key:'handleChange',value:function handleChange(event){if(this.props.input.onChange){this.props.input.onChange(event.target.value);}if(this.props.onValueChange){this.props.onValueChange(event.target.value);}}},{key:'render',value:function render(){var lValue=this.props.input.value?this.props.input.value:this.props.options[0].value;var items=this.props.options.map(function(option,i){if((typeof option==='undefined'?'undefined':_typeof(option))==='object'&&option){if(option.hidden)return null;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core__["F" /* MenuItem */],{value:option.value,key:option.value,className:!option.value?'dropdownEmpty':''},!option.value?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{display:'block',width:'100%',cursor:'default',marginBottom:'10px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'emptyOption',style:!lValue?{background:'rgba(0, 0, 0, 0.08)'}:{}},option.displayValue),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(FancyLabel,{text:'or'})):option.displayValue);}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core__["F" /* MenuItem */],{value:option,key:i},option);}});var error=this.props.meta.error;var touched=this.props.input.value?true:false;var trySubmit=this.props.checkValidation?true:false;var validationError=(lValue==='validationError'||!lValue)&&touched&&this.props.isrequired?true:(lValue==='validationError'||!lValue)&&this.props.isrequired&&trySubmit?true:false;var errors=error&&(touched||this.props.fixedValue)||error&&trySubmit||validationError;var label=this.props.label;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core__["t" /* FormControl */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core__["A" /* InputLabel */],{htmlFor:label,style:errors?{color:'#f44336'}:{}},this.props.label),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core__["M" /* Select */],{className:this.props.classes.dropdown,value:lValue,disabled:this.state.disabled,onChange:this.handleChange,input:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core__["y" /* Input */],{id:''}),autowidth:'true',id:label,error:errors&&true,style:errors?{color:'#f44336'}:{}},items),errors?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core__["Z" /* Typography */],{className:'errorText'},error):null);}}]);return FormDropdown;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);FormDropdown.propTypes={input:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,classes:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,label:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2__material_ui_core__["_1" /* withStyles */])(styles)(FormDropdown));

/***/ }),
/* 26 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return isEmptyOrSpaces; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return required; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return requiredDropdown; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return percentage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return dateValid; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return monthDayValid; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return number; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return saId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return email; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_helpers_DateHelpers__ = __webpack_require__(40);
var isEmptyOrSpaces=function isEmptyOrSpaces(str){return str===undefined||str===null||str.toString().match(/^ *$/)!==null;};var required=function required(value){return isEmptyOrSpaces(value)?'Required':undefined;};var requiredDropdown=function requiredDropdown(value){if(isEmptyOrSpaces(value)||value==='validationError'){return'Required';}return undefined;};var percentage=function percentage(value){if(value===undefined)return undefined;if(isNaN(value)){return'Must be a number';}if(parseInt(value,10)>=101||parseInt(value,10)<0){return'Not a valid Percentage';}return undefined;};var dateValid=function dateValid(value){if(isEmptyOrSpaces(value)){return undefined;}if(value.length!==10){return'Too short (DD/MM/YYYY)';}if(value[2]!=='/'||value[5]!=='/'){return'Invalid Format (DD/MM/YYYY)';}var parsed=Object(__WEBPACK_IMPORTED_MODULE_0_helpers_DateHelpers__["b" /* ParseDMYwSlashes */])(value);if(parsed.toString().includes('Invalid Date')){return'Invalid Date (DD/MM/YYYY)';}return undefined;};var monthDayValid=function monthDayValid(value){if(isEmptyOrSpaces(value))return undefined;if(value.length!==5){return'Invalid Format (DD/MM)';}if(value[2]!=='/'){return'Invalid Format (DD/MM)';}var parsed=Object(__WEBPACK_IMPORTED_MODULE_0_helpers_DateHelpers__["b" /* ParseDMYwSlashes */])(value+'/2018');if(parsed.toString().includes('Invalid Date')){return'Invalid Date';}return undefined;};var number=function number(value){if(isEmptyOrSpaces(value))return undefined;return isNaN(value.toString())?'Must be a number':undefined;};var saId=function saId(value){if(isEmptyOrSpaces(value))return undefined;if(value.length!==13){return'Not a Valid SA ID';}// apply Luhn formula for check-digits
var initTotal=0;var checkSum=0;var multiplier=1;for(var i=0;i<13;++i){initTotal=parseInt(value.charAt(i),10)*multiplier;if(initTotal>9){initTotal=parseInt(initTotal.toString().charAt(0),10)+parseInt(initTotal.toString().charAt(1),10);}checkSum=checkSum+initTotal;multiplier=multiplier%2===0?1:2;}if(checkSum%10!==0){return'Not a Valid SA ID';}return undefined;};var email=function email(value){if(isEmptyOrSpaces(value))return undefined;var mailformat=/\S+@\S+\.\S+/;return value.match(mailformat)?undefined:'Not a Valid Email Addres';};

/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__splice__ = __webpack_require__(1152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getIn__ = __webpack_require__(1153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__setIn__ = __webpack_require__(1180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__deepEqual__ = __webpack_require__(1181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__deleteIn__ = __webpack_require__(1214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__keys__ = __webpack_require__(1215);








var structure = {
  allowsArrayErrors: true,
  empty: {},
  emptyList: [],
  getIn: __WEBPACK_IMPORTED_MODULE_1__getIn__["a" /* default */],
  setIn: __WEBPACK_IMPORTED_MODULE_2__setIn__["a" /* default */],
  deepEqual: __WEBPACK_IMPORTED_MODULE_3__deepEqual__["a" /* default */],
  deleteIn: __WEBPACK_IMPORTED_MODULE_4__deleteIn__["a" /* default */],
  forEach: function forEach(items, callback) {
    return items.forEach(callback);
  },
  fromJS: function fromJS(value) {
    return value;
  },
  keys: __WEBPACK_IMPORTED_MODULE_5__keys__["a" /* default */],
  size: function size(array) {
    return array ? array.length : 0;
  },
  some: function some(items, callback) {
    return items.some(callback);
  },
  splice: __WEBPACK_IMPORTED_MODULE_0__splice__["a" /* default */],
  toJS: function toJS(value) {
    return value;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (structure);

/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_animation_frame__ = __webpack_require__(2502);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__common_animation_frame__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_class__ = __webpack_require__(274);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__common_class__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_html_encode__ = __webpack_require__(2503);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_2__common_html_encode__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_log_to_console__ = __webpack_require__(2504);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_3__common_log_to_console__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_observable__ = __webpack_require__(2505);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_4__common_observable__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_save_as__ = __webpack_require__(2506);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_5__common_save_as__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_support__ = __webpack_require__(638);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_6__common_support__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_template__ = __webpack_require__(2507);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_7__common_template__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_throttle__ = __webpack_require__(2508);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_8__common_throttle__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common_color__ = __webpack_require__(2509);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_9__common_color__["a"]; });














/***/ }),
/* 30 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return alertDanger; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return alertWarning; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return successWarning; });
/* unused harmony export snack */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return showSnack; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__(10);
var DANGER="sure-quote/alert/DANGER";var WARN="sure-quote/alert/WARN";var SNACK="sure-quote/alert/SNACK";var SUCCESS="sure-quote/alert/SUCCESS";var defaultState={errorWindow:{open:false,title:"",message:null,onClose:null},warningWindow:{open:false,title:"",message:null,showCancel:true,showConfirm:true,onCancel:null,onConfirm:null,confirmBtnText:"Ok",cancelBtnText:"Cancel"},successWindow:{open:false,title:"",showConfirm:true,onConfirm:null,confirmBtnText:"Ok"},snack:{open:false,color:"primary",message:""}};var handleWarningAlert=function handleWarningAlert(state,action){var open=action.props.open;if(action.props.cancelClicked){if(state.warningWindow.onCancel){state.warningWindow.onCancel();}open=false;}if(action.props.confirmClicked){if(state.warningWindow.onConfirm){state.warningWindow.onConfirm();}open=false;}return Object.assign({},state,{warningWindow:{open:open,title:action.props.title,message:action.props.message,showCancel:action.props.showCancel!==undefined?action.props.showCancel:false,showConfirm:action.props.showConfirm!==undefined?action.props.showConfirm:true,onCancel:action.props.onCancel?action.props.onCancel:null,onConfirm:action.props.onConfirm?action.props.onConfirm:null,confirmBtnText:action.props.confirmBtnText!==undefined?action.props.confirmBtnText:"Ok",cancelBtnText:action.props.cancelBtnText!==undefined?action.props.cancelBtnText:"Cancel"}});};var handleSuccessAlert=function handleSuccessAlert(state,action){var open=action.props.open;if(action.props.confirmClicked){if(state.successWindow.onConfirm){state.successWindow.onConfirm();}open=false;}return Object.assign({},state,{successWindow:{open:open,title:action.props.title,showConfirm:action.props.showConfirm!==undefined?action.props.showConfirm:true,onConfirm:action.props.onConfirm?action.props.onConfirm:null,confirmBtnText:action.props.confirmBtnText!==undefined?action.props.confirmBtnText:"Ok"}});};var handleDangerAlert=function handleDangerAlert(state,action){if(!action.props.open&&state.errorWindow.onClose){state.errorWindow.onClose();}return Object.assign({},state,{errorWindow:{open:action.props.open,title:action.props.title,message:action.props.message,onClose:action.props.open?action.props.onClose:null}});};var handleSnack=function handleSnack(state,action){var open=action.props.open;return Object.assign({},state,{snack:{open:action.props.open,color:open?action.props.color:state.snack.color,message:open?action.props.message:state.snack.message}});};var NotificationReducer=function NotificationReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:defaultState;var action=arguments[1];switch(action.type){case DANGER:return handleDangerAlert(state,action);case SUCCESS:return handleSuccessAlert(state,action);case SNACK:return handleSnack(state,action);case WARN:return handleWarningAlert(state,action);default:return state;}};var alertDanger=function alertDanger(props){return{type:DANGER,props:props};};var alertWarning=function alertWarning(props){return{type:WARN,props:props};};var successWarning=function successWarning(props){return{type:SUCCESS,props:props};};var snack=function snack(props){return{type:SNACK,props:props};};var timer;var showSnack=function showSnack(props){if(props.open!==undefined){__WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].dispatch(snack(props));}else{props.open=true;__WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].dispatch(snack(props));clearTimeout(timer);timer=setTimeout(function(){props.open=false;__WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].dispatch(snack(props));},10000);}return{type:null};};/* harmony default export */ __webpack_exports__["c"] = (NotificationReducer);

/***/ }),
/* 31 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_core__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_number_format__ = __webpack_require__(2480);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_number_format___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_number_format__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var styles=function styles(theme){return{textField:{width:"100%",marginTop:0,marginBottom:0}};};var NumberInput=function(_React$Component){_inherits(NumberInput,_React$Component);function NumberInput(props){_classCallCheck(this,NumberInput);var _this=_possibleConstructorReturn(this,(NumberInput.__proto__||Object.getPrototypeOf(NumberInput)).call(this,props));_initialiseProps.call(_this);_this.handleChange=_this.handleChange.bind(_this);return _this;}_createClass(NumberInput,[{key:"shouldComponentUpdate",value:function shouldComponentUpdate(nextProps){var _this2=this;var comparedState=false;Object.keys(this.props).map(function(s){if(_this2.props[s]!==nextProps[s]){comparedState=true;}return s;});return comparedState;}},{key:"render",value:function render(){this.props.meta.valid=false;var trySubmit=this.props.checkValidation?true:false;var _props$meta=this.props.meta,touched=_props$meta.touched,error=_props$meta.error;var lValue=this.props.fixedValue?this.props.fixedValue:this.props.input.value?this.props.input.value:"";return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["X" /* TextField */],{onChange:this.handleChange,id:this.props.input.name,value:lValue,label:this.props.label,className:this.props.classes.textField,margin:"normal",error:error&&error.length>0&&touched?true:error&&error.length>0&&trySubmit?true:false,helperText:error&&touched||error&&trySubmit?error:null,name:this.props.prefix,InputProps:{inputComponent:this.NumberFormatCustom}});}}]);return NumberInput;}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);var _initialiseProps=function _initialiseProps(){var _this3=this;this.NumberFormatCustom=function(props){var inputRef=props.inputRef,onChange=props.onChange,other=_objectWithoutProperties(props,["inputRef","onChange"]);var _props=_this3.props,prefix=_props.prefix,suffix=_props.suffix,seperator=_props.seperator;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_number_format___default.a,Object.assign({},other,{getInputRef:inputRef,onValueChange:function onValueChange(values){onChange({target:{value:values.value}});},thousandSeparator:seperator?seperator:"",prefix:prefix?prefix:"",suffix:suffix?suffix:""}));};this.handleChange=function(event){if(_this3.props.input.onChange&&!_this3.props.readOnly){_this3.props.input.onChange(event.target.value);_this3.props.input.onBlur(event.target.value);if(_this3.props.changed){_this3.props.changed(event.target.value);}}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["_1" /* withStyles */])(styles)(NumberInput));

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var __DEV__ = "production" !== 'production';

var warning = function() {};

if (__DEV__) {
  var printWarning = function printWarning(format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    var argIndex = 0;
    var message = 'Warning: ' +
      format.replace(/%s/g, function() {
        return args[argIndex++];
      });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  }

  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
          '`warning(condition, format, ...args)` requires a warning ' +
          'message argument'
      );
    }
    if (!condition) {
      printWarning.apply(null, [format].concat(args));
    }
  };
}

module.exports = warning;


/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MemoryRouter__ = __webpack_require__(445);
/* unused harmony reexport MemoryRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Prompt__ = __webpack_require__(448);
/* unused harmony reexport Prompt */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Redirect__ = __webpack_require__(449);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__Redirect__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Route__ = __webpack_require__(299);
/* unused harmony reexport Route */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(211);
/* unused harmony reexport Router */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__StaticRouter__ = __webpack_require__(451);
/* unused harmony reexport StaticRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Switch__ = __webpack_require__(452);
/* unused harmony reexport Switch */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__generatePath__ = __webpack_require__(450);
/* unused harmony reexport generatePath */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__matchPath__ = __webpack_require__(212);
/* unused harmony reexport matchPath */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__withRouter__ = __webpack_require__(453);
/* unused harmony reexport withRouter */





















/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Grid.default;
  }
});

var _Grid = _interopRequireDefault(__webpack_require__(991));

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.capitalize = capitalize;
exports.contains = contains;
exports.findIndex = findIndex;
exports.find = find;
exports.createChainedFunction = createChainedFunction;

var _typeof2 = _interopRequireDefault(__webpack_require__(454));

var _warning = _interopRequireDefault(__webpack_require__(32));

//  weak
function capitalize(string) {
  if (false) {
    throw new Error('Material-UI: capitalize(string) expects a string argument.');
  }

  return string.charAt(0).toUpperCase() + string.slice(1);
}

function contains(obj, pred) {
  return Object.keys(pred).every(function (key) {
    return obj.hasOwnProperty(key) && obj[key] === pred[key];
  });
}

function findIndex(arr, pred) {
  var predType = (0, _typeof2.default)(pred);

  for (var i = 0; i < arr.length; i += 1) {
    if (predType === 'function' && !!pred(arr[i], i, arr) === true) {
      return i;
    }

    if (predType === 'object' && contains(arr[i], pred)) {
      return i;
    }

    if (['string', 'number', 'boolean'].indexOf(predType) !== -1) {
      return arr.indexOf(pred);
    }
  }

  return -1;
}

function find(arr, pred) {
  var index = findIndex(arr, pred);
  return index > -1 ? arr[index] : undefined;
}
/**
 * Safe chained function
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 *
 * @param {function} functions to chain
 * @returns {function|null}
 */


function createChainedFunction() {
  for (var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  return funcs.filter(function (func) {
    return func != null;
  }).reduce(function (acc, func) {
     false ? (0, _warning.default)(typeof func === 'function', 'Material-UI: invalid Argument Type, must only provide functions, undefined, or null.') : void 0;
    return function chainedFunction() {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      acc.apply(this, args);
      func.apply(this, args);
    };
  }, function () {});
}

/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Provider__ = __webpack_require__(1138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_connectAdvanced__ = __webpack_require__(537);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__connect_connect__ = __webpack_require__(1142);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Provider__["a"]; });
/* unused harmony reexport createProvider */
/* unused harmony reexport connectAdvanced */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__connect_connect__["a"]; });





/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FullField; });
/* unused harmony export HalfField */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return HalfFieldSmall; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_Grid_GridItem_jsx__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_form__ = __webpack_require__(15);
var FullField=function FullField(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:12,style:props.gridStyle?Object.assign({},props.gridStyle):{marginBottom:'25px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["t" /* FormControl */],{fullWidth:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["a" /* Field */],props)));};var HalfField=function HalfField(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:6,style:props.gridStyle?Object.assign({},props.gridStyle):{marginBottom:'25px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["t" /* FormControl */],{fullWidth:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["a" /* Field */],props)));};var HalfFieldSmall=function HalfFieldSmall(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:6,md:6,style:props.gridStyle?Object.assign({},props.gridStyle):{marginBottom:'25px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["t" /* FormControl */],{fullWidth:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["a" /* Field */],props)));};

/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AccessAlarm__ = __webpack_require__(1337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AccessAlarm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__AccessAlarm__);
/* unused harmony reexport AccessAlarm */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AccessAlarms__ = __webpack_require__(1338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AccessAlarms___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__AccessAlarms__);
/* unused harmony reexport AccessAlarms */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Accessibility__ = __webpack_require__(1339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Accessibility___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Accessibility__);
/* unused harmony reexport Accessibility */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Accessible__ = __webpack_require__(1340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Accessible___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Accessible__);
/* unused harmony reexport Accessible */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__AccessTime__ = __webpack_require__(1341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__AccessTime___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__AccessTime__);
/* unused harmony reexport AccessTime */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__AccountBalance__ = __webpack_require__(1342);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__AccountBalance___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__AccountBalance__);
/* unused harmony reexport AccountBalance */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__AccountBalanceWallet__ = __webpack_require__(1343);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__AccountBalanceWallet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__AccountBalanceWallet__);
/* unused harmony reexport AccountBalanceWallet */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__AccountBox__ = __webpack_require__(1344);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__AccountBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__AccountBox__);
/* unused harmony reexport AccountBox */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__AccountCircle__ = __webpack_require__(1345);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__AccountCircle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__AccountCircle__);
/* unused harmony reexport AccountCircle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__AcUnit__ = __webpack_require__(1346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__AcUnit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__AcUnit__);
/* unused harmony reexport AcUnit */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Adb__ = __webpack_require__(1347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Adb___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__Adb__);
/* unused harmony reexport Adb */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Add__ = __webpack_require__(1348);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Add___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__Add__);
/* unused harmony reexport Add */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__AddAlarm__ = __webpack_require__(1349);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__AddAlarm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__AddAlarm__);
/* unused harmony reexport AddAlarm */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__AddAlert__ = __webpack_require__(1350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__AddAlert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__AddAlert__);
/* unused harmony reexport AddAlert */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__AddAPhoto__ = __webpack_require__(1351);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__AddAPhoto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__AddAPhoto__);
/* unused harmony reexport AddAPhoto */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__AddBox__ = __webpack_require__(1352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__AddBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__AddBox__);
/* unused harmony reexport AddBox */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__AddCircle__ = __webpack_require__(1353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__AddCircle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__AddCircle__);
/* unused harmony reexport AddCircle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__AddCircleOutline__ = __webpack_require__(1354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__AddCircleOutline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__AddCircleOutline__);
/* unused harmony reexport AddCircleOutline */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__AddLocation__ = __webpack_require__(1355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__AddLocation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__AddLocation__);
/* unused harmony reexport AddLocation */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__AddShoppingCart__ = __webpack_require__(1356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__AddShoppingCart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__AddShoppingCart__);
/* unused harmony reexport AddShoppingCart */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__AddToPhotos__ = __webpack_require__(1357);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__AddToPhotos___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__AddToPhotos__);
/* unused harmony reexport AddToPhotos */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__AddToQueue__ = __webpack_require__(1358);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__AddToQueue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__AddToQueue__);
/* unused harmony reexport AddToQueue */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__Adjust__ = __webpack_require__(1359);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__Adjust___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__Adjust__);
/* unused harmony reexport Adjust */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__AirlineSeatFlat__ = __webpack_require__(1360);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__AirlineSeatFlat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__AirlineSeatFlat__);
/* unused harmony reexport AirlineSeatFlat */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__AirlineSeatFlatAngled__ = __webpack_require__(1361);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__AirlineSeatFlatAngled___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__AirlineSeatFlatAngled__);
/* unused harmony reexport AirlineSeatFlatAngled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__AirlineSeatIndividualSuite__ = __webpack_require__(1362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__AirlineSeatIndividualSuite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__AirlineSeatIndividualSuite__);
/* unused harmony reexport AirlineSeatIndividualSuite */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__AirlineSeatLegroomExtra__ = __webpack_require__(1363);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__AirlineSeatLegroomExtra___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__AirlineSeatLegroomExtra__);
/* unused harmony reexport AirlineSeatLegroomExtra */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__AirlineSeatLegroomNormal__ = __webpack_require__(1364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__AirlineSeatLegroomNormal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__AirlineSeatLegroomNormal__);
/* unused harmony reexport AirlineSeatLegroomNormal */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__AirlineSeatLegroomReduced__ = __webpack_require__(1365);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__AirlineSeatLegroomReduced___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__AirlineSeatLegroomReduced__);
/* unused harmony reexport AirlineSeatLegroomReduced */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__AirlineSeatReclineExtra__ = __webpack_require__(1366);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__AirlineSeatReclineExtra___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29__AirlineSeatReclineExtra__);
/* unused harmony reexport AirlineSeatReclineExtra */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__AirlineSeatReclineNormal__ = __webpack_require__(1367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__AirlineSeatReclineNormal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30__AirlineSeatReclineNormal__);
/* unused harmony reexport AirlineSeatReclineNormal */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__AirplanemodeActive__ = __webpack_require__(1368);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__AirplanemodeActive___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31__AirplanemodeActive__);
/* unused harmony reexport AirplanemodeActive */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__AirplanemodeInactive__ = __webpack_require__(1369);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__AirplanemodeInactive___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32__AirplanemodeInactive__);
/* unused harmony reexport AirplanemodeInactive */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__Airplay__ = __webpack_require__(1370);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__Airplay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33__Airplay__);
/* unused harmony reexport Airplay */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__AirportShuttle__ = __webpack_require__(1371);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__AirportShuttle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34__AirportShuttle__);
/* unused harmony reexport AirportShuttle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__Alarm__ = __webpack_require__(1372);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__Alarm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_35__Alarm__);
/* unused harmony reexport Alarm */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__AlarmAdd__ = __webpack_require__(1373);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__AlarmAdd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_36__AlarmAdd__);
/* unused harmony reexport AlarmAdd */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__AlarmOff__ = __webpack_require__(1374);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__AlarmOff___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_37__AlarmOff__);
/* unused harmony reexport AlarmOff */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__AlarmOn__ = __webpack_require__(1375);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__AlarmOn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_38__AlarmOn__);
/* unused harmony reexport AlarmOn */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__Album__ = __webpack_require__(1376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__Album___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_39__Album__);
/* unused harmony reexport Album */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__AllInclusive__ = __webpack_require__(1377);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__AllInclusive___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_40__AllInclusive__);
/* unused harmony reexport AllInclusive */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__AllOut__ = __webpack_require__(1378);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__AllOut___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_41__AllOut__);
/* unused harmony reexport AllOut */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__Android__ = __webpack_require__(1379);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__Android___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_42__Android__);
/* unused harmony reexport Android */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__Announcement__ = __webpack_require__(1380);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__Announcement___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_43__Announcement__);
/* unused harmony reexport Announcement */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__Apps__ = __webpack_require__(1381);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__Apps___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_44__Apps__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_44__Apps___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__Archive__ = __webpack_require__(1382);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__Archive___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_45__Archive__);
/* unused harmony reexport Archive */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__ArrowBack__ = __webpack_require__(1383);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__ArrowBack___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_46__ArrowBack__);
/* unused harmony reexport ArrowBack */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__ArrowDownward__ = __webpack_require__(1384);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__ArrowDownward___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_47__ArrowDownward__);
/* unused harmony reexport ArrowDownward */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__ArrowDropDown__ = __webpack_require__(1385);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__ArrowDropDown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_48__ArrowDropDown__);
/* unused harmony reexport ArrowDropDown */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__ArrowDropDownCircle__ = __webpack_require__(1386);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__ArrowDropDownCircle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_49__ArrowDropDownCircle__);
/* unused harmony reexport ArrowDropDownCircle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__ArrowDropUp__ = __webpack_require__(1387);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__ArrowDropUp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_50__ArrowDropUp__);
/* unused harmony reexport ArrowDropUp */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__ArrowForward__ = __webpack_require__(1388);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__ArrowForward___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_51__ArrowForward__);
/* unused harmony reexport ArrowForward */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__ArrowUpward__ = __webpack_require__(1389);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__ArrowUpward___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_52__ArrowUpward__);
/* unused harmony reexport ArrowUpward */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__ArtTrack__ = __webpack_require__(1390);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__ArtTrack___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_53__ArtTrack__);
/* unused harmony reexport ArtTrack */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__AspectRatio__ = __webpack_require__(1391);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__AspectRatio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_54__AspectRatio__);
/* unused harmony reexport AspectRatio */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__Assessment__ = __webpack_require__(1392);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__Assessment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_55__Assessment__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_55__Assessment___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__Assignment__ = __webpack_require__(1393);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__Assignment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_56__Assignment__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_56__Assignment___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__AssignmentInd__ = __webpack_require__(1394);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__AssignmentInd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_57__AssignmentInd__);
/* unused harmony reexport AssignmentInd */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__AssignmentLate__ = __webpack_require__(1395);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__AssignmentLate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_58__AssignmentLate__);
/* unused harmony reexport AssignmentLate */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__AssignmentReturn__ = __webpack_require__(1396);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__AssignmentReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_59__AssignmentReturn__);
/* unused harmony reexport AssignmentReturn */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60__AssignmentReturned__ = __webpack_require__(1397);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60__AssignmentReturned___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_60__AssignmentReturned__);
/* unused harmony reexport AssignmentReturned */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61__AssignmentTurnedIn__ = __webpack_require__(1398);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61__AssignmentTurnedIn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_61__AssignmentTurnedIn__);
/* unused harmony reexport AssignmentTurnedIn */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62__Assistant__ = __webpack_require__(1399);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62__Assistant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_62__Assistant__);
/* unused harmony reexport Assistant */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63__AssistantPhoto__ = __webpack_require__(1400);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63__AssistantPhoto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_63__AssistantPhoto__);
/* unused harmony reexport AssistantPhoto */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64__AttachFile__ = __webpack_require__(1401);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64__AttachFile___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_64__AttachFile__);
/* unused harmony reexport AttachFile */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65__Attachment__ = __webpack_require__(1402);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65__Attachment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_65__Attachment__);
/* unused harmony reexport Attachment */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66__AttachMoney__ = __webpack_require__(575);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66__AttachMoney___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_66__AttachMoney__);
/* unused harmony reexport AttachMoney */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67__Audiotrack__ = __webpack_require__(1403);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67__Audiotrack___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_67__Audiotrack__);
/* unused harmony reexport Audiotrack */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68__Autorenew__ = __webpack_require__(1404);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68__Autorenew___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_68__Autorenew__);
/* unused harmony reexport Autorenew */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69__AvTimer__ = __webpack_require__(1405);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69__AvTimer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_69__AvTimer__);
/* unused harmony reexport AvTimer */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_70__Backspace__ = __webpack_require__(1406);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_70__Backspace___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_70__Backspace__);
/* unused harmony reexport Backspace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_71__Backup__ = __webpack_require__(1407);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_71__Backup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_71__Backup__);
/* unused harmony reexport Backup */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_72__Battery20__ = __webpack_require__(1408);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_72__Battery20___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_72__Battery20__);
/* unused harmony reexport Battery20 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_73__Battery30__ = __webpack_require__(1409);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_73__Battery30___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_73__Battery30__);
/* unused harmony reexport Battery30 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_74__Battery50__ = __webpack_require__(1410);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_74__Battery50___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_74__Battery50__);
/* unused harmony reexport Battery50 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_75__Battery60__ = __webpack_require__(1411);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_75__Battery60___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_75__Battery60__);
/* unused harmony reexport Battery60 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_76__Battery80__ = __webpack_require__(1412);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_76__Battery80___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_76__Battery80__);
/* unused harmony reexport Battery80 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_77__Battery90__ = __webpack_require__(1413);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_77__Battery90___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_77__Battery90__);
/* unused harmony reexport Battery90 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_78__BatteryAlert__ = __webpack_require__(1414);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_78__BatteryAlert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_78__BatteryAlert__);
/* unused harmony reexport BatteryAlert */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_79__BatteryCharging20__ = __webpack_require__(1415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_79__BatteryCharging20___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_79__BatteryCharging20__);
/* unused harmony reexport BatteryCharging20 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_80__BatteryCharging30__ = __webpack_require__(1416);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_80__BatteryCharging30___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_80__BatteryCharging30__);
/* unused harmony reexport BatteryCharging30 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_81__BatteryCharging50__ = __webpack_require__(1417);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_81__BatteryCharging50___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_81__BatteryCharging50__);
/* unused harmony reexport BatteryCharging50 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_82__BatteryCharging60__ = __webpack_require__(1418);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_82__BatteryCharging60___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_82__BatteryCharging60__);
/* unused harmony reexport BatteryCharging60 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_83__BatteryCharging80__ = __webpack_require__(1419);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_83__BatteryCharging80___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_83__BatteryCharging80__);
/* unused harmony reexport BatteryCharging80 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_84__BatteryCharging90__ = __webpack_require__(1420);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_84__BatteryCharging90___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_84__BatteryCharging90__);
/* unused harmony reexport BatteryCharging90 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_85__BatteryChargingFull__ = __webpack_require__(1421);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_85__BatteryChargingFull___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_85__BatteryChargingFull__);
/* unused harmony reexport BatteryChargingFull */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_86__BatteryFull__ = __webpack_require__(1422);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_86__BatteryFull___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_86__BatteryFull__);
/* unused harmony reexport BatteryFull */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_87__BatteryStd__ = __webpack_require__(1423);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_87__BatteryStd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_87__BatteryStd__);
/* unused harmony reexport BatteryStd */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_88__BatteryUnknown__ = __webpack_require__(1424);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_88__BatteryUnknown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_88__BatteryUnknown__);
/* unused harmony reexport BatteryUnknown */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_89__BeachAccess__ = __webpack_require__(1425);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_89__BeachAccess___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_89__BeachAccess__);
/* unused harmony reexport BeachAccess */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_90__Beenhere__ = __webpack_require__(1426);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_90__Beenhere___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_90__Beenhere__);
/* unused harmony reexport Beenhere */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_91__Block__ = __webpack_require__(1427);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_91__Block___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_91__Block__);
/* unused harmony reexport Block */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_92__Bluetooth__ = __webpack_require__(1428);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_92__Bluetooth___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_92__Bluetooth__);
/* unused harmony reexport Bluetooth */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_93__BluetoothAudio__ = __webpack_require__(1429);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_93__BluetoothAudio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_93__BluetoothAudio__);
/* unused harmony reexport BluetoothAudio */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_94__BluetoothConnected__ = __webpack_require__(1430);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_94__BluetoothConnected___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_94__BluetoothConnected__);
/* unused harmony reexport BluetoothConnected */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_95__BluetoothDisabled__ = __webpack_require__(1431);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_95__BluetoothDisabled___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_95__BluetoothDisabled__);
/* unused harmony reexport BluetoothDisabled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_96__BluetoothSearching__ = __webpack_require__(1432);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_96__BluetoothSearching___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_96__BluetoothSearching__);
/* unused harmony reexport BluetoothSearching */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_97__BlurCircular__ = __webpack_require__(1433);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_97__BlurCircular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_97__BlurCircular__);
/* unused harmony reexport BlurCircular */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_98__BlurLinear__ = __webpack_require__(1434);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_98__BlurLinear___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_98__BlurLinear__);
/* unused harmony reexport BlurLinear */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_99__BlurOff__ = __webpack_require__(1435);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_99__BlurOff___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_99__BlurOff__);
/* unused harmony reexport BlurOff */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_100__BlurOn__ = __webpack_require__(1436);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_100__BlurOn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_100__BlurOn__);
/* unused harmony reexport BlurOn */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_101__Book__ = __webpack_require__(1437);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_101__Book___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_101__Book__);
/* unused harmony reexport Book */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_102__Bookmark__ = __webpack_require__(1438);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_102__Bookmark___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_102__Bookmark__);
/* unused harmony reexport Bookmark */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_103__BookmarkBorder__ = __webpack_require__(1439);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_103__BookmarkBorder___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_103__BookmarkBorder__);
/* unused harmony reexport BookmarkBorder */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_104__BorderAll__ = __webpack_require__(1440);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_104__BorderAll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_104__BorderAll__);
/* unused harmony reexport BorderAll */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_105__BorderBottom__ = __webpack_require__(1441);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_105__BorderBottom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_105__BorderBottom__);
/* unused harmony reexport BorderBottom */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_106__BorderClear__ = __webpack_require__(1442);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_106__BorderClear___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_106__BorderClear__);
/* unused harmony reexport BorderClear */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_107__BorderColor__ = __webpack_require__(1443);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_107__BorderColor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_107__BorderColor__);
/* unused harmony reexport BorderColor */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_108__BorderHorizontal__ = __webpack_require__(1444);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_108__BorderHorizontal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_108__BorderHorizontal__);
/* unused harmony reexport BorderHorizontal */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_109__BorderInner__ = __webpack_require__(1445);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_109__BorderInner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_109__BorderInner__);
/* unused harmony reexport BorderInner */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_110__BorderLeft__ = __webpack_require__(1446);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_110__BorderLeft___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_110__BorderLeft__);
/* unused harmony reexport BorderLeft */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_111__BorderOuter__ = __webpack_require__(1447);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_111__BorderOuter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_111__BorderOuter__);
/* unused harmony reexport BorderOuter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_112__BorderRight__ = __webpack_require__(1448);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_112__BorderRight___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_112__BorderRight__);
/* unused harmony reexport BorderRight */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_113__BorderStyle__ = __webpack_require__(1449);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_113__BorderStyle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_113__BorderStyle__);
/* unused harmony reexport BorderStyle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_114__BorderTop__ = __webpack_require__(1450);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_114__BorderTop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_114__BorderTop__);
/* unused harmony reexport BorderTop */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_115__BorderVertical__ = __webpack_require__(1451);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_115__BorderVertical___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_115__BorderVertical__);
/* unused harmony reexport BorderVertical */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_116__BrandingWatermark__ = __webpack_require__(1452);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_116__BrandingWatermark___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_116__BrandingWatermark__);
/* unused harmony reexport BrandingWatermark */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_117__Brightness1__ = __webpack_require__(1453);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_117__Brightness1___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_117__Brightness1__);
/* unused harmony reexport Brightness1 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_118__Brightness2__ = __webpack_require__(1454);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_118__Brightness2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_118__Brightness2__);
/* unused harmony reexport Brightness2 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_119__Brightness3__ = __webpack_require__(1455);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_119__Brightness3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_119__Brightness3__);
/* unused harmony reexport Brightness3 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_120__Brightness4__ = __webpack_require__(1456);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_120__Brightness4___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_120__Brightness4__);
/* unused harmony reexport Brightness4 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_121__Brightness5__ = __webpack_require__(1457);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_121__Brightness5___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_121__Brightness5__);
/* unused harmony reexport Brightness5 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_122__Brightness6__ = __webpack_require__(1458);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_122__Brightness6___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_122__Brightness6__);
/* unused harmony reexport Brightness6 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_123__Brightness7__ = __webpack_require__(1459);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_123__Brightness7___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_123__Brightness7__);
/* unused harmony reexport Brightness7 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_124__BrightnessAuto__ = __webpack_require__(1460);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_124__BrightnessAuto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_124__BrightnessAuto__);
/* unused harmony reexport BrightnessAuto */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_125__BrightnessHigh__ = __webpack_require__(1461);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_125__BrightnessHigh___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_125__BrightnessHigh__);
/* unused harmony reexport BrightnessHigh */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_126__BrightnessLow__ = __webpack_require__(1462);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_126__BrightnessLow___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_126__BrightnessLow__);
/* unused harmony reexport BrightnessLow */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_127__BrightnessMedium__ = __webpack_require__(1463);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_127__BrightnessMedium___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_127__BrightnessMedium__);
/* unused harmony reexport BrightnessMedium */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_128__BrokenImage__ = __webpack_require__(1464);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_128__BrokenImage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_128__BrokenImage__);
/* unused harmony reexport BrokenImage */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_129__Brush__ = __webpack_require__(1465);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_129__Brush___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_129__Brush__);
/* unused harmony reexport Brush */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_130__BubbleChart__ = __webpack_require__(1466);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_130__BubbleChart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_130__BubbleChart__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_130__BubbleChart___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_131__BugReport__ = __webpack_require__(1467);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_131__BugReport___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_131__BugReport__);
/* unused harmony reexport BugReport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_132__Build__ = __webpack_require__(1468);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_132__Build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_132__Build__);
/* unused harmony reexport Build */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_133__BurstMode__ = __webpack_require__(1469);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_133__BurstMode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_133__BurstMode__);
/* unused harmony reexport BurstMode */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_134__Business__ = __webpack_require__(1470);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_134__Business___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_134__Business__);
/* unused harmony reexport Business */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_135__BusinessCenter__ = __webpack_require__(1471);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_135__BusinessCenter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_135__BusinessCenter__);
/* unused harmony reexport BusinessCenter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_136__Cached__ = __webpack_require__(1472);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_136__Cached___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_136__Cached__);
/* unused harmony reexport Cached */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_137__Cake__ = __webpack_require__(1473);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_137__Cake___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_137__Cake__);
/* unused harmony reexport Cake */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_138__Call__ = __webpack_require__(1474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_138__Call___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_138__Call__);
/* unused harmony reexport Call */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_139__CallEnd__ = __webpack_require__(1475);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_139__CallEnd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_139__CallEnd__);
/* unused harmony reexport CallEnd */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_140__CallMade__ = __webpack_require__(1476);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_140__CallMade___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_140__CallMade__);
/* unused harmony reexport CallMade */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_141__CallMerge__ = __webpack_require__(1477);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_141__CallMerge___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_141__CallMerge__);
/* unused harmony reexport CallMerge */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_142__CallMissed__ = __webpack_require__(1478);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_142__CallMissed___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_142__CallMissed__);
/* unused harmony reexport CallMissed */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_143__CallMissedOutgoing__ = __webpack_require__(1479);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_143__CallMissedOutgoing___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_143__CallMissedOutgoing__);
/* unused harmony reexport CallMissedOutgoing */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_144__CallReceived__ = __webpack_require__(1480);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_144__CallReceived___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_144__CallReceived__);
/* unused harmony reexport CallReceived */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_145__CallSplit__ = __webpack_require__(1481);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_145__CallSplit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_145__CallSplit__);
/* unused harmony reexport CallSplit */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_146__CallToAction__ = __webpack_require__(1482);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_146__CallToAction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_146__CallToAction__);
/* unused harmony reexport CallToAction */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_147__Camera__ = __webpack_require__(1483);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_147__Camera___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_147__Camera__);
/* unused harmony reexport Camera */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_148__CameraAlt__ = __webpack_require__(1484);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_148__CameraAlt___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_148__CameraAlt__);
/* unused harmony reexport CameraAlt */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_149__CameraEnhance__ = __webpack_require__(1485);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_149__CameraEnhance___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_149__CameraEnhance__);
/* unused harmony reexport CameraEnhance */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_150__CameraFront__ = __webpack_require__(1486);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_150__CameraFront___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_150__CameraFront__);
/* unused harmony reexport CameraFront */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_151__CameraRear__ = __webpack_require__(1487);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_151__CameraRear___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_151__CameraRear__);
/* unused harmony reexport CameraRear */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_152__CameraRoll__ = __webpack_require__(1488);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_152__CameraRoll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_152__CameraRoll__);
/* unused harmony reexport CameraRoll */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_153__Cancel__ = __webpack_require__(1489);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_153__Cancel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_153__Cancel__);
/* unused harmony reexport Cancel */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_154__CardGiftcard__ = __webpack_require__(1490);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_154__CardGiftcard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_154__CardGiftcard__);
/* unused harmony reexport CardGiftcard */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_155__CardMembership__ = __webpack_require__(1491);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_155__CardMembership___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_155__CardMembership__);
/* unused harmony reexport CardMembership */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_156__CardTravel__ = __webpack_require__(1492);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_156__CardTravel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_156__CardTravel__);
/* unused harmony reexport CardTravel */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_157__Casino__ = __webpack_require__(1493);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_157__Casino___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_157__Casino__);
/* unused harmony reexport Casino */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_158__Cast__ = __webpack_require__(1494);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_158__Cast___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_158__Cast__);
/* unused harmony reexport Cast */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_159__CastConnected__ = __webpack_require__(1495);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_159__CastConnected___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_159__CastConnected__);
/* unused harmony reexport CastConnected */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_160__CenterFocusStrong__ = __webpack_require__(1496);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_160__CenterFocusStrong___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_160__CenterFocusStrong__);
/* unused harmony reexport CenterFocusStrong */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_161__CenterFocusWeak__ = __webpack_require__(1497);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_161__CenterFocusWeak___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_161__CenterFocusWeak__);
/* unused harmony reexport CenterFocusWeak */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_162__ChangeHistory__ = __webpack_require__(1498);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_162__ChangeHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_162__ChangeHistory__);
/* unused harmony reexport ChangeHistory */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_163__Chat__ = __webpack_require__(1499);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_163__Chat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_163__Chat__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_163__Chat___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_164__ChatBubble__ = __webpack_require__(1500);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_164__ChatBubble___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_164__ChatBubble__);
/* unused harmony reexport ChatBubble */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_165__ChatBubbleOutline__ = __webpack_require__(1501);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_165__ChatBubbleOutline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_165__ChatBubbleOutline__);
/* unused harmony reexport ChatBubbleOutline */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_166__Check__ = __webpack_require__(1502);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_166__Check___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_166__Check__);
/* unused harmony reexport Check */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_167__CheckBox__ = __webpack_require__(1503);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_167__CheckBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_167__CheckBox__);
/* unused harmony reexport CheckBox */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_168__CheckBoxOutlineBlank__ = __webpack_require__(1504);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_168__CheckBoxOutlineBlank___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_168__CheckBoxOutlineBlank__);
/* unused harmony reexport CheckBoxOutlineBlank */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_169__CheckCircle__ = __webpack_require__(1505);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_169__CheckCircle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_169__CheckCircle__);
/* unused harmony reexport CheckCircle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_170__ChevronLeft__ = __webpack_require__(1506);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_170__ChevronLeft___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_170__ChevronLeft__);
/* unused harmony reexport ChevronLeft */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_171__ChevronRight__ = __webpack_require__(1507);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_171__ChevronRight___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_171__ChevronRight__);
/* unused harmony reexport ChevronRight */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_172__ChildCare__ = __webpack_require__(1508);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_172__ChildCare___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_172__ChildCare__);
/* unused harmony reexport ChildCare */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_173__ChildFriendly__ = __webpack_require__(1509);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_173__ChildFriendly___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_173__ChildFriendly__);
/* unused harmony reexport ChildFriendly */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_174__ChromeReaderMode__ = __webpack_require__(1510);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_174__ChromeReaderMode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_174__ChromeReaderMode__);
/* unused harmony reexport ChromeReaderMode */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_175__Class__ = __webpack_require__(1511);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_175__Class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_175__Class__);
/* unused harmony reexport Class */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_176__Clear__ = __webpack_require__(1512);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_176__Clear___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_176__Clear__);
/* unused harmony reexport Clear */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_177__ClearAll__ = __webpack_require__(1513);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_177__ClearAll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_177__ClearAll__);
/* unused harmony reexport ClearAll */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_178__Close__ = __webpack_require__(515);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_178__Close___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_178__Close__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_178__Close___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_179__ClosedCaption__ = __webpack_require__(1514);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_179__ClosedCaption___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_179__ClosedCaption__);
/* unused harmony reexport ClosedCaption */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_180__Cloud__ = __webpack_require__(1515);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_180__Cloud___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_180__Cloud__);
/* unused harmony reexport Cloud */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_181__CloudCircle__ = __webpack_require__(1516);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_181__CloudCircle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_181__CloudCircle__);
/* unused harmony reexport CloudCircle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_182__CloudDone__ = __webpack_require__(1517);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_182__CloudDone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_182__CloudDone__);
/* unused harmony reexport CloudDone */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_183__CloudDownload__ = __webpack_require__(1518);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_183__CloudDownload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_183__CloudDownload__);
/* unused harmony reexport CloudDownload */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_184__CloudOff__ = __webpack_require__(1519);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_184__CloudOff___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_184__CloudOff__);
/* unused harmony reexport CloudOff */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_185__CloudQueue__ = __webpack_require__(1520);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_185__CloudQueue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_185__CloudQueue__);
/* unused harmony reexport CloudQueue */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_186__CloudUpload__ = __webpack_require__(1521);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_186__CloudUpload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_186__CloudUpload__);
/* unused harmony reexport CloudUpload */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_187__Code__ = __webpack_require__(1522);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_187__Code___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_187__Code__);
/* unused harmony reexport Code */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_188__Collections__ = __webpack_require__(1523);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_188__Collections___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_188__Collections__);
/* unused harmony reexport Collections */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_189__CollectionsBookmark__ = __webpack_require__(1524);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_189__CollectionsBookmark___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_189__CollectionsBookmark__);
/* unused harmony reexport CollectionsBookmark */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_190__Colorize__ = __webpack_require__(1525);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_190__Colorize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_190__Colorize__);
/* unused harmony reexport Colorize */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_191__ColorLens__ = __webpack_require__(1526);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_191__ColorLens___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_191__ColorLens__);
/* unused harmony reexport ColorLens */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_192__Comment__ = __webpack_require__(1527);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_192__Comment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_192__Comment__);
/* unused harmony reexport Comment */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_193__Compare__ = __webpack_require__(1528);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_193__Compare___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_193__Compare__);
/* unused harmony reexport Compare */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_194__CompareArrows__ = __webpack_require__(1529);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_194__CompareArrows___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_194__CompareArrows__);
/* unused harmony reexport CompareArrows */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_195__Computer__ = __webpack_require__(1530);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_195__Computer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_195__Computer__);
/* unused harmony reexport Computer */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_196__ConfirmationNumber__ = __webpack_require__(1531);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_196__ConfirmationNumber___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_196__ConfirmationNumber__);
/* unused harmony reexport ConfirmationNumber */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_197__ContactMail__ = __webpack_require__(1532);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_197__ContactMail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_197__ContactMail__);
/* unused harmony reexport ContactMail */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_198__ContactPhone__ = __webpack_require__(1533);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_198__ContactPhone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_198__ContactPhone__);
/* unused harmony reexport ContactPhone */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_199__Contacts__ = __webpack_require__(1534);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_199__Contacts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_199__Contacts__);
/* unused harmony reexport Contacts */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_200__ContentCopy__ = __webpack_require__(1535);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_200__ContentCopy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_200__ContentCopy__);
/* unused harmony reexport ContentCopy */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_201__ContentCut__ = __webpack_require__(1536);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_201__ContentCut___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_201__ContentCut__);
/* unused harmony reexport ContentCut */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_202__ContentPaste__ = __webpack_require__(1537);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_202__ContentPaste___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_202__ContentPaste__);
/* unused harmony reexport ContentPaste */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_203__ControlPoint__ = __webpack_require__(1538);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_203__ControlPoint___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_203__ControlPoint__);
/* unused harmony reexport ControlPoint */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_204__ControlPointDuplicate__ = __webpack_require__(1539);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_204__ControlPointDuplicate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_204__ControlPointDuplicate__);
/* unused harmony reexport ControlPointDuplicate */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_205__Copyright__ = __webpack_require__(1540);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_205__Copyright___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_205__Copyright__);
/* unused harmony reexport Copyright */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_206__Create__ = __webpack_require__(1541);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_206__Create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_206__Create__);
/* unused harmony reexport Create */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_207__CreateNewFolder__ = __webpack_require__(1542);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_207__CreateNewFolder___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_207__CreateNewFolder__);
/* unused harmony reexport CreateNewFolder */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_208__CreditCard__ = __webpack_require__(1543);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_208__CreditCard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_208__CreditCard__);
/* unused harmony reexport CreditCard */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_209__Crop__ = __webpack_require__(1544);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_209__Crop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_209__Crop__);
/* unused harmony reexport Crop */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_210__Crop169__ = __webpack_require__(1545);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_210__Crop169___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_210__Crop169__);
/* unused harmony reexport Crop169 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_211__Crop32__ = __webpack_require__(1546);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_211__Crop32___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_211__Crop32__);
/* unused harmony reexport Crop32 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_212__Crop54__ = __webpack_require__(1547);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_212__Crop54___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_212__Crop54__);
/* unused harmony reexport Crop54 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_213__Crop75__ = __webpack_require__(1548);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_213__Crop75___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_213__Crop75__);
/* unused harmony reexport Crop75 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_214__CropDin__ = __webpack_require__(1549);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_214__CropDin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_214__CropDin__);
/* unused harmony reexport CropDin */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_215__CropFree__ = __webpack_require__(1550);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_215__CropFree___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_215__CropFree__);
/* unused harmony reexport CropFree */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_216__CropLandscape__ = __webpack_require__(1551);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_216__CropLandscape___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_216__CropLandscape__);
/* unused harmony reexport CropLandscape */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_217__CropOriginal__ = __webpack_require__(1552);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_217__CropOriginal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_217__CropOriginal__);
/* unused harmony reexport CropOriginal */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_218__CropPortrait__ = __webpack_require__(1553);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_218__CropPortrait___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_218__CropPortrait__);
/* unused harmony reexport CropPortrait */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_219__CropRotate__ = __webpack_require__(1554);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_219__CropRotate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_219__CropRotate__);
/* unused harmony reexport CropRotate */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_220__CropSquare__ = __webpack_require__(1555);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_220__CropSquare___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_220__CropSquare__);
/* unused harmony reexport CropSquare */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_221__Dashboard__ = __webpack_require__(1556);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_221__Dashboard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_221__Dashboard__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_221__Dashboard___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_222__DataUsage__ = __webpack_require__(1557);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_222__DataUsage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_222__DataUsage__);
/* unused harmony reexport DataUsage */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_223__DateRange__ = __webpack_require__(1558);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_223__DateRange___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_223__DateRange__);
/* unused harmony reexport DateRange */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_224__Dehaze__ = __webpack_require__(1559);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_224__Dehaze___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_224__Dehaze__);
/* unused harmony reexport Dehaze */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_225__Delete__ = __webpack_require__(1560);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_225__Delete___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_225__Delete__);
/* unused harmony reexport Delete */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_226__DeleteForever__ = __webpack_require__(1561);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_226__DeleteForever___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_226__DeleteForever__);
/* unused harmony reexport DeleteForever */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_227__DeleteSweep__ = __webpack_require__(1562);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_227__DeleteSweep___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_227__DeleteSweep__);
/* unused harmony reexport DeleteSweep */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_228__Description__ = __webpack_require__(1563);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_228__Description___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_228__Description__);
/* unused harmony reexport Description */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_229__DesktopMac__ = __webpack_require__(1564);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_229__DesktopMac___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_229__DesktopMac__);
/* unused harmony reexport DesktopMac */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_230__DesktopWindows__ = __webpack_require__(1565);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_230__DesktopWindows___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_230__DesktopWindows__);
/* unused harmony reexport DesktopWindows */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_231__Details__ = __webpack_require__(1566);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_231__Details___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_231__Details__);
/* unused harmony reexport Details */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_232__DeveloperBoard__ = __webpack_require__(1567);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_232__DeveloperBoard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_232__DeveloperBoard__);
/* unused harmony reexport DeveloperBoard */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_233__DeveloperMode__ = __webpack_require__(1568);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_233__DeveloperMode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_233__DeveloperMode__);
/* unused harmony reexport DeveloperMode */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_234__DeviceHub__ = __webpack_require__(1569);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_234__DeviceHub___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_234__DeviceHub__);
/* unused harmony reexport DeviceHub */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_235__Devices__ = __webpack_require__(1570);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_235__Devices___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_235__Devices__);
/* unused harmony reexport Devices */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_236__DevicesOther__ = __webpack_require__(1571);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_236__DevicesOther___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_236__DevicesOther__);
/* unused harmony reexport DevicesOther */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_237__DialerSip__ = __webpack_require__(1572);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_237__DialerSip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_237__DialerSip__);
/* unused harmony reexport DialerSip */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_238__Dialpad__ = __webpack_require__(1573);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_238__Dialpad___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_238__Dialpad__);
/* unused harmony reexport Dialpad */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_239__Directions__ = __webpack_require__(1574);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_239__Directions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_239__Directions__);
/* unused harmony reexport Directions */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_240__DirectionsBike__ = __webpack_require__(1575);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_240__DirectionsBike___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_240__DirectionsBike__);
/* unused harmony reexport DirectionsBike */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_241__DirectionsBoat__ = __webpack_require__(1576);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_241__DirectionsBoat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_241__DirectionsBoat__);
/* unused harmony reexport DirectionsBoat */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_242__DirectionsBus__ = __webpack_require__(1577);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_242__DirectionsBus___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_242__DirectionsBus__);
/* unused harmony reexport DirectionsBus */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_243__DirectionsCar__ = __webpack_require__(1578);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_243__DirectionsCar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_243__DirectionsCar__);
/* unused harmony reexport DirectionsCar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_244__DirectionsRailway__ = __webpack_require__(1579);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_244__DirectionsRailway___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_244__DirectionsRailway__);
/* unused harmony reexport DirectionsRailway */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_245__DirectionsRun__ = __webpack_require__(1580);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_245__DirectionsRun___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_245__DirectionsRun__);
/* unused harmony reexport DirectionsRun */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_246__DirectionsSubway__ = __webpack_require__(1581);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_246__DirectionsSubway___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_246__DirectionsSubway__);
/* unused harmony reexport DirectionsSubway */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_247__DirectionsTransit__ = __webpack_require__(1582);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_247__DirectionsTransit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_247__DirectionsTransit__);
/* unused harmony reexport DirectionsTransit */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_248__DirectionsWalk__ = __webpack_require__(1583);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_248__DirectionsWalk___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_248__DirectionsWalk__);
/* unused harmony reexport DirectionsWalk */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_249__DiscFull__ = __webpack_require__(1584);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_249__DiscFull___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_249__DiscFull__);
/* unused harmony reexport DiscFull */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_250__Dns__ = __webpack_require__(1585);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_250__Dns___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_250__Dns__);
/* unused harmony reexport Dns */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_251__Dock__ = __webpack_require__(1586);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_251__Dock___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_251__Dock__);
/* unused harmony reexport Dock */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_252__Domain__ = __webpack_require__(1587);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_252__Domain___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_252__Domain__);
/* unused harmony reexport Domain */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_253__Done__ = __webpack_require__(1588);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_253__Done___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_253__Done__);
/* unused harmony reexport Done */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_254__DoneAll__ = __webpack_require__(1589);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_254__DoneAll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_254__DoneAll__);
/* unused harmony reexport DoneAll */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_255__DoNotDisturb__ = __webpack_require__(1590);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_255__DoNotDisturb___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_255__DoNotDisturb__);
/* unused harmony reexport DoNotDisturb */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_256__DoNotDisturbAlt__ = __webpack_require__(1591);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_256__DoNotDisturbAlt___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_256__DoNotDisturbAlt__);
/* unused harmony reexport DoNotDisturbAlt */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_257__DoNotDisturbOff__ = __webpack_require__(1592);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_257__DoNotDisturbOff___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_257__DoNotDisturbOff__);
/* unused harmony reexport DoNotDisturbOff */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_258__DoNotDisturbOn__ = __webpack_require__(1593);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_258__DoNotDisturbOn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_258__DoNotDisturbOn__);
/* unused harmony reexport DoNotDisturbOn */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_259__DonutLarge__ = __webpack_require__(1594);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_259__DonutLarge___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_259__DonutLarge__);
/* unused harmony reexport DonutLarge */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_260__DonutSmall__ = __webpack_require__(1595);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_260__DonutSmall___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_260__DonutSmall__);
/* unused harmony reexport DonutSmall */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_261__Drafts__ = __webpack_require__(1596);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_261__Drafts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_261__Drafts__);
/* unused harmony reexport Drafts */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_262__DragHandle__ = __webpack_require__(1597);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_262__DragHandle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_262__DragHandle__);
/* unused harmony reexport DragHandle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_263__DriveEta__ = __webpack_require__(1598);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_263__DriveEta___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_263__DriveEta__);
/* unused harmony reexport DriveEta */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_264__Dvr__ = __webpack_require__(1599);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_264__Dvr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_264__Dvr__);
/* unused harmony reexport Dvr */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_265__Edit__ = __webpack_require__(1600);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_265__Edit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_265__Edit__);
/* unused harmony reexport Edit */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_266__EditLocation__ = __webpack_require__(1601);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_266__EditLocation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_266__EditLocation__);
/* unused harmony reexport EditLocation */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_267__Eject__ = __webpack_require__(1602);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_267__Eject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_267__Eject__);
/* unused harmony reexport Eject */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_268__Email__ = __webpack_require__(1603);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_268__Email___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_268__Email__);
/* unused harmony reexport Email */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_269__EnhancedEncryption__ = __webpack_require__(1604);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_269__EnhancedEncryption___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_269__EnhancedEncryption__);
/* unused harmony reexport EnhancedEncryption */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_270__Equalizer__ = __webpack_require__(1605);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_270__Equalizer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_270__Equalizer__);
/* unused harmony reexport Equalizer */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_271__Error__ = __webpack_require__(1606);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_271__Error___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_271__Error__);
/* unused harmony reexport Error */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_272__ErrorOutline__ = __webpack_require__(1607);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_272__ErrorOutline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_272__ErrorOutline__);
/* unused harmony reexport ErrorOutline */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_273__EuroSymbol__ = __webpack_require__(1608);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_273__EuroSymbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_273__EuroSymbol__);
/* unused harmony reexport EuroSymbol */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_274__Event__ = __webpack_require__(1609);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_274__Event___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_274__Event__);
/* unused harmony reexport Event */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_275__EventAvailable__ = __webpack_require__(1610);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_275__EventAvailable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_275__EventAvailable__);
/* unused harmony reexport EventAvailable */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_276__EventBusy__ = __webpack_require__(1611);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_276__EventBusy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_276__EventBusy__);
/* unused harmony reexport EventBusy */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_277__EventNote__ = __webpack_require__(1612);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_277__EventNote___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_277__EventNote__);
/* unused harmony reexport EventNote */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_278__EventSeat__ = __webpack_require__(1613);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_278__EventSeat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_278__EventSeat__);
/* unused harmony reexport EventSeat */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_279__EvStation__ = __webpack_require__(1614);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_279__EvStation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_279__EvStation__);
/* unused harmony reexport EvStation */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_280__ExitToApp__ = __webpack_require__(1615);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_280__ExitToApp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_280__ExitToApp__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_280__ExitToApp___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_281__ExpandLess__ = __webpack_require__(1616);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_281__ExpandLess___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_281__ExpandLess__);
/* unused harmony reexport ExpandLess */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_282__ExpandMore__ = __webpack_require__(576);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_282__ExpandMore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_282__ExpandMore__);
/* unused harmony reexport ExpandMore */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_283__Explicit__ = __webpack_require__(1617);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_283__Explicit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_283__Explicit__);
/* unused harmony reexport Explicit */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_284__Explore__ = __webpack_require__(1618);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_284__Explore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_284__Explore__);
/* unused harmony reexport Explore */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_285__Exposure__ = __webpack_require__(1619);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_285__Exposure___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_285__Exposure__);
/* unused harmony reexport Exposure */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_286__ExposureNeg1__ = __webpack_require__(1620);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_286__ExposureNeg1___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_286__ExposureNeg1__);
/* unused harmony reexport ExposureNeg1 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_287__ExposureNeg2__ = __webpack_require__(1621);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_287__ExposureNeg2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_287__ExposureNeg2__);
/* unused harmony reexport ExposureNeg2 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_288__ExposurePlus1__ = __webpack_require__(1622);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_288__ExposurePlus1___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_288__ExposurePlus1__);
/* unused harmony reexport ExposurePlus1 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_289__ExposurePlus2__ = __webpack_require__(1623);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_289__ExposurePlus2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_289__ExposurePlus2__);
/* unused harmony reexport ExposurePlus2 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_290__ExposureZero__ = __webpack_require__(1624);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_290__ExposureZero___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_290__ExposureZero__);
/* unused harmony reexport ExposureZero */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_291__Extension__ = __webpack_require__(1625);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_291__Extension___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_291__Extension__);
/* unused harmony reexport Extension */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_292__Face__ = __webpack_require__(1626);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_292__Face___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_292__Face__);
/* unused harmony reexport Face */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_293__FastForward__ = __webpack_require__(1627);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_293__FastForward___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_293__FastForward__);
/* unused harmony reexport FastForward */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_294__FastRewind__ = __webpack_require__(1628);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_294__FastRewind___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_294__FastRewind__);
/* unused harmony reexport FastRewind */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_295__Favorite__ = __webpack_require__(1629);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_295__Favorite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_295__Favorite__);
/* unused harmony reexport Favorite */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_296__FavoriteBorder__ = __webpack_require__(1630);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_296__FavoriteBorder___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_296__FavoriteBorder__);
/* unused harmony reexport FavoriteBorder */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_297__FeaturedPlayList__ = __webpack_require__(1631);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_297__FeaturedPlayList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_297__FeaturedPlayList__);
/* unused harmony reexport FeaturedPlayList */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_298__FeaturedVideo__ = __webpack_require__(1632);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_298__FeaturedVideo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_298__FeaturedVideo__);
/* unused harmony reexport FeaturedVideo */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_299__Feedback__ = __webpack_require__(1633);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_299__Feedback___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_299__Feedback__);
/* unused harmony reexport Feedback */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_300__FiberDvr__ = __webpack_require__(1634);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_300__FiberDvr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_300__FiberDvr__);
/* unused harmony reexport FiberDvr */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_301__FiberManualRecord__ = __webpack_require__(1635);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_301__FiberManualRecord___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_301__FiberManualRecord__);
/* unused harmony reexport FiberManualRecord */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_302__FiberNew__ = __webpack_require__(1636);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_302__FiberNew___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_302__FiberNew__);
/* unused harmony reexport FiberNew */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_303__FiberPin__ = __webpack_require__(1637);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_303__FiberPin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_303__FiberPin__);
/* unused harmony reexport FiberPin */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_304__FiberSmartRecord__ = __webpack_require__(1638);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_304__FiberSmartRecord___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_304__FiberSmartRecord__);
/* unused harmony reexport FiberSmartRecord */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_305__FileDownload__ = __webpack_require__(1639);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_305__FileDownload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_305__FileDownload__);
/* unused harmony reexport FileDownload */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_306__FileUpload__ = __webpack_require__(1640);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_306__FileUpload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_306__FileUpload__);
/* unused harmony reexport FileUpload */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_307__Filter__ = __webpack_require__(1641);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_307__Filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_307__Filter__);
/* unused harmony reexport Filter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_308__Filter1__ = __webpack_require__(1642);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_308__Filter1___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_308__Filter1__);
/* unused harmony reexport Filter1 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_309__Filter2__ = __webpack_require__(1643);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_309__Filter2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_309__Filter2__);
/* unused harmony reexport Filter2 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_310__Filter3__ = __webpack_require__(1644);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_310__Filter3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_310__Filter3__);
/* unused harmony reexport Filter3 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_311__Filter4__ = __webpack_require__(1645);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_311__Filter4___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_311__Filter4__);
/* unused harmony reexport Filter4 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_312__Filter5__ = __webpack_require__(1646);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_312__Filter5___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_312__Filter5__);
/* unused harmony reexport Filter5 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_313__Filter6__ = __webpack_require__(1647);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_313__Filter6___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_313__Filter6__);
/* unused harmony reexport Filter6 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_314__Filter7__ = __webpack_require__(1648);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_314__Filter7___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_314__Filter7__);
/* unused harmony reexport Filter7 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_315__Filter8__ = __webpack_require__(1649);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_315__Filter8___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_315__Filter8__);
/* unused harmony reexport Filter8 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_316__Filter9__ = __webpack_require__(1650);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_316__Filter9___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_316__Filter9__);
/* unused harmony reexport Filter9 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_317__Filter9Plus__ = __webpack_require__(1651);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_317__Filter9Plus___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_317__Filter9Plus__);
/* unused harmony reexport Filter9Plus */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_318__FilterBAndW__ = __webpack_require__(1652);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_318__FilterBAndW___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_318__FilterBAndW__);
/* unused harmony reexport FilterBAndW */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_319__FilterCenterFocus__ = __webpack_require__(1653);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_319__FilterCenterFocus___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_319__FilterCenterFocus__);
/* unused harmony reexport FilterCenterFocus */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_320__FilterDrama__ = __webpack_require__(1654);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_320__FilterDrama___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_320__FilterDrama__);
/* unused harmony reexport FilterDrama */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_321__FilterFrames__ = __webpack_require__(1655);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_321__FilterFrames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_321__FilterFrames__);
/* unused harmony reexport FilterFrames */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_322__FilterHdr__ = __webpack_require__(1656);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_322__FilterHdr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_322__FilterHdr__);
/* unused harmony reexport FilterHdr */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_323__FilterList__ = __webpack_require__(1657);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_323__FilterList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_323__FilterList__);
/* unused harmony reexport FilterList */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_324__FilterNone__ = __webpack_require__(1658);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_324__FilterNone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_324__FilterNone__);
/* unused harmony reexport FilterNone */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_325__FilterTiltShift__ = __webpack_require__(1659);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_325__FilterTiltShift___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_325__FilterTiltShift__);
/* unused harmony reexport FilterTiltShift */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_326__FilterVintage__ = __webpack_require__(1660);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_326__FilterVintage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_326__FilterVintage__);
/* unused harmony reexport FilterVintage */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_327__FindInPage__ = __webpack_require__(1661);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_327__FindInPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_327__FindInPage__);
/* unused harmony reexport FindInPage */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_328__FindReplace__ = __webpack_require__(1662);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_328__FindReplace___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_328__FindReplace__);
/* unused harmony reexport FindReplace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_329__Fingerprint__ = __webpack_require__(1663);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_329__Fingerprint___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_329__Fingerprint__);
/* unused harmony reexport Fingerprint */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_330__FirstPage__ = __webpack_require__(1664);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_330__FirstPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_330__FirstPage__);
/* unused harmony reexport FirstPage */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_331__FitnessCenter__ = __webpack_require__(1665);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_331__FitnessCenter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_331__FitnessCenter__);
/* unused harmony reexport FitnessCenter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_332__Flag__ = __webpack_require__(1666);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_332__Flag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_332__Flag__);
/* unused harmony reexport Flag */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_333__Flare__ = __webpack_require__(1667);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_333__Flare___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_333__Flare__);
/* unused harmony reexport Flare */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_334__FlashAuto__ = __webpack_require__(1668);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_334__FlashAuto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_334__FlashAuto__);
/* unused harmony reexport FlashAuto */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_335__FlashOff__ = __webpack_require__(1669);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_335__FlashOff___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_335__FlashOff__);
/* unused harmony reexport FlashOff */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_336__FlashOn__ = __webpack_require__(1670);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_336__FlashOn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_336__FlashOn__);
/* unused harmony reexport FlashOn */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_337__Flight__ = __webpack_require__(1671);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_337__Flight___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_337__Flight__);
/* unused harmony reexport Flight */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_338__FlightLand__ = __webpack_require__(1672);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_338__FlightLand___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_338__FlightLand__);
/* unused harmony reexport FlightLand */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_339__FlightTakeoff__ = __webpack_require__(1673);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_339__FlightTakeoff___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_339__FlightTakeoff__);
/* unused harmony reexport FlightTakeoff */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_340__Flip__ = __webpack_require__(1674);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_340__Flip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_340__Flip__);
/* unused harmony reexport Flip */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_341__FlipToBack__ = __webpack_require__(1675);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_341__FlipToBack___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_341__FlipToBack__);
/* unused harmony reexport FlipToBack */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_342__FlipToFront__ = __webpack_require__(1676);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_342__FlipToFront___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_342__FlipToFront__);
/* unused harmony reexport FlipToFront */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_343__Folder__ = __webpack_require__(1677);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_343__Folder___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_343__Folder__);
/* unused harmony reexport Folder */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_344__FolderOpen__ = __webpack_require__(1678);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_344__FolderOpen___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_344__FolderOpen__);
/* unused harmony reexport FolderOpen */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_345__FolderShared__ = __webpack_require__(1679);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_345__FolderShared___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_345__FolderShared__);
/* unused harmony reexport FolderShared */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_346__FolderSpecial__ = __webpack_require__(1680);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_346__FolderSpecial___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_346__FolderSpecial__);
/* unused harmony reexport FolderSpecial */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_347__FontDownload__ = __webpack_require__(1681);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_347__FontDownload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_347__FontDownload__);
/* unused harmony reexport FontDownload */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_348__FormatAlignCenter__ = __webpack_require__(1682);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_348__FormatAlignCenter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_348__FormatAlignCenter__);
/* unused harmony reexport FormatAlignCenter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_349__FormatAlignJustify__ = __webpack_require__(1683);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_349__FormatAlignJustify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_349__FormatAlignJustify__);
/* unused harmony reexport FormatAlignJustify */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_350__FormatAlignLeft__ = __webpack_require__(1684);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_350__FormatAlignLeft___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_350__FormatAlignLeft__);
/* unused harmony reexport FormatAlignLeft */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_351__FormatAlignRight__ = __webpack_require__(1685);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_351__FormatAlignRight___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_351__FormatAlignRight__);
/* unused harmony reexport FormatAlignRight */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_352__FormatBold__ = __webpack_require__(1686);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_352__FormatBold___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_352__FormatBold__);
/* unused harmony reexport FormatBold */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_353__FormatClear__ = __webpack_require__(1687);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_353__FormatClear___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_353__FormatClear__);
/* unused harmony reexport FormatClear */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_354__FormatColorFill__ = __webpack_require__(1688);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_354__FormatColorFill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_354__FormatColorFill__);
/* unused harmony reexport FormatColorFill */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_355__FormatColorReset__ = __webpack_require__(1689);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_355__FormatColorReset___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_355__FormatColorReset__);
/* unused harmony reexport FormatColorReset */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_356__FormatColorText__ = __webpack_require__(1690);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_356__FormatColorText___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_356__FormatColorText__);
/* unused harmony reexport FormatColorText */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_357__FormatIndentDecrease__ = __webpack_require__(1691);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_357__FormatIndentDecrease___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_357__FormatIndentDecrease__);
/* unused harmony reexport FormatIndentDecrease */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_358__FormatIndentIncrease__ = __webpack_require__(1692);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_358__FormatIndentIncrease___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_358__FormatIndentIncrease__);
/* unused harmony reexport FormatIndentIncrease */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_359__FormatItalic__ = __webpack_require__(1693);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_359__FormatItalic___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_359__FormatItalic__);
/* unused harmony reexport FormatItalic */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_360__FormatLineSpacing__ = __webpack_require__(1694);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_360__FormatLineSpacing___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_360__FormatLineSpacing__);
/* unused harmony reexport FormatLineSpacing */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_361__FormatListBulleted__ = __webpack_require__(1695);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_361__FormatListBulleted___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_361__FormatListBulleted__);
/* unused harmony reexport FormatListBulleted */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_362__FormatListNumbered__ = __webpack_require__(1696);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_362__FormatListNumbered___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_362__FormatListNumbered__);
/* unused harmony reexport FormatListNumbered */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_363__FormatPaint__ = __webpack_require__(1697);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_363__FormatPaint___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_363__FormatPaint__);
/* unused harmony reexport FormatPaint */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_364__FormatQuote__ = __webpack_require__(1698);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_364__FormatQuote___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_364__FormatQuote__);
/* unused harmony reexport FormatQuote */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_365__FormatShapes__ = __webpack_require__(1699);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_365__FormatShapes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_365__FormatShapes__);
/* unused harmony reexport FormatShapes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_366__FormatSize__ = __webpack_require__(1700);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_366__FormatSize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_366__FormatSize__);
/* unused harmony reexport FormatSize */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_367__FormatStrikethrough__ = __webpack_require__(1701);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_367__FormatStrikethrough___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_367__FormatStrikethrough__);
/* unused harmony reexport FormatStrikethrough */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_368__FormatTextdirectionLToR__ = __webpack_require__(1702);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_368__FormatTextdirectionLToR___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_368__FormatTextdirectionLToR__);
/* unused harmony reexport FormatTextdirectionLToR */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_369__FormatTextdirectionRToL__ = __webpack_require__(1703);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_369__FormatTextdirectionRToL___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_369__FormatTextdirectionRToL__);
/* unused harmony reexport FormatTextdirectionRToL */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_370__FormatUnderlined__ = __webpack_require__(1704);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_370__FormatUnderlined___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_370__FormatUnderlined__);
/* unused harmony reexport FormatUnderlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_371__Forum__ = __webpack_require__(1705);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_371__Forum___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_371__Forum__);
/* unused harmony reexport Forum */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_372__Forward__ = __webpack_require__(1706);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_372__Forward___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_372__Forward__);
/* unused harmony reexport Forward */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_373__Forward10__ = __webpack_require__(1707);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_373__Forward10___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_373__Forward10__);
/* unused harmony reexport Forward10 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_374__Forward30__ = __webpack_require__(1708);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_374__Forward30___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_374__Forward30__);
/* unused harmony reexport Forward30 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_375__Forward5__ = __webpack_require__(1709);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_375__Forward5___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_375__Forward5__);
/* unused harmony reexport Forward5 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_376__FreeBreakfast__ = __webpack_require__(1710);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_376__FreeBreakfast___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_376__FreeBreakfast__);
/* unused harmony reexport FreeBreakfast */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_377__Fullscreen__ = __webpack_require__(1711);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_377__Fullscreen___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_377__Fullscreen__);
/* unused harmony reexport Fullscreen */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_378__FullscreenExit__ = __webpack_require__(1712);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_378__FullscreenExit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_378__FullscreenExit__);
/* unused harmony reexport FullscreenExit */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_379__Functions__ = __webpack_require__(1713);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_379__Functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_379__Functions__);
/* unused harmony reexport Functions */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_380__Gamepad__ = __webpack_require__(1714);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_380__Gamepad___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_380__Gamepad__);
/* unused harmony reexport Gamepad */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_381__Games__ = __webpack_require__(1715);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_381__Games___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_381__Games__);
/* unused harmony reexport Games */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_382__Gavel__ = __webpack_require__(1716);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_382__Gavel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_382__Gavel__);
/* unused harmony reexport Gavel */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_383__Gesture__ = __webpack_require__(1717);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_383__Gesture___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_383__Gesture__);
/* unused harmony reexport Gesture */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_384__GetApp__ = __webpack_require__(1718);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_384__GetApp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_384__GetApp__);
/* unused harmony reexport GetApp */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_385__Gif__ = __webpack_require__(1719);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_385__Gif___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_385__Gif__);
/* unused harmony reexport Gif */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_386__GolfCourse__ = __webpack_require__(1720);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_386__GolfCourse___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_386__GolfCourse__);
/* unused harmony reexport GolfCourse */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_387__GpsFixed__ = __webpack_require__(1721);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_387__GpsFixed___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_387__GpsFixed__);
/* unused harmony reexport GpsFixed */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_388__GpsNotFixed__ = __webpack_require__(1722);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_388__GpsNotFixed___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_388__GpsNotFixed__);
/* unused harmony reexport GpsNotFixed */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_389__GpsOff__ = __webpack_require__(1723);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_389__GpsOff___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_389__GpsOff__);
/* unused harmony reexport GpsOff */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_390__Grade__ = __webpack_require__(1724);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_390__Grade___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_390__Grade__);
/* unused harmony reexport Grade */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_391__Gradient__ = __webpack_require__(1725);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_391__Gradient___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_391__Gradient__);
/* unused harmony reexport Gradient */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_392__Grain__ = __webpack_require__(1726);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_392__Grain___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_392__Grain__);
/* unused harmony reexport Grain */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_393__GraphicEq__ = __webpack_require__(1727);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_393__GraphicEq___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_393__GraphicEq__);
/* unused harmony reexport GraphicEq */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_394__GridOff__ = __webpack_require__(1728);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_394__GridOff___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_394__GridOff__);
/* unused harmony reexport GridOff */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_395__GridOn__ = __webpack_require__(1729);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_395__GridOn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_395__GridOn__);
/* unused harmony reexport GridOn */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_396__Group__ = __webpack_require__(1730);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_396__Group___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_396__Group__);
/* unused harmony reexport Group */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_397__GroupAdd__ = __webpack_require__(1731);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_397__GroupAdd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_397__GroupAdd__);
/* unused harmony reexport GroupAdd */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_398__GroupWork__ = __webpack_require__(1732);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_398__GroupWork___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_398__GroupWork__);
/* unused harmony reexport GroupWork */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_399__GTranslate__ = __webpack_require__(1733);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_399__GTranslate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_399__GTranslate__);
/* unused harmony reexport GTranslate */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_400__Hd__ = __webpack_require__(1734);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_400__Hd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_400__Hd__);
/* unused harmony reexport Hd */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_401__HdrOff__ = __webpack_require__(1735);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_401__HdrOff___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_401__HdrOff__);
/* unused harmony reexport HdrOff */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_402__HdrOn__ = __webpack_require__(1736);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_402__HdrOn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_402__HdrOn__);
/* unused harmony reexport HdrOn */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_403__HdrStrong__ = __webpack_require__(1737);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_403__HdrStrong___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_403__HdrStrong__);
/* unused harmony reexport HdrStrong */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_404__HdrWeak__ = __webpack_require__(1738);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_404__HdrWeak___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_404__HdrWeak__);
/* unused harmony reexport HdrWeak */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_405__Headset__ = __webpack_require__(1739);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_405__Headset___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_405__Headset__);
/* unused harmony reexport Headset */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_406__HeadsetMic__ = __webpack_require__(1740);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_406__HeadsetMic___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_406__HeadsetMic__);
/* unused harmony reexport HeadsetMic */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_407__Healing__ = __webpack_require__(1741);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_407__Healing___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_407__Healing__);
/* unused harmony reexport Healing */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_408__Hearing__ = __webpack_require__(1742);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_408__Hearing___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_408__Hearing__);
/* unused harmony reexport Hearing */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_409__Help__ = __webpack_require__(1743);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_409__Help___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_409__Help__);
/* unused harmony reexport Help */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_410__HelpOutline__ = __webpack_require__(1744);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_410__HelpOutline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_410__HelpOutline__);
/* unused harmony reexport HelpOutline */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_411__Highlight__ = __webpack_require__(1745);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_411__Highlight___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_411__Highlight__);
/* unused harmony reexport Highlight */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_412__HighlightOff__ = __webpack_require__(1746);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_412__HighlightOff___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_412__HighlightOff__);
/* unused harmony reexport HighlightOff */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_413__HighQuality__ = __webpack_require__(1747);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_413__HighQuality___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_413__HighQuality__);
/* unused harmony reexport HighQuality */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_414__History__ = __webpack_require__(1748);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_414__History___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_414__History__);
/* unused harmony reexport History */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_415__Home__ = __webpack_require__(1749);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_415__Home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_415__Home__);
/* unused harmony reexport Home */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_416__Hotel__ = __webpack_require__(1750);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_416__Hotel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_416__Hotel__);
/* unused harmony reexport Hotel */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_417__HotTub__ = __webpack_require__(1751);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_417__HotTub___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_417__HotTub__);
/* unused harmony reexport HotTub */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_418__HourglassEmpty__ = __webpack_require__(1752);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_418__HourglassEmpty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_418__HourglassEmpty__);
/* unused harmony reexport HourglassEmpty */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_419__HourglassFull__ = __webpack_require__(1753);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_419__HourglassFull___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_419__HourglassFull__);
/* unused harmony reexport HourglassFull */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_420__Http__ = __webpack_require__(1754);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_420__Http___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_420__Http__);
/* unused harmony reexport Http */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_421__Https__ = __webpack_require__(1755);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_421__Https___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_421__Https__);
/* unused harmony reexport Https */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_422__Image__ = __webpack_require__(1756);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_422__Image___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_422__Image__);
/* unused harmony reexport Image */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_423__ImageAspectRatio__ = __webpack_require__(1757);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_423__ImageAspectRatio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_423__ImageAspectRatio__);
/* unused harmony reexport ImageAspectRatio */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_424__ImportantDevices__ = __webpack_require__(1758);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_424__ImportantDevices___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_424__ImportantDevices__);
/* unused harmony reexport ImportantDevices */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_425__ImportContacts__ = __webpack_require__(1759);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_425__ImportContacts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_425__ImportContacts__);
/* unused harmony reexport ImportContacts */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_426__ImportExport__ = __webpack_require__(1760);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_426__ImportExport___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_426__ImportExport__);
/* unused harmony reexport ImportExport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_427__Inbox__ = __webpack_require__(1761);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_427__Inbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_427__Inbox__);
/* unused harmony reexport Inbox */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_428__IndeterminateCheckBox__ = __webpack_require__(1762);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_428__IndeterminateCheckBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_428__IndeterminateCheckBox__);
/* unused harmony reexport IndeterminateCheckBox */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_429__Info__ = __webpack_require__(1763);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_429__Info___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_429__Info__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_429__Info___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_430__InfoOutline__ = __webpack_require__(1764);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_430__InfoOutline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_430__InfoOutline__);
/* unused harmony reexport InfoOutline */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_431__Input__ = __webpack_require__(1765);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_431__Input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_431__Input__);
/* unused harmony reexport Input */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_432__InsertChart__ = __webpack_require__(1766);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_432__InsertChart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_432__InsertChart__);
/* unused harmony reexport InsertChart */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_433__InsertComment__ = __webpack_require__(1767);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_433__InsertComment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_433__InsertComment__);
/* unused harmony reexport InsertComment */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_434__InsertDriveFile__ = __webpack_require__(1768);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_434__InsertDriveFile___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_434__InsertDriveFile__);
/* unused harmony reexport InsertDriveFile */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_435__InsertEmoticon__ = __webpack_require__(1769);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_435__InsertEmoticon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_435__InsertEmoticon__);
/* unused harmony reexport InsertEmoticon */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_436__InsertInvitation__ = __webpack_require__(1770);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_436__InsertInvitation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_436__InsertInvitation__);
/* unused harmony reexport InsertInvitation */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_437__InsertLink__ = __webpack_require__(1771);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_437__InsertLink___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_437__InsertLink__);
/* unused harmony reexport InsertLink */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_438__InsertPhoto__ = __webpack_require__(1772);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_438__InsertPhoto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_438__InsertPhoto__);
/* unused harmony reexport InsertPhoto */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_439__InvertColors__ = __webpack_require__(1773);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_439__InvertColors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_439__InvertColors__);
/* unused harmony reexport InvertColors */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_440__InvertColorsOff__ = __webpack_require__(1774);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_440__InvertColorsOff___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_440__InvertColorsOff__);
/* unused harmony reexport InvertColorsOff */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_441__Iso__ = __webpack_require__(1775);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_441__Iso___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_441__Iso__);
/* unused harmony reexport Iso */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_442__Keyboard__ = __webpack_require__(1776);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_442__Keyboard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_442__Keyboard__);
/* unused harmony reexport Keyboard */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_443__KeyboardArrowDown__ = __webpack_require__(1777);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_443__KeyboardArrowDown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_443__KeyboardArrowDown__);
/* unused harmony reexport KeyboardArrowDown */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_444__KeyboardArrowLeft__ = __webpack_require__(1778);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_444__KeyboardArrowLeft___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_444__KeyboardArrowLeft__);
/* unused harmony reexport KeyboardArrowLeft */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_445__KeyboardArrowRight__ = __webpack_require__(1779);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_445__KeyboardArrowRight___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_445__KeyboardArrowRight__);
/* unused harmony reexport KeyboardArrowRight */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_446__KeyboardArrowUp__ = __webpack_require__(1780);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_446__KeyboardArrowUp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_446__KeyboardArrowUp__);
/* unused harmony reexport KeyboardArrowUp */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_447__KeyboardBackspace__ = __webpack_require__(1781);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_447__KeyboardBackspace___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_447__KeyboardBackspace__);
/* unused harmony reexport KeyboardBackspace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_448__KeyboardCapslock__ = __webpack_require__(1782);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_448__KeyboardCapslock___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_448__KeyboardCapslock__);
/* unused harmony reexport KeyboardCapslock */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_449__KeyboardHide__ = __webpack_require__(1783);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_449__KeyboardHide___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_449__KeyboardHide__);
/* unused harmony reexport KeyboardHide */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_450__KeyboardReturn__ = __webpack_require__(1784);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_450__KeyboardReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_450__KeyboardReturn__);
/* unused harmony reexport KeyboardReturn */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_451__KeyboardTab__ = __webpack_require__(1785);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_451__KeyboardTab___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_451__KeyboardTab__);
/* unused harmony reexport KeyboardTab */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_452__KeyboardVoice__ = __webpack_require__(1786);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_452__KeyboardVoice___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_452__KeyboardVoice__);
/* unused harmony reexport KeyboardVoice */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_453__Kitchen__ = __webpack_require__(1787);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_453__Kitchen___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_453__Kitchen__);
/* unused harmony reexport Kitchen */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_454__Label__ = __webpack_require__(1788);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_454__Label___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_454__Label__);
/* unused harmony reexport Label */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_455__LabelOutline__ = __webpack_require__(1789);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_455__LabelOutline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_455__LabelOutline__);
/* unused harmony reexport LabelOutline */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_456__Landscape__ = __webpack_require__(1790);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_456__Landscape___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_456__Landscape__);
/* unused harmony reexport Landscape */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_457__Language__ = __webpack_require__(1791);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_457__Language___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_457__Language__);
/* unused harmony reexport Language */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_458__Laptop__ = __webpack_require__(1792);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_458__Laptop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_458__Laptop__);
/* unused harmony reexport Laptop */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_459__LaptopChromebook__ = __webpack_require__(1793);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_459__LaptopChromebook___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_459__LaptopChromebook__);
/* unused harmony reexport LaptopChromebook */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_460__LaptopMac__ = __webpack_require__(1794);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_460__LaptopMac___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_460__LaptopMac__);
/* unused harmony reexport LaptopMac */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_461__LaptopWindows__ = __webpack_require__(1795);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_461__LaptopWindows___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_461__LaptopWindows__);
/* unused harmony reexport LaptopWindows */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_462__LastPage__ = __webpack_require__(1796);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_462__LastPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_462__LastPage__);
/* unused harmony reexport LastPage */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_463__Launch__ = __webpack_require__(1797);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_463__Launch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_463__Launch__);
/* unused harmony reexport Launch */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_464__Layers__ = __webpack_require__(1798);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_464__Layers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_464__Layers__);
/* unused harmony reexport Layers */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_465__LayersClear__ = __webpack_require__(1799);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_465__LayersClear___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_465__LayersClear__);
/* unused harmony reexport LayersClear */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_466__LeakAdd__ = __webpack_require__(1800);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_466__LeakAdd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_466__LeakAdd__);
/* unused harmony reexport LeakAdd */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_467__LeakRemove__ = __webpack_require__(1801);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_467__LeakRemove___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_467__LeakRemove__);
/* unused harmony reexport LeakRemove */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_468__Lens__ = __webpack_require__(1802);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_468__Lens___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_468__Lens__);
/* unused harmony reexport Lens */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_469__LibraryAdd__ = __webpack_require__(1803);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_469__LibraryAdd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_469__LibraryAdd__);
/* unused harmony reexport LibraryAdd */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_470__LibraryBooks__ = __webpack_require__(1804);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_470__LibraryBooks___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_470__LibraryBooks__);
/* unused harmony reexport LibraryBooks */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_471__LibraryMusic__ = __webpack_require__(1805);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_471__LibraryMusic___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_471__LibraryMusic__);
/* unused harmony reexport LibraryMusic */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_472__LightbulbOutline__ = __webpack_require__(1806);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_472__LightbulbOutline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_472__LightbulbOutline__);
/* unused harmony reexport LightbulbOutline */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_473__LinearScale__ = __webpack_require__(1807);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_473__LinearScale___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_473__LinearScale__);
/* unused harmony reexport LinearScale */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_474__LineStyle__ = __webpack_require__(1808);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_474__LineStyle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_474__LineStyle__);
/* unused harmony reexport LineStyle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_475__LineWeight__ = __webpack_require__(1809);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_475__LineWeight___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_475__LineWeight__);
/* unused harmony reexport LineWeight */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_476__Link__ = __webpack_require__(1810);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_476__Link___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_476__Link__);
/* unused harmony reexport Link */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_477__LinkedCamera__ = __webpack_require__(1811);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_477__LinkedCamera___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_477__LinkedCamera__);
/* unused harmony reexport LinkedCamera */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_478__List__ = __webpack_require__(1812);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_478__List___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_478__List__);
/* unused harmony reexport List */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_479__LiveHelp__ = __webpack_require__(1813);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_479__LiveHelp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_479__LiveHelp__);
/* unused harmony reexport LiveHelp */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_480__LiveTv__ = __webpack_require__(1814);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_480__LiveTv___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_480__LiveTv__);
/* unused harmony reexport LiveTv */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_481__LocalActivity__ = __webpack_require__(1815);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_481__LocalActivity___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_481__LocalActivity__);
/* unused harmony reexport LocalActivity */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_482__LocalAirport__ = __webpack_require__(1816);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_482__LocalAirport___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_482__LocalAirport__);
/* unused harmony reexport LocalAirport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_483__LocalAtm__ = __webpack_require__(1817);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_483__LocalAtm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_483__LocalAtm__);
/* unused harmony reexport LocalAtm */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_484__LocalBar__ = __webpack_require__(1818);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_484__LocalBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_484__LocalBar__);
/* unused harmony reexport LocalBar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_485__LocalCafe__ = __webpack_require__(1819);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_485__LocalCafe___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_485__LocalCafe__);
/* unused harmony reexport LocalCafe */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_486__LocalCarWash__ = __webpack_require__(1820);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_486__LocalCarWash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_486__LocalCarWash__);
/* unused harmony reexport LocalCarWash */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_487__LocalConvenienceStore__ = __webpack_require__(1821);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_487__LocalConvenienceStore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_487__LocalConvenienceStore__);
/* unused harmony reexport LocalConvenienceStore */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_488__LocalDining__ = __webpack_require__(1822);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_488__LocalDining___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_488__LocalDining__);
/* unused harmony reexport LocalDining */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_489__LocalDrink__ = __webpack_require__(1823);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_489__LocalDrink___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_489__LocalDrink__);
/* unused harmony reexport LocalDrink */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_490__LocalFlorist__ = __webpack_require__(1824);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_490__LocalFlorist___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_490__LocalFlorist__);
/* unused harmony reexport LocalFlorist */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_491__LocalGasStation__ = __webpack_require__(1825);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_491__LocalGasStation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_491__LocalGasStation__);
/* unused harmony reexport LocalGasStation */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_492__LocalGroceryStore__ = __webpack_require__(1826);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_492__LocalGroceryStore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_492__LocalGroceryStore__);
/* unused harmony reexport LocalGroceryStore */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_493__LocalHospital__ = __webpack_require__(1827);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_493__LocalHospital___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_493__LocalHospital__);
/* unused harmony reexport LocalHospital */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_494__LocalHotel__ = __webpack_require__(1828);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_494__LocalHotel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_494__LocalHotel__);
/* unused harmony reexport LocalHotel */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_495__LocalLaundryService__ = __webpack_require__(1829);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_495__LocalLaundryService___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_495__LocalLaundryService__);
/* unused harmony reexport LocalLaundryService */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_496__LocalLibrary__ = __webpack_require__(1830);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_496__LocalLibrary___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_496__LocalLibrary__);
/* unused harmony reexport LocalLibrary */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_497__LocalMall__ = __webpack_require__(1831);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_497__LocalMall___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_497__LocalMall__);
/* unused harmony reexport LocalMall */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_498__LocalMovies__ = __webpack_require__(1832);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_498__LocalMovies___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_498__LocalMovies__);
/* unused harmony reexport LocalMovies */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_499__LocalOffer__ = __webpack_require__(1833);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_499__LocalOffer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_499__LocalOffer__);
/* unused harmony reexport LocalOffer */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_500__LocalParking__ = __webpack_require__(1834);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_500__LocalParking___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_500__LocalParking__);
/* unused harmony reexport LocalParking */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_501__LocalPharmacy__ = __webpack_require__(1835);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_501__LocalPharmacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_501__LocalPharmacy__);
/* unused harmony reexport LocalPharmacy */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_502__LocalPhone__ = __webpack_require__(1836);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_502__LocalPhone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_502__LocalPhone__);
/* unused harmony reexport LocalPhone */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_503__LocalPizza__ = __webpack_require__(1837);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_503__LocalPizza___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_503__LocalPizza__);
/* unused harmony reexport LocalPizza */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_504__LocalPlay__ = __webpack_require__(1838);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_504__LocalPlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_504__LocalPlay__);
/* unused harmony reexport LocalPlay */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_505__LocalPostOffice__ = __webpack_require__(1839);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_505__LocalPostOffice___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_505__LocalPostOffice__);
/* unused harmony reexport LocalPostOffice */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_506__LocalPrintshop__ = __webpack_require__(1840);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_506__LocalPrintshop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_506__LocalPrintshop__);
/* unused harmony reexport LocalPrintshop */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_507__LocalSee__ = __webpack_require__(1841);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_507__LocalSee___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_507__LocalSee__);
/* unused harmony reexport LocalSee */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_508__LocalShipping__ = __webpack_require__(1842);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_508__LocalShipping___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_508__LocalShipping__);
/* unused harmony reexport LocalShipping */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_509__LocalTaxi__ = __webpack_require__(1843);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_509__LocalTaxi___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_509__LocalTaxi__);
/* unused harmony reexport LocalTaxi */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_510__LocationCity__ = __webpack_require__(1844);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_510__LocationCity___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_510__LocationCity__);
/* unused harmony reexport LocationCity */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_511__LocationDisabled__ = __webpack_require__(1845);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_511__LocationDisabled___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_511__LocationDisabled__);
/* unused harmony reexport LocationDisabled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_512__LocationOff__ = __webpack_require__(1846);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_512__LocationOff___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_512__LocationOff__);
/* unused harmony reexport LocationOff */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_513__LocationOn__ = __webpack_require__(1847);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_513__LocationOn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_513__LocationOn__);
/* unused harmony reexport LocationOn */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_514__LocationSearching__ = __webpack_require__(1848);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_514__LocationSearching___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_514__LocationSearching__);
/* unused harmony reexport LocationSearching */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_515__Lock__ = __webpack_require__(1849);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_515__Lock___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_515__Lock__);
/* unused harmony reexport Lock */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_516__LockOpen__ = __webpack_require__(572);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_516__LockOpen___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_516__LockOpen__);
/* unused harmony reexport LockOpen */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_517__LockOutline__ = __webpack_require__(1850);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_517__LockOutline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_517__LockOutline__);
/* unused harmony reexport LockOutline */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_518__Looks__ = __webpack_require__(1851);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_518__Looks___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_518__Looks__);
/* unused harmony reexport Looks */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_519__Looks3__ = __webpack_require__(1852);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_519__Looks3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_519__Looks3__);
/* unused harmony reexport Looks3 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_520__Looks4__ = __webpack_require__(1853);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_520__Looks4___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_520__Looks4__);
/* unused harmony reexport Looks4 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_521__Looks5__ = __webpack_require__(1854);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_521__Looks5___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_521__Looks5__);
/* unused harmony reexport Looks5 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_522__Looks6__ = __webpack_require__(1855);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_522__Looks6___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_522__Looks6__);
/* unused harmony reexport Looks6 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_523__LooksOne__ = __webpack_require__(1856);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_523__LooksOne___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_523__LooksOne__);
/* unused harmony reexport LooksOne */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_524__LooksTwo__ = __webpack_require__(1857);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_524__LooksTwo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_524__LooksTwo__);
/* unused harmony reexport LooksTwo */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_525__Loop__ = __webpack_require__(1858);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_525__Loop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_525__Loop__);
/* unused harmony reexport Loop */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_526__Loupe__ = __webpack_require__(1859);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_526__Loupe___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_526__Loupe__);
/* unused harmony reexport Loupe */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_527__LowPriority__ = __webpack_require__(1860);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_527__LowPriority___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_527__LowPriority__);
/* unused harmony reexport LowPriority */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_528__Loyalty__ = __webpack_require__(1861);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_528__Loyalty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_528__Loyalty__);
/* unused harmony reexport Loyalty */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_529__Mail__ = __webpack_require__(1862);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_529__Mail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_529__Mail__);
/* unused harmony reexport Mail */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_530__MailOutline__ = __webpack_require__(1863);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_530__MailOutline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_530__MailOutline__);
/* unused harmony reexport MailOutline */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_531__Map__ = __webpack_require__(1864);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_531__Map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_531__Map__);
/* unused harmony reexport Map */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_532__Markunread__ = __webpack_require__(1865);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_532__Markunread___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_532__Markunread__);
/* unused harmony reexport Markunread */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_533__MarkunreadMailbox__ = __webpack_require__(1866);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_533__MarkunreadMailbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_533__MarkunreadMailbox__);
/* unused harmony reexport MarkunreadMailbox */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_534__Memory__ = __webpack_require__(1867);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_534__Memory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_534__Memory__);
/* unused harmony reexport Memory */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_535__Menu__ = __webpack_require__(577);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_535__Menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_535__Menu__);
/* unused harmony reexport Menu */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_536__MergeType__ = __webpack_require__(1868);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_536__MergeType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_536__MergeType__);
/* unused harmony reexport MergeType */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_537__Message__ = __webpack_require__(1869);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_537__Message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_537__Message__);
/* unused harmony reexport Message */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_538__Mic__ = __webpack_require__(1870);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_538__Mic___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_538__Mic__);
/* unused harmony reexport Mic */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_539__MicNone__ = __webpack_require__(1871);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_539__MicNone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_539__MicNone__);
/* unused harmony reexport MicNone */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_540__MicOff__ = __webpack_require__(1872);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_540__MicOff___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_540__MicOff__);
/* unused harmony reexport MicOff */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_541__Mms__ = __webpack_require__(1873);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_541__Mms___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_541__Mms__);
/* unused harmony reexport Mms */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_542__ModeComment__ = __webpack_require__(1874);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_542__ModeComment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_542__ModeComment__);
/* unused harmony reexport ModeComment */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_543__ModeEdit__ = __webpack_require__(1875);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_543__ModeEdit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_543__ModeEdit__);
/* unused harmony reexport ModeEdit */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_544__MonetizationOn__ = __webpack_require__(1876);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_544__MonetizationOn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_544__MonetizationOn__);
/* unused harmony reexport MonetizationOn */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_545__MoneyOff__ = __webpack_require__(1877);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_545__MoneyOff___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_545__MoneyOff__);
/* unused harmony reexport MoneyOff */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_546__MonochromePhotos__ = __webpack_require__(1878);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_546__MonochromePhotos___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_546__MonochromePhotos__);
/* unused harmony reexport MonochromePhotos */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_547__Mood__ = __webpack_require__(1879);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_547__Mood___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_547__Mood__);
/* unused harmony reexport Mood */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_548__MoodBad__ = __webpack_require__(1880);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_548__MoodBad___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_548__MoodBad__);
/* unused harmony reexport MoodBad */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_549__More__ = __webpack_require__(1881);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_549__More___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_549__More__);
/* unused harmony reexport More */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_550__MoreHoriz__ = __webpack_require__(1882);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_550__MoreHoriz___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_550__MoreHoriz__);
/* unused harmony reexport MoreHoriz */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_551__MoreVert__ = __webpack_require__(1883);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_551__MoreVert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_551__MoreVert__);
/* unused harmony reexport MoreVert */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_552__Motorcycle__ = __webpack_require__(1884);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_552__Motorcycle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_552__Motorcycle__);
/* unused harmony reexport Motorcycle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_553__Mouse__ = __webpack_require__(1885);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_553__Mouse___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_553__Mouse__);
/* unused harmony reexport Mouse */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_554__MoveToInbox__ = __webpack_require__(1886);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_554__MoveToInbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_554__MoveToInbox__);
/* unused harmony reexport MoveToInbox */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_555__Movie__ = __webpack_require__(1887);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_555__Movie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_555__Movie__);
/* unused harmony reexport Movie */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_556__MovieCreation__ = __webpack_require__(1888);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_556__MovieCreation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_556__MovieCreation__);
/* unused harmony reexport MovieCreation */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_557__MovieFilter__ = __webpack_require__(1889);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_557__MovieFilter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_557__MovieFilter__);
/* unused harmony reexport MovieFilter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_558__MultilineChart__ = __webpack_require__(1890);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_558__MultilineChart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_558__MultilineChart__);
/* unused harmony reexport MultilineChart */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_559__MusicNote__ = __webpack_require__(1891);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_559__MusicNote___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_559__MusicNote__);
/* unused harmony reexport MusicNote */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_560__MusicVideo__ = __webpack_require__(1892);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_560__MusicVideo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_560__MusicVideo__);
/* unused harmony reexport MusicVideo */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_561__MyLocation__ = __webpack_require__(1893);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_561__MyLocation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_561__MyLocation__);
/* unused harmony reexport MyLocation */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_562__Nature__ = __webpack_require__(1894);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_562__Nature___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_562__Nature__);
/* unused harmony reexport Nature */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_563__NaturePeople__ = __webpack_require__(1895);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_563__NaturePeople___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_563__NaturePeople__);
/* unused harmony reexport NaturePeople */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_564__NavigateBefore__ = __webpack_require__(1896);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_564__NavigateBefore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_564__NavigateBefore__);
/* unused harmony reexport NavigateBefore */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_565__NavigateNext__ = __webpack_require__(1897);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_565__NavigateNext___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_565__NavigateNext__);
/* unused harmony reexport NavigateNext */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_566__Navigation__ = __webpack_require__(1898);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_566__Navigation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_566__Navigation__);
/* unused harmony reexport Navigation */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_567__NearMe__ = __webpack_require__(1899);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_567__NearMe___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_567__NearMe__);
/* unused harmony reexport NearMe */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_568__NetworkCell__ = __webpack_require__(1900);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_568__NetworkCell___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_568__NetworkCell__);
/* unused harmony reexport NetworkCell */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_569__NetworkCheck__ = __webpack_require__(1901);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_569__NetworkCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_569__NetworkCheck__);
/* unused harmony reexport NetworkCheck */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_570__NetworkLocked__ = __webpack_require__(1902);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_570__NetworkLocked___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_570__NetworkLocked__);
/* unused harmony reexport NetworkLocked */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_571__NetworkWifi__ = __webpack_require__(1903);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_571__NetworkWifi___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_571__NetworkWifi__);
/* unused harmony reexport NetworkWifi */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_572__NewReleases__ = __webpack_require__(1904);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_572__NewReleases___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_572__NewReleases__);
/* unused harmony reexport NewReleases */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_573__NextWeek__ = __webpack_require__(1905);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_573__NextWeek___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_573__NextWeek__);
/* unused harmony reexport NextWeek */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_574__Nfc__ = __webpack_require__(1906);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_574__Nfc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_574__Nfc__);
/* unused harmony reexport Nfc */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_575__NoEncryption__ = __webpack_require__(1907);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_575__NoEncryption___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_575__NoEncryption__);
/* unused harmony reexport NoEncryption */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_576__NoSim__ = __webpack_require__(1908);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_576__NoSim___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_576__NoSim__);
/* unused harmony reexport NoSim */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_577__Note__ = __webpack_require__(1909);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_577__Note___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_577__Note__);
/* unused harmony reexport Note */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_578__NoteAdd__ = __webpack_require__(1910);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_578__NoteAdd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_578__NoteAdd__);
/* unused harmony reexport NoteAdd */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_579__Notifications__ = __webpack_require__(1911);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_579__Notifications___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_579__Notifications__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_579__Notifications___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_580__NotificationsActive__ = __webpack_require__(1912);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_580__NotificationsActive___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_580__NotificationsActive__);
/* unused harmony reexport NotificationsActive */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_581__NotificationsNone__ = __webpack_require__(1913);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_581__NotificationsNone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_581__NotificationsNone__);
/* unused harmony reexport NotificationsNone */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_582__NotificationsOff__ = __webpack_require__(1914);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_582__NotificationsOff___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_582__NotificationsOff__);
/* unused harmony reexport NotificationsOff */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_583__NotificationsPaused__ = __webpack_require__(1915);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_583__NotificationsPaused___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_583__NotificationsPaused__);
/* unused harmony reexport NotificationsPaused */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_584__NotInterested__ = __webpack_require__(1916);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_584__NotInterested___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_584__NotInterested__);
/* unused harmony reexport NotInterested */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_585__OfflinePin__ = __webpack_require__(1917);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_585__OfflinePin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_585__OfflinePin__);
/* unused harmony reexport OfflinePin */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_586__OndemandVideo__ = __webpack_require__(1918);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_586__OndemandVideo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_586__OndemandVideo__);
/* unused harmony reexport OndemandVideo */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_587__Opacity__ = __webpack_require__(1919);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_587__Opacity___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_587__Opacity__);
/* unused harmony reexport Opacity */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_588__OpenInBrowser__ = __webpack_require__(1920);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_588__OpenInBrowser___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_588__OpenInBrowser__);
/* unused harmony reexport OpenInBrowser */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_589__OpenInNew__ = __webpack_require__(1921);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_589__OpenInNew___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_589__OpenInNew__);
/* unused harmony reexport OpenInNew */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_590__OpenWith__ = __webpack_require__(1922);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_590__OpenWith___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_590__OpenWith__);
/* unused harmony reexport OpenWith */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_591__Pages__ = __webpack_require__(1923);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_591__Pages___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_591__Pages__);
/* unused harmony reexport Pages */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_592__Pageview__ = __webpack_require__(1924);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_592__Pageview___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_592__Pageview__);
/* unused harmony reexport Pageview */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_593__Palette__ = __webpack_require__(1925);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_593__Palette___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_593__Palette__);
/* unused harmony reexport Palette */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_594__Panorama__ = __webpack_require__(1926);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_594__Panorama___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_594__Panorama__);
/* unused harmony reexport Panorama */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_595__PanoramaFishEye__ = __webpack_require__(1927);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_595__PanoramaFishEye___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_595__PanoramaFishEye__);
/* unused harmony reexport PanoramaFishEye */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_596__PanoramaHorizontal__ = __webpack_require__(1928);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_596__PanoramaHorizontal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_596__PanoramaHorizontal__);
/* unused harmony reexport PanoramaHorizontal */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_597__PanoramaVertical__ = __webpack_require__(1929);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_597__PanoramaVertical___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_597__PanoramaVertical__);
/* unused harmony reexport PanoramaVertical */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_598__PanoramaWideAngle__ = __webpack_require__(1930);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_598__PanoramaWideAngle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_598__PanoramaWideAngle__);
/* unused harmony reexport PanoramaWideAngle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_599__PanTool__ = __webpack_require__(1931);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_599__PanTool___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_599__PanTool__);
/* unused harmony reexport PanTool */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_600__PartyMode__ = __webpack_require__(1932);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_600__PartyMode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_600__PartyMode__);
/* unused harmony reexport PartyMode */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_601__Pause__ = __webpack_require__(1933);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_601__Pause___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_601__Pause__);
/* unused harmony reexport Pause */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_602__PauseCircleFilled__ = __webpack_require__(1934);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_602__PauseCircleFilled___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_602__PauseCircleFilled__);
/* unused harmony reexport PauseCircleFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_603__PauseCircleOutline__ = __webpack_require__(1935);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_603__PauseCircleOutline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_603__PauseCircleOutline__);
/* unused harmony reexport PauseCircleOutline */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_604__Payment__ = __webpack_require__(1936);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_604__Payment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_604__Payment__);
/* unused harmony reexport Payment */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_605__People__ = __webpack_require__(1937);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_605__People___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_605__People__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_605__People___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_606__PeopleOutline__ = __webpack_require__(1938);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_606__PeopleOutline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_606__PeopleOutline__);
/* unused harmony reexport PeopleOutline */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_607__PermCameraMic__ = __webpack_require__(1939);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_607__PermCameraMic___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_607__PermCameraMic__);
/* unused harmony reexport PermCameraMic */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_608__PermContactCalendar__ = __webpack_require__(1940);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_608__PermContactCalendar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_608__PermContactCalendar__);
/* unused harmony reexport PermContactCalendar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_609__PermDataSetting__ = __webpack_require__(1941);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_609__PermDataSetting___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_609__PermDataSetting__);
/* unused harmony reexport PermDataSetting */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_610__PermDeviceInformation__ = __webpack_require__(1942);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_610__PermDeviceInformation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_610__PermDeviceInformation__);
/* unused harmony reexport PermDeviceInformation */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_611__PermIdentity__ = __webpack_require__(578);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_611__PermIdentity___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_611__PermIdentity__);
/* unused harmony reexport PermIdentity */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_612__PermMedia__ = __webpack_require__(1943);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_612__PermMedia___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_612__PermMedia__);
/* unused harmony reexport PermMedia */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_613__PermPhoneMsg__ = __webpack_require__(1944);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_613__PermPhoneMsg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_613__PermPhoneMsg__);
/* unused harmony reexport PermPhoneMsg */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_614__PermScanWifi__ = __webpack_require__(1945);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_614__PermScanWifi___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_614__PermScanWifi__);
/* unused harmony reexport PermScanWifi */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_615__Person__ = __webpack_require__(1946);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_615__Person___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_615__Person__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_615__Person___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_616__PersonAdd__ = __webpack_require__(1947);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_616__PersonAdd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_616__PersonAdd__);
/* unused harmony reexport PersonAdd */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_617__PersonalVideo__ = __webpack_require__(1948);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_617__PersonalVideo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_617__PersonalVideo__);
/* unused harmony reexport PersonalVideo */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_618__PersonOutline__ = __webpack_require__(1949);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_618__PersonOutline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_618__PersonOutline__);
/* unused harmony reexport PersonOutline */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_619__PersonPin__ = __webpack_require__(1950);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_619__PersonPin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_619__PersonPin__);
/* unused harmony reexport PersonPin */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_620__PersonPinCircle__ = __webpack_require__(1951);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_620__PersonPinCircle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_620__PersonPinCircle__);
/* unused harmony reexport PersonPinCircle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_621__Pets__ = __webpack_require__(1952);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_621__Pets___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_621__Pets__);
/* unused harmony reexport Pets */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_622__Phone__ = __webpack_require__(1953);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_622__Phone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_622__Phone__);
/* unused harmony reexport Phone */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_623__PhoneAndroid__ = __webpack_require__(1954);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_623__PhoneAndroid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_623__PhoneAndroid__);
/* unused harmony reexport PhoneAndroid */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_624__PhoneBluetoothSpeaker__ = __webpack_require__(1955);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_624__PhoneBluetoothSpeaker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_624__PhoneBluetoothSpeaker__);
/* unused harmony reexport PhoneBluetoothSpeaker */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_625__PhoneForwarded__ = __webpack_require__(1956);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_625__PhoneForwarded___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_625__PhoneForwarded__);
/* unused harmony reexport PhoneForwarded */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_626__PhoneInTalk__ = __webpack_require__(1957);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_626__PhoneInTalk___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_626__PhoneInTalk__);
/* unused harmony reexport PhoneInTalk */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_627__PhoneIphone__ = __webpack_require__(1958);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_627__PhoneIphone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_627__PhoneIphone__);
/* unused harmony reexport PhoneIphone */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_628__Phonelink__ = __webpack_require__(1959);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_628__Phonelink___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_628__Phonelink__);
/* unused harmony reexport Phonelink */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_629__PhonelinkErase__ = __webpack_require__(1960);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_629__PhonelinkErase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_629__PhonelinkErase__);
/* unused harmony reexport PhonelinkErase */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_630__PhonelinkLock__ = __webpack_require__(1961);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_630__PhonelinkLock___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_630__PhonelinkLock__);
/* unused harmony reexport PhonelinkLock */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_631__PhonelinkOff__ = __webpack_require__(1962);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_631__PhonelinkOff___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_631__PhonelinkOff__);
/* unused harmony reexport PhonelinkOff */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_632__PhonelinkRing__ = __webpack_require__(1963);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_632__PhonelinkRing___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_632__PhonelinkRing__);
/* unused harmony reexport PhonelinkRing */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_633__PhonelinkSetup__ = __webpack_require__(1964);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_633__PhonelinkSetup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_633__PhonelinkSetup__);
/* unused harmony reexport PhonelinkSetup */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_634__PhoneLocked__ = __webpack_require__(1965);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_634__PhoneLocked___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_634__PhoneLocked__);
/* unused harmony reexport PhoneLocked */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_635__PhoneMissed__ = __webpack_require__(1966);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_635__PhoneMissed___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_635__PhoneMissed__);
/* unused harmony reexport PhoneMissed */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_636__PhonePaused__ = __webpack_require__(1967);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_636__PhonePaused___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_636__PhonePaused__);
/* unused harmony reexport PhonePaused */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_637__Photo__ = __webpack_require__(1968);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_637__Photo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_637__Photo__);
/* unused harmony reexport Photo */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_638__PhotoAlbum__ = __webpack_require__(1969);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_638__PhotoAlbum___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_638__PhotoAlbum__);
/* unused harmony reexport PhotoAlbum */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_639__PhotoCamera__ = __webpack_require__(1970);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_639__PhotoCamera___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_639__PhotoCamera__);
/* unused harmony reexport PhotoCamera */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_640__PhotoFilter__ = __webpack_require__(1971);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_640__PhotoFilter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_640__PhotoFilter__);
/* unused harmony reexport PhotoFilter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_641__PhotoLibrary__ = __webpack_require__(1972);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_641__PhotoLibrary___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_641__PhotoLibrary__);
/* unused harmony reexport PhotoLibrary */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_642__PhotoSizeSelectActual__ = __webpack_require__(1973);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_642__PhotoSizeSelectActual___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_642__PhotoSizeSelectActual__);
/* unused harmony reexport PhotoSizeSelectActual */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_643__PhotoSizeSelectLarge__ = __webpack_require__(1974);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_643__PhotoSizeSelectLarge___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_643__PhotoSizeSelectLarge__);
/* unused harmony reexport PhotoSizeSelectLarge */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_644__PhotoSizeSelectSmall__ = __webpack_require__(1975);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_644__PhotoSizeSelectSmall___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_644__PhotoSizeSelectSmall__);
/* unused harmony reexport PhotoSizeSelectSmall */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_645__PictureAsPdf__ = __webpack_require__(1976);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_645__PictureAsPdf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_645__PictureAsPdf__);
/* unused harmony reexport PictureAsPdf */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_646__PictureInPicture__ = __webpack_require__(1977);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_646__PictureInPicture___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_646__PictureInPicture__);
/* unused harmony reexport PictureInPicture */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_647__PictureInPictureAlt__ = __webpack_require__(1978);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_647__PictureInPictureAlt___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_647__PictureInPictureAlt__);
/* unused harmony reexport PictureInPictureAlt */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_648__PieChart__ = __webpack_require__(1979);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_648__PieChart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_648__PieChart__);
/* unused harmony reexport PieChart */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_649__PieChartOutlined__ = __webpack_require__(1980);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_649__PieChartOutlined___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_649__PieChartOutlined__);
/* unused harmony reexport PieChartOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_650__PinDrop__ = __webpack_require__(1981);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_650__PinDrop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_650__PinDrop__);
/* unused harmony reexport PinDrop */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_651__Place__ = __webpack_require__(1982);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_651__Place___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_651__Place__);
/* unused harmony reexport Place */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_652__PlayArrow__ = __webpack_require__(1983);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_652__PlayArrow___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_652__PlayArrow__);
/* unused harmony reexport PlayArrow */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_653__PlayCircleFilled__ = __webpack_require__(1984);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_653__PlayCircleFilled___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_653__PlayCircleFilled__);
/* unused harmony reexport PlayCircleFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_654__PlayCircleOutline__ = __webpack_require__(1985);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_654__PlayCircleOutline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_654__PlayCircleOutline__);
/* unused harmony reexport PlayCircleOutline */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_655__PlayForWork__ = __webpack_require__(1986);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_655__PlayForWork___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_655__PlayForWork__);
/* unused harmony reexport PlayForWork */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_656__PlaylistAdd__ = __webpack_require__(1987);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_656__PlaylistAdd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_656__PlaylistAdd__);
/* unused harmony reexport PlaylistAdd */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_657__PlaylistAddCheck__ = __webpack_require__(1988);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_657__PlaylistAddCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_657__PlaylistAddCheck__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_657__PlaylistAddCheck___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_658__PlaylistPlay__ = __webpack_require__(1989);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_658__PlaylistPlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_658__PlaylistPlay__);
/* unused harmony reexport PlaylistPlay */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_659__PlusOne__ = __webpack_require__(1990);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_659__PlusOne___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_659__PlusOne__);
/* unused harmony reexport PlusOne */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_660__Poll__ = __webpack_require__(1991);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_660__Poll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_660__Poll__);
/* unused harmony reexport Poll */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_661__Polymer__ = __webpack_require__(1992);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_661__Polymer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_661__Polymer__);
/* unused harmony reexport Polymer */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_662__Pool__ = __webpack_require__(1993);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_662__Pool___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_662__Pool__);
/* unused harmony reexport Pool */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_663__PortableWifiOff__ = __webpack_require__(1994);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_663__PortableWifiOff___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_663__PortableWifiOff__);
/* unused harmony reexport PortableWifiOff */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_664__Portrait__ = __webpack_require__(1995);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_664__Portrait___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_664__Portrait__);
/* unused harmony reexport Portrait */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_665__Power__ = __webpack_require__(1996);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_665__Power___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_665__Power__);
/* unused harmony reexport Power */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_666__PowerInput__ = __webpack_require__(1997);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_666__PowerInput___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_666__PowerInput__);
/* unused harmony reexport PowerInput */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_667__PowerSettingsNew__ = __webpack_require__(1998);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_667__PowerSettingsNew___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_667__PowerSettingsNew__);
/* unused harmony reexport PowerSettingsNew */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_668__PregnantWoman__ = __webpack_require__(1999);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_668__PregnantWoman___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_668__PregnantWoman__);
/* unused harmony reexport PregnantWoman */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_669__PresentToAll__ = __webpack_require__(2000);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_669__PresentToAll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_669__PresentToAll__);
/* unused harmony reexport PresentToAll */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_670__Print__ = __webpack_require__(2001);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_670__Print___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_670__Print__);
/* unused harmony reexport Print */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_671__PriorityHigh__ = __webpack_require__(2002);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_671__PriorityHigh___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_671__PriorityHigh__);
/* unused harmony reexport PriorityHigh */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_672__Public__ = __webpack_require__(2003);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_672__Public___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_672__Public__);
/* unused harmony reexport Public */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_673__Publish__ = __webpack_require__(2004);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_673__Publish___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_673__Publish__);
/* unused harmony reexport Publish */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_674__QueryBuilder__ = __webpack_require__(2005);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_674__QueryBuilder___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_674__QueryBuilder__);
/* unused harmony reexport QueryBuilder */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_675__QuestionAnswer__ = __webpack_require__(2006);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_675__QuestionAnswer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_675__QuestionAnswer__);
/* unused harmony reexport QuestionAnswer */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_676__Queue__ = __webpack_require__(2007);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_676__Queue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_676__Queue__);
/* unused harmony reexport Queue */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_677__QueueMusic__ = __webpack_require__(2008);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_677__QueueMusic___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_677__QueueMusic__);
/* unused harmony reexport QueueMusic */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_678__QueuePlayNext__ = __webpack_require__(2009);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_678__QueuePlayNext___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_678__QueuePlayNext__);
/* unused harmony reexport QueuePlayNext */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_679__Radio__ = __webpack_require__(2010);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_679__Radio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_679__Radio__);
/* unused harmony reexport Radio */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_680__RadioButtonChecked__ = __webpack_require__(2011);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_680__RadioButtonChecked___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_680__RadioButtonChecked__);
/* unused harmony reexport RadioButtonChecked */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_681__RadioButtonUnchecked__ = __webpack_require__(2012);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_681__RadioButtonUnchecked___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_681__RadioButtonUnchecked__);
/* unused harmony reexport RadioButtonUnchecked */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_682__RateReview__ = __webpack_require__(2013);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_682__RateReview___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_682__RateReview__);
/* unused harmony reexport RateReview */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_683__Receipt__ = __webpack_require__(2014);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_683__Receipt___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_683__Receipt__);
/* unused harmony reexport Receipt */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_684__RecentActors__ = __webpack_require__(2015);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_684__RecentActors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_684__RecentActors__);
/* unused harmony reexport RecentActors */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_685__RecordVoiceOver__ = __webpack_require__(2016);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_685__RecordVoiceOver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_685__RecordVoiceOver__);
/* unused harmony reexport RecordVoiceOver */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_686__Redeem__ = __webpack_require__(2017);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_686__Redeem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_686__Redeem__);
/* unused harmony reexport Redeem */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_687__Redo__ = __webpack_require__(2018);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_687__Redo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_687__Redo__);
/* unused harmony reexport Redo */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_688__Refresh__ = __webpack_require__(2019);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_688__Refresh___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_688__Refresh__);
/* unused harmony reexport Refresh */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_689__Remove__ = __webpack_require__(2020);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_689__Remove___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_689__Remove__);
/* unused harmony reexport Remove */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_690__RemoveCircle__ = __webpack_require__(2021);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_690__RemoveCircle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_690__RemoveCircle__);
/* unused harmony reexport RemoveCircle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_691__RemoveCircleOutline__ = __webpack_require__(2022);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_691__RemoveCircleOutline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_691__RemoveCircleOutline__);
/* unused harmony reexport RemoveCircleOutline */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_692__RemoveFromQueue__ = __webpack_require__(2023);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_692__RemoveFromQueue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_692__RemoveFromQueue__);
/* unused harmony reexport RemoveFromQueue */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_693__RemoveRedEye__ = __webpack_require__(2024);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_693__RemoveRedEye___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_693__RemoveRedEye__);
/* unused harmony reexport RemoveRedEye */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_694__RemoveShoppingCart__ = __webpack_require__(2025);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_694__RemoveShoppingCart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_694__RemoveShoppingCart__);
/* unused harmony reexport RemoveShoppingCart */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_695__Reorder__ = __webpack_require__(2026);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_695__Reorder___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_695__Reorder__);
/* unused harmony reexport Reorder */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_696__Repeat__ = __webpack_require__(2027);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_696__Repeat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_696__Repeat__);
/* unused harmony reexport Repeat */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_697__RepeatOne__ = __webpack_require__(2028);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_697__RepeatOne___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_697__RepeatOne__);
/* unused harmony reexport RepeatOne */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_698__Replay__ = __webpack_require__(2029);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_698__Replay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_698__Replay__);
/* unused harmony reexport Replay */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_699__Replay10__ = __webpack_require__(2030);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_699__Replay10___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_699__Replay10__);
/* unused harmony reexport Replay10 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_700__Replay30__ = __webpack_require__(2031);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_700__Replay30___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_700__Replay30__);
/* unused harmony reexport Replay30 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_701__Replay5__ = __webpack_require__(2032);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_701__Replay5___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_701__Replay5__);
/* unused harmony reexport Replay5 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_702__Reply__ = __webpack_require__(2033);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_702__Reply___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_702__Reply__);
/* unused harmony reexport Reply */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_703__ReplyAll__ = __webpack_require__(2034);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_703__ReplyAll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_703__ReplyAll__);
/* unused harmony reexport ReplyAll */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_704__Report__ = __webpack_require__(2035);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_704__Report___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_704__Report__);
/* unused harmony reexport Report */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_705__ReportProblem__ = __webpack_require__(2036);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_705__ReportProblem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_705__ReportProblem__);
/* unused harmony reexport ReportProblem */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_706__Restaurant__ = __webpack_require__(2037);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_706__Restaurant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_706__Restaurant__);
/* unused harmony reexport Restaurant */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_707__RestaurantMenu__ = __webpack_require__(2038);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_707__RestaurantMenu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_707__RestaurantMenu__);
/* unused harmony reexport RestaurantMenu */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_708__Restore__ = __webpack_require__(2039);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_708__Restore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_708__Restore__);
/* unused harmony reexport Restore */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_709__RestorePage__ = __webpack_require__(2040);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_709__RestorePage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_709__RestorePage__);
/* unused harmony reexport RestorePage */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_710__RingVolume__ = __webpack_require__(2041);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_710__RingVolume___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_710__RingVolume__);
/* unused harmony reexport RingVolume */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_711__Room__ = __webpack_require__(2042);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_711__Room___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_711__Room__);
/* unused harmony reexport Room */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_712__RoomService__ = __webpack_require__(2043);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_712__RoomService___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_712__RoomService__);
/* unused harmony reexport RoomService */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_713__Rotate90DegreesCcw__ = __webpack_require__(2044);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_713__Rotate90DegreesCcw___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_713__Rotate90DegreesCcw__);
/* unused harmony reexport Rotate90DegreesCcw */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_714__RotateLeft__ = __webpack_require__(2045);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_714__RotateLeft___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_714__RotateLeft__);
/* unused harmony reexport RotateLeft */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_715__RotateRight__ = __webpack_require__(2046);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_715__RotateRight___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_715__RotateRight__);
/* unused harmony reexport RotateRight */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_716__RoundedCorner__ = __webpack_require__(2047);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_716__RoundedCorner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_716__RoundedCorner__);
/* unused harmony reexport RoundedCorner */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_717__Router__ = __webpack_require__(2048);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_717__Router___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_717__Router__);
/* unused harmony reexport Router */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_718__Rowing__ = __webpack_require__(2049);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_718__Rowing___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_718__Rowing__);
/* unused harmony reexport Rowing */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_719__RssFeed__ = __webpack_require__(2050);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_719__RssFeed___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_719__RssFeed__);
/* unused harmony reexport RssFeed */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_720__RvHookup__ = __webpack_require__(2051);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_720__RvHookup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_720__RvHookup__);
/* unused harmony reexport RvHookup */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_721__Satellite__ = __webpack_require__(2052);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_721__Satellite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_721__Satellite__);
/* unused harmony reexport Satellite */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_722__Save__ = __webpack_require__(2053);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_722__Save___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_722__Save__);
/* unused harmony reexport Save */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_723__Scanner__ = __webpack_require__(2054);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_723__Scanner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_723__Scanner__);
/* unused harmony reexport Scanner */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_724__Schedule__ = __webpack_require__(2055);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_724__Schedule___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_724__Schedule__);
/* unused harmony reexport Schedule */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_725__School__ = __webpack_require__(2056);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_725__School___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_725__School__);
/* unused harmony reexport School */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_726__ScreenLockLandscape__ = __webpack_require__(2057);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_726__ScreenLockLandscape___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_726__ScreenLockLandscape__);
/* unused harmony reexport ScreenLockLandscape */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_727__ScreenLockPortrait__ = __webpack_require__(2058);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_727__ScreenLockPortrait___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_727__ScreenLockPortrait__);
/* unused harmony reexport ScreenLockPortrait */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_728__ScreenLockRotation__ = __webpack_require__(2059);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_728__ScreenLockRotation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_728__ScreenLockRotation__);
/* unused harmony reexport ScreenLockRotation */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_729__ScreenRotation__ = __webpack_require__(2060);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_729__ScreenRotation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_729__ScreenRotation__);
/* unused harmony reexport ScreenRotation */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_730__ScreenShare__ = __webpack_require__(2061);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_730__ScreenShare___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_730__ScreenShare__);
/* unused harmony reexport ScreenShare */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_731__SdCard__ = __webpack_require__(2062);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_731__SdCard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_731__SdCard__);
/* unused harmony reexport SdCard */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_732__SdStorage__ = __webpack_require__(2063);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_732__SdStorage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_732__SdStorage__);
/* unused harmony reexport SdStorage */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_733__Search__ = __webpack_require__(2064);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_733__Search___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_733__Search__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_733__Search___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_734__Security__ = __webpack_require__(2065);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_734__Security___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_734__Security__);
/* unused harmony reexport Security */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_735__SelectAll__ = __webpack_require__(2066);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_735__SelectAll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_735__SelectAll__);
/* unused harmony reexport SelectAll */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_736__Send__ = __webpack_require__(2067);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_736__Send___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_736__Send__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_736__Send___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_737__SentimentDissatisfied__ = __webpack_require__(2068);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_737__SentimentDissatisfied___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_737__SentimentDissatisfied__);
/* unused harmony reexport SentimentDissatisfied */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_738__SentimentNeutral__ = __webpack_require__(2069);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_738__SentimentNeutral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_738__SentimentNeutral__);
/* unused harmony reexport SentimentNeutral */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_739__SentimentSatisfied__ = __webpack_require__(2070);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_739__SentimentSatisfied___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_739__SentimentSatisfied__);
/* unused harmony reexport SentimentSatisfied */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_740__SentimentVeryDissatisfied__ = __webpack_require__(2071);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_740__SentimentVeryDissatisfied___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_740__SentimentVeryDissatisfied__);
/* unused harmony reexport SentimentVeryDissatisfied */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_741__SentimentVerySatisfied__ = __webpack_require__(2072);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_741__SentimentVerySatisfied___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_741__SentimentVerySatisfied__);
/* unused harmony reexport SentimentVerySatisfied */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_742__Settings__ = __webpack_require__(2073);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_742__Settings___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_742__Settings__);
/* unused harmony reexport Settings */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_743__SettingsApplications__ = __webpack_require__(2074);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_743__SettingsApplications___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_743__SettingsApplications__);
/* unused harmony reexport SettingsApplications */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_744__SettingsBackupRestore__ = __webpack_require__(2075);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_744__SettingsBackupRestore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_744__SettingsBackupRestore__);
/* unused harmony reexport SettingsBackupRestore */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_745__SettingsBluetooth__ = __webpack_require__(2076);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_745__SettingsBluetooth___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_745__SettingsBluetooth__);
/* unused harmony reexport SettingsBluetooth */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_746__SettingsBrightness__ = __webpack_require__(2077);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_746__SettingsBrightness___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_746__SettingsBrightness__);
/* unused harmony reexport SettingsBrightness */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_747__SettingsCell__ = __webpack_require__(2078);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_747__SettingsCell___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_747__SettingsCell__);
/* unused harmony reexport SettingsCell */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_748__SettingsEthernet__ = __webpack_require__(2079);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_748__SettingsEthernet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_748__SettingsEthernet__);
/* unused harmony reexport SettingsEthernet */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_749__SettingsInputAntenna__ = __webpack_require__(2080);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_749__SettingsInputAntenna___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_749__SettingsInputAntenna__);
/* unused harmony reexport SettingsInputAntenna */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_750__SettingsInputComponent__ = __webpack_require__(2081);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_750__SettingsInputComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_750__SettingsInputComponent__);
/* unused harmony reexport SettingsInputComponent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_751__SettingsInputComposite__ = __webpack_require__(2082);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_751__SettingsInputComposite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_751__SettingsInputComposite__);
/* unused harmony reexport SettingsInputComposite */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_752__SettingsInputHdmi__ = __webpack_require__(2083);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_752__SettingsInputHdmi___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_752__SettingsInputHdmi__);
/* unused harmony reexport SettingsInputHdmi */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_753__SettingsInputSvideo__ = __webpack_require__(2084);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_753__SettingsInputSvideo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_753__SettingsInputSvideo__);
/* unused harmony reexport SettingsInputSvideo */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_754__SettingsOverscan__ = __webpack_require__(2085);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_754__SettingsOverscan___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_754__SettingsOverscan__);
/* unused harmony reexport SettingsOverscan */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_755__SettingsPhone__ = __webpack_require__(2086);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_755__SettingsPhone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_755__SettingsPhone__);
/* unused harmony reexport SettingsPhone */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_756__SettingsPower__ = __webpack_require__(2087);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_756__SettingsPower___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_756__SettingsPower__);
/* unused harmony reexport SettingsPower */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_757__SettingsRemote__ = __webpack_require__(2088);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_757__SettingsRemote___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_757__SettingsRemote__);
/* unused harmony reexport SettingsRemote */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_758__SettingsSystemDaydream__ = __webpack_require__(2089);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_758__SettingsSystemDaydream___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_758__SettingsSystemDaydream__);
/* unused harmony reexport SettingsSystemDaydream */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_759__SettingsVoice__ = __webpack_require__(2090);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_759__SettingsVoice___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_759__SettingsVoice__);
/* unused harmony reexport SettingsVoice */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_760__Share__ = __webpack_require__(2091);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_760__Share___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_760__Share__);
/* unused harmony reexport Share */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_761__Shop__ = __webpack_require__(2092);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_761__Shop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_761__Shop__);
/* unused harmony reexport Shop */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_762__ShoppingBasket__ = __webpack_require__(2093);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_762__ShoppingBasket___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_762__ShoppingBasket__);
/* unused harmony reexport ShoppingBasket */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_763__ShoppingCart__ = __webpack_require__(2094);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_763__ShoppingCart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_763__ShoppingCart__);
/* unused harmony reexport ShoppingCart */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_764__ShopTwo__ = __webpack_require__(2095);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_764__ShopTwo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_764__ShopTwo__);
/* unused harmony reexport ShopTwo */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_765__ShortText__ = __webpack_require__(2096);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_765__ShortText___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_765__ShortText__);
/* unused harmony reexport ShortText */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_766__ShowChart__ = __webpack_require__(2097);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_766__ShowChart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_766__ShowChart__);
/* unused harmony reexport ShowChart */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_767__Shuffle__ = __webpack_require__(2098);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_767__Shuffle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_767__Shuffle__);
/* unused harmony reexport Shuffle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_768__SignalCellular0Bar__ = __webpack_require__(2099);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_768__SignalCellular0Bar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_768__SignalCellular0Bar__);
/* unused harmony reexport SignalCellular0Bar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_769__SignalCellular1Bar__ = __webpack_require__(2100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_769__SignalCellular1Bar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_769__SignalCellular1Bar__);
/* unused harmony reexport SignalCellular1Bar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_770__SignalCellular2Bar__ = __webpack_require__(2101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_770__SignalCellular2Bar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_770__SignalCellular2Bar__);
/* unused harmony reexport SignalCellular2Bar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_771__SignalCellular3Bar__ = __webpack_require__(2102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_771__SignalCellular3Bar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_771__SignalCellular3Bar__);
/* unused harmony reexport SignalCellular3Bar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_772__SignalCellular4Bar__ = __webpack_require__(2103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_772__SignalCellular4Bar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_772__SignalCellular4Bar__);
/* unused harmony reexport SignalCellular4Bar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_773__SignalCellularConnectedNoInternet0Bar__ = __webpack_require__(2104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_773__SignalCellularConnectedNoInternet0Bar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_773__SignalCellularConnectedNoInternet0Bar__);
/* unused harmony reexport SignalCellularConnectedNoInternet0Bar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_774__SignalCellularConnectedNoInternet1Bar__ = __webpack_require__(2105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_774__SignalCellularConnectedNoInternet1Bar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_774__SignalCellularConnectedNoInternet1Bar__);
/* unused harmony reexport SignalCellularConnectedNoInternet1Bar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_775__SignalCellularConnectedNoInternet2Bar__ = __webpack_require__(2106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_775__SignalCellularConnectedNoInternet2Bar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_775__SignalCellularConnectedNoInternet2Bar__);
/* unused harmony reexport SignalCellularConnectedNoInternet2Bar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_776__SignalCellularConnectedNoInternet3Bar__ = __webpack_require__(2107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_776__SignalCellularConnectedNoInternet3Bar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_776__SignalCellularConnectedNoInternet3Bar__);
/* unused harmony reexport SignalCellularConnectedNoInternet3Bar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_777__SignalCellularConnectedNoInternet4Bar__ = __webpack_require__(2108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_777__SignalCellularConnectedNoInternet4Bar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_777__SignalCellularConnectedNoInternet4Bar__);
/* unused harmony reexport SignalCellularConnectedNoInternet4Bar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_778__SignalCellularNoSim__ = __webpack_require__(2109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_778__SignalCellularNoSim___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_778__SignalCellularNoSim__);
/* unused harmony reexport SignalCellularNoSim */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_779__SignalCellularNull__ = __webpack_require__(2110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_779__SignalCellularNull___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_779__SignalCellularNull__);
/* unused harmony reexport SignalCellularNull */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_780__SignalCellularOff__ = __webpack_require__(2111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_780__SignalCellularOff___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_780__SignalCellularOff__);
/* unused harmony reexport SignalCellularOff */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_781__SignalWifi0Bar__ = __webpack_require__(2112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_781__SignalWifi0Bar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_781__SignalWifi0Bar__);
/* unused harmony reexport SignalWifi0Bar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_782__SignalWifi1Bar__ = __webpack_require__(2113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_782__SignalWifi1Bar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_782__SignalWifi1Bar__);
/* unused harmony reexport SignalWifi1Bar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_783__SignalWifi1BarLock__ = __webpack_require__(2114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_783__SignalWifi1BarLock___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_783__SignalWifi1BarLock__);
/* unused harmony reexport SignalWifi1BarLock */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_784__SignalWifi2Bar__ = __webpack_require__(2115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_784__SignalWifi2Bar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_784__SignalWifi2Bar__);
/* unused harmony reexport SignalWifi2Bar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_785__SignalWifi2BarLock__ = __webpack_require__(2116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_785__SignalWifi2BarLock___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_785__SignalWifi2BarLock__);
/* unused harmony reexport SignalWifi2BarLock */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_786__SignalWifi3Bar__ = __webpack_require__(2117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_786__SignalWifi3Bar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_786__SignalWifi3Bar__);
/* unused harmony reexport SignalWifi3Bar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_787__SignalWifi3BarLock__ = __webpack_require__(2118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_787__SignalWifi3BarLock___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_787__SignalWifi3BarLock__);
/* unused harmony reexport SignalWifi3BarLock */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_788__SignalWifi4Bar__ = __webpack_require__(2119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_788__SignalWifi4Bar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_788__SignalWifi4Bar__);
/* unused harmony reexport SignalWifi4Bar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_789__SignalWifi4BarLock__ = __webpack_require__(2120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_789__SignalWifi4BarLock___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_789__SignalWifi4BarLock__);
/* unused harmony reexport SignalWifi4BarLock */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_790__SignalWifiOff__ = __webpack_require__(2121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_790__SignalWifiOff___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_790__SignalWifiOff__);
/* unused harmony reexport SignalWifiOff */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_791__SimCard__ = __webpack_require__(2122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_791__SimCard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_791__SimCard__);
/* unused harmony reexport SimCard */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_792__SimCardAlert__ = __webpack_require__(2123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_792__SimCardAlert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_792__SimCardAlert__);
/* unused harmony reexport SimCardAlert */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_793__SkipNext__ = __webpack_require__(2124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_793__SkipNext___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_793__SkipNext__);
/* unused harmony reexport SkipNext */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_794__SkipPrevious__ = __webpack_require__(2125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_794__SkipPrevious___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_794__SkipPrevious__);
/* unused harmony reexport SkipPrevious */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_795__Slideshow__ = __webpack_require__(2126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_795__Slideshow___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_795__Slideshow__);
/* unused harmony reexport Slideshow */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_796__SlowMotionVideo__ = __webpack_require__(2127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_796__SlowMotionVideo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_796__SlowMotionVideo__);
/* unused harmony reexport SlowMotionVideo */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_797__Smartphone__ = __webpack_require__(2128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_797__Smartphone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_797__Smartphone__);
/* unused harmony reexport Smartphone */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_798__SmokeFree__ = __webpack_require__(2129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_798__SmokeFree___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_798__SmokeFree__);
/* unused harmony reexport SmokeFree */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_799__SmokingRooms__ = __webpack_require__(2130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_799__SmokingRooms___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_799__SmokingRooms__);
/* unused harmony reexport SmokingRooms */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_800__Sms__ = __webpack_require__(2131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_800__Sms___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_800__Sms__);
/* unused harmony reexport Sms */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_801__SmsFailed__ = __webpack_require__(2132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_801__SmsFailed___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_801__SmsFailed__);
/* unused harmony reexport SmsFailed */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_802__Snooze__ = __webpack_require__(2133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_802__Snooze___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_802__Snooze__);
/* unused harmony reexport Snooze */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_803__Sort__ = __webpack_require__(2134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_803__Sort___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_803__Sort__);
/* unused harmony reexport Sort */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_804__SortByAlpha__ = __webpack_require__(2135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_804__SortByAlpha___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_804__SortByAlpha__);
/* unused harmony reexport SortByAlpha */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_805__Spa__ = __webpack_require__(2136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_805__Spa___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_805__Spa__);
/* unused harmony reexport Spa */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_806__SpaceBar__ = __webpack_require__(2137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_806__SpaceBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_806__SpaceBar__);
/* unused harmony reexport SpaceBar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_807__Speaker__ = __webpack_require__(2138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_807__Speaker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_807__Speaker__);
/* unused harmony reexport Speaker */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_808__SpeakerGroup__ = __webpack_require__(2139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_808__SpeakerGroup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_808__SpeakerGroup__);
/* unused harmony reexport SpeakerGroup */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_809__SpeakerNotes__ = __webpack_require__(2140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_809__SpeakerNotes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_809__SpeakerNotes__);
/* unused harmony reexport SpeakerNotes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_810__SpeakerNotesOff__ = __webpack_require__(2141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_810__SpeakerNotesOff___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_810__SpeakerNotesOff__);
/* unused harmony reexport SpeakerNotesOff */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_811__SpeakerPhone__ = __webpack_require__(2142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_811__SpeakerPhone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_811__SpeakerPhone__);
/* unused harmony reexport SpeakerPhone */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_812__Spellcheck__ = __webpack_require__(2143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_812__Spellcheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_812__Spellcheck__);
/* unused harmony reexport Spellcheck */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_813__Star__ = __webpack_require__(2144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_813__Star___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_813__Star__);
/* unused harmony reexport Star */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_814__StarBorder__ = __webpack_require__(2145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_814__StarBorder___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_814__StarBorder__);
/* unused harmony reexport StarBorder */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_815__StarHalf__ = __webpack_require__(2146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_815__StarHalf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_815__StarHalf__);
/* unused harmony reexport StarHalf */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_816__Stars__ = __webpack_require__(2147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_816__Stars___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_816__Stars__);
/* unused harmony reexport Stars */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_817__StayCurrentLandscape__ = __webpack_require__(2148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_817__StayCurrentLandscape___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_817__StayCurrentLandscape__);
/* unused harmony reexport StayCurrentLandscape */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_818__StayCurrentPortrait__ = __webpack_require__(2149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_818__StayCurrentPortrait___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_818__StayCurrentPortrait__);
/* unused harmony reexport StayCurrentPortrait */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_819__StayPrimaryLandscape__ = __webpack_require__(2150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_819__StayPrimaryLandscape___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_819__StayPrimaryLandscape__);
/* unused harmony reexport StayPrimaryLandscape */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_820__StayPrimaryPortrait__ = __webpack_require__(2151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_820__StayPrimaryPortrait___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_820__StayPrimaryPortrait__);
/* unused harmony reexport StayPrimaryPortrait */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_821__Stop__ = __webpack_require__(2152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_821__Stop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_821__Stop__);
/* unused harmony reexport Stop */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_822__StopScreenShare__ = __webpack_require__(2153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_822__StopScreenShare___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_822__StopScreenShare__);
/* unused harmony reexport StopScreenShare */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_823__Storage__ = __webpack_require__(2154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_823__Storage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_823__Storage__);
/* unused harmony reexport Storage */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_824__Store__ = __webpack_require__(2155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_824__Store___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_824__Store__);
/* unused harmony reexport Store */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_825__StoreMallDirectory__ = __webpack_require__(2156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_825__StoreMallDirectory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_825__StoreMallDirectory__);
/* unused harmony reexport StoreMallDirectory */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_826__Straighten__ = __webpack_require__(2157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_826__Straighten___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_826__Straighten__);
/* unused harmony reexport Straighten */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_827__Streetview__ = __webpack_require__(2158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_827__Streetview___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_827__Streetview__);
/* unused harmony reexport Streetview */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_828__StrikethroughS__ = __webpack_require__(2159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_828__StrikethroughS___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_828__StrikethroughS__);
/* unused harmony reexport StrikethroughS */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_829__Style__ = __webpack_require__(2160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_829__Style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_829__Style__);
/* unused harmony reexport Style */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_830__SubdirectoryArrowLeft__ = __webpack_require__(2161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_830__SubdirectoryArrowLeft___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_830__SubdirectoryArrowLeft__);
/* unused harmony reexport SubdirectoryArrowLeft */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_831__SubdirectoryArrowRight__ = __webpack_require__(2162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_831__SubdirectoryArrowRight___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_831__SubdirectoryArrowRight__);
/* unused harmony reexport SubdirectoryArrowRight */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_832__Subject__ = __webpack_require__(2163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_832__Subject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_832__Subject__);
/* unused harmony reexport Subject */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_833__Subscriptions__ = __webpack_require__(2164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_833__Subscriptions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_833__Subscriptions__);
/* unused harmony reexport Subscriptions */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_834__Subtitles__ = __webpack_require__(2165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_834__Subtitles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_834__Subtitles__);
/* unused harmony reexport Subtitles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_835__Subway__ = __webpack_require__(2166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_835__Subway___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_835__Subway__);
/* unused harmony reexport Subway */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_836__SupervisorAccount__ = __webpack_require__(2167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_836__SupervisorAccount___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_836__SupervisorAccount__);
/* unused harmony reexport SupervisorAccount */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_837__SurroundSound__ = __webpack_require__(2168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_837__SurroundSound___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_837__SurroundSound__);
/* unused harmony reexport SurroundSound */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_838__SwapCalls__ = __webpack_require__(2169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_838__SwapCalls___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_838__SwapCalls__);
/* unused harmony reexport SwapCalls */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_839__SwapHoriz__ = __webpack_require__(2170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_839__SwapHoriz___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_839__SwapHoriz__);
/* unused harmony reexport SwapHoriz */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_840__SwapVert__ = __webpack_require__(2171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_840__SwapVert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_840__SwapVert__);
/* unused harmony reexport SwapVert */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_841__SwapVerticalCircle__ = __webpack_require__(2172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_841__SwapVerticalCircle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_841__SwapVerticalCircle__);
/* unused harmony reexport SwapVerticalCircle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_842__SwitchCamera__ = __webpack_require__(2173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_842__SwitchCamera___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_842__SwitchCamera__);
/* unused harmony reexport SwitchCamera */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_843__SwitchVideo__ = __webpack_require__(2174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_843__SwitchVideo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_843__SwitchVideo__);
/* unused harmony reexport SwitchVideo */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_844__Sync__ = __webpack_require__(2175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_844__Sync___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_844__Sync__);
/* unused harmony reexport Sync */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_845__SyncDisabled__ = __webpack_require__(2176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_845__SyncDisabled___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_845__SyncDisabled__);
/* unused harmony reexport SyncDisabled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_846__SyncProblem__ = __webpack_require__(2177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_846__SyncProblem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_846__SyncProblem__);
/* unused harmony reexport SyncProblem */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_847__SystemUpdate__ = __webpack_require__(2178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_847__SystemUpdate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_847__SystemUpdate__);
/* unused harmony reexport SystemUpdate */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_848__SystemUpdateAlt__ = __webpack_require__(2179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_848__SystemUpdateAlt___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_848__SystemUpdateAlt__);
/* unused harmony reexport SystemUpdateAlt */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_849__Tab__ = __webpack_require__(2180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_849__Tab___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_849__Tab__);
/* unused harmony reexport Tab */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_850__Tablet__ = __webpack_require__(2181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_850__Tablet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_850__Tablet__);
/* unused harmony reexport Tablet */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_851__TabletAndroid__ = __webpack_require__(2182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_851__TabletAndroid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_851__TabletAndroid__);
/* unused harmony reexport TabletAndroid */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_852__TabletMac__ = __webpack_require__(2183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_852__TabletMac___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_852__TabletMac__);
/* unused harmony reexport TabletMac */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_853__TabUnselected__ = __webpack_require__(2184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_853__TabUnselected___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_853__TabUnselected__);
/* unused harmony reexport TabUnselected */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_854__TagFaces__ = __webpack_require__(2185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_854__TagFaces___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_854__TagFaces__);
/* unused harmony reexport TagFaces */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_855__TapAndPlay__ = __webpack_require__(2186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_855__TapAndPlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_855__TapAndPlay__);
/* unused harmony reexport TapAndPlay */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_856__Terrain__ = __webpack_require__(2187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_856__Terrain___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_856__Terrain__);
/* unused harmony reexport Terrain */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_857__TextFields__ = __webpack_require__(2188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_857__TextFields___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_857__TextFields__);
/* unused harmony reexport TextFields */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_858__TextFormat__ = __webpack_require__(2189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_858__TextFormat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_858__TextFormat__);
/* unused harmony reexport TextFormat */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_859__Textsms__ = __webpack_require__(2190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_859__Textsms___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_859__Textsms__);
/* unused harmony reexport Textsms */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_860__Texture__ = __webpack_require__(2191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_860__Texture___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_860__Texture__);
/* unused harmony reexport Texture */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_861__Theaters__ = __webpack_require__(2192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_861__Theaters___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_861__Theaters__);
/* unused harmony reexport Theaters */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_862__ThreeDRotation__ = __webpack_require__(2193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_862__ThreeDRotation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_862__ThreeDRotation__);
/* unused harmony reexport ThreeDRotation */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_863__ThumbDown__ = __webpack_require__(2194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_863__ThumbDown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_863__ThumbDown__);
/* unused harmony reexport ThumbDown */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_864__ThumbsUpDown__ = __webpack_require__(2195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_864__ThumbsUpDown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_864__ThumbsUpDown__);
/* unused harmony reexport ThumbsUpDown */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_865__ThumbUp__ = __webpack_require__(2196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_865__ThumbUp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_865__ThumbUp__);
/* unused harmony reexport ThumbUp */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_866__Timelapse__ = __webpack_require__(2197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_866__Timelapse___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_866__Timelapse__);
/* unused harmony reexport Timelapse */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_867__Timeline__ = __webpack_require__(2198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_867__Timeline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_867__Timeline__);
/* unused harmony reexport Timeline */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_868__Timer__ = __webpack_require__(2199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_868__Timer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_868__Timer__);
/* unused harmony reexport Timer */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_869__Timer10__ = __webpack_require__(2200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_869__Timer10___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_869__Timer10__);
/* unused harmony reexport Timer10 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_870__Timer3__ = __webpack_require__(2201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_870__Timer3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_870__Timer3__);
/* unused harmony reexport Timer3 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_871__TimerOff__ = __webpack_require__(2202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_871__TimerOff___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_871__TimerOff__);
/* unused harmony reexport TimerOff */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_872__TimeToLeave__ = __webpack_require__(2203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_872__TimeToLeave___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_872__TimeToLeave__);
/* unused harmony reexport TimeToLeave */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_873__Title__ = __webpack_require__(2204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_873__Title___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_873__Title__);
/* unused harmony reexport Title */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_874__Toc__ = __webpack_require__(2205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_874__Toc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_874__Toc__);
/* unused harmony reexport Toc */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_875__Today__ = __webpack_require__(2206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_875__Today___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_875__Today__);
/* unused harmony reexport Today */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_876__Toll__ = __webpack_require__(2207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_876__Toll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_876__Toll__);
/* unused harmony reexport Toll */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_877__Tonality__ = __webpack_require__(2208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_877__Tonality___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_877__Tonality__);
/* unused harmony reexport Tonality */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_878__TouchApp__ = __webpack_require__(2209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_878__TouchApp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_878__TouchApp__);
/* unused harmony reexport TouchApp */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_879__Toys__ = __webpack_require__(2210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_879__Toys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_879__Toys__);
/* unused harmony reexport Toys */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_880__TrackChanges__ = __webpack_require__(2211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_880__TrackChanges___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_880__TrackChanges__);
/* unused harmony reexport TrackChanges */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_881__Traffic__ = __webpack_require__(2212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_881__Traffic___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_881__Traffic__);
/* unused harmony reexport Traffic */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_882__Train__ = __webpack_require__(2213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_882__Train___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_882__Train__);
/* unused harmony reexport Train */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_883__Tram__ = __webpack_require__(2214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_883__Tram___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_883__Tram__);
/* unused harmony reexport Tram */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_884__TransferWithinAStation__ = __webpack_require__(2215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_884__TransferWithinAStation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_884__TransferWithinAStation__);
/* unused harmony reexport TransferWithinAStation */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_885__Transform__ = __webpack_require__(2216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_885__Transform___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_885__Transform__);
/* unused harmony reexport Transform */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_886__Translate__ = __webpack_require__(2217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_886__Translate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_886__Translate__);
/* unused harmony reexport Translate */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_887__TrendingDown__ = __webpack_require__(2218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_887__TrendingDown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_887__TrendingDown__);
/* unused harmony reexport TrendingDown */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_888__TrendingFlat__ = __webpack_require__(2219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_888__TrendingFlat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_888__TrendingFlat__);
/* unused harmony reexport TrendingFlat */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_889__TrendingUp__ = __webpack_require__(2220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_889__TrendingUp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_889__TrendingUp__);
/* unused harmony reexport TrendingUp */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_890__Tune__ = __webpack_require__(2221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_890__Tune___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_890__Tune__);
/* unused harmony reexport Tune */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_891__TurnedIn__ = __webpack_require__(2222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_891__TurnedIn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_891__TurnedIn__);
/* unused harmony reexport TurnedIn */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_892__TurnedInNot__ = __webpack_require__(2223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_892__TurnedInNot___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_892__TurnedInNot__);
/* unused harmony reexport TurnedInNot */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_893__Tv__ = __webpack_require__(2224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_893__Tv___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_893__Tv__);
/* unused harmony reexport Tv */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_894__Unarchive__ = __webpack_require__(2225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_894__Unarchive___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_894__Unarchive__);
/* unused harmony reexport Unarchive */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_895__Undo__ = __webpack_require__(2226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_895__Undo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_895__Undo__);
/* unused harmony reexport Undo */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_896__UnfoldLess__ = __webpack_require__(2227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_896__UnfoldLess___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_896__UnfoldLess__);
/* unused harmony reexport UnfoldLess */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_897__UnfoldMore__ = __webpack_require__(2228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_897__UnfoldMore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_897__UnfoldMore__);
/* unused harmony reexport UnfoldMore */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_898__Update__ = __webpack_require__(2229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_898__Update___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_898__Update__);
/* unused harmony reexport Update */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_899__Usb__ = __webpack_require__(2230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_899__Usb___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_899__Usb__);
/* unused harmony reexport Usb */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_900__VerifiedUser__ = __webpack_require__(2231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_900__VerifiedUser___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_900__VerifiedUser__);
/* unused harmony reexport VerifiedUser */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_901__VerticalAlignBottom__ = __webpack_require__(2232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_901__VerticalAlignBottom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_901__VerticalAlignBottom__);
/* unused harmony reexport VerticalAlignBottom */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_902__VerticalAlignCenter__ = __webpack_require__(2233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_902__VerticalAlignCenter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_902__VerticalAlignCenter__);
/* unused harmony reexport VerticalAlignCenter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_903__VerticalAlignTop__ = __webpack_require__(2234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_903__VerticalAlignTop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_903__VerticalAlignTop__);
/* unused harmony reexport VerticalAlignTop */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_904__Vibration__ = __webpack_require__(2235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_904__Vibration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_904__Vibration__);
/* unused harmony reexport Vibration */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_905__VideoCall__ = __webpack_require__(2236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_905__VideoCall___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_905__VideoCall__);
/* unused harmony reexport VideoCall */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_906__Videocam__ = __webpack_require__(2237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_906__Videocam___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_906__Videocam__);
/* unused harmony reexport Videocam */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_907__VideocamOff__ = __webpack_require__(2238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_907__VideocamOff___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_907__VideocamOff__);
/* unused harmony reexport VideocamOff */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_908__VideogameAsset__ = __webpack_require__(2239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_908__VideogameAsset___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_908__VideogameAsset__);
/* unused harmony reexport VideogameAsset */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_909__VideoLabel__ = __webpack_require__(2240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_909__VideoLabel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_909__VideoLabel__);
/* unused harmony reexport VideoLabel */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_910__VideoLibrary__ = __webpack_require__(2241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_910__VideoLibrary___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_910__VideoLibrary__);
/* unused harmony reexport VideoLibrary */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_911__ViewAgenda__ = __webpack_require__(2242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_911__ViewAgenda___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_911__ViewAgenda__);
/* unused harmony reexport ViewAgenda */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_912__ViewArray__ = __webpack_require__(2243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_912__ViewArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_912__ViewArray__);
/* unused harmony reexport ViewArray */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_913__ViewCarousel__ = __webpack_require__(2244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_913__ViewCarousel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_913__ViewCarousel__);
/* unused harmony reexport ViewCarousel */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_914__ViewColumn__ = __webpack_require__(2245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_914__ViewColumn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_914__ViewColumn__);
/* unused harmony reexport ViewColumn */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_915__ViewComfy__ = __webpack_require__(2246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_915__ViewComfy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_915__ViewComfy__);
/* unused harmony reexport ViewComfy */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_916__ViewCompact__ = __webpack_require__(2247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_916__ViewCompact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_916__ViewCompact__);
/* unused harmony reexport ViewCompact */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_917__ViewDay__ = __webpack_require__(2248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_917__ViewDay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_917__ViewDay__);
/* unused harmony reexport ViewDay */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_918__ViewHeadline__ = __webpack_require__(2249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_918__ViewHeadline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_918__ViewHeadline__);
/* unused harmony reexport ViewHeadline */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_919__ViewList__ = __webpack_require__(2250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_919__ViewList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_919__ViewList__);
/* unused harmony reexport ViewList */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_920__ViewModule__ = __webpack_require__(2251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_920__ViewModule___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_920__ViewModule__);
/* unused harmony reexport ViewModule */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_921__ViewQuilt__ = __webpack_require__(2252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_921__ViewQuilt___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_921__ViewQuilt__);
/* unused harmony reexport ViewQuilt */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_922__ViewStream__ = __webpack_require__(2253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_922__ViewStream___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_922__ViewStream__);
/* unused harmony reexport ViewStream */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_923__ViewWeek__ = __webpack_require__(2254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_923__ViewWeek___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_923__ViewWeek__);
/* unused harmony reexport ViewWeek */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_924__Vignette__ = __webpack_require__(2255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_924__Vignette___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_924__Vignette__);
/* unused harmony reexport Vignette */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_925__Visibility__ = __webpack_require__(516);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_925__Visibility___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_925__Visibility__);
/* unused harmony reexport Visibility */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_926__VisibilityOff__ = __webpack_require__(517);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_926__VisibilityOff___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_926__VisibilityOff__);
/* unused harmony reexport VisibilityOff */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_927__VoiceChat__ = __webpack_require__(2256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_927__VoiceChat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_927__VoiceChat__);
/* unused harmony reexport VoiceChat */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_928__Voicemail__ = __webpack_require__(2257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_928__Voicemail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_928__Voicemail__);
/* unused harmony reexport Voicemail */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_929__VolumeDown__ = __webpack_require__(2258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_929__VolumeDown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_929__VolumeDown__);
/* unused harmony reexport VolumeDown */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_930__VolumeMute__ = __webpack_require__(2259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_930__VolumeMute___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_930__VolumeMute__);
/* unused harmony reexport VolumeMute */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_931__VolumeOff__ = __webpack_require__(2260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_931__VolumeOff___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_931__VolumeOff__);
/* unused harmony reexport VolumeOff */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_932__VolumeUp__ = __webpack_require__(2261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_932__VolumeUp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_932__VolumeUp__);
/* unused harmony reexport VolumeUp */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_933__VpnKey__ = __webpack_require__(2262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_933__VpnKey___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_933__VpnKey__);
/* unused harmony reexport VpnKey */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_934__VpnLock__ = __webpack_require__(2263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_934__VpnLock___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_934__VpnLock__);
/* unused harmony reexport VpnLock */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_935__Wallpaper__ = __webpack_require__(2264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_935__Wallpaper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_935__Wallpaper__);
/* unused harmony reexport Wallpaper */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_936__Warning__ = __webpack_require__(2265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_936__Warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_936__Warning__);
/* unused harmony reexport Warning */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_937__Watch__ = __webpack_require__(2266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_937__Watch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_937__Watch__);
/* unused harmony reexport Watch */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_938__WatchLater__ = __webpack_require__(2267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_938__WatchLater___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_938__WatchLater__);
/* unused harmony reexport WatchLater */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_939__WbAuto__ = __webpack_require__(2268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_939__WbAuto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_939__WbAuto__);
/* unused harmony reexport WbAuto */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_940__WbCloudy__ = __webpack_require__(2269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_940__WbCloudy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_940__WbCloudy__);
/* unused harmony reexport WbCloudy */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_941__WbIncandescent__ = __webpack_require__(2270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_941__WbIncandescent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_941__WbIncandescent__);
/* unused harmony reexport WbIncandescent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_942__WbIridescent__ = __webpack_require__(2271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_942__WbIridescent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_942__WbIridescent__);
/* unused harmony reexport WbIridescent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_943__WbSunny__ = __webpack_require__(2272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_943__WbSunny___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_943__WbSunny__);
/* unused harmony reexport WbSunny */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_944__Wc__ = __webpack_require__(2273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_944__Wc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_944__Wc__);
/* unused harmony reexport Wc */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_945__Web__ = __webpack_require__(2274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_945__Web___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_945__Web__);
/* unused harmony reexport Web */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_946__WebAsset__ = __webpack_require__(2275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_946__WebAsset___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_946__WebAsset__);
/* unused harmony reexport WebAsset */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_947__Weekend__ = __webpack_require__(2276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_947__Weekend___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_947__Weekend__);
/* unused harmony reexport Weekend */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_948__Whatshot__ = __webpack_require__(2277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_948__Whatshot___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_948__Whatshot__);
/* unused harmony reexport Whatshot */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_949__Widgets__ = __webpack_require__(2278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_949__Widgets___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_949__Widgets__);
/* unused harmony reexport Widgets */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_950__Wifi__ = __webpack_require__(2279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_950__Wifi___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_950__Wifi__);
/* unused harmony reexport Wifi */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_951__WifiLock__ = __webpack_require__(2280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_951__WifiLock___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_951__WifiLock__);
/* unused harmony reexport WifiLock */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_952__WifiTethering__ = __webpack_require__(2281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_952__WifiTethering___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_952__WifiTethering__);
/* unused harmony reexport WifiTethering */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_953__Work__ = __webpack_require__(2282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_953__Work___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_953__Work__);
/* unused harmony reexport Work */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_954__WrapText__ = __webpack_require__(2283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_954__WrapText___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_954__WrapText__);
/* unused harmony reexport WrapText */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_955__YoutubeSearchedFor__ = __webpack_require__(2284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_955__YoutubeSearchedFor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_955__YoutubeSearchedFor__);
/* unused harmony reexport YoutubeSearchedFor */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_956__ZoomIn__ = __webpack_require__(2285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_956__ZoomIn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_956__ZoomIn__);
/* unused harmony reexport ZoomIn */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_957__ZoomOut__ = __webpack_require__(2286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_957__ZoomOut___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_957__ZoomOut__);
/* unused harmony reexport ZoomOut */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_958__ZoomOutMap__ = __webpack_require__(2287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_958__ZoomOutMap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_958__ZoomOutMap__);
/* unused harmony reexport ZoomOutMap */
/** @license Material-UI v1.1.0
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = DateTimeFormatter;
/* harmony export (immutable) */ __webpack_exports__["c"] = ParseYMDwDash;
/* harmony export (immutable) */ __webpack_exports__["b"] = ParseDMYwSlashes;
/* harmony export (immutable) */ __webpack_exports__["d"] = calcDiffInDays;
/* harmony export (immutable) */ __webpack_exports__["e"] = createCustomDateString1;
/* harmony export (immutable) */ __webpack_exports__["f"] = validateDateRange;
function DateTimeFormatter(dateStr){dateStr=dateStr.replace(","," ");var date=dateStr.split(" ")[0];var items=date.split("/");items.map(function(item,i){if(item.length===1){items[i]="0"+items[i];}return item;});return items.join("/");}function ParseYMDwDash(dateString){dateString=dateString.split("T")[0];var dateItems=dateString.split("-");var formattedDate=dateItems[2]+"/"+dateItems[1]+"/"+dateItems[0];return formattedDate;}function ParseDMYwSlashes(dateString){var dateItems=dateString.split("/");var formattedDate=dateItems[2]+"-"+dateItems[1]+"-"+dateItems[0];var finalDate=new Date(formattedDate);return finalDate;}function calcDiffInDays(date1,date2){var timeDiff=Math.abs(date2.getTime()-date1.getTime());var diffDays=Math.ceil(timeDiff/(1000*3600*24));return diffDays;}function createCustomDateString1(){var now=new Date();return now.getDate()+"/"+now.getMonth()+"/"+now.getFullYear()+" "+now.getHours()+":"+now.getMinutes()+":"+now.getSeconds();}function validateDateRange(date1,date2){//will return false if date2 is smaller than date1
var parsed1=ParseDMYwSlashes(date1);var parsed2=ParseDMYwSlashes(date2);if(parsed1.toString().includes("Invalid Date")||parsed2.toString().includes("Invalid Date")){return false;}return date2>date1;}

/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ParseUriParams; });
var splitAt=function splitAt(index,x){return[x.slice(0,index).join(""),x.slice(index).join("")];};var ParseUriParams=function ParseUriParams(UriString){UriString=UriString.replace("?","");var params=UriString.split("&");var keyvalues={};for(var i=0;i<params.length;i++){var p=params[i];if(!isEmptyOrSpaces(p)){var psplit=p.split("");var eqIndex=psplit.indexOf("=");var arr=splitAt(eqIndex,psplit);var key=arr[0];var value=arr[1].replace("=","");if(!isEmptyOrSpaces(value)){keyvalues[key]=value.toString().replace(/%20/g," ");}}}return keyvalues;};function isEmptyOrSpaces(str){return str===undefined||str===null||str.match(/^ *$/)!==null;}

/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__accessors_define_accessors__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_observers_mixin__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__matrix__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__to_matrix__ = __webpack_require__(119);







var Point = (function (Class) {
    function Point(x, y) {
        Class.call(this);

        this.x = x || 0;
        this.y = y || 0;
    }

    if ( Class ) Point.__proto__ = Class;
    Point.prototype = Object.create( Class && Class.prototype );
    Point.prototype.constructor = Point;

    var staticAccessors = { ZERO: { configurable: true } };

    Point.prototype.equals = function equals (other) {
        return other && other.x === this.x && other.y === this.y;
    };

    Point.prototype.clone = function clone () {
        return new Point(this.x, this.y);
    };

    Point.prototype.rotate = function rotate (angle, origin) {
        var originPoint = Point.create(origin) || Point.ZERO;

        return this.transform(__WEBPACK_IMPORTED_MODULE_4__matrix__["a" /* default */].rotate(angle, originPoint.x, originPoint.y));
    };

    Point.prototype.translate = function translate (x, y) {
        this.x += x;
        this.y += y;

        this.geometryChange();

        return this;
    };

    Point.prototype.translateWith = function translateWith (point) {
        return this.translate(point.x, point.y);
    };

    Point.prototype.move = function move (x, y) {
        this.x = this.y = 0;
        return this.translate(x, y);
    };

    Point.prototype.scale = function scale (scaleX, scaleY) {
        if ( scaleY === void 0 ) scaleY = scaleX;

        this.x *= scaleX;
        this.y *= scaleY;

        this.geometryChange();

        return this;
    };

    Point.prototype.scaleCopy = function scaleCopy (scaleX, scaleY) {
        return this.clone().scale(scaleX, scaleY);
    };

    Point.prototype.transform = function transform (transformation) {
        var matrix = Object(__WEBPACK_IMPORTED_MODULE_5__to_matrix__["a" /* default */])(transformation);
        var ref = this;
        var x = ref.x;
        var y = ref.y;

        this.x = matrix.a * x + matrix.c * y + matrix.e;
        this.y = matrix.b * x + matrix.d * y + matrix.f;

        this.geometryChange();

        return this;
    };

    Point.prototype.transformCopy = function transformCopy (transformation) {
        var point = this.clone();

        if (transformation) {
            point.transform(transformation);
        }

        return point;
    };

    Point.prototype.distanceTo = function distanceTo (point) {
        var dx = this.x - point.x;
        var dy = this.y - point.y;

        return Math.sqrt(dx * dx + dy * dy);
    };

    Point.prototype.round = function round$1 (digits) {
        this.x = Object(__WEBPACK_IMPORTED_MODULE_3__util__["w" /* round */])(this.x, digits);
        this.y = Object(__WEBPACK_IMPORTED_MODULE_3__util__["w" /* round */])(this.y, digits);

        this.geometryChange();

        return this;
    };

    Point.prototype.toArray = function toArray (digits) {
        var doRound = Object(__WEBPACK_IMPORTED_MODULE_3__util__["g" /* defined */])(digits);
        var x = doRound ? Object(__WEBPACK_IMPORTED_MODULE_3__util__["w" /* round */])(this.x, digits) : this.x;
        var y = doRound ? Object(__WEBPACK_IMPORTED_MODULE_3__util__["w" /* round */])(this.y, digits) : this.y;

        return [ x, y ];
    };

    Point.prototype.toString = function toString (digits, separator) {
        if ( separator === void 0 ) separator = " ";

        var ref = this;
        var x = ref.x;
        var y = ref.y;

        if (Object(__WEBPACK_IMPORTED_MODULE_3__util__["g" /* defined */])(digits)) {
            x = Object(__WEBPACK_IMPORTED_MODULE_3__util__["w" /* round */])(x, digits);
            y = Object(__WEBPACK_IMPORTED_MODULE_3__util__["w" /* round */])(y, digits);
        }

        return x + separator + y;
    };

    Point.create = function create (arg0, arg1) {
        if (Object(__WEBPACK_IMPORTED_MODULE_3__util__["g" /* defined */])(arg0)) {
            if (arg0 instanceof Point) {
                return arg0;
            } else if (arguments.length === 1 && arg0.length === 2) {
                return new Point(arg0[0], arg0[1]);
            }

            return new Point(arg0, arg1);
        }
    };

    Point.min = function min () {
        var arguments$1 = arguments;

        var minX = __WEBPACK_IMPORTED_MODULE_3__util__["a" /* MAX_NUM */];
        var minY = __WEBPACK_IMPORTED_MODULE_3__util__["a" /* MAX_NUM */];

        for (var i = 0; i < arguments.length; i++) {
            var point = arguments$1[i];
            minX = Math.min(point.x, minX);
            minY = Math.min(point.y, minY);
        }

        return new Point(minX, minY);
    };

    Point.max = function max () {
        var arguments$1 = arguments;

        var maxX = __WEBPACK_IMPORTED_MODULE_3__util__["b" /* MIN_NUM */];
        var maxY = __WEBPACK_IMPORTED_MODULE_3__util__["b" /* MIN_NUM */];

        for (var i = 0; i < arguments.length; i++) {
            var point = arguments$1[i];
            maxX = Math.max(point.x, maxX);
            maxY = Math.max(point.y, maxY);
        }

        return new Point(maxX, maxY);
    };

    Point.minPoint = function minPoint () {
        return new Point(__WEBPACK_IMPORTED_MODULE_3__util__["b" /* MIN_NUM */], __WEBPACK_IMPORTED_MODULE_3__util__["b" /* MIN_NUM */]);
    };

    Point.maxPoint = function maxPoint () {
        return new Point(__WEBPACK_IMPORTED_MODULE_3__util__["a" /* MAX_NUM */], __WEBPACK_IMPORTED_MODULE_3__util__["a" /* MAX_NUM */]);
    };

    staticAccessors.ZERO.get = function () {
        return new Point(0, 0);
    };

    Object.defineProperties( Point, staticAccessors );

    return Point;
}(__WEBPACK_IMPORTED_MODULE_2__common__["a" /* Class */]));

Object(__WEBPACK_IMPORTED_MODULE_0__accessors_define_accessors__["a" /* default */])(Point.prototype, [ "x", "y" ]);
__WEBPACK_IMPORTED_MODULE_1__mixins_observers_mixin__["a" /* default */].extend(Point.prototype);

/* harmony default export */ __webpack_exports__["a"] = (Point);


/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["__extends"] = __extends;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__assign", function() { return __assign; });
/* harmony export (immutable) */ __webpack_exports__["__rest"] = __rest;
/* harmony export (immutable) */ __webpack_exports__["__decorate"] = __decorate;
/* harmony export (immutable) */ __webpack_exports__["__param"] = __param;
/* harmony export (immutable) */ __webpack_exports__["__metadata"] = __metadata;
/* harmony export (immutable) */ __webpack_exports__["__awaiter"] = __awaiter;
/* harmony export (immutable) */ __webpack_exports__["__generator"] = __generator;
/* harmony export (immutable) */ __webpack_exports__["__exportStar"] = __exportStar;
/* harmony export (immutable) */ __webpack_exports__["__values"] = __values;
/* harmony export (immutable) */ __webpack_exports__["__read"] = __read;
/* harmony export (immutable) */ __webpack_exports__["__spread"] = __spread;
/* harmony export (immutable) */ __webpack_exports__["__await"] = __await;
/* harmony export (immutable) */ __webpack_exports__["__asyncGenerator"] = __asyncGenerator;
/* harmony export (immutable) */ __webpack_exports__["__asyncDelegator"] = __asyncDelegator;
/* harmony export (immutable) */ __webpack_exports__["__asyncValues"] = __asyncValues;
/* harmony export (immutable) */ __webpack_exports__["__makeTemplateObject"] = __makeTemplateObject;
/* harmony export (immutable) */ __webpack_exports__["__importStar"] = __importStar;
/* harmony export (immutable) */ __webpack_exports__["__importDefault"] = __importDefault;
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __exportStar(m, exports) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}

function __values(o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result.default = mod;
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}


/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_core_TableCell__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_core_TableCell___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__material_ui_core_TableCell__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_TableHead__ = __webpack_require__(330);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_TableHead___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_TableHead__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_TableRow__ = __webpack_require__(332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_TableRow___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_TableRow__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_TableSortLabel__ = __webpack_require__(333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_TableSortLabel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_TableSortLabel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Tooltip__ = __webpack_require__(334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var colwidth=function colwidth(value){return{width:value,minWidth:value,maxWidth:value};};var EnhancedTableHead=function(_React$Component){_inherits(EnhancedTableHead,_React$Component);function EnhancedTableHead(){var _ref;var _temp,_this,_ret;_classCallCheck(this,EnhancedTableHead);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=EnhancedTableHead.__proto__||Object.getPrototypeOf(EnhancedTableHead)).call.apply(_ref,[this].concat(args))),_this),_this.createSortHandler=function(property){return function(event){_this.props.onRequestSort(event,property);};},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(EnhancedTableHead,[{key:"render",value:function render(){var _this2=this;var _props=this.props,order=_props.order,orderBy=_props.orderBy;return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_TableHead___default.a,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_TableRow___default.a,null,this.props.columnData.map(function(column){return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core_TableCell___default.a,{key:column.id,numeric:column.numeric,padding:column.disablePadding?"none":"default",sortDirection:orderBy===column.id?order:false,className:column.cellPaddingSmall?"cellPaddingSmall":"",style:Object.assign({padding:column.width?"0px":"4px 56px 4px 24px"},column.width?colwidth(column.width):{})},column.noSort?column.label:__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Tooltip___default.a,{title:"Sort",placement:column.numeric?"bottom-end":"bottom-start",enterDelay:300},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_TableSortLabel___default.a,{active:orderBy===column.id,direction:order,onClick:_this2.createSortHandler(column.id)},column.label)));},this)));}}]);return EnhancedTableHead;}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);EnhancedTableHead.propTypes={onRequestSort:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func.isRequired,order:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string.isRequired,orderBy:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string.isRequired,rowCount:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number.isRequired};/* harmony default export */ __webpack_exports__["a"] = (EnhancedTableHead);

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function checkDCE() {
  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
  if (
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function'
  ) {
    return;
  }
  if (false) {
    // This branch is unreachable because this function is only called
    // in production, but the condition is true only in development.
    // Therefore if the branch is still here, dead code elimination wasn't
    // properly applied.
    // Don't change the message. React DevTools relies on it. Also make sure
    // this message doesn't occur elsewhere in this function, or it will cause
    // a false positive.
    throw new Error('^_^');
  }
  try {
    // Verify that the code above has been dead code eliminated (DCE'd).
    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
  } catch (err) {
    // DevTools shouldn't crash React, no matter what.
    // We should still report in case we break this code.
    console.error(err);
  }
}

if (true) {
  // DCE check should happen before ReactDOM bundle executes so that
  // DevTools can report bad minification during injection.
  checkDCE();
  module.exports = __webpack_require__(762);
} else {
  module.exports = require('./cjs/react-dom.development.js');
}


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Typography.default;
  }
});

var _Typography = _interopRequireDefault(__webpack_require__(882));

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _SvgIcon.default;
  }
});

var _SvgIcon = _interopRequireDefault(__webpack_require__(930));

/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return fileUploadServerPath; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return QuotePdfUri; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ResultsPdfUri; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ResultsPdfPhysicalPath; });
/* unused harmony export serverPath */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return messagePath; });
var fileUploadServerPath="http://www.rhlm.co.za/upload";//local
var QuotePdfUri="http://www.rhlm.co.za/";var ResultsPdfUri="http://www.rhlm.co.za/";var ResultsPdfPhysicalPath="/home/hosting/documents";var serverPath="http://www.rhlm.co.za/api";var messagePath="http://www.rhlm.co.za/message/";//server
/*
export const QuotePdfUri = "https://www.sure-quote.co.za/app/quotepdf/";
export const ResultsPdfUri = "https://www.sure-quote.co.za/resultpdf/";
export const ResultsPdfPhysicalPath = "C:\\Dev\\quote-history\\";
export const serverPath = "https://www.sure-quote.co.za:8080"
*/

/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_core__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var FormCheckbox=function(_React$Component){_inherits(FormCheckbox,_React$Component);function FormCheckbox(props){_classCallCheck(this,FormCheckbox);var _this=_possibleConstructorReturn(this,(FormCheckbox.__proto__||Object.getPrototypeOf(FormCheckbox)).call(this,props));_this.handleChange=function(event,value){if(_this.props.input.onChange&&!_this.props.readOnly){_this.props.input.onChange(event);_this.props.input.onBlur(event);if(_this.props.onToggle){_this.props.onToggle(value);}}};_this.handleChange=_this.handleChange.bind(_this);return _this;}_createClass(FormCheckbox,[{key:"render",value:function render(){var lValue=this.props.input.value;if(!lValue){lValue=false;}var lLabel="Yes";if(!lValue){lLabel="No";}return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",null,this.props.label?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{variant:"caption"},this.props.label):null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["u" /* FormControlLabel */],{control:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["O" /* Switch */],{checked:lValue,onChange:this.handleChange}),label:lLabel}));}}]);return FormCheckbox;}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (FormCheckbox);

/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_graphql_language_printer__ = __webpack_require__(143);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "printAST", function() { return __WEBPACK_IMPORTED_MODULE_0_graphql_language_printer__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_ObservableQuery__ = __webpack_require__(336);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ObservableQuery", function() { return __WEBPACK_IMPORTED_MODULE_1__core_ObservableQuery__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_networkStatus__ = __webpack_require__(175);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "NetworkStatus", function() { return __WEBPACK_IMPORTED_MODULE_2__core_networkStatus__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__core_types__ = __webpack_require__(229);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "FetchType", function() { return __WEBPACK_IMPORTED_MODULE_3__core_types__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__errors_ApolloError__ = __webpack_require__(340);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ApolloError", function() { return __WEBPACK_IMPORTED_MODULE_4__errors_ApolloError__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ApolloClient__ = __webpack_require__(1115);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ApolloClient", function() { return __WEBPACK_IMPORTED_MODULE_5__ApolloClient__["a"]; });







/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_5__ApolloClient__["a" /* default */]);
//# sourceMappingURL=index.js.map

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function(dest, source, overwrite) {
  if (!source) return dest;
  for (var key in source) {
    if (!source.hasOwnProperty(key)) continue;
    if (dest.hasOwnProperty(key) && overwrite === false) continue;
    if (dest[key] !== source[key])
      dest[key] = source[key];
  }
  return dest;
};


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _shouldUpdate = __webpack_require__(889);

var _shouldUpdate2 = _interopRequireDefault(_shouldUpdate);

var _shallowEqual = __webpack_require__(929);

var _shallowEqual2 = _interopRequireDefault(_shallowEqual);

var _setDisplayName = __webpack_require__(483);

var _setDisplayName2 = _interopRequireDefault(_setDisplayName);

var _wrapDisplayName = __webpack_require__(162);

var _wrapDisplayName2 = _interopRequireDefault(_wrapDisplayName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var pure = function pure(BaseComponent) {
  var hoc = (0, _shouldUpdate2.default)(function (props, nextProps) {
    return !(0, _shallowEqual2.default)(props, nextProps);
  });

  if (false) {
    return (0, _setDisplayName2.default)((0, _wrapDisplayName2.default)(BaseComponent, 'pure'))(hoc(BaseComponent));
  }

  return hoc(BaseComponent);
};

exports.default = pure;

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var extend = __webpack_require__(51);

module.exports = function(parent, methods) {
  if (typeof parent !== 'function') {
    methods = parent;
    parent  = Object;
  }

  var klass = function() {
    if (!this.initialize) return this;
    return this.initialize.apply(this, arguments) || this;
  };

  var bridge = function() {};
  bridge.prototype = parent.prototype;

  klass.prototype = new bridge();
  extend(klass.prototype, methods);

  return klass;
};


/***/ }),
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__inMemoryCache__ = __webpack_require__(2343);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__inMemoryCache__["a"]; });
/* unused harmony reexport defaultDataIdFromObject */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__readFromStore__ = __webpack_require__(590);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__writeToStore__ = __webpack_require__(592);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__fragmentMatcher__ = __webpack_require__(589);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__objectCache__ = __webpack_require__(370);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__recordingCache__ = __webpack_require__(593);
/* unused harmony namespace reexport */






//# sourceMappingURL=index.js.map

/***/ }),
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

var ObserversMixin = {
    extend: function(proto) {
        var this$1 = this;

        for (var method in this$1) {
            if (method !== "extend") {
                proto[method] = this$1[method];
            }
        }
    },

    observers: function() {
        this._observers = this._observers || [];
        return this._observers;
    },

    addObserver: function(element) {
        if (!this._observers) {
            this._observers = [ element ];
        } else {
            this._observers.push(element);
        }
        return this;
    },

    removeObserver: function(element) {
        var observers = this.observers();
        var index = observers.indexOf(element);
        if (index !== -1) {
            observers.splice(index, 1);
        }
        return this;
    },

    trigger: function(methodName, event) {
        var observers = this._observers;

        if (observers && !this._suspended) {
            for (var idx = 0; idx < observers.length; idx++) {
                var observer = observers[idx];
                if (observer[methodName]) {
                    observer[methodName](event);
                }
            }
        }
        return this;
    },

    optionsChange: function(e) {
        if ( e === void 0 ) e = {};

        e.element = this;
        this.trigger("optionsChange", e);
    },

    geometryChange: function() {
        this.trigger("geometryChange", {
            element: this
        });
    },

    suspend: function() {
        this._suspended = (this._suspended || 0) + 1;
        return this;
    },

    resume: function() {
        this._suspended = Math.max((this._suspended || 0) - 1, 0);
        return this;
    },

    _observerField: function(field, value) {
        if (this[field]) {
            this[field].removeObserver(this);
        }
        this[field] = value;
        value.addObserver(this);
    }
};

/* harmony default export */ __webpack_exports__["a"] = (ObserversMixin);

/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core__ = __webpack_require__(4);
var CustomCardHeading=function CustomCardHeading(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["Z" /* Typography */],{variant:"subheading",className:"centerCell"},props.subheading),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["Z" /* Typography */],{variant:"caption",className:"centerCell"},props.caption),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:{borderBottom:"1px solid #cccccc69",margin:"5px auto",width:"25%"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["Z" /* Typography */],{variant:"headline",className:"centerCell",style:{marginBottom:"35px"}},props.headline));};/* harmony default export */ __webpack_exports__["a"] = (CustomCardHeading);

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Button.default;
  }
});

var _Button = _interopRequireDefault(__webpack_require__(873));

/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__directives__ = __webpack_require__(1103);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_0__directives__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "q", function() { return __WEBPACK_IMPORTED_MODULE_0__directives__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "A", function() { return __WEBPACK_IMPORTED_MODULE_0__directives__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__fragments__ = __webpack_require__(1105);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_1__fragments__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getFromAST__ = __webpack_require__(523);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_2__getFromAST__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_2__getFromAST__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_2__getFromAST__["d"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_2__getFromAST__["e"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_2__getFromAST__["f"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_2__getFromAST__["g"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_2__getFromAST__["i"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_2__getFromAST__["j"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__transform__ = __webpack_require__(1106);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_3__transform__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "y", function() { return __WEBPACK_IMPORTED_MODULE_3__transform__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__storeUtils__ = __webpack_require__(337);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_4__storeUtils__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_4__storeUtils__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "s", function() { return __WEBPACK_IMPORTED_MODULE_4__storeUtils__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "t", function() { return __WEBPACK_IMPORTED_MODULE_4__storeUtils__["d"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "u", function() { return __WEBPACK_IMPORTED_MODULE_4__storeUtils__["e"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "v", function() { return __WEBPACK_IMPORTED_MODULE_4__storeUtils__["f"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "z", function() { return __WEBPACK_IMPORTED_MODULE_4__storeUtils__["g"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "B", function() { return __WEBPACK_IMPORTED_MODULE_4__storeUtils__["h"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "C", function() { return __WEBPACK_IMPORTED_MODULE_4__storeUtils__["i"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_assign__ = __webpack_require__(524);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_5__util_assign__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_cloneDeep__ = __webpack_require__(525);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_6__util_cloneDeep__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_environment__ = __webpack_require__(338);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "w", function() { return __WEBPACK_IMPORTED_MODULE_7__util_environment__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "x", function() { return __WEBPACK_IMPORTED_MODULE_7__util_environment__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util_errorHandling__ = __webpack_require__(1107);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "p", function() { return __WEBPACK_IMPORTED_MODULE_8__util_errorHandling__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "D", function() { return __WEBPACK_IMPORTED_MODULE_8__util_errorHandling__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util_isEqual__ = __webpack_require__(1108);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "r", function() { return __WEBPACK_IMPORTED_MODULE_9__util_isEqual__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util_maybeDeepFreeze__ = __webpack_require__(1109);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__util_warnOnce__ = __webpack_require__(1110);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "E", function() { return __WEBPACK_IMPORTED_MODULE_11__util_warnOnce__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__util_stripSymbols__ = __webpack_require__(1111);
/* unused harmony namespace reexport */













//# sourceMappingURL=index.js.map

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var require;//! moment.js

;(function (global, factory) {
     true ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    global.moment = factory()
}(this, (function () { 'use strict';

    var hookCallback;

    function hooks () {
        return hookCallback.apply(null, arguments);
    }

    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback (callback) {
        hookCallback = callback;
    }

    function isArray(input) {
        return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
    }

    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return input != null && Object.prototype.toString.call(input) === '[object Object]';
    }

    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) {
            return (Object.getOwnPropertyNames(obj).length === 0);
        } else {
            var k;
            for (k in obj) {
                if (obj.hasOwnProperty(k)) {
                    return false;
                }
            }
            return true;
        }
    }

    function isUndefined(input) {
        return input === void 0;
    }

    function isNumber(input) {
        return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
    }

    function isDate(input) {
        return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
    }

    function map(arr, fn) {
        var res = [], i;
        for (i = 0; i < arr.length; ++i) {
            res.push(fn(arr[i], i));
        }
        return res;
    }

    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }

    function extend(a, b) {
        for (var i in b) {
            if (hasOwnProp(b, i)) {
                a[i] = b[i];
            }
        }

        if (hasOwnProp(b, 'toString')) {
            a.toString = b.toString;
        }

        if (hasOwnProp(b, 'valueOf')) {
            a.valueOf = b.valueOf;
        }

        return a;
    }

    function createUTC (input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }

    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty           : false,
            unusedTokens    : [],
            unusedInput     : [],
            overflow        : -2,
            charsLeftOver   : 0,
            nullInput       : false,
            invalidMonth    : null,
            invalidFormat   : false,
            userInvalidated : false,
            iso             : false,
            parsedDateParts : [],
            meridiem        : null,
            rfc2822         : false,
            weekdayMismatch : false
        };
    }

    function getParsingFlags(m) {
        if (m._pf == null) {
            m._pf = defaultParsingFlags();
        }
        return m._pf;
    }

    var some;
    if (Array.prototype.some) {
        some = Array.prototype.some;
    } else {
        some = function (fun) {
            var t = Object(this);
            var len = t.length >>> 0;

            for (var i = 0; i < len; i++) {
                if (i in t && fun.call(this, t[i], i, t)) {
                    return true;
                }
            }

            return false;
        };
    }

    function isValid(m) {
        if (m._isValid == null) {
            var flags = getParsingFlags(m);
            var parsedParts = some.call(flags.parsedDateParts, function (i) {
                return i != null;
            });
            var isNowValid = !isNaN(m._d.getTime()) &&
                flags.overflow < 0 &&
                !flags.empty &&
                !flags.invalidMonth &&
                !flags.invalidWeekday &&
                !flags.weekdayMismatch &&
                !flags.nullInput &&
                !flags.invalidFormat &&
                !flags.userInvalidated &&
                (!flags.meridiem || (flags.meridiem && parsedParts));

            if (m._strict) {
                isNowValid = isNowValid &&
                    flags.charsLeftOver === 0 &&
                    flags.unusedTokens.length === 0 &&
                    flags.bigHour === undefined;
            }

            if (Object.isFrozen == null || !Object.isFrozen(m)) {
                m._isValid = isNowValid;
            }
            else {
                return isNowValid;
            }
        }
        return m._isValid;
    }

    function createInvalid (flags) {
        var m = createUTC(NaN);
        if (flags != null) {
            extend(getParsingFlags(m), flags);
        }
        else {
            getParsingFlags(m).userInvalidated = true;
        }

        return m;
    }

    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = hooks.momentProperties = [];

    function copyConfig(to, from) {
        var i, prop, val;

        if (!isUndefined(from._isAMomentObject)) {
            to._isAMomentObject = from._isAMomentObject;
        }
        if (!isUndefined(from._i)) {
            to._i = from._i;
        }
        if (!isUndefined(from._f)) {
            to._f = from._f;
        }
        if (!isUndefined(from._l)) {
            to._l = from._l;
        }
        if (!isUndefined(from._strict)) {
            to._strict = from._strict;
        }
        if (!isUndefined(from._tzm)) {
            to._tzm = from._tzm;
        }
        if (!isUndefined(from._isUTC)) {
            to._isUTC = from._isUTC;
        }
        if (!isUndefined(from._offset)) {
            to._offset = from._offset;
        }
        if (!isUndefined(from._pf)) {
            to._pf = getParsingFlags(from);
        }
        if (!isUndefined(from._locale)) {
            to._locale = from._locale;
        }

        if (momentProperties.length > 0) {
            for (i = 0; i < momentProperties.length; i++) {
                prop = momentProperties[i];
                val = from[prop];
                if (!isUndefined(val)) {
                    to[prop] = val;
                }
            }
        }

        return to;
    }

    var updateInProgress = false;

    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) {
            this._d = new Date(NaN);
        }
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }

    function isMoment (obj) {
        return obj instanceof Moment || (obj != null && obj._isAMomentObject != null);
    }

    function absFloor (number) {
        if (number < 0) {
            // -0 -> 0
            return Math.ceil(number) || 0;
        } else {
            return Math.floor(number);
        }
    }

    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion,
            value = 0;

        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
            value = absFloor(coercedNumber);
        }

        return value;
    }

    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length),
            lengthDiff = Math.abs(array1.length - array2.length),
            diffs = 0,
            i;
        for (i = 0; i < len; i++) {
            if ((dontConvert && array1[i] !== array2[i]) ||
                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
                diffs++;
            }
        }
        return diffs + lengthDiff;
    }

    function warn(msg) {
        if (hooks.suppressDeprecationWarnings === false &&
                (typeof console !==  'undefined') && console.warn) {
            console.warn('Deprecation warning: ' + msg);
        }
    }

    function deprecate(msg, fn) {
        var firstTime = true;

        return extend(function () {
            if (hooks.deprecationHandler != null) {
                hooks.deprecationHandler(null, msg);
            }
            if (firstTime) {
                var args = [];
                var arg;
                for (var i = 0; i < arguments.length; i++) {
                    arg = '';
                    if (typeof arguments[i] === 'object') {
                        arg += '\n[' + i + '] ';
                        for (var key in arguments[0]) {
                            arg += key + ': ' + arguments[0][key] + ', ';
                        }
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else {
                        arg = arguments[i];
                    }
                    args.push(arg);
                }
                warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + (new Error()).stack);
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }

    var deprecations = {};

    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) {
            hooks.deprecationHandler(name, msg);
        }
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }

    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;

    function isFunction(input) {
        return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
    }

    function set (config) {
        var prop, i;
        for (i in config) {
            prop = config[i];
            if (isFunction(prop)) {
                this[i] = prop;
            } else {
                this['_' + i] = prop;
            }
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp(
            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
                '|' + (/\d{1,2}/).source);
    }

    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig), prop;
        for (prop in childConfig) {
            if (hasOwnProp(childConfig, prop)) {
                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                    res[prop] = {};
                    extend(res[prop], parentConfig[prop]);
                    extend(res[prop], childConfig[prop]);
                } else if (childConfig[prop] != null) {
                    res[prop] = childConfig[prop];
                } else {
                    delete res[prop];
                }
            }
        }
        for (prop in parentConfig) {
            if (hasOwnProp(parentConfig, prop) &&
                    !hasOwnProp(childConfig, prop) &&
                    isObject(parentConfig[prop])) {
                // make sure changes to properties don't modify parent config
                res[prop] = extend({}, res[prop]);
            }
        }
        return res;
    }

    function Locale(config) {
        if (config != null) {
            this.set(config);
        }
    }

    var keys;

    if (Object.keys) {
        keys = Object.keys;
    } else {
        keys = function (obj) {
            var i, res = [];
            for (i in obj) {
                if (hasOwnProp(obj, i)) {
                    res.push(i);
                }
            }
            return res;
        };
    }

    var defaultCalendar = {
        sameDay : '[Today at] LT',
        nextDay : '[Tomorrow at] LT',
        nextWeek : 'dddd [at] LT',
        lastDay : '[Yesterday at] LT',
        lastWeek : '[Last] dddd [at] LT',
        sameElse : 'L'
    };

    function calendar (key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }

    var defaultLongDateFormat = {
        LTS  : 'h:mm:ss A',
        LT   : 'h:mm A',
        L    : 'MM/DD/YYYY',
        LL   : 'MMMM D, YYYY',
        LLL  : 'MMMM D, YYYY h:mm A',
        LLLL : 'dddd, MMMM D, YYYY h:mm A'
    };

    function longDateFormat (key) {
        var format = this._longDateFormat[key],
            formatUpper = this._longDateFormat[key.toUpperCase()];

        if (format || !formatUpper) {
            return format;
        }

        this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
            return val.slice(1);
        });

        return this._longDateFormat[key];
    }

    var defaultInvalidDate = 'Invalid date';

    function invalidDate () {
        return this._invalidDate;
    }

    var defaultOrdinal = '%d';
    var defaultDayOfMonthOrdinalParse = /\d{1,2}/;

    function ordinal (number) {
        return this._ordinal.replace('%d', number);
    }

    var defaultRelativeTime = {
        future : 'in %s',
        past   : '%s ago',
        s  : 'a few seconds',
        ss : '%d seconds',
        m  : 'a minute',
        mm : '%d minutes',
        h  : 'an hour',
        hh : '%d hours',
        d  : 'a day',
        dd : '%d days',
        M  : 'a month',
        MM : '%d months',
        y  : 'a year',
        yy : '%d years'
    };

    function relativeTime (number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return (isFunction(output)) ?
            output(number, withoutSuffix, string, isFuture) :
            output.replace(/%d/i, number);
    }

    function pastFuture (diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }

    var aliases = {};

    function addUnitAlias (unit, shorthand) {
        var lowerCase = unit.toLowerCase();
        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
    }

    function normalizeUnits(units) {
        return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
    }

    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {},
            normalizedProp,
            prop;

        for (prop in inputObject) {
            if (hasOwnProp(inputObject, prop)) {
                normalizedProp = normalizeUnits(prop);
                if (normalizedProp) {
                    normalizedInput[normalizedProp] = inputObject[prop];
                }
            }
        }

        return normalizedInput;
    }

    var priorities = {};

    function addUnitPriority(unit, priority) {
        priorities[unit] = priority;
    }

    function getPrioritizedUnits(unitsObj) {
        var units = [];
        for (var u in unitsObj) {
            units.push({unit: u, priority: priorities[u]});
        }
        units.sort(function (a, b) {
            return a.priority - b.priority;
        });
        return units;
    }

    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number),
            zerosToFill = targetLength - absNumber.length,
            sign = number >= 0;
        return (sign ? (forceSign ? '+' : '') : '-') +
            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
    }

    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;

    var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;

    var formatFunctions = {};

    var formatTokenFunctions = {};

    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken (token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') {
            func = function () {
                return this[callback]();
            };
        }
        if (token) {
            formatTokenFunctions[token] = func;
        }
        if (padded) {
            formatTokenFunctions[padded[0]] = function () {
                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
            };
        }
        if (ordinal) {
            formatTokenFunctions[ordinal] = function () {
                return this.localeData().ordinal(func.apply(this, arguments), token);
            };
        }
    }

    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) {
            return input.replace(/^\[|\]$/g, '');
        }
        return input.replace(/\\/g, '');
    }

    function makeFormatFunction(format) {
        var array = format.match(formattingTokens), i, length;

        for (i = 0, length = array.length; i < length; i++) {
            if (formatTokenFunctions[array[i]]) {
                array[i] = formatTokenFunctions[array[i]];
            } else {
                array[i] = removeFormattingTokens(array[i]);
            }
        }

        return function (mom) {
            var output = '', i;
            for (i = 0; i < length; i++) {
                output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
            }
            return output;
        };
    }

    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) {
            return m.localeData().invalidDate();
        }

        format = expandFormat(format, m.localeData());
        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);

        return formatFunctions[format](m);
    }

    function expandFormat(format, locale) {
        var i = 5;

        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }

        localFormattingTokens.lastIndex = 0;
        while (i >= 0 && localFormattingTokens.test(format)) {
            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }

        return format;
    }

    var match1         = /\d/;            //       0 - 9
    var match2         = /\d\d/;          //      00 - 99
    var match3         = /\d{3}/;         //     000 - 999
    var match4         = /\d{4}/;         //    0000 - 9999
    var match6         = /[+-]?\d{6}/;    // -999999 - 999999
    var match1to2      = /\d\d?/;         //       0 - 99
    var match3to4      = /\d\d\d\d?/;     //     999 - 9999
    var match5to6      = /\d\d\d\d\d\d?/; //   99999 - 999999
    var match1to3      = /\d{1,3}/;       //       0 - 999
    var match1to4      = /\d{1,4}/;       //       0 - 9999
    var match1to6      = /[+-]?\d{1,6}/;  // -999999 - 999999

    var matchUnsigned  = /\d+/;           //       0 - inf
    var matchSigned    = /[+-]?\d+/;      //    -inf - inf

    var matchOffset    = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
    var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z

    var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123

    // any word (or two) characters or numbers including two/three word month in arabic.
    // includes scottish gaelic two word and hyphenated months
    var matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i;

    var regexes = {};

    function addRegexToken (token, regex, strictRegex) {
        regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
            return (isStrict && strictRegex) ? strictRegex : regex;
        };
    }

    function getParseRegexForToken (token, config) {
        if (!hasOwnProp(regexes, token)) {
            return new RegExp(unescapeFormat(token));
        }

        return regexes[token](config._strict, config._locale);
    }

    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
            return p1 || p2 || p3 || p4;
        }));
    }

    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }

    var tokens = {};

    function addParseToken (token, callback) {
        var i, func = callback;
        if (typeof token === 'string') {
            token = [token];
        }
        if (isNumber(callback)) {
            func = function (input, array) {
                array[callback] = toInt(input);
            };
        }
        for (i = 0; i < token.length; i++) {
            tokens[token[i]] = func;
        }
    }

    function addWeekParseToken (token, callback) {
        addParseToken(token, function (input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }

    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) {
            tokens[token](input, config._a, config, token);
        }
    }

    var YEAR = 0;
    var MONTH = 1;
    var DATE = 2;
    var HOUR = 3;
    var MINUTE = 4;
    var SECOND = 5;
    var MILLISECOND = 6;
    var WEEK = 7;
    var WEEKDAY = 8;

    // FORMATTING

    addFormatToken('Y', 0, 0, function () {
        var y = this.year();
        return y <= 9999 ? '' + y : '+' + y;
    });

    addFormatToken(0, ['YY', 2], 0, function () {
        return this.year() % 100;
    });

    addFormatToken(0, ['YYYY',   4],       0, 'year');
    addFormatToken(0, ['YYYYY',  5],       0, 'year');
    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

    // ALIASES

    addUnitAlias('year', 'y');

    // PRIORITIES

    addUnitPriority('year', 1);

    // PARSING

    addRegexToken('Y',      matchSigned);
    addRegexToken('YY',     match1to2, match2);
    addRegexToken('YYYY',   match1to4, match4);
    addRegexToken('YYYYY',  match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);

    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
    addParseToken('YYYY', function (input, array) {
        array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function (input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function (input, array) {
        array[YEAR] = parseInt(input, 10);
    });

    // HELPERS

    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }

    function isLeapYear(year) {
        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
    }

    // HOOKS

    hooks.parseTwoDigitYear = function (input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };

    // MOMENTS

    var getSetYear = makeGetSet('FullYear', true);

    function getIsLeapYear () {
        return isLeapYear(this.year());
    }

    function makeGetSet (unit, keepTime) {
        return function (value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else {
                return get(this, unit);
            }
        };
    }

    function get (mom, unit) {
        return mom.isValid() ?
            mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
    }

    function set$1 (mom, unit, value) {
        if (mom.isValid() && !isNaN(value)) {
            if (unit === 'FullYear' && isLeapYear(mom.year()) && mom.month() === 1 && mom.date() === 29) {
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value, mom.month(), daysInMonth(value, mom.month()));
            }
            else {
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
            }
        }
    }

    // MOMENTS

    function stringGet (units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
            return this[units]();
        }
        return this;
    }


    function stringSet (units, value) {
        if (typeof units === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units);
            for (var i = 0; i < prioritized.length; i++) {
                this[prioritized[i].unit](units[prioritized[i].unit]);
            }
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) {
                return this[units](value);
            }
        }
        return this;
    }

    function mod(n, x) {
        return ((n % x) + x) % x;
    }

    var indexOf;

    if (Array.prototype.indexOf) {
        indexOf = Array.prototype.indexOf;
    } else {
        indexOf = function (o) {
            // I know
            var i;
            for (i = 0; i < this.length; ++i) {
                if (this[i] === o) {
                    return i;
                }
            }
            return -1;
        };
    }

    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) {
            return NaN;
        }
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1 ? (isLeapYear(year) ? 29 : 28) : (31 - modMonth % 7 % 2);
    }

    // FORMATTING

    addFormatToken('M', ['MM', 2], 'Mo', function () {
        return this.month() + 1;
    });

    addFormatToken('MMM', 0, 0, function (format) {
        return this.localeData().monthsShort(this, format);
    });

    addFormatToken('MMMM', 0, 0, function (format) {
        return this.localeData().months(this, format);
    });

    // ALIASES

    addUnitAlias('month', 'M');

    // PRIORITY

    addUnitPriority('month', 8);

    // PARSING

    addRegexToken('M',    match1to2);
    addRegexToken('MM',   match1to2, match2);
    addRegexToken('MMM',  function (isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function (isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });

    addParseToken(['M', 'MM'], function (input, array) {
        array[MONTH] = toInt(input) - 1;
    });

    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) {
            array[MONTH] = month;
        } else {
            getParsingFlags(config).invalidMonth = input;
        }
    });

    // LOCALES

    var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/;
    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
    function localeMonths (m, format) {
        if (!m) {
            return isArray(this._months) ? this._months :
                this._months['standalone'];
        }
        return isArray(this._months) ? this._months[m.month()] :
            this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
    }

    var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
    function localeMonthsShort (m, format) {
        if (!m) {
            return isArray(this._monthsShort) ? this._monthsShort :
                this._monthsShort['standalone'];
        }
        return isArray(this._monthsShort) ? this._monthsShort[m.month()] :
            this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
    }

    function handleStrictParse(monthName, format, strict) {
        var i, ii, mom, llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for (i = 0; i < 12; ++i) {
                mom = createUTC([2000, i]);
                this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeMonthsParse (monthName, format, strict) {
        var i, mom, regex;

        if (this._monthsParseExact) {
            return handleStrictParse.call(this, monthName, format, strict);
        }

        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }

        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
                this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
            }
            if (!strict && !this._monthsParse[i]) {
                regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
                return i;
            } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
                return i;
            } else if (!strict && this._monthsParse[i].test(monthName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function setMonth (mom, value) {
        var dayOfMonth;

        if (!mom.isValid()) {
            // No op
            return mom;
        }

        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) {
                value = toInt(value);
            } else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) {
                    return mom;
                }
            }
        }

        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
        return mom;
    }

    function getSetMonth (value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else {
            return get(this, 'Month');
        }
    }

    function getDaysInMonth () {
        return daysInMonth(this.year(), this.month());
    }

    var defaultMonthsShortRegex = matchWord;
    function monthsShortRegex (isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsShortStrictRegex;
            } else {
                return this._monthsShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) {
                this._monthsShortRegex = defaultMonthsShortRegex;
            }
            return this._monthsShortStrictRegex && isStrict ?
                this._monthsShortStrictRegex : this._monthsShortRegex;
        }
    }

    var defaultMonthsRegex = matchWord;
    function monthsRegex (isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsStrictRegex;
            } else {
                return this._monthsRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) {
                this._monthsRegex = defaultMonthsRegex;
            }
            return this._monthsStrictRegex && isStrict ?
                this._monthsStrictRegex : this._monthsRegex;
        }
    }

    function computeMonthsParse () {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var shortPieces = [], longPieces = [], mixedPieces = [],
            i, mom;
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            shortPieces.push(this.monthsShort(mom, ''));
            longPieces.push(this.months(mom, ''));
            mixedPieces.push(this.months(mom, ''));
            mixedPieces.push(this.monthsShort(mom, ''));
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for (i = 0; i < 12; i++) {
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
        }
        for (i = 0; i < 24; i++) {
            mixedPieces[i] = regexEscape(mixedPieces[i]);
        }

        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
    }

    function createDate (y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date = new Date(y, m, d, h, M, s, ms);

        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0 && isFinite(date.getFullYear())) {
            date.setFullYear(y);
        }
        return date;
    }

    function createUTCDate (y) {
        var date = new Date(Date.UTC.apply(null, arguments));

        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0 && isFinite(date.getUTCFullYear())) {
            date.setUTCFullYear(y);
        }
        return date;
    }

    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
            fwd = 7 + dow - doy,
            // first-week day local weekday -- which local weekday is fwd
            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

        return -fwdlw + fwd - 1;
    }

    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7,
            weekOffset = firstWeekOffset(year, dow, doy),
            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
            resYear, resDayOfYear;

        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }

        return {
            year: resYear,
            dayOfYear: resDayOfYear
        };
    }

    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
            resWeek, resYear;

        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }

        return {
            week: resWeek,
            year: resYear
        };
    }

    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy),
            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }

    // FORMATTING

    addFormatToken('w', ['ww', 2], 'wo', 'week');
    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

    // ALIASES

    addUnitAlias('week', 'w');
    addUnitAlias('isoWeek', 'W');

    // PRIORITIES

    addUnitPriority('week', 5);
    addUnitPriority('isoWeek', 5);

    // PARSING

    addRegexToken('w',  match1to2);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W',  match1to2);
    addRegexToken('WW', match1to2, match2);

    addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
        week[token.substr(0, 1)] = toInt(input);
    });

    // HELPERS

    // LOCALES

    function localeWeek (mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }

    var defaultLocaleWeek = {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 6th is the first week of the year.
    };

    function localeFirstDayOfWeek () {
        return this._week.dow;
    }

    function localeFirstDayOfYear () {
        return this._week.doy;
    }

    // MOMENTS

    function getSetWeek (input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    function getSetISOWeek (input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    // FORMATTING

    addFormatToken('d', 0, 'do', 'day');

    addFormatToken('dd', 0, 0, function (format) {
        return this.localeData().weekdaysMin(this, format);
    });

    addFormatToken('ddd', 0, 0, function (format) {
        return this.localeData().weekdaysShort(this, format);
    });

    addFormatToken('dddd', 0, 0, function (format) {
        return this.localeData().weekdays(this, format);
    });

    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');

    // ALIASES

    addUnitAlias('day', 'd');
    addUnitAlias('weekday', 'e');
    addUnitAlias('isoWeekday', 'E');

    // PRIORITY
    addUnitPriority('day', 11);
    addUnitPriority('weekday', 11);
    addUnitPriority('isoWeekday', 11);

    // PARSING

    addRegexToken('d',    match1to2);
    addRegexToken('e',    match1to2);
    addRegexToken('E',    match1to2);
    addRegexToken('dd',   function (isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd',   function (isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd',   function (isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });

    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) {
            week.d = weekday;
        } else {
            getParsingFlags(config).invalidWeekday = input;
        }
    });

    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
        week[token] = toInt(input);
    });

    // HELPERS

    function parseWeekday(input, locale) {
        if (typeof input !== 'string') {
            return input;
        }

        if (!isNaN(input)) {
            return parseInt(input, 10);
        }

        input = locale.weekdaysParse(input);
        if (typeof input === 'number') {
            return input;
        }

        return null;
    }

    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') {
            return locale.weekdaysParse(input) % 7 || 7;
        }
        return isNaN(input) ? null : input;
    }

    // LOCALES

    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
    function localeWeekdays (m, format) {
        if (!m) {
            return isArray(this._weekdays) ? this._weekdays :
                this._weekdays['standalone'];
        }
        return isArray(this._weekdays) ? this._weekdays[m.day()] :
            this._weekdays[this._weekdays.isFormat.test(format) ? 'format' : 'standalone'][m.day()];
    }

    var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
    function localeWeekdaysShort (m) {
        return (m) ? this._weekdaysShort[m.day()] : this._weekdaysShort;
    }

    var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
    function localeWeekdaysMin (m) {
        return (m) ? this._weekdaysMin[m.day()] : this._weekdaysMin;
    }

    function handleStrictParse$1(weekdayName, format, strict) {
        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];

            for (i = 0; i < 7; ++i) {
                mom = createUTC([2000, 1]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeWeekdaysParse (weekdayName, format, strict) {
        var i, mom, regex;

        if (this._weekdaysParseExact) {
            return handleStrictParse$1.call(this, weekdayName, format, strict);
        }

        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }

        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already

            mom = createUTC([2000, 1]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\\.?') + '$', 'i');
                this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$', 'i');
                this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$', 'i');
            }
            if (!this._weekdaysParse[i]) {
                regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function getSetDayOfWeek (input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else {
            return day;
        }
    }

    function getSetLocaleDayOfWeek (input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }

    function getSetISODayOfWeek (input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }

        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.

        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else {
            return this.day() || 7;
        }
    }

    var defaultWeekdaysRegex = matchWord;
    function weekdaysRegex (isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysStrictRegex;
            } else {
                return this._weekdaysRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                this._weekdaysRegex = defaultWeekdaysRegex;
            }
            return this._weekdaysStrictRegex && isStrict ?
                this._weekdaysStrictRegex : this._weekdaysRegex;
        }
    }

    var defaultWeekdaysShortRegex = matchWord;
    function weekdaysShortRegex (isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysShortStrictRegex;
            } else {
                return this._weekdaysShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            }
            return this._weekdaysShortStrictRegex && isStrict ?
                this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
        }
    }

    var defaultWeekdaysMinRegex = matchWord;
    function weekdaysMinRegex (isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysMinStrictRegex;
            } else {
                return this._weekdaysMinRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            }
            return this._weekdaysMinStrictRegex && isStrict ?
                this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
        }
    }


    function computeWeekdaysParse () {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [],
            i, mom, minp, shortp, longp;
        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, 1]).day(i);
            minp = this.weekdaysMin(mom, '');
            shortp = this.weekdaysShort(mom, '');
            longp = this.weekdays(mom, '');
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for (i = 0; i < 7; i++) {
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
            mixedPieces[i] = regexEscape(mixedPieces[i]);
        }

        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;

        this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
        this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
    }

    // FORMATTING

    function hFormat() {
        return this.hours() % 12 || 12;
    }

    function kFormat() {
        return this.hours() || 24;
    }

    addFormatToken('H', ['HH', 2], 0, 'hour');
    addFormatToken('h', ['hh', 2], 0, hFormat);
    addFormatToken('k', ['kk', 2], 0, kFormat);

    addFormatToken('hmm', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });

    addFormatToken('hmmss', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2);
    });

    addFormatToken('Hmm', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });

    addFormatToken('Hmmss', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2);
    });

    function meridiem (token, lowercase) {
        addFormatToken(token, 0, 0, function () {
            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
        });
    }

    meridiem('a', true);
    meridiem('A', false);

    // ALIASES

    addUnitAlias('hour', 'h');

    // PRIORITY
    addUnitPriority('hour', 13);

    // PARSING

    function matchMeridiem (isStrict, locale) {
        return locale._meridiemParse;
    }

    addRegexToken('a',  matchMeridiem);
    addRegexToken('A',  matchMeridiem);
    addRegexToken('H',  match1to2);
    addRegexToken('h',  match1to2);
    addRegexToken('k',  match1to2);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);

    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);

    addParseToken(['H', 'HH'], HOUR);
    addParseToken(['k', 'kk'], function (input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken(['a', 'A'], function (input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken(['h', 'hh'], function (input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function (input, array, config) {
        var pos1 = input.length - 4;
        var pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function (input, array, config) {
        var pos1 = input.length - 4;
        var pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });

    // LOCALES

    function localeIsPM (input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return ((input + '').toLowerCase().charAt(0) === 'p');
    }

    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
    function localeMeridiem (hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'pm' : 'PM';
        } else {
            return isLower ? 'am' : 'AM';
        }
    }


    // MOMENTS

    // Setting the hour should keep the time, because the user explicitly
    // specified which hour they want. So trying to maintain the same hour (in
    // a new timezone) makes sense. Adding/subtracting hours does not follow
    // this rule.
    var getSetHour = makeGetSet('Hours', true);

    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,

        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,

        week: defaultLocaleWeek,

        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,

        meridiemParse: defaultLocaleMeridiemParse
    };

    // internal storage for locale config files
    var locales = {};
    var localeFamilies = {};
    var globalLocale;

    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }

    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0, j, next, locale, split;

        while (i < names.length) {
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while (j > 0) {
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) {
                    return locale;
                }
                if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
                    //the next array item is better than a shallower substring of this one
                    break;
                }
                j--;
            }
            i++;
        }
        return globalLocale;
    }

    function loadLocale(name) {
        var oldLocale = null;
        // TODO: Find a better way to register and load all the locales in Node
        if (!locales[name] && (typeof module !== 'undefined') &&
                module && module.exports) {
            try {
                oldLocale = globalLocale._abbr;
                var aliasedRequire = require;
                !(function webpackMissingModule() { var e = new Error("Cannot find module \"./locale\""); e.code = 'MODULE_NOT_FOUND'; throw e; }());
                getSetGlobalLocale(oldLocale);
            } catch (e) {}
        }
        return locales[name];
    }

    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale (key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) {
                data = getLocale(key);
            }
            else {
                data = defineLocale(key, values);
            }

            if (data) {
                // moment.duration._locale = moment._locale = data;
                globalLocale = data;
            }
            else {
                if ((typeof console !==  'undefined') && console.warn) {
                    //warn user if arguments are passed but the locale could not be set
                    console.warn('Locale ' + key +  ' not found. Did you forget to load it?');
                }
            }
        }

        return globalLocale._abbr;
    }

    function defineLocale (name, config) {
        if (config !== null) {
            var locale, parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple('defineLocaleOverride',
                        'use moment.updateLocale(localeName, config) to change ' +
                        'an existing locale. moment.defineLocale(localeName, ' +
                        'config) should only be used for creating a new locale ' +
                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) {
                    parentConfig = locales[config.parentLocale]._config;
                } else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) {
                        parentConfig = locale._config;
                    } else {
                        if (!localeFamilies[config.parentLocale]) {
                            localeFamilies[config.parentLocale] = [];
                        }
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));

            if (localeFamilies[name]) {
                localeFamilies[name].forEach(function (x) {
                    defineLocale(x.name, x.config);
                });
            }

            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);


            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }

    function updateLocale(name, config) {
        if (config != null) {
            var locale, tmpLocale, parentConfig = baseConfig;
            // MERGE
            tmpLocale = loadLocale(name);
            if (tmpLocale != null) {
                parentConfig = tmpLocale._config;
            }
            config = mergeConfigs(parentConfig, config);
            locale = new Locale(config);
            locale.parentLocale = locales[name];
            locales[name] = locale;

            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else {
            // pass null for config to unupdate, useful for tests
            if (locales[name] != null) {
                if (locales[name].parentLocale != null) {
                    locales[name] = locales[name].parentLocale;
                } else if (locales[name] != null) {
                    delete locales[name];
                }
            }
        }
        return locales[name];
    }

    // returns locale data
    function getLocale (key) {
        var locale;

        if (key && key._locale && key._locale._abbr) {
            key = key._locale._abbr;
        }

        if (!key) {
            return globalLocale;
        }

        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) {
                return locale;
            }
            key = [key];
        }

        return chooseLocale(key);
    }

    function listLocales() {
        return keys(locales);
    }

    function checkOverflow (m) {
        var overflow;
        var a = m._a;

        if (a && getParsingFlags(m).overflow === -2) {
            overflow =
                a[MONTH]       < 0 || a[MONTH]       > 11  ? MONTH :
                a[DATE]        < 1 || a[DATE]        > daysInMonth(a[YEAR], a[MONTH]) ? DATE :
                a[HOUR]        < 0 || a[HOUR]        > 24 || (a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0)) ? HOUR :
                a[MINUTE]      < 0 || a[MINUTE]      > 59  ? MINUTE :
                a[SECOND]      < 0 || a[SECOND]      > 59  ? SECOND :
                a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND :
                -1;

            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
                overflow = DATE;
            }
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
                overflow = WEEK;
            }
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
                overflow = WEEKDAY;
            }

            getParsingFlags(m).overflow = overflow;
        }

        return m;
    }

    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) {
            return a;
        }
        if (b != null) {
            return b;
        }
        return c;
    }

    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) {
            return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
        }
        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
    }

    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray (config) {
        var i, date, input = [], currentDate, expectedWeekday, yearToUse;

        if (config._d) {
            return;
        }

        currentDate = currentDateArray(config);

        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
            dayOfYearFromWeekInfo(config);
        }

        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

            if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) {
                getParsingFlags(config)._overflowDayOfYear = true;
            }

            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }

        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for (i = 0; i < 3 && config._a[i] == null; ++i) {
            config._a[i] = input[i] = currentDate[i];
        }

        // Zero out whatever was not defaulted, including time
        for (; i < 7; i++) {
            config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
        }

        // Check for 24:00:00.000
        if (config._a[HOUR] === 24 &&
                config._a[MINUTE] === 0 &&
                config._a[SECOND] === 0 &&
                config._a[MILLISECOND] === 0) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }

        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
        expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();

        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) {
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        }

        if (config._nextDay) {
            config._a[HOUR] = 24;
        }

        // check for mismatching day of week
        if (config._w && typeof config._w.d !== 'undefined' && config._w.d !== expectedWeekday) {
            getParsingFlags(config).weekdayMismatch = true;
        }
    }

    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;

        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;

            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) {
                weekdayOverflow = true;
            }
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;

            var curWeek = weekOfYear(createLocal(), dow, doy);

            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);

            // Default to current week.
            week = defaults(w.w, curWeek.week);

            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) {
                    weekdayOverflow = true;
                }
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) {
                    weekdayOverflow = true;
                }
            } else {
                // default to beginning of week
                weekday = dow;
            }
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
            getParsingFlags(config)._overflowWeeks = true;
        } else if (weekdayOverflow != null) {
            getParsingFlags(config)._overflowWeekday = true;
        } else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }

    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
    var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;

    var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;

    var isoDates = [
        ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
        ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
        ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
        ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
        ['YYYY-DDD', /\d{4}-\d{3}/],
        ['YYYY-MM', /\d{4}-\d\d/, false],
        ['YYYYYYMMDD', /[+-]\d{10}/],
        ['YYYYMMDD', /\d{8}/],
        // YYYYMM is NOT allowed by the standard
        ['GGGG[W]WWE', /\d{4}W\d{3}/],
        ['GGGG[W]WW', /\d{4}W\d{2}/, false],
        ['YYYYDDD', /\d{7}/]
    ];

    // iso time formats and regexes
    var isoTimes = [
        ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
        ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
        ['HH:mm:ss', /\d\d:\d\d:\d\d/],
        ['HH:mm', /\d\d:\d\d/],
        ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
        ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
        ['HHmmss', /\d\d\d\d\d\d/],
        ['HHmm', /\d\d\d\d/],
        ['HH', /\d\d/]
    ];

    var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;

    // date from iso format
    function configFromISO(config) {
        var i, l,
            string = config._i,
            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
            allowTime, dateFormat, timeFormat, tzFormat;

        if (match) {
            getParsingFlags(config).iso = true;

            for (i = 0, l = isoDates.length; i < l; i++) {
                if (isoDates[i][1].exec(match[1])) {
                    dateFormat = isoDates[i][0];
                    allowTime = isoDates[i][2] !== false;
                    break;
                }
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for (i = 0, l = isoTimes.length; i < l; i++) {
                    if (isoTimes[i][1].exec(match[3])) {
                        // match[2] should be 'T' or space
                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
                        break;
                    }
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) {
                    tzFormat = 'Z';
                } else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else {
            config._isValid = false;
        }
    }

    // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
    var rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/;

    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10)
        ];

        if (secondStr) {
            result.push(parseInt(secondStr, 10));
        }

        return result;
    }

    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) {
            return 2000 + year;
        } else if (year <= 999) {
            return 1900 + year;
        }
        return year;
    }

    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s.replace(/\([^)]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').replace(/^\s\s*/, '').replace(/\s\s*$/, '');
    }

    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an indepentent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
                weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }

    var obsOffsets = {
        UT: 0,
        GMT: 0,
        EDT: -4 * 60,
        EST: -5 * 60,
        CDT: -5 * 60,
        CST: -6 * 60,
        MDT: -6 * 60,
        MST: -7 * 60,
        PDT: -7 * 60,
        PST: -8 * 60
    };

    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) {
            return obsOffsets[obsOffset];
        } else if (militaryOffset) {
            // the only allowed military tz is Z
            return 0;
        } else {
            var hm = parseInt(numOffset, 10);
            var m = hm % 100, h = (hm - m) / 100;
            return h * 60 + m;
        }
    }

    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i));
        if (match) {
            var parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
            if (!checkWeekday(match[1], parsedArray, config)) {
                return;
            }

            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);

            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);

            getParsingFlags(config).rfc2822 = true;
        } else {
            config._isValid = false;
        }
    }

    // date from iso format or fallback
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);

        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }

        configFromISO(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        configFromRFC2822(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        // Final attempt, use Input Fallback
        hooks.createFromInputFallback(config);
    }

    hooks.createFromInputFallback = deprecate(
        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
        'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
        'discouraged and will be removed in an upcoming major release. Please refer to ' +
        'http://momentjs.com/guides/#/warnings/js-date/ for more info.',
        function (config) {
            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
        }
    );

    // constant that refers to the ISO standard
    hooks.ISO_8601 = function () {};

    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function () {};

    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;

        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i,
            i, parsedInput, tokens, token, skipped,
            stringLength = string.length,
            totalParsedInputLength = 0;

        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];

        for (i = 0; i < tokens.length; i++) {
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
            // console.log('token', token, 'parsedInput', parsedInput,
            //         'regex', getParseRegexForToken(token, config));
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) {
                    getParsingFlags(config).unusedInput.push(skipped);
                }
                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) {
                    getParsingFlags(config).empty = false;
                }
                else {
                    getParsingFlags(config).unusedTokens.push(token);
                }
                addTimeToArrayFromToken(token, parsedInput, config);
            }
            else if (config._strict && !parsedInput) {
                getParsingFlags(config).unusedTokens.push(token);
            }
        }

        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
        if (string.length > 0) {
            getParsingFlags(config).unusedInput.push(string);
        }

        // clear _12h flag if hour is <= 12
        if (config._a[HOUR] <= 12 &&
            getParsingFlags(config).bigHour === true &&
            config._a[HOUR] > 0) {
            getParsingFlags(config).bigHour = undefined;
        }

        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);

        configFromArray(config);
        checkOverflow(config);
    }


    function meridiemFixWrap (locale, hour, meridiem) {
        var isPm;

        if (meridiem == null) {
            // nothing to do
            return hour;
        }
        if (locale.meridiemHour != null) {
            return locale.meridiemHour(hour, meridiem);
        } else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) {
                hour += 12;
            }
            if (!isPm && hour === 12) {
                hour = 0;
            }
            return hour;
        } else {
            // this is not supposed to happen
            return hour;
        }
    }

    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig,
            bestMoment,

            scoreToBeat,
            i,
            currentScore;

        if (config._f.length === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }

        for (i = 0; i < config._f.length; i++) {
            currentScore = 0;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) {
                tempConfig._useUTC = config._useUTC;
            }
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);

            if (!isValid(tempConfig)) {
                continue;
            }

            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;

            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

            getParsingFlags(tempConfig).score = currentScore;

            if (scoreToBeat == null || currentScore < scoreToBeat) {
                scoreToBeat = currentScore;
                bestMoment = tempConfig;
            }
        }

        extend(config, bestMoment || tempConfig);
    }

    function configFromObject(config) {
        if (config._d) {
            return;
        }

        var i = normalizeObjectUnits(config._i);
        config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function (obj) {
            return obj && parseInt(obj, 10);
        });

        configFromArray(config);
    }

    function createFromConfig (config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }

        return res;
    }

    function prepareConfig (config) {
        var input = config._i,
            format = config._f;

        config._locale = config._locale || getLocale(config._l);

        if (input === null || (format === undefined && input === '')) {
            return createInvalid({nullInput: true});
        }

        if (typeof input === 'string') {
            config._i = input = config._locale.preparse(input);
        }

        if (isMoment(input)) {
            return new Moment(checkOverflow(input));
        } else if (isDate(input)) {
            config._d = input;
        } else if (isArray(format)) {
            configFromStringAndArray(config);
        } else if (format) {
            configFromStringAndFormat(config);
        }  else {
            configFromInput(config);
        }

        if (!isValid(config)) {
            config._d = null;
        }

        return config;
    }

    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) {
            config._d = new Date(hooks.now());
        } else if (isDate(input)) {
            config._d = new Date(input.valueOf());
        } else if (typeof input === 'string') {
            configFromString(config);
        } else if (isArray(input)) {
            config._a = map(input.slice(0), function (obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) {
            configFromObject(config);
        } else if (isNumber(input)) {
            // from milliseconds
            config._d = new Date(input);
        } else {
            hooks.createFromInputFallback(config);
        }
    }

    function createLocalOrUTC (input, format, locale, strict, isUTC) {
        var c = {};

        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }

        if ((isObject(input) && isObjectEmpty(input)) ||
                (isArray(input) && input.length === 0)) {
            input = undefined;
        }
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;

        return createFromConfig(c);
    }

    function createLocal (input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }

    var prototypeMin = deprecate(
        'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
        function () {
            var other = createLocal.apply(null, arguments);
            if (this.isValid() && other.isValid()) {
                return other < this ? this : other;
            } else {
                return createInvalid();
            }
        }
    );

    var prototypeMax = deprecate(
        'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
        function () {
            var other = createLocal.apply(null, arguments);
            if (this.isValid() && other.isValid()) {
                return other > this ? this : other;
            } else {
                return createInvalid();
            }
        }
    );

    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) {
            moments = moments[0];
        }
        if (!moments.length) {
            return createLocal();
        }
        res = moments[0];
        for (i = 1; i < moments.length; ++i) {
            if (!moments[i].isValid() || moments[i][fn](res)) {
                res = moments[i];
            }
        }
        return res;
    }

    // TODO: Use [].sort instead?
    function min () {
        var args = [].slice.call(arguments, 0);

        return pickBy('isBefore', args);
    }

    function max () {
        var args = [].slice.call(arguments, 0);

        return pickBy('isAfter', args);
    }

    var now = function () {
        return Date.now ? Date.now() : +(new Date());
    };

    var ordering = ['year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', 'millisecond'];

    function isDurationValid(m) {
        for (var key in m) {
            if (!(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) {
                return false;
            }
        }

        var unitHasDecimal = false;
        for (var i = 0; i < ordering.length; ++i) {
            if (m[ordering[i]]) {
                if (unitHasDecimal) {
                    return false; // only allow non-integers for smallest unit
                }
                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
                    unitHasDecimal = true;
                }
            }
        }

        return true;
    }

    function isValid$1() {
        return this._isValid;
    }

    function createInvalid$1() {
        return createDuration(NaN);
    }

    function Duration (duration) {
        var normalizedInput = normalizeObjectUnits(duration),
            years = normalizedInput.year || 0,
            quarters = normalizedInput.quarter || 0,
            months = normalizedInput.month || 0,
            weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
            days = normalizedInput.day || 0,
            hours = normalizedInput.hour || 0,
            minutes = normalizedInput.minute || 0,
            seconds = normalizedInput.second || 0,
            milliseconds = normalizedInput.millisecond || 0;

        this._isValid = isDurationValid(normalizedInput);

        // representation for dateAddRemove
        this._milliseconds = +milliseconds +
            seconds * 1e3 + // 1000
            minutes * 6e4 + // 1000 * 60
            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days +
            weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months +
            quarters * 3 +
            years * 12;

        this._data = {};

        this._locale = getLocale();

        this._bubble();
    }

    function isDuration (obj) {
        return obj instanceof Duration;
    }

    function absRound (number) {
        if (number < 0) {
            return Math.round(-1 * number) * -1;
        } else {
            return Math.round(number);
        }
    }

    // FORMATTING

    function offset (token, separator) {
        addFormatToken(token, 0, 0, function () {
            var offset = this.utcOffset();
            var sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~(offset) % 60, 2);
        });
    }

    offset('Z', ':');
    offset('ZZ', '');

    // PARSING

    addRegexToken('Z',  matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken(['Z', 'ZZ'], function (input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });

    // HELPERS

    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;

    function offsetFromString(matcher, string) {
        var matches = (string || '').match(matcher);

        if (matches === null) {
            return null;
        }

        var chunk   = matches[matches.length - 1] || [];
        var parts   = (chunk + '').match(chunkOffset) || ['-', 0, 0];
        var minutes = +(parts[1] * 60) + toInt(parts[2]);

        return minutes === 0 ?
          0 :
          parts[0] === '+' ? minutes : -minutes;
    }

    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else {
            return createLocal(input).local();
        }
    }

    function getDateOffset (m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
    }

    // HOOKS

    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function () {};

    // MOMENTS

    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset (input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0,
            localAdjust;
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) {
                    return this;
                }
            } else if (Math.abs(input) < 16 && !keepMinutes) {
                input = input * 60;
            }
            if (!this._isUTC && keepLocalTime) {
                localAdjust = getDateOffset(this);
            }
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) {
                this.add(localAdjust, 'm');
            }
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) {
                    addSubtract(this, createDuration(input - offset, 'm'), 1, false);
                } else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else {
            return this._isUTC ? offset : getDateOffset(this);
        }
    }

    function getSetZone (input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') {
                input = -input;
            }

            this.utcOffset(input, keepLocalTime);

            return this;
        } else {
            return -this.utcOffset();
        }
    }

    function setOffsetToUTC (keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }

    function setOffsetToLocal (keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;

            if (keepLocalTime) {
                this.subtract(getDateOffset(this), 'm');
            }
        }
        return this;
    }

    function setOffsetToParsedOffset () {
        if (this._tzm != null) {
            this.utcOffset(this._tzm, false, true);
        } else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) {
                this.utcOffset(tZone);
            }
            else {
                this.utcOffset(0, true);
            }
        }
        return this;
    }

    function hasAlignedHourOffset (input) {
        if (!this.isValid()) {
            return false;
        }
        input = input ? createLocal(input).utcOffset() : 0;

        return (this.utcOffset() - input) % 60 === 0;
    }

    function isDaylightSavingTime () {
        return (
            this.utcOffset() > this.clone().month(0).utcOffset() ||
            this.utcOffset() > this.clone().month(5).utcOffset()
        );
    }

    function isDaylightSavingTimeShifted () {
        if (!isUndefined(this._isDSTShifted)) {
            return this._isDSTShifted;
        }

        var c = {};

        copyConfig(c, this);
        c = prepareConfig(c);

        if (c._a) {
            var other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted = this.isValid() &&
                compareArrays(c._a, other.toArray()) > 0;
        } else {
            this._isDSTShifted = false;
        }

        return this._isDSTShifted;
    }

    function isLocal () {
        return this.isValid() ? !this._isUTC : false;
    }

    function isUtcOffset () {
        return this.isValid() ? this._isUTC : false;
    }

    function isUtc () {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }

    // ASP.NET json date format regex
    var aspNetRegex = /^(\-|\+)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/;

    // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
    // and further modified to allow for strings containing both week and day
    var isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

    function createDuration (input, key) {
        var duration = input,
            // matching against regexp is expensive, do it on demand
            match = null,
            sign,
            ret,
            diffRes;

        if (isDuration(input)) {
            duration = {
                ms : input._milliseconds,
                d  : input._days,
                M  : input._months
            };
        } else if (isNumber(input)) {
            duration = {};
            if (key) {
                duration[key] = input;
            } else {
                duration.milliseconds = input;
            }
        } else if (!!(match = aspNetRegex.exec(input))) {
            sign = (match[1] === '-') ? -1 : 1;
            duration = {
                y  : 0,
                d  : toInt(match[DATE])                         * sign,
                h  : toInt(match[HOUR])                         * sign,
                m  : toInt(match[MINUTE])                       * sign,
                s  : toInt(match[SECOND])                       * sign,
                ms : toInt(absRound(match[MILLISECOND] * 1000)) * sign // the millisecond decimal point is included in the match
            };
        } else if (!!(match = isoRegex.exec(input))) {
            sign = (match[1] === '-') ? -1 : 1;
            duration = {
                y : parseIso(match[2], sign),
                M : parseIso(match[3], sign),
                w : parseIso(match[4], sign),
                d : parseIso(match[5], sign),
                h : parseIso(match[6], sign),
                m : parseIso(match[7], sign),
                s : parseIso(match[8], sign)
            };
        } else if (duration == null) {// checks for null or undefined
            duration = {};
        } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
            diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));

            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }

        ret = new Duration(duration);

        if (isDuration(input) && hasOwnProp(input, '_locale')) {
            ret._locale = input._locale;
        }

        return ret;
    }

    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;

    function parseIso (inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }

    function positiveMomentsDifference(base, other) {
        var res = {milliseconds: 0, months: 0};

        res.months = other.month() - base.month() +
            (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) {
            --res.months;
        }

        res.milliseconds = +other - +(base.clone().add(res.months, 'M'));

        return res;
    }

    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) {
            return {milliseconds: 0, months: 0};
        }

        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) {
            res = positiveMomentsDifference(base, other);
        } else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }

        return res;
    }

    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function (val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(name, 'moment().' + name  + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' +
                'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
                tmp = val; val = period; period = tmp;
            }

            val = typeof val === 'string' ? +val : val;
            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }

    function addSubtract (mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds,
            days = absRound(duration._days),
            months = absRound(duration._months);

        if (!mom.isValid()) {
            // No op
            return;
        }

        updateOffset = updateOffset == null ? true : updateOffset;

        if (months) {
            setMonth(mom, get(mom, 'Month') + months * isAdding);
        }
        if (days) {
            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
        }
        if (milliseconds) {
            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        }
        if (updateOffset) {
            hooks.updateOffset(mom, days || months);
        }
    }

    var add      = createAdder(1, 'add');
    var subtract = createAdder(-1, 'subtract');

    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6 ? 'sameElse' :
                diff < -1 ? 'lastWeek' :
                diff < 0 ? 'lastDay' :
                diff < 1 ? 'sameDay' :
                diff < 2 ? 'nextDay' :
                diff < 7 ? 'nextWeek' : 'sameElse';
    }

    function calendar$1 (time, formats) {
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(),
            sod = cloneWithOffset(now, this).startOf('day'),
            format = hooks.calendarFormat(this, sod) || 'sameElse';

        var output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);

        return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
    }

    function clone () {
        return new Moment(this);
    }

    function isAfter (input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() > localInput.valueOf();
        } else {
            return localInput.valueOf() < this.clone().startOf(units).valueOf();
        }
    }

    function isBefore (input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() < localInput.valueOf();
        } else {
            return this.clone().endOf(units).valueOf() < localInput.valueOf();
        }
    }

    function isBetween (from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from),
            localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
            return false;
        }
        inclusivity = inclusivity || '()';
        return (inclusivity[0] === '(' ? this.isAfter(localFrom, units) : !this.isBefore(localFrom, units)) &&
            (inclusivity[1] === ')' ? this.isBefore(localTo, units) : !this.isAfter(localTo, units));
    }

    function isSame (input, units) {
        var localInput = isMoment(input) ? input : createLocal(input),
            inputMs;
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() === localInput.valueOf();
        } else {
            inputMs = localInput.valueOf();
            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
        }
    }

    function isSameOrAfter (input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }

    function isSameOrBefore (input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }

    function diff (input, units, asFloat) {
        var that,
            zoneDelta,
            output;

        if (!this.isValid()) {
            return NaN;
        }

        that = cloneWithOffset(input, this);

        if (!that.isValid()) {
            return NaN;
        }

        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

        units = normalizeUnits(units);

        switch (units) {
            case 'year': output = monthDiff(this, that) / 12; break;
            case 'month': output = monthDiff(this, that); break;
            case 'quarter': output = monthDiff(this, that) / 3; break;
            case 'second': output = (this - that) / 1e3; break; // 1000
            case 'minute': output = (this - that) / 6e4; break; // 1000 * 60
            case 'hour': output = (this - that) / 36e5; break; // 1000 * 60 * 60
            case 'day': output = (this - that - zoneDelta) / 864e5; break; // 1000 * 60 * 60 * 24, negate dst
            case 'week': output = (this - that - zoneDelta) / 6048e5; break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default: output = this - that;
        }

        return asFloat ? output : absFloor(output);
    }

    function monthDiff (a, b) {
        // difference in months
        var wholeMonthDiff = ((b.year() - a.year()) * 12) + (b.month() - a.month()),
            // b is in (anchor - 1 month, anchor + 1 month)
            anchor = a.clone().add(wholeMonthDiff, 'months'),
            anchor2, adjust;

        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }

        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }

    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

    function toString () {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }

    function toISOString(keepOffset) {
        if (!this.isValid()) {
            return null;
        }
        var utc = keepOffset !== true;
        var m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) {
            return formatMoment(m, utc ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ');
        }
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) {
                return this.toDate().toISOString();
            } else {
                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000).toISOString().replace('Z', formatMoment(m, 'Z'));
            }
        }
        return formatMoment(m, utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ');
    }

    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */
    function inspect () {
        if (!this.isValid()) {
            return 'moment.invalid(/* ' + this._i + ' */)';
        }
        var func = 'moment';
        var zone = '';
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
            zone = 'Z';
        }
        var prefix = '[' + func + '("]';
        var year = (0 <= this.year() && this.year() <= 9999) ? 'YYYY' : 'YYYYYY';
        var datetime = '-MM-DD[T]HH:mm:ss.SSS';
        var suffix = zone + '[")]';

        return this.format(prefix + year + datetime + suffix);
    }

    function format (inputString) {
        if (!inputString) {
            inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
        }
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }

    function from (time, withoutSuffix) {
        if (this.isValid() &&
                ((isMoment(time) && time.isValid()) ||
                 createLocal(time).isValid())) {
            return createDuration({to: this, from: time}).locale(this.locale()).humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function fromNow (withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }

    function to (time, withoutSuffix) {
        if (this.isValid() &&
                ((isMoment(time) && time.isValid()) ||
                 createLocal(time).isValid())) {
            return createDuration({from: this, to: time}).locale(this.locale()).humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function toNow (withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }

    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale (key) {
        var newLocaleData;

        if (key === undefined) {
            return this._locale._abbr;
        } else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) {
                this._locale = newLocaleData;
            }
            return this;
        }
    }

    var lang = deprecate(
        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
        function (key) {
            if (key === undefined) {
                return this.localeData();
            } else {
                return this.locale(key);
            }
        }
    );

    function localeData () {
        return this._locale;
    }

    function startOf (units) {
        units = normalizeUnits(units);
        // the following switch intentionally omits break keywords
        // to utilize falling through the cases.
        switch (units) {
            case 'year':
                this.month(0);
                /* falls through */
            case 'quarter':
            case 'month':
                this.date(1);
                /* falls through */
            case 'week':
            case 'isoWeek':
            case 'day':
            case 'date':
                this.hours(0);
                /* falls through */
            case 'hour':
                this.minutes(0);
                /* falls through */
            case 'minute':
                this.seconds(0);
                /* falls through */
            case 'second':
                this.milliseconds(0);
        }

        // weeks are a special case
        if (units === 'week') {
            this.weekday(0);
        }
        if (units === 'isoWeek') {
            this.isoWeekday(1);
        }

        // quarters are also special
        if (units === 'quarter') {
            this.month(Math.floor(this.month() / 3) * 3);
        }

        return this;
    }

    function endOf (units) {
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond') {
            return this;
        }

        // 'date' is an alias for 'day', so it should be considered as such.
        if (units === 'date') {
            units = 'day';
        }

        return this.startOf(units).add(1, (units === 'isoWeek' ? 'week' : units)).subtract(1, 'ms');
    }

    function valueOf () {
        return this._d.valueOf() - ((this._offset || 0) * 60000);
    }

    function unix () {
        return Math.floor(this.valueOf() / 1000);
    }

    function toDate () {
        return new Date(this.valueOf());
    }

    function toArray () {
        var m = this;
        return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
    }

    function toObject () {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds()
        };
    }

    function toJSON () {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }

    function isValid$2 () {
        return isValid(this);
    }

    function parsingFlags () {
        return extend({}, getParsingFlags(this));
    }

    function invalidAt () {
        return getParsingFlags(this).overflow;
    }

    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict
        };
    }

    // FORMATTING

    addFormatToken(0, ['gg', 2], 0, function () {
        return this.weekYear() % 100;
    });

    addFormatToken(0, ['GG', 2], 0, function () {
        return this.isoWeekYear() % 100;
    });

    function addWeekYearFormatToken (token, getter) {
        addFormatToken(0, [token, token.length], 0, getter);
    }

    addWeekYearFormatToken('gggg',     'weekYear');
    addWeekYearFormatToken('ggggg',    'weekYear');
    addWeekYearFormatToken('GGGG',  'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');

    // ALIASES

    addUnitAlias('weekYear', 'gg');
    addUnitAlias('isoWeekYear', 'GG');

    // PRIORITY

    addUnitPriority('weekYear', 1);
    addUnitPriority('isoWeekYear', 1);


    // PARSING

    addRegexToken('G',      matchSigned);
    addRegexToken('g',      matchSigned);
    addRegexToken('GG',     match1to2, match2);
    addRegexToken('gg',     match1to2, match2);
    addRegexToken('GGGG',   match1to4, match4);
    addRegexToken('gggg',   match1to4, match4);
    addRegexToken('GGGGG',  match1to6, match6);
    addRegexToken('ggggg',  match1to6, match6);

    addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
        week[token.substr(0, 2)] = toInt(input);
    });

    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });

    // MOMENTS

    function getSetWeekYear (input) {
        return getSetWeekYearHelper.call(this,
                input,
                this.week(),
                this.weekday(),
                this.localeData()._week.dow,
                this.localeData()._week.doy);
    }

    function getSetISOWeekYear (input) {
        return getSetWeekYearHelper.call(this,
                input, this.isoWeek(), this.isoWeekday(), 1, 4);
    }

    function getISOWeeksInYear () {
        return weeksInYear(this.year(), 1, 4);
    }

    function getWeeksInYear () {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }

    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) {
            return weekOfYear(this, dow, doy).year;
        } else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) {
                week = weeksTarget;
            }
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }

    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }

    // FORMATTING

    addFormatToken('Q', 0, 'Qo', 'quarter');

    // ALIASES

    addUnitAlias('quarter', 'Q');

    // PRIORITY

    addUnitPriority('quarter', 7);

    // PARSING

    addRegexToken('Q', match1);
    addParseToken('Q', function (input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });

    // MOMENTS

    function getSetQuarter (input) {
        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
    }

    // FORMATTING

    addFormatToken('D', ['DD', 2], 'Do', 'date');

    // ALIASES

    addUnitAlias('date', 'D');

    // PRIORITY
    addUnitPriority('date', 9);

    // PARSING

    addRegexToken('D',  match1to2);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function (isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict ?
          (locale._dayOfMonthOrdinalParse || locale._ordinalParse) :
          locale._dayOfMonthOrdinalParseLenient;
    });

    addParseToken(['D', 'DD'], DATE);
    addParseToken('Do', function (input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });

    // MOMENTS

    var getSetDayOfMonth = makeGetSet('Date', true);

    // FORMATTING

    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

    // ALIASES

    addUnitAlias('dayOfYear', 'DDD');

    // PRIORITY
    addUnitPriority('dayOfYear', 4);

    // PARSING

    addRegexToken('DDD',  match1to3);
    addRegexToken('DDDD', match3);
    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
        config._dayOfYear = toInt(input);
    });

    // HELPERS

    // MOMENTS

    function getSetDayOfYear (input) {
        var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
        return input == null ? dayOfYear : this.add((input - dayOfYear), 'd');
    }

    // FORMATTING

    addFormatToken('m', ['mm', 2], 0, 'minute');

    // ALIASES

    addUnitAlias('minute', 'm');

    // PRIORITY

    addUnitPriority('minute', 14);

    // PARSING

    addRegexToken('m',  match1to2);
    addRegexToken('mm', match1to2, match2);
    addParseToken(['m', 'mm'], MINUTE);

    // MOMENTS

    var getSetMinute = makeGetSet('Minutes', false);

    // FORMATTING

    addFormatToken('s', ['ss', 2], 0, 'second');

    // ALIASES

    addUnitAlias('second', 's');

    // PRIORITY

    addUnitPriority('second', 15);

    // PARSING

    addRegexToken('s',  match1to2);
    addRegexToken('ss', match1to2, match2);
    addParseToken(['s', 'ss'], SECOND);

    // MOMENTS

    var getSetSecond = makeGetSet('Seconds', false);

    // FORMATTING

    addFormatToken('S', 0, 0, function () {
        return ~~(this.millisecond() / 100);
    });

    addFormatToken(0, ['SS', 2], 0, function () {
        return ~~(this.millisecond() / 10);
    });

    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
    addFormatToken(0, ['SSSS', 4], 0, function () {
        return this.millisecond() * 10;
    });
    addFormatToken(0, ['SSSSS', 5], 0, function () {
        return this.millisecond() * 100;
    });
    addFormatToken(0, ['SSSSSS', 6], 0, function () {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
        return this.millisecond() * 1000000;
    });


    // ALIASES

    addUnitAlias('millisecond', 'ms');

    // PRIORITY

    addUnitPriority('millisecond', 16);

    // PARSING

    addRegexToken('S',    match1to3, match1);
    addRegexToken('SS',   match1to3, match2);
    addRegexToken('SSS',  match1to3, match3);

    var token;
    for (token = 'SSSS'; token.length <= 9; token += 'S') {
        addRegexToken(token, matchUnsigned);
    }

    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }

    for (token = 'S'; token.length <= 9; token += 'S') {
        addParseToken(token, parseMs);
    }
    // MOMENTS

    var getSetMillisecond = makeGetSet('Milliseconds', false);

    // FORMATTING

    addFormatToken('z',  0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');

    // MOMENTS

    function getZoneAbbr () {
        return this._isUTC ? 'UTC' : '';
    }

    function getZoneName () {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }

    var proto = Moment.prototype;

    proto.add               = add;
    proto.calendar          = calendar$1;
    proto.clone             = clone;
    proto.diff              = diff;
    proto.endOf             = endOf;
    proto.format            = format;
    proto.from              = from;
    proto.fromNow           = fromNow;
    proto.to                = to;
    proto.toNow             = toNow;
    proto.get               = stringGet;
    proto.invalidAt         = invalidAt;
    proto.isAfter           = isAfter;
    proto.isBefore          = isBefore;
    proto.isBetween         = isBetween;
    proto.isSame            = isSame;
    proto.isSameOrAfter     = isSameOrAfter;
    proto.isSameOrBefore    = isSameOrBefore;
    proto.isValid           = isValid$2;
    proto.lang              = lang;
    proto.locale            = locale;
    proto.localeData        = localeData;
    proto.max               = prototypeMax;
    proto.min               = prototypeMin;
    proto.parsingFlags      = parsingFlags;
    proto.set               = stringSet;
    proto.startOf           = startOf;
    proto.subtract          = subtract;
    proto.toArray           = toArray;
    proto.toObject          = toObject;
    proto.toDate            = toDate;
    proto.toISOString       = toISOString;
    proto.inspect           = inspect;
    proto.toJSON            = toJSON;
    proto.toString          = toString;
    proto.unix              = unix;
    proto.valueOf           = valueOf;
    proto.creationData      = creationData;
    proto.year       = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear    = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month       = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week           = proto.weeks        = getSetWeek;
    proto.isoWeek        = proto.isoWeeks     = getSetISOWeek;
    proto.weeksInYear    = getWeeksInYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.date       = getSetDayOfMonth;
    proto.day        = proto.days             = getSetDayOfWeek;
    proto.weekday    = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear  = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset            = getSetOffset;
    proto.utc                  = setOffsetToUTC;
    proto.local                = setOffsetToLocal;
    proto.parseZone            = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST                = isDaylightSavingTime;
    proto.isLocal              = isLocal;
    proto.isUtcOffset          = isUtcOffset;
    proto.isUtc                = isUtc;
    proto.isUTC                = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates  = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
    proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
    proto.years  = deprecate('years accessor is deprecated. Use year instead', getSetYear);
    proto.zone   = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
    proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);

    function createUnix (input) {
        return createLocal(input * 1000);
    }

    function createInZone () {
        return createLocal.apply(null, arguments).parseZone();
    }

    function preParsePostFormat (string) {
        return string;
    }

    var proto$1 = Locale.prototype;

    proto$1.calendar        = calendar;
    proto$1.longDateFormat  = longDateFormat;
    proto$1.invalidDate     = invalidDate;
    proto$1.ordinal         = ordinal;
    proto$1.preparse        = preParsePostFormat;
    proto$1.postformat      = preParsePostFormat;
    proto$1.relativeTime    = relativeTime;
    proto$1.pastFuture      = pastFuture;
    proto$1.set             = set;

    proto$1.months            =        localeMonths;
    proto$1.monthsShort       =        localeMonthsShort;
    proto$1.monthsParse       =        localeMonthsParse;
    proto$1.monthsRegex       = monthsRegex;
    proto$1.monthsShortRegex  = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;

    proto$1.weekdays       =        localeWeekdays;
    proto$1.weekdaysMin    =        localeWeekdaysMin;
    proto$1.weekdaysShort  =        localeWeekdaysShort;
    proto$1.weekdaysParse  =        localeWeekdaysParse;

    proto$1.weekdaysRegex       =        weekdaysRegex;
    proto$1.weekdaysShortRegex  =        weekdaysShortRegex;
    proto$1.weekdaysMinRegex    =        weekdaysMinRegex;

    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;

    function get$1 (format, index, field, setter) {
        var locale = getLocale();
        var utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }

    function listMonthsImpl (format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';

        if (index != null) {
            return get$1(format, index, field, 'month');
        }

        var i;
        var out = [];
        for (i = 0; i < 12; i++) {
            out[i] = get$1(format, i, field, 'month');
        }
        return out;
    }

    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl (localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;

            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        }

        var locale = getLocale(),
            shift = localeSorted ? locale._week.dow : 0;

        if (index != null) {
            return get$1(format, (index + shift) % 7, field, 'day');
        }

        var i;
        var out = [];
        for (i = 0; i < 7; i++) {
            out[i] = get$1(format, (i + shift) % 7, field, 'day');
        }
        return out;
    }

    function listMonths (format, index) {
        return listMonthsImpl(format, index, 'months');
    }

    function listMonthsShort (format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }

    function listWeekdays (localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }

    function listWeekdaysShort (localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }

    function listWeekdaysMin (localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }

    getSetGlobalLocale('en', {
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (toInt(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
            return number + output;
        }
    });

    // Side effect imports

    hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
    hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);

    var mathAbs = Math.abs;

    function abs () {
        var data           = this._data;

        this._milliseconds = mathAbs(this._milliseconds);
        this._days         = mathAbs(this._days);
        this._months       = mathAbs(this._months);

        data.milliseconds  = mathAbs(data.milliseconds);
        data.seconds       = mathAbs(data.seconds);
        data.minutes       = mathAbs(data.minutes);
        data.hours         = mathAbs(data.hours);
        data.months        = mathAbs(data.months);
        data.years         = mathAbs(data.years);

        return this;
    }

    function addSubtract$1 (duration, input, value, direction) {
        var other = createDuration(input, value);

        duration._milliseconds += direction * other._milliseconds;
        duration._days         += direction * other._days;
        duration._months       += direction * other._months;

        return duration._bubble();
    }

    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1 (input, value) {
        return addSubtract$1(this, input, value, 1);
    }

    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1 (input, value) {
        return addSubtract$1(this, input, value, -1);
    }

    function absCeil (number) {
        if (number < 0) {
            return Math.floor(number);
        } else {
            return Math.ceil(number);
        }
    }

    function bubble () {
        var milliseconds = this._milliseconds;
        var days         = this._days;
        var months       = this._months;
        var data         = this._data;
        var seconds, minutes, hours, years, monthsFromDays;

        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (!((milliseconds >= 0 && days >= 0 && months >= 0) ||
                (milliseconds <= 0 && days <= 0 && months <= 0))) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }

        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;

        seconds           = absFloor(milliseconds / 1000);
        data.seconds      = seconds % 60;

        minutes           = absFloor(seconds / 60);
        data.minutes      = minutes % 60;

        hours             = absFloor(minutes / 60);
        data.hours        = hours % 24;

        days += absFloor(hours / 24);

        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        data.days   = days;
        data.months = months;
        data.years  = years;

        return this;
    }

    function daysToMonths (days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return days * 4800 / 146097;
    }

    function monthsToDays (months) {
        // the reverse of daysToMonths
        return months * 146097 / 4800;
    }

    function as (units) {
        if (!this.isValid()) {
            return NaN;
        }
        var days;
        var months;
        var milliseconds = this._milliseconds;

        units = normalizeUnits(units);

        if (units === 'month' || units === 'year') {
            days   = this._days   + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            return units === 'month' ? months : months / 12;
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch (units) {
                case 'week'   : return days / 7     + milliseconds / 6048e5;
                case 'day'    : return days         + milliseconds / 864e5;
                case 'hour'   : return days * 24    + milliseconds / 36e5;
                case 'minute' : return days * 1440  + milliseconds / 6e4;
                case 'second' : return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond': return Math.floor(days * 864e5) + milliseconds;
                default: throw new Error('Unknown unit ' + units);
            }
        }
    }

    // TODO: Use this.as('ms')?
    function valueOf$1 () {
        if (!this.isValid()) {
            return NaN;
        }
        return (
            this._milliseconds +
            this._days * 864e5 +
            (this._months % 12) * 2592e6 +
            toInt(this._months / 12) * 31536e6
        );
    }

    function makeAs (alias) {
        return function () {
            return this.as(alias);
        };
    }

    var asMilliseconds = makeAs('ms');
    var asSeconds      = makeAs('s');
    var asMinutes      = makeAs('m');
    var asHours        = makeAs('h');
    var asDays         = makeAs('d');
    var asWeeks        = makeAs('w');
    var asMonths       = makeAs('M');
    var asYears        = makeAs('y');

    function clone$1 () {
        return createDuration(this);
    }

    function get$2 (units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + 's']() : NaN;
    }

    function makeGetter(name) {
        return function () {
            return this.isValid() ? this._data[name] : NaN;
        };
    }

    var milliseconds = makeGetter('milliseconds');
    var seconds      = makeGetter('seconds');
    var minutes      = makeGetter('minutes');
    var hours        = makeGetter('hours');
    var days         = makeGetter('days');
    var months       = makeGetter('months');
    var years        = makeGetter('years');

    function weeks () {
        return absFloor(this.days() / 7);
    }

    var round = Math.round;
    var thresholds = {
        ss: 44,         // a few seconds to seconds
        s : 45,         // seconds to minute
        m : 45,         // minutes to hour
        h : 22,         // hours to day
        d : 26,         // days to month
        M : 11          // months to year
    };

    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }

    function relativeTime$1 (posNegDuration, withoutSuffix, locale) {
        var duration = createDuration(posNegDuration).abs();
        var seconds  = round(duration.as('s'));
        var minutes  = round(duration.as('m'));
        var hours    = round(duration.as('h'));
        var days     = round(duration.as('d'));
        var months   = round(duration.as('M'));
        var years    = round(duration.as('y'));

        var a = seconds <= thresholds.ss && ['s', seconds]  ||
                seconds < thresholds.s   && ['ss', seconds] ||
                minutes <= 1             && ['m']           ||
                minutes < thresholds.m   && ['mm', minutes] ||
                hours   <= 1             && ['h']           ||
                hours   < thresholds.h   && ['hh', hours]   ||
                days    <= 1             && ['d']           ||
                days    < thresholds.d   && ['dd', days]    ||
                months  <= 1             && ['M']           ||
                months  < thresholds.M   && ['MM', months]  ||
                years   <= 1             && ['y']           || ['yy', years];

        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }

    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding (roundingFunction) {
        if (roundingFunction === undefined) {
            return round;
        }
        if (typeof(roundingFunction) === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }

    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold (threshold, limit) {
        if (thresholds[threshold] === undefined) {
            return false;
        }
        if (limit === undefined) {
            return thresholds[threshold];
        }
        thresholds[threshold] = limit;
        if (threshold === 's') {
            thresholds.ss = limit - 1;
        }
        return true;
    }

    function humanize (withSuffix) {
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var locale = this.localeData();
        var output = relativeTime$1(this, !withSuffix, locale);

        if (withSuffix) {
            output = locale.pastFuture(+this, output);
        }

        return locale.postformat(output);
    }

    var abs$1 = Math.abs;

    function sign(x) {
        return ((x > 0) - (x < 0)) || +x;
    }

    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var seconds = abs$1(this._milliseconds) / 1000;
        var days         = abs$1(this._days);
        var months       = abs$1(this._months);
        var minutes, hours, years;

        // 3600 seconds -> 60 minutes -> 1 hour
        minutes           = absFloor(seconds / 60);
        hours             = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;

        // 12 months -> 1 year
        years  = absFloor(months / 12);
        months %= 12;


        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        var Y = years;
        var M = months;
        var D = days;
        var h = hours;
        var m = minutes;
        var s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
        var total = this.asSeconds();

        if (!total) {
            // this is the same as C#'s (Noda) and python (isodate)...
            // but not other JS (goog.date)
            return 'P0D';
        }

        var totalSign = total < 0 ? '-' : '';
        var ymSign = sign(this._months) !== sign(total) ? '-' : '';
        var daysSign = sign(this._days) !== sign(total) ? '-' : '';
        var hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';

        return totalSign + 'P' +
            (Y ? ymSign + Y + 'Y' : '') +
            (M ? ymSign + M + 'M' : '') +
            (D ? daysSign + D + 'D' : '') +
            ((h || m || s) ? 'T' : '') +
            (h ? hmsSign + h + 'H' : '') +
            (m ? hmsSign + m + 'M' : '') +
            (s ? hmsSign + s + 'S' : '');
    }

    var proto$2 = Duration.prototype;

    proto$2.isValid        = isValid$1;
    proto$2.abs            = abs;
    proto$2.add            = add$1;
    proto$2.subtract       = subtract$1;
    proto$2.as             = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds      = asSeconds;
    proto$2.asMinutes      = asMinutes;
    proto$2.asHours        = asHours;
    proto$2.asDays         = asDays;
    proto$2.asWeeks        = asWeeks;
    proto$2.asMonths       = asMonths;
    proto$2.asYears        = asYears;
    proto$2.valueOf        = valueOf$1;
    proto$2._bubble        = bubble;
    proto$2.clone          = clone$1;
    proto$2.get            = get$2;
    proto$2.milliseconds   = milliseconds;
    proto$2.seconds        = seconds;
    proto$2.minutes        = minutes;
    proto$2.hours          = hours;
    proto$2.days           = days;
    proto$2.weeks          = weeks;
    proto$2.months         = months;
    proto$2.years          = years;
    proto$2.humanize       = humanize;
    proto$2.toISOString    = toISOString$1;
    proto$2.toString       = toISOString$1;
    proto$2.toJSON         = toISOString$1;
    proto$2.locale         = locale;
    proto$2.localeData     = localeData;

    proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
    proto$2.lang = lang;

    // Side effect imports

    // FORMATTING

    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');

    // PARSING

    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function (input, array, config) {
        config._d = new Date(parseFloat(input, 10) * 1000);
    });
    addParseToken('x', function (input, array, config) {
        config._d = new Date(toInt(input));
    });

    // Side effect imports


    hooks.version = '2.23.0';

    setHookCallback(createLocal);

    hooks.fn                    = proto;
    hooks.min                   = min;
    hooks.max                   = max;
    hooks.now                   = now;
    hooks.utc                   = createUTC;
    hooks.unix                  = createUnix;
    hooks.months                = listMonths;
    hooks.isDate                = isDate;
    hooks.locale                = getSetGlobalLocale;
    hooks.invalid               = createInvalid;
    hooks.duration              = createDuration;
    hooks.isMoment              = isMoment;
    hooks.weekdays              = listWeekdays;
    hooks.parseZone             = createInZone;
    hooks.localeData            = getLocale;
    hooks.isDuration            = isDuration;
    hooks.monthsShort           = listMonthsShort;
    hooks.weekdaysMin           = listWeekdaysMin;
    hooks.defineLocale          = defineLocale;
    hooks.updateLocale          = updateLocale;
    hooks.locales               = listLocales;
    hooks.weekdaysShort         = listWeekdaysShort;
    hooks.normalizeUnits        = normalizeUnits;
    hooks.relativeTimeRounding  = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat        = getCalendarFormat;
    hooks.prototype             = proto;

    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm',             // <input type="datetime-local" />
        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss',  // <input type="datetime-local" step="1" />
        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS',   // <input type="datetime-local" step="0.001" />
        DATE: 'YYYY-MM-DD',                             // <input type="date" />
        TIME: 'HH:mm',                                  // <input type="time" />
        TIME_SECONDS: 'HH:mm:ss',                       // <input type="time" step="1" />
        TIME_MS: 'HH:mm:ss.SSS',                        // <input type="time" step="0.001" />
        WEEK: 'GGGG-[W]WW',                             // <input type="week" />
        MONTH: 'YYYY-MM'                                // <input type="month" />
    };

    return hooks;

})));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(248)(module)))

/***/ }),
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return keyCodes; });
/* harmony export (immutable) */ __webpack_exports__["f"] = getMonth;
/* harmony export (immutable) */ __webpack_exports__["h"] = getWeek;
/* harmony export (immutable) */ __webpack_exports__["i"] = getWeeksInMonth;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ScrollSpeed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return scrollbarSize; });
/* harmony export (immutable) */ __webpack_exports__["d"] = emptyFn;
/* harmony export (immutable) */ __webpack_exports__["l"] = sanitizeDate;
/* harmony export (immutable) */ __webpack_exports__["e"] = getDateString;
/* harmony export (immutable) */ __webpack_exports__["g"] = getMonthsForYear;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return withImmutableProps; });
/* harmony export (immutable) */ __webpack_exports__["c"] = debounce;
/* harmony export (immutable) */ __webpack_exports__["k"] = range;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_recompose_withPropsOnChange__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_recompose_withPropsOnChange___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_recompose_withPropsOnChange__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_dom_helpers_util_scrollbarSize__ = __webpack_require__(323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_dom_helpers_util_scrollbarSize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_dom_helpers_util_scrollbarSize__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_date_fns_get_days_in_month__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_date_fns_get_days_in_month___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_date_fns_get_days_in_month__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_date_fns_get_day__ = __webpack_require__(384);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_date_fns_get_day___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_date_fns_get_day__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_date_fns_is_after__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_date_fns_is_after___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_date_fns_is_after__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_date_fns_is_before__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_date_fns_is_before___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_date_fns_is_before__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_date_fns_is_same_day__ = __webpack_require__(606);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_date_fns_is_same_day___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_date_fns_is_same_day__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_date_fns_end_of_day__ = __webpack_require__(260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_date_fns_end_of_day___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_date_fns_end_of_day__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_date_fns_start_of_day__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_date_fns_start_of_day___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_date_fns_start_of_day__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__animate__ = __webpack_require__(2389);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_9__animate__["a"]; });


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }











var keyCodes = {
  command: 91,
  control: 17,
  down: 40,
  enter: 13,
  escape: 27,
  left: 37,
  right: 39,
  shift: 16,
  up: 38
};

/**
 * Given a year and a month, returns the rows for that month to be iterated over
 * @param {Number} year - the year number
 * @param {Number} month - the index of the month
 * @param {Number} weekStartsOn - the index of the first day of the week (from 0 to 6)
 * @return {Object} - Returns the first day of the month and the rows of that month
 */
function getMonth(year, month, weekStartsOn) {
  var rows = [];
  var monthDate = new Date(year, month, 1);
  var daysInMonth = __WEBPACK_IMPORTED_MODULE_2_date_fns_get_days_in_month___default()(monthDate);
  var weekEndsOn = getEndOfWeekIndex(weekStartsOn);

  var dow = __WEBPACK_IMPORTED_MODULE_3_date_fns_get_day___default()(new Date(year, month, 1));
  var week = 0;

  for (var day = 1; day <= daysInMonth; day++) {
    if (!rows[week]) {
      rows[week] = [];
    }

    rows[week].push(day);

    if (dow === weekEndsOn) {
      week++;
    }

    dow = dow < 6 ? dow + 1 : 0;
  }

  return {
    date: monthDate,
    rows: rows
  };
}

function getWeek(yearStart, date, weekStartsOn) {
  var yearStartDate = typeof yearStart === 'number' ? new Date(yearStart, 0, 1) // 1st Jan of the Year
  : yearStart;

  return Math.ceil((Math.round((date - yearStartDate) / (60 * 60 * 24 * 1000)) + yearStartDate.getDay() + 1 - weekStartsOn) / 7);
}

/**
 * Get the number of weeks in a given month to be able to calculate the height of that month
 * @param {Number} year - the year number
 * @param {Number} month - the index of the month
 * @param {Number} weekStartsOn - the index of the first day of the week (from 0 to 6)
 * @return {Number} - Returns the number of weeks for the given month
 */
function getWeeksInMonth(month) {
  var year = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Date().getFullYear();
  var weekStartsOn = arguments[2];
  var isLastDisplayedMonth = arguments[3];

  var weekEndsOn = getEndOfWeekIndex(weekStartsOn);

  var firstOfMonth = new Date(year, month, 1);
  var firstWeekNumber = getWeek(year, firstOfMonth, weekStartsOn);

  var lastOfMonth = new Date(year, month + 1, 0); // Last date of the Month
  var lastWeekNumber = getWeek(year, lastOfMonth, weekStartsOn);

  var rowCount = lastWeekNumber - firstWeekNumber;

  // If the last week contains 7 days, we need to add an extra row
  if (lastOfMonth.getDay() === weekEndsOn || isLastDisplayedMonth) {
    rowCount++;
  }

  return rowCount;
}

/**
 * Helper to find out what day the week ends on given the localized start of the week
 * @param {Number} weekStartsOn - the index of the first day of the week (from 0 to 6)
 * @return {Number} - Returns the index of the day the week ends on
 */
function getEndOfWeekIndex(weekStartsOn) {
  var weekEndsOn = weekStartsOn === 0 ? 6 : weekStartsOn - 1;

  return weekEndsOn;
}

var ScrollSpeed = function () {
  function ScrollSpeed() {
    var _this = this;

    _classCallCheck(this, ScrollSpeed);

    this.clear = function () {
      _this.lastPosition = null;
      _this.delta = 0;
    };
  }

  ScrollSpeed.prototype.getScrollSpeed = function getScrollSpeed(scrollOffset) {
    if (this.lastPosition != null) {
      this.delta = scrollOffset - this.lastPosition;
    }
    this.lastPosition = scrollOffset;

    clearTimeout(this._timeout);
    this._timeout = setTimeout(this.clear, 50);

    return this.delta;
  };

  return ScrollSpeed;
}();

var scrollbarSize = __WEBPACK_IMPORTED_MODULE_1_dom_helpers_util_scrollbarSize___default()();

function emptyFn() {
  /* no-op */
}

function sanitizeDate(date, _ref) {
  var _ref$disabledDates = _ref.disabledDates,
      disabledDates = _ref$disabledDates === undefined ? [] : _ref$disabledDates,
      _ref$disabledDays = _ref.disabledDays,
      disabledDays = _ref$disabledDays === undefined ? [] : _ref$disabledDays,
      minDate = _ref.minDate,
      maxDate = _ref.maxDate;

  // Selected date should not be disabled or outside the selectable range
  if (!date || disabledDates.some(function (disabledDate) {
    return __WEBPACK_IMPORTED_MODULE_6_date_fns_is_same_day___default()(disabledDate, date);
  }) || disabledDays && disabledDays.indexOf(__WEBPACK_IMPORTED_MODULE_3_date_fns_get_day___default()(date)) !== -1 || minDate && __WEBPACK_IMPORTED_MODULE_5_date_fns_is_before___default()(date, __WEBPACK_IMPORTED_MODULE_8_date_fns_start_of_day___default()(minDate)) || maxDate && __WEBPACK_IMPORTED_MODULE_4_date_fns_is_after___default()(date, __WEBPACK_IMPORTED_MODULE_7_date_fns_end_of_day___default()(maxDate))) {
    return null;
  }

  return date;
}

function getDateString(year, month, date) {
  return year + '-' + ('0' + (month + 1)).slice(-2) + '-' + ('0' + date).slice(-2);
}

function getMonthsForYear(year) {
  var day = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

  return Array.apply(null, Array(12)).map(function (val, index) {
    return new Date(year, index, day);
  });
}

var withImmutableProps = function withImmutableProps(props) {
  return __WEBPACK_IMPORTED_MODULE_0_recompose_withPropsOnChange___default()(function () {
    return false;
  }, props);
};

function debounce(callback, wait) {
  var _this2 = this;

  var timeout = null;
  var callbackArgs = null;

  var later = function later() {
    return callback.apply(_this2, callbackArgs);
  };

  return function () {
    callbackArgs = arguments;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
}

function range(start, stop) {
  var step = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;

  var length = Math.max(Math.ceil((stop - start) / step), 0);
  var range = Array(length);

  for (var i = 0; i < length; i++, start += step) {
    range[i] = start;
  }

  return range;
};



/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = SearchDataSet;
function SearchDataSet(dataSet,values,inc){var filteredData=[];dataSet.map(function(d){var allData=[];Object.keys(d).map(function(c){if(inc.includes(c)&&!isEmptyOrSpaces(d[c])){var cVals=d[c].toLowerCase().split(" ");cVals.map(function(cval){allData.push(cval.toLowerCase());return cval;});}return c;});var cc=true;values.map(function(v){if(!allData.some(function(a){return a.includes(v.toLowerCase());})){cc=false;}return v;});if(cc){filteredData.push(d);}return d;});return filteredData;}function isEmptyOrSpaces(str){return!str||str===null||str.match(/^ *$/)!==null;}

/***/ }),
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core__ = __webpack_require__(4);
var CustomCardHeading=function CustomCardHeading(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["Z" /* Typography */],{variant:"subheading",className:"centerCell"},props.subheading),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["Z" /* Typography */],{variant:"caption",className:"centerCell"},props.caption),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:{borderBottom:"1px solid #cccccc69",margin:"5px auto",width:"25%"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["Z" /* Typography */],{variant:"headline",className:"centerCell",style:{marginBottom:"35px"}},props.headline));};/* harmony default export */ __webpack_exports__["a"] = (CustomCardHeading);

/***/ }),
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_observers_mixin__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__point__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__size__ = __webpack_require__(276);





var Rect = (function (Class) {
    function Rect(origin, size) {
        if ( origin === void 0 ) origin = new __WEBPACK_IMPORTED_MODULE_2__point__["a" /* default */]();
        if ( size === void 0 ) size = new __WEBPACK_IMPORTED_MODULE_3__size__["a" /* default */]();

        Class.call(this);

        this.setOrigin(origin);
        this.setSize(size);
    }

    if ( Class ) Rect.__proto__ = Class;
    Rect.prototype = Object.create( Class && Class.prototype );
    Rect.prototype.constructor = Rect;

    Rect.prototype.clone = function clone () {
        return new Rect(
            this.origin.clone(),
            this.size.clone()
        );
    };

    Rect.prototype.equals = function equals (other) {
        return other &&
               other.origin.equals(this.origin) &&
               other.size.equals(this.size);
    };

    Rect.prototype.setOrigin = function setOrigin (value) {
        this._observerField("origin", __WEBPACK_IMPORTED_MODULE_2__point__["a" /* default */].create(value));
        this.geometryChange();
        return this;
    };

    Rect.prototype.getOrigin = function getOrigin () {
        return this.origin;
    };

    Rect.prototype.setSize = function setSize (value) {
        this._observerField("size", __WEBPACK_IMPORTED_MODULE_3__size__["a" /* default */].create(value));
        this.geometryChange();
        return this;
    };

    Rect.prototype.getSize = function getSize () {
        return this.size;
    };

    Rect.prototype.width = function width () {
        return this.size.width;
    };

    Rect.prototype.height = function height () {
        return this.size.height;
    };

    Rect.prototype.topLeft = function topLeft () {
        return this.origin.clone();
    };

    Rect.prototype.bottomRight = function bottomRight () {
        return this.origin.clone().translate(this.width(), this.height());
    };

    Rect.prototype.topRight = function topRight () {
        return this.origin.clone().translate(this.width(), 0);
    };

    Rect.prototype.bottomLeft = function bottomLeft () {
        return this.origin.clone().translate(0, this.height());
    };

    Rect.prototype.center = function center () {
        return this.origin.clone().translate(this.width() / 2, this.height() / 2);
    };

    Rect.prototype.bbox = function bbox (matrix) {
        var tl = this.topLeft().transformCopy(matrix);
        var tr = this.topRight().transformCopy(matrix);
        var br = this.bottomRight().transformCopy(matrix);
        var bl = this.bottomLeft().transformCopy(matrix);

        return Rect.fromPoints(tl, tr, br, bl);
    };

    Rect.prototype.transformCopy = function transformCopy (m) {
        return Rect.fromPoints(
            this.topLeft().transform(m),
            this.bottomRight().transform(m)
        );
    };

    Rect.prototype.expand = function expand (x, y) {
        if ( y === void 0 ) y = x;


        this.size.width += 2 * x;
        this.size.height += 2 * y;

        this.origin.translate(-x, -y);

        return this;
    };

    Rect.prototype.expandCopy = function expandCopy (x, y) {
        return this.clone().expand(x, y);
    };

    Rect.prototype.containsPoint = function containsPoint (point) {
        var origin = this.origin;
        var bottomRight = this.bottomRight();
        return !(point.x < origin.x || point.y < origin.y || bottomRight.x < point.x || bottomRight.y < point.y);
    };

    Rect.prototype._isOnPath = function _isOnPath (point, width) {
        var rectOuter = this.expandCopy(width, width);
        var rectInner = this.expandCopy(-width, -width);

        return rectOuter.containsPoint(point) && !rectInner.containsPoint(point);
    };

    Rect.fromPoints = function fromPoints () {
        var topLeft = __WEBPACK_IMPORTED_MODULE_2__point__["a" /* default */].min.apply(null, arguments);
        var bottomRight = __WEBPACK_IMPORTED_MODULE_2__point__["a" /* default */].max.apply(null, arguments);
        var size = new __WEBPACK_IMPORTED_MODULE_3__size__["a" /* default */](
            bottomRight.x - topLeft.x,
            bottomRight.y - topLeft.y
        );

        return new Rect(topLeft, size);
    };

    Rect.union = function union (a, b) {
        return Rect.fromPoints(
            __WEBPACK_IMPORTED_MODULE_2__point__["a" /* default */].min(a.topLeft(), b.topLeft()),
            __WEBPACK_IMPORTED_MODULE_2__point__["a" /* default */].max(a.bottomRight(), b.bottomRight())
        );
    };

    Rect.intersect = function intersect (a, b) {
        var rect1 = {
            left: a.topLeft().x,
            top: a.topLeft().y,
            right: a.bottomRight().x,
            bottom: a.bottomRight().y
        };

        var rect2 = {
            left: b.topLeft().x,
            top: b.topLeft().y,
            right: b.bottomRight().x,
            bottom: b.bottomRight().y
        };

        if (rect1.left <= rect2.right &&
            rect2.left <= rect1.right &&
            rect1.top <= rect2.bottom &&
            rect2.top <= rect1.bottom) {
            return Rect.fromPoints(
                new __WEBPACK_IMPORTED_MODULE_2__point__["a" /* default */](Math.max(rect1.left, rect2.left), Math.max(rect1.top, rect2.top)),
                new __WEBPACK_IMPORTED_MODULE_2__point__["a" /* default */](Math.min(rect1.right, rect2.right), Math.min(rect1.bottom, rect2.bottom))
            );
        }
    };

    return Rect;
}(__WEBPACK_IMPORTED_MODULE_1__common__["a" /* Class */]));

__WEBPACK_IMPORTED_MODULE_0__mixins_observers_mixin__["a" /* default */].extend(Rect.prototype);

/* harmony default export */ __webpack_exports__["a"] = (Rect);

/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return drawerWidth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return drawerMiniWidth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return transition; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return container; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return containerFluid; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return boxShadow; });
/* unused harmony export card */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return defaultFont; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return primaryColor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return warningColor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return dangerColor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return successColor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return infoColor; });
/* unused harmony export deepPurple */
/* unused harmony export deepPurpleSecondary */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return roseColor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return grayColor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return primaryBoxShadow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return infoBoxShadow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return successBoxShadow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return warningBoxShadow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return dangerBoxShadow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return roseBoxShadow; });
/* unused harmony export orangeCardHeader */
/* unused harmony export greenCardHeader */
/* unused harmony export redCardHeader */
/* unused harmony export blueCardHeader */
/* unused harmony export purpleCardHeader */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return roseCardHeader; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return deepPurpleCardHeader; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return yellowCardHeader; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return grayBlueCardHeader; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return sqPurpleCardHeader; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return sqPurpleSecondCardHeader; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return sqOrangeCardHeader; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return sqLightBlueCardHeader; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return warningCardHeader; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return successCardHeader; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return dangerCardHeader; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return infoCardHeader; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return primaryCardHeader; });
/* unused harmony export cardActions */
/* unused harmony export cardHeader */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return defaultBoxShadow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return tooltip; });
/* unused harmony export title */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return cardTitle; });
/* unused harmony export cardSubtitle */
/* unused harmony export cardLink */
/*!

 =========================================================
 * Material Dashboard PRO React - v1.2.0 based on Material Dashboard PRO - v1.2.1
 =========================================================

 * Product Page: https://www.creative-tim.com/product/material-dashboard-react
 * Copyright 2018 Creative Tim (https://www.creative-tim.com)
 * Licensed under MIT (https://github.com/creativetimofficial/material-dashboard-react/blob/master/LICENSE.md)

 =========================================================

 * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

 */// ##############################
// // // Variables - Styles that are used on more than one component
// #############################
var drawerWidth=200;var drawerMiniWidth=80;var transition={transition:"all 0.33s cubic-bezier(0.685, 0.0473, 0.346, 1)"};var containerFluid={paddingRight:"15px",paddingLeft:"15px",marginRight:"auto",marginLeft:"auto","&:before,&:after":{display:"table",content:'" "'},"&:after":{clear:"both"}};var container={paddingRight:"15px",paddingLeft:"15px",marginRight:"auto",marginLeft:"auto","@media (min-width: 768px)":{width:"750px"},"@media (min-width: 992px)":{width:"970px"},"@media (min-width: 1200px)":{width:"1170px"},"&:before,&:after":{display:"table",content:'" "'},"&:after":{clear:"both"}};var boxShadow={boxShadow:"0 10px 30px -12px rgba(0, 0, 0, 0.42), 0 4px 25px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(0, 0, 0, 0.2)"};var card={display:"inline-block",position:"relative",width:"100%",margin:"25px 0",boxShadow:"0 1px 4px 0 rgba(0, 0, 0, 0.14)",borderRadius:"6px",color:"rgba(0, 0, 0, 0.87)",background:"#fff"};var defaultFont={fontFamily:'"Roboto", "Helvetica", "Arial", sans-serif',fontWeight:"300",lineHeight:"1.5em"};var primaryColor="#9c27b0";var warningColor="#ff9800";var dangerColor="#f44336";var successColor="#4caf50";var infoColor="#00acc1";var deepPurple="#555270";var deepPurpleSecondary="#5346cc";var roseColor="#e91e63";var grayColor="#999999";var primaryBoxShadow={boxShadow:"0 12px 20px -10px rgba(156, 39, 176, 0.28), 0 4px 20px 0px rgba(0, 0, 0, 0.12), 0 7px 8px -5px rgba(156, 39, 176, 0.2)"};var deepPurpleBoxShadow={boxShadow:"0 4px 20px 0px rgba(0, 0, 0, 0.14), 0 7px 10px -5px rgb(78, 76, 107)"};var infoBoxShadow={boxShadow:"0 12px 20px -10px rgba(0, 188, 212, 0.28), 0 4px 20px 0px rgba(0, 0, 0, 0.12), 0 7px 8px -5px rgba(0, 188, 212, 0.2)"};var successBoxShadow={boxShadow:"0 12px 20px -10px rgba(76, 175, 80, 0.28), 0 4px 20px 0px rgba(0, 0, 0, 0.12), 0 7px 8px -5px rgba(76, 175, 80, 0.2)"};var warningBoxShadow={boxShadow:"0 12px 20px -10px rgba(255, 152, 0, 0.28), 0 4px 20px 0px rgba(0, 0, 0, 0.12), 0 7px 8px -5px rgba(255, 152, 0, 0.2)"};var dangerBoxShadow={boxShadow:"0 12px 20px -10px rgba(244, 67, 54, 0.28), 0 4px 20px 0px rgba(0, 0, 0, 0.12), 0 7px 8px -5px rgba(244, 67, 54, 0.2)"};var roseBoxShadow={boxShadow:"0 4px 20px 0px rgba(0, 0, 0, 0.14), 0 7px 10px -5px rgba(233, 30, 99, 0.4)"};// old card headers
var orangeCardHeader=Object.assign({background:"linear-gradient(60deg, #ffa726, #fb8c00)"},warningBoxShadow);var greenCardHeader=Object.assign({background:"linear-gradient(60deg, #66bb6a, #43a047)"},successBoxShadow);var redCardHeader=Object.assign({background:"linear-gradient(60deg, #ef5350, #e53935)"},dangerBoxShadow);var blueCardHeader=Object.assign({background:"linear-gradient(60deg, #26c6da, #00acc1)"},infoBoxShadow);var purpleCardHeader=Object.assign({background:"linear-gradient(60deg, #ab47bc, #8e24aa)"},primaryBoxShadow);// new card headers
var warningCardHeader=Object.assign({background:"linear-gradient(60deg, #ffa726, #fb8c00)"},warningBoxShadow);var successCardHeader=Object.assign({background:"linear-gradient(60deg, #66bb6a, #43a047)"},successBoxShadow);var dangerCardHeader=Object.assign({background:"linear-gradient(60deg, #ef5350, #e53935)"},dangerBoxShadow);var infoCardHeader=Object.assign({background:"linear-gradient(60deg, #26c6da, #00acc1)"},infoBoxShadow);var primaryCardHeader=Object.assign({background:"linear-gradient(60deg, #ab47bc, #8e24aa)"},primaryBoxShadow);var roseCardHeader=Object.assign({background:"linear-gradient(60deg, #ec407a, #d81b60)"},roseBoxShadow);var deepPurpleCardHeader=Object.assign({background:"linear-gradient(30deg, #55526f, #1f1858)"},deepPurpleBoxShadow);var yellowCardHeader=Object.assign({background:"linear-gradient(60deg, #e0bd7d, #d28e11)"},deepPurpleBoxShadow);var grayBlueCardHeader=Object.assign({background:"linear-gradient(60deg, #8297ad, #245d98)"},deepPurpleBoxShadow);var sqPurpleCardHeader=Object.assign({background:"linear-gradient(60deg, #55526f, #55526f)"},deepPurpleBoxShadow);var sqOrangeCardHeader=Object.assign({background:"linear-gradient(60deg, #e8b352, #e8b352)"},deepPurpleBoxShadow);var sqLightBlueCardHeader=Object.assign({background:"linear-gradient(60deg, #8297ad, #8297ad)"},deepPurpleBoxShadow);var sqPurpleSecondCardHeader=Object.assign({background:"linear-gradient(60deg, #6c5cab, #6c5cab)"},deepPurpleBoxShadow);var cardActions=Object.assign({margin:"0 20px 10px",paddingTop:"10px",borderTop:"1px solid #eeeeee",height:"auto"},defaultFont);var cardHeader={margin:"-20px 15px 0",borderRadius:"3px",padding:"15px"};var defaultBoxShadow={border:"0",borderRadius:"3px",boxShadow:"0 10px 20px -12px rgba(0, 0, 0, 0.42), 0 3px 20px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(0, 0, 0, 0.2)",padding:"10px 0",transition:"all 150ms ease 0s"};var tooltip={padding:"10px 15px",minWidth:"130px",color:"#FFFFFF",lineHeight:"1.7em",background:"rgba(85,85,85,0.9)",border:"none",borderRadius:"3px",opacity:"1!important",boxShadow:"0 8px 10px 1px rgba(0, 0, 0, 0.14), 0 3px 14px 2px rgba(0, 0, 0, 0.12), 0 5px 5px -3px rgba(0, 0, 0, 0.2)",maxWidth:"200px",textAlign:"center",fontFamily:'"Helvetica Neue",Helvetica,Arial,sans-serif',fontSize:"12px",fontStyle:"normal",fontWeight:"400",textShadow:"none",textTransform:"none",letterSpacing:"normal",wordBreak:"normal",wordSpacing:"normal",wordWrap:"normal",whiteSpace:"normal",lineBreak:"auto"};var title={color:"#3C4858",textDecoration:"none",fontWeight:"300",marginTop:"30px",marginBottom:"25px",minHeight:"32px",fontFamily:"'Roboto', 'Helvetica', 'Arial', sans-serif","& small":{color:"#777",fontSize:"65%",fontWeight:"400",lineHeight:"1"}};var cardTitle=Object.assign({},title,{marginTop:"0",marginBottom:"3px",minHeight:"auto","& a":Object.assign({},title,{marginTop:".625rem",marginBottom:"0.75rem",minHeight:"auto"})});var cardSubtitle={marginTop:"-.375rem"};var cardLink={"& + $cardLink":{marginLeft:"1.25rem"}};

/***/ }),
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/* harmony default export */ __webpack_exports__["a"] = (isArray);


/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_components_buttonStyle_jsx__ = __webpack_require__(574);
// ##############################
// // // SweetAlert view styles
// #############################
var sweetAlertStyle=Object.assign({cardTitle:{marginTop:"0",marginBottom:"3px",color:"#3C4858",fontSize:"18px"},center:{textAlign:"center"},right:{textAlign:"right"},left:{textAlign:"left"}},__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_components_buttonStyle_jsx__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (sweetAlertStyle);

/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createUploadLink; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_function_name__ = __webpack_require__(371);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_function_name___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_function_name__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_web_dom_iterable__ = __webpack_require__(596);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_web_dom_iterable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_core_js_modules_web_dom_iterable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_apollo_link__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_apollo_link_http_common__ = __webpack_require__(380);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_extract_files__ = __webpack_require__(381);
/* unused harmony reexport ReactNativeFile */






var createUploadLink = function createUploadLink() {
  var _ref =
      arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref$uri = _ref.uri,
    fetchUri = _ref$uri === void 0 ? '/graphql' : _ref$uri,
    _ref$fetch = _ref.fetch,
    linkFetch = _ref$fetch === void 0 ? fetch : _ref$fetch,
    fetchOptions = _ref.fetchOptions,
    credentials = _ref.credentials,
    headers = _ref.headers,
    includeExtensions = _ref.includeExtensions

  var linkConfig = {
    http: {
      includeExtensions: includeExtensions
    },
    options: fetchOptions,
    credentials: credentials,
    headers: headers
  }
  return new __WEBPACK_IMPORTED_MODULE_2_apollo_link__["ApolloLink"](function(operation) {
    var uri = Object(__WEBPACK_IMPORTED_MODULE_3_apollo_link_http_common__["selectURI"])(operation, fetchUri)
    var context = operation.getContext()
    var contextConfig = {
      http: context.http,
      options: context.fetchOptions,
      credentials: context.credentials,
      headers: context.headers
    }

    var _selectHttpOptionsAnd = Object(__WEBPACK_IMPORTED_MODULE_3_apollo_link_http_common__["selectHttpOptionsAndBody"])(
        operation,
        __WEBPACK_IMPORTED_MODULE_3_apollo_link_http_common__["fallbackHttpConfig"],
        linkConfig,
        contextConfig
      ),
      options = _selectHttpOptionsAnd.options,
      body = _selectHttpOptionsAnd.body

    var files = Object(__WEBPACK_IMPORTED_MODULE_4_extract_files__["default"])(body)
    var payload = Object(__WEBPACK_IMPORTED_MODULE_3_apollo_link_http_common__["serializeFetchParameter"])(body, 'Payload')

    if (files.length) {
      delete options.headers['content-type']
      options.body = new FormData()
      options.body.append('operations', payload)
      options.body.append(
        'map',
        JSON.stringify(
          files.reduce(function(map, _ref2, index) {
            var path = _ref2.path
            map[''.concat(index)] = [path]
            return map
          }, {})
        )
      )
      files.forEach(function(_ref3, index) {
        var file = _ref3.file
        return options.body.append(index, file, file.name)
      })
    } else options.body = payload

    return new __WEBPACK_IMPORTED_MODULE_2_apollo_link__["Observable"](function(observer) {
      var _createSignalIfSuppor = Object(__WEBPACK_IMPORTED_MODULE_3_apollo_link_http_common__["createSignalIfSupported"])(),
        controller = _createSignalIfSuppor.controller,
        signal = _createSignalIfSuppor.signal

      if (controller) options.signal = signal
      linkFetch(uri, options)
        .then(function(response) {
          operation.setContext({
            response: response
          })
          return response
        })
        .then(Object(__WEBPACK_IMPORTED_MODULE_3_apollo_link_http_common__["parseAndCheckHttpResponse"])(operation))
        .then(function(result) {
          observer.next(result)
          observer.complete()
        })
        .catch(function(error) {
          if (error.name === 'AbortError') return
          if (error.result && error.result.errors && error.result.data)
            observer.next(error.result)
          observer.error(error)
        })
      return function() {
        if (controller) controller.abort()
      }
    })
  })
}


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Paper.default;
  }
});

var _Paper = _interopRequireDefault(__webpack_require__(852));

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _ButtonBase.default;
  }
});

var _ButtonBase = _interopRequireDefault(__webpack_require__(863));

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = ownerDocument;

function ownerDocument(node) {
  return node && node.ownerDocument || document;
}

module.exports = exports["default"];

/***/ }),
/* 72 */
/***/ (function(module, exports) {

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

module.exports = _interopRequireDefault;

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _classCallCheck = _interopDefault(__webpack_require__(938));
var _createClass = _interopDefault(__webpack_require__(939));
var _possibleConstructorReturn = _interopDefault(__webpack_require__(940));
var _getPrototypeOf = _interopDefault(__webpack_require__(942));
var _inherits = _interopDefault(__webpack_require__(943));
var _typeof = _interopDefault(__webpack_require__(486));
var _objectWithoutProperties = _interopDefault(__webpack_require__(945));
var _extends = _interopDefault(__webpack_require__(947));
var React = _interopDefault(__webpack_require__(0));
var PropTypes = _interopDefault(__webpack_require__(3));
var warning = _interopDefault(__webpack_require__(32));

function defineProperty(object, property, attr) {
  return Object.defineProperty(object, property, attr);
} // Passive options
// Inspired by https://github.com/Modernizr/Modernizr/blob/master/feature-detects/dom/passiveeventlisteners.js


var passiveOption = function () {
  var cache = null;
  return function () {
    if (cache !== null) {
      return cache;
    }

    var supportsPassiveOption = false;

    try {
      window.addEventListener('test', null, defineProperty({}, 'passive', {
        get: function get() {
          supportsPassiveOption = true;
        }
      }));
    } catch (err) {//
    }

    cache = supportsPassiveOption;
    return supportsPassiveOption;
  }();
}();

var defaultEventOptions = {
  capture: false,
  passive: false
};

function mergeDefaultEventOptions(options) {
  return _extends({}, defaultEventOptions, options);
}

function getEventListenerArgs(eventName, callback, options) {
  var args = [eventName, callback];
  args.push(passiveOption ? options : options.capture);
  return args;
}

function on(target, eventName, callback, options) {
  // eslint-disable-next-line prefer-spread
  target.addEventListener.apply(target, getEventListenerArgs(eventName, callback, options));
}

function off(target, eventName, callback, options) {
  // eslint-disable-next-line prefer-spread
  target.removeEventListener.apply(target, getEventListenerArgs(eventName, callback, options));
}

function forEachListener(props, iteratee) {
  var children = props.children,
      target = props.target,
      eventProps = _objectWithoutProperties(props, ["children", "target"]);

  Object.keys(eventProps).forEach(function (name) {
    if (name.substring(0, 2) !== 'on') {
      return;
    }

    var prop = eventProps[name];

    var type = _typeof(prop);

    var isObject = type === 'object';
    var isFunction = type === 'function';

    if (!isObject && !isFunction) {
      return;
    }

    var capture = name.substr(-7).toLowerCase() === 'capture';
    var eventName = name.substring(2).toLowerCase();
    eventName = capture ? eventName.substring(0, eventName.length - 7) : eventName;

    if (isObject) {
      iteratee(eventName, prop.handler, prop.options);
    } else {
      iteratee(eventName, prop, mergeDefaultEventOptions({
        capture: capture
      }));
    }
  });
}

function withOptions(handler, options) {
   false ? warning(options, 'react-event-listener: should be specified options in withOptions.') : void 0;
  return {
    handler: handler,
    options: mergeDefaultEventOptions(options)
  };
}

var EventListener =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(EventListener, _React$PureComponent);

  function EventListener() {
    _classCallCheck(this, EventListener);

    return _possibleConstructorReturn(this, _getPrototypeOf(EventListener).apply(this, arguments));
  }

  _createClass(EventListener, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.applyListeners(on);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      this.applyListeners(off, prevProps);
      this.applyListeners(on);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.applyListeners(off);
    }
  }, {
    key: "applyListeners",
    value: function applyListeners(onOrOff) {
      var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.props;
      var target = props.target;

      if (target) {
        var element = target;

        if (typeof target === 'string') {
          element = window[target];
        }

        forEachListener(props, onOrOff.bind(null, element));
      }
    }
  }, {
    key: "render",
    value: function render() {
      return this.props.children || null;
    }
  }]);

  return EventListener;
}(React.PureComponent);

EventListener.propTypes =  false ? {
  /**
   * You can provide a single child too.
   */
  children: PropTypes.node,

  /**
   * The DOM target to listen to.
   */
  target: PropTypes.oneOfType([PropTypes.object, PropTypes.string]).isRequired
} : {};

exports.withOptions = withOptions;
exports.default = EventListener;


/***/ }),
/* 74 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__ = __webpack_require__(546);


/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__["a" /* default */] || freeSelf || Function('return this')();

/* harmony default export */ __webpack_exports__["a"] = (root);


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1324);

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

var getDayOfYear = __webpack_require__(609)
var getISOWeek = __webpack_require__(386)
var getISOYear = __webpack_require__(114)
var parse = __webpack_require__(9)
var isValid = __webpack_require__(611)
var enLocale = __webpack_require__(387)

/**
 * @category Common Helpers
 * @summary Format the date.
 *
 * @description
 * Return the formatted date string in the given format.
 *
 * Accepted tokens:
 * | Unit                    | Token | Result examples                  |
 * |-------------------------|-------|----------------------------------|
 * | Month                   | M     | 1, 2, ..., 12                    |
 * |                         | Mo    | 1st, 2nd, ..., 12th              |
 * |                         | MM    | 01, 02, ..., 12                  |
 * |                         | MMM   | Jan, Feb, ..., Dec               |
 * |                         | MMMM  | January, February, ..., December |
 * | Quarter                 | Q     | 1, 2, 3, 4                       |
 * |                         | Qo    | 1st, 2nd, 3rd, 4th               |
 * | Day of month            | D     | 1, 2, ..., 31                    |
 * |                         | Do    | 1st, 2nd, ..., 31st              |
 * |                         | DD    | 01, 02, ..., 31                  |
 * | Day of year             | DDD   | 1, 2, ..., 366                   |
 * |                         | DDDo  | 1st, 2nd, ..., 366th             |
 * |                         | DDDD  | 001, 002, ..., 366               |
 * | Day of week             | d     | 0, 1, ..., 6                     |
 * |                         | do    | 0th, 1st, ..., 6th               |
 * |                         | dd    | Su, Mo, ..., Sa                  |
 * |                         | ddd   | Sun, Mon, ..., Sat               |
 * |                         | dddd  | Sunday, Monday, ..., Saturday    |
 * | Day of ISO week         | E     | 1, 2, ..., 7                     |
 * | ISO week                | W     | 1, 2, ..., 53                    |
 * |                         | Wo    | 1st, 2nd, ..., 53rd              |
 * |                         | WW    | 01, 02, ..., 53                  |
 * | Year                    | YY    | 00, 01, ..., 99                  |
 * |                         | YYYY  | 1900, 1901, ..., 2099            |
 * | ISO week-numbering year | GG    | 00, 01, ..., 99                  |
 * |                         | GGGG  | 1900, 1901, ..., 2099            |
 * | AM/PM                   | A     | AM, PM                           |
 * |                         | a     | am, pm                           |
 * |                         | aa    | a.m., p.m.                       |
 * | Hour                    | H     | 0, 1, ... 23                     |
 * |                         | HH    | 00, 01, ... 23                   |
 * |                         | h     | 1, 2, ..., 12                    |
 * |                         | hh    | 01, 02, ..., 12                  |
 * | Minute                  | m     | 0, 1, ..., 59                    |
 * |                         | mm    | 00, 01, ..., 59                  |
 * | Second                  | s     | 0, 1, ..., 59                    |
 * |                         | ss    | 00, 01, ..., 59                  |
 * | 1/10 of second          | S     | 0, 1, ..., 9                     |
 * | 1/100 of second         | SS    | 00, 01, ..., 99                  |
 * | Millisecond             | SSS   | 000, 001, ..., 999               |
 * | Timezone                | Z     | -01:00, +00:00, ... +12:00       |
 * |                         | ZZ    | -0100, +0000, ..., +1200         |
 * | Seconds timestamp       | X     | 512969520                        |
 * | Milliseconds timestamp  | x     | 512969520900                     |
 *
 * The characters wrapped in square brackets are escaped.
 *
 * The result may vary by locale.
 *
 * @param {Date|String|Number} date - the original date
 * @param {String} [format='YYYY-MM-DDTHH:mm:ss.SSSZ'] - the string of tokens
 * @param {Object} [options] - the object with options
 * @param {Object} [options.locale=enLocale] - the locale object
 * @returns {String} the formatted date string
 *
 * @example
 * // Represent 11 February 2014 in middle-endian format:
 * var result = format(
 *   new Date(2014, 1, 11),
 *   'MM/DD/YYYY'
 * )
 * //=> '02/11/2014'
 *
 * @example
 * // Represent 2 July 2014 in Esperanto:
 * var eoLocale = require('date-fns/locale/eo')
 * var result = format(
 *   new Date(2014, 6, 2),
 *   'Do [de] MMMM YYYY',
 *   {locale: eoLocale}
 * )
 * //=> '2-a de julio 2014'
 */
function format (dirtyDate, dirtyFormatStr, dirtyOptions) {
  var formatStr = dirtyFormatStr ? String(dirtyFormatStr) : 'YYYY-MM-DDTHH:mm:ss.SSSZ'
  var options = dirtyOptions || {}

  var locale = options.locale
  var localeFormatters = enLocale.format.formatters
  var formattingTokensRegExp = enLocale.format.formattingTokensRegExp
  if (locale && locale.format && locale.format.formatters) {
    localeFormatters = locale.format.formatters

    if (locale.format.formattingTokensRegExp) {
      formattingTokensRegExp = locale.format.formattingTokensRegExp
    }
  }

  var date = parse(dirtyDate)

  if (!isValid(date)) {
    return 'Invalid Date'
  }

  var formatFn = buildFormatFn(formatStr, localeFormatters, formattingTokensRegExp)

  return formatFn(date)
}

var formatters = {
  // Month: 1, 2, ..., 12
  'M': function (date) {
    return date.getMonth() + 1
  },

  // Month: 01, 02, ..., 12
  'MM': function (date) {
    return addLeadingZeros(date.getMonth() + 1, 2)
  },

  // Quarter: 1, 2, 3, 4
  'Q': function (date) {
    return Math.ceil((date.getMonth() + 1) / 3)
  },

  // Day of month: 1, 2, ..., 31
  'D': function (date) {
    return date.getDate()
  },

  // Day of month: 01, 02, ..., 31
  'DD': function (date) {
    return addLeadingZeros(date.getDate(), 2)
  },

  // Day of year: 1, 2, ..., 366
  'DDD': function (date) {
    return getDayOfYear(date)
  },

  // Day of year: 001, 002, ..., 366
  'DDDD': function (date) {
    return addLeadingZeros(getDayOfYear(date), 3)
  },

  // Day of week: 0, 1, ..., 6
  'd': function (date) {
    return date.getDay()
  },

  // Day of ISO week: 1, 2, ..., 7
  'E': function (date) {
    return date.getDay() || 7
  },

  // ISO week: 1, 2, ..., 53
  'W': function (date) {
    return getISOWeek(date)
  },

  // ISO week: 01, 02, ..., 53
  'WW': function (date) {
    return addLeadingZeros(getISOWeek(date), 2)
  },

  // Year: 00, 01, ..., 99
  'YY': function (date) {
    return addLeadingZeros(date.getFullYear(), 4).substr(2)
  },

  // Year: 1900, 1901, ..., 2099
  'YYYY': function (date) {
    return addLeadingZeros(date.getFullYear(), 4)
  },

  // ISO week-numbering year: 00, 01, ..., 99
  'GG': function (date) {
    return String(getISOYear(date)).substr(2)
  },

  // ISO week-numbering year: 1900, 1901, ..., 2099
  'GGGG': function (date) {
    return getISOYear(date)
  },

  // Hour: 0, 1, ... 23
  'H': function (date) {
    return date.getHours()
  },

  // Hour: 00, 01, ..., 23
  'HH': function (date) {
    return addLeadingZeros(date.getHours(), 2)
  },

  // Hour: 1, 2, ..., 12
  'h': function (date) {
    var hours = date.getHours()
    if (hours === 0) {
      return 12
    } else if (hours > 12) {
      return hours % 12
    } else {
      return hours
    }
  },

  // Hour: 01, 02, ..., 12
  'hh': function (date) {
    return addLeadingZeros(formatters['h'](date), 2)
  },

  // Minute: 0, 1, ..., 59
  'm': function (date) {
    return date.getMinutes()
  },

  // Minute: 00, 01, ..., 59
  'mm': function (date) {
    return addLeadingZeros(date.getMinutes(), 2)
  },

  // Second: 0, 1, ..., 59
  's': function (date) {
    return date.getSeconds()
  },

  // Second: 00, 01, ..., 59
  'ss': function (date) {
    return addLeadingZeros(date.getSeconds(), 2)
  },

  // 1/10 of second: 0, 1, ..., 9
  'S': function (date) {
    return Math.floor(date.getMilliseconds() / 100)
  },

  // 1/100 of second: 00, 01, ..., 99
  'SS': function (date) {
    return addLeadingZeros(Math.floor(date.getMilliseconds() / 10), 2)
  },

  // Millisecond: 000, 001, ..., 999
  'SSS': function (date) {
    return addLeadingZeros(date.getMilliseconds(), 3)
  },

  // Timezone: -01:00, +00:00, ... +12:00
  'Z': function (date) {
    return formatTimezone(date.getTimezoneOffset(), ':')
  },

  // Timezone: -0100, +0000, ... +1200
  'ZZ': function (date) {
    return formatTimezone(date.getTimezoneOffset())
  },

  // Seconds timestamp: 512969520
  'X': function (date) {
    return Math.floor(date.getTime() / 1000)
  },

  // Milliseconds timestamp: 512969520900
  'x': function (date) {
    return date.getTime()
  }
}

function buildFormatFn (formatStr, localeFormatters, formattingTokensRegExp) {
  var array = formatStr.match(formattingTokensRegExp)
  var length = array.length

  var i
  var formatter
  for (i = 0; i < length; i++) {
    formatter = localeFormatters[array[i]] || formatters[array[i]]
    if (formatter) {
      array[i] = formatter
    } else {
      array[i] = removeFormattingTokens(array[i])
    }
  }

  return function (date) {
    var output = ''
    for (var i = 0; i < length; i++) {
      if (array[i] instanceof Function) {
        output += array[i](date, formatters)
      } else {
        output += array[i]
      }
    }
    return output
  }
}

function removeFormattingTokens (input) {
  if (input.match(/\[[\s\S]/)) {
    return input.replace(/^\[|]$/g, '')
  }
  return input.replace(/\\/g, '')
}

function formatTimezone (offset, delimeter) {
  delimeter = delimeter || ''
  var sign = offset > 0 ? '-' : '+'
  var absOffset = Math.abs(offset)
  var hours = Math.floor(absOffset / 60)
  var minutes = absOffset % 60
  return sign + addLeadingZeros(hours, 2) + delimeter + addLeadingZeros(minutes, 2)
}

function addLeadingZeros (number, targetLength) {
  var output = Math.abs(number).toString()
  while (output.length < targetLength) {
    output = '0' + output
  }
  return output
}

module.exports = format


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.isNumber = exports.isString = exports.formatMs = exports.duration = exports.easing = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _warning = _interopRequireDefault(__webpack_require__(32));

/* eslint-disable no-param-reassign */
// Follow https://material.google.com/motion/duration-easing.html#duration-easing-natural-easing-curves
// to learn the context in which each easing should be used.
var easing = {
  // This is the most common easing curve.
  easeInOut: 'cubic-bezier(0.4, 0, 0.2, 1)',
  // Objects enter the screen at full velocity from off-screen and
  // slowly decelerate to a resting point.
  easeOut: 'cubic-bezier(0.0, 0, 0.2, 1)',
  // Objects leave the screen at full velocity. They do not decelerate when off-screen.
  easeIn: 'cubic-bezier(0.4, 0, 1, 1)',
  // The sharp curve is used by objects that may return to the screen at any time.
  sharp: 'cubic-bezier(0.4, 0, 0.6, 1)'
}; // Follow https://material.io/guidelines/motion/duration-easing.html#duration-easing-common-durations
// to learn when use what timing

exports.easing = easing;
var duration = {
  shortest: 150,
  shorter: 200,
  short: 250,
  // most basic recommended timing
  standard: 300,
  // this is to be used in complex animations
  complex: 375,
  // recommended when something is entering screen
  enteringScreen: 225,
  // recommended when something is leaving screen
  leavingScreen: 195
};
exports.duration = duration;

var formatMs = function formatMs(milliseconds) {
  return "".concat(Math.round(milliseconds), "ms");
};

exports.formatMs = formatMs;

var isString = function isString(value) {
  return typeof value === 'string';
};

exports.isString = isString;

var isNumber = function isNumber(value) {
  return !Number.isNaN(parseFloat(value));
};
/**
 * @param {string|Array} props
 * @param {object} param
 * @param {string} param.prop
 * @param {number} param.duration
 * @param {string} param.easing
 * @param {number} param.delay
 */


exports.isNumber = isNumber;
var _default = {
  easing: easing,
  duration: duration,
  create: function create() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ['all'];
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return function () {
      var _options$duration = options.duration,
          durationOption = _options$duration === void 0 ? duration.standard : _options$duration,
          _options$easing = options.easing,
          easingOption = _options$easing === void 0 ? easing.easeInOut : _options$easing,
          _options$delay = options.delay,
          delay = _options$delay === void 0 ? 0 : _options$delay,
          other = (0, _objectWithoutProperties2.default)(options, ["duration", "easing", "delay"]);
       false ? (0, _warning.default)(isString(props) || Array.isArray(props), 'Material-UI: argument "props" must be a string or Array.') : void 0;
       false ? (0, _warning.default)(isNumber(durationOption) || isString(durationOption), "Material-UI: argument \"duration\" must be a number or a string but found ".concat(durationOption, ".")) : void 0;
       false ? (0, _warning.default)(isString(easingOption), 'Material-UI: argument "easing" must be a string.') : void 0;
       false ? (0, _warning.default)(isNumber(delay) || isString(delay), 'Material-UI: argument "delay" must be a number or a string.') : void 0;
       false ? (0, _warning.default)(Object.keys(other).length === 0, "Material-UI: unrecognized argument(s) [".concat(Object.keys(other).join(','), "]")) : void 0;
      return (Array.isArray(props) ? props : [props]).map(function (animatedProp) {
        return "".concat(animatedProp, " ").concat(typeof durationOption === 'string' ? durationOption : formatMs(durationOption), " ").concat(easingOption, " ").concat(typeof delay === 'string' ? delay : formatMs(delay));
      }).join(',');
    }();
  },
  getAutoHeightDuration: function getAutoHeightDuration(height) {
    if (!height) {
      return 0;
    }

    var constant = height / 36; // https://www.wolframalpha.com/input/?i=(4+%2B+15+*+(x+%2F+36+)+**+0.25+%2B+(x+%2F+36)+%2F+5)+*+10

    return Math.round((4 + 15 * Math.pow(constant, 0.25) + constant / 5) * 10);
  }
};
exports.default = _default;

/***/ }),
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addPendingTask; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return newTask; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return toggleProgressOpen; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return openProgress; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return closeProgress; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return removeTask; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return initialFetch; });
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var NEW_TASK='sure-quote/tasks/task/NEW_TASK';var TOGGLE_PROGRESS_OPEN='TOGGLE_PROGRESS_OPEN';var OPEN_PROGRESS='OPEN_PROGRESS';var CLOSE_PROGRESS='CLOSE_PROGRESS';var REMOVE_TASK='REMOVE_TASK';var ADD_PENDING_TASK='ADD_PENDING_TASK';var INITIAL_FETCH='INITIAL_FETCH';var defaultState={progressOpen:false,currentTasks:[],pendingTasks:[],initialFetchDone:false};var handletoggleProgressOpen=function handletoggleProgressOpen(state,action){var progressOpen=!state.progressOpen;global.monkey=progressOpen;return Object.assign({},state,{progressOpen:progressOpen});};var handleOpenProgress=function handleOpenProgress(state,action){global.monkey=true;return Object.assign({},state,{progressOpen:true});};var handleCloseProgress=function handleCloseProgress(state,action){global.monkey=false;return Object.assign({},state,{progressOpen:false});};var handleAddPendingTask=function handleAddPendingTask(state,action){return Object.assign({},state,{pendingTasks:[].concat(_toConsumableArray(state.pendingTasks),[action.props.task])});};var handleNewTask=function handleNewTask(state,action){var currentTasks=action.props.props;var pendingTasks=state.pendingTasks;currentTasks.forEach(function(task){pendingTasks=pendingTasks.filter(function(t){return t.guid!==task.guid;});});return Object.assign({},state,{currentTasks:action.props.props,pendingTasks:pendingTasks});};var handleRemoveTask=function handleRemoveTask(state,action){var currentTasks=state.currentTasks.filter(function(t){return t.guid!==action.props.guid;});return Object.assign({},state,{currentTasks:currentTasks,progressOpen:true});};var handleInitalFetch=function handleInitalFetch(state,action){if(state.initialFetchDone)return state;return Object.assign({},state,{currentTasks:action.props.tasks,initialFetchDone:true});};var TasksReducer=function TasksReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:defaultState;var action=arguments[1];switch(action.type){case ADD_PENDING_TASK:return handleAddPendingTask(state,action);case NEW_TASK:return handleNewTask(state,action);case TOGGLE_PROGRESS_OPEN:return handletoggleProgressOpen(state,action);case OPEN_PROGRESS:return handleOpenProgress(state,action);case CLOSE_PROGRESS:return handleCloseProgress(state,action);case REMOVE_TASK:return handleRemoveTask(state,action);case INITIAL_FETCH:return handleInitalFetch(state,action);default:return state;}};var addPendingTask=function addPendingTask(props){return{type:ADD_PENDING_TASK,props:props};};var newTask=function newTask(props){return{type:NEW_TASK,props:props};};var toggleProgressOpen=function toggleProgressOpen(){return{type:TOGGLE_PROGRESS_OPEN};};var openProgress=function openProgress(){return{type:OPEN_PROGRESS};};var closeProgress=function closeProgress(){return{type:CLOSE_PROGRESS};};var removeTask=function removeTask(props){return{type:REMOVE_TASK,props:props};};var initialFetch=function initialFetch(props){return{type:INITIAL_FETCH,props:props};};/* harmony default export */ __webpack_exports__["c"] = (TasksReducer);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(26)))

/***/ }),
/* 80 */
/***/ (function(module, exports) {

module.exports = {
	overlay: {
		backgroundColor: 'rgba(0, 0, 0, 0.4)',
		position: 'fixed',
		left: 0,
		right: 0,
		top: 0,
		bottom: 0,
		zIndex: 5000
	},
	sweetAlert: {
		backgroundColor: '#fff',
		outline: 'none',
		width: 478,
		padding: 17,
		borderRadius: 5,
		textAlign: 'center',
		position: 'fixed',
		left: '50%',
		top: '50%',
		marginLeft: -256,
		marginTop: -200,
		overflow: 'hidden',
		zIndex: 5500,
		animation: 'showSweetAlert 0.3s'
	},
	sweetAlertMobile: {
		width: 'auto',
		marginLeft: 0,
		marginRight: 0,
		left: 15,
		right: 15
	},
	icon: {
		width: 80,
		height: 80,
		borderWidth: 4,
		borderStyle: 'solid',
		borderColor: 'gray',
		borderRadius: '50%',
		margin: '20px auto',
		position: 'relative',
		boxSizing: 'content-box'
	},
	iconError: {
		borderColor: '#d43f3a',
		animation: 'animateErrorIcon 0.5s'
	},
	iconErrorX: {
		position: 'relative',
		display: 'block',
		animation: 'animateXMark 0.5s'
	},
	iconErrorLine: {
		position: 'absolute',
		height: 5,
		width: 47,
		backgroundColor: '#d9534f',
		display: 'block',
		top: 37,
		borderRadius: 2
	},
	iconErrorLineLeft: {
		transform: 'rotate(45deg)',
		left: 17
	},
	iconErrorLineRight: {
		transform: 'rotate(-45deg)',
		right: 16
	},
	iconWarning: {
		borderColor: '#eea236',
		animation: 'pulseWarning 0.75s infinite alternate'
	},
	iconWarningBody: {
		position: 'absolute',
		width: 5,
		height: 47,
		left: '50%',
		top: 10,
		borderRadius: 2,
		marginLeft: -2,
		backgroundColor: '#f0ad4e',
		animation: 'pulseWarningIns 0.75s infinite alternate'
	},
	iconWarningDot: {
		position: 'absolute',
		width: 7,
		height: 7,
		borderRadius: '50%',
		marginLeft: -3,
		left: '50%',
		bottom: 10,
		backgroundColor: '#f0ad4e',
		animation: 'pulseWarningIns 0.75s infinite alternate'
	},
	iconInfo: {
		borderColor: '#46b8da'
	},
	iconInfoBefore: {
		content: "",
		position: 'absolute',
		width: 5,
		height: 29,
		left: '50%',
		bottom: 17,
		borderRadius: 2,
		marginLeft: -2,
		backgroundColor: '#5bc0de'
	},
	iconInfoAfter: {
		content: "",
		position: 'absolute',
		width: 7,
		height: 7,
		borderRadius: '50%',
		marginLeft: -3,
		left: '50%',
		top: 19,
		backgroundColor: '#5bc0de'
	},
	iconSuccess: {
		borderColor: '#4cae4c'
	},
	iconSuccessBeforeAfter: {
		content: '',
		borderRadius: '50%',
		position: 'absolute',
		width: 60,
		height: 120,
		background: 'white',
		transform: 'rotate(45deg)'
	},
	iconSuccessBefore: {
		borderRadius: '120px 0 0 120px',
		height: 100,
		top: -7,
		left: -33,
		transform: 'rotate(-45deg)',
		transformOrigin: '60px 60px'
	},
	iconSuccessAfter: {
		borderRadius: '0 120px 120px 0',
		top: -11,
		left: 30,
		transform: 'rotate(-45deg)',
		transformOrigin: '0px 60px',
		animation: 'rotatePlaceholder 4.25s ease-in'
	},
	iconSuccessPlaceholder: {
		width: 80,
		height: 80,
		border: '4px solid rgba(92, 184, 92, 0.2)',
		borderRadius: '50%',
		boxSizing: 'content-box',
		position: 'absolute',
		left: -4,
		top: -4,
		zIndex: 2
	},
	iconSuccessFix: {
		width: 5,
		height: 90,
		backgroundColor: '#fff',
		position: 'absolute',
		left: 28,
		top: 8,
		zIndex: 1,
		transform: 'rotate(-45deg)'
	},
	iconSuccessLine: {
		height: 5,
		backgroundColor: '#5cb85c',
		display: 'block',
		borderRadius: 2,
		position: 'absolute',
		zIndex: 2
	},
	iconSuccessLineTip: {
		width: 25,
		left: 14,
		top: 46,
		transform: 'rotate(45deg)',
		animation: 'animateSuccessTip 0.75s'
	},
	iconSuccessLineLong: {
		width: 47,
		right: 8,
		top: 38,
		transform: 'rotate(-45deg)',
		animation: 'animateSuccessLong 0.75s'
	},
	iconCustom: {
		backgroundSize: 'contain',
		borderRadius: 0,
		border: 'none',
		backgroundPosition: 'center center',
		backgroundRepeat: 'no-repeat'
	},
	button: {
		marginRight: 8
	},
	validationMessage: {
		display: 'block',
		backgroundColor: '#f1f1f1',
	    marginLeft: -17,
	    marginRight: -17,
	    marginTop: 20,
	    overflow: 'hidden',
	    padding: 10,
	    maxHeight: 100,
	    transition: 'padding 0.25s, max-height 0.25s',
	    color: '#797979',
	    fontSize: 16,
	    textAlign: 'center',
	    fontWeight: 300
	},
	exclamationIcon: {
		display: 'inline-block',
	    width: 24,
	    height: 24,
	    borderRadius: '50%',
	    backgroundColor: '#ea7d7d',
	    color: 'white',
	    lineHeight: '24px',
	    textAlign: 'center',
	    marginRight: 5
	},
	inputErrorIcon: {
		position: 'absolute',
	    top: 8,
	    right: 8,
	    width: 20,
	    height: 20,
	    opacity: 0,
	    transform: 'scale(0.5)',
	    transformOrigin: '50% 50%',
	    transition: 'all 0.1s',
	    opacity: 1,
	    transform: 'scale(1)'
	},
	inputErrorIconBeforeAfter: {
		content: "",
	    width: 20,
	    height: 6,
	    backgroundColor: '#f06e57',
	    borderRadius: 3,
	    position: 'absolute',
	    top: '50%',
	    marginTop: -4,
	    left: '50%',
	    marginLeft: -9
	},
	inputErrorIconBefore: {
		transform: 'rotate(-45deg)'
	},
	inputErrorIconAfter: {
		transform: 'rotate(45deg)'
	}
};

/***/ }),
/* 81 */
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(9)

/**
 * @category Day Helpers
 * @summary Return the start of a day for the given date.
 *
 * @description
 * Return the start of a day for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the start of a day
 *
 * @example
 * // The start of a day for 2 September 2014 11:55:00:
 * var result = startOfDay(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 02 2014 00:00:00
 */
function startOfDay (dirtyDate) {
  var date = parse(dirtyDate)
  date.setHours(0, 0, 0, 0)
  return date
}

module.exports = startOfDay


/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return RemoveField; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FormHasErrors; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_form__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_store__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
var RemoveField=function RemoveField(form,property){var parent=arguments.length>2&&arguments[2]!==undefined?arguments[2]:null;var value=arguments.length>3&&arguments[3]!==undefined?arguments[3]:null;__WEBPACK_IMPORTED_MODULE_1_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_redux_form__["b" /* change */])(form,property,value?value:""));__WEBPACK_IMPORTED_MODULE_1_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_redux_form__["h" /* untouch */])(form,property));__WEBPACK_IMPORTED_MODULE_1_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_redux_form__["g" /* unregisterField */])(form,property));if(parent){var formVal=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(__WEBPACK_IMPORTED_MODULE_1_store__["a" /* default */].getState().form,form+".values."+parent,{});if(Object.keys(formVal).length<1){__WEBPACK_IMPORTED_MODULE_1_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_redux_form__["b" /* change */])(form,parent,""));return true;}else{return false;}}return false;};var FormHasErrors=function FormHasErrors(form,ignoreList){var formErrors=Object.assign({},__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(__WEBPACK_IMPORTED_MODULE_1_store__["a" /* default */].getState().form,form+".syncErrors",null));if(Object.keys(formErrors).length<1)return false;ignoreList.map(function(i){var propList=i.split(".");var prop=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(formErrors,propList,"uselessstring");if(checkEmptyness(prop)){formErrors=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.omit(formErrors,propList);}return i;});if(Object.keys(formErrors).length>0){return true;}return false;};var checkEmptyness=function checkEmptyness(obj){return!obj||Array.isArray(obj)&&obj.length<1||Object.keys(obj).length<1;};

/***/ }),
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_options_store__ = __webpack_require__(399);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_observers_mixin__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__geometry_rect__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__geometry_matrix__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__geometry_transform__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__geometry_to_matrix__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util__ = __webpack_require__(22);









var Element = (function (Class) {
    function Element(options) {
        Class.call(this);

        this._initOptions(options);
    }

    if ( Class ) Element.__proto__ = Class;
    Element.prototype = Object.create( Class && Class.prototype );
    Element.prototype.constructor = Element;

    Element.prototype._initOptions = function _initOptions (options) {
        if ( options === void 0 ) options = {};

        var clip = options.clip;
        var transform = options.transform;

        if (transform) {
            options.transform = Object(__WEBPACK_IMPORTED_MODULE_4__geometry_transform__["a" /* default */])(transform);
        }

        if (clip && !clip.id) {
            clip.id = Object(__WEBPACK_IMPORTED_MODULE_7__util__["h" /* definitionId */])();
        }

        this.options = new __WEBPACK_IMPORTED_MODULE_0__core_options_store__["a" /* default */](options);
        this.options.addObserver(this);
    };

    Element.prototype.transform = function transform (value) {
        if (Object(__WEBPACK_IMPORTED_MODULE_7__util__["g" /* defined */])(value)) {
            this.options.set("transform", Object(__WEBPACK_IMPORTED_MODULE_4__geometry_transform__["a" /* default */])(value));
        } else {
            return this.options.get("transform");
        }
    };

    Element.prototype.parentTransform = function parentTransform () {
        var element = this;
        var parentMatrix;

        while (element.parent) {
            element = element.parent;
            var transformation = element.transform();
            if (transformation) {
                parentMatrix = transformation.matrix().multiplyCopy(parentMatrix || __WEBPACK_IMPORTED_MODULE_3__geometry_matrix__["a" /* default */].unit());
            }
        }

        if (parentMatrix) {
            return Object(__WEBPACK_IMPORTED_MODULE_4__geometry_transform__["a" /* default */])(parentMatrix);
        }
    };

    Element.prototype.currentTransform = function currentTransform (parentTransform) {
        if ( parentTransform === void 0 ) parentTransform = this.parentTransform();

        var elementTransform = this.transform();
        var elementMatrix = Object(__WEBPACK_IMPORTED_MODULE_5__geometry_to_matrix__["a" /* default */])(elementTransform);

        var parentMatrix = Object(__WEBPACK_IMPORTED_MODULE_5__geometry_to_matrix__["a" /* default */])(parentTransform);
        var combinedMatrix;

        if (elementMatrix && parentMatrix) {
            combinedMatrix = parentMatrix.multiplyCopy(elementMatrix);
        } else {
            combinedMatrix = elementMatrix || parentMatrix;
        }

        if (combinedMatrix) {
            return Object(__WEBPACK_IMPORTED_MODULE_4__geometry_transform__["a" /* default */])(combinedMatrix);
        }
    };

    Element.prototype.visible = function visible (value) {
        if (Object(__WEBPACK_IMPORTED_MODULE_7__util__["g" /* defined */])(value)) {
            this.options.set("visible", value);
            return this;
        }

        return this.options.get("visible") !== false;
    };

    Element.prototype.clip = function clip (value) {
        var options = this.options;
        if (Object(__WEBPACK_IMPORTED_MODULE_7__util__["g" /* defined */])(value)) {
            if (value && !value.id) {
                value.id = Object(__WEBPACK_IMPORTED_MODULE_7__util__["h" /* definitionId */])();
            }
            options.set("clip", value);
            return this;
        }

        return options.get("clip");
    };

    Element.prototype.opacity = function opacity (value) {
        if (Object(__WEBPACK_IMPORTED_MODULE_7__util__["g" /* defined */])(value)) {
            this.options.set("opacity", value);
            return this;
        }

        return Object(__WEBPACK_IMPORTED_MODULE_7__util__["y" /* valueOrDefault */])(this.options.get("opacity"), 1);
    };

    Element.prototype.clippedBBox = function clippedBBox (transformation) {
        var bbox = this._clippedBBox(transformation);
        if (bbox) {
            var clip = this.clip();
            return clip ? __WEBPACK_IMPORTED_MODULE_2__geometry_rect__["a" /* default */].intersect(bbox, clip.bbox(transformation)) : bbox;
        }
    };

    Element.prototype.containsPoint = function containsPoint (point, parentTransform) {
        if (this.visible()) {
            var transform = this.currentTransform(parentTransform);
            var transformedPoint = point;
            if (transform) {
                transformedPoint = point.transformCopy(transform.matrix().invert());
            }
            return (this._hasFill() && this._containsPoint(transformedPoint)) || (this._isOnPath && this._hasStroke() && this._isOnPath(transformedPoint));
        }
        return false;
    };

    Element.prototype._hasFill = function _hasFill () {
        var fill = this.options.fill;
        return fill && !Object(__WEBPACK_IMPORTED_MODULE_7__util__["p" /* isTransparent */])(fill.color);
    };

    Element.prototype._hasStroke = function _hasStroke () {
        var stroke = this.options.stroke;
        return stroke && stroke.width > 0 && !Object(__WEBPACK_IMPORTED_MODULE_7__util__["p" /* isTransparent */])(stroke.color);
    };

    Element.prototype._clippedBBox = function _clippedBBox (transformation) {
        return this.bbox(transformation);
    };

    return Element;
}(__WEBPACK_IMPORTED_MODULE_6__common__["a" /* Class */]));

Element.prototype.nodeType = "Element";

__WEBPACK_IMPORTED_MODULE_1__mixins_observers_mixin__["a" /* default */].extend(Element.prototype);

/* harmony default export */ __webpack_exports__["a"] = (Element);


/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = transform;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__transformation__ = __webpack_require__(646);


function transform(matrix) {
    if (matrix === null) {
        return null;
    }

    if (matrix instanceof __WEBPACK_IMPORTED_MODULE_0__transformation__["a" /* default */]) {
        return matrix;
    }

    return new __WEBPACK_IMPORTED_MODULE_0__transformation__["a" /* default */](matrix);
}

/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var NODE_MAP = {};

/* harmony default export */ __webpack_exports__["a"] = (NODE_MAP);

/***/ }),
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var NODE_MAP = {};

/* harmony default export */ __webpack_exports__["a"] = (NODE_MAP);

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {/**
 * This is the web browser implementation of `debug()`.
 *
 * Expose `debug()` as the module.
 */

exports = module.exports = __webpack_require__(2619);
exports.log = log;
exports.formatArgs = formatArgs;
exports.save = save;
exports.load = load;
exports.useColors = useColors;
exports.storage = 'undefined' != typeof chrome
               && 'undefined' != typeof chrome.storage
                  ? chrome.storage.local
                  : localstorage();

/**
 * Colors.
 */

exports.colors = [
  '#0000CC', '#0000FF', '#0033CC', '#0033FF', '#0066CC', '#0066FF', '#0099CC',
  '#0099FF', '#00CC00', '#00CC33', '#00CC66', '#00CC99', '#00CCCC', '#00CCFF',
  '#3300CC', '#3300FF', '#3333CC', '#3333FF', '#3366CC', '#3366FF', '#3399CC',
  '#3399FF', '#33CC00', '#33CC33', '#33CC66', '#33CC99', '#33CCCC', '#33CCFF',
  '#6600CC', '#6600FF', '#6633CC', '#6633FF', '#66CC00', '#66CC33', '#9900CC',
  '#9900FF', '#9933CC', '#9933FF', '#99CC00', '#99CC33', '#CC0000', '#CC0033',
  '#CC0066', '#CC0099', '#CC00CC', '#CC00FF', '#CC3300', '#CC3333', '#CC3366',
  '#CC3399', '#CC33CC', '#CC33FF', '#CC6600', '#CC6633', '#CC9900', '#CC9933',
  '#CCCC00', '#CCCC33', '#FF0000', '#FF0033', '#FF0066', '#FF0099', '#FF00CC',
  '#FF00FF', '#FF3300', '#FF3333', '#FF3366', '#FF3399', '#FF33CC', '#FF33FF',
  '#FF6600', '#FF6633', '#FF9900', '#FF9933', '#FFCC00', '#FFCC33'
];

/**
 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
 * and the Firebug extension (any Firefox version) are known
 * to support "%c" CSS customizations.
 *
 * TODO: add a `localStorage` variable to explicitly enable/disable colors
 */

function useColors() {
  // NB: In an Electron preload script, document will be defined but not fully
  // initialized. Since we know we're in Chrome, we'll just detect this case
  // explicitly
  if (typeof window !== 'undefined' && window.process && window.process.type === 'renderer') {
    return true;
  }

  // Internet Explorer and Edge do not support colors.
  if (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/(edge|trident)\/(\d+)/)) {
    return false;
  }

  // is webkit? http://stackoverflow.com/a/16459606/376773
  // document is undefined in react-native: https://github.com/facebook/react-native/pull/1632
  return (typeof document !== 'undefined' && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance) ||
    // is firebug? http://stackoverflow.com/a/398120/376773
    (typeof window !== 'undefined' && window.console && (window.console.firebug || (window.console.exception && window.console.table))) ||
    // is firefox >= v31?
    // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
    (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31) ||
    // double check webkit in userAgent just in case we are in a worker
    (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/));
}

/**
 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
 */

exports.formatters.j = function(v) {
  try {
    return JSON.stringify(v);
  } catch (err) {
    return '[UnexpectedJSONParseError]: ' + err.message;
  }
};


/**
 * Colorize log arguments if enabled.
 *
 * @api public
 */

function formatArgs(args) {
  var useColors = this.useColors;

  args[0] = (useColors ? '%c' : '')
    + this.namespace
    + (useColors ? ' %c' : ' ')
    + args[0]
    + (useColors ? '%c ' : ' ')
    + '+' + exports.humanize(this.diff);

  if (!useColors) return;

  var c = 'color: ' + this.color;
  args.splice(1, 0, c, 'color: inherit')

  // the final "%c" is somewhat tricky, because there could be other
  // arguments passed either before or after the %c, so we need to
  // figure out the correct index to insert the CSS into
  var index = 0;
  var lastC = 0;
  args[0].replace(/%[a-zA-Z%]/g, function(match) {
    if ('%%' === match) return;
    index++;
    if ('%c' === match) {
      // we only are interested in the *last* %c
      // (the user may have provided their own)
      lastC = index;
    }
  });

  args.splice(lastC, 0, c);
}

/**
 * Invokes `console.log()` when available.
 * No-op when `console.log` is not a "function".
 *
 * @api public
 */

function log() {
  // this hackery is required for IE8/9, where
  // the `console.log` function doesn't have 'apply'
  return 'object' === typeof console
    && console.log
    && Function.prototype.apply.call(console.log, console, arguments);
}

/**
 * Save `namespaces`.
 *
 * @param {String} namespaces
 * @api private
 */

function save(namespaces) {
  try {
    if (null == namespaces) {
      exports.storage.removeItem('debug');
    } else {
      exports.storage.debug = namespaces;
    }
  } catch(e) {}
}

/**
 * Load `namespaces`.
 *
 * @return {String} returns the previously persisted debug modes
 * @api private
 */

function load() {
  var r;
  try {
    r = exports.storage.debug;
  } catch(e) {}

  // If debug isn't set in LS, and we're in Electron, try to load $DEBUG
  if (!r && typeof process !== 'undefined' && 'env' in process) {
    r = Object({"NODE_ENV":"production","PUBLIC_URL":"","REACT_APP_API_URL":"127.0.0.1/mailApi","REACT_APP_SMTP_EMAIL":"admin@rhlm.co.za"}).DEBUG;
  }

  return r;
}

/**
 * Enable namespaces listed in `localStorage.debug` initially.
 */

exports.enable(load());

/**
 * Localstorage attempts to return the localstorage.
 *
 * This is necessary because safari throws
 * when a user disables cookies/localstorage
 * and you attempt to access it.
 *
 * @return {LocalStorage}
 * @api private
 */

function localstorage() {
  try {
    return window.localStorage;
  } catch (e) {}
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(74)))

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var misc_1 = __webpack_require__(158);
// TODO: Implement different loggers for different environments
var global = misc_1.getGlobalObject();
/** JSDoc */
var Logger = /** @class */ (function () {
    /** JSDoc */
    function Logger() {
        this.enabled = false;
    }
    /** JSDoc */
    Logger.prototype.disable = function () {
        this.enabled = false;
    };
    /** JSDoc */
    Logger.prototype.enable = function () {
        this.enabled = true;
    };
    /** JSDoc */
    Logger.prototype.log = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (!this.enabled) {
            return;
        }
        misc_1.consoleSandbox(function () {
            global.console.log("Sentry Logger [Log]: " + args.join(' ')); // tslint:disable-line:no-console
        });
    };
    /** JSDoc */
    Logger.prototype.warn = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (!this.enabled) {
            return;
        }
        misc_1.consoleSandbox(function () {
            global.console.warn("Sentry Logger [Warn]: " + args.join(' ')); // tslint:disable-line:no-console
        });
    };
    /** JSDoc */
    Logger.prototype.error = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (!this.enabled) {
            return;
        }
        misc_1.consoleSandbox(function () {
            global.console.error("Sentry Logger [Error]: " + args.join(' ')); // tslint:disable-line:no-console
        });
    };
    return Logger;
}());
var logger = new Logger();
exports.logger = logger;
//# sourceMappingURL=logger.js.map

/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.convertHexToRGB = convertHexToRGB;
exports.decomposeColor = decomposeColor;
exports.recomposeColor = recomposeColor;
exports.getContrastRatio = getContrastRatio;
exports.getLuminance = getLuminance;
exports.emphasize = emphasize;
exports.fade = fade;
exports.darken = darken;
exports.lighten = lighten;

var _warning = _interopRequireDefault(__webpack_require__(32));

//  weak

/* eslint-disable no-use-before-define */

/**
 * Returns a number whose value is limited to the given range.
 *
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */
function clamp(value) {
  var min = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var max = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
   false ? (0, _warning.default)(value >= min && value <= max, "Material-UI: the value provided ".concat(value, " is out of range [").concat(min, ", ").concat(max, "].")) : void 0;

  if (value < min) {
    return min;
  }

  if (value > max) {
    return max;
  }

  return value;
}
/**
 * Converts a color from CSS hex format to CSS rgb format.
 *
 * @param {string} color - Hex color, i.e. #nnn or #nnnnnn
 * @returns {string} A CSS rgb color string
 */


function convertHexToRGB(color) {
  color = color.substr(1);
  var re = new RegExp(".{1,".concat(color.length / 3, "}"), 'g');
  var colors = color.match(re);

  if (colors && colors[0].length === 1) {
    colors = colors.map(function (n) {
      return n + n;
    });
  }

  return colors ? "rgb(".concat(colors.map(function (n) {
    return parseInt(n, 16);
  }).join(', '), ")") : '';
}
/**
 * Returns an object with the type and values of a color.
 *
 * Note: Does not support rgb % values.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {object} - A MUI color object: {type: string, values: number[]}
 */


function decomposeColor(color) {
  if (color.charAt(0) === '#') {
    return decomposeColor(convertHexToRGB(color));
  }

  var marker = color.indexOf('(');
  var type = color.substring(0, marker);
  var values = color.substring(marker + 1, color.length - 1).split(',');
  values = values.map(function (value) {
    return parseFloat(value);
  });

  if (false) {
    if (['rgb', 'rgba', 'hsl', 'hsla'].indexOf(type) === -1) {
      throw new Error(["Material-UI: unsupported `".concat(color, "` color."), 'We support the following formats: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla().'].join('\n'));
    }
  }

  return {
    type: type,
    values: values
  };
}
/**
 * Converts a color object with type and values to a string.
 *
 * @param {object} color - Decomposed color
 * @param {string} color.type - One of: 'rgb', 'rgba', 'hsl', 'hsla'
 * @param {array} color.values - [n,n,n] or [n,n,n,n]
 * @returns {string} A CSS color string
 */


function recomposeColor(color) {
  var type = color.type;
  var values = color.values;

  if (type.indexOf('rgb') !== -1) {
    // Only convert the first 3 values to int (i.e. not alpha)
    values = values.map(function (n, i) {
      return i < 3 ? parseInt(n, 10) : n;
    });
  }

  if (type.indexOf('hsl') !== -1) {
    values[1] = "".concat(values[1], "%");
    values[2] = "".concat(values[2], "%");
  }

  return "".concat(color.type, "(").concat(values.join(', '), ")");
}
/**
 * Calculates the contrast ratio between two colors.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 *
 * @param {string} foreground - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {string} background - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {number} A contrast ratio value in the range 0 - 21.
 */


function getContrastRatio(foreground, background) {
  var lumA = getLuminance(foreground);
  var lumB = getLuminance(background);
  return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}
/**
 * The relative brightness of any point in a color space,
 * normalized to 0 for darkest black and 1 for lightest white.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {number} The relative brightness of the color in the range 0 - 1
 */


function getLuminance(color) {
  var decomposedColor = decomposeColor(color);

  if (decomposedColor.type.indexOf('rgb') !== -1) {
    var rgb = decomposedColor.values.map(function (val) {
      val /= 255; // normalized

      return val <= 0.03928 ? val / 12.92 : Math.pow((val + 0.055) / 1.055, 2.4);
    }); // Truncate at 3 digits

    return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
  } // else if (decomposedColor.type.indexOf('hsl') !== -1)


  return decomposedColor.values[2] / 100;
}
/**
 * Darken or lighten a colour, depending on its luminance.
 * Light colors are darkened, dark colors are lightened.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {number} coefficient=0.15 - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */


function emphasize(color) {
  var coefficient = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0.15;
  return getLuminance(color) > 0.5 ? darken(color, coefficient) : lighten(color, coefficient);
}
/**
 * Set the absolute transparency of a color.
 * Any existing alpha values are overwritten.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {number} value - value to set the alpha channel to in the range 0 -1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */


function fade(color, value) {
   false ? (0, _warning.default)(color, "Material-UI: missing color argument in fade(".concat(color, ", ").concat(value, ").")) : void 0;
  if (!color) return color;
  color = decomposeColor(color);
  value = clamp(value);

  if (color.type === 'rgb' || color.type === 'hsl') {
    color.type += 'a';
  }

  color.values[3] = value;
  return recomposeColor(color);
}
/**
 * Darkens a color.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */


function darken(color, coefficient) {
   false ? (0, _warning.default)(color, "Material-UI: missing color argument in darken(".concat(color, ", ").concat(coefficient, ").")) : void 0;
  if (!color) return color;
  color = decomposeColor(color);
  coefficient = clamp(coefficient);

  if (color.type.indexOf('hsl') !== -1) {
    color.values[2] *= 1 - coefficient;
  } else if (color.type.indexOf('rgb') !== -1) {
    for (var i = 0; i < 3; i += 1) {
      color.values[i] *= 1 - coefficient;
    }
  }

  return recomposeColor(color);
}
/**
 * Lightens a color.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */


function lighten(color, coefficient) {
   false ? (0, _warning.default)(color, "Material-UI: missing color argument in lighten(".concat(color, ", ").concat(coefficient, ").")) : void 0;
  if (!color) return color;
  color = decomposeColor(color);
  coefficient = clamp(coefficient);

  if (color.type.indexOf('hsl') !== -1) {
    color.values[2] += (100 - color.values[2]) * coefficient;
  } else if (color.type.indexOf('rgb') !== -1) {
    for (var i = 0; i < 3; i += 1) {
      color.values[i] += (255 - color.values[i]) * coefficient;
    }
  }

  return recomposeColor(color);
}

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(8));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(18));

var _createClass2 = _interopRequireDefault(__webpack_require__(19));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(20));

var _inherits2 = _interopRequireDefault(__webpack_require__(21));

var _react = _interopRequireDefault(__webpack_require__(0));

var _hoistNonReactStatics = _interopRequireDefault(__webpack_require__(160));

var _wrapDisplayName = _interopRequireDefault(__webpack_require__(162));

var _createMuiTheme = _interopRequireDefault(__webpack_require__(304));

var _themeListener = _interopRequireDefault(__webpack_require__(306));

var defaultTheme;

function getDefaultTheme() {
  if (defaultTheme) {
    return defaultTheme;
  }

  defaultTheme = (0, _createMuiTheme.default)();
  return defaultTheme;
} // Provide the theme object as a property to the input component.


var withTheme = function withTheme() {
  return function (Component) {
    var WithTheme =
    /*#__PURE__*/
    function (_React$Component) {
      (0, _inherits2.default)(WithTheme, _React$Component);

      function WithTheme(props, context) {
        var _this;

        (0, _classCallCheck2.default)(this, WithTheme);
        _this = (0, _possibleConstructorReturn2.default)(this, (WithTheme.__proto__ || Object.getPrototypeOf(WithTheme)).call(this, props, context));
        _this.state = {};
        _this.unsubscribeId = null;
        _this.state = {
          // We use || as the function call is lazy evaluated.
          theme: _themeListener.default.initial(context) || getDefaultTheme()
        };
        return _this;
      }

      (0, _createClass2.default)(WithTheme, [{
        key: "componentDidMount",
        value: function componentDidMount() {
          var _this2 = this;

          this.unsubscribeId = _themeListener.default.subscribe(this.context, function (theme) {
            _this2.setState({
              theme: theme
            });
          });
        }
      }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
          if (this.unsubscribeId !== null) {
            _themeListener.default.unsubscribe(this.context, this.unsubscribeId);
          }
        }
      }, {
        key: "render",
        value: function render() {
          return _react.default.createElement(Component, (0, _extends2.default)({
            theme: this.state.theme
          }, this.props));
        }
      }]);
      return WithTheme;
    }(_react.default.Component);

    WithTheme.contextTypes = _themeListener.default.contextTypes;

    if (false) {
      WithTheme.displayName = (0, _wrapDisplayName.default)(Component, 'WithTheme');
    }

    (0, _hoistNonReactStatics.default)(WithTheme, Component);

    if (false) {
      // Exposed for test purposes.
      WithTheme.Naked = Component;
    }

    return WithTheme;
  };
};

var _default = withTheme;
exports.default = _default;

/***/ }),
/* 92 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 93 */
/***/ (function(module, exports) {

/**
 * Returns a function, that, as long as it continues to be invoked, will not
 * be triggered. The function will be called after it stops being called for
 * N milliseconds. If `immediate` is passed, trigger the function on the
 * leading edge, instead of the trailing. The function also has a property 'clear' 
 * that is a function which will clear the timer to prevent previously scheduled executions. 
 *
 * @source underscore.js
 * @see http://unscriptable.com/2009/03/20/debouncing-javascript-methods/
 * @param {Function} function to wrap
 * @param {Number} timeout in ms (`100`)
 * @param {Boolean} whether to execute at the beginning (`false`)
 * @api public
 */
function debounce(func, wait, immediate){
  var timeout, args, context, timestamp, result;
  if (null == wait) wait = 100;

  function later() {
    var last = Date.now() - timestamp;

    if (last < wait && last >= 0) {
      timeout = setTimeout(later, wait - last);
    } else {
      timeout = null;
      if (!immediate) {
        result = func.apply(context, args);
        context = args = null;
      }
    }
  };

  var debounced = function(){
    context = this;
    args = arguments;
    timestamp = Date.now();
    var callNow = immediate && !timeout;
    if (!timeout) timeout = setTimeout(later, wait);
    if (callNow) {
      result = func.apply(context, args);
      context = args = null;
    }

    return result;
  };

  debounced.clear = function() {
    if (timeout) {
      clearTimeout(timeout);
      timeout = null;
    }
  };
  
  debounced.flush = function() {
    if (timeout) {
      result = func.apply(context, args);
      context = args = null;
      
      clearTimeout(timeout);
      timeout = null;
    }
  };

  return debounced;
};

// Adds compatibility for ES modules
debounce.debounce = debounce;

module.exports = debounce;


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/sure_quote_website_logo.9d05fc9a.png";

/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__link__ = __webpack_require__(1112);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "empty", function() { return __WEBPACK_IMPORTED_MODULE_0__link__["c"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "from", function() { return __WEBPACK_IMPORTED_MODULE_0__link__["e"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "split", function() { return __WEBPACK_IMPORTED_MODULE_0__link__["f"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "concat", function() { return __WEBPACK_IMPORTED_MODULE_0__link__["b"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "ApolloLink", function() { return __WEBPACK_IMPORTED_MODULE_0__link__["a"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "execute", function() { return __WEBPACK_IMPORTED_MODULE_0__link__["d"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__linkUtils__ = __webpack_require__(528);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "createOperation", function() { return __WEBPACK_IMPORTED_MODULE_1__linkUtils__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "makePromise", function() { return __WEBPACK_IMPORTED_MODULE_1__linkUtils__["f"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "toPromise", function() { return __WEBPACK_IMPORTED_MODULE_1__linkUtils__["g"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "fromPromise", function() { return __WEBPACK_IMPORTED_MODULE_1__linkUtils__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "fromError", function() { return __WEBPACK_IMPORTED_MODULE_1__linkUtils__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_zen_observable_ts__ = __webpack_require__(339);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Observable", function() { return __WEBPACK_IMPORTED_MODULE_2_zen_observable_ts__["a"]; });




//# sourceMappingURL=index.js.map

/***/ }),
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Click; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return changeAvatar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Clear; });
var CLICK="sure-quote/Login/CLICK";var CHANGEAVATAR="sure-quote/Login/CHANGEAVATAR";var CLEAR="sure-quote/Login/CLEAR";var defaultState={userEmail:"",name:"",surname:"",userID:"",token:"",avatar:"",userType:""};var handleChangeAvatar=function handleChangeAvatar(state,action){var uAvatar=action.props.props;return Object.assign({},state,{avatar:uAvatar});};var handleClick=function handleClick(state,action){var obj={};if(action.props.props.token){obj={userEmail:action.props.props.userName,userID:action.props.props.id,token:action.props.props.token,name:action.props.props.name,surname:action.props.props.surname,avatar:action.props.props.avatar,userType:action.props.props.userType};}return Object.assign({},state,obj);};var handleClear=function handleClear(state,action){var obj={userEmail:"",userID:"",token:"",name:"",surname:"",avatar:"",userType:""};return Object.assign({},state,obj);};var LoginReducer=function LoginReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:defaultState;var action=arguments[1];switch(action.type){case CLICK:return handleClick(state,action);case CHANGEAVATAR:return handleChangeAvatar(state,action);case CLEAR:return handleClear(state,action);default:return state;}};var Click=function Click(props){return{type:CLICK,props:props};};var changeAvatar=function changeAvatar(props){return{type:CHANGEAVATAR,props:props};};var Clear=function Clear(props){return{type:CLEAR,props:props};};/* harmony default export */ __webpack_exports__["d"] = (LoginReducer);

/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

/* harmony default export */ __webpack_exports__["a"] = (isObject);


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
  isURI: function(uri) {
    return uri && uri.protocol && uri.host && uri.path;
  },

  isSameOrigin: function(uri) {
    return uri.protocol === location.protocol &&
           uri.hostname === location.hostname &&
           uri.port     === location.port;
  },

  parse: function(url) {
    if (typeof url !== 'string') return url;
    var uri = {}, parts, query, pairs, i, n, data;

    var consume = function(name, pattern) {
      url = url.replace(pattern, function(match) {
        uri[name] = match;
        return '';
      });
      uri[name] = uri[name] || '';
    };

    consume('protocol', /^[a-z]+\:/i);
    consume('host',     /^\/\/[^\/\?#]+/);

    if (!/^\//.test(url) && !uri.host)
      url = location.pathname.replace(/[^\/]*$/, '') + url;

    consume('pathname', /^[^\?#]*/);
    consume('search',   /^\?[^#]*/);
    consume('hash',     /^#.*/);

    uri.protocol = uri.protocol || location.protocol;

    if (uri.host) {
      uri.host     = uri.host.substr(2);
      parts        = uri.host.split(':');
      uri.hostname = parts[0];
      uri.port     = parts[1] || '';
    } else {
      uri.host     = location.host;
      uri.hostname = location.hostname;
      uri.port     = location.port;
    }

    uri.pathname = uri.pathname || '/';
    uri.path = uri.pathname + uri.search;

    query = uri.search.replace(/^\?/, '');
    pairs = query ? query.split('&') : [];
    data  = {};

    for (i = 0, n = pairs.length; i < n; i++) {
      parts = pairs[i].split('=');
      data[decodeURIComponent(parts[0] || '')] = decodeURIComponent(parts[1] || '');
    }

    uri.query = data;

    uri.href = this.stringify(uri);
    return uri;
  },

  stringify: function(uri) {
    var string = uri.protocol + '//' + uri.hostname;
    if (uri.port) string += ':' + uri.port;
    string += uri.pathname + this.queryString(uri.query) + (uri.hash || '');
    return string;
  },

  queryString: function(query) {
    var pairs = [];
    for (var key in query) {
      if (!query.hasOwnProperty(key)) continue;
      pairs.push(encodeURIComponent(key) + '=' + encodeURIComponent(query[key]));
    }
    if (pairs.length === 0) return '';
    return '?' + pairs.join('&');
  }
};


/***/ }),
/* 99 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_assets_jss_material_dashboard_pro_react_components_cardStyle_jsx__ = __webpack_require__(2328);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}// nodejs library that concatenates classes
// nodejs library to set properties for components
// @material-ui/core components
// @material-ui/icons
// core components
function Card(_ref){var _classNames;var props=_objectWithoutProperties(_ref,[]);var classes=props.classes,className=props.className,children=props.children,plain=props.plain,profile=props.profile,blog=props.blog,raised=props.raised,background=props.background,pricing=props.pricing,color=props.color,product=props.product,testimonial=props.testimonial,chart=props.chart,login=props.login,rest=_objectWithoutProperties(props,["classes","className","children","plain","profile","blog","raised","background","pricing","color","product","testimonial","chart","login"]);var cardClasses=__WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classNames={},_defineProperty(_classNames,classes.card,true),_defineProperty(_classNames,classes.cardPlain,plain),_defineProperty(_classNames,classes.cardProfile,profile||testimonial),_defineProperty(_classNames,classes.cardBlog,blog),_defineProperty(_classNames,classes.cardRaised,raised),_defineProperty(_classNames,classes.cardBackground,background),_defineProperty(_classNames,classes.cardPricingColor,pricing&&color!==undefined||pricing&&background!==undefined),_defineProperty(_classNames,classes[color],color),_defineProperty(_classNames,classes.cardPricing,pricing),_defineProperty(_classNames,classes.cardProduct,product),_defineProperty(_classNames,classes.cardChart,chart),_defineProperty(_classNames,classes.cardLogin,login),_defineProperty(_classNames,className,className!==undefined),_classNames));return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",Object.assign({className:cardClasses},rest),children);}Card.propTypes={classes:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,className:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,plain:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,profile:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,blog:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,raised:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,background:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,pricing:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,testimonial:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,color:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(["primary","info","success","warning","danger","rose"]),product:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,chart:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,login:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool};/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles___default()(__WEBPACK_IMPORTED_MODULE_4_assets_jss_material_dashboard_pro_react_components_cardStyle_jsx__["a" /* default */])(Card));

/***/ }),
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(2377);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_styles__ = __webpack_require__(2379);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint prefer-template: 0 */






var Dropzone = function (_React$Component) {
  _inherits(Dropzone, _React$Component);

  function Dropzone(props, context) {
    _classCallCheck(this, Dropzone);

    var _this = _possibleConstructorReturn(this, (Dropzone.__proto__ || Object.getPrototypeOf(Dropzone)).call(this, props, context));

    _this.renderChildren = function (children, isDragActive, isDragAccept, isDragReject) {
      if (typeof children === 'function') {
        return children(_extends({}, _this.state, {
          isDragActive: isDragActive,
          isDragAccept: isDragAccept,
          isDragReject: isDragReject
        }));
      }
      return children;
    };

    _this.composeHandlers = _this.composeHandlers.bind(_this);
    _this.onClick = _this.onClick.bind(_this);
    _this.onDocumentDrop = _this.onDocumentDrop.bind(_this);
    _this.onDragEnter = _this.onDragEnter.bind(_this);
    _this.onDragLeave = _this.onDragLeave.bind(_this);
    _this.onDragOver = _this.onDragOver.bind(_this);
    _this.onDragStart = _this.onDragStart.bind(_this);
    _this.onDrop = _this.onDrop.bind(_this);
    _this.onFileDialogCancel = _this.onFileDialogCancel.bind(_this);
    _this.onInputElementClick = _this.onInputElementClick.bind(_this);

    _this.setRef = _this.setRef.bind(_this);
    _this.setRefs = _this.setRefs.bind(_this);

    _this.isFileDialogActive = false;

    _this.state = {
      draggedFiles: [],
      acceptedFiles: [],
      rejectedFiles: []
    };
    return _this;
  }

  _createClass(Dropzone, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var preventDropOnDocument = this.props.preventDropOnDocument;

      this.dragTargets = [];

      if (preventDropOnDocument) {
        document.addEventListener('dragover', __WEBPACK_IMPORTED_MODULE_2__utils__["f" /* onDocumentDragOver */], false);
        document.addEventListener('drop', this.onDocumentDrop, false);
      }
      this.fileInputEl.addEventListener('click', this.onInputElementClick, false);
      window.addEventListener('focus', this.onFileDialogCancel, false);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      var preventDropOnDocument = this.props.preventDropOnDocument;

      if (preventDropOnDocument) {
        document.removeEventListener('dragover', __WEBPACK_IMPORTED_MODULE_2__utils__["f" /* onDocumentDragOver */]);
        document.removeEventListener('drop', this.onDocumentDrop);
      }
      if (this.fileInputEl != null) {
        this.fileInputEl.removeEventListener('click', this.onInputElementClick, false);
      }
      window.removeEventListener('focus', this.onFileDialogCancel, false);
    }
  }, {
    key: 'composeHandlers',
    value: function composeHandlers(handler) {
      if (this.props.disabled) {
        return null;
      }

      return handler;
    }
  }, {
    key: 'onDocumentDrop',
    value: function onDocumentDrop(evt) {
      if (this.node && this.node.contains(evt.target)) {
        // if we intercepted an event for our instance, let it propagate down to the instance's onDrop handler
        return;
      }
      evt.preventDefault();
      this.dragTargets = [];
    }
  }, {
    key: 'onDragStart',
    value: function onDragStart(evt) {
      if (this.props.onDragStart) {
        this.props.onDragStart.call(this, evt);
      }
    }
  }, {
    key: 'onDragEnter',
    value: function onDragEnter(evt) {
      var _this2 = this;

      evt.preventDefault();

      // Count the dropzone and any children that are entered.
      if (this.dragTargets.indexOf(evt.target) === -1) {
        this.dragTargets.push(evt.target);
      }

      Promise.resolve(this.props.getDataTransferItems(evt)).then(function (draggedFiles) {
        _this2.setState({
          isDragActive: true, // Do not rely on files for the drag state. It doesn't work in Safari.
          draggedFiles: draggedFiles
        });
      });
      if (this.props.onDragEnter) {
        this.props.onDragEnter.call(this, evt);
      }
    }
  }, {
    key: 'onDragOver',
    value: function onDragOver(evt) {
      // eslint-disable-line class-methods-use-this
      evt.preventDefault();
      evt.stopPropagation();
      try {
        // The file dialog on Chrome allows users to drag files from the dialog onto
        // the dropzone, causing the browser the crash when the file dialog is closed.
        // A drop effect of 'none' prevents the file from being dropped
        evt.dataTransfer.dropEffect = this.isFileDialogActive ? 'none' : 'copy'; // eslint-disable-line no-param-reassign
      } catch (err) {
        // continue regardless of error
      }

      if (this.props.onDragOver) {
        this.props.onDragOver.call(this, evt);
      }
      return false;
    }
  }, {
    key: 'onDragLeave',
    value: function onDragLeave(evt) {
      var _this3 = this;

      evt.preventDefault();

      // Only deactivate once the dropzone and all children have been left.
      this.dragTargets = this.dragTargets.filter(function (el) {
        return el !== evt.target && _this3.node.contains(el);
      });
      if (this.dragTargets.length > 0) {
        return;
      }

      // Clear dragging files state
      this.setState({
        isDragActive: false,
        draggedFiles: []
      });

      if (this.props.onDragLeave) {
        this.props.onDragLeave.call(this, evt);
      }
    }
  }, {
    key: 'onDrop',
    value: function onDrop(evt) {
      var _this4 = this;

      var _props = this.props,
          onDrop = _props.onDrop,
          onDropAccepted = _props.onDropAccepted,
          onDropRejected = _props.onDropRejected,
          multiple = _props.multiple,
          disablePreview = _props.disablePreview,
          accept = _props.accept,
          getDataTransferItems = _props.getDataTransferItems;

      // Stop default browser behavior

      evt.preventDefault();

      // Reset the counter along with the drag on a drop.
      this.dragTargets = [];
      this.isFileDialogActive = false;

      // Clear files value
      this.draggedFiles = null;

      // Reset drag state
      this.setState({
        isDragActive: false,
        draggedFiles: []
      });

      Promise.resolve(getDataTransferItems(evt)).then(function (fileList) {
        var acceptedFiles = [];
        var rejectedFiles = [];

        fileList.forEach(function (file) {
          if (!disablePreview) {
            try {
              file.preview = window.URL.createObjectURL(file); // eslint-disable-line no-param-reassign
            } catch (err) {
              if (false) {
                console.error('Failed to generate preview for file', file, err); // eslint-disable-line no-console
              }
            }
          }

          if (Object(__WEBPACK_IMPORTED_MODULE_2__utils__["b" /* fileAccepted */])(file, accept) && Object(__WEBPACK_IMPORTED_MODULE_2__utils__["c" /* fileMatchSize */])(file, _this4.props.maxSize, _this4.props.minSize)) {
            acceptedFiles.push(file);
          } else {
            rejectedFiles.push(file);
          }
        });

        if (!multiple) {
          // if not in multi mode add any extra accepted files to rejected.
          // This will allow end users to easily ignore a multi file drop in "single" mode.
          rejectedFiles.push.apply(rejectedFiles, _toConsumableArray(acceptedFiles.splice(1)));
        }

        if (onDrop) {
          onDrop.call(_this4, acceptedFiles, rejectedFiles, evt);
        }

        if (rejectedFiles.length > 0 && onDropRejected) {
          onDropRejected.call(_this4, rejectedFiles, evt);
        }

        if (acceptedFiles.length > 0 && onDropAccepted) {
          onDropAccepted.call(_this4, acceptedFiles, evt);
        }
      });
    }
  }, {
    key: 'onClick',
    value: function onClick(evt) {
      var _props2 = this.props,
          onClick = _props2.onClick,
          disableClick = _props2.disableClick;

      if (!disableClick) {
        evt.stopPropagation();

        if (onClick) {
          onClick.call(this, evt);
        }

        // in IE11/Edge the file-browser dialog is blocking, ensure this is behind setTimeout
        // this is so react can handle state changes in the onClick prop above above
        // see: https://github.com/react-dropzone/react-dropzone/issues/450
        if (Object(__WEBPACK_IMPORTED_MODULE_2__utils__["e" /* isIeOrEdge */])()) {
          setTimeout(this.open.bind(this), 0);
        } else {
          this.open();
        }
      }
    }
  }, {
    key: 'onInputElementClick',
    value: function onInputElementClick(evt) {
      evt.stopPropagation();
      if (this.props.inputProps && this.props.inputProps.onClick) {
        this.props.inputProps.onClick();
      }
    }
  }, {
    key: 'onFileDialogCancel',
    value: function onFileDialogCancel() {
      var _this5 = this;

      // timeout will not recognize context of this method
      var onFileDialogCancel = this.props.onFileDialogCancel;
      // execute the timeout only if the FileDialog is opened in the browser

      if (this.isFileDialogActive) {
        setTimeout(function () {
          if (_this5.fileInputEl != null) {
            // Returns an object as FileList
            var files = _this5.fileInputEl.files;


            if (!files.length) {
              _this5.isFileDialogActive = false;
            }
          }

          if (typeof onFileDialogCancel === 'function') {
            onFileDialogCancel();
          }
        }, 300);
      }
    }
  }, {
    key: 'setRef',
    value: function setRef(ref) {
      this.node = ref;
    }
  }, {
    key: 'setRefs',
    value: function setRefs(ref) {
      this.fileInputEl = ref;
    }
    /**
     * Open system file upload dialog.
     *
     * @public
     */

  }, {
    key: 'open',
    value: function open() {
      this.isFileDialogActive = true;
      this.fileInputEl.value = null;
      this.fileInputEl.click();
    }
  }, {
    key: 'render',
    value: function render() {
      var _props3 = this.props,
          accept = _props3.accept,
          acceptClassName = _props3.acceptClassName,
          activeClassName = _props3.activeClassName,
          children = _props3.children,
          disabled = _props3.disabled,
          disabledClassName = _props3.disabledClassName,
          inputProps = _props3.inputProps,
          multiple = _props3.multiple,
          name = _props3.name,
          rejectClassName = _props3.rejectClassName,
          rest = _objectWithoutProperties(_props3, ['accept', 'acceptClassName', 'activeClassName', 'children', 'disabled', 'disabledClassName', 'inputProps', 'multiple', 'name', 'rejectClassName']);

      var acceptStyle = rest.acceptStyle,
          activeStyle = rest.activeStyle,
          _rest$className = rest.className,
          className = _rest$className === undefined ? '' : _rest$className,
          disabledStyle = rest.disabledStyle,
          rejectStyle = rest.rejectStyle,
          style = rest.style,
          props = _objectWithoutProperties(rest, ['acceptStyle', 'activeStyle', 'className', 'disabledStyle', 'rejectStyle', 'style']);

      var _state = this.state,
          isDragActive = _state.isDragActive,
          draggedFiles = _state.draggedFiles;

      var filesCount = draggedFiles.length;
      var isMultipleAllowed = multiple || filesCount <= 1;
      var isDragAccept = filesCount > 0 && Object(__WEBPACK_IMPORTED_MODULE_2__utils__["a" /* allFilesAccepted */])(draggedFiles, this.props.accept);
      var isDragReject = filesCount > 0 && (!isDragAccept || !isMultipleAllowed);
      var noStyles = !className && !style && !activeStyle && !acceptStyle && !rejectStyle && !disabledStyle;

      if (isDragActive && activeClassName) {
        className += ' ' + activeClassName;
      }
      if (isDragAccept && acceptClassName) {
        className += ' ' + acceptClassName;
      }
      if (isDragReject && rejectClassName) {
        className += ' ' + rejectClassName;
      }
      if (disabled && disabledClassName) {
        className += ' ' + disabledClassName;
      }

      if (noStyles) {
        style = __WEBPACK_IMPORTED_MODULE_3__utils_styles__["a" /* default */].default;
        activeStyle = __WEBPACK_IMPORTED_MODULE_3__utils_styles__["a" /* default */].active;
        acceptStyle = __WEBPACK_IMPORTED_MODULE_3__utils_styles__["a" /* default */].active;
        rejectStyle = __WEBPACK_IMPORTED_MODULE_3__utils_styles__["a" /* default */].rejected;
        disabledStyle = __WEBPACK_IMPORTED_MODULE_3__utils_styles__["a" /* default */].disabled;
      }

      var appliedStyle = _extends({ position: 'relative' }, style);
      if (activeStyle && isDragActive) {
        appliedStyle = _extends({}, appliedStyle, activeStyle);
      }
      if (acceptStyle && isDragAccept) {
        appliedStyle = _extends({}, appliedStyle, acceptStyle);
      }
      if (rejectStyle && isDragReject) {
        appliedStyle = _extends({}, appliedStyle, rejectStyle);
      }
      if (disabledStyle && disabled) {
        appliedStyle = _extends({}, appliedStyle, disabledStyle);
      }

      var inputAttributes = {
        accept: accept,
        disabled: disabled,
        type: 'file',
        style: _extends({
          position: 'absolute',
          top: 0,
          right: 0,
          bottom: 0,
          left: 0,
          opacity: 0.00001,
          pointerEvents: 'none'
        }, inputProps.style),
        multiple: __WEBPACK_IMPORTED_MODULE_2__utils__["g" /* supportMultiple */] && multiple,
        ref: this.setRefs,
        onChange: this.onDrop,
        autoComplete: 'off'
      };

      if (name && name.length) {
        inputAttributes.name = name;
      }

      // Destructure custom props away from props used for the div element

      var acceptedFiles = props.acceptedFiles,
          preventDropOnDocument = props.preventDropOnDocument,
          disablePreview = props.disablePreview,
          disableClick = props.disableClick,
          onDropAccepted = props.onDropAccepted,
          onDropRejected = props.onDropRejected,
          onFileDialogCancel = props.onFileDialogCancel,
          maxSize = props.maxSize,
          minSize = props.minSize,
          getDataTransferItems = props.getDataTransferItems,
          divProps = _objectWithoutProperties(props, ['acceptedFiles', 'preventDropOnDocument', 'disablePreview', 'disableClick', 'onDropAccepted', 'onDropRejected', 'onFileDialogCancel', 'maxSize', 'minSize', 'getDataTransferItems']);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        _extends({
          className: className,
          style: appliedStyle
        }, divProps /* expand user provided props first so event handlers are never overridden */, {
          onClick: this.composeHandlers(this.onClick),
          onDragStart: this.composeHandlers(this.onDragStart),
          onDragEnter: this.composeHandlers(this.onDragEnter),
          onDragOver: this.composeHandlers(this.onDragOver),
          onDragLeave: this.composeHandlers(this.onDragLeave),
          onDrop: this.composeHandlers(this.onDrop),
          ref: this.setRef,
          'aria-disabled': disabled
        }),
        this.renderChildren(children, isDragActive, isDragAccept, isDragReject),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', _extends({}, inputProps /* expand user provided inputProps first so inputAttributes override them */, inputAttributes))
      );
    }
  }]);

  return Dropzone;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (Dropzone);

Dropzone.propTypes = {
  /**
   * Allow specific types of files. See https://github.com/okonet/attr-accept for more information.
   * Keep in mind that mime type determination is not reliable across platforms. CSV files,
   * for example, are reported as text/plain under macOS but as application/vnd.ms-excel under
   * Windows. In some cases there might not be a mime type set at all.
   * See: https://github.com/react-dropzone/react-dropzone/issues/276
   */
  accept: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string)]),

  /**
   * Contents of the dropzone
   */
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func]),

  /**
   * Disallow clicking on the dropzone container to open file dialog
   */
  disableClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * Enable/disable the dropzone entirely
   */
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * Enable/disable preview generation
   */
  disablePreview: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * If false, allow dropped items to take over the current browser window
   */
  preventDropOnDocument: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * Pass additional attributes to the `<input type="file"/>` tag
   */
  inputProps: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,

  /**
   * Allow dropping multiple files
   */
  multiple: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * `name` attribute for the input tag
   */
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * Maximum file size (in bytes)
   */
  maxSize: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,

  /**
   * Minimum file size (in bytes)
   */
  minSize: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,

  /**
   * className
   */
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * className to apply when drag is active
   */
  activeClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * className to apply when drop will be accepted
   */
  acceptClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * className to apply when drop will be rejected
   */
  rejectClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * className to apply when dropzone is disabled
   */
  disabledClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * CSS styles to apply
   */
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,

  /**
   * CSS styles to apply when drag is active
   */
  activeStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,

  /**
   * CSS styles to apply when drop will be accepted
   */
  acceptStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,

  /**
   * CSS styles to apply when drop will be rejected
   */
  rejectStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,

  /**
   * CSS styles to apply when dropzone is disabled
   */
  disabledStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,

  /**
   * getDataTransferItems handler
   * @param {Event} event
   * @returns {Array} array of File objects
   */
  getDataTransferItems: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * onClick callback
   * @param {Event} event
   */
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * onDrop callback
   */
  onDrop: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * onDropAccepted callback
   */
  onDropAccepted: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * onDropRejected callback
   */
  onDropRejected: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * onDragStart callback
   */
  onDragStart: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * onDragEnter callback
   */
  onDragEnter: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * onDragOver callback
   */
  onDragOver: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * onDragLeave callback
   */
  onDragLeave: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * Provide a callback on clicking the cancel button of the file dialog
   */
  onFileDialogCancel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

Dropzone.defaultProps = {
  preventDropOnDocument: true,
  disabled: false,
  disablePreview: false,
  disableClick: false,
  inputProps: {},
  multiple: true,
  maxSize: Infinity,
  minSize: 0,
  getDataTransferItems: __WEBPACK_IMPORTED_MODULE_2__utils__["d" /* getDataTransferItems */]
};

/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_base_node__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_render_all_attributes__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_render_attribute__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_render_style__ = __webpack_require__(666);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__node_map__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_render_svg__ = __webpack_require__(667);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util__ = __webpack_require__(22);










var TRANSFORM = "transform";
var DefinitionMap = {
    clip: "clip-path",
    fill: "fill"
};

function isDefinition(type, value) {
    return type === "clip" || (type === "fill" && (!value || value.nodeType === "Gradient"));
}

function baseUrl() {
    var base = document.getElementsByTagName("base")[0];
    var href = document.location.href;
    var url = "";

    if (base && !__WEBPACK_IMPORTED_MODULE_7__common__["h" /* support */].browser.msie) {
        var hashIndex = href.indexOf("#");
        if (hashIndex !== -1) {
            href = href.substring(0, hashIndex);
        }

        url = href;
    }

    return url;
}

var Node = (function (BaseNode) {
    function Node(srcElement, options) {
        BaseNode.call(this, srcElement);
        this.definitions = {};

        this.options = options;
    }

    if ( BaseNode ) Node.__proto__ = BaseNode;
    Node.prototype = Object.create( BaseNode && BaseNode.prototype );
    Node.prototype.constructor = Node;

    Node.prototype.destroy = function destroy () {
        if (this.element) {
            this.element._kendoNode = null;
            this.element = null;
        }

        this.clearDefinitions();
        BaseNode.prototype.destroy.call(this);
    };

    Node.prototype.load = function load (elements, pos) {
        var this$1 = this;

        for (var i = 0; i < elements.length; i++) {
            var srcElement = elements[i];
            var children = srcElement.children;

            var childNode = new __WEBPACK_IMPORTED_MODULE_4__node_map__["a" /* default */][srcElement.nodeType](srcElement, this$1.options);

            if (Object(__WEBPACK_IMPORTED_MODULE_8__util__["g" /* defined */])(pos)) {
                this$1.insertAt(childNode, pos);
            } else {
                this$1.append(childNode);
            }

            childNode.createDefinitions();

            if (children && children.length > 0) {
                childNode.load(children);
            }

            var element = this$1.element;
            if (element) {
                childNode.attachTo(element, pos);
            }
        }
    };

    Node.prototype.root = function root () {
        var root = this;

        while (root.parent) {
            root = root.parent;
        }

        return root;
    };

    Node.prototype.attachTo = function attachTo (domElement, pos) {
        var container = document.createElement("div");
        Object(__WEBPACK_IMPORTED_MODULE_5__utils_render_svg__["a" /* default */])(container,
            "<svg xmlns='" + __WEBPACK_IMPORTED_MODULE_6__constants__["b" /* SVG_NS */] + "' version='1.1'>" +
                this.render() +
            "</svg>"
        );

        var element = container.firstChild.firstChild;
        if (element) {
            if (Object(__WEBPACK_IMPORTED_MODULE_8__util__["g" /* defined */])(pos)) {
                domElement.insertBefore(element, domElement.childNodes[pos] || null);
            } else {
                domElement.appendChild(element);
            }
            this.setElement(element);
        }
    };

    Node.prototype.setElement = function setElement (element) {
        if (this.element) {
            this.element._kendoNode = null;
        }

        this.element = element;
        this.element._kendoNode = this;

        var nodes = this.childNodes;
        for (var i = 0; i < nodes.length; i++) {
            var childElement = element.childNodes[i];
            nodes[i].setElement(childElement);
        }
    };

    Node.prototype.clear = function clear () {
        this.clearDefinitions();

        if (this.element) {
            this.element.innerHTML = "";
        }

        var children = this.childNodes;
        for (var i = 0; i < children.length; i++) {
            children[i].destroy();
        }

        this.childNodes = [];
    };

    Node.prototype.removeSelf = function removeSelf () {
        if (this.element) {
            var parentNode = this.element.parentNode;
            if (parentNode) {
                parentNode.removeChild(this.element);
            }
            this.element = null;
        }

        BaseNode.prototype.removeSelf.call(this);
    };

    Node.prototype.template = function template () {
        return this.renderChildren();
    };

    Node.prototype.render = function render () {
        return this.template();
    };

    Node.prototype.renderChildren = function renderChildren () {
        var nodes = this.childNodes;
        var output = "";

        for (var i = 0; i < nodes.length; i++) {
            output += nodes[i].render();
        }

        return output;
    };

    Node.prototype.optionsChange = function optionsChange (e) {
        var field = e.field;
        var value = e.value;

        if (field === "visible") {
            this.css("display", value ? "" : __WEBPACK_IMPORTED_MODULE_6__constants__["a" /* NONE */]);
        } else if (DefinitionMap[field] && isDefinition(field, value)) {
            this.updateDefinition(field, value);
        } else if (field === "opacity") {
            this.attr("opacity", value);
        } else if (field === "cursor") {
            this.css("cursor", value);
        } else if (field === "id") {
            if (value) {
                this.attr("id", value);
            } else {
                this.removeAttr("id");
            }
        }

        BaseNode.prototype.optionsChange.call(this, e);
    };

    Node.prototype.attr = function attr (name, value) {
        if (this.element) {
            this.element.setAttribute(name, value);
        }
    };

    Node.prototype.allAttr = function allAttr (attrs) {
        var this$1 = this;

        for (var i = 0; i < attrs.length; i++) {
            this$1.attr(attrs[i][0], attrs[i][1]);
        }
    };

    Node.prototype.css = function css (name, value) {
        if (this.element) {
            this.element.style[name] = value;
        }
    };

    Node.prototype.allCss = function allCss (styles) {
        var this$1 = this;

        for (var i = 0; i < styles.length; i++) {
            this$1.css(styles[i][0], styles[i][1]);
        }
    };

    Node.prototype.removeAttr = function removeAttr (name) {
        if (this.element) {
            this.element.removeAttribute(name);
        }
    };

    Node.prototype.mapTransform = function mapTransform (transform) {
        var attrs = [];
        if (transform) {
            attrs.push([
                TRANSFORM,
                "matrix(" + transform.matrix().toString(6) + ")"
            ]);
        }

        return attrs;
    };

    Node.prototype.renderTransform = function renderTransform () {
        return Object(__WEBPACK_IMPORTED_MODULE_1__utils_render_all_attributes__["a" /* default */])(
            this.mapTransform(this.srcElement.transform())
        );
    };

    Node.prototype.transformChange = function transformChange (value) {
        if (value) {
            this.allAttr(this.mapTransform(value));
        } else {
            this.removeAttr(TRANSFORM);
        }
    };

    Node.prototype.mapStyle = function mapStyle () {
        var options = this.srcElement.options;
        var style = [ [ "cursor", options.cursor ] ];

        if (options.visible === false) {
            style.push([ "display", __WEBPACK_IMPORTED_MODULE_6__constants__["a" /* NONE */] ]);
        }

        return style;
    };

    Node.prototype.renderStyle = function renderStyle$1 () {
        return Object(__WEBPACK_IMPORTED_MODULE_2__utils_render_attribute__["a" /* default */])("style", Object(__WEBPACK_IMPORTED_MODULE_3__utils_render_style__["a" /* default */])(this.mapStyle(true)));
    };

    Node.prototype.renderOpacity = function renderOpacity () {
        return Object(__WEBPACK_IMPORTED_MODULE_2__utils_render_attribute__["a" /* default */])("opacity", this.srcElement.options.opacity);
    };

    Node.prototype.renderId = function renderId () {
        return Object(__WEBPACK_IMPORTED_MODULE_2__utils_render_attribute__["a" /* default */])("id", this.srcElement.options.id);
    };

    Node.prototype.createDefinitions = function createDefinitions () {
        var srcElement = this.srcElement;
        var definitions = this.definitions;
        if (srcElement) {
            var options = srcElement.options;
            var hasDefinitions;

            for (var field in DefinitionMap) {
                var definition = options.get(field);
                if (definition && isDefinition(field, definition)) {
                    definitions[field] = definition;
                    hasDefinitions = true;
                }
            }
            if (hasDefinitions) {
                this.definitionChange({
                    action: "add",
                    definitions: definitions
                });
            }
        }
    };

    Node.prototype.definitionChange = function definitionChange (e) {
        if (this.parent) {
            this.parent.definitionChange(e);
        }
    };

    Node.prototype.updateDefinition = function updateDefinition (type, value) {
        var definitions = this.definitions;
        var current = definitions[type];
        var attr = DefinitionMap[type];
        var definition = {};
        if (current) {
            definition[type] = current;
            this.definitionChange({
                action: "remove",
                definitions: definition
            });
            delete definitions[type];
        }

        if (!value) {
            if (current) {
                this.removeAttr(attr);
            }
        } else {
            definition[type] = value;
            this.definitionChange({
                action: "add",
                definitions: definition
            });
            definitions[type] = value;
            this.attr(attr, this.refUrl(value.id));
        }
    };

    Node.prototype.clearDefinitions = function clearDefinitions () {
        var definitions = this.definitions;

        this.definitionChange({
            action: "remove",
            definitions: definitions
        });
        this.definitions = {};
    };

    Node.prototype.renderDefinitions = function renderDefinitions () {
        return Object(__WEBPACK_IMPORTED_MODULE_1__utils_render_all_attributes__["a" /* default */])(this.mapDefinitions());
    };

    Node.prototype.mapDefinitions = function mapDefinitions () {
        var this$1 = this;

        var definitions = this.definitions;
        var attrs = [];

        for (var field in definitions) {
            attrs.push([ DefinitionMap[field], this$1.refUrl(definitions[field].id) ]);
        }

        return attrs;
    };

    Node.prototype.refUrl = function refUrl (id) {
        var skipBaseHref = (this.options || {}).skipBaseHref;
        var baseHref = this.baseUrl().replace(/'/g, "\\'");
        var base = skipBaseHref ? '' : baseHref;
        return ("url(" + base + "#" + id + ")");
    };

    Node.prototype.baseUrl = function baseUrl$1 () {
        return baseUrl();
    };

    return Node;
}(__WEBPACK_IMPORTED_MODULE_0__core_base_node__["a" /* default */]));

/* harmony default export */ __webpack_exports__["a"] = (Node);


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var scope_1 = __webpack_require__(751);
exports.addGlobalEventProcessor = scope_1.addGlobalEventProcessor;
exports.Scope = scope_1.Scope;
var hub_1 = __webpack_require__(2868);
exports.getCurrentHub = hub_1.getCurrentHub;
exports.getHubFromCarrier = hub_1.getHubFromCarrier;
exports.getMainCarrier = hub_1.getMainCarrier;
exports.Hub = hub_1.Hub;
exports.setHubOnCarrier = hub_1.setHubOnCarrier;
//# sourceMappingURL=index.js.map

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = function() {};

if (false) {
  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
        '`warning(condition, format, ...args)` requires a warning ' +
        'message argument'
      );
    }

    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
      throw new Error(
        'The warning format should be able to uniquely identify this ' +
        'warning. Please, use a more descriptive format than: ' + format
      );
    }

    if (!condition) {
      var argIndex = 0;
      var message = 'Warning: ' +
        format.replace(/%s/g, function() {
          return args[argIndex++];
        });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch(x) {}
    }
  };
}

module.exports = warning;


/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "polyfill", function() { return polyfill; });
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

function componentWillMount() {
  // Call this.constructor.gDSFP to support sub-classes.
  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
  if (state !== null && state !== undefined) {
    this.setState(state);
  }
}

function componentWillReceiveProps(nextProps) {
  // Call this.constructor.gDSFP to support sub-classes.
  // Use the setState() updater to ensure state isn't stale in certain edge cases.
  function updater(prevState) {
    var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
    return state !== null && state !== undefined ? state : null;
  }
  // Binding "this" is important for shallow renderer support.
  this.setState(updater.bind(this));
}

function componentWillUpdate(nextProps, nextState) {
  try {
    var prevProps = this.props;
    var prevState = this.state;
    this.props = nextProps;
    this.state = nextState;
    this.__reactInternalSnapshotFlag = true;
    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
      prevProps,
      prevState
    );
  } finally {
    this.props = prevProps;
    this.state = prevState;
  }
}

// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
componentWillMount.__suppressDeprecationWarning = true;
componentWillReceiveProps.__suppressDeprecationWarning = true;
componentWillUpdate.__suppressDeprecationWarning = true;

function polyfill(Component) {
  var prototype = Component.prototype;

  if (!prototype || !prototype.isReactComponent) {
    throw new Error('Can only polyfill class components');
  }

  if (
    typeof Component.getDerivedStateFromProps !== 'function' &&
    typeof prototype.getSnapshotBeforeUpdate !== 'function'
  ) {
    return Component;
  }

  // If new component APIs are defined, "unsafe" lifecycles won't be called.
  // Error if any of these lifecycles are present,
  // Because they would work differently between older and newer (16.3+) versions of React.
  var foundWillMountName = null;
  var foundWillReceivePropsName = null;
  var foundWillUpdateName = null;
  if (typeof prototype.componentWillMount === 'function') {
    foundWillMountName = 'componentWillMount';
  } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
    foundWillMountName = 'UNSAFE_componentWillMount';
  }
  if (typeof prototype.componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'componentWillReceiveProps';
  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
  }
  if (typeof prototype.componentWillUpdate === 'function') {
    foundWillUpdateName = 'componentWillUpdate';
  } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
    foundWillUpdateName = 'UNSAFE_componentWillUpdate';
  }
  if (
    foundWillMountName !== null ||
    foundWillReceivePropsName !== null ||
    foundWillUpdateName !== null
  ) {
    var componentName = Component.displayName || Component.name;
    var newApiName =
      typeof Component.getDerivedStateFromProps === 'function'
        ? 'getDerivedStateFromProps()'
        : 'getSnapshotBeforeUpdate()';

    throw Error(
      'Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' +
        componentName +
        ' uses ' +
        newApiName +
        ' but also contains the following legacy lifecycles:' +
        (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') +
        (foundWillReceivePropsName !== null
          ? '\n  ' + foundWillReceivePropsName
          : '') +
        (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') +
        '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' +
        'https://fb.me/react-async-component-lifecycle-hooks'
    );
  }

  // React <= 16.2 does not support static getDerivedStateFromProps.
  // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
  // Newer versions of React will ignore these lifecycles if gDSFP exists.
  if (typeof Component.getDerivedStateFromProps === 'function') {
    prototype.componentWillMount = componentWillMount;
    prototype.componentWillReceiveProps = componentWillReceiveProps;
  }

  // React <= 16.2 does not support getSnapshotBeforeUpdate.
  // As a workaround, use cWU to invoke the new lifecycle.
  // Newer versions of React will ignore that lifecycle if gSBU exists.
  if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
    if (typeof prototype.componentDidUpdate !== 'function') {
      throw new Error(
        'Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype'
      );
    }

    prototype.componentWillUpdate = componentWillUpdate;

    var componentDidUpdate = prototype.componentDidUpdate;

    prototype.componentDidUpdate = function componentDidUpdatePolyfill(
      prevProps,
      prevState,
      maybeSnapshot
    ) {
      // 16.3+ will not execute our will-update method;
      // It will pass a snapshot value to did-update though.
      // Older versions will require our polyfilled will-update value.
      // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
      // Because for <= 15.x versions this might be a "prevContext" object.
      // We also can't just check "__reactInternalSnapshot",
      // Because get-snapshot might return a falsy value.
      // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
      var snapshot = this.__reactInternalSnapshotFlag
        ? this.__reactInternalSnapshot
        : maybeSnapshot;

      componentDidUpdate.call(this, prevProps, prevState, snapshot);
    };
  }

  return Component;
}




/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.cloneElementWithClassName = cloneElementWithClassName;
exports.cloneChildrenWithClassName = cloneChildrenWithClassName;
exports.isMuiElement = isMuiElement;
exports.isMuiComponent = isMuiComponent;

var _react = _interopRequireDefault(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(6));

/* eslint-disable import/prefer-default-export */
function cloneElementWithClassName(child, className) {
  return _react.default.cloneElement(child, {
    className: (0, _classnames.default)(child.props.className, className)
  });
}

function cloneChildrenWithClassName(children, className) {
  return _react.default.Children.map(children, function (child) {
    return _react.default.isValidElement(child) && cloneElementWithClassName(child, className);
  });
}

function isMuiElement(element, muiNames) {
  return _react.default.isValidElement(element) && muiNames.indexOf(element.type.muiName) !== -1;
}

function isMuiComponent(element, muiNames) {
  return muiNames.indexOf(element.muiName) !== -1;
}

/***/ }),
/* 106 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _List.default;
  }
});

var _List = _interopRequireDefault(__webpack_require__(1010));

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _ListItem.default;
  }
});

var _ListItem = _interopRequireDefault(__webpack_require__(1011));

/***/ }),
/* 109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_core__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_icons_Visibility__ = __webpack_require__(516);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_icons_Visibility___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_icons_Visibility__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_icons_VisibilityOff__ = __webpack_require__(517);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_icons_VisibilityOff___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_icons_VisibilityOff__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/*eslint-disable*/var styles=function styles(theme){return{textField:{width:"100%",marginTop:0,marginBottom:0}};};var FormInputClass=function(_React$Component){_inherits(FormInputClass,_React$Component);function FormInputClass(props){_classCallCheck(this,FormInputClass);var _this=_possibleConstructorReturn(this,(FormInputClass.__proto__||Object.getPrototypeOf(FormInputClass)).call(this,props));_this.handleChange=function(event){event.preventDefault();if(_this.props.input.onChange){_this.props.input.onChange(event);_this.props.input.onBlur(event);}};_this.handleChange=_this.handleChange.bind(_this);return _this;}_createClass(FormInputClass,[{key:"componentWillReceiveProps",value:function componentWillReceiveProps(nextProps){if(nextProps.meta.touched||nextProps.input.value!==this.props.input.value||nextProps.p_value!==this.props.p_value){this.forceUpdate();}}},{key:"shouldComponentUpdate",value:function shouldComponentUpdate(){return true;}},{key:"render",value:function render(){var _this2=this;/* if (this.props.meta.pristine) {
            this.props.meta.valid = false;
        }

        if (this.props.isrequired == false) {
            this.props.meta.valid = true;
        }
         */this.props.meta.valid=false;var trySubmit=this.props.checkValidation?true:false;var _props$meta=this.props.meta,touched=_props$meta.touched,error=_props$meta.error,warning=_props$meta.warning;var lValue=this.props.input.value;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["X" /* TextField */],{onKeyPress:function onKeyPress(e){return _this2.props.handleKeyPress?_this2.props.handleKeyPress(e):{};},onChange:this.handleChange,id:this.props.input.name,value:lValue,label:this.props.label,className:this.props.classes.textField,margin:"normal",error:error&&error.length>0&&touched?true:error&&error.length>0&&trySubmit?true:false,helperText:error&&error.length>0&&touched||error&&error.length>0&&trySubmit?error:null,type:this.props.showPassword?"text":"password",InputProps:this.props.showPassword!==undefined?{endAdornment:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["z" /* InputAdornment */],{variant:"filled",position:"end"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["x" /* IconButton */],{"aria-label":"Toggle password visibility",onClick:this.props.handleClickShowPassword},this.props.showPassword?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_icons_VisibilityOff___default.a,null):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_icons_Visibility___default.a,null)))}:{}});}}]);return FormInputClass;}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["_1" /* withStyles */])(styles)(FormInputClass));

/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

/* harmony default export */ __webpack_exports__["a"] = (isObjectLike);


/***/ }),
/* 111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseIsNative_js__ = __webpack_require__(1161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getValue_js__ = __webpack_require__(1164);



/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = Object(__WEBPACK_IMPORTED_MODULE_1__getValue_js__["a" /* default */])(object, key);
  return Object(__WEBPACK_IMPORTED_MODULE_0__baseIsNative_js__["a" /* default */])(value) ? value : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = (getNative);


/***/ }),
/* 112 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

var startOfWeek = __webpack_require__(262)

/**
 * @category ISO Week Helpers
 * @summary Return the start of an ISO week for the given date.
 *
 * @description
 * Return the start of an ISO week for the given date.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the start of an ISO week
 *
 * @example
 * // The start of an ISO week for 2 September 2014 11:55:00:
 * var result = startOfISOWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Mon Sep 01 2014 00:00:00
 */
function startOfISOWeek (dirtyDate) {
  return startOfWeek(dirtyDate, {weekStartsOn: 1})
}

module.exports = startOfISOWeek


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(9)
var startOfISOWeek = __webpack_require__(113)

/**
 * @category ISO Week-Numbering Year Helpers
 * @summary Get the ISO week-numbering year of the given date.
 *
 * @description
 * Get the ISO week-numbering year of the given date,
 * which always starts 3 days before the year's first Thursday.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the ISO week-numbering year
 *
 * @example
 * // Which ISO-week numbering year is 2 January 2005?
 * var result = getISOYear(new Date(2005, 0, 2))
 * //=> 2004
 */
function getISOYear (dirtyDate) {
  var date = parse(dirtyDate)
  var year = date.getFullYear()

  var fourthOfJanuaryOfNextYear = new Date(0)
  fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4)
  fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0)
  var startOfNextYear = startOfISOWeek(fourthOfJanuaryOfNextYear)

  var fourthOfJanuaryOfThisYear = new Date(0)
  fourthOfJanuaryOfThisYear.setFullYear(year, 0, 4)
  fourthOfJanuaryOfThisYear.setHours(0, 0, 0, 0)
  var startOfThisYear = startOfISOWeek(fourthOfJanuaryOfThisYear)

  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year
  } else {
    return year - 1
  }
}

module.exports = getISOYear


/***/ }),
/* 115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getClientsByBroker; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_graphql_tag__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_graphql_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_graphql_tag__);
var _templateObject=_taggedTemplateLiteral(["\n  query getClientsByBroker(\n    $brokerId: String!\n    $token: String!\n    $userType: String!\n    $status: String!\n  ) {\n    getClientsByBroker(\n      brokerId: $brokerId\n      token: $token\n      userType: $userType\n      status: $status\n    ) {\n        id\n        scd_name\n        scd_surname\n        scd_email\n        date_created\n        scd_clientType\n        scd_registered\n        invite_sent\n        app_info_complete\n        status\n        date_modified\n        \n        \n    }\n  }\n"],["\n  query getClientsByBroker(\n    $brokerId: String!\n    $token: String!\n    $userType: String!\n    $status: String!\n  ) {\n    getClientsByBroker(\n      brokerId: $brokerId\n      token: $token\n      userType: $userType\n      status: $status\n    ) {\n        id\n        scd_name\n        scd_surname\n        scd_email\n        date_created\n        scd_clientType\n        scd_registered\n        invite_sent\n        app_info_complete\n        status\n        date_modified\n        \n        \n    }\n  }\n"]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var getClientsByBroker=__WEBPACK_IMPORTED_MODULE_0_graphql_tag___default()(_templateObject);

/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return QuoteEligibility; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_graphql_tag__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_graphql_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_graphql_tag__);
var _templateObject=_taggedTemplateLiteral(["\n  mutation($input: QuoteEligibilityInput!) {\n    QuoteEligibility(input: $input) {\n      valid,\n      invalidFields\n    }\n  }\n"],["\n  mutation($input: QuoteEligibilityInput!) {\n    QuoteEligibility(input: $input) {\n      valid,\n      invalidFields\n    }\n  }\n"]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var QuoteEligibility=__WEBPACK_IMPORTED_MODULE_0_graphql_tag___default()(_templateObject);

/***/ }),
/* 117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_core__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var DescriptiveRow=function DescriptiveRow(props){var hasBorder=props.count<1;if(props.noBorder)hasBorder=false;if(props.hasBorder)hasBorder=true;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{style:{borderBottom:hasBorder?"1px solid #e0e0e0":"0px",padding:"0px",paddingTop:"15px"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{container:true},props.description?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{item:true,xs:12,sm:12,md:9},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("strong",null,props.description))):null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{item:true,xs:10,sm:10,md:props.description?1:10},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["d" /* Button */],{variant:"fab",mini:true,className:"minifab",color:"primary",style:{bottom:"3px"},onClick:function onClick(){return props.add();}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["w" /* Icon */],{style:{color:"white"}},"add"))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{item:true,xs:2,sm:2,md:2,style:{textAlign:"center"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{variant:"caption"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("strong",null,props.count===0?"":props.count)))))),!props.extraCells?null:[].concat(_toConsumableArray(Array(props.extraCells))).map(function(c,i){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{key:i,style:{borderBottom:hasBorder?"1px solid #e0e0e0":"0px",padding:"0px",paddingTop:"15px"}});}));};/* harmony default export */ __webpack_exports__["a"] = (DescriptiveRow);

/***/ }),
/* 118 */
/***/ (function(module, exports) {

if (typeof Object.create === 'function') {
  // implementation from standard node.js 'util' module
  module.exports = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor
    ctor.prototype = Object.create(superCtor.prototype, {
      constructor: {
        value: ctor,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
  };
} else {
  // old school shim for old browsers
  module.exports = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor
    var TempCtor = function () {}
    TempCtor.prototype = superCtor.prototype
    ctor.prototype = new TempCtor()
    ctor.prototype.constructor = ctor
  }
}


/***/ }),
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = toMatrix;
function toMatrix(transformation) {
    if (transformation && typeof transformation.matrix === "function") {
        return transformation.matrix();
    }

    return transformation;
}

/***/ }),
/* 120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_constants__ = __webpack_require__(674);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_render_all_attributes__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_render_attribute__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__node_map__ = __webpack_require__(86);








var ATTRIBUTE_MAP = {
    "fill.opacity": "fill-opacity",
    "stroke.color": "stroke",
    "stroke.width": "stroke-width",
    "stroke.opacity": "stroke-opacity"
};
var SPACE = " ";

var PathNode = (function (Node) {
    function PathNode () {
        Node.apply(this, arguments);
    }

    if ( Node ) PathNode.__proto__ = Node;
    PathNode.prototype = Object.create( Node && Node.prototype );
    PathNode.prototype.constructor = PathNode;

    PathNode.prototype.geometryChange = function geometryChange () {
        this.attr("d", this.renderData());
        this.invalidate();
    };

    PathNode.prototype.optionsChange = function optionsChange (e) {
        switch (e.field) {
            case "fill":
                if (e.value) {
                    this.allAttr(this.mapFill(e.value));
                } else {
                    this.removeAttr("fill");
                }
                break;

            case "fill.color":
                this.allAttr(this.mapFill({ color: e.value }));
                break;

            case "stroke":
                if (e.value) {
                    this.allAttr(this.mapStroke(e.value));
                } else {
                    this.removeAttr("stroke");
                }
                break;

            case "transform":
                this.transformChange(e.value);
                break;

            default:
                var name = ATTRIBUTE_MAP[e.field];
                if (name) {
                    this.attr(name, e.value);
                }
                break;
        }

        Node.prototype.optionsChange.call(this, e);
    };

    PathNode.prototype.content = function content () {
        if (this.element) {
            this.element.textContent = this.srcElement.content();
        }
    };

    PathNode.prototype.renderData = function renderData () {
        return this.printPath(this.srcElement);
    };

    PathNode.prototype.printPath = function printPath (path) {
        var this$1 = this;

        var segments = path.segments;
        var length = segments.length;
        if (length > 0) {
            var parts = [];
            var output, currentType;

            for (var i = 1; i < length; i++) {
                var segmentType = this$1.segmentType(segments[i - 1], segments[i]);
                if (segmentType !== currentType) {
                    currentType = segmentType;
                    parts.push(segmentType);
                }

                if (segmentType === "L") {
                    parts.push(this$1.printPoints(segments[i].anchor()));
                } else {
                    parts.push(this$1.printPoints(segments[i - 1].controlOut(), segments[i].controlIn(), segments[i].anchor()));
                }
            }

            output = "M" + this.printPoints(segments[0].anchor()) + SPACE + parts.join(SPACE);
            if (path.options.closed) {
                output += "Z";
            }

            return output;
        }
    };

    PathNode.prototype.printPoints = function printPoints () {
        var points = arguments;
        var length = points.length;
        var result = [];

        for (var i = 0; i < length; i++) {
            result.push(points[i].toString(3));
        }

        return result.join(" ");
    };

    PathNode.prototype.segmentType = function segmentType (segmentStart, segmentEnd) {
        return segmentStart.controlOut() && segmentEnd.controlIn() ? "C" : "L";
    };

    PathNode.prototype.mapStroke = function mapStroke (stroke) {
        var attrs = [];

        if (stroke && !Object(__WEBPACK_IMPORTED_MODULE_1__util__["p" /* isTransparent */])(stroke.color)) {
            attrs.push([ "stroke", stroke.color ]);
            attrs.push([ "stroke-width", stroke.width ]);
            attrs.push([ "stroke-linecap", this.renderLinecap(stroke) ]);
            attrs.push([ "stroke-linejoin", stroke.lineJoin ]);

            if (Object(__WEBPACK_IMPORTED_MODULE_1__util__["g" /* defined */])(stroke.opacity)) {
                attrs.push([ "stroke-opacity", stroke.opacity ]);
            }

            if (Object(__WEBPACK_IMPORTED_MODULE_1__util__["g" /* defined */])(stroke.dashType)) {
                attrs.push([ "stroke-dasharray", this.renderDashType(stroke) ]);
            }
        } else {
            attrs.push([ "stroke", __WEBPACK_IMPORTED_MODULE_3__constants__["a" /* NONE */] ]);
        }

        return attrs;
    };

    PathNode.prototype.renderStroke = function renderStroke () {
        return Object(__WEBPACK_IMPORTED_MODULE_4__utils_render_all_attributes__["a" /* default */])(
            this.mapStroke(this.srcElement.options.stroke)
        );
    };

    PathNode.prototype.renderDashType = function renderDashType (stroke) {
        var dashType = stroke.dashType;
        var width = stroke.width; if ( width === void 0 ) width = 1;

        if (dashType && dashType !== __WEBPACK_IMPORTED_MODULE_2__core_constants__["c" /* SOLID */]) {
            var dashArray = __WEBPACK_IMPORTED_MODULE_2__core_constants__["b" /* DASH_ARRAYS */][dashType.toLowerCase()];
            var result = [];

            for (var i = 0; i < dashArray.length; i++) {
                result.push(dashArray[i] * width);
            }

            return result.join(" ");
        }
    };

    PathNode.prototype.renderLinecap = function renderLinecap (stroke) {
        var dashType = stroke.dashType;
        var lineCap = stroke.lineCap;

        return (dashType && dashType !== "solid") ? __WEBPACK_IMPORTED_MODULE_2__core_constants__["a" /* BUTT */] : lineCap;
    };

    PathNode.prototype.mapFill = function mapFill (fill) {
        var attrs = [];
        if (!(fill && fill.nodeType === "Gradient")) {
            if (fill && !Object(__WEBPACK_IMPORTED_MODULE_1__util__["p" /* isTransparent */])(fill.color)) {
                attrs.push([ "fill", fill.color ]);

                if (Object(__WEBPACK_IMPORTED_MODULE_1__util__["g" /* defined */])(fill.opacity)) {
                    attrs.push([ "fill-opacity", fill.opacity ]);
                }
            } else {
                attrs.push([ "fill", __WEBPACK_IMPORTED_MODULE_3__constants__["a" /* NONE */] ]);
            }
        }

        return attrs;
    };

    PathNode.prototype.renderFill = function renderFill () {
        return Object(__WEBPACK_IMPORTED_MODULE_4__utils_render_all_attributes__["a" /* default */])(
            this.mapFill(this.srcElement.options.fill)
        );
    };

    PathNode.prototype.template = function template () {
        return "<path " + (this.renderId()) + " " + (this.renderStyle()) + " " + (this.renderOpacity()) + " " + (Object(__WEBPACK_IMPORTED_MODULE_5__utils_render_attribute__["a" /* default */])('d', this.renderData())) +
                    "" + (this.renderStroke()) + (this.renderFill()) + (this.renderDefinitions()) + (this.renderTransform()) + "></path>";
    };

    return PathNode;
}(__WEBPACK_IMPORTED_MODULE_0__node__["a" /* default */]));

__WEBPACK_IMPORTED_MODULE_6__node_map__["a" /* default */].Path = PathNode;

/* harmony default export */ __webpack_exports__["a"] = (PathNode);

/***/ }),
/* 121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__geometry_circle__ = __webpack_require__(647);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__geometry_circle__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__geometry_arc__ = __webpack_require__(401);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__geometry_arc__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__geometry_rect__ = __webpack_require__(64);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_2__geometry_rect__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__geometry_point__ = __webpack_require__(42);
/* unused harmony reexport Point */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__geometry_segment__ = __webpack_require__(652);
/* unused harmony reexport Segment */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__geometry_matrix__ = __webpack_require__(200);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_5__geometry_matrix__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__geometry_size__ = __webpack_require__(276);
/* unused harmony reexport Size */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__geometry_to_matrix__ = __webpack_require__(119);
/* unused harmony reexport toMatrix */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__geometry_transformation__ = __webpack_require__(646);
/* unused harmony reexport Transformation */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__geometry_transform__ = __webpack_require__(85);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_9__geometry_transform__["a"]; });












/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node__ = __webpack_require__(411);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__gradients_linear_gradient__ = __webpack_require__(406);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__gradients_radial_gradient__ = __webpack_require__(408);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__core_constants__ = __webpack_require__(674);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_render_path__ = __webpack_require__(283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__node_map__ = __webpack_require__(87);









function addGradientStops(gradient, stops) {
    for (var idx = 0; idx < stops.length; idx++) {
        var stop = stops[idx];
        var color = Object(__WEBPACK_IMPORTED_MODULE_1__common__["f" /* parseColor */])(stop.color());

        color.a *= stop.opacity();

        gradient.addColorStop(stop.offset(), color.toCssRgba());
    }
}

var PathNode = (function (Node) {
    function PathNode () {
        Node.apply(this, arguments);
    }

    if ( Node ) PathNode.__proto__ = Node;
    PathNode.prototype = Object.create( Node && Node.prototype );
    PathNode.prototype.constructor = PathNode;

    PathNode.prototype.renderTo = function renderTo (ctx) {
        ctx.save();

        this.setTransform(ctx);
        this.setClip(ctx);
        this.setOpacity(ctx);

        ctx.beginPath();

        this.renderPoints(ctx, this.srcElement);

        this.setLineDash(ctx);
        this.setLineCap(ctx);
        this.setLineJoin(ctx);

        this.setFill(ctx);
        this.setStroke(ctx);

        ctx.restore();
    };

    PathNode.prototype.setFill = function setFill (ctx) {
        var fill = this.srcElement.options.fill;
        var hasFill = false;

        if (fill) {
            if (fill.nodeType === "Gradient") {
                this.setGradientFill(ctx, fill);
                hasFill = true;
            } else if (!Object(__WEBPACK_IMPORTED_MODULE_2__util__["p" /* isTransparent */])(fill.color)) {
                ctx.fillStyle = fill.color;

                ctx.save();
                this.globalAlpha(ctx, fill.opacity);
                ctx.fill();
                ctx.restore();

                hasFill = true;
            }
        }

        return hasFill;
    };

    PathNode.prototype.setGradientFill = function setGradientFill (ctx, fill) {
        var bbox = this.srcElement.rawBBox();
        var gradient;

        if (fill instanceof __WEBPACK_IMPORTED_MODULE_3__gradients_linear_gradient__["a" /* default */]) {
            var start = fill.start();
            var end = fill.end();
            gradient = ctx.createLinearGradient(start.x, start.y, end.x, end.y);
        } else if (fill instanceof __WEBPACK_IMPORTED_MODULE_4__gradients_radial_gradient__["a" /* default */]) {
            var center = fill.center();
            gradient = ctx.createRadialGradient(center.x, center.y, 0, center.x, center.y, fill.radius());
        }

        addGradientStops(gradient, fill.stops);

        ctx.save();

        if (!fill.userSpace()) {
            ctx.transform(bbox.width(), 0, 0, bbox.height(), bbox.origin.x, bbox.origin.y);
        }
        ctx.fillStyle = gradient;
        ctx.fill();

        ctx.restore();
    };

    PathNode.prototype.setStroke = function setStroke (ctx) {
        var stroke = this.srcElement.options.stroke;
        if (stroke && !Object(__WEBPACK_IMPORTED_MODULE_2__util__["p" /* isTransparent */])(stroke.color) && stroke.width > 0) {
            ctx.strokeStyle = stroke.color;
            ctx.lineWidth = Object(__WEBPACK_IMPORTED_MODULE_2__util__["y" /* valueOrDefault */])(stroke.width, 1);

            ctx.save();
            this.globalAlpha(ctx, stroke.opacity);
            ctx.stroke();
            ctx.restore();

            return true;
        }
    };

    PathNode.prototype.dashType = function dashType () {
        var stroke = this.srcElement.options.stroke;
        if (stroke && stroke.dashType) {
            return stroke.dashType.toLowerCase();
        }
    };

    PathNode.prototype.setLineDash = function setLineDash (ctx) {
        var dashType = this.dashType();
        if (dashType && dashType !== __WEBPACK_IMPORTED_MODULE_5__core_constants__["c" /* SOLID */]) {
            var dashArray = __WEBPACK_IMPORTED_MODULE_5__core_constants__["b" /* DASH_ARRAYS */][dashType];
            if (ctx.setLineDash) {
                ctx.setLineDash(dashArray);
            } else {
                ctx.mozDash = dashArray;
                ctx.webkitLineDash = dashArray;
            }
        }
    };

    PathNode.prototype.setLineCap = function setLineCap (ctx) {
        var dashType = this.dashType();
        var stroke = this.srcElement.options.stroke;
        if (dashType && dashType !== __WEBPACK_IMPORTED_MODULE_5__core_constants__["c" /* SOLID */]) {
            ctx.lineCap = __WEBPACK_IMPORTED_MODULE_5__core_constants__["a" /* BUTT */];
        } else if (stroke && stroke.lineCap) {
            ctx.lineCap = stroke.lineCap;
        }
    };

    PathNode.prototype.setLineJoin = function setLineJoin (ctx) {
        var stroke = this.srcElement.options.stroke;
        if (stroke && stroke.lineJoin) {
            ctx.lineJoin = stroke.lineJoin;
        }
    };

    PathNode.prototype.renderPoints = function renderPoints (ctx, path) {
        Object(__WEBPACK_IMPORTED_MODULE_6__utils_render_path__["a" /* default */])(ctx, path);
    };

    return PathNode;
}(__WEBPACK_IMPORTED_MODULE_0__node__["a" /* default */]));

__WEBPACK_IMPORTED_MODULE_7__node_map__["a" /* default */].Path = PathNode;

/* harmony default export */ __webpack_exports__["a"] = (PathNode);


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */



var base64 = __webpack_require__(2622)
var ieee754 = __webpack_require__(2623)
var isArray = __webpack_require__(695)

exports.Buffer = Buffer
exports.SlowBuffer = SlowBuffer
exports.INSPECT_MAX_BYTES = 50

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Use Object implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * Due to various browser bugs, sometimes the Object implementation will be used even
 * when the browser supports typed arrays.
 *
 * Note:
 *
 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
 *
 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
 *
 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
 *     incorrect length in some situations.

 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
 * get the Object implementation, which is slower but behaves correctly.
 */
Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
  ? global.TYPED_ARRAY_SUPPORT
  : typedArraySupport()

/*
 * Export kMaxLength after typed array support is determined.
 */
exports.kMaxLength = kMaxLength()

function typedArraySupport () {
  try {
    var arr = new Uint8Array(1)
    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
    return arr.foo() === 42 && // typed array instances can be augmented
        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
  } catch (e) {
    return false
  }
}

function kMaxLength () {
  return Buffer.TYPED_ARRAY_SUPPORT
    ? 0x7fffffff
    : 0x3fffffff
}

function createBuffer (that, length) {
  if (kMaxLength() < length) {
    throw new RangeError('Invalid typed array length')
  }
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = new Uint8Array(length)
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    if (that === null) {
      that = new Buffer(length)
    }
    that.length = length
  }

  return that
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer (arg, encodingOrOffset, length) {
  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
    return new Buffer(arg, encodingOrOffset, length)
  }

  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new Error(
        'If encoding is specified then the first argument must be a string'
      )
    }
    return allocUnsafe(this, arg)
  }
  return from(this, arg, encodingOrOffset, length)
}

Buffer.poolSize = 8192 // not used by this implementation

// TODO: Legacy, not needed anymore. Remove in next major version.
Buffer._augment = function (arr) {
  arr.__proto__ = Buffer.prototype
  return arr
}

function from (that, value, encodingOrOffset, length) {
  if (typeof value === 'number') {
    throw new TypeError('"value" argument must not be a number')
  }

  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
    return fromArrayBuffer(that, value, encodingOrOffset, length)
  }

  if (typeof value === 'string') {
    return fromString(that, value, encodingOrOffset)
  }

  return fromObject(that, value)
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(null, value, encodingOrOffset, length)
}

if (Buffer.TYPED_ARRAY_SUPPORT) {
  Buffer.prototype.__proto__ = Uint8Array.prototype
  Buffer.__proto__ = Uint8Array
  if (typeof Symbol !== 'undefined' && Symbol.species &&
      Buffer[Symbol.species] === Buffer) {
    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
    Object.defineProperty(Buffer, Symbol.species, {
      value: null,
      configurable: true
    })
  }
}

function assertSize (size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be a number')
  } else if (size < 0) {
    throw new RangeError('"size" argument must not be negative')
  }
}

function alloc (that, size, fill, encoding) {
  assertSize(size)
  if (size <= 0) {
    return createBuffer(that, size)
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === 'string'
      ? createBuffer(that, size).fill(fill, encoding)
      : createBuffer(that, size).fill(fill)
  }
  return createBuffer(that, size)
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(null, size, fill, encoding)
}

function allocUnsafe (that, size) {
  assertSize(size)
  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) {
    for (var i = 0; i < size; ++i) {
      that[i] = 0
    }
  }
  return that
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(null, size)
}
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(null, size)
}

function fromString (that, string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8'
  }

  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('"encoding" must be a valid string encoding')
  }

  var length = byteLength(string, encoding) | 0
  that = createBuffer(that, length)

  var actual = that.write(string, encoding)

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    that = that.slice(0, actual)
  }

  return that
}

function fromArrayLike (that, array) {
  var length = array.length < 0 ? 0 : checked(array.length) | 0
  that = createBuffer(that, length)
  for (var i = 0; i < length; i += 1) {
    that[i] = array[i] & 255
  }
  return that
}

function fromArrayBuffer (that, array, byteOffset, length) {
  array.byteLength // this throws if `array` is not a valid ArrayBuffer

  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('\'offset\' is out of bounds')
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('\'length\' is out of bounds')
  }

  if (byteOffset === undefined && length === undefined) {
    array = new Uint8Array(array)
  } else if (length === undefined) {
    array = new Uint8Array(array, byteOffset)
  } else {
    array = new Uint8Array(array, byteOffset, length)
  }

  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = array
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    that = fromArrayLike(that, array)
  }
  return that
}

function fromObject (that, obj) {
  if (Buffer.isBuffer(obj)) {
    var len = checked(obj.length) | 0
    that = createBuffer(that, len)

    if (that.length === 0) {
      return that
    }

    obj.copy(that, 0, 0, len)
    return that
  }

  if (obj) {
    if ((typeof ArrayBuffer !== 'undefined' &&
        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
      if (typeof obj.length !== 'number' || isnan(obj.length)) {
        return createBuffer(that, 0)
      }
      return fromArrayLike(that, obj)
    }

    if (obj.type === 'Buffer' && isArray(obj.data)) {
      return fromArrayLike(that, obj.data)
    }
  }

  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
}

function checked (length) {
  // Note: cannot use `length < kMaxLength()` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= kMaxLength()) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
  }
  return length | 0
}

function SlowBuffer (length) {
  if (+length != length) { // eslint-disable-line eqeqeq
    length = 0
  }
  return Buffer.alloc(+length)
}

Buffer.isBuffer = function isBuffer (b) {
  return !!(b != null && b._isBuffer)
}

Buffer.compare = function compare (a, b) {
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError('Arguments must be Buffers')
  }

  if (a === b) return 0

  var x = a.length
  var y = b.length

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i]
      y = b[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

Buffer.isEncoding = function isEncoding (encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true
    default:
      return false
  }
}

Buffer.concat = function concat (list, length) {
  if (!isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers')
  }

  if (list.length === 0) {
    return Buffer.alloc(0)
  }

  var i
  if (length === undefined) {
    length = 0
    for (i = 0; i < list.length; ++i) {
      length += list[i].length
    }
  }

  var buffer = Buffer.allocUnsafe(length)
  var pos = 0
  for (i = 0; i < list.length; ++i) {
    var buf = list[i]
    if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers')
    }
    buf.copy(buffer, pos)
    pos += buf.length
  }
  return buffer
}

function byteLength (string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length
  }
  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
    return string.byteLength
  }
  if (typeof string !== 'string') {
    string = '' + string
  }

  var len = string.length
  if (len === 0) return 0

  // Use a for loop to avoid recursion
  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len
      case 'utf8':
      case 'utf-8':
      case undefined:
        return utf8ToBytes(string).length
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2
      case 'hex':
        return len >>> 1
      case 'base64':
        return base64ToBytes(string).length
      default:
        if (loweredCase) return utf8ToBytes(string).length // assume utf8
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}
Buffer.byteLength = byteLength

function slowToString (encoding, start, end) {
  var loweredCase = false

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return ''
  }

  if (end === undefined || end > this.length) {
    end = this.length
  }

  if (end <= 0) {
    return ''
  }

  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0
  start >>>= 0

  if (end <= start) {
    return ''
  }

  if (!encoding) encoding = 'utf8'

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end)

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end)

      case 'ascii':
        return asciiSlice(this, start, end)

      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end)

      case 'base64':
        return base64Slice(this, start, end)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = (encoding + '').toLowerCase()
        loweredCase = true
    }
  }
}

// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
// Buffer instances.
Buffer.prototype._isBuffer = true

function swap (b, n, m) {
  var i = b[n]
  b[n] = b[m]
  b[m] = i
}

Buffer.prototype.swap16 = function swap16 () {
  var len = this.length
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits')
  }
  for (var i = 0; i < len; i += 2) {
    swap(this, i, i + 1)
  }
  return this
}

Buffer.prototype.swap32 = function swap32 () {
  var len = this.length
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits')
  }
  for (var i = 0; i < len; i += 4) {
    swap(this, i, i + 3)
    swap(this, i + 1, i + 2)
  }
  return this
}

Buffer.prototype.swap64 = function swap64 () {
  var len = this.length
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits')
  }
  for (var i = 0; i < len; i += 8) {
    swap(this, i, i + 7)
    swap(this, i + 1, i + 6)
    swap(this, i + 2, i + 5)
    swap(this, i + 3, i + 4)
  }
  return this
}

Buffer.prototype.toString = function toString () {
  var length = this.length | 0
  if (length === 0) return ''
  if (arguments.length === 0) return utf8Slice(this, 0, length)
  return slowToString.apply(this, arguments)
}

Buffer.prototype.equals = function equals (b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
  if (this === b) return true
  return Buffer.compare(this, b) === 0
}

Buffer.prototype.inspect = function inspect () {
  var str = ''
  var max = exports.INSPECT_MAX_BYTES
  if (this.length > 0) {
    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
    if (this.length > max) str += ' ... '
  }
  return '<Buffer ' + str + '>'
}

Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
  if (!Buffer.isBuffer(target)) {
    throw new TypeError('Argument must be a Buffer')
  }

  if (start === undefined) {
    start = 0
  }
  if (end === undefined) {
    end = target ? target.length : 0
  }
  if (thisStart === undefined) {
    thisStart = 0
  }
  if (thisEnd === undefined) {
    thisEnd = this.length
  }

  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index')
  }

  if (thisStart >= thisEnd && start >= end) {
    return 0
  }
  if (thisStart >= thisEnd) {
    return -1
  }
  if (start >= end) {
    return 1
  }

  start >>>= 0
  end >>>= 0
  thisStart >>>= 0
  thisEnd >>>= 0

  if (this === target) return 0

  var x = thisEnd - thisStart
  var y = end - start
  var len = Math.min(x, y)

  var thisCopy = this.slice(thisStart, thisEnd)
  var targetCopy = target.slice(start, end)

  for (var i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i]
      y = targetCopy[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset
    byteOffset = 0
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000
  }
  byteOffset = +byteOffset  // Coerce to Number.
  if (isNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : (buffer.length - 1)
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
  if (byteOffset >= buffer.length) {
    if (dir) return -1
    else byteOffset = buffer.length - 1
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0
    else return -1
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding)
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
  } else if (typeof val === 'number') {
    val = val & 0xFF // Search for a byte value [0-255]
    if (Buffer.TYPED_ARRAY_SUPPORT &&
        typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
      }
    }
    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
  }

  throw new TypeError('val must be string, number or Buffer')
}

function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
  var indexSize = 1
  var arrLength = arr.length
  var valLength = val.length

  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase()
    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
        encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1
      }
      indexSize = 2
      arrLength /= 2
      valLength /= 2
      byteOffset /= 2
    }
  }

  function read (buf, i) {
    if (indexSize === 1) {
      return buf[i]
    } else {
      return buf.readUInt16BE(i * indexSize)
    }
  }

  var i
  if (dir) {
    var foundIndex = -1
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
      } else {
        if (foundIndex !== -1) i -= i - foundIndex
        foundIndex = -1
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
    for (i = byteOffset; i >= 0; i--) {
      var found = true
      for (var j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false
          break
        }
      }
      if (found) return i
    }
  }

  return -1
}

Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1
}

Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
}

Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
}

function hexWrite (buf, string, offset, length) {
  offset = Number(offset) || 0
  var remaining = buf.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }

  // must be an even number of digits
  var strLen = string.length
  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')

  if (length > strLen / 2) {
    length = strLen / 2
  }
  for (var i = 0; i < length; ++i) {
    var parsed = parseInt(string.substr(i * 2, 2), 16)
    if (isNaN(parsed)) return i
    buf[offset + i] = parsed
  }
  return i
}

function utf8Write (buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
}

function asciiWrite (buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length)
}

function latin1Write (buf, string, offset, length) {
  return asciiWrite(buf, string, offset, length)
}

function base64Write (buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length)
}

function ucs2Write (buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
}

Buffer.prototype.write = function write (string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8'
    length = this.length
    offset = 0
  // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset
    length = this.length
    offset = 0
  // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset | 0
    if (isFinite(length)) {
      length = length | 0
      if (encoding === undefined) encoding = 'utf8'
    } else {
      encoding = length
      length = undefined
    }
  // legacy write(string, encoding, offset, length) - remove in v0.13
  } else {
    throw new Error(
      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
    )
  }

  var remaining = this.length - offset
  if (length === undefined || length > remaining) length = remaining

  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds')
  }

  if (!encoding) encoding = 'utf8'

  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length)

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length)

      case 'ascii':
        return asciiWrite(this, string, offset, length)

      case 'latin1':
      case 'binary':
        return latin1Write(this, string, offset, length)

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}

Buffer.prototype.toJSON = function toJSON () {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  }
}

function base64Slice (buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf)
  } else {
    return base64.fromByteArray(buf.slice(start, end))
  }
}

function utf8Slice (buf, start, end) {
  end = Math.min(buf.length, end)
  var res = []

  var i = start
  while (i < end) {
    var firstByte = buf[i]
    var codePoint = null
    var bytesPerSequence = (firstByte > 0xEF) ? 4
      : (firstByte > 0xDF) ? 3
      : (firstByte > 0xBF) ? 2
      : 1

    if (i + bytesPerSequence <= end) {
      var secondByte, thirdByte, fourthByte, tempCodePoint

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte
          }
          break
        case 2:
          secondByte = buf[i + 1]
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint
            }
          }
          break
        case 3:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint
            }
          }
          break
        case 4:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          fourthByte = buf[i + 3]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD
      bytesPerSequence = 1
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000
      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
      codePoint = 0xDC00 | codePoint & 0x3FF
    }

    res.push(codePoint)
    i += bytesPerSequence
  }

  return decodeCodePointsArray(res)
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000

function decodeCodePointsArray (codePoints) {
  var len = codePoints.length
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  var res = ''
  var i = 0
  while (i < len) {
    res += String.fromCharCode.apply(
      String,
      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
    )
  }
  return res
}

function asciiSlice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F)
  }
  return ret
}

function latin1Slice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i])
  }
  return ret
}

function hexSlice (buf, start, end) {
  var len = buf.length

  if (!start || start < 0) start = 0
  if (!end || end < 0 || end > len) end = len

  var out = ''
  for (var i = start; i < end; ++i) {
    out += toHex(buf[i])
  }
  return out
}

function utf16leSlice (buf, start, end) {
  var bytes = buf.slice(start, end)
  var res = ''
  for (var i = 0; i < bytes.length; i += 2) {
    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
  }
  return res
}

Buffer.prototype.slice = function slice (start, end) {
  var len = this.length
  start = ~~start
  end = end === undefined ? len : ~~end

  if (start < 0) {
    start += len
    if (start < 0) start = 0
  } else if (start > len) {
    start = len
  }

  if (end < 0) {
    end += len
    if (end < 0) end = 0
  } else if (end > len) {
    end = len
  }

  if (end < start) end = start

  var newBuf
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    newBuf = this.subarray(start, end)
    newBuf.__proto__ = Buffer.prototype
  } else {
    var sliceLen = end - start
    newBuf = new Buffer(sliceLen, undefined)
    for (var i = 0; i < sliceLen; ++i) {
      newBuf[i] = this[i + start]
    }
  }

  return newBuf
}

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset (offset, ext, length) {
  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
}

Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }

  return val
}

Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length)
  }

  var val = this[offset + --byteLength]
  var mul = 1
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul
  }

  return val
}

Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  return this[offset]
}

Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return this[offset] | (this[offset + 1] << 8)
}

Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return (this[offset] << 8) | this[offset + 1]
}

Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return ((this[offset]) |
      (this[offset + 1] << 8) |
      (this[offset + 2] << 16)) +
      (this[offset + 3] * 0x1000000)
}

Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] * 0x1000000) +
    ((this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    this[offset + 3])
}

Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var i = byteLength
  var mul = 1
  var val = this[offset + --i]
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  if (!(this[offset] & 0x80)) return (this[offset])
  return ((0xff - this[offset] + 1) * -1)
}

Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset] | (this[offset + 1] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset + 1] | (this[offset] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset]) |
    (this[offset + 1] << 8) |
    (this[offset + 2] << 16) |
    (this[offset + 3] << 24)
}

Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] << 24) |
    (this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    (this[offset + 3])
}

Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, true, 23, 4)
}

Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, false, 23, 4)
}

Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, true, 52, 8)
}

Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, false, 52, 8)
}

function checkInt (buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
}

Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var mul = 1
  var i = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var i = byteLength - 1
  var mul = 1
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  this[offset] = (value & 0xff)
  return offset + 1
}

function objectWriteUInt16 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
      (littleEndian ? i : 1 - i) * 8
  }
}

Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

function objectWriteUInt32 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffffffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
  }
}

Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset + 3] = (value >>> 24)
    this[offset + 2] = (value >>> 16)
    this[offset + 1] = (value >>> 8)
    this[offset] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = 0
  var mul = 1
  var sub = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = byteLength - 1
  var mul = 1
  var sub = 0
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  if (value < 0) value = 0xff + value + 1
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
    this[offset + 2] = (value >>> 16)
    this[offset + 3] = (value >>> 24)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (value < 0) value = 0xffffffff + value + 1
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

function checkIEEE754 (buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
  if (offset < 0) throw new RangeError('Index out of range')
}

function writeFloat (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4)
  return offset + 4
}

Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert)
}

Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert)
}

function writeDouble (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8)
  return offset + 8
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert)
}

Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert)
}

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy (target, targetStart, start, end) {
  if (!start) start = 0
  if (!end && end !== 0) end = this.length
  if (targetStart >= target.length) targetStart = target.length
  if (!targetStart) targetStart = 0
  if (end > 0 && end < start) end = start

  // Copy 0 bytes; we're done
  if (end === start) return 0
  if (target.length === 0 || this.length === 0) return 0

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds')
  }
  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
  if (end < 0) throw new RangeError('sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length) end = this.length
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start
  }

  var len = end - start
  var i

  if (this === target && start < targetStart && targetStart < end) {
    // descending copy from end
    for (i = len - 1; i >= 0; --i) {
      target[i + targetStart] = this[i + start]
    }
  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
    // ascending copy from start
    for (i = 0; i < len; ++i) {
      target[i + targetStart] = this[i + start]
    }
  } else {
    Uint8Array.prototype.set.call(
      target,
      this.subarray(start, start + len),
      targetStart
    )
  }

  return len
}

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill (val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start
      start = 0
      end = this.length
    } else if (typeof end === 'string') {
      encoding = end
      end = this.length
    }
    if (val.length === 1) {
      var code = val.charCodeAt(0)
      if (code < 256) {
        val = code
      }
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string')
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding)
    }
  } else if (typeof val === 'number') {
    val = val & 255
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index')
  }

  if (end <= start) {
    return this
  }

  start = start >>> 0
  end = end === undefined ? this.length : end >>> 0

  if (!val) val = 0

  var i
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val
    }
  } else {
    var bytes = Buffer.isBuffer(val)
      ? val
      : utf8ToBytes(new Buffer(val, encoding).toString())
    var len = bytes.length
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len]
    }
  }

  return this
}

// HELPER FUNCTIONS
// ================

var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g

function base64clean (str) {
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return ''
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '='
  }
  return str
}

function stringtrim (str) {
  if (str.trim) return str.trim()
  return str.replace(/^\s+|\s+$/g, '')
}

function toHex (n) {
  if (n < 16) return '0' + n.toString(16)
  return n.toString(16)
}

function utf8ToBytes (string, units) {
  units = units || Infinity
  var codePoint
  var length = string.length
  var leadSurrogate = null
  var bytes = []

  for (var i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i)

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        }

        // valid lead
        leadSurrogate = codePoint

        continue
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
        leadSurrogate = codePoint
        continue
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
    }

    leadSurrogate = null

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break
      bytes.push(codePoint)
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break
      bytes.push(
        codePoint >> 0x6 | 0xC0,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break
      bytes.push(
        codePoint >> 0xC | 0xE0,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break
      bytes.push(
        codePoint >> 0x12 | 0xF0,
        codePoint >> 0xC & 0x3F | 0x80,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else {
      throw new Error('Invalid code point')
    }
  }

  return bytes
}

function asciiToBytes (str) {
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF)
  }
  return byteArray
}

function utf16leToBytes (str, units) {
  var c, hi, lo
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break

    c = str.charCodeAt(i)
    hi = c >> 8
    lo = c % 256
    byteArray.push(lo)
    byteArray.push(hi)
  }

  return byteArray
}

function base64ToBytes (str) {
  return base64.toByteArray(base64clean(str))
}

function blitBuffer (src, dst, offset, length) {
  for (var i = 0; i < length; ++i) {
    if ((i + offset >= dst.length) || (i >= src.length)) break
    dst[i + offset] = src[i]
  }
  return i
}

function isnan (val) {
  return val !== val // eslint-disable-line no-self-compare
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(26)))

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototypal inheritance, this class
// prototypally inherits from Readable, and then parasitically from
// Writable.



/*<replacement>*/

var pna = __webpack_require__(288);
/*</replacement>*/

/*<replacement>*/
var objectKeys = Object.keys || function (obj) {
  var keys = [];
  for (var key in obj) {
    keys.push(key);
  }return keys;
};
/*</replacement>*/

module.exports = Duplex;

/*<replacement>*/
var util = __webpack_require__(208);
util.inherits = __webpack_require__(118);
/*</replacement>*/

var Readable = __webpack_require__(746);
var Writable = __webpack_require__(427);

util.inherits(Duplex, Readable);

{
  // avoid scope creep, the keys array can then be collected
  var keys = objectKeys(Writable.prototype);
  for (var v = 0; v < keys.length; v++) {
    var method = keys[v];
    if (!Duplex.prototype[method]) Duplex.prototype[method] = Writable.prototype[method];
  }
}

function Duplex(options) {
  if (!(this instanceof Duplex)) return new Duplex(options);

  Readable.call(this, options);
  Writable.call(this, options);

  if (options && options.readable === false) this.readable = false;

  if (options && options.writable === false) this.writable = false;

  this.allowHalfOpen = true;
  if (options && options.allowHalfOpen === false) this.allowHalfOpen = false;

  this.once('end', onend);
}

Object.defineProperty(Duplex.prototype, 'writableHighWaterMark', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function () {
    return this._writableState.highWaterMark;
  }
});

// the no-half-open enforcer
function onend() {
  // if we allow half-open state, or if the writable side ended,
  // then we're ok.
  if (this.allowHalfOpen || this._writableState.ended) return;

  // no more data can be written.
  // But allow more writes to happen in this tick.
  pna.nextTick(onEndNT, this);
}

function onEndNT(self) {
  self.end();
}

Object.defineProperty(Duplex.prototype, 'destroyed', {
  get: function () {
    if (this._readableState === undefined || this._writableState === undefined) {
      return false;
    }
    return this._readableState.destroyed && this._writableState.destroyed;
  },
  set: function (value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (this._readableState === undefined || this._writableState === undefined) {
      return;
    }

    // backward compatibility, the user is explicitly
    // managing destroyed
    this._readableState.destroyed = value;
    this._writableState.destroyed = value;
  }
});

Duplex.prototype._destroy = function (err, cb) {
  this.push(null);
  this.end();

  pna.nextTick(cb, err);
};

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Checks whether given value's type is one of a few Error or Error-like
 * {@link isError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isError(wat) {
    switch (Object.prototype.toString.call(wat)) {
        case '[object Error]':
            return true;
        case '[object Exception]':
            return true;
        case '[object DOMException]':
            return true;
        default:
            return wat instanceof Error;
    }
}
exports.isError = isError;
/**
 * Checks whether given value's type is ErrorEvent
 * {@link isErrorEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isErrorEvent(wat) {
    return Object.prototype.toString.call(wat) === '[object ErrorEvent]';
}
exports.isErrorEvent = isErrorEvent;
/**
 * Checks whether given value's type is DOMError
 * {@link isDOMError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isDOMError(wat) {
    return Object.prototype.toString.call(wat) === '[object DOMError]';
}
exports.isDOMError = isDOMError;
/**
 * Checks whether given value's type is DOMException
 * {@link isDOMException}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isDOMException(wat) {
    return Object.prototype.toString.call(wat) === '[object DOMException]';
}
exports.isDOMException = isDOMException;
/**
 * Checks whether given value's type is an undefined
 * {@link isUndefined}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isUndefined(wat) {
    return wat === void 0;
}
exports.isUndefined = isUndefined;
/**
 * Checks whether given value's type is a function
 * {@link isFunction}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isFunction(wat) {
    return typeof wat === 'function';
}
exports.isFunction = isFunction;
/**
 * Checks whether given value's type is a string
 * {@link isString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isString(wat) {
    return Object.prototype.toString.call(wat) === '[object String]';
}
exports.isString = isString;
/**
 * Checks whether given value's is a primitive (undefined, null, number, boolean, string)
 * {@link isPrimitive}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isPrimitive(wat) {
    return wat === null || (typeof wat !== 'object' && typeof wat !== 'function');
}
exports.isPrimitive = isPrimitive;
/**
 * Checks whether given value's type is an array
 * {@link isArray}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isArray(wat) {
    return Object.prototype.toString.call(wat) === '[object Array]';
}
exports.isArray = isArray;
/**
 * Checks whether given value's type is an object literal
 * {@link isPlainObject}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isPlainObject(wat) {
    return Object.prototype.toString.call(wat) === '[object Object]';
}
exports.isPlainObject = isPlainObject;
/**
 * Checks whether given value's type is an regexp
 * {@link isRegExp}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isRegExp(wat) {
    return Object.prototype.toString.call(wat) === '[object RegExp]';
}
exports.isRegExp = isRegExp;
/**
 * Checks whether given value's type is a NaN
 * {@link isNaN}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isNaN(wat) {
    return wat !== wat;
}
exports.isNaN = isNaN;
//# sourceMappingURL=is.js.map

/***/ }),
/* 126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BrowserRouter__ = __webpack_require__(771);
/* unused harmony reexport BrowserRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__HashRouter__ = __webpack_require__(774);
/* unused harmony reexport HashRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Link__ = __webpack_require__(444);
/* unused harmony reexport Link */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MemoryRouter__ = __webpack_require__(776);
/* unused harmony reexport MemoryRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__NavLink__ = __webpack_require__(777);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_4__NavLink__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Prompt__ = __webpack_require__(779);
/* unused harmony reexport Prompt */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Redirect__ = __webpack_require__(780);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_6__Redirect__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Route__ = __webpack_require__(446);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_7__Route__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Router__ = __webpack_require__(298);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_8__Router__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__StaticRouter__ = __webpack_require__(781);
/* unused harmony reexport StaticRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Switch__ = __webpack_require__(782);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_10__Switch__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__matchPath__ = __webpack_require__(783);
/* unused harmony reexport matchPath */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__withRouter__ = __webpack_require__(784);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_12__withRouter__["a"]; });



























/***/ }),
/* 127 */
/***/ (function(module, exports) {

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

module.exports = _assertThisInitialized;

/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = function() {};

if (false) {
  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
        '`warning(condition, format, ...args)` requires a warning ' +
        'message argument'
      );
    }

    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
      throw new Error(
        'The warning format should be able to uniquely identify this ' +
        'warning. Please, use a more descriptive format than: ' + format
      );
    }

    if (!condition) {
      var argIndex = 0;
      var message = 'Warning: ' +
        format.replace(/%s/g, function() {
          return args[argIndex++];
        });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch(x) {}
    }
  };
}

module.exports = warning;


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _warning = __webpack_require__(128);

var _warning2 = _interopRequireDefault(_warning);

var _toCss = __webpack_require__(300);

var _toCss2 = _interopRequireDefault(_toCss);

var _toCssValue = __webpack_require__(213);

var _toCssValue2 = _interopRequireDefault(_toCssValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var StyleRule = function () {
  function StyleRule(key, style, options) {
    _classCallCheck(this, StyleRule);

    this.type = 'style';
    this.isProcessed = false;
    var sheet = options.sheet,
        Renderer = options.Renderer,
        selector = options.selector;

    this.key = key;
    this.options = options;
    this.style = style;
    if (selector) this.selectorText = selector;
    this.renderer = sheet ? sheet.renderer : new Renderer();
  }

  /**
   * Set selector string.
   * Attention: use this with caution. Most browsers didn't implement
   * selectorText setter, so this may result in rerendering of entire Style Sheet.
   */


  _createClass(StyleRule, [{
    key: 'prop',


    /**
     * Get or set a style property.
     */
    value: function prop(name, value) {
      // It's a getter.
      if (value === undefined) return this.style[name];

      // Don't do anything if the value has not changed.
      if (this.style[name] === value) return this;

      value = this.options.jss.plugins.onChangeValue(value, name, this);

      var isEmpty = value == null || value === false;
      var isDefined = name in this.style;

      // Value is empty and wasn't defined before.
      if (isEmpty && !isDefined) return this;

      // We are going to remove this value.
      var remove = isEmpty && isDefined;

      if (remove) delete this.style[name];else this.style[name] = value;

      // Renderable is defined if StyleSheet option `link` is true.
      if (this.renderable) {
        if (remove) this.renderer.removeProperty(this.renderable, name);else this.renderer.setProperty(this.renderable, name, value);
        return this;
      }

      var sheet = this.options.sheet;

      if (sheet && sheet.attached) {
        (0, _warning2['default'])(false, 'Rule is not linked. Missing sheet option "link: true".');
      }
      return this;
    }

    /**
     * Apply rule to an element inline.
     */

  }, {
    key: 'applyTo',
    value: function applyTo(renderable) {
      var json = this.toJSON();
      for (var prop in json) {
        this.renderer.setProperty(renderable, prop, json[prop]);
      }return this;
    }

    /**
     * Returns JSON representation of the rule.
     * Fallbacks are not supported.
     * Useful for inline styles.
     */

  }, {
    key: 'toJSON',
    value: function toJSON() {
      var json = {};
      for (var prop in this.style) {
        var value = this.style[prop];
        if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) !== 'object') json[prop] = value;else if (Array.isArray(value)) json[prop] = (0, _toCssValue2['default'])(value);
      }
      return json;
    }

    /**
     * Generates a CSS string.
     */

  }, {
    key: 'toString',
    value: function toString(options) {
      var sheet = this.options.sheet;

      var link = sheet ? sheet.options.link : false;
      var opts = link ? _extends({}, options, { allowEmpty: true }) : options;
      return (0, _toCss2['default'])(this.selector, this.style, opts);
    }
  }, {
    key: 'selector',
    set: function set(selector) {
      if (selector === this.selectorText) return;

      this.selectorText = selector;

      if (!this.renderable) return;

      var hasChanged = this.renderer.setSelector(this.renderable, selector);

      // If selector setter is not implemented, rerender the rule.
      if (!hasChanged && this.renderable) {
        var renderable = this.renderer.replaceRule(this.renderable, this);
        if (renderable) this.renderable = renderable;
      }
    }

    /**
     * Get selector string.
     */
    ,
    get: function get() {
      return this.selectorText;
    }
  }]);

  return StyleRule;
}();

exports['default'] = StyleRule;

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _AppBar.default;
  }
});

var _AppBar = _interopRequireDefault(__webpack_require__(851));

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = exports.EXITING = exports.ENTERED = exports.ENTERING = exports.EXITED = exports.UNMOUNTED = void 0;

var PropTypes = _interopRequireWildcard(__webpack_require__(3));

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactDom = _interopRequireDefault(__webpack_require__(45));

var _reactLifecyclesCompat = __webpack_require__(104);

var _PropTypes = __webpack_require__(856);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var UNMOUNTED = 'unmounted';
exports.UNMOUNTED = UNMOUNTED;
var EXITED = 'exited';
exports.EXITED = EXITED;
var ENTERING = 'entering';
exports.ENTERING = ENTERING;
var ENTERED = 'entered';
exports.ENTERED = ENTERED;
var EXITING = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the components.
 * It's up to you to give meaning and effect to those states. For example we can
 * add styles to a component when it enters or exits:
 *
 * ```jsx
 * import Transition from 'react-transition-group/Transition';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 0 },
 *   entered:  { opacity: 1 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {(state) => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * As noted the `Transition` component doesn't _do_ anything by itself to its child component.
 * What it does do is track transition states over time so you can update the
 * component (such as by adding styles or classes) when it changes states.
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component begins the
 * "Enter" stage. During this stage, the component will shift from its current transition state,
 * to `'entering'` for the duration of the transition and then to the `'entered'` stage once
 * it's complete. Let's take the following example:
 *
 * ```jsx
 * state = { in: false };
 *
 * toggleEnterState = () => {
 *   this.setState({ in: true });
 * }
 *
 * render() {
 *   return (
 *     <div>
 *       <Transition in={this.state.in} timeout={500} />
 *       <button onClick={this.toggleEnterState}>Click to Enter</button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state and
 * stay there for 500ms (the value of `timeout`) before it finally switches to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from `'exiting'` to `'exited'`.
 *
 * ## Timing
 *
 * Timing is often the trickiest part of animation, mistakes can result in slight delays
 * that are hard to pin down. A common example is when you want to add an exit transition,
 * you should set the desired final styles when the state is `'exiting'`. That's when the
 * transition to those styles will start and, if you matched the `timeout` prop with the
 * CSS Transition duration, it will end exactly when the state changes to `'exited'`.
 *
 * > **Note**: For simpler transitions the `Transition` component might be enough, but
 * > take into account that it's platform-agnostic, while the `CSSTransition` component
 * > [forces reflows](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
 * > in order to make more complex transitions more predictable. For example, even though
 * > classes `example-enter` and `example-enter-active` are applied immediately one after
 * > another, you can still transition from one to the other because of the forced reflow
 * > (read [this issue](https://github.com/reactjs/react-transition-group/issues/159#issuecomment-322761171)
 * > for more info). Take this into account when choosing between `Transition` and
 * > `CSSTransition`.
 */

exports.EXITING = EXITING;

var Transition =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Transition, _React$Component);

  function Transition(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    var parentGroup = context.transitionGroup; // In the context of a TransitionGroup all enters are really appears

    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
    var initialStatus;
    _this.appearStatus = null;

    if (props.in) {
      if (appear) {
        initialStatus = EXITED;
        _this.appearStatus = ENTERING;
      } else {
        initialStatus = ENTERED;
      }
    } else {
      if (props.unmountOnExit || props.mountOnEnter) {
        initialStatus = UNMOUNTED;
      } else {
        initialStatus = EXITED;
      }
    }

    _this.state = {
      status: initialStatus
    };
    _this.nextCallback = null;
    return _this;
  }

  var _proto = Transition.prototype;

  _proto.getChildContext = function getChildContext() {
    return {
      transitionGroup: null // allows for nested Transitions

    };
  };

  Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
    var nextIn = _ref.in;

    if (nextIn && prevState.status === UNMOUNTED) {
      return {
        status: EXITED
      };
    }

    return null;
  }; // getSnapshotBeforeUpdate(prevProps) {
  //   let nextStatus = null
  //   if (prevProps !== this.props) {
  //     const { status } = this.state
  //     if (this.props.in) {
  //       if (status !== ENTERING && status !== ENTERED) {
  //         nextStatus = ENTERING
  //       }
  //     } else {
  //       if (status === ENTERING || status === ENTERED) {
  //         nextStatus = EXITING
  //       }
  //     }
  //   }
  //   return { nextStatus }
  // }


  _proto.componentDidMount = function componentDidMount() {
    this.updateStatus(true, this.appearStatus);
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var nextStatus = null;

    if (prevProps !== this.props) {
      var status = this.state.status;

      if (this.props.in) {
        if (status !== ENTERING && status !== ENTERED) {
          nextStatus = ENTERING;
        }
      } else {
        if (status === ENTERING || status === ENTERED) {
          nextStatus = EXITING;
        }
      }
    }

    this.updateStatus(false, nextStatus);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.cancelNextCallback();
  };

  _proto.getTimeouts = function getTimeouts() {
    var timeout = this.props.timeout;
    var exit, enter, appear;
    exit = enter = appear = timeout;

    if (timeout != null && typeof timeout !== 'number') {
      exit = timeout.exit;
      enter = timeout.enter;
      appear = timeout.appear;
    }

    return {
      exit: exit,
      enter: enter,
      appear: appear
    };
  };

  _proto.updateStatus = function updateStatus(mounting, nextStatus) {
    if (mounting === void 0) {
      mounting = false;
    }

    if (nextStatus !== null) {
      // nextStatus will always be ENTERING or EXITING.
      this.cancelNextCallback();

      var node = _reactDom.default.findDOMNode(this);

      if (nextStatus === ENTERING) {
        this.performEnter(node, mounting);
      } else {
        this.performExit(node);
      }
    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
      this.setState({
        status: UNMOUNTED
      });
    }
  };

  _proto.performEnter = function performEnter(node, mounting) {
    var _this2 = this;

    var enter = this.props.enter;
    var appearing = this.context.transitionGroup ? this.context.transitionGroup.isMounting : mounting;
    var timeouts = this.getTimeouts(); // no enter animation skip right to ENTERED
    // if we are mounting and running this it means appear _must_ be set

    if (!mounting && !enter) {
      this.safeSetState({
        status: ENTERED
      }, function () {
        _this2.props.onEntered(node);
      });
      return;
    }

    this.props.onEnter(node, appearing);
    this.safeSetState({
      status: ENTERING
    }, function () {
      _this2.props.onEntering(node, appearing); // FIXME: appear timeout?


      _this2.onTransitionEnd(node, timeouts.enter, function () {
        _this2.safeSetState({
          status: ENTERED
        }, function () {
          _this2.props.onEntered(node, appearing);
        });
      });
    });
  };

  _proto.performExit = function performExit(node) {
    var _this3 = this;

    var exit = this.props.exit;
    var timeouts = this.getTimeouts(); // no exit animation skip right to EXITED

    if (!exit) {
      this.safeSetState({
        status: EXITED
      }, function () {
        _this3.props.onExited(node);
      });
      return;
    }

    this.props.onExit(node);
    this.safeSetState({
      status: EXITING
    }, function () {
      _this3.props.onExiting(node);

      _this3.onTransitionEnd(node, timeouts.exit, function () {
        _this3.safeSetState({
          status: EXITED
        }, function () {
          _this3.props.onExited(node);
        });
      });
    });
  };

  _proto.cancelNextCallback = function cancelNextCallback() {
    if (this.nextCallback !== null) {
      this.nextCallback.cancel();
      this.nextCallback = null;
    }
  };

  _proto.safeSetState = function safeSetState(nextState, callback) {
    // This shouldn't be necessary, but there are weird race conditions with
    // setState callbacks and unmounting in testing, so always make sure that
    // we can cancel any pending setState callbacks after we unmount.
    callback = this.setNextCallback(callback);
    this.setState(nextState, callback);
  };

  _proto.setNextCallback = function setNextCallback(callback) {
    var _this4 = this;

    var active = true;

    this.nextCallback = function (event) {
      if (active) {
        active = false;
        _this4.nextCallback = null;
        callback(event);
      }
    };

    this.nextCallback.cancel = function () {
      active = false;
    };

    return this.nextCallback;
  };

  _proto.onTransitionEnd = function onTransitionEnd(node, timeout, handler) {
    this.setNextCallback(handler);

    if (node) {
      if (this.props.addEndListener) {
        this.props.addEndListener(node, this.nextCallback);
      }

      if (timeout != null) {
        setTimeout(this.nextCallback, timeout);
      }
    } else {
      setTimeout(this.nextCallback, 0);
    }
  };

  _proto.render = function render() {
    var status = this.state.status;

    if (status === UNMOUNTED) {
      return null;
    }

    var _this$props = this.props,
        children = _this$props.children,
        childProps = _objectWithoutPropertiesLoose(_this$props, ["children"]); // filter props for Transtition


    delete childProps.in;
    delete childProps.mountOnEnter;
    delete childProps.unmountOnExit;
    delete childProps.appear;
    delete childProps.enter;
    delete childProps.exit;
    delete childProps.timeout;
    delete childProps.addEndListener;
    delete childProps.onEnter;
    delete childProps.onEntering;
    delete childProps.onEntered;
    delete childProps.onExit;
    delete childProps.onExiting;
    delete childProps.onExited;

    if (typeof children === 'function') {
      return children(status, childProps);
    }

    var child = _react.default.Children.only(children);

    return _react.default.cloneElement(child, childProps);
  };

  return Transition;
}(_react.default.Component);

Transition.contextTypes = {
  transitionGroup: PropTypes.object
};
Transition.childContextTypes = {
  transitionGroup: function transitionGroup() {}
};
Transition.propTypes =  false ? {
  /**
   * A `function` child can be used instead of a React element.
   * This function is called with the current transition status
   * ('entering', 'entered', 'exiting', 'exited', 'unmounted'), which can be used
   * to apply context specific props to a component.
   *
   * ```jsx
   * <Transition timeout={150}>
   *   {(status) => (
   *     <MyComponent className={`fade fade-${status}`} />
   *   )}
   * </Transition>
   * ```
   */
  children: PropTypes.oneOfType([PropTypes.func.isRequired, PropTypes.element.isRequired]).isRequired,

  /**
   * Show the component; triggers the enter or exit states
   */
  in: PropTypes.bool,

  /**
   * By default the child component is mounted immediately along with
   * the parent `Transition` component. If you want to "lazy mount" the component on the
   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
   * mounted, even on "exited", unless you also specify `unmountOnExit`.
   */
  mountOnEnter: PropTypes.bool,

  /**
   * By default the child component stays mounted after it reaches the `'exited'` state.
   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
   */
  unmountOnExit: PropTypes.bool,

  /**
   * Normally a component is not transitioned if it is shown when the `<Transition>` component mounts.
   * If you want to transition on the first mount set `appear` to `true`, and the
   * component will transition in as soon as the `<Transition>` mounts.
   *
   * > Note: there are no specific "appear" states. `appear` only adds an additional `enter` transition.
   */
  appear: PropTypes.bool,

  /**
   * Enable or disable enter transitions.
   */
  enter: PropTypes.bool,

  /**
   * Enable or disable exit transitions.
   */
  exit: PropTypes.bool,

  /**
   * The duration of the transition, in milliseconds.
   * Required unless `addEndListener` is provided
   *
   * You may specify a single timeout for all transitions like: `timeout={500}`,
   * or individually like:
   *
   * ```jsx
   * timeout={{
   *  enter: 300,
   *  exit: 500,
   * }}
   * ```
   *
   * @type {number | { enter?: number, exit?: number }}
   */
  timeout: function timeout(props) {
    var pt = process.env.NODE_ENV !== "production" ? _PropTypes.timeoutsShape : {};;
    if (!props.addEndListener) pt = pt.isRequired;

    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return pt.apply(void 0, [props].concat(args));
  },

  /**
   * Add a custom transition end trigger. Called with the transitioning
   * DOM node and a `done` callback. Allows for more fine grained transition end
   * logic. **Note:** Timeouts are still used as a fallback if provided.
   *
   * ```jsx
   * addEndListener={(node, done) => {
   *   // use the css transitionend event to mark the finish of a transition
   *   node.addEventListener('transitionend', done, false);
   * }}
   * ```
   */
  addEndListener: PropTypes.func,

  /**
   * Callback fired before the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEnter: PropTypes.func,

  /**
   * Callback fired after the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,

  /**
   * Callback fired after the "entered" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEntered: PropTypes.func,

  /**
   * Callback fired before the "exiting" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExit: PropTypes.func,

  /**
   * Callback fired after the "exiting" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExiting: PropTypes.func,

  /**
   * Callback fired after the "exited" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExited: PropTypes.func // Name the function so it is clearer in the documentation

} : {};

function noop() {}

Transition.defaultProps = {
  in: false,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,
  enter: true,
  exit: true,
  onEnter: noop,
  onEntering: noop,
  onEntered: noop,
  onExit: noop,
  onExiting: noop,
  onExited: noop
};
Transition.UNMOUNTED = 0;
Transition.EXITED = 1;
Transition.ENTERING = 2;
Transition.ENTERED = 3;
Transition.EXITING = 4;

var _default = (0, _reactLifecyclesCompat.polyfill)(Transition);

exports.default = _default;

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTransitionProps = getTransitionProps;
exports.reflow = void 0;

var reflow = function reflow(node) {
  return node.scrollTop;
};

exports.reflow = reflow;

function getTransitionProps(props, options) {
  var timeout = props.timeout,
      _props$style = props.style,
      style = _props$style === void 0 ? {} : _props$style;
  return {
    duration: style.transitionDuration || typeof timeout === 'number' ? timeout : timeout[options.mode],
    delay: style.transitionDelay
  };
}

/***/ }),
/* 133 */
/***/ (function(module, exports) {

// Source: http://jsfiddle.net/vWx8V/
// http://stackoverflow.com/questions/5603195/full-list-of-javascript-keycodes

/**
 * Conenience method returns corresponding value for given keyName or keyCode.
 *
 * @param {Mixed} keyCode {Number} or keyName {String}
 * @return {Mixed}
 * @api public
 */

function keyCode(searchInput) {
  // Keyboard Events
  if (searchInput && 'object' === typeof searchInput) {
    var hasKeyCode = searchInput.which || searchInput.keyCode || searchInput.charCode
    if (hasKeyCode) searchInput = hasKeyCode
  }

  // Numbers
  if ('number' === typeof searchInput) return names[searchInput]

  // Everything else (cast to string)
  var search = String(searchInput)

  // check codes
  var foundNamedKey = codes[search.toLowerCase()]
  if (foundNamedKey) return foundNamedKey

  // check aliases
  var foundNamedKey = aliases[search.toLowerCase()]
  if (foundNamedKey) return foundNamedKey

  // weird character?
  if (search.length === 1) return search.charCodeAt(0)

  return undefined
}

/**
 * Compares a keyboard event with a given keyCode or keyName.
 *
 * @param {Event} event Keyboard event that should be tested
 * @param {Mixed} keyCode {Number} or keyName {String}
 * @return {Boolean}
 * @api public
 */
keyCode.isEventKey = function isEventKey(event, nameOrCode) {
  if (event && 'object' === typeof event) {
    var keyCode = event.which || event.keyCode || event.charCode
    if (keyCode === null || keyCode === undefined) { return false; }
    if (typeof nameOrCode === 'string') {
      // check codes
      var foundNamedKey = codes[nameOrCode.toLowerCase()]
      if (foundNamedKey) { return foundNamedKey === keyCode; }
    
      // check aliases
      var foundNamedKey = aliases[nameOrCode.toLowerCase()]
      if (foundNamedKey) { return foundNamedKey === keyCode; }
    } else if (typeof nameOrCode === 'number') {
      return nameOrCode === keyCode;
    }
    return false;
  }
}

exports = module.exports = keyCode;

/**
 * Get by name
 *
 *   exports.code['enter'] // => 13
 */

var codes = exports.code = exports.codes = {
  'backspace': 8,
  'tab': 9,
  'enter': 13,
  'shift': 16,
  'ctrl': 17,
  'alt': 18,
  'pause/break': 19,
  'caps lock': 20,
  'esc': 27,
  'space': 32,
  'page up': 33,
  'page down': 34,
  'end': 35,
  'home': 36,
  'left': 37,
  'up': 38,
  'right': 39,
  'down': 40,
  'insert': 45,
  'delete': 46,
  'command': 91,
  'left command': 91,
  'right command': 93,
  'numpad *': 106,
  'numpad +': 107,
  'numpad -': 109,
  'numpad .': 110,
  'numpad /': 111,
  'num lock': 144,
  'scroll lock': 145,
  'my computer': 182,
  'my calculator': 183,
  ';': 186,
  '=': 187,
  ',': 188,
  '-': 189,
  '.': 190,
  '/': 191,
  '`': 192,
  '[': 219,
  '\\': 220,
  ']': 221,
  "'": 222
}

// Helper aliases

var aliases = exports.aliases = {
  'windows': 91,
  '⇧': 16,
  '⌥': 18,
  '⌃': 17,
  '⌘': 91,
  'ctl': 17,
  'control': 17,
  'option': 18,
  'pause': 19,
  'break': 19,
  'caps': 20,
  'return': 13,
  'escape': 27,
  'spc': 32,
  'spacebar': 32,
  'pgup': 33,
  'pgdn': 34,
  'ins': 45,
  'del': 46,
  'cmd': 91
}

/*!
 * Programatically add the following
 */

// lower case chars
for (i = 97; i < 123; i++) codes[String.fromCharCode(i)] = i - 32

// numbers
for (var i = 48; i < 58; i++) codes[i - 48] = i

// function keys
for (i = 1; i < 13; i++) codes['f'+i] = i + 111

// numpad keys
for (i = 0; i < 10; i++) codes['numpad '+i] = i + 96

/**
 * Get by code
 *
 *   exports.name[13] // => 'Enter'
 */

var names = exports.names = exports.title = {} // title for backward compat

// Create reverse mapping
for (i in codes) names[codes[i]] = i

// Add aliases
for (var alias in aliases) {
  codes[alias] = aliases[alias]
}


/***/ }),
/* 134 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.6.2' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(136);
var createDesc = __webpack_require__(223);
module.exports = __webpack_require__(138) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(169);
var IE8_DOM_DEFINE = __webpack_require__(475);
var toPrimitive = __webpack_require__(311);
var dP = Object.defineProperty;

exports.f = __webpack_require__(138) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 137 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(222)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(899);
var defined = __webpack_require__(310);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(316)('wks');
var uid = __webpack_require__(224);
var Symbol = __webpack_require__(92).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _ListItemText.default;
  }
});

var _ListItemText = _interopRequireDefault(__webpack_require__(1017));

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _MobileStepper.default;
  }
});

var _MobileStepper = _interopRequireDefault(__webpack_require__(1024));

/***/ }),
/* 143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = print;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__visitor__ = __webpack_require__(522);
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Converts an AST into a string, using one set of reasonable
 * formatting rules.
 */
function print(ast) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__visitor__["b" /* visit */])(ast, { leave: printDocASTReducer });
}

var printDocASTReducer = {
  Name: function Name(node) {
    return node.value;
  },
  Variable: function Variable(node) {
    return '$' + node.name;
  },

  // Document

  Document: function Document(node) {
    return join(node.definitions, '\n\n') + '\n';
  },

  OperationDefinition: function OperationDefinition(node) {
    var op = node.operation;
    var name = node.name;
    var varDefs = wrap('(', join(node.variableDefinitions, ', '), ')');
    var directives = join(node.directives, ' ');
    var selectionSet = node.selectionSet;
    // Anonymous queries with no directives or variable definitions can use
    // the query short form.
    return !name && !directives && !varDefs && op === 'query' ? selectionSet : join([op, join([name, varDefs]), directives, selectionSet], ' ');
  },


  VariableDefinition: function VariableDefinition(_ref) {
    var variable = _ref.variable,
        type = _ref.type,
        defaultValue = _ref.defaultValue;
    return variable + ': ' + type + wrap(' = ', defaultValue);
  },

  SelectionSet: function SelectionSet(_ref2) {
    var selections = _ref2.selections;
    return block(selections);
  },

  Field: function Field(_ref3) {
    var alias = _ref3.alias,
        name = _ref3.name,
        args = _ref3.arguments,
        directives = _ref3.directives,
        selectionSet = _ref3.selectionSet;
    return join([wrap('', alias, ': ') + name + wrap('(', join(args, ', '), ')'), join(directives, ' '), selectionSet], ' ');
  },

  Argument: function Argument(_ref4) {
    var name = _ref4.name,
        value = _ref4.value;
    return name + ': ' + value;
  },

  // Fragments

  FragmentSpread: function FragmentSpread(_ref5) {
    var name = _ref5.name,
        directives = _ref5.directives;
    return '...' + name + wrap(' ', join(directives, ' '));
  },

  InlineFragment: function InlineFragment(_ref6) {
    var typeCondition = _ref6.typeCondition,
        directives = _ref6.directives,
        selectionSet = _ref6.selectionSet;
    return join(['...', wrap('on ', typeCondition), join(directives, ' '), selectionSet], ' ');
  },

  FragmentDefinition: function FragmentDefinition(_ref7) {
    var name = _ref7.name,
        typeCondition = _ref7.typeCondition,
        variableDefinitions = _ref7.variableDefinitions,
        directives = _ref7.directives,
        selectionSet = _ref7.selectionSet;
    return (
      // Note: fragment variable definitions are experimental and may be changed
      // or removed in the future.
      'fragment ' + name + wrap('(', join(variableDefinitions, ', '), ')') + ' ' + ('on ' + typeCondition + ' ' + wrap('', join(directives, ' '), ' ')) + selectionSet
    );
  },

  // Value

  IntValue: function IntValue(_ref8) {
    var value = _ref8.value;
    return value;
  },
  FloatValue: function FloatValue(_ref9) {
    var value = _ref9.value;
    return value;
  },
  StringValue: function StringValue(_ref10, key) {
    var value = _ref10.value,
        isBlockString = _ref10.block;
    return isBlockString ? printBlockString(value, key === 'description') : JSON.stringify(value);
  },
  BooleanValue: function BooleanValue(_ref11) {
    var value = _ref11.value;
    return value ? 'true' : 'false';
  },
  NullValue: function NullValue() {
    return 'null';
  },
  EnumValue: function EnumValue(_ref12) {
    var value = _ref12.value;
    return value;
  },
  ListValue: function ListValue(_ref13) {
    var values = _ref13.values;
    return '[' + join(values, ', ') + ']';
  },
  ObjectValue: function ObjectValue(_ref14) {
    var fields = _ref14.fields;
    return '{' + join(fields, ', ') + '}';
  },
  ObjectField: function ObjectField(_ref15) {
    var name = _ref15.name,
        value = _ref15.value;
    return name + ': ' + value;
  },

  // Directive

  Directive: function Directive(_ref16) {
    var name = _ref16.name,
        args = _ref16.arguments;
    return '@' + name + wrap('(', join(args, ', '), ')');
  },

  // Type

  NamedType: function NamedType(_ref17) {
    var name = _ref17.name;
    return name;
  },
  ListType: function ListType(_ref18) {
    var type = _ref18.type;
    return '[' + type + ']';
  },
  NonNullType: function NonNullType(_ref19) {
    var type = _ref19.type;
    return type + '!';
  },

  // Type System Definitions

  SchemaDefinition: function SchemaDefinition(_ref20) {
    var directives = _ref20.directives,
        operationTypes = _ref20.operationTypes;
    return join(['schema', join(directives, ' '), block(operationTypes)], ' ');
  },

  OperationTypeDefinition: function OperationTypeDefinition(_ref21) {
    var operation = _ref21.operation,
        type = _ref21.type;
    return operation + ': ' + type;
  },

  ScalarTypeDefinition: addDescription(function (_ref22) {
    var name = _ref22.name,
        directives = _ref22.directives;
    return join(['scalar', name, join(directives, ' ')], ' ');
  }),

  ObjectTypeDefinition: addDescription(function (_ref23) {
    var name = _ref23.name,
        interfaces = _ref23.interfaces,
        directives = _ref23.directives,
        fields = _ref23.fields;
    return join(['type', name, wrap('implements ', join(interfaces, ' & ')), join(directives, ' '), block(fields)], ' ');
  }),

  FieldDefinition: addDescription(function (_ref24) {
    var name = _ref24.name,
        args = _ref24.arguments,
        type = _ref24.type,
        directives = _ref24.directives;
    return name + wrap('(', join(args, ', '), ')') + ': ' + type + wrap(' ', join(directives, ' '));
  }),

  InputValueDefinition: addDescription(function (_ref25) {
    var name = _ref25.name,
        type = _ref25.type,
        defaultValue = _ref25.defaultValue,
        directives = _ref25.directives;
    return join([name + ': ' + type, wrap('= ', defaultValue), join(directives, ' ')], ' ');
  }),

  InterfaceTypeDefinition: addDescription(function (_ref26) {
    var name = _ref26.name,
        directives = _ref26.directives,
        fields = _ref26.fields;
    return join(['interface', name, join(directives, ' '), block(fields)], ' ');
  }),

  UnionTypeDefinition: addDescription(function (_ref27) {
    var name = _ref27.name,
        directives = _ref27.directives,
        types = _ref27.types;
    return join(['union', name, join(directives, ' '), types && types.length !== 0 ? '= ' + join(types, ' | ') : ''], ' ');
  }),

  EnumTypeDefinition: addDescription(function (_ref28) {
    var name = _ref28.name,
        directives = _ref28.directives,
        values = _ref28.values;
    return join(['enum', name, join(directives, ' '), block(values)], ' ');
  }),

  EnumValueDefinition: addDescription(function (_ref29) {
    var name = _ref29.name,
        directives = _ref29.directives;
    return join([name, join(directives, ' ')], ' ');
  }),

  InputObjectTypeDefinition: addDescription(function (_ref30) {
    var name = _ref30.name,
        directives = _ref30.directives,
        fields = _ref30.fields;
    return join(['input', name, join(directives, ' '), block(fields)], ' ');
  }),

  ScalarTypeExtension: function ScalarTypeExtension(_ref31) {
    var name = _ref31.name,
        directives = _ref31.directives;
    return join(['extend scalar', name, join(directives, ' ')], ' ');
  },

  ObjectTypeExtension: function ObjectTypeExtension(_ref32) {
    var name = _ref32.name,
        interfaces = _ref32.interfaces,
        directives = _ref32.directives,
        fields = _ref32.fields;
    return join(['extend type', name, wrap('implements ', join(interfaces, ' & ')), join(directives, ' '), block(fields)], ' ');
  },

  InterfaceTypeExtension: function InterfaceTypeExtension(_ref33) {
    var name = _ref33.name,
        directives = _ref33.directives,
        fields = _ref33.fields;
    return join(['extend interface', name, join(directives, ' '), block(fields)], ' ');
  },

  UnionTypeExtension: function UnionTypeExtension(_ref34) {
    var name = _ref34.name,
        directives = _ref34.directives,
        types = _ref34.types;
    return join(['extend union', name, join(directives, ' '), types && types.length !== 0 ? '= ' + join(types, ' | ') : ''], ' ');
  },

  EnumTypeExtension: function EnumTypeExtension(_ref35) {
    var name = _ref35.name,
        directives = _ref35.directives,
        values = _ref35.values;
    return join(['extend enum', name, join(directives, ' '), block(values)], ' ');
  },

  InputObjectTypeExtension: function InputObjectTypeExtension(_ref36) {
    var name = _ref36.name,
        directives = _ref36.directives,
        fields = _ref36.fields;
    return join(['extend input', name, join(directives, ' '), block(fields)], ' ');
  },

  DirectiveDefinition: addDescription(function (_ref37) {
    var name = _ref37.name,
        args = _ref37.arguments,
        locations = _ref37.locations;
    return 'directive @' + name + wrap('(', join(args, ', '), ')') + ' on ' + join(locations, ' | ');
  })
};

function addDescription(cb) {
  return function (node) {
    return join([node.description, cb(node)], '\n');
  };
}

/**
 * Given maybeArray, print an empty string if it is null or empty, otherwise
 * print all items together separated by separator if provided
 */
function join(maybeArray, separator) {
  return maybeArray ? maybeArray.filter(function (x) {
    return x;
  }).join(separator || '') : '';
}

/**
 * Given array, print each item on its own line, wrapped in an
 * indented "{ }" block.
 */
function block(array) {
  return array && array.length !== 0 ? '{\n' + indent(join(array, '\n')) + '\n}' : '';
}

/**
 * If maybeString is not null or empty, then wrap with start and end, otherwise
 * print an empty string.
 */
function wrap(start, maybeString, end) {
  return maybeString ? start + maybeString + (end || '') : '';
}

function indent(maybeString) {
  return maybeString && '  ' + maybeString.replace(/\n/g, '\n  ');
}

/**
 * Print a block string in the indented block form by adding a leading and
 * trailing blank line. However, if a block string starts with whitespace and is
 * a single-line, adding a leading blank line would strip that whitespace.
 */
function printBlockString(value, isDescription) {
  var escaped = value.replace(/"""/g, '\\"""');
  return (value[0] === ' ' || value[0] === '\t') && value.indexOf('\n') === -1 ? '"""' + escaped.replace(/"$/, '"\n') + '"""' : '"""\n' + (isDescription ? escaped : indent(escaped)) + '\n"""';
}

/***/ }),
/* 144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getRawTag_js__ = __webpack_require__(1154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__objectToString_js__ = __webpack_require__(1155);




/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? Object(__WEBPACK_IMPORTED_MODULE_1__getRawTag_js__["a" /* default */])(value)
    : Object(__WEBPACK_IMPORTED_MODULE_2__objectToString_js__["a" /* default */])(value);
}

/* harmony default export */ __webpack_exports__["a"] = (baseGetTag);


/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var Class    = __webpack_require__(53),
    Cookie   = __webpack_require__(584).Cookie,
    Promise  = __webpack_require__(246),
    URI      = __webpack_require__(98),
    array    = __webpack_require__(364),
    extend   = __webpack_require__(51),
    Logging  = __webpack_require__(181),
    Timeouts = __webpack_require__(2307),
    Channel  = __webpack_require__(582);

var Transport = extend(Class({ className: 'Transport',
  DEFAULT_PORTS: {'http:': 80, 'https:': 443, 'ws:': 80, 'wss:': 443},
  MAX_DELAY:     0,

  batching:  true,

  initialize: function(dispatcher, endpoint) {
    this._dispatcher = dispatcher;
    this.endpoint    = endpoint;
    this._outbox     = [];
    this._proxy      = extend({}, this._dispatcher.proxy);

    if (!this._proxy.origin)
      this._proxy.origin = this._findProxy();
  },

  close: function() {},

  encode: function(messages) {
    return '';
  },

  sendMessage: function(message) {
    this.debug('Client ? sending message to ?: ?',
               this._dispatcher.clientId, URI.stringify(this.endpoint), message);

    if (!this.batching) return Promise.resolve(this.request([message]));

    this._outbox.push(message);
    this._flushLargeBatch();

    if (message.channel === Channel.HANDSHAKE)
      return this._publish(0.01);

    if (message.channel === Channel.CONNECT)
      this._connectMessage = message;

    return this._publish(this.MAX_DELAY);
  },

  _makePromise: function() {
    var self = this;

    this._requestPromise = this._requestPromise || new Promise(function(resolve) {
      self._resolvePromise = resolve;
    });
  },

  _publish: function(delay) {
    this._makePromise();

    this.addTimeout('publish', delay, function() {
      this._flush();
      delete this._requestPromise;
    }, this);

    return this._requestPromise;
  },

  _flush: function() {
    this.removeTimeout('publish');

    if (this._outbox.length > 1 && this._connectMessage)
      this._connectMessage.advice = {timeout: 0};

    this._resolvePromise(this.request(this._outbox));

    this._connectMessage = null;
    this._outbox = [];
  },

  _flushLargeBatch: function() {
    var string = this.encode(this._outbox);
    if (string.length < this._dispatcher.maxRequestSize) return;
    var last = this._outbox.pop();

    this._makePromise();
    this._flush();

    if (last) this._outbox.push(last);
  },

  _receive: function(replies) {
    if (!replies) return;
    replies = [].concat(replies);

    this.debug('Client ? received from ? via ?: ?',
               this._dispatcher.clientId, URI.stringify(this.endpoint), this.connectionType, replies);

    for (var i = 0, n = replies.length; i < n; i++)
      this._dispatcher.handleResponse(replies[i]);
  },

  _handleError: function(messages, immediate) {
    messages = [].concat(messages);

    this.debug('Client ? failed to send to ? via ?: ?',
               this._dispatcher.clientId, URI.stringify(this.endpoint), this.connectionType, messages);

    for (var i = 0, n = messages.length; i < n; i++)
      this._dispatcher.handleError(messages[i]);
  },

  _getCookies: function() {
    var cookies = this._dispatcher.cookies,
        url     = URI.stringify(this.endpoint);

    if (!cookies) return '';

    return array.map(cookies.getCookiesSync(url), function(cookie) {
      return cookie.cookieString();
    }).join('; ');
  },

  _storeCookies: function(setCookie) {
    var cookies = this._dispatcher.cookies,
        url     = URI.stringify(this.endpoint),
        cookie;

    if (!setCookie || !cookies) return;
    setCookie = [].concat(setCookie);

    for (var i = 0, n = setCookie.length; i < n; i++) {
      cookie = Cookie.parse(setCookie[i]);
      cookies.setCookieSync(cookie, url);
    }
  },

  _findProxy: function() {
    if (typeof process === 'undefined') return undefined;

    var protocol = this.endpoint.protocol;
    if (!protocol) return undefined;

    var name   = protocol.replace(/:$/, '').toLowerCase() + '_proxy',
        upcase = name.toUpperCase(),
        env    = Object({"NODE_ENV":"production","PUBLIC_URL":"","REACT_APP_API_URL":"127.0.0.1/mailApi","REACT_APP_SMTP_EMAIL":"admin@rhlm.co.za"}),
        keys, proxy;

    if (name === 'http_proxy' && env.REQUEST_METHOD) {
      keys = Object.keys(env).filter(function(k) { return /^http_proxy$/i.test(k) });
      if (keys.length === 1) {
        if (keys[0] === name && env[upcase] === undefined)
          proxy = env[name];
      } else if (keys.length > 1) {
        proxy = env[name];
      }
      proxy = proxy || env['CGI_' + upcase];
    } else {
      proxy = env[name] || env[upcase];
      if (proxy && !env[name])
        console.warn('The environment variable ' + upcase +
                     ' is discouraged. Use ' + name + '.');
    }
    return proxy;
  }

}), {
  get: function(dispatcher, allowed, disabled, callback, context) {
    var endpoint = dispatcher.endpoint;

    array.asyncEach(this._transports, function(pair, resume) {
      var connType     = pair[0], klass = pair[1],
          connEndpoint = dispatcher.endpointFor(connType);

      if (array.indexOf(disabled, connType) >= 0)
        return resume();

      if (array.indexOf(allowed, connType) < 0) {
        klass.isUsable(dispatcher, connEndpoint, function() {});
        return resume();
      }

      klass.isUsable(dispatcher, connEndpoint, function(isUsable) {
        if (!isUsable) return resume();
        var transport = klass.hasOwnProperty('create') ? klass.create(dispatcher, connEndpoint) : new klass(dispatcher, connEndpoint);
        callback.call(context, transport);
      });
    }, function() {
      throw new Error('Could not find a usable connection type for ' + URI.stringify(endpoint));
    });
  },

  register: function(type, klass) {
    this._transports.push([type, klass]);
    klass.prototype.connectionType = type;
  },

  getConnectionTypes: function() {
    return array.map(this._transports, function(t) { return t[0] });
  },

  _transports: []
});

extend(Transport.prototype, Logging);
extend(Transport.prototype, Timeouts);

module.exports = Transport;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(74)))

/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(249);
var createDesc = __webpack_require__(599);
module.exports = __webpack_require__(187) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var createHelper = function createHelper(func, helperName) {
  var setDisplayName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var noArgs = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

  if (false) {
    var _ret = function () {
      /* eslint-disable global-require */
      var wrapDisplayName = require('./wrapDisplayName').default;
      /* eslint-enable global-require */

      if (noArgs) {
        return {
          v: function v(BaseComponent) {
            var Component = func(BaseComponent);
            Component.displayName = wrapDisplayName(BaseComponent, helperName);
            return Component;
          }
        };
      }

      return {
        v: function v() {
          for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }

          return function (BaseComponent) {
            var Component = func.apply(undefined, args)(BaseComponent);
            Component.displayName = wrapDisplayName(BaseComponent, helperName);
            return Component;
          };
        }
      };
    }();

    if (typeof _ret === "object") return _ret.v;
  }

  return func;
};

exports.default = createHelper;

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(9)

/**
 * @category Day Helpers
 * @summary Add the specified number of days to the given date.
 *
 * @description
 * Add the specified number of days to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of days to be added
 * @returns {Date} the new date with the days added
 *
 * @example
 * // Add 10 days to 1 September 2014:
 * var result = addDays(new Date(2014, 8, 1), 10)
 * //=> Thu Sep 11 2014 00:00:00
 */
function addDays (dirtyDate, dirtyAmount) {
  var date = parse(dirtyDate)
  var amount = Number(dirtyAmount)
  date.setDate(date.getDate() + amount)
  return date
}

module.exports = addDays


/***/ }),
/* 149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return documentTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return imageTypes; });
/* harmony export (immutable) */ __webpack_exports__["d"] = validateFile;
/* harmony export (immutable) */ __webpack_exports__["b"] = getExtension;
var documentTypes=[".jpeg",".jpg",".png",".doc",".docx",".pdf",".csv",".xls",".xlsx",".ppt",".pptx",".xps",".rar",".zip",".7z"];var imageTypes=[".jpeg",".jpg",".png"];function validateFile(name,acceptableTypes){var iPos=name.lastIndexOf(".");var ext=name.substring(iPos,name.length);if(!acceptableTypes.includes(ext))return false;return true;}function getExtension(name){console.log('got name',name);var iPos=name.lastIndexOf(".");var ext=name.substring(iPos,name.length);console.log('ext',ext);return ext;}

/***/ }),
/* 150 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return GetQuoteHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return GetQuoteHistoryMedical; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ClientQuoteInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ClientQuoteInfoMedical; });
/* unused harmony export TargetMedical */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_graphql_tag__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_graphql_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_graphql_tag__);
var _templateObject=_taggedTemplateLiteral(["\n  query quoteHistory(\n    $brokerId: String!\n    $token: String!\n    $limit: Int!\n    $page: Int!\n    $orderBy: String\n    $direction: String\n    $search: String\n    $clientId: String\n  ) {\n    QuoteHistory(\n      brokerId: $brokerId\n      token: $token\n      limit: $limit\n      page: $page\n      orderBy: $orderBy\n      direction: $direction\n      search: $search\n      clientId: $clientId\n    ) {\n      Count\n      Results {\n        id\n        description\n        sq_taskguid\n        fk_clientID\n        fk_userId\n        benefits\n        date_created\n        fullName\n        values\n      }\n    }\n  }\n"],["\n  query quoteHistory(\n    $brokerId: String!\n    $token: String!\n    $limit: Int!\n    $page: Int!\n    $orderBy: String\n    $direction: String\n    $search: String\n    $clientId: String\n  ) {\n    QuoteHistory(\n      brokerId: $brokerId\n      token: $token\n      limit: $limit\n      page: $page\n      orderBy: $orderBy\n      direction: $direction\n      search: $search\n      clientId: $clientId\n    ) {\n      Count\n      Results {\n        id\n        description\n        sq_taskguid\n        fk_clientID\n        fk_userId\n        benefits\n        date_created\n        fullName\n        values\n      }\n    }\n  }\n"]),_templateObject2=_taggedTemplateLiteral(["\n  query quoteHistoryMedical(\n    $brokerId: String!\n    $token: String!\n    $limit: Int!\n    $page: Int!\n    $orderBy: String\n    $direction: String\n    $search: String\n    $clientId: String\n  ) {\n    QuoteHistoryMedical(\n      brokerId: $brokerId\n      token: $token\n      limit: $limit\n      page: $page\n      orderBy: $orderBy\n      direction: $direction\n      search: $search\n      clientId: $clientId\n    ) {\n      Count\n      Results {\n        id\n        description\n        sq_taskguid\n        fk_clientID\n        fk_userId\n        gapTarget\n        date_created\n        fullName\n        values\n      }\n    }\n  }\n"],["\n  query quoteHistoryMedical(\n    $brokerId: String!\n    $token: String!\n    $limit: Int!\n    $page: Int!\n    $orderBy: String\n    $direction: String\n    $search: String\n    $clientId: String\n  ) {\n    QuoteHistoryMedical(\n      brokerId: $brokerId\n      token: $token\n      limit: $limit\n      page: $page\n      orderBy: $orderBy\n      direction: $direction\n      search: $search\n      clientId: $clientId\n    ) {\n      Count\n      Results {\n        id\n        description\n        sq_taskguid\n        fk_clientID\n        fk_userId\n        gapTarget\n        date_created\n        fullName\n        values\n      }\n    }\n  }\n"]),_templateObject3=_taggedTemplateLiteral(["\n  query clientQuoteInfo(\n    $brokerId: String!\n    $clientId: String!\n    $token: String!\n    $guid: String\n  ) {\n    ClientQuoteInfo(\n      brokerId: $brokerId\n      clientId: $clientId\n      token: $token\n      guid: $guid\n    ) {\n      id\n      scd_name\n      scd_surname\n      scd_dateOfBirth\n      scd_age\n      scd_title\n      scd_occupation\n      scd_monthlyIncome\n      scd_smoker\n      scd_maritalStatus\n      scd_qualification\n      scd_selfEmployed\n      scd_salaryType\n      scd_taxDispensation\n      scd_spouseIncome\n      scd_pAdmin\n      scd_pTravel\n      scd_pManual\n      scd_pSupervision\n      scd_gender\n      scd_calculatedMonthlyIncomeAT\n      scd_actualMonthlyIncomeAT\n      scd_saID\n      fmiOccupation\n      sanlamOccupation\n      doesNotQualifyForIP\n      disOnlyImpairment\n      formValues\n      targets\n      benefits\n      misc_benefits\n      AvailTargetsForBroker {\n        id\n        name\n        logo\n      }\n    }\n  }\n"],["\n  query clientQuoteInfo(\n    $brokerId: String!\n    $clientId: String!\n    $token: String!\n    $guid: String\n  ) {\n    ClientQuoteInfo(\n      brokerId: $brokerId\n      clientId: $clientId\n      token: $token\n      guid: $guid\n    ) {\n      id\n      scd_name\n      scd_surname\n      scd_dateOfBirth\n      scd_age\n      scd_title\n      scd_occupation\n      scd_monthlyIncome\n      scd_smoker\n      scd_maritalStatus\n      scd_qualification\n      scd_selfEmployed\n      scd_salaryType\n      scd_taxDispensation\n      scd_spouseIncome\n      scd_pAdmin\n      scd_pTravel\n      scd_pManual\n      scd_pSupervision\n      scd_gender\n      scd_calculatedMonthlyIncomeAT\n      scd_actualMonthlyIncomeAT\n      scd_saID\n      fmiOccupation\n      sanlamOccupation\n      doesNotQualifyForIP\n      disOnlyImpairment\n      formValues\n      targets\n      benefits\n      misc_benefits\n      AvailTargetsForBroker {\n        id\n        name\n        logo\n      }\n    }\n  }\n"]),_templateObject4=_taggedTemplateLiteral(["\n  query clientQuoteInfoMedical(\n    $brokerId: String!\n    $clientId: String!\n    $token: String!\n    $guid: String\n  ) {\n    ClientQuoteInfoMedical(\n      brokerId: $brokerId\n      clientId: $clientId\n      token: $token\n      guid: $guid\n    ) {\n      id\n      scd_name\n      scd_surname\n      scd_dateOfBirth\n      scd_age\n      scd_title\n      scd_occupation\n      scd_monthlyIncome\n      scd_smoker\n      scd_maritalStatus\n      scd_qualification\n      scd_selfEmployed\n      scd_salaryType\n      scd_taxDispensation\n      scd_spouseIncome\n      scd_pAdmin\n      scd_pTravel\n      scd_pManual\n      scd_pSupervision\n      scd_gender\n      scd_calculatedMonthlyIncomeAT\n      scd_actualMonthlyIncomeAT\n      fmiOccupation\n      sanlamOccupation\n      doesNotQualifyForIP\n      disOnlyImpairment\n      formValues\n      targets\n      benefits\n      misc_benefits\n      AvailTargetsForBroker {\n        id\n        name\n        logo\n      }\n    }\n  }\n"],["\n  query clientQuoteInfoMedical(\n    $brokerId: String!\n    $clientId: String!\n    $token: String!\n    $guid: String\n  ) {\n    ClientQuoteInfoMedical(\n      brokerId: $brokerId\n      clientId: $clientId\n      token: $token\n      guid: $guid\n    ) {\n      id\n      scd_name\n      scd_surname\n      scd_dateOfBirth\n      scd_age\n      scd_title\n      scd_occupation\n      scd_monthlyIncome\n      scd_smoker\n      scd_maritalStatus\n      scd_qualification\n      scd_selfEmployed\n      scd_salaryType\n      scd_taxDispensation\n      scd_spouseIncome\n      scd_pAdmin\n      scd_pTravel\n      scd_pManual\n      scd_pSupervision\n      scd_gender\n      scd_calculatedMonthlyIncomeAT\n      scd_actualMonthlyIncomeAT\n      fmiOccupation\n      sanlamOccupation\n      doesNotQualifyForIP\n      disOnlyImpairment\n      formValues\n      targets\n      benefits\n      misc_benefits\n      AvailTargetsForBroker {\n        id\n        name\n        logo\n      }\n    }\n  }\n"]),_templateObject5=_taggedTemplateLiteral(["\n  query TargetMedical\n  {\n    TargetMedical\n    {\n      id\n      name\n      logo\n    }\n  }\n"],["\n  query TargetMedical\n  {\n    TargetMedical\n    {\n      id\n      name\n      logo\n    }\n  }\n"]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var GetQuoteHistory=__WEBPACK_IMPORTED_MODULE_0_graphql_tag___default()(_templateObject);var GetQuoteHistoryMedical=__WEBPACK_IMPORTED_MODULE_0_graphql_tag___default()(_templateObject2);var ClientQuoteInfo=__WEBPACK_IMPORTED_MODULE_0_graphql_tag___default()(_templateObject3);var ClientQuoteInfoMedical=__WEBPACK_IMPORTED_MODULE_0_graphql_tag___default()(_templateObject4);var TargetMedical=__WEBPACK_IMPORTED_MODULE_0_graphql_tag___default()(_templateObject5);

/***/ }),
/* 151 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util__ = __webpack_require__(22);


var GRADIENT = "Gradient";

var Paintable = {
    extend: function(proto) {
        proto.fill = this.fill;
        proto.stroke = this.stroke;
    },

    fill: function(color, opacity) {
        var options = this.options;

        if (Object(__WEBPACK_IMPORTED_MODULE_0__util__["g" /* defined */])(color)) {
            if (color && color.nodeType !== GRADIENT) {
                var newFill = {
                    color: color
                };
                if (Object(__WEBPACK_IMPORTED_MODULE_0__util__["g" /* defined */])(opacity)) {
                    newFill.opacity = opacity;
                }
                options.set("fill", newFill);
            } else {
                options.set("fill", color);
            }

            return this;
        }

        return options.get("fill");
    },

    stroke: function(color, width, opacity) {
        if (Object(__WEBPACK_IMPORTED_MODULE_0__util__["g" /* defined */])(color)) {
            this.options.set("stroke.color", color);

            if (Object(__WEBPACK_IMPORTED_MODULE_0__util__["g" /* defined */])(width)) {
                this.options.set("stroke.width", width);
            }

            if (Object(__WEBPACK_IMPORTED_MODULE_0__util__["g" /* defined */])(opacity)) {
                this.options.set("stroke.opacity", opacity);
            }

            return this;
        }

        return this.options.get("stroke");
    }
};

/* harmony default export */ __webpack_exports__["a"] = (Paintable);

/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {


/**
 * Expose `Emitter`.
 */

if (true) {
  module.exports = Emitter;
}

/**
 * Initialize a new `Emitter`.
 *
 * @api public
 */

function Emitter(obj) {
  if (obj) return mixin(obj);
};

/**
 * Mixin the emitter properties.
 *
 * @param {Object} obj
 * @return {Object}
 * @api private
 */

function mixin(obj) {
  for (var key in Emitter.prototype) {
    obj[key] = Emitter.prototype[key];
  }
  return obj;
}

/**
 * Listen on the given `event` with `fn`.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */

Emitter.prototype.on =
Emitter.prototype.addEventListener = function(event, fn){
  this._callbacks = this._callbacks || {};
  (this._callbacks['$' + event] = this._callbacks['$' + event] || [])
    .push(fn);
  return this;
};

/**
 * Adds an `event` listener that will be invoked a single
 * time then automatically removed.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */

Emitter.prototype.once = function(event, fn){
  function on() {
    this.off(event, on);
    fn.apply(this, arguments);
  }

  on.fn = fn;
  this.on(event, on);
  return this;
};

/**
 * Remove the given callback for `event` or all
 * registered callbacks.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */

Emitter.prototype.off =
Emitter.prototype.removeListener =
Emitter.prototype.removeAllListeners =
Emitter.prototype.removeEventListener = function(event, fn){
  this._callbacks = this._callbacks || {};

  // all
  if (0 == arguments.length) {
    this._callbacks = {};
    return this;
  }

  // specific event
  var callbacks = this._callbacks['$' + event];
  if (!callbacks) return this;

  // remove all handlers
  if (1 == arguments.length) {
    delete this._callbacks['$' + event];
    return this;
  }

  // remove specific handler
  var cb;
  for (var i = 0; i < callbacks.length; i++) {
    cb = callbacks[i];
    if (cb === fn || cb.fn === fn) {
      callbacks.splice(i, 1);
      break;
    }
  }
  return this;
};

/**
 * Emit `event` with the given args.
 *
 * @param {String} event
 * @param {Mixed} ...
 * @return {Emitter}
 */

Emitter.prototype.emit = function(event){
  this._callbacks = this._callbacks || {};
  var args = [].slice.call(arguments, 1)
    , callbacks = this._callbacks['$' + event];

  if (callbacks) {
    callbacks = callbacks.slice(0);
    for (var i = 0, len = callbacks.length; i < len; ++i) {
      callbacks[i].apply(this, args);
    }
  }

  return this;
};

/**
 * Return array of callbacks for `event`.
 *
 * @param {String} event
 * @return {Array}
 * @api public
 */

Emitter.prototype.listeners = function(event){
  this._callbacks = this._callbacks || {};
  return this._callbacks['$' + event] || [];
};

/**
 * Check if this emitter has `event` handlers.
 *
 * @param {String} event
 * @return {Boolean}
 * @api public
 */

Emitter.prototype.hasListeners = function(event){
  return !! this.listeners(event).length;
};


/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Module dependencies.
 */

var keys = __webpack_require__(2628);
var hasBinary = __webpack_require__(699);
var sliceBuffer = __webpack_require__(2630);
var after = __webpack_require__(2631);
var utf8 = __webpack_require__(2632);

var base64encoder;
if (typeof ArrayBuffer !== 'undefined') {
  base64encoder = __webpack_require__(2633);
}

/**
 * Check if we are running an android browser. That requires us to use
 * ArrayBuffer with polling transports...
 *
 * http://ghinda.net/jpeg-blob-ajax-android/
 */

var isAndroid = typeof navigator !== 'undefined' && /Android/i.test(navigator.userAgent);

/**
 * Check if we are running in PhantomJS.
 * Uploading a Blob with PhantomJS does not work correctly, as reported here:
 * https://github.com/ariya/phantomjs/issues/11395
 * @type boolean
 */
var isPhantomJS = typeof navigator !== 'undefined' && /PhantomJS/i.test(navigator.userAgent);

/**
 * When true, avoids using Blobs to encode payloads.
 * @type boolean
 */
var dontSendBlobs = isAndroid || isPhantomJS;

/**
 * Current protocol version.
 */

exports.protocol = 3;

/**
 * Packet types.
 */

var packets = exports.packets = {
    open:     0    // non-ws
  , close:    1    // non-ws
  , ping:     2
  , pong:     3
  , message:  4
  , upgrade:  5
  , noop:     6
};

var packetslist = keys(packets);

/**
 * Premade error packet.
 */

var err = { type: 'error', data: 'parser error' };

/**
 * Create a blob api even for blob builder when vendor prefixes exist
 */

var Blob = __webpack_require__(2634);

/**
 * Encodes a packet.
 *
 *     <packet type id> [ <data> ]
 *
 * Example:
 *
 *     5hello world
 *     3
 *     4
 *
 * Binary is encoded in an identical principle
 *
 * @api private
 */

exports.encodePacket = function (packet, supportsBinary, utf8encode, callback) {
  if (typeof supportsBinary === 'function') {
    callback = supportsBinary;
    supportsBinary = false;
  }

  if (typeof utf8encode === 'function') {
    callback = utf8encode;
    utf8encode = null;
  }

  var data = (packet.data === undefined)
    ? undefined
    : packet.data.buffer || packet.data;

  if (typeof ArrayBuffer !== 'undefined' && data instanceof ArrayBuffer) {
    return encodeArrayBuffer(packet, supportsBinary, callback);
  } else if (typeof Blob !== 'undefined' && data instanceof Blob) {
    return encodeBlob(packet, supportsBinary, callback);
  }

  // might be an object with { base64: true, data: dataAsBase64String }
  if (data && data.base64) {
    return encodeBase64Object(packet, callback);
  }

  // Sending data as a utf-8 string
  var encoded = packets[packet.type];

  // data fragment is optional
  if (undefined !== packet.data) {
    encoded += utf8encode ? utf8.encode(String(packet.data), { strict: false }) : String(packet.data);
  }

  return callback('' + encoded);

};

function encodeBase64Object(packet, callback) {
  // packet data is an object { base64: true, data: dataAsBase64String }
  var message = 'b' + exports.packets[packet.type] + packet.data.data;
  return callback(message);
}

/**
 * Encode packet helpers for binary types
 */

function encodeArrayBuffer(packet, supportsBinary, callback) {
  if (!supportsBinary) {
    return exports.encodeBase64Packet(packet, callback);
  }

  var data = packet.data;
  var contentArray = new Uint8Array(data);
  var resultBuffer = new Uint8Array(1 + data.byteLength);

  resultBuffer[0] = packets[packet.type];
  for (var i = 0; i < contentArray.length; i++) {
    resultBuffer[i+1] = contentArray[i];
  }

  return callback(resultBuffer.buffer);
}

function encodeBlobAsArrayBuffer(packet, supportsBinary, callback) {
  if (!supportsBinary) {
    return exports.encodeBase64Packet(packet, callback);
  }

  var fr = new FileReader();
  fr.onload = function() {
    exports.encodePacket({ type: packet.type, data: fr.result }, supportsBinary, true, callback);
  };
  return fr.readAsArrayBuffer(packet.data);
}

function encodeBlob(packet, supportsBinary, callback) {
  if (!supportsBinary) {
    return exports.encodeBase64Packet(packet, callback);
  }

  if (dontSendBlobs) {
    return encodeBlobAsArrayBuffer(packet, supportsBinary, callback);
  }

  var length = new Uint8Array(1);
  length[0] = packets[packet.type];
  var blob = new Blob([length.buffer, packet.data]);

  return callback(blob);
}

/**
 * Encodes a packet with binary data in a base64 string
 *
 * @param {Object} packet, has `type` and `data`
 * @return {String} base64 encoded message
 */

exports.encodeBase64Packet = function(packet, callback) {
  var message = 'b' + exports.packets[packet.type];
  if (typeof Blob !== 'undefined' && packet.data instanceof Blob) {
    var fr = new FileReader();
    fr.onload = function() {
      var b64 = fr.result.split(',')[1];
      callback(message + b64);
    };
    return fr.readAsDataURL(packet.data);
  }

  var b64data;
  try {
    b64data = String.fromCharCode.apply(null, new Uint8Array(packet.data));
  } catch (e) {
    // iPhone Safari doesn't let you apply with typed arrays
    var typed = new Uint8Array(packet.data);
    var basic = new Array(typed.length);
    for (var i = 0; i < typed.length; i++) {
      basic[i] = typed[i];
    }
    b64data = String.fromCharCode.apply(null, basic);
  }
  message += btoa(b64data);
  return callback(message);
};

/**
 * Decodes a packet. Changes format to Blob if requested.
 *
 * @return {Object} with `type` and `data` (if any)
 * @api private
 */

exports.decodePacket = function (data, binaryType, utf8decode) {
  if (data === undefined) {
    return err;
  }
  // String data
  if (typeof data === 'string') {
    if (data.charAt(0) === 'b') {
      return exports.decodeBase64Packet(data.substr(1), binaryType);
    }

    if (utf8decode) {
      data = tryDecode(data);
      if (data === false) {
        return err;
      }
    }
    var type = data.charAt(0);

    if (Number(type) != type || !packetslist[type]) {
      return err;
    }

    if (data.length > 1) {
      return { type: packetslist[type], data: data.substring(1) };
    } else {
      return { type: packetslist[type] };
    }
  }

  var asArray = new Uint8Array(data);
  var type = asArray[0];
  var rest = sliceBuffer(data, 1);
  if (Blob && binaryType === 'blob') {
    rest = new Blob([rest]);
  }
  return { type: packetslist[type], data: rest };
};

function tryDecode(data) {
  try {
    data = utf8.decode(data, { strict: false });
  } catch (e) {
    return false;
  }
  return data;
}

/**
 * Decodes a packet encoded in a base64 string
 *
 * @param {String} base64 encoded message
 * @return {Object} with `type` and `data` (if any)
 */

exports.decodeBase64Packet = function(msg, binaryType) {
  var type = packetslist[msg.charAt(0)];
  if (!base64encoder) {
    return { type: type, data: { base64: true, data: msg.substr(1) } };
  }

  var data = base64encoder.decode(msg.substr(1));

  if (binaryType === 'blob' && Blob) {
    data = new Blob([data]);
  }

  return { type: type, data: data };
};

/**
 * Encodes multiple messages (payload).
 *
 *     <length>:data
 *
 * Example:
 *
 *     11:hello world2:hi
 *
 * If any contents are binary, they will be encoded as base64 strings. Base64
 * encoded strings are marked with a b before the length specifier
 *
 * @param {Array} packets
 * @api private
 */

exports.encodePayload = function (packets, supportsBinary, callback) {
  if (typeof supportsBinary === 'function') {
    callback = supportsBinary;
    supportsBinary = null;
  }

  var isBinary = hasBinary(packets);

  if (supportsBinary && isBinary) {
    if (Blob && !dontSendBlobs) {
      return exports.encodePayloadAsBlob(packets, callback);
    }

    return exports.encodePayloadAsArrayBuffer(packets, callback);
  }

  if (!packets.length) {
    return callback('0:');
  }

  function setLengthHeader(message) {
    return message.length + ':' + message;
  }

  function encodeOne(packet, doneCallback) {
    exports.encodePacket(packet, !isBinary ? false : supportsBinary, false, function(message) {
      doneCallback(null, setLengthHeader(message));
    });
  }

  map(packets, encodeOne, function(err, results) {
    return callback(results.join(''));
  });
};

/**
 * Async array map using after
 */

function map(ary, each, done) {
  var result = new Array(ary.length);
  var next = after(ary.length, done);

  var eachWithIndex = function(i, el, cb) {
    each(el, function(error, msg) {
      result[i] = msg;
      cb(error, result);
    });
  };

  for (var i = 0; i < ary.length; i++) {
    eachWithIndex(i, ary[i], next);
  }
}

/*
 * Decodes data when a payload is maybe expected. Possible binary contents are
 * decoded from their base64 representation
 *
 * @param {String} data, callback method
 * @api public
 */

exports.decodePayload = function (data, binaryType, callback) {
  if (typeof data !== 'string') {
    return exports.decodePayloadAsBinary(data, binaryType, callback);
  }

  if (typeof binaryType === 'function') {
    callback = binaryType;
    binaryType = null;
  }

  var packet;
  if (data === '') {
    // parser error - ignoring payload
    return callback(err, 0, 1);
  }

  var length = '', n, msg;

  for (var i = 0, l = data.length; i < l; i++) {
    var chr = data.charAt(i);

    if (chr !== ':') {
      length += chr;
      continue;
    }

    if (length === '' || (length != (n = Number(length)))) {
      // parser error - ignoring payload
      return callback(err, 0, 1);
    }

    msg = data.substr(i + 1, n);

    if (length != msg.length) {
      // parser error - ignoring payload
      return callback(err, 0, 1);
    }

    if (msg.length) {
      packet = exports.decodePacket(msg, binaryType, false);

      if (err.type === packet.type && err.data === packet.data) {
        // parser error in individual packet - ignoring payload
        return callback(err, 0, 1);
      }

      var ret = callback(packet, i + n, l);
      if (false === ret) return;
    }

    // advance cursor
    i += n;
    length = '';
  }

  if (length !== '') {
    // parser error - ignoring payload
    return callback(err, 0, 1);
  }

};

/**
 * Encodes multiple messages (payload) as binary.
 *
 * <1 = binary, 0 = string><number from 0-9><number from 0-9>[...]<number
 * 255><data>
 *
 * Example:
 * 1 3 255 1 2 3, if the binary contents are interpreted as 8 bit integers
 *
 * @param {Array} packets
 * @return {ArrayBuffer} encoded payload
 * @api private
 */

exports.encodePayloadAsArrayBuffer = function(packets, callback) {
  if (!packets.length) {
    return callback(new ArrayBuffer(0));
  }

  function encodeOne(packet, doneCallback) {
    exports.encodePacket(packet, true, true, function(data) {
      return doneCallback(null, data);
    });
  }

  map(packets, encodeOne, function(err, encodedPackets) {
    var totalLength = encodedPackets.reduce(function(acc, p) {
      var len;
      if (typeof p === 'string'){
        len = p.length;
      } else {
        len = p.byteLength;
      }
      return acc + len.toString().length + len + 2; // string/binary identifier + separator = 2
    }, 0);

    var resultArray = new Uint8Array(totalLength);

    var bufferIndex = 0;
    encodedPackets.forEach(function(p) {
      var isString = typeof p === 'string';
      var ab = p;
      if (isString) {
        var view = new Uint8Array(p.length);
        for (var i = 0; i < p.length; i++) {
          view[i] = p.charCodeAt(i);
        }
        ab = view.buffer;
      }

      if (isString) { // not true binary
        resultArray[bufferIndex++] = 0;
      } else { // true binary
        resultArray[bufferIndex++] = 1;
      }

      var lenStr = ab.byteLength.toString();
      for (var i = 0; i < lenStr.length; i++) {
        resultArray[bufferIndex++] = parseInt(lenStr[i]);
      }
      resultArray[bufferIndex++] = 255;

      var view = new Uint8Array(ab);
      for (var i = 0; i < view.length; i++) {
        resultArray[bufferIndex++] = view[i];
      }
    });

    return callback(resultArray.buffer);
  });
};

/**
 * Encode as Blob
 */

exports.encodePayloadAsBlob = function(packets, callback) {
  function encodeOne(packet, doneCallback) {
    exports.encodePacket(packet, true, true, function(encoded) {
      var binaryIdentifier = new Uint8Array(1);
      binaryIdentifier[0] = 1;
      if (typeof encoded === 'string') {
        var view = new Uint8Array(encoded.length);
        for (var i = 0; i < encoded.length; i++) {
          view[i] = encoded.charCodeAt(i);
        }
        encoded = view.buffer;
        binaryIdentifier[0] = 0;
      }

      var len = (encoded instanceof ArrayBuffer)
        ? encoded.byteLength
        : encoded.size;

      var lenStr = len.toString();
      var lengthAry = new Uint8Array(lenStr.length + 1);
      for (var i = 0; i < lenStr.length; i++) {
        lengthAry[i] = parseInt(lenStr[i]);
      }
      lengthAry[lenStr.length] = 255;

      if (Blob) {
        var blob = new Blob([binaryIdentifier.buffer, lengthAry.buffer, encoded]);
        doneCallback(null, blob);
      }
    });
  }

  map(packets, encodeOne, function(err, results) {
    return callback(new Blob(results));
  });
};

/*
 * Decodes data when a payload is maybe expected. Strings are decoded by
 * interpreting each byte as a key code for entries marked to start with 0. See
 * description of encodePayloadAsBinary
 *
 * @param {ArrayBuffer} data, callback method
 * @api public
 */

exports.decodePayloadAsBinary = function (data, binaryType, callback) {
  if (typeof binaryType === 'function') {
    callback = binaryType;
    binaryType = null;
  }

  var bufferTail = data;
  var buffers = [];

  while (bufferTail.byteLength > 0) {
    var tailArray = new Uint8Array(bufferTail);
    var isString = tailArray[0] === 0;
    var msgLength = '';

    for (var i = 1; ; i++) {
      if (tailArray[i] === 255) break;

      // 310 = char length of Number.MAX_VALUE
      if (msgLength.length > 310) {
        return callback(err, 0, 1);
      }

      msgLength += tailArray[i];
    }

    bufferTail = sliceBuffer(bufferTail, 2 + msgLength.length);
    msgLength = parseInt(msgLength);

    var msg = sliceBuffer(bufferTail, 0, msgLength);
    if (isString) {
      try {
        msg = String.fromCharCode.apply(null, new Uint8Array(msg));
      } catch (e) {
        // iPhone Safari doesn't let you apply to typed arrays
        var typed = new Uint8Array(msg);
        msg = '';
        for (var i = 0; i < typed.length; i++) {
          msg += String.fromCharCode(typed[i]);
        }
      }
    }

    buffers.push(msg);
    bufferTail = sliceBuffer(bufferTail, msgLength);
  }

  var total = buffers.length;
  buffers.forEach(function(buffer, i) {
    callback(exports.decodePacket(buffer, binaryType, true), i, total);
  });
};


/***/ }),
/* 154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return Life; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ComprehensiveDisability; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return OwnOccupationDis; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return Impairment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CritIllness; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return TemporaryIncomeProtector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ExtendedIncomeProtector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return DIncomeProtector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return getValidationCriteria; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return validateCriteria; });
/* unused harmony export premiumPatternMap */
var Life={target1:{toAgeWholeLife:{companyName:'Momentum',minAges:{any:15},maxAges:{any:80},minCovers:{defaults:{any:100000}},maxCovers:{defaults:{any:'20xAnSal'},students:{any:500000}}}},target3:{toAgeWholeLife:{companyName:'Sanlam',minAges:{level:15,fivePercent:30,ageRated:15},maxAges:{any:79},minCovers:{defaults:{any:150000}},maxCovers:{defaults:{any:100000000},students:{'15-18':1000000,'19+':2000000}}}},target10:{toAgeWholeLife:{companyName:'Bidvest',minAges:{any:18},maxAges:{any:75},minCovers:{defaults:{any:150000}},maxCovers:{defaults:{any:'20xAnSal'},absoluteMax:{any:50000000}}}},target2:{toAgeWholeLife:{companyName:'Liberty',minAges:{level:15,fivePercent:25,ageRated:20},maxAges:{any:80},minCovers:{defaults:{any:150000}},maxCovers:{defaults:{any:100000000},students:{any:1500000}}}}};var ComprehensiveDisability={target1:{toAgeAny:{minAges:{any:15},maxAges:{any:70},minCovers:{defaults:{any:100000}},maxCovers:{defaults:{any:25000000}}}},target3:{toAge65:{minAges:{level:15,fivePercent:30,ageRated:15},maxAges:{any:60},minCovers:{defaults:{any:50000}},maxCovers:{defaults:{any:30000000},absoluteMax:{any:'20xAnSal'}}},toAge70:{minAges:{any:'na'},maxAges:{any:'na'},minCovers:{defaults:{any:'na'}},maxCovers:{defaults:{any:'na'}}}},target10:{toAgeAny:{minAges:{any:18},maxAges:{any:60},minCovers:{defaults:{any:100000}},maxCovers:{defaults:{any:20000000}}}},target2:{toAgeAny:{minAges:{level:15,fivePercent:25,ageRated:20},maxAges:{level:'yearsBeforeBenefitCeaseAge:10',fivePercent:'yearsBeforeBenefitCeaseAge:10',ageRated:'yearsBeforeBenefitCeaseAge:10'},minCovers:{defaults:{any:100000}},maxCovers:{defaults:{any:60000000}}}}};var OwnOccupationDis={target1:{toAgeAny:{minAges:{any:15},maxAges:{any:70},minCovers:{defaults:{any:100000}},maxCovers:{defaults:{any:25000000}}}},target3:{toAge65:{minAges:{level:15,fivePercent:30,ageRated:15},maxAges:{any:60},minCovers:{defaults:{any:50000}},maxCovers:{defaults:{any:30000000},absoluteMax:{any:'20xAnSal'}}},toAge70:{minAges:{any:'na'},maxAges:{any:'na'},minCovers:{defaults:{any:'na'}},maxCovers:{defaults:{any:'na'}}}},target10:{toAgeAny:{minAges:{any:18},maxAges:{any:60},minCovers:{defaults:{any:100000}},maxCovers:{defaults:{any:20000000}}}},target2:{toAgeAny:{minAges:{level:15,fivePercent:25,ageRated:20},maxAges:{level:'yearsBeforeBenefitCeaseAge:10',fivePercent:'yearsBeforeBenefitCeaseAge:10',ageRated:'yearsBeforeBenefitCeaseAge:10'},minCovers:{defaults:{any:100000}},maxCovers:{defaults:{any:60000000}}}}};var Impairment={target1:{toAgeAny:{minAges:{any:15},maxAges:{any:70},minCovers:{defaults:{any:100000}},maxCovers:{defaults:{any:25000000}}}},target3:{toAge65:{minAges:{level:15,fivePercent:30,ageRated:15},maxAges:{any:60},minCovers:{defaults:{any:50000}},maxCovers:{defaults:{any:30000000},absoluteMax:{any:'20xAnSal'}}},toAge70:{minAges:{any:'na'},maxAges:{any:'na'},minCovers:{defaults:{any:'na'}},maxCovers:{defaults:{any:'na'}}}},target10:{toAgeAny:{minAges:{any:18},maxAges:{any:60},minCovers:{defaults:{any:100000}},maxCovers:{defaults:{any:20000000}}}},target2:{toAgeAny:{minAges:{level:15,fivePercent:25,ageRated:20},maxAges:{level:'yearsBeforeBenefitCeaseAge:10',fivePercent:'yearsBeforeBenefitCeaseAge:10',ageRated:'yearsBeforeBenefitCeaseAge:10'},minCovers:{defaults:{any:100000}},maxCovers:{defaults:{any:60000000}}}}};var CritIllness={target1:{toAge65:{minAges:{any:15},maxAges:{any:65},minCovers:{defaults:{any:100000}},maxCovers:{defaults:{any:4500000},students:{any:1000000},professional:{any:5000000}}},toAgeWholeLife:{minAges:{any:15},maxAges:{any:70},minCovers:{defaults:{any:100000}},maxCovers:{defaults:{any:5000000},students:{any:1000000},professional:{any:5500000}}}},target3:{toAge65:{minAges:{level:15,fivePercent:30,ageRated:15},maxAges:{any:60},minCovers:{defaults:{any:50000}},maxCovers:{defaults:{any:6000000},absoluteMax:{any:'20xAnSal'}}},toAgeWholeLife:{minAges:{level:15,fivePercent:30,ageRated:15},maxAges:{any:65},minCovers:{defaults:{any:50000}},maxCovers:{defaults:{any:6000000},absoluteMax:{any:'20xAnSal'}}}},target10:{toAge65:{minAges:{any:18},maxAges:{any:60},minCovers:{defaults:{any:100000}},maxCovers:{defaults:{any:5000000}}},toAgeWholeLife:{minAges:{any:18},maxAges:{any:70},minCovers:{defaults:{any:100000}},maxCovers:{defaults:{any:5000000}}}},target2:{toAge65:{minAges:{level:15,fivePercent:30,ageRated:15},maxAges:{any:60},minCovers:{defaults:{any:100000}},maxCovers:{defaults:{any:6000000}}},toAgeWholeLife:{minAges:{level:15,fivePercent:30,ageRated:15},maxAges:{any:65},minCovers:{defaults:{any:100000}},maxCovers:{defaults:{any:6000000}}}}};var TemporaryIncomeProtector={target1:{minAges:{any:15},maxAges:{level:'yearsBeforeBenefitCeaseAge:5',fivePercent:'yearsBeforeBenefitCeaseAge:5',ageRated:'yearsBeforeBenefitCeaseAge:10'},minCovers:{defaults:{any:2000}},maxCovers:{defaults:{any:150000},professional:{any:200000}}},target3:{minAges:{level:17,fivePercent:30,ageRated:17},maxAges:{level:'yearsBeforeBenefitCeaseAge:5',fivePercent:'yearsBeforeBenefitCeaseAge:5',ageRated:'yearsBeforeBenefitCeaseAge:5'},minCovers:{defaults:{any:3000}},maxCovers:{defaults:{any:'na'}}},target10:{minAges:{any:18},maxAges:{level:'yearsBeforeBenefitCeaseAge:5',fivePercent:'yearsBeforeBenefitCeaseAge:5',ageRated:'yearsBeforeBenefitCeaseAge:10'},minCovers:{defaults:{any:2000}},maxCovers:{defaults:{any:150000}}},target2:{toAge60:{minAges:{level:18,fivePercent:20,ageRated:20},maxAges:{level:50,fivePercent:45,ageRated:45},minCovers:{defaults:{any:2000}},maxCovers:{defaults:{any:100000},professional:{any:150000}}},toAge65:{minAges:{level:18,fivePercent:20,ageRated:20},maxAges:{level:55,fivePercent:50,ageRated:50},minCovers:{defaults:{any:2000}},maxCovers:{defaults:{any:100000},professional:{any:150000}}},toAge70:{minAges:{level:18,fivePercent:20,ageRated:20},maxAges:{level:65,fivePercent:60,ageRated:60},minCovers:{defaults:{any:2000}},maxCovers:{defaults:{any:100000},professional:{any:150000}}}}};var ExtendedIncomeProtector={target1:{minAges:{any:15},maxAges:{level:'yearsBeforeBenefitCeaseAge:5',fivePercent:'yearsBeforeBenefitCeaseAge:5',ageRated:'yearsBeforeBenefitCeaseAge:5'},minCovers:{defaults:{any:2000}},maxCovers:{defaults:{any:150000},professional:{any:200000}}},target3:{minAges:{level:17,fivePercent:30,ageRated:17},maxAges:{level:'yearsBeforeBenefitCeaseAge:5',fivePercent:'yearsBeforeBenefitCeaseAge:5',ageRated:'yearsBeforeBenefitCeaseAge:5'},minCovers:{defaults:{any:3000}},maxCovers:{defaults:{any:'na'}}},target10:{minAges:{any:18},maxAges:{level:'yearsBeforeBenefitCeaseAge:5',fivePercent:'yearsBeforeBenefitCeaseAge:5',ageRated:'yearsBeforeBenefitCeaseAge:5'},minCovers:{defaults:{any:2000}},maxCovers:{defaults:{any:150000}}},target2:{toAge60:{minAges:{level:18,fivePercent:20,ageRated:20},maxAges:{level:50,fivePercent:45,ageRated:45},minCovers:{defaults:{any:2000}},maxCovers:{defaults:{level:75000,fivePercent:100000,ageRated:100000},professional:{any:112500}}},toAge65:{minAges:{level:18,fivePercent:20,ageRated:20},maxAges:{level:55,fivePercent:50,ageRated:50},minCovers:{defaults:{any:2000}},maxCovers:{defaults:{level:75000,fivePercent:100000,ageRated:100000},professional:{any:112500}}},toAge70:{minAges:{level:18,fivePercent:20,ageRated:20},maxAges:{level:65,fivePercent:60,ageRated:60},minCovers:{defaults:{any:2000}},maxCovers:{defaults:{level:75000,fivePercent:100000,ageRated:100000},professional:{any:112500}}}}};var DIncomeProtector={target1:{minAges:{any:15},maxAges:{level:'yearsBeforeBenefitCeaseAge:5',fivePercent:'yearsBeforeBenefitCeaseAge:5',ageRated:'yearsBeforeBenefitCeaseAge:5'},minCovers:{defaults:{any:2000}},maxCovers:{defaults:{any:150000},professional:{any:200000}}},target3:{minAges:{level:17,fivePercent:30,ageRated:17},maxAges:{level:'yearsBeforeBenefitCeaseAge:5',fivePercent:'yearsBeforeBenefitCeaseAge:5',ageRated:'yearsBeforeBenefitCeaseAge:5'},minCovers:{defaults:{any:3000}},maxCovers:{defaults:{any:'na'}}},target10:{minAges:{any:18},maxAges:{level:'yearsBeforeBenefitCeaseAge:5',fivePercent:'yearsBeforeBenefitCeaseAge:5',ageRated:'yearsBeforeBenefitCeaseAge:5'},minCovers:{defaults:{any:2000}},maxCovers:{defaults:{any:150000}}},target2:{toAge60:{minAges:{level:18,fivePercent:20,ageRated:20},maxAges:{level:50,fivePercent:45,ageRated:45},minCovers:{defaults:{any:2000}},maxCovers:{defaults:{level:75000,fivePercent:100000,ageRated:100000},professional:{any:112500}}},toAge65:{minAges:{level:18,fivePercent:20,ageRated:20},maxAges:{level:55,fivePercent:50,ageRated:50},minCovers:{defaults:{any:2000}},maxCovers:{defaults:{level:75000,fivePercent:100000,ageRated:100000},professional:{any:112500}}},toAge70:{minAges:{level:18,fivePercent:20,ageRated:20},maxAges:{level:65,fivePercent:60,ageRated:60},minCovers:{defaults:{any:2000}},maxCovers:{defaults:{level:75000,fivePercent:100000,ageRated:100000},professional:{any:112500}}}}};var getValidationCriteria=function getValidationCriteria(obj){var benefitValidationObj=obj.benefitValidationObj,targets=obj.targets,selectedTargets=obj.selectedTargets,occupation=obj.occupation,qualification=obj.qualification,age=obj.age,toAge=obj.toAge;var companyCriteria={};var premiumPattern=premiumPatternMap[obj.premiumPattern];var anualSalary=parseFloat(obj.anualSalary);selectedTargets.map(function(targetId){var target=targets.find(function(t){return t.id===targetId;});if(!target){return targetId;}var targetName=target.name;var validationObj=benefitValidationObj['target'+targetId];if(!validationObj)return targetId;if(validationObj['toAge'+toAge]){validationObj=validationObj['toAge'+toAge];}else if(validationObj.toAgeAny){validationObj=validationObj.toAgeAny;}companyCriteria[targetName]={};var minAge=validationObj.minAges[premiumPattern]||validationObj.minAges.any||null;var maxAge=validationObj.maxAges[premiumPattern]||validationObj.maxAges.any||null;if(maxAge.toString().includes('yearsBeforeBenefitCeaseAge:')&&!isNaN(toAge)){maxAge=parseInt(toAge,10)-parseInt(maxAge.split(':')[1],10);}companyCriteria[targetName].minAge=minAge;companyCriteria[targetName].maxAge=maxAge;var minCover=validationObj.minCovers.defaults[premiumPattern]||validationObj.minCovers.defaults.any||null;if(minCover==='20xAnSal')minCover=anualSalary*20;var maxCover=validationObj.maxCovers.absoluteMax?validationObj.maxCovers.absoluteMax.any:validationObj.maxCovers.defaults[premiumPattern]||validationObj.maxCovers.defaults.any||null;if(occupation.toLowerCase().includes('student')&&validationObj.maxCovers.students){if(validationObj.maxCovers.students.any){maxCover=validationObj.maxCovers.students.any;}else{Object.keys(validationObj.maxCovers.students).map(function(ageKey){if(ageKey.includes('-')){var minStudentAge=parseInt(ageKey.split('-')[0],10);var maxStudentAge=parseInt(ageKey.split('-')[1],10);if(age>=minStudentAge&&age<=maxStudentAge){maxCover=validationObj.maxCovers.students[ageKey];}}else if(ageKey.includes('+')){var _minStudentAge=parseInt(ageKey.split('+')[0],10);if(age>=_minStudentAge){maxCover=validationObj.maxCovers.students[ageKey];}}return ageKey;});}}if((qualification==='3-yearDegreeOr4-yearDiploma'||qualification==='4-yearDegreeOrProfessional')&&validationObj.maxCovers.professional){maxCover=validationObj.maxCovers.professional.any;}if(maxCover==='20xAnSal')maxCover=anualSalary*20;companyCriteria[targetName].minCover=minCover;companyCriteria[targetName].maxCover=maxCover;return targetId;});return companyCriteria;};var validateCriteria=function validateCriteria(criteria,obj){var minAmount=arguments.length>2&&arguments[2]!==undefined?arguments[2]:1;var maxAmount=arguments.length>3&&arguments[3]!==undefined?arguments[3]:null;var companyErrors={};var age=parseInt(obj.age,10);var amount=parseFloat(obj.amount);Object.keys(criteria).map(function(company){var messages=[];var _criteria$company=criteria[company],minAge=_criteria$company.minAge,maxAge=_criteria$company.maxAge,minCover=_criteria$company.minCover,maxCover=_criteria$company.maxCover;if(minAge&&minAge!=='na'&&age<minAge||maxAge&&maxAge!=='na'&&age>maxAge){messages.push('Client\'s age must be between '+minAge+' and '+maxAge+' to qualify');}if(amount>=minAmount&&(maxAmount?amount<=maxAmount:true)){if(minCover&&minCover!=='na'&&amount<minCover){messages.push('Cover Amount must be '+minCover+' or greater.');}if(maxCover&&maxCover!=='na'&&amount>maxCover){messages.push('Cover Amount must be  '+maxCover+' or less');}}if(messages.length>0)companyErrors[company]={messages:messages};return company;});return companyErrors;};var premiumPatternMap={Level:'level',Compulsory:'fivePercent',AgeRated:'ageRated'};

/***/ }),
/* 155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core__ = __webpack_require__(4);
var CompanyErrorBlock=function CompanyErrorBlock(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{border:'1px solid red',borderRadius:'5px',padding:'15px 15px 15px 23px',position:'relative'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["Z" /* Typography */],{variant:'body1',style:{position:'absolute',top:'-9px',left:'15px',backgroundColor:'white',padding:'0px 8px',color:'red'}},'Company Errors'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["Z" /* Typography */],{style:{marginTop:'10px'}},'*NB: Errors are subject to Premium Pattern and/or Benefit\'s Cease Age'),Object.keys(props.companyErrors).map(function(company){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,{key:company},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["Z" /* Typography */],{style:{color:'red',marginTop:'10px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,company)),props.companyErrors[company].messages.map(function(message,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["Z" /* Typography */],{style:{color:'red',paddingLeft:'30px',paddingTop:'3px'},key:i},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{paddingRight:'5px'}},'\u2022'),message);}));}));};/* harmony default export */ __webpack_exports__["a"] = (CompanyErrorBlock);

/***/ }),
/* 156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return Life; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ComprehensiveDisability; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return OwnOccupationDis; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return Impairment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CritIllness; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return TemporaryIncomeProtector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ExtendedIncomeProtector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return DIncomeProtector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return getValidationCriteria; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return validateCriteria; });
/* unused harmony export premiumPatternMap */
var Life={target1:{toAgeWholeLife:{companyName:'Momentum',minAges:{any:15},maxAges:{any:80},minCovers:{defaults:{any:100000}},maxCovers:{defaults:{any:'20xAnSal'},students:{any:500000}}}},target3:{toAgeWholeLife:{companyName:'Sanlam',minAges:{level:15,fivePercent:30,ageRated:15},maxAges:{any:79},minCovers:{defaults:{any:150000}},maxCovers:{defaults:{any:100000000},students:{'15-18':1000000,'19+':2000000}}}},target10:{toAgeWholeLife:{companyName:'Bidvest',minAges:{any:18},maxAges:{any:75},minCovers:{defaults:{any:150000}},maxCovers:{defaults:{any:'20xAnSal'},absoluteMax:{any:50000000}}}},target2:{toAgeWholeLife:{companyName:'Liberty',minAges:{level:15,fivePercent:25,ageRated:20},maxAges:{any:80},minCovers:{defaults:{any:150000}},maxCovers:{defaults:{any:100000000},students:{any:1500000}}}}};var ComprehensiveDisability={target1:{toAgeAny:{minAges:{any:15},maxAges:{any:70},minCovers:{defaults:{any:100000}},maxCovers:{defaults:{any:25000000}}}},target3:{toAge65:{minAges:{level:15,fivePercent:30,ageRated:15},maxAges:{any:60},minCovers:{defaults:{any:50000}},maxCovers:{defaults:{any:30000000},absoluteMax:{any:'20xAnSal'}}},toAge70:{minAges:{any:'na'},maxAges:{any:'na'},minCovers:{defaults:{any:'na'}},maxCovers:{defaults:{any:'na'}}}},target10:{toAgeAny:{minAges:{any:18},maxAges:{any:60},minCovers:{defaults:{any:100000}},maxCovers:{defaults:{any:20000000}}}},target2:{toAgeAny:{minAges:{level:15,fivePercent:25,ageRated:20},maxAges:{level:'yearsBeforeBenefitCeaseAge:10',fivePercent:'yearsBeforeBenefitCeaseAge:10',ageRated:'yearsBeforeBenefitCeaseAge:10'},minCovers:{defaults:{any:100000}},maxCovers:{defaults:{any:60000000}}}}};var OwnOccupationDis={target1:{toAgeAny:{minAges:{any:15},maxAges:{any:70},minCovers:{defaults:{any:100000}},maxCovers:{defaults:{any:25000000}}}},target3:{toAge65:{minAges:{level:15,fivePercent:30,ageRated:15},maxAges:{any:60},minCovers:{defaults:{any:50000}},maxCovers:{defaults:{any:30000000},absoluteMax:{any:'20xAnSal'}}},toAge70:{minAges:{any:'na'},maxAges:{any:'na'},minCovers:{defaults:{any:'na'}},maxCovers:{defaults:{any:'na'}}}},target10:{toAgeAny:{minAges:{any:18},maxAges:{any:60},minCovers:{defaults:{any:100000}},maxCovers:{defaults:{any:20000000}}}},target2:{toAgeAny:{minAges:{level:15,fivePercent:25,ageRated:20},maxAges:{level:'yearsBeforeBenefitCeaseAge:10',fivePercent:'yearsBeforeBenefitCeaseAge:10',ageRated:'yearsBeforeBenefitCeaseAge:10'},minCovers:{defaults:{any:100000}},maxCovers:{defaults:{any:60000000}}}}};var Impairment={target1:{toAgeAny:{minAges:{any:15},maxAges:{any:70},minCovers:{defaults:{any:100000}},maxCovers:{defaults:{any:25000000}}}},target3:{toAge65:{minAges:{level:15,fivePercent:30,ageRated:15},maxAges:{any:60},minCovers:{defaults:{any:50000}},maxCovers:{defaults:{any:30000000},absoluteMax:{any:'20xAnSal'}}},toAge70:{minAges:{any:'na'},maxAges:{any:'na'},minCovers:{defaults:{any:'na'}},maxCovers:{defaults:{any:'na'}}}},target10:{toAgeAny:{minAges:{any:18},maxAges:{any:60},minCovers:{defaults:{any:100000}},maxCovers:{defaults:{any:20000000}}}},target2:{toAgeAny:{minAges:{level:15,fivePercent:25,ageRated:20},maxAges:{level:'yearsBeforeBenefitCeaseAge:10',fivePercent:'yearsBeforeBenefitCeaseAge:10',ageRated:'yearsBeforeBenefitCeaseAge:10'},minCovers:{defaults:{any:100000}},maxCovers:{defaults:{any:60000000}}}}};var CritIllness={target1:{toAge65:{minAges:{any:15},maxAges:{any:65},minCovers:{defaults:{any:100000}},maxCovers:{defaults:{any:4500000},students:{any:1000000},professional:{any:5000000}}},toAgeWholeLife:{minAges:{any:15},maxAges:{any:70},minCovers:{defaults:{any:100000}},maxCovers:{defaults:{any:5000000},students:{any:1000000},professional:{any:5500000}}}},target3:{toAge65:{minAges:{level:15,fivePercent:30,ageRated:15},maxAges:{any:60},minCovers:{defaults:{any:50000}},maxCovers:{defaults:{any:6000000},absoluteMax:{any:'20xAnSal'}}},toAgeWholeLife:{minAges:{level:15,fivePercent:30,ageRated:15},maxAges:{any:65},minCovers:{defaults:{any:50000}},maxCovers:{defaults:{any:6000000},absoluteMax:{any:'20xAnSal'}}}},target10:{toAge65:{minAges:{any:18},maxAges:{any:60},minCovers:{defaults:{any:100000}},maxCovers:{defaults:{any:5000000}}},toAgeWholeLife:{minAges:{any:18},maxAges:{any:70},minCovers:{defaults:{any:100000}},maxCovers:{defaults:{any:5000000}}}},target2:{toAge65:{minAges:{level:15,fivePercent:30,ageRated:15},maxAges:{any:60},minCovers:{defaults:{any:100000}},maxCovers:{defaults:{any:6000000}}},toAgeWholeLife:{minAges:{level:15,fivePercent:30,ageRated:15},maxAges:{any:65},minCovers:{defaults:{any:100000}},maxCovers:{defaults:{any:6000000}}}}};var TemporaryIncomeProtector={target1:{minAges:{any:15},maxAges:{level:'yearsBeforeBenefitCeaseAge:5',fivePercent:'yearsBeforeBenefitCeaseAge:5',ageRated:'yearsBeforeBenefitCeaseAge:10'},minCovers:{defaults:{any:2000}},maxCovers:{defaults:{any:150000},professional:{any:200000}}},target3:{minAges:{level:17,fivePercent:30,ageRated:17},maxAges:{level:'yearsBeforeBenefitCeaseAge:5',fivePercent:'yearsBeforeBenefitCeaseAge:5',ageRated:'yearsBeforeBenefitCeaseAge:5'},minCovers:{defaults:{any:3000}},maxCovers:{defaults:{any:'na'}}},target10:{minAges:{any:18},maxAges:{level:'yearsBeforeBenefitCeaseAge:5',fivePercent:'yearsBeforeBenefitCeaseAge:5',ageRated:'yearsBeforeBenefitCeaseAge:10'},minCovers:{defaults:{any:2000}},maxCovers:{defaults:{any:150000}}},target2:{toAge60:{minAges:{level:18,fivePercent:20,ageRated:20},maxAges:{level:50,fivePercent:45,ageRated:45},minCovers:{defaults:{any:2000}},maxCovers:{defaults:{any:100000},professional:{any:150000}}},toAge65:{minAges:{level:18,fivePercent:20,ageRated:20},maxAges:{level:55,fivePercent:50,ageRated:50},minCovers:{defaults:{any:2000}},maxCovers:{defaults:{any:100000},professional:{any:150000}}},toAge70:{minAges:{level:18,fivePercent:20,ageRated:20},maxAges:{level:65,fivePercent:60,ageRated:60},minCovers:{defaults:{any:2000}},maxCovers:{defaults:{any:100000},professional:{any:150000}}}}};var ExtendedIncomeProtector={target1:{minAges:{any:15},maxAges:{level:'yearsBeforeBenefitCeaseAge:5',fivePercent:'yearsBeforeBenefitCeaseAge:5',ageRated:'yearsBeforeBenefitCeaseAge:5'},minCovers:{defaults:{any:2000}},maxCovers:{defaults:{any:150000},professional:{any:200000}}},target3:{minAges:{level:17,fivePercent:30,ageRated:17},maxAges:{level:'yearsBeforeBenefitCeaseAge:5',fivePercent:'yearsBeforeBenefitCeaseAge:5',ageRated:'yearsBeforeBenefitCeaseAge:5'},minCovers:{defaults:{any:3000}},maxCovers:{defaults:{any:'na'}}},target10:{minAges:{any:18},maxAges:{level:'yearsBeforeBenefitCeaseAge:5',fivePercent:'yearsBeforeBenefitCeaseAge:5',ageRated:'yearsBeforeBenefitCeaseAge:5'},minCovers:{defaults:{any:2000}},maxCovers:{defaults:{any:150000}}},target2:{toAge60:{minAges:{level:18,fivePercent:20,ageRated:20},maxAges:{level:50,fivePercent:45,ageRated:45},minCovers:{defaults:{any:2000}},maxCovers:{defaults:{level:75000,fivePercent:100000,ageRated:100000},professional:{any:112500}}},toAge65:{minAges:{level:18,fivePercent:20,ageRated:20},maxAges:{level:55,fivePercent:50,ageRated:50},minCovers:{defaults:{any:2000}},maxCovers:{defaults:{level:75000,fivePercent:100000,ageRated:100000},professional:{any:112500}}},toAge70:{minAges:{level:18,fivePercent:20,ageRated:20},maxAges:{level:65,fivePercent:60,ageRated:60},minCovers:{defaults:{any:2000}},maxCovers:{defaults:{level:75000,fivePercent:100000,ageRated:100000},professional:{any:112500}}}}};var DIncomeProtector={target1:{minAges:{any:15},maxAges:{level:'yearsBeforeBenefitCeaseAge:5',fivePercent:'yearsBeforeBenefitCeaseAge:5',ageRated:'yearsBeforeBenefitCeaseAge:5'},minCovers:{defaults:{any:2000}},maxCovers:{defaults:{any:150000},professional:{any:200000}}},target3:{minAges:{level:17,fivePercent:30,ageRated:17},maxAges:{level:'yearsBeforeBenefitCeaseAge:5',fivePercent:'yearsBeforeBenefitCeaseAge:5',ageRated:'yearsBeforeBenefitCeaseAge:5'},minCovers:{defaults:{any:3000}},maxCovers:{defaults:{any:'na'}}},target10:{minAges:{any:18},maxAges:{level:'yearsBeforeBenefitCeaseAge:5',fivePercent:'yearsBeforeBenefitCeaseAge:5',ageRated:'yearsBeforeBenefitCeaseAge:5'},minCovers:{defaults:{any:2000}},maxCovers:{defaults:{any:150000}}},target2:{toAge60:{minAges:{level:18,fivePercent:20,ageRated:20},maxAges:{level:50,fivePercent:45,ageRated:45},minCovers:{defaults:{any:2000}},maxCovers:{defaults:{level:75000,fivePercent:100000,ageRated:100000},professional:{any:112500}}},toAge65:{minAges:{level:18,fivePercent:20,ageRated:20},maxAges:{level:55,fivePercent:50,ageRated:50},minCovers:{defaults:{any:2000}},maxCovers:{defaults:{level:75000,fivePercent:100000,ageRated:100000},professional:{any:112500}}},toAge70:{minAges:{level:18,fivePercent:20,ageRated:20},maxAges:{level:65,fivePercent:60,ageRated:60},minCovers:{defaults:{any:2000}},maxCovers:{defaults:{level:75000,fivePercent:100000,ageRated:100000},professional:{any:112500}}}}};var getValidationCriteria=function getValidationCriteria(obj){var benefitValidationObj=obj.benefitValidationObj,targets=obj.targets,selectedTargets=obj.selectedTargets,occupation=obj.occupation,qualification=obj.qualification,age=obj.age,toAge=obj.toAge;var companyCriteria={};var premiumPattern=premiumPatternMap[obj.premiumPattern];var anualSalary=parseFloat(obj.anualSalary);selectedTargets.map(function(targetId){var target=targets.find(function(t){return t.id===targetId;});if(!target){return targetId;}var targetName=target.name;var validationObj=benefitValidationObj['target'+targetId];if(!validationObj)return targetId;if(validationObj['toAge'+toAge]){validationObj=validationObj['toAge'+toAge];}else if(validationObj.toAgeAny){validationObj=validationObj.toAgeAny;}companyCriteria[targetName]={};var minAge=validationObj.minAges[premiumPattern]||validationObj.minAges.any||null;var maxAge=validationObj.maxAges[premiumPattern]||validationObj.maxAges.any||null;if(maxAge.toString().includes('yearsBeforeBenefitCeaseAge:')&&!isNaN(toAge)){maxAge=parseInt(toAge,10)-parseInt(maxAge.split(':')[1],10);}companyCriteria[targetName].minAge=minAge;companyCriteria[targetName].maxAge=maxAge;var minCover=validationObj.minCovers.defaults[premiumPattern]||validationObj.minCovers.defaults.any||null;if(minCover==='20xAnSal')minCover=anualSalary*20;var maxCover=validationObj.maxCovers.absoluteMax?validationObj.maxCovers.absoluteMax.any:validationObj.maxCovers.defaults[premiumPattern]||validationObj.maxCovers.defaults.any||null;if(occupation.toLowerCase().includes('student')&&validationObj.maxCovers.students){if(validationObj.maxCovers.students.any){maxCover=validationObj.maxCovers.students.any;}else{Object.keys(validationObj.maxCovers.students).map(function(ageKey){if(ageKey.includes('-')){var minStudentAge=parseInt(ageKey.split('-')[0],10);var maxStudentAge=parseInt(ageKey.split('-')[1],10);if(age>=minStudentAge&&age<=maxStudentAge){maxCover=validationObj.maxCovers.students[ageKey];}}else if(ageKey.includes('+')){var _minStudentAge=parseInt(ageKey.split('+')[0],10);if(age>=_minStudentAge){maxCover=validationObj.maxCovers.students[ageKey];}}return ageKey;});}}if((qualification==='3-yearDegreeOr4-yearDiploma'||qualification==='4-yearDegreeOrProfessional')&&validationObj.maxCovers.professional){maxCover=validationObj.maxCovers.professional.any;}if(maxCover==='20xAnSal')maxCover=anualSalary*20;companyCriteria[targetName].minCover=minCover;companyCriteria[targetName].maxCover=maxCover;return targetId;});return companyCriteria;};var validateCriteria=function validateCriteria(criteria,obj){var minAmount=arguments.length>2&&arguments[2]!==undefined?arguments[2]:1;var maxAmount=arguments.length>3&&arguments[3]!==undefined?arguments[3]:null;var companyErrors={};var age=parseInt(obj.age,10);var amount=parseFloat(obj.amount);Object.keys(criteria).map(function(company){var messages=[];var _criteria$company=criteria[company],minAge=_criteria$company.minAge,maxAge=_criteria$company.maxAge,minCover=_criteria$company.minCover,maxCover=_criteria$company.maxCover;if(minAge&&minAge!=='na'&&age<minAge||maxAge&&maxAge!=='na'&&age>maxAge){messages.push('Client\'s age must be between '+minAge+' and '+maxAge+' to qualify');}if(amount>=minAmount&&(maxAmount?amount<=maxAmount:true)){if(minCover&&minCover!=='na'&&amount<minCover){messages.push('Cover Amount must be '+minCover+' or greater.');}if(maxCover&&maxCover!=='na'&&amount>maxCover){messages.push('Cover Amount must be  '+maxCover+' or less');}}if(messages.length>0)companyErrors[company]={messages:messages};return company;});return companyErrors;};var premiumPatternMap={Level:'level',Compulsory:'fivePercent',AgeRated:'ageRated'};

/***/ }),
/* 157 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core__ = __webpack_require__(4);
var CompanyErrorBlock=function CompanyErrorBlock(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{border:'1px solid red',borderRadius:'5px',padding:'15px 15px 15px 23px',position:'relative'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["Z" /* Typography */],{variant:'body1',style:{position:'absolute',top:'-9px',left:'15px',backgroundColor:'white',padding:'0px 8px',color:'red'}},'Company Errors'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["Z" /* Typography */],{style:{marginTop:'10px'}},'*NB: Errors are subject to Premium Pattern and/or Benefit\'s Cease Age'),Object.keys(props.companyErrors).map(function(company){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,{key:company},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["Z" /* Typography */],{style:{color:'red',marginTop:'10px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,company)),props.companyErrors[company].messages.map(function(message,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["Z" /* Typography */],{style:{color:'red',paddingLeft:'30px',paddingTop:'3px'},key:i},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{paddingRight:'5px'}},'\u2022'),message);}));}));};/* harmony default export */ __webpack_exports__["a"] = (CompanyErrorBlock);

/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process, global) {
Object.defineProperty(exports, "__esModule", { value: true });
var is_1 = __webpack_require__(125);
/**
 * Requires a module which is protected against bundler minification.
 *
 * @param request The module path to resolve
 */
function dynamicRequire(mod, request) {
    return mod.require(request);
}
exports.dynamicRequire = dynamicRequire;
/**
 * Checks whether we're in the Node.js or Browser environment
 *
 * @returns Answer to given question
 */
function isNodeEnv() {
    // tslint:disable:strict-type-predicates
    return Object.prototype.toString.call(typeof process !== 'undefined' ? process : 0) === '[object process]';
}
exports.isNodeEnv = isNodeEnv;
/**
 * Safely get global scope object
 *
 * @returns Global scope object
 */
// tslint:disable:strict-type-predicates
function getGlobalObject() {
    return isNodeEnv() ? global : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {};
}
exports.getGlobalObject = getGlobalObject;
/**
 * UUID4 generator
 *
 * @returns string Generated UUID4.
 */
function uuid4() {
    var global = getGlobalObject();
    var crypto = global.crypto || global.msCrypto;
    if (!(crypto === void 0) && crypto.getRandomValues) {
        // Use window.crypto API if available
        var arr = new Uint16Array(8);
        crypto.getRandomValues(arr);
        // set 4 in byte 7
        // tslint:disable-next-line:no-bitwise
        arr[3] = (arr[3] & 0xfff) | 0x4000;
        // set 2 most significant bits of byte 9 to '10'
        // tslint:disable-next-line:no-bitwise
        arr[4] = (arr[4] & 0x3fff) | 0x8000;
        var pad = function (num) {
            var v = num.toString(16);
            while (v.length < 4) {
                v = "0" + v;
            }
            return v;
        };
        return (pad(arr[0]) + pad(arr[1]) + pad(arr[2]) + pad(arr[3]) + pad(arr[4]) + pad(arr[5]) + pad(arr[6]) + pad(arr[7]));
    }
    else {
        // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
        return 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            // tslint:disable-next-line:no-bitwise
            var r = (Math.random() * 16) | 0;
            // tslint:disable-next-line:no-bitwise
            var v = c === 'x' ? r : (r & 0x3) | 0x8;
            return v.toString(16);
        });
    }
}
exports.uuid4 = uuid4;
/**
 * Given a child DOM element, returns a query-selector statement describing that
 * and its ancestors
 * e.g. [HTMLElement] => body > div > input#foo.btn[name=baz]
 * @returns generated DOM path
 */
function htmlTreeAsString(elem) {
    var currentElem = elem;
    var MAX_TRAVERSE_HEIGHT = 5;
    var MAX_OUTPUT_LEN = 80;
    var out = [];
    var height = 0;
    var len = 0;
    var separator = ' > ';
    var sepLength = separator.length;
    var nextStr;
    while (currentElem && height++ < MAX_TRAVERSE_HEIGHT) {
        nextStr = htmlElementAsString(currentElem);
        // bail out if
        // - nextStr is the 'html' element
        // - the length of the string that would be created exceeds MAX_OUTPUT_LEN
        //   (ignore this limit if we are on the first iteration)
        if (nextStr === 'html' || (height > 1 && len + out.length * sepLength + nextStr.length >= MAX_OUTPUT_LEN)) {
            break;
        }
        out.push(nextStr);
        len += nextStr.length;
        currentElem = currentElem.parentNode;
    }
    return out.reverse().join(separator);
}
exports.htmlTreeAsString = htmlTreeAsString;
/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @returns generated DOM path
 */
function htmlElementAsString(elem) {
    var out = [];
    var className;
    var classes;
    var key;
    var attr;
    var i;
    if (!elem || !elem.tagName) {
        return '';
    }
    out.push(elem.tagName.toLowerCase());
    if (elem.id) {
        out.push("#" + elem.id);
    }
    className = elem.className;
    if (className && is_1.isString(className)) {
        classes = className.split(/\s+/);
        for (i = 0; i < classes.length; i++) {
            out.push("." + classes[i]);
        }
    }
    var attrWhitelist = ['type', 'name', 'title', 'alt'];
    for (i = 0; i < attrWhitelist.length; i++) {
        key = attrWhitelist[i];
        attr = elem.getAttribute(key);
        if (attr) {
            out.push("[" + key + "=\"" + attr + "\"]");
        }
    }
    return out.join('');
}
exports.htmlElementAsString = htmlElementAsString;
/**
 * Parses string form of URL into an object
 * // borrowed from https://tools.ietf.org/html/rfc3986#appendix-B
 * // intentionally using regex and not <a/> href parsing trick because React Native and other
 * // environments where DOM might not be available
 * @returns parsed URL object
 */
function parseUrl(url) {
    if (!url) {
        return {};
    }
    var match = url.match(/^(([^:\/?#]+):)?(\/\/([^\/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
    if (!match) {
        return {};
    }
    // coerce to undefined values to empty string so we don't get 'undefined'
    var query = match[6] || '';
    var fragment = match[8] || '';
    return {
        host: match[4],
        path: match[5],
        protocol: match[2],
        relative: match[5] + query + fragment,
    };
}
exports.parseUrl = parseUrl;
/**
 * Extracts either message or type+value from an event that can be used for user-facing logs
 * @returns event's description
 */
function getEventDescription(event) {
    if (event.message) {
        return event.message;
    }
    else if (event.exception && event.exception.values && event.exception.values[0]) {
        var exception = event.exception.values[0];
        if (exception.type && exception.value) {
            return exception.type + ": " + exception.value;
        }
        else {
            return exception.type || exception.value || event.event_id || '<unknown>';
        }
    }
    else {
        return event.event_id || '<unknown>';
    }
}
exports.getEventDescription = getEventDescription;
/** JSDoc */
function consoleSandbox(callback) {
    var global = getGlobalObject();
    var levels = ['debug', 'info', 'warn', 'error', 'log'];
    if (!('console' in global)) {
        return callback();
    }
    var originalConsole = global.console;
    var wrappedLevels = {};
    // Restore all wrapped console methods
    levels.forEach(function (level) {
        if (level in global.console && originalConsole[level].__sentry__) {
            wrappedLevels[level] = originalConsole[level].__sentry_wrapped__;
            originalConsole[level] = originalConsole[level].__sentry_original__;
        }
    });
    // Perform callback manipulations
    var result = callback();
    // Revert restoration to wrapped state
    Object.keys(wrappedLevels).forEach(function (level) {
        originalConsole[level] = wrappedLevels[level];
    });
    return result;
}
exports.consoleSandbox = consoleSandbox;
//# sourceMappingURL=misc.js.map
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(74), __webpack_require__(26)))

/***/ }),
/* 159 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addLeadingSlash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return stripLeadingSlash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return hasBasename; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return stripBasename; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return stripTrailingSlash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return parsePath; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return createPath; });
var addLeadingSlash = function addLeadingSlash(path) {
  return path.charAt(0) === '/' ? path : '/' + path;
};

var stripLeadingSlash = function stripLeadingSlash(path) {
  return path.charAt(0) === '/' ? path.substr(1) : path;
};

var hasBasename = function hasBasename(path, prefix) {
  return new RegExp('^' + prefix + '(\\/|\\?|#|$)', 'i').test(path);
};

var stripBasename = function stripBasename(path, prefix) {
  return hasBasename(path, prefix) ? path.substr(prefix.length) : path;
};

var stripTrailingSlash = function stripTrailingSlash(path) {
  return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
};

var parsePath = function parsePath(path) {
  var pathname = path || '/';
  var search = '';
  var hash = '';

  var hashIndex = pathname.indexOf('#');
  if (hashIndex !== -1) {
    hash = pathname.substr(hashIndex);
    pathname = pathname.substr(0, hashIndex);
  }

  var searchIndex = pathname.indexOf('?');
  if (searchIndex !== -1) {
    search = pathname.substr(searchIndex);
    pathname = pathname.substr(0, searchIndex);
  }

  return {
    pathname: pathname,
    search: search === '?' ? '' : search,
    hash: hash === '#' ? '' : hash
  };
};

var createPath = function createPath(location) {
  var pathname = location.pathname,
      search = location.search,
      hash = location.hash;


  var path = pathname || '/';

  if (search && search !== '?') path += search.charAt(0) === '?' ? search : '?' + search;

  if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : '#' + hash;

  return path;
};

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = getPrototypeOf && getPrototypeOf(Object);

function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components

        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) {
                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
            }
        }

        var keys = getOwnPropertyNames(sourceComponent);

        if (getOwnPropertySymbols) {
            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try { // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }

        return targetComponent;
    }

    return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 161 */
/***/ (function(module, exports) {

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

module.exports = _interopRequireWildcard;

/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getDisplayName = __webpack_require__(455);

var _getDisplayName2 = _interopRequireDefault(_getDisplayName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var wrapDisplayName = function wrapDisplayName(BaseComponent, hocName) {
  return hocName + '(' + (0, _getDisplayName2.default)(BaseComponent) + ')';
};

exports.default = wrapDisplayName;

/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _createRule = __webpack_require__(214);

var _createRule2 = _interopRequireDefault(_createRule);

var _linkRule = __webpack_require__(460);

var _linkRule2 = _interopRequireDefault(_linkRule);

var _StyleRule = __webpack_require__(129);

var _StyleRule2 = _interopRequireDefault(_StyleRule);

var _escape = __webpack_require__(795);

var _escape2 = _interopRequireDefault(_escape);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Contains rules objects and allows adding/removing etc.
 * Is used for e.g. by `StyleSheet` or `ConditionalRule`.
 */
var RuleList = function () {

  // Original styles object.
  function RuleList(options) {
    var _this = this;

    _classCallCheck(this, RuleList);

    this.map = {};
    this.raw = {};
    this.index = [];

    this.update = function (name, data) {
      var _options = _this.options,
          plugins = _options.jss.plugins,
          sheet = _options.sheet;

      if (typeof name === 'string') {
        plugins.onUpdate(data, _this.get(name), sheet);
      } else {
        for (var index = 0; index < _this.index.length; index++) {
          plugins.onUpdate(name, _this.index[index], sheet);
        }
      }
    };

    this.options = options;
    this.classes = options.classes;
  }

  /**
   * Create and register rule.
   *
   * Will not render after Style Sheet was rendered the first time.
   */


  // Used to ensure correct rules order.

  // Rules registry for access by .get() method.
  // It contains the same rule registered by name and by selector.


  _createClass(RuleList, [{
    key: 'add',
    value: function add(name, decl, options) {
      var _options2 = this.options,
          parent = _options2.parent,
          sheet = _options2.sheet,
          jss = _options2.jss,
          Renderer = _options2.Renderer,
          generateClassName = _options2.generateClassName;


      options = _extends({
        classes: this.classes,
        parent: parent,
        sheet: sheet,
        jss: jss,
        Renderer: Renderer,
        generateClassName: generateClassName
      }, options);

      if (!options.selector && this.classes[name]) {
        options.selector = '.' + (0, _escape2['default'])(this.classes[name]);
      }

      this.raw[name] = decl;

      var rule = (0, _createRule2['default'])(name, decl, options);

      var className = void 0;

      if (!options.selector && rule instanceof _StyleRule2['default']) {
        className = generateClassName(rule, sheet);
        rule.selector = '.' + (0, _escape2['default'])(className);
      }

      this.register(rule, className);

      var index = options.index === undefined ? this.index.length : options.index;
      this.index.splice(index, 0, rule);

      return rule;
    }

    /**
     * Get a rule.
     */

  }, {
    key: 'get',
    value: function get(name) {
      return this.map[name];
    }

    /**
     * Delete a rule.
     */

  }, {
    key: 'remove',
    value: function remove(rule) {
      this.unregister(rule);
      this.index.splice(this.indexOf(rule), 1);
    }

    /**
     * Get index of a rule.
     */

  }, {
    key: 'indexOf',
    value: function indexOf(rule) {
      return this.index.indexOf(rule);
    }

    /**
     * Run `onProcessRule()` plugins on every rule.
     */

  }, {
    key: 'process',
    value: function process() {
      var plugins = this.options.jss.plugins;
      // We need to clone array because if we modify the index somewhere else during a loop
      // we end up with very hard-to-track-down side effects.

      this.index.slice(0).forEach(plugins.onProcessRule, plugins);
    }

    /**
     * Register a rule in `.map` and `.classes` maps.
     */

  }, {
    key: 'register',
    value: function register(rule, className) {
      this.map[rule.key] = rule;
      if (rule instanceof _StyleRule2['default']) {
        this.map[rule.selector] = rule;
        if (className) this.classes[rule.key] = className;
      }
    }

    /**
     * Unregister a rule.
     */

  }, {
    key: 'unregister',
    value: function unregister(rule) {
      delete this.map[rule.key];
      if (rule instanceof _StyleRule2['default']) {
        delete this.map[rule.selector];
        delete this.classes[rule.key];
      }
    }

    /**
     * Update the function values with a new data.
     */

  }, {
    key: 'link',


    /**
     * Link renderable rules with CSSRuleList.
     */
    value: function link(cssRules) {
      var map = this.options.sheet.renderer.getUnescapedKeysMap(this.index);

      for (var i = 0; i < cssRules.length; i++) {
        var cssRule = cssRules[i];
        var _key = this.options.sheet.renderer.getKey(cssRule);
        if (map[_key]) _key = map[_key];
        var rule = this.map[_key];
        if (rule) (0, _linkRule2['default'])(rule, cssRule);
      }
    }

    /**
     * Convert rules to a CSS string.
     */

  }, {
    key: 'toString',
    value: function toString(options) {
      var str = '';
      var sheet = this.options.sheet;

      var link = sheet ? sheet.options.link : false;

      for (var index = 0; index < this.index.length; index++) {
        var rule = this.index[index];
        var css = rule.toString(options);

        // No need to render an empty rule.
        if (!css && !link) continue;

        if (str) str += '\n';
        str += css;
      }

      return str;
    }
  }]);

  return RuleList;
}();

exports['default'] = RuleList;

/***/ }),
/* 164 */
/***/ (function(module, exports) {

module.exports = function(originalModule) {
	if(!originalModule.webpackPolyfill) {
		var module = Object.create(originalModule);
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		Object.defineProperty(module, "exports", {
			enumerable: true,
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createBreakpoints;
exports.keys = void 0;

var _objectSpread2 = _interopRequireDefault(__webpack_require__(23));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

// Sorted ASC by size. That's important.
// It can't be configured as it's used statically for propTypes.
var keys = ['xs', 'sm', 'md', 'lg', 'xl']; // Keep in mind that @media is inclusive by the CSS specification.

exports.keys = keys;

function createBreakpoints(breakpoints) {
  var _breakpoints$values = breakpoints.values,
      values = _breakpoints$values === void 0 ? {
    xs: 0,
    sm: 600,
    md: 960,
    lg: 1280,
    xl: 1920
  } : _breakpoints$values,
      _breakpoints$unit = breakpoints.unit,
      unit = _breakpoints$unit === void 0 ? 'px' : _breakpoints$unit,
      _breakpoints$step = breakpoints.step,
      step = _breakpoints$step === void 0 ? 5 : _breakpoints$step,
      other = (0, _objectWithoutProperties2.default)(breakpoints, ["values", "unit", "step"]);

  function up(key) {
    var value = typeof values[key] === 'number' ? values[key] : key;
    return "@media (min-width:".concat(value).concat(unit, ")");
  }

  function down(key) {
    var endIndex = keys.indexOf(key) + 1;
    var upperbound = values[keys[endIndex]];

    if (endIndex === keys.length) {
      // xl down applies to all sizes
      return up('xs');
    }

    var value = typeof upperbound === 'number' && endIndex > 0 ? upperbound : key;
    return "@media (max-width:".concat(value - step / 100).concat(unit, ")");
  }

  function between(start, end) {
    var endIndex = keys.indexOf(end) + 1;

    if (endIndex === keys.length) {
      return up(start);
    }

    return "@media (min-width:".concat(values[start]).concat(unit, ") and ") + "(max-width:".concat(values[keys[endIndex]] - step / 100).concat(unit, ")");
  }

  function only(key) {
    return between(key, key);
  }

  function width(key) {
    return values[key];
  }

  return (0, _objectSpread2.default)({
    keys: keys,
    values: values,
    up: up,
    down: down,
    between: between,
    only: only,
    width: width
  }, other);
}

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exactProp;
exports.specialProperty = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(11));

var _objectSpread3 = _interopRequireDefault(__webpack_require__(23));

// This module is based on https://github.com/airbnb/prop-types-exact repository.
// However, in order to reduce the number of dependencies and to remove some extra safe checks
// the module was forked.
var specialProperty = "exact-prop: \u200B";
exports.specialProperty = specialProperty;

function exactProp(propTypes, componentNameInError) {
  return (0, _objectSpread3.default)({}, propTypes, (0, _defineProperty2.default)({}, specialProperty, function (props) {
    var unknownProps = Object.keys(props).filter(function (prop) {
      return !propTypes.hasOwnProperty(prop);
    });

    if (unknownProps.length > 0) {
      return new TypeError("".concat(componentNameInError, ": unknown props found: ").concat(unknownProps.join(', '), ". Please remove the unknown properties."));
    }

    return null;
  }));
}

/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var _default = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _IconButton.default;
  }
});

var _IconButton = _interopRequireDefault(__webpack_require__(887));

/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(137);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Divider.default;
  }
});

var _Divider = _interopRequireDefault(__webpack_require__(974));

/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Input.default;
  }
});

var _Input = _interopRequireDefault(__webpack_require__(326));

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Tabs.default;
  }
});

var _Tabs = _interopRequireDefault(__webpack_require__(1071));

/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Tab.default;
  }
});

var _Tab = _interopRequireDefault(__webpack_require__(1079));

/***/ }),
/* 174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Snackbar__ = __webpack_require__(508);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Snackbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Snackbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_IconButton__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_IconButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_IconButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_icons_Close__ = __webpack_require__(515);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_icons_Close___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_icons_Close__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_assets_jss_material_dashboard_pro_react_components_snackbarContentStyle_jsx__ = __webpack_require__(1093);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}// @material-ui/core components
// @material-ui/icons
function Snackbar(_ref){var _cx2;var props=_objectWithoutProperties(_ref,[]);var classes=props.classes,message=props.message,color=props.color,close=props.close,icon=props.icon,place=props.place,open=props.open;var action=[];var messageClasses=__WEBPACK_IMPORTED_MODULE_2_classnames___default()(_defineProperty({},classes.iconMessage,icon!==undefined));if(close!==undefined){action=[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_IconButton___default.a,{className:classes.iconButton,key:"close","aria-label":"Close",color:"inherit",onClick:function onClick(){return props.closeNotification();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_icons_Close___default.a,{className:classes.close}))];}var iconClasses=__WEBPACK_IMPORTED_MODULE_2_classnames___default()((_cx2={},_defineProperty(_cx2,classes.icon,classes.icon),_defineProperty(_cx2,classes.infoIcon,color==="info"),_defineProperty(_cx2,classes.successIcon,color==="success"),_defineProperty(_cx2,classes.warningIcon,color==="warning"),_defineProperty(_cx2,classes.dangerIcon,color==="danger"),_defineProperty(_cx2,classes.primaryIcon,color==="primary"),_defineProperty(_cx2,classes.roseIcon,color==="rose"),_cx2));return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Snackbar___default.a,{classes:{anchorOriginTopCenter:classes.top20,anchorOriginTopRight:classes.top40,anchorOriginTopLeft:classes.top40},anchorOrigin:{vertical:place.indexOf("t")===-1?"bottom":"top",horizontal:place.indexOf("l")!==-1?"left":place.indexOf("c")!==-1?"center":"right"},open:open,message:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,icon!==undefined?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(props.icon,{className:iconClasses}):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:messageClasses},message)),action:action,ContentProps:{classes:{root:classes.root+" "+classes[color],message:classes.message}}});}Snackbar.defaultProps={color:"info"};Snackbar.propTypes={classes:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,message:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node.isRequired,color:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["info","success","warning","danger","primary","rose"]),close:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,icon:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,place:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["tl","tr","tc","br","bl","bc"]),open:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool};/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles___default()(__WEBPACK_IMPORTED_MODULE_7_assets_jss_material_dashboard_pro_react_components_snackbarContentStyle_jsx__["a" /* default */])(Snackbar));

/***/ }),
/* 175 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NetworkStatus; });
/* harmony export (immutable) */ __webpack_exports__["b"] = isNetworkRequestInFlight;
var NetworkStatus;
(function (NetworkStatus) {
    NetworkStatus[NetworkStatus["loading"] = 1] = "loading";
    NetworkStatus[NetworkStatus["setVariables"] = 2] = "setVariables";
    NetworkStatus[NetworkStatus["fetchMore"] = 3] = "fetchMore";
    NetworkStatus[NetworkStatus["refetch"] = 4] = "refetch";
    NetworkStatus[NetworkStatus["poll"] = 6] = "poll";
    NetworkStatus[NetworkStatus["ready"] = 7] = "ready";
    NetworkStatus[NetworkStatus["error"] = 8] = "error";
})(NetworkStatus || (NetworkStatus = {}));
function isNetworkRequestInFlight(networkStatus) {
    return networkStatus < 7;
}
//# sourceMappingURL=networkStatus.js.map

/***/ }),
/* 176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


var formatName = function formatName(_ref, name) {
  var sectionPrefix = _ref._reduxForm.sectionPrefix;
  return sectionPrefix ? sectionPrefix + '.' + name : name;
};


/* harmony default export */ __webpack_exports__["a"] = (formatName);

/***/ }),
/* 177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return createStore; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return combineReducers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return bindActionCreators; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return applyMiddleware; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return compose; });
/* unused harmony export __DO_NOT_USE__ActionTypes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_symbol_observable__ = __webpack_require__(301);


/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */
var randomString = function randomString() {
  return Math.random().toString(36).substring(7).split('').join('.');
};

var ActionTypes = {
  INIT: "@@redux/INIT" + randomString(),
  REPLACE: "@@redux/REPLACE" + randomString(),
  PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
    return "@@redux/PROBE_UNKNOWN_ACTION" + randomString();
  }
};

/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */
function isPlainObject(obj) {
  if (typeof obj !== 'object' || obj === null) return false;
  var proto = obj;

  while (Object.getPrototypeOf(proto) !== null) {
    proto = Object.getPrototypeOf(proto);
  }

  return Object.getPrototypeOf(obj) === proto;
}

/**
 * Creates a Redux store that holds the state tree.
 * The only way to change the data in the store is to call `dispatch()` on it.
 *
 * There should only be a single store in your app. To specify how different
 * parts of the state tree respond to actions, you may combine several reducers
 * into a single reducer function by using `combineReducers`.
 *
 * @param {Function} reducer A function that returns the next state tree, given
 * the current state tree and the action to handle.
 *
 * @param {any} [preloadedState] The initial state. You may optionally specify it
 * to hydrate the state from the server in universal apps, or to restore a
 * previously serialized user session.
 * If you use `combineReducers` to produce the root reducer function, this must be
 * an object with the same shape as `combineReducers` keys.
 *
 * @param {Function} [enhancer] The store enhancer. You may optionally specify it
 * to enhance the store with third-party capabilities such as middleware,
 * time travel, persistence, etc. The only store enhancer that ships with Redux
 * is `applyMiddleware()`.
 *
 * @returns {Store} A Redux store that lets you read the state, dispatch actions
 * and subscribe to changes.
 */

function createStore(reducer, preloadedState, enhancer) {
  var _ref2;

  if (typeof preloadedState === 'function' && typeof enhancer === 'function' || typeof enhancer === 'function' && typeof arguments[3] === 'function') {
    throw new Error('It looks like you are passing several store enhancers to ' + 'createStore(). This is not supported. Instead, compose them ' + 'together to a single function');
  }

  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
    enhancer = preloadedState;
    preloadedState = undefined;
  }

  if (typeof enhancer !== 'undefined') {
    if (typeof enhancer !== 'function') {
      throw new Error('Expected the enhancer to be a function.');
    }

    return enhancer(createStore)(reducer, preloadedState);
  }

  if (typeof reducer !== 'function') {
    throw new Error('Expected the reducer to be a function.');
  }

  var currentReducer = reducer;
  var currentState = preloadedState;
  var currentListeners = [];
  var nextListeners = currentListeners;
  var isDispatching = false;

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }
  /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */


  function getState() {
    if (isDispatching) {
      throw new Error('You may not call store.getState() while the reducer is executing. ' + 'The reducer has already received the state as an argument. ' + 'Pass it down from the top reducer instead of reading it from the store.');
    }

    return currentState;
  }
  /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */


  function subscribe(listener) {
    if (typeof listener !== 'function') {
      throw new Error('Expected the listener to be a function.');
    }

    if (isDispatching) {
      throw new Error('You may not call store.subscribe() while the reducer is executing. ' + 'If you would like to be notified after the store has been updated, subscribe from a ' + 'component and invoke store.getState() in the callback to access the latest state. ' + 'See https://redux.js.org/api-reference/store#subscribe(listener) for more details.');
    }

    var isSubscribed = true;
    ensureCanMutateNextListeners();
    nextListeners.push(listener);
    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }

      if (isDispatching) {
        throw new Error('You may not unsubscribe from a store listener while the reducer is executing. ' + 'See https://redux.js.org/api-reference/store#subscribe(listener) for more details.');
      }

      isSubscribed = false;
      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
    };
  }
  /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */


  function dispatch(action) {
    if (!isPlainObject(action)) {
      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
    }

    if (typeof action.type === 'undefined') {
      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
    }

    if (isDispatching) {
      throw new Error('Reducers may not dispatch actions.');
    }

    try {
      isDispatching = true;
      currentState = currentReducer(currentState, action);
    } finally {
      isDispatching = false;
    }

    var listeners = currentListeners = nextListeners;

    for (var i = 0; i < listeners.length; i++) {
      var listener = listeners[i];
      listener();
    }

    return action;
  }
  /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */


  function replaceReducer(nextReducer) {
    if (typeof nextReducer !== 'function') {
      throw new Error('Expected the nextReducer to be a function.');
    }

    currentReducer = nextReducer;
    dispatch({
      type: ActionTypes.REPLACE
    });
  }
  /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */


  function observable() {
    var _ref;

    var outerSubscribe = subscribe;
    return _ref = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function subscribe(observer) {
        if (typeof observer !== 'object' || observer === null) {
          throw new TypeError('Expected the observer to be an object.');
        }

        function observeState() {
          if (observer.next) {
            observer.next(getState());
          }
        }

        observeState();
        var unsubscribe = outerSubscribe(observeState);
        return {
          unsubscribe: unsubscribe
        };
      }
    }, _ref[__WEBPACK_IMPORTED_MODULE_0_symbol_observable__["default"]] = function () {
      return this;
    }, _ref;
  } // When a store is created, an "INIT" action is dispatched so that every
  // reducer returns their initial state. This effectively populates
  // the initial state tree.


  dispatch({
    type: ActionTypes.INIT
  });
  return _ref2 = {
    dispatch: dispatch,
    subscribe: subscribe,
    getState: getState,
    replaceReducer: replaceReducer
  }, _ref2[__WEBPACK_IMPORTED_MODULE_0_symbol_observable__["default"]] = observable, _ref2;
}

/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */


  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
  } catch (e) {} // eslint-disable-line no-empty

}

function getUndefinedStateErrorMessage(key, action) {
  var actionType = action && action.type;
  var actionDescription = actionType && "action \"" + String(actionType) + "\"" || 'an action';
  return "Given " + actionDescription + ", reducer \"" + key + "\" returned undefined. " + "To ignore an action, you must explicitly return the previous state. " + "If you want this reducer to hold no value, you can return null instead of undefined.";
}

function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
  var reducerKeys = Object.keys(reducers);
  var argumentName = action && action.type === ActionTypes.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';

  if (reducerKeys.length === 0) {
    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
  }

  if (!isPlainObject(inputState)) {
    return "The " + argumentName + " has unexpected type of \"" + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + "\". Expected argument to be an object with the following " + ("keys: \"" + reducerKeys.join('", "') + "\"");
  }

  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
  });
  unexpectedKeys.forEach(function (key) {
    unexpectedKeyCache[key] = true;
  });
  if (action && action.type === ActionTypes.REPLACE) return;

  if (unexpectedKeys.length > 0) {
    return "Unexpected " + (unexpectedKeys.length > 1 ? 'keys' : 'key') + " " + ("\"" + unexpectedKeys.join('", "') + "\" found in " + argumentName + ". ") + "Expected to find one of the known reducer keys instead: " + ("\"" + reducerKeys.join('", "') + "\". Unexpected keys will be ignored.");
  }
}

function assertReducerShape(reducers) {
  Object.keys(reducers).forEach(function (key) {
    var reducer = reducers[key];
    var initialState = reducer(undefined, {
      type: ActionTypes.INIT
    });

    if (typeof initialState === 'undefined') {
      throw new Error("Reducer \"" + key + "\" returned undefined during initialization. " + "If the state passed to the reducer is undefined, you must " + "explicitly return the initial state. The initial state may " + "not be undefined. If you don't want to set a value for this reducer, " + "you can use null instead of undefined.");
    }

    if (typeof reducer(undefined, {
      type: ActionTypes.PROBE_UNKNOWN_ACTION()
    }) === 'undefined') {
      throw new Error("Reducer \"" + key + "\" returned undefined when probed with a random type. " + ("Don't try to handle " + ActionTypes.INIT + " or other actions in \"redux/*\" ") + "namespace. They are considered private. Instead, you must return the " + "current state for any unknown actions, unless it is undefined, " + "in which case you must return the initial state, regardless of the " + "action type. The initial state may not be undefined, but can be null.");
    }
  });
}
/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */


function combineReducers(reducers) {
  var reducerKeys = Object.keys(reducers);
  var finalReducers = {};

  for (var i = 0; i < reducerKeys.length; i++) {
    var key = reducerKeys[i];

    if (false) {
      if (typeof reducers[key] === 'undefined') {
        warning("No reducer provided for key \"" + key + "\"");
      }
    }

    if (typeof reducers[key] === 'function') {
      finalReducers[key] = reducers[key];
    }
  }

  var finalReducerKeys = Object.keys(finalReducers);
  var unexpectedKeyCache;

  if (false) {
    unexpectedKeyCache = {};
  }

  var shapeAssertionError;

  try {
    assertReducerShape(finalReducers);
  } catch (e) {
    shapeAssertionError = e;
  }

  return function combination(state, action) {
    if (state === void 0) {
      state = {};
    }

    if (shapeAssertionError) {
      throw shapeAssertionError;
    }

    if (false) {
      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);

      if (warningMessage) {
        warning(warningMessage);
      }
    }

    var hasChanged = false;
    var nextState = {};

    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
      var _key = finalReducerKeys[_i];
      var reducer = finalReducers[_key];
      var previousStateForKey = state[_key];
      var nextStateForKey = reducer(previousStateForKey, action);

      if (typeof nextStateForKey === 'undefined') {
        var errorMessage = getUndefinedStateErrorMessage(_key, action);
        throw new Error(errorMessage);
      }

      nextState[_key] = nextStateForKey;
      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
    }

    return hasChanged ? nextState : state;
  };
}

function bindActionCreator(actionCreator, dispatch) {
  return function () {
    return dispatch(actionCreator.apply(this, arguments));
  };
}
/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass a single function as the first argument,
 * and get a function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */


function bindActionCreators(actionCreators, dispatch) {
  if (typeof actionCreators === 'function') {
    return bindActionCreator(actionCreators, dispatch);
  }

  if (typeof actionCreators !== 'object' || actionCreators === null) {
    throw new Error("bindActionCreators expected an object or a function, instead received " + (actionCreators === null ? 'null' : typeof actionCreators) + ". " + "Did you write \"import ActionCreators from\" instead of \"import * as ActionCreators from\"?");
  }

  var keys = Object.keys(actionCreators);
  var boundActionCreators = {};

  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    var actionCreator = actionCreators[key];

    if (typeof actionCreator === 'function') {
      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
    }
  }

  return boundActionCreators;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */
function compose() {
  for (var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(void 0, arguments));
    };
  });
}

/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */

function applyMiddleware() {
  for (var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  return function (createStore) {
    return function () {
      var store = createStore.apply(void 0, arguments);

      var _dispatch = function dispatch() {
        throw new Error("Dispatching while constructing your middleware is not allowed. " + "Other middleware would not be applied to this dispatch.");
      };

      var middlewareAPI = {
        getState: store.getState,
        dispatch: function dispatch() {
          return _dispatch.apply(void 0, arguments);
        }
      };
      var chain = middlewares.map(function (middleware) {
        return middleware(middlewareAPI);
      });
      _dispatch = compose.apply(void 0, chain)(store.dispatch);
      return _objectSpread({}, store, {
        dispatch: _dispatch
      });
    };
  };
}

/*
 * This is a dummy function to check if the function name has been altered by minification.
 * If the function has been minified and NODE_ENV !== 'production', warn the user.
 */

function isCrushed() {}

if (false) {
  warning('You are currently using minified code outside of NODE_ENV === "production". ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or setting mode to production in webpack (https://webpack.js.org/concepts/mode/) ' + 'to ensure you have the correct code for your production build.');
}




/***/ }),
/* 178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/* harmony default export */ __webpack_exports__["a"] = (eq);


/***/ }),
/* 179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isSymbol_js__ = __webpack_require__(232);


/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || Object(__WEBPACK_IMPORTED_MODULE_0__isSymbol_js__["a" /* default */])(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/* harmony default export */ __webpack_exports__["a"] = (toKey);


/***/ }),
/* 180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isFunction_js__ = __webpack_require__(349);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isLength_js__ = __webpack_require__(354);



/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && Object(__WEBPACK_IMPORTED_MODULE_1__isLength_js__["a" /* default */])(value.length) && !Object(__WEBPACK_IMPORTED_MODULE_0__isFunction_js__["a" /* default */])(value);
}

/* harmony default export */ __webpack_exports__["a"] = (isArrayLike);


/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var toJSON = __webpack_require__(182);

var Logging = {
  LOG_LEVELS: {
    fatal:  4,
    error:  3,
    warn:   2,
    info:   1,
    debug:  0
  },

  writeLog: function(messageArgs, level) {
    var logger = Logging.logger || (Logging.wrapper || Logging).logger;
    if (!logger) return;

    var args   = Array.prototype.slice.apply(messageArgs),
        banner = '[Faye',
        klass  = this.className,

        message = args.shift().replace(/\?/g, function() {
          try {
            return toJSON(args.shift());
          } catch (error) {
            return '[Object]';
          }
        });

    if (klass) banner += '.' + klass;
    banner += '] ';

    if (typeof logger[level] === 'function')
      logger[level](banner + message);
    else if (typeof logger === 'function')
      logger(banner + message);
  }
};

for (var key in Logging.LOG_LEVELS)
  (function(level) {
    Logging[level] = function() {
      this.writeLog(arguments, level);
    };
  })(key);

module.exports = Logging;


/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// http://assanka.net/content/tech/2009/09/02/json2-js-vs-prototype/

module.exports = function(object) {
  return JSON.stringify(object, function(key, value) {
    return (this[key] instanceof Array) ? this[key] : value;
  });
};


/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var Promise   = __webpack_require__(246);

module.exports = {
  then: function(callback, errback) {
    var self = this;
    if (!this._promise)
      this._promise = new Promise(function(resolve, reject) {
        self._resolve = resolve;
        self._reject  = reject;
      });

    if (arguments.length === 0)
      return this._promise;
    else
      return this._promise.then(callback, errback);
  },

  callback: function(callback, context) {
    return this.then(function(value) { callback.call(context, value) });
  },

  errback: function(callback, context) {
    return this.then(null, function(reason) { callback.call(context, reason) });
  },

  timeout: function(seconds, message) {
    this.then();
    var self = this;
    this._timer = global.setTimeout(function() {
      self._reject(message);
    }, seconds * 1000);
  },

  setDeferredStatus: function(status, value) {
    if (this._timer) global.clearTimeout(this._timer);

    this.then();

    if (status === 'succeeded')
      this._resolve(value);
    else if (status === 'failed')
      this._reject(value);
    else
      delete this._promise;
  }
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(26)))

/***/ }),
/* 184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_assets_jss_material_dashboard_pro_react_components_cardBodyStyle_jsx__ = __webpack_require__(2329);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}// nodejs library that concatenates classes
// nodejs library to set properties for components
// @material-ui/core components
// @material-ui/icons
// core components
function CardBody(_ref){var _classNames;var props=_objectWithoutProperties(_ref,[]);var classes=props.classes,className=props.className,children=props.children,background=props.background,plain=props.plain,formHorizontal=props.formHorizontal,pricing=props.pricing,signup=props.signup,color=props.color,profile=props.profile,calendar=props.calendar,rest=_objectWithoutProperties(props,["classes","className","children","background","plain","formHorizontal","pricing","signup","color","profile","calendar"]);var cardBodyClasses=__WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classNames={},_defineProperty(_classNames,classes.cardBody,true),_defineProperty(_classNames,classes.cardBodyBackground,background),_defineProperty(_classNames,classes.cardBodyPlain,plain),_defineProperty(_classNames,classes.cardBodyFormHorizontal,formHorizontal),_defineProperty(_classNames,classes.cardPricing,pricing),_defineProperty(_classNames,classes.cardSignup,signup),_defineProperty(_classNames,classes.cardBodyColor,color),_defineProperty(_classNames,classes.cardBodyProfile,profile),_defineProperty(_classNames,classes.cardBodyCalendar,calendar),_defineProperty(_classNames,className,className!==undefined),_classNames));return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",Object.assign({className:cardBodyClasses},rest),children);}CardBody.propTypes={classes:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,className:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,background:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,plain:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,formHorizontal:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,pricing:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,signup:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,color:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,profile:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,calendar:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool};/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles___default()(__WEBPACK_IMPORTED_MODULE_4_assets_jss_material_dashboard_pro_react_components_cardBodyStyle_jsx__["a" /* default */])(CardBody));

/***/ }),
/* 185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_assets_jss_material_dashboard_pro_react_components_cardHeaderStyle_jsx__ = __webpack_require__(2332);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}// nodejs library that concatenates classes
// nodejs library to set properties for components
// @material-ui/core components
// @material-ui/icons
// core components
function CardHeader(_ref){var _classNames;var props=_objectWithoutProperties(_ref,[]);var classes=props.classes,className=props.className,children=props.children,color=props.color,plain=props.plain,image=props.image,contact=props.contact,signup=props.signup,stats=props.stats,icon=props.icon,text=props.text,rest=_objectWithoutProperties(props,["classes","className","children","color","plain","image","contact","signup","stats","icon","text"]);var cardHeaderClasses=__WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classNames={},_defineProperty(_classNames,classes.cardHeader,true),_defineProperty(_classNames,classes[color+"CardHeader"],color),_defineProperty(_classNames,classes.cardHeaderPlain,plain),_defineProperty(_classNames,classes.cardHeaderImage,image),_defineProperty(_classNames,classes.cardHeaderContact,contact),_defineProperty(_classNames,classes.cardHeaderSignup,signup),_defineProperty(_classNames,classes.cardHeaderStats,stats),_defineProperty(_classNames,classes.cardHeaderIcon,icon),_defineProperty(_classNames,classes.cardHeaderText,text),_defineProperty(_classNames,className,className!==undefined),_classNames));return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",Object.assign({className:cardHeaderClasses},rest),children);}CardHeader.propTypes={classes:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,className:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,color:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(["warning","success","danger","info","primary","rose"]),plain:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,image:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,contact:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,signup:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,stats:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,icon:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,text:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool};/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles___default()(__WEBPACK_IMPORTED_MODULE_4_assets_jss_material_dashboard_pro_react_components_cardHeaderStyle_jsx__["a" /* default */])(CardHeader));

/***/ }),
/* 186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_styles_withStyles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_styles_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_styles_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid__);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}// @material-ui/core components
var style={grid:{margin:"0 -15px",width:"calc(100% + 30px)"// '&:before,&:after':{
//   display: 'table',
//   content: '" "',
// },
// '&:after':{
//   clear: 'both',
// }
}};function GridContainer(_ref){var props=_objectWithoutProperties(_ref,[]);var classes=props.classes,children=props.children,className=props.className,rest=_objectWithoutProperties(props,["classes","children","className"]);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,Object.assign({container:true},rest,{className:classes.grid+" "+className}),children);}/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1__material_ui_core_styles_withStyles___default()(style)(GridContainer));

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(594)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(597)('wks');
var uid = __webpack_require__(375);
var Symbol = __webpack_require__(112).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return withDefaultProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Calendar; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_recompose_defaultProps__ = __webpack_require__(2382);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_recompose_defaultProps___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_recompose_defaultProps__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_defaultDisplayOptions__ = __webpack_require__(2390);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_defaultDisplayOptions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__utils_defaultDisplayOptions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_defaultLocale__ = __webpack_require__(2391);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_defaultLocale___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__utils_defaultLocale__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_defaultTheme__ = __webpack_require__(2392);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_defaultTheme___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__utils_defaultTheme__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Today__ = __webpack_require__(2393);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Header__ = __webpack_require__(2394);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__MonthList__ = __webpack_require__(2407);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Weekdays__ = __webpack_require__(2409);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Years__ = __webpack_require__(2410);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Day__ = __webpack_require__(2411);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_date_fns_parse__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_date_fns_parse___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_date_fns_parse__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_date_fns_format__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_date_fns_format___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_date_fns_format__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_date_fns_start_of_day__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_date_fns_start_of_day___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_date_fns_start_of_day__);


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



















var styles = {
  container: {
    'root': 'Cal__Container__root',
    'landscape': 'Cal__Container__landscape',
    'wrapper': 'Cal__Container__wrapper',
    'listWrapper': 'Cal__Container__listWrapper'
  },
  day: {
    'root': 'Cal__Day__root',
    'enabled': 'Cal__Day__enabled',
    'highlighted': 'Cal__Day__highlighted',
    'today': 'Cal__Day__today',
    'disabled': 'Cal__Day__disabled',
    'selected': 'Cal__Day__selected',
    'month': 'Cal__Day__month',
    'year': 'Cal__Day__year',
    'selection': 'Cal__Day__selection',
    'day': 'Cal__Day__day',
    'range': 'Cal__Day__range',
    'start': 'Cal__Day__start',
    'end': 'Cal__Day__end',
    'betweenRange': 'Cal__Day__betweenRange'
  }
};

var withDefaultProps = __WEBPACK_IMPORTED_MODULE_0_recompose_defaultProps___default()({
  autoFocus: true,
  DayComponent: __WEBPACK_IMPORTED_MODULE_13__Day__["a" /* default */],
  display: 'days',
  displayOptions: {},
  HeaderComponent: __WEBPACK_IMPORTED_MODULE_9__Header__["a" /* default */],
  height: 500,
  keyboardSupport: true,
  max: new Date(2050, 11, 31),
  maxDate: new Date(2050, 11, 31),
  min: new Date(1980, 0, 1),
  minDate: new Date(1980, 0, 1),
  onHighlightedDateChange: __WEBPACK_IMPORTED_MODULE_4__utils__["d" /* emptyFn */],
  onScroll: __WEBPACK_IMPORTED_MODULE_4__utils__["d" /* emptyFn */],
  onScrollEnd: __WEBPACK_IMPORTED_MODULE_4__utils__["d" /* emptyFn */],
  onSelect: __WEBPACK_IMPORTED_MODULE_4__utils__["d" /* emptyFn */],
  passThrough: {},
  rowHeight: 56,
  tabIndex: 1,
  width: 400,
  YearsComponent: __WEBPACK_IMPORTED_MODULE_12__Years__["a" /* default */]
});

var Calendar = function (_Component) {
  _inherits(Calendar, _Component);

  function Calendar(props) {
    _classCallCheck(this, Calendar);

    var _this = _possibleConstructorReturn(this, _Component.apply(this, arguments));

    _this._displayOptions = {};
    _this._locale = {};
    _this._theme = {};

    _this.getCurrentOffset = function () {
      return _this.scrollTop;
    };

    _this.getDateOffset = function (date) {
      return _this._MonthList && _this._MonthList.getDateOffset(date);
    };

    _this.scrollTo = function (offset) {
      return _this._MonthList && _this._MonthList.scrollTo(offset);
    };

    _this.scrollToDate = function () {
      var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Date();
      var offset = arguments[1];
      var shouldAnimate = arguments[2];
      var display = _this.props.display;


      return _this._MonthList && _this._MonthList.scrollToDate(date, offset, shouldAnimate && display === 'days', function () {
        return _this.setState({ isScrolling: false });
      });
    };

    _this.getScrollSpeed = new __WEBPACK_IMPORTED_MODULE_4__utils__["a" /* ScrollSpeed */]().getScrollSpeed;

    _this.handleScroll = function (scrollTop, e) {
      var _this$props = _this.props,
          onScroll = _this$props.onScroll,
          rowHeight = _this$props.rowHeight;
      var isScrolling = _this.state.isScrolling;

      var _this$getDisplayOptio = _this.getDisplayOptions(),
          showTodayHelper = _this$getDisplayOptio.showTodayHelper,
          showOverlay = _this$getDisplayOptio.showOverlay;

      var scrollSpeed = _this.scrollSpeed = Math.abs(_this.getScrollSpeed(scrollTop));
      _this.scrollTop = scrollTop;

      // We only want to display the months overlay if the user is rapidly scrolling
      if (showOverlay && scrollSpeed > rowHeight && !isScrolling) {
        _this.setState({
          isScrolling: true
        });
      }

      if (showTodayHelper) {
        _this.updateTodayHelperPosition(scrollSpeed);
      }

      onScroll(scrollTop, e);
      _this.handleScrollEnd();
    };

    _this.handleScrollEnd = Object(__WEBPACK_IMPORTED_MODULE_4__utils__["c" /* debounce */])(function () {
      var onScrollEnd = _this.props.onScrollEnd;
      var isScrolling = _this.state.isScrolling;

      var _this$getDisplayOptio2 = _this.getDisplayOptions(),
          showTodayHelper = _this$getDisplayOptio2.showTodayHelper;

      if (isScrolling) {
        _this.setState({ isScrolling: false });
      }

      if (showTodayHelper) {
        _this.updateTodayHelperPosition(0);
      }

      onScrollEnd(_this.scrollTop);
    }, 150);

    _this.updateTodayHelperPosition = function (scrollSpeed) {
      var today = _this.today;
      var scrollTop = _this.scrollTop;
      var showToday = _this.state.showToday;
      var _this$props2 = _this.props,
          height = _this$props2.height,
          rowHeight = _this$props2.rowHeight;

      var _this$getDisplayOptio3 = _this.getDisplayOptions(),
          todayHelperRowOffset = _this$getDisplayOptio3.todayHelperRowOffset;

      var newState = void 0;

      if (!_this._todayOffset) {
        _this._todayOffset = _this.getDateOffset(today);
      }

      // Today is above the fold
      if (scrollTop >= _this._todayOffset + (height - rowHeight) / 2 + rowHeight * todayHelperRowOffset) {
        if (showToday !== __WEBPACK_IMPORTED_MODULE_8__Today__["b" /* DIRECTION_UP */]) newState = __WEBPACK_IMPORTED_MODULE_8__Today__["b" /* DIRECTION_UP */];
      }
      // Today is below the fold
      else if (scrollTop <= _this._todayOffset - height / 2 - rowHeight * (todayHelperRowOffset + 1)) {
          if (showToday !== __WEBPACK_IMPORTED_MODULE_8__Today__["a" /* DIRECTION_DOWN */]) newState = __WEBPACK_IMPORTED_MODULE_8__Today__["a" /* DIRECTION_DOWN */];
        } else if (showToday && scrollSpeed <= 1) {
          newState = false;
        }

      if (scrollTop === 0) {
        newState = false;
      }

      if (newState != null) {
        _this.setState({ showToday: newState });
      }
    };

    _this.setDisplay = function (display) {
      _this.setState({ display: display });
    };

    _this.updateYears(props);

    _this.state = {
      display: props.display
    };
    return _this;
  }

  Calendar.prototype.componentDidMount = function componentDidMount() {
    var autoFocus = this.props.autoFocus;


    if (autoFocus) {
      this.node.focus();
    }
  };

  Calendar.prototype.componentWillUpdate = function componentWillUpdate(nextProps, nextState) {
    var _props = this.props,
        min = _props.min,
        minDate = _props.minDate,
        max = _props.max,
        maxDate = _props.maxDate;


    if (nextProps.min !== min || nextProps.minDate !== minDate || nextProps.max !== max || nextProps.maxDate !== maxDate) {
      this.updateYears(nextProps);
    }

    if (nextProps.display !== this.props.display) {
      this.setState({ display: nextProps.display });
    }
  };

  Calendar.prototype.updateYears = function updateYears() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;

    this._min = __WEBPACK_IMPORTED_MODULE_14_date_fns_parse___default()(props.min);
    this._max = __WEBPACK_IMPORTED_MODULE_14_date_fns_parse___default()(props.max);
    this._minDate = __WEBPACK_IMPORTED_MODULE_14_date_fns_parse___default()(props.minDate);
    this._maxDate = __WEBPACK_IMPORTED_MODULE_14_date_fns_parse___default()(props.maxDate);

    var min = this._min.getFullYear();
    var minMonth = this._min.getMonth();
    var max = this._max.getFullYear();
    var maxMonth = this._max.getMonth();

    var months = [];
    var year = void 0,
        month = void 0;
    for (year = min; year <= max; year++) {
      for (month = 0; month < 12; month++) {
        if (year === min && month < minMonth || year === max && month > maxMonth) {
          continue;
        }

        months.push({ month: month, year: year });
      }
    }

    this.months = months;
  };

  Calendar.prototype.getDisabledDates = function getDisabledDates(disabledDates) {
    return disabledDates && disabledDates.map(function (date) {
      return __WEBPACK_IMPORTED_MODULE_15_date_fns_format___default()(__WEBPACK_IMPORTED_MODULE_14_date_fns_parse___default()(date), 'YYYY-MM-DD');
    });
  };

  Calendar.prototype.getDisplayOptions = function getDisplayOptions() {
    var displayOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props.displayOptions;

    return Object.assign(this._displayOptions, __WEBPACK_IMPORTED_MODULE_5__utils_defaultDisplayOptions___default.a, displayOptions);
  };

  Calendar.prototype.getLocale = function getLocale() {
    return Object.assign(this._locale, __WEBPACK_IMPORTED_MODULE_6__utils_defaultLocale___default.a, this.props.locale);
  };

  Calendar.prototype.getTheme = function getTheme() {
    return Object.assign(this._theme, __WEBPACK_IMPORTED_MODULE_7__utils_defaultTheme___default.a, this.props.theme);
  };

  Calendar.prototype.render = function render() {
    var _classNames,
        _this2 = this;

    var _props2 = this.props,
        className = _props2.className,
        passThrough = _props2.passThrough,
        DayComponent = _props2.DayComponent,
        disabledDays = _props2.disabledDays,
        displayDate = _props2.displayDate,
        height = _props2.height,
        HeaderComponent = _props2.HeaderComponent,
        rowHeight = _props2.rowHeight,
        scrollDate = _props2.scrollDate,
        selected = _props2.selected,
        tabIndex = _props2.tabIndex,
        width = _props2.width,
        YearsComponent = _props2.YearsComponent;

    var _getDisplayOptions = this.getDisplayOptions(),
        hideYearsOnSelect = _getDisplayOptions.hideYearsOnSelect,
        layout = _getDisplayOptions.layout,
        overscanMonthCount = _getDisplayOptions.overscanMonthCount,
        shouldHeaderAnimate = _getDisplayOptions.shouldHeaderAnimate,
        showHeader = _getDisplayOptions.showHeader,
        showMonthsForYears = _getDisplayOptions.showMonthsForYears,
        showOverlay = _getDisplayOptions.showOverlay,
        showTodayHelper = _getDisplayOptions.showTodayHelper,
        showWeekdays = _getDisplayOptions.showWeekdays;

    var _state = this.state,
        display = _state.display,
        isScrolling = _state.isScrolling,
        showToday = _state.showToday;

    var disabledDates = this.getDisabledDates(this.props.disabledDates);
    var locale = this.getLocale();
    var theme = this.getTheme();
    var today = this.today = __WEBPACK_IMPORTED_MODULE_16_date_fns_start_of_day___default()(new Date());

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      'div',
      _extends({
        tabIndex: tabIndex,
        className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, styles.container.root, (_classNames = {}, _classNames[styles.container.landscape] = layout === 'landscape', _classNames)),
        style: { color: theme.textColor.default, width: width },
        'aria-label': 'Calendar',
        ref: function ref(node) {
          _this2.node = node;
        }
      }, passThrough.rootNode),
      showHeader && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(HeaderComponent, _extends({
        selected: selected,
        shouldAnimate: Boolean(shouldHeaderAnimate && display !== 'years'),
        layout: layout,
        theme: theme,
        locale: locale,
        scrollToDate: this.scrollToDate,
        setDisplay: this.setDisplay,
        dateFormat: locale.headerFormat,
        display: display,
        displayDate: displayDate
      }, passThrough.Header)),
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: styles.container.wrapper },
        showWeekdays && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Weekdays__["a" /* default */], { weekdays: locale.weekdays, weekStartsOn: locale.weekStartsOn, theme: theme }),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: styles.container.listWrapper },
          showTodayHelper && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Today__["c" /* default */], {
            scrollToDate: this.scrollToDate,
            show: showToday,
            today: today,
            theme: theme,
            todayLabel: locale.todayLabel.long
          }),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__MonthList__["a" /* default */], {
            ref: function ref(instance) {
              _this2._MonthList = instance;
            },
            DayComponent: DayComponent,
            disabledDates: disabledDates,
            disabledDays: disabledDays,
            height: height,
            isScrolling: isScrolling,
            locale: locale,
            maxDate: this._maxDate,
            min: this._min,
            minDate: this._minDate,
            months: this.months,
            onScroll: this.handleScroll,
            overscanMonthCount: overscanMonthCount,
            passThrough: passThrough,
            theme: theme,
            today: today,
            rowHeight: rowHeight,
            selected: selected,
            scrollDate: scrollDate,
            showOverlay: showOverlay,
            width: width
          })
        ),
        display === 'years' && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(YearsComponent, _extends({
          ref: function ref(instance) {
            _this2._Years = instance;
          },
          height: height,
          hideOnSelect: hideYearsOnSelect,
          locale: locale,
          max: this._max,
          maxDate: this._maxDate,
          min: this._min,
          minDate: this._minDate,
          scrollToDate: this.scrollToDate,
          selected: selected,
          setDisplay: this.setDisplay,
          showMonths: showMonthsForYears,
          theme: theme,
          today: today,
          width: width,
          years: Object(__WEBPACK_IMPORTED_MODULE_4__utils__["k" /* range */])(this._min.getFullYear(), this._max.getFullYear() + 1)
        }, passThrough.Years))
      )
    );
  };

  return Calendar;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);


 false ? Calendar.propTypes = {
  autoFocus: PropTypes.bool,
  className: PropTypes.string,
  DayComponent: PropTypes.func,
  disabledDates: PropTypes.arrayOf(PropTypes.instanceOf(Date)),
  disabledDays: PropTypes.arrayOf(PropTypes.number),
  display: PropTypes.oneOf(['years', 'days']),
  displayOptions: PropTypes.shape({
    hideYearsOnSelect: PropTypes.bool,
    layout: PropTypes.oneOf(['portrait', 'landscape']),
    overscanMonthCount: PropTypes.number,
    shouldHeaderAnimate: PropTypes.bool,
    showHeader: PropTypes.bool,
    showMonthsForYears: PropTypes.bool,
    showOverlay: PropTypes.bool,
    showTodayHelper: PropTypes.bool,
    showWeekdays: PropTypes.bool,
    todayHelperRowOffset: PropTypes.number
  }),
  height: PropTypes.number,
  keyboardSupport: PropTypes.bool,
  locale: PropTypes.shape({
    blank: PropTypes.string,
    headerFormat: PropTypes.string,
    todayLabel: PropTypes.shape({
      long: PropTypes.string,
      short: PropTypes.string
    }),
    weekdays: PropTypes.arrayOf(PropTypes.string),
    weekStartsOn: PropTypes.oneOf([0, 1, 2, 3, 4, 5, 6])
  }),
  max: PropTypes.instanceOf(Date),
  maxDate: PropTypes.instanceOf(Date),
  min: PropTypes.instanceOf(Date),
  minDate: PropTypes.instanceOf(Date),
  onScroll: PropTypes.func,
  onScrollEnd: PropTypes.func,
  onSelect: PropTypes.func,
  rowHeight: PropTypes.number,
  tabIndex: PropTypes.number,
  theme: PropTypes.shape({
    floatingNav: PropTypes.shape({
      background: PropTypes.string,
      chevron: PropTypes.string,
      color: PropTypes.string
    }),
    headerColor: PropTypes.string,
    selectionColor: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
    textColor: PropTypes.shape({
      active: PropTypes.string,
      default: PropTypes.string
    }),
    todayColor: PropTypes.string,
    weekdayColor: PropTypes.string
  }),
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  YearsComponent: PropTypes.func
} : void 0;
;

/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _createEagerElementUtil = __webpack_require__(2383);

var _createEagerElementUtil2 = _interopRequireDefault(_createEagerElementUtil);

var _isReferentiallyTransparentFunctionComponent = __webpack_require__(2384);

var _isReferentiallyTransparentFunctionComponent2 = _interopRequireDefault(_isReferentiallyTransparentFunctionComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createFactory = function createFactory(type) {
  var isReferentiallyTransparent = (0, _isReferentiallyTransparentFunctionComponent2.default)(type);
  return function (p, c) {
    return (0, _createEagerElementUtil2.default)(false, isReferentiallyTransparent, type, p, c);
  };
};

exports.default = createFactory;

/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(9)

/**
 * @category Common Helpers
 * @summary Is the first date before the second one?
 *
 * @description
 * Is the first date before the second one?
 *
 * @param {Date|String|Number} date - the date that should be before the other one to return true
 * @param {Date|String|Number} dateToCompare - the date to compare with
 * @returns {Boolean} the first date is before the second date
 *
 * @example
 * // Is 10 July 1989 before 11 February 1987?
 * var result = isBefore(new Date(1989, 6, 10), new Date(1987, 1, 11))
 * //=> false
 */
function isBefore (dirtyDate, dirtyDateToCompare) {
  var date = parse(dirtyDate)
  var dateToCompare = parse(dirtyDateToCompare)
  return date.getTime() < dateToCompare.getTime()
}

module.exports = isBefore


/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

var getISOYear = __webpack_require__(114)
var startOfISOWeek = __webpack_require__(113)

/**
 * @category ISO Week-Numbering Year Helpers
 * @summary Return the start of an ISO week-numbering year for the given date.
 *
 * @description
 * Return the start of an ISO week-numbering year,
 * which always starts 3 days before the year's first Thursday.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the start of an ISO year
 *
 * @example
 * // The start of an ISO week-numbering year for 2 July 2005:
 * var result = startOfISOYear(new Date(2005, 6, 2))
 * //=> Mon Jan 03 2005 00:00:00
 */
function startOfISOYear (dirtyDate) {
  var year = getISOYear(dirtyDate)
  var fourthOfJanuary = new Date(0)
  fourthOfJanuary.setFullYear(year, 0, 4)
  fourthOfJanuary.setHours(0, 0, 0, 0)
  var date = startOfISOWeek(fourthOfJanuary)
  return date
}

module.exports = startOfISOYear


/***/ }),
/* 193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return idNumberValid; });
function idMethod(idNum){try{// SA ID Number have to be 13 digits, so check the length
if(idNum.length!==13||isNaN(idNum)){return"error";}// apply Luhn formula for check-digits
var initTotal=0;var checkSum=0;var multiplier=1;for(var i=0;i<13;++i){initTotal=parseInt(idNum.charAt(i),10)*multiplier;if(initTotal>9){initTotal=parseInt(initTotal.toString().charAt(0),10)+parseInt(initTotal.toString().charAt(1),10);}checkSum=checkSum+initTotal;multiplier=multiplier%2===0?1:2;}if(checkSum%10!==0){return"error";}var year=idNum.substring(0,2);var yDif=(new Date().getFullYear()-14).toString().substring(2,4);if(parseInt(year,10)>yDif){year="19"+year;}else{year="20"+year;}//get date of birth from id
var initDate=new Date(year,idNum.substring(2,4)-1,idNum.substring(4,6));var dob=formattedDate(initDate);// get Gender from id number
var genderCode=idNum.substring(6,10);var gender=parseInt(genderCode,10)<5000?"F":"M";return{gender:gender,dob:dob};}catch(error){console.log(error);return"error";}}function formattedDate(date){var mm=date.getMonth()+1;// getMonth() is zero-based
var dd=date.getDate();return[(dd>9?"":"0")+dd,(mm>9?"":"0")+mm,date.getFullYear()].join("/");}var isEmptyOrSpaces=function isEmptyOrSpaces(str){return str===undefined||str===null||str.toString().match(/^ *$/)!==null;};var idNumberValid=function idNumberValid(value){if(!value){return undefined;}if(isEmptyOrSpaces(value)){return undefined;}if(isNaN(Number(value))){return"Must be a number";}if(value.length!==13){return"Id number too short";}var x=idMethod(value);if(x==="error"){return"Invalid Id";}return undefined;};/* harmony default export */ __webpack_exports__["a"] = (idMethod);

/***/ }),
/* 194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_core__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var EmptyBody=function EmptyBody(props){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{colSpan:props.colSpan,style:{textAlign:"center",border:"0px",width:"100%"}},props.placeHolder)),[].concat(_toConsumableArray(Array(props.rowSpan-1))).map(function(a,i){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],{key:i});}));};/* harmony default export */ __webpack_exports__["a"] = (EmptyBody);

/***/ }),
/* 195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core__ = __webpack_require__(4);
var CustomChip=function CustomChip(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:Object.assign({width:props.width?props.width:"100%",textAlign:"center"},props.style)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["i" /* Chip */],{avatar:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["b" /* Avatar */],{style:props.avatarStyle?Object.assign({},props.avatarStyle):{backgroundColor:"#6c5cab",color:"white"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["w" /* Icon */],null,props.icon)),className:"customChip",variant:"outlined",label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["Z" /* Typography */],{style:props.textStyle?Object.assign({},props.textStyle):{color:"white"}},props.text),color:"secondary",style:props.chipStyle?Object.assign({},props.chipStyle):{backgroundColor:"#4239d659",color:"white"},onClick:props.clicked}));};/* harmony default export */ __webpack_exports__["a"] = (CustomChip);

/***/ }),
/* 196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AssistantBrokers; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_graphql_tag__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_graphql_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_graphql_tag__);
var _templateObject=_taggedTemplateLiteral(["\n  query assistantBrokers($userId: String!,$token:String!,$statuses: [Int]!) {\n    AssistantBrokers(userId:$userId,token:$token,statuses: $statuses){\n      su_ID,\n      su_name,\n      su_surname,\n      su_email,\n      ab_Id,\n      status\n    }\n  }\n"],["\n  query assistantBrokers($userId: String!,$token:String!,$statuses: [Int]!) {\n    AssistantBrokers(userId:$userId,token:$token,statuses: $statuses){\n      su_ID,\n      su_name,\n      su_surname,\n      su_email,\n      ab_Id,\n      status\n    }\n  }\n"]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var AssistantBrokers=__WEBPACK_IMPORTED_MODULE_0_graphql_tag___default()(_templateObject);

/***/ }),
/* 197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FnaResults; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FnaById; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return GetFnaHistory; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_graphql_tag__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_graphql_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_graphql_tag__);
var _templateObject=_taggedTemplateLiteral(["\n  query fnaResults($fnaId: String!, $token: String!) {\n    FnaResults(fnaId: $fnaId, token: $token) {\n      FnaResultObj\n      FnaDetails\n    }\n  }\n"],["\n  query fnaResults($fnaId: String!, $token: String!) {\n    FnaResults(fnaId: $fnaId, token: $token) {\n      FnaResultObj\n      FnaDetails\n    }\n  }\n"]),_templateObject2=_taggedTemplateLiteral(["\n  query fnaById($clientId: String!, $fnaId: Int) {\n    FnaById(clientId: $clientId, fnaId: $fnaId) {\n      form_data\n      editMode\n    }\n  }\n"],["\n  query fnaById($clientId: String!, $fnaId: Int) {\n    FnaById(clientId: $clientId, fnaId: $fnaId) {\n      form_data\n      editMode\n    }\n  }\n"]),_templateObject3=_taggedTemplateLiteral(["\n  query fnaHistory(\n    $brokerId: String!\n    $token: String!\n    $limit: Int!\n    $page: Int!\n    $orderBy: String\n    $direction: String\n    $search: String\n    $clientId: String\n  ) {\n    FnaHistory(\n      brokerId: $brokerId\n      token: $token\n      limit: $limit\n      page: $page\n      orderBy: $orderBy\n      direction: $direction\n      search: $search\n      clientId: $clientId\n    ) {\n      Count\n      Results {\n        id\n        description\n        date_created\n        clientFullName\n        client_id\n      }\n    }\n  }\n"],["\n  query fnaHistory(\n    $brokerId: String!\n    $token: String!\n    $limit: Int!\n    $page: Int!\n    $orderBy: String\n    $direction: String\n    $search: String\n    $clientId: String\n  ) {\n    FnaHistory(\n      brokerId: $brokerId\n      token: $token\n      limit: $limit\n      page: $page\n      orderBy: $orderBy\n      direction: $direction\n      search: $search\n      clientId: $clientId\n    ) {\n      Count\n      Results {\n        id\n        description\n        date_created\n        clientFullName\n        client_id\n      }\n    }\n  }\n"]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var FnaResults=__WEBPACK_IMPORTED_MODULE_0_graphql_tag___default()(_templateObject);var FnaById=__WEBPACK_IMPORTED_MODULE_0_graphql_tag___default()(_templateObject2);var GetFnaHistory=__WEBPACK_IMPORTED_MODULE_0_graphql_tag___default()(_templateObject3);

/***/ }),
/* 198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shapes__ = __webpack_require__(637);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__shapes__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__shapes__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_0__shapes__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_0__shapes__["d"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_0__shapes__["e"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_0__shapes__["f"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__alignment__ = __webpack_require__(2546);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__gradients__ = __webpack_require__(2554);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__gradients__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_2__gradients__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_2__gradients__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__animations__ = __webpack_require__(2557);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__parsing_path_parser__ = __webpack_require__(656);
/* unused harmony reexport PathParser */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__core_surface__ = __webpack_require__(409);
/* unused harmony reexport Surface */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__core_base_node__ = __webpack_require__(203);
/* unused harmony reexport BaseNode */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__core_surface_factory__ = __webpack_require__(281);
/* unused harmony reexport SurfaceFactory */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__core_options_store__ = __webpack_require__(399);
/* unused harmony reexport OptionsStore */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__svg__ = __webpack_require__(2560);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__canvas__ = __webpack_require__(2569);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__util__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__canvas_export_image__ = __webpack_require__(2577);
/* unused harmony reexport exportImage */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__svg_export_svg__ = __webpack_require__(2578);
/* unused harmony reexport exportSVG */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__search_quad_node__ = __webpack_require__(681);
/* unused harmony reexport QuadNode */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__search_shapes_quad_tree__ = __webpack_require__(679);
/* unused harmony reexport ShapesQuadTree */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__mixins_observers_mixin__ = __webpack_require__(55);
/* unused harmony reexport ObserversMixin */
/* unused harmony reexport svg */
/* unused harmony reexport canvas */
/* unused harmony reexport util */

























/***/ }),
/* 199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = defined;
var UNDEFINED = "undefined";

function defined(value) {
    return typeof value !== UNDEFINED;
}

/***/ }),
/* 200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__(22);



var Matrix = (function (Class) {
    function Matrix(a, b, c, d, e, f) {
        if ( a === void 0 ) a = 0;
        if ( b === void 0 ) b = 0;
        if ( c === void 0 ) c = 0;
        if ( d === void 0 ) d = 0;
        if ( e === void 0 ) e = 0;
        if ( f === void 0 ) f = 0;

        Class.call(this);

        this.a = a;
        this.b = b;
        this.c = c;
        this.d = d;
        this.e = e;
        this.f = f;
    }

    if ( Class ) Matrix.__proto__ = Class;
    Matrix.prototype = Object.create( Class && Class.prototype );
    Matrix.prototype.constructor = Matrix;

    Matrix.prototype.multiplyCopy = function multiplyCopy (matrix) {
        return new Matrix(
            this.a * matrix.a + this.c * matrix.b,
            this.b * matrix.a + this.d * matrix.b,
            this.a * matrix.c + this.c * matrix.d,
            this.b * matrix.c + this.d * matrix.d,
            this.a * matrix.e + this.c * matrix.f + this.e,
            this.b * matrix.e + this.d * matrix.f + this.f
        );
    };

    Matrix.prototype.invert = function invert () {
        var ref = this;
        var a = ref.a;
        var b = ref.b;
        var d = ref.c;
        var e = ref.d;
        var g = ref.e;
        var h = ref.f;
        var det = a * e - b * d;

        if (det === 0) {
            return null;
        }

        return new Matrix(e / det, -b / det, -d / det, a / det,
                          (d * h - e * g) / det, (b * g - a * h) / det);
    };

    Matrix.prototype.clone = function clone () {
        return new Matrix(this.a, this.b, this.c, this.d, this.e, this.f);
    };

    Matrix.prototype.equals = function equals (other) {
        if (!other) {
            return false;
        }

        return this.a === other.a && this.b === other.b &&
               this.c === other.c && this.d === other.d &&
               this.e === other.e && this.f === other.f;
    };

    Matrix.prototype.round = function round$1 (precision) {
        this.a = Object(__WEBPACK_IMPORTED_MODULE_1__util__["w" /* round */])(this.a, precision);
        this.b = Object(__WEBPACK_IMPORTED_MODULE_1__util__["w" /* round */])(this.b, precision);
        this.c = Object(__WEBPACK_IMPORTED_MODULE_1__util__["w" /* round */])(this.c, precision);
        this.d = Object(__WEBPACK_IMPORTED_MODULE_1__util__["w" /* round */])(this.d, precision);
        this.e = Object(__WEBPACK_IMPORTED_MODULE_1__util__["w" /* round */])(this.e, precision);
        this.f = Object(__WEBPACK_IMPORTED_MODULE_1__util__["w" /* round */])(this.f, precision);

        return this;
    };

    Matrix.prototype.toArray = function toArray (precision) {
        var result = [ this.a, this.b, this.c, this.d, this.e, this.f ];

        if (Object(__WEBPACK_IMPORTED_MODULE_1__util__["g" /* defined */])(precision)) {
            for (var i = 0; i < result.length; i++) {
                result[i] = Object(__WEBPACK_IMPORTED_MODULE_1__util__["w" /* round */])(result[i], precision);
            }
        }

        return result;
    };

    Matrix.prototype.toString = function toString (precision, separator) {
        if ( separator === void 0 ) separator = ",";

        return this.toArray(precision).join(separator);
    };

    Matrix.translate = function translate (x, y) {
        return new Matrix(1, 0, 0, 1, x, y);
    };

    Matrix.unit = function unit () {
        return new Matrix(1, 0, 0, 1, 0, 0);
    };

    Matrix.rotate = function rotate (angle, x, y) {
        var matrix = new Matrix();
        matrix.a = Math.cos(Object(__WEBPACK_IMPORTED_MODULE_1__util__["v" /* rad */])(angle));
        matrix.b = Math.sin(Object(__WEBPACK_IMPORTED_MODULE_1__util__["v" /* rad */])(angle));
        matrix.c = -matrix.b;
        matrix.d = matrix.a;
        matrix.e = (x - x * matrix.a + y * matrix.b) || 0;
        matrix.f = (y - y * matrix.a - x * matrix.b) || 0;

        return matrix;
    };

    Matrix.scale = function scale (scaleX, scaleY) {
        return new Matrix(scaleX, 0, 0, scaleY, 0, 0);
    };

    return Matrix;
}(__WEBPACK_IMPORTED_MODULE_0__common__["a" /* Class */]));

Matrix.IDENTITY = Matrix.unit();

/* harmony default export */ __webpack_exports__["a"] = (Matrix);

/***/ }),
/* 201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__geometry_matrix__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__geometry_to_matrix__ = __webpack_require__(119);



var IDENTITY_MATRIX_HASH = __WEBPACK_IMPORTED_MODULE_0__geometry_matrix__["a" /* default */].IDENTITY.toString();

var Measurable = {
    extend: function(proto) {
        proto.bbox = this.bbox;
        proto.geometryChange = this.geometryChange;
    },

    bbox: function(transformation) {
        var combinedMatrix = Object(__WEBPACK_IMPORTED_MODULE_1__geometry_to_matrix__["a" /* default */])(this.currentTransform(transformation));
        var matrixHash = combinedMatrix ? combinedMatrix.toString() : IDENTITY_MATRIX_HASH;
        var bbox;

        if (this._bboxCache && this._matrixHash === matrixHash) {
            bbox = this._bboxCache.clone();
        } else {
            bbox = this._bbox(combinedMatrix);
            this._bboxCache = bbox ? bbox.clone() : null;
            this._matrixHash = matrixHash;
        }

        var strokeWidth = this.options.get("stroke.width");
        if (strokeWidth && bbox) {
            bbox.expand(strokeWidth / 2);
        }

        return bbox;
    },

    geometryChange: function() {
        delete this._bboxCache;
        this.trigger("geometryChange", {
            element: this
        });
    }
};

/* harmony default export */ __webpack_exports__["a"] = (Measurable);

/***/ }),
/* 202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__element__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_traversable__ = __webpack_require__(404);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_elements_bounding_box__ = __webpack_require__(658);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_elements_clippend_bounding_box__ = __webpack_require__(659);






var Group = (function (Element) {
    function Group(options) {
        Element.call(this, options);
        this.children = [];
    }

    if ( Element ) Group.__proto__ = Element;
    Group.prototype = Object.create( Element && Element.prototype );
    Group.prototype.constructor = Group;

    Group.prototype.childrenChange = function childrenChange (action, items, index) {
        this.trigger("childrenChange",{
            action: action,
            items: items,
            index: index
        });
    };

    Group.prototype.append = function append$1 () {
        Object(__WEBPACK_IMPORTED_MODULE_2__util__["c" /* append */])(this.children, arguments);
        this._reparent(arguments, this);

        this.childrenChange("add", arguments);

        return this;
    };

    Group.prototype.insert = function insert (index, element) {
        this.children.splice(index, 0, element);
        element.parent = this;

        this.childrenChange("add", [ element ], index);

        return this;
    };

    Group.prototype.insertAt = function insertAt (element, index) {
        return this.insert(index, element);
    };

    Group.prototype.remove = function remove (element) {
        var index = this.children.indexOf(element);
        if (index >= 0) {
            this.children.splice(index, 1);
            element.parent = null;
            this.childrenChange("remove", [ element ], index);
        }

        return this;
    };

    Group.prototype.removeAt = function removeAt (index) {
        if (0 <= index && index < this.children.length) {
            var element = this.children[index];
            this.children.splice(index, 1);
            element.parent = null;
            this.childrenChange("remove", [ element ], index);
        }

        return this;
    };

    Group.prototype.clear = function clear () {
        var items = this.children;
        this.children = [];
        this._reparent(items, null);

        this.childrenChange("remove", items, 0);

        return this;
    };

    Group.prototype.bbox = function bbox (transformation) {
        return Object(__WEBPACK_IMPORTED_MODULE_3__utils_elements_bounding_box__["a" /* default */])(this.children, true, this.currentTransform(transformation));
    };

    Group.prototype.rawBBox = function rawBBox () {
        return Object(__WEBPACK_IMPORTED_MODULE_3__utils_elements_bounding_box__["a" /* default */])(this.children, false);
    };

    Group.prototype._clippedBBox = function _clippedBBox (transformation) {
        return Object(__WEBPACK_IMPORTED_MODULE_4__utils_elements_clippend_bounding_box__["a" /* default */])(this.children, this.currentTransform(transformation));
    };

    Group.prototype.currentTransform = function currentTransform (transformation) {
        return Element.prototype.currentTransform.call(this, transformation) || null;
    };

    Group.prototype.containsPoint = function containsPoint (point, parentTransform) {
        if (this.visible()) {
            var children = this.children;
            var transform = this.currentTransform(parentTransform);
            for (var idx = 0; idx < children.length; idx++) {
                if (children[idx].containsPoint(point, transform)) {
                    return true;
                }
            }
        }
        return false;
    };

    Group.prototype._reparent = function _reparent (elements, newParent) {
        var this$1 = this;

        for (var i = 0; i < elements.length; i++) {
            var child = elements[i];
            var parent = child.parent;
            if (parent && parent !== this$1 && parent.remove) {
                parent.remove(child);
            }

            child.parent = newParent;
        }
    };

    return Group;
}(__WEBPACK_IMPORTED_MODULE_0__element__["a" /* default */]));

Group.prototype.nodeType = "Group";

__WEBPACK_IMPORTED_MODULE_1__mixins_traversable__["a" /* default */].extend(Group.prototype, "children");

/* harmony default export */ __webpack_exports__["a"] = (Group);

/***/ }),
/* 203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common__ = __webpack_require__(29);


var BaseNode = (function (Class) {
    function BaseNode(srcElement) {
        Class.call(this);

        this.childNodes = [];
        this.parent = null;

        if (srcElement) {
            this.srcElement = srcElement;
            this.observe();
        }
    }

    if ( Class ) BaseNode.__proto__ = Class;
    BaseNode.prototype = Object.create( Class && Class.prototype );
    BaseNode.prototype.constructor = BaseNode;

    BaseNode.prototype.destroy = function destroy () {
        var this$1 = this;

        if (this.srcElement) {
            this.srcElement.removeObserver(this);
        }

        var children = this.childNodes;
        for (var i = 0; i < children.length; i++) {
            this$1.childNodes[i].destroy();
        }

        this.parent = null;
    };

    BaseNode.prototype.load = function load () {};

    BaseNode.prototype.observe = function observe () {
        if (this.srcElement) {
            this.srcElement.addObserver(this);
        }
    };

    BaseNode.prototype.append = function append (node) {
        this.childNodes.push(node);
        node.parent = this;
    };

    BaseNode.prototype.insertAt = function insertAt (node, pos) {
        this.childNodes.splice(pos, 0, node);
        node.parent = this;
    };

    BaseNode.prototype.remove = function remove (index, count) {
        var this$1 = this;

        var end = index + count;
        for (var i = index; i < end; i++) {
            this$1.childNodes[i].removeSelf();
        }
        this.childNodes.splice(index, count);
    };

    BaseNode.prototype.removeSelf = function removeSelf () {
        this.clear();
        this.destroy();
    };

    BaseNode.prototype.clear = function clear () {
        this.remove(0, this.childNodes.length);
    };

    BaseNode.prototype.invalidate = function invalidate () {
        if (this.parent) {
            this.parent.invalidate();
        }
    };

    BaseNode.prototype.geometryChange = function geometryChange () {
        this.invalidate();
    };

    BaseNode.prototype.optionsChange = function optionsChange () {
        this.invalidate();
    };

    BaseNode.prototype.childrenChange = function childrenChange (e) {
        if (e.action === "add") {
            this.load(e.items, e.index);
        } else if (e.action === "remove") {
            this.remove(e.index, e.items.length);
        }

        this.invalidate();
    };

    return BaseNode;
}(__WEBPACK_IMPORTED_MODULE_0__common__["a" /* Class */]));

/* harmony default export */ __webpack_exports__["a"] = (BaseNode);

/***/ }),
/* 204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = renderAttr;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util__ = __webpack_require__(22);


function renderAttr(name, value) {
    return (Object(__WEBPACK_IMPORTED_MODULE_0__util__["g" /* defined */])(value) && value !== null) ? (" " + name + "=\"" + value + "\" ") : "";
}

/***/ }),
/* 205 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SVG_NS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NONE; });
var SVG_NS = "http://www.w3.org/2000/svg";
var NONE = "none";



/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(9)

/**
 * @category Millisecond Helpers
 * @summary Add the specified number of milliseconds to the given date.
 *
 * @description
 * Add the specified number of milliseconds to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be added
 * @returns {Date} the new date with the milliseconds added
 *
 * @example
 * // Add 750 milliseconds to 10 July 2014 12:45:30.000:
 * var result = addMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:30.750
 */
function addMilliseconds (dirtyDate, dirtyAmount) {
  var timestamp = parse(dirtyDate).getTime()
  var amount = Number(dirtyAmount)
  return new Date(timestamp + amount)
}

module.exports = addMilliseconds


/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(9)

/**
 * @category Common Helpers
 * @summary Compare the two dates and return -1, 0 or 1.
 *
 * @description
 * Compare the two dates and return 1 if the first date is after the second,
 * -1 if the first date is before the second or 0 if dates are equal.
 *
 * @param {Date|String|Number} dateLeft - the first date to compare
 * @param {Date|String|Number} dateRight - the second date to compare
 * @returns {Number} the result of the comparison
 *
 * @example
 * // Compare 11 February 1987 and 10 July 1989:
 * var result = compareAsc(
 *   new Date(1987, 1, 11),
 *   new Date(1989, 6, 10)
 * )
 * //=> -1
 *
 * @example
 * // Sort the array of dates:
 * var result = [
 *   new Date(1995, 6, 2),
 *   new Date(1987, 1, 11),
 *   new Date(1989, 6, 10)
 * ].sort(compareAsc)
 * //=> [
 * //   Wed Feb 11 1987 00:00:00,
 * //   Mon Jul 10 1989 00:00:00,
 * //   Sun Jul 02 1995 00:00:00
 * // ]
 */
function compareAsc (dirtyDateLeft, dirtyDateRight) {
  var dateLeft = parse(dirtyDateLeft)
  var timeLeft = dateLeft.getTime()
  var dateRight = parse(dirtyDateRight)
  var timeRight = dateRight.getTime()

  if (timeLeft < timeRight) {
    return -1
  } else if (timeLeft > timeRight) {
    return 1
  } else {
    return 0
  }
}

module.exports = compareAsc


/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.

function isArray(arg) {
  if (Array.isArray) {
    return Array.isArray(arg);
  }
  return objectToString(arg) === '[object Array]';
}
exports.isArray = isArray;

function isBoolean(arg) {
  return typeof arg === 'boolean';
}
exports.isBoolean = isBoolean;

function isNull(arg) {
  return arg === null;
}
exports.isNull = isNull;

function isNullOrUndefined(arg) {
  return arg == null;
}
exports.isNullOrUndefined = isNullOrUndefined;

function isNumber(arg) {
  return typeof arg === 'number';
}
exports.isNumber = isNumber;

function isString(arg) {
  return typeof arg === 'string';
}
exports.isString = isString;

function isSymbol(arg) {
  return typeof arg === 'symbol';
}
exports.isSymbol = isSymbol;

function isUndefined(arg) {
  return arg === void 0;
}
exports.isUndefined = isUndefined;

function isRegExp(re) {
  return objectToString(re) === '[object RegExp]';
}
exports.isRegExp = isRegExp;

function isObject(arg) {
  return typeof arg === 'object' && arg !== null;
}
exports.isObject = isObject;

function isDate(d) {
  return objectToString(d) === '[object Date]';
}
exports.isDate = isDate;

function isError(e) {
  return (objectToString(e) === '[object Error]' || e instanceof Error);
}
exports.isError = isError;

function isFunction(arg) {
  return typeof arg === 'function';
}
exports.isFunction = isFunction;

function isPrimitive(arg) {
  return arg === null ||
         typeof arg === 'boolean' ||
         typeof arg === 'number' ||
         typeof arg === 'string' ||
         typeof arg === 'symbol' ||  // ES6 symbol
         typeof arg === 'undefined';
}
exports.isPrimitive = isPrimitive;

exports.isBuffer = Buffer.isBuffer;

function objectToString(o) {
  return Object.prototype.toString.call(o);
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(123).Buffer))

/***/ }),
/* 209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createBrowserHistory__ = __webpack_require__(768);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__createBrowserHistory__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createHashHistory__ = __webpack_require__(769);
/* unused harmony reexport createHashHistory */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__createMemoryHistory__ = __webpack_require__(770);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__createMemoryHistory__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__LocationUtils__ = __webpack_require__(210);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_3__LocationUtils__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_3__LocationUtils__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PathUtils__ = __webpack_require__(159);
/* unused harmony reexport parsePath */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_4__PathUtils__["b"]; });










/***/ }),
/* 210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createLocation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return locationsAreEqual; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_resolve_pathname__ = __webpack_require__(436);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_value_equal__ = __webpack_require__(437);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PathUtils__ = __webpack_require__(159);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var createLocation = function createLocation(path, state, key, currentLocation) {
  var location = void 0;
  if (typeof path === 'string') {
    // Two-arg form: push(path, state)
    location = Object(__WEBPACK_IMPORTED_MODULE_2__PathUtils__["d" /* parsePath */])(path);
    location.state = state;
  } else {
    // One-arg form: push(location)
    location = _extends({}, path);

    if (location.pathname === undefined) location.pathname = '';

    if (location.search) {
      if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
    } else {
      location.search = '';
    }

    if (location.hash) {
      if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
    } else {
      location.hash = '';
    }

    if (state !== undefined && location.state === undefined) location.state = state;
  }

  try {
    location.pathname = decodeURI(location.pathname);
  } catch (e) {
    if (e instanceof URIError) {
      throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
    } else {
      throw e;
    }
  }

  if (key) location.key = key;

  if (currentLocation) {
    // Resolve incomplete/relative pathname relative to current location.
    if (!location.pathname) {
      location.pathname = currentLocation.pathname;
    } else if (location.pathname.charAt(0) !== '/') {
      location.pathname = Object(__WEBPACK_IMPORTED_MODULE_0_resolve_pathname__["default"])(location.pathname, currentLocation.pathname);
    }
  } else {
    // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) {
      location.pathname = '/';
    }
  }

  return location;
};

var locationsAreEqual = function locationsAreEqual(a, b) {
  return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && Object(__WEBPACK_IMPORTED_MODULE_1_value_equal__["default"])(a.state, b.state);
};

/***/ }),
/* 211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






/**
 * The public API for putting history on context.
 */

var Router = function (_React$Component) {
  _inherits(Router, _React$Component);

  function Router() {
    var _temp, _this, _ret;

    _classCallCheck(this, Router);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      match: _this.computeMatch(_this.props.history.location.pathname)
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Router.prototype.getChildContext = function getChildContext() {
    return {
      router: _extends({}, this.context.router, {
        history: this.props.history,
        route: {
          location: this.props.history.location,
          match: this.state.match
        }
      })
    };
  };

  Router.prototype.computeMatch = function computeMatch(pathname) {
    return {
      path: "/",
      url: "/",
      params: {},
      isExact: pathname === "/"
    };
  };

  Router.prototype.componentWillMount = function componentWillMount() {
    var _this2 = this;

    var _props = this.props,
        children = _props.children,
        history = _props.history;


    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(children == null || __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.count(children) === 1, "A <Router> may have only one child element");

    // Do this here so we can setState when a <Redirect> changes the
    // location in componentWillMount. This happens e.g. when doing
    // server rendering using a <StaticRouter>.
    this.unlisten = history.listen(function () {
      _this2.setState({
        match: _this2.computeMatch(history.location.pathname)
      });
    });
  };

  Router.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(this.props.history === nextProps.history, "You cannot change <Router history>");
  };

  Router.prototype.componentWillUnmount = function componentWillUnmount() {
    this.unlisten();
  };

  Router.prototype.render = function render() {
    var children = this.props.children;

    return children ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(children) : null;
  };

  return Router;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

Router.propTypes = {
  history: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node
};
Router.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
Router.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Router);

/***/ }),
/* 212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp__ = __webpack_require__(447);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_path_to_regexp__);


var patternCache = {};
var cacheLimit = 10000;
var cacheCount = 0;

var compilePath = function compilePath(pattern, options) {
  var cacheKey = "" + options.end + options.strict + options.sensitive;
  var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});

  if (cache[pattern]) return cache[pattern];

  var keys = [];
  var re = __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default()(pattern, keys, options);
  var compiledPattern = { re: re, keys: keys };

  if (cacheCount < cacheLimit) {
    cache[pattern] = compiledPattern;
    cacheCount++;
  }

  return compiledPattern;
};

/**
 * Public API for matching a URL pathname to a path pattern.
 */
var matchPath = function matchPath(pathname) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var parent = arguments[2];

  if (typeof options === "string") options = { path: options };

  var _options = options,
      path = _options.path,
      _options$exact = _options.exact,
      exact = _options$exact === undefined ? false : _options$exact,
      _options$strict = _options.strict,
      strict = _options$strict === undefined ? false : _options$strict,
      _options$sensitive = _options.sensitive,
      sensitive = _options$sensitive === undefined ? false : _options$sensitive;


  if (path == null) return parent;

  var _compilePath = compilePath(path, { end: exact, strict: strict, sensitive: sensitive }),
      re = _compilePath.re,
      keys = _compilePath.keys;

  var match = re.exec(pathname);

  if (!match) return null;

  var url = match[0],
      values = match.slice(1);

  var isExact = pathname === url;

  if (exact && !isExact) return null;

  return {
    path: path, // the path pattern used to match
    url: path === "/" && url === "" ? "/" : url, // the matched portion of the URL
    isExact: isExact, // whether or not we matched exactly
    params: keys.reduce(function (memo, key, index) {
      memo[key.name] = values[index];
      return memo;
    }, {})
  };
};

/* harmony default export */ __webpack_exports__["a"] = (matchPath);

/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = toCssValue;
var join = function join(value, by) {
  var result = '';
  for (var i = 0; i < value.length; i++) {
    // Remove !important from the value, it will be readded later.
    if (value[i] === '!important') break;
    if (result) result += by;
    result += value[i];
  }
  return result;
};

/**
 * Converts array values to string.
 *
 * `margin: [['5px', '10px']]` > `margin: 5px 10px;`
 * `border: ['1px', '2px']` > `border: 1px, 2px;`
 * `margin: [['5px', '10px'], '!important']` > `margin: 5px 10px !important;`
 * `color: ['red', !important]` > `color: red !important;`
 */
function toCssValue(value) {
  var ignoreImportant = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  if (!Array.isArray(value)) return value;

  var cssValue = '';

  // Support space separated values via `[['5px', '10px']]`.
  if (Array.isArray(value[0])) {
    for (var i = 0; i < value.length; i++) {
      if (value[i] === '!important') break;
      if (cssValue) cssValue += ', ';
      cssValue += join(value[i], ' ');
    }
  } else cssValue = join(value, ', ');

  // Add !important, because it was ignored.
  if (!ignoreImportant && value[value.length - 1] === '!important') {
    cssValue += ' !important';
  }

  return cssValue;
}

/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = createRule;

var _warning = __webpack_require__(128);

var _warning2 = _interopRequireDefault(_warning);

var _StyleRule = __webpack_require__(129);

var _StyleRule2 = _interopRequireDefault(_StyleRule);

var _cloneStyle = __webpack_require__(793);

var _cloneStyle2 = _interopRequireDefault(_cloneStyle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 * Create a rule instance.
 */
function createRule() {
  var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'unnamed';
  var decl = arguments[1];
  var options = arguments[2];
  var jss = options.jss;

  var declCopy = (0, _cloneStyle2['default'])(decl);

  var rule = jss.plugins.onCreateRule(name, declCopy, options);
  if (rule) return rule;

  // It is an at-rule and it has no instance.
  if (name[0] === '@') {
    (0, _warning2['default'])(false, '[JSS] Unknown at-rule %s', name);
  }

  return new _StyleRule2['default'](name, declCopy, options);
}

/***/ }),
/* 215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isBrowser", function() { return isBrowser; });
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var isBrowser = (typeof window === "undefined" ? "undefined" : _typeof(window)) === "object" && (typeof document === "undefined" ? "undefined" : _typeof(document)) === 'object' && document.nodeType === 9;

/* harmony default export */ __webpack_exports__["default"] = (isBrowser);


/***/ }),
/* 216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var isMergeableObject = function isMergeableObject(value) {
	return isNonNullObject(value)
		&& !isSpecial(value)
};

function isNonNullObject(value) {
	return !!value && typeof value === 'object'
}

function isSpecial(value) {
	var stringValue = Object.prototype.toString.call(value);

	return stringValue === '[object RegExp]'
		|| stringValue === '[object Date]'
		|| isReactElement(value)
}

// see https://github.com/facebook/react/blob/b5ac963fb791d1298e7f396236383bc955f916c1/src/isomorphic/classic/element/ReactElement.js#L21-L25
var canUseSymbol = typeof Symbol === 'function' && Symbol.for;
var REACT_ELEMENT_TYPE = canUseSymbol ? Symbol.for('react.element') : 0xeac7;

function isReactElement(value) {
	return value.$$typeof === REACT_ELEMENT_TYPE
}

function emptyTarget(val) {
	return Array.isArray(val) ? [] : {}
}

function cloneUnlessOtherwiseSpecified(value, options) {
	return (options.clone !== false && options.isMergeableObject(value))
		? deepmerge(emptyTarget(value), value, options)
		: value
}

function defaultArrayMerge(target, source, options) {
	return target.concat(source).map(function(element) {
		return cloneUnlessOtherwiseSpecified(element, options)
	})
}

function mergeObject(target, source, options) {
	var destination = {};
	if (options.isMergeableObject(target)) {
		Object.keys(target).forEach(function(key) {
			destination[key] = cloneUnlessOtherwiseSpecified(target[key], options);
		});
	}
	Object.keys(source).forEach(function(key) {
		if (!options.isMergeableObject(source[key]) || !target[key]) {
			destination[key] = cloneUnlessOtherwiseSpecified(source[key], options);
		} else {
			destination[key] = deepmerge(target[key], source[key], options);
		}
	});
	return destination
}

function deepmerge(target, source, options) {
	options = options || {};
	options.arrayMerge = options.arrayMerge || defaultArrayMerge;
	options.isMergeableObject = options.isMergeableObject || isMergeableObject;

	var sourceIsArray = Array.isArray(source);
	var targetIsArray = Array.isArray(target);
	var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;

	if (!sourceAndTargetTypesMatch) {
		return cloneUnlessOtherwiseSpecified(source, options)
	} else if (sourceIsArray) {
		return options.arrayMerge(target, source, options)
	} else {
		return mergeObject(target, source, options)
	}
}

deepmerge.all = function deepmergeAll(array, options) {
	if (!Array.isArray(array)) {
		throw new Error('first argument should be an array')
	}

	return array.reduce(function(prev, next) {
		return deepmerge(prev, next, options)
	}, {})
};

var deepmerge_1 = deepmerge;

/* harmony default export */ __webpack_exports__["default"] = (deepmerge_1);


/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ownerDocument = _interopRequireDefault(__webpack_require__(71));

var ownerWindow = function ownerWindow(node) {
  var fallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window;
  var doc = (0, _ownerDocument.default)(node);
  return doc.defaultView || doc.parentView || fallback;
};

var _default = ownerWindow;
exports.default = _default;

/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(72);

exports.__esModule = true;
exports.default = void 0;

var _inDOM = _interopRequireDefault(__webpack_require__(167));

var _default = function () {
  // HTML DOM and SVG DOM may have different support levels,
  // so we need to check on context instead of a document root element.
  return _inDOM.default ? function (context, node) {
    if (context.contains) {
      return context.contains(node);
    } else if (context.compareDocumentPosition) {
      return context === node || !!(context.compareDocumentPosition(node) & 16);
    } else {
      return fallback(context, node);
    }
  } : fallback;
}();

exports.default = _default;

function fallback(context, node) {
  if (node) do {
    if (node === context) return true;
  } while (node = node.parentNode);
  return false;
}

module.exports = exports["default"];

/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

var arrayWithoutHoles = __webpack_require__(866);

var iterableToArray = __webpack_require__(867);

var nonIterableSpread = __webpack_require__(868);

function _toConsumableArray(arr) {
  return arrayWithoutHoles(arr) || iterableToArray(arr) || nonIterableSpread();
}

module.exports = _toConsumableArray;

/***/ }),
/* 220 */
/***/ (function(module, exports) {

module.exports = true;


/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(92);
var core = __webpack_require__(134);
var ctx = __webpack_require__(474);
var hide = __webpack_require__(135);
var has = __webpack_require__(106);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && has(exports, key)) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 222 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 223 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 224 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Collapse.default;
  }
});

var _Collapse = _interopRequireDefault(__webpack_require__(948));

/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Modal.default;
  }
});
Object.defineProperty(exports, "ModalManager", {
  enumerable: true,
  get: function get() {
    return _ModalManager.default;
  }
});

var _Modal = _interopRequireDefault(__webpack_require__(953));

var _ModalManager = _interopRequireDefault(__webpack_require__(489));

/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _TableCell.default;
  }
});

var _TableCell = _interopRequireDefault(__webpack_require__(1059));

/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/web-background2.427d9b0c.jpg";

/***/ }),
/* 229 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FetchType; });
var FetchType;
(function (FetchType) {
    FetchType[FetchType["normal"] = 1] = "normal";
    FetchType[FetchType["refetch"] = 2] = "refetch";
    FetchType[FetchType["poll"] = 3] = "poll";
})(FetchType || (FetchType = {}));
//# sourceMappingURL=types.js.map

/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var ReactIs = __webpack_require__(343);
var REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};

var FORWARD_REF_STATICS = {
    '$$typeof': true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};

var TYPE_STATICS = {};
TYPE_STATICS[ReactIs.ForwardRef] = FORWARD_REF_STATICS;

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;

function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components

        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) {
                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
            }
        }

        var keys = getOwnPropertyNames(sourceComponent);

        if (getOwnPropertySymbols) {
            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        }

        var targetStatics = TYPE_STATICS[targetComponent['$$typeof']] || REACT_STATICS;
        var sourceStatics = TYPE_STATICS[sourceComponent['$$typeof']] || REACT_STATICS;

        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }

        return targetComponent;
    }

    return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 231 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayMap_js__ = __webpack_require__(544);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__copyArray_js__ = __webpack_require__(545);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isArray_js__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isSymbol_js__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__stringToPath_js__ = __webpack_require__(547);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__toKey_js__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__toString_js__ = __webpack_require__(549);








/**
 * Converts `value` to a property path array.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Util
 * @param {*} value The value to convert.
 * @returns {Array} Returns the new property path array.
 * @example
 *
 * _.toPath('a.b.c');
 * // => ['a', 'b', 'c']
 *
 * _.toPath('a[0].b.c');
 * // => ['a', '0', 'b', 'c']
 */
function toPath(value) {
  if (Object(__WEBPACK_IMPORTED_MODULE_2__isArray_js__["a" /* default */])(value)) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__arrayMap_js__["a" /* default */])(value, __WEBPACK_IMPORTED_MODULE_5__toKey_js__["a" /* default */]);
  }
  return Object(__WEBPACK_IMPORTED_MODULE_3__isSymbol_js__["a" /* default */])(value) ? [value] : Object(__WEBPACK_IMPORTED_MODULE_1__copyArray_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_4__stringToPath_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_6__toString_js__["a" /* default */])(value)));
}

/* harmony default export */ __webpack_exports__["a"] = (toPath);


/***/ }),
/* 232 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__ = __webpack_require__(110);



/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (Object(__WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__["a" /* default */])(value) && Object(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value) == symbolTag);
}

/* harmony default export */ __webpack_exports__["a"] = (isSymbol);


/***/ }),
/* 233 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_js__ = __webpack_require__(75);


/** Built-in value references. */
var Symbol = __WEBPACK_IMPORTED_MODULE_0__root_js__["a" /* default */].Symbol;

/* harmony default export */ __webpack_exports__["a"] = (Symbol);


/***/ }),
/* 234 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getNative_js__ = __webpack_require__(111);


/* Built-in method references that are verified to be native. */
var nativeCreate = Object(__WEBPACK_IMPORTED_MODULE_0__getNative_js__["a" /* default */])(Object, 'create');

/* harmony default export */ __webpack_exports__["a"] = (nativeCreate);


/***/ }),
/* 235 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__listCacheClear_js__ = __webpack_require__(1169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__listCacheDelete_js__ = __webpack_require__(1170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__listCacheGet_js__ = __webpack_require__(1171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__listCacheHas_js__ = __webpack_require__(1172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__listCacheSet_js__ = __webpack_require__(1173);






/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = __WEBPACK_IMPORTED_MODULE_0__listCacheClear_js__["a" /* default */];
ListCache.prototype['delete'] = __WEBPACK_IMPORTED_MODULE_1__listCacheDelete_js__["a" /* default */];
ListCache.prototype.get = __WEBPACK_IMPORTED_MODULE_2__listCacheGet_js__["a" /* default */];
ListCache.prototype.has = __WEBPACK_IMPORTED_MODULE_3__listCacheHas_js__["a" /* default */];
ListCache.prototype.set = __WEBPACK_IMPORTED_MODULE_4__listCacheSet_js__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (ListCache);


/***/ }),
/* 236 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__eq_js__ = __webpack_require__(178);


/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (Object(__WEBPACK_IMPORTED_MODULE_0__eq_js__["a" /* default */])(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/* harmony default export */ __webpack_exports__["a"] = (assocIndexOf);


/***/ }),
/* 237 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isKeyable_js__ = __webpack_require__(1175);


/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return Object(__WEBPACK_IMPORTED_MODULE_0__isKeyable_js__["a" /* default */])(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/* harmony default export */ __webpack_exports__["a"] = (getMapData);


/***/ }),
/* 238 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseIsEqualDeep_js__ = __webpack_require__(1182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__ = __webpack_require__(110);



/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!Object(__WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__["a" /* default */])(value) && !Object(__WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__["a" /* default */])(other))) {
    return value !== value && other !== other;
  }
  return Object(__WEBPACK_IMPORTED_MODULE_0__baseIsEqualDeep_js__["a" /* default */])(value, other, bitmask, customizer, baseIsEqual, stack);
}

/* harmony default export */ __webpack_exports__["a"] = (baseIsEqual);


/***/ }),
/* 239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseIsArguments_js__ = __webpack_require__(1204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__ = __webpack_require__(110);



/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = Object(__WEBPACK_IMPORTED_MODULE_0__baseIsArguments_js__["a" /* default */])(function() { return arguments; }()) ? __WEBPACK_IMPORTED_MODULE_0__baseIsArguments_js__["a" /* default */] : function(value) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__["a" /* default */])(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

/* harmony default export */ __webpack_exports__["a"] = (isArguments);


/***/ }),
/* 240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_js__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__stubFalse_js__ = __webpack_require__(1205);



/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? __WEBPACK_IMPORTED_MODULE_0__root_js__["a" /* default */].Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || __WEBPACK_IMPORTED_MODULE_1__stubFalse_js__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (isBuffer);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(164)(module)))

/***/ }),
/* 241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseIsTypedArray_js__ = __webpack_require__(1206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseUnary_js__ = __webpack_require__(1207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__nodeUtil_js__ = __webpack_require__(1208);




/* Node.js helper references. */
var nodeIsTypedArray = __WEBPACK_IMPORTED_MODULE_2__nodeUtil_js__["a" /* default */] && __WEBPACK_IMPORTED_MODULE_2__nodeUtil_js__["a" /* default */].isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? Object(__WEBPACK_IMPORTED_MODULE_1__baseUnary_js__["a" /* default */])(nodeIsTypedArray) : __WEBPACK_IMPORTED_MODULE_0__baseIsTypedArray_js__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (isTypedArray);


/***/ }),
/* 242 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/* harmony default export */ __webpack_exports__["a"] = (isPrototype);


/***/ }),
/* 243 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__defineProperty_js__ = __webpack_require__(558);


/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && __WEBPACK_IMPORTED_MODULE_0__defineProperty_js__["a" /* default */]) {
    Object(__WEBPACK_IMPORTED_MODULE_0__defineProperty_js__["a" /* default */])(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

/* harmony default export */ __webpack_exports__["a"] = (baseAssignValue);


/***/ }),
/* 244 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_assets_jss_material_dashboard_pro_react_views_sweetAlertStyle_jsx__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles_withStyles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_bootstrap_sweetalert__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_bootstrap_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap_sweetalert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__reducers_NotificationReducer__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_Snackbar_Snackbar_jsx__ = __webpack_require__(174);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var NotificationWrapper=function(_React$Component){_inherits(NotificationWrapper,_React$Component);function NotificationWrapper(){var _ref;var _temp,_this,_ret;_classCallCheck(this,NotificationWrapper);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=NotificationWrapper.__proto__||Object.getPrototypeOf(NotificationWrapper)).call.apply(_ref,[this].concat(args))),_this),_this.state={errorDialogOpen:false},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(NotificationWrapper,[{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,this.props.children,__WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].getState().alert.errorWindow.open?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap_sweetalert___default.a,{danger:true,title:__WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].getState().alert.errorWindow.title,onConfirm:function onConfirm(){__WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__reducers_NotificationReducer__["a" /* alertDanger */])({open:false,title:"",message:null}));},confirmBtnCssClass:this.props.classes.button+" "+this.props.classes.info,confirmBtnText:"Ok"},__WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].getState().alert.errorWindow.message):null,__WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].getState().alert.warningWindow.open?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap_sweetalert___default.a,{warning:true,title:__WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].getState().alert.warningWindow.title,onConfirm:function onConfirm(){__WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__reducers_NotificationReducer__["b" /* alertWarning */])({confirmClicked:true,open:false,title:"",message:null}));},onCancel:function onCancel(){__WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__reducers_NotificationReducer__["b" /* alertWarning */])({cancelClicked:true,open:false,title:"",message:null}));},confirmBtnCssClass:this.props.classes.button+" "+this.props.classes.success,cancelBtnCssClass:this.props.classes.button+" "+this.props.classes.danger,confirmBtnText:__WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].getState().alert.warningWindow.confirmBtnText,cancelBtnText:__WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].getState().alert.warningWindow.cancelBtnText,showCancel:__WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].getState().alert.warningWindow.showCancel,showConfirm:__WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].getState().alert.warningWindow.showConfirm},__WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].getState().alert.warningWindow.message):null,__WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].getState().alert.successWindow.open?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap_sweetalert___default.a,{success:true,style:{display:"block",left:"60%",top:"25%",marginTop:"-0px"},title:__WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].getState().alert.successWindow.title,onConfirm:function onConfirm(){__WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__reducers_NotificationReducer__["e" /* successWarning */])({confirmClicked:true,open:false,title:""}));},confirmBtnCssClass:this.props.classes.button+" "+this.props.classes.success}):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_Snackbar_Snackbar_jsx__["a" /* default */],{place:"br",color:__WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].getState().alert.snack.color,message:__WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].getState().alert.snack.message,open:__WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].getState().alert.snack.open,closeNotification:function closeNotification(){__WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__reducers_NotificationReducer__["d" /* showSnack */])({open:false}));},close:true}));}}]);return NotificationWrapper;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var mapStateToProps=function mapStateToProps(state){return{alert:state.alert};};NotificationWrapper=Object(__WEBPACK_IMPORTED_MODULE_5_react_redux__["b" /* connect */])(mapStateToProps)(NotificationWrapper);/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles_withStyles___default()(__WEBPACK_IMPORTED_MODULE_1_assets_jss_material_dashboard_pro_react_views_sweetAlertStyle_jsx__["a" /* default */])(NotificationWrapper));

/***/ }),
/* 245 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/*!
 * perfect-scrollbar v1.3.0
 * (c) 2017 Hyunje Jun
 * @license MIT
 */
function get(element) {
  return getComputedStyle(element);
}

function set(element, obj) {
  for (var key in obj) {
    var val = obj[key];
    if (typeof val === 'number') {
      val = val + "px";
    }
    element.style[key] = val;
  }
  return element;
}

function div(className) {
  var div = document.createElement('div');
  div.className = className;
  return div;
}

var elMatches =
  typeof Element !== 'undefined' &&
  (Element.prototype.matches ||
    Element.prototype.webkitMatchesSelector ||
    Element.prototype.msMatchesSelector);

function matches(element, query) {
  if (!elMatches) {
    throw new Error('No element matching method supported');
  }

  return elMatches.call(element, query);
}

function remove(element) {
  if (element.remove) {
    element.remove();
  } else {
    if (element.parentNode) {
      element.parentNode.removeChild(element);
    }
  }
}

function queryChildren(element, selector) {
  return Array.prototype.filter.call(element.children, function (child) { return matches(child, selector); }
  );
}

var cls = {
  main: 'ps',
  element: {
    thumb: function (x) { return ("ps__thumb-" + x); },
    rail: function (x) { return ("ps__rail-" + x); },
    consuming: 'ps__child--consume',
  },
  state: {
    focus: 'ps--focus',
    active: function (x) { return ("ps--active-" + x); },
    scrolling: function (x) { return ("ps--scrolling-" + x); },
  },
};

/*
 * Helper methods
 */
var scrollingClassTimeout = { x: null, y: null };

function addScrollingClass(i, x) {
  var classList = i.element.classList;
  var className = cls.state.scrolling(x);

  if (classList.contains(className)) {
    clearTimeout(scrollingClassTimeout[x]);
  } else {
    classList.add(className);
  }
}

function removeScrollingClass(i, x) {
  scrollingClassTimeout[x] = setTimeout(
    function () { return i.isAlive && i.element.classList.remove(cls.state.scrolling(x)); },
    i.settings.scrollingThreshold
  );
}

function setScrollingClassInstantly(i, x) {
  addScrollingClass(i, x);
  removeScrollingClass(i, x);
}

var EventElement = function EventElement(element) {
  this.element = element;
  this.handlers = {};
};

var prototypeAccessors = { isEmpty: { configurable: true } };

EventElement.prototype.bind = function bind (eventName, handler) {
  if (typeof this.handlers[eventName] === 'undefined') {
    this.handlers[eventName] = [];
  }
  this.handlers[eventName].push(handler);
  this.element.addEventListener(eventName, handler, false);
};

EventElement.prototype.unbind = function unbind (eventName, target) {
    var this$1 = this;

  this.handlers[eventName] = this.handlers[eventName].filter(function (handler) {
    if (target && handler !== target) {
      return true;
    }
    this$1.element.removeEventListener(eventName, handler, false);
    return false;
  });
};

EventElement.prototype.unbindAll = function unbindAll () {
    var this$1 = this;

  for (var name in this$1.handlers) {
    this$1.unbind(name);
  }
};

prototypeAccessors.isEmpty.get = function () {
    var this$1 = this;

  return Object.keys(this.handlers).every(
    function (key) { return this$1.handlers[key].length === 0; }
  );
};

Object.defineProperties( EventElement.prototype, prototypeAccessors );

var EventManager = function EventManager() {
  this.eventElements = [];
};

EventManager.prototype.eventElement = function eventElement (element) {
  var ee = this.eventElements.filter(function (ee) { return ee.element === element; })[0];
  if (!ee) {
    ee = new EventElement(element);
    this.eventElements.push(ee);
  }
  return ee;
};

EventManager.prototype.bind = function bind (element, eventName, handler) {
  this.eventElement(element).bind(eventName, handler);
};

EventManager.prototype.unbind = function unbind (element, eventName, handler) {
  var ee = this.eventElement(element);
  ee.unbind(eventName, handler);

  if (ee.isEmpty) {
    // remove
    this.eventElements.splice(this.eventElements.indexOf(ee), 1);
  }
};

EventManager.prototype.unbindAll = function unbindAll () {
  this.eventElements.forEach(function (e) { return e.unbindAll(); });
  this.eventElements = [];
};

EventManager.prototype.once = function once (element, eventName, handler) {
  var ee = this.eventElement(element);
  var onceHandler = function (evt) {
    ee.unbind(eventName, onceHandler);
    handler(evt);
  };
  ee.bind(eventName, onceHandler);
};

function createEvent(name) {
  if (typeof window.CustomEvent === 'function') {
    return new CustomEvent(name);
  } else {
    var evt = document.createEvent('CustomEvent');
    evt.initCustomEvent(name, false, false, undefined);
    return evt;
  }
}

var processScrollDiff = function(
  i,
  axis,
  diff,
  useScrollingClass,
  forceFireReachEvent
) {
  if ( useScrollingClass === void 0 ) useScrollingClass = true;
  if ( forceFireReachEvent === void 0 ) forceFireReachEvent = false;

  var fields;
  if (axis === 'top') {
    fields = [
      'contentHeight',
      'containerHeight',
      'scrollTop',
      'y',
      'up',
      'down' ];
  } else if (axis === 'left') {
    fields = [
      'contentWidth',
      'containerWidth',
      'scrollLeft',
      'x',
      'left',
      'right' ];
  } else {
    throw new Error('A proper axis should be provided');
  }

  processScrollDiff$1(i, diff, fields, useScrollingClass, forceFireReachEvent);
};

function processScrollDiff$1(
  i,
  diff,
  ref,
  useScrollingClass,
  forceFireReachEvent
) {
  var contentHeight = ref[0];
  var containerHeight = ref[1];
  var scrollTop = ref[2];
  var y = ref[3];
  var up = ref[4];
  var down = ref[5];
  if ( useScrollingClass === void 0 ) useScrollingClass = true;
  if ( forceFireReachEvent === void 0 ) forceFireReachEvent = false;

  var element = i.element;

  // reset reach
  i.reach[y] = null;

  // 1 for subpixel rounding
  if (element[scrollTop] < 1) {
    i.reach[y] = 'start';
  }

  // 1 for subpixel rounding
  if (element[scrollTop] > i[contentHeight] - i[containerHeight] - 1) {
    i.reach[y] = 'end';
  }

  if (diff) {
    element.dispatchEvent(createEvent(("ps-scroll-" + y)));

    if (diff < 0) {
      element.dispatchEvent(createEvent(("ps-scroll-" + up)));
    } else if (diff > 0) {
      element.dispatchEvent(createEvent(("ps-scroll-" + down)));
    }

    if (useScrollingClass) {
      setScrollingClassInstantly(i, y);
    }
  }

  if (i.reach[y] && (diff || forceFireReachEvent)) {
    element.dispatchEvent(createEvent(("ps-" + y + "-reach-" + (i.reach[y]))));
  }
}

function toInt(x) {
  return parseInt(x, 10) || 0;
}

function isEditable(el) {
  return (
    matches(el, 'input,[contenteditable]') ||
    matches(el, 'select,[contenteditable]') ||
    matches(el, 'textarea,[contenteditable]') ||
    matches(el, 'button,[contenteditable]')
  );
}

function outerWidth(element) {
  var styles = get(element);
  return (
    toInt(styles.width) +
    toInt(styles.paddingLeft) +
    toInt(styles.paddingRight) +
    toInt(styles.borderLeftWidth) +
    toInt(styles.borderRightWidth)
  );
}

var env = {
  isWebKit:
    typeof document !== 'undefined' &&
    'WebkitAppearance' in document.documentElement.style,
  supportsTouch:
    typeof window !== 'undefined' &&
    ('ontouchstart' in window ||
      (window.DocumentTouch && document instanceof window.DocumentTouch)),
  supportsIePointer:
    typeof navigator !== 'undefined' && navigator.msMaxTouchPoints,
  isChrome:
    typeof navigator !== 'undefined' &&
    /Chrome/i.test(navigator && navigator.userAgent),
};

var updateGeometry = function(i) {
  var element = i.element;

  i.containerWidth = element.clientWidth;
  i.containerHeight = element.clientHeight;
  i.contentWidth = element.scrollWidth;
  i.contentHeight = element.scrollHeight;

  if (!element.contains(i.scrollbarXRail)) {
    // clean up and append
    queryChildren(element, cls.element.rail('x')).forEach(function (el) { return remove(el); }
    );
    element.appendChild(i.scrollbarXRail);
  }
  if (!element.contains(i.scrollbarYRail)) {
    // clean up and append
    queryChildren(element, cls.element.rail('y')).forEach(function (el) { return remove(el); }
    );
    element.appendChild(i.scrollbarYRail);
  }

  if (
    !i.settings.suppressScrollX &&
    i.containerWidth + i.settings.scrollXMarginOffset < i.contentWidth
  ) {
    i.scrollbarXActive = true;
    i.railXWidth = i.containerWidth - i.railXMarginWidth;
    i.railXRatio = i.containerWidth / i.railXWidth;
    i.scrollbarXWidth = getThumbSize(
      i,
      toInt(i.railXWidth * i.containerWidth / i.contentWidth)
    );
    i.scrollbarXLeft = toInt(
      (i.negativeScrollAdjustment + element.scrollLeft) *
        (i.railXWidth - i.scrollbarXWidth) /
        (i.contentWidth - i.containerWidth)
    );
  } else {
    i.scrollbarXActive = false;
  }

  if (
    !i.settings.suppressScrollY &&
    i.containerHeight + i.settings.scrollYMarginOffset < i.contentHeight
  ) {
    i.scrollbarYActive = true;
    i.railYHeight = i.containerHeight - i.railYMarginHeight;
    i.railYRatio = i.containerHeight / i.railYHeight;
    i.scrollbarYHeight = getThumbSize(
      i,
      toInt(i.railYHeight * i.containerHeight / i.contentHeight)
    );
    i.scrollbarYTop = toInt(
      element.scrollTop *
        (i.railYHeight - i.scrollbarYHeight) /
        (i.contentHeight - i.containerHeight)
    );
  } else {
    i.scrollbarYActive = false;
  }

  if (i.scrollbarXLeft >= i.railXWidth - i.scrollbarXWidth) {
    i.scrollbarXLeft = i.railXWidth - i.scrollbarXWidth;
  }
  if (i.scrollbarYTop >= i.railYHeight - i.scrollbarYHeight) {
    i.scrollbarYTop = i.railYHeight - i.scrollbarYHeight;
  }

  updateCss(element, i);

  if (i.scrollbarXActive) {
    element.classList.add(cls.state.active('x'));
  } else {
    element.classList.remove(cls.state.active('x'));
    i.scrollbarXWidth = 0;
    i.scrollbarXLeft = 0;
    element.scrollLeft = 0;
  }
  if (i.scrollbarYActive) {
    element.classList.add(cls.state.active('y'));
  } else {
    element.classList.remove(cls.state.active('y'));
    i.scrollbarYHeight = 0;
    i.scrollbarYTop = 0;
    element.scrollTop = 0;
  }
};

function getThumbSize(i, thumbSize) {
  if (i.settings.minScrollbarLength) {
    thumbSize = Math.max(thumbSize, i.settings.minScrollbarLength);
  }
  if (i.settings.maxScrollbarLength) {
    thumbSize = Math.min(thumbSize, i.settings.maxScrollbarLength);
  }
  return thumbSize;
}

function updateCss(element, i) {
  var xRailOffset = { width: i.railXWidth };
  if (i.isRtl) {
    xRailOffset.left =
      i.negativeScrollAdjustment +
      element.scrollLeft +
      i.containerWidth -
      i.contentWidth;
  } else {
    xRailOffset.left = element.scrollLeft;
  }
  if (i.isScrollbarXUsingBottom) {
    xRailOffset.bottom = i.scrollbarXBottom - element.scrollTop;
  } else {
    xRailOffset.top = i.scrollbarXTop + element.scrollTop;
  }
  set(i.scrollbarXRail, xRailOffset);

  var yRailOffset = { top: element.scrollTop, height: i.railYHeight };
  if (i.isScrollbarYUsingRight) {
    if (i.isRtl) {
      yRailOffset.right =
        i.contentWidth -
        (i.negativeScrollAdjustment + element.scrollLeft) -
        i.scrollbarYRight -
        i.scrollbarYOuterWidth;
    } else {
      yRailOffset.right = i.scrollbarYRight - element.scrollLeft;
    }
  } else {
    if (i.isRtl) {
      yRailOffset.left =
        i.negativeScrollAdjustment +
        element.scrollLeft +
        i.containerWidth * 2 -
        i.contentWidth -
        i.scrollbarYLeft -
        i.scrollbarYOuterWidth;
    } else {
      yRailOffset.left = i.scrollbarYLeft + element.scrollLeft;
    }
  }
  set(i.scrollbarYRail, yRailOffset);

  set(i.scrollbarX, {
    left: i.scrollbarXLeft,
    width: i.scrollbarXWidth - i.railBorderXWidth,
  });
  set(i.scrollbarY, {
    top: i.scrollbarYTop,
    height: i.scrollbarYHeight - i.railBorderYWidth,
  });
}

var clickRail = function(i) {
  i.event.bind(i.scrollbarY, 'mousedown', function (e) { return e.stopPropagation(); });
  i.event.bind(i.scrollbarYRail, 'mousedown', function (e) {
    var positionTop =
      e.pageY -
      window.pageYOffset -
      i.scrollbarYRail.getBoundingClientRect().top;
    var direction = positionTop > i.scrollbarYTop ? 1 : -1;

    i.element.scrollTop += direction * i.containerHeight;
    updateGeometry(i);

    e.stopPropagation();
  });

  i.event.bind(i.scrollbarX, 'mousedown', function (e) { return e.stopPropagation(); });
  i.event.bind(i.scrollbarXRail, 'mousedown', function (e) {
    var positionLeft =
      e.pageX -
      window.pageXOffset -
      i.scrollbarXRail.getBoundingClientRect().left;
    var direction = positionLeft > i.scrollbarXLeft ? 1 : -1;

    i.element.scrollLeft += direction * i.containerWidth;
    updateGeometry(i);

    e.stopPropagation();
  });
};

var dragThumb = function(i) {
  bindMouseScrollHandler(i, [
    'containerWidth',
    'contentWidth',
    'pageX',
    'railXWidth',
    'scrollbarX',
    'scrollbarXWidth',
    'scrollLeft',
    'x' ]);
  bindMouseScrollHandler(i, [
    'containerHeight',
    'contentHeight',
    'pageY',
    'railYHeight',
    'scrollbarY',
    'scrollbarYHeight',
    'scrollTop',
    'y' ]);
};

function bindMouseScrollHandler(
  i,
  ref
) {
  var containerHeight = ref[0];
  var contentHeight = ref[1];
  var pageY = ref[2];
  var railYHeight = ref[3];
  var scrollbarY = ref[4];
  var scrollbarYHeight = ref[5];
  var scrollTop = ref[6];
  var y = ref[7];

  var element = i.element;

  var startingScrollTop = null;
  var startingMousePageY = null;
  var scrollBy = null;

  function mouseMoveHandler(e) {
    element[scrollTop] =
      startingScrollTop + scrollBy * (e[pageY] - startingMousePageY);
    addScrollingClass(i, y);
    updateGeometry(i);

    e.stopPropagation();
    e.preventDefault();
  }

  function mouseUpHandler() {
    removeScrollingClass(i, y);
    i.event.unbind(i.ownerDocument, 'mousemove', mouseMoveHandler);
  }

  i.event.bind(i[scrollbarY], 'mousedown', function (e) {
    startingScrollTop = element[scrollTop];
    startingMousePageY = e[pageY];
    scrollBy =
      (i[contentHeight] - i[containerHeight]) /
      (i[railYHeight] - i[scrollbarYHeight]);

    i.event.bind(i.ownerDocument, 'mousemove', mouseMoveHandler);
    i.event.once(i.ownerDocument, 'mouseup', mouseUpHandler);

    e.stopPropagation();
    e.preventDefault();
  });
}

var keyboard = function(i) {
  var element = i.element;

  var elementHovered = function () { return matches(element, ':hover'); };
  var scrollbarFocused = function () { return matches(i.scrollbarX, ':focus') || matches(i.scrollbarY, ':focus'); };

  function shouldPreventDefault(deltaX, deltaY) {
    var scrollTop = element.scrollTop;
    if (deltaX === 0) {
      if (!i.scrollbarYActive) {
        return false;
      }
      if (
        (scrollTop === 0 && deltaY > 0) ||
        (scrollTop >= i.contentHeight - i.containerHeight && deltaY < 0)
      ) {
        return !i.settings.wheelPropagation;
      }
    }

    var scrollLeft = element.scrollLeft;
    if (deltaY === 0) {
      if (!i.scrollbarXActive) {
        return false;
      }
      if (
        (scrollLeft === 0 && deltaX < 0) ||
        (scrollLeft >= i.contentWidth - i.containerWidth && deltaX > 0)
      ) {
        return !i.settings.wheelPropagation;
      }
    }
    return true;
  }

  i.event.bind(i.ownerDocument, 'keydown', function (e) {
    if (
      (e.isDefaultPrevented && e.isDefaultPrevented()) ||
      e.defaultPrevented
    ) {
      return;
    }

    if (!elementHovered() && !scrollbarFocused()) {
      return;
    }

    var activeElement = document.activeElement
      ? document.activeElement
      : i.ownerDocument.activeElement;
    if (activeElement) {
      if (activeElement.tagName === 'IFRAME') {
        activeElement = activeElement.contentDocument.activeElement;
      } else {
        // go deeper if element is a webcomponent
        while (activeElement.shadowRoot) {
          activeElement = activeElement.shadowRoot.activeElement;
        }
      }
      if (isEditable(activeElement)) {
        return;
      }
    }

    var deltaX = 0;
    var deltaY = 0;

    switch (e.which) {
      case 37: // left
        if (e.metaKey) {
          deltaX = -i.contentWidth;
        } else if (e.altKey) {
          deltaX = -i.containerWidth;
        } else {
          deltaX = -30;
        }
        break;
      case 38: // up
        if (e.metaKey) {
          deltaY = i.contentHeight;
        } else if (e.altKey) {
          deltaY = i.containerHeight;
        } else {
          deltaY = 30;
        }
        break;
      case 39: // right
        if (e.metaKey) {
          deltaX = i.contentWidth;
        } else if (e.altKey) {
          deltaX = i.containerWidth;
        } else {
          deltaX = 30;
        }
        break;
      case 40: // down
        if (e.metaKey) {
          deltaY = -i.contentHeight;
        } else if (e.altKey) {
          deltaY = -i.containerHeight;
        } else {
          deltaY = -30;
        }
        break;
      case 32: // space bar
        if (e.shiftKey) {
          deltaY = i.containerHeight;
        } else {
          deltaY = -i.containerHeight;
        }
        break;
      case 33: // page up
        deltaY = i.containerHeight;
        break;
      case 34: // page down
        deltaY = -i.containerHeight;
        break;
      case 36: // home
        deltaY = i.contentHeight;
        break;
      case 35: // end
        deltaY = -i.contentHeight;
        break;
      default:
        return;
    }

    if (i.settings.suppressScrollX && deltaX !== 0) {
      return;
    }
    if (i.settings.suppressScrollY && deltaY !== 0) {
      return;
    }

    element.scrollTop -= deltaY;
    element.scrollLeft += deltaX;
    updateGeometry(i);

    if (shouldPreventDefault(deltaX, deltaY)) {
      e.preventDefault();
    }
  });
};

var wheel = function(i) {
  var element = i.element;

  function shouldPreventDefault(deltaX, deltaY) {
    var isTop = element.scrollTop === 0;
    var isBottom =
      element.scrollTop + element.offsetHeight === element.scrollHeight;
    var isLeft = element.scrollLeft === 0;
    var isRight =
      element.scrollLeft + element.offsetWidth === element.offsetWidth;

    var hitsBound;

    // pick axis with primary direction
    if (Math.abs(deltaY) > Math.abs(deltaX)) {
      hitsBound = isTop || isBottom;
    } else {
      hitsBound = isLeft || isRight;
    }

    return hitsBound ? !i.settings.wheelPropagation : true;
  }

  function getDeltaFromEvent(e) {
    var deltaX = e.deltaX;
    var deltaY = -1 * e.deltaY;

    if (typeof deltaX === 'undefined' || typeof deltaY === 'undefined') {
      // OS X Safari
      deltaX = -1 * e.wheelDeltaX / 6;
      deltaY = e.wheelDeltaY / 6;
    }

    if (e.deltaMode && e.deltaMode === 1) {
      // Firefox in deltaMode 1: Line scrolling
      deltaX *= 10;
      deltaY *= 10;
    }

    if (deltaX !== deltaX && deltaY !== deltaY /* NaN checks */) {
      // IE in some mouse drivers
      deltaX = 0;
      deltaY = e.wheelDelta;
    }

    if (e.shiftKey) {
      // reverse axis with shift key
      return [-deltaY, -deltaX];
    }
    return [deltaX, deltaY];
  }

  function shouldBeConsumedByChild(target, deltaX, deltaY) {
    // FIXME: this is a workaround for <select> issue in FF and IE #571
    if (!env.isWebKit && element.querySelector('select:focus')) {
      return true;
    }

    if (!element.contains(target)) {
      return false;
    }

    var cursor = target;

    while (cursor && cursor !== element) {
      if (cursor.classList.contains(cls.element.consuming)) {
        return true;
      }

      var style = get(cursor);
      var overflow = [style.overflow, style.overflowX, style.overflowY].join(
        ''
      );

      // if scrollable
      if (overflow.match(/(scroll|auto)/)) {
        var maxScrollTop = cursor.scrollHeight - cursor.clientHeight;
        if (maxScrollTop > 0) {
          if (
            !(cursor.scrollTop === 0 && deltaY > 0) &&
            !(cursor.scrollTop === maxScrollTop && deltaY < 0)
          ) {
            return true;
          }
        }
        var maxScrollLeft = cursor.scrollLeft - cursor.clientWidth;
        if (maxScrollLeft > 0) {
          if (
            !(cursor.scrollLeft === 0 && deltaX < 0) &&
            !(cursor.scrollLeft === maxScrollLeft && deltaX > 0)
          ) {
            return true;
          }
        }
      }

      cursor = cursor.parentNode;
    }

    return false;
  }

  function mousewheelHandler(e) {
    var ref = getDeltaFromEvent(e);
    var deltaX = ref[0];
    var deltaY = ref[1];

    if (shouldBeConsumedByChild(e.target, deltaX, deltaY)) {
      return;
    }

    var shouldPrevent = false;
    if (!i.settings.useBothWheelAxes) {
      // deltaX will only be used for horizontal scrolling and deltaY will
      // only be used for vertical scrolling - this is the default
      element.scrollTop -= deltaY * i.settings.wheelSpeed;
      element.scrollLeft += deltaX * i.settings.wheelSpeed;
    } else if (i.scrollbarYActive && !i.scrollbarXActive) {
      // only vertical scrollbar is active and useBothWheelAxes option is
      // active, so let's scroll vertical bar using both mouse wheel axes
      if (deltaY) {
        element.scrollTop -= deltaY * i.settings.wheelSpeed;
      } else {
        element.scrollTop += deltaX * i.settings.wheelSpeed;
      }
      shouldPrevent = true;
    } else if (i.scrollbarXActive && !i.scrollbarYActive) {
      // useBothWheelAxes and only horizontal bar is active, so use both
      // wheel axes for horizontal bar
      if (deltaX) {
        element.scrollLeft += deltaX * i.settings.wheelSpeed;
      } else {
        element.scrollLeft -= deltaY * i.settings.wheelSpeed;
      }
      shouldPrevent = true;
    }

    updateGeometry(i);

    shouldPrevent = shouldPrevent || shouldPreventDefault(deltaX, deltaY);
    if (shouldPrevent && !e.ctrlKey) {
      e.stopPropagation();
      e.preventDefault();
    }
  }

  if (typeof window.onwheel !== 'undefined') {
    i.event.bind(element, 'wheel', mousewheelHandler);
  } else if (typeof window.onmousewheel !== 'undefined') {
    i.event.bind(element, 'mousewheel', mousewheelHandler);
  }
};

var touch = function(i) {
  if (!env.supportsTouch && !env.supportsIePointer) {
    return;
  }

  var element = i.element;

  function shouldPrevent(deltaX, deltaY) {
    var scrollTop = element.scrollTop;
    var scrollLeft = element.scrollLeft;
    var magnitudeX = Math.abs(deltaX);
    var magnitudeY = Math.abs(deltaY);

    if (magnitudeY > magnitudeX) {
      // user is perhaps trying to swipe up/down the page

      if (
        (deltaY < 0 && scrollTop === i.contentHeight - i.containerHeight) ||
        (deltaY > 0 && scrollTop === 0)
      ) {
        // set prevent for mobile Chrome refresh
        return window.scrollY === 0 && deltaY > 0 && env.isChrome;
      }
    } else if (magnitudeX > magnitudeY) {
      // user is perhaps trying to swipe left/right across the page

      if (
        (deltaX < 0 && scrollLeft === i.contentWidth - i.containerWidth) ||
        (deltaX > 0 && scrollLeft === 0)
      ) {
        return true;
      }
    }

    return true;
  }

  function applyTouchMove(differenceX, differenceY) {
    element.scrollTop -= differenceY;
    element.scrollLeft -= differenceX;

    updateGeometry(i);
  }

  var startOffset = {};
  var startTime = 0;
  var speed = {};
  var easingLoop = null;

  function getTouch(e) {
    if (e.targetTouches) {
      return e.targetTouches[0];
    } else {
      // Maybe IE pointer
      return e;
    }
  }

  function shouldHandle(e) {
    if (e.pointerType && e.pointerType === 'pen' && e.buttons === 0) {
      return false;
    }
    if (e.targetTouches && e.targetTouches.length === 1) {
      return true;
    }
    if (
      e.pointerType &&
      e.pointerType !== 'mouse' &&
      e.pointerType !== e.MSPOINTER_TYPE_MOUSE
    ) {
      return true;
    }
    return false;
  }

  function touchStart(e) {
    if (!shouldHandle(e)) {
      return;
    }

    var touch = getTouch(e);

    startOffset.pageX = touch.pageX;
    startOffset.pageY = touch.pageY;

    startTime = new Date().getTime();

    if (easingLoop !== null) {
      clearInterval(easingLoop);
    }
  }

  function shouldBeConsumedByChild(target, deltaX, deltaY) {
    if (!element.contains(target)) {
      return false;
    }

    var cursor = target;

    while (cursor && cursor !== element) {
      if (cursor.classList.contains(cls.element.consuming)) {
        return true;
      }

      var style = get(cursor);
      var overflow = [style.overflow, style.overflowX, style.overflowY].join(
        ''
      );

      // if scrollable
      if (overflow.match(/(scroll|auto)/)) {
        var maxScrollTop = cursor.scrollHeight - cursor.clientHeight;
        if (maxScrollTop > 0) {
          if (
            !(cursor.scrollTop === 0 && deltaY > 0) &&
            !(cursor.scrollTop === maxScrollTop && deltaY < 0)
          ) {
            return true;
          }
        }
        var maxScrollLeft = cursor.scrollLeft - cursor.clientWidth;
        if (maxScrollLeft > 0) {
          if (
            !(cursor.scrollLeft === 0 && deltaX < 0) &&
            !(cursor.scrollLeft === maxScrollLeft && deltaX > 0)
          ) {
            return true;
          }
        }
      }

      cursor = cursor.parentNode;
    }

    return false;
  }

  function touchMove(e) {
    if (shouldHandle(e)) {
      var touch = getTouch(e);

      var currentOffset = { pageX: touch.pageX, pageY: touch.pageY };

      var differenceX = currentOffset.pageX - startOffset.pageX;
      var differenceY = currentOffset.pageY - startOffset.pageY;

      if (shouldBeConsumedByChild(e.target, differenceX, differenceY)) {
        return;
      }

      applyTouchMove(differenceX, differenceY);
      startOffset = currentOffset;

      var currentTime = new Date().getTime();

      var timeGap = currentTime - startTime;
      if (timeGap > 0) {
        speed.x = differenceX / timeGap;
        speed.y = differenceY / timeGap;
        startTime = currentTime;
      }

      if (shouldPrevent(differenceX, differenceY)) {
        e.preventDefault();
      }
    }
  }
  function touchEnd() {
    if (i.settings.swipeEasing) {
      clearInterval(easingLoop);
      easingLoop = setInterval(function() {
        if (i.isInitialized) {
          clearInterval(easingLoop);
          return;
        }

        if (!speed.x && !speed.y) {
          clearInterval(easingLoop);
          return;
        }

        if (Math.abs(speed.x) < 0.01 && Math.abs(speed.y) < 0.01) {
          clearInterval(easingLoop);
          return;
        }

        applyTouchMove(speed.x * 30, speed.y * 30);

        speed.x *= 0.8;
        speed.y *= 0.8;
      }, 10);
    }
  }

  if (env.supportsTouch) {
    i.event.bind(element, 'touchstart', touchStart);
    i.event.bind(element, 'touchmove', touchMove);
    i.event.bind(element, 'touchend', touchEnd);
  } else if (env.supportsIePointer) {
    if (window.PointerEvent) {
      i.event.bind(element, 'pointerdown', touchStart);
      i.event.bind(element, 'pointermove', touchMove);
      i.event.bind(element, 'pointerup', touchEnd);
    } else if (window.MSPointerEvent) {
      i.event.bind(element, 'MSPointerDown', touchStart);
      i.event.bind(element, 'MSPointerMove', touchMove);
      i.event.bind(element, 'MSPointerUp', touchEnd);
    }
  }
};

var defaultSettings = function () { return ({
  handlers: ['click-rail', 'drag-thumb', 'keyboard', 'wheel', 'touch'],
  maxScrollbarLength: null,
  minScrollbarLength: null,
  scrollingThreshold: 1000,
  scrollXMarginOffset: 0,
  scrollYMarginOffset: 0,
  suppressScrollX: false,
  suppressScrollY: false,
  swipeEasing: true,
  useBothWheelAxes: false,
  wheelPropagation: false,
  wheelSpeed: 1,
}); };

var handlers = {
  'click-rail': clickRail,
  'drag-thumb': dragThumb,
  keyboard: keyboard,
  wheel: wheel,
  touch: touch,
};

var PerfectScrollbar = function PerfectScrollbar(element, userSettings) {
  var this$1 = this;
  if ( userSettings === void 0 ) userSettings = {};

  if (typeof element === 'string') {
    element = document.querySelector(element);
  }

  if (!element || !element.nodeName) {
    throw new Error('no element is specified to initialize PerfectScrollbar');
  }

  this.element = element;

  element.classList.add(cls.main);

  this.settings = defaultSettings();
  for (var key in userSettings) {
    this$1.settings[key] = userSettings[key];
  }

  this.containerWidth = null;
  this.containerHeight = null;
  this.contentWidth = null;
  this.contentHeight = null;

  var focus = function () { return element.classList.add(cls.state.focus); };
  var blur = function () { return element.classList.remove(cls.state.focus); };

  this.isRtl = get(element).direction === 'rtl';
  this.isNegativeScroll = (function () {
    var originalScrollLeft = element.scrollLeft;
    var result = null;
    element.scrollLeft = -1;
    result = element.scrollLeft < 0;
    element.scrollLeft = originalScrollLeft;
    return result;
  })();
  this.negativeScrollAdjustment = this.isNegativeScroll
    ? element.scrollWidth - element.clientWidth
    : 0;
  this.event = new EventManager();
  this.ownerDocument = element.ownerDocument || document;

  this.scrollbarXRail = div(cls.element.rail('x'));
  element.appendChild(this.scrollbarXRail);
  this.scrollbarX = div(cls.element.thumb('x'));
  this.scrollbarXRail.appendChild(this.scrollbarX);
  this.scrollbarX.setAttribute('tabindex', 0);
  this.event.bind(this.scrollbarX, 'focus', focus);
  this.event.bind(this.scrollbarX, 'blur', blur);
  this.scrollbarXActive = null;
  this.scrollbarXWidth = null;
  this.scrollbarXLeft = null;
  var railXStyle = get(this.scrollbarXRail);
  this.scrollbarXBottom = parseInt(railXStyle.bottom, 10);
  if (isNaN(this.scrollbarXBottom)) {
    this.isScrollbarXUsingBottom = false;
    this.scrollbarXTop = toInt(railXStyle.top);
  } else {
    this.isScrollbarXUsingBottom = true;
  }
  this.railBorderXWidth =
    toInt(railXStyle.borderLeftWidth) + toInt(railXStyle.borderRightWidth);
  // Set rail to display:block to calculate margins
  set(this.scrollbarXRail, { display: 'block' });
  this.railXMarginWidth =
    toInt(railXStyle.marginLeft) + toInt(railXStyle.marginRight);
  set(this.scrollbarXRail, { display: '' });
  this.railXWidth = null;
  this.railXRatio = null;

  this.scrollbarYRail = div(cls.element.rail('y'));
  element.appendChild(this.scrollbarYRail);
  this.scrollbarY = div(cls.element.thumb('y'));
  this.scrollbarYRail.appendChild(this.scrollbarY);
  this.scrollbarY.setAttribute('tabindex', 0);
  this.event.bind(this.scrollbarY, 'focus', focus);
  this.event.bind(this.scrollbarY, 'blur', blur);
  this.scrollbarYActive = null;
  this.scrollbarYHeight = null;
  this.scrollbarYTop = null;
  var railYStyle = get(this.scrollbarYRail);
  this.scrollbarYRight = parseInt(railYStyle.right, 10);
  if (isNaN(this.scrollbarYRight)) {
    this.isScrollbarYUsingRight = false;
    this.scrollbarYLeft = toInt(railYStyle.left);
  } else {
    this.isScrollbarYUsingRight = true;
  }
  this.scrollbarYOuterWidth = this.isRtl ? outerWidth(this.scrollbarY) : null;
  this.railBorderYWidth =
    toInt(railYStyle.borderTopWidth) + toInt(railYStyle.borderBottomWidth);
  set(this.scrollbarYRail, { display: 'block' });
  this.railYMarginHeight =
    toInt(railYStyle.marginTop) + toInt(railYStyle.marginBottom);
  set(this.scrollbarYRail, { display: '' });
  this.railYHeight = null;
  this.railYRatio = null;

  this.reach = {
    x:
      element.scrollLeft <= 0
        ? 'start'
        : element.scrollLeft >= this.contentWidth - this.containerWidth
          ? 'end'
          : null,
    y:
      element.scrollTop <= 0
        ? 'start'
        : element.scrollTop >= this.contentHeight - this.containerHeight
          ? 'end'
          : null,
  };

  this.isAlive = true;

  this.settings.handlers.forEach(function (handlerName) { return handlers[handlerName](this$1); });

  this.lastScrollTop = element.scrollTop; // for onScroll only
  this.lastScrollLeft = element.scrollLeft; // for onScroll only
  this.event.bind(this.element, 'scroll', function (e) { return this$1.onScroll(e); });
  updateGeometry(this);
};

PerfectScrollbar.prototype.update = function update () {
  if (!this.isAlive) {
    return;
  }

  // Recalcuate negative scrollLeft adjustment
  this.negativeScrollAdjustment = this.isNegativeScroll
    ? this.element.scrollWidth - this.element.clientWidth
    : 0;

  // Recalculate rail margins
  set(this.scrollbarXRail, { display: 'block' });
  set(this.scrollbarYRail, { display: 'block' });
  this.railXMarginWidth =
    toInt(get(this.scrollbarXRail).marginLeft) +
    toInt(get(this.scrollbarXRail).marginRight);
  this.railYMarginHeight =
    toInt(get(this.scrollbarYRail).marginTop) +
    toInt(get(this.scrollbarYRail).marginBottom);

  // Hide scrollbars not to affect scrollWidth and scrollHeight
  set(this.scrollbarXRail, { display: 'none' });
  set(this.scrollbarYRail, { display: 'none' });

  updateGeometry(this);

  processScrollDiff(this, 'top', 0, false, true);
  processScrollDiff(this, 'left', 0, false, true);

  set(this.scrollbarXRail, { display: '' });
  set(this.scrollbarYRail, { display: '' });
};

PerfectScrollbar.prototype.onScroll = function onScroll (e) {
  if (!this.isAlive) {
    return;
  }

  updateGeometry(this);
  processScrollDiff(this, 'top', this.element.scrollTop - this.lastScrollTop);
  processScrollDiff(
    this,
    'left',
    this.element.scrollLeft - this.lastScrollLeft
  );

  this.lastScrollTop = this.element.scrollTop;
  this.lastScrollLeft = this.element.scrollLeft;
};

PerfectScrollbar.prototype.destroy = function destroy () {
  if (!this.isAlive) {
    return;
  }

  this.event.unbindAll();
  remove(this.scrollbarX);
  remove(this.scrollbarY);
  remove(this.scrollbarXRail);
  remove(this.scrollbarYRail);
  this.removePsClasses();

  // unset elements
  this.element = null;
  this.scrollbarX = null;
  this.scrollbarY = null;
  this.scrollbarXRail = null;
  this.scrollbarYRail = null;

  this.isAlive = false;
};

PerfectScrollbar.prototype.removePsClasses = function removePsClasses () {
  this.element.className = this.element.className
    .split(' ')
    .filter(function (name) { return !name.match(/^ps([-_].+|)$/); })
    .join(' ');
};

/* harmony default export */ __webpack_exports__["a"] = (PerfectScrollbar);


/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var asap = __webpack_require__(581);

var PENDING   = 0,
    FULFILLED = 1,
    REJECTED  = 2;

var RETURN = function(x) { return x },
    THROW  = function(x) { throw  x };

var Promise = function(task) {
  this._state       = PENDING;
  this._onFulfilled = [];
  this._onRejected  = [];

  if (typeof task !== 'function') return;
  var self = this;

  task(function(value)  { resolve(self, value) },
       function(reason) { reject(self, reason) });
};

Promise.prototype.then = function(onFulfilled, onRejected) {
  var next = new Promise();
  registerOnFulfilled(this, onFulfilled, next);
  registerOnRejected(this, onRejected, next);
  return next;
};

Promise.prototype['catch'] = function(onRejected) {
  return this.then(null, onRejected);
};

var registerOnFulfilled = function(promise, onFulfilled, next) {
  if (typeof onFulfilled !== 'function') onFulfilled = RETURN;
  var handler = function(value) { invoke(onFulfilled, value, next) };

  if (promise._state === PENDING) {
    promise._onFulfilled.push(handler);
  } else if (promise._state === FULFILLED) {
    handler(promise._value);
  }
};

var registerOnRejected = function(promise, onRejected, next) {
  if (typeof onRejected !== 'function') onRejected = THROW;
  var handler = function(reason) { invoke(onRejected, reason, next) };

  if (promise._state === PENDING) {
    promise._onRejected.push(handler);
  } else if (promise._state === REJECTED) {
    handler(promise._reason);
  }
};

var invoke = function(fn, value, next) {
  asap(function() { _invoke(fn, value, next) });
};

var _invoke = function(fn, value, next) {
  var outcome;

  try {
    outcome = fn(value);
  } catch (error) {
    return reject(next, error);
  }

  if (outcome === next) {
    reject(next, new TypeError('Recursive promise chain detected'));
  } else {
    resolve(next, outcome);
  }
};

var resolve = function(promise, value) {
  var called = false, type, then;

  try {
    type = typeof value;
    then = value !== null && (type === 'function' || type === 'object') && value.then;

    if (typeof then !== 'function') return fulfill(promise, value);

    then.call(value, function(v) {
      if (!(called ^ (called = true))) return;
      resolve(promise, v);
    }, function(r) {
      if (!(called ^ (called = true))) return;
      reject(promise, r);
    });
  } catch (error) {
    if (!(called ^ (called = true))) return;
    reject(promise, error);
  }
};

var fulfill = function(promise, value) {
  if (promise._state !== PENDING) return;

  promise._state      = FULFILLED;
  promise._value      = value;
  promise._onRejected = [];

  var onFulfilled = promise._onFulfilled, fn;
  while (fn = onFulfilled.shift()) fn(value);
};

var reject = function(promise, reason) {
  if (promise._state !== PENDING) return;

  promise._state       = REJECTED;
  promise._reason      = reason;
  promise._onFulfilled = [];

  var onRejected = promise._onRejected, fn;
  while (fn = onRejected.shift()) fn(reason);
};

Promise.resolve = function(value) {
  return new Promise(function(resolve, reject) { resolve(value) });
};

Promise.reject = function(reason) {
  return new Promise(function(resolve, reject) { reject(reason) });
};

Promise.all = function(promises) {
  return new Promise(function(resolve, reject) {
    var list = [], n = promises.length, i;

    if (n === 0) return resolve(list);

    for (i = 0; i < n; i++) (function(promise, i) {
      Promise.resolve(promise).then(function(value) {
        list[i] = value;
        if (--n === 0) resolve(list);
      }, reject);
    })(promises[i], i);
  });
};

Promise.race = function(promises) {
  return new Promise(function(resolve, reject) {
    for (var i = 0, n = promises.length; i < n; i++)
      Promise.resolve(promises[i]).then(resolve, reject);
  });
};

Promise.deferred = Promise.pending = function() {
  var tuple = {};

  tuple.promise = new Promise(function(resolve, reject) {
    tuple.resolve = resolve;
    tuple.reject  = reject;
  });
  return tuple;
};

module.exports = Promise;


/***/ }),
/* 247 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_assets_jss_material_dashboard_pro_react_components_cardIconStyle_jsx__ = __webpack_require__(2333);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}// nodejs library that concatenates classes
// nodejs library to set properties for components
// @material-ui/core components
// @material-ui/icons
// core components
function CardIcon(_ref){var _classNames;var props=_objectWithoutProperties(_ref,[]);var classes=props.classes,className=props.className,children=props.children,color=props.color,rest=_objectWithoutProperties(props,["classes","className","children","color"]);var cardIconClasses=__WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classNames={},_defineProperty(_classNames,classes.cardIcon,true),_defineProperty(_classNames,classes[color+"CardHeader"],color),_defineProperty(_classNames,className,className!==undefined),_classNames));return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",Object.assign({className:cardIconClasses},rest),children);}CardIcon.propTypes={classes:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,className:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,color:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(["warning","success","danger","info","primary","rose","deepPurple","yellow","grayBlue","sqPurple","sqPurpleSecond","sqOrange","sqLightBlue"])};/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles___default()(__WEBPACK_IMPORTED_MODULE_4_assets_jss_material_dashboard_pro_react_components_cardIconStyle_jsx__["a" /* default */])(CardIcon));

/***/ }),
/* 248 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(372);
var IE8_DOM_DEFINE = __webpack_require__(2355);
var toPrimitive = __webpack_require__(2356);
var dP = Object.defineProperty;

exports.f = __webpack_require__(187) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 250 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 251 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__ = __webpack_require__(65);
var userProfileStyles={cardTitle:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["b" /* cardTitle */],cardIconTitle:Object.assign({},__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["b" /* cardTitle */],{marginTop:"15px",marginBottom:"0px","& small":{fontSize:"80%",fontWeight:"400"}}),cardCategory:{marginTop:"10px",color:"#999999 !important",textAlign:"center"},description:{color:"#999999"},updateProfileButton:{float:"right"}};/* harmony default export */ __webpack_exports__["a"] = (userProfileStyles);

/***/ }),
/* 252 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return BrokerageBrProfileUpdate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return BrokerProfileUpdate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AssistantProfileUpdate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return UpdateCompanyDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return UpdateAstuteDetails; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_graphql_tag__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_graphql_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_graphql_tag__);
var _templateObject=_taggedTemplateLiteral(["\n  mutation brokerageBrProfileUpdate($input: BrokerageBrProfileUpdateInput!) {\n    BrokerageBrProfileUpdate(input: $input) {\n      clientMutationId\n    }\n  }\n"],["\n  mutation brokerageBrProfileUpdate($input: BrokerageBrProfileUpdateInput!) {\n    BrokerageBrProfileUpdate(input: $input) {\n      clientMutationId\n    }\n  }\n"]),_templateObject2=_taggedTemplateLiteral(["\n  mutation brokerProfileUpdate($input: BrokerProfileUpdateInput!) {\n    BrokerProfileUpdate(input: $input) {\n      clientMutationId\n    }\n  }\n"],["\n  mutation brokerProfileUpdate($input: BrokerProfileUpdateInput!) {\n    BrokerProfileUpdate(input: $input) {\n      clientMutationId\n    }\n  }\n"]),_templateObject3=_taggedTemplateLiteral(["\n  mutation assistantProfileUpdate($input: AssistantProfileUpdateInput!) {\n    AssistantProfileUpdate(input: $input) {\n      clientMutationId\n    }\n  }\n"],["\n  mutation assistantProfileUpdate($input: AssistantProfileUpdateInput!) {\n    AssistantProfileUpdate(input: $input) {\n      clientMutationId\n    }\n  }\n"]),_templateObject4=_taggedTemplateLiteral(["\nmutation updateCompanyDetail($input: UpdateCompanyDetailInput!) {\n  UpdateCompanyDetail(input: $input) {\n    clientMutationId\n  }\n}\n"],["\nmutation updateCompanyDetail($input: UpdateCompanyDetailInput!) {\n  UpdateCompanyDetail(input: $input) {\n    clientMutationId\n  }\n}\n"]),_templateObject5=_taggedTemplateLiteral(["\nmutation updateAstuteDetails($input: UpdateAstuteDetailsInput!) {\n  UpdateAstuteDetails(input: $input) {\n    clientMutationId\n  }\n}\n"],["\nmutation updateAstuteDetails($input: UpdateAstuteDetailsInput!) {\n  UpdateAstuteDetails(input: $input) {\n    clientMutationId\n  }\n}\n"]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var BrokerageBrProfileUpdate=__WEBPACK_IMPORTED_MODULE_0_graphql_tag___default()(_templateObject);var BrokerProfileUpdate=__WEBPACK_IMPORTED_MODULE_0_graphql_tag___default()(_templateObject2);var AssistantProfileUpdate=__WEBPACK_IMPORTED_MODULE_0_graphql_tag___default()(_templateObject3);var UpdateCompanyDetail=__WEBPACK_IMPORTED_MODULE_0_graphql_tag___default()(_templateObject4);var UpdateAstuteDetails=__WEBPACK_IMPORTED_MODULE_0_graphql_tag___default()(_templateObject5);

/***/ }),
/* 253 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return updatePassword; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_graphql_tag__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_graphql_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_graphql_tag__);
var _templateObject=_taggedTemplateLiteral(["\n  mutation updatePassword($input: UpdatePasswordInput!) {\n    UpdatePassword(input: $input) {\n      clientMutationId\n    }\n  }\n"],["\n  mutation updatePassword($input: UpdatePasswordInput!) {\n    UpdatePassword(input: $input) {\n      clientMutationId\n    }\n  }\n"]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var updatePassword=__WEBPACK_IMPORTED_MODULE_0_graphql_tag___default()(_templateObject);

/***/ }),
/* 254 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = calculateIncomeAfterTax;
function calculateIncomeAfterTax(salaryPm,age){if(salaryPm<=0)return 0.0;var x=salaryPm*12;age=age?age:0;var rebate=x<78150?0:age<65?14067:age<75?21780:24354;var taxRate=x>=taxTable[taxTable.length-1].lower?taxTable[taxTable.length-1]:taxTable.filter(function(t){return x<=t.upper&&x>=t.lower;})[0];var tax=taxRate.standard+(x-(taxRate.lower-1))*taxRate.rate;x=x-tax+rebate;return parseFloat(x/12).toFixed(2);}var taxTable=[{lower:0,upper:195850,rate:0.18,standard:0},{lower:195851,upper:305850,rate:0.26,standard:35253},{lower:305851,upper:423300,rate:0.31,standard:63853},{lower:423301,upper:555600,rate:0.36,standard:100263},{lower:555601,upper:708310,rate:0.39,standard:147891},{lower:708311,upper:1500000,rate:0.41,standard:207448},{lower:1500001,rate:0.45,standard:532041}];

/***/ }),
/* 255 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_Wrappers_materialUIWrappers_components_FormInput__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_Wrappers_materialUIWrappers_components_FormDropDown__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Wrappers_materialUIWrappers_components_DatePicker__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_form__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core__ = __webpack_require__(4);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/*eslint-disable*/var required=function required(value){return value?undefined:"Required";};var requiredDropdown=function requiredDropdown(value){if(value==="validationError"){return"Required";}else if(value){return undefined;}else{return"Required";}};var styles=function styles(){return{};};var CC_bankDetail=function(_React$Component){_inherits(CC_bankDetail,_React$Component);function CC_bankDetail(){_classCallCheck(this,CC_bankDetail);return _possibleConstructorReturn(this,(CC_bankDetail.__proto__||Object.getPrototypeOf(CC_bankDetail)).apply(this,arguments));}_createClass(CC_bankDetail,[{key:"componentDidMount",value:function componentDidMount(){this.props.scrollMeBar();}},{key:"render",value:function render(){var validate=[];validate.push(required);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["e" /* Card */],{className:"contentWithStepper"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["g" /* CardHeader */],{title:"Client Bank Details"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["f" /* CardContent */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["v" /* Grid */],{container:true,spacing:24},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["v" /* Grid */],{item:true,xs:12,sm:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["t" /* FormControl */],{fullWidth:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["a" /* Field */],{name:"bankAccountName",component:__WEBPACK_IMPORTED_MODULE_1_components_Wrappers_materialUIWrappers_components_FormInput__["a" /* default */],label:"Account name"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["v" /* Grid */],{item:true,xs:12,sm:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["t" /* FormControl */],{fullWidth:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_2_components_Wrappers_materialUIWrappers_components_FormDropDown__["a" /* default */],checkValidation:this.props.checkValidation,label:"Bank",name:"bank",options:[{value:"validationError",displayValue:"Please select"},{value:"absa",displayValue:"Absa"},{value:"fnb",displayValue:"FNB"},{value:"capitec",displayValue:"Capitec"},{value:"nedbank",displayValue:"Nedbank"},{value:"standardbank",displayValue:"Standard Bank"},{value:"africanbank",displayValue:"African Bank"},{value:"mercantilebank",displayValue:"Mercantile Bank"},{value:"grindrodbank",displayValue:"Grindrod Bank"},{value:"bidvestbank",displayValue:"Bidvest Bank"},{value:"sasfin",displayValue:"Sasfin"},{value:"albarakabank",displayValue:"Albaraka Bank"},{value:"ubank",displayValue:"Ubank"},{value:"hbzbank",displayValue:"HBZ Bank"},{value:"southafricanbankofathens",displayValue:"South African Bank of Athens"},{value:"discoverybank",displayValue:"Discovery Bank"}]}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["v" /* Grid */],{item:true,xs:12,sm:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["t" /* FormControl */],{fullWidth:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["a" /* Field */],{name:"bankBranch",component:__WEBPACK_IMPORTED_MODULE_1_components_Wrappers_materialUIWrappers_components_FormInput__["a" /* default */],label:"Branch"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["v" /* Grid */],{item:true,xs:12,sm:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["t" /* FormControl */],{fullWidth:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["a" /* Field */],{name:"bankBranchCode",component:__WEBPACK_IMPORTED_MODULE_1_components_Wrappers_materialUIWrappers_components_FormInput__["a" /* default */],label:"Branch code"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["v" /* Grid */],{item:true,xs:12,sm:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["t" /* FormControl */],{fullWidth:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["a" /* Field */],{name:"bankAccNumber",component:__WEBPACK_IMPORTED_MODULE_1_components_Wrappers_materialUIWrappers_components_FormInput__["a" /* default */],label:"Account number"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["v" /* Grid */],{item:true,xs:12,sm:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["t" /* FormControl */],{fullWidth:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["a" /* Field */],{name:"bankAccountType",component:__WEBPACK_IMPORTED_MODULE_1_components_Wrappers_materialUIWrappers_components_FormInput__["a" /* default */],label:"Type of account"}))))));}}]);return CC_bankDetail;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["_1" /* withStyles */])(styles)(CC_bankDetail));

/***/ }),
/* 256 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_infinite_calendar__ = __webpack_require__(2381);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_infinite_calendar_styles_css__ = __webpack_require__(2420);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_infinite_calendar_styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_infinite_calendar_styles_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}//import Datetime from "react-datetime";
// only needs to be imported once
var styles=function styles(theme){return{datePicker:{width:"100%"}};};var DatePicker=function(_React$Component){_inherits(DatePicker,_React$Component);function DatePicker(props){_classCallCheck(this,DatePicker);var _this=_possibleConstructorReturn(this,(DatePicker.__proto__||Object.getPrototypeOf(DatePicker)).call(this,props));_this.state={open:false};_this.handleChange=function(event){if(_this.props.input.onChange){var date=__WEBPACK_IMPORTED_MODULE_2_moment___default()(event).format("YYYY-MM-DD");if(_this.props.dateChanged){_this.props.dateChanged(date);}_this.props.input.onChange(date);}};_this.handleChange=_this.handleChange.bind(_this);return _this;}_createClass(DatePicker,[{key:"componentWillReceiveProps",value:function componentWillReceiveProps(nextProps){if(nextProps.meta.touched||nextProps.input.value!==this.props.input.value||nextProps.p_value!==this.props.p_value){this.forceUpdate();}}},{key:"shouldComponentUpdate",value:function shouldComponentUpdate(){return false;}},{key:"openDialog",value:function openDialog(){this.setState({open:true});this.forceUpdate();}},{key:"closeDialog",value:function closeDialog(){this.setState({open:false});this.forceUpdate();}},{key:"render",value:function render(){var _this2=this;var lValue=new Date();var naDate=false;if(this.props.input.value){lValue=this.props.input.value;}else{naDate=true;}var open=this.state.open;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["t" /* FormControl */],{fullWidth:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["X" /* TextField */],{onClick:function onClick(){return _this2.openDialog();},value:naDate?"Please Select":lValue,label:this.props.label,InputProps:{readOnly:true}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["k" /* Dialog */],{"aria-labelledby":"form-dialog-title",open:open,onClose:function onClose(){return _this2.closeDialog();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["o" /* DialogTitle */],{id:"form-dialog-title"},"Choose Date"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["m" /* DialogContent */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_infinite_calendar__["a" /* default */],{width:400,height:300,selected:lValue,onSelect:this.handleChange,min:new Date(1900,0,1),minDate:new Date(1900,0,1),showTodayHelper:true,hideYearsOnSelect:false})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["l" /* DialogActions */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["d" /* Button */],{onClick:function onClick(){return _this2.closeDialog();},color:"primary"},"Close"))));}}]);return DatePicker;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["_1" /* withStyles */])(styles)(DatePicker));

/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _pick = __webpack_require__(2386);

var _pick2 = _interopRequireDefault(_pick);

var _shallowEqual = __webpack_require__(2387);

var _shallowEqual2 = _interopRequireDefault(_shallowEqual);

var _createHelper = __webpack_require__(147);

var _createHelper2 = _interopRequireDefault(_createHelper);

var _createEagerFactory = __webpack_require__(190);

var _createEagerFactory2 = _interopRequireDefault(_createEagerFactory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var withPropsOnChange = function withPropsOnChange(shouldMapOrKeys, propsMapper) {
  return function (BaseComponent) {
    var factory = (0, _createEagerFactory2.default)(BaseComponent);
    var shouldMap = typeof shouldMapOrKeys === 'function' ? shouldMapOrKeys : function (props, nextProps) {
      return !(0, _shallowEqual2.default)((0, _pick2.default)(props, shouldMapOrKeys), (0, _pick2.default)(nextProps, shouldMapOrKeys));
    };

    return function (_Component) {
      _inherits(_class2, _Component);

      function _class2() {
        var _temp, _this, _ret;

        _classCallCheck(this, _class2);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.computedProps = propsMapper(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
      }

      _class2.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        if (shouldMap(this.props, nextProps)) {
          this.computedProps = propsMapper(nextProps);
        }
      };

      _class2.prototype.render = function render() {
        return factory(_extends({}, this.props, this.computedProps));
      };

      return _class2;
    }(_react.Component);
  };
};

exports.default = (0, _createHelper2.default)(withPropsOnChange, 'withPropsOnChange');

/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(9)

/**
 * @category Month Helpers
 * @summary Get the number of days in a month of the given date.
 *
 * @description
 * Get the number of days in a month of the given date.
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the number of days in a month
 *
 * @example
 * // How many days are in February 2000?
 * var result = getDaysInMonth(new Date(2000, 1))
 * //=> 29
 */
function getDaysInMonth (dirtyDate) {
  var date = parse(dirtyDate)
  var year = date.getFullYear()
  var monthIndex = date.getMonth()
  var lastDayOfMonth = new Date(0)
  lastDayOfMonth.setFullYear(year, monthIndex + 1, 0)
  lastDayOfMonth.setHours(0, 0, 0, 0)
  return lastDayOfMonth.getDate()
}

module.exports = getDaysInMonth


/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(9)

/**
 * @category Common Helpers
 * @summary Is the first date after the second one?
 *
 * @description
 * Is the first date after the second one?
 *
 * @param {Date|String|Number} date - the date that should be after the other one to return true
 * @param {Date|String|Number} dateToCompare - the date to compare with
 * @returns {Boolean} the first date is after the second date
 *
 * @example
 * // Is 10 July 1989 after 11 February 1987?
 * var result = isAfter(new Date(1989, 6, 10), new Date(1987, 1, 11))
 * //=> true
 */
function isAfter (dirtyDate, dirtyDateToCompare) {
  var date = parse(dirtyDate)
  var dateToCompare = parse(dirtyDateToCompare)
  return date.getTime() > dateToCompare.getTime()
}

module.exports = isAfter


/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(9)

/**
 * @category Day Helpers
 * @summary Return the end of a day for the given date.
 *
 * @description
 * Return the end of a day for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the end of a day
 *
 * @example
 * // The end of a day for 2 September 2014 11:55:00:
 * var result = endOfDay(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 02 2014 23:59:59.999
 */
function endOfDay (dirtyDate) {
  var date = parse(dirtyDate)
  date.setHours(23, 59, 59, 999)
  return date
}

module.exports = endOfDay


/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

var startOfDay = __webpack_require__(82)

var MILLISECONDS_IN_MINUTE = 60000
var MILLISECONDS_IN_DAY = 86400000

/**
 * @category Day Helpers
 * @summary Get the number of calendar days between the given dates.
 *
 * @description
 * Get the number of calendar days between the given dates.
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @returns {Number} the number of calendar days
 *
 * @example
 * // How many calendar days are between
 * // 2 July 2011 23:00:00 and 2 July 2012 00:00:00?
 * var result = differenceInCalendarDays(
 *   new Date(2012, 6, 2, 0, 0),
 *   new Date(2011, 6, 2, 23, 0)
 * )
 * //=> 366
 */
function differenceInCalendarDays (dirtyDateLeft, dirtyDateRight) {
  var startOfDayLeft = startOfDay(dirtyDateLeft)
  var startOfDayRight = startOfDay(dirtyDateRight)

  var timestampLeft = startOfDayLeft.getTime() -
    startOfDayLeft.getTimezoneOffset() * MILLISECONDS_IN_MINUTE
  var timestampRight = startOfDayRight.getTime() -
    startOfDayRight.getTimezoneOffset() * MILLISECONDS_IN_MINUTE

  // Round the number of days to the nearest integer
  // because the number of milliseconds in a day is not constant
  // (e.g. it's different in the day of the daylight saving time clock shift)
  return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_DAY)
}

module.exports = differenceInCalendarDays


/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(9)

/**
 * @category Week Helpers
 * @summary Return the start of a week for the given date.
 *
 * @description
 * Return the start of a week for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @param {Object} [options] - the object with options
 * @param {Number} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @returns {Date} the start of a week
 *
 * @example
 * // The start of a week for 2 September 2014 11:55:00:
 * var result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sun Aug 31 2014 00:00:00
 *
 * @example
 * // If the week starts on Monday, the start of the week for 2 September 2014 11:55:00:
 * var result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0), {weekStartsOn: 1})
 * //=> Mon Sep 01 2014 00:00:00
 */
function startOfWeek (dirtyDate, dirtyOptions) {
  var weekStartsOn = dirtyOptions ? (Number(dirtyOptions.weekStartsOn) || 0) : 0

  var date = parse(dirtyDate)
  var day = date.getDay()
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn

  date.setDate(date.getDate() - diff)
  date.setHours(0, 0, 0, 0)
  return date
}

module.exports = startOfWeek


/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _createHelper = __webpack_require__(147);

var _createHelper2 = _interopRequireDefault(_createHelper);

var _createEagerFactory = __webpack_require__(190);

var _createEagerFactory2 = _interopRequireDefault(_createEagerFactory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var withState = function withState(stateName, stateUpdaterName, initialState) {
  return function (BaseComponent) {
    var factory = (0, _createEagerFactory2.default)(BaseComponent);
    return function (_Component) {
      _inherits(_class2, _Component);

      function _class2() {
        var _temp, _this, _ret;

        _classCallCheck(this, _class2);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
          stateValue: typeof initialState === 'function' ? initialState(_this.props) : initialState
        }, _this.updateStateValue = function (updateFn, callback) {
          return _this.setState(function (_ref) {
            var stateValue = _ref.stateValue;
            return {
              stateValue: typeof updateFn === 'function' ? updateFn(stateValue) : updateFn
            };
          }, callback);
        }, _temp), _possibleConstructorReturn(_this, _ret);
      }

      _class2.prototype.render = function render() {
        var _extends2;

        return factory(_extends({}, this.props, (_extends2 = {}, _extends2[stateName] = this.state.stateValue, _extends2[stateUpdaterName] = this.updateStateValue, _extends2)));
      };

      return _class2;
    }(_react.Component);
  };
};

exports.default = (0, _createHelper2.default)(withState, 'withState');

/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createHelper = __webpack_require__(147);

var _createHelper2 = _interopRequireDefault(_createHelper);

var _mapProps = __webpack_require__(2412);

var _mapProps2 = _interopRequireDefault(_mapProps);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var withProps = function withProps(input) {
  return (0, _mapProps2.default)(function (props) {
    return _extends({}, props, typeof input === 'function' ? input(props) : input);
  });
};

exports.default = (0, _createHelper2.default)(withProps, 'withProps');

/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = compose;
function compose() {
  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(undefined, arguments));
    };
  });
}

/***/ }),
/* 266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_core__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_apollo_cache_inmemory__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_apollo_client__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_apollo_upload_client__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_assets_img_faces_avatar1_jpg__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_assets_img_faces_avatar1_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_assets_img_faces_avatar1_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_Wrappers_materialUIWrappers_components_FormDropDown__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_Wrappers_materialUIWrappers_components_FormInput__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_constants_js__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_helpers_GetIdInformation__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_helpers_ValidationHelpers__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_dropzone__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_redux_form__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_store__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__FieldIndicators_jsx__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__coi_options__ = __webpack_require__(615);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/*eslint-disable*/var client=new __WEBPACK_IMPORTED_MODULE_2_apollo_client__["ApolloClient"]({link:Object(__WEBPACK_IMPORTED_MODULE_3_apollo_upload_client__["a" /* createUploadLink */])({uri:__WEBPACK_IMPORTED_MODULE_7_constants_js__["d" /* fileUploadServerPath */]}),cache:new __WEBPACK_IMPORTED_MODULE_1_apollo_cache_inmemory__["a" /* InMemoryCache */]()});var required=function required(value){return value?undefined:'Required';};var requiredDropdown=function requiredDropdown(value){if(!value||value==='validationError'){return'Required';}return undefined;};var charMin2=function charMin2(value){if(value===undefined)return undefined;if(value.length<2)return'Must be at least 2 characters';return undefined;};var styles=function styles(){return{};};var CC_clientForm=function(_React$Component){_inherits(CC_clientForm,_React$Component);function CC_clientForm(){var _ref;var _temp,_this,_ret;_classCallCheck(this,CC_clientForm);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=CC_clientForm.__proto__||Object.getPrototypeOf(CC_clientForm)).call.apply(_ref,[this].concat(args))),_this),_this.state={idValid:false,idChanged:false},_this.idChanged=function(value){var x=Object(__WEBPACK_IMPORTED_MODULE_8_helpers_GetIdInformation__["a" /* default */])(value);if(x==='error'){return;}__WEBPACK_IMPORTED_MODULE_14_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_13_redux_form__["b" /* change */])('client','dateOfBirth',x.dob));__WEBPACK_IMPORTED_MODULE_14_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_13_redux_form__["b" /* change */])('client','gender',x.gender));_this.props.dobChanged(x.dob);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(CC_clientForm,[{key:'componentDidMount',value:function componentDidMount(){this.props.scrollMeBar();}},{key:'genderChanged',value:function genderChanged(gender){var title=__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.get(__WEBPACK_IMPORTED_MODULE_14_store__["a" /* default */].getState().form.client,'values.title',null);if(title&&gender){__WEBPACK_IMPORTED_MODULE_14_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_13_redux_form__["b" /* change */])('client','title',gender==='F'?'MS':'MR'));}this.forceUpdate();}},{key:'render',value:function render(){var _this2=this;var validate=[];validate.push(required);var marriedOptions=null;var idOptions=null;var gender=__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.get(__WEBPACK_IMPORTED_MODULE_14_store__["a" /* default */].getState().form.client,'values.gender',null);var hideFemaleOption=!gender?false:gender==='M'?true:false;var hideMaleOption=!gender?false:gender==='F'?true:false;var womanOptions=[{value:'MRS',displayValue:'MRS',hidden:hideFemaleOption},{value:'MISS',displayValue:'MISS',hidden:hideFemaleOption}];if(!hideFemaleOption&&__WEBPACK_IMPORTED_MODULE_14_store__["a" /* default */].getState().form.client&&__WEBPACK_IMPORTED_MODULE_14_store__["a" /* default */].getState().form.client.values){var mStatus=__WEBPACK_IMPORTED_MODULE_14_store__["a" /* default */].getState().form.client.values.maritalStatus;if(mStatus&&mStatus!=='validationError'){if(mStatus==='Married'){womanOptions=[{value:'MRS',displayValue:'MRS',hidden:hideFemaleOption}];}else{womanOptions=[{value:'MISS',displayValue:'MISS',hidden:hideFemaleOption}];}}}var titleOptions=[{value:'validationError',displayValue:'Please select'},{value:'MR',displayValue:'MR',hidden:hideMaleOption}].concat(_toConsumableArray(womanOptions),[{value:'MS',displayValue:'MS',hidden:hideFemaleOption},{value:'ADV',displayValue:'ADV'},{value:'DR',displayValue:'DR'},{value:'JUDG',displayValue:'JUDGE'},{value:'PROF',displayValue:'PROF'}]);if(this.props.saCitizen){idOptions=__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{item:true,xs:12,sm:6},__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["t" /* FormControl */],{fullWidth:true},__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_6_components_Wrappers_materialUIWrappers_components_FormInput__["a" /* default */],checkValidation:this.props.checkValidation,name:'said',label:'South African ID',validate:[__WEBPACK_IMPORTED_MODULE_8_helpers_GetIdInformation__["b" /* idNumberValid */]],onChange:function onChange(e){return _this2.idChanged(e.target.value);}}))));}else{idOptions=__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{item:true,xs:12,sm:6},__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["t" /* FormControl */],{fullWidth:true},__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_6_components_Wrappers_materialUIWrappers_components_FormInput__["a" /* default */],checkValidation:this.props.checkValidation,name:'passportNumber',label:'Pasport number'}))),__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{item:true,xs:12,sm:6},__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["t" /* FormControl */],{fullWidth:true},__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_5_components_Wrappers_materialUIWrappers_components_FormDropDown__["a" /* default */],options:__WEBPACK_IMPORTED_MODULE_16__coi_options__["a" /* default */],checkValidation:this.props.checkValidation,name:'countryOfIssue',label:'Pasport Country Of Issue'}))));}if(this.props.married){marriedOptions=__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{item:true,xs:12,sm:6},__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["t" /* FormControl */],{fullWidth:true},__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_redux_form__["a" /* Field */],{label:'Wedding date *',name:'weddingDate',component:__WEBPACK_IMPORTED_MODULE_6_components_Wrappers_materialUIWrappers_components_FormInput__["a" /* default */],placeholder:'DD/MM/YYYY'}))),__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{item:true,xs:12,sm:6},__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["t" /* FormControl */],{fullWidth:true},__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_5_components_Wrappers_materialUIWrappers_components_FormDropDown__["a" /* default */],label:'How married *',name:'howMarried',options:[{value:'validationError',displayValue:'Please select'},{value:'inCom',displayValue:'In Community'},{value:'outComWithAcc',displayValue:'Out of Community with accrual'},{value:'outComNoAcc',displayValue:'Out of Community without accrual'}]}))));}var age=__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.get(__WEBPACK_IMPORTED_MODULE_14_store__["a" /* default */].getState().form,'client.values.age',null);return __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement('div',{className:'contentWithStepper'},__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["e" /* Card */],null,__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["g" /* CardHeader */],{title:this.props.firstName+' '+this.props.lastName,style:{textAlign:'center'}}),__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement('div',{style:{width:'100%',textAlign:'center',display:'block'}},__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement('a',{href:'#pablo',onClick:function onClick(e){return e.preventDefault();},style:{margin:'0px auto'}},__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement('img',{className:'avatarImg',src:this.props.imgSrc?this.props.imgSrc:__WEBPACK_IMPORTED_MODULE_4_assets_img_faces_avatar1_jpg___default.a,alt:'...',style:{width:'100px',height:'100px',objectFit:'cover'}})),__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react_dropzone__["a" /* default */],{style:{width:'fit-content',height:'fit-content',margin:'auto',border:'none',textAlign:'center'},onDrop:function onDrop(_ref2){var _ref3=_slicedToArray(_ref2,1),file=_ref3[0];_this2.props.fileAttached(file);}},__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["i" /* Chip */],{avatar:__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["b" /* Avatar */],{style:{backgroundColor:'#6c5cab',color:'white'}},__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["w" /* Icon */],null,'edit')),variant:'outlined',label:__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{color:'white'}},'Edit Picture'),color:'secondary',style:{backgroundColor:'#a59fff',color:'white',position:'relative',top:'-10px',cursor:'pointer'}})),__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement('div',{style:{display:'flex',marginLeft:'23px'}},Object(__WEBPACK_IMPORTED_MODULE_15__FieldIndicators_jsx__["b" /* quoteIn */])(),' = Required for Quote'),__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement('div',{style:{display:'flex',marginLeft:'23px'}},Object(__WEBPACK_IMPORTED_MODULE_15__FieldIndicators_jsx__["a" /* astuteIn */])(),' = Required for Astute')),__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["g" /* CardHeader */],{title:'Client Basic Info'}),__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["f" /* CardContent */],null,__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{container:true,spacing:24},__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{item:true,xs:12,sm:6},__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["t" /* FormControl */],{fullWidth:true},__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_5_components_Wrappers_materialUIWrappers_components_FormDropDown__["a" /* default */],label:'Active/Prospect',name:'clientType',options:[{value:'validationError',displayValue:'Please select'},{value:'active',displayValue:'Active'},{value:'prospect',displayValue:'Prospect'}]}))),__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{item:true,xs:12,sm:6},__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["t" /* FormControl */],{fullWidth:true},__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_6_components_Wrappers_materialUIWrappers_components_FormInput__["a" /* default */],name:'clientFileNumber',label:'Client/File number'}))),__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{item:true,xs:12,sm:6},__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["t" /* FormControl */],{fullWidth:true},__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_5_components_Wrappers_materialUIWrappers_components_FormDropDown__["a" /* default */],label:'Type of correspondence',name:'correspondenceType',options:[{value:'validationError',displayValue:'Please select'},{value:'app',displayValue:'App'},{value:'sms',displayValue:'SMS'},{value:'email',displayValue:'Email'},{value:'phone',displayValue:'Phone'}]}))),__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{item:true,xs:12,sm:6},__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["t" /* FormControl */],{fullWidth:true},__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_5_components_Wrappers_materialUIWrappers_components_FormDropDown__["a" /* default */],label:'Correspondence language',name:'correspondenceLanguage',options:[{value:'validationError',displayValue:'Please select'},{value:'english',displayValue:'English'},{value:'afrikaans',displayValue:'Afrikaans'}]}))),__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{item:true,xs:12,sm:6},__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["t" /* FormControl */],{fullWidth:true},__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_5_components_Wrappers_materialUIWrappers_components_FormDropDown__["a" /* default */],label:'Correspondence Formality',name:'correspondenceFormality',options:[{value:'validationError',displayValue:'Please select'},{value:'formal',displayValue:'Formal'},{value:'informal',displayValue:'Informal'}]}))))),__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["f" /* CardContent */],null,__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{container:true,spacing:24},__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{item:true,xs:12,sm:6,style:{display:'flex'}},__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement('div',null,Object(__WEBPACK_IMPORTED_MODULE_15__FieldIndicators_jsx__["b" /* quoteIn */])(true)),__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["t" /* FormControl */],{fullWidth:true},__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_5_components_Wrappers_materialUIWrappers_components_FormDropDown__["a" /* default */],checkValidation:this.props.checkValidation,label:'Title *',name:'title',options:titleOptions,isrequired:true,validate:[requiredDropdown]}))),__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{item:true,xs:12,sm:6},__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["t" /* FormControl */],{fullWidth:true},__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_6_components_Wrappers_materialUIWrappers_components_FormInput__["a" /* default */],name:'nickName',label:'Nick name'}))),__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{item:true,xs:12,sm:6,style:{display:'flex'}},__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement('div',null,Object(__WEBPACK_IMPORTED_MODULE_15__FieldIndicators_jsx__["b" /* quoteIn */])(true)),__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["t" /* FormControl */],{fullWidth:true},__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_6_components_Wrappers_materialUIWrappers_components_FormInput__["a" /* default */],isrequired:true,validate:[required,charMin2],checkValidation:this.props.checkValidation,name:'firstName',label:'First name *',onChange:function onChange(e){return _this2.props.changeFirstName(e.target.value);}}))),__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{item:true,xs:12,sm:6},__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["t" /* FormControl */],{fullWidth:true},__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_6_components_Wrappers_materialUIWrappers_components_FormInput__["a" /* default */],name:'secondNames',label:'Second and other names',onChange:function onChange(e){return _this2.props.changeSecondName(e.target.value);}}))),__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{item:true,xs:12,sm:6,style:{display:'flex'}},__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement('div',null,Object(__WEBPACK_IMPORTED_MODULE_15__FieldIndicators_jsx__["a" /* astuteIn */])(true)),__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["t" /* FormControl */],{fullWidth:true},__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_6_components_Wrappers_materialUIWrappers_components_FormInput__["a" /* default */],name:'initials',label:'Initials'}))),__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{item:true,xs:12,sm:6,style:{display:'flex'}},__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement('div',null,Object(__WEBPACK_IMPORTED_MODULE_15__FieldIndicators_jsx__["b" /* quoteIn */])(),Object(__WEBPACK_IMPORTED_MODULE_15__FieldIndicators_jsx__["a" /* astuteIn */])()),__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["t" /* FormControl */],{fullWidth:true},__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_6_components_Wrappers_materialUIWrappers_components_FormInput__["a" /* default */],isrequired:true,validate:[required,charMin2],checkValidation:this.props.checkValidation,name:'lastName',label:'Surname *',onChange:function onChange(e){return _this2.props.changeLastName(e.target.value);}}))),__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{item:true,xs:12,sm:6},__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["t" /* FormControl */],{fullWidth:true},__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_5_components_Wrappers_materialUIWrappers_components_FormDropDown__["a" /* default */],label:'Identification Type',name:'idType',options:[{value:'idNumber',displayValue:'Id Number'},{value:'passport',displayValue:'Passport'}],onValueChange:function onValueChange(e){return _this2.props.idChangeHandler(e);}}))),idOptions,__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{item:true,xs:12,sm:6,style:{display:'flex'}},__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement('div',null,Object(__WEBPACK_IMPORTED_MODULE_15__FieldIndicators_jsx__["b" /* quoteIn */])(true)),__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["t" /* FormControl */],{fullWidth:true},__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_redux_form__["a" /* Field */],{label:'Date of birth',name:'dateOfBirth',component:__WEBPACK_IMPORTED_MODULE_6_components_Wrappers_materialUIWrappers_components_FormInput__["a" /* default */],placeholder:'DD/MM/YYYY',validate:[__WEBPACK_IMPORTED_MODULE_9_helpers_ValidationHelpers__["a" /* dateValid */]],onChange:function onChange(e){return _this2.props.dobChanged(e.target.value);}})),Object(__WEBPACK_IMPORTED_MODULE_9_helpers_ValidationHelpers__["c" /* isEmptyOrSpaces */])(age)?__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement('div',{style:{height:'47px'}}):__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement('div',{className:'ageBlock'},__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{variant:'caption'},'Age'),__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],null,age))),__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{item:true,xs:12,sm:6,style:{display:'flex'}},__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement('div',null,Object(__WEBPACK_IMPORTED_MODULE_15__FieldIndicators_jsx__["b" /* quoteIn */])(true)),__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["t" /* FormControl */],{fullWidth:true},__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_5_components_Wrappers_materialUIWrappers_components_FormDropDown__["a" /* default */],label:'Gender',name:'gender',options:[{value:'validationError',displayValue:'Please select'},{value:'M',displayValue:'Male'},{value:'F',displayValue:'Female'}],onValueChange:function onValueChange(e){return _this2.genderChanged(e);}}))),__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{item:true,xs:12,sm:6},__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["t" /* FormControl */],{fullWidth:true},__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_6_components_Wrappers_materialUIWrappers_components_FormInput__["a" /* default */],name:'maidenName',label:'Maiden Name'}))),__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{item:true,xs:12,sm:6,style:{display:'flex'}},__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement('div',null,Object(__WEBPACK_IMPORTED_MODULE_15__FieldIndicators_jsx__["b" /* quoteIn */])(true)),__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["t" /* FormControl */],{fullWidth:true},__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_5_components_Wrappers_materialUIWrappers_components_FormDropDown__["a" /* default */],checkValidation:this.props.checkValidation,label:'Smoker?',name:'smoker',options:[{value:'validationError',displayValue:'Please select'},{value:'N',displayValue:'No'},{value:'Y',displayValue:'Yes'}]}))),__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{item:true,xs:12,sm:6,style:{display:'flex'}},__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement('div',null,Object(__WEBPACK_IMPORTED_MODULE_15__FieldIndicators_jsx__["b" /* quoteIn */])(true)),__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["t" /* FormControl */],{fullWidth:true},__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_5_components_Wrappers_materialUIWrappers_components_FormDropDown__["a" /* default */],checkValidation:this.props.checkValidation,label:'Marital Status',name:'maritalStatus',options:[{value:'validationError',displayValue:'Please select'},{value:'Single',displayValue:'Single'},{value:'Divorced',displayValue:'Divorced'},{value:'Married',displayValue:'Married'},{value:'Widowed',displayValue:'Widowed'}],onValueChange:function onValueChange(e){return _this2.props.maritalChangeHandler(e);}}))),marriedOptions,__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{item:true,xs:12,sm:6},__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["t" /* FormControl */],{fullWidth:true},__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_6_components_Wrappers_materialUIWrappers_components_FormInput__["a" /* default */],name:'taxNumber',label:'Income tax number'})))),__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement('br',null))));}}]);return CC_clientForm;}(__WEBPACK_IMPORTED_MODULE_11_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["_1" /* withStyles */])(styles)(CC_clientForm));

/***/ }),
/* 267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return quoteIn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return astuteIn; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core__ = __webpack_require__(4);
var quoteIn=function quoteIn(lower){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["Y" /* Tooltip */],{title:"Required for Quote"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["Z" /* Typography */],{variant:"button",style:{position:"relative",top:lower?"20px":"0px",marginRight:"8px",color:"#9568ff",cursor:"default"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"Q")));};var astuteIn=function astuteIn(lower){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["Y" /* Tooltip */],{title:"Required for Astute"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["Z" /* Typography */],{variant:"button",style:{position:"relative",top:lower?"20px":"0px",marginRight:"8px",color:"#75ce91",cursor:"default"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"A")));};

/***/ }),
/* 268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_graphql_tag__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_graphql_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_graphql_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_Wrappers_materialUIWrappers_components_FormInput__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Wrappers_materialUIWrappers_components_FormDropDown__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Wrappers_materialUIWrappers_components_GrandInput__ = __webpack_require__(616);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__layouts_hoc_NotificationWrapper__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_Wrappers_materialUIWrappers_components_Autofill__ = __webpack_require__(617);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_reducers_NotificationReducer__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_redux_form__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_store__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_apollo__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_reducers_OccupationsReducer__ = __webpack_require__(360);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_Wrappers_materialUIWrappers_components_AutofillV2__ = __webpack_require__(618);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__FieldIndicators_jsx__ = __webpack_require__(267);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(["\n  {\n    Occupations {\n      occupations\n    }\n  }\n"],["\n  {\n    Occupations {\n      occupations\n    }\n  }\n"]);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}/*eslint-disable*/var GET="sure-quote/Occupations/GET";var required=function required(value){return value?undefined:"Required";};var number=function number(value){if(value===undefined)return undefined;value=value.replace(/,/g,"").replace(/ /g,"");return isNaN(Number(value))?"Must be a number":undefined;};var percentage=function percentage(value){if(value===undefined)return undefined;if(isNaN(Number(value))){return"Must be a number";}if(parseInt(value)>100||parseInt(value)<0){return"Cannot be more than 100 or less than 0";}return undefined;};var occupationQuery=__WEBPACK_IMPORTED_MODULE_1_graphql_tag___default()(_templateObject);var CurrencySymbol="R";var requiredDropdown=function requiredDropdown(value){if(value==="validationError"){return"Required";}else if(value){return undefined;}else{return"Required";}};var charMin3=function charMin3(value){if(value===undefined||value.trim()==="")return undefined;if(value)if(value.length<3)return"Must be at least 3 characters";return undefined;};var businessOwner=function businessOwner(value){if(value===undefined||value.trim()==="")return undefined;if(value==="Business Owner/Businessman"){__WEBPACK_IMPORTED_MODULE_10_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_7_reducers_NotificationReducer__["d" /* showSnack */])({message:"If possible please select an occupation that better describe what the client does.",color:"danger"}));return;}if(value===undefined||value.trim()==="")return undefined;if(value.length<3)return"Must be at least 3 characters";return undefined;};var styles=function styles(theme){return{};};var form="client";var CC_clientOccForm=function(_React$Component){_inherits(CC_clientOccForm,_React$Component);function CC_clientOccForm(){_classCallCheck(this,CC_clientOccForm);return _possibleConstructorReturn(this,(CC_clientOccForm.__proto__||Object.getPrototypeOf(CC_clientOccForm)).apply(this,arguments));}_createClass(CC_clientOccForm,[{key:"componentDidMount",value:function componentDidMount(){this.props.scrollMeBar();}},{key:"render",value:function render(){var _this2=this;var validate=[];validate.push(required);var spousalDetails=null;if(__WEBPACK_IMPORTED_MODULE_10_store__["a" /* default */].getState().form.client){var mStatus=__WEBPACK_IMPORTED_MODULE_10_store__["a" /* default */].getState().form.client.values.maritalStatus;if(mStatus&&mStatus==="Married"){spousalDetails=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["v" /* Grid */],{item:true,xs:12,sm:6,style:{display:"flex"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,Object(__WEBPACK_IMPORTED_MODULE_14__FieldIndicators_jsx__["b" /* quoteIn */])(true)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["t" /* FormControl */],{fullWidth:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_2_components_Wrappers_materialUIWrappers_components_FormInput__["a" /* default */],checkValidation:this.props.checkValidation,validate:[number],label:"Spouse Monthly Income",name:"spouseIncome"})));}}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_apollo__["Query"],{query:occupationQuery},function(_ref){var loading=_ref.loading,error=_ref.error,data=_ref.data;if(loading)return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["B" /* LinearProgress */],null));if(error)return"Error! "+error.message;if(__WEBPACK_IMPORTED_MODULE_10_store__["a" /* default */].getState().occupations.occupations.length<1){var occupations=data.Occupations[0];__WEBPACK_IMPORTED_MODULE_10_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_12_reducers_OccupationsReducer__["a" /* addOccupations */])({type:GET,props:occupations}));_this2.forceUpdate();}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["e" /* Card */],{className:"contentWithStepper"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["g" /* CardHeader */],{title:"Client Occupational Info"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["f" /* CardContent */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:{display:"flex",marginLeft:"23px"}},Object(__WEBPACK_IMPORTED_MODULE_14__FieldIndicators_jsx__["b" /* quoteIn */])()," = Required for Quote"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:{display:"flex",marginLeft:"23px"}},Object(__WEBPACK_IMPORTED_MODULE_14__FieldIndicators_jsx__["a" /* astuteIn */])()," = Required for Astute"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["v" /* Grid */],{container:true,spacing:24,style:{marginTop:"15px"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["v" /* Grid */],{item:true,xs:12,sm:6,style:{display:"flex"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,Object(__WEBPACK_IMPORTED_MODULE_14__FieldIndicators_jsx__["b" /* quoteIn */])(true)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["t" /* FormControl */],{fullWidth:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{className:"labelSmall"},"Occupation for Quote purposes"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_redux_form__["a" /* Field */],{name:"occupation",component:__WEBPACK_IMPORTED_MODULE_13_components_Wrappers_materialUIWrappers_components_AutofillV2__["a" /* default */],validate:[charMin3,businessOwner],onItemSelect:function onItemSelect(){return _this2.props.toggleOccupationValid(true);}//alert(JSON.stringify( this.name))
,textChanged:function textChanged(e){return _this2.props.toggleOccupationValid(e.target.value.trim()==="");},autoFillList:_.get(__WEBPACK_IMPORTED_MODULE_10_store__["a" /* default */].getState(),"occupations.occupations",[])}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["v" /* Grid */],{item:true,xs:12,sm:6,style:{display:"flex"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,Object(__WEBPACK_IMPORTED_MODULE_14__FieldIndicators_jsx__["b" /* quoteIn */])(true)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["t" /* FormControl */],{fullWidth:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_3_components_Wrappers_materialUIWrappers_components_FormDropDown__["a" /* default */],label:"Highest qualification",name:"qualification",options:[{value:"validationError",displayValue:"Please select"},{value:"LessThanMatric",displayValue:"Less than matric"},{value:"Matric",displayValue:"Matric"},{value:"3-yearDiploma",displayValue:"3-year diploma"},{value:"3-yearDegreeOr4-yearDiploma",displayValue:"3-year degree / 4-year diploma"},{value:"4-yearDegreeOrProfessional",displayValue:"4-year degree / Professional"}]}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["v" /* Grid */],{item:true,xs:12,sm:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["t" /* FormControl */],{fullWidth:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_redux_form__["a" /* Field */],{name:"qualificationName",component:__WEBPACK_IMPORTED_MODULE_2_components_Wrappers_materialUIWrappers_components_FormInput__["a" /* default */],checkValidation:_this2.props.checkValidation,label:"Occupation and Qualifications",onChange:function onChange(e){return _this2.props.salaryChangeHandler(e.target.value);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["v" /* Grid */],{item:true,xs:12,sm:6,style:{display:"flex"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,Object(__WEBPACK_IMPORTED_MODULE_14__FieldIndicators_jsx__["b" /* quoteIn */])(true)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["t" /* FormControl */],{fullWidth:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_3_components_Wrappers_materialUIWrappers_components_FormDropDown__["a" /* default */],checkValidation:_this2.props.checkValidation,label:"Self Employed",name:"selfEmployed",options:[{value:"validationError",displayValue:"Please select"},{value:"N",displayValue:"No"},{value:"Y",displayValue:"Yes"}]}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["v" /* Grid */],{item:true,xs:12,sm:6,style:{display:"flex"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,Object(__WEBPACK_IMPORTED_MODULE_14__FieldIndicators_jsx__["b" /* quoteIn */])(true)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["t" /* FormControl */],{fullWidth:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_redux_form__["a" /* Field */],{name:"salaryType",component:__WEBPACK_IMPORTED_MODULE_3_components_Wrappers_materialUIWrappers_components_FormDropDown__["a" /* default */],label:"Commission or Fixed Salary?",options:[{value:"validationError",displayValue:"Please select"},{value:"commission",displayValue:"Commission"},{value:"fixed",displayValue:"Fixed"}]}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["v" /* Grid */],{item:true,xs:12,sm:6,style:{display:"flex"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,Object(__WEBPACK_IMPORTED_MODULE_14__FieldIndicators_jsx__["b" /* quoteIn */])(true)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["t" /* FormControl */],{fullWidth:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_redux_form__["a" /* Field */],{name:"monthlyIncome",component:__WEBPACK_IMPORTED_MODULE_4_components_Wrappers_materialUIWrappers_components_GrandInput__["a" /* default */],checkValidation:_this2.props.checkValidation,label:"Monthly income (Gross)",validate:[number],onChange:function onChange(e){return _this2.props.salaryChangeHandler(e.target.value);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["v" /* Grid */],{item:true,xs:12,sm:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["t" /* FormControl */],{fullWidth:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_redux_form__["a" /* Field */],{name:"calculatedMonthlyIncomeAT",component:__WEBPACK_IMPORTED_MODULE_4_components_Wrappers_materialUIWrappers_components_GrandInput__["a" /* default */],label:"Monthly After Tax Income (Calculated)",fixedValue:_this2.props.afterTaxIncome,readOnly:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["v" /* Grid */],{item:true,xs:12,sm:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["t" /* FormControl */],{fullWidth:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_redux_form__["a" /* Field */],{name:"actualMonthlyIncomeAT",component:__WEBPACK_IMPORTED_MODULE_4_components_Wrappers_materialUIWrappers_components_GrandInput__["a" /* default */],validate:[number],checkValidation:_this2.props.checkValidation,label:"Actual monthly after tax income"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["v" /* Grid */],{item:true,xs:12,sm:6,style:{display:"flex"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,Object(__WEBPACK_IMPORTED_MODULE_14__FieldIndicators_jsx__["b" /* quoteIn */])(true)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["t" /* FormControl */],{fullWidth:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_3_components_Wrappers_materialUIWrappers_components_FormDropDown__["a" /* default */],label:"Tax dispensation",name:"TaxDispensation",options:[{value:"validationError",displayValue:"Please select"},{value:"NaturalPerson",displayValue:"Natural person"},{value:"TaxPayingInstitution",displayValue:"Tax-paying institution"},{value:"TaxExemptInstitution",displayValue:"Tax-exempt institution"},{value:"Trust",displayValue:"Trust"}]}))),spousalDetails,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["v" /* Grid */],{item:true,xs:12,sm:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{className:"labelSmall"},"Occupational Duties")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["v" /* Grid */],{item:true,xs:12,sm:6,style:{display:"flex"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,Object(__WEBPACK_IMPORTED_MODULE_14__FieldIndicators_jsx__["b" /* quoteIn */])(true)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["t" /* FormControl */],{fullWidth:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_redux_form__["a" /* Field */],{name:"Admin",component:__WEBPACK_IMPORTED_MODULE_2_components_Wrappers_materialUIWrappers_components_FormInput__["a" /* default */],validate:[percentage],checkValidation:_this2.props.checkValidation,label:"Admin % *",isRequired:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["v" /* Grid */],{item:true,xs:12,sm:6,style:{display:"flex"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,Object(__WEBPACK_IMPORTED_MODULE_14__FieldIndicators_jsx__["b" /* quoteIn */])(true)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["t" /* FormControl */],{fullWidth:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_redux_form__["a" /* Field */],{name:"Travel",component:__WEBPACK_IMPORTED_MODULE_2_components_Wrappers_materialUIWrappers_components_FormInput__["a" /* default */],validate:[percentage],checkValidation:_this2.props.checkValidation,label:"Travel % *",isRequired:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["v" /* Grid */],{item:true,xs:12,sm:6,style:{display:"flex"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,Object(__WEBPACK_IMPORTED_MODULE_14__FieldIndicators_jsx__["b" /* quoteIn */])(true)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["t" /* FormControl */],{fullWidth:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_redux_form__["a" /* Field */],{name:"ManualLabour",component:__WEBPACK_IMPORTED_MODULE_2_components_Wrappers_materialUIWrappers_components_FormInput__["a" /* default */],validate:[percentage],checkValidation:_this2.props.checkValidation,label:"Manual Labour % *",isRequired:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["v" /* Grid */],{item:true,xs:12,sm:6,style:{display:"flex"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,Object(__WEBPACK_IMPORTED_MODULE_14__FieldIndicators_jsx__["b" /* quoteIn */])(true)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["t" /* FormControl */],{fullWidth:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_redux_form__["a" /* Field */],{name:"Supervision",component:__WEBPACK_IMPORTED_MODULE_2_components_Wrappers_materialUIWrappers_components_FormInput__["a" /* default */],validate:[percentage],checkValidation:_this2.props.checkValidation,label:"Supervision % *",isRequired:true})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null)));});}}]);return CC_clientOccForm;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["_1" /* withStyles */])(styles)(CC_clientOccForm));

/***/ }),
/* 269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_Wrappers_materialUIWrappers_components_FormInput__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_Wrappers_materialUIWrappers_components_FormDropDown__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Wrappers_materialUIWrappers_components_DatePicker__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_form__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_store__ = __webpack_require__(10);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/*eslint-disable*/var required=function required(value){return value?undefined:"Required";};var number=function number(value){if(value===undefined)return undefined;return isNaN(Number(value))?"Must be a number":undefined;};var email=function email(value){var mailformat=/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;return value.match(mailformat)?undefined:"Not a Valid Email Addres";};var max4=function max4(value){if(value===undefined)return undefined;return value.length>4?"Must be 4 characters or less":undefined;};var requiredDropdown=function requiredDropdown(value){if(value==="validationError"){return"Required";}else if(value){return undefined;}else{return"Required";}};var styles=function styles(){return{};};var CC_contactDetails=function(_React$Component){_inherits(CC_contactDetails,_React$Component);function CC_contactDetails(){var _ref;var _temp,_this,_ret;_classCallCheck(this,CC_contactDetails);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=CC_contactDetails.__proto__||Object.getPrototypeOf(CC_contactDetails)).call.apply(_ref,[this].concat(args))),_this),_this.state={addrSame:false},_this.handleSameAddress=function(event){_this.setState({addrSame:event.target.checked});if(event.target.checked){__WEBPACK_IMPORTED_MODULE_6_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_redux_form__["b" /* change */])("client","postalAddressOne",__WEBPACK_IMPORTED_MODULE_6_store__["a" /* default */].getState().form.client.values.resAddressOne));__WEBPACK_IMPORTED_MODULE_6_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_redux_form__["b" /* change */])("client","postalAddressTwo",__WEBPACK_IMPORTED_MODULE_6_store__["a" /* default */].getState().form.client.values.resAddressTwo));__WEBPACK_IMPORTED_MODULE_6_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_redux_form__["b" /* change */])("client","postalAddressThree",__WEBPACK_IMPORTED_MODULE_6_store__["a" /* default */].getState().form.client.values.resAddressThree));__WEBPACK_IMPORTED_MODULE_6_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_redux_form__["b" /* change */])("client","postalAddressFour",__WEBPACK_IMPORTED_MODULE_6_store__["a" /* default */].getState().form.client.values.resAddressFour));__WEBPACK_IMPORTED_MODULE_6_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_redux_form__["b" /* change */])("client","postalAddressCode",__WEBPACK_IMPORTED_MODULE_6_store__["a" /* default */].getState().form.client.values.postalCode));}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(CC_contactDetails,[{key:"componentDidMount",value:function componentDidMount(){this.props.scrollMeBar();}},{key:"render",value:function render(){var validate=[];validate.push(required);var postalAddr=null;if(!this.state.addrSame){postalAddr=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["v" /* Grid */],{item:true,xs:12,sm:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["t" /* FormControl */],{fullWidth:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["a" /* Field */],{name:"postalAddressOne",component:__WEBPACK_IMPORTED_MODULE_1_components_Wrappers_materialUIWrappers_components_FormInput__["a" /* default */],label:"Postal Address 1"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["v" /* Grid */],{item:true,xs:12,sm:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["t" /* FormControl */],{fullWidth:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["a" /* Field */],{name:"postalAddressTwo",component:__WEBPACK_IMPORTED_MODULE_1_components_Wrappers_materialUIWrappers_components_FormInput__["a" /* default */],label:"Postal address 2"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["v" /* Grid */],{item:true,xs:12,sm:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["t" /* FormControl */],{fullWidth:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["a" /* Field */],{name:"postalAddressThree",component:__WEBPACK_IMPORTED_MODULE_1_components_Wrappers_materialUIWrappers_components_FormInput__["a" /* default */],label:"Postal address 3"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["v" /* Grid */],{item:true,xs:12,sm:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["t" /* FormControl */],{fullWidth:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["a" /* Field */],{name:"postalAddressFour",component:__WEBPACK_IMPORTED_MODULE_1_components_Wrappers_materialUIWrappers_components_FormInput__["a" /* default */],label:"Postal address 4"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["v" /* Grid */],{item:true,xs:12,sm:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["t" /* FormControl */],{fullWidth:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["a" /* Field */],{name:"postalAddressCode",component:__WEBPACK_IMPORTED_MODULE_1_components_Wrappers_materialUIWrappers_components_FormInput__["a" /* default */],label:"Postal Address Code",validate:[number,max4],checkValidation:this.props.checkValidation}))));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"contentWithStepper"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["e" /* Card */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["g" /* CardHeader */],{title:"Client Contact Details"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["f" /* CardContent */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["v" /* Grid */],{container:true,spacing:24},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["v" /* Grid */],{item:true,xs:12,sm:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["t" /* FormControl */],{fullWidth:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_1_components_Wrappers_materialUIWrappers_components_FormInput__["a" /* default */],isrequired:false,validate:[].concat(validate,[number]),checkValidation:this.props.checkValidation,name:"cellNumber",label:"Cell number *"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["v" /* Grid */],{item:true,xs:12,sm:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["t" /* FormControl */],{fullWidth:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_1_components_Wrappers_materialUIWrappers_components_FormInput__["a" /* default */],isrequired:true,validate:[].concat(validate,[email]),checkValidation:this.props.checkValidation,name:"email",label:"Email *"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["v" /* Grid */],{item:true,xs:12,sm:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["t" /* FormControl */],{fullWidth:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["a" /* Field */],{name:"telNumberHome",component:__WEBPACK_IMPORTED_MODULE_1_components_Wrappers_materialUIWrappers_components_FormInput__["a" /* default */],label:"Tel (h)"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["v" /* Grid */],{item:true,xs:12,sm:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["t" /* FormControl */],{fullWidth:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["a" /* Field */],{name:"telNumberWork",component:__WEBPACK_IMPORTED_MODULE_1_components_Wrappers_materialUIWrappers_components_FormInput__["a" /* default */],label:"Tel (w)"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["v" /* Grid */],{item:true,xs:12,sm:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["t" /* FormControl */],{fullWidth:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["a" /* Field */],{name:"resAddressOne",component:__WEBPACK_IMPORTED_MODULE_1_components_Wrappers_materialUIWrappers_components_FormInput__["a" /* default */],label:"Residential address 1"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["v" /* Grid */],{item:true,xs:12,sm:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["t" /* FormControl */],{fullWidth:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["a" /* Field */],{name:"resAddressTwo",component:__WEBPACK_IMPORTED_MODULE_1_components_Wrappers_materialUIWrappers_components_FormInput__["a" /* default */],label:"Residential address 2"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["v" /* Grid */],{item:true,xs:12,sm:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["t" /* FormControl */],{fullWidth:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["a" /* Field */],{name:"resAddressThree",component:__WEBPACK_IMPORTED_MODULE_1_components_Wrappers_materialUIWrappers_components_FormInput__["a" /* default */],label:"Residential address 3"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["v" /* Grid */],{item:true,xs:12,sm:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["t" /* FormControl */],{fullWidth:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["a" /* Field */],{name:"resAddressFour",component:__WEBPACK_IMPORTED_MODULE_1_components_Wrappers_materialUIWrappers_components_FormInput__["a" /* default */],label:"Residential address 4"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["v" /* Grid */],{item:true,xs:12,sm:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["t" /* FormControl */],{fullWidth:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["a" /* Field */],{name:"postalCode",component:__WEBPACK_IMPORTED_MODULE_1_components_Wrappers_materialUIWrappers_components_FormInput__["a" /* default */],validate:[number,max4],checkValidation:this.props.checkValidation,label:"Residential Address Code"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["v" /* Grid */],{item:true,xs:12,sm:6,md:6,style:{display:"flex"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["Z" /* Typography */],{variant:"body2",style:{height:"fit-content",position:"relative",top:"24%"}},"Postal Address same as Residential Address?"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["h" /* Checkbox */],{checked:this.state.addrSame,onChange:this.handleSameAddress,value:"brokerUser"})),postalAddr))));}}]);return CC_contactDetails;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["_1" /* withStyles */])(styles)(CC_contactDetails));

/***/ }),
/* 270 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_Wrappers_materialUIWrappers_components_FormInput__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_Wrappers_materialUIWrappers_components_FormDropDown__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Wrappers_materialUIWrappers_components_DatePicker__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_form__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core__ = __webpack_require__(4);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/*eslint-disable*/var required=function required(value){return value?undefined:"Required";};var requiredDropdown=function requiredDropdown(value){if(value==="validationError"){return"Required";}else if(value){return undefined;}else{return"Required";}};var styles=function styles(){return{};};var CC_healthInfo=function(_React$Component){_inherits(CC_healthInfo,_React$Component);function CC_healthInfo(){_classCallCheck(this,CC_healthInfo);return _possibleConstructorReturn(this,(CC_healthInfo.__proto__||Object.getPrototypeOf(CC_healthInfo)).apply(this,arguments));}_createClass(CC_healthInfo,[{key:"componentDidMount",value:function componentDidMount(){this.props.scrollMeBar();}},{key:"render",value:function render(){var validate=[];validate.push(required);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["e" /* Card */],{className:"contentWithStepper"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["g" /* CardHeader */],{title:"Client Health Info"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["f" /* CardContent */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["v" /* Grid */],{container:true,spacing:24},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["v" /* Grid */],{item:true,xs:12,sm:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["t" /* FormControl */],{fullWidth:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["a" /* Field */],{name:"healthHeight",component:__WEBPACK_IMPORTED_MODULE_1_components_Wrappers_materialUIWrappers_components_FormInput__["a" /* default */],label:"Height (m)"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["v" /* Grid */],{item:true,xs:12,sm:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["t" /* FormControl */],{fullWidth:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["a" /* Field */],{name:"healthWeight",component:__WEBPACK_IMPORTED_MODULE_1_components_Wrappers_materialUIWrappers_components_FormInput__["a" /* default */],label:"Weight (kg)"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["v" /* Grid */],{item:true,xs:12,sm:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["t" /* FormControl */],{fullWidth:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["a" /* Field */],{name:"healthCurrentGp",component:__WEBPACK_IMPORTED_MODULE_1_components_Wrappers_materialUIWrappers_components_FormInput__["a" /* default */],label:"Current GP"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["v" /* Grid */],{item:true,xs:12,sm:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["t" /* FormControl */],{fullWidth:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["a" /* Field */],{name:"healthGpYears",component:__WEBPACK_IMPORTED_MODULE_1_components_Wrappers_materialUIWrappers_components_FormInput__["a" /* default */],label:"How many years your GP"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["v" /* Grid */],{item:true,xs:12,sm:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["t" /* FormControl */],{fullWidth:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["a" /* Field */],{name:"healthCurrentDentist",component:__WEBPACK_IMPORTED_MODULE_1_components_Wrappers_materialUIWrappers_components_FormInput__["a" /* default */],label:"Current dentist"}))))));}}]);return CC_healthInfo;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["_1" /* withStyles */])(styles)(CC_healthInfo));

/***/ }),
/* 271 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_Wrappers_materialUIWrappers_components_FormInput__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_Wrappers_materialUIWrappers_components_FormDropDown__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Wrappers_materialUIWrappers_components_DatePicker__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_form__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core__ = __webpack_require__(4);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/*eslint-disable*/var required=function required(value){return value?undefined:"Required";};var requiredDropdown=function requiredDropdown(value){if(value==="validationError"){return"Required";}else if(value){return undefined;}else{return"Required";}};var styles=function styles(){return{};};var CC_willDetail=function(_React$Component){_inherits(CC_willDetail,_React$Component);function CC_willDetail(){_classCallCheck(this,CC_willDetail);return _possibleConstructorReturn(this,(CC_willDetail.__proto__||Object.getPrototypeOf(CC_willDetail)).apply(this,arguments));}_createClass(CC_willDetail,[{key:"componentDidMount",value:function componentDidMount(){this.props.scrollMeBar();}},{key:"render",value:function render(){var validate=[];validate.push(required);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["e" /* Card */],{className:"contentWithStepper"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["g" /* CardHeader */],{title:"Client Will detail"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["f" /* CardContent */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["v" /* Grid */],{container:true,spacing:24},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["v" /* Grid */],{item:true,xs:12,sm:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["t" /* FormControl */],{fullWidth:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_2_components_Wrappers_materialUIWrappers_components_FormDropDown__["a" /* default */],checkValidation:this.props.checkValidation,label:"Does the client have a will?",name:"willHasWill",options:[{value:"validationError",displayValue:"Please select"},{value:"Y",displayValue:"Yes"},{value:"N",displayValue:"No"}]}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["v" /* Grid */],{item:true,xs:12,sm:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["t" /* FormControl */],{fullWidth:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["a" /* Field */],{name:"willExcecutor",component:__WEBPACK_IMPORTED_MODULE_1_components_Wrappers_materialUIWrappers_components_FormInput__["a" /* default */],label:"Who is the excecutor?"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["v" /* Grid */],{item:true,xs:12,sm:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["t" /* FormControl */],{fullWidth:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["a" /* Field */],{name:"willLocation",component:__WEBPACK_IMPORTED_MODULE_1_components_Wrappers_materialUIWrappers_components_FormInput__["a" /* default */],label:"Where does the client keep their will?"}))))));}}]);return CC_willDetail;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["_1" /* withStyles */])(styles)(CC_willDetail));

/***/ }),
/* 272 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_core__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_icons__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Grid_GridItem_jsx__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var BaseTablePageContent=function(_React$Component){_inherits(BaseTablePageContent,_React$Component);function BaseTablePageContent(){var _ref;var _temp,_this,_ret;_classCallCheck(this,BaseTablePageContent);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=BaseTablePageContent.__proto__||Object.getPrototypeOf(BaseTablePageContent)).call.apply(_ref,[this].concat(args))),_this),_this.state={filterEl:null},_this.handlePopoverClose=function(name){_this.setState(_defineProperty({},name,null));},_this.handlePopoverOpen=function(event,name){_this.setState(_defineProperty({},name,event.currentTarget));},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(BaseTablePageContent,[{key:"render",value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{container:true},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:10,style:{flexBasis:"100%",maxWidth:"100%",margin:"auto"}},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["e" /* Card */],null,__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["f" /* CardContent */],null,__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{container:true,justify:"space-between",style:{marginBottom:"15px"}},!this.props.hideFilter?__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{item:true,xs:12,sm:12,md:10,lg:10},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{variant:"headline",gutterBottom:true},this.props.title)),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{item:true,xs:12,sm:12,md:2,lg:2},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["d" /* Button */],{fullWidth:true,variant:"outlined",className:"outlinedButton",color:"primary",onClick:function onClick(e){return _this2.handlePopoverOpen(e,"filterEl");}},"Filter",__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["w" /* Icon */],null,"arrow_drop_down")),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["J" /* Popover */],{open:Boolean(this.state.filterEl),anchorEl:this.state.filterEl,onClose:function onClose(){return _this2.handlePopoverClose("filterEl");},anchorOrigin:{vertical:"bottom",horizontal:"center"},transformOrigin:{vertical:"top",horizontal:"center"}},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["C" /* List */],{component:"nav"},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["D" /* ListItem */],{button:true,onClick:function onClick(e){return _this2.props.toggleFilterItem(2);}},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["h" /* Checkbox */],{checked:this.props.filters.includes(2),onChange:function onChange(e){return _this2.props.toggleFilterItem(2);}}),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{variant:"subheading",style:{marginLeft:"10px",marginRight:"10px"}},"Assigned")),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["p" /* Divider */],null),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["D" /* ListItem */],{button:true,onClick:function onClick(e){return _this2.props.toggleFilterItem(3);}},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["h" /* Checkbox */],{checked:this.props.filters.includes(3),onChange:function onChange(e){return _this2.props.toggleFilterItem(3);}}),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{variant:"subheading",style:{marginLeft:"10px",marginRight:"10px"}},"Unassigned")),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["p" /* Divider */],null),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["D" /* ListItem */],{button:true,onClick:function onClick(e){return _this2.props.toggleFilterItem(0);}},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["h" /* Checkbox */],{checked:this.props.filters.includes(0),onChange:function onChange(e){return _this2.props.toggleFilterItem(0);}}),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{variant:"subheading",style:{marginLeft:"10px",marginRight:"10px"}},"Request Sent")),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["p" /* Divider */],null),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["D" /* ListItem */],{button:true,onClick:function onClick(e){return _this2.props.toggleFilterItem(1);}},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["h" /* Checkbox */],{checked:this.props.filters.includes(1),onChange:function onChange(e){return _this2.props.toggleFilterItem(1);}}),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{variant:"subheading",style:{marginLeft:"10px",marginRight:"10px"}},"Request Recieved")))))):__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{item:true,xs:12,sm:12,md:12,lg:12},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{variant:"headline",gutterBottom:true},this.props.title))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["X" /* TextField */],{id:"input-with-icon-textfield",fullWidth:true,style:{marginBottom:"3vh"},placeholder:"Search by Name, Surname, or Email",onChange:this.props.handleSearch,label:"Search",InputProps:{startAdornment:__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["z" /* InputAdornment */],{position:"start"},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_icons__["n" /* Search */],null))}}),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["I" /* Paper */],{style:{overflowX:"auto"}},this.props.children)))));}}]);return BaseTablePageContent;}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (BaseTablePageContent);

/***/ }),
/* 273 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return assetItems; });
var assetItems=[{displayValue:"Please Select",value:" ",limit:1},{displayValue:"Residential Property (Primary residence) you permanently live in and is owned by yourself",value:"primary_residential",limit:1},{displayValue:"Other residential property",value:"other_residential"},{displayValue:"Farm/s owned by you",value:"farms_owned"},{displayValue:"Motor Vehicles",value:"motorvehicles"},{displayValue:"Household content (not replacement value)",value:"household_content"},{displayValue:"Fire arms",value:"firearms"},{displayValue:"Aeroplanes",value:"aeroplanes"},{displayValue:"Boats",value:"boats"},{displayValue:"Trailers",value:"trailers"},{displayValue:"Caravans",value:"caravans"},{displayValue:"Motor bikes",value:"motorbikes"},{displayValue:"Shares listed on the JSE",value:"jse_shares"},{displayValue:"Investments",value:"investments"},{displayValue:"Cash in bank or fixed deposits",value:"cash_in_bank_or_fixed_deposits"},{displayValue:"Interest in Partnership",value:"interest_in_partnership"},{displayValue:"Interest in Close Corporation",value:"interest_in_close_corporation"},{displayValue:"Shareholding in a Private Company (not listed)",value:"shareholding_in_private_company"},{displayValue:"Loan amount owed to you by Trusts",value:"loan_amount_owed_to_you_by_trusts"},{displayValue:"Loan amount owed to you by Closed Corporations",value:"loan_amount_owed_to_you_by_closed_corporations"},{displayValue:"Loan amount owed to you by Private Companies",value:"loan_amount_owed_to_you_by_private_companies"},{displayValue:"Foreign Assets",value:"foreign_assets"},{displayValue:"Usufruct, Annuity charged on Property or similar right",value:"usufruct_annuity_charged_on_property_or_similar_right"}];

/***/ }),
/* 274 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var Class = function Class () {};

/* harmony default export */ __webpack_exports__["a"] = (Class);

/***/ }),
/* 275 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = defineAccessors;
function setAccessor(field) {
    return function(value) {
        if (this[field] !== value) {
            this[field] = value;
            this.geometryChange();
        }

        return this;
    };
}

function getAccessor(field) {
    return function() {
        return this[field];
    };
}

function defineAccessors(fn, fields) {
    for (var i = 0; i < fields.length; i++) {
        var name = fields[i];
        var capitalized = name.charAt(0).toUpperCase() +
                          name.substring(1, name.length);

        fn["set" + capitalized] = setAccessor(name);
        fn["get" + capitalized] = getAccessor(name);
    }
}

/***/ }),
/* 276 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__accessors_define_accessors__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_observers_mixin__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util__ = __webpack_require__(22);





var Size = (function (Class) {
    function Size(width, height) {
        Class.call(this);

        this.width = width || 0;
        this.height = height || 0;
    }

    if ( Class ) Size.__proto__ = Class;
    Size.prototype = Object.create( Class && Class.prototype );
    Size.prototype.constructor = Size;

    var staticAccessors = { ZERO: { configurable: true } };

    Size.prototype.equals = function equals (other) {
        return other && other.width === this.width && other.height === this.height;
    };

    Size.prototype.clone = function clone () {
        return new Size(this.width, this.height);
    };

    Size.prototype.toArray = function toArray (digits) {
        var doRound = Object(__WEBPACK_IMPORTED_MODULE_3__util__["g" /* defined */])(digits);
        var width = doRound ? Object(__WEBPACK_IMPORTED_MODULE_3__util__["w" /* round */])(this.width, digits) : this.width;
        var height = doRound ? Object(__WEBPACK_IMPORTED_MODULE_3__util__["w" /* round */])(this.height, digits) : this.height;

        return [ width, height ];
    };

    Size.create = function create (arg0, arg1) {
        if (Object(__WEBPACK_IMPORTED_MODULE_3__util__["g" /* defined */])(arg0)) {
            if (arg0 instanceof Size) {
                return arg0;
            } else if (arguments.length === 1 && arg0.length === 2) {
                return new Size(arg0[0], arg0[1]);
            }

            return new Size(arg0, arg1);
        }
    };

    staticAccessors.ZERO.get = function () {
        return new Size(0, 0);
    };

    Object.defineProperties( Size, staticAccessors );

    return Size;
}(__WEBPACK_IMPORTED_MODULE_2__common__["a" /* Class */]));

Object(__WEBPACK_IMPORTED_MODULE_0__accessors_define_accessors__["a" /* default */])(Size.prototype, [ "width", "height" ]);
__WEBPACK_IMPORTED_MODULE_1__mixins_observers_mixin__["a" /* default */].extend(Size.prototype);

/* harmony default export */ __webpack_exports__["a"] = (Size);

/***/ }),
/* 277 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = defineGeometryAccessors;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util__ = __webpack_require__(22);


function geometryAccessor(name) {
    var fieldName = "_" + name;
    return function(value) {
        if (Object(__WEBPACK_IMPORTED_MODULE_0__util__["g" /* defined */])(value)) {
            this._observerField(fieldName, value);
            this.geometryChange();
            return this;
        }

        return this[fieldName];
    };
}

function defineGeometryAccessors(fn, names) {
    for (var i = 0; i < names.length; i++) {
        fn[names[i]] = geometryAccessor(names[i]);
    }
}

/***/ }),
/* 278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PRECISION; });
var PRECISION = 10;



/***/ }),
/* 279 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = definePointAccessors;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__geometry_point__ = __webpack_require__(42);



function pointAccessor(name) {
    var fieldName = "_" + name;
    return function(value) {
        if (Object(__WEBPACK_IMPORTED_MODULE_0__util__["g" /* defined */])(value)) {
            this._observerField(fieldName, __WEBPACK_IMPORTED_MODULE_1__geometry_point__["a" /* default */].create(value));
            this.geometryChange();
            return this;
        }

        return this[fieldName];
    };
}

function definePointAccessors(fn, names) {
    for (var i = 0; i < names.length; i++) {
        fn[names[i]] = pointAccessor(names[i]);
    }
}

/***/ }),
/* 280 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = translateToPoint;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__geometry_transform__ = __webpack_require__(85);


function translateToPoint(point, bbox, element) {
    var transofrm = element.transform() || Object(__WEBPACK_IMPORTED_MODULE_0__geometry_transform__["a" /* default */])();
    var matrix = transofrm.matrix();
    matrix.e += point.x - bbox.origin.x;
    matrix.f += point.y - bbox.origin.y;

    transofrm.matrix(matrix);
    element.transform(transofrm);
}

/***/ }),
/* 281 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common__ = __webpack_require__(29);


var SurfaceFactory = (function (Class) {
    function SurfaceFactory() {
        Class.call(this);

        this._items = [];
    }

    if ( Class ) SurfaceFactory.__proto__ = Class;
    SurfaceFactory.prototype = Object.create( Class && Class.prototype );
    SurfaceFactory.prototype.constructor = SurfaceFactory;

    SurfaceFactory.prototype.register = function register (name, type, order) {
        var items = this._items;
        var first = items[0];
        var entry = {
            name: name,
            type: type,
            order: order
        };

        if (!first || order < first.order) {
            items.unshift(entry);
        } else {
            items.push(entry);
        }
    };

    SurfaceFactory.prototype.create = function create (element, options) {
        var items = this._items;
        var match = items[0];

        if (options && options.type) {
            var preferred = options.type.toLowerCase();
            for (var i = 0; i < items.length; i++) {
                if (items[i].name === preferred) {
                    match = items[i];
                    break;
                }
            }
        }

        if (match) {
            return new match.type(element, options);
        }

        Object(__WEBPACK_IMPORTED_MODULE_0__common__["e" /* logToConsole */])(
            "Warning: Unable to create Kendo UI Drawing Surface. Possible causes:\n" +
            "- The browser does not support SVG and Canvas. User agent: " + (navigator.userAgent));
    };

    return SurfaceFactory;
}(__WEBPACK_IMPORTED_MODULE_0__common__["a" /* Class */]));

SurfaceFactory.current = new SurfaceFactory();

/* harmony default export */ __webpack_exports__["a"] = (SurfaceFactory);

/***/ }),
/* 282 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = renderAllAttr;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__render_attribute__ = __webpack_require__(204);


function renderAllAttr(attrs) {
    var output = "";
    for (var i = 0; i < attrs.length; i++) {
        output += Object(__WEBPACK_IMPORTED_MODULE_0__render_attribute__["a" /* default */])(attrs[i][0], attrs[i][1]);
    }

    return output;
}

/***/ }),
/* 283 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = renderPath;

function renderPath(ctx, path) {
    var segments = path.segments;

    if (segments.length === 0) {
        return;
    }

    var segment = segments[0];
    var anchor = segment.anchor();
    ctx.moveTo(anchor.x, anchor.y);

    for (var i = 1; i < segments.length; i++) {
        segment = segments[i];
        anchor = segment.anchor();

        var prevSeg = segments[i - 1];
        var prevOut = prevSeg.controlOut();
        var controlIn = segment.controlIn();

        if (prevOut && controlIn) {
            ctx.bezierCurveTo(prevOut.x, prevOut.y,
                              controlIn.x, controlIn.y,
                              anchor.x, anchor.y);
        } else {
            ctx.lineTo(anchor.x, anchor.y);
        }
    }

    if (path.options.closed) {
        ctx.closePath();
    }
}

/***/ }),
/* 284 */
/***/ (function(module, exports) {

/**
 * Compiles a querystring
 * Returns string representation of the object
 *
 * @param {Object}
 * @api private
 */

exports.encode = function (obj) {
  var str = '';

  for (var i in obj) {
    if (obj.hasOwnProperty(i)) {
      if (str.length) str += '&';
      str += encodeURIComponent(i) + '=' + encodeURIComponent(obj[i]);
    }
  }

  return str;
};

/**
 * Parses a simple querystring into an object
 *
 * @param {String} qs
 * @api private
 */

exports.decode = function(qs){
  var qry = {};
  var pairs = qs.split('&');
  for (var i = 0, l = pairs.length; i < l; i++) {
    var pair = pairs[i].split('=');
    qry[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1]);
  }
  return qry;
};


/***/ }),
/* 285 */
/***/ (function(module, exports) {


module.exports = function(a, b){
  var fn = function(){};
  fn.prototype = b.prototype;
  a.prototype = new fn;
  a.prototype.constructor = a;
};

/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(9)
var getDaysInMonth = __webpack_require__(258)

/**
 * @category Month Helpers
 * @summary Add the specified number of months to the given date.
 *
 * @description
 * Add the specified number of months to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of months to be added
 * @returns {Date} the new date with the months added
 *
 * @example
 * // Add 5 months to 1 September 2014:
 * var result = addMonths(new Date(2014, 8, 1), 5)
 * //=> Sun Feb 01 2015 00:00:00
 */
function addMonths (dirtyDate, dirtyAmount) {
  var date = parse(dirtyDate)
  var amount = Number(dirtyAmount)
  var desiredMonth = date.getMonth() + amount
  var dateWithDesiredMonth = new Date(0)
  dateWithDesiredMonth.setFullYear(date.getFullYear(), desiredMonth, 1)
  dateWithDesiredMonth.setHours(0, 0, 0, 0)
  var daysInMonth = getDaysInMonth(dateWithDesiredMonth)
  // Set the last day of the new month
  // if the original date was the last day of the longer month
  date.setMonth(desiredMonth, Math.min(daysInMonth, date.getDate()))
  return date
}

module.exports = addMonths


/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(9)

/**
 * @category Millisecond Helpers
 * @summary Get the number of milliseconds between the given dates.
 *
 * @description
 * Get the number of milliseconds between the given dates.
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @returns {Number} the number of milliseconds
 *
 * @example
 * // How many milliseconds are between
 * // 2 July 2014 12:30:20.600 and 2 July 2014 12:30:21.700?
 * var result = differenceInMilliseconds(
 *   new Date(2014, 6, 2, 12, 30, 21, 700),
 *   new Date(2014, 6, 2, 12, 30, 20, 600)
 * )
 * //=> 1100
 */
function differenceInMilliseconds (dirtyDateLeft, dirtyDateRight) {
  var dateLeft = parse(dirtyDateLeft)
  var dateRight = parse(dirtyDateRight)
  return dateLeft.getTime() - dateRight.getTime()
}

module.exports = differenceInMilliseconds


/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

if (!process.version ||
    process.version.indexOf('v0.') === 0 ||
    process.version.indexOf('v1.') === 0 && process.version.indexOf('v1.8.') !== 0) {
  module.exports = { nextTick: nextTick };
} else {
  module.exports = process
}

function nextTick(fn, arg1, arg2, arg3) {
  if (typeof fn !== 'function') {
    throw new TypeError('"callback" argument must be a function');
  }
  var len = arguments.length;
  var args, i;
  switch (len) {
  case 0:
  case 1:
    return process.nextTick(fn);
  case 2:
    return process.nextTick(function afterTickOne() {
      fn.call(null, arg1);
    });
  case 3:
    return process.nextTick(function afterTickTwo() {
      fn.call(null, arg1, arg2);
    });
  case 4:
    return process.nextTick(function afterTickThree() {
      fn.call(null, arg1, arg2, arg3);
    });
  default:
    args = new Array(len - 1);
    i = 0;
    while (i < args.length) {
      args[i++] = arguments[i];
    }
    return process.nextTick(function afterTick() {
      fn.apply(null, args);
    });
  }
}


/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(74)))

/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable node/no-deprecated-api */
var buffer = __webpack_require__(123)
var Buffer = buffer.Buffer

// alternative to using Object.keys for old browsers
function copyProps (src, dst) {
  for (var key in src) {
    dst[key] = src[key]
  }
}
if (Buffer.from && Buffer.alloc && Buffer.allocUnsafe && Buffer.allocUnsafeSlow) {
  module.exports = buffer
} else {
  // Copy properties from require('buffer')
  copyProps(buffer, exports)
  exports.Buffer = SafeBuffer
}

function SafeBuffer (arg, encodingOrOffset, length) {
  return Buffer(arg, encodingOrOffset, length)
}

// Copy static methods from Buffer
copyProps(Buffer, SafeBuffer)

SafeBuffer.from = function (arg, encodingOrOffset, length) {
  if (typeof arg === 'number') {
    throw new TypeError('Argument must not be a number')
  }
  return Buffer(arg, encodingOrOffset, length)
}

SafeBuffer.alloc = function (size, fill, encoding) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  var buf = Buffer(size)
  if (fill !== undefined) {
    if (typeof encoding === 'string') {
      buf.fill(fill, encoding)
    } else {
      buf.fill(fill)
    }
  } else {
    buf.fill(0)
  }
  return buf
}

SafeBuffer.allocUnsafe = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return Buffer(size)
}

SafeBuffer.allocUnsafeSlow = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return buffer.SlowBuffer(size)
}


/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {
Object.defineProperty(exports, "__esModule", { value: true });
var is_1 = __webpack_require__(125);
var string_1 = __webpack_require__(432);
/**
 * Serializes the given object into a string.
 * Like JSON.stringify, but doesn't throw on circular references.
 *
 * @param object A JSON-serializable object.
 * @returns A string containing the serialized object.
 */
function serialize(object) {
    return JSON.stringify(object, serializer({ normalize: false }));
}
exports.serialize = serialize;
/**
 * Deserializes an object from a string previously serialized with
 * {@link serialize}.
 *
 * @param str A serialized object.
 * @returns The deserialized object.
 */
function deserialize(str) {
    return JSON.parse(str);
}
exports.deserialize = deserialize;
/**
 * Creates a deep copy of the given object.
 *
 * The object must be serializable, i.e.:
 *  - It must not contain any cycles
 *  - Only primitive types are allowed (object, array, number, string, boolean)
 *  - Its depth should be considerably low for performance reasons
 *
 * @param object A JSON-serializable object.
 * @returns The object clone.
 */
function clone(object) {
    return deserialize(serialize(object));
}
exports.clone = clone;
/**
 * Wrap a given object method with a higher-order function
 *
 * @param source An object that contains a method to be wrapped.
 * @param name A name of method to be wrapped.
 * @param replacement A function that should be used to wrap a given method.
 * @returns void
 */
function fill(source, name, replacement) {
    if (!(name in source) || source[name].__sentry__) {
        return;
    }
    var original = source[name];
    var wrapped = replacement(original);
    wrapped.__sentry__ = true;
    wrapped.__sentry_original__ = original;
    wrapped.__sentry_wrapped__ = wrapped;
    source[name] = wrapped;
}
exports.fill = fill;
/**
 * Encodes given object into url-friendly format
 *
 * @param object An object that contains serializable values
 * @returns string Encoded
 */
function urlEncode(object) {
    return Object.keys(object)
        .map(
    // tslint:disable-next-line:no-unsafe-any
    function (key) { return encodeURIComponent(key) + "=" + encodeURIComponent(object[key]); })
        .join('&');
}
exports.urlEncode = urlEncode;
// Default Node.js REPL depth
var MAX_SERIALIZE_EXCEPTION_DEPTH = 3;
// 100kB, as 200kB is max payload size, so half sounds reasonable
var MAX_SERIALIZE_EXCEPTION_SIZE = 100 * 1024;
var MAX_SERIALIZE_KEYS_LENGTH = 40;
/** JSDoc */
function utf8Length(value) {
    // tslint:disable-next-line:no-bitwise
    return ~-encodeURI(value).split(/%..|./).length;
}
/** JSDoc */
function jsonSize(value) {
    return utf8Length(JSON.stringify(value));
}
/** JSDoc */
function serializeValue(value) {
    var type = Object.prototype.toString.call(value);
    if (typeof value === 'string') {
        return string_1.truncate(value, 40);
    }
    else if (type === '[object Object]') {
        // Node.js REPL notation
        return '[Object]';
    }
    else if (type === '[object Array]') {
        // Node.js REPL notation
        return '[Array]';
    }
    else {
        return normalizeValue(value);
    }
}
/** JSDoc */
function serializeObject(value, depth) {
    if (depth === 0) {
        return serializeValue(value);
    }
    if (is_1.isPlainObject(value)) {
        var serialized_1 = {};
        var val_1 = value;
        Object.keys(val_1).forEach(function (key) {
            serialized_1[key] = serializeObject(val_1[key], depth - 1);
        });
        return serialized_1;
    }
    else if (Array.isArray(value)) {
        var val = value;
        return val.map(function (v) { return serializeObject(v, depth - 1); });
    }
    return serializeValue(value);
}
exports.serializeObject = serializeObject;
/** JSDoc */
function limitObjectDepthToSize(object, depth, maxSize) {
    if (depth === void 0) { depth = MAX_SERIALIZE_EXCEPTION_DEPTH; }
    if (maxSize === void 0) { maxSize = MAX_SERIALIZE_EXCEPTION_SIZE; }
    var serialized = serializeObject(object, depth);
    if (jsonSize(serialize(serialized)) > maxSize) {
        return limitObjectDepthToSize(object, depth - 1);
    }
    return serialized;
}
exports.limitObjectDepthToSize = limitObjectDepthToSize;
/** JSDoc */
function serializeKeysToEventMessage(keys, maxLength) {
    if (maxLength === void 0) { maxLength = MAX_SERIALIZE_KEYS_LENGTH; }
    if (!keys.length) {
        return '[object has no keys]';
    }
    if (keys[0].length >= maxLength) {
        return string_1.truncate(keys[0], maxLength);
    }
    for (var includedKeys = keys.length; includedKeys > 0; includedKeys--) {
        var serialized = keys.slice(0, includedKeys).join(', ');
        if (serialized.length > maxLength) {
            continue;
        }
        if (includedKeys === keys.length) {
            return serialized;
        }
        return string_1.truncate(serialized, maxLength);
    }
    return '';
}
exports.serializeKeysToEventMessage = serializeKeysToEventMessage;
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/assign#Polyfill
/** JSDoc */
function assign(target) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    if (target === null || target === undefined) {
        throw new TypeError('Cannot convert undefined or null to object');
    }
    var to = Object(target);
    // tslint:disable-next-line
    for (var i = 0; i < args.length; i++) {
        var source = args[i];
        if (source !== null) {
            for (var nextKey in source) {
                if (Object.prototype.hasOwnProperty.call(source, nextKey)) {
                    to[nextKey] = source[nextKey];
                }
            }
        }
    }
    return to;
}
exports.assign = assign;
/**
 * Transforms Error object into an object literal with all it's attributes
 * attached to it.
 *
 * Based on: https://github.com/ftlabs/js-abbreviate/blob/fa709e5f139e7770a71827b1893f22418097fbda/index.js#L95-L106
 *
 * @param error An Error containing all relevant information
 * @returns An object with all error properties
 */
function objectifyError(error) {
    // These properties are implemented as magical getters and don't show up in `for-in` loop
    var err = {
        message: error.message,
        name: error.name,
        stack: error.stack,
    };
    for (var i in error) {
        if (Object.prototype.hasOwnProperty.call(error, i)) {
            err[i] = error[i];
        }
    }
    return err;
}
/**
 * normalizeValue()
 *
 * Takes unserializable input and make it serializable friendly
 *
 * - translates undefined/NaN values to "[undefined]"/"[NaN]" respectively,
 * - serializes Error objects
 * - filter global objects
 */
function normalizeValue(value, key) {
    if (key === 'domain' && typeof value === 'object' && value._events) {
        return '[Domain]';
    }
    if (key === 'domainEmitter') {
        return '[DomainEmitter]';
    }
    if (typeof global !== 'undefined' && value === global) {
        return '[Global]';
    }
    if (typeof window !== 'undefined' && value === window) {
        return '[Window]';
    }
    if (typeof document !== 'undefined' && value === document) {
        return '[Document]';
    }
    if (value instanceof Date) {
        return "[Date] " + value;
    }
    if (value instanceof Error) {
        return objectifyError(value);
    }
    if (is_1.isNaN(value)) {
        return '[NaN]';
    }
    if (is_1.isUndefined(value)) {
        return '[undefined]';
    }
    if (typeof value === 'function') {
        return "[Function: " + (value.name || '<unknown-function-name>') + "]";
    }
    return value;
}
/**
 * serializer()
 *
 * Remove circular references,
 * translates undefined/NaN values to "[undefined]"/"[NaN]" respectively,
 * and takes care of Error objects serialization
 */
function serializer(options) {
    if (options === void 0) { options = { normalize: true }; }
    var stack = [];
    var keys = [];
    /** recursive */
    function cycleserializer(_key, value) {
        if (stack[0] === value) {
            return '[Circular ~]';
        }
        return "[Circular ~." + keys.slice(0, stack.indexOf(value)).join('.') + "]";
    }
    return function (key, value) {
        if (stack.length > 0) {
            var thisPos = stack.indexOf(this);
            if (thisPos === -1) {
                stack.push(this);
                keys.push(key);
            }
            else {
                stack.splice(thisPos + 1);
                keys.splice(thisPos, Infinity, key);
            }
            if (stack.indexOf(value) !== -1) {
                // tslint:disable-next-line:no-parameter-reassignment
                value = cycleserializer.call(this, key, value);
            }
        }
        else {
            stack.push(value);
        }
        return options.normalize ? normalizeValue(value, key) : value;
    };
}
/**
 * safeNormalize()
 *
 * Creates a copy of the input by applying serializer function on it and parsing it back to unify the data
 */
function safeNormalize(input) {
    try {
        return JSON.parse(JSON.stringify(input, serializer({ normalize: true })));
    }
    catch (_oO) {
        return '**non-serializable**';
    }
}
exports.safeNormalize = safeNormalize;
//# sourceMappingURL=object.js.map
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(26)))

/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(43);
/** An error emitted by Sentry SDKs and related utilities. */
var SentryError = /** @class */ (function (_super) {
    tslib_1.__extends(SentryError, _super);
    function SentryError(message) {
        var _newTarget = this.constructor;
        var _this = _super.call(this, message) || this;
        _this.message = message;
        // tslint:disable:no-unsafe-any
        _this.name = _newTarget.prototype.constructor.name;
        Object.setPrototypeOf(_this, _newTarget.prototype);
        return _this;
    }
    return SentryError;
}(Error));
exports.SentryError = SentryError;
//# sourceMappingURL=error.js.map

/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyObject = {};

if (false) {
  Object.freeze(emptyObject);
}

module.exports = emptyObject;

/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 * 
 */

/*eslint-disable no-self-compare */



var hasOwnProperty = Object.prototype.hasOwnProperty;

/**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */
function is(x, y) {
  // SameValue algorithm
  if (x === y) {
    // Steps 1-5, 7-10
    // Steps 6.b-6.e: +0 != -0
    // Added the nonzero y check to make Flow happy, but it is redundant
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    // Step 6.a: NaN == NaN
    return x !== x && y !== y;
  }
}

/**
 * Performs equality by iterating through keys on an object and returning false
 * when any key has values which are not strictly equal between the arguments.
 * Returns true when the values of all keys are strictly equal.
 */
function shallowEqual(objA, objB) {
  if (is(objA, objB)) {
    return true;
  }

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

module.exports = shallowEqual;

/***/ }),
/* 296 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);


var createTransitionManager = function createTransitionManager() {
  var prompt = null;

  var setPrompt = function setPrompt(nextPrompt) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(prompt == null, 'A history supports only one prompt at a time');

    prompt = nextPrompt;

    return function () {
      if (prompt === nextPrompt) prompt = null;
    };
  };

  var confirmTransitionTo = function confirmTransitionTo(location, action, getUserConfirmation, callback) {
    // TODO: If another transition starts while we're still confirming
    // the previous one, we may end up in a weird state. Figure out the
    // best way to handle this.
    if (prompt != null) {
      var result = typeof prompt === 'function' ? prompt(location, action) : prompt;

      if (typeof result === 'string') {
        if (typeof getUserConfirmation === 'function') {
          getUserConfirmation(result, callback);
        } else {
          __WEBPACK_IMPORTED_MODULE_0_warning___default()(false, 'A history needs a getUserConfirmation function in order to use a prompt message');

          callback(true);
        }
      } else {
        // Return false from a transition hook to cancel the transition.
        callback(result !== false);
      }
    } else {
      callback(true);
    }
  };

  var listeners = [];

  var appendListener = function appendListener(fn) {
    var isActive = true;

    var listener = function listener() {
      if (isActive) fn.apply(undefined, arguments);
    };

    listeners.push(listener);

    return function () {
      isActive = false;
      listeners = listeners.filter(function (item) {
        return item !== listener;
      });
    };
  };

  var notifyListeners = function notifyListeners() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    listeners.forEach(function (listener) {
      return listener.apply(undefined, args);
    });
  };

  return {
    setPrompt: setPrompt,
    confirmTransitionTo: confirmTransitionTo,
    appendListener: appendListener,
    notifyListeners: notifyListeners
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createTransitionManager);

/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var addLeadingSlash = exports.addLeadingSlash = function addLeadingSlash(path) {
  return path.charAt(0) === '/' ? path : '/' + path;
};

var stripLeadingSlash = exports.stripLeadingSlash = function stripLeadingSlash(path) {
  return path.charAt(0) === '/' ? path.substr(1) : path;
};

var hasBasename = exports.hasBasename = function hasBasename(path, prefix) {
  return new RegExp('^' + prefix + '(\\/|\\?|#|$)', 'i').test(path);
};

var stripBasename = exports.stripBasename = function stripBasename(path, prefix) {
  return hasBasename(path, prefix) ? path.substr(prefix.length) : path;
};

var stripTrailingSlash = exports.stripTrailingSlash = function stripTrailingSlash(path) {
  return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
};

var parsePath = exports.parsePath = function parsePath(path) {
  var pathname = path || '/';
  var search = '';
  var hash = '';

  var hashIndex = pathname.indexOf('#');
  if (hashIndex !== -1) {
    hash = pathname.substr(hashIndex);
    pathname = pathname.substr(0, hashIndex);
  }

  var searchIndex = pathname.indexOf('?');
  if (searchIndex !== -1) {
    search = pathname.substr(searchIndex);
    pathname = pathname.substr(0, searchIndex);
  }

  return {
    pathname: pathname,
    search: search === '?' ? '' : search,
    hash: hash === '#' ? '' : hash
  };
};

var createPath = exports.createPath = function createPath(location) {
  var pathname = location.pathname,
      search = location.search,
      hash = location.hash;


  var path = pathname || '/';

  if (search && search !== '?') path += search.charAt(0) === '?' ? search : '?' + search;

  if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : '#' + hash;

  return path;
};

/***/ }),
/* 298 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Router__ = __webpack_require__(211);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Router__["a" /* default */]);

/***/ }),
/* 299 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__matchPath__ = __webpack_require__(212);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var isEmptyChildren = function isEmptyChildren(children) {
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.count(children) === 0;
};

/**
 * The public API for matching a single path and rendering.
 */

var Route = function (_React$Component) {
  _inherits(Route, _React$Component);

  function Route() {
    var _temp, _this, _ret;

    _classCallCheck(this, Route);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      match: _this.computeMatch(_this.props, _this.context.router)
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Route.prototype.getChildContext = function getChildContext() {
    return {
      router: _extends({}, this.context.router, {
        route: {
          location: this.props.location || this.context.router.route.location,
          match: this.state.match
        }
      })
    };
  };

  Route.prototype.computeMatch = function computeMatch(_ref, router) {
    var computedMatch = _ref.computedMatch,
        location = _ref.location,
        path = _ref.path,
        strict = _ref.strict,
        exact = _ref.exact,
        sensitive = _ref.sensitive;

    if (computedMatch) return computedMatch; // <Switch> already computed the match for us

    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(router, "You should not use <Route> or withRouter() outside a <Router>");

    var route = router.route;

    var pathname = (location || route.location).pathname;

    return Object(__WEBPACK_IMPORTED_MODULE_4__matchPath__["a" /* default */])(pathname, { path: path, strict: strict, exact: exact, sensitive: sensitive }, route.match);
  };

  Route.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.component && this.props.render), "You should not use <Route component> and <Route render> in the same route; <Route render> will be ignored");

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.component && this.props.children && !isEmptyChildren(this.props.children)), "You should not use <Route component> and <Route children> in the same route; <Route children> will be ignored");

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.render && this.props.children && !isEmptyChildren(this.props.children)), "You should not use <Route render> and <Route children> in the same route; <Route children> will be ignored");
  };

  Route.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps, nextContext) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(nextProps.location && !this.props.location), '<Route> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(!nextProps.location && this.props.location), '<Route> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');

    this.setState({
      match: this.computeMatch(nextProps, nextContext.router)
    });
  };

  Route.prototype.render = function render() {
    var match = this.state.match;
    var _props = this.props,
        children = _props.children,
        component = _props.component,
        render = _props.render;
    var _context$router = this.context.router,
        history = _context$router.history,
        route = _context$router.route,
        staticContext = _context$router.staticContext;

    var location = this.props.location || route.location;
    var props = { match: match, location: location, history: history, staticContext: staticContext };

    if (component) return match ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(component, props) : null;

    if (render) return match ? render(props) : null;

    if (typeof children === "function") return children(props);

    if (children && !isEmptyChildren(children)) return __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(children);

    return null;
  };

  return Route;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

Route.propTypes = {
  computedMatch: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object, // private, from <Switch>
  path: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  exact: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  strict: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  sensitive: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  component: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  render: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node]),
  location: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
Route.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
    route: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
    staticContext: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
  })
};
Route.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Route);

/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = toCss;

var _toCssValue = __webpack_require__(213);

var _toCssValue2 = _interopRequireDefault(_toCssValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 * Indent a string.
 * http://jsperf.com/array-join-vs-for
 */
function indentStr(str, indent) {
  var result = '';
  for (var index = 0; index < indent; index++) {
    result += '  ';
  }return result + str;
}

/**
 * Converts a Rule to CSS string.
 */

function toCss(selector, style) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  var result = '';

  if (!style) return result;

  var _options$indent = options.indent,
      indent = _options$indent === undefined ? 0 : _options$indent;
  var fallbacks = style.fallbacks;


  indent++;

  // Apply fallbacks first.
  if (fallbacks) {
    // Array syntax {fallbacks: [{prop: value}]}
    if (Array.isArray(fallbacks)) {
      for (var index = 0; index < fallbacks.length; index++) {
        var fallback = fallbacks[index];
        for (var prop in fallback) {
          var value = fallback[prop];
          if (value != null) {
            result += '\n' + indentStr(prop + ': ' + (0, _toCssValue2['default'])(value) + ';', indent);
          }
        }
      }
    } else {
      // Object syntax {fallbacks: {prop: value}}
      for (var _prop in fallbacks) {
        var _value = fallbacks[_prop];
        if (_value != null) {
          result += '\n' + indentStr(_prop + ': ' + (0, _toCssValue2['default'])(_value) + ';', indent);
        }
      }
    }
  }

  for (var _prop2 in style) {
    var _value2 = style[_prop2];
    if (_value2 != null && _prop2 !== 'fallbacks') {
      result += '\n' + indentStr(_prop2 + ': ' + (0, _toCssValue2['default'])(_value2) + ';', indent);
    }
  }

  // Allow empty style in this case, because properties will be added dynamically.
  if (!result && !options.allowEmpty) return result;

  indent--;
  result = indentStr(selector + ' {' + result + '\n', indent) + indentStr('}', indent);

  return result;
}

/***/ }),
/* 301 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global, module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ponyfill_js__ = __webpack_require__(794);
/* global window */


var root;

if (typeof self !== 'undefined') {
  root = self;
} else if (typeof window !== 'undefined') {
  root = window;
} else if (typeof global !== 'undefined') {
  root = global;
} else if (true) {
  root = module;
} else {
  root = Function('return this')();
}

var result = Object(__WEBPACK_IMPORTED_MODULE_0__ponyfill_js__["a" /* default */])(root);
/* harmony default export */ __webpack_exports__["default"] = (result);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(26), __webpack_require__(164)(module)))

/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _SheetsRegistry = __webpack_require__(458);

var _SheetsRegistry2 = _interopRequireDefault(_SheetsRegistry);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 * This is a global sheets registry. Only DomRenderer will add sheets to it.
 * On the server one should use an own SheetsRegistry instance and add the
 * sheets to it, because you need to make sure to create a new registry for
 * each request in order to not leak sheets across requests.
 */
exports['default'] = new _SheetsRegistry2['default']();

/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _isInBrowser = __webpack_require__(215);

var _isInBrowser2 = _interopRequireDefault(_isInBrowser);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var js = ''; /**
              * Export javascript style and css style vendor prefixes.
              * Based on "transform" support test.
              */

var css = '';

// We should not do anything if required serverside.
if (_isInBrowser2['default']) {
  // Order matters. We need to check Webkit the last one because
  // other vendors use to add Webkit prefixes to some properties
  var jsCssMap = {
    Moz: '-moz-',
    // IE did it wrong again ...
    ms: '-ms-',
    O: '-o-',
    Webkit: '-webkit-'
  };
  var style = document.createElement('p').style;
  var testProp = 'Transform';

  for (var key in jsCssMap) {
    if (key + testProp in style) {
      js = key;
      css = jsCssMap[key];
      break;
    }
  }
}

/**
 * Vendor prefix string for the current browser.
 *
 * @type {{js: String, css: String}}
 * @api public
 */
exports['default'] = { js: js, css: css };

/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectSpread2 = _interopRequireDefault(__webpack_require__(23));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _deepmerge = _interopRequireDefault(__webpack_require__(216));

var _warning = _interopRequireDefault(__webpack_require__(32));

var _createTypography = _interopRequireDefault(__webpack_require__(822));

var _createBreakpoints = _interopRequireDefault(__webpack_require__(165));

var _createPalette = _interopRequireDefault(__webpack_require__(823));

var _createMixins = _interopRequireDefault(__webpack_require__(824));

var _shadows = _interopRequireDefault(__webpack_require__(825));

var _transitions = _interopRequireDefault(__webpack_require__(78));

var _zIndex = _interopRequireDefault(__webpack_require__(826));

var _spacing = _interopRequireDefault(__webpack_require__(827));

// < 1kb payload overhead when lodash/merge is > 3kb.
function createMuiTheme() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _options$palette = options.palette,
      paletteInput = _options$palette === void 0 ? {} : _options$palette,
      _options$breakpoints = options.breakpoints,
      breakpointsInput = _options$breakpoints === void 0 ? {} : _options$breakpoints,
      _options$mixins = options.mixins,
      mixinsInput = _options$mixins === void 0 ? {} : _options$mixins,
      _options$typography = options.typography,
      typographyInput = _options$typography === void 0 ? {} : _options$typography,
      shadowsInput = options.shadows,
      other = (0, _objectWithoutProperties2.default)(options, ["palette", "breakpoints", "mixins", "typography", "shadows"]);
  var palette = (0, _createPalette.default)(paletteInput);
  var breakpoints = (0, _createBreakpoints.default)(breakpointsInput);
  var muiTheme = (0, _objectSpread2.default)({
    breakpoints: breakpoints,
    direction: 'ltr',
    mixins: (0, _createMixins.default)(breakpoints, _spacing.default, mixinsInput),
    overrides: {},
    // Inject custom styles
    palette: palette,
    props: {},
    // Inject custom properties
    shadows: shadowsInput || _shadows.default,
    typography: (0, _createTypography.default)(palette, typographyInput)
  }, (0, _deepmerge.default)({
    transitions: _transitions.default,
    spacing: _spacing.default,
    zIndex: _zIndex.default
  }, other));
   false ? (0, _warning.default)(muiTheme.shadows.length === 25, 'Material-UI: the shadows array provided to createMuiTheme should support 25 elevations.') : void 0;
  return muiTheme;
}

var _default = createMuiTheme;
exports.default = _default;

/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var common = {
  black: '#000',
  white: '#fff'
};
var _default = common;
exports.default = _default;

/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.CHANNEL = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(11));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

// Same value used by react-jss
var CHANNEL = '__THEMING__';
exports.CHANNEL = CHANNEL;
var themeListener = {
  contextTypes: (0, _defineProperty2.default)({}, CHANNEL, _propTypes.default.object),
  initial: function initial(context) {
    if (!context[CHANNEL]) {
      return null;
    }

    return context[CHANNEL].getState();
  },
  subscribe: function subscribe(context, cb) {
    if (!context[CHANNEL]) {
      return null;
    }

    return context[CHANNEL].subscribe(cb);
  },
  unsubscribe: function unsubscribe(context, subscriptionId) {
    if (context[CHANNEL]) {
      context[CHANNEL].unsubscribe(subscriptionId);
    }
  }
};
var _default = themeListener;
exports.default = _default;

/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Fade.default;
  }
});

var _Fade = _interopRequireDefault(__webpack_require__(855));

/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(8));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(11));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(18));

var _createClass2 = _interopRequireDefault(__webpack_require__(19));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(20));

var _inherits2 = _interopRequireDefault(__webpack_require__(21));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _classnames = _interopRequireDefault(__webpack_require__(6));

var _withStyles = _interopRequireDefault(__webpack_require__(5));

var _IconButton = _interopRequireDefault(__webpack_require__(168));

// @inheritedComponent IconButton
var styles = {
  root: {
    display: 'inline-flex',
    alignItems: 'center',
    transition: 'none',
    '&:hover': {
      // Disable the hover effect for the IconButton.
      backgroundColor: 'transparent'
    }
  },
  checked: {},
  disabled: {},
  input: {
    cursor: 'inherit',
    position: 'absolute',
    opacity: 0,
    width: '100%',
    height: '100%',
    top: 0,
    left: 0,
    margin: 0,
    padding: 0
  }
};
exports.styles = styles;

var SwitchBase =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(SwitchBase, _React$Component);

  function SwitchBase(props) {
    var _this;

    (0, _classCallCheck2.default)(this, SwitchBase);
    _this = (0, _possibleConstructorReturn2.default)(this, (SwitchBase.__proto__ || Object.getPrototypeOf(SwitchBase)).call(this, props));
    _this.state = {};
    _this.input = null;
    _this.isControlled = null;

    _this.handleInputChange = function (event) {
      var checked = event.target.checked;

      if (!_this.isControlled) {
        _this.setState({
          checked: checked
        });
      }

      if (_this.props.onChange) {
        _this.props.onChange(event, checked);
      }
    };

    _this.isControlled = props.checked != null;

    if (!_this.isControlled) {
      // not controlled, use internal state
      _this.state.checked = props.defaultChecked !== undefined ? props.defaultChecked : false;
    }

    return _this;
  }

  (0, _createClass2.default)(SwitchBase, [{
    key: "render",
    value: function render() {
      var _classNames;

      var _props = this.props,
          checkedProp = _props.checked,
          checkedIcon = _props.checkedIcon,
          classes = _props.classes,
          classNameProp = _props.className,
          disabledProp = _props.disabled,
          icon = _props.icon,
          id = _props.id,
          inputProps = _props.inputProps,
          inputRef = _props.inputRef,
          name = _props.name,
          onChange = _props.onChange,
          tabIndex = _props.tabIndex,
          type = _props.type,
          value = _props.value,
          other = (0, _objectWithoutProperties2.default)(_props, ["checked", "checkedIcon", "classes", "className", "disabled", "icon", "id", "inputProps", "inputRef", "name", "onChange", "tabIndex", "type", "value"]);
      var muiFormControl = this.context.muiFormControl;
      var disabled = disabledProp;

      if (muiFormControl) {
        if (typeof disabled === 'undefined') {
          disabled = muiFormControl.disabled;
        }
      }

      var checked = this.isControlled ? checkedProp : this.state.checked;
      var hasLabelFor = type === 'checkbox' || type === 'radio';
      return _react.default.createElement(_IconButton.default, (0, _extends2.default)({
        component: "span",
        className: (0, _classnames.default)(classes.root, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes.checked, checked), (0, _defineProperty2.default)(_classNames, classes.disabled, disabled), _classNames), classNameProp),
        disabled: disabled,
        tabIndex: null,
        role: undefined
      }, other), checked ? checkedIcon : icon, _react.default.createElement("input", (0, _extends2.default)({
        id: hasLabelFor && id,
        type: type,
        name: name,
        checked: checked,
        onChange: this.handleInputChange,
        className: classes.input,
        disabled: disabled,
        tabIndex: tabIndex,
        value: value,
        ref: inputRef
      }, inputProps)));
    }
  }]);
  return SwitchBase;
}(_react.default.Component); // NB: If changed, please update Checkbox, Switch and Radio
// so that the API documentation is updated.


SwitchBase.propTypes =  false ? {
  /**
   * If `true`, the component is checked.
   */
  checked: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.string]),

  /**
   * The icon to display when the component is checked.
   */
  checkedIcon: _propTypes.default.node.isRequired,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * @ignore
   */
  defaultChecked: _propTypes.default.bool,

  /**
   * If `true`, the switch will be disabled.
   */
  disabled: _propTypes.default.bool,

  /**
   * If `true`, the ripple effect will be disabled.
   */
  disableRipple: _propTypes.default.bool,

  /**
   * The icon to display when the component is unchecked.
   */
  icon: _propTypes.default.node.isRequired,

  /**
   * The id of the `input` element.
   */
  id: _propTypes.default.string,

  /**
   * If `true`, the component appears indeterminate.
   */
  indeterminate: _propTypes.default.bool,

  /**
   * The icon to display when the component is indeterminate.
   */
  indeterminateIcon: _propTypes.default.node,

  /**
   * Properties applied to the `input` element.
   */
  inputProps: _propTypes.default.object,

  /**
   * Use that property to pass a ref callback to the native input component.
   */
  inputRef: _propTypes.default.func,

  /*
   * @ignore
   */
  name: _propTypes.default.string,

  /**
   * Callback fired when the state is changed.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.checked`.
   * @param {boolean} checked The `checked` value of the switch
   */
  onChange: _propTypes.default.func,

  /**
   * @ignore
   */
  tabIndex: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),

  /**
   * The input component property `type`.
   */
  type: _propTypes.default.string,

  /**
   * The value of the component.
   */
  value: _propTypes.default.string
} : {};
SwitchBase.defaultProps = {
  type: 'checkbox'
};
SwitchBase.contextTypes = {
  muiFormControl: _propTypes.default.object
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiSwitchBase'
})(SwitchBase);

exports.default = _default;

/***/ }),
/* 309 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 310 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(137);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 312 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(169);
var dPs = __webpack_require__(898);
var enumBugKeys = __webpack_require__(317);
var IE_PROTO = __webpack_require__(315)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(476)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(903).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(478);
var enumBugKeys = __webpack_require__(317);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(316)('keys');
var uid = __webpack_require__(224);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(134);
var global = __webpack_require__(92);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__(220) ? 'pure' : 'global',
  copyright: '© 2019 Denis Pushkarev (zloirock.ru)'
});


/***/ }),
/* 317 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(136).f;
var has = __webpack_require__(106);
var TAG = __webpack_require__(140)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(140);


/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(92);
var core = __webpack_require__(134);
var LIBRARY = __webpack_require__(220);
var wksExt = __webpack_require__(319);
var defineProperty = __webpack_require__(136).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 321 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Portal.default;
  }
});

var _Portal = _interopRequireDefault(__webpack_require__(955));

/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(72);

exports.__esModule = true;
exports.default = scrollbarSize;

var _inDOM = _interopRequireDefault(__webpack_require__(167));

var size;

function scrollbarSize(recalc) {
  if (!size && size !== 0 || recalc) {
    if (_inDOM.default) {
      var scrollDiv = document.createElement('div');
      scrollDiv.style.position = 'absolute';
      scrollDiv.style.top = '-9999px';
      scrollDiv.style.width = '50px';
      scrollDiv.style.height = '50px';
      scrollDiv.style.overflow = 'scroll';
      document.body.appendChild(scrollDiv);
      size = scrollDiv.offsetWidth - scrollDiv.clientWidth;
      document.body.removeChild(scrollDiv);
    }
  }

  return size;
}

module.exports = exports["default"];

/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isHorizontal = isHorizontal;
exports.getAnchor = getAnchor;
exports.default = exports.styles = void 0;

var _objectSpread2 = _interopRequireDefault(__webpack_require__(23));

var _extends2 = _interopRequireDefault(__webpack_require__(8));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(11));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(18));

var _createClass2 = _interopRequireDefault(__webpack_require__(19));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(20));

var _inherits2 = _interopRequireDefault(__webpack_require__(21));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _classnames = _interopRequireDefault(__webpack_require__(6));

var _Modal = _interopRequireDefault(__webpack_require__(226));

var _withStyles = _interopRequireDefault(__webpack_require__(5));

var _Slide = _interopRequireDefault(__webpack_require__(325));

var _Paper = _interopRequireDefault(__webpack_require__(69));

var _helpers = __webpack_require__(36);

var _transitions = __webpack_require__(78);

var oppositeDirection = {
  left: 'right',
  right: 'left',
  top: 'down',
  bottom: 'up'
};

function isHorizontal(props) {
  return ['left', 'right'].indexOf(props.anchor) !== -1;
}

function getAnchor(props) {
  return props.theme.direction === 'rtl' && isHorizontal(props) ? oppositeDirection[props.anchor] : props.anchor;
}

var styles = function styles(theme) {
  return {
    docked: {
      flex: '0 0 auto'
    },
    paper: {
      overflowY: 'auto',
      display: 'flex',
      flexDirection: 'column',
      height: '100vh',
      flex: '1 0 auto',
      zIndex: theme.zIndex.drawer,
      WebkitOverflowScrolling: 'touch',
      // Add iOS momentum scrolling.
      // temporary style
      position: 'fixed',
      top: 0,
      // We disable the focus ring for mouse, touch and keyboard users.
      // At some point, it would be better to keep it for keyboard users.
      // :focus-ring CSS pseudo-class will help.
      outline: 'none'
    },
    paperAnchorLeft: {
      left: 0,
      right: 'auto'
    },
    paperAnchorRight: {
      left: 'auto',
      right: 0
    },
    paperAnchorTop: {
      top: 0,
      left: 0,
      bottom: 'auto',
      right: 0,
      height: 'auto',
      maxHeight: '100vh'
    },
    paperAnchorBottom: {
      top: 'auto',
      left: 0,
      bottom: 0,
      right: 0,
      height: 'auto',
      maxHeight: '100vh'
    },
    paperAnchorDockedLeft: {
      borderRight: "1px solid ".concat(theme.palette.divider)
    },
    paperAnchorDockedTop: {
      borderBottom: "1px solid ".concat(theme.palette.divider)
    },
    paperAnchorDockedRight: {
      borderLeft: "1px solid ".concat(theme.palette.divider)
    },
    paperAnchorDockedBottom: {
      borderTop: "1px solid ".concat(theme.palette.divider)
    },
    modal: {} // Just here so people can override the style.

  };
};
/**
 * The properties of the [Modal](/api/modal) component are available
 * when `variant="temporary"` is set.
 */


exports.styles = styles;

var Drawer =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(Drawer, _React$Component);

  function Drawer() {
    var _ref;

    var _temp, _this;

    (0, _classCallCheck2.default)(this, Drawer);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return (0, _possibleConstructorReturn2.default)(_this, (_temp = _this = (0, _possibleConstructorReturn2.default)(this, (_ref = Drawer.__proto__ || Object.getPrototypeOf(Drawer)).call.apply(_ref, [this].concat(args))), _this.mounted = false, _temp));
  }

  (0, _createClass2.default)(Drawer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.mounted = true;
    } // Let's assume that the Drawer will always be rendered on user space.
    // We use that state is order to skip the appear transition during the
    // initial mount of the component.

  }, {
    key: "render",
    value: function render() {
      var _props = this.props,
          anchorProp = _props.anchor,
          children = _props.children,
          classes = _props.classes,
          className = _props.className,
          elevation = _props.elevation,
          _props$ModalProps = _props.ModalProps;
      _props$ModalProps = _props$ModalProps === void 0 ? {} : _props$ModalProps;
      var BackdropPropsProp = _props$ModalProps.BackdropProps,
          ModalProps = (0, _objectWithoutProperties2.default)(_props$ModalProps, ["BackdropProps"]),
          onClose = _props.onClose,
          open = _props.open,
          PaperProps = _props.PaperProps,
          SlideProps = _props.SlideProps,
          theme = _props.theme,
          transitionDuration = _props.transitionDuration,
          variant = _props.variant,
          other = (0, _objectWithoutProperties2.default)(_props, ["anchor", "children", "classes", "className", "elevation", "ModalProps", "onClose", "open", "PaperProps", "SlideProps", "theme", "transitionDuration", "variant"]);
      var anchor = getAnchor(this.props);

      var drawer = _react.default.createElement(_Paper.default, (0, _extends2.default)({
        elevation: variant === 'temporary' ? elevation : 0,
        square: true,
        className: (0, _classnames.default)(classes.paper, classes["paperAnchor".concat((0, _helpers.capitalize)(anchor))], (0, _defineProperty2.default)({}, classes["paperAnchorDocked".concat((0, _helpers.capitalize)(anchor))], variant !== 'temporary'))
      }, PaperProps), children);

      if (variant === 'permanent') {
        return _react.default.createElement("div", (0, _extends2.default)({
          className: (0, _classnames.default)(classes.docked, className)
        }, other), drawer);
      }

      var slidingDrawer = _react.default.createElement(_Slide.default, (0, _extends2.default)({
        "in": open,
        direction: oppositeDirection[anchor],
        timeout: transitionDuration,
        appear: this.mounted
      }, SlideProps), drawer);

      if (variant === 'persistent') {
        return _react.default.createElement("div", (0, _extends2.default)({
          className: (0, _classnames.default)(classes.docked, className)
        }, other), slidingDrawer);
      } // variant === temporary


      return _react.default.createElement(_Modal.default, (0, _extends2.default)({
        BackdropProps: (0, _objectSpread2.default)({}, BackdropPropsProp, {
          transitionDuration: transitionDuration
        }),
        className: (0, _classnames.default)(classes.modal, className),
        open: open,
        onClose: onClose
      }, other, ModalProps), slidingDrawer);
    }
  }]);
  return Drawer;
}(_react.default.Component);

Drawer.propTypes =  false ? {
  /**
   * Side from which the drawer will appear.
   */
  anchor: _propTypes.default.oneOf(['left', 'top', 'right', 'bottom']),

  /**
   * The contents of the drawer.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The elevation of the drawer.
   */
  elevation: _propTypes.default.number,

  /**
   * Properties applied to the `Modal` element.
   */
  ModalProps: _propTypes.default.object,

  /**
   * Callback fired when the component requests to be closed.
   *
   * @param {object} event The event source of the callback
   */
  onClose: _propTypes.default.func,

  /**
   * If `true`, the drawer is open.
   */
  open: _propTypes.default.bool,

  /**
   * Properties applied to the `Paper` element.
   */
  PaperProps: _propTypes.default.object,

  /**
   * Properties applied to the `Slide` element.
   */
  SlideProps: _propTypes.default.object,

  /**
   * @ignore
   */
  theme: _propTypes.default.object.isRequired,

  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   */
  transitionDuration: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
    enter: _propTypes.default.number,
    exit: _propTypes.default.number
  })]),

  /**
   * The variant of drawer.
   */
  variant: _propTypes.default.oneOf(['permanent', 'persistent', 'temporary'])
} : {};
Drawer.defaultProps = {
  anchor: 'left',
  elevation: 16,
  open: false,
  transitionDuration: {
    enter: _transitions.duration.enteringScreen,
    exit: _transitions.duration.leavingScreen
  },
  variant: 'temporary' // Mobile first.

};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiDrawer',
  flip: false,
  withTheme: true
})(Drawer);

exports.default = _default;

/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Slide.default;
  }
});

var _Slide = _interopRequireDefault(__webpack_require__(975));

/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hasValue = hasValue;
exports.isFilled = isFilled;
exports.isAdornedStart = isAdornedStart;
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(8));

var _objectSpread2 = _interopRequireDefault(__webpack_require__(23));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(11));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(18));

var _createClass2 = _interopRequireDefault(__webpack_require__(19));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(20));

var _inherits2 = _interopRequireDefault(__webpack_require__(21));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _classnames = _interopRequireDefault(__webpack_require__(6));

var _withStyles = _interopRequireDefault(__webpack_require__(5));

var _Textarea = _interopRequireDefault(__webpack_require__(985));

// Supports determination of isControlled().
// Controlled input accepts its current value as a prop.
//
// @see https://facebook.github.io/react/docs/forms.html#controlled-components
// @param value
// @returns {boolean} true if string (including '') or number (including zero)
function hasValue(value) {
  return value != null && !(Array.isArray(value) && value.length === 0);
} // Determine if field is empty or filled.
// Response determines if label is presented above field or as placeholder.
//
// @param obj
// @param SSR
// @returns {boolean} False when not present or empty string.
//                    True when any number or string with length.


function isFilled(obj) {
  var SSR = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return obj && (hasValue(obj.value) && obj.value !== '' || SSR && hasValue(obj.defaultValue) && obj.defaultValue !== '');
} // Determine if an Input is adorned on start.
// It's corresponding to the left with LTR.
//
// @param obj
// @returns {boolean} False when no adornments.
//                    True when adorned at the start.


function isAdornedStart(obj) {
  return obj.startAdornment;
}

var styles = function styles(theme) {
  var light = theme.palette.type === 'light';
  var placeholder = {
    color: 'currentColor',
    opacity: light ? 0.42 : 0.5,
    transition: theme.transitions.create('opacity', {
      duration: theme.transitions.duration.shorter
    })
  };
  var placeholderHidden = {
    opacity: 0
  };
  var placeholderVisible = {
    opacity: light ? 0.42 : 0.5
  };
  var bottomLineColor = light ? 'rgba(0, 0, 0, 0.42)' : 'rgba(255, 255, 255, 0.7)';
  return {
    root: {
      // Mimics the default input display property used by browsers for an input.
      display: 'inline-flex',
      position: 'relative',
      fontFamily: theme.typography.fontFamily,
      color: light ? 'rgba(0, 0, 0, 0.87)' : theme.palette.common.white,
      fontSize: theme.typography.pxToRem(16),
      lineHeight: '1.1875em',
      // Reset (19px), match the native input line-height
      '&$disabled': {
        color: theme.palette.text.disabled
      }
    },
    formControl: {
      'label + &': {
        marginTop: theme.spacing.unit * 2
      }
    },
    focused: {},
    disabled: {},
    underline: {
      '&:after': {
        borderBottom: "2px solid ".concat(theme.palette.primary[light ? 'dark' : 'light']),
        left: 0,
        bottom: 0,
        // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
        content: '""',
        position: 'absolute',
        right: 0,
        transform: 'scaleX(0)',
        transition: theme.transitions.create('transform', {
          duration: theme.transitions.duration.shorter,
          easing: theme.transitions.easing.easeOut
        }),
        pointerEvents: 'none' // Transparent to the hover style.

      },
      '&$focused:after': {
        transform: 'scaleX(1)'
      },
      '&$error:after': {
        borderBottomColor: theme.palette.error.main,
        transform: 'scaleX(1)' // error is always underlined in red

      },
      '&:before': {
        borderBottom: "1px solid ".concat(bottomLineColor),
        left: 0,
        bottom: 0,
        // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
        content: '"\\00a0"',
        position: 'absolute',
        right: 0,
        transition: theme.transitions.create('border-bottom-color', {
          duration: theme.transitions.duration.shorter
        }),
        pointerEvents: 'none' // Transparent to the hover style.

      },
      '&:hover:not($disabled):not($focused):not($error):before': {
        borderBottom: "2px solid ".concat(theme.palette.text.primary)
      },
      '&$disabled:before': {
        borderBottom: "1px dotted ".concat(bottomLineColor)
      }
    },
    error: {},
    multiline: {
      padding: "".concat(theme.spacing.unit - 2, "px 0 ").concat(theme.spacing.unit - 1, "px")
    },
    fullWidth: {
      width: '100%'
    },
    input: {
      font: 'inherit',
      color: 'currentColor',
      padding: "".concat(theme.spacing.unit - 2, "px 0 ").concat(theme.spacing.unit - 1, "px"),
      border: 0,
      boxSizing: 'content-box',
      verticalAlign: 'middle',
      background: 'none',
      margin: 0,
      // Reset for Safari
      // Remove grey highlight
      WebkitTapHighlightColor: 'transparent',
      display: 'block',
      // Make the flex item shrink with Firefox
      minWidth: 0,
      flexGrow: 1,
      '&::-webkit-input-placeholder': placeholder,
      '&::-moz-placeholder': placeholder,
      // Firefox 19+
      '&:-ms-input-placeholder': placeholder,
      // IE 11
      '&::-ms-input-placeholder': placeholder,
      // Edge
      '&:focus': {
        outline: 0
      },
      // Reset Firefox invalid required input style
      '&:invalid': {
        boxShadow: 'none'
      },
      '&::-webkit-search-decoration': {
        // Remove the padding when type=search.
        '-webkit-appearance': 'none'
      },
      // Show and hide the placeholder logic
      'label[data-shrink=false] + $formControl &': {
        '&::-webkit-input-placeholder': placeholderHidden,
        '&::-moz-placeholder': placeholderHidden,
        // Firefox 19+
        '&:-ms-input-placeholder': placeholderHidden,
        // IE 11
        '&::-ms-input-placeholder': placeholderHidden,
        // Edge
        '&:focus::-webkit-input-placeholder': placeholderVisible,
        '&:focus::-moz-placeholder': placeholderVisible,
        // Firefox 19+
        '&:focus:-ms-input-placeholder': placeholderVisible,
        // IE 11
        '&:focus::-ms-input-placeholder': placeholderVisible // Edge

      },
      '&$disabled': {
        opacity: 1 // Reset iOS opacity

      }
    },
    inputMarginDense: {
      paddingTop: theme.spacing.unit / 2 - 1
    },
    inputMultiline: {
      resize: 'none',
      padding: 0
    },
    inputType: {
      // type="date" or type="time", etc. have specific styles we need to reset.
      height: '1.1875em' // Reset (19px), match the native input line-height

    },
    inputTypeSearch: {
      // Improve type search style.
      '-moz-appearance': 'textfield',
      '-webkit-appearance': 'textfield'
    }
  };
};

exports.styles = styles;

function formControlState(props, context) {
  var disabled = props.disabled;
  var error = props.error;
  var margin = props.margin;

  if (context && context.muiFormControl) {
    if (typeof disabled === 'undefined') {
      disabled = context.muiFormControl.disabled;
    }

    if (typeof error === 'undefined') {
      error = context.muiFormControl.error;
    }

    if (typeof margin === 'undefined') {
      margin = context.muiFormControl.margin;
    }
  }

  return {
    disabled: disabled,
    error: error,
    margin: margin
  };
}

var Input =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(Input, _React$Component);

  function Input(props, context) {
    var _this;

    (0, _classCallCheck2.default)(this, Input);
    _this = (0, _possibleConstructorReturn2.default)(this, (Input.__proto__ || Object.getPrototypeOf(Input)).call(this, props, context));
    _this.state = {
      focused: false
    };
    _this.isControlled = _this.props.value != null;
    _this.input = null;

    _this.handleFocus = function (event) {
      // Fix an bug with IE11 where the focus/blur events are triggered
      // while the input is disabled.
      if (formControlState(_this.props, _this.context).disabled) {
        event.stopPropagation();
        return;
      }

      _this.setState({
        focused: true
      });

      if (_this.props.onFocus) {
        _this.props.onFocus(event);
      }
    };

    _this.handleBlur = function (event) {
      _this.setState({
        focused: false
      });

      if (_this.props.onBlur) {
        _this.props.onBlur(event);
      }
    };

    _this.handleChange = function (event) {
      if (!_this.isControlled) {
        _this.checkDirty(_this.input);
      } // Perform in the willUpdate


      if (_this.props.onChange) {
        _this.props.onChange(event);
      }
    };

    _this.handleRefInput = function (node) {
      _this.input = node;

      if (_this.props.inputRef) {
        _this.props.inputRef(node);
      } else if (_this.props.inputProps && _this.props.inputProps.ref) {
        _this.props.inputProps.ref(node);
      }
    };

    if (_this.isControlled) {
      _this.checkDirty(props);
    }

    var componentWillReceiveProps = function componentWillReceiveProps(nextProps, nextContext) {
      // The blur won't fire when the disabled state is set on a focused input.
      // We need to book keep the focused state manually.
      if (!formControlState(_this.props, _this.context).disabled && formControlState(nextProps, nextContext).disabled) {
        _this.setState({
          focused: false
        });
      }
    };

    var componentWillUpdate = function componentWillUpdate(nextProps, nextState, nextContext) {
      // Book keep the focused state.
      if (!formControlState(_this.props, _this.context).disabled && formControlState(nextProps, nextContext).disabled) {
        var muiFormControl = _this.context.muiFormControl;

        if (muiFormControl && muiFormControl.onBlur) {
          muiFormControl.onBlur();
        }
      }
    }; // Support for react >= 16.3.0 && < 17.0.0

    /* istanbul ignore else */


    if (_react.default.createContext) {
      _this.UNSAFE_componentWillReceiveProps = componentWillReceiveProps;
      _this.UNSAFE_componentWillUpdate = componentWillUpdate;
    } else {
      _this.componentWillReceiveProps = componentWillReceiveProps;
      _this.componentWillUpdate = componentWillUpdate;
    }

    return _this;
  }

  (0, _createClass2.default)(Input, [{
    key: "getChildContext",
    value: function getChildContext() {
      // We are consuming the parent muiFormControl context.
      // We don't want a child to consume it a second time.
      return {
        muiFormControl: null
      };
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!this.isControlled) {
        this.checkDirty(this.input);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      if (this.isControlled) {
        this.checkDirty(this.props);
      } // else performed in the onChange

    }
  }, {
    key: "checkDirty",
    value: function checkDirty(obj) {
      var muiFormControl = this.context.muiFormControl;

      if (isFilled(obj)) {
        if (muiFormControl && muiFormControl.onFilled) {
          muiFormControl.onFilled();
        }

        if (this.props.onFilled) {
          this.props.onFilled();
        }

        return;
      }

      if (muiFormControl && muiFormControl.onEmpty) {
        muiFormControl.onEmpty();
      }

      if (this.props.onEmpty) {
        this.props.onEmpty();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _classNames, _classNames2;

      var _props = this.props,
          autoComplete = _props.autoComplete,
          autoFocus = _props.autoFocus,
          classes = _props.classes,
          classNameProp = _props.className,
          defaultValue = _props.defaultValue,
          disabledProp = _props.disabled,
          disableUnderline = _props.disableUnderline,
          endAdornment = _props.endAdornment,
          errorProp = _props.error,
          fullWidth = _props.fullWidth,
          id = _props.id,
          inputComponent = _props.inputComponent,
          _props$inputProps = _props.inputProps;
      _props$inputProps = _props$inputProps === void 0 ? {} : _props$inputProps;
      var inputPropsClassName = _props$inputProps.className,
          inputPropsProp = (0, _objectWithoutProperties2.default)(_props$inputProps, ["className"]),
          inputRef = _props.inputRef,
          marginProp = _props.margin,
          multiline = _props.multiline,
          name = _props.name,
          onBlur = _props.onBlur,
          onChange = _props.onChange,
          onEmpty = _props.onEmpty,
          onFilled = _props.onFilled,
          onFocus = _props.onFocus,
          onKeyDown = _props.onKeyDown,
          onKeyUp = _props.onKeyUp,
          placeholder = _props.placeholder,
          readOnly = _props.readOnly,
          rows = _props.rows,
          rowsMax = _props.rowsMax,
          startAdornment = _props.startAdornment,
          type = _props.type,
          value = _props.value,
          other = (0, _objectWithoutProperties2.default)(_props, ["autoComplete", "autoFocus", "classes", "className", "defaultValue", "disabled", "disableUnderline", "endAdornment", "error", "fullWidth", "id", "inputComponent", "inputProps", "inputRef", "margin", "multiline", "name", "onBlur", "onChange", "onEmpty", "onFilled", "onFocus", "onKeyDown", "onKeyUp", "placeholder", "readOnly", "rows", "rowsMax", "startAdornment", "type", "value"]);
      var muiFormControl = this.context.muiFormControl;

      var _formControlState = formControlState(this.props, this.context),
          disabled = _formControlState.disabled,
          error = _formControlState.error,
          margin = _formControlState.margin;

      var className = (0, _classnames.default)(classes.root, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes.disabled, disabled), (0, _defineProperty2.default)(_classNames, classes.error, error), (0, _defineProperty2.default)(_classNames, classes.fullWidth, fullWidth), (0, _defineProperty2.default)(_classNames, classes.focused, this.state.focused), (0, _defineProperty2.default)(_classNames, classes.formControl, muiFormControl), (0, _defineProperty2.default)(_classNames, classes.multiline, multiline), (0, _defineProperty2.default)(_classNames, classes.underline, !disableUnderline), _classNames), classNameProp);
      var inputClassName = (0, _classnames.default)(classes.input, (_classNames2 = {}, (0, _defineProperty2.default)(_classNames2, classes.disabled, disabled), (0, _defineProperty2.default)(_classNames2, classes.inputType, type !== 'text'), (0, _defineProperty2.default)(_classNames2, classes.inputTypeSearch, type === 'search'), (0, _defineProperty2.default)(_classNames2, classes.inputMultiline, multiline), (0, _defineProperty2.default)(_classNames2, classes.inputMarginDense, margin === 'dense'), _classNames2), inputPropsClassName);
      var required = muiFormControl && muiFormControl.required === true;
      var InputComponent = 'input';
      var inputProps = (0, _objectSpread2.default)({}, inputPropsProp, {
        ref: this.handleRefInput
      });

      if (inputComponent) {
        InputComponent = inputComponent;
        inputProps = (0, _objectSpread2.default)({
          // Rename ref to inputRef as we don't know the
          // provided `inputComponent` structure.
          inputRef: this.handleRefInput
        }, inputProps, {
          ref: null
        });
      } else if (multiline) {
        if (rows && !rowsMax) {
          InputComponent = 'textarea';
        } else {
          inputProps = (0, _objectSpread2.default)({
            rowsMax: rowsMax,
            textareaRef: this.handleRefInput
          }, inputProps, {
            ref: null
          });
          InputComponent = _Textarea.default;
        }
      }

      return _react.default.createElement("div", (0, _extends2.default)({
        className: className
      }, other), startAdornment, _react.default.createElement(InputComponent, (0, _extends2.default)({
        "aria-invalid": error,
        "aria-required": required,
        autoComplete: autoComplete,
        autoFocus: autoFocus,
        className: inputClassName,
        defaultValue: defaultValue,
        disabled: disabled,
        id: id,
        name: name,
        onBlur: this.handleBlur,
        onChange: this.handleChange,
        onFocus: this.handleFocus,
        onKeyDown: onKeyDown,
        onKeyUp: onKeyUp,
        placeholder: placeholder,
        readOnly: readOnly,
        required: required ? true : undefined,
        rows: rows,
        type: type,
        value: value
      }, inputProps)), endAdornment);
    }
  }]);
  return Input;
}(_react.default.Component);

Input.propTypes =  false ? {
  /**
   * This property helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it here:
   * https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill
   */
  autoComplete: _propTypes.default.string,

  /**
   * If `true`, the input will be focused during the first mount.
   */
  autoFocus: _propTypes.default.bool,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * The CSS class name of the wrapper element.
   */
  className: _propTypes.default.string,

  /**
   * The default input value, useful when not controlling the component.
   */
  defaultValue: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),

  /**
   * If `true`, the input will be disabled.
   */
  disabled: _propTypes.default.bool,

  /**
   * If `true`, the input will not have an underline.
   */
  disableUnderline: _propTypes.default.bool,

  /**
   * End `InputAdornment` for this component.
   */
  endAdornment: _propTypes.default.node,

  /**
   * If `true`, the input will indicate an error. This is normally obtained via context from
   * FormControl.
   */
  error: _propTypes.default.bool,

  /**
   * If `true`, the input will take up the full width of its container.
   */
  fullWidth: _propTypes.default.bool,

  /**
   * The id of the `input` element.
   */
  id: _propTypes.default.string,

  /**
   * The component used for the native input.
   * Either a string to use a DOM element or a component.
   */
  inputComponent: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func]),

  /**
   * Properties applied to the `input` element.
   */
  inputProps: _propTypes.default.object,

  /**
   * Use that property to pass a ref callback to the native input component.
   */
  inputRef: _propTypes.default.func,

  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   */
  margin: _propTypes.default.oneOf(['dense', 'none']),

  /**
   * If `true`, a textarea element will be rendered.
   */
  multiline: _propTypes.default.bool,

  /**
   * Name attribute of the `input` element.
   */
  name: _propTypes.default.string,

  /**
   * @ignore
   */
  onBlur: _propTypes.default.func,

  /**
   * Callback fired when the value is changed.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value`.
   */
  onChange: _propTypes.default.func,

  /**
   * @ignore
   */
  onEmpty: _propTypes.default.func,

  /**
   * @ignore
   */
  onFilled: _propTypes.default.func,

  /**
   * @ignore
   */
  onFocus: _propTypes.default.func,

  /**
   * @ignore
   */
  onKeyDown: _propTypes.default.func,

  /**
   * @ignore
   */
  onKeyUp: _propTypes.default.func,

  /**
   * The short hint displayed in the input before the user enters a value.
   */
  placeholder: _propTypes.default.string,

  /**
   * @ignore
   */
  readOnly: _propTypes.default.bool,

  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),

  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  rowsMax: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),

  /**
   * Start `InputAdornment` for this component.
   */
  startAdornment: _propTypes.default.node,

  /**
   * Type of the input element. It should be a valid HTML5 input type.
   */
  type: _propTypes.default.string,

  /**
   * The input value, required for a controlled component.
   */
  value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number, _propTypes.default.arrayOf(_propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]))])
} : {};
Input.muiName = 'Input';
Input.defaultProps = {
  disableUnderline: false,
  fullWidth: false,
  multiline: false,
  type: 'text'
};
Input.contextTypes = {
  muiFormControl: _propTypes.default.object
};
Input.childContextTypes = {
  muiFormControl: _propTypes.default.object
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiInput'
})(Input);

exports.default = _default;

/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Hidden.default;
  }
});

var _Hidden = _interopRequireDefault(__webpack_require__(1000));

/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {};
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _withWidth.default;
  }
});

var _withWidth = _interopRequireDefault(__webpack_require__(1002));

Object.keys(_withWidth).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _withWidth[key];
    }
  });
});

/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Select.default;
  }
});

var _Select = _interopRequireDefault(__webpack_require__(1032));

/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _TableHead.default;
  }
});

var _TableHead = _interopRequireDefault(__webpack_require__(1062));

/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Toolbar.default;
  }
});

var _Toolbar = _interopRequireDefault(__webpack_require__(1065));

/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _TableRow.default;
  }
});

var _TableRow = _interopRequireDefault(__webpack_require__(1068));

/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _TableSortLabel.default;
  }
});

var _TableSortLabel = _interopRequireDefault(__webpack_require__(1069));

/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Tooltip.default;
  }
});

var _Tooltip = _interopRequireDefault(__webpack_require__(1082));

/***/ }),
/* 335 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = GraphQLError;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__printError__ = __webpack_require__(520);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__language_location__ = __webpack_require__(521);
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */




/**
 * A GraphQLError describes an Error found during the parse, validate, or
 * execute phases of performing a GraphQL operation. In addition to a message
 * and stack trace, it also includes information about the locations in a
 * GraphQL document and/or execution result that correspond to the Error.
 */


function GraphQLError( // eslint-disable-line no-redeclare
message, nodes, source, positions, path, originalError, extensions) {
  // Compute list of blame nodes.
  var _nodes = Array.isArray(nodes) ? nodes.length !== 0 ? nodes : undefined : nodes ? [nodes] : undefined;

  // Compute locations in the source for the given nodes/positions.
  var _source = source;
  if (!_source && _nodes) {
    var node = _nodes[0];
    _source = node && node.loc && node.loc.source;
  }

  var _positions = positions;
  if (!_positions && _nodes) {
    _positions = _nodes.reduce(function (list, node) {
      if (node.loc) {
        list.push(node.loc.start);
      }
      return list;
    }, []);
  }
  if (_positions && _positions.length === 0) {
    _positions = undefined;
  }

  var _locations = void 0;
  if (positions && source) {
    _locations = positions.map(function (pos) {
      return Object(__WEBPACK_IMPORTED_MODULE_1__language_location__["a" /* getLocation */])(source, pos);
    });
  } else if (_nodes) {
    _locations = _nodes.reduce(function (list, node) {
      if (node.loc) {
        list.push(Object(__WEBPACK_IMPORTED_MODULE_1__language_location__["a" /* getLocation */])(node.loc.source, node.loc.start));
      }
      return list;
    }, []);
  }

  Object.defineProperties(this, {
    message: {
      value: message,
      // By being enumerable, JSON.stringify will include `message` in the
      // resulting output. This ensures that the simplest possible GraphQL
      // service adheres to the spec.
      enumerable: true,
      writable: true
    },
    locations: {
      // Coercing falsey values to undefined ensures they will not be included
      // in JSON.stringify() when not provided.
      value: _locations || undefined,
      // By being enumerable, JSON.stringify will include `locations` in the
      // resulting output. This ensures that the simplest possible GraphQL
      // service adheres to the spec.
      enumerable: true
    },
    path: {
      // Coercing falsey values to undefined ensures they will not be included
      // in JSON.stringify() when not provided.
      value: path || undefined,
      // By being enumerable, JSON.stringify will include `path` in the
      // resulting output. This ensures that the simplest possible GraphQL
      // service adheres to the spec.
      enumerable: true
    },
    nodes: {
      value: _nodes || undefined
    },
    source: {
      value: _source || undefined
    },
    positions: {
      value: _positions || undefined
    },
    originalError: {
      value: originalError
    },
    extensions: {
      value: extensions || originalError && originalError.extensions
    }
  });

  // Include (non-enumerable) stack trace.
  if (originalError && originalError.stack) {
    Object.defineProperty(this, 'stack', {
      value: originalError.stack,
      writable: true,
      configurable: true
    });
  } else if (Error.captureStackTrace) {
    Error.captureStackTrace(this, GraphQLError);
  } else {
    Object.defineProperty(this, 'stack', {
      value: Error().stack,
      writable: true,
      configurable: true
    });
  }
}

GraphQLError.prototype = Object.create(Error.prototype, {
  constructor: { value: GraphQLError },
  name: { value: 'GraphQLError' },
  toString: {
    value: function toString() {
      return Object(__WEBPACK_IMPORTED_MODULE_0__printError__["a" /* printError */])(this);
    }
  }
});

/***/ }),
/* 336 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export hasError */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ObservableQuery; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_apollo_utilities__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__networkStatus__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_Observable__ = __webpack_require__(526);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__errors_ApolloError__ = __webpack_require__(340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__types__ = __webpack_require__(229);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};





var hasError = function (storeValue, policy) {
    if (policy === void 0) { policy = 'none'; }
    return storeValue &&
        ((storeValue.graphQLErrors &&
            storeValue.graphQLErrors.length > 0 &&
            policy === 'none') ||
            storeValue.networkError);
};
var ObservableQuery = (function (_super) {
    __extends(ObservableQuery, _super);
    function ObservableQuery(_a) {
        var scheduler = _a.scheduler, options = _a.options, _b = _a.shouldSubscribe, shouldSubscribe = _b === void 0 ? true : _b;
        var _this = _super.call(this, function (observer) {
            return _this.onSubscribe(observer);
        }) || this;
        _this.isCurrentlyPolling = false;
        _this.isTornDown = false;
        _this.options = options;
        _this.variables = options.variables || {};
        _this.queryId = scheduler.queryManager.generateQueryId();
        _this.shouldSubscribe = shouldSubscribe;
        _this.scheduler = scheduler;
        _this.queryManager = scheduler.queryManager;
        _this.observers = [];
        _this.subscriptionHandles = [];
        return _this;
    }
    ObservableQuery.prototype.result = function () {
        var that = this;
        return new Promise(function (resolve, reject) {
            var subscription;
            var observer = {
                next: function (result) {
                    resolve(result);
                    if (!that.observers.some(function (obs) { return obs !== observer; })) {
                        that.queryManager.removeQuery(that.queryId);
                    }
                    setTimeout(function () {
                        subscription.unsubscribe();
                    }, 0);
                },
                error: function (error) {
                    reject(error);
                },
            };
            subscription = that.subscribe(observer);
        });
    };
    ObservableQuery.prototype.currentResult = function () {
        if (this.isTornDown) {
            return {
                data: this.lastError ? {} : this.lastResult ? this.lastResult.data : {},
                error: this.lastError,
                loading: false,
                networkStatus: __WEBPACK_IMPORTED_MODULE_1__networkStatus__["a" /* NetworkStatus */].error,
            };
        }
        var queryStoreValue = this.queryManager.queryStore.get(this.queryId);
        if (hasError(queryStoreValue, this.options.errorPolicy)) {
            return {
                data: {},
                loading: false,
                networkStatus: queryStoreValue.networkStatus,
                error: new __WEBPACK_IMPORTED_MODULE_3__errors_ApolloError__["a" /* ApolloError */]({
                    graphQLErrors: queryStoreValue.graphQLErrors,
                    networkError: queryStoreValue.networkError,
                }),
            };
        }
        var _a = this.queryManager.getCurrentQueryResult(this), data = _a.data, partial = _a.partial;
        var queryLoading = !queryStoreValue ||
            queryStoreValue.networkStatus === __WEBPACK_IMPORTED_MODULE_1__networkStatus__["a" /* NetworkStatus */].loading;
        var loading = (this.options.fetchPolicy === 'network-only' && queryLoading) ||
            (partial && this.options.fetchPolicy !== 'cache-only');
        var networkStatus;
        if (queryStoreValue) {
            networkStatus = queryStoreValue.networkStatus;
        }
        else {
            networkStatus = loading ? __WEBPACK_IMPORTED_MODULE_1__networkStatus__["a" /* NetworkStatus */].loading : __WEBPACK_IMPORTED_MODULE_1__networkStatus__["a" /* NetworkStatus */].ready;
        }
        var result = {
            data: data,
            loading: Object(__WEBPACK_IMPORTED_MODULE_1__networkStatus__["b" /* isNetworkRequestInFlight */])(networkStatus),
            networkStatus: networkStatus,
        };
        if (queryStoreValue &&
            queryStoreValue.graphQLErrors &&
            this.options.errorPolicy === 'all') {
            result.errors = queryStoreValue.graphQLErrors;
        }
        if (!partial) {
            this.lastResult = __assign({}, result, { stale: false });
            this.lastResultSnapshot = Object(__WEBPACK_IMPORTED_MODULE_0_apollo_utilities__["d" /* cloneDeep */])(this.lastResult);
        }
        return __assign({}, result, { partial: partial });
    };
    ObservableQuery.prototype.isDifferentFromLastResult = function (newResult) {
        var snapshot = this.lastResultSnapshot;
        return !(snapshot && newResult &&
            snapshot.networkStatus === newResult.networkStatus &&
            snapshot.stale === newResult.stale &&
            Object(__WEBPACK_IMPORTED_MODULE_0_apollo_utilities__["r" /* isEqual */])(snapshot.data, newResult.data));
    };
    ObservableQuery.prototype.getLastResult = function () {
        return this.lastResult;
    };
    ObservableQuery.prototype.getLastError = function () {
        return this.lastError;
    };
    ObservableQuery.prototype.resetLastResults = function () {
        delete this.lastResult;
        delete this.lastResultSnapshot;
        delete this.lastError;
        this.isTornDown = false;
    };
    ObservableQuery.prototype.refetch = function (variables) {
        var fetchPolicy = this.options.fetchPolicy;
        if (fetchPolicy === 'cache-only') {
            return Promise.reject(new Error('cache-only fetchPolicy option should not be used together with query refetch.'));
        }
        if (!Object(__WEBPACK_IMPORTED_MODULE_0_apollo_utilities__["r" /* isEqual */])(this.variables, variables)) {
            this.variables = Object.assign({}, this.variables, variables);
        }
        if (!Object(__WEBPACK_IMPORTED_MODULE_0_apollo_utilities__["r" /* isEqual */])(this.options.variables, this.variables)) {
            this.options.variables = Object.assign({}, this.options.variables, this.variables);
        }
        var isNetworkFetchPolicy = fetchPolicy === 'network-only' || fetchPolicy === 'no-cache';
        var combinedOptions = __assign({}, this.options, { fetchPolicy: isNetworkFetchPolicy ? fetchPolicy : 'network-only' });
        return this.queryManager
            .fetchQuery(this.queryId, combinedOptions, __WEBPACK_IMPORTED_MODULE_4__types__["a" /* FetchType */].refetch)
            .then(function (result) { return result; });
    };
    ObservableQuery.prototype.fetchMore = function (fetchMoreOptions) {
        var _this = this;
        if (!fetchMoreOptions.updateQuery) {
            throw new Error('updateQuery option is required. This function defines how to update the query data with the new results.');
        }
        var combinedOptions;
        return Promise.resolve()
            .then(function () {
            var qid = _this.queryManager.generateQueryId();
            if (fetchMoreOptions.query) {
                combinedOptions = fetchMoreOptions;
            }
            else {
                combinedOptions = __assign({}, _this.options, fetchMoreOptions, { variables: Object.assign({}, _this.variables, fetchMoreOptions.variables) });
            }
            combinedOptions.fetchPolicy = 'network-only';
            return _this.queryManager.fetchQuery(qid, combinedOptions, __WEBPACK_IMPORTED_MODULE_4__types__["a" /* FetchType */].normal, _this.queryId);
        })
            .then(function (fetchMoreResult) {
            _this.updateQuery(function (previousResult) {
                return fetchMoreOptions.updateQuery(previousResult, {
                    fetchMoreResult: fetchMoreResult.data,
                    variables: combinedOptions.variables,
                });
            });
            return fetchMoreResult;
        });
    };
    ObservableQuery.prototype.subscribeToMore = function (options) {
        var _this = this;
        var subscription = this.queryManager
            .startGraphQLSubscription({
            query: options.document,
            variables: options.variables,
        })
            .subscribe({
            next: function (subscriptionData) {
                if (options.updateQuery) {
                    _this.updateQuery(function (previous, _a) {
                        var variables = _a.variables;
                        return options.updateQuery(previous, {
                            subscriptionData: subscriptionData,
                            variables: variables,
                        });
                    });
                }
            },
            error: function (err) {
                if (options.onError) {
                    options.onError(err);
                    return;
                }
                console.error('Unhandled GraphQL subscription error', err);
            },
        });
        this.subscriptionHandles.push(subscription);
        return function () {
            var i = _this.subscriptionHandles.indexOf(subscription);
            if (i >= 0) {
                _this.subscriptionHandles.splice(i, 1);
                subscription.unsubscribe();
            }
        };
    };
    ObservableQuery.prototype.setOptions = function (opts) {
        var oldOptions = this.options;
        this.options = Object.assign({}, this.options, opts);
        if (opts.pollInterval) {
            this.startPolling(opts.pollInterval);
        }
        else if (opts.pollInterval === 0) {
            this.stopPolling();
        }
        var tryFetch = (oldOptions.fetchPolicy !== 'network-only' &&
            opts.fetchPolicy === 'network-only') ||
            (oldOptions.fetchPolicy === 'cache-only' &&
                opts.fetchPolicy !== 'cache-only') ||
            (oldOptions.fetchPolicy === 'standby' &&
                opts.fetchPolicy !== 'standby') ||
            false;
        return this.setVariables(this.options.variables, tryFetch, opts.fetchResults);
    };
    ObservableQuery.prototype.setVariables = function (variables, tryFetch, fetchResults) {
        if (tryFetch === void 0) { tryFetch = false; }
        if (fetchResults === void 0) { fetchResults = true; }
        this.isTornDown = false;
        var newVariables = variables ? variables : this.variables;
        if (Object(__WEBPACK_IMPORTED_MODULE_0_apollo_utilities__["r" /* isEqual */])(newVariables, this.variables) && !tryFetch) {
            if (this.observers.length === 0 || !fetchResults) {
                return new Promise(function (resolve) { return resolve(); });
            }
            return this.result();
        }
        else {
            this.variables = newVariables;
            this.options.variables = newVariables;
            if (this.observers.length === 0) {
                return new Promise(function (resolve) { return resolve(); });
            }
            return this.queryManager
                .fetchQuery(this.queryId, __assign({}, this.options, { variables: this.variables }))
                .then(function (result) { return result; });
        }
    };
    ObservableQuery.prototype.updateQuery = function (mapFn) {
        var _a = this.queryManager.getQueryWithPreviousResult(this.queryId), previousResult = _a.previousResult, variables = _a.variables, document = _a.document;
        var newResult = Object(__WEBPACK_IMPORTED_MODULE_0_apollo_utilities__["D" /* tryFunctionOrLogError */])(function () {
            return mapFn(previousResult, { variables: variables });
        });
        if (newResult) {
            this.queryManager.dataStore.markUpdateQueryResult(document, variables, newResult);
            this.queryManager.broadcastQueries();
        }
    };
    ObservableQuery.prototype.stopPolling = function () {
        if (this.isCurrentlyPolling) {
            this.scheduler.stopPollingQuery(this.queryId);
            this.options.pollInterval = undefined;
            this.isCurrentlyPolling = false;
        }
    };
    ObservableQuery.prototype.startPolling = function (pollInterval) {
        if (this.options.fetchPolicy === 'cache-first' ||
            this.options.fetchPolicy === 'cache-only') {
            throw new Error('Queries that specify the cache-first and cache-only fetchPolicies cannot also be polling queries.');
        }
        if (this.isCurrentlyPolling) {
            this.scheduler.stopPollingQuery(this.queryId);
            this.isCurrentlyPolling = false;
        }
        this.options.pollInterval = pollInterval;
        this.isCurrentlyPolling = true;
        this.scheduler.startPollingQuery(this.options, this.queryId);
    };
    ObservableQuery.prototype.onSubscribe = function (observer) {
        var _this = this;
        if (observer._subscription &&
            observer._subscription._observer &&
            !observer._subscription._observer.error) {
            observer._subscription._observer.error = function (error) {
                console.error('Unhandled error', error.message, error.stack);
            };
        }
        this.observers.push(observer);
        if (observer.next && this.lastResult)
            observer.next(this.lastResult);
        if (observer.error && this.lastError)
            observer.error(this.lastError);
        if (this.observers.length === 1)
            this.setUpQuery();
        return function () {
            _this.observers = _this.observers.filter(function (obs) { return obs !== observer; });
            if (_this.observers.length === 0) {
                _this.tearDownQuery();
            }
        };
    };
    ObservableQuery.prototype.setUpQuery = function () {
        var _this = this;
        if (this.shouldSubscribe) {
            this.queryManager.addObservableQuery(this.queryId, this);
        }
        if (!!this.options.pollInterval) {
            if (this.options.fetchPolicy === 'cache-first' ||
                this.options.fetchPolicy === 'cache-only') {
                throw new Error('Queries that specify the cache-first and cache-only fetchPolicies cannot also be polling queries.');
            }
            this.isCurrentlyPolling = true;
            this.scheduler.startPollingQuery(this.options, this.queryId);
        }
        var observer = {
            next: function (result) {
                _this.lastResult = result;
                _this.lastResultSnapshot = Object(__WEBPACK_IMPORTED_MODULE_0_apollo_utilities__["d" /* cloneDeep */])(result);
                _this.observers.forEach(function (obs) { return obs.next && obs.next(result); });
            },
            error: function (error) {
                _this.lastError = error;
                _this.observers.forEach(function (obs) { return obs.error && obs.error(error); });
            },
        };
        this.queryManager.startQuery(this.queryId, this.options, this.queryManager.queryListenerForObserver(this.queryId, this.options, observer));
    };
    ObservableQuery.prototype.tearDownQuery = function () {
        this.isTornDown = true;
        if (this.isCurrentlyPolling) {
            this.scheduler.stopPollingQuery(this.queryId);
            this.isCurrentlyPolling = false;
        }
        this.subscriptionHandles.forEach(function (sub) { return sub.unsubscribe(); });
        this.subscriptionHandles = [];
        this.queryManager.removeObservableQuery(this.queryId);
        this.queryManager.stopQuery(this.queryId);
        this.observers = [];
    };
    return ObservableQuery;
}(__WEBPACK_IMPORTED_MODULE_2__util_Observable__["a" /* Observable */]));

//# sourceMappingURL=ObservableQuery.js.map

/***/ }),
/* 337 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export isScalarValue */
/* unused harmony export isNumberValue */
/* harmony export (immutable) */ __webpack_exports__["j"] = valueToObjectRepresentation;
/* harmony export (immutable) */ __webpack_exports__["h"] = storeKeyNameFromField;
/* harmony export (immutable) */ __webpack_exports__["b"] = getStoreKeyName;
/* harmony export (immutable) */ __webpack_exports__["a"] = argumentsObjectFromField;
/* harmony export (immutable) */ __webpack_exports__["g"] = resultKeyNameFromField;
/* harmony export (immutable) */ __webpack_exports__["c"] = isField;
/* harmony export (immutable) */ __webpack_exports__["e"] = isInlineFragment;
/* harmony export (immutable) */ __webpack_exports__["d"] = isIdValue;
/* harmony export (immutable) */ __webpack_exports__["i"] = toIdValue;
/* harmony export (immutable) */ __webpack_exports__["f"] = isJsonValue;
/* unused harmony export valueFromNode */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fast_json_stable_stringify__ = __webpack_require__(1104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fast_json_stable_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_fast_json_stable_stringify__);
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function isScalarValue(value) {
    return ['StringValue', 'BooleanValue', 'EnumValue'].indexOf(value.kind) > -1;
}
function isNumberValue(value) {
    return ['IntValue', 'FloatValue'].indexOf(value.kind) > -1;
}
function isStringValue(value) {
    return value.kind === 'StringValue';
}
function isBooleanValue(value) {
    return value.kind === 'BooleanValue';
}
function isIntValue(value) {
    return value.kind === 'IntValue';
}
function isFloatValue(value) {
    return value.kind === 'FloatValue';
}
function isVariable(value) {
    return value.kind === 'Variable';
}
function isObjectValue(value) {
    return value.kind === 'ObjectValue';
}
function isListValue(value) {
    return value.kind === 'ListValue';
}
function isEnumValue(value) {
    return value.kind === 'EnumValue';
}
function isNullValue(value) {
    return value.kind === 'NullValue';
}
function valueToObjectRepresentation(argObj, name, value, variables) {
    if (isIntValue(value) || isFloatValue(value)) {
        argObj[name.value] = Number(value.value);
    }
    else if (isBooleanValue(value) || isStringValue(value)) {
        argObj[name.value] = value.value;
    }
    else if (isObjectValue(value)) {
        var nestedArgObj_1 = {};
        value.fields.map(function (obj) {
            return valueToObjectRepresentation(nestedArgObj_1, obj.name, obj.value, variables);
        });
        argObj[name.value] = nestedArgObj_1;
    }
    else if (isVariable(value)) {
        var variableValue = (variables || {})[value.name.value];
        argObj[name.value] = variableValue;
    }
    else if (isListValue(value)) {
        argObj[name.value] = value.values.map(function (listValue) {
            var nestedArgArrayObj = {};
            valueToObjectRepresentation(nestedArgArrayObj, name, listValue, variables);
            return nestedArgArrayObj[name.value];
        });
    }
    else if (isEnumValue(value)) {
        argObj[name.value] = value.value;
    }
    else if (isNullValue(value)) {
        argObj[name.value] = null;
    }
    else {
        throw new Error("The inline argument \"" + name.value + "\" of kind \"" + value.kind + "\"" +
            'is not supported. Use variables instead of inline arguments to ' +
            'overcome this limitation.');
    }
}
function storeKeyNameFromField(field, variables) {
    var directivesObj = null;
    if (field.directives) {
        directivesObj = {};
        field.directives.forEach(function (directive) {
            directivesObj[directive.name.value] = {};
            if (directive.arguments) {
                directive.arguments.forEach(function (_a) {
                    var name = _a.name, value = _a.value;
                    return valueToObjectRepresentation(directivesObj[directive.name.value], name, value, variables);
                });
            }
        });
    }
    var argObj = null;
    if (field.arguments && field.arguments.length) {
        argObj = {};
        field.arguments.forEach(function (_a) {
            var name = _a.name, value = _a.value;
            return valueToObjectRepresentation(argObj, name, value, variables);
        });
    }
    return getStoreKeyName(field.name.value, argObj, directivesObj);
}
var KNOWN_DIRECTIVES = [
    'connection',
    'include',
    'skip',
    'client',
    'rest',
    'export',
];
function getStoreKeyName(fieldName, args, directives) {
    if (directives &&
        directives['connection'] &&
        directives['connection']['key']) {
        if (directives['connection']['filter'] &&
            directives['connection']['filter'].length > 0) {
            var filterKeys = directives['connection']['filter']
                ? directives['connection']['filter']
                : [];
            filterKeys.sort();
            var queryArgs_1 = args;
            var filteredArgs_1 = {};
            filterKeys.forEach(function (key) {
                filteredArgs_1[key] = queryArgs_1[key];
            });
            return directives['connection']['key'] + "(" + JSON.stringify(filteredArgs_1) + ")";
        }
        else {
            return directives['connection']['key'];
        }
    }
    var completeFieldName = fieldName;
    if (args) {
        var stringifiedArgs = __WEBPACK_IMPORTED_MODULE_0_fast_json_stable_stringify___default()(args);
        completeFieldName += "(" + stringifiedArgs + ")";
    }
    if (directives) {
        Object.keys(directives).forEach(function (key) {
            if (KNOWN_DIRECTIVES.indexOf(key) !== -1)
                return;
            if (directives[key] && Object.keys(directives[key]).length) {
                completeFieldName += "@" + key + "(" + JSON.stringify(directives[key]) + ")";
            }
            else {
                completeFieldName += "@" + key;
            }
        });
    }
    return completeFieldName;
}
function argumentsObjectFromField(field, variables) {
    if (field.arguments && field.arguments.length) {
        var argObj_1 = {};
        field.arguments.forEach(function (_a) {
            var name = _a.name, value = _a.value;
            return valueToObjectRepresentation(argObj_1, name, value, variables);
        });
        return argObj_1;
    }
    return null;
}
function resultKeyNameFromField(field) {
    return field.alias ? field.alias.value : field.name.value;
}
function isField(selection) {
    return selection.kind === 'Field';
}
function isInlineFragment(selection) {
    return selection.kind === 'InlineFragment';
}
function isIdValue(idObject) {
    return idObject &&
        idObject.type === 'id' &&
        typeof idObject.generated === 'boolean';
}
function toIdValue(idConfig, generated) {
    if (generated === void 0) { generated = false; }
    return __assign({ type: 'id', generated: generated }, (typeof idConfig === 'string'
        ? { id: idConfig, typename: undefined }
        : idConfig));
}
function isJsonValue(jsonObject) {
    return (jsonObject != null &&
        typeof jsonObject === 'object' &&
        jsonObject.type === 'json');
}
function defaultValueFromVariable(node) {
    throw new Error("Variable nodes are not supported by valueFromNode");
}
function valueFromNode(node, onVariable) {
    if (onVariable === void 0) { onVariable = defaultValueFromVariable; }
    switch (node.kind) {
        case 'Variable':
            return onVariable(node);
        case 'NullValue':
            return null;
        case 'IntValue':
            return parseInt(node.value, 10);
        case 'FloatValue':
            return parseFloat(node.value);
        case 'ListValue':
            return node.values.map(function (v) { return valueFromNode(v, onVariable); });
        case 'ObjectValue': {
            var value = {};
            for (var _i = 0, _a = node.fields; _i < _a.length; _i++) {
                var field = _a[_i];
                value[field.name.value] = valueFromNode(field.value, onVariable);
            }
            return value;
        }
        default:
            return node.value;
    }
}
//# sourceMappingURL=storeUtils.js.map

/***/ }),
/* 338 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/* unused harmony export getEnv */
/* unused harmony export isEnv */
/* harmony export (immutable) */ __webpack_exports__["b"] = isProduction;
/* harmony export (immutable) */ __webpack_exports__["a"] = isDevelopment;
/* harmony export (immutable) */ __webpack_exports__["c"] = isTest;
function getEnv() {
    if (typeof process !== 'undefined' && "production") {
        return "production";
    }
    return 'development';
}
function isEnv(env) {
    return getEnv() === env;
}
function isProduction() {
    return isEnv('production') === true;
}
function isDevelopment() {
    return isEnv('development') === true;
}
function isTest() {
    return isEnv('test') === true;
}
//# sourceMappingURL=environment.js.map
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(74)))

/***/ }),
/* 339 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__zenObservable__ = __webpack_require__(527);
/* unused harmony namespace reexport */


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__zenObservable__["a" /* Observable */]);
//# sourceMappingURL=index.js.map

/***/ }),
/* 340 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = isApolloError;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ApolloError; });
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
function isApolloError(err) {
    return err.hasOwnProperty('graphQLErrors');
}
var generateErrorMessage = function (err) {
    var message = '';
    if (Array.isArray(err.graphQLErrors) && err.graphQLErrors.length !== 0) {
        err.graphQLErrors.forEach(function (graphQLError) {
            var errorMessage = graphQLError
                ? graphQLError.message
                : 'Error message not found.';
            message += "GraphQL error: " + errorMessage + "\n";
        });
    }
    if (err.networkError) {
        message += 'Network error: ' + err.networkError.message + '\n';
    }
    message = message.replace(/\n$/, '');
    return message;
};
var ApolloError = (function (_super) {
    __extends(ApolloError, _super);
    function ApolloError(_a) {
        var graphQLErrors = _a.graphQLErrors, networkError = _a.networkError, errorMessage = _a.errorMessage, extraInfo = _a.extraInfo;
        var _this = _super.call(this, errorMessage) || this;
        _this.graphQLErrors = graphQLErrors || [];
        _this.networkError = networkError || null;
        if (!errorMessage) {
            _this.message = generateErrorMessage(_this);
        }
        else {
            _this.message = errorMessage;
        }
        _this.extraInfo = extraInfo;
        _this.__proto__ = ApolloError.prototype;
        return _this;
    }
    return ApolloError;
}(Error));

//# sourceMappingURL=ApolloError.js.map

/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(1124);
} else {
  module.exports = require('./cjs/react-dom-server.browser.development.js');
}


/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 * 
 */

/*eslint-disable no-self-compare */


var hasOwnProperty = Object.prototype.hasOwnProperty;
/**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */

function is(x, y) {
  // SameValue algorithm
  if (x === y) {
    // Steps 1-5, 7-10
    // Steps 6.b-6.e: +0 != -0
    // Added the nonzero y check to make Flow happy, but it is redundant
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    // Step 6.a: NaN == NaN
    return x !== x && y !== y;
  }
}
/**
 * Performs equality by iterating through keys on an object and returning false
 * when any key has values which are not strictly equal between the arguments.
 * Returns true when the values of all keys are strictly equal.
 */


function shallowEqual(objA, objB) {
  if (is(objA, objB)) {
    return true;
  }

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  } // Test for A's keys different from B.


  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

module.exports = shallowEqual;

/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(1128);
} else {
  module.exports = require('./cjs/react-is.development.js');
}


/***/ }),
/* 344 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "prefix", function() { return prefix; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ARRAY_INSERT", function() { return ARRAY_INSERT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ARRAY_MOVE", function() { return ARRAY_MOVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ARRAY_POP", function() { return ARRAY_POP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ARRAY_PUSH", function() { return ARRAY_PUSH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ARRAY_REMOVE", function() { return ARRAY_REMOVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ARRAY_REMOVE_ALL", function() { return ARRAY_REMOVE_ALL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ARRAY_SHIFT", function() { return ARRAY_SHIFT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ARRAY_SPLICE", function() { return ARRAY_SPLICE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ARRAY_UNSHIFT", function() { return ARRAY_UNSHIFT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ARRAY_SWAP", function() { return ARRAY_SWAP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AUTOFILL", function() { return AUTOFILL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BLUR", function() { return BLUR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CHANGE", function() { return CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CLEAR_FIELDS", function() { return CLEAR_FIELDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CLEAR_SUBMIT", function() { return CLEAR_SUBMIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CLEAR_SUBMIT_ERRORS", function() { return CLEAR_SUBMIT_ERRORS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CLEAR_ASYNC_ERROR", function() { return CLEAR_ASYNC_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DESTROY", function() { return DESTROY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FOCUS", function() { return FOCUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "INITIALIZE", function() { return INITIALIZE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "REGISTER_FIELD", function() { return REGISTER_FIELD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RESET", function() { return RESET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RESET_SECTION", function() { return RESET_SECTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_SUBMIT_FAILED", function() { return SET_SUBMIT_FAILED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_SUBMIT_SUCCEEDED", function() { return SET_SUBMIT_SUCCEEDED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "START_ASYNC_VALIDATION", function() { return START_ASYNC_VALIDATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "START_SUBMIT", function() { return START_SUBMIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "STOP_ASYNC_VALIDATION", function() { return STOP_ASYNC_VALIDATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "STOP_SUBMIT", function() { return STOP_SUBMIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SUBMIT", function() { return SUBMIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TOUCH", function() { return TOUCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UNREGISTER_FIELD", function() { return UNREGISTER_FIELD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UNTOUCH", function() { return UNTOUCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UPDATE_SYNC_ERRORS", function() { return UPDATE_SYNC_ERRORS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UPDATE_SYNC_WARNINGS", function() { return UPDATE_SYNC_WARNINGS; });
var prefix = '@@redux-form/';

var ARRAY_INSERT = prefix + 'ARRAY_INSERT';
var ARRAY_MOVE = prefix + 'ARRAY_MOVE';
var ARRAY_POP = prefix + 'ARRAY_POP';
var ARRAY_PUSH = prefix + 'ARRAY_PUSH';
var ARRAY_REMOVE = prefix + 'ARRAY_REMOVE';
var ARRAY_REMOVE_ALL = prefix + 'ARRAY_REMOVE_ALL';
var ARRAY_SHIFT = prefix + 'ARRAY_SHIFT';
var ARRAY_SPLICE = prefix + 'ARRAY_SPLICE';
var ARRAY_UNSHIFT = prefix + 'ARRAY_UNSHIFT';
var ARRAY_SWAP = prefix + 'ARRAY_SWAP';
var AUTOFILL = prefix + 'AUTOFILL';
var BLUR = prefix + 'BLUR';
var CHANGE = prefix + 'CHANGE';
var CLEAR_FIELDS = prefix + 'CLEAR_FIELDS';
var CLEAR_SUBMIT = prefix + 'CLEAR_SUBMIT';
var CLEAR_SUBMIT_ERRORS = prefix + 'CLEAR_SUBMIT_ERRORS';
var CLEAR_ASYNC_ERROR = prefix + 'CLEAR_ASYNC_ERROR';
var DESTROY = prefix + 'DESTROY';
var FOCUS = prefix + 'FOCUS';
var INITIALIZE = prefix + 'INITIALIZE';
var REGISTER_FIELD = prefix + 'REGISTER_FIELD';
var RESET = prefix + 'RESET';
var RESET_SECTION = prefix + 'RESET_SECTION';
var SET_SUBMIT_FAILED = prefix + 'SET_SUBMIT_FAILED';
var SET_SUBMIT_SUCCEEDED = prefix + 'SET_SUBMIT_SUCCEEDED';
var START_ASYNC_VALIDATION = prefix + 'START_ASYNC_VALIDATION';
var START_SUBMIT = prefix + 'START_SUBMIT';
var STOP_ASYNC_VALIDATION = prefix + 'STOP_ASYNC_VALIDATION';
var STOP_SUBMIT = prefix + 'STOP_SUBMIT';
var SUBMIT = prefix + 'SUBMIT';
var TOUCH = prefix + 'TOUCH';
var UNREGISTER_FIELD = prefix + 'UNREGISTER_FIELD';
var UNTOUCH = prefix + 'UNTOUCH';
var UPDATE_SYNC_ERRORS = prefix + 'UPDATE_SYNC_ERRORS';
var UPDATE_SYNC_WARNINGS = prefix + 'UPDATE_SYNC_WARNINGS';

/***/ }),
/* 345 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = warning;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */


  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */

}

/***/ }),
/* 346 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _extends;
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

/***/ }),
/* 347 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _objectWithoutPropertiesLoose;
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

/***/ }),
/* 348 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mapCacheClear_js__ = __webpack_require__(1158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mapCacheDelete_js__ = __webpack_require__(1174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mapCacheGet_js__ = __webpack_require__(1176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mapCacheHas_js__ = __webpack_require__(1177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mapCacheSet_js__ = __webpack_require__(1178);






/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = __WEBPACK_IMPORTED_MODULE_0__mapCacheClear_js__["a" /* default */];
MapCache.prototype['delete'] = __WEBPACK_IMPORTED_MODULE_1__mapCacheDelete_js__["a" /* default */];
MapCache.prototype.get = __WEBPACK_IMPORTED_MODULE_2__mapCacheGet_js__["a" /* default */];
MapCache.prototype.has = __WEBPACK_IMPORTED_MODULE_3__mapCacheHas_js__["a" /* default */];
MapCache.prototype.set = __WEBPACK_IMPORTED_MODULE_4__mapCacheSet_js__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (MapCache);


/***/ }),
/* 349 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isObject_js__ = __webpack_require__(97);



/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_1__isObject_js__["a" /* default */])(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = Object(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

/* harmony default export */ __webpack_exports__["a"] = (isFunction);


/***/ }),
/* 350 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getNative_js__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__root_js__ = __webpack_require__(75);



/* Built-in method references that are verified to be native. */
var Map = Object(__WEBPACK_IMPORTED_MODULE_0__getNative_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__root_js__["a" /* default */], 'Map');

/* harmony default export */ __webpack_exports__["a"] = (Map);


/***/ }),
/* 351 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ListCache_js__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__stackClear_js__ = __webpack_require__(1183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__stackDelete_js__ = __webpack_require__(1184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__stackGet_js__ = __webpack_require__(1185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__stackHas_js__ = __webpack_require__(1186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__stackSet_js__ = __webpack_require__(1187);







/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new __WEBPACK_IMPORTED_MODULE_0__ListCache_js__["a" /* default */](entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = __WEBPACK_IMPORTED_MODULE_1__stackClear_js__["a" /* default */];
Stack.prototype['delete'] = __WEBPACK_IMPORTED_MODULE_2__stackDelete_js__["a" /* default */];
Stack.prototype.get = __WEBPACK_IMPORTED_MODULE_3__stackGet_js__["a" /* default */];
Stack.prototype.has = __WEBPACK_IMPORTED_MODULE_4__stackHas_js__["a" /* default */];
Stack.prototype.set = __WEBPACK_IMPORTED_MODULE_5__stackSet_js__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (Stack);


/***/ }),
/* 352 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayLikeKeys_js__ = __webpack_require__(553);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseKeys_js__ = __webpack_require__(554);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isArrayLike_js__ = __webpack_require__(180);




/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return Object(__WEBPACK_IMPORTED_MODULE_2__isArrayLike_js__["a" /* default */])(object) ? Object(__WEBPACK_IMPORTED_MODULE_0__arrayLikeKeys_js__["a" /* default */])(object) : Object(__WEBPACK_IMPORTED_MODULE_1__baseKeys_js__["a" /* default */])(object);
}

/* harmony default export */ __webpack_exports__["a"] = (keys);


/***/ }),
/* 353 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

/* harmony default export */ __webpack_exports__["a"] = (isIndex);


/***/ }),
/* 354 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/* harmony default export */ __webpack_exports__["a"] = (isLength);


/***/ }),
/* 355 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseAssignValue_js__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseForOwn_js__ = __webpack_require__(1222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__baseIteratee_js__ = __webpack_require__(1224);




/**
 * Creates an object with the same keys as `object` and values generated
 * by running each own enumerable string keyed property of `object` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapKeys
 * @example
 *
 * var users = {
 *   'fred':    { 'user': 'fred',    'age': 40 },
 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
 * };
 *
 * _.mapValues(users, function(o) { return o.age; });
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 *
 * // The `_.property` iteratee shorthand.
 * _.mapValues(users, 'age');
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 */
function mapValues(object, iteratee) {
  var result = {};
  iteratee = Object(__WEBPACK_IMPORTED_MODULE_2__baseIteratee_js__["a" /* default */])(iteratee, 3);

  Object(__WEBPACK_IMPORTED_MODULE_1__baseForOwn_js__["a" /* default */])(object, function(value, key, object) {
    Object(__WEBPACK_IMPORTED_MODULE_0__baseAssignValue_js__["a" /* default */])(result, key, iteratee(value, key, object));
  });
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (mapValues);


/***/ }),
/* 356 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isArray_js__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isSymbol_js__ = __webpack_require__(232);



/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (Object(__WEBPACK_IMPORTED_MODULE_0__isArray_js__["a" /* default */])(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || Object(__WEBPACK_IMPORTED_MODULE_1__isSymbol_js__["a" /* default */])(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

/* harmony default export */ __webpack_exports__["a"] = (isKey);


/***/ }),
/* 357 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

/* harmony default export */ __webpack_exports__["a"] = (identity);


/***/ }),
/* 358 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__hasError__ = __webpack_require__(1267);



var createIsValid = function createIsValid(structure) {
  var getIn = structure.getIn,
      keys = structure.keys;

  var hasError = Object(__WEBPACK_IMPORTED_MODULE_0__hasError__["a" /* default */])(structure);
  return function (form, getFormState) {
    var ignoreSubmitErrors = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    return function (state) {
      var nonNullGetFormState = getFormState || function (state) {
        return getIn(state, 'form');
      };
      var formState = nonNullGetFormState(state);
      var syncError = getIn(formState, form + '.syncError');
      if (syncError) {
        return false;
      }
      if (!ignoreSubmitErrors) {
        var error = getIn(formState, form + '.error');
        if (error) {
          return false;
        }
      }
      var syncErrors = getIn(formState, form + '.syncErrors');
      var asyncErrors = getIn(formState, form + '.asyncErrors');
      var submitErrors = ignoreSubmitErrors ? undefined : getIn(formState, form + '.submitErrors');
      if (!syncErrors && !asyncErrors && !submitErrors) {
        return true;
      }

      var registeredFields = getIn(formState, form + '.registeredFields');
      if (!registeredFields) {
        return true;
      }

      return !keys(registeredFields).filter(function (name) {
        return getIn(registeredFields, '[\'' + name + '\'].count') > 0;
      }).some(function (name) {
        return hasError(getIn(registeredFields, '[\'' + name + '\']'), syncErrors, asyncErrors, submitErrors);
      });
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createIsValid);

/***/ }),
/* 359 */
/***/ (function(module, exports) {

module.exports = isPromise;

function isPromise(obj) {
  return !!obj && (typeof obj === 'object' || typeof obj === 'function') && typeof obj.then === 'function';
}


/***/ }),
/* 360 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addOccupations; });
var GET='sure-quote/Occupations/GET';var defaultState={occupations:[]};var handleChange=function handleChange(state,action){return Object.assign({},state,{occupations:JSON.parse(action.props.props.occupations)});};var OccupationsReducer=function OccupationsReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:defaultState;var action=arguments[1];switch(action.type){case GET:return handleChange(state,action);default:return state;}};var addOccupations=function addOccupations(props){return{type:GET,props:props};};/* harmony default export */ __webpack_exports__["b"] = (OccupationsReducer);

/***/ }),
/* 361 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 362 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return submitSignup; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_graphql_tag__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_graphql_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_graphql_tag__);
var _templateObject=_taggedTemplateLiteral(['\n\tmutation submitSignup($input: RegisterInput!) {\n\t\tRegister(input: $input) {\n\t\t\terror\n\t\t\tmessage\n\t\t}\n\t}\n'],['\n\tmutation submitSignup($input: RegisterInput!) {\n\t\tRegister(input: $input) {\n\t\t\terror\n\t\t\tmessage\n\t\t}\n\t}\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var submitSignup=__WEBPACK_IMPORTED_MODULE_0_graphql_tag___default()(_templateObject);

/***/ }),
/* 363 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
  commonElement: function(lista, listb) {
    for (var i = 0, n = lista.length; i < n; i++) {
      if (this.indexOf(listb, lista[i]) !== -1)
        return lista[i];
    }
    return null;
  },

  indexOf: function(list, needle) {
    if (list.indexOf) return list.indexOf(needle);

    for (var i = 0, n = list.length; i < n; i++) {
      if (list[i] === needle) return i;
    }
    return -1;
  },

  map: function(object, callback, context) {
    if (object.map) return object.map(callback, context);
    var result = [];

    if (object instanceof Array) {
      for (var i = 0, n = object.length; i < n; i++) {
        result.push(callback.call(context || null, object[i], i));
      }
    } else {
      for (var key in object) {
        if (!object.hasOwnProperty(key)) continue;
        result.push(callback.call(context || null, key, object[key]));
      }
    }
    return result;
  },

  filter: function(array, callback, context) {
    if (array.filter) return array.filter(callback, context);
    var result = [];
    for (var i = 0, n = array.length; i < n; i++) {
      if (callback.call(context || null, array[i], i))
        result.push(array[i]);
    }
    return result;
  },

  asyncEach: function(list, iterator, callback, context) {
    var n       = list.length,
        i       = -1,
        calls   = 0,
        looping = false;

    var iterate = function() {
      calls -= 1;
      i += 1;
      if (i === n) return callback && callback.call(context);
      iterator(list[i], resume);
    };

    var loop = function() {
      if (looping) return;
      looping = true;
      while (calls > 0) iterate();
      looping = false;
    };

    var resume = function() {
      calls += 1;
      loop();
    };
    resume();
  }
};


/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var Event = {
  _registry: [],

  on: function(element, eventName, callback, context) {
    var wrapped = function() { callback.call(context) };

    if (element.addEventListener)
      element.addEventListener(eventName, wrapped, false);
    else
      element.attachEvent('on' + eventName, wrapped);

    this._registry.push({
      _element:   element,
      _type:      eventName,
      _callback:  callback,
      _context:     context,
      _handler:   wrapped
    });
  },

  detach: function(element, eventName, callback, context) {
    var i = this._registry.length, register;
    while (i--) {
      register = this._registry[i];

      if ((element    && element    !== register._element)  ||
          (eventName  && eventName  !== register._type)     ||
          (callback   && callback   !== register._callback) ||
          (context    && context    !== register._context))
        continue;

      if (register._element.removeEventListener)
        register._element.removeEventListener(register._type, register._handler, false);
      else
        register._element.detachEvent('on' + register._type, register._handler);

      this._registry.splice(i,1);
      register = null;
    }
  }
};

if (global.onunload !== undefined)
  Event.on(global, 'unload', Event.detach, Event);

module.exports = {
  Event: Event
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(26)))

/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var extend       = __webpack_require__(51),
    EventEmitter = __webpack_require__(2304);

var Publisher = {
  countListeners: function(eventType) {
    return this.listeners(eventType).length;
  },

  bind: function(eventType, listener, context) {
    var slice   = Array.prototype.slice,
        handler = function() { listener.apply(context, slice.call(arguments)) };

    this._listeners = this._listeners || [];
    this._listeners.push([eventType, listener, context, handler]);
    return this.on(eventType, handler);
  },

  unbind: function(eventType, listener, context) {
    this._listeners = this._listeners || [];
    var n = this._listeners.length, tuple;

    while (n--) {
      tuple = this._listeners[n];
      if (tuple[0] !== eventType) continue;
      if (listener && (tuple[1] !== listener || tuple[2] !== context)) continue;
      this._listeners.splice(n, 1);
      this.removeListener(eventType, tuple[3]);
    }
  }
};

extend(Publisher, EventEmitter.prototype);
Publisher.trigger = Publisher.emit;

module.exports = Publisher;


/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var copyObject = function(object) {
  var clone, i, key;
  if (object instanceof Array) {
    clone = [];
    i = object.length;
    while (i--) clone[i] = copyObject(object[i]);
    return clone;
  } else if (typeof object === 'object') {
    clone = (object === null) ? null : {};
    for (key in object) clone[key] = copyObject(object[key]);
    return clone;
  } else {
    return object;
  }
};

module.exports = copyObject;


/***/ }),
/* 368 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return wrap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CacheKeyNode; });
var wrap = __webpack_require__(2350).wrap;

var CacheKeyNode = (function () {
    function CacheKeyNode() {
        this.children = null;
        this.key = null;
    }
    CacheKeyNode.prototype.lookup = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return this.lookupArray(args);
    };
    CacheKeyNode.prototype.lookupArray = function (array) {
        var node = this;
        array.forEach(function (value) {
            node = node.getOrCreate(value);
        });
        return node.key || (node.key = Object.create(null));
    };
    CacheKeyNode.prototype.getOrCreate = function (value) {
        var map = this.children || (this.children = new Map());
        var node = map.get(value);
        if (!node) {
            map.set(value, node = new CacheKeyNode());
        }
        return node;
    };
    return CacheKeyNode;
}());

//# sourceMappingURL=optimism.js.map

/***/ }),
/* 369 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DepTrackingCache; });
/* harmony export (immutable) */ __webpack_exports__["b"] = defaultNormalizedCacheFactory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__optimism__ = __webpack_require__(368);

var hasOwn = Object.prototype.hasOwnProperty;
var DepTrackingCache = (function () {
    function DepTrackingCache(data) {
        if (data === void 0) { data = Object.create(null); }
        var _this = this;
        this.data = data;
        this.depend = Object(__WEBPACK_IMPORTED_MODULE_0__optimism__["b" /* wrap */])(function (dataId) { return _this.data[dataId]; }, {
            disposable: true,
            makeCacheKey: function (dataId) {
                return dataId;
            }
        });
    }
    DepTrackingCache.prototype.toObject = function () {
        return this.data;
    };
    DepTrackingCache.prototype.get = function (dataId) {
        this.depend(dataId);
        return this.data[dataId];
    };
    DepTrackingCache.prototype.set = function (dataId, value) {
        var oldValue = this.data[dataId];
        if (value !== oldValue) {
            this.data[dataId] = value;
            this.depend.dirty(dataId);
        }
    };
    DepTrackingCache.prototype.delete = function (dataId) {
        if (hasOwn.call(this.data, dataId)) {
            delete this.data[dataId];
            this.depend.dirty(dataId);
        }
    };
    DepTrackingCache.prototype.clear = function () {
        this.replace(null);
    };
    DepTrackingCache.prototype.replace = function (newData) {
        var _this = this;
        if (newData) {
            Object.keys(newData).forEach(function (dataId) {
                _this.set(dataId, newData[dataId]);
            });
            Object.keys(this.data).forEach(function (dataId) {
                if (!hasOwn.call(newData, dataId)) {
                    _this.delete(dataId);
                }
            });
        }
        else {
            Object.keys(this.data).forEach(function (dataId) {
                _this.delete(dataId);
            });
        }
    };
    return DepTrackingCache;
}());

function defaultNormalizedCacheFactory(seed) {
    return new DepTrackingCache(seed);
}
//# sourceMappingURL=depTrackingCache.js.map

/***/ }),
/* 370 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ObjectCache; });
/* unused harmony export defaultNormalizedCacheFactory */
var ObjectCache = (function () {
    function ObjectCache(data) {
        if (data === void 0) { data = Object.create(null); }
        this.data = data;
    }
    ObjectCache.prototype.toObject = function () {
        return this.data;
    };
    ObjectCache.prototype.get = function (dataId) {
        return this.data[dataId];
    };
    ObjectCache.prototype.set = function (dataId, value) {
        this.data[dataId] = value;
    };
    ObjectCache.prototype.delete = function (dataId) {
        this.data[dataId] = undefined;
    };
    ObjectCache.prototype.clear = function () {
        this.data = Object.create(null);
    };
    ObjectCache.prototype.replace = function (newData) {
        this.data = newData || Object.create(null);
    };
    return ObjectCache;
}());

function defaultNormalizedCacheFactory(seed) {
    return new ObjectCache(seed);
}
//# sourceMappingURL=objectCache.js.map

/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(249).f;
var FProto = Function.prototype;
var nameRE = /^\s*function ([^ (]*)/;
var NAME = 'name';

// 19.2.4.2 name
NAME in FProto || __webpack_require__(187) && dP(FProto, NAME, {
  configurable: true,
  get: function () {
    try {
      return ('' + this).match(nameRE)[1];
    } catch (e) {
      return '';
    }
  }
});


/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(373);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 373 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 374 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.6.2' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 375 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 376 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(2360);
var defined = __webpack_require__(600);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(112);
var hide = __webpack_require__(146);
var has = __webpack_require__(250);
var SRC = __webpack_require__(375)('src');
var TO_STRING = 'toString';
var $toString = Function[TO_STRING];
var TPL = ('' + $toString).split(TO_STRING);

__webpack_require__(374).inspectSource = function (it) {
  return $toString.call(it);
};

(module.exports = function (O, key, val, safe) {
  var isFunction = typeof val == 'function';
  if (isFunction) has(val, 'name') || hide(val, 'name', key);
  if (O[key] === val) return;
  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
  if (O === global) {
    O[key] = val;
  } else if (!safe) {
    delete O[key];
    hide(O, key, val);
  } else if (O[key]) {
    O[key] = val;
  } else {
    hide(O, key, val);
  }
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, TO_STRING, function toString() {
  return typeof this == 'function' && this[SRC] || $toString.call(this);
});


/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(597)('keys');
var uid = __webpack_require__(375);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 380 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fallbackHttpConfig", function() { return fallbackHttpConfig; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "throwServerError", function() { return throwServerError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "parseAndCheckHttpResponse", function() { return parseAndCheckHttpResponse; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "checkFetcher", function() { return checkFetcher; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createSignalIfSupported", function() { return createSignalIfSupported; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "selectHttpOptionsAndBody", function() { return selectHttpOptionsAndBody; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "serializeFetchParameter", function() { return serializeFetchParameter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "selectURI", function() { return selectURI; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_graphql_language_printer__ = __webpack_require__(143);
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

var defaultHttpOptions = {
    includeQuery: true,
    includeExtensions: false,
};
var defaultHeaders = {
    // headers are case insensitive (https://stackoverflow.com/a/5259004)
    accept: '*/*',
    'content-type': 'application/json',
};
var defaultOptions = {
    method: 'POST',
};
var fallbackHttpConfig = {
    http: defaultHttpOptions,
    headers: defaultHeaders,
    options: defaultOptions,
};
var throwServerError = function (response, result, message) {
    var error = new Error(message);
    error.name = 'ServerError';
    error.response = response;
    error.statusCode = response.status;
    error.result = result;
    throw error;
};
//TODO: when conditional types come in ts 2.8, operations should be a generic type that extends Operation | Array<Operation>
var parseAndCheckHttpResponse = function (operations) { return function (response) {
    return (response
        .text()
        .then(function (bodyText) {
        try {
            return JSON.parse(bodyText);
        }
        catch (err) {
            var parseError = err;
            parseError.name = 'ServerParseError';
            parseError.response = response;
            parseError.statusCode = response.status;
            parseError.bodyText = bodyText;
            return Promise.reject(parseError);
        }
    })
        //TODO: when conditional types come out then result should be T extends Array ? Array<FetchResult> : FetchResult
        .then(function (result) {
        if (response.status >= 300) {
            //Network error
            throwServerError(response, result, "Response not successful: Received status code " + response.status);
        }
        //TODO should really error per response in a Batch based on properties
        //    - could be done in a validation link
        if (!Array.isArray(result) &&
            !result.hasOwnProperty('data') &&
            !result.hasOwnProperty('errors')) {
            //Data error
            throwServerError(response, result, "Server response was missing for query '" + (Array.isArray(operations)
                ? operations.map(function (op) { return op.operationName; })
                : operations.operationName) + "'.");
        }
        return result;
    }));
}; };
var checkFetcher = function (fetcher) {
    if (!fetcher && typeof fetch === 'undefined') {
        var library = 'unfetch';
        if (typeof window === 'undefined')
            library = 'node-fetch';
        throw new Error("\nfetch is not found globally and no fetcher passed, to fix pass a fetch for\nyour environment like https://www.npmjs.com/package/" + library + ".\n\nFor example:\nimport fetch from '" + library + "';\nimport { createHttpLink } from 'apollo-link-http';\n\nconst link = createHttpLink({ uri: '/graphql', fetch: fetch });");
    }
};
var createSignalIfSupported = function () {
    if (typeof AbortController === 'undefined')
        return { controller: false, signal: false };
    var controller = new AbortController();
    var signal = controller.signal;
    return { controller: controller, signal: signal };
};
var selectHttpOptionsAndBody = function (operation, fallbackConfig) {
    var configs = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        configs[_i - 2] = arguments[_i];
    }
    var options = __assign({}, fallbackConfig.options, { headers: fallbackConfig.headers, credentials: fallbackConfig.credentials });
    var http = fallbackConfig.http;
    /*
     * use the rest of the configs to populate the options
     * configs later in the list will overwrite earlier fields
     */
    configs.forEach(function (config) {
        options = __assign({}, options, config.options, { headers: __assign({}, options.headers, config.headers) });
        if (config.credentials)
            options.credentials = config.credentials;
        http = __assign({}, http, config.http);
    });
    //The body depends on the http options
    var operationName = operation.operationName, extensions = operation.extensions, variables = operation.variables, query = operation.query;
    var body = { operationName: operationName, variables: variables };
    if (http.includeExtensions)
        body.extensions = extensions;
    // not sending the query (i.e persisted queries)
    if (http.includeQuery)
        body.query = Object(__WEBPACK_IMPORTED_MODULE_0_graphql_language_printer__["a" /* print */])(query);
    return {
        options: options,
        body: body,
    };
};
var serializeFetchParameter = function (p, label) {
    var serialized;
    try {
        serialized = JSON.stringify(p);
    }
    catch (e) {
        var parseError = new Error("Network request failed. " + label + " is not serializable: " + e.message);
        parseError.parseError = e;
        throw parseError;
    }
    return serialized;
};
//selects "/graphql" by default
var selectURI = function (operation, fallbackURI) {
    var context = operation.getContext();
    var contextURI = context.uri;
    if (contextURI) {
        return contextURI;
    }
    else if (typeof fallbackURI === 'function') {
        return fallbackURI(operation);
    }
    else {
        return fallbackURI || '/graphql';
    }
};
//# sourceMappingURL=index.js.map

/***/ }),
/* 381 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isObject", function() { return isObject; });
/* harmony export (immutable) */ __webpack_exports__["default"] = extractFiles;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ReactNativeFile", function() { return ReactNativeFile; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_function_name__ = __webpack_require__(371);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_function_name___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_function_name__);

var isObject = function isObject(node) {
  return typeof node === 'object' && node !== null
}
function extractFiles(tree, treePath) {
  if (treePath === void 0) {
    treePath = ''
  }

  var files = []

  var recurse = function recurse(node, nodePath) {
    Object.keys(node).forEach(function(key) {
      if (!isObject(node[key])) return
      var path = '' + nodePath + key

      if (
        (typeof File !== 'undefined' && node[key] instanceof File) ||
        (typeof Blob !== 'undefined' && node[key] instanceof Blob) ||
        node[key] instanceof ReactNativeFile
      ) {
        files.push({
          path: path,
          file: node[key]
        })
        node[key] = null
        return
      }

      if (typeof FileList !== 'undefined' && node[key] instanceof FileList)
        node[key] = Array.prototype.slice.call(node[key])
      recurse(node[key], path + '.')
    })
  }

  if (isObject(tree)) recurse(tree, treePath === '' ? treePath : treePath + '.')
  return files
}
var ReactNativeFile = function ReactNativeFile(_ref) {
  var uri = _ref.uri,
    type = _ref.type,
    name = _ref.name
  this.uri = uri
  this.type = type
  this.name = name
}

ReactNativeFile.list = function(files) {
  return files.map(function(file) {
    return new ReactNativeFile(file)
  })
}


/***/ }),
/* 382 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_assets_jss_material_dashboard_pro_react_components_cardAvatarStyle_jsx__ = __webpack_require__(2376);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}// nodejs library that concatenates classes
// nodejs library to set properties for components
// @material-ui/core components
// @material-ui/icons
// core components
function CardAvatar(_ref){var _classNames;var props=_objectWithoutProperties(_ref,[]);var classes=props.classes,children=props.children,className=props.className,plain=props.plain,profile=props.profile,testimonial=props.testimonial,testimonialFooter=props.testimonialFooter,rest=_objectWithoutProperties(props,["classes","children","className","plain","profile","testimonial","testimonialFooter"]);var cardAvatarClasses=__WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classNames={},_defineProperty(_classNames,classes.cardAvatar,true),_defineProperty(_classNames,classes.cardAvatarProfile,profile),_defineProperty(_classNames,classes.cardAvatarPlain,plain),_defineProperty(_classNames,classes.cardAvatarTestimonial,testimonial),_defineProperty(_classNames,classes.cardAvatarTestimonialFooter,testimonialFooter),_defineProperty(_classNames,className,className!==undefined),_classNames));return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",Object.assign({className:cardAvatarClasses},rest),children);}CardAvatar.propTypes={children:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node.isRequired,className:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,profile:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,plain:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,testimonial:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,testimonialFooter:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool};/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles___default()(__WEBPACK_IMPORTED_MODULE_4_assets_jss_material_dashboard_pro_react_components_cardAvatarStyle_jsx__["a" /* default */])(CardAvatar));

/***/ }),
/* 383 */
/***/ (function(module, exports) {

/**
 * @category Common Helpers
 * @summary Is the given argument an instance of Date?
 *
 * @description
 * Is the given argument an instance of Date?
 *
 * @param {*} argument - the argument to check
 * @returns {Boolean} the given argument is an instance of Date
 *
 * @example
 * // Is 'mayonnaise' a Date?
 * var result = isDate('mayonnaise')
 * //=> false
 */
function isDate (argument) {
  return argument instanceof Date
}

module.exports = isDate


/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(9)

/**
 * @category Weekday Helpers
 * @summary Get the day of the week of the given date.
 *
 * @description
 * Get the day of the week of the given date.
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the day of week
 *
 * @example
 * // Which day of the week is 29 February 2012?
 * var result = getDay(new Date(2012, 1, 29))
 * //=> 3
 */
function getDay (dirtyDate) {
  var date = parse(dirtyDate)
  var day = date.getDay()
  return day
}

module.exports = getDay


/***/ }),
/* 385 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = defaultSelectionRenderer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_transition_group_CSSTransitionGroup__ = __webpack_require__(607);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_transition_group_CSSTransitionGroup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_transition_group_CSSTransitionGroup__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_date_fns_parse__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_date_fns_parse___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_date_fns_parse__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_date_fns_format__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_date_fns_format___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_date_fns_format__);





var styles = {
  'root': 'Cal__Header__root',
  'landscape': 'Cal__Header__landscape',
  'dateWrapper': 'Cal__Header__dateWrapper',
  'day': 'Cal__Header__day',
  'wrapper': 'Cal__Header__wrapper',
  'blank': 'Cal__Header__blank',
  'active': 'Cal__Header__active',
  'year': 'Cal__Header__year',
  'date': 'Cal__Header__date',
  'range': 'Cal__Header__range'
};
var animation = {
  'enter': 'Cal__Animation__enter',
  'enterActive': 'Cal__Animation__enterActive',
  'leave': 'Cal__Animation__leave',
  'leaveActive': 'Cal__Animation__leaveActive'
};


function defaultSelectionRenderer(value, _ref) {
  var display = _ref.display,
      key = _ref.key,
      locale = _ref.locale.locale,
      dateFormat = _ref.dateFormat,
      onYearClick = _ref.onYearClick,
      scrollToDate = _ref.scrollToDate,
      setDisplay = _ref.setDisplay,
      shouldAnimate = _ref.shouldAnimate;

  var date = __WEBPACK_IMPORTED_MODULE_3_date_fns_parse___default()(value);
  var values = date && [{
    active: display === 'years',
    handleClick: function handleClick(e) {
      onYearClick(date, e, key);
      setDisplay('years');
    },
    item: 'year',
    title: display === 'days' ? 'Change year' : null,
    value: date.getFullYear()
  }, {
    active: display === 'days',
    handleClick: function handleClick(e) {
      if (display !== 'days') {
        setDisplay('days');
      } else if (date) {
        scrollToDate(date, -40, true);
      }
    },
    item: 'day',
    title: display === 'days' ? 'Scroll to ' + __WEBPACK_IMPORTED_MODULE_4_date_fns_format___default()(date, dateFormat, { locale: locale }) : null,
    value: __WEBPACK_IMPORTED_MODULE_4_date_fns_format___default()(date, dateFormat, { locale: locale })
  }];

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    {
      key: key,
      className: styles.wrapper,
      'aria-label': __WEBPACK_IMPORTED_MODULE_4_date_fns_format___default()(date, dateFormat + ' YYYY', { locale: locale })
    },
    values.map(function (_ref2) {
      var _classNames;

      var handleClick = _ref2.handleClick,
          item = _ref2.item,
          key = _ref2.key,
          value = _ref2.value,
          active = _ref2.active,
          title = _ref2.title;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        {
          key: item,
          className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(styles.dateWrapper, styles[item], (_classNames = {}, _classNames[styles.active] = active, _classNames)),
          title: title
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_1_react_transition_group_CSSTransitionGroup___default.a,
          {
            transitionName: animation,
            transitionEnterTimeout: 250,
            transitionLeaveTimeout: 250,
            transitionEnter: shouldAnimate,
            transitionLeave: shouldAnimate
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            {
              key: item + '-' + value,
              className: styles.date,
              'aria-hidden': true,
              onClick: handleClick
            },
            value
          )
        )
      );
    })
  );
}

/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(9)
var startOfISOWeek = __webpack_require__(113)
var startOfISOYear = __webpack_require__(192)

var MILLISECONDS_IN_WEEK = 604800000

/**
 * @category ISO Week Helpers
 * @summary Get the ISO week of the given date.
 *
 * @description
 * Get the ISO week of the given date.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the ISO week
 *
 * @example
 * // Which week of the ISO-week numbering year is 2 January 2005?
 * var result = getISOWeek(new Date(2005, 0, 2))
 * //=> 53
 */
function getISOWeek (dirtyDate) {
  var date = parse(dirtyDate)
  var diff = startOfISOWeek(date).getTime() - startOfISOYear(date).getTime()

  // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)
  return Math.round(diff / MILLISECONDS_IN_WEEK) + 1
}

module.exports = getISOWeek


/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

var buildDistanceInWordsLocale = __webpack_require__(2404)
var buildFormatLocale = __webpack_require__(2405)

/**
 * @category Locales
 * @summary English locale.
 */
module.exports = {
  distanceInWords: buildDistanceInWordsLocale(),
  format: buildFormatLocale()
}


/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(9)

/**
 * @category Year Helpers
 * @summary Are the given dates in the same year?
 *
 * @description
 * Are the given dates in the same year?
 *
 * @param {Date|String|Number} dateLeft - the first date to check
 * @param {Date|String|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same year
 *
 * @example
 * // Are 2 September 2014 and 25 September 2014 in the same year?
 * var result = isSameYear(
 *   new Date(2014, 8, 2),
 *   new Date(2014, 8, 25)
 * )
 * //=> true
 */
function isSameYear (dirtyDateLeft, dirtyDateRight) {
  var dateLeft = parse(dirtyDateLeft)
  var dateRight = parse(dirtyDateRight)
  return dateLeft.getFullYear() === dateRight.getFullYear()
}

module.exports = isSameYear


/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(9)

/**
 * @category Month Helpers
 * @summary Are the given dates in the same month?
 *
 * @description
 * Are the given dates in the same month?
 *
 * @param {Date|String|Number} dateLeft - the first date to check
 * @param {Date|String|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same month
 *
 * @example
 * // Are 2 September 2014 and 25 September 2014 in the same month?
 * var result = isSameMonth(
 *   new Date(2014, 8, 2),
 *   new Date(2014, 8, 25)
 * )
 * //=> true
 */
function isSameMonth (dirtyDateLeft, dirtyDateRight) {
  var dateLeft = parse(dirtyDateLeft)
  var dateRight = parse(dirtyDateRight)
  return dateLeft.getFullYear() === dateRight.getFullYear() &&
    dateLeft.getMonth() === dateRight.getMonth()
}

module.exports = isSameMonth


/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.default = compareObjects;
function compareObjects(objA, objB) {
  var keys = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

  if (objA === objB) {
    return false;
  }

  var aKeys = Object.keys(objA);
  var bKeys = Object.keys(objB);

  if (aKeys.length !== bKeys.length) {
    return true;
  }

  var keysMap = {};
  var i = void 0,
      len = void 0;

  for (i = 0, len = keys.length; i < len; i++) {
    keysMap[keys[i]] = true;
  }

  for (i = 0, len = aKeys.length; i < len; i++) {
    var key = aKeys[i];
    var aValue = objA[key];
    var bValue = objB[key];

    if (aValue === bValue) {
      continue;
    }

    if (!keysMap[key] || aValue === null || bValue === null || (typeof aValue === 'undefined' ? 'undefined' : _typeof(aValue)) !== 'object' || (typeof bValue === 'undefined' ? 'undefined' : _typeof(bValue)) !== 'object') {
      return true;
    }

    var aValueKeys = Object.keys(aValue);
    var bValueKeys = Object.keys(bValue);

    if (aValueKeys.length !== bValueKeys.length) {
      return true;
    }

    for (var n = 0, length = aValueKeys.length; n < length; n++) {
      var aValueKey = aValueKeys[n];

      if (aValue[aValueKey] !== bValue[aValueKey]) {
        return true;
      }
    }
  }

  return false;
}

/***/ }),
/* 391 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = ParseGraphqlError;
function ParseGraphqlError(error){var err=error.toString().replace("Error: GraphQL error: ","").replace("Error: ","");return err;}

/***/ }),
/* 392 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return newQuoteMutation; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_graphql_tag__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_graphql_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_graphql_tag__);
var _templateObject=_taggedTemplateLiteral(['\n\tmutation newQuote($input: NewQuoteInput!) {\n\t\tnewQuote(input: $input) {\n\t\t\tguid\n\t\t}\n\t}\n'],['\n\tmutation newQuote($input: NewQuoteInput!) {\n\t\tnewQuote(input: $input) {\n\t\t\tguid\n\t\t}\n\t}\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var newQuoteMutation=__WEBPACK_IMPORTED_MODULE_0_graphql_tag___default()(_templateObject);

/***/ }),
/* 393 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ClientById; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_graphql_tag__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_graphql_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_graphql_tag__);
var _templateObject=_taggedTemplateLiteral(["\n  query Client($id: String!, $token: String!) {\n    ClientById(id: $id, token: $token) {\n      id\n      scd_name\n      scd_surname\n      scd_email\n      scd_pp_path\n      scd_saID\n      scd_cellNumber\n      scd_dateOfBirth\n      scd_title\n      scd_occupation\n      scd_residentialAddress\n      scd_monthlyIncome\n      scd_smoker\n      scd_maritalStatus\n      scd_qualification\n      scd_selfEmployed\n      scd_salaryType\n      scd_taxDispensation\n      scd_spouseIncome\n      scd_pAdmin\n      scd_pTravel\n      scd_pManual\n      scd_pSupervision\n      scd_gender\n      scd_calculatedMonthlyIncomeAT\n      scd_actualMonthlyIncomeAT\n      scd_clientFileNumber\n      scd_clientType\n      scd_correspondenceType\n      scd_correspondenceLanguage\n      scd_correspondenceFormality\n      scd_nickName\n      scd_secondAndOtherNames\n      scd_initials\n      scd_idType\n      scd_passportNumber\n      scd_countryOfIssue\n      scd_maidenName\n      scd_weddingDate\n      scd_howMarried\n      scd_incomeTaxNumber\n      scd_TelNumberHome\n      scd_TelNumberWork\n      scd_qualificationName\n      scd_height\n      scd_weight\n      scd_currentGp\n      scd_currentGpYears\n      scd_currentDentist\n      scd_hasWill\n      scd_willExecutor\n      scd_wilLocation\n      sb_accountName\n      sb_bank\n      sb_branchName\n      sb_branch\n      sb_accountNumber\n      sb_accountType\n      scd_residentialAddress2\n      scd_residentialAddress3\n      scd_residentialAddress4\n      scd_postalCode\n      scd_postalAddress1\n      scd_postalAddress2\n      scd_postalAddress3\n      scd_postalAddress4\n      scd_postalAddressCode\n    }\n  }\n"],["\n  query Client($id: String!, $token: String!) {\n    ClientById(id: $id, token: $token) {\n      id\n      scd_name\n      scd_surname\n      scd_email\n      scd_pp_path\n      scd_saID\n      scd_cellNumber\n      scd_dateOfBirth\n      scd_title\n      scd_occupation\n      scd_residentialAddress\n      scd_monthlyIncome\n      scd_smoker\n      scd_maritalStatus\n      scd_qualification\n      scd_selfEmployed\n      scd_salaryType\n      scd_taxDispensation\n      scd_spouseIncome\n      scd_pAdmin\n      scd_pTravel\n      scd_pManual\n      scd_pSupervision\n      scd_gender\n      scd_calculatedMonthlyIncomeAT\n      scd_actualMonthlyIncomeAT\n      scd_clientFileNumber\n      scd_clientType\n      scd_correspondenceType\n      scd_correspondenceLanguage\n      scd_correspondenceFormality\n      scd_nickName\n      scd_secondAndOtherNames\n      scd_initials\n      scd_idType\n      scd_passportNumber\n      scd_countryOfIssue\n      scd_maidenName\n      scd_weddingDate\n      scd_howMarried\n      scd_incomeTaxNumber\n      scd_TelNumberHome\n      scd_TelNumberWork\n      scd_qualificationName\n      scd_height\n      scd_weight\n      scd_currentGp\n      scd_currentGpYears\n      scd_currentDentist\n      scd_hasWill\n      scd_willExecutor\n      scd_wilLocation\n      sb_accountName\n      sb_bank\n      sb_branchName\n      sb_branch\n      sb_accountNumber\n      sb_accountType\n      scd_residentialAddress2\n      scd_residentialAddress3\n      scd_residentialAddress4\n      scd_postalCode\n      scd_postalAddress1\n      scd_postalAddress2\n      scd_postalAddress3\n      scd_postalAddress4\n      scd_postalAddressCode\n    }\n  }\n"]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var ClientById=__WEBPACK_IMPORTED_MODULE_0_graphql_tag___default()(_templateObject);

/***/ }),
/* 394 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = PopulateClient;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_helpers_TestNullOrReturn__ = __webpack_require__(621);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_helpers_DateHelpers__ = __webpack_require__(40);
function PopulateClient(data){return Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_0_helpers_TestNullOrReturn__["b" /* v */])("firstName",data.scd_name),{lastName:Object(__WEBPACK_IMPORTED_MODULE_0_helpers_TestNullOrReturn__["a" /* default */])(data.scd_surname,""),email:Object(__WEBPACK_IMPORTED_MODULE_0_helpers_TestNullOrReturn__["a" /* default */])(data.scd_email,""),dateOfBirth:data.scd_dateOfBirth?Object(__WEBPACK_IMPORTED_MODULE_1_helpers_DateHelpers__["c" /* ParseYMDwDash */])(data.scd_dateOfBirth):null,title:Object(__WEBPACK_IMPORTED_MODULE_0_helpers_TestNullOrReturn__["a" /* default */])(data.scd_title,"validationError"),occupation:Object(__WEBPACK_IMPORTED_MODULE_0_helpers_TestNullOrReturn__["a" /* default */])(data.scd_occupation,""),monthlyIncome:Object(__WEBPACK_IMPORTED_MODULE_0_helpers_TestNullOrReturn__["a" /* default */])(data.scd_monthlyIncome,""),smoker:Object(__WEBPACK_IMPORTED_MODULE_0_helpers_TestNullOrReturn__["a" /* default */])(data.scd_smoker,"validationError"),maritalStatus:Object(__WEBPACK_IMPORTED_MODULE_0_helpers_TestNullOrReturn__["a" /* default */])(data.scd_maritalStatus,"validationError"),qualification:Object(__WEBPACK_IMPORTED_MODULE_0_helpers_TestNullOrReturn__["a" /* default */])(data.scd_qualification,"validationError"),selfEmployed:Object(__WEBPACK_IMPORTED_MODULE_0_helpers_TestNullOrReturn__["a" /* default */])(data.scd_selfEmployed,"validationError"),salaryType:Object(__WEBPACK_IMPORTED_MODULE_0_helpers_TestNullOrReturn__["a" /* default */])(data.scd_salaryType,"validationError"),TaxDispensation:Object(__WEBPACK_IMPORTED_MODULE_0_helpers_TestNullOrReturn__["a" /* default */])(data.scd_taxDispensation,"validationError"),spouseIncome:Object(__WEBPACK_IMPORTED_MODULE_0_helpers_TestNullOrReturn__["a" /* default */])(data.scd_spouseIncome,""),Admin:Object(__WEBPACK_IMPORTED_MODULE_0_helpers_TestNullOrReturn__["a" /* default */])(data.scd_pAdmin,""),Travel:Object(__WEBPACK_IMPORTED_MODULE_0_helpers_TestNullOrReturn__["a" /* default */])(data.scd_pTravel,""),ManualLabour:Object(__WEBPACK_IMPORTED_MODULE_0_helpers_TestNullOrReturn__["a" /* default */])(data.scd_pManual,""),Supervision:Object(__WEBPACK_IMPORTED_MODULE_0_helpers_TestNullOrReturn__["a" /* default */])(data.scd_pSupervision,""),gender:Object(__WEBPACK_IMPORTED_MODULE_0_helpers_TestNullOrReturn__["a" /* default */])(data.scd_gender,"validationError"),resAddressOne:Object(__WEBPACK_IMPORTED_MODULE_0_helpers_TestNullOrReturn__["a" /* default */])(data.scd_residentialAddress,""),cellNumber:Object(__WEBPACK_IMPORTED_MODULE_0_helpers_TestNullOrReturn__["a" /* default */])(data.scd_cellNumber,""),said:Object(__WEBPACK_IMPORTED_MODULE_0_helpers_TestNullOrReturn__["a" /* default */])(data.scd_saID,""),actualMonthlyIncomeAT:Object(__WEBPACK_IMPORTED_MODULE_0_helpers_TestNullOrReturn__["a" /* default */])(data.scd_actualMonthlyIncomeAT,""),clientType:Object(__WEBPACK_IMPORTED_MODULE_0_helpers_TestNullOrReturn__["a" /* default */])(data.scd_clientType,"validationError"),clientFileNumber:Object(__WEBPACK_IMPORTED_MODULE_0_helpers_TestNullOrReturn__["a" /* default */])(data.scd_clientFileNumber,""),correspondenceType:Object(__WEBPACK_IMPORTED_MODULE_0_helpers_TestNullOrReturn__["a" /* default */])(data.scd_correspondenceType,"validationError"),correspondenceLanguage:Object(__WEBPACK_IMPORTED_MODULE_0_helpers_TestNullOrReturn__["a" /* default */])(data.scd_correspondenceLanguage,"validationError"),correspondenceFormality:Object(__WEBPACK_IMPORTED_MODULE_0_helpers_TestNullOrReturn__["a" /* default */])(data.scd_correspondenceFormality,"validationError"),nickName:Object(__WEBPACK_IMPORTED_MODULE_0_helpers_TestNullOrReturn__["a" /* default */])(data.scd_nickName,""),initials:Object(__WEBPACK_IMPORTED_MODULE_0_helpers_TestNullOrReturn__["a" /* default */])(data.scd_initials,""),secondNames:Object(__WEBPACK_IMPORTED_MODULE_0_helpers_TestNullOrReturn__["a" /* default */])(data.scd_secondAndOtherNames,""),idType:Object(__WEBPACK_IMPORTED_MODULE_0_helpers_TestNullOrReturn__["a" /* default */])(data.scd_idType,"idNumber"),passportNumber:Object(__WEBPACK_IMPORTED_MODULE_0_helpers_TestNullOrReturn__["a" /* default */])(data.scd_passportNumber,""),countryOfIssue:Object(__WEBPACK_IMPORTED_MODULE_0_helpers_TestNullOrReturn__["a" /* default */])(data.scd_countryOfIssue,""),maidenName:Object(__WEBPACK_IMPORTED_MODULE_0_helpers_TestNullOrReturn__["a" /* default */])(data.scd_maidenName,""),weddingDate:data.scd_weddingDate&&data.scd_weddingDate.split("T")[0]?data.scd_weddingDate.split("T")[0]:"",howMarried:Object(__WEBPACK_IMPORTED_MODULE_0_helpers_TestNullOrReturn__["a" /* default */])(data.scd_howMarried,"validationError"),taxNumber:Object(__WEBPACK_IMPORTED_MODULE_0_helpers_TestNullOrReturn__["a" /* default */])(data.scd_incomeTaxNumber,""),telNumberHome:Object(__WEBPACK_IMPORTED_MODULE_0_helpers_TestNullOrReturn__["a" /* default */])(data.scd_TelNumberHome,""),telNumberWork:Object(__WEBPACK_IMPORTED_MODULE_0_helpers_TestNullOrReturn__["a" /* default */])(data.scd_TelNumberWork,""),resAddressTwo:Object(__WEBPACK_IMPORTED_MODULE_0_helpers_TestNullOrReturn__["a" /* default */])(data.scd_residentialAddress2,""),resAddressThree:Object(__WEBPACK_IMPORTED_MODULE_0_helpers_TestNullOrReturn__["a" /* default */])(data.scd_residentialAddress3,""),resAddressFour:Object(__WEBPACK_IMPORTED_MODULE_0_helpers_TestNullOrReturn__["a" /* default */])(data.scd_residentialAddress4,""),postalCode:Object(__WEBPACK_IMPORTED_MODULE_0_helpers_TestNullOrReturn__["a" /* default */])(data.scd_postalCode,""),qualificationName:Object(__WEBPACK_IMPORTED_MODULE_0_helpers_TestNullOrReturn__["a" /* default */])(data.scd_qualificationName,""),healthHeight:Object(__WEBPACK_IMPORTED_MODULE_0_helpers_TestNullOrReturn__["a" /* default */])(data.scd_height,""),healthWeight:Object(__WEBPACK_IMPORTED_MODULE_0_helpers_TestNullOrReturn__["a" /* default */])(data.scd_weight,""),healthCurrentGp:Object(__WEBPACK_IMPORTED_MODULE_0_helpers_TestNullOrReturn__["a" /* default */])(data.scd_currentGp,""),healthGpYears:Object(__WEBPACK_IMPORTED_MODULE_0_helpers_TestNullOrReturn__["a" /* default */])(data.scd_currentGpYears,""),healthCurrentDentist:Object(__WEBPACK_IMPORTED_MODULE_0_helpers_TestNullOrReturn__["a" /* default */])(data.scd_currentDentist,""),willHasWill:Object(__WEBPACK_IMPORTED_MODULE_0_helpers_TestNullOrReturn__["a" /* default */])(data.scd_hasWill,"validationError"),willExcecutor:Object(__WEBPACK_IMPORTED_MODULE_0_helpers_TestNullOrReturn__["a" /* default */])(data.scd_willExecutor,""),willLocation:Object(__WEBPACK_IMPORTED_MODULE_0_helpers_TestNullOrReturn__["a" /* default */])(data.scd_wilLocation,""),bankAccountName:Object(__WEBPACK_IMPORTED_MODULE_0_helpers_TestNullOrReturn__["a" /* default */])(data.sb_accountName,""),bank:Object(__WEBPACK_IMPORTED_MODULE_0_helpers_TestNullOrReturn__["a" /* default */])(data.sb_bank,"validationError"),bankBranch:Object(__WEBPACK_IMPORTED_MODULE_0_helpers_TestNullOrReturn__["a" /* default */])(data.sb_branchName,""),bankBranchCode:Object(__WEBPACK_IMPORTED_MODULE_0_helpers_TestNullOrReturn__["a" /* default */])(data.sb_branch,""),bankAccNumber:Object(__WEBPACK_IMPORTED_MODULE_0_helpers_TestNullOrReturn__["a" /* default */])(data.sb_accountNumber,""),bankAccountType:Object(__WEBPACK_IMPORTED_MODULE_0_helpers_TestNullOrReturn__["a" /* default */])(data.sb_accountType,"")});}

/***/ }),
/* 395 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_graphql_tag__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_graphql_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_graphql_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_Wrappers_materialUIWrappers_components_FormInput__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Wrappers_materialUIWrappers_components_FormDropDown__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Wrappers_materialUIWrappers_components_GrandInput__ = __webpack_require__(616);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__layouts_hoc_NotificationWrapper__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_Wrappers_materialUIWrappers_components_Autofill__ = __webpack_require__(617);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_reducers_NotificationReducer__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_redux_form__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_store__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_apollo__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_reducers_OccupationsReducer__ = __webpack_require__(360);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_Wrappers_materialUIWrappers_components_AutofillV2__ = __webpack_require__(618);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__FieldIndicators_jsx__ = __webpack_require__(267);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(["\n  {\n    Occupations {\n      occupations\n    }\n  }\n"],["\n  {\n    Occupations {\n      occupations\n    }\n  }\n"]);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}/*eslint-disable*/var GET="sure-quote/Occupations/GET";var required=function required(value){return value?undefined:"Required";};var number=function number(value){if(value===undefined)return undefined;value=value.replace(/,/g,"").replace(/ /g,"");return isNaN(Number(value))?"Must be a number":undefined;};var percentage=function percentage(value){if(value===undefined)return undefined;if(isNaN(Number(value))){return"Must be a number";}if(parseInt(value)>100||parseInt(value)<0){return"Cannot be more than 100 or less than 0";}return undefined;};var occupationQuery=__WEBPACK_IMPORTED_MODULE_1_graphql_tag___default()(_templateObject);var CurrencySymbol="R";var requiredDropdown=function requiredDropdown(value){if(value==="validationError"){return"Required";}else if(value){return undefined;}else{return"Required";}};var charMin3=function charMin3(value){if(value===undefined||value.trim()==="")return undefined;if(value.length<3)return"Must be at least 3 characters";return undefined;};var businessOwner=function businessOwner(value){if(value==="Business Owner/Businessman"){__WEBPACK_IMPORTED_MODULE_10_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_7_reducers_NotificationReducer__["d" /* showSnack */])({message:"If possible please select an occupation that better describe what the client does.",color:"danger"}));return;}if(value.length<3)return"Must be at least 3 characters";return undefined;};var styles=function styles(theme){return{};};var form="client";var CC_clientOccForm_EliteWealth=function(_React$Component){_inherits(CC_clientOccForm_EliteWealth,_React$Component);function CC_clientOccForm_EliteWealth(){_classCallCheck(this,CC_clientOccForm_EliteWealth);return _possibleConstructorReturn(this,(CC_clientOccForm_EliteWealth.__proto__||Object.getPrototypeOf(CC_clientOccForm_EliteWealth)).apply(this,arguments));}_createClass(CC_clientOccForm_EliteWealth,[{key:"componentDidMount",value:function componentDidMount(){}},{key:"render",value:function render(){var _this2=this;var validate=[];validate.push(required);var spousalDetails=null;if(__WEBPACK_IMPORTED_MODULE_10_store__["a" /* default */].getState().form.client){var mStatus=__WEBPACK_IMPORTED_MODULE_10_store__["a" /* default */].getState().form.client.values.maritalStatus;if(mStatus&&mStatus==="Married"){spousalDetails=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["v" /* Grid */],{item:true,xs:12,sm:6,style:{display:"flex"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,Object(__WEBPACK_IMPORTED_MODULE_14__FieldIndicators_jsx__["b" /* quoteIn */])(true)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["t" /* FormControl */],{fullWidth:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_2_components_Wrappers_materialUIWrappers_components_FormInput__["a" /* default */],checkValidation:this.props.checkValidation,validate:[number],label:"Spouse Monthly Income",name:"spouseIncome"})));}}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_apollo__["Query"],{query:occupationQuery},function(_ref){var loading=_ref.loading,error=_ref.error,data=_ref.data;if(loading)return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["B" /* LinearProgress */],null));if(error)return"Error! "+error.message;if(__WEBPACK_IMPORTED_MODULE_10_store__["a" /* default */].getState().occupations.occupations.length<1){var occupations=data.Occupations[0];__WEBPACK_IMPORTED_MODULE_10_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_12_reducers_OccupationsReducer__["a" /* addOccupations */])({type:GET,props:occupations}));_this2.forceUpdate();}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["e" /* Card */],{className:"contentWithStepper"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["g" /* CardHeader */],{title:"Client Occupational Info"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["f" /* CardContent */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["v" /* Grid */],{container:true,spacing:24,style:{marginTop:"15px"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["v" /* Grid */],{item:true,xs:12,sm:6,style:{display:"flex"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["t" /* FormControl */],{fullWidth:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{className:"labelSmall"},"Occupation for Quote purposes"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_redux_form__["a" /* Field */],{name:"occupation",component:__WEBPACK_IMPORTED_MODULE_13_components_Wrappers_materialUIWrappers_components_AutofillV2__["a" /* default */],validate:[charMin3,businessOwner],onItemSelect:function onItemSelect(){return _this2.props.toggleOccupationValid(true);}//alert(JSON.stringify( this.name))
,textChanged:function textChanged(e){return _this2.props.toggleOccupationValid(e.target.value.trim()==="");},autoFillList:_.get(__WEBPACK_IMPORTED_MODULE_10_store__["a" /* default */].getState(),"occupations.occupations",[])}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["v" /* Grid */],{item:true,xs:12,sm:6,style:{display:"flex"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["t" /* FormControl */],{fullWidth:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_3_components_Wrappers_materialUIWrappers_components_FormDropDown__["a" /* default */],label:"Highest qualification",name:"qualification",options:[{value:"validationError",displayValue:"Please select"},{value:"LessThanMatric",displayValue:"Less than matric"},{value:"Matric",displayValue:"Matric"},{value:"3-yearDiploma",displayValue:"3-year diploma"},{value:"3-yearDegreeOr4-yearDiploma",displayValue:"3-year degree / 4-year diploma"},{value:"4-yearDegreeOrProfessional",displayValue:"4-year degree / Professional"}]}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["v" /* Grid */],{item:true,xs:12,sm:6,style:{display:"flex"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["t" /* FormControl */],{fullWidth:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_3_components_Wrappers_materialUIWrappers_components_FormDropDown__["a" /* default */],checkValidation:_this2.props.checkValidation,label:"Self Employed",name:"selfEmployed",options:[{value:"validationError",displayValue:"Please select"},{value:"N",displayValue:"No"},{value:"Y",displayValue:"Yes"}]}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["v" /* Grid */],{item:true,xs:12,sm:6,style:{display:"flex"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["t" /* FormControl */],{fullWidth:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_redux_form__["a" /* Field */],{name:"salaryType",component:__WEBPACK_IMPORTED_MODULE_3_components_Wrappers_materialUIWrappers_components_FormDropDown__["a" /* default */],label:"Commission or Fixed Salary?",options:[{value:"validationError",displayValue:"Please select"},{value:"commission",displayValue:"Commission"},{value:"fixed",displayValue:"Fixed"}]}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["v" /* Grid */],{item:true,xs:12,sm:6,style:{display:"flex"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["t" /* FormControl */],{fullWidth:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_redux_form__["a" /* Field */],{name:"monthlyIncome",component:__WEBPACK_IMPORTED_MODULE_4_components_Wrappers_materialUIWrappers_components_GrandInput__["a" /* default */],checkValidation:_this2.props.checkValidation,label:"Monthly income (Gross)",validate:[number],onChange:function onChange(e){return _this2.props.salaryChangeHandler(e.target.value);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["v" /* Grid */],{item:true,xs:12,sm:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["t" /* FormControl */],{fullWidth:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_redux_form__["a" /* Field */],{name:"calculatedMonthlyIncomeAT",component:__WEBPACK_IMPORTED_MODULE_4_components_Wrappers_materialUIWrappers_components_GrandInput__["a" /* default */],label:"Monthly After Tax Income (Calculated)",fixedValue:_this2.props.afterTaxIncome,readOnly:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["v" /* Grid */],{item:true,xs:12,sm:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["t" /* FormControl */],{fullWidth:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_redux_form__["a" /* Field */],{name:"actualMonthlyIncomeAT",component:__WEBPACK_IMPORTED_MODULE_4_components_Wrappers_materialUIWrappers_components_GrandInput__["a" /* default */],validate:[number],checkValidation:_this2.props.checkValidation,label:"Actual monthly after tax income"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["v" /* Grid */],{item:true,xs:12,sm:6,style:{display:"flex"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["t" /* FormControl */],{fullWidth:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_3_components_Wrappers_materialUIWrappers_components_FormDropDown__["a" /* default */],label:"Tax dispensation",name:"TaxDispensation",options:[{value:"validationError",displayValue:"Please select"},{value:"NaturalPerson",displayValue:"Natural person"},{value:"TaxPayingInstitution",displayValue:"Tax-paying institution"},{value:"TaxExemptInstitution",displayValue:"Tax-exempt institution"},{value:"Trust",displayValue:"Trust"}]}))),spousalDetails,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["v" /* Grid */],{item:true,xs:12,sm:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{className:"labelSmall"},"Occupational Duties")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["v" /* Grid */],{item:true,xs:12,sm:6,style:{display:"flex"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["t" /* FormControl */],{fullWidth:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_redux_form__["a" /* Field */],{name:"Admin",component:__WEBPACK_IMPORTED_MODULE_2_components_Wrappers_materialUIWrappers_components_FormInput__["a" /* default */],validate:[percentage],checkValidation:_this2.props.checkValidation,label:"Admin % *",isRequired:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["v" /* Grid */],{item:true,xs:12,sm:6,style:{display:"flex"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["t" /* FormControl */],{fullWidth:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_redux_form__["a" /* Field */],{name:"Travel",component:__WEBPACK_IMPORTED_MODULE_2_components_Wrappers_materialUIWrappers_components_FormInput__["a" /* default */],validate:[percentage],checkValidation:_this2.props.checkValidation,label:"Travel % *",isRequired:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["v" /* Grid */],{item:true,xs:12,sm:6,style:{display:"flex"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["t" /* FormControl */],{fullWidth:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_redux_form__["a" /* Field */],{name:"ManualLabour",component:__WEBPACK_IMPORTED_MODULE_2_components_Wrappers_materialUIWrappers_components_FormInput__["a" /* default */],validate:[percentage],checkValidation:_this2.props.checkValidation,label:"Manual Labour % *",isRequired:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["v" /* Grid */],{item:true,xs:12,sm:6,style:{display:"flex"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["t" /* FormControl */],{fullWidth:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_redux_form__["a" /* Field */],{name:"Supervision",component:__WEBPACK_IMPORTED_MODULE_2_components_Wrappers_materialUIWrappers_components_FormInput__["a" /* default */],validate:[percentage],checkValidation:_this2.props.checkValidation,label:"Supervision % *",isRequired:true})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null)));});}}]);return CC_clientOccForm_EliteWealth;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["_1" /* withStyles */])(styles)(CC_clientOccForm_EliteWealth));

/***/ }),
/* 396 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return otherLiabilityItems; });
var otherLiabilityItems=[{displayValue:"Credit cards",value:"credit_cards"},{displayValue:"Overdrafts",value:"overdrafts"},{displayValue:"Loans from your business/trust",value:"business_or_trust_loans"},{displayValue:"Personal loan",value:"personal_loan"},{displayValue:"Loan from someone else",value:"loan_from_someone_else"},{displayValue:"Maintenance",value:"maintenance"},{displayValue:"Court order (including divorce)",value:"court_order"},{displayValue:"Did you sign surety for anyone?",value:"surety_signed"}];

/***/ }),
/* 397 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return cgtAsset; });
/* unused harmony export incomeNeedAtDeath */
/* unused harmony export incomeProvisionAtDeath */
/* unused harmony export assetsDisabilityCgt */
/* unused harmony export disabilityIncomeNeed */
/* unused harmony export disabilityIncomeProvision */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fnaResult; });
function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var cgtAsset={description:"",marketValue:0.00,baseCost:0.00,capitalGain:0.00,bequethedToSpouse:0.00,residueTospouse:0.00,netGain:0.00};var incomeNeedAtDeath={need:"",dependant:"",mounhtlyAmount:0.00,seaceAge:0,anualIncrease:0.00};var incomeProvisionAtDeath={income:"",dependant:"",mounhtlyAmount:0.00,seaceAge:0,anualIncrease:0.00};var assetsDisabilityCgt={marketValue:0.00,baseCost:0.00,capitalGain:0.00};var disabilityIncomeNeed={need:"",mounhtlyAmount:0.00,seaceAge:0,anualIncrease:0.00};var disabilityIncomeProvision={income:"",mounhtlyAmount:0.00,seaceAge:0,anualIncrease:0.00};var fnaResult=function fnaResult(){_classCallCheck(this,fnaResult);this.fna={balanceSheet:{assets:[],netAssetsClient:0.00,netAssetsSpouse:0.00,policies:[],netPoliciesClient:0.00,netPoliciesSpouse:0.00,liabilities:[],netLiabilitiesClient:0.00,netLiabilitiesSpouse:0.00,netTotalAssetsClient:0.00,netTotalAssetsSpouse:0.00},executorFees:{percentageApplicable:0.00,vat:0.00,pToEstate:0.00,executorFee:0.00},cgt:{pResidence:{description:"",marketValue:0.00,baseCost:0.00,capitalGain:0.00,bequethedToSpouse:0.00,residueTospouse:0.00,spouseCapitalGain:0.00,netGain:0.00},cgtAssets:[],netCgtMarketValue:0.00,netClientsBaseCost:0.00,netClientsCapitalGain:0.00,netClientsCapitalGainDisplay:0.00,netCashBequestTospouse:0.00,netResidueTospouse:0.00,netSpouseCapitalGain:0.00,capitalGain:0.00,minuspResidence:{primaryResidenceExclusion:0.00,primaryResidence:0.00,primaryResidenceLossExclusion:0.00,primaryResidenceLoss:0.00,netExclusion:0.00},netMinusExlusion:0.00,minusspouseRollOver:{portionBequethedTospouse:0.00,portionResidueTospouse:0.00,netRollOver:0.00},netMinusRollOver:0.00,minusPreviousLoss:0.00,netMinusPreviousLoss:0.00,minusExclusionAtDeath:0.00,netMinusExlusionAtDeath:0.00,netCgt:0.00,marginalTax:0.00,inclusionRate:0.00,cgtPayable:0.00},estateDuty:{assets:{netAssets:0.00,netFarms:0.00,netDeemedAssets:0.00,netPoliciesOnLife:0.00,netPoliciesWithChash:0.00,netAccrualClaim:0.00,netEstateAssets:0.00},deductions:{netLiabilities:0.00,netAdministration:0.00,netFuneral:0.00,netMastersFee:0.00,netExectutorsFee:0.00,netCapitalGainTax:0.00,netTransferCosts:0.00,netBequethedAssets:0.00,netCashBequestTospouse:0.00,netCashBequestToCharity:0.00,netResidueTospouse:0.00,netPoliciesToSpouse:0.00,netAccrualClaim:0.00,netDeductions:0.00},netEstate:0.00,minusRebate:0.00,minusRebateFromPreviousSpouse:0.00,taxableEstate:0.00,estateDutyPayable:0.00,apportionmentOfEstate:0.00,payableByOther:0.00,payableByEstate:0.00},liquidity:{cashNeeded:{netCgt:0.00,netLiabilities:0.00,netExectutorsFee:0.00,netEstateDuty:0.00,netOtherCosts:0.00,netBequethedLiquidAssets:0.00,netCashBequests:0.00,netAccrualClaim:0.00,netCashNeeded:0.00},cashAvailable:{cash:0.00,netLiquidInvestments:0.00,netCashAssets:0.00,netPolicies:0.00,netCashAvailable:0.00},cash:0.00},accrual:{current:{valueOfAssets:{client:0.00,spouse:0.00},valueOfPolicies:0.00,minusLiabilities:{client:0.00,spouse:0.00},netValue:{client:0.00,spouse:0.00}},assetValueExcluded:{client:0.00,spouse:0.00},atMarriage:{valueANC:{client:0.00,spouse:0.00},valueCpiAdjusted:{client:0.00,spouse:0.00}},netAccrual:{client:0.00,spouse:0.00},claimAgainstSpouse:0.00,clainBySpouse:0.00},residue:{totalAssets:0.00,minus:0.00,policies:0.00,bequestsToOther:0.00,cashBequestsToOther:0.00,bequestsToSpouse:0.00,cashBequestsToSpouse:0.00,liabilities:0.00,costs:0.00,accrualClaimBySpouse:0.00,residueBeforeEstateDuty:0.00,minusEstateDuty:0.00,residue:0.00},deathProvision:{liquidity:0.00,surplusToOther:0.00,capitalNeed:0.00,netNeed:0.00,provision:{policies:0.00,cashToSpouse:0.00,capitalLiquidity:0.00},needAtDeath:[],incomeProvision:[],capitalProvisioning:[],monthsProvisioned:0},disabilityCgt:{assets:[],netAssetMarketValue:0.00,netAssetBaseCost:0.00,netAssetCapitalGain:0.00,deductions:{primaryResidence:0.00,smallBusiness:0.00,exclusion:0.00,previousCgtLoss:0.00},netCgt:0.00,marginalTax:0.00,inclusionRate:0.00,cgtPayable:0.00},disabilityLiquidity:{cashNeeded:0.00,cgt:0.00,liabilities:0.00,cashAvailable:{cash:0.00,liquidInvestments:0.00,assetstToCash:0.00,policies:0.00,cededPolicies:0.00,netCash:0.00},netCash:0.00},disabilityProvision:{surplus:0.00,capitalNeed:0.00,capitalProvision:0.00,disabilityIncomeNeed:[],disabilityIncomeProvision:[]}};};

/***/ }),
/* 398 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var assumptions={estate_duty_exemption:3500000,primary_residence_exemption:2000000,small_business_exemption:1800000,inclusion_rate_for_cgt:40,masters_fees:7000,transfer_costs:2,vat_on_executors_fees:15,estateDutyLT:20,//Estate duty < 30M rand
estateDutyGT:25,//Estate duty > 30M rand
cgtExclusionAtDeath:300000};/* harmony default export */ __webpack_exports__["a"] = (assumptions);

/***/ }),
/* 399 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_observers_mixin__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util__ = __webpack_require__(22);




var toString = {}.toString;

var OptionsStore = (function (Class) {
    function OptionsStore(options, prefix) {
        var this$1 = this;
        if ( prefix === void 0 ) prefix = "";

        Class.call(this);

        this.prefix = prefix;

        for (var field in options) {
            var member = options[field];
            member = this$1._wrap(member, field);
            this$1[field] = member;
        }
    }

    if ( Class ) OptionsStore.__proto__ = Class;
    OptionsStore.prototype = Object.create( Class && Class.prototype );
    OptionsStore.prototype.constructor = OptionsStore;

    OptionsStore.prototype.get = function get (field) {
        var parts = field.split(".");
        var result = this;

        while (parts.length && result) {
            var part = parts.shift();
            result = result[part];
        }

        return result;
    };

    OptionsStore.prototype.set = function set (field, value) {
        var current = this.get(field);

        if (current !== value) {
            this._set(field, this._wrap(value, field));
            this.optionsChange({
                field: this.prefix + field,
                value: value
            });
        }
    };

    OptionsStore.prototype._set = function _set (field, value) {
        var this$1 = this;

        var composite = field.indexOf(".") >= 0;
        var parentObj = this;
        var fieldName = field;

        if (composite) {
            var parts = fieldName.split(".");
            var prefix = this.prefix;

            while (parts.length > 1) {
                fieldName = parts.shift();
                prefix += fieldName + ".";

                var obj = parentObj[fieldName];

                if (!obj) {
                    obj = new OptionsStore({}, prefix);
                    obj.addObserver(this$1);
                    parentObj[fieldName] = obj;
                }
                parentObj = obj;
            }
            fieldName = parts[0];
        }

        parentObj._clear(fieldName);
        parentObj[fieldName] = value;
    };

    OptionsStore.prototype._clear = function _clear (field) {
        var current = this[field];
        if (current && current.removeObserver) {
            current.removeObserver(this);
        }
    };

    OptionsStore.prototype._wrap = function _wrap (object, field) {
        var type = toString.call(object);
        var wrapped = object;

        if (wrapped !== null && Object(__WEBPACK_IMPORTED_MODULE_2__util__["g" /* defined */])(wrapped) && type === "[object Object]") {
            if (!(object instanceof OptionsStore) && !(object instanceof Class)) {
                wrapped = new OptionsStore(wrapped, this.prefix + field + ".");
            }

            wrapped.addObserver(this);
        }

        return wrapped;
    };

    return OptionsStore;
}(__WEBPACK_IMPORTED_MODULE_1__common__["a" /* Class */]));

__WEBPACK_IMPORTED_MODULE_0__mixins_observers_mixin__["a" /* default */].extend(OptionsStore.prototype);

/* harmony default export */ __webpack_exports__["a"] = (OptionsStore);

/***/ }),
/* 400 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DEG_TO_RAD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return MAX_NUM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return MIN_NUM; });
var DEG_TO_RAD = Math.PI / 180;
var MAX_NUM = Number.MAX_VALUE;
var MIN_NUM = -Number.MAX_VALUE;



/***/ }),
/* 401 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__accessors_define_accessors__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_observers_mixin__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__math_close_or_less__ = __webpack_require__(2534);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__math_line_intersection__ = __webpack_require__(2535);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__math_ellipse_extreme_angles__ = __webpack_require__(648);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constants__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__point__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__rect__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__transform__ = __webpack_require__(85);














var MAX_INTERVAL = 45;
var pow = Math.pow;

var Arc = (function (Class) {
    function Arc(center, options) {
        if ( center === void 0 ) center = new __WEBPACK_IMPORTED_MODULE_8__point__["a" /* default */]();
        if ( options === void 0 ) options = {};

        Class.call(this);

        this.setCenter(center);

        this.radiusX = options.radiusX;
        this.radiusY = options.radiusY || options.radiusX;
        this.startAngle = options.startAngle;
        this.endAngle = options.endAngle;
        this.anticlockwise = options.anticlockwise || false;
        this.xRotation = options.xRotation;
    }

    if ( Class ) Arc.__proto__ = Class;
    Arc.prototype = Object.create( Class && Class.prototype );
    Arc.prototype.constructor = Arc;

    Arc.prototype.clone = function clone () {
        return new Arc(this.center, {
            radiusX: this.radiusX,
            radiusY: this.radiusY,
            startAngle: this.startAngle,
            endAngle: this.endAngle,
            anticlockwise: this.anticlockwise
        });
    };

    Arc.prototype.setCenter = function setCenter (value) {
        this._observerField("center", __WEBPACK_IMPORTED_MODULE_8__point__["a" /* default */].create(value));
        this.geometryChange();
        return this;
    };

    Arc.prototype.getCenter = function getCenter () {
        return this.center;
    };

    Arc.prototype.pointAt = function pointAt (angle) {
        var center = this.center;
        var radian = Object(__WEBPACK_IMPORTED_MODULE_3__util__["v" /* rad */])(angle);

        return new __WEBPACK_IMPORTED_MODULE_8__point__["a" /* default */](
            center.x + this.radiusX * Math.cos(radian),
            center.y + this.radiusY * Math.sin(radian)
        );
    };

    Arc.prototype.curvePoints = function curvePoints () {
        var this$1 = this;

        var startAngle = this.startAngle;
        var dir = this.anticlockwise ? -1 : 1;
        var curvePoints = [ this.pointAt(startAngle) ];
        var interval = this._arcInterval();
        var intervalAngle = interval.endAngle - interval.startAngle;
        var subIntervalsCount = Math.ceil(intervalAngle / MAX_INTERVAL);
        var subIntervalAngle = intervalAngle / subIntervalsCount;
        var currentAngle = startAngle;
        var transformation;
        if (this.xRotation) {
            transformation = Object(__WEBPACK_IMPORTED_MODULE_10__transform__["a" /* default */])().rotate(this.xRotation, this.center);
        }

        for (var i = 1; i <= subIntervalsCount; i++) {
            var nextAngle = currentAngle + dir * subIntervalAngle;
            var points = this$1._intervalCurvePoints(currentAngle, nextAngle, transformation);

            curvePoints.push(points.cp1, points.cp2, points.p2);
            currentAngle = nextAngle;
        }

        return curvePoints;
    };

    Arc.prototype.bbox = function bbox (matrix) {
        var this$1 = this;

        var interval = this._arcInterval();
        var startAngle = interval.startAngle;
        var endAngle = interval.endAngle;
        var extremeAngles = Object(__WEBPACK_IMPORTED_MODULE_6__math_ellipse_extreme_angles__["a" /* default */])(this.center, this.radiusX, this.radiusY, matrix);
        var extremeX = Object(__WEBPACK_IMPORTED_MODULE_3__util__["i" /* deg */])(extremeAngles.x);
        var extremeY = Object(__WEBPACK_IMPORTED_MODULE_3__util__["i" /* deg */])(extremeAngles.y);
        var endPoint = this.pointAt(endAngle).transformCopy(matrix);
        var currentAngleX = bboxStartAngle(extremeX, startAngle);
        var currentAngleY = bboxStartAngle(extremeY, startAngle);
        var currentPoint = this.pointAt(startAngle).transformCopy(matrix);
        var minPoint = __WEBPACK_IMPORTED_MODULE_8__point__["a" /* default */].min(currentPoint, endPoint);
        var maxPoint = __WEBPACK_IMPORTED_MODULE_8__point__["a" /* default */].max(currentPoint, endPoint);

        while (currentAngleX < endAngle || currentAngleY < endAngle) {
            var currentPointX = (void 0);
            if (currentAngleX < endAngle) {
                currentPointX = this$1.pointAt(currentAngleX).transformCopy(matrix);
                currentAngleX += 90;
            }

            var currentPointY = (void 0);
            if (currentAngleY < endAngle) {
                currentPointY = this$1.pointAt(currentAngleY).transformCopy(matrix);
                currentAngleY += 90;
            }

            currentPoint = new __WEBPACK_IMPORTED_MODULE_8__point__["a" /* default */](currentPointX.x, currentPointY.y);
            minPoint = __WEBPACK_IMPORTED_MODULE_8__point__["a" /* default */].min(minPoint, currentPoint);
            maxPoint = __WEBPACK_IMPORTED_MODULE_8__point__["a" /* default */].max(maxPoint, currentPoint);
        }

        return __WEBPACK_IMPORTED_MODULE_9__rect__["a" /* default */].fromPoints(minPoint, maxPoint);
    };

    Arc.prototype._arcInterval = function _arcInterval () {
        var ref = this;
        var startAngle = ref.startAngle;
        var endAngle = ref.endAngle;
        var anticlockwise = ref.anticlockwise;

        if (anticlockwise) {
            var oldStart = startAngle;
            startAngle = endAngle;
            endAngle = oldStart;
        }

        if (startAngle > endAngle || (anticlockwise && startAngle === endAngle)) {
            endAngle += 360;
        }

        return {
            startAngle: startAngle,
            endAngle: endAngle
        };
    };

    Arc.prototype._intervalCurvePoints = function _intervalCurvePoints (startAngle, endAngle, transformation) {
        var p1 = this.pointAt(startAngle);
        var p2 = this.pointAt(endAngle);
        var p1Derivative = this._derivativeAt(startAngle);
        var p2Derivative = this._derivativeAt(endAngle);
        var t = (Object(__WEBPACK_IMPORTED_MODULE_3__util__["v" /* rad */])(endAngle) - Object(__WEBPACK_IMPORTED_MODULE_3__util__["v" /* rad */])(startAngle)) / 3;
        var cp1 = new __WEBPACK_IMPORTED_MODULE_8__point__["a" /* default */](p1.x + t * p1Derivative.x, p1.y + t * p1Derivative.y);
        var cp2 = new __WEBPACK_IMPORTED_MODULE_8__point__["a" /* default */](p2.x - t * p2Derivative.x, p2.y - t * p2Derivative.y);
        if (transformation) {
            p1.transform(transformation);
            p2.transform(transformation);
            cp1.transform(transformation);
            cp2.transform(transformation);
        }

        return {
            p1: p1,
            cp1: cp1,
            cp2: cp2,
            p2: p2
        };
    };

    Arc.prototype._derivativeAt = function _derivativeAt (angle) {
        var radian = Object(__WEBPACK_IMPORTED_MODULE_3__util__["v" /* rad */])(angle);

        return new __WEBPACK_IMPORTED_MODULE_8__point__["a" /* default */](-this.radiusX * Math.sin(radian), this.radiusY * Math.cos(radian));
    };

    Arc.prototype.containsPoint = function containsPoint (point) {
        var interval = this._arcInterval();
        var intervalAngle = interval.endAngle - interval.startAngle;
        var ref = this;
        var center = ref.center;
        var radiusX = ref.radiusX;
        var radiusY = ref.radiusY;
        var distance = center.distanceTo(point);
        var angleRad = Math.atan2(point.y - center.y, point.x - center.x);
        var pointRadius = (radiusX * radiusY) /
            Math.sqrt(pow(radiusX, 2) * pow(Math.sin(angleRad), 2) + pow(radiusY, 2) * pow(Math.cos(angleRad), 2));
        var startPoint = this.pointAt(this.startAngle).round(__WEBPACK_IMPORTED_MODULE_7__constants__["a" /* PRECISION */]);
        var endPoint = this.pointAt(this.endAngle).round(__WEBPACK_IMPORTED_MODULE_7__constants__["a" /* PRECISION */]);
        var intersection = Object(__WEBPACK_IMPORTED_MODULE_5__math_line_intersection__["a" /* default */])(center, point.round(__WEBPACK_IMPORTED_MODULE_7__constants__["a" /* PRECISION */]), startPoint, endPoint);
        var containsPoint;

        if (intervalAngle < 180) {
            containsPoint = intersection && Object(__WEBPACK_IMPORTED_MODULE_4__math_close_or_less__["a" /* default */])(center.distanceTo(intersection), distance) && Object(__WEBPACK_IMPORTED_MODULE_4__math_close_or_less__["a" /* default */])(distance, pointRadius);
        } else {
            var angle = calculateAngle(center.x, center.y, radiusX, radiusY, point.x, point.y);
            if (angle !== 360) {
                angle = (360 + angle) % 360;
            }

            var inAngleRange = interval.startAngle <= angle && angle <= interval.endAngle;
            containsPoint = (inAngleRange && Object(__WEBPACK_IMPORTED_MODULE_4__math_close_or_less__["a" /* default */])(distance, pointRadius)) || (!inAngleRange && (!intersection || intersection.equals(point)));
        }
        return containsPoint;
    };

    Arc.prototype._isOnPath = function _isOnPath (point, width) {
        var interval = this._arcInterval();
        var center = this.center;
        var angle = calculateAngle(center.x, center.y, this.radiusX, this.radiusY, point.x, point.y);
        if (angle !== 360) {
            angle = (360 + angle) % 360;
        }

        var inAngleRange = interval.startAngle <= angle && angle <= interval.endAngle;

        return inAngleRange && this.pointAt(angle).distanceTo(point) <= width;
    };

    Arc.fromPoints = function fromPoints (start, end, rx, ry, largeArc, swipe, rotation) {// eslint-disable-line max-params
        var arcParameters = normalizeArcParameters({
            x1: start.x,
            y1: start.y,
            x2: end.x,
            y2: end.y,
            rx: rx,
            ry: ry,
            largeArc: largeArc,
            swipe: swipe,
            rotation: rotation
        });

        return new Arc(arcParameters.center, {
            startAngle: arcParameters.startAngle,
            endAngle: arcParameters.endAngle,
            radiusX: arcParameters.radiusX,
            radiusY: arcParameters.radiusY,
            xRotation: arcParameters.xRotation,
            anticlockwise: swipe === 0
        });
    };

    return Arc;
}(__WEBPACK_IMPORTED_MODULE_2__common__["a" /* Class */]));

Object(__WEBPACK_IMPORTED_MODULE_0__accessors_define_accessors__["a" /* default */])(Arc.prototype, [ "radiusX", "radiusY", "startAngle", "endAngle", "anticlockwise" ]);
__WEBPACK_IMPORTED_MODULE_1__mixins_observers_mixin__["a" /* default */].extend(Arc.prototype);

function calculateAngle(cx, cy, rx, ry, x, y) {
    var cos = Object(__WEBPACK_IMPORTED_MODULE_3__util__["w" /* round */])((x - cx) / rx, 3);
    var sin = Object(__WEBPACK_IMPORTED_MODULE_3__util__["w" /* round */])((y - cy) / ry, 3);

    return Object(__WEBPACK_IMPORTED_MODULE_3__util__["w" /* round */])(Object(__WEBPACK_IMPORTED_MODULE_3__util__["i" /* deg */])(Math.atan2(sin, cos)));
}

function normalizeArcParameters(parameters) {
    var x1 = parameters.x1;
    var y1 = parameters.y1;
    var x2 = parameters.x2;
    var y2 = parameters.y2;
    var rx = parameters.rx;
    var ry = parameters.ry;
    var largeArc = parameters.largeArc;
    var swipe = parameters.swipe;
    var rotation = parameters.rotation; if ( rotation === void 0 ) rotation = 0;

    var radians = Object(__WEBPACK_IMPORTED_MODULE_3__util__["v" /* rad */])(rotation);
    var cosine = Math.cos(radians);
    var sine = Math.sin(radians);

    var xT = cosine * (x1 - x2) / 2 + sine * (y1 - y2) / 2;
    var yT = -sine * (x1 - x2) / 2 + cosine * (y1 - y2) / 2;

    var sign = largeArc !== swipe ? 1 : -1;

    var xt2 = Math.pow(xT, 2);
    var yt2 = Math.pow(yT, 2);
    var rx2 = Math.pow(rx, 2);
    var ry2 = Math.pow(ry, 2);

    var delta = xt2 / rx2 + yt2 / ry2;

    if (delta > 1) {
        delta = Math.sqrt(xt2 / rx2 + yt2 / ry2);
        rx = delta * rx;
        rx2 = Math.pow(rx, 2);

        ry = delta * ry;
        ry2 = Math.pow(ry, 2);
    }

    var constT = sign * Math.sqrt((rx2 * ry2 - rx2 * yt2 - ry2 * xt2) / (rx2 * yt2 + ry2 * xt2));
    // due to rounding errors the value could become NaN even after radii correction
    if (isNaN(constT)) {
        constT = 0;
    }

    var cxT = constT * (rx * yT) / ry;
    var cyT = - constT * (ry * xT) / rx;

    var cx = cosine * cxT - sine * cyT + (x1 + x2) / 2;
    var cy = sine * cxT + cosine * cyT + (y1 + y2) / 2;


    var uX = (xT - cxT) / rx;
    var uY = (yT - cyT) / ry;
    var vX = -(xT + cxT) / rx;
    var vY = -(yT + cyT) / ry;

    var startAngle = (uY >= 0 ? 1 : -1) * Object(__WEBPACK_IMPORTED_MODULE_3__util__["i" /* deg */])(Math.acos(uX / Math.sqrt(uX * uX + uY * uY)));

    var angleCosine = Object(__WEBPACK_IMPORTED_MODULE_3__util__["w" /* round */])((uX * vX + uY * vY) / (Math.sqrt(uX * uX + uY * uY) * Math.sqrt(vX * vX + vY * vY)), 10);
    var angle = (uX * vY - uY * vX >= 0 ? 1 : -1) * Object(__WEBPACK_IMPORTED_MODULE_3__util__["i" /* deg */])(Math.acos(angleCosine));

    if (!swipe && angle > 0) {
        angle -= 360;
    }

    if (swipe && angle < 0) {
        angle += 360;
    }
    var endAngle = startAngle + angle;
    var signEndAngle = endAngle >= 0 ? 1 : -1;
    endAngle = (Math.abs(endAngle) % 360) * signEndAngle;

    return {
        center: new __WEBPACK_IMPORTED_MODULE_8__point__["a" /* default */](cx, cy),
        startAngle: startAngle,
        endAngle: endAngle,
        radiusX: rx,
        radiusY: ry,
        xRotation: rotation
    };
}

function bboxStartAngle(angle, start) {
    var startAngle = angle;

    while (startAngle < start) {
        startAngle += 90;
    }

    return startAngle;
}

/* harmony default export */ __webpack_exports__["a"] = (Arc);


/***/ }),
/* 402 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__geometry_elements_array__ = __webpack_require__(650);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__element__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_paintable__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_measurable__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__geometry_arc__ = __webpack_require__(401);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__geometry_rect__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__geometry_segment__ = __webpack_require__(652);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__geometry_point__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__geometry_size__ = __webpack_require__(276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__geometry_math_line_intersections_count__ = __webpack_require__(655);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__parsing_path_parser__ = __webpack_require__(656);













var Path = (function (Element) {
    function Path(options) {
        Element.call(this, options);
        this.segments = new __WEBPACK_IMPORTED_MODULE_0__geometry_elements_array__["a" /* default */]();
        this.segments.addObserver(this);

        if (!Object(__WEBPACK_IMPORTED_MODULE_10__util__["g" /* defined */])(this.options.stroke)) {
            this.stroke("#000");

            if (!Object(__WEBPACK_IMPORTED_MODULE_10__util__["g" /* defined */])(this.options.stroke.lineJoin)) {
                this.options.set("stroke.lineJoin", "miter");
            }
        }
    }

    if ( Element ) Path.__proto__ = Element;
    Path.prototype = Object.create( Element && Element.prototype );
    Path.prototype.constructor = Path;

    Path.prototype.moveTo = function moveTo (x, y) {
        this.suspend();
        this.segments.elements([]);
        this.resume();

        this.lineTo(x, y);

        return this;
    };

    Path.prototype.lineTo = function lineTo (x, y) {
        var point = Object(__WEBPACK_IMPORTED_MODULE_10__util__["g" /* defined */])(y) ? new __WEBPACK_IMPORTED_MODULE_7__geometry_point__["a" /* default */](x, y) : x;
        var segment = new __WEBPACK_IMPORTED_MODULE_6__geometry_segment__["a" /* default */](point);

        this.segments.push(segment);

        return this;
    };

    Path.prototype.curveTo = function curveTo (controlOut, controlIn, point) {
        if (this.segments.length > 0) {
            var lastSegment = Object(__WEBPACK_IMPORTED_MODULE_10__util__["q" /* last */])(this.segments);
            var segment = new __WEBPACK_IMPORTED_MODULE_6__geometry_segment__["a" /* default */](point, controlIn);
            this.suspend();
            lastSegment.controlOut(controlOut);
            this.resume();

            this.segments.push(segment);
        }

        return this;
    };

    Path.prototype.arc = function arc (startAngle, endAngle, radiusX, radiusY, anticlockwise) {
        if (this.segments.length > 0) {
            var lastSegment = Object(__WEBPACK_IMPORTED_MODULE_10__util__["q" /* last */])(this.segments);
            var anchor = lastSegment.anchor();
            var start = Object(__WEBPACK_IMPORTED_MODULE_10__util__["v" /* rad */])(startAngle);
            var center = new __WEBPACK_IMPORTED_MODULE_7__geometry_point__["a" /* default */](anchor.x - radiusX * Math.cos(start),
                anchor.y - radiusY * Math.sin(start));
            var arc = new __WEBPACK_IMPORTED_MODULE_4__geometry_arc__["a" /* default */](center, {
                startAngle: startAngle,
                endAngle: endAngle,
                radiusX: radiusX,
                radiusY: radiusY,
                anticlockwise: anticlockwise
            });

            this._addArcSegments(arc);
        }

        return this;
    };

    Path.prototype.arcTo = function arcTo (end, rx, ry, largeArc, swipe, rotation) {
        if (this.segments.length > 0) {
            var lastSegment = Object(__WEBPACK_IMPORTED_MODULE_10__util__["q" /* last */])(this.segments);
            var anchor = lastSegment.anchor();
            var arc = __WEBPACK_IMPORTED_MODULE_4__geometry_arc__["a" /* default */].fromPoints(anchor, end, rx, ry, largeArc, swipe, rotation);

            this._addArcSegments(arc);
        }
        return this;
    };

    Path.prototype._addArcSegments = function _addArcSegments (arc) {
        var this$1 = this;

        this.suspend();

        var curvePoints = arc.curvePoints();

        for (var i = 1; i < curvePoints.length; i += 3) {
            this$1.curveTo(curvePoints[i], curvePoints[i + 1], curvePoints[i + 2]);
        }

        this.resume();
        this.geometryChange();
    };

    Path.prototype.close = function close () {
        this.options.closed = true;
        this.geometryChange();

        return this;
    };

    Path.prototype.rawBBox = function rawBBox () {
        return this._bbox();
    };

    Path.prototype._containsPoint = function _containsPoint (point) {
        var segments = this.segments;
        var length = segments.length;
        var intersectionsCount = 0;
        var previous, current;

        for (var idx = 1; idx < length; idx++) {
            previous = segments[idx - 1];
            current = segments[idx];
            intersectionsCount += previous._intersectionsTo(current, point);
        }

        if (this.options.closed || !segments[0].anchor().equals(segments[length - 1].anchor())) {
            intersectionsCount += Object(__WEBPACK_IMPORTED_MODULE_9__geometry_math_line_intersections_count__["a" /* default */])(segments[0].anchor(), segments[length - 1].anchor(), point);
        }

        return intersectionsCount % 2 !== 0;
    };

    Path.prototype._isOnPath = function _isOnPath (point, width) {
        var segments = this.segments;
        var length = segments.length;
        var pathWidth = width || this.options.stroke.width;

        if (length > 1) {
            if (segments[0]._isOnPathTo(segments[1], point, pathWidth, "start")) {
                return true;
            }

            for (var idx = 2; idx <= length - 2; idx++) {
                if (segments[idx - 1]._isOnPathTo(segments[idx], point, pathWidth)) {
                    return true;
                }
            }

            if (segments[length - 2]._isOnPathTo(segments[length - 1], point, pathWidth, "end")) {
                return true;
            }
        }
        return false;
    };

    Path.prototype._bbox = function _bbox (matrix) {
        var segments = this.segments;
        var length = segments.length;
        var boundingBox;

        if (length === 1) {
            var anchor = segments[0].anchor().transformCopy(matrix);
            boundingBox = new __WEBPACK_IMPORTED_MODULE_5__geometry_rect__["a" /* default */](anchor, __WEBPACK_IMPORTED_MODULE_8__geometry_size__["a" /* default */].ZERO);
        } else if (length > 0) {
            for (var i = 1; i < length; i++) {
                var segmentBox = segments[i - 1].bboxTo(segments[i], matrix);
                if (boundingBox) {
                    boundingBox = __WEBPACK_IMPORTED_MODULE_5__geometry_rect__["a" /* default */].union(boundingBox, segmentBox);
                } else {
                    boundingBox = segmentBox;
                }
            }
        }

        return boundingBox;
    };

    Path.fromRect = function fromRect (rect, options) {
        return new Path(options)
            .moveTo(rect.topLeft())
            .lineTo(rect.topRight())
            .lineTo(rect.bottomRight())
            .lineTo(rect.bottomLeft())
            .close();
    };

    Path.fromPoints = function fromPoints (points, options) {
        if (points) {
            var path = new Path(options);

            for (var i = 0; i < points.length; i++) {
                var point = __WEBPACK_IMPORTED_MODULE_7__geometry_point__["a" /* default */].create(points[i]);
                if (point) {
                    if (i === 0) {
                        path.moveTo(point);
                    } else {
                        path.lineTo(point);
                    }
                }
            }

            return path;
        }
    };

    Path.fromArc = function fromArc (arc, options) {
        var path = new Path(options);
        var startAngle = arc.startAngle;
        var start = arc.pointAt(startAngle);
        path.moveTo(start.x, start.y);
        path.arc(startAngle, arc.endAngle, arc.radiusX, arc.radiusY, arc.anticlockwise);
        return path;
    };

    return Path;
}(__WEBPACK_IMPORTED_MODULE_1__element__["a" /* default */]));

Path.prototype.nodeType = "Path";

__WEBPACK_IMPORTED_MODULE_2__mixins_paintable__["a" /* default */].extend(Path.prototype);
__WEBPACK_IMPORTED_MODULE_3__mixins_measurable__["a" /* default */].extend(Path.prototype);

Path.parse = function(str, options) {
    return __WEBPACK_IMPORTED_MODULE_11__parsing_path_parser__["a" /* default */].current.parse(str, options);
};

/* harmony default export */ __webpack_exports__["a"] = (Path);


/***/ }),
/* 403 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = calculateCurveAt;
function calculateCurveAt(t, field, points) {
    var t1 = 1 - t;
    return Math.pow(t1, 3) * points[0][field] +
        3 * Math.pow(t1, 2) * t * points[1][field] +
        3 * Math.pow(t, 2) * t1 * points[2][field] +
        Math.pow(t, 3) * points[3][field];
}

/***/ }),
/* 404 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

var Traversable = {
    extend: function(proto, childrenField) {
        proto.traverse = function(callback) {
            var children = this[childrenField];

            for (var i = 0; i < children.length; i++) {
                var child = children[i];

                if (child.traverse) {
                    child.traverse(callback);
                } else {
                    callback(child);
                }
            }

            return this;
        };
    }
};

/* harmony default export */ __webpack_exports__["a"] = (Traversable);

/***/ }),
/* 405 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = stackElements;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__geometry_point__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__translate_to_point__ = __webpack_require__(280);



function stackElements(elements, stackAxis, otherAxis, sizeField) {
    if (elements.length > 1) {
        var origin = new __WEBPACK_IMPORTED_MODULE_0__geometry_point__["a" /* default */]();
        var previousBBox = elements[0].bbox;

        for (var idx = 1; idx < elements.length; idx++) {
            var element = elements[idx].element;
            var bbox = elements[idx].bbox;
            origin[stackAxis] = previousBBox.origin[stackAxis] + previousBBox.size[sizeField];
            origin[otherAxis] = bbox.origin[otherAxis];
            Object(__WEBPACK_IMPORTED_MODULE_1__translate_to_point__["a" /* default */])(origin, bbox, element);
            bbox.origin[stackAxis] = origin[stackAxis];
            previousBBox = bbox;
        }
    }
}

/***/ }),
/* 406 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__accessors_define_point_accessors__ = __webpack_require__(279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__geometry_point__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__gradient__ = __webpack_require__(407);




var LinearGradient = (function (Gradient) {
    function LinearGradient(options) {
        if ( options === void 0 ) options = {};

        Gradient.call(this, options);

        this.start(options.start || new __WEBPACK_IMPORTED_MODULE_1__geometry_point__["a" /* default */]());

        this.end(options.end || new __WEBPACK_IMPORTED_MODULE_1__geometry_point__["a" /* default */](1, 0));
    }

    if ( Gradient ) LinearGradient.__proto__ = Gradient;
    LinearGradient.prototype = Object.create( Gradient && Gradient.prototype );
    LinearGradient.prototype.constructor = LinearGradient;

    return LinearGradient;
}(__WEBPACK_IMPORTED_MODULE_2__gradient__["a" /* default */]));

Object(__WEBPACK_IMPORTED_MODULE_0__accessors_define_point_accessors__["a" /* default */])(LinearGradient.prototype, [ "start", "end" ]);

/* harmony default export */ __webpack_exports__["a"] = (LinearGradient);

/***/ }),
/* 407 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_observers_mixin__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__stops_array__ = __webpack_require__(2555);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__gradient_stop__ = __webpack_require__(664);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util__ = __webpack_require__(22);






var Gradient = (function (Class) {
    function Gradient(options) {
        if ( options === void 0 ) options = {};

        Class.call(this);

        this.stops = new __WEBPACK_IMPORTED_MODULE_1__stops_array__["a" /* default */](this._createStops(options.stops));
        this.stops.addObserver(this);
        this._userSpace = options.userSpace;
        this.id = Object(__WEBPACK_IMPORTED_MODULE_4__util__["h" /* definitionId */])();
    }

    if ( Class ) Gradient.__proto__ = Class;
    Gradient.prototype = Object.create( Class && Class.prototype );
    Gradient.prototype.constructor = Gradient;

    Gradient.prototype.userSpace = function userSpace (value) {
        if (Object(__WEBPACK_IMPORTED_MODULE_4__util__["g" /* defined */])(value)) {
            this._userSpace = value;
            this.optionsChange();
            return this;
        }

        return this._userSpace;
    };

    Gradient.prototype._createStops = function _createStops (stops) {
        if ( stops === void 0 ) stops = [];

        var result = [];
        for (var idx = 0; idx < stops.length; idx++) {
            result.push(__WEBPACK_IMPORTED_MODULE_2__gradient_stop__["a" /* default */].create(stops[idx]));
        }

        return result;
    };

    Gradient.prototype.addStop = function addStop (offset, color, opacity) {
        this.stops.push(new __WEBPACK_IMPORTED_MODULE_2__gradient_stop__["a" /* default */](offset, color, opacity));
    };

    Gradient.prototype.removeStop = function removeStop (stop) {
        var index = this.stops.indexOf(stop);
        if (index >= 0) {
            this.stops.splice(index, 1);
        }
    };

    return Gradient;
}(__WEBPACK_IMPORTED_MODULE_3__common__["a" /* Class */]));

Gradient.prototype.nodeType = "Gradient";

__WEBPACK_IMPORTED_MODULE_0__mixins_observers_mixin__["a" /* default */].extend(Gradient.prototype);

Object.assign(Gradient.prototype, {
    optionsChange: function(e) {
        this.trigger("optionsChange", {
            field: "gradient" + (e ? "." + e.field : ""),
            value: this
        });
    },

    geometryChange: function() {
        this.optionsChange();
    }
});

/* harmony default export */ __webpack_exports__["a"] = (Gradient);

/***/ }),
/* 408 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__accessors_define_point_accessors__ = __webpack_require__(279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__geometry_point__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__gradient__ = __webpack_require__(407);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util__ = __webpack_require__(22);





var RadialGradient = (function (Gradient) {
    function RadialGradient(options) {
        if ( options === void 0 ) options = {};

        Gradient.call(this, options);

        this.center(options.center || new __WEBPACK_IMPORTED_MODULE_1__geometry_point__["a" /* default */]());
        this._radius = Object(__WEBPACK_IMPORTED_MODULE_3__util__["g" /* defined */])(options.radius) ? options.radius : 1;
        this._fallbackFill = options.fallbackFill;
    }

    if ( Gradient ) RadialGradient.__proto__ = Gradient;
    RadialGradient.prototype = Object.create( Gradient && Gradient.prototype );
    RadialGradient.prototype.constructor = RadialGradient;

    RadialGradient.prototype.radius = function radius (value) {
        if (Object(__WEBPACK_IMPORTED_MODULE_3__util__["g" /* defined */])(value)) {
            this._radius = value;
            this.geometryChange();
            return this;
        }

        return this._radius;
    };

    RadialGradient.prototype.fallbackFill = function fallbackFill (value) {
        if (Object(__WEBPACK_IMPORTED_MODULE_3__util__["g" /* defined */])(value)) {
            this._fallbackFill = value;
            this.optionsChange();
            return this;
        }

        return this._fallbackFill;
    };

    return RadialGradient;
}(__WEBPACK_IMPORTED_MODULE_2__gradient__["a" /* default */]));

Object(__WEBPACK_IMPORTED_MODULE_0__accessors_define_point_accessors__["a" /* default */])(RadialGradient.prototype, [ "center" ]);

/* harmony default export */ __webpack_exports__["a"] = (RadialGradient);

/***/ }),
/* 409 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shapes_group__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__geometry_point__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__surface_factory__ = __webpack_require__(281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util__ = __webpack_require__(22);






var events = [
    "click",
    "mouseenter",
    "mouseleave",
    "mousemove",
    "resize"
];

var Surface = (function (Observable) {
    function Surface(element, options) {
        Observable.call(this);

        this.options = Object.assign({}, options);
        this.element = element;
        this.element._kendoExportVisual = this.exportVisual.bind(this);

        this._click = this._handler("click");
        this._mouseenter = this._handler("mouseenter");
        this._mouseleave = this._handler("mouseleave");
        this._mousemove = this._handler("mousemove");

        this._visual = new __WEBPACK_IMPORTED_MODULE_0__shapes_group__["a" /* default */]();

        Object(__WEBPACK_IMPORTED_MODULE_4__util__["k" /* elementSize */])(element, this.options);

        this.bind(events, this.options);

        this._enableTracking();
    }

    if ( Observable ) Surface.__proto__ = Observable;
    Surface.prototype = Object.create( Observable && Observable.prototype );
    Surface.prototype.constructor = Surface;

    Surface.prototype.draw = function draw (element) {
        this._visual.children.push(element);
    };

    Surface.prototype.clear = function clear () {
        this._visual.children = [];
    };

    Surface.prototype.destroy = function destroy () {
        this._visual = null;
        this.element._kendoExportVisual = null;
        this.unbind();
    };

    Surface.prototype.eventTarget = function eventTarget (e) {
        var this$1 = this;

        var domNode = Object(__WEBPACK_IMPORTED_MODULE_4__util__["o" /* eventElement */])(e);
        var node;

        while (!node && domNode) {
            node = domNode._kendoNode;
            if (domNode === this$1.element) {
                break;
            }

            domNode = domNode.parentElement;
        }

        if (node) {
            return node.srcElement;
        }
    };

    Surface.prototype.exportVisual = function exportVisual () {
        return this._visual;
    };

    Surface.prototype.getSize = function getSize () {
        return Object(__WEBPACK_IMPORTED_MODULE_4__util__["k" /* elementSize */])(this.element);
    };

    Surface.prototype.currentSize = function currentSize (size) {
        if (size) {
            this._size = size;
        } else {
            return this._size;
        }
    };

    Surface.prototype.setSize = function setSize (size) {
        Object(__WEBPACK_IMPORTED_MODULE_4__util__["k" /* elementSize */])(this.element, size);

        this.currentSize(size);
        this._resize();
    };

    Surface.prototype.resize = function resize (force) {
        var size = this.getSize();
        var currentSize = this.currentSize();

        if (force || (size.width > 0 || size.height > 0) && (!currentSize || size.width !== currentSize.width || size.height !== currentSize.height)) {
            this.currentSize(size);
            this._resize(size, force);
            this.trigger("resize", size);
        }
    };

    Surface.prototype.size = function size (value) {
        if (!value) {
            return this.getSize();
        }

        this.setSize(value);
    };

    Surface.prototype.suspendTracking = function suspendTracking () {
        this._suspendedTracking = true;
    };

    Surface.prototype.resumeTracking = function resumeTracking () {
        this._suspendedTracking = false;
    };

    Surface.prototype._enableTracking = function _enableTracking () {};

    Surface.prototype._resize = function _resize () {};

    Surface.prototype._handler = function _handler (eventName) {
        var this$1 = this;

        return function (e) {
            var node = this$1.eventTarget(e);
            if (node && !this$1._suspendedTracking) {
                this$1.trigger(eventName, {
                    element: node,
                    originalEvent: e,
                    type: eventName
                });
            }
        };
    };

    Surface.prototype._elementOffset = function _elementOffset () {
        var element = this.element;
        var ref = Object(__WEBPACK_IMPORTED_MODULE_4__util__["l" /* elementStyles */])(element, [ "paddingLeft", "paddingTop" ]);
        var paddingLeft = ref.paddingLeft;
        var paddingTop = ref.paddingTop;
        var ref$1 = Object(__WEBPACK_IMPORTED_MODULE_4__util__["j" /* elementOffset */])(element);
        var left = ref$1.left;
        var top = ref$1.top;

        return {
            left: left + parseInt(paddingLeft, 10),
            top: top + parseInt(paddingTop, 10)
        };
    };

    Surface.prototype._surfacePoint = function _surfacePoint (e) {
        var offset = this._elementOffset();
        var coord = Object(__WEBPACK_IMPORTED_MODULE_4__util__["n" /* eventCoordinates */])(e);
        var x = coord.x - offset.left;
        var y = coord.y - offset.top;

        return new __WEBPACK_IMPORTED_MODULE_1__geometry_point__["a" /* default */](x, y);
    };

    return Surface;
}(__WEBPACK_IMPORTED_MODULE_3__common__["b" /* Observable */]));

Surface.create = function(element, options) {
    return __WEBPACK_IMPORTED_MODULE_2__surface_factory__["a" /* default */].current.create(element, options);
};

Surface.support = {};

/* harmony default export */ __webpack_exports__["a"] = (Surface);


/***/ }),
/* 410 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_base_node__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__definition_node__ = __webpack_require__(668);




var RootNode = (function (Node) {
    function RootNode(options) {
        Node.call(this);
        this.options = options;
        this.defs = new __WEBPACK_IMPORTED_MODULE_2__definition_node__["a" /* default */]();
    }

    if ( Node ) RootNode.__proto__ = Node;
    RootNode.prototype = Object.create( Node && Node.prototype );
    RootNode.prototype.constructor = RootNode;

    RootNode.prototype.attachTo = function attachTo (domElement) {
        this.element = domElement;
        this.defs.attachTo(domElement.firstElementChild);
    };

    RootNode.prototype.clear = function clear () {
        __WEBPACK_IMPORTED_MODULE_0__core_base_node__["a" /* default */].prototype.clear.call(this);
    };

    RootNode.prototype.template = function template () {
        return this.defs.render() + this.renderChildren();
    };

    RootNode.prototype.definitionChange = function definitionChange (e) {
        this.defs.definitionChange(e);
    };

    return RootNode;
}(__WEBPACK_IMPORTED_MODULE_1__node__["a" /* default */]));

/* harmony default export */ __webpack_exports__["a"] = (RootNode);

/***/ }),
/* 411 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_base_node__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_map__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_render_path__ = __webpack_require__(283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util__ = __webpack_require__(22);





var Node = (function (BaseNode) {
    function Node(srcElement) {
        BaseNode.call(this, srcElement);
        if (srcElement) {
            this.initClip();
        }
    }

    if ( BaseNode ) Node.__proto__ = BaseNode;
    Node.prototype = Object.create( BaseNode && BaseNode.prototype );
    Node.prototype.constructor = Node;

    Node.prototype.initClip = function initClip () {
        var clip = this.srcElement.clip();
        if (clip) {
            this.clip = clip;
            clip.addObserver(this);
        }
    };

    Node.prototype.clear = function clear () {
        if (this.srcElement) {
            this.srcElement.removeObserver(this);
        }

        this.clearClip();

        BaseNode.prototype.clear.call(this);
    };

    Node.prototype.clearClip = function clearClip () {
        if (this.clip) {
            this.clip.removeObserver(this);
            delete this.clip;
        }
    };

    Node.prototype.setClip = function setClip (ctx) {
        if (this.clip) {
            ctx.beginPath();
            Object(__WEBPACK_IMPORTED_MODULE_2__utils_render_path__["a" /* default */])(ctx, this.clip);
            ctx.clip();
        }
    };

    Node.prototype.optionsChange = function optionsChange (e) {
        if (e.field === "clip") {
            this.clearClip();
            this.initClip();
        }

        BaseNode.prototype.optionsChange.call(this, e);
    };

    Node.prototype.setTransform = function setTransform (ctx) {
        if (this.srcElement) {
            var transform = this.srcElement.transform();
            if (transform) {
                ctx.transform.apply(ctx, transform.matrix().toArray(6));
            }
        }
    };

    Node.prototype.loadElements = function loadElements (elements, pos, cors) {
        var this$1 = this;

        for (var i = 0; i < elements.length; i++) {
            var srcElement = elements[i];
            var children = srcElement.children;

            var childNode = new __WEBPACK_IMPORTED_MODULE_1__node_map__["a" /* default */][srcElement.nodeType](srcElement, cors);

            if (children && children.length > 0) {
                childNode.load(children, pos, cors);
            }

            if (Object(__WEBPACK_IMPORTED_MODULE_3__util__["g" /* defined */])(pos)) {
                this$1.insertAt(childNode, pos);
            } else {
                this$1.append(childNode);
            }
        }
    };

    Node.prototype.load = function load (elements, pos, cors) {
        this.loadElements(elements, pos, cors);

        this.invalidate();
    };

    Node.prototype.setOpacity = function setOpacity (ctx) {
        if (this.srcElement) {
            var opacity = this.srcElement.opacity();
            if (Object(__WEBPACK_IMPORTED_MODULE_3__util__["g" /* defined */])(opacity)) {
                this.globalAlpha(ctx, opacity);
            }
        }
    };

    Node.prototype.globalAlpha = function globalAlpha (ctx, value) {
        var opactity = value;
        if (opactity && ctx.globalAlpha) {
            opactity *= ctx.globalAlpha;
        }
        ctx.globalAlpha = opactity;
    };

    Node.prototype.visible = function visible () {
        var src = this.srcElement;
        return !src || (src && src.options.visible !== false);
    };

    return Node;
}(__WEBPACK_IMPORTED_MODULE_0__core_base_node__["a" /* default */]));

/* harmony default export */ __webpack_exports__["a"] = (Node);

/***/ }),
/* 412 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pdf_core__ = __webpack_require__(682);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__pdf_core__["d"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__pdf_core__["f"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__pdf_drawing__ = __webpack_require__(2582);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__pdf_drawing__["a"]; });




/***/ }),
/* 413 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getPageMargin;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PDFMargin__ = __webpack_require__(685);


var fieldsNames = ['bottom', 'left', 'right', 'top'];
/**
 * @hidden
 * Returns the margin options by reading the props of he component and the `PDFMargin` child.
 * The props of the `PDFMargin` child are with greater priority.
 */
function getPageMargin(props) {
    var marginChild = __WEBPACK_IMPORTED_MODULE_0_react__["Children"]
        .toArray(props.children)
        .find(function (child) { return child && child.type === __WEBPACK_IMPORTED_MODULE_1__PDFMargin__["a" /* PDFMargin */]; });
    return marginChild ? getMarginComponentProps(marginChild) : props.margin;
}
function getMarginComponentProps(marginComponent) {
    var result = {};
    for (var idx = 0; idx < fieldsNames.length; idx++) {
        var fieldName = fieldsNames[idx];
        var value = marginComponent.props[fieldName];
        if (value !== undefined) {
            result[fieldName] = value;
        }
    }
    return result;
}
//# sourceMappingURL=getPageMargin.js.map

/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {


/**
 * Module dependencies.
 */

var debug = __webpack_require__(88)('socket.io-parser');
var Emitter = __webpack_require__(152);
var binary = __webpack_require__(2621);
var isArray = __webpack_require__(693);
var isBuf = __webpack_require__(694);

/**
 * Protocol version.
 *
 * @api public
 */

exports.protocol = 4;

/**
 * Packet types.
 *
 * @api public
 */

exports.types = [
  'CONNECT',
  'DISCONNECT',
  'EVENT',
  'ACK',
  'ERROR',
  'BINARY_EVENT',
  'BINARY_ACK'
];

/**
 * Packet type `connect`.
 *
 * @api public
 */

exports.CONNECT = 0;

/**
 * Packet type `disconnect`.
 *
 * @api public
 */

exports.DISCONNECT = 1;

/**
 * Packet type `event`.
 *
 * @api public
 */

exports.EVENT = 2;

/**
 * Packet type `ack`.
 *
 * @api public
 */

exports.ACK = 3;

/**
 * Packet type `error`.
 *
 * @api public
 */

exports.ERROR = 4;

/**
 * Packet type 'binary event'
 *
 * @api public
 */

exports.BINARY_EVENT = 5;

/**
 * Packet type `binary ack`. For acks with binary arguments.
 *
 * @api public
 */

exports.BINARY_ACK = 6;

/**
 * Encoder constructor.
 *
 * @api public
 */

exports.Encoder = Encoder;

/**
 * Decoder constructor.
 *
 * @api public
 */

exports.Decoder = Decoder;

/**
 * A socket.io Encoder instance
 *
 * @api public
 */

function Encoder() {}

var ERROR_PACKET = exports.ERROR + '"encode error"';

/**
 * Encode a packet as a single string if non-binary, or as a
 * buffer sequence, depending on packet type.
 *
 * @param {Object} obj - packet object
 * @param {Function} callback - function to handle encodings (likely engine.write)
 * @return Calls callback with Array of encodings
 * @api public
 */

Encoder.prototype.encode = function(obj, callback){
  debug('encoding packet %j', obj);

  if (exports.BINARY_EVENT === obj.type || exports.BINARY_ACK === obj.type) {
    encodeAsBinary(obj, callback);
  } else {
    var encoding = encodeAsString(obj);
    callback([encoding]);
  }
};

/**
 * Encode packet as string.
 *
 * @param {Object} packet
 * @return {String} encoded
 * @api private
 */

function encodeAsString(obj) {

  // first is type
  var str = '' + obj.type;

  // attachments if we have them
  if (exports.BINARY_EVENT === obj.type || exports.BINARY_ACK === obj.type) {
    str += obj.attachments + '-';
  }

  // if we have a namespace other than `/`
  // we append it followed by a comma `,`
  if (obj.nsp && '/' !== obj.nsp) {
    str += obj.nsp + ',';
  }

  // immediately followed by the id
  if (null != obj.id) {
    str += obj.id;
  }

  // json data
  if (null != obj.data) {
    var payload = tryStringify(obj.data);
    if (payload !== false) {
      str += payload;
    } else {
      return ERROR_PACKET;
    }
  }

  debug('encoded %j as %s', obj, str);
  return str;
}

function tryStringify(str) {
  try {
    return JSON.stringify(str);
  } catch(e){
    return false;
  }
}

/**
 * Encode packet as 'buffer sequence' by removing blobs, and
 * deconstructing packet into object with placeholders and
 * a list of buffers.
 *
 * @param {Object} packet
 * @return {Buffer} encoded
 * @api private
 */

function encodeAsBinary(obj, callback) {

  function writeEncoding(bloblessData) {
    var deconstruction = binary.deconstructPacket(bloblessData);
    var pack = encodeAsString(deconstruction.packet);
    var buffers = deconstruction.buffers;

    buffers.unshift(pack); // add packet info to beginning of data list
    callback(buffers); // write all the buffers
  }

  binary.removeBlobs(obj, writeEncoding);
}

/**
 * A socket.io Decoder instance
 *
 * @return {Object} decoder
 * @api public
 */

function Decoder() {
  this.reconstructor = null;
}

/**
 * Mix in `Emitter` with Decoder.
 */

Emitter(Decoder.prototype);

/**
 * Decodes an encoded packet string into packet JSON.
 *
 * @param {String} obj - encoded packet
 * @return {Object} packet
 * @api public
 */

Decoder.prototype.add = function(obj) {
  var packet;
  if (typeof obj === 'string') {
    packet = decodeString(obj);
    if (exports.BINARY_EVENT === packet.type || exports.BINARY_ACK === packet.type) { // binary packet's json
      this.reconstructor = new BinaryReconstructor(packet);

      // no attachments, labeled binary but no binary data to follow
      if (this.reconstructor.reconPack.attachments === 0) {
        this.emit('decoded', packet);
      }
    } else { // non-binary full packet
      this.emit('decoded', packet);
    }
  } else if (isBuf(obj) || obj.base64) { // raw binary data
    if (!this.reconstructor) {
      throw new Error('got binary data when not reconstructing a packet');
    } else {
      packet = this.reconstructor.takeBinaryData(obj);
      if (packet) { // received final buffer
        this.reconstructor = null;
        this.emit('decoded', packet);
      }
    }
  } else {
    throw new Error('Unknown type: ' + obj);
  }
};

/**
 * Decode a packet String (JSON data)
 *
 * @param {String} str
 * @return {Object} packet
 * @api private
 */

function decodeString(str) {
  var i = 0;
  // look up type
  var p = {
    type: Number(str.charAt(0))
  };

  if (null == exports.types[p.type]) {
    return error('unknown packet type ' + p.type);
  }

  // look up attachments if type binary
  if (exports.BINARY_EVENT === p.type || exports.BINARY_ACK === p.type) {
    var buf = '';
    while (str.charAt(++i) !== '-') {
      buf += str.charAt(i);
      if (i == str.length) break;
    }
    if (buf != Number(buf) || str.charAt(i) !== '-') {
      throw new Error('Illegal attachments');
    }
    p.attachments = Number(buf);
  }

  // look up namespace (if any)
  if ('/' === str.charAt(i + 1)) {
    p.nsp = '';
    while (++i) {
      var c = str.charAt(i);
      if (',' === c) break;
      p.nsp += c;
      if (i === str.length) break;
    }
  } else {
    p.nsp = '/';
  }

  // look up id
  var next = str.charAt(i + 1);
  if ('' !== next && Number(next) == next) {
    p.id = '';
    while (++i) {
      var c = str.charAt(i);
      if (null == c || Number(c) != c) {
        --i;
        break;
      }
      p.id += str.charAt(i);
      if (i === str.length) break;
    }
    p.id = Number(p.id);
  }

  // look up json data
  if (str.charAt(++i)) {
    var payload = tryParse(str.substr(i));
    var isPayloadValid = payload !== false && (p.type === exports.ERROR || isArray(payload));
    if (isPayloadValid) {
      p.data = payload;
    } else {
      return error('invalid payload');
    }
  }

  debug('decoded %s as %j', str, p);
  return p;
}

function tryParse(str) {
  try {
    return JSON.parse(str);
  } catch(e){
    return false;
  }
}

/**
 * Deallocates a parser's resources
 *
 * @api public
 */

Decoder.prototype.destroy = function() {
  if (this.reconstructor) {
    this.reconstructor.finishedReconstruction();
  }
};

/**
 * A manager of a binary event's 'buffer sequence'. Should
 * be constructed whenever a packet of type BINARY_EVENT is
 * decoded.
 *
 * @param {Object} packet
 * @return {BinaryReconstructor} initialized reconstructor
 * @api private
 */

function BinaryReconstructor(packet) {
  this.reconPack = packet;
  this.buffers = [];
}

/**
 * Method to be called when binary data received from connection
 * after a BINARY_EVENT packet.
 *
 * @param {Buffer | ArrayBuffer} binData - the raw binary data received
 * @return {null | Object} returns null if more binary data is expected or
 *   a reconstructed packet object if all buffers have been received.
 * @api private
 */

BinaryReconstructor.prototype.takeBinaryData = function(binData) {
  this.buffers.push(binData);
  if (this.buffers.length === this.reconPack.attachments) { // done with buffer list
    var packet = binary.reconstructPacket(this.reconPack, this.buffers);
    this.finishedReconstruction();
    return packet;
  }
  return null;
};

/**
 * Cleans up binary packet reconstruction variables.
 *
 * @api private
 */

BinaryReconstructor.prototype.finishedReconstruction = function() {
  this.reconPack = null;
  this.buffers = [];
};

function error(msg) {
  return {
    type: exports.ERROR,
    data: 'parser error: ' + msg
  };
}


/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

// browser shim for xmlhttprequest module

var hasCORS = __webpack_require__(2626);

module.exports = function (opts) {
  var xdomain = opts.xdomain;

  // scheme must be same when usign XDomainRequest
  // http://blogs.msdn.com/b/ieinternals/archive/2010/05/13/xdomainrequest-restrictions-limitations-and-workarounds.aspx
  var xscheme = opts.xscheme;

  // XDomainRequest has a flow of not sending cookie, therefore it should be disabled as a default.
  // https://github.com/Automattic/engine.io-client/pull/217
  var enablesXDR = opts.enablesXDR;

  // XMLHttpRequest can be disabled on IE
  try {
    if ('undefined' !== typeof XMLHttpRequest && (!xdomain || hasCORS)) {
      return new XMLHttpRequest();
    }
  } catch (e) { }

  // Use XDomainRequest for IE8 if enablesXDR is true
  // because loading bar keeps flashing when using jsonp-polling
  // https://github.com/yujiosaka/socke.io-ie8-loading-example
  try {
    if ('undefined' !== typeof XDomainRequest && !xscheme && enablesXDR) {
      return new XDomainRequest();
    }
  } catch (e) { }

  if (!xdomain) {
    try {
      return new self[['Active'].concat('Object').join('X')]('Microsoft.XMLHTTP');
    } catch (e) { }
  }
};


/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Module dependencies.
 */

var parser = __webpack_require__(153);
var Emitter = __webpack_require__(152);

/**
 * Module exports.
 */

module.exports = Transport;

/**
 * Transport abstract constructor.
 *
 * @param {Object} options.
 * @api private
 */

function Transport (opts) {
  this.path = opts.path;
  this.hostname = opts.hostname;
  this.port = opts.port;
  this.secure = opts.secure;
  this.query = opts.query;
  this.timestampParam = opts.timestampParam;
  this.timestampRequests = opts.timestampRequests;
  this.readyState = '';
  this.agent = opts.agent || false;
  this.socket = opts.socket;
  this.enablesXDR = opts.enablesXDR;

  // SSL options for Node.js client
  this.pfx = opts.pfx;
  this.key = opts.key;
  this.passphrase = opts.passphrase;
  this.cert = opts.cert;
  this.ca = opts.ca;
  this.ciphers = opts.ciphers;
  this.rejectUnauthorized = opts.rejectUnauthorized;
  this.forceNode = opts.forceNode;

  // results of ReactNative environment detection
  this.isReactNative = opts.isReactNative;

  // other options for Node.js client
  this.extraHeaders = opts.extraHeaders;
  this.localAddress = opts.localAddress;
}

/**
 * Mix in `Emitter`.
 */

Emitter(Transport.prototype);

/**
 * Emits an error.
 *
 * @param {String} str
 * @return {Transport} for chaining
 * @api public
 */

Transport.prototype.onError = function (msg, desc) {
  var err = new Error(msg);
  err.type = 'TransportError';
  err.description = desc;
  this.emit('error', err);
  return this;
};

/**
 * Opens the transport.
 *
 * @api public
 */

Transport.prototype.open = function () {
  if ('closed' === this.readyState || '' === this.readyState) {
    this.readyState = 'opening';
    this.doOpen();
  }

  return this;
};

/**
 * Closes the transport.
 *
 * @api private
 */

Transport.prototype.close = function () {
  if ('opening' === this.readyState || 'open' === this.readyState) {
    this.doClose();
    this.onClose();
  }

  return this;
};

/**
 * Sends multiple packets.
 *
 * @param {Array} packets
 * @api private
 */

Transport.prototype.send = function (packets) {
  if ('open' === this.readyState) {
    this.write(packets);
  } else {
    throw new Error('Transport not open');
  }
};

/**
 * Called upon open
 *
 * @api private
 */

Transport.prototype.onOpen = function () {
  this.readyState = 'open';
  this.writable = true;
  this.emit('open');
};

/**
 * Called with data.
 *
 * @param {String} data
 * @api private
 */

Transport.prototype.onData = function (data) {
  var packet = parser.decodePacket(data, this.socket.binaryType);
  this.onPacket(packet);
};

/**
 * Called with a decoded packet.
 */

Transport.prototype.onPacket = function (packet) {
  this.emit('packet', packet);
};

/**
 * Called upon close.
 *
 * @api private
 */

Transport.prototype.onClose = function () {
  this.readyState = 'closed';
  this.emit('close');
};


/***/ }),
/* 417 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ClientsSearch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ClientProfileSummary; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ClientAdvSearch; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_graphql_tag__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_graphql_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_graphql_tag__);
var _templateObject=_taggedTemplateLiteral(['\n\tquery clientSearch($brokerId: String!, $search: String!, $token: String!) {\n\t\tClientsSearch(brokerId: $brokerId, search: $search, token: $token) {\n\t\t\tid\n\t\t\tscd_name\n\t\t\tscd_surname\n\t\t\tfull_name\n\t\t\tscd_email\n\t\t}\n\t}\n'],['\n\tquery clientSearch($brokerId: String!, $search: String!, $token: String!) {\n\t\tClientsSearch(brokerId: $brokerId, search: $search, token: $token) {\n\t\t\tid\n\t\t\tscd_name\n\t\t\tscd_surname\n\t\t\tfull_name\n\t\t\tscd_email\n\t\t}\n\t}\n']),_templateObject2=_taggedTemplateLiteral(['\n\tquery clientProfileSummary($id: String!, $token: String!) {\n\t\tClientProfileSummary(id: $id, token: $token) {\n\t\t\tid\n\t\t\tscd_pp_path\n\t\t\tscd_name\n\t\t\tscd_surname\n\t\t\tscd_initials\n\t\t\tscd_email\n\t\t\tscd_cellNumber\n\t\t\tscd_title\n\t\t\tinvite_sent\n\t\t\tapp_active\n\t\t\tscd_clientType\n\t\t\tscd_dateOfBirth\n\t\t\tscd_monthlyIncome\n\t\t\tscd_smoker\n\t\t\tscd_maritalStatus\n\t\t\tscd_qualification\n\t\t\tscd_selfEmployed\n\t\t\tscd_salaryType\n\t\t\tscd_taxDispensation\n\t\t\tscd_spouseIncome\n\t\t\tscd_pAdmin\n\t\t\tscd_pTravel\n\t\t\tscd_pManual\n\t\t\tscd_pSupervision\n\t\t\tscd_gender\n\t\t\tscd_occupation\n\t\t}\n\t}\n'],['\n\tquery clientProfileSummary($id: String!, $token: String!) {\n\t\tClientProfileSummary(id: $id, token: $token) {\n\t\t\tid\n\t\t\tscd_pp_path\n\t\t\tscd_name\n\t\t\tscd_surname\n\t\t\tscd_initials\n\t\t\tscd_email\n\t\t\tscd_cellNumber\n\t\t\tscd_title\n\t\t\tinvite_sent\n\t\t\tapp_active\n\t\t\tscd_clientType\n\t\t\tscd_dateOfBirth\n\t\t\tscd_monthlyIncome\n\t\t\tscd_smoker\n\t\t\tscd_maritalStatus\n\t\t\tscd_qualification\n\t\t\tscd_selfEmployed\n\t\t\tscd_salaryType\n\t\t\tscd_taxDispensation\n\t\t\tscd_spouseIncome\n\t\t\tscd_pAdmin\n\t\t\tscd_pTravel\n\t\t\tscd_pManual\n\t\t\tscd_pSupervision\n\t\t\tscd_gender\n\t\t\tscd_occupation\n\t\t}\n\t}\n']),_templateObject3=_taggedTemplateLiteral(['\n\tquery clientAdvSearch(\n\t\t$brokerId: String!\n\t\t$token: String!\n\t\t$occupation: String\n\t\t$title: String\n\t\t$language: String\n\t\t$smoker: String\n\t\t$birthdayFrom: String\n\t\t$birthdayTo: String\n\t\t$anneversaryFrom: String\n\t\t$anneversaryTo: String\n\t\t$incomeFrom: String\n\t\t$incomeTo: String\n\t\t$ageFrom: String\n\t\t$ageTo: String\n\t) {\n\t\tClientAdvSearch(\n\t\t\tbrokerId: $brokerId\n\t\t\ttoken: $token\n\t\t\toccupation: $occupation\n\t\t\ttitle: $title\n\t\t\tlanguage: $language\n\t\t\tsmoker: $smoker\n\t\t\tbirthdayFrom: $birthdayFrom\n\t\t\tbirthdayTo: $birthdayTo\n\t\t\tanneversaryFrom: $anneversaryFrom\n\t\t\tanneversaryTo: $anneversaryTo\n\t\t\tincomeFrom: $incomeFrom\n\t\t\tincomeTo: $incomeTo\n\t\t\tageFrom: $ageFrom\n\t\t\tageTo: $ageTo\n\t\t) {\n\t\t\tid\n\t\t\tscd_name\n\t\t\tscd_surname\n\t\t\tscd_nickName\n\t\t\tscd_secondAndOtherNames\n\t\t\tscd_maidenName\n\t\t\tscd_initials\n\t\t\tfull_name\n\t\t\tscd_email\n\t\t\tscd_title\n\t\t\tscd_gender\n\t\t\tscd_saID\n\t\t\tscd_smoker\n\t\t\tscd_correspondenceLanguage\n\t\t\tscd_correspondenceType\n\t\t\tscd_cellNumber\n\t\t\tscd_phoneNumber\n\t\t\tdate_of_birth\n\t\t\tage\n\t\t\tscd_monthlyIncome\n\t\t\tscd_weddingDate\n\t\t\tscd_maritalStatus\n\t\t\tscd_clientFileNumber\n\t\t\tscd_residentialAddress\n\t\t\tscd_residentialAddress2\n\t\t\tscd_residentialAddress3\n\t\t\tscd_residentialAddress4\n\t\t\tscd_postalCode\n\t\t\tscd_postalAddress1\n\t\t\tscd_postalAddress2\n\t\t\tscd_postalAddress3\n\t\t\tscd_postalAddress4\n\t\t\tscd_postalAddressCode\n\t\t\tsb_accountName\n\t\t\tsb_bank\n\t\t\tsb_branchName\n\t\t\tsb_branch\n\t\t\tsb_accountType\n\t\t\tdate_created\n\t\t\tdate_modified\n\t\t}\n\t}\n'],['\n\tquery clientAdvSearch(\n\t\t$brokerId: String!\n\t\t$token: String!\n\t\t$occupation: String\n\t\t$title: String\n\t\t$language: String\n\t\t$smoker: String\n\t\t$birthdayFrom: String\n\t\t$birthdayTo: String\n\t\t$anneversaryFrom: String\n\t\t$anneversaryTo: String\n\t\t$incomeFrom: String\n\t\t$incomeTo: String\n\t\t$ageFrom: String\n\t\t$ageTo: String\n\t) {\n\t\tClientAdvSearch(\n\t\t\tbrokerId: $brokerId\n\t\t\ttoken: $token\n\t\t\toccupation: $occupation\n\t\t\ttitle: $title\n\t\t\tlanguage: $language\n\t\t\tsmoker: $smoker\n\t\t\tbirthdayFrom: $birthdayFrom\n\t\t\tbirthdayTo: $birthdayTo\n\t\t\tanneversaryFrom: $anneversaryFrom\n\t\t\tanneversaryTo: $anneversaryTo\n\t\t\tincomeFrom: $incomeFrom\n\t\t\tincomeTo: $incomeTo\n\t\t\tageFrom: $ageFrom\n\t\t\tageTo: $ageTo\n\t\t) {\n\t\t\tid\n\t\t\tscd_name\n\t\t\tscd_surname\n\t\t\tscd_nickName\n\t\t\tscd_secondAndOtherNames\n\t\t\tscd_maidenName\n\t\t\tscd_initials\n\t\t\tfull_name\n\t\t\tscd_email\n\t\t\tscd_title\n\t\t\tscd_gender\n\t\t\tscd_saID\n\t\t\tscd_smoker\n\t\t\tscd_correspondenceLanguage\n\t\t\tscd_correspondenceType\n\t\t\tscd_cellNumber\n\t\t\tscd_phoneNumber\n\t\t\tdate_of_birth\n\t\t\tage\n\t\t\tscd_monthlyIncome\n\t\t\tscd_weddingDate\n\t\t\tscd_maritalStatus\n\t\t\tscd_clientFileNumber\n\t\t\tscd_residentialAddress\n\t\t\tscd_residentialAddress2\n\t\t\tscd_residentialAddress3\n\t\t\tscd_residentialAddress4\n\t\t\tscd_postalCode\n\t\t\tscd_postalAddress1\n\t\t\tscd_postalAddress2\n\t\t\tscd_postalAddress3\n\t\t\tscd_postalAddress4\n\t\t\tscd_postalAddressCode\n\t\t\tsb_accountName\n\t\t\tsb_bank\n\t\t\tsb_branchName\n\t\t\tsb_branch\n\t\t\tsb_accountType\n\t\t\tdate_created\n\t\t\tdate_modified\n\t\t}\n\t}\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var ClientsSearch=__WEBPACK_IMPORTED_MODULE_0_graphql_tag___default()(_templateObject);var ClientProfileSummary=__WEBPACK_IMPORTED_MODULE_0_graphql_tag___default()(_templateObject2);var ClientAdvSearch=__WEBPACK_IMPORTED_MODULE_0_graphql_tag___default()(_templateObject3);

/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
  addDays: __webpack_require__(148),
  addHours: __webpack_require__(709),
  addISOYears: __webpack_require__(710),
  addMilliseconds: __webpack_require__(206),
  addMinutes: __webpack_require__(712),
  addMonths: __webpack_require__(286),
  addQuarters: __webpack_require__(713),
  addSeconds: __webpack_require__(714),
  addWeeks: __webpack_require__(419),
  addYears: __webpack_require__(715),
  areRangesOverlapping: __webpack_require__(2682),
  closestIndexTo: __webpack_require__(2683),
  closestTo: __webpack_require__(2684),
  compareAsc: __webpack_require__(207),
  compareDesc: __webpack_require__(420),
  differenceInCalendarDays: __webpack_require__(261),
  differenceInCalendarISOWeeks: __webpack_require__(2685),
  differenceInCalendarISOYears: __webpack_require__(716),
  differenceInCalendarMonths: __webpack_require__(717),
  differenceInCalendarQuarters: __webpack_require__(2686),
  differenceInCalendarWeeks: __webpack_require__(2687),
  differenceInCalendarYears: __webpack_require__(719),
  differenceInDays: __webpack_require__(720),
  differenceInHours: __webpack_require__(2688),
  differenceInISOYears: __webpack_require__(2689),
  differenceInMilliseconds: __webpack_require__(287),
  differenceInMinutes: __webpack_require__(2690),
  differenceInMonths: __webpack_require__(421),
  differenceInQuarters: __webpack_require__(2691),
  differenceInSeconds: __webpack_require__(422),
  differenceInWeeks: __webpack_require__(2692),
  differenceInYears: __webpack_require__(2693),
  distanceInWords: __webpack_require__(722),
  distanceInWordsStrict: __webpack_require__(2694),
  distanceInWordsToNow: __webpack_require__(2695),
  eachDay: __webpack_require__(2696),
  endOfDay: __webpack_require__(260),
  endOfHour: __webpack_require__(2697),
  endOfISOWeek: __webpack_require__(2698),
  endOfISOYear: __webpack_require__(2699),
  endOfMinute: __webpack_require__(2700),
  endOfMonth: __webpack_require__(724),
  endOfQuarter: __webpack_require__(2701),
  endOfSecond: __webpack_require__(2702),
  endOfToday: __webpack_require__(2703),
  endOfTomorrow: __webpack_require__(2704),
  endOfWeek: __webpack_require__(723),
  endOfYear: __webpack_require__(2705),
  endOfYesterday: __webpack_require__(2706),
  format: __webpack_require__(77),
  getDate: __webpack_require__(2707),
  getDay: __webpack_require__(384),
  getDayOfYear: __webpack_require__(609),
  getDaysInMonth: __webpack_require__(258),
  getDaysInYear: __webpack_require__(2708),
  getHours: __webpack_require__(2709),
  getISODay: __webpack_require__(726),
  getISOWeek: __webpack_require__(386),
  getISOWeeksInYear: __webpack_require__(2710),
  getISOYear: __webpack_require__(114),
  getMilliseconds: __webpack_require__(2711),
  getMinutes: __webpack_require__(2712),
  getMonth: __webpack_require__(2713),
  getOverlappingDaysInRanges: __webpack_require__(2714),
  getQuarter: __webpack_require__(718),
  getSeconds: __webpack_require__(2715),
  getTime: __webpack_require__(2716),
  getYear: __webpack_require__(2717),
  isAfter: __webpack_require__(259),
  isBefore: __webpack_require__(191),
  isDate: __webpack_require__(383),
  isEqual: __webpack_require__(2718),
  isFirstDayOfMonth: __webpack_require__(2719),
  isFriday: __webpack_require__(2720),
  isFuture: __webpack_require__(2721),
  isLastDayOfMonth: __webpack_require__(2722),
  isLeapYear: __webpack_require__(725),
  isMonday: __webpack_require__(2723),
  isPast: __webpack_require__(2724),
  isSameDay: __webpack_require__(606),
  isSameHour: __webpack_require__(727),
  isSameISOWeek: __webpack_require__(729),
  isSameISOYear: __webpack_require__(730),
  isSameMinute: __webpack_require__(731),
  isSameMonth: __webpack_require__(389),
  isSameQuarter: __webpack_require__(733),
  isSameSecond: __webpack_require__(735),
  isSameWeek: __webpack_require__(423),
  isSameYear: __webpack_require__(388),
  isSaturday: __webpack_require__(2725),
  isSunday: __webpack_require__(2726),
  isThisHour: __webpack_require__(2727),
  isThisISOWeek: __webpack_require__(2728),
  isThisISOYear: __webpack_require__(2729),
  isThisMinute: __webpack_require__(2730),
  isThisMonth: __webpack_require__(2731),
  isThisQuarter: __webpack_require__(2732),
  isThisSecond: __webpack_require__(2733),
  isThisWeek: __webpack_require__(2734),
  isThisYear: __webpack_require__(2735),
  isThursday: __webpack_require__(2736),
  isToday: __webpack_require__(2737),
  isTomorrow: __webpack_require__(2738),
  isTuesday: __webpack_require__(2739),
  isValid: __webpack_require__(611),
  isWednesday: __webpack_require__(2740),
  isWeekend: __webpack_require__(2741),
  isWithinRange: __webpack_require__(2742),
  isYesterday: __webpack_require__(2743),
  lastDayOfISOWeek: __webpack_require__(2744),
  lastDayOfISOYear: __webpack_require__(2745),
  lastDayOfMonth: __webpack_require__(2746),
  lastDayOfQuarter: __webpack_require__(2747),
  lastDayOfWeek: __webpack_require__(737),
  lastDayOfYear: __webpack_require__(2748),
  max: __webpack_require__(2749),
  min: __webpack_require__(2750),
  parse: __webpack_require__(9),
  setDate: __webpack_require__(2751),
  setDay: __webpack_require__(2752),
  setDayOfYear: __webpack_require__(2753),
  setHours: __webpack_require__(2754),
  setISODay: __webpack_require__(2755),
  setISOWeek: __webpack_require__(2756),
  setISOYear: __webpack_require__(711),
  setMilliseconds: __webpack_require__(2757),
  setMinutes: __webpack_require__(2758),
  setMonth: __webpack_require__(738),
  setQuarter: __webpack_require__(2759),
  setSeconds: __webpack_require__(2760),
  setYear: __webpack_require__(2761),
  startOfDay: __webpack_require__(82),
  startOfHour: __webpack_require__(728),
  startOfISOWeek: __webpack_require__(113),
  startOfISOYear: __webpack_require__(192),
  startOfMinute: __webpack_require__(732),
  startOfMonth: __webpack_require__(613),
  startOfQuarter: __webpack_require__(734),
  startOfSecond: __webpack_require__(736),
  startOfToday: __webpack_require__(2762),
  startOfTomorrow: __webpack_require__(2763),
  startOfWeek: __webpack_require__(262),
  startOfYear: __webpack_require__(610),
  startOfYesterday: __webpack_require__(2764),
  subDays: __webpack_require__(2765),
  subHours: __webpack_require__(2766),
  subISOYears: __webpack_require__(721),
  subMilliseconds: __webpack_require__(2767),
  subMinutes: __webpack_require__(2768),
  subMonths: __webpack_require__(2769),
  subQuarters: __webpack_require__(2770),
  subSeconds: __webpack_require__(2771),
  subWeeks: __webpack_require__(2772),
  subYears: __webpack_require__(2773)
}


/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

var addDays = __webpack_require__(148)

/**
 * @category Week Helpers
 * @summary Add the specified number of weeks to the given date.
 *
 * @description
 * Add the specified number of week to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of weeks to be added
 * @returns {Date} the new date with the weeks added
 *
 * @example
 * // Add 4 weeks to 1 September 2014:
 * var result = addWeeks(new Date(2014, 8, 1), 4)
 * //=> Mon Sep 29 2014 00:00:00
 */
function addWeeks (dirtyDate, dirtyAmount) {
  var amount = Number(dirtyAmount)
  var days = amount * 7
  return addDays(dirtyDate, days)
}

module.exports = addWeeks


/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(9)

/**
 * @category Common Helpers
 * @summary Compare the two dates reverse chronologically and return -1, 0 or 1.
 *
 * @description
 * Compare the two dates and return -1 if the first date is after the second,
 * 1 if the first date is before the second or 0 if dates are equal.
 *
 * @param {Date|String|Number} dateLeft - the first date to compare
 * @param {Date|String|Number} dateRight - the second date to compare
 * @returns {Number} the result of the comparison
 *
 * @example
 * // Compare 11 February 1987 and 10 July 1989 reverse chronologically:
 * var result = compareDesc(
 *   new Date(1987, 1, 11),
 *   new Date(1989, 6, 10)
 * )
 * //=> 1
 *
 * @example
 * // Sort the array of dates in reverse chronological order:
 * var result = [
 *   new Date(1995, 6, 2),
 *   new Date(1987, 1, 11),
 *   new Date(1989, 6, 10)
 * ].sort(compareDesc)
 * //=> [
 * //   Sun Jul 02 1995 00:00:00,
 * //   Mon Jul 10 1989 00:00:00,
 * //   Wed Feb 11 1987 00:00:00
 * // ]
 */
function compareDesc (dirtyDateLeft, dirtyDateRight) {
  var dateLeft = parse(dirtyDateLeft)
  var timeLeft = dateLeft.getTime()
  var dateRight = parse(dirtyDateRight)
  var timeRight = dateRight.getTime()

  if (timeLeft > timeRight) {
    return -1
  } else if (timeLeft < timeRight) {
    return 1
  } else {
    return 0
  }
}

module.exports = compareDesc


/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(9)
var differenceInCalendarMonths = __webpack_require__(717)
var compareAsc = __webpack_require__(207)

/**
 * @category Month Helpers
 * @summary Get the number of full months between the given dates.
 *
 * @description
 * Get the number of full months between the given dates.
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @returns {Number} the number of full months
 *
 * @example
 * // How many full months are between 31 January 2014 and 1 September 2014?
 * var result = differenceInMonths(
 *   new Date(2014, 8, 1),
 *   new Date(2014, 0, 31)
 * )
 * //=> 7
 */
function differenceInMonths (dirtyDateLeft, dirtyDateRight) {
  var dateLeft = parse(dirtyDateLeft)
  var dateRight = parse(dirtyDateRight)

  var sign = compareAsc(dateLeft, dateRight)
  var difference = Math.abs(differenceInCalendarMonths(dateLeft, dateRight))
  dateLeft.setMonth(dateLeft.getMonth() - sign * difference)

  // Math.abs(diff in full months - diff in calendar months) === 1 if last calendar month is not full
  // If so, result must be decreased by 1 in absolute value
  var isLastMonthNotFull = compareAsc(dateLeft, dateRight) === -sign
  return sign * (difference - isLastMonthNotFull)
}

module.exports = differenceInMonths


/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

var differenceInMilliseconds = __webpack_require__(287)

/**
 * @category Second Helpers
 * @summary Get the number of seconds between the given dates.
 *
 * @description
 * Get the number of seconds between the given dates.
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @returns {Number} the number of seconds
 *
 * @example
 * // How many seconds are between
 * // 2 July 2014 12:30:07.999 and 2 July 2014 12:30:20.000?
 * var result = differenceInSeconds(
 *   new Date(2014, 6, 2, 12, 30, 20, 0),
 *   new Date(2014, 6, 2, 12, 30, 7, 999)
 * )
 * //=> 12
 */
function differenceInSeconds (dirtyDateLeft, dirtyDateRight) {
  var diff = differenceInMilliseconds(dirtyDateLeft, dirtyDateRight) / 1000
  return diff > 0 ? Math.floor(diff) : Math.ceil(diff)
}

module.exports = differenceInSeconds


/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

var startOfWeek = __webpack_require__(262)

/**
 * @category Week Helpers
 * @summary Are the given dates in the same week?
 *
 * @description
 * Are the given dates in the same week?
 *
 * @param {Date|String|Number} dateLeft - the first date to check
 * @param {Date|String|Number} dateRight - the second date to check
 * @param {Object} [options] - the object with options
 * @param {Number} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @returns {Boolean} the dates are in the same week
 *
 * @example
 * // Are 31 August 2014 and 4 September 2014 in the same week?
 * var result = isSameWeek(
 *   new Date(2014, 7, 31),
 *   new Date(2014, 8, 4)
 * )
 * //=> true
 *
 * @example
 * // If week starts with Monday,
 * // are 31 August 2014 and 4 September 2014 in the same week?
 * var result = isSameWeek(
 *   new Date(2014, 7, 31),
 *   new Date(2014, 8, 4),
 *   {weekStartsOn: 1}
 * )
 * //=> false
 */
function isSameWeek (dirtyDateLeft, dirtyDateRight, dirtyOptions) {
  var dateLeftStartOfWeek = startOfWeek(dirtyDateLeft, dirtyOptions)
  var dateRightStartOfWeek = startOfWeek(dirtyDateRight, dirtyOptions)

  return dateLeftStartOfWeek.getTime() === dateRightStartOfWeek.getTime()
}

module.exports = isSameWeek


/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./1.png": 2787,
	"./Discovery.png": 2788,
	"./Health Squared.jpg": 2789,
	"./PPS.jpg": 2790,
	"./Sizwe.jpg": 2791,
	"./agility.png": 2792,
	"./bestmed.jpg": 2793,
	"./bidvest-small.png": 2794,
	"./bidvest.png": 2795,
	"./bonitas.jpg": 2796,
	"./compcare.jpg": 2797,
	"./curemed.png": 2798,
	"./fedhealth.jpg": 2799,
	"./fmi-small.png": 2800,
	"./fmi-small0.png": 2801,
	"./fmi.png": 2802,
	"./fmi0.png": 2803,
	"./hosmed - Copy.jpg": 2804,
	"./hosmed.jpg": 2805,
	"./keyhealth.png": 2806,
	"./liberty-small.jpg": 2807,
	"./liberty.png": 2808,
	"./madgap.png": 2809,
	"./medgap.png": 2810,
	"./medihelp.jpg": 743,
	"./medshield.png": 2811,
	"./momentum-small.jpg": 2812,
	"./momentum.png": 2813,
	"./momentumMed.png": 2814,
	"./old mutual.jpg": 2815,
	"./old mutual.png": 2816,
	"./oldmutual.png": 2817,
	"./pps.png": 2818,
	"./profmed.jpg": 2819,
	"./sanlam-small.png": 2820,
	"./sanlam.png": 2821,
	"./sirago.png": 2822,
	"./stratum.jpg": 2823,
	"./sureqoute1.png": 2824,
	"./sureqoute2.png": 2825,
	"./tra.svg": 2826,
	"./turnberry.png": 2827,
	"./zest.jpg": 2828
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 424;

/***/ }),
/* 425 */
/***/ (function(module, exports) {

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

function EventEmitter() {
  this._events = this._events || {};
  this._maxListeners = this._maxListeners || undefined;
}
module.exports = EventEmitter;

// Backwards-compat with node 0.10.x
EventEmitter.EventEmitter = EventEmitter;

EventEmitter.prototype._events = undefined;
EventEmitter.prototype._maxListeners = undefined;

// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
EventEmitter.defaultMaxListeners = 10;

// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
EventEmitter.prototype.setMaxListeners = function(n) {
  if (!isNumber(n) || n < 0 || isNaN(n))
    throw TypeError('n must be a positive number');
  this._maxListeners = n;
  return this;
};

EventEmitter.prototype.emit = function(type) {
  var er, handler, len, args, i, listeners;

  if (!this._events)
    this._events = {};

  // If there is no 'error' event listener then throw.
  if (type === 'error') {
    if (!this._events.error ||
        (isObject(this._events.error) && !this._events.error.length)) {
      er = arguments[1];
      if (er instanceof Error) {
        throw er; // Unhandled 'error' event
      } else {
        // At least give some kind of context to the user
        var err = new Error('Uncaught, unspecified "error" event. (' + er + ')');
        err.context = er;
        throw err;
      }
    }
  }

  handler = this._events[type];

  if (isUndefined(handler))
    return false;

  if (isFunction(handler)) {
    switch (arguments.length) {
      // fast cases
      case 1:
        handler.call(this);
        break;
      case 2:
        handler.call(this, arguments[1]);
        break;
      case 3:
        handler.call(this, arguments[1], arguments[2]);
        break;
      // slower
      default:
        args = Array.prototype.slice.call(arguments, 1);
        handler.apply(this, args);
    }
  } else if (isObject(handler)) {
    args = Array.prototype.slice.call(arguments, 1);
    listeners = handler.slice();
    len = listeners.length;
    for (i = 0; i < len; i++)
      listeners[i].apply(this, args);
  }

  return true;
};

EventEmitter.prototype.addListener = function(type, listener) {
  var m;

  if (!isFunction(listener))
    throw TypeError('listener must be a function');

  if (!this._events)
    this._events = {};

  // To avoid recursion in the case that type === "newListener"! Before
  // adding it to the listeners, first emit "newListener".
  if (this._events.newListener)
    this.emit('newListener', type,
              isFunction(listener.listener) ?
              listener.listener : listener);

  if (!this._events[type])
    // Optimize the case of one listener. Don't need the extra array object.
    this._events[type] = listener;
  else if (isObject(this._events[type]))
    // If we've already got an array, just append.
    this._events[type].push(listener);
  else
    // Adding the second element, need to change to array.
    this._events[type] = [this._events[type], listener];

  // Check for listener leak
  if (isObject(this._events[type]) && !this._events[type].warned) {
    if (!isUndefined(this._maxListeners)) {
      m = this._maxListeners;
    } else {
      m = EventEmitter.defaultMaxListeners;
    }

    if (m && m > 0 && this._events[type].length > m) {
      this._events[type].warned = true;
      console.error('(node) warning: possible EventEmitter memory ' +
                    'leak detected. %d listeners added. ' +
                    'Use emitter.setMaxListeners() to increase limit.',
                    this._events[type].length);
      if (typeof console.trace === 'function') {
        // not supported in IE 10
        console.trace();
      }
    }
  }

  return this;
};

EventEmitter.prototype.on = EventEmitter.prototype.addListener;

EventEmitter.prototype.once = function(type, listener) {
  if (!isFunction(listener))
    throw TypeError('listener must be a function');

  var fired = false;

  function g() {
    this.removeListener(type, g);

    if (!fired) {
      fired = true;
      listener.apply(this, arguments);
    }
  }

  g.listener = listener;
  this.on(type, g);

  return this;
};

// emits a 'removeListener' event iff the listener was removed
EventEmitter.prototype.removeListener = function(type, listener) {
  var list, position, length, i;

  if (!isFunction(listener))
    throw TypeError('listener must be a function');

  if (!this._events || !this._events[type])
    return this;

  list = this._events[type];
  length = list.length;
  position = -1;

  if (list === listener ||
      (isFunction(list.listener) && list.listener === listener)) {
    delete this._events[type];
    if (this._events.removeListener)
      this.emit('removeListener', type, listener);

  } else if (isObject(list)) {
    for (i = length; i-- > 0;) {
      if (list[i] === listener ||
          (list[i].listener && list[i].listener === listener)) {
        position = i;
        break;
      }
    }

    if (position < 0)
      return this;

    if (list.length === 1) {
      list.length = 0;
      delete this._events[type];
    } else {
      list.splice(position, 1);
    }

    if (this._events.removeListener)
      this.emit('removeListener', type, listener);
  }

  return this;
};

EventEmitter.prototype.removeAllListeners = function(type) {
  var key, listeners;

  if (!this._events)
    return this;

  // not listening for removeListener, no need to emit
  if (!this._events.removeListener) {
    if (arguments.length === 0)
      this._events = {};
    else if (this._events[type])
      delete this._events[type];
    return this;
  }

  // emit removeListener for all listeners on all events
  if (arguments.length === 0) {
    for (key in this._events) {
      if (key === 'removeListener') continue;
      this.removeAllListeners(key);
    }
    this.removeAllListeners('removeListener');
    this._events = {};
    return this;
  }

  listeners = this._events[type];

  if (isFunction(listeners)) {
    this.removeListener(type, listeners);
  } else if (listeners) {
    // LIFO order
    while (listeners.length)
      this.removeListener(type, listeners[listeners.length - 1]);
  }
  delete this._events[type];

  return this;
};

EventEmitter.prototype.listeners = function(type) {
  var ret;
  if (!this._events || !this._events[type])
    ret = [];
  else if (isFunction(this._events[type]))
    ret = [this._events[type]];
  else
    ret = this._events[type].slice();
  return ret;
};

EventEmitter.prototype.listenerCount = function(type) {
  if (this._events) {
    var evlistener = this._events[type];

    if (isFunction(evlistener))
      return 1;
    else if (evlistener)
      return evlistener.length;
  }
  return 0;
};

EventEmitter.listenerCount = function(emitter, type) {
  return emitter.listenerCount(type);
};

function isFunction(arg) {
  return typeof arg === 'function';
}

function isNumber(arg) {
  return typeof arg === 'number';
}

function isObject(arg) {
  return typeof arg === 'object' && arg !== null;
}

function isUndefined(arg) {
  return arg === void 0;
}


/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(746);
exports.Stream = exports;
exports.Readable = exports;
exports.Writable = __webpack_require__(427);
exports.Duplex = __webpack_require__(124);
exports.Transform = __webpack_require__(749);
exports.PassThrough = __webpack_require__(2848);


/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process, setImmediate, global) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.



/*<replacement>*/

var pna = __webpack_require__(288);
/*</replacement>*/

module.exports = Writable;

/* <replacement> */
function WriteReq(chunk, encoding, cb) {
  this.chunk = chunk;
  this.encoding = encoding;
  this.callback = cb;
  this.next = null;
}

// It seems a linked list but it is not
// there will be only 2 of these for each stream
function CorkedRequest(state) {
  var _this = this;

  this.next = null;
  this.entry = null;
  this.finish = function () {
    onCorkedFinish(_this, state);
  };
}
/* </replacement> */

/*<replacement>*/
var asyncWrite = !process.browser && ['v0.10', 'v0.9.'].indexOf(process.version.slice(0, 5)) > -1 ? setImmediate : pna.nextTick;
/*</replacement>*/

/*<replacement>*/
var Duplex;
/*</replacement>*/

Writable.WritableState = WritableState;

/*<replacement>*/
var util = __webpack_require__(208);
util.inherits = __webpack_require__(118);
/*</replacement>*/

/*<replacement>*/
var internalUtil = {
  deprecate: __webpack_require__(2847)
};
/*</replacement>*/

/*<replacement>*/
var Stream = __webpack_require__(747);
/*</replacement>*/

/*<replacement>*/

var Buffer = __webpack_require__(289).Buffer;
var OurUint8Array = global.Uint8Array || function () {};
function _uint8ArrayToBuffer(chunk) {
  return Buffer.from(chunk);
}
function _isUint8Array(obj) {
  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
}

/*</replacement>*/

var destroyImpl = __webpack_require__(748);

util.inherits(Writable, Stream);

function nop() {}

function WritableState(options, stream) {
  Duplex = Duplex || __webpack_require__(124);

  options = options || {};

  // Duplex streams are both readable and writable, but share
  // the same options object.
  // However, some cases require setting options to different
  // values for the readable and the writable sides of the duplex stream.
  // These options can be provided separately as readableXXX and writableXXX.
  var isDuplex = stream instanceof Duplex;

  // object stream flag to indicate whether or not this stream
  // contains buffers or objects.
  this.objectMode = !!options.objectMode;

  if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;

  // the point at which write() starts returning false
  // Note: 0 is a valid value, means that we always return false if
  // the entire buffer is not flushed immediately on write()
  var hwm = options.highWaterMark;
  var writableHwm = options.writableHighWaterMark;
  var defaultHwm = this.objectMode ? 16 : 16 * 1024;

  if (hwm || hwm === 0) this.highWaterMark = hwm;else if (isDuplex && (writableHwm || writableHwm === 0)) this.highWaterMark = writableHwm;else this.highWaterMark = defaultHwm;

  // cast to ints.
  this.highWaterMark = Math.floor(this.highWaterMark);

  // if _final has been called
  this.finalCalled = false;

  // drain event flag.
  this.needDrain = false;
  // at the start of calling end()
  this.ending = false;
  // when end() has been called, and returned
  this.ended = false;
  // when 'finish' is emitted
  this.finished = false;

  // has it been destroyed
  this.destroyed = false;

  // should we decode strings into buffers before passing to _write?
  // this is here so that some node-core streams can optimize string
  // handling at a lower level.
  var noDecode = options.decodeStrings === false;
  this.decodeStrings = !noDecode;

  // Crypto is kind of old and crusty.  Historically, its default string
  // encoding is 'binary' so we have to make this configurable.
  // Everything else in the universe uses 'utf8', though.
  this.defaultEncoding = options.defaultEncoding || 'utf8';

  // not an actual buffer we keep track of, but a measurement
  // of how much we're waiting to get pushed to some underlying
  // socket or file.
  this.length = 0;

  // a flag to see when we're in the middle of a write.
  this.writing = false;

  // when true all writes will be buffered until .uncork() call
  this.corked = 0;

  // a flag to be able to tell if the onwrite cb is called immediately,
  // or on a later tick.  We set this to true at first, because any
  // actions that shouldn't happen until "later" should generally also
  // not happen before the first write call.
  this.sync = true;

  // a flag to know if we're processing previously buffered items, which
  // may call the _write() callback in the same tick, so that we don't
  // end up in an overlapped onwrite situation.
  this.bufferProcessing = false;

  // the callback that's passed to _write(chunk,cb)
  this.onwrite = function (er) {
    onwrite(stream, er);
  };

  // the callback that the user supplies to write(chunk,encoding,cb)
  this.writecb = null;

  // the amount that is being written when _write is called.
  this.writelen = 0;

  this.bufferedRequest = null;
  this.lastBufferedRequest = null;

  // number of pending user-supplied write callbacks
  // this must be 0 before 'finish' can be emitted
  this.pendingcb = 0;

  // emit prefinish if the only thing we're waiting for is _write cbs
  // This is relevant for synchronous Transform streams
  this.prefinished = false;

  // True if the error was already emitted and should not be thrown again
  this.errorEmitted = false;

  // count buffered requests
  this.bufferedRequestCount = 0;

  // allocate the first CorkedRequest, there is always
  // one allocated and free to use, and we maintain at most two
  this.corkedRequestsFree = new CorkedRequest(this);
}

WritableState.prototype.getBuffer = function getBuffer() {
  var current = this.bufferedRequest;
  var out = [];
  while (current) {
    out.push(current);
    current = current.next;
  }
  return out;
};

(function () {
  try {
    Object.defineProperty(WritableState.prototype, 'buffer', {
      get: internalUtil.deprecate(function () {
        return this.getBuffer();
      }, '_writableState.buffer is deprecated. Use _writableState.getBuffer ' + 'instead.', 'DEP0003')
    });
  } catch (_) {}
})();

// Test _writableState for inheritance to account for Duplex streams,
// whose prototype chain only points to Readable.
var realHasInstance;
if (typeof Symbol === 'function' && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === 'function') {
  realHasInstance = Function.prototype[Symbol.hasInstance];
  Object.defineProperty(Writable, Symbol.hasInstance, {
    value: function (object) {
      if (realHasInstance.call(this, object)) return true;
      if (this !== Writable) return false;

      return object && object._writableState instanceof WritableState;
    }
  });
} else {
  realHasInstance = function (object) {
    return object instanceof this;
  };
}

function Writable(options) {
  Duplex = Duplex || __webpack_require__(124);

  // Writable ctor is applied to Duplexes, too.
  // `realHasInstance` is necessary because using plain `instanceof`
  // would return false, as no `_writableState` property is attached.

  // Trying to use the custom `instanceof` for Writable here will also break the
  // Node.js LazyTransform implementation, which has a non-trivial getter for
  // `_writableState` that would lead to infinite recursion.
  if (!realHasInstance.call(Writable, this) && !(this instanceof Duplex)) {
    return new Writable(options);
  }

  this._writableState = new WritableState(options, this);

  // legacy.
  this.writable = true;

  if (options) {
    if (typeof options.write === 'function') this._write = options.write;

    if (typeof options.writev === 'function') this._writev = options.writev;

    if (typeof options.destroy === 'function') this._destroy = options.destroy;

    if (typeof options.final === 'function') this._final = options.final;
  }

  Stream.call(this);
}

// Otherwise people can pipe Writable streams, which is just wrong.
Writable.prototype.pipe = function () {
  this.emit('error', new Error('Cannot pipe, not readable'));
};

function writeAfterEnd(stream, cb) {
  var er = new Error('write after end');
  // TODO: defer error events consistently everywhere, not just the cb
  stream.emit('error', er);
  pna.nextTick(cb, er);
}

// Checks that a user-supplied chunk is valid, especially for the particular
// mode the stream is in. Currently this means that `null` is never accepted
// and undefined/non-string values are only allowed in object mode.
function validChunk(stream, state, chunk, cb) {
  var valid = true;
  var er = false;

  if (chunk === null) {
    er = new TypeError('May not write null values to stream');
  } else if (typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
    er = new TypeError('Invalid non-string/buffer chunk');
  }
  if (er) {
    stream.emit('error', er);
    pna.nextTick(cb, er);
    valid = false;
  }
  return valid;
}

Writable.prototype.write = function (chunk, encoding, cb) {
  var state = this._writableState;
  var ret = false;
  var isBuf = !state.objectMode && _isUint8Array(chunk);

  if (isBuf && !Buffer.isBuffer(chunk)) {
    chunk = _uint8ArrayToBuffer(chunk);
  }

  if (typeof encoding === 'function') {
    cb = encoding;
    encoding = null;
  }

  if (isBuf) encoding = 'buffer';else if (!encoding) encoding = state.defaultEncoding;

  if (typeof cb !== 'function') cb = nop;

  if (state.ended) writeAfterEnd(this, cb);else if (isBuf || validChunk(this, state, chunk, cb)) {
    state.pendingcb++;
    ret = writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
  }

  return ret;
};

Writable.prototype.cork = function () {
  var state = this._writableState;

  state.corked++;
};

Writable.prototype.uncork = function () {
  var state = this._writableState;

  if (state.corked) {
    state.corked--;

    if (!state.writing && !state.corked && !state.finished && !state.bufferProcessing && state.bufferedRequest) clearBuffer(this, state);
  }
};

Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
  // node::ParseEncoding() requires lower case.
  if (typeof encoding === 'string') encoding = encoding.toLowerCase();
  if (!(['hex', 'utf8', 'utf-8', 'ascii', 'binary', 'base64', 'ucs2', 'ucs-2', 'utf16le', 'utf-16le', 'raw'].indexOf((encoding + '').toLowerCase()) > -1)) throw new TypeError('Unknown encoding: ' + encoding);
  this._writableState.defaultEncoding = encoding;
  return this;
};

function decodeChunk(state, chunk, encoding) {
  if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') {
    chunk = Buffer.from(chunk, encoding);
  }
  return chunk;
}

Object.defineProperty(Writable.prototype, 'writableHighWaterMark', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function () {
    return this._writableState.highWaterMark;
  }
});

// if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
  if (!isBuf) {
    var newChunk = decodeChunk(state, chunk, encoding);
    if (chunk !== newChunk) {
      isBuf = true;
      encoding = 'buffer';
      chunk = newChunk;
    }
  }
  var len = state.objectMode ? 1 : chunk.length;

  state.length += len;

  var ret = state.length < state.highWaterMark;
  // we must ensure that previous needDrain will not be reset to false.
  if (!ret) state.needDrain = true;

  if (state.writing || state.corked) {
    var last = state.lastBufferedRequest;
    state.lastBufferedRequest = {
      chunk: chunk,
      encoding: encoding,
      isBuf: isBuf,
      callback: cb,
      next: null
    };
    if (last) {
      last.next = state.lastBufferedRequest;
    } else {
      state.bufferedRequest = state.lastBufferedRequest;
    }
    state.bufferedRequestCount += 1;
  } else {
    doWrite(stream, state, false, len, chunk, encoding, cb);
  }

  return ret;
}

function doWrite(stream, state, writev, len, chunk, encoding, cb) {
  state.writelen = len;
  state.writecb = cb;
  state.writing = true;
  state.sync = true;
  if (writev) stream._writev(chunk, state.onwrite);else stream._write(chunk, encoding, state.onwrite);
  state.sync = false;
}

function onwriteError(stream, state, sync, er, cb) {
  --state.pendingcb;

  if (sync) {
    // defer the callback if we are being called synchronously
    // to avoid piling up things on the stack
    pna.nextTick(cb, er);
    // this can emit finish, and it will always happen
    // after error
    pna.nextTick(finishMaybe, stream, state);
    stream._writableState.errorEmitted = true;
    stream.emit('error', er);
  } else {
    // the caller expect this to happen before if
    // it is async
    cb(er);
    stream._writableState.errorEmitted = true;
    stream.emit('error', er);
    // this can emit finish, but finish must
    // always follow error
    finishMaybe(stream, state);
  }
}

function onwriteStateUpdate(state) {
  state.writing = false;
  state.writecb = null;
  state.length -= state.writelen;
  state.writelen = 0;
}

function onwrite(stream, er) {
  var state = stream._writableState;
  var sync = state.sync;
  var cb = state.writecb;

  onwriteStateUpdate(state);

  if (er) onwriteError(stream, state, sync, er, cb);else {
    // Check if we're actually ready to finish, but don't emit yet
    var finished = needFinish(state);

    if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) {
      clearBuffer(stream, state);
    }

    if (sync) {
      /*<replacement>*/
      asyncWrite(afterWrite, stream, state, finished, cb);
      /*</replacement>*/
    } else {
      afterWrite(stream, state, finished, cb);
    }
  }
}

function afterWrite(stream, state, finished, cb) {
  if (!finished) onwriteDrain(stream, state);
  state.pendingcb--;
  cb();
  finishMaybe(stream, state);
}

// Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function onwriteDrain(stream, state) {
  if (state.length === 0 && state.needDrain) {
    state.needDrain = false;
    stream.emit('drain');
  }
}

// if there's something in the buffer waiting, then process it
function clearBuffer(stream, state) {
  state.bufferProcessing = true;
  var entry = state.bufferedRequest;

  if (stream._writev && entry && entry.next) {
    // Fast case, write everything using _writev()
    var l = state.bufferedRequestCount;
    var buffer = new Array(l);
    var holder = state.corkedRequestsFree;
    holder.entry = entry;

    var count = 0;
    var allBuffers = true;
    while (entry) {
      buffer[count] = entry;
      if (!entry.isBuf) allBuffers = false;
      entry = entry.next;
      count += 1;
    }
    buffer.allBuffers = allBuffers;

    doWrite(stream, state, true, state.length, buffer, '', holder.finish);

    // doWrite is almost always async, defer these to save a bit of time
    // as the hot path ends with doWrite
    state.pendingcb++;
    state.lastBufferedRequest = null;
    if (holder.next) {
      state.corkedRequestsFree = holder.next;
      holder.next = null;
    } else {
      state.corkedRequestsFree = new CorkedRequest(state);
    }
    state.bufferedRequestCount = 0;
  } else {
    // Slow case, write chunks one-by-one
    while (entry) {
      var chunk = entry.chunk;
      var encoding = entry.encoding;
      var cb = entry.callback;
      var len = state.objectMode ? 1 : chunk.length;

      doWrite(stream, state, false, len, chunk, encoding, cb);
      entry = entry.next;
      state.bufferedRequestCount--;
      // if we didn't call the onwrite immediately, then
      // it means that we need to wait until it does.
      // also, that means that the chunk and cb are currently
      // being processed, so move the buffer counter past them.
      if (state.writing) {
        break;
      }
    }

    if (entry === null) state.lastBufferedRequest = null;
  }

  state.bufferedRequest = entry;
  state.bufferProcessing = false;
}

Writable.prototype._write = function (chunk, encoding, cb) {
  cb(new Error('_write() is not implemented'));
};

Writable.prototype._writev = null;

Writable.prototype.end = function (chunk, encoding, cb) {
  var state = this._writableState;

  if (typeof chunk === 'function') {
    cb = chunk;
    chunk = null;
    encoding = null;
  } else if (typeof encoding === 'function') {
    cb = encoding;
    encoding = null;
  }

  if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);

  // .end() fully uncorks
  if (state.corked) {
    state.corked = 1;
    this.uncork();
  }

  // ignore unnecessary end() calls.
  if (!state.ending && !state.finished) endWritable(this, state, cb);
};

function needFinish(state) {
  return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}
function callFinal(stream, state) {
  stream._final(function (err) {
    state.pendingcb--;
    if (err) {
      stream.emit('error', err);
    }
    state.prefinished = true;
    stream.emit('prefinish');
    finishMaybe(stream, state);
  });
}
function prefinish(stream, state) {
  if (!state.prefinished && !state.finalCalled) {
    if (typeof stream._final === 'function') {
      state.pendingcb++;
      state.finalCalled = true;
      pna.nextTick(callFinal, stream, state);
    } else {
      state.prefinished = true;
      stream.emit('prefinish');
    }
  }
}

function finishMaybe(stream, state) {
  var need = needFinish(state);
  if (need) {
    prefinish(stream, state);
    if (state.pendingcb === 0) {
      state.finished = true;
      stream.emit('finish');
    }
  }
  return need;
}

function endWritable(stream, state, cb) {
  state.ending = true;
  finishMaybe(stream, state);
  if (cb) {
    if (state.finished) pna.nextTick(cb);else stream.once('finish', cb);
  }
  state.ended = true;
  stream.writable = false;
}

function onCorkedFinish(corkReq, state, err) {
  var entry = corkReq.entry;
  corkReq.entry = null;
  while (entry) {
    var cb = entry.callback;
    state.pendingcb--;
    cb(err);
    entry = entry.next;
  }
  if (state.corkedRequestsFree) {
    state.corkedRequestsFree.next = corkReq;
  } else {
    state.corkedRequestsFree = corkReq;
  }
}

Object.defineProperty(Writable.prototype, 'destroyed', {
  get: function () {
    if (this._writableState === undefined) {
      return false;
    }
    return this._writableState.destroyed;
  },
  set: function (value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (!this._writableState) {
      return;
    }

    // backward compatibility, the user is explicitly
    // managing destroyed
    this._writableState.destroyed = value;
  }
});

Writable.prototype.destroy = destroyImpl.destroy;
Writable.prototype._undestroy = destroyImpl.undestroy;
Writable.prototype._destroy = function (err, cb) {
  this.end();
  cb(err);
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(74), __webpack_require__(2845).setImmediate, __webpack_require__(26)))

/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



/*<replacement>*/

var Buffer = __webpack_require__(289).Buffer;
/*</replacement>*/

var isEncoding = Buffer.isEncoding || function (encoding) {
  encoding = '' + encoding;
  switch (encoding && encoding.toLowerCase()) {
    case 'hex':case 'utf8':case 'utf-8':case 'ascii':case 'binary':case 'base64':case 'ucs2':case 'ucs-2':case 'utf16le':case 'utf-16le':case 'raw':
      return true;
    default:
      return false;
  }
};

function _normalizeEncoding(enc) {
  if (!enc) return 'utf8';
  var retried;
  while (true) {
    switch (enc) {
      case 'utf8':
      case 'utf-8':
        return 'utf8';
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return 'utf16le';
      case 'latin1':
      case 'binary':
        return 'latin1';
      case 'base64':
      case 'ascii':
      case 'hex':
        return enc;
      default:
        if (retried) return; // undefined
        enc = ('' + enc).toLowerCase();
        retried = true;
    }
  }
};

// Do not cache `Buffer.isEncoding` when checking encoding names as some
// modules monkey-patch it to support additional encodings
function normalizeEncoding(enc) {
  var nenc = _normalizeEncoding(enc);
  if (typeof nenc !== 'string' && (Buffer.isEncoding === isEncoding || !isEncoding(enc))) throw new Error('Unknown encoding: ' + enc);
  return nenc || enc;
}

// StringDecoder provides an interface for efficiently splitting a series of
// buffers into a series of JS strings without breaking apart multi-byte
// characters.
exports.StringDecoder = StringDecoder;
function StringDecoder(encoding) {
  this.encoding = normalizeEncoding(encoding);
  var nb;
  switch (this.encoding) {
    case 'utf16le':
      this.text = utf16Text;
      this.end = utf16End;
      nb = 4;
      break;
    case 'utf8':
      this.fillLast = utf8FillLast;
      nb = 4;
      break;
    case 'base64':
      this.text = base64Text;
      this.end = base64End;
      nb = 3;
      break;
    default:
      this.write = simpleWrite;
      this.end = simpleEnd;
      return;
  }
  this.lastNeed = 0;
  this.lastTotal = 0;
  this.lastChar = Buffer.allocUnsafe(nb);
}

StringDecoder.prototype.write = function (buf) {
  if (buf.length === 0) return '';
  var r;
  var i;
  if (this.lastNeed) {
    r = this.fillLast(buf);
    if (r === undefined) return '';
    i = this.lastNeed;
    this.lastNeed = 0;
  } else {
    i = 0;
  }
  if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
  return r || '';
};

StringDecoder.prototype.end = utf8End;

// Returns only complete characters in a Buffer
StringDecoder.prototype.text = utf8Text;

// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
StringDecoder.prototype.fillLast = function (buf) {
  if (this.lastNeed <= buf.length) {
    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
  }
  buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
  this.lastNeed -= buf.length;
};

// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
// continuation byte. If an invalid byte is detected, -2 is returned.
function utf8CheckByte(byte) {
  if (byte <= 0x7F) return 0;else if (byte >> 5 === 0x06) return 2;else if (byte >> 4 === 0x0E) return 3;else if (byte >> 3 === 0x1E) return 4;
  return byte >> 6 === 0x02 ? -1 : -2;
}

// Checks at most 3 bytes at the end of a Buffer in order to detect an
// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
// needed to complete the UTF-8 character (if applicable) are returned.
function utf8CheckIncomplete(self, buf, i) {
  var j = buf.length - 1;
  if (j < i) return 0;
  var nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) self.lastNeed = nb - 1;
    return nb;
  }
  if (--j < i || nb === -2) return 0;
  nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) self.lastNeed = nb - 2;
    return nb;
  }
  if (--j < i || nb === -2) return 0;
  nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) {
      if (nb === 2) nb = 0;else self.lastNeed = nb - 3;
    }
    return nb;
  }
  return 0;
}

// Validates as many continuation bytes for a multi-byte UTF-8 character as
// needed or are available. If we see a non-continuation byte where we expect
// one, we "replace" the validated continuation bytes we've seen so far with
// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
// behavior. The continuation byte check is included three times in the case
// where all of the continuation bytes for a character exist in the same buffer.
// It is also done this way as a slight performance increase instead of using a
// loop.
function utf8CheckExtraBytes(self, buf, p) {
  if ((buf[0] & 0xC0) !== 0x80) {
    self.lastNeed = 0;
    return '\ufffd';
  }
  if (self.lastNeed > 1 && buf.length > 1) {
    if ((buf[1] & 0xC0) !== 0x80) {
      self.lastNeed = 1;
      return '\ufffd';
    }
    if (self.lastNeed > 2 && buf.length > 2) {
      if ((buf[2] & 0xC0) !== 0x80) {
        self.lastNeed = 2;
        return '\ufffd';
      }
    }
  }
}

// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
function utf8FillLast(buf) {
  var p = this.lastTotal - this.lastNeed;
  var r = utf8CheckExtraBytes(this, buf, p);
  if (r !== undefined) return r;
  if (this.lastNeed <= buf.length) {
    buf.copy(this.lastChar, p, 0, this.lastNeed);
    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
  }
  buf.copy(this.lastChar, p, 0, buf.length);
  this.lastNeed -= buf.length;
}

// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
// partial character, the character's bytes are buffered until the required
// number of bytes are available.
function utf8Text(buf, i) {
  var total = utf8CheckIncomplete(this, buf, i);
  if (!this.lastNeed) return buf.toString('utf8', i);
  this.lastTotal = total;
  var end = buf.length - (total - this.lastNeed);
  buf.copy(this.lastChar, 0, end);
  return buf.toString('utf8', i, end);
}

// For UTF-8, a replacement character is added when ending on a partial
// character.
function utf8End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) return r + '\ufffd';
  return r;
}

// UTF-16LE typically needs two bytes per character, but even if we have an even
// number of bytes available, we need to check if we end on a leading/high
// surrogate. In that case, we need to wait for the next two bytes in order to
// decode the last character properly.
function utf16Text(buf, i) {
  if ((buf.length - i) % 2 === 0) {
    var r = buf.toString('utf16le', i);
    if (r) {
      var c = r.charCodeAt(r.length - 1);
      if (c >= 0xD800 && c <= 0xDBFF) {
        this.lastNeed = 2;
        this.lastTotal = 4;
        this.lastChar[0] = buf[buf.length - 2];
        this.lastChar[1] = buf[buf.length - 1];
        return r.slice(0, -1);
      }
    }
    return r;
  }
  this.lastNeed = 1;
  this.lastTotal = 2;
  this.lastChar[0] = buf[buf.length - 1];
  return buf.toString('utf16le', i, buf.length - 1);
}

// For UTF-16LE we do not explicitly append special replacement characters if we
// end on a partial character, we simply let v8 handle that.
function utf16End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) {
    var end = this.lastTotal - this.lastNeed;
    return r + this.lastChar.toString('utf16le', 0, end);
  }
  return r;
}

function base64Text(buf, i) {
  var n = (buf.length - i) % 3;
  if (n === 0) return buf.toString('base64', i);
  this.lastNeed = 3 - n;
  this.lastTotal = 3;
  if (n === 1) {
    this.lastChar[0] = buf[buf.length - 1];
  } else {
    this.lastChar[0] = buf[buf.length - 2];
    this.lastChar[1] = buf[buf.length - 1];
  }
  return buf.toString('base64', i, buf.length - n);
}

function base64End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) return r + this.lastChar.toString('base64', 0, 3 - this.lastNeed);
  return r;
}

// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
function simpleWrite(buf) {
  return buf.toString(this.encoding);
}

function simpleEnd(buf) {
  return buf && buf.length ? this.write(buf) : '';
}

/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(430).isArray;

module.exports = {

  copyOptions: function (options) {
    var key, copy = {};
    for (key in options) {
      if (options.hasOwnProperty(key)) {
        copy[key] = options[key];
      }
    }
    return copy;
  },

  ensureFlagExists: function (item, options) {
    if (!(item in options) || typeof options[item] !== 'boolean') {
      options[item] = false;
    }
  },

  ensureSpacesExists: function (options) {
    if (!('spaces' in options) || (typeof options.spaces !== 'number' && typeof options.spaces !== 'string')) {
      options.spaces = 0;
    }
  },

  ensureAlwaysArrayExists: function (options) {
    if (!('alwaysArray' in options) || (typeof options.alwaysArray !== 'boolean' && !isArray(options.alwaysArray))) {
      options.alwaysArray = false;
    }
  },

  ensureKeyExists: function (key, options) {
    if (!(key + 'Key' in options) || typeof options[key + 'Key'] !== 'string') {
      options[key + 'Key'] = options.compact ? '_' + key : key;
    }
  },

  checkFnExists: function (key, options) {
    return key + 'Fn' in options;
  }

};


/***/ }),
/* 430 */
/***/ (function(module, exports) {

module.exports = {

  isArray: function(value) {
    if (Array.isArray) {
      return Array.isArray(value);
    }
    // fallback for older browsers like  IE 8
    return Object.prototype.toString.call( value ) === '[object Array]';
  }

};


/***/ }),
/* 431 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fields; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return propertyMapping; });
var fields=['Name','Surname','Nickname','Second Names','Maiden Name','Initials','Full Name','Email','Title','Gender','SA ID','Smoker','Language','Correspondence Type','Cell number','Phone number','Date of birth','Age','Monthly Income','Wedding date','Marriage Status','File no.','Residential Address 1','Residential Address 2','Residential Address 3','Residential Address 4','Residential Postal Code','Postal Address 1','Postal Address 2','Postal Address 3','Postal Address 4','Postal Address Code','Bank Account Name','Bank Name','Branch Name','Branch Code','Account Type'];var propertyMapping={Name:'scd_name',Surname:'scd_surname',Nickname:'scd_nickName','Second Names':'scd_secondAndOtherNames','Maiden Name':'scd_maidenName',Initials:'scd_initials','Full Name':'full_name',Email:'scd_email',Title:'scd_title',Gender:'scd_gender','SA ID':'scd_saID',Smoker:'scd_smoker',Language:'scd_correspondenceLanguage','Correspondence Type':'scd_correspondenceType','Cell number':'scd_cellNumber','Phone number':'scd_phoneNumber','Date of birth':'date_of_birth',Age:'age','Monthly Income':'scd_monthlyIncome','Wedding date':'scd_weddingDate','Marriage Status':'scd_maritalStatus','File no.':'scd_clientFileNumber','Residential Address 1':'scd_residentialAddress','Residential Address 2':'scd_residentialAddress2','Residential Address 3':'scd_residentialAddress3','Residential Address 4':'scd_residentialAddress4','Residential Postal Code':'scd_postalCode','Postal Address 1':'scd_postalAddress1','Postal Address 2':'scd_postalAddress2','Postal Address 3':'scd_postalAddress3','Postal Address 4':'scd_postalAddress4','Postal Address Code':'scd_postalAddressCode','Bank Account Name':'sb_accountName','Bank Name':'sb_bank','Branch Name':'sb_branchName','Branch Code':'sb_branch','Account Type':'sb_accountType'};

/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var is_1 = __webpack_require__(125);
/**
 * Truncates given string to the maximum characters count
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string
 * @returns string Encoded
 */
function truncate(str, max) {
    if (max === void 0) { max = 0; }
    if (max === 0 || !is_1.isString(str)) {
        return str;
    }
    return str.length <= max ? str : str.substr(0, max) + "...";
}
exports.truncate = truncate;
/**
 * This is basically just `trim_line` from
 * https://github.com/getsentry/sentry/blob/master/src/sentry/lang/javascript/processor.py#L67
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string
 * @returns string Encoded
 */
function snipLine(line, colno) {
    var newLine = line;
    var ll = newLine.length;
    if (ll <= 150) {
        return newLine;
    }
    if (colno > ll) {
        colno = ll; // tslint:disable-line:no-parameter-reassignment
    }
    var start = Math.max(colno - 60, 0);
    if (start < 5) {
        start = 0;
    }
    var end = Math.min(start + 140, ll);
    if (end > ll - 5) {
        end = ll;
    }
    if (end === ll) {
        start = Math.max(end - 140, 0);
    }
    newLine = newLine.slice(start, end);
    if (start > 0) {
        newLine = "'{snip} " + newLine;
    }
    if (end < ll) {
        newLine += ' {snip}';
    }
    return newLine;
}
exports.snipLine = snipLine;
/**
 * Join values in array
 * @param input array of values to be joined together
 * @param delimiter string to be placed in-between values
 * @returns Joined values
 */
function safeJoin(input, delimiter) {
    if (!Array.isArray(input)) {
        return '';
    }
    var output = [];
    // tslint:disable-next-line
    for (var i = 0; i < input.length; i++) {
        var value = input[i];
        try {
            output.push(String(value));
        }
        catch (e) {
            output.push('[value cannot be serialized]');
        }
    }
    return output.join(delimiter);
}
exports.safeJoin = safeJoin;
/**
 * Checks if given value is included in the target
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/includes#Polyfill
 * @param target source string
 * @param search string to be looked for
 * @returns An answer
 */
function includes(target, search) {
    if (search.length > target.length) {
        return false;
    }
    else {
        return target.indexOf(search) !== -1;
    }
}
exports.includes = includes;
//# sourceMappingURL=string.js.map

/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(43);
var is_1 = __webpack_require__(125);
var object_1 = __webpack_require__(290);
var error_1 = __webpack_require__(291);
/** Regular expression used to parse a Dsn. */
var DSN_REGEX = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+))?@)([\w\.-]+)(?::(\d+))?\/(.+)/;
/** The Sentry Dsn, identifying a Sentry instance and project. */
var Dsn = /** @class */ (function () {
    /** Creates a new Dsn component */
    function Dsn(from) {
        if (typeof from === 'string') {
            this.fromString(from);
        }
        else {
            this.fromComponents(from);
        }
        this.validate();
    }
    /**
     * Renders the string representation of this Dsn.
     *
     * By default, this will render the public representation without the password
     * component. To get the deprecated private representation, set `withPassword`
     * to true.
     *
     * @param withPassword When set to true, the password will be included.
     */
    Dsn.prototype.toString = function (withPassword) {
        if (withPassword === void 0) { withPassword = false; }
        // tslint:disable-next-line:no-this-assignment
        var _a = this, host = _a.host, path = _a.path, pass = _a.pass, port = _a.port, projectId = _a.projectId, protocol = _a.protocol, user = _a.user;
        return (protocol + "://" + user + (withPassword && pass ? ":" + pass : '') +
            ("@" + host + (port ? ":" + port : '') + "/" + (path ? path + "/" : path) + projectId));
    };
    /** Parses a string into this Dsn. */
    Dsn.prototype.fromString = function (str) {
        var match = DSN_REGEX.exec(str);
        if (!match) {
            throw new error_1.SentryError('Invalid Dsn');
        }
        var _a = tslib_1.__read(match.slice(1), 6), protocol = _a[0], user = _a[1], _b = _a[2], pass = _b === void 0 ? '' : _b, host = _a[3], _c = _a[4], port = _c === void 0 ? '' : _c, lastPath = _a[5];
        var path = '';
        var projectId = lastPath;
        var split = projectId.split('/');
        if (split.length > 1) {
            path = split.slice(0, -1).join('/');
            projectId = split.pop();
        }
        object_1.assign(this, { host: host, pass: pass, path: path, projectId: projectId, port: port, protocol: protocol, user: user });
    };
    /** Maps Dsn components into this instance. */
    Dsn.prototype.fromComponents = function (components) {
        this.protocol = components.protocol;
        this.user = components.user;
        this.pass = components.pass || '';
        this.host = components.host;
        this.port = components.port || '';
        this.path = components.path || '';
        this.projectId = components.projectId;
    };
    /** Validates this Dsn and throws on error. */
    Dsn.prototype.validate = function () {
        var e_1, _a;
        try {
            for (var _b = tslib_1.__values(['protocol', 'user', 'host', 'projectId']), _c = _b.next(); !_c.done; _c = _b.next()) {
                var component = _c.value;
                if (!this[component]) {
                    throw new error_1.SentryError("Invalid Dsn: Missing " + component);
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
        if (this.protocol !== 'http' && this.protocol !== 'https') {
            throw new error_1.SentryError("Invalid Dsn: Unsupported protocol \"" + this.protocol + "\"");
        }
        if (this.port && is_1.isNaN(parseInt(this.port, 10))) {
            throw new error_1.SentryError("Invalid Dsn: Invalid port number \"" + this.port + "\"");
        }
    };
    return Dsn;
}());
exports.Dsn = Dsn;
//# sourceMappingURL=dsn.js.map

/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var asap = __webpack_require__(435);

function noop() {}

// States:
//
// 0 - pending
// 1 - fulfilled with _value
// 2 - rejected with _value
// 3 - adopted the state of another promise, _value
//
// once the state is no longer pending (0) it is immutable

// All `_` prefixed properties will be reduced to `_{random number}`
// at build time to obfuscate them and discourage their use.
// We don't use symbols or Object.defineProperty to fully hide them
// because the performance isn't good enough.


// to avoid using try/catch inside critical functions, we
// extract them to here.
var LAST_ERROR = null;
var IS_ERROR = {};
function getThen(obj) {
  try {
    return obj.then;
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

function tryCallOne(fn, a) {
  try {
    return fn(a);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}
function tryCallTwo(fn, a, b) {
  try {
    fn(a, b);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

module.exports = Promise;

function Promise(fn) {
  if (typeof this !== 'object') {
    throw new TypeError('Promises must be constructed via new');
  }
  if (typeof fn !== 'function') {
    throw new TypeError('Promise constructor\'s argument is not a function');
  }
  this._75 = 0;
  this._83 = 0;
  this._18 = null;
  this._38 = null;
  if (fn === noop) return;
  doResolve(fn, this);
}
Promise._47 = null;
Promise._71 = null;
Promise._44 = noop;

Promise.prototype.then = function(onFulfilled, onRejected) {
  if (this.constructor !== Promise) {
    return safeThen(this, onFulfilled, onRejected);
  }
  var res = new Promise(noop);
  handle(this, new Handler(onFulfilled, onRejected, res));
  return res;
};

function safeThen(self, onFulfilled, onRejected) {
  return new self.constructor(function (resolve, reject) {
    var res = new Promise(noop);
    res.then(resolve, reject);
    handle(self, new Handler(onFulfilled, onRejected, res));
  });
}
function handle(self, deferred) {
  while (self._83 === 3) {
    self = self._18;
  }
  if (Promise._47) {
    Promise._47(self);
  }
  if (self._83 === 0) {
    if (self._75 === 0) {
      self._75 = 1;
      self._38 = deferred;
      return;
    }
    if (self._75 === 1) {
      self._75 = 2;
      self._38 = [self._38, deferred];
      return;
    }
    self._38.push(deferred);
    return;
  }
  handleResolved(self, deferred);
}

function handleResolved(self, deferred) {
  asap(function() {
    var cb = self._83 === 1 ? deferred.onFulfilled : deferred.onRejected;
    if (cb === null) {
      if (self._83 === 1) {
        resolve(deferred.promise, self._18);
      } else {
        reject(deferred.promise, self._18);
      }
      return;
    }
    var ret = tryCallOne(cb, self._18);
    if (ret === IS_ERROR) {
      reject(deferred.promise, LAST_ERROR);
    } else {
      resolve(deferred.promise, ret);
    }
  });
}
function resolve(self, newValue) {
  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
  if (newValue === self) {
    return reject(
      self,
      new TypeError('A promise cannot be resolved with itself.')
    );
  }
  if (
    newValue &&
    (typeof newValue === 'object' || typeof newValue === 'function')
  ) {
    var then = getThen(newValue);
    if (then === IS_ERROR) {
      return reject(self, LAST_ERROR);
    }
    if (
      then === self.then &&
      newValue instanceof Promise
    ) {
      self._83 = 3;
      self._18 = newValue;
      finale(self);
      return;
    } else if (typeof then === 'function') {
      doResolve(then.bind(newValue), self);
      return;
    }
  }
  self._83 = 1;
  self._18 = newValue;
  finale(self);
}

function reject(self, newValue) {
  self._83 = 2;
  self._18 = newValue;
  if (Promise._71) {
    Promise._71(self, newValue);
  }
  finale(self);
}
function finale(self) {
  if (self._75 === 1) {
    handle(self, self._38);
    self._38 = null;
  }
  if (self._75 === 2) {
    for (var i = 0; i < self._38.length; i++) {
      handle(self, self._38[i]);
    }
    self._38 = null;
  }
}

function Handler(onFulfilled, onRejected, promise){
  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
  this.promise = promise;
}

/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */
function doResolve(fn, promise) {
  var done = false;
  var res = tryCallTwo(fn, function (value) {
    if (done) return;
    done = true;
    resolve(promise, value);
  }, function (reason) {
    if (done) return;
    done = true;
    reject(promise, reason);
  });
  if (!done && res === IS_ERROR) {
    done = true;
    reject(promise, LAST_ERROR);
  }
}


/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

// Use the fastest means possible to execute a task in its own turn, with
// priority over other events including IO, animation, reflow, and redraw
// events in browsers.
//
// An exception thrown by a task will permanently interrupt the processing of
// subsequent tasks. The higher level `asap` function ensures that if an
// exception is thrown by a task, that the task queue will continue flushing as
// soon as possible, but if you use `rawAsap` directly, you are responsible to
// either ensure that no exceptions are thrown from your task, or to manually
// call `rawAsap.requestFlush` if an exception is thrown.
module.exports = rawAsap;
function rawAsap(task) {
    if (!queue.length) {
        requestFlush();
        flushing = true;
    }
    // Equivalent to push, but avoids a function call.
    queue[queue.length] = task;
}

var queue = [];
// Once a flush has been requested, no further calls to `requestFlush` are
// necessary until the next `flush` completes.
var flushing = false;
// `requestFlush` is an implementation-specific method that attempts to kick
// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
// the event queue before yielding to the browser's own event loop.
var requestFlush;
// The position of the next task to execute in the task queue. This is
// preserved between calls to `flush` so that it can be resumed if
// a task throws an exception.
var index = 0;
// If a task schedules additional tasks recursively, the task queue can grow
// unbounded. To prevent memory exhaustion, the task queue will periodically
// truncate already-completed tasks.
var capacity = 1024;

// The flush function processes all tasks that have been scheduled with
// `rawAsap` unless and until one of those tasks throws an exception.
// If a task throws an exception, `flush` ensures that its state will remain
// consistent and will resume where it left off when called again.
// However, `flush` does not make any arrangements to be called again if an
// exception is thrown.
function flush() {
    while (index < queue.length) {
        var currentIndex = index;
        // Advance the index before calling the task. This ensures that we will
        // begin flushing on the next task the task throws an error.
        index = index + 1;
        queue[currentIndex].call();
        // Prevent leaking memory for long chains of recursive calls to `asap`.
        // If we call `asap` within tasks scheduled by `asap`, the queue will
        // grow, but to avoid an O(n) walk for every task we execute, we don't
        // shift tasks off the queue after they have been executed.
        // Instead, we periodically shift 1024 tasks off the queue.
        if (index > capacity) {
            // Manually shift all values starting at the index back to the
            // beginning of the queue.
            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
                queue[scan] = queue[scan + index];
            }
            queue.length -= index;
            index = 0;
        }
    }
    queue.length = 0;
    index = 0;
    flushing = false;
}

// `requestFlush` is implemented using a strategy based on data collected from
// every available SauceLabs Selenium web driver worker at time of writing.
// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593

// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
// have WebKitMutationObserver but not un-prefixed MutationObserver.
// Must use `global` or `self` instead of `window` to work in both frames and web
// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.

/* globals self */
var scope = typeof global !== "undefined" ? global : self;
var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;

// MutationObservers are desirable because they have high priority and work
// reliably everywhere they are implemented.
// They are implemented in all modern browsers.
//
// - Android 4-4.3
// - Chrome 26-34
// - Firefox 14-29
// - Internet Explorer 11
// - iPad Safari 6-7.1
// - iPhone Safari 7-7.1
// - Safari 6-7
if (typeof BrowserMutationObserver === "function") {
    requestFlush = makeRequestCallFromMutationObserver(flush);

// MessageChannels are desirable because they give direct access to the HTML
// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
// 11-12, and in web workers in many engines.
// Although message channels yield to any queued rendering and IO tasks, they
// would be better than imposing the 4ms delay of timers.
// However, they do not work reliably in Internet Explorer or Safari.

// Internet Explorer 10 is the only browser that has setImmediate but does
// not have MutationObservers.
// Although setImmediate yields to the browser's renderer, it would be
// preferrable to falling back to setTimeout since it does not have
// the minimum 4ms penalty.
// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
// Desktop to a lesser extent) that renders both setImmediate and
// MessageChannel useless for the purposes of ASAP.
// https://github.com/kriskowal/q/issues/396

// Timers are implemented universally.
// We fall back to timers in workers in most engines, and in foreground
// contexts in the following browsers.
// However, note that even this simple case requires nuances to operate in a
// broad spectrum of browsers.
//
// - Firefox 3-13
// - Internet Explorer 6-9
// - iPad Safari 4.3
// - Lynx 2.8.7
} else {
    requestFlush = makeRequestCallFromTimer(flush);
}

// `requestFlush` requests that the high priority event queue be flushed as
// soon as possible.
// This is useful to prevent an error thrown in a task from stalling the event
// queue if the exception handled by Node.js’s
// `process.on("uncaughtException")` or by a domain.
rawAsap.requestFlush = requestFlush;

// To request a high priority event, we induce a mutation observer by toggling
// the text of a text node between "1" and "-1".
function makeRequestCallFromMutationObserver(callback) {
    var toggle = 1;
    var observer = new BrowserMutationObserver(callback);
    var node = document.createTextNode("");
    observer.observe(node, {characterData: true});
    return function requestCall() {
        toggle = -toggle;
        node.data = toggle;
    };
}

// The message channel technique was discovered by Malte Ubl and was the
// original foundation for this library.
// http://www.nonblocking.io/2011/06/windownexttick.html

// Safari 6.0.5 (at least) intermittently fails to create message ports on a
// page's first load. Thankfully, this version of Safari supports
// MutationObservers, so we don't need to fall back in that case.

// function makeRequestCallFromMessageChannel(callback) {
//     var channel = new MessageChannel();
//     channel.port1.onmessage = callback;
//     return function requestCall() {
//         channel.port2.postMessage(0);
//     };
// }

// For reasons explained above, we are also unable to use `setImmediate`
// under any circumstances.
// Even if we were, there is another bug in Internet Explorer 10.
// It is not sufficient to assign `setImmediate` to `requestFlush` because
// `setImmediate` must be called *by name* and therefore must be wrapped in a
// closure.
// Never forget.

// function makeRequestCallFromSetImmediate(callback) {
//     return function requestCall() {
//         setImmediate(callback);
//     };
// }

// Safari 6.0 has a problem where timers will get lost while the user is
// scrolling. This problem does not impact ASAP because Safari 6.0 supports
// mutation observers, so that implementation is used instead.
// However, if we ever elect to use timers in Safari, the prevalent work-around
// is to add a scroll event listener that calls for a flush.

// `setTimeout` does not call the passed callback if the delay is less than
// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
// even then.

function makeRequestCallFromTimer(callback) {
    return function requestCall() {
        // We dispatch a timeout with a specified delay of 0 for engines that
        // can reliably accommodate that request. This will usually be snapped
        // to a 4 milisecond delay, but once we're flushing, there's no delay
        // between events.
        var timeoutHandle = setTimeout(handleTimer, 0);
        // However, since this timer gets frequently dropped in Firefox
        // workers, we enlist an interval handle that will try to fire
        // an event 20 times per second until it succeeds.
        var intervalHandle = setInterval(handleTimer, 50);

        function handleTimer() {
            // Whichever timer succeeds will cancel both timers and
            // execute the callback.
            clearTimeout(timeoutHandle);
            clearInterval(intervalHandle);
            callback();
        }
    };
}

// This is for `asap.js` only.
// Its name will be periodically randomized to break any code that depends on
// its existence.
rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;

// ASAP was originally a nextTick shim included in Q. This was factored out
// into this ASAP package. It was later adapted to RSVP which made further
// amendments. These decisions, particularly to marginalize MessageChannel and
// to capture the MutationObserver implementation in a closure, were integrated
// back into ASAP proper.
// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(26)))

/***/ }),
/* 436 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
function isAbsolute(pathname) {
  return pathname.charAt(0) === '/';
}

// About 1.5x faster than the two-arg version of Array#splice()
function spliceOne(list, index) {
  for (var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1) {
    list[i] = list[k];
  }

  list.pop();
}

// This implementation is based heavily on node's url.parse
function resolvePathname(to) {
  var from = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  var toParts = to && to.split('/') || [];
  var fromParts = from && from.split('/') || [];

  var isToAbs = to && isAbsolute(to);
  var isFromAbs = from && isAbsolute(from);
  var mustEndAbs = isToAbs || isFromAbs;

  if (to && isAbsolute(to)) {
    // to is absolute
    fromParts = toParts;
  } else if (toParts.length) {
    // to is relative, drop the filename
    fromParts.pop();
    fromParts = fromParts.concat(toParts);
  }

  if (!fromParts.length) return '/';

  var hasTrailingSlash = void 0;
  if (fromParts.length) {
    var last = fromParts[fromParts.length - 1];
    hasTrailingSlash = last === '.' || last === '..' || last === '';
  } else {
    hasTrailingSlash = false;
  }

  var up = 0;
  for (var i = fromParts.length; i >= 0; i--) {
    var part = fromParts[i];

    if (part === '.') {
      spliceOne(fromParts, i);
    } else if (part === '..') {
      spliceOne(fromParts, i);
      up++;
    } else if (up) {
      spliceOne(fromParts, i);
      up--;
    }
  }

  if (!mustEndAbs) for (; up--; up) {
    fromParts.unshift('..');
  }if (mustEndAbs && fromParts[0] !== '' && (!fromParts[0] || !isAbsolute(fromParts[0]))) fromParts.unshift('');

  var result = fromParts.join('/');

  if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';

  return result;
}

/* harmony default export */ __webpack_exports__["default"] = (resolvePathname);

/***/ }),
/* 437 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function valueEqual(a, b) {
  if (a === b) return true;

  if (a == null || b == null) return false;

  if (Array.isArray(a)) {
    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
      return valueEqual(item, b[index]);
    });
  }

  var aType = typeof a === 'undefined' ? 'undefined' : _typeof(a);
  var bType = typeof b === 'undefined' ? 'undefined' : _typeof(b);

  if (aType !== bType) return false;

  if (aType === 'object') {
    var aValue = a.valueOf();
    var bValue = b.valueOf();

    if (aValue !== a || bValue !== b) return valueEqual(aValue, bValue);

    var aKeys = Object.keys(a);
    var bKeys = Object.keys(b);

    if (aKeys.length !== bKeys.length) return false;

    return aKeys.every(function (key) {
      return valueEqual(a[key], b[key]);
    });
  }

  return false;
}

/* harmony default export */ __webpack_exports__["default"] = (valueEqual);

/***/ }),
/* 438 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return canUseDOM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addEventListener; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return removeEventListener; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getConfirmation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return supportsHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return supportsPopStateOnHashChange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return supportsGoWithoutReloadUsingHash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return isExtraneousPopstateEvent; });
var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

var addEventListener = function addEventListener(node, event, listener) {
  return node.addEventListener ? node.addEventListener(event, listener, false) : node.attachEvent('on' + event, listener);
};

var removeEventListener = function removeEventListener(node, event, listener) {
  return node.removeEventListener ? node.removeEventListener(event, listener, false) : node.detachEvent('on' + event, listener);
};

var getConfirmation = function getConfirmation(message, callback) {
  return callback(window.confirm(message));
}; // eslint-disable-line no-alert

/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */
var supportsHistory = function supportsHistory() {
  var ua = window.navigator.userAgent;

  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;

  return window.history && 'pushState' in window.history;
};

/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */
var supportsPopStateOnHashChange = function supportsPopStateOnHashChange() {
  return window.navigator.userAgent.indexOf('Trident') === -1;
};

/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */
var supportsGoWithoutReloadUsingHash = function supportsGoWithoutReloadUsingHash() {
  return window.navigator.userAgent.indexOf('Firefox') === -1;
};

/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */
var isExtraneousPopstateEvent = function isExtraneousPopstateEvent(event) {
  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
};

/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = function() {};

if (false) {
  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
        '`warning(condition, format, ...args)` requires a warning ' +
        'message argument'
      );
    }

    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
      throw new Error(
        'The warning format should be able to uniquely identify this ' +
        'warning. Please, use a more descriptive format than: ' + format
      );
    }

    if (!condition) {
      var argIndex = 0;
      var message = 'Warning: ' +
        format.replace(/%s/g, function() {
          return args[argIndex++];
        });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch(x) {}
    }
  };
}

module.exports = warning;


/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _warning = __webpack_require__(103);

var _warning2 = _interopRequireDefault(_warning);

var _invariant = __webpack_require__(35);

var _invariant2 = _interopRequireDefault(_invariant);

var _LocationUtils = __webpack_require__(441);

var _PathUtils = __webpack_require__(297);

var _createTransitionManager = __webpack_require__(442);

var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);

var _DOMUtils = __webpack_require__(443);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PopStateEvent = 'popstate';
var HashChangeEvent = 'hashchange';

var getHistoryState = function getHistoryState() {
  try {
    return window.history.state || {};
  } catch (e) {
    // IE 11 sometimes throws when accessing window.history.state
    // See https://github.com/ReactTraining/history/pull/289
    return {};
  }
};

/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */
var createBrowserHistory = function createBrowserHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  (0, _invariant2.default)(_DOMUtils.canUseDOM, 'Browser history needs a DOM');

  var globalHistory = window.history;
  var canUseHistory = (0, _DOMUtils.supportsHistory)();
  var needsHashChangeListener = !(0, _DOMUtils.supportsPopStateOnHashChange)();

  var _props$forceRefresh = props.forceRefresh,
      forceRefresh = _props$forceRefresh === undefined ? false : _props$forceRefresh,
      _props$getUserConfirm = props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === undefined ? _DOMUtils.getConfirmation : _props$getUserConfirm,
      _props$keyLength = props.keyLength,
      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;

  var basename = props.basename ? (0, _PathUtils.stripTrailingSlash)((0, _PathUtils.addLeadingSlash)(props.basename)) : '';

  var getDOMLocation = function getDOMLocation(historyState) {
    var _ref = historyState || {},
        key = _ref.key,
        state = _ref.state;

    var _window$location = window.location,
        pathname = _window$location.pathname,
        search = _window$location.search,
        hash = _window$location.hash;


    var path = pathname + search + hash;

    (0, _warning2.default)(!basename || (0, _PathUtils.hasBasename)(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".');

    if (basename) path = (0, _PathUtils.stripBasename)(path, basename);

    return (0, _LocationUtils.createLocation)(path, state, key);
  };

  var createKey = function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  };

  var transitionManager = (0, _createTransitionManager2.default)();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = globalHistory.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var handlePopState = function handlePopState(event) {
    // Ignore extraneous popstate events in WebKit.
    if ((0, _DOMUtils.isExtraneousPopstateEvent)(event)) return;

    handlePop(getDOMLocation(event.state));
  };

  var handleHashChange = function handleHashChange() {
    handlePop(getDOMLocation(getHistoryState()));
  };

  var forceNextPop = false;

  var handlePop = function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';

      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({ action: action, location: location });
        } else {
          revertPop(location);
        }
      });
    }
  };

  var revertPop = function revertPop(fromLocation) {
    var toLocation = history.location;

    // TODO: We could probably make this more reliable by
    // keeping a list of keys we've seen in sessionStorage.
    // Instead, we just default to 0 for keys we don't know.

    var toIndex = allKeys.indexOf(toLocation.key);

    if (toIndex === -1) toIndex = 0;

    var fromIndex = allKeys.indexOf(fromLocation.key);

    if (fromIndex === -1) fromIndex = 0;

    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  };

  var initialLocation = getDOMLocation(getHistoryState());
  var allKeys = [initialLocation.key];

  // Public interface

  var createHref = function createHref(location) {
    return basename + (0, _PathUtils.createPath)(location);
  };

  var push = function push(path, state) {
    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'PUSH';
    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var href = createHref(location);
      var key = location.key,
          state = location.state;


      if (canUseHistory) {
        globalHistory.pushState({ key: key, state: state }, null, href);

        if (forceRefresh) {
          window.location.href = href;
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          var nextKeys = allKeys.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);

          nextKeys.push(location.key);
          allKeys = nextKeys;

          setState({ action: action, location: location });
        }
      } else {
        (0, _warning2.default)(state === undefined, 'Browser history cannot push state in browsers that do not support HTML5 history');

        window.location.href = href;
      }
    });
  };

  var replace = function replace(path, state) {
    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'REPLACE';
    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var href = createHref(location);
      var key = location.key,
          state = location.state;


      if (canUseHistory) {
        globalHistory.replaceState({ key: key, state: state }, null, href);

        if (forceRefresh) {
          window.location.replace(href);
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);

          if (prevIndex !== -1) allKeys[prevIndex] = location.key;

          setState({ action: action, location: location });
        }
      } else {
        (0, _warning2.default)(state === undefined, 'Browser history cannot replace state in browsers that do not support HTML5 history');

        window.location.replace(href);
      }
    });
  };

  var go = function go(n) {
    globalHistory.go(n);
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var listenerCount = 0;

  var checkDOMListeners = function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1) {
      (0, _DOMUtils.addEventListener)(window, PopStateEvent, handlePopState);

      if (needsHashChangeListener) (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      (0, _DOMUtils.removeEventListener)(window, PopStateEvent, handlePopState);

      if (needsHashChangeListener) (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleHashChange);
    }
  };

  var isBlocked = false;

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  };

  var listen = function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);

    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  };

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };

  return history;
};

exports.default = createBrowserHistory;

/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.locationsAreEqual = exports.createLocation = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _resolvePathname = __webpack_require__(436);

var _resolvePathname2 = _interopRequireDefault(_resolvePathname);

var _valueEqual = __webpack_require__(437);

var _valueEqual2 = _interopRequireDefault(_valueEqual);

var _PathUtils = __webpack_require__(297);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createLocation = exports.createLocation = function createLocation(path, state, key, currentLocation) {
  var location = void 0;
  if (typeof path === 'string') {
    // Two-arg form: push(path, state)
    location = (0, _PathUtils.parsePath)(path);
    location.state = state;
  } else {
    // One-arg form: push(location)
    location = _extends({}, path);

    if (location.pathname === undefined) location.pathname = '';

    if (location.search) {
      if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
    } else {
      location.search = '';
    }

    if (location.hash) {
      if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
    } else {
      location.hash = '';
    }

    if (state !== undefined && location.state === undefined) location.state = state;
  }

  try {
    location.pathname = decodeURI(location.pathname);
  } catch (e) {
    if (e instanceof URIError) {
      throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
    } else {
      throw e;
    }
  }

  if (key) location.key = key;

  if (currentLocation) {
    // Resolve incomplete/relative pathname relative to current location.
    if (!location.pathname) {
      location.pathname = currentLocation.pathname;
    } else if (location.pathname.charAt(0) !== '/') {
      location.pathname = (0, _resolvePathname2.default)(location.pathname, currentLocation.pathname);
    }
  } else {
    // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) {
      location.pathname = '/';
    }
  }

  return location;
};

var locationsAreEqual = exports.locationsAreEqual = function locationsAreEqual(a, b) {
  return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && (0, _valueEqual2.default)(a.state, b.state);
};

/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _warning = __webpack_require__(103);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createTransitionManager = function createTransitionManager() {
  var prompt = null;

  var setPrompt = function setPrompt(nextPrompt) {
    (0, _warning2.default)(prompt == null, 'A history supports only one prompt at a time');

    prompt = nextPrompt;

    return function () {
      if (prompt === nextPrompt) prompt = null;
    };
  };

  var confirmTransitionTo = function confirmTransitionTo(location, action, getUserConfirmation, callback) {
    // TODO: If another transition starts while we're still confirming
    // the previous one, we may end up in a weird state. Figure out the
    // best way to handle this.
    if (prompt != null) {
      var result = typeof prompt === 'function' ? prompt(location, action) : prompt;

      if (typeof result === 'string') {
        if (typeof getUserConfirmation === 'function') {
          getUserConfirmation(result, callback);
        } else {
          (0, _warning2.default)(false, 'A history needs a getUserConfirmation function in order to use a prompt message');

          callback(true);
        }
      } else {
        // Return false from a transition hook to cancel the transition.
        callback(result !== false);
      }
    } else {
      callback(true);
    }
  };

  var listeners = [];

  var appendListener = function appendListener(fn) {
    var isActive = true;

    var listener = function listener() {
      if (isActive) fn.apply(undefined, arguments);
    };

    listeners.push(listener);

    return function () {
      isActive = false;
      listeners = listeners.filter(function (item) {
        return item !== listener;
      });
    };
  };

  var notifyListeners = function notifyListeners() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    listeners.forEach(function (listener) {
      return listener.apply(undefined, args);
    });
  };

  return {
    setPrompt: setPrompt,
    confirmTransitionTo: confirmTransitionTo,
    appendListener: appendListener,
    notifyListeners: notifyListeners
  };
};

exports.default = createTransitionManager;

/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var canUseDOM = exports.canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

var addEventListener = exports.addEventListener = function addEventListener(node, event, listener) {
  return node.addEventListener ? node.addEventListener(event, listener, false) : node.attachEvent('on' + event, listener);
};

var removeEventListener = exports.removeEventListener = function removeEventListener(node, event, listener) {
  return node.removeEventListener ? node.removeEventListener(event, listener, false) : node.detachEvent('on' + event, listener);
};

var getConfirmation = exports.getConfirmation = function getConfirmation(message, callback) {
  return callback(window.confirm(message));
}; // eslint-disable-line no-alert

/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */
var supportsHistory = exports.supportsHistory = function supportsHistory() {
  var ua = window.navigator.userAgent;

  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;

  return window.history && 'pushState' in window.history;
};

/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */
var supportsPopStateOnHashChange = exports.supportsPopStateOnHashChange = function supportsPopStateOnHashChange() {
  return window.navigator.userAgent.indexOf('Trident') === -1;
};

/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */
var supportsGoWithoutReloadUsingHash = exports.supportsGoWithoutReloadUsingHash = function supportsGoWithoutReloadUsingHash() {
  return window.navigator.userAgent.indexOf('Firefox') === -1;
};

/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */
var isExtraneousPopstateEvent = exports.isExtraneousPopstateEvent = function isExtraneousPopstateEvent(event) {
  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
};

/***/ }),
/* 444 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var isModifiedEvent = function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
};

/**
 * The public API for rendering a history-aware <a>.
 */

var Link = function (_React$Component) {
  _inherits(Link, _React$Component);

  function Link() {
    var _temp, _this, _ret;

    _classCallCheck(this, Link);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleClick = function (event) {
      if (_this.props.onClick) _this.props.onClick(event);

      if (!event.defaultPrevented && // onClick prevented default
      event.button === 0 && // ignore right clicks
      !_this.props.target && // let browser handle "target=_blank" etc.
      !isModifiedEvent(event) // ignore clicks with modifier keys
      ) {
          event.preventDefault();

          var history = _this.context.router.history;
          var _this$props = _this.props,
              replace = _this$props.replace,
              to = _this$props.to;


          if (replace) {
            history.replace(to);
          } else {
            history.push(to);
          }
        }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Link.prototype.render = function render() {
    var _props = this.props,
        replace = _props.replace,
        to = _props.to,
        innerRef = _props.innerRef,
        props = _objectWithoutProperties(_props, ['replace', 'to', 'innerRef']); // eslint-disable-line no-unused-vars

    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(this.context.router, 'You should not use <Link> outside a <Router>');

    var href = this.context.router.history.createHref(typeof to === 'string' ? { pathname: to } : to);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', _extends({}, props, { onClick: this.handleClick, href: href, ref: innerRef }));
  };

  return Link;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Link.propTypes = {
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  target: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]).isRequired,
  innerRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func])
};
Link.defaultProps = {
  replace: false
};
Link.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      createHref: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Link);

/***/ }),
/* 445 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(211);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that stores location in memory.
 */

var MemoryRouter = function (_React$Component) {
  _inherits(MemoryRouter, _React$Component);

  function MemoryRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, MemoryRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["c" /* createMemoryHistory */])(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  MemoryRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<MemoryRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { MemoryRouter as Router }`.");
  };

  MemoryRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return MemoryRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

MemoryRouter.propTypes = {
  initialEntries: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,
  initialIndex: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  keyLength: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* harmony default export */ __webpack_exports__["a"] = (MemoryRouter);

/***/ }),
/* 446 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Route__ = __webpack_require__(299);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Route__["a" /* default */]);

/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

var isarray = __webpack_require__(778)

/**
 * Expose `pathToRegexp`.
 */
module.exports = pathToRegexp
module.exports.parse = parse
module.exports.compile = compile
module.exports.tokensToFunction = tokensToFunction
module.exports.tokensToRegExp = tokensToRegExp

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g')

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = []
  var key = 0
  var index = 0
  var path = ''
  var defaultDelimiter = options && options.delimiter || '/'
  var res

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0]
    var escaped = res[1]
    var offset = res.index
    path += str.slice(index, offset)
    index = offset + m.length

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1]
      continue
    }

    var next = str[index]
    var prefix = res[2]
    var name = res[3]
    var capture = res[4]
    var group = res[5]
    var modifier = res[6]
    var asterisk = res[7]

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path)
      path = ''
    }

    var partial = prefix != null && next != null && next !== prefix
    var repeat = modifier === '+' || modifier === '*'
    var optional = modifier === '?' || modifier === '*'
    var delimiter = res[2] || defaultDelimiter
    var pattern = capture || group

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
    })
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index)
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path)
  }

  return tokens
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options))
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length)

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$')
    }
  }

  return function (obj, opts) {
    var path = ''
    var data = obj || {}
    var options = opts || {}
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i]

      if (typeof token === 'string') {
        path += token

        continue
      }

      var value = data[token.name]
      var segment

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j])

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value)

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g)

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      })
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = []

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source)
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options))

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  var strict = options.strict
  var end = options.end !== false
  var route = ''

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i]

    if (typeof token === 'string') {
      route += escapeString(token)
    } else {
      var prefix = escapeString(token.prefix)
      var capture = '(?:' + token.pattern + ')'

      keys.push(token)

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*'
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?'
        } else {
          capture = prefix + '(' + capture + ')?'
        }
      } else {
        capture = prefix + '(' + capture + ')'
      }

      route += capture
    }
  }

  var delimiter = escapeString(options.delimiter || '/')
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?'
  }

  if (end) {
    route += '$'
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)'
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */ (keys))
  }

  if (isarray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
  }

  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
}


/***/ }),
/* 448 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





/**
 * The public API for prompting the user before navigating away
 * from a screen with a component.
 */

var Prompt = function (_React$Component) {
  _inherits(Prompt, _React$Component);

  function Prompt() {
    _classCallCheck(this, Prompt);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Prompt.prototype.enable = function enable(message) {
    if (this.unblock) this.unblock();

    this.unblock = this.context.router.history.block(message);
  };

  Prompt.prototype.disable = function disable() {
    if (this.unblock) {
      this.unblock();
      this.unblock = null;
    }
  };

  Prompt.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(this.context.router, "You should not use <Prompt> outside a <Router>");

    if (this.props.when) this.enable(this.props.message);
  };

  Prompt.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.when) {
      if (!this.props.when || this.props.message !== nextProps.message) this.enable(nextProps.message);
    } else {
      this.disable();
    }
  };

  Prompt.prototype.componentWillUnmount = function componentWillUnmount() {
    this.disable();
  };

  Prompt.prototype.render = function render() {
    return null;
  };

  return Prompt;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Prompt.propTypes = {
  when: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  message: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]).isRequired
};
Prompt.defaultProps = {
  when: true
};
Prompt.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      block: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Prompt);

/***/ }),
/* 449 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_history__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__generatePath__ = __webpack_require__(450);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








/**
 * The public API for updating the location programmatically
 * with a component.
 */

var Redirect = function (_React$Component) {
  _inherits(Redirect, _React$Component);

  function Redirect() {
    _classCallCheck(this, Redirect);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Redirect.prototype.isStatic = function isStatic() {
    return this.context.router && this.context.router.staticContext;
  };

  Redirect.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_3_invariant___default()(this.context.router, "You should not use <Redirect> outside a <Router>");

    if (this.isStatic()) this.perform();
  };

  Redirect.prototype.componentDidMount = function componentDidMount() {
    if (!this.isStatic()) this.perform();
  };

  Redirect.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    var prevTo = Object(__WEBPACK_IMPORTED_MODULE_4_history__["b" /* createLocation */])(prevProps.to);
    var nextTo = Object(__WEBPACK_IMPORTED_MODULE_4_history__["b" /* createLocation */])(this.props.to);

    if (Object(__WEBPACK_IMPORTED_MODULE_4_history__["e" /* locationsAreEqual */])(prevTo, nextTo)) {
      __WEBPACK_IMPORTED_MODULE_2_warning___default()(false, "You tried to redirect to the same route you're currently on: " + ("\"" + nextTo.pathname + nextTo.search + "\""));
      return;
    }

    this.perform();
  };

  Redirect.prototype.computeTo = function computeTo(_ref) {
    var computedMatch = _ref.computedMatch,
        to = _ref.to;

    if (computedMatch) {
      if (typeof to === "string") {
        return Object(__WEBPACK_IMPORTED_MODULE_5__generatePath__["a" /* default */])(to, computedMatch.params);
      } else {
        return _extends({}, to, {
          pathname: Object(__WEBPACK_IMPORTED_MODULE_5__generatePath__["a" /* default */])(to.pathname, computedMatch.params)
        });
      }
    }

    return to;
  };

  Redirect.prototype.perform = function perform() {
    var history = this.context.router.history;
    var push = this.props.push;

    var to = this.computeTo(this.props);

    if (push) {
      history.push(to);
    } else {
      history.replace(to);
    }
  };

  Redirect.prototype.render = function render() {
    return null;
  };

  return Redirect;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Redirect.propTypes = {
  computedMatch: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object, // private, from <Switch>
  push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  from: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]).isRequired
};
Redirect.defaultProps = {
  push: false
};
Redirect.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired,
    staticContext: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Redirect);

/***/ }),
/* 450 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp__ = __webpack_require__(447);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_path_to_regexp__);


var patternCache = {};
var cacheLimit = 10000;
var cacheCount = 0;

var compileGenerator = function compileGenerator(pattern) {
  var cacheKey = pattern;
  var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});

  if (cache[pattern]) return cache[pattern];

  var compiledGenerator = __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default.a.compile(pattern);

  if (cacheCount < cacheLimit) {
    cache[pattern] = compiledGenerator;
    cacheCount++;
  }

  return compiledGenerator;
};

/**
 * Public API for generating a URL pathname from a pattern and parameters.
 */
var generatePath = function generatePath() {
  var pattern = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "/";
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (pattern === "/") {
    return pattern;
  }
  var generator = compileGenerator(pattern);
  return generator(params, { pretty: true });
};

/* harmony default export */ __webpack_exports__["a"] = (generatePath);

/***/ }),
/* 451 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_history__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Router__ = __webpack_require__(211);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var addLeadingSlash = function addLeadingSlash(path) {
  return path.charAt(0) === "/" ? path : "/" + path;
};

var addBasename = function addBasename(basename, location) {
  if (!basename) return location;

  return _extends({}, location, {
    pathname: addLeadingSlash(basename) + location.pathname
  });
};

var stripBasename = function stripBasename(basename, location) {
  if (!basename) return location;

  var base = addLeadingSlash(basename);

  if (location.pathname.indexOf(base) !== 0) return location;

  return _extends({}, location, {
    pathname: location.pathname.substr(base.length)
  });
};

var createURL = function createURL(location) {
  return typeof location === "string" ? location : Object(__WEBPACK_IMPORTED_MODULE_4_history__["d" /* createPath */])(location);
};

var staticHandler = function staticHandler(methodName) {
  return function () {
    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(false, "You cannot %s with <StaticRouter>", methodName);
  };
};

var noop = function noop() {};

/**
 * The public top-level API for a "static" <Router>, so-called because it
 * can't actually change the current location. Instead, it just records
 * location changes in a context object. Useful mainly in testing and
 * server-rendering scenarios.
 */

var StaticRouter = function (_React$Component) {
  _inherits(StaticRouter, _React$Component);

  function StaticRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, StaticRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.createHref = function (path) {
      return addLeadingSlash(_this.props.basename + createURL(path));
    }, _this.handlePush = function (location) {
      var _this$props = _this.props,
          basename = _this$props.basename,
          context = _this$props.context;

      context.action = "PUSH";
      context.location = addBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_4_history__["b" /* createLocation */])(location));
      context.url = createURL(context.location);
    }, _this.handleReplace = function (location) {
      var _this$props2 = _this.props,
          basename = _this$props2.basename,
          context = _this$props2.context;

      context.action = "REPLACE";
      context.location = addBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_4_history__["b" /* createLocation */])(location));
      context.url = createURL(context.location);
    }, _this.handleListen = function () {
      return noop;
    }, _this.handleBlock = function () {
      return noop;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  StaticRouter.prototype.getChildContext = function getChildContext() {
    return {
      router: {
        staticContext: this.props.context
      }
    };
  };

  StaticRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<StaticRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { StaticRouter as Router }`.");
  };

  StaticRouter.prototype.render = function render() {
    var _props = this.props,
        basename = _props.basename,
        context = _props.context,
        location = _props.location,
        props = _objectWithoutProperties(_props, ["basename", "context", "location"]);

    var history = {
      createHref: this.createHref,
      action: "POP",
      location: stripBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_4_history__["b" /* createLocation */])(location)),
      push: this.handlePush,
      replace: this.handleReplace,
      go: staticHandler("go"),
      goBack: staticHandler("goBack"),
      goForward: staticHandler("goForward"),
      listen: this.handleListen,
      block: this.handleBlock
    };

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Router__["a" /* default */], _extends({}, props, { history: history }));
  };

  return StaticRouter;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

StaticRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  context: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  location: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object])
};
StaticRouter.defaultProps = {
  basename: "",
  location: "/"
};
StaticRouter.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (StaticRouter);

/***/ }),
/* 452 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__matchPath__ = __webpack_require__(212);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for rendering the first <Route> that matches.
 */

var Switch = function (_React$Component) {
  _inherits(Switch, _React$Component);

  function Switch() {
    _classCallCheck(this, Switch);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Switch.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_3_invariant___default()(this.context.router, "You should not use <Switch> outside a <Router>");
  };

  Switch.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    __WEBPACK_IMPORTED_MODULE_2_warning___default()(!(nextProps.location && !this.props.location), '<Switch> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');

    __WEBPACK_IMPORTED_MODULE_2_warning___default()(!(!nextProps.location && this.props.location), '<Switch> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');
  };

  Switch.prototype.render = function render() {
    var route = this.context.router.route;
    var children = this.props.children;

    var location = this.props.location || route.location;

    var match = void 0,
        child = void 0;
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (element) {
      if (match == null && __WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(element)) {
        var _element$props = element.props,
            pathProp = _element$props.path,
            exact = _element$props.exact,
            strict = _element$props.strict,
            sensitive = _element$props.sensitive,
            from = _element$props.from;

        var path = pathProp || from;

        child = element;
        match = Object(__WEBPACK_IMPORTED_MODULE_4__matchPath__["a" /* default */])(location.pathname, { path: path, exact: exact, strict: strict, sensitive: sensitive }, route.match);
      }
    });

    return match ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(child, { location: location, computedMatch: match }) : null;
  };

  return Switch;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Switch.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    route: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
  }).isRequired
};
Switch.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};


/* harmony default export */ __webpack_exports__["a"] = (Switch);

/***/ }),
/* 453 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Route__ = __webpack_require__(299);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






/**
 * A public higher-order component to access the imperative API
 */
var withRouter = function withRouter(Component) {
  var C = function C(props) {
    var wrappedComponentRef = props.wrappedComponentRef,
        remainingProps = _objectWithoutProperties(props, ["wrappedComponentRef"]);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Route__["a" /* default */], {
      children: function children(routeComponentProps) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component, _extends({}, remainingProps, routeComponentProps, {
          ref: wrappedComponentRef
        }));
      }
    });
  };

  C.displayName = "withRouter(" + (Component.displayName || Component.name) + ")";
  C.WrappedComponent = Component;
  C.propTypes = {
    wrappedComponentRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
  };

  return __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default()(C, Component);
};

/* harmony default export */ __webpack_exports__["a"] = (withRouter);

/***/ }),
/* 454 */
/***/ (function(module, exports) {

function _typeof2(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof2 = function _typeof2(obj) { return typeof obj; }; } else { _typeof2 = function _typeof2(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof2(obj); }

function _typeof(obj) {
  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
    module.exports = _typeof = function _typeof(obj) {
      return _typeof2(obj);
    };
  } else {
    module.exports = _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : _typeof2(obj);
    };
  }

  return _typeof(obj);
}

module.exports = _typeof;

/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var getDisplayName = function getDisplayName(Component) {
  if (typeof Component === 'string') {
    return Component;
  }

  if (!Component) {
    return undefined;
  }

  return Component.displayName || Component.name || 'Component';
};

exports.default = getDisplayName;

/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Namespaces to avoid conflicts on the context.
 */
var jss = exports.jss = '64a55d578f856d258dc345b094a2a2b3';
var sheetsRegistry = exports.sheetsRegistry = 'd4bd0baacbc52bbd48bbb9eb24344ecd';
var managers = exports.managers = 'b768b78919504fba9de2c03545c5cd3a';
var sheetOptions = exports.sheetOptions = '6fc570d6bd61383819d0f9e7407c452d';

/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.create = exports.createGenerateClassName = exports.sheets = exports.RuleList = exports.SheetsManager = exports.SheetsRegistry = exports.toCssValue = exports.getDynamicStyles = undefined;

var _getDynamicStyles = __webpack_require__(791);

Object.defineProperty(exports, 'getDynamicStyles', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_getDynamicStyles)['default'];
  }
});

var _toCssValue = __webpack_require__(213);

Object.defineProperty(exports, 'toCssValue', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_toCssValue)['default'];
  }
});

var _SheetsRegistry = __webpack_require__(458);

Object.defineProperty(exports, 'SheetsRegistry', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_SheetsRegistry)['default'];
  }
});

var _SheetsManager = __webpack_require__(792);

Object.defineProperty(exports, 'SheetsManager', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_SheetsManager)['default'];
  }
});

var _RuleList = __webpack_require__(163);

Object.defineProperty(exports, 'RuleList', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_RuleList)['default'];
  }
});

var _sheets = __webpack_require__(302);

Object.defineProperty(exports, 'sheets', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_sheets)['default'];
  }
});

var _createGenerateClassName = __webpack_require__(461);

Object.defineProperty(exports, 'createGenerateClassName', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_createGenerateClassName)['default'];
  }
});

var _Jss = __webpack_require__(797);

var _Jss2 = _interopRequireDefault(_Jss);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 * Creates a new instance of Jss.
 */
var create = exports.create = function create(options) {
  return new _Jss2['default'](options);
};

/**
 * A global Jss instance.
 */
exports['default'] = create();

/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Sheets registry to access them all at one place.
 */
var SheetsRegistry = function () {
  function SheetsRegistry() {
    _classCallCheck(this, SheetsRegistry);

    this.registry = [];
  }

  _createClass(SheetsRegistry, [{
    key: 'add',


    /**
     * Register a Style Sheet.
     */
    value: function add(sheet) {
      var registry = this.registry;
      var index = sheet.options.index;


      if (registry.indexOf(sheet) !== -1) return;

      if (registry.length === 0 || index >= this.index) {
        registry.push(sheet);
        return;
      }

      // Find a position.
      for (var i = 0; i < registry.length; i++) {
        if (registry[i].options.index > index) {
          registry.splice(i, 0, sheet);
          return;
        }
      }
    }

    /**
     * Reset the registry.
     */

  }, {
    key: 'reset',
    value: function reset() {
      this.registry = [];
    }

    /**
     * Remove a Style Sheet.
     */

  }, {
    key: 'remove',
    value: function remove(sheet) {
      var index = this.registry.indexOf(sheet);
      this.registry.splice(index, 1);
    }

    /**
     * Convert all attached sheets to a CSS string.
     */

  }, {
    key: 'toString',
    value: function toString(options) {
      return this.registry.filter(function (sheet) {
        return sheet.attached;
      }).map(function (sheet) {
        return sheet.toString(options);
      }).join('\n');
    }
  }, {
    key: 'index',


    /**
     * Current highest index number.
     */
    get: function get() {
      return this.registry.length === 0 ? 0 : this.registry[this.registry.length - 1].options.index;
    }
  }]);

  return SheetsRegistry;
}();

exports['default'] = SheetsRegistry;

/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _symbolObservable = __webpack_require__(301);

var _symbolObservable2 = _interopRequireDefault(_symbolObservable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = function (value) {
  return value && value[_symbolObservable2['default']] && value === value[_symbolObservable2['default']]();
};

/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = linkRule;
/**
 * Link rule with CSSStyleRule and nested rules with corresponding nested cssRules if both exists.
 */
function linkRule(rule, cssRule) {
  rule.renderable = cssRule;
  if (rule.rules && cssRule.cssRules) rule.rules.link(cssRule.cssRules);
}

/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _warning = __webpack_require__(128);

var _warning2 = _interopRequireDefault(_warning);

var _StyleSheet = __webpack_require__(462);

var _StyleSheet2 = _interopRequireDefault(_StyleSheet);

var _moduleId = __webpack_require__(796);

var _moduleId2 = _interopRequireDefault(_moduleId);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var maxRules = 1e10;


var env = "production";

/**
 * Returns a function which generates unique class names based on counters.
 * When new generator function is created, rule counter is reseted.
 * We need to reset the rule counter for SSR for each request.
 */

exports['default'] = function () {
  var ruleCounter = 0;
  var defaultPrefix = env === 'production' ? 'c' : '';

  return function (rule, sheet) {
    ruleCounter += 1;

    if (ruleCounter > maxRules) {
      (0, _warning2['default'])(false, '[JSS] You might have a memory leak. Rule counter is at %s.', ruleCounter);
    }

    var prefix = defaultPrefix;
    var jssId = '';

    if (sheet) {
      prefix = sheet.options.classNamePrefix || defaultPrefix;
      if (sheet.options.jss.id != null) jssId += sheet.options.jss.id;
    }

    if (env === 'production') {
      return '' + prefix + _moduleId2['default'] + jssId + ruleCounter;
    }

    return prefix + rule.key + '-' + _moduleId2['default'] + (jssId && '-' + jssId) + '-' + ruleCounter;
  };
};

/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _linkRule = __webpack_require__(460);

var _linkRule2 = _interopRequireDefault(_linkRule);

var _RuleList = __webpack_require__(163);

var _RuleList2 = _interopRequireDefault(_RuleList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint-disable-next-line no-use-before-define */
var StyleSheet = function () {
  function StyleSheet(styles, options) {
    var _this = this;

    _classCallCheck(this, StyleSheet);

    this.update = function (name, data) {
      if (typeof name === 'string') {
        _this.rules.update(name, data);
      } else {
        _this.rules.update(name);
      }
      return _this;
    };

    this.attached = false;
    this.deployed = false;
    this.linked = false;
    this.classes = {};
    this.options = _extends({}, options, {
      sheet: this,
      parent: this,
      classes: this.classes
    });
    this.renderer = new options.Renderer(this);
    this.rules = new _RuleList2['default'](this.options);

    for (var _name in styles) {
      this.rules.add(_name, styles[_name]);
    }

    this.rules.process();
  }

  /**
   * Attach renderable to the render tree.
   */


  _createClass(StyleSheet, [{
    key: 'attach',
    value: function attach() {
      if (this.attached) return this;
      if (!this.deployed) this.deploy();
      this.renderer.attach();
      if (!this.linked && this.options.link) this.link();
      this.attached = true;
      return this;
    }

    /**
     * Remove renderable from render tree.
     */

  }, {
    key: 'detach',
    value: function detach() {
      if (!this.attached) return this;
      this.renderer.detach();
      this.attached = false;
      return this;
    }

    /**
     * Add a rule to the current stylesheet.
     * Will insert a rule also after the stylesheet has been rendered first time.
     */

  }, {
    key: 'addRule',
    value: function addRule(name, decl, options) {
      var queue = this.queue;

      // Plugins can create rules.
      // In order to preserve the right order, we need to queue all `.addRule` calls,
      // which happen after the first `rules.add()` call.

      if (this.attached && !queue) this.queue = [];

      var rule = this.rules.add(name, decl, options);
      this.options.jss.plugins.onProcessRule(rule);

      if (this.attached) {
        if (!this.deployed) return rule;
        // Don't insert rule directly if there is no stringified version yet.
        // It will be inserted all together when .attach is called.
        if (queue) queue.push(rule);else {
          this.insertRule(rule);
          if (this.queue) {
            this.queue.forEach(this.insertRule, this);
            this.queue = undefined;
          }
        }
        return rule;
      }

      // We can't add rules to a detached style node.
      // We will redeploy the sheet once user will attach it.
      this.deployed = false;

      return rule;
    }

    /**
     * Insert rule into the StyleSheet
     */

  }, {
    key: 'insertRule',
    value: function insertRule(rule) {
      var renderable = this.renderer.insertRule(rule);
      if (renderable && this.options.link) (0, _linkRule2['default'])(rule, renderable);
    }

    /**
     * Create and add rules.
     * Will render also after Style Sheet was rendered the first time.
     */

  }, {
    key: 'addRules',
    value: function addRules(styles, options) {
      var added = [];
      for (var _name2 in styles) {
        added.push(this.addRule(_name2, styles[_name2], options));
      }
      return added;
    }

    /**
     * Get a rule by name.
     */

  }, {
    key: 'getRule',
    value: function getRule(name) {
      return this.rules.get(name);
    }

    /**
     * Delete a rule by name.
     * Returns `true`: if rule has been deleted from the DOM.
     */

  }, {
    key: 'deleteRule',
    value: function deleteRule(name) {
      var rule = this.rules.get(name);

      if (!rule) return false;

      this.rules.remove(rule);

      if (this.attached && rule.renderable) {
        return this.renderer.deleteRule(rule.renderable);
      }

      return true;
    }

    /**
     * Get index of a rule.
     */

  }, {
    key: 'indexOf',
    value: function indexOf(rule) {
      return this.rules.indexOf(rule);
    }

    /**
     * Deploy pure CSS string to a renderable.
     */

  }, {
    key: 'deploy',
    value: function deploy() {
      this.renderer.deploy();
      this.deployed = true;
      return this;
    }

    /**
     * Link renderable CSS rules from sheet with their corresponding models.
     */

  }, {
    key: 'link',
    value: function link() {
      var cssRules = this.renderer.getRules();

      // Is undefined when VirtualRenderer is used.
      if (cssRules) this.rules.link(cssRules);
      this.linked = true;
      return this;
    }

    /**
     * Update the function values with a new data.
     */

  }, {
    key: 'toString',


    /**
     * Convert rules to a CSS string.
     */
    value: function toString(options) {
      return this.rules.toString(options);
    }
  }]);

  return StyleSheet;
}();

exports['default'] = StyleSheet;

/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _jssGlobal = _interopRequireDefault(__webpack_require__(809));

var _jssNested = _interopRequireDefault(__webpack_require__(810));

var _jssCamelCase = _interopRequireDefault(__webpack_require__(812));

var _jssDefaultUnit = _interopRequireDefault(__webpack_require__(814));

var _jssVendorPrefixer = _interopRequireDefault(__webpack_require__(816));

var _jssPropsSort = _interopRequireDefault(__webpack_require__(821));

// Subset of jss-preset-default with only the plugins the Material-UI
// components are using.
function jssPreset() {
  return {
    plugins: [(0, _jssGlobal.default)(), (0, _jssNested.default)(), (0, _jssCamelCase.default)(), (0, _jssDefaultUnit.default)(), (0, _jssVendorPrefixer.default)(), (0, _jssPropsSort.default)()]
  };
}

var _default = jssPreset;
exports.default = _default;

/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var indigo = {
  50: '#e8eaf6',
  100: '#c5cae9',
  200: '#9fa8da',
  300: '#7986cb',
  400: '#5c6bc0',
  500: '#3f51b5',
  600: '#3949ab',
  700: '#303f9f',
  800: '#283593',
  900: '#1a237e',
  A100: '#8c9eff',
  A200: '#536dfe',
  A400: '#3d5afe',
  A700: '#304ffe'
};
var _default = indigo;
exports.default = _default;

/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var pink = {
  50: '#fce4ec',
  100: '#f8bbd0',
  200: '#f48fb1',
  300: '#f06292',
  400: '#ec407a',
  500: '#e91e63',
  600: '#d81b60',
  700: '#c2185b',
  800: '#ad1457',
  900: '#880e4f',
  A100: '#ff80ab',
  A200: '#ff4081',
  A400: '#f50057',
  A700: '#c51162'
};
var _default = pink;
exports.default = _default;

/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var grey = {
  50: '#fafafa',
  100: '#f5f5f5',
  200: '#eeeeee',
  300: '#e0e0e0',
  400: '#bdbdbd',
  500: '#9e9e9e',
  600: '#757575',
  700: '#616161',
  800: '#424242',
  900: '#212121',
  A100: '#d5d5d5',
  A200: '#aaaaaa',
  A400: '#303030',
  A700: '#616161'
};
var _default = grey;
exports.default = _default;

/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var red = {
  50: '#ffebee',
  100: '#ffcdd2',
  200: '#ef9a9a',
  300: '#e57373',
  400: '#ef5350',
  500: '#f44336',
  600: '#e53935',
  700: '#d32f2f',
  800: '#c62828',
  900: '#b71c1c',
  A100: '#ff8a80',
  A200: '#ff5252',
  A400: '#ff1744',
  A700: '#d50000'
};
var _default = red;
exports.default = _default;

/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createGenerateClassName;

var _warning = _interopRequireDefault(__webpack_require__(32));

/* eslint-disable no-underscore-dangle */
// People might bundle this classname generator twice.
// We need to use a global.
global.__MUI_GENERATOR_COUNTER__ = 0; // Returns a function which generates unique class names based on counters.
// When new generator function is created, rule counter is reset.
// We need to reset the rule counter for SSR for each request.
//
// It's inspired by
// https://github.com/cssinjs/jss/blob/4e6a05dd3f7b6572fdd3ab216861d9e446c20331/src/utils/createGenerateClassName.js

function createGenerateClassName() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _options$dangerouslyU = options.dangerouslyUseGlobalCSS,
      dangerouslyUseGlobalCSS = _options$dangerouslyU === void 0 ? false : _options$dangerouslyU,
      _options$productionPr = options.productionPrefix,
      productionPrefix = _options$productionPr === void 0 ? 'jss' : _options$productionPr;
  var escapeRegex = /([[\].#*$><+~=|^:(),"'`\s])/g;
  var ruleCounter = 0; // - HMR can lead to many class name generators being instantiated,
  // so the warning is only triggered in production.
  // - We expect a class name generator to be instantiated per new request on the server,
  // so the warning is only triggered client side.
  // - You can get away with having multiple class name generators
  // by modifying the `productionPrefix`.

  if ("production" === 'production' && typeof window !== 'undefined' && productionPrefix === 'jss') {
    global.__MUI_GENERATOR_COUNTER__ += 1;

    if (global.__MUI_GENERATOR_COUNTER__ > 2) {
      // eslint-disable-next-line no-console
      console.error(['Material-UI: we have detected more than needed creation of the class name generator.', 'You should only use one class name generator on the client side.', 'If you do otherwise, you take the risk to have conflicting class names in production.'].join('\n'));
    }
  }

  return function (rule, styleSheet) {
    ruleCounter += 1;
     false ? (0, _warning.default)(ruleCounter < 1e10, ['Material-UI: you might have a memory leak.', 'The ruleCounter is not supposed to grow that much.'].join('')) : void 0; // Code branch the whole block at the expense of more code.

    if (dangerouslyUseGlobalCSS) {
      if (styleSheet && styleSheet.options.classNamePrefix) {
        var prefix = styleSheet.options.classNamePrefix; // Sanitize the string as will be used to prefix the generated class name.

        prefix = prefix.replace(escapeRegex, '-');

        if (prefix.match(/^Mui/)) {
          return "".concat(prefix, "-").concat(rule.key);
        }

        if (false) {
          return "".concat(prefix, "-").concat(rule.key, "-").concat(ruleCounter);
        }
      }

      if (true) {
        return "".concat(productionPrefix).concat(ruleCounter);
      }

      return "".concat(rule.key, "-").concat(ruleCounter);
    }

    if (true) {
      return "".concat(productionPrefix).concat(ruleCounter);
    }

    if (styleSheet && styleSheet.options.classNamePrefix) {
      var _prefix = styleSheet.options.classNamePrefix; // Sanitize the string as will be used to prefix the generated class name.

      _prefix = _prefix.replace(escapeRegex, '-');
      return "".concat(_prefix, "-").concat(rule.key, "-").concat(ruleCounter);
    }

    return "".concat(rule.key, "-").concat(ruleCounter);
  };
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(26)))

/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "createGenerateClassName", {
  enumerable: true,
  get: function get() {
    return _createGenerateClassName.default;
  }
});
Object.defineProperty(exports, "createMuiTheme", {
  enumerable: true,
  get: function get() {
    return _createMuiTheme.default;
  }
});
Object.defineProperty(exports, "jssPreset", {
  enumerable: true,
  get: function get() {
    return _jssPreset.default;
  }
});
Object.defineProperty(exports, "MuiThemeProvider", {
  enumerable: true,
  get: function get() {
    return _MuiThemeProvider.default;
  }
});
Object.defineProperty(exports, "createStyles", {
  enumerable: true,
  get: function get() {
    return _createStyles.default;
  }
});
Object.defineProperty(exports, "withStyles", {
  enumerable: true,
  get: function get() {
    return _withStyles.default;
  }
});
Object.defineProperty(exports, "withTheme", {
  enumerable: true,
  get: function get() {
    return _withTheme.default;
  }
});

var _createGenerateClassName = _interopRequireDefault(__webpack_require__(468));

var _createMuiTheme = _interopRequireDefault(__webpack_require__(304));

var _jssPreset = _interopRequireDefault(__webpack_require__(463));

var _MuiThemeProvider = _interopRequireDefault(__webpack_require__(848));

var _createStyles = _interopRequireDefault(__webpack_require__(850));

var _withStyles = _interopRequireDefault(__webpack_require__(5));

var _withTheme = _interopRequireDefault(__webpack_require__(91));

/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(8));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(11));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _classnames = _interopRequireDefault(__webpack_require__(6));

var _withStyles = _interopRequireDefault(__webpack_require__(5));

var styles = function styles(theme) {
  return {
    root: {
      position: 'relative',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexShrink: 0,
      width: theme.spacing.unit * 5,
      height: theme.spacing.unit * 5,
      fontFamily: theme.typography.fontFamily,
      fontSize: theme.typography.pxToRem(20),
      borderRadius: '50%',
      overflow: 'hidden',
      userSelect: 'none'
    },
    colorDefault: {
      color: theme.palette.background.default,
      backgroundColor: theme.palette.type === 'light' ? theme.palette.grey[400] : theme.palette.grey[600]
    },
    img: {
      width: '100%',
      height: '100%',
      textAlign: 'center',
      // Handle non-square image. The property isn't supported by IE11.
      objectFit: 'cover'
    }
  };
};

exports.styles = styles;

function Avatar(props) {
  var alt = props.alt,
      childrenProp = props.children,
      childrenClassNameProp = props.childrenClassName,
      classes = props.classes,
      classNameProp = props.className,
      Component = props.component,
      imgProps = props.imgProps,
      sizes = props.sizes,
      src = props.src,
      srcSet = props.srcSet,
      other = (0, _objectWithoutProperties2.default)(props, ["alt", "children", "childrenClassName", "classes", "className", "component", "imgProps", "sizes", "src", "srcSet"]);
  var className = (0, _classnames.default)(classes.root, (0, _defineProperty2.default)({}, classes.colorDefault, childrenProp && !src && !srcSet), classNameProp);
  var children = null;

  if (childrenProp) {
    if (childrenClassNameProp && typeof childrenProp !== 'string' && _react.default.isValidElement(childrenProp)) {
      var childrenClassName = (0, _classnames.default)(childrenClassNameProp, childrenProp.props.className);
      children = _react.default.cloneElement(childrenProp, {
        className: childrenClassName
      });
    } else {
      children = childrenProp;
    }
  } else if (src || srcSet) {
    children = _react.default.createElement("img", (0, _extends2.default)({
      alt: alt,
      src: src,
      srcSet: srcSet,
      sizes: sizes,
      className: classes.img
    }, imgProps));
  }

  return _react.default.createElement(Component, (0, _extends2.default)({
    className: className
  }, other), children);
}

Avatar.propTypes =  false ? {
  /**
   * Used in combination with `src` or `srcSet` to
   * provide an alt attribute for the rendered `img` element.
   */
  alt: _propTypes.default.string,

  /**
   * Used to render icon or text elements inside the Avatar.
   * `src` and `alt` props will not be used and no `img` will
   * be rendered by default.
   *
   * This can be an element, or just a string.
   */
  children: _propTypes.default.node,

  /**
   * @ignore
   * The className of the child element.
   * Used by Chip and ListItemIcon to style the Avatar icon.
   */
  childrenClassName: _propTypes.default.string,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func]),

  /**
   * Properties applied to the `img` element when the component
   * is used to display an image.
   */
  imgProps: _propTypes.default.object,

  /**
   * The `sizes` attribute for the `img` element.
   */
  sizes: _propTypes.default.string,

  /**
   * The `src` attribute for the `img` element.
   */
  src: _propTypes.default.string,

  /**
   * The `srcSet` attribute for the `img` element.
   */
  srcSet: _propTypes.default.string
} : {};
Avatar.defaultProps = {
  component: 'div'
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiAvatar'
})(Avatar);

exports.default = _default;

/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Backdrop.default;
  }
});

var _Backdrop = _interopRequireDefault(__webpack_require__(854));

/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _iterator = __webpack_require__(892);

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = __webpack_require__(910);

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};

/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(220);
var $export = __webpack_require__(221);
var redefine = __webpack_require__(477);
var hide = __webpack_require__(135);
var Iterators = __webpack_require__(312);
var $iterCreate = __webpack_require__(897);
var setToStringTag = __webpack_require__(318);
var getPrototypeOf = __webpack_require__(904);
var ITERATOR = __webpack_require__(140)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(896);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(138) && !__webpack_require__(222)(function () {
  return Object.defineProperty(__webpack_require__(476)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(137);
var document = __webpack_require__(92).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(135);


/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(106);
var toIObject = __webpack_require__(139);
var arrayIndexOf = __webpack_require__(900)(false);
var IE_PROTO = __webpack_require__(315)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 479 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 480 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(478);
var hiddenKeys = __webpack_require__(317).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(321);
var createDesc = __webpack_require__(223);
var toIObject = __webpack_require__(139);
var toPrimitive = __webpack_require__(311);
var has = __webpack_require__(106);
var IE8_DOM_DEFINE = __webpack_require__(475);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(138) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _setStatic = __webpack_require__(928);

var _setStatic2 = _interopRequireDefault(_setStatic);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var setDisplayName = function setDisplayName(displayName) {
  return (0, _setStatic2.default)('displayName', displayName);
};

exports.default = setDisplayName;

/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _CircularProgress.default;
  }
});

var _CircularProgress = _interopRequireDefault(__webpack_require__(936));

/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _ClickAwayListener.default;
  }
});

var _ClickAwayListener = _interopRequireDefault(__webpack_require__(937));

/***/ }),
/* 486 */
/***/ (function(module, exports) {

function _typeof2(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof2 = function _typeof2(obj) { return typeof obj; }; } else { _typeof2 = function _typeof2(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof2(obj); }

function _typeof(obj) {
  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
    module.exports = _typeof = function _typeof(obj) {
      return _typeof2(obj);
    };
  } else {
    module.exports = _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : _typeof2(obj);
    };
  }

  return _typeof(obj);
}

module.exports = _typeof;

/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(72);

exports.__esModule = true;
exports.default = activeElement;

var _ownerDocument = _interopRequireDefault(__webpack_require__(71));

function activeElement(doc) {
  if (doc === void 0) {
    doc = (0, _ownerDocument.default)();
  }

  try {
    return doc.activeElement;
  } catch (e) {
    /* ie throws if no active element */
  }
}

module.exports = exports["default"];

/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _RootRef.default;
  }
});

var _RootRef = _interopRequireDefault(__webpack_require__(954));

/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(18));

var _createClass2 = _interopRequireDefault(__webpack_require__(19));

var _style = _interopRequireDefault(__webpack_require__(956));

var _ownerDocument = _interopRequireDefault(__webpack_require__(71));

var _scrollbarSize = _interopRequireDefault(__webpack_require__(323));

var _isOverflowing = _interopRequireDefault(__webpack_require__(963));

var _manageAriaHidden = __webpack_require__(965);

function findIndexOf(data, callback) {
  var idx = -1;
  data.some(function (item, index) {
    if (callback(item)) {
      idx = index;
      return true;
    }

    return false;
  });
  return idx;
}

function getPaddingRight(node) {
  return parseInt((0, _style.default)(node, 'paddingRight') || 0, 10);
}

function setContainerStyle(data, container) {
  var style = {
    overflow: 'hidden'
  }; // We are only interested in the actual `style` here because we will override it.

  data.style = {
    overflow: container.style.overflow,
    paddingRight: container.style.paddingRight
  };

  if (data.overflowing) {
    var scrollbarSize = (0, _scrollbarSize.default)(); // Use computed style, here to get the real padding to add our scrollbar width.

    style.paddingRight = "".concat(getPaddingRight(container) + scrollbarSize, "px"); // .mui-fixed is a global helper.

    var fixedNodes = (0, _ownerDocument.default)(container).querySelectorAll('.mui-fixed');

    for (var i = 0; i < fixedNodes.length; i += 1) {
      var paddingRight = getPaddingRight(fixedNodes[i]);
      data.prevPaddings.push(paddingRight);
      fixedNodes[i].style.paddingRight = "".concat(paddingRight + scrollbarSize, "px");
    }
  }

  Object.keys(style).forEach(function (key) {
    container.style[key] = style[key];
  });
}

function removeContainerStyle(data, container) {
  Object.keys(data.style).forEach(function (key) {
    container.style[key] = data.style[key];
  });
  var fixedNodes = (0, _ownerDocument.default)(container).querySelectorAll('.mui-fixed');

  for (var i = 0; i < fixedNodes.length; i += 1) {
    fixedNodes[i].style.paddingRight = "".concat(data.prevPaddings[i], "px");
  }
}
/**
 * @ignore - do not document.
 *
 * Proper state managment for containers and the modals in those containers.
 * Simplified, but inspired by react-overlay's ModalManager class
 * Used by the Modal to ensure proper styling of containers.
 */


var ModalManager =
/*#__PURE__*/
function () {
  function ModalManager() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    (0, _classCallCheck2.default)(this, ModalManager);
    var _options$hideSiblingN = options.hideSiblingNodes,
        hideSiblingNodes = _options$hideSiblingN === void 0 ? true : _options$hideSiblingN,
        _options$handleContai = options.handleContainerOverflow,
        handleContainerOverflow = _options$handleContai === void 0 ? true : _options$handleContai;
    this.hideSiblingNodes = hideSiblingNodes;
    this.handleContainerOverflow = handleContainerOverflow; // this.modals[modalIdx] = modal

    this.modals = []; // this.containers[containerIdx] = container

    this.containers = []; // this.data[containerIdx] = {
    //   modals: [],
    // }

    this.data = [];
  }

  (0, _createClass2.default)(ModalManager, [{
    key: "add",
    value: function add(modal, container) {
      var modalIdx = this.modals.indexOf(modal);

      if (modalIdx !== -1) {
        return modalIdx;
      }

      modalIdx = this.modals.length;
      this.modals.push(modal);

      if (this.hideSiblingNodes) {
        (0, _manageAriaHidden.hideSiblings)(container, modal.mountNode);
      }

      var containerIdx = this.containers.indexOf(container);

      if (containerIdx !== -1) {
        this.data[containerIdx].modals.push(modal);
        return modalIdx;
      }

      var data = {
        modals: [modal],
        overflowing: (0, _isOverflowing.default)(container),
        prevPaddings: []
      };

      if (this.handleContainerOverflow) {
        setContainerStyle(data, container);
      }

      this.containers.push(container);
      this.data.push(data);
      return modalIdx;
    }
  }, {
    key: "remove",
    value: function remove(modal) {
      var modalIdx = this.modals.indexOf(modal);

      if (modalIdx === -1) {
        return modalIdx;
      }

      var containerIdx = findIndexOf(this.data, function (item) {
        return item.modals.indexOf(modal) !== -1;
      });
      var data = this.data[containerIdx];
      var container = this.containers[containerIdx];
      data.modals.splice(data.modals.indexOf(modal), 1);
      this.modals.splice(modalIdx, 1); // If that was the last modal in a container, clean up the container.

      if (data.modals.length === 0) {
        if (this.handleContainerOverflow) {
          removeContainerStyle(data, container);
        }

        if (this.hideSiblingNodes) {
          (0, _manageAriaHidden.showSiblings)(container, modal.mountNode);
        }

        this.containers.splice(containerIdx, 1);
        this.data.splice(containerIdx, 1);
      } else if (this.hideSiblingNodes) {
        // Otherwise make sure the next top modal is visible to a screan reader.
        (0, _manageAriaHidden.ariaHidden)(false, data.modals[data.modals.length - 1].mountNode);
      }

      return modalIdx;
    }
  }, {
    key: "isTopModal",
    value: function isTopModal(modal) {
      return !!this.modals.length && this.modals[this.modals.length - 1] === modal;
    }
  }]);
  return ModalManager;
}();

var _default = ModalManager;
exports.default = _default;

/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(72);

exports.__esModule = true;
exports.default = camelizeStyleName;

var _camelize = _interopRequireDefault(__webpack_require__(957));

/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/camelizeStyleName.js
 */
var msPattern = /^-ms-/;

function camelizeStyleName(string) {
  return (0, _camelize.default)(string.replace(msPattern, 'ms-'));
}

module.exports = exports["default"];

/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(72);

exports.__esModule = true;
exports.default = exports.animationEnd = exports.animationDelay = exports.animationTiming = exports.animationDuration = exports.animationName = exports.transitionEnd = exports.transitionDuration = exports.transitionDelay = exports.transitionTiming = exports.transitionProperty = exports.transform = void 0;

var _inDOM = _interopRequireDefault(__webpack_require__(167));

var transform = 'transform';
exports.transform = transform;
var prefix, transitionEnd, animationEnd;
exports.animationEnd = animationEnd;
exports.transitionEnd = transitionEnd;
var transitionProperty, transitionDuration, transitionTiming, transitionDelay;
exports.transitionDelay = transitionDelay;
exports.transitionTiming = transitionTiming;
exports.transitionDuration = transitionDuration;
exports.transitionProperty = transitionProperty;
var animationName, animationDuration, animationTiming, animationDelay;
exports.animationDelay = animationDelay;
exports.animationTiming = animationTiming;
exports.animationDuration = animationDuration;
exports.animationName = animationName;

if (_inDOM.default) {
  var _getTransitionPropert = getTransitionProperties();

  prefix = _getTransitionPropert.prefix;
  exports.transitionEnd = transitionEnd = _getTransitionPropert.transitionEnd;
  exports.animationEnd = animationEnd = _getTransitionPropert.animationEnd;
  exports.transform = transform = prefix + "-" + transform;
  exports.transitionProperty = transitionProperty = prefix + "-transition-property";
  exports.transitionDuration = transitionDuration = prefix + "-transition-duration";
  exports.transitionDelay = transitionDelay = prefix + "-transition-delay";
  exports.transitionTiming = transitionTiming = prefix + "-transition-timing-function";
  exports.animationName = animationName = prefix + "-animation-name";
  exports.animationDuration = animationDuration = prefix + "-animation-duration";
  exports.animationTiming = animationTiming = prefix + "-animation-delay";
  exports.animationDelay = animationDelay = prefix + "-animation-timing-function";
}

var _default = {
  transform: transform,
  end: transitionEnd,
  property: transitionProperty,
  timing: transitionTiming,
  delay: transitionDelay,
  duration: transitionDuration
};
exports.default = _default;

function getTransitionProperties() {
  var style = document.createElement('div').style;
  var vendorMap = {
    O: function O(e) {
      return "o" + e.toLowerCase();
    },
    Moz: function Moz(e) {
      return e.toLowerCase();
    },
    Webkit: function Webkit(e) {
      return "webkit" + e;
    },
    ms: function ms(e) {
      return "MS" + e;
    }
  };
  var vendors = Object.keys(vendorMap);
  var transitionEnd, animationEnd;
  var prefix = '';

  for (var i = 0; i < vendors.length; i++) {
    var vendor = vendors[i];

    if (vendor + "TransitionProperty" in style) {
      prefix = "-" + vendor.toLowerCase();
      transitionEnd = vendorMap[vendor]('TransitionEnd');
      animationEnd = vendorMap[vendor]('AnimationEnd');
      break;
    }
  }

  if (!transitionEnd && 'transitionProperty' in style) transitionEnd = 'transitionend';
  if (!animationEnd && 'animationName' in style) animationEnd = 'animationend';
  style = null;
  return {
    animationEnd: animationEnd,
    transitionEnd: transitionEnd,
    prefix: prefix
  };
}

/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Drawer.default;
  }
});

var _Drawer = _interopRequireDefault(__webpack_require__(324));

/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _FormControl.default;
  }
});

var _FormControl = _interopRequireDefault(__webpack_require__(984));

/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _FormGroup.default;
  }
});

var _FormGroup = _interopRequireDefault(__webpack_require__(988));

/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _FormHelperText.default;
  }
});

var _FormHelperText = _interopRequireDefault(__webpack_require__(989));

/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _FormLabel.default;
  }
});

var _FormLabel = _interopRequireDefault(__webpack_require__(990));

/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Grow.default;
  }
});

var _Grow = _interopRequireDefault(__webpack_require__(999));

/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _InputLabel.default;
  }
});

var _InputLabel = _interopRequireDefault(__webpack_require__(1008));

/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _LinearProgress.default;
  }
});

var _LinearProgress = _interopRequireDefault(__webpack_require__(1009));

/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _ListItemIcon.default;
  }
});

var _ListItemIcon = _interopRequireDefault(__webpack_require__(1014));

/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(8));

var _objectSpread2 = _interopRequireDefault(__webpack_require__(23));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(18));

var _createClass2 = _interopRequireDefault(__webpack_require__(19));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(20));

var _inherits2 = _interopRequireDefault(__webpack_require__(21));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _reactDom = _interopRequireDefault(__webpack_require__(45));

var _scrollbarSize = _interopRequireDefault(__webpack_require__(323));

var _withStyles = _interopRequireDefault(__webpack_require__(5));

var _Popover = _interopRequireDefault(__webpack_require__(502));

var _MenuList = _interopRequireDefault(__webpack_require__(503));

// @inheritedComponent Popover
var RTL_ORIGIN = {
  vertical: 'top',
  horizontal: 'right'
};
var LTR_ORIGIN = {
  vertical: 'top',
  horizontal: 'left'
};
var styles = {
  paper: {
    // specZ: The maximum height of a simple menu should be one or more rows less than the view
    // height. This ensures a tappable area outside of the simple menu with which to dismiss
    // the menu.
    maxHeight: 'calc(100% - 96px)',
    // Add iOS momentum scrolling.
    WebkitOverflowScrolling: 'touch'
  }
};
exports.styles = styles;

var Menu =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(Menu, _React$Component);

  function Menu() {
    var _ref;

    var _temp, _this;

    (0, _classCallCheck2.default)(this, Menu);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return (0, _possibleConstructorReturn2.default)(_this, (_temp = _this = (0, _possibleConstructorReturn2.default)(this, (_ref = Menu.__proto__ || Object.getPrototypeOf(Menu)).call.apply(_ref, [this].concat(args))), _this.getContentAnchorEl = function () {
      if (!_this.menuList || !_this.menuList.selectedItem) {
        return _reactDom.default.findDOMNode(_this.menuList).firstChild;
      }

      return _reactDom.default.findDOMNode(_this.menuList.selectedItem);
    }, _this.menuList = undefined, _this.focus = function () {
      if (_this.menuList && _this.menuList.selectedItem) {
        _reactDom.default.findDOMNode(_this.menuList.selectedItem).focus();

        return;
      }

      var menuList = _reactDom.default.findDOMNode(_this.menuList);

      if (menuList && menuList.firstChild) {
        menuList.firstChild.focus();
      }
    }, _this.handleEnter = function (element) {
      var theme = _this.props.theme;

      var menuList = _reactDom.default.findDOMNode(_this.menuList); // Focus so the scroll computation of the Popover works as expected.


      _this.focus(); // Let's ignore that piece of logic if users are already overriding the width
      // of the menu.


      if (menuList && element.clientHeight < menuList.clientHeight && !menuList.style.width) {
        var size = "".concat((0, _scrollbarSize.default)(), "px");
        menuList.style[theme.direction === 'rtl' ? 'paddingLeft' : 'paddingRight'] = size;
        menuList.style.width = "calc(100% + ".concat(size, ")");
      }

      if (_this.props.onEnter) {
        _this.props.onEnter(element);
      }
    }, _this.handleListKeyDown = function (event, key) {
      if (key === 'tab') {
        event.preventDefault();

        if (_this.props.onClose) {
          _this.props.onClose(event);
        }
      }
    }, _temp));
  }

  (0, _createClass2.default)(Menu, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.open) {
        this.focus();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          children = _props.children,
          classes = _props.classes,
          MenuListProps = _props.MenuListProps,
          onEnter = _props.onEnter,
          _props$PaperProps = _props.PaperProps,
          PaperProps = _props$PaperProps === void 0 ? {} : _props$PaperProps,
          PopoverClasses = _props.PopoverClasses,
          theme = _props.theme,
          other = (0, _objectWithoutProperties2.default)(_props, ["children", "classes", "MenuListProps", "onEnter", "PaperProps", "PopoverClasses", "theme"]);
      return _react.default.createElement(_Popover.default, (0, _extends2.default)({
        getContentAnchorEl: this.getContentAnchorEl,
        classes: PopoverClasses,
        onEnter: this.handleEnter,
        anchorOrigin: theme.direction === 'rtl' ? RTL_ORIGIN : LTR_ORIGIN,
        transformOrigin: theme.direction === 'rtl' ? RTL_ORIGIN : LTR_ORIGIN,
        PaperProps: (0, _objectSpread2.default)({}, PaperProps, {
          classes: (0, _objectSpread2.default)({}, PaperProps.classes, {
            root: classes.paper
          })
        })
      }, other), _react.default.createElement(_MenuList.default, (0, _extends2.default)({
        role: "menu",
        onKeyDown: this.handleListKeyDown
      }, MenuListProps, {
        ref: function ref(node) {
          _this2.menuList = node;
        }
      }), children));
    }
  }]);
  return Menu;
}(_react.default.Component);

Menu.propTypes =  false ? {
  /**
   * The DOM element used to set the position of the menu.
   */
  anchorEl: _propTypes.default.object,

  /**
   * Menu contents, normally `MenuItem`s.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * Properties applied to the `MenuList` element.
   */
  MenuListProps: _propTypes.default.object,

  /**
   * Callback fired when the component requests to be closed.
   *
   * @param {object} event The event source of the callback
   */
  onClose: _propTypes.default.func,

  /**
   * Callback fired before the Menu enters.
   */
  onEnter: _propTypes.default.func,

  /**
   * Callback fired when the Menu has entered.
   */
  onEntered: _propTypes.default.func,

  /**
   * Callback fired when the Menu is entering.
   */
  onEntering: _propTypes.default.func,

  /**
   * Callback fired before the Menu exits.
   */
  onExit: _propTypes.default.func,

  /**
   * Callback fired when the Menu has exited.
   */
  onExited: _propTypes.default.func,

  /**
   * Callback fired when the Menu is exiting.
   */
  onExiting: _propTypes.default.func,

  /**
   * If `true`, the menu is visible.
   */
  open: _propTypes.default.bool.isRequired,

  /**
   * @ignore
   */
  PaperProps: _propTypes.default.object,

  /**
   * `classes` property applied to the `Popover` element.
   */
  PopoverClasses: _propTypes.default.object,

  /**
   * @ignore
   */
  theme: _propTypes.default.object.isRequired,

  /**
   * The length of the transition in `ms`, or 'auto'
   */
  transitionDuration: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
    enter: _propTypes.default.number,
    exit: _propTypes.default.number
  }), _propTypes.default.oneOf(['auto'])])
} : {};
Menu.defaultProps = {
  transitionDuration: 'auto'
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiMenu',
  withTheme: true
})(Menu);

exports.default = _default;

/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Popover.default;
  }
});

var _Popover = _interopRequireDefault(__webpack_require__(1021));

/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _MenuList.default;
  }
});

var _MenuList = _interopRequireDefault(__webpack_require__(1022));

/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _MenuItem.default;
  }
});

var _MenuItem = _interopRequireDefault(__webpack_require__(1023));

/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _objectSpread2 = _interopRequireDefault(__webpack_require__(23));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _NativeSelectInput = _interopRequireDefault(__webpack_require__(506));

var _withStyles = _interopRequireDefault(__webpack_require__(5));

var _ArrowDropDown = _interopRequireDefault(__webpack_require__(507));

var _Input = _interopRequireDefault(__webpack_require__(171));

// @inheritedComponent Input
var styles = function styles(theme) {
  return {
    root: {
      position: 'relative',
      width: '100%'
    },
    select: {
      '-moz-appearance': 'none',
      // Reset
      '-webkit-appearance': 'none',
      // Reset
      // When interacting quickly, the text can end up selected.
      // Native select can't be selected either.
      userSelect: 'none',
      paddingRight: theme.spacing.unit * 4,
      width: "calc(100% - ".concat(theme.spacing.unit * 4, "px)"),
      minWidth: theme.spacing.unit * 2,
      // So it doesn't collapse.
      cursor: 'pointer',
      '&:focus': {
        // Show that it's not an text input
        background: theme.palette.type === 'light' ? 'rgba(0, 0, 0, 0.05)' : 'rgba(255, 255, 255, 0.05)',
        borderRadius: 0 // Reset Chrome style

      },
      // Remove Firefox focus border
      '&:-moz-focusring': {
        color: 'transparent',
        textShadow: '0 0 0 #000'
      },
      // Remove IE11 arrow
      '&::-ms-expand': {
        display: 'none'
      },
      '&$disabled': {
        cursor: 'default'
      }
    },
    selectMenu: {
      width: 'auto',
      // Fix Safari textOverflow
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      minHeight: '1.1875em' // Reset (19px), match the native input line-height

    },
    disabled: {},
    icon: {
      // We use a position absolute over a flexbox in order to forward the pointer events
      // to the input.
      position: 'absolute',
      right: 0,
      top: 'calc(50% - 12px)',
      // Center vertically
      color: theme.palette.action.active,
      'pointer-events': 'none' // Don't block pointer events on the select under the icon.

    }
  };
};
/**
 * An alternative to `<Select native />` with a much smaller dependency graph.
 */


exports.styles = styles;

function NativeSelect(props) {
  var children = props.children,
      classes = props.classes,
      IconComponent = props.IconComponent,
      input = props.input,
      inputProps = props.inputProps,
      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "IconComponent", "input", "inputProps"]);
  return _react.default.cloneElement(input, (0, _objectSpread2.default)({
    // Most of the logic is implemented in `NativeSelectInput`.
    // The `Select` component is a simple API wrapper to expose something better to play with.
    inputComponent: _NativeSelectInput.default,
    inputProps: (0, _objectSpread2.default)({
      children: children,
      classes: classes,
      IconComponent: IconComponent,
      type: undefined
    }, inputProps, input ? input.props.inputProps : {})
  }, other));
}

NativeSelect.propTypes =  false ? {
  /**
   * The option elements to populate the select with.
   * Can be some `<option>` elements.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * The icon that displays the arrow.
   */
  IconComponent: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func]),

  /**
   * An `Input` element; does not have to be a material-ui specific `Input`.
   */
  input: _propTypes.default.element,

  /**
   * Properties applied to the `input` element.
   * The properties are applied on the `select` element.
   */
  inputProps: _propTypes.default.object,

  /**
   * Callback function fired when a menu item is selected.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value`.
   */
  onChange: _propTypes.default.func,

  /**
   * The input value.
   */
  value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number])
} : {};
NativeSelect.defaultProps = {
  IconComponent: _ArrowDropDown.default,
  input: _react.default.createElement(_Input.default, null)
};
NativeSelect.muiName = 'NativeSelect';

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiNativeSelect'
})(NativeSelect);

exports.default = _default;

/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(8));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(11));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _classnames = _interopRequireDefault(__webpack_require__(6));

/**
 * @ignore - internal component.
 */
function NativeSelectInput(props) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      disabled = props.disabled,
      IconComponent = props.IconComponent,
      inputRef = props.inputRef,
      name = props.name,
      onChange = props.onChange,
      value = props.value,
      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "disabled", "IconComponent", "inputRef", "name", "onChange", "value"]);
  return _react.default.createElement("div", {
    className: classes.root
  }, _react.default.createElement("select", (0, _extends2.default)({
    className: (0, _classnames.default)(classes.select, (0, _defineProperty2.default)({}, classes.disabled, disabled), className),
    name: name,
    disabled: disabled,
    onChange: onChange,
    value: value,
    ref: inputRef
  }, other), children), _react.default.createElement(IconComponent, {
    className: classes.icon
  }));
}

NativeSelectInput.propTypes =  false ? {
  /**
   * The option elements to populate the select with.
   * Can be some `<option>` elements.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * The CSS class name of the select element.
   */
  className: _propTypes.default.string,

  /**
   * If `true`, the select will be disabled.
   */
  disabled: _propTypes.default.bool,

  /**
   * The icon that displays the arrow.
   */
  IconComponent: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func]),

  /**
   * Use that property to pass a ref callback to the native select element.
   */
  inputRef: _propTypes.default.func,

  /**
   * Name attribute of the `select` or hidden `input` element.
   */
  name: _propTypes.default.string,

  /**
   * Callback function fired when a menu item is selected.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value`.
   */
  onChange: _propTypes.default.func,

  /**
   * The input value.
   */
  value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number])
} : {};
var _default = NativeSelectInput;
exports.default = _default;

/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _pure = _interopRequireDefault(__webpack_require__(52));

var _SvgIcon = _interopRequireDefault(__webpack_require__(47));

var _ref = _react.default.createElement("path", {
  d: "M7 10l5 5 5-5z"
});

/**
 * @ignore - internal component.
 */
var ArrowDropDown = function ArrowDropDown(props) {
  return _react.default.createElement(_SvgIcon.default, props, _ref);
};

ArrowDropDown = (0, _pure.default)(ArrowDropDown);
ArrowDropDown.muiName = 'SvgIcon';
var _default = ArrowDropDown;
exports.default = _default;

/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Snackbar.default;
  }
});

var _Snackbar = _interopRequireDefault(__webpack_require__(1034));

/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _SnackbarContent.default;
  }
});

var _SnackbarContent = _interopRequireDefault(__webpack_require__(1035));

/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _StepLabel.default;
  }
});

var _StepLabel = _interopRequireDefault(__webpack_require__(1040));

/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _StepIcon.default;
  }
});

var _StepIcon = _interopRequireDefault(__webpack_require__(1041));

/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _StepConnector.default;
  }
});

var _StepConnector = _interopRequireDefault(__webpack_require__(1045));

/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _pure = _interopRequireDefault(__webpack_require__(52));

var _SvgIcon = _interopRequireDefault(__webpack_require__(47));

var _ref = _react.default.createElement("path", {
  d: "M15.41 16.09l-4.58-4.59 4.58-4.59L14 5.5l-6 6 6 6z"
});

/**
 * @ignore - internal component.
 */
var KeyboardArrowLeft = function KeyboardArrowLeft(props) {
  return _react.default.createElement(_SvgIcon.default, props, _ref);
};

KeyboardArrowLeft = (0, _pure.default)(KeyboardArrowLeft);
KeyboardArrowLeft.muiName = 'SvgIcon';
var _default = KeyboardArrowLeft;
exports.default = _default;

/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _pure = _interopRequireDefault(__webpack_require__(52));

var _SvgIcon = _interopRequireDefault(__webpack_require__(47));

var _ref = _react.default.createElement("path", {
  d: "M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z"
});

/**
 * @ignore - internal component.
 */
var KeyboardArrowRight = function KeyboardArrowRight(props) {
  return _react.default.createElement(_SvgIcon.default, props, _ref);
};

KeyboardArrowRight = (0, _pure.default)(KeyboardArrowRight);
KeyboardArrowRight.muiName = 'SvgIcon';
var _default = KeyboardArrowRight;
exports.default = _default;

/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
})), 'Close');

exports.default = _default;

/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"
})), 'Visibility');

exports.default = _default;

/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 7c2.76 0 5 2.24 5 5 0 .65-.13 1.26-.36 1.83l2.92 2.92c1.51-1.26 2.7-2.89 3.43-4.75-1.73-4.39-6-7.5-11-7.5-1.4 0-2.74.25-3.98.7l2.16 2.16C10.74 7.13 11.35 7 12 7zM2 4.27l2.28 2.28.46.46C3.08 8.3 1.78 10.02 1 12c1.73 4.39 6 7.5 11 7.5 1.55 0 3.03-.3 4.38-.84l.42.42L19.73 22 21 20.73 3.27 3 2 4.27zM7.53 9.8l1.55 1.55c-.05.21-.08.43-.08.65 0 1.66 1.34 3 3 3 .22 0 .44-.03.65-.08l1.55 1.55c-.67.33-1.41.53-2.2.53-2.76 0-5-2.24-5-5 0-.79.2-1.53.53-2.2zm4.31-.78l3.15 3.15.02-.16c0-1.66-1.34-3-3-3l-.17.01z"
})), 'VisibilityOff');

exports.default = _default;

/***/ }),
/* 518 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = invariant;
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */

function invariant(condition, message) {
  /* istanbul ignore else */
  if (!condition) {
    throw new Error(message);
  }
}

/***/ }),
/* 519 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__GraphQLError__ = __webpack_require__(335);
/* unused harmony reexport GraphQLError */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__syntaxError__ = __webpack_require__(1096);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__syntaxError__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__locatedError__ = __webpack_require__(1097);
/* unused harmony reexport locatedError */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__printError__ = __webpack_require__(520);
/* unused harmony reexport printError */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__formatError__ = __webpack_require__(1098);
/* unused harmony reexport formatError */
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */







/***/ }),
/* 520 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = printError;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__language_location__ = __webpack_require__(521);
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */




/**
 * Prints a GraphQLError to a string, representing useful location information
 * about the error's position in the source.
 */
function printError(error) {
  var printedLocations = [];
  if (error.nodes) {
    error.nodes.forEach(function (node) {
      if (node.loc) {
        printedLocations.push(highlightSourceAtLocation(node.loc.source, Object(__WEBPACK_IMPORTED_MODULE_0__language_location__["a" /* getLocation */])(node.loc.source, node.loc.start)));
      }
    });
  } else if (error.source && error.locations) {
    var source = error.source;
    error.locations.forEach(function (location) {
      printedLocations.push(highlightSourceAtLocation(source, location));
    });
  }
  return printedLocations.length === 0 ? error.message : [error.message].concat(printedLocations).join('\n\n') + '\n';
}

/**
 * Render a helpful description of the location of the error in the GraphQL
 * Source document.
 */
function highlightSourceAtLocation(source, location) {
  var line = location.line;
  var lineOffset = source.locationOffset.line - 1;
  var columnOffset = getColumnOffset(source, location);
  var contextLine = line + lineOffset;
  var contextColumn = location.column + columnOffset;
  var prevLineNum = (contextLine - 1).toString();
  var lineNum = contextLine.toString();
  var nextLineNum = (contextLine + 1).toString();
  var padLen = nextLineNum.length;
  var lines = source.body.split(/\r\n|[\n\r]/g);
  lines[0] = whitespace(source.locationOffset.column - 1) + lines[0];
  var outputLines = [source.name + ' (' + contextLine + ':' + contextColumn + ')', line >= 2 && lpad(padLen, prevLineNum) + ': ' + lines[line - 2], lpad(padLen, lineNum) + ': ' + lines[line - 1], whitespace(2 + padLen + contextColumn - 1) + '^', line < lines.length && lpad(padLen, nextLineNum) + ': ' + lines[line]];
  return outputLines.filter(Boolean).join('\n');
}

function getColumnOffset(source, location) {
  return location.line === 1 ? source.locationOffset.column - 1 : 0;
}

function whitespace(len) {
  return Array(len + 1).join(' ');
}

function lpad(len, str) {
  return whitespace(len - str.length) + str;
}

/***/ }),
/* 521 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getLocation;


/**
 * Takes a Source and a UTF-8 character offset, and returns the corresponding
 * line and column as a SourceLocation.
 */
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */

function getLocation(source, position) {
  var lineRegexp = /\r\n|[\n\r]/g;
  var line = 1;
  var column = position + 1;
  var match = void 0;
  while ((match = lineRegexp.exec(source.body)) && match.index < position) {
    line += 1;
    column = position + 1 - (match.index + match[0].length);
  }
  return { line: line, column: column };
}

/**
 * Represents a location in a Source.
 */

/***/ }),
/* 522 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return QueryDocumentKeys; });
/* unused harmony export BREAK */
/* harmony export (immutable) */ __webpack_exports__["b"] = visit;
/* unused harmony export visitInParallel */
/* unused harmony export visitWithTypeInfo */
/* unused harmony export getVisitFn */


/**
 * A visitor is comprised of visit functions, which are called on each node
 * during the visitor's traversal.
 */


/**
 * A visitor is provided to visit, it contains the collection of
 * relevant functions to be called during the visitor's traversal.
 */
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */

var QueryDocumentKeys = {
  Name: [],

  Document: ['definitions'],
  OperationDefinition: ['name', 'variableDefinitions', 'directives', 'selectionSet'],
  VariableDefinition: ['variable', 'type', 'defaultValue'],
  Variable: ['name'],
  SelectionSet: ['selections'],
  Field: ['alias', 'name', 'arguments', 'directives', 'selectionSet'],
  Argument: ['name', 'value'],

  FragmentSpread: ['name', 'directives'],
  InlineFragment: ['typeCondition', 'directives', 'selectionSet'],
  FragmentDefinition: ['name',
  // Note: fragment variable definitions are experimental and may be changed
  // or removed in the future.
  'variableDefinitions', 'typeCondition', 'directives', 'selectionSet'],

  IntValue: [],
  FloatValue: [],
  StringValue: [],
  BooleanValue: [],
  NullValue: [],
  EnumValue: [],
  ListValue: ['values'],
  ObjectValue: ['fields'],
  ObjectField: ['name', 'value'],

  Directive: ['name', 'arguments'],

  NamedType: ['name'],
  ListType: ['type'],
  NonNullType: ['type'],

  SchemaDefinition: ['directives', 'operationTypes'],
  OperationTypeDefinition: ['type'],

  ScalarTypeDefinition: ['description', 'name', 'directives'],
  ObjectTypeDefinition: ['description', 'name', 'interfaces', 'directives', 'fields'],
  FieldDefinition: ['description', 'name', 'arguments', 'type', 'directives'],
  InputValueDefinition: ['description', 'name', 'type', 'defaultValue', 'directives'],
  InterfaceTypeDefinition: ['description', 'name', 'directives', 'fields'],
  UnionTypeDefinition: ['description', 'name', 'directives', 'types'],
  EnumTypeDefinition: ['description', 'name', 'directives', 'values'],
  EnumValueDefinition: ['description', 'name', 'directives'],
  InputObjectTypeDefinition: ['description', 'name', 'directives', 'fields'],

  ScalarTypeExtension: ['name', 'directives'],
  ObjectTypeExtension: ['name', 'interfaces', 'directives', 'fields'],
  InterfaceTypeExtension: ['name', 'directives', 'fields'],
  UnionTypeExtension: ['name', 'directives', 'types'],
  EnumTypeExtension: ['name', 'directives', 'values'],
  InputObjectTypeExtension: ['name', 'directives', 'fields'],

  DirectiveDefinition: ['description', 'name', 'arguments', 'locations']
};

/**
 * A KeyMap describes each the traversable properties of each kind of node.
 */


var BREAK = {};

/**
 * visit() will walk through an AST using a depth first traversal, calling
 * the visitor's enter function at each node in the traversal, and calling the
 * leave function after visiting that node and all of its child nodes.
 *
 * By returning different values from the enter and leave functions, the
 * behavior of the visitor can be altered, including skipping over a sub-tree of
 * the AST (by returning false), editing the AST by returning a value or null
 * to remove the value, or to stop the whole traversal by returning BREAK.
 *
 * When using visit() to edit an AST, the original AST will not be modified, and
 * a new version of the AST with the changes applied will be returned from the
 * visit function.
 *
 *     const editedAST = visit(ast, {
 *       enter(node, key, parent, path, ancestors) {
 *         // @return
 *         //   undefined: no action
 *         //   false: skip visiting this node
 *         //   visitor.BREAK: stop visiting altogether
 *         //   null: delete this node
 *         //   any value: replace this node with the returned value
 *       },
 *       leave(node, key, parent, path, ancestors) {
 *         // @return
 *         //   undefined: no action
 *         //   false: no action
 *         //   visitor.BREAK: stop visiting altogether
 *         //   null: delete this node
 *         //   any value: replace this node with the returned value
 *       }
 *     });
 *
 * Alternatively to providing enter() and leave() functions, a visitor can
 * instead provide functions named the same as the kinds of AST nodes, or
 * enter/leave visitors at a named key, leading to four permutations of
 * visitor API:
 *
 * 1) Named visitors triggered when entering a node a specific kind.
 *
 *     visit(ast, {
 *       Kind(node) {
 *         // enter the "Kind" node
 *       }
 *     })
 *
 * 2) Named visitors that trigger upon entering and leaving a node of
 *    a specific kind.
 *
 *     visit(ast, {
 *       Kind: {
 *         enter(node) {
 *           // enter the "Kind" node
 *         }
 *         leave(node) {
 *           // leave the "Kind" node
 *         }
 *       }
 *     })
 *
 * 3) Generic visitors that trigger upon entering and leaving any node.
 *
 *     visit(ast, {
 *       enter(node) {
 *         // enter any node
 *       },
 *       leave(node) {
 *         // leave any node
 *       }
 *     })
 *
 * 4) Parallel visitors for entering and leaving nodes of a specific kind.
 *
 *     visit(ast, {
 *       enter: {
 *         Kind(node) {
 *           // enter the "Kind" node
 *         }
 *       },
 *       leave: {
 *         Kind(node) {
 *           // leave the "Kind" node
 *         }
 *       }
 *     })
 */
function visit(root, visitor) {
  var visitorKeys = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : QueryDocumentKeys;

  /* eslint-disable no-undef-init */
  var stack = undefined;
  var inArray = Array.isArray(root);
  var keys = [root];
  var index = -1;
  var edits = [];
  var node = undefined;
  var key = undefined;
  var parent = undefined;
  var path = [];
  var ancestors = [];
  var newRoot = root;
  /* eslint-enable no-undef-init */

  do {
    index++;
    var isLeaving = index === keys.length;
    var isEdited = isLeaving && edits.length !== 0;
    if (isLeaving) {
      key = ancestors.length === 0 ? undefined : path[path.length - 1];
      node = parent;
      parent = ancestors.pop();
      if (isEdited) {
        if (inArray) {
          node = node.slice();
        } else {
          var clone = {};
          for (var k in node) {
            if (node.hasOwnProperty(k)) {
              clone[k] = node[k];
            }
          }
          node = clone;
        }
        var editOffset = 0;
        for (var ii = 0; ii < edits.length; ii++) {
          var editKey = edits[ii][0];
          var editValue = edits[ii][1];
          if (inArray) {
            editKey -= editOffset;
          }
          if (inArray && editValue === null) {
            node.splice(editKey, 1);
            editOffset++;
          } else {
            node[editKey] = editValue;
          }
        }
      }
      index = stack.index;
      keys = stack.keys;
      edits = stack.edits;
      inArray = stack.inArray;
      stack = stack.prev;
    } else {
      key = parent ? inArray ? index : keys[index] : undefined;
      node = parent ? parent[key] : newRoot;
      if (node === null || node === undefined) {
        continue;
      }
      if (parent) {
        path.push(key);
      }
    }

    var result = void 0;
    if (!Array.isArray(node)) {
      if (!isNode(node)) {
        throw new Error('Invalid AST Node: ' + JSON.stringify(node));
      }
      var visitFn = getVisitFn(visitor, node.kind, isLeaving);
      if (visitFn) {
        result = visitFn.call(visitor, node, key, parent, path, ancestors);

        if (result === BREAK) {
          break;
        }

        if (result === false) {
          if (!isLeaving) {
            path.pop();
            continue;
          }
        } else if (result !== undefined) {
          edits.push([key, result]);
          if (!isLeaving) {
            if (isNode(result)) {
              node = result;
            } else {
              path.pop();
              continue;
            }
          }
        }
      }
    }

    if (result === undefined && isEdited) {
      edits.push([key, node]);
    }

    if (isLeaving) {
      path.pop();
    } else {
      stack = { inArray: inArray, index: index, keys: keys, edits: edits, prev: stack };
      inArray = Array.isArray(node);
      keys = inArray ? node : visitorKeys[node.kind] || [];
      index = -1;
      edits = [];
      if (parent) {
        ancestors.push(parent);
      }
      parent = node;
    }
  } while (stack !== undefined);

  if (edits.length !== 0) {
    newRoot = edits[edits.length - 1][1];
  }

  return newRoot;
}

function isNode(maybeNode) {
  return Boolean(maybeNode && typeof maybeNode.kind === 'string');
}

/**
 * Creates a new visitor instance which delegates to many visitors to run in
 * parallel. Each visitor will be visited for each node before moving on.
 *
 * If a prior visitor edits a node, no following visitors will see that node.
 */
function visitInParallel(visitors) {
  var skipping = new Array(visitors.length);

  return {
    enter: function enter(node) {
      for (var i = 0; i < visitors.length; i++) {
        if (!skipping[i]) {
          var fn = getVisitFn(visitors[i], node.kind, /* isLeaving */false);
          if (fn) {
            var result = fn.apply(visitors[i], arguments);
            if (result === false) {
              skipping[i] = node;
            } else if (result === BREAK) {
              skipping[i] = BREAK;
            } else if (result !== undefined) {
              return result;
            }
          }
        }
      }
    },
    leave: function leave(node) {
      for (var i = 0; i < visitors.length; i++) {
        if (!skipping[i]) {
          var fn = getVisitFn(visitors[i], node.kind, /* isLeaving */true);
          if (fn) {
            var result = fn.apply(visitors[i], arguments);
            if (result === BREAK) {
              skipping[i] = BREAK;
            } else if (result !== undefined && result !== false) {
              return result;
            }
          }
        } else if (skipping[i] === node) {
          skipping[i] = null;
        }
      }
    }
  };
}

/**
 * Creates a new visitor instance which maintains a provided TypeInfo instance
 * along with visiting visitor.
 */
function visitWithTypeInfo(typeInfo, visitor) {
  return {
    enter: function enter(node) {
      typeInfo.enter(node);
      var fn = getVisitFn(visitor, node.kind, /* isLeaving */false);
      if (fn) {
        var result = fn.apply(visitor, arguments);
        if (result !== undefined) {
          typeInfo.leave(node);
          if (isNode(result)) {
            typeInfo.enter(result);
          }
        }
        return result;
      }
    },
    leave: function leave(node) {
      var fn = getVisitFn(visitor, node.kind, /* isLeaving */true);
      var result = void 0;
      if (fn) {
        result = fn.apply(visitor, arguments);
      }
      typeInfo.leave(node);
      return result;
    }
  };
}

/**
 * Given a visitor instance, if it is leaving or not, and a node kind, return
 * the function the visitor runtime should call.
 */
function getVisitFn(visitor, kind, isLeaving) {
  var kindVisitor = visitor[kind];
  if (kindVisitor) {
    if (!isLeaving && typeof kindVisitor === 'function') {
      // { Kind() {} }
      return kindVisitor;
    }
    var kindSpecificVisitor = isLeaving ? kindVisitor.leave : kindVisitor.enter;
    if (typeof kindSpecificVisitor === 'function') {
      // { Kind: { enter() {}, leave() {} } }
      return kindSpecificVisitor;
    }
  } else {
    var specificVisitor = isLeaving ? visitor.leave : visitor.enter;
    if (specificVisitor) {
      if (typeof specificVisitor === 'function') {
        // { enter() {}, leave() {} }
        return specificVisitor;
      }
      var specificKindVisitor = specificVisitor[kind];
      if (typeof specificKindVisitor === 'function') {
        // { enter: { Kind() {} }, leave: { Kind() {} } }
        return specificKindVisitor;
      }
    }
  }
}

/***/ }),
/* 523 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["f"] = getMutationDefinition;
/* harmony export (immutable) */ __webpack_exports__["a"] = checkDocument;
/* harmony export (immutable) */ __webpack_exports__["g"] = getOperationDefinition;
/* harmony export (immutable) */ __webpack_exports__["h"] = getOperationDefinitionOrDie;
/* harmony export (immutable) */ __webpack_exports__["i"] = getOperationName;
/* harmony export (immutable) */ __webpack_exports__["d"] = getFragmentDefinitions;
/* harmony export (immutable) */ __webpack_exports__["j"] = getQueryDefinition;
/* unused harmony export getFragmentDefinition */
/* harmony export (immutable) */ __webpack_exports__["e"] = getMainDefinition;
/* harmony export (immutable) */ __webpack_exports__["b"] = createFragmentMap;
/* harmony export (immutable) */ __webpack_exports__["c"] = getDefaultValues;
/* unused harmony export variablesInOperation */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_assign__ = __webpack_require__(524);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__storeUtils__ = __webpack_require__(337);


function getMutationDefinition(doc) {
    checkDocument(doc);
    var mutationDef = doc.definitions.filter(function (definition) {
        return definition.kind === 'OperationDefinition' &&
            definition.operation === 'mutation';
    })[0];
    if (!mutationDef) {
        throw new Error('Must contain a mutation definition.');
    }
    return mutationDef;
}
function checkDocument(doc) {
    if (doc.kind !== 'Document') {
        throw new Error("Expecting a parsed GraphQL document. Perhaps you need to wrap the query string in a \"gql\" tag? http://docs.apollostack.com/apollo-client/core.html#gql");
    }
    var operations = doc.definitions
        .filter(function (d) { return d.kind !== 'FragmentDefinition'; })
        .map(function (definition) {
        if (definition.kind !== 'OperationDefinition') {
            throw new Error("Schema type definitions not allowed in queries. Found: \"" + definition.kind + "\"");
        }
        return definition;
    });
    if (operations.length > 1) {
        throw new Error("Ambiguous GraphQL document: contains " + operations.length + " operations");
    }
}
function getOperationDefinition(doc) {
    checkDocument(doc);
    return doc.definitions.filter(function (definition) { return definition.kind === 'OperationDefinition'; })[0];
}
function getOperationDefinitionOrDie(document) {
    var def = getOperationDefinition(document);
    if (!def) {
        throw new Error("GraphQL document is missing an operation");
    }
    return def;
}
function getOperationName(doc) {
    return (doc.definitions
        .filter(function (definition) {
        return definition.kind === 'OperationDefinition' && definition.name;
    })
        .map(function (x) { return x.name.value; })[0] || null);
}
function getFragmentDefinitions(doc) {
    return doc.definitions.filter(function (definition) { return definition.kind === 'FragmentDefinition'; });
}
function getQueryDefinition(doc) {
    var queryDef = getOperationDefinition(doc);
    if (!queryDef || queryDef.operation !== 'query') {
        throw new Error('Must contain a query definition.');
    }
    return queryDef;
}
function getFragmentDefinition(doc) {
    if (doc.kind !== 'Document') {
        throw new Error("Expecting a parsed GraphQL document. Perhaps you need to wrap the query string in a \"gql\" tag? http://docs.apollostack.com/apollo-client/core.html#gql");
    }
    if (doc.definitions.length > 1) {
        throw new Error('Fragment must have exactly one definition.');
    }
    var fragmentDef = doc.definitions[0];
    if (fragmentDef.kind !== 'FragmentDefinition') {
        throw new Error('Must be a fragment definition.');
    }
    return fragmentDef;
}
function getMainDefinition(queryDoc) {
    checkDocument(queryDoc);
    var fragmentDefinition;
    for (var _i = 0, _a = queryDoc.definitions; _i < _a.length; _i++) {
        var definition = _a[_i];
        if (definition.kind === 'OperationDefinition') {
            var operation = definition.operation;
            if (operation === 'query' ||
                operation === 'mutation' ||
                operation === 'subscription') {
                return definition;
            }
        }
        if (definition.kind === 'FragmentDefinition' && !fragmentDefinition) {
            fragmentDefinition = definition;
        }
    }
    if (fragmentDefinition) {
        return fragmentDefinition;
    }
    throw new Error('Expected a parsed GraphQL query with a query, mutation, subscription, or a fragment.');
}
function createFragmentMap(fragments) {
    if (fragments === void 0) { fragments = []; }
    var symTable = {};
    fragments.forEach(function (fragment) {
        symTable[fragment.name.value] = fragment;
    });
    return symTable;
}
function getDefaultValues(definition) {
    if (definition &&
        definition.variableDefinitions &&
        definition.variableDefinitions.length) {
        var defaultValues = definition.variableDefinitions
            .filter(function (_a) {
            var defaultValue = _a.defaultValue;
            return defaultValue;
        })
            .map(function (_a) {
            var variable = _a.variable, defaultValue = _a.defaultValue;
            var defaultValueObj = {};
            Object(__WEBPACK_IMPORTED_MODULE_1__storeUtils__["j" /* valueToObjectRepresentation */])(defaultValueObj, variable.name, defaultValue);
            return defaultValueObj;
        });
        return __WEBPACK_IMPORTED_MODULE_0__util_assign__["a" /* assign */].apply(void 0, [{}].concat(defaultValues));
    }
    return {};
}
function variablesInOperation(operation) {
    var names = new Set();
    if (operation.variableDefinitions) {
        for (var _i = 0, _a = operation.variableDefinitions; _i < _a.length; _i++) {
            var definition = _a[_i];
            names.add(definition.variable.name.value);
        }
    }
    return names;
}
//# sourceMappingURL=getFromAST.js.map

/***/ }),
/* 524 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = assign;
function assign(target) {
    var sources = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        sources[_i - 1] = arguments[_i];
    }
    sources.forEach(function (source) {
        if (typeof source === 'undefined' || source === null) {
            return;
        }
        Object.keys(source).forEach(function (key) {
            target[key] = source[key];
        });
    });
    return target;
}
//# sourceMappingURL=assign.js.map

/***/ }),
/* 525 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = cloneDeep;
var toString = Object.prototype.toString;
function cloneDeep(value) {
    return cloneDeepHelper(value, new Map());
}
function cloneDeepHelper(val, seen) {
    switch (toString.call(val)) {
        case "[object Array]": {
            if (seen.has(val))
                return seen.get(val);
            var copy_1 = val.slice(0);
            seen.set(val, copy_1);
            copy_1.forEach(function (child, i) {
                copy_1[i] = cloneDeepHelper(child, seen);
            });
            return copy_1;
        }
        case "[object Object]": {
            if (seen.has(val))
                return seen.get(val);
            var copy_2 = Object.create(Object.getPrototypeOf(val));
            seen.set(val, copy_2);
            Object.keys(val).forEach(function (key) {
                copy_2[key] = cloneDeepHelper(val[key], seen);
            });
            return copy_2;
        }
        default:
            return val;
    }
}
//# sourceMappingURL=cloneDeep.js.map

/***/ }),
/* 526 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Observable; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_apollo_link__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_symbol_observable__ = __webpack_require__(301);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


var Observable = (function (_super) {
    __extends(Observable, _super);
    function Observable() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Observable.prototype[__WEBPACK_IMPORTED_MODULE_1_symbol_observable__["default"]] = function () {
        return this;
    };
    Observable.prototype['@@observable'] = function () {
        return this;
    };
    return Observable;
}(__WEBPACK_IMPORTED_MODULE_0_apollo_link__["Observable"]));

//# sourceMappingURL=Observable.js.map

/***/ }),
/* 527 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Observable; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zen_observable__ = __webpack_require__(1113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zen_observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_zen_observable__);
/* tslint:disable */

var Observable = __WEBPACK_IMPORTED_MODULE_0_zen_observable___default.a;
//# sourceMappingURL=zenObservable.js.map

/***/ }),
/* 528 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["i"] = validateOperation;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LinkError; });
/* harmony export (immutable) */ __webpack_exports__["e"] = isTerminating;
/* harmony export (immutable) */ __webpack_exports__["g"] = toPromise;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return makePromise; });
/* harmony export (immutable) */ __webpack_exports__["d"] = fromPromise;
/* harmony export (immutable) */ __webpack_exports__["c"] = fromError;
/* harmony export (immutable) */ __webpack_exports__["h"] = transformOperation;
/* harmony export (immutable) */ __webpack_exports__["b"] = createOperation;
/* unused harmony export getKey */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_apollo_utilities__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_zen_observable_ts__ = __webpack_require__(339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_graphql_language_printer__ = __webpack_require__(143);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};



function validateOperation(operation) {
    var OPERATION_FIELDS = [
        'query',
        'operationName',
        'variables',
        'extensions',
        'context',
    ];
    for (var _i = 0, _a = Object.keys(operation); _i < _a.length; _i++) {
        var key = _a[_i];
        if (OPERATION_FIELDS.indexOf(key) < 0) {
            throw new Error("illegal argument: " + key);
        }
    }
    return operation;
}
var LinkError = /** @class */ (function (_super) {
    __extends(LinkError, _super);
    function LinkError(message, link) {
        var _this = _super.call(this, message) || this;
        _this.link = link;
        return _this;
    }
    return LinkError;
}(Error));

function isTerminating(link) {
    return link.request.length <= 1;
}
function toPromise(observable) {
    var completed = false;
    return new Promise(function (resolve, reject) {
        observable.subscribe({
            next: function (data) {
                if (completed) {
                    console.warn("Promise Wrapper does not support multiple results from Observable");
                }
                else {
                    completed = true;
                    resolve(data);
                }
            },
            error: reject,
        });
    });
}
// backwards compat
var makePromise = toPromise;
function fromPromise(promise) {
    return new __WEBPACK_IMPORTED_MODULE_1_zen_observable_ts__["a" /* default */](function (observer) {
        promise
            .then(function (value) {
            observer.next(value);
            observer.complete();
        })
            .catch(observer.error.bind(observer));
    });
}
function fromError(errorValue) {
    return new __WEBPACK_IMPORTED_MODULE_1_zen_observable_ts__["a" /* default */](function (observer) {
        observer.error(errorValue);
    });
}
function transformOperation(operation) {
    var transformedOperation = {
        variables: operation.variables || {},
        extensions: operation.extensions || {},
        operationName: operation.operationName,
        query: operation.query,
    };
    // best guess at an operation name
    if (!transformedOperation.operationName) {
        transformedOperation.operationName =
            typeof transformedOperation.query !== 'string'
                ? Object(__WEBPACK_IMPORTED_MODULE_0_apollo_utilities__["m" /* getOperationName */])(transformedOperation.query)
                : '';
    }
    return transformedOperation;
}
function createOperation(starting, operation) {
    var context = __assign({}, starting);
    var setContext = function (next) {
        if (typeof next === 'function') {
            context = __assign({}, context, next(context));
        }
        else {
            context = __assign({}, context, next);
        }
    };
    var getContext = function () { return (__assign({}, context)); };
    Object.defineProperty(operation, 'setContext', {
        enumerable: false,
        value: setContext,
    });
    Object.defineProperty(operation, 'getContext', {
        enumerable: false,
        value: getContext,
    });
    Object.defineProperty(operation, 'toKey', {
        enumerable: false,
        value: function () { return getKey(operation); },
    });
    return operation;
}
function getKey(operation) {
    // XXX we're assuming here that variables will be serialized in the same order.
    // that might not always be true
    return Object(__WEBPACK_IMPORTED_MODULE_2_graphql_language_printer__["a" /* print */])(operation.query) + "|" + JSON.stringify(operation.variables) + "|" + operation.operationName;
}
//# sourceMappingURL=linkUtils.js.map

/***/ }),
/* 529 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actionTypes__ = __webpack_require__(344);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




var arrayInsert = function arrayInsert(form, field, index, value) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["ARRAY_INSERT"],
    meta: { form: form, field: field, index: index },
    payload: value
  };
};

var arrayMove = function arrayMove(form, field, from, to) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["ARRAY_MOVE"],
    meta: { form: form, field: field, from: from, to: to }
  };
};

var arrayPop = function arrayPop(form, field) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["ARRAY_POP"],
    meta: { form: form, field: field }
  };
};

var arrayPush = function arrayPush(form, field, value) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["ARRAY_PUSH"],
    meta: { form: form, field: field },
    payload: value
  };
};

var arrayRemove = function arrayRemove(form, field, index) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["ARRAY_REMOVE"],
    meta: { form: form, field: field, index: index }
  };
};

var arrayRemoveAll = function arrayRemoveAll(form, field) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["ARRAY_REMOVE_ALL"],
    meta: { form: form, field: field }
  };
};

var arrayShift = function arrayShift(form, field) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["ARRAY_SHIFT"],
    meta: { form: form, field: field }
  };
};

var arraySplice = function arraySplice(form, field, index, removeNum, value) {
  var action = {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["ARRAY_SPLICE"],
    meta: { form: form, field: field, index: index, removeNum: removeNum }
  };
  if (value !== undefined) {
    action.payload = value;
  }
  return action;
};

var arraySwap = function arraySwap(form, field, indexA, indexB) {
  if (indexA === indexB) {
    throw new Error('Swap indices cannot be equal');
  }
  if (indexA < 0 || indexB < 0) {
    throw new Error('Swap indices cannot be negative');
  }
  return { type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["ARRAY_SWAP"], meta: { form: form, field: field, indexA: indexA, indexB: indexB } };
};

var arrayUnshift = function arrayUnshift(form, field, value) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["ARRAY_UNSHIFT"],
    meta: { form: form, field: field },
    payload: value
  };
};

var autofill = function autofill(form, field, value) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["AUTOFILL"],
    meta: { form: form, field: field },
    payload: value
  };
};

var blur = function blur(form, field, value, touch) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["BLUR"],
    meta: { form: form, field: field, touch: touch },
    payload: value
  };
};

var change = function change(form, field, value, touch, persistentSubmitErrors) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["CHANGE"],
    meta: { form: form, field: field, touch: touch, persistentSubmitErrors: persistentSubmitErrors },
    payload: value
  };
};

var clearSubmit = function clearSubmit(form) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["CLEAR_SUBMIT"],
    meta: { form: form }
  };
};

var clearSubmitErrors = function clearSubmitErrors(form) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["CLEAR_SUBMIT_ERRORS"],
    meta: { form: form }
  };
};

var clearAsyncError = function clearAsyncError(form, field) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["CLEAR_ASYNC_ERROR"],
    meta: { form: form, field: field }
  };
};

var clearFields = function clearFields(form, keepTouched, persistentSubmitErrors) {
  for (var _len = arguments.length, fields = Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
    fields[_key - 3] = arguments[_key];
  }

  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["CLEAR_FIELDS"],
    meta: { form: form, keepTouched: keepTouched, persistentSubmitErrors: persistentSubmitErrors, fields: fields }
  };
};

var destroy = function destroy() {
  for (var _len2 = arguments.length, form = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    form[_key2] = arguments[_key2];
  }

  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["DESTROY"],
    meta: { form: form }
  };
};

var focus = function focus(form, field) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["FOCUS"],
    meta: { form: form, field: field }
  };
};

var initialize = function initialize(form, values, keepDirty) {
  var otherMeta = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

  if (keepDirty instanceof Object) {
    otherMeta = keepDirty;
    keepDirty = false;
  }
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["INITIALIZE"],
    meta: _extends({ form: form, keepDirty: keepDirty }, otherMeta),
    payload: values
  };
};

var registerField = function registerField(form, name, type) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["REGISTER_FIELD"],
    meta: { form: form },
    payload: { name: name, type: type }
  };
};

var reset = function reset(form) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["RESET"],
    meta: { form: form }
  };
};

var resetSection = function resetSection(form) {
  for (var _len3 = arguments.length, sections = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
    sections[_key3 - 1] = arguments[_key3];
  }

  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["RESET_SECTION"],
    meta: { form: form, sections: sections }
  };
};

var startAsyncValidation = function startAsyncValidation(form, field) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["START_ASYNC_VALIDATION"],
    meta: { form: form, field: field }
  };
};

var startSubmit = function startSubmit(form) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["START_SUBMIT"],
    meta: { form: form }
  };
};

var stopAsyncValidation = function stopAsyncValidation(form, errors) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["STOP_ASYNC_VALIDATION"],
    meta: { form: form },
    payload: errors,
    error: !!(errors && Object.keys(errors).length)
  };
};

var stopSubmit = function stopSubmit(form, errors) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["STOP_SUBMIT"],
    meta: { form: form },
    payload: errors,
    error: !!(errors && Object.keys(errors).length)
  };
};

var submit = function submit(form) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["SUBMIT"],
    meta: { form: form }
  };
};

var setSubmitFailed = function setSubmitFailed(form) {
  for (var _len4 = arguments.length, fields = Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
    fields[_key4 - 1] = arguments[_key4];
  }

  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["SET_SUBMIT_FAILED"],
    meta: { form: form, fields: fields },
    error: true
  };
};

var setSubmitSucceeded = function setSubmitSucceeded(form) {
  for (var _len5 = arguments.length, fields = Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
    fields[_key5 - 1] = arguments[_key5];
  }

  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["SET_SUBMIT_SUCCEEDED"],
    meta: { form: form, fields: fields },
    error: false
  };
};

var touch = function touch(form) {
  for (var _len6 = arguments.length, fields = Array(_len6 > 1 ? _len6 - 1 : 0), _key6 = 1; _key6 < _len6; _key6++) {
    fields[_key6 - 1] = arguments[_key6];
  }

  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["TOUCH"],
    meta: { form: form, fields: fields }
  };
};

var unregisterField = function unregisterField(form, name) {
  var destroyOnUnmount = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["UNREGISTER_FIELD"],
    meta: { form: form },
    payload: { name: name, destroyOnUnmount: destroyOnUnmount }
  };
};

var untouch = function untouch(form) {
  for (var _len7 = arguments.length, fields = Array(_len7 > 1 ? _len7 - 1 : 0), _key7 = 1; _key7 < _len7; _key7++) {
    fields[_key7 - 1] = arguments[_key7];
  }

  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["UNTOUCH"],
    meta: { form: form, fields: fields }
  };
};

var updateSyncErrors = function updateSyncErrors(form) {
  var syncErrors = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var error = arguments[2];
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["UPDATE_SYNC_ERRORS"],
    meta: { form: form },
    payload: { syncErrors: syncErrors, error: error }
  };
};

var updateSyncWarnings = function updateSyncWarnings(form) {
  var syncWarnings = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var warning = arguments[2];
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["UPDATE_SYNC_WARNINGS"],
    meta: { form: form },
    payload: { syncWarnings: syncWarnings, warning: warning }
  };
};

var actions = {
  arrayInsert: arrayInsert,
  arrayMove: arrayMove,
  arrayPop: arrayPop,
  arrayPush: arrayPush,
  arrayRemove: arrayRemove,
  arrayRemoveAll: arrayRemoveAll,
  arrayShift: arrayShift,
  arraySplice: arraySplice,
  arraySwap: arraySwap,
  arrayUnshift: arrayUnshift,
  autofill: autofill,
  blur: blur,
  change: change,
  clearFields: clearFields,
  clearSubmit: clearSubmit,
  clearSubmitErrors: clearSubmitErrors,
  clearAsyncError: clearAsyncError,
  destroy: destroy,
  focus: focus,
  initialize: initialize,
  registerField: registerField,
  reset: reset,
  resetSection: resetSection,
  startAsyncValidation: startAsyncValidation,
  startSubmit: startSubmit,
  stopAsyncValidation: stopAsyncValidation,
  stopSubmit: stopSubmit,
  submit: submit,
  setSubmitFailed: setSubmitFailed,
  setSubmitSucceeded: setSubmitSucceeded,
  touch: touch,
  unregisterField: unregisterField,
  untouch: untouch,
  updateSyncErrors: updateSyncErrors,
  updateSyncWarnings: updateSyncWarnings
};

/* harmony default export */ __webpack_exports__["a"] = (actions);

/***/ }),
/* 530 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


var defaultShouldAsyncValidate = function defaultShouldAsyncValidate(_ref) {
  var initialized = _ref.initialized,
      trigger = _ref.trigger,
      pristine = _ref.pristine,
      syncValidationPasses = _ref.syncValidationPasses;

  if (!syncValidationPasses) {
    return false;
  }
  switch (trigger) {
    case 'blur':
    case 'change':
      // blurring
      return true;
    case 'submit':
      // submitting, so only async validate if form is dirty or was never initialized
      // conversely, DON'T async validate if the form is pristine just as it was initialized
      return !pristine || !initialized;
    default:
      return false;
  }
};


/* harmony default export */ __webpack_exports__["a"] = (defaultShouldAsyncValidate);

/***/ }),
/* 531 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


var defaultShouldValidate = function defaultShouldValidate(_ref) {
  var values = _ref.values,
      nextProps = _ref.nextProps,
      initialRender = _ref.initialRender,
      lastFieldValidatorKeys = _ref.lastFieldValidatorKeys,
      fieldValidatorKeys = _ref.fieldValidatorKeys,
      structure = _ref.structure;

  if (initialRender) {
    return true;
  }
  return !structure.deepEqual(values, nextProps && nextProps.values) || !structure.deepEqual(lastFieldValidatorKeys, fieldValidatorKeys);
};


/* harmony default export */ __webpack_exports__["a"] = (defaultShouldValidate);

/***/ }),
/* 532 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


var defaultShouldError = function defaultShouldError(_ref) {
  var values = _ref.values,
      nextProps = _ref.nextProps,
      initialRender = _ref.initialRender,
      lastFieldValidatorKeys = _ref.lastFieldValidatorKeys,
      fieldValidatorKeys = _ref.fieldValidatorKeys,
      structure = _ref.structure;

  if (initialRender) {
    return true;
  }
  return !structure.deepEqual(values, nextProps && nextProps.values) || !structure.deepEqual(lastFieldValidatorKeys, fieldValidatorKeys);
};


/* harmony default export */ __webpack_exports__["a"] = (defaultShouldError);

/***/ }),
/* 533 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


var defaultShouldWarn = function defaultShouldWarn(_ref) {
  var values = _ref.values,
      nextProps = _ref.nextProps,
      initialRender = _ref.initialRender,
      lastFieldValidatorKeys = _ref.lastFieldValidatorKeys,
      fieldValidatorKeys = _ref.fieldValidatorKeys,
      structure = _ref.structure;

  if (initialRender) {
    return true;
  }
  return !structure.deepEqual(values, nextProps && nextProps.values) || !structure.deepEqual(lastFieldValidatorKeys, fieldValidatorKeys);
};


/* harmony default export */ __webpack_exports__["a"] = (defaultShouldWarn);

/***/ }),
/* 534 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_es6_error__ = __webpack_require__(1133);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var SubmissionError = function (_ExtendableError) {
  _inherits(SubmissionError, _ExtendableError);

  function SubmissionError(errors) {
    _classCallCheck(this, SubmissionError);

    var _this = _possibleConstructorReturn(this, (SubmissionError.__proto__ || Object.getPrototypeOf(SubmissionError)).call(this, 'Submit Validation Failed'));

    _this.errors = errors;
    return _this;
  }

  return SubmissionError;
}(__WEBPACK_IMPORTED_MODULE_0_es6_error__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (SubmissionError);

/***/ }),
/* 535 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _inheritsLoose;
function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

/***/ }),
/* 536 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return subscriptionShape; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return storeShape; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);

var subscriptionShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  trySubscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  tryUnsubscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  notifyNestedSubs: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  isSubscribed: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
});
var storeShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  subscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  dispatch: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  getState: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
});

/***/ }),
/* 537 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = connectAdvanced;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(535);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_assertThisInitialized__ = __webpack_require__(1139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__ = __webpack_require__(346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics__ = __webpack_require__(1140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_invariant__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_is__ = __webpack_require__(343);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_is___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_is__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_Subscription__ = __webpack_require__(1141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_PropTypes__ = __webpack_require__(536);










var hotReloadingVersion = 0;
var dummyState = {};

function noop() {}

function makeSelectorStateful(sourceSelector, store) {
  // wrap the selector in an object that tracks its results between runs.
  var selector = {
    run: function runComponentSelector(props) {
      try {
        var nextProps = sourceSelector(store.getState(), props);

        if (nextProps !== selector.props || selector.error) {
          selector.shouldComponentUpdate = true;
          selector.props = nextProps;
          selector.error = null;
        }
      } catch (error) {
        selector.shouldComponentUpdate = true;
        selector.error = error;
      }
    }
  };
  return selector;
}

function connectAdvanced(
/*
  selectorFactory is a func that is responsible for returning the selector function used to
  compute new props from state, props, and dispatch. For example:
     export default connectAdvanced((dispatch, options) => (state, props) => ({
      thing: state.things[props.thingId],
      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
    }))(YourComponent)
   Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
   Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
  props. Do not use connectAdvanced directly without memoizing results between calls to your
  selector, otherwise the Connect component will re-render on every state or props change.
*/
selectorFactory, // options object:
_ref) {
  var _contextTypes, _childContextTypes;

  if (_ref === void 0) {
    _ref = {};
  }

  var _ref2 = _ref,
      _ref2$getDisplayName = _ref2.getDisplayName,
      getDisplayName = _ref2$getDisplayName === void 0 ? function (name) {
    return "ConnectAdvanced(" + name + ")";
  } : _ref2$getDisplayName,
      _ref2$methodName = _ref2.methodName,
      methodName = _ref2$methodName === void 0 ? 'connectAdvanced' : _ref2$methodName,
      _ref2$renderCountProp = _ref2.renderCountProp,
      renderCountProp = _ref2$renderCountProp === void 0 ? undefined : _ref2$renderCountProp,
      _ref2$shouldHandleSta = _ref2.shouldHandleStateChanges,
      shouldHandleStateChanges = _ref2$shouldHandleSta === void 0 ? true : _ref2$shouldHandleSta,
      _ref2$storeKey = _ref2.storeKey,
      storeKey = _ref2$storeKey === void 0 ? 'store' : _ref2$storeKey,
      _ref2$withRef = _ref2.withRef,
      withRef = _ref2$withRef === void 0 ? false : _ref2$withRef,
      connectOptions = Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref2, ["getDisplayName", "methodName", "renderCountProp", "shouldHandleStateChanges", "storeKey", "withRef"]);

  var subscriptionKey = storeKey + 'Subscription';
  var version = hotReloadingVersion++;
  var contextTypes = (_contextTypes = {}, _contextTypes[storeKey] = __WEBPACK_IMPORTED_MODULE_9__utils_PropTypes__["a" /* storeShape */], _contextTypes[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_9__utils_PropTypes__["b" /* subscriptionShape */], _contextTypes);
  var childContextTypes = (_childContextTypes = {}, _childContextTypes[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_9__utils_PropTypes__["b" /* subscriptionShape */], _childContextTypes);
  return function wrapWithConnect(WrappedComponent) {
    __WEBPACK_IMPORTED_MODULE_5_invariant___default()(Object(__WEBPACK_IMPORTED_MODULE_7_react_is__["isValidElementType"])(WrappedComponent), "You must pass a component to the function returned by " + (methodName + ". Instead received " + JSON.stringify(WrappedComponent)));
    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
    var displayName = getDisplayName(wrappedComponentName);

    var selectorFactoryOptions = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__["a" /* default */])({}, connectOptions, {
      getDisplayName: getDisplayName,
      methodName: methodName,
      renderCountProp: renderCountProp,
      shouldHandleStateChanges: shouldHandleStateChanges,
      storeKey: storeKey,
      withRef: withRef,
      displayName: displayName,
      wrappedComponentName: wrappedComponentName,
      WrappedComponent: WrappedComponent // TODO Actually fix our use of componentWillReceiveProps

      /* eslint-disable react/no-deprecated */

    });

    var Connect =
    /*#__PURE__*/
    function (_Component) {
      Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Connect, _Component);

      function Connect(props, context) {
        var _this;

        _this = _Component.call(this, props, context) || this;
        _this.version = version;
        _this.state = {};
        _this.renderCount = 0;
        _this.store = props[storeKey] || context[storeKey];
        _this.propsMode = Boolean(props[storeKey]);
        _this.setWrappedInstance = _this.setWrappedInstance.bind(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
        __WEBPACK_IMPORTED_MODULE_5_invariant___default()(_this.store, "Could not find \"" + storeKey + "\" in either the context or props of " + ("\"" + displayName + "\". Either wrap the root component in a <Provider>, ") + ("or explicitly pass \"" + storeKey + "\" as a prop to \"" + displayName + "\"."));

        _this.initSelector();

        _this.initSubscription();

        return _this;
      }

      var _proto = Connect.prototype;

      _proto.getChildContext = function getChildContext() {
        var _ref3;

        // If this component received store from props, its subscription should be transparent
        // to any descendants receiving store+subscription from context; it passes along
        // subscription passed to it. Otherwise, it shadows the parent subscription, which allows
        // Connect to control ordering of notifications to flow top-down.
        var subscription = this.propsMode ? null : this.subscription;
        return _ref3 = {}, _ref3[subscriptionKey] = subscription || this.context[subscriptionKey], _ref3;
      };

      _proto.componentDidMount = function componentDidMount() {
        if (!shouldHandleStateChanges) return; // componentWillMount fires during server side rendering, but componentDidMount and
        // componentWillUnmount do not. Because of this, trySubscribe happens during ...didMount.
        // Otherwise, unsubscription would never take place during SSR, causing a memory leak.
        // To handle the case where a child component may have triggered a state change by
        // dispatching an action in its componentWillMount, we have to re-run the select and maybe
        // re-render.

        this.subscription.trySubscribe();
        this.selector.run(this.props);
        if (this.selector.shouldComponentUpdate) this.forceUpdate();
      };

      _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        this.selector.run(nextProps);
      };

      _proto.shouldComponentUpdate = function shouldComponentUpdate() {
        return this.selector.shouldComponentUpdate;
      };

      _proto.componentWillUnmount = function componentWillUnmount() {
        if (this.subscription) this.subscription.tryUnsubscribe();
        this.subscription = null;
        this.notifyNestedSubs = noop;
        this.store = null;
        this.selector.run = noop;
        this.selector.shouldComponentUpdate = false;
      };

      _proto.getWrappedInstance = function getWrappedInstance() {
        __WEBPACK_IMPORTED_MODULE_5_invariant___default()(withRef, "To access the wrapped instance, you need to specify " + ("{ withRef: true } in the options argument of the " + methodName + "() call."));
        return this.wrappedInstance;
      };

      _proto.setWrappedInstance = function setWrappedInstance(ref) {
        this.wrappedInstance = ref;
      };

      _proto.initSelector = function initSelector() {
        var sourceSelector = selectorFactory(this.store.dispatch, selectorFactoryOptions);
        this.selector = makeSelectorStateful(sourceSelector, this.store);
        this.selector.run(this.props);
      };

      _proto.initSubscription = function initSubscription() {
        if (!shouldHandleStateChanges) return; // parentSub's source should match where store came from: props vs. context. A component
        // connected to the store via props shouldn't use subscription from context, or vice versa.

        var parentSub = (this.propsMode ? this.props : this.context)[subscriptionKey];
        this.subscription = new __WEBPACK_IMPORTED_MODULE_8__utils_Subscription__["a" /* default */](this.store, parentSub, this.onStateChange.bind(this)); // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
        // the middle of the notification loop, where `this.subscription` will then be null. An
        // extra null check every change can be avoided by copying the method onto `this` and then
        // replacing it with a no-op on unmount. This can probably be avoided if Subscription's
        // listeners logic is changed to not call listeners that have been unsubscribed in the
        // middle of the notification loop.

        this.notifyNestedSubs = this.subscription.notifyNestedSubs.bind(this.subscription);
      };

      _proto.onStateChange = function onStateChange() {
        this.selector.run(this.props);

        if (!this.selector.shouldComponentUpdate) {
          this.notifyNestedSubs();
        } else {
          this.componentDidUpdate = this.notifyNestedSubsOnComponentDidUpdate;
          this.setState(dummyState);
        }
      };

      _proto.notifyNestedSubsOnComponentDidUpdate = function notifyNestedSubsOnComponentDidUpdate() {
        // `componentDidUpdate` is conditionally implemented when `onStateChange` determines it
        // needs to notify nested subs. Once called, it unimplements itself until further state
        // changes occur. Doing it this way vs having a permanent `componentDidUpdate` that does
        // a boolean check every time avoids an extra method call most of the time, resulting
        // in some perf boost.
        this.componentDidUpdate = undefined;
        this.notifyNestedSubs();
      };

      _proto.isSubscribed = function isSubscribed() {
        return Boolean(this.subscription) && this.subscription.isSubscribed();
      };

      _proto.addExtraProps = function addExtraProps(props) {
        if (!withRef && !renderCountProp && !(this.propsMode && this.subscription)) return props; // make a shallow copy so that fields added don't leak to the original selector.
        // this is especially important for 'ref' since that's a reference back to the component
        // instance. a singleton memoized selector would then be holding a reference to the
        // instance, preventing the instance from being garbage collected, and that would be bad

        var withExtras = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props);

        if (withRef) withExtras.ref = this.setWrappedInstance;
        if (renderCountProp) withExtras[renderCountProp] = this.renderCount++;
        if (this.propsMode && this.subscription) withExtras[subscriptionKey] = this.subscription;
        return withExtras;
      };

      _proto.render = function render() {
        var selector = this.selector;
        selector.shouldComponentUpdate = false;

        if (selector.error) {
          throw selector.error;
        } else {
          return Object(__WEBPACK_IMPORTED_MODULE_6_react__["createElement"])(WrappedComponent, this.addExtraProps(selector.props));
        }
      };

      return Connect;
    }(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);
    /* eslint-enable react/no-deprecated */


    Connect.WrappedComponent = WrappedComponent;
    Connect.displayName = displayName;
    Connect.childContextTypes = childContextTypes;
    Connect.contextTypes = contextTypes;
    Connect.propTypes = contextTypes;

    if (false) {
      Connect.prototype.componentWillUpdate = function componentWillUpdate() {
        var _this2 = this;

        // We are hot reloading!
        if (this.version !== version) {
          this.version = version;
          this.initSelector(); // If any connected descendants don't hot reload (and resubscribe in the process), their
          // listeners will be lost when we unsubscribe. Unfortunately, by copying over all
          // listeners, this does mean that the old versions of connected descendants will still be
          // notified of state changes; however, their onStateChange function is a no-op so this
          // isn't a huge deal.

          var oldListeners = [];

          if (this.subscription) {
            oldListeners = this.subscription.listeners.get();
            this.subscription.tryUnsubscribe();
          }

          this.initSubscription();

          if (shouldHandleStateChanges) {
            this.subscription.trySubscribe();
            oldListeners.forEach(function (listener) {
              return _this2.subscription.listeners.subscribe(listener);
            });
          }
        }
      };
    }

    return __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics___default()(Connect, WrappedComponent);
  };
}

/***/ }),
/* 538 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = wrapMapToPropsConstant;
/* unused harmony export getDependsOnOwnProps */
/* harmony export (immutable) */ __webpack_exports__["b"] = wrapMapToPropsFunc;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_verifyPlainObject__ = __webpack_require__(539);

function wrapMapToPropsConstant(getConstant) {
  return function initConstantSelector(dispatch, options) {
    var constant = getConstant(dispatch, options);

    function constantSelector() {
      return constant;
    }

    constantSelector.dependsOnOwnProps = false;
    return constantSelector;
  };
} // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
// whether mapToProps needs to be invoked when props have changed.
// 
// A length of one signals that mapToProps does not depend on props from the parent component.
// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
// therefore not reporting its length accurately..

function getDependsOnOwnProps(mapToProps) {
  return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
} // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
// this function wraps mapToProps in a proxy function which does several things:
// 
//  * Detects whether the mapToProps function being called depends on props, which
//    is used by selectorFactory to decide if it should reinvoke on props changes.
//    
//  * On first call, handles mapToProps if returns another function, and treats that
//    new function as the true mapToProps for subsequent calls.
//    
//  * On first call, verifies the first result is a plain object, in order to warn
//    the developer that their mapToProps function is not returning a valid result.
//    

function wrapMapToPropsFunc(mapToProps, methodName) {
  return function initProxySelector(dispatch, _ref) {
    var displayName = _ref.displayName;

    var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
      return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
    }; // allow detectFactoryAndVerify to get ownProps


    proxy.dependsOnOwnProps = true;

    proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
      proxy.mapToProps = mapToProps;
      proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
      var props = proxy(stateOrDispatch, ownProps);

      if (typeof props === 'function') {
        proxy.mapToProps = props;
        proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
        props = proxy(stateOrDispatch, ownProps);
      }

      if (false) verifyPlainObject(props, displayName, methodName);
      return props;
    };

    return proxy;
  };
}

/***/ }),
/* 539 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isPlainObject__ = __webpack_require__(1145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__warning__ = __webpack_require__(345);


function verifyPlainObject(value, displayName, methodName) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_0__isPlainObject__["a" /* default */])(value)) {
    Object(__WEBPACK_IMPORTED_MODULE_1__warning__["a" /* default */])(methodName + "() in " + displayName + " must return a plain object. Instead received " + value + ".");
  }
}

/***/ }),
/* 540 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var processProps = function processProps(type, props, _value, deepEqual) {
  var value = props.value;

  if (type === 'checkbox') {
    return _extends({}, props, {
      checked: !!value
    });
  }
  if (type === 'radio') {
    return _extends({}, props, {
      checked: deepEqual(value, _value),
      value: _value
    });
  }
  if (type === 'select-multiple') {
    return _extends({}, props, {
      value: value || []
    });
  }
  if (type === 'file') {
    return _extends({}, props, {
      value: value || undefined
    });
  }
  return props;
};

var createFieldProps = function createFieldProps(_ref2, name, _ref) {
  var getIn = _ref2.getIn,
      toJS = _ref2.toJS,
      deepEqual = _ref2.deepEqual;

  var asyncError = _ref.asyncError,
      asyncValidating = _ref.asyncValidating,
      onBlur = _ref.onBlur,
      onChange = _ref.onChange,
      onDrop = _ref.onDrop,
      onDragStart = _ref.onDragStart,
      dirty = _ref.dirty,
      dispatch = _ref.dispatch,
      onFocus = _ref.onFocus,
      form = _ref.form,
      format = _ref.format,
      initial = _ref.initial,
      parse = _ref.parse,
      pristine = _ref.pristine,
      props = _ref.props,
      state = _ref.state,
      submitError = _ref.submitError,
      submitFailed = _ref.submitFailed,
      submitting = _ref.submitting,
      syncError = _ref.syncError,
      syncWarning = _ref.syncWarning,
      validate = _ref.validate,
      value = _ref.value,
      _value = _ref._value,
      warn = _ref.warn,
      custom = _objectWithoutProperties(_ref, ['asyncError', 'asyncValidating', 'onBlur', 'onChange', 'onDrop', 'onDragStart', 'dirty', 'dispatch', 'onFocus', 'form', 'format', 'initial', 'parse', 'pristine', 'props', 'state', 'submitError', 'submitFailed', 'submitting', 'syncError', 'syncWarning', 'validate', 'value', '_value', 'warn']);

  var error = syncError || asyncError || submitError;
  var warning = syncWarning;

  var formatFieldValue = function formatFieldValue(value, format) {
    if (format === null) {
      return value;
    }
    var defaultFormattedValue = value == null ? '' : value;
    return format ? format(value, name) : defaultFormattedValue;
  };

  var formattedFieldValue = formatFieldValue(value, format);

  return {
    input: processProps(custom.type, {
      name: name,
      onBlur: onBlur,
      onChange: onChange,
      onDragStart: onDragStart,
      onDrop: onDrop,
      onFocus: onFocus,
      value: formattedFieldValue
    }, _value, deepEqual),
    meta: _extends({}, toJS(state), {
      active: !!(state && getIn(state, 'active')),
      asyncValidating: asyncValidating,
      autofilled: !!(state && getIn(state, 'autofilled')),
      dirty: dirty,
      dispatch: dispatch,
      error: error,
      form: form,
      initial: initial,
      warning: warning,
      invalid: !!error,
      pristine: pristine,
      submitting: !!submitting,
      submitFailed: !!submitFailed,
      touched: !!(state && getIn(state, 'touched')),
      valid: !error,
      visited: !!(state && getIn(state, 'visited'))
    }),
    custom: _extends({}, custom, props)
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createFieldProps);

/***/ }),
/* 541 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getValue__ = __webpack_require__(1150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isReactNative__ = __webpack_require__(543);




var onChangeValue = function onChangeValue(event, _ref) {
  var name = _ref.name,
      parse = _ref.parse,
      normalize = _ref.normalize;

  // read value from input
  var value = Object(__WEBPACK_IMPORTED_MODULE_0__getValue__["a" /* default */])(event, __WEBPACK_IMPORTED_MODULE_1__isReactNative__["a" /* default */]);

  // parse value if we have a parser
  if (parse) {
    value = parse(value, name);
  }

  // normalize value
  if (normalize) {
    value = normalize(name, value);
  }

  return value;
};

/* harmony default export */ __webpack_exports__["a"] = (onChangeValue);

/***/ }),
/* 542 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var isEvent = function isEvent(candidate) {
  return !!(candidate && candidate.stopPropagation && candidate.preventDefault);
};

/* harmony default export */ __webpack_exports__["a"] = (isEvent);

/***/ }),
/* 543 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var isReactNative = typeof window !== 'undefined' && window.navigator && window.navigator.product && window.navigator.product === 'ReactNative';

/* harmony default export */ __webpack_exports__["a"] = (isReactNative);

/***/ }),
/* 544 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (arrayMap);


/***/ }),
/* 545 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

/* harmony default export */ __webpack_exports__["a"] = (copyArray);


/***/ }),
/* 546 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/* harmony default export */ __webpack_exports__["a"] = (freeGlobal);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(26)))

/***/ }),
/* 547 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__memoizeCapped_js__ = __webpack_require__(1156);


/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = Object(__WEBPACK_IMPORTED_MODULE_0__memoizeCapped_js__["a" /* default */])(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

/* harmony default export */ __webpack_exports__["a"] = (stringToPath);


/***/ }),
/* 548 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/* harmony default export */ __webpack_exports__["a"] = (toSource);


/***/ }),
/* 549 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseToString_js__ = __webpack_require__(1179);


/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : Object(__WEBPACK_IMPORTED_MODULE_0__baseToString_js__["a" /* default */])(value);
}

/* harmony default export */ __webpack_exports__["a"] = (toString);


/***/ }),
/* 550 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseIsEqual_js__ = __webpack_require__(238);


/**
 * This method is like `_.isEqual` except that it accepts `customizer` which
 * is invoked to compare values. If `customizer` returns `undefined`, comparisons
 * are handled by the method instead. The `customizer` is invoked with up to
 * six arguments: (objValue, othValue [, index|key, object, other, stack]).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * function isGreeting(value) {
 *   return /^h(?:i|ello)$/.test(value);
 * }
 *
 * function customizer(objValue, othValue) {
 *   if (isGreeting(objValue) && isGreeting(othValue)) {
 *     return true;
 *   }
 * }
 *
 * var array = ['hello', 'goodbye'];
 * var other = ['hi', 'goodbye'];
 *
 * _.isEqualWith(array, other, customizer);
 * // => true
 */
function isEqualWith(value, other, customizer) {
  customizer = typeof customizer == 'function' ? customizer : undefined;
  var result = customizer ? customizer(value, other) : undefined;
  return result === undefined ? Object(__WEBPACK_IMPORTED_MODULE_0__baseIsEqual_js__["a" /* default */])(value, other, undefined, customizer) : !!result;
}

/* harmony default export */ __webpack_exports__["a"] = (isEqualWith);


/***/ }),
/* 551 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SetCache_js__ = __webpack_require__(1188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__arraySome_js__ = __webpack_require__(1191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cacheHas_js__ = __webpack_require__(1192);




/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(array);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new __WEBPACK_IMPORTED_MODULE_0__SetCache_js__["a" /* default */] : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!Object(__WEBPACK_IMPORTED_MODULE_1__arraySome_js__["a" /* default */])(other, function(othValue, othIndex) {
            if (!Object(__WEBPACK_IMPORTED_MODULE_2__cacheHas_js__["a" /* default */])(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (equalArrays);


/***/ }),
/* 552 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_js__ = __webpack_require__(75);


/** Built-in value references. */
var Uint8Array = __WEBPACK_IMPORTED_MODULE_0__root_js__["a" /* default */].Uint8Array;

/* harmony default export */ __webpack_exports__["a"] = (Uint8Array);


/***/ }),
/* 553 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseTimes_js__ = __webpack_require__(1203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isArguments_js__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isArray_js__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isBuffer_js__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__isIndex_js__ = __webpack_require__(353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__isTypedArray_js__ = __webpack_require__(241);







/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = Object(__WEBPACK_IMPORTED_MODULE_2__isArray_js__["a" /* default */])(value),
      isArg = !isArr && Object(__WEBPACK_IMPORTED_MODULE_1__isArguments_js__["a" /* default */])(value),
      isBuff = !isArr && !isArg && Object(__WEBPACK_IMPORTED_MODULE_3__isBuffer_js__["a" /* default */])(value),
      isType = !isArr && !isArg && !isBuff && Object(__WEBPACK_IMPORTED_MODULE_5__isTypedArray_js__["a" /* default */])(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? Object(__WEBPACK_IMPORTED_MODULE_0__baseTimes_js__["a" /* default */])(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           Object(__WEBPACK_IMPORTED_MODULE_4__isIndex_js__["a" /* default */])(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (arrayLikeKeys);


/***/ }),
/* 554 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isPrototype_js__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__nativeKeys_js__ = __webpack_require__(1209);



/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_0__isPrototype_js__["a" /* default */])(object)) {
    return Object(__WEBPACK_IMPORTED_MODULE_1__nativeKeys_js__["a" /* default */])(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (baseKeys);


/***/ }),
/* 555 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/* harmony default export */ __webpack_exports__["a"] = (overArg);


/***/ }),
/* 556 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DataView_js__ = __webpack_require__(1210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Map_js__ = __webpack_require__(350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Promise_js__ = __webpack_require__(1211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Set_js__ = __webpack_require__(1212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__WeakMap_js__ = __webpack_require__(1213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__baseGetTag_js__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__toSource_js__ = __webpack_require__(548);








/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = Object(__WEBPACK_IMPORTED_MODULE_6__toSource_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0__DataView_js__["a" /* default */]),
    mapCtorString = Object(__WEBPACK_IMPORTED_MODULE_6__toSource_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__Map_js__["a" /* default */]),
    promiseCtorString = Object(__WEBPACK_IMPORTED_MODULE_6__toSource_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_2__Promise_js__["a" /* default */]),
    setCtorString = Object(__WEBPACK_IMPORTED_MODULE_6__toSource_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_3__Set_js__["a" /* default */]),
    weakMapCtorString = Object(__WEBPACK_IMPORTED_MODULE_6__toSource_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_4__WeakMap_js__["a" /* default */]);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = __WEBPACK_IMPORTED_MODULE_5__baseGetTag_js__["a" /* default */];

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((__WEBPACK_IMPORTED_MODULE_0__DataView_js__["a" /* default */] && getTag(new __WEBPACK_IMPORTED_MODULE_0__DataView_js__["a" /* default */](new ArrayBuffer(1))) != dataViewTag) ||
    (__WEBPACK_IMPORTED_MODULE_1__Map_js__["a" /* default */] && getTag(new __WEBPACK_IMPORTED_MODULE_1__Map_js__["a" /* default */]) != mapTag) ||
    (__WEBPACK_IMPORTED_MODULE_2__Promise_js__["a" /* default */] && getTag(__WEBPACK_IMPORTED_MODULE_2__Promise_js__["a" /* default */].resolve()) != promiseTag) ||
    (__WEBPACK_IMPORTED_MODULE_3__Set_js__["a" /* default */] && getTag(new __WEBPACK_IMPORTED_MODULE_3__Set_js__["a" /* default */]) != setTag) ||
    (__WEBPACK_IMPORTED_MODULE_4__WeakMap_js__["a" /* default */] && getTag(new __WEBPACK_IMPORTED_MODULE_4__WeakMap_js__["a" /* default */]) != weakMapTag)) {
  getTag = function(value) {
    var result = Object(__WEBPACK_IMPORTED_MODULE_5__baseGetTag_js__["a" /* default */])(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? Object(__WEBPACK_IMPORTED_MODULE_6__toSource_js__["a" /* default */])(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

/* harmony default export */ __webpack_exports__["a"] = (getTag);


/***/ }),
/* 557 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_isEqualWith__ = __webpack_require__(550);



var customizer = function customizer(objectValue, otherValue, indexOrkey, object, other, stack) {
  // https://lodash.com/docs/4.17.4#isEqualWith
  if (stack) {
    // Shallow compares
    // For 1st level, stack === undefined.
    //   -> Do nothing (and implicitly return undefined so that it goes to compare 2nd level)
    // For 2nd level and up, stack !== undefined.
    //   -> Compare by === operator
    return objectValue === otherValue;
  }
};

var shallowCompare = function shallowCompare(instance, nextProps, nextState) {
  var propsEqual = Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_isEqualWith__["a" /* default */])(instance.props, nextProps, customizer);
  var stateEqual = Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_isEqualWith__["a" /* default */])(instance.state, nextState, customizer);

  return !propsEqual || !stateEqual;
};

/* harmony default export */ __webpack_exports__["a"] = (shallowCompare);

/***/ }),
/* 558 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getNative_js__ = __webpack_require__(111);


var defineProperty = (function() {
  try {
    var func = Object(__WEBPACK_IMPORTED_MODULE_0__getNative_js__["a" /* default */])(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

/* harmony default export */ __webpack_exports__["a"] = (defineProperty);


/***/ }),
/* 559 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createBaseFor_js__ = __webpack_require__(1223);


/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = Object(__WEBPACK_IMPORTED_MODULE_0__createBaseFor_js__["a" /* default */])();

/* harmony default export */ __webpack_exports__["a"] = (baseFor);


/***/ }),
/* 560 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isObject_js__ = __webpack_require__(97);


/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !Object(__WEBPACK_IMPORTED_MODULE_0__isObject_js__["a" /* default */])(value);
}

/* harmony default export */ __webpack_exports__["a"] = (isStrictComparable);


/***/ }),
/* 561 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

/* harmony default export */ __webpack_exports__["a"] = (matchesStrictComparable);


/***/ }),
/* 562 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__castPath_js__ = __webpack_require__(563);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toKey_js__ = __webpack_require__(179);



/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = Object(__WEBPACK_IMPORTED_MODULE_0__castPath_js__["a" /* default */])(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[Object(__WEBPACK_IMPORTED_MODULE_1__toKey_js__["a" /* default */])(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = (baseGet);


/***/ }),
/* 563 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isArray_js__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isKey_js__ = __webpack_require__(356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__stringToPath_js__ = __webpack_require__(547);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__toString_js__ = __webpack_require__(549);





/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (Object(__WEBPACK_IMPORTED_MODULE_0__isArray_js__["a" /* default */])(value)) {
    return value;
  }
  return Object(__WEBPACK_IMPORTED_MODULE_1__isKey_js__["a" /* default */])(value, object) ? [value] : Object(__WEBPACK_IMPORTED_MODULE_2__stringToPath_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__toString_js__["a" /* default */])(value));
}

/* harmony default export */ __webpack_exports__["a"] = (castPath);


/***/ }),
/* 564 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var createIsPristine = function createIsPristine(_ref) {
  var deepEqual = _ref.deepEqual,
      empty = _ref.empty,
      getIn = _ref.getIn;
  return function (form, getFormState) {
    return function (state) {
      for (var _len = arguments.length, fields = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        fields[_key - 1] = arguments[_key];
      }

      var nonNullGetFormState = getFormState || function (state) {
        return getIn(state, 'form');
      };
      var formState = nonNullGetFormState(state);
      if (fields && fields.length) {
        return fields.every(function (field) {
          var fieldInitial = getIn(formState, form + '.initial.' + field);
          var fieldValue = getIn(formState, form + '.values.' + field);
          return deepEqual(fieldInitial, fieldValue);
        });
      }
      var initial = getIn(formState, form + '.initial') || empty;
      var values = getIn(formState, form + '.values') || initial;
      return deepEqual(initial, values);
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createIsPristine);

/***/ }),
/* 565 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseAssignValue_js__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__eq_js__ = __webpack_require__(178);



/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignMergeValue(object, key, value) {
  if ((value !== undefined && !Object(__WEBPACK_IMPORTED_MODULE_1__eq_js__["a" /* default */])(object[key], value)) ||
      (value === undefined && !(key in object))) {
    Object(__WEBPACK_IMPORTED_MODULE_0__baseAssignValue_js__["a" /* default */])(object, key, value);
  }
}

/* harmony default export */ __webpack_exports__["a"] = (assignMergeValue);


/***/ }),
/* 566 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__overArg_js__ = __webpack_require__(555);


/** Built-in value references. */
var getPrototype = Object(__WEBPACK_IMPORTED_MODULE_0__overArg_js__["a" /* default */])(Object.getPrototypeOf, Object);

/* harmony default export */ __webpack_exports__["a"] = (getPrototype);


/***/ }),
/* 567 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Gets the value at `key`, unless `key` is "__proto__".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function safeGet(object, key) {
  if (key == '__proto__') {
    return;
  }

  return object[key];
}

/* harmony default export */ __webpack_exports__["a"] = (safeGet);


/***/ }),
/* 568 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayLikeKeys_js__ = __webpack_require__(553);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseKeysIn_js__ = __webpack_require__(1291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isArrayLike_js__ = __webpack_require__(180);




/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return Object(__WEBPACK_IMPORTED_MODULE_2__isArrayLike_js__["a" /* default */])(object) ? Object(__WEBPACK_IMPORTED_MODULE_0__arrayLikeKeys_js__["a" /* default */])(object, true) : Object(__WEBPACK_IMPORTED_MODULE_1__baseKeysIn_js__["a" /* default */])(object);
}

/* harmony default export */ __webpack_exports__["a"] = (keysIn);


/***/ }),
/* 569 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isEvent__ = __webpack_require__(542);


var silenceEvent = function silenceEvent(event) {
  var is = Object(__WEBPACK_IMPORTED_MODULE_0__isEvent__["a" /* default */])(event);
  if (is) {
    event.preventDefault();
  }
  return is;
};

/* harmony default export */ __webpack_exports__["a"] = (silenceEvent);

/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.routerReducer = routerReducer;
/**
 * This action type will be dispatched when your history
 * receives a location change.
 */
var LOCATION_CHANGE = exports.LOCATION_CHANGE = '@@router/LOCATION_CHANGE';

var initialState = {
  locationBeforeTransitions: null
};

/**
 * This reducer will update the state with the most recent location history
 * has transitioned to. This may not be in sync with the router, particularly
 * if you have asynchronously-loaded routes, so reading from and relying on
 * this state is discouraged.
 */
function routerReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;

  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      type = _ref.type,
      payload = _ref.payload;

  if (type === LOCATION_CHANGE) {
    return _extends({}, state, { locationBeforeTransitions: payload });
  }

  return state;
}

/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * This action type will be dispatched by the history actions below.
 * If you're writing a middleware to watch for navigation events, be sure to
 * look for actions of this type.
 */
var CALL_HISTORY_METHOD = exports.CALL_HISTORY_METHOD = '@@router/CALL_HISTORY_METHOD';

function updateLocation(method) {
  return function () {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return {
      type: CALL_HISTORY_METHOD,
      payload: { method: method, args: args }
    };
  };
}

/**
 * These actions correspond to the history API.
 * The associated routerMiddleware will capture these events before they get to
 * your reducer and reissue them as the matching function on your history.
 */
var push = exports.push = updateLocation('push');
var replace = exports.replace = updateLocation('replace');
var go = exports.go = updateLocation('go');
var goBack = exports.goBack = updateLocation('goBack');
var goForward = exports.goForward = updateLocation('goForward');

var routerActions = exports.routerActions = { push: push, replace: replace, go: go, goBack: goBack, goForward: goForward };

/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 17c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm6-9h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6h1.9c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm0 12H6V10h12v10z"
})), 'LockOpen');

exports.default = _default;

/***/ }),
/* 573 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SetForgotPassword; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ResetForgotPassword; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_graphql_tag__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_graphql_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_graphql_tag__);
var _templateObject=_taggedTemplateLiteral(["\n  mutation forgotPassword($input: ForgotPasswordInput!) {\n    ForgotPassword(input: $input) {\n      clientMutationId\n    }\n  }\n"],["\n  mutation forgotPassword($input: ForgotPasswordInput!) {\n    ForgotPassword(input: $input) {\n      clientMutationId\n    }\n  }\n"]),_templateObject2=_taggedTemplateLiteral(["\n  mutation resetForgotPassword($input: ResetForgotPasswordInput!) {\n    ResetForgotPassword(input: $input) {\n      clientMutationId\n    }\n  }\n"],["\n  mutation resetForgotPassword($input: ResetForgotPasswordInput!) {\n    ResetForgotPassword(input: $input) {\n      clientMutationId\n    }\n  }\n"]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var SetForgotPassword=__WEBPACK_IMPORTED_MODULE_0_graphql_tag___default()(_templateObject);var ResetForgotPassword=__WEBPACK_IMPORTED_MODULE_0_graphql_tag___default()(_templateObject2);

/***/ }),
/* 574 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__ = __webpack_require__(65);
// ##############################
// // // Button styles
// #############################
var buttonStyle={button:{minHeight:"auto",minWidth:"auto",backgroundColor:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["n" /* grayColor */],color:"#FFFFFF",boxShadow:"0 2px 2px 0 rgba(153, 153, 153, 0.14), 0 3px 1px -2px rgba(153, 153, 153, 0.2), 0 1px 5px 0 rgba(153, 153, 153, 0.12)",border:"none",borderRadius:"3px",position:"relative",padding:"12px 30px",margin:".3125rem 1px",fontSize:"12px",fontWeight:"400",textTransform:"uppercase",letterSpacing:"0",willChange:"box-shadow, transform",transition:"box-shadow 0.2s cubic-bezier(0.4, 0, 1, 1), background-color 0.2s cubic-bezier(0.4, 0, 0.2, 1)",lineHeight:"1.42857143",textAlign:"center",whiteSpace:"nowrap",verticalAlign:"middle",touchAction:"manipulation",cursor:"pointer","&:hover,&:focus":{color:"#FFFFFF",backgroundColor:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["n" /* grayColor */],boxShadow:"0 14px 26px -12px rgba(153, 153, 153, 0.42), 0 4px 23px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(153, 153, 153, 0.2)"},"& .fab,& .fas,& .far,& .fal":{position:"relative",display:"inline-block",top:"0",marginTop:"-1em",marginBottom:"-1em",fontSize:"1.1rem",marginRight:"4px",verticalAlign:"middle"},"& svg":{position:"relative",display:"inline-block",top:"0",width:"18px",height:"18px",marginRight:"4px",verticalAlign:"middle"},"&$justIcon":{"& .fab,& .fas,& .far,& .fal":{marginTop:"0px",position:"absolute",width:"100%",transform:"none",left:"0px",top:"0px",height:"100%",lineHeight:"41px",fontSize:"20px"}}},fullWidth:{width:"100%"},primary:{backgroundColor:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["t" /* primaryColor */],boxShadow:"0 2px 2px 0 rgba(156, 39, 176, 0.14), 0 3px 1px -2px rgba(156, 39, 176, 0.2), 0 1px 5px 0 rgba(156, 39, 176, 0.12)","&:hover,&:focus":{backgroundColor:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["t" /* primaryColor */],boxShadow:"0 14px 26px -12px rgba(156, 39, 176, 0.42), 0 4px 23px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(156, 39, 176, 0.2)"}},info:{backgroundColor:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["q" /* infoColor */],boxShadow:"0 2px 2px 0 rgba(0, 188, 212, 0.14), 0 3px 1px -2px rgba(0, 188, 212, 0.2), 0 1px 5px 0 rgba(0, 188, 212, 0.12)","&:hover,&:focus":{backgroundColor:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["q" /* infoColor */],boxShadow:"0 14px 26px -12px rgba(0, 188, 212, 0.42), 0 4px 23px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(0, 188, 212, 0.2)"}},success:{backgroundColor:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["D" /* successColor */],boxShadow:"0 2px 2px 0 rgba(76, 175, 80, 0.14), 0 3px 1px -2px rgba(76, 175, 80, 0.2), 0 1px 5px 0 rgba(76, 175, 80, 0.12)","&:hover,&:focus":{backgroundColor:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["D" /* successColor */],boxShadow:"0 14px 26px -12px rgba(76, 175, 80, 0.42), 0 4px 23px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(76, 175, 80, 0.2)"}},warning:{backgroundColor:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["I" /* warningColor */],boxShadow:"0 2px 2px 0 rgba(255, 152, 0, 0.14), 0 3px 1px -2px rgba(255, 152, 0, 0.2), 0 1px 5px 0 rgba(255, 152, 0, 0.12)","&:hover,&:focus":{backgroundColor:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["I" /* warningColor */],boxShadow:"0 14px 26px -12px rgba(255, 152, 0, 0.42), 0 4px 23px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(255, 152, 0, 0.2)"}},danger:{backgroundColor:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["g" /* dangerColor */],boxShadow:"0 2px 2px 0 rgba(244, 67, 54, 0.14), 0 3px 1px -2px rgba(244, 67, 54, 0.2), 0 1px 5px 0 rgba(244, 67, 54, 0.12)","&:hover,&:focus":{backgroundColor:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["g" /* dangerColor */],boxShadow:"0 14px 26px -12px rgba(244, 67, 54, 0.42), 0 4px 23px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(244, 67, 54, 0.2)"}},rose:{backgroundColor:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["w" /* roseColor */],boxShadow:"0 2px 2px 0 rgba(233, 30, 99, 0.14), 0 3px 1px -2px rgba(233, 30, 99, 0.2), 0 1px 5px 0 rgba(233, 30, 99, 0.12)","&:hover,&:focus":{backgroundColor:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["w" /* roseColor */],boxShadow:"0 14px 26px -12px rgba(233, 30, 99, 0.42), 0 4px 23px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(233, 30, 99, 0.2)"}},white:{"&,&:focus,&:hover":{backgroundColor:"#FFFFFF",color:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["n" /* grayColor */]}},twitter:{backgroundColor:"#55acee",color:"#fff",boxShadow:"0 2px 2px 0 rgba(85, 172, 238, 0.14), 0 3px 1px -2px rgba(85, 172, 238, 0.2), 0 1px 5px 0 rgba(85, 172, 238, 0.12)","&:hover,&:focus,&:visited":{backgroundColor:"#55acee",color:"#fff",boxShadow:"0 14px 26px -12px rgba(85, 172, 238, 0.42), 0 4px 23px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(85, 172, 238, 0.2)"}},facebook:{backgroundColor:"#3b5998",color:"#fff",boxShadow:"0 2px 2px 0 rgba(59, 89, 152, 0.14), 0 3px 1px -2px rgba(59, 89, 152, 0.2), 0 1px 5px 0 rgba(59, 89, 152, 0.12)","&:hover,&:focus":{backgroundColor:"#3b5998",color:"#fff",boxShadow:"0 14px 26px -12px rgba(59, 89, 152, 0.42), 0 4px 23px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(59, 89, 152, 0.2)"}},google:{backgroundColor:"#dd4b39",color:"#fff",boxShadow:"0 2px 2px 0 rgba(221, 75, 57, 0.14), 0 3px 1px -2px rgba(221, 75, 57, 0.2), 0 1px 5px 0 rgba(221, 75, 57, 0.12)","&:hover,&:focus":{backgroundColor:"#dd4b39",color:"#fff",boxShadow:"0 14px 26px -12px rgba(221, 75, 57, 0.42), 0 4px 23px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(221, 75, 57, 0.2)"}},linkedin:{backgroundColor:"#0976b4",color:"#fff",boxShadow:"0 2px 2px 0 rgba(9, 118, 180, 0.14), 0 3px 1px -2px rgba(9, 118, 180, 0.2), 0 1px 5px 0 rgba(9, 118, 180, 0.12)","&:hover,&:focus":{backgroundColor:"#0976b4",color:"#fff",boxShadow:"0 14px 26px -12px rgba(9, 118, 180, 0.42), 0 4px 23px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(9, 118, 180, 0.2)"}},pinterest:{backgroundColor:"#cc2127",color:"#fff",boxShadow:"0 2px 2px 0 rgba(204, 33, 39, 0.14), 0 3px 1px -2px rgba(204, 33, 39, 0.2), 0 1px 5px 0 rgba(204, 33, 39, 0.12)","&:hover,&:focus":{backgroundColor:"#cc2127",color:"#fff",boxShadow:"0 14px 26px -12px rgba(204, 33, 39, 0.42), 0 4px 23px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(204, 33, 39, 0.2)"}},youtube:{backgroundColor:"#e52d27",color:"#fff",boxShadow:"0 2px 2px 0 rgba(229, 45, 39, 0.14), 0 3px 1px -2px rgba(229, 45, 39, 0.2), 0 1px 5px 0 rgba(229, 45, 39, 0.12)","&:hover,&:focus":{backgroundColor:"#e52d27",color:"#fff",boxShadow:"0 14px 26px -12px rgba(229, 45, 39, 0.42), 0 4px 23px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(229, 45, 39, 0.2)"}},tumblr:{backgroundColor:"#35465c",color:"#fff",boxShadow:"0 2px 2px 0 rgba(53, 70, 92, 0.14), 0 3px 1px -2px rgba(53, 70, 92, 0.2), 0 1px 5px 0 rgba(53, 70, 92, 0.12)","&:hover,&:focus":{backgroundColor:"#35465c",color:"#fff",boxShadow:"0 14px 26px -12px rgba(53, 70, 92, 0.42), 0 4px 23px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(53, 70, 92, 0.2)"}},github:{backgroundColor:"#333333",color:"#fff",boxShadow:"0 2px 2px 0 rgba(51, 51, 51, 0.14), 0 3px 1px -2px rgba(51, 51, 51, 0.2), 0 1px 5px 0 rgba(51, 51, 51, 0.12)","&:hover,&:focus":{backgroundColor:"#333333",color:"#fff",boxShadow:"0 14px 26px -12px rgba(51, 51, 51, 0.42), 0 4px 23px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(51, 51, 51, 0.2)"}},behance:{backgroundColor:"#1769ff",color:"#fff",boxShadow:"0 2px 2px 0 rgba(23, 105, 255, 0.14), 0 3px 1px -2px rgba(23, 105, 255, 0.2), 0 1px 5px 0 rgba(23, 105, 255, 0.12)","&:hover,&:focus":{backgroundColor:"#1769ff",color:"#fff",boxShadow:"0 14px 26px -12px rgba(23, 105, 255, 0.42), 0 4px 23px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(23, 105, 255, 0.2)"}},dribbble:{backgroundColor:"#ea4c89",color:"#fff",boxShadow:"0 2px 2px 0 rgba(234, 76, 137, 0.14), 0 3px 1px -2px rgba(234, 76, 137, 0.2), 0 1px 5px 0 rgba(234, 76, 137, 0.12)","&:hover,&:focus":{backgroundColor:"#ea4c89",color:"#fff",boxShadow:"0 14px 26px -12px rgba(234, 76, 137, 0.42), 0 4px 23px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(234, 76, 137, 0.2)"}},reddit:{backgroundColor:"#ff4500",color:" #fff",boxShadow:"0 2px 2px 0 rgba(255, 69, 0, 0.14), 0 3px 1px -2px rgba(255, 69, 0, 0.2), 0 1px 5px 0 rgba(255, 69, 0, 0.12)","&:hover,&:focus":{backgroundColor:"#ff4500",color:" #fff",boxShadow:"0 14px 26px -12px rgba(255, 69, 0, 0.42), 0 4px 23px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(255, 69, 0, 0.2)"}},simple:{"&,&:focus,&:hover":{color:"#FFFFFF",background:"transparent",boxShadow:"none"},"&$primary":{"&,&:focus,&:hover,&:visited":{color:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["t" /* primaryColor */]}},"&$info":{"&,&:focus,&:hover,&:visited":{color:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["q" /* infoColor */]}},"&$success":{"&,&:focus,&:hover,&:visited":{color:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["D" /* successColor */]}},"&$warning":{"&,&:focus,&:hover,&:visited":{color:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["I" /* warningColor */]}},"&$rose":{"&,&:focus,&:hover,&:visited":{color:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["w" /* roseColor */]}},"&$danger":{"&,&:focus,&:hover,&:visited":{color:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["g" /* dangerColor */]}},"&$twitter":{"&,&:focus,&:hover,&:visited":{color:"#55acee"}},"&$facebook":{"&,&:focus,&:hover,&:visited":{color:"#3b5998"}},"&$google":{"&,&:focus,&:hover,&:visited":{color:"#dd4b39"}},"&$linkedin":{"&,&:focus,&:hover,&:visited":{color:"#0976b4"}},"&$pinterest":{"&,&:focus,&:hover,&:visited":{color:"#cc2127"}},"&$youtube":{"&,&:focus,&:hover,&:visited":{color:"#e52d27"}},"&$tumblr":{"&,&:focus,&:hover,&:visited":{color:"#35465c"}},"&$github":{"&,&:focus,&:hover,&:visited":{color:"#333333"}},"&$behance":{"&,&:focus,&:hover,&:visited":{color:"#1769ff"}},"&$dribbble":{"&,&:focus,&:hover,&:visited":{color:"#ea4c89"}},"&$reddit":{"&,&:focus,&:hover,&:visited":{color:"#ff4500"}}},transparent:{"&,&:focus,&:hover":{color:"inherit",background:"transparent",boxShadow:"none"}},disabled:{opacity:"0.65",pointerEvents:"none"},lg:{padding:"1.125rem 2.25rem",fontSize:"0.875rem",lineHeight:"1.333333",borderRadius:"0.2rem"},sm:{padding:"0.40625rem 1.25rem",fontSize:"0.6875rem",lineHeight:"1.5",borderRadius:"0.2rem"},round:{borderRadius:"30px"},block:{width:"100% !important"},link:{"&,&:hover,&:focus":{backgroundColor:"transparent",color:"#999999",boxShadow:"none"}},justIcon:{paddingLeft:"12px",paddingRight:"12px",fontSize:"20px",height:"41px",minWidth:"41px",width:"41px","& .fab,& .fas,& .far,& .fal,& svg":{marginRight:"0px"},"&$lg":{height:"57px",minWidth:"57px",width:"57px",lineHeight:"56px","& .fab,& .fas,& .far,& .fal":{fontSize:"32px",lineHeight:"56px"},"& svg":{width:"32px",height:"32px"}},"&$sm":{height:"30px",minWidth:"30px",width:"30px","& .fab,& .fas,& .far,& .fal":{fontSize:"17px",lineHeight:"29px"},"& svg":{width:"17px",height:"17px"}}}};/* harmony default export */ __webpack_exports__["a"] = (buttonStyle);

/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M11.8 10.9c-2.27-.59-3-1.2-3-2.15 0-1.09 1.01-1.85 2.7-1.85 1.78 0 2.44.85 2.5 2.1h2.21c-.07-1.72-1.12-3.3-3.21-3.81V3h-3v2.16c-1.94.42-3.5 1.68-3.5 3.61 0 2.31 1.91 3.46 4.7 4.13 2.5.6 3 1.48 3 2.41 0 .69-.49 1.79-2.7 1.79-2.06 0-2.87-.92-2.98-2.1h-2.2c.12 2.19 1.76 3.42 3.68 3.83V21h3v-2.15c1.95-.37 3.5-1.5 3.5-3.55 0-2.84-2.43-3.81-4.7-4.4z"
})), 'AttachMoney');

exports.default = _default;

/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z"
})), 'ExpandMore');

exports.default = _default;

/***/ }),
/* 577 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z"
})), 'Menu');

exports.default = _default;

/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 5.9c1.16 0 2.1.94 2.1 2.1s-.94 2.1-2.1 2.1S9.9 9.16 9.9 8s.94-2.1 2.1-2.1m0 9c2.97 0 6.1 1.46 6.1 2.1v1.1H5.9V17c0-.64 3.13-2.1 6.1-2.1M12 4C9.79 4 8 5.79 8 8s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 9c-2.67 0-8 1.34-8 4v3h16v-3c0-2.66-5.33-4-8-4z"
})), 'PermIdentity');

exports.default = _default;

/***/ }),
/* 579 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_core__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_CircularProgress__ = __webpack_require__(484);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_CircularProgress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_CircularProgress__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_icons__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_assets_img_fmi_small_png__ = __webpack_require__(2290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_assets_img_fmi_small_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_assets_img_fmi_small_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_assets_img_hollard_png__ = __webpack_require__(2291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_assets_img_hollard_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_assets_img_hollard_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_assets_img_liberty_small_jpg__ = __webpack_require__(2292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_assets_img_liberty_small_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_assets_img_liberty_small_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_assets_img_momentum_small_jpg__ = __webpack_require__(2293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_assets_img_momentum_small_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_assets_img_momentum_small_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_assets_img_sanlam_small_png__ = __webpack_require__(2294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_assets_img_sanlam_small_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_assets_img_sanlam_small_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_assets_img_pps_png__ = __webpack_require__(2295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_assets_img_pps_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_assets_img_pps_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_assets_img_oldmutual_png__ = __webpack_require__(2296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_assets_img_oldmutual_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_assets_img_oldmutual_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_helpers_UserHelper__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_queries_Target__ = __webpack_require__(2297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_apollo__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_redux__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react_router_dom__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_reducers_TasksReducer__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_store__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__task_TaskManager__ = __webpack_require__(2298);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var logoMap={fmi:__WEBPACK_IMPORTED_MODULE_3_assets_img_fmi_small_png___default.a,bidvest:__WEBPACK_IMPORTED_MODULE_3_assets_img_fmi_small_png___default.a,liberty:__WEBPACK_IMPORTED_MODULE_5_assets_img_liberty_small_jpg___default.a,momentum:__WEBPACK_IMPORTED_MODULE_6_assets_img_momentum_small_jpg___default.a,sanlam:__WEBPACK_IMPORTED_MODULE_7_assets_img_sanlam_small_png___default.a,hollard:__WEBPACK_IMPORTED_MODULE_4_assets_img_hollard_png___default.a,pps:__WEBPACK_IMPORTED_MODULE_8_assets_img_pps_png___default.a,"old mutual":__WEBPACK_IMPORTED_MODULE_9_assets_img_oldmutual_png___default.a};var theme=Object(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["_0" /* createMuiTheme */])({palette:{primary:{main:'#bb00ff'},secondary:{main:'#4caf50'}}});var CustomHeadingLabel=function CustomHeadingLabel(props){return __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div',{style:{position:'absolute',top:'-8px',left:'10px',backgroundColor:'#e0e0e0',borderRadius:'10px',padding:'1px 18px'}},__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{variant:'subheading'},__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('strong',null,props.label)));};var styles={root:{width:'400px'},linearProgress:{width:'100%',backgroundColor:'#dadada'},listItem:{width:'350px'},Description:{color:'grey'},logo:{width:'32px',height:'auto'}};var TaskList=function(_React$Component){_inherits(TaskList,_React$Component);function TaskList(){var _ref;var _temp,_this,_ret;_classCallCheck(this,TaskList);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=TaskList.__proto__||Object.getPrototypeOf(TaskList)).call.apply(_ref,[this].concat(args))),_this),_this.state={errorDialogOpen:false,errorText:null,errorTarget:null,errorDesc:null},_this.closeErrorDialog=function(){_this.setState({errorDialogOpen:false});},_this.openErrorDialog=function(errorText,targetName,desc){_this.setState({errorDialogOpen:true,errorText:errorText,errorTarget:targetName,errorDesc:desc});},_this.pendingTasks=function(){var pendingTasks=_this.props.pendingTasks;return __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div',{style:{backgroundColor:'#fff',position:'relative',minHeight:95,padding:'18px 0px 15px 0px'}},__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(CustomHeadingLabel,{label:'Pending Quotes'}),__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div',{style:{marginBottom:25}}),pendingTasks.map(function(task){return __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div',{style:{textAlign:'center'}},__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div',{style:{display:'flex',justifyContent:'space-between',margin:'15px',borderBottom:'1px solid #cecece'}},__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('h4',null,__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('b',null,task.description)),__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_CircularProgress___default.a,{style:{width:'20px',height:'20px',top:'10px',right:'15px',position:'relative'}})));}));},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(TaskList,[{key:'navigateResults',value:function navigateResults(guid){this.props.history.push({pathname:'/app/quoteresult',search:'guid='+guid});}},{key:'makeButton',value:function makeButton(currentTask){var _this2=this;return currentTask.jobs.filter(function(x){return x.progress===100;}).length>0?__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["d" /* Button */],{variant:'outlined',className:'outlinedButton',style:{color:'#6c5cab',marginLeft:'15px',marginBottom:'5px'},onClick:function onClick(){return _this2.navigateResults(currentTask.guid);}},'View'):null;}},{key:'runningTasks',value:function runningTasks(){var _this3=this;var _props=this.props,classes=_props.classes,currentTasks=_props.currentTasks;return __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div',{style:{backgroundColor:'#fff',position:'relative',minHeight:95,padding:'18px 10px 15px'}},__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(CustomHeadingLabel,{label:'Quotes In Progress'}),currentTasks.map(function(task){var taskJobs=[].concat(_toConsumableArray(task.jobs));taskJobs.sort(function(a,b){var textA=a.targetName.toUpperCase();var textB=b.targetName.toUpperCase();return textA<textB?-1:textA>textB?1:0;});task.jobs=taskJobs;var taskDesc=task.meta?task.meta.desc:task.jobs[0].client;return __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["e" /* Card */],{style:{marginTop:'18px',border:'1px solid #cecece',borderRadius:'10px'}},__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["f" /* CardContent */],{style:{textAlign:'center',padding:0}},__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{container:true},__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{item:true,xs:11,sm:11,md:11,style:{backgroundColor:'#cecece4f'}},__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('h4',{style:{margin:'0'}},__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('b',{style:{paddingLeft:15}},taskDesc))),__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Y" /* Tooltip */],{title:'Close Quote'},__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{item:true,xs:1,sm:1,md:1,style:{borderBottom:'1px solid #cecece4f',cursor:'pointer'},onClick:function onClick(e){global.messager.publish('/clearTask',{guid:task.guid,uid:Object(__WEBPACK_IMPORTED_MODULE_10_helpers_UserHelper__["a" /* GetUserId */])()});__WEBPACK_IMPORTED_MODULE_17_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_16_reducers_TasksReducer__["g" /* removeTask */])({guid:task.guid}));}},__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_icons__["f" /* Close */],{style:{fontSize:'1.34em'}})))),task.jobs.map(function(job){var logoSrc=logoMap[job.targetName.toLowerCase()];return job.error===0?__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["C" /* List */],null,__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["D" /* ListItem */],null,__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('img',{src:logoSrc,alt:job.targetName,className:classes.logo}),__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["E" /* ListItemText */],{primary:job.targetName,className:classes.listItem})),__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["D" /* ListItem */],null,__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["B" /* LinearProgress */],{className:classes.linearProgress,color:job.progress===100?'secondary':'primary',variant:'determinate',value:job.progress}))):__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["C" /* List */],null,__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["D" /* ListItem */],null,__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('img',{src:logoSrc,alt:job.targetName,className:classes.logo}),__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["E" /* ListItemText */],{primary:job.targetName,className:classes.listItem})),__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["D" /* ListItem */],{style:{padding:'0px 27px',position:'relative',top:'-5px'}},job.error.includes('TextError:')?__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{className:'typographyLink',onClick:function onClick(e){_this3.openErrorDialog(job.error.replace('TextError:',''),job.targetName,taskDesc);},style:{cursor:'pointer'}},'Error: Click to view'):__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('a',{href:job.error,target:'_blank'},'Error: Click to view'))));}),_this3.makeButton(task)));}));}},{key:'render',value:function render(){var _this4=this;if(!global.taskmanager&&Object(__WEBPACK_IMPORTED_MODULE_10_helpers_UserHelper__["c" /* GetUserToken */])()!==''){global.taskmanager=new __WEBPACK_IMPORTED_MODULE_18__task_TaskManager__["a" /* default */]();global.taskmanager.start();if(!this.props.initialFetchDone)global.taskmanager.initialFetch();}this.taskmanager=global.taskmanager;var _props2=this.props,classes=_props2.classes,currentTasks=_props2.currentTasks,pendingTasks=_props2.pendingTasks;var noTasksExist=currentTasks.length===0&&pendingTasks.length===0;return __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["H" /* MuiThemeProvider */],{theme:theme},__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["J" /* Popover */],{open:this.props.tasksOpen,onClose:function onClose(){return __WEBPACK_IMPORTED_MODULE_17_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_16_reducers_TasksReducer__["b" /* closeProgress */])());},anchorReference:'anchorEl',anchorOrigin:{vertical:'top',horizontal:'right'},transformOrigin:{vertical:'top',horizontal:'center'}},__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["I" /* Paper */],{className:classes.root,style:{padding:noTasksExist?'15px 15px 15px':'30px 0px 15px'}},noTasksExist?__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],null,'No in-progress or pending quotes yet.'):__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react___default.a.Fragment,null,currentTasks.length>0?this.runningTasks():null,__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div',{style:{marginBottom:20}}),pendingTasks.length>0?this.pendingTasks():null))),__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["k" /* Dialog */],{open:this.state.errorDialogOpen,onClose:function onClose(){return _this4.closeErrorDialog();},'aria-labelledby':'form-dialog-title',className:'centerFixedDialog'},__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["o" /* DialogTitle */],{id:'form-dialog-title',style:{textAlign:'center'}},this.state.errorTarget+' Quote Error - '+this.state.errorDesc),__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["m" /* DialogContent */],null,__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],null,this.state.errorText)),__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["l" /* DialogActions */],null,__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["d" /* Button */],{onClick:function onClick(){return _this4.closeErrorDialog();},color:'primary'},'Close'))));}}]);return TaskList;}(__WEBPACK_IMPORTED_MODULE_12_react___default.a.Component);TaskList=Object(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["_1" /* withStyles */])(styles)(TaskList);TaskList=Object(__WEBPACK_IMPORTED_MODULE_15_react_router_dom__["f" /* withRouter */])(TaskList);TaskList=Object(__WEBPACK_IMPORTED_MODULE_13_react_apollo__["graphql"])(__WEBPACK_IMPORTED_MODULE_11_queries_Target__["a" /* getTargets */])(TaskList);function mapStateToProps(state){return{tasksOpen:state.tasks.progressOpen,currentTasks:state.tasks.currentTasks,pendingTasks:state.tasks.pendingTasks,initialFetchDone:state.tasks.initialFetchDone};}TaskList=Object(__WEBPACK_IMPORTED_MODULE_14_react_redux__["b" /* connect */])(mapStateToProps)(TaskList);/* harmony default export */ __webpack_exports__["a"] = (TaskList);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(26)))

/***/ }),
/* 580 */
/***/ (function(module, exports) {

module.exports = {
  VERSION:          '1.2.4',

  BAYEUX_VERSION:   '1.0',
  ID_LENGTH:        160,
  JSONP_CALLBACK:   'jsonpcallback',
  CONNECTION_TYPES: ['long-polling', 'cross-origin-long-polling', 'callback-polling', 'websocket', 'eventsource', 'in-process'],

  MANDATORY_CONNECTION_TYPES: ['long-polling', 'callback-polling', 'in-process']
};


/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// rawAsap provides everything we need except exception management.
var rawAsap = __webpack_require__(435);
// RawTasks are recycled to reduce GC churn.
var freeTasks = [];
// We queue errors to ensure they are thrown in right order (FIFO).
// Array-as-queue is good enough here, since we are just dealing with exceptions.
var pendingErrors = [];
var requestErrorThrow = rawAsap.makeRequestCallFromTimer(throwFirstError);

function throwFirstError() {
    if (pendingErrors.length) {
        throw pendingErrors.shift();
    }
}

/**
 * Calls a task as soon as possible after returning, in its own event, with priority
 * over other events like animation, reflow, and repaint. An error thrown from an
 * event will not interrupt, nor even substantially slow down the processing of
 * other events, but will be rather postponed to a lower priority event.
 * @param {{call}} task A callable object, typically a function that takes no
 * arguments.
 */
module.exports = asap;
function asap(task) {
    var rawTask;
    if (freeTasks.length) {
        rawTask = freeTasks.pop();
    } else {
        rawTask = new RawTask();
    }
    rawTask.task = task;
    rawAsap(rawTask);
}

// We wrap tasks with recyclable task objects.  A task object implements
// `call`, just like a function.
function RawTask() {
    this.task = null;
}

// The sole purpose of wrapping the task is to catch the exception and recycle
// the task object after its single use.
RawTask.prototype.call = function () {
    try {
        this.task.call();
    } catch (error) {
        if (asap.onerror) {
            // This hook exists purely for testing purposes.
            // Its name will be periodically randomized to break any code that
            // depends on its existence.
            asap.onerror(error);
        } else {
            // In a web browser, exceptions are not fatal. However, to avoid
            // slowing down the queue of pending tasks, we rethrow the error in a
            // lower priority turn.
            pendingErrors.push(error);
            requestErrorThrow();
        }
    } finally {
        this.task = null;
        freeTasks[freeTasks.length] = this;
    }
};


/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Class     = __webpack_require__(53),
    extend    = __webpack_require__(51),
    Publisher = __webpack_require__(366),
    Grammar   = __webpack_require__(583);

var Channel = Class({
  initialize: function(name) {
    this.id = this.name = name;
  },

  push: function(message) {
    this.trigger('message', message);
  },

  isUnused: function() {
    return this.countListeners('message') === 0;
  }
});

extend(Channel.prototype, Publisher);

extend(Channel, {
  HANDSHAKE:    '/meta/handshake',
  CONNECT:      '/meta/connect',
  SUBSCRIBE:    '/meta/subscribe',
  UNSUBSCRIBE:  '/meta/unsubscribe',
  DISCONNECT:   '/meta/disconnect',

  META:         'meta',
  SERVICE:      'service',

  expand: function(name) {
    var segments = this.parse(name),
        channels = ['/**', name];

    var copy = segments.slice();
    copy[copy.length - 1] = '*';
    channels.push(this.unparse(copy));

    for (var i = 1, n = segments.length; i < n; i++) {
      copy = segments.slice(0, i);
      copy.push('**');
      channels.push(this.unparse(copy));
    }

    return channels;
  },

  isValid: function(name) {
    return Grammar.CHANNEL_NAME.test(name) ||
           Grammar.CHANNEL_PATTERN.test(name);
  },

  parse: function(name) {
    if (!this.isValid(name)) return null;
    return name.split('/').slice(1);
  },

  unparse: function(segments) {
    return '/' + segments.join('/');
  },

  isMeta: function(name) {
    var segments = this.parse(name);
    return segments ? (segments[0] === this.META) : null;
  },

  isService: function(name) {
    var segments = this.parse(name);
    return segments ? (segments[0] === this.SERVICE) : null;
  },

  isSubscribable: function(name) {
    if (!this.isValid(name)) return null;
    return !this.isMeta(name) && !this.isService(name);
  },

  Set: Class({
    initialize: function() {
      this._channels = {};
    },

    getKeys: function() {
      var keys = [];
      for (var key in this._channels) keys.push(key);
      return keys;
    },

    remove: function(name) {
      delete this._channels[name];
    },

    hasSubscription: function(name) {
      return this._channels.hasOwnProperty(name);
    },

    subscribe: function(names, subscription) {
      var name;
      for (var i = 0, n = names.length; i < n; i++) {
        name = names[i];
        var channel = this._channels[name] = this._channels[name] || new Channel(name);
        channel.bind('message', subscription);
      }
    },

    unsubscribe: function(name, subscription) {
      var channel = this._channels[name];
      if (!channel) return false;
      channel.unbind('message', subscription);

      if (channel.isUnused()) {
        this.remove(name);
        return true;
      } else {
        return false;
      }
    },

    distributeMessage: function(message) {
      var channels = Channel.expand(message.channel);

      for (var i = 0, n = channels.length; i < n; i++) {
        var channel = this._channels[channels[i]];
        if (channel) channel.trigger('message', message);
      }
    }
  })
});

module.exports = Channel;


/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
  CHANNEL_NAME:     /^\/(((([a-z]|[A-Z])|[0-9])|(\-|\_|\!|\~|\(|\)|\$|\@)))+(\/(((([a-z]|[A-Z])|[0-9])|(\-|\_|\!|\~|\(|\)|\$|\@)))+)*$/,
  CHANNEL_PATTERN:  /^(\/(((([a-z]|[A-Z])|[0-9])|(\-|\_|\!|\~|\(|\)|\$|\@)))+)*\/\*{1,2}$/,
  ERROR:            /^([0-9][0-9][0-9]:(((([a-z]|[A-Z])|[0-9])|(\-|\_|\!|\~|\(|\)|\$|\@)| |\/|\*|\.))*(,(((([a-z]|[A-Z])|[0-9])|(\-|\_|\!|\~|\(|\)|\$|\@)| |\/|\*|\.))*)*:(((([a-z]|[A-Z])|[0-9])|(\-|\_|\!|\~|\(|\)|\$|\@)| |\/|\*|\.))*|[0-9][0-9][0-9]::(((([a-z]|[A-Z])|[0-9])|(\-|\_|\!|\~|\(|\)|\$|\@)| |\/|\*|\.))*)$/,
  VERSION:          /^([0-9])+(\.(([a-z]|[A-Z])|[0-9])(((([a-z]|[A-Z])|[0-9])|\-|\_))*)*$/
};


/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {};


/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Class = __webpack_require__(53);

module.exports = Class({
  initialize: function() {
    this._index = {};
  },

  add: function(item) {
    var key = (item.id !== undefined) ? item.id : item;
    if (this._index.hasOwnProperty(key)) return false;
    this._index[key] = item;
    return true;
  },

  forEach: function(block, context) {
    for (var key in this._index) {
      if (this._index.hasOwnProperty(key))
        block.call(context, this._index[key]);
    }
  },

  isEmpty: function() {
    for (var key in this._index) {
      if (this._index.hasOwnProperty(key)) return false;
    }
    return true;
  },

  member: function(item) {
    for (var key in this._index) {
      if (this._index[key] === item) return true;
    }
    return false;
  },

  remove: function(item) {
    var key = (item.id !== undefined) ? item.id : item;
    var removed = this._index[key];
    delete this._index[key];
    return removed;
  },

  toArray: function() {
    var array = [];
    this.forEach(function(item) { array.push(item) });
    return array;
  }
});


/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var Class     = __webpack_require__(53),
    URI       = __webpack_require__(98),
    browser   = __webpack_require__(365),
    extend    = __webpack_require__(51),
    toJSON    = __webpack_require__(182),
    Transport = __webpack_require__(145);

var XHR = extend(Class(Transport, {
  encode: function(messages) {
    return toJSON(messages);
  },

  request: function(messages) {
    var href = this.endpoint.href,
        self = this,
        xhr;

    // Prefer XMLHttpRequest over ActiveXObject if they both exist
    if (global.XMLHttpRequest) {
      xhr = new XMLHttpRequest();
    } else if (global.ActiveXObject) {
      xhr = new ActiveXObject('Microsoft.XMLHTTP');
    } else {
      return this._handleError(messages);
    }

    xhr.open('POST', href, true);
    xhr.setRequestHeader('Content-Type', 'application/json');
    xhr.setRequestHeader('Pragma', 'no-cache');
    xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');

    var headers = this._dispatcher.headers;
    for (var key in headers) {
      if (!headers.hasOwnProperty(key)) continue;
      xhr.setRequestHeader(key, headers[key]);
    }

    var abort = function() { xhr.abort() };
    if (global.onbeforeunload !== undefined)
      browser.Event.on(global, 'beforeunload', abort);

    xhr.onreadystatechange = function() {
      if (!xhr || xhr.readyState !== 4) return;

      var replies    = null,
          status     = xhr.status,
          text       = xhr.responseText,
          successful = (status >= 200 && status < 300) || status === 304 || status === 1223;

      if (global.onbeforeunload !== undefined)
        browser.Event.detach(global, 'beforeunload', abort);

      xhr.onreadystatechange = function() {};
      xhr = null;

      if (!successful) return self._handleError(messages);

      try {
        replies = JSON.parse(text);
      } catch (error) {}

      if (replies)
        self._receive(replies);
      else
        self._handleError(messages);
    };

    xhr.send(this.encode(messages));
    return xhr;
  }
}), {
  isUsable: function(dispatcher, endpoint, callback, context) {
    var usable = (navigator.product === 'ReactNative')
              || URI.isSameOrigin(endpoint);

    callback.call(context, usable);
  }
});

module.exports = XHR;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(26)))

/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var extend = __webpack_require__(51);

var Scheduler = function(message, options) {
  this.message  = message;
  this.options  = options;
  this.attempts = 0;
};

extend(Scheduler.prototype, {
  getTimeout: function() {
    return this.options.timeout;
  },

  getInterval: function() {
    return this.options.interval;
  },

  isDeliverable: function() {
    var attempts = this.options.attempts,
        made     = this.attempts,
        deadline = this.options.deadline,
        now      = new Date().getTime();

    if (attempts !== undefined && made >= attempts)
      return false;

    if (deadline !== undefined && now > deadline)
      return false;

    return true;
  },

  send: function() {
    this.attempts += 1;
  },

  succeed: function() {},

  fail: function() {},

  abort: function() {}
});

module.exports = Scheduler;


/***/ }),
/* 588 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_assets_jss_material_dashboard_pro_react_components_footerStyle__ = __webpack_require__(2320);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}// @material-ui/core components
function Footer(_ref){var _cx;var props=_objectWithoutProperties(_ref,[]);var classes=props.classes,fluid=props.fluid,white=props.white;var container=__WEBPACK_IMPORTED_MODULE_2_classnames___default()((_cx={},_defineProperty(_cx,classes.container,!fluid),_defineProperty(_cx,classes.containerFluid,fluid),_defineProperty(_cx,classes.whiteColor,white),_cx));return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("footer",{className:classes.footer,style:{borderTop:"0px"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:container},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:classes.left}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:classes.right})));}Footer.propTypes={classes:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,fluid:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,white:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,rtlActive:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool};/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles___default()(__WEBPACK_IMPORTED_MODULE_4_assets_jss_material_dashboard_pro_react_components_footerStyle__["a" /* default */])(Footer));

/***/ }),
/* 589 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HeuristicFragmentMatcher; });
/* unused harmony export IntrospectionFragmentMatcher */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_apollo_utilities__ = __webpack_require__(59);

var haveWarned = false;
var HeuristicFragmentMatcher = (function () {
    function HeuristicFragmentMatcher() {
    }
    HeuristicFragmentMatcher.prototype.ensureReady = function () {
        return Promise.resolve();
    };
    HeuristicFragmentMatcher.prototype.canBypassInit = function () {
        return true;
    };
    HeuristicFragmentMatcher.prototype.match = function (idValue, typeCondition, context) {
        var obj = context.store.get(idValue.id);
        if (!obj && idValue.id === 'ROOT_QUERY') {
            return true;
        }
        if (!obj) {
            return false;
        }
        if (!obj.__typename) {
            if (!haveWarned) {
                console.warn("You're using fragments in your queries, but either don't have the addTypename:\n  true option set in Apollo Client, or you are trying to write a fragment to the store without the __typename.\n   Please turn on the addTypename option and include __typename when writing fragments so that Apollo Client\n   can accurately match fragments.");
                console.warn('Could not find __typename on Fragment ', typeCondition, obj);
                console.warn("DEPRECATION WARNING: using fragments without __typename is unsupported behavior " +
                    "and will be removed in future versions of Apollo client. You should fix this and set addTypename to true now.");
                if (!Object(__WEBPACK_IMPORTED_MODULE_0_apollo_utilities__["x" /* isTest */])()) {
                    haveWarned = true;
                }
            }
            return 'heuristic';
        }
        if (obj.__typename === typeCondition) {
            return true;
        }
        Object(__WEBPACK_IMPORTED_MODULE_0_apollo_utilities__["E" /* warnOnceInDevelopment */])('You are using the simple (heuristic) fragment matcher, but your ' +
            'queries contain union or interface types. Apollo Client will not be ' +
            'able to accurately map fragments. To make this error go away, use ' +
            'the `IntrospectionFragmentMatcher` as described in the docs: ' +
            'https://www.apollographql.com/docs/react/recipes/fragment-matching.html', 'error');
        return 'heuristic';
    };
    return HeuristicFragmentMatcher;
}());

var IntrospectionFragmentMatcher = (function () {
    function IntrospectionFragmentMatcher(options) {
        if (options && options.introspectionQueryResultData) {
            this.possibleTypesMap = this.parseIntrospectionResult(options.introspectionQueryResultData);
            this.isReady = true;
        }
        else {
            this.isReady = false;
        }
        this.match = this.match.bind(this);
    }
    IntrospectionFragmentMatcher.prototype.match = function (idValue, typeCondition, context) {
        if (!this.isReady) {
            throw new Error('FragmentMatcher.match() was called before FragmentMatcher.init()');
        }
        var obj = context.store.get(idValue.id);
        if (!obj) {
            return false;
        }
        if (!obj.__typename) {
            throw new Error("Cannot match fragment because __typename property is missing: " + JSON.stringify(obj));
        }
        if (obj.__typename === typeCondition) {
            return true;
        }
        var implementingTypes = this.possibleTypesMap[typeCondition];
        if (implementingTypes && implementingTypes.indexOf(obj.__typename) > -1) {
            return true;
        }
        return false;
    };
    IntrospectionFragmentMatcher.prototype.parseIntrospectionResult = function (introspectionResultData) {
        var typeMap = {};
        introspectionResultData.__schema.types.forEach(function (type) {
            if (type.kind === 'UNION' || type.kind === 'INTERFACE') {
                typeMap[type.name] = type.possibleTypes.map(function (implementingType) { return implementingType.name; });
            }
        });
        return typeMap;
    };
    return IntrospectionFragmentMatcher;
}());

//# sourceMappingURL=fragmentMatcher.js.map

/***/ }),
/* 590 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StoreReader; });
/* unused harmony export assertIdValue */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_apollo_utilities__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__optimism__ = __webpack_require__(368);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__depTrackingCache__ = __webpack_require__(369);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__queryKeyMaker__ = __webpack_require__(2354);
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};




var StoreReader = (function () {
    function StoreReader(cacheKeyRoot) {
        if (cacheKeyRoot === void 0) { cacheKeyRoot = new __WEBPACK_IMPORTED_MODULE_1__optimism__["a" /* CacheKeyNode */]; }
        var _this = this;
        this.cacheKeyRoot = cacheKeyRoot;
        var reader = this;
        var executeStoreQuery = reader.executeStoreQuery, executeSelectionSet = reader.executeSelectionSet;
        reader.keyMaker = new __WEBPACK_IMPORTED_MODULE_3__queryKeyMaker__["a" /* QueryKeyMaker */](cacheKeyRoot);
        this.executeStoreQuery = Object(__WEBPACK_IMPORTED_MODULE_1__optimism__["b" /* wrap */])(function (options) {
            return executeStoreQuery.call(_this, options);
        }, {
            makeCacheKey: function (_a) {
                var query = _a.query, rootValue = _a.rootValue, contextValue = _a.contextValue, variableValues = _a.variableValues, fragmentMatcher = _a.fragmentMatcher;
                if (contextValue.store instanceof __WEBPACK_IMPORTED_MODULE_2__depTrackingCache__["a" /* DepTrackingCache */]) {
                    return reader.cacheKeyRoot.lookup(reader.keyMaker.forQuery(query).lookupQuery(query), contextValue.store, fragmentMatcher, JSON.stringify(variableValues), rootValue.id);
                }
                return;
            }
        });
        this.executeSelectionSet = Object(__WEBPACK_IMPORTED_MODULE_1__optimism__["b" /* wrap */])(function (options) {
            return executeSelectionSet.call(_this, options);
        }, {
            makeCacheKey: function (_a) {
                var selectionSet = _a.selectionSet, rootValue = _a.rootValue, execContext = _a.execContext;
                if (execContext.contextValue.store instanceof __WEBPACK_IMPORTED_MODULE_2__depTrackingCache__["a" /* DepTrackingCache */]) {
                    return reader.cacheKeyRoot.lookup(reader.keyMaker.forQuery(execContext.query).lookupSelectionSet(selectionSet), execContext.contextValue.store, execContext.fragmentMatcher, JSON.stringify(execContext.variableValues), rootValue.id);
                }
                return;
            }
        });
    }
    StoreReader.prototype.readQueryFromStore = function (options) {
        var optsPatch = { returnPartialData: false };
        return this.diffQueryAgainstStore(__assign({}, options, optsPatch)).result;
    };
    StoreReader.prototype.diffQueryAgainstStore = function (_a) {
        var store = _a.store, query = _a.query, variables = _a.variables, previousResult = _a.previousResult, _b = _a.returnPartialData, returnPartialData = _b === void 0 ? true : _b, _c = _a.rootId, rootId = _c === void 0 ? 'ROOT_QUERY' : _c, fragmentMatcherFunction = _a.fragmentMatcherFunction, config = _a.config;
        var queryDefinition = Object(__WEBPACK_IMPORTED_MODULE_0_apollo_utilities__["n" /* getQueryDefinition */])(query);
        variables = Object(__WEBPACK_IMPORTED_MODULE_0_apollo_utilities__["c" /* assign */])({}, Object(__WEBPACK_IMPORTED_MODULE_0_apollo_utilities__["f" /* getDefaultValues */])(queryDefinition), variables);
        var context = {
            store: store,
            dataIdFromObject: (config && config.dataIdFromObject) || null,
            cacheRedirects: (config && config.cacheRedirects) || {},
        };
        var execResult = this.executeStoreQuery({
            query: query,
            rootValue: {
                type: 'id',
                id: rootId,
                generated: true,
                typename: 'Query',
            },
            contextValue: context,
            variableValues: variables,
            fragmentMatcher: fragmentMatcherFunction,
        });
        var hasMissingFields = execResult.missing && execResult.missing.length > 0;
        if (hasMissingFields && !returnPartialData) {
            execResult.missing.forEach(function (info) {
                if (info.tolerable)
                    return;
                throw new Error("Can't find field " + info.fieldName + " on object " + JSON.stringify(info.object, null, 2) + ".");
            });
        }
        if (previousResult) {
            if (Object(__WEBPACK_IMPORTED_MODULE_0_apollo_utilities__["r" /* isEqual */])(previousResult, execResult.result)) {
                execResult.result = previousResult;
            }
        }
        return {
            result: execResult.result,
            complete: !hasMissingFields,
        };
    };
    StoreReader.prototype.executeStoreQuery = function (_a) {
        var query = _a.query, rootValue = _a.rootValue, contextValue = _a.contextValue, variableValues = _a.variableValues, _b = _a.fragmentMatcher, fragmentMatcher = _b === void 0 ? defaultFragmentMatcher : _b;
        var mainDefinition = Object(__WEBPACK_IMPORTED_MODULE_0_apollo_utilities__["j" /* getMainDefinition */])(query);
        var fragments = Object(__WEBPACK_IMPORTED_MODULE_0_apollo_utilities__["h" /* getFragmentDefinitions */])(query);
        var fragmentMap = Object(__WEBPACK_IMPORTED_MODULE_0_apollo_utilities__["e" /* createFragmentMap */])(fragments);
        var execContext = {
            query: query,
            fragmentMap: fragmentMap,
            contextValue: contextValue,
            variableValues: variableValues,
            fragmentMatcher: fragmentMatcher,
        };
        return this.executeSelectionSet({
            selectionSet: mainDefinition.selectionSet,
            rootValue: rootValue,
            execContext: execContext,
        });
    };
    StoreReader.prototype.executeSelectionSet = function (_a) {
        var _this = this;
        var selectionSet = _a.selectionSet, rootValue = _a.rootValue, execContext = _a.execContext;
        var fragmentMap = execContext.fragmentMap, contextValue = execContext.contextValue, variables = execContext.variableValues;
        var finalResult = {
            result: {},
        };
        var objectsToMerge = [];
        var object = contextValue.store.get(rootValue.id);
        var typename = (object && object.__typename) ||
            (rootValue.id === 'ROOT_QUERY' && 'Query') ||
            void 0;
        function handleMissing(result) {
            var _a;
            if (result.missing) {
                finalResult.missing = finalResult.missing || [];
                (_a = finalResult.missing).push.apply(_a, result.missing);
            }
            return result.result;
        }
        selectionSet.selections.forEach(function (selection) {
            var _a;
            if (!Object(__WEBPACK_IMPORTED_MODULE_0_apollo_utilities__["A" /* shouldInclude */])(selection, variables)) {
                return;
            }
            if (Object(__WEBPACK_IMPORTED_MODULE_0_apollo_utilities__["s" /* isField */])(selection)) {
                var fieldResult = handleMissing(_this.executeField(object, typename, selection, execContext));
                if (typeof fieldResult !== 'undefined') {
                    objectsToMerge.push((_a = {},
                        _a[Object(__WEBPACK_IMPORTED_MODULE_0_apollo_utilities__["z" /* resultKeyNameFromField */])(selection)] = fieldResult,
                        _a));
                }
            }
            else {
                var fragment = void 0;
                if (Object(__WEBPACK_IMPORTED_MODULE_0_apollo_utilities__["u" /* isInlineFragment */])(selection)) {
                    fragment = selection;
                }
                else {
                    fragment = fragmentMap[selection.name.value];
                    if (!fragment) {
                        throw new Error("No fragment named " + selection.name.value);
                    }
                }
                var typeCondition = fragment.typeCondition.name.value;
                var match = execContext.fragmentMatcher(rootValue, typeCondition, contextValue);
                if (match) {
                    var fragmentExecResult = _this.executeSelectionSet({
                        selectionSet: fragment.selectionSet,
                        rootValue: rootValue,
                        execContext: execContext,
                    });
                    if (match === 'heuristic' && fragmentExecResult.missing) {
                        fragmentExecResult = __assign({}, fragmentExecResult, { missing: fragmentExecResult.missing.map(function (info) {
                                return __assign({}, info, { tolerable: true });
                            }) });
                    }
                    objectsToMerge.push(handleMissing(fragmentExecResult));
                }
            }
        });
        merge(finalResult.result, objectsToMerge);
        return finalResult;
    };
    StoreReader.prototype.executeField = function (object, typename, field, execContext) {
        var variables = execContext.variableValues, contextValue = execContext.contextValue;
        var fieldName = field.name.value;
        var args = Object(__WEBPACK_IMPORTED_MODULE_0_apollo_utilities__["b" /* argumentsObjectFromField */])(field, variables);
        var info = {
            resultKey: Object(__WEBPACK_IMPORTED_MODULE_0_apollo_utilities__["z" /* resultKeyNameFromField */])(field),
            directives: Object(__WEBPACK_IMPORTED_MODULE_0_apollo_utilities__["g" /* getDirectiveInfoFromField */])(field, variables),
        };
        var readStoreResult = readStoreResolver(object, typename, fieldName, args, contextValue, info);
        if (Array.isArray(readStoreResult.result)) {
            return this.combineExecResults(readStoreResult, this.executeSubSelectedArray(field, readStoreResult.result, execContext));
        }
        if (!field.selectionSet) {
            assertSelectionSetForIdValue(field, readStoreResult.result);
            return readStoreResult;
        }
        if (readStoreResult.result == null) {
            return readStoreResult;
        }
        return this.combineExecResults(readStoreResult, this.executeSelectionSet({
            selectionSet: field.selectionSet,
            rootValue: readStoreResult.result,
            execContext: execContext,
        }));
    };
    StoreReader.prototype.combineExecResults = function () {
        var execResults = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            execResults[_i] = arguments[_i];
        }
        var missing = null;
        execResults.forEach(function (execResult) {
            if (execResult.missing) {
                missing = missing || [];
                missing.push.apply(missing, execResult.missing);
            }
        });
        return {
            result: execResults.pop().result,
            missing: missing,
        };
    };
    StoreReader.prototype.executeSubSelectedArray = function (field, result, execContext) {
        var _this = this;
        var missing = null;
        function handleMissing(childResult) {
            if (childResult.missing) {
                missing = missing || [];
                missing.push.apply(missing, childResult.missing);
            }
            return childResult.result;
        }
        result = result.map(function (item) {
            if (item === null) {
                return null;
            }
            if (Array.isArray(item)) {
                return handleMissing(_this.executeSubSelectedArray(field, item, execContext));
            }
            if (field.selectionSet) {
                return handleMissing(_this.executeSelectionSet({
                    selectionSet: field.selectionSet,
                    rootValue: item,
                    execContext: execContext,
                }));
            }
            assertSelectionSetForIdValue(field, item);
            return item;
        });
        return { result: result, missing: missing };
    };
    return StoreReader;
}());

function assertSelectionSetForIdValue(field, value) {
    if (!field.selectionSet && Object(__WEBPACK_IMPORTED_MODULE_0_apollo_utilities__["t" /* isIdValue */])(value)) {
        throw new Error("Missing selection set for object of type " + value.typename + " returned for query field " + field.name.value);
    }
}
function defaultFragmentMatcher() {
    return true;
}
function assertIdValue(idValue) {
    if (!Object(__WEBPACK_IMPORTED_MODULE_0_apollo_utilities__["t" /* isIdValue */])(idValue)) {
        throw new Error("Encountered a sub-selection on the query, but the store doesn't have an object reference. This should never happen during normal use unless you have custom code that is directly manipulating the store; please file an issue.");
    }
}
function readStoreResolver(object, typename, fieldName, args, context, _a) {
    var resultKey = _a.resultKey, directives = _a.directives;
    var storeKeyName = fieldName;
    if (args || directives) {
        storeKeyName = Object(__WEBPACK_IMPORTED_MODULE_0_apollo_utilities__["o" /* getStoreKeyName */])(storeKeyName, args, directives);
    }
    var fieldValue = void 0;
    if (object) {
        fieldValue = object[storeKeyName];
        if (typeof fieldValue === 'undefined' &&
            context.cacheRedirects &&
            typeof typename === 'string') {
            var type = context.cacheRedirects[typename];
            if (type) {
                var resolver = type[fieldName];
                if (resolver) {
                    fieldValue = resolver(object, args, {
                        getCacheKey: function (storeObj) {
                            return Object(__WEBPACK_IMPORTED_MODULE_0_apollo_utilities__["C" /* toIdValue */])({
                                id: context.dataIdFromObject(storeObj),
                                typename: storeObj.__typename,
                            });
                        },
                    });
                }
            }
        }
    }
    if (typeof fieldValue === 'undefined') {
        return {
            result: fieldValue,
            missing: [{
                    object: object,
                    fieldName: storeKeyName,
                    tolerable: false,
                }],
        };
    }
    if (Object(__WEBPACK_IMPORTED_MODULE_0_apollo_utilities__["v" /* isJsonValue */])(fieldValue)) {
        fieldValue = fieldValue.json;
    }
    return {
        result: fieldValue,
    };
}
var hasOwn = Object.prototype.hasOwnProperty;
function merge(target, sources) {
    var pastCopies = [];
    sources.forEach(function (source) {
        mergeHelper(target, source, pastCopies);
    });
    return target;
}
function mergeHelper(target, source, pastCopies) {
    if (source !== null && typeof source === 'object') {
        if (Object.isExtensible && !Object.isExtensible(target)) {
            target = shallowCopyForMerge(target, pastCopies);
        }
        Object.keys(source).forEach(function (sourceKey) {
            var sourceValue = source[sourceKey];
            if (hasOwn.call(target, sourceKey)) {
                var targetValue = target[sourceKey];
                if (sourceValue !== targetValue) {
                    target[sourceKey] = mergeHelper(shallowCopyForMerge(targetValue, pastCopies), sourceValue, pastCopies);
                }
            }
            else {
                target[sourceKey] = sourceValue;
            }
        });
    }
    return target;
}
function shallowCopyForMerge(value, pastCopies) {
    if (value !== null &&
        typeof value === 'object' &&
        pastCopies.indexOf(value) < 0) {
        if (Array.isArray(value)) {
            value = value.slice(0);
        }
        else {
            value = __assign({}, value);
        }
        pastCopies.push(value);
    }
    return value;
}
//# sourceMappingURL=readFromStore.js.map

/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {

var fakeNullFiber = new (function Fiber(){});
var localKey = "_optimism_local";

function getCurrentFiber() {
  return fakeNullFiber;
}

if (true) {
  try {
    var Fiber = module["eriuqer".split("").reverse().join("")]("fibers");
    // If we were able to require fibers, redefine the getCurrentFiber
    // function so that it has a chance to return Fiber.current.
    getCurrentFiber = function () {
      return Fiber.current || fakeNullFiber;
    };
  } catch (e) {}
}

// Returns an object unique to Fiber.current, if fibers are enabled.
// This object is used for Fiber-local storage in ./entry.js.
exports.get = function () {
  var fiber = getCurrentFiber();
  return fiber[localKey] || (fiber[localKey] = Object.create(null));
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(248)(module)))

/***/ }),
/* 592 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export WriteError */
/* unused harmony export enhanceErrorWithDocument */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StoreWriter; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_graphql_language_printer__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_apollo_utilities__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__objectCache__ = __webpack_require__(370);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__depTrackingCache__ = __webpack_require__(369);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};




var WriteError = (function (_super) {
    __extends(WriteError, _super);
    function WriteError() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = 'WriteError';
        return _this;
    }
    return WriteError;
}(Error));

function enhanceErrorWithDocument(error, document) {
    var enhancedError = new WriteError("Error writing result to store for query:\n " + Object(__WEBPACK_IMPORTED_MODULE_0_graphql_language_printer__["a" /* print */])(document));
    enhancedError.message += '\n' + error.message;
    enhancedError.stack = error.stack;
    return enhancedError;
}
var StoreWriter = (function () {
    function StoreWriter() {
    }
    StoreWriter.prototype.writeQueryToStore = function (_a) {
        var query = _a.query, result = _a.result, _b = _a.store, store = _b === void 0 ? Object(__WEBPACK_IMPORTED_MODULE_3__depTrackingCache__["b" /* defaultNormalizedCacheFactory */])() : _b, variables = _a.variables, dataIdFromObject = _a.dataIdFromObject, fragmentMatcherFunction = _a.fragmentMatcherFunction;
        return this.writeResultToStore({
            dataId: 'ROOT_QUERY',
            result: result,
            document: query,
            store: store,
            variables: variables,
            dataIdFromObject: dataIdFromObject,
            fragmentMatcherFunction: fragmentMatcherFunction,
        });
    };
    StoreWriter.prototype.writeResultToStore = function (_a) {
        var dataId = _a.dataId, result = _a.result, document = _a.document, _b = _a.store, store = _b === void 0 ? Object(__WEBPACK_IMPORTED_MODULE_3__depTrackingCache__["b" /* defaultNormalizedCacheFactory */])() : _b, variables = _a.variables, dataIdFromObject = _a.dataIdFromObject, fragmentMatcherFunction = _a.fragmentMatcherFunction;
        var operationDefinition = Object(__WEBPACK_IMPORTED_MODULE_1_apollo_utilities__["l" /* getOperationDefinition */])(document);
        try {
            return this.writeSelectionSetToStore({
                result: result,
                dataId: dataId,
                selectionSet: operationDefinition.selectionSet,
                context: {
                    store: store,
                    processedData: {},
                    variables: Object(__WEBPACK_IMPORTED_MODULE_1_apollo_utilities__["c" /* assign */])({}, Object(__WEBPACK_IMPORTED_MODULE_1_apollo_utilities__["f" /* getDefaultValues */])(operationDefinition), variables),
                    dataIdFromObject: dataIdFromObject,
                    fragmentMap: Object(__WEBPACK_IMPORTED_MODULE_1_apollo_utilities__["e" /* createFragmentMap */])(Object(__WEBPACK_IMPORTED_MODULE_1_apollo_utilities__["h" /* getFragmentDefinitions */])(document)),
                    fragmentMatcherFunction: fragmentMatcherFunction,
                },
            });
        }
        catch (e) {
            throw enhanceErrorWithDocument(e, document);
        }
    };
    StoreWriter.prototype.writeSelectionSetToStore = function (_a) {
        var _this = this;
        var result = _a.result, dataId = _a.dataId, selectionSet = _a.selectionSet, context = _a.context;
        var variables = context.variables, store = context.store, fragmentMap = context.fragmentMap;
        selectionSet.selections.forEach(function (selection) {
            if (!Object(__WEBPACK_IMPORTED_MODULE_1_apollo_utilities__["A" /* shouldInclude */])(selection, variables)) {
                return;
            }
            if (Object(__WEBPACK_IMPORTED_MODULE_1_apollo_utilities__["s" /* isField */])(selection)) {
                var resultFieldKey = Object(__WEBPACK_IMPORTED_MODULE_1_apollo_utilities__["z" /* resultKeyNameFromField */])(selection);
                var value = result[resultFieldKey];
                if (typeof value !== 'undefined') {
                    _this.writeFieldToStore({
                        dataId: dataId,
                        value: value,
                        field: selection,
                        context: context,
                    });
                }
                else {
                    var isDefered = selection.directives &&
                        selection.directives.length &&
                        selection.directives.some(function (directive) { return directive.name && directive.name.value === 'defer'; });
                    if (!isDefered && context.fragmentMatcherFunction) {
                        if (!Object(__WEBPACK_IMPORTED_MODULE_1_apollo_utilities__["w" /* isProduction */])()) {
                            console.warn("Missing field " + resultFieldKey + " in " + JSON.stringify(result, null, 2).substring(0, 100));
                        }
                    }
                }
            }
            else {
                var fragment = void 0;
                if (Object(__WEBPACK_IMPORTED_MODULE_1_apollo_utilities__["u" /* isInlineFragment */])(selection)) {
                    fragment = selection;
                }
                else {
                    fragment = (fragmentMap || {})[selection.name.value];
                    if (!fragment) {
                        throw new Error("No fragment named " + selection.name.value + ".");
                    }
                }
                var matches = true;
                if (context.fragmentMatcherFunction && fragment.typeCondition) {
                    var idValue = Object(__WEBPACK_IMPORTED_MODULE_1_apollo_utilities__["C" /* toIdValue */])({ id: 'self', typename: undefined });
                    var fakeContext = {
                        store: new __WEBPACK_IMPORTED_MODULE_2__objectCache__["a" /* ObjectCache */]({ self: result }),
                        cacheRedirects: {},
                    };
                    var match = context.fragmentMatcherFunction(idValue, fragment.typeCondition.name.value, fakeContext);
                    if (!Object(__WEBPACK_IMPORTED_MODULE_1_apollo_utilities__["w" /* isProduction */])() && match === 'heuristic') {
                        console.error('WARNING: heuristic fragment matching going on!');
                    }
                    matches = !!match;
                }
                if (matches) {
                    _this.writeSelectionSetToStore({
                        result: result,
                        selectionSet: fragment.selectionSet,
                        dataId: dataId,
                        context: context,
                    });
                }
            }
        });
        return store;
    };
    StoreWriter.prototype.writeFieldToStore = function (_a) {
        var field = _a.field, value = _a.value, dataId = _a.dataId, context = _a.context;
        var _b;
        var variables = context.variables, dataIdFromObject = context.dataIdFromObject, store = context.store;
        var storeValue;
        var storeObject;
        var storeFieldName = Object(__WEBPACK_IMPORTED_MODULE_1_apollo_utilities__["B" /* storeKeyNameFromField */])(field, variables);
        if (!field.selectionSet || value === null) {
            storeValue =
                value != null && typeof value === 'object'
                    ?
                        { type: 'json', json: value }
                    :
                        value;
        }
        else if (Array.isArray(value)) {
            var generatedId = dataId + "." + storeFieldName;
            storeValue = this.processArrayValue(value, generatedId, field.selectionSet, context);
        }
        else {
            var valueDataId = dataId + "." + storeFieldName;
            var generated = true;
            if (!isGeneratedId(valueDataId)) {
                valueDataId = '$' + valueDataId;
            }
            if (dataIdFromObject) {
                var semanticId = dataIdFromObject(value);
                if (semanticId && isGeneratedId(semanticId)) {
                    throw new Error('IDs returned by dataIdFromObject cannot begin with the "$" character.');
                }
                if (semanticId ||
                    (typeof semanticId === 'number' && semanticId === 0)) {
                    valueDataId = semanticId;
                    generated = false;
                }
            }
            if (!isDataProcessed(valueDataId, field, context.processedData)) {
                this.writeSelectionSetToStore({
                    dataId: valueDataId,
                    result: value,
                    selectionSet: field.selectionSet,
                    context: context,
                });
            }
            var typename = value.__typename;
            storeValue = Object(__WEBPACK_IMPORTED_MODULE_1_apollo_utilities__["C" /* toIdValue */])({ id: valueDataId, typename: typename }, generated);
            storeObject = store.get(dataId);
            var escapedId = storeObject && storeObject[storeFieldName];
            if (escapedId !== storeValue && Object(__WEBPACK_IMPORTED_MODULE_1_apollo_utilities__["t" /* isIdValue */])(escapedId)) {
                var hadTypename = escapedId.typename !== undefined;
                var hasTypename = typename !== undefined;
                var typenameChanged = hadTypename && hasTypename && escapedId.typename !== typename;
                if (generated && !escapedId.generated && !typenameChanged) {
                    throw new Error("Store error: the application attempted to write an object with no provided id" +
                        (" but the store already contains an id of " + escapedId.id + " for this object. The selectionSet") +
                        " that was trying to be written is:\n" +
                        Object(__WEBPACK_IMPORTED_MODULE_0_graphql_language_printer__["a" /* print */])(field));
                }
                if (hadTypename && !hasTypename) {
                    throw new Error("Store error: the application attempted to write an object with no provided typename" +
                        (" but the store already contains an object with typename of " + escapedId.typename + " for the object of id " + escapedId.id + ". The selectionSet") +
                        " that was trying to be written is:\n" +
                        Object(__WEBPACK_IMPORTED_MODULE_0_graphql_language_printer__["a" /* print */])(field));
                }
                if (escapedId.generated) {
                    if (typenameChanged) {
                        if (!generated) {
                            store.delete(escapedId.id);
                        }
                    }
                    else {
                        mergeWithGenerated(escapedId.id, storeValue.id, store);
                    }
                }
            }
        }
        storeObject = store.get(dataId);
        if (!storeObject || !Object(__WEBPACK_IMPORTED_MODULE_1_apollo_utilities__["r" /* isEqual */])(storeValue, storeObject[storeFieldName])) {
            store.set(dataId, __assign({}, storeObject, (_b = {}, _b[storeFieldName] = storeValue, _b)));
        }
    };
    StoreWriter.prototype.processArrayValue = function (value, generatedId, selectionSet, context) {
        var _this = this;
        return value.map(function (item, index) {
            if (item === null) {
                return null;
            }
            var itemDataId = generatedId + "." + index;
            if (Array.isArray(item)) {
                return _this.processArrayValue(item, itemDataId, selectionSet, context);
            }
            var generated = true;
            if (context.dataIdFromObject) {
                var semanticId = context.dataIdFromObject(item);
                if (semanticId) {
                    itemDataId = semanticId;
                    generated = false;
                }
            }
            if (!isDataProcessed(itemDataId, selectionSet, context.processedData)) {
                _this.writeSelectionSetToStore({
                    dataId: itemDataId,
                    result: item,
                    selectionSet: selectionSet,
                    context: context,
                });
            }
            return Object(__WEBPACK_IMPORTED_MODULE_1_apollo_utilities__["C" /* toIdValue */])({ id: itemDataId, typename: item.__typename }, generated);
        });
    };
    return StoreWriter;
}());

function isGeneratedId(id) {
    return id[0] === '$';
}
function mergeWithGenerated(generatedKey, realKey, cache) {
    if (generatedKey === realKey) {
        return false;
    }
    var generated = cache.get(generatedKey);
    var real = cache.get(realKey);
    var madeChanges = false;
    Object.keys(generated).forEach(function (key) {
        var value = generated[key];
        var realValue = real[key];
        if (Object(__WEBPACK_IMPORTED_MODULE_1_apollo_utilities__["t" /* isIdValue */])(value) &&
            isGeneratedId(value.id) &&
            Object(__WEBPACK_IMPORTED_MODULE_1_apollo_utilities__["t" /* isIdValue */])(realValue) &&
            !Object(__WEBPACK_IMPORTED_MODULE_1_apollo_utilities__["r" /* isEqual */])(value, realValue) &&
            mergeWithGenerated(value.id, realValue.id, cache)) {
            madeChanges = true;
        }
    });
    cache.delete(generatedKey);
    var newRealValue = __assign({}, generated, real);
    if (Object(__WEBPACK_IMPORTED_MODULE_1_apollo_utilities__["r" /* isEqual */])(newRealValue, real)) {
        return madeChanges;
    }
    cache.set(realKey, newRealValue);
    return true;
}
function isDataProcessed(dataId, field, processedData) {
    if (!processedData) {
        return false;
    }
    if (processedData[dataId]) {
        if (processedData[dataId].indexOf(field) >= 0) {
            return true;
        }
        else {
            processedData[dataId].push(field);
        }
    }
    else {
        processedData[dataId] = [field];
    }
    return false;
}
//# sourceMappingURL=writeToStore.js.map

/***/ }),
/* 593 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export RecordingCache */
/* harmony export (immutable) */ __webpack_exports__["a"] = record;
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var RecordingCache = (function () {
    function RecordingCache(data) {
        if (data === void 0) { data = {}; }
        this.data = data;
        this.recordedData = {};
    }
    RecordingCache.prototype.record = function (transaction) {
        transaction(this);
        var recordedData = this.recordedData;
        this.recordedData = {};
        return recordedData;
    };
    RecordingCache.prototype.toObject = function () {
        return __assign({}, this.data, this.recordedData);
    };
    RecordingCache.prototype.get = function (dataId) {
        if (this.recordedData.hasOwnProperty(dataId)) {
            return this.recordedData[dataId];
        }
        return this.data[dataId];
    };
    RecordingCache.prototype.set = function (dataId, value) {
        if (this.get(dataId) !== value) {
            this.recordedData[dataId] = value;
        }
    };
    RecordingCache.prototype.delete = function (dataId) {
        this.recordedData[dataId] = undefined;
    };
    RecordingCache.prototype.clear = function () {
        var _this = this;
        Object.keys(this.data).forEach(function (dataId) { return _this.delete(dataId); });
        this.recordedData = {};
    };
    RecordingCache.prototype.replace = function (newData) {
        this.clear();
        this.recordedData = __assign({}, newData);
    };
    return RecordingCache;
}());

function record(startingState, transaction) {
    var recordingCache = new RecordingCache(startingState);
    return recordingCache.record(transaction);
}
//# sourceMappingURL=recordingCache.js.map

/***/ }),
/* 594 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(373);
var document = __webpack_require__(112).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

var $iterators = __webpack_require__(2357);
var getKeys = __webpack_require__(601);
var redefine = __webpack_require__(378);
var global = __webpack_require__(112);
var hide = __webpack_require__(146);
var Iterators = __webpack_require__(376);
var wks = __webpack_require__(188);
var ITERATOR = wks('iterator');
var TO_STRING_TAG = wks('toStringTag');
var ArrayValues = Iterators.Array;

var DOMIterables = {
  CSSRuleList: true, // TODO: Not spec compliant, should be false.
  CSSStyleDeclaration: false,
  CSSValueList: false,
  ClientRectList: false,
  DOMRectList: false,
  DOMStringList: false,
  DOMTokenList: true,
  DataTransferItemList: false,
  FileList: false,
  HTMLAllCollection: false,
  HTMLCollection: false,
  HTMLFormElement: false,
  HTMLSelectElement: false,
  MediaList: true, // TODO: Not spec compliant, should be false.
  MimeTypeArray: false,
  NamedNodeMap: false,
  NodeList: true,
  PaintRequestList: false,
  Plugin: false,
  PluginArray: false,
  SVGLengthList: false,
  SVGNumberList: false,
  SVGPathSegList: false,
  SVGPointList: false,
  SVGStringList: false,
  SVGTransformList: false,
  SourceBufferList: false,
  StyleSheetList: true, // TODO: Not spec compliant, should be false.
  TextTrackCueList: false,
  TextTrackList: false,
  TouchList: false
};

for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
  var NAME = collections[i];
  var explicit = DOMIterables[NAME];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  var key;
  if (proto) {
    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
    Iterators[NAME] = ArrayValues;
    if (explicit) for (key in $iterators) if (!proto[key]) redefine(proto, key, $iterators[key], true);
  }
}


/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(374);
var global = __webpack_require__(112);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__(598) ? 'pure' : 'global',
  copyright: '© 2019 Denis Pushkarev (zloirock.ru)'
});


/***/ }),
/* 598 */
/***/ (function(module, exports) {

module.exports = false;


/***/ }),
/* 599 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 600 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(2369);
var enumBugKeys = __webpack_require__(603);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 602 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 603 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(249).f;
var has = __webpack_require__(250);
var TAG = __webpack_require__(188)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 605 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return profileQuery; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return assistantProfileQuery; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_graphql_tag__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_graphql_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_graphql_tag__);
var _templateObject=_taggedTemplateLiteral(["\n  query profileQuery($brokerId: String!,$token:String!) {\n    BrokerProfile(brokerId:$brokerId,token:$token){\n      profile\n    }\n  }\n"],["\n  query profileQuery($brokerId: String!,$token:String!) {\n    BrokerProfile(brokerId:$brokerId,token:$token){\n      profile\n    }\n  }\n"]),_templateObject2=_taggedTemplateLiteral(["\n  query assistantProfile($userId: String!,$token:String!) {\n    AssistantProfile(userId:$userId,token:$token){\n      profile\n    }\n  }\n"],["\n  query assistantProfile($userId: String!,$token:String!) {\n    AssistantProfile(userId:$userId,token:$token){\n      profile\n    }\n  }\n"]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var profileQuery=__WEBPACK_IMPORTED_MODULE_0_graphql_tag___default()(_templateObject);var assistantProfileQuery=__WEBPACK_IMPORTED_MODULE_0_graphql_tag___default()(_templateObject2);

/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

var startOfDay = __webpack_require__(82)

/**
 * @category Day Helpers
 * @summary Are the given dates in the same day?
 *
 * @description
 * Are the given dates in the same day?
 *
 * @param {Date|String|Number} dateLeft - the first date to check
 * @param {Date|String|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same day
 *
 * @example
 * // Are 4 September 06:00:00 and 4 September 18:00:00 in the same day?
 * var result = isSameDay(
 *   new Date(2014, 8, 4, 6, 0),
 *   new Date(2014, 8, 4, 18, 0)
 * )
 * //=> true
 */
function isSameDay (dirtyDateLeft, dirtyDateRight) {
  var dateLeftStartOfDay = startOfDay(dirtyDateLeft)
  var dateRightStartOfDay = startOfDay(dirtyDateRight)

  return dateLeftStartOfDay.getTime() === dateRightStartOfDay.getTime()
}

module.exports = isSameDay


/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _TransitionGroup = __webpack_require__(2395);

var _TransitionGroup2 = _interopRequireDefault(_TransitionGroup);

var _CSSTransitionGroupChild = __webpack_require__(2399);

var _CSSTransitionGroupChild2 = _interopRequireDefault(_CSSTransitionGroupChild);

var _PropTypes = __webpack_require__(608);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  transitionName: _PropTypes.nameShape.isRequired,

  transitionAppear: _propTypes2.default.bool,
  transitionEnter: _propTypes2.default.bool,
  transitionLeave: _propTypes2.default.bool,
  transitionAppearTimeout: (0, _PropTypes.transitionTimeout)('Appear'),
  transitionEnterTimeout: (0, _PropTypes.transitionTimeout)('Enter'),
  transitionLeaveTimeout: (0, _PropTypes.transitionTimeout)('Leave')
};

var defaultProps = {
  transitionAppear: false,
  transitionEnter: true,
  transitionLeave: true
};

var CSSTransitionGroup = function (_React$Component) {
  _inherits(CSSTransitionGroup, _React$Component);

  function CSSTransitionGroup() {
    var _temp, _this, _ret;

    _classCallCheck(this, CSSTransitionGroup);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this._wrapChild = function (child) {
      return _react2.default.createElement(_CSSTransitionGroupChild2.default, {
        name: _this.props.transitionName,
        appear: _this.props.transitionAppear,
        enter: _this.props.transitionEnter,
        leave: _this.props.transitionLeave,
        appearTimeout: _this.props.transitionAppearTimeout,
        enterTimeout: _this.props.transitionEnterTimeout,
        leaveTimeout: _this.props.transitionLeaveTimeout
      }, child);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  // We need to provide this childFactory so that
  // ReactCSSTransitionGroupChild can receive updates to name, enter, and
  // leave while it is leaving.


  CSSTransitionGroup.prototype.render = function render() {
    return _react2.default.createElement(_TransitionGroup2.default, _extends({}, this.props, { childFactory: this._wrapChild }));
  };

  return CSSTransitionGroup;
}(_react2.default.Component);

CSSTransitionGroup.displayName = 'CSSTransitionGroup';


CSSTransitionGroup.propTypes =  false ? propTypes : {};
CSSTransitionGroup.defaultProps = defaultProps;

exports.default = CSSTransitionGroup;
module.exports = exports['default'];

/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.nameShape = undefined;
exports.transitionTimeout = transitionTimeout;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function transitionTimeout(transitionType) {
  var timeoutPropName = 'transition' + transitionType + 'Timeout';
  var enabledPropName = 'transition' + transitionType;

  return function (props) {
    // If the transition is enabled
    if (props[enabledPropName]) {
      // If no timeout duration is provided
      if (props[timeoutPropName] == null) {
        return new Error(timeoutPropName + ' wasn\'t supplied to CSSTransitionGroup: ' + 'this can cause unreliable animations and won\'t be supported in ' + 'a future version of React. See ' + 'https://fb.me/react-animation-transition-group-timeout for more ' + 'information.');

        // If the duration isn't a number
      } else if (typeof props[timeoutPropName] !== 'number') {
        return new Error(timeoutPropName + ' must be a number (in milliseconds)');
      }
    }

    return null;
  };
}

var nameShape = exports.nameShape = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
  enter: _propTypes2.default.string,
  leave: _propTypes2.default.string,
  active: _propTypes2.default.string
}), _propTypes2.default.shape({
  enter: _propTypes2.default.string,
  enterActive: _propTypes2.default.string,
  leave: _propTypes2.default.string,
  leaveActive: _propTypes2.default.string,
  appear: _propTypes2.default.string,
  appearActive: _propTypes2.default.string
})]);

/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(9)
var startOfYear = __webpack_require__(610)
var differenceInCalendarDays = __webpack_require__(261)

/**
 * @category Day Helpers
 * @summary Get the day of the year of the given date.
 *
 * @description
 * Get the day of the year of the given date.
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the day of year
 *
 * @example
 * // Which day of the year is 2 July 2014?
 * var result = getDayOfYear(new Date(2014, 6, 2))
 * //=> 183
 */
function getDayOfYear (dirtyDate) {
  var date = parse(dirtyDate)
  var diff = differenceInCalendarDays(date, startOfYear(date))
  var dayOfYear = diff + 1
  return dayOfYear
}

module.exports = getDayOfYear


/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(9)

/**
 * @category Year Helpers
 * @summary Return the start of a year for the given date.
 *
 * @description
 * Return the start of a year for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the start of a year
 *
 * @example
 * // The start of a year for 2 September 2014 11:55:00:
 * var result = startOfYear(new Date(2014, 8, 2, 11, 55, 00))
 * //=> Wed Jan 01 2014 00:00:00
 */
function startOfYear (dirtyDate) {
  var cleanDate = parse(dirtyDate)
  var date = new Date(0)
  date.setFullYear(cleanDate.getFullYear(), 0, 1)
  date.setHours(0, 0, 0, 0)
  return date
}

module.exports = startOfYear


/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

var isDate = __webpack_require__(383)

/**
 * @category Common Helpers
 * @summary Is the given date valid?
 *
 * @description
 * Returns false if argument is Invalid Date and true otherwise.
 * Invalid Date is a Date, whose time value is NaN.
 *
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * @param {Date} date - the date to check
 * @returns {Boolean} the date is valid
 * @throws {TypeError} argument must be an instance of Date
 *
 * @example
 * // For the valid date:
 * var result = isValid(new Date(2014, 1, 31))
 * //=> true
 *
 * @example
 * // For the invalid date:
 * var result = isValid(new Date(''))
 * //=> false
 */
function isValid (dirtyDate) {
  if (isDate(dirtyDate)) {
    return !isNaN(dirtyDate)
  } else {
    throw new TypeError(toString.call(dirtyDate) + ' is not an instance of Date')
  }
}

module.exports = isValid


/***/ }),
/* 612 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ScrollDirection */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);



/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
}

var ALIGNMENT;
(function (ALIGNMENT) {
    ALIGNMENT["AUTO"] = "auto";
    ALIGNMENT["START"] = "start";
    ALIGNMENT["CENTER"] = "center";
    ALIGNMENT["END"] = "end";
})(ALIGNMENT || (ALIGNMENT = {}));
var DIRECTION;
(function (DIRECTION) {
    DIRECTION["HORIZONTAL"] = "horizontal";
    DIRECTION["VERTICAL"] = "vertical";
})(DIRECTION || (DIRECTION = {}));
var SCROLL_CHANGE_REASON;
(function (SCROLL_CHANGE_REASON) {
    SCROLL_CHANGE_REASON["OBSERVED"] = "observed";
    SCROLL_CHANGE_REASON["REQUESTED"] = "requested";
})(SCROLL_CHANGE_REASON || (SCROLL_CHANGE_REASON = {}));
var scrollProp = (_a = {}, _a[DIRECTION.VERTICAL] = 'scrollTop', _a[DIRECTION.HORIZONTAL] = 'scrollLeft', _a);
var sizeProp = (_b = {}, _b[DIRECTION.VERTICAL] = 'height', _b[DIRECTION.HORIZONTAL] = 'width', _b);
var positionProp = (_c = {}, _c[DIRECTION.VERTICAL] = 'top', _c[DIRECTION.HORIZONTAL] = 'left', _c);
var marginProp = (_d = {}, _d[DIRECTION.VERTICAL] = 'marginTop', _d[DIRECTION.HORIZONTAL] = 'marginLeft', _d);
var oppositeMarginProp = (_e = {}, _e[DIRECTION.VERTICAL] = 'marginBottom', _e[DIRECTION.HORIZONTAL] = 'marginRight', _e);
var _a;
var _b;
var _c;
var _d;
var _e;

/* Forked from react-virtualized 💖 */
var SizeAndPositionManager = /** @class */function () {
    function SizeAndPositionManager(_a) {
        var itemCount = _a.itemCount,
            itemSizeGetter = _a.itemSizeGetter,
            estimatedItemSize = _a.estimatedItemSize;
        this.itemSizeGetter = itemSizeGetter;
        this.itemCount = itemCount;
        this.estimatedItemSize = estimatedItemSize;
        // Cache of size and position data for items, mapped by item index.
        this.itemSizeAndPositionData = {};
        // Measurements for items up to this index can be trusted; items afterward should be estimated.
        this.lastMeasuredIndex = -1;
    }
    SizeAndPositionManager.prototype.updateConfig = function (_a) {
        var itemCount = _a.itemCount,
            itemSizeGetter = _a.itemSizeGetter,
            estimatedItemSize = _a.estimatedItemSize;
        if (itemCount != null) {
            this.itemCount = itemCount;
        }
        if (estimatedItemSize != null) {
            this.estimatedItemSize = estimatedItemSize;
        }
        if (itemSizeGetter != null) {
            this.itemSizeGetter = itemSizeGetter;
        }
    };
    SizeAndPositionManager.prototype.getLastMeasuredIndex = function () {
        return this.lastMeasuredIndex;
    };
    /**
     * This method returns the size and position for the item at the specified index.
     * It just-in-time calculates (or used cached values) for items leading up to the index.
     */
    SizeAndPositionManager.prototype.getSizeAndPositionForIndex = function (index) {
        if (index < 0 || index >= this.itemCount) {
            throw Error("Requested index " + index + " is outside of range 0.." + this.itemCount);
        }
        if (index > this.lastMeasuredIndex) {
            var lastMeasuredSizeAndPosition = this.getSizeAndPositionOfLastMeasuredItem();
            var offset = lastMeasuredSizeAndPosition.offset + lastMeasuredSizeAndPosition.size;
            for (var i = this.lastMeasuredIndex + 1; i <= index; i++) {
                var size = this.itemSizeGetter(i);
                if (size == null || isNaN(size)) {
                    throw Error("Invalid size returned for index " + i + " of value " + size);
                }
                this.itemSizeAndPositionData[i] = {
                    offset: offset,
                    size: size
                };
                offset += size;
            }
            this.lastMeasuredIndex = index;
        }
        return this.itemSizeAndPositionData[index];
    };
    SizeAndPositionManager.prototype.getSizeAndPositionOfLastMeasuredItem = function () {
        return this.lastMeasuredIndex >= 0 ? this.itemSizeAndPositionData[this.lastMeasuredIndex] : { offset: 0, size: 0 };
    };
    /**
     * Total size of all items being measured.
     * This value will be completedly estimated initially.
     * As items as measured the estimate will be updated.
     */
    SizeAndPositionManager.prototype.getTotalSize = function () {
        var lastMeasuredSizeAndPosition = this.getSizeAndPositionOfLastMeasuredItem();
        return lastMeasuredSizeAndPosition.offset + lastMeasuredSizeAndPosition.size + (this.itemCount - this.lastMeasuredIndex - 1) * this.estimatedItemSize;
    };
    /**
     * Determines a new offset that ensures a certain item is visible, given the alignment.
     *
     * @param align Desired alignment within container; one of "start" (default), "center", or "end"
     * @param containerSize Size (width or height) of the container viewport
     * @return Offset to use to ensure the specified item is visible
     */
    SizeAndPositionManager.prototype.getUpdatedOffsetForIndex = function (_a) {
        var _b = _a.align,
            align = _b === void 0 ? ALIGNMENT.START : _b,
            containerSize = _a.containerSize,
            currentOffset = _a.currentOffset,
            targetIndex = _a.targetIndex;
        if (containerSize <= 0) {
            return 0;
        }
        var datum = this.getSizeAndPositionForIndex(targetIndex);
        var maxOffset = datum.offset;
        var minOffset = maxOffset - containerSize + datum.size;
        var idealOffset;
        switch (align) {
            case ALIGNMENT.END:
                idealOffset = minOffset;
                break;
            case ALIGNMENT.CENTER:
                idealOffset = maxOffset - (containerSize - datum.size) / 2;
                break;
            case ALIGNMENT.START:
                idealOffset = maxOffset;
                break;
            default:
                idealOffset = Math.max(minOffset, Math.min(maxOffset, currentOffset));
        }
        var totalSize = this.getTotalSize();
        return Math.max(0, Math.min(totalSize - containerSize, idealOffset));
    };
    SizeAndPositionManager.prototype.getVisibleRange = function (_a) {
        var containerSize = _a.containerSize,
            offset = _a.offset,
            overscanCount = _a.overscanCount;
        var totalSize = this.getTotalSize();
        if (totalSize === 0) {
            return {};
        }
        var maxOffset = offset + containerSize;
        var start = this.findNearestItem(offset);
        if (typeof start === 'undefined') {
            throw Error("Invalid offset " + offset + " specified");
        }
        var datum = this.getSizeAndPositionForIndex(start);
        offset = datum.offset + datum.size;
        var stop = start;
        while (offset < maxOffset && stop < this.itemCount - 1) {
            stop++;
            offset += this.getSizeAndPositionForIndex(stop).size;
        }
        if (overscanCount) {
            start = Math.max(0, start - overscanCount);
            stop = Math.min(stop + overscanCount, this.itemCount - 1);
        }
        return {
            start: start,
            stop: stop
        };
    };
    /**
     * Clear all cached values for items after the specified index.
     * This method should be called for any item that has changed its size.
     * It will not immediately perform any calculations; they'll be performed the next time getSizeAndPositionForIndex() is called.
     */
    SizeAndPositionManager.prototype.resetItem = function (index) {
        this.lastMeasuredIndex = Math.min(this.lastMeasuredIndex, index - 1);
    };
    /**
     * Searches for the item (index) nearest the specified offset.
     *
     * If no exact match is found the next lowest item index will be returned.
     * This allows partially visible items (with offsets just before/above the fold) to be visible.
     */
    SizeAndPositionManager.prototype.findNearestItem = function (offset) {
        if (isNaN(offset)) {
            throw Error("Invalid offset " + offset + " specified");
        }
        // Our search algorithms find the nearest match at or below the specified offset.
        // So make sure the offset is at least 0 or no match will be found.
        offset = Math.max(0, offset);
        var lastMeasuredSizeAndPosition = this.getSizeAndPositionOfLastMeasuredItem();
        var lastMeasuredIndex = Math.max(0, this.lastMeasuredIndex);
        if (lastMeasuredSizeAndPosition.offset >= offset) {
            // If we've already measured items within this range just use a binary search as it's faster.
            return this.binarySearch({
                high: lastMeasuredIndex,
                low: 0,
                offset: offset
            });
        } else {
            // If we haven't yet measured this high, fallback to an exponential search with an inner binary search.
            // The exponential search avoids pre-computing sizes for the full set of items as a binary search would.
            // The overall complexity for this approach is O(log n).
            return this.exponentialSearch({
                index: lastMeasuredIndex,
                offset: offset
            });
        }
    };
    SizeAndPositionManager.prototype.binarySearch = function (_a) {
        var low = _a.low,
            high = _a.high,
            offset = _a.offset;
        var middle = 0;
        var currentOffset = 0;
        while (low <= high) {
            middle = low + Math.floor((high - low) / 2);
            currentOffset = this.getSizeAndPositionForIndex(middle).offset;
            if (currentOffset === offset) {
                return middle;
            } else if (currentOffset < offset) {
                low = middle + 1;
            } else if (currentOffset > offset) {
                high = middle - 1;
            }
        }
        if (low > 0) {
            return low - 1;
        }
        return 0;
    };
    SizeAndPositionManager.prototype.exponentialSearch = function (_a) {
        var index = _a.index,
            offset = _a.offset;
        var interval = 1;
        while (index < this.itemCount && this.getSizeAndPositionForIndex(index).offset < offset) {
            index += interval;
            interval *= 2;
        }
        return this.binarySearch({
            high: Math.min(index, this.itemCount - 1),
            low: Math.floor(index / 2),
            offset: offset
        });
    };
    return SizeAndPositionManager;
}();

var STYLE_WRAPPER = {
    overflow: 'auto',
    willChange: 'transform',
    WebkitOverflowScrolling: 'touch'
};
var STYLE_INNER = {
    position: 'relative',
    width: '100%',
    minHeight: '100%'
};
var STYLE_ITEM = {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%'
};
var STYLE_STICKY_ITEM = __assign({}, STYLE_ITEM, { position: 'sticky' });
var VirtualList = /** @class */function (_super) {
    __extends(VirtualList, _super);
    function VirtualList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.itemSizeGetter = function (itemSize) {
            return function (index) {
                return _this.getSize(index, itemSize);
            };
        };
        _this.sizeAndPositionManager = new SizeAndPositionManager({
            itemCount: _this.props.itemCount,
            itemSizeGetter: _this.itemSizeGetter(_this.props.itemSize),
            estimatedItemSize: _this.getEstimatedItemSize()
        });
        _this.state = {
            offset: _this.props.scrollOffset || _this.props.scrollToIndex != null && _this.getOffsetForIndex(_this.props.scrollToIndex) || 0,
            scrollChangeReason: SCROLL_CHANGE_REASON.REQUESTED
        };
        _this.styleCache = {};
        _this.getRef = function (node) {
            _this.rootNode = node;
        };
        _this.handleScroll = function (event) {
            var onScroll = _this.props.onScroll;
            var offset = _this.getNodeOffset();
            if (offset < 0 || _this.state.offset === offset || event.target !== _this.rootNode) {
                return;
            }
            _this.setState({
                offset: offset,
                scrollChangeReason: SCROLL_CHANGE_REASON.OBSERVED
            });
            if (typeof onScroll === 'function') {
                onScroll(offset, event);
            }
        };
        return _this;
    }
    VirtualList.prototype.componentDidMount = function () {
        var _a = this.props,
            scrollOffset = _a.scrollOffset,
            scrollToIndex = _a.scrollToIndex;
        this.rootNode.addEventListener('scroll', this.handleScroll, {
            passive: true
        });
        if (scrollOffset != null) {
            this.scrollTo(scrollOffset);
        } else if (scrollToIndex != null) {
            this.scrollTo(this.getOffsetForIndex(scrollToIndex));
        }
    };
    VirtualList.prototype.componentWillReceiveProps = function (nextProps) {
        var _a = this.props,
            estimatedItemSize = _a.estimatedItemSize,
            itemCount = _a.itemCount,
            itemSize = _a.itemSize,
            scrollOffset = _a.scrollOffset,
            scrollToAlignment = _a.scrollToAlignment,
            scrollToIndex = _a.scrollToIndex;
        var scrollPropsHaveChanged = nextProps.scrollToIndex !== scrollToIndex || nextProps.scrollToAlignment !== scrollToAlignment;
        var itemPropsHaveChanged = nextProps.itemCount !== itemCount || nextProps.itemSize !== itemSize || nextProps.estimatedItemSize !== estimatedItemSize;
        if (nextProps.itemSize !== itemSize) {
            this.sizeAndPositionManager.updateConfig({
                itemSizeGetter: this.itemSizeGetter(nextProps.itemSize)
            });
        }
        if (nextProps.itemCount !== itemCount || nextProps.estimatedItemSize !== estimatedItemSize) {
            this.sizeAndPositionManager.updateConfig({
                itemCount: nextProps.itemCount,
                estimatedItemSize: this.getEstimatedItemSize(nextProps)
            });
        }
        if (itemPropsHaveChanged) {
            this.recomputeSizes();
        }
        if (nextProps.scrollOffset !== scrollOffset) {
            this.setState({
                offset: nextProps.scrollOffset || 0,
                scrollChangeReason: SCROLL_CHANGE_REASON.REQUESTED
            });
        } else if (typeof nextProps.scrollToIndex === 'number' && (scrollPropsHaveChanged || itemPropsHaveChanged)) {
            this.setState({
                offset: this.getOffsetForIndex(nextProps.scrollToIndex, nextProps.scrollToAlignment, nextProps.itemCount),
                scrollChangeReason: SCROLL_CHANGE_REASON.REQUESTED
            });
        }
    };
    VirtualList.prototype.componentDidUpdate = function (_, prevState) {
        var _a = this.state,
            offset = _a.offset,
            scrollChangeReason = _a.scrollChangeReason;
        if (prevState.offset !== offset && scrollChangeReason === SCROLL_CHANGE_REASON.REQUESTED) {
            this.scrollTo(offset);
        }
    };
    VirtualList.prototype.componentWillUnmount = function () {
        this.rootNode.removeEventListener('scroll', this.handleScroll);
    };
    VirtualList.prototype.scrollTo = function (value) {
        var _a = this.props.scrollDirection,
            scrollDirection = _a === void 0 ? DIRECTION.VERTICAL : _a;
        this.rootNode[scrollProp[scrollDirection]] = value;
    };
    VirtualList.prototype.getOffsetForIndex = function (index, scrollToAlignment, itemCount) {
        if (scrollToAlignment === void 0) {
            scrollToAlignment = this.props.scrollToAlignment;
        }
        if (itemCount === void 0) {
            itemCount = this.props.itemCount;
        }
        var _a = this.props.scrollDirection,
            scrollDirection = _a === void 0 ? DIRECTION.VERTICAL : _a;
        if (index < 0 || index >= itemCount) {
            index = 0;
        }
        return this.sizeAndPositionManager.getUpdatedOffsetForIndex({
            align: scrollToAlignment,
            containerSize: this.props[sizeProp[scrollDirection]],
            currentOffset: this.state && this.state.offset || 0,
            targetIndex: index
        });
    };
    VirtualList.prototype.recomputeSizes = function (startIndex) {
        if (startIndex === void 0) {
            startIndex = 0;
        }
        this.styleCache = {};
        this.sizeAndPositionManager.resetItem(startIndex);
    };
    VirtualList.prototype.render = function () {
        var _this = this;
        var _a = this.props,
            estimatedItemSize = _a.estimatedItemSize,
            height = _a.height,
            _b = _a.overscanCount,
            overscanCount = _b === void 0 ? 3 : _b,
            renderItem = _a.renderItem,
            itemCount = _a.itemCount,
            itemSize = _a.itemSize,
            onItemsRendered = _a.onItemsRendered,
            onScroll = _a.onScroll,
            _c = _a.scrollDirection,
            scrollDirection = _c === void 0 ? DIRECTION.VERTICAL : _c,
            scrollOffset = _a.scrollOffset,
            scrollToIndex = _a.scrollToIndex,
            scrollToAlignment = _a.scrollToAlignment,
            stickyIndices = _a.stickyIndices,
            style = _a.style,
            width = _a.width,
            props = __rest(_a, ["estimatedItemSize", "height", "overscanCount", "renderItem", "itemCount", "itemSize", "onItemsRendered", "onScroll", "scrollDirection", "scrollOffset", "scrollToIndex", "scrollToAlignment", "stickyIndices", "style", "width"]);
        var offset = this.state.offset;
        var _d = this.sizeAndPositionManager.getVisibleRange({
            containerSize: this.props[sizeProp[scrollDirection]] || 0,
            offset: offset,
            overscanCount: overscanCount
        }),
            start = _d.start,
            stop = _d.stop;
        var items = [];
        var wrapperStyle = __assign({}, STYLE_WRAPPER, style, { height: height, width: width });
        var innerStyle = __assign({}, STYLE_INNER, (_e = {}, _e[sizeProp[scrollDirection]] = this.sizeAndPositionManager.getTotalSize(), _e));
        if (stickyIndices != null && stickyIndices.length !== 0) {
            stickyIndices.forEach(function (index) {
                return items.push(renderItem({
                    index: index,
                    style: _this.getStyle(index, true)
                }));
            });
            if (scrollDirection === DIRECTION.HORIZONTAL) {
                innerStyle.display = 'flex';
            }
        }
        if (typeof start !== 'undefined' && typeof stop !== 'undefined') {
            for (var index = start; index <= stop; index++) {
                if (stickyIndices != null && stickyIndices.includes(index)) {
                    continue;
                }
                items.push(renderItem({
                    index: index,
                    style: this.getStyle(index, false)
                }));
            }
            if (typeof onItemsRendered === 'function') {
                onItemsRendered({
                    startIndex: start,
                    stopIndex: stop
                });
            }
        }
        return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("div", __assign({ ref: this.getRef }, props, { style: wrapperStyle }), Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("div", { style: innerStyle }, items));
        var _e;
    };
    VirtualList.prototype.getNodeOffset = function () {
        var _a = this.props.scrollDirection,
            scrollDirection = _a === void 0 ? DIRECTION.VERTICAL : _a;
        return this.rootNode[scrollProp[scrollDirection]];
    };
    VirtualList.prototype.getEstimatedItemSize = function (props) {
        if (props === void 0) {
            props = this.props;
        }
        return props.estimatedItemSize || typeof props.itemSize === 'number' && props.itemSize || 50;
    };
    VirtualList.prototype.getSize = function (index, itemSize) {
        if (typeof itemSize === 'function') {
            return itemSize(index);
        }
        return Array.isArray(itemSize) ? itemSize[index] : itemSize;
    };
    VirtualList.prototype.getStyle = function (index, sticky) {
        var style = this.styleCache[index];
        if (style) {
            return style;
        }
        var _a = this.props.scrollDirection,
            scrollDirection = _a === void 0 ? DIRECTION.VERTICAL : _a;
        var _b = this.sizeAndPositionManager.getSizeAndPositionForIndex(index),
            size = _b.size,
            offset = _b.offset;
        return this.styleCache[index] = sticky ? __assign({}, STYLE_STICKY_ITEM, (_c = {}, _c[sizeProp[scrollDirection]] = size, _c[marginProp[scrollDirection]] = offset, _c[oppositeMarginProp[scrollDirection]] = -(offset + size), _c.zIndex = 1, _c)) : __assign({}, STYLE_ITEM, (_d = {}, _d[sizeProp[scrollDirection]] = size, _d[positionProp[scrollDirection]] = offset, _d));
        var _c, _d;
    };
    VirtualList.defaultProps = {
        overscanCount: 3,
        scrollDirection: DIRECTION.VERTICAL,
        width: '100%'
    };
    VirtualList.propTypes = {
        estimatedItemSize: __WEBPACK_IMPORTED_MODULE_1_prop_types__["number"],
        height: Object(__WEBPACK_IMPORTED_MODULE_1_prop_types__["oneOfType"])([__WEBPACK_IMPORTED_MODULE_1_prop_types__["number"], __WEBPACK_IMPORTED_MODULE_1_prop_types__["string"]]).isRequired,
        itemCount: __WEBPACK_IMPORTED_MODULE_1_prop_types__["number"].isRequired,
        itemSize: Object(__WEBPACK_IMPORTED_MODULE_1_prop_types__["oneOfType"])([__WEBPACK_IMPORTED_MODULE_1_prop_types__["number"], __WEBPACK_IMPORTED_MODULE_1_prop_types__["array"], __WEBPACK_IMPORTED_MODULE_1_prop_types__["func"]]).isRequired,
        onScroll: __WEBPACK_IMPORTED_MODULE_1_prop_types__["func"],
        onItemsRendered: __WEBPACK_IMPORTED_MODULE_1_prop_types__["func"],
        overscanCount: __WEBPACK_IMPORTED_MODULE_1_prop_types__["number"],
        renderItem: __WEBPACK_IMPORTED_MODULE_1_prop_types__["func"].isRequired,
        scrollOffset: __WEBPACK_IMPORTED_MODULE_1_prop_types__["number"],
        scrollToIndex: __WEBPACK_IMPORTED_MODULE_1_prop_types__["number"],
        scrollToAlignment: Object(__WEBPACK_IMPORTED_MODULE_1_prop_types__["oneOf"])([ALIGNMENT.AUTO, ALIGNMENT.START, ALIGNMENT.CENTER, ALIGNMENT.END]),
        scrollDirection: Object(__WEBPACK_IMPORTED_MODULE_1_prop_types__["oneOf"])([DIRECTION.HORIZONTAL, DIRECTION.VERTICAL]),
        stickyIndices: Object(__WEBPACK_IMPORTED_MODULE_1_prop_types__["arrayOf"])(__WEBPACK_IMPORTED_MODULE_1_prop_types__["number"]),
        style: __WEBPACK_IMPORTED_MODULE_1_prop_types__["object"],
        width: Object(__WEBPACK_IMPORTED_MODULE_1_prop_types__["oneOfType"])([__WEBPACK_IMPORTED_MODULE_1_prop_types__["number"], __WEBPACK_IMPORTED_MODULE_1_prop_types__["string"]])
    };
    return VirtualList;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);


/* harmony default export */ __webpack_exports__["a"] = (VirtualList);


/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(9)

/**
 * @category Month Helpers
 * @summary Return the start of a month for the given date.
 *
 * @description
 * Return the start of a month for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the start of a month
 *
 * @example
 * // The start of a month for 2 September 2014 11:55:00:
 * var result = startOfMonth(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Mon Sep 01 2014 00:00:00
 */
function startOfMonth (dirtyDate) {
  var date = parse(dirtyDate)
  date.setDate(1)
  date.setHours(0, 0, 0, 0)
  return date
}

module.exports = startOfMonth


/***/ }),
/* 614 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export enhanceDay */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return withDateSelection; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_recompose_withState__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_recompose_withState___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_recompose_withState__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_recompose_withPropsOnChange__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_recompose_withPropsOnChange___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_recompose_withPropsOnChange__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_recompose_withProps__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_recompose_withProps___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_recompose_withProps__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_recompose_compose__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_recompose_compose___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_recompose_compose__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4____ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_date_fns_format__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_date_fns_format___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_date_fns_format__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_date_fns_parse__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_date_fns_parse___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_date_fns_parse__);





function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






var enhanceDay = __WEBPACK_IMPORTED_MODULE_1_recompose_withPropsOnChange___default()(['selected'], function (props) {
  return {
    isSelected: props.selected === props.date
  };
});

var enhanceYear = __WEBPACK_IMPORTED_MODULE_1_recompose_withPropsOnChange___default()(['selected'], function (_ref) {
  var selected = _ref.selected;
  return {
    selected: __WEBPACK_IMPORTED_MODULE_7_date_fns_parse___default()(selected)
  };
});

// Enhancer to handle selecting and displaying a single date
var withDateSelection = __WEBPACK_IMPORTED_MODULE_3_recompose_compose___default()(__WEBPACK_IMPORTED_MODULE_4____["b" /* withDefaultProps */], Object(__WEBPACK_IMPORTED_MODULE_5__utils__["n" /* withImmutableProps */])(function (_ref2) {
  var DayComponent = _ref2.DayComponent,
      onSelect = _ref2.onSelect,
      setScrollDate = _ref2.setScrollDate,
      YearsComponent = _ref2.YearsComponent;
  return {
    DayComponent: enhanceDay(DayComponent),
    YearsComponent: enhanceYear(YearsComponent)
  };
}), __WEBPACK_IMPORTED_MODULE_0_recompose_withState___default()('scrollDate', 'setScrollDate', function (props) {
  return props.selected || new Date();
}), __WEBPACK_IMPORTED_MODULE_2_recompose_withProps___default()(function (_ref3) {
  var _onSelect = _ref3.onSelect,
      setScrollDate = _ref3.setScrollDate,
      props = _objectWithoutProperties(_ref3, ['onSelect', 'setScrollDate']);

  var selected = Object(__WEBPACK_IMPORTED_MODULE_5__utils__["l" /* sanitizeDate */])(props.selected, props);

  return {
    passThrough: {
      Day: {
        onClick: _onSelect
      },
      Years: {
        onSelect: function onSelect(year) {
          return handleYearSelect(year, { onSelect: _onSelect, selected: selected, setScrollDate: setScrollDate });
        }
      }
    },
    selected: selected && __WEBPACK_IMPORTED_MODULE_6_date_fns_format___default()(selected, 'YYYY-MM-DD')
  };
}));


function handleYearSelect(date, _ref4) {
  var setScrollDate = _ref4.setScrollDate,
      selected = _ref4.selected,
      onSelect = _ref4.onSelect;

  var newDate = __WEBPACK_IMPORTED_MODULE_7_date_fns_parse___default()(date);

  onSelect(newDate);
  setScrollDate(newDate);
}

/***/ }),
/* 615 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{value:'validationError',displayValue:'Please select'},{value:'ZNC',displayValue:'Any country not on this list'},{value:'ABW',displayValue:'Aruba'},{value:'AFG',displayValue:'Afghanistan'},{value:'AGO',displayValue:'Angola'},{value:'AIA',displayValue:'Anguilla'},{value:'ALA',displayValue:'Åland Islands'},{value:'ALB',displayValue:'Albania'},{value:'AND',displayValue:'Andorra'},{value:'ANT',displayValue:'Netherlands Antilles'},{value:'ARE',displayValue:'United Arab Emirates'},{value:'ARG',displayValue:'Argentina'},{value:'ARM',displayValue:'Armenia'},{value:'ASM',displayValue:'American Samoa'},{value:'ATA',displayValue:'Antarctica'},{value:'ATF',displayValue:'French Southern Territories  TF'},{value:'ATG',displayValue:'Antigua and Barbuda'},{value:'AUS',displayValue:'Australia'},{value:'AUT',displayValue:'Austria'},{value:'AZE',displayValue:'Azerbaijan'},{value:'BDI',displayValue:'Burundi'},{value:'BEL',displayValue:'Belgium'},{value:'BEN',displayValue:'Benin'},{value:'BFA',displayValue:'Burkina Faso'},{value:'BGD',displayValue:'Bangladesh'},{value:'BGR',displayValue:'Bulgaria'},{value:'BHR',displayValue:'Bahrain'},{value:'BHS',displayValue:'Bahamas'},{value:'BIH',displayValue:'Bosnia and Herzegovina'},{value:'BLR',displayValue:'Belarus'},{value:'BLZ',displayValue:'Belize'},{value:'BMU',displayValue:'Bermuda'},{value:'BOL',displayValue:'Bolivia'},{value:'BRA',displayValue:'Brazil'},{value:'BRB',displayValue:'Barbados'},{value:'BRN',displayValue:'Brunei Darussalam'},{value:'BTN',displayValue:'Bhutan'},{value:'BVT',displayValue:'Bouvet Island'},{value:'BWA',displayValue:'Botswana'},{value:'CAF',displayValue:'Central African Republic'},{value:'CAN',displayValue:'Canada'},{value:'CCK',displayValue:'Cocos Keeling Island'},{value:'CHE',displayValue:'Switzerland'},{value:'CHL',displayValue:'Chile'},{value:'CHN',displayValue:'China'},{value:'CIV',displayValue:'Côte dIvoire'},{value:'CMR',displayValue:'Cameroon'},{value:'COD',displayValue:'Democratic Republic of the Congo'},{value:'COG',displayValue:'Congo'},{value:'COK',displayValue:'Cook Islands'},{value:'COL',displayValue:'Colombia'},{value:'COM',displayValue:'Comoros'},{value:'CPV',displayValue:'Cape Verde'},{value:'CRI',displayValue:'Costa Rica'},{value:'CUB',displayValue:'Cuba'},{value:'CXR',displayValue:'Christmas Island'},{value:'CYM',displayValue:'Cayman Islands'},{value:'CYP',displayValue:'Cyprus'},{value:'CZE',displayValue:'Czech Republic'},{value:'DEU',displayValue:'Germany'},{value:'DJI',displayValue:'Djibouti'},{value:'DMA',displayValue:'Dominica'},{value:'DNK',displayValue:'Denmark'},{value:'DOM',displayValue:'Dominican Republic'},{value:'DZA',displayValue:'Algeria'},{value:'ECU',displayValue:'Ecuador'},{value:'EGY',displayValue:'Egypt'},{value:'ERI',displayValue:'Eritrea'},{value:'ESH',displayValue:'Western Sahara'},{value:'ESP',displayValue:'Spain'},{value:'EST',displayValue:'Estonia'},{value:'ETH',displayValue:'Ethiopia'},{value:'FIN',displayValue:'Finland'},{value:'FJI',displayValue:'Fiji'},{value:'FLK',displayValue:'Falkland Islands Malvinas'},{value:'FRA',displayValue:'France'},{value:'FRO',displayValue:'Faroe Islands'},{value:'FSM',displayValue:'Micronesia Federated States of'},{value:'FXX',displayValue:'France Metropolitan'},{value:'GAB',displayValue:'Gabon'},{value:'GBD',displayValue:'United Kingdom of Great Britain Dependent Territories Citizen'},{value:'GBN',displayValue:'United Kingdom of Great Britain National Overseas'},{value:'GBO',displayValue:'United Kingdom of Great Britain Overseas citizen'},{value:'GBP',displayValue:'United Kingdom of Great Britain Protected person'},{value:'GBR',displayValue:'United Kingdom of Great Britain Citizen'},{value:'GBS',displayValue:'United Kingdom of Great Britain Subject'},{value:'GEO',displayValue:'Georgia'},{value:'GGY',displayValue:'Guernsey'},{value:'GHA',displayValue:'Ghana'},{value:'GIB',displayValue:'Gibraltar'},{value:'GIN',displayValue:'Guinea'},{value:'GLP',displayValue:'Guadeloupe'},{value:'GMB',displayValue:'Gambia'},{value:'GNB',displayValue:'GuineaBissau'},{value:'GNQ',displayValue:'Equatorial Guinea'},{value:'GRC',displayValue:'Greece'},{value:'GRD',displayValue:'Grenada'},{value:'GRL',displayValue:'Greenland'},{value:'GTM',displayValue:'Guatemala'},{value:'GUF',displayValue:'French Guiana'},{value:'GUM',displayValue:'Guam'},{value:'GUY',displayValue:'Guyana'},{value:'HKG',displayValue:'Hong Kong Special Administrative Region of China'},{value:'HMD',displayValue:'Heard and McDonald Islands'},{value:'HND',displayValue:'Honduras'},{value:'HRV',displayValue:'Croatia'},{value:'HTI',displayValue:'Haiti'},{value:'HUN',displayValue:'Hungary'},{value:',displayValueN',displayValue:'Indonesia'},{value:'IMN',displayValue:'Isle of Man'},{value:'IND',displayValue:'India'},{value:'IOT',displayValue:'British Indian Ocean Territory'},{value:'IRL',displayValue:'Ireland'},{value:'IRN',displayValue:'Iran Islamic Republic of'},{value:'IRQ',displayValue:'Iraq'},{value:'ISL',displayValue:'Iceland'},{value:'ISR',displayValue:'Israel'},{value:'ITA',displayValue:'Italy'},{value:'JAM',displayValue:'Jamaica'},{value:'JEY',displayValue:'Jersey'},{value:'JOR',displayValue:'Jordan'},{value:'JPN',displayValue:'Japan'},{value:'KAZ',displayValue:'Kazakhstan'},{value:'KEN',displayValue:'Kenya'},{value:'KGZ',displayValue:'Kyrgyzstan'},{value:'KHM',displayValue:'Cambodia'},{value:'KIR',displayValue:'Kiribati'},{value:'KNA',displayValue:'Saint Kitts and Nevis'},{value:'KOR',displayValue:'Republic of Korea'},{value:'KWT',displayValue:'Kuwait'},{value:'LAO',displayValue:'Lao Peoples Democratic Republic'},{value:'LBN',displayValue:'Lebanon'},{value:'LBR',displayValue:'Liberia'},{value:'LBY',displayValue:'Libyan Arab Jamahiriya'},{value:'LCA',displayValue:'Saint Lucia'},{value:'LIE',displayValue:'Liechtenstein'},{value:'LKA',displayValue:'Sri Lanka'},{value:'LSO',displayValue:'Lesotho'},{value:'LTU',displayValue:'Lithuania'},{value:'LUX',displayValue:'Luxembourg'},{value:'LVA',displayValue:'Latvia'},{value:'MAC',displayValue:'Macao Special Administrative Region of China'},{value:'MAR',displayValue:'Morocco'},{value:'MCO',displayValue:'Monaco'},{value:'MDA',displayValue:'Moldova'},{value:'MDG',displayValue:'Madagascar'},{value:'MDV',displayValue:'Maldives'},{value:'MEX',displayValue:'Mexico'},{value:'MHL',displayValue:'Marshall Islands'},{value:'MKD',displayValue:'The former Yugoslav Republic of Macedonia'},{value:'MLI',displayValue:'Mali'},{value:'MLT',displayValue:'Malta'},{value:'MMR',displayValue:'Myanmar'},{value:'MNE',displayValue:'Montenegro'},{value:'MNG',displayValue:'Mongolia'},{value:'MNP',displayValue:'Northern Mariana Islands'},{value:'MOZ',displayValue:'Mozambique'},{value:'MRT',displayValue:'Mauritania'},{value:'MSR',displayValue:'Montserrat'},{value:'MTQ',displayValue:'Martinique'},{value:'MUS',displayValue:'Mauritius'},{value:'MWI',displayValue:'Malawi'},{value:'MYS',displayValue:'Malaysia'},{value:'MYT',displayValue:'Mayotte'},{value:'NAM',displayValue:'Namibia'},{value:'NCL',displayValue:'New Caledonia'},{value:'NER',displayValue:'Niger'},{value:'NFK',displayValue:'Norfolk Island'},{value:'NGA',displayValue:'Nigeria'},{value:'NIC',displayValue:'Nicaragua'},{value:'NIU',displayValue:'Niue'},{value:'NLD',displayValue:'Netherlands'},{value:'NOR',displayValue:'Norway'},{value:'NPL',displayValue:'Nepal'},{value:'NRU',displayValue:'Nauru'},{value:'NTZ',displayValue:'Neutral Zone'},{value:'NZL',displayValue:'New Zealand'},{value:'OMN',displayValue:'Oman'},{value:'PAK',displayValue:'Pakistan'},{value:'PAN',displayValue:'Panama'},{value:'PCN',displayValue:'Pitcairn'},{value:'PER',displayValue:'Peru'},{value:'PHL',displayValue:'Philippines'},{value:'PLW',displayValue:'Palau'},{value:'PNG',displayValue:'Papua New Guinea'},{value:'POL',displayValue:'Poland'},{value:'PRI',displayValue:'Puerto Rico'},{value:'PRK',displayValue:'Democratic Peoples Republic of Korea'},{value:'PRT',displayValue:'Portugal'},{value:'PRY',displayValue:'Paraguay'},{value:'PSE',displayValue:'Occupied Palestinian Territory'},{value:'PYF',displayValue:'French Polynesia'},{value:'QAT',displayValue:'Qatar'},{value:'REU',displayValue:'Réunion'},{value:'ROU',displayValue:'Romania'},{value:'RUS',displayValue:'Russian Federation'},{value:'RWA',displayValue:'Rwanda'},{value:'SAU',displayValue:'Saudi Arabia'},{value:'SDN',displayValue:'Sudan'},{value:'SEN',displayValue:'Senegal'},{value:'SGP',displayValue:'Singapore'},{value:'SGS',displayValue:'South Georgia and South Sandwich Is'},{value:'SHN',displayValue:'Saint Helena'},{value:'SJM',displayValue:'Svalbard and Jan Mayen Islands'},{value:'SLB',displayValue:'Solomon Islands'},{value:'SLE',displayValue:'Sierra Leone'},{value:'SLV',displayValue:'El Salvador'},{value:'SMR',displayValue:'San Marino'},{value:'SOM',displayValue:'Somalia'},{value:'SPM',displayValue:'Saint Pierre and Miquelon'},{value:'SRB',displayValue:'Serbia'},{value:'STP',displayValue:'Sao Tome and Principe'},{value:'SUR',displayValue:'Suriname'},{value:'SVK',displayValue:'Slovakia'},{value:'SVN',displayValue:'Slovenia'},{value:'SWE',displayValue:'Sweden'},{value:'SWZ',displayValue:'Swaziland'},{value:'SYC',displayValue:'Seychelles'},{value:'SYR',displayValue:'Syrian Arab Republic'},{value:'TCA',displayValue:'Turks and Caicos Islands'},{value:'TCD',displayValue:'Chad'},{value:'TGO',displayValue:'Togo'},{value:'THA',displayValue:'Thailand'},{value:'TJK',displayValue:'Tajikistan'},{value:'TKL',displayValue:'Tokelau'},{value:'TKM',displayValue:'Turkmenistan'},{value:'TLS',displayValue:'TimorLeste'},{value:'TON',displayValue:'Tonga'},{value:'TTO',displayValue:'Trin,displayValuead and Tobago'},{value:'TUN',displayValue:'Tunisia'},{value:'TUR',displayValue:'Turkey'},{value:'TUV',displayValue:'Tuvalu'},{value:'TWN',displayValue:'Taiwan Province of China'},{value:'TZA',displayValue:'United Republic of Tanzania'},{value:'UGA',displayValue:'Uganda'},{value:'UKR',displayValue:'Ukraine'},{value:'UMI',displayValue:'US Minor Outlying Islands'},{value:'URY',displayValue:'Uruguay'},{value:'USA',displayValue:'United States of America'},{value:'UZB',displayValue:'Uzbekistan'},{value:'VAT',displayValue:'Vatican City'},{value:'VCT',displayValue:'Saint Vincent and the Grenadines'},{value:'VEN',displayValue:'Venezuela'},{value:'VGB',displayValue:'Virgin Islands British'},{value:'VIR',displayValue:'Virgin Islands United States'},{value:'VNM',displayValue:'Viet Nam'},{value:'VUT',displayValue:'Vanuatu'},{value:'WLF',displayValue:'Wallis and Futuna Islands'},{value:'WSM',displayValue:'Samoa'},{value:'YEM',displayValue:'Yemen'},{value:'ZAF',displayValue:'South Africa'},{value:'ZMB',displayValue:'Zambia'},{value:'ZWE',displayValue:'Zimbabwe'}]);

/***/ }),
/* 616 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_core__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/*eslint-disable*/var styles=function styles(theme){return{textField:{width:"100%",marginTop:0,marginBottom:0}};};var grandSeperator=function grandSeperator(val){val=val.replace(/,/g,"").replace(/ /g,"");var parsed=parseFloat(val);if(!isNaN(parsed)){return parsed.toLocaleString().replace(/,/g," ");}else{return val;}};var GrandInput=function(_React$Component){_inherits(GrandInput,_React$Component);function GrandInput(props){_classCallCheck(this,GrandInput);var _this=_possibleConstructorReturn(this,(GrandInput.__proto__||Object.getPrototypeOf(GrandInput)).call(this,props));_this.handleChange=function(event){event.preventDefault();if(_this.props.input.onChange&&!_this.props.readOnly){_this.props.input.onChange(event);_this.props.input.onBlur(event);}};_this.handleChange=_this.handleChange.bind(_this);return _this;}_createClass(GrandInput,[{key:"componentWillReceiveProps",value:function componentWillReceiveProps(nextProps){if(nextProps.meta.touched||nextProps.input.value!==this.props.input.value||nextProps.p_value!==this.props.p_value){this.forceUpdate();}}},{key:"shouldComponentUpdate",value:function shouldComponentUpdate(){return true;}},{key:"render",value:function render(){this.props.meta.valid=false;var trySubmit=this.props.checkValidation?true:false;var _props$meta=this.props.meta,touched=_props$meta.touched,error=_props$meta.error,warning=_props$meta.warning;var lValue=this.props.fixedValue?this.props.fixedValue:this.props.input.value;//default lOutputComponent
var lOutputComponent=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["X" /* TextField */],{onChange:this.handleChange,id:this.props.input.name,value:grandSeperator(lValue),label:this.props.label,className:this.props.classes.textField,margin:"normal"});if(lValue){lOutputComponent=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["X" /* TextField */],{onChange:this.handleChange,id:this.props.input.name,value:grandSeperator(lValue),label:this.props.label,className:this.props.classes.textField,margin:"normal",error:error&&error.length>0&&touched?true:error&&error.length>0&&trySubmit?true:false,helperText:error&&touched||error&&trySubmit?error:null});}else{lOutputComponent=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["X" /* TextField */],{onChange:this.handleChange,id:this.props.input.name,value:grandSeperator(lValue),label:this.props.label,className:this.props.classes.textField,margin:"normal",error:error&&error.length>0&&touched?true:error&&error.length>0&&trySubmit?true:false,helperText:error&&error.length>0&&touched||error&&error.length>0&&trySubmit?error:null});}return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",null,lOutputComponent);}}]);return GrandInput;}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["_1" /* withStyles */])(styles)(GrandInput));

/***/ }),
/* 617 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_autosuggest__ = __webpack_require__(2421);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_autosuggest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_autosuggest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_store__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Autofill_css__ = __webpack_require__(2433);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Autofill_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Autofill_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/*eslint-disable*/// Teach Autosuggest how to calculate suggestions for any given input value.
var getSuggestions=function getSuggestions(value){var inputValue=value.trim().toLowerCase();var inputLength=inputValue.length;return inputLength===0?[]:__WEBPACK_IMPORTED_MODULE_2_store__["a" /* default */].getState().occupations.occupations.filter(function(occ){return occ.name.toLowerCase().includes(inputValue);});};// When suggestion is clicked, Autosuggest needs to populate the input
// based on the clicked suggestion. Teach Autosuggest how to calculate the
// input value for every given suggestion.
var getSuggestionValue=function getSuggestionValue(suggestion){return suggestion.name;};// Use your imagination to render suggestions.
var renderSuggestion=function renderSuggestion(suggestion){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",null,suggestion.name);};var Autofill=function(_React$Component){_inherits(Autofill,_React$Component);function Autofill(props){_classCallCheck(this,Autofill);var _this=_possibleConstructorReturn(this,(Autofill.__proto__||Object.getPrototypeOf(Autofill)).call(this,props));_this.onChange=function(event,_ref){var newValue=_ref.newValue;_this.setState({value:newValue});_this.props.input.onChange(newValue);};_this.onSuggestionsFetchRequested=function(_ref2){var value=_ref2.value;_this.setState({suggestions:getSuggestions(value)});};_this.onSuggestionsClearRequested=function(){_this.setState({suggestions:[]});};_this.state={value:"",suggestions:[]};return _this;}// Autosuggest will call this function every time you need to update suggestions.
// You already implemented this logic above, so just use it.
// Autosuggest will call this function every time you need to clear suggestions.
_createClass(Autofill,[{key:"isrequired",value:function isrequired(id){return this.props.isrequired;}},{key:"render",value:function render(){if(this.props.meta.pristine){this.props.meta.valid=false;}if(this.isrequired(this.props.input.isrequired)==false){this.props.meta.valid=true;}var _state=this.state,value=_state.value,suggestions=_state.suggestions;var trySubmit=this.props.checkValidation?true:false;var _props$meta=this.props.meta,touched=_props$meta.touched,error=_props$meta.error,warning=_props$meta.warning;var lValue=this.props.input.value;var inputProps={placeholder:"Type an occupation",value:lValue,onChange:this.onChange};return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_autosuggest___default.a,{suggestions:suggestions,onSuggestionsFetchRequested:this.onSuggestionsFetchRequested.bind(this),onSuggestionsClearRequested:this.onSuggestionsClearRequested,getSuggestionValue:getSuggestionValue,renderSuggestion:renderSuggestion,inputProps:inputProps}));}}]);return Autofill;}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);/* unused harmony default export */ var _unused_webpack_default_export = (Autofill);

/***/ }),
/* 618 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_core__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/*eslint-disable*/var styles=function styles(theme){return{textField:{width:"100%",marginTop:0,marginBottom:0}};};function isEmptyOrSpaces(str){return str===undefined||str===null||str.match(/^ *$/)!==null;}var AutofillV2=function(_React$Component){_inherits(AutofillV2,_React$Component);function AutofillV2(props){_classCallCheck(this,AutofillV2);var _this=_possibleConstructorReturn(this,(AutofillV2.__proto__||Object.getPrototypeOf(AutofillV2)).call(this,props));_this.state={listOpen:false};_this.handleChange=function(event){event.preventDefault();_this.setState({listOpen:true});if(_this.props.input.onChange&&!_this.props.readOnly){_this.props.input.onChange(event);_this.props.input.onBlur(event);_this.props.textChanged(event);}};_this.setListOpen=function(){_this.setState({listOpen:true});};_this.selectItem=function(value){_this.setState({listOpen:false});_this.props.input.onChange(value);_this.props.onItemSelect();};_this.handleChange=_this.handleChange.bind(_this);_this.setWrapperRef=_this.setWrapperRef.bind(_this);_this.handleClickOutside=_this.handleClickOutside.bind(_this);return _this;}_createClass(AutofillV2,[{key:"componentDidMount",value:function componentDidMount(){document.addEventListener("mousedown",this.handleClickOutside);}},{key:"componentWillUnmount",value:function componentWillUnmount(){document.removeEventListener("mousedown",this.handleClickOutside);}},{key:"componentWillReceiveProps",value:function componentWillReceiveProps(nextProps){if(nextProps.meta.touched||nextProps.input.value!==this.props.input.value||nextProps.p_value!==this.props.p_value){this.forceUpdate();}}},{key:"shouldComponentUpdate",value:function shouldComponentUpdate(){return true;}},{key:"setWrapperRef",value:function setWrapperRef(node){this.wrapperRef=node;}},{key:"handleClickOutside",value:function handleClickOutside(event){if(this.wrapperRef&&!this.wrapperRef.contains(event.target)){this.setState({listOpen:false});}}},{key:"render",value:function render(){var _this2=this;this.props.meta.valid=false;var trySubmit=this.props.checkValidation?true:false;var _props$meta=this.props.meta,touched=_props$meta.touched,error=_props$meta.error,warning=_props$meta.warning;var selectableItems=[];var lValue=this.props.fixedValue?this.props.fixedValue:this.props.input.value?this.props.input.value:"";var searchForOccupations=false;if(!isEmptyOrSpaces(lValue)&&lValue.length>2){if(this.props.autoFillList.length>0){searchForOccupations=true;selectableItems=this.props.autoFillList.filter(function(a){return a.name.toLowerCase().includes(lValue.toLowerCase());});}}var notFound=searchForOccupations&&!this.state.listOpen&&selectableItems.length<1?true:false;var lOutputComponent=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{ref:this.setWrapperRef},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["X" /* TextField */],{onMouseDown:function onMouseDown(){return _this2.setListOpen();},onChange:this.handleChange,id:this.props.input.name,value:lValue,label:this.props.label,className:this.props.classes.textField,margin:"normal",error:notFound?true:error&&error.length>0&&touched?true:error&&error.length>0&&trySubmit?true:false,helperText:notFound?"Invalid Occupation":error&&touched||error&&trySubmit?error:null,placeholder:this.props.placeholder}),searchForOccupations&&this.state.listOpen?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"autofillBox"},selectableItems.length<1?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{padding:"10px",color:"red"},variant:"body1"},"No occupations found"):null,selectableItems.map(function(s){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"autofillItem",onClick:function onClick(){return _this2.selectItem(s.name);}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{padding:"10px"},variant:"body1"},s.name));})):null);return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",null,lOutputComponent);}}]);return AutofillV2;}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["_1" /* withStyles */])(styles)(AutofillV2));

/***/ }),
/* 619 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SendAppInvite; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_graphql_tag__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_graphql_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_graphql_tag__);
var _templateObject=_taggedTemplateLiteral(["\n  mutation SendAppInvite($input: SendAppInviteInput!) {\n    SendAppInvite(input: $input) {\n      clientMutationId\n    }\n  }\n"],["\n  mutation SendAppInvite($input: SendAppInviteInput!) {\n    SendAppInvite(input: $input) {\n      clientMutationId\n    }\n  }\n"]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var SendAppInvite=__WEBPACK_IMPORTED_MODULE_0_graphql_tag___default()(_templateObject);

/***/ }),
/* 620 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_core__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/*eslint-disable*/var styles=function styles(theme){return{textField:{width:'100%',marginTop:0,marginBottom:0}};};function isEmptyOrSpaces(str){return str===undefined||str===null||str.toString().match(/^ *$/)!==null;}var AutofillV3=function(_React$Component){_inherits(AutofillV3,_React$Component);function AutofillV3(props){_classCallCheck(this,AutofillV3);var _this=_possibleConstructorReturn(this,(AutofillV3.__proto__||Object.getPrototypeOf(AutofillV3)).call(this,props));_this.state={listOpen:false};_this.handleChange=function(event){event.preventDefault();_this.setState({listOpen:true});if(_this.props.input.onChange&&!_this.props.readOnly){_this.props.input.onChange(event);_this.props.input.onBlur(event);}};_this.setListOpen=function(){_this.setState({listOpen:true});};_this.selectItem=function(displayText,value){_this.setState({listOpen:false});_this.props.input.onChange(displayText);_this.props.onItemSelect(displayText,value);};_this.handleChange=_this.handleChange.bind(_this);_this.setWrapperRef=_this.setWrapperRef.bind(_this);_this.handleClickOutside=_this.handleClickOutside.bind(_this);return _this;}_createClass(AutofillV3,[{key:'componentDidMount',value:function componentDidMount(){document.addEventListener('mousedown',this.handleClickOutside);}},{key:'componentWillUnmount',value:function componentWillUnmount(){document.removeEventListener('mousedown',this.handleClickOutside);}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(nextProps.meta.touched||nextProps.input.value!==this.props.input.value||nextProps.p_value!==this.props.p_value){this.forceUpdate();}}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(){return true;}},{key:'setWrapperRef',value:function setWrapperRef(node){this.wrapperRef=node;}},{key:'handleClickOutside',value:function handleClickOutside(event){if(this.wrapperRef&&!this.wrapperRef.contains(event.target)){this.setState({listOpen:false});}}},{key:'render',value:function render(){var _this2=this;this.props.meta.valid=false;var trySubmit=this.props.checkValidation?true:false;var _props$meta=this.props.meta,touched=_props$meta.touched,error=_props$meta.error,warning=_props$meta.warning;var lValue=this.props.fixedValue?this.props.fixedValue:this.props.input.value?this.props.input.value:'';var searchForItems=false;if(!isEmptyOrSpaces(lValue)&&lValue.length>2){if(this.props.autoFillList.length>0){searchForItems=true;}}var lOutputComponent=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{ref:this.setWrapperRef},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["X" /* TextField */],{onMouseDown:function onMouseDown(){return _this2.setListOpen();},onChange:this.handleChange,id:this.props.input.name,value:lValue,label:this.props.label,className:this.props.classes.textField,margin:'normal',error:error&&error.length>0&&touched?true:error&&error.length>0&&trySubmit?true:false,helperText:error&&touched||error&&trySubmit?error:null,placeholder:this.props.placeholder}),lValue.length>2&&this.props.autoFillList&&this.state.listOpen?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'autofillList',style:{zIndex:this.props.zIndex?this.props.zIndex:'auto',position:this.props.absolute?'absolute':'relative'}},this.props.loading?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{textAlign:'center',width:'100%',marginTop:'5px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["j" /* CircularProgress */],{size:25})):null,this.props.autoFillList.length<1&&!this.props.loading?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{padding:'10px',color:'red'},variant:'body1'},'No ',this.props.listName,' Found'):null,this.props.autoFillList.map(function(a,i){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{key:i,className:'autofillItem',onClick:function onClick(){return _this2.selectItem(a[_this2.props.displayText],a.id);}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{padding:'10px'},variant:'body1'},a[_this2.props.displayText],__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{variant:'caption'},a[_this2.props.subText])));})):null);return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,lOutputComponent);}}]);return AutofillV3;}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["_1" /* withStyles */])(styles)(AutofillV3));

/***/ }),
/* 621 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = TestNullOrReturn;
/* harmony export (immutable) */ __webpack_exports__["b"] = v;
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function TestNullOrReturn(value,edge){if(value===null||value===undefined){return edge;}else{return value;}}function isEmptyOrSpaces(str){return str===null||str.match(/^ *$/)!==null;}function v(field,value){if(value&&!isEmptyOrSpaces(value.toString())){return _defineProperty({},field,value);}else{return{};}}

/***/ }),
/* 622 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_core__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_apollo_cache_inmemory__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_apollo_client__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_apollo_upload_client__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_assets_img_faces_avatar1_jpg__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_assets_img_faces_avatar1_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_assets_img_faces_avatar1_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_Wrappers_materialUIWrappers_components_FormDropDown__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_Wrappers_materialUIWrappers_components_FormInput__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_constants_js__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_helpers_GetIdInformation__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_helpers_ValidationHelpers__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_dropzone__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_redux_form__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_store__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__FieldIndicators_jsx__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__coi_options__ = __webpack_require__(615);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__CC_clientOccForm_EliteWealth__ = __webpack_require__(395);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/*eslint-disable*/var client=new __WEBPACK_IMPORTED_MODULE_2_apollo_client__["ApolloClient"]({link:Object(__WEBPACK_IMPORTED_MODULE_3_apollo_upload_client__["a" /* createUploadLink */])({uri:__WEBPACK_IMPORTED_MODULE_7_constants_js__["d" /* fileUploadServerPath */]}),cache:new __WEBPACK_IMPORTED_MODULE_1_apollo_cache_inmemory__["a" /* InMemoryCache */]()});var required=function required(value){return value?undefined:'Required';};var requiredDropdown=function requiredDropdown(value){if(!value||value==='validationError'){return'Required';}return undefined;};var charMin2=function charMin2(value){if(value===undefined)return undefined;if(value.length<2)return'Must be at least 2 characters';return undefined;};var styles=function styles(){return{};};var CC_clientForm_EliteWealth=function(_React$Component){_inherits(CC_clientForm_EliteWealth,_React$Component);function CC_clientForm_EliteWealth(){var _ref;var _temp,_this,_ret;_classCallCheck(this,CC_clientForm_EliteWealth);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=CC_clientForm_EliteWealth.__proto__||Object.getPrototypeOf(CC_clientForm_EliteWealth)).call.apply(_ref,[this].concat(args))),_this),_this.state={idValid:false,idChanged:false},_this.idChanged=function(value){var x=Object(__WEBPACK_IMPORTED_MODULE_8_helpers_GetIdInformation__["a" /* default */])(value);if(x==='error'){return;}__WEBPACK_IMPORTED_MODULE_14_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_13_redux_form__["b" /* change */])('client','dateOfBirth',x.dob));__WEBPACK_IMPORTED_MODULE_14_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_13_redux_form__["b" /* change */])('client','gender',x.gender));_this.props.dobChanged(x.dob);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(CC_clientForm_EliteWealth,[{key:'componentDidMount',value:function componentDidMount(){this.props.scrollMeBar();}},{key:'genderChanged',value:function genderChanged(gender){var title=__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.get(__WEBPACK_IMPORTED_MODULE_14_store__["a" /* default */].getState().form.client,'values.title',null);if(title&&gender){__WEBPACK_IMPORTED_MODULE_14_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_13_redux_form__["b" /* change */])('client','title',gender==='F'?'MS':'MR'));}this.forceUpdate();}},{key:'render',value:function render(){var _this2=this;var validate=[];validate.push(required);var marriedOptions=null;var idOptions=null;var gender=__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.get(__WEBPACK_IMPORTED_MODULE_14_store__["a" /* default */].getState().form.client,'values.gender',null);var hideFemaleOption=!gender?false:gender==='M'?true:false;var hideMaleOption=!gender?false:gender==='F'?true:false;var womanOptions=[{value:'MRS',displayValue:'MRS',hidden:hideFemaleOption},{value:'MISS',displayValue:'MISS',hidden:hideFemaleOption}];if(!hideFemaleOption&&__WEBPACK_IMPORTED_MODULE_14_store__["a" /* default */].getState().form.client&&__WEBPACK_IMPORTED_MODULE_14_store__["a" /* default */].getState().form.client.values){var mStatus=__WEBPACK_IMPORTED_MODULE_14_store__["a" /* default */].getState().form.client.values.maritalStatus;if(mStatus&&mStatus!=='validationError'){if(mStatus==='Married'){womanOptions=[{value:'MRS',displayValue:'MRS',hidden:hideFemaleOption}];}else{womanOptions=[{value:'MISS',displayValue:'MISS',hidden:hideFemaleOption}];}}}var titleOptions=[{value:'validationError',displayValue:'Please select'},{value:'MR',displayValue:'MR',hidden:hideMaleOption}].concat(_toConsumableArray(womanOptions),[{value:'MS',displayValue:'MS',hidden:hideFemaleOption},{value:'ADV',displayValue:'ADV'},{value:'DR',displayValue:'DR'},{value:'JUDG',displayValue:'JUDGE'},{value:'PROF',displayValue:'PROF'}]);if(this.props.saCitizen){idOptions=__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{item:true,xs:12,sm:6},__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["t" /* FormControl */],{fullWidth:true},__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_6_components_Wrappers_materialUIWrappers_components_FormInput__["a" /* default */],checkValidation:this.props.checkValidation,name:'said',label:'South African ID',validate:[__WEBPACK_IMPORTED_MODULE_8_helpers_GetIdInformation__["b" /* idNumberValid */]],onChange:function onChange(e){return _this2.idChanged(e.target.value);}}))));}else{idOptions=__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{item:true,xs:12,sm:6},__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["t" /* FormControl */],{fullWidth:true},__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_6_components_Wrappers_materialUIWrappers_components_FormInput__["a" /* default */],checkValidation:this.props.checkValidation,name:'passportNumber',label:'Pasport number'}))),__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{item:true,xs:12,sm:6},__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["t" /* FormControl */],{fullWidth:true},__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_5_components_Wrappers_materialUIWrappers_components_FormDropDown__["a" /* default */],options:__WEBPACK_IMPORTED_MODULE_16__coi_options__["a" /* default */],checkValidation:this.props.checkValidation,name:'countryOfIssue',label:'Pasport Country Of Issue'}))));}var age=__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.get(__WEBPACK_IMPORTED_MODULE_14_store__["a" /* default */].getState().form,'client.values.age',null);return __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement('div',{className:'contentWithStepper'},__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["e" /* Card */],null,__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["g" /* CardHeader */],{title:this.props.firstName+' '+this.props.lastName,style:{textAlign:'center'}}),__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["f" /* CardContent */],null,__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{container:true,spacing:24},__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{item:true,xs:12,sm:6,style:{display:'flex'}},__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["t" /* FormControl */],{fullWidth:true},__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_5_components_Wrappers_materialUIWrappers_components_FormDropDown__["a" /* default */],checkValidation:this.props.checkValidation,label:'Title *',name:'title',options:titleOptions,isrequired:true,validate:[requiredDropdown]}))),__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{item:true,xs:12,sm:6,style:{display:'flex'}},__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["t" /* FormControl */],{fullWidth:true},__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_6_components_Wrappers_materialUIWrappers_components_FormInput__["a" /* default */],isrequired:true,validate:[required,charMin2],checkValidation:this.props.checkValidation,name:'firstName',label:'First name *',onChange:function onChange(e){return _this2.props.changeFirstName(e.target.value);}}))),__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{item:true,xs:12,sm:6,style:{display:'flex'}},__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["t" /* FormControl */],{fullWidth:true},__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_6_components_Wrappers_materialUIWrappers_components_FormInput__["a" /* default */],isrequired:true,validate:[required,charMin2],checkValidation:this.props.checkValidation,name:'lastName',label:'Surname *',onChange:function onChange(e){return _this2.props.changeLastName(e.target.value);}}))),__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{item:true,xs:12,sm:6,style:{display:'flex'}},__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["t" /* FormControl */],{fullWidth:true},__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_redux_form__["a" /* Field */],{label:'Date of birth',name:'dateOfBirth',component:__WEBPACK_IMPORTED_MODULE_6_components_Wrappers_materialUIWrappers_components_FormInput__["a" /* default */],placeholder:'DD/MM/YYYY',validate:[__WEBPACK_IMPORTED_MODULE_9_helpers_ValidationHelpers__["a" /* dateValid */]],onChange:function onChange(e){return _this2.props.dobChanged(e.target.value);}})),Object(__WEBPACK_IMPORTED_MODULE_9_helpers_ValidationHelpers__["c" /* isEmptyOrSpaces */])(age)?__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement('div',{style:{height:'47px'}}):__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement('div',{className:'ageBlock'},__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{variant:'caption'},'Age'),__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],null,age))),__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{item:true,xs:12,sm:6,style:{display:'flex'}},__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["t" /* FormControl */],{fullWidth:true},__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_5_components_Wrappers_materialUIWrappers_components_FormDropDown__["a" /* default */],label:'Gender',name:'gender',options:[{value:'validationError',displayValue:'Please select'},{value:'M',displayValue:'Male'},{value:'F',displayValue:'Female'}],onValueChange:function onValueChange(e){return _this2.genderChanged(e);}}))),__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{item:true,xs:12,sm:6,style:{display:'flex'}},__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["t" /* FormControl */],{fullWidth:true},__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_5_components_Wrappers_materialUIWrappers_components_FormDropDown__["a" /* default */],checkValidation:this.props.checkValidation,label:'Smoker?',name:'smoker',options:[{value:'validationError',displayValue:'Please select'},{value:'N',displayValue:'No'},{value:'Y',displayValue:'Yes'}]}))),__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{item:true,xs:12,sm:6,style:{display:'flex'}},__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["t" /* FormControl */],{fullWidth:true},__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_5_components_Wrappers_materialUIWrappers_components_FormDropDown__["a" /* default */],checkValidation:this.props.checkValidation,label:'Marital Status',name:'maritalStatus',options:[{value:'validationError',displayValue:'Please select'},{value:'Single',displayValue:'Single'},{value:'Divorced',displayValue:'Divorced'},{value:'Married',displayValue:'Married'},{value:'Widowed',displayValue:'Widowed'}],onValueChange:function onValueChange(e){return _this2.props.maritalChangeHandler(e);}})))),__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement('br',null))));}}]);return CC_clientForm_EliteWealth;}(__WEBPACK_IMPORTED_MODULE_11_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["_1" /* withStyles */])(styles)(CC_clientForm_EliteWealth));

/***/ }),
/* 623 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_core__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_Divider__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_Divider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Divider__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_List__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_List___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_List__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_ListItem__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_ListItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_ListItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_ListItemText__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_ListItemText___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_ListItemText__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_EnhancedTableHead_EnhancedTableHead_jsx__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_Table_EmptyBody_jsx__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_helpers_UserHelper__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_queries_quotes_queries__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_apollo__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_router__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_CustomChip_CustomChip_jsx__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_queries_QuoteEligibility__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__material_ui_core_Grid__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__material_ui_core_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__material_ui_core_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react_bootstrap_sweetalert__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react_bootstrap_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_react_bootstrap_sweetalert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_assets_jss_material_dashboard_pro_react_views_sweetAlertStyle_jsx__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__material_ui_core_styles_withStyles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__material_ui_core_styles_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__material_ui_core_styles_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_react_router_dom__ = __webpack_require__(126);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var columnData=[{id:'edit',numeric:false,disablePadding:true,label:'',noSort:true,width:'30px'},{id:'description',numeric:false,disablePadding:true,label:'Description',noSort:true},{id:'t.date_created',numeric:false,disablePadding:true,label:'Date Created',noSort:true}];var QuotesTab_EliteWealth=function(_React$Component){_inherits(QuotesTab_EliteWealth,_React$Component);function QuotesTab_EliteWealth(props){_classCallCheck(this,QuotesTab_EliteWealth);var _this=_possibleConstructorReturn(this,(QuotesTab_EliteWealth.__proto__||Object.getPrototypeOf(QuotesTab_EliteWealth)).call(this,props));_this.state={openMenus:[],openMenusPage:0,anchorTop:0,anchorLeft:0,popoverOpen:false,assistantActive:false,eligibilityDialogOpen:false,invalidFields:[],selectedClient:{}};_this.handleClick=function(event,id){_this.setState({anchorTop:event.clientY,anchorLeft:event.clientX});var openMenus=_this.state.openMenus.slice();openMenus.filter(function(x){return x.id===id;})[0].open=true;_this.setState({openMenus:openMenus,popoverOpen:true});};_this.handleClose=function(id){var openMenus=_this.state.openMenus.slice();openMenus.filter(function(x){return x.id===id;})[0].open=false;_this.setState({openMenus:openMenus,popoverOpen:false});};_this.handleCloseAll=function(){var openMenus=_this.state.openMenus.slice();openMenus=openMenus.map(function(x){return x.open===false;});_this.setState({openMenus:openMenus,popoverOpen:false});};_this.getBrokerId=function(){var brokerId=Object(__WEBPACK_IMPORTED_MODULE_7_helpers_UserHelper__["a" /* GetUserId */])();if(_this.checkAssistantActive()){brokerId=sessionStorage.getItem('ActiveBrokerId');}return brokerId;};_this.getBrokerName=function(){return sessionStorage.getItem('ActiveBrokerName');};_this.handleNewQuote=function(clientId){_this.props.history.push({pathname:'/app/quote/',search:'clientId='+clientId});};_this.handleClick=_this.handleClick.bind(_this);return _this;}_createClass(QuotesTab_EliteWealth,[{key:'handleView',value:function handleView(quote){this.props.history.push({pathname:'/app/quoteresult',search:'guid='+quote.sq_taskguid});}},{key:'handleEdit',value:function handleEdit(clientId,guid){this.props.history.push({pathname:'/app/quote/',search:'clientId='+clientId+'&guid='+guid});}},{key:'checkAssistantActive',value:function checkAssistantActive(){if(Object(__WEBPACK_IMPORTED_MODULE_7_helpers_UserHelper__["b" /* GetUserKey */])('userType')==='6'){if(!this.state.assistantActive){this.setState({assistantActive:true});}return true;}return false;}},{key:'render',value:function render(){var _this2=this;var colSpan=Object.keys(columnData).length;var _props=this.props,clientId=_props.clientId,clientName=_props.clientName;return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react_apollo__["Query"],{query:__WEBPACK_IMPORTED_MODULE_8_queries_quotes_queries__["c" /* GetQuoteHistory */],variables:{brokerId:this.getBrokerId(),token:Object(__WEBPACK_IMPORTED_MODULE_7_helpers_UserHelper__["c" /* GetUserToken */])(),limit:7,page:0,clientId:clientId},fetchPolicy:'network-only'},function(_ref){var loading=_ref.loading,error=_ref.error,data=_ref.data,refetch=_ref.refetch;if(loading){return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["B" /* LinearProgress */],null);}if(error&&error.message&&error.message==='GraphQL error: invalid token'){Object(__WEBPACK_IMPORTED_MODULE_7_helpers_UserHelper__["d" /* Logout */])();return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_router__["a" /* Redirect */],{to:'/app/portal/login'});}if(error)return'Error! '+error.message;var items=data.QuoteHistory.Results;if(items&&_this2.state.openMenus.length!==items.length){var openMenus=[];items.map(function(q){openMenus.push({open:false,id:q.sq_taskguid});return q;});_this2.setState({openMenus:openMenus});}return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["e" /* Card */],{className:'contentWithStepper'},__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["g" /* CardHeader */],{title:'Quote History'})),__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],null),__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["I" /* Paper */],{style:{overflowX:'auto'}},__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Q" /* Table */],null,__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_EnhancedTableHead_EnhancedTableHead_jsx__["a" /* default */],{order:_this2.props.order,orderBy:_this2.props.orderBy,onRequestSort:function onRequestSort(event,property){return _this2.props.handleRequestSort(event,property);},rowCount:_this2.props.items?_this2.props.items.length:0,columnData:columnData}),__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["R" /* TableBody */],null,' ',__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react___default.a.Fragment,null,items.length<1?__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Table_EmptyBody_jsx__["a" /* default */],{colSpan:colSpan,rowSpan:3,placeHolder:__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{variant:'subheading'},'No Quotes created yet. Click on Create Quote')}):__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react___default.a.Fragment,null,items.map(function(quote){var openMenus=_this2.state.openMenus.length>0;var openMenu=null;if(openMenus){openMenu=_this2.state.openMenus.find(function(m){return m.id===quote.sq_taskguid;});}return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],{className:'sqDataTable',key:quote.id,onClick:function onClick(e){return _this2.state.popoverOpen===false?_this2.handleClick(e,quote.sq_taskguid):null;},style:openMenu&&openMenu.open?{backgroundColor:'#dedede'}:{}},__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{style:{padding:'0px',borderRight:'1px solid #e0e0e0',backgroundColor:'white'}},__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["x" /* IconButton */],{onClick:function onClick(e){return _this2.state.popoverOpen===false?_this2.handleClick(e,quote.sq_taskguid):null;}},__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["w" /* Icon */],null,'more_vert'))),__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,quote.description),__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,quote.date_created),__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["J" /* Popover */],{open:openMenu?openMenu.open:false,anchorReference:'anchorPosition',anchorPosition:{left:_this2.state.anchorLeft,top:_this2.state.anchorTop},onClose:function onClose(){return _this2.handleClose(quote.sq_taskguid);}},__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_List___default.a,{component:'nav'},__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_ListItem___default.a,{button:true,onClick:function onClick(){return _this2.handleView(quote);}},__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_ListItemText___default.a,{primary:'View Results'})),__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Divider___default.a,null),__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react_apollo__["Mutation"],{mutation:__WEBPACK_IMPORTED_MODULE_13_queries_QuoteEligibility__["a" /* QuoteEligibility */],onCompleted:function onCompleted(data){var quoteEligibility=data.QuoteEligibility;if(!quoteEligibility.valid){var invalidFields=quoteEligibility.invalidFields.split(',');_this2.setState({eligibilityDialogOpen:true,invalidFields:invalidFields,selectedClient:quote.fullName});}else{_this2.handleEdit(quote.fk_clientID,quote.sq_taskguid);}}},function(mutate){return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_ListItem___default.a,{button:true,divider:true,onClick:function onClick(){return mutate({variables:{input:{clientId:quote.fk_clientID}}});}},__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_ListItemText___default.a,{primary:'Edit Quote'}));}))));})))))),_this2.state.eligibilityDialogOpen?__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_react_bootstrap_sweetalert___default.a,{warning:true,style:{wordWrap:'break-word',top:'40%'},title:'Ineligible',confirmBtnCssClass:_this2.props.classes.button+' '+_this2.props.classes.success,cancelBtnCssClass:_this2.props.classes.button+' '+_this2.props.classes.danger,confirmBtnText:'Edit Client',cancelBtnText:'Close',onConfirm:function onConfirm(){_this2.handleEditClient();},onCancel:function onCancel(){_this2.setState({eligibilityDialogOpen:false});},showCancel:!_this2.state.loadingDelete,showConfirm:!_this2.state.loadingDelete},__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],null,_this2.state.selectedClient,'is ineligible for a quote.'),__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],null,'Please update the following fields: '),__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__material_ui_core_Grid___default.a,{container:true,className:'invalidListBlock'},_this2.state.invalidFields.map(function(i){return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__material_ui_core_Grid___default.a,{item:true,xs:12,sm:6,md:6},__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],null,i));}))):null);});}}]);return QuotesTab_EliteWealth;}(__WEBPACK_IMPORTED_MODULE_9_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_18_react_router_dom__["f" /* withRouter */])(__WEBPACK_IMPORTED_MODULE_17__material_ui_core_styles_withStyles___default()(__WEBPACK_IMPORTED_MODULE_16_assets_jss_material_dashboard_pro_react_views_sweetAlertStyle_jsx__["a" /* default */])(QuotesTab_EliteWealth)));

/***/ }),
/* 624 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_core__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_icons__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Grid_GridItem_jsx__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var BaseTablePageContent=function(_React$Component){_inherits(BaseTablePageContent,_React$Component);function BaseTablePageContent(){var _ref;var _temp,_this,_ret;_classCallCheck(this,BaseTablePageContent);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=BaseTablePageContent.__proto__||Object.getPrototypeOf(BaseTablePageContent)).call.apply(_ref,[this].concat(args))),_this),_this.state={filterEl:null},_this.handlePopoverClose=function(name){_this.setState(_defineProperty({},name,null));},_this.handlePopoverOpen=function(event,name){_this.setState(_defineProperty({},name,event.currentTarget));},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(BaseTablePageContent,[{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div",{className:"contentWithStepper"},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["e" /* Card */],null,__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["g" /* CardHeader */],{title:this.props.title,style:{textAlign:'center'}}),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["f" /* CardContent */],null,__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["X" /* TextField */],{id:"input-with-icon-textfield",fullWidth:true,style:{marginBottom:"3vh"},placeholder:"Search by Name, Surname, or Email",onChange:this.props.handleSearch,label:"Search",InputProps:{startAdornment:__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["z" /* InputAdornment */],{position:"start"},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_icons__["n" /* Search */],null))}}),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["I" /* Paper */],{style:{overflowX:"auto"}},this.props.children))));}}]);return BaseTablePageContent;}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (BaseTablePageContent);

/***/ }),
/* 625 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(2450);


/***/ }),
/* 626 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var spaceDisplay=function spaceDisplay(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:props.style},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:{display:"grid",paddingTop:'3px',paddingBottom:'3px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{style:{float:"left"}},props.left),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{style:{float:"right"}},props.right))));};/* harmony default export */ __webpack_exports__["a"] = (spaceDisplay);

/***/ }),
/* 627 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SubscriptionInfo; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_graphql_tag__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_graphql_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_graphql_tag__);
var _templateObject=_taggedTemplateLiteral(["\n  query subscriptionInfo($userId: String!, $token: String!) {\n    SubscriptionInfo(userId: $userId, token: $token) {\n      sd_id\n      fk_su_ID\n      sd_brokerage_user_plan\n      sd_basic_brokers\n      sd_standard_brokers\n      sd_premium_brokers\n      sd_free_assistants\n      sd_extra_assistants\n      sd_price_pm\n      sd_subscription_active\n      sd_start_date\n      sd_twelth_month_end\n      sd_next_payment\n    }\n  }\n"],["\n  query subscriptionInfo($userId: String!, $token: String!) {\n    SubscriptionInfo(userId: $userId, token: $token) {\n      sd_id\n      fk_su_ID\n      sd_brokerage_user_plan\n      sd_basic_brokers\n      sd_standard_brokers\n      sd_premium_brokers\n      sd_free_assistants\n      sd_extra_assistants\n      sd_price_pm\n      sd_subscription_active\n      sd_start_date\n      sd_twelth_month_end\n      sd_next_payment\n    }\n  }\n"]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var SubscriptionInfo=__WEBPACK_IMPORTED_MODULE_0_graphql_tag___default()(_templateObject);

/***/ }),
/* 628 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ActivateUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DeactivateUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return DeclineUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return InviteUsers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return DeleteUser; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_graphql_tag__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_graphql_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_graphql_tag__);
var _templateObject=_taggedTemplateLiteral(["\n  mutation activateUser($input: ActivateUserInput!) {\n    ActivateUser(input: $input) {\n      clientMutationId\n    }\n  }\n"],["\n  mutation activateUser($input: ActivateUserInput!) {\n    ActivateUser(input: $input) {\n      clientMutationId\n    }\n  }\n"]),_templateObject2=_taggedTemplateLiteral(["\n  mutation deactivateUser($input: DeactivateUserInput!) {\n    DeactivateUser(input: $input) {\n      clientMutationId\n    }\n  }\n"],["\n  mutation deactivateUser($input: DeactivateUserInput!) {\n    DeactivateUser(input: $input) {\n      clientMutationId\n    }\n  }\n"]),_templateObject3=_taggedTemplateLiteral(["\n  mutation declineUser($input: DeclineUserInput!) {\n    DeclineUser(input: $input) {\n      clientMutationId\n    }\n  }\n"],["\n  mutation declineUser($input: DeclineUserInput!) {\n    DeclineUser(input: $input) {\n      clientMutationId\n    }\n  }\n"]),_templateObject4=_taggedTemplateLiteral(["\n  mutation inviteUsers($input: InviteUsersInput!) {\n    InviteUsers(input: $input) {\n      clientMutationId\n    }\n  }\n"],["\n  mutation inviteUsers($input: InviteUsersInput!) {\n    InviteUsers(input: $input) {\n      clientMutationId\n    }\n  }\n"]),_templateObject5=_taggedTemplateLiteral(["\n  mutation deleteUser($input: DeleteUserInput!) {\n    DeleteUser(input: $input) {\n      clientMutationId\n    }\n  }\n"],["\n  mutation deleteUser($input: DeleteUserInput!) {\n    DeleteUser(input: $input) {\n      clientMutationId\n    }\n  }\n"]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var ActivateUser=__WEBPACK_IMPORTED_MODULE_0_graphql_tag___default()(_templateObject);var DeactivateUser=__WEBPACK_IMPORTED_MODULE_0_graphql_tag___default()(_templateObject2);var DeclineUser=__WEBPACK_IMPORTED_MODULE_0_graphql_tag___default()(_templateObject3);var InviteUsers=__WEBPACK_IMPORTED_MODULE_0_graphql_tag___default()(_templateObject4);var DeleteUser=__WEBPACK_IMPORTED_MODULE_0_graphql_tag___default()(_templateObject5);

/***/ }),
/* 629 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UserStatus; });
/* unused harmony export AssistantAssignment */
var UserStatus=Object.freeze({Active:"1",Requested:"0",Inactive:"-1"});var AssistantAssignment=Object.freeze({Assigned:2,BrokerRequested:1,AssistantRequested:0});

/***/ }),
/* 630 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return banks; });
var banks=[{value:"na",displayValue:"N/A"},{value:"absa",displayValue:"Absa"},{value:"fnb",displayValue:"FNB"},{value:"capitec",displayValue:"Capitec"},{value:"nedbank",displayValue:"Nedbank"},{value:"standardbank",displayValue:"Standard Bank"},{value:"africanbank",displayValue:"African Bank"},{value:"mercantilebank",displayValue:"Mercantile Bank"},{value:"grindrodbank",displayValue:"Grindrod Bank"},{value:"bidvestbank",displayValue:"Bidvest Bank"},{value:"sasfin",displayValue:"Sasfin"},{value:"albarakabank",displayValue:"Albaraka Bank"},{value:"ubank",displayValue:"Ubank"},{value:"hbzbank",displayValue:"HBZ Bank"},{value:"southafricanbankofathens",displayValue:"South African Bank of Athens"},{value:"discoverybank",displayValue:"Discovery Bank"}];

/***/ }),
/* 631 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_core__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
var DescriptiveCell=function DescriptiveCell(props){var hasBorder=props.count<1;if(props.noBorder)hasBorder=false;if(props.hasBorder)hasBorder=true;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{style:{borderBottom:hasBorder?"1px solid #e0e0e0":"0px",padding:"0px",paddingTop:"15px",width:"150em"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{container:true},props.description?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{item:true,xs:6,sm:6,md:4},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("strong",null,props.description))):null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{item:true,xs:2,sm:2,md:props.description?1:10},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["d" /* Button */],{variant:"fab",mini:true,className:"minifab",color:"primary",style:{bottom:"3px"},onClick:function onClick(event){event.stopPropagation();props.add();}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["w" /* Icon */],{style:{color:"white"}},"add"))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{item:true,xs:2,sm:2,md:2,style:{textAlign:"center"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{variant:"caption"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("strong",null,props.count===0?"":props.count)))));};/* harmony default export */ __webpack_exports__["a"] = (DescriptiveCell);

/***/ }),
/* 632 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_core__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_Wrappers_materialUIWrappers_components_FormCheckbox_jsx__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Wrappers_materialUIWrappers_components_FormInput__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_redux_form__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_store__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_CustomCardHeading_jsx__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_Wrappers_materialUIWrappers_components_NumberInput__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__objects_assumptions__ = __webpack_require__(398);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_helpers_ValidationHelpers__ = __webpack_require__(27);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/*eslint-disable*/var grandSeperator=function grandSeperator(val){val=val.toLocaleString().replace(/,/g,"").replace(/ /g,"");var parsed=parseFloat(val);if(!isNaN(parsed)){return parsed.toLocaleString().replace(/,/g," ");}else{return val;}};var Assumptions=function(_React$Component){_inherits(Assumptions,_React$Component);function Assumptions(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Assumptions);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Assumptions.__proto__||Object.getPrototypeOf(Assumptions)).call.apply(_ref,[this].concat(args))),_this),_this.checkItem=function(label,name){return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{item:true,xs:12,sm:12,md:12},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{container:true},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:6,style:{marginBottom:"30px",position:"relative"}},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{variant:"body1",style:{position:"absolute",top:"25%"}},label)),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:6,style:{marginBottom:"30px"}},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["t" /* FormControl */],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_2_components_Wrappers_materialUIWrappers_components_FormCheckbox_jsx__["a" /* default */],name:name,onChange:function onChange(){_this.forceUpdate();}}))))));},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Assumptions,[{key:"componentDidMount",value:function componentDidMount(){this.props.scrollMeBar();}},{key:"render",value:function render(){var checkValidation=this.props.checkValidation;var clientD="";if(this.props.state)if(this.props.state.client)clientD=this.props.state.client.first_name+" "+this.props.state.client.surname;return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("div",{className:"contentWithStepper"},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["e" /* Card */],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["f" /* CardContent */],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_CustomCardHeading_jsx__["a" /* default */],{subheading:"Financial Needs Analysis",caption:clientD,headline:"Fixed Assumptions"}),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{container:true},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{item:true,xs:12,sm:12,md:10,style:{margin:"0px auto"}},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{container:true},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:6},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{variant:"body1"},"Estate Duty Exemption:")),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:6,style:{marginBottom:"30px",textAlign:"left"}},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{variant:"body1"},"R ",grandSeperator(__WEBPACK_IMPORTED_MODULE_10__objects_assumptions__["a" /* default */].estate_duty_exemption))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:6},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{variant:"body1"},"Primary Residence Exemption:")),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:6,style:{marginBottom:"30px"}},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{variant:"body1"},"R"," ",grandSeperator(__WEBPACK_IMPORTED_MODULE_10__objects_assumptions__["a" /* default */].primary_residence_exemption))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:6},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{variant:"body1"},"Small Business Exemption:")),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:6,style:{marginBottom:"30px"}},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{variant:"body1"},"R ",grandSeperator(__WEBPACK_IMPORTED_MODULE_10__objects_assumptions__["a" /* default */].small_business_exemption))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:6},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{variant:"body1"},"Inclusion Rate for CGT:")),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:6,style:{marginBottom:"30px"}},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{variant:"body1"},__WEBPACK_IMPORTED_MODULE_10__objects_assumptions__["a" /* default */].inclusion_rate_for_cgt,"%")),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:6},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{variant:"body1"},"Masters Fees:")),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:6,style:{marginBottom:"30px"}},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{variant:"body1"},"R ",grandSeperator(__WEBPACK_IMPORTED_MODULE_10__objects_assumptions__["a" /* default */].masters_fees))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:6},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{variant:"body1"},"Transfer costs:")),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:6,style:{marginBottom:"30px"}},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{variant:"body1"},__WEBPACK_IMPORTED_MODULE_10__objects_assumptions__["a" /* default */].transfer_costs,"%")),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:6},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{variant:"body1"},"Rate of Estate Duty (<R30m):")),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:6,style:{marginBottom:"30px"}},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{variant:"body1"},__WEBPACK_IMPORTED_MODULE_10__objects_assumptions__["a" /* default */].estateDutyLT,"%")),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:6},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{variant:"body1"},"Rate of Estate Duty (>R30m):")),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:6,style:{marginBottom:"30px"}},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{variant:"body1"},__WEBPACK_IMPORTED_MODULE_10__objects_assumptions__["a" /* default */].estateDutyGT,"%")),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:6},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{variant:"body1"},"CGT Exclusion on Death:")),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:6,style:{marginBottom:"30px"}},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{variant:"body1"},"R ",grandSeperator(__WEBPACK_IMPORTED_MODULE_10__objects_assumptions__["a" /* default */].cgtExclusionAtDeath)))))))));}}]);return Assumptions;}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Assumptions);

/***/ }),
/* 633 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SubmitFna; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_graphql_tag__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_graphql_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_graphql_tag__);
var _templateObject=_taggedTemplateLiteral(["\n  mutation submitFna($input: SubmitFnaInput!) {\n    SubmitFna(input: $input) {\n      id\n    }\n  }\n"],["\n  mutation submitFna($input: SubmitFnaInput!) {\n    SubmitFna(input: $input) {\n      id\n    }\n  }\n"]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var SubmitFna=__WEBPACK_IMPORTED_MODULE_0_graphql_tag___default()(_templateObject);

/***/ }),
/* 634 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_core__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__progress_kendo_react_pdf__ = __webpack_require__(635);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_Grid_GridItem_jsx__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_helpers_UriReader__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_helpers_UserHelper__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_queries_fna_queries__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_apollo__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_router__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_CustomCardHeading_CustomCardHeading_jsx__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__results_Accrual_jsx__ = __webpack_require__(2592);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__results_BalanceSheet_jsx__ = __webpack_require__(2593);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__results_CGT_jsx__ = __webpack_require__(2594);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__results_EstateDuty_jsx__ = __webpack_require__(2595);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__results_ExecutorsFees_jsx__ = __webpack_require__(2596);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__results_Liquidity_jsx__ = __webpack_require__(2597);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__results_Residue_jsx__ = __webpack_require__(2598);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__results_DeathProv_jsx__ = __webpack_require__(2599);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__ResultsPdf_ResultsPdf__ = __webpack_require__(2600);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}//import styler from 'stylerjs';
var tabStyle={color:'#6c5cab',borderBottom:'2px solid'};var tabs=['Balance Sheet','CGT','Estate Duty','Liquidity','Accrual','Residue','Death Provision'];var FnaResultsPage=function(_React$Component){_inherits(FnaResultsPage,_React$Component);function FnaResultsPage(){var _ref;var _temp,_this,_ret;_classCallCheck(this,FnaResultsPage);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=FnaResultsPage.__proto__||Object.getPrototypeOf(FnaResultsPage)).call.apply(_ref,[this].concat(args))),_this),_this.handleChangeTab=function(event,value){_this.props.state.tab=value;_this.props.changeTab();},_this.exportPDF=function(){_this.resume.save();},_this.togglePdfPreview=function(){_this.setState(function(prevState){return{showPdfPreview:!prevState.showPdfPreview};});},_this.renderToPdf=function(){/* 		const htmlstring = ReactDOMServer.renderToStaticMarkup(
			<div className="green">
				<Typography>Hello</Typography>
			</div>
		); */var htmlstring=document.getElementById('takeThis').innerHTML;console.log('htmlstring:',htmlstring);var preClasses=htmlstring.split('class="');preClasses.splice(0,1);var postClasses=[];for(var i=0;i<preClasses.length;i++){var classNames=preClasses[i];classNames=classNames.split('"')[0];var classes=classNames.split(' ');postClasses=postClasses.concat([].concat(_toConsumableArray(classes)));}/* 	console.log('postClasses:', postClasses);

		for (const className of postClasses) {
			var styles = styler('.' + className).get([
				'margin-top',
				'color',
				'font-weight',
				'z-index',
				'font-family',
				'background-color'
			]);
			console.log(`styles for ${className}:`, styles);
		} */},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(FnaResultsPage,[{key:'render',value:function render(){var tab=this.props.state.tab;var balanceSheet=__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__results_BalanceSheet_jsx__["a" /* default */],{state:this.props.state});var CgtSheet=__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__results_CGT_jsx__["a" /* default */],{state:this.props.state});var EstateDutySheet=__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__results_EstateDuty_jsx__["a" /* default */],{state:this.props.state});var LiquiditySheet=__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__results_Liquidity_jsx__["a" /* default */],{state:this.props.state});var AccrualSheet=__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__results_Accrual_jsx__["a" /* default */],{state:this.props.state});var ResidueSheet=__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__results_Residue_jsx__["a" /* default */],{state:this.props.state});var DeathProv=__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__results_DeathProv_jsx__["a" /* default */],{state:this.props.state});var clientD="";if(this.props.state.client)clientD=this.props.state.client.first_name+" "+this.props.state.client.surname;return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{container:true,style:{width:"150%",marginLeft:"-25%",marginTop:"25px",flex:1,height:"fit-content"}},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:10,style:{margin:'auto'}},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["e" /* Card */],null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["f" /* CardContent */],null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_CustomCardHeading_CustomCardHeading_jsx__["a" /* default */],{subheading:"Financial Needs Analysis",caption:clientD,headline:"Result"}),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["a" /* AppBar */],{position:'static',color:'default',style:{marginBottom:'20px',marginTop:'-30px'}},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["W" /* Tabs */],{tab:tab,onChange:this.handleChangeTab,indicatorColor:'primary',textColor:'secondary',scrollable:true,scrollButtons:'auto'},tabs.map(function(t,i){return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["P" /* Tab */],{label:t,style:i===tab?tabStyle:{}});}))),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{variant:'title'},tabs[tab]),tab===0&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div',null,balanceSheet),tab===1&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div',null,CgtSheet),tab===2&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div',null,EstateDutySheet),tab===3&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div',null,LiquiditySheet),tab===4&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div',null,AccrualSheet),tab===5&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div',null,ResidueSheet),tab===6&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div',null,DeathProv)))));}}]);return FnaResultsPage;}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (FnaResultsPage);

/***/ }),
/* 635 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PDFExport__ = __webpack_require__(2501);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PDFMargin__ = __webpack_require__(685);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__savePDF__ = __webpack_require__(687);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__getPageMargin__ = __webpack_require__(413);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__grid_GridPDFExport__ = __webpack_require__(2587);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__PDFExport__["a"]; });
/* unused harmony reexport PDFMargin */
/* unused harmony reexport savePDF */
/* unused harmony reexport getPageMargin */
/* unused harmony reexport GridPDFExport */






//# sourceMappingURL=main.js.map

/***/ }),
/* 636 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__drawing__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__geometry__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pdf__ = __webpack_require__(412);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__html__ = __webpack_require__(2583);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_3__html__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__pdf__["b"]; });
/* unused harmony reexport exportImage */
/* unused harmony reexport exportSVG */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common__ = __webpack_require__(29);
/* unused harmony reexport animationFrame */
/* unused harmony reexport Class */
/* unused harmony reexport Color */
/* unused harmony reexport htmlEncode */
/* unused harmony reexport logToConsole */
/* unused harmony reexport Observable */
/* unused harmony reexport saveAs */
/* unused harmony reexport support */
/* unused harmony reexport template */
/* unused harmony reexport throttle */
/* unused harmony reexport Animation */
/* unused harmony reexport AnimationFactory */
/* unused harmony reexport Arc */
/* unused harmony reexport BaseNode */
/* unused harmony reexport Circle */
/* unused harmony reexport Element */
/* unused harmony reexport Gradient */
/* unused harmony reexport GradientStop */
/* unused harmony reexport Group */
/* unused harmony reexport Image */
/* unused harmony reexport Layout */
/* unused harmony reexport LinearGradient */
/* unused harmony reexport MultiPath */
/* unused harmony reexport ObserversMixin */
/* unused harmony reexport OptionsStore */
/* unused harmony reexport Path */
/* unused harmony reexport PathParser */
/* unused harmony reexport QuadNode */
/* unused harmony reexport RadialGradient */
/* unused harmony reexport Rect */
/* unused harmony reexport ShapesQuadTree */
/* unused harmony reexport Surface */
/* unused harmony reexport SurfaceFactory */
/* unused harmony reexport Text */
/* unused harmony reexport align */
/* unused harmony reexport fit */
/* unused harmony reexport stack */
/* unused harmony reexport vAlign */
/* unused harmony reexport vStack */
/* unused harmony reexport vWrap */
/* unused harmony reexport wrap */
/* unused harmony reexport drawing */
/* unused harmony reexport geometry */
/* unused harmony reexport pdf */
















/***/ }),
/* 637 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shapes_element__ = __webpack_require__(84);
/* unused harmony reexport Element */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shapes_circle__ = __webpack_require__(2532);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__shapes_circle__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shapes_arc__ = __webpack_require__(2533);
/* unused harmony reexport Arc */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shapes_path__ = __webpack_require__(402);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_3__shapes_path__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shapes_multi_path__ = __webpack_require__(657);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_4__shapes_multi_path__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shapes_text__ = __webpack_require__(2541);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_5__shapes_text__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shapes_image__ = __webpack_require__(2542);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_6__shapes_image__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shapes_group__ = __webpack_require__(202);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_7__shapes_group__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shapes_layout__ = __webpack_require__(2543);
/* unused harmony reexport Layout */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__shapes_rect__ = __webpack_require__(2545);
/* unused harmony reexport Rect */











/***/ }),
/* 638 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var support = {};

if (typeof window !== 'undefined') {
    support.browser = (function(userAgent) {
        var browserRxs = {
            edge: /(edge)[ \/]([\w.]+)/i,
            webkit: /(chrome)[ \/]([\w.]+)/i,
            safari: /(webkit)[ \/]([\w.]+)/i,
            opera: /(opera)(?:.*version|)[ \/]([\w.]+)/i,
            msie: /(msie\s|trident.*? rv:)([\w.]+)/i,
            mozilla: /(mozilla)(?:.*? rv:([\w.]+)|)/i
        };

        var browser;

        for (var agent in browserRxs) {
            if (browserRxs.hasOwnProperty(agent)) {
                var match = userAgent.match(browserRxs[agent]);
                if (match) {
                    browser = {};
                    browser[agent] = true;
                    browser[match[1].toLowerCase().split(" ")[0].split("/")[0]] = true;
                    browser.version = parseInt(document.documentMode || match[2], 10);

                    break;
                }
            }
        }

        return browser;

    })(window.navigator.userAgent);
}

/* harmony default export */ __webpack_exports__["a"] = (support);



/***/ }),
/* 639 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return RGB; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Bytes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return HSV; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return HSL; });
/* harmony export (immutable) */ __webpack_exports__["e"] = parseColor;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__class__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__support__ = __webpack_require__(638);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__named_colors__ = __webpack_require__(640);




var browser = __WEBPACK_IMPORTED_MODULE_1__support__["a" /* default */].browser;

var matchNamedColor = function (color) {
    var colorNames = Object.keys(__WEBPACK_IMPORTED_MODULE_2__named_colors__["a" /* default */]);
    colorNames.push("transparent");

    var regexp = new RegExp("^(" + colorNames.join("|") + ")(\\W|$)", "i");
    matchNamedColor = function (color) { return regexp.exec(color); };

    return regexp.exec(color);
};

var BaseColor = (function (Class) {
    function BaseColor() { Class.call(this); }

    if ( Class ) BaseColor.__proto__ = Class;
    BaseColor.prototype = Object.create( Class && Class.prototype );
    BaseColor.prototype.constructor = BaseColor;
    BaseColor.prototype.toHSV = function toHSV () { return this; };

    BaseColor.prototype.toRGB = function toRGB () { return this; };

    BaseColor.prototype.toHex = function toHex () { return this.toBytes().toHex(); };

    BaseColor.prototype.toBytes = function toBytes () { return this; };

    BaseColor.prototype.toCss = function toCss () { return "#" + this.toHex(); };

    BaseColor.prototype.toCssRgba = function toCssRgba () {
        var rgb = this.toBytes();
        return ("rgba(" + (rgb.r) + ", " + (rgb.g) + ", " + (rgb.b) + ", " + (parseFloat((Number(this.a)).toFixed(3))) + ")");
    };

    BaseColor.prototype.toDisplay = function toDisplay () {
        if (browser.msie && browser.version < 9) {
            return this.toCss(); // no RGBA support; does it support any opacity in colors?
        }
        return this.toCssRgba();
    };

    BaseColor.prototype.equals = function equals (c) {
        return c === this || c !== null && this.toCssRgba() === parseColor(c).toCssRgba();
    };

    BaseColor.prototype.diff = function diff (other) {
        if (other === null) {
            return NaN;
        }

        var c1 = this.toBytes();
        var c2 = other.toBytes();

        return Math.sqrt(Math.pow((c1.r - c2.r) * 0.30, 2) +
                         Math.pow((c1.g - c2.g) * 0.59, 2) +
                         Math.pow((c1.b - c2.b) * 0.11, 2));
    };

    BaseColor.prototype.clone = function clone () {
        var c = this.toBytes();
        if (c === this) {
            c = new Bytes(c.r, c.g, c.b, c.a);
        }

        return c;
    };

    return BaseColor;
}(__WEBPACK_IMPORTED_MODULE_0__class__["a" /* default */]));

var RGB = (function (BaseColor) {
    function RGB(r, g, b, a) {
        BaseColor.call(this);

        this.r = r;
        this.g = g;
        this.b = b;
        this.a = a;
    }

    if ( BaseColor ) RGB.__proto__ = BaseColor;
    RGB.prototype = Object.create( BaseColor && BaseColor.prototype );
    RGB.prototype.constructor = RGB;

    RGB.prototype.toHSV = function toHSV () {
        var ref = this;
        var r = ref.r;
        var g = ref.g;
        var b = ref.b;
        var min = Math.min(r, g, b);
        var max = Math.max(r, g, b);
        var delta = max - min;
        var v = max;
        var h, s;

        if (delta === 0) {
            return new HSV(0, 0, v, this.a);
        }

        if (max !== 0) {
            s = delta / max;
            if (r === max) {
                h = (g - b) / delta;
            } else if (g === max) {
                h = 2 + (b - r) / delta;
            } else {
                h = 4 + (r - g) / delta;
            }

            h *= 60;
            if (h < 0) {
                h += 360;
            }
        } else {
            s = 0;
            h = -1;
        }

        return new HSV(h, s, v, this.a);
    };

    RGB.prototype.toHSL = function toHSL () {
        var ref = this;
        var r = ref.r;
        var g = ref.g;
        var b = ref.b;
        var max = Math.max(r, g, b);
        var min = Math.min(r, g, b);
        var h, s, l = (max + min) / 2;

        if (max === min) {
            h = s = 0;
        } else {
            var d = max - min;
            s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
            switch (max) {
                case r: h = (g - b) / d + (g < b ? 6 : 0); break;
                case g: h = (b - r) / d + 2; break;
                case b: h = (r - g) / d + 4; break;
                default: break;
            }
        }

        return new HSL(h * 60, s * 100, l * 100, this.a);
    };

    RGB.prototype.toBytes = function toBytes () {
        return new Bytes(this.r * 255, this.g * 255, this.b * 255, this.a);
    };

    return RGB;
}(BaseColor));

var Bytes = (function (RGB) {
    function Bytes(r, g, b, a) {
        RGB.call(this, Math.round(r), Math.round(g), Math.round(b), a);
    }

    if ( RGB ) Bytes.__proto__ = RGB;
    Bytes.prototype = Object.create( RGB && RGB.prototype );
    Bytes.prototype.constructor = Bytes;

    Bytes.prototype.toRGB = function toRGB () {
        return new RGB(this.r / 255, this.g / 255, this.b / 255, this.a);
    };

    Bytes.prototype.toHSV = function toHSV () {
        return this.toRGB().toHSV();
    };

    Bytes.prototype.toHSL = function toHSL () {
        return this.toRGB().toHSL();
    };

    Bytes.prototype.toHex = function toHex () {
        return hex(this.r, 2) + hex(this.g, 2) + hex(this.b, 2);
    };

    Bytes.prototype.toBytes = function toBytes () {
        return this;
    };

    return Bytes;
}(RGB));

function hex(n, width, pad) {
    if ( pad === void 0 ) pad = "0";

    var result = n.toString(16);
    while (width > result.length) {
        result = pad + result;
    }

    return result;
}

var HSV = (function (BaseColor) {
    function HSV(h, s, v, a) {
        BaseColor.call(this);

        this.h = h;
        this.s = s;
        this.v = v;
        this.a = a;
    }

    if ( BaseColor ) HSV.__proto__ = BaseColor;
    HSV.prototype = Object.create( BaseColor && BaseColor.prototype );
    HSV.prototype.constructor = HSV;

    HSV.prototype.toRGB = function toRGB () {
        var ref = this;
        var h = ref.h;
        var s = ref.s;
        var v = ref.v;
        var r, g, b;

        if (s === 0) {
            r = g = b = v;
        } else {
            h /= 60;

            var i = Math.floor(h);
            var f = h - i;
            var p = v * (1 - s);
            var q = v * (1 - s * f);
            var t = v * (1 - s * (1 - f));

            switch (i) {
                case 0: r = v; g = t; b = p; break;
                case 1: r = q; g = v; b = p; break;
                case 2: r = p; g = v; b = t; break;
                case 3: r = p; g = q; b = v; break;
                case 4: r = t; g = p; b = v; break;
                default: r = v; g = p; b = q; break;
            }
        }

        return new RGB(r, g, b, this.a);
    };

    HSV.prototype.toHSL = function toHSL () {
        return this.toRGB().toHSL();
    };

    HSV.prototype.toBytes = function toBytes () {
        return this.toRGB().toBytes();
    };

    return HSV;
}(BaseColor));

var HSL = (function (BaseColor) {
    function HSL(h, s, l, a) {
        BaseColor.call(this);

        this.h = h;
        this.s = s;
        this.l = l;
        this.a = a;
    }

    if ( BaseColor ) HSL.__proto__ = BaseColor;
    HSL.prototype = Object.create( BaseColor && BaseColor.prototype );
    HSL.prototype.constructor = HSL;

    HSL.prototype.toRGB = function toRGB () {
        var h = this.h / 360;
        var s = this.s / 100;
        var l = this.l / 100;
        var r, g, b;

        if (s === 0) {
            r = g = b = l; // achromatic
        } else {
            var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
            var p = 2 * l - q;
            r = hue2rgb(p, q, h + 1 / 3);
            g = hue2rgb(p, q, h);
            b = hue2rgb(p, q, h - 1 / 3);
        }

        return new RGB(r, g, b, this.a);
    };

    HSL.prototype.toHSV = function toHSV () {
        return this.toRGB().toHSV();
    };

    HSL.prototype.toBytes = function toBytes () {
        return this.toRGB().toBytes();
    };

    return HSL;
}(BaseColor));

function hue2rgb(p, q, s) {
    var t = s;

    if (t < 0) {
        t += 1;
    }

    if (t > 1) {
        t -= 1;
    }

    if (t < 1 / 6) {
        return p + (q - p) * 6 * t;
    }

    if (t < 1 / 2) {
        return q;
    }

    if (t < 2 / 3) {
        return p + (q - p) * (2 / 3 - t) * 6;
    }

    return p;
}



function parseColor(value, safe) {
    var m, ret;

    if (value == null || value === "none") {
        return null;
    }

    if (value instanceof BaseColor) {
        return value;
    }

    var color = value.toLowerCase();
    if ((m = matchNamedColor(color))) {
        if (m[1] === "transparent") {
            color = new RGB(1, 1, 1, 0);
        } else {
            color = parseColor(__WEBPACK_IMPORTED_MODULE_2__named_colors__["a" /* default */][m[1]], safe);
        }
        color.match = [ m[1] ];
        return color;
    }
    if ((m = /^#?([0-9a-f]{2})([0-9a-f]{2})([0-9a-f]{2})\b/i.exec(color))) {
        ret = new Bytes(parseInt(m[1], 16),
                        parseInt(m[2], 16),
                        parseInt(m[3], 16), 1);
    } else if ((m = /^#?([0-9a-f])([0-9a-f])([0-9a-f])\b/i.exec(color))) {
        ret = new Bytes(parseInt(m[1] + m[1], 16),
                        parseInt(m[2] + m[2], 16),
                        parseInt(m[3] + m[3], 16), 1);
    } else if ((m = /^rgb\(\s*([0-9]+)\s*,\s*([0-9]+)\s*,\s*([0-9]+)\s*\)/.exec(color))) {
        ret = new Bytes(parseInt(m[1], 10),
                        parseInt(m[2], 10),
                        parseInt(m[3], 10), 1);
    } else if ((m = /^rgba\(\s*([0-9]+)\s*,\s*([0-9]+)\s*,\s*([0-9]+)\s*,\s*([0-9.]+)\s*\)/.exec(color))) {
        ret = new Bytes(parseInt(m[1], 10),
                        parseInt(m[2], 10),
                        parseInt(m[3], 10), parseFloat(m[4]));
    } else if ((m = /^rgb\(\s*([0-9]*\.?[0-9]+)%\s*,\s*([0-9]*\.?[0-9]+)%\s*,\s*([0-9]*\.?[0-9]+)%\s*\)/.exec(color))) {
        ret = new RGB(parseFloat(m[1]) / 100,
                      parseFloat(m[2]) / 100,
                      parseFloat(m[3]) / 100, 1);
    } else if ((m = /^rgba\(\s*([0-9]*\.?[0-9]+)%\s*,\s*([0-9]*\.?[0-9]+)%\s*,\s*([0-9]*\.?[0-9]+)%\s*,\s*([0-9.]+)\s*\)/.exec(color))) {
        ret = new RGB(parseFloat(m[1]) / 100,
                      parseFloat(m[2]) / 100,
                      parseFloat(m[3]) / 100, parseFloat(m[4]));
    }

    if (ret) {
        ret.match = m;
    } else if (!safe) {
        throw new Error("Cannot parse color: " + color);
    }

    return ret;
}


/***/ }),
/* 640 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var namedColors = {
    aliceblue: "f0f8ff", antiquewhite: "faebd7", aqua: "00ffff",
    aquamarine: "7fffd4", azure: "f0ffff", beige: "f5f5dc",
    bisque: "ffe4c4", black: "000000", blanchedalmond: "ffebcd",
    blue: "0000ff", blueviolet: "8a2be2", brown: "a52a2a",
    burlywood: "deb887", cadetblue: "5f9ea0", chartreuse: "7fff00",
    chocolate: "d2691e", coral: "ff7f50", cornflowerblue: "6495ed",
    cornsilk: "fff8dc", crimson: "dc143c", cyan: "00ffff",
    darkblue: "00008b", darkcyan: "008b8b", darkgoldenrod: "b8860b",
    darkgray: "a9a9a9", darkgrey: "a9a9a9", darkgreen: "006400",
    darkkhaki: "bdb76b", darkmagenta: "8b008b", darkolivegreen: "556b2f",
    darkorange: "ff8c00", darkorchid: "9932cc", darkred: "8b0000",
    darksalmon: "e9967a", darkseagreen: "8fbc8f", darkslateblue: "483d8b",
    darkslategray: "2f4f4f", darkslategrey: "2f4f4f", darkturquoise: "00ced1",
    darkviolet: "9400d3", deeppink: "ff1493", deepskyblue: "00bfff",
    dimgray: "696969", dimgrey: "696969", dodgerblue: "1e90ff",
    firebrick: "b22222", floralwhite: "fffaf0", forestgreen: "228b22",
    fuchsia: "ff00ff", gainsboro: "dcdcdc", ghostwhite: "f8f8ff",
    gold: "ffd700", goldenrod: "daa520", gray: "808080",
    grey: "808080", green: "008000", greenyellow: "adff2f",
    honeydew: "f0fff0", hotpink: "ff69b4", indianred: "cd5c5c",
    indigo: "4b0082", ivory: "fffff0", khaki: "f0e68c",
    lavender: "e6e6fa", lavenderblush: "fff0f5", lawngreen: "7cfc00",
    lemonchiffon: "fffacd", lightblue: "add8e6", lightcoral: "f08080",
    lightcyan: "e0ffff", lightgoldenrodyellow: "fafad2", lightgray: "d3d3d3",
    lightgrey: "d3d3d3", lightgreen: "90ee90", lightpink: "ffb6c1",
    lightsalmon: "ffa07a", lightseagreen: "20b2aa", lightskyblue: "87cefa",
    lightslategray: "778899", lightslategrey: "778899", lightsteelblue: "b0c4de",
    lightyellow: "ffffe0", lime: "00ff00", limegreen: "32cd32",
    linen: "faf0e6", magenta: "ff00ff", maroon: "800000",
    mediumaquamarine: "66cdaa", mediumblue: "0000cd", mediumorchid: "ba55d3",
    mediumpurple: "9370d8", mediumseagreen: "3cb371", mediumslateblue: "7b68ee",
    mediumspringgreen: "00fa9a", mediumturquoise: "48d1cc", mediumvioletred: "c71585",
    midnightblue: "191970", mintcream: "f5fffa", mistyrose: "ffe4e1",
    moccasin: "ffe4b5", navajowhite: "ffdead", navy: "000080",
    oldlace: "fdf5e6", olive: "808000", olivedrab: "6b8e23",
    orange: "ffa500", orangered: "ff4500", orchid: "da70d6",
    palegoldenrod: "eee8aa", palegreen: "98fb98", paleturquoise: "afeeee",
    palevioletred: "d87093", papayawhip: "ffefd5", peachpuff: "ffdab9",
    peru: "cd853f", pink: "ffc0cb", plum: "dda0dd",
    powderblue: "b0e0e6", purple: "800080", red: "ff0000",
    rosybrown: "bc8f8f", royalblue: "4169e1", saddlebrown: "8b4513",
    salmon: "fa8072", sandybrown: "f4a460", seagreen: "2e8b57",
    seashell: "fff5ee", sienna: "a0522d", silver: "c0c0c0",
    skyblue: "87ceeb", slateblue: "6a5acd", slategray: "708090",
    slategrey: "708090", snow: "fffafa", springgreen: "00ff7f",
    steelblue: "4682b4", tan: "d2b48c", teal: "008080",
    thistle: "d8bfd8", tomato: "ff6347", turquoise: "40e0d0",
    violet: "ee82ee", wheat: "f5deb3", white: "ffffff",
    whitesmoke: "f5f5f5", yellow: "ffff00", yellowgreen: "9acd32"
};

/* harmony default export */ __webpack_exports__["a"] = (namedColors);

/***/ }),
/* 641 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = elementStyles;
function elementStyles(element, styles) {
    var result = {};
    var style = window.getComputedStyle(element) || {};
    var stylesArray = Array.isArray(styles) ? styles : [ styles ];

    for (var idx = 0; idx < stylesArray.length; idx++) {
        var field = stylesArray[idx];
        result[field] = style[field];
    }

    return result;
}

/***/ }),
/* 642 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__text_metrics_lru_cache__ = __webpack_require__(643);
/* unused harmony reexport LRUCache */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__text_metrics_text_metrics__ = __webpack_require__(644);
/* unused harmony reexport TextMetrics */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__text_metrics_measure_text__ = __webpack_require__(2531);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__text_metrics_measure_text__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__text_metrics_util__ = __webpack_require__(645);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_3__text_metrics_util__["b"]; });






/***/ }),
/* 643 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common__ = __webpack_require__(29);


var LRUCache = (function (Class) {
    function LRUCache(size) {
        Class.call(this);

        this._size = size;
        this._length = 0;
        this._map = {};
    }

    if ( Class ) LRUCache.__proto__ = Class;
    LRUCache.prototype = Object.create( Class && Class.prototype );
    LRUCache.prototype.constructor = LRUCache;

    LRUCache.prototype.put = function put (key, value) {
        var map = this._map;
        var entry = { key: key, value: value };

        map[key] = entry;

        if (!this._head) {
            this._head = this._tail = entry;
        } else {
            this._tail.newer = entry;
            entry.older = this._tail;
            this._tail = entry;
        }

        if (this._length >= this._size) {
            map[this._head.key] = null;
            this._head = this._head.newer;
            this._head.older = null;
        } else {
            this._length++;
        }
    };

    LRUCache.prototype.get = function get (key) {
        var entry = this._map[key];

        if (entry) {
            if (entry === this._head && entry !== this._tail) {
                this._head = entry.newer;
                this._head.older = null;
            }

            if (entry !== this._tail) {
                if (entry.older) {
                    entry.older.newer = entry.newer;
                    entry.newer.older = entry.older;
                }

                entry.older = this._tail;
                entry.newer = null;

                this._tail.newer = entry;
                this._tail = entry;
            }

            return entry.value;
        }
    };

    return LRUCache;
}(__WEBPACK_IMPORTED_MODULE_0__common__["a" /* Class */]));

/* harmony default export */ __webpack_exports__["a"] = (LRUCache);

/***/ }),
/* 644 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lru_cache__ = __webpack_require__(643);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util__ = __webpack_require__(645);




function zeroSize() {
    return { width: 0, height: 0, baseline: 0 };
}

var DEFAULT_OPTIONS = {
    baselineMarkerSize: 1
};

var defaultMeasureBox;

if (typeof document !== "undefined") {
    defaultMeasureBox = document.createElement("div");
    defaultMeasureBox.style.cssText = "position: absolute !important; top: -4000px !important; width: auto !important; height: auto !important;" +
              "padding: 0 !important; margin: 0 !important; border: 0 !important;" +
              "line-height: normal !important; visibility: hidden !important; white-space: pre!important;";
}

var TextMetrics = (function (Class) {
    function TextMetrics(options) {
        Class.call(this);

        this._cache = new __WEBPACK_IMPORTED_MODULE_0__lru_cache__["a" /* default */](1000);
        this.options = Object.assign({}, DEFAULT_OPTIONS, options);
    }

    if ( Class ) TextMetrics.__proto__ = Class;
    TextMetrics.prototype = Object.create( Class && Class.prototype );
    TextMetrics.prototype.constructor = TextMetrics;

    TextMetrics.prototype.measure = function measure (text, style, options) {
        if ( options === void 0 ) options = {};

        if (!text) {
            return zeroSize();
        }

        var styleKey = Object(__WEBPACK_IMPORTED_MODULE_2__util__["c" /* objectKey */])(style);
        var cacheKey = Object(__WEBPACK_IMPORTED_MODULE_2__util__["a" /* hashKey */])(text + styleKey);
        var cachedResult = this._cache.get(cacheKey);

        if (cachedResult) {
            return cachedResult;
        }

        var size = zeroSize();
        var measureBox = options.box || defaultMeasureBox;
        var baselineMarker = this._baselineMarker().cloneNode(false);

        for (var key in style) {
            var value = style[key];
            if (typeof value !== "undefined") {
                measureBox.style[key] = value;
            }
        }

        var textStr = options.normalizeText !== false ? Object(__WEBPACK_IMPORTED_MODULE_2__util__["b" /* normalizeText */])(text) : String(text);

        measureBox.textContent = textStr;
        measureBox.appendChild(baselineMarker);
        document.body.appendChild(measureBox);

        if (textStr.length) {
            size.width = measureBox.offsetWidth - this.options.baselineMarkerSize;
            size.height = measureBox.offsetHeight;
            size.baseline = baselineMarker.offsetTop + this.options.baselineMarkerSize;
        }

        if (size.width > 0 && size.height > 0) {
            this._cache.put(cacheKey, size);
        }

        measureBox.parentNode.removeChild(measureBox);

        return size;
    };

    TextMetrics.prototype._baselineMarker = function _baselineMarker () {
        var marker = document.createElement("div");
        marker.style.cssText = "display: inline-block; vertical-align: baseline;width: " +
            this.options.baselineMarkerSize + "px; height: " + this.options.baselineMarkerSize + "px;overflow: hidden;";

        return marker;
    };

    return TextMetrics;
}(__WEBPACK_IMPORTED_MODULE_1__common__["a" /* Class */]));

TextMetrics.current = new TextMetrics();

/* harmony default export */ __webpack_exports__["a"] = (TextMetrics);

/***/ }),
/* 645 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return objectKey; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return hashKey; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return normalizeText; });
var REPLACE_REGEX = /\r?\n|\r|\t/g;
var SPACE = ' ';

function normalizeText(text) {
    return String(text).replace(REPLACE_REGEX, SPACE);
}

function objectKey(object) {
    var parts = [];
    for (var key in object) {
        parts.push(key + object[key]);
    }

    return parts.sort().join("");
}

// Computes FNV-1 hash
// See http://en.wikipedia.org/wiki/Fowler%E2%80%93Noll%E2%80%93Vo_hash_function
function hashKey(str) {
    // 32-bit FNV-1 offset basis
    // See http://isthe.com/chongo/tech/comp/fnv/#FNV-param
    var hash = 0x811C9DC5;

    for (var i = 0; i < str.length; ++i) {
        hash += (hash << 1) + (hash << 4) + (hash << 7) + (hash << 8) + (hash << 24);
        hash ^= str.charCodeAt(i);
    }

    return hash >>> 0;
}



/***/ }),
/* 646 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_observers_mixin__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__to_matrix__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__matrix__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__point__ = __webpack_require__(42);






var Transformation = (function (Class) {
    function Transformation(matrix) {
        if ( matrix === void 0 ) matrix = __WEBPACK_IMPORTED_MODULE_3__matrix__["a" /* default */].unit();

        Class.call(this);

        this._matrix = matrix;
    }

    if ( Class ) Transformation.__proto__ = Class;
    Transformation.prototype = Object.create( Class && Class.prototype );
    Transformation.prototype.constructor = Transformation;

    Transformation.prototype.clone = function clone () {
        return new Transformation(
            this._matrix.clone()
        );
    };

    Transformation.prototype.equals = function equals (other) {
        return other &&
               other._matrix.equals(this._matrix);
    };

    Transformation.prototype.translate = function translate (x, y) {
        this._matrix = this._matrix.multiplyCopy(__WEBPACK_IMPORTED_MODULE_3__matrix__["a" /* default */].translate(x, y));

        this._optionsChange();
        return this;
    };

    Transformation.prototype.scale = function scale (scaleX, scaleY, origin) {
        if ( scaleY === void 0 ) scaleY = scaleX;
        if ( origin === void 0 ) origin = null;

        var originPoint = origin;

        if (originPoint) {
            originPoint = __WEBPACK_IMPORTED_MODULE_4__point__["a" /* default */].create(originPoint);
            this._matrix = this._matrix.multiplyCopy(__WEBPACK_IMPORTED_MODULE_3__matrix__["a" /* default */].translate(originPoint.x, originPoint.y));
        }

        this._matrix = this._matrix.multiplyCopy(__WEBPACK_IMPORTED_MODULE_3__matrix__["a" /* default */].scale(scaleX, scaleY));

        if (originPoint) {
            this._matrix = this._matrix.multiplyCopy(__WEBPACK_IMPORTED_MODULE_3__matrix__["a" /* default */].translate(-originPoint.x, -originPoint.y));
        }

        this._optionsChange();
        return this;
    };

    Transformation.prototype.rotate = function rotate (angle, origin) {
        var originPoint = __WEBPACK_IMPORTED_MODULE_4__point__["a" /* default */].create(origin) || __WEBPACK_IMPORTED_MODULE_4__point__["a" /* default */].ZERO;

        this._matrix = this._matrix.multiplyCopy(__WEBPACK_IMPORTED_MODULE_3__matrix__["a" /* default */].rotate(angle, originPoint.x, originPoint.y));

        this._optionsChange();
        return this;
    };

    Transformation.prototype.multiply = function multiply (transformation) {
        var matrix = Object(__WEBPACK_IMPORTED_MODULE_2__to_matrix__["a" /* default */])(transformation);

        this._matrix = this._matrix.multiplyCopy(matrix);

        this._optionsChange();
        return this;
    };

    Transformation.prototype.matrix = function matrix (value) {
        if (value) {
            this._matrix = value;
            this._optionsChange();
            return this;
        }

        return this._matrix;
    };

    Transformation.prototype._optionsChange = function _optionsChange () {
        this.optionsChange({
            field: "transform",
            value: this
        });
    };

    return Transformation;
}(__WEBPACK_IMPORTED_MODULE_1__common__["a" /* Class */]));

__WEBPACK_IMPORTED_MODULE_0__mixins_observers_mixin__["a" /* default */].extend(Transformation.prototype);

/* harmony default export */ __webpack_exports__["a"] = (Transformation);


/***/ }),
/* 647 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__accessors_define_accessors__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_observers_mixin__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__point__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__rect__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__math_ellipse_extreme_angles__ = __webpack_require__(648);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util__ = __webpack_require__(22);








var PI_DIV_2 = Math.PI / 2;

var Circle = (function (Class) {
    function Circle(center, radius) {
        if ( center === void 0 ) center = new __WEBPACK_IMPORTED_MODULE_2__point__["a" /* default */]();
        if ( radius === void 0 ) radius = 0;

        Class.call(this);

        this.setCenter(center);
        this.setRadius(radius);
    }

    if ( Class ) Circle.__proto__ = Class;
    Circle.prototype = Object.create( Class && Class.prototype );
    Circle.prototype.constructor = Circle;

    Circle.prototype.setCenter = function setCenter (value) {
        this._observerField("center", __WEBPACK_IMPORTED_MODULE_2__point__["a" /* default */].create(value));
        this.geometryChange();
        return this;
    };

    Circle.prototype.getCenter = function getCenter () {
        return this.center;
    };

    Circle.prototype.equals = function equals (other) {
        return other &&
               other.center.equals(this.center) &&
               other.radius === this.radius;
    };

    Circle.prototype.clone = function clone () {
        return new Circle(this.center.clone(), this.radius);
    };

    Circle.prototype.pointAt = function pointAt (angle) {
        return this._pointAt(Object(__WEBPACK_IMPORTED_MODULE_6__util__["v" /* rad */])(angle));
    };

    Circle.prototype.bbox = function bbox (matrix) {
        var this$1 = this;

        var extremeAngles = Object(__WEBPACK_IMPORTED_MODULE_4__math_ellipse_extreme_angles__["a" /* default */])(this.center, this.radius, this.radius, matrix);
        var minPoint = __WEBPACK_IMPORTED_MODULE_2__point__["a" /* default */].maxPoint();
        var maxPoint = __WEBPACK_IMPORTED_MODULE_2__point__["a" /* default */].minPoint();

        for (var i = 0; i < 4; i++) {
            var currentPointX = this$1._pointAt(extremeAngles.x + i * PI_DIV_2).transformCopy(matrix);
            var currentPointY = this$1._pointAt(extremeAngles.y + i * PI_DIV_2).transformCopy(matrix);
            var currentPoint = new __WEBPACK_IMPORTED_MODULE_2__point__["a" /* default */](currentPointX.x, currentPointY.y);

            minPoint = __WEBPACK_IMPORTED_MODULE_2__point__["a" /* default */].min(minPoint, currentPoint);
            maxPoint = __WEBPACK_IMPORTED_MODULE_2__point__["a" /* default */].max(maxPoint, currentPoint);
        }

        return __WEBPACK_IMPORTED_MODULE_3__rect__["a" /* default */].fromPoints(minPoint, maxPoint);
    };

    Circle.prototype._pointAt = function _pointAt (angle) {
        var ref = this;
        var center = ref.center;
        var radius = ref.radius;

        return new __WEBPACK_IMPORTED_MODULE_2__point__["a" /* default */](
            center.x + radius * Math.cos(angle),
            center.y + radius * Math.sin(angle)
        );
    };

    Circle.prototype.containsPoint = function containsPoint (point) {
        var ref = this;
        var center = ref.center;
        var radius = ref.radius;
        var inCircle = Math.pow(point.x - center.x, 2) +
            Math.pow(point.y - center.y, 2) <= Math.pow(radius, 2);
        return inCircle;
    };

    Circle.prototype._isOnPath = function _isOnPath (point, width) {
        var ref = this;
        var center = ref.center;
        var radius = ref.radius;
        var pointDistance = center.distanceTo(point);

        return radius - width <= pointDistance && pointDistance <= radius + width;
    };

    return Circle;
}(__WEBPACK_IMPORTED_MODULE_5__common__["a" /* Class */]));

Object(__WEBPACK_IMPORTED_MODULE_0__accessors_define_accessors__["a" /* default */])(Circle.prototype, [ "radius" ]);
__WEBPACK_IMPORTED_MODULE_1__mixins_observers_mixin__["a" /* default */].extend(Circle.prototype);

/* harmony default export */ __webpack_exports__["a"] = (Circle);

/***/ }),
/* 648 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = ellipseExtremeAngles;
function ellipseExtremeAngles(center, rx, ry, matrix) {
    var extremeX = 0;
    var extremeY = 0;

    if (matrix) {
        extremeX = Math.atan2(matrix.c * ry, matrix.a * rx);
        if (matrix.b !== 0) {
            extremeY = Math.atan2(matrix.d * ry, matrix.b * rx);
        }
    }

    return {
        x: extremeX,
        y: extremeY
    };
}

/***/ }),
/* 649 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = close;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__(22);




function close(a, b, tolerance) {
    if ( tolerance === void 0 ) tolerance = __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* PRECISION */];

    return Object(__WEBPACK_IMPORTED_MODULE_1__util__["w" /* round */])(Math.abs(a - b), tolerance) === 0;
}

/***/ }),
/* 650 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__elements_array__ = __webpack_require__(651);


var GeometryElementsArray = (function (ElementsArray) {
    function GeometryElementsArray () {
        ElementsArray.apply(this, arguments);
    }

    if ( ElementsArray ) GeometryElementsArray.__proto__ = ElementsArray;
    GeometryElementsArray.prototype = Object.create( ElementsArray && ElementsArray.prototype );
    GeometryElementsArray.prototype.constructor = GeometryElementsArray;

    GeometryElementsArray.prototype._change = function _change () {
        this.geometryChange();
    };

    return GeometryElementsArray;
}(__WEBPACK_IMPORTED_MODULE_0__elements_array__["a" /* default */]));

/* harmony default export */ __webpack_exports__["a"] = (GeometryElementsArray);

/***/ }),
/* 651 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_observers_mixin__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common__ = __webpack_require__(29);



var push = [].push;
var pop = [].pop;
var splice = [].splice;
var shift = [].shift;
var slice = [].slice;
var unshift = [].unshift;

var ElementsArray = (function (Class) {
    function ElementsArray(array) {
        if ( array === void 0 ) array = [];

        Class.call(this);

        this.length = 0;
        this._splice(0, array.length, array);
    }

    if ( Class ) ElementsArray.__proto__ = Class;
    ElementsArray.prototype = Object.create( Class && Class.prototype );
    ElementsArray.prototype.constructor = ElementsArray;

    ElementsArray.prototype.elements = function elements (value) {
        if (value) {
            this._splice(0, this.length, value);

            this._change();
            return this;
        }

        return this.slice(0);
    };

    ElementsArray.prototype.push = function push$1 () {
        var elements = arguments;
        var result = push.apply(this, elements);

        this._add(elements);

        return result;
    };

    ElementsArray.prototype.slice = function slice$1 () {
        return slice.call(this);
    };

    ElementsArray.prototype.pop = function pop$1 () {
        var length = this.length;
        var result = pop.apply(this);

        if (length) {
            this._remove([ result ]);
        }

        return result;
    };

    ElementsArray.prototype.splice = function splice (index, howMany) {
        var elements = slice.call(arguments, 2);
        var result = this._splice(index, howMany, elements);

        this._change();

        return result;
    };

    ElementsArray.prototype.shift = function shift$1 () {
        var length = this.length;
        var result = shift.apply(this);

        if (length) {
            this._remove([ result ]);
        }

        return result;
    };

    ElementsArray.prototype.unshift = function unshift$1 () {
        var elements = arguments;
        var result = unshift.apply(this, elements);

        this._add(elements);

        return result;
    };

    ElementsArray.prototype.indexOf = function indexOf (element) {
        var this$1 = this;

        var length = this.length;

        for (var idx = 0; idx < length; idx++) {
            if (this$1[idx] === element) {
                return idx;
            }
        }
        return -1;
    };

    ElementsArray.prototype._splice = function _splice (index, howMany, elements) {
        var result = splice.apply(this, [ index, howMany ].concat(elements));

        this._clearObserver(result);
        this._setObserver(elements);

        return result;
    };

    ElementsArray.prototype._add = function _add (elements) {
        this._setObserver(elements);
        this._change();
    };

    ElementsArray.prototype._remove = function _remove (elements) {
        this._clearObserver(elements);
        this._change();
    };

    ElementsArray.prototype._setObserver = function _setObserver (elements) {
        var this$1 = this;

        for (var idx = 0; idx < elements.length; idx++) {
            elements[idx].addObserver(this$1);
        }
    };

    ElementsArray.prototype._clearObserver = function _clearObserver (elements) {
        var this$1 = this;

        for (var idx = 0; idx < elements.length; idx++) {
            elements[idx].removeObserver(this$1);
        }
    };

    ElementsArray.prototype._change = function _change () {};

    return ElementsArray;
}(__WEBPACK_IMPORTED_MODULE_1__common__["a" /* Class */]));

__WEBPACK_IMPORTED_MODULE_0__mixins_observers_mixin__["a" /* default */].extend(ElementsArray.prototype);

/* harmony default export */ __webpack_exports__["a"] = (ElementsArray);


/***/ }),
/* 652 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_observers_mixin__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__accessors_define_point_accessors__ = __webpack_require__(279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__rect__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__point__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__transform__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__math_is_out_of_end_point__ = __webpack_require__(2536);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__math_calculate_curve_at__ = __webpack_require__(403);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__math_has_roots_in_range__ = __webpack_require__(2537);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__math_curve_intersections_count__ = __webpack_require__(2539);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__math_line_intersections_count__ = __webpack_require__(655);













var Segment = (function (Class) {
    function Segment(anchor, controlIn, controlOut) {
        Class.call(this);

        this.anchor(anchor || new __WEBPACK_IMPORTED_MODULE_4__point__["a" /* default */]());
        this.controlIn(controlIn);
        this.controlOut(controlOut);
    }

    if ( Class ) Segment.__proto__ = Class;
    Segment.prototype = Object.create( Class && Class.prototype );
    Segment.prototype.constructor = Segment;

    Segment.prototype.bboxTo = function bboxTo (toSegment, matrix) {
        var segmentAnchor = this.anchor().transformCopy(matrix);
        var toSegmentAnchor = toSegment.anchor().transformCopy(matrix);
        var rect;

        if (this.controlOut() && toSegment.controlIn()) {
            rect = this._curveBoundingBox(
                segmentAnchor, this.controlOut().transformCopy(matrix),
                toSegment.controlIn().transformCopy(matrix), toSegmentAnchor
            );
        } else {
            rect = this._lineBoundingBox(segmentAnchor, toSegmentAnchor);
        }

        return rect;
    };

    Segment.prototype._lineBoundingBox = function _lineBoundingBox (p1, p2) {
        return __WEBPACK_IMPORTED_MODULE_3__rect__["a" /* default */].fromPoints(p1, p2);
    };

    Segment.prototype._curveBoundingBox = function _curveBoundingBox (p1, cp1, cp2, p2) {
        var points = [ p1, cp1, cp2, p2 ];
        var extremesX = this._curveExtremesFor(points, "x");
        var extremesY = this._curveExtremesFor(points, "y");
        var xLimits = arrayLimits([ extremesX.min, extremesX.max, p1.x, p2.x ]);
        var yLimits = arrayLimits([ extremesY.min, extremesY.max, p1.y, p2.y ]);

        return __WEBPACK_IMPORTED_MODULE_3__rect__["a" /* default */].fromPoints(new __WEBPACK_IMPORTED_MODULE_4__point__["a" /* default */](xLimits.min, yLimits.min), new __WEBPACK_IMPORTED_MODULE_4__point__["a" /* default */](xLimits.max, yLimits.max));
    };

    Segment.prototype._curveExtremesFor = function _curveExtremesFor (points, field) {
        var extremes = this._curveExtremes(
            points[0][field], points[1][field],
            points[2][field], points[3][field]
        );

        return {
            min: Object(__WEBPACK_IMPORTED_MODULE_8__math_calculate_curve_at__["a" /* default */])(extremes.min, field, points),
            max: Object(__WEBPACK_IMPORTED_MODULE_8__math_calculate_curve_at__["a" /* default */])(extremes.max, field, points)
        };
    };

    Segment.prototype._curveExtremes = function _curveExtremes (x1, x2, x3, x4) {
        var a = x1 - 3 * x2 + 3 * x3 - x4;
        var b = - 2 * (x1 - 2 * x2 + x3);
        var c = x1 - x2;
        var sqrt = Math.sqrt(b * b - 4 * a * c);
        var t1 = 0;
        var t2 = 1;

        if (a === 0) {
            if (b !== 0) {
                t1 = t2 = -c / b;
            }
        } else if (!isNaN(sqrt)) {
            t1 = (- b + sqrt) / (2 * a);
            t2 = (- b - sqrt) / (2 * a);
        }

        var min = Math.max(Math.min(t1, t2), 0);
        if (min < 0 || min > 1) {
            min = 0;
        }

        var max = Math.min(Math.max(t1, t2), 1);
        if (max > 1 || max < 0) {
            max = 1;
        }

        return {
            min: min,
            max: max
        };
    };

    Segment.prototype._intersectionsTo = function _intersectionsTo (segment, point) {
        var intersectionsCount;
        if (this.controlOut() && segment.controlIn()) {
            intersectionsCount = Object(__WEBPACK_IMPORTED_MODULE_10__math_curve_intersections_count__["a" /* default */])([ this.anchor(), this.controlOut(), segment.controlIn(), segment.anchor() ], point, this.bboxTo(segment));
        } else {
            intersectionsCount = Object(__WEBPACK_IMPORTED_MODULE_11__math_line_intersections_count__["a" /* default */])(this.anchor(), segment.anchor(), point);
        }
        return intersectionsCount;
    };

    Segment.prototype._isOnCurveTo = function _isOnCurveTo (segment, point, width, endSegment) {
        var bbox = this.bboxTo(segment).expand(width, width);
        if (bbox.containsPoint(point)) {
            var p1 = this.anchor();
            var p2 = this.controlOut();
            var p3 = segment.controlIn();
            var p4 = segment.anchor();

            if (endSegment === "start" && p1.distanceTo(point) <= width) {
                return !Object(__WEBPACK_IMPORTED_MODULE_7__math_is_out_of_end_point__["a" /* default */])(p1, p2, point);
            } else if (endSegment === "end" && p4.distanceTo(point) <= width) {
                return !Object(__WEBPACK_IMPORTED_MODULE_7__math_is_out_of_end_point__["a" /* default */])(p4, p3, point);
            }

            //the approach is not entirely correct but is close and the alternatives are solving a 6th degree polynomial or testing the segment points
            var points = [ p1, p2, p3, p4 ];
            if (Object(__WEBPACK_IMPORTED_MODULE_9__math_has_roots_in_range__["a" /* default */])(points, point, "x", "y", width) || Object(__WEBPACK_IMPORTED_MODULE_9__math_has_roots_in_range__["a" /* default */])(points, point, "y", "x", width)) {
                return true;
            }
            var rotation = Object(__WEBPACK_IMPORTED_MODULE_5__transform__["a" /* default */])().rotate(45, point);
            var rotatedPoints = [ p1.transformCopy(rotation), p2.transformCopy(rotation), p3.transformCopy(rotation), p4.transformCopy(rotation) ];
            return Object(__WEBPACK_IMPORTED_MODULE_9__math_has_roots_in_range__["a" /* default */])(rotatedPoints, point, "x", "y", width) || Object(__WEBPACK_IMPORTED_MODULE_9__math_has_roots_in_range__["a" /* default */])(rotatedPoints, point, "y", "x", width);
        }
    };

    Segment.prototype._isOnLineTo = function _isOnLineTo (segment, point, width) {
        var p1 = this.anchor();
        var p2 = segment.anchor();
        var angle = Object(__WEBPACK_IMPORTED_MODULE_6__util__["i" /* deg */])(Math.atan2(p2.y - p1.y, p2.x - p1.x));
        var rect = new __WEBPACK_IMPORTED_MODULE_3__rect__["a" /* default */]([ p1.x, p1.y - width / 2 ], [ p1.distanceTo(p2), width ]);
        return rect.containsPoint(point.transformCopy(Object(__WEBPACK_IMPORTED_MODULE_5__transform__["a" /* default */])().rotate(-angle, p1)));
    };

    Segment.prototype._isOnPathTo = function _isOnPathTo (segment, point, width, endSegment) {
        var isOnPath;
        if (this.controlOut() && segment.controlIn()) {
            isOnPath = this._isOnCurveTo(segment, point, width / 2, endSegment);
        } else {
            isOnPath = this._isOnLineTo(segment, point, width);
        }
        return isOnPath;
    };

    return Segment;
}(__WEBPACK_IMPORTED_MODULE_1__common__["a" /* Class */]));

Object(__WEBPACK_IMPORTED_MODULE_2__accessors_define_point_accessors__["a" /* default */])(Segment.prototype, [ "anchor", "controlIn", "controlOut" ]);
__WEBPACK_IMPORTED_MODULE_0__mixins_observers_mixin__["a" /* default */].extend(Segment.prototype);

function arrayLimits(arr) {
    var length = arr.length;
    var min = __WEBPACK_IMPORTED_MODULE_6__util__["a" /* MAX_NUM */];
    var max = __WEBPACK_IMPORTED_MODULE_6__util__["b" /* MIN_NUM */];

    for (var i = 0; i < length; i ++) {
        max = Math.max(max, arr[i]);
        min = Math.min(min, arr[i]);
    }

    return {
        min: min,
        max: max
    };
}

/* harmony default export */ __webpack_exports__["a"] = (Segment);

/***/ }),
/* 653 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = toCubicPolynomial;
function toCubicPolynomial(points, field) {
    return [ -points[0][field] + 3 * points[1][field] - 3 * points[2][field] + points[3][field],
        3 * (points[0][field] - 2 * points[1][field] + points[2][field]),
        3 * (-points[0][field] + points[1][field]),
        points[0][field]
    ];
}

/***/ }),
/* 654 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = solveCubicEquation;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__complex_number__ = __webpack_require__(2538);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util__ = __webpack_require__(22);




function numberSign(x) {
    return x < 0 ? -1 : 1;
}

function solveQuadraticEquation(a, b, c) {
    var squareRoot = Math.sqrt(Math.pow(b, 2) - 4 * a * c);
    return [
        (-b + squareRoot) / (2 * a),
        (-b - squareRoot) / (2 * a)
    ];
}

//Cardano's formula
function solveCubicEquation(a, b, c, d) {
    if (a === 0) {
        return solveQuadraticEquation(b, c, d);
    }

    var p = (3 * a * c - Math.pow(b, 2)) / (3 * Math.pow(a, 2));
    var q = (2 * Math.pow(b, 3) - 9 * a * b * c + 27 * Math.pow(a, 2) * d) / (27 * Math.pow(a, 3));
    var Q = Math.pow(p / 3, 3) + Math.pow(q / 2, 2);
    var i = new __WEBPACK_IMPORTED_MODULE_0__complex_number__["a" /* default */](0,1);
    var b3a = -b / (3 * a);
    var x1, x2, y1, y2, y3, z1, z2;

    if (Q < 0) {
        x1 = new __WEBPACK_IMPORTED_MODULE_0__complex_number__["a" /* default */](-q / 2, Math.sqrt(-Q)).nthRoot(3);
        x2 = new __WEBPACK_IMPORTED_MODULE_0__complex_number__["a" /* default */](-q / 2, - Math.sqrt(-Q)).nthRoot(3);
    } else {
        x1 = -q / 2 + Math.sqrt(Q);
        x1 = new __WEBPACK_IMPORTED_MODULE_0__complex_number__["a" /* default */](numberSign(x1) * Math.pow(Math.abs(x1), 1 / 3));
        x2 = -q / 2 - Math.sqrt(Q);
        x2 = new __WEBPACK_IMPORTED_MODULE_0__complex_number__["a" /* default */](numberSign(x2) * Math.pow(Math.abs(x2), 1 / 3));
    }

    y1 = x1.add(x2);

    z1 = x1.add(x2).multiplyConstant(-1 / 2);
    z2 = x1.add(x2.negate()).multiplyConstant(Math.sqrt(3) / 2);

    y2 = z1.add(i.multiply(z2));
    y3 = z1.add(i.negate().multiply(z2));

    var result = [];

    if (y1.isReal()) {
        result.push(Object(__WEBPACK_IMPORTED_MODULE_2__util__["w" /* round */])(y1.real + b3a, __WEBPACK_IMPORTED_MODULE_1__constants__["a" /* PRECISION */]));
    }
    if (y2.isReal()) {
        result.push(Object(__WEBPACK_IMPORTED_MODULE_2__util__["w" /* round */])(y2.real + b3a, __WEBPACK_IMPORTED_MODULE_1__constants__["a" /* PRECISION */]));
    }
    if (y3.isReal()) {
        result.push(Object(__WEBPACK_IMPORTED_MODULE_2__util__["w" /* round */])(y3.real + b3a, __WEBPACK_IMPORTED_MODULE_1__constants__["a" /* PRECISION */]));
    }

    return result;
}

/***/ }),
/* 655 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = lineIntersectionsCount;
function lineIntersectionsCount(a, b, point) {
    var intersects;
    if (a.x !== b.x) {
        var minX = Math.min(a.x, b.x);
        var maxX = Math.max(a.x, b.x);
        var minY = Math.min(a.y, b.y);
        var maxY = Math.max(a.y, b.y);
        var inRange = minX <= point.x && point.x < maxX;

        if (minY === maxY) {
            intersects = point.y <= minY && inRange;
        } else {
            intersects = inRange && (((maxY - minY) * ((a.x - b.x) * (a.y - b.y) > 0 ? point.x - minX : maxX - point.x)) / (maxX - minX) + minY - point.y) >= 0;
        }
    }

    return intersects ? 1 : 0;
}

/***/ }),
/* 656 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shapes_multi_path__ = __webpack_require__(657);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__geometry_point__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shape_map__ = __webpack_require__(2540);





var SEGMENT_REGEX = /([a-df-z]{1})([^a-df-z]*)(z)?/gi;
var SPLIT_REGEX = /[,\s]?([+\-]?(?:\d*\.\d+|\d+)(?:[eE][+\-]?\d+)?)/g;
var MOVE = "m";
var CLOSE = "z";

function parseParameters(str) {
    var parameters = [];
    str.replace(SPLIT_REGEX, function(match, number) {
        parameters.push(parseFloat(number));
    });
    return parameters;
}

var PathParser = (function (Class) {
    function PathParser () {
        Class.apply(this, arguments);
    }

    if ( Class ) PathParser.__proto__ = Class;
    PathParser.prototype = Object.create( Class && Class.prototype );
    PathParser.prototype.constructor = PathParser;

    PathParser.prototype.parse = function parse (str, options) {
        var multiPath = new __WEBPACK_IMPORTED_MODULE_1__shapes_multi_path__["a" /* default */](options);
        var position = new __WEBPACK_IMPORTED_MODULE_2__geometry_point__["a" /* default */]();
        var previousCommand;

        str.replace(SEGMENT_REGEX, function (match, element, params, closePath) {
            var command = element.toLowerCase();
            var isRelative = command === element;
            var parameters = parseParameters(params.trim());

            if (command === MOVE) {
                if (isRelative) {
                    position.x += parameters[0];
                    position.y += parameters[1];
                } else {
                    position.x = parameters[0];
                    position.y = parameters[1];
                }

                multiPath.moveTo(position.x, position.y);

                if (parameters.length > 2) {
                    command = "l";
                    parameters.splice(0, 2);
                }
            }

            if (__WEBPACK_IMPORTED_MODULE_3__shape_map__["a" /* default */][command]) {
                __WEBPACK_IMPORTED_MODULE_3__shape_map__["a" /* default */][command](
                    multiPath, {
                        parameters: parameters,
                        position: position,
                        isRelative: isRelative,
                        previousCommand: previousCommand
                    }
                );

                if (closePath && closePath.toLowerCase() === CLOSE) {
                    multiPath.close();
                }
            } else if (command !== MOVE) {
                throw new Error("Error while parsing SVG path. Unsupported command: " + command);
            }

            previousCommand = command;
        });

        return multiPath;
    };

    return PathParser;
}(__WEBPACK_IMPORTED_MODULE_0__common__["a" /* Class */]));

PathParser.current = new PathParser();

/* harmony default export */ __webpack_exports__["a"] = (PathParser);


/***/ }),
/* 657 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__geometry_elements_array__ = __webpack_require__(650);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__element__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__path__ = __webpack_require__(402);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_paintable__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_measurable__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_elements_bounding_box__ = __webpack_require__(658);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_elements_clippend_bounding_box__ = __webpack_require__(659);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util__ = __webpack_require__(22);









var MultiPath = (function (Element) {
    function MultiPath(options) {
        Element.call(this, options);
        this.paths = new __WEBPACK_IMPORTED_MODULE_0__geometry_elements_array__["a" /* default */]();
        this.paths.addObserver(this);

        if (!Object(__WEBPACK_IMPORTED_MODULE_7__util__["g" /* defined */])(this.options.stroke)) {
            this.stroke("#000");
        }
    }

    if ( Element ) MultiPath.__proto__ = Element;
    MultiPath.prototype = Object.create( Element && Element.prototype );
    MultiPath.prototype.constructor = MultiPath;

    MultiPath.prototype.moveTo = function moveTo (x, y) {
        var path = new __WEBPACK_IMPORTED_MODULE_2__path__["a" /* default */]();
        path.moveTo(x, y);

        this.paths.push(path);

        return this;
    };

    MultiPath.prototype.lineTo = function lineTo (x, y) {
        if (this.paths.length > 0) {
            Object(__WEBPACK_IMPORTED_MODULE_7__util__["q" /* last */])(this.paths).lineTo(x, y);
        }

        return this;
    };

    MultiPath.prototype.curveTo = function curveTo (controlOut, controlIn, point) {
        if (this.paths.length > 0) {
            Object(__WEBPACK_IMPORTED_MODULE_7__util__["q" /* last */])(this.paths).curveTo(controlOut, controlIn, point);
        }

        return this;
    };

    MultiPath.prototype.arc = function arc (startAngle, endAngle, radiusX, radiusY, anticlockwise) {
        if (this.paths.length > 0) {
            Object(__WEBPACK_IMPORTED_MODULE_7__util__["q" /* last */])(this.paths).arc(startAngle, endAngle, radiusX, radiusY, anticlockwise);
        }

        return this;
    };

    MultiPath.prototype.arcTo = function arcTo (end, rx, ry, largeArc, swipe, rotation) {
        if (this.paths.length > 0) {
            Object(__WEBPACK_IMPORTED_MODULE_7__util__["q" /* last */])(this.paths).arcTo(end, rx, ry, largeArc, swipe, rotation);
        }

        return this;
    };

    MultiPath.prototype.close = function close () {
        if (this.paths.length > 0) {
            Object(__WEBPACK_IMPORTED_MODULE_7__util__["q" /* last */])(this.paths).close();
        }

        return this;
    };

    MultiPath.prototype._bbox = function _bbox (matrix) {
        return Object(__WEBPACK_IMPORTED_MODULE_5__utils_elements_bounding_box__["a" /* default */])(this.paths, true, matrix);
    };

    MultiPath.prototype.rawBBox = function rawBBox () {
        return Object(__WEBPACK_IMPORTED_MODULE_5__utils_elements_bounding_box__["a" /* default */])(this.paths, false);
    };

    MultiPath.prototype._containsPoint = function _containsPoint (point) {
        var paths = this.paths;

        for (var idx = 0; idx < paths.length; idx++) {
            if (paths[idx]._containsPoint(point)) {
                return true;
            }
        }
        return false;
    };

    MultiPath.prototype._isOnPath = function _isOnPath (point) {
        var paths = this.paths;
        var width = this.options.stroke.width;

        for (var idx = 0; idx < paths.length; idx++) {
            if (paths[idx]._isOnPath(point, width)) {
                return true;
            }
        }
        return false;
    };

    MultiPath.prototype._clippedBBox = function _clippedBBox (transformation) {
        return Object(__WEBPACK_IMPORTED_MODULE_6__utils_elements_clippend_bounding_box__["a" /* default */])(this.paths, this.currentTransform(transformation));
    };

    return MultiPath;
}(__WEBPACK_IMPORTED_MODULE_1__element__["a" /* default */]));

MultiPath.prototype.nodeType = "MultiPath";

__WEBPACK_IMPORTED_MODULE_3__mixins_paintable__["a" /* default */].extend(MultiPath.prototype);
__WEBPACK_IMPORTED_MODULE_4__mixins_measurable__["a" /* default */].extend(MultiPath.prototype);

/* harmony default export */ __webpack_exports__["a"] = (MultiPath);

/***/ }),
/* 658 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = elementsBoundingBox;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__geometry_rect__ = __webpack_require__(64);


function elementsBoundingBox(elements, applyTransform, transformation) {
    var boundingBox;

    for (var i = 0; i < elements.length; i++) {
        var element = elements[i];
        if (element.visible()) {
            var elementBoundingBox = applyTransform ? element.bbox(transformation) : element.rawBBox();
            if (elementBoundingBox) {
                if (boundingBox) {
                    boundingBox = __WEBPACK_IMPORTED_MODULE_0__geometry_rect__["a" /* default */].union(boundingBox, elementBoundingBox);
                } else {
                    boundingBox = elementBoundingBox;
                }
            }
        }
    }

    return boundingBox;
}



/***/ }),
/* 659 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = elementsClippedBoundingBox;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__geometry_rect__ = __webpack_require__(64);


function elementsClippedBoundingBox(elements, transformation) {
    var boundingBox;

    for (var i = 0; i < elements.length; i++) {
        var element = elements[i];
        if (element.visible()) {
            var elementBoundingBox = element.clippedBBox(transformation);
            if (elementBoundingBox) {
                if (boundingBox) {
                    boundingBox = __WEBPACK_IMPORTED_MODULE_0__geometry_rect__["a" /* default */].union(boundingBox, elementBoundingBox);
                } else {
                    boundingBox = elementBoundingBox;
                }
            }
        }
    }

    return boundingBox;
}

/***/ }),
/* 660 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = alignStart;

function alignStart(size, rect, align, axis, sizeField) {
    var start;
    if (align === "start") {
        start = rect.origin[axis];
    } else if (align === "end") {
        start = rect.origin[axis] + rect.size[sizeField] - size;
    } else {
        start = rect.origin[axis] + (rect.size[sizeField] - size) / 2;
    }

    return start;
}

/***/ }),
/* 661 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = alignElements;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__translate_to_point__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__align_start__ = __webpack_require__(660);



function alignElements(elements, rect, alignment, axis, sizeField) {
    for (var idx = 0; idx < elements.length; idx++) {
        var bbox = elements[idx].clippedBBox();
        if (bbox) {
            var point = bbox.origin.clone();
            point[axis] = Object(__WEBPACK_IMPORTED_MODULE_1__align_start__["a" /* default */])(bbox.size[sizeField], rect, alignment || "start", axis, sizeField);
            Object(__WEBPACK_IMPORTED_MODULE_0__translate_to_point__["a" /* default */])(point, bbox, elements[idx]);
        }
    }
}

/***/ }),
/* 662 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createStackElements;
function createStackElements(elements) {
    var stackElements = [];

    for (var idx = 0; idx < elements.length; idx++) {
        var element = elements[idx];
        var bbox = element.clippedBBox();
        if (bbox) {
            stackElements.push({
                element: element,
                bbox: bbox
            });
        }
    }

    return stackElements;
}

/***/ }),
/* 663 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = wrapElements;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__translate_to_point__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__stack_elements__ = __webpack_require__(405);



function getStacks(elements, rect, sizeField) {
    var maxSize = rect.size[sizeField];
    var stacks = [];
    var stack = [];
    var stackSize = 0;
    var element, bbox;

    var addElementToStack = function() {
        stack.push({
            element: element,
            bbox: bbox
        });
    };

    for (var idx = 0; idx < elements.length; idx++) {
        element = elements[idx];

        bbox = element.clippedBBox();
        if (bbox) {
            var size = bbox.size[sizeField];
            if (stackSize + size > maxSize) {
                if (stack.length) {
                    stacks.push(stack);
                    stack = [];
                    addElementToStack();
                    stackSize = size;
                } else {
                    addElementToStack();
                    stacks.push(stack);
                    stack = [];
                    stackSize = 0;
                }
            } else {
                addElementToStack();
                stackSize += size;
            }
        }
    }

    if (stack.length) {
        stacks.push(stack);
    }

    return stacks;
}

function wrapElements(elements, rect, axis, otherAxis, sizeField) {
    var stacks = getStacks(elements, rect, sizeField);
    var origin = rect.origin.clone();
    var result = [];

    for (var idx = 0; idx < stacks.length; idx++) {
        var stack = stacks[idx];
        var startElement = stack[0];
        origin[otherAxis] = startElement.bbox.origin[otherAxis];
        Object(__WEBPACK_IMPORTED_MODULE_0__translate_to_point__["a" /* default */])(origin, startElement.bbox, startElement.element);
        startElement.bbox.origin[axis] = origin[axis];
        Object(__WEBPACK_IMPORTED_MODULE_1__stack_elements__["a" /* default */])(stack, axis, otherAxis, sizeField);
        result.push([]);
        for (var elementIdx = 0; elementIdx < stack.length; elementIdx++) {
            result[idx].push(stack[elementIdx].element);
        }
    }
    return result;
}

/***/ }),
/* 664 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__accessors_define_options_accessors__ = __webpack_require__(2556);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_options_store__ = __webpack_require__(399);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_observers_mixin__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util__ = __webpack_require__(22);






var GradientStop = (function (Class) {
    function GradientStop(offset, color, opacity) {
        Class.call(this);

        this.options = new __WEBPACK_IMPORTED_MODULE_1__core_options_store__["a" /* default */]({
            offset: offset,
            color: color,
            opacity: Object(__WEBPACK_IMPORTED_MODULE_4__util__["g" /* defined */])(opacity) ? opacity : 1
        });
        this.options.addObserver(this);
    }

    if ( Class ) GradientStop.__proto__ = Class;
    GradientStop.prototype = Object.create( Class && Class.prototype );
    GradientStop.prototype.constructor = GradientStop;

    GradientStop.create = function create (arg) {
        if (Object(__WEBPACK_IMPORTED_MODULE_4__util__["g" /* defined */])(arg)) {
            var stop;
            if (arg instanceof GradientStop) {
                stop = arg;
            } else if (arg.length > 1) {
                stop = new GradientStop(arg[0], arg[1], arg[2]);
            } else {
                stop = new GradientStop(arg.offset, arg.color, arg.opacity);
            }

            return stop;
        }
    };

    return GradientStop;
}(__WEBPACK_IMPORTED_MODULE_3__common__["a" /* Class */]));

Object(__WEBPACK_IMPORTED_MODULE_0__accessors_define_options_accessors__["a" /* default */])(GradientStop.prototype, [ "offset", "color", "opacity" ]);
__WEBPACK_IMPORTED_MODULE_2__mixins_observers_mixin__["a" /* default */].extend(GradientStop.prototype);

/* harmony default export */ __webpack_exports__["a"] = (GradientStop);


/***/ }),
/* 665 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common__ = __webpack_require__(29);


var AnimationFactory = (function (Class) {
    function AnimationFactory() {
        Class.call(this);

        this._items = [];
    }

    if ( Class ) AnimationFactory.__proto__ = Class;
    AnimationFactory.prototype = Object.create( Class && Class.prototype );
    AnimationFactory.prototype.constructor = AnimationFactory;

    AnimationFactory.prototype.register = function register (name, type) {
        this._items.push({
            name: name,
            type: type
        });
    };

    AnimationFactory.prototype.create = function create (element, options) {
        var items = this._items;
        var match;

        if (options && options.type) {
            var type = options.type.toLowerCase();
            for (var i = 0; i < items.length; i++) {
                if (items[i].name.toLowerCase() === type) {
                    match = items[i];
                    break;
                }
            }
        }

        if (match) {
            return new match.type(element, options);
        }
    };

    return AnimationFactory;
}(__WEBPACK_IMPORTED_MODULE_0__common__["a" /* Class */]));

AnimationFactory.current = new AnimationFactory();

/* harmony default export */ __webpack_exports__["a"] = (AnimationFactory);


/***/ }),
/* 666 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = renderStyle;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util__ = __webpack_require__(22);


function renderStyle(attrs) {
    var output = "";
    for (var i = 0; i < attrs.length; i++) {
        var value = attrs[i][1];
        if (Object(__WEBPACK_IMPORTED_MODULE_0__util__["g" /* defined */])(value)) {
            output += attrs[i][0] + ":" + value + ";";
        }
    }

    if (output !== "") {
        return output;
    }
}

/***/ }),
/* 667 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(205);


var renderSVG = function(container, svg) {
    container.innerHTML = svg;
};

if (typeof document !== "undefined") {
    var testFragment = "<svg xmlns='" + __WEBPACK_IMPORTED_MODULE_0__constants__["b" /* SVG_NS */] + "'></svg>";
    var testContainer = document.createElement("div");
    var hasParser = typeof DOMParser !== "undefined";

    testContainer.innerHTML = testFragment;

    if (hasParser && testContainer.firstChild.namespaceURI !== __WEBPACK_IMPORTED_MODULE_0__constants__["b" /* SVG_NS */]) {
        renderSVG = function(container, svg) {
            var parser = new DOMParser();
            var chartDoc = parser.parseFromString(svg, "text/xml");
            var importedDoc = document.adoptNode(chartDoc.documentElement);

            container.innerHTML = "";
            container.appendChild(importedDoc);
        };
    }
}

/* harmony default export */ __webpack_exports__["a"] = (renderSVG);

/***/ }),
/* 668 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__gradients_linear_gradient__ = __webpack_require__(406);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__gradients_radial_gradient__ = __webpack_require__(408);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__linear_gradient_node__ = __webpack_require__(669);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__radial_gradient_node__ = __webpack_require__(672);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__node__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__clip_node__ = __webpack_require__(673);







var DefinitionNode = (function (Node) {
    function DefinitionNode() {
        Node.call(this);
        this.definitionMap = {};
    }

    if ( Node ) DefinitionNode.__proto__ = Node;
    DefinitionNode.prototype = Object.create( Node && Node.prototype );
    DefinitionNode.prototype.constructor = DefinitionNode;

    DefinitionNode.prototype.attachTo = function attachTo (domElement) {
        this.element = domElement;
    };

    DefinitionNode.prototype.template = function template () {
        return ("<defs>" + (this.renderChildren()) + "</defs>");
    };

    DefinitionNode.prototype.definitionChange = function definitionChange (e) {
        var definitions = e.definitions;
        var action = e.action;

        if (action === "add") {
            this.addDefinitions(definitions);
        } else if (action === "remove") {
            this.removeDefinitions(definitions);
        }
    };

    DefinitionNode.prototype.createDefinition = function createDefinition (type, item) {
        var nodeType;
        if (type === "clip") {
            nodeType = __WEBPACK_IMPORTED_MODULE_5__clip_node__["a" /* default */];
        } else if (type === "fill") {
            if (item instanceof __WEBPACK_IMPORTED_MODULE_0__gradients_linear_gradient__["a" /* default */]) {
                nodeType = __WEBPACK_IMPORTED_MODULE_2__linear_gradient_node__["a" /* default */];
            } else if (item instanceof __WEBPACK_IMPORTED_MODULE_1__gradients_radial_gradient__["a" /* default */]) {
                nodeType = __WEBPACK_IMPORTED_MODULE_3__radial_gradient_node__["a" /* default */];
            }
        }
        return new nodeType(item);
    };

    DefinitionNode.prototype.addDefinitions = function addDefinitions (definitions) {
        var this$1 = this;

        for (var field in definitions) {
            this$1.addDefinition(field, definitions[field]);
        }
    };

    DefinitionNode.prototype.addDefinition = function addDefinition (type, srcElement) {
        var ref = this;
        var element = ref.element;
        var definitionMap = ref.definitionMap;
        var id = srcElement.id;
        var mapItem = definitionMap[id];
        if (!mapItem) {
            var node = this.createDefinition(type, srcElement);
            definitionMap[id] = {
                element: node,
                count: 1
            };
            this.append(node);
            if (element) {
                node.attachTo(this.element);
            }
        } else {
            mapItem.count++;
        }
    };

    DefinitionNode.prototype.removeDefinitions = function removeDefinitions (definitions) {
        var this$1 = this;

        for (var field in definitions) {
            this$1.removeDefinition(definitions[field]);
        }
    };

    DefinitionNode.prototype.removeDefinition = function removeDefinition (srcElement) {
        var definitionMap = this.definitionMap;
        var id = srcElement.id;
        var mapItem = definitionMap[id];

        if (mapItem) {
            mapItem.count--;
            if (mapItem.count === 0) {
                this.remove(this.childNodes.indexOf(mapItem.element), 1);
                delete definitionMap[id];
            }
        }
    };

    return DefinitionNode;
}(__WEBPACK_IMPORTED_MODULE_4__node__["a" /* default */]));

/* harmony default export */ __webpack_exports__["a"] = (DefinitionNode);

/***/ }),
/* 669 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__gradient_node__ = __webpack_require__(670);


var LinearGradientNode = (function (GradientNode) {
    function LinearGradientNode () {
        GradientNode.apply(this, arguments);
    }

    if ( GradientNode ) LinearGradientNode.__proto__ = GradientNode;
    LinearGradientNode.prototype = Object.create( GradientNode && GradientNode.prototype );
    LinearGradientNode.prototype.constructor = LinearGradientNode;

    LinearGradientNode.prototype.template = function template () {
        return ("<linearGradient id='" + (this.id) + "' " + (this.renderCoordinates()) + ">" + (this.renderChildren()) + "</linearGradient>");
    };

    LinearGradientNode.prototype.mapCoordinates = function mapCoordinates () {
        var srcElement = this.srcElement;
        var start = srcElement.start();
        var end = srcElement.end();
        var attrs = [
            [ "x1", start.x ],
            [ "y1", start.y ],
            [ "x2", end.x ],
            [ "y2", end.y ],
            this.mapSpace()
        ];

        return attrs;
    };

    return LinearGradientNode;
}(__WEBPACK_IMPORTED_MODULE_0__gradient_node__["a" /* default */]));

/* harmony default export */ __webpack_exports__["a"] = (LinearGradientNode);

/***/ }),
/* 670 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__gradient_stop_node__ = __webpack_require__(671);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_base_node__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_render_all_attributes__ = __webpack_require__(282);





var GradientNode = (function (Node) {
    function GradientNode(srcElement) {
        Node.call(this, srcElement);

        this.id = srcElement.id;

        this.loadStops();
    }

    if ( Node ) GradientNode.__proto__ = Node;
    GradientNode.prototype = Object.create( Node && Node.prototype );
    GradientNode.prototype.constructor = GradientNode;

    GradientNode.prototype.loadStops = function loadStops () {
        var this$1 = this;

        var stops = this.srcElement.stops;
        var element = this.element;

        for (var idx = 0; idx < stops.length; idx++) {
            var stopNode = new __WEBPACK_IMPORTED_MODULE_0__gradient_stop_node__["a" /* default */](stops[idx]);
            this$1.append(stopNode);
            if (element) {
                stopNode.attachTo(element);
            }
        }
    };

    GradientNode.prototype.optionsChange = function optionsChange (e) {
        if (e.field === "gradient.stops") {
            __WEBPACK_IMPORTED_MODULE_1__core_base_node__["a" /* default */].prototype.clear.call(this);
            this.loadStops();
        } else if (e.field === "gradient") {
            this.allAttr(this.mapCoordinates());
        }
    };

    GradientNode.prototype.renderCoordinates = function renderCoordinates () {
        return Object(__WEBPACK_IMPORTED_MODULE_3__utils_render_all_attributes__["a" /* default */])(this.mapCoordinates());
    };

    GradientNode.prototype.mapSpace = function mapSpace () {
        return [ "gradientUnits", this.srcElement.userSpace() ? "userSpaceOnUse" : "objectBoundingBox" ];
    };

    return GradientNode;
}(__WEBPACK_IMPORTED_MODULE_2__node__["a" /* default */]));

/* harmony default export */ __webpack_exports__["a"] = (GradientNode);

/***/ }),
/* 671 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_render_attribute__ = __webpack_require__(204);



var GradientStopNode = (function (Node) {
    function GradientStopNode () {
        Node.apply(this, arguments);
    }

    if ( Node ) GradientStopNode.__proto__ = Node;
    GradientStopNode.prototype = Object.create( Node && Node.prototype );
    GradientStopNode.prototype.constructor = GradientStopNode;

    GradientStopNode.prototype.template = function template () {
        return ("<stop " + (this.renderOffset()) + " " + (this.renderStyle()) + " />");
    };

    GradientStopNode.prototype.renderOffset = function renderOffset () {
        return Object(__WEBPACK_IMPORTED_MODULE_1__utils_render_attribute__["a" /* default */])("offset", this.srcElement.offset());
    };

    GradientStopNode.prototype.mapStyle = function mapStyle () {
        var srcElement = this.srcElement;
        return [
            [ "stop-color", srcElement.color() ],
            [ "stop-opacity", srcElement.opacity() ]
        ];
    };

    GradientStopNode.prototype.optionsChange = function optionsChange (e) {
        if (e.field === "offset") {
            this.attr(e.field, e.value);
        } else if (e.field === "color" || e.field === "opacity") {
            this.css("stop-" + e.field, e.value);
        }
    };

    return GradientStopNode;
}(__WEBPACK_IMPORTED_MODULE_0__node__["a" /* default */]));

/* harmony default export */ __webpack_exports__["a"] = (GradientStopNode);

/***/ }),
/* 672 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__gradient_node__ = __webpack_require__(670);


var RadialGradientNode = (function (GradientNode) {
    function RadialGradientNode () {
        GradientNode.apply(this, arguments);
    }

    if ( GradientNode ) RadialGradientNode.__proto__ = GradientNode;
    RadialGradientNode.prototype = Object.create( GradientNode && GradientNode.prototype );
    RadialGradientNode.prototype.constructor = RadialGradientNode;

    RadialGradientNode.prototype.template = function template () {
        return ("<radialGradient id='" + (this.id) + "' " + (this.renderCoordinates()) + ">" + (this.renderChildren()) + "</radialGradient>");
    };

    RadialGradientNode.prototype.mapCoordinates = function mapCoordinates () {
        var srcElement = this.srcElement;
        var center = srcElement.center();
        var radius = srcElement.radius();
        var attrs = [
            [ "cx", center.x ],
            [ "cy", center.y ],
            [ "r", radius ],
            this.mapSpace()
        ];
        return attrs;
    };

    return RadialGradientNode;
}(__WEBPACK_IMPORTED_MODULE_0__gradient_node__["a" /* default */]));

/* harmony default export */ __webpack_exports__["a"] = (RadialGradientNode);

/***/ }),
/* 673 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node__ = __webpack_require__(101);


var ClipNode = (function (Node) {
    function ClipNode(srcElement) {
        Node.call(this);

        this.srcElement = srcElement;
        this.id = srcElement.id;

        this.load([ srcElement ]);
    }

    if ( Node ) ClipNode.__proto__ = Node;
    ClipNode.prototype = Object.create( Node && Node.prototype );
    ClipNode.prototype.constructor = ClipNode;

    ClipNode.prototype.template = function template () {
        return ("<clipPath id='" + (this.id) + "'>" + (this.renderChildren()) + "</clipPath>");
    };

    return ClipNode;
}(__WEBPACK_IMPORTED_MODULE_0__node__["a" /* default */]));

/* harmony default export */ __webpack_exports__["a"] = (ClipNode);

/***/ }),
/* 674 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DASH_ARRAYS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SOLID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BUTT; });
var DASH_ARRAYS = {
    dot: [ 1.5, 3.5 ],
    dash: [ 4, 3.5 ],
    longdash: [ 8, 3.5 ],
    dashdot: [ 3.5, 3.5, 1.5, 3.5 ],
    longdashdot: [ 8, 3.5, 1.5, 3.5 ],
    longdashdotdot: [ 8, 3.5, 1.5, 3.5, 1.5, 3.5 ]
};

var SOLID = "solid";
var BUTT = "butt";



/***/ }),
/* 675 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = exportGroup;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_node__ = __webpack_require__(410);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shapes__ = __webpack_require__(637);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__geometry__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(205);





function exportGroup(group) {
    var root = new __WEBPACK_IMPORTED_MODULE_0__root_node__["a" /* default */]({
        skipBaseHref: true
    });
    var bbox = group.clippedBBox();
    var rootGroup = group;

    if (bbox) {
        var origin = bbox.getOrigin();
        var exportRoot = new __WEBPACK_IMPORTED_MODULE_1__shapes__["b" /* Group */]();
        exportRoot.transform(Object(__WEBPACK_IMPORTED_MODULE_2__geometry__["e" /* transform */])().translate(-origin.x, -origin.y));
        exportRoot.children.push(group);
        rootGroup = exportRoot;
    }

    root.load([ rootGroup ]);

    var svg = "<?xml version='1.0' ?><svg xmlns='" + __WEBPACK_IMPORTED_MODULE_3__constants__["b" /* SVG_NS */] + "' xmlns:xlink='http://www.w3.org/1999/xlink' version='1.1'>" + (root.render()) + "</svg>";

    root.destroy();

    return svg;
}

/***/ }),
/* 676 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_surface__ = __webpack_require__(409);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_surface_factory__ = __webpack_require__(281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__root_node__ = __webpack_require__(677);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__search_shapes_quad_tree__ = __webpack_require__(679);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__surface_cursor__ = __webpack_require__(2570);







var Surface = (function (BaseSurface) {
    function Surface(element, options) {
        BaseSurface.call(this, element, options);

        this.element.innerHTML = this._template(this);

        var canvas = this.element.firstElementChild;
        var size = Object(__WEBPACK_IMPORTED_MODULE_2__util__["k" /* elementSize */])(element);

        canvas.width = size.width;
        canvas.height = size.height;

        this._rootElement = canvas;

        this._root = new __WEBPACK_IMPORTED_MODULE_3__root_node__["a" /* default */](canvas);

        this._mouseTrackHandler = this._trackMouse.bind(this);

        Object(__WEBPACK_IMPORTED_MODULE_2__util__["e" /* bindEvents */])(this.element, {
            click: this._mouseTrackHandler,
            mousemove: this._mouseTrackHandler
        });
    }

    if ( BaseSurface ) Surface.__proto__ = BaseSurface;
    Surface.prototype = Object.create( BaseSurface && BaseSurface.prototype );
    Surface.prototype.constructor = Surface;

    Surface.prototype.destroy = function destroy () {
        BaseSurface.prototype.destroy.call(this);

        if (this._root) {
            this._root.destroy();
            this._root = null;
        }

        if (this._searchTree) {
            this._searchTree.clear();
            delete this._searchTree;
        }

        if (this._cursor) {
            this._cursor.destroy();
            delete this._cursor;
        }

        Object(__WEBPACK_IMPORTED_MODULE_2__util__["x" /* unbindEvents */])(this.element, {
            click: this._mouseTrackHandler,
            mousemove: this._mouseTrackHandler
        });
    };

    Surface.prototype.draw = function draw (element) {
        BaseSurface.prototype.draw.call(this, element);
        this._root.load([ element ], undefined, this.options.cors);

        if (this._searchTree) {
            this._searchTree.add([ element ]);
        }
    };

    Surface.prototype.clear = function clear () {
        BaseSurface.prototype.clear.call(this);
        this._root.clear();

        if (this._searchTree) {
            this._searchTree.clear();
        }

        if (this._cursor) {
            this._cursor.clear();
        }
    };

    Surface.prototype.eventTarget = function eventTarget (e) {
        if (this._searchTree) {
            var point = this._surfacePoint(e);
            var shape = this._searchTree.pointShape(point);
            return shape;
        }
    };

    Surface.prototype.image = function image () {
        var ref = this;
        var root = ref._root;
        var rootElement = ref._rootElement;
        var loadingStates = [];

        root.traverse(function (childNode) {
            if (childNode.loading) {
                loadingStates.push(childNode.loading);
            }
        });

        var promise = Object(__WEBPACK_IMPORTED_MODULE_2__util__["f" /* createPromise */])();
        var resolveDataURL = function () {
            root._invalidate();

            try {
                var data = rootElement.toDataURL();
                promise.resolve(data);
            } catch (e) {
                promise.reject(e);
            }
        };

        Object(__WEBPACK_IMPORTED_MODULE_2__util__["u" /* promiseAll */])(loadingStates).then(resolveDataURL, resolveDataURL);

        return promise;
    };

    Surface.prototype.suspendTracking = function suspendTracking () {
        BaseSurface.prototype.suspendTracking.call(this);
        if (this._searchTree) {
            this._searchTree.clear();
            delete this._searchTree;
        }
    };

    Surface.prototype.resumeTracking = function resumeTracking () {
        BaseSurface.prototype.resumeTracking.call(this);
        if (!this._searchTree) {
            this._searchTree = new __WEBPACK_IMPORTED_MODULE_4__search_shapes_quad_tree__["a" /* default */]();

            var childNodes = this._root.childNodes;
            var rootElements = [];
            for (var idx = 0; idx < childNodes.length; idx++) {
                rootElements.push(childNodes[idx].srcElement);
            }
            this._searchTree.add(rootElements);
        }
    };

    Surface.prototype._resize = function _resize () {
        this._rootElement.width = this._size.width;
        this._rootElement.height = this._size.height;

        this._root.invalidate();
    };

    Surface.prototype._template = function _template () {
        return "<canvas style='width: 100%; height: 100%;'></canvas>";
    };

    Surface.prototype._enableTracking = function _enableTracking () {
        this._searchTree = new __WEBPACK_IMPORTED_MODULE_4__search_shapes_quad_tree__["a" /* default */]();
        this._cursor = new __WEBPACK_IMPORTED_MODULE_5__surface_cursor__["a" /* default */](this);

        BaseSurface.prototype._enableTracking.call(this);
    };

    Surface.prototype._trackMouse = function _trackMouse (e) {
        if (this._suspendedTracking) {
            return;
        }

        var shape = this.eventTarget(e);

        if (e.type !== "click") {
            var currentShape = this._currentShape;
            if (currentShape && currentShape !== shape) {
                this.trigger("mouseleave", {
                    element: currentShape,
                    originalEvent: e,
                    type: "mouseleave"
                });
            }

            if (shape && currentShape !== shape) {
                this.trigger("mouseenter", {
                    element: shape,
                    originalEvent: e,
                    type: "mouseenter"
                });
            }

            this.trigger("mousemove", {
                element: shape,
                originalEvent: e,
                type: "mousemove"
            });

            this._currentShape = shape;
        } else if (shape) {
            this.trigger("click", {
                element: shape,
                originalEvent: e,
                type: "click"
            });
        }
    };

    return Surface;
}(__WEBPACK_IMPORTED_MODULE_0__core_surface__["a" /* default */]));

Surface.prototype.type = "canvas";

if (typeof document !== "undefined" && document.createElement("canvas").getContext) {
    __WEBPACK_IMPORTED_MODULE_0__core_surface__["a" /* default */].support.canvas = true;
    __WEBPACK_IMPORTED_MODULE_1__core_surface_factory__["a" /* default */].current.register("canvas", Surface, 20);
}

/* harmony default export */ __webpack_exports__["a"] = (Surface);


/***/ }),
/* 677 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__group_node__ = __webpack_require__(678);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_traversable__ = __webpack_require__(404);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common__ = __webpack_require__(29);




var FRAME_DELAY = 1000 / 60;

var RootNode = (function (GroupNode) {
    function RootNode(canvas) {
        GroupNode.call(this);

        this.canvas = canvas;
        this.ctx = canvas.getContext("2d");

        var invalidateHandler = this._invalidate.bind(this);
        this.invalidate = Object(__WEBPACK_IMPORTED_MODULE_2__common__["j" /* throttle */])(function () {
            Object(__WEBPACK_IMPORTED_MODULE_2__common__["c" /* animationFrame */])(invalidateHandler);
        }, FRAME_DELAY);
    }

    if ( GroupNode ) RootNode.__proto__ = GroupNode;
    RootNode.prototype = Object.create( GroupNode && GroupNode.prototype );
    RootNode.prototype.constructor = RootNode;

    RootNode.prototype.destroy = function destroy () {
        GroupNode.prototype.destroy.call(this);
        this.canvas = null;
        this.ctx = null;
    };

    RootNode.prototype.load = function load (elements, pos, cors) {
        this.loadElements(elements, pos, cors);
        this._invalidate();
    };

    RootNode.prototype._invalidate = function _invalidate () {
        if (!this.ctx) {
            return;
        }
        this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
        this.renderTo(this.ctx);
    };

    return RootNode;
}(__WEBPACK_IMPORTED_MODULE_0__group_node__["a" /* default */]));

__WEBPACK_IMPORTED_MODULE_1__mixins_traversable__["a" /* default */].extend(RootNode.prototype, "childNodes");

/* harmony default export */ __webpack_exports__["a"] = (RootNode);

/***/ }),
/* 678 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node__ = __webpack_require__(411);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_traversable__ = __webpack_require__(404);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_map__ = __webpack_require__(87);




var GroupNode = (function (Node) {
    function GroupNode () {
        Node.apply(this, arguments);
    }

    if ( Node ) GroupNode.__proto__ = Node;
    GroupNode.prototype = Object.create( Node && Node.prototype );
    GroupNode.prototype.constructor = GroupNode;

    GroupNode.prototype.renderTo = function renderTo (ctx) {
        if (!this.visible()) {
            return;
        }

        ctx.save();

        this.setTransform(ctx);
        this.setClip(ctx);
        this.setOpacity(ctx);

        var childNodes = this.childNodes;
        for (var i = 0; i < childNodes.length; i++) {
            var child = childNodes[i];
            if (child.visible()) {
                child.renderTo(ctx);
            }
        }

        ctx.restore();
    };

    return GroupNode;
}(__WEBPACK_IMPORTED_MODULE_0__node__["a" /* default */]));

__WEBPACK_IMPORTED_MODULE_1__mixins_traversable__["a" /* default */].extend(GroupNode.prototype, "childNodes");

__WEBPACK_IMPORTED_MODULE_2__node_map__["a" /* default */].Group = GroupNode;

/* harmony default export */ __webpack_exports__["a"] = (GroupNode);

/***/ }),
/* 679 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__quad_root__ = __webpack_require__(680);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__quad_node__ = __webpack_require__(681);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__geometry__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util__ = __webpack_require__(22);






var ROOT_SIZE = 3000;
var LEVEL_STEP = 10000;
var MAX_LEVEL = 75;

var ShapesQuadTree = (function (Class) {
    function ShapesQuadTree() {
        Class.call(this);

        this.initRoots();
    }

    if ( Class ) ShapesQuadTree.__proto__ = Class;
    ShapesQuadTree.prototype = Object.create( Class && Class.prototype );
    ShapesQuadTree.prototype.constructor = ShapesQuadTree;

    ShapesQuadTree.prototype.initRoots = function initRoots () {
        this.rootMap = {};
        this.root = new __WEBPACK_IMPORTED_MODULE_0__quad_root__["a" /* default */]();
        this.rootElements = [];
    };

    ShapesQuadTree.prototype.clear = function clear () {
        var this$1 = this;

        var rootElements = this.rootElements;
        for (var idx = 0; idx < rootElements.length; idx++) {
            this$1.remove(rootElements[idx]);
        }
        this.initRoots();
    };

    ShapesQuadTree.prototype.pointShape = function pointShape (point) {
        var sectorRoot = ( this.rootMap[ Math.floor( point.x / ROOT_SIZE ) ] || {} )[ Math.floor( point.y / ROOT_SIZE ) ];
        var result = this.root.pointShapes(point);

        if (sectorRoot) {
            result = result.concat(sectorRoot.pointShapes(point));
        }

        this.assignZindex(result);

        result.sort(zIndexComparer);
        for (var idx = 0; idx < result.length; idx++) {
            if (result[idx].containsPoint(point)) {
                return result[idx];
            }
        }
    };

    ShapesQuadTree.prototype.assignZindex = function assignZindex (elements) {
        var this$1 = this;

        for (var idx = 0; idx < elements.length; idx++) {
            var element = elements[idx];
            var zIndex = 0;
            var levelWeight = Math.pow(LEVEL_STEP, MAX_LEVEL);
            var parents = [];

            while (element) {
                parents.push(element);
                element = element.parent;
            }

            while (parents.length) {
                element = parents.pop();
                zIndex += ((element.parent ? element.parent.children : this$1.rootElements).indexOf(element) + 1) * levelWeight;
                levelWeight /= LEVEL_STEP;
            }

            elements[idx]._zIndex = zIndex;
        }
    };

    ShapesQuadTree.prototype.optionsChange = function optionsChange (e) {
        if (e.field === "transform" || e.field === "stroke.width") {
            this.bboxChange(e.element);
        }
    };

    ShapesQuadTree.prototype.geometryChange = function geometryChange (e) {
        this.bboxChange(e.element);
    };

    ShapesQuadTree.prototype.bboxChange = function bboxChange (element) {
        var this$1 = this;

        if (element.nodeType === "Group") {
            for (var idx = 0; idx < element.children.length; idx++) {
                this$1.bboxChange(element.children[idx]);
            }
        } else {
            if (element._quadNode) {
                element._quadNode.remove(element);
            }
            this._insertShape(element);
        }
    };

    ShapesQuadTree.prototype.add = function add (elements) {
        var elementsArray = Array.isArray(elements) ? elements.slice(0) : [ elements ];

        Object(__WEBPACK_IMPORTED_MODULE_4__util__["c" /* append */])(this.rootElements, elementsArray);
        this._insert(elementsArray);
    };

    ShapesQuadTree.prototype.childrenChange = function childrenChange (e) {
        var this$1 = this;

        if (e.action === "remove") {
            for (var idx = 0; idx < e.items.length; idx++) {
                this$1.remove(e.items[idx]);
            }
        } else {
            this._insert(Array.prototype.slice.call(e.items, 0));
        }
    };

    ShapesQuadTree.prototype._insert = function _insert (elements) {
        var this$1 = this;

        var element;

        while (elements.length > 0) {
            element = elements.pop();
            element.addObserver(this$1);
            if (element.nodeType === "Group") {
                Object(__WEBPACK_IMPORTED_MODULE_4__util__["c" /* append */])(elements, element.children);
            } else {
                this$1._insertShape(element);
            }
        }
    };

    ShapesQuadTree.prototype._insertShape = function _insertShape (shape) {
        var bbox = shape.bbox();
        if (bbox) {
            var sectors = this.getSectors(bbox);
            var x = sectors[0][0];
            var y = sectors[1][0];

            if (this.inRoot(sectors)) {
                this.root.insert(shape, bbox);
            } else {
                var rootMap = this.rootMap;
                if (!rootMap[x]) {
                    rootMap[x] = {};
                }

                if (!rootMap[x][y]) {
                    rootMap[x][y] = new __WEBPACK_IMPORTED_MODULE_1__quad_node__["a" /* default */](
                        new __WEBPACK_IMPORTED_MODULE_2__geometry__["d" /* Rect */]([ x * ROOT_SIZE, y * ROOT_SIZE ], [ ROOT_SIZE, ROOT_SIZE ])
                    );
                }

                rootMap[x][y].insert(shape, bbox);
            }
        }
    };

    ShapesQuadTree.prototype.remove = function remove (element) {
        var this$1 = this;

        element.removeObserver(this);

        if (element.nodeType === "Group") {
            var children = element.children;
            for (var idx = 0; idx < children.length; idx++) {
                this$1.remove(children[idx]);
            }
        } else if (element._quadNode) {
            element._quadNode.remove(element);
            delete element._quadNode;
        }
    };

    ShapesQuadTree.prototype.inRoot = function inRoot (sectors) {
        return sectors[0].length > 1 || sectors[1].length > 1;
    };

    ShapesQuadTree.prototype.getSectors = function getSectors (rect) {
        var bottomRight = rect.bottomRight();
        var bottomX = Math.floor(bottomRight.x / ROOT_SIZE);
        var bottomY = Math.floor(bottomRight.y / ROOT_SIZE);
        var sectors = [ [], [] ];
        for (var x = Math.floor(rect.origin.x / ROOT_SIZE); x <= bottomX; x++) {
            sectors[0].push(x);
        }
        for (var y = Math.floor(rect.origin.y / ROOT_SIZE); y <= bottomY; y++) {
            sectors[1].push(y);
        }
        return sectors;
    };

    return ShapesQuadTree;
}(__WEBPACK_IMPORTED_MODULE_3__common__["a" /* Class */]));

function zIndexComparer(x1, x2) {
    if (x1._zIndex < x2._zIndex) {
        return 1;
    }
    if (x1._zIndex > x2._zIndex) {
        return -1;
    }

    return 0;
}

/* harmony default export */ __webpack_exports__["a"] = (ShapesQuadTree);

/***/ }),
/* 680 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common__ = __webpack_require__(29);


var QuadRoot = (function (Class) {
    function QuadRoot() {
        Class.call(this);

        this.shapes = [];
    }

    if ( Class ) QuadRoot.__proto__ = Class;
    QuadRoot.prototype = Object.create( Class && Class.prototype );
    QuadRoot.prototype.constructor = QuadRoot;

    QuadRoot.prototype._add = function _add (shape, bbox) {
        this.shapes.push({
            bbox: bbox,
            shape: shape
        });
        shape._quadNode = this;
    };

    QuadRoot.prototype.pointShapes = function pointShapes (point) {
        var shapes = this.shapes;
        var length = shapes.length;
        var result = [];
        for (var idx = 0; idx < length; idx++) {
            if (shapes[idx].bbox.containsPoint(point)) {
                result.push(shapes[idx].shape);
            }
        }
        return result;
    };

    QuadRoot.prototype.insert = function insert (shape, bbox) {
        this._add(shape, bbox);
    };

    QuadRoot.prototype.remove = function remove (shape) {
        var shapes = this.shapes;
        var length = shapes.length;

        for (var idx = 0; idx < length; idx++) {
            if (shapes[idx].shape === shape) {
                shapes.splice(idx, 1);
                break;
            }
        }
    };

    return QuadRoot;
}(__WEBPACK_IMPORTED_MODULE_0__common__["a" /* Class */]));

/* harmony default export */ __webpack_exports__["a"] = (QuadRoot);

/***/ }),
/* 681 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__quad_root__ = __webpack_require__(680);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__geometry__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util__ = __webpack_require__(22);




var QuadNode = (function (QuadRoot) {
    function QuadNode(rect) {
        QuadRoot.call(this);
        this.children = [];
        this.rect = rect;
    }

    if ( QuadRoot ) QuadNode.__proto__ = QuadRoot;
    QuadNode.prototype = Object.create( QuadRoot && QuadRoot.prototype );
    QuadNode.prototype.constructor = QuadNode;

    QuadNode.prototype.inBounds = function inBounds (rect) {
        var nodeRect = this.rect;
        var nodeBottomRight = nodeRect.bottomRight();
        var bottomRight = rect.bottomRight();
        var inBounds = nodeRect.origin.x <= rect.origin.x && nodeRect.origin.y <= rect.origin.y && bottomRight.x <= nodeBottomRight.x &&
            bottomRight.y <= nodeBottomRight.y;
        return inBounds;
    };

    QuadNode.prototype.pointShapes = function pointShapes (point) {
        var children = this.children;
        var length = children.length;
        var result = QuadRoot.prototype.pointShapes.call(this, point);
        for (var idx = 0; idx < length; idx++) {
            Object(__WEBPACK_IMPORTED_MODULE_2__util__["c" /* append */])(result, children[idx].pointShapes(point));
        }
        return result;
    };

    QuadNode.prototype.insert = function insert (shape, bbox) {
        var children = this.children;
        var inserted = false;

        if (this.inBounds(bbox)) {
            if (this.shapes.length < 4) {
                this._add(shape, bbox);
            } else {
                if (!children.length) {
                    this._initChildren();
                }

                for (var idx = 0; idx < children.length; idx++) {
                    if (children[idx].insert(shape, bbox)) {
                        inserted = true;
                        break;
                    }
                }

                if (!inserted) {
                    this._add(shape, bbox);
                }
            }
            inserted = true;
        }

        return inserted;
    };

    QuadNode.prototype._initChildren = function _initChildren () {
        var ref = this;
        var rect = ref.rect;
        var children = ref.children;
        var center = rect.center();
        var halfWidth = rect.width() / 2;
        var halfHeight = rect.height() / 2;

        children.push(
            new QuadNode(new __WEBPACK_IMPORTED_MODULE_1__geometry__["d" /* Rect */]([ rect.origin.x, rect.origin.y ], [ halfWidth, halfHeight ])),
            new QuadNode(new __WEBPACK_IMPORTED_MODULE_1__geometry__["d" /* Rect */]([ center.x, rect.origin.y ], [ halfWidth, halfHeight ])),
            new QuadNode(new __WEBPACK_IMPORTED_MODULE_1__geometry__["d" /* Rect */]([ rect.origin.x, center.y ], [ halfWidth, halfHeight ])),
            new QuadNode(new __WEBPACK_IMPORTED_MODULE_1__geometry__["d" /* Rect */]([ center.x, center.y ], [ halfWidth, halfHeight ]))
        );
    };

    return QuadNode;
}(__WEBPACK_IMPORTED_MODULE_0__quad_root__["a" /* default */]));

/* harmony default export */ __webpack_exports__["a"] = (QuadNode);

/***/ }),
/* 682 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PDFDocument; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return defineFont; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return parseFontDef; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getFontURL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return loadFonts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return loadImages; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getPaperOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return clearImageCache; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return TEXT_RENDERING_MODE; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(683);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ttf__ = __webpack_require__(2579);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__deflate__ = __webpack_require__(2580);
/* unused harmony reexport BinaryStream */
/* eslint-disable no-multi-spaces, key-spacing, indent, camelcase, space-before-blocks, eqeqeq, brace-style */
/* eslint-disable space-infix-ops, space-before-function-paren, array-bracket-spacing, object-curly-spacing */
/* eslint-disable no-nested-ternary, max-params, default-case, no-else-return, no-empty */
/* eslint-disable no-param-reassign, no-var, block-scoped-var */






var browser = __WEBPACK_IMPORTED_MODULE_1__common__["h" /* support */].browser;
var NL = "\n";

var RESOURCE_COUNTER = 0;

var PAPER_SIZE = {
    a0        : [ 2383.94 , 3370.39 ],
    a1        : [ 1683.78 , 2383.94 ],
    a2        : [ 1190.55 , 1683.78 ],
    a3        : [ 841.89  , 1190.55 ],
    a4        : [ 595.28  , 841.89  ],
    a5        : [ 419.53  , 595.28  ],
    a6        : [ 297.64  , 419.53  ],
    a7        : [ 209.76  , 297.64  ],
    a8        : [ 147.40  , 209.76  ],
    a9        : [ 104.88  , 147.40  ],
    a10       : [ 73.70   , 104.88  ],
    b0        : [ 2834.65 , 4008.19 ],
    b1        : [ 2004.09 , 2834.65 ],
    b2        : [ 1417.32 , 2004.09 ],
    b3        : [ 1000.63 , 1417.32 ],
    b4        : [ 708.66  , 1000.63 ],
    b5        : [ 498.90  , 708.66  ],
    b6        : [ 354.33  , 498.90  ],
    b7        : [ 249.45  , 354.33  ],
    b8        : [ 175.75  , 249.45  ],
    b9        : [ 124.72  , 175.75  ],
    b10       : [ 87.87   , 124.72  ],
    c0        : [ 2599.37 , 3676.54 ],
    c1        : [ 1836.85 , 2599.37 ],
    c2        : [ 1298.27 , 1836.85 ],
    c3        : [ 918.43  , 1298.27 ],
    c4        : [ 649.13  , 918.43  ],
    c5        : [ 459.21  , 649.13  ],
    c6        : [ 323.15  , 459.21  ],
    c7        : [ 229.61  , 323.15  ],
    c8        : [ 161.57  , 229.61  ],
    c9        : [ 113.39  , 161.57  ],
    c10       : [ 79.37   , 113.39  ],
    executive : [ 521.86  , 756.00  ],
    folio     : [ 612.00  , 936.00  ],
    legal     : [ 612.00  , 1008.00 ],
    letter    : [ 612.00  , 792.00  ],
    tabloid   : [ 792.00  , 1224.00 ]
};

function makeOutput() {
    var indentLevel = 0, output = Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* BinaryStream */])();
    function out() {
        var arguments$1 = arguments;

        for (var i = 0; i < arguments.length; ++i) {
            var x = arguments$1[i];
            if (x === undefined) {
                throw new Error("Cannot output undefined to PDF");
            }
            else if (x instanceof PDFValue) {
                x.beforeRender(out);
                x.render(out);
            }
            else if (isArray(x)) {
                renderArray(x, out);
            }
            else if (isDate(x)) {
                renderDate(x, out);
            }
            else if (typeof x == "number") {
                if (isNaN(x)) {
                    throw new Error("Cannot output NaN to PDF");
                }
                // make sure it doesn't end up in exponent notation
                var num = x.toFixed(7);
                if (num.indexOf(".") >= 0) {
                    num = num.replace(/\.?0+$/, "");
                }
                if (num == "-0") {
                    num = "0";
                }
                output.writeString(num);
            }
            else if (/string|boolean/.test(typeof x)) {
                output.writeString(String(x));
            }
            else if (typeof x.get == "function") {
                output.write(x.get());
            }
            else if (typeof x == "object") {
                if (!x) {
                    output.writeString("null");
                } else {
                    out(new PDFDictionary(x));
                }
            }
        }
    }
    out.writeData = function(data) {
        output.write(data);
    };
    out.withIndent = function(f) {
        ++indentLevel;
        f(out);
        --indentLevel;
    };
    out.indent = function() {
        out(NL, pad("", indentLevel * 2, "  "));
        out.apply(null, arguments);
    };
    out.offset = function() {
        return output.offset();
    };
    out.toString = function() {
        throw new Error("FIX CALLER");
    };
    out.get = function() {
        return output.get();
    };
    out.stream = function() {
        return output;
    };
    return out;
}

function wrapObject(value, id) {
    var beforeRender = value.beforeRender;
    var renderValue = value.render;

    value.beforeRender = function(){};

    value.render = function(out) {
        out(id, " 0 R");
    };

    value.renderFull = function(out) {
        value._offset = out.offset();
        out(id, " 0 obj ");
        beforeRender.call(value, out);
        renderValue.call(value, out);
        out(" endobj");
    };
}

function getPaperOptions(getOption) {
    if (typeof getOption != "function") {
        var options = getOption;
        getOption = function(key, def) {
            return key in options ? options[key] : def;
        };
    }
    var paperSize = getOption("paperSize", PAPER_SIZE.a4);
    if (!paperSize) {
        return {};
    }
    if (typeof paperSize == "string") {
        paperSize = PAPER_SIZE[paperSize.toLowerCase()];
        if (paperSize == null) {
            throw new Error("Unknown paper size");
        }
    }

    paperSize[0] = unitsToPoints(paperSize[0]);
    paperSize[1] = unitsToPoints(paperSize[1]);

    if (getOption("landscape", false)) {
        paperSize = [
            Math.max(paperSize[0], paperSize[1]),
            Math.min(paperSize[0], paperSize[1])
        ];
    }

    var margin = getOption("margin");
    if (margin) {
        if (typeof margin == "string" || typeof margin == "number") {
            margin = unitsToPoints(margin, 0);
            margin = { left: margin, top: margin, right: margin, bottom: margin };
        } else {
            margin = {
                left   : unitsToPoints(margin.left, 0),
                top    : unitsToPoints(margin.top, 0),
                right  : unitsToPoints(margin.right, 0),
                bottom : unitsToPoints(margin.bottom, 0)
            };
        }
        if (getOption("addMargin")) {
            paperSize[0] += margin.left + margin.right;
            paperSize[1] += margin.top + margin.bottom;
        }
    }
    return { paperSize: paperSize, margin: margin };
}

function PDFDocument(options) {
    var self = this;
    var out = makeOutput();
    var objcount = 0;
    var objects = [];

    function getOption(name, defval) {
        return (options && options[name] != null) ? options[name] : defval;
    }

    self.getOption = getOption;

    self.attach = function(value) {
        if (objects.indexOf(value) < 0) {
            wrapObject(value, ++objcount);
            objects.push(value);
        }
        return value;
    };

    self.pages = [];

    self.FONTS = {};
    self.IMAGES = {};
    self.GRAD_COL_FUNCTIONS = {}; // cache for color gradient functions
    self.GRAD_OPC_FUNCTIONS = {}; // cache for opacity gradient functions
    self.GRAD_COL = {};     // cache for whole color gradient objects
    self.GRAD_OPC = {};     // cache for whole opacity gradient objects

    var catalog = self.attach(new PDFCatalog());
    var pageTree = self.attach(new PDFPageTree());

    if (getOption("autoPrint")) {
        var nameTree = {};
        nameTree.JavaScript = new PDFDictionary({ Names: [
            new PDFString("JS"), self.attach(new PDFDictionary({
                S: _("JavaScript"),
                JS: new PDFString("print(true);")
            }))
        ] });
        catalog.props.Names = new PDFDictionary(nameTree);
    }

    catalog.setPages(pageTree);

    var info = self.attach(new PDFDictionary({
        Producer     : new PDFString(getOption("producer", "Kendo UI PDF Generator")), // XXX: kendo.version?
        Title        : new PDFString(getOption("title", "")),
        Author       : new PDFString(getOption("author", "")),
        Subject      : new PDFString(getOption("subject", "")),
        Keywords     : new PDFString(getOption("keywords", "")),
        Creator      : new PDFString(getOption("creator", "Kendo UI PDF Generator")),
        CreationDate : getOption("date", new Date())
    }));

    self.addPage = function(options) {
        var paperOptions  = getPaperOptions(function(name, defval){
            return (options && options[name] != null) ? options[name] : defval;
        });
        var paperSize     = paperOptions.paperSize;
        var margin        = paperOptions.margin;
        var contentWidth  = paperSize[0];
        var contentHeight = paperSize[1];
        if (margin) {
            contentWidth -= margin.left + margin.right;
            contentHeight -= margin.top + margin.bottom;
        }
        var content = new PDFStream(makeOutput(), null, true);
        var props = {
            Contents : self.attach(content),
            Parent   : pageTree,
            MediaBox : [ 0, 0, paperSize[0], paperSize[1] ]
        };
        var page = new PDFPage(self, props);
        page._content = content;
        pageTree.addPage(self.attach(page));

        // canvas-like coord. system.  (0,0) is upper-left.
        // text must be vertically mirorred before drawing.
        page.transform(1, 0, 0, -1, 0, paperSize[1]);

        if (margin) {
            page.translate(margin.left, margin.top);
            // XXX: clip to right/bottom margin.  Make this optional?
            page.rect(0, 0, contentWidth, contentHeight);
            page.clip();
        }

        self.pages.push(page);
        return page;
    };

    self.render = function() {
        var i;
        /// file header
        out("%PDF-1.4", NL, "%\xc2\xc1\xda\xcf\xce", NL, NL);

        /// file body
        for (i = 0; i < objects.length; ++i) {
            objects[i].renderFull(out);
            out(NL, NL);
        }

        /// cross-reference table
        var xrefOffset = out.offset();
        out("xref", NL, 0, " ", objects.length + 1, NL);
        out("0000000000 65535 f ", NL);
        for (i = 0; i < objects.length; ++i) {
            out(zeropad(objects[i]._offset, 10), " 00000 n ", NL);
        }
        out(NL);

        /// trailer
        out("trailer", NL);
        out(new PDFDictionary({
            Size: objects.length + 1,
            Root: catalog,
            Info: info
        }), NL, NL);

        /// end
        out("startxref", NL, xrefOffset, NL);
        out("%%EOF", NL);

        return out.stream().offset(0);
    };
}

var FONT_CACHE = {
    "Times-Roman"           : true,
    "Times-Bold"            : true,
    "Times-Italic"          : true,
    "Times-BoldItalic"      : true,
    "Helvetica"             : true,
    "Helvetica-Bold"        : true,
    "Helvetica-Oblique"     : true,
    "Helvetica-BoldOblique" : true,
    "Courier"               : true,
    "Courier-Bold"          : true,
    "Courier-Oblique"       : true,
    "Courier-BoldOblique"   : true,
    "Symbol"                : true,
    "ZapfDingbats"          : true
};

function loadBinary(url, cont) {
    // IE throws Accesss denied error for Data URIs
    var m;
    if (browser.msie && (m = /^data:.*?;base64,/i.exec(url))) {
        cont(Object(__WEBPACK_IMPORTED_MODULE_0__utils__["c" /* base64ToUint8Array */])(url.substr(m[0].length)));
        return;
    }

    function error() {
        if (window.console) {
            if (window.console.error) {
                window.console.error("Cannot load URL: %s", url);
            } else {
                window.console.log("Cannot load URL: %s", url);
            }
        }
        cont(null);
    }
    var req = new XMLHttpRequest();
    req.open('GET', url, true);
    if (__WEBPACK_IMPORTED_MODULE_0__utils__["b" /* HAS_TYPED_ARRAYS */]) {
        req.responseType = "arraybuffer";
    }
    req.onload = function() {
        if (req.status == 200 || req.status == 304) {
            if (__WEBPACK_IMPORTED_MODULE_0__utils__["b" /* HAS_TYPED_ARRAYS */]) {
                cont(new Uint8Array(req.response));
            } else {
                cont(new window.VBArray(req.responseBody).toArray()); // IE9 only
            }
        } else {
            error();
        }
    };
    req.onerror = error;
    req.send(null);
}

function loadFont(url, cont) {
    var font = FONT_CACHE[url];
    if (font) {
        cont(font);
    } else {
        loadBinary(url, function(data){
            if (data == null) {
                throw new Error("Cannot load font from " + url);
            } else {
                var font = new __WEBPACK_IMPORTED_MODULE_2__ttf__["a" /* TTFFont */](data);
                FONT_CACHE[url] = font;
                cont(font);
            }
        });
    }
}

var IMAGE_CACHE = {};

function clearImageCache() {
    IMAGE_CACHE = {};
}

function loadImage(url, size, cont) {
    var img = IMAGE_CACHE[url], bloburl, blob;
    if (img) {
        cont(img);
    } else {
        img = new Image();
        if (!(/^data:/i.test(url))) {
            img.crossOrigin = "Anonymous";
        }
        if (__WEBPACK_IMPORTED_MODULE_0__utils__["b" /* HAS_TYPED_ARRAYS */] && !(/^data:/i.test(url))) {
            // IE10 fails to load images from another domain even when the server sends the
            // proper CORS headers.  a XHR, however, will be able to load the data.
            // http://stackoverflow.com/a/19734516/154985
            //
            // On the other hand, it's worth doing it this way for all browsers which support
            // responseType = "blob" (HAS_TYPED_ARRAYS will be true), because we can inspect the
            // mime type and if it's a JPEG (very common case) we can save a lot of time in
            // _load below.
            var xhr = new XMLHttpRequest();
            xhr.onload = function() {
                blob = xhr.response;
                bloburl = URL.createObjectURL(blob);
                _load(bloburl);
            };
            xhr.onerror = _onerror;
            xhr.open("GET", url, true);
            xhr.responseType = "blob";
            xhr.send();
        } else {
            _load(url);
        }
    }

    function _load(url) {
        img.src = url;
        if (img.complete && !browser.msie) {
            // IE, bless it's little heart, says img.complete == true even though the image is
            // not loaded (width=0), therefore we must go the onload route (ticket 929635).
            _onload();
        } else {
            img.onload = _onload;
            img.onerror = _onerror;
        }
    }

    function _trycanvas() {
        if (!size) {
            size = { width: img.width, height: img.height };
        }

        var canvas = document.createElement("canvas");
        canvas.width = size.width;
        canvas.height = size.height;

        var ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0, size.width, size.height);

        var imgdata;
        try {
            imgdata = ctx.getImageData(0, 0, size.width, size.height);
        } catch (ex) {
            // it tainted the canvas -- can't draw it.
            _onerror();
            return;
        } finally {
            if (bloburl) {
                URL.revokeObjectURL(bloburl);
            }
        }

        // in case it contains transparency, we must separate rgb data from the alpha
        // channel and create a PDFRawImage image with opacity.  otherwise we can use a
        // PDFJpegImage.
        //
        // to do this in one step, we create the rgb and alpha streams anyway, even if
        // we might end up not using them if hasAlpha remains false.

        var hasAlpha = false, rgb = Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* BinaryStream */])(), alpha = Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* BinaryStream */])();
        var rawbytes = imgdata.data;
        var i = 0;
        while (i < rawbytes.length) {
            rgb.writeByte(rawbytes[i++]);
            rgb.writeByte(rawbytes[i++]);
            rgb.writeByte(rawbytes[i++]);
            var a = rawbytes[i++];
            if (a < 255) {
                hasAlpha = true;
            }
            alpha.writeByte(a);
        }

        if (hasAlpha) {
            img = new PDFRawImage(size.width, size.height, rgb, alpha);
        } else {
            // no transparency, encode as JPEG.
            var data = canvas.toDataURL("image/jpeg");
            data = data.substr(data.indexOf(";base64,") + 8);

            var stream = Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* BinaryStream */])();
            stream.writeBase64(data);
            img = new PDFJpegImage(stream);
        }

        cont(IMAGE_CACHE[url] = img);
    }

    function _onerror() {
        cont(IMAGE_CACHE[url] = "ERROR");
    }

    function _onload() {
        if (size) {
            // but if requested size is bigger than the image, just use the original image.
            if (size.width >= img.width || size.height >= img.height) {
                size = null;
            }
        }
        if (!size && blob && /^image\/jpe?g$/i.test(blob.type)) {
            // If we know we got a JPEG, we can skip the process of rendering it to a
            // canvas, getting the pixel data, searching for transparency we know we won't
            // find, getting back a data URI and then decoding the BASE64 to finally get the
            // binary we already have.  Also, we avoid downgrading the image quality, with
            // the possible drawback of making a bigger PDF; still, seems legit.
            //
            // Besides saving a lot of work, this also reuses the buffer memory
            // (BinaryStream does not create a copy), potentially saving some GC cycles.
            var reader = new FileReader();
            reader.onload = function() {
                try {
                    var img = new PDFJpegImage(Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* BinaryStream */])(new Uint8Array(this.result)));
                    URL.revokeObjectURL(bloburl);
                    cont(IMAGE_CACHE[url] = img);
                } catch (ex) {
                    // if there's an error parsing the JPEG stream, it could be due to a
                    // misconfigured server (improper content-type:
                    // https://github.com/telerik/kendo-ui-core/issues/4184).  If that's the case,
                    // the canvas will still be able to draw it.
                    _trycanvas();
                }
            };
            reader.readAsArrayBuffer(blob);
        } else {
            _trycanvas();
        }
    }
}

function manyLoader(loadOne) {
    return function(urls, callback) {
        var n = urls.length, i = n;
        if (n === 0) {
            return callback();
        }
        function next() {
            if (--n === 0) {
                callback();
            }
        }
        while (i-- > 0) {
            loadOne(urls[i], next);
        }
    };
}

var loadFonts = manyLoader(loadFont);
var loadImages = function(images, callback) {
    var urls = Object.keys(images), n = urls.length;
    if (n === 0) {
        return callback();
    }
    function next() {
        if (--n === 0) {
            callback();
        }
    }
    urls.forEach(function(url){
        loadImage(url, images[url], next);
    });
};

PDFDocument.prototype = {
    loadFonts: loadFonts,
    loadImages: loadImages,

    getFont: function(url) {
        var font = this.FONTS[url];
        if (!font) {
            font = FONT_CACHE[url];
            if (!font) {
                throw new Error("Font " + url + " has not been loaded");
            }
            if (font === true) {
                font = this.attach(new PDFStandardFont(url));
            } else {
                font = this.attach(new PDFFont(this, font));
            }
            this.FONTS[url] = font;
        }
        return font;
    },

    getImage: function(url) {
        var img = this.IMAGES[url];
        if (!img) {
            img = IMAGE_CACHE[url];
            if (!img) {
                throw new Error("Image " + url + " has not been loaded");
            }
            if (img === "ERROR") {
                return null;
            }
            img = this.IMAGES[url] = this.attach(img.asStream(this));
        }
        return img;
    },

    getOpacityGS: function(opacity, forStroke) {
        var id = parseFloat(opacity).toFixed(3);
        opacity = parseFloat(id);
        id += forStroke ? "S" : "F";
        var cache = this._opacityGSCache || (this._opacityGSCache = {});
        var gs = cache[id];
        if (!gs) {
            var props = {
                Type: _("ExtGState")
            };
            if (forStroke) {
                props.CA = opacity;
            } else {
                props.ca = opacity;
            }
            gs = this.attach(new PDFDictionary(props));
            gs._resourceName = _("GS" + (++RESOURCE_COUNTER));
            cache[id] = gs;
        }
        return gs;
    },

    dict: function(props) {
        return new PDFDictionary(props);
    },

    name: function(str) {
        return _(str);
    },

    stream: function(props, content) {
        return new PDFStream(content, props);
    }
};

/* -----[ utils ]----- */

function pad(str, len, ch) {
    while (str.length < len) {
        str = ch + str;
    }
    return str;
}

function zeropad(n, len) {
    return pad(String(n), len, "0");
}

function hasOwnProperty(obj, key) {
    return Object.prototype.hasOwnProperty.call(obj, key);
}

var isArray = Array.isArray || function(obj) {
    return obj instanceof Array;
};

function isDate(obj) {
    return obj instanceof Date;
}

function renderArray(a, out) {
    out("[");
    if (a.length > 0) {
        out.withIndent(function(){
            for (var i = 0; i < a.length; ++i) {
                if (i > 0 && i % 8 === 0) {
                    out.indent(a[i]);
                } else {
                    out(" ", a[i]);
                }
            }
        });
        //out.indent();
    }
    out(" ]");
}

function renderDate(date, out) {
    out("(D:",
        zeropad(date.getUTCFullYear(), 4),
        zeropad(date.getUTCMonth() + 1, 2),
        zeropad(date.getUTCDate(), 2),
        zeropad(date.getUTCHours(), 2),
        zeropad(date.getUTCMinutes(), 2),
        zeropad(date.getUTCSeconds(), 2),
        "Z)");
}

function mm2pt(mm) {
    return mm * (72/25.4);
}

function cm2pt(cm) {
    return mm2pt(cm * 10);
}

function in2pt(inch)  {
    return inch * 72;
}


function unitsToPoints(x, def) {
    if (typeof x == "number") {
        return x;
    }
    if (typeof x == "string") {
        var m;
        m = /^\s*([0-9.]+)\s*(mm|cm|in|pt)\s*$/.exec(x);
        if (m) {
            var num = parseFloat(m[1]);
            if (!isNaN(num)) {
                if (m[2] == "pt") {
                    return num;
                }
                return {
                    "mm": mm2pt,
                    "cm": cm2pt,
                    "in": in2pt
                }[m[2]](num);
            }
        }
    }
    if (def != null) {
        return def;
    }
    throw new Error("Can't parse unit: " + x);
}

/* -----[ PDF basic objects ]----- */

function PDFValue(){}

PDFValue.prototype.beforeRender = function(){};

function defclass(Ctor, proto, Base) {
    if (!Base) {
        Base = PDFValue;
    }
    Ctor.prototype = new Base();
    for (var i in proto) {
        if (hasOwnProperty(proto, i)) {
            Ctor.prototype[i] = proto[i];
        }
    }
    return Ctor;
}

/// strings

var PDFString = defclass(function PDFString(value){
    this.value = value;
}, {
    render: function(out) {
        var txt = "", val = this.value;
        for (var i = 0; i < val.length; ++i) {
            txt += String.fromCharCode(val.charCodeAt(i) & 0xFF);
        }
        out("(", txt.replace(/([\(\)\\])/g, "\\$1"), ")");
    },
    toString: function() {
        return this.value;
    }
});

var PDFHexString = defclass(function PDFHexString(value){
    this.value = value;
}, {
    render: function(out) {
        var this$1 = this;

        out("<");
        for (var i = 0; i < this.value.length; ++i) {
            out(zeropad(this$1.value.charCodeAt(i).toString(16), 4));
        }
        out(">");
    }
}, PDFString);

/// names

var PDFName = defclass(function PDFName(name) {
    this.name = name;
}, {
    render: function(out) {
        out("/" + this.escape());
    },
    escape: function() {
        return this.name.replace(/[^\x21-\x7E]/g, function(c){
            return "#" + zeropad(c.charCodeAt(0).toString(16), 2);
        });
    },
    toString: function() {
        return this.name;
    }
});

var PDFName_cache = {};
PDFName.get = _;

function _(name) {
    if (hasOwnProperty(PDFName_cache, name)) {
        return PDFName_cache[name];
    }
    return (PDFName_cache[name] = new PDFName(name));
}

/// dictionary

var PDFDictionary = defclass(function PDFDictionary(props) {
    this.props = props;
}, {
    render: function(out) {
        var props = this.props, empty = true;
        out("<<");
        out.withIndent(function(){
            for (var i in props) {
                if (hasOwnProperty(props, i) && !/^_/.test(i)) {
                    empty = false;
                    out.indent(_(i), " ", props[i]);
                }
            }
        });
        if (!empty) {
            out.indent();
        }
        out(">>");
    }
});

/// streams

var PDFStream = defclass(function PDFStream(data, props, compress) {
    if (typeof data == "string") {
        var tmp = Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* BinaryStream */])();
        tmp.write(data);
        data = tmp;
    }
    this.data = data;
    this.props = props || {};
    this.compress = compress;
}, {
    render: function(out) {
        var data = this.data.get(), props = this.props;
        if (this.compress && Object(__WEBPACK_IMPORTED_MODULE_3__deflate__["b" /* supportsDeflate */])()) {
            if (!props.Filter) {
                props.Filter = [];
            } else if (!(props.Filter instanceof Array)) {
                props.Filter = [ props.Filter ];
            }
            props.Filter.unshift(_("FlateDecode"));
            data = Object(__WEBPACK_IMPORTED_MODULE_3__deflate__["a" /* deflate */])(data);
        }
        props.Length = data.length;
        out(new PDFDictionary(props), " stream", NL);
        out.writeData(data);
        out(NL, "endstream");
    }
});

/// catalog

var PDFCatalog = defclass(function PDFCatalog(){
    this.props = {
        Type: _("Catalog")
    };
}, {
    setPages: function(pagesObj) {
        this.props.Pages = pagesObj;
    }
}, PDFDictionary);

/// page tree

var PDFPageTree = defclass(function PDFPageTree(){
    this.props = {
        Type  : _("Pages"),
        Kids  : [],
        Count : 0
    };
}, {
    addPage: function(pageObj) {
        this.props.Kids.push(pageObj);
        this.props.Count++;
    }
}, PDFDictionary);

/// images

// JPEG

var SOF_CODES = [0xc0, 0xc1, 0xc2, 0xc3, 0xc5, 0xc6, 0xc7, 0xc9, 0xca, 0xcb, 0xcd, 0xce, 0xcf];

function PDFJpegImage(data) {
    // we must determine the correct color space.  we'll parse a bit
    // of the JPEG stream for this, it's still better than going
    // through the canvas.
    // https://github.com/telerik/kendo-ui-core/issues/2845
    data.offset(0);
    var width, height, colorSpace, bitsPerComponent;
    var soi = data.readShort();
    if (soi != 0xFFD8) {
        // XXX: do we have some better options here?
        throw new Error("Invalid JPEG image");
    }
    while (!data.eof()) {
        var ff = data.readByte();
        if (ff != 0xFF) {
            throw new Error("Invalid JPEG image");
        }
        var marker = data.readByte();
        var length = data.readShort();
        if (SOF_CODES.indexOf(marker) >= 0) {
            // "start of frame" marker
            bitsPerComponent = data.readByte();
            height = data.readShort();
            width = data.readShort();
            colorSpace = data.readByte();
            break;
        }
        data.skip(length - 2);
    }

    if (colorSpace == null) {
        throw new Error("Invalid JPEG image");
    }

    var props = {
        Type             : _("XObject"),
        Subtype          : _("Image"),
        Width            : width,
        Height           : height,
        BitsPerComponent : bitsPerComponent,
        Filter           : _("DCTDecode")
    };

    switch (colorSpace) {
      case 1:
        props.ColorSpace = _("DeviceGray");
        break;
      case 3:
        props.ColorSpace = _("DeviceRGB");
        break;
      case 4:
        props.ColorSpace = _("DeviceCMYK");
        props.Decode = [ 1, 0, 1, 0, 1, 0, 1, 0 ]; // invert colors
        break;
    }

    this.asStream = function() {
        data.offset(0);
        var stream = new PDFStream(data, props);
        stream._resourceName = _("I" + (++RESOURCE_COUNTER));
        return stream;
    };
}

// PDFRawImage will be used for images with transparency (PNG)

function PDFRawImage(width, height, rgb, alpha) {
    this.asStream = function(pdf) {
        var mask = new PDFStream(alpha, {
            Type             : _("XObject"),
            Subtype          : _("Image"),
            Width            : width,
            Height           : height,
            BitsPerComponent : 8,
            ColorSpace       : _("DeviceGray")
        }, true);
        var stream = new PDFStream(rgb, {
            Type             : _("XObject"),
            Subtype          : _("Image"),
            Width            : width,
            Height           : height,
            BitsPerComponent : 8,
            ColorSpace       : _("DeviceRGB"),
            SMask            : pdf.attach(mask)
        }, true);
        stream._resourceName = _("I" + (++RESOURCE_COUNTER));
        return stream;
    };
}

/// standard fonts

var PDFStandardFont = defclass(function PDFStandardFont(name){
    this.props = {
        Type     : _("Font"),
        Subtype  : _("Type1"),
        BaseFont : _(name)
    };
    this._resourceName = _("F" + (++RESOURCE_COUNTER));
}, {
    encodeText: function(str) {
        return new PDFString(String(str));
    }
}, PDFDictionary);

/// TTF fonts

var PDFFont = defclass(function PDFFont(pdf, font, props){
    props = this.props = props || {};
    props.Type = _("Font");
    props.Subtype = _("Type0");
    props.Encoding = _("Identity-H");

    this._pdf = pdf;
    this._font = font;
    this._sub = font.makeSubset();
    this._resourceName = _("F" + (++RESOURCE_COUNTER));

    var head = font.head;

    this.name = font.psName;
    var scale = this.scale = font.scale;
    this.bbox = [
        head.xMin * scale,
        head.yMin * scale,
        head.xMax * scale,
        head.yMax * scale
    ];

    this.italicAngle = font.post.italicAngle;
    this.ascent = font.ascent * scale;
    this.descent = font.descent * scale;
    this.lineGap = font.lineGap * scale;
    this.capHeight = font.os2.capHeight || this.ascent;
    this.xHeight = font.os2.xHeight || 0;
    this.stemV = 0;

    this.familyClass = (font.os2.familyClass || 0) >> 8;
    this.isSerif = this.familyClass >= 1 && this.familyClass <= 7;
    this.isScript = this.familyClass == 10;

    this.flags = ((font.post.isFixedPitch ? 1 : 0) |
                  (this.isSerif ? 1 << 1 : 0) |
                  (this.isScript ? 1 << 3 : 0) |
                  (this.italicAngle !== 0 ? 1 << 6 : 0) |
                  (1 << 5));
}, {
    encodeText: function(text) {
        return new PDFHexString(this._sub.encodeText(String(text)));
    },
    getTextWidth: function(fontSize, text) {
        var this$1 = this;

        var width = 0, codeMap = this._font.cmap.codeMap;
        for (var i = 0; i < text.length; ++i) {
            var glyphId = codeMap[text.charCodeAt(i)];
            width += this$1._font.widthOfGlyph(glyphId || 0);
        }
        return width * fontSize / 1000;
    },
    beforeRender: function() {
        var self = this;
        var sub = self._sub;

        // write the TTF data
        var data = sub.render();
        var fontStream = new PDFStream(Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* BinaryStream */])(data), {
            Length1: data.length
        }, true);

        var descriptor = self._pdf.attach(new PDFDictionary({
            Type         : _("FontDescriptor"),
            FontName     : _(self._sub.psName),
            FontBBox     : self.bbox,
            Flags        : self.flags,
            StemV        : self.stemV,
            ItalicAngle  : self.italicAngle,
            Ascent       : self.ascent,
            Descent      : self.descent,
            CapHeight    : self.capHeight,
            XHeight      : self.xHeight,
            FontFile2    : self._pdf.attach(fontStream)
        }));

        var cmap = sub.ncid2ogid;
        var firstChar = sub.firstChar;
        var lastChar = sub.lastChar;
        var charWidths = [];
        (function loop(i, chunk){
            if (i <= lastChar) {
                var gid = cmap[i];
                if (gid == null) {
                    loop(i + 1);
                } else {
                    if (!chunk) {
                        charWidths.push(i, chunk = []);
                    }
                    chunk.push(self._font.widthOfGlyph(gid));
                    loop(i + 1, chunk);
                }
            }
        })(firstChar);

        // As if two dictionaries weren't enough, we need another
        // one, the "descendant font".  Only that one can be of
        // Subtype CIDFontType2.  PDF is the X11 of document
        // formats: portable but full of legacy that nobody cares
        // about anymore.

        var descendant = new PDFDictionary({
            Type: _("Font"),
            Subtype: _("CIDFontType2"),
            BaseFont: _(self._sub.psName),
            CIDSystemInfo: new PDFDictionary({
                Registry   : new PDFString("Adobe"),
                Ordering   : new PDFString("Identity"),
                Supplement : 0
            }),
            FontDescriptor: descriptor,
            FirstChar: firstChar,
            LastChar: lastChar,
            DW: Math.round(self._font.widthOfGlyph(0)),
            W: charWidths,
            CIDToGIDMap: self._pdf.attach(self._makeCidToGidMap())
        });

        var dict = self.props;
        dict.BaseFont = _(self._sub.psName);
        dict.DescendantFonts = [ self._pdf.attach(descendant) ];

        // Compute the ToUnicode map so that apps can extract
        // meaningful text from the PDF.
        var unimap = new PDFToUnicodeCmap(firstChar, lastChar, sub.subset);
        var unimapStream = new PDFStream(makeOutput(), null, true);
        unimapStream.data(unimap);
        dict.ToUnicode = self._pdf.attach(unimapStream);
    },
    _makeCidToGidMap: function() {
        return new PDFStream(Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* BinaryStream */])(this._sub.cidToGidMap()), null, true);
    }
}, PDFDictionary);

var PDFToUnicodeCmap = defclass(function PDFUnicodeCMap(firstChar, lastChar, map){
    this.firstChar = firstChar;
    this.lastChar = lastChar;
    this.map = map;
}, {
    render: function(out) {
        out.indent("/CIDInit /ProcSet findresource begin");
        out.indent("12 dict begin");
        out.indent("begincmap");
        out.indent("/CIDSystemInfo <<");
        out.indent("  /Registry (Adobe)");
        out.indent("  /Ordering (UCS)");
        out.indent("  /Supplement 0");
        out.indent(">> def");
        out.indent("/CMapName /Adobe-Identity-UCS def");
        out.indent("/CMapType 2 def");
        out.indent("1 begincodespacerange");
        out.indent("  <0000><ffff>");
        out.indent("endcodespacerange");

        var self = this;
        out.indent(self.lastChar - self.firstChar + 1, " beginbfchar");
        out.withIndent(function(){
            for (var code = self.firstChar; code <= self.lastChar; ++code) {
                var unicode = self.map[code];
                var str = Object(__WEBPACK_IMPORTED_MODULE_0__utils__["e" /* ucs2encode */])([ unicode ]);
                out.indent("<", zeropad(code.toString(16), 4), ">", "<");
                for (var i = 0; i < str.length; ++i) {
                    out(zeropad(str.charCodeAt(i).toString(16), 4));
                }
                out(">");
            }
        });
        out.indent("endbfchar");

        out.indent("endcmap");
        out.indent("CMapName currentdict /CMap defineresource pop");
        out.indent("end");
        out.indent("end");
    }
});

/// gradients

function makeHash(a) {
    return a.map(function(x){
        return isArray(x) ? makeHash(x)
            : typeof x == "number" ? (Math.round(x * 1000) / 1000).toFixed(3)
            : x;
    }).join(" ");
}

function cacheColorGradientFunction(pdf, r1, g1, b1, r2, g2, b2) {
    var hash = makeHash([ r1, g1, b1, r2, g2, b2 ]);
    var func = pdf.GRAD_COL_FUNCTIONS[hash];
    if (!func) {
        func = pdf.GRAD_COL_FUNCTIONS[hash] = pdf.attach(new PDFDictionary({
            FunctionType: 2,
            Domain: [ 0, 1 ],
            Range: [ 0, 1, 0, 1, 0, 1 ],
            N: 1,
            C0: [ r1 , g1 , b1 ],
            C1: [ r2 , g2 , b2 ]
        }));
    }
    return func;
}

function cacheOpacityGradientFunction(pdf, a1, a2) {
    var hash = makeHash([ a1, a2 ]);
    var func = pdf.GRAD_OPC_FUNCTIONS[hash];
    if (!func) {
        func = pdf.GRAD_OPC_FUNCTIONS[hash] = pdf.attach(new PDFDictionary({
            FunctionType: 2,
            Domain: [ 0, 1 ],
            Range: [ 0, 1 ],
            N: 1,
            C0: [ a1 ],
            C1: [ a2 ]
        }));
    }
    return func;
}

function makeGradientFunctions(pdf, stops) {
    var hasAlpha = false;
    var opacities = [];
    var colors = [];
    var offsets = [];
    var encode = [];
    var i, prev, cur, prevColor, curColor;
    for (i = 1; i < stops.length; ++i) {
        prev = stops[i - 1];
        cur = stops[i];
        prevColor = prev.color;
        curColor = cur.color;
        colors.push(cacheColorGradientFunction(
            pdf,
            prevColor.r, prevColor.g, prevColor.b,
            curColor.r,  curColor.g,  curColor.b
        ));
        if (prevColor.a < 1 || curColor.a < 1) {
            hasAlpha = true;
        }
        offsets.push(cur.offset);
        encode.push(0, 1);
    }
    if (hasAlpha) {
        for (i = 1; i < stops.length; ++i) {
            prev = stops[i - 1];
            cur = stops[i];
            prevColor = prev.color;
            curColor = cur.color;
            opacities.push(cacheOpacityGradientFunction(
                pdf, prevColor.a, curColor.a
            ));
        }
    }
    offsets.pop();
    return {
        hasAlpha  : hasAlpha,
        colors    : assemble(colors),
        opacities : hasAlpha ? assemble(opacities) : null
    };
    function assemble(funcs) {
        if (funcs.length == 1) {
            return funcs[0];
        }
        return {
            FunctionType: 3,
            Functions: funcs,
            Domain: [ 0, 1 ],
            Bounds: offsets,
            Encode: encode
        };
    }
}

function cacheColorGradient(pdf, isRadial, stops, coords, funcs, box) {
    var shading, hash;
    // if box is given then we have user-space coordinates, which
    // means the gradient is designed for a certain position/size
    // on page.  caching won't do any good.
    if (!box) {
        var a = [ isRadial ].concat(coords);
        stops.forEach(function(x){
            a.push(x.offset, x.color.r, x.color.g, x.color.b);
        });
        hash = makeHash(a);
        shading = pdf.GRAD_COL[hash];
    }
    if (!shading) {
        shading = new PDFDictionary({
            Type: _("Shading"),
            ShadingType: isRadial ? 3 : 2,
            ColorSpace: _("DeviceRGB"),
            Coords: coords,
            Domain: [ 0, 1 ],
            Function: funcs,
            Extend: [ true, true ]
        });
        pdf.attach(shading);
        shading._resourceName = "S" + (++RESOURCE_COUNTER);
        if (hash) {
            pdf.GRAD_COL[hash] = shading;
        }
    }
    return shading;
}

function cacheOpacityGradient(pdf, isRadial, stops, coords, funcs, box) {
    var opacity, hash;
    // if box is given then we have user-space coordinates, which
    // means the gradient is designed for a certain position/size
    // on page.  caching won't do any good.
    if (!box) {
        var a = [ isRadial ].concat(coords);
        stops.forEach(function(x){
            a.push(x.offset, x.color.a);
        });
        hash = makeHash(a);
        opacity = pdf.GRAD_OPC[hash];
    }
    if (!opacity) {
        opacity = new PDFDictionary({
            Type: _("ExtGState"),
            AIS: false,
            CA: 1,
            ca: 1,
            SMask: {
                Type: _("Mask"),
                S: _("Luminosity"),
                G: pdf.attach(new PDFStream("/a0 gs /s0 sh", {
                    Type: _("XObject"),
                    Subtype: _("Form"),
                    FormType: 1,
                    BBox: (box ? [
                        box.left, box.top + box.height, box.left + box.width, box.top
                    ] : [ 0, 1, 1, 0 ]),
                    Group: {
                        Type: _("Group"),
                        S: _("Transparency"),
                        CS: _("DeviceGray"),
                        I: true
                    },
                    Resources: {
                        ExtGState: {
                            a0: { CA: 1, ca: 1 }
                        },
                        Shading: {
                            s0: {
                                ColorSpace: _("DeviceGray"),
                                Coords: coords,
                                Domain: [ 0, 1 ],
                                ShadingType: isRadial ? 3 : 2,
                                Function: funcs,
                                Extend: [ true, true ]
                            }
                        }
                    }
                }))
            }
        });
        pdf.attach(opacity);
        opacity._resourceName = "O" + (++RESOURCE_COUNTER);
        if (hash) {
            pdf.GRAD_OPC[hash] = opacity;
        }
    }
    return opacity;
}

function cacheGradient(pdf, gradient, box) {
    var isRadial = gradient.type == "radial";
    var funcs = makeGradientFunctions(pdf, gradient.stops);
    var coords = isRadial ? [
        gradient.start.x , gradient.start.y , gradient.start.r,
        gradient.end.x   , gradient.end.y   , gradient.end.r
    ] : [
        gradient.start.x , gradient.start.y,
        gradient.end.x   , gradient.end.y
    ];
    var shading = cacheColorGradient(
        pdf, isRadial, gradient.stops, coords, funcs.colors, gradient.userSpace && box
    );
    var opacity = funcs.hasAlpha ? cacheOpacityGradient(
        pdf, isRadial, gradient.stops, coords, funcs.opacities, gradient.userSpace && box
    ) : null;
    return {
        hasAlpha: funcs.hasAlpha,
        shading: shading,
        opacity: opacity
    };
}

/// page object

var PDFPage = defclass(function PDFPage(pdf, props){
    this._pdf = pdf;
    this._rcount = 0;
    this._textMode = false;
    this._fontResources = {};
    this._gsResources = {};
    this._xResources = {};
    this._patResources = {};
    this._shResources = {};
    this._opacity = 1;
    this._matrix = [ 1, 0, 0, 1, 0, 0 ];
    this._annotations = [];

    this._font = null;
    this._fontSize = null;

    this._contextStack = [];

    props = this.props = props || {};
    props.Type = _("Page");
    props.ProcSet = [
        _("PDF"),
        _("Text"),
        _("ImageB"),
        _("ImageC"),
        _("ImageI")
    ];
    props.Resources = new PDFDictionary({
        Font      : new PDFDictionary(this._fontResources),
        ExtGState : new PDFDictionary(this._gsResources),
        XObject   : new PDFDictionary(this._xResources),
        Pattern   : new PDFDictionary(this._patResources),
        Shading   : new PDFDictionary(this._shResources)
    });
    props.Annots = this._annotations;
}, {
    _out: function() {
        this._content.data.apply(null, arguments);
    },
    transform: function(a, b, c, d, e, f) {
        if (!isIdentityMatrix(arguments)) {
            this._matrix = mmul(arguments, this._matrix);
            this._out(a, " ", b, " ", c, " ", d, " ", e, " ", f, " cm");
            // XXX: debug
            // this._out(" % current matrix: ", this._matrix);
            this._out(NL);
        }
    },
    translate: function(dx, dy) {
        this.transform(1, 0, 0, 1, dx, dy);
    },
    scale: function(sx, sy) {
        this.transform(sx, 0, 0, sy, 0, 0);
    },
    rotate: function(angle) {
        var cos = Math.cos(angle), sin = Math.sin(angle);
        this.transform(cos, sin, -sin, cos, 0, 0);
    },
    beginText: function() {
        this._textMode = true;
        this._out("BT", NL);
    },
    endText: function() {
        this._textMode = false;
        this._out("ET", NL);
    },
    _requireTextMode: function() {
        if (!this._textMode) {
            throw new Error("Text mode required; call page.beginText() first");
        }
    },
    _requireFont: function() {
        if (!this._font) {
            throw new Error("No font selected; call page.setFont() first");
        }
    },
    setFont: function(font, size) {
        this._requireTextMode();
        if (font == null) {
            font = this._font;
        } else if (!(font instanceof PDFFont)) {
            font = this._pdf.getFont(font);
        }
        if (size == null) {
            size = this._fontSize;
        }
        this._fontResources[font._resourceName] = font;
        this._font = font;
        this._fontSize = size;
        this._out(font._resourceName, " ", size, " Tf", NL);
    },
    setTextLeading: function(size) {
        this._requireTextMode();
        this._out(size, " TL", NL);
    },
    setTextRenderingMode: function(mode) {
        this._requireTextMode();
        this._out(mode, " Tr", NL);
    },
    showText: function(text, requestedWidth) {
        this._requireFont();
        if (text.length > 1 && requestedWidth && this._font instanceof PDFFont) {
            var outputWidth = this._font.getTextWidth(this._fontSize, text);
            var scale = requestedWidth / outputWidth * 100;
            this._out(scale, " Tz ");
        }
        this._out(this._font.encodeText(text), " Tj", NL);
    },
    showTextNL: function(text) {
        this._requireFont();
        this._out(this._font.encodeText(text), " '", NL);
    },
    addLink: function(uri, box) {
        var ll = this._toPage({ x: box.left, y: box.bottom });
        var ur = this._toPage({ x: box.right, y: box.top });
        this._annotations.push(new PDFDictionary({
            Type    : _("Annot"),
            Subtype : _("Link"),
            Rect    : [ ll.x, ll.y, ur.x, ur.y ],
            Border  : [ 0, 0, 0 ],
            A       : new PDFDictionary({
                Type : _("Action"),
                S    : _("URI"),
                URI  : new PDFString(uri)
            })
        }));
    },
    setStrokeColor: function(r, g, b) {
        this._out(r, " ", g, " ", b, " RG", NL);
    },
    setOpacity: function(opacity) {
        this.setFillOpacity(opacity);
        this.setStrokeOpacity(opacity);
        this._opacity *= opacity;
    },
    setStrokeOpacity: function(opacity) {
        if (opacity < 1) {
            var gs = this._pdf.getOpacityGS(this._opacity * opacity, true);
            this._gsResources[gs._resourceName] = gs;
            this._out(gs._resourceName, " gs", NL);
        }
    },
    setFillColor: function(r, g, b) {
        this._out(r, " ", g, " ", b, " rg", NL);
    },
    setFillOpacity: function(opacity) {
        if (opacity < 1) {
            var gs = this._pdf.getOpacityGS(this._opacity * opacity, false);
            this._gsResources[gs._resourceName] = gs;
            this._out(gs._resourceName, " gs", NL);
        }
    },
    gradient: function(gradient, box) {
        this.save();
        this.rect(box.left, box.top, box.width, box.height);
        this.clip();
        if (!gradient.userSpace) {
            this.transform(box.width, 0, 0, box.height, box.left, box.top);
        }
        var g = cacheGradient(this._pdf, gradient, box);
        var sname = g.shading._resourceName, oname;
        this._shResources[sname] = g.shading;
        if (g.hasAlpha) {
            oname = g.opacity._resourceName;
            this._gsResources[oname] = g.opacity;
            this._out("/" + oname + " gs ");
        }
        this._out("/" + sname + " sh", NL);
        this.restore();
    },
    setDashPattern: function(dashArray, dashPhase) {
        this._out(dashArray, " ", dashPhase, " d", NL);
    },
    setLineWidth: function(width) {
        this._out(width, " w", NL);
    },
    setLineCap: function(lineCap) {
        this._out(lineCap, " J", NL);
    },
    setLineJoin: function(lineJoin) {
        this._out(lineJoin, " j", NL);
    },
    setMitterLimit: function(mitterLimit) {
        this._out(mitterLimit, " M", NL);
    },
    save: function() {
        this._contextStack.push(this._context());
        this._out("q", NL);
    },
    restore: function() {
        this._out("Q", NL);
        this._context(this._contextStack.pop());
    },

    // paths
    moveTo: function(x, y) {
        this._out(x, " ", y, " m", NL);
    },
    lineTo: function(x, y) {
        this._out(x, " ", y, " l", NL);
    },
    bezier: function(x1, y1, x2, y2, x3, y3) {
        this._out(x1, " ", y1, " ", x2, " ", y2, " ", x3, " ", y3, " c", NL);
    },
    bezier1: function(x1, y1, x3, y3) {
        this._out(x1, " ", y1, " ", x3, " ", y3, " y", NL);
    },
    bezier2: function(x2, y2, x3, y3) {
        this._out(x2, " ", y2, " ", x3, " ", y3, " v", NL);
    },
    close: function() {
        this._out("h", NL);
    },
    rect: function(x, y, w, h) {
        this._out(x, " ", y, " ", w, " ", h, " re", NL);
    },
    ellipse: function(x, y, rx, ry) {
        function _X(v) { return x + v; }
        function _Y(v) { return y + v; }

        // how to get to the "magic number" is explained here:
        // http://www.whizkidtech.redprince.net/bezier/circle/kappa/
        var k = 0.5522847498307936;

        this.moveTo(_X(0), _Y(ry));
        this.bezier(
            _X(rx * k) , _Y(ry),
            _X(rx)     , _Y(ry * k),
            _X(rx)     , _Y(0)
        );
        this.bezier(
            _X(rx)     , _Y(-ry * k),
            _X(rx * k) , _Y(-ry),
            _X(0)      , _Y(-ry)
        );
        this.bezier(
            _X(-rx * k) , _Y(-ry),
            _X(-rx)     , _Y(-ry * k),
            _X(-rx)     , _Y(0)
        );
        this.bezier(
            _X(-rx)     , _Y(ry * k),
            _X(-rx * k) , _Y(ry),
            _X(0)       , _Y(ry)
        );
    },
    circle: function(x, y, r) {
        this.ellipse(x, y, r, r);
    },
    stroke: function() {
        this._out("S", NL);
    },
    nop: function() {
        this._out("n", NL);
    },
    clip: function() {
        this._out("W n", NL);
    },
    clipStroke: function() {
        this._out("W S", NL);
    },
    closeStroke: function() {
        this._out("s", NL);
    },
    fill: function() {
        this._out("f", NL);
    },
    fillStroke: function() {
        this._out("B", NL);
    },
    drawImage: function(url) {
        var img = this._pdf.getImage(url);
        if (img) { // the result can be null for a cross-domain image
            this._xResources[img._resourceName] = img;
            this._out(img._resourceName, " Do", NL);
        }
    },
    comment: function(txt) {
        var self = this;
        txt.split(/\r?\n/g).forEach(function(line){
            self._out("% ", line, NL);
        });
    },

    // internal
    _context: function(val) {
        if (val != null) {
            this._opacity = val.opacity;
            this._matrix = val.matrix;
        } else {
            return {
                opacity: this._opacity,
                matrix: this._matrix
            };
        }
    },

    _toPage: function(p) {
        var m = this._matrix;
        var a = m[0], b = m[1], c = m[2], d = m[3], e = m[4], f = m[5];
        return {
            x: a*p.x + c*p.y + e,
            y: b*p.x + d*p.y + f
        };
    }
}, PDFDictionary);

function unquote(str) {
    return str.replace(/^\s*(['"])(.*)\1\s*$/, "$2");
}

function parseFontDef(fontdef) {
    // XXX: this is very crude for now and buggy.  Proper parsing is quite involved.
    var rx = /^\s*((normal|italic)\s+)?((normal|small-caps)\s+)?((normal|bold|\d+)\s+)?(([0-9.]+)(px|pt))(\/(([0-9.]+)(px|pt)|normal))?\s+(.*?)\s*$/i;
    var m = rx.exec(fontdef);
    if (!m) {
        return { fontSize: 12, fontFamily: "sans-serif" };
    }
    var fontSize = m[8] ? parseInt(m[8], 10) : 12;
    return {
        italic     : m[2] && m[2].toLowerCase() == "italic",
        variant    : m[4],
        bold       : m[6] && /bold|700/i.test(m[6]),
        fontSize   : fontSize,
        lineHeight : m[12] ? m[12] == "normal" ? fontSize : parseInt(m[12], 10) : null,
        fontFamily : m[14].split(/\s*,\s*/g).map(unquote)
    };
}

function getFontURL(style) {
    function mkFamily(name) {
        if (style.bold) {
            name += "|bold";
        }
        if (style.italic) {
            name += "|italic";
        }
        return name.toLowerCase();
    }
    var fontFamily = style.fontFamily;
    var name, url;
    if (fontFamily instanceof Array) {
        for (var i = 0; i < fontFamily.length; ++i) {
            name = mkFamily(fontFamily[i]);
            url = FONT_MAPPINGS[name];
            if (url) {
                break;
            }
        }
    } else {
        url = FONT_MAPPINGS[fontFamily.toLowerCase()];
    }
    while (typeof url == "function") {
        url = url();
    }
    if (!url) {
        url = "Times-Roman";
    }
    return url;
}

var FONT_MAPPINGS = {
    "serif"                    : "Times-Roman",
    "serif|bold"               : "Times-Bold",
    "serif|italic"             : "Times-Italic",
    "serif|bold|italic"        : "Times-BoldItalic",
    "sans-serif"               : "Helvetica",
    "sans-serif|bold"          : "Helvetica-Bold",
    "sans-serif|italic"        : "Helvetica-Oblique",
    "sans-serif|bold|italic"   : "Helvetica-BoldOblique",
    "monospace"                : "Courier",
    "monospace|bold"           : "Courier-Bold",
    "monospace|italic"         : "Courier-Oblique",
    "monospace|bold|italic"    : "Courier-BoldOblique",
    "zapfdingbats"             : "ZapfDingbats",
    "zapfdingbats|bold"        : "ZapfDingbats",
    "zapfdingbats|italic"      : "ZapfDingbats",
    "zapfdingbats|bold|italic" : "ZapfDingbats"
};

function fontAlias(alias, name) {
    alias = alias.toLowerCase();
    FONT_MAPPINGS[alias] = function() {
        return FONT_MAPPINGS[name];
    };
    FONT_MAPPINGS[alias + "|bold"] = function() {
        return FONT_MAPPINGS[name + "|bold"];
    };
    FONT_MAPPINGS[alias + "|italic"] = function() {
        return FONT_MAPPINGS[name + "|italic"];
    };
    FONT_MAPPINGS[alias + "|bold|italic"] = function() {
        return FONT_MAPPINGS[name + "|bold|italic"];
    };
}

// Let's define some common names to an appropriate replacement.
// These are overridable via pdf.defineFont, should the user want to
// include the proper versions.

fontAlias("Times New Roman" , "serif");
fontAlias("Courier New"     , "monospace");
fontAlias("Arial"           , "sans-serif");
fontAlias("Helvetica"       , "sans-serif");
fontAlias("Verdana"         , "sans-serif");
fontAlias("Tahoma"          , "sans-serif");
fontAlias("Georgia"         , "sans-serif");
fontAlias("Monaco"          , "monospace");
fontAlias("Andale Mono"     , "monospace");

function defineFont(name, url) {
    if (arguments.length == 1) {
        for (var i in name) {
            if (hasOwnProperty(name, i)) {
                defineFont(i, name[i]);
            }
        }
    } else {
        name = name.toLowerCase();
        FONT_MAPPINGS[name] = url;

        // special handling for DejaVu fonts: if they get defined,
        // let them also replace the default families, for good
        // Unicode support out of the box.
        switch (name) {
          case "dejavu sans"               : FONT_MAPPINGS["sans-serif"]              = url; break;
          case "dejavu sans|bold"          : FONT_MAPPINGS["sans-serif|bold"]         = url; break;
          case "dejavu sans|italic"        : FONT_MAPPINGS["sans-serif|italic"]       = url; break;
          case "dejavu sans|bold|italic"   : FONT_MAPPINGS["sans-serif|bold|italic"]  = url; break;
          case "dejavu serif"              : FONT_MAPPINGS["serif"]                   = url; break;
          case "dejavu serif|bold"         : FONT_MAPPINGS["serif|bold"]              = url; break;
          case "dejavu serif|italic"       : FONT_MAPPINGS["serif|italic"]            = url; break;
          case "dejavu serif|bold|italic"  : FONT_MAPPINGS["serif|bold|italic"]       = url; break;
          case "dejavu mono"               : FONT_MAPPINGS["monospace"]               = url; break;
          case "dejavu mono|bold"          : FONT_MAPPINGS["monospace|bold"]          = url; break;
          case "dejavu mono|italic"        : FONT_MAPPINGS["monospace|italic"]        = url; break;
          case "dejavu mono|bold|italic"   : FONT_MAPPINGS["monospace|bold|italic"]   = url; break;
        }
    }
}

function mmul(a, b) {
    var a1 = a[0], b1 = a[1], c1 = a[2], d1 = a[3], e1 = a[4], f1 = a[5];
    var a2 = b[0], b2 = b[1], c2 = b[2], d2 = b[3], e2 = b[4], f2 = b[5];
    return [
        a1*a2 + b1*c2,          a1*b2 + b1*d2,
        c1*a2 + d1*c2,          c1*b2 + d1*d2,
        e1*a2 + f1*c2 + e2,     e1*b2 + f1*d2 + f2
    ];
}

function isIdentityMatrix(m) {
    return m[0] === 1 && m[1] === 0 && m[2] === 0 && m[3] === 1 && m[4] === 0 && m[5] === 0;
}

var TEXT_RENDERING_MODE = {
    fill           : 0,
    stroke         : 1,
    fillAndStroke  : 2,
    invisible      : 3,
    fillAndClip    : 4,
    strokeAndClip  : 5,
    fillStrokeClip : 6,
    clip           : 7
};




/***/ }),
/* 683 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return HAS_TYPED_ARRAYS; });
/* unused harmony export BASE64 */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BinaryStream; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ucs2decode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return ucs2encode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return base64ToUint8Array; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common__ = __webpack_require__(29);


/* eslint-disable no-multi-spaces, key-spacing, indent, camelcase, space-before-blocks, eqeqeq, brace-style */
/* eslint-disable space-infix-ops, space-before-function-paren, array-bracket-spacing, object-curly-spacing */
/* eslint-disable no-nested-ternary, max-params, default-case, no-else-return, no-empty */
/* eslint-disable no-param-reassign, no-var, block-scoped-var */

// XXX: remove this junk (assume `true`) when we no longer have to support IE < 10
// IE 9 (at least compatibility) reports having Uint8Array but the request response does not contain ArrayBuffer which results in missing table head error
var HAS_TYPED_ARRAYS = typeof Uint8Array !== 'undefined' && __WEBPACK_IMPORTED_MODULE_0__common__["h" /* support */].browser && (!__WEBPACK_IMPORTED_MODULE_0__common__["h" /* support */].browser.msie || __WEBPACK_IMPORTED_MODULE_0__common__["h" /* support */].browser.version > 9);

var BASE64 = (function(){
    var keyStr = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
    return {
        decode: function(str) {
            var input = str.replace(/[^A-Za-z0-9\+\/\=]/g, ""), i = 0, n = input.length, output = [];

            while (i < n) {
                var enc1 = keyStr.indexOf(input.charAt(i++));
                var enc2 = keyStr.indexOf(input.charAt(i++));
                var enc3 = keyStr.indexOf(input.charAt(i++));
                var enc4 = keyStr.indexOf(input.charAt(i++));

                var chr1 = (enc1 << 2) | (enc2 >>> 4);
                var chr2 = ((enc2 & 15) << 4) | (enc3 >>> 2);
                var chr3 = ((enc3 & 3) << 6) | enc4;

                output.push(chr1);
                if (enc3 != 64) {
                    output.push(chr2);
                }
                if (enc4 != 64) {
                    output.push(chr3);
                }
            }

            return output;
        },
        encode: function(bytes) {
            var i = 0, n = bytes.length;
            var output = "";

            while (i < n) {
                var chr1 = bytes[i++];
                var chr2 = bytes[i++];
                var chr3 = bytes[i++];

                var enc1 = chr1 >>> 2;
                var enc2 = ((chr1 & 3) << 4) | (chr2 >>> 4);
                var enc3 = ((chr2 & 15) << 2) | (chr3 >>> 6);
                var enc4 = chr3 & 63;

                if (i - n == 2) {
                    enc3 = enc4 = 64;
                } else if (i - n == 1) {
                    enc4 = 64;
                }

                output += keyStr.charAt(enc1) + keyStr.charAt(enc2) + keyStr.charAt(enc3) + keyStr.charAt(enc4);
            }
            return output;
        }
    };
}());

function BinaryStream(data) {
    var offset = 0, length = 0;
    if (data == null) {
        data = HAS_TYPED_ARRAYS ? new Uint8Array(256) : [];
    } else {
        length = data.length;
    }

    var ensure = HAS_TYPED_ARRAYS ? function(len) {
        if (len >= data.length) {
            var tmp = new Uint8Array(Math.max(len + 256, data.length * 2));
            tmp.set(data, 0);
            data = tmp;
        }
    } : function() {};

    var get = HAS_TYPED_ARRAYS ? function() {
        return new Uint8Array(data.buffer, 0, length);
    } : function() {
        return data;
    };

    var write = HAS_TYPED_ARRAYS ? function(bytes) {
        if (typeof bytes == "string") {
            return writeString(bytes);
        }
        var len = bytes.length;
        ensure(offset + len);
        data.set(bytes, offset);
        offset += len;
        if (offset > length) {
            length = offset;
        }
    } : function(bytes) {
        if (typeof bytes == "string") {
            return writeString(bytes);
        }
        for (var i = 0; i < bytes.length; ++i) {
            writeByte(bytes[i]);
        }
    };

    var slice = HAS_TYPED_ARRAYS ? function(start, length) {
        if (data.buffer.slice) {
            return new Uint8Array(data.buffer.slice(start, start + length));
        } else {
            // IE10
            var x = new Uint8Array(length);
            x.set(new Uint8Array(data.buffer, start, length));
            return x;
        }
    } : function(start, length) {
        return data.slice(start, start + length);
    };

    function eof() {
        return offset >= length;
    }
    function readByte() {
        return offset < length ? data[offset++] : 0;
    }
    function writeByte(b) {
        ensure(offset);
        data[offset++] = b & 0xFF;
        if (offset > length) {
            length = offset;
        }
    }
    function readShort() {
        return (readByte() << 8) | readByte();
    }
    function writeShort(w) {
        writeByte(w >> 8);
        writeByte(w);
    }
    function readShort_() {
        var w = readShort();
        return w >= 0x8000 ? w - 0x10000 : w;
    }
    function writeShort_(w) {
        writeShort(w < 0 ? w + 0x10000 : w);
    }
    function readLong() {
        return (readShort() * 0x10000) + readShort();
    }
    function writeLong(w) {
        writeShort((w >>> 16) & 0xFFFF);
        writeShort(w & 0xFFFF);
    }
    function readLong_() {
        var w = readLong();
        return w >= 0x80000000 ? w - 0x100000000 : w;
    }
    function writeLong_(w) {
        writeLong(w < 0 ? w + 0x100000000 : w);
    }
    function readFixed() {
        return readLong() / 0x10000;
    }
    function writeFixed(f) {
        writeLong(Math.round(f * 0x10000));
    }
    function readFixed_() {
        return readLong_() / 0x10000;
    }
    function writeFixed_(f) {
        writeLong_(Math.round(f * 0x10000));
    }
    function read(len) {
        return times(len, readByte);
    }
    function readString(len) {
        return String.fromCharCode.apply(String, read(len));
    }
    function writeString(str) {
        for (var i = 0; i < str.length; ++i) {
            writeByte(str.charCodeAt(i));
        }
    }
    function times(n, reader) {
        for (var ret = new Array(n), i = 0; i < n; ++i) {
            ret[i] = reader();
        }
        return ret;
    }

    var stream = {
        eof         : eof,
        readByte    : readByte,
        writeByte   : writeByte,
        readShort   : readShort,
        writeShort  : writeShort,
        readLong    : readLong,
        writeLong   : writeLong,
        readFixed   : readFixed,
        writeFixed  : writeFixed,

        // signed numbers.
        readShort_  : readShort_,
        writeShort_ : writeShort_,
        readLong_   : readLong_,
        writeLong_  : writeLong_,
        readFixed_  : readFixed_,
        writeFixed_ : writeFixed_,

        read        : read,
        write       : write,
        readString  : readString,
        writeString : writeString,

        times       : times,
        get         : get,
        slice       : slice,

        offset: function(pos) {
            if (pos != null) {
                offset = pos;
                return stream;
            }
            return offset;
        },

        skip: function(nbytes) {
            offset += nbytes;
        },

        toString: function() {
            throw new Error("FIX CALLER.  BinaryStream is no longer convertible to string!");
        },

        length: function() { return length; },

        saveExcursion: function(f) {
            var pos = offset;
            try {
                return f();
            } finally {
                offset = pos;
            }
        },

        writeBase64: function(base64) {
            if (window.atob) {
                writeString(window.atob(base64));
            } else {
                write(BASE64.decode(base64));
            }
        },
        base64: function() {
            return BASE64.encode(get());
        }
    };

    return stream;
}

function ucs2decode(string) {
    var output = [],
        counter = 0,
        length = string.length,
        value,
        extra;
    while (counter < length) {
        value = string.charCodeAt(counter++);
        if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
            // high surrogate, and there is a next character
            extra = string.charCodeAt(counter++);
            if ((extra & 0xFC00) == 0xDC00) { // low surrogate
                output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
            } else {
                // unmatched surrogate; only append this code unit, in case the next
                // code unit is the high surrogate of a surrogate pair
                output.push(value);
                counter--;
            }
        } else {
            output.push(value);
        }
    }
    return output;
}

function ucs2encode(array) {
    return array.map(function(value){
        var output = "";
        if (value > 0xFFFF) {
            value -= 0x10000;
            output += String.fromCharCode(value >>> 10 & 0x3FF | 0xD800);
            value = 0xDC00 | value & 0x3FF;
        }
        output += String.fromCharCode(value);
        return output;
    }).join("");
}

function atobUint8Array(base64) {
    var data = window.atob(base64);
    var result = new Uint8Array(data.length);

    for (var idx = 0; idx < data.length; idx++) {
        result[idx] = data.charCodeAt(idx);
    }

    return result;
}

function createUint8Array(data) {
    var result = new Uint8Array(data.length);

    for (var idx = 0; idx < data.length; idx++) {
        result[idx] = data[idx];
    }

    return result;
}

function base64ToUint8Array(base64) {
    if (window.atob) {
        return atobUint8Array(base64);
    }

    return createUint8Array(BASE64.decode(base64));
}




/***/ }),
/* 684 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__save_as__ = __webpack_require__(2585);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__save_as__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base64__ = __webpack_require__(2586);
/* unused harmony reexport encodeBase64 */




/***/ }),
/* 685 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PDFMargin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


/**
 * @hidden
 */
var PDFMargin = /** @class */ (function (_super) {
    __extends(PDFMargin, _super);
    function PDFMargin() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PDFMargin.prototype.render = function () {
        return null;
    };
    PDFMargin.propTypes = {
        left: __WEBPACK_IMPORTED_MODULE_1_prop_types__["oneOfType"]([__WEBPACK_IMPORTED_MODULE_1_prop_types__["number"], __WEBPACK_IMPORTED_MODULE_1_prop_types__["string"]]),
        top: __WEBPACK_IMPORTED_MODULE_1_prop_types__["oneOfType"]([__WEBPACK_IMPORTED_MODULE_1_prop_types__["number"], __WEBPACK_IMPORTED_MODULE_1_prop_types__["string"]]),
        right: __WEBPACK_IMPORTED_MODULE_1_prop_types__["oneOfType"]([__WEBPACK_IMPORTED_MODULE_1_prop_types__["number"], __WEBPACK_IMPORTED_MODULE_1_prop_types__["string"]]),
        bottom: __WEBPACK_IMPORTED_MODULE_1_prop_types__["oneOfType"]([__WEBPACK_IMPORTED_MODULE_1_prop_types__["number"], __WEBPACK_IMPORTED_MODULE_1_prop_types__["string"]])
    };
    return PDFMargin;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));

//# sourceMappingURL=PDFMargin.js.map

/***/ }),
/* 686 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom_server__ = __webpack_require__(341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom_server___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom_server__);


var defaultFileName = 'export.pdf';
var defaultCreator = 'Kendo UI PDF Generator';
/**
 * @hidden
 */
var KendoDrawingAdapter = /** @class */ (function () {
    function KendoDrawingAdapter(drawDOM, exportPDF, saveAs, domElement, options) {
        if (options === void 0) { options = {}; }
        var _this = this;
        this.drawDOM = drawDOM;
        this.exportPDF = exportPDF;
        this.saveAs = saveAs;
        this.domElement = domElement;
        this.options = options;
        this.convertPageTemplateToHtml = function (pageContext) {
            var pageTemplateContent = __WEBPACK_IMPORTED_MODULE_1_react_dom_server__["renderToStaticMarkup"](__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](_this.options.pageTemplate, {
                pageNum: pageContext.pageNum, totalPages: pageContext.totalPages
            }));
            return "<span>" + pageTemplateContent + "</span>";
        };
    }
    KendoDrawingAdapter.prototype.savePDF = function (callback) {
        var _this = this;
        var savePromise = this.drawDOM(this.domElement, this.getDrawOptions())
            .then(function (group) { return _this.exportPDF(group, _this.getPDFOptions()); })
            .then(function (dataUri) { return _this.saveAs(dataUri, _this.options.fileName || defaultFileName, _this.getSaveOptions()); });
        if (callback) {
            savePromise.then(callback, callback);
        }
    };
    KendoDrawingAdapter.prototype.getDrawOptions = function () {
        return {
            avoidLinks: this.options.avoidLinks,
            forcePageBreak: this.options.forcePageBreak,
            keepTogether: this.options.keepTogether,
            margin: this.options.margin,
            paperSize: this.options.paperSize,
            landscape: this.options.landscape,
            repeatHeaders: this.options.repeatHeaders,
            scale: this.options.scale,
            template: this.options.pageTemplate && this.convertPageTemplateToHtml
        };
    };
    KendoDrawingAdapter.prototype.getPDFOptions = function () {
        return {
            author: this.options.author,
            creator: this.options.creator || defaultCreator,
            date: this.options.date,
            imgDPI: this.options.imageResolution,
            keywords: this.options.keywords,
            landscape: this.options.landscape,
            margin: this.options.margin,
            multiPage: true,
            paperSize: this.options.paperSize,
            producer: this.options.producer,
            subject: this.options.subject,
            title: this.options.title
        };
    };
    KendoDrawingAdapter.prototype.getSaveOptions = function () {
        return {
            forceProxy: this.options.forceProxy,
            proxyData: this.options.proxyData,
            proxyTarget: this.options.proxyTarget,
            proxyURL: this.options.proxyURL
        };
    };
    return KendoDrawingAdapter;
}());
/* harmony default export */ __webpack_exports__["a"] = (KendoDrawingAdapter);
//# sourceMappingURL=KendoDrawingAdapter.js.map

/***/ }),
/* 687 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = savePDF;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__progress_kendo_drawing__ = __webpack_require__(636);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__progress_kendo_file_saver__ = __webpack_require__(684);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__KendoDrawingAdapter__ = __webpack_require__(686);



/**
 * Saves the content of a DOM element to a PDF file.
 *
 * @param domElement - The root DOM element to save to a PDF file.
 * @param options - The export options.
 * @param callback - The callback to be executed after the PDF is saved.
 */
function savePDF(domElement, options, callback) {
    if (options === void 0) { options = {}; }
    new __WEBPACK_IMPORTED_MODULE_2__KendoDrawingAdapter__["a" /* default */](__WEBPACK_IMPORTED_MODULE_0__progress_kendo_drawing__["a" /* drawDOM */], __WEBPACK_IMPORTED_MODULE_0__progress_kendo_drawing__["b" /* exportPDF */], __WEBPACK_IMPORTED_MODULE_1__progress_kendo_file_saver__["a" /* saveAs */], domElement, options).savePDF(callback);
}
//# sourceMappingURL=savePDF.js.map

/***/ }),
/* 688 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core__ = __webpack_require__(4);
var CustomCardHeading=function CustomCardHeading(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["Z" /* Typography */],{variant:"subheading",className:"centerCell"},props.subheading),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["Z" /* Typography */],{variant:"caption",className:"centerCell"},props.caption),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:{borderBottom:"1px solid #cccccc69",margin:"5px auto",width:"25%"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["Z" /* Typography */],{variant:"headline",className:"centerCell",style:{marginBottom:"35px"}},props.headline));};/* harmony default export */ __webpack_exports__["a"] = (CustomCardHeading);

/***/ }),
/* 689 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_core__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
var DescriptiveCell=function DescriptiveCell(props){var hasBorder=props.count<1;if(props.noBorder)hasBorder=false;if(props.hasBorder)hasBorder=true;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{style:{borderBottom:hasBorder?"1px solid #e0e0e0":"0px",padding:"0px",paddingTop:"15px",width:"150em"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{container:true},props.description?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{item:true,xs:6,sm:6,md:4},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("strong",null,props.description))):null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{item:true,xs:2,sm:2,md:props.description?1:10},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["d" /* Button */],{variant:"fab",mini:true,className:"minifab",color:"primary",style:{bottom:"3px"},onClick:function onClick(event){event.stopPropagation();props.add();}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["w" /* Icon */],{style:{color:"white"}},"add"))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{item:true,xs:2,sm:2,md:2,style:{textAlign:"center"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{variant:"caption"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("strong",null,props.count===0?"":props.count)))));};/* harmony default export */ __webpack_exports__["a"] = (DescriptiveCell);

/***/ }),
/* 690 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_core__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_icons__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_assets_img_faces_avatar1_jpg__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_assets_img_faces_avatar1_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_assets_img_faces_avatar1_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_ChatCard_ChatCard_jsx__ = __webpack_require__(2614);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_Grid_GridItem_jsx__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_helpers_UriReader__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_helpers_UserHelper__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_perfect_scrollbar__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_perfect_scrollbar_css_perfect_scrollbar_css__ = __webpack_require__(363);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_perfect_scrollbar_css_perfect_scrollbar_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_perfect_scrollbar_css_perfect_scrollbar_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_queries_messaging_mutations__ = __webpack_require__(2615);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_queries_messaging_queries_js__ = __webpack_require__(691);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_apollo__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_router__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_sockets_api__ = __webpack_require__(2616);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Todos_components_TodoDialog_jsx__ = __webpack_require__(705);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/*eslint-disable*/var ps;var ClientMessages=function(_React$Component){_inherits(ClientMessages,_React$Component);function ClientMessages(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ClientMessages);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ClientMessages.__proto__||Object.getPrototypeOf(ClientMessages)).call.apply(_ref,[this].concat(args))),_this),_this.state={initiated:false,clientId:null,clientName:null,messages:[],inputText:"",comboRoute:"",openTodoDialog:false,selectedTodo:null},_this.handelCloseTodoDialog=function(){_this.setState({openTodoDialog:false,selectedTodo:null});},_this.handelOpenTodoDialog=function(message,clientId,clientName){var todo={client_fullname:clientName,client_id:clientId,desc:message.message};_this.setState({selectedTodo:todo,openTodoDialog:true});},_this.todoAdded=function(todo){},_this.updatePs=function(){if(ps){ps.update();if(_this.refs.chat1){var container=_this.refs.chat1;var scrollBottom=container.scrollTop+container.clientHeight;container.scrollTop=scrollBottom;}}},_this.onInputChange=function(event){_this.setState({inputText:event.target.value});},_this.sendMessage=function(){Object(__WEBPACK_IMPORTED_MODULE_15_sockets_api__["c" /* sendClientMessage */])(_this.state.inputText,Object(__WEBPACK_IMPORTED_MODULE_7_helpers_UserHelper__["a" /* GetUserId */])(),_this.state.comboRoute);_this.setState({inputText:""});},_this.onNewMessage=function(data){if(data.error)return;var messages=[].concat(_toConsumableArray(_this.state.messages));messages.push(data);_this.setState({messages:messages});if(data.sender_id.toString()!==Object(__WEBPACK_IMPORTED_MODULE_7_helpers_UserHelper__["a" /* GetUserId */])()){_this.setMessageRead(data.messageId);}},_this.setMessageRead=function(messageId){_this.props.SetClientMessageRead({variables:{input:{brokerId:Object(__WEBPACK_IMPORTED_MODULE_7_helpers_UserHelper__["a" /* GetUserId */])(),token:Object(__WEBPACK_IMPORTED_MODULE_7_helpers_UserHelper__["c" /* GetUserToken */])(),messageId:messageId}}}).then(function(resp){console.log("message read");}).catch(function(error){console.log("err",error);});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ClientMessages,[{key:"componentDidMount",value:function componentDidMount(){var _this2=this;if(navigator.platform.indexOf("Win")>-1){if(this.refs.chat1){ps=new __WEBPACK_IMPORTED_MODULE_8_perfect_scrollbar__["a" /* default */](this.refs.chat1,{wheelSpeed:0.5,wheelPropagation:true,minScrollbarLength:20});var container=this.refs.chat1;var scrollBottom=container.scrollTop+container.clientHeight;container.scrollTop=scrollBottom;}}//msg init
var clientId=null;if(this.props.clientId&&this.props.clientName){clientId=this.props.clientId;this.setState({clientId:this.props.clientId,clientName:this.props.clientName});}else{var params=Object(__WEBPACK_IMPORTED_MODULE_6_helpers_UriReader__["a" /* ParseUriParams */])(this.props.location.search);var clientName=params.clientName;clientId=params.clientId;this.setState({clientId:clientId,clientName:clientName});}var comboRoute="subscribe/client_messaging/"+Object(__WEBPACK_IMPORTED_MODULE_7_helpers_UserHelper__["a" /* GetUserId */])()+"+"+clientId;this.setState({comboRoute:comboRoute,clientId:clientId});Object(__WEBPACK_IMPORTED_MODULE_15_sockets_api__["d" /* subscribeToClientMessaging */])(Object(__WEBPACK_IMPORTED_MODULE_7_helpers_UserHelper__["a" /* GetUserId */])(),clientId,Object(__WEBPACK_IMPORTED_MODULE_7_helpers_UserHelper__["c" /* GetUserToken */])());Object(__WEBPACK_IMPORTED_MODULE_15_sockets_api__["b" /* listenToClientMessages */])(comboRoute,function(data){return _this2.onNewMessage(data);});}},{key:"componentWillUnmount",value:function componentWillUnmount(){Object(__WEBPACK_IMPORTED_MODULE_15_sockets_api__["a" /* RemoveMessageListeners */])(this.state.comboRoute);if(navigator.platform.indexOf("Win")>-1){if(ps){ps.destroy();}}}},{key:"componentDidUpdate",value:function componentDidUpdate(e){if(navigator.platform.indexOf("Win")>-1){if(this.refs.chat1){var container=this.refs.chat1;var scrollBottom=container.scrollTop+container.clientHeight;container.scrollTop=scrollBottom;}}}},{key:"render",value:function render(){var _this3=this;var _state=this.state,clientId=_state.clientId,clientName=_state.clientName;return __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{container:true},__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:12,style:{flexBasis:"100%",maxWidth:"100%",margin:'auto'}},__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["e" /* Card */],null,__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["f" /* CardContent */],null,this.props.clientId&&this.props.clientName?null:__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{variant:"headline",className:"centerCell"},"Client Messages"),__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement("div",{style:{borderBottom:"1px solid #cccccc69",margin:"5px auto",width:"25%"}}),clientName?__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{variant:"subheading",className:"centerCell"},clientName):null),__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement("div",{style:{position:"relative",height:"30em",overflowY:"hidden",overflowX:"hidden",border:"1px solid #ababab57",margin:"5px 0px",padding:"5px 0px"},id:"chatBlock",ref:"chat1"},__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{container:true,style:{display:"inline-grid"}},__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_react_apollo__["Query"],{query:__WEBPACK_IMPORTED_MODULE_11_queries_messaging_queries_js__["b" /* GetClientMessages */],variables:{brokerId:Object(__WEBPACK_IMPORTED_MODULE_7_helpers_UserHelper__["a" /* GetUserId */])(),clientId:clientId,token:Object(__WEBPACK_IMPORTED_MODULE_7_helpers_UserHelper__["c" /* GetUserToken */])()},fetchPolicy:"network-only"},function(_ref2){var loading=_ref2.loading,error=_ref2.error,data=_ref2.data;if(loading)return __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["B" /* LinearProgress */],null));if(error&&error.message&&error.message==="GraphQL error: invalid token"){Object(__WEBPACK_IMPORTED_MODULE_7_helpers_UserHelper__["d" /* Logout */])();return __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_react_router__["a" /* Redirect */],{to:"/app/portal/login"});}else if(error)return"Error! "+error.message;var _data$ClientMessages=data.ClientMessages,Client=_data$ClientMessages.Client,Messages=_data$ClientMessages.Messages;var avatarPath=__WEBPACK_IMPORTED_MODULE_3_assets_img_faces_avatar1_jpg___default.a;if(Client.client_avatar!==null&&Client.client_avatar!==""){avatarPath=Client.client_avatar;}var brokerAvatarPath=__WEBPACK_IMPORTED_MODULE_3_assets_img_faces_avatar1_jpg___default.a;if(Object(__WEBPACK_IMPORTED_MODULE_7_helpers_UserHelper__["b" /* GetUserKey */])("avatar")!==""){brokerAvatarPath=Object(__WEBPACK_IMPORTED_MODULE_7_helpers_UserHelper__["b" /* GetUserKey */])("avatar");}if(!_this3.state.initiated){_this3.setState({messages:Messages,initiated:true});}return __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react___default.a.Fragment,null,_this3.state.messages.map(function(message,index){var ownMessage=message.sender_id.toString()===Object(__WEBPACK_IMPORTED_MODULE_7_helpers_UserHelper__["a" /* GetUserId */])();return __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement("div",{key:index},__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_ChatCard_ChatCard_jsx__["a" /* default */],{ownMessage:ownMessage?true:false,avatarPath:ownMessage?brokerAvatarPath:avatarPath,name:ownMessage?Object(__WEBPACK_IMPORTED_MODULE_7_helpers_UserHelper__["b" /* GetUserKey */])("name")+" "+Object(__WEBPACK_IMPORTED_MODULE_7_helpers_UserHelper__["b" /* GetUserKey */])("surname"):Client.client_fullname,text:message.message,date:message.date_sent,updatePs:_this3.updatePs,addTodo:function addTodo(){return _this3.handelOpenTodoDialog(message,clientId,clientName);}}));}),_this3.state.messages.length<1?__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{className:"centerCell",variant:"caption"},"No messages for this client yet"):null);}))),__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{container:true},__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:12,style:{display:"flex"}},__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["X" /* TextField */],{label:"Type a message...",multiline:true,rowsMax:"4",value:this.state.inputText,onChange:this.onInputChange,fullWidth:true}),__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement("button",{onClick:function onClick(){return _this3.sendMessage();},style:{backgroundColor:"#f3f3f3",border:"1px solid #949494",cursor:"pointer"}},__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_icons__["o" /* Send */],null))))))),this.state.openTodoDialog?__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__Todos_components_TodoDialog_jsx__["a" /* default */],{open:true,closeDialog:this.handelCloseTodoDialog,todoAdded:function todoAdded(resp){return _this3.todoAdded(resp);},todo:this.state.selectedTodo}):null);}}]);return ClientMessages;}(__WEBPACK_IMPORTED_MODULE_12_react___default.a.Component);ClientMessages=Object(__WEBPACK_IMPORTED_MODULE_13_react_apollo__["compose"])(Object(__WEBPACK_IMPORTED_MODULE_13_react_apollo__["graphql"])(__WEBPACK_IMPORTED_MODULE_10_queries_messaging_mutations__["a" /* SetClientMessageRead */],{name:"SetClientMessageRead"}))(ClientMessages);/* harmony default export */ __webpack_exports__["a"] = (ClientMessages);

/***/ }),
/* 691 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return GetClientMessages; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GetClientMessageHistory; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_graphql_tag__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_graphql_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_graphql_tag__);
var _templateObject=_taggedTemplateLiteral(["\n  query clientMessages(\n    $brokerId: String!\n    $clientId: String!\n    $token: String!\n  ) {\n    ClientMessages(brokerId: $brokerId, clientId: $clientId, token: $token) {\n      Client {\n        id\n        client_fullname\n        client_avatar\n      }\n      Messages {\n        id\n        sender_id\n        message\n        date_sent\n      }\n    }\n  }\n"],["\n  query clientMessages(\n    $brokerId: String!\n    $clientId: String!\n    $token: String!\n  ) {\n    ClientMessages(brokerId: $brokerId, clientId: $clientId, token: $token) {\n      Client {\n        id\n        client_fullname\n        client_avatar\n      }\n      Messages {\n        id\n        sender_id\n        message\n        date_sent\n      }\n    }\n  }\n"]),_templateObject2=_taggedTemplateLiteral(["\n  query clientMessageHistory(\n    $brokerId: String!\n    $token: String!\n    $limit: Int!\n    $page: Int!\n    $orderBy: String\n    $direction: String\n    $search: String\n  ) {\n    ClientMessageHistory(\n      brokerId: $brokerId\n      token: $token\n      limit: $limit\n      page: $page\n      orderBy: $orderBy\n      direction: $direction\n      search: $search\n    ) {\n      Count\n      Results {\n        id\n        clientFullName\n        latest_message_date\n        unread_messages\n      }\n    }\n  }\n"],["\n  query clientMessageHistory(\n    $brokerId: String!\n    $token: String!\n    $limit: Int!\n    $page: Int!\n    $orderBy: String\n    $direction: String\n    $search: String\n  ) {\n    ClientMessageHistory(\n      brokerId: $brokerId\n      token: $token\n      limit: $limit\n      page: $page\n      orderBy: $orderBy\n      direction: $direction\n      search: $search\n    ) {\n      Count\n      Results {\n        id\n        clientFullName\n        latest_message_date\n        unread_messages\n      }\n    }\n  }\n"]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var GetClientMessages=__WEBPACK_IMPORTED_MODULE_0_graphql_tag___default()(_templateObject);var GetClientMessageHistory=__WEBPACK_IMPORTED_MODULE_0_graphql_tag___default()(_templateObject2);

/***/ }),
/* 692 */
/***/ (function(module, exports) {

/**
 * Parses an URI
 *
 * @author Steven Levithan <stevenlevithan.com> (MIT license)
 * @api private
 */

var re = /^(?:(?![^:@]+:[^:@\/]*@)(http|https|ws|wss):\/\/)?((?:(([^:@]*)(?::([^:@]*))?)?@)?((?:[a-f0-9]{0,4}:){2,7}[a-f0-9]{0,4}|[^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/;

var parts = [
    'source', 'protocol', 'authority', 'userInfo', 'user', 'password', 'host', 'port', 'relative', 'path', 'directory', 'file', 'query', 'anchor'
];

module.exports = function parseuri(str) {
    var src = str,
        b = str.indexOf('['),
        e = str.indexOf(']');

    if (b != -1 && e != -1) {
        str = str.substring(0, b) + str.substring(b, e).replace(/:/g, ';') + str.substring(e, str.length);
    }

    var m = re.exec(str || ''),
        uri = {},
        i = 14;

    while (i--) {
        uri[parts[i]] = m[i] || '';
    }

    if (b != -1 && e != -1) {
        uri.source = src;
        uri.host = uri.host.substring(1, uri.host.length - 1).replace(/;/g, ':');
        uri.authority = uri.authority.replace('[', '').replace(']', '').replace(/;/g, ':');
        uri.ipv6uri = true;
    }

    return uri;
};


/***/ }),
/* 693 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};


/***/ }),
/* 694 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {
module.exports = isBuf;

var withNativeBuffer = typeof Buffer === 'function' && typeof Buffer.isBuffer === 'function';
var withNativeArrayBuffer = typeof ArrayBuffer === 'function';

var isView = function (obj) {
  return typeof ArrayBuffer.isView === 'function' ? ArrayBuffer.isView(obj) : (obj.buffer instanceof ArrayBuffer);
};

/**
 * Returns true if obj is a buffer or an arraybuffer.
 *
 * @api private
 */

function isBuf(obj) {
  return (withNativeBuffer && Buffer.isBuffer(obj)) ||
          (withNativeArrayBuffer && (obj instanceof ArrayBuffer || isView(obj)));
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(123).Buffer))

/***/ }),
/* 695 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};


/***/ }),
/* 696 */
/***/ (function(module, exports, __webpack_require__) {


/**
 * Module dependencies.
 */

var eio = __webpack_require__(2624);
var Socket = __webpack_require__(702);
var Emitter = __webpack_require__(152);
var parser = __webpack_require__(414);
var on = __webpack_require__(703);
var bind = __webpack_require__(704);
var debug = __webpack_require__(88)('socket.io-client:manager');
var indexOf = __webpack_require__(701);
var Backoff = __webpack_require__(2639);

/**
 * IE6+ hasOwnProperty
 */

var has = Object.prototype.hasOwnProperty;

/**
 * Module exports
 */

module.exports = Manager;

/**
 * `Manager` constructor.
 *
 * @param {String} engine instance or engine uri/opts
 * @param {Object} options
 * @api public
 */

function Manager (uri, opts) {
  if (!(this instanceof Manager)) return new Manager(uri, opts);
  if (uri && ('object' === typeof uri)) {
    opts = uri;
    uri = undefined;
  }
  opts = opts || {};

  opts.path = opts.path || '/socket.io';
  this.nsps = {};
  this.subs = [];
  this.opts = opts;
  this.reconnection(opts.reconnection !== false);
  this.reconnectionAttempts(opts.reconnectionAttempts || Infinity);
  this.reconnectionDelay(opts.reconnectionDelay || 1000);
  this.reconnectionDelayMax(opts.reconnectionDelayMax || 5000);
  this.randomizationFactor(opts.randomizationFactor || 0.5);
  this.backoff = new Backoff({
    min: this.reconnectionDelay(),
    max: this.reconnectionDelayMax(),
    jitter: this.randomizationFactor()
  });
  this.timeout(null == opts.timeout ? 20000 : opts.timeout);
  this.readyState = 'closed';
  this.uri = uri;
  this.connecting = [];
  this.lastPing = null;
  this.encoding = false;
  this.packetBuffer = [];
  var _parser = opts.parser || parser;
  this.encoder = new _parser.Encoder();
  this.decoder = new _parser.Decoder();
  this.autoConnect = opts.autoConnect !== false;
  if (this.autoConnect) this.open();
}

/**
 * Propagate given event to sockets and emit on `this`
 *
 * @api private
 */

Manager.prototype.emitAll = function () {
  this.emit.apply(this, arguments);
  for (var nsp in this.nsps) {
    if (has.call(this.nsps, nsp)) {
      this.nsps[nsp].emit.apply(this.nsps[nsp], arguments);
    }
  }
};

/**
 * Update `socket.id` of all sockets
 *
 * @api private
 */

Manager.prototype.updateSocketIds = function () {
  for (var nsp in this.nsps) {
    if (has.call(this.nsps, nsp)) {
      this.nsps[nsp].id = this.generateId(nsp);
    }
  }
};

/**
 * generate `socket.id` for the given `nsp`
 *
 * @param {String} nsp
 * @return {String}
 * @api private
 */

Manager.prototype.generateId = function (nsp) {
  return (nsp === '/' ? '' : (nsp + '#')) + this.engine.id;
};

/**
 * Mix in `Emitter`.
 */

Emitter(Manager.prototype);

/**
 * Sets the `reconnection` config.
 *
 * @param {Boolean} true/false if it should automatically reconnect
 * @return {Manager} self or value
 * @api public
 */

Manager.prototype.reconnection = function (v) {
  if (!arguments.length) return this._reconnection;
  this._reconnection = !!v;
  return this;
};

/**
 * Sets the reconnection attempts config.
 *
 * @param {Number} max reconnection attempts before giving up
 * @return {Manager} self or value
 * @api public
 */

Manager.prototype.reconnectionAttempts = function (v) {
  if (!arguments.length) return this._reconnectionAttempts;
  this._reconnectionAttempts = v;
  return this;
};

/**
 * Sets the delay between reconnections.
 *
 * @param {Number} delay
 * @return {Manager} self or value
 * @api public
 */

Manager.prototype.reconnectionDelay = function (v) {
  if (!arguments.length) return this._reconnectionDelay;
  this._reconnectionDelay = v;
  this.backoff && this.backoff.setMin(v);
  return this;
};

Manager.prototype.randomizationFactor = function (v) {
  if (!arguments.length) return this._randomizationFactor;
  this._randomizationFactor = v;
  this.backoff && this.backoff.setJitter(v);
  return this;
};

/**
 * Sets the maximum delay between reconnections.
 *
 * @param {Number} delay
 * @return {Manager} self or value
 * @api public
 */

Manager.prototype.reconnectionDelayMax = function (v) {
  if (!arguments.length) return this._reconnectionDelayMax;
  this._reconnectionDelayMax = v;
  this.backoff && this.backoff.setMax(v);
  return this;
};

/**
 * Sets the connection timeout. `false` to disable
 *
 * @return {Manager} self or value
 * @api public
 */

Manager.prototype.timeout = function (v) {
  if (!arguments.length) return this._timeout;
  this._timeout = v;
  return this;
};

/**
 * Starts trying to reconnect if reconnection is enabled and we have not
 * started reconnecting yet
 *
 * @api private
 */

Manager.prototype.maybeReconnectOnOpen = function () {
  // Only try to reconnect if it's the first time we're connecting
  if (!this.reconnecting && this._reconnection && this.backoff.attempts === 0) {
    // keeps reconnection from firing twice for the same reconnection loop
    this.reconnect();
  }
};

/**
 * Sets the current transport `socket`.
 *
 * @param {Function} optional, callback
 * @return {Manager} self
 * @api public
 */

Manager.prototype.open =
Manager.prototype.connect = function (fn, opts) {
  debug('readyState %s', this.readyState);
  if (~this.readyState.indexOf('open')) return this;

  debug('opening %s', this.uri);
  this.engine = eio(this.uri, this.opts);
  var socket = this.engine;
  var self = this;
  this.readyState = 'opening';
  this.skipReconnect = false;

  // emit `open`
  var openSub = on(socket, 'open', function () {
    self.onopen();
    fn && fn();
  });

  // emit `connect_error`
  var errorSub = on(socket, 'error', function (data) {
    debug('connect_error');
    self.cleanup();
    self.readyState = 'closed';
    self.emitAll('connect_error', data);
    if (fn) {
      var err = new Error('Connection error');
      err.data = data;
      fn(err);
    } else {
      // Only do this if there is no fn to handle the error
      self.maybeReconnectOnOpen();
    }
  });

  // emit `connect_timeout`
  if (false !== this._timeout) {
    var timeout = this._timeout;
    debug('connect attempt will timeout after %d', timeout);

    // set timer
    var timer = setTimeout(function () {
      debug('connect attempt timed out after %d', timeout);
      openSub.destroy();
      socket.close();
      socket.emit('error', 'timeout');
      self.emitAll('connect_timeout', timeout);
    }, timeout);

    this.subs.push({
      destroy: function () {
        clearTimeout(timer);
      }
    });
  }

  this.subs.push(openSub);
  this.subs.push(errorSub);

  return this;
};

/**
 * Called upon transport open.
 *
 * @api private
 */

Manager.prototype.onopen = function () {
  debug('open');

  // clear old subs
  this.cleanup();

  // mark as open
  this.readyState = 'open';
  this.emit('open');

  // add new subs
  var socket = this.engine;
  this.subs.push(on(socket, 'data', bind(this, 'ondata')));
  this.subs.push(on(socket, 'ping', bind(this, 'onping')));
  this.subs.push(on(socket, 'pong', bind(this, 'onpong')));
  this.subs.push(on(socket, 'error', bind(this, 'onerror')));
  this.subs.push(on(socket, 'close', bind(this, 'onclose')));
  this.subs.push(on(this.decoder, 'decoded', bind(this, 'ondecoded')));
};

/**
 * Called upon a ping.
 *
 * @api private
 */

Manager.prototype.onping = function () {
  this.lastPing = new Date();
  this.emitAll('ping');
};

/**
 * Called upon a packet.
 *
 * @api private
 */

Manager.prototype.onpong = function () {
  this.emitAll('pong', new Date() - this.lastPing);
};

/**
 * Called with data.
 *
 * @api private
 */

Manager.prototype.ondata = function (data) {
  this.decoder.add(data);
};

/**
 * Called when parser fully decodes a packet.
 *
 * @api private
 */

Manager.prototype.ondecoded = function (packet) {
  this.emit('packet', packet);
};

/**
 * Called upon socket error.
 *
 * @api private
 */

Manager.prototype.onerror = function (err) {
  debug('error', err);
  this.emitAll('error', err);
};

/**
 * Creates a new socket for the given `nsp`.
 *
 * @return {Socket}
 * @api public
 */

Manager.prototype.socket = function (nsp, opts) {
  var socket = this.nsps[nsp];
  if (!socket) {
    socket = new Socket(this, nsp, opts);
    this.nsps[nsp] = socket;
    var self = this;
    socket.on('connecting', onConnecting);
    socket.on('connect', function () {
      socket.id = self.generateId(nsp);
    });

    if (this.autoConnect) {
      // manually call here since connecting event is fired before listening
      onConnecting();
    }
  }

  function onConnecting () {
    if (!~indexOf(self.connecting, socket)) {
      self.connecting.push(socket);
    }
  }

  return socket;
};

/**
 * Called upon a socket close.
 *
 * @param {Socket} socket
 */

Manager.prototype.destroy = function (socket) {
  var index = indexOf(this.connecting, socket);
  if (~index) this.connecting.splice(index, 1);
  if (this.connecting.length) return;

  this.close();
};

/**
 * Writes a packet.
 *
 * @param {Object} packet
 * @api private
 */

Manager.prototype.packet = function (packet) {
  debug('writing packet %j', packet);
  var self = this;
  if (packet.query && packet.type === 0) packet.nsp += '?' + packet.query;

  if (!self.encoding) {
    // encode, then write to engine with result
    self.encoding = true;
    this.encoder.encode(packet, function (encodedPackets) {
      for (var i = 0; i < encodedPackets.length; i++) {
        self.engine.write(encodedPackets[i], packet.options);
      }
      self.encoding = false;
      self.processPacketQueue();
    });
  } else { // add packet to the queue
    self.packetBuffer.push(packet);
  }
};

/**
 * If packet buffer is non-empty, begins encoding the
 * next packet in line.
 *
 * @api private
 */

Manager.prototype.processPacketQueue = function () {
  if (this.packetBuffer.length > 0 && !this.encoding) {
    var pack = this.packetBuffer.shift();
    this.packet(pack);
  }
};

/**
 * Clean up transport subscriptions and packet buffer.
 *
 * @api private
 */

Manager.prototype.cleanup = function () {
  debug('cleanup');

  var subsLength = this.subs.length;
  for (var i = 0; i < subsLength; i++) {
    var sub = this.subs.shift();
    sub.destroy();
  }

  this.packetBuffer = [];
  this.encoding = false;
  this.lastPing = null;

  this.decoder.destroy();
};

/**
 * Close the current socket.
 *
 * @api private
 */

Manager.prototype.close =
Manager.prototype.disconnect = function () {
  debug('disconnect');
  this.skipReconnect = true;
  this.reconnecting = false;
  if ('opening' === this.readyState) {
    // `onclose` will not fire because
    // an open event never happened
    this.cleanup();
  }
  this.backoff.reset();
  this.readyState = 'closed';
  if (this.engine) this.engine.close();
};

/**
 * Called upon engine close.
 *
 * @api private
 */

Manager.prototype.onclose = function (reason) {
  debug('onclose');

  this.cleanup();
  this.backoff.reset();
  this.readyState = 'closed';
  this.emit('close', reason);

  if (this._reconnection && !this.skipReconnect) {
    this.reconnect();
  }
};

/**
 * Attempt a reconnection.
 *
 * @api private
 */

Manager.prototype.reconnect = function () {
  if (this.reconnecting || this.skipReconnect) return this;

  var self = this;

  if (this.backoff.attempts >= this._reconnectionAttempts) {
    debug('reconnect failed');
    this.backoff.reset();
    this.emitAll('reconnect_failed');
    this.reconnecting = false;
  } else {
    var delay = this.backoff.duration();
    debug('will wait %dms before reconnect attempt', delay);

    this.reconnecting = true;
    var timer = setTimeout(function () {
      if (self.skipReconnect) return;

      debug('attempting reconnect');
      self.emitAll('reconnect_attempt', self.backoff.attempts);
      self.emitAll('reconnecting', self.backoff.attempts);

      // check again for the case socket closed in above events
      if (self.skipReconnect) return;

      self.open(function (err) {
        if (err) {
          debug('reconnect attempt error');
          self.reconnecting = false;
          self.reconnect();
          self.emitAll('reconnect_error', err.data);
        } else {
          debug('reconnect success');
          self.onreconnect();
        }
      });
    }, delay);

    this.subs.push({
      destroy: function () {
        clearTimeout(timer);
      }
    });
  }
};

/**
 * Called upon successful reconnect.
 *
 * @api private
 */

Manager.prototype.onreconnect = function () {
  var attempt = this.backoff.attempts;
  this.reconnecting = false;
  this.backoff.reset();
  this.updateSocketIds();
  this.emitAll('reconnect', attempt);
};


/***/ }),
/* 697 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Module dependencies
 */

var XMLHttpRequest = __webpack_require__(415);
var XHR = __webpack_require__(2627);
var JSONP = __webpack_require__(2635);
var websocket = __webpack_require__(2636);

/**
 * Export transports.
 */

exports.polling = polling;
exports.websocket = websocket;

/**
 * Polling transport polymorphic constructor.
 * Decides on xhr vs jsonp based on feature detection.
 *
 * @api private
 */

function polling (opts) {
  var xhr;
  var xd = false;
  var xs = false;
  var jsonp = false !== opts.jsonp;

  if (typeof location !== 'undefined') {
    var isSSL = 'https:' === location.protocol;
    var port = location.port;

    // some user agents have empty `location.port`
    if (!port) {
      port = isSSL ? 443 : 80;
    }

    xd = opts.hostname !== location.hostname || port !== opts.port;
    xs = opts.secure !== isSSL;
  }

  opts.xdomain = xd;
  opts.xscheme = xs;
  xhr = new XMLHttpRequest(opts);

  if ('open' in xhr && !opts.forceJSONP) {
    return new XHR(opts);
  } else {
    if (!jsonp) throw new Error('JSONP disabled');
    return new JSONP(opts);
  }
}


/***/ }),
/* 698 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Module dependencies.
 */

var Transport = __webpack_require__(416);
var parseqs = __webpack_require__(284);
var parser = __webpack_require__(153);
var inherit = __webpack_require__(285);
var yeast = __webpack_require__(700);
var debug = __webpack_require__(88)('engine.io-client:polling');

/**
 * Module exports.
 */

module.exports = Polling;

/**
 * Is XHR2 supported?
 */

var hasXHR2 = (function () {
  var XMLHttpRequest = __webpack_require__(415);
  var xhr = new XMLHttpRequest({ xdomain: false });
  return null != xhr.responseType;
})();

/**
 * Polling interface.
 *
 * @param {Object} opts
 * @api private
 */

function Polling (opts) {
  var forceBase64 = (opts && opts.forceBase64);
  if (!hasXHR2 || forceBase64) {
    this.supportsBinary = false;
  }
  Transport.call(this, opts);
}

/**
 * Inherits from Transport.
 */

inherit(Polling, Transport);

/**
 * Transport name.
 */

Polling.prototype.name = 'polling';

/**
 * Opens the socket (triggers polling). We write a PING message to determine
 * when the transport is open.
 *
 * @api private
 */

Polling.prototype.doOpen = function () {
  this.poll();
};

/**
 * Pauses polling.
 *
 * @param {Function} callback upon buffers are flushed and transport is paused
 * @api private
 */

Polling.prototype.pause = function (onPause) {
  var self = this;

  this.readyState = 'pausing';

  function pause () {
    debug('paused');
    self.readyState = 'paused';
    onPause();
  }

  if (this.polling || !this.writable) {
    var total = 0;

    if (this.polling) {
      debug('we are currently polling - waiting to pause');
      total++;
      this.once('pollComplete', function () {
        debug('pre-pause polling complete');
        --total || pause();
      });
    }

    if (!this.writable) {
      debug('we are currently writing - waiting to pause');
      total++;
      this.once('drain', function () {
        debug('pre-pause writing complete');
        --total || pause();
      });
    }
  } else {
    pause();
  }
};

/**
 * Starts polling cycle.
 *
 * @api public
 */

Polling.prototype.poll = function () {
  debug('polling');
  this.polling = true;
  this.doPoll();
  this.emit('poll');
};

/**
 * Overloads onData to detect payloads.
 *
 * @api private
 */

Polling.prototype.onData = function (data) {
  var self = this;
  debug('polling got data %s', data);
  var callback = function (packet, index, total) {
    // if its the first message we consider the transport open
    if ('opening' === self.readyState) {
      self.onOpen();
    }

    // if its a close packet, we close the ongoing requests
    if ('close' === packet.type) {
      self.onClose();
      return false;
    }

    // otherwise bypass onData and handle the message
    self.onPacket(packet);
  };

  // decode payload
  parser.decodePayload(data, this.socket.binaryType, callback);

  // if an event did not trigger closing
  if ('closed' !== this.readyState) {
    // if we got data we're not polling
    this.polling = false;
    this.emit('pollComplete');

    if ('open' === this.readyState) {
      this.poll();
    } else {
      debug('ignoring poll - transport state "%s"', this.readyState);
    }
  }
};

/**
 * For polling, send a close packet.
 *
 * @api private
 */

Polling.prototype.doClose = function () {
  var self = this;

  function close () {
    debug('writing close packet');
    self.write([{ type: 'close' }]);
  }

  if ('open' === this.readyState) {
    debug('transport open - closing');
    close();
  } else {
    // in case we're trying to close while
    // handshaking is in progress (GH-164)
    debug('transport not open - deferring close');
    this.once('open', close);
  }
};

/**
 * Writes a packets payload.
 *
 * @param {Array} data packets
 * @param {Function} drain callback
 * @api private
 */

Polling.prototype.write = function (packets) {
  var self = this;
  this.writable = false;
  var callbackfn = function () {
    self.writable = true;
    self.emit('drain');
  };

  parser.encodePayload(packets, this.supportsBinary, function (data) {
    self.doWrite(data, callbackfn);
  });
};

/**
 * Generates uri for connection.
 *
 * @api private
 */

Polling.prototype.uri = function () {
  var query = this.query || {};
  var schema = this.secure ? 'https' : 'http';
  var port = '';

  // cache busting is forced
  if (false !== this.timestampRequests) {
    query[this.timestampParam] = yeast();
  }

  if (!this.supportsBinary && !query.sid) {
    query.b64 = 1;
  }

  query = parseqs.encode(query);

  // avoid port if default for schema
  if (this.port && (('https' === schema && Number(this.port) !== 443) ||
     ('http' === schema && Number(this.port) !== 80))) {
    port = ':' + this.port;
  }

  // prepend ? to query
  if (query.length) {
    query = '?' + query;
  }

  var ipv6 = this.hostname.indexOf(':') !== -1;
  return schema + '://' + (ipv6 ? '[' + this.hostname + ']' : this.hostname) + port + this.path + query;
};


/***/ }),
/* 699 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {/* global Blob File */

/*
 * Module requirements.
 */

var isArray = __webpack_require__(2629);

var toString = Object.prototype.toString;
var withNativeBlob = typeof Blob === 'function' ||
                        typeof Blob !== 'undefined' && toString.call(Blob) === '[object BlobConstructor]';
var withNativeFile = typeof File === 'function' ||
                        typeof File !== 'undefined' && toString.call(File) === '[object FileConstructor]';

/**
 * Module exports.
 */

module.exports = hasBinary;

/**
 * Checks for binary data.
 *
 * Supports Buffer, ArrayBuffer, Blob and File.
 *
 * @param {Object} anything
 * @api public
 */

function hasBinary (obj) {
  if (!obj || typeof obj !== 'object') {
    return false;
  }

  if (isArray(obj)) {
    for (var i = 0, l = obj.length; i < l; i++) {
      if (hasBinary(obj[i])) {
        return true;
      }
    }
    return false;
  }

  if ((typeof Buffer === 'function' && Buffer.isBuffer && Buffer.isBuffer(obj)) ||
    (typeof ArrayBuffer === 'function' && obj instanceof ArrayBuffer) ||
    (withNativeBlob && obj instanceof Blob) ||
    (withNativeFile && obj instanceof File)
  ) {
    return true;
  }

  // see: https://github.com/Automattic/has-binary/pull/4
  if (obj.toJSON && typeof obj.toJSON === 'function' && arguments.length === 1) {
    return hasBinary(obj.toJSON(), true);
  }

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key) && hasBinary(obj[key])) {
      return true;
    }
  }

  return false;
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(123).Buffer))

/***/ }),
/* 700 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var alphabet = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz-_'.split('')
  , length = 64
  , map = {}
  , seed = 0
  , i = 0
  , prev;

/**
 * Return a string representing the specified number.
 *
 * @param {Number} num The number to convert.
 * @returns {String} The string representation of the number.
 * @api public
 */
function encode(num) {
  var encoded = '';

  do {
    encoded = alphabet[num % length] + encoded;
    num = Math.floor(num / length);
  } while (num > 0);

  return encoded;
}

/**
 * Return the integer value specified by the given string.
 *
 * @param {String} str The string to convert.
 * @returns {Number} The integer value represented by the string.
 * @api public
 */
function decode(str) {
  var decoded = 0;

  for (i = 0; i < str.length; i++) {
    decoded = decoded * length + map[str.charAt(i)];
  }

  return decoded;
}

/**
 * Yeast: A tiny growing id generator.
 *
 * @returns {String} A unique id.
 * @api public
 */
function yeast() {
  var now = encode(+new Date());

  if (now !== prev) return seed = 0, prev = now;
  return now +'.'+ encode(seed++);
}

//
// Map each character to its index.
//
for (; i < length; i++) map[alphabet[i]] = i;

//
// Expose the `yeast`, `encode` and `decode` functions.
//
yeast.encode = encode;
yeast.decode = decode;
module.exports = yeast;


/***/ }),
/* 701 */
/***/ (function(module, exports) {


var indexOf = [].indexOf;

module.exports = function(arr, obj){
  if (indexOf) return arr.indexOf(obj);
  for (var i = 0; i < arr.length; ++i) {
    if (arr[i] === obj) return i;
  }
  return -1;
};

/***/ }),
/* 702 */
/***/ (function(module, exports, __webpack_require__) {


/**
 * Module dependencies.
 */

var parser = __webpack_require__(414);
var Emitter = __webpack_require__(152);
var toArray = __webpack_require__(2638);
var on = __webpack_require__(703);
var bind = __webpack_require__(704);
var debug = __webpack_require__(88)('socket.io-client:socket');
var parseqs = __webpack_require__(284);
var hasBin = __webpack_require__(699);

/**
 * Module exports.
 */

module.exports = exports = Socket;

/**
 * Internal events (blacklisted).
 * These events can't be emitted by the user.
 *
 * @api private
 */

var events = {
  connect: 1,
  connect_error: 1,
  connect_timeout: 1,
  connecting: 1,
  disconnect: 1,
  error: 1,
  reconnect: 1,
  reconnect_attempt: 1,
  reconnect_failed: 1,
  reconnect_error: 1,
  reconnecting: 1,
  ping: 1,
  pong: 1
};

/**
 * Shortcut to `Emitter#emit`.
 */

var emit = Emitter.prototype.emit;

/**
 * `Socket` constructor.
 *
 * @api public
 */

function Socket (io, nsp, opts) {
  this.io = io;
  this.nsp = nsp;
  this.json = this; // compat
  this.ids = 0;
  this.acks = {};
  this.receiveBuffer = [];
  this.sendBuffer = [];
  this.connected = false;
  this.disconnected = true;
  this.flags = {};
  if (opts && opts.query) {
    this.query = opts.query;
  }
  if (this.io.autoConnect) this.open();
}

/**
 * Mix in `Emitter`.
 */

Emitter(Socket.prototype);

/**
 * Subscribe to open, close and packet events
 *
 * @api private
 */

Socket.prototype.subEvents = function () {
  if (this.subs) return;

  var io = this.io;
  this.subs = [
    on(io, 'open', bind(this, 'onopen')),
    on(io, 'packet', bind(this, 'onpacket')),
    on(io, 'close', bind(this, 'onclose'))
  ];
};

/**
 * "Opens" the socket.
 *
 * @api public
 */

Socket.prototype.open =
Socket.prototype.connect = function () {
  if (this.connected) return this;

  this.subEvents();
  this.io.open(); // ensure open
  if ('open' === this.io.readyState) this.onopen();
  this.emit('connecting');
  return this;
};

/**
 * Sends a `message` event.
 *
 * @return {Socket} self
 * @api public
 */

Socket.prototype.send = function () {
  var args = toArray(arguments);
  args.unshift('message');
  this.emit.apply(this, args);
  return this;
};

/**
 * Override `emit`.
 * If the event is in `events`, it's emitted normally.
 *
 * @param {String} event name
 * @return {Socket} self
 * @api public
 */

Socket.prototype.emit = function (ev) {
  if (events.hasOwnProperty(ev)) {
    emit.apply(this, arguments);
    return this;
  }

  var args = toArray(arguments);
  var packet = {
    type: (this.flags.binary !== undefined ? this.flags.binary : hasBin(args)) ? parser.BINARY_EVENT : parser.EVENT,
    data: args
  };

  packet.options = {};
  packet.options.compress = !this.flags || false !== this.flags.compress;

  // event ack callback
  if ('function' === typeof args[args.length - 1]) {
    debug('emitting packet with ack id %d', this.ids);
    this.acks[this.ids] = args.pop();
    packet.id = this.ids++;
  }

  if (this.connected) {
    this.packet(packet);
  } else {
    this.sendBuffer.push(packet);
  }

  this.flags = {};

  return this;
};

/**
 * Sends a packet.
 *
 * @param {Object} packet
 * @api private
 */

Socket.prototype.packet = function (packet) {
  packet.nsp = this.nsp;
  this.io.packet(packet);
};

/**
 * Called upon engine `open`.
 *
 * @api private
 */

Socket.prototype.onopen = function () {
  debug('transport is open - connecting');

  // write connect packet if necessary
  if ('/' !== this.nsp) {
    if (this.query) {
      var query = typeof this.query === 'object' ? parseqs.encode(this.query) : this.query;
      debug('sending connect packet with query %s', query);
      this.packet({type: parser.CONNECT, query: query});
    } else {
      this.packet({type: parser.CONNECT});
    }
  }
};

/**
 * Called upon engine `close`.
 *
 * @param {String} reason
 * @api private
 */

Socket.prototype.onclose = function (reason) {
  debug('close (%s)', reason);
  this.connected = false;
  this.disconnected = true;
  delete this.id;
  this.emit('disconnect', reason);
};

/**
 * Called with socket packet.
 *
 * @param {Object} packet
 * @api private
 */

Socket.prototype.onpacket = function (packet) {
  var sameNamespace = packet.nsp === this.nsp;
  var rootNamespaceError = packet.type === parser.ERROR && packet.nsp === '/';

  if (!sameNamespace && !rootNamespaceError) return;

  switch (packet.type) {
    case parser.CONNECT:
      this.onconnect();
      break;

    case parser.EVENT:
      this.onevent(packet);
      break;

    case parser.BINARY_EVENT:
      this.onevent(packet);
      break;

    case parser.ACK:
      this.onack(packet);
      break;

    case parser.BINARY_ACK:
      this.onack(packet);
      break;

    case parser.DISCONNECT:
      this.ondisconnect();
      break;

    case parser.ERROR:
      this.emit('error', packet.data);
      break;
  }
};

/**
 * Called upon a server event.
 *
 * @param {Object} packet
 * @api private
 */

Socket.prototype.onevent = function (packet) {
  var args = packet.data || [];
  debug('emitting event %j', args);

  if (null != packet.id) {
    debug('attaching ack callback to event');
    args.push(this.ack(packet.id));
  }

  if (this.connected) {
    emit.apply(this, args);
  } else {
    this.receiveBuffer.push(args);
  }
};

/**
 * Produces an ack callback to emit with an event.
 *
 * @api private
 */

Socket.prototype.ack = function (id) {
  var self = this;
  var sent = false;
  return function () {
    // prevent double callbacks
    if (sent) return;
    sent = true;
    var args = toArray(arguments);
    debug('sending ack %j', args);

    self.packet({
      type: hasBin(args) ? parser.BINARY_ACK : parser.ACK,
      id: id,
      data: args
    });
  };
};

/**
 * Called upon a server acknowlegement.
 *
 * @param {Object} packet
 * @api private
 */

Socket.prototype.onack = function (packet) {
  var ack = this.acks[packet.id];
  if ('function' === typeof ack) {
    debug('calling ack %s with %j', packet.id, packet.data);
    ack.apply(this, packet.data);
    delete this.acks[packet.id];
  } else {
    debug('bad ack %s', packet.id);
  }
};

/**
 * Called upon server connect.
 *
 * @api private
 */

Socket.prototype.onconnect = function () {
  this.connected = true;
  this.disconnected = false;
  this.emit('connect');
  this.emitBuffered();
};

/**
 * Emit buffered events (received and emitted).
 *
 * @api private
 */

Socket.prototype.emitBuffered = function () {
  var i;
  for (i = 0; i < this.receiveBuffer.length; i++) {
    emit.apply(this, this.receiveBuffer[i]);
  }
  this.receiveBuffer = [];

  for (i = 0; i < this.sendBuffer.length; i++) {
    this.packet(this.sendBuffer[i]);
  }
  this.sendBuffer = [];
};

/**
 * Called upon server disconnect.
 *
 * @api private
 */

Socket.prototype.ondisconnect = function () {
  debug('server disconnect (%s)', this.nsp);
  this.destroy();
  this.onclose('io server disconnect');
};

/**
 * Called upon forced client/server side disconnections,
 * this method ensures the manager stops tracking us and
 * that reconnections don't get triggered for this.
 *
 * @api private.
 */

Socket.prototype.destroy = function () {
  if (this.subs) {
    // clean subscriptions to avoid reconnections
    for (var i = 0; i < this.subs.length; i++) {
      this.subs[i].destroy();
    }
    this.subs = null;
  }

  this.io.destroy(this);
};

/**
 * Disconnects the socket manually.
 *
 * @return {Socket} self
 * @api public
 */

Socket.prototype.close =
Socket.prototype.disconnect = function () {
  if (this.connected) {
    debug('performing disconnect (%s)', this.nsp);
    this.packet({ type: parser.DISCONNECT });
  }

  // remove socket from pool
  this.destroy();

  if (this.connected) {
    // fire events
    this.onclose('io client disconnect');
  }
  return this;
};

/**
 * Sets the compress flag.
 *
 * @param {Boolean} if `true`, compresses the sending data
 * @return {Socket} self
 * @api public
 */

Socket.prototype.compress = function (compress) {
  this.flags.compress = compress;
  return this;
};

/**
 * Sets the binary flag
 *
 * @param {Boolean} whether the emitted data contains binary
 * @return {Socket} self
 * @api public
 */

Socket.prototype.binary = function (binary) {
  this.flags.binary = binary;
  return this;
};


/***/ }),
/* 703 */
/***/ (function(module, exports) {


/**
 * Module exports.
 */

module.exports = on;

/**
 * Helper for subscriptions.
 *
 * @param {Object|EventEmitter} obj with `Emitter` mixin or `EventEmitter`
 * @param {String} event name
 * @param {Function} callback
 * @api public
 */

function on (obj, ev, fn) {
  obj.on(ev, fn);
  return {
    destroy: function () {
      obj.removeListener(ev, fn);
    }
  };
}


/***/ }),
/* 704 */
/***/ (function(module, exports) {

/**
 * Slice reference.
 */

var slice = [].slice;

/**
 * Bind `obj` to `fn`.
 *
 * @param {Object} obj
 * @param {Function|String} fn or string
 * @return {Function}
 * @api public
 */

module.exports = function(obj, fn){
  if ('string' == typeof fn) fn = obj[fn];
  if ('function' != typeof fn) throw new Error('bind() requires a function');
  var args = slice.call(arguments, 2);
  return function(){
    return fn.apply(obj, args.concat(slice.call(arguments)));
  }
};


/***/ }),
/* 705 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_core__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_Wrappers_materialUIWrappers_components_AutofillV3__ = __webpack_require__(620);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_Wrappers_materialUIWrappers_components_FormInput__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_helpers_UserHelper__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_queries_assistant_queries__ = __webpack_require__(2640);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_queries_clients_queries__ = __webpack_require__(417);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_queries_todo_mutations__ = __webpack_require__(706);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_apollo__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_reducers_NotificationReducer__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_redux__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_redux_form__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_store__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_components_Wrappers_materialUIWrappers_components_DayMonthYear__ = __webpack_require__(2641);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_helpers_ValidationHelpers__ = __webpack_require__(27);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var max25=function max25(value){return!value?undefined:value.length<26?undefined:'Max 25 characters';};var max120=function max120(value){return!value?undefined:value.length<121?undefined:'Max 55 characters';};var charMin3=function charMin3(value){return Object(__WEBPACK_IMPORTED_MODULE_15_helpers_ValidationHelpers__["c" /* isEmptyOrSpaces */])(value)?undefined:value.length>2?undefined:'Must be at least 3 characters';};var initialState={checkValidation:false,client_id:null,client_fullname:'',assigned_userId:null,assigned_user_fullname:'',editMode:false,loadingSubmit:false};var TodoDialog=function(_React$Component){_inherits(TodoDialog,_React$Component);function TodoDialog(){var _ref;var _temp,_this,_ret;_classCallCheck(this,TodoDialog);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=TodoDialog.__proto__||Object.getPrototypeOf(TodoDialog)).call.apply(_ref,[this].concat(args))),_this),_this.state=Object.assign({},initialState),_this.resetState=function(){_this.setState({initialState:initialState});},_this.clientSearchTextChanged=function(event,refetch){if(event&&event.target){_this.setState({client_fullname:event.target.value,client_id:null});refetch();}},_this.clientSelected=function(displayText,id,refetch){_this.setState({client_id:parseInt(atob(id).split(':')[1],10),client_fullname:displayText});refetch();},_this.assistantSearchTextChanged=function(event,refetch){if(event&&event.target){_this.setState({assigned_user_fullname:event.target.value,assigned_userId:null});refetch();}},_this.assistantSelected=function(displayText,id,refetch){_this.setState({assigned_userId:parseInt(id,10),assigned_user_fullname:displayText});refetch();},_this.onSubmit=function(){if(__WEBPACK_IMPORTED_MODULE_13_store__["a" /* default */].getState().form.todo.syncErrors){__WEBPACK_IMPORTED_MODULE_13_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_10_reducers_NotificationReducer__["d" /* showSnack */])({message:'Invalid Information',color:'danger'}));return;}_this.setState({loadingSubmit:true});var todo=__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(__WEBPACK_IMPORTED_MODULE_13_store__["a" /* default */].getState().form.todo,'values');var input={userId:Object(__WEBPACK_IMPORTED_MODULE_3_helpers_UserHelper__["a" /* GetUserId */])(),token:Object(__WEBPACK_IMPORTED_MODULE_3_helpers_UserHelper__["c" /* GetUserToken */])(),title:todo.title,desc:todo.desc,assistantId:_this.state.assigned_userId,clientId:_this.state.client_id,todoId:_this.state.editMode&&_this.props.todo.id?_this.props.todo.id:null,dueDate:todo.due_date};_this.props.Todo({variables:{input:input}}).then(function(resp){if(_this.state.editMode&&_this.props.todo.id){_this.props.todoEdited(resp.data.Todo);}else{_this.props.todoAdded(resp.data.Todo);}_this.props.closeDialog();_this.setState({loadingSubmit:false});__WEBPACK_IMPORTED_MODULE_13_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_10_reducers_NotificationReducer__["d" /* showSnack */])({message:_this.state.editMode&&_this.props.todo.id?'Todo Updated':'Todo Added',color:'success'}));}).catch(function(error){_this.setState({loadingSubmit:false});console.log('err',error);});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(TodoDialog,[{key:'componentDidMount',value:function componentDidMount(){if(this.props.todo&&(this.props.todo.id||this.props.todo.client_id)){this.props.initialize(Object.assign({},this.props.todo));this.setState(Object.assign({},this.props.todo,{editMode:true}));}}},{key:'componentWillUnmount',value:function componentWillUnmount(){this.resetState();}},{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["k" /* Dialog */],{open:this.props.open,onClose:this.props.closeDialog,className:'centerFixedDialog'},this.state.loadingSubmit?null:__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["o" /* DialogTitle */],{id:'form-dialog-title',style:{textAlign:'center'}},this.state.editMode?'Edit':'Add',' To Do'),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["m" /* DialogContent */],null,this.state.loadingSubmit?__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('div',{style:{textAlign:'center'}},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{marginBottom:'15px'}},'Saving...'),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["j" /* CircularProgress */],{size:25})):__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{container:true},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{item:true,xs:12,sm:12,style:{marginTop:'20px'}},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["t" /* FormControl */],{fullWidth:true},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_2_components_Wrappers_materialUIWrappers_components_FormInput__["a" /* default */],name:'title',label:'Title',isrequired:true,validate:[__WEBPACK_IMPORTED_MODULE_15_helpers_ValidationHelpers__["g" /* required */],max25],checkValidation:this.state.checkValidation}))),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{item:true,xs:12,sm:12,style:{marginTop:'20px'}},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["t" /* FormControl */],{fullWidth:true},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_2_components_Wrappers_materialUIWrappers_components_FormInput__["a" /* default */],name:'desc',label:'Description',isrequired:true,validate:[max120],checkValidation:this.state.checkValidation}))),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{item:true,xs:12,sm:12,style:{marginTop:'20px'}},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["t" /* FormControl */],{fullWidth:true},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_14_components_Wrappers_materialUIWrappers_components_DayMonthYear__["a" /* default */],name:'due_date',label:'Due Date',placeholder:'DD/MM/YYYY',checkValidation:this.state.checkValidation,validate:[__WEBPACK_IMPORTED_MODULE_15_helpers_ValidationHelpers__["a" /* dateValid */]]}))),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{item:true,xs:12,sm:12,style:{marginTop:'20px'}},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_apollo__["Query"],{query:__WEBPACK_IMPORTED_MODULE_5_queries_assistant_queries__["a" /* AssistantsSearch */],variables:{brokerId:Object(__WEBPACK_IMPORTED_MODULE_3_helpers_UserHelper__["a" /* GetUserId */])(),search:this.state.assigned_user_fullname.length>2?this.state.assigned_user_fullname:''},fetchPolicy:'network-only'},function(_ref2){var loading=_ref2.loading,error=_ref2.error,data=_ref2.data,refetch=_ref2.refetch;return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_redux_form__["a" /* Field */],{label:'Assign To (Optional)',name:'assigned_user_fullname',component:__WEBPACK_IMPORTED_MODULE_1_components_Wrappers_materialUIWrappers_components_AutofillV3__["a" /* default */],validate:[charMin3],onItemSelect:function onItemSelect(displayText,id){return _this2.assistantSelected(displayText,id,refetch);}//textChanged={() => this.props.toggleOccupationValid(false)}
,autoFillList:!loading&&data.AssistantsSearch?data.AssistantsSearch:[],loading:loading,listName:'Assistants',zIndex:1000,displayText:'full_name',subText:'email',onChange:function onChange(e){return _this2.assistantSearchTextChanged(e,refetch);}});})),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{item:true,xs:12,sm:12,style:{marginTop:'20px'}},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_apollo__["Query"],{query:__WEBPACK_IMPORTED_MODULE_6_queries_clients_queries__["c" /* ClientsSearch */],variables:{brokerId:Object(__WEBPACK_IMPORTED_MODULE_3_helpers_UserHelper__["a" /* GetUserId */])(),token:Object(__WEBPACK_IMPORTED_MODULE_3_helpers_UserHelper__["c" /* GetUserToken */])(),search:this.state.client_fullname.length>2?this.state.client_fullname:''},fetchPolicy:'network-only'},function(_ref3){var loading=_ref3.loading,error=_ref3.error,data=_ref3.data,refetch=_ref3.refetch;return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_redux_form__["a" /* Field */],{label:'Client (Optional)',name:'client_fullname',component:__WEBPACK_IMPORTED_MODULE_1_components_Wrappers_materialUIWrappers_components_AutofillV3__["a" /* default */],validate:[charMin3],onItemSelect:function onItemSelect(displayText,id){return _this2.clientSelected(displayText,id,refetch);}//textChanged={() => this.props.toggleOccupationValid(false)}
,autoFillList:!loading&&data.ClientsSearch?data.ClientsSearch:[],loading:loading,listName:'Clients',zIndex:1000,displayText:'full_name',subText:'scd_email',onChange:function onChange(e){return _this2.clientSearchTextChanged(e,refetch);}});})),this.state.loading?__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{item:true,xs:12,sm:12,style:{textAlign:'center',margin:'40px 0px 0px'}},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["j" /* CircularProgress */],{color:'secondary',size:30})):null)),this.state.loadingSubmit?null:__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["l" /* DialogActions */],null,__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["d" /* Button */],{color:'primary',onClick:this.props.closeDialog},'Cancel'),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["d" /* Button */],{color:'primary',onClick:this.onSubmit},this.state.editMode?'Save':'Add')));}}]);return TodoDialog;}(__WEBPACK_IMPORTED_MODULE_8_react___default.a.Component);TodoDialog=Object(__WEBPACK_IMPORTED_MODULE_12_redux_form__["e" /* reduxForm */])({form:'todo',destroyOnUnmount:true})(TodoDialog);TodoDialog=Object(__WEBPACK_IMPORTED_MODULE_11_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_9_react_apollo__["graphql"])(__WEBPACK_IMPORTED_MODULE_7_queries_todo_mutations__["b" /* Todo */],{name:'Todo'}))(TodoDialog);/* harmony default export */ __webpack_exports__["a"] = (TodoDialog);

/***/ }),
/* 706 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Todo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DeleteTodo; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_graphql_tag__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_graphql_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_graphql_tag__);
var _templateObject=_taggedTemplateLiteral(["\n  mutation todo($input: TodoInput!) {\n    Todo(input: $input) {\n      id\n      title\n      desc\n      done\n      date_created\n      assigned_userId\n      assigned_user_fullname\n      client_id\n      client_fullname\n      todo_assigned_done\n    }\n  }\n"],["\n  mutation todo($input: TodoInput!) {\n    Todo(input: $input) {\n      id\n      title\n      desc\n      done\n      date_created\n      assigned_userId\n      assigned_user_fullname\n      client_id\n      client_fullname\n      todo_assigned_done\n    }\n  }\n"]),_templateObject2=_taggedTemplateLiteral(["\n  mutation deleteTodo($input: DeleteTodoInput!) {\n    DeleteTodo(input: $input) {\n      id\n    }\n  }\n"],["\n  mutation deleteTodo($input: DeleteTodoInput!) {\n    DeleteTodo(input: $input) {\n      id\n    }\n  }\n"]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Todo=__WEBPACK_IMPORTED_MODULE_0_graphql_tag___default()(_templateObject);var DeleteTodo=__WEBPACK_IMPORTED_MODULE_0_graphql_tag___default()(_templateObject2);

/***/ }),
/* 707 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core__ = __webpack_require__(4);
function isEmptyOrSpaces(str){return str===undefined||str===null||str.toString().match(/^ *$/)!==null;}var todoCard=function todoCard(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["e" /* Card */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["v" /* Grid */],{container:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["v" /* Grid */],{item:true,xs:9,sm:9,md:10,style:{borderRight:'1px solid #cccccc69'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["f" /* CardContent */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["Z" /* Typography */],{variant:'subheading'},props.title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{borderBottom:'1px solid #cccccc69',margin:'5px auto',width:'100%'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["Z" /* Typography */],{variant:'body2',className:'todoDesc'},props.desc),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{borderBottom:'1px solid #cccccc69',margin:'5px auto',width:'100%'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["Z" /* Typography */],{variant:'caption'},'Created: ',props.date_created),props.due_date?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["Z" /* Typography */],{variant:'caption'},'Due: ',props.due_date):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{display:'flex',marginTop:'15px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["Z" /* Typography */],{variant:'caption'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Assigned To:'),' '),!isEmptyOrSpaces(props.assigned_user_fullname)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["Z" /* Typography */],{variant:'caption',style:{marginLeft:'10px'}},props.assigned_user_fullname),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["Y" /* Tooltip */],{title:props.todo_assigned_done?'Completed by Assignee':'Not yet completed by Assignee'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["w" /* Icon */],{fontSize:'small',style:{color:props.todo_assigned_done?'green':'#ff721f',marginLeft:'10px',position:'relative',bottom:'5px'}},'check_circle_outline'))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["Z" /* Typography */],{variant:'caption',style:{marginLeft:'10px'}},'None')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["Z" /* Typography */],{variant:'caption'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Client:'),' ',!isEmptyOrSpaces(props.client_fullname)?props.client_fullname:'None'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["v" /* Grid */],{item:true,xs:3,sm:3,md:2,style:{textAlign:'center'}},props.loadingAction?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{marginTop:'10px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["j" /* CircularProgress */],{size:20})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["v" /* Grid */],{container:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["v" /* Grid */],{item:true,xs:12,sm:12,md:12,style:{marginTop:'10px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["Y" /* Tooltip */],{title:props.done?"Move back to Current Todo's":'Mark as done'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["d" /* Button */],{variant:'fab',mini:true,color:'secondary','aria-label':'Edit',className:'semiSmallFab',onClick:props.doneToggle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["w" /* Icon */],{style:{color:'white'}},props.done?'add':'check')))),props.done?null:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["v" /* Grid */],{item:true,xs:12,sm:12,md:12,style:{marginTop:'10px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["Y" /* Tooltip */],{title:'Click to edit'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["d" /* Button */],{variant:'fab',mini:true,color:'primary','aria-label':'Edit',className:'semiSmallFab',onClick:props.handleEdit},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["w" /* Icon */],{style:{color:'white'}},'create')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["v" /* Grid */],{item:true,xs:12,sm:12,md:12,style:{marginTop:'10px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["Y" /* Tooltip */],{title:'Delete'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["d" /* Button */],{variant:'fab',mini:true,style:{backgroundColor:'#ff721f'},'aria-label':'Delete',className:'semiSmallFab',onClick:props.handleDelete},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["w" /* Icon */],{style:{color:'white'}},'delete_outline'))))))));};/* harmony default export */ __webpack_exports__["a"] = (todoCard);

/***/ }),
/* 708 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = calculateDrivingHours;
function calculateDrivingHours(travel){var pTravel=parseFloat(travel);if(pTravel<=1)return"0";var drivingHours=pTravel>=hoursMap[hoursMap.length-1].lower?hoursMap[hoursMap.length-1]:hoursMap.filter(function(t){return pTravel<=t.upper&&pTravel>=t.lower;})[0];return drivingHours.value;}var hoursMap=[{lower:1,upper:19,value:"15"},{lower:20,upper:38,value:"25"},{lower:39,upper:56,value:"35"},{lower:57,upper:75,value:"45"},{lower:76,value:"100"}];

/***/ }),
/* 709 */
/***/ (function(module, exports, __webpack_require__) {

var addMilliseconds = __webpack_require__(206)

var MILLISECONDS_IN_HOUR = 3600000

/**
 * @category Hour Helpers
 * @summary Add the specified number of hours to the given date.
 *
 * @description
 * Add the specified number of hours to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of hours to be added
 * @returns {Date} the new date with the hours added
 *
 * @example
 * // Add 2 hours to 10 July 2014 23:00:00:
 * var result = addHours(new Date(2014, 6, 10, 23, 0), 2)
 * //=> Fri Jul 11 2014 01:00:00
 */
function addHours (dirtyDate, dirtyAmount) {
  var amount = Number(dirtyAmount)
  return addMilliseconds(dirtyDate, amount * MILLISECONDS_IN_HOUR)
}

module.exports = addHours


/***/ }),
/* 710 */
/***/ (function(module, exports, __webpack_require__) {

var getISOYear = __webpack_require__(114)
var setISOYear = __webpack_require__(711)

/**
 * @category ISO Week-Numbering Year Helpers
 * @summary Add the specified number of ISO week-numbering years to the given date.
 *
 * @description
 * Add the specified number of ISO week-numbering years to the given date.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of ISO week-numbering years to be added
 * @returns {Date} the new date with the ISO week-numbering years added
 *
 * @example
 * // Add 5 ISO week-numbering years to 2 July 2010:
 * var result = addISOYears(new Date(2010, 6, 2), 5)
 * //=> Fri Jun 26 2015 00:00:00
 */
function addISOYears (dirtyDate, dirtyAmount) {
  var amount = Number(dirtyAmount)
  return setISOYear(dirtyDate, getISOYear(dirtyDate) + amount)
}

module.exports = addISOYears


/***/ }),
/* 711 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(9)
var startOfISOYear = __webpack_require__(192)
var differenceInCalendarDays = __webpack_require__(261)

/**
 * @category ISO Week-Numbering Year Helpers
 * @summary Set the ISO week-numbering year to the given date.
 *
 * @description
 * Set the ISO week-numbering year to the given date,
 * saving the week number and the weekday number.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} isoYear - the ISO week-numbering year of the new date
 * @returns {Date} the new date with the ISO week-numbering year setted
 *
 * @example
 * // Set ISO week-numbering year 2007 to 29 December 2008:
 * var result = setISOYear(new Date(2008, 11, 29), 2007)
 * //=> Mon Jan 01 2007 00:00:00
 */
function setISOYear (dirtyDate, dirtyISOYear) {
  var date = parse(dirtyDate)
  var isoYear = Number(dirtyISOYear)
  var diff = differenceInCalendarDays(date, startOfISOYear(date))
  var fourthOfJanuary = new Date(0)
  fourthOfJanuary.setFullYear(isoYear, 0, 4)
  fourthOfJanuary.setHours(0, 0, 0, 0)
  date = startOfISOYear(fourthOfJanuary)
  date.setDate(date.getDate() + diff)
  return date
}

module.exports = setISOYear


/***/ }),
/* 712 */
/***/ (function(module, exports, __webpack_require__) {

var addMilliseconds = __webpack_require__(206)

var MILLISECONDS_IN_MINUTE = 60000

/**
 * @category Minute Helpers
 * @summary Add the specified number of minutes to the given date.
 *
 * @description
 * Add the specified number of minutes to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of minutes to be added
 * @returns {Date} the new date with the minutes added
 *
 * @example
 * // Add 30 minutes to 10 July 2014 12:00:00:
 * var result = addMinutes(new Date(2014, 6, 10, 12, 0), 30)
 * //=> Thu Jul 10 2014 12:30:00
 */
function addMinutes (dirtyDate, dirtyAmount) {
  var amount = Number(dirtyAmount)
  return addMilliseconds(dirtyDate, amount * MILLISECONDS_IN_MINUTE)
}

module.exports = addMinutes


/***/ }),
/* 713 */
/***/ (function(module, exports, __webpack_require__) {

var addMonths = __webpack_require__(286)

/**
 * @category Quarter Helpers
 * @summary Add the specified number of year quarters to the given date.
 *
 * @description
 * Add the specified number of year quarters to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of quarters to be added
 * @returns {Date} the new date with the quarters added
 *
 * @example
 * // Add 1 quarter to 1 September 2014:
 * var result = addQuarters(new Date(2014, 8, 1), 1)
 * //=> Mon Dec 01 2014 00:00:00
 */
function addQuarters (dirtyDate, dirtyAmount) {
  var amount = Number(dirtyAmount)
  var months = amount * 3
  return addMonths(dirtyDate, months)
}

module.exports = addQuarters


/***/ }),
/* 714 */
/***/ (function(module, exports, __webpack_require__) {

var addMilliseconds = __webpack_require__(206)

/**
 * @category Second Helpers
 * @summary Add the specified number of seconds to the given date.
 *
 * @description
 * Add the specified number of seconds to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of seconds to be added
 * @returns {Date} the new date with the seconds added
 *
 * @example
 * // Add 30 seconds to 10 July 2014 12:45:00:
 * var result = addSeconds(new Date(2014, 6, 10, 12, 45, 0), 30)
 * //=> Thu Jul 10 2014 12:45:30
 */
function addSeconds (dirtyDate, dirtyAmount) {
  var amount = Number(dirtyAmount)
  return addMilliseconds(dirtyDate, amount * 1000)
}

module.exports = addSeconds


/***/ }),
/* 715 */
/***/ (function(module, exports, __webpack_require__) {

var addMonths = __webpack_require__(286)

/**
 * @category Year Helpers
 * @summary Add the specified number of years to the given date.
 *
 * @description
 * Add the specified number of years to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of years to be added
 * @returns {Date} the new date with the years added
 *
 * @example
 * // Add 5 years to 1 September 2014:
 * var result = addYears(new Date(2014, 8, 1), 5)
 * //=> Sun Sep 01 2019 00:00:00
 */
function addYears (dirtyDate, dirtyAmount) {
  var amount = Number(dirtyAmount)
  return addMonths(dirtyDate, amount * 12)
}

module.exports = addYears


/***/ }),
/* 716 */
/***/ (function(module, exports, __webpack_require__) {

var getISOYear = __webpack_require__(114)

/**
 * @category ISO Week-Numbering Year Helpers
 * @summary Get the number of calendar ISO week-numbering years between the given dates.
 *
 * @description
 * Get the number of calendar ISO week-numbering years between the given dates.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @returns {Number} the number of calendar ISO week-numbering years
 *
 * @example
 * // How many calendar ISO week-numbering years are 1 January 2010 and 1 January 2012?
 * var result = differenceInCalendarISOYears(
 *   new Date(2012, 0, 1),
 *   new Date(2010, 0, 1)
 * )
 * //=> 2
 */
function differenceInCalendarISOYears (dirtyDateLeft, dirtyDateRight) {
  return getISOYear(dirtyDateLeft) - getISOYear(dirtyDateRight)
}

module.exports = differenceInCalendarISOYears


/***/ }),
/* 717 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(9)

/**
 * @category Month Helpers
 * @summary Get the number of calendar months between the given dates.
 *
 * @description
 * Get the number of calendar months between the given dates.
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @returns {Number} the number of calendar months
 *
 * @example
 * // How many calendar months are between 31 January 2014 and 1 September 2014?
 * var result = differenceInCalendarMonths(
 *   new Date(2014, 8, 1),
 *   new Date(2014, 0, 31)
 * )
 * //=> 8
 */
function differenceInCalendarMonths (dirtyDateLeft, dirtyDateRight) {
  var dateLeft = parse(dirtyDateLeft)
  var dateRight = parse(dirtyDateRight)

  var yearDiff = dateLeft.getFullYear() - dateRight.getFullYear()
  var monthDiff = dateLeft.getMonth() - dateRight.getMonth()

  return yearDiff * 12 + monthDiff
}

module.exports = differenceInCalendarMonths


/***/ }),
/* 718 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(9)

/**
 * @category Quarter Helpers
 * @summary Get the year quarter of the given date.
 *
 * @description
 * Get the year quarter of the given date.
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the quarter
 *
 * @example
 * // Which quarter is 2 July 2014?
 * var result = getQuarter(new Date(2014, 6, 2))
 * //=> 3
 */
function getQuarter (dirtyDate) {
  var date = parse(dirtyDate)
  var quarter = Math.floor(date.getMonth() / 3) + 1
  return quarter
}

module.exports = getQuarter


/***/ }),
/* 719 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(9)

/**
 * @category Year Helpers
 * @summary Get the number of calendar years between the given dates.
 *
 * @description
 * Get the number of calendar years between the given dates.
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @returns {Number} the number of calendar years
 *
 * @example
 * // How many calendar years are between 31 December 2013 and 11 February 2015?
 * var result = differenceInCalendarYears(
 *   new Date(2015, 1, 11),
 *   new Date(2013, 11, 31)
 * )
 * //=> 2
 */
function differenceInCalendarYears (dirtyDateLeft, dirtyDateRight) {
  var dateLeft = parse(dirtyDateLeft)
  var dateRight = parse(dirtyDateRight)

  return dateLeft.getFullYear() - dateRight.getFullYear()
}

module.exports = differenceInCalendarYears


/***/ }),
/* 720 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(9)
var differenceInCalendarDays = __webpack_require__(261)
var compareAsc = __webpack_require__(207)

/**
 * @category Day Helpers
 * @summary Get the number of full days between the given dates.
 *
 * @description
 * Get the number of full days between the given dates.
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @returns {Number} the number of full days
 *
 * @example
 * // How many full days are between
 * // 2 July 2011 23:00:00 and 2 July 2012 00:00:00?
 * var result = differenceInDays(
 *   new Date(2012, 6, 2, 0, 0),
 *   new Date(2011, 6, 2, 23, 0)
 * )
 * //=> 365
 */
function differenceInDays (dirtyDateLeft, dirtyDateRight) {
  var dateLeft = parse(dirtyDateLeft)
  var dateRight = parse(dirtyDateRight)

  var sign = compareAsc(dateLeft, dateRight)
  var difference = Math.abs(differenceInCalendarDays(dateLeft, dateRight))
  dateLeft.setDate(dateLeft.getDate() - sign * difference)

  // Math.abs(diff in full days - diff in calendar days) === 1 if last calendar day is not full
  // If so, result must be decreased by 1 in absolute value
  var isLastDayNotFull = compareAsc(dateLeft, dateRight) === -sign
  return sign * (difference - isLastDayNotFull)
}

module.exports = differenceInDays


/***/ }),
/* 721 */
/***/ (function(module, exports, __webpack_require__) {

var addISOYears = __webpack_require__(710)

/**
 * @category ISO Week-Numbering Year Helpers
 * @summary Subtract the specified number of ISO week-numbering years from the given date.
 *
 * @description
 * Subtract the specified number of ISO week-numbering years from the given date.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of ISO week-numbering years to be subtracted
 * @returns {Date} the new date with the ISO week-numbering years subtracted
 *
 * @example
 * // Subtract 5 ISO week-numbering years from 1 September 2014:
 * var result = subISOYears(new Date(2014, 8, 1), 5)
 * //=> Mon Aug 31 2009 00:00:00
 */
function subISOYears (dirtyDate, dirtyAmount) {
  var amount = Number(dirtyAmount)
  return addISOYears(dirtyDate, -amount)
}

module.exports = subISOYears


/***/ }),
/* 722 */
/***/ (function(module, exports, __webpack_require__) {

var compareDesc = __webpack_require__(420)
var parse = __webpack_require__(9)
var differenceInSeconds = __webpack_require__(422)
var differenceInMonths = __webpack_require__(421)
var enLocale = __webpack_require__(387)

var MINUTES_IN_DAY = 1440
var MINUTES_IN_ALMOST_TWO_DAYS = 2520
var MINUTES_IN_MONTH = 43200
var MINUTES_IN_TWO_MONTHS = 86400

/**
 * @category Common Helpers
 * @summary Return the distance between the given dates in words.
 *
 * @description
 * Return the distance between the given dates in words.
 *
 * | Distance between dates                                            | Result              |
 * |-------------------------------------------------------------------|---------------------|
 * | 0 ... 30 secs                                                     | less than a minute  |
 * | 30 secs ... 1 min 30 secs                                         | 1 minute            |
 * | 1 min 30 secs ... 44 mins 30 secs                                 | [2..44] minutes     |
 * | 44 mins ... 30 secs ... 89 mins 30 secs                           | about 1 hour        |
 * | 89 mins 30 secs ... 23 hrs 59 mins 30 secs                        | about [2..24] hours |
 * | 23 hrs 59 mins 30 secs ... 41 hrs 59 mins 30 secs                 | 1 day               |
 * | 41 hrs 59 mins 30 secs ... 29 days 23 hrs 59 mins 30 secs         | [2..30] days        |
 * | 29 days 23 hrs 59 mins 30 secs ... 44 days 23 hrs 59 mins 30 secs | about 1 month       |
 * | 44 days 23 hrs 59 mins 30 secs ... 59 days 23 hrs 59 mins 30 secs | about 2 months      |
 * | 59 days 23 hrs 59 mins 30 secs ... 1 yr                           | [2..12] months      |
 * | 1 yr ... 1 yr 3 months                                            | about 1 year        |
 * | 1 yr 3 months ... 1 yr 9 month s                                  | over 1 year         |
 * | 1 yr 9 months ... 2 yrs                                           | almost 2 years      |
 * | N yrs ... N yrs 3 months                                          | about N years       |
 * | N yrs 3 months ... N yrs 9 months                                 | over N years        |
 * | N yrs 9 months ... N+1 yrs                                        | almost N+1 years    |
 *
 * With `options.includeSeconds == true`:
 * | Distance between dates | Result               |
 * |------------------------|----------------------|
 * | 0 secs ... 5 secs      | less than 5 seconds  |
 * | 5 secs ... 10 secs     | less than 10 seconds |
 * | 10 secs ... 20 secs    | less than 20 seconds |
 * | 20 secs ... 40 secs    | half a minute        |
 * | 40 secs ... 60 secs    | less than a minute   |
 * | 60 secs ... 90 secs    | 1 minute             |
 *
 * @param {Date|String|Number} dateToCompare - the date to compare with
 * @param {Date|String|Number} date - the other date
 * @param {Object} [options] - the object with options
 * @param {Boolean} [options.includeSeconds=false] - distances less than a minute are more detailed
 * @param {Boolean} [options.addSuffix=false] - result indicates if the second date is earlier or later than the first
 * @param {Object} [options.locale=enLocale] - the locale object
 * @returns {String} the distance in words
 *
 * @example
 * // What is the distance between 2 July 2014 and 1 January 2015?
 * var result = distanceInWords(
 *   new Date(2014, 6, 2),
 *   new Date(2015, 0, 1)
 * )
 * //=> '6 months'
 *
 * @example
 * // What is the distance between 1 January 2015 00:00:15
 * // and 1 January 2015 00:00:00, including seconds?
 * var result = distanceInWords(
 *   new Date(2015, 0, 1, 0, 0, 15),
 *   new Date(2015, 0, 1, 0, 0, 0),
 *   {includeSeconds: true}
 * )
 * //=> 'less than 20 seconds'
 *
 * @example
 * // What is the distance from 1 January 2016
 * // to 1 January 2015, with a suffix?
 * var result = distanceInWords(
 *   new Date(2016, 0, 1),
 *   new Date(2015, 0, 1),
 *   {addSuffix: true}
 * )
 * //=> 'about 1 year ago'
 *
 * @example
 * // What is the distance between 1 August 2016 and 1 January 2015 in Esperanto?
 * var eoLocale = require('date-fns/locale/eo')
 * var result = distanceInWords(
 *   new Date(2016, 7, 1),
 *   new Date(2015, 0, 1),
 *   {locale: eoLocale}
 * )
 * //=> 'pli ol 1 jaro'
 */
function distanceInWords (dirtyDateToCompare, dirtyDate, dirtyOptions) {
  var options = dirtyOptions || {}

  var comparison = compareDesc(dirtyDateToCompare, dirtyDate)

  var locale = options.locale
  var localize = enLocale.distanceInWords.localize
  if (locale && locale.distanceInWords && locale.distanceInWords.localize) {
    localize = locale.distanceInWords.localize
  }

  var localizeOptions = {
    addSuffix: Boolean(options.addSuffix),
    comparison: comparison
  }

  var dateLeft, dateRight
  if (comparison > 0) {
    dateLeft = parse(dirtyDateToCompare)
    dateRight = parse(dirtyDate)
  } else {
    dateLeft = parse(dirtyDate)
    dateRight = parse(dirtyDateToCompare)
  }

  var seconds = differenceInSeconds(dateRight, dateLeft)
  var offset = dateRight.getTimezoneOffset() - dateLeft.getTimezoneOffset()
  var minutes = Math.round(seconds / 60) - offset
  var months

  // 0 up to 2 mins
  if (minutes < 2) {
    if (options.includeSeconds) {
      if (seconds < 5) {
        return localize('lessThanXSeconds', 5, localizeOptions)
      } else if (seconds < 10) {
        return localize('lessThanXSeconds', 10, localizeOptions)
      } else if (seconds < 20) {
        return localize('lessThanXSeconds', 20, localizeOptions)
      } else if (seconds < 40) {
        return localize('halfAMinute', null, localizeOptions)
      } else if (seconds < 60) {
        return localize('lessThanXMinutes', 1, localizeOptions)
      } else {
        return localize('xMinutes', 1, localizeOptions)
      }
    } else {
      if (minutes === 0) {
        return localize('lessThanXMinutes', 1, localizeOptions)
      } else {
        return localize('xMinutes', minutes, localizeOptions)
      }
    }

  // 2 mins up to 0.75 hrs
  } else if (minutes < 45) {
    return localize('xMinutes', minutes, localizeOptions)

  // 0.75 hrs up to 1.5 hrs
  } else if (minutes < 90) {
    return localize('aboutXHours', 1, localizeOptions)

  // 1.5 hrs up to 24 hrs
  } else if (minutes < MINUTES_IN_DAY) {
    var hours = Math.round(minutes / 60)
    return localize('aboutXHours', hours, localizeOptions)

  // 1 day up to 1.75 days
  } else if (minutes < MINUTES_IN_ALMOST_TWO_DAYS) {
    return localize('xDays', 1, localizeOptions)

  // 1.75 days up to 30 days
  } else if (minutes < MINUTES_IN_MONTH) {
    var days = Math.round(minutes / MINUTES_IN_DAY)
    return localize('xDays', days, localizeOptions)

  // 1 month up to 2 months
  } else if (minutes < MINUTES_IN_TWO_MONTHS) {
    months = Math.round(minutes / MINUTES_IN_MONTH)
    return localize('aboutXMonths', months, localizeOptions)
  }

  months = differenceInMonths(dateRight, dateLeft)

  // 2 months up to 12 months
  if (months < 12) {
    var nearestMonth = Math.round(minutes / MINUTES_IN_MONTH)
    return localize('xMonths', nearestMonth, localizeOptions)

  // 1 year up to max Date
  } else {
    var monthsSinceStartOfYear = months % 12
    var years = Math.floor(months / 12)

    // N years up to 1 years 3 months
    if (monthsSinceStartOfYear < 3) {
      return localize('aboutXYears', years, localizeOptions)

    // N years 3 months up to N years 9 months
    } else if (monthsSinceStartOfYear < 9) {
      return localize('overXYears', years, localizeOptions)

    // N years 9 months up to N year 12 months
    } else {
      return localize('almostXYears', years + 1, localizeOptions)
    }
  }
}

module.exports = distanceInWords


/***/ }),
/* 723 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(9)

/**
 * @category Week Helpers
 * @summary Return the end of a week for the given date.
 *
 * @description
 * Return the end of a week for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @param {Object} [options] - the object with options
 * @param {Number} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @returns {Date} the end of a week
 *
 * @example
 * // The end of a week for 2 September 2014 11:55:00:
 * var result = endOfWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sat Sep 06 2014 23:59:59.999
 *
 * @example
 * // If the week starts on Monday, the end of the week for 2 September 2014 11:55:00:
 * var result = endOfWeek(new Date(2014, 8, 2, 11, 55, 0), {weekStartsOn: 1})
 * //=> Sun Sep 07 2014 23:59:59.999
 */
function endOfWeek (dirtyDate, dirtyOptions) {
  var weekStartsOn = dirtyOptions ? (Number(dirtyOptions.weekStartsOn) || 0) : 0

  var date = parse(dirtyDate)
  var day = date.getDay()
  var diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn)

  date.setDate(date.getDate() + diff)
  date.setHours(23, 59, 59, 999)
  return date
}

module.exports = endOfWeek


/***/ }),
/* 724 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(9)

/**
 * @category Month Helpers
 * @summary Return the end of a month for the given date.
 *
 * @description
 * Return the end of a month for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the end of a month
 *
 * @example
 * // The end of a month for 2 September 2014 11:55:00:
 * var result = endOfMonth(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 30 2014 23:59:59.999
 */
function endOfMonth (dirtyDate) {
  var date = parse(dirtyDate)
  var month = date.getMonth()
  date.setFullYear(date.getFullYear(), month + 1, 0)
  date.setHours(23, 59, 59, 999)
  return date
}

module.exports = endOfMonth


/***/ }),
/* 725 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(9)

/**
 * @category Year Helpers
 * @summary Is the given date in the leap year?
 *
 * @description
 * Is the given date in the leap year?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is in the leap year
 *
 * @example
 * // Is 1 September 2012 in the leap year?
 * var result = isLeapYear(new Date(2012, 8, 1))
 * //=> true
 */
function isLeapYear (dirtyDate) {
  var date = parse(dirtyDate)
  var year = date.getFullYear()
  return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0
}

module.exports = isLeapYear


/***/ }),
/* 726 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(9)

/**
 * @category Weekday Helpers
 * @summary Get the day of the ISO week of the given date.
 *
 * @description
 * Get the day of the ISO week of the given date,
 * which is 7 for Sunday, 1 for Monday etc.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the day of ISO week
 *
 * @example
 * // Which day of the ISO week is 26 February 2012?
 * var result = getISODay(new Date(2012, 1, 26))
 * //=> 7
 */
function getISODay (dirtyDate) {
  var date = parse(dirtyDate)
  var day = date.getDay()

  if (day === 0) {
    day = 7
  }

  return day
}

module.exports = getISODay


/***/ }),
/* 727 */
/***/ (function(module, exports, __webpack_require__) {

var startOfHour = __webpack_require__(728)

/**
 * @category Hour Helpers
 * @summary Are the given dates in the same hour?
 *
 * @description
 * Are the given dates in the same hour?
 *
 * @param {Date|String|Number} dateLeft - the first date to check
 * @param {Date|String|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same hour
 *
 * @example
 * // Are 4 September 2014 06:00:00 and 4 September 06:30:00 in the same hour?
 * var result = isSameHour(
 *   new Date(2014, 8, 4, 6, 0),
 *   new Date(2014, 8, 4, 6, 30)
 * )
 * //=> true
 */
function isSameHour (dirtyDateLeft, dirtyDateRight) {
  var dateLeftStartOfHour = startOfHour(dirtyDateLeft)
  var dateRightStartOfHour = startOfHour(dirtyDateRight)

  return dateLeftStartOfHour.getTime() === dateRightStartOfHour.getTime()
}

module.exports = isSameHour


/***/ }),
/* 728 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(9)

/**
 * @category Hour Helpers
 * @summary Return the start of an hour for the given date.
 *
 * @description
 * Return the start of an hour for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the start of an hour
 *
 * @example
 * // The start of an hour for 2 September 2014 11:55:00:
 * var result = startOfHour(new Date(2014, 8, 2, 11, 55))
 * //=> Tue Sep 02 2014 11:00:00
 */
function startOfHour (dirtyDate) {
  var date = parse(dirtyDate)
  date.setMinutes(0, 0, 0)
  return date
}

module.exports = startOfHour


/***/ }),
/* 729 */
/***/ (function(module, exports, __webpack_require__) {

var isSameWeek = __webpack_require__(423)

/**
 * @category ISO Week Helpers
 * @summary Are the given dates in the same ISO week?
 *
 * @description
 * Are the given dates in the same ISO week?
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} dateLeft - the first date to check
 * @param {Date|String|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same ISO week
 *
 * @example
 * // Are 1 September 2014 and 7 September 2014 in the same ISO week?
 * var result = isSameISOWeek(
 *   new Date(2014, 8, 1),
 *   new Date(2014, 8, 7)
 * )
 * //=> true
 */
function isSameISOWeek (dirtyDateLeft, dirtyDateRight) {
  return isSameWeek(dirtyDateLeft, dirtyDateRight, {weekStartsOn: 1})
}

module.exports = isSameISOWeek


/***/ }),
/* 730 */
/***/ (function(module, exports, __webpack_require__) {

var startOfISOYear = __webpack_require__(192)

/**
 * @category ISO Week-Numbering Year Helpers
 * @summary Are the given dates in the same ISO week-numbering year?
 *
 * @description
 * Are the given dates in the same ISO week-numbering year?
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} dateLeft - the first date to check
 * @param {Date|String|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same ISO week-numbering year
 *
 * @example
 * // Are 29 December 2003 and 2 January 2005 in the same ISO week-numbering year?
 * var result = isSameISOYear(
 *   new Date(2003, 11, 29),
 *   new Date(2005, 0, 2)
 * )
 * //=> true
 */
function isSameISOYear (dirtyDateLeft, dirtyDateRight) {
  var dateLeftStartOfYear = startOfISOYear(dirtyDateLeft)
  var dateRightStartOfYear = startOfISOYear(dirtyDateRight)

  return dateLeftStartOfYear.getTime() === dateRightStartOfYear.getTime()
}

module.exports = isSameISOYear


/***/ }),
/* 731 */
/***/ (function(module, exports, __webpack_require__) {

var startOfMinute = __webpack_require__(732)

/**
 * @category Minute Helpers
 * @summary Are the given dates in the same minute?
 *
 * @description
 * Are the given dates in the same minute?
 *
 * @param {Date|String|Number} dateLeft - the first date to check
 * @param {Date|String|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same minute
 *
 * @example
 * // Are 4 September 2014 06:30:00 and 4 September 2014 06:30:15
 * // in the same minute?
 * var result = isSameMinute(
 *   new Date(2014, 8, 4, 6, 30),
 *   new Date(2014, 8, 4, 6, 30, 15)
 * )
 * //=> true
 */
function isSameMinute (dirtyDateLeft, dirtyDateRight) {
  var dateLeftStartOfMinute = startOfMinute(dirtyDateLeft)
  var dateRightStartOfMinute = startOfMinute(dirtyDateRight)

  return dateLeftStartOfMinute.getTime() === dateRightStartOfMinute.getTime()
}

module.exports = isSameMinute


/***/ }),
/* 732 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(9)

/**
 * @category Minute Helpers
 * @summary Return the start of a minute for the given date.
 *
 * @description
 * Return the start of a minute for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the start of a minute
 *
 * @example
 * // The start of a minute for 1 December 2014 22:15:45.400:
 * var result = startOfMinute(new Date(2014, 11, 1, 22, 15, 45, 400))
 * //=> Mon Dec 01 2014 22:15:00
 */
function startOfMinute (dirtyDate) {
  var date = parse(dirtyDate)
  date.setSeconds(0, 0)
  return date
}

module.exports = startOfMinute


/***/ }),
/* 733 */
/***/ (function(module, exports, __webpack_require__) {

var startOfQuarter = __webpack_require__(734)

/**
 * @category Quarter Helpers
 * @summary Are the given dates in the same year quarter?
 *
 * @description
 * Are the given dates in the same year quarter?
 *
 * @param {Date|String|Number} dateLeft - the first date to check
 * @param {Date|String|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same quarter
 *
 * @example
 * // Are 1 January 2014 and 8 March 2014 in the same quarter?
 * var result = isSameQuarter(
 *   new Date(2014, 0, 1),
 *   new Date(2014, 2, 8)
 * )
 * //=> true
 */
function isSameQuarter (dirtyDateLeft, dirtyDateRight) {
  var dateLeftStartOfQuarter = startOfQuarter(dirtyDateLeft)
  var dateRightStartOfQuarter = startOfQuarter(dirtyDateRight)

  return dateLeftStartOfQuarter.getTime() === dateRightStartOfQuarter.getTime()
}

module.exports = isSameQuarter


/***/ }),
/* 734 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(9)

/**
 * @category Quarter Helpers
 * @summary Return the start of a year quarter for the given date.
 *
 * @description
 * Return the start of a year quarter for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the start of a quarter
 *
 * @example
 * // The start of a quarter for 2 September 2014 11:55:00:
 * var result = startOfQuarter(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Jul 01 2014 00:00:00
 */
function startOfQuarter (dirtyDate) {
  var date = parse(dirtyDate)
  var currentMonth = date.getMonth()
  var month = currentMonth - currentMonth % 3
  date.setMonth(month, 1)
  date.setHours(0, 0, 0, 0)
  return date
}

module.exports = startOfQuarter


/***/ }),
/* 735 */
/***/ (function(module, exports, __webpack_require__) {

var startOfSecond = __webpack_require__(736)

/**
 * @category Second Helpers
 * @summary Are the given dates in the same second?
 *
 * @description
 * Are the given dates in the same second?
 *
 * @param {Date|String|Number} dateLeft - the first date to check
 * @param {Date|String|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same second
 *
 * @example
 * // Are 4 September 2014 06:30:15.000 and 4 September 2014 06:30.15.500
 * // in the same second?
 * var result = isSameSecond(
 *   new Date(2014, 8, 4, 6, 30, 15),
 *   new Date(2014, 8, 4, 6, 30, 15, 500)
 * )
 * //=> true
 */
function isSameSecond (dirtyDateLeft, dirtyDateRight) {
  var dateLeftStartOfSecond = startOfSecond(dirtyDateLeft)
  var dateRightStartOfSecond = startOfSecond(dirtyDateRight)

  return dateLeftStartOfSecond.getTime() === dateRightStartOfSecond.getTime()
}

module.exports = isSameSecond


/***/ }),
/* 736 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(9)

/**
 * @category Second Helpers
 * @summary Return the start of a second for the given date.
 *
 * @description
 * Return the start of a second for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the start of a second
 *
 * @example
 * // The start of a second for 1 December 2014 22:15:45.400:
 * var result = startOfSecond(new Date(2014, 11, 1, 22, 15, 45, 400))
 * //=> Mon Dec 01 2014 22:15:45.000
 */
function startOfSecond (dirtyDate) {
  var date = parse(dirtyDate)
  date.setMilliseconds(0)
  return date
}

module.exports = startOfSecond


/***/ }),
/* 737 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(9)

/**
 * @category Week Helpers
 * @summary Return the last day of a week for the given date.
 *
 * @description
 * Return the last day of a week for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @param {Object} [options] - the object with options
 * @param {Number} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @returns {Date} the last day of a week
 *
 * @example
 * // The last day of a week for 2 September 2014 11:55:00:
 * var result = lastDayOfWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sat Sep 06 2014 00:00:00
 *
 * @example
 * // If the week starts on Monday, the last day of the week for 2 September 2014 11:55:00:
 * var result = lastDayOfWeek(new Date(2014, 8, 2, 11, 55, 0), {weekStartsOn: 1})
 * //=> Sun Sep 07 2014 00:00:00
 */
function lastDayOfWeek (dirtyDate, dirtyOptions) {
  var weekStartsOn = dirtyOptions ? (Number(dirtyOptions.weekStartsOn) || 0) : 0

  var date = parse(dirtyDate)
  var day = date.getDay()
  var diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn)

  date.setHours(0, 0, 0, 0)
  date.setDate(date.getDate() + diff)
  return date
}

module.exports = lastDayOfWeek


/***/ }),
/* 738 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(9)
var getDaysInMonth = __webpack_require__(258)

/**
 * @category Month Helpers
 * @summary Set the month to the given date.
 *
 * @description
 * Set the month to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} month - the month of the new date
 * @returns {Date} the new date with the month setted
 *
 * @example
 * // Set February to 1 September 2014:
 * var result = setMonth(new Date(2014, 8, 1), 1)
 * //=> Sat Feb 01 2014 00:00:00
 */
function setMonth (dirtyDate, dirtyMonth) {
  var date = parse(dirtyDate)
  var month = Number(dirtyMonth)
  var year = date.getFullYear()
  var day = date.getDate()

  var dateWithDesiredMonth = new Date(0)
  dateWithDesiredMonth.setFullYear(year, month, 15)
  dateWithDesiredMonth.setHours(0, 0, 0, 0)
  var daysInMonth = getDaysInMonth(dateWithDesiredMonth)
  // Set the last day of the new month
  // if the original date was the last day of the longer month
  date.setMonth(month, Math.min(day, daysInMonth))
  return date
}

module.exports = setMonth


/***/ }),
/* 739 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core__ = __webpack_require__(4);
var CustomCardSubHeading=function CustomCardSubHeading(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["Z" /* Typography */],{variant:"subheading"},props.subheading),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["Z" /* Typography */],{variant:"caption"},props.caption),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:{borderBottom:"1px solid #cccccc69",margin:"5px",width:"25%"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["Z" /* Typography */],{variant:"headline",className:"centerCell",style:{marginBottom:"5px"}},props.headline));};/* harmony default export */ __webpack_exports__["a"] = (CustomCardSubHeading);

/***/ }),
/* 740 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core__ = __webpack_require__(4);
var CustomChipLeft=function CustomChipLeft(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:Object.assign({textAlign:"center"},props.style)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["i" /* Chip */],{avatar:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["b" /* Avatar */],{style:props.avatarStyle?Object.assign({},props.avatarStyle):{backgroundColor:"#6c5cab",color:"white"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["w" /* Icon */],null,props.icon)),className:"CustomChipLeft",variant:"outlined",label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["Z" /* Typography */],{style:props.textStyle?Object.assign({},props.textStyle):{color:"white"}},props.text),color:"secondary",style:props.chipStyle?Object.assign({},props.chipStyle):{backgroundColor:"#4239d659",color:"white"},onClick:props.clicked}));};/* harmony default export */ __webpack_exports__["a"] = (CustomChipLeft);

/***/ }),
/* 741 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core__ = __webpack_require__(4);
var CustomChipLeftReversed=function CustomChipLeftReversed(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:Object.assign({textAlign:"center"},props.style)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["i" /* Chip */],{id:props.name,className:"CustomChipLeftReversed",variant:"outlined",color:"secondary",style:props.chipStyle?Object.assign({},props.chipStyle):{backgroundColor:"#FFFFFF",color:"white",width:"2px"},avatar:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["b" /* Avatar */],{style:props.avatarStyle?Object.assign({},props.avatarStyle):{backgroundColor:"#6c5cab",color:"white",size:"100%"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["w" /* Icon */],null,props.icon)),onClick:props.clicked}));};/* harmony default export */ __webpack_exports__["a"] = (CustomChipLeftReversed);

/***/ }),
/* 742 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return planDetails; });
var planDetails=[{"company":"Bestmed","name":"Beat 1","planType":"Hospital Plan","coverLevel":"Mid","hospital":"Any","chronic":"Any","serviceType":"N/A","familyIncome":"N/A","mainContribution":"R1746","mainCompSavings":"R0.00","mainTotal":"R1746","dependendContributionAdult":"R1354","dependentCompSavingsAdult":"R0.00","dependentTotalAdult":"R1354","dependendContributionChild":"R734","dependentCompSavingsChild":"R0.00","dependentTotalChild":"R734","maxChildContribution":"3","mainThreshold":"","dependentThresholdAdult":"","dependentThresholdChild":"","preferedHospitalProvider":"Any hospital","overallLimit":"None","coPayment":"R3 800 All endoscopic investigations and specialised diagnostic imaging, if done in-private hospital\\nAny other facility, no co-payment \\n","rate":"100% Scheme Rate","generalMedicin":"7 days' supply","specialist":"100% Scheme Rate","dentistSurgical":"Maxillo facial: No benefit\\n- PMBs only at DSP day hospitals\\nDental and oral surgery(In or out of hospital) : \\n- PMBs only at DSP day hospitals\\n","mentalHealth":"                        \\n21 days per beneficiary \\nTreatment of chemical & substance abuse:\\n � 21 days or R33 655 per beneficiary\\nSubject to network facilities\\n","radiology":"100% Scheme Rate, unlimited","pathology":"100% Scheme Rate, unlimited","maternityBenefit":"In-hospital: 100% Scheme Rate\\nMidwife-assisted births: 100% Scheme Rate\\nOut-of-Hospital\\n� 6 consults at GP/gynae/midwife\\n� 1x lactation consultation at registered\\nnurse or lactation specialist\\n� 2 x 2D scans per pregnancy\\n� 3 baby growth and development\\nassessments per year for children\\n0-2 years\\n\\n ","dialysis":"Subject to pre-authorisation and DSPs","cancer":"Subject to pre-authorisation and DSP\\n","transplant":"PMBs only","mri":"In Hospital:100% Scheme Rate, unlimited\\nOut of Hospital: R5 567 per family ","prosthesisInternal":"Subject to preferred providers and DSPs \\nR82 158 per family\\n� Sub-limits per beneficiary:\\nFunctional: R14 698\\nVascular/Spinal: R32 792 per type\\nPacemaker (dual chamber): R44 791\\nMesh: R11 508\\nGynaecology/Urology: R9 404 \\nLens implants: R7 176 per lens\\nExclusions (in-hospital)- Joint replacements, unless PMB\\nProsthesis limits: Hip replacement and other major joints: R34 552\\nKnee replacement: R42 564\\nOther minor joints: R13 240","prosthesisExternal":"External Prosthesis : No benefit (PMBs only)\\nMedical aids, apparatus & appliances incl wheelchairs & hearing aids : no benefit","rehab":"Alternatives to hospitalisation\\n100% Scheme Rate                                                                                \\nRehabilitation after trauma: PMB only\\nWound care benefit: R3 675 per family\\nPalliative care and Home-based care: \\nR60 000 per beneficiary per annum. Subject to pre-auth and treatment plan\\n","designatedServiceProvider":"yes","conditionsCovered":"CDL in PMB ","formulary":"Yes, 30% co-payment for non-formulary medicines","partialLimits":"No benefit\\nBiological medicine during hospitalisation:\\nR10 000 per family","preferredProvider":"yes","overallAnualLimit":"None","medicationOverCounter":"No benefit","medicationPrescribed":"No benefit","practitionersGeneral":"No benefit\\nDiabetes primary care consultation: Subject to registration with HaloCare \\n2 consultations at Dis-Chem Pharmacies ","specialistsCover":"No benefit","dentistryCover":"No benefit","dentistryCoverSpecial":"No benefit","optical":"No benefit","ambulance":"Rendered and pre-authorised by ER24","international":"Leisure Travel: 45 days and R500 000 cover for travel to the USA. All other countries covered up to 90 days,R5 million per member and R10 million for principal member and dependants \\nBusiness Travel: 45 days and R500 000 cover for travel to the USA. All other countries covered up to 45 days, R5 million per member and R10 million for principal member and dependants","hospitalCoverAids":"100% Scheme Rate\\nSubject to pre-auth and DSP","artTtreatment":"See above for details","preventative":"� Preventative care \\nFlu vaccines\\nPneumonia vaccines\\nContraceptives: R2 412 per beneficiary \\nHPV vaccinations\\nBack and neck preventative programme\\nPap smear\\n\\nTempo Wellness Programme\\nBestmed Tempo Health which includes:\\n- The Bestmed Tempo lifestyle questionnaire\\n- Blood pressure check\\n- Cholesterol check\\n- Glucose check\\n- HIV screening\\n- Height, weight and waist circumference\\n\\n","logo":"bestmed.jpg"},{"company":"Bestmed","name":"Beat 2","planType":"New Generation","coverLevel":"Mid","hospital":"Any","chronic":"Any","serviceType":"Any","familyIncome":"N/A","mainContribution":"R1792","mainCompSavings":"R341","mainTotal":"R2133","dependendContributionAdult":"R1391","dependentCompSavingsAdult":"R265","dependentTotalAdult":"R1656","dependendContributionChild":"R754","dependentCompSavingsChild":"R144","dependentTotalChild":"R898","maxChildContribution":"3","mainThreshold":"","dependentThresholdAdult":"","dependentThresholdChild":"","preferedHospitalProvider":"Any hospital","overallLimit":"None","coPayment":"R3 800 All endoscopic investigations and specialised diagnostic imaging, if done in-private hospital\\nAny other facility, no co-payment \\n","rate":"100% Scheme Rate","generalMedicin":"7 days' supply","specialist":"100% Scheme Rate","dentistSurgical":"Maxillo facial: No benefit\\n- PMBs only at DSP day hospitals\\nDental and oral surgery : \\n- PMBs only at DSP day hospitals\\n\\nPULP procedures, extraction and Restorations: R5 471 per family for disabled\\nand beneficiaries 0-7 years \\n","mentalHealth":"                        \\n21 days per beneficiary \\nTreatment of chemical & substance abuse:\\n � 21 days or R33 655 per beneficiary\\nSubject to network facilities\\n","radiology":"100% Scheme Rate, unlimited","pathology":"100% Scheme Rate, unlimited","maternityBenefit":"In-hospital: 100% Scheme Rate\\nMidwife-assisted births: 100% Scheme Rate\\nOut-of-Hospital\\n� 6 consults at GP/gynae/midwife\\n� 1x lactation consultation at registered\\nnurse or lactation specialist\\n� 2 x 2D scans per pregnancy\\n� 3 baby growth and development\\nassessments per year for children\\n0-2 years\\n\\n ","dialysis":"Subject to pre-authorisation and DSPs","cancer":"Subject to pre-authorisation and DSP\\n","transplant":"PMBs only","mri":"In Hospital:100% Scheme Rate, unlimited\\nOut of Hospital: R5 567 per family ","prosthesisInternal":"Subject to preferred providers and DSPs \\nR82 158 per family\\n� Sub-limits per beneficiary:\\nFunctional: R14 698\\nVascular/Spinal: R32 792 per type\\nPacemaker (dual chamber): R44 791\\nMesh: R11 508\\nGynaecology/Urology: R9 404 \\nLens implants: R7 176 per lens\\nExclusions (in-hospital)- Joint replacements, unless PMB\\nProsthesis limits: Hip replacement and other major joints: R34 552\\nKnee replacement: R42 564\\nOther minor joints: R13 240","prosthesisExternal":"External Prosthesis : No benefit\\nMedical aids, apparatus & appliances:\\n- subject to savings","rehab":"Alternatives to hospitalisation\\n100% Scheme Rate                                                                                \\nRehabilitation after trauma: PMB only\\nWound care benefit: R3 675 per family\\nPalliative care and Home-based care: \\nR60 000 per beneficiary per annum. Subject to pre-auth and treatment plan\\n","designatedServiceProvider":"Yes","conditionsCovered":"CDL in PMB ","formulary":"Yes, 30% co-payment for non-formulary medicines","partialLimits":"No benefit\\nBiological medicine during hospitalisation:\\nR15 000 per family","preferredProvider":"yes","overallAnualLimit":"None","medicationOverCounter":"Subject to available Savings ","medicationPrescribed":"Subject to available Savings ","practitionersGeneral":"Subject to savings\\nDiabetes primary care consultation: Subject to registration with HaloCare \\n2 consultations at Dis-Chem Pharmacies ","specialistsCover":"Subject to available Savings ","dentistryCover":"\\nSubject to preventative benefit or Savings \\n","dentistryCoverSpecial":"Subject to available Savings   \\nOrthodontic: subject to pre-authorisation","optical":"Subject to available Savings ","ambulance":"Rendered and pre-authorised by ER24","international":"Leisure Travel: 45 days and R500 000 cover for travel to the USA. All other countries covered up to 90 days,R5 million per member and R10 million for principal member and dependants \\nBusiness Travel: 45 days and R500 000 cover for travel to the USA. All other countries covered up to 45 days, R5 million per member and R10 million for principal member and dependants","hospitalCoverAids":"100% Scheme Rate\\nSubject to pre-auth and DSP","artTtreatment":"See above for details","preventative":"� Preventative care benefits\\nFlu vaccines\\nPneumonia vaccines\\nTravel vaccines\\nPaediatric immunisations\\nContraceptives: R2 412 per beneficiary \\nBack and neck preventative programme\\nHPV vaccinations\\nMammogram\\nPreventative Dentistry\\nPSA screening\\nPap smear\\n\\nTempo Wellness Programme\\nBestmed Tempo Health which includes:\\n- The Bestmed Tempo lifestyle questionnaire\\n- Blood pressure check\\n- Cholesterol check\\n- Glucose check\\n- HIV screening\\n- Height, weight and waist circumference\\n\\n","logo":"bestmed.jpg"},{"company":"Bestmed","name":"Beat 3","planType":"New Generation","coverLevel":"Mid","hospital":"Any","chronic":"Any","serviceType":"Any","familyIncome":"N/A","mainContribution":"R2721","mainCompSavings":"R518","mainTotal":"R3239","dependendContributionAdult":"R1933","dependentCompSavingsAdult":"R368","dependentTotalAdult":"R2301","dependendContributionChild":"R1050","dependentCompSavingsChild":"R200","dependentTotalChild":"R1250","maxChildContribution":"3","mainThreshold":"","dependentThresholdAdult":"","dependentThresholdChild":"","preferedHospitalProvider":"Any hospital","overallLimit":"None","coPayment":"Any other facility, no co-payment \\n","rate":"100% Scheme Rate","generalMedicin":"7 days' supply","specialist":"100% Scheme Rate","dentistSurgical":"\\nMaxillo facial and oral surgery: \\n R13 487 per family\\n(strictly related to certain conditions)\\nDental and oral surgery (in or out-of-hospital) R8 414 per family","mentalHealth":"                        \\n21 days per beneficiary \\nTreatment of chemical & substance abuse:\\n � 21 days or R33 655 per beneficiary\\nSubject to network facilities\\n","radiology":"100% Scheme Rate, unlimited","pathology":"100% Scheme Rate, unlimited","maternityBenefit":"In-Hospital: 100% Scheme Rate\\nMidwife-assisted births: 100% Scheme Rate\\nOut-of-Hospital: \\n� 9 consults at GP/gynae/midwife\\n� Antenatal supplements\\n� 1x postnatal consultation at GP/Midwife/ Gynaecologist\\n� 1x lactation consultation at registered\\nnurse or lactation specialist\\n� 2 x 2D scans per pregnancy\\n� 3 baby growth and development\\nassessments per year for children\\n0-2 years\\n ","dialysis":"Subject to pre-authorisation and DSPs","cancer":"Subject to pre-auth, DSP & registration on the oncology programme \\n","transplant":"PMBs only","mri":"In Hospital: 100% Scheme Rate, unlimited\\nOut of Hospital: R11 694 per family ","prosthesisInternal":"Subject to preferred providers and DSPs\\nR83 025 per family\\n� Sub-limits per beneficiary:\\nFunctional: R14 699\\nVascular/Spinal: R32 913 per type\\nPacemaker (dual chamber): R44 791\\nMesh: R11 567\\nGynaecology/Urology: R9 553\\nLens implants: R7 176 per lens\\nExclusions (in-hospital)    \\nJoint Replacements Surgery(except  PMBs), subject to Prosthesis limits: Hip replacement and other major joints: R34 769, Knee replacement: R43 022\\nOther minor joints: R13 240","prosthesisExternal":"External Prosthesis : No benefit\\nMedical aids, apparatus & appliances:\\n- subject to savings","rehab":"Alternatives to hospitalisation\\n100% Scheme Rate                                                                                \\nRehabilitation after trauma: PMB only\\nWound care benefit: R3 675 per family\\nPalliative care and Home-based care: \\nR60 000 per beneficiary per annum. Subject to pre-auth and treatment plan\\n","designatedServiceProvider":"Yes","conditionsCovered":"CDL in PMB + 5 conditions","formulary":"Yes, 30% co-payment for non-formulary medicines","partialLimits":"Non-CDL chronic medicine: 80% Scheme rate. Limited to M : R3 589, M1+ : R7 300\\n30% co-payment for non-formulary medicines  \\nBiological medicine during hospitalisation:\\nR20 000 per family","preferredProvider":"yes","overallAnualLimit":"None","medicationOverCounter":"Subject to available Savings ","medicationPrescribed":"Subject to available Savings ","practitionersGeneral":"Subject to savings\\nDiabetes primary care consultation: Subject to registration with HaloCare \\n2 consultations at Dis-Chem Pharmacies ","specialistsCover":"Subject to available Savings ","dentistryCover":"Subject to available Savings ","dentistryCoverSpecial":"Subject to available Savings   \\nOrthodontic: subject to pre-authorisation","optical":"Benefits available every 2 years\\nNetwork Provider(PPN) \\n� Consultation: 1 per beneficiary\\n� Frame: R860\\n� Lenses 100% cost \\n(single-vision/bifocal/ multifocal or\\nContact lenses: R1 630 OR\\nNon-network Provider\\n� Consultation: R350\\n� Frame: R598 and\\n� Single-vision lenses: R210 OR\\n� Bifocal lenses: R445 OR\\n� Multifocal lenses: R1 000 OR\\n� Contact lenses: R1 630\\nRefractive surgery: R8 661 per eye\\n \\n","ambulance":"Rendered and pre-authorised by ER24","international":"Leisure Travel: 45 days and R500 000 cover for travel to the USA. All other countries covered up to 90 days,R5 million per member and R10 million for principal member and dependants \\nBusiness Travel: 45 days and R500 000 cover for travel to the USA. All other countries covered up to 45 days, R5 million per member and R10 million for principal member and dependants","hospitalCoverAids":"100% Scheme Rate\\nSubject to pre-auth and DSP","artTtreatment":"See above for details","preventative":"� Preventative care benefits\\nFlu vaccines\\nPneumonia vaccines\\nTravel vaccines\\nPaediatric immunisations\\nContraceptives: R2 412 per beneficiary \\nBack and neck preventative programme\\nHPV vaccinations\\nMammogram\\nPreventative Dentistry\\nPSA screening\\nPap smear\\n\\nTempo Wellness Programme\\nBestmed Tempo Health which includes:\\n- The Bestmed Tempo lifestyle questionnaire\\n- Blood pressure check\\n- Cholesterol check\\n- Glucose check\\n- HIV screening\\n- Height, weight and waist circumference\\n\\n","logo":"bestmed.jpg"},{"company":"Bestmed","name":"Beat 4","planType":"Hybrid option","coverLevel":"Mid","hospital":"Any","chronic":"Any","serviceType":"Any","familyIncome":"N/A","mainContribution":"R4353","mainCompSavings":"R709","mainTotal":"R5062","dependendContributionAdult":"R3596","dependentCompSavingsAdult":"R585","dependentTotalAdult":"R4181","dependendContributionChild":"R1076","dependentCompSavingsChild":"R175","dependentTotalChild":"R1251","maxChildContribution":"3","mainThreshold":"","dependentThresholdAdult":"","dependentThresholdChild":"","preferedHospitalProvider":"Any hospital","overallLimit":"None","coPayment":"None","rate":"100% Scheme Rate","generalMedicin":"7 days' supply","specialist":"100% Scheme Rate","dentistSurgical":"\\nMaxillo facial and oral surgery: \\n R13 487 per family\\n(strictly related to certain conditions)\\nDental and oral surgery (in or out-of-hospital) R8 414 per family","mentalHealth":"                        \\n21 days per beneficiary \\nTreatment of chemical & substance abuse:\\n � 21 days or R33 655 per beneficiary\\nSubject to network facilities\\n","radiology":"In Hospital: 100% Scheme Rate\\nOut of Hospital: Savings then \\nM: R3 265 M+: R6 650","pathology":"In Hospital: 100% Scheme Rate\\nOut of Hospital: Shared limit with Radiology ","maternityBenefit":"In-Hospital: 100% Scheme Rate\\nMidwife-assisted births: 100% Scheme Rate\\nOut-of-Hospital: \\n� 9 consults at GP/gynae/midwife\\n� Antenatal supplements\\n� 1x postnatal consultation at GP/Midwife/ Gynaecologist\\n� 1x lactation consultation at registered\\nnurse or lactation specialist\\n� 2 x 2D scans per pregnancy\\n� 3 baby growth and development\\nassessments per year for children 0-2 years\\n ","dialysis":"Subject to pre-authorisation and DSPs","cancer":"Subject to pre-auth, DSP & registration on the oncology programme \\n","transplant":"PMBs only","mri":"In Hospital: 100% Scheme Rate, unlimited\\nOut of Hospital: R17 694 per family ","prosthesisInternal":"Subject to preferred providers and DSPs\\nR101 345 per family\\n� Sub-limits per beneficiary\\nFunctional: R17 694\\nVascular/Spinal : R35 017 per type\\nPacemaker (dual chamber) R58 649\\nDrug eluting stents: R19 674\\nMesh: R12 992\\nGynaecology and urology: R9 528\\nLens implants: R7 424 per lens\\nJoint Replacements Surgery(except  PMBs): Hip prosthesis and other major joints: R36 007\\nKnee replacement: R47 835\\nMinor joints: R14 698","prosthesisExternal":"External Prosthesis: R24 376 per family\\nApparatus and appliances: R12 003 per family every 2 years\\nHearing aids: R11 000 per family, every 2 years, subject to day-to-day limit ","rehab":" Alternatives to hospitalisation, unlimited\\nRehabilitation after trauma: unlimited\\nWound care benefit: Savings first, then        R5 197 per family\\nPalliative care and Home-based care: \\nR90 000 per beneficiary per annum. Subject to pre-auth and treatment plan","designatedServiceProvider":"Yes","conditionsCovered":"CDL in PMB + 9 conditions","formulary":"Yes, 20% co-payment for non-formulary medicines","partialLimits":"Non-CDL chronic medicine: 90% Scheme rate. Limited to M : R7 882, M1+ : R15 764\\n20% co-payment for non-formulary medicines \\nMajor depression will continue\\nto be funded from risk once non-CDL limit are depleted \\nBiological medicine during hospitalisation:\\nR25 000 per family","preferredProvider":"yes","overallAnualLimit":"M : R13 363, M1+ : R26 726","medicationOverCounter":"R1 000 OR access to full savings for OTC\\npurchases (after R1 000 limit), self- payment gap accumulation\\nSubject to available savings","medicationPrescribed":"Savings first,(Subject to day-to-day limit)\\nLimited to M: R3 006, M1 +: R6 075\\n\\n ","practitionersGeneral":"Savings first       \\nLimited to M: R3 403, M1 +: R6 063\\n(Subject to day-to-day limit)\\nDiabetes primary care consultation: Subject to registration with HaloCare \\n2 consultations at Dis-Chem Pharmacies. First paid from GP and specialist limits, thereafter Risk ","specialistsCover":"Shared limit with GP benefits","dentistryCover":"Shared limit with Specialised dentistry","dentistryCoverSpecial":"Shared limit with conservative dentistry \\nSavings first and then from day-to-day limits\\nLimited to M : R5 887, M1+ : R11 825 \\nOrthodontic: subject to pre-authorisation","optical":"Benefits available every 2 years\\nNetwork Provider(PPN) \\n� Consultation: 1 per beneficiary\\n� Frame: RR950\\n� Lenses 100% cost \\n(single-vision/bifocal/ multifocal or\\nContact lenses: R1 720 OR\\nNon-network Provider\\n� Consultation: R350\\n� Frame: R598 and\\n� Single-vision lenses: R210 OR\\n� Bifocal lenses: R445 OR\\n� Multifocal lenses: R1 000 OR\\n� Contact lenses: R1 720\\nRefractive surgery: R9 775 per eye\\n \\n","ambulance":"Rendered and pre-authorised by ER24","international":"Leisure Travel: 45 days and R500 000 cover for travel to the USA. All other countries covered up to 90 days,R5 million per member and R10 million for principal member and dependants \\nBusiness Travel: 45 days and R500 000 cover for travel to the USA. All other countries covered up to 45 days, R5 million per member and R10 million for principal member and dependants","hospitalCoverAids":"100% Scheme Rate\\nSubject to pre-auth and DSP","artTtreatment":"See above for details","preventative":"�Preventative care\\nFlu vaccines\\nPneumonia vaccines\\nTravel vaccines\\nPaediatric immunisations\\nContraceptives - R2 315 per beneficiary\\nBack and neck preventative programme\\nPreventative dentistry\\nMammogram\\nHPV vaccinations\\nPSA screening\\nPap smear\\n\\nTempo Wellness Programme\\nBestmed Tempo Health which includes:\\n- The Bestmed Tempo lifestyle questionnaire\\n- Blood pressure check\\n- Cholesterol check\\n- Glucose check\\n- HIV screening\\n- Height, weight and waist circumference\\n\\n","logo":"bestmed.jpg"},{"company":"Bestmed","name":"Beat 1 Network","planType":"Hospital Plan","coverLevel":"Mid","hospital":"Network","chronic":"Network","serviceType":"N/A","familyIncome":"N/A","mainContribution":"R1570","mainCompSavings":"R0.00","mainTotal":"R1570","dependendContributionAdult":"R1220","dependentCompSavingsAdult":"R0.00","dependentTotalAdult":"R1220","dependendContributionChild":"R661","dependentCompSavingsChild":"R0.00","dependentTotalChild":"R661","maxChildContribution":"3","mainThreshold":"","dependentThresholdAdult":"","dependentThresholdChild":"","preferedHospitalProvider":"\\nNetwork hospitals\\n","overallLimit":"None","coPayment":"R3 800 All endoscopic investigations and specialised diagnostic imaging, if done in-private hospital\\nAny other facility, no co-payment \\nnon-DSP hospital: R12 373 per event","rate":"100% Scheme Rate","generalMedicin":"7 days' supply","specialist":"100% Scheme Rate \\nSubject to DSP specialist network","dentistSurgical":"Maxillo facial: No benefit\\n- PMBs only at DSP day hospitals\\nDental and oral surgery(In or out of hospital) : \\n- PMBs only at DSP day hospitals\\n","mentalHealth":"                        \\n21 days per beneficiary \\nTreatment of chemical & substance abuse:\\n � 21 days or R33 655 per beneficiary\\nSubject to network facilities\\n","radiology":"100% Scheme Rate, unlimited","pathology":"100% Scheme Rate, unlimited","maternityBenefit":"In-hospital: 100% Scheme Rate\\nMidwife-assisted births: 100% Scheme Rate\\nOut-of-Hospital\\n� 6 consults at GP/gynae/midwife\\n� 1x lactation consultation at registered\\nnurse or lactation specialist\\n� 2 x 2D scans per pregnancy\\n� 3 baby growth and development\\nassessments per year for children\\n0-2 years\\n\\n ","dialysis":"Subject to pre-authorisation and DSPs","cancer":"Subject to pre-authorisation and DSP\\n","transplant":"PMBs only","mri":"In Hospital:100% Scheme Rate, unlimited\\nOut of Hospital: R5 567 per family ","prosthesisInternal":"Subject to preferred providers and DSPs \\nR82 158 per family\\n� Sub-limits per beneficiary:\\nFunctional: R14 698\\nVascular/Spinal: R32 792 per type\\nPacemaker (dual chamber): R44 791\\nMesh: R11 508\\nGynaecology/Urology: R9 404 \\nLens implants: R7 176 per lens\\nExclusions (in-hospital)- Joint replacements, unless PMB\\nProsthesis limits: Hip replacement and other major joints: R34 552\\nKnee replacement: R42 564\\nOther minor joints: R13 240","prosthesisExternal":"External Prosthesis : No benefit (PMBs only)\\nMedical aids, apparatus & appliances incl wheelchairs & hearing aids : no benefit","rehab":"Alternatives to hospitalisation\\n100% Scheme Rate                                                                                \\nRehabilitation after trauma: PMB only\\nWound care benefit: R3 675 per family\\nPalliative care and Home-based care: \\nR60 000 per beneficiary per annum. Subject to pre-auth and treatment plan\\n","designatedServiceProvider":"Yes","conditionsCovered":"CDL in PMB ","formulary":"Yes, 30% co-payment for non-formulary medicines","partialLimits":"No benefit\\nBiological medicine during hospitalisation:\\nR10 000 per family","preferredProvider":"yes","overallAnualLimit":"None","medicationOverCounter":"No Benefit","medicationPrescribed":"No Benefit","practitionersGeneral":"No benefit\\nDiabetes primary care consultation: Subject to registration with HaloCare \\n2 consultations at Dis-Chem Pharmacies ","specialistsCover":"No Benefit","dentistryCover":"No Benefit","dentistryCoverSpecial":"No Benefit","optical":"No Benefit\\n","ambulance":"Rendered and pre-authorised by ER24","international":"Leisure Travel: 45 days and R500 000 cover for travel to the USA. All other countries covered up to 90 days,R5 million per member and R10 million for principal member and dependants \\nBusiness Travel: 45 days and R500 000 cover for travel to the USA. All other countries covered up to 45 days, R5 million per member and R10 million for principal member and dependants","hospitalCoverAids":"100% Scheme Rate\\nSubject to pre-auth and DSP","artTtreatment":"See above for details","preventative":"� Preventative care \\nFlu vaccines\\nPneumonia vaccines\\nContraceptives: R2 412 per beneficiary \\nHPV vaccinations\\nBack and neck preventative programme\\nPap smear\\n\\nTempo Wellness Programme\\nBestmed Tempo Health which includes:\\n- The Bestmed Tempo lifestyle questionnaire\\n- Blood pressure check\\n- Cholesterol check\\n- Glucose check\\n- HIV screening\\n- Height, weight and waist circumference\\n\\n","logo":"bestmed.jpg"},{"company":"Bestmed","name":"Beat 2 Network","planType":"New Generation","coverLevel":"Mid","hospital":"Network","chronic":"Any","serviceType":"Any","familyIncome":"N/A","mainContribution":"R1612","mainCompSavings":"R307","mainTotal":"R1919","dependendContributionAdult":"R1252","dependentCompSavingsAdult":"R239","dependentTotalAdult":"R1491","dependendContributionChild":"R678","dependentCompSavingsChild":"R129","dependentTotalChild":"R807","maxChildContribution":"3","mainThreshold":"","dependentThresholdAdult":"","dependentThresholdChild":"","preferedHospitalProvider":"\\nNetwork hospitals\\n","overallLimit":"None","coPayment":"Any other facility, no co-payment \\nnon-DSP hospital: R12 373 per event","rate":"100% Scheme Rate","generalMedicin":"7 days' supply","specialist":"100% Scheme Rate \\nSubject to DSP specialist network","dentistSurgical":"Maxillo facial: No benefit\\n- PMBs only at DSP day hospitals\\nDental and oral surgery : \\n- PMBs only at DSP day hospitals\\n\\nPULP procedures, extraction and Restorations: R5 471 per family for disabled\\nand beneficiaries 0-7 years \\n","mentalHealth":"                        \\n21 days per beneficiary \\nTreatment of chemical & substance abuse:\\n � 21 days or R33 655 per beneficiary\\nSubject to network facilities\\n","radiology":"100% Scheme Rate, unlimited","pathology":"100% Scheme Rate, unlimited","maternityBenefit":"In-hospital: 100% Scheme Rate\\nMidwife-assisted births: 100% Scheme Rate\\nOut-of-Hospital\\n� 6 consults at GP/gynae/midwife\\n� 1x lactation consultation at registered\\nnurse or lactation specialist\\n� 2 x 2D scans per pregnancy\\n� 3 baby growth and development\\nassessments per year for children\\n0-2 years\\n\\n ","dialysis":"Subject to pre-authorisation and DSPs","cancer":"Subject to pre-authorisation and DSP\\n","transplant":"PMBs only","mri":"In Hospital:100% Scheme Rate, unlimited\\nOut of Hospital: R5 567 per family ","prosthesisInternal":"Subject to preferred providers and DSPs \\nR82 158 per family\\n� Sub-limits per beneficiary:\\nFunctional: R14 698\\nVascular/Spinal: R32 792 per type\\nPacemaker (dual chamber): R44 791\\nMesh: R11 508\\nGynaecology/Urology: R9 404 \\nLens implants: R7 176 per lens\\nExclusions (in-hospital)- Joint replacements, unless PMB\\nProsthesis limits: Hip replacement and other major joints: R34 552\\nKnee replacement: R42 564\\nOther minor joints: R13 240","prosthesisExternal":"External Prosthesis : No benefit\\nMedical aids, apparatus & appliances:\\n- subject to savings","rehab":"Alternatives to hospitalisation\\n100% Scheme Rate                                                                                \\nRehabilitation after trauma: PMB only\\nWound care benefit: R3 675 per family\\nPalliative care and Home-based care: \\nR60 000 per beneficiary per annum. Subject to pre-auth and treatment plan\\n","designatedServiceProvider":"Yes","conditionsCovered":"CDL in PMB ","formulary":"Yes, 30% co-payment for non-formulary medicines","partialLimits":"No benefit\\nBiological medicine during hospitalisation:\\nR15 000 per family","preferredProvider":"yes","overallAnualLimit":"None","medicationOverCounter":"Subject to available Savings ","medicationPrescribed":"Subject to available Savings ","practitionersGeneral":"Subject to savings\\nDiabetes primary care consultation: Subject to registration with HaloCare \\n2 consultations at Dis-Chem Pharmacies ","specialistsCover":"Subject to available Savings \\nat Network provider","dentistryCover":"\\nSubject to preventative benefit or Savings \\n","dentistryCoverSpecial":"Subject to available Savings   \\nOrthodontic: subject to pre-authorisation","optical":"Subject to available Savings ","ambulance":"Rendered and pre-authorised by ER24","international":"Leisure Travel: 45 days and R500 000 cover for travel to the USA. All other countries covered up to 90 days,R5 million per member and R10 million for principal member and dependants \\nBusiness Travel: 45 days and R500 000 cover for travel to the USA. All other countries covered up to 45 days, R5 million per member and R10 million for principal member and dependants","hospitalCoverAids":"100% Scheme Rate\\nSubject to pre-auth and DSP","artTtreatment":"See above for details","preventative":"� Preventative care benefits\\nFlu vaccines\\nPneumonia vaccines\\nTravel vaccines\\nPaediatric immunisations\\nContraceptives: R2 412 per beneficiary \\nBack and neck preventative programme\\nHPV vaccinations\\nMammogram\\nPreventative Dentistry\\nPSA screening\\nPap smear\\n\\nTempo Wellness Programme\\nBestmed Tempo Health which includes:\\n- The Bestmed Tempo lifestyle questionnaire\\n- Blood pressure check\\n- Cholesterol check\\n- Glucose check\\n- HIV screening\\n- Height, weight and waist circumference\\n\\n","logo":"bestmed.jpg"},{"company":"Bestmed","name":"Beat 3 Network","planType":"New Generation","coverLevel":"Mid","hospital":"Network","chronic":"Any","serviceType":"Any","familyIncome":"N/A","mainContribution":"R2448","mainCompSavings":"R466","mainTotal":"R2914","dependendContributionAdult":"R1741","dependentCompSavingsAdult":"R332","dependentTotalAdult":"R2073","dependendContributionChild":"R947","dependentCompSavingsChild":"R180","dependentTotalChild":"R1127","maxChildContribution":"3","mainThreshold":"","dependentThresholdAdult":"","dependentThresholdChild":"","preferedHospitalProvider":"\\nNetwork hospitals\\n","overallLimit":"None","coPayment":"Any other facility, no co-payment \\nnon-DSP hospital: R12 373 per event","rate":"100% Scheme Rate","generalMedicin":"7 days' supply","specialist":"100% Scheme Rate \\nSubject to DSP specialist network","dentistSurgical":"\\nMaxillo facial and oral surgery: \\n R13 487 per family\\n(strictly related to certain conditions)\\nDental and oral surgery (in or out-of-hospital) R8 414 per family","mentalHealth":"                        \\n21 days per beneficiary \\nTreatment of chemical & substance abuse:\\n � 21 days or R33 655 per beneficiary\\nSubject to network facilities\\n","radiology":"100% Scheme Rate, unlimited","pathology":"100% Scheme Rate, unlimited","maternityBenefit":"In-Hospital: 100% Scheme Rate\\nMidwife-assisted births: 100% Scheme Rate\\nOut-of-Hospital: \\n� 9 consults at GP/gynae/midwife\\n� Antenatal supplements\\n� 1x postnatal consultation at GP/Midwife/ Gynaecologist\\n� 1x lactation consultation at registered\\nnurse or lactation specialist\\n� 2 x 2D scans per pregnancy\\n� 3 baby growth and development\\nassessments per year for children 0-2 years\\n ","dialysis":"Subject to pre-authorisation and DSPs","cancer":"Subject to pre-auth, DSP & registration on the oncology programme \\n","transplant":"PMBs only","mri":"In Hospital: 100% Scheme Rate, unlimited\\nOut of Hospital: R11 694 per family ","prosthesisInternal":"Subject to preferred providers and DSPs\\nR83 025 per family\\n� Sub-limits per beneficiary:\\nFunctional: R14 699\\nVascular/Spinal: R32 913 per type\\nPacemaker (dual chamber): R44 791\\nMesh: R11 567\\nGynaecology/Urology: R9 553\\nLens implants: R7 176 per lens\\nExclusions (in-hospital)    \\nJoint Replacements Surgery(except  PMBs), subject to Prosthesis limits: Hip replacement and other major joints: R34 769, Knee replacement: R43 022\\nOther minor joints: R13 240","prosthesisExternal":"External Prosthesis : No benefit\\nMedical aids, apparatus & appliances: subject to savings","rehab":"Alternatives to hospitalisation :\\n100% Scheme Rate                                                                                \\nRehabilitation after trauma: PMB only\\nWound care benefit: R3 675 per family\\nPalliative care and Home-based care: \\nR60 000 per beneficiary per annum. Subject to pre-auth and treatment plan\\n","designatedServiceProvider":"Yes","conditionsCovered":"CDL in PMB + 5 conditions","formulary":"Yes, 30% co-payment for non-formulary medicines","partialLimits":"Non-CDL chronic medicine: 80% Scheme rate. Limited to M : R3 589, M1+ : R7 300\\n30% co-payment for non-formulary medicines  \\nBiological medicine during hospitalisation:\\nR20 000 per family","preferredProvider":"yes","overallAnualLimit":"None","medicationOverCounter":"Subject to available Savings ","medicationPrescribed":"Subject to available Savings ","practitionersGeneral":"Subject to savings\\nDiabetes primary care consultation: Subject to registration with HaloCare \\n2 consultations at Dis-Chem Pharmacies ","specialistsCover":"Subject to available Savings \\nat Network provider","dentistryCover":"Subject to available Savings ","dentistryCoverSpecial":"Subject to available Savings \\nOrthodontic: subject to pre-authorisation","optical":"Benefits available every 2 years\\nNetwork Provider(PPN) \\n� Consultation: 1 per beneficiary\\n� Frame: R860\\n� Lenses 100% cost \\n(single-vision/bifocal/ multifocal or\\nContact lenses: R1 630 OR\\nNon-network Provider\\n� Consultation: R350\\n� Frame: R598 and\\n� Single-vision lenses: R210 OR\\n� Bifocal lenses: R445 OR\\n� Multifocal lenses: R1 000 OR\\n� Contact lenses: R1 630\\nRefractive surgery: R8 661 per eye\\n \\n","ambulance":"Rendered and pre-authorised by ER24","international":"Leisure Travel: 45 days and R500 000 cover for travel to the USA. All other countries covered up to 90 days,R5 million per member and R10 million for principal member and dependants \\nBusiness Travel: 45 days and R500 000 cover for travel to the USA. All other countries covered up to 45 days, R5 million per member and R10 million for principal member and dependants","hospitalCoverAids":"100% Scheme Rate\\nSubject to pre-auth and DSP","artTtreatment":"See above for details","preventative":"� Preventative care benefits\\nFlu vaccines\\nPneumonia vaccines\\nTravel vaccines\\nPaediatric immunisations\\nContraceptives: R2 412 per beneficiary \\nBack and neck preventative programme\\nHPV vaccinations\\nMammogram\\nPreventative Dentistry\\nPSA screening\\nPap smear\\n\\nTempo Wellness Programme\\nBestmed Tempo Health which includes:\\n- The Bestmed Tempo lifestyle questionnaire\\n- Blood pressure check\\n- Cholesterol check\\n- Glucose check\\n- HIV screening\\n- Height, weight and waist circumference\\n\\n","logo":"bestmed.jpg"},{"company":"Bestmed","name":"Pace 1","planType":"Hybrid option","coverLevel":"Mid","hospital":"Any","chronic":"Network","serviceType":"Network","familyIncome":"N/A","mainContribution":"R3436","mainCompSavings":"R806","mainTotal":"R4242","dependendContributionAdult":"R2414","dependentCompSavingsAdult":"R566","dependentTotalAdult":"R2980","dependendContributionChild":"R868","dependentCompSavingsChild":"R203","dependentTotalChild":"R1071","maxChildContribution":"3","mainThreshold":"","dependentThresholdAdult":"","dependentThresholdChild":"","preferedHospitalProvider":"Any hospital","overallLimit":"None","coPayment":"None","rate":"100% Scheme Rate","generalMedicin":"7 days' supply","specialist":"100% Scheme Rate","dentistSurgical":"\\nMaxillo facial and oral surgery\\nR13 610 per family.\\n(strictly related to certain conditions)\\nDental and oral surgery (In or out-of-hospital) R8 414 per family","mentalHealth":"                        \\n21 days per beneficiary \\nTreatment of chemical & substance abuse:\\n � 21 days or R33 655 per beneficiary\\nSubject to network facilities\\n","radiology":"In Hospital: 100% Scheme Rate\\nOut of Hospital: Savings then \\nM: R3 402 M+: R6 806 \\n(subject to overall day-to-day limit)","pathology":"In Hospital: 100% Scheme Rate\\nOut of Hospital: Shared limit with Radiology ","maternityBenefit":"In-Hospital: 100% Scheme Rate\\nMidwife-assisted births: 100% Scheme Rate\\nOut-of-Hospital: \\n� 9 consults at GP/gynae/midwife\\n� Antenatal supplements\\n� 1x postnatal consultation at GP/Midwife/ Gynaecologist\\n� 1x lactation consultation at registered\\nnurse or lactation specialist\\n� 2 x 2D scans per pregnancy  \\n� 3 baby growth and development\\nassessments per year for children 0-2 years","dialysis":"Subject to pre-authorisation and DSPs","cancer":"Subject to pre-auth, DSP & registration on the oncology programme \\n","transplant":"PMBs only","mri":"In Hospital: 100% Scheme Rate, unlimited\\nOut of Hospital: R15 220 per family ","prosthesisInternal":"Subject to preferred provider \\nR94 036 per family \\n� Sub-limits per beneficiary\\nFunctional: R16 890\\nVascular/Spinal: R34 273 per type\\nPacemaker (dual chamber): R58 526\\nMesh: R12 868\\nGynaecology/Urology: R9 280\\nLens implants: R7 053 per lens\\nExclusions (in-hospital)\\nJoint Replacements Surgery(except  PMBs): Hip prosthesis and other major joints:R34 892\\nKnee replacement: R46 400\\nMinor joints: R14 415\\n","prosthesisExternal":"External Prosthesis: R23 881 per family\\nApparatus and appliances: R12 003 per family savings and then from day-to-day limits \\nHearing Aids: R 8 336per family, every 2 years, Subject to quotation, motivation and audiogram. ","rehab":"Alternatives to hospitalisation, unlimited      \\nRehabilitation after trauma: unlimited\\nWound care benefit: Savings first, then R3 774 per family. (subject to day-to-day limit) \\nPalliative care and Home-based care: \\nR75 000 per beneficiary per annum. Subject to pre-auth and treatment plan","designatedServiceProvider":"Yes","conditionsCovered":"CDL in PMB +7 conditions","formulary":"Yes, 25% co-payment for non-formulary medicines","partialLimits":"Non-CDL chronic medicine: 90% Scheme rate. Limited to M : R6 929, M1+ = R13 858\\n25% co-payment for non-formulary medicines  \\nBiological medicine during hospitalisation:\\nR30 000 per family","preferredProvider":"yes","overallAnualLimit":"M : R11 359, M1+: R22 717","medicationOverCounter":"R1 000 OR access to full savings for OTC\\npurchases (after R1 000 limit), self- payment gap accumulation\\nSubject to available savings","medicationPrescribed":"Savings first,(Subject to day-to-day limit)\\nLimited to M : R2 451, M1 +: R5 074\\n\\n ","practitionersGeneral":"Savings first       \\nLimited to M : R2 339, M1+: R4 702\\n(Subject to day-to-day limit)\\nDiabetes primary care consultation: Subject to registration with HaloCare \\n2 consultations at Dis-Chem Pharmacies. First paid from GP and specialist limits, thereafter Risk  ","specialistsCover":"Shared limit with GP benefits","dentistryCover":"Shared limit with Specialised dentistry","dentistryCoverSpecial":"Shared limit with conservative dentistry \\nSavings and then from day-to-day limits\\nLimited to M :R4 305, M1+ :R8 736  \\nOrthodontic: subject to pre-authorisation","optical":"Benefits available every 2 years\\nNetwork Provider(PPN) \\n� Consultation: 1 per beneficiary\\n� Frame: R950\\n� Lenses 100% cost \\n(single-vision/bifocal/ multifocal or\\nContact lenses: R1 720 OR\\nNon-network Provider\\n� Consultation: R350\\n� Frame: R598 and\\n� Single-vision lenses: R210 OR\\n� Bifocal lenses: R445 OR\\n� Multifocal lenses: R1 000  OR\\n� Contact lenses: R1 720\\nRefractive surgery: R9 354 per eye\\n \\n","ambulance":"Rendered and pre-authorised by ER24","international":"Leisure Travel: 45 days and R500 000 cover for travel to the USA. All other countries covered up to 90 days,R5 million per member and R10 million for principal member and dependants \\nBusiness Travel: 45 days and R500 000 cover for travel to the USA. All other countries covered up to 45 days, R5 million per member and R10 million for principal member and dependants","hospitalCoverAids":"100% Scheme Rate\\nSubject to pre-auth and DSP","artTtreatment":"See above for details","preventative":"�Preventative care\\nFlu vaccines\\nPneumonia vaccines\\nTravel vaccines\\nPaediatric immunisations\\nContraceptives - R2 412 per beneficiary\\nBack and neck preventative programme\\nPreventative dentistry\\nMammogram\\nPSA screening\\nHPV vaccinations\\nPap smear\\n\\nTempo Wellness Programme\\nBestmed Tempo Health which includes:\\n- The Bestmed Tempo lifestyle questionnaire\\n- Blood pressure check\\n- Cholesterol check\\n- Glucose check\\n- HIV screening\\n- Height, weight and waist circumference\\n\\n","logo":"bestmed.jpg"},{"company":"Bestmed","name":"Pace 2","planType":"Hybrid option","coverLevel":"Mid","hospital":"Any","chronic":"Network","serviceType":"Network","familyIncome":"N/A","mainContribution":"R5182","mainCompSavings":"R844","mainTotal":"R6026","dependendContributionAdult":"R5082","dependentCompSavingsAdult":"R827","dependentTotalAdult":"R5909","dependendContributionChild":"R1143","dependentCompSavingsChild":"R186","dependentTotalChild":"R1329","maxChildContribution":"3","mainThreshold":"","dependentThresholdAdult":"","dependentThresholdChild":"","preferedHospitalProvider":"Any hospital","overallLimit":"None","coPayment":"None","rate":"100% Scheme Rate","generalMedicin":"7 days' supply","specialist":"100% Scheme Rate","dentistSurgical":"Maxillo facial and oral surgery \\n100% Scheme Rate, unlimited\\n(strictly related to certain conditions)\\nDental and oral surgery (In or out-of-hospital) R13 982 per family","mentalHealth":"                        \\n21 days per beneficiary \\nTreatment of chemical & substance abuse:\\n � 21 days or R33 655 per beneficiary\\nSubject to network facilities\\n","radiology":"In Hospital: 100% Scheme Rate\\nOut of Hospital: Savings then \\nM: R3 402 M+: R6 806 \\n(subject to overall day-to-day limit)","pathology":"In Hospital: 100% Scheme Rate\\nOut of Hospital: Shared limit with Radiology ","maternityBenefit":"In-Hospital: 100% Scheme Rate\\nMidwife-assisted births: 100% Scheme Rate\\nOut-of-Hospital: 100% Scheme Rate\\n� 9 consults at GP/gynae/midwife\\n� Antenatal supplements\\n� 1x post-natal consultation at GP/Midwife/ Gynaecologist\\n� 1x lactation consultation at registered\\nnurse or lactation specialist\\n� 2 x 2D scans per pregnancy\\n� 3 baby growth and development\\nassessments per year for children 0-2 years\\n ","dialysis":"Subject to pre-authorisation and DSPs","cancer":"100% Scheme Rate, DSP applies\\nMammary surgery:\\nR38 294 for symmetrising surgery\\nSubject to pre-auth ","transplant":"PMBs only","mri":"In Hospital: 100% Scheme Rate, unlimited\\nOut of Hospital: Max of 3 per beneficiary\\nPET scan: 1 scan per beneficiary ","prosthesisInternal":"Subject to preferred provider \\nR120 762 per family  \\n� Sub-limits per beneficiary\\nFunctional: R18 374\\nVascular: R45 286\\nSpinal including artificial disc: R60 542\\nDrug-eluting stents: R19 797\\nPacemaker: R65 268\\nMesh: R19 797\\nGynaecology/Urology: R14 786 per type\\nLens implants: R12 695 per lens\\nJoint Replacements: Hip prosthesis and other major joints: R54 380\\nKnee replacement: R63 103\\nMinor joints: R23 447\\n","prosthesisExternal":"External Prosthesis: R28 458 per family\\nApparatus and appliances: R10 888 per family, savings first ten day to-day limit\\n- Wheelchairs: R14 725 per family every 4 yrs.\\n- Hearing Aids: R30 005 per beneficiary every 2 years, Subject to quotation, motivation and audiogram. ","rehab":"Alternatives to hospitalisation, unlimited                                                               \\nRehabilitation after trauma: unlimited\\nWound care: Savings first, then limited to       R7 176 per family (subject to overall day-to-day limit)\\nPalliative care and Home-based care: \\nR120 000 per beneficiary per annum. Subject to pre-auth and treatment plan","designatedServiceProvider":"Yes","conditionsCovered":"CDL in PMB + 20 conditions","formulary":"Yes, 20% co-payment for non-formulary medicines","partialLimits":"\\nNon-CDL chronic medicine: 90% of Scheme Rate: Limited to M : R9 528, M1+: R19 055\\nCo-payment of 20% for non-formulary medicine \\nBiologicals and other high-cost medicine: R173 110 per beneficiary\\n","preferredProvider":"yes","overallAnualLimit":"M : R16 036, M1+: R32 071","medicationOverCounter":"R1 000 OR access to full savings for OTC\\npurchases (after R1 000 limit), self- payment gap accumulation\\nSubject to available savings","medicationPrescribed":"Savings first,(Subject to day-to-day limit)\\nLimited to M : R5 074, M1 +: R10 146\\n\\n ","practitionersGeneral":"Savings first       \\nLimited to M : R4 579, M1+: R9 280\\n(Subject to day-to-day limit)\\nDiabetes primary care consultation: Subject to registration with HaloCare \\n2 consultations at Dis-Chem Pharmacies. First paid from GP and specialist limits, thereafter Risk ","specialistsCover":"Shared limit with GP benefits","dentistryCover":"Shared limit with Specialised dentistry","dentistryCoverSpecial":"Shared limit with conservative dentistry \\nSavings and then from day-to-day limits\\nLimited to M : R7 217, M1+ : R14 433\\nOrthodontic: subject to pre-authorisation\\nLimited to R7 000 per event\\n(for beneficiaries up to 18 years of age)","optical":"Benefits available every 2 years\\nNetwork Provider(PPN) \\n� Consultation: 1 per beneficiary\\n� Frame: R990\\n� Lenses 100% cost \\n(single-vision/bifocal/ multifocal or\\n� Lenses enhancement: R750 OR\\nContact lenses: R1 880 OR\\nNon-network Provider\\n� Consultation: R350\\n� Frame: R598 and\\n� Single-vision lenses: R210 OR\\n� Bifocal lenses: R445 OR\\n� Multifocal lenses: R1 000  OR\\n� Contact lenses: R1 880\\nRefractive surgery: R9 774 per eye\\n \\n","ambulance":"Rendered and pre-authorised by ER24","international":"Leisure Travel: 45 days and R500 000 cover for travel to the USA. All other countries covered up to 90 days,R5 million per member and R10 million for principal member and dependants \\nBusiness Travel: 45 days and R500 000 cover for travel to the USA. All other countries covered up to 45 days, R5 million per member and R10 million for principal member and dependants","hospitalCoverAids":"100% Scheme Rate\\nSubject to pre-auth and DSP","artTtreatment":"See above for details","preventative":"�Preventative care\\nFlu vaccines\\nPneumonia vaccines\\nTravel vaccines\\nPaediatric immunisations\\nContraceptives - R2 412 per beneficiary\\nBack and neck preventative programme\\nPreventative dentistry\\nMammogram\\nPSA screening\\nHPV vaccinations\\nBone densitometry\\nPap smear\\nTempo Wellness Programme\\nBestmed Tempo Health which includes:\\n- The Bestmed Tempo lifestyle questionnaire\\n- Blood pressure check\\n- Cholesterol check\\n- Glucose check\\n- HIV screening\\n- Height, weight and waist circumference\\n\\n","logo":"bestmed.jpg"},{"company":"Bestmed","name":"Pace 3","planType":"Hybrid option","coverLevel":"Mid","hospital":"Any","chronic":"Network","serviceType":"Network","familyIncome":"N/A","mainContribution":"R5949","mainCompSavings":"R969","mainTotal":"R6918","dependendContributionAdult":"R4789","dependentCompSavingsAdult":"R780","dependentTotalAdult":"R5569","dependendContributionChild":"R1023","dependentCompSavingsChild":"R167","dependentTotalChild":"R1190","maxChildContribution":"3","mainThreshold":"","dependentThresholdAdult":"","dependentThresholdChild":"","preferedHospitalProvider":"Any hospital","overallLimit":"None","coPayment":"None","rate":"100% Scheme Rate","generalMedicin":"7 days' supply","specialist":"100% Scheme Rate","dentistSurgical":"Maxillo facial and oral surgery \\n100% Scheme Rate, unlimited\\n(strictly related to certain conditions)\\nDental and oral surgery (In or out-of-hospital) R17 570 per family","mentalHealth":"                        \\n21 days per beneficiary \\nTreatment of chemical & substance abuse:\\n � 21 days or R33 655 per beneficiary\\nSubject to network facilities\\n","radiology":"In Hospital: 100% Scheme Rate\\nOut of Hospital: Savings then \\nM: M = R3 712 M+: R6 806 \\n(subject to overall day-to-day limit)","pathology":"In Hospital: 100% Scheme Rate\\nOut of Hospital: Shared limit with Radiology ","maternityBenefit":"In-Hospital: 100% Scheme Rate\\nMidwife-assisted births: 100% Scheme Rate\\nOut-of-Hospital: 100% Scheme Rate\\n� 9 consults at GP/gynae/midwife\\n� Antenatal supplements\\n� 1x post-natal consultation at GP/Midwife/ Gynaecologist\\n� 1x lactation consultation at registered\\nnurse or lactation specialist\\n� 2 x 2D scans per pregnancy\\n� 3 baby growth and development\\nassessments per year for children 0-2 years\\n ","dialysis":"Subject to pre-authorisation and DSPs","cancer":"100% Scheme Rate, DSP applies. Access\\nto extended protocols\\nMammary surgery:\\nR38 294 for symmetrising surgery\\nSubject to pre-auth ","transplant":"PMBs only","mri":"In Hospital: 100% Scheme Rate, unlimited\\nOut of Hospital: Max of 3 per beneficiary\\nPET scan: 1 scan per beneficiary ","prosthesisInternal":"Subject to preferred provider \\nR121 381 per family\\n� Sub-limits per beneficiary\\nFunctional: R19 797\\nVascular: R45 410\\nSpinal including artificial disc: R60 657 \\nDrug-eluting stents: R19 797\\nPacemaker: R65 268\\nMesh: R19 797\\nGynaecology/Urology: R14 848 per type\\nLens implants: R12 695 per lens\\nJoint Replacements: Hip prosthesis and other major joints: R52 442\\nKnee replacement: R63 413\\nMinor joints: R23 447\\n","prosthesisExternal":"External Prosthesis: R28 583 per family\\nApparatus and appliances: R10 888 per family, savings first ten day to-day limit\\n- Wheelchairs: R14 725 per family every 4 years\\n- Hearing Aids: R33 779 per beneficiary every 2 years, Subject to quotation, motivation and audiogram. ","rehab":"Alternatives to hospitalisation, unlimited                                                               \\nRehabilitation after trauma: unlimited\\nWound care: Savings first, then limited to      R11 136 per family (subject to overall day-to-day limit)\\nPalliative care and Home-based care: \\nR120 000 per beneficiary per annum. Subject to pre-auth and treatment plan","designatedServiceProvider":"Yes","conditionsCovered":"CDL in PMB + 20 conditions","formulary":"Yes, 15% co-payment for non-formulary medicines","partialLimits":"\\nNon-CDL chronic medicine: 90% of Scheme Rate: Limited to M : R15 368, M1+: R30 735 Co-payment of 15% for non-formulary medicine \\nBiologicals and other high-cost medicine: R346 449 per beneficiary\\n","preferredProvider":"yes","overallAnualLimit":"M : R20 045, M1+: R41 425","medicationOverCounter":"R1 000 OR access to full savings for OTC\\npurchases (after R1 000 limit), self- payment gap accumulation\\nSubject to available savings","medicationPrescribed":"Savings first,(Subject to day-to-day limit)\\nLimited to M : R1 609, M1 +: R3 960\\n\\n ","practitionersGeneral":"Savings first       \\nLimited to M: R4 579, M1+: R9 280\\n(Subject to day-to-day limit)\\nDiabetes primary care consultation: Subject to registration with HaloCare \\n2 consultations at Dis-Chem Pharmacies. First paid from GP and specialist limits, thereafter Risk ","specialistsCover":"Shared limit with GP benefits","dentistryCover":"Shared limit with Specialised dentistry","dentistryCoverSpecial":"Shared limit with conservative dentistry \\nSavings and then from day-to-day limits\\nLimited to M : R7 776, M1+ : R14 497\\nOrthodontic: subject to pre-authorisation\\nLimited to R9 000 per event\\n(for beneficiaries up to 18 years of age)","optical":"Benefits available every 2 years\\nNetwork Provider(PPN) \\n� Consultation: 1 per beneficiary\\n� Frame: R990\\n� Lenses 100% cost \\n(single-vision/bifocal/ multifocal or                              � Lenses enhancement: R750                                  \\nContact lenses: R1 880 OR\\nNon-network Provider\\n� Consultation: R350\\n� Frame: R598 and\\n� Single-vision lenses: R210 OR\\n� Bifocal lenses: R445 OR\\n� Multifocal lenses: R1 000  OR\\n� Contact lenses: R1 880\\nRefractive surgery: R10 518 per eye\\n \\n","ambulance":"Rendered and pre-authorised by ER24","international":"Leisure Travel: 45 days and R500 000 cover for travel to the USA. All other countries covered up to 90 days,R5 million per member and R10 million for principal member and dependants \\nBusiness Travel: 45 days and R500 000 cover for travel to the USA. All other countries covered up to 45 days, R5 million per member and R10 million for principal member and dependants","hospitalCoverAids":"100% Scheme Rate\\nSubject to pre-auth and DSP","artTtreatment":"See above for details","preventative":"�Preventative care\\nFlu vaccines\\nPneumonia vaccines\\nTravel vaccines\\nPaediatric immunisations\\nContraceptives - R2 412 per beneficiary\\nBack and neck preventative programme\\nPreventative dentistry\\nMammogram\\nPSA screening\\nHPV vaccinations\\nBone densitometry\\nPap smear\\nTempo Wellness Programme\\nBestmed Tempo Health which includes:\\n- The Bestmed Tempo lifestyle questionnaire\\n- Blood pressure check\\n- Cholesterol check\\n- Glucose check\\n- HIV screening\\n- Height, weight and waist circumference\\n\\n","logo":"bestmed.jpg"},{"company":"Bestmed","name":"Pace 4","planType":"Hybrid option","coverLevel":"High","hospital":"Any","chronic":"Any","serviceType":"Any","familyIncome":"N/A","mainContribution":"R8383","mainCompSavings":"R259","mainTotal":"R8642","dependendContributionAdult":"R8383","dependentCompSavingsAdult":"R259","dependentTotalAdult":"R8642","dependendContributionChild":"R1964","dependentCompSavingsChild":"R61","dependentTotalChild":"R2025","maxChildContribution":"3","mainThreshold":"","dependentThresholdAdult":"","dependentThresholdChild":"","preferedHospitalProvider":"Any hospital","overallLimit":"Unlimited","coPayment":"None","rate":"100% Scheme Rate","generalMedicin":"7 days' supply per event","specialist":"100% Scheme Rate","dentistSurgical":"Maxillo facial and oral surgery: unlimited \\n(strictly related to certain conditions)\\nDental and oral surgery(In or out-of-hospital): R21 034 per family","mentalHealth":"                        \\n21 days per beneficiary \\nTreatment of chemical & substance abuse:\\n � 21 days or R33 655 per beneficiary\\nSubject to network facilities\\n","radiology":"In Hospital: 100% Scheme Rate\\nOut of Hospital: M: M = R5 877 M+: R11 569 \\n(subject to overall day-to-day limit)","pathology":"In Hospital: 100% Scheme Rate\\nOut of Hospital: Shared limit with Radiology ","maternityBenefit":"In-Hospital: 100% Scheme Rate\\nMidwife-assisted births: 100% Scheme Rate\\nOut-of-Hospital: \\n� 9 consults at GP/gynae/midwife\\n� Antenatal supplements - limited to R120\\n� 1x postnatal consultation at GP/Midwife/ Gynaecologist\\n� 1x lactation consultation at registered\\nnurse or lactation specialist\\n� 2 x 2D scans per pregnancy\\n� 3 baby growth and development\\nassessments per year for children 0-2 years\\n ","dialysis":"100% Scheme Rate. Subject to pre-authorisation and DSPs","cancer":"100% Scheme Rate, DSP applies. Access\\nto extended protocols\\nMammary surgery:\\nR38 294 for symmetrising surgery\\nSubject to pre-auth ","transplant":"100% Scheme Rate: Unlimited\\nSubject to pre-auth & protocols","mri":"In Hospital: 100% Scheme Rate, unlimited\\nOut of Hospital: Max of 3 per beneficiary\\nPET scan: 1 scan per beneficiary ","prosthesisInternal":"Subject to preferred provider \\nR140 064 per family\\n� Sub-limits per beneficiary:\\nFunctional: R20 539\\nVascular: R51 967\\nSpinal including artificial disc: R70 038\\nDrug-eluting stents: R23 324\\nPacemaker: R65 268\\nMesh: R20 539\\nGynaecology/Urology: R16 952 per type\\nLens implants: R18 770 per lens\\nJoint Replacements: Hip prosthesis and other major joints: R62 670\\nKnee replacement: R72 569\\nMinor joints: R23 324\\n","prosthesisExternal":"External Prosthesis: R32 295 per family\\nAppliances : Subject to day-to-day limit R10 450 per family, \\n-Wheelchairs: R14 725 per family, every 4 years, - Hearing Aids: R37 614 per beneficiary, every 2 years. Subject to quotation,\\nmotivation and audiogram. ","rehab":"Alternatives to hospitalisation, unlimited\\nRehabilitation after trauma, unlimited\\nWound care: R14 353 per family\\nPalliative care and Home-based care: \\nR120 000 per beneficiary per annum. Subject to pre-auth and treatment plan","designatedServiceProvider":"Yes","conditionsCovered":"CDL in PMB + 28 conditions","formulary":"Yes, 10% co-payment for non-formulary medicines","partialLimits":"Non-CDL chronic medicine: 100% of Scheme Rate: Limited to M : R20 724, M1+: R41 636 Co-payment of 10% for non-formulary medicine \\nBiologicals and other high-cost medicine: R512 744 per beneficiary\\n","preferredProvider":"None","overallAnualLimit":"M : R37 367, M1+: R60 258","medicationOverCounter":"Subject to available Savings ","medicationPrescribed":"\\nSubject to day-to-day limit\\nLimited to M : R9 280, M1+ : R14 415\\n10% co-payment applies\\n","practitionersGeneral":"\\nSubject to day-to-day limit\\nLimited to M : R5 877, M1+: R9 528\\nDiabetes primary care consultation: Subject to registration with HaloCare.\\n2 consultations at Dis-Chem Pharmacies. First paid from GP and specialist limits, thereafter Risk \\n","specialistsCover":"Shared limit with GP benefits","dentistryCover":"Shared limit with Specialised dentistry","dentistryCoverSpecial":"\\nSubject to day-to-day limit\\nLimited to M : R12 977, M1+ : R21 903\\nOrthodontic: subject to pre-authorisation\\nLimited to R11 000 per event\\n(for beneficiaries up to 18 years of age)\\n\\n","optical":"Benefits available every 2 years\\nNetwork Provider(PPN) \\n� Consultation: 1 per beneficiary\\n� Frame: R990\\n� Lenses 100% cost \\n(single-vision/bifocal/ multifocal and\\n� Lenses enhancement: R750 OR\\nContact lenses: R2 220 OR\\nNon-network Provider\\n� Consultation: R350\\n� Frame: R598 and\\n� Single-vision lenses: R210 OR\\n� Bifocal lenses: R445 OR\\n� Multifocal lenses: R1 000 OR\\n� Contact lenses: R2 220\\nRefractive surgery: R10 518 per eye\\n \\n","ambulance":"Rendered and pre-authorised by ER24","international":"Leisure Travel: 45 days and R500 000 cover for travel to the USA. All other countries covered up to 90 days,R5 million per member and R10 million for principal member and dependants \\nBusiness Travel: 45 days and R500 000 cover for travel to the USA. All other countries covered up to 45 days, R5 million per member and R10 million for principal member and dependants","hospitalCoverAids":"100% of Scheme Rate\\nSubject to pre-auth and DSP","artTtreatment":"See above for details","preventative":"�Preventative care\\nFlu vaccines\\nPneumonia vaccines\\nTravel vaccines\\nPaediatric immunisations\\nContraceptives - R2 412 per beneficiary\\nBack and neck preventative programme\\nPreventative dentistry\\nMammogram\\nPSA screening\\nHPV vaccinations\\nBone densitometry\\nPap smear\\nTempo Wellness Programme\\nBestmed Tempo Health which includes:\\n- The Bestmed Tempo lifestyle questionnaire\\n- Blood pressure check\\n- Cholesterol check\\n- Glucose check\\n- HIV screening\\n- Height, weight and waist circumference\\n\\n","logo":"bestmed.jpg"},{"company":"Bestmed","name":"Pulse 1","planType":"Traditional","coverLevel":"Low","hospital":"Network","chronic":"Network","serviceType":"Network","familyIncome":"R0 -R5500 pm","mainContribution":"R1760","mainCompSavings":"R0.00","mainTotal":"R1760","dependendContributionAdult":"R1673","dependentCompSavingsAdult":"R0.00","dependentTotalAdult":"R1673","dependendContributionChild":"R1059","dependentCompSavingsChild":"R0.00","dependentTotalChild":"R1059","maxChildContribution":"","mainThreshold":"","dependentThresholdAdult":"","dependentThresholdChild":"","preferedHospitalProvider":"DSP-Netcare, Pulse Specialist DSP network\\nR12 373 per event for voluntary use of a non-\\nDSP hospital","overallLimit":"Unlimited","coPayment":"No co-payment","rate":"100% Scheme Rate","generalMedicin":"Limited to 3 days","specialist":"100% Scheme Rate","dentistSurgical":"No Benefit","mentalHealth":"Limited to 21 days per beneficiary\\nTreatment of chemical or substance abuse: PMB level of care, 21 days per beneficiary ","radiology":"100% Scheme Rate","pathology":"100% Scheme Rate","maternityBenefit":"Midwife-assisted births: 100% Scheme Rate\\nOut-of-Hospital: 100% Scheme Rate\\n� 9 consults at GP/gynae/midwife\\n� Iron and folic acid supplements (9 fills)\\n� 1 x post-natal consultation at GP/Midwife/Gynae\\n� 3 baby growth and development assessments per year for children 0-2 years\\n� Two 2D scans per pregnancy\\n ","dialysis":"Subject to pre-authorisation and DSPs","cancer":"100% of Scheme Rate\\nSubject to oncology programme, pre-authorisation and DSPs","transplant":"PMBs only","mri":"In Hospital: 100% Scheme Rate, unlimited\\nOut of Hospital: PMB only\\n","prosthesisInternal":"\\nR55 309  per family - subject to preferred provider\\nSub-limits per beneficiary\\nFunctional  R11 755\\nPacemaker (dual chamber) R44 791\\nSpinal / Vascular R27 406\\nMesh R10 023\\nGynaecology/urology R8 278\\nLens implants R5 755 per lens per eye\\n                                 \\nExclusions\\n(Joint replacement surgery (except for PMBs)\\nPMBs subject to prosthesis limits:\\nHip replacement and other major joints:\\nR28 088, Knee replacement R35 512\\nMinor joints R13 301\\n                                                             ","prosthesisExternal":"External Prosthesis : PMBs only\\nGeneral appliances: No benefit\\nOrthopaedic and medical appliances: \\n -  R6 806per family","rehab":"Alternatives to hospitalisation\\n100% Scheme Rate                                                                                \\nPalliative care and Home-based care: \\nR60 000 per beneficiary per annum. Subject to pre-auth and treatment plan","designatedServiceProvider":"Yes , 30% co-payment for non-formulary medicines","conditionsCovered":"CDL in PMB ","formulary":"Yes","partialLimits":"30% co-payment for non-formulary medicines\\nBiological medicine during hospitalisation:\\nR15 000 per family","preferredProvider":"DSP","overallAnualLimit":"N/A","medicationOverCounter":"\\nR600 per family\\n","medicationPrescribed":"100% Scheme Rate\\n(Subject to Scheme formulary)","practitionersGeneral":"Network GPs: unlimited  \\nDiabetes primary care consultation: subject to registration with HaloCare : 2 consultations at Dis-Chem Pharmacies\\nCasualty and out-of-network GP visits:           \\n- R1 485 per family                        \\n","specialistsCover":"\\nReferred by Network GP. Subject to Network Specialist DSP network\\nLimited to M : R1 500, M1+ : R2 500 \\n","dentistryCover":"Subject to  Dental Network Providers\\n","dentistryCoverSpecial":"No benefit","optical":"Benefits available every 2 years\\nNetwork Provider(PPN) \\n� Consultation: only at PPN \\n� Frame, R235 AND\\n� Single vision lenses R210 OR\\n� Bifocal lenses R445 OR\\n� Contact lenses : R655 \\n","ambulance":"Rendered and pre-authorised by ER24","international":"Leisure Travel: 45 days and R500 000 cover for travel to the USA. All other countries covered up to 90 days,R5 million per member and R10 million for principal member and dependants \\nBusiness Travel: 45 days and R500 000 cover for travel to the USA. All other countries covered up to 45 days, R5 million per member and R10 million for principal member and dependants","hospitalCoverAids":"PMBs only at DSP","artTtreatment":"See above for details","preventative":"�Preventative care\\nFlu vaccines\\nPneumonia vaccines\\nTravel vaccines\\nPaediatric immunisations\\nContraceptives - R2 412 per beneficiary\\nBack and neck preventative programme\\nMammogram\\nPSA screening\\nHPV vaccinations\\nPap smear\\nTempo Wellness Programme\\nBestmed Tempo Health which includes:\\n- The Bestmed Tempo lifestyle questionnaire\\n- Blood pressure check\\n- Cholesterol check\\n- Glucose check\\n- HIV screening\\n- Height, weight and waist circumference\\n\\n","logo":"bestmed.jpg"},{"company":"Bestmed","name":"Pulse 1","planType":"Capitation","coverLevel":"Low","hospital":"Network","chronic":"Network","serviceType":"Network","familyIncome":"R5501-R8500 pm","mainContribution":"R2114","mainCompSavings":"R0.00","mainTotal":"R2114","dependendContributionAdult":"R2009","dependentCompSavingsAdult":"R0.00","dependentTotalAdult":"R2009","dependendContributionChild":"R1269","dependentCompSavingsChild":"R0.00","dependentTotalChild":"R1269","maxChildContribution":"","mainThreshold":"","dependentThresholdAdult":"","dependentThresholdChild":"","preferedHospitalProvider":"DSP-Netcare, Pulse Specialist DSP network\\nR12 373 per event for voluntary use of a non-\\nDSP hospital","overallLimit":"Unlimited","coPayment":"No co-payment","rate":"100% Scheme Rate","generalMedicin":"Limited to 3 days","specialist":"100% Scheme Rate","dentistSurgical":"No Benefit","mentalHealth":"Limited to 21 days per beneficiary\\nTreatment of chemical or substance abuse: PMB level of care, 21 days per beneficiary ","radiology":"100% Scheme Rate","pathology":"100% Scheme Rate","maternityBenefit":"Midwife-assisted births: 100% Scheme Rate\\nOut-of-Hospital: 100% Scheme Rate\\n� 9 consults at GP/gynae/midwife\\n� Iron and folic acid supplements (9 fills)\\n� 1 x post-natal consultation at GP/Midwife/Gynae\\n� 3 baby growth and development assessments per year for children 0-2 years\\n� Two 2D scans per pregnancy\\n ","dialysis":"Subject to pre-authorisation and DSPs","cancer":"100% of Scheme Rate\\nSubject to oncology programme, pre-authorisation and DSPs","transplant":"PMBs only","mri":"In Hospital: 100% Scheme Rate, unlimited\\nOut of Hospital: PMB only\\n","prosthesisInternal":"\\nR55 309  per family - subject to preferred provider\\nSub-limits per beneficiary\\nFunctional  R11 755\\nPacemaker (dual chamber) R44 791\\nSpinal / Vascular R27 406\\nMesh R10 023\\nGynaecology/urology R8 278\\nLens implants R5 755 per lens per eye\\n                                 \\nExclusions\\n(Joint replacement surgery (except for PMBs)\\nPMBs subject to prosthesis limits:\\nHip replacement and other major joints:\\nR28 088, Knee replacement R35 512\\nMinor joints R13 301\\n                                                             ","prosthesisExternal":"External Prosthesis : PMBs only\\nGeneral appliances: No benefit\\nOrthopaedic and medical appliances: \\n -  R6 806per family","rehab":"Alternatives to hospitalisation\\n100% Scheme Rate                                                                                \\nPalliative care and Home-based care: \\nR60 000 per beneficiary per annum. Subject to pre-auth and treatment plan","designatedServiceProvider":"Yes , 30% co-payment for non-formulary medicines","conditionsCovered":"CDL in PMB ","formulary":"Yes","partialLimits":"30% co-payment for non-formulary medicines\\nBiological medicine during hospitalisation:\\nR15 000 per family","preferredProvider":"DSP","overallAnualLimit":"N/A","medicationOverCounter":"\\nR600 per family\\n","medicationPrescribed":"100% Scheme Rate\\n(Subject to Scheme formulary)","practitionersGeneral":"Network GPs: unlimited  \\nDiabetes primary care consultation: subject to registration with HaloCare : 2 consultations at Dis-Chem Pharmacies\\nCasualty and out-of-network GP visits:           \\n- R1 485 per family                        \\n","specialistsCover":"\\nReferred by Network GP. Subject to Network Specialist DSP network\\nLimited to M : R1 500, M1+ : R2 500 \\n","dentistryCover":"Subject to  Dental Network Providers\\n","dentistryCoverSpecial":"No benefit","optical":"Benefits available every 2 years\\nNetwork Provider(PPN) \\n� Consultation: only at PPN \\n� Frame, R235 AND\\n� Single vision lenses R210 OR\\n� Bifocal lenses R445 OR\\n� Contact lenses : R655 \\n","ambulance":"Rendered and pre-authorised by ER24","international":"Leisure Travel: 45 days and R500 000 cover for travel to the USA. All other countries covered up to 90 days,R5 million per member and R10 million for principal member and dependants \\nBusiness Travel: 45 days and R500 000 cover for travel to the USA. All other countries covered up to 45 days, R5 million per member and R10 million for principal member and dependants","hospitalCoverAids":"PMBs only at DSP","artTtreatment":"See above for details","preventative":"�Preventative care\\nFlu vaccines\\nPneumonia vaccines\\nTravel vaccines\\nPaediatric immunisations\\nContraceptives - R2 412 per beneficiary\\nBack and neck preventative programme\\nMammogram\\nPSA screening\\nHPV vaccinations\\nPap smear\\nTempo Wellness Programme\\nBestmed Tempo Health which includes:\\n- The Bestmed Tempo lifestyle questionnaire\\n- Blood pressure check\\n- Cholesterol check\\n- Glucose check\\n- HIV screening\\n- Height, weight and waist circumference\\n\\n","logo":"bestmed.jpg"},{"company":"Bestmed","name":"Pulse 1","planType":"Capitation","coverLevel":"Low","hospital":"Network","chronic":"Network","serviceType":"Network","familyIncome":">R8500","mainContribution":"R2597","mainCompSavings":"R0.00","mainTotal":"R2597","dependendContributionAdult":"R2284","dependentCompSavingsAdult":"R0.00","dependentTotalAdult":"R2284","dependendContributionChild":"R1269","dependentCompSavingsChild":"R0.00","dependentTotalChild":"R1269","maxChildContribution":"","mainThreshold":"","dependentThresholdAdult":"","dependentThresholdChild":"","preferedHospitalProvider":"DSP-Netcare, Pulse Specialist DSP network\\nR12 373 per event for voluntary use of a non-\\nDSP hospital","overallLimit":"Unlimited","coPayment":"No co-payment","rate":"100% Scheme Rate","generalMedicin":"Limited to 3 days","specialist":"100% Scheme Rate","dentistSurgical":"No Benefit","mentalHealth":"Limited to 21 days per beneficiary\\nTreatment of chemical or substance abuse: PMB level of care, 21 days per beneficiary ","radiology":"100% Scheme Rate","pathology":"100% Scheme Rate","maternityBenefit":"Midwife-assisted births: 100% Scheme Rate\\nOut-of-Hospital: 100% Scheme Rate\\n� 9 consults at GP/gynae/midwife\\n� Iron and folic acid supplements (9 fills)\\n� 1 x post-natal consultation at GP/Midwife/Gynae\\n� 3 baby growth and development assessments per year for children 0-2 years\\n� Two 2D scans per pregnancy\\n ","dialysis":"Subject to pre-authorisation and DSPs","cancer":"100% of Scheme Rate\\nSubject to oncology programme, pre-authorisation and DSPs","transplant":"PMBs only","mri":"In Hospital: 100% Scheme Rate, unlimited\\nOut of Hospital: PMB only\\n","prosthesisInternal":"\\nR55 309  per family - subject to preferred provider\\nSub-limits per beneficiary\\nFunctional  R11 755\\nPacemaker (dual chamber) R44 791\\nSpinal / Vascular R27 406\\nMesh R10 023\\nGynaecology/urology R8 278\\nLens implants R5 755 per lens per eye\\n                                 \\nExclusions\\n(Joint replacement surgery (except for PMBs)\\nPMBs subject to prosthesis limits:\\nHip replacement and other major joints:\\nR28 088, Knee replacement R35 512\\nMinor joints R13 301\\n                                                             ","prosthesisExternal":"External Prosthesis : PMBs only\\nGeneral appliances: No benefit\\nOrthopaedic and medical appliances: \\n -  R6 806per family","rehab":"Alternatives to hospitalisation\\n100% Scheme Rate                                                                                \\nPalliative care and Home-based care: \\nR60 000 per beneficiary per annum. Subject to pre-auth and treatment plan","designatedServiceProvider":"Yes , 30% co-payment for non-formulary medicines","conditionsCovered":"CDL in PMB ","formulary":"Yes","partialLimits":"30% co-payment for non-formulary medicines\\nBiological medicine during hospitalisation:\\nR15 000 per family","preferredProvider":"DSP","overallAnualLimit":"N/A","medicationOverCounter":"\\nR600 per family\\n","medicationPrescribed":"100% Scheme Rate\\n(Subject to Scheme formulary)","practitionersGeneral":"Network GPs: unlimited  \\nDiabetes primary care consultation: subject to registration with HaloCare : 2 consultations at Dis-Chem Pharmacies\\nCasualty and out-of-network GP visits:           \\n- R1 485 per family                        \\n","specialistsCover":"\\nReferred by Network GP. Subject to Network Specialist DSP network\\nLimited to M : R1 500, M1+ : R2 500 \\n","dentistryCover":"Subject to  Dental Network Providers\\n","dentistryCoverSpecial":"No benefit","optical":"Benefits available every 2 years\\nNetwork Provider(PPN) \\n� Consultation: only at PPN \\n� Frame, R235 AND\\n� Single vision lenses R210 OR\\n� Bifocal lenses R445 OR\\n� Contact lenses : R655 \\n","ambulance":"Rendered and pre-authorised by ER24","international":"Leisure Travel: 45 days and R500 000 cover for travel to the USA. All other countries covered up to 90 days,R5 million per member and R10 million for principal member and dependants \\nBusiness Travel: 45 days and R500 000 cover for travel to the USA. All other countries covered up to 45 days, R5 million per member and R10 million for principal member and dependants","hospitalCoverAids":"PMBs only at DSP","artTtreatment":"See above for details","preventative":"�Preventative care\\nFlu vaccines\\nPneumonia vaccines\\nTravel vaccines\\nPaediatric immunisations\\nContraceptives - R2 412 per beneficiary\\nBack and neck preventative programme\\nMammogram\\nPSA screening\\nHPV vaccinations\\nPap smear\\nTempo Wellness Programme\\nBestmed Tempo Health which includes:\\n- The Bestmed Tempo lifestyle questionnaire\\n- Blood pressure check\\n- Cholesterol check\\n- Glucose check\\n- HIV screening\\n- Height, weight and waist circumference\\n\\n","logo":"bestmed.jpg"},{"company":"Bonitas","name":"BonCap","planType":"Capitation","coverLevel":"Low","hospital":"Network","chronic":"Network","serviceType":"Network","familyIncome":"R0 -R9430 pm","mainContribution":"R1274","mainCompSavings":"R0.00","mainTotal":"R1274","dependendContributionAdult":"R1274","dependentCompSavingsAdult":"R0.00","dependentTotalAdult":"R1274","dependendContributionChild":"R600","dependentCompSavingsChild":"R0.00","dependentTotalChild":"R600","maxChildContribution":"10","mainThreshold":"","dependentThresholdAdult":"","dependentThresholdChild":"","preferedHospitalProvider":"\\nBonCap Network\\n","overallLimit":"Unlimited","coPayment":"R10 390 co-payment for use of non-network hospital\\n\\nDay surgery procedures: R10 390 co-payment if day-hospital network is not used\\n\\nOncology & Kidney Dialysis: 20% co-payment for use of a non-network facility\\n\\nCataract Surgery: R6 230 co-payment for use of non-DSP network","rate":"100% Scheme Rate ","generalMedicin":"7 days' supply up to R420 �per admission","specialist":"Unlimited, 100% of Scheme Rate","dentistSurgical":"100% of BR\\n(Maxillo-facial surgery: dental chair), PMB only\\nIn-hospital dental surgery - no benefit","mentalHealth":"\\nPMB only at DSP \\nR10 390 co-payment for use of non-DSP network\\nNo cover for physiotherapy for mental health admissions\\n ","radiology":"Unlimited, 100% of Scheme Rate","pathology":"R27 880 per family except for PMB","maternityBenefit":"In-hospital: 100% BR\\n(Includes midwifery services)\\n\\nOut-of-hospital: 100% BR\\n� Antenatal visits subject to GP and specialist consultations benefits\\n� 4 postnatal midwife consultations. 1 visit can be used with a lactation specialist\\n� 2 x 2D scans\\n� Online antenatal classes\\n� Hearing screening for newborns\\n� 24/7 telephonic baby advice line\\n� Congenital hypothyroidism screening for infants below 1 month \\n\\n ","dialysis":"Unlimited at a DSP \\n20% co-payment applies at a non-DSP","cancer":"PMB at DSP\\n20% co-payment applies at a non-DSP\\nPalliative care: unlimited","transplant":"PMB at DSP","mri":"In-hospital: R12 720 per family, with R1 040 co-payment\\nOut-of-hospital: Included in Specialist consultation limit, pre-auth required","prosthesisInternal":"\\nPMB only, at a preferred provider\\nPre-authorisation required\\n","prosthesisExternal":"External Prosthesis: PMBs only\\nGeneral appliances: R5 960 per family at preferred supplier","rehab":"Physical Rehabilitation: \\nR54 360 per family\\nAlternatives to hospitalisation:\\nR15 660 per family","designatedServiceProvider":"Pharmacy Direct\\n40% co-payment for use of non-formulary non-DSP","conditionsCovered":"26 CDL conditions ","formulary":"Yes","partialLimits":"None","preferredProvider":"Bonitas GP Network and Bonitas Specialist Network are the Scheme's DSPs","overallAnualLimit":"None","medicationOverCounter":"\\nR100 per event, maximum of R 280 per beneficiary\\n","medicationPrescribed":"\\nCombined limit for GP referred acute medication, x-rays and pathology\\nMember:       R1 940 \\nMember+1 :  R3 230\\nMember+2:   R3 860\\nMember+3:   R4 220\\nMember+4+: R4 680\\n","practitionersGeneral":"Network GP, incl Virtual Care Consultations\\nUnlimited, auth required after 8th visit ( max of 2 nominated GPs)\\n\\nNon-Network GP Visits: 1 per beneficiary, maximum of 2 visit per family. Limited to R1 110  \\n20% co-payment applies \\n","specialistsCover":"Network  Specialist:\\nLimited to 3 visits or R3 280 per beneficiary\\n5 visits or R4 870 per family\\nGP referral required, as well as pre-auth\\n\\nNon-Network  Specialist:\\nLimited to 1 visit or R1 100 per beneficiary, 2 visits or R2 000 per family (included in the Network Specialist Consultation benefit) \\n10% co-payment applies","dentistryCover":"Subject to Denis Managed Care protocols\\nCovered at the Bonitas Dental Tarif\\n","dentistryCoverSpecial":"No benefit","optical":"Benefit every two years\\nContact lenses: R1 140 per beneficiary \\nNetwork limits per beneficiary:\\nEye examination: 1 test\\nFrames: R225  \\nLenses: 100% of cost \\nNon-network limits per beneficiary:\\nEye examination: R350 \\nFrames: R169 per beneficiary  \\nMultifocal lenses: R770 per lens or\\nSingle Vision lenses: R210 per lens or\\nBifocal lenses: R445 per lens or\\n","ambulance":"Preferred provider: ER24                                    ","international":"Africa Benefit per trip    \\nIn and out-of-hospital: 100% of the BR","hospitalCoverAids":"Unlimited, subject to registration on the HIV/AIDS programme   ","artTtreatment":"Medicine must be obtained from DSP","preventative":"Preventative Care Benefit \\n� Flu vaccine\\n� HIV test\\n� Pap smear\\n� Mammogram  (female>=40, every 2 years)\\n� Prostate screening (annua males  45 - 69)\\nElderly\\n� Pneumococcal vaccine  (over 65, every 5 years)\\n� Stool test for colon cancer ( 50 - 75 years)\\n\\n� Dental fissure sealants: for beneficiaries under 16 years\\n\\n Contraceptives: R1 110 per family at DSP (woman under 50)\\n\\nWellness screening  includes:\\n� Blood pressure\\n� Glucose\\n� Cholesterol\\n� Body Mass Index\\n� Waist-to-hip ratio\\n\\nManagement programmes\\nCancer, HIV/AIDS \\n","logo":"bonitas.jpg"},{"company":"Bonitas","name":"BonCap","planType":"Capitation","coverLevel":"Low","hospital":"Network","chronic":"Network","serviceType":"Network","familyIncome":"R9430 -R15320","mainContribution":"R1507","mainCompSavings":"R0.00","mainTotal":"R1507","dependendContributionAdult":"R1507","dependentCompSavingsAdult":"R0.00","dependentTotalAdult":"R1507","dependendContributionChild":"R693","dependentCompSavingsChild":"R0.00","dependentTotalChild":"R693","maxChildContribution":"10","mainThreshold":"","dependentThresholdAdult":"","dependentThresholdChild":"","preferedHospitalProvider":"\\nBonCap Network\\n","overallLimit":"Unlimited","coPayment":"R10 390 co-payment for use of non-network hospital\\n\\nDay surgery procedures: R10 390 co-payment if day-hospital network is not used\\n\\nOncology & Kidney Dialysis: 20% co-payment for use of a non-network facility\\n\\nCataract Surgery: R6 230 co-payment for use of non-DSP network","rate":"100% Scheme Rate ","generalMedicin":"7 days' supply up to R420 �per admission","specialist":"Unlimited, 100% of Scheme Rate","dentistSurgical":"100% of BR\\n(Maxillo-facial surgery: dental chair), PMB only\\nIn-hospital dental surgery - no benefit","mentalHealth":"\\nPMB only at DSP \\nR10 390 co-payment for use of non-DSP network\\nNo cover for physiotherapy for mental health admissions\\n ","radiology":"Unlimited, 100% of Scheme Rate","pathology":"R27 880 per family except for PMB","maternityBenefit":"In-hospital: 100% BR\\n(Includes midwifery services)\\n\\nOut-of-hospital: 100% BR\\n� Antenatal visits subject to GP and specialist consultations benefits\\n� 4 postnatal midwife consultations. 1 visit can be used with a lactation specialist\\n� 2 x 2D scans\\n� Online antenatal classes\\n� Hearing screening for newborns\\n� 24/7 telephonic baby advice line\\n� Congenital hypothyroidism screening for infants below 1 month \\n\\n ","dialysis":"Unlimited at a DSP \\n20% co-payment applies at a non-DSP","cancer":"PMB at DSP\\n20% co-payment applies at a non-DSP\\nPalliative care: unlimited","transplant":"PMB at DSP","mri":"In-hospital: R12 720 per family, with R1 040 co-payment\\nOut-of-hospital: Included in Specialist consultation limit, pre-auth required","prosthesisInternal":"\\nPMB only, at a preferred provider\\nPre-authorisation required\\n","prosthesisExternal":"External Prosthesis: PMBs only\\nGeneral appliances: R5 960 per family at preferred supplier","rehab":"Physical Rehabilitation: \\nR54 360 per family\\nAlternatives to hospitalisation:\\nR15 660 per family","designatedServiceProvider":"Pharmacy Direct\\n40% co-payment for use of non-formulary non-DSP","conditionsCovered":"26 CDL conditions ","formulary":"Yes","partialLimits":"None","preferredProvider":"Bonitas GP Network and Bonitas Specialist Network are the Scheme's DSPs","overallAnualLimit":"None","medicationOverCounter":"\\nR100 per event, maximum of R 280 per beneficiary\\n","medicationPrescribed":"\\nCombined limit for GP referred acute medication, x-rays and pathology\\nMember:       R1 940 \\nMember+1 :  R3 230\\nMember+2:   R3 860\\nMember+3:   R4 220\\nMember+4+: R4 680\\n","practitionersGeneral":"Network GP, incl Virtual Care Consultations\\nUnlimited, auth required after 8th visit ( max of 2 nominated GPs)\\n\\nNon-Network GP Visits: 1 per beneficiary, maximum of 2 visit per family. Limited to R1 110  \\n20% co-payment applies \\n","specialistsCover":"Network  Specialist:\\nLimited to 3 visits or R3 280 per beneficiary\\n5 visits or R4 870 per family\\nGP referral required, as well as pre-auth\\n\\nNon-Network  Specialist:\\nLimited to 1 visit or R1 100 per beneficiary, 2 visits or R2 000 per family (included in the Network Specialist Consultation benefit) \\n10% co-payment applies","dentistryCover":"Subject to Denis Managed Care protocols\\nCovered at the Bonitas Dental Tarif\\n","dentistryCoverSpecial":"No benefit","optical":"Benefit every two years\\nContact lenses: R1 140 per beneficiary \\nNetwork limits per beneficiary:\\nEye examination: 1 test\\nFrames: R225  \\nLenses: 100% of cost \\nNon-network limits per beneficiary:\\nEye examination: R350 \\nFrames: R169 per beneficiary  \\nMultifocal lenses: R770 per lens or\\nSingle Vision lenses: R210 per lens or\\nBifocal lenses: R445 per lens or\\n","ambulance":"Preferred provider: ER24                                    ","international":"Africa Benefit per trip    \\nIn and out-of-hospital: 100% of the BR","hospitalCoverAids":"Unlimited, subject to registration on the HIV/AIDS programme   ","artTtreatment":"Medicine must be obtained from DSP","preventative":"Preventative Care Benefit \\n� Flu vaccine\\n� HIV test\\n� Pap smear\\n� Mammogram  (female>=40, every 2 years)\\n� Prostate screening (annua males  45 - 69)\\nElderly\\n� Pneumococcal vaccine  (over 65, every 5 years)\\n� Stool test for colon cancer ( 50 - 75 years)\\n\\n� Dental fissure sealants: for beneficiaries under 16 years\\n\\n Contraceptives: R1 110 per family at DSP (woman under 50)\\n\\nWellness screening  includes:\\n� Blood pressure\\n� Glucose\\n� Cholesterol\\n� Body Mass Index\\n� Waist-to-hip ratio\\n\\nManagement programmes\\nCancer, HIV/AIDS \\n","logo":"bonitas.jpg"},{"company":"Bonitas","name":"BonCap","planType":"Capitation","coverLevel":"Low","hospital":"Network","chronic":"Network","serviceType":"Network","familyIncome":"R15320 - R19930","mainContribution":"R2429","mainCompSavings":"R0.00","mainTotal":"R2429","dependendContributionAdult":"R2429","dependentCompSavingsAdult":"R0.00","dependentTotalAdult":"R2429","dependendContributionChild":"R919","dependentCompSavingsChild":"R0.00","dependentTotalChild":"R919","maxChildContribution":"10","mainThreshold":"","dependentThresholdAdult":"","dependentThresholdChild":"","preferedHospitalProvider":"\\nBonCap Network\\n","overallLimit":"Unlimited","coPayment":"R10 390 co-payment for use of non-network hospital\\n\\nDay surgery procedures: R10 390 co-payment if day-hospital network is not used\\n\\nOncology & Kidney Dialysis: 20% co-payment for use of a non-network facility\\n\\nCataract Surgery: R6 230 co-payment for use of non-DSP network","rate":"100% Scheme Rate ","generalMedicin":"7 days' supply up to R420 �per admission","specialist":"Unlimited, 100% of Scheme Rate","dentistSurgical":"100% of BR\\n(Maxillo-facial surgery: dental chair), PMB only\\nIn-hospital dental surgery - no benefit","mentalHealth":"\\nPMB only at DSP \\nR10 390 co-payment for use of non-DSP network\\nNo cover for physiotherapy for mental health admissions\\n ","radiology":"Unlimited, 100% of Scheme Rate","pathology":"R27 880 per family except for PMB","maternityBenefit":"In-hospital: 100% BR\\n(Includes midwifery services)\\n\\nOut-of-hospital: 100% BR\\n� Antenatal visits subject to GP and specialist consultations benefits\\n� 4 postnatal midwife consultations. 1 visit can be used with a lactation specialist\\n� 2 x 2D scans\\n� Online antenatal classes\\n� Hearing screening for newborns\\n� 24/7 telephonic baby advice line\\n� Congenital hypothyroidism screening for infants below 1 month \\n\\n ","dialysis":"Unlimited at a DSP \\n20% co-payment applies at a non-DSP","cancer":"PMB at DSP\\n20% co-payment applies at a non-DSP\\nPalliative care: unlimited","transplant":"PMB at DSP","mri":"In-hospital: R12 720 per family, with R1 040 co-payment\\nOut-of-hospital: Included in Specialist consultation limit, pre-auth required","prosthesisInternal":"\\nPMB only, at a preferred provider\\nPre-authorisation required\\n","prosthesisExternal":"External Prosthesis: PMBs only\\nGeneral appliances: R5 960 per family at preferred supplier","rehab":"Physical Rehabilitation: \\nR54 360 per family\\nAlternatives to hospitalisation:\\nR15 660 per family","designatedServiceProvider":"Pharmacy Direct\\n40% co-payment for use of non-formulary non-DSP","conditionsCovered":"26 CDL conditions ","formulary":"Yes","partialLimits":"None","preferredProvider":"Bonitas GP Network and Bonitas Specialist Network are the Scheme's DSPs","overallAnualLimit":"None","medicationOverCounter":"\\nR100 per event, maximum of R 280 per beneficiary\\n","medicationPrescribed":"\\nCombined limit for GP referred acute medication, x-rays and pathology\\nMember:       R1 940 \\nMember+1 :  R3 230\\nMember+2:   R3 860\\nMember+3:   R4 220\\nMember+4+: R4 680\\n","practitionersGeneral":"Network GP, incl Virtual Care Consultations\\nUnlimited, auth required after 8th visit ( max of 2 nominated GPs)\\n\\nNon-Network GP Visits: 1 per beneficiary, maximum of 2 visit per family. Limited to R1 110  \\n20% co-payment applies \\n","specialistsCover":"Network  Specialist:\\nLimited to 3 visits or R3 280 per beneficiary\\n5 visits or R4 870 per family\\nGP referral required, as well as pre-auth\\n\\nNon-Network  Specialist:\\nLimited to 1 visit or R1 100 per beneficiary, 2 visits or R2 000 per family (included in the Network Specialist Consultation benefit) \\n10% co-payment applies","dentistryCover":"Subject to Denis Managed Care protocols\\nCovered at the Bonitas Dental Tarif\\n","dentistryCoverSpecial":"No benefit","optical":"Benefit every two years\\nContact lenses: R1 140 per beneficiary \\nNetwork limits per beneficiary:\\nEye examination: 1 test\\nFrames: R225  \\nLenses: 100% of cost \\nNon-network limits per beneficiary:\\nEye examination: R350 \\nFrames: R169 per beneficiary  \\nMultifocal lenses: R770 per lens or\\nSingle Vision lenses: R210 per lens or\\nBifocal lenses: R445 per lens or\\n","ambulance":"Preferred provider: ER24                                    ","international":"Africa Benefit per trip    \\nIn and out-of-hospital: 100% of the BR","hospitalCoverAids":"Unlimited, subject to registration on the HIV/AIDS programme   ","artTtreatment":"Medicine must be obtained from DSP","preventative":"Preventative Care Benefit \\n� Flu vaccine\\n� HIV test\\n� Pap smear\\n� Mammogram  (female>=40, every 2 years)\\n� Prostate screening (annua males  45 - 69)\\nElderly\\n� Pneumococcal vaccine  (over 65, every 5 years)\\n� Stool test for colon cancer ( 50 - 75 years)\\n\\n� Dental fissure sealants: for beneficiaries under 16 years\\n\\n Contraceptives: R1 110 per family at DSP (woman under 50)\\n\\nWellness screening  includes:\\n� Blood pressure\\n� Glucose\\n� Cholesterol\\n� Body Mass Index\\n� Waist-to-hip ratio\\n\\nManagement programmes\\nCancer, HIV/AIDS \\n","logo":"bonitas.jpg"},{"company":"Bonitas","name":"BonCap","planType":"Capitation","coverLevel":"Low","hospital":"Network","chronic":"Network","serviceType":"Network","familyIncome":"R19 931+","mainContribution":"R2982","mainCompSavings":"R0.00","mainTotal":"R2982","dependendContributionAdult":"R2982","dependentCompSavingsAdult":"R0.00","dependentTotalAdult":"R2982","dependendContributionChild":"R1131","dependentCompSavingsChild":"R0.00","dependentTotalChild":"R1131","maxChildContribution":"10","mainThreshold":"","dependentThresholdAdult":"","dependentThresholdChild":"","preferedHospitalProvider":"\\nBonCap Network\\n","overallLimit":"Unlimited","coPayment":"R10 390 co-payment for use of non-network hospital\\n\\nDay surgery procedures: R10 390 co-payment if day-hospital network is not used\\n\\nOncology & Kidney Dialysis: 20% co-payment for use of a non-network facility\\n\\nCataract Surgery: R6 230 co-payment for use of non-DSP network","rate":"100% Scheme Rate ","generalMedicin":"7 days' supply up to R420 �per admission","specialist":"Unlimited, 100% of Scheme Rate","dentistSurgical":"100% of BR\\n(Maxillo-facial surgery: dental chair), PMB only\\nIn-hospital dental surgery - no benefit","mentalHealth":"\\nPMB only at DSP \\nR10 390 co-payment for use of non-DSP network\\nNo cover for physiotherapy for mental health admissions\\n ","radiology":"Unlimited, 100% of Scheme Rate","pathology":"R27 880 per family except for PMB","maternityBenefit":"In-hospital: 100% BR\\n(Includes midwifery services)\\n\\nOut-of-hospital: 100% BR\\n� Antenatal visits subject to GP and specialist consultations benefits\\n� 4 postnatal midwife consultations. 1 visit can be used with a lactation specialist\\n� 2 x 2D scans\\n� Online antenatal classes\\n� Hearing screening for newborns\\n� 24/7 telephonic baby advice line\\n� Congenital hypothyroidism screening for infants below 1 month \\n\\n ","dialysis":"Unlimited at a DSP \\n20% co-payment applies at a non-DSP","cancer":"PMB at DSP\\n20% co-payment applies at a non-DSP\\nPalliative care: unlimited","transplant":"PMB at DSP","mri":"In-hospital: R12 720 per family, with R1 040 co-payment\\nOut-of-hospital: Included in Specialist consultation limit, pre-auth required","prosthesisInternal":"\\nPMB only, at a preferred provider\\nPre-authorisation required\\n","prosthesisExternal":"External Prosthesis: PMBs only\\nGeneral appliances: R5 960 per family at preferred supplier","rehab":"Physical Rehabilitation: \\nR54 360 per family\\nAlternatives to hospitalisation:\\nR15 660 per family","designatedServiceProvider":"Pharmacy Direct\\n40% co-payment for use of non-formulary non-DSP","conditionsCovered":"26 CDL conditions ","formulary":"Yes","partialLimits":"None","preferredProvider":"Bonitas GP Network and Bonitas Specialist Network are the Scheme's DSPs","overallAnualLimit":"None","medicationOverCounter":"\\nR100 per event, maximum of R 280 per beneficiary\\n","medicationPrescribed":"\\nCombined limit for GP referred acute medication, x-rays and pathology\\nMember:       R1 940 \\nMember+1 :  R3 230\\nMember+2:   R3 860\\nMember+3:   R4 220\\nMember+4+: R4 680\\n","practitionersGeneral":"Network GP, incl Virtual Care Consultations\\nUnlimited, auth required after 8th visit ( max of 2 nominated GPs)\\n\\nNon-Network GP Visits: 1 per beneficiary, maximum of 2 visit per family. Limited to R1 110  \\n20% co-payment applies \\n","specialistsCover":"Network  Specialist:\\nLimited to 3 visits or R3 280 per beneficiary\\n5 visits or R4 870 per family\\nGP referral required, as well as pre-auth\\n\\nNon-Network  Specialist:\\nLimited to 1 visit or R1 100 per beneficiary, 2 visits or R2 000 per family (included in the Network Specialist Consultation benefit) \\n10% co-payment applies","dentistryCover":"Subject to Denis Managed Care protocols\\nCovered at the Bonitas Dental Tarif\\n","dentistryCoverSpecial":"No benefit","optical":"Benefit every two years\\nContact lenses: R1 140 per beneficiary \\nNetwork limits per beneficiary:\\nEye examination: 1 test\\nFrames: R225  \\nLenses: 100% of cost \\nNon-network limits per beneficiary:\\nEye examination: R350 \\nFrames: R169 per beneficiary  \\nMultifocal lenses: R770 per lens or\\nSingle Vision lenses: R210 per lens or\\nBifocal lenses: R445 per lens or\\n","ambulance":"Preferred provider: ER24                                    ","international":"Africa Benefit per trip    \\nIn and out-of-hospital: 100% of the BR","hospitalCoverAids":"Unlimited, subject to registration on the HIV/AIDS programme   ","artTtreatment":"Medicine must be obtained from DSP","preventative":"Preventative Care Benefit \\n� Flu vaccine\\n� HIV test\\n� Pap smear\\n� Mammogram  (female>=40, every 2 years)\\n� Prostate screening (annua males  45 - 69)\\nElderly\\n� Pneumococcal vaccine  (over 65, every 5 years)\\n� Stool test for colon cancer ( 50 - 75 years)\\n\\n� Dental fissure sealants: for beneficiaries under 16 years\\n\\n Contraceptives: R1 110 per family at DSP (woman under 50)\\n\\nWellness screening  includes:\\n� Blood pressure\\n� Glucose\\n� Cholesterol\\n� Body Mass Index\\n� Waist-to-hip ratio\\n\\nManagement programmes\\nCancer, HIV/AIDS \\n","logo":"bonitas.jpg"},{"company":"Bonitas","name":"BonClassic","planType":"New generation","coverLevel":"Mid","hospital":"Network","chronic":"Network","serviceType":"Any","familyIncome":"N/A","mainContribution":"R4875","mainCompSavings":"R802","mainTotal":"R5677","dependendContributionAdult":"R4185","dependentCompSavingsAdult":"R689","dependentTotalAdult":"R4874","dependendContributionChild":"R1203","dependentCompSavingsChild":"R198","dependentTotalChild":"R1401","maxChildContribution":"3","mainThreshold":"","dependentThresholdAdult":"","dependentThresholdChild":"","preferedHospitalProvider":"Network hospital\\n","overallLimit":"Unlimited","coPayment":"The use of non-DSP or non-Network Providers will have a co-payment\\n\\nDay surgery procedures: R2 290 co-payment if day-hospital network is not used\\n\\nHearing Aids: 10% co-payment\\n\\nKidney Dialysis: 20% co-payment for use of a non-network facility\\n\\nHip and knee replacements: R31 170 co-payment for use of non-DSP network\\n\\nSpinal surgery: R15 590 co-pay if no assessment was done through the back and neck rehabilitation programme\\n\\nCataract Surgery: R6 230 co-payment for use of non-DSP network\\n\\n","rate":"100% Scheme Rate","generalMedicin":"7 days' supply up to R510 �per admission","specialist":"Network Specialist: \\nUnlimited, covered in full\\nnon-Network Specialists: \\n100% of Scheme Rate\\nGP: Unlimited, 100% of Scheme Rate","dentistSurgical":"Maxillo-facial surgery and oral pathology-\\nCovered at the Bonitas Dental Tariff\\nManaged Care protocols apply\\nHospitalisation (General Anaesthetic) -\\nR3 500 co-payment per admission for children under 5 years and R5 000 for any other admission","mentalHealth":"R44 270 per family at DSP\\nSub-limit of R17 070 per family, for out-of-hospital consultations\\nNo cover for physiotherapy for mental health admissions\\n","radiology":"100% Scheme Rate, unlimited","pathology":"100% Scheme Rate, unlimited","maternityBenefit":"In-hospital: Unlimited\\nOut-of-hospital:  \\n12 Antenatal visits\\n� Online antenatal classes\\n4 Postnatal midwife consultations, 1 consultations can be used with a lactation specialist\\n2 x 2D scans per pregnancy\\nAntenatal classes: R1 330\\n1 Amniocentesis test\\nHearing screening for newborns\\nCongenital hypothyroidism screening for infants below 1 month \\n24/7 telephonic baby advice line\\n� Access to 24/7 maternity advice line\\n\\n\\n ","dialysis":"Unlimited at a DSP \\n20% co-payment applies at a non-DSP","cancer":"\\nR410 400 per family, at preferred provider\\nBrachytherapy, sub-limit of R51 000 p.b. \\n20% co-payment apply for not using Oncology medication network \\n� Palliative care: unlimited\\n ","transplant":"Unlimited, sub-limit of R34 520 per beneficiary for Corneal grafts","mri":"In and Out of Hospital: R31 770 per family - with R1 560 co-payment per scan","prosthesisInternal":"\\nCombined limit for Internal and External prosthesis at preferred provider\\nR59 830 per family\\nBreast prosthesis sub-limit of R5 760 (limited to 2 per annum)\\nCochlear Implants: R304 300 per family\\n\\nJointCare: hip and knee replacements surgery at DSP only(ICPS) \\n\\n\\n","prosthesisExternal":"External Prosthesis, shared limit with Internal prosthesis  \\nGeneral appliances: paid from savings\\nHearing aids: R18 500 per family every 5 years (10% co-payment)","rehab":"Physical Rehabilitation: R54 360 per family \\nAlternatives to hospitalisation:\\nR18 130 per family","designatedServiceProvider":"Pharmacy Direct\\n40% co-payment for use of non-formulary non-DSP","conditionsCovered":"47 conditions covered ","formulary":"Yes ","partialLimits":"\\n20 non-CDL conditions, limited to\\nR12 420 per beneficiary,\\nR25 680 per family\\n\\n\\n","preferredProvider":"Bonitas Pharmacy Network and Optometry Network","overallAnualLimit":"None","medicationOverCounter":"Subject to available Savings","medicationPrescribed":"Subject to available Savings","practitionersGeneral":"Subject to available Savings","specialistsCover":"Subject to available Savings","dentistryCover":"R5 138 per family per annum\\nCovered at the Bonitas Dental Tariff \\n","dentistryCoverSpecial":"R6 186 per family per annum\\nCovered at the Bonitas Dental Tariff\\n","optical":"Benefit every two years\\nR5 845 per family per annum\\nContact lenses: R1 880 per beneficiary \\nNetwork limits per beneficiary:\\nEye examination: 1 test\\nFrames: R1 110 per  \\nLenses: 100% of cost \\nNon-network limits per beneficiary:\\nEye examination: R350 \\nFrames: R833 per beneficiary \\nMultifocal lenses: R770 per lens or\\nBifocal lenses: R445 per lens or\\nSingle Vision lenses: R210 per lens.\\n","ambulance":"Preferred Provider: ER24","international":"R10 million per family for medical emergencies when traveling outside SA, \\n\\nAfrica Benefit per trip In and out-of-hospital: 100% of the BR\\n\\nAdditional benefit for compulsory COVID-19 test and medical quarantine up to \\nR10 000 per person","hospitalCoverAids":"Unlimited, subject to registration on the HIV/AIDS programme   ","artTtreatment":"Medicine must be obtained from DSP","preventative":"Preventative Care Benefit \\n� Flu vaccine\\n� Full lipogram (every 5 years, ages 20+)\\n� HIV test \\n� Pap smear (every 3 years, ages 21-65)\\n� Mammogram (every 2 years, ages 40+)\\n� Prostate screening (ages 45-69)\\n� Childhood immunisations\\nElderly\\n� Pneumococcal vaccine (every 5 years, 65+)\\n� Stool test for colon cancer (ages 50-75)\\nBone density (every 5 years, women 65+, men 70+)\\n� Dental fissure sealants: for beneficiaries under 16 years\\n\\nWellness screening benefit: Blood pressure, Glucose, Cholesterol, Body Mass Index, Waist-to-hip ratio\\n\\nBenefit Booster: R1 880 per family, benefit available after completing a wellness screening   \\nContraceptives: R1 720 at DSP, or 40% co-payment\\n\\nManagement programmes\\nBack and neck, Mental Wellness\\nHip and knee replacements\\nCancer, Diabetes\\nHIV/AIDS\\nHome-based care(by Quro Medical Services)\\n","logo":"bonitas.jpg"},{"company":"Bonitas","name":"BonComplete","planType":"New generation","coverLevel":"Mid","hospital":"Network","chronic":"Network","serviceType":"Any","familyIncome":"N/A","mainContribution":"#REF!","mainCompSavings":"R684","mainTotal":"#REF!","dependendContributionAdult":"#REF!","dependentCompSavingsAdult":"R548","dependentTotalAdult":"#REF!","dependendContributionChild":"#REF!","dependentCompSavingsChild":"R186","dependentTotalChild":"#REF!","maxChildContribution":"3","mainThreshold":"R9534","dependentThresholdAdult":"R7718","dependentThresholdChild":"R2488","preferedHospitalProvider":"Network hospital\\n","overallLimit":"Unlimited","coPayment":"The use of non-DSP or non-Network Providers will have a co-payment\\n\\nDay surgery procedures: R2 290 co-payment if day-hospital network is not used\\n\\nAcute Medicine and OTC medicine: 20% co-payment for non-network or non-formulary use in above threshold benefit\\n\\nKidney Dialysis: 20% co-payment for use of a non-network facility\\n\\nCataract Surgery: R6 230 co-payment for use of non-DSP network\\n\\nHip and knee replacements: R31 170 co-payment for use of non-DSP network\\n\\nSpinal surgery: R15 590 co-pay if no assessment was done through the back and neck rehabilitation programme\\n\\n\\n\\n","rate":"100% Scheme Rate","generalMedicin":"7 days' supply up to R450 �per admission","specialist":"Network Specialist: \\nUnlimited, covered in full\\nnon-Network Specialists: \\n100% of Scheme Rate\\nGP: Unlimited, 100% of Scheme Rate","dentistSurgical":"Maxillo-facial surgery and oral pathology-\\nCovered at the Bonitas Dental Tariff\\nManaged Care protocols apply\\nHospitalisation (General Anaesthetic) -\\nR3 500 co-payment per admission for children under 5 years and R5 000 for any other admission","mentalHealth":"R34 610 per family\\nSub-limit of R17 070 per family, for out-of-hospital consultations\\nNo cover for physiotherapy for mental health admissions\\n","radiology":"100% Scheme Rate, unlimited","pathology":"100% Scheme Rate, unlimited","maternityBenefit":"In-hospital: Unlimited\\nOut-of-hospital: \\n6 Antenatal visits\\n� Online antenatal classes\\n4 Postnatal midwife consultations, 1 visit can be used with a lactation specialist\\nAntenatal classes: R1 330\\n2 x 2D scans per pregnancy\\n1 Amniocentesis test\\nHearing screening for newborns\\nCongenital hypothyroidism screening for infants below 1 month \\nPaediatric or GP consultations: \\n- 2 consults for child under 1 years; \\n- 1 consult for children between 1 and 2 years\\n24/7 telephonic baby advice line� Access to 24/7 maternity advice line\\n","dialysis":"Unlimited at a DSP \\n20% co-payment applies at a non-DSP","cancer":"\\nR344 500 per family, at preferred provider\\nBrachytherapy, sub-limit of R51 000 p.b. \\n20% co-payment apply for not using Oncology medication network \\n� Palliative care: unlimited\\n ","transplant":"Unlimited, sub-limit of R34 520 per beneficiary for Corneal grafts","mri":"In and Out of Hospital: R25 570 per family\\nwith R1 560 co-payment per scan\\n","prosthesisInternal":"Combined limit for Internal and External prosthesis at preferred provider\\nLimited to R48 440 per family \\nBreast prosthesis sub-limit of R5 760 (limited to 2 per annum)\\n\\nJointCare: hip and knee replacements surgery at DSP only(ICPS)\\n","prosthesisExternal":"External Prosthesis, shared limit with Internal prosthesis  \\nGeneral appliances and Hearing Aids: Paid from Savings and/or threshold\\n","rehab":"Physical Rehabilitation: R54 360 per family \\nAlternatives to hospitalisation:\\nR18 130 per family","designatedServiceProvider":"Pharmacy Direct\\n40% co-payment for use of non-formulary non-DSP","conditionsCovered":"30 conditions covered","formulary":"Yes ","partialLimits":"None","preferredProvider":"Bonitas Pharmacy Network and Optometry Network","overallAnualLimit":"None","medicationOverCounter":"Subject to Savings and/or Threshold\\nIncluded in Prescribed medication limit 20% co-payment for non-network or non-formulary use in the above threshold benefit","medicationPrescribed":"Subject to Savings and/or Threshold\\nIncluded in Prescribed medication limit 20% co-payment for non-network or non-formulary use in the above threshold benefit","practitionersGeneral":"\\nSubject to available Savings or above  threshold benefit\\nGP consult: 1 visit per child, 2-12 years\\n","specialistsCover":"Subject to available Savings or above  threshold benefit. GP referral required","dentistryCover":"100% of Scheme Rate\\n(Subject to Bonitas Dental Programme)","dentistryCoverSpecial":"100% of Scheme Rate\\nCovered at the Bonitas Dental Tariff","optical":"Benefit every two years, paid from savings and/or threshold\\nContact lenses: R2 105 per beneficiary \\nNetwork limits per beneficiary:\\nEye examination: 1 test\\nFrames: R855 \\nLenses: 100% of cost \\nNon-network limits per beneficiary:\\nEye examination: R350 \\nFrames: R855 per beneficiary \\nMultifocal lenses: R770 per lens or\\nBifocal lenses: R445 per lens or\\nSingle Vision lenses: R210 per lens.","ambulance":"Preferred Provider: ER24","international":"R10 million per family for medical emergencies when traveling outside SA, \\n\\nAfrica Benefit per trip In and out-of-hospital: 100% of the BR\\n\\nAdditional benefit for compulsory COVID-19 test and medical quarantine up to \\nR10 000 per person","hospitalCoverAids":"Unlimited, subject to registration on the HIV/AIDS programme   ","artTtreatment":"Medicine must be obtained from DSP","preventative":"Preventative Care Benefit \\n� Flu vaccine\\n� Full lipogram (every 5 years, ages 20+)\\n� HIV test \\n� Pap smear (every 3 years, ages 21-65)\\n� Mammogram (every 2 years, ages 40+)\\n� Prostate screening (ages 45-69)\\n� Childhood immunisations\\nElderly\\n� Pneumococcal vaccine (every 5 years, 65+)\\n� Stool test for colon cancer (ages 50-75)\\n� Bone density (every 5 years, women 65+, men 70+)\\n� Dental fissure sealants: for beneficiaries under 16 years\\n\\nWellness screening benefit: Blood pressure, Glucose, Cholesterol, Body Mass Index, Waist-to-hip ratio\\n\\nBenefit Booster: R1 880 per family, benefit available after completing a wellness screening   \\nContraceptives: R1 720 at DSP, or 40% co-payment\\n\\nManagement programmes\\nBack and neck, Mental Wellness\\nHip and knee replacements\\nCancer, Diabetes\\nHIV/AIDS\\nHome-based care(by Quro Medical Services)\\n","logo":"bonitas.jpg"},{"company":"Bonitas","name":"BonComprehensive","planType":"Threshold option","coverLevel":"High","hospital":"Any","chronic":"Network","serviceType":"Any","familyIncome":"N/A","mainContribution":"#REF!","mainCompSavings":"R1550","mainTotal":"#REF!","dependendContributionAdult":"#REF!","dependentCompSavingsAdult":"R1461","dependentTotalAdult":"#REF!","dependendContributionChild":"#REF!","dependentCompSavingsChild":"R315","dependentTotalChild":"#REF!","maxChildContribution":"3","mainThreshold":"","dependentThresholdAdult":"","dependentThresholdChild":"","preferedHospitalProvider":"Any hospital","overallLimit":"Unlimited","coPayment":"The use of non-DSP or non-Network Providers will have a co-payment\\n\\nHip and knee replacements: R31 170 co-payment for use of non-DSP network\\n\\nCataract Surgery: R6 230 co-payment for use of non-DSP network\\n\\nSpinal surgery: \\nR15 590 co-payment if no assessment was done through the back and neck rehabilitation programme\\n\\nNon use of DSP for Kidney Dialysis:\\n20% co-payment\\n\\nDay surgery procedures: R2 290 co-payment if day-hospital network is not used","rate":"150% Scheme Rate","generalMedicin":"7 days' supply up to R595 �per admission","specialist":"Specialist: 150% of Scheme Rate\\nGP: 100% of Scheme Rate","dentistSurgical":"Maxillo-facial surgery and oral pathology\\nManaged Care protocols apply\\nGeneral anaesthetic available for children under 5 years for extensive dental treatment, once per lifetime","mentalHealth":"R50 360 per family\\nSub-limit of R17 070 per family, for out-of-hospital consultations\\nNo cover for physiotherapy for mental health admissions\\n","radiology":"100% Scheme Rate, unlimited","pathology":"100% Scheme Rate, unlimited","maternityBenefit":"In-hospital: Unlimited\\nPrivate ward for post delivery (up to 3 days)\\nOut-of-hospital:\\n12 Antenatal visits, 4 Postnatal visits with a midwife (1 can be used for a consultation with a lactation specialist)\\n2 x 2D scans\\n� Online antenatal classes\\nAntenatal classes: R1 330\\n1 Amniocentesis test\\nHearing screening\\nCongenital hypothyroidism screening for infants below 1 month \\nPaediatric or GP consultations:  \\n- 3 consults for child under 1 years; \\n- 2 consult for children between 1 and 2 years\\n24/7 telephonic baby advice line\\n\\n ","dialysis":"Unlimited at DSP, 20% co-payment for use of non-DSP Network   ","cancer":"\\nR618 500 per family, sub-limit of R245 400  for specialised drugs (including biological drugs). Sub limit of R51 000 per beneficiary for Brachytherapy. 20% co-payment apply for  not using Oncology medication network \\n� Palliative care: unlimited","transplant":"Unlimited, sub-limit of R34 520 per beneficiary for Corneal grafts","mri":"In and Out of Hospital: R34 340 per family\\nwith R1 560 co-payment per scan","prosthesisInternal":"\\nInternal prostheses:\\nR60 380 per family \\nCochlear Implants, R304 300 per family \\nInternal Nerve Stimulators, R181 400 per family, Deep brain stimulation (excluding prosthesis): R255 700 per beneficiary\\n\\nJointCare: hip and knee replacements surgery at DSP only(ICPS)\\n\\n","prosthesisExternal":"\\nExternal Prosthesis, R60 380 per family with \\nsub-limit of R5 760 per breast prosthesis (max, 2 per year)\\nGeneral appliances, subject to available Savings and use of preferred provider\\nHearing aids, R28 250 per family every 5 years, with 10% co-payment and use of preferred provider\\n\\n","rehab":"Physical Rehabilitation: R54 360 per family \\nAlternatives to hospitalisation:\\nR18 130 per family","designatedServiceProvider":"Bonitas Pharmacy Network\\n40% co-payment for use of non-formulary non-DSP ","conditionsCovered":"60 conditions  ","formulary":"Comprehensive formulary before limits, restrictive formulary for PMBs after limits","partialLimits":"Non-CDL conditions, limited to\\nR15 160 per beneficiary, R30 190 per family \\n","preferredProvider":"None","overallAnualLimit":"None","medicationOverCounter":"Subject to available Savings or above threshold. Formulary and Network applies to above threshold benefit or 20% co payment","medicationPrescribed":"Subject to available Savings or above threshold. Above threshold limit of R15 000 per family combined with OTC benefit. Formulary and Network applies to above threshold benefit or 20% co payment","practitionersGeneral":"\\nSubject to available Savings or above threshold, incl. virtual care consultations\\n","specialistsCover":" \\nSubject to available Savings or Threshold - GP referral required\\n","dentistryCover":"\\nSubject to available Savings and/or above threshold and Bonitas Dental Programme  \\n \\n","dentistryCoverSpecial":"\\nSubject to available savings and/or threshold. (Subject to Bonitas Dental Programme) \\n \\n","optical":"Subject to available Savings or above threshold benefit, limited to R3 500 per beneficiary every 2 years\\n1 eye test and lenses at Network provider\\nNon-network limits per beneficiary\\nEye examination, R350 \\nFrames/Contact lenses subject to Savings or threshold and Optometry sub limit \\nMultifocal lenses, R770 per lens or\\nBifocal lenses, R445 per lens or\\nSingle Vision lenses, R210 per lens.\\n","ambulance":"Preferred provider: ER24","international":"R10 million per family for medical emergencies when traveling outside SA, \\n\\nAfrica Benefit per trip In and out-of-hospital: 100% of the BR\\n\\nAdditional benefit for compulsory COVID-19 test and medical quarantine up to \\nR10 000 per person","hospitalCoverAids":"Unlimited, subject to registration on the HIV/AIDS programme   ","artTtreatment":"Medicine must be obtained from DSP","preventative":"Preventative Care Benefit \\n� Flu vaccine\\n� Full lipogram (every 5 years, ages 20+)\\n� HIV test \\n� Pap smear (every 3 years, ages 21-65)\\n� Mammogram (every 2 years, ages 40+)\\n� Prostate screening (ages 45-69)\\n� Childhood immunisations\\nElderly\\n� Pneumococcal vaccine (every 5 years, 65+)\\n� Stool test for colon cancer (ages 50-75)\\n� Bone density (every 5 years, women 65+, men 70+)\\n� Dental fissure sealants: for beneficiaries under 16 years\\n\\nWellness screening benefit: Blood pressure, Glucose, Cholesterol, Body Mass Index, Waist-to-hip ratio\\n\\nBenefit Booster: R2 730 per family, benefit available after completing a wellness screening   \\nContraceptives: R1 720 at DSP, or 40% co-payment\\n\\nManagement programmes\\nBack and neck, Mental Wellness\\nHip and knee replacements\\nCancer, Diabetes\\nHIV/AIDS\\nHome-based care(by Quro Medical Services)","logo":"bonitas.jpg"},{"company":"Bonitas","name":"BonEssential Select","planType":"Hospital plan","coverLevel":"Mid","hospital":"Network","chronic":"Network","serviceType":"N/A","familyIncome":"N/A","mainContribution":"R1784","mainCompSavings":"R0.00","mainTotal":"R1784","dependendContributionAdult":"R1364","dependentCompSavingsAdult":"R0.00","dependentTotalAdult":"R1364","dependendContributionChild":"R523","dependentCompSavingsChild":"R0.00","dependentTotalChild":"R523","maxChildContribution":"3","mainThreshold":"","dependentThresholdAdult":"","dependentThresholdChild":"","preferedHospitalProvider":"BonEssential Select Network\\n","overallLimit":"Unlimited","coPayment":"The use of non-DSP or non-Network Providers will have a co-payment\\n30% co-payment for use of non-network hospital\\n\\nCataract Surgery: R6 230 co-payment for use of non-DSP network\\n\\nDay surgery procedures: R4 570 co-payment if day-hospital network is not used\\n\\nProcedure co-payments\\nR1 630: Colonoscopy, Conservative Back Treatment, Cystoscopy, Facet Joint Injections, Flexible sigmoidoscopy, Functional nasal surgery, Gastroscopy, Hysteroscopy (not endometrial ablation), Myringotomy, Tonsillectomy, Adenoidectomy, Umbilical Hernia Repair and Varicose vein surgery \\n\\nR4 140: Arthroscopy, Diagnostic Laparoscopy, Laparoscopic Hysterectomy, Percutaneous Radiofrequency Ablations (Percutaneous Rhizotomies) \\n\\nR8 150: Laparoscopic Pyeloplasty, Laparoscopic Radical Prostatectomy, Nissen Fundoplication (Reflux surgery)","rate":"100% Scheme Rate","generalMedicin":"7 days' supply up to R420 �per admission","specialist":"Network Specialist: \\nUnlimited, covered in full\\nnon-Network Specialists: \\n100% of Scheme Rate\\nGP: Unlimited: 100% of Scheme Rate","dentistSurgical":"Hospitalisation for dentistry: pre-authorisation required\\nR5 000 co-payment per admission applies for the removal of impacted wisdom teeth \\n\\nA 30% co-payment applies for non-network admissions ","mentalHealth":"R34 610 per family\\n- at DSP or 30% co-payment applies\\nNo cover for physiotherapy for mental health admissions\\n","radiology":"100% Scheme Rate, unlimited","pathology":"100% Scheme Rate, unlimited","maternityBenefit":"In-hospital: Unlimited\\nOut-of-hospital: \\n6 Antenatal visits\\n� Online antenatal classes\\n4 Postnatal midwife consultations, 1 visit can be used with a lactation specialist\\n2 x 2D scans per pregnancy\\n1 Amniocentesis test \\nHearing screening for newborns\\nCongenital hypothyroidism screening for infants below 1 month \\n24/7 telephonic baby advice line\\n� Access to 24/7 maternity advice line\\n\\n\\n ","dialysis":"Unlimited at a DSP \\n20% co-payment applies at a non-DSP","cancer":"\\nPMB only at DSP \\n20% co-payment apply for not using an Oncology medication network \\nBrachytherapy, sub-limit of R51 000 p.b. \\n� Palliative care: unlimited\\n ","transplant":"PMB only","mri":"In and Out of Hospital: R17 270 per family\\nwith R1 560 co-payment per scan\\n","prosthesisInternal":"PMB only","prosthesisExternal":"External Prosthesis: PMBs only at a preferred provider\\nGeneral appliances: No benefit","rehab":"Physical Rehabilitation: R54 360 per family \\nAlternatives to hospitalisation:\\nR18 130 per family","designatedServiceProvider":"Pharmacy Direct\\n40% co-payment for use of non-formulary non-DSP","conditionsCovered":"CDL in PMBs","formulary":"Yes ","partialLimits":"None","preferredProvider":"None","overallAnualLimit":"N/A","medicationOverCounter":"No benefit","medicationPrescribed":"No benefit","practitionersGeneral":"No benefit","specialistsCover":"No benefit","dentistryCover":"No benefit","dentistryCoverSpecial":"No benefit","optical":"No benefit","ambulance":"Preferred Provider: ER24","international":"R10 million per family for medical emergencies when traveling outside SA, \\n\\nAfrica Benefit per trip                                                   In and out-of-hospital: 100% of the BR\\n\\nAdditional benefit for compulsory COVID-19 test and medical quarantine up to \\nR10 000 per person","hospitalCoverAids":"Unlimited, subject to registration on the HIV/AIDS programme   ","artTtreatment":"Medicine must be obtained from DSP","preventative":"Preventative Care Benefit \\n� Flu vaccine\\n� HIV test\\n� Pap smear (every 3 years, ages 21 - 65)\\n� Mammogram (every 2 years, ages 40+)\\n� Prostate screening (ages 45 - 69)\\nElderly\\n� Pneumococcal vaccine (every 5 years, ages 65+)\\n� Stool test for colon cancer (ages 50 -75)\\nChildcare Benefit: 1 GP consult per child between 2-12 years\\n� Dental fissure sealants: for beneficiaries under 16 years\\n\\nWellness screening benefit: Blood pressure, Glucose, Cholesterol, Body Mass Index, Waist-to-hip ratio\\n\\nBenefit Booster: R940 per family, available after completing a wellness screening or online assessment  \\n\\nContraceptives: R1 330 at DSP, or 40% co-payment\\n\\nManagement programmes\\nBack and neck\\nCancer, Diabetes\\n HIV/AIDS\\nHome-based care(by Quro Medical Services)\\n","logo":"bonitas.jpg"},{"company":"Bonitas","name":"BonFit Select","planType":"New generation","coverLevel":"Mid","hospital":"Network","chronic":"Network","serviceType":"Any","familyIncome":"N/A","mainContribution":"R1873","mainCompSavings":"R357","mainTotal":"R2230","dependendContributionAdult":"R1451","dependentCompSavingsAdult":"R276","dependentTotalAdult":"R1727","dependendContributionChild":"R562","dependentCompSavingsChild":"R107","dependentTotalChild":"R669","maxChildContribution":"3","mainThreshold":"","dependentThresholdAdult":"","dependentThresholdChild":"","preferedHospitalProvider":"BonFit Network hospital\\n","overallLimit":"Unlimited","coPayment":"30% co-payment for use of non-network hospital\\n\\nThe use of non-DSP or non-Network Providers will have a co-payment\\n\\nCataract Surgery: R6 230 co-payment for use of non-DSP network\\n\\nDay surgery procedures: R4 570 co-payment if day-hospital network is not used\\n\\nProcedure co-payments\\nR1 630: Colonoscopy, Conservative Back Treatment, Cystoscopy, Facet Joint Injections, Flexible sigmoidoscopy, Functional nasal surgery, Gastroscopy, Hysteroscopy (not endometrial ablation), Myringotomy, Tonsillectomy, Adenoidectomy, Umbilical Hernia Repair and Varicose vein surgery \\n\\nR4 140: Arthroscopy, Diagnostic Laparoscopy, Laparoscopic Hysterectomy, Percutaneous Radiofrequency Ablations (Percutaneous Rhizotomies) \\n\\nR8 150: Laparoscopic Pyeloplasty, Laparoscopic Radical Prostatectomy, Nissen Fundoplication (Reflux surgery)","rate":"100% Scheme Rate","generalMedicin":"7 days' supply up to R420 �per admission","specialist":"Network Specialist: \\nUnlimited, covered in full\\nnon-Network Specialists: \\n100% of Scheme Rate\\nGP: Unlimited: 100% of Scheme Rate","dentistSurgical":"No benefit","mentalHealth":"R34 610 per family\\n- at DSP or 30% co-payment applies\\nIn and out-of-hospital consultations (out-of-hospital PMB only)\\nNo cover for physiotherapy for mental health admissions\\n","radiology":"100% Scheme Rate, unlimited","pathology":"100% Scheme Rate, unlimited","maternityBenefit":"In-hospital: Unlimited\\nOut-of-hospital: \\n6 Antenatal visits\\n� Online antenatal classes\\n4 Postnatal midwife consultations, 1 visit can be used with a lactation specialist\\nAntenatal classes: R1 330\\n2 x 2D scans per pregnancy\\n1 Amniocentesis test\\nHearing screening for newborns\\nCongenital hypothyroidism screening for infants below 1 month \\nPaediatric or GP consultations: \\n- 2 consults for child under 1 years; \\n- 1 consult for children between 1 and 2 years\\n24/7 telephonic baby advice line\\n� Access to 24/7 maternity advice line\\n\\n ","dialysis":"Unlimited at a DSP \\n20% co-payment applies at a non-DSP","cancer":"\\nR165 500 per family, at preferred provider\\nBrachytherapy, sub-limit of R51 000 p.b. \\n20% co-payment apply for not using an Oncology medication network \\n� Palliative care: unlimited\\n ","transplant":"Unlimited, Corneal grafts PMB only","mri":"In-Hospital: R17 270 per family - with \\nR1 560 co-payment per scan\\nOut of Hospital: from available savings","prosthesisInternal":"PMBs only","prosthesisExternal":"External Prosthesis: no benefit\\nAppliances: Subject to available Savings","rehab":"Physical Rehabilitation: R54 360 per family \\nAlternatives to hospitalisation:\\nR18 130 per family","designatedServiceProvider":"Pharmacy Direct\\n40% co-payment for use of non-formulary non-DSP","conditionsCovered":"CDL in PMBs","formulary":"Yes ","partialLimits":"None","preferredProvider":"None","overallAnualLimit":"N/A","medicationOverCounter":"Subject to available Savings","medicationPrescribed":"Subject to available Savings","practitionersGeneral":"(including virtual care consultations)\\nSubject to available Savings\\nOnce saving is depleted limited to\\n- 1 visits per beneficiary \\n- 2 visits per family","specialistsCover":"\\nSubject to available Savings and GP referral\\n ","dentistryCover":"Subject Bonitas Dental Tariff and clinical protocols ","dentistryCoverSpecial":"No benefit","optical":"Subject to available Savings","ambulance":"Preferred Provider: ER24","international":"R10 million per family for medical emergencies when traveling outside SA, \\n\\nAfrica Benefit per trip In and out-of-hospital: 100% of the BR\\n\\nAdditional benefit for compulsory COVID-19 test and medical quarantine up to \\nR10 000 per person","hospitalCoverAids":"Unlimited, subject to registration on the HIV/AIDS programme   ","artTtreatment":"Medicine must be obtained from DSP","preventative":"Preventative Care Benefit \\n� Flu vaccine\\n� HIV test\\n� Pap smear\\n� Mammogram\\n� Prostate screening\\n� Childhood immunisations\\nElderly\\n� Pneumococcal vaccine\\n� Stool test for colon cancer\\nChildcare Benefit: 1 GP consult per child between 2-12 years\\n� Dental fissure sealants: for beneficiaries under 16 years\\n\\nWellness screening benefit: Blood pressure, Glucose, Cholesterol, Body Mass Index, Waist-to-hip ratio\\n\\nBenefit Booster: R1 310 per family, benefit available after completing a wellness screening   \\nContraceptives: R1 660 at DSP, or 40% co-payment\\n\\nManagement programmes\\nBack and neck\\nCancer, Diabetes\\nHIV/AIDS\\nHome-based care(by Quro Medical Services)","logo":"bonitas.jpg"},{"company":"Bonitas","name":"BonSave","planType":"New generation","coverLevel":"Mid","hospital":"Any","chronic":"Network","serviceType":"Any","familyIncome":"N/A","mainContribution":"R2375","mainCompSavings":"R575","mainTotal":"R2950","dependendContributionAdult":"R1839","dependentCompSavingsAdult":"R445","dependentTotalAdult":"R2284","dependendContributionChild":"R711","dependentCompSavingsChild":"R172","dependentTotalChild":"R883","maxChildContribution":"3","mainThreshold":"","dependentThresholdAdult":"","dependentThresholdChild":"","preferedHospitalProvider":"Any hospital \\n","overallLimit":"Unlimited","coPayment":"The use of non-DSP or non-Network Providers will have a co-payment\\n\\nCataract Surgery: R6 230 co-payment for use of non-DSP network\\n\\nDay surgery procedures: R2 290 co-payment if day-hospital network is not used\\n\\nProcedure co-payments\\nR1 630: Colonoscopy, Conservative Back Treatment, Cystoscopy, Facet Joint Injections, Flexible sigmoidoscopy, Functional nasal surgery, Gastroscopy, Hysteroscopy (not endometrial ablation), Myringotomy, Tonsillectomy, Adenoidectomy, Umbilical Hernia Repair and Varicose vein surgery \\n\\nR4 140: Arthroscopy, Diagnostic Laparoscopy, Laparoscopic Hysterectomy, Percutaneous Radiofrequency Ablations (Percutaneous Rhizotomies) \\n\\nR8 150: Laparoscopic Pyeloplasty, Laparoscopic Radical Prostatectomy, Nissen Fundoplication (Reflux surgery)","rate":"100% Scheme Rate","generalMedicin":"7 days' supply up to R420 �per admission","specialist":"Specialist: Unlimited - 100% of Scheme Rate\\nGP: Unlimited - 100% of Scheme Rate","dentistSurgical":"Hospitalisation for dentistry: pre-authorisation required\\nR5 000 co-payment per admission applies for the removal of impacted wisdom teeth  ","mentalHealth":"R34 610 per family\\nSub-limit of R17 070 per family, for out-of-hospital consultations\\nNo cover for physiotherapy for mental health admissions\\n","radiology":"100% Scheme Rate, unlimited","pathology":"100% Scheme Rate, unlimited","maternityBenefit":"In-hospital: Unlimited\\nOut-of-hospital: \\n6 Antenatal visits\\n� Online antenatal classes\\n4 Postnatal midwife consultations, 1 visit can be used with a lactation specialist\\nAntenatal classes: R1 330\\n2 x 2D scans per pregnancy\\n1 Amniocentesis test\\nHearing screening for newborns\\nCongenital hypothyroidism screening for infants below 1 month \\nPaediatric or GP consultations: \\n- 2 consults for child under 1 years; \\n- 1 consult for children between 1 and 2 years\\n24/7 telephonic baby advice line\\n� Access to 24/7 maternity advice line\\n\\n ","dialysis":"Unlimited at a DSP \\n20% co-payment applies at a non-DSP","cancer":"\\nR344 500 per family, at preferred provider\\nBrachytherapy, sub-limit of R51 000 p.b. \\n20% co-payment apply for not using an  Oncology medication network \\n� Palliative care: unlimited\\n ","transplant":"Unlimited, sub-limit of R34 520 per beneficiary for Corneal grafts","mri":"In and Out of Hospital: R25 570 per family - with R1 560 co-payment per scan","prosthesisInternal":"Internal only: R34 520 per family\\nJoint replacements, no benefit (PMB only)\\n- at a preferred provider","prosthesisExternal":"Subject to available Savings","rehab":"Physical Rehabilitation: R54 360 per family \\nAlternatives to hospitalisation:\\nR18 130 per family","designatedServiceProvider":"Pharmacy Direct\\n40% co-payment for use of non-formulary non-DSP","conditionsCovered":"CDL in PMBs","formulary":"Yes ","partialLimits":"None","preferredProvider":"None","overallAnualLimit":"N/A","medicationOverCounter":"Subject to available Savings","medicationPrescribed":"Subject to available Savings","practitionersGeneral":"(including virtual care consultations)\\nSubject to available Savings\\nOnce saving is depleted, limited to \\n- 3 visits per beneficiary \\n- 6 visits per family","specialistsCover":"\\nSubject to available Savings and GP referral\\n ","dentistryCover":"Subject Bonitas Dental Tariff and clinical protocols ","dentistryCoverSpecial":"Covered at the Bonitas Dental Tariff ","optical":"Subject to available Savings","ambulance":"Preferred Provider: ER24","international":"R10 million per family for medical emergencies when traveling outside SA, \\n\\nAfrica Benefit per trip In and out-of-hospital: 100% of the BR\\n\\nAdditional benefit for compulsory COVID-19 test and medical quarantine up to \\nR10 000 per person","hospitalCoverAids":"Unlimited, subject to registration on the HIV/AIDS programme   ","artTtreatment":"Medicine must be obtained from DSP","preventative":"Preventative Care Benefit \\n� Flu vaccine\\n� HIV test\\n� Pap smear\\n� Mammogram\\n� Prostate screening\\n� Childhood immunisations\\nElderly\\n� Pneumococcal vaccine\\n� Stool test for colon cancer\\nChildcare Benefit: 1 GP consult per child between 2-12 years\\n� Dental fissure sealants: for beneficiaries under 16 years\\n\\nWellness screening benefit: Blood pressure, Glucose, Cholesterol, Body Mass Index, Waist-to-hip ratio\\n\\nBenefit Booster: R1 310 per family, benefit available after completing a wellness screening   \\nContraceptives: R1 660 at DSP, or 40% co-payment\\n\\nManagement programmes\\nBack and neck\\nCancer, Diabetes\\n HIV/AIDS\\nHome-based care(by Quro Medical Services)","logo":"bonitas.jpg"},{"company":"Bonitas","name":"BonStart","planType":"Edge plan\\n","coverLevel":"Low","hospital":"Network","chronic":"Network","serviceType":"Network","familyIncome":"N/A","mainContribution":"R1338","mainCompSavings":"R0.00","mainTotal":"R1338","dependendContributionAdult":"R1338","dependentCompSavingsAdult":"R0.00","dependentTotalAdult":"R1338","dependendContributionChild":"R1338","dependentCompSavingsChild":"R0.00","dependentTotalChild":"R1338","maxChildContribution":"","mainThreshold":"","dependentThresholdAdult":"","dependentThresholdChild":"","preferedHospitalProvider":"BonStart Hospital Network","overallLimit":"Unlimited","coPayment":"The use of non-DSP or non-Network Providers will have a co-payment\\nR1 500 per admission\\n\\nExcept for motor vehicle accidents and maternity confinements and emergency treatment\\n\\nDay surgery procedures: R10 650 co-payment if day-hospital network is not used\\n\\nCataract Surgery: R6 000 co-payment for use of non-DSP network\\n\\nProcedure co-payments\\nR2 550 co-payment: Arthroscopy (done as part of a surgical procedure) & Laparoscopic Hysterectomy","rate":"100% Scheme Rate","generalMedicin":"7 days' supply up to R390 �per admission","specialist":"Specialist: Unlimited - 100% of Scheme Rate\\nGP: Unlimited - 100% of Scheme Rate","dentistSurgical":" PMBs only","mentalHealth":"PMB at DSP","radiology":"100% Scheme Rate, unlimited","pathology":"R25 950 per family","maternityBenefit":"Natural birth: unlimited at hospital network\\nR10 650 co-pay at non-network hospital\\nEmergency caesareans only\\n�24/7 telephonic baby advice line\\n� Online antenatal classes\\n� Access to 24/7 maternity advice line\\n","dialysis":"PMB at DSP or 30% upfront co-payment ","cancer":"PMB at DSP or 30% upfront co-payment, \\n20% co-payment for non-network medicines\\nTerminal care: unlimited, subject to pre-authorisation \\n ","transplant":"PMB at DSP or 30% upfront co-payment ","mri":"In Hospital: R11 840 per family\\nwith R2 500 co-payment per scan\\n","prosthesisInternal":"PMB at preferred provider","prosthesisExternal":"External Prosthesis: PMBs only\\n\\nGeneral appliances and Hearing Aids: PMB\\n","rehab":"Physical Rehabilitation: R50 600 per family \\nAlternatives to hospitalisation:\\nR14 570 per family ","designatedServiceProvider":"Pharmacy Direct\\n40% co-payment for use of non-formulary non-DSP","conditionsCovered":"CDL in PMBs","formulary":"Yes ","partialLimits":"None","preferredProvider":"Bonitas Pharmacy Network and Optometry Network","overallAnualLimit":"None","medicationOverCounter":"R95 per event, max of R460 per family\\n40% co-payment for use of non-formulary non-DSP","medicationPrescribed":"(GP referred Acute medicine, x-rays and blood tests) limited to R1 500 per family\\n20% co-payment per script\\n40% co-payment for use of non-formulary non-DSP","practitionersGeneral":"GP consultation: Unlimited (subject to completion of Wellness Assessment first) R110 co-payment per visit, authorisation required after 6th visit \\n\\n2 non-network GP consultations for emergencies per family\\n\\nVirtual Care and Nurse consultations: unlimited at network GP and Nurse consultations \\n","specialistsCover":"1 visit per family up to R1 100\\nSubject to network GP referral and R220 co-payment per visit","dentistryCover":"1 consultation per beneficiary  \\nR110 co-payment applies","dentistryCoverSpecial":"No benefit","optical":"1 eye test per beneficiary at a network\\nR110 co-payment applies\\n\\nLimited to R350 at a non-network provider","ambulance":"Preferred provider: ER24                                    ","international":"R10 million per family for medical emergencies when traveling outside SA, \\n\\nAfrica Benefit per trip                                                   In and out-of-hospital: 100% of the BR\\n\\nAdditional benefit for compulsory COVID-19 test and medical quarantine up to \\nR10 000 per person","hospitalCoverAids":"Unlimited, subject to registration on the HIV/AIDS programme   ","artTtreatment":"Medicine must be obtained from DSP or 30% co-payment","preventative":"Preventative Care Benefit \\n� Flu vaccine\\n� HIV test\\n� Pap smear\\n- Dental fissure sealant for children < 16\\n- Contraceptives: R1 290 at DSP, or 40% co-payment\\n \\nWellness screening  includes:\\n� Blood pressure\\n� Glucose\\n� Cholesterol\\n� Body Mass Index\\n� Waist-to-hip ratio\\n\\nBenefit Booster: R940 per family, available after completing a wellness screening or online assessment  \\nContraceptives: R1 070 at DSP, or 40% co-payment\\n\\nPhysiotherapy: 2 consultations per beneficiary for sport-related injuries with a R110 co-payment per visit. . Subject to network GP/specialist referral \\n\\nManagement programmes\\nCancer, HIV/AIDS\\nHome-based Care(Quro medical services)","logo":"bonitas.jpg"},{"company":"Bonitas","name":"BonStart Plus","planType":"Edge plan\\n","coverLevel":"Low","hospital":"Network","chronic":"Network","serviceType":"Network","familyIncome":"N/A","mainContribution":"R1670","mainCompSavings":"R0.00","mainTotal":"R1670","dependendContributionAdult":"R1587","dependentCompSavingsAdult":"R0.00","dependentTotalAdult":"R1587","dependendContributionChild":"R735","dependentCompSavingsChild":"R0.00","dependentTotalChild":"R735","maxChildContribution":"","mainThreshold":"","dependentThresholdAdult":"","dependentThresholdChild":"","preferedHospitalProvider":"BonStart Hospital Network","overallLimit":"Unlimited","coPayment":"The use of non-DSP or non-Network Providers will have a co-payment\\n30% co-payment for use of non-network hospital\\n\\nR1 000 co-payment per admission, except for PMB emergencies\\n\\nCataract Surgery: R6 000 co-payment for use of non-DSP network\\n\\nDay surgery network for defined procedures: R10 650 co-payment at other hospitals\\n\\nProcedure co-payments\\nR2 550 co-payment: Arthroscopy (done as part of a surgical procedure) & Laparoscopic Hysterectomy","rate":"100% Scheme Rate","generalMedicin":"7 days' supply up to R390 �per admission","specialist":"Specialist: Unlimited - 100% of Scheme Rate\\nGP: Unlimited - 100% of Scheme Rate","dentistSurgical":" PMBs only","mentalHealth":"PMB at DSP","radiology":"100% Scheme Rate, unlimited","pathology":"100% Scheme Rate, unlimited","maternityBenefit":"Natural birth: unlimited at hospital network\\nR10 650 co-pay at non-Network hospital\\nEmergency caesareans only\\nOut-of-hospital:\\n� 6 Antenatal visits, 4 Postnatal midwife consultations, 1 visit can be used with a lactation specialist\\n� Online antenatal classes\\n� 2 x 2D scans per pregnancy\\n� 1 Amniocentesis test\\n� Hearing screening for newborns\\n� Congenital hypothyroidism screening for infants below 1 month \\n� 24/7 telephonic baby advice line\\n� Access to 24/7 maternity advice line","dialysis":"PMB at DSP or 30% upfront co-payment ","cancer":"PMB at DSP or 30% upfront co-payment\\n20% co-payment for non-network medicines\\nTerminal care: unlimited, subject to pre-authorisation \\n� Palliative care: unlimited\\n ","transplant":"PMB at DSP or 30% upfront co-payment ","mri":"In Hospital: R16 070 per family\\nwith R2 000 co-payment per scan\\n","prosthesisInternal":"R16 070 per family\\n- at preferred provider\\nJoint replacements, no benefit (PMB only)","prosthesisExternal":"External Prosthesis: PMBs only\\nGeneral appliances: R5 550 per family\\nAt preferred provider","rehab":"Physical Rehabilitation: R50 600 per family \\nAlternatives to hospitalisation:\\nR16 880 per family ","designatedServiceProvider":"Pharmacy Direct\\n40% co-payment for use of non-formulary non-DSP","conditionsCovered":"CDL in PMBs","formulary":"Yes ","partialLimits":"None","preferredProvider":"Bonitas Pharmacy Network and Optometry Network","overallAnualLimit":"None","medicationOverCounter":"R145 per event, max of R690 per family\\n40% co-payment for use of non-formulary non-DSP","medicationPrescribed":"(GP referred Acute medicine, x-rays and blood tests) limited to R2 800 per family\\n20% co-payment per script\\n40% co-payment for use of non-formulary non-DSP","practitionersGeneral":"GP consultation: Unlimited (subject to completion of Wellness Assessment first) R55 co-payment per visit, authorisation required after 10th visit  \\n\\n2 non-network GP consultations for emergencies per family\\n\\nVirtual Care and Nurse consultations: unlimited at network GP and Nurse consultations ","specialistsCover":"2 visits per family up to R2 000 with R110 co-pay per visit\\nSubject to network GP referral","dentistryCover":"1 consultation per beneficiary  \\nR55 co-payment applies","dentistryCoverSpecial":"No benefit","optical":"1 eye test per beneficiary at a network\\nR55 co-payment applies\\n\\nLimited to R350 at a non-network provider","ambulance":"Preferred provider: ER24                                    ","international":"R10 million per family for medical emergencies when traveling outside SA, \\n\\nAfrica Benefit per trip                                                   In and out-of-hospital: 100% of the BR\\n\\nAdditional benefit for compulsory COVID-19 test and medical quarantine up to \\nR10 000 per person","hospitalCoverAids":"Unlimited, subject to registration on the HIV/AIDS programme   ","artTtreatment":"Medicine must be obtained from DSP or 30% co-payment","preventative":"Preventative Care Benefit \\n� Flu vaccine\\n� HIV test\\n� Pap smear\\n- Dental fissure sealant for children < 16\\n- Contraceptives: R1 290 at DSP, or 40% co-payment\\n \\nWellness screening  includes:\\n� Blood pressure\\n� Glucose\\n� Cholesterol\\n� Body Mass Index\\n� Waist-to-hip ratio\\n\\nBenefit Booster: R940 per family, available after completing a wellness screening or online assessment  \\nContraceptives: R1 290 at DSP, or 40% co-payment\\n\\nPhysiotherapy: 4 consultations per beneficiary for sport-related injuries with a R55 co-payment per visit. Subject to network GP/specialist referral \\n\\nManagement programmes\\nCancer, HIV/AIDS\\nHome-based Care(Quro medical services)","logo":"bonitas.jpg"},{"company":"Bonitas","name":"Hospital Standard","planType":"Hospital plan","coverLevel":"Mid","hospital":"Any","chronic":"Network","serviceType":"N/A","familyIncome":"N/A","mainContribution":"R2592","mainCompSavings":"R0.00","mainTotal":"R2592","dependendContributionAdult":"R2184","dependentCompSavingsAdult":"R0.00","dependentTotalAdult":"R2184","dependendContributionChild":"R986","dependentCompSavingsChild":"R0.00","dependentTotalChild":"R986","maxChildContribution":"3","mainThreshold":"","dependentThresholdAdult":"","dependentThresholdChild":"","preferedHospitalProvider":"Any hospital \\n","overallLimit":"Unlimited","coPayment":"\\n\\nOncology medication and Kidney Dialysis: 20% co-payment for use of a non-network facility\\n\\nCataract Surgery: R6 230 co-payment for use of non-DSP network\\n\\nDay surgery procedures: R2 290 co-payment if day-hospital network is not used\\n\\nProcedure co-payments\\nR1 630: Colonoscopy, Conservative Back Treatment, Cystoscopy, Facet Joint Injections, Flexible sigmoidoscopy, Functional nasal surgery, Gastroscopy, Hysteroscopy (not endometrial ablation), Myringotomy, Tonsillectomy, Adenoidectomy, Umbilical Hernia Repair and Varicose vein surgery \\n\\nR4 140: Arthroscopy, Diagnostic Laparoscopy, Laparoscopic Hysterectomy, Percutaneous Radiofrequency Ablations (Percutaneous Rhizotomies) \\n\\nR8 150: Laparoscopic Pyeloplasty, Laparoscopic Radical Prostatectomy, Nissen Fundoplication (Reflux surgery)\\n\\n\\n\\n","rate":"100% Scheme Rate","generalMedicin":"7 days' supply up to R510 �per admission","specialist":"Network Specialist: \\nUnlimited, covered in full\\nnon-Network Specialists: \\n100% of Scheme Rate\\nGP: Unlimited, 100% of Scheme Rate","dentistSurgical":"R3 500 co-payment per admission for children under 5 years and R5 000 for any other admission\\nGeneral anaesthetic only available to children under the age of 5 for extensive\\ndental treatment once per lifetime","mentalHealth":"\\nR34 610 per family\\nNo cover for physiotherapy for mental health admissions\\n\\n","radiology":"100% Scheme Rate, unlimited","pathology":"100% Scheme Rate, unlimited","maternityBenefit":"In-hospital: Unlimited\\nOut-of-hospital:\\n6 Antenatal visits\\n� Online antenatal classes\\n4 Postnatal midwife consultations, 1 visit can be used with a lactation specialist\\n2 x 2D scans per pregnancy\\n1 Amniocentesis test\\nHearing screening for newborns\\nCongenital hypothyroidism screening for infants below 1 month \\nPaediatric or GP consultations: \\n- 2 consults for child under 1 years; \\n- 1 consult for children between 1 and 2 years\\n24/7 telephonic baby advice line\\n� Access to 24/7 maternity advice line\\n ","dialysis":"Unlimited at a DSP \\n20% co-payment applies at a non-DSP","cancer":"\\nR165 500 per family, at preferred provider\\nBrachytherapy, sub-limit of R51 000 p.b. \\n20% co-payment apply for not using an Oncology medication network \\n� Palliative care: unlimited\\n ","transplant":"Unlimited, sub-limit of R34 520 per beneficiary for Corneal grafts","mri":"In and Out of Hospital: 28 600 per family - with R1 560 co-payment per scan","prosthesisInternal":"R48 440 per family\\n - at preferred provider\\nJoint replacements or back and neck surgery, no benefit (PMB only)","prosthesisExternal":"External Prosthesis: PMBs only\\nGeneral appliances: No benefit","rehab":"Physical Rehabilitation: R54 360 per family \\nAlternatives to hospitalisation:\\nR18 130 per family","designatedServiceProvider":"Pharmacy Direct\\n40% co-payment for use of non-formulary non-DSP","conditionsCovered":"CDL in PMBs","formulary":"Yes ","partialLimits":"None","preferredProvider":"None","overallAnualLimit":"N/A","medicationOverCounter":"No benefit","medicationPrescribed":"No benefit","practitionersGeneral":"No benefit","specialistsCover":"No benefit","dentistryCover":"No benefit","dentistryCoverSpecial":"No benefit","optical":"No benefit","ambulance":"Preferred Provider: ER24","international":"R10 million per family for medical emergencies when traveling outside SA, \\n\\nAfrica Benefit per trip                                                   In and out-of-hospital: 100% of the BR\\n\\nAdditional benefit for compulsory COVID-19 test and medical quarantine up to \\nR10 000 per person","hospitalCoverAids":"Unlimited, subject to registration on the HIV/AIDS programme   ","artTtreatment":"Medicine must be obtained from DSP","preventative":"Preventative Care Benefit \\n� Flu vaccine\\n� Full lipogram\\n� HIV test\\n� Pap smear (every 3 years, ages 21 - 65)\\n� Mammogram (every 2 years, ages 40+)\\n� Prostate screening (ages 45 - 69)\\nElderly\\n� Pneumococcal vaccine (every 5 years, ages 65+)\\n� Stool test for colon cancer (ages 50 -75)\\nChildcare Benefit: 1 GP consult per child between 2-12 years\\n� Dental fissure sealants: for beneficiaries under 16 years\\n\\nWellness screening benefit: Blood pressure, Glucose, Cholesterol, Body Mass Index, Waist-to-hip ratio\\n\\nBenefit Booster: R1 360 per family, available after completing a wellness screening or online assessment    \\nContraceptives: R1 720 at DSP, or 40% co-payment\\n\\nManagement programmes\\nBack and neck\\nCancer, Diabetes\\n HIV/AIDS\\nHome-based care(by Quro Medical Services)\\n","logo":"bonitas.jpg"},{"company":"Bonitas","name":"Primary","planType":"Traditional","coverLevel":"Mid","hospital":"Any","chronic":"Network","serviceType":"Network","familyIncome":"N/A","mainContribution":"R2654","mainCompSavings":"R0.00","mainTotal":"R2654","dependendContributionAdult":"R2076","dependentCompSavingsAdult":"R0.00","dependentTotalAdult":"R2076","dependendContributionChild":"R844","dependentCompSavingsChild":"R0.00","dependentTotalChild":"R844","maxChildContribution":"3","mainThreshold":"","dependentThresholdAdult":"","dependentThresholdChild":"","preferedHospitalProvider":"Any hospital","overallLimit":"Unlimited","coPayment":"Cataract Surgery: R6 230 co-payment for use of non-DSP network\\n\\nDay surgery procedures: R2 290 co-payment if day-hospital network is not used\\n\\nProcedure co-payments\\nR1 630: Colonoscopy, Conservative Back Treatment, Cystoscopy, Facet Joint Injections, Flexible sigmoidoscopy, Functional nasal surgery, Gastroscopy, Hysteroscopy (not endometrial ablation), Myringotomy, Tonsillectomy, Adenoidectomy, Umbilical Hernia Repair and Varicose vein surgery \\n\\nR4 140: Arthroscopy, Diagnostic Laparoscopy, Laparoscopic Hysterectomy, Percutaneous Radiofrequency Ablations (Percutaneous Rhizotomies) \\n\\nR8 150: Laparoscopic Pyeloplasty, Laparoscopic Radical Prostatectomy, Nissen Fundoplication (Reflux surgery)","rate":"100% Scheme Rate","generalMedicin":"7 days' supply up to R420 �per admission","specialist":"Network Specialist:\\nUnlimited covered in full \\nNon-network Specialists:\\n100% of Scheme\\nGP: Unlimited, 100% of Scheme Rate","dentistSurgical":"Maxillo-facial surgery and oral pathology-Managed Care protocols apply\\nHospitalisation (General Anaesthetic) -\\nR3 500 co-payment per admission for children under 5 years and R5 000 for any other admission","mentalHealth":"R17 010 per family\\nSub-limit of R10 280 per family, for out-of-hospital consultations\\nNo cover for physiotherapy for mental health admissions\\n","radiology":"100% Scheme Rate, unlimited","pathology":"100% Scheme Rate, unlimited","maternityBenefit":"\\n\\nIn-hospital: 100% Scheme Rate\\n(Includes midwifery services)\\n\\nOut-of-hospital: \\n6 Antenatal visits\\n4 postnatal midwife consultations. 1 visit can be used with a lactation specialist\\n2 x 2D scans\\n1 Amniocentesis test\\nHearing screening for newborns\\n24/7 telephonic baby advice line\\nCongenital hypothyroidism screening for infants below 1 month \\nPaediatric or GP consultations: \\n- 1 consult for child under 1 years; \\n- 1 consult for children between 1 and 2 years\\n� Online antenatal classes\\n� Access to 24/7 maternity advice line\\n\\n\\n\\n ","dialysis":"Unlimited at a DSP \\n20% co-payment applies at a non-DSP","cancer":"R165 500 per family, at preferred provider\\n20% co-payment apply for not using Oncology medication network \\nBrachytherapy, sub-limit of R51 000 p.b. \\n� Palliative care: unlimited","transplant":"PMB only","mri":"In and Out of Hospital: R14 240 per family\\nwith R1 560 co-payment per scan\\n","prosthesisInternal":"PMB only","prosthesisExternal":"External Prosthesis: PMBs only\\nGeneral appliances: limited to and included in the day-to-day benefit - The benefit may be\\nexceeded by R6 910 per family for Stoma Care and CPAP machines\\n","rehab":"Physical Rehabilitation: R54 360 per family \\nAlternatives to hospitalisation:\\nR18 130 per family","designatedServiceProvider":"Pharmacy Direct\\n40% co-payment for use of non-formulary non-DSP","conditionsCovered":"CDL in PMBs","formulary":"Restrictive","partialLimits":"None","preferredProvider":"Bonitas GP Network and Bonitas Specialist Network are the Scheme's DSPs","overallAnualLimit":"M:        R2 750\\nM+1 :   R4 920\\nM+2:    R5 780\\nM+3:    R6 210\\nM+4+:  R6 730","medicationOverCounter":"R515 per beneficiary, R1 510 per family\\nPaid from available day-to-day benefits, 20% co-payment for non-network, \\n20% co-payment for non-formulary medication","medicationPrescribed":"Paid from available day-to-day benefits, 20% co-payment if network is not used,\\n20% co-payment for non-formulary medication","practitionersGeneral":"(including virtual care consultations)\\nGP Network\\nM:       R1 960\\nM+1:  R3 610\\nM+2:   R4 270\\nM+3:   R4 590\\nM+4+: R5 200\\n\\nNon-network - Benefit incl in the Network benefit, 30% co-payment applies\\n� Member:   R635\\n� Member+1: R1 200\\n� Member+2:  R1 360\\n� Member+3: R1 530\\n� Member+4+: R1 810                               \\n \\n\\n","specialistsCover":"Subject to day-to-day benefit and GP referral","dentistryCover":"Covered from Risk,\\nDental programme limits are in place","dentistryCoverSpecial":"No benefit","optical":"R5 163 per family, every two years\\nContact lenses: R1 295 per beneficiary (included in family limit)\\n\\nNetwork limits per beneficiary:\\nEye examination: 1 test per beneficiary\\nFrames: R525 per beneficiary  \\nLenses: 100% of cost\\nNon-network limits per beneficiary:\\nEye examination:  R350 \\nFrames: R394 per beneficiary  \\nMultifocal lenses: R770 per lens,\\nBifocal lenses: R445 per lens,\\nSingle Vision: R210 per lens.","ambulance":"Preferred provider: ER24                                    ","international":"R10 million per family for medical emergencies when traveling outside SA, \\n\\nAfrica Benefit per trip                                                   In and out-of-hospital: 100% of the BR\\n\\nAdditional benefit for compulsory COVID-19 test and medical quarantine up to \\nR10 000 per person","hospitalCoverAids":"Unlimited, subject to registration on the HIV/AIDS programme   ","artTtreatment":"Medicine must be obtained from DSP","preventative":"Preventative Care Benefit \\n� Flu vaccine\\n� HIV test\\n� Pap smear (every 3 years, age 21-65)\\n� Mammogram (every 2 years, over age 40+)\\n� Prostate screening (men 45-69 years)\\n� Childhood immunisations\\nElderly\\n� Pneumococcal vaccine (every 5 years, aged 65+)\\n� Stool test for colon cancer (1 aged 50-75)\\nChildcare Benefit\\n� 1 GP consult per child between 2-12 years\\n\\nWellness screening benefit: Blood pressure, Glucose, Cholesterol, Body Mass Index, Waist-to-hip ratio\\n\\n Benefit Booster: R1 310 per family, available after completing a wellness screening or online assessment  \\nContraceptives: R1 660 family at DSP \\n\\nManagement programmes\\nCancer, HIV/AIDS\\nHome-based Care(Quro medical services)\\n","logo":"bonitas.jpg"},{"company":"Bonitas","name":"Primary Select","planType":"Traditional","coverLevel":"Low","hospital":"Network","chronic":"Network","serviceType":"Network","familyIncome":"N/A","mainContribution":"R2322","mainCompSavings":"R0.00","mainTotal":"R2322","dependendContributionAdult":"R1816","dependentCompSavingsAdult":"R0.00","dependentTotalAdult":"R1816","dependendContributionChild":"R738","dependentCompSavingsChild":"R0.00","dependentTotalChild":"R738","maxChildContribution":"3","mainThreshold":"","dependentThresholdAdult":"","dependentThresholdChild":"","preferedHospitalProvider":"\\nNetwork hospital\\n","overallLimit":"Unlimited","coPayment":"30% co-payment for use of non-network hospital\\n\\nCataract Surgery: R6 230 co-payment for use of non-DSP network\\n\\nDay surgery procedures: R4 570 co-payment if day-hospital network is not used\\n\\nProcedure co-payments\\nR1 630: Colonoscopy, Conservative Back Treatment, Cystoscopy, Facet Joint Injections, Flexible sigmoidoscopy, Functional nasal surgery, Gastroscopy, Hysteroscopy (not endometrial ablation), Myringotomy, Tonsillectomy, Adenoidectomy, Umbilical Hernia Repair and Varicose vein surgery \\n\\nR4 140: Arthroscopy, Diagnostic Laparoscopy, Laparoscopic Hysterectomy, Percutaneous Radiofrequency Ablations (Percutaneous Rhizotomies) \\n\\nR8 150: Laparoscopic Pyeloplasty, Laparoscopic Radical Prostatectomy, Nissen Fundoplication (Reflux surgery)","rate":"100% Scheme Rate","generalMedicin":"7 days' supply up to R420 �per admission","specialist":"Network Specialist:\\nUnlimited covered in full \\nNon-network Specialists:\\n100% of Scheme\\nGP: Unlimited, 100% of Scheme Rate","dentistSurgical":"Maxillo-facial surgery and oral pathology-Managed Care protocols apply\\nHospitalisation (General Anaesthetic) -\\nR3 500 co-payment per admission for children under 5 years and R5 000 for any other admission","mentalHealth":"R17 010 per family\\nIn and out-of-hospital consultations:\\nSub-limit of R10 280 per family\\n\\n- at DSP or 30% co-payment applies\\nNo cover for physiotherapy for mental health admissions\\n","radiology":"100% Scheme Rate, unlimited","pathology":"100% Scheme Rate, unlimited","maternityBenefit":"\\n\\nIn-hospital: 100% Scheme Rate\\n(Includes midwifery services)\\n\\nOut-of-hospital: \\n6 Antenatal visits\\n4 postnatal midwife consultations. 1 visit can be used with a lactation specialist\\n2 x 2D scans\\n1 Amniocentesis test\\nHearing screening for newborns\\n24/7 telephonic baby advice line\\nCongenital hypothyroidism screening for infants below 1 month \\nPaediatric or GP consultations: \\n- 1 consult for child under 1 years; \\n- 1 consult for children between 1 and 2 years\\n � Online antenatal classes\\n� Access to 24/7 maternity advice line\\n\\n\\n\\n ","dialysis":"Unlimited at a DSP \\n20% co-payment applies at a non-DSP","cancer":"R165 500 per family, at preferred provider\\n20% co-payment apply for not using Oncology medication network \\nBrachytherapy, sub-limit of R51 000 p.b. \\n� Palliative care: unlimited","transplant":"PMB only","mri":"In and Out of Hospital: R14 240 per family\\nwith R1 560 co-payment per scan\\n","prosthesisInternal":"PMB only","prosthesisExternal":"External Prosthesis: PMBs only\\nGeneral appliances: limited to and included in the day-to-day benefit - The benefit may be\\nexceeded by R6 910 per family for Stoma Care and CPAP machines\\n","rehab":"Physical Rehabilitation: R54 360 per family \\nAlternatives to hospitalisation:\\nR18 130 per family","designatedServiceProvider":"Pharmacy Direct\\n40% co-payment for use of non-formulary non-DSP","conditionsCovered":"CDL in PMBs","formulary":"Restrictive","partialLimits":"None","preferredProvider":"Bonitas GP Network and Bonitas Specialist Network are the Scheme's DSPs","overallAnualLimit":"M:        R2 750\\nM+1 :   R4 920\\nM+2:    R5 780\\nM+3:    R6 210\\nM+4+:  R6 730","medicationOverCounter":"R515 per beneficiary, R1 510 per family\\nPaid from available day-to-day benefits, 20% co-payment for non-network, \\n20% co-payment for non-formulary medication","medicationPrescribed":"Paid from available day-to-day benefits, 20% co-payment if network is not used,\\n20% co-payment for non-formulary medication","practitionersGeneral":"(including virtual care consultations)\\n2 nominated GPs per beneficiary\\nGP Network\\nM:       R1 960\\nM+1:  R3 610\\nM+2:   R4 270\\nM+3:   R4 590\\nM+4+: R5 200\\n\\nNon-network /non-nominated GP:\\n2 visits per family (30% co-pay apply)\\nLimited to and included in Network benefit\\n\\n","specialistsCover":"Subject to day-to-day benefit and GP referral","dentistryCover":"Covered from Risk,\\nDental programme limits are in place","dentistryCoverSpecial":"No benefit","optical":"R5 163 per family, every two years\\nContact lenses: R1 295 per beneficiary (included in family limit)\\n\\nNetwork limits per beneficiary:\\nEye examination: 1 test per beneficiary\\nFrames: R525 per beneficiary  \\nLenses: 100% of cost\\nNon-network limits per beneficiary:\\nEye examination:  R350 \\nFrames: R394 per beneficiary  \\nMultifocal lenses: R770 per lens,\\nBifocal lenses: R445 per lens,\\nSingle Vision: R210 per lens.","ambulance":"Preferred provider: ER24                                    ","international":"R10 million per family for medical emergencies when traveling outside SA, \\n\\nAfrica Benefit per trip                                                   In and out-of-hospital: 100% of the BR\\n\\nAdditional benefit for compulsory COVID-19 test and medical quarantine up to \\nR10 000 per person","hospitalCoverAids":"Unlimited, subject to registration on the HIV/AIDS programme   ","artTtreatment":"Medicine must be obtained from DSP","preventative":"Preventative Care Benefit \\n� Flu vaccine\\n� HIV test\\n� Pap smear (every 3 years, age 21-65)\\n� Mammogram (every 2 years, over age 40+)\\n� Prostate screening (men 45-69 years)\\n� Childhood immunisations\\nElderly\\n� Pneumococcal vaccine (every 5 years, aged 65+)\\n� Stool test for colon cancer (1 aged 50-75)\\nChildcare Benefit\\n� 1 GP consult per child between 2-12 years\\n\\nWellness screening benefit: Blood pressure, Glucose, Cholesterol, Body Mass Index, Waist-to-hip ratio\\n\\n Benefit Booster: R1 310 per family, available after completing a wellness screening or online assessment  \\nContraceptives: R1 660 family at DSP \\n\\nManagement programmes\\nCancer, HIV/AIDS\\nHome-based Care(Quro medical services)\\n","logo":"bonitas.jpg"},{"company":"Bonitas","name":"Standard ","planType":"Traditional","coverLevel":"Mid","hospital":"Any","chronic":"Network","serviceType":"Network","familyIncome":"N/A","mainContribution":"R4230","mainCompSavings":"R0.00","mainTotal":"R4230","dependendContributionAdult":"R3667","dependentCompSavingsAdult":"R0.00","dependentTotalAdult":"R3667","dependendContributionChild":"R1241","dependentCompSavingsChild":"R0.00","dependentTotalChild":"R1241","maxChildContribution":"3","mainThreshold":"","dependentThresholdAdult":"","dependentThresholdChild":"","preferedHospitalProvider":"Any hospital \\n","overallLimit":"Unlimited","coPayment":"The use of non-DSP or non-Network Providers will have a co-payment\\n\\nDay surgery procedures: R2 290 co-payment if day-hospital network is not used\\n\\nHearing Aids: 20% co-payment\\n\\nOncology medication and Kidney Dialysis: 20% co-payment for use of a non-network facility\\n\\nHip and knee replacements: R31 170 co-payment for use of non-DSP network \\n\\nCataract Surgery: R6 230 co-payment for use of non-DSP network\\n\\nSpinal surgery: R15 590 co-pay if no assessment was done through the back and neck rehabilitation programme\\n\\nOTC and Acute medicine: 20% co-payment on medicine outside formulary or not obtained from DSP","rate":"100% Scheme Rate","generalMedicin":"7 days' supply up to R510 �per admission","specialist":"Network Specialist: \\nUnlimited, covered in full\\nnon-Network Specialists: \\n100% of Scheme Rate\\nGP: Unlimited: 100% of Scheme Rate","dentistSurgical":"Maxillo-facial surgery and oral pathology-\\nCovered at the Bonitas Dental Tariff\\nManaged Care protocols apply\\nHospitalisation (General Anaesthetic) - \\nR3 500 co-payment per admission for children under 5 years and R5 000 for any other admission","mentalHealth":"R43 620 per family\\nSub-limit of R17 070 per family, for out-of-hospital consultations\\nNo cover for physiotherapy for mental health admissions\\n","radiology":"100% Scheme Rate, unlimited","pathology":"100% Scheme Rate, unlimited","maternityBenefit":"In-hospital: Unlimited\\nOut-of-hospital:  \\n12 Antenatal visits\\n� Online antenatal classes\\n4 Postnatal midwife consultations, 1 visit can be used with a lactation specialist\\nAntenatal classes: R1 330\\n2 x 2D scans per pregnancy\\n1 Amniocentesis test \\nHearing screening for newborns\\nCongenital hypothyroidism screening for infants below 1 month \\nPaediatric or GP consultations: \\n- 2 consults for child under 1 years; \\n- 2 consults for children between 1 and 2 years\\n24/7 telephonic baby advice line\\n� Access to 24/7 maternity advice line\\n","dialysis":"Unlimited at a DSP \\n20% co-payment applies at a non-DSP","cancer":"\\nR344 500 per family, at preferred provider\\nBrachytherapy, sub-limit of R51 000 p.b. \\n20% co-payment apply for not using an Oncology medication network \\n� Palliative care: unlimited\\n ","transplant":"Unlimited, sub-limit of R34 520 per beneficiary for Corneal grafts","mri":"In and Out of Hospital: 28 600 per family - with R1 560 co-payment per scan","prosthesisInternal":"Combined limit for Internal and External prosthesis at preferred provider\\nR48 440 per family\\nBreast prosthesis sub-limit of R5 760 (limited to 2 per annum)\\nCochlear Implants: R304 300 per family \\nInternal Nerve Stimulators: R181 400 per family\\n\\nJointCare: hip and knee replacements surgery at DSP only(ICPS)\\n","prosthesisExternal":"External Prosthesis, shared limit with Internal prosthesis  \\nGeneral appliances: R8 410 per family - additional R7 180 per family will\\napply should Stoma Care and CPAP\\nmachines exceed the appliances limit\\nHearing aids: R17 530 per family every 5 years (20% co-payment ), at preferred provider","rehab":"Physical Rehabilitation: R54 360 per family \\nAlternatives to hospitalisation:\\nR18 130 per family","designatedServiceProvider":"Pharmacy Direct\\n40% co-payment for use of non-formulary non-DSP","conditionsCovered":"44 conditions covered","formulary":"Yes ","partialLimits":"18 non-CDL conditions, limited to\\nR10 530 per beneficiary, \\nR21 130 per family\\n\\n","preferredProvider":"Bonitas GP Network and Bonitas Specialist Network are the Scheme's DSPs","overallAnualLimit":"Combined limit for specialist, acute medicine, x-rays, blood tests and other out-of-hospital medical expenses (excluding GP consultations)\\nSubject to day-to-day limit\\n� M:     R6 380\\n� M+1:  R9 700\\n� M+2: R11 210\\n� M+3:  R12 250\\n� M+4+: R13 340","medicationOverCounter":"\\nSubject to day-to-day benefits\\nR845 per beneficiary, R2 580 per family\\n20% co-payment for use of non-formulary, non-DSP \\n","medicationPrescribed":"\\nSubject to day-to-day benefits\\n20% co-payment for use of non-formulary, non-DSP\\n","practitionersGeneral":"(including virtual care consultations)\\nGP Network\\n� Member:     R4 560\\n� Member+1:  R6 690\\n� Member+2:  R7 420\\n� Member+3:  R7 790\\n� Member+4+: R8 460\\n\\nNon-network - Benefit incl in the Network benefit, 30% co-payment applies\\n� Member:    R1 490\\n� Member+1:  R2 290\\n� Member+2:  R2 500\\n� Member+3:  R2 610\\n� Member+4+: R2 820                                \\n ","specialistsCover":"\\nSubject to day-to-day benefits\\nGP referral\\n","dentistryCover":"\\nSubject Bonitas Dental Tariff and clinical protocols ","dentistryCoverSpecial":"Covered at the Bonitas Dental Tariff  and clinical protocols","optical":"Benefit every two years\\nR6 700 per family per annum  \\nContact lenses: R1 965 per beneficiary \\n\\nNetwork limits per beneficiary:\\nEye examination: 1 test\\nFrames: R1 275  \\nLenses: 100% of cost \\nNon-network limits per beneficiary:\\nEye examination: R350 \\nFrames: R956 \\nMultifocal lenses: R770 per lens or\\nBifocal lenses: R445 per lens or\\nSingle Vision lenses: R210 per lens.","ambulance":"Preferred Provider: ER24","international":"R10 million per family for medical emergencies when traveling outside SA, \\n\\nAfrica Benefit per trip                                                   In and out-of-hospital: 100% of the BR\\n\\nAdditional benefit for compulsory COVID-19 test and medical quarantine up to \\nR10 000 per person","hospitalCoverAids":"Unlimited, subject to registration on the HIV/AIDS programme   ","artTtreatment":"Medicine must be obtained from DSP","preventative":"Preventative Care Benefit \\n� Flu vaccine\\n� Full lipogram (every 5 years, ages 20+)\\n� HIV test\\n� Pap smear (every 3 years, ages 21 - 65)\\n� Mammogram (every 2 years, ages 40+)\\n� Prostate screening (ages 45 - 69)\\n�   Childhood immunisations\\nElderly\\n� Pneumococcal vaccine (every 5 years, ages 65+)\\n� Stool test for colon cancer (ages 50 - 75)\\nChildcare Benefit: 1 GP consult per child between 2-12 years\\n� Dental fissure sealants: for beneficiaries under 16 years\\n\\nWellness screening benefit: Blood pressure, Glucose, Cholesterol, Body Mass Index, Waist-to-hip ratio\\n\\nBenefit Booster: R1 880 per family, available after completing a wellness screening or online assessment    \\nContraceptives: R1 720 at DSP (up to age 50), or 40% co-payment\\n\\nManagement programmes\\nBack and neck, Mental Wellness\\nCancer, Diabetes\\n HIV/AIDS, Hip and knee replacements\\nHome-based care(by Quro Medical Services)\\n","logo":"bonitas.jpg"},{"company":"Bonitas","name":"Standard Select","planType":"Traditional","coverLevel":"Mid","hospital":"Network","chronic":"Network","serviceType":"Network","familyIncome":"N/A","mainContribution":"R3822","mainCompSavings":"R0.00","mainTotal":"R3822","dependendContributionAdult":"R3307","dependentCompSavingsAdult":"R0.00","dependentTotalAdult":"R3307","dependendContributionChild":"R1119","dependentCompSavingsChild":"R0.00","dependentTotalChild":"R1119","maxChildContribution":"3","mainThreshold":"","dependentThresholdAdult":"","dependentThresholdChild":"","preferedHospitalProvider":"Network hospital\\n","overallLimit":"Unlimited","coPayment":"30% co-payment for use of non-network hospital\\n\\nThe use of non-DSP or non-Network Providers will have a co-payment\\n\\nDay surgery procedures: R4 570 co-payment if day-hospital network is not used\\n\\nHearing Aids: 20% co-payment\\n\\nOncology medication and Kidney Dialysis: 20% co-payment for use of a non-network facility\\n\\nHip and knee replacements: R31 170 co-payment for use of non-DSP network\\n \\nCataract Surgery: R6 230 co-payment for use of non-DSP network\\n\\nSpinal surgery: R15 590 co-pay if no assessment was done through the back and neck rehabilitation programme\\n\\nOTC and Acute medicine: 20% co-payment on medicine outside formulary or not obtained from DSP","rate":"100% Scheme Rate","generalMedicin":"7 days' supply up to R510 �per admission","specialist":"Network Specialist: \\nUnlimited, covered in full\\nnon-Network Specialists: \\n100% of Scheme Rate\\nGP: Unlimited, 100% of Scheme Rate","dentistSurgical":"Maxillo-facial surgery and oral pathology-\\nCovered at the Bonitas Dental Tariff\\nManaged Care protocols apply\\nHospitalisation (General Anaesthetic) - \\nR3 500 co-payment per admission for children under 5 years and R5 000 for any other admission","mentalHealth":"R43 620 per family\\nSub-limit of R17 070 per family, for out-of-hospital consultations\\nNo cover for physiotherapy for mental health admissions\\n","radiology":"100% Scheme Rate, unlimited","pathology":"100% Scheme Rate, unlimited","maternityBenefit":"In-hospital: Unlimited\\nOut-of-hospital:  \\n12 Antenatal visits\\n� Online antenatal classes\\n4 Postnatal midwife consultations, 1 visit can be used with a lactation specialist\\nAntenatal classes: R1 330\\n2 x 2D scans per pregnancy\\n1 Amniocentesis test\\nHearing screening for newborns\\nCongenital hypothyroidism screening for infants below 1 month \\nPaediatric or GP consultations: \\n- 2 consults for child under 1 years; \\n- 2 consults for children between 1 and 2 years\\n24/7 telephonic baby advice line\\n� Access to 24/7 maternity advice line\\n","dialysis":"Unlimited at a DSP \\n20% co-payment applies at a non-DSP","cancer":"\\nR344 500 per family, at preferred provider\\nBrachytherapy, sub-limit of R51 000 p.b. \\n20% co-payment apply for not using an  Oncology medication network \\n� Palliative care: unlimited \\n ","transplant":"Unlimited, sub-limit of R34 520 per beneficiary for Corneal grafts","mri":"In and Out of Hospital: 28 600 per family - with R1 560 co-payment per scan","prosthesisInternal":"Combined limit for Internal and External prosthesis at preferred provider\\nR48 440 per family\\nBreast prosthesis sub-limit of R5 760 (limited to 2 per annum)\\nCochlear Implants: R304 300 per family \\nInternal Nerve Stimulators: R181 400 per family\\n\\nJointCare: hip and knee replacements surgery at DSP only(ICPS)\\n","prosthesisExternal":"External Prosthesis, shared limit with Internal prosthesis  \\nGeneral appliances: R8 410 per family - additional R7 180 per family will\\napply should Stoma Care and CPAP\\nmachines exceed the appliances limit\\nHearing aids: R17 530 per family every 5 years (20% co-payment ), at preferred provider","rehab":"Physical Rehabilitation: R54 360 per family \\nAlternatives to hospitalisation:\\nR18 130 per family","designatedServiceProvider":"Pharmacy Direct\\n40% co-payment for use of non-formulary non-DSP","conditionsCovered":"44 conditions covered","formulary":"Yes ","partialLimits":"18 non-CDL conditions, limited to\\nR10 530 per beneficiary, \\nR21 130 per family\\n\\n","preferredProvider":"Bonitas GP Network and Bonitas Specialist Network are the Scheme's DSPs","overallAnualLimit":"Combined limit for specialist, acute medicine, x-rays, blood tests and other out-of-hospital medical expenses (excluding GP consultations)\\nSubject to day-to-day limit\\n� M:     R6 380\\n� M+1:  R9 700\\n� M+2: R11 210\\n� M+3:  R12 250\\n� M+4+: R13 340","medicationOverCounter":"\\nSubject to day-to-day benefits\\nR845 per beneficiary, R2 580 per family\\n20% co-payment for use of non-formulary, non-DSP \\n","medicationPrescribed":"\\nSubject to day-to-day benefits\\n20% co-payment for use of non-formulary, non-DSP\\n","practitionersGeneral":"(including virtual care consultations)\\n2 nominated GPs per beneficiary\\nGP Network\\n� Member:     R4 560\\n� Member+1:  R6 690\\n� Member+2:  R7 420\\n� Member+3:  R7 790\\n� Member+4+: R8 460\\n\\nNon-network /non-nominated GP:\\n2 visits per family (30% co-pay apply)\\nLimited to and included in Network benefit\\n","specialistsCover":"\\nSubject to day-to-day benefits\\nGP referral\\n","dentistryCover":"\\nSubject Bonitas Dental Tariff and clinical protocols ","dentistryCoverSpecial":"Covered at the Bonitas Dental Tariff  and clinical protocols","optical":"Benefit every two years\\nR6 700 per family per annum  \\nContact lenses: R1 965 per beneficiary \\n\\nNetwork limits per beneficiary:\\nEye examination: 1 test\\nFrames: R1 275  \\nLenses: 100% of cost \\nNon-network limits per beneficiary:\\nEye examination: R350 \\nFrames: R956 \\nMultifocal lenses: R770 per lens or\\nBifocal lenses: R445 per lens or\\nSingle Vision lenses: R210 per lens.","ambulance":"Preferred Provider: ER24","international":"R10 million per family for medical emergencies when traveling outside SA, \\n\\nAfrica Benefit per trip                                                   In and out-of-hospital: 100% of the BR\\n\\nAdditional benefit for compulsory COVID-19 test and medical quarantine up to \\nR10 000 per person","hospitalCoverAids":"Unlimited, subject to registration on the HIV/AIDS programme   ","artTtreatment":"Medicine must be obtained from DSP","preventative":"Preventative Care Benefit \\n� Flu vaccine\\n� Full lipogram (every 5 years, ages 20+)\\n� HIV test\\n� Pap smear (every 3 years, ages 21 - 65)\\n� Mammogram (every 2 years, ages 40+)\\n� Prostate screening (ages 45 - 69)\\n�   Childhood immunisations\\nElderly\\n� Pneumococcal vaccine (every 5 years, ages 65+)\\n� Stool test for colon cancer (ages 50 - 75)\\nChildcare Benefit: 1 GP consult per child between 2-12 years\\n� Dental fissure sealants: for beneficiaries under 16 years\\n\\nWellness screening benefit: Blood pressure, Glucose, Cholesterol, Body Mass Index, Waist-to-hip ratio\\n\\nBenefit Booster: R1 880 per family, available after completing a wellness screening or online assessment    \\nContraceptives: R1 720 at DSP (up to age 50), or 40% co-payment\\n\\nManagement programmes\\nBack and neck, Mental Wellness\\nCancer, Diabetes\\n HIV/AIDS, Hip and knee replacements\\nHome-based care(by Quro Medical Services)\\n","logo":"bonitas.jpg"},{"company":"Discovery","name":"Essential Delta Comprehensive","planType":"Threshold option","coverLevel":"High","hospital":"Network","chronic":"Network","serviceType":"Any","familyIncome":"","mainContribution":"R4059","mainCompSavings":"R716","mainTotal":"R4775","dependendContributionAdult":"R3834","dependentCompSavingsAdult":"R676","dependentTotalAdult":"R4510","dependendContributionChild":"R814","dependentCompSavingsChild":"R143","dependentTotalChild":"R957","maxChildContribution":"3","mainThreshold":"R21,700","dependentThresholdAdult":"R21,700","dependentThresholdChild":"R4,150","preferedHospitalProvider":"Network hospital","overallLimit":"Unlimited","coPayment":"R9 100 co-payment for use of non-network hospital\\n\\nScopes co-payment:\\nDay clinic R3 800, In-hospital R5 550 co-payment will reduce to R4 450 if performed by a value-based network doctor\\n\\nIf both a Gastroscopy and Colonoscopy is performed in the same admission, the following co-payment apply\\nDay clinic R4 650, In-hospital R6 900 co-payment will reduce to R5 600 if performed by a value-based network doctor  \\n\\nR9 100 upfront payment for scopes performed outside the Day surgery network \\nIf both a Gastroscopy and Colonoscopy is performed R6 900 co-pay apply \\n\\nNo co-payment if done in doctor's room as part of a PMB where indicated and approved for Dyspepsia or children under 12 years \\n\\nDefined list of Procedure: R9 100 admission to facility outside of Day surgery network","rate":"100% Scheme Rate","generalMedicin":"Paid from available day-to-day benefits","specialist":"\\nFull cover for Network specialists.\\nNon-network Specialists and GPs: \\n100% of Scheme Rate\\n","dentistSurgical":"Severe dental and oral surgery covers a defined list of procedures with no co-payment or limits \\n        \\nDental admissions co-payments: \\nMembers 13 years and older,     \\nHospital R7 350, Day clinic R4 700\\nMembers under 13 years,      \\nHospital R2 850, Day clinic R1 300\\nThereafter paid from hospital benefit\\nDental appliances, their placements and orthodontic treatments (incl. related accounts) paid from day-to-day benefits limit of R30 750 per beneficiary\\n\\nBasic Dental Trauma Benefit\\nCover for dental appliances and prostheses and the placement thereof  paid up to an annual limit of R58 000 per person per year\\n","mentalHealth":"In Hospital: 21 days per beneficiary  or \\nOut of Hospital: 15 consultations per beneficiary for treatment of (Major affective disorders, Anorexia, Bulimia) and 12 consultations per beneficiary for treatment of acute stress disorder due to recent trauma. Subject to PMB and Psychiatric Network (20% co-payment for non-DSP) \\n \\n21 days per beneficiary for alcohol and drug rehabilitation, 3 days per approved admission for detoxification\\n","radiology":"100% of Scheme Rate - Unlimited","pathology":"100% of Scheme Rate - Unlimited","maternityBenefit":"\\nIn Hospital: Unlimited\\nPrivate ward cover up to R2 320 per day\\nOut-of-Hospital: \\n� 12 Antenatal visit \\n� R5 350 for essential registered devices (25% co-payment applies)\\n� Certain blood tests\\n� 5 Pre- or postnatal visits \\n� 2 x 2D scans incl. 1 nuchal translucency test. 3D and 4D scans are covered at 2D scans rate\\n� For two years after birth: two visits for baby with a GP, Paediatrician or ENT\\n� One six week post-birth with a midwife, GP or gynaecologist\\n� 1 flu vaccination during pregnancy\\n� 1 nutritional assessment\\n� Two mental health consultations\\n� 1 lactation consult \\n� Assisted Reproductive Therapy, limited to         R115 000 per person (25% co-payment applies)\\n\\n\\n ","dialysis":"Full cover for approved treatment plan and use of network provide, otherwise 20% co-payments will apply","cancer":"First R400 000. Thereafter, with a 20% co-payment, except if the treatment forms part of the Extended Oncology Benefit.\\nOncology Innovation Benefit: cover a defined list of innovative cancer medicines that meet the Scheme�s criteria, subject to a 25% co-payments\\nMedicine from DSP or 20% co-payment\\nAdvanced Illness benefit: comprehensive\\npalliative care programme","transplant":"100% Scheme Rate\\nNo details supplied for cadaver donor costs or live related donor costs","mri":"\\nIn Hospital: Up to 100% of Scheme Rate if related to Hospital Admission, if not related to admission or for conservative neck and back scans, R3 270 co-payment applies \\n\\nOut-of-Hospital:�R3 270 co-pay applies\\nConservative back and neck scans - limit  \\nof one scan per spinal and neck region\\n\\n","prosthesisInternal":"Cochlear implants and Auditory Brain implants and processors:\\n- R230 400 per beneficiary per benefit \\nInternal Nerve Stimulators \\n- R165 300 per beneficiary \\nShoulder joint prosthesis\\n- Network Provider: Unlimited \\n- Non-Network Provider: R 42 950 \\nMajor joints surgery (80% of scheme rate)\\n- Network Provider: Unlimited \\n- Non-Network Provider: R 30 900 \\nProsthetic devices used in spinal surgery: \\n- Network Provider: Unlimited \\n- Non-Network Provider: \\n    - First level: R26 250 per beneficiary\\n    - Two or more levels: R52 500 per beneficiary ","prosthesisExternal":"Subject to day-to-day benefits\\nR40 550 per family per annum\\nHearing Aids: R21 350 per family \\n","rehab":"Connected care: quality care at home\\nCare offered: \\n- Postnatal care\\n- IV infusions (drips) \\n- Wound care\\n- Advanced illness care : Unlimited palliative care cover for approved care \\n","designatedServiceProvider":"MedXpress","conditionsCovered":"49 conditions including in PMBs","formulary":"Yes","partialLimits":"22 Non-CDL conditions\\nOut-of-formulary drugs - paid up to a monthly drug amount. 20% co-payment for use of non-DSP. Specialised Medicine and Technology Benefit, R200 000 per person (20% co-payment applies) ","preferredProvider":"None","overallAnualLimit":"None","medicationOverCounter":"Subject to available Savings\\n(Does not accumulate to threshold) ","medicationPrescribed":"Preferred medicine paid at 100%  \\nNon-preferred medicine up to 75% DHR if the price of the medicine is within 25% of the preferred equivalent, or up to 50% of\\nthe DHR if the price of the medicine is more than 50% of the price of the preferred equivalent. Limited to:\\n� M :R22 950\\n� M+1: R27 950\\n� M+2: R33 650\\n� M+3+: R36 700 \\nFor accumulation to threshold and payments from above threshold benefits\\n","practitionersGeneral":"Subject to Savings\\nExtender Benefit (DEB) covers: \\nUnlimited pharmacy clinic consultations in wellness network, video call consults with network GP. \\nUnlimited consultation with a network GP who meets the digital criteria, when referred\\nUnlimited after Threshold is reached ","specialistsCover":"Subject to available Savings. Unlimited once Threshold is reached\\nNetwork specialists: covered in full\\nnon-Network specialists: 100% of Scheme Rate\\nAllied, therapeutic and psychology healthcare services\\n- M: R12 600\\n- M+1: R17 840\\n- M+2: R23 150\\n- M+3+: R27 350","dentistryCover":"\\nSubject to available Savings. Unlimited at Scheme Rate after Threshold is reached\\n","dentistryCoverSpecial":"Subject to available Savings and Threshold\\nR30 750 per beneficiary for dental appliances and orthodontic treatment\\n","optical":"\\nR6 180 per beneficiary, paid from Savings, thereafter Threshold\\n(20% discount on frames and lenses at a network optometrist at point of sale) \\n","ambulance":"Preferred provider: Discovery 911","international":"Only for emergencies while travelling abroad; R5 million, 90 days travelling\\nAfrica Evacuation Benefit","hospitalCoverAids":"Subject to registration on HIVCare Programme and use of Network Providers","artTtreatment":"Approved meds covered in full. Meds not on list covered up to a set monthly amount. 20% co-pay applies for use of non DSP Network","preventative":"Screening benefits for Adults and Seniors \\nKids Screening - growth assessments,\\nhealth and milestone tracking \\n- Stem Cell Banking with Netcells\\n- International Second Opinion Services\\n- Overseas Treatment benefit, R500 000 per person - with 20% co-payment\\n- Trauma Recovery Extender Benefit \\n\\nChronic Care Programmes  :\\n- Diabetes\\n- Mental health\\n- HIV or Heart-related medical conditions\\n\\nConservative Care Programmes : \\n- Dyspepsia (severe heartburn)\\n- Tonsillitis (children under the age of 16) \\n\\nSpinal Care Programme\\n\\nConnected Care for Acute Care at Home\\n\\nConnected Care a digital health care service through Discovery app\\n(refer to brochure for detailed information)\\n ","logo":"Discovery.png"},{"company":"Discovery","name":"Essential Comprehensive","planType":"Threshold option","coverLevel":"High","hospital":"Any","chronic":"Network","serviceType":"Any","familyIncome":"","mainContribution":"R4506","mainCompSavings":"R795","mainTotal":"R5301","dependendContributionAdult":"R4259","dependentCompSavingsAdult":"R751","dependentTotalAdult":"R5010","dependendContributionChild":"R909","dependentCompSavingsChild":"R160","dependentTotalChild":"R1069","maxChildContribution":"3","mainThreshold":"R21,700","dependentThresholdAdult":"R21,700","dependentThresholdChild":"R4,150","preferedHospitalProvider":"Any hospital","overallLimit":"Unlimited","coPayment":"Scopes co-payment:\\nDay clinic R3 800, In-hospital R5 550 co-payment will reduce to R4 450 if performed by a value-based network doctor \\n\\nIf both a Gastroscopy and Colonoscopy is performed in the same admission, the following co-payment apply\\nDay clinic R4 650, In-hospital R6 900 co-payment will reduce to R5 600 if performed by a value-based network doctor  \\n\\nR5 950 upfront payment for scopes performed outside the Day surgery network \\nIf both a Gastroscopy and Colonoscopy is performed R6 900 co-pay apply \\n\\nNo co-payment if done in doctor's room as part of a PMB where indicated and approved for Dyspepsia or children under 12 years \\n\\nDefined list of Procedure: R5 950 admission to facility outside of Day surgery network","rate":"100% Scheme Rate","generalMedicin":"Paid from available day-to-day benefits","specialist":"\\nFull cover for Network specialists\\nNon-network Specialists and GPs: \\n100% of Scheme Rate: Unlimited\\n","dentistSurgical":"Severe dental and oral surgery covers a defined list of procedures with no co-payment or limits \\n        \\nDental admissions co-payments: \\nMembers 13 years and older,     \\nHospital R7 350, Day clinic R4 700\\nMembers under 13 years,      \\nHospital R2 850, Day clinic R1 300\\nThereafter paid from hospital benefit\\nDental appliances, their placements and orthodontic treatments (incl. related accounts) paid from day-to-day benefits limit of R30 750 per beneficiary\\n\\nBasic Dental Trauma Benefit\\nCover for dental appliances and prostheses and the placement thereof  paid up to an annual limit of R58 000 per person per year\\n","mentalHealth":"In Hospital: 21 days per beneficiary  or \\nOut of Hospital: 15 consultations per beneficiary for treatment of (Major affective disorders, Anorexia, Bulimia) and 12 consultations per beneficiary for treatment of acute stress disorder due to recent trauma. Subject to PMB and Psychiatric Network (20% co-payment for non-DSP) \\n \\n21 days per beneficiary for alcohol and drug rehabilitation, 3 days per approved admission for detoxification\\n","radiology":"100% of Scheme Rate - Unlimited","pathology":"100% of Scheme Rate - Unlimited","maternityBenefit":"\\nIn Hospital: Unlimited\\nPrivate ward cover up to R2 320 per day\\nOut-of-Hospital: \\n� 12 Antenatal visit \\n� R5 350 for essential registered devices (25% co-payment applies)\\n� Certain blood tests\\n� 5 Pre- or postnatal visits \\n� 2 x 2D scans incl. 1 nuchal translucency test. 3D and 4D scans are covered at 2D scans rate\\n� For two years after birth: two visits for baby with a GP, Paediatrician or ENT\\n� One six week post-birth with a midwife, GP or gynaecologist\\n� 1 flu vaccination during pregnancy\\n� 1 nutritional assessment\\n� Two mental health consultations\\n� 1 lactation consult \\n� Assisted Reproductive Therapy, limited to         R115 000 per person (25% co-payment applies)\\n\\n\\n ","dialysis":"Full cover for approved treatment plan and use of network provide, otherwise 20% co-payments will apply","cancer":"First R400 000. Thereafter, with a 20% co-payment, except if the treatment forms part of the Extended Oncology Benefit.\\nOncology Innovation Benefit: cover a defined list of innovative cancer medicines that meet the Scheme�s criteria, subject to a 25% co-payments\\nMedicine from DSP or 20% co-payment\\nAdvanced Illness benefit: comprehensive\\npalliative care programme","transplant":"100% Scheme Rate\\nNo details supplied for cadaver donor costs or live related donor costs","mri":"\\nIn Hospital: Up to 100% of Scheme Rate if related to Hospital Admission, if not related to admission or for conservative neck and back scans, R3 270 co-payment applies \\n\\nOut-of-Hospital:�R3 270 co-pay applies\\nConservative back and neck scans - limit  \\nof one scan per spinal and neck region\\n\\n","prosthesisInternal":"Cochlear implants and Auditory Brain implants and processors:\\n- R230 400 per beneficiary per benefit \\nInternal Nerve Stimulators \\n- R165 300 per beneficiary \\nShoulder joint prosthesis\\n- Network Provider: Unlimited \\n- Non-Network Provider: R 42 950 \\nMajor joints surgery (80% of scheme rate)\\n- Network Provider: Unlimited \\n- Non-Network Provider: R 30 900 \\nProsthetic devices used in spinal surgery: \\n- Network Provider: Unlimited \\n- Non-Network Provider: \\n    - First level: R26 250 per beneficiary\\n    - Two or more levels: R52 500 per beneficiary ","prosthesisExternal":"Subject to day-to-day benefits\\nR40 550 per family per annum\\nHearing Aids: R21 350 per family \\n","rehab":"Connected care: quality care at home\\nCare offered: \\n- Postnatal care\\n- IV infusions (drips) \\n- Wound care\\n- Advanced illness care : Unlimited palliative care cover for approved care \\n","designatedServiceProvider":"Any Network pharmacy","conditionsCovered":"49 conditions including in PMBs","formulary":"Yes","partialLimits":"22 Non-CDL conditions\\nOut-of-formulary drugs - paid up to a monthly drug amount. 20% co-payment for use of non-DSP. Specialised Medicine and Technology Benefit, R200 000 per person (20% co-payment applies) ","preferredProvider":"None","overallAnualLimit":"None","medicationOverCounter":"Subject to available Savings\\n(Does not accumulate to threshold) ","medicationPrescribed":"Preferred medicine paid at 100%  \\nNon-preferred medicine up to 75% DHR if the price of the medicine is within 25% of the preferred equivalent, or up to 50% of\\nthe DHR if the price of the medicine is more than 50% of the price of the preferred equivalent. Limited to:\\n� M: R22 950\\n� M+1: R27 950\\n� M+2: R33 650\\n� M+3+: R36 700 \\nFor accumulation to threshold and payments from above threshold benefits\\n","practitionersGeneral":"Subject to Savings\\nExtender Benefit (DEB) covers: \\nUnlimited pharmacy clinic consultations in wellness network, video call consults with network GP. \\nUnlimited consultation with a network GP who meets the digital criteria, when referred\\nUnlimited after Threshold is reached ","specialistsCover":"Subject to available Savings. Unlimited once Threshold is reached\\nNetwork specialists: covered in full\\nnon-Network specialists: 100% of Scheme Rate\\nAllied, therapeutic and psychology healthcare services\\n- M: R12 600\\n- M+1: R17 840\\n- M+2: R23 150\\n- M+3+: R27 350","dentistryCover":"\\nSubject to available Savings. Unlimited at Scheme Rate after Threshold is reached\\n","dentistryCoverSpecial":"Subject to available Savings and Threshold\\nR30 750 per beneficiary for dental appliances and orthodontic treatment\\n","optical":"\\nR6 180 per beneficiary, paid from Savings, thereafter Threshold\\n(20% discount on frames and lenses at a network optometrist at point of sale) \\n","ambulance":"Preferred provider: Discovery 911","international":"Only for emergencies while travelling abroad; R5 million, 90 days travelling\\nAfrica Evacuation Benefit","hospitalCoverAids":"Subject to registration on HIVCare Programme and use of Network Providers","artTtreatment":"Approved meds covered in full. Meds not on list covered up to a set monthly amount. 20% co-pay applies for use of non DSP Network","preventative":"Screening benefits for Adults and Seniors \\nKids Screening - growth assessments,\\nhealth and milestone tracking \\n- Stem Cell Banking with Netcells\\n- International Second Opinion Services\\n- Overseas Treatment benefit, R500 000 per person - with 20% co-payment\\n- Trauma Recovery Extender Benefit \\n\\nChronic Care Programmes  :\\n- Diabetes\\n- Mental health\\n- HIV or Heart-related medical conditions\\n\\nConservative Care Programmes : \\n- Dyspepsia (severe heartburn)\\n- Tonsillitis (children under the age of 16) \\n\\nSpinal Care Programme\\n\\nConnected Care for Acute Care at Home\\n\\nConnected Care a digital health care service through Discovery app\\n(refer to brochure for detailed information)\\n ","logo":"Discovery.png"},{"company":"Discovery","name":"Classic Smart Comprehensive ","planType":"Threshold option","coverLevel":"High","hospital":"Network","chronic":"Network","serviceType":"Any","familyIncome":"","mainContribution":"R4585","mainCompSavings":"R0.00","mainTotal":"R4585","dependendContributionAdult":"R4230","dependentCompSavingsAdult":"R0.00","dependentTotalAdult":"R4230","dependendContributionChild":"R1459","dependentCompSavingsChild":"R0.00","dependentTotalChild":"R1459","maxChildContribution":"3","mainThreshold":"R24,850","dependentThresholdAdult":"R24,850","dependentThresholdChild":"R850","preferedHospitalProvider":"Network hospital","overallLimit":"Unlimited","coPayment":"R10 400 co-payment for use of non-network hospital\\n\\nScopes co-payment:\\nDay clinic R3 800, In-hospital R5 550 co-payment will reduce to R4 450 if performed by a value-based network doctor \\n\\nIf both a Gastroscopy and Colonoscopy is performed in the same admission, the following co-payment apply\\nDay clinic R4 650, In-hospital R6 900 co-payment will reduce to R5 600 if performed by a value-based network doctor  \\n\\nR10 400 upfront payment for scopes performed outside the Day surgery network \\nIf both a Gastroscopy and Colonoscopy is performed R6 900 co-pay apply \\n\\nNo co-payment if done in doctor's room as part of a PMB where indicated and approved for Dyspepsia or children under 12 years \\n\\nDefined list of Procedure: R10 400 admission to facility outside of Day surgery network","rate":"200% Scheme Rate ","generalMedicin":"Paid from available day-to-day benefits","specialist":"Full cover for Network specialists\\nNon-network Specialists and GPs: \\n200% of Scheme Rate\\n","dentistSurgical":"Severe dental and oral surgery covers a defined list of procedures with no co-payment or limits \\n        \\nDental admissions co-payments: \\nMembers 13 years and older,     \\nHospital R7 350, Day clinic R4 700\\nMembers under 13 years,      \\nHospital R2 850, Day clinic R1 300\\nThereafter paid from hospital benefit\\nDental appliances, their placements and orthodontic treatments (incl. related accounts) paid from day-to-day benefits limit of R30 750 per beneficiary. Benefits apply once the Annual Threshold is reached.\\n\\nBasic Dental Trauma Benefit\\nCover for dental appliances and prostheses and the placement thereof  paid up to an annual limit of R58 000 per person per year\\n","mentalHealth":"In Hospital: 21 days per beneficiary  or \\nOut of Hospital: 15 consultations per beneficiary for treatment of (Major affective disorders, Anorexia, Bulimia) and 12 consultations per beneficiary for treatment of acute stress disorder due to recent trauma. Subject to PMB and Psychiatric Network (20% co-payment for non-DSP) \\n \\n21 days per beneficiary for alcohol and drug rehabilitation, 3 days per approved admission for detoxification\\n","radiology":"100% of Scheme Rate - Unlimited","pathology":"100% of Scheme Rate - Unlimited","maternityBenefit":"\\nIn Hospital: Unlimited\\nPrivate ward cover up to R2 320 per day\\nOut-of-Hospital: \\n� 12 Antenatal visit \\n� R5 350 for essential registered devices (25% co-payment applies)\\n� Certain blood tests\\n� 5 Pre- or postnatal visits \\n� 2 x 2D scans incl. 1 nuchal translucency test. 3D and 4D scans are covered at 2D scans rate\\n� For two years after birth: two visits for baby with a GP, Paediatrician or ENT\\n� One six week post-birth with a midwife, GP or gynaecologist\\n� 1 flu vaccination during pregnancy\\n� 1 nutritional assessment\\n� Two mental health consultations\\n� 1 lactation consult \\n� Assisted Reproductive Therapy, limited to         R115 000 per person (25% co-payment applies)\\n\\n\\n ","dialysis":"Full cover for approved treatment plan and use of network provide, otherwise 20% co-payments will apply","cancer":"First R300 000. Thereafter, with a 20% co-payment. Medicine from DSP or 20% co-payment\\nOncology Innovation Benefit: cover a defined list of innovative cancer medicines that meet the Scheme�s criteria, subject to a 50% co-payments\\nAdvanced Illness benefit: comprehensive palliative care programme","transplant":"100% Scheme Rate\\nNo details supplied for cadaver donor costs or live related donor costs","mri":"\\nIn Hospital: Up to 100% of Scheme Rate if related to Hospital Admission, if not related to admission or for conservative neck and back scans, R3 270 co-payment applies \\n\\nOut-of-Hospital:�R3 270 co-pay applies\\nConservative back and neck scans - limit  \\nof one scan per spinal and neck region\\n\\n","prosthesisInternal":"Cochlear implants and Auditory Brain implants and processors:\\n- R230 400 per beneficiary per benefit \\nInternal Nerve Stimulators \\n- R165 300 per beneficiary \\nShoulder joint prosthesis\\n- Network Provider: Unlimited \\n- Non-Network Provider: R 42 950 \\nMajor joints surgery (80% of scheme rate)\\n- Network Provider: Unlimited \\n- Non-Network Provider: R 30 900 \\nProsthetic devices used in spinal surgery: \\n- Network Provider: Unlimited \\n- Non-Network Provider: \\n    - First level: R26 250 per beneficiary\\n    - Two or more levels: R52 500 per beneficiary ","prosthesisExternal":"Covered once you reach Threshold\\nFamily limit per annum\\n� R60 550 \\nHearing Aids: R26 600 per family","rehab":"Connected care: quality care at home\\nCare offered: \\n- Postnatal care\\n- IV infusions (drips) \\n- Wound care\\n- Advanced illness care : Unlimited palliative care cover for approved care \\n","designatedServiceProvider":"Any Network pharmacy","conditionsCovered":"CDL in PMB","formulary":"Yes","partialLimits":"Out-of-formulary drugs - paid up to a monthly drug amount.  20% co-payment for use of non-DSP ","preferredProvider":"None","overallAnualLimit":"None","medicationOverCounter":"Limited to R860 per family p.a. \\n(subject to network pharmacy)","medicationPrescribed":"Cover certain medicine as prescribed by Network GP at MedXpress or MedXpress Network Pharmacy\\nBeneficiary: R2 700\\nFamily: R4 340","practitionersGeneral":"Network GP : Unlimited\\nR60 co-payment per visit\\nExcluding video call consults, which are covered in full\\nUnlimited after Threshold is reached","specialistsCover":"\\nSelected specialist consultations: R5 380 per beneficiary, R10 750 per family. Subject to Smart Network GP referral. \\nSports injury benefit when referred by Smart network GP:\\n- 2 specialist visits per beneficiary\\n- 4 visits to either a physio, biokineticist or chiropractor\\n- Cover for basic X-rays. R115 co-payment per visit \\n","dentistryCover":"1 check-up with R115 co-payment\\nUnlimited at Scheme Rate after Threshold is reached","dentistryCoverSpecial":"Dental appliances benefit available after Threshold is reached ","optical":" \\nOne eye test per annum at Network Provider with an upfront payment of R60\\n(20% discount on frames and lenses at a network optometrist at point of sale) ","ambulance":"Preferred provider: Discovery 911","international":"Only for emergencies while travelling abroad; R5 million, 90 days travelling\\nAfrica Evacuation Benefit","hospitalCoverAids":"Subject to registration on HIVCare Programme and use of Network Providers","artTtreatment":"Approved meds covered in full. Meds not on list covered up to a set monthly amount. 20% co-pay applies for use of non DSP Network","preventative":"Screening benefits for Adults and Seniors \\nKids Screening - growth assessments,\\nhealth and milestone tracking \\n- Stem Cell Banking with Netcells\\n- International Second Opinion Services, 50% of cost of second opinion service.\\n- Overseas Treatment benefit, R500 000 per person - with 20% co-payment\\n- Trauma Recovery Extender Benefit \\n\\nChronic Care Programmes  :\\n- Diabetes\\n- Mental health\\n- HIV or Heart-related medical conditions\\n\\nConservative Care Programmes : \\n- Dyspepsia (severe heartburn)\\n- Tonsillitis (children under the age of 16) \\n- Spinal Care Programme\\n\\nConnected Care for Acute Care at Home\\n\\nConnected Care a digital health care service through Discovery app\\n(refer to brochure for detailed information)\\n ","logo":"Discovery.png"},{"company":"Discovery","name":"Classic Delta Comprehensive","planType":"Threshold option","coverLevel":"High","hospital":"Network","chronic":"Network","serviceType":"Any","familyIncome":"","mainContribution":"R4261","mainCompSavings":"R1420","mainTotal":"R5681","dependendContributionAdult":"R4034","dependentCompSavingsAdult":"R1344","dependentTotalAdult":"R5378","dependendContributionChild":"R849","dependentCompSavingsChild":"R283","dependentTotalChild":"R1132","maxChildContribution":"3","mainThreshold":"R21,700","dependentThresholdAdult":"R21,700","dependentThresholdChild":"R4,150","preferedHospitalProvider":"Network hospital","overallLimit":"Unlimited","coPayment":"R9 100 co-payment for use of non-network hospital\\n\\nScopes co-payment:\\nDay clinic R3 800, In-hospital R5 550 co-payment will reduce to R4 450 if performed by a value-based network doctor \\n\\nIf both a Gastroscopy and Colonoscopy is performed in the same admission, the following co-payment apply\\nDay clinic R4 650, In-hospital R6 900 co-payment will reduce to R5 600 if performed by a value-based network doctor\\n\\nR9 100 upfront payment for scopes performed outside the Day surgery network \\nIf both a Gastroscopy and Colonoscopy is performed R6 900 co-pay apply \\n\\nNo co-payment if done in doctor's room as part of a PMB where indicated and approved for Dyspepsia or children under 12 years \\n\\nDefined list of Procedure: R9 100 admission to facility outside of Day surgery network","rate":"200% Scheme Rate ","generalMedicin":"Paid from available day-to-day benefits","specialist":"\\nFull cover for Network specialists\\nNon-network Specialists and GPs: \\n200% of Scheme Rate\\n","dentistSurgical":"Severe dental and oral surgery covers a defined list of procedures with no co-payment or limits \\n        \\nDental admissions co-payments: \\nMembers 13 years and older,     \\nHospital R7 350, Day clinic R4 700\\nMembers under 13 years,      \\nHospital R2 850, Day clinic R1 300\\nThereafter paid from hospital benefit\\nDental appliances, their placements and orthodontic treatments (incl. related accounts) paid from day-to-day benefits limit of R30 750 per beneficiary\\n\\nBasic Dental Trauma Benefit\\nCover for dental appliances and prostheses and the placement thereof  paid up to an annual limit of R58 000 per person per year\\n","mentalHealth":"In Hospital: 21 days per beneficiary  or \\nOut of Hospital: 15 consultations per beneficiary for treatment of (Major affective disorders, Anorexia, Bulimia) and 12 consultations per beneficiary for treatment of acute stress disorder due to recent trauma. Subject to PMB and Psychiatric Network (20% co-payment for non-DSP) \\n \\n21 days per beneficiary for alcohol and drug rehabilitation, 3 days per approved admission for detoxification\\n","radiology":"100% of Scheme Rate - Unlimited","pathology":"100% of Scheme Rate - Unlimited","maternityBenefit":"\\nIn Hospital: Unlimited\\nPrivate ward cover up to R2 320 per day\\nOut-of-Hospital: \\n� 12 Antenatal visit \\n� R5 350 for essential registered devices (25% co-payment applies)\\n� Certain blood tests\\n� 5 Pre- or postnatal visits \\n� 2 x 2D scans incl. 1 nuchal translucency test. 3D and 4D scans are covered at 2D scans rate\\n� For two years after birth: two visits for baby with a GP, Paediatrician or ENT\\n� One six week post-birth with a midwife, GP or gynaecologist\\n� 1 flu vaccination during pregnancy\\n� 1 nutritional assessment\\n� Two mental health consultations\\n� 1 lactation consult \\n� Assisted Reproductive Therapy, limited to         R115 000 per person (25% co-payment applies)\\n\\n\\n ","dialysis":"Full cover for approved treatment plan and use of network provide, otherwise 20% co-payments will apply","cancer":"First R400 000. Thereafter, with a 20% co-payment, except if the treatment forms part of the Extended Oncology Benefit.\\nOncology Innovation Benefit: cover a defined list of innovative cancer medicines that meet the Scheme�s criteria, subject to a 25% co-payments\\nMedicine from DSP or 20% co-payment\\nAdvanced Illness benefit: comprehensive\\npalliative care programme","transplant":"100% Scheme Rate\\nNo details supplied for cadaver donor costs or live related donor costs","mri":"\\nIn Hospital: Up to 100% of Scheme Rate if related to Hospital Admission, if not related to admission or for conservative neck and back scans, R3 270 co-payment applies \\n\\nOut-of-Hospital:�R3 270 co-pay applies\\nConservative back and neck scans - limit  \\nof one scan per spinal and neck region\\n\\n","prosthesisInternal":"Cochlear implants and Auditory Brain implants and processors:\\n- R230 400 per beneficiary per benefit \\nInternal Nerve Stimulators \\n- R165 300 per beneficiary \\nShoulder joint prosthesis\\n- Network Provider: Unlimited \\n- Non-Network Provider: R 42 950 \\nMajor joints surgery (80% of scheme rate)\\n- Network Provider: Unlimited \\n- Non-Network Provider: R 30 900 \\nProsthetic devices used in spinal surgery: \\n- Network Provider: Unlimited \\n- Non-Network Provider: \\n    - First level: R26 250 per beneficiary\\n    - Two or more levels: R52 500 per beneficiary ","prosthesisExternal":"Subject to day-to-day benefits\\nR60 550 per family per annum\\nHearing Aids: R26 600 per family \\n","rehab":"Connected care: quality care at home\\nCare offered: \\n- Postnatal care\\n- IV infusions (drips) \\n- Wound care\\n- Advanced illness care : Unlimited palliative care cover for approved care \\n","designatedServiceProvider":"MedXpress","conditionsCovered":"49 conditions including in PMBs","formulary":"Yes","partialLimits":"22 Non-CDL conditions\\nOut-of-formulary drugs - paid up to a monthly drug amount. 20% co-payment for use of non-DSP. Specialised Medicine and Technology Benefit, R200 000 per person (20% co-payment applies) ","preferredProvider":"None","overallAnualLimit":"None","medicationOverCounter":"Subject to available Savings\\n(Does not accumulate to threshold) ","medicationPrescribed":"Preferred medicine paid at 100%  \\nNon-preferred medicine up to 75% DHR if the price of the medicine is within 25% of the preferred equivalent, or up to 50% of\\nthe DHR if the price of the medicine is more than 50% of the price of the preferred equivalent. Limited to:\\n� M: R35 750\\n� M+1: R41 950\\n� M+2: R48 700\\n� M+3+: R55 550 \\nFor accumulation to threshold and payments from above threshold benefits \\n ","practitionersGeneral":"Subject to Savings\\nExtender Benefit (DEB) covers: \\nUnlimited pharmacy clinic consultations in wellness network, video call consults with network GP. \\nUnlimited consultation with a network GP who meets the digital criteria, when referred\\n- 2 Casualty visit for kids under 10 years\\nUnlimited after Threshold is reached ","specialistsCover":"Subject to available Savings. Unlimited once Threshold is reached\\nNetwork specialists: covered in full\\nnon-Network specialists: 100% of Scheme Rate\\nAllied, therapeutic and psychology healthcare services\\n- M: R20 950\\n- M+1: R28 450\\n- M+2: R34 700\\n- M+3+: R40 250","dentistryCover":"\\nSubject to available Savings. Unlimited at Scheme Rate after Threshold is reached\\n","dentistryCoverSpecial":"Subject to available Savings and Threshold\\nR30 750 per beneficiary for dental appliances and orthodontic treatment\\n","optical":"\\nR6 180 per beneficiary, paid from Savings, thereafter Threshold\\n(20% discount on frames and lenses at a network optometrist at point of sale) \\n","ambulance":"Preferred provider: Discovery 911","international":"Only for emergencies while travelling abroad; R5 million, 90 days travelling\\nAfrica Evacuation Benefit","hospitalCoverAids":"Subject to registration on HIVCare Programme and use of Network Providers","artTtreatment":"Approved meds covered in full. Meds not on list covered up to a set monthly amount. 20% co-pay applies for use of non DSP Network","preventative":"Screening benefits for Adults and Seniors \\nKids Screening - growth assessments,\\nhealth and milestone tracking \\n- Stem Cell Banking with Netcells\\n- International Second Opinion Services\\n- Overseas Treatment benefit, R500 000 per person - with 20% co-payment\\n- Trauma Recovery Extender Benefit \\n\\nChronic Care Programmes  :\\n- Diabetes\\n- Mental health\\n- HIV or Heart-related medical conditions\\n\\nConservative Care Programmes : \\n- Dyspepsia (severe heartburn)\\n- Tonsillitis (children under the age of 16) \\n\\nSpinal Care Programme\\n\\nConnected Care for Acute Care at Home\\n\\nConnected Care a digital health care service through Discovery app\\n(refer to brochure for detailed information)\\n ","logo":"Discovery.png"},{"company":"Discovery","name":"Classic Comprehensive","planType":"Threshold option","coverLevel":"High","hospital":"Any","chronic":"Network","serviceType":"Any","familyIncome":"","mainContribution":"R4732","mainCompSavings":"R1577","mainTotal":"R6309","dependendContributionAdult":"R4475","dependentCompSavingsAdult":"R1491","dependentTotalAdult":"R5966","dependendContributionChild":"R944","dependentCompSavingsChild":"R314","dependentTotalChild":"R1258","maxChildContribution":"3","mainThreshold":"R21,700","dependentThresholdAdult":"R21,700","dependentThresholdChild":"R4,150","preferedHospitalProvider":"Any hospital","overallLimit":"Unlimited","coPayment":"Scopes co-payment:\\nDay clinic R3 800, In-hospital R5 550 co-payment will reduce to R4 450 if performed by a value-based network doctor \\n\\nIf both a Gastroscopy and Colonoscopy is performed in the same admission, the following co-payment apply\\nDay clinic R4 650, In-hospital R6 900 co-payment will reduce to R5 600 if performed by a value-based network doctor  \\n\\nR5 950 upfront payment for scopes performed outside the Day surgery network \\nIf both a Gastroscopy and Colonoscopy is performed R6 900 co-pay apply \\n\\nNo co-payment if done in doctor's room as part of a PMB where indicated and approved for Dyspepsia or children under 12 years \\n\\nDefined list of Procedure: R5 950 admission to facility outside of Day surgery network","rate":"200% Scheme Rate ","generalMedicin":"Paid from available day-to-day benefits","specialist":"\\nFull cover for Network specialists\\nNon-network Specialists and GPs: \\n200% of Scheme Rate","dentistSurgical":"Severe dental and oral surgery covers a defined list of procedures with no co-payment or limits \\n        \\nDental admissions co-payments: \\nMembers 13 years and older,     \\nHospital R7 350, Day clinic R4 700\\nMembers under 13 years,      \\nHospital R2 850, Day clinic R1 300\\nThereafter paid from hospital benefit\\nDental appliances, their placements and orthodontic treatments (incl. related accounts) paid from day-to-day benefits limit of R30 750 per beneficiary\\n\\nBasic Dental Trauma Benefit\\nCover for dental appliances and prostheses and the placement thereof  paid up to an annual limit of R58 000 per person per year\\n","mentalHealth":"In Hospital: 21 days per beneficiary  or \\nOut of Hospital: 15 consultations per beneficiary for treatment of (Major affective disorders, Anorexia, Bulimia) and 12 consultations per beneficiary for treatment of acute stress disorder due to recent trauma. Subject to PMB and Psychiatric Network (20% co-payment for non-DSP) \\n \\n21 days per beneficiary for alcohol and drug rehabilitation, 3 days per approved admission for detoxification\\n","radiology":"100% of Scheme Rate - Unlimited","pathology":"100% of Scheme Rate - Unlimited","maternityBenefit":"\\nIn Hospital: Unlimited\\nPrivate ward cover up to R2 320 per day\\nOut-of-Hospital: \\n� 12 Antenatal visit \\n� R5 350 for essential registered devices (25% co-payment applies)\\n� Certain blood tests\\n� 5 Pre- or postnatal visits \\n� 2 x 2D scans incl. 1 nuchal translucency test. 3D and 4D scans are covered at 2D scans rate\\n� For two years after birth: two visits for baby with a GP, Paediatrician or ENT\\n� One six week post-birth with a midwife, GP or gynaecologist\\n� 1 flu vaccination during pregnancy\\n� 1 nutritional assessment\\n� Two mental health consultations\\n� 1 lactation consult \\n� Assisted Reproductive Therapy, limited to         R115 000 per person (25% co-payment applies)\\n\\n\\n ","dialysis":"Full cover for approved treatment plan and use of network provide, otherwise 20% co-payments will apply","cancer":"First R400 000. Thereafter, with a 20% co-payment, except if the treatment forms part of the Extended Oncology Benefit.\\nOncology Innovation Benefit: cover a defined list of innovative cancer medicines that meet the Scheme�s criteria, subject to a 25% co-payments\\nMedicine from DSP or 20% co-payment\\nAdvanced Illness benefit: comprehensive\\npalliative care programme","transplant":"100% Scheme Rate\\nNo details supplied for cadaver donor costs or live related donor costs","mri":"\\nIn Hospital: Up to 100% of Scheme Rate if related to Hospital Admission, if not related to admission or for conservative neck and back scans, R3 270 co-payment applies \\n\\nOut-of-Hospital:�R3 270 co-pay applies\\nConservative back and neck scans - limit  \\nof one scan per spinal and neck region\\n\\n","prosthesisInternal":"Cochlear implants and Auditory Brain implants and processors:\\n- R230 400 per beneficiary per benefit \\nInternal Nerve Stimulators \\n- R165 300 per beneficiary \\nShoulder joint prosthesis\\n- Network Provider: Unlimited \\n- Non-Network Provider: R 42 950 \\nMajor joints surgery (80% of scheme rate)\\n- Network Provider: Unlimited \\n- Non-Network Provider: R 30 900 \\nProsthetic devices used in spinal surgery: \\n- Network Provider: Unlimited \\n- Non-Network Provider: \\n    - First level: R26 250 per beneficiary\\n    - Two or more levels: R52 500 per beneficiary ","prosthesisExternal":"Subject to day-to-day benefits\\nR60 550 per family per annum\\nHearing Aids: R26 600 per family \\n","rehab":"Connected care: quality care at home\\nCare offered: \\n- Postnatal care\\n- IV infusions (drips) \\n- Wound care\\n- Advanced illness care : Unlimited palliative care cover for approved care \\n","designatedServiceProvider":"Any Network pharmacy","conditionsCovered":"49 conditions including in PMBs","formulary":"Yes","partialLimits":"22 Non-CDL conditions\\nOut-of-formulary drugs - paid up to a monthly drug amount. 20% co-payment for use of non-DSP. Specialised Medicine and Technology Benefit, R200 000 per person (20% co-payment applies) ","preferredProvider":"None","overallAnualLimit":"None","medicationOverCounter":"Subject to available Savings\\n(Does not accumulate to threshold) ","medicationPrescribed":"Preferred medicine paid at 100%  \\nNon-preferred medicine up to 75% DHR if the price of the medicine is within 25% of the preferred equivalent, or up to 50% of\\nthe DHR if the price of the medicine is more than 50% of the price of the preferred equivalent. Limited to:\\n� M: R35 750\\n� M+1: R41 950\\n� M+2: R48 700\\n� M+3+: R55 550 \\nFor accumulation to threshold and payments from above threshold benefits \\n ","practitionersGeneral":"Subject to Savings\\nExtender Benefit (DEB) covers: \\nUnlimited pharmacy clinic consultations in wellness network, video call consults with network GP. \\nUnlimited consultation with a network GP who meets the digital criteria, when referred\\n- 2 Casualty visit for kids under 10 years\\nUnlimited after Threshold is reached ","specialistsCover":"Subject to available Savings. Unlimited once Threshold is reached\\nNetwork specialists: covered in full\\nnon-Network specialists: 100% of Scheme Rate\\nAllied, therapeutic and psychology healthcare services\\n- M: R20 950\\n- M+1: R28 450\\n- M+2: R34 700\\n- M+3+: R40 250","dentistryCover":"\\nSubject to available Savings. Unlimited at Scheme Rate after Threshold is reached\\n","dentistryCoverSpecial":"Subject to available Savings and Threshold\\nR30 750 per beneficiary for dental appliances and orthodontic treatment\\n","optical":"\\nR6 180 per beneficiary, paid from Savings, thereafter Threshold\\n(20% discount on frames and lenses at a network optometrist at point of sale) \\n","ambulance":"Preferred provider: Discovery 911","international":"Only for emergencies while travelling abroad; R5 million, 90 days travelling\\nAfrica Evacuation Benefit","hospitalCoverAids":"Subject to registration on HIVCare Programme and use of Network Providers","artTtreatment":"Approved meds covered in full. Meds not on list covered up to a set monthly amount. 20% co-pay applies for use of non DSP Network","preventative":"Screening benefits for Adults and Seniors \\nKids Screening - growth assessments,\\nhealth and milestone tracking \\n- Stem Cell Banking with Netcells\\n- International Second Opinion Services\\n- Overseas Treatment benefit, R500 000 per person - with 20% co-payment\\n- Trauma Recovery Extender Benefit \\n\\nChronic Care Programmes  :\\n- Diabetes\\n- Mental health\\n- HIV or Heart-related medical conditions\\n\\nConservative Care Programmes : \\n- Dyspepsia (severe heartburn)\\n- Tonsillitis (children under the age of 16) \\n\\nSpinal Care Programme\\n\\nConnected Care for Acute Care at Home\\n\\nConnected Care a digital health care service through Discovery app\\n(refer to brochure for detailed information)\\n ","logo":"Discovery.png"},{"company":"Discovery","name":"Executive Plan","planType":"Threshold option","coverLevel":"High","hospital":"Any","chronic":"Network","serviceType":"Any","familyIncome":"","mainContribution":"R5766","mainCompSavings":"R1922","mainTotal":"R7688","dependendContributionAdult":"R5766","dependentCompSavingsAdult":"R1922","dependentTotalAdult":"R7688","dependendContributionChild":"R1101","dependentCompSavingsChild":"R367","dependentTotalChild":"R1468","maxChildContribution":"","mainThreshold":"R26,300","dependentThresholdAdult":"R26,300","dependentThresholdChild":"R5,000","preferedHospitalProvider":"Any hospital","overallLimit":"Unlimited, plus private ward cover\\nof up to R2 320 each day","coPayment":"Scopes co-payment:\\nDay clinic R3 800, In-hospital R5 550 co-payment will reduce to R4 450 if performed by a value-based network doctor \\n\\nIf both a Gastroscopy and Colonoscopy is performed in the same admission, the following co-payment apply\\nDay clinic R4 650, In-hospital R6 900 co-payment will reduce to R5 600 if performed by a value-based network doctor  \\n\\nNo co-payment if done in doctor's room as part of a PMB where indicated and approved for Dyspepsia or children under 12 years \\n\\n","rate":"300% Scheme Rate ","generalMedicin":"Paid from available day-to-day benefits","specialist":"\\nFull cover for Network specialists\\nOther Specialists: 300% of Scheme Rate \\nGPs: 200% of Scheme Rate\\nUnlimited\\n","dentistSurgical":"Severe dental and oral surgery covers a defined list of procedures with no co-payment or limits \\n        \\nDental admissions co-payments: \\nMembers 13 years and older,     \\nHospital R7 350, Day clinic R4 700\\nMembers under 13 years,      \\nHospital R2 850, Day clinic R1 300\\nThereafter paid from hospital benefit\\nDental appliances, their placements and orthodontic treatments (incl. related accounts) paid from day-to-day benefits limit of R30 750 per beneficiary\\n\\nBasic Dental Trauma Benefit\\nCover for dental appliances and prostheses and the placement thereof paid up to an annual limit of R58 000 per person per year\\n","mentalHealth":"In Hospital: 21 days per beneficiary  or \\nOut of Hospital: 15 consultations per beneficiary for treatment of (Major affective disorders, Anorexia, Bulimia) and 12 consultations per beneficiary for treatment of acute stress disorder due to recent trauma. Subject to PMB and Psychiatric Network (20% co-payment for non-DSP) \\n \\n21 days per beneficiary for alcohol and drug rehabilitation, 3 days per approved admission for detoxification\\n","radiology":"100% of Scheme Rate - Unlimited","pathology":"100% of Scheme Rate - Unlimited","maternityBenefit":"\\nIn Hospital: Unlimited\\nPrivate ward cover up to R2 320 per day\\nOut-of-Hospital: \\n� 12 Antenatal visit \\n� R5 350 for essential registered devices (25% co-payment applies)\\n� Certain blood tests\\n� 5 Pre- or postnatal visits \\n� 2 x 2D scans incl. 1 nuchal translucency test. 3D and 4D scans are covered at 2D scans rate\\n� For two years after birth: two visits for baby with a GP, Paediatrician or ENT\\n� One six week post-birth with a midwife, GP or gynaecologist\\n� 1 flu vaccination during pregnancy\\n� 1 nutritional assessment\\n� Two mental health consultations\\n� 1 lactation consult \\n� Assisted Reproductive Therapy, limited to         R115 000 per person (25% co-payment applies)\\n\\n\\n ","dialysis":"100% of Scheme Rate - Unlimited","cancer":"First R400 000. Thereafter, with a 20% co-payment, except if the treatment forms part of the Extended Oncology Benefit.\\nOncology Innovation Benefit: cover a defined list of innovative cancer medicines that meet the Scheme�s criteria, subject to a 25% co-payments\\nMedicine from DSP or 20% co-payment\\nAdvanced Illness benefit: comprehensive\\npalliative care programme","transplant":"100% Scheme Rate\\nNo details supplied for cadaver donor costs or live related donor costs","mri":"\\nIn Hospital: if not related to admission or for conservative neck and back scans, R3 270 co-payment from Day-to-Day benefits applies \\n\\nOut-of-Hospital:�R3 270 co-pay applies\\nConservative back and neck scans - limit  \\nof one scan per spinal and neck region\\n\\n","prosthesisInternal":"Cochlear implants and Auditory Brain implants and processors:\\n- R230 400 per beneficiary per benefit \\nInternal Nerve Stimulators \\n- R165 300 per beneficiary \\nShoulder joint prosthesis\\n- Network Provider: Unlimited \\n- Non-Network Provider: R 42 950 \\nMajor joints surgery (80% of scheme rate)\\n- Network Provider: Unlimited \\n- Non-Network Provider: R 30 900 \\nProsthetic devices used in spinal surgery: \\n- Network Provider: Unlimited \\n- Non-Network Provider: \\n    - First level: R26 250 per beneficiary\\n    - Two or more levels: R52 500 per beneficiary ","prosthesisExternal":"Subject to day-to-day benefits\\nR60 550 per family per annum\\nHearing Aids: R26 600 per family \\n","rehab":"Connected care: quality care at home\\nCare offered: \\n- Postnatal care\\n- IV infusions (drips) \\n- Wound care\\n- Advanced illness care : Unlimited palliative care cover for approved care \\n","designatedServiceProvider":"Any Network pharmacy","conditionsCovered":"49 conditions including in PMBs","formulary":"Yes","partialLimits":"22 Non-CDL conditions\\nPaid up to a monthly drug amount. No medicine list applies, including an exclusive list of brand medicines. \\nSpecialised Medicine and Technology Benefit, R200 000 per person (20% co-payment applies) ","preferredProvider":"None","overallAnualLimit":"None","medicationOverCounter":"Subject to available Savings\\n(Does not accumulate to threshold) ","medicationPrescribed":"Preferred medicine paid at 100%  \\nNon-preferred medicine up to 75% DHR if the price of the medicine is within 25% of the preferred equivalent, or up to 50% of\\nthe DHR if the price of the medicine is more than 50% of the price of the preferred equivalent. Limited to:\\n� M: R43 850\\n� M+1: R51 400\\n� M+2: R58 850\\n� M+3+: R66 350 \\nFor accumulation to threshold and payments from above threshold benefits\\n","practitionersGeneral":"Subject to Savings\\nExtender Benefit (DEB) covers: \\nUnlimited pharmacy clinic consultations in wellness network, video call consults with network GP. \\nUnlimited consultation with a network GP who meets the digital criteria, when referred\\n- 2 Casualty visit for kids under 10 years\\nUnlimited after Threshold is reached ","specialistsCover":"Subject to available Savings. Unlimited once Threshold is reached\\nNetwork specialists: covered in full\\nnon-Network specialists: 300% of Scheme Rate\\nAllied, therapeutic and psychology healthcare services\\n- M: R26 250\\n- M+1: R31 550\\n- M+2: R36 950\\n- M+3+: R44 300","dentistryCover":"\\nSubject to available Savings. Unlimited at Scheme Rate after Threshold is reached\\n","dentistryCoverSpecial":"Subject to available Savings and Threshold\\nR30 750 per beneficiary for dental appliances and orthodontic treatment\\n","optical":"\\nR9 010 per beneficiary, paid from Savings, thereafter Threshold\\n(20% discount on frames and lenses at a network optometrist at point of sale) \\n","ambulance":"Preferred provider: Discovery 911","international":"Only for emergencies while travelling abroad; 1 million US Dollars, 90 days travelling\\nAfrica Evacuation Benefit","hospitalCoverAids":"Subject to registration on HIVCare Programme and use of Network Providers","artTtreatment":"Approved meds covered in full. Meds not on list covered up to a set monthly amount. 20% co-pay applies for use of non DSP Network","preventative":"Screening benefits for Adults and Seniors \\nKids Screening - growth assessments,\\nhealth and milestone tracking \\n- Stem Cell Banking with Netcells\\n- International Second Opinion Services\\n- Overseas Treatment benefit, R750 000 per person (R300 000 if treatment available in-hospital in SA) - with 20% co-payment\\n- Trauma Recovery Extender Benefit \\n\\nChronic Care Programmes  :\\n- Diabetes\\n- Mental health\\n- HIV or Heart-related medical conditions\\n\\nConservative Care Programmes : \\n- Dyspepsia (severe heartburn)\\n- Tonsillitis (children under the age of 16) \\n\\nSpinal Care Programme\\n\\nConnected Care for Acute Care at Home\\n\\nConnected Care a digital health care service through Discovery app\\n(refer to brochure for detailed information)\\n ","logo":"Discovery.png"},{"company":"Discovery","name":"Essential Core","planType":"Hospital plan","coverLevel":"Mid","hospital":"Any","chronic":"Network","serviceType":"N/A","familyIncome":"","mainContribution":"R2229","mainCompSavings":"R0.00","mainTotal":"R2229","dependendContributionAdult":"R1671","dependentCompSavingsAdult":"R0.00","dependentTotalAdult":"R1671","dependendContributionChild":"R896","dependentCompSavingsChild":"R0.00","dependentTotalChild":"R896","maxChildContribution":"3","mainThreshold":"","dependentThresholdAdult":"","dependentThresholdChild":"","preferedHospitalProvider":"Any hospital","overallLimit":"Unlimited","coPayment":"Scope Admissions co-payments:\\nDay clinic R3 800, In-hospital R6 550 co-payment will reduce to R5 450 if performed by a value-based network doctor\\n\\nIf both a Gastroscopy and Colonoscopy is performed in the same admission, the following co-payment apply\\nDay clinic R4 650, In-hospital R8 150 co-payment will reduce to R6 800 if performed by a value-based network doctor  \\n\\nNo co-payment if done in doctor's room as part of a PMB where indicated and approved for Dyspepsia or children under 12 years \\n \\nCo-payments for Outside of Day Surgery Network:\\n- Facility outside of the Network:   R5 950 \\n- Hospital outside the Network: R6 550 \\n- Both a gastroscopy and\\ncolonoscopy: R8 150","rate":"100% Scheme Rate ","generalMedicin":"No benefit","specialist":"Full cover for Network specialists\\nNon-network Specialists and GPs :  100% of Scheme Rate\\n","dentistSurgical":"Severe dental and oral surgery covers a defined list of procedures with no co-payment or limits \\n\\nDental admissions co-payments: \\nMembers 13 years and older,              \\nHospital R7 350, Day clinic R4 700\\nMembers under 13 years,                               Hospital R2 850, Day clinic R1 300\\nDental appliances, their placements and orthodontic treatments (incl. related accounts) for members account\\n\\nBasic Dental Trauma Benefit\\nCover for dental appliances and prostheses and the placement thereof  paid up to an annual limit of R58 000 per person per year\\n","mentalHealth":"In Hospital: 21 days per beneficiary or \\nOut of Hospital: 15 consultations per beneficiary for treatment of (Major affective disorders, Anorexia, Bulimia) and 12 consultations per beneficiary for treatment of acute stress disorder due to recent trauma. Subject to PMB and Psychiatric Network (20% co-payment for non-DSP) \\n \\n21 days per beneficiary for alcohol and drug rehabilitation, 3 days per approved admission for detoxification\\n","radiology":"100% of Scheme Rate - Unlimited","pathology":"100% of Scheme Rate - Unlimited","maternityBenefit":"\\nIn hospital: Unlimited\\nOut-of-Hospital: \\n� 8 Antenatal visits (GP/Gynae/Midwife)\\n� 2 x 2D scans incl. 1 nuchal translucency test. 3D and 4D scans are covered at 2D scans rate\\n� Selected blood tests\\n� 1 Flu vaccination during pregnancy\\n� 5 Pre- or postnatal visits\\nCover for first 2 years after birth\\n� 2 GP, paediatric or ENT visits for baby\\n� 1 post-birth consult with Midwife, GP or Gynae \\n� 1 Dietitian nutritional assessment\\n� 2 Mental health consultations\\n� 1 Lactation consultations\\n\\n ","dialysis":"Full cover for approved treatment plan and use of network provide, otherwise 20% co-payments will apply","cancer":"First R200 000, thereafter, with a 20% co-payment. Medicine from DSP or 20% co-pay\\nOncology Innovation Benefit: cover a defined list of innovative cancer medicines that meet the Scheme�s criteria, subject to a 50% co-payments\\n","transplant":"100% Scheme Rate\\nNo details supplied for cadaver donor costs or live related donor costs","mri":"In Hospital:�100% of Scheme  Rate. No benefit, if not related to admission or if for conservative neck and back scans\\nOut-of-Hospital:�No benefit","prosthesisInternal":"Cochlear implants and Auditory Brain implants and processors:\\n- R230 400 per beneficiary per benefit \\nInternal Nerve Stimulators \\n- R165 300 per beneficiary \\nShoulder joint prosthesis\\n- Network Provider: Unlimited \\n- Non-Network Provider: R 42 950 \\nMajor joints surgery\\n- Network Provider: Unlimited \\n- Non-Network Provider: 20% co-payment up to max of R 30 900 \\nProsthetic devices used in spinal surgery: \\n- Network Provider: Unlimited \\n- Non-Network Provider: \\n    - First level: R26 250 per beneficiary\\n    - Two or more levels: R52 500 per beneficiary \\n- Up to 80% of Scheme rate","prosthesisExternal":"No benefit","rehab":"Connected care: quality care at home\\nCare offered: \\n- Postnatal care\\n- IV infusions (drips) \\n- Wound care\\n- Advanced illness care : Unlimited palliative care cover for approved care \\n","designatedServiceProvider":"MedXpress and MedXpress pharmacies","conditionsCovered":"CDL in PMB","formulary":"Yes","partialLimits":"20% co-payment for use of non-DSP Pharmacy","preferredProvider":"None","overallAnualLimit":"N/A","medicationOverCounter":"No benefit","medicationPrescribed":"No benefit","practitionersGeneral":"No benefit","specialistsCover":"No benefit","dentistryCover":"No benefit","dentistryCoverSpecial":"No benefit","optical":"No day-to-day benefits\\n(20% discount on frames and lenses at a network optometrist at point of sale) ","ambulance":"Preferred provider: Discovery 911","international":"Only for emergencies while travelling abroad; R5 million 90 days travelling\\nAfrica Evacuation Benefit","hospitalCoverAids":"Subject to registration on HIVCare Programme and use of Network Providers","artTtreatment":"Approved meds covered in full. Meds not on list covered up to a set monthly amount. 20% co-pay applies for use of non DSP Network","preventative":"Screening for Adults and Seniors\\nScreening for Kids\\nOther:\\n- Stem Cell Banking: with Netcells\\n- International Second Opinion Services from Cleveland clinic, with a 50% co-payment\\n- Trauma Recovery Extender Benefit \\nChronic Care Programmes:\\n- Diabetes\\n- Mental health\\n- HIV or Heart-related medical conditions\\nConservative Care Programmes: \\n- Dyspepsia (severe heartburn)\\n- Tonsillitis (children under the age of 16) \\nSpinal Care Programme\\n\\nPre-operative Management Programme for Major surgeries\\n\\nConnected Care: Access to care from home\\nConnected Care a digital health care service through Discovery app\\n\\n(refer to brochure for detailed information)","logo":"Discovery.png"},{"company":"Discovery","name":"Essential Delta Core","planType":"Hospital plan","coverLevel":"Mid","hospital":"Network","chronic":"Network","serviceType":"N/A","familyIncome":"","mainContribution":"R1781","mainCompSavings":"R0.00","mainTotal":"R1781","dependendContributionAdult":"R1340","dependentCompSavingsAdult":"R0.00","dependentTotalAdult":"R1340","dependendContributionChild":"R715","dependentCompSavingsChild":"R0.00","dependentTotalChild":"R715","maxChildContribution":"3","mainThreshold":"","dependentThresholdAdult":"","dependentThresholdChild":"","preferedHospitalProvider":"Delta Network hospital","overallLimit":"Unlimited","coPayment":"\\n\\nScope Admissions co-payments:\\nDay clinic R3 800, In-hospital R6 550 co-payment will reduce to R5 450 if performed by a value-based network doctor\\n\\nIf both a Gastroscopy and Colonoscopy is performed in the same admission, the following co-payment apply\\nDay clinic R4 650, In-hospital R8 150 co-payment will reduce to R6 800 if performed by a value-based network doctor  \\n\\nNo co-payment if done in doctor's room as part of a PMB where indicated and approved for Dyspepsia or children under 12 years \\n\\nDefined list of procedure: R9 100 admission to facility outside of Day surgery network","rate":"100% Scheme Rate ","generalMedicin":"No benefit","specialist":"Full cover for Network specialists\\nNon-network Specialists and GPs :  100% of Scheme Rate\\n","dentistSurgical":"Severe dental and oral surgery covers a defined list of procedures with no co-payment or limits \\n\\nDental admissions co-payments: \\nMembers 13 years and older,              \\nHospital R7 350, Day clinic R4 700\\nMembers under 13 years,                               Hospital R2 850, Day clinic R1 300\\nDental appliances, their placements and orthodontic treatments (incl. related accounts) for members account\\n\\nBasic Dental Trauma Benefit\\nCover for dental appliances and prostheses and the placement thereof  paid up to an annual limit of R58 000 per person per year\\n","mentalHealth":"In Hospital: 21 days per beneficiary or \\nOut of Hospital: 15 consultations per beneficiary for treatment of (Major affective disorders, Anorexia, Bulimia) and 12 consultations per beneficiary for treatment of acute stress disorder due to recent trauma. Subject to PMB and Psychiatric Network (20% co-payment for non-DSP) \\n \\n21 days per beneficiary for alcohol and drug rehabilitation, 3 days per approved admission for detoxification\\n","radiology":"100% of Scheme Rate - Unlimited","pathology":"100% of Scheme Rate - Unlimited","maternityBenefit":"\\nIn hospital: Unlimited\\nOut-of-Hospital: \\n� 8 Antenatal visits (GP/Gynae/Midwife)\\n� 2 x 2D scans incl. 1 nuchal translucency test. 3D and 4D scans are covered at 2D scans rate\\n� Selected blood tests\\n� 1 Flu vaccination during pregnancy\\n� 5 Pre- or postnatal visits\\nCover for first 2 years after birth\\n� 2 GP, paediatric or ENT visits for baby\\n� 1 post-birth consult with Midwife, GP or Gynae \\n� 1 Dietitian nutritional assessment\\n� 2 Mental health consultations\\n� 1 Lactation consultations\\n\\n ","dialysis":"Full cover for approved treatment plan and use of network provide, otherwise 20% co-payments will apply","cancer":"First R200 000, thereafter, with a 20% co-payment. Medicine from DSP or 20% co-pay\\nOncology Innovation Benefit: cover a defined list of innovative cancer medicines that meet the Scheme�s criteria, subject to a 50% co-payments\\n","transplant":"100% Scheme Rate\\nNo details supplied for cadaver donor costs or live related donor costs","mri":"In Hospital:�100% of Scheme  Rate. No benefit, if not related to admission or if for conservative neck and back scans\\nOut-of-Hospital:�No benefit","prosthesisInternal":"Cochlear implants and Auditory Brain implants and processors:\\n- R230 400 per beneficiary per benefit \\nInternal Nerve Stimulators \\n- R165 300 per beneficiary \\nShoulder joint prosthesis\\n- Network Provider: Unlimited \\n- Non-Network Provider: R 42 950 \\nMajor joints surgery\\n- Network Provider: Unlimited \\n- Non-Network Provider: 20% co-payment up to max of R 30 900 \\nProsthetic devices used in spinal surgery: \\n- Network Provider: Unlimited \\n- Non-Network Provider: \\n    - First level: R26 250 per beneficiary\\n    - Two or more levels: R52 500 per beneficiary \\n- Up to 80% of Scheme rate","prosthesisExternal":"No benefit","rehab":"Connected care: quality care at home\\nCare offered: \\n- Postnatal care\\n- IV infusions (drips) \\n- Wound care\\n- Advanced illness care : Unlimited palliative care cover for approved care \\n","designatedServiceProvider":"MedXpress and MedXpress pharmacies","conditionsCovered":"CDL in PMB","formulary":"Yes","partialLimits":"20% co-payment for use of non-DSP Pharmacy","preferredProvider":"None","overallAnualLimit":"N/A","medicationOverCounter":"No benefit","medicationPrescribed":"No benefit","practitionersGeneral":"No benefit","specialistsCover":"No benefit","dentistryCover":"No benefit","dentistryCoverSpecial":"No benefit","optical":"No day-to-day benefits\\n(20% discount on frames and lenses at a network optometrist at point of sale) ","ambulance":"Preferred provider: Discovery 911","international":"Only for emergencies while travelling abroad; R5 million 90 days travelling\\nAfrica Evacuation Benefit","hospitalCoverAids":"Subject to registration on HIVCare Programme and use of Network Providers","artTtreatment":"Approved meds covered in full. Meds not on list covered up to a set monthly amount. 20% co-pay applies for use of non DSP Network","preventative":"Screening for Adults and Seniors\\nScreening for Kids\\nOther:\\n- Stem Cell Banking: with Netcells\\n- International Second Opinion Services from Cleveland clinic, with a 50% co-payment\\n- Trauma Recovery Extender Benefit \\nChronic Care Programmes:\\n- Diabetes\\n- Mental health\\n- HIV or Heart-related medical conditions\\nConservative Care Programmes: \\n- Dyspepsia (severe heartburn)\\n- Tonsillitis (children under the age of 16) \\nSpinal Care Programme\\n\\nPre-operative Management Programme for Major surgeries\\n\\nConnected Care: Access to care from home\\nConnected Care a digital health care service through Discovery app\\n\\n(refer to brochure for detailed information)","logo":"Discovery.png"},{"company":"Discovery","name":"Coastal Core","planType":"Hospital plan","coverLevel":"Mid","hospital":"Network","chronic":"Network","serviceType":"N/A","familyIncome":"","mainContribution":"R2062","mainCompSavings":"R0.00","mainTotal":"R2062","dependendContributionAdult":"R1584","dependentCompSavingsAdult":"R0.00","dependentTotalAdult":"R1584","dependendContributionChild":"R820","dependentCompSavingsChild":"R0.00","dependentTotalChild":"R820","maxChildContribution":"3","mainThreshold":"","dependentThresholdAdult":"","dependentThresholdChild":"","preferedHospitalProvider":"Coastal Network hospital","overallLimit":"Unlimited","coPayment":"\\n\\nScope Admissions co-payments:\\nDay clinic R3 800, In-hospital R6 550 co-payment will reduce to R5 450 if performed by a value-based network doctor\\n\\nIf both a Gastroscopy and Colonoscopy is performed in the same admission, the following co-payment apply\\nDay clinic R4 650, In-hospital R8 150 co-payment will reduce to R6 800 if performed by a value-based network doctor  \\n\\nNo co-payment if done in doctor's room as part of a PMB where indicated and approved for Dyspepsia or children under 12 years \\n\\nDefined list of procedure:\\n- Facility outside of the Network:   R5 950 \\n- Hospital outside the Network: R6 550 \\n- Both a gastroscopy and\\ncolonoscopy: R8 150","rate":"100% Scheme Rate ","generalMedicin":"No benefit","specialist":"Full cover for Network specialists\\nNon-network Specialists and GPs :  100% of Scheme Rate\\n","dentistSurgical":"Severe dental and oral surgery covers a defined list of procedures with no co-payment or limits \\n\\nDental admissions co-payments: \\nMembers 13 years and older,              \\nHospital R7 350, Day clinic R4 700\\nMembers under 13 years,                               Hospital R2 850, Day clinic R1 300\\nDental appliances, their placements and orthodontic treatments (incl. related accounts) for members account\\n\\nBasic Dental Trauma Benefit\\nCover for dental appliances and prostheses and the placement thereof  paid up to an annual limit of R58 000 per person per year\\n","mentalHealth":"In Hospital: 21 days per beneficiary or \\nOut of Hospital: 15 consultations per beneficiary for treatment of (Major affective disorders, Anorexia, Bulimia) and 12 consultations per beneficiary for treatment of acute stress disorder due to recent trauma. Subject to PMB and Psychiatric Network (20% co-payment for non-DSP) \\n \\n21 days per beneficiary for alcohol and drug rehabilitation, 3 days per approved admission for detoxification\\n","radiology":"100% of Scheme Rate - Unlimited","pathology":"100% of Scheme Rate - Unlimited","maternityBenefit":"\\nIn hospital: Unlimited\\nOut-of-Hospital: \\n� 8 Antenatal visits (GP/Gynae/Midwife)\\n� 2 x 2D scans incl. 1 nuchal translucency test. 3D and 4D scans are covered at 2D scans rate\\n� Selected blood tests\\n� 1 Flu vaccination during pregnancy\\n� 5 Pre- or postnatal visits\\nCover for first 2 years after birth\\n� 2 GP, paediatric or ENT visits for baby\\n� 1 post-birth consult with Midwife, GP or Gynae \\n� 1 Dietitian nutritional assessment\\n� 2 Mental health consultations\\n� 1 Lactation consultations\\n\\n ","dialysis":"Full cover for approved treatment plan and use of network provide, otherwise 20% co-payments will apply","cancer":"First R200 000, thereafter, with a 20% co-payment. Medicine from DSP or 20% co-pay\\nOncology Innovation Benefit: cover a defined list of innovative cancer medicines that meet the Scheme�s criteria, subject to a 50% co-payments\\n","transplant":"100% Scheme Rate\\nNo details supplied for cadaver donor costs or live related donor costs","mri":"In Hospital:�100% of Scheme  Rate. No benefit, if not related to admission or if for conservative neck and back scans\\nOut-of-Hospital:�No benefit","prosthesisInternal":"Cochlear implants and Auditory Brain implants and processors:\\n- R230 400 per beneficiary per benefit \\nInternal Nerve Stimulators \\n- R165 300 per beneficiary \\nShoulder joint prosthesis\\n- Network Provider: Unlimited \\n- Non-Network Provider: R 42 950 \\nMajor joints surgery\\n- Network Provider: Unlimited \\n- Non-Network Provider: 20% co-payment up to max of R 30 900 \\nProsthetic devices used in spinal surgery: \\n- Network Provider: Unlimited \\n- Non-Network Provider: \\n    - First level: R26 250 per beneficiary\\n    - Two or more levels: R52 500 per beneficiary \\n- Up to 80% of Scheme rate","prosthesisExternal":"No benefit","rehab":"Connected care: quality care at home\\nCare offered: \\n- Postnatal care\\n- IV infusions (drips) \\n- Wound care\\n- Advanced illness care : Unlimited palliative care cover for approved care \\n","designatedServiceProvider":"MedXpress and MedXpress pharmacies","conditionsCovered":"CDL in PMB","formulary":"Yes","partialLimits":"20% co-payment for use of non-DSP Pharmacy","preferredProvider":"None","overallAnualLimit":"N/A","medicationOverCounter":"No benefit","medicationPrescribed":"No benefit","practitionersGeneral":"No benefit","specialistsCover":"No benefit","dentistryCover":"No benefit","dentistryCoverSpecial":"No benefit","optical":"No day-to-day benefits\\n(20% discount on frames and lenses at a network optometrist at point of sale) ","ambulance":"Preferred provider: Discovery 911","international":"Only for emergencies while travelling abroad; R5 million 90 days travelling\\nAfrica Evacuation Benefit","hospitalCoverAids":"Subject to registration on HIVCare Programme and use of Network Providers","artTtreatment":"Approved meds covered in full. Meds not on list covered up to a set monthly amount. 20% co-pay applies for use of non DSP Network","preventative":"Screening for Adults and Seniors\\nScreening for Kids\\nOther:\\n- Stem Cell Banking: with Netcells\\n- International Second Opinion Services from Cleveland clinic, with a 50% co-payment\\n- Trauma Recovery Extender Benefit \\nChronic Care Programmes:\\n- Diabetes\\n- Mental health\\n- HIV or Heart-related medical conditions\\nConservative Care Programmes: \\n- Dyspepsia (severe heartburn)\\n- Tonsillitis (children under the age of 16) \\nSpinal Care Programme\\n\\nPre-operative Management Programme for Major surgeries\\n\\nConnected Care: Access to care from home\\nConnected Care a digital health care service through Discovery app\\n\\n(refer to brochure for detailed information)","logo":"Discovery.png"},{"company":"Discovery","name":"Classic Core ","planType":"Hospital plan","coverLevel":"Mid","hospital":"Any","chronic":"Network","serviceType":"N/A","familyIncome":"","mainContribution":"R2594","mainCompSavings":"R0.00","mainTotal":"R2594","dependendContributionAdult":"R2046","dependentCompSavingsAdult":"R0.00","dependentTotalAdult":"R2046","dependendContributionChild":"R1038","dependentCompSavingsChild":"R0.00","dependentTotalChild":"R1038","maxChildContribution":"3","mainThreshold":"","dependentThresholdAdult":"","dependentThresholdChild":"","preferedHospitalProvider":"Any hospital","overallLimit":"Unlimited","coPayment":"Scope Admissions co-payments:\\nDay clinic R3 800, In-hospital R6 550 co-payment will reduce to R5 450 if performed by a value-based network doctor\\n\\nIf both a Gastroscopy and Colonoscopy is performed in the same admission, the following co-payment apply\\nDay clinic R4 650, In-hospital R8 150 co-payment will reduce to R6 800 if performed by a value-based network doctor  \\n\\nNo co-payment if done in doctor's room as part of a PMB where indicated and approved for Dyspepsia or children under 12 years \\n\\nDefined list of procedure:\\n- Facility outside of the Network:   R5 950 \\n- Hospital outside the Network: R6 550 \\n- Both a gastroscopy and\\ncolonoscopy: R8 150","rate":"200% Scheme Rate ","generalMedicin":"No benefit","specialist":"Full cover for Network specialists\\nNon-network Specialists and GPs : 200% of Scheme Rate\\n","dentistSurgical":"Severe dental and oral surgery covers a defined list of procedures with no co-payment or limits \\n\\nDental admissions co-payments: \\nMembers 13 years and older,              \\nHospital R7 350, Day clinic R4 700\\nMembers under 13 years,                               Hospital R2 850, Day clinic R1 300\\nDental appliances, their placements and orthodontic treatments (incl. related accounts) for members account\\n\\nBasic Dental Trauma Benefit\\nCover for dental appliances and prostheses and the placement thereof  paid up to an annual limit of R58 000 per person per year\\n","mentalHealth":"In Hospital: 21 days per beneficiary or \\nOut of Hospital: 15 consultations per beneficiary for treatment of (Major affective disorders, Anorexia, Bulimia) and 12 consultations per beneficiary for treatment of acute stress disorder due to recent trauma. Subject to PMB and Psychiatric Network (20% co-payment for non-DSP) \\n \\n21 days per beneficiary for alcohol and drug rehabilitation, 3 days per approved admission for detoxification\\n","radiology":"100% of Scheme Rate - Unlimited","pathology":"100% of Scheme Rate - Unlimited","maternityBenefit":"\\nIn hospital: Unlimited\\nOut-of-Hospital: \\n� 8 Antenatal visits (GP/Gynae/Midwife)\\n� 2 x 2D scans incl. 1 nuchal translucency test. 3D and 4D scans are covered at 2D scans rate\\n� Selected blood tests\\n� 1 Flu vaccination during pregnancy\\n� 5 Pre- or postnatal visits\\nCover for first 2 years after birth\\n� 2 GP, paediatric or ENT visits for baby\\n� 1 post-birth consult with Midwife, GP or Gynae \\n� 1 Dietitian nutritional assessment\\n� 2 Mental health consultations\\n� 1 Lactation consultations\\n\\n ","dialysis":"Full cover for approved treatment plan and use of network provide, otherwise 20% co-payments will apply","cancer":"First R200 000, thereafter, with a 20% co-payment. Medicine from DSP or 20% co-pay\\nOncology Innovation Benefit: cover a defined list of innovative cancer medicines that meet the Scheme�s criteria, subject to a 50% co-payments\\n","transplant":"100% Scheme Rate\\nNo details supplied for cadaver donor costs or live related donor costs","mri":"In Hospital:�100% of Scheme  Rate. No benefit, if not related to admission or if for conservative neck and back scans\\nOut-of-Hospital:�No benefit","prosthesisInternal":"Cochlear implants and Auditory Brain implants and processors:\\n- R230 400 per beneficiary per benefit \\nInternal Nerve Stimulators \\n- R165 300 per beneficiary \\nShoulder joint prosthesis\\n- Network Provider: Unlimited \\n- Non-Network Provider: R 42 950 \\nMajor joints surgery\\n- Network Provider: Unlimited \\n- Non-Network Provider: 20% co-payment up to max of R 30 900 \\nProsthetic devices used in spinal surgery: \\n- Network Provider: Unlimited \\n- Non-Network Provider: \\n    - First level: R26 250 per beneficiary\\n    - Two or more levels: R52 500 per beneficiary \\n- Up to 80% of Scheme rate","prosthesisExternal":"No benefit","rehab":"Connected care: quality care at home\\nCare offered: \\n- Postnatal care\\n- IV infusions (drips) \\n- Wound care\\n- Advanced illness care : Unlimited palliative care cover for approved care \\n","designatedServiceProvider":"MedXpress and MedXpress pharmacies","conditionsCovered":"CDL in PMB","formulary":"Yes","partialLimits":"20% co-payment for use of non-DSP Pharmacy","preferredProvider":"None","overallAnualLimit":"N/A","medicationOverCounter":"No benefit","medicationPrescribed":"No benefit","practitionersGeneral":"No benefit","specialistsCover":"No benefit","dentistryCover":"No benefit","dentistryCoverSpecial":"No benefit","optical":"No day-to-day benefits\\n(20% discount on frames and lenses at a network optometrist at point of sale) ","ambulance":"Preferred provider: Discovery 911","international":"Only for emergencies while travelling abroad; R5 million 90 days travelling\\nAfrica Evacuation Benefit","hospitalCoverAids":"Subject to registration on HIVCare Programme and use of Network Providers","artTtreatment":"Approved meds covered in full. Meds not on list covered up to a set monthly amount. 20% co-pay applies for use of non DSP Network","preventative":"Screening for Adults and Seniors\\nScreening for Kids\\nOther:\\n- Stem Cell Banking: with Netcells\\n- International Second Opinion Services from Cleveland clinic, with a 50% co-payment\\n- Trauma Recovery Extender Benefit \\nChronic Care Programmes:\\n- Diabetes\\n- Mental health\\n- HIV or Heart-related medical conditions\\nConservative Care Programmes: \\n- Dyspepsia (severe heartburn)\\n- Tonsillitis (children under the age of 16) \\nSpinal Care Programme\\n\\nPre-operative Management Programme for Major surgeries\\n\\nConnected Care: Access to care from home\\nConnected Care a digital health care service through Discovery app\\n\\n(refer to brochure for detailed information)","logo":"Discovery.png"},{"company":"Discovery","name":"Classic Delta Core","planType":"Hospital plan","coverLevel":"Mid","hospital":"Network","chronic":"Network","serviceType":"N/A","familyIncome":"","mainContribution":"R2076","mainCompSavings":"R0.00","mainTotal":"R2076","dependendContributionAdult":"R1637","dependentCompSavingsAdult":"R0.00","dependentTotalAdult":"R1637","dependendContributionChild":"R830","dependentCompSavingsChild":"R0.00","dependentTotalChild":"R830","maxChildContribution":"3","mainThreshold":"","dependentThresholdAdult":"","dependentThresholdChild":"","preferedHospitalProvider":"Delta Network hospital","overallLimit":"Unlimited","coPayment":"\\n\\nScope Admissions co-payments:\\nDay clinic R3 800, In-hospital R6 550 co-payment will reduce to R5 450 if performed by a value-based network doctor\\n\\nIf both a Gastroscopy and Colonoscopy is performed in the same admission, the following co-payment apply\\nDay clinic R4 650, In-hospital R8 150 co-payment will reduce to R6 800 if performed by a value-based network doctor  \\n\\nNo co-payment if done in doctor's room as part of a PMB where indicated and approved for Dyspepsia or children under 12 years \\n\\nDefined list of procedure: R9 100 admission to facility outside of Day surgery network","rate":"200% Scheme Rate ","generalMedicin":"No benefit","specialist":"Full cover for Network specialists\\nNon-network Specialists and GPs : 200% of Scheme Rate\\n","dentistSurgical":"Severe dental and oral surgery covers a defined list of procedures with no co-payment or limits \\n\\nDental admissions co-payments: \\nMembers 13 years and older,              \\nHospital R7 350, Day clinic R4 700\\nMembers under 13 years,                               Hospital R2 850, Day clinic R1 300\\nDental appliances, their placements and orthodontic treatments (incl. related accounts) for members account\\n\\nBasic Dental Trauma Benefit\\nCover for dental appliances and prostheses and the placement thereof  paid up to an annual limit of R58 000 per person per year\\n","mentalHealth":"In Hospital: 21 days per beneficiary or \\nOut of Hospital: 15 consultations per beneficiary for treatment of (Major affective disorders, Anorexia, Bulimia) and 12 consultations per beneficiary for treatment of acute stress disorder due to recent trauma. Subject to PMB and Psychiatric Network (20% co-payment for non-DSP) \\n \\n21 days per beneficiary for alcohol and drug rehabilitation, 3 days per approved admission for detoxification\\n","radiology":"100% of Scheme Rate - Unlimited","pathology":"100% of Scheme Rate - Unlimited","maternityBenefit":"\\nIn hospital: Unlimited\\nOut-of-Hospital: \\n� 8 Antenatal visits (GP/Gynae/Midwife)\\n� 2 x 2D scans incl. 1 nuchal translucency test. 3D and 4D scans are covered at 2D scans rate\\n� Selected blood tests\\n� 1 Flu vaccination during pregnancy\\n� 5 Pre- or postnatal visits\\nCover for first 2 years after birth\\n� 2 GP, paediatric or ENT visits for baby\\n� 1 post-birth consult with Midwife, GP or Gynae \\n� 1 Dietitian nutritional assessment\\n� 2 Mental health consultations\\n� 1 Lactation consultations\\n\\n ","dialysis":"Full cover for approved treatment plan and use of network provide, otherwise 20% co-payments will apply","cancer":"First R200 000, thereafter, with a 20% co-payment. Medicine from DSP or 20% co-pay\\nOncology Innovation Benefit: cover a defined list of innovative cancer medicines that meet the Scheme�s criteria, subject to a 50% co-payments\\n","transplant":"100% Scheme Rate\\nNo details supplied for cadaver donor costs or live related donor costs","mri":"In Hospital:�100% of Scheme  Rate. No benefit, if not related to admission or if for conservative neck and back scans\\nOut-of-Hospital:�No benefit","prosthesisInternal":"Cochlear implants and Auditory Brain implants and processors:\\n- R230 400 per beneficiary per benefit \\nInternal Nerve Stimulators \\n- R165 300 per beneficiary \\nShoulder joint prosthesis\\n- Network Provider: Unlimited \\n- Non-Network Provider: R 42 950 \\nMajor joints surgery\\n- Network Provider: Unlimited \\n- Non-Network Provider: 20% co-payment up to max of R 30 900 \\nProsthetic devices used in spinal surgery: \\n- Network Provider: Unlimited \\n- Non-Network Provider: \\n    - First level: R26 250 per beneficiary\\n    - Two or more levels: R52 500 per beneficiary \\n- Up to 80% of Scheme rate","prosthesisExternal":"No benefit","rehab":"Connected care: quality care at home\\nCare offered: \\n- Postnatal care\\n- IV infusions (drips) \\n- Wound care\\n- Advanced illness care : Unlimited palliative care cover for approved care \\n","designatedServiceProvider":"MedXpress and MedXpress pharmacies","conditionsCovered":"CDL in PMB","formulary":"Yes","partialLimits":"20% co-payment for use of non-DSP Pharmacy","preferredProvider":"None","overallAnualLimit":"N/A","medicationOverCounter":"No benefit","medicationPrescribed":"No benefit","practitionersGeneral":"No benefit","specialistsCover":"No benefit","dentistryCover":"No benefit","dentistryCoverSpecial":"No benefit","optical":"No day-to-day benefits\\n(20% discount on frames and lenses at a network optometrist at point of sale) ","ambulance":"Preferred provider: Discovery 911","international":"Only for emergencies while travelling abroad; R5 million 90 days travelling\\nAfrica Evacuation Benefit","hospitalCoverAids":"Subject to registration on HIVCare Programme and use of Network Providers","artTtreatment":"Approved meds covered in full. Meds not on list covered up to a set monthly amount. 20% co-pay applies for use of non DSP Network","preventative":"Screening for Adults and Seniors\\nScreening for Kids\\nOther:\\n- Stem Cell Banking: with Netcells\\n- International Second Opinion Services from Cleveland clinic, with a 50% co-payment\\n- Trauma Recovery Extender Benefit \\nChronic Care Programmes:\\n- Diabetes\\n- Mental health\\n- HIV or Heart-related medical conditions\\nConservative Care Programmes: \\n- Dyspepsia (severe heartburn)\\n- Tonsillitis (children under the age of 16) \\nSpinal Care Programme\\n\\nPre-operative Management Programme for Major surgeries\\n\\nConnected Care: Access to care from home\\nConnected Care a digital health care service through Discovery app\\n\\n(refer to brochure for detailed information)","logo":"Discovery.png"},{"company":"Discovery","name":"Coastal Saver","planType":"New generation","coverLevel":"Mid","hospital":"Network","chronic":"Network","serviceType":"Any","familyIncome":"","mainContribution":"R2211","mainCompSavings":"R552","mainTotal":"R2763","dependendContributionAdult":"R1663","dependentCompSavingsAdult":"R415","dependentTotalAdult":"R2078","dependendContributionChild":"R893","dependentCompSavingsChild":"R223","dependentTotalChild":"R1116","maxChildContribution":"3","mainThreshold":"","dependentThresholdAdult":"","dependentThresholdChild":"","preferedHospitalProvider":"Coastal Network hospital","overallLimit":"Unlimited","coPayment":"\\n30% co-pay for use of non-network hospital\\n\\nScope Admissions co-payments:\\nDay clinic R3 800, In-hospital R6 550 co-payment will reduce to R5 450 if performed by a value-based network doctor\\n\\nIf both a Gastroscopy and Colonoscopy is performed in the same admission, the following co-payment apply\\nDay clinic R4 650, In-hospital R8 150 co-payment will reduce to R6 800 if performed by a value-based network doctor  \\n\\nNo co-payment if done in doctor's room as part of a PMB where indicated and approved for Dyspepsia or children under 12 years \\n\\nDefined list of procedure:\\n- Facility outside of the Network:   R5 950 \\n- Hospital outside the Network: R6 550 \\n- Both a gastroscopy and\\ncolonoscopy: R8 150","rate":"100% Scheme Rate ","generalMedicin":"Paid from available Savings","specialist":"Full cover for Network specialists\\nNon-network Specialists and GPs : \\n100% of Scheme Rate\\n","dentistSurgical":"Severe dental and oral surgery covers a defined list of procedures with no co-payment or limits \\n\\nDental admissions co-payments: \\nMembers 13 years and older,              \\nHospital R7 350, Day clinic R4 700\\nMembers under 13 years,                               Hospital R2 850, Day clinic R1 300\\nDental appliances, their placements and orthodontic treatments (incl. related accounts) for members account\\n\\nBasic Dental Trauma Benefit\\nCover for dental appliances and prostheses and the placement thereof  paid up to an annual limit of R58 000 per person per year\\n","mentalHealth":"In Hospital: 21 days per beneficiary or \\nOut of Hospital: 15 consultations per beneficiary for treatment of (Major affective disorders, Anorexia, Bulimia) and 12 consultations per beneficiary for treatment of acute stress disorder due to recent trauma. Subject to PMB and Psychiatric Network (20% co-payment for non-DSP) \\n \\n21 days per beneficiary for alcohol and drug rehabilitation, 3 days per approved admission for detoxification\\n","radiology":"100% of Scheme Rate - Unlimited","pathology":"100% of Scheme Rate - Unlimited","maternityBenefit":"\\nIn hospital: Unlimited\\nOut-of-Hospital: \\n� 8 Antenatal visits (GP/Gynae/Midwife)\\n� 2 x 2D scans incl. 1 nuchal translucency test. 3D and 4D scans are covered at 2D scans rate\\n� Selected blood tests\\n� 1 Flu vaccination during pregnancy\\n� 5 Pre- or postnatal visits\\nCover for first 2 years after birth\\n� 2 GP, paediatric or ENT visits for baby\\n� 1 post-birth consult with Midwife, GP or Gynae \\n� 1 Dietitian nutritional assessment\\n� 2 Mental health consultations\\n� 1 Lactation consultations\\n\\n ","dialysis":"Full cover for approved treatment plan and use of network provide, otherwise 20% co-payments will apply","cancer":"First R200 000, thereafter, with a 20% co-payment. Medicine from DSP or 20% co-pay\\nOncology Innovation Benefit: cover a defined list of innovative cancer medicines that meet the Scheme�s criteria, subject to a 50% co-payments\\n","transplant":"100% Scheme Rate\\nNo details supplied for cadaver donor costs or live related donor costs","mri":"\\nIn Hospital: 100% of Scheme Rate. If not related to admission or for conservative neck and back scans, R3 270 co-payment applies \\n\\nOut-of-Hospital:�R3 270 co-pay applies\\nConservative back and neck scans - limit  \\nof one scan per spinal and neck region\\n\\n","prosthesisInternal":"Cochlear implants and Auditory Brain implants and processors:\\n- R230 400 per beneficiary per benefit \\nInternal Nerve Stimulators \\n- R165 300 per beneficiary \\nShoulder joint prosthesis\\n- Network Provider: Unlimited \\n- Non-Network Provider: R 42 950 \\nMajor joints surgery\\n- Network Provider: Unlimited \\n- Non-Network Provider: 20% co-payment up to max of R 30 900 \\nProsthetic devices used in spinal surgery: \\n- Network Provider: Unlimited \\n- Non-Network Provider: \\n    - First level: R26 250 per beneficiary\\n    - Two or more levels: R52 500 per beneficiary \\n- Up to 80% of Scheme rate","prosthesisExternal":"Subject to available Savings","rehab":"Connected care: quality care at home\\nCare offered: \\n- Postnatal care\\n- IV infusions (drips) \\n- Wound care\\n- Advanced illness care : Unlimited palliative care cover for approved care \\n","designatedServiceProvider":"MedXpress and MedXpress pharmacies","conditionsCovered":"CDL in PMB","formulary":"Yes","partialLimits":"20% co-payment for use of non-DSP Pharmacy","preferredProvider":"None","overallAnualLimit":"N/A","medicationOverCounter":"Subject to available Savings","medicationPrescribed":"Subject to available Savings","practitionersGeneral":"Subject to available Savings\\nOnce Savings is depleted, Extender Benefit covers, unlimited pharmacy clinic consultations in wellness network, video call consults with network GP. Unlimited consultation with a network GP who meets the digital criteria, when referred\\nLimited to 3 per beneficiary, 6 per family","specialistsCover":"Subject to available Savings","dentistryCover":"Subject to available Savings","dentistryCoverSpecial":"Subject to available Savings","optical":"Subject to available Savings\\n(20% discount on frames and lenses at a network optometrist at point of sale) ","ambulance":"Preferred provider: Discovery 911","international":"Only for emergencies while travelling abroad; R5 million 90 days travelling\\nAfrica Evacuation Benefit","hospitalCoverAids":"Subject to registration on HIVCare Programme and use of Network Providers","artTtreatment":"Approved meds covered in full. Subject to 20% co-payment for use of non-Network Pharmacy","preventative":"Screening for Adults and Seniors\\nScreening for Kids\\nOther:\\n- Stem Cell Banking: with Netcells\\n- International Second Opinion Services from Cleveland clinic, with a 50% co-payment\\n- Trauma Recovery Extender Benefit \\nChronic Care Programmes:\\n- Diabetes\\n- Mental health\\n- HIV or Heart-related medical conditions\\nConservative Care Programmes: \\n- Dyspepsia (severe heartburn)\\n- Tonsillitis (children under the age of 16) \\nSpinal Care Programme\\n\\nPre-operative Management Programme for Major surgeries\\n\\nConnected Care: Access to care from home\\nConnected Care a digital health care service through Discovery app\\n\\n(refer to brochure for detailed information)","logo":"Discovery.png"},{"company":"Discovery","name":"Essential Delta Saver","planType":"New generation","coverLevel":"Mid","hospital":"Network","chronic":"Network","serviceType":"Any","familyIncome":"","mainContribution":"R1878","mainCompSavings":"R331","mainTotal":"R2209","dependendContributionAdult":"R1418","dependentCompSavingsAdult":"R250","dependentTotalAdult":"R1668","dependendContributionChild":"R754","dependentCompSavingsChild":"R133","dependentTotalChild":"R887","maxChildContribution":"3","mainThreshold":"","dependentThresholdAdult":"","dependentThresholdChild":"","preferedHospitalProvider":"Delta Network hospital","overallLimit":"Unlimited","coPayment":"R9 100 co-pay for non-Network hospital\\n\\nScope Admissions co-payments:\\nDay clinic R3 800, In-hospital R6 550 co-payment will reduce to R5 450 if performed by a value-based network doctor\\n\\nIf both a Gastroscopy and Colonoscopy is performed in the same admission, the following co-payment apply\\nDay clinic R4 650, In-hospital R8 150 co-payment will reduce to R6 800 if performed by a value-based network doctor  \\n\\nNo co-payment if done in doctor's room as part of a PMB where indicated and approved for Dyspepsia or children under 12 years \\n\\nDefined list of procedure: R9 100 admission to facility outside of Day surgery network","rate":"100% Scheme Rate ","generalMedicin":"Paid from available Savings","specialist":"Full cover for Network specialists\\nNon-network Specialists and GPs : \\n100% of Scheme Rate\\n","dentistSurgical":"Severe dental and oral surgery covers a defined list of procedures with no co-payment or limits \\n\\nDental admissions co-payments: \\nMembers 13 years and older,              \\nHospital R7 350, Day clinic R4 700\\nMembers under 13 years,                               Hospital R2 850, Day clinic R1 300\\nDental appliances, their placements and orthodontic treatments (incl. related accounts) for members account\\n\\nBasic Dental Trauma Benefit\\nCover for dental appliances and prostheses and the placement thereof  paid up to an annual limit of R58 000 per person per year\\n","mentalHealth":"In Hospital: 21 days per beneficiary or \\nOut of Hospital: 15 consultations per beneficiary for treatment of (Major affective disorders, Anorexia, Bulimia) and 12 consultations per beneficiary for treatment of acute stress disorder due to recent trauma. Subject to PMB and Psychiatric Network (20% co-payment for non-DSP) \\n \\n21 days per beneficiary for alcohol and drug rehabilitation, 3 days per approved admission for detoxification\\n","radiology":"100% of Scheme Rate - Unlimited","pathology":"100% of Scheme Rate - Unlimited","maternityBenefit":"\\nIn hospital: Unlimited\\nOut-of-Hospital: \\n� 8 Antenatal visits (GP/Gynae/Midwife)\\n� 2 x 2D scans incl. 1 nuchal translucency test. 3D and 4D scans are covered at 2D scans rate\\n� Selected blood tests\\n� 1 Flu vaccination during pregnancy\\n� 5 Pre- or postnatal visits\\nCover for first 2 years after birth\\n� 2 GP, paediatric or ENT visits for baby\\n� 1 post-birth consult with Midwife, GP or Gynae \\n� 1 Dietitian nutritional assessment\\n� 2 Mental health consultations\\n� 1 Lactation consultations\\n\\n ","dialysis":"Full cover for approved treatment plan and use of network provide, otherwise 20% co-payments will apply","cancer":"First R200 000, thereafter, with a 20% co-payment. Medicine from DSP or 20% co-pay\\nOncology Innovation Benefit: cover a defined list of innovative cancer medicines that meet the Scheme�s criteria, subject to a 50% co-payments\\n","transplant":"100% Scheme Rate\\nNo details supplied for cadaver donor costs or live related donor costs","mri":"\\nIn Hospital: 100% of Scheme Rate. If not related to admission or for conservative neck and back scans, R3 270 co-payment applies \\n\\nOut-of-Hospital:�R3 270 co-pay applies\\nConservative back and neck scans - limit  \\nof one scan per spinal and neck region\\n\\n","prosthesisInternal":"Cochlear implants and Auditory Brain implants and processors:\\n- R230 400 per beneficiary per benefit \\nInternal Nerve Stimulators \\n- R165 300 per beneficiary \\nShoulder joint prosthesis\\n- Network Provider: Unlimited \\n- Non-Network Provider: R 42 950 \\nMajor joints surgery\\n- Network Provider: Unlimited \\n- Non-Network Provider: 20% co-payment up to max of R 30 900 \\nProsthetic devices used in spinal surgery: \\n- Network Provider: Unlimited \\n- Non-Network Provider: \\n    - First level: R26 250 per beneficiary\\n    - Two or more levels: R52 500 per beneficiary \\n- Up to 80% of Scheme rate","prosthesisExternal":"Subject to available Savings","rehab":"Connected care: quality care at home\\nCare offered: \\n- Postnatal care\\n- IV infusions (drips) \\n- Wound care\\n- Advanced illness care : Unlimited palliative care cover for approved care \\n","designatedServiceProvider":"MedXpress and MedXpress pharmacies","conditionsCovered":"CDL in PMB","formulary":"Yes","partialLimits":"20% co-payment for use of non-DSP Pharmacy","preferredProvider":"None","overallAnualLimit":"N/A","medicationOverCounter":"Subject to available Savings","medicationPrescribed":"Subject to available Savings","practitionersGeneral":"Subject to available Savings\\nOnce Savings is depleted, Extender Benefit covers, unlimited pharmacy clinic consultations in wellness network, video call consults with network GP. Unlimited consultation with a network GP who meets the digital criteria, when referred\\nLimited to 2 per beneficiary, 4 per family","specialistsCover":"Subject to available Savings","dentistryCover":"Subject to available Savings","dentistryCoverSpecial":"Subject to available Savings","optical":"Subject to available Savings\\n(20% discount on frames and lenses at a network optometrist at point of sale) ","ambulance":"Preferred provider: Discovery 911","international":"Only for emergencies while travelling abroad; R5 million 90 days travelling\\nAfrica Evacuation Benefit","hospitalCoverAids":"Subject to registration on HIVCare Programme and use of Network Providers","artTtreatment":"Approved meds covered in full. Meds not on list covered up to a set monthly amount. Subject to DSP to avoid 20% co-payment","preventative":"Screening for Adults and Seniors\\nScreening for Kids\\nOther:\\n- Stem Cell Banking: with Netcells\\n- International Second Opinion Services from Cleveland clinic, with a 50% co-payment\\n- Trauma Recovery Extender Benefit \\nChronic Care Programmes:\\n- Diabetes\\n- Mental health\\n- HIV or Heart-related medical conditions\\nConservative Care Programmes: \\n- Dyspepsia (severe heartburn)\\n- Tonsillitis (children under the age of 16) \\nSpinal Care Programme\\n\\nPre-operative Management Programme for Major surgeries\\n\\nConnected Care: Access to care from home\\nConnected Care a digital health care service through Discovery app\\n\\n(refer to brochure for detailed information)","logo":"Discovery.png"},{"company":"Discovery","name":"Essential Saver","planType":"New generation","coverLevel":"Mid","hospital":"Any","chronic":"Network","serviceType":"Any","familyIncome":"","mainContribution":"R2355","mainCompSavings":"R415","mainTotal":"R2770","dependendContributionAdult":"R1767","dependentCompSavingsAdult":"R311","dependentTotalAdult":"R2078","dependendContributionChild":"R944","dependentCompSavingsChild":"R166","dependentTotalChild":"R1110","maxChildContribution":"3","mainThreshold":"","dependentThresholdAdult":"","dependentThresholdChild":"","preferedHospitalProvider":"Any hospital","overallLimit":"Unlimited","coPayment":"\\nScope Admissions co-payments:\\nDay clinic R3 800, In-hospital R6 550 co-payment will reduce to R5 450 if performed by a value-based network doctor\\n\\nIf both a Gastroscopy and Colonoscopy is performed in the same admission, the following co-payment apply\\nDay clinic R4 650, In-hospital R8 150 co-payment will reduce to R6 800 if performed by a value-based network doctor  \\n\\nNo co-payment if done in doctor's room as part of a PMB where indicated and approved for Dyspepsia or children under 12 years \\n\\nDefined list of procedure:\\n- Facility outside of the Network:   R5 950 \\n- Hospital outside the Network: R6 550 \\n- Both a gastroscopy and\\ncolonoscopy: R8 150","rate":"100% Scheme Rate ","generalMedicin":"Paid from available Savings","specialist":"Full cover for Network specialists\\nNon-network Specialists and GPs : \\n100% of Scheme Rate\\n","dentistSurgical":"Severe dental and oral surgery covers a defined list of procedures with no co-payment or limits \\n\\nDental admissions co-payments: \\nMembers 13 years and older,              \\nHospital R7 350, Day clinic R4 700\\nMembers under 13 years,                               Hospital R2 850, Day clinic R1 300\\nDental appliances, their placements and orthodontic treatments (incl. related accounts) for members account\\n\\nBasic Dental Trauma Benefit\\nCover for dental appliances and prostheses and the placement thereof  paid up to an annual limit of R58 000 per person per year\\n","mentalHealth":"In Hospital: 21 days per beneficiary or \\nOut of Hospital: 15 consultations per beneficiary for treatment of (Major affective disorders, Anorexia, Bulimia) and 12 consultations per beneficiary for treatment of acute stress disorder due to recent trauma. Subject to PMB and Psychiatric Network (20% co-payment for non-DSP) \\n \\n21 days per beneficiary for alcohol and drug rehabilitation, 3 days per approved admission for detoxification\\n","radiology":"100% of Scheme Rate - Unlimited","pathology":"100% of Scheme Rate - Unlimited","maternityBenefit":"\\nIn hospital: Unlimited\\nOut-of-Hospital: \\n� 8 Antenatal visits (GP/Gynae/Midwife)\\n� 2 x 2D scans incl. 1 nuchal translucency test. 3D and 4D scans are covered at 2D scans rate\\n� Selected blood tests\\n� 1 Flu vaccination during pregnancy\\n� 5 Pre- or postnatal visits\\nCover for first 2 years after birth\\n� 2 GP, paediatric or ENT visits for baby\\n� 1 post-birth consult with Midwife, GP or Gynae \\n� 1 Dietitian nutritional assessment\\n� 2 Mental health consultations\\n� 1 Lactation consultations\\n\\n ","dialysis":"Full cover for approved treatment plan and use of network provide, otherwise 20% co-payments will apply","cancer":"First R200 000, thereafter, with a 20% co-payment. Medicine from DSP or 20% co-pay\\nOncology Innovation Benefit: cover a defined list of innovative cancer medicines that meet the Scheme�s criteria, subject to a 50% co-payments\\n","transplant":"100% Scheme Rate\\nNo details supplied for cadaver donor costs or live related donor costs","mri":"\\nIn Hospital: 100% of Scheme Rate. If not related to admission or for conservative neck and back scans, R3 270 co-payment applies \\n\\nOut-of-Hospital:�R3 270 co-pay applies\\nConservative back and neck scans - limit  \\nof one scan per spinal and neck region\\n\\n","prosthesisInternal":"Cochlear implants and Auditory Brain implants and processors:\\n- R230 400 per beneficiary per benefit \\nInternal Nerve Stimulators \\n- R165 300 per beneficiary \\nShoulder joint prosthesis\\n- Network Provider: Unlimited \\n- Non-Network Provider: R 42 950 \\nMajor joints surgery\\n- Network Provider: Unlimited \\n- Non-Network Provider: 20% co-payment up to max of R 30 900 \\nProsthetic devices used in spinal surgery: \\n- Network Provider: Unlimited \\n- Non-Network Provider: \\n    - First level: R26 250 per beneficiary\\n    - Two or more levels: R52 500 per beneficiary \\n- Up to 80% of Scheme rate","prosthesisExternal":"Subject to available Savings","rehab":"Connected care: quality care at home\\nCare offered: \\n- Postnatal care\\n- IV infusions (drips) \\n- Wound care\\n- Advanced illness care : Unlimited palliative care cover for approved care \\n","designatedServiceProvider":"MedXpress and MedXpress pharmacies","conditionsCovered":"CDL in PMB","formulary":"Yes","partialLimits":"20% co-payment for use of non-DSP Pharmacy","preferredProvider":"None","overallAnualLimit":"N/A","medicationOverCounter":"Subject to available Savings","medicationPrescribed":"Subject to available Savings","practitionersGeneral":"Subject to available Savings\\nOnce Savings is depleted, Extender Benefit covers, unlimited pharmacy clinic consultations in wellness network, video call consults with network GP. Unlimited consultation with a network GP who meets the digital criteria, when referred\\nLimited to 2 per beneficiary, 4 per family","specialistsCover":"Subject to available Savings","dentistryCover":"Subject to available Savings","dentistryCoverSpecial":"Subject to available Savings","optical":"Subject to available Savings\\n(20% discount on frames and lenses at a network optometrist at point of sale) ","ambulance":"Preferred provider: Discovery 911","international":"Only for emergencies while travelling abroad; R5 million 90 days travelling\\nAfrica Evacuation Benefit","hospitalCoverAids":"Subject to registration on HIVCare Programme and use of Network Providers","artTtreatment":"Approved meds covered in full. Meds not on list covered up to a set monthly amount. 20% co-pay applies for use of non DSP Network","preventative":"Screening for Adults and Seniors\\nScreening for Kids\\nOther:\\n- Stem Cell Banking: with Netcells\\n- International Second Opinion Services from Cleveland clinic, with a 50% co-payment\\n- Trauma Recovery Extender Benefit \\nChronic Care Programmes:\\n- Diabetes\\n- Mental health\\n- HIV or Heart-related medical conditions\\nConservative Care Programmes: \\n- Dyspepsia (severe heartburn)\\n- Tonsillitis (children under the age of 16) \\nSpinal Care Programme\\n\\nPre-operative Management Programme for Major surgeries\\n\\nConnected Care: Access to care from home\\nConnected Care a digital health care service through Discovery app\\n\\n(refer to brochure for detailed information)","logo":"Discovery.png"},{"company":"Discovery","name":"Classic Delta Saver ","planType":"New generation","coverLevel":"Mid","hospital":"Network","chronic":"Network","serviceType":"Any","familyIncome":"","mainContribution":"R2088","mainCompSavings":"R696","mainTotal":"R2784","dependendContributionAdult":"R1650","dependentCompSavingsAdult":"R550","dependentTotalAdult":"R2200","dependendContributionChild":"R839","dependentCompSavingsChild":"R279","dependentTotalChild":"R1118","maxChildContribution":"3","mainThreshold":"","dependentThresholdAdult":"","dependentThresholdChild":"","preferedHospitalProvider":"Delta Network hospital","overallLimit":"Unlimited","coPayment":"R9 100 co-pay for non-Network hospital\\n\\nScope Admissions co-payments:\\nDay clinic R3 800, In-hospital R6 550 co-payment will reduce to R5 450 if performed by a value-based network doctor\\n\\nIf both a Gastroscopy and Colonoscopy is performed in the same admission, the following co-payment apply\\nDay clinic R4 650, In-hospital R8 150 co-payment will reduce to R6 800 if performed by a value-based network doctor  \\n\\nNo co-payment if done in doctor's room as part of a PMB where indicated and approved for Dyspepsia or children under 12 years  \\n\\nDefined list of procedure: R9 100 admission to facility outside of Day surgery network","rate":"200% Scheme Rate ","generalMedicin":"Paid from available Savings","specialist":"Full cover for Network specialists\\nNon-network Specialists and GPs: \\n200% of Scheme Rate\\n","dentistSurgical":"Severe dental and oral surgery covers a defined list of procedures with no co-payment or limits \\n\\nDental admissions co-payments: \\nMembers 13 years and older,              \\nHospital R7 350, Day clinic R4 700\\nMembers under 13 years,                               Hospital R2 850, Day clinic R1 300\\nDental appliances, their placements and orthodontic treatments (incl. related accounts) for members account\\n\\nBasic Dental Trauma Benefit\\nCover for dental appliances and prostheses and the placement thereof  paid up to an annual limit of R58 000 per person per year\\n","mentalHealth":"In Hospital: 21 days per beneficiary or \\nOut of Hospital: 15 consultations per beneficiary for treatment of (Major affective disorders, Anorexia, Bulimia) and 12 consultations per beneficiary for treatment of acute stress disorder due to recent trauma. Subject to PMB and Psychiatric Network (20% co-payment for non-DSP) \\n \\n21 days per beneficiary for alcohol and drug rehabilitation, 3 days per approved admission for detoxification\\n","radiology":"100% of Scheme Rate - Unlimited","pathology":"100% of Scheme Rate - Unlimited","maternityBenefit":"\\nIn hospital: Unlimited\\nOut-of-Hospital: \\n� 8 Antenatal visits (GP/Gynae/Midwife)\\n� 2 x 2D scans incl. 1 nuchal translucency test. 3D and 4D scans are covered at 2D scans rate\\n� Selected blood tests\\n� 1 Flu vaccination during pregnancy\\n� 5 Pre- or postnatal visits\\nCover for first 2 years after birth\\n� 2 GP, paediatric or ENT visits for baby\\n� 1 post-birth consult with Midwife, GP or Gynae \\n� 1 Dietitian nutritional assessment\\n� 2 Mental health consultations\\n� 1 Lactation consultations\\n\\n ","dialysis":"Full cover for approved treatment plan and use of network provide, otherwise 20% co-payments will apply","cancer":"First R200 000, thereafter, with a 20% co-payment. Medicine from DSP or 20% co-pay\\nOncology Innovation Benefit: cover a defined list of innovative cancer medicines that meet the Scheme�s criteria, subject to a 50% co-payments\\n","transplant":"100% Scheme Rate\\nNo details supplied for cadaver donor costs or live related donor costs","mri":"\\nIn Hospital: 100% of Scheme Rate. If not related to admission or for conservative neck and back scans, R3 270 co-payment applies \\n\\nOut-of-Hospital:�R3 270 co-pay applies\\nConservative back and neck scans - limit  \\nof one scan per spinal and neck region\\n\\n","prosthesisInternal":"Cochlear implants and Auditory Brain implants and processors:\\n- R230 400 per beneficiary per benefit \\nInternal Nerve Stimulators \\n- R165 300 per beneficiary \\nShoulder joint prosthesis\\n- Network Provider: Unlimited \\n- Non-Network Provider: R 42 950 \\nMajor joints surgery\\n- Network Provider: Unlimited \\n- Non-Network Provider: 20% co-payment up to max of R 30 900 \\nProsthetic devices used in spinal surgery: \\n- Network Provider: Unlimited \\n- Non-Network Provider: \\n    - First level: R26 250 per beneficiary\\n    - Two or more levels: R52 500 per beneficiary \\n- Up to 80% of Scheme rate","prosthesisExternal":"Subject to available Savings","rehab":"Connected care: quality care at home\\nCare offered: \\n- Postnatal care\\n- IV infusions (drips) \\n- Wound care\\n- Advanced illness care : Unlimited palliative care cover for approved care \\n","designatedServiceProvider":"MedXpress and MedXpress pharmacies","conditionsCovered":"CDL in PMB","formulary":"Yes","partialLimits":"20% co-payment for use of non-DSP Pharmacy","preferredProvider":"None","overallAnualLimit":"N/A","medicationOverCounter":"Subject to available Savings","medicationPrescribed":"Subject to available Savings","practitionersGeneral":"Subject to available Savings\\nOnce Savings is depleted, Extender Benefit covers, unlimited pharmacy clinic consultations in wellness network, video call consults with network GP. Unlimited consultation with a network GP who meets the digital criteria, when referred\\nLimited to 3 per beneficiary, 6 per family\\n- 2 casualty visit for kids under 10 years","specialistsCover":"Subject to available Savings","dentistryCover":"Subject to available Savings","dentistryCoverSpecial":"Subject to available Savings","optical":"Subject to available Savings\\n(20% discount on frames and lenses at a network optometrist at point of sale) ","ambulance":"Preferred provider: Discovery 911","international":"Only for emergencies while travelling abroad; R5 million 90 days travelling\\nAfrica Evacuation Benefit","hospitalCoverAids":"Subject to registration on HIVCare Programme and use of Network Providers","artTtreatment":"Approved meds covered in full. Meds not on list covered up to a set monthly amount. 20% co-pay applies for use of non DSP Network","preventative":"Screening for Adults and Seniors\\nScreening for Kids\\nOther:\\n- Stem Cell Banking: with Netcells\\n- International Second Opinion Services from Cleveland clinic, with a 50% co-payment\\n- Trauma Recovery Extender Benefit \\nChronic Care Programmes:\\n- Diabetes\\n- Mental health\\n- HIV or Heart-related medical conditions\\nConservative Care Programmes: \\n- Dyspepsia (severe heartburn)\\n- Tonsillitis (children under the age of 16) \\nSpinal Care Programme\\n\\nPre-operative Management Programme for Major surgeries\\n\\nConnected Care: Access to care from home\\nConnected Care a digital health care service through Discovery app\\n\\n(refer to brochure for detailed information)","logo":"Discovery.png"},{"company":"Discovery","name":"Classic Saver ","planType":"New generation","coverLevel":"Mid","hospital":"Network","chronic":"Network","serviceType":"Any","familyIncome":"","mainContribution":"R2614","mainCompSavings":"R871","mainTotal":"R3485","dependendContributionAdult":"R2063","dependentCompSavingsAdult":"R687","dependentTotalAdult":"R2750","dependendContributionChild":"R1048","dependentCompSavingsChild":"R349","dependentTotalChild":"R1397","maxChildContribution":"3","mainThreshold":"","dependentThresholdAdult":"","dependentThresholdChild":"","preferedHospitalProvider":"Any hospital","overallLimit":"Unlimited","coPayment":"\\nScope Admissions co-payments:\\nDay clinic R3 800, In-hospital R6 550 co-payment will reduce to R5 450 if performed by a value-based network doctor\\n\\nIf both a Gastroscopy and Colonoscopy is performed in the same admission, the following co-payment apply\\nDay clinic R4 650, In-hospital R8 150 co-payment will reduce to R6 800 if performed by a value-based network doctor  \\n\\nNo co-payment if done in doctor's room as part of a PMB where indicated and approved for Dyspepsia or children under 12 years \\n\\nDefined list of procedure:\\n- Facility outside of the Network:   R5 950 \\n- Hospital outside the Network: R6 550 \\n- Both a gastroscopy and\\ncolonoscopy: R8 150","rate":"200% Scheme Rate ","generalMedicin":"Paid from available Savings","specialist":"Full cover for Network specialists\\nNon-network Specialists and GPs: \\n200% of Scheme Rate\\n","dentistSurgical":"Severe dental and oral surgery covers a defined list of procedures with no co-payment or limits \\n\\nDental admissions co-payments: \\nMembers 13 years and older,              \\nHospital R7 350, Day clinic R4 700\\nMembers under 13 years,                               Hospital R2 850, Day clinic R1 300\\nDental appliances, their placements and orthodontic treatments (incl. related accounts) for members account\\n\\nBasic Dental Trauma Benefit\\nCover for dental appliances and prostheses and the placement thereof  paid up to an annual limit of R58 000 per person per year\\n","mentalHealth":"In Hospital: 21 days per beneficiary or \\nOut of Hospital: 15 consultations per beneficiary for treatment of (Major affective disorders, Anorexia, Bulimia) and 12 consultations per beneficiary for treatment of acute stress disorder due to recent trauma. Subject to PMB and Psychiatric Network (20% co-payment for non-DSP) \\n \\n21 days per beneficiary for alcohol and drug rehabilitation, 3 days per approved admission for detoxification\\n","radiology":"100% of Scheme Rate - Unlimited","pathology":"100% of Scheme Rate - Unlimited","maternityBenefit":"\\nIn hospital: Unlimited\\nOut-of-Hospital: \\n� 8 Antenatal visits (GP/Gynae/Midwife)\\n� 2 x 2D scans incl. 1 nuchal translucency test. 3D and 4D scans are covered at 2D scans rate\\n� Selected blood tests\\n� 1 Flu vaccination during pregnancy\\n� 5 Pre- or postnatal visits\\nCover for first 2 years after birth\\n� 2 GP, paediatric or ENT visits for baby\\n� 1 post-birth consult with Midwife, GP or Gynae \\n� 1 Dietitian nutritional assessment\\n� 2 Mental health consultations\\n� 1 Lactation consultations\\n\\n ","dialysis":"Full cover for approved treatment plan and use of network provide, otherwise 20% co-payments will apply","cancer":"First R200 000, thereafter, with a 20% co-payment. Medicine from DSP or 20% co-pay\\nOncology Innovation Benefit: cover a defined list of innovative cancer medicines that meet the Scheme�s criteria, subject to a 50% co-payments\\n","transplant":"100% Scheme Rate\\nNo details supplied for cadaver donor costs or live related donor costs","mri":"\\nIn Hospital: 100% of Scheme Rate. If not related to admission or for conservative neck and back scans, R3 270 co-payment applies \\n\\nOut-of-Hospital:�R3 270 co-pay applies\\nConservative back and neck scans - limit  \\nof one scan per spinal and neck region\\n\\n","prosthesisInternal":"Cochlear implants and Auditory Brain implants and processors:\\n- R230 400 per beneficiary per benefit \\nInternal Nerve Stimulators \\n- R165 300 per beneficiary \\nShoulder joint prosthesis\\n- Network Provider: Unlimited \\n- Non-Network Provider: R 42 950 \\nMajor joints surgery\\n- Network Provider: Unlimited \\n- Non-Network Provider: 20% co-payment up to max of R 30 900 \\nProsthetic devices used in spinal surgery: \\n- Network Provider: Unlimited \\n- Non-Network Provider: \\n    - First level: R26 250 per beneficiary\\n    - Two or more levels: R52 500 per beneficiary \\n- Up to 80% of Scheme rate","prosthesisExternal":"Subject to available Savings","rehab":"Connected care: quality care at home\\nCare offered: \\n- Postnatal care\\n- IV infusions (drips) \\n- Wound care\\n- Advanced illness care : Unlimited palliative care cover for approved care \\n","designatedServiceProvider":"MedXpress and MedXpress pharmacies","conditionsCovered":"CDL in PMB","formulary":"Yes","partialLimits":"20% co-payment for use of non-DSP Pharmacy","preferredProvider":"None","overallAnualLimit":"N/A","medicationOverCounter":"Subject to available Savings","medicationPrescribed":"Subject to available Savings","practitionersGeneral":"Subject to available Savings\\nOnce Savings is depleted, Extender Benefit covers, unlimited pharmacy clinic consultations in wellness network, video call consults with network GP. Unlimited consultation with a network GP who meets the digital criteria, when referred\\nLimited to 3 per beneficiary, 6 per family\\n- 2 casualty visit for kids under 10 years","specialistsCover":"Subject to available Savings","dentistryCover":"Subject to available Savings","dentistryCoverSpecial":"Subject to available Savings","optical":"Subject to available Savings\\n(20% discount on frames and lenses at a network optometrist at point of sale) ","ambulance":"Preferred provider: Discovery 911","international":"Only for emergencies while travelling abroad; R5 million 90 days travelling\\nAfrica Evacuation Benefit","hospitalCoverAids":"Subject to registration on HIVCare Programme and use of Network Providers","artTtreatment":"Approved meds covered in full. Meds not on list covered up to a set monthly amount. 20% co-pay applies for use of non DSP Network","preventative":"Screening for Adults and Seniors\\nScreening for Kids\\nOther:\\n- Stem Cell Banking: with Netcells\\n- International Second Opinion Services from Cleveland clinic, with a 50% co-payment\\n- Trauma Recovery Extender Benefit \\nChronic Care Programmes:\\n- Diabetes\\n- Mental health\\n- HIV or Heart-related medical conditions\\nConservative Care Programmes: \\n- Dyspepsia (severe heartburn)\\n- Tonsillitis (children under the age of 16) \\nSpinal Care Programme\\n\\nPre-operative Management Programme for Major surgeries\\n\\nConnected Care: Access to care from home\\nConnected Care a digital health care service through Discovery app\\n\\n(refer to brochure for detailed information)","logo":"Discovery.png"},{"company":"Discovery","name":"Essential Smart","planType":"New generation","coverLevel":"Mid","hospital":"Network","chronic":"Network","serviceType":"Any","familyIncome":"","mainContribution":"R1483","mainCompSavings":"R0.00","mainTotal":"R1483","dependendContributionAdult":"R1483","dependentCompSavingsAdult":"R0.00","dependentTotalAdult":"R1483","dependendContributionChild":"R1483","dependentCompSavingsChild":"R0.00","dependentTotalChild":"R1483","maxChildContribution":"3","mainThreshold":"","dependentThresholdAdult":"","dependentThresholdChild":"","preferedHospitalProvider":"Smart Network hospital","overallLimit":"Unlimited","coPayment":"R10 400 co-pay for non-Network hospital\\n\\nScope Admissions co-payments:\\nDay clinic R3 800, In-hospital R6 550 co-payment will reduce to R5 450 if performed by a value-based network doctor\\n\\nIf both a Gastroscopy and Colonoscopy is performed in the same admission, the following co-payment apply\\nDay clinic R4 650, In-hospital R8 150 co-payment will reduce to R6 800 if performed by a value-based network doctor  \\n\\nNo co-payment if done in doctor's room as part of a PMB where indicated and approved for Dyspepsia or children under 12 years \\n\\nDefined list of procedure: R10 400 admission to facility outside of Day surgery network ","rate":"100% Scheme Rate ","generalMedicin":"No benefit","specialist":"Full cover for Network specialists\\nNon-network Specialists and GPs: \\n100% of Scheme Rate\\n","dentistSurgical":"For severe dental and oral surgery, a defined list of procedures is included, with no upfront payment and no overall limit.                               \\nDentistry hospital admissions: no benefit\\n\\n","mentalHealth":"In Hospital: 21 days per beneficiary or \\nOut of Hospital: 15 consultations per beneficiary for treatment of (Major affective disorders, Anorexia, Bulimia) and 12 consultations per beneficiary for treatment of acute stress disorder due to recent trauma. Subject to PMB and Psychiatric Network (20% co-payment for non-DSP) \\n \\n21 days per beneficiary for alcohol and drug rehabilitation, 3 days per approved admission for detoxification\\n","radiology":"100% of Scheme Rate - Unlimited","pathology":"100% of Scheme Rate - Unlimited","maternityBenefit":"\\nIn hospital: Unlimited\\nElective caesarean section - no benefit\\nOut-of-Hospital: \\n� 8 Antenatal visits (GP/Gynae/Midwife)\\n� 2 x 2D scans incl. 1 nuchal translucency test. 3D and 4D scans are covered at 2D scans rate\\n� Selected blood tests\\n� 1 Flu vaccination during pregnancy\\n� 5 Pre- or postnatal visits\\nCover for first 2 years after birth\\n� 2 GP, paediatric or ENT visits for baby\\n� 1 post-birth consult with Midwife, GP or Gynae \\n� 1 Dietitian nutritional assessment\\n� 2 Mental health consultations\\n� 1 Lactation consultations\\n\\n ","dialysis":"Limited to State facility","cancer":"First R200 000, thereafter, with a 20% co-payment. Medicine from DSP or 20% co-pay\\nOncology Innovation Benefit: cover a defined list of innovative cancer medicines that meet the Scheme�s criteria, subject to a 50% co-payments\\n","transplant":"100% Scheme Rate\\nNo details supplied for cadaver donor costs or live related donor costs","mri":"In hospital:�No benefit, if not related to admission or if for conservative neck and back scans.\\nOut-of-Hospital:�No benefit","prosthesisInternal":"No benefit\\nMajor joints surgery:\\nCover limited to arthroscopies only\\n","prosthesisExternal":"No benefit","rehab":"Connected care: quality care at home\\nCare offered: \\n- Postnatal care\\n- IV infusions (drips) \\n- Wound care\\n- Advanced illness care : Unlimited palliative care cover for approved care \\n","designatedServiceProvider":"MedXpress and MedXpress pharmacies","conditionsCovered":"CDL in PMB","formulary":"Yes","partialLimits":"20% co-payment for use of non-DSP Pharmacy","preferredProvider":"None","overallAnualLimit":"N/A","medicationOverCounter":"Limited to R 495 per family\\n(subject to network pharmacy)","medicationPrescribed":"No benefit","practitionersGeneral":"Smart Plan Network GP: Unlimited\\nR115 co-payment per consult\\nVideo call consults covered in full\\n","specialistsCover":"No benefit","dentistryCover":"1 defined dental check-up with R170 co-payment","dentistryCoverSpecial":"No benefit","optical":"One eye test pbpa, at a Smart Network.\\nR115 co-payment apply\\n(20% discount on frames and lenses at a network optometrist at point of sale) ","ambulance":"Preferred provider: Discovery 911","international":"Only for emergencies while travelling abroad; R5 million 90 days travelling\\nAfrica Evacuation Benefit","hospitalCoverAids":"Subject to registration on HIVCare Programme and use of Network Providers","artTtreatment":"Approved meds covered in full. Meds not on list covered up to a set monthly amount. 20% co-pay applies for use of non DSP Network","preventative":"Screening for Adults and Seniors\\nScreening for Kids\\nOther:\\n- Stem Cell Banking: with Netcells\\n- International Second Opinion Services from Cleveland clinic, with a 50% co-payment\\n- Trauma Recovery Extender Benefit \\nChronic Care Programmes:\\n- Diabetes\\n- Mental health\\n- HIV or Heart-related medical conditions\\nConservative Care Programmes: \\n- Dyspepsia (severe heartburn)\\n- Tonsillitis (children under the age of 16) \\nSpinal Care Programme\\n\\nPre-operative Management Programme for Major surgeries\\n\\nConnected Care: Access to care from home\\nConnected Care a digital health care service through Discovery app\\n\\n(refer to brochure for detailed information)","logo":"Discovery.png"},{"company":"Discovery","name":"Classic Smart","planType":"New generation","coverLevel":"Mid","hospital":"Network","chronic":"Network","serviceType":"Any","familyIncome":"","mainContribution":"R2070","mainCompSavings":"R0.00","mainTotal":"R2070","dependendContributionAdult":"R1634","dependentCompSavingsAdult":"R0.00","dependentTotalAdult":"R1634","dependendContributionChild":"R827","dependentCompSavingsChild":"R0.00","dependentTotalChild":"R827","maxChildContribution":"3","mainThreshold":"","dependentThresholdAdult":"","dependentThresholdChild":"","preferedHospitalProvider":"Smart Network hospital","overallLimit":"Unlimited","coPayment":"R10 400 co-pay for non-Network hospital\\n\\nScope Admissions co-payments:\\nDay clinic R3 800, In-hospital R6 550 co-payment will reduce to R5 450 if performed by a value-based network doctor\\n\\nIf both a Gastroscopy and Colonoscopy is performed in the same admission, the following co-payment apply\\nDay clinic R4 650, In-hospital R8 150 co-payment will reduce to R6 800 if performed by a value-based network doctor  \\n\\nNo co-payment if done in doctor's room as part of a PMB where indicated and approved for Dyspepsia or children under 12 years \\n\\nDefined list of procedure: R10 400 admission to facility outside of Day surgery network ","rate":"200% Scheme Rate","generalMedicin":"No benefit","specialist":"Full cover for Network specialists\\nNon-network Specialists and GPs: \\n200% of Scheme Rate\\n","dentistSurgical":"Severe dental and oral surgery covers a defined list of procedures with no co-payment or limits \\n\\nDental admissions co-payments: \\nMembers 13 years and older,   \\nHospital R7 350, Day clinic R4 700\\nMembers under 13 years,         \\nHospital R2 850, Day clinic R1 300\\nDental appliances, their placements and orthodontic treatments (incl. related accounts) for members account\\n\\nBasic Dental Trauma Benefit\\nCover for dental appliances and prostheses and the placement thereof  paid up to an annual limit of R58 000 per person per year\\n","mentalHealth":"In Hospital: 21 days per beneficiary or \\nOut of Hospital: 15 consultations per beneficiary for treatment of (Major affective disorders, Anorexia, Bulimia) and 12 consultations per beneficiary for treatment of acute stress disorder due to recent trauma. Subject to PMB and Psychiatric Network (20% co-payment for non-DSP) \\n \\n21 days per beneficiary for alcohol and drug rehabilitation, 3 days per approved admission for detoxification\\n","radiology":"100% of Scheme Rate - Unlimited","pathology":"100% of Scheme Rate - Unlimited","maternityBenefit":"\\nIn hospital: Unlimited\\nOut-of-Hospital: \\n� 8 Antenatal visits (GP/Gynae/Midwife)\\n� 2 x 2D scans incl. 1 nuchal translucency test. 3D and 4D scans are covered at 2D scans rate\\n� Selected blood tests\\n� 1 Flu vaccination during pregnancy\\n� 5 Pre- or postnatal visits\\nCover for first 2 years after birth\\n� 2 GP, paediatric or ENT visits for baby\\n� 1 post-birth consult with Midwife, GP or Gynae \\n� 1 Dietitian nutritional assessment\\n� 2 Mental health consultations\\n� 1 Lactation consultations\\n\\n ","dialysis":"Full cover for approved treatment plan and use of network provide, otherwise 20% co-payments will apply","cancer":"First R200 000, thereafter, with a 20% co-payment. Medicine from DSP or 20% co-pay\\nOncology Innovation Benefit: cover a defined list of innovative cancer medicines that meet the Scheme�s criteria, subject to a 50% co-payments\\n","transplant":"100% Scheme Rate\\nNo details supplied for cadaver donor costs or live related donor costs","mri":"\\nIn Hospital: if not related to admission or for conservative neck and back scans, R3 270 co-payment applies \\n\\nOut-of-Hospital:�R3 270 co-pay applies\\nConservative back and neck scans - limit  \\nof one scan per spinal and neck region\\n\\n","prosthesisInternal":"Cochlear implants and Auditory Brain implants and processors:\\n- R230 400 per beneficiary per benefit \\nInternal Nerve Stimulators \\n- R165 300 per beneficiary \\nShoulder joint prosthesis\\n- Network Provider: Unlimited \\n- Non-Network Provider: R 42 950 \\nMajor joints surgery\\n- Network Provider: Unlimited \\n- Non-Network Provider: 20% co-payment up to max of R 30 900 \\nProsthetic devices used in spinal surgery: \\n- Network Provider: Unlimited \\n- Non-Network Provider: \\n    - First level: R26 250 per beneficiary\\n    - Two or more levels: R52 500 per beneficiary \\n- Up to 80% of Scheme rate","prosthesisExternal":"No benefit","rehab":"Connected care: quality care at home\\nCare offered: \\n- Postnatal care\\n- IV infusions (drips) \\n- Wound care\\n- Advanced illness care : Unlimited palliative care cover for approved care \\n","designatedServiceProvider":"MedXpress and MedXpress pharmacies","conditionsCovered":"CDL in PMB","formulary":"Yes","partialLimits":"20% co-payment for use of non-DSP Pharmacy","preferredProvider":"None","overallAnualLimit":"N/A","medicationOverCounter":"Limited to R 740 per family\\n(subject to network pharmacy)","medicationPrescribed":"Cover for a defined list of medicine prescribed by Network GP\\nLimited to R1 620 per beneficiary, R2 700 per family per at a network pharmacy","practitionersGeneral":"Smart Plan Network GP: Unlimited\\nR60 co-payment per consult\\nVideo call consults covered in full\\n","specialistsCover":"Benefits available when referred by a  Smart Network GP for sports injuries:\\n- 2 specialist visits per beneficiary\\n- 4 visits to either a physio, biokineticist or chiropractor\\n- Cover for basic X-rays. R115 co-payment per visit \\n","dentistryCover":"1 defined dental check-up with R115 co-payment","dentistryCoverSpecial":"No benefit","optical":"One eye test pbpa, at a Smart Network.\\nR60 co-payment apply\\n(20% discount on frames and lenses at a network optometrist at point of sale) ","ambulance":"Preferred provider: Discovery 911","international":"Only for emergencies while travelling abroad; R5 million 90 days travelling\\nAfrica Evacuation Benefit","hospitalCoverAids":"Subject to registration on HIVCare Programme and use of Network Providers","artTtreatment":"Approved meds covered in full. Meds not on list covered up to a set monthly amount. 20% co-pay applies for use of non DSP Network","preventative":"Screening for Adults and Seniors\\nScreening for Kids\\nOther:\\n- Stem Cell Banking: with Netcells\\n- International Second Opinion Services from Cleveland clinic, with a 50% co-payment\\n- Trauma Recovery Extender Benefit \\nChronic Care Programmes:\\n- Diabetes\\n- Mental health\\n- HIV or Heart-related medical conditions\\nConservative Care Programmes: \\n- Dyspepsia (severe heartburn)\\n- Tonsillitis (children under the age of 16) \\nSpinal Care Programme\\n\\nPre-operative Management Programme for Major surgeries\\n\\nConnected Care: Access to care from home\\nConnected Care a digital health care service through Discovery app\\n\\n(refer to brochure for detailed information)","logo":"Discovery.png"},{"company":"Discovery","name":"Essential Priority","planType":"Limited threshold option","coverLevel":"Mid","hospital":"Any","chronic":"Network","serviceType":"Any","familyIncome":"","mainContribution":"R2952","mainCompSavings":"R520","mainTotal":"R3472","dependendContributionAdult":"R2322","dependentCompSavingsAdult":"R409","dependentTotalAdult":"R2731","dependendContributionChild":"R1180","dependentCompSavingsChild":"R208","dependentTotalChild":"R1388","maxChildContribution":"3","mainThreshold":"","dependentThresholdAdult":"","dependentThresholdChild":"","preferedHospitalProvider":"Any hospital","overallLimit":"Unlimited","coPayment":"Defined list of Procedure: R5 950 admission to facility outside of Day surgery network \\n� Co-payment when below listed procedures are performed during a hospital admission including procedures in the Day surgery network\\nR4 050 Conservative back and neck treatment, adenoidectomy, myringotomy (grommets) tonsillectomy\\nR9 450 Arthroscopy functional nasal procedures hysterectomy, laparoscopy,  hysteroscopy endometrial ablation\\nR19 450 Reflux surgery, spinal surgery joint replacements\\n\\nScope Admissions co-payments:\\nDay clinic R3 800, In-hospital R6 150 co-payment will reduce to R5 000 if performed by a value-based network doctor\\n\\nIf both a Gastroscopy and Colonoscopy is performed in the same admission, the following co-payment apply\\nDay clinic R4 650, In-hospital R7 700 co-payment will reduce to R6 300 if performed by a value-based network doctor   \\n\\nNo co-payment if done in doctor's room as part of a PMB where indicated and approved for Dyspepsia or children under 12 years ","rate":"100% Scheme Rate ","generalMedicin":"Paid from available day-to-day benefits","specialist":"Full cover for Network specialists\\nNon-network Specialists and GPs: \\n100% of Scheme Rate\\n","dentistSurgical":"Severe dental and oral surgery covers a defined list of procedures with no co-payment or limits  \\n       \\nDental admissions co-payments: \\nMembers 13 years and older,      \\nHospital R7 350, Day clinic R4 700\\nMembers under 13 years,              \\nHospital R2 850, Day clinic R1 300\\nThereafter paid from hospital benefit\\nDental appliances, their placements and orthodontic treatments (incl. related accounts) paid from day-to-day benefit limit of R19 150 per beneficiary\\n\\nBasic Dental Trauma Benefit\\nCover for dental appliances and prostheses and the placement thereof  paid up to an annual limit of R58 000 per person per year\\n","mentalHealth":"In Hospital: 21 days per beneficiary or \\nOut of Hospital: 15 consultations per beneficiary for treatment of (Major affective disorders, Anorexia, Bulimia) and 12 consultations per beneficiary for treatment of acute stress disorder due to recent trauma. Subject to PMB and Psychiatric Network (20% co-payment for non-DSP) \\n \\n21 days per beneficiary for alcohol and drug rehabilitation, 3 days per approved admission for detoxification\\n","radiology":"100% of Scheme Rate - Unlimited","pathology":"100% of Scheme Rate - Unlimited","maternityBenefit":"\\nIn hospital: Unlimited\\nOut-of-Hospital: \\n� 8 Antenatal visits (GP/Gynae/Midwife)\\n� 2 x 2D scans incl. 1 nuchal translucency test. 3D and 4D scans are covered at 2D scans rate\\n� Selected blood tests\\n� 1 Flu vaccination during pregnancy\\n� 5 Pre- or postnatal visits\\nCover for first 2 years after birth\\n� 2 GP, paediatric or ENT visits for baby\\n� 1 post-birth consult with Midwife, GP or Gynae \\n� 1 Dietitian nutritional assessment\\n� 2 Mental health consultations\\n� 1 Lactation consultations\\n\\n ","dialysis":"Full cover for approved treatment plan and use of network provide, otherwise 20% co-payments will apply","cancer":"First R200 000, thereafter, with a 20% co-payment. Medicine from DSP or 20% co-pay\\nOncology Innovation Benefit: cover a defined list of innovative cancer medicines that meet the Scheme�s criteria, subject to a 50% co-payments\\n","transplant":"100% Scheme Rate\\nNo details supplied for cadaver donor costs or live related donor costs","mri":"In Hospital: if not related to admission,   \\nR3 270 co-payment paid from Savings         \\nFor conservative neck and back scans, deductible of R4 050 applies \\n\\nOut-of-Hospital:�R3 270 co-pay applies\\nConservative back and neck scans - limit  \\nof one scan per spinal and neck region\\n","prosthesisInternal":"Cochlear implants and Auditory Brain implants and processors:\\n- R230 400 per beneficiary per benefit \\nInternal Nerve Stimulators \\n- R165 300 per beneficiary \\nShoulder joint prosthesis\\n- Network Provider: Unlimited \\n- Non-Network Provider: R 42 950 \\nMajor joints surgery\\n- Network Provider: Unlimited \\n- Non-Network Provider: 20% co-payment up to max of R 30 900 \\nProsthetic devices used in spinal surgery: \\n- Network Provider: Unlimited \\n- Non-Network Provider: \\n    - First level: R26 250 per beneficiary\\n    - Two or more levels: R52 500 per beneficiary \\n- Up to 80% of Scheme rate","prosthesisExternal":"Subject to day-to-day limits\\nR27 250 per family\\nHearing Aids: R15 200 per family \\n","rehab":"Connected care: quality care at home\\nCare offered: \\n- Postnatal care\\n- IV infusions (drips) \\n- Wound care\\n- Advanced illness care : Unlimited palliative care cover for approved care \\n","designatedServiceProvider":"MedXpress and MedXpress pharmacies","conditionsCovered":"CDL in PMB","formulary":"Yes","partialLimits":"20% co-payment for use of non-DSP Pharmacy","preferredProvider":"None","overallAnualLimit":"ATB limited to:                      \\nPrincipal R16 030\\nAdult R11 440\\nChild R5 610 (max 3)                           ","medicationOverCounter":"100% Cost paid from savings\\n(Does not accumulate to threshold or pay from ATB) ","medicationPrescribed":"Subject to available Savings and ATB Preferred medicine paid at 100%  \\nNon-preferred medicine 75% DHR if the price of the medicine is within 25% of the preferred equivalent, or 50% of DHR if the price of the medicine is more than 50% of the price of the preferred equivalent \\n� M:    R16 200\\n� M+1:  R19 150\\n� M+2:  R22 750\\n� M+3+: R27 650","practitionersGeneral":"Subject to Savings, during self payment gap,\\nExtender Benefit (DEB) covers: \\nUnlimited pharmacy clinic consultations in wellness network, video call consults with network GP. \\nUnlimited consultation with a network GP who meets the digital criteria, when referred\\n","specialistsCover":"For accumulation to threshold and payments from above threshold benefits\\nNetwork specialists: covered in full\\nnon-Network specialists: 100% of Scheme Rate\\nAllied, therapeutic and psychology healthcare services\\n- M: R8 300\\n- M+1: R12 500\\n- M+2: R15 550\\n- M+3+: R18 750","dentistryCover":"\\nPaid from day-to-day limits\\n100% Scheme Rate                            \\n              ","dentistryCoverSpecial":"Paid from day-to-day limits\\nR19 150 per beneficiary \\n- Dental appliances and Orthodontic treatments, including related accounts","optical":"Subject to available Savings and ATB, limited to R5 610 per person including surgery to correct refractive errors\\n(20% discount on frames and lenses at a network optometrist at point of sale) \\n","ambulance":"Preferred provider: Discovery 911","international":"Only for emergencies while travelling abroad; R5 million 90 days travelling\\nAfrica Evacuation Benefit","hospitalCoverAids":"Subject to registration on HIVCare Programme and use of Network Providers","artTtreatment":"Approved meds covered in full. Meds not on list covered up to a set monthly amount. 20% co-pay applies for use of non DSP Network","preventative":"Screening for Adults and Seniors\\nScreening for Kids\\nOther:\\n- Stem Cell Banking: with Netcells\\n- International Second Opinion Services from Cleveland clinic, with a 50% co-payment\\n- Trauma Recovery Extender Benefit \\nChronic Care Programmes:\\n- Diabetes\\n- Mental health\\n- HIV or Heart-related medical conditions\\nConservative Care Programmes: \\n- Dyspepsia (severe heartburn)\\n- Tonsillitis (children under the age of 16) \\nSpinal Care Programme\\n\\nPre-operative Management Programme for Major surgeries\\n\\nConnected Care: Access to care from home\\nConnected Care a digital health care service through Discovery app\\n\\n(refer to brochure for detailed information)","logo":"Discovery.png"},{"company":"Discovery","name":"Classic Priority ","planType":"Limited threshold option","coverLevel":"Mid","hospital":"Any","chronic":"Network","serviceType":"Any","familyIncome":"","mainContribution":"R3031","mainCompSavings":"R1010","mainTotal":"R4041","dependendContributionAdult":"R2390","dependentCompSavingsAdult":"R796","dependentTotalAdult":"R3186","dependendContributionChild":"R1213","dependentCompSavingsChild":"R404","dependentTotalChild":"R1617","maxChildContribution":"3","mainThreshold":"","dependentThresholdAdult":"","dependentThresholdChild":"","preferedHospitalProvider":"Any hospital","overallLimit":"Unlimited","coPayment":"Defined list of Procedure: R5 950 admission to facility outside of Day surgery network \\n� Co-payment when below listed procedures are performed during a hospital admission including procedures in the Day surgery network\\nR4 050 Conservative back and neck treatment, adenoidectomy, myringotomy (grommets) tonsillectomy\\nR9 450 Arthroscopy functional nasal procedures hysterectomy, laparoscopy,  hysteroscopy endometrial ablation\\nR19 450 Reflux surgery, spinal surgery joint replacements\\n\\nScope Admissions co-payments:\\nDay clinic R3 800, In-hospital R6 150 co-payment will reduce to R5 000 if performed by a value-based network doctor\\n\\nIf both a Gastroscopy and Colonoscopy is performed in the same admission, the following co-payment apply\\nDay clinic R4 650, In-hospital R7 700 co-payment will reduce to R6 300 if performed by a value-based network doctor   \\n\\nNo co-payment if done in doctor's room as part of a PMB where indicated and approved for Dyspepsia or children under 12 years ","rate":"200% Scheme Rate ","generalMedicin":"Paid from available day-to-day benefits","specialist":"Full cover for Network specialists\\nNon-network Specialists and GPs: \\n200% of Scheme Rate\\n","dentistSurgical":"Severe dental and oral surgery covers a defined list of procedures with no co-payment or limits  \\n       \\nDental admissions co-payments: \\nMembers 13 years and older,      \\nHospital R7 350, Day clinic R4 700\\nMembers under 13 years,              \\nHospital R2 850, Day clinic R1 300\\nThereafter paid from hospital benefit\\nDental appliances, their placements and orthodontic treatments (incl. related accounts) paid from day-to-day benefit limit of R19 150 per beneficiary\\n\\nBasic Dental Trauma Benefit\\nCover for dental appliances and prostheses and the placement thereof  paid up to an annual limit of R58 000 per person per year\\n","mentalHealth":"In Hospital: 21 days per beneficiary or \\nOut of Hospital: 15 consultations per beneficiary for treatment of (Major affective disorders, Anorexia, Bulimia) and 12 consultations per beneficiary for treatment of acute stress disorder due to recent trauma. Subject to PMB and Psychiatric Network (20% co-payment for non-DSP) \\n \\n21 days per beneficiary for alcohol and drug rehabilitation, 3 days per approved admission for detoxification\\n","radiology":"100% of Scheme Rate - Unlimited","pathology":"100% of Scheme Rate - Unlimited","maternityBenefit":"\\nIn hospital: Unlimited\\nOut-of-Hospital: \\n� 8 Antenatal visits (GP/Gynae/Midwife)\\n� 2 x 2D scans incl. 1 nuchal translucency test. 3D and 4D scans are covered at 2D scans rate\\n� Selected blood tests\\n� 1 Flu vaccination during pregnancy\\n� 5 Pre- or postnatal visits\\nCover for first 2 years after birth\\n� 2 GP, paediatric or ENT visits for baby\\n� 1 post-birth consult with Midwife, GP or Gynae \\n� 1 Dietitian nutritional assessment\\n� 2 Mental health consultations\\n� 1 Lactation consultations\\n\\n ","dialysis":"Full cover for approved treatment plan and use of network provide, otherwise 20% co-payments will apply","cancer":"First R200 000, thereafter, with a 20% co-payment. Medicine from DSP or 20% co-pay\\nOncology Innovation Benefit: cover a defined list of innovative cancer medicines that meet the Scheme�s criteria, subject to a 50% co-payments\\n","transplant":"100% Scheme Rate\\nNo details supplied for cadaver donor costs or live related donor costs","mri":"In Hospital: if not related to admission,   \\nR3 270 co-payment paid from Savings         \\nFor conservative neck and back scans, deductible of R4 050 applies \\n\\nOut-of-Hospital:�R3 270 co-pay applies\\nConservative back and neck scans - limit  \\nof one scan per spinal and neck region\\n","prosthesisInternal":"Cochlear implants and Auditory Brain implants and processors:\\n- R230 400 per beneficiary per benefit \\nInternal Nerve Stimulators \\n- R165 300 per beneficiary \\nShoulder joint prosthesis\\n- Network Provider: Unlimited \\n- Non-Network Provider: R 42 950 \\nMajor joints surgery\\n- Network Provider: Unlimited \\n- Non-Network Provider: 20% co-payment up to max of R 30 900 \\nProsthetic devices used in spinal surgery: \\n- Network Provider: Unlimited \\n- Non-Network Provider: \\n    - First level: R26 250 per beneficiary\\n    - Two or more levels: R52 500 per beneficiary \\n- Up to 80% of Scheme rate","prosthesisExternal":"Subject to day-to-day limits\\nR40 550 per family\\nHearing Aids: R21 350 per family \\n","rehab":"Connected care: quality care at home\\nCare offered: \\n- Postnatal care\\n- IV infusions (drips) \\n- Wound care\\n- Advanced illness care : Unlimited palliative care cover for approved care \\n","designatedServiceProvider":"MedXpress and MedXpress pharmacies","conditionsCovered":"CDL in PMB","formulary":"Yes","partialLimits":"20% co-payment for use of non-DSP Pharmacy","preferredProvider":"None","overallAnualLimit":"ATB limited to:                      \\nPrincipal R16 030\\nAdult R11 440\\nChild R5 610 (max 3)                           ","medicationOverCounter":"100% Cost paid from savings\\n(Does not accumulate to threshold or pay from ATB) ","medicationPrescribed":"Subject to available Savings and ATB Preferred medicine paid at 100%  \\nNon-preferred medicine 75% DHR if the price of the medicine is within 25% of the preferred equivalent, or 50% of DHR if the price of the medicine is more than 50% of the price of the preferred equivalent \\n� M:    R22 850\\n� M+1:  R27 700\\n� M+2:  R33 350\\n� M+3+: R36 400","practitionersGeneral":"\\nSubject to Savings, during self payment gap,\\nExtender Benefit (DEB) covers: \\nUnlimited pharmacy clinic consultations in wellness network, video call consults with network GP. \\nUnlimited consultation with a network GP who meets the digital criteria, when referred\\n- 2 casualty visit for kids under 10 years\\n\\n","specialistsCover":"For accumulation to threshold and payments from above threshold benefits\\nNetwork specialists: covered in full\\nnon-Network specialists: 100% of Scheme Rate\\nAllied, therapeutic and psychology healthcare services\\n- M: R12 500\\n- M+1: R17 700\\n- M+2: R22 900\\n- M+3+: R27 050","dentistryCover":"\\nPaid from day-to-day limits\\n100% Scheme Rate                            \\n              ","dentistryCoverSpecial":"Paid from day-to-day limits\\nR19 150 per beneficiary \\n- Dental appliances and Orthodontic treatments, including related accounts","optical":"Subject to available Savings and ATB, limited to R5 610 per person including surgery to correct refractive errors\\n(20% discount on frames and lenses at a network optometrist at point of sale) \\n","ambulance":"Preferred provider: Discovery 911","international":"Only for emergencies while travelling abroad; R5 million 90 days travelling\\nAfrica Evacuation Benefit","hospitalCoverAids":"Subject to registration on HIVCare Programme and use of Network Providers","artTtreatment":"Approved meds covered in full. Meds not on list covered up to a set monthly amount. 20% co-pay applies for use of non DSP Network","preventative":"Screening for Adults and Seniors\\nScreening for Kids\\nOther:\\n- Stem Cell Banking: with Netcells\\n- International Second Opinion Services from Cleveland clinic, with a 50% co-payment\\n- Trauma Recovery Extender Benefit \\nChronic Care Programmes:\\n- Diabetes\\n- Mental health\\n- HIV or Heart-related medical conditions\\nConservative Care Programmes: \\n- Dyspepsia (severe heartburn)\\n- Tonsillitis (children under the age of 16) \\nSpinal Care Programme\\n\\nPre-operative Management Programme for Major surgeries\\n\\nConnected Care: Access to care from home\\nConnected Care a digital health care service through Discovery app\\n\\n(refer to brochure for detailed information)","logo":"Discovery.png"},{"company":"Discovery","name":"KeyCare Start","planType":"Capitation","coverLevel":"Low","hospital":"Network","chronic":"Network","serviceType":"Network","familyIncome":"0 -R9 150","mainContribution":"R968","mainCompSavings":"R0.00","mainTotal":"R968","dependendContributionAdult":"R968","dependentCompSavingsAdult":"R0.00","dependentTotalAdult":"R968","dependendContributionChild":"R583","dependentCompSavingsChild":"R0.00","dependentTotalChild":"R583","maxChildContribution":"","mainThreshold":"","dependentThresholdAdult":"","dependentThresholdChild":"","preferedHospitalProvider":"KeyCare Network Hospitals","overallLimit":"Unlimited","coPayment":"None","rate":"100% of Scheme Rate ","generalMedicin":"No details provided","specialist":"Full cover for Network specialists\\nGPs: 100% of Scheme Rate ","dentistSurgical":"No benefit","mentalHealth":"In Hospital: 21 days per beneficiary  or \\nOut of Hospital: 15 consultations per beneficiary  for treatment of  (Major affective disorders, Anorexia, Bulimia) and 12 consultations per beneficiary for treatment of acute stress disorder due to recent trauma. Subject to PMB and Psychiatric Network (20% co-payment for non-DSP) \\n \\n21 days per beneficiary for alcohol and drug rehabilitation, 3 days per approved admission for detoxification\\n","radiology":"100% of Scheme Rate ","pathology":"100% of Scheme Rate ","maternityBenefit":"\\nIn Hospital:\\nNatural birth unlimited\\nNetwork of private hospitals\\n� Caesarean section, exclusion unless an emergency\\n\\nBenefits are subject to chosen GP referral\\n� 8 Antenatal visits (GP/Gynae/Midwife)\\n�  2 x 2D scans incl. 1 nuchal translucency test. 3D and 4D scans are covered at 2D scans rate\\n� 1 NIPT test\\n� Selected blood tests\\n� 5 Pre- or postnatal visits \\n(Cover for first 2 years after birth)\\n� 2 GP, paediatric or ENT visits for baby\\n� 1 post-birth consult with Midwife, GP or Gynae \\n�1 Dietitian nutritional assessment\\n� 2 Mental health consultations\\n� 1 lactation consult \\n","dialysis":"Subject to registration, approved treatment plan and use of state facility","cancer":"Limited to PMBs at State facilities\\nUnlimited palliative care cover for approved care at home\\n","transplant":"\\n100% Scheme Rate\\nCovered in KeyCare Start Network hospital\\n","mri":"In Hospital: Related to approved admission (subject to pre-auth) up to 100% of Scheme Rate\\nOut of Hospital: Limited to R2 370 per beneficiary\\n(subject to day-to-day Specialist benefit)\\n\\n","prosthesisInternal":"Subject to PMB and Network Hospitals","prosthesisExternal":"No benefit","rehab":"Connected care: quality care at home\\nCare offered: \\n- Postnatal care\\n- IV infusions (drips) \\n- Wound care\\n- Advanced illness care : Unlimited palliative care cover for approved care \\n","designatedServiceProvider":"State, 20% co-payment applies for use of non-DSP Pharmacy","conditionsCovered":"CDL in PMB ","formulary":"Yes ","partialLimits":"None, nominated network GP can prescribe chronic medicine \\nMembers diagnosed with multiple chronic conditions covered in full subject to registration on Member Care Programme","preferredProvider":"Discovery KeyCare Start  GP","overallAnualLimit":"N/A","medicationOverCounter":"No benefit","medicationPrescribed":"\\nSubject to provider formulary, if prescribed by chosen KeyCare Start GP\\n","practitionersGeneral":"Chosen Network GP: Unlimited \\nSecond GP can be nominated\\nAuthorisation required after 15th visit    \\n2 Out-of-Network GP visit per beneficiary\\nCasualty visits at chosen GP or network provider\\n    ","specialistsCover":"\\n\\n2 Visits up to R2 370 per beneficiary if referred by chosen GP\\n","dentistryCover":"Cover for consultations, fillings and tooth removals at a network provider. Certain rules and limits may apply","dentistryCoverSpecial":"No benefit","optical":"1 eye test, glasses or contact lenses\\nBenefits every two years from at KeyCare optometry Network\\n","ambulance":"Preferred provider: Discovery 911","international":"No benefit","hospitalCoverAids":"Subject to registration on HIVCare Programme and use of Network Providers","artTtreatment":"Unlimited: at DSP \\n20% co-payment applies for use of non-DSP","preventative":"Screening benefits for Adults and Seniors \\nKids Screening - growth assessments,\\nhealth and milestone tracking \\nStem Cell Banking with Netcells\\nInternational Second Opinion Services, members can obtain second opinion from Cleveland Clinic\\n\\nTrauma Recovery Extender Benefit \\n\\nChronic Care Programmes  :\\n- Diabetes\\n- Mental health\\n- HIV or Heart-related medical conditions\\n\\nConservative Care Programmes : \\n- Dyspepsia (severe heartburn)\\n\\nPre-operative Management Programme for Major surgeries\\n\\nConnected Care for Acute Care at Home - access to hospital-level care in your home instead of having to go to hospital for acute hospital care\\n\\nConnected Care a digital health care service through Discovery app\\n\\nTrack Your Health through Discovery app \\n","logo":"Discovery.png"},{"company":"Discovery","name":"KeyCare Start","planType":"Capitation","coverLevel":"Low","hospital":"Network","chronic":"Network","serviceType":"Network","familyIncome":"R9 151 - R13 800","mainContribution":"R1629","mainCompSavings":"R0.00","mainTotal":"R1629","dependendContributionAdult":"R1629","dependentCompSavingsAdult":"R0.00","dependentTotalAdult":"R1629","dependendContributionChild":"R637","dependentCompSavingsChild":"R0.00","dependentTotalChild":"R637","maxChildContribution":"","mainThreshold":"","dependentThresholdAdult":"","dependentThresholdChild":"","preferedHospitalProvider":"KeyCare Network Hospitals","overallLimit":"Unlimited","coPayment":"None","rate":"100% of Scheme Rate ","generalMedicin":"No details provided","specialist":"Full cover for Network specialists\\nGPs: 100% of Scheme Rate ","dentistSurgical":"No benefit","mentalHealth":"In Hospital: 21 days per beneficiary  or \\nOut of Hospital: 15 consultations per beneficiary  for treatment of  (Major affective disorders, Anorexia, Bulimia) and 12 consultations per beneficiary for treatment of acute stress disorder due to recent trauma. Subject to PMB and Psychiatric Network (20% co-payment for non-DSP) \\n \\n21 days per beneficiary for alcohol and drug rehabilitation, 3 days per approved admission for detoxification\\n","radiology":"100% of Scheme Rate ","pathology":"100% of Scheme Rate ","maternityBenefit":"\\nIn Hospital:\\nNatural birth unlimited\\nNetwork of private hospitals\\n� Caesarean section, exclusion unless an emergency\\n\\nBenefits are subject to chosen GP referral\\n� 8 Antenatal visits (GP/Gynae/Midwife)\\n�  2 x 2D scans incl. 1 nuchal translucency test. 3D and 4D scans are covered at 2D scans rate\\n� 1 NIPT test\\n� Selected blood tests\\n� 5 Pre- or postnatal visits \\n(Cover for first 2 years after birth)\\n� 2 GP, paediatric or ENT visits for baby\\n� 1 post-birth consult with Midwife, GP or Gynae \\n�1 Dietitian nutritional assessment\\n� 2 Mental health consultations\\n� 1 lactation consult \\n","dialysis":"Subject to registration, approved treatment plan and use of state facility","cancer":"Limited to PMBs at State facilities\\nUnlimited palliative care cover for approved care at home\\n","transplant":"\\n100% Scheme Rate\\nCovered in KeyCare Start Network hospital\\n","mri":"In Hospital: Related to approved admission (subject to pre-auth) up to 100% of Scheme Rate\\nOut of Hospital: Limited to R2 370 per beneficiary\\n(subject to day-to-day Specialist benefit)\\n\\n","prosthesisInternal":"Subject to PMB and Network Hospitals","prosthesisExternal":"No benefit","rehab":"Connected care: quality care at home\\nCare offered: \\n- Postnatal care\\n- IV infusions (drips) \\n- Wound care\\n- Advanced illness care : Unlimited palliative care cover for approved care \\n","designatedServiceProvider":"State, 20% co-payment applies for use of non-DSP Pharmacy","conditionsCovered":"CDL in PMB ","formulary":"Yes ","partialLimits":"None, nominated network GP can prescribe chronic medicine \\nMembers diagnosed with multiple chronic conditions covered in full subject to registration on Member Care Programme","preferredProvider":"Discovery KeyCare Start  GP","overallAnualLimit":"N/A","medicationOverCounter":"No benefit","medicationPrescribed":"\\nSubject to provider formulary, if prescribed by chosen KeyCare Start GP\\n","practitionersGeneral":"Chosen Network GP: Unlimited \\nSecond GP can be nominated\\nAuthorisation required after 15th visit    \\n2 Out-of-Network GP visit per beneficiary\\nCasualty visits at chosen GP or network provider\\n    ","specialistsCover":"\\n\\n2 Visits up to R2 370 per beneficiary if referred by chosen GP\\n","dentistryCover":"Cover for consultations, fillings and tooth removals at a network provider. Certain rules and limits may apply","dentistryCoverSpecial":"No benefit","optical":"1 eye test, glasses or contact lenses\\nBenefits every two years from at KeyCare optometry Network\\n","ambulance":"Preferred provider: Discovery 911","international":"No benefit","hospitalCoverAids":"Subject to registration on HIVCare Programme and use of Network Providers","artTtreatment":"Unlimited: at DSP \\n20% co-payment applies for use of non-DSP","preventative":"Screening benefits for Adults and Seniors \\nKids Screening - growth assessments,\\nhealth and milestone tracking \\nStem Cell Banking with Netcells\\nInternational Second Opinion Services, members can obtain second opinion from Cleveland Clinic\\n\\nTrauma Recovery Extender Benefit \\n\\nChronic Care Programmes  :\\n- Diabetes\\n- Mental health\\n- HIV or Heart-related medical conditions\\n\\nConservative Care Programmes : \\n- Dyspepsia (severe heartburn)\\n\\nPre-operative Management Programme for Major surgeries\\n\\nConnected Care for Acute Care at Home - access to hospital-level care in your home instead of having to go to hospital for acute hospital care\\n\\nConnected Care a digital health care service through Discovery app\\n\\nTrack Your Health through Discovery app \\n","logo":"Discovery.png"},{"company":"Discovery","name":"KeyCare Start","planType":"Capitation","coverLevel":"Low","hospital":"Network","chronic":"Network","serviceType":"Network","familyIncome":"R13 801+","mainContribution":"R2536","mainCompSavings":"R0.00","mainTotal":"R2536","dependendContributionAdult":"R2536","dependentCompSavingsAdult":"R0.00","dependentTotalAdult":"R2536","dependendContributionChild":"R688","dependentCompSavingsChild":"R0.00","dependentTotalChild":"R688","maxChildContribution":"","mainThreshold":"","dependentThresholdAdult":"","dependentThresholdChild":"","preferedHospitalProvider":"KeyCare Network Hospitals","overallLimit":"Unlimited","coPayment":"None","rate":"100% of Scheme Rate ","generalMedicin":"No details provided","specialist":"Full cover for Network specialists\\nGPs: 100% of Scheme Rate ","dentistSurgical":"No benefit","mentalHealth":"In Hospital: 21 days per beneficiary  or \\nOut of Hospital: 15 consultations per beneficiary  for treatment of  (Major affective disorders, Anorexia, Bulimia) and 12 consultations per beneficiary for treatment of acute stress disorder due to recent trauma. Subject to PMB and Psychiatric Network (20% co-payment for non-DSP) \\n \\n21 days per beneficiary for alcohol and drug rehabilitation, 3 days per approved admission for detoxification\\n","radiology":"100% of Scheme Rate ","pathology":"100% of Scheme Rate ","maternityBenefit":"\\nIn Hospital:\\nNatural birth unlimited\\nNetwork of private hospitals\\n� Caesarean section, exclusion unless an emergency\\n\\nBenefits are subject to chosen GP referral\\n� 8 Antenatal visits (GP/Gynae/Midwife)\\n�  2 x 2D scans incl. 1 nuchal translucency test. 3D and 4D scans are covered at 2D scans rate\\n� 1 NIPT test\\n� Selected blood tests\\n� 5 Pre- or postnatal visits \\n(Cover for first 2 years after birth)\\n� 2 GP, paediatric or ENT visits for baby\\n� 1 post-birth consult with Midwife, GP or Gynae \\n�1 Dietitian nutritional assessment\\n� 2 Mental health consultations\\n� 1 lactation consult \\n","dialysis":"Subject to registration, approved treatment plan and use of state facility","cancer":"Limited to PMBs at State facilities\\nUnlimited palliative care cover for approved care at home\\n","transplant":"\\n100% Scheme Rate\\nCovered in KeyCare Start Network hospital\\n","mri":"In Hospital: Related to approved admission (subject to pre-auth) up to 100% of Scheme Rate\\nOut of Hospital: Limited to R2 370 per beneficiary\\n(subject to day-to-day Specialist benefit)\\n\\n","prosthesisInternal":"Subject to PMB and Network Hospitals","prosthesisExternal":"No benefit","rehab":"Connected care: quality care at home\\nCare offered: \\n- Postnatal care\\n- IV infusions (drips) \\n- Wound care\\n- Advanced illness care : Unlimited palliative care cover for approved care \\n","designatedServiceProvider":"State, 20% co-payment applies for use of non-DSP Pharmacy","conditionsCovered":"CDL in PMB ","formulary":"Yes ","partialLimits":"None, nominated network GP can prescribe chronic medicine \\nMembers diagnosed with multiple chronic conditions covered in full subject to registration on Member Care Programme","preferredProvider":"Discovery KeyCare Start  GP","overallAnualLimit":"N/A","medicationOverCounter":"No benefit","medicationPrescribed":"\\nSubject to provider formulary, if prescribed by chosen KeyCare Start GP\\n","practitionersGeneral":"Chosen Network GP: Unlimited \\nSecond GP can be nominated\\nAuthorisation required after 15th visit    \\n2 Out-of-Network GP visit per beneficiary\\nCasualty visits at chosen GP or network provider\\n    ","specialistsCover":"\\n\\n2 Visits up to R2 370 per beneficiary if referred by chosen GP\\n","dentistryCover":"Cover for consultations, fillings and tooth removals at a network provider. Certain rules and limits may apply","dentistryCoverSpecial":"No benefit","optical":"1 eye test, glasses or contact lenses\\nBenefits every two years from at KeyCare optometry Network\\n","ambulance":"Preferred provider: Discovery 911","international":"No benefit","hospitalCoverAids":"Subject to registration on HIVCare Programme and use of Network Providers","artTtreatment":"Unlimited: at DSP \\n20% co-payment applies for use of non-DSP","preventative":"Screening benefits for Adults and Seniors \\nKids Screening - growth assessments,\\nhealth and milestone tracking \\nStem Cell Banking with Netcells\\nInternational Second Opinion Services, members can obtain second opinion from Cleveland Clinic\\n\\nTrauma Recovery Extender Benefit \\n\\nChronic Care Programmes  :\\n- Diabetes\\n- Mental health\\n- HIV or Heart-related medical conditions\\n\\nConservative Care Programmes : \\n- Dyspepsia (severe heartburn)\\n\\nPre-operative Management Programme for Major surgeries\\n\\nConnected Care for Acute Care at Home - access to hospital-level care in your home instead of having to go to hospital for acute hospital care\\n\\nConnected Care a digital health care service through Discovery app\\n\\nTrack Your Health through Discovery app \\n","logo":"Discovery.png"},{"company":"Discovery","name":"KeyCare Plus","planType":"Capitation","coverLevel":"Low","hospital":"Network","chronic":"Network","serviceType":"Network","familyIncome":"0 - R8 550","mainContribution":"R1279","mainCompSavings":"R0.00","mainTotal":"R1279","dependendContributionAdult":"R1279","dependentCompSavingsAdult":"R0.00","dependentTotalAdult":"R1279","dependendContributionChild":"R464","dependentCompSavingsChild":"R0.00","dependentTotalChild":"R464","maxChildContribution":"","mainThreshold":"","dependentThresholdAdult":"","dependentThresholdChild":"","preferedHospitalProvider":"KeyCare Network Hospitals","overallLimit":"Unlimited","coPayment":"None","rate":"100% of Scheme Rate ","generalMedicin":"No details provided","specialist":"Full cover for Network specialists\\nGPs: 100% of Scheme Rate ","dentistSurgical":"No benefit","mentalHealth":"In Hospital: 21 days per beneficiary  or \\nOut of Hospital: 15 consultations per beneficiary  for treatment of  (Major affective disorders, Anorexia, Bulimia) and 12 consultations per beneficiary for treatment of acute stress disorder due to recent trauma. Subject to PMB and Psychiatric Network (20% co-payment for non-DSP) \\n \\n21 days per beneficiary for alcohol and drug rehabilitation, 3 days per approved admission for detoxification\\n","radiology":"100% of Scheme Rate ","pathology":"100% of Scheme Rate ","maternityBenefit":"\\nIn Hospital:\\nNatural birth unlimited\\nNetwork of private hospitals\\n� Caesarean section, exclusion unless an emergency\\n\\nBenefits are subject to chosen GP referral\\n� 8 Antenatal visits (GP/Gynae/Midwife)\\n�  2 x 2D scans incl. 1 nuchal translucency test. 3D and 4D scans are covered at 2D scans rate\\n� 1 NIPT test\\n� Selected blood tests\\n� 5 Pre- or postnatal visits \\n(Cover for first 2 years after birth)\\n� 2 GP, paediatric or ENT visits for baby\\n� 1 post-birth consult with Midwife, GP or Gynae \\n�1 Dietitian nutritional assessment\\n� 2 Mental health consultations\\n� 1 lactation consult \\n","dialysis":"Full cover for approved treatment plan and use of network provider or state facility. 20% co-payment for use of non-Network facility   ","cancer":"Limited to PMBs at State facilities\\nUnlimited palliative care cover for approved care at home\\n","transplant":"\\n100% Scheme Rate\\nCovered in Network facilities\\nsubject to approval and pre-auth\\n","mri":"In Hospital: Related to approved admission (subject to pre-auth) up to 100% of Scheme Rate\\nOut of Hospital: Limited to R4 730 per beneficiary\\n(subject to day-to-day Specialist benefit)\\n\\n","prosthesisInternal":"Subject to PMB and Network Hospitals","prosthesisExternal":"External Prosthesis: no benefit\\nAppliances: R5 400 per family \\nCrutches, Walkers, Wheelchairs, etc. covered at a network provider","rehab":"Connected care: quality care at home\\nCare offered: \\n- Postnatal care\\n- IV infusions (drips) \\n- Wound care\\n- Advanced illness care : Unlimited palliative care cover for approved care \\n","designatedServiceProvider":"Pharmacy network or chosen GP\\n20% co-payment applies for use of non-DSP Pharmacy","conditionsCovered":"CDL in PMB ","formulary":"Yes ","partialLimits":"None, nominated network GP can prescribe chronic medicine \\nMembers diagnosed with multiple chronic conditions covered in full subject to registration on Member Care Programme","preferredProvider":"Discovery KeyCare GP","overallAnualLimit":"N/A","medicationOverCounter":"No benefit","medicationPrescribed":"Subject to provider formulary, if prescribed by chosen KeyCare GP","practitionersGeneral":"Chosen Network GP: Unlimited \\nSecond GP can be nominated\\nAuthorisation required after 15th visit                                                                                                                                          4 Out-of-Network GP visit per beneficiary\\nCasualty visits, first R425 paid by member, subject to approval before visit \\n    ","specialistsCover":"R4 730 per beneficiary, if referred by chosen GP","dentistryCover":"Cover for consultations, fillings and tooth removals at a network provider. Certain rules and limits may apply","dentistryCoverSpecial":"No benefit","optical":"1 eye test, glasses or contact lenses\\nBenefits every two years from at KeyCare optometry Network\\n","ambulance":"Preferred provider: Discovery 911","international":"No benefit","hospitalCoverAids":"Subject to registration on HIVCare Programme and use of Network Providers","artTtreatment":"Unlimited: at DSP \\n20% co-payment applies for use of non-DSP","preventative":"Screening benefits for Adults and Seniors \\nKids Screening - growth assessments,\\nhealth and milestone tracking \\nStem Cell Banking with Netcells\\nInternational Second Opinion Services, members can obtain second opinion from Cleveland Clinic\\n\\nTrauma Recovery Extender Benefit \\n\\nChronic Care Programmes  :\\n- Diabetes\\n- Mental health\\n- HIV or Heart-related medical conditions\\n\\nConservative Care Programmes : \\n- Dyspepsia (severe heartburn)\\n\\nPre-operative Management Programme for Major surgeries\\n\\nConnected Care for Acute Care at Home - access to hospital-level care in your home instead of having to go to hospital for acute hospital care\\n\\nConnected Care a digital health care service through Discovery app\\n\\nTrack Your Health through Discovery app \\n","logo":"Discovery.png"},{"company":"Discovery","name":"KeyCare Plus","planType":"Capitation","coverLevel":"Low","hospital":"Network","chronic":"Network","serviceType":"Network","familyIncome":"R8 551 - R13 800","mainContribution":"R1758","mainCompSavings":"R0.00","mainTotal":"R1758","dependendContributionAdult":"R1758","dependentCompSavingsAdult":"R0.00","dependentTotalAdult":"R1758","dependendContributionChild":"R495","dependentCompSavingsChild":"R0.00","dependentTotalChild":"R495","maxChildContribution":"","mainThreshold":"","dependentThresholdAdult":"","dependentThresholdChild":"","preferedHospitalProvider":"KeyCare Network Hospitals","overallLimit":"Unlimited","coPayment":"None","rate":"100% of Scheme Rate ","generalMedicin":"No details provided","specialist":"Full cover for Network specialists\\nGPs: 100% of Scheme Rate ","dentistSurgical":"No benefit","mentalHealth":"In Hospital: 21 days per beneficiary  or \\nOut of Hospital: 15 consultations per beneficiary  for treatment of  (Major affective disorders, Anorexia, Bulimia) and 12 consultations per beneficiary for treatment of acute stress disorder due to recent trauma. Subject to PMB and Psychiatric Network (20% co-payment for non-DSP) \\n \\n21 days per beneficiary for alcohol and drug rehabilitation, 3 days per approved admission for detoxification\\n","radiology":"100% of Scheme Rate ","pathology":"100% of Scheme Rate ","maternityBenefit":"\\nIn Hospital:\\nNatural birth unlimited\\nNetwork of private hospitals\\n� Caesarean section, exclusion unless an emergency\\n\\nBenefits are subject to chosen GP referral\\n� 8 Antenatal visits (GP/Gynae/Midwife)\\n�  2 x 2D scans incl. 1 nuchal translucency test. 3D and 4D scans are covered at 2D scans rate\\n� 1 NIPT test\\n� Selected blood tests\\n� 5 Pre- or postnatal visits \\n(Cover for first 2 years after birth)\\n� 2 GP, paediatric or ENT visits for baby\\n� 1 post-birth consult with Midwife, GP or Gynae \\n�1 Dietitian nutritional assessment\\n� 2 Mental health consultations\\n� 1 lactation consult \\n","dialysis":"Full cover for approved treatment plan and use of network provider or state facility. 20% co-payment for use of non-Network facility   ","cancer":"Limited to PMBs at State facilities\\nUnlimited palliative care cover for approved care at home\\n","transplant":"\\n100% Scheme Rate\\nCovered in Network facilities\\nsubject to approval and pre-auth\\n","mri":"In Hospital: Related to approved admission (subject to pre-auth) up to 100% of Scheme Rate\\nOut of Hospital: Limited to R4 730 per beneficiary\\n(subject to day-to-day Specialist benefit)\\n\\n","prosthesisInternal":"Subject to PMB and Network Hospitals","prosthesisExternal":"External Prosthesis: no benefit\\nAppliances: R5 400 per family \\nCrutches, Walkers, Wheelchairs, etc. covered at a network provider","rehab":"Connected care: quality care at home\\nCare offered: \\n- Postnatal care\\n- IV infusions (drips) \\n- Wound care\\n- Advanced illness care : Unlimited palliative care cover for approved care \\n","designatedServiceProvider":"Pharmacy network or chosen GP\\n20% co-payment applies for use of non-DSP Pharmacy","conditionsCovered":"CDL in PMB ","formulary":"Yes ","partialLimits":"None, nominated network GP can prescribe chronic medicine \\nMembers diagnosed with multiple chronic conditions covered in full subject to registration on Member Care Programme","preferredProvider":"Discovery KeyCare GP","overallAnualLimit":"N/A","medicationOverCounter":"No benefit","medicationPrescribed":"Subject to provider formulary, if prescribed by chosen KeyCare GP","practitionersGeneral":"Chosen Network GP: Unlimited \\nSecond GP can be nominated\\nAuthorisation required after 15th visit                                                                                                                                          4 Out-of-Network GP visit per beneficiary\\nCasualty visits, first R425 paid by member, subject to approval before visit \\n    ","specialistsCover":"R4 730 per beneficiary, if referred by chosen GP","dentistryCover":"Cover for consultations, fillings and tooth removals at a network provider. Certain rules and limits may apply","dentistryCoverSpecial":"No benefit","optical":"1 eye test, glasses or contact lenses\\nBenefits every two years from at KeyCare optometry Network\\n","ambulance":"Preferred provider: Discovery 911","international":"No benefit","hospitalCoverAids":"Subject to registration on HIVCare Programme and use of Network Providers","artTtreatment":"Unlimited: at DSP \\n20% co-payment applies for use of non-DSP","preventative":"Screening benefits for Adults and Seniors \\nKids Screening - growth assessments,\\nhealth and milestone tracking \\nStem Cell Banking with Netcells\\nInternational Second Opinion Services, members can obtain second opinion from Cleveland Clinic\\n\\nTrauma Recovery Extender Benefit \\n\\nChronic Care Programmes  :\\n- Diabetes\\n- Mental health\\n- HIV or Heart-related medical conditions\\n\\nConservative Care Programmes : \\n- Dyspepsia (severe heartburn)\\n\\nPre-operative Management Programme for Major surgeries\\n\\nConnected Care for Acute Care at Home - access to hospital-level care in your home instead of having to go to hospital for acute hospital care\\n\\nConnected Care a digital health care service through Discovery app\\n\\nTrack Your Health through Discovery app \\n","logo":"Discovery.png"},{"company":"Discovery","name":"KeyCare Plus","planType":"Capitation","coverLevel":"Low","hospital":"Network","chronic":"Network","serviceType":"Network","familyIncome":"R13 801+","mainContribution":"R2595","mainCompSavings":"R0.00","mainTotal":"R2595","dependendContributionAdult":"R2595","dependentCompSavingsAdult":"R0.00","dependentTotalAdult":"R2595","dependendContributionChild":"R695","dependentCompSavingsChild":"R0.00","dependentTotalChild":"R695","maxChildContribution":"","mainThreshold":"","dependentThresholdAdult":"","dependentThresholdChild":"","preferedHospitalProvider":"KeyCare Network Hospitals","overallLimit":"Unlimited","coPayment":"None","rate":"100% of Scheme Rate ","generalMedicin":"No details provided","specialist":"Full cover for Network specialists\\nGPs: 100% of Scheme Rate ","dentistSurgical":"No benefit","mentalHealth":"In Hospital: 21 days per beneficiary  or \\nOut of Hospital: 15 consultations per beneficiary  for treatment of  (Major affective disorders, Anorexia, Bulimia) and 12 consultations per beneficiary for treatment of acute stress disorder due to recent trauma. Subject to PMB and Psychiatric Network (20% co-payment for non-DSP) \\n \\n21 days per beneficiary for alcohol and drug rehabilitation, 3 days per approved admission for detoxification\\n","radiology":"100% of Scheme Rate ","pathology":"100% of Scheme Rate ","maternityBenefit":"\\nIn Hospital:\\nNatural birth unlimited\\nNetwork of private hospitals\\n� Caesarean section, exclusion unless an emergency\\n\\nBenefits are subject to chosen GP referral\\n� 8 Antenatal visits (GP/Gynae/Midwife)\\n�  2 x 2D scans incl. 1 nuchal translucency test. 3D and 4D scans are covered at 2D scans rate\\n� 1 NIPT test\\n� Selected blood tests\\n� 5 Pre- or postnatal visits \\n(Cover for first 2 years after birth)\\n� 2 GP, paediatric or ENT visits for baby\\n� 1 post-birth consult with Midwife, GP or Gynae \\n�1 Dietitian nutritional assessment\\n� 2 Mental health consultations\\n� 1 lactation consult \\n","dialysis":"Full cover for approved treatment plan and use of network provider or state facility. 20% co-payment for use of non-Network facility   ","cancer":"Limited to PMBs at State facilities\\nUnlimited palliative care cover for approved care at home\\n","transplant":"\\n100% Scheme Rate\\nCovered in Network facilities\\nsubject to approval and pre-auth\\n","mri":"In Hospital: Related to approved admission (subject to pre-auth) up to 100% of Scheme Rate\\nOut of Hospital: Limited to R4 730 per beneficiary\\n(subject to day-to-day Specialist benefit)\\n\\n","prosthesisInternal":"Subject to PMB and Network Hospitals","prosthesisExternal":"External Prosthesis: no benefit\\nAppliances: R5 400 per family \\nCrutches, Walkers, Wheelchairs, etc. covered at a network provider","rehab":"Connected care: quality care at home\\nCare offered: \\n- Postnatal care\\n- IV infusions (drips) \\n- Wound care\\n- Advanced illness care : Unlimited palliative care cover for approved care \\n","designatedServiceProvider":"Pharmacy network or chosen GP\\n20% co-payment applies for use of non-DSP Pharmacy","conditionsCovered":"CDL in PMB ","formulary":"Yes ","partialLimits":"None, nominated network GP can prescribe chronic medicine \\nMembers diagnosed with multiple chronic conditions covered in full subject to registration on Member Care Programme","preferredProvider":"Discovery KeyCare GP","overallAnualLimit":"N/A","medicationOverCounter":"No benefit","medicationPrescribed":"Subject to provider formulary, if prescribed by chosen KeyCare GP","practitionersGeneral":"Chosen Network GP: Unlimited \\nSecond GP can be nominated\\nAuthorisation required after 15th visit                                                                                                                                          4 Out-of-Network GP visit per beneficiary\\nCasualty visits, first R425 paid by member, subject to approval before visit \\n    ","specialistsCover":"R4 730 per beneficiary, if referred by chosen GP","dentistryCover":"Cover for consultations, fillings and tooth removals at a network provider. Certain rules and limits may apply","dentistryCoverSpecial":"No benefit","optical":"1 eye test, glasses or contact lenses\\nBenefits every two years from at KeyCare optometry Network\\n","ambulance":"Preferred provider: Discovery 911","international":"No benefit","hospitalCoverAids":"Subject to registration on HIVCare Programme and use of Network Providers","artTtreatment":"Unlimited: at DSP \\n20% co-payment applies for use of non-DSP","preventative":"Screening benefits for Adults and Seniors \\nKids Screening - growth assessments,\\nhealth and milestone tracking \\nStem Cell Banking with Netcells\\nInternational Second Opinion Services, members can obtain second opinion from Cleveland Clinic\\n\\nTrauma Recovery Extender Benefit \\n\\nChronic Care Programmes  :\\n- Diabetes\\n- Mental health\\n- HIV or Heart-related medical conditions\\n\\nConservative Care Programmes : \\n- Dyspepsia (severe heartburn)\\n\\nPre-operative Management Programme for Major surgeries\\n\\nConnected Care for Acute Care at Home - access to hospital-level care in your home instead of having to go to hospital for acute hospital care\\n\\nConnected Care a digital health care service through Discovery app\\n\\nTrack Your Health through Discovery app \\n","logo":"Discovery.png"},{"company":"Discovery","name":"KeyCare Core","planType":"Hospital Plan","coverLevel":"Low","hospital":"Network","chronic":"Network","serviceType":"N/A","familyIncome":"0 - R8 550","mainContribution":"R0.00","mainCompSavings":"R0.00","mainTotal":"R0.00","dependendContributionAdult":"R0.00","dependentCompSavingsAdult":"R0.00","dependentTotalAdult":"R0.00","dependendContributionChild":"R0.00","dependentCompSavingsChild":"R0.00","dependentTotalChild":"R0.00","maxChildContribution":"","mainThreshold":"","dependentThresholdAdult":"","dependentThresholdChild":"","preferedHospitalProvider":"KeyCare Network Hospitals","overallLimit":"Unlimited","coPayment":"None","rate":"100% of Scheme Rate ","generalMedicin":"No details provided","specialist":"Full cover for Network specialists\\nGPs: 100% of Scheme Rate ","dentistSurgical":"No benefit","mentalHealth":"In Hospital: 21 days per beneficiary  or \\nOut of Hospital: 15 consultations per beneficiary  for treatment of  (Major affective disorders, Anorexia, Bulimia) and 12 consultations per beneficiary for treatment of acute stress disorder due to recent trauma. Subject to PMB and Psychiatric Network (20% co-payment for non-DSP) \\n \\n21 days per beneficiary for alcohol and drug rehabilitation, 3 days per approved admission for detoxification\\n","radiology":"100% of Scheme Rate ","pathology":"100% of Scheme Rate ","maternityBenefit":"\\nIn Hospital:\\nNatural birth unlimited\\nNetwork of private hospitals\\n� Caesarean section, exclusion unless an emergency\\n\\nBenefits are subject to chosen GP referral\\n� 8 Antenatal visits (GP/Gynae/Midwife)\\n�  2 x 2D scans incl. 1 nuchal translucency test. 3D and 4D scans are covered at 2D scans rate\\n� 1 NIPT test\\n� Selected blood tests\\n� 5 Pre- or postnatal visits \\n(Cover for first 2 years after birth)\\n� 2 GP, paediatric or ENT visits for baby\\n� 1 post-birth consult with Midwife, GP or Gynae \\n�1 Dietitian nutritional assessment\\n� 2 Mental health consultations\\n� 1 lactation consult \\n","dialysis":"Full cover for approved treatment plan and use of network provider or state facility. 20% co-payment for use of non-Network facility   ","cancer":"Limited to PMBs at State facilities\\nUnlimited palliative care cover for approved care at home\\n","transplant":"\\n100% Scheme Rate\\nCovered in Network facilities\\nsubject to approval and pre-auth\\n","mri":"In Hospital: Related to approved admission (subject to pre-auth) up to 100% of Scheme Rate\\nOut of Hospital: Limited to R4 730 per beneficiary\\n(subject to day-to-day Specialist benefit)\\n\\n","prosthesisInternal":"Subject to PMB and Network Hospitals","prosthesisExternal":"No benefit","rehab":"Connected care: quality care at home\\nCare offered: \\n- Postnatal care\\n- IV infusions (drips) \\n- Wound care\\n- Advanced illness care : Unlimited palliative care cover for approved care \\n","designatedServiceProvider":"Pharmacy network or chosen GP\\n20% co-payment applies for use of non-DSP Pharmacy","conditionsCovered":"CDL in PMB ","formulary":"Yes ","partialLimits":"None, nominated network GP can prescribe chronic medicine \\nMembers diagnosed with multiple chronic conditions covered in full subject to registration on Member Care Programme","preferredProvider":"None","overallAnualLimit":"N/A","medicationOverCounter":"No benefit","medicationPrescribed":"No benefit","practitionersGeneral":"No benefit","specialistsCover":"R4 730 per beneficiary","dentistryCover":"No benefit","dentistryCoverSpecial":"No benefit","optical":"No benefit","ambulance":"Preferred provider: Discovery 911","international":"No benefit","hospitalCoverAids":"Subject to registration on HIVCare Programme and use of Network Providers","artTtreatment":"Unlimited: at DSP \\n20% co-payment applies for use of non-DSP","preventative":"Screening benefits for Adults and Seniors \\nKids Screening - growth assessments,\\nhealth and milestone tracking \\nStem Cell Banking with Netcells\\nInternational Second Opinion Services, members can obtain second opinion from Cleveland Clinic\\n\\nTrauma Recovery Extender Benefit \\n\\nChronic Care Programmes  :\\n- Diabetes\\n- Mental health\\n- HIV or Heart-related medical conditions\\n\\nConservative Care Programmes : \\n- Dyspepsia (severe heartburn)\\n\\nPre-operative Management Programme for Major surgeries\\n\\nConnected Care for Acute Care at Home - access to hospital-level care in your home instead of having to go to hospital for acute hospital care\\n\\nConnected Care a digital health care service through Discovery app\\n\\nTrack Your Health through Discovery app \\n","logo":"Discovery.png"},{"company":"Discovery","name":"KeyCare Core","planType":"Hospital Plan","coverLevel":"Low","hospital":"Network","chronic":"Network","serviceType":"N/A","familyIncome":"R8 551 - R13 800","mainContribution":"R0.00","mainCompSavings":"R0.00","mainTotal":"R0.00","dependendContributionAdult":"R0.00","dependentCompSavingsAdult":"R0.00","dependentTotalAdult":"R0.00","dependendContributionChild":"R0.00","dependentCompSavingsChild":"R0.00","dependentTotalChild":"R0.00","maxChildContribution":"","mainThreshold":"","dependentThresholdAdult":"","dependentThresholdChild":"","preferedHospitalProvider":"KeyCare Network Hospitals","overallLimit":"Unlimited","coPayment":"None","rate":"100% of Scheme Rate ","generalMedicin":"No details provided","specialist":"Full cover for Network specialists\\nGPs: 100% of Scheme Rate ","dentistSurgical":"No benefit","mentalHealth":"In Hospital: 21 days per beneficiary  or \\nOut of Hospital: 15 consultations per beneficiary  for treatment of  (Major affective disorders, Anorexia, Bulimia) and 12 consultations per beneficiary for treatment of acute stress disorder due to recent trauma. Subject to PMB and Psychiatric Network (20% co-payment for non-DSP) \\n \\n21 days per beneficiary for alcohol and drug rehabilitation, 3 days per approved admission for detoxification\\n","radiology":"100% of Scheme Rate ","pathology":"100% of Scheme Rate ","maternityBenefit":"\\nIn Hospital:\\nNatural birth unlimited\\nNetwork of private hospitals\\n� Caesarean section, exclusion unless an emergency\\n\\nBenefits are subject to chosen GP referral\\n� 8 Antenatal visits (GP/Gynae/Midwife)\\n�  2 x 2D scans incl. 1 nuchal translucency test. 3D and 4D scans are covered at 2D scans rate\\n� 1 NIPT test\\n� Selected blood tests\\n� 5 Pre- or postnatal visits \\n(Cover for first 2 years after birth)\\n� 2 GP, paediatric or ENT visits for baby\\n� 1 post-birth consult with Midwife, GP or Gynae \\n�1 Dietitian nutritional assessment\\n� 2 Mental health consultations\\n� 1 lactation consult \\n","dialysis":"Full cover for approved treatment plan and use of network provider or state facility. 20% co-payment for use of non-Network facility   ","cancer":"Limited to PMBs at State facilities\\nUnlimited palliative care cover for approved care at home\\n","transplant":"\\n100% Scheme Rate\\nCovered in Network facilities\\nsubject to approval and pre-auth\\n","mri":"In Hospital: Related to approved admission (subject to pre-auth) up to 100% of Scheme Rate\\nOut of Hospital: Limited to R4 730 per beneficiary\\n(subject to day-to-day Specialist benefit)\\n\\n","prosthesisInternal":"Subject to PMB and Network Hospitals","prosthesisExternal":"No benefit","rehab":"Connected care: quality care at home\\nCare offered: \\n- Postnatal care\\n- IV infusions (drips) \\n- Wound care\\n- Advanced illness care : Unlimited palliative care cover for approved care \\n","designatedServiceProvider":"Pharmacy network or chosen GP\\n20% co-payment applies for use of non-DSP Pharmacy","conditionsCovered":"CDL in PMB ","formulary":"Yes ","partialLimits":"None, nominated network GP can prescribe chronic medicine \\nMembers diagnosed with multiple chronic conditions covered in full subject to registration on Member Care Programme","preferredProvider":"None","overallAnualLimit":"N/A","medicationOverCounter":"No benefit","medicationPrescribed":"No benefit","practitionersGeneral":"No benefit","specialistsCover":"R4 730 per beneficiary","dentistryCover":"No benefit","dentistryCoverSpecial":"No benefit","optical":"No benefit","ambulance":"Preferred provider: Discovery 911","international":"No benefit","hospitalCoverAids":"Subject to registration on HIVCare Programme and use of Network Providers","artTtreatment":"Unlimited: at DSP \\n20% co-payment applies for use of non-DSP","preventative":"Screening benefits for Adults and Seniors \\nKids Screening - growth assessments,\\nhealth and milestone tracking \\nStem Cell Banking with Netcells\\nInternational Second Opinion Services, members can obtain second opinion from Cleveland Clinic\\n\\nTrauma Recovery Extender Benefit \\n\\nChronic Care Programmes  :\\n- Diabetes\\n- Mental health\\n- HIV or Heart-related medical conditions\\n\\nConservative Care Programmes : \\n- Dyspepsia (severe heartburn)\\n\\nPre-operative Management Programme for Major surgeries\\n\\nConnected Care for Acute Care at Home - access to hospital-level care in your home instead of having to go to hospital for acute hospital care\\n\\nConnected Care a digital health care service through Discovery app\\n\\nTrack Your Health through Discovery app \\n","logo":"Discovery.png"},{"company":"Discovery","name":"KeyCare Core","planType":"Hospital Plan","coverLevel":"Low","hospital":"Network","chronic":"Network","serviceType":"N/A","familyIncome":"R13 801+","mainContribution":"R0.00","mainCompSavings":"R0.00","mainTotal":"R0.00","dependendContributionAdult":"R0.00","dependentCompSavingsAdult":"R0.00","dependentTotalAdult":"R0.00","dependendContributionChild":"R0.00","dependentCompSavingsChild":"R0.00","dependentTotalChild":"R0.00","maxChildContribution":"","mainThreshold":"","dependentThresholdAdult":"","dependentThresholdChild":"","preferedHospitalProvider":"KeyCare Network Hospitals","overallLimit":"Unlimited","coPayment":"None","rate":"100% of Scheme Rate ","generalMedicin":"No details provided","specialist":"Full cover for Network specialists\\nGPs: 100% of Scheme Rate ","dentistSurgical":"No benefit","mentalHealth":"In Hospital: 21 days per beneficiary  or \\nOut of Hospital: 15 consultations per beneficiary  for treatment of  (Major affective disorders, Anorexia, Bulimia) and 12 consultations per beneficiary for treatment of acute stress disorder due to recent trauma. Subject to PMB and Psychiatric Network (20% co-payment for non-DSP) \\n \\n21 days per beneficiary for alcohol and drug rehabilitation, 3 days per approved admission for detoxification\\n","radiology":"100% of Scheme Rate ","pathology":"100% of Scheme Rate ","maternityBenefit":"\\nIn Hospital:\\nNatural birth unlimited\\nNetwork of private hospitals\\n� Caesarean section, exclusion unless an emergency\\n\\nBenefits are subject to chosen GP referral\\n� 8 Antenatal visits (GP/Gynae/Midwife)\\n�  2 x 2D scans incl. 1 nuchal translucency test. 3D and 4D scans are covered at 2D scans rate\\n� 1 NIPT test\\n� Selected blood tests\\n� 5 Pre- or postnatal visits \\n(Cover for first 2 years after birth)\\n� 2 GP, paediatric or ENT visits for baby\\n� 1 post-birth consult with Midwife, GP or Gynae \\n�1 Dietitian nutritional assessment\\n� 2 Mental health consultations\\n� 1 lactation consult \\n","dialysis":"Full cover for approved treatment plan and use of network provider or state facility. 20% co-payment for use of non-Network facility   ","cancer":"Limited to PMBs at State facilities\\nUnlimited palliative care cover for approved care at home\\n","transplant":"\\n100% Scheme Rate\\nCovered in Network facilities\\nsubject to approval and pre-auth\\n","mri":"In Hospital: Related to approved admission (subject to pre-auth) up to 100% of Scheme Rate\\nOut of Hospital: Limited to R4 730 per beneficiary\\n(subject to day-to-day Specialist benefit)\\n\\n","prosthesisInternal":"Subject to PMB and Network Hospitals","prosthesisExternal":"No benefit","rehab":"Connected care: quality care at home\\nCare offered: \\n- Postnatal care\\n- IV infusions (drips) \\n- Wound care\\n- Advanced illness care : Unlimited palliative care cover for approved care \\n","designatedServiceProvider":"Pharmacy network or chosen GP\\n20% co-payment applies for use of non-DSP Pharmacy","conditionsCovered":"CDL in PMB ","formulary":"Yes ","partialLimits":"None, nominated network GP can prescribe chronic medicine \\nMembers diagnosed with multiple chronic conditions covered in full subject to registration on Member Care Programme","preferredProvider":"None","overallAnualLimit":"N/A","medicationOverCounter":"No benefit","medicationPrescribed":"No benefit","practitionersGeneral":"No benefit","specialistsCover":"R4 730 per beneficiary","dentistryCover":"No benefit","dentistryCoverSpecial":"No benefit","optical":"No benefit","ambulance":"Preferred provider: Discovery 911","international":"No benefit","hospitalCoverAids":"Subject to registration on HIVCare Programme and use of Network Providers","artTtreatment":"Unlimited: at DSP \\n20% co-payment applies for use of non-DSP","preventative":"Screening benefits for Adults and Seniors \\nKids Screening - growth assessments,\\nhealth and milestone tracking \\nStem Cell Banking with Netcells\\nInternational Second Opinion Services, members can obtain second opinion from Cleveland Clinic\\n\\nTrauma Recovery Extender Benefit \\n\\nChronic Care Programmes  :\\n- Diabetes\\n- Mental health\\n- HIV or Heart-related medical conditions\\n\\nConservative Care Programmes : \\n- Dyspepsia (severe heartburn)\\n\\nPre-operative Management Programme for Major surgeries\\n\\nConnected Care for Acute Care at Home - access to hospital-level care in your home instead of having to go to hospital for acute hospital care\\n\\nConnected Care a digital health care service through Discovery app\\n\\nTrack Your Health through Discovery app \\n","logo":"Discovery.png"},{"company":"Fedhealth","name":"MaxiFed maxima EXEC","planType":"Threshold option","coverLevel":"High","hospital":"Any","chronic":"Network","serviceType":"Network","familyIncome":"","mainContribution":"R5936","mainCompSavings":"R880","mainTotal":"R6816","dependendContributionAdult":"R5153","dependentCompSavingsAdult":"R764","dependentTotalAdult":"R5917","dependendContributionChild":"R1889","dependentCompSavingsChild":"R279","dependentTotalChild":"R2168","maxChildContribution":"3","mainThreshold":"R14800\\n10% co-payment applies to all claims paid from the Threshold Benefit","dependentThresholdAdult":"R11400\\n10% co-payment applies to all claims paid from the Threshold Benefit","dependentThresholdChild":"R3800\\n10% co-payment applies to all claims paid from the Threshold Benefit","preferedHospitalProvider":"Any hospital","overallLimit":"None","coPayment":"Surgical extraction of impacted wisdom teeth: R4 800\\n\\nArthroscopic procedures (hip, wrist, knee, shoulder, ankle, other arthroscopic procedures), colonoscopy, upper GI endoscopy: R2 800\\n\\nOther joint replacements,\\nlaparoscopic hernia repairs, laparoscopic\\nprocedures, rhizotomies and facet\\npain blocks, surgical extraction of\\nimpacted wisdom teeth: R4 800\\n\\nSpinal surgery (No benefit unless conservative back and neck rehabilitation programme has been completed): R6 300\\n\\nSingle hip and knee replacements - voluntary use of non-Contracted Provider: R29 600\\n\\nOther joint replacements and\\ninvoluntary use of non-CP* for\\nsingle hip and knee replacements: R4 800","rate":"Unlimited at negotiated tariff","generalMedicin":"7 days' supply","specialist":"Network GP's /Specialists: covered in full\\nNon-network GP: Paid up to Scheme Rate\\nNon-network specialist: 200% of Scheme Rate\\nOther healthcare professionals: Paid up to Scheme Rate","dentistSurgical":"Maxillo facial surgery \\nUnlimited, subject to approval\\n\\nIn-hospital dentistry for children under 7:\\nThe hospital and anaesthetist account to be paid from the in-hospital benefit while the dentist�s account to be paid from the day-to-day benefit\\n","mentalHealth":"Psychiatric services: R35 800 per family","radiology":"Unlimited at Scheme Rate","pathology":"Unlimited at Scheme Rate","maternityBenefit":"In-hospital: Private ward cover\\n\\nDoula benefit: R3 000 per delivery \\n\\nOut-of-hospital:\\nPaid from risk thereafter paid from savings and Threshold\\n12 Ante-or postnatal consultations with a midwife, network gynaecologist or GP\\nAntenatal classes: R1 160 with a midwife \\n4 Postnatal midwife consultations\\n1 amniocentesis test\\n1 Paediatric consultation; without GP referral up to 24 months \\nInfant hearing screening benefit\\n2 x 2D scans per pregnancy\\nPaed-IQ telephonic advice line\\nFedhealth Baby Programme\\n- Childhood illness specialised drug benefit for children up to 18","dialysis":"R624 000 per family\\n40% co-payment for use of non-DSP ","cancer":"R624 000 per family at preferred providers\\nCore protocol at ICON and tier 2 standard level of care at SAOC\\n40% co-payment if network is not used \\nSpecialised medication: R194 600\\n- Palliative care benefit","transplant":"R624 000 per family \\nIncluding immunosuppression medication\\nCorneal graft: R36 300 per beneficiary","mri":"In and Out of Hospital\\nUnlimited at Scheme Rate\\nFirst R2 480 for non-PMB MRI/CT scans\\nfor the member�s account","prosthesisInternal":"100% of cost\\n(Limit per family per year)\\nAorta stent grafts: R65 500\\nCardiac pacemakers: R54 500\\nCardiac stents: R56 100\\nCardiac valves: R49 800\\nDetachable platinum coils: R56 700\\nElbow, hip, knee and shoulder replacement: R38 900\\nIntraocular lenses (per lens): R3 500\\nCombined limit for all unlisted internal prosthesis: R32 700\\n","prosthesisExternal":"External prosthesis: R19 300 at cost\\nAppliances, external accessories and orthotics: In and out-of-hospital: subject to Savings \\nDoes not accumulate to Threshold.\\nPaid from Threshold up to R17 300 per family \\nSub-limit of R4 860 per beneficiary for foot orthotics    ","rehab":"Alternatives to hospitalisation: unlimited - at negotiated tariff\\nTerminal Care: R34 500 ","designatedServiceProvider":"\\nDis-Chem, Medi-Rite, Clicks or Pharmacy Direct","conditionsCovered":"57 conditions including PMBs","formulary":"Comprehensive formulary","partialLimits":"Unlimited for CDL conditions\\nnon-CDL conditions limited to:\\nR7 890 per beneficiary\\nR14 500 per family per year","preferredProvider":"Fedhealth contracted providers","overallAnualLimit":"None","medicationOverCounter":"Up to 100% of MPL \\nPaid from Savings, does not accumulate to or pay from Threshold","medicationPrescribed":"Paid from day-to-day benefits\\nR7 940 per beneficiary , R14 700 per family per year, before and after Threshold","practitionersGeneral":"Network GPs: Paid from Savings then unlimited from risk\\nNon-Network GPs: Paid from day-to-day benefits at scheme rate. Does not accumulate to Threshold               \\n                    ","specialistsCover":"Specialists excluding psychiatrists\\nNetwork specialists: Paid from Savings and accumulation at cost to Threshold. Unlimited at cost once Threshold is reached. 10% co-payment if GP referral is not obtained.                                 \\n\\nNon-Network: Paid from Savings and Threshold. Does not accumulate to Threshold. 10% co-payment if GP referral is not obtained.\\n\\nPsychiatrists\\nNetwork psychiatrists: Paid from Savings. Does not accumulate to Threshold. Paid\\nat cost from Threshold up to the Additional Medical Services limit of R19 400 per family per year. 10% co-payment if GP referral is\\nnot obtained.\\n\\nNon-Network: Paid from Savings. Does not\\naccumulate to threshold. Paid from Threshold up to the Additional Medical Services limit of R19 400 per family per year. 10% co-payment if GP referral is not obtained","dentistryCover":"Paid from Savings and Threshold\\nUnlimited once Threshold is reached","dentistryCoverSpecial":"Paid from Savings and Threshold\\nR8 270 per beneficiary, max of R24 700 per family per year before and after Threshold     ","optical":"Paid from Savings and Threshold.\\nR3 740 per beneficiary, R11 400 per family per year before and after Threshold ","ambulance":"Unlimited with Europ Assistance","international":"International Travel benefit  through AMP\\nR5 million cover","hospitalCoverAids":"\\nUnlimited\\n","artTtreatment":"Preferred providers or a 20% co-payment apply at non-DSP","preventative":"\\nScreening benefit\\nPap smear\\nProstate Specific Antigen (PSA)\\nChildrens Health (Immunisation programme, HPV vaccine girls 9-14 years )\\nCholesterol screening\\nOver 45's (Breast cancer screening with\\nmammography, Colorectal cancer screening, Pneumococcal vaccination)\\nGeneral (Flu vaccination; HIV test)\\nHealth risk assessments\\nPreventative screening (waist-to-hip ratio, body fat %, flexibility, posture & fitness)\\n\\nFemale contraceptives\\n30 days post hospitalisation benefit\\n\\nAdditional services\\nUpgrade within 30 days of a life-changing event\\nHospital at home with Quro Medical\\nCorporate wellness days\\nSisters-on-Site\\nWeight Management Programme\\nGoSmokeFree Smoking Cessation Programme\\nAfA (HIV Management)\\nPaed IQ\\nDiabetes Care\\nSOS Call Me\\n24-hour Nurse Line\\nMeditaxi\\n\\n\\n","logo":"fedhealth.jpg"},{"company":"Fedhealth","name":"MaxiFed maxima PLUS","planType":"Hybrid option","coverLevel":"High","hospital":"Any","chronic":"Network","serviceType":"Network","familyIncome":"","mainContribution":"R10229","mainCompSavings":"R543","mainTotal":"R10772","dependendContributionAdult":"R8830","dependentCompSavingsAdult":"R468","dependentTotalAdult":"R9298","dependendContributionChild":"R3254","dependentCompSavingsChild":"R172","dependentTotalChild":"R3426","maxChildContribution":"3","mainThreshold":"R17,100","dependentThresholdAdult":"R13,200","dependentThresholdChild":"R4,600","preferedHospitalProvider":"Any hospital","overallLimit":"None","coPayment":"Single hip and knee replacements - voluntary use of non-contracted provider: R28 400","rate":"Unlimited at negotiated tariff","generalMedicin":"7 days' supply","specialist":"Network GP's /Specialists: covered in full\\nNon-network GP: Paid up to Scheme Rate\\nNon-network specialist: 200% of Scheme Rate\\nOther healthcare professionals: 300% of Scheme Rate","dentistSurgical":"Maxillo facial surgery - Unlimited, subject to approval\\n\\nIn-hospital dentistry for children under 7:\\nThe hospital and anaesthetist account to be paid from the in-hospital benefit while the dentist�s account to be paid from the day-to-day benefit","mentalHealth":"Psychiatric services: R45 100 per family","radiology":"Unlimited at Scheme Rate","pathology":"Unlimited at Scheme Rate","maternityBenefit":"In-hospital: Private ward cover\\n\\nDoula benefit: R3 000 per delivery \\n \\nOut-of-hospital:\\nPaid from risk thereafter paid from OHEB, savings and Threshold\\n12 Ante-or prenatal consultations with a midwife, network gynaecologist or GP\\nAntenatal classes: R1 160 with a midwife\\n4 Postnatal midwife consultations \\n1 amniocentesis test\\n1 Paediatric consultation; without GP referral up to 24 months\\nInfant hearing screening benefit\\n2 x 2D scans per pregnancy\\nPaed-IQ telephonic advice line\\nFedhealth Baby Programme\\n- Childhood illness specialised drug benefit for children up to 18","dialysis":"Unlimited up to Scheme Rate\\n40% co-payment for use of non-DSP ","cancer":"Unlimited at preferred providers\\nEnhanced protocol at ICON and tier 3 level of care at SAOC\\nSpecialised medication: R390 400 at cost\\n- Palliative care benefit","transplant":"Unlimited\\nIncluding immunosuppression medication  \\nCorneal graft: R36 300 per beneficiary         ","mri":"In and Out of Hospital\\nUnlimited at Scheme Rate","prosthesisInternal":"100% of cost\\n(Limit per family per year)\\nCardiac pacemakers: R65 500\\nElbow, hip, knee and shoulder replacement: R49 800\\nCombined limit for all unlisted internal prosthesis: R40 400\\n","prosthesisExternal":"External prosthesis: R24 300 at cost\\nAppliances, external accessories and orthotics: Unlimited at cost\\nOut of hospital: Paid from Savings, OHEB and Threshold limited to R17 300 per family \\nSub-limit of R4 680 per person for foot orthotics ","rehab":"Alternatives to hospitalisation: unlimited - at negotiated tariff\\nTerminal Care: R34 500","designatedServiceProvider":"\\nDis-Chem, Medi-Rite, Clicks or Pharmacy Direct","conditionsCovered":"70 conditions including PMBs","formulary":"Comprehensive formulary","partialLimits":"Unlimited for CDL conditions\\nnon-CDL conditions limited to:\\nR16 700 per beneficiary\\nR31 300 per family per year ","preferredProvider":"Fedhealth contracted providers","overallAnualLimit":"Annual OHEB\\nMember    R9 794\\nAdult         R7 067\\nChild         R2 171  ","medicationOverCounter":"Up to 100% of MPL \\nPaid from Savings, does not accumulate to or pay from Threshold","medicationPrescribed":"Paid from day-to-day benefits\\nR11 060 per beneficiary, R22 010 per family per year, before and after Threshold","practitionersGeneral":"Network GPs: Paid from OHEB then unlimited from risk\\nNon-Network GPs: Paid from day-to-day benefits at scheme rate.\\nUnlimited accumulation to and refund from Threshold","specialistsCover":"Specialists excluding psychiatrists\\nNetwork specialists: Paid from Savings, OHEB and accumulation at cost to Threshold. Unlimited at cost once Threshold is reached. 10% co-payment if GP referral is not obtained.\\n\\nNon-Network: Paid from Savings, OHEB and Threshold. Does not accumulate to Threshold. 10% co-payment if GP referral is not obtained.\\n\\nPsychiatrists\\nNetwork psychiatrists: Paid from Savings, OHEB and accumulation to and refund from Threshold at cost. 10% co-payment if GP referral is not obtained. Subject to Additional Medical Services limit of R19 400 per family\\nper year before and after Threshold.\\n\\nNon-Network: Paid from Savings, OHEB and\\naccumulation to and refund from Threshold.\\n10% co-payment if GP referral is not obtained. Subject to Additional Medical Services limit of R19 400 per family per year before and after Threshold","dentistryCover":"Paid from OHEB, Savings and Threshold Unlimited once Threshold is reached","dentistryCoverSpecial":"Paid from OHEB, Savings and Threshold\\nR8 270 per beneficiary, max of R24 700 per family per year before and after Threshold         ","optical":"Paid from Savings, OHEB and Threshold.\\nR3 740 per beneficiary, R11 400 per family per year before and after Threshold ","ambulance":"Unlimited with Europ Assistance","international":"International Travel benefit  through AMP\\nR5 million cover","hospitalCoverAids":"\\nUnlimited\\n","artTtreatment":"Pharmacy Direct or a 20% co-payment apply at non-DSP","preventative":"\\nScreening benefit\\nPap smear\\nProstate Specific Antigen (PSA)\\nChildrens Health (Immunisation programme, HPV vaccine girls 9-14 years )\\nCholesterol screening\\nOver 45's (Breast cancer screening with\\nmammography, Colorectal cancer screening, Pneumococcal vaccination)\\nGeneral (Flu vaccination; HIV test)\\nHealth risk assessments\\nPreventative screening (waist-to-hip ratio, body fat %, flexibility, posture & fitness)\\n\\nFemale contraceptives\\n30 days post hospitalisation benefit\\n\\nAdditional services\\nUpgrade within 30 days of a life-changing event\\nHospital at home with Quro Medical\\nCorporate wellness days\\nSisters-on-Site\\nWeight Management Programme\\nGoSmokeFree Smoking Cessation Programme\\nAfA (HIV Management)\\nPaed IQ\\nDiabetes Care\\nSOS Call Me\\n24-hour Nurse Line\\nMeditaxi\\n\\n\\n","logo":"fedhealth.jpg"},{"company":"Fedhealth","name":"FlexiFED 1","planType":"New generation","coverLevel":"Mid","hospital":"Network","chronic":"Network","serviceType":"Network","familyIncome":"","mainContribution":"R1763","mainCompSavings":"R25","mainTotal":"R1788","dependendContributionAdult":"R1382","dependentCompSavingsAdult":"R19","dependentTotalAdult":"R1401","dependendContributionChild":"R645","dependentCompSavingsChild":"R8","dependentTotalChild":"R653","maxChildContribution":"3","mainThreshold":"","dependentThresholdAdult":"","dependentThresholdChild":"","preferedHospitalProvider":"Network (Fedhealth Network Hospitals)","overallLimit":"Unlimited at network\\nhospitals only","coPayment":"Voluntary use of non-network hospitals: R7 300\\nVoluntary use of  non-network day surgery facility: R2 100\\n\\nSurgical extraction of impacted wisdom teeth: R4 800\\n\\nAdenoidectomy, bunion procedures,\\ndiagnostic cystoscopy, gastritis/ dyspepsia/heartburn, nasal procedures, skin biopsy/ excision, All open hernia surgery, Inguinal hernia\\nsugary, Back and neck procedures, Colonoscopy, upper GI endoscopy: R7 100\\n\\nArthroscopic procedures - knee,\\nshoulder, ankle and other: R8 900\\n\\nHysterectomy (unless for cancer): R4 200\\n\\nLaparoscopic hernia repairs\\n(bilateral inguinal, repeated inguinal\\nhernias and Nissen/ Toupet\\nhernia repairs only), laparoscopic\\nprocedures, Laparoscopic varicocelectomy, Varicose vein procedures: R7 100\\n\\nTonsillectomy (12 and over): R7 100","rate":"Negotiated tariff ","generalMedicin":"7 days' supply","specialist":"Network: Unlimited. Paid in full.\\nNon-network: 100% of Scheme Rate\\nOther Healthcare Professionals: 100% Scheme Rate","dentistSurgical":"Maxillo facial surgery: Unlimited, subject to approval\\n","mentalHealth":"Psychiatric services: Unlimited at cost at PMB level of care\\nPMB conditions:\\n21 days in-hospital OR\\n15 psychotherapy sessions out-of-hospital","radiology":"Unlimited at Scheme Rate","pathology":"Unlimited at Scheme Rate","maternityBenefit":"In-hospital:\\nNetwork: Unlimited. Paid in full.\\nNon-network: 100% of Scheme Rate\\nOther Healthcare Professionals: 100% Scheme Rate\\n\\nDoula benefit: R3 000 per delivery \\n\\nOut-of-hospital:\\nPaid Savings\\\\Wallet or self funded\\nAntenatal classes: R1 120 with a midwife \\n4 Postnatal midwife consultations\\n1 amniocentesis test\\nInfant hearing screening benefit\\n2 x 2D scans per pregnancy\\nPaed-IQ telephonic advice line\\nmyFed Baby Programme","dialysis":"Unlimited at cost at PMB level of care at DSP\\n40% co-payment for use of non-DSP ","cancer":"Unlimited at cost at PMB level of care at  preferred providers \\nEssential protocol at ICON and tier 1 primary level of care at SAOC\\n40% co-payment for non-DSP\\n- Palliative care benefit","transplant":"PMB level of care\\nCorneal graft: No benefit","mri":"In and Out of Hospital: Unlimited at Scheme Rate\\nFirst R3 440 for non-PMB MRI/CT scans for the member�s account","prosthesisInternal":"Unlimited at cost at PMB level of care\\nTotal ankle replacement: No benefit","prosthesisExternal":"External prosthesis:\\nUnlimited at cost at PMB level of care\\nAppliances, external accessories and orthotics (In and out of hospital):\\nPaid from Savings / Wallet or self-funded","rehab":"Nursing services: Unlimited at negotiated tariff\\nSub-acute facilities: Unlimited at cost up to PMB level of care \\nTerminal care: R34 500 ","designatedServiceProvider":"Clicks, Dis-Chem, MediRite, Pharmacy Direct, Clicks Direct Medicines\\nand Dis-Chem Direct","conditionsCovered":"CDL in PMB ","formulary":"Basic formulary","partialLimits":"None","preferredProvider":"Fedhealth contracted providers","overallAnualLimit":"None","medicationOverCounter":"Paid from Savings\\\\Wallet or self funded\\nAccumulates at cost to Threshold level","medicationPrescribed":"Paid from Savings\\\\Wallet or self funded\\nAccumulates at cost to Threshold level","practitionersGeneral":"Network:\\nPaid from Savings/Wallet, then unlimited at nominated network GP once Threshold has been reached.\\nBeneficiaries can nominate up to two network GPs.\\n2 x mental health consultations per beneficiary per year.\\n2 x network GP consultations per beneficiary for non-nominated GPs allowed per year (referred to as out-of-area) OR\\n2 x non-network GP consultations per beneficiary up to Scheme Rate\\n\\nNon-network:\\nPaid from Savings/Wallet or self-funded. Accumulates at cost to Threshold level","specialistsCover":"Paid from Savings/Wallet or self funded, subject to GP referral","dentistryCover":"Paid from Savings/Wallet or self-funded\\nFollowing benefits will be paid from Threshold once your threshold level has been reached:\\n2 x annual consultations per beneficiary incl. x-rays, scaling and polishing \\nSubject to contracted dentists and limited to a list of approved procedures, dental tariff codes and protocols","dentistryCoverSpecial":"Paid from Savings/Wallet or self-funded\\nAccumulates at cost to Threshold level","optical":"Paid from Savings/Wallet or self-funded","ambulance":"Unlimited with Europ Assistance","international":"International Travel benefit  through AMP\\nR5 million cover","hospitalCoverAids":"Unlimited\\nHIV Management (Aid for AIDS)","artTtreatment":"Pharmacy Direct, or a 40% co-payment ","preventative":"\\nScreening benefit\\nPap smear\\nProstate Specific Antigen (PSA)\\nChildrens Health (Immunisation programme)\\nCholesterol screening\\nOver 45's (Breast cancer screening with\\nmammography, Colorectal cancer screening, Pneumococcal vaccination)\\nGeneral (Flu vaccination; HIV test)\\nHealth risk assessments\\nPreventative screening (waist-to-hip ratio, body fat %, flexibility, posture & fitness)\\n\\nFemale contraceptives\\n30 days post hospitalisation benefit\\n\\n\\nAdditional services\\nUpgrades within 30 days of a life-changing event\\nHospital at home with Quro Medical\\nCorporate wellness days\\nSisters-on-Site\\nWeight Management Programme\\nGoSmokeFree Smoking Cessation Programme\\nAfA (HIV Management)\\nPaed IQ\\nDiabetes Care\\nSOS Call Me\\n24-hour Nurse Line\\nMeditaxi\\n\\n\\n","logo":"fedhealth.jpg"},{"company":"Fedhealth","name":"FlexiFED 1 Elect","planType":"New generation","coverLevel":"Mid","hospital":"Network","chronic":"Network","serviceType":"Network","familyIncome":"","mainContribution":"R1374","mainCompSavings":"R19","mainTotal":"R1393","dependendContributionAdult":"R1075","dependentCompSavingsAdult":"R14","dependentTotalAdult":"R1089","dependendContributionChild":"R501","dependentCompSavingsChild":"R6","dependentTotalChild":"R507","maxChildContribution":"3","mainThreshold":"","dependentThresholdAdult":"","dependentThresholdChild":"","preferedHospitalProvider":"Network (Fedhealth Network Hospitals)","overallLimit":"Unlimited at network\\nhospitals only","coPayment":"All hospital admissions except for emergencies: R13 000\\n\\nVoluntary use of non-network hospitals: R7 300\\nVoluntary use of  non-network day surgery facility: R2 100\\n\\nSurgical extraction of impacted wisdom teeth: R4 800\\n\\nAdenoidectomy, bunion procedures,\\ndiagnostic cystoscopy, gastritis/ dyspepsia/heartburn, nasal procedures, skin biopsy/ excision, All open hernia surgery, Inguinal hernia\\nsugary, Back and neck procedures, Colonoscopy, upper GI endoscopy: R7 100\\n\\nArthroscopic procedures - knee,\\nshoulder, ankle and other: R8 900\\n\\nHysterectomy (unless for cancer): R4 200\\n\\n\\nLaparoscopic hernia repairs\\n(bilateral inguinal, repeated inguinal\\nhernias and Nissen/ Toupet\\nhernia repairs only), laparoscopic\\nprocedures, Laparoscopic varicocelectomy, Varicose vein procedures: R7 100\\n\\nTonsillectomy (12 and over): R7 100","rate":"Negotiated tariff ","generalMedicin":"7 days' supply","specialist":"Network: Unlimited. Paid in full.\\nNon-network: 100% of Scheme Rate\\nOther Healthcare Professionals: 100% Scheme Rate","dentistSurgical":"Maxillo facial surgery: Unlimited, subject to approval","mentalHealth":"Psychiatric services: Unlimited at cost at PMB level of care\\nPMB conditions:\\n21 days in-hospital OR\\n15 psychotherapy sessions out-of-hospital","radiology":"Unlimited at Scheme Rate","pathology":"Unlimited at Scheme Rate","maternityBenefit":"In-hospital:\\nNetwork: Unlimited. Paid in full.\\nNon-network: 100% of Scheme Rate\\nOther Healthcare Professionals: 100% Scheme Rate\\n\\nDoula benefit: R3 000 per delivery \\n\\nOut-of-hospital:\\nPaid Savings\\\\Wallet or self funded\\nAntenatal classes: R1 120 with a midwife \\n4 Postnatal midwife consultations\\n1 amniocentesis test\\nInfant hearing screening benefit\\n2 x 2D scans per pregnancy\\nPaed-IQ telephonic advice line\\nmyFed Baby Programme","dialysis":"Unlimited at cost at PMB level of care at DSP\\n40% co-payment for use of non-DSP ","cancer":"Unlimited at cost at PMB level of care at  preferred providers \\nEssential protocol at ICON and tier 1 primary level of care at SAOC\\n40% co-payment for non-DSP\\n- Palliative care benefit","transplant":"PMB level of care\\nCorneal graft: No benefit","mri":"In and Out of Hospital: Unlimited at Scheme Rate\\nFirst R3 440 for non-PMB MRI/CT scans for the member�s account","prosthesisInternal":"Unlimited at cost at PMB level of care\\nTotal ankle replacement: No benefit","prosthesisExternal":"External prosthesis:\\nUnlimited at cost at PMB level of care\\nAppliances, external accessories and orthotics (In and out of hospital):\\nPaid from Savings / Wallet or self-funded","rehab":"Nursing services: Unlimited at negotiated tariff\\nSub-acute facilities: Unlimited at cost up to PMB level of care \\nTerminal care: R34 500 ","designatedServiceProvider":"Pharmacy Direct, Clicks Direct Medicines\\nand Dis-Chem Direct","conditionsCovered":"CDL in PMB ","formulary":"Basic formulary","partialLimits":"None","preferredProvider":"Fedhealth contracted providers","overallAnualLimit":"None","medicationOverCounter":"Paid from Savings\\\\Wallet or self funded\\nAccumulates at cost to Threshold level","medicationPrescribed":"Paid from Savings\\\\Wallet or self funded\\nAccumulates at cost to Threshold level","practitionersGeneral":"Network:\\nPaid from Savings/Wallet, then unlimited at nominated network GP once Threshold has been reached.\\nBeneficiaries can nominate up to two network GPs.\\n2 x mental health consultations per beneficiary per year.\\n2 x network GP consultations per beneficiary for non-nominated GPs allowed per year (referred to as out-of-area) OR\\n2 x non-network GP consultations per beneficiary up to Scheme Rate\\n\\nNon-network:\\nPaid from Savings/Wallet or self-funded. Accumulates at cost to Threshold level","specialistsCover":"Paid from Savings/Wallet or self funded, subject to network GP referral (including PMB conditions)\\nAccumulates at cost to Threshold level","dentistryCover":"Paid from Savings/Wallet or self-funded\\nFollowing benefits will be paid from Threshold once your threshold level has been reached:\\n2 x annual consultations per beneficiary incl. x-rays, scaling and polishing \\nSubject to contracted dentists and limited to a list of approved procedures, dental tariff codes and protocols","dentistryCoverSpecial":"Paid from Savings/Wallet or self-funded\\nAccumulates at cost to Threshold level","optical":"Paid from Savings/Wallet or self-funded","ambulance":"Unlimited with Europ Assistance","international":"International Travel benefit  through AMP\\nR5 million cover","hospitalCoverAids":"Unlimited\\nHIV Management (Aid for AIDS)","artTtreatment":"Pharmacy Direct, or a 40% co-payment ","preventative":"\\nScreening benefit\\nPap smear\\nProstate Specific Antigen (PSA)\\nChildrens Health (Immunisation programme)\\nCholesterol screening\\nOver 45's (Breast cancer screening with\\nmammography, Colorectal cancer screening, Pneumococcal vaccination)\\nGeneral (Flu vaccination; HIV test)\\nHealth risk assessments\\nPreventative screening (waist-to-hip ratio, body fat %, flexibility, posture & fitness)\\n\\nFemale contraceptives\\n30 days post hospitalisation benefit\\n\\n\\nAdditional services\\nUpgrades within 30 days of a life-changing event\\nHospital at home with Quro Medical\\nCorporate wellness days\\nSisters-on-Site\\nWeight Management Programme\\nGoSmokeFree Smoking Cessation Programme\\nAfA (HIV Management)\\nPaed IQ\\nDiabetes Care\\nSOS Call Me\\n24-hour Nurse Line\\nMeditaxi\\n\\n\\n","logo":"fedhealth.jpg"},{"company":"Fedhealth","name":"FlexiFED 2","planType":"New generation","coverLevel":"Mid","hospital":"Any","chronic":"Network","serviceType":"Network","familyIncome":"","mainContribution":"R2473","mainCompSavings":"R27","mainTotal":"R2500","dependendContributionAdult":"R2148","dependentCompSavingsAdult":"R23","dependentTotalAdult":"R2171","dependendContributionChild":"R735","dependentCompSavingsChild":"R7","dependentTotalChild":"R742","maxChildContribution":"3","mainThreshold":"","dependentThresholdAdult":"","dependentThresholdChild":"","preferedHospitalProvider":"Any hospital\\nPartial cover for the following hospitals: Zuid-Afrikaans Hospital, Arwyp Medical Centre, Busamed Modderfontein, Hibiscus\\nHospital, Mooimed Private Hospital, St\\nHelena Private Hospital, Capital Hospital","overallLimit":"Unlimited at negotiated tariff","coPayment":"Surgical extraction of impacted wisdom teeth: R4 800\\n\\nR7 300 co-payment for Elective Procedures\\n\\nAdenoidectomy, bunion procedures,\\ndiagnostic cystoscopy, gastritis/ dyspepsia/heartburn, nasal procedures, skin biopsy/ excision, Back and neck procedures, Dental admissions: R7 100\\n\\nAll open hernia surgery, Colonoscopy, upper GI endoscopy, Inguinal hernia sugary: R4 800\\n\\nArthroscopic procedures - knee,\\nshoulder, ankle, hip, wrist and\\nother: R8 900\\n\\nHysterectomy (unless for cancer): R4 200\\n\\nLaparoscopic hernia repairs\\n(bilateral inguinal, repeated inguinal\\nhernias and Nissen/ Toupet\\nhernia repairs only), laparoscopic\\nprocedures, Laparoscopic varicocelectomy, Varicose vein procedures: R7 100\\n\\nTonsillectomy (12 and over): R7 100","rate":"Negotiated tariff ","generalMedicin":"7 days' supply","specialist":"Network: Unlimited. Paid in full.\\nNon-network: 100% of Scheme Rate\\nOther Healthcare Professionals: 100% Scheme Rate","dentistSurgical":"Maxillo facial surgery\\nUnlimited, subject to approval\\n\\nIn-hospital dentistry for children under 7:\\nThe hospital and anaesthetist account to be paid from the in-hospital benefit while the dentist�s account to be paid from the day-to-day benefit","mentalHealth":"Psychiatric services: R26 400 per family\\nPMB conditions:\\n21 days in-hospital OR\\n15 psychotherapy sessions out-of-hospital","radiology":"Unlimited at Scheme Rate","pathology":"Unlimited at Scheme Rate","maternityBenefit":"In-hospital:\\nNetwork: Unlimited. Paid in full.\\nNon-network: 100% of Scheme Rate\\nOther Healthcare Professionals: 100% Scheme Rate\\n\\nDoula benefit: R3 000 per delivery \\n\\nOut-of-hospital:\\nAntenatal classes: R1 160 with a midwife \\n8 Ante-or postnatal consultations with a midwife, network gynaecologist or GP\\n4 Postnatal midwife consultations\\n1 amniocentesis test\\n1 Paediatric consultation; without GP referral up to 12 months \\nInfant hearing screening benefit\\n2 x 2D scans per pregnancy\\nPaed-IQ telephonic advice line\\nmyFed Baby Programme\\n- Childhood illness specialised drug benefit for children up to 18","dialysis":"R311 900 per family at DSP\\n40% co-payment for use of non-DSP ","cancer":"R311 900 per family at preferred providers \\nEssential protocol at ICON and tier 1\\nprimary level of care at SAOC\\n40% co-payment if network is not used \\nSpecialised medication: No benefit\\n- Palliative care benefit","transplant":"R311 900 per family \\nCorneal graft: No benefit","mri":"In and Out of Hospital: Unlimited at Scheme Rate\\nFirst R2 480 for non-PMB MRI/CT scans for the member�s account","prosthesisInternal":"Unlimited at cost at PMB level of care\\nTotal ankle replacement: No benefit","prosthesisExternal":"External prosthesis:\\nR12 100 at cost\\nAppliances, external accessories and orthotics (In and out of hospital):\\npaid from Savings/ Wallet or self-funded","rehab":"Nursing services: Unlimited at negotiated tariff\\nSub-acute facilities: Unlimited at cost up to PMB level of care \\nTerminal care: R34 500 ","designatedServiceProvider":"Clicks, Dis-Chem, MediRite, Pharmacy Direct, Clicks Direct Medicines\\nand Dis-Chem Direct","conditionsCovered":"CDL in PMB ","formulary":"Intermediate formulary","partialLimits":"None","preferredProvider":"Fedhealth contracted providers","overallAnualLimit":"None","medicationOverCounter":"Paid from Savings\\\\Wallet or self funded\\nAccumulates at cost to Threshold level","medicationPrescribed":"Paid from Savings\\\\Wallet or self funded\\nAccumulates at cost to Threshold level","practitionersGeneral":"Network:\\nPaid from Savings/Wallet, then unlimited at nominated network GP once Threshold has been reached.\\nBeneficiaries can nominate up to two network GPs.\\n2 x mental health consultations per beneficiary per year.\\n2 x network GP consultations per beneficiary for non-nominated GPs allowed per year (referred to as out-of-area) OR\\n2 x non-network GP consultations per beneficiary up to Scheme Rate\\n\\nNon-network:\\nPaid from Savings/Wallet or self-funded. Accumulates at cost to Threshold level","specialistsCover":"Paid from Savings/Wallet or self funded, subject to network GP referral (including PMB conditions)\\nAccumulates at cost to Threshold level","dentistryCover":"Paid from Savings/Wallet or self-funded\\nFollowing benefits will be paid from Threshold once your threshold level has been reached:\\n2 x annual consultations per beneficiary incl. x-rays, scaling, polishing, fillings, extractions and root canal\\nSubject to contracted dentists and limited to a list of approved procedures, dental tariff codes and protocols","dentistryCoverSpecial":"Paid from Savings/Wallet or self-funded\\nAccumulates at cost to Threshold level","optical":"Paid from Savings/Wallet or self-funded","ambulance":"Unlimited with Europ Assistance","international":"International Travel benefit  through AMP\\nR5 million cover","hospitalCoverAids":"Unlimited\\nHIV Management (Aid for AIDS)","artTtreatment":"At preferred providers","preventative":"\\nScreening benefit\\nPap smear\\nProstate Specific Antigen (PSA)\\nChildrens Health (Immunisation programme, HPV vaccine girls 9-14 years )\\nCholesterol screening\\nOver 45's (Breast cancer screening with\\nmammography, Colorectal cancer screening, Pneumococcal vaccination)\\nGeneral (Flu vaccination; HIV test)\\nHealth risk assessments\\nPreventative screening (waist-to-hip ratio, body fat %, flexibility, posture & fitness)\\n\\nFemale contraceptives\\n30 days post hospitalisation benefit\\nUpgrades within 30 days of a life-changing event\\n\\nAdditional services\\nUpgrades within 30 days of a life-changing event\\nHospital at home with Quro Medical\\nCorporate wellness days\\nSisters-on-Site\\nWeight Management Programme\\nGoSmokeFree Smoking Cessation Programme\\nAfA (HIV Management)\\nPaed IQ\\nDiabetes Care\\nSOS Call Me\\n24-hour Nurse Line\\nMeditaxi\\n\\n\\n","logo":"fedhealth.jpg"},{"company":"Fedhealth","name":"FlexiFED 2 Grid","planType":"New generation","coverLevel":"Mid","hospital":"Network","chronic":"Network","serviceType":"Network","familyIncome":"","mainContribution":"R2198","mainCompSavings":"R24","mainTotal":"R2222","dependendContributionAdult":"R1913","dependentCompSavingsAdult":"R20","dependentTotalAdult":"R1933","dependendContributionChild":"R653","dependentCompSavingsChild":"R7","dependentTotalChild":"R660","maxChildContribution":"3","mainThreshold":"","dependentThresholdAdult":"","dependentThresholdChild":"","preferedHospitalProvider":"Network (Fedhealth Network Hospitals)","overallLimit":"Unlimited at negotiated tariff","coPayment":"Voluntary use of non-network hospitals: R13 000\\nVoluntary use of  non-network day surgery facility: R2 100\\n\\nSurgical extraction of impacted wisdom teeth: R4 800\\n\\nAdenoidectomy, bunion procedures,\\ndiagnostic cystoscopy, gastritis/ dyspepsia/heartburn, nasal procedures, skin biopsy/ excision, Back and neck procedures, Dental admissions: R7 100\\n\\nAll open hernia surgery, Colonoscopy, upper GI endoscopy, Inguinal hernia sugary: R4 800\\n\\nArthroscopic procedures - knee,\\nshoulder, ankle, hip, wrist and\\nother: R8 900\\n\\nHysterectomy (unless for cancer): R4 200\\n\\nLaparoscopic hernia repairs\\n(bilateral inguinal, repeated inguinal\\nhernias and Nissen/ Toupet\\nhernia repairs only), laparoscopic\\nprocedures, Laparoscopic varicocelectomy, Varicose vein procedures: R7 100\\n\\nTonsillectomy (12 and over): R7 100","rate":"Negotiated tariff ","generalMedicin":"7 days' supply","specialist":"Network: Unlimited. Paid in full.\\nNon-network: 100% of Scheme Rate\\nOther Healthcare Professionals: 100% Scheme Rate","dentistSurgical":"Maxillo facial surgery\\nUnlimited, subject to approval\\n\\nIn-hospital dentistry for children under 7:\\nThe hospital and anaesthetist account to be paid from the in-hospital benefit while the dentist�s account to be paid from the day-to-day benefit","mentalHealth":"Psychiatric services: R26 400 per family\\nPMB conditions:\\n21 days in-hospital OR\\n15 psychotherapy sessions out-of-hospital","radiology":"Unlimited at Scheme Rate","pathology":"Unlimited at Scheme Rate","maternityBenefit":"In-hospital:\\nNetwork: Unlimited. Paid in full.\\nNon-network: 100% of Scheme Rate\\nOther Healthcare Professionals: 100% Scheme Rate\\n\\nDoula benefit: R3 000 per delivery \\n\\nOut-of-hospital:\\nAntenatal classes: R1 160 with a midwife \\n8 Ante-or postnatal consultations with a midwife, network gynaecologist or GP\\n4 Postnatal midwife consultations\\n1 amniocentesis test\\n1 Paediatric consultation; without GP referral up to 12 months \\nInfant hearing screening benefit\\n2 x 2D scans per pregnancy\\nPaed-IQ telephonic advice line\\nmyFed Baby Programme\\n- Childhood illness specialised drug benefit for children up to 18","dialysis":"R311 900 per family at DSP\\n40% co-payment for use of non-DSP ","cancer":"R311 900 per family at preferred providers \\nEssential protocol at ICON and tier 1\\nprimary level of care at SAOC\\n40% co-payment if network is not used \\nSpecialised medication: No benefit\\n- Palliative care benefit","transplant":"R311 900 per family \\nCorneal graft: No benefit","mri":"In and Out of Hospital: Unlimited at Scheme Rate\\nFirst R2 480 for non-PMB MRI/CT scans for the member�s account","prosthesisInternal":"Unlimited at cost at PMB level of care\\nTotal ankle replacement: No benefit","prosthesisExternal":"External prosthesis:\\nR12 100 at cost\\nAppliances, external accessories and orthotics (In and out of hospital):\\npaid from Savings/ Wallet or self-funded","rehab":"Nursing services: Unlimited at negotiated tariff\\nSub-acute facilities: Unlimited at cost up to PMB level of care \\nTerminal care: R34 500 ","designatedServiceProvider":"Clicks, Dis-Chem, MediRite, Pharmacy Direct, Clicks Direct Medicines\\nand Dis-Chem Direct","conditionsCovered":"CDL in PMB ","formulary":"Intermediate formulary","partialLimits":"None","preferredProvider":"Fedhealth contracted providers","overallAnualLimit":"None","medicationOverCounter":"Paid from Savings\\\\Wallet or self funded\\nAccumulates at cost to Threshold level","medicationPrescribed":"Paid from Savings\\\\Wallet or self funded\\nAccumulates at cost to Threshold level","practitionersGeneral":"Network:\\nPaid from Savings/Wallet, then unlimited at nominated network GP once Threshold has been reached.\\nBeneficiaries can nominate up to two network GPs.\\n2 x mental health consultations per beneficiary per year.\\n2 x network GP consultations per beneficiary for non-nominated GPs allowed per year (referred to as out-of-area) OR\\n2 x non-network GP consultations per beneficiary up to Scheme Rate\\n\\nNon-network:\\nPaid from Savings/Wallet or self-funded. Accumulates at cost to Threshold level","specialistsCover":"Paid from Savings/Wallet or self funded, subject to network GP referral (including PMB conditions)\\nAccumulates at cost to Threshold level","dentistryCover":"Paid from Savings/Wallet or self-funded\\nFollowing benefits will be paid from Threshold once your threshold level has been reached:\\n2 x annual consultations per beneficiary incl. x-rays, scaling, polishing, fillings, extractions and root canal\\nSubject to contracted dentists and limited to a list of approved procedures, dental tariff codes and protocols","dentistryCoverSpecial":"Paid from Savings/Wallet or self-funded\\nAccumulates at cost to Threshold level","optical":"Paid from Savings/Wallet or self-funded","ambulance":"Unlimited with Europ Assistance","international":"International Travel benefit  through AMP\\nR5 million cover","hospitalCoverAids":"Unlimited\\nHIV Management (Aid for AIDS)","artTtreatment":"At preferred providers","preventative":"\\nScreening benefit\\nPap smear\\nProstate Specific Antigen (PSA)\\nChildrens Health (Immunisation programme, HPV vaccine girls 9-14 years )\\nCholesterol screening\\nOver 45's (Breast cancer screening with\\nmammography, Colorectal cancer screening, Pneumococcal vaccination)\\nGeneral (Flu vaccination; HIV test)\\nHealth risk assessments\\nPreventative screening (waist-to-hip ratio, body fat %, flexibility, posture & fitness)\\n\\nFemale contraceptives\\n30 days post hospitalisation benefit\\nUpgrades within 30 days of a life-changing event\\n\\nAdditional services\\nUpgrades within 30 days of a life-changing event\\nHospital at home with Quro Medical\\nCorporate wellness days\\nSisters-on-Site\\nWeight Management Programme\\nGoSmokeFree Smoking Cessation Programme\\nAfA (HIV Management)\\nPaed IQ\\nDiabetes Care\\nSOS Call Me\\n24-hour Nurse Line\\nMeditaxi\\n\\n\\n","logo":"fedhealth.jpg"},{"company":"Fedhealth","name":"FlexiFED 2 Elect","planType":"New generation","coverLevel":"Mid","hospital":"Network","chronic":"Network","serviceType":"Network","familyIncome":"","mainContribution":"R1851","mainCompSavings":"R20","mainTotal":"R1871","dependendContributionAdult":"R1614","dependentCompSavingsAdult":"R17","dependentTotalAdult":"R1631","dependendContributionChild":"R552","dependentCompSavingsChild":"R6","dependentTotalChild":"R558","maxChildContribution":"3","mainThreshold":"","dependentThresholdAdult":"","dependentThresholdChild":"","preferedHospitalProvider":"Restricted network hospitals, consist of 29 hospitals) ","overallLimit":"Unlimited at negotiated tariff","coPayment":"All hospital admissions except for emergencies: R13 000\\n\\nSurgical extraction of impacted wisdom teeth: R4 800\\n\\nAdenoidectomy, bunion procedures,\\ndiagnostic cystoscopy, gastritis/ dyspepsia/heartburn, nasal procedures, skin biopsy/ excision, Back and neck procedures, Dental admissions: R7 100\\n\\nAll open hernia surgery, Colonoscopy, upper GI endoscopy, Inguinal hernia sugary: R4 800\\n\\nArthroscopic procedures - knee,\\nshoulder, ankle, hip, wrist and\\nother: R8 900\\n\\nHysterectomy (unless for cancer): R4 200\\n\\nLaparoscopic hernia repairs\\n(bilateral inguinal, repeated inguinal\\nhernias and Nissen/ Toupet\\nhernia repairs only), laparoscopic\\nprocedures, Laparoscopic varicocelectomy, Varicose vein procedures: R7 100\\n\\nTonsillectomy (12 and over): R7 100","rate":"Negotiated tariff ","generalMedicin":"7 days' supply","specialist":"Network: Unlimited. Paid in full.\\nNon-network: 100% of Scheme Rate\\nOther Healthcare Professionals: 100% Scheme Rate","dentistSurgical":"Maxillo facial surgery\\nUnlimited, subject to approval\\n\\nIn-hospital dentistry for children under 7:\\nThe hospital and anaesthetist account to be paid from the in-hospital benefit while the dentist�s account to be paid from the day-to-day benefit","mentalHealth":"Psychiatric services: R26 400 per family\\nPMB conditions:\\n21 days in-hospital OR\\n15 psychotherapy sessions out-of-hospital","radiology":"Unlimited at Scheme Rate","pathology":"Unlimited at Scheme Rate","maternityBenefit":"In-hospital:\\nNetwork: Unlimited. Paid in full.\\nNon-network: 100% of Scheme Rate\\nOther Healthcare Professionals: 100% Scheme Rate\\n\\nDoula benefit: R3 000 per delivery \\n\\nOut-of-hospital:\\nAntenatal classes: R1 160 with a midwife \\n8 Ante-or postnatal consultations with a midwife, network gynaecologist or GP\\n4 Postnatal midwife consultations\\n1 amniocentesis test\\n1 Paediatric consultation; without GP referral up to 12 months \\nInfant hearing screening benefit\\n2 x 2D scans per pregnancy\\nPaed-IQ telephonic advice line\\nmyFed Baby Programme\\n- Childhood illness specialised drug benefit for children up to 18","dialysis":"R311 900 per family at DSP\\n40% co-payment for use of non-DSP ","cancer":"R311 900 per family at preferred providers \\nEssential protocol at ICON and tier 1\\nprimary level of care at SAOC\\n40% co-payment if network is not used \\nSpecialised medication: No benefit\\n- Palliative care benefit","transplant":"R311 900 per family \\nCorneal graft: No benefit","mri":"In and Out of Hospital: Unlimited at Scheme Rate\\nFirst R2 480 for non-PMB MRI/CT scans for the member�s account","prosthesisInternal":"Unlimited at cost at PMB level of care\\nTotal ankle replacement: No benefit","prosthesisExternal":"External prosthesis:\\nR12 100 at cost\\nAppliances, external accessories and orthotics (In and out of hospital):\\npaid from Savings/ Wallet or self-funded","rehab":"Nursing services: Unlimited at negotiated tariff\\nSub-acute facilities: Unlimited at cost up to PMB level of care \\nTerminal care: R34 500 ","designatedServiceProvider":"Pharmacy Direct, Clicks Direct Medicines\\nand Dis-Chem Direct","conditionsCovered":"CDL in PMB ","formulary":"Intermediate formulary","partialLimits":"None","preferredProvider":"Fedhealth contracted providers","overallAnualLimit":"None","medicationOverCounter":"Paid from Savings\\\\Wallet or self funded\\nAccumulates at cost to Threshold level","medicationPrescribed":"Paid from Savings\\\\Wallet or self funded\\nAccumulates at cost to Threshold level","practitionersGeneral":"Network:\\nPaid from Savings/Wallet, then unlimited at nominated network GP once Threshold has been reached.\\nBeneficiaries can nominate up to two network GPs.\\n2 x mental health consultations per beneficiary per year.\\n2 x network GP consultations per beneficiary for non-nominated GPs allowed per year (referred to as out-of-area) OR\\n2 x non-network GP consultations per beneficiary up to Scheme Rate\\n\\nNon-network:\\nPaid from Savings/Wallet or self-funded. Accumulates at cost to Threshold level","specialistsCover":"Paid from Savings/Wallet or self funded, subject to network GP referral (including PMB conditions)\\nAccumulates at cost to Threshold level","dentistryCover":"Paid from Savings/Wallet or self-funded\\nFollowing benefits will be paid from Threshold once your threshold level has been reached:\\n2 x annual consultations per beneficiary incl. x-rays, scaling, polishing, fillings, extractions and root canal\\nSubject to contracted dentists and limited to a list of approved procedures, dental tariff codes and protocols","dentistryCoverSpecial":"Paid from Savings/Wallet or self-funded\\nAccumulates at cost to Threshold level","optical":"Paid from Savings/Wallet or self-funded","ambulance":"Unlimited with Europ Assistance","international":"International Travel benefit  through AMP\\nR5 million cover","hospitalCoverAids":"Unlimited\\nHIV Management (Aid for AIDS)","artTtreatment":"At preferred providers","preventative":"\\nScreening benefit\\nPap smear\\nProstate Specific Antigen (PSA)\\nChildrens Health (Immunisation programme, HPV vaccine girls 9-14 years )\\nCholesterol screening\\nOver 45's (Breast cancer screening with\\nmammography, Colorectal cancer screening, Pneumococcal vaccination)\\nGeneral (Flu vaccination; HIV test)\\nHealth risk assessments\\nPreventative screening (waist-to-hip ratio, body fat %, flexibility, posture & fitness)\\n\\nFemale contraceptives\\n30 days post hospitalisation benefit\\nUpgrades within 30 days of a life-changing event\\n\\nAdditional services\\nUpgrades within 30 days of a life-changing event\\nHospital at home with Quro Medical\\nCorporate wellness days\\nSisters-on-Site\\nWeight Management Programme\\nGoSmokeFree Smoking Cessation Programme\\nAfA (HIV Management)\\nPaed IQ\\nDiabetes Care\\nSOS Call Me\\n24-hour Nurse Line\\nMeditaxi\\n\\n\\n","logo":"fedhealth.jpg"},{"company":"Fedhealth","name":"FlexiFED 3","planType":"New generation","coverLevel":"Mid","hospital":"Any","chronic":"Network","serviceType":"Network","familyIncome":"","mainContribution":"R2798","mainCompSavings":"R27","mainTotal":"R2825","dependendContributionAdult":"R2525","dependentCompSavingsAdult":"R24","dependentTotalAdult":"R2549","dependendContributionChild":"R1006","dependentCompSavingsChild":"R9","dependentTotalChild":"R1015","maxChildContribution":"3","mainThreshold":"","dependentThresholdAdult":"","dependentThresholdChild":"","preferedHospitalProvider":"Any hospital\\nPartial cover for the following hospitals: Zuid-Afrikaans Hospital, Arwyp Medical Centre, Busamed Modderfontein, Hibiscus\\nHospital, Mooimed Private Hospital, St\\nHelena Private Hospital, Capital Hospital","overallLimit":"Unlimited at negotiated tariff","coPayment":"\\nSurgical extraction of impacted wisdom teeth: R4 800\\n\\nR7 300 co-payment for Elective Procedures\\n\\nSpinal surgery: R8 400 (No benefit unless conservative back and neck rehabilitation programme has been completed)\\n\\nAll open hernia surgery: R4 800\\n\\nArthroscopic procedures - knee,\\nshoulder, ankle, hip, wrist and\\nother: R8 900\\n\\nBack and neck procedures: R4 700\\n\\nColonoscopy, upper GI endoscopy, Inguinal hernia sugary: R4 800\\n\\nHysterectomy (unless for cancer): R4 200\\n\\nSingle hip and knee replacements - voluntary non-use of CP: R29 600\\n\\nOther joint replacements and\\ninvoluntary non-use of CP for single hip and knee replacements: R7 100\\n\\nLaparoscopic hernia repairs\\n(bilateral inguinal, repeated inguinal\\nhernias and Nissen/ Toupet\\nhernia repairs only), laparoscopic\\nprocedures, Laparoscopic varicocelectomy: R7 100\\n\\nVaricose vein procedures: R4 800","rate":"Negotiated tariff ","generalMedicin":"7 days' supply","specialist":"Network: Unlimited. Paid in full.\\nNon-network: 100% of Scheme Rate\\nOther Healthcare Professionals: 100% Scheme Rate","dentistSurgical":"Maxillo facial surgery\\nUnlimited, subject to approval\\n\\nIn-hospital dentistry for children under 7:\\nThe hospital and anaesthetist account to be paid from the in-hospital benefit while the dentist�s account to be paid from the day-to-day benefit","mentalHealth":"Psychiatric services: R28 000 per family\\nPMB conditions:\\n21 days in-hospital OR\\n15 psychotherapy sessions out-of-hospital","radiology":"Unlimited at Scheme Rate","pathology":"Unlimited at Scheme Rate","maternityBenefit":"In-hospital: Private ward cover\\nNetwork: Unlimited. Paid in full.\\nNon-network: 100% of Scheme Rate\\nOther Healthcare Professionals: 100% Scheme Rate\\n\\nDoula benefit: R3 000 per delivery \\n\\nOut-of-hospital:\\nAntenatal classes: R1 160 with a midwife \\n12 Ante-or postnatal consultations with a midwife, network gynaecologist or GP\\n4 Postnatal midwife consultations\\n1 amniocentesis test\\n1 Paediatric consultation; without GP referral up to 24 months \\nInfant hearing screening benefit\\n2 x 2D scans per pregnancy\\nPaed-IQ telephonic advice line\\nmyFed Baby Programme\\n- Childhood illness specialised drug benefit for children up to 18","dialysis":"R311 900 per family at DSP\\n40% co-payment for use of non-DSP ","cancer":"R311 900 per family at preferred providers \\nEssential protocol at ICON and tier 1\\nprimary level of care at SAOC\\n40% co-payment if network is not used \\nSpecialised medication: No benefit\\n- Palliative care benefit","transplant":"R311 900 per family \\nCorneal graft: No benefit","mri":"In and Out of Hospital: Unlimited at Scheme Rate\\nFirst R2 480 for non-PMB MRI/CT scans for the member�s account","prosthesisInternal":"Aorta stent grafts: R65 500\\nCardiac pacemakers, cardiac stents, cardiac valves: Unlimited at cost at PMB level of care\\nDetachable platinum coils: R56 700\\nTotal ankle replacement: No benefit\\nIntraocular lenses: R3 500 per lens\\nCombined limit for all unlisted internal prosthesis: R27 900","prosthesisExternal":"External prosthesis:\\nR12 900 at cost\\nAppliances, external accessories and orthotics (In and out of hospital):\\nPaid from Savings/ Wallet or self-funded","rehab":"Nursing services: Unlimited at negotiated tariff\\nSub-acute facilities: Unlimited at cost up to PMB level of care \\nTerminal care: R34 500 ","designatedServiceProvider":"Clicks, Dis-Chem, MediRite, Pharmacy Direct, Clicks Direct Medicines\\nand Dis-Chem Direct","conditionsCovered":"CDL in PMB + 7 ","formulary":"Intermediate formulary","partialLimits":"Acne (up to the age of 21), Allergic rhinitis (up to the age of 18), Eczema (up to the age of 18)\\n\\nUnlimited cover for conditions on the CDL plus allergic rhinitis, acne and eczema.\\n\\nAttention Deficit Hyperactivity Disorder, Depression, Generalised Anxiety Disorder, Post-Traumatic Stress Disorder subject to a limit of R3 200 per family","preferredProvider":"Fedhealth contracted providers","overallAnualLimit":"None","medicationOverCounter":"Paid from Savings\\\\Wallet or self funded\\nAccumulates at cost to Threshold level","medicationPrescribed":"Paid from Savings\\\\Wallet or self funded\\nAccumulates at cost to Threshold level","practitionersGeneral":"Network:\\nPaid from Savings/Wallet, then unlimited at nominated network GP once Threshold has been reached.\\nBeneficiaries can nominate up to two network GPs.\\n2 x mental health consultations per beneficiary per year.\\n2 x network GP consultations per beneficiary for non-nominated GPs allowed per year (referred to as out-of-area) OR\\n2 x non-network GP consultations per beneficiary up to Scheme Rate\\n\\nNon-network:\\nPaid from Savings/Wallet or self-funded. Accumulates at cost to Threshold level","specialistsCover":"Paid from Savings/Wallet or self funded, subject to network GP referral (including PMB conditions)\\nAccumulates at cost to Threshold level","dentistryCover":"Paid from Savings/Wallet or self-funded\\nFollowing benefits will be paid from Threshold once your threshold level has been reached:\\n2 x annual consultations per beneficiary incl. x-rays, scaling, polishing, fillings, extractions and root canal\\nSubject to contracted dentists and limited to a list of approved procedures, dental tariff codes and protocols","dentistryCoverSpecial":"Paid from Savings/Wallet or self-funded\\nAccumulates at cost to Threshold level","optical":"Limited to R1 930 per beneficiary every 24 months, thereafter paid from Savings/Wallet or self-funded","ambulance":"Unlimited with Europ Assistance","international":"International Travel benefit  through AMP\\nR5 million cover","hospitalCoverAids":"Unlimited\\nHIV Management (Aid for AIDS)","artTtreatment":"At preferred providers","preventative":"\\nScreening benefit\\nPap smear\\nProstate Specific Antigen (PSA)\\nChildrens Health (Immunisation programme, HPV vaccine girls 9-14 years )\\nCholesterol screening\\nOver 45's (Breast cancer screening with\\nmammography, Colorectal cancer screening, Pneumococcal vaccination)\\nGeneral (Flu vaccination; HIV test)\\nHealth risk assessments\\nPreventative screening (waist-to-hip ratio, body fat %, flexibility, posture & fitness)\\n\\nFemale contraceptives\\n30 days post hospitalisation benefit\\nUpgrades within 30 days of a life-changing event\\n\\nAdditional services\\nUpgrades within 30 days of a life-changing event\\nHospital at home with Quro Medical\\nCorporate wellness days\\nSisters-on-Site\\nWeight Management Programme\\nGoSmokeFree Smoking Cessation Programme\\nAfA (HIV Management)\\nPaed IQ\\nDiabetes Care\\nSOS Call Me\\n24-hour Nurse Line\\nMeditaxi\\n\\n\\n","logo":"fedhealth.jpg"},{"company":"Fedhealth","name":"FlexiFED 3 Grid","planType":"New generation","coverLevel":"Mid","hospital":"Network","chronic":"Network","serviceType":"Network","familyIncome":"","mainContribution":"R2487","mainCompSavings":"R24","mainTotal":"R2511","dependendContributionAdult":"R2247","dependentCompSavingsAdult":"R22","dependentTotalAdult":"R2269","dependendContributionChild":"R895","dependentCompSavingsChild":"R8","dependentTotalChild":"R903","maxChildContribution":"3","mainThreshold":"","dependentThresholdAdult":"","dependentThresholdChild":"","preferedHospitalProvider":"Network (Fedhealth Network Hospitals)","overallLimit":"Unlimited at negotiated tariff","coPayment":"Voluntary use of non-network hospitals: R13 000\\nVoluntary use of  non-network day surgery facility: R2 100\\n\\nSurgical extraction of impacted wisdom teeth: R4 800\\n\\nSpinal surgery: R8 400 (No benefit unless conservative back and neck rehabilitation programme has been completed)\\n\\nAll open hernia surgery: R4 800\\n\\nArthroscopic procedures - knee,\\nshoulder, ankle, hip, wrist and\\nother: R8 500\\n\\nBack and neck procedures: R4 700\\n\\nColonoscopy, upper GI endoscopy, Inguinal hernia sugary: R4 800\\n\\nHysterectomy (unless for cancer): R4 200\\n\\nSingle hip and knee replacements - voluntary non-use of CP: R29 600\\n\\nOther joint replacements and\\ninvoluntary non-use of CP for single hip and knee replacements: R7 100\\n\\nLaparoscopic hernia repairs\\n(bilateral inguinal, repeated inguinal\\nhernias and Nissen/ Toupet\\nhernia repairs only), laparoscopic\\nprocedures, Laparoscopic varicocelectomy: R7 100\\n\\nVaricose vein procedures: R4 800","rate":"Negotiated tariff ","generalMedicin":"7 days' supply","specialist":"Network: Unlimited. Paid in full.\\nNon-network: 100% of Scheme Rate\\nOther Healthcare Professionals: 100% Scheme Rate","dentistSurgical":"Maxillo facial surgery\\nUnlimited, subject to approval\\n\\nIn-hospital dentistry for children under 7:\\nThe hospital and anaesthetist account to be paid from the in-hospital benefit while the dentist�s account to be paid from the day-to-day benefit","mentalHealth":"Psychiatric services: R28 000 per family\\nPMB conditions:\\n21 days in-hospital OR\\n15 psychotherapy sessions out-of-hospital","radiology":"Unlimited at Scheme Rate","pathology":"Unlimited at Scheme Rate","maternityBenefit":"In-hospital: Private ward cover\\nNetwork: Unlimited. Paid in full.\\nNon-network: 100% of Scheme Rate\\nOther Healthcare Professionals: 100% Scheme Rate\\n\\nDoula benefit: R3 000 per delivery \\n\\nOut-of-hospital:\\nAntenatal classes: R1 160 with a midwife \\n12 Ante-or postnatal consultations with a midwife, network gynaecologist or GP\\n4 Postnatal midwife consultations\\n1 amniocentesis test\\n1 Paediatric consultation; without GP referral up to 24 months \\nInfant hearing screening benefit\\n2 x 2D scans per pregnancy\\nPaed-IQ telephonic advice line\\nmyFed Baby Programme\\n- Childhood illness specialised drug benefit for children up to 18","dialysis":"R311 900 per family at DSP\\n40% co-payment for use of non-DSP ","cancer":"R311 900 per family at preferred providers \\nEssential protocol at ICON and tier 1\\nprimary level of care at SAOC\\n40% co-payment if network is not used \\nSpecialised medication: No benefit\\n- Palliative care benefit","transplant":"R311 900 per family \\nCorneal graft: No benefit","mri":"In and Out of Hospital: Unlimited at Scheme Rate\\nFirst R2 480 for non-PMB MRI/CT scans for the member�s account","prosthesisInternal":"Aorta stent grafts: R65 500\\nCardiac pacemakers, cardiac stents, cardiac valves: Unlimited at cost at PMB level of care\\nDetachable platinum coils: R56 700\\nTotal ankle replacement: No benefit\\nIntraocular lenses: R3 500 per lens\\nCombined limit for all unlisted internal prosthesis: R27 900","prosthesisExternal":"External prosthesis:\\nR12 900 at cost\\nAppliances, external accessories and orthotics (In and out of hospital):\\nPaid from Savings/ Wallet or self-funded","rehab":"Nursing services: Unlimited at negotiated tariff\\nSub-acute facilities: Unlimited at cost up to PMB level of care \\nTerminal care: R34 500 ","designatedServiceProvider":"Clicks, Dis-Chem, MediRite, Pharmacy Direct, Clicks Direct Medicines\\nand Dis-Chem Direct","conditionsCovered":"CDL in PMB + 7 ","formulary":"Intermediate formulary","partialLimits":"Acne (up to the age of 21), Allergic rhinitis (up to the age of 18), Eczema (up to the age of 18)\\n\\nUnlimited cover for conditions on the CDL plus allergic rhinitis, acne and eczema.\\n\\nAttention Deficit Hyperactivity Disorder, Depression, Generalised Anxiety Disorder, Post-Traumatic Stress Disorder subject to a limit of R3 200 per family","preferredProvider":"Fedhealth contracted providers","overallAnualLimit":"None","medicationOverCounter":"Paid from Savings\\\\Wallet or self funded\\nAccumulates at cost to Threshold level","medicationPrescribed":"Paid from Savings\\\\Wallet or self funded\\nAccumulates at cost to Threshold level","practitionersGeneral":"Network:\\nPaid from Savings/Wallet, then unlimited at nominated network GP once Threshold has been reached.\\nBeneficiaries can nominate up to two network GPs.\\n2 x mental health consultations per beneficiary per year.\\n2 x network GP consultations per beneficiary for non-nominated GPs allowed per year (referred to as out-of-area) OR\\n2 x non-network GP consultations per beneficiary up to Scheme Rate\\n\\nNon-network:\\nPaid from Savings/Wallet or self-funded. Accumulates at cost to Threshold level","specialistsCover":"Paid from Savings/Wallet or self funded, subject to network GP referral (including PMB conditions)\\nAccumulates at cost to Threshold level","dentistryCover":"Paid from Savings/Wallet or self-funded\\nFollowing benefits will be paid from Threshold once your threshold level has been reached:\\n2 x annual consultations per beneficiary incl. x-rays, scaling, polishing, fillings, extractions and root canal\\nSubject to contracted dentists and limited to a list of approved procedures, dental tariff codes and protocols","dentistryCoverSpecial":"Paid from Savings/Wallet or self-funded\\nAccumulates at cost to Threshold level","optical":"Limited to R1 930 per beneficiary every 24 months, thereafter paid from Savings/Wallet or self-funded","ambulance":"Unlimited with Europ Assistance","international":"International Travel benefit  through AMP\\nR5 million cover","hospitalCoverAids":"Unlimited\\nHIV Management (Aid for AIDS)","artTtreatment":"At preferred providers","preventative":"\\nScreening benefit\\nPap smear\\nProstate Specific Antigen (PSA)\\nChildrens Health (Immunisation programme, HPV vaccine girls 9-14 years )\\nCholesterol screening\\nOver 45's (Breast cancer screening with\\nmammography, Colorectal cancer screening, Pneumococcal vaccination)\\nGeneral (Flu vaccination; HIV test)\\nHealth risk assessments\\nPreventative screening (waist-to-hip ratio, body fat %, flexibility, posture & fitness)\\n\\nFemale contraceptives\\n30 days post hospitalisation benefit\\nUpgrades within 30 days of a life-changing event\\n\\nAdditional services\\nUpgrades within 30 days of a life-changing event\\nHospital at home with Quro Medical\\nCorporate wellness days\\nSisters-on-Site\\nWeight Management Programme\\nGoSmokeFree Smoking Cessation Programme\\nAfA (HIV Management)\\nPaed IQ\\nDiabetes Care\\nSOS Call Me\\n24-hour Nurse Line\\nMeditaxi\\n\\n\\n","logo":"fedhealth.jpg"},{"company":"Fedhealth","name":"FlexiFED 3 Elect","planType":"New generation","coverLevel":"Mid","hospital":"Network","chronic":"Network","serviceType":"Network","familyIncome":"","mainContribution":"R2096","mainCompSavings":"R21","mainTotal":"R2117","dependendContributionAdult":"R1894","dependentCompSavingsAdult":"R17","dependentTotalAdult":"R1911","dependendContributionChild":"R755","dependentCompSavingsChild":"R7","dependentTotalChild":"R762","maxChildContribution":"3","mainThreshold":"","dependentThresholdAdult":"","dependentThresholdChild":"","preferedHospitalProvider":"Restricted network hospitals, consist of 29 hospitals) ","overallLimit":"Unlimited at negotiated tariff","coPayment":"All hospital admissions except for emergencies: R13 000\\n\\nSurgical extraction of impacted wisdom teeth: R4 800\\n\\nSpinal surgery: R8 400 (No benefit unless conservative back and neck rehabilitation programme has been completed)\\n\\nAll open hernia surgery: R4 800\\n\\nArthroscopic procedures - knee,\\nshoulder, ankle, hip, wrist and\\nother: R8 500\\n\\nBack and neck procedures: R4 700\\n\\nColonoscopy, upper GI endoscopy, Inguinal hernia sugary: R4 800\\n\\nHysterectomy (unless for cancer): R4 200\\n\\nSingle hip and knee replacements - voluntary non-use of CP: R29 600\\n\\nOther joint replacements and\\ninvoluntary non-use of CP for single hip and knee replacements: R7 100\\n\\nLaparoscopic hernia repairs\\n(bilateral inguinal, repeated inguinal\\nhernias and Nissen/ Toupet\\nhernia repairs only), laparoscopic\\nprocedures, Laparoscopic varicocelectomy: R7 100\\n\\nVaricose vein procedures: R4 800","rate":"Negotiated tariff ","generalMedicin":"7 days' supply","specialist":"Network: Unlimited. Paid in full.\\nNon-network: 100% of Scheme Rate\\nOther Healthcare Professionals: 100% Scheme Rate","dentistSurgical":"Maxillo facial surgery\\nUnlimited, subject to approval\\n\\nIn-hospital dentistry for children under 7:\\nThe hospital and anaesthetist account to be paid from the in-hospital benefit while the dentist�s account to be paid from the day-to-day benefit","mentalHealth":"Psychiatric services: R28 000 per family\\nPMB conditions:\\n21 days in-hospital OR\\n15 psychotherapy sessions out-of-hospital","radiology":"Unlimited at Scheme Rate","pathology":"Unlimited at Scheme Rate","maternityBenefit":"In-hospital: Private ward cover\\nNetwork: Unlimited. Paid in full.\\nNon-network: 100% of Scheme Rate\\nOther Healthcare Professionals: 100% Scheme Rate\\n\\nDoula benefit: R3 000 per delivery \\n\\nOut-of-hospital:\\nAntenatal classes: R1 160 with a midwife \\n12 Ante-or postnatal consultations with a midwife, network gynaecologist or GP\\n4 Postnatal midwife consultations\\n1 amniocentesis test\\n1 Paediatric consultation; without GP referral up to 24 months \\nInfant hearing screening benefit\\n2 x 2D scans per pregnancy\\nPaed-IQ telephonic advice line\\nmyFed Baby Programme\\n- Childhood illness specialised drug benefit for children up to 18","dialysis":"R311 900 per family at DSP\\n40% co-payment for use of non-DSP ","cancer":"R311 900 per family at preferred providers \\nEssential protocol at ICON and tier 1\\nprimary level of care at SAOC\\n40% co-payment if network is not used \\nSpecialised medication: No benefit\\n- Palliative care benefit","transplant":"R311 900 per family \\nCorneal graft: No benefit","mri":"In and Out of Hospital: Unlimited at Scheme Rate\\nFirst R2 480 for non-PMB MRI/CT scans for the member�s account","prosthesisInternal":"Aorta stent grafts: R65 500\\nCardiac pacemakers, cardiac stents, cardiac valves: Unlimited at cost at PMB level of care\\nDetachable platinum coils: R56 700\\nTotal ankle replacement: No benefit\\nIntraocular lenses: R3 500 per lens\\nCombined limit for all unlisted internal prosthesis: R27 900","prosthesisExternal":"External prosthesis:\\nR12 900 at cost\\nAppliances, external accessories and orthotics (In and out of hospital):\\nPaid from Savings/ Wallet or self-funded","rehab":"Nursing services: Unlimited at negotiated tariff\\nSub-acute facilities: Unlimited at cost up to PMB level of care \\nTerminal care: R34 500 ","designatedServiceProvider":"Pharmacy Direct, Clicks Direct Medicines\\nand Dis-Chem Direct","conditionsCovered":"CDL in PMB + 7 ","formulary":"Intermediate formulary","partialLimits":"Acne (up to the age of 21), Allergic rhinitis (up to the age of 18), Eczema (up to the age of 18)\\n\\nUnlimited cover for conditions on the CDL plus allergic rhinitis, acne and eczema.\\n\\nAttention Deficit Hyperactivity Disorder, Depression, Generalised Anxiety Disorder, Post-Traumatic Stress Disorder subject to a limit of R3 200 per family","preferredProvider":"Fedhealth contracted providers","overallAnualLimit":"None","medicationOverCounter":"Paid from Savings\\\\Wallet or self funded\\nAccumulates at cost to Threshold level","medicationPrescribed":"Paid from Savings\\\\Wallet or self funded\\nAccumulates at cost to Threshold level","practitionersGeneral":"Network:\\nPaid from Savings/Wallet, then unlimited at nominated network GP once Threshold has been reached.\\nBeneficiaries can nominate up to two network GPs.\\n2 x mental health consultations per beneficiary per year.\\n2 x network GP consultations per beneficiary for non-nominated GPs allowed per year (referred to as out-of-area) OR\\n2 x non-network GP consultations per beneficiary up to Scheme Rate\\n\\nNon-network:\\nPaid from Savings/Wallet or self-funded. Accumulates at cost to Threshold level","specialistsCover":"Paid from Savings/Wallet or self funded, subject to network GP referral (including PMB conditions)\\nAccumulates at cost to Threshold level","dentistryCover":"Paid from Savings/Wallet or self-funded\\nFollowing benefits will be paid from Threshold once your threshold level has been reached:\\n2 x annual consultations per beneficiary incl. x-rays, scaling, polishing, fillings, extractions and root canal\\nSubject to contracted dentists and limited to a list of approved procedures, dental tariff codes and protocols","dentistryCoverSpecial":"Paid from Savings/Wallet or self-funded\\nAccumulates at cost to Threshold level","optical":"Limited to R1 930 per beneficiary every 24 months, thereafter paid from Savings/Wallet or self-funded","ambulance":"Unlimited with Europ Assistance","international":"International Travel benefit  through AMP\\nR5 million cover","hospitalCoverAids":"Unlimited\\nHIV Management (Aid for AIDS)","artTtreatment":"At preferred providers","preventative":"\\nScreening benefit\\nPap smear\\nProstate Specific Antigen (PSA)\\nChildrens Health (Immunisation programme, HPV vaccine girls 9-14 years )\\nCholesterol screening\\nOver 45's (Breast cancer screening with\\nmammography, Colorectal cancer screening, Pneumococcal vaccination)\\nGeneral (Flu vaccination; HIV test)\\nHealth risk assessments\\nPreventative screening (waist-to-hip ratio, body fat %, flexibility, posture & fitness)\\n\\nFemale contraceptives\\n30 days post hospitalisation benefit\\nUpgrades within 30 days of a life-changing event\\n\\nAdditional services\\nUpgrades within 30 days of a life-changing event\\nHospital at home with Quro Medical\\nCorporate wellness days\\nSisters-on-Site\\nWeight Management Programme\\nGoSmokeFree Smoking Cessation Programme\\nAfA (HIV Management)\\nPaed IQ\\nDiabetes Care\\nSOS Call Me\\n24-hour Nurse Line\\nMeditaxi\\n\\n\\n","logo":"fedhealth.jpg"},{"company":"Fedhealth","name":"FlexiFED 4","planType":"New generation","coverLevel":"Mid","hospital":"Any","chronic":"Network","serviceType":"Network","familyIncome":"","mainContribution":"R3720","mainCompSavings":"R27","mainTotal":"R3747","dependendContributionAdult":"R3375","dependentCompSavingsAdult":"R24","dependentTotalAdult":"R3399","dependendContributionChild":"R1145","dependentCompSavingsChild":"R8","dependentTotalChild":"R1153","maxChildContribution":"3","mainThreshold":"","dependentThresholdAdult":"","dependentThresholdChild":"","preferedHospitalProvider":"Any hospital\\nPartial cover for the following hospitals: Zuid-Afrikaans Hospital, Arwyp Medical Centre, Busamed Modderfontein, Hibiscus\\nHospital, Mooimed Private Hospital, St\\nHelena Private Hospital, Capital Hospital","overallLimit":"Unlimited at negotiated tariff","coPayment":"Surgical extraction of impacted wisdom teeth: R4 800\\n\\nR7 300 co-payment for Elective Procedures\\n\\nSpinal surgery: R6 300 (No benefit unless conservative back and neck rehabilitation programme has been completed)\\n\\nArthroscopic procedures - knee,\\nshoulder, ankle, hip, wrist and\\nother; Colonoscopy, upper GI endoscopy: R2 800\\n \\nBack and neck procedures: R2 600\\n\\nSingle hip and knee replacements - voluntary non-use of CP: R29 600\\n\\nOther joint replacements and\\ninvoluntary non-use of CP for single hip and knee replacements: R4 800\\n\\nLaparoscopic hernia repairs\\n(bilateral inguinal, repeated inguinal\\nhernias and Nissen/ Toupet\\nhernia repairs only), laparoscopic\\nprocedures: R4 800\\n\\nRhizotomies and facet pain\\nblocks (limited to 1 of either\\nprocedure per beneficiary\\nper year): R4 800","rate":"Negotiated tariff ","generalMedicin":"7 days' supply","specialist":"Network: Unlimited. Paid in full.\\nNon-network: 100% of Scheme Rate\\nOther Healthcare Professionals: 100% Scheme Rate","dentistSurgical":"Maxillo facial surgery\\nUnlimited, subject to approval\\n\\nIn-hospital dentistry for children under 7:\\nThe hospital and anaesthetist account to be paid from the in-hospital benefit while the dentist�s account to be paid from the day-to-day benefit","mentalHealth":"Psychiatric services: R28 000 per family\\nPMB conditions:\\n21 days in-hospital OR\\n15 psychotherapy sessions out-of-hospital","radiology":"Unlimited at Scheme Rate","pathology":"Unlimited at Scheme Rate","maternityBenefit":"In-hospital: Private ward cover\\nNetwork: Unlimited. Paid in full.\\nNon-network: 100% of Scheme Rate\\nOther Healthcare Professionals: 100% Scheme Rate\\n\\nDoula benefit: R3 000 per delivery \\n\\nOut-of-hospital:\\nAntenatal classes: R1 160 with a midwife \\n12 Ante-or postnatal consultations with a midwife, network gynaecologist or GP\\n4 Postnatal midwife consultations\\n1 amniocentesis test\\n1 Paediatric consultation; without GP referral up to 24 months \\nInfant hearing screening benefit\\n2 x 2D scans per pregnancy\\nPaed-IQ telephonic advice line\\nmyFed Baby Programme\\n- Childhood illness specialised drug benefit for children up to 18","dialysis":"R499 100 per family at DSP\\n40% co-payment for use of non-DSP ","cancer":"R499 100 per family at preferred providers\\nEssential protocol at ICON and tier 1\\nprimary level of care at SAOC\\n40% co-payment if network is not used \\nSpecialised medication: No benefit\\n- Palliative care benefit","transplant":"R499 100 per family\\nCorneal graft: R36 300 per beneficiary","mri":"In and Out of Hospital: Unlimited at Scheme Rate\\nFirst R2 480 for non-PMB MRI/CT scans for the member�s account","prosthesisInternal":"Aorta stent grafts: R65 500\\nCardiac pacemakers, cardiac stents, cardiac valves: R31 000\\nDetachable platinum coils: R56 700\\nElbow, hip, knee and shoulder replacement: R31 000\\nIntraocular lenses: R3 500 per lens\\nCombined limit for all unlisted internal prosthesis: R27 900","prosthesisExternal":"External prosthesis:\\nR12 900 at cost\\nAppliances, external accessories and orthotics (In and out of hospital):\\nPaid from Savings/ Wallet or self-funded. Does not accumulate to Threshold. Paid from Threshold up to R12 900 per family   (R4 860 sub-limit for foot orthotics)\\n","rehab":"Nursing services: Unlimited at negotiated tariff\\nSub-acute facilities: Unlimited at cost up to PMB level of care \\nTerminal care: R34 500 ","designatedServiceProvider":"Clicks, Dis-Chem, MediRite, Pharmacy Direct, Clicks Direct Medicines\\nand Dis-Chem Direct","conditionsCovered":"CDL in PMB + 19","formulary":"Intermediate formulary","partialLimits":"Acne (up to the age of 21), Allergic rhinitis (up to the age of 18), Ankylosing Spondylitis, Anorexia Nervosa, Attention Deficit, Hyperactivity Disorder (from 6 to age 18), Bulimia Nervosa, Depression, Dermatomyositis, Eczema (up to the age of 18), Generalised Anxiety Disorder, Narcolepsy, Obsessive Compulsive Disorder, Panic Disorder, Paraplegia/ Quadriplegia (associated medicine), Post-Traumatic Stress Disorder, Scleroderma, Tourette�s Syndrome, Benign Prostatic Hyperplasia\\n\\nSubject to a limit of R6 300 per beneficiary,\\nand R12 600 per family ","preferredProvider":"Fedhealth contracted providers","overallAnualLimit":"None","medicationOverCounter":"Paid from Savings\\\\Wallet or self funded\\nDoes not accumulate to or pay from Threshold","medicationPrescribed":"Paid from Savings\\\\Wallet or self funded \\nR6 330 per beneficiary per year  \\nR12 770 per family per year before and after Threshold","practitionersGeneral":"Network:\\nUnlimited at network GP.\\nBeneficiaries can nominate up to two network GPs.\\n2 x mental health consultations per beneficiary per year.\\n2 x network GP consultations per beneficiary for non-nominated GPs allowed per year (referred to as out-of-area) OR\\n2 x non-network GP consultations per beneficiary up to Scheme Rate\\n\\nNon-network:\\nPaid from Savings/\\\\Wallet or self-funded and Threshold. Unlimited accumulation to and refund from Threshold at FR.\\n2 x mental health consultations per\\nbeneficiary per year","specialistsCover":"Specialists excluding psychiatrists\\nNetwork specialists: Paid from Savings/ Wallet or self-funded and\\naccumulation at cost to Threshold.\\nUnlimited at cost once Threshold is\\nreached.\\n20% co-payment if GP referral not obtained\\n\\nNon-Network: Paid from Savings/ Wallet or self-funded and Threshold. \\nAccumulation to and refund from\\nThreshold.\\n20% co-payment if GP referral not obtained.\\n\\nPsychiatrists\\nNetwork: Paid from Savings/ Wallet\\nor self-funded. Does not accumulate to Threshold.\\nPaid from Threshold at cost up to the Additional Medical Services limit of\\nR12 500 per family per year.\\n20% co-payment if GP referral not obtained.\\n\\nNon-Network: Paid from Savings/ Wallet or self-funded.\\nDoes not accumulate to Threshold.\\nPaid up to the Additional Medical\\nServices limit of R12 500 per family per year.\\n20% co-payment if GP referral not obtained","dentistryCover":"Paid from Savings/Wallet or self-funded and Threshold\\nUnlimited once Threshold is reached","dentistryCoverSpecial":"\\nPaid from Savings/Wallet or self-funded and Threshold  \\nR8 270 per beneficiary per year\\nR24 700 per family per year before and after Threshold \\n   ","optical":"Paid from Savings/Wallet or self-funded and Threshold\\nR3 740 per beneficiary per year\\nR11 400 per family per year before and after Threshold\\n\\nOptical screening for children aged 5 to 8 years - 1 per lifetime","ambulance":"Unlimited with Europ Assistance","international":"International Travel benefit  through AMP\\nR5 million cover","hospitalCoverAids":"Unlimited\\nHIV Management (Aid for AIDS)","artTtreatment":"Pharmacy Direct, or a 40% co-payment ","preventative":"\\nScreening benefit\\nPap smear\\nProstate Specific Antigen (PSA)\\nChildrens Health (Immunisation programme, HPV vaccine girls 9-14 years )\\nCholesterol screening\\nOver 45's (Breast cancer screening with\\nmammography, Colorectal cancer screening, Pneumococcal vaccination)\\nGeneral (Flu vaccination; HIV test)\\nHealth risk assessments\\nPreventative screening (waist-to-hip ratio, body fat %, flexibility, posture & fitness)\\n\\nFemale contraceptives\\n30 days post hospitalisation benefit\\nUpgrades within 30 days of a life-changing event\\n\\nAdditional services\\nUpgrades within 30 days of a life-changing event\\nHospital at home with Quro Medical\\nCorporate wellness days\\nSisters-on-Site\\nWeight Management Programme\\nGoSmokeFree Smoking Cessation Programme\\nAfA (HIV Management)\\nPaed IQ\\nDiabetes Care\\nSOS Call Me\\n24-hour Nurse Line\\nMeditaxi\\n\\n\\n","logo":"fedhealth.jpg"},{"company":"Fedhealth","name":"FlexiFED 4 Grid","planType":"Threshold option","coverLevel":"Mid","hospital":"Network","chronic":"Network","serviceType":"Network","familyIncome":"","mainContribution":"R3302","mainCompSavings":"R24","mainTotal":"R3326","dependendContributionAdult":"R3003","dependentCompSavingsAdult":"R22","dependentTotalAdult":"R3025","dependendContributionChild":"R1020","dependentCompSavingsChild":"R7","dependentTotalChild":"R1027","maxChildContribution":"3","mainThreshold":"M: R14 700\\nM+1: R26 700\\nM+2: R30 300\\nM+2+: R33 900","dependentThresholdAdult":"","dependentThresholdChild":"","preferedHospitalProvider":"Network (Fedhealth Network Hospitals)","overallLimit":"Unlimited at negotiated tariff","coPayment":"Voluntary use of non-network hospitals: R13 000\\n\\nVoluntary use of  non-network day surgery facility: R2 100\\n\\nSurgical extraction of impacted wisdom teeth: R4 800\\n\\nSpinal surgery: R6 300 (No benefit unless conservative back and neck rehabilitation programme has been completed)\\n\\nArthroscopic procedures - knee,\\nshoulder, ankle, hip, wrist and\\nother; Colonoscopy, upper GI endoscopy: R2 800\\n \\nBack and neck procedures: R2 600\\n\\nSingle hip and knee replacements - voluntary non-use of CP: R29 600\\n\\nOther joint replacements and\\ninvoluntary non-use of CP for single hip and knee replacements: R4 800\\n\\nLaparoscopic hernia repairs\\n(bilateral inguinal, repeated inguinal\\nhernias and Nissen/ Toupet\\nhernia repairs only), laparoscopic\\nprocedures: R4 800\\n\\nRhizotomies and facet pain\\nblocks (limited to 1 of either\\nprocedure per beneficiary\\nper year): R4 800","rate":"Negotiated tariff ","generalMedicin":"7 days' supply","specialist":"Network: Unlimited. Paid in full.\\nNon-network: 100% of Scheme Rate\\nOther Healthcare Professionals: 100% Scheme Rate","dentistSurgical":"Maxillo facial surgery\\nUnlimited, subject to approval\\n\\nIn-hospital dentistry for children under 7:\\nThe hospital and anaesthetist account to be paid from the in-hospital benefit while the dentist�s account to be paid from the day-to-day benefit","mentalHealth":"Psychiatric services: R28 000 per family\\nPMB conditions:\\n21 days in-hospital OR\\n15 psychotherapy sessions out-of-hospital","radiology":"Unlimited at Scheme Rate","pathology":"Unlimited at Scheme Rate","maternityBenefit":"In-hospital: Private ward cover\\nNetwork: Unlimited. Paid in full.\\nNon-network: 100% of Scheme Rate\\nOther Healthcare Professionals: 100% Scheme Rate\\n\\nDoula benefit: R3 000 per delivery \\n\\nOut-of-hospital:\\nAntenatal classes: R1 160 with a midwife \\n12 Ante-or postnatal consultations with a midwife, network gynaecologist or GP\\n4 Postnatal midwife consultations\\n1 amniocentesis test\\n1 Paediatric consultation; without GP referral up to 24 months \\nInfant hearing screening benefit\\n2 x 2D scans per pregnancy\\nPaed-IQ telephonic advice line\\nmyFed Baby Programme\\n- Childhood illness specialised drug benefit for children up to 18","dialysis":"R499 100 per family at DSP\\n40% co-payment for use of non-DSP ","cancer":"R499 100 per family at preferred providers\\nEssential protocol at ICON and tier 1\\nprimary level of care at SAOC\\n40% co-payment if network is not used \\nSpecialised medication: No benefit\\n- Palliative care benefit","transplant":"R499 100 per family\\nCorneal graft: R36 300 per beneficiary","mri":"In and Out of Hospital: Unlimited at Scheme Rate\\nFirst R2 480 for non-PMB MRI/CT scans for the member�s account","prosthesisInternal":"Aorta stent grafts: R65 500\\nCardiac pacemakers, cardiac stents, cardiac valves: R31 000\\nDetachable platinum coils: R56 700\\nElbow, hip, knee and shoulder replacement: R31 000\\nIntraocular lenses: R3 500 per lens\\nCombined limit for all unlisted internal prosthesis: R27 900","prosthesisExternal":"External prosthesis:\\nR12 900 at cost\\nAppliances, external accessories and orthotics (In and out of hospital):\\nPaid from Savings/ Wallet or self-funded. Does not accumulate to Threshold. Paid from Threshold up to R12 900 per family    (R4 860 sub-limit for foot orthotics)\\n","rehab":"Nursing services: Unlimited at negotiated tariff\\nSub-acute facilities: Unlimited at cost up to PMB level of care \\nTerminal care: R34 500 ","designatedServiceProvider":"Clicks, Dis-Chem, MediRite, Pharmacy Direct, Clicks Direct Medicines\\nand Dis-Chem Direct","conditionsCovered":"CDL in PMB + 19","formulary":"Intermediate formulary","partialLimits":"Acne (up to the age of 21), Allergic rhinitis (up to the age of 18), Ankylosing Spondylitis, Anorexia Nervosa, Attention Deficit, Hyperactivity Disorder (from 6 to age 18), Bulimia Nervosa, Depression, Dermatomyositis, Eczema (up to the age of 18), Generalised Anxiety Disorder, Narcolepsy, Obsessive Compulsive Disorder, Panic Disorder, Paraplegia/ Quadriplegia (associated medicine), Post-Traumatic Stress Disorder, Scleroderma, Tourette�s Syndrome, Benign Prostatic Hyperplasia\\n\\nSubject to a limit of R6 300 per beneficiary,\\nand R12 600 per family ","preferredProvider":"Fedhealth contracted providers","overallAnualLimit":"None","medicationOverCounter":"Paid from Savings\\\\Wallet or self funded\\nDoes not accumulate to or pay from Threshold","medicationPrescribed":"Paid from Savings\\\\Wallet or self funded \\nR6 330 per beneficiary per year  \\nR12 770 per family per year before and after Threshold","practitionersGeneral":"Network:\\nUnlimited at nominated network GP.\\nBeneficiaries can nominate up to two network GPs.\\n2 x mental health consultations per beneficiary per year.\\n2 x network GP consultations per beneficiary for non-nominated GPs allowed per year (referred to as out-of-area) OR\\n2 x non-network GP consultations per beneficiary up to Scheme Rate\\n\\nNon-network:\\nPaid from Savings/\\\\Wallet or self-funded and Threshold. Unlimited accumulation to and refund from Threshold at FR.\\n2 x mental health consultations per\\nbeneficiary per year","specialistsCover":"Specialists excluding psychiatrists\\nNetwork specialists: Paid from Savings/ Wallet or self-funded and\\naccumulation at cost to Threshold.\\nUnlimited at cost once Threshold is\\nreached.\\n20% co-payment if GP referral not obtained\\n\\nNon-Network: Paid from Savings/ Wallet or self-funded and Threshold. \\nAccumulation to and refund from\\nThreshold.\\n20% co-payment if GP referral not obtained.\\n\\nPsychiatrists\\nNetwork: Paid from Savings/ Wallet\\nor self-funded. Does not accumulate to Threshold.\\nPaid from Threshold at cost up to the Additional Medical Services limit of\\nR12 500 per family per year.\\n20% co-payment if GP referral not obtained.\\n\\nNon-Network: Paid from Savings/ Wallet or self-funded.\\nDoes not accumulate to Threshold.\\nPaid up to the Additional Medical\\nServices limit of R12 500 per family per year.\\n20% co-payment if GP referral not obtained","dentistryCover":"Paid from Savings/Wallet or self-funded and Threshold\\nUnlimited once Threshold is reached","dentistryCoverSpecial":"\\nPaid from Savings/Wallet or self-funded and Threshold  \\nR8 270 per beneficiary per year\\nR24 700 per family per year before and after Threshold \\n   ","optical":"Paid from Savings/Wallet or self-funded and Threshold\\nR3 740 per beneficiary per year\\nR11 400 per family per year before and after Threshold\\n\\nOptical screening for children aged 5 to 8 years - 1 per lifetime","ambulance":"Unlimited with Europ Assistance","international":"International Travel benefit  through AMP\\nR5 million cover","hospitalCoverAids":"Unlimited\\nHIV Management (Aid for AIDS)","artTtreatment":"Pharmacy Direct, or a 40% co-payment ","preventative":"\\nScreening benefit\\nPap smear\\nProstate Specific Antigen (PSA)\\nChildrens Health (Immunisation programme, HPV vaccine girls 9-14 years )\\nCholesterol screening\\nOver 45's (Breast cancer screening with\\nmammography, Colorectal cancer screening, Pneumococcal vaccination)\\nGeneral (Flu vaccination; HIV test)\\nHealth risk assessments\\nPreventative screening (waist-to-hip ratio, body fat %, flexibility, posture & fitness)\\n\\nFemale contraceptives\\n30 days post hospitalisation benefit\\nUpgrades within 30 days of a life-changing event\\n\\nAdditional services\\nUpgrades within 30 days of a life-changing event\\nHospital at home with Quro Medical\\nCorporate wellness days\\nSisters-on-Site\\nWeight Management Programme\\nGoSmokeFree Smoking Cessation Programme\\nAfA (HIV Management)\\nPaed IQ\\nDiabetes Care\\nSOS Call Me\\n24-hour Nurse Line\\nMeditaxi\\n\\n\\n","logo":"fedhealth.jpg"},{"company":"Fedhealth","name":"FlexiFED 4 Elect","planType":"Threshold option","coverLevel":"Mid","hospital":"Network","chronic":"Network","serviceType":"Network","familyIncome":"","mainContribution":"R2785","mainCompSavings":"R21","mainTotal":"R2806","dependendContributionAdult":"R2580","dependentCompSavingsAdult":"R18","dependentTotalAdult":"R2598","dependendContributionChild":"R875","dependentCompSavingsChild":"R6","dependentTotalChild":"R881","maxChildContribution":"3","mainThreshold":"M: R14 700\\nM+1: R26 700\\nM+2: R30 300\\nM+2+: R33 900","dependentThresholdAdult":"","dependentThresholdChild":"","preferedHospitalProvider":"Restricted network hospitals, consist of 29 hospitals) ","overallLimit":"Unlimited at negotiated tariff","coPayment":"All hospital admissions except for emergencies: R12 500\\n\\nSurgical extraction of impacted wisdom teeth: R4 800\\n\\nSpinal surgery: R6 300 (No benefit unless conservative back and neck rehabilitation programme has been completed)\\n\\nArthroscopic procedures - knee,\\nshoulder, ankle, hip, wrist and\\nother; Colonoscopy, upper GI endoscopy: R2 800\\n \\nBack and neck procedures: R2 600\\n\\nSingle hip and knee replacements - voluntary non-use of CP: R29 600\\n\\nOther joint replacements and\\ninvoluntary non-use of CP for single hip and knee replacements: R4 800\\n\\nLaparoscopic hernia repairs\\n(bilateral inguinal, repeated inguinal\\nhernias and Nissen/ Toupet\\nhernia repairs only), laparoscopic\\nprocedures: R4 800\\n\\nRhizotomies and facet pain\\nblocks (limited to 1 of either\\nprocedure per beneficiary\\nper year): R4 600","rate":"Negotiated tariff ","generalMedicin":"7 days' supply","specialist":"Network: Unlimited. Paid in full.\\nNon-network: 100% of Scheme Rate\\nOther Healthcare Professionals: 100% Scheme Rate","dentistSurgical":"Maxillo facial surgery\\nUnlimited, subject to approval\\n\\nIn-hospital dentistry for children under 7:\\nThe hospital and anaesthetist account to be paid from the in-hospital benefit while the dentist�s account to be paid from the day-to-day benefit","mentalHealth":"Psychiatric services: R28 000 per family\\nPMB conditions:\\n21 days in-hospital OR\\n15 psychotherapy sessions out-of-hospital","radiology":"Unlimited at Scheme Rate","pathology":"Unlimited at Scheme Rate","maternityBenefit":"In-hospital: Private ward cover\\nNetwork: Unlimited. Paid in full.\\nNon-network: 100% of Scheme Rate\\nOther Healthcare Professionals: 100% Scheme Rate\\n\\nDoula benefit: R3 000 per delivery \\n\\nOut-of-hospital:\\nAntenatal classes: R1 160 with a midwife \\n12 Ante-or postnatal consultations with a midwife, network gynaecologist or GP\\n4 Postnatal midwife consultations\\n1 amniocentesis test\\n1 Paediatric consultation; without GP referral up to 24 months \\nInfant hearing screening benefit\\n2 x 2D scans per pregnancy\\nPaed-IQ telephonic advice line\\nmyFed Baby Programme\\n- Childhood illness specialised drug benefit for children up to 18","dialysis":"R499 100 per family at DSP\\n40% co-payment for use of non-DSP ","cancer":"R499 100 per family at preferred providers\\nEssential protocol at ICON and tier 1\\nprimary level of care at SAOC\\n40% co-payment if network is not used \\nSpecialised medication: No benefit\\n- Palliative care benefit","transplant":"R499 100 per family\\nCorneal graft: R36 300 per beneficiary","mri":"In and Out of Hospital: Unlimited at Scheme Rate\\nFirst R2 480 for non-PMB MRI/CT scans for the member�s account","prosthesisInternal":"Aorta stent grafts: R65 500\\nCardiac pacemakers, cardiac stents, cardiac valves: R31 000\\nDetachable platinum coils: R56 700\\nElbow, hip, knee and shoulder replacement: R31 000\\nIntraocular lenses: R3 500 per lens\\nCombined limit for all unlisted internal prosthesis: R27 900","prosthesisExternal":"External prosthesis:\\nR12 900 at cost\\nAppliances, external accessories and orthotics (In and out of hospital):\\nPaid from Savings/ Wallet or self-funded. Does not accumulate to Threshold. Paid from Threshold up to R12 900 per family   (R4 860 sub-limit for foot orthotics)\\n","rehab":"Nursing services: Unlimited at negotiated tariff\\nSub-acute facilities: Unlimited at cost up to PMB level of care \\nTerminal care: R34 500 ","designatedServiceProvider":"Pharmacy Direct, Clicks Direct Medicines\\nand Dis-Chem Direct","conditionsCovered":"CDL in PMB + 19","formulary":"Intermediate formulary","partialLimits":"Acne (up to the age of 21), Allergic rhinitis (up to the age of 18), Ankylosing Spondylitis, Anorexia Nervosa, Attention Deficit, Hyperactivity Disorder (from 6 to age 18), Bulimia Nervosa, Depression, Dermatomyositis, Eczema (up to the age of 18), Generalised Anxiety Disorder, Narcolepsy, Obsessive Compulsive Disorder, Panic Disorder, Paraplegia/ Quadriplegia (associated medicine), Post-Traumatic Stress Disorder, Scleroderma, Tourette�s Syndrome, Benign Prostatic Hyperplasia\\n\\nSubject to a limit of R6 300 per beneficiary,\\nand R12 600 per family ","preferredProvider":"Fedhealth contracted providers","overallAnualLimit":"None","medicationOverCounter":"Paid from Savings\\\\Wallet or self funded\\nDoes not accumulate to or pay from Threshold","medicationPrescribed":"Paid from Savings\\\\Wallet or self funded \\nR6 330 per beneficiary per year  \\nR12 770 per family per year before and after Threshold","practitionersGeneral":"Network:\\nUnlimited at nominated network GP.\\nBeneficiaries can nominate up to two network GPs.\\n2 x mental health consultations per beneficiary per year.\\n2 x network GP consultations per beneficiary for non-nominated GPs allowed per year (referred to as out-of-area) OR\\n2 x non-network GP consultations per beneficiary up to Scheme Rate\\n\\nNon-network:\\nPaid from Savings/\\\\Wallet or self-funded and Threshold. Unlimited accumulation to and refund from Threshold at FR.\\n2 x mental health consultations per\\nbeneficiary per year","specialistsCover":"Specialists excluding psychiatrists\\nNetwork specialists: Paid from Savings/ Wallet or self-funded and\\naccumulation at cost to Threshold.\\nUnlimited at cost once Threshold is\\nreached.\\n20% co-payment if GP referral not obtained\\n\\nNon-Network: Paid from Savings/ Wallet or self-funded and Threshold. \\nAccumulation to and refund from\\nThreshold.\\n20% co-payment if GP referral not obtained.\\n\\nPsychiatrists\\nNetwork: Paid from Savings/ Wallet\\nor self-funded. Does not accumulate to Threshold.\\nPaid from Threshold at cost up to the Additional Medical Services limit of\\nR12 500 per family per year.\\n20% co-payment if GP referral not obtained.\\n\\nNon-Network: Paid from Savings/ Wallet or self-funded.\\nDoes not accumulate to Threshold.\\nPaid up to the Additional Medical\\nServices limit of R12 500 per family per year.\\n20% co-payment if GP referral not obtained","dentistryCover":"Paid from Savings/Wallet or self-funded and Threshold\\nUnlimited once Threshold is reached","dentistryCoverSpecial":"\\nPaid from Savings/Wallet or self-funded and Threshold  \\nR8 270 per beneficiary per year\\nR24 700 per family per year before and after Threshold \\n   ","optical":"Paid from Savings/Wallet or self-funded and Threshold\\nR3 740 per beneficiary per year\\nR11 400 per family per year before and after Threshold\\n\\nOptical screening for children aged 5 to 8 years - 1 per lifetime","ambulance":"Unlimited with Europ Assistance","international":"International Travel benefit  through AMP\\nR5 million cover","hospitalCoverAids":"Unlimited\\nHIV Management (Aid for AIDS)","artTtreatment":"Pharmacy Direct, or a 40% co-payment ","preventative":"\\nScreening benefit\\nPap smear\\nProstate Specific Antigen (PSA)\\nChildrens Health (Immunisation programme, HPV vaccine girls 9-14 years )\\nCholesterol screening\\nOver 45's (Breast cancer screening with\\nmammography, Colorectal cancer screening, Pneumococcal vaccination)\\nGeneral (Flu vaccination; HIV test)\\nHealth risk assessments\\nPreventative screening (waist-to-hip ratio, body fat %, flexibility, posture & fitness)\\n\\nFemale contraceptives\\n30 days post hospitalisation benefit\\nUpgrades within 30 days of a life-changing event\\n\\nAdditional services\\nUpgrades within 30 days of a life-changing event\\nHospital at home with Quro Medical\\nCorporate wellness days\\nSisters-on-Site\\nWeight Management Programme\\nGoSmokeFree Smoking Cessation Programme\\nAfA (HIV Management)\\nPaed IQ\\nDiabetes Care\\nSOS Call Me\\n24-hour Nurse Line\\nMeditaxi\\n\\n\\n","logo":"fedhealth.jpg"},{"company":"Fedhealth","name":"MyFed","planType":"Capitation","coverLevel":"Low","hospital":"Network","chronic":"Network","serviceType":"Network","familyIncome":"0 - R6 251","mainContribution":"R1128","mainCompSavings":"R0.00","mainTotal":"R1128","dependendContributionAdult":"R985","dependentCompSavingsAdult":"R0.00","dependentTotalAdult":"R985","dependendContributionChild":"R543","dependentCompSavingsChild":"R0.00","dependentTotalChild":"R543","maxChildContribution":"","mainThreshold":"","dependentThresholdAdult":"","dependentThresholdChild":"","preferedHospitalProvider":"Network (Fedhealth Network Hospitals)","overallLimit":"Unlimited (at network hospitals only) ","coPayment":"R13 000 co-pay for voluntary use of non-network hospitals\\nR2 000 co-payment on voluntary use of non-network Day Clinics","rate":"Negotiated tariff ","generalMedicin":"7 days' supply","specialist":"Network GPs and Specialists: covered in full\\nNon-network GPs and Specialists: 100% of Scheme Rate (R2 500 per beneficiary)\\nOther Healthcare Professionals: 100% Scheme Rate","dentistSurgical":"No benefit","mentalHealth":"             \\nPMB conditions: Up to 21 days in-hospital OR up to 15 psychotherapy sessions out-of-hospital\\nPsychiatric services: R9 700","radiology":"Unlimited at Scheme Rate","pathology":"Unlimited ","maternityBenefit":"Unlimited at cost at PMB level of care\\nElective Caesarean Section: subject to R12 900 co-payment\\nScans: as per radiology benefit\\n4 Postnatal midwife consultations \\nInfant hearing screening benefit\\nPaed-IQ telephonic advice line\\nmyFed baby programme","dialysis":"Unlimited at cost, PMB level of care\\n40% co-payment for use of non-DSP \\n- Palliative care benefit","cancer":"Subject to level 1 treatment protocols                   \\nPMBs only at ICON(SOAC)\\n25% co-payment for use non-Oncology Pharmacy\\nNetwork","transplant":"Unlimited at cost, PMB level of care","mri":"In hospital: R15 030 per beneficiary, \\nmaximum of R30 300 per family per year. \\nOut of Hospital: No benefit","prosthesisInternal":"Unlimited at cost, PMB level of care","prosthesisExternal":"Unlimited at cost, PMB level of care","rehab":"Alternatives to Hospitalisation: \\nUnlimited at cost, PMB level of care   \\nHospice Care: No benefit\\nPalliative care benefit","designatedServiceProvider":"\\nClicks, Dis-Chem, Medirite, Pharmacy Direct, Clicks Direct Medicines, Dis-Chem Direct and Medirite Courier Pharmacy, non-DSP or non-formulary, 40% co-payment applies","conditionsCovered":"CDL in PMB ","formulary":"Basic formulary","partialLimits":"None","preferredProvider":"Fedhealth contracted providers","overallAnualLimit":"N/A","medicationOverCounter":"No benefit","medicationPrescribed":"Unlimited at dispensing contracted GP\\nNon-Dispensing GP: Unlimited, subject formulary","practitionersGeneral":"Unlimited at nominated, contracted GP\\nBeneficiaries can nominate up to two network GPs\\nPre-auth required after 10th visit\\n2x mental health visits per beneficiary\\nUp to 2 myFED network GP consultations per beneficiary for non-nominated GPs allowed per year (referred to as out-of-area)\\nNon-network: No benefit","specialistsCover":"2 consultations, limited to R2 000 per family  (No   GP referral , 40% co-payment applies)\\nNon-network Specialist: No benefit\\n\\n","dentistryCover":"Subject to a contracted list of dentists and limited to a list of approved procedures and dental tariff codes\\nPlastic dentures: Limited to 1 set per beneficiary every two years","dentistryCoverSpecial":"No benefit","optical":"Subject to ISO Leso network optometrist\\nFrame: R230 or R230 off any other frame\\n1 pair of single vision clear CR39 lenses or 1 pair of bifocal CR39 lenses\\n1 Comprehensive consultation\\nBenefit available every 2 years per beneficiary","ambulance":"Unlimited with Europ Assistance","international":"International travel benefit through AMP, R5 million cover","hospitalCoverAids":"Unlimited at cost, PMB level of care \\nHIV Management (Aid for AIDS)","artTtreatment":"Pharmacy Direct, or a 40% co-payment ","preventative":"Screening benefit\\nProstate Specific Antigen (PSA)\\nGeneral (Flu vaccination; HIV test)\\nHealth risk assessments (Wellness screening; Preventative screening)\\n\\nFemale contraception benefit\\n\\nAdditional services\\nHospital at home with Quro Medical\\nCorporate wellness days\\nSisters-on-Site\\nWeight Management Programme\\nGoSmokeFree Smoking Cessation Programme\\nAfA (HIV Management)\\nDiabetes Care\\nSOS Call Me\\n24-hour Nurse Line\\nMeditaxi\\nContraceptives subject to formulary\\n\\n","logo":"fedhealth.jpg"},{"company":"Fedhealth","name":"MyFed","planType":"Capitation","coverLevel":"Low","hospital":"Network","chronic":"Network","serviceType":"Network","familyIncome":"R6 252 - R10 219","mainContribution":"R1430","mainCompSavings":"R0.00","mainTotal":"R1430","dependendContributionAdult":"R1242","dependentCompSavingsAdult":"R0.00","dependentTotalAdult":"R1242","dependendContributionChild":"R699","dependentCompSavingsChild":"R0.00","dependentTotalChild":"R699","maxChildContribution":"","mainThreshold":"","dependentThresholdAdult":"","dependentThresholdChild":"","preferedHospitalProvider":"Network (Fedhealth Network Hospitals)","overallLimit":"Unlimited (at network hospitals only) ","coPayment":"R13 000 co-pay for voluntary use of non-network hospitals\\nR2 000 co-payment on voluntary use of non-network Day Clinics","rate":"Negotiated tariff ","generalMedicin":"7 days' supply","specialist":"Network GPs and Specialists: covered in full\\nNon-network GPs and Specialists: 100% of Scheme Rate (R2 500 per beneficiary)\\nOther Healthcare Professionals: 100% Scheme Rate","dentistSurgical":"No benefit","mentalHealth":"             \\nPMB conditions: Up to 21 days in-hospital OR up to 15 psychotherapy sessions out-of-hospital\\nPsychiatric services: R9 700","radiology":"Unlimited at Scheme Rate","pathology":"Unlimited ","maternityBenefit":"Unlimited at cost at PMB level of care\\nElective Caesarean Section: subject to R12 900 co-payment\\nScans: as per radiology benefit\\n4 Postnatal midwife consultations \\nInfant hearing screening benefit\\nPaed-IQ telephonic advice line\\nmyFed baby programme","dialysis":"Unlimited at cost, PMB level of care\\n40% co-payment for use of non-DSP \\n- Palliative care benefit","cancer":"Subject to level 1 treatment protocols                   \\nPMBs only at ICON(SOAC)\\n25% co-payment for use non-Oncology Pharmacy\\nNetwork","transplant":"Unlimited at cost, PMB level of care","mri":"In hospital: R15 030 per beneficiary, \\nmaximum of R30 300 per family per year. \\nOut of Hospital: No benefit","prosthesisInternal":"Unlimited at cost, PMB level of care","prosthesisExternal":"Unlimited at cost, PMB level of care","rehab":"Alternatives to Hospitalisation: \\nUnlimited at cost, PMB level of care   \\nHospice Care: No benefit\\nPalliative care benefit","designatedServiceProvider":"\\nClicks, Dis-Chem, Medirite, Pharmacy Direct, Clicks Direct Medicines, Dis-Chem Direct and Medirite Courier Pharmacy, non-DSP or non-formulary, 40% co-payment applies","conditionsCovered":"CDL in PMB ","formulary":"Basic formulary","partialLimits":"None","preferredProvider":"Fedhealth contracted providers","overallAnualLimit":"N/A","medicationOverCounter":"No benefit","medicationPrescribed":"Unlimited at dispensing contracted GP\\nNon-Dispensing GP: Unlimited, subject formulary","practitionersGeneral":"Unlimited at nominated, contracted GP\\nBeneficiaries can nominate up to two network GPs\\nPre-auth required after 10th visit\\n2x mental health visits per beneficiary\\nUp to 2 myFED network GP consultations per beneficiary for non-nominated GPs allowed per year (referred to as out-of-area)\\nNon-network: No benefit","specialistsCover":"2 consultations, limited to R2 000 per family  (No   GP referral , 40% co-payment applies)\\nNon-network Specialist: No benefit\\n\\n","dentistryCover":"Subject to a contracted list of dentists and limited to a list of approved procedures and dental tariff codes\\nPlastic dentures: Limited to 1 set per beneficiary every two years","dentistryCoverSpecial":"No benefit","optical":"Subject to ISO Leso network optometrist\\nFrame: R230 or R230 off any other frame\\n1 pair of single vision clear CR39 lenses or 1 pair of bifocal CR39 lenses\\n1 Comprehensive consultation\\nBenefit available every 2 years per beneficiary","ambulance":"Unlimited with Europ Assistance","international":"International travel benefit through AMP, R5 million cover","hospitalCoverAids":"Unlimited at cost, PMB level of care \\nHIV Management (Aid for AIDS)","artTtreatment":"Pharmacy Direct, or a 40% co-payment ","preventative":"Screening benefit\\nProstate Specific Antigen (PSA)\\nGeneral (Flu vaccination; HIV test)\\nHealth risk assessments (Wellness screening; Preventative screening)\\n\\nFemale contraception benefit\\n\\nAdditional services\\nHospital at home with Quro Medical\\nCorporate wellness days\\nSisters-on-Site\\nWeight Management Programme\\nGoSmokeFree Smoking Cessation Programme\\nAfA (HIV Management)\\nDiabetes Care\\nSOS Call Me\\n24-hour Nurse Line\\nMeditaxi\\nContraceptives subject to formulary\\n\\n","logo":"fedhealth.jpg"},{"company":"Fedhealth","name":"MyFed","planType":"Capitation","coverLevel":"Low","hospital":"Network","chronic":"Network","serviceType":"Network","familyIncome":"R10 220 - R12 622","mainContribution":"R2005","mainCompSavings":"R0.00","mainTotal":"R2005","dependendContributionAdult":"R1750","dependentCompSavingsAdult":"R0.00","dependentTotalAdult":"R1750","dependendContributionChild":"R769","dependentCompSavingsChild":"R0.00","dependentTotalChild":"R769","maxChildContribution":"","mainThreshold":"","dependentThresholdAdult":"","dependentThresholdChild":"","preferedHospitalProvider":"Network (Fedhealth Network Hospitals)","overallLimit":"Unlimited (at network hospitals only) ","coPayment":"R13 000 co-pay for voluntary use of non-network hospitals\\nR2 000 co-payment on voluntary use of non-network Day Clinics","rate":"Negotiated tariff ","generalMedicin":"7 days' supply","specialist":"Network GPs and Specialists: covered in full\\nNon-network GPs and Specialists: 100% of Scheme Rate (R2 500 per beneficiary)\\nOther Healthcare Professionals: 100% Scheme Rate","dentistSurgical":"No benefit","mentalHealth":"             \\nPMB conditions: Up to 21 days in-hospital OR up to 15 psychotherapy sessions out-of-hospital\\nPsychiatric services: R9 700","radiology":"Unlimited at Scheme Rate","pathology":"Unlimited ","maternityBenefit":"Unlimited at cost at PMB level of care\\nElective Caesarean Section: subject to R12 900 co-payment\\nScans: as per radiology benefit\\n4 Postnatal midwife consultations \\nInfant hearing screening benefit\\nPaed-IQ telephonic advice line\\nmyFed baby programme","dialysis":"Unlimited at cost, PMB level of care\\n40% co-payment for use of non-DSP \\n- Palliative care benefit","cancer":"Subject to level 1 treatment protocols                   \\nPMBs only at ICON(SOAC)\\n25% co-payment for use non-Oncology Pharmacy\\nNetwork","transplant":"Unlimited at cost, PMB level of care","mri":"In hospital: R15 030 per beneficiary, \\nmaximum of R30 300 per family per year. \\nOut of Hospital: No benefit","prosthesisInternal":"Unlimited at cost, PMB level of care","prosthesisExternal":"Unlimited at cost, PMB level of care","rehab":"Alternatives to Hospitalisation: \\nUnlimited at cost, PMB level of care   \\nHospice Care: No benefit\\nPalliative care benefit","designatedServiceProvider":"\\nClicks, Dis-Chem, Medirite, Pharmacy Direct, Clicks Direct Medicines, Dis-Chem Direct and Medirite Courier Pharmacy, non-DSP or non-formulary, 40% co-payment applies","conditionsCovered":"CDL in PMB ","formulary":"Basic formulary","partialLimits":"None","preferredProvider":"Fedhealth contracted providers","overallAnualLimit":"N/A","medicationOverCounter":"No benefit","medicationPrescribed":"Unlimited at dispensing contracted GP\\nNon-Dispensing GP: Unlimited, subject formulary","practitionersGeneral":"Unlimited at nominated, contracted GP\\nBeneficiaries can nominate up to two network GPs\\nPre-auth required after 10th visit\\n2x mental health visits per beneficiary\\nUp to 2 myFED network GP consultations per beneficiary for non-nominated GPs allowed per year (referred to as out-of-area)\\nNon-network: No benefit","specialistsCover":"2 consultations, limited to R2 000 per family  (No   GP referral , 40% co-payment applies)\\nNon-network Specialist: No benefit\\n\\n","dentistryCover":"Subject to a contracted list of dentists and limited to a list of approved procedures and dental tariff codes\\nPlastic dentures: Limited to 1 set per beneficiary every two years","dentistryCoverSpecial":"No benefit","optical":"Subject to ISO Leso network optometrist\\nFrame: R230 or R230 off any other frame\\n1 pair of single vision clear CR39 lenses or 1 pair of bifocal CR39 lenses\\n1 Comprehensive consultation\\nBenefit available every 2 years per beneficiary","ambulance":"Unlimited with Europ Assistance","international":"International travel benefit through AMP, R5 million cover","hospitalCoverAids":"Unlimited at cost, PMB level of care \\nHIV Management (Aid for AIDS)","artTtreatment":"Pharmacy Direct, or a 40% co-payment ","preventative":"Screening benefit\\nProstate Specific Antigen (PSA)\\nGeneral (Flu vaccination; HIV test)\\nHealth risk assessments (Wellness screening; Preventative screening)\\n\\nFemale contraception benefit\\n\\nAdditional services\\nHospital at home with Quro Medical\\nCorporate wellness days\\nSisters-on-Site\\nWeight Management Programme\\nGoSmokeFree Smoking Cessation Programme\\nAfA (HIV Management)\\nDiabetes Care\\nSOS Call Me\\n24-hour Nurse Line\\nMeditaxi\\nContraceptives subject to formulary\\n\\n","logo":"fedhealth.jpg"},{"company":"Fedhealth","name":"MyFed","planType":"Capitation","coverLevel":"Low","hospital":"Network","chronic":"Network","serviceType":"Network","familyIncome":"R12 623 - R14 426","mainContribution":"R2547","mainCompSavings":"R0.00","mainTotal":"R2547","dependendContributionAdult":"R2100","dependentCompSavingsAdult":"R0.00","dependentTotalAdult":"R2100","dependendContributionChild":"R996","dependentCompSavingsChild":"R0.00","dependentTotalChild":"R996","maxChildContribution":"","mainThreshold":"","dependentThresholdAdult":"","dependentThresholdChild":"","preferedHospitalProvider":"Network (Fedhealth Network Hospitals)","overallLimit":"Unlimited (at network hospitals only) ","coPayment":"R13 000 co-pay for voluntary use of non-network hospitals\\nR2 000 co-payment on voluntary use of non-network Day Clinics","rate":"Negotiated tariff ","generalMedicin":"7 days' supply","specialist":"Network GPs and Specialists: covered in full\\nNon-network GPs and Specialists: 100% of Scheme Rate (R2 500 per beneficiary)\\nOther Healthcare Professionals: 100% Scheme Rate","dentistSurgical":"No benefit","mentalHealth":"             \\nPMB conditions: Up to 21 days in-hospital OR up to 15 psychotherapy sessions out-of-hospital\\nPsychiatric services: R9 700","radiology":"Unlimited at Scheme Rate","pathology":"Unlimited ","maternityBenefit":"Unlimited at cost at PMB level of care\\nElective Caesarean Section: subject to R12 900 co-payment\\nScans: as per radiology benefit\\n4 Postnatal midwife consultations \\nInfant hearing screening benefit\\nPaed-IQ telephonic advice line\\nmyFed baby programme","dialysis":"Unlimited at cost, PMB level of care\\n40% co-payment for use of non-DSP \\n- Palliative care benefit","cancer":"Subject to level 1 treatment protocols                   \\nPMBs only at ICON(SOAC)\\n25% co-payment for use non-Oncology Pharmacy\\nNetwork","transplant":"Unlimited at cost, PMB level of care","mri":"In hospital: R15 030 per beneficiary, \\nmaximum of R30 300 per family per year. \\nOut of Hospital: No benefit","prosthesisInternal":"Unlimited at cost, PMB level of care","prosthesisExternal":"Unlimited at cost, PMB level of care","rehab":"Alternatives to Hospitalisation: \\nUnlimited at cost, PMB level of care   \\nHospice Care: No benefit\\nPalliative care benefit","designatedServiceProvider":"\\nClicks, Dis-Chem, Medirite, Pharmacy Direct, Clicks Direct Medicines, Dis-Chem Direct and Medirite Courier Pharmacy, non-DSP or non-formulary, 40% co-payment applies","conditionsCovered":"CDL in PMB ","formulary":"Basic formulary","partialLimits":"None","preferredProvider":"Fedhealth contracted providers","overallAnualLimit":"N/A","medicationOverCounter":"No benefit","medicationPrescribed":"Unlimited at dispensing contracted GP\\nNon-Dispensing GP: Unlimited, subject formulary","practitionersGeneral":"Unlimited at nominated, contracted GP\\nBeneficiaries can nominate up to two network GPs\\nPre-auth required after 10th visit\\n2x mental health visits per beneficiary\\nUp to 2 myFED network GP consultations per beneficiary for non-nominated GPs allowed per year (referred to as out-of-area)\\nNon-network: No benefit","specialistsCover":"2 consultations, limited to R2 000 per family  (No   GP referral , 40% co-payment applies)\\nNon-network Specialist: No benefit\\n\\n","dentistryCover":"Subject to a contracted list of dentists and limited to a list of approved procedures and dental tariff codes\\nPlastic dentures: Limited to 1 set per beneficiary every two years","dentistryCoverSpecial":"No benefit","optical":"Subject to ISO Leso network optometrist\\nFrame: R230 or R230 off any other frame\\n1 pair of single vision clear CR39 lenses or 1 pair of bifocal CR39 lenses\\n1 Comprehensive consultation\\nBenefit available every 2 years per beneficiary","ambulance":"Unlimited with Europ Assistance","international":"International travel benefit through AMP, R5 million cover","hospitalCoverAids":"Unlimited at cost, PMB level of care \\nHIV Management (Aid for AIDS)","artTtreatment":"Pharmacy Direct, or a 40% co-payment ","preventative":"Screening benefit\\nProstate Specific Antigen (PSA)\\nGeneral (Flu vaccination; HIV test)\\nHealth risk assessments (Wellness screening; Preventative screening)\\n\\nFemale contraception benefit\\n\\nAdditional services\\nHospital at home with Quro Medical\\nCorporate wellness days\\nSisters-on-Site\\nWeight Management Programme\\nGoSmokeFree Smoking Cessation Programme\\nAfA (HIV Management)\\nDiabetes Care\\nSOS Call Me\\n24-hour Nurse Line\\nMeditaxi\\nContraceptives subject to formulary\\n\\n","logo":"fedhealth.jpg"},{"company":"Fedhealth","name":"MyFed","planType":"Capitation","coverLevel":"Low","hospital":"Network","chronic":"Network","serviceType":"Network","familyIncome":"R14 427+","mainContribution":"R3455","mainCompSavings":"R0.00","mainTotal":"R3455","dependendContributionAdult":"R3147","dependentCompSavingsAdult":"R0.00","dependentTotalAdult":"R3147","dependendContributionChild":"R1317","dependentCompSavingsChild":"R0.00","dependentTotalChild":"R1317","maxChildContribution":"","mainThreshold":"","dependentThresholdAdult":"","dependentThresholdChild":"","preferedHospitalProvider":"Network (Fedhealth Network Hospitals)","overallLimit":"Unlimited (at network hospitals only) ","coPayment":"R13 000 co-pay for voluntary use of non-network hospitals\\nR2 000 co-payment on voluntary use of non-network Day Clinics","rate":"Negotiated tariff ","generalMedicin":"7 days' supply","specialist":"Network GPs and Specialists: covered in full\\nNon-network GPs and Specialists: 100% of Scheme Rate (R2 500 per beneficiary)\\nOther Healthcare Professionals: 100% Scheme Rate","dentistSurgical":"No benefit","mentalHealth":"             \\nPMB conditions: Up to 21 days in-hospital OR up to 15 psychotherapy sessions out-of-hospital\\nPsychiatric services: R9 700","radiology":"Unlimited at Scheme Rate","pathology":"Unlimited ","maternityBenefit":"Unlimited at cost at PMB level of care\\nElective Caesarean Section: subject to R12 900 co-payment\\nScans: as per radiology benefit\\n4 Postnatal midwife consultations \\nInfant hearing screening benefit\\nPaed-IQ telephonic advice line\\nmyFed baby programme","dialysis":"Unlimited at cost, PMB level of care\\n40% co-payment for use of non-DSP \\n- Palliative care benefit","cancer":"Subject to level 1 treatment protocols                   \\nPMBs only at ICON(SOAC)\\n25% co-payment for use non-Oncology Pharmacy\\nNetwork","transplant":"Unlimited at cost, PMB level of care","mri":"In hospital: R15 030 per beneficiary, \\nmaximum of R30 300 per family per year. \\nOut of Hospital: No benefit","prosthesisInternal":"Unlimited at cost, PMB level of care","prosthesisExternal":"Unlimited at cost, PMB level of care","rehab":"Alternatives to Hospitalisation: \\nUnlimited at cost, PMB level of care   \\nHospice Care: No benefit\\nPalliative care benefit","designatedServiceProvider":"\\nClicks, Dis-Chem, Medirite, Pharmacy Direct, Clicks Direct Medicines, Dis-Chem Direct and Medirite Courier Pharmacy, non-DSP or non-formulary, 40% co-payment applies","conditionsCovered":"CDL in PMB ","formulary":"Basic formulary","partialLimits":"None","preferredProvider":"Fedhealth contracted providers","overallAnualLimit":"N/A","medicationOverCounter":"No benefit","medicationPrescribed":"Unlimited at dispensing contracted GP\\nNon-Dispensing GP: Unlimited, subject formulary","practitionersGeneral":"Unlimited at nominated, contracted GP\\nBeneficiaries can nominate up to two network GPs\\nPre-auth required after 10th visit\\n2x mental health visits per beneficiary\\nUp to 2 myFED network GP consultations per beneficiary for non-nominated GPs allowed per year (referred to as out-of-area)\\nNon-network: No benefit","specialistsCover":"2 consultations, limited to R2 000 per family  (No   GP referral , 40% co-payment applies)\\nNon-network Specialist: No benefit\\n\\n","dentistryCover":"Subject to a contracted list of dentists and limited to a list of approved procedures and dental tariff codes\\nPlastic dentures: Limited to 1 set per beneficiary every two years","dentistryCoverSpecial":"No benefit","optical":"Subject to ISO Leso network optometrist\\nFrame: R230 or R230 off any other frame\\n1 pair of single vision clear CR39 lenses or 1 pair of bifocal CR39 lenses\\n1 Comprehensive consultation\\nBenefit available every 2 years per beneficiary","ambulance":"Unlimited with Europ Assistance","international":"International travel benefit through AMP, R5 million cover","hospitalCoverAids":"Unlimited at cost, PMB level of care \\nHIV Management (Aid for AIDS)","artTtreatment":"Pharmacy Direct, or a 40% co-payment ","preventative":"Screening benefit\\nProstate Specific Antigen (PSA)\\nGeneral (Flu vaccination; HIV test)\\nHealth risk assessments (Wellness screening; Preventative screening)\\n\\nFemale contraception benefit\\n\\nAdditional services\\nHospital at home with Quro Medical\\nCorporate wellness days\\nSisters-on-Site\\nWeight Management Programme\\nGoSmokeFree Smoking Cessation Programme\\nAfA (HIV Management)\\nDiabetes Care\\nSOS Call Me\\n24-hour Nurse Line\\nMeditaxi\\nContraceptives subject to formulary\\n\\n","logo":"fedhealth.jpg"},{"company":"Health Squared","name":"ultimate option","planType":"Threshold option","coverLevel":"High","hospital":"Any","chronic":"Network","serviceType":"Any","familyIncome":"","mainContribution":"R8395","mainCompSavings":"R0.00","mainTotal":"R8395","dependendContributionAdult":"R7650","dependentCompSavingsAdult":"R0.00","dependentTotalAdult":"R7650","dependendContributionChild":"R2080","dependentCompSavingsChild":"R0.00","dependentTotalChild":"R2080","maxChildContribution":"","mainThreshold":"","dependentThresholdAdult":"","dependentThresholdChild":"","preferedHospitalProvider":"Any hospital","overallLimit":"Unlimited","coPayment":"R3 764 - Cystoscopy, Excision nail bed, Skin lesions, Tympanoplasty\\nR3 920 - Circumcision, Vasectomy, Colonoscopy, Dental admissions\\nR5 002 - Arthroscopy\\nR6 000 - Rotator cuff surgery\\nR7 840 - Gastroscopy, Hernia repair, Conservative back / spine treatment\\nR9 024 - Endometrial Ablation, Laparoscopic procedures, Urinary incontinence repair,  Varicose veins\\nR10 453 - Hysteroscopy, Hysterectomy\\nR15 680 - Joint Replacement, Spinal Surgery\\n\\nThe highest co-payment will apply where more than one payment is required\\n\\n","rate":"100% of Scheme Rate","generalMedicin":"7 days' supply","specialist":"Non-contracted Providers: 100% of Scheme Rate. Contracted Providers up to 100% of Contracted Rate","dentistSurgical":"Removal of impacted wisdom teeth in adults. Extensive dental treatment for children <5 years of age\\nSubject to R3 920 co-payment","mentalHealth":"\\nPsychiatric disorders: \\nPMB's - Unlimited\\nNon PMBs - to R35 748 per family \\nTrauma counselling: 3 psychologist visits per beneficiary - R790 per visit\\n ","radiology":"100% of Scheme Rate - unlimited","pathology":"100% of Scheme Rate - unlimited","maternityBenefit":"In-hospital: 100% of Scheme Rate\\nNormal delivery: 3 days and 2 nights\\nCaesarean Section: 4 days and 3 nights\\nElective Caesarean Section: Included\\nOut-of-hospital:\\nSpecialist, GP and midwife consultations coved from Risk\\nR1 104 voucher \\n2 x 2D scans\\n","dialysis":"Covered at Network Providers. Subject to Scheme protocols and pre-authorisation  ","cancer":"Unlimited - subject to ICON Core networks and protocols\\n(40% co-payment for non-DSP)\\nIncludes 12 day Hospice benefit\\nSpecialised medicine: \\nper beneficiary - R150 000\\nper family - R300 000\\nIncludes 21 day Hospice benefit","transplant":" Unlimited cover for PMBs ","mri":"In and out of hospital\\nR22 566 per family per year \\nR3 764 co-payment per incident\\nVideo EEG for epilepsy surgery: \\nR17 644 per family  ","prosthesisInternal":"Non-PMB : R75 000 per family\\nSubject to prosthesis sub-limits   ","prosthesisExternal":"External medical appliances \\nLimited to R18 024 per family and subject to appliance sub-limits\\n","rehab":"\\nHome Nursing: 12 days per family .\\nRehab and Sub-Acute facility: 21 days per family      \\n\\n","designatedServiceProvider":"DSP Pharmacies","conditionsCovered":"59 conditions including CDL in PMBs","formulary":"Supreme Chronic Formulary","partialLimits":"\\nFor additional Chronic conditions:\\nM: R6 475, M+: R12 933 \\n","preferredProvider":"Consultations outside of network for GPs and Specialists may incur a co-payment","overallAnualLimit":"\\nDay-to-day limits: \\nPrincipal   R17 099\\nAdult          R12 823\\nChild          R1 788 max of 3\\n\\nAdditional out-of-hospital benefits\\nM:             R8 932\\nM+1:         R15 721\\nM+2+:       R17 075\\nFollowing day-to-day benefits covered: Alternative Healthcare Services, Radiology and pathology, Physiotherapy, Psychology and psychiatric treatment, Speech therapy and audiology, Acute medication \\n\\n","medicationOverCounter":"Member: R2 652\\nMember + 1 : R4 568\\nMember + 2+ : R4 989\\nSubject to additional out-of-hospital benefit                                                                                                                                   \\n","medicationPrescribed":"\\nSubject to additional out-of-hospital benefit. Following sub-limit of: \\nMember: R9 165\\nMember + 1 : R16 122\\nMember + 2+ : R18 385                                                                                                                            \\n","practitionersGeneral":"Unlimited. (Subject to day-to-day benefit)\\n","specialistsCover":"220% of Scheme Rate\\nM:      4 Visits \\nM+1:  5 Visits\\nM+2:  6 Visits \\nAdditional visits subject to PMBs and pre-authorisation\\n","dentistryCover":"Subject to Scheme Protocols\\nSub limits apply, view brochure for full details","dentistryCoverSpecial":"\\nR15 756 sub-limit\\n(Subject to day-to-day benefit)\\n\\n","optical":"Limited to Network Provider and 2-year benefit cycle. \\n1 pair of single vision spectacles inclusive of a frame and consult p.b., limited to R2 830 OR \\n1 pair of flat top bifocal spectacles inclusive of a frame and consult p.b., limited to R3 381  OR\\n1 pair of multifocal spectacles inclusive of a frame and consult p.b, limited to R4 238  OR\\nContact lenses: R3 440 per beneficiary","ambulance":"100% of Scheme Rate\\nNetcare 911","international":"No details provided","hospitalCoverAids":"Limited to Network Provider and registration on HIV programme","artTtreatment":"HIV Management Programme","preventative":"Preventative and Screening benefit\\nScreening tests limited to R4 588\\nSublimit of R145 per beneficiary for screening test (Blood pressure, Blood sugar, Cholesterol, BMI), Pap smear, PSA test , Flu vaccine \\nHIV Test paid from Risk\\n\\nChildhood immunisations (R2 304 up to 18 months)  \\nHPV vaccine (females 9-25 years)\\nOral contraception benefit limited to R1 848 (R154 per month) \\n\\nCasualty Benefit: R1 958 per family per annum\\n\\nPatient Driven Care (PDC): gives members \\naccess to the amount of care they need to stay healthier for longer","logo":"Health Squared.jpg"},{"company":"Health Squared","name":"aspire","planType":"Hospital plan","coverLevel":"Mid","hospital":"Network","chronic":"Network","serviceType":"N/A","familyIncome":"","mainContribution":"R2494","mainCompSavings":"R0.00","mainTotal":"R2494","dependendContributionAdult":"R2016","dependentCompSavingsAdult":"R0.00","dependentTotalAdult":"R2016","dependendContributionChild":"R890","dependentCompSavingsChild":"R0.00","dependentTotalChild":"R890","maxChildContribution":"3","mainThreshold":"","dependentThresholdAdult":"","dependentThresholdChild":"","preferedHospitalProvider":"Any Hospital","overallLimit":"Unlimited","coPayment":"R3 000 - Tonsillectomy, Adenoidectomy\\nR3 266 - Myringotomy\\nR3 764 - Cystoscopy, Excision nail bed, Skin lesions, Tympanoplasty\\nR3 920 -  Circumcision, Vasectomy, Colonoscopy, Dental admissions\\nR5 002 -Arthroscopy\\nR7 840 - Gastroscopy, Hernia repair, Nasal surgery (including endoscopy)\\nR9 024 - Endometrial Ablation, Laparoscopic procedures, Urinary incontinence repair,  Varicose veins\\nR10 453- Hysteroscopy, Hysterectomy\\nR15 680 - Rotator cuff surgery, Reflux surgery\\nThe highest co-payment will apply where more than one payment is required\\n\\nNon-DSP hospital: 30% (Minimum, R7 000)","rate":"100% of Scheme Rate ","generalMedicin":"7 days' supply","specialist":"\\nNon-Contracted Providers :100% of Scheme Rate. Contracted Providers: 100% of contracted Rate\\n","dentistSurgical":"\\nLimited to R5 161 per family per annum for impacted wisdom teeth (including hospital and anaesthetist, No Dentist Benefits) \\nSubject to R3 920 co-payment\\n","mentalHealth":"Psychiatric disorders: \\nSubject to PMB's at  Network Providers","radiology":"100% of Scheme Rate","pathology":"100% of Scheme Rate","maternityBenefit":"In hospital: 100% of Scheme Rate\\nNormal delivery: 3 days and 2 nights\\nCaesarean Section : 4 days and 3 nights\\nElective Caesarean Section : Limit of R11 740 if not authorised\\n2 x 2D scans\\n \\n\\n","dialysis":"Unlimited at Foundation Network Providers\\nPre-authorisation required","cancer":"\\nCovered at DSP (ICON)\\nSubject to Essential networks and protocols\\n40% Non-DSP co-payment\\nIncludes 10 day Hospice benefit\\n","transplant":"PMB's  ","mri":"100% of Scheme Rate\\nIn-and-out- of hospital\\nR9 027 per family per annum\\nR3 764 co-payment per incident","prosthesisInternal":"R42 136  per family \\nSubject to prosthesis sub-limits   ","prosthesisExternal":"External medical appliances \\nR4 421 per family per annum\\n(subject to PMBs, Scheme Protocols and  appliance sub-limits)","rehab":"Home Nursing: in lieu of hospitalisation\\nRehab and Sub-Acute facility: 10 days per family per annum ","designatedServiceProvider":"DSP pharmacies -  40% Non-DSP co-pay","conditionsCovered":"CDL in PMB + 2 additional","formulary":"Yes ","partialLimits":"None","preferredProvider":"None","overallAnualLimit":"None","medicationOverCounter":"No benefit","medicationPrescribed":"No benefit","practitionersGeneral":"3 x Network GP visits per annum, subject to R75 co-payment per visit OR\\n2x Non - Primary Care Network GP visits per family per annum, subject  R150 co-payment  per visit","specialistsCover":"No Benefits. Subject to PMB�s","dentistryCover":"No benefit","dentistryCoverSpecial":"No benefit","optical":"No benefit","ambulance":"100% of Scheme Rate\\nNetcare 911","international":"No details provided","hospitalCoverAids":"Limited to Network Provider and registration on HIV programme","artTtreatment":"HIV Management Programme","preventative":"Preventative and Screening benefit\\nLimited to R2 999:\\n1 x Pap smear (>45 years)\\n1 x  PSA test (>45 years)\\n1 x Flu vaccination\\nHIV Test paid from Risk\\nChildhood immunisations (R2 211 up to 18 months) \\nOral contraception benefit limited to R1 776 (R148 per month)\\nNurse Helpline and Rape Crisis Centre\\n\\nPatient Driven Care (PDC): gives members \\naccess to the amount of care they need to stay healthier for longer\\n","logo":"Health Squared.jpg"},{"company":"Health Squared","name":"flex","planType":"New generation","coverLevel":"Mid","hospital":"Network","chronic":"Network","serviceType":"N/A","familyIncome":"","mainContribution":"R3272","mainCompSavings":"R284","mainTotal":"R3556","dependendContributionAdult":"R2940","dependentCompSavingsAdult":"R255","dependentTotalAdult":"R3195","dependendContributionChild":"R1018","dependentCompSavingsChild":"R88","dependentTotalChild":"R1106","maxChildContribution":"","mainThreshold":"","dependentThresholdAdult":"","dependentThresholdChild":"","preferedHospitalProvider":"Network Hospitals","overallLimit":"0","coPayment":"25% - Joint Replacement, Spinal Surgery\\nR3 000 - Tonsillectomy, Adenoidectomy\\nR3 266 - Myringotomy\\nR3 764 - Cystoscopy, Excision nail bed, Skin lesions, Tympanoplasty\\nR3 920 -  Circumcision, Vasectomy, Colonoscopy, Dental admissions\\nR5 002 -Arthroscopy\\nR7 840 - Gastroscopy, Hernia repair, Nasal surgery (including endoscopy), Conservative back / spine treatment\\nR9 024 - Endometrial Ablation, Laparoscopic procedures, Urinary incontinence repair,  Varicose veins\\nR10 453- Hysteroscopy, Hysterectomy\\nR15 680 - Rotator cuff surgery, Reflux surgery\\nThe highest co-payment will apply where more than one payment is required\\n\\nNon-DSP hospital: 30% (Minimum, R7 000)","rate":"100% of Scheme Rate","generalMedicin":"7 days' supply","specialist":"Non-contracted Providers: 100% of Scheme Rate. Contracted Providers: 100% of Contracted Rate","dentistSurgical":"Removal of impacted wisdom teeth in adults. Extensive dental treatment for children <5 years of age\\nSubject to R3 920 co-payment","mentalHealth":"Psychiatric disorders: \\nSubject to PMB's at  Network Providers","radiology":"100% of Scheme Rate - unlimited","pathology":"100% of Scheme Rate - unlimited","maternityBenefit":"In-hospital: 100% of Scheme Rate\\nNormal delivery: 3 days and 2 nights\\nCaesarean Section : 4 days and 3 nights\\nElective Caesarean Section : Limit of R11 740 if not authorised\\nOut-of-hospital: 3x specialist, GP and midwife consultations\\nR722 voucher\\n2 x 2D scans and 1x3D scan\\n\\n","dialysis":"Unlimited at Foundation Network Providers\\nPre-authorisation required","cancer":"R250 000 per family - subject to ICON Essential networks and protocols\\n(40% co-payment for non-DSP)\\nIncludes 12 day Hospice benefit\\n","transplant":"100% of Scheme Rate\\nNon-PMB, R132 733 per family ","mri":"In-and-out- of hospital\\nR11 356  per family per year \\nR3 764 co-payment per incident","prosthesisInternal":"Non-PMB - R50 000 per family per annum. \\nSubject to prosthesis sub-limits   ","prosthesisExternal":"External medical appliances \\nLimited to R4 687 per family and subject to appliance sub-limits\\n","rehab":"Home Nursing: 5 days per family \\nRehab and Sub-Acute facility: 12 days per family per annum ","designatedServiceProvider":"DSP pharmacies","conditionsCovered":"CDL in PMB + 7 additional","formulary":"Yes","partialLimits":"Subject to available Savings","preferredProvider":"Consultations outside of network for GPs and Specialists may incur a co-payment.","overallAnualLimit":"Flexi benefit: \\nM: R2 675\\nM+1: R3 394\\n","medicationOverCounter":"sub-limits on Schedule 0-2 drugs of:\\nM: R678\\nM+: R1 025 ","medicationPrescribed":"Subject to available Savings\\nSubject to Option Specific formulary.","practitionersGeneral":"Primary Care Network Benefit: \\nM: 6 visits per annum \\nM+1: 10 visits per annum \\nM+2+: 13 visits per annum OR\\n\\nNon - Primary Care Network Benefit:\\nM: 4 visits per annum \\nM+1: 7 visits per annum\\nM+2+: 9 visits per annum\\n","specialistsCover":"Non-Contracted Providers up to 100% of Scheme Rate\\nContracted Providers up to 100% of contracted Rate\\nM:       2 Visits per annum\\nM+1:   3 Visits per annum\\nM+2+: 3 Visits per annum\\n","dentistryCover":"Subject to available Savings  \\n","dentistryCoverSpecial":"Subject to available Savings","optical":"Subject to available Savings and\\n2-year benefit cycle\\nSub-limit of: R2 838 per beneficiary\\nFrame sub-limit of R1 328","ambulance":"100% of Scheme Rate\\nNetcare 911","international":"No details provided","hospitalCoverAids":"Limited to Network Provider and registration on HIV programme","artTtreatment":"HIV Management Programme","preventative":"Preventative and Screening benefit\\nLimited to R3 125\\n\\nSublimit of R145 per beneficiary for screening test (Blood pressure, Blood sugar, BMI Cholesterol) \\n\\nMammogram, Pap Smear, PSA test\\nHIV Test paid from Risk \\n\\nOral contraception - limited to R1 848 (R154 per month)  \\nChildhood immunisations (R2 304 up to 18 months)  \\n\\nCasualty Benefit: non-PMB, R1 879 per family\\n\\nPatient Driven Care (PDC): gives members \\naccess to the amount of care they need to stay healthier for longer\\n","logo":"Health Squared.jpg"},{"company":"Health Squared","name":"prosper","planType":"New generation","coverLevel":"Mid","hospital":"Network","chronic":"Network","serviceType":"Any","familyIncome":"","mainContribution":"R3989","mainCompSavings":"R394","mainTotal":"R4383","dependendContributionAdult":"R3713","dependentCompSavingsAdult":"R367","dependentTotalAdult":"R4080","dependendContributionChild":"R1396","dependentCompSavingsChild":"R137","dependentTotalChild":"R1533","maxChildContribution":"","mainThreshold":"","dependentThresholdAdult":"","dependentThresholdChild":"","preferedHospitalProvider":"Network Hospitals","overallLimit":"Unlimited","coPayment":"25% - Joint Replacement, Spinal Surgery\\nR3 000 - Tonsillectomy, Adenoidectomy\\nR3 266 - Myringotomy\\nR3 764 - Cystoscopy, Excision nail bed, Skin lesions, Tympanoplasty\\nR3 920 -  Circumcision, Vasectomy, Colonoscopy, Dental admissions\\nR5 002 -Arthroscopy\\nR7 840 - Gastroscopy, Hernia repair, Nasal surgery (including endoscopy), Conservative back / spine treatment\\nR9 024 - Endometrial Ablation, Laparoscopic procedures, Urinary incontinence repair,  Varicose veins\\nR10 453- Hysteroscopy, Hysterectomy\\nR15 680 - Rotator cuff surgery, Reflux surgery\\n\\nThe highest co-payment will apply where more than one payment is required\\n\\nNon-DSP hospital: 30% (Minimum, R7 000)","rate":"100% of Scheme Rate","generalMedicin":"7 days' supply","specialist":"Non-contracted Providers: 100% of Scheme Rate. Contracted Providers: 100% of Contracted Rate","dentistSurgical":"Removal of impacted wisdom teeth in adults. Extensive dental treatment for children <5 years of age\\nSubject to R3 920 co-payment","mentalHealth":"Psychiatric disorders: \\nSubject to PMB's at  Network Providers","radiology":"100% of Scheme Rate - unlimited","pathology":"100% of Scheme Rate - unlimited","maternityBenefit":"In-hospital: 100% of Scheme Rate\\nNormal delivery: 3 days and 2 nights\\nCaesarean Section : 4 days and 3 nights\\nElective Caesarean Section : Limit of R11 740 if not authorised\\nOut-of-hospital:\\nConsultation limited to Savings\\nR364 voucher\\n2 x 2D scans\\n\\n","dialysis":"Unlimited at Foundation Network Providers\\nPre-authorisation required","cancer":"R350 000 per family - subject to ICON Essential networks and protocols\\n(40% co-payment for non-DSP)\\nIncludes 12 day Hospice benefit\\nSpecialised medicine: \\n- R62 500 per beneficiary, R125 per family\\n","transplant":"PMB conditions - unlimited","mri":"In-and-out- of hospital\\nR21 723 per family per year \\nR3 764 co-payment per incident","prosthesisInternal":"Non-PMB - R60 000 per family \\n25% Co-payment and sub-limit for non-PMB Spinal Surgery and Joint Replacements apply","prosthesisExternal":"External medical appliances \\nLimited to R4 687 per family and subject to appliance sub-limits\\n","rehab":"Home Nursing: in lieu of hospitalisation\\nRehab and Sub-Acute facility: in lieu of hospitalisation","designatedServiceProvider":"DSP pharmacies","conditionsCovered":"CDL in PMB + 2 additional","formulary":"Yes","partialLimits":"None","preferredProvider":"None","overallAnualLimit":"None","medicationOverCounter":"Subject to available Savings  \\n","medicationPrescribed":"Subject to available Savings  \\n","practitionersGeneral":"Primary Care Network Benefit: \\nM: 6 visits per annum \\nM+1: 10 visits per annum \\nM+2+: 13 visits per annum OR\\n\\nNon - Primary Care Network Benefit\\nM: 4 visits per annum \\nM+1: 7 visits per annum\\nM+2+: 9 visits per annum\\n","specialistsCover":"Subject to available Savings  \\n","dentistryCover":"Subject to Scheme Protocols and annual\\nlimits of:\\nM: R3 517, M+: R5 653 ","dentistryCoverSpecial":"Subject to available Savings","optical":"2-year benefit cycle. 1 consultation per beneficiary\\n1 pair of single vision spectacles inclusive of a frame and consult p.b., limited to R1 437  OR \\n1 pair of flat top bifocal spectacles inclusive of a frame and consult p.b., limited to R2 190 OR\\n1 pair of multifocal spectacles inclusive of a frame and consult p.b, limited to R2 664  OR\\nContact lenses: R1 437 per beneficiary","ambulance":"100% of Scheme Rate\\nNetcare 911","international":"No details provided","hospitalCoverAids":"Limited to Network Provider and registration on HIV programme","artTtreatment":"HIV Management Programme","preventative":"\\nPreventative Care\\nLimited to R3 125 per family per annum  (Blood pressure, Blood sugar, Cholesterol, BMI, Mammograms)\\nHIV Test paid from Risk\\n\\nSublimit of R145 per beneficiary for screening test (Blood pressure, Blood sugar, BMI Cholesterol) \\nHIV Test paid from Risk\\n\\nPatient Driven Care (PDC): gives members \\naccess to the amount of care they need to stay healthier for longer\\n\\n","logo":"Health Squared.jpg"},{"company":"Health Squared","name":"optimum","planType":"Hybrid option","coverLevel":"Mid","hospital":"Any","chronic":"Network","serviceType":"Network","familyIncome":"","mainContribution":"R5246","mainCompSavings":"R854","mainTotal":"R6100","dependendContributionAdult":"R4374","dependentCompSavingsAdult":"R712","dependentTotalAdult":"R5086","dependendContributionChild":"R1795","dependentCompSavingsChild":"R292","dependentTotalChild":"R2087","maxChildContribution":"","mainThreshold":"","dependentThresholdAdult":"","dependentThresholdChild":"","preferedHospitalProvider":"Any Hospital","overallLimit":"Unlimited","coPayment":"R3 266 - Myringotomy\\nR3 764 - Cystoscopy, Excision nail bed, Skin lesions, Tympanoplasty\\nR3 920 -  Circumcision, Vasectomy, Colonoscopy, Dental admissions\\nR5 002 -Arthroscopy\\nR7 840 - Gastroscopy, Hernia repair, Nasal surgery (including endoscopy), Conservative back / spine treatment\\nR9 024 - Endometrial Ablation, Laparoscopic procedures, Urinary incontinence repair,  Varicose veins\\nR10 453- Hysteroscopy, Hysterectomy\\nR15 680 - Rotator cuff surgery, Reflux surgery, Joint Replacement, Spinal Surgery\\n\\nThe highest co-payment will apply where more than one payment is required\\n\\nNon-DSP hospital: 30% (Minimum, R7 000)","rate":"100% of Scheme Rate","generalMedicin":"7 days' supply","specialist":"Non-contracted Providers: 100% of Scheme Rate. Contracted Providers up to 100% of Contracted Rate","dentistSurgical":"Removal of impacted wisdom teeth in adults. Extensive dental treatment for children <5 years of age\\nSubject to R3 920 co-payment","mentalHealth":"Psychiatric disorders: \\nPMB's at DSP's - Unlimited\\nNon-PMB - R21 872 per family ","radiology":"100% of Scheme Rate - unlimited","pathology":"100% of Scheme Rate - unlimited","maternityBenefit":"In-hospital: 100% of Scheme Rate\\nNormal delivery: Length of stay:\\nNormal delivery: 3 days and 2 nights\\nCaesarean Section : 4 days and 3 nights                                            \\nHome births: R12 070 per confinement, 10 pre-natal + 3 Post Natal Midwife visits)\\nElective Caesarean Section : Limit of R11 740 if not authorised\\nOut-of-hospital: \\nConsultation limited to Savings\\n4 x 2D scans \\n","dialysis":"PMB's at Network Providers\\nPre-authorisation required","cancer":"Unlimited - subject to ICON Core networks and protocols\\n(40% co-payment for non-DSP)\\nIncludes 12 day Hospice benefit\\nSpecialised medicine: \\nper beneficiary - R100 000\\nper family - R200 000\\n\\nHospice benefit, R9 615 per family","transplant":"PMB conditions - unlimited","mri":"In-and-out- of hospital\\nR17 905 per family\\nR3 764 co-payment per incident","prosthesisInternal":"\\nNon-PMB : R65 000 per family \\nSubject to prosthesis sub-limits   \\n","prosthesisExternal":"External medical appliances \\nSubject to available Savings","rehab":"Home Nursing: in lieu of hospitalisation\\nRehab and Sub-Acute facility: R9 615 per family per annum","designatedServiceProvider":"DSP pharmacies","conditionsCovered":"CDL in PMB + 8 additional","formulary":"Yes","partialLimits":"Subject to available Savings","preferredProvider":"None","overallAnualLimit":"\\nBenefit Booster\\nM: R7 938\\nM+1: R9 615\\nM+2: R11 069\\nM+3: R12 573\\nM+4+: R14 200\\n\\n","medicationOverCounter":"Subject to available Savings  \\n","medicationPrescribed":"Subject to available Savings  \\n","practitionersGeneral":"Subject to available Savings\\nCDL PMBs consultations covered separately.","specialistsCover":"Subject to available Savings  \\n","dentistryCover":"Subject to available Savings  \\n","dentistryCoverSpecial":"Subject to Benefit Booster and sub-limits of: \\nM: R5 986\\nM+1: R7 528\\nM+2: R8 954\\nM+3: R10 550\\nM+4+: R12 089\\n\\nImplants: R4 391 per implant, max of 2 per annum  \\n","optical":"Subject to available Savings and\\n2-year benefit cycle\\nSub-limit of: R2 838 per beneficiary\\nFrame sub-limit of R1 328","ambulance":"100% of Scheme Rate\\nNetcare 911","international":"No details provided","hospitalCoverAids":"Limited to Network Provider and registration on HIV programme","artTtreatment":"HIV Management Programme","preventative":"\\nPreventative Care\\nLimited to R3 076 per family per annum \\n\\nScreening benefit, subject to BenefitBooster: sublimit of R1 711 per family at preferred provider (Blood pressure, Blood sugar, Cholesterol, BMI, Pap smear)\\nHIV Test paid from Risk\\n\\nNurse consult at preferred provider\\n\\nPatient Driven Care (PDC): gives members \\naccess to the amount of care they need to stay healthier for longer\\n\\nMedibooster of R1 738 (subject to Benefit Booster)\\n\\n","logo":"Health Squared.jpg"},{"company":"Health Squared","name":"millennium","planType":"New generation","coverLevel":"Mid","hospital":"Any","chronic":"Network","serviceType":"Any","familyIncome":"","mainContribution":"R6233","mainCompSavings":"R1014","mainTotal":"R7247","dependendContributionAdult":"R5337","dependentCompSavingsAdult":"R868","dependentTotalAdult":"R6205","dependendContributionChild":"R1452","dependentCompSavingsChild":"R236","dependentTotalChild":"R1688","maxChildContribution":"","mainThreshold":"","dependentThresholdAdult":"","dependentThresholdChild":"","preferedHospitalProvider":"Any Hospital","overallLimit":"Unlimited","coPayment":"R3 266 - Myringotomy\\nR3 764 - Cystoscopy, Excision nail bed, Skin lesions, Tympanoplasty\\nR3 920 -  Circumcision, Vasectomy, Colonoscopy, Dental admissions\\nR5 002 -Arthroscopy\\nR6 000 - Rotator cuff surgery\\nR7 840 - Gastroscopy, Hernia repair, Nasal surgery (including endoscopy), Conservative back / spine treatment\\nR9 024 - Endometrial Ablation, Laparoscopic procedures, Urinary incontinence repair,  Varicose veins\\nR10 453- Hysteroscopy, Hysterectomy\\nR15 680 - Reflux surgery, Joint Replacement, Spinal Surgery\\n\\nThe highest co-payment will apply where more than one payment is required\\n\\n","rate":"100% of Scheme Rate","generalMedicin":"7 days' supply","specialist":"Non-contracted Providers: 100% of Scheme Rate. Contracted Providers up to 100% of Contracted Rate","dentistSurgical":"Removal of impacted wisdom teeth in adults. Extensive dental treatment for children <5 years of age\\nSubject to R3 920 co-payment","mentalHealth":"Psychiatric disorders: \\nPMB's - Unlimited\\nNon-PMB - R23 053 per family ","radiology":"100% of Scheme Rate - unlimited","pathology":"100% of Scheme Rate - unlimited","maternityBenefit":"\\nIn-hospital: 100% of Scheme Rate\\nNormal delivery: 3 days and 2 nights\\nCaesarean Section : 4 days and 3 nights\\n100% of Scheme Rate\\nOut-of-hospital: Consultations - any provider (Subject to Savings and ATB)  \\nR978 voucher\\n2 x 2D scans\\n\\n\\n\\n","dialysis":"PMB's at Network Providers\\nPre-authorisation required","cancer":"Unlimited - subject to ICON Core networks and protocols\\n(40% co-payment for non-DSP)\\nIncludes 12 day Hospice benefit\\nSpecialised medicine: \\nper beneficiary - R100 000\\nper family - R200 000\\n\\nHospice benefit, R9 615 per family","transplant":"PMB conditions - unlimited","mri":"In-and-out- of hospital\\nR18 051 per family   \\nR3 764 co-payment per incident","prosthesisInternal":"Non-PMB : R68 934 per family \\nSubject to prosthesis sub-limits   \\n","prosthesisExternal":"External medical appliances \\nR13 538 per family \\nsubject to appliance sub-limits\\n","rehab":"Home Nursing: 10 days per family \\nRehab and Sub-Acute facility: 18 days per family per annum ","designatedServiceProvider":"DSP pharmacies","conditionsCovered":"CDL in PMB + 32 additional","formulary":"Yes","partialLimits":"\\nFor additional Chronic conditions:\\nM: R3 125, M+: R6 387 \\n","preferredProvider":"None","overallAnualLimit":"None","medicationOverCounter":"Subject to available Savings and ATB","medicationPrescribed":"Subject to available Savings and ATB","practitionersGeneral":"Subject to available Savings and ATB\\n100% of Contracted Rate\\nCDL PMBs consultations covered separately.","specialistsCover":"Subject to available Savings and ATB\\n220% of Scheme Rate","dentistryCover":"Subject to available Savings and ATB  \\nsub-limits of: \\nM: R7 374\\nM+1: R10 174\\nM+2+: R12 093\\n\\n","dentistryCoverSpecial":"Subject to available Savings and ATB  \\nsub-limits of: \\nM: R6 958\\nM+1: R9 599\\nM+2+: R11 410\\n\\n","optical":"Subject to Savings and ATB \\nSub-limit of: R3 374 per beneficiary every 2 years","ambulance":"100% of Scheme Rate\\nNetcare 911","international":"No details provided","hospitalCoverAids":"Limited to Network Provider and registration on HIV programme","artTtreatment":"HIV Management Programme","preventative":"Preventative and Screening benefit\\nScreening tests limited to R3 065\\nSublimit of R145 per beneficiary for screening test (Blood pressure, Blood sugar, Cholesterol, BMI), Pap smear, PSA test , Flu vaccine \\nHIV Test paid from Risk\\n\\nChildhood immunisations (R2 304 up to 18 months)  \\nHPV vaccine (females 9-25 years)\\nOral contraception benefit limited to R1 848 (R154 per month) \\n\\nPatient Driven Care (PDC): gives members \\naccess to the amount of care they need to stay healthier for longer\\n","logo":"Health Squared.jpg"},{"company":"Health Squared","name":"cobalt","planType":"Hybrid Option","coverLevel":"Mid","hospital":"Any","chronic":"Network","serviceType":"Any","familyIncome":"","mainContribution":"R8308","mainCompSavings":"R1701","mainTotal":"R10009","dependendContributionAdult":"R8043","dependentCompSavingsAdult":"R1647","dependentTotalAdult":"R9690","dependendContributionChild":"R2963","dependentCompSavingsChild":"R606","dependentTotalChild":"R3569","maxChildContribution":"","mainThreshold":"","dependentThresholdAdult":"","dependentThresholdChild":"","preferedHospitalProvider":"Any hospital","overallLimit":"Unlimited","coPayment":"R3 764 - Cystoscopy, Excision nail bed, Skin lesions, Tympanoplasty\\nR3 920 - Circumcision, Vasectomy, Colonoscopy, Dental admissions\\nR5 002 - Arthroscopy\\nR6 000 - Rotator cuff surgery\\nR7 840 - Gastroscopy, Hernia repair, Conservative back / spine treatment\\nR9 024 - Endometrial Ablation, Laparoscopic procedures, Urinary incontinence repair,  Varicose veins\\nR10 453 - Hysteroscopy, Hysterectomy\\nR15 680 - Joint Replacement, Spinal Surgery\\n\\nThe highest co-payment will apply where more than one payment is required\\n\\n","rate":"100% of Scheme Rate","generalMedicin":"7 days' supply","specialist":"Non-contracted Providers: 100% of Scheme Rate. Contracted Providers up to 100% of Contracted Rate","dentistSurgical":"Removal of impacted wisdom teeth in adults. Extensive dental treatment for children <5 years of age\\nSubject to R3 920 co-payment","mentalHealth":"Psychiatric disorders: \\nPMB's at DSP's - Unlimited\\nNon-PMB - R35 396 per family ","radiology":"100% of Scheme Rate - unlimited","pathology":"100% of Scheme Rate - unlimited","maternityBenefit":"\\nIn-hospital: 100% of Scheme Rate\\nNormal delivery: 3 days and 2 nights\\nCaesarean Section : 4 days and 3 nights\\nSpecialist, GP and midwife consultations coved from Risk\\nElective Caesarean : Limit of R11 740 if not authorised\\nOut-of-hospital:\\nR570 for Antenatal classes\\n3 x 2D scans\\n\\n\\n","dialysis":"Subject to network provider, Scheme protocols and pre-authorisation","cancer":"Unlimited - subject to ICON Core networks and protocols\\n(40% co-payment for non-DSP)\\nIncludes 12 day Hospice benefit\\nSpecialised medicine: \\nper beneficiary - R150 000\\nper family - R300 000\\n\\nHospice benefit, R9 615 per family","transplant":"PMB conditions - unlimited","mri":"In-and-out- of hospital\\nR25 433  per family  \\nR3 764 co-payment per incident","prosthesisInternal":"Non-PMB : R80 000 per family\\nSubject to prosthesis sub-limits   ","prosthesisExternal":"External medical appliances \\nSubject to Benefit Booster\\n","rehab":"Home Nursing: in lieu of hospitalisation\\nRehab and Sub-Acute facility: R15 989 per family per annum","designatedServiceProvider":"DSP pharmacies","conditionsCovered":"CDL in PMB + 16 additional","formulary":"Yes","partialLimits":"Subject to available Savings","preferredProvider":"None","overallAnualLimit":"\\nBenefit Booster\\nM: R10 398\\nM+1: R12 635\\nM+2: R14 316\\nM+3: R17 442\\nM+4+: R19 567\\n\\n","medicationOverCounter":"Subject to available Savings","medicationPrescribed":"Subject to available Savings","practitionersGeneral":"Subject to available Savings","specialistsCover":"Subject to available Savings","dentistryCover":"Subject to available Benefit Booster","dentistryCoverSpecial":"Subject to Benefit Booster\\nSub-limits of: \\nM: R10 606\\nM+1: R12 888\\nM+2: R14 602\\nM+3: R17 792\\nM+4+: R19 958\\nImplants: R4 391 per implant, max of 2 per annum","optical":"Subject to available Savings","ambulance":"100% of Scheme Rate\\nNetcare 911","international":"No details provided","hospitalCoverAids":"Limited to Network Provider and registration on HIV programme","artTtreatment":"HIV Management Programme","preventative":"Preventative Care Benefits: Subject to BenefitBooster\\n\\nScreening benefit, subject to Benefit Booster: sublimit of R2 851 per family at preferred provider (Blood pressure, Blood sugar, Cholesterol, BMI, Pap smear)\\nHIV Test paid from Risk\\n\\nNurse consult paid from Benefit Booster\\n\\nMedibooster of R1 955 (subject to Benefit Booster)\\n\\nPatient Driven Care (PDC): gives members \\naccess to the amount of care they need to stay healthier for longer","logo":"Health Squared.jpg"},{"company":"Health Squared","name":"foundation","planType":"Capitation","coverLevel":"Low","hospital":"Network","chronic":"Network","serviceType":"Network","familyIncome":"0 - R8000","mainContribution":"R1234","mainCompSavings":"R0.00","mainTotal":"R1234","dependendContributionAdult":"R1234","dependentCompSavingsAdult":"R0.00","dependentTotalAdult":"R1234","dependendContributionChild":"R534","dependentCompSavingsChild":"R0.00","dependentTotalChild":"R534","maxChildContribution":"","mainThreshold":"","dependentThresholdAdult":"","dependentThresholdChild":"","preferedHospitalProvider":"Network hospitals ","overallLimit":"Unlimited","coPayment":"No co-payment","rate":"100% of Scheme Rate ","generalMedicin":"7 days' supply","specialist":"Non-contracted Providers: 100% of Scheme Rate. Contracted Providers: 100% of Contracted Rate","dentistSurgical":"PMBs only                                                                               \\nPre-auth and protocols apply \\nMultiple hospital admissions are not covered","mentalHealth":"Psychiatric disorders: \\nSubject to PMB's at  Network Providers","radiology":"100% of Scheme Rate","pathology":"100% of Scheme Rate","maternityBenefit":"In hospital: 100% of Scheme Rate\\nNormal delivery: 3 days and 2 nights\\nCaesarean Section (emergency only):  Length of stay: 4 days and 3 nights\\nElective Caesarean Section : Limit of R11 740 if not authorised\\nOut-of-hospital: 9 visits at  GPs/ midwives \\nSpecialists require authorisation \\n2 x 2D scans\\n\\n","dialysis":"PMB's conditions at preferred providers ","cancer":"\\nUnlimited\\nICON Essential network protocols\\n40% Non-DSP co-payment\\nIncludes 10 day Hospice benefit\\n","transplant":"PMB's at Provincial hospitals","mri":"Unlimited cover for trauma and PMB-related scans\\n","prosthesisInternal":"PMB: unlimited\\nR42 136  per family per annum \\nSubject to prosthesis sub-limits   ","prosthesisExternal":"No details provided","rehab":"Home nursing, Rehab and sub-acute facility (Subject to pre-authorisation): Unlimited in lieu of hospitalisation","designatedServiceProvider":"DSP pharmacies","conditionsCovered":"CDL in PMB + 2 additional","formulary":"Yes","partialLimits":"None","preferredProvider":"Network Providers","overallAnualLimit":"None","medicationOverCounter":"Limited to R50 per event","medicationPrescribed":"Unlimited, as dispensed by network GP\\n Subject to formulary","practitionersGeneral":"Network Providers: Unlimited\\n- 2 out-of-network visits per family","specialistsCover":"Unlimited benefit (subject to referral and pre-authorisation) Foundation specialist network applies","dentistryCover":"\\nSubject to Scheme Protocols, Network\\nProviders and annual limits of: \\nM: R2 249, M+ R3 747\\n","dentistryCoverSpecial":"No benefit","optical":"DSP's and 2-year benefit cycle\\n� Consultation, test, frame and single vision lenses:                  R1 258 per beneficiary OR\\n� Consultation, test, frame  bifocal lenses:                                 R1 915 per beneficiary\\nContact lenses: No benefit","ambulance":"100% of Scheme Rate\\nNetcare 911","international":"No details provided","hospitalCoverAids":"Limited to Network Provider and registration on HIV programme.","artTtreatment":"HIV Management Programme","preventative":"\\nPreventative Care Benefits\\n\\nScreening Tests : (Blood pressure, Blood sugar, BMI,  Cholesterol)\\n- Mammogram \\n- Pap Smear\\n- PSA Testing\\n- HIV Test\\n\\nVaccination\\n- Flu vaccination\\n- Childhood immunisations ( up to 18 months)\\n\\n","logo":"Health Squared.jpg"},{"company":"Health Squared","name":"foundation","planType":"Capitation","coverLevel":"Low","hospital":"Network","chronic":"Network","serviceType":"Network","familyIncome":"R8001 - R12000","mainContribution":"R1537","mainCompSavings":"R0.00","mainTotal":"R1537","dependendContributionAdult":"R1537","dependentCompSavingsAdult":"R0.00","dependentTotalAdult":"R1537","dependendContributionChild":"R691","dependentCompSavingsChild":"R0.00","dependentTotalChild":"R691","maxChildContribution":"","mainThreshold":"","dependentThresholdAdult":"","dependentThresholdChild":"","preferedHospitalProvider":"Network hospitals ","overallLimit":"Unlimited","coPayment":"No co-payment","rate":"100% of Scheme Rate ","generalMedicin":"7 days' supply","specialist":"Non-contracted Providers: 100% of Scheme Rate. Contracted Providers: 100% of Contracted Rate","dentistSurgical":"PMBs only                                                                               \\nPre-auth and protocols apply \\nMultiple hospital admissions are not covered","mentalHealth":"Psychiatric disorders: \\nSubject to PMB's at  Network Providers","radiology":"100% of Scheme Rate","pathology":"100% of Scheme Rate","maternityBenefit":"In hospital: 100% of Scheme Rate\\nNormal delivery: 3 days and 2 nights\\nCaesarean Section (emergency only):  Length of stay: 4 days and 3 nights\\nElective Caesarean Section : Limit of R11 740 if not authorised\\nOut-of-hospital: 9 visits at  GPs/ midwives \\nSpecialists require authorisation \\n2 x 2D scans\\n\\n","dialysis":"PMB's conditions at preferred providers ","cancer":"\\nUnlimited\\nICON Essential network protocols\\n40% Non-DSP co-payment\\nIncludes 10 day Hospice benefit\\n","transplant":"PMB's at Provincial hospitals","mri":"Unlimited cover for trauma and PMB-related scans\\n","prosthesisInternal":"PMB: unlimited\\nR42 136  per family per annum \\nSubject to prosthesis sub-limits   ","prosthesisExternal":"No details provided","rehab":"Home nursing, Rehab and sub-acute facility (Subject to pre-authorisation): Unlimited in lieu of hospitalisation","designatedServiceProvider":"DSP pharmacies","conditionsCovered":"CDL in PMB + 2 additional","formulary":"Yes","partialLimits":"None","preferredProvider":"Network Providers","overallAnualLimit":"None","medicationOverCounter":"Limited to R50 per event","medicationPrescribed":"Unlimited, as dispensed by network GP\\n Subject to formulary","practitionersGeneral":"Network Providers: Unlimited\\n- 2 out-of-network visits per family","specialistsCover":"Unlimited benefit (subject to referral and pre-authorisation) Foundation specialist network applies","dentistryCover":"\\nSubject to Scheme Protocols, Network\\nProviders and annual limits of: \\nM: R2 249, M+ R3 747\\n","dentistryCoverSpecial":"No benefit","optical":"DSP's and 2-year benefit cycle\\n� Consultation, test, frame and single vision lenses:                  R1 258 per beneficiary OR\\n� Consultation, test, frame  bifocal lenses:                                 R1 915 per beneficiary\\nContact lenses: No benefit","ambulance":"100% of Scheme Rate\\nNetcare 911","international":"No details provided","hospitalCoverAids":"Limited to Network Provider and registration on HIV programme.","artTtreatment":"HIV Management Programme","preventative":"\\nPreventative Care Benefits\\n\\nScreening Tests : (Blood pressure, Blood sugar, BMI,  Cholesterol)\\n- Mammogram \\n- Pap Smear\\n- PSA Testing\\n- HIV Test\\n\\nVaccination\\n- Flu vaccination\\n- Childhood immunisations ( up to 18 months)\\n\\n","logo":"Health Squared.jpg"},{"company":"Health Squared","name":"foundation","planType":"Capitation","coverLevel":"Low","hospital":"Network","chronic":"Network","serviceType":"Network","familyIncome":"R12001 - R15000","mainContribution":"R1646","mainCompSavings":"R0.00","mainTotal":"R1646","dependendContributionAdult":"R1646","dependentCompSavingsAdult":"R0.00","dependentTotalAdult":"R1646","dependendContributionChild":"R746","dependentCompSavingsChild":"R0.00","dependentTotalChild":"R746","maxChildContribution":"","mainThreshold":"","dependentThresholdAdult":"","dependentThresholdChild":"","preferedHospitalProvider":"Network hospitals ","overallLimit":"Unlimited","coPayment":"No co-payment","rate":"100% of Scheme Rate ","generalMedicin":"7 days' supply","specialist":"Non-contracted Providers: 100% of Scheme Rate. Contracted Providers: 100% of Contracted Rate","dentistSurgical":"PMBs only                                                                               \\nPre-auth and protocols apply \\nMultiple hospital admissions are not covered","mentalHealth":"Psychiatric disorders: \\nSubject to PMB's at  Network Providers","radiology":"100% of Scheme Rate","pathology":"100% of Scheme Rate","maternityBenefit":"In hospital: 100% of Scheme Rate\\nNormal delivery: 3 days and 2 nights\\nCaesarean Section (emergency only):  Length of stay: 4 days and 3 nights\\nElective Caesarean Section : Limit of R11 740 if not authorised\\nOut-of-hospital: 9 visits at  GPs/ midwives \\nSpecialists require authorisation \\n2 x 2D scans\\n\\n","dialysis":"PMB's conditions at preferred providers ","cancer":"\\nUnlimited\\nICON Essential network protocols\\n40% Non-DSP co-payment\\nIncludes 10 day Hospice benefit\\n","transplant":"PMB's at Provincial hospitals","mri":"Unlimited cover for trauma and PMB-related scans\\n","prosthesisInternal":"PMB: unlimited\\nR42 136  per family per annum \\nSubject to prosthesis sub-limits   ","prosthesisExternal":"No details provided","rehab":"Home nursing, Rehab and sub-acute facility (Subject to pre-authorisation): Unlimited in lieu of hospitalisation","designatedServiceProvider":"DSP pharmacies","conditionsCovered":"CDL in PMB + 2 additional","formulary":"Yes","partialLimits":"None","preferredProvider":"Network Providers","overallAnualLimit":"None","medicationOverCounter":"Limited to R50 per event","medicationPrescribed":"Unlimited, as dispensed by network GP\\n Subject to formulary","practitionersGeneral":"Network Providers: Unlimited\\n- 2 out-of-network visits per family","specialistsCover":"Unlimited benefit (subject to referral and pre-authorisation) Foundation specialist network applies","dentistryCover":"\\nSubject to Scheme Protocols, Network\\nProviders and annual limits of: \\nM: R2 249, M+ R3 747\\n","dentistryCoverSpecial":"No benefit","optical":"DSP's and 2-year benefit cycle\\n� Consultation, test, frame and single vision lenses:                  R1 258 per beneficiary OR\\n� Consultation, test, frame  bifocal lenses:                                 R1 915 per beneficiary\\nContact lenses: No benefit","ambulance":"100% of Scheme Rate\\nNetcare 911","international":"No details provided","hospitalCoverAids":"Limited to Network Provider and registration on HIV programme.","artTtreatment":"HIV Management Programme","preventative":"\\nPreventative Care Benefits\\n\\nScreening Tests : (Blood pressure, Blood sugar, BMI,  Cholesterol)\\n- Mammogram \\n- Pap Smear\\n- PSA Testing\\n- HIV Test\\n\\nVaccination\\n- Flu vaccination\\n- Childhood immunisations ( up to 18 months)\\n\\n","logo":"Health Squared.jpg"},{"company":"Health Squared","name":"foundation","planType":"Capitation","coverLevel":"Low","hospital":"Network","chronic":"Network","serviceType":"Network","familyIncome":"R15000 - R18 700","mainContribution":"R2986","mainCompSavings":"R0.00","mainTotal":"R2986","dependendContributionAdult":"R2986","dependentCompSavingsAdult":"R0.00","dependentTotalAdult":"R2986","dependendContributionChild":"R1029","dependentCompSavingsChild":"R0.00","dependentTotalChild":"R1029","maxChildContribution":"","mainThreshold":"","dependentThresholdAdult":"","dependentThresholdChild":"","preferedHospitalProvider":"Network hospitals ","overallLimit":"Unlimited","coPayment":"No co-payment","rate":"100% of Scheme Rate ","generalMedicin":"7 days' supply","specialist":"Non-contracted Providers: 100% of Scheme Rate. Contracted Providers: 100% of Contracted Rate","dentistSurgical":"PMBs only                                                                               \\nPre-auth and protocols apply \\nMultiple hospital admissions are not covered","mentalHealth":"Psychiatric disorders: \\nSubject to PMB's at  Network Providers","radiology":"100% of Scheme Rate","pathology":"100% of Scheme Rate","maternityBenefit":"In hospital: 100% of Scheme Rate\\nNormal delivery: 3 days and 2 nights\\nCaesarean Section (emergency only):  Length of stay: 4 days and 3 nights\\nElective Caesarean Section : Limit of R11 740 if not authorised\\nOut-of-hospital: 9 visits at  GPs/ midwives \\nSpecialists require authorisation \\n2 x 2D scans\\n\\n","dialysis":"PMB's conditions at preferred providers ","cancer":"\\nUnlimited\\nICON Essential network protocols\\n40% Non-DSP co-payment\\nIncludes 10 day Hospice benefit\\n","transplant":"PMB's at Provincial hospitals","mri":"Unlimited cover for trauma and PMB-related scans\\n","prosthesisInternal":"PMB: unlimited\\nR42 136  per family per annum \\nSubject to prosthesis sub-limits   ","prosthesisExternal":"No details provided","rehab":"Home nursing, Rehab and sub-acute facility (Subject to pre-authorisation): Unlimited in lieu of hospitalisation","designatedServiceProvider":"DSP pharmacies","conditionsCovered":"CDL in PMB + 2 additional","formulary":"Yes","partialLimits":"None","preferredProvider":"Network Providers","overallAnualLimit":"None","medicationOverCounter":"Limited to R50 per event","medicationPrescribed":"Unlimited, as dispensed by network GP\\n Subject to formulary","practitionersGeneral":"Network Providers: Unlimited\\n- 2 out-of-network visits per family","specialistsCover":"Unlimited benefit (subject to referral and pre-authorisation) Foundation specialist network applies","dentistryCover":"\\nSubject to Scheme Protocols, Network\\nProviders and annual limits of: \\nM: R2 249, M+ R3 747\\n","dentistryCoverSpecial":"No benefit","optical":"DSP's and 2-year benefit cycle\\n� Consultation, test, frame and single vision lenses:                  R1 258 per beneficiary OR\\n� Consultation, test, frame  bifocal lenses:                                 R1 915 per beneficiary\\nContact lenses: No benefit","ambulance":"100% of Scheme Rate\\nNetcare 911","international":"No details provided","hospitalCoverAids":"Limited to Network Provider and registration on HIV programme.","artTtreatment":"HIV Management Programme","preventative":"\\nPreventative Care Benefits\\n\\nScreening Tests : (Blood pressure, Blood sugar, BMI,  Cholesterol)\\n- Mammogram \\n- Pap Smear\\n- PSA Testing\\n- HIV Test\\n\\nVaccination\\n- Flu vaccination\\n- Childhood immunisations ( up to 18 months)\\n\\n","logo":"Health Squared.jpg"},{"company":"Health Squared","name":"foundation","planType":"Capitation","coverLevel":"Low","hospital":"Network","chronic":"Network","serviceType":"Network","familyIncome":"R18 701+","mainContribution":"R3812","mainCompSavings":"R0.00","mainTotal":"R3812","dependendContributionAdult":"R3812","dependentCompSavingsAdult":"R0.00","dependentTotalAdult":"R3812","dependendContributionChild":"R1307","dependentCompSavingsChild":"R0.00","dependentTotalChild":"R1307","maxChildContribution":"","mainThreshold":"","dependentThresholdAdult":"","dependentThresholdChild":"","preferedHospitalProvider":"Network hospitals ","overallLimit":"Unlimited","coPayment":"No co-payment","rate":"100% of Scheme Rate ","generalMedicin":"7 days' supply","specialist":"Non-contracted Providers: 100% of Scheme Rate. Contracted Providers: 100% of Contracted Rate","dentistSurgical":"PMBs only                                                                               \\nPre-auth and protocols apply \\nMultiple hospital admissions are not covered","mentalHealth":"Psychiatric disorders: \\nSubject to PMB's at  Network Providers","radiology":"100% of Scheme Rate","pathology":"100% of Scheme Rate","maternityBenefit":"In hospital: 100% of Scheme Rate\\nNormal delivery: 3 days and 2 nights\\nCaesarean Section (emergency only):  Length of stay: 4 days and 3 nights\\nElective Caesarean Section : Limit of R11 740 if not authorised\\nOut-of-hospital: 9 visits at  GPs/ midwives \\nSpecialists require authorisation \\n2 x 2D scans\\n\\n","dialysis":"PMB's conditions at preferred providers ","cancer":"\\nUnlimited\\nICON Essential network protocols\\n40% Non-DSP co-payment\\nIncludes 10 day Hospice benefit\\n","transplant":"PMB's at Provincial hospitals","mri":"Unlimited cover for trauma and PMB-related scans\\n","prosthesisInternal":"PMB: unlimited\\nR42 136  per family per annum \\nSubject to prosthesis sub-limits   ","prosthesisExternal":"No details provided","rehab":"Home nursing, Rehab and sub-acute facility (Subject to pre-authorisation): Unlimited in lieu of hospitalisation","designatedServiceProvider":"DSP pharmacies","conditionsCovered":"CDL in PMB + 2 additional","formulary":"Yes","partialLimits":"None","preferredProvider":"Network Providers","overallAnualLimit":"None","medicationOverCounter":"Limited to R50 per event","medicationPrescribed":"Unlimited, as dispensed by network GP\\n Subject to formulary","practitionersGeneral":"Network Providers: Unlimited\\n- 2 out-of-network visits per family","specialistsCover":"Unlimited benefit (subject to referral and pre-authorisation) Foundation specialist network applies","dentistryCover":"\\nSubject to Scheme Protocols, Network\\nProviders and annual limits of: \\nM: R2 249, M+ R3 747\\n","dentistryCoverSpecial":"No benefit","optical":"DSP's and 2-year benefit cycle\\n� Consultation, test, frame and single vision lenses:                  R1 258 per beneficiary OR\\n� Consultation, test, frame  bifocal lenses:                                 R1 915 per beneficiary\\nContact lenses: No benefit","ambulance":"100% of Scheme Rate\\nNetcare 911","international":"No details provided","hospitalCoverAids":"Limited to Network Provider and registration on HIV programme.","artTtreatment":"HIV Management Programme","preventative":"\\nPreventative Care Benefits\\n\\nScreening Tests : (Blood pressure, Blood sugar, BMI,  Cholesterol)\\n- Mammogram \\n- Pap Smear\\n- PSA Testing\\n- HIV Test\\n\\nVaccination\\n- Flu vaccination\\n- Childhood immunisations ( up to 18 months)\\n\\n","logo":"Health Squared.jpg"},{"company":"Key Health","name":"Platinum Option","planType":"Threshold option","coverLevel":"High","hospital":"Network","chronic":"Network","serviceType":"Network","familyIncome":"","mainContribution":"R9624","mainCompSavings":"R0.00","mainTotal":"R9624","dependendContributionAdult":"R6747","dependentCompSavingsAdult":"R0.00","dependentTotalAdult":"R6747","dependendContributionChild":"R2031","dependentCompSavingsChild":"R0.00","dependentTotalChild":"R2031","maxChildContribution":"3","mainThreshold":"","dependentThresholdAdult":"","dependentThresholdChild":"","preferedHospitalProvider":"DSP  hospital (Netcare or Life Healthcare and Mediclinic in Western Cape only)","overallLimit":"Unlimited","coPayment":"Colonoscopy and/or Gastroscopy, Sigmoidoscopy, Cystoscopy, Hysteroscopy, Arthroscopy, Laparoscopy\\nNo co-payment if done in DSP Hospital / Provider�s rooms and in the case of PMB conditions\\nAll other endoscopic procedures: \\nNo co-payment if done in DSP Hospital / Provider�s rooms and in the case of PMB conditions","rate":"100% of Scheme Rate","generalMedicin":"R575 per admission","specialist":"100% of Scheme Rate","dentistSurgical":"Maxillo-Facial and Oral surgery\\nPre-authorisation by DENIS  \\n\\nHospitalisation and Anaesthetics\\nGeneral anaesthetic for children under the age of 5, for extensive dental treatment.\\nRemoval of impacted wisdom teeth\\nPre-authorisation by DENIS  \\n","mentalHealth":"R60 200 per family per annum, combined limit in-and-out-of-hospital\\nSub-limit of R25 100 per family for out-of-hospital psychiatric treatment ","radiology":"100% of Scheme Rate - unlimited","pathology":"100% of Scheme Rate - unlimited","maternityBenefit":"In-hospital: 100% Scheme Rate\\nPrivate ward: 3 days for natural birth  \\nOut-of-hospital:\\n� 12 Antenatal visits\\n� Paediatric visits for registered baby: 2 visits in baby�s 1st year, 1 visit in baby�s 2nd year\\n�  3 baby growth assessments per year for babies aged 35 months and older\\n� Antenatal classes: R2 180 first pregnancy only\\n� Antenatal vitamins: R2 180 \\n� Two scans per pregnancy\\nR1 290 to cover any short payment/co-payment for certain maternity related services and/or certain baby related appliances\\n","dialysis":"100% of Scheme Rate - unlimited     \\nPre-authorisation compulsory and subject to case management and Scheme protocols","cancer":"100% of Scheme Rate - unlimited    \\nPre-authorisation compulsory and subject to case management and Scheme protocols\\n","transplant":"100% of Scheme Rate - unlimited    \\nPre-authorisation compulsory and subject to DSP and case management\\n","mri":"In and out of hospital: R26 700 per family per annum\\nPET scans: 2 pbpa, max of R25 200 per scan","prosthesisInternal":"Unlimited (internal, external, fixation devices and implanted devices)\\nSubject to DSP and reference price","prosthesisExternal":"Appliances: In-and-out-of-Hospital  \\nR12 450 per family per annum\\nHearing aids: R37 700 per family per 5th year; max of R18 700 per year\\nMaintenance batteries included in hearing aids: R1 435 per beneficiary per annum","rehab":"Combined limit for alternatives to hospitalisation of R53 500 per family per annum, subject to case management \\nWound Care: R18 500 sub-limit per family\\nPalliative Care: In lieu of hospital admission","designatedServiceProvider":"Yes - Keyhealth DSP pharmacies","conditionsCovered":"55 conditions including PMBs","formulary":"Yes","partialLimits":"Unlimited for 26 conditions  \\n29 non-CDL conditions limited to: \\nR20 500 per beneficiary per annum , R41 900 per family per year subject to reference price \\n","preferredProvider":"Specialist Network � OneCare","overallAnualLimit":"Day-to-day limit which includes GP and Specialist consultations, Radiology, Prescribed medication and self medication, Optical and Auxiliary services, contraceptive pills and biokinetics.        \\nPM: R11 685 per annum\\nAD:  R11 335 per annum\\nCD: R2 770 per annum","medicationOverCounter":"R3 280 per family per annum sub-limit\\nsubject to overall day-to-day benefits and/or threshold","medicationPrescribed":"\\n100% of Scheme Rate  \\nSubject to overall day-to-day benefits limit and/or threshold\\n","practitionersGeneral":"100% of Scheme Rate  \\n(Subject to overall day-to-day benefits limit and/or threshold)","specialistsCover":"(Subject to Onecare network and overall day-to-day benefits limit and/or threshold)","dentistryCover":"100% of Scheme Rate\\nOrthodontics (non-cosmetic), Child 9-18 years\\nSubject to DENIS protocols, and sub-limits","dentistryCoverSpecial":"\\nSubject to DENIS clinical protocols\\n100% of Scheme Rate \\nSubject to DENIS clinical protocols\\nImplants: R4 700 per beneficiary per annum \\n","optical":"Subject to day-to-day benefit and thresholds \\nR5 650 Pbp2a \\n\\nThe following sub-limits apply\\nFrames: R1 690 per frame pbp2a\\nLenses: 1 pair pbp2a\\nEye test: 1 test pbp2a                             \\nContact lenses: R2 620 per beneficiary\\nRefractive surgery: R11 450 pbp2a. Pre-auth compulsory \\n\\nOTC reading glasses: R225 per beneficiary per annum, subject to over-the-counter medicine sub-limit                                                                      ","ambulance":"National: Netcare 911  ","international":"R6 mil per beneficiary, per journey relating to in-hospital and emergency treatment","hospitalCoverAids":"Unlimited, subject to management programme (LifeSense)","artTtreatment":"Unlimited, subject to management programme","preventative":"Health Booster, preventative treatment and early detection: \\nBaby immunisation\\nFlu vaccination\\nTetanus diphtheria injection\\nPneumococcal vaccination\\nMammogram\\nPap smears\\nProstate specific antigen\\nHealth Assessment\\nMalaria medication (R415 pbpa), \\n\\n�Smart Baby\\n� Dental emergencies cover\\n� Easy-ER: (No upfront payments required)\\n� Back and neck treatment in lieu of surgery","logo":"keyhealth.png"},{"company":"Key Health","name":"Essence Option","planType":"Hospital plan","coverLevel":"Mid","hospital":"Network","chronic":"Network","serviceType":"N/A","familyIncome":"","mainContribution":"R1697","mainCompSavings":"R0.00","mainTotal":"R1697","dependendContributionAdult":"R1360","dependentCompSavingsAdult":"R0.00","dependentTotalAdult":"R1360","dependendContributionChild":"R612","dependentCompSavingsChild":"R0.00","dependentTotalChild":"R612","maxChildContribution":"all","mainThreshold":"","dependentThresholdAdult":"","dependentThresholdChild":"","preferedHospitalProvider":"DSP  hospital (Netcare or Life Healthcare and Mediclinic in Western Cape only)","overallLimit":"Unlimited","coPayment":"30% co-pay for non-DSP hospital\\nColonoscopy and/or Gastroscopy: \\nNo co-payment if done in DSP Hospital/ Provider�s room\\nAll other endoscopic procedures: \\nNo co-payment if done in DSP Hospital / Provider�s rooms and in the case of PMB conditions","rate":"100% Scheme Rate ","generalMedicin":"R575 per admission","specialist":"100% of Scheme Rate\\nUnlimited, subject to use of DSP provider","dentistSurgical":"No benefit","mentalHealth":"R21 500 per family per annum, pre-auth compulsory \\nOut-of-hospital: PMBs only","radiology":"100% Scheme Rate, unlimited","pathology":"100% Scheme Rate, unlimited","maternityBenefit":"In-hospital: 100% Scheme Rate\\n3 days for natural birth  \\nOut-of-hospital:\\n� 12 Antenatal visits;\\n� 2 Paediatric visits for registered baby in  baby�s 1st year and a 3rd visit within baby�s 2nd year\\n� 3 baby growth assessments per year for babies aged 35 months and older\\n� Antenatal classes: R2 180 first pregnancy only\\n� Antenatal vitamins: R2 180 \\n� Two scans per pregnancy\\nR1 290 to cover any short payment/co-payment for certain maternity related services and/or certain baby related appliances\\n","dialysis":"Pre-auth compulsory. Subject to case management and PMBs only ","cancer":"R169 000 per family per annum\\nPMB once exceeded, subject to DSP","transplant":"Pre-auth compulsory. Subject to case management and PMBs only ","mri":"In and Out of Hospital: R17 800 per family per annum\\nPET scans: No benefit","prosthesisInternal":"Subject to pre-authorisation and Scheme protocols(internal, external, fixation devices and implanted devices). PMB entitlement only","prosthesisExternal":"External: Subject to pre-authorisation and Scheme protocols. PMB entitlement only\\nAppliances - In and out of hospital: \\n- R7 900 per family per annum\\nHearing aids: No benefit","rehab":"100% of Scheme Rate\\nPre-auth compulsory. Subject to case management and PMBs only \\nPalliative Care: In lieu of hospital admission","designatedServiceProvider":"Yes - Keyhealth DSP pharmacies","conditionsCovered":"CDL in PMB\\nCover for 26 chronic medical conditions","formulary":"Yes","partialLimits":"Hormone Replacement Therapy (HRT) additional to CDL","preferredProvider":"None","overallAnualLimit":"None","medicationOverCounter":"No benefit","medicationPrescribed":"No benefit","practitionersGeneral":"No benefit","specialistsCover":"No benefit","dentistryCover":"No benefit\\nDental consultation pbpa available via Health Booster benefit. Limit of 743 ","dentistryCoverSpecial":"No benefit","optical":"No benefit","ambulance":"National: Netcare 911  ","international":"R6 million per beneficiary, per journey relating to in-hospital and emergency treatment","hospitalCoverAids":"Unlimited, subject to management programme (LifeSense)","artTtreatment":"Unlimited, Subject to management programme","preventative":"Health Booster: \\nPreventative treatment and early detection\\nBaby immunisation, Flu vaccination, HPV vaccine, Tetanus diphtheria injection,\\nPneumococcal vaccination, Mammogram\\nPap smears, Prostate specific antigen\\nHealth Assessment, Covid-19 vaccination\\n\\nContraceptives: oral tablets or injectable\\nMalaria medication (R415 pbpa) \\n\\n�Smart Baby\\n� Dental emergencies cover\\n� Easy-ER: (No upfront payments required)\\n� (DBC) Back and neck treatment in lieu of surgery","logo":"keyhealth.png"},{"company":"Key Health","name":"Origin Option","planType":"Traditional","coverLevel":"Mid","hospital":"Network","chronic":"Network","serviceType":"Any","familyIncome":"","mainContribution":"R1939","mainCompSavings":"R0.00","mainTotal":"R1939","dependendContributionAdult":"R1381","dependentCompSavingsAdult":"R0.00","dependentTotalAdult":"R1381","dependendContributionChild":"R631","dependentCompSavingsChild":"R0.00","dependentTotalChild":"R631","maxChildContribution":"all","mainThreshold":"","dependentThresholdAdult":"","dependentThresholdChild":"","preferedHospitalProvider":"DSP  hospital (Netcare or Life Healthcare and Mediclinic in Western Cape only)","overallLimit":"0","coPayment":"30% co-pay for non-DSP hospital\\nColonoscopy and/or Gastroscopy: \\nNo co-payment if done in DSP Hospital/ Provider�s room\\nAll other endoscopic procedures: \\nNo co-payment if done in DSP Hospital / Provider�s rooms  and in the case of PMB conditions","rate":"100% Scheme Rate ","generalMedicin":"R575 per admission","specialist":"100% of Scheme Rate\\nUnlimited, subject to use of DSP provider","dentistSurgical":"100% of scheme Rate\\nMaxillo-Facial and Oral surgery: DENIS protocols and Scheme Rules apply  \\n \\nHospitalisation and Anaesthetics\\nRemoval of impacted wisdom teeth only\\nPre-authorisation by DENIS   \\n","mentalHealth":"R21 500 per family per annum, pre-auth compulsory \\nOut-of-hospital: PMBs only","radiology":"100% Scheme Rate, unlimited","pathology":"100% Scheme Rate, unlimited","maternityBenefit":"In-hospital: 100% Scheme Rate\\nPrivate ward: 3 days for natural birth  \\nOut-of-hospital:\\n� 12 Antenatal visits;\\n� 2 Paediatric visits for registered baby in  baby�s 1st year and a 3rd visit within baby�s 2nd year\\n� 3 baby growth assessments per year for babies aged 35 months and older\\n� Antenatal classes: R2 180 first pregnancy only\\n� Antenatal vitamins: R2 180  \\n� Two scans per pregnancy\\nR1 290 to cover any short payment/co-payment for certain maternity related services and/or certain baby related appliances\\n","dialysis":"Pre-auth compulsory. Subject to case management and PMBs only ","cancer":"R169 000 per family per annum\\nPMB once exceeded, subject to DSP","transplant":"Pre-auth compulsory. Subject to case management and PMBs only ","mri":"In and Out of Hospital: R17 800 per family per annum\\nPET scans: No benefit","prosthesisInternal":"Subject to pre-authorisation and Scheme protocols(internal, external, fixation devices and implanted devices). PMB entitlement only","prosthesisExternal":"External: Subject to pre-authorisation and Scheme protocols. PMB entitlement only\\nAppliances - In and out of hospital: \\n- R7 900 per family per annum\\nHearing aids: No benefit","rehab":"100% of Scheme Rate\\nPre-auth compulsory. Subject to case management and PMBs only \\nPalliative Care: In lieu of hospital admission","designatedServiceProvider":"Yes - Keyhealth DSP pharmacies","conditionsCovered":"CDL in PMBs\\nCover for 26 chronic medical conditions","formulary":"Yes","partialLimits":"Hormone Replacement Therapy (HRT) additional to CDL","preferredProvider":"None","overallAnualLimit":"100% Scheme Rate  \\nDay-to-day limit which includes GP and Specialist consultations, Radiology, Prescribed and self medication, Optical and Auxiliary services and biokinetics\\nPM: R2 815 per annum\\nAD: R1 640 per annum\\nCH: R865 per annum","medicationOverCounter":"Subject to day-to-day benefit","medicationPrescribed":"Subject to day-to-day benefit","practitionersGeneral":"Subject to day-to-day benefit","specialistsCover":"Subject to day-to-day benefit","dentistryCover":"Subject to day-to-day benefit. \\nScheme Rules and protocols apply.\\nPlastic dentures: no benefit","dentistryCoverSpecial":"No benefit","optical":"Subject to day-to-day benefit\\nOTC reading glasses: R120 per beneficiary per annum\\n","ambulance":"National: Netcare 911  ","international":"R6 million per beneficiary, per journey relating to in-hospital and emergency treatment","hospitalCoverAids":"Unlimited, subject to management programme (LifeSense)","artTtreatment":"Unlimited, Subject to management programme","preventative":"Health Booster: \\nPreventative treatment and early detection\\nBaby immunisation, Flu vaccination, HPV vaccine, Tetanus diphtheria injection,\\nPneumococcal vaccination, Mammogram\\nPap smears, Prostate specific antigen\\nHealth Assessment, Covid-19 vaccination\\n\\nContraceptives: oral tablets or injectable\\nMalaria medication (R415 pbpa) \\n\\n�Smart Baby\\n� Dental emergencies cover\\n� Easy-ER: (No upfront payments required)\\n� (DBC) Back and neck treatment in lieu of surgery","logo":"keyhealth.png"},{"company":"Key Health","name":"Equilibrium Option","planType":"Hybrid","coverLevel":"Mid","hospital":"Network","chronic":"Network","serviceType":"Any","familyIncome":"","mainContribution":"R2196","mainCompSavings":"R172","mainTotal":"R2368","dependendContributionAdult":"R1357","dependentCompSavingsAdult":"R106","dependentTotalAdult":"R1463","dependendContributionChild":"R674","dependentCompSavingsChild":"R53","dependentTotalChild":"R727","maxChildContribution":"3","mainThreshold":"","dependentThresholdAdult":"","dependentThresholdChild":"","preferedHospitalProvider":"DSP  hospital (Netcare or Life Healthcare and Mediclinic in Western Cape only)","overallLimit":"Unlimited","coPayment":"30% co-pay for non-DSP hospital\\nColonoscopy and/or Gastroscopy: \\nNo co-payment if done in DSP Hospital/ Provider�s room\\nAll other endoscopic procedures: \\nNo co-payment if done in DSP Hospital / Provider�s rooms  and in the case of PMB conditions","rate":"100% Scheme Rate ","generalMedicin":"R575 per admission","specialist":"100% of Scheme Rate\\nUnlimited, subject to use of DSP provider","dentistSurgical":"100% of Scheme Rate\\nMaxillo-Facial and Oral surgery: Pre-authorisation by DENIS   \\nGeneral anaesthetic for children under the age of 5, for extensive dental treatment\\nRemoval of impacted wisdom teeth: Pre-authorisation by DENIS   \\n","mentalHealth":"R21 500 per family per annum, pre-auth compulsory \\nOut-of-hospital: PMBs only","radiology":"100% Scheme Rate, unlimited","pathology":"100% Scheme Rate, unlimited","maternityBenefit":"In-hospital: 100% Scheme Rate\\nPrivate ward: 3 days for natural birth  \\nOut-of-hospital:\\n� 12 Antenatal visits;\\n� 2 Paediatric visits for registered baby in  baby�s 1st year and a 3rd visit within baby�s 2nd year\\n� 3 baby growth assessments per year for babies aged 35 months and older\\n� Antenatal classes: R2 180 first pregnancy only\\n� Antenatal vitamins: R2 180  \\n� Two scans per pregnancy\\nR1 290 to cover any short payment/co-payment for certain maternity related services and/or certain baby related appliances\\n","dialysis":"Pre-auth compulsory. Subject to case management and PMBs only ","cancer":"R169 000 per family per annum\\nPMB once exceeded, subject to DSP","transplant":"Pre-auth compulsory. Subject to case management and PMBs only ","mri":"In and Out of Hospital: R17 800 per family per annum\\nPET scans: No benefit","prosthesisInternal":"R3 500 per family per annum for (internal, external, fixation devices and implanted devices)\\nSubject to reference pricing and DSP","prosthesisExternal":"External: Subject to pre-authorisation and Scheme protocols. PMB entitlement only\\nAppliances - In and out of hospital: \\n- R7 900 per family per annum\\nHearing aids: No benefit","rehab":"100% of Scheme Rate\\nPre-auth compulsory. Subject to case management and PMBs only \\nPalliative Care: In lieu of hospital admission","designatedServiceProvider":"Yes - Keyhealth DSP pharmacies","conditionsCovered":"CDL in PMBs\\nCover for 29 chronic medical conditions","formulary":"Yes","partialLimits":"3 Additional non-CDL conditions: Acne;\\n? ADHD/ADD/Hyperkinesis; ? Rhinitis \\nFor children up to the age of 21 years\\nCo-payment directly to service provider\\nHormone Replacement Therapy (HRT) additional to CDL","preferredProvider":"None","overallAnualLimit":"100% Scheme Rate  \\nDay-to-day limit which includes GP and Specialist consultations, Radiology, Prescribed and self medication, Optical and Auxiliary services and biokinetics\\nPM: R3 090 per annum\\nAD: R2 125 per annum\\nCH: R945 per annum","medicationOverCounter":"Subject to savings and/or day-to-day benefit ","medicationPrescribed":"Subject to savings and/or day-to-day benefit ","practitionersGeneral":"Subject to savings and/or day-to-day benefit ","specialistsCover":"100% of MST                                                                                                            (subject to overall day-to-day benefits and savings) ","dentistryCover":"100% of Scheme Rate\\nSubject to DENIS protocols, and sub-limits. Includes plastic dentures","dentistryCoverSpecial":"100% of Scheme Rate\\nOrthodontics (non-cosmetic), Child 9-18 years\\nSubject to DENIS protocols, and sub-limits. ","optical":"Subject to savings and/or day-to-day benefit \\nOTC reading glasses: R120 per beneficiary per annum\\n                                                                            ","ambulance":"National: Netcare 911  ","international":"R6 million per beneficiary, per journey relating to in-hospital and emergency treatment","hospitalCoverAids":"Unlimited, subject to management programme (LifeSense)","artTtreatment":"Unlimited, Subject to management programme","preventative":"Health Booster: \\nPreventative treatment and early detection\\nBaby immunisation, Flu vaccination, HPV vaccine, Tetanus diphtheria injection,\\nPneumococcal vaccination, Mammogram\\nPap smears, Prostate specific antigen\\nHealth Assessment, Covid-19 vaccination\\n\\nContraceptives: oral tablets or injectable\\nMalaria medication (R415 pbpa) \\n\\n�Smart Baby\\n� Dental emergencies cover\\n� Easy-ER: (No upfront payments required)\\n� (DBC) Back and neck treatment in lieu of surgery","logo":"keyhealth.png"},{"company":"Key Health","name":"Silver Option","planType":"Traditional","coverLevel":"Mid","hospital":"Network","chronic":"Network","serviceType":"Any","familyIncome":"","mainContribution":"R4084","mainCompSavings":"R0.00","mainTotal":"R4084","dependendContributionAdult":"R2197","dependentCompSavingsAdult":"R0.00","dependentTotalAdult":"R2197","dependendContributionChild":"R852","dependentCompSavingsChild":"R0.00","dependentTotalChild":"R852","maxChildContribution":"3","mainThreshold":"","dependentThresholdAdult":"","dependentThresholdChild":"","preferedHospitalProvider":"DSP  hospital (Netcare or Life Healthcare and Mediclinic in Western Cape only)","overallLimit":"Unlimited","coPayment":"30% co-pay for non-DSP hospital\\nColonoscopy and/or Gastroscopy: \\nNo co-payment if done in DSP Hospital/ Provider�s room\\nAll other endoscopic procedures: \\nNo co-payment if done in DSP Hospital / Provider�s rooms  and in the case of PMB conditions","rate":"100% Scheme Rate ","generalMedicin":"R575 per admission","specialist":"100% of Scheme Rate\\nUnlimited, subject to use of DSP provider","dentistSurgical":"100% of Scheme Rate\\nMaxillo-Facial and Oral surgery: Pre-authorisation by DENIS   \\nGeneral anaesthetic for children under the age of 5, for extensive dental treatment\\nRemoval of impacted wisdom teeth: Pre-authorisation by DENIS   \\n","mentalHealth":"R21 500 per family per annum, pre-auth compulsory \\nOut-of-hospital: PMBs only","radiology":"100% Scheme Rate, unlimited","pathology":"100% Scheme Rate, unlimited","maternityBenefit":"In-hospital: 100% Scheme Rate\\nPrivate ward: 3 days for natural birth  \\nOut-of-hospital:\\n� 12 Antenatal visits;\\n� 2 Paediatric visits for registered baby in  baby�s 1st year and a 3rd visit within baby�s 2nd year\\n� 3 baby growth assessments per year for babies aged 35 months and older\\n� Antenatal classes: R2 180 first pregnancy only\\n� Antenatal vitamins: R2 180  \\n� Two scans per pregnancy\\nR1 290 to cover any short payment/co-payment for certain maternity related services and/or certain baby related appliances\\n","dialysis":"Pre-auth compulsory. Subject to case management and PMBs only ","cancer":"R189 500 per family per annum\\nPMB once exceeded, subject to DSP","transplant":"Pre-auth compulsory. Subject to case management and PMBs only ","mri":"In and Out of Hospital: R17 800 per family per annum \\nPET scans: No benefit","prosthesisInternal":"R6 900 per family per annum for (internal, external, fixation devices and implanted devices)\\nSubject to DSP and Scheme protocols","prosthesisExternal":"In and out of hospital - R8 200 per family per annum\\nHearing aids and maintenance incl in above (subject to medical appliances benefit)","rehab":"100% of Scheme Rate \\nCombined limit for alternatives to hospitalisation: R32 100 family limit p.a.\\nWound Care: R10 300 sub-limit per family\\nPalliative Care: In lieu of hospital admission","designatedServiceProvider":"Yes - Keyhealth DSP pharmacies","conditionsCovered":"CDL in PMBs\\nCover for 29 chronic medical conditions","formulary":"Yes","partialLimits":"3 Additional non-CDL conditions: Acne;\\n? ADHD/ADD/Hyperkinesis; ? Rhinitis \\nFor children up to the age of 21 years\\nCo-payment directly to service provider\\nHormone Replacement Therapy (HRT) additional to CDL","preferredProvider":"None","overallAnualLimit":"100% Scheme Rate  \\nDay-to-day limit which includes GP and Specialist consultations, Radiology, Prescribed and self medication, Optical and Auxiliary services and biokinetics.    \\nPM: R8 315 per annum\\nR6 045 per annum\\nCH: R1 680 per annum","medicationOverCounter":"Subject to day-to-day benefit\\nSub-limit of R1 790 per family per annum","medicationPrescribed":"Subject to day-to-day benefit","practitionersGeneral":"Subject to day-to-day benefit limit\\n3 additional GP visits for children (up to 21 years) when day-to-day limits are depleted ","specialistsCover":"Subject to day-to-day benefit","dentistryCover":"100% of Scheme Rate\\nSubject to DENIS protocols, and sub-limits. Includes plastic dentures","dentistryCoverSpecial":"100% of Scheme Rate\\nOrthodontics (non-cosmetic), Child 9-18 years\\nSubject to DENIS protocols, and sub-limits. ","optical":"Subject to day-to-day benefit\\nR1 690 Pbp2a\\n(Benefit confirmation compulsory)\\n\\nSub-limits per beneficiary:\\nFrames: R560 per frame \\nLenses: 1 pair single vision lenses\\nEye test: 1 test                                                         \\nContact lenses: R755  \\n\\nOTC reading glasses: R135 per beneficiary per annum\\nsubject to over-the-counter medicine sub-limit                                                                                                                                            ","ambulance":"National: Netcare 911  ","international":"R6 million per beneficiary, per journey relating to in-hospital and emergency treatment","hospitalCoverAids":"Unlimited, subject to management programme (LifeSense)","artTtreatment":"Unlimited, Subject to management programme","preventative":"Health Booster: \\nPreventative treatment and early detection\\nBaby immunisation, Flu vaccination, HPV vaccine, Tetanus diphtheria injection,\\nPneumococcal vaccination, Mammogram\\nPap smears, Prostate specific antigen\\nHealth Assessment, Covid-19 vaccination\\n\\nContraceptives: oral tablets or injectable\\nMalaria medication (R415 pbpa) \\n\\n�Smart Baby\\n� Dental emergencies cover\\n� Easy-ER: (No upfront payments required)\\n� (DBC) Back and neck treatment in lieu of surgery","logo":"keyhealth.png"},{"company":"Key Health","name":"Gold Option","planType":"Hybrid","coverLevel":"Mid","hospital":"Network","chronic":"Network","serviceType":"Any","familyIncome":"","mainContribution":"R5380","mainCompSavings":"R597","mainTotal":"R5977","dependendContributionAdult":"R3638","dependentCompSavingsAdult":"R404","dependentTotalAdult":"R4042","dependendContributionChild":"R1056","dependentCompSavingsChild":"R117","dependentTotalChild":"R1173","maxChildContribution":"3","mainThreshold":"","dependentThresholdAdult":"","dependentThresholdChild":"","preferedHospitalProvider":"DSP  hospital (Netcare or Life Healthcare and Mediclinic in Western Cape only)","overallLimit":"Unlimited","coPayment":"30% co-pay for non-DSP hospital\\nColonoscopy and/or Gastroscopy: \\nNo co-payment if done in DSP Hospital/ Provider�s room and in the case of PMB conditions\\nAll other endoscopic procedures: \\nNo co-payment if done in DSP Hospital / Provider�s rooms and in the case of PMB conditions","rate":"100% Scheme Rate ","generalMedicin":"R575 per admission","specialist":"100% of Scheme Rate\\nUnlimited, subject to use of DSP provider","dentistSurgical":"100% of Scheme Rate\\nMaxillo-Facial and Oral surgery: Pre-authorisation by DENIS   \\nGeneral anaesthetic for children under the age of 5, for extensive dental treatment\\nRemoval of impacted wisdom teeth: Pre-authorisation by DENIS   \\n","mentalHealth":"100% of Scheme Rate\\nR43 600 per family  per annum\\nSub-limit of R17 800 for out-of-hospital psychiatric treatment ","radiology":"100% Scheme Rate, unlimited","pathology":"100% Scheme Rate, unlimited","maternityBenefit":"In-hospital: 100% Scheme Rate\\nPrivate ward: 3 days for natural birth  \\nOut-of-hospital:\\n� 12 Antenatal visits;\\n� 2 Paediatric visits for registered baby in  baby�s 1st year and a 3rd visit within baby�s 2nd year\\n� 3 baby growth assessments per year for babies aged 35 months and older)\\n� Antenatal classes: R2 180 first pregnancy only\\n� Antenatal vitamins: R2 180 \\n� Two scans per pregnancy\\nR1 290 to cover any short payment/co-payment for certain maternity related services and/or certain baby related appliances\\n","dialysis":"Pre-auth compulsory. Subject to case management and PMBs only ","cancer":"R433 500 per family per annum\\nPMB once exceeded, subject to DSP","transplant":"Pre-auth compulsory. Subject to case management and PMBs only ","mri":"In and Out of Hospital: R17 8000 per family per annum\\nPET scans: 2 per beneficiary per annum, \\nmax of R25 200 per scan","prosthesisInternal":"R50 500 per family per annum for (internal, external, fixation devices and implanted devices)\\nSubject to DSP and reference price","prosthesisExternal":"Appliances - In and out of hospital: \\n- R9 700 per family per annum\\nHearing aids: R17 250 p.family per 5th year, maximum of R8 650 per ear\\nMaintenance: R1 085 per beneficiary","rehab":"100% of Scheme Rate \\nCombined limit for alternatives to hospitalisation: R43 600 family limit p.a.\\nWound Care: R14 300 sub-limit per family\\nPalliative Care: In lieu of hospital admission","designatedServiceProvider":"Yes - Keyhealth DSP pharmacies","conditionsCovered":"CDL in PMBs\\nCover for 29 chronic medical conditions","formulary":"Yes","partialLimits":"Non-CDL: R9 200 per family per annum\\n\\n    ","preferredProvider":"None","overallAnualLimit":"100% Scheme Rate  \\nDay-to-day limit which includes GP and Specialist consultations, Radiology, Prescribed and self medication, Optical and Auxiliary services and biokinetics  \\nPM: R5 380 per annum\\nAD: R4 010 per annum\\nCH: R1 290 per annum","medicationOverCounter":"R2 200 per family per annum\\nSubject to savings and/or day-to-day benefit  ","medicationPrescribed":"Subject to savings and/or day-to-day benefit ","practitionersGeneral":"100% of Scheme Rate                                                                                                             subject to savings and/or day-to-day benefit ","specialistsCover":"100% of MST                                                (Subject to overall day-to-day benefits limit and/or savings)","dentistryCover":"100% of Scheme Rate\\nSubject to DENIS protocols, and Scheme Rules. Includes plastic dentures","dentistryCoverSpecial":"100% of Scheme Rate\\nOrthodontics (non-cosmetic), Child 9-18 years\\nSubject to DENIS protocols, and sub-limits. ","optical":"Subject to day-to-day benefit/or day-to-day benefit : R3 380 Pbp2a\\n(Benefit confirmation compulsory)\\n\\nSub-limits per beneficiary:\\nFrames: R1 070 per frame \\nLenses: 1 pair single vision lenses\\nEye test: 1 test                                                         \\nContact lenses: R1 600\\n\\nOTC reading glasses: R200 per beneficiary per annum\\nsubject to over-the-counter medicine sub-limit                                                                                                                                            ","ambulance":"National: Netcare 911  ","international":"R6 million per beneficiary, per journey relating to in-hospital and emergency treatment","hospitalCoverAids":"Unlimited, subject to management programme (LifeSense)","artTtreatment":"Unlimited, Subject to management programme","preventative":"Health Booster: \\nPreventative treatment and early detection\\nBaby immunisation, Flu vaccination, HPV vaccine, Tetanus diphtheria injection,\\nPneumococcal vaccination, Mammogram\\nPap smears, Prostate specific antigen\\nHealth Assessment, Covid-19 vaccination\\n\\nContraceptives: oral tablets or injectable\\nMalaria medication (R415 pbpa) \\n\\n�Smart Baby\\n� Dental emergencies cover\\n� Easy-ER: (No upfront payments required)\\n� (DBC) Back and neck treatment in lieu of surgery","logo":"keyhealth.png"},{"company":"Medihelp","name":"MedPlus","planType":"Traditional option","coverLevel":"High","hospital":"Any","chronic":"Any","serviceType":"Any","familyIncome":"","mainContribution":"R10122","mainCompSavings":"R0.00","mainTotal":"R10122","dependendContributionAdult":"R10122","dependentCompSavingsAdult":"R0.00","dependentTotalAdult":"R10122","dependendContributionChild":"R2526","dependentCompSavingsChild":"R0.00","dependentTotalChild":"R2526","maxChildContribution":"All","mainThreshold":"","dependentThresholdAdult":"","dependentThresholdChild":"","preferedHospitalProvider":"Any hospital","overallLimit":"Unlimited","coPayment":"Refer to brochure for all applicable co-payments\\n20% co-payment, only when the following have not been pre-authorised:                      \\nHospitalisation\\nSub-acute care\\nConfinement\\nInternally implanted prostheses Endoscopic procedures\\nDental procedures under general anaesthesia\\nPsychiatry\\nHospice services as an alternative to hospitalisation\\nOxygen out-of-hospital","rate":"100% of Scheme Rate                     ","generalMedicin":"R630 per admission","specialist":"100% of Scheme Rate     \\nUnlimited","dentistSurgical":"\\n100% of Medihelp Dental Tariff               \\nDental Procedures under anaesthesia\\nOnly for removal of impacted teeth and extensive dental treatment for children < 7 years\\nOrthodontic treatment (one per beneficiary <18 years per family) -once per lifetime                                                                                          Subject to pre-auth and protocols , 20% co-pay if not pre-authorised.","mentalHealth":"Psychiatric Treatment - In and out of hospital\\n46 600 per beneficiary    \\nR63 500 per family \\n","radiology":"100% of Scheme Rate     \\nUnlimited","pathology":"100% of Scheme Rate     \\nUnlimited","maternityBenefit":"In-hospital: Unlimited\\nHome Delivery:  R14 100 per event - 20% co-payment  if pre-authorisation is not obtained\\n\\nOut-of-hospital: subject to registration on HealthPrint�s Maternity and Baby programme: \\nFlu vaccination\\n10 Antenatal and postnatal visits with midwife/GP/gynae\\n2 Antenatal and postnatal visits at a dietician/breastfeeding specialist/\\nantenatal classes\\n2 x 2D scans \\n9 months� suppl y of antenatal supplements (iron and folic acid) \\n2 visits with a GP/Paediatric/ENT specialist, children under 2 years\\n ","dialysis":"100% of Scheme Rate: Unlimited","cancer":"Unlimited\\n10% deductible if treatment deviates from\\nprotocols","transplant":"PMB only � unlimited\\nCornea implants: R31 100 per implant\\n","mri":"In and Out of Hospital: \\n100% of Scheme Rate - Unlimited  \\nPET Scan (non-PMB): R24 000 per case\\nRadiography in & out of hospital - R1 150 per family per year","prosthesisInternal":"\\nHealth-essential functional prosthesis:\\n(R67 000 per beneficiary per year) \\nIntra-ocular lenses: R4 480 per lens\\n(2 lenses per beneficiary) \\nHip, knee and shoulder (non-PMBS):\\n(in case of acute injury) - Prosthesis  \\n\\nOther prostheses\\nVascular/cardiac prosthesis: R60 400\\nEVARS prosthesis:  R141 200 \\nProsthesis with reconstructive or restorative surgery and external breast prostheses: R10 300 per family \\nImplantable hearing devices (including devices and components):  R291 000 per beneficiary per year \\n\\nNeurostimulators: R125 000 per beneficiary \\n\\n\\n\\n","prosthesisExternal":"\\nExternal prostheses and medical appliances\\nIn-and-out-of-hospital\\nBenefit per beneficiary per 3-year cycle:  \\nArtificial eyes, speech and hearing aids: R17 100\\nArtificial limbs and wheelchairs: R9 300 \\nMedical appliances and hyperbaric oxygen\\ntreatment � R2 000 \\nCPAP apparatus � R10 400 per person \\n \\n\\n","rehab":"100% of Scheme Rate - (subject to pre-auth)\\nPalliative care: R29 200 per family","designatedServiceProvider":"None","conditionsCovered":"CDL in PMB and additional conditions","formulary":"Yes","partialLimits":"Non PMB chronic medication: \\n100% of (MMAP), generic medicine \\n80% of MT (if no generic is available)\\n70% of MMAP (original medicine used voluntarily although generic available)\\nR20 000 per beneficiary per year ","preferredProvider":"None","overallAnualLimit":"None","medicationOverCounter":"\\n(See prescribed medication)","medicationPrescribed":"\\nR7 000 per beneficiary, pooled per family  ","practitionersGeneral":"Combined with GP and specialist visits, virtual consultations, physiotherapy, clinical\\npsychology, psychiatric nursing and\\nsupplementary health services: R3 900 per beneficiary , pooled per family","specialistsCover":"0","dentistryCover":"DRC network applies     \\n(Routine check-ups, fillings, X-rays and oral hygiene)        \\n","dentistryCoverSpecial":"DRC network applies     \\n(including crowns, bridges and orthodontic treatment)         \\nOrthodontic treatment (one per beneficiary <18 years per family) R15 880 per lifetime   ","optical":"100% of  contracted tariff \\nBenefits per 24-month cycle per beneficiary at PPN. \\nTests: 1 comprehensive consultation,   \\nLenses: Single vision or bifocal or multifocal lenses                                                                                                                                                                                \\nSpectacles: Frames and / or Lens enhancements: R1 000 or\\nContact lenses: R1 680               ","ambulance":"Road and Air Transport: Netcare 911 \\nOutside these borders  \\nTransport by road:\\n100% of Cost - R2 210 per case\\nTransport by air:\\n100% of Cost - R14 700 per case","international":"No details provided","hospitalCoverAids":"Managed healthcare partner, LifeSense","artTtreatment":"Dis-Chem Direct and Medipost-preferred provider for HIV/Aids medicine","preventative":"Preventive care benefits\\n- Tetanus vaccine\\n- Flu vaccine\\n- Mammogram every 2 years\\n- Pap smear every 3 years\\n- Prostate test\\n- Pneumovax vaccine\\n- Faecal occult blood test (FOBT) \\n- Bone mineral density test every 2 years\\n- 2 HPV vaccinations for girls and boys between 10-14 years or three between 15-26 years\\nHealth screening tests\\nOne combo health screening (blood glucose, cholesterol, BMI & blood pressure measurement) or\\nan individual test (blood glucose or cholesterol)\\nHIV testing, counselling & support\\nChild immunisation\\nContraceptives - R160 per month, up to R1 900 per year\\n\\nCare extender benefit :\\nOne additional GP consultation\\nand R450 for self-medication\\n\\nPost-hospital care : R2 000 per member and R2 800 per family\\nBack treatment at a Document Based Care facility\\nChronic Care programme\\nOne dietician consultation if BMI is >30\\n(Refer to brochure for detailed benefits)","logo":"medihelp.jpg"},{"company":"Medihelp","name":"MedPrime","planType":"New generation","coverLevel":"Mid","hospital":"Any","chronic":"Network","serviceType":"N/A","familyIncome":"","mainContribution":"R3510","mainCompSavings":"R396","mainTotal":"R3906","dependendContributionAdult":"R2976","dependentCompSavingsAdult":"R330","dependentTotalAdult":"R3306","dependendContributionChild":"R1020","dependentCompSavingsChild":"R120","dependentTotalChild":"R1140","maxChildContribution":"2","mainThreshold":"","dependentThresholdAdult":"","dependentThresholdChild":"","preferedHospitalProvider":"Any hospital","overallLimit":"Unlimited","coPayment":"Refer to brochure for all applicable co-payments\\nProcedure-specific co-pays apply for non-PMB cases. 20% co-payment  if pre-authorisation is not obtained\\n\\nSpinal column surgery: R9 900 co-pay \\n\\nEndoscopic Procedures : R3 500 per\\nadmission, only gastroscopy, colonoscopy,\\narthroscopy and sigmoidoscopy\\nNetwork options: Day procedure network applies\\nNon-network options: Day procedure facilities apply\\n\\nMedicine on prescription/self-medication: 80% benefit applies to original medicine if no generic equivalent is available, 70% benefit applies to original medicine if a generic equivalent is available\\n","rate":"100% of Scheme Rate                                     ","generalMedicin":"R470 per admission","specialist":"100% of Scheme Rate                                                     Unlimited","dentistSurgical":"Dental procedures under anaesthesia\\n(Subject to pre-auth and R1 600 per admission co-pay)  For the removal of impacted teeth and extensive dental treatment for children < 7 years only.","mentalHealth":"Psychiatric treatment \\nIn and out of hospital\\nR31 600 per beneficiary\\nR42 500 per family per annum\\n","radiology":"100% of Scheme Rate : Unlimited ","pathology":"100% of Scheme Rate : Unlimited ","maternityBenefit":"In-hospital: unlimited\\nHome Delivery: R14 100 per event - 20% co-payment  if pre-authorisation is not obtained\\n\\nOut-of-hospital: subject to registration on HealthPrint�s Maternity and Baby programme: Flu vaccination\\n10 antenatal and postnatal visits with midwife/GP/gynae\\n2 antenatal and postnatal visits at a dietician/breastfeeding specialist/\\nantenatal classes\\nTwo 2D scans \\n9 months� supply of antenatal supplements (iron and folic acid) \\n2 visits with a GP/Paediatric/ENT specialist, children under 2 years\\n ","dialysis":"100% of Scheme Rate - Unlimited","cancer":"Subject to pre-auth and registration on Oncology Management Programme.\\n� PMB � unlimited\\n� Non-PMB � R285 000 per family\\n20% deductible if treatment deviates from\\nprotocols\\n","transplant":"PMB � unlimited\\nCornea implants: R31 100 per implant","mri":"In Hospital: \\nUnlimited - with  R2 100 co-payment \\nOut of Hospital: R1 800 co-payment\\nRadiography in & out of hospital - R1 150 per family per year","prosthesisInternal":"\\nHealth-essential functional prosthesis:\\n(R67 000 per beneficiary per year) \\nIntra-ocular lenses: R4 480 per lens\\n(2 lenses per beneficiary) \\nHip, knee and shoulder (non-PMBS):\\n(in case of acute injury) - Prosthesis  \\n\\nOther prostheses\\nVascular/cardiac prosthesis: R60 400\\nEVARS prosthesis:  R141 200 \\nProsthesis with reconstructive or restorative surgery and external breast prostheses: R10 300 per family \\nImplantable hearing devices (including devices and components): R260 000 per beneficiary per year \\n\\nNeurostimulators: R62 500 per beneficiary\\n\\n\\n\\n","prosthesisExternal":"\\nExternal prostheses and medical appliances\\nIn-and-out-of-hospital: \\nBenefits per 3-year cycle:  \\nArtificial eyes, speech and hearing aids:      R5 000 per family\\nArtificial limbs and wheelchairs:                   R5 000 per family  \\n\\nMedical appliances and hyperbaric oxygen\\ntreatment � R1 400 \\nCPAP apparatus � R10 400 per person \\n\\n\\n","rehab":"100% of Scheme Rate - unlimited\\nServices must be in an approved facility\\nPalliative care, R25 000 per family ","designatedServiceProvider":"Yes","conditionsCovered":"CDL in PMB","formulary":"Yes","partialLimits":"Non-PMB chronic medicine paid from available Savings first then day-to-day benefit\\n100% of (MMAP), generic medicine \\n80% of MT (if no generic is available)\\n70% of MMAP (original medicine used voluntarily although generic available)","preferredProvider":"None","overallAnualLimit":"\\nDay-to-day limit for GPs and specialists, clinical psychology and physiotherapy,  supplementary health , Acute medication,, non-PMB chronic, standard radiology and pathology:\\nLimits available after depletion of savings  \\nMember: R6 300\\nMember +: R11 500\\n","medicationOverCounter":"Subject to Savings, once depleted limited to available day-to-day benefits","medicationPrescribed":"Subject to Savings, once depleted limited to available day-to-day benefits","practitionersGeneral":"Subject to Savings, once depleted limited to available day-to-day benefits","specialistsCover":"Subject to Savings, once depleted limited to available day-to-day benefits (GP referral required) ","dentistryCover":"DRC network applies     \\n(including routine check-ups, fillings, X-rays, oral hygiene)            \\n","dentistryCoverSpecial":"DRC network applies     \\n(crowns, bridges and orthodontic treatment)    \\nOrthodontic treatment (one per beneficiary <18 years per family) R9 730 per lifetime     \\n","optical":"Benefits per 24-month cycle per beneficiary at PPN \\n1 Eye test   \\nLenses: Single vision lenses or bifocal or multifocal lenses                                                                                                                                                                                \\nSpectacles: Frames and / or Lens enhancements: R800 or\\nContact lenses: R1 200               ","ambulance":"Road and Air Transport: Netcare 911 \\nOutside these borders  \\nTransport by road:\\n100% of Cost - R2 210 per case\\nTransport by air:\\n100% of Cost - R14 700 per case","international":"No details provided","hospitalCoverAids":"Managed healthcare partner, LifeSense","artTtreatment":"Dis-Chem Direct and Medipost-preferred provider for HIV/Aids medicine","preventative":"Preventive care benefits\\n- Tetanus vaccine\\n- Flu vaccine\\n- Mammogram every 2 years\\n- Pap smear every 3 years\\n- Prostate test\\n- Pneumovax vaccine\\n- Faecal occult blood test (FOBT) \\n- Bone mineral density test every 2 years\\n- 2 HPV vaccinations for girls and boys between 10-14 years or three between 15-26 years\\nHealth screening tests\\nOne combo health screening (blood glucose, cholesterol, BMI & blood pressure measurement) or\\nan individual test (blood glucose or cholesterol)\\nHIV testing, counselling & support\\nChild immunisation\\nContraceptives - R155 per month, up to R1 820 per year\\n\\nCare extender benefit :\\nOne additional GP consultation\\nand R450 for self-medication\\n\\nPost-hospital care : R2 000 per member and R2 800 per family\\nBack treatment at a Document Based Care facility\\nChronic Care programme\\nOne dietician consultation if BMI is >30\\n(Refer to brochure for detailed benefits)","logo":"medihelp.jpg"},{"company":"Medihelp","name":"MedPrime Elect","planType":"New generation","coverLevel":"Mid","hospital":"Network","chronic":"Network","serviceType":"N/A","familyIncome":"","mainContribution":"R2880","mainCompSavings":"R318","mainTotal":"R3198","dependendContributionAdult":"R2436","dependentCompSavingsAdult":"R270","dependentTotalAdult":"R2706","dependendContributionChild":"R840","dependentCompSavingsChild":"R90","dependentTotalChild":"R930","maxChildContribution":"2","mainThreshold":"","dependentThresholdAdult":"","dependentThresholdChild":"","preferedHospitalProvider":"Network hospitals and day procedure network applies for certain day procedures","overallLimit":"Unlimited","coPayment":"Refer to brochure for all applicable co-payments\\nVoluntary use of non-network hospital: 35% co-payment applies\\nProcedure-specific co-pays apply for non-PMB cases. 20% co-payment  if pre-authorisation is not obtained.\\n\\nSpinal column surgery: R9 900 co-pay\\n \\nEndoscopic Procedures : R3 500 per\\nadmission, only gastroscopy, colonoscopy,\\narthroscopy and sigmoidoscopy\\nNetwork options: Day procedure network applies\\nNon-network options: Day procedure facilities apply\\n\\n\\nMedicine on prescription/self-medication: 80% benefit applies to original medicine if no generic equivalent is available, 70% benefit applies to original medicine if a generic equivalent is available\\n","rate":"100% of Scheme Rate                                     ","generalMedicin":"R470 per admission","specialist":"100% of Scheme Rate                                                     Unlimited","dentistSurgical":"Dental procedures under anaesthesia\\n(Subject to pre-auth, day hospital and R1 600 per admission co-pay)  For the removal of impacted teeth and extensive dental treatment for children < 7 years only.","mentalHealth":"Psychiatric treatment \\nIn and out of hospital\\nR31 600 per beneficiary\\nR42 500 per family per annum\\n","radiology":"100% of Scheme Rate : Unlimited ","pathology":"100% of Scheme Rate : Unlimited ","maternityBenefit":"In-hospital: unlimited\\nHome Delivery: R14 100 per event - 20% co-payment  if pre-authorisation is not obtained\\n\\nOut-of-hospital: subject to registration on HealthPrint�s Maternity and Baby programme: Flu vaccination\\n10 antenatal and postnatal visits with midwife/GP/gynae\\n2 antenatal and postnatal visits at a dietician/breastfeeding specialist/\\nantenatal classes\\nTwo 2D scans \\n9 months� supply of antenatal supplements (iron and folic acid) \\n2 visits with a GP/Paediatric/ENT specialist, children under 2 years\\n ","dialysis":"100% of Scheme Rate - Unlimited","cancer":"Subject to pre-auth and registration on Oncology Management Programme.\\n� PMB � unlimited\\n� Non-PMB � R285 000 per family\\n20% deductible if treatment deviates from\\nprotocols\\nOncology medicine DSP: Dis-Chem Oncology and Medipost ","transplant":"PMB � unlimited\\nCornea implants: R31 100 per implant","mri":"In Hospital: \\nUnlimited - with  R2 100 co-payment \\nOut of Hospital: R1 800 co-payment\\nRadiography in & out of hospital - R1 150 per family per year","prosthesisInternal":"\\nHealth-essential functional prosthesis:\\n(R67 000 per beneficiary per year) \\nIntra-ocular lenses: R4 480 per lens\\n(2 lenses per beneficiary) \\nHip, knee and shoulder (non-PMBS):\\n(in case of acute injury) - Prosthesis  \\n\\nOther prostheses\\nVascular/cardiac prosthesis: R60 400\\nEVARS prosthesis:  R141 200 \\nProsthesis with reconstructive or restorative surgery and external breast prostheses: R10 300 per family \\nImplantable hearing devices (including devices and components): R260 000 per beneficiary per year\\n\\nNeurostimulators: R62 500 per beneficiary \\n\\n\\n\\n","prosthesisExternal":"\\nExternal prostheses and medical appliances\\nIn-and-out-of-hospital: \\nBenefits per 3-year cycle:  \\nArtificial eyes, speech and hearing aids:      R5 000 per family\\nArtificial limbs and wheelchairs:                   R5 000 per family  \\n\\nMedical appliances and hyperbaric oxygen\\ntreatment � R1 400 \\nCPAP apparatus � R10 400 per person \\n\\n\\n","rehab":"100% of Scheme Rate - unlimited\\nServices must be in an approved facility\\nPalliative care, R25 000 per family ","designatedServiceProvider":"Yes","conditionsCovered":"CDL in PMB","formulary":"Yes, 60% co-payment applies for non-formulary, non-DSP","partialLimits":"Non-PMB chronic medicine paid from available Savings first then day-to-day benefit\\n100% of (MMAP), generic medicine \\n80% of MT (if no generic is available)\\n70% of MMAP (original medicine used voluntarily although generic available)","preferredProvider":"None","overallAnualLimit":"\\nDay-to-day limit for GPs and specialists, clinical psychology, physiotherapy,  supplementary health , Acute medication,, non-PMB chronic, standard radiology and pathology:\\nLimits available after depletion of savings  \\nMember: R6 300\\nMember +: R11 500\\n","medicationOverCounter":"Subject to Savings, once depleted limited to available day-to-day benefits","medicationPrescribed":"Subject to Savings, once depleted limited to available day-to-day benefits","practitionersGeneral":"Subject to Savings, once depleted limited to available day-to-day benefits","specialistsCover":"Subject to Savings, once depleted limited to available day-to-day benefits (Network GP referral or 35% co-payment) ","dentistryCover":"DRC network applies     \\n(including routine check-ups, fillings, X-rays, oral hygiene)            \\n","dentistryCoverSpecial":"DRC network applies     \\n(crowns, bridges and orthodontic treatment)    \\nOrthodontic treatment (one per beneficiary <18 years per family) R9 730 per lifetime     \\n","optical":"Benefits per 24-month cycle per beneficiary at PPN \\n1 Eye test   \\nLenses: Single vision lenses or bifocal or multifocal lenses                                                                                                                                                                                \\nSpectacles: Frames and / or Lens enhancements: R800 or\\nContact lenses: R1 200               ","ambulance":"Road and Air Transport: Netcare 911 \\nOutside these borders  \\nTransport by road:\\n100% of Cost - R2 210 per case\\nTransport by air:\\n100% of Cost - R14 700 per case","international":"No details provided","hospitalCoverAids":"Managed healthcare partner, LifeSense","artTtreatment":"Dis-Chem Direct and Medipost-preferred provider for HIV/Aids medicine","preventative":"Preventive care benefits\\n- Tetanus vaccine\\n- Flu vaccine\\n- Mammogram every 2 years\\n- Pap smear every 3 years\\n- Prostate test\\n- Pneumovax vaccine\\n- Faecal occult blood test (FOBT) \\n- Bone mineral density test every 2 years\\n- 2 HPV vaccinations for girls and boys between 10-14 years or three between 15-26 years\\nHealth screening tests\\nOne combo health screening (blood glucose, cholesterol, BMI & blood pressure measurement) or\\nan individual test (blood glucose or cholesterol)\\nHIV testing, counselling & support\\nChild immunisation\\nContraceptives - R155 per month, up to R1 820 per year\\n\\nCare extender benefit :\\nOne additional GP consultation\\nand R450 for self-medication\\n\\nPost-hospital care : R2 000 per member and R2 800 per family\\nBack treatment at a Document Based Care facility\\nChronic Care programme\\nOne dietician consultation if BMI is >30\\n(Refer to brochure for detailed benefits)","logo":"medihelp.jpg"},{"company":"Medihelp","name":"Prime","planType":"New generation","coverLevel":"Mid","hospital":"Any","chronic":"Network","serviceType":"Any","familyIncome":"","mainContribution":"R3510","mainCompSavings":"R396","mainTotal":"R3906","dependendContributionAdult":"R2976","dependentCompSavingsAdult":"R330","dependentTotalAdult":"R3306","dependendContributionChild":"R1020","dependentCompSavingsChild":"R120","dependentTotalChild":"R1140","maxChildContribution":"2","mainThreshold":"","dependentThresholdAdult":"","dependentThresholdChild":"","preferedHospitalProvider":"#N/A","overallLimit":"#N/A","coPayment":"#N/A","rate":"#N/A","generalMedicin":"#N/A","specialist":"#N/A","dentistSurgical":"#N/A","mentalHealth":"#N/A","radiology":"#N/A","pathology":"#N/A","maternityBenefit":"#N/A","dialysis":"#N/A","cancer":"#N/A","transplant":"#N/A","mri":"#N/A","prosthesisInternal":"#N/A","prosthesisExternal":"#N/A","rehab":"#N/A","designatedServiceProvider":"#N/A","conditionsCovered":"#N/A","formulary":"#N/A","partialLimits":"#N/A","preferredProvider":"#N/A","overallAnualLimit":"#N/A","medicationOverCounter":"#N/A","medicationPrescribed":"#N/A","practitionersGeneral":"#N/A","specialistsCover":"#N/A","dentistryCover":"#N/A","dentistryCoverSpecial":"#N/A","optical":"#N/A","ambulance":"#N/A","international":"#N/A","hospitalCoverAids":"#N/A","artTtreatment":"#N/A","preventative":"#N/A","logo":"medihelp.jpg"},{"company":"Medihelp","name":"MedVital Elect","planType":"Hospital plan","coverLevel":"Mid","hospital":"Network","chronic":"Network","serviceType":"Any","familyIncome":"","mainContribution":"R1650","mainCompSavings":"R0.00","mainTotal":"R1650","dependendContributionAdult":"R1200","dependentCompSavingsAdult":"R0.00","dependentTotalAdult":"R1200","dependendContributionChild":"R648","dependentCompSavingsChild":"R0.00","dependentTotalChild":"R648","maxChildContribution":"2","mainThreshold":"","dependentThresholdAdult":"","dependentThresholdChild":"","preferedHospitalProvider":"Network hospital","overallLimit":"Unlimited","coPayment":"Refer to brochure for all applicable co-payments\\nVoluntary use of non-network hospital: 35% co-payment applies\\nProcedure-specific co-pays apply for non-PMB cases. 20% co-payment  if pre-authorisation is not obtained\\n\\nSpinal column surgery: R15 700 co-pay \\n\\nEndoscopic Procedures : R4 400 per admission\\nNetwork options: Day procedure network applies\\nNon-network options: Day procedure facilities apply\\n\\nR6 800 co-pay: Prostatectomy (conventional or laparoscopic), hysterectomy and endometrial ablation \\n\\nMedicine on prescription/self-medication: 80% benefit applies to original medicine if no generic equivalent is available, 70% benefit applies to original medicine if a generic equivalent is available","rate":"100% of Scheme Rate                                     ","generalMedicin":"R370 per admission","specialist":"100% of Scheme Rate                                                 Unlimited","dentistSurgical":"Dental procedures under anaesthesia\\n(Subject to pre-auth, day hospital and R3 560 per admission co-pay) For the removal of impacted teeth and extensive dental treatment for children < 7 years only.","mentalHealth":"Psychiatric treatment \\nIn and out of hospital\\nR20 800 per beneficiary\\nR31 600 per family per annum\\n","radiology":"100% of Scheme Rate : Unlimited ","pathology":"100% of Scheme Rate : Unlimited ","maternityBenefit":"In-hospital: unlimited\\nHome Delivery: R14 100 per event - 20% co-payment  if pre-authorisation is not obtained\\n\\nOut-of-hospital: subject to registration on HealthPrint�s Maternity and Baby programme: Flu vaccination\\n10 antenatal and postnatal visits with midwife/GP/gynae\\n2 antenatal and postnatal visits at a dietician/breastfeeding specialist/\\nantenatal classes\\n2 x 2D scans \\n2 visits with a GP/Paediatric/ENT specialist, children under 2 years\\n ","dialysis":"100% of Scheme Rate - Unlimited","cancer":"Subject to pre-auth and registration on Oncology Management Programme.\\n� PMB � unlimited\\n� Non-PMB � R230 000 per family\\n20% deductible if treatment deviates from\\nprotocols\\nOncology medicine DSP: Dis-Chem Oncology and Medipost \\n\\n","transplant":"PMB only � unlimited \\nCornea implants � R31 100 per implant","mri":"In & Out of Hospital: \\nUnlimited - with  R2 800 co-payment \\nRadiography in & out of hospital - R1 150 per family per year","prosthesisInternal":"\\nHealth-essential functional prosthesis:\\n(R24 900 per beneficiary per year) \\nIntra-ocular lenses: R4 480 per lens\\n(2 lenses per beneficiary) \\nHip, knee and shoulder (non-PMBS):\\n(in case of acute injury) - Prosthesis  \\n\\nOther prostheses\\nVascular/cardiac prosthesis: R37 500\\nEVARS prosthesis: R37 500\\nProsthesis with reconstructive or restorative surgery and external breast prostheses: R4 580 per family \\n\\n\\n\\n\\n","prosthesisExternal":"External Prosthesis - no benefit\\nMedical appliances: PMB only\\n\\n ","rehab":"100% of Scheme Rate - unlimited\\nServices must be in an approved facility\\nPalliative care, R20 800 per family ","designatedServiceProvider":"Yes","conditionsCovered":"CDL in PMB","formulary":"Yes, 60% co-payment applies for non-formulary, non-DSP","partialLimits":"Non-PMB chronic medicine paid from available day-to-day limits\\n100% of (MMAP), generic medicine \\n80% of MT (if no generic is available)\\n70% of MMAP (original medicine used voluntarily although generic available)","preferredProvider":"None","overallAnualLimit":"Day-to-day limit for GPs, specialists, physiotherapy, Acute medicine, including visits to emergency units: \\nMember: R1 300\\nMember +: R2 600","medicationOverCounter":"Paid from available day-to-day limits","medicationPrescribed":"Paid from available day-to-day limits","practitionersGeneral":"Paid from available day-to-day limit","specialistsCover":"Paid from available day-to-day limit\\nNetwork GP referral or 35% co-payment","dentistryCover":" Subject to DRC network\\nRemoval of impacted teeth in the dentist�s chair","dentistryCoverSpecial":"No benefit","optical":"No benefit","ambulance":"Road and Air Transport: Netcare 911 \\nOutside these borders  \\nTransport by road:\\n100% of Cost - R2 210 per case\\nTransport by air:\\n100% of Cost - R14 700 per case","international":"No details provided","hospitalCoverAids":"Managed healthcare partner, LifeSense","artTtreatment":"Dis-Chem Direct and Medipost-preferred provider for HIV/Aids medicine","preventative":"Preventive care benefits\\n- Tetanus vaccine\\n- Flu vaccine\\n- Mammogram every 2 years\\n- Pap smear every 3 years\\n- Prostate test\\n- Pneumovax vaccine\\n- Faecal occult blood test (FOBT) \\n- Bone mineral density test every 2 years\\n- 2 HPV vaccinations for girls and boys between 10-14 years or three between 15-26 years\\nHealth screening tests\\nOne combo health screening (blood glucose, cholesterol, BMI & blood pressure measurement) or\\nan individual test (blood glucose or cholesterol)\\nHIV testing, counselling & support\\nChild immunisation\\nContraceptives - R140 per month, up to R1 550 per year\\n\\nCare extender benefit :\\nOne additional GP consultation\\nand R450 for self-medication\\n\\nPost-hospital care : R2 000 per member and R2 800 per family\\nBack treatment at a Document Based Care facility\\nChronic Care programme\\nOne dietician consultation if BMI is >30\\n(Refer to brochure for detailed benefits)","logo":"medihelp.jpg"},{"company":"Medihelp","name":"MedVital  ","planType":"Hospital plan","coverLevel":"Mid","hospital":"Any","chronic":"Network","serviceType":"Any","familyIncome":"","mainContribution":"R2100","mainCompSavings":"R0.00","mainTotal":"R2100","dependendContributionAdult":"R1602","dependentCompSavingsAdult":"R0.00","dependentTotalAdult":"R1602","dependendContributionChild":"R690","dependentCompSavingsChild":"R0.00","dependentTotalChild":"R690","maxChildContribution":"2","mainThreshold":"","dependentThresholdAdult":"","dependentThresholdChild":"","preferedHospitalProvider":"Any hospital","overallLimit":"Unlimited","coPayment":"Refer to brochure for all applicable co-payments\\nProcedure-specific co-pays apply for non-PMB cases. 20% co-payment  if pre-authorisation is not obtained.\\n\\nSpinal column surgery: R15 700 co-pay \\n\\nEndoscopic Procedures : R4 400 per admission\\nNetwork options: Day procedure network applies\\nNon-network options: Day procedure facilities apply\\n\\nR6 800 co-pay: Prostatectomy (conventional or laparoscopic), hysterectomy and endometrial ablation \\n\\nMedicine on prescription/self-medication : 80% benefit applies to original medicine if no generic equivalent is available, 70% benefit applies to original medicine if a generic equivalent is available","rate":"100% of Scheme Rate                                     ","generalMedicin":"R370 per admission","specialist":"100% of Scheme Rate                                                 Unlimited","dentistSurgical":"Dental procedures under anaesthesia\\n(Subject to pre-auth and R3 560 per admission co-pay) For the removal of impacted teeth and extensive dental treatment for children < 7 years only.","mentalHealth":"Psychiatric treatment \\nIn and out of hospital\\nR20 800 per beneficiary\\nR31 600 per family per annum\\n","radiology":"100% of Scheme Rate : Unlimited ","pathology":"100% of Scheme Rate : Unlimited ","maternityBenefit":"In-hospital: unlimited\\nHome Delivery: R14 100 per event - 20% co-payment  if pre-authorisation is not obtained\\n\\nOut-of-hospital: subject to registration on HealthPrint�s Maternity and Baby programme: Flu vaccination\\n10 antenatal and postnatal visits with midwife/GP/gynae\\n2 antenatal and postnatal visits at a dietician/breastfeeding specialist/\\nantenatal classes\\n2 x 2D scans \\n2 visits with a GP/Paediatric/ENT specialist, children under 2 years\\n ","dialysis":"100% of Scheme Rate - Unlimited","cancer":"Subject to pre-auth and registration on Oncology Management Programme.\\n� PMB � unlimited\\n� Non-PMB � R230 000 per family\\n20% deductible if treatment deviates from\\nprotocols\\n\\n\\n","transplant":"PMB only � unlimited \\nCornea implants � R31 100 per implant","mri":"In & Out of Hospital: \\nUnlimited - with  R2 800 co-payment \\nRadiography in & out of hospital - R1 150 per family per year\\n","prosthesisInternal":"\\nHealth-essential functional prosthesis:\\n(R24 900 per beneficiary per year) \\nIntra-ocular lenses: R4 480 per lens\\n(2 lenses per beneficiary) \\nHip, knee and shoulder (non-PMBS):\\n(in case of acute injury) - Prosthesis  \\n\\nOther prostheses\\nVascular/cardiac prosthesis: R37 500\\nEVARS prosthesis: R37 500\\nProsthesis with reconstructive or restorative surgery and external breast prostheses: R4 580 per family \\n\\n\\n\\n\\n","prosthesisExternal":"External Prosthesis - no benefit\\nMedical appliances: PMB only\\n\\n ","rehab":"100% of Scheme Rate - unlimited\\nServices must be in an approved facility\\nPalliative care, R20 800 per family ","designatedServiceProvider":"Yes","conditionsCovered":"CDL in PMB","formulary":"Yes","partialLimits":"Non-PMB chronic medicine paid from available day-to-day limits\\n100% of (MMAP), generic medicine \\n80% of MT (if no generic is available)\\n70% of MMAP (original medicine used voluntarily although generic available)","preferredProvider":"None","overallAnualLimit":"Day-to-day limit for GPs, specialists, physiotherapy, Acute medicine, including visits to emergency units: \\nMember: R1 300\\nMember +: R2 600","medicationOverCounter":"Paid from available day-to-day limits","medicationPrescribed":"Paid from available day-to-day limits","practitionersGeneral":"Paid from available day-to-day limit","specialistsCover":"Paid from available day-to-day limit\\nGP referral ","dentistryCover":" Subject to DRC network\\nRemoval of impacted teeth in the dentist�s chair","dentistryCoverSpecial":"No benefit","optical":"No benefit","ambulance":"Road and Air Transport: Netcare 911 \\nOutside these borders  \\nTransport by road:\\n100% of Cost - R2 210 per case\\nTransport by air:\\n100% of Cost - R14 700 per case","international":"No details provided","hospitalCoverAids":"Managed healthcare partner, LifeSense","artTtreatment":"Dis-Chem Direct and Medipost-preferred provider for HIV/Aids medicine","preventative":"Preventive care benefits\\n- Tetanus vaccine\\n- Flu vaccine\\n- Mammogram every 2 years\\n- Pap smear every 3 years\\n- Prostate test\\n- Pneumovax vaccine\\n- Faecal occult blood test (FOBT) \\n- Bone mineral density test every 2 years\\n- 2 HPV vaccinations for girls and boys between 10-14 years or three between 15-26 years\\nHealth screening tests\\nOne combo health screening (blood glucose, cholesterol, BMI & blood pressure measurement) or\\nan individual test (blood glucose or cholesterol)\\nHIV testing, counselling & support\\nChild immunisation\\nContraceptives - R140 per month, up to R1 550 per year\\n\\nCare extender benefit :\\nOne additional GP consultation\\nand R450 for self-medication\\n\\nPost-hospital care : R2 000 per member and R2 800 per family\\nBack treatment at a Document Based Care facility\\nChronic Care programme\\nOne dietician consultation if BMI is >30\\n(Refer to brochure for detailed benefits)","logo":"medihelp.jpg"},{"company":"Medihelp","name":"MedAdd Elect","planType":"New generation","coverLevel":"Mid","hospital":"Network","chronic":"Network","serviceType":"Any","familyIncome":"","mainContribution":"R1824","mainCompSavings":"R324","mainTotal":"R2148","dependendContributionAdult":"R1602","dependentCompSavingsAdult":"R240","dependentTotalAdult":"R1842","dependendContributionChild":"R636","dependentCompSavingsChild":"R114","dependentTotalChild":"R750","maxChildContribution":"2","mainThreshold":"","dependentThresholdAdult":"","dependentThresholdChild":"","preferedHospitalProvider":"Network hospitals and day procedure network applies for certain day procedures","overallLimit":"Unlimited","coPayment":"Refer to brochure for all applicable co-payments\\nVoluntary use of non-network hospital: 35% co-payment applies\\nProcedure-specific co-pays apply for non-PMB cases. 20% co-payment  if pre-authorisation is not obtained.\\n\\nSpinal column surgery: R11 400 co-pay \\n\\nEndoscopic Procedures : R4 300 per admission\\nNetwork options: Day procedure network applies\\nNon-network options: Day procedure facilities apply\\n\\nR6 300 co-pay: Prostatectomy (conventional or laparoscopic), hysterectomy and endometrial ablation \\n\\nMedicine on prescription/self-medication : 80% benefit applies to original medicine if no generic equivalent is available, 70% benefit applies to original medicine if a generic equivalent is available","rate":"100% of Scheme Rate                                     ","generalMedicin":"R370 per admission","specialist":"100% of Scheme Rate                                                             Unlimited","dentistSurgical":"Dental procedures under anaesthesia\\n(Subject to pre-auth, day hospital and R3 560 per admission co-pay) For the removal of impacted teeth and extensive dental treatment for children < 7 years only.","mentalHealth":"Psychiatric treatment \\nIn and out of hospital\\nR26 300 per beneficiary\\nR36 200 per family per annum\\n","radiology":"100% of Scheme Rate : Unlimited ","pathology":"100% of Scheme Rate : Unlimited ","maternityBenefit":"In-hospital: unlimited\\nHome Delivery:  R14 100 per event - 20% co-payment  if pre-authorisation is not obtained\\n\\nOut-of-hospital: subject to registration on HealthPrint�s Maternity and Baby programme: Flu vaccination\\n10 antenatal and postnatal visits with midwife/GP/gynae\\n2 antenatal and postnatal visits at a dietician/breastfeeding specialist/\\nantenatal classes\\nTwo 2D scans \\n2 visits with a GP/Paediatric/ENT specialist, children under 2 years\\n ","dialysis":"100% of Scheme Rate - Unlimited","cancer":"Subject to pre-auth and registration on Oncology Management Programme.\\n� PMB � unlimited\\n� Non-PMB � R250 000 per family\\n20% deductible if treatment deviates from\\nprotocols\\nOncology medicine DSP: Dis-Chem Oncology and Medipost \\n","transplant":"PMB only � unlimited \\nCornea implants � R31 100 per implant","mri":"In & Out of Hospital: \\nUnlimited - with  R2 610 co-payment \\nRadiography in & out of hospital - R1 150 per family per year\\n","prosthesisInternal":"\\nHealth-essential functional prosthesis:\\n(R67 000 per beneficiary per year) \\nIntra-ocular lenses: R4 480 per lens\\n(2 lenses per beneficiary) \\nHip, knee and shoulder (non-PMBS):\\n(in case of acute injury) - Prosthesis  \\n\\nOther prostheses\\nVascular/cardiac prosthesis: R60 400\\nEVARS prosthesis:  R141 200 \\nProsthesis with reconstructive or restorative surgery and external breast prostheses: R10 300 per family \\n\\n\\n\\n\\n","prosthesisExternal":"External Prosthesis and Appliances: \\nSubject to available savings  \\nHyperbaric oxygen treatment: \\n� R700 per family\\n","rehab":"100% of Scheme Rate - unlimited\\nServices must be in an approved facility\\nPalliative care, R22 900 per family ","designatedServiceProvider":"Yes","conditionsCovered":"CDL in PMB","formulary":"Yes, 60% co-payment applies for non-formulary, non-DSP","partialLimits":"Non-PMB chronic medicine paid from available Savings\\n100% of (MMAP), generic medicine \\n80% of MT (if no generic is available)\\n70% of MMAP (original medicine used voluntarily although generic available)","preferredProvider":"None","overallAnualLimit":"Day-to-day limit for GP and specialist visits, virtual consultations, physiotherapy acute and self-medication including visits to emergency units\\nMember: R1 300\\nMember +: R2 600\\n","medicationOverCounter":"Subject to Savings, once depleted limited to available day-to-day benefits","medicationPrescribed":"Subject to Savings and GP Network, once depleted limited to available day-to-day benefits","practitionersGeneral":"Subject to Savings, once depleted limited to available day-to-day benefits","specialistsCover":"(Subject to Savings first)\\nNetwork GP referral - (day-to-day benefit)","dentistryCover":"Conservative dental benefits for children <18 years\\nRemoval of impacted teeth in the dentist�s chair - Benefits subject to DRC network","dentistryCoverSpecial":"Subject to available Savings","optical":"Benefits per 24-month cycle per beneficiary at PPN \\n1 Eye test   \\nLenses: Single vision lenses or bifocal or multifocal lenses                                                                                                                                                                                \\nSpectacles: Frames and / or Lens enhancements: R275 or\\nContact lenses: R650               ","ambulance":"Road and Air Transport: Netcare 911 \\nOutside these borders  \\nTransport by road:\\n100% of Cost - R2 210 per case\\nTransport by air:\\n100% of Cost - R14 700 per case","international":"No details provided","hospitalCoverAids":"Managed healthcare partner, LifeSense","artTtreatment":"Dis-Chem Direct and Medipost-preferred provider for HIV/Aids medicine","preventative":"Preventive care benefits\\n- Tetanus vaccine\\n- Flu vaccine\\n- Mammogram every 2 years\\n- Pap smear every 3 years\\n- Prostate test\\n- Pneumovax vaccine\\n- Faecal occult blood test (FOBT) \\n- Bone mineral density test every 2 years\\n- 2 HPV vaccinations for girls and boys between 10-14 years or three between 15-26 years\\nHealth screening tests\\nOne combo health screening (blood glucose, cholesterol, BMI & blood pressure measurement) or\\nan individual test (blood glucose or cholesterol)\\nHIV testing, counselling & support\\nChild immunisation\\nContraceptives - R145 per month, up to R1 690 per year\\n\\nCare extender benefit : Activates after\\nundergoing specific health tests:\\n� 1 GP consultation\\n� R450 for self medication\\n\\nPost-hospital care : R2 000 per member and R2 800 per family\\nBack treatment at a Document Based Care facility\\nChronic Care programme\\nOne dietician consultation if BMI is >30\\n(Refer to brochure for detailed benefits)","logo":"medihelp.jpg"},{"company":"Medihelp","name":"MedAdd Elect","planType":"New generation","coverLevel":"Mid","hospital":"Any","chronic":"Any","serviceType":"Any","familyIncome":"","mainContribution":"R1824","mainCompSavings":"R324","mainTotal":"R2148","dependendContributionAdult":"R1602","dependentCompSavingsAdult":"R240","dependentTotalAdult":"R1842","dependendContributionChild":"R636","dependentCompSavingsChild":"R114","dependentTotalChild":"R750","maxChildContribution":"2","mainThreshold":"","dependentThresholdAdult":"","dependentThresholdChild":"","preferedHospitalProvider":"Network hospitals and day procedure network applies for certain day procedures","overallLimit":"Unlimited","coPayment":"Refer to brochure for all applicable co-payments\\nVoluntary use of non-network hospital: 35% co-payment applies\\nProcedure-specific co-pays apply for non-PMB cases. 20% co-payment  if pre-authorisation is not obtained.\\n\\nSpinal column surgery: R11 400 co-pay \\n\\nEndoscopic Procedures : R4 300 per admission\\nNetwork options: Day procedure network applies\\nNon-network options: Day procedure facilities apply\\n\\nR6 300 co-pay: Prostatectomy (conventional or laparoscopic), hysterectomy and endometrial ablation \\n\\nMedicine on prescription/self-medication : 80% benefit applies to original medicine if no generic equivalent is available, 70% benefit applies to original medicine if a generic equivalent is available","rate":"100% of Scheme Rate                                     ","generalMedicin":"R370 per admission","specialist":"100% of Scheme Rate                                                             Unlimited","dentistSurgical":"Dental procedures under anaesthesia\\n(Subject to pre-auth, day hospital and R3 560 per admission co-pay) For the removal of impacted teeth and extensive dental treatment for children < 7 years only.","mentalHealth":"Psychiatric treatment \\nIn and out of hospital\\nR26 300 per beneficiary\\nR36 200 per family per annum\\n","radiology":"100% of Scheme Rate : Unlimited ","pathology":"100% of Scheme Rate : Unlimited ","maternityBenefit":"In-hospital: unlimited\\nHome Delivery:  R14 100 per event - 20% co-payment  if pre-authorisation is not obtained\\n\\nOut-of-hospital: subject to registration on HealthPrint�s Maternity and Baby programme: Flu vaccination\\n10 antenatal and postnatal visits with midwife/GP/gynae\\n2 antenatal and postnatal visits at a dietician/breastfeeding specialist/\\nantenatal classes\\nTwo 2D scans \\n2 visits with a GP/Paediatric/ENT specialist, children under 2 years\\n ","dialysis":"100% of Scheme Rate - Unlimited","cancer":"Subject to pre-auth and registration on Oncology Management Programme.\\n� PMB � unlimited\\n� Non-PMB � R250 000 per family\\n20% deductible if treatment deviates from\\nprotocols\\nOncology medicine DSP: Dis-Chem Oncology and Medipost \\n","transplant":"PMB only � unlimited \\nCornea implants � R31 100 per implant","mri":"In & Out of Hospital: \\nUnlimited - with  R2 610 co-payment \\nRadiography in & out of hospital - R1 150 per family per year\\n","prosthesisInternal":"\\nHealth-essential functional prosthesis:\\n(R67 000 per beneficiary per year) \\nIntra-ocular lenses: R4 480 per lens\\n(2 lenses per beneficiary) \\nHip, knee and shoulder (non-PMBS):\\n(in case of acute injury) - Prosthesis  \\n\\nOther prostheses\\nVascular/cardiac prosthesis: R60 400\\nEVARS prosthesis:  R141 200 \\nProsthesis with reconstructive or restorative surgery and external breast prostheses: R10 300 per family \\n\\n\\n\\n\\n","prosthesisExternal":"External Prosthesis and Appliances: \\nSubject to available savings  \\nHyperbaric oxygen treatment: \\n� R700 per family\\n","rehab":"100% of Scheme Rate - unlimited\\nServices must be in an approved facility\\nPalliative care, R22 900 per family ","designatedServiceProvider":"Yes","conditionsCovered":"CDL in PMB","formulary":"Yes, 60% co-payment applies for non-formulary, non-DSP","partialLimits":"Non-PMB chronic medicine paid from available Savings\\n100% of (MMAP), generic medicine \\n80% of MT (if no generic is available)\\n70% of MMAP (original medicine used voluntarily although generic available)","preferredProvider":"None","overallAnualLimit":"Day-to-day limit for GP and specialist visits, virtual consultations, physiotherapy acute and self-medication including visits to emergency units\\nMember: R1 300\\nMember +: R2 600\\n","medicationOverCounter":"Subject to Savings, once depleted limited to available day-to-day benefits","medicationPrescribed":"Subject to Savings and GP Network, once depleted limited to available day-to-day benefits","practitionersGeneral":"Subject to Savings, once depleted limited to available day-to-day benefits","specialistsCover":"(Subject to Savings first)\\nNetwork GP referral - (day-to-day benefit)","dentistryCover":"Conservative dental benefits for children <18 years\\nRemoval of impacted teeth in the dentist�s chair - Benefits subject to DRC network","dentistryCoverSpecial":"Subject to available Savings","optical":"Benefits per 24-month cycle per beneficiary at PPN \\n1 Eye test   \\nLenses: Single vision lenses or bifocal or multifocal lenses                                                                                                                                                                                \\nSpectacles: Frames and / or Lens enhancements: R275 or\\nContact lenses: R650               ","ambulance":"Road and Air Transport: Netcare 911 \\nOutside these borders  \\nTransport by road:\\n100% of Cost - R2 210 per case\\nTransport by air:\\n100% of Cost - R14 700 per case","international":"No details provided","hospitalCoverAids":"Managed healthcare partner, LifeSense","artTtreatment":"Dis-Chem Direct and Medipost-preferred provider for HIV/Aids medicine","preventative":"Preventive care benefits\\n- Tetanus vaccine\\n- Flu vaccine\\n- Mammogram every 2 years\\n- Pap smear every 3 years\\n- Prostate test\\n- Pneumovax vaccine\\n- Faecal occult blood test (FOBT) \\n- Bone mineral density test every 2 years\\n- 2 HPV vaccinations for girls and boys between 10-14 years or three between 15-26 years\\nHealth screening tests\\nOne combo health screening (blood glucose, cholesterol, BMI & blood pressure measurement) or\\nan individual test (blood glucose or cholesterol)\\nHIV testing, counselling & support\\nChild immunisation\\nContraceptives - R145 per month, up to R1 690 per year\\n\\nCare extender benefit : Activates after\\nundergoing specific health tests:\\n� 1 GP consultation\\n� R450 for self medication\\n\\nPost-hospital care : R2 000 per member and R2 800 per family\\nBack treatment at a Document Based Care facility\\nChronic Care programme\\nOne dietician consultation if BMI is >30\\n(Refer to brochure for detailed benefits)","logo":"medihelp.jpg"},{"company":"Medihelp","name":"MedElite","planType":"New generation","coverLevel":"Mid","hospital":"Any","chronic":"Any","serviceType":"Any","familyIncome":"","mainContribution":"R5250","mainCompSavings":"R582","mainTotal":"R5832","dependendContributionAdult":"R4908","dependentCompSavingsAdult":"R546","dependentTotalAdult":"R5454","dependendContributionChild":"R1428","dependentCompSavingsChild":"R156","dependentTotalChild":"R1584","maxChildContribution":"All","mainThreshold":"","dependentThresholdAdult":"","dependentThresholdChild":"","preferedHospitalProvider":"Any hospital","overallLimit":"Unlimited","coPayment":"Refer to brochure for all applicable co-payments\\nProcedure-specific co-pays apply for non-PMB cases. 20% co-payment  if pre-authorisation is not obtained\\n\\nSpinal column surgery: R8 500 co-pay \\n\\nEndoscopic Procedures : R2 300 per\\nadmission, only gastroscopy, colonoscopy,\\narthroscopy and sigmoidoscopy\\nNetwork options: Day procedure network applies\\nNon-network options: Day procedure facilities apply\\n\\nMedicine on prescription/self-medication: 80% benefit applies to original medicine if no generic equivalent is available, 70% benefit applies to original medicine if a generic equivalent is available\\n","rate":"100% of Scheme Rate                                     ","generalMedicin":"R530 per admission","specialist":"100% of Scheme Rate                                           Unlimited","dentistSurgical":"Dental procedures under anaesthesia\\n(Subject to pre-auth and R970 per admission co-pay) For the removal of impacted teeth and extensive dental treatment for children < 7 years only.","mentalHealth":"Psychiatric treatment \\nIn and out of hospital\\nR38 200 per beneficiary\\nR53 100 per family per annum\\n","radiology":"100% of Scheme Rate : Unlimited ","pathology":"100% of Scheme Rate : Unlimited ","maternityBenefit":"In-hospital: unlimited\\nHome Delivery : R14 100 per event - 20% co-payment  if pre-authorisation is not obtained\\n\\nOut-of-hospital: subject to registration on HealthPrint�s Maternity and Baby programme: Flu vaccination\\n10 antenatal and postnatal visits with midwife/GP/gynae\\n2 antenatal and postnatal visits at a dietician/breastfeeding specialist/\\nantenatal classes\\nTwo 2D scans \\n9 months� supply of antenatal supplements (iron and folic acid) \\n2 visits with a GP/Paediatric/ENT specialist, children under 2 years\\n ","dialysis":"100% of Scheme Rate - Unlimited","cancer":"Subject to pre-auth and registration on Oncology Management Programme.\\n� PMB � unlimited\\n� Non-PMB � R433 000 per family\\n15% deductible if treatment deviates from\\nprotocols\\n\\n","transplant":"PMB � unlimited\\nCornea implants: R31 100 per implant","mri":"In Hospital:\\nUnlimited - with  R1 600 co-payment \\nOut of Hospital: R1 300 co-payment\\nRadiography in & out of hospital - R1 150 per family per year","prosthesisInternal":"\\nHealth-essential functional prosthesis:\\n(R67 000 per beneficiary per year) \\nIntra-ocular lenses: R4 480 per lens\\n(2 lenses per beneficiary) \\nHip, knee and shoulder (non-PMBS):\\n(in case of acute injury) - Prosthesis  \\n\\nOther prostheses\\nVascular/cardiac prosthesis: R60 400\\nEVARS prosthesis:  R141 200 \\nProsthesis with reconstructive or restorative surgery and external breast prostheses: R10 300 per family \\nImplantable hearing devices (including devices and components): R281 000 per beneficiary per year \\n\\nNeurostimulators: R93 700 per beneficiary\\n\\n\\n\\n","prosthesisExternal":"\\nExternal prostheses and medical appliances\\nIn-and-out-of-hospital\\nBenefit per 3-year cycle:  \\nArtificial eyes, speech and hearing aids:      R8 500 per beneficiary\\nArtificial limbs and wheelchairs: R6 750 per beneficiary\\n  \\nMedical appliances and hyperbaric oxygen\\ntreatment � R1 600 \\nCPAP apparatus � R10 400 per person \\n \\n\\n","rehab":"100% of Scheme Rate - unlimited\\nServices must be in an approved facility\\nPalliative care, R27 100 per family ","designatedServiceProvider":"None","conditionsCovered":"CDL in PMB and additional conditions","formulary":"Yes","partialLimits":"Non PMB chronic medication: \\n100% of MMAP\\nMember: R4 900\\nMember +1: R7 400\\nMember +2: R9 900\\nMember +3+: R10 600\\n100% of (MMAP), generic medicine \\n80% of MT (if no generic is available)\\n70% of MMAP (original medicine used voluntarily although generic available)","preferredProvider":"None","overallAnualLimit":"Day-to-day benefits\\nMember: R12 600\\nMember +1: R14 600\\nMember +2: R16 700\\nMember +3+: R18 800\\nLimits available after depletion of savings  \\n","medicationOverCounter":"Subject to Acute medicine limits","medicationPrescribed":"Subject to Savings, once depleted limited to available day-to-day benefits, following sub-limits apply:\\nMember: R4 200\\nMember +1: R5 300\\nMember +2: R6 300\\nMember +3+: R7 300","practitionersGeneral":"GP and specialist visits, virtual consultations, physiotherapy, clinical psychology, psychiatric nursing and supplementary health services. Subject to day-to-day limits and following sub-limits: \\nMember: R3 200\\nMember +1: R4 200\\nMember +2: R5 300\\nMember +3+:  R6 300","specialistsCover":"Subject to Savings, once depleted limited to available day-to-day benefits ","dentistryCover":"DRC network applies     \\n(including routine check-ups, fillings, X-rays, oral hygiene)            \\n","dentistryCoverSpecial":"DRC network applies     \\n(crowns, bridges and orthodontic treatment)    \\nOrthodontic treatment (one per beneficiary <18 years per family) R12 750 per lifetime     \\n","optical":"Benefits per 24-month cycle per beneficiary at PPN \\n1 Eye test\\nR1 680 for contact lenses\\nReplacement of lost/broken spectacles               ","ambulance":"Road and Air Transport: Netcare 911 \\nOutside these borders  \\nTransport by road:\\n100% of Cost - R2 210 per case\\nTransport by air:\\n100% of Cost - R14 700 per case","international":"No details provided","hospitalCoverAids":"Managed healthcare partner, LifeSense","artTtreatment":"Dis-Chem Direct and Medipost-preferred provider for HIV/Aids medicine","preventative":"Preventive care benefits\\n- Tetanus vaccine\\n- Flu vaccine\\n- Mammogram every 2 years\\n- Pap smear every 3 years\\n- Prostate test\\n- Pneumovax vaccine\\n- Faecal occult blood test (FOBT) \\n- Bone mineral density test every 2 years\\n- 2 HPV vaccinations for girls and boys between 10-14 years or three between 15-26 years\\nHealth screening tests\\nOne combo health screening (blood glucose, cholesterol, BMI & blood pressure measurement) or\\nan individual test (blood glucose or cholesterol)\\nHIV testing, counselling & support\\nChild immunisation\\nContraceptives - R160 per month, up to R1 900 per year\\n\\nCare extender benefit :\\nOne additional GP consultation\\nand R450 for self-medication\\n\\nPost-hospital care : R2 000 per member and R2 800 per family\\nBack treatment at a Document Based Care facility\\nChronic Care programme\\nOne dietician consultation if BMI is >30\\n(Refer to brochure for detailed benefits)","logo":"medihelp.jpg"},{"company":"Medihelp","name":"MedSaver","planType":"New generation","coverLevel":"Mid","hospital":"Network","chronic":"Network","serviceType":"Network","familyIncome":"","mainContribution":"R2118","mainCompSavings":"R696","mainTotal":"R2814","dependendContributionAdult":"R1734","dependentCompSavingsAdult":"R576","dependentTotalAdult":"R2310","dependendContributionChild":"R642","dependentCompSavingsChild":"R204","dependentTotalChild":"R846","maxChildContribution":"2","mainThreshold":"","dependentThresholdAdult":"","dependentThresholdChild":"","preferedHospitalProvider":"Any hospital","overallLimit":"Unlimited","coPayment":"Refer to brochure for all applicable co-payments\\nProcedure-specific co-pays apply for non-PMB cases. 20% co-payment  if pre-authorisation is not obtained.\\n\\nSpinal column surgery: R11 400 co-pay \\n\\nEndoscopic Procedures : R4 300 per admission\\nNetwork options: Day procedure network applies\\nNon-network options: Day procedure facilities apply\\n\\nR6 300 co-pay: Prostatectomy (conventional or laparoscopic), hysterectomy and endometrial ablation \\n\\nMedicine on prescription/self-medication : 80% benefit applies to original medicine if no generic equivalent is available, 70% benefit applies to original medicine if a generic equivalent is available","rate":"100% of the Scheme Rate","generalMedicin":"R370 per admission","specialist":"100% of the contracted tariff","dentistSurgical":"Dental procedures under anaesthesia\\n(Subject to pre-auth and R3 560 per admission co-pay) For the removal of impacted teeth and extensive dental treatment for children < 7 years only.","mentalHealth":"Psychiatric treatment \\nIn and out of hospital\\nR26 300 per beneficiary\\nR36 200 per family per annum\\n","radiology":"100% of Scheme Rate : Unlimited ","pathology":"100% of Scheme Rate : Unlimited ","maternityBenefit":"In-hospital: unlimited\\nHome Delivery:  R14 100 per event - 20% co-payment  if pre-authorisation is not obtained\\n\\nOut-of-hospital: subject to registration on HealthPrint�s Maternity and Baby programme: Flu vaccination\\n10 antenatal and postnatal visits with midwife/GP/gynae\\n2 antenatal and postnatal visits at a dietician/breastfeeding specialist/\\nantenatal classes\\nTwo 2D scans \\n2 visits with a GP/Paediatric/ENT specialist, children under 2 years\\n ","dialysis":"100% of Scheme Rate - Unlimited","cancer":"Subject to pre-auth and registration on Oncology Management Programme.\\n� PMB � unlimited\\n� Non-PMB � R250 000 per family\\n20% deductible if treatment deviates from\\nprotocols\\n\\n","transplant":"PMB only � unlimited \\nCornea implants � R31 100 per implant","mri":"In & Out of Hospital: \\nUnlimited - with  R2 610 co-payment \\nRadiography in & out of hospital - R1 150 per family per year\\n","prosthesisInternal":"\\nHealth-essential functional prosthesis:\\n(R67 000 per beneficiary per year) \\nIntra-ocular lenses: R4 480 per lens\\n(2 lenses per beneficiary) \\nHip, knee and shoulder (non-PMBS):\\n(in case of acute injury) - Prosthesis  \\n\\nOther prostheses\\nVascular/cardiac prosthesis: R60 400\\nEVARS prosthesis:  R141 200 \\nProsthesis with reconstructive or restorative surgery and external breast prostheses: R10 300 per family \\n\\n\\n\\n\\n","prosthesisExternal":"External Prosthesis and Appliances: \\nSubject to available savings  \\nHyperbaric oxygen treatment: \\n� R700 per family\\n","rehab":"100% of Scheme Rate - unlimited\\nServices must be in an approved facility\\nPalliative care, R22 900 per family ","designatedServiceProvider":"None","conditionsCovered":"CDL in PMB","formulary":"Yes","partialLimits":"Non-PMB chronic medicine paid from available Savings\\n100% of (MMAP), generic medicine \\n80% of MT (if no generic is available)\\n70% of MMAP (original medicine used voluntarily although generic available)","preferredProvider":"None","overallAnualLimit":"None","medicationOverCounter":"\\nSubject to available Savings","medicationPrescribed":"\\nSubject to available Savings","practitionersGeneral":"\\nSubject to Savings\\nChild care benefit: M+ R1 140 limit\\nGP consultations for children ?2 to <12 years, once Savings are depleted","specialistsCover":"\\nSubject to available Savings","dentistryCover":" Subject to DRC network\\nRemoval of impacted teeth in the dentist�s chair","dentistryCoverSpecial":"Subject to available Savings","optical":"Subject to available Savings","ambulance":"Road and Air Transport: Netcare 911 \\nOutside these borders  \\nTransport by road:\\n100% of Cost - R2 210 per case\\nTransport by air:\\n100% of Cost - R14 700 per case","international":"No details provided","hospitalCoverAids":"Managed healthcare partner, LifeSense","artTtreatment":"Dis-Chem Direct and Medipost-preferred provider for HIV/Aids medicine","preventative":"Preventive care benefits\\n- Tetanus vaccine\\n- Flu vaccine\\n- Mammogram every 2 years\\n- Pap smear every 3 years\\n- Prostate test\\n- Pneumovax vaccine\\n- Faecal occult blood test (FOBT) \\n- Bone mineral density test every 2 years\\n- 2 HPV vaccinations for girls and boys between 10-14 years or three between 15-26 years\\nHealth screening tests\\nOne combo health screening (blood glucose, cholesterol, BMI & blood pressure measurement) or\\nan individual test (blood glucose or cholesterol)\\nHIV testing, counselling & support\\nChild immunisation\\nContraceptives - R145 per month, up to R1 690 per year\\n\\nCare extender benefit :\\nOne additional GP consultation\\nand R450 for self-medication\\n\\nPost-hospital care : R2 000 per member and R2 800 per family\\nBack treatment at a Document Based Care facility\\nChronic Care programme\\nOne dietician consultation if BMI is >30\\n(Refer to brochure for detailed benefits)","logo":"medihelp.jpg"},{"company":"Medihelp","name":"MedElect Network Option","planType":"Capitation","coverLevel":"Low","hospital":"Network","chronic":"Network","serviceType":"Network","familyIncome":"0 - R800","mainContribution":"R702","mainCompSavings":"R0.00","mainTotal":"R702","dependendContributionAdult":"R702","dependentCompSavingsAdult":"R0.00","dependentTotalAdult":"R702","dependendContributionChild":"R702","dependentCompSavingsChild":"R0.00","dependentTotalChild":"R702","maxChildContribution":"","mainThreshold":"","dependentThresholdAdult":"","dependentThresholdChild":"","preferedHospitalProvider":"Network hospital\\nDay procedure network applies for certain day procedures","overallLimit":"Unlimited","coPayment":"Refer to brochure for all applicable co-payments\\n\\nProcedure-specific co-pays apply for non-PMB cases. 20% co-payment  if pre-authorisation is not obtained\\n\\nSpinal column surgery: R15 600 co-pay \\n\\nEndoscopic Procedures : R4 600 per admission\\nNetwork options: Day procedure network applies\\nNon-network options: Day procedure facilities apply\\n\\nR6 900 co-pay: Prostatectomy (conventional or laparoscopic), hysterectomy and endometrial ablation\\n\\nMedicine on prescription/self-medication : 80% benefit applies to original medicine if no generic equivalent is available, 70% benefit applies to original medicine if a generic equivalent is available ","rate":"100% of Scheme Rate","generalMedicin":"R370 per admission","specialist":"100% of the UPFS / contracted/ medicine price / scheme tariff","dentistSurgical":"Dental procedures under anaesthesia\\n(Subject to pre-auth, day hospital and R1 960 per admission co-pay) For the removal of impacted teeth and extensive dental treatment for children < 7 years only.","mentalHealth":"Psychiatric treatment \\nIn and out of hospital\\nR20 800  per beneficiary\\nR31 600 per family per annum","radiology":"100% of Scheme Rate : Unlimited ","pathology":"100% of Scheme Rate : Unlimited ","maternityBenefit":"\\nIn-hospital: unlimited \\nHome delivery: R14 100 per event - 35% co-payment  if pre-authorisation is not obtained\\n\\nOut-of-hospital: subject to registration on HealthPrint�s Maternity and Baby programme:\\nFlu vaccination\\n10 antenatal and postnatal visits with midwife/GP/gynae\\n2 antenatal and postnatal visits at a dietician/breastfeeding specialist/\\nantenatal classes\\nTwo 2D scans  \\n2 visits with a GP/Paediatric/ENT specialist,  children under 2 years\\n\\n ","dialysis":"100% of Scheme Rate - Unlimited","cancer":"Subject to pre-auth and registration on Oncology Management Programme.\\n� PMB: 100% of Scheme Rate\\n� Non-PMB: R220 000 per family\\n25% deductible if treatment deviates from\\nprotocols\\nOncology medicine DSP: Dis-Chem Oncology and Medipost ","transplant":"PMB only\\nCornea implants: R31 100 per implant","mri":"In & Out of Hospital: \\nUnlimited - with  R2 700 co-payment \\n","prosthesisInternal":"PMBs only","prosthesisExternal":"External Prosthesis: no benefit\\nWheelchairs & Appliances: \\nR1 000 per family\\nShared with benefit for glucometers","rehab":"Hospice: PMB only\\nSub-Acute and Private Nursing :\\nR24 100 per family per year(general day-to-day care excluded)\\nPalliative care: R18 800 per family per annum","designatedServiceProvider":"Medihelp Preferred Pharmacy Network","conditionsCovered":"CDL in PMB","formulary":"Yes","partialLimits":"None","preferredProvider":"GP and specialist Network","overallAnualLimit":"Annual day-to-day benefit\\nMember: R3 000\\nMember +: R5 300\\nMember +2: R6 100\\nMember +3: R6 500\\nMember +:7 000 per year","medicationOverCounter":"Member = R530\\nFamily = R1 570\\nSubject to day-to-day benefit","medicationPrescribed":"Subject to day-to-day benefit","practitionersGeneral":"\\nNetwork GP visits and virtual care: \\nMember: R2 100\\nMember +1: R3 700\\nMember +2: R4 350\\nMember +3: R4 650\\nMember +4+: R5 200\\n\\nNon-network GP consultations\\nMember = R1 200\\nFamily = R2 450","specialistsCover":"Subject to day-to-day benefit","dentistryCover":"DRC network applies     \\n(including routine check-ups, fillings, X-rays, oral hygiene and removal of impacted wisdom teeth)  ","dentistryCoverSpecial":"No benefit","optical":"Benefits per 24-month cycle per beneficiary at PPN \\n1 Eye test   \\nLenses: Single vision lenses or bifocal or multifocal lenses                                                                                                                                                                                \\nSpectacles: Frames and / or Lens enhancements: R550 or\\nContact lenses: R750               ","ambulance":"\\nWithin the borders of South Africa, by Netcare 911: 100% of Scheme Rate\\nOutside these borders  \\nTransport by road:\\n100% of Cost - R2 210 per case\\nTransport by air:\\n100% of Cost - R14 700 per case\\n","international":"No benefit","hospitalCoverAids":"Managed healthcare partner, LifeSense","artTtreatment":"Dis-Chem Direct and Medipost-preferred provider for HIV/Aids medicine","preventative":"Preventive care benefits\\n- Tetanus vaccine\\n- Flu vaccine\\n- Mammogram every 2 years\\n- Pap smear every 3 years\\n- Prostate test\\n- Pneumovax vaccine\\n- Faecal occult blood test (FOBT) \\n- Bone mineral density test every 2 years\\n- 2 HPV vaccinations for girls and boys between 10-14 years or three between 15-26 years\\nHealth screening tests\\nOne combo health screening (blood glucose, cholesterol, BMI & blood pressure measurement) or\\nan individual test (blood glucose or cholesterol)\\nHIV testing, counselling & support\\nChild immunisation\\nContraceptives - R140 per month, up to R1 600 per year\\nCare extender benefit :\\nOne additional GP consultation\\nand R450 for self-medication\\n\\nBack treatment at a Document Based Care facility\\nChronic Care programme\\nOne dietician consultation if BMI is >30\\n(Refer to brochure for detailed benefits)","logo":"medihelp.jpg"},{"company":"Medihelp","name":"MedElect Network Option","planType":"Capitation","coverLevel":"Low","hospital":"Network","chronic":"Network","serviceType":"Network","familyIncome":"R801+","mainContribution":"R2226","mainCompSavings":"R0.00","mainTotal":"R2226","dependendContributionAdult":"R1740","dependentCompSavingsAdult":"R0.00","dependentTotalAdult":"R1740","dependendContributionChild":"R720","dependentCompSavingsChild":"R0.00","dependentTotalChild":"R720","maxChildContribution":"","mainThreshold":"","dependentThresholdAdult":"","dependentThresholdChild":"","preferedHospitalProvider":"Network hospital\\nDay procedure network applies for certain day procedures","overallLimit":"Unlimited","coPayment":"Refer to brochure for all applicable co-payments\\n\\nProcedure-specific co-pays apply for non-PMB cases. 20% co-payment  if pre-authorisation is not obtained\\n\\nSpinal column surgery: R15 600 co-pay \\n\\nEndoscopic Procedures : R4 600 per admission\\nNetwork options: Day procedure network applies\\nNon-network options: Day procedure facilities apply\\n\\nR6 900 co-pay: Prostatectomy (conventional or laparoscopic), hysterectomy and endometrial ablation\\n\\nMedicine on prescription/self-medication : 80% benefit applies to original medicine if no generic equivalent is available, 70% benefit applies to original medicine if a generic equivalent is available ","rate":"100% of Scheme Rate","generalMedicin":"R370 per admission","specialist":"100% of the UPFS / contracted/ medicine price / scheme tariff","dentistSurgical":"Dental procedures under anaesthesia\\n(Subject to pre-auth, day hospital and R1 960 per admission co-pay) For the removal of impacted teeth and extensive dental treatment for children < 7 years only.","mentalHealth":"Psychiatric treatment \\nIn and out of hospital\\nR20 800  per beneficiary\\nR31 600 per family per annum","radiology":"100% of Scheme Rate : Unlimited ","pathology":"100% of Scheme Rate : Unlimited ","maternityBenefit":"\\nIn-hospital: unlimited \\nHome delivery: R14 100 per event - 35% co-payment  if pre-authorisation is not obtained\\n\\nOut-of-hospital: subject to registration on HealthPrint�s Maternity and Baby programme:\\nFlu vaccination\\n10 antenatal and postnatal visits with midwife/GP/gynae\\n2 antenatal and postnatal visits at a dietician/breastfeeding specialist/\\nantenatal classes\\nTwo 2D scans  \\n2 visits with a GP/Paediatric/ENT specialist,  children under 2 years\\n\\n ","dialysis":"100% of Scheme Rate - Unlimited","cancer":"Subject to pre-auth and registration on Oncology Management Programme.\\n� PMB: 100% of Scheme Rate\\n� Non-PMB: R220 000 per family\\n25% deductible if treatment deviates from\\nprotocols\\nOncology medicine DSP: Dis-Chem Oncology and Medipost ","transplant":"PMB only\\nCornea implants: R31 100 per implant","mri":"In & Out of Hospital: \\nUnlimited - with  R2 700 co-payment \\n","prosthesisInternal":"PMBs only","prosthesisExternal":"External Prosthesis: no benefit\\nWheelchairs & Appliances: \\nR1 000 per family\\nShared with benefit for glucometers","rehab":"Hospice: PMB only\\nSub-Acute and Private Nursing :\\nR24 100 per family per year(general day-to-day care excluded)\\nPalliative care: R18 800 per family per annum","designatedServiceProvider":"Medihelp Preferred Pharmacy Network","conditionsCovered":"CDL in PMB","formulary":"Yes","partialLimits":"None","preferredProvider":"GP and specialist Network","overallAnualLimit":"Annual day-to-day benefit\\nMember: R3 000\\nMember +: R5 300\\nMember +2: R6 100\\nMember +3: R6 500\\nMember +:7 000 per year","medicationOverCounter":"Member = R530\\nFamily = R1 570\\nSubject to day-to-day benefit","medicationPrescribed":"Subject to day-to-day benefit","practitionersGeneral":"\\nNetwork GP visits and virtual care: \\nMember: R2 100\\nMember +1: R3 700\\nMember +2: R4 350\\nMember +3: R4 650\\nMember +4+: R5 200\\n\\nNon-network GP consultations\\nMember = R1 200\\nFamily = R2 450","specialistsCover":"Subject to day-to-day benefit","dentistryCover":"DRC network applies     \\n(including routine check-ups, fillings, X-rays, oral hygiene and removal of impacted wisdom teeth)  ","dentistryCoverSpecial":"No benefit","optical":"Benefits per 24-month cycle per beneficiary at PPN \\n1 Eye test   \\nLenses: Single vision lenses or bifocal or multifocal lenses                                                                                                                                                                                \\nSpectacles: Frames and / or Lens enhancements: R550 or\\nContact lenses: R750               ","ambulance":"\\nWithin the borders of South Africa, by Netcare 911: 100% of Scheme Rate\\nOutside these borders  \\nTransport by road:\\n100% of Cost - R2 210 per case\\nTransport by air:\\n100% of Cost - R14 700 per case\\n","international":"No benefit","hospitalCoverAids":"Managed healthcare partner, LifeSense","artTtreatment":"Dis-Chem Direct and Medipost-preferred provider for HIV/Aids medicine","preventative":"Preventive care benefits\\n- Tetanus vaccine\\n- Flu vaccine\\n- Mammogram every 2 years\\n- Pap smear every 3 years\\n- Prostate test\\n- Pneumovax vaccine\\n- Faecal occult blood test (FOBT) \\n- Bone mineral density test every 2 years\\n- 2 HPV vaccinations for girls and boys between 10-14 years or three between 15-26 years\\nHealth screening tests\\nOne combo health screening (blood glucose, cholesterol, BMI & blood pressure measurement) or\\nan individual test (blood glucose or cholesterol)\\nHIV testing, counselling & support\\nChild immunisation\\nContraceptives - R140 per month, up to R1 600 per year\\nCare extender benefit :\\nOne additional GP consultation\\nand R450 for self-medication\\n\\nBack treatment at a Document Based Care facility\\nChronic Care programme\\nOne dietician consultation if BMI is >30\\n(Refer to brochure for detailed benefits)","logo":"medihelp.jpg"},{"company":"Medihelp","name":"MedElect Student","planType":"Capitation","coverLevel":"Low","hospital":"Network","chronic":"Network","serviceType":"Network","familyIncome":"0 - R800","mainContribution":"R702","mainCompSavings":"R0.00","mainTotal":"R702","dependendContributionAdult":"R702","dependentCompSavingsAdult":"R0.00","dependentTotalAdult":"R702","dependendContributionChild":"R702","dependentCompSavingsChild":"R0.00","dependentTotalChild":"R702","maxChildContribution":"","mainThreshold":"","dependentThresholdAdult":"","dependentThresholdChild":"","preferedHospitalProvider":"Network hospital\\nDay procedure network applies for certain day procedures","overallLimit":"Unlimited","coPayment":"Refer to brochure for all applicable co-payments\\n\\nProcedure-specific co-pays apply for non-PMB cases. 20% co-payment  if pre-authorisation is not obtained\\n\\nSpinal column surgery: R15 600 co-pay \\n\\nEndoscopic Procedures : R4 600 per admission\\nNetwork options: Day procedure network applies\\nNon-network options: Day procedure facilities apply\\n\\nR6 900 co-pay: Prostatectomy (conventional or laparoscopic), hysterectomy and endometrial ablation\\n\\nMedicine on prescription/self-medication : 80% benefit applies to original medicine if no generic equivalent is available, 70% benefit applies to original medicine if a generic equivalent is available ","rate":"100% of Scheme Rate","generalMedicin":"R370 per admission","specialist":"100% of the UPFS / contracted/ medicine price / scheme tariff","dentistSurgical":"Dental procedures under anaesthesia\\n(Subject to pre-auth, day hospital and R1 960 per admission co-pay) For the removal of impacted teeth and extensive dental treatment for children < 7 years only.","mentalHealth":"Psychiatric treatment \\nIn and out of hospital\\nR20 800  per beneficiary\\nR31 600 per family per annum","radiology":"100% of Scheme Rate : Unlimited ","pathology":"100% of Scheme Rate : Unlimited ","maternityBenefit":"\\nIn-hospital: unlimited \\nHome delivery: R14 100 per event - 35% co-payment  if pre-authorisation is not obtained\\n\\nOut-of-hospital: subject to registration on HealthPrint�s Maternity and Baby programme:\\nFlu vaccination\\n10 antenatal and postnatal visits with midwife/GP/gynae\\n2 antenatal and postnatal visits at a dietician/breastfeeding specialist/\\nantenatal classes\\nTwo 2D scans  \\n2 visits with a GP/Paediatric/ENT specialist,  children under 2 years\\n\\n ","dialysis":"100% of Scheme Rate - Unlimited","cancer":"Subject to pre-auth and registration on Oncology Management Programme.\\n� PMB: 100% of Scheme Rate\\n� Non-PMB: R220 000 per family\\n25% deductible if treatment deviates from\\nprotocols\\n","transplant":"PMB only\\nCornea implants: R31 100 per implant","mri":"In & Out of Hospital: \\nUnlimited - with  R2 700 co-payment \\nRadiography in & out of hospital - R1 150 per family per year\\n","prosthesisInternal":"PMBs only","prosthesisExternal":"External Prosthesis: no benefit\\nWheelchairs & Appliances: \\nR1 000 per family\\nShared with benefit for glucometers","rehab":"Hospice: PMB only\\nSub-Acute and Private Nursing :\\nR24 100 per family per year(general day-to-day care excluded)\\nPalliative care: R18 800 per family per annum","designatedServiceProvider":"Medihelp Preferred Pharmacy Network","conditionsCovered":"CDL in PMB","formulary":"Yes","partialLimits":"None","preferredProvider":"GP and specialist Network","overallAnualLimit":"Annual day-to-day benefit\\nMember: R3 000\\nMember +: R5 300\\nMember +2: R6 100\\nMember +3: R6 500\\nMember +:7 000 per year","medicationOverCounter":"Member = R530\\nFamily = R1 570\\nSubject to day-to-day benefit","medicationPrescribed":"Subject to day-to-day benefit","practitionersGeneral":"\\nNetwork GP visits and virtual care: \\nMember: R2 100\\nMember +1: R3 700\\nMember +2: R4 350\\nMember +3: R4 650\\nMember +4+: R5 200\\n\\nNon-network GP consultations\\nMember = R1 200\\nFamily = R2 450","specialistsCover":"Subject to day-to-day benefit","dentistryCover":"DRC network applies     \\n(including routine check-ups, fillings, X-rays, oral hygiene and removal of impacted wisdom teeth)  ","dentistryCoverSpecial":"No benefit","optical":"Benefits per 24-month cycle per beneficiary at PPN \\n1 Eye test   \\nLenses: Single vision lenses or bifocal or multifocal lenses                                                                                                                                                                                \\nSpectacles: Frames and / or Lens enhancements: R550 or\\nContact lenses: R750               ","ambulance":"\\nWithin the borders of South Africa, by Netcare 911: 100% of Scheme Rate\\nOutside these borders  \\nTransport by road:\\n100% of Cost - R2 210 per case\\nTransport by air:\\n100% of Cost - R14 700 per case\\n","international":"No benefit","hospitalCoverAids":"Managed healthcare partner, LifeSense","artTtreatment":"Dis-Chem Direct and Medipost-preferred provider for HIV/Aids medicine","preventative":"Preventive care benefits\\n- Tetanus vaccine\\n- Flu vaccine\\n- Mammogram every 2 years\\n- Pap smear every 3 years\\n- Prostate test\\n- Pneumovax vaccine\\n- Faecal occult blood test (FOBT) \\n- Bone mineral density test every 2 years\\n- 2 HPV vaccinations for girls and boys between 10-14 years or three between 15-26 years\\nHealth screening tests\\nOne combo health screening (blood glucose, cholesterol, BMI & blood pressure measurement) or\\nan individual test (blood glucose or cholesterol)\\nHIV testing, counselling & support\\nChild immunisation\\nContraceptives - R140 per month, up to R1 600 per year\\nCare extender benefit :\\nOne additional GP consultation\\nand R450 for self-medication\\n\\nBack treatment at a Document Based Care facility\\nChronic Care programme\\nOne dietician consultation if BMI is >30\\n(Refer to brochure for detailed benefits)","logo":"medihelp.jpg"},{"company":"Medshield","name":"Premium Plus ","planType":"Threshold option","coverLevel":"High","hospital":"Any","chronic":"Network","serviceType":"Any","familyIncome":"","mainContribution":"R5398","mainCompSavings":"R1349","mainTotal":"R6747","dependendContributionAdult":"R4946","dependentCompSavingsAdult":"R1237","dependentTotalAdult":"R6183","dependendContributionChild":"R1032","dependentCompSavingsChild":"R258","dependentTotalChild":"R1290","maxChildContribution":"3","mainThreshold":"","dependentThresholdAdult":"","dependentThresholdChild":"","preferedHospitalProvider":"Any hospital","overallLimit":"Unlimited","coPayment":"Co-payment \\nR1 000 Endoscopic procedures, functional nasal surgery\\nR2 000 Arthroscopic procedures, laparoscopies procedures, wisdom teeth\\nR3 000 Hernia repair (except in infants)\\nR4 000 Back and neck surgery\\nR5 000 Nissen fundoplication, hysterectomy \\n20% penalty, in addition to above co-payments if authorisation was not obtained\\n(No In-Hospital Endoscopic procedural co-payment applicable for children 8 years and younger) ","rate":"200% of Scheme Rate","generalMedicin":"Limited to R840 per admission","specialist":"100% of Scheme Rate\\nExtended Benefit Cover (up to 200%)","dentistSurgical":"\\nAccording to the Dental Managed Healthcare Programme\\n\\nMaxillo-facial and oral surgery \\nExtended Benefit Cover (up to 200%)\\nR19 300 per family\\nNon-elective surgery only                                                                                                             \\n\\nImpacted Teeth, Wisdom Teeth and Apicectomy: subject to specialised dentistry limit of R19 300 per family \\n(R2 000 co-payment when performed in hospital)                                                                                          \\n\\n","mentalHealth":"\\nR58 545 per family per annum \\nMax 3 days cover if admitted by a GP \\nRehabilitation for substance abuse:\\nSub-limit of R15 620 per family \\nLimited to 1 rehab programme pbpa\\n\\n","radiology":"100% Scheme Rate, unlimited","pathology":"100% Scheme Rate, unlimited","maternityBenefit":"In-hospital: Unlimited\\nOut of hospital:\\n4 postnatal midwife consultations\\nDelivery by a registered Midwife: 200% Medshield Private rate\\n12 Antenatal consultations\\nAntenatal classes: R530 per family \\n1 Amniocentesis test per pregnancy\\n2 x 2D scans\\nMedshield MOM : assist women\\non their journey to motherhood\\n ","dialysis":"100% negotiated fee\\n40% co-payment for use of non-DSP   ","cancer":"Unlimited, Enhanced Protocols apply.\\nPost active treatment covered for 36 months. 40% co-payment for use of non-DSP\\nFollowing sub-limits apply per annum:\\nOncology Medicine: R372 355 per family  \\n- Specialised drugs: Subject to Oncology medicine limit  \\n- Integrated continuous care: to 6 visits per family p.a\\n- Vitreoretinal Benefit: subject to the Specialised Drugs Limit \\n- PET-CT: R23 670 per family, 10% co-pay for non-PMB. (1 scan per beneficiary per year)  \\n- Breast reconstruction: R89 200 per family p.a                         \\n\\n                             \\n","transplant":"Unlimited: subject to pre-auth by relevant Managed Healthcare Programme\\n� Corneal Grafts and Transplant (International): R44 185 per beneficiary  \\n� Corneal Grafts and Transplant (Local): \\n   R18 940 per beneficiary         ","mri":"\\nIn and out of hospital: R28 150 per family p.a","prosthesisInternal":"R66 300 per family, 25% co-payment for non-PMBs. Hips and knees sub-limit of R33 660 p.b. Subject to pre-authorisation and services obtained form a DSP\\n","prosthesisExternal":"External prosthesis: combined with internal Prosthesis, no co-payments\\nAppliance, R6 630 per family p.a\\n","rehab":"R140 550 per family p.a\\nTerminal Care: R39 240 per family sub-limit","designatedServiceProvider":"Medshield Pharmacy Network","conditionsCovered":"CDL in PMB + 54 conditions","formulary":"MPL / MGP formulary","partialLimits":"54 Non-CDL conditions limited to:\\nBeneficiary:  R15 630\\nFamily: R31 260\\n40% co-payment for out of formulary medication and non-network pharmacy\\n\\n","preferredProvider":"None","overallAnualLimit":"None","medicationOverCounter":"Subject to Savings and threshold\\nLimit to R250 per script, 1 script p.b per day\\nco-payment for non-network provider","medicationPrescribed":"Subject to Savings, threshold and above threshold","practitionersGeneral":"\\nSubject to Savings, threshold and above threshold - Unlimited\\nOnce Savings is depleted, 2 visits per beneficiary from Risk \\nRegistered Chronic beneficiaries extended FP consultations and visits : Once Savings is depleted, 2 visits per beneficiary from Risk \\nSmartCare Benefits:\\nUnlimited pharmacy / private nurse consultations at DSP\\nNurse-led Videomed FP: 1 visit per family paid from Risk benefit, thereafter paid from Savings\\n","specialistsCover":"Subject to Savings, threshold and above threshold\\nSmartCare Benefits:\\nMedical specialist telephonic and video consultations  ","dentistryCover":"Subject to Savings, threshold and above threshold. DENIS protocols apply","dentistryCoverSpecial":"Limited to R19 300 per family, subject to Savings, threshold and above threshold. DENIS protocols apply","optical":"\\nSubject to Savings \\n\\nThe following sub-limits apply:\\nEye test: 1 test per beneficiary every two years\\nReaders: R180 per beneficiary per annum \\n\\n","ambulance":"Netcare 911","international":"No detail supplied","hospitalCoverAids":"Unlimited, Lifesense Disease Management registration required","artTtreatment":"Out of formulary PMB medication voluntarily obtained or PMB medication voluntarily obtained from a provider other than the DSP will have a 40% upfront co-payment","preventative":"Wellness Benefits:\\nAdult Vaccination Including Travel Vaccinations  \\nBirth Control (limit of R190 per script)\\nBone Density\\nFlu Vaccination\\nHealth Risk Assessment (Pharmacy or Family Practitioner)\\nHPV Vaccination\\nMammogram\\nNational HIV Counselling Testing\\nPap Smear\\nPneumococcal Vaccination\\nPSA Screening\\nTB Test\\nChild Immunisations as per DoH\\nIntrauterine devices & alternatives: 1 per female beneficiary\\nMirena/Kyleena device: every 5 years\\nImplanon: every 3 years\\nNova T: every 2 years\\n","logo":"medshield.png"},{"company":"Medshield","name":"MediValue Prime","planType":"Traditional","coverLevel":"Mid","hospital":"Network","chronic":"Network","serviceType":"Network","familyIncome":"","mainContribution":"R2364","mainCompSavings":"R0.00","mainTotal":"R2364","dependendContributionAdult":"R2064","dependentCompSavingsAdult":"R0.00","dependentTotalAdult":"R2064","dependendContributionChild":"R666","dependentCompSavingsChild":"R0.00","dependentTotalChild":"R666","maxChildContribution":"3","mainThreshold":"","dependentThresholdAdult":"","dependentThresholdChild":"","preferedHospitalProvider":"Prime Hospital Network","overallLimit":"Unlimited","coPayment":"25% co-payment for use of non-network hospital\\nCo-payments:\\nR2 000 Endoscopic, Functional Nasal surgery\\nR3 000 Hernia repair (except in infants)\\nR4 000 Laparoscopies procedures, Arthroscopic procedures\\nR5 000 Nissen Fundoplication, Hysterectomy \\n20% penalty, in addition to co-payments if authorisation was not obtained \\nnon-PMB Internal Prosthesis: 20%\\n(No In-Hospital Endoscopic procedural co-payment applicable for children 8 years and younger) ","rate":"100% of Scheme Rate","generalMedicin":"Limited to R475 per admission","specialist":"100% of Scheme Rate, unlimited","dentistSurgical":"According to the Dental Managed Healthcare Programme)\\nHospitalisation for basic dentistry for beneficiaries under the age of 6 years - \\nsubject to Basic Dentistry limit of R2 300 per family, thereafter subject to Day-to-Day Limit\\n\\nMaxillo-facial and Oral Surgery:\\nR7 470 per family p.a. (Non-elective surgery only) \\nImpacted Teeth, Wisdom Teeth and Apicectomy:  subject to Specialised Dentistry limit- R6 630 per family per annum \\nR4 000 co-payment apply\\n                                              ","mentalHealth":"Unlimited, subject to PMB and PMB level of care, 25% co-payment for use of non-DSP facility. Max 3 days cover if admitted by a GP \\nRehabilitation for substance abuse\\nLimited to 1 rehab programme pbpa and PMB level of care\\n","radiology":"100% Scheme Rate, unlimited","pathology":"100% Scheme Rate, unlimited","maternityBenefit":"In hospital: Unlimited \\nDelivery by a registered Midwife: \\n200% of Scheme Private rate\\nOut of hospital: \\n6 Antenatal consultations\\nAntenatal classes: R530 per family \\n4 postnatal midwife consultations\\n1 Amniocentesis test per pregnancy\\n2 x 2D scans\\nMedshield MOM  : assist women\\non their journey to motherhood","dialysis":"Unlimited, subject to PMB and PMB level of care at DSP. 40% co-payment for use of non-DSP  ","cancer":"Unlimited, subject to PMB and PMB level of care. ICON standard protocols apply\\nPost active treatment covered for 36 months. 40% co-payment for use of non-DSP   \\n- PET Scans: 1 scan per family\\n- Integrated continuous care: 6 visits per family \\n- Vitreoretinal Benefit: R40 000 per family\\n- Breast reconstruction: R89 200 per family       \\n             \\n","transplant":"\\nUnlimited subject to PMB and\\nPMB level of care\\n25% co-pay apply for non-DSP hospital\\n� Corneal Grafts and Transplant (International): R44 185 per beneficiary  \\n� Corneal Grafts and Transplant (Local): R18 940 per beneficiary  \\n\\n","mri":"In and out of hospital: \\nR9 800 per family, with 8% co-payment \\nCT Colonography (Virtual colonoscopy): no co-payment applies\\n","prosthesisInternal":"Subject to PMBs and network\\nR33 660 p.b. for hips and knees","prosthesisExternal":"External prosthesis subject PMBs\\nAppliances: R2 800 per family \\n","rehab":"\\nR31 250 per family at Network provider\\nTerminal care: R13 000  family sub-limit. Treatment only available immediately following an event\\n","designatedServiceProvider":"Medshield Pharmacy Network","conditionsCovered":"CDL in PMB","formulary":"Yes","partialLimits":"40% co-payment for use of non-formulary, non-Network Pharmacy","preferredProvider":"Nominated GP","overallAnualLimit":"M        : R6 000\\nM+1    : R7 150\\nM+2    : R8 050\\nM+3    : R9 370\\nM4+    : R10 365","medicationOverCounter":"Subject to day-to-day limit\\nR250 per script, 1 script p.b per day","medicationPrescribed":"Subject to day-to-day limit","practitionersGeneral":"\\nSubject to day-to-day limit\\nGP visits can be accessed in-person, telephonically or virtually\\nNominated GP(max of 2 GPs can be nominated) : Unlimited\\n2 additional visits per family, once day-to-day limit has been depleted \\nNon-nominated GP:\\n2 visits per family, subject to day-to-day limit\\nSmartCare Benefits:\\nUnlimited pharmacy / private nurse consultations at DSP\\nNurse-led Videomed FP: 1 visit per family paid from Risk benefit, thereafter paid from day-to-day limit\\n Registered chronic beneficiaries extended GP consultations and visits: 2  per beneficiary, once day-to-day limit has been depleted \\n \\n","specialistsCover":"2 visit per family, thereafter paid from day-to-day limit\\nSmartCare Benefits:\\nMedical specialist telephonic and video consultations ","dentistryCover":"R2 300 per family p.a., thereafter subject to day-to-day limit","dentistryCoverSpecial":"Limited to R6 630 per family per annum, protocols apply","optical":"1 test per beneficiary every 24 month cycle, subject to Risk benefits\\n1 pair lenses OR contact lenses p.b. \\nFrame and/or lens enhancements: R420\\nReaders: R180 per beneficiary p.a.","ambulance":"Netcare 911","international":"No details supplied","hospitalCoverAids":"Unlimited, Lifesense Disease Management registration required","artTtreatment":"40% co-payment for out of formulary PMB medication or use of non-DSP","preventative":"Wellness Benefits:\\nAdult Vaccination Including Travel Vaccinations  \\nBirth Control (limit of R190 per script)\\nBone Density\\nFlu Vaccination\\nHealth Risk Assessment (Pharmacy or Family Practitioner)\\nHPV Vaccination\\nMammogram\\nNational HIV Counselling Testing\\nPap Smear\\nPneumococcal Vaccination\\nPSA Screening\\nTB Test\\nChild Immunisations as per DoH\\nIntrauterine devices & alternatives: 1 per female beneficiary\\nMirena/Kyleena device: every 5 years\\nImplanon: every 3 years\\nNova T: every 2 years\\n","logo":"medshield.png"},{"company":"Medshield","name":"MediValue Compact","planType":"Traditional","coverLevel":"Mid","hospital":"Network","chronic":"Network","serviceType":"Network","familyIncome":"","mainContribution":"R2139","mainCompSavings":"R0.00","mainTotal":"R2139","dependendContributionAdult":"R1869","dependentCompSavingsAdult":"R0.00","dependentTotalAdult":"R1869","dependendContributionChild":"R603","dependentCompSavingsChild":"R0.00","dependentTotalChild":"R603","maxChildContribution":"3","mainThreshold":"","dependentThresholdAdult":"","dependentThresholdChild":"","preferedHospitalProvider":"Compact Hospital Network","overallLimit":"Unlimited","coPayment":"25% co-payment for use of non-network hospital\\nCo-payments:\\nR2 000 Endoscopic, Functional Nasal surgery\\nR3 000 Hernia repair (except in infants)\\nR4 000 Laparoscopies procedures, Arthroscopic procedures\\nR5 000 Nissen Fundoplication, Hysterectomy \\n20% penalty, in addition to co-payments if authorisation was not obtained \\nnon-PMB Internal Prosthesis: 20%\\n(No In-Hospital Endoscopic procedural co-payment applicable for children 8 years and younger) ","rate":"100% of Scheme Rate","generalMedicin":"Limited to R475 per admission","specialist":"100% of Scheme Rate, unlimited","dentistSurgical":"According to the Dental Managed Healthcare Programme)\\nHospitalisation for basic dentistry for beneficiaries under the age of 6 years - \\nsubject to Basic Dentistry limit of R2 300 per family, thereafter subject to Day-to-Day Limit\\n\\nMaxillo-facial and Oral Surgery:\\nR7 470 per family p.a. (Non-elective surgery only) \\nImpacted Teeth, Wisdom Teeth and Apicectomy:  subject to Specialised Dentistry limit- R6 630 per family per annum\\nR4 000 co-payment apply\\n                                              ","mentalHealth":"Subject to PMB and PMB level of care, 25% co-payment for use of non-DSP facility. Max 3 days cover if admitted by a GP \\nRehabilitation for substance abuse\\nLimited to 1 rehab programme pbpa and PMB level of care\\n","radiology":"100% Scheme Rate, unlimited","pathology":"100% Scheme Rate, unlimited","maternityBenefit":"In hospital: Unlimited \\nDelivery by a registered Midwife: \\n200% of Scheme Private rate\\nOut of hospital: \\n6 Antenatal consultations\\nAntenatal classes: R530 per family \\n4 postnatal midwife consultations\\n1 Amniocentesis test per pregnancy\\n2 x 2D scans\\nMedshield MOM  : assist women\\non their journey to motherhood","dialysis":"Unlimited, subject to PMB and PMB level of care at DSP. 40% co-payment for use of non-DSP  ","cancer":"Unlimited, subject to PMB and PMB level of care. ICON standard protocols apply \\nPost active treatment covered for 36 months. 40% co-payment for use of non-DSP   \\n- PET Scans: 1 scan per family\\n- Integrated continuous care: 6 visits per family \\n- Vitreoretinal Benefit: R40 000 per family\\n- Breast reconstruction: R89 200 per family       \\n             \\n","transplant":"\\nUnlimited subject to PMB and\\nPMB level of care\\n25% co-pay apply for non-DSP hospital\\n� Corneal Grafts and Transplant (International): R44 185 per beneficiary  \\n� Corneal Grafts and Transplant (Local): R18 940 per beneficiary  \\n\\n","mri":"In and out of hospital: \\nR9 800 per family, with 8% co-payment \\nCT Colonography (Virtual colonoscopy): no co-payment applies\\n","prosthesisInternal":"Subject to PMBs and network\\nR33 660 p.b. for hips and knees","prosthesisExternal":"External prosthesis subject PMBs\\nAppliances: R2 800 per family \\n","rehab":"\\nR31 250 per family at Network provider\\nTerminal care: R13 000  family sub-limit. Treatment only available immediately following an event\\n","designatedServiceProvider":"Medshield Pharmacy Network","conditionsCovered":"CDL in PMB","formulary":"Yes","partialLimits":"40% co-payment for use of non-formulary, non-Network Pharmacy","preferredProvider":"Nominated GP","overallAnualLimit":"M        : R6 000\\nM+1    : R7 150\\nM+2    : R8 050\\nM+3    : R9 370\\nM4+    : R10 365","medicationOverCounter":"Subject to day-to-day limit\\nR250 per script, 1 script p.b per day","medicationPrescribed":"Subject to day-to-day limit","practitionersGeneral":"Subject to day-to-day limit\\nGP visits can be accessed in-person, telephonically or virtually\\nNominated GP : (max of 2 GPs can be nominated): Unlimited\\n2 additional visits per family, once day-to-day limit has been depleted \\nNon-nominated GP:\\n2 visits per family, subject to day-to-day limit. Once depleted 40% co-payment apply\\nSmartCare Benefits:\\nUnlimited pharmacy / private nurse consultations at DSP\\nNurse-led Videomed FP: 1 visit per family paid from Risk, thereafter paid from day-to-day limit\\n Registered chronic beneficiaries extended GP consultations and visits: 2  per beneficiary, once day-to-day limit has been depleted \\n","specialistsCover":"2 visit per family, thereafter paid from day-to-day limit. Subject to nominated Network GP referral, 40% co-pay for non-referral \\nSmartCare Benefits:\\nMedical specialist telephonic and video consultations - subject to referral auth","dentistryCover":"R2 300 per family p.a., thereafter subject to day-to-day limit","dentistryCoverSpecial":"Limited to R6 630 per family per annum, protocols apply","optical":"Preferred Provider: Compact Optical Network. \\n1 test per beneficiary every 24 month cycle, subject to Risk benefits.\\n1 pair lenses OR contact lenses p.b. Frame and/or lens enhancements: R420. Readers: R180 per beneficiary p.a.","ambulance":"Netcare 911","international":"No details supplied","hospitalCoverAids":"Unlimited, Lifesense Disease Management registration required","artTtreatment":"40% co-payment for out of formulary PMB medication or use of non-DSP","preventative":"Wellness Benefits:\\nAdult Vaccination Including Travel Vaccinations  \\nBirth Control (limit of R190 per script)\\nBone Density\\nFlu Vaccination\\nHealth Risk Assessment (Pharmacy or Family Practitioner)\\nHPV Vaccination\\nMammogram\\nNational HIV Counselling Testing\\nPap Smear\\nPneumococcal Vaccination\\nPSA Screening\\nTB Test\\nChild Immunisations as per DoH\\nIntrauterine devices & alternatives: 1 per female beneficiary\\nMirena/Kyleena device: every 5 years\\nImplanon: every 3 years\\nNova T: every 2 years\\n","logo":"medshield.png"},{"company":"Medshield","name":"MediCore","planType":"Hospital plan","coverLevel":"Mid","hospital":"Network","chronic":"Any","serviceType":"N/A","familyIncome":"","mainContribution":"R2961","mainCompSavings":"R0.00","mainTotal":"R2961","dependendContributionAdult":"R2505","dependentCompSavingsAdult":"R0.00","dependentTotalAdult":"R2505","dependendContributionChild":"R684","dependentCompSavingsChild":"R0.00","dependentTotalChild":"R684","maxChildContribution":"3","mainThreshold":"","dependentThresholdAdult":"","dependentThresholdChild":"","preferedHospitalProvider":"Medshield Hospital Network","overallLimit":"Unlimited","coPayment":"25% co-payment for use of non-network hospital\\nCo-payments:\\nR2 000 Endoscopic procedures\\nR3 000 on Hernia repair \\nR4 000 Arthroscopic procedures, Laparoscopies procedures\\nR5 000 Nissen Fundoplication, Hysterectomy, Functional nasal surgery\\nR8 000 Back and Neck surgery \\n20% penalty, in addition to co-payments if authorisation was not obtained\\n(No In-Hospital Endoscopic procedural co-payment applicable for children 8 years and younger) \\n ","rate":"100% of Scheme Rate","generalMedicin":"Limited to R370 per admission","specialist":"Unlimited, Extended Benefit Cover (up to 200%)","dentistSurgical":"According to the Dental Managed Healthcare Programme)\\nIn-hospital (only for beneficiaries under the age of 6 years old for extensive\\nBasic Dentistry).\\n\\nMaxillo-Facial and Oral Surgery\\nR12 900 per family, Extended benefit cover up to 200% \\nNon-elective surgery only \\n                                           ","mentalHealth":"\\n\\nR37 240 per family, 25% co-payment for use of non-DSP facility\\nMax 3 days cover if admitted by a GP \\nRehabilitation for substance abuse\\nLimited to 1 rehab programme pbpa and PMB level of care\\n\\n\\n","radiology":"100% Scheme Rate, unlimited\\n1 Bone Densitometry scan p.b. p.a","pathology":"100% Scheme Rate, unlimited","maternityBenefit":"In hospital: Unlimited \\nDelivery by a registered Midwife: \\n200% of Scheme Private rate\\nOut of hospital: \\n6 Antenatal consultations\\n4 postnatal midwife consultations\\n2 x 2D scans\\nMedshield MOM : assist women\\non their journey to motherhood","dialysis":"Unlimited, subject to PMB and PMB level of care at DSP. 40% co-payment for use of non-DSP  ","cancer":"Unlimited, subject to PMB and PMB level of care. ICON Standard Protocols apply\\nPost active treatment covered for 36 months. 40% co-payment for use of non-DSP   \\n- PET Scans: Subject to oncology limit\\n- Integrated continuous care: 6 visits per family\\nBreast reconstruction: R89 200 per family       \\n             \\n","transplant":"\\nUnlimited subject to PMB and\\nPMB level of care\\n25% co-pay apply for non-DSP hospital\\n� Corneal Grafts and Transplant (International): R44 185 per beneficiary  \\n� Corneal Grafts and Transplant (Local): R18 940 per beneficiary  \\n","mri":"In and out of hospital:                       \\nR10 050 per family, with 10% co-payment\\n","prosthesisInternal":"\\n\\nR35 770 per family, 25% co-payment for non-PMB Internal Prosthesis and Devices. Hips and knees: sub-limit of R33 660 p.b. Subject to PMB and  PMB level of care\\n\\n\\n","prosthesisExternal":"External prosthesis: Combined with Internal prosthesis: No co-payments\\nAppliances: Unlimited if pre-authorised, PMBs only","rehab":"\\nR42 710 per family at DSP \\nTerminal Care: R39 240 per family sub-limit. Treatment only available immediately following an event\\n","designatedServiceProvider":"Medshield Pharmacy Network","conditionsCovered":"CDL in PMB","formulary":"Yes","partialLimits":"40% co-payment for use of non-formulary, non-Network Pharmacy","preferredProvider":"None","overallAnualLimit":"N/A","medicationOverCounter":"No benefit","medicationPrescribed":"No benefit","practitionersGeneral":"SmartCare Benefits:\\nUnlimited pharmacy / private nurse consultations at DSP\\nNurse-led Videomed GP:\\n1 visit per family paid from Risk benefit\\nGP visits can be accessed in-person, telephonically or virtually\\n(Family Practitioner) consultations and visits: 2 per beneficiary paid from Risk\\n\\n ","specialistsCover":"No benefit","dentistryCover":"No benefit","dentistryCoverSpecial":"No benefit","optical":"No benefit","ambulance":"Netcare 911","international":"No details supplied","hospitalCoverAids":"Unlimited, Lifesense Disease Management registration required","artTtreatment":"40% co-payment for out of formulary PMB medication or use of non-DSP","preventative":"Wellness Benefits:\\nBirth Control (limit of R190 per script)\\nFlu Vaccination\\nHealth Risk Assessment (Pharmacy or Family Practitioner)\\nHPV Vaccination\\nNational HIV Counselling Testing\\nPap Smear\\nPneumococcal Vaccination\\nTB Test\\nChild Immunisations as per DoH\\n\\n","logo":"medshield.png"},{"company":"Medshield","name":"MediBonus","planType":"Traditional","coverLevel":"Mid","hospital":"Any","chronic":"Network","serviceType":"Network","familyIncome":"","mainContribution":"R6528","mainCompSavings":"R0.00","mainTotal":"R6528","dependendContributionAdult":"R4587","dependentCompSavingsAdult":"R0.00","dependentTotalAdult":"R4587","dependendContributionChild":"R1359","dependentCompSavingsChild":"R0.00","dependentTotalChild":"R1359","maxChildContribution":"3","mainThreshold":"","dependentThresholdAdult":"","dependentThresholdChild":"","preferedHospitalProvider":"Any hospital","overallLimit":"Unlimited","coPayment":"Co-payment:\\nR1 000 Endoscopic procedures, Functional Nasal surgery\\nR2 000 Arthroscopic procedures, Laparoscopies procedures, - Wisdom Teeth\\nR3 000 Hernia repair (except in infants)\\nR4 000 Back and Neck surgery\\nR5 000 Nissen Fundoplication, Hysterectomy \\n20% penalty, in addition to co-payments if authorisation was not obtained \\n(No In-Hospital Endoscopic procedural co-payment applicable for children 8 years and younger) \\n ","rate":"200% of Scheme Rate","generalMedicin":"Limited to R790 per admission","specialist":"Unlimited\\nExtended Benefit Cover (up to 200%)","dentistSurgical":"According to the Dental Managed Healthcare Programme\\nIn-hospital (only for beneficiaries under the age of 6 years old for extensive\\nBasic Dentistry).\\n\\nImpacted Teeth, Wisdom Teeth and Apicectomy: subject to Specialised Dentistry Limit of R18 370 (R2 000 co-pay when performed in hospital)\\nMaxillo-Facial and Oral Surgery\\nR19 780 per family, Extended benefit cover up to 200% - Non-elective surgery only          \\nFailure to obtain an authorisation prior to treatment, will result in a 20% penalty \\n\\n\\n                                         ","mentalHealth":"In and out of hospital:\\nR43 400 per family at a DSP \\nMax 3 days cover if admitted by a GP \\nRehabilitation for substance abuse:\\nSubject to Mental Health limit\\nLimited to 1 rehab programme pbpa\\n","radiology":"100% Scheme Rate, unlimited\\n1 Bone Densitometry scan p.b. p.a","pathology":"100% Scheme Rate, unlimited","maternityBenefit":"In hospital: Unlimited\\nDelivery by a registered Midwife: 200% Medshield Private rate\\nOut of hospital:\\n12 Antenatal consultations\\nAntenatal classes: R530 per family \\n4 postnatal midwife consultations\\n1 Amniocentesis test per pregnancy\\n2 x 2D scans\\nMedshield MOM : assist women\\non their journey to motherhood","dialysis":"Unlimited, subject to PMB and PMB level of care at DSP. 40% co-payment for use of non-DSP  ","cancer":"R524 100 per family, ICON Enhanced Protocols apply. Post active treatment covered for 36 months. 40% co-payment for use of non-DSP \\nFollowing sub-limits apply per annum:\\n- Integrated continuous care: 6 visits per family \\n- Specialised drugs limit: R211 870 per family\\n- Vitreoretinal Benefit: subject to Specialised Drugs Limit.  \\n- PET Scans: 1 per family \\n- Breast reconstruction: R89 200 per family \\n","transplant":"\\n100% negotiated fee  - unlimited \\n � Corneal Grafts and Transplant (International): R44 185 per beneficiary  \\n� Corneal Grafts and Transplant (Local):\\n   R18 940 per beneficiary  \\n\\n","mri":"In and out of hospital: \\nR23 460 per family, with 10% co-payment \\n","prosthesisInternal":"R50 500 per family, 20% co-payment for non-PMB Internal Prosthesis and Devices. Hips and knees: sub-limit of R33 660 per beneficiary\\n","prosthesisExternal":"External prosthesis: Combined with Internal prosthesis: No co-payments\\nAppliances: R14 940 per family per annum \\n","rehab":"\\nR93 630 per family per annum\\nTerminal care: R39 240 per family sub-limit. Treatment only available immediately following an event\\n","designatedServiceProvider":"Medshield Pharmacy Network","conditionsCovered":"CDL in PMB+ 44 conditions","formulary":"Yes","partialLimits":"44 Non-CDL conditions limited to:\\nBeneficiary: R15 630\\nFamily: R31 250\\n40% co-payment for use of non-formulary, non-Network Pharmacy\\n","preferredProvider":"Nominated GP","overallAnualLimit":"Day-to-day limit\\nM       : R12 150\\nM+1   : R17 050\\nM+2   : R18 940\\nM+3   : R20 830\\nM+4+  : R22 520","medicationOverCounter":"Subject to day-to-day limit\\nR250 per script, 1 script p.b per day","medicationPrescribed":"Subject to day-to-day limit","practitionersGeneral":"Subject to day-to-day limit\\nGP visits can be accessed in-person, telephonically or virtually - unlimited\\nGP Network: 2 per beneficiary paid from Risk benefits once day-to-day limits has been depleted\\nRegistered chronic beneficiaries extended GP consultations and visits: 2  per beneficiary at Network GP\\nSmartCare Benefits:\\nUnlimited pharmacy / private nurse consultations at DSP\\nNurse-led Videomed GP: 1 visit per family paid from Risk benefit, thereafter paid from Day-to-day limit\\n \\n\\n","specialistsCover":"\\nSubject to day-to-day limit and Specialist Network\\n","dentistryCover":"100% of negotiated fee\\nUnlimited, 20% penalty if authorisation was not obtained","dentistryCoverSpecial":"100% of negotiated fee\\nLimited to R18 370 per family, 20% penalty if authorisation was not obtained\\n ","optical":"Benefits subject to Risk benefits p.b every 24 months\\n1 test per beneficiary every 24 month cycle\\nSpectacles OR contact lenses subject to optical limit\\nFrames and/or lens enhancements: R1 105\\nReaders: R180 per beneficiary p.a.\\nRefractory surgery: R18 730 per family p.a","ambulance":"Netcare 911","international":"No details supplied","hospitalCoverAids":"Unlimited, Lifesense Disease Management registration required","artTtreatment":"40% co-payment for out of formulary PMB medication or use of non-DSP","preventative":"Wellness Benefits:\\nAdult Vaccination Including Travel Vaccinations  \\nBirth Control (limit of R190 per script)\\nBone Density\\nFlu Vaccination\\nHealth Risk Assessment (Pharmacy or Family Practitioner)\\nHPV Vaccination\\nMammogram\\nNational HIV Counselling Testing\\nPap Smear\\nPneumococcal Vaccination\\nPSA Screening\\nTB Test\\nChild Immunisations as per DoH\\nIntrauterine devices & alternatives: 1 per female beneficiary\\nMirena/Kyleena device: every 5 years\\nImplanon: every 3 years\\nNova T: every 2 years\\n","logo":"medshield.png"},{"company":"Medshield","name":"MediPlus prime","planType":"Traditional","coverLevel":"Mid","hospital":"Network","chronic":"Network","serviceType":"Network","familyIncome":"","mainContribution":"R3885","mainCompSavings":"R0.00","mainTotal":"R3885","dependendContributionAdult":"R2772","dependentCompSavingsAdult":"R0.00","dependentTotalAdult":"R2772","dependendContributionChild":"R873","dependentCompSavingsChild":"R0.00","dependentTotalChild":"R873","maxChildContribution":"3","mainThreshold":"","dependentThresholdAdult":"","dependentThresholdChild":"","preferedHospitalProvider":"Prime Hospital Network","overallLimit":"Unlimited","coPayment":"25% co-payment for use of non-network hospital\\nCo-payments:\\nR1 500 Endoscopic procedures, Functional Nasal surgery\\nR3 000 Hernia repair (except in infants)\\nR3 500 Arthroscopic procedures, Laparoscopies procedures\\nR5 000 Nissen Fundoplication, Hysterectomy \\nR7 000 Back and Neck surgery\\n20% penalty, in addition to above co-payments if authorisation was not obtained\\n(No In-Hospital Endoscopic procedural co-payment applicable for children 8 years and younger)  \\n ","rate":"100% of Scheme Rate","generalMedicin":"Limited to R580 per admission","specialist":"100% of Scheme Rate, unlimited","dentistSurgical":"\\nAccording to the Dental Managed Healthcare Programme\\n\\nImpacted Teeth, Wisdom Teeth and Apicectomy: subject to Specialised Dentistry Limit of R13 150 per family (R3 500 co-pay when performed in hospital)    \\nMaxillo-Facial and Oral Surgery:\\nR16 940 per family - Non-elective surgery only\\nSubject to pre-authorisation and services obtained from a DSP\\n\\n                                          ","mentalHealth":"In and out of hospital:\\nR32 820 per family, 25% co-payment for use of non-DSP Facility\\nMax 3 days cover if admitted by a GP \\nRehabilitation for substance abuse: \\nSubject to Mental Health limit\\nLimited to 1 rehab programme pbpa\\n\\n","radiology":"100% Scheme Rate, unlimited","pathology":"100% Scheme Rate, unlimited","maternityBenefit":"In hospital: Unlimited\\nDelivery by a registered Midwife: 200% Medshield Private rate\\nOut of hospital:\\n12 Antenatal consultations\\nAntenatal classes: R530 per family \\n4 postnatal midwife consultations\\n1 Amniocentesis test per pregnancy\\n2 x 2D scans\\nMedshield MOM : assist women\\non their journey to motherhood","dialysis":"R195 150 per family at DSP \\n40% co-payment for use of non-DSP  ","cancer":"R267 630 per family, ICON Standard Protocols apply. Post active treatment covered for 36 months. 40% co-payment for use of non-DSP \\nFollowing sub-limits apply per annum:\\n- Integrated continuous care: 6 visits per family\\n- Specialised drugs limit: R123 820 per fam, 15% upfront-co-pay for non-PMB \\n- Vitreoretinal Benefit: subject to Specialised Drugs Limit.  \\n- PET Scans: 1 per family, 10% co-payment for non-PMB \\n- Breast reconstruction: R89 200 per family","transplant":"\\n100% negotiated fee                                          \\nR156 120 per family at DSP Network\\n25% co-payment for non-DSP hospital \\nClinical Protocols apply\\n� Corneal Grafts and Transplant (International): R44 185 per beneficiary  \\n� Corneal Grafts and Transplant (Local): \\n   R18 940 per beneficiary  \\n","mri":"In and out of hospital: \\nR13 415 per family, with 10% co-payment \\n","prosthesisInternal":"R38 500 per family, 20% co-payment for non-PMB. Hips and knees: sub-limit of R33 660 p.b. Subject to pre-authorisation and services obtained from a DSP\\n","prosthesisExternal":"External prosthesis: Combined with Internal prosthesis: No co-payments\\nAppliances: R9 785 per family per annum \\n","rehab":"R66 750 per family at DSP\\nTerminal care: R39 000 per family sub-limit. Treatment only available immediately following an event","designatedServiceProvider":"Medshield Pharmacy Network","conditionsCovered":"CDL in PMB +14 conditions","formulary":"Yes","partialLimits":"14 Non-CDL conditions limited to:\\nBeneficiary: R7 075\\nFamily: R14 150 \\n40% co-payment for use of non-formulary, non-Network Pharmacy\\n \\n","preferredProvider":"Nominated GP","overallAnualLimit":"Day-to-day limit\\nM       : R8 890\\nM+1  : R12 415\\nM+2  : R13 890\\nM+3  : R15 625\\nM+4+ : R17 150","medicationOverCounter":"Subject to day-to-day limit\\nR250 per script, 1 script p.b per day","medicationPrescribed":"Subject to day-to-day limit","practitionersGeneral":"Subject to day-to-day limit\\nGP visits can be accessed in-person, telephonically or virtually  \\nNominated GP: unlimited\\nMax of 2 nominated GP per beneficiary\\nOnce day-to-day limits has been depleted, 2 additional visits per beneficiary from Risk\\nNon-nominated GP: 2 visits per beneficiary, (subject to day-to-day limit) \\nRegistered chronic beneficiaries extended GP consultations and visits: 2  per beneficiary at Network GP, once Day-to-day limits has been depleted\\nSmartCare Benefits:\\nUnlimited pharmacy / private nurse consultations at DSP\\nNurse-led Videomed GP: 1 visit per family paid from Risk, thereafter paid from Day-to-day limit\\n\\n","specialistsCover":"2 visit per family paid from Risk benefit, thereafter paid from Day-to-day limit\\n","dentistryCover":"Unlimited. DENIS protocols apply","dentistryCoverSpecial":"\\nR13 150 per family, for wisdom teeth, apicectomy, dental implants, crowns, bridges, dentures etc. Pre-auth required DENIS protocols apply\\n ","optical":"1 test per beneficiary every 24 month cycle\\nReaders: R180 per beneficiary per annum\\nSpectacles OR contact lenses subject to OAL.\\nFrame and/or lens enhancements: R610 \\nBenefit paid from Risk","ambulance":"Netcare 911","international":"No details supplied","hospitalCoverAids":"Unlimited, Lifesense Disease Management registration required","artTtreatment":"40% co-payment for out of formulary PMB medication or use of non-DSP","preventative":"Wellness Benefits:\\nAdult Vaccination Including Travel Vaccinations  \\nBirth Control (limit of R190 per script)\\nBone Density\\nFlu Vaccination\\nHealth Risk Assessment (Pharmacy or Family Practitioner)\\nHPV Vaccination\\nMammogram\\nNational HIV Counselling Testing\\nPap Smear\\nPneumococcal Vaccination\\nPSA Screening\\nTB Test\\nChild Immunisations as per DoH\\nIntrauterine devices & alternatives: 1 per female beneficiary\\nMirena/Kyleena device: every 5 years\\nImplanon: every 3 years\\nNova T: every 2 years\\n","logo":"medshield.png"},{"company":"Medshield","name":"MediPlus compact","planType":"Traditional","coverLevel":"Mid","hospital":"Network","chronic":"Network","serviceType":"Network","familyIncome":"","mainContribution":"R3531","mainCompSavings":"R0.00","mainTotal":"R3531","dependendContributionAdult":"R2520","dependentCompSavingsAdult":"R0.00","dependentTotalAdult":"R2520","dependendContributionChild":"R792","dependentCompSavingsChild":"R0.00","dependentTotalChild":"R792","maxChildContribution":"3","mainThreshold":"","dependentThresholdAdult":"","dependentThresholdChild":"","preferedHospitalProvider":"Compact Hospital Network","overallLimit":"Unlimited","coPayment":"25% co-payment for use of non-network hospital\\nCo-payments:\\nR1 500 Endoscopic procedures, Functional Nasal surgery\\nR3 000 Hernia repair (except in infants)\\nR3 500 Arthroscopic procedures, Laparoscopies procedures\\nR5 000 Nissen Fundoplication, Hysterectomy \\nR7 000 Back and Neck surgery\\n20% penalty, in addition to above co-payments if authorisation was not obtained\\n(No In-Hospital Endoscopic procedural co-payment applicable for children 8 years and younger)  \\n ","rate":"100% of Scheme Rate","generalMedicin":"Limited to R580 per admission","specialist":"100% of Scheme Rate, unlimited","dentistSurgical":"\\nAccording to the Dental Managed Healthcare Programme\\n\\nImpacted Teeth, Wisdom Teeth and Apicectomy: subject to Specialised Dentistry Limit of R13 150 per family (R3 500 co-pay when performed in hospital)    \\nMaxillo-Facial and Oral Surgery:\\nR16 940 per family - Non-elective surgery only\\nSubject to pre-authorisation and services obtained from a DSP\\n\\n                                          ","mentalHealth":"In and out of hospital:\\nR32 820 per family, 25% co-payment for use of non-DSP Facility\\nMax 3 days cover if admitted by a GP \\nRehabilitation for substance abuse: \\nSubject to Mental Health limit\\nLimited to 1 rehab programme pbpa\\n\\n","radiology":"100% Scheme Rate, unlimited","pathology":"100% Scheme Rate, unlimited","maternityBenefit":"In hospital: Unlimited\\nDelivery by a registered Midwife: 200% Medshield Private rate\\nOut of hospital:\\n12 Antenatal consultations\\nAntenatal classes: R530 per family \\n4 postnatal midwife consultations\\n1 Amniocentesis test per pregnancy\\n2 x 2D scans\\nMedshield MOM : assist women\\non their journey to motherhood","dialysis":"R195 150 per family at DSP \\n40% co-payment for use of non-DSP  ","cancer":"R267 630 per family, ICON Standard Protocols apply. Post active treatment covered for 36 months. 40% co-payment for use of non-DSP \\nFollowing sub-limits apply per annum:\\n- Integrated continuous care: 6 visits per family \\n- Specialised drugs limit: R123 820 per fam, 15% upfront-co-pay for non-PMB \\n- Vitreoretinal Benefit: subject to Specialised Drugs Limit.  \\n- PET Scans: 1 per family, 10% co-payment for non-PMB \\n- Breast reconstruction: R89 200 per family","transplant":"\\n100% negotiated fee                                          \\nR156 120 per family at DSP Network\\n25% co-payment for non-DSP hospital \\nClinical Protocols apply\\n� Corneal Grafts and Transplant (International): R44 185 per beneficiary  \\n� Corneal Grafts and Transplant (Local): \\n   R18 940 per beneficiary  \\n","mri":"In and out of hospital: \\nR13 415 per family, with 10% co-payment \\n","prosthesisInternal":"R38 500 per family, 20% co-payment for non-PMB. Hips and knees: sub-limit of R33 660 p.b. Subject to pre-authorisation and services obtained from a DSP\\n","prosthesisExternal":"External prosthesis: Combined with Internal prosthesis: No co-payments\\nAppliances: R9 785 per family per annum \\n","rehab":"R66 750 per family at DSP\\nTerminal care: R39 000 per family sub-limit. Treatment only available immediately following an event","designatedServiceProvider":"Medshield Pharmacy Network","conditionsCovered":"CDL in PMB +14 conditions","formulary":"Yes","partialLimits":"14 Non-CDL conditions limited to:\\nBeneficiary: R7 075\\nFamily: R14 150 \\n40% co-payment for use of non-formulary, non-Network Pharmacy\\n \\n","preferredProvider":"Nominated GP","overallAnualLimit":"Day-to-day limit\\nM       : R8 890\\nM+1  : R12 415\\nM+2  : R13 890\\nM+3  : R15 625\\nM+4+ : R17 150","medicationOverCounter":"Subject to day-to-day limit\\nR250 per script, 1 script p.b per day","medicationPrescribed":"Subject to day-to-day limit","practitionersGeneral":"Subject to day-to-day limit\\nGP visits can be accessed in-person, telephonically or virtually \\nNominated GP: unlimited\\nMax of 2 nominated GP per beneficiary\\nOnce day-to-day limits has been depleted, 2 additional visits per beneficiary from Risk\\nNon-nominated GP: 2 visits per family (subject to day-to-day limit), thereafter 40% co-pay applies\\nRegistered chronic beneficiaries extended GP consultations and visits: 2  per beneficiary at Network  Day-to-day limits has been depleted\\nSmartCare Benefits:\\nUnlimited pharmacy / private nurse consultations at DSP\\nNurse-led Videomed GP: 1 visit per family paid from Risk, thereafter paid from Day-to-day limit\\n\\n","specialistsCover":"2 visits per family paid from Risk, thereafter subject to day-to-day Limit and Network GP referral. 40% Co-payment applies for no referral\\n","dentistryCover":"Unlimited. DENIS protocols apply","dentistryCoverSpecial":"\\nR13 150 per family, for wisdom teeth, apicectomy, dental implants, crowns, bridges, dentures etc. Pre-auth required DENIS protocols apply\\n ","optical":"Preferred Provider: Compact Optical Network.\\n1 test per beneficiary every 24 month cycle\\nReaders: R180 per beneficiary per annum\\nSpectacles OR contact lenses subject to OAL.\\nFrame and/or lens enhancements: R610 \\nBenefit paid from Risk","ambulance":"Netcare 911","international":"No details supplied","hospitalCoverAids":"Unlimited, Lifesense Disease Management registration required","artTtreatment":"40% co-payment for out of formulary PMB medication or use of non-DSP","preventative":"Wellness Benefits:\\nAdult Vaccination Including Travel Vaccinations  \\nBirth Control (limit of R190 per script)\\nBone Density\\nFlu Vaccination\\nHealth Risk Assessment (Pharmacy or Family Practitioner)\\nHPV Vaccination\\nMammogram\\nNational HIV Counselling Testing\\nPap Smear\\nPneumococcal Vaccination\\nPSA Screening\\nTB Test\\nChild Immunisations as per DoH\\nIntrauterine devices & alternatives: 1 per female beneficiary\\nMirena/Kyleena device: every 5 years\\nImplanon: every 3 years\\nNova T: every 2 years\\n","logo":"medshield.png"},{"company":"Medshield","name":"MediSaver","planType":"New generation ","coverLevel":"Mid","hospital":"Network","chronic":"Network","serviceType":"Network","familyIncome":"","mainContribution":"R3310","mainCompSavings":"R584","mainTotal":"R3894","dependendContributionAdult":"R2741","dependentCompSavingsAdult":"R484","dependentTotalAdult":"R3225","dependendContributionChild":"R806","dependentCompSavingsChild":"R142","dependentTotalChild":"R948","maxChildContribution":"3","mainThreshold":"","dependentThresholdAdult":"","dependentThresholdChild":"","preferedHospitalProvider":"Compact Hospital Network","overallLimit":"Unlimited","coPayment":"25% co-payment for use of non-network hospital\\nCo-payments: \\nR1 500 on Endoscopic procedures\\nR3 000 Hernia repair (except in infants)\\nR3 500 Arthroscopic procedures, Laparoscopies procedures \\nR5 000 Nissen Fundoplication, Functional Nasal surgery, Hysterectomy \\nR7 000 Back and Neck surgery\\n20% penalty, in addition to co-payments if authorisation was not obtained \\n(No In-Hospital Endoscopic procedural co-payment applicable for children 8 years and younger)  \\n ","rate":"100% of Scheme Rate","generalMedicin":"Limited to R685 per admission","specialist":"100% of Scheme Rate, unlimited","dentistSurgical":"\\n\\n\\n\\nAccording to the Dental Managed Healthcare Programme\\n\\nImpacted Teeth, Wisdom Teeth and Apicectomy: subject to Specialised Dentistry Limit of R13 150 per family (R3 500 co-pay when performed in hospital)\\nMaxillo-Facial and Oral Surgery:\\nR19 780 per family - Non-elective surgery only\\nSubject to pre-authorisation and services obtained form a DSP\\n\\n\\n  \\n\\n          \\n","mentalHealth":"In and out of hospital:\\nR43 870 per family, 25% co-payment for use of non-DSP Facility\\nMax of 3 days cover if admitted by a GP \\nSub-limit of R15 780 for rehabilitation \\nLimited to 1 rehab programme pbpa\\n\\n","radiology":"100% Scheme Rate, unlimited","pathology":"100% Scheme Rate, unlimited","maternityBenefit":"In hospital: Unlimited\\nDelivery by a registered Midwife: 200% Medshield Private rate\\nOut of hospital:\\n12 Antenatal consultations\\nAntenatal classes: R530 per family \\n4 postnatal midwife consultations\\n1 Amniocentesis test per pregnancy\\n2 x 2D scans\\nMedshield MOM : assist women\\non their journey to motherhood","dialysis":"R279 000 per family at DSP \\n40% co-payment for use of non-DSP  ","cancer":"\\nR351 265 per family\\nICON Standard Protocols apply \\nPost active treatment covered for 36 months. 40% co-payment for use of non-DSP\\nFollowing sub-limits apply per annum:\\n- Oncology Medicine: R234 175 per family\\n- Specialised drugs for oncology, non-Oncology and Biological drugs: subject to Oncology medicine limit. 20% co-payment for non-PMB \\n- Integrated continuous care: 6 visits per family per annum\\n- Vitreoretinal Benefit, subject to Oncology Medicine limit\\n- PET Scans: R22 300 per family per annum, 10% co-payment for non-PMB. Limited to 1 scan per beneficiary \\n- Breast reconstruction: R89 200 per family per annum            \\n","transplant":"\\n100% negotiated fee \\nR279 000 per family at DSP Network\\n25% co-payment for non-DSP hospital \\nClinical Protocols apply\\n� Corneal Grafts and Transplant (International): R44 185 per beneficiary  \\n� Corneal Grafts and Transplant (Local):\\n  R18 940 per beneficiary  \\n","mri":"In and out of hospital: \\nR20 780 per family, with 10% co-payment for non-PMB\\n","prosthesisInternal":"R46 500 per family, 25% co-payment for non-PMB. Hips and knees: sub-limit of R33 660 p.b. Subject to pre-authorisation and services obtained from a DSP","prosthesisExternal":"External prosthesis: Combined with Internal prosthesis: No co-payments\\nAppliances: R10 500 per family per annum \\n","rehab":"R70 275 per family at DSP\\nTerminal care: R39 000 per family sub-limit. Treatment only available immediately following an event","designatedServiceProvider":"Medshield Pharmacy Network","conditionsCovered":"CDL in PMB","formulary":"Yes","partialLimits":"40% co-payment for use of non-formulary, non-Network Pharmacy","preferredProvider":"None","overallAnualLimit":"N/A","medicationOverCounter":"Subject to Savings, R250 per script, 1 script p.b per day","medicationPrescribed":"Subject to Savings","practitionersGeneral":"GP visits can be accessed in-person, telephonically or virtually \\nSubject to Savings. Once depleted, 2 GP visits per beneficiary from Risk\\n\\nRegistered chronic beneficiaries extended GP consultations and visits: 2  per beneficiary at Network  Savings is depleted. Subject to registering on the relevant DMP.\\n\\nSmartCare Benefits:\\nUnlimited out of hospital private nurse consultations at DSP\\nNurse-led Videomed GP: 1 visit paid from Risk then subject to available Savings\\n\\n\\n","specialistsCover":"Subject to Savings\\nSmartCare Benefits:\\nMedical specialist telephonic and video consultations ","dentistryCover":"Subject to Savings","dentistryCoverSpecial":"Subject to Savings\\nR13 150 per family, for wisdom teeth, apicectomy, dental implants. Pre-auth required. DENIS protocols apply","optical":"Subject to Savings\\n1 test per beneficiary every 24 month cycle\\nReaders: R180 per beneficiary per annum\\n\\n","ambulance":"Netcare 911","international":"No details supplied","hospitalCoverAids":"Unlimited, Lifesense Disease Management registration required","artTtreatment":"40% co-payment for out of formulary PMB medication or use of non-DSP","preventative":"Wellness Benefits:\\nAdult Vaccination Including Travel Vaccinations  \\nBirth Control (limit of R190 per script)\\nBone Density\\nFlu Vaccination\\nHealth Risk Assessment (Pharmacy or Family Practitioner)\\nHPV Vaccination\\nMammogram\\nNational HIV Counselling Testing\\nPap Smear\\nPneumococcal Vaccination\\nPSA Screening\\nTB Test\\nChild Immunisations as per DoH\\nIntrauterine devices & alternatives: 1 per female beneficiary\\nMirena/Kyleena device: every 5 years\\nImplanon: every 3 years\\nNova T: every 2 years\\n","logo":"medshield.png"},{"company":"Medshield","name":"MediPhila","planType":"Capitation","coverLevel":"Low","hospital":"Network","chronic":"Network","serviceType":"Network","familyIncome":"","mainContribution":"R1593","mainCompSavings":"R0.00","mainTotal":"R1593","dependendContributionAdult":"R1593","dependentCompSavingsAdult":"R0.00","dependentTotalAdult":"R1593","dependendContributionChild":"R411","dependentCompSavingsChild":"R0.00","dependentTotalChild":"R411","maxChildContribution":"","mainThreshold":"","dependentThresholdAdult":"","dependentThresholdChild":"","preferedHospitalProvider":"MediPhila Hospital Network","overallLimit":"R1 000 000 per family","coPayment":"25% co-payment for use of non-network hospital\\nR5 000 co-payment - hysterectomy\\n20% penalty, in addition to above co-payments if authorisation was not obtain (except for emergency)","rate":"100% of negotiated tariff","generalMedicin":"Limited to R210 per admission","specialist":"Subject to Overall Annual Limit\\n100% Negotiated fee","dentistSurgical":"Maxillo-facial and Oral Surgery: PMBs only\\nImpacted Teeth, Wisdom Teeth and Apicectomy: subject to Specialised Dentistry Limit of R6 200 per family per annum (R4 000 co-pay when performed in hospital)\\n ","mentalHealth":"\\nSubject to PMB and PMB level of care at DSP, 40% co-payment for use of non-DSP facility\\nMax 3 days cover if admitted by a GP \\nRehabilitation for substance abuse: \\nSubject to PMB and PMB level of care\\nLimited to 1 rehab programme pbpa\\n","radiology":"Subject to Overall Annual Limit and protocols ","pathology":"Subject to Overall Annual Limit and protocols ","maternityBenefit":"In hospital Unlimited\\nOut of hospital: \\nDelivery by a registered Midwife or a Practitioner - Applies to a registered Midwife only\\n6 antenatal consultations\\n4 postnatal midwife consultations\\n2 x 2D scans \\nMedshield MOM : assist women\\non their journey to motherhood","dialysis":"Unlimited, subject to PMBs and PMB level of care 40% co-payment for use of non-DSP   ","cancer":"\\nUnlimited subject to PMB and PMB level of care ICON standard protocols apply\\nPost active treatment for 36 months                                (40% co-payment for use of non-DSP)     \\n\\nPET Scans: 1 scan per family\\nIntegrated continuous care:\\n4 visits per family per annum\\nVitreoretinal Benefit: R20 000 per family\\n\\n                          \\n","transplant":"Unlimited, subject to PMBs and PMB level of care 25% upfront co-payment for use of non-Network hospital\\n � Corneal Grafts and Transplant (International): R44 185 per beneficiary  \\n� Corneal Grafts and Transplant (Local):\\n   R18 940 per beneficiary  ","mri":"In and out of hospital: \\nR7 050 per family, with 10% co-payment for non-PMB\\nSubject to pre-authorisation, DSP or Network\\n","prosthesisInternal":"Limited to PMB and PMB level of care and network. Hips and knees: Sub-limit of R33 660 per beneficiary- subject to PMB and PMB level of care","prosthesisExternal":"Limited to PMB and PMB level of care","rehab":"\\nUnlimited, subject to PMB and PMB level of care\\nTerminal Care: R13 000 per family\\nTreatment only available immediately following an event","designatedServiceProvider":"MediPhila Pharmacy Network Provider","conditionsCovered":"CDL in PMB","formulary":"Yes, basic","partialLimits":"40% co-payment for use of non-formulary, non-Network Pharmacy","preferredProvider":"Medi Phila Network","overallAnualLimit":"R3 400 per family per annum","medicationOverCounter":"Subject to Acute Medications limit\\nR90 per script, 1 script p.beneficiary per day","medicationPrescribed":"R1 480 per family, subject to day-to-day limit\\nSubject to Pharmacy Network and formulary","practitionersGeneral":"Limited to:\\nM: 8 visits\\nM+1: 9 visits\\nM2+: 11 visits\\nThereafter unlimited - subject to pre-auth\\nOut-of-Network: 2 visits per family, thereafter a 40% co-payment apply \\nSubject to GP Network Limit\\nRegistered chronic beneficiaries extended GP consultations and visits: 2  per beneficiary from risk, once allocated GP visits have been depleted\\nSmartCare Benefits:\\nUnlimited out of hospital private nurse consultations at DSP\\nNurse-led Videomed FP: 1 visit per family paid from Risk benefit, thereafter paid from GP limit\\n","specialistsCover":"1 visits per family, thereafter subject to day-to-day limit and Network GP referral\\nNo referral will result in a 40% co-payment","dentistryCover":"\\nR1 525 per family,\\nsubject to Specialised Dentistry limit \\n","dentistryCoverSpecial":"R6 200 per family per annum\\nIncluded in hospital limit","optical":"R850 per beneficiary every two years at DSP \\nThe following sub-limits apply:\\n1 eye test per beneficiary, 1 pair lenses and a frame. Readers: R180 per beneficiary p.a.","ambulance":"Netcare 911","international":"No benefit","hospitalCoverAids":"Unlimited, Lifesense Disease Management registration required","artTtreatment":"40% upfront co-pay for out of formulary and use of non-DSP","preventative":"Wellness Benefits:\\nBirth Control (limit of R125 per script)\\nFlu Vaccination\\nHealth Risk Assessment (Pharmacy or Family Practitioner)\\nHPV Vaccination\\nNational HIV Counselling Testing\\nPap Smear\\nPSA Screening\\nTB Test\\nChild Immunisations as per DoH\\nIntrauterine devices & alternatives: 1 per female beneficiary\\nMirena/Kyleena device: every 5 years\\nImplanon: every 3 years\\nNova T: every 2 years\\n\\n","logo":"medshield.png"},{"company":"Momentum","name":"Extender Option: Associated hospitals | State chronic  ","planType":"Threshold option","coverLevel":"High","hospital":"Network","chronic":"State","serviceType":"Any","familyIncome":"","mainContribution":"R3923","mainCompSavings":"R1308","mainTotal":"R5231","dependendContributionAdult":"R2975","dependentCompSavingsAdult":"R992","dependentTotalAdult":"R3967","dependendContributionChild":"R1153","dependentCompSavingsChild":"R384","dependentTotalChild":"R1537","maxChildContribution":"3","mainThreshold":"","dependentThresholdAdult":"","dependentThresholdChild":"","preferedHospitalProvider":"Associated hospitals","overallLimit":"Unlimited","coPayment":"30% co-payment for use of non-network hospital\\n\\nSpecialised procedures in-hospital:\\nR3 280 co-payment applies\\nSpecialised procedures in day-hospital:\\nR1 640 co-payment applies\\nSpecialised procedures done out-of-hospital: paid by Scheme, no co-payment applies\\nCertain specialised procedures done out-of-hospital- paid from available day-to-day benefits, no co-payment applies\\n\\nRefer to brochure for details\\n","rate":"200% Scheme Rate","generalMedicin":"7 days' supply per event","specialist":"Full cover for Associated specialists\\nSpecialists and GPs: 200% Scheme Rate\\n","dentistSurgical":"Maxillo-facial surgery (excluding implants) and general anaesthesia for children under 7, subject to R1 500 co-payment per authorisation \\n\\nDental and dental specialist bills paid from day-to-day benefits and accumulate towards limit\\n\\nImpacted wisdom teeth :\\nR3 000 co-payment for day hospitals and\\nR5 500 co-payment for other hospitals, per authorisation. Dental, dental specialist and maxillo-facial surgeon accounts paid up to 100% of Scheme Rate","mentalHealth":"Including psychiatry and psychology, drug and alcohol rehabilitation: R41 100 per beneficiary \\n21- day sublimit for alcohol and drug rehab Subject to treatment at preferred provider","radiology":"100% Scheme Rate, unlimited","pathology":"100% Scheme Rate, unlimited","maternityBenefit":"In hospital: Unlimited\\nOut of hospital:�(Subject to registration on maternity programme)\\n12 Antenatal visits\\n2 Paediatric visit in baby�s first year\\nOnline antenatal and postnatal classes \\nOnline video consult with lactation specialist\\nList of blood tests \\nDoula benefit: 2 visits per pregnancy \\n1 Nurse home visit day after discharge from hospital, plus 2 weeks and 6 weeks after initial visit\\n2 scans. 3D/4D scans are covered at 2D scan price ","dialysis":"Unlimited - subject to management programme. Treatment must be obtained from State facilities","cancer":"R500 000 per beneficiary, with a 20% co-payment thereafter, subject to management programme from an oncologist authorised by the Scheme","transplant":"Recipient - unlimited\\nDonor - R23 300 for cadaver costs and \\nR47 100 for live donor costs (incl. transportation)","mri":"In and out of hospital: Unlimited\\nR2 480 co-payment applies ","prosthesisInternal":"Cochlear implants: R198 000 per beneficiary \\nIntraocular lenses: R7 750 per beneficiary per event, max 2 events per year\\nOther internal prostheses: R74 900 per beneficiary per event, max 2 events per year","prosthesisExternal":"\\nExternal prosthesis: R26 000 per family per year \\nAppliances \\n- In Hospital R7 500 family limit per year\\n- Out-of-Hospital R 26 500 \\n- Hearing Aid Sub-limit R8 000 per family\\n(subject to day-to-day benefits)","rehab":"R60 000 per family per year \\n","designatedServiceProvider":"State","conditionsCovered":"62 conditions including PMBs","formulary":"State","partialLimits":"Unlimited for CDL conditions -\\nadditional 36 conditions - R11 100 per family","preferredProvider":"None","overallAnualLimit":"None","medicationOverCounter":"100% of cost\\nSubject to available Savings\\n(Does not accumulate to Threshold) ","medicationPrescribed":"Subject to available Savings and Threshold\\nExtended Cover limit of R18 900 per beneficiary, R35 800 per family ","practitionersGeneral":"Non-Associated GP, 70% of Scheme Rate \\nSubject to Savings, if available. Unlimited once Threshold is reached\\n\\nVirtual GP support:\\nMembers have free, unlimited access to doctors via Hello Doctor, on their phone, anytime, anywhere, in any official South African language, within an hour. Members can speak to the doctor over the phone or chat via text message. They can also get free daily advice with Hello Doctor�s Health Tips and health coaching. Hello Doctor can now prescribe medicine and issue sick notes, where appropriate. Prescribed medicine is covered from HealthSaver, if available.","specialistsCover":"Subject to Savings, if available. Unlimited once Threshold is reached\\n100% of Scheme Rate","dentistryCover":"Subject to Savings, if available. Unlimited once Threshold is reached","dentistryCoverSpecial":"Subject to available Savings and Threshold\\nExtended cover limit of R14 600 per beneficiary, R38 100 per family. Both in and out of hospital dental specialist accounts accumulate towards the limit, except for impacted wisdom teeth\\n\\nExtraction of impacted wisdom teeth in Dr's rooms: Dental specialist accounts - paid from Risk benefit at 100% of  Scheme Rate, subject to R1 500 co-payment and pre-authorisation\\n ","optical":"Subject to available Savings and Threshold\\nExtended cover limit of R4 500 per beneficiary, sub-limit of R2 450 for frames \\n","ambulance":"National: Netcare 911  \\nInternational: ISOS","international":"R8.22 million emergency cover per 90 day journey incl.  R15 500 cover for emergency optometry and dentistry. R765 000 terrorism cover. R1 850 co-payment per claim","hospitalCoverAids":"HIV related admissions: R78 600 per family","artTtreatment":"Unlimited, at chosen network provider","preventative":"Health Platform benefits\\n\\nEarly detection \\n- Health assessment\\n- Dental check-up\\n- Mammograms\\n- Pap smear consultation and test\\n- Prostate test\\n- General physical examination\\n- DEXA scan\\n- Glaucoma test\\n- Pathology tests: HIV, cholesterol and blood sugar\\n\\nPreventative care\\n- Flu vaccinations\\n- Baby immunisations\\n- Tetanus diphtheria injection\\n- Pneumococcal vaccine\\n\\nHealth management programmes \\n- Diabetes, Hypertension, HIV/Aids,\\nOncology, Drug and alcohol rehabilitation, Chronic renal failure,\\nOrgan transplants, Cholesterol  \\n\\nHealth education and advice\\n \\n(Refer to member guide for full details)","logo":"momentumMed.png"},{"company":"Momentum","name":"Extender Option: Associated hospitals | Associated  chronic  ","planType":"Threshold option","coverLevel":"High","hospital":"Network","chronic":"Network","serviceType":"Any","familyIncome":"","mainContribution":"R4477","mainCompSavings":"R1492","mainTotal":"R5969","dependendContributionAdult":"R3604","dependentCompSavingsAdult":"R1201","dependentTotalAdult":"R4805","dependendContributionChild":"R1288","dependentCompSavingsChild":"R429","dependentTotalChild":"R1717","maxChildContribution":"3","mainThreshold":"","dependentThresholdAdult":"","dependentThresholdChild":"","preferedHospitalProvider":"Associated hospitals","overallLimit":"Unlimited","coPayment":"30% co-payment for use of non-network hospital\\n\\nSpecialised procedures in-hospital:\\nR3 280 co-payment applies\\nSpecialised procedures in day-hospital:\\nR1 640 co-payment applies\\nSpecialised procedures done out-of-hospital: paid by Scheme, no co-payment applies\\nCertain specialised procedures done out-of-hospital- paid from available day-to-day benefits, no co-payment applies\\n\\nRefer to brochure for details\\n","rate":"200% Scheme Rate","generalMedicin":"7 days' supply per event","specialist":"Full cover for Associated specialists\\nSpecialists and GPs: 200% Scheme Rate\\n","dentistSurgical":"Maxillo-facial surgery (excluding implants),  anaesthetic for children under 7 years, subject to R1 500 co-payment per authorisation \\n\\nDental and dental specialist bills paid from day-to-day benefits and accumulate towards limit\\n\\nImpacted wisdom teeth :\\nR3 000 co-payment for day hospitals and\\nR5 500 co-payment for other hospitals, per authorisation. Dental, dental specialist and maxillo-facial surgeon accounts paid up to 100% of Scheme Rate","mentalHealth":"Including psychiatry and psychology, drug and alcohol rehabilitation: R41 100 per beneficiary \\n21- day sublimit for alcohol and drug rehab Subject to treatment at preferred provider","radiology":"100% Scheme Rate, unlimited","pathology":"100% Scheme Rate, unlimited","maternityBenefit":"In hospital: Unlimited\\nOut of hospital:�(Subject to registration on maternity programme)\\n12 Antenatal visits\\n2 Paediatric visit in baby�s first year\\nOnline antenatal and postnatal classes \\nOnline video consult with lactation specialist\\nList of blood tests \\nDoula benefit: 2 visits per pregnancy \\n1 Nurse home visit day after discharge from hospital, plus 2 weeks and 6 weeks after initial visit\\n2 scans. 3D/4D scans are covered at 2D scan price ","dialysis":"Unlimited, subject to management programme ","cancer":"R500 000 per beneficiary, with a 20% co-payment thereafter, subject to management programme","transplant":"Recipient - unlimited\\nDonor - R23 300 for cadaver costs and \\nR47 100 for live donor costs (incl. transportation)","mri":"In and out of hospital: Unlimited\\nR2 480 co-payment applies ","prosthesisInternal":"Cochlear implants: R198 000 per beneficiary \\nIntraocular lenses: R7 750 per beneficiary per event, max 2 events per year\\nOther internal prostheses: R74 900 per beneficiary per event, max 2 events per year","prosthesisExternal":"\\nExternal prosthesis: R26 000 per family per year \\nAppliances \\n- In Hospital R7 500 family limit per year\\n- Out-of-Hospital R 26 500 \\n- Hearing Aid Sub-limit R8 000 per family\\n(subject to day-to-day benefits)","rehab":"R60 000 per family per year \\n","designatedServiceProvider":"Associated GPs and Medipost courier pharmacy","conditionsCovered":"62 conditions including PMBs","formulary":"Entry level ","partialLimits":"Unlimited for CDL conditions -\\nadditional 36 conditions - R11 100 per family","preferredProvider":"Associated GP for GP benefits","overallAnualLimit":"None","medicationOverCounter":"100% of cost\\nSubject to available Savings\\n(Does not accumulate to Threshold) ","medicationPrescribed":"Subject to available Savings and Threshold\\nExtended Cover limit of R18 900 per beneficiary, R35 800 per family ","practitionersGeneral":"Non-Associated GP, 70% of Scheme Rate \\nSubject to Savings, if available. Unlimited once Threshold is reached\\n\\nVirtual GP support:\\nMembers have free, unlimited access to doctors via Hello Doctor, on their phone, anytime, anywhere, in any official South African language, within an hour. Members can speak to the doctor over the phone or chat via text message. They can also get free daily advice with Hello Doctor�s Health Tips and health coaching. Hello Doctor can now prescribe medicine and issue sick notes, where appropriate. Prescribed medicine is covered from HealthSaver, if available.","specialistsCover":"Subject to Savings, if available. Unlimited once Threshold is reached\\n100% of Scheme Rate","dentistryCover":"Subject to Savings, if available. Unlimited once Threshold is reached","dentistryCoverSpecial":"Subject to available Savings and Threshold\\nExtended cover limit of R14 600 per beneficiary, R38 100 per family. Both in and out of hospital dental specialist accounts accumulate towards the limit, except for impacted wisdom teeth\\n\\nExtraction of impacted wisdom teeth in Dr's rooms: Dental specialist accounts - paid from Risk benefit at 100% of  Scheme Rate, subject to R1 500 co-payment and pre-authorisation\\n ","optical":"Subject to available Savings and Threshold\\nExtended cover limit of R4 500 per beneficiary, sub-limit of R2 450 for frames \\n","ambulance":"National: Netcare 911  \\nInternational: ISOS","international":"R8.22 million emergency cover per 90 day journey incl.  R15 500 cover for emergency optometry and dentistry. R765 000 terrorism cover. R1 850 co-payment per claim","hospitalCoverAids":"HIV related admissions: R78 600 per family","artTtreatment":"Unlimited, at chosen network provider","preventative":"Health Platform benefits\\n\\nEarly detection \\n- Health assessment\\n- Dental check-up\\n- Mammograms\\n- Pap smear consultation and test\\n- Prostate test\\n- General physical examination\\n- DEXA scan\\n- Glaucoma test\\n- Pathology tests: HIV, cholesterol and blood sugar\\n\\nPreventative care\\n- Flu vaccinations\\n- Baby immunisations\\n- Tetanus diphtheria injection\\n- Pneumococcal vaccine\\n\\nHealth management programmes \\n- Diabetes, Hypertension, HIV/Aids,\\nOncology, Drug and alcohol rehabilitation, Chronic renal failure,\\nOrgan transplants, Cholesterol  \\n\\nHealth education and advice\\n \\n(Refer to member guide for full details)","logo":"momentumMed.png"},{"company":"Momentum","name":"Extender Option: Associated hospitals | Any chronic  ","planType":"Threshold option","coverLevel":"High","hospital":"Network","chronic":"Any","serviceType":"Any","familyIncome":"","mainContribution":"R4892","mainCompSavings":"R1631","mainTotal":"R6523","dependendContributionAdult":"R3941","dependentCompSavingsAdult":"R1314","dependentTotalAdult":"R5255","dependendContributionChild":"R1384","dependentCompSavingsChild":"R461","dependentTotalChild":"R1845","maxChildContribution":"3","mainThreshold":"","dependentThresholdAdult":"","dependentThresholdChild":"","preferedHospitalProvider":"Associated hospitals","overallLimit":"Unlimited","coPayment":"30% co-payment for use of non-network hospital\\n\\nSpecialised procedures in-hospital:\\nR3 280 co-payment applies\\nSpecialised procedures in day-hospital:\\nR1 640 co-payment applies\\nSpecialised procedures done out-of-hospital: paid by Scheme, no co-payment applies\\nCertain specialised procedures done out-of-hospital- paid from available day-to-day benefits, no co-payment applies\\n\\nRefer to brochure for details\\n","rate":"200% Scheme Rate","generalMedicin":"7 days' supply per event","specialist":"Full cover for Associated specialists\\nSpecialists and GPs: 200% Scheme Rate\\n","dentistSurgical":"Maxillo-facial surgery (excluding implants),  anaesthetic for children under 7 years, subject to R1 500 co-payment per authorisation \\n\\nDental and dental specialist bills paid from day-to-day benefits and accumulate towards limit\\n\\nImpacted wisdom teeth :\\nR3 000 co-payment for day hospitals and\\nR5 500 co-payment for other hospitals, per authorisation. Dental, dental specialist and maxillo-facial surgeon accounts paid up to 100% of Scheme Rate","mentalHealth":"Including psychiatry and psychology, drug and alcohol rehabilitation: R41 100 per beneficiary \\n21- day sublimit for alcohol and drug rehab Subject to treatment at preferred provider","radiology":"100% Scheme Rate, unlimited","pathology":"100% Scheme Rate, unlimited","maternityBenefit":"In hospital: Unlimited\\nOut of hospital:�(Subject to registration on maternity programme)\\n12 Antenatal visits\\n2 Paediatric visit in baby�s first year\\nOnline antenatal and postnatal classes \\nOnline video consult with lactation specialist\\nList of blood tests \\nDoula benefit: 2 visits per pregnancy \\n1 Nurse home visit day after discharge from hospital, plus 2 weeks and 6 weeks after initial visit\\n2 scans. 3D/4D scans are covered at 2D scan price ","dialysis":"Unlimited, subject to management programme ","cancer":"R500 000 per beneficiary, with a 20% co-payment thereafter, subject to management programme","transplant":"Recipient - unlimited\\nDonor - R23 300 for cadaver costs and \\nR47 100 for live donor costs (incl. transportation)","mri":"In and out of hospital: Unlimited\\nR2 480 co-payment applies ","prosthesisInternal":"Cochlear implants: R198 000 per beneficiary \\nIntraocular lenses: R7 750 per beneficiary per event, max 2 events per year\\nOther internal prostheses: R74 900 per beneficiary per event, max 2 events per year","prosthesisExternal":"\\nExternal prosthesis: R26 000 per family per year \\nAppliances \\n- In Hospital R7 500 family limit per year\\n- Out-of-Hospital R 26 500 \\n- Hearing Aid Sub-limit R8 000 per family\\n(subject to day-to-day benefits)","rehab":"R60 000 per family per year \\n","designatedServiceProvider":"Any GP and Any pharmacy","conditionsCovered":"62 conditions including PMBs","formulary":"Extended","partialLimits":"Unlimited for CDL conditions -\\nadditional 36 conditions - R11 100 per family","preferredProvider":"None","overallAnualLimit":"None","medicationOverCounter":"100% of cost\\nSubject to available Savings\\n(Does not accumulate to Threshold) ","medicationPrescribed":"Subject to available Savings and Threshold\\nExtended Cover limit of R18 900 per beneficiary, R35 800 per family ","practitionersGeneral":"Non-Associated GP, 70% of Scheme Rate \\nSubject to Savings, if available. Unlimited once Threshold is reached\\n\\nVirtual GP support:\\nMembers have free, unlimited access to doctors via Hello Doctor, on their phone, anytime, anywhere, in any official South African language, within an hour. Members can speak to the doctor over the phone or chat via text message. They can also get free daily advice with Hello Doctor�s Health Tips and health coaching. Hello Doctor can now prescribe medicine and issue sick notes, where appropriate. Prescribed medicine is covered from HealthSaver, if available.","specialistsCover":"Subject to Savings, if available. Unlimited once Threshold is reached\\n100% of Scheme Rate","dentistryCover":"Subject to Savings, if available. Unlimited once Threshold is reached","dentistryCoverSpecial":"Subject to available Savings and Threshold\\nExtended cover limit of R14 600 per beneficiary, R38 100 per family. Both in and out of hospital dental specialist accounts accumulate towards the limit, except for impacted wisdom teeth\\n\\nExtraction of impacted wisdom teeth in Dr's rooms: Dental specialist accounts - paid from Risk benefit at 100% of  Scheme Rate, subject to R1 500 co-payment and pre-authorisation\\n ","optical":"Subject to available Savings and Threshold\\nExtended cover limit of R4 500 per beneficiary, sub-limit of R2 450 for frames \\n","ambulance":"National: Netcare 911  \\nInternational: ISOS","international":"R8.22 million emergency cover per 90 day journey incl.  R15 500 cover for emergency optometry and dentistry. R765 000 terrorism cover. R1 850 co-payment per claim","hospitalCoverAids":"HIV related admissions: R78 600 per family","artTtreatment":"Unlimited, at chosen network provider","preventative":"Health Platform benefits\\n\\nEarly detection \\n- Health assessment\\n- Dental check-up\\n- Mammograms\\n- Pap smear consultation and test\\n- Prostate test\\n- General physical examination\\n- DEXA scan\\n- Glaucoma test\\n- Pathology tests: HIV, cholesterol and blood sugar\\n\\nPreventative care\\n- Flu vaccinations\\n- Baby immunisations\\n- Tetanus diphtheria injection\\n- Pneumococcal vaccine\\n\\nHealth management programmes \\n- Diabetes, Hypertension, HIV/Aids,\\nOncology, Drug and alcohol rehabilitation, Chronic renal failure,\\nOrgan transplants, Cholesterol  \\n\\nHealth education and advice\\n \\n(Refer to member guide for full details)","logo":"momentumMed.png"},{"company":"Momentum","name":"Extender Option: Any hospitals | State chronic","planType":"Threshold option","coverLevel":"High","hospital":"Any","chronic":"State","serviceType":"Any","familyIncome":"","mainContribution":"R4456","mainCompSavings":"R1485","mainTotal":"R5941","dependendContributionAdult":"R3658","dependentCompSavingsAdult":"R1219","dependentTotalAdult":"R4877","dependendContributionChild":"R1309","dependentCompSavingsChild":"R436","dependentTotalChild":"R1745","maxChildContribution":"3","mainThreshold":"","dependentThresholdAdult":"","dependentThresholdChild":"","preferedHospitalProvider":"Any hospital","overallLimit":"Unlimited","coPayment":"Specialised procedures in-hospital:\\nR3 280 co-payment applies\\nSpecialised procedures in day-hospital:\\nR1 640 co-payment applies\\nSpecialised procedures done out-of-hospital - paid by Scheme, no co-payment applies\\n\\nCertain specialised procedures done out-of-hospital, paid from available day-to-day benefits, no co-payment applies\\n\\nRefer to brochure for details","rate":"200% Scheme Rate","generalMedicin":"7 days' supply per event","specialist":"Full cover for Associated specialists\\nSpecialists and GPs: 200% Scheme Rate\\n","dentistSurgical":"Maxillo-facial surgery (excluding implants),  anaesthetic for children under 7 years, subject to R1 500 co-payment per authorisation \\n\\nDental and dental specialist bills paid from day-to-day benefits and accumulate towards limit\\n\\nImpacted wisdom teeth :\\nR3 000 co-payment for day hospitals and\\nR5 500 co-payment for other hospitals, per authorisation. Dental, dental specialist and maxillo-facial surgeon accounts paid up to 100% of Scheme Rate","mentalHealth":"Including psychiatry and psychology, drug and alcohol rehabilitation: R41 100 per beneficiary \\n21- day sublimit for alcohol and drug rehab Subject to treatment at preferred provider","radiology":"100% Scheme Rate, unlimited","pathology":"100% Scheme Rate, unlimited","maternityBenefit":"In hospital: Unlimited\\nOut of hospital:�(Subject to registration on maternity programme)\\n12 Antenatal visits\\n2 Paediatric visit in baby�s first year\\nOnline antenatal and postnatal classes \\nOnline video consult with lactation specialist\\nList of blood tests \\nDoula benefit: 2 visits per pregnancy \\n1 Nurse home visit day after discharge from hospital, plus 2 weeks and 6 weeks after initial visit\\n2 scans. 3D/4D scans are covered at 2D scan price ","dialysis":"Unlimited - subject to management programme. Treatment must be obtained from State facilities","cancer":"R500 000 per beneficiary, with a 20% co-payment thereafter, subject to management programme from an oncologist authorised by the Scheme","transplant":"Recipient - unlimited\\nDonor - R23 300 for cadaver costs and \\nR47 100 for live donor costs (incl. transportation)","mri":"In and out of hospital: Unlimited\\nR2 480 co-payment applies ","prosthesisInternal":"Cochlear implants: R198 000 per beneficiary \\nIntraocular lenses: R7 750 per beneficiary per event, max 2 events per year\\nOther internal prostheses: R74 900 per beneficiary per event, max 2 events per year","prosthesisExternal":"\\nExternal prosthesis: R26 000 per family per year \\nAppliances \\n- In Hospital R7 500 family limit per year\\n- Out-of-Hospital R 26 500 \\n- Hearing Aid Sub-limit R8 000 per family\\n(subject to day-to-day benefits)","rehab":"R60 000 per family per year \\n","designatedServiceProvider":"State","conditionsCovered":"62 conditions including PMBs","formulary":"State","partialLimits":"Unlimited for CDL conditions -\\nadditional 36 conditions - R11 100 per family","preferredProvider":"None","overallAnualLimit":"None","medicationOverCounter":"100% of cost\\nSubject to available Savings\\n(Does not accumulate to Threshold) ","medicationPrescribed":"Subject to available Savings and Threshold\\nExtended Cover limit of R18 900 per beneficiary, R35 800 per family ","practitionersGeneral":"Non-Associated GP, 70% of Scheme Rate \\nSubject to Savings, if available. Unlimited once Threshold is reached\\n\\nVirtual GP support:\\nMembers have free, unlimited access to doctors via Hello Doctor, on their phone, anytime, anywhere, in any official South African language, within an hour. Members can speak to the doctor over the phone or chat via text message. They can also get free daily advice with Hello Doctor�s Health Tips and health coaching. Hello Doctor can now prescribe medicine and issue sick notes, where appropriate. Prescribed medicine is covered from HealthSaver, if available.","specialistsCover":"Subject to Savings, if available. Unlimited once Threshold is reached\\n100% of Scheme Rate","dentistryCover":"Subject to Savings, if available. Unlimited once Threshold is reached","dentistryCoverSpecial":"Subject to available Savings and Threshold\\nExtended cover limit of R14 600 per beneficiary, R38 100 per family. Both in and out of hospital dental specialist accounts accumulate towards the limit, except for impacted wisdom teeth\\n\\nExtraction of impacted wisdom teeth in Dr's rooms: Dental specialist accounts - paid from Risk benefit at 100% of  Scheme Rate, subject to R1 500 co-payment and pre-authorisation\\n ","optical":"Subject to available Savings and Threshold\\nExtended cover limit of R4 500 per beneficiary, sub-limit of R2 450 for frames \\n","ambulance":"National: Netcare 911  \\nInternational: ISOS","international":"R8.22 million emergency cover per 90 day journey incl.  R15 500 cover for emergency optometry and dentistry. R765 000 terrorism cover. R1 850 co-payment per claim","hospitalCoverAids":"HIV related admissions: R78 600 per family","artTtreatment":"Unlimited, at chosen network provider","preventative":"Health Platform benefits\\n\\nEarly detection \\n- Health assessment\\n- Dental check-up\\n- Mammograms\\n- Pap smear consultation and test\\n- Prostate test\\n- General physical examination\\n- DEXA scan\\n- Glaucoma test\\n- Pathology tests: HIV, cholesterol and blood sugar\\n\\nPreventative care\\n- Flu vaccinations\\n- Baby immunisations\\n- Tetanus diphtheria injection\\n- Pneumococcal vaccine\\n\\nHealth management programmes \\n- Diabetes, Hypertension, HIV/Aids,\\nOncology, Drug and alcohol rehabilitation, Chronic renal failure,\\nOrgan transplants, Cholesterol  \\n\\nHealth education and advice\\n \\n(Refer to member guide for full details)","logo":"momentumMed.png"},{"company":"Momentum","name":"Extender Option: Any hospitals | Associated chronic","planType":"Threshold option","coverLevel":"High","hospital":"Any","chronic":"Network","serviceType":"Any","familyIncome":"","mainContribution":"R4968","mainCompSavings":"R1656","mainTotal":"R6624","dependendContributionAdult":"R4001","dependentCompSavingsAdult":"R1334","dependentTotalAdult":"R5335","dependendContributionChild":"R1429","dependentCompSavingsChild":"R476","dependentTotalChild":"R1905","maxChildContribution":"3","mainThreshold":"","dependentThresholdAdult":"","dependentThresholdChild":"","preferedHospitalProvider":"Any hospital","overallLimit":"Unlimited","coPayment":"Specialised procedures in-hospital:\\nR3 280 co-payment applies\\nSpecialised procedures in day-hospital:\\nR1 640 co-payment applies\\nSpecialised procedures done out-of-hospital - paid by Scheme, no co-payment applies\\n\\nCertain specialised procedures done out-of-hospital, paid from available day-to-day benefits, no co-payment applies\\n\\nRefer to brochure for details","rate":"200% Scheme Rate","generalMedicin":"7 days' supply per event","specialist":"Full cover for Associated specialists\\nSpecialists and GPs: 200% Scheme Rate\\n","dentistSurgical":"Maxillo-facial surgery (excluding implants),  anaesthetic for children under 7 years, subject to R1 500 co-payment per authorisation \\n\\nDental and dental specialist bills paid from day-to-day benefits and accumulate towards limit\\n\\nImpacted wisdom teeth :\\nR3 000 co-payment for day hospitals and\\nR5 500 co-payment for other hospitals, per authorisation. Dental, dental specialist and maxillo-facial surgeon accounts paid up to 100% of Scheme Rate","mentalHealth":"Including psychiatry and psychology, drug and alcohol rehabilitation: R41 100 per beneficiary \\n21- day sublimit for alcohol and drug rehab Subject to treatment at preferred provider","radiology":"100% Scheme Rate, unlimited","pathology":"100% Scheme Rate, unlimited","maternityBenefit":"In hospital: Unlimited\\nOut of hospital:�(Subject to registration on maternity programme)\\n12 Antenatal visits\\n2 Paediatric visit in baby�s first year\\nOnline antenatal and postnatal classes \\nOnline video consult with lactation specialist\\nList of blood tests \\nDoula benefit: 2 visits per pregnancy \\n1 Nurse home visit day after discharge from hospital, plus 2 weeks and 6 weeks after initial visit\\n2 scans. 3D/4D scans are covered at 2D scan price ","dialysis":"Unlimited, subject to management programme ","cancer":"R500 000 per beneficiary, with a 20% co-payment thereafter, subject to management programme","transplant":"Recipient - unlimited\\nDonor - R23 300 for cadaver costs and \\nR47 100 for live donor costs (incl. transportation)","mri":"In and out of hospital: Unlimited\\nR2 480 co-payment applies ","prosthesisInternal":"Cochlear implants: R198 000 per beneficiary \\nIntraocular lenses: R7 750 per beneficiary per event, max 2 events per year\\nOther internal prostheses: R74 900 per beneficiary per event, max 2 events per year","prosthesisExternal":"\\nExternal prosthesis: R26 000 per family per year \\nAppliances \\n- In Hospital R7 500 family limit per year\\n- Out-of-Hospital R 26 500 \\n- Hearing Aid Sub-limit R8 000 per family\\n(subject to day-to-day benefits)","rehab":"R60 000 per family per year \\n","designatedServiceProvider":"Associated GPs and Medipost courier pharmacy","conditionsCovered":"62 conditions including PMBs","formulary":"Entry level ","partialLimits":"Unlimited for CDL conditions -\\nadditional 36 conditions - R11 100 per family","preferredProvider":"Associated GP for GP benefits","overallAnualLimit":"None","medicationOverCounter":"100% of cost\\nSubject to available Savings\\n(Does not accumulate to Threshold) ","medicationPrescribed":"Subject to available Savings and Threshold\\nExtended Cover limit of R18 900 per beneficiary, R35 800 per family ","practitionersGeneral":"Non-Associated GP, 70% of Scheme Rate \\nSubject to Savings, if available. Unlimited once Threshold is reached\\n\\nVirtual GP support:\\nMembers have free, unlimited access to doctors via Hello Doctor, on their phone, anytime, anywhere, in any official South African language, within an hour. Members can speak to the doctor over the phone or chat via text message. They can also get free daily advice with Hello Doctor�s Health Tips and health coaching. Hello Doctor can now prescribe medicine and issue sick notes, where appropriate. Prescribed medicine is covered from HealthSaver, if available.","specialistsCover":"Subject to Savings, if available. Unlimited once Threshold is reached\\n100% of Scheme Rate","dentistryCover":"Subject to Savings, if available. Unlimited once Threshold is reached","dentistryCoverSpecial":"Subject to available Savings and Threshold\\nExtended cover limit of R14 600 per beneficiary, R38 100 per family. Both in and out of hospital dental specialist accounts accumulate towards the limit, except for impacted wisdom teeth\\n\\nExtraction of impacted wisdom teeth in Dr's rooms: Dental specialist accounts - paid from Risk benefit at 100% of  Scheme Rate, subject to R1 500 co-payment and pre-authorisation\\n ","optical":"Subject to available Savings and Threshold\\nExtended cover limit of R4 500 per beneficiary, sub-limit of R2 450 for frames \\n","ambulance":"National: Netcare 911  \\nInternational: ISOS","international":"R8.22 million emergency cover per 90 day journey incl.  R15 500 cover for emergency optometry and dentistry. R765 000 terrorism cover. R1 850 co-payment per claim","hospitalCoverAids":"HIV related admissions: R78 600 per family","artTtreatment":"Unlimited, at chosen network provider","preventative":"Health Platform benefits\\n\\nEarly detection \\n- Health assessment\\n- Dental check-up\\n- Mammograms\\n- Pap smear consultation and test\\n- Prostate test\\n- General physical examination\\n- DEXA scan\\n- Glaucoma test\\n- Pathology tests: HIV, cholesterol and blood sugar\\n\\nPreventative care\\n- Flu vaccinations\\n- Baby immunisations\\n- Tetanus diphtheria injection\\n- Pneumococcal vaccine\\n\\nHealth management programmes \\n- Diabetes, Hypertension, HIV/Aids,\\nOncology, Drug and alcohol rehabilitation, Chronic renal failure,\\nOrgan transplants, Cholesterol  \\n\\nHealth education and advice\\n \\n(Refer to member guide for full details)","logo":"momentumMed.png"},{"company":"Momentum","name":"Extender Option: Any hospitals | Any chronic","planType":"Threshold option","coverLevel":"High","hospital":"Any","chronic":"Any","serviceType":"Any","familyIncome":"","mainContribution":"R5564","mainCompSavings":"R1855","mainTotal":"R7419","dependendContributionAdult":"R4481","dependentCompSavingsAdult":"R1494","dependentTotalAdult":"R5975","dependendContributionChild":"R1596","dependentCompSavingsChild":"R532","dependentTotalChild":"R2128","maxChildContribution":"3","mainThreshold":"","dependentThresholdAdult":"","dependentThresholdChild":"","preferedHospitalProvider":"Any hospital","overallLimit":"Unlimited","coPayment":"Specialised procedures in-hospital:\\nR3 280 co-payment applies\\nSpecialised procedures in day-hospital:\\nR1 640 co-payment applies\\nSpecialised procedures done out-of-hospital - paid by Scheme, no co-payment applies\\n\\nCertain specialised procedures done out-of-hospital, paid from available day-to-day benefits, no co-payment applies\\n\\nRefer to brochure for details","rate":"200% Scheme Rate","generalMedicin":"7 days' supply per event","specialist":"Full cover for Associated specialists\\nSpecialists and GPs: 200% Scheme Rate\\n","dentistSurgical":"Maxillo-facial surgery (excluding implants),  anaesthetic for children under 7 years, subject to R1 500 co-payment per authorisation \\n\\nDental and dental specialist bills paid from day-to-day benefits and accumulate towards limit\\n\\nImpacted wisdom teeth :\\nR3 000 co-payment for day hospitals and\\nR5 500 co-payment for other hospitals, per authorisation. Dental, dental specialist and maxillo-facial surgeon accounts paid up to 100% of Scheme Rate","mentalHealth":"Including psychiatry and psychology, drug and alcohol rehabilitation: R41 100 per beneficiary \\n21- day sublimit for alcohol and drug rehab Subject to treatment at preferred provider","radiology":"100% Scheme Rate, unlimited","pathology":"100% Scheme Rate, unlimited","maternityBenefit":"In hospital: Unlimited\\nOut of hospital:�(Subject to registration on maternity programme)\\n12 Antenatal visits\\n2 Paediatric visit in baby�s first year\\nOnline antenatal and postnatal classes \\nOnline video consult with lactation specialist\\nList of blood tests \\nDoula benefit: 2 visits per pregnancy \\n1 Nurse home visit day after discharge from hospital, plus 2 weeks and 6 weeks after initial visit\\n2 scans. 3D/4D scans are covered at 2D scan price ","dialysis":"Unlimited, subject to management programme ","cancer":"R500 000 per beneficiary, with a 20% co-payment thereafter, subject to management programme","transplant":"Recipient - unlimited\\nDonor - R23 300 for cadaver costs and \\nR47 100 for live donor costs (incl. transportation)","mri":"In and out of hospital: Unlimited\\nR2 480 co-payment applies ","prosthesisInternal":"Cochlear implants: R198 000 per beneficiary \\nIntraocular lenses: R7 750 per beneficiary per event, max 2 events per year\\nOther internal prostheses: R74 900 per beneficiary per event, max 2 events per year","prosthesisExternal":"\\nExternal prosthesis: R26 000 per family per year \\nAppliances \\n- In Hospital R7 500 family limit per year\\n- Out-of-Hospital R 26 500 \\n- Hearing Aid Sub-limit R8 000 per family\\n(subject to day-to-day benefits)","rehab":"R60 000 per family per year \\n","designatedServiceProvider":"Any GP and Any pharmacy","conditionsCovered":"62 conditions including PMBs","formulary":"Extended","partialLimits":"Unlimited for CDL conditions -\\nadditional 36 conditions - R11 100 per family","preferredProvider":"None","overallAnualLimit":"None","medicationOverCounter":"100% of cost\\nSubject to available Savings\\n(Does not accumulate to Threshold) ","medicationPrescribed":"Subject to available Savings and Threshold\\nExtended Cover limit of R18 900 per beneficiary, R35 800 per family ","practitionersGeneral":"Non-Associated GP, 70% of Scheme Rate \\nSubject to Savings, if available. Unlimited once Threshold is reached\\n\\nVirtual GP support:\\nMembers have free, unlimited access to doctors via Hello Doctor, on their phone, anytime, anywhere, in any official South African language, within an hour. Members can speak to the doctor over the phone or chat via text message. They can also get free daily advice with Hello Doctor�s Health Tips and health coaching. Hello Doctor can now prescribe medicine and issue sick notes, where appropriate. Prescribed medicine is covered from HealthSaver, if available.","specialistsCover":"Subject to Savings, if available. Unlimited once Threshold is reached\\n100% of Scheme Rate","dentistryCover":"Subject to Savings, if available. Unlimited once Threshold is reached","dentistryCoverSpecial":"Subject to available Savings and Threshold\\nExtended cover limit of R14 600 per beneficiary, R38 100 per family. Both in and out of hospital dental specialist accounts accumulate towards the limit, except for impacted wisdom teeth\\n\\nExtraction of impacted wisdom teeth in Dr's rooms: Dental specialist accounts - paid from Risk benefit at 100% of  Scheme Rate, subject to R1 500 co-payment and pre-authorisation\\n ","optical":"Subject to available Savings and Threshold\\nExtended cover limit of R4 500 per beneficiary, sub-limit of R2 450 for frames \\n","ambulance":"National: Netcare 911  \\nInternational: ISOS","international":"R8.22 million emergency cover per 90 day journey incl.  R15 500 cover for emergency optometry and dentistry. R765 000 terrorism cover. R1 850 co-payment per claim","hospitalCoverAids":"HIV related admissions: R78 600 per family","artTtreatment":"Unlimited, at chosen network provider","preventative":"Health Platform benefits\\n\\nEarly detection \\n- Health assessment\\n- Dental check-up\\n- Mammograms\\n- Pap smear consultation and test\\n- Prostate test\\n- General physical examination\\n- DEXA scan\\n- Glaucoma test\\n- Pathology tests: HIV, cholesterol and blood sugar\\n\\nPreventative care\\n- Flu vaccinations\\n- Baby immunisations\\n- Tetanus diphtheria injection\\n- Pneumococcal vaccine\\n\\nHealth management programmes \\n- Diabetes, Hypertension, HIV/Aids,\\nOncology, Drug and alcohol rehabilitation, Chronic renal failure,\\nOrgan transplants, Cholesterol  \\n\\nHealth education and advice\\n \\n(Refer to member guide for full details)","logo":"momentumMed.png"},{"company":"Momentum","name":"Summit Option","planType":"Traditional option","coverLevel":"High","hospital":"Any","chronic":"Any","serviceType":"Any","familyIncome":"","mainContribution":"R10642","mainCompSavings":"R0.00","mainTotal":"R10642","dependendContributionAdult":"R8511","dependentCompSavingsAdult":"R0.00","dependentTotalAdult":"R8511","dependendContributionChild":"R2445","dependentCompSavingsChild":"R0.00","dependentTotalChild":"R2445","maxChildContribution":"3","mainThreshold":"","dependentThresholdAdult":"","dependentThresholdChild":"","preferedHospitalProvider":"Any hospital","overallLimit":"Unlimited","coPayment":"None","rate":"300% Scheme Rate","generalMedicin":"7 days' supply per event","specialist":"Full cover for Associated specialists\\nSpecialists and GPs: 300% Scheme Rate\\n","dentistSurgical":"Maxillo-facial surgery (excluding implants) and general anaesthesia for children under 7\\n\\nDental and dental specialist bills, paid from day-to-day benefits and accumulate towards overall limit of R28 000 per beneficiary\\n\\nImpacted wisdom teeth :\\nHospital and anaesthetist accounts paid from Risk Benefit. Dental, dental specialist and maxillo-facial surgeon accounts paid from Risk Benefit, up to 100% of the Scheme Rate","mentalHealth":"Including psychiatry and psychology, drug and alcohol rehabilitation: R41 100 per beneficiary \\n21- day sublimit for alcohol and drug rehab Subject to treatment at preferred provider","radiology":"100% Scheme Rate, unlimited","pathology":"100% Scheme Rate, unlimited","maternityBenefit":"In hospital: Unlimited\\nOut of hospital:�(Subject to registration on maternity programme)\\n12 Antenatal visits\\n2 Paediatric visit in baby�s first year\\nOnline antenatal and postnatal classes \\nOnline video consult with lactation specialist\\nList of blood tests \\nDoula benefit: 2 visits per pregnancy \\n1 Nurse home visit day after discharge from hospital, plus 2 weeks and 6 weeks after initial visit\\n2 scans. 3D/4D scans are covered at 2D scan price ","dialysis":"100% of Scheme Rate\\nUnlimited, subject to management programme","cancer":"Unlimited, subject to management programme","transplant":"Recipient - unlimited\\nDonor - R23 300 for cadaver costs and \\nR47 100 for live donor costs (incl. transportation)","mri":"In and out of hospital: Unlimited\\nR2 480 co-payment applies ","prosthesisInternal":"Cochlear implants: R198 000 per beneficiary \\nIntraocular lenses: R7 750 per beneficiary per event, max 2 events per year\\nOther internal prostheses: R74 900 per beneficiary per event, max 2 events per year","prosthesisExternal":"\\nExternal prosthesis: R26 000 per family per year \\nAppliances \\n- In Hospital R7 500 family limit per year\\n- Out-of-Hospital R 26 500\\n- Hearing Aid Sub-limit R8 000 per family\\n(subject to day-to-day benefits)","rehab":"R60 000 per family per year \\n","designatedServiceProvider":"Any","conditionsCovered":"62 conditions including PMBs","formulary":"Comprehensive","partialLimits":"Unlimited for CDL conditions - \\nadditional 36 conditions subject to day-to-day limit of R28 000 per beneficiary","preferredProvider":"None","overallAnualLimit":"R28 000 per beneficiary per annum.\\nAll benefits are paid subject to sub-limits, until overall out-of-hospital limit is reached","medicationOverCounter":"No benefit","medicationPrescribed":"R21 800 per beneficiary, R35 900 per family, subject to overall annual day-to-day limit ","practitionersGeneral":"\\nSubject to overall annual day-to-day limit\\n\\nVirtual GP support:\\nMembers have free, unlimited access to doctors via Hello Doctor, on their phone, anytime, anywhere, in any official South African language, within an hour. Members can speak to the doctor over the phone or chat via text message. They can also get free daily advice with Hello Doctor�s Health Tips and health coaching. Hello Doctor can now prescribe medicine and issue sick notes, where appropriate. Prescribed medicine is covered from HealthSaver, if available.\\n","specialistsCover":"\\nSubject to overall annual day-to-day limit\\n","dentistryCover":"\\nSubject to overall annual day-to-day limit\\n","dentistryCoverSpecial":"Subject to overall annual day-to-day limit\\nR16 800 per beneficiary, R40 500 per family\\nAll dental specialist accounts accumulate towards limit.  \\nExtraction of impacted wisdom teeth in Dr's rooms: Dental specialist accounts - paid from Risk benefit at 100% of  Scheme Rate, subject to pre-authorisation","optical":"Subject to overall annual day-to-day limit\\nLimited to R4 900 per beneficiary, sub-limit of     R2 500 for frames\\n","ambulance":"National: Netcare 911  \\nInternational: ISOS","international":"R9.01 million emergency cover per 90 day journey incl. R15 500 cover for emergency optometry and dentistry. R765 000 terrorism cover. R1 850 co-payment per claim","hospitalCoverAids":"HIV related admissions: R78 600 per family","artTtreatment":"Unlimited, at any provider","preventative":"Health Platform benefits\\n\\nEarly detection \\n- Health assessment\\n- Dental check-up\\n- Mammograms\\n- Pap smear consultation and test\\n- Prostate test\\n- General physical examination\\n- DEXA scan\\n- Glaucoma test\\n- Pathology tests: HIV, cholesterol and blood sugar\\n\\nPreventative care\\n- Flu vaccinations\\n- Baby immunisations\\n- Tetanus diphtheria injection\\n- Pneumococcal vaccine\\n\\nHealth management programmes \\n- Diabetes, Hypertension, HIV/Aids,\\nOncology, Drug and alcohol rehabilitation, Chronic renal failure,\\nOrgan transplants, Cholesterol  \\n\\nHealth education and advice\\n \\n(Refer to member guide for full details)","logo":"momentumMed.png"},{"company":"Momentum","name":"Evolve Option: Network hospitals and day facilities | State chronic ","planType":"Hybrid plan","coverLevel":"Mid","hospital":"Network","chronic":"State","serviceType":"N/A","familyIncome":"","mainContribution":"R1345","mainCompSavings":"R0.00","mainTotal":"R1345","dependendContributionAdult":"R1345","dependentCompSavingsAdult":"R0.00","dependentTotalAdult":"R1345","dependendContributionChild":"R1345","dependentCompSavingsChild":"R0.00","dependentTotalChild":"R1345","maxChildContribution":"3","mainThreshold":"","dependentThresholdAdult":"","dependentThresholdChild":"","preferedHospitalProvider":"Evolve Network hospitals, certain procedures only covered in day facilities ","overallLimit":"Unlimited","coPayment":"30% co-payment for use of non-network hospital\\n\\nR1 640 per authorisation, except for motor vehicle accidents, maternity confinements and emergency treatment\\n\\nSpecialised procedures in-hospital: R4 920 co-payment applies\\nSpecialised procedures done out-of-hospital:     R1 640 co-payment applies\\nCertain specialised procedures done out-of-hospital paid from HealthSaver+ if available: no co-payment applies \\n\\nThe following specialised procedures are covered for PMBs in State facilities: \\n� Back and neck treatment/surgery\\n� Joint replacements (including, but not limited to hips, knees, shoulders and elbows \\n� Other hip and knee surgery\\n\\nRefer to brochure for details","rate":"100% Scheme Rate, unlimited","generalMedicin":"7 days' supply per event","specialist":"Full cover for Associated specialists\\nOther specialists and GPs: 100% of Scheme Rate","dentistSurgical":"Maxillo-facial surgery: \\nPMBs only at State facilities","mentalHealth":"Including psychiatry and psychology drug and alcohol rehabilitation)\\nLimited to PMBs at State facilities\\nSub-limit of 21 days for alcohol and drug rehab","radiology":"100% Scheme Rate, unlimited","pathology":"100% Scheme Rate, unlimited","maternityBenefit":"In hospital: Unlimited\\nOut of hospital: (Subject to registration on maternity programme)�\\n12 Antenatal visits\\n2 Paediatric visit in baby�s first year\\nList of blood test \\nDoula benefit : 2 visits per pregnancy\\n1 Nurse home visit day after discharge from hospital, and 2 weeks after initial visit \\n2 pregnancy scans. 3D/4D scans are covered at 2D scan price\\n\\n ","dialysis":"Unlimited - subject to management programme at State facilities","cancer":"R200 000 per beneficiary per year, thereafter a 20% co-payment applies. Treatment must be obtained from Evolve Network of Oncologists","transplant":"PMBs only at State facilities","mri":"In and out of hospital: Unlimited\\nR2 740 co-payment applies ","prosthesisInternal":"Intraocular lenses: R5 400 per beneficiary per event, 2 events per year \\nOther internal prostheses: R35 900 per beneficiary per event max 2 events per year ","prosthesisExternal":"External prosthesis: R23 250 per family \\nAppliances: \\n- In Hospital: R6 450 per family per year ","rehab":"R49 600 per family","designatedServiceProvider":"State","conditionsCovered":"CDL in PMB ","formulary":"State ","partialLimits":"None","preferredProvider":"None","overallAnualLimit":"N/A","medicationOverCounter":"Subject to HealthSaver+, if available","medicationPrescribed":"Subject to HealthSaver+, if available","practitionersGeneral":"\\nSubject to HealthSaver+, if available\\n\\nVirtual consults: 2 per beneficiary subject to Hello Doctor Network GP or any contracted GP\\n\\nVirtual GP support:\\nMembers have free, unlimited access to doctors via Hello Doctor, on their phone, anytime, anywhere, in any official South African language, within an hour. Members can speak to the doctor over the phone or chat via text message. They can also get free daily advice with Hello Doctor�s Health Tips and health coaching. Hello Doctor can now prescribe medicine and issue sick notes, where appropriate. Prescribed medicine is covered from HealthSaver, if available.\\n\\n ","specialistsCover":"Subject to HealthSaver+, if available","dentistryCover":"Subject to HealthSaver+, if available","dentistryCoverSpecial":"Subject to HealthSaver+, if available","optical":"Subject to HealthSaver+, if available","ambulance":"National: Netcare 911 \\nInternational: ISOS","international":"R5 million emergency cover per 90 day journey incl. R15 500 cover for emergency optometry and dentistry. R765 000 terrorism cover. R1 850 co-payment per claim","hospitalCoverAids":"HIV related admissions: R41 000 per family ","artTtreatment":"Unlimited, at chosen network provider","preventative":"Health Platform benefits\\n\\nEarly detection \\n- Health assessment\\n- Dental check-up\\n- Mammograms\\n- Pap smear consultation and test\\n- Prostate test\\n- General physical examination\\n- DEXA scan\\n- Glaucoma test\\n- Pathology tests: HIV, cholesterol and blood sugar\\n\\nPreventative care\\n- Flu vaccinations\\n- Baby immunisations\\n- Tetanus diphtheria injection\\n- Pneumococcal vaccine\\n\\nHealth management programmes \\n- Diabetes, Hypertension, HIV/Aids,\\nOncology, Drug and alcohol rehabilitation, Chronic renal failure,\\nOrgan transplants, Cholesterol  \\n\\nHealth education and advice\\n \\n(Refer to member guide for full details)","logo":"momentumMed.png"},{"company":"Momentum","name":"Custom Option: Associated hospitals | State chronic  ","planType":"Hospital plan","coverLevel":"Mid","hospital":"Network","chronic":"State","serviceType":"N/A","familyIncome":"","mainContribution":"R1706","mainCompSavings":"R0.00","mainTotal":"R1706","dependendContributionAdult":"R1291","dependentCompSavingsAdult":"R0.00","dependentTotalAdult":"R1291","dependendContributionChild":"R605","dependentCompSavingsChild":"R0.00","dependentTotalChild":"R605","maxChildContribution":"3","mainThreshold":"","dependentThresholdAdult":"","dependentThresholdChild":"","preferedHospitalProvider":"Associated hospitals","overallLimit":"Unlimited","coPayment":"30% co-payment for use of non-network hospital\\n \\nR1 640 per authorisation, except for motor vehicle accidents, maternity confinements and emergency treatment\\n\\nSpecialised procedures in-hospital:\\n R4 920 co-payment applies\\nSpecialised procedures in day hospital:\\nR3 280 co-payment applies\\nSpecialised procedures done out-of-hospital:     R1 640 co-payment applies\\nCertain Specialised procedures done out-of-hospital paid from HealthSaver+ if available: no co-payment applies\\n\\nRefer to brochure for details","rate":"100% Scheme Rate, unlimited","generalMedicin":"7 days' supply per event","specialist":"Full cover for Associated specialists\\nOther specialists and GPs: 100% of Scheme Rate","dentistSurgical":"Maxillo-facial surgery (excluding implants),  and general anaesthetic for children under 7 years. Paid from Major Medical Benefit, R1 640 co-payment per auth. \\nDental and dental specialist bills subject to HealthSaver+, if available \\n\\nImpacted wisdom teeth :\\nR3 000 co-payment for day hospitals and\\nR5 500 co-payment for other hospitals, per authorisation. Dental, dental specialist and maxillo-facial surgeon accounts paid up to 100% of Scheme Rate","mentalHealth":"Including psychiatry and psychology, drug and alcohol rehabilitation: R38 500 per beneficiary \\n21- day sublimit for alcohol and drug rehab Subject to treatment at preferred provider","radiology":"100% Scheme Rate, unlimited","pathology":"100% Scheme Rate, unlimited","maternityBenefit":"In hospital: Unlimited\\nOut of hospital: (Subject to registration on maternity programme)�\\n12 Antenatal visits\\n2 Paediatric visit in baby�s first year\\nList of blood test \\nDoula benefit : 2 visits per pregnancy\\n1 Nurse home visit day after discharge from hospital, and 2 weeks after initial visit \\n2 pregnancy scans. 3D/4D scans are covered at 2D scan price\\n\\n ","dialysis":"Unlimited - subject to management programme. Treatment must be obtained from State facilities","cancer":"R300 000 per beneficiary per year, thereafter a 20% co-payment applies. Subject to management programme from an oncologist authorised by the Scheme","transplant":"Recipient - unlimited\\nDonor - R21 100 for cadaver costs and R42 800 for live donor costs (incl. transportation)","mri":"In and out of hospital: Unlimited\\nR2 740 co-payment applies ","prosthesisInternal":"Intraocular lenses: R5 900 per beneficiary per event max 2 events per year \\nOther internal prostheses: R50 200 per beneficiary per event max 2 events per year ","prosthesisExternal":"External prosthesis: R23 750 per family \\nAppliances: \\n- In Hospital: R6 820 per family per year ","rehab":"R55 000 per family","designatedServiceProvider":"State","conditionsCovered":"CDL in PMB ","formulary":"State","partialLimits":"None","preferredProvider":"None","overallAnualLimit":"N/A","medicationOverCounter":"Subject to HealthSaver+, if available","medicationPrescribed":"Subject to HealthSaver+, if available","practitionersGeneral":"Subject to HealthSaver+, if available\\n\\n\\n\\nVirtual GP support:\\nMembers have free, unlimited access to doctors via Hello Doctor, on their phone, anytime, anywhere, in any official South African language, within an hour. Members can speak to the doctor over the phone or chat via text message. They can also get free daily advice with Hello Doctor�s Health Tips and health coaching. Hello Doctor can now prescribe medicine and issue sick notes, where appropriate. Prescribed medicine is covered from HealthSaver, if available.\\n\\n","specialistsCover":"Subject to HealthSaver+, if available","dentistryCover":"Subject to HealthSaver+, if available","dentistryCoverSpecial":"Subject to HealthSaver+, if available\\n\\nExtraction of impacted wisdom teeth in Dr's rooms: Dental specialist accounts - Paid from Risk benefit at 100% of  Scheme Rate, subject to     R1 640 co-payment and pre-authorisation\\n\\nOther specialised dentistry: Subject to Savings, if available ","optical":"Subject to HealthSaver+, if available","ambulance":"National: Netcare 911 \\nInternational: ISOS","international":"R7.66 million emergency cover per 90 day journey incl. R15 500 cover for emergency optometry and dentistry. R765 000 terrorism cover. R1 850 co-payment per claim","hospitalCoverAids":"HIV related admissions: R72 700 per family ","artTtreatment":"Unlimited, at chosen network provider","preventative":"Health Platform benefits\\n\\nEarly detection \\n- Health assessment\\n- Dental check-up\\n- Mammograms\\n- Pap smear consultation and test\\n- Prostate test\\n- General physical examination\\n- DEXA scan\\n- Glaucoma test\\n- Pathology tests: HIV, cholesterol and blood sugar\\n\\nPreventative care\\n- Flu vaccinations\\n- Baby immunisations\\n- Tetanus diphtheria injection\\n- Pneumococcal vaccine\\n\\nHealth management programmes \\n- Diabetes, Hypertension, HIV/Aids,\\nOncology, Drug and alcohol rehabilitation, Chronic renal failure,\\nOrgan transplants, Cholesterol  \\n\\nHealth education and advice\\n \\n(Refer to member guide for full details)","logo":"momentumMed.png"},{"company":"Momentum","name":"Custom Option: Associated hospitals | Associated chronic","planType":"Hospital plan","coverLevel":"Mid","hospital":"Network","chronic":"Network","serviceType":"N/A","familyIncome":"","mainContribution":"R2194","mainCompSavings":"R0.00","mainTotal":"R2194","dependendContributionAdult":"R1701","dependentCompSavingsAdult":"R0.00","dependentTotalAdult":"R1701","dependendContributionChild":"R775","dependentCompSavingsChild":"R0.00","dependentTotalChild":"R775","maxChildContribution":"3","mainThreshold":"","dependentThresholdAdult":"","dependentThresholdChild":"","preferedHospitalProvider":"Associated hospitals","overallLimit":"Unlimited","coPayment":"30% co-payment for use of non-network hospital\\n \\nR1 640 per authorisation, except for motor vehicle accidents, maternity confinements and emergency treatment\\n\\nSpecialised procedures in-hospital:\\n R4 920 co-payment applies\\nSpecialised procedures in day hospital:\\nR3 280 co-payment applies\\nSpecialised procedures done out-of-hospital:     R1 640 co-payment applies\\nCertain Specialised procedures done out-of-hospital paid from HealthSaver+ if available: no co-payment applies\\n\\nRefer to brochure for details","rate":"100% Scheme Rate, unlimited","generalMedicin":"7 days' supply per event","specialist":"Full cover for Associated specialists\\nOther specialists and GPs: 100% of Scheme Rate","dentistSurgical":"Maxillo-facial surgery (excluding implants),  and general anaesthetic for children under 7 years. Paid from Major Medical Benefit, R1 640 co-payment per auth. \\nDental and dental specialist bills subject to HealthSaver+, if available \\n\\nImpacted wisdom teeth :\\nR3 000 co-payment for day hospitals and\\nR5 500 co-payment for other hospitals, per authorisation. Dental, dental specialist and maxillo-facial surgeon accounts paid up to 100% of Scheme Rate","mentalHealth":"Including psychiatry and psychology, drug and alcohol rehabilitation: R38 500 per beneficiary \\n21- day sublimit for alcohol and drug rehab Subject to treatment at preferred provider","radiology":"100% Scheme Rate, unlimited","pathology":"100% Scheme Rate, unlimited","maternityBenefit":"In hospital: Unlimited\\nOut of hospital: (Subject to registration on maternity programme)�\\n12 Antenatal visits\\n2 Paediatric visit in baby�s first year\\nList of blood test \\nDoula benefit : 2 visits per pregnancy\\n1 Nurse home visit day after discharge from hospital, and 2 weeks after initial visit \\n2 pregnancy scans. 3D/4D scans are covered at 2D scan price\\n\\n ","dialysis":"Unlimited, subject to management programme ","cancer":"R300 000 per beneficiary per year, thereafter a 20% co-payment applies. Subject to management programme ","transplant":"Recipient - unlimited\\nDonor - R21 100 for cadaver costs and R42 800 for live donor costs (incl. transportation)","mri":"In and out of hospital: Unlimited\\nR2 740 co-payment applies ","prosthesisInternal":"Intraocular lenses: R5 900 per beneficiary per event max 2 events per year \\nOther internal prostheses: R50 200 per beneficiary per event max 2 events per year ","prosthesisExternal":"External prosthesis: R23 750 per family \\nAppliances: \\n- In Hospital: R6 820 per family per year ","rehab":"R55 000 per family","designatedServiceProvider":"Associated GPs and Medipost courier pharmacy","conditionsCovered":"CDL in PMB ","formulary":"Entry level ","partialLimits":"None","preferredProvider":"None","overallAnualLimit":"N/A","medicationOverCounter":"Subject to HealthSaver+, if available","medicationPrescribed":"Subject to HealthSaver+, if available","practitionersGeneral":"Subject to HealthSaver+, if available\\n\\nVirtual GP support:\\nMembers have free, unlimited access to doctors via Hello Doctor, on their phone, anytime, anywhere, in any official South African language, within an hour. Members can speak to the doctor over the phone or chat via text message. They can also get free daily advice with Hello Doctor�s Health Tips and health coaching. Hello Doctor can now prescribe medicine and issue sick notes, where appropriate. Prescribed medicine is covered from HealthSaver, if available.\\n\\n","specialistsCover":"Subject to HealthSaver+, if available","dentistryCover":"Subject to HealthSaver+, if available","dentistryCoverSpecial":"Subject to HealthSaver+, if available\\n\\nExtraction of impacted wisdom teeth in Dr's rooms: Dental specialist accounts - Paid from Risk benefit at 100% of  Scheme Rate, subject to     R1 640 co-payment and pre-authorisation\\n\\nOther specialised dentistry: Subject to Savings, if available ","optical":"Subject to HealthSaver+, if available","ambulance":"National: Netcare 911 \\nInternational: ISOS","international":"R7.66 million emergency cover per 90 day journey incl. R15 500 cover for emergency optometry and dentistry. R765 000 terrorism cover. R1 850 co-payment per claim","hospitalCoverAids":"HIV related admissions: R72 700 per family ","artTtreatment":"Unlimited, at chosen network provider","preventative":"Health Platform benefits\\n\\nEarly detection \\n- Health assessment\\n- Dental check-up\\n- Mammograms\\n- Pap smear consultation and test\\n- Prostate test\\n- General physical examination\\n- DEXA scan\\n- Glaucoma test\\n- Pathology tests: HIV, cholesterol and blood sugar\\n\\nPreventative care\\n- Flu vaccinations\\n- Baby immunisations\\n- Tetanus diphtheria injection\\n- Pneumococcal vaccine\\n\\nHealth management programmes \\n- Diabetes, Hypertension, HIV/Aids,\\nOncology, Drug and alcohol rehabilitation, Chronic renal failure,\\nOrgan transplants, Cholesterol  \\n\\nHealth education and advice\\n \\n(Refer to member guide for full details)","logo":"momentumMed.png"},{"company":"Momentum","name":"Custom Option: Associated hospitals | Any chronic  ","planType":"Hospital plan","coverLevel":"Mid","hospital":"Network","chronic":"Any","serviceType":"N/A","familyIncome":"","mainContribution":"R2423","mainCompSavings":"R0.00","mainTotal":"R2423","dependendContributionAdult":"R1912","dependentCompSavingsAdult":"R0.00","dependentTotalAdult":"R1912","dependendContributionChild":"R855","dependentCompSavingsChild":"R0.00","dependentTotalChild":"R855","maxChildContribution":"3","mainThreshold":"","dependentThresholdAdult":"","dependentThresholdChild":"","preferedHospitalProvider":"Associated hospitals","overallLimit":"Unlimited","coPayment":"30% co-payment for use of non-network hospital\\n \\nR1 640 per authorisation, except for motor vehicle accidents, maternity confinements and emergency treatment\\n\\nSpecialised procedures in-hospital:\\n R4 920 co-payment applies\\nSpecialised procedures in day hospital:\\nR3 280 co-payment applies\\nSpecialised procedures done out-of-hospital:     R1 640 co-payment applies\\nCertain Specialised procedures done out-of-hospital paid from HealthSaver+ if available: no co-payment applies\\n\\nRefer to brochure for details","rate":"100% Scheme Rate, unlimited","generalMedicin":"7 days' supply per event","specialist":"Full cover for Associated specialists\\nOther specialists and GPs: 100% of Scheme Rate","dentistSurgical":"Maxillo-facial surgery (excluding implants),  and general anaesthetic for children under 7 years. Paid from Major Medical Benefit, R1 640 co-payment per auth. \\nDental and dental specialist bills subject to HealthSaver+, if available \\n\\nImpacted wisdom teeth :\\nR3 000 co-payment for day hospitals and\\nR5 500 co-payment for other hospitals, per authorisation. Dental, dental specialist and maxillo-facial surgeon accounts paid up to 100% of Scheme Rate","mentalHealth":"Including psychiatry and psychology, drug and alcohol rehabilitation: R38 500 per beneficiary \\n21- day sublimit for alcohol and drug rehab Subject to treatment at preferred provider","radiology":"100% Scheme Rate, unlimited","pathology":"100% Scheme Rate, unlimited","maternityBenefit":"In hospital: Unlimited\\nOut of hospital: (Subject to registration on maternity programme)�\\n12 Antenatal visits\\n2 Paediatric visit in baby�s first year\\nList of blood test \\nDoula benefit : 2 visits per pregnancy\\n1 Nurse home visit day after discharge from hospital, and 2 weeks after initial visit \\n2 pregnancy scans. 3D/4D scans are covered at 2D scan price\\n\\n ","dialysis":"Unlimited, subject to management programme ","cancer":"R300 000 per beneficiary per year, thereafter a 20% co-payment applies. Subject to management programme ","transplant":"Recipient - unlimited\\nDonor - R21 100 for cadaver costs and R42 800 for live donor costs (incl. transportation)","mri":"In and out of hospital: Unlimited\\nR2 740 co-payment applies ","prosthesisInternal":"Intraocular lenses: R5 900 per beneficiary per event max 2 events per year \\nOther internal prostheses: R50 200 per beneficiary per event max 2 events per year ","prosthesisExternal":"External prosthesis: R23 750 per family \\nAppliances: \\n- In Hospital: R6 820 per family per year ","rehab":"R55 000 per family","designatedServiceProvider":"Any GP and Any pharmacy","conditionsCovered":"CDL in PMB ","formulary":"Core","partialLimits":"None","preferredProvider":"None","overallAnualLimit":"N/A","medicationOverCounter":"Subject to HealthSaver+, if available","medicationPrescribed":"Subject to HealthSaver+, if available","practitionersGeneral":"Subject to HealthSaver+, if available\\n\\nVirtual GP support:\\nMembers have free, unlimited access to doctors via Hello Doctor, on their phone, anytime, anywhere, in any official South African language, within an hour. Members can speak to the doctor over the phone or chat via text message. They can also get free daily advice with Hello Doctor�s Health Tips and health coaching. Hello Doctor can now prescribe medicine and issue sick notes, where appropriate. Prescribed medicine is covered from HealthSaver, if available.\\n\\n","specialistsCover":"Subject to HealthSaver+, if available","dentistryCover":"Subject to HealthSaver+, if available","dentistryCoverSpecial":"Subject to HealthSaver+, if available\\n\\nExtraction of impacted wisdom teeth in Dr's rooms: Dental specialist accounts - Paid from Risk benefit at 100% of  Scheme Rate, subject to     R1 640 co-payment and pre-authorisation\\n\\nOther specialised dentistry: Subject to Savings, if available ","optical":"Subject to HealthSaver+, if available","ambulance":"National: Netcare 911 \\nInternational: ISOS","international":"R7.66 million emergency cover per 90 day journey incl. R15 500 cover for emergency optometry and dentistry. R765 000 terrorism cover. R1 850 co-payment per claim","hospitalCoverAids":"HIV related admissions: R72 700 per family ","artTtreatment":"Unlimited, at chosen network provider","preventative":"Health Platform benefits\\n\\nEarly detection \\n- Health assessment\\n- Dental check-up\\n- Mammograms\\n- Pap smear consultation and test\\n- Prostate test\\n- General physical examination\\n- DEXA scan\\n- Glaucoma test\\n- Pathology tests: HIV, cholesterol and blood sugar\\n\\nPreventative care\\n- Flu vaccinations\\n- Baby immunisations\\n- Tetanus diphtheria injection\\n- Pneumococcal vaccine\\n\\nHealth management programmes \\n- Diabetes, Hypertension, HIV/Aids,\\nOncology, Drug and alcohol rehabilitation, Chronic renal failure,\\nOrgan transplants, Cholesterol  \\n\\nHealth education and advice\\n \\n(Refer to member guide for full details)","logo":"momentumMed.png"},{"company":"Momentum","name":"Custom Option: Any hospitals | State chronic  ","planType":"Hospital plan","coverLevel":"Mid","hospital":"Any","chronic":"State","serviceType":"N/A","familyIncome":"","mainContribution":"R2173","mainCompSavings":"R0.00","mainTotal":"R2173","dependendContributionAdult":"R1640","dependentCompSavingsAdult":"R0.00","dependentTotalAdult":"R1640","dependendContributionChild":"R796","dependentCompSavingsChild":"R0.00","dependentTotalChild":"R796","maxChildContribution":"3","mainThreshold":"","dependentThresholdAdult":"","dependentThresholdChild":"","preferedHospitalProvider":"Any hospital","overallLimit":"Unlimited","coPayment":"R1 640 per authorisation, except for motor vehicle accidents, maternity confinements and emergency treatment\\n\\nSpecialised procedures in-hospital:\\n R4 920 co-payment applies\\nSpecialised procedures in day hospital:\\nR3 280 co-payment applies\\nSpecialised procedures done out-of-hospital:     R1 640 co-payment applies\\nCertain Specialised procedures done out-of-hospital paid from HealthSaver+ if available: no co-payment applies\\n\\nRefer to brochure for details","rate":"100% Scheme Rate, unlimited","generalMedicin":"7 days' supply per event","specialist":"Full cover for Associated specialists\\nOther specialists and GPs: 100% of Scheme Rate","dentistSurgical":"Maxillo-facial surgery (excluding implants),  and general anaesthetic for children under 7 years. Paid from Major Medical Benefit, R1 640 co-payment per auth. \\nDental and dental specialist bills subject to HealthSaver+, if available \\n\\nImpacted wisdom teeth :\\nR3 000 co-payment for day hospitals and\\nR5 500 co-payment for other hospitals, per authorisation. Dental, dental specialist and maxillo-facial surgeon accounts paid up to 100% of Scheme Rate","mentalHealth":"Including psychiatry and psychology, drug and alcohol rehabilitation: R38 500 per beneficiary \\n21- day sublimit for alcohol and drug rehab Subject to treatment at preferred provider","radiology":"100% Scheme Rate, unlimited","pathology":"100% Scheme Rate, unlimited","maternityBenefit":"In hospital: Unlimited\\nOut of hospital: (Subject to registration on maternity programme)�\\n12 Antenatal visits\\n2 Paediatric visit in baby�s first year\\nList of blood test \\nDoula benefit : 2 visits per pregnancy\\n1 Nurse home visit day after discharge from hospital, and 2 weeks after initial visit \\n2 pregnancy scans. 3D/4D scans are covered at 2D scan price\\n\\n ","dialysis":"Unlimited, subject to management programme. Treatment must be obtained from State facilities","cancer":"\\nR300 000 per beneficiary with a 20% co-payment thereafter, subject to management programme from an oncologist authorised by the Scheme","transplant":"Recipient - unlimited\\nDonor - R21 100 for cadaver costs and R42 800 for live donor costs (incl. transportation)","mri":"In and out of hospital: Unlimited\\nR2 740 co-payment applies ","prosthesisInternal":"Intraocular lenses: R5 900 per beneficiary per event max 2 events per year \\nOther internal prostheses: R50 200 per beneficiary per event max 2 events per year ","prosthesisExternal":"External prosthesis: R23 750 per family \\nAppliances: \\n- In Hospital: R6 820 per family per year ","rehab":"R55 000 per family","designatedServiceProvider":"State","conditionsCovered":"CDL in PMB ","formulary":"State","partialLimits":"None","preferredProvider":"None","overallAnualLimit":"N/A","medicationOverCounter":"Subject to HealthSaver+, if available","medicationPrescribed":"Subject to HealthSaver+, if available","practitionersGeneral":"Subject to HealthSaver+, if available\\n\\nVirtual GP support:\\nMembers have free, unlimited access to doctors via Hello Doctor, on their phone, anytime, anywhere, in any official South African language, within an hour. Members can speak to the doctor over the phone or chat via text message. They can also get free daily advice with Hello Doctor�s Health Tips and health coaching. Hello Doctor can now prescribe medicine and issue sick notes, where appropriate. Prescribed medicine is covered from HealthSaver, if available.\\n\\n","specialistsCover":"Subject to HealthSaver+, if available","dentistryCover":"Subject to HealthSaver+, if available","dentistryCoverSpecial":"Subject to HealthSaver+, if available\\n\\nExtraction of impacted wisdom teeth in Dr's rooms: Dental specialist accounts - Paid from Risk benefit at 100% of  Scheme Rate, subject to     R1 640 co-payment and pre-authorisation\\n\\nOther specialised dentistry: Subject to Savings, if available ","optical":"Subject to HealthSaver+, if available","ambulance":"National: Netcare 911 \\nInternational: ISOS","international":"R7.66 million emergency cover per 90 day journey incl. R15 500 cover for emergency optometry and dentistry. R765 000 terrorism cover. R1 850 co-payment per claim","hospitalCoverAids":"HIV related admissions: R72 700 per family ","artTtreatment":"Unlimited, at chosen network provider","preventative":"Health Platform benefits\\n\\nEarly detection \\n- Health assessment\\n- Dental check-up\\n- Mammograms\\n- Pap smear consultation and test\\n- Prostate test\\n- General physical examination\\n- DEXA scan\\n- Glaucoma test\\n- Pathology tests: HIV, cholesterol and blood sugar\\n\\nPreventative care\\n- Flu vaccinations\\n- Baby immunisations\\n- Tetanus diphtheria injection\\n- Pneumococcal vaccine\\n\\nHealth management programmes \\n- Diabetes, Hypertension, HIV/Aids,\\nOncology, Drug and alcohol rehabilitation, Chronic renal failure,\\nOrgan transplants, Cholesterol  \\n\\nHealth education and advice\\n \\n(Refer to member guide for full details)","logo":"momentumMed.png"},{"company":"Momentum","name":"Custom Option: Any hospitals | Associated  chronic","planType":"Hospital plan","coverLevel":"Mid","hospital":"Any","chronic":"Network","serviceType":"N/A","familyIncome":"","mainContribution":"R2601","mainCompSavings":"R0.00","mainTotal":"R2601","dependendContributionAdult":"R2032","dependentCompSavingsAdult":"R0.00","dependentTotalAdult":"R2032","dependendContributionChild":"R945","dependentCompSavingsChild":"R0.00","dependentTotalChild":"R945","maxChildContribution":"3","mainThreshold":"","dependentThresholdAdult":"","dependentThresholdChild":"","preferedHospitalProvider":"Any hospital","overallLimit":"Unlimited","coPayment":"R1 640 per authorisation, except for motor vehicle accidents, maternity confinements and emergency treatment\\n\\nSpecialised procedures in-hospital:\\n R4 920 co-payment applies\\nSpecialised procedures in day hospital:\\nR3 280 co-payment applies\\nSpecialised procedures done out-of-hospital: R1 640 co-payment applies\\nCertain Specialised procedures done out-of-hospital paid from HealthSaver+ if available: no co-payment applies\\n\\nRefer to brochure for details","rate":"100% Scheme Rate, unlimited","generalMedicin":"7 days' supply per event","specialist":"Full cover for Associated specialists\\nOther specialists and GPs: 100% of Scheme Rate","dentistSurgical":"Maxillo-facial surgery (excluding implants),  and general anaesthetic for children under 7 years. Paid from Major Medical Benefit, R1 640 co-payment per auth. \\nDental and dental specialist bills subject to HealthSaver+, if available \\n\\nImpacted wisdom teeth :\\nR3 000 co-payment for day hospitals and\\nR5 500 co-payment for other hospitals, per authorisation. Dental, dental specialist and maxillo-facial surgeon accounts paid up to 100% of Scheme Rate","mentalHealth":"Including psychiatry and psychology, drug and alcohol rehabilitation: R38 500 per beneficiary \\n21- day sublimit for alcohol and drug rehab Subject to treatment at preferred provider","radiology":"100% Scheme Rate, unlimited","pathology":"100% Scheme Rate, unlimited","maternityBenefit":"In hospital: Unlimited\\nOut of hospital: (Subject to registration on maternity programme)�\\n12 Antenatal visits\\n2 Paediatric visit in baby�s first year\\nList of blood test \\nDoula benefit : 2 visits per pregnancy\\n1 Nurse home visit day after discharge from hospital, and 2 weeks after initial visit \\n2 pregnancy scans. 3D/4D scans are covered at 2D scan price\\n\\n ","dialysis":"Unlimited, subject to management programme ","cancer":"R300 000 per beneficiary per year, thereafter a 20% co-payment applies. Subject to management programme ","transplant":"Recipient - unlimited\\nDonor - R21 100 for cadaver costs and R42 800 for live donor costs (incl. transportation)","mri":"In and out of hospital: Unlimited\\nR2 740 co-payment applies ","prosthesisInternal":"Intraocular lenses: R5 900 per beneficiary per event max 2 events per year \\nOther internal prostheses: R50 200 per beneficiary per event max 2 events per year ","prosthesisExternal":"External prosthesis: R23 750 per family \\nAppliances: \\n- In Hospital: R6 820 per family per year ","rehab":"R55 000 per family","designatedServiceProvider":"Associated GPs and Medipost courier pharmacy","conditionsCovered":"CDL in PMB ","formulary":"Entry level ","partialLimits":"None","preferredProvider":"None","overallAnualLimit":"N/A","medicationOverCounter":"Subject to HealthSaver+, if available","medicationPrescribed":"Subject to HealthSaver+, if available","practitionersGeneral":"Subject to HealthSaver+, if available\\n\\nVirtual GP support:\\nMembers have free, unlimited access to doctors via Hello Doctor, on their phone, anytime, anywhere, in any official South African language, within an hour. Members can speak to the doctor over the phone or chat via text message. They can also get free daily advice with Hello Doctor�s Health Tips and health coaching. Hello Doctor can now prescribe medicine and issue sick notes, where appropriate. Prescribed medicine is covered from HealthSaver, if available.\\n\\n","specialistsCover":"Subject to HealthSaver+, if available","dentistryCover":"Subject to HealthSaver+, if available","dentistryCoverSpecial":"Subject to HealthSaver+, if available\\n\\nExtraction of impacted wisdom teeth in Dr's rooms: Dental specialist accounts - Paid from Risk benefit at 100% of  Scheme Rate, subject to     R1 640 co-payment and pre-authorisation\\n\\nOther specialised dentistry: Subject to Savings, if available ","optical":"Subject to HealthSaver+, if available","ambulance":"National: Netcare 911 \\nInternational: ISOS","international":"R7.66 million emergency cover per 90 day journey incl. R15 500 cover for emergency optometry and dentistry. R765 000 terrorism cover. R1 850 co-payment per claim","hospitalCoverAids":"HIV related admissions: R72 700 per family ","artTtreatment":"Unlimited, at chosen network provider","preventative":"Health Platform benefits\\n\\nEarly detection \\n- Health assessment\\n- Dental check-up\\n- Mammograms\\n- Pap smear consultation and test\\n- Prostate test\\n- General physical examination\\n- DEXA scan\\n- Glaucoma test\\n- Pathology tests: HIV, cholesterol and blood sugar\\n\\nPreventative care\\n- Flu vaccinations\\n- Baby immunisations\\n- Tetanus diphtheria injection\\n- Pneumococcal vaccine\\n\\nHealth management programmes \\n- Diabetes, Hypertension, HIV/Aids,\\nOncology, Drug and alcohol rehabilitation, Chronic renal failure,\\nOrgan transplants, Cholesterol  \\n\\nHealth education and advice\\n \\n(Refer to member guide for full details)","logo":"momentumMed.png"},{"company":"Momentum","name":"Custom Option: Any hospitals |Any chronic  ","planType":"Hospital plan","coverLevel":"Mid","hospital":"Any","chronic":"Any","serviceType":"N/A","familyIncome":"","mainContribution":"R2891","mainCompSavings":"R0.00","mainTotal":"R2891","dependendContributionAdult":"R2320","dependentCompSavingsAdult":"R0.00","dependentTotalAdult":"R2320","dependendContributionChild":"R1032","dependentCompSavingsChild":"R0.00","dependentTotalChild":"R1032","maxChildContribution":"3","mainThreshold":"","dependentThresholdAdult":"","dependentThresholdChild":"","preferedHospitalProvider":"Any hospital","overallLimit":"Unlimited","coPayment":"R1 640 per authorisation, except for motor vehicle accidents, maternity confinements and emergency treatment\\n\\nSpecialised procedures in-hospital:\\n R4 920 co-payment applies\\nSpecialised procedures in day hospital:\\nR3 280 co-payment applies\\nSpecialised procedures done out-of-hospital:     R1 640 co-payment applies\\nCertain Specialised procedures done out-of-hospital paid from HealthSaver+ if available: no co-payment applies\\n\\nRefer to brochure for details","rate":"100% Scheme Rate, unlimited","generalMedicin":"7 days' supply per event","specialist":"Full cover for Associated specialists\\nOther specialists and GPs: 100% of Scheme Rate","dentistSurgical":"Maxillo-facial surgery (excluding implants),  and general anaesthetic for children under 7 years. Paid from Major Medical Benefit, R1 640 co-payment per auth. \\nDental and dental specialist bills subject to HealthSaver+, if available \\n\\nImpacted wisdom teeth :\\nR3 000 co-payment for day hospitals and\\nR5 500 co-payment for other hospitals, per authorisation. Dental, dental specialist and maxillo-facial surgeon accounts paid up to 100% of Scheme Rate","mentalHealth":"Including psychiatry and psychology, drug and alcohol rehabilitation: R38 500 per beneficiary \\n21- day sublimit for alcohol and drug rehab Subject to treatment at preferred provider","radiology":"100% Scheme Rate, unlimited","pathology":"100% Scheme Rate, unlimited","maternityBenefit":"In hospital: Unlimited\\nOut of hospital: (Subject to registration on maternity programme)�\\n12 Antenatal visits\\n2 Paediatric visit in baby�s first year\\nList of blood test \\nDoula benefit : 2 visits per pregnancy\\n1 Nurse home visit day after discharge from hospital, and 2 weeks after initial visit \\n2 pregnancy scans. 3D/4D scans are covered at 2D scan price\\n\\n ","dialysis":"Unlimited, subject to management programme ","cancer":"R300 000 per beneficiary per year, thereafter a 20% co-payment applies. Subject to management programme ","transplant":"Recipient - unlimited\\nDonor - R21 100 for cadaver costs and R42 800 for live donor costs (incl. transportation)","mri":"In and out of hospital: Unlimited\\nR2 740 co-payment applies ","prosthesisInternal":"Intraocular lenses: R5 900 per beneficiary per event max 2 events per year \\nOther internal prostheses: R50 200 per beneficiary per event max 2 events per year ","prosthesisExternal":"External prosthesis: R23 750 per family \\nAppliances: \\n- In Hospital: R6 820 per family per year ","rehab":"R55 000 per family","designatedServiceProvider":"Any GP and Any pharmacy","conditionsCovered":"CDL in PMB ","formulary":"Core","partialLimits":"None","preferredProvider":"None","overallAnualLimit":"N/A","medicationOverCounter":"Subject to HealthSaver+, if available","medicationPrescribed":"Subject to HealthSaver+, if available","practitionersGeneral":"Subject to HealthSaver+, if available\\n\\nVirtual GP support:\\nMembers have free, unlimited access to doctors via Hello Doctor, on their phone, anytime, anywhere, in any official South African language, within an hour. Members can speak to the doctor over the phone or chat via text message. They can also get free daily advice with Hello Doctor�s Health Tips and health coaching. Hello Doctor can now prescribe medicine and issue sick notes, where appropriate. Prescribed medicine is covered from HealthSaver, if available.\\n\\n","specialistsCover":"Subject to HealthSaver+, if available","dentistryCover":"Subject to HealthSaver+, if available","dentistryCoverSpecial":"Subject to HealthSaver+, if available\\n\\nExtraction of impacted wisdom teeth in Dr's rooms: Dental specialist accounts - Paid from Risk benefit at 100% of  Scheme Rate, subject to     R1 640 co-payment and pre-authorisation\\n\\nOther specialised dentistry: Subject to Savings, if available ","optical":"Subject to HealthSaver+, if available","ambulance":"National: Netcare 911 \\nInternational: ISOS","international":"R7.66 million emergency cover per 90 day journey incl. R15 500 cover for emergency optometry and dentistry. R765 000 terrorism cover. R1 850 co-payment per claim","hospitalCoverAids":"HIV related admissions: R72 700 per family ","artTtreatment":"Unlimited, at chosen network provider","preventative":"Health Platform benefits\\n\\nEarly detection \\n- Health assessment\\n- Dental check-up\\n- Mammograms\\n- Pap smear consultation and test\\n- Prostate test\\n- General physical examination\\n- DEXA scan\\n- Glaucoma test\\n- Pathology tests: HIV, cholesterol and blood sugar\\n\\nPreventative care\\n- Flu vaccinations\\n- Baby immunisations\\n- Tetanus diphtheria injection\\n- Pneumococcal vaccine\\n\\nHealth management programmes \\n- Diabetes, Hypertension, HIV/Aids,\\nOncology, Drug and alcohol rehabilitation, Chronic renal failure,\\nOrgan transplants, Cholesterol  \\n\\nHealth education and advice\\n \\n(Refer to member guide for full details)","logo":"momentumMed.png"},{"company":"Momentum","name":"Incentive Option: Associated hospitals | State chronic ","planType":"New generation","coverLevel":"Mid","hospital":"Network","chronic":"State","serviceType":"Any","familyIncome":"","mainContribution":"R2002","mainCompSavings":"R222","mainTotal":"R2224","dependendContributionAdult":"R1580","dependentCompSavingsAdult":"R176","dependentTotalAdult":"R1756","dependendContributionChild":"R768","dependentCompSavingsChild":"R85","dependentTotalChild":"R853","maxChildContribution":"3","mainThreshold":"","dependentThresholdAdult":"","dependentThresholdChild":"","preferedHospitalProvider":"Associated hospitals","overallLimit":"Unlimited","coPayment":"30% co-payment for use of non-network hospital\\n\\nSpecialised procedures in-hospital:\\nR3 280 co-payment applies\\nSpecialised procedures in day hospital:\\nR1 640 co-payment applies\\nSpecialised procedures done out-of-hospital: paid by Scheme, no co-payment applies\\nCertain specialised procedures done out-of-hospital- paid from available day-to-day benefits, no co-payment applies\\n\\nRefer to brochure for details\\n","rate":"200% Scheme Rate","generalMedicin":"7 days' supply per event","specialist":"Full cover for Associated specialists\\nOther specialists and GPs: 200% of Scheme Rate","dentistSurgical":"Maxillo-facial surgery (excluding implants),  and general anaesthetic for children under 7 years. Paid from Risk, R1 500 co-payment per auth. \\nDental and dental specialist bills subject to available Savings\\n\\nImpacted wisdom teeth :\\nR3 000 co-payment for day hospitals and\\nR5 500 co-payment for other hospitals, per authorisation. Dental, dental specialist and maxillo-facial surgeon accounts paid up to 100% of Scheme Rate\\n","mentalHealth":"Including psychiatry and psychology, drug and alcohol rehabilitation: R41 100 per beneficiary \\n21- day sublimit for alcohol and drug rehab Subject to treatment at preferred provider","radiology":"100% Scheme Rate, unlimited","pathology":"100% Scheme Rate, unlimited","maternityBenefit":"In hospital: Unlimited\\nOut of hospital:�(Subject to registration on maternity programme)\\n12 Antenatal visits\\n2 Paediatric visit in baby�s first year\\nOnline antenatal and postnatal classes \\nOnline video consult with lactation specialist\\nList of blood tests \\nDoula benefit: 2 visits per pregnancy \\n1 Nurse home visit day after discharge from hospital, plus 2 weeks and 6 weeks after initial visit\\n2 scans. 3D/4D scans are covered at 2D scan price ","dialysis":"Unlimited, subject to management programme. Treatment must be obtained from State facilities","cancer":"R400 000 per beneficiary with a 20% co-payment thereafter, subject to management programme from an oncologist authorised by the Scheme","transplant":"Recipient - unlimited\\nDonor - R23 300 for cadaver costs and R47 100 for live donor costs (incl. transportation)","mri":"In and out of hospital: Unlimited\\nR2 480 co-payment applies ","prosthesisInternal":"Cochlear implants: R181 700 per beneficiary \\nIntraocular lenses: R7 250 per beneficiary per event max 2 events per year\\nOther internal prostheses: R55 000 per beneficiary per event max 2 events per year","prosthesisExternal":"External prosthesis: R24 900 per family\\nAppliances: \\n- In Hospital: R7 150 per family per year\\n- Out of Hospital: Subject to available Savings ","rehab":"R57 500 per family ","designatedServiceProvider":"State","conditionsCovered":"CDL in PMB + 6 conditions","formulary":"State","partialLimits":"Unlimited for CDL conditions -\\nadditional 6 conditions - R11 100 per family \\n","preferredProvider":"None","overallAnualLimit":"N/A","medicationOverCounter":"Subject to available Savings","medicationPrescribed":"Subject to available Savings","practitionersGeneral":"Subject to available Savings\\n\\nVirtual GP support:\\nMembers have free, unlimited access to doctors via Hello Doctor, on their phone, anytime, anywhere, in any official South African language, within an hour. Members can speak to the doctor over the phone or chat via text message. They can also get free daily advice with Hello Doctor�s Health Tips and health coaching. Hello Doctor can now prescribe medicine and issue sick notes, where appropriate. Prescribed medicine is covered from HealthSaver, if available.","specialistsCover":"Subject to available Savings","dentistryCover":"Subject to available Savings","dentistryCoverSpecial":"Subject to HealthSaver+, if available\\n\\nExtraction of impacted wisdom teeth in Dr's rooms: Dental specialist accounts - Paid from Risk benefit at 100% of  Scheme Rate, subject to     R1 500 co-payment and pre-authorisation\\n\\nOther specialised dentistry: Subject to Savings, if available ","optical":"Subject to available Savings","ambulance":"National: Netcare 911 \\nInternational: ISOS","international":"R8 million emergency cover per 90 day journey incl. R15 500 cover for emergency optometry and dentistry. R765 000 terrorism cover. R1 850 co-payment per claim","hospitalCoverAids":"HIV related admissions: R78 600 per family ","artTtreatment":"Unlimited, at chosen network provider","preventative":"Health Platform benefits\\n\\nEarly detection \\n- Health assessment\\n- Dental check-up\\n- Mammograms\\n- Pap smear consultation and test\\n- Prostate test\\n- General physical examination\\n- DEXA scan\\n- Glaucoma test\\n- Pathology tests: HIV, cholesterol and blood sugar\\n\\nPreventative care\\n- Flu vaccinations\\n- Baby immunisations\\n- Tetanus diphtheria injection\\n- Pneumococcal vaccine\\n\\nHealth management programmes \\n- Diabetes, Hypertension, HIV/Aids,\\nOncology, Drug and alcohol rehabilitation, Chronic renal failure,\\nOrgan transplants, Cholesterol  \\n\\nHealth education and advice\\n \\n(Refer to member guide for full details)","logo":"momentumMed.png"},{"company":"Momentum","name":"Incentive Option: Associated hospitals | Associated chronic","planType":"New generation","coverLevel":"Mid","hospital":"Network","chronic":"Network","serviceType":"Any","familyIncome":"","mainContribution":"R2802","mainCompSavings":"R311","mainTotal":"R3113","dependendContributionAdult":"R2229","dependentCompSavingsAdult":"R248","dependentTotalAdult":"R2477","dependendContributionChild":"R1064","dependentCompSavingsChild":"R118","dependentTotalChild":"R1182","maxChildContribution":"3","mainThreshold":"","dependentThresholdAdult":"","dependentThresholdChild":"","preferedHospitalProvider":"Associated hospitals","overallLimit":"Unlimited","coPayment":"30% co-payment for use of non-network hospital\\n\\nSpecialised procedures in-hospital:\\nR3 280 co-payment applies\\nSpecialised procedures in day hospital:\\nR1 640 co-payment applies\\nSpecialised procedures done out-of-hospital: paid by Scheme, no co-payment applies\\nCertain specialised procedures done out-of-hospital- paid from available day-to-day benefits, no co-payment applies\\n\\nRefer to brochure for details\\n","rate":"200% Scheme Rate","generalMedicin":"7 days' supply per event","specialist":"Full cover for Associated specialists\\nOther specialists and GPs: 200% of Scheme Rate","dentistSurgical":"Maxillo-facial surgery (excluding implants),  and general anaesthetic for children under 7 years. Paid from Risk, R1 500 co-payment per auth. \\nDental and dental specialist bills subject to available Savings\\n\\nImpacted wisdom teeth :\\nR3 000 co-payment for day hospitals and\\nR5 500 co-payment for other hospitals, per authorisation. Dental, dental specialist and maxillo-facial surgeon accounts paid up to 100% of Scheme Rate\\n","mentalHealth":"Including psychiatry and psychology, drug and alcohol rehabilitation: R41 100 per beneficiary \\n21- day sublimit for alcohol and drug rehab Subject to treatment at preferred provider","radiology":"100% Scheme Rate, unlimited","pathology":"100% Scheme Rate, unlimited","maternityBenefit":"In hospital: Unlimited\\nOut of hospital:�(Subject to registration on maternity programme)\\n12 Antenatal visits\\n2 Paediatric visit in baby�s first year\\nOnline antenatal and postnatal classes \\nOnline video consult with lactation specialist\\nList of blood tests \\nDoula benefit: 2 visits per pregnancy \\n1 Nurse home visit day after discharge from hospital, plus 2 weeks and 6 weeks after initial visit\\n2 scans. 3D/4D scans are covered at 2D scan price ","dialysis":"Unlimited, subject to management programme ","cancer":"R400 000 per beneficiary per year, thereafter a 20% co-payment applies. Subject to management programme ","transplant":"Recipient - unlimited\\nDonor - R23 300 for cadaver costs and R47 100 for live donor costs (incl. transportation)","mri":"In and out of hospital: Unlimited\\nR2 480 co-payment applies ","prosthesisInternal":"Cochlear implants: R181 700 per beneficiary \\nIntraocular lenses: R7 250 per beneficiary per event max 2 events per year\\nOther internal prostheses: R55 000 per beneficiary per event max 2 events per year","prosthesisExternal":"External prosthesis: R24 900 per family\\nAppliances: \\n- In Hospital: R7 150 per family per year\\n- Out of Hospital: Subject to available Savings ","rehab":"R57 500 per family ","designatedServiceProvider":"Associated GPs and Medipost courier pharmacy","conditionsCovered":"CDL in PMB + 6 conditions","formulary":"Entry level ","partialLimits":"Unlimited for CDL conditions -\\nadditional 6 conditions - R11 100 per family \\n","preferredProvider":"None","overallAnualLimit":"N/A","medicationOverCounter":"Subject to available Savings","medicationPrescribed":"Subject to available Savings","practitionersGeneral":"Subject to available Savings\\n\\nVirtual GP support:\\nMembers have free, unlimited access to doctors via Hello Doctor, on their phone, anytime, anywhere, in any official South African language, within an hour. Members can speak to the doctor over the phone or chat via text message. They can also get free daily advice with Hello Doctor�s Health Tips and health coaching. Hello Doctor can now prescribe medicine and issue sick notes, where appropriate. Prescribed medicine is covered from HealthSaver, if available.","specialistsCover":"Subject to available Savings","dentistryCover":"Subject to available Savings","dentistryCoverSpecial":"Subject to HealthSaver+, if available\\n\\nExtraction of impacted wisdom teeth in Dr's rooms: Dental specialist accounts - Paid from Risk benefit at 100% of  Scheme Rate, subject to     R1 500 co-payment and pre-authorisation\\n\\nOther specialised dentistry: Subject to Savings, if available ","optical":"Subject to available Savings","ambulance":"National: Netcare 911 \\nInternational: ISOS","international":"R8 million emergency cover per 90 day journey incl. R15 500 cover for emergency optometry and dentistry. R765 000 terrorism cover. R1 850 co-payment per claim","hospitalCoverAids":"HIV related admissions: R78 600 per family ","artTtreatment":"Unlimited, at chosen network provider","preventative":"Health Platform benefits\\n\\nEarly detection \\n- Health assessment\\n- Dental check-up\\n- Mammograms\\n- Pap smear consultation and test\\n- Prostate test\\n- General physical examination\\n- DEXA scan\\n- Glaucoma test\\n- Pathology tests: HIV, cholesterol and blood sugar\\n\\nPreventative care\\n- Flu vaccinations\\n- Baby immunisations\\n- Tetanus diphtheria injection\\n- Pneumococcal vaccine\\n\\nHealth management programmes \\n- Diabetes, Hypertension, HIV/Aids,\\nOncology, Drug and alcohol rehabilitation, Chronic renal failure,\\nOrgan transplants, Cholesterol  \\n\\nHealth education and advice\\n \\n(Refer to member guide for full details)","logo":"momentumMed.png"},{"company":"Momentum","name":"Incentive Option: Associated hospitals | Any chronic  ","planType":"New generation","coverLevel":"Mid","hospital":"Network","chronic":"Any","serviceType":"Any","familyIncome":"","mainContribution":"R3104","mainCompSavings":"R345","mainTotal":"R3449","dependendContributionAdult":"R2497","dependentCompSavingsAdult":"R277","dependentTotalAdult":"R2774","dependendContributionChild":"R1160","dependentCompSavingsChild":"R129","dependentTotalChild":"R1289","maxChildContribution":"3","mainThreshold":"","dependentThresholdAdult":"","dependentThresholdChild":"","preferedHospitalProvider":"Associated hospitals","overallLimit":"Unlimited","coPayment":"30% co-payment for use of non-network hospital\\n\\nSpecialised procedures in-hospital:\\nR3 280 co-payment applies\\nSpecialised procedures in day hospital:\\nR1 640 co-payment applies\\nSpecialised procedures done out-of-hospital: paid by Scheme, no co-payment applies\\nCertain specialised procedures done out-of-hospital- paid from available day-to-day benefits, no co-payment applies\\n\\nRefer to brochure for details\\n","rate":"200% Scheme Rate","generalMedicin":"7 days' supply per event","specialist":"Full cover for Associated specialists\\nOther specialists and GPs: 200% of Scheme Rate","dentistSurgical":"Maxillo-facial surgery (excluding implants),  and general anaesthetic for children under 7 years. Paid from Risk, R1 500 co-payment per auth. \\nDental and dental specialist bills subject to available Savings\\n\\nImpacted wisdom teeth :\\nR3 000 co-payment for day hospitals and\\nR5 500 co-payment for other hospitals, per authorisation. Dental, dental specialist and maxillo-facial surgeon accounts paid up to 100% of Scheme Rate\\n","mentalHealth":"Including psychiatry and psychology, drug and alcohol rehabilitation: R41 100 per beneficiary \\n21- day sublimit for alcohol and drug rehab Subject to treatment at preferred provider","radiology":"100% Scheme Rate, unlimited","pathology":"100% Scheme Rate, unlimited","maternityBenefit":"In hospital: Unlimited\\nOut of hospital:�(Subject to registration on maternity programme)\\n12 Antenatal visits\\n2 Paediatric visit in baby�s first year\\nOnline antenatal and postnatal classes \\nOnline video consult with lactation specialist\\nList of blood tests \\nDoula benefit: 2 visits per pregnancy \\n1 Nurse home visit day after discharge from hospital, plus 2 weeks and 6 weeks after initial visit\\n2 scans. 3D/4D scans are covered at 2D scan price ","dialysis":"Unlimited, subject to management programme ","cancer":"R400 000 per beneficiary per year, thereafter a 20% co-payment applies. Subject to management programme ","transplant":"Recipient - unlimited\\nDonor - R23 300 for cadaver costs and R47 100 for live donor costs (incl. transportation)","mri":"In and out of hospital: Unlimited\\nR2 480 co-payment applies ","prosthesisInternal":"Cochlear implants: R181 700 per beneficiary \\nIntraocular lenses: R7 250 per beneficiary per event max 2 events per year\\nOther internal prostheses: R55 000 per beneficiary per event max 2 events per year","prosthesisExternal":"External prosthesis: R24 900 per family\\nAppliances: \\n- In Hospital: R7 150 per family per year\\n- Out of Hospital: Subject to available Savings ","rehab":"R57 500 per family ","designatedServiceProvider":"Any GP and Any pharmacy","conditionsCovered":"CDL in PMB + 6 conditions","formulary":"Standard","partialLimits":"Unlimited for CDL conditions -\\nadditional 6 conditions - R11 100 per family \\n","preferredProvider":"None","overallAnualLimit":"N/A","medicationOverCounter":"Subject to available Savings","medicationPrescribed":"Subject to available Savings","practitionersGeneral":"Subject to available Savings\\n\\nVirtual GP support:\\nMembers have free, unlimited access to doctors via Hello Doctor, on their phone, anytime, anywhere, in any official South African language, within an hour. Members can speak to the doctor over the phone or chat via text message. They can also get free daily advice with Hello Doctor�s Health Tips and health coaching. Hello Doctor can now prescribe medicine and issue sick notes, where appropriate. Prescribed medicine is covered from HealthSaver, if available.","specialistsCover":"Subject to available Savings","dentistryCover":"Subject to available Savings","dentistryCoverSpecial":"Subject to HealthSaver+, if available\\n\\nExtraction of impacted wisdom teeth in Dr's rooms: Dental specialist accounts - Paid from Risk benefit at 100% of  Scheme Rate, subject to     R1 500 co-payment and pre-authorisation\\n\\nOther specialised dentistry: Subject to Savings, if available ","optical":"Subject to available Savings","ambulance":"National: Netcare 911 \\nInternational: ISOS","international":"R8 million emergency cover per 90 day journey incl. R15 500 cover for emergency optometry and dentistry. R765 000 terrorism cover. R1 850 co-payment per claim","hospitalCoverAids":"HIV related admissions: R78 600 per family ","artTtreatment":"Unlimited, at chosen network provider","preventative":"Health Platform benefits\\n\\nEarly detection \\n- Health assessment\\n- Dental check-up\\n- Mammograms\\n- Pap smear consultation and test\\n- Prostate test\\n- General physical examination\\n- DEXA scan\\n- Glaucoma test\\n- Pathology tests: HIV, cholesterol and blood sugar\\n\\nPreventative care\\n- Flu vaccinations\\n- Baby immunisations\\n- Tetanus diphtheria injection\\n- Pneumococcal vaccine\\n\\nHealth management programmes \\n- Diabetes, Hypertension, HIV/Aids,\\nOncology, Drug and alcohol rehabilitation, Chronic renal failure,\\nOrgan transplants, Cholesterol  \\n\\nHealth education and advice\\n \\n(Refer to member guide for full details)","logo":"momentumMed.png"},{"company":"Momentum","name":"Incentive Option: Any hospitals | State chronic  ","planType":"New generation","coverLevel":"Mid","hospital":"Any","chronic":"State","serviceType":"Any","familyIncome":"","mainContribution":"R2487","mainCompSavings":"R276","mainTotal":"R2763","dependendContributionAdult":"R1960","dependentCompSavingsAdult":"R218","dependentTotalAdult":"R2178","dependendContributionChild":"R984","dependentCompSavingsChild":"R109","dependentTotalChild":"R1093","maxChildContribution":"3","mainThreshold":"","dependentThresholdAdult":"","dependentThresholdChild":"","preferedHospitalProvider":"Any hospital","overallLimit":"Unlimited","coPayment":"\\nSpecialised procedures in-hospital:\\nR3 280 co-payment applies\\nSpecialised procedures in day hospital:\\nR1 640 co-payment applies\\nSpecialised procedures done out-of-hospital: paid by Scheme, no co-payment applies\\nCertain specialised procedures done out-of-hospital- paid from available day-to-day benefits, no co-payment applies\\n\\nRefer to brochure for details\\n","rate":"200% Scheme Rate","generalMedicin":"7 days' supply per event","specialist":"Full cover for Associated specialists\\nOther specialists and GPs: 200% of Scheme Rate","dentistSurgical":"Maxillo-facial surgery (excluding implants),  and general anaesthetic for children under 7 years. Paid from Risk, R1 500 co-payment per auth. \\nDental and dental specialist bills subject to available Savings\\n\\nImpacted wisdom teeth :\\nR3 000 co-payment for day hospitals and\\nR5 500 co-payment for other hospitals, per authorisation. Dental, dental specialist and maxillo-facial surgeon accounts paid up to 100% of Scheme Rate\\n","mentalHealth":"Including psychiatry and psychology, drug and alcohol rehabilitation: R41 100 per beneficiary \\n21- day sublimit for alcohol and drug rehab Subject to treatment at preferred provider","radiology":"100% Scheme Rate, unlimited","pathology":"100% Scheme Rate, unlimited","maternityBenefit":"In hospital: Unlimited\\nOut of hospital:�(Subject to registration on maternity programme)\\n12 Antenatal visits\\n2 Paediatric visit in baby�s first year\\nOnline antenatal and postnatal classes \\nOnline video consult with lactation specialist\\nList of blood tests \\nDoula benefit: 2 visits per pregnancy \\n1 Nurse home visit day after discharge from hospital, plus 2 weeks and 6 weeks after initial visit\\n2 scans. 3D/4D scans are covered at 2D scan price ","dialysis":"Unlimited, subject to management programme. Treatment must be obtained from State facilities","cancer":"R400 000 per beneficiary with a 20% co-payment thereafter, subject to management programme from an oncologist authorised by the Scheme","transplant":"Recipient - unlimited\\nDonor - R23 300 for cadaver costs and R47 100 for live donor costs (incl. transportation)","mri":"In and out of hospital: Unlimited\\nR2 480 co-payment applies ","prosthesisInternal":"Cochlear implants: R181 700 per beneficiary \\nIntraocular lenses: R7 250 per beneficiary per event max 2 events per year\\nOther internal prostheses: R55 000 per beneficiary per event max 2 events per year","prosthesisExternal":"External prosthesis: R24 900 per family\\nAppliances: \\n- In Hospital: R7 150 per family per year\\n- Out of Hospital: Subject to available Savings ","rehab":"R57 500 per family ","designatedServiceProvider":"State","conditionsCovered":"CDL in PMB + 6 conditions","formulary":"State","partialLimits":"Unlimited for CDL conditions -\\nadditional 6 conditions - R11 100 per family \\n","preferredProvider":"None","overallAnualLimit":"N/A","medicationOverCounter":"Subject to available Savings","medicationPrescribed":"Subject to available Savings","practitionersGeneral":"Subject to available Savings\\n\\nVirtual GP support:\\nMembers have free, unlimited access to doctors via Hello Doctor, on their phone, anytime, anywhere, in any official South African language, within an hour. Members can speak to the doctor over the phone or chat via text message. They can also get free daily advice with Hello Doctor�s Health Tips and health coaching. Hello Doctor can now prescribe medicine and issue sick notes, where appropriate. Prescribed medicine is covered from HealthSaver, if available.","specialistsCover":"Subject to available Savings","dentistryCover":"Subject to available Savings","dentistryCoverSpecial":"Subject to HealthSaver+, if available\\n\\nExtraction of impacted wisdom teeth in Dr's rooms: Dental specialist accounts - Paid from Risk benefit at 100% of  Scheme Rate, subject to R1 500 co-payment and pre-authorisation\\n\\nOther specialised dentistry: Subject to Savings, if available ","optical":"Subject to available Savings","ambulance":"National: Netcare 911 \\nInternational: ISOS","international":"R8 million emergency cover per 90 day journey incl. R15 500 cover for emergency optometry and dentistry. R765 000 terrorism cover. R1 850 co-payment per claim","hospitalCoverAids":"HIV related admissions: R78 600 per family ","artTtreatment":"Unlimited, at chosen network provider","preventative":"Health Platform benefits\\n\\nEarly detection \\n- Health assessment\\n- Dental check-up\\n- Mammograms\\n- Pap smear consultation and test\\n- Prostate test\\n- General physical examination\\n- DEXA scan\\n- Glaucoma test\\n- Pathology tests: HIV, cholesterol and blood sugar\\n\\nPreventative care\\n- Flu vaccinations\\n- Baby immunisations\\n- Tetanus diphtheria injection\\n- Pneumococcal vaccine\\n\\nHealth management programmes \\n- Diabetes, Hypertension, HIV/Aids,\\nOncology, Drug and alcohol rehabilitation, Chronic renal failure,\\nOrgan transplants, Cholesterol  \\n\\nHealth education and advice\\n \\n(Refer to member guide for full details)","logo":"momentumMed.png"},{"company":"Momentum","name":"Incentive Option: Any hospitals | Associated chronic","planType":"New generation","coverLevel":"Mid","hospital":"Network","chronic":"Network","serviceType":"Any","familyIncome":"","mainContribution":"R3049","mainCompSavings":"R339","mainTotal":"R3388","dependendContributionAdult":"R2446","dependentCompSavingsAdult":"R272","dependentTotalAdult":"R2718","dependendContributionChild":"R1198","dependentCompSavingsChild":"R133","dependentTotalChild":"R1331","maxChildContribution":"3","mainThreshold":"","dependentThresholdAdult":"","dependentThresholdChild":"","preferedHospitalProvider":"Any hospital","overallLimit":"Unlimited","coPayment":"\\nSpecialised procedures in-hospital:\\nR3 280 co-payment applies\\nSpecialised procedures in day hospital:\\nR1 640 co-payment applies\\nSpecialised procedures done out-of-hospital: paid by Scheme, no co-payment applies\\nCertain specialised procedures done out-of-hospital- paid from available day-to-day benefits, no co-payment applies\\n\\nRefer to brochure for details\\n","rate":"200% Scheme Rate","generalMedicin":"7 days' supply per event","specialist":"Full cover for Associated specialists\\nOther specialists and GPs: 200% of Scheme Rate","dentistSurgical":"Maxillo-facial surgery (excluding implants),  and general anaesthetic for children under 7 years. Paid from Risk, R1 500 co-payment per auth. \\nDental and dental specialist bills subject to available Savings\\n\\nImpacted wisdom teeth :\\nR3 000 co-payment for day hospitals and\\nR5 500 co-payment for other hospitals, per authorisation. Dental, dental specialist and maxillo-facial surgeon accounts paid up to 100% of Scheme Rate\\n","mentalHealth":"Including psychiatry and psychology, drug and alcohol rehabilitation: R41 100 per beneficiary \\n21- day sublimit for alcohol and drug rehab Subject to treatment at preferred provider","radiology":"100% Scheme Rate, unlimited","pathology":"100% Scheme Rate, unlimited","maternityBenefit":"In hospital: Unlimited\\nOut of hospital:�(Subject to registration on maternity programme)\\n12 Antenatal visits\\n2 Paediatric visit in baby�s first year\\nOnline antenatal and postnatal classes \\nOnline video consult with lactation specialist\\nList of blood tests \\nDoula benefit: 2 visits per pregnancy \\n1 Nurse home visit day after discharge from hospital, plus 2 weeks and 6 weeks after initial visit\\n2 scans. 3D/4D scans are covered at 2D scan price ","dialysis":"Unlimited, subject to management programme ","cancer":"R400 000 per beneficiary per year, thereafter a 20% co-payment applies. Subject to management programme ","transplant":"Recipient - unlimited\\nDonor - R23 300 for cadaver costs and R47 100 for live donor costs (incl. transportation)","mri":"In and out of hospital: Unlimited\\nR2 480 co-payment applies ","prosthesisInternal":"Cochlear implants: R181 700 per beneficiary \\nIntraocular lenses: R7 250 per beneficiary per event max 2 events per year\\nOther internal prostheses: R55 000 per beneficiary per event max 2 events per year","prosthesisExternal":"External prosthesis: R24 900 per family\\nAppliances: \\n- In Hospital: R7 150 per family per year\\n- Out of Hospital: Subject to available Savings ","rehab":"R57 500 per family ","designatedServiceProvider":"Associated GPs and Medipost courier pharmacy","conditionsCovered":"CDL in PMB + 6 conditions","formulary":"Entry level ","partialLimits":"Unlimited for CDL conditions -\\nadditional 6 conditions - R11 100 per family \\n","preferredProvider":"None","overallAnualLimit":"N/A","medicationOverCounter":"Subject to available Savings","medicationPrescribed":"Subject to available Savings","practitionersGeneral":"Subject to available Savings\\n\\nVirtual GP support:\\nMembers have free, unlimited access to doctors via Hello Doctor, on their phone, anytime, anywhere, in any official South African language, within an hour. Members can speak to the doctor over the phone or chat via text message. They can also get free daily advice with Hello Doctor�s Health Tips and health coaching. Hello Doctor can now prescribe medicine and issue sick notes, where appropriate. Prescribed medicine is covered from HealthSaver, if available.","specialistsCover":"Subject to available Savings","dentistryCover":"Subject to available Savings","dentistryCoverSpecial":"Subject to HealthSaver+, if available\\n\\nExtraction of impacted wisdom teeth in Dr's rooms: Dental specialist accounts - Paid from Risk benefit at 100% of  Scheme Rate, subject to R1 500 co-payment and pre-authorisation\\n\\nOther specialised dentistry: Subject to Savings, if available ","optical":"Subject to available Savings","ambulance":"National: Netcare 911 \\nInternational: ISOS","international":"R8 million emergency cover per 90 day journey incl. R15 500 cover for emergency optometry and dentistry. R765 000 terrorism cover. R1 850 co-payment per claim","hospitalCoverAids":"HIV related admissions: R78 600 per family ","artTtreatment":"Unlimited, at chosen network provider","preventative":"Health Platform benefits\\n\\nEarly detection \\n- Health assessment\\n- Dental check-up\\n- Mammograms\\n- Pap smear consultation and test\\n- Prostate test\\n- General physical examination\\n- DEXA scan\\n- Glaucoma test\\n- Pathology tests: HIV, cholesterol and blood sugar\\n\\nPreventative care\\n- Flu vaccinations\\n- Baby immunisations\\n- Tetanus diphtheria injection\\n- Pneumococcal vaccine\\n\\nHealth management programmes \\n- Diabetes, Hypertension, HIV/Aids,\\nOncology, Drug and alcohol rehabilitation, Chronic renal failure,\\nOrgan transplants, Cholesterol  \\n\\nHealth education and advice\\n \\n(Refer to member guide for full details)","logo":"momentumMed.png"},{"company":"Momentum","name":"Incentive Option: Any hospitals | Any chronic ","planType":"New generation","coverLevel":"Mid","hospital":"Any","chronic":"Any","serviceType":"Any","familyIncome":"","mainContribution":"R3509","mainCompSavings":"R390","mainTotal":"R3899","dependendContributionAdult":"R2851","dependentCompSavingsAdult":"R317","dependentTotalAdult":"R3168","dependendContributionChild":"R1368","dependentCompSavingsChild":"R152","dependentTotalChild":"R1520","maxChildContribution":"3","mainThreshold":"","dependentThresholdAdult":"","dependentThresholdChild":"","preferedHospitalProvider":"Any hospital","overallLimit":"Unlimited","coPayment":"Specialised procedures in-hospital:\\nR3 280 co-payment applies\\nSpecialised procedures in day hospital:\\nR1 640 co-payment applies\\nSpecialised procedures done out-of-hospital: paid by Scheme, no co-payment applies\\nCertain specialised procedures done out-of-hospital- paid from available day-to-day benefits, no co-payment applies\\n\\nRefer to brochure for details\\n","rate":"200% Scheme Rate","generalMedicin":"7 days' supply per event","specialist":"Full cover for Associated specialists\\nOther specialists and GPs: 200% of Scheme Rate","dentistSurgical":"Maxillo-facial surgery (excluding implants),  and general anaesthetic for children under 7 years. Paid from Risk, R1 500 co-payment per auth. \\nDental and dental specialist bills subject to available Savings\\n\\nImpacted wisdom teeth :\\nR3 000 co-payment for day hospitals and\\nR5 500 co-payment for other hospitals, per authorisation. Dental, dental specialist and maxillo-facial surgeon accounts paid up to 100% of Scheme Rate\\n","mentalHealth":"Including psychiatry and psychology, drug and alcohol rehabilitation: R41 100 per beneficiary \\n21- day sublimit for alcohol and drug rehab Subject to treatment at preferred provider","radiology":"100% Scheme Rate, unlimited","pathology":"100% Scheme Rate, unlimited","maternityBenefit":"In hospital: Unlimited\\nOut of hospital:�(Subject to registration on maternity programme)\\n12 Antenatal visits\\n2 Paediatric visit in baby�s first year\\nOnline antenatal and postnatal classes \\nOnline video consult with lactation specialist\\nList of blood tests \\nDoula benefit: 2 visits per pregnancy \\n1 Nurse home visit day after discharge from hospital, plus 2 weeks and 6 weeks after initial visit\\n2 scans. 3D/4D scans are covered at 2D scan price ","dialysis":"Unlimited, subject to management programme ","cancer":"R400 000 per beneficiary per year, thereafter a 20% co-payment applies. Subject to management programme ","transplant":"Recipient - unlimited\\nDonor - R23 300 for cadaver costs and R47 100 for live donor costs (incl. transportation)","mri":"In and out of hospital: Unlimited\\nR2 480 co-payment applies ","prosthesisInternal":"Cochlear implants: R181 700 per beneficiary \\nIntraocular lenses: R7 250 per beneficiary per event max 2 events per year\\nOther internal prostheses: R55 000 per beneficiary per event max 2 events per year","prosthesisExternal":"External prosthesis: R24 900 per family\\nAppliances: \\n- In Hospital: R7 150 per family per year\\n- Out of Hospital: Subject to available Savings ","rehab":"R57 500 per family ","designatedServiceProvider":"Any GP and Any pharmacy","conditionsCovered":"CDL in PMB + 6 conditions","formulary":"Standard","partialLimits":"Unlimited for CDL conditions -\\nadditional 6 conditions - R11 100 per family \\n","preferredProvider":"None","overallAnualLimit":"N/A","medicationOverCounter":"Subject to available Savings","medicationPrescribed":"Subject to available Savings","practitionersGeneral":"Subject to available Savings\\n\\nVirtual GP support:\\nMembers have free, unlimited access to doctors via Hello Doctor, on their phone, anytime, anywhere, in any official South African language, within an hour. Members can speak to the doctor over the phone or chat via text message. They can also get free daily advice with Hello Doctor�s Health Tips and health coaching. Hello Doctor can now prescribe medicine and issue sick notes, where appropriate. Prescribed medicine is covered from HealthSaver, if available.","specialistsCover":"Subject to available Savings","dentistryCover":"Subject to available Savings","dentistryCoverSpecial":"Subject to HealthSaver+, if available\\n\\nExtraction of impacted wisdom teeth in Dr's rooms: Dental specialist accounts - Paid from Risk benefit at 100% of  Scheme Rate, subject to R1 500 co-payment and pre-authorisation\\n\\nOther specialised dentistry: Subject to Savings, if available ","optical":"Subject to available Savings","ambulance":"National: Netcare 911 \\nInternational: ISOS","international":"R8 million emergency cover per 90 day journey incl. R15 500 cover for emergency optometry and dentistry. R765 000 terrorism cover. R1 850 co-payment per claim","hospitalCoverAids":"HIV related admissions: R78 600 per family ","artTtreatment":"Unlimited, at chosen network provider","preventative":"Health Platform benefits\\n\\nEarly detection \\n- Health assessment\\n- Dental check-up\\n- Mammograms\\n- Pap smear consultation and test\\n- Prostate test\\n- General physical examination\\n- DEXA scan\\n- Glaucoma test\\n- Pathology tests: HIV, cholesterol and blood sugar\\n\\nPreventative care\\n- Flu vaccinations\\n- Baby immunisations\\n- Tetanus diphtheria injection\\n- Pneumococcal vaccine\\n\\nHealth management programmes \\n- Diabetes, Hypertension, HIV/Aids,\\nOncology, Drug and alcohol rehabilitation, Chronic renal failure,\\nOrgan transplants, Cholesterol  \\n\\nHealth education and advice\\n \\n(Refer to member guide for full details)","logo":"momentumMed.png"},{"company":"Momentum","name":"Ingwe Option: Ingwe State hospitals","planType":"Capitation","coverLevel":"Low","hospital":"State","chronic":"Network","serviceType":"Network","familyIncome":"0 - R775","mainContribution":"R455","mainCompSavings":"R0.00","mainTotal":"R455","dependendContributionAdult":"R455","dependentCompSavingsAdult":"R0.00","dependentTotalAdult":"R455","dependendContributionChild":"R392","dependentCompSavingsChild":"R0.00","dependentTotalChild":"R392","maxChildContribution":"","mainThreshold":"","dependentThresholdAdult":"","dependentThresholdChild":"","preferedHospitalProvider":"State hospitals","overallLimit":"Unlimited","coPayment":"Use of non-DSP hospitals - difference in the cost between State facility charges and the amount charged by the provider member uses","rate":"100% Scheme Rate ","generalMedicin":"7 days' supply per event","specialist":"100% of Scheme Rate ","dentistSurgical":"Maxillo-facial surgery: \\nPMBs only, at State facilities","mentalHealth":"Limited to PMBs at State facilities\\nMaximum of 21 days for drug and alcohol rehabilitation","radiology":"Unlimited, subject to protocols","pathology":"Unlimited, subject to protocols","maternityBenefit":"Natural birth: Unlimited \\nCaesareans: Emergency only\\n\\nSubject to registration on maternity  programme: \\n� 7 antenatal visits\\n� 2 growth scans\\n� 1 nurse home visit after discharge from hospital\\n� List of blood test \\n� 1 Paediatric visit in baby�s first year","dialysis":"Limited to PMBs at State facilities","cancer":"Limited to PMBs at State facilities","transplant":"Limited to PMBs at State facilities","mri":"PMBs at State facilities","prosthesisInternal":"Limited to PMBs at State facilities","prosthesisExternal":"Limited to PMBs at State facilities\\nAppliances in hospital: R5 800 per family ","rehab":"\\nHospice care and private nursing: No benefit   \\nR14 200 per beneficiary for rehabilitation and step-down facilities\\n      ","designatedServiceProvider":"Ingwe Primary Care Network","conditionsCovered":"CDL in PMB ","formulary":"Entry-level formulary","partialLimits":"None","preferredProvider":"Ingwe Primary Care Network","overallAnualLimit":"None","medicationOverCounter":"No benefit","medicationPrescribed":"100% Scheme Rate                                                                         Subject to prescribed formulary","practitionersGeneral":"Unlimited at Network GP, pre-authorisation required from 11th visit\\n1 out-of-network visit per person, maximum of 2 visits per family, with R100 co-payment per visit\\nSubject to authorisation within 72 hours otherwise 30% co-payment applies  \\n\\nVirtual GP support:\\nMembers have free, unlimited access to doctors via Hello Doctor, on their phone, anytime, anywhere, in any official South African language, within an hour. Members can speak to the doctor over the phone or chat via text message. They can also get free daily advice with Hello Doctor�s Health Tips and health coaching. Hello Doctor can now prescribe medicine and issue sick notes, where appropriate. Prescribed medicine is covered from HealthSaver, if available.","specialistsCover":"2 visits per family per annum\\nR1 150 per visit, up to R2 300 per family\\nSubject to referral by Network GP and pre-authorisation","dentistryCover":"1 Consultation per beneficiary, fillings and x-rays as per the list of tariff codes at Network dentists\\n Pre-authorisation required if more than 4 fillings and extractions are required","dentistryCoverSpecial":"No benefit","optical":"1 eye test per person; 1 pair of clear standard or bi-focal lenses and frame per person, every two years, at Network optometrists\\nSpectacles will only be granted if refraction measurement is more than 0.5","ambulance":"Netcare 911","international":"No benefit","hospitalCoverAids":"HIV related admissions: R35 000 per family                                                                            Subject to management programme","artTtreatment":"R34 500 per family per annum subject to management programme","preventative":"Health Platform benefits from Chosen Primary Care Network provider\\n\\nEarly detection \\n- Health assessment\\n- Dental check-up\\n- Pap smear consultation and test\\n- Prostate test\\n- General physical examination\\n- Pathology tests: HIV, cholesterol and blood sugar\\n\\nPreventative care \\n- Flu vaccinations\\n-  Baby immunisations covered in private facilities up to R2 500 in baby's first year, thereafter at DOH baby clinics\\n- Tetanus diphtheria injection\\n\\nHealth management programmes \\n- Diabetes, Hypertension, HIV/Aids, Oncology, Drug and alcohol rehabilitation, Chronic renal failure, Organ transplants, Cholesterol  \\n\\nHealth education and advice\\n \\n(Refer to member guide for full details)\\n","logo":"momentumMed.png"},{"company":"Momentum","name":"Ingwe Option: Ingwe State hospitals","planType":"Capitation","coverLevel":"Low","hospital":"State","chronic":"Network","serviceType":"Network","familyIncome":"R775 - R7 750","mainContribution":"R747","mainCompSavings":"R0.00","mainTotal":"R747","dependendContributionAdult":"R747","dependentCompSavingsAdult":"R0.00","dependentTotalAdult":"R747","dependendContributionChild":"R403","dependentCompSavingsChild":"R0.00","dependentTotalChild":"R403","maxChildContribution":"","mainThreshold":"","dependentThresholdAdult":"","dependentThresholdChild":"","preferedHospitalProvider":"State hospitals","overallLimit":"Unlimited","coPayment":"Use of non-DSP hospitals - difference in the cost between State facility charges and the amount charged by the provider member uses","rate":"100% Scheme Rate ","generalMedicin":"7 days' supply per event","specialist":"100% of Scheme Rate ","dentistSurgical":"Maxillo-facial surgery: \\nPMBs only, at State facilities","mentalHealth":"Limited to PMBs at State facilities\\nMaximum of 21 days for drug and alcohol rehabilitation","radiology":"Unlimited, subject to protocols","pathology":"Unlimited, subject to protocols","maternityBenefit":"Natural birth: Unlimited \\nCaesareans: Emergency only\\n\\nSubject to registration on maternity  programme: \\n� 7 antenatal visits\\n� 2 growth scans\\n� 1 nurse home visit after discharge from hospital\\n� List of blood test \\n� 1 Paediatric visit in baby�s first year","dialysis":"Limited to PMBs at State facilities","cancer":"Limited to PMBs at State facilities","transplant":"Limited to PMBs at State facilities","mri":"PMBs at State facilities","prosthesisInternal":"Limited to PMBs at State facilities","prosthesisExternal":"Limited to PMBs at State facilities\\nAppliances in hospital: R5 800 per family ","rehab":"\\nHospice care and private nursing: No benefit   \\nR14 200 per beneficiary for rehabilitation and step-down facilities\\n      ","designatedServiceProvider":"Ingwe Primary Care Network","conditionsCovered":"CDL in PMB ","formulary":"Entry-level formulary","partialLimits":"None","preferredProvider":"Ingwe Primary Care Network","overallAnualLimit":"None","medicationOverCounter":"No benefit","medicationPrescribed":"100% Scheme Rate                                                                         Subject to prescribed formulary","practitionersGeneral":"Unlimited at Network GP, pre-authorisation required from 11th visit\\n1 out-of-network visit per person, maximum of 2 visits per family, with R100 co-payment per visit\\nSubject to authorisation within 72 hours otherwise 30% co-payment applies  \\n\\nVirtual GP support:\\nMembers have free, unlimited access to doctors via Hello Doctor, on their phone, anytime, anywhere, in any official South African language, within an hour. Members can speak to the doctor over the phone or chat via text message. They can also get free daily advice with Hello Doctor�s Health Tips and health coaching. Hello Doctor can now prescribe medicine and issue sick notes, where appropriate. Prescribed medicine is covered from HealthSaver, if available.","specialistsCover":"2 visits per family per annum\\nR1 150 per visit, up to R2 300 per family\\nSubject to referral by Network GP and pre-authorisation","dentistryCover":"1 Consultation per beneficiary, fillings and x-rays as per the list of tariff codes at Network dentists\\n Pre-authorisation required if more than 4 fillings and extractions are required","dentistryCoverSpecial":"No benefit","optical":"1 eye test per person; 1 pair of clear standard or bi-focal lenses and frame per person, every two years, at Network optometrists\\nSpectacles will only be granted if refraction measurement is more than 0.5","ambulance":"Netcare 911","international":"No benefit","hospitalCoverAids":"HIV related admissions: R35 000 per family                                                                            Subject to management programme","artTtreatment":"R34 500 per family per annum subject to management programme","preventative":"Health Platform benefits from Chosen Primary Care Network provider\\n\\nEarly detection \\n- Health assessment\\n- Dental check-up\\n- Pap smear consultation and test\\n- Prostate test\\n- General physical examination\\n- Pathology tests: HIV, cholesterol and blood sugar\\n\\nPreventative care \\n- Flu vaccinations\\n-  Baby immunisations covered in private facilities up to R2 500 in baby's first year, thereafter at DOH baby clinics\\n- Tetanus diphtheria injection\\n\\nHealth management programmes \\n- Diabetes, Hypertension, HIV/Aids, Oncology, Drug and alcohol rehabilitation, Chronic renal failure, Organ transplants, Cholesterol  \\n\\nHealth education and advice\\n \\n(Refer to member guide for full details)\\n","logo":"momentumMed.png"},{"company":"Momentum","name":"Ingwe Option: Ingwe State hospitals","planType":"Capitation","coverLevel":"Low","hospital":"State","chronic":"Network","serviceType":"Network","familyIncome":"R7 751 - R10250","mainContribution":"R856","mainCompSavings":"R0.00","mainTotal":"R856","dependendContributionAdult":"R856","dependentCompSavingsAdult":"R0.00","dependentTotalAdult":"R856","dependendContributionChild":"R413","dependentCompSavingsChild":"R0.00","dependentTotalChild":"R413","maxChildContribution":"","mainThreshold":"","dependentThresholdAdult":"","dependentThresholdChild":"","preferedHospitalProvider":"State hospitals","overallLimit":"Unlimited","coPayment":"Use of non-DSP hospitals - difference in the cost between State facility charges and the amount charged by the provider member uses","rate":"100% Scheme Rate ","generalMedicin":"7 days' supply per event","specialist":"100% of Scheme Rate ","dentistSurgical":"Maxillo-facial surgery: \\nPMBs only, at State facilities","mentalHealth":"Limited to PMBs at State facilities\\nMaximum of 21 days for drug and alcohol rehabilitation","radiology":"Unlimited, subject to protocols","pathology":"Unlimited, subject to protocols","maternityBenefit":"Natural birth: Unlimited \\nCaesareans: Emergency only\\n\\nSubject to registration on maternity  programme: \\n� 7 antenatal visits\\n� 2 growth scans\\n� 1 nurse home visit after discharge from hospital\\n� List of blood test \\n� 1 Paediatric visit in baby�s first year","dialysis":"Limited to PMBs at State facilities","cancer":"Limited to PMBs at State facilities","transplant":"Limited to PMBs at State facilities","mri":"PMBs at State facilities","prosthesisInternal":"Limited to PMBs at State facilities","prosthesisExternal":"Limited to PMBs at State facilities\\nAppliances in hospital: R5 800 per family ","rehab":"\\nHospice care and private nursing: No benefit   \\nR14 200 per beneficiary for rehabilitation and step-down facilities\\n      ","designatedServiceProvider":"Ingwe Primary Care Network","conditionsCovered":"CDL in PMB ","formulary":"Entry-level formulary","partialLimits":"None","preferredProvider":"Ingwe Primary Care Network","overallAnualLimit":"None","medicationOverCounter":"No benefit","medicationPrescribed":"100% Scheme Rate                                                                         Subject to prescribed formulary","practitionersGeneral":"Unlimited at Network GP, pre-authorisation required from 11th visit\\n1 out-of-network visit per person, maximum of 2 visits per family, with R100 co-payment per visit\\nSubject to authorisation within 72 hours otherwise 30% co-payment applies  \\n\\nVirtual GP support:\\nMembers have free, unlimited access to doctors via Hello Doctor, on their phone, anytime, anywhere, in any official South African language, within an hour. Members can speak to the doctor over the phone or chat via text message. They can also get free daily advice with Hello Doctor�s Health Tips and health coaching. Hello Doctor can now prescribe medicine and issue sick notes, where appropriate. Prescribed medicine is covered from HealthSaver, if available.","specialistsCover":"2 visits per family per annum\\nR1 150 per visit, up to R2 300 per family\\nSubject to referral by Network GP and pre-authorisation","dentistryCover":"1 Consultation per beneficiary, fillings and x-rays as per the list of tariff codes at Network dentists\\n Pre-authorisation required if more than 4 fillings and extractions are required","dentistryCoverSpecial":"No benefit","optical":"1 eye test per person; 1 pair of clear standard or bi-focal lenses and frame per person, every two years, at Network optometrists\\nSpectacles will only be granted if refraction measurement is more than 0.5","ambulance":"Netcare 911","international":"No benefit","hospitalCoverAids":"HIV related admissions: R35 000 per family                                                                            Subject to management programme","artTtreatment":"R34 500 per family per annum subject to management programme","preventative":"Health Platform benefits from Chosen Primary Care Network provider\\n\\nEarly detection \\n- Health assessment\\n- Dental check-up\\n- Pap smear consultation and test\\n- Prostate test\\n- General physical examination\\n- Pathology tests: HIV, cholesterol and blood sugar\\n\\nPreventative care \\n- Flu vaccinations\\n-  Baby immunisations covered in private facilities up to R2 500 in baby's first year, thereafter at DOH baby clinics\\n- Tetanus diphtheria injection\\n\\nHealth management programmes \\n- Diabetes, Hypertension, HIV/Aids, Oncology, Drug and alcohol rehabilitation, Chronic renal failure, Organ transplants, Cholesterol  \\n\\nHealth education and advice\\n \\n(Refer to member guide for full details)\\n","logo":"momentumMed.png"},{"company":"Momentum","name":"Ingwe Option: Ingwe State hospitals","planType":"Capitation","coverLevel":"Low","hospital":"State","chronic":"Network","serviceType":"Network","familyIncome":"R10250 - R14600","mainContribution":"R999","mainCompSavings":"R0.00","mainTotal":"R999","dependendContributionAdult":"R999","dependentCompSavingsAdult":"R0.00","dependentTotalAdult":"R999","dependendContributionChild":"R432","dependentCompSavingsChild":"R0.00","dependentTotalChild":"R432","maxChildContribution":"","mainThreshold":"","dependentThresholdAdult":"","dependentThresholdChild":"","preferedHospitalProvider":"State hospitals","overallLimit":"Unlimited","coPayment":"Use of non-DSP hospitals - difference in the cost between State facility charges and the amount charged by the provider member uses","rate":"100% Scheme Rate ","generalMedicin":"7 days' supply per event","specialist":"100% of Scheme Rate ","dentistSurgical":"Maxillo-facial surgery: \\nPMBs only, at State facilities","mentalHealth":"Limited to PMBs at State facilities\\nMaximum of 21 days for drug and alcohol rehabilitation","radiology":"Unlimited, subject to protocols","pathology":"Unlimited, subject to protocols","maternityBenefit":"Natural birth: Unlimited \\nCaesareans: Emergency only\\n\\nSubject to registration on maternity  programme: \\n� 7 antenatal visits\\n� 2 growth scans\\n� 1 nurse home visit after discharge from hospital\\n� List of blood test \\n� 1 Paediatric visit in baby�s first year","dialysis":"Limited to PMBs at State facilities","cancer":"Limited to PMBs at State facilities","transplant":"Limited to PMBs at State facilities","mri":"PMBs at State facilities","prosthesisInternal":"Limited to PMBs at State facilities","prosthesisExternal":"Limited to PMBs at State facilities\\nAppliances in hospital: R5 800 per family ","rehab":"\\nHospice care and private nursing: No benefit   \\nR14 200 per beneficiary for rehabilitation and step-down facilities\\n      ","designatedServiceProvider":"Ingwe Primary Care Network","conditionsCovered":"CDL in PMB ","formulary":"Entry-level formulary","partialLimits":"None","preferredProvider":"Ingwe Primary Care Network","overallAnualLimit":"None","medicationOverCounter":"No benefit","medicationPrescribed":"100% Scheme Rate                                                                         Subject to prescribed formulary","practitionersGeneral":"Unlimited at Network GP, pre-authorisation required from 11th visit\\n1 out-of-network visit per person, maximum of 2 visits per family, with R100 co-payment per visit\\nSubject to authorisation within 72 hours otherwise 30% co-payment applies  \\n\\nVirtual GP support:\\nMembers have free, unlimited access to doctors via Hello Doctor, on their phone, anytime, anywhere, in any official South African language, within an hour. Members can speak to the doctor over the phone or chat via text message. They can also get free daily advice with Hello Doctor�s Health Tips and health coaching. Hello Doctor can now prescribe medicine and issue sick notes, where appropriate. Prescribed medicine is covered from HealthSaver, if available.","specialistsCover":"2 visits per family per annum\\nR1 150 per visit, up to R2 300 per family\\nSubject to referral by Network GP and pre-authorisation","dentistryCover":"1 Consultation per beneficiary, fillings and x-rays as per the list of tariff codes at Network dentists\\n Pre-authorisation required if more than 4 fillings and extractions are required","dentistryCoverSpecial":"No benefit","optical":"1 eye test per person; 1 pair of clear standard or bi-focal lenses and frame per person, every two years, at Network optometrists\\nSpectacles will only be granted if refraction measurement is more than 0.5","ambulance":"Netcare 911","international":"No benefit","hospitalCoverAids":"HIV related admissions: R35 000 per family                                                                            Subject to management programme","artTtreatment":"R34 500 per family per annum subject to management programme","preventative":"Health Platform benefits from Chosen Primary Care Network provider\\n\\nEarly detection \\n- Health assessment\\n- Dental check-up\\n- Pap smear consultation and test\\n- Prostate test\\n- General physical examination\\n- Pathology tests: HIV, cholesterol and blood sugar\\n\\nPreventative care \\n- Flu vaccinations\\n-  Baby immunisations covered in private facilities up to R2 500 in baby's first year, thereafter at DOH baby clinics\\n- Tetanus diphtheria injection\\n\\nHealth management programmes \\n- Diabetes, Hypertension, HIV/Aids, Oncology, Drug and alcohol rehabilitation, Chronic renal failure, Organ transplants, Cholesterol  \\n\\nHealth education and advice\\n \\n(Refer to member guide for full details)\\n","logo":"momentumMed.png"},{"company":"Momentum","name":"Ingwe Option: Ingwe State hospitals","planType":"Capitation","coverLevel":"Low","hospital":"State","chronic":"Network","serviceType":"Network","familyIncome":"R14 601+","mainContribution":"R1726","mainCompSavings":"R0.00","mainTotal":"R1726","dependendContributionAdult":"R1726","dependentCompSavingsAdult":"R0.00","dependentTotalAdult":"R1726","dependendContributionChild":"R519","dependentCompSavingsChild":"R0.00","dependentTotalChild":"R519","maxChildContribution":"","mainThreshold":"","dependentThresholdAdult":"","dependentThresholdChild":"","preferedHospitalProvider":"State hospitals","overallLimit":"Unlimited","coPayment":"Use of non-DSP hospitals - difference in the cost between State facility charges and the amount charged by the provider member uses","rate":"100% Scheme Rate ","generalMedicin":"7 days' supply per event","specialist":"100% of Scheme Rate ","dentistSurgical":"Maxillo-facial surgery: \\nPMBs only, at State facilities","mentalHealth":"Limited to PMBs at State facilities\\nMaximum of 21 days for drug and alcohol rehabilitation","radiology":"Unlimited, subject to protocols","pathology":"Unlimited, subject to protocols","maternityBenefit":"Natural birth: Unlimited \\nCaesareans: Emergency only\\n\\nSubject to registration on maternity  programme: \\n� 7 antenatal visits\\n� 2 growth scans\\n� 1 nurse home visit after discharge from hospital\\n� List of blood test \\n� 1 Paediatric visit in baby�s first year","dialysis":"Limited to PMBs at State facilities","cancer":"Limited to PMBs at State facilities","transplant":"Limited to PMBs at State facilities","mri":"PMBs at State facilities","prosthesisInternal":"Limited to PMBs at State facilities","prosthesisExternal":"Limited to PMBs at State facilities\\nAppliances in hospital: R5 800 per family ","rehab":"\\nHospice care and private nursing: No benefit   \\nR14 200 per beneficiary for rehabilitation and step-down facilities\\n      ","designatedServiceProvider":"Ingwe Primary Care Network","conditionsCovered":"CDL in PMB ","formulary":"Entry-level formulary","partialLimits":"None","preferredProvider":"Ingwe Primary Care Network","overallAnualLimit":"None","medicationOverCounter":"No benefit","medicationPrescribed":"100% Scheme Rate                                                                         Subject to prescribed formulary","practitionersGeneral":"Unlimited at Network GP, pre-authorisation required from 11th visit\\n1 out-of-network visit per person, maximum of 2 visits per family, with R100 co-payment per visit\\nSubject to authorisation within 72 hours otherwise 30% co-payment applies  \\n\\nVirtual GP support:\\nMembers have free, unlimited access to doctors via Hello Doctor, on their phone, anytime, anywhere, in any official South African language, within an hour. Members can speak to the doctor over the phone or chat via text message. They can also get free daily advice with Hello Doctor�s Health Tips and health coaching. Hello Doctor can now prescribe medicine and issue sick notes, where appropriate. Prescribed medicine is covered from HealthSaver, if available.","specialistsCover":"2 visits per family per annum\\nR1 150 per visit, up to R2 300 per family\\nSubject to referral by Network GP and pre-authorisation","dentistryCover":"1 Consultation per beneficiary, fillings and x-rays as per the list of tariff codes at Network dentists\\n Pre-authorisation required if more than 4 fillings and extractions are required","dentistryCoverSpecial":"No benefit","optical":"1 eye test per person; 1 pair of clear standard or bi-focal lenses and frame per person, every two years, at Network optometrists\\nSpectacles will only be granted if refraction measurement is more than 0.5","ambulance":"Netcare 911","international":"No benefit","hospitalCoverAids":"HIV related admissions: R35 000 per family                                                                            Subject to management programme","artTtreatment":"R34 500 per family per annum subject to management programme","preventative":"Health Platform benefits from Chosen Primary Care Network provider\\n\\nEarly detection \\n- Health assessment\\n- Dental check-up\\n- Pap smear consultation and test\\n- Prostate test\\n- General physical examination\\n- Pathology tests: HIV, cholesterol and blood sugar\\n\\nPreventative care \\n- Flu vaccinations\\n-  Baby immunisations covered in private facilities up to R2 500 in baby's first year, thereafter at DOH baby clinics\\n- Tetanus diphtheria injection\\n\\nHealth management programmes \\n- Diabetes, Hypertension, HIV/Aids, Oncology, Drug and alcohol rehabilitation, Chronic renal failure, Organ transplants, Cholesterol  \\n\\nHealth education and advice\\n \\n(Refer to member guide for full details)\\n","logo":"momentumMed.png"},{"company":"Momentum","name":"Ingwe Option: Ingwe Network hospitals","planType":"Capitation","coverLevel":"Low","hospital":"Network","chronic":"Network","serviceType":"Network","familyIncome":"0 - R775","mainContribution":"R455","mainCompSavings":"R0.00","mainTotal":"R455","dependendContributionAdult":"R455","dependentCompSavingsAdult":"R0.00","dependentTotalAdult":"R455","dependendContributionChild":"R410","dependentCompSavingsChild":"R0.00","dependentTotalChild":"R410","maxChildContribution":"","mainThreshold":"","dependentThresholdAdult":"","dependentThresholdChild":"","preferedHospitalProvider":"Ingwe Network hospitals","overallLimit":"Unlimited","coPayment":"Use of non-Network hospitals - 30% of the hospital account","rate":"100% Scheme Rate ","generalMedicin":"7 days' supply per event","specialist":"100% of Scheme Rate ","dentistSurgical":"Maxillo-facial surgery: \\nPMBs only, at State facilities","mentalHealth":"Limited to PMBs at State facilities\\nMaximum of 21 days for drug and alcohol rehabilitation","radiology":"Unlimited, subject to protocols","pathology":"Unlimited, subject to protocols","maternityBenefit":"Natural birth: Unlimited \\nCaesareans: Emergency only\\n\\nSubject to registration on maternity  programme: \\n� 7 antenatal visits\\n� 2 growth scans\\n� 1 nurse home visit after discharge from hospital\\n� List of blood test \\n� 1 Paediatric visit in baby�s first year","dialysis":"Limited to PMBs at State facilities","cancer":"Limited to PMBs at State facilities","transplant":"Limited to PMBs at State facilities","mri":"PMBs at State facilities","prosthesisInternal":"Limited to PMBs at State facilities","prosthesisExternal":"Limited to PMBs at State facilities\\nAppliances in hospital: R5 800 per family ","rehab":"\\nHospice care and private nursing: No benefit   \\nR14 200 per beneficiary for rehabilitation and step-down facilities\\n      ","designatedServiceProvider":"Ingwe Primary Care Network","conditionsCovered":"CDL in PMB ","formulary":"Entry-level formulary","partialLimits":"None","preferredProvider":"Ingwe Primary Care Network","overallAnualLimit":"None","medicationOverCounter":"No benefit","medicationPrescribed":"100% Scheme Rate                                                                         Subject to prescribed formulary","practitionersGeneral":"Unlimited at Network GP, pre-authorisation required from 11th visit\\n1 out-of-network visit per person, maximum of 2 visits per family, with R100 co-payment per visit\\nSubject to authorisation within 72 hours otherwise 30% co-payment applies  \\n\\nVirtual GP support:\\nMembers have free, unlimited access to doctors via Hello Doctor, on their phone, anytime, anywhere, in any official South African language, within an hour. Members can speak to the doctor over the phone or chat via text message. They can also get free daily advice with Hello Doctor�s Health Tips and health coaching. Hello Doctor can now prescribe medicine and issue sick notes, where appropriate. Prescribed medicine is covered from HealthSaver, if available.","specialistsCover":"2 visits per family per annum\\nR1 150 per visit, up to R2 300 per family\\nSubject to referral by Network GP and pre-authorisation","dentistryCover":"1 Consultation per beneficiary, fillings and x-rays as per the list of tariff codes at Network dentists\\n Pre-authorisation required if more than 4 fillings and extractions are required","dentistryCoverSpecial":"No benefit","optical":"1 eye test per person; 1 pair of clear standard or bi-focal lenses and frame per person, every two years, at Network optometrists\\nSpectacles will only be granted if refraction measurement is more than 0.5","ambulance":"Netcare 911","international":"No benefit","hospitalCoverAids":"HIV related admissions: R35 000 per family                                                                            Subject to management programme","artTtreatment":"R34 500 per family per annum subject to management programme","preventative":"Health Platform benefits from Chosen Primary Care Network provider\\n\\nEarly detection \\n- Health assessment\\n- Dental check-up\\n- Pap smear consultation and test\\n- Prostate test\\n- General physical examination\\n- Pathology tests: HIV, cholesterol and blood sugar\\n\\nPreventative care \\n- Flu vaccinations\\n-  Baby immunisations covered in private facilities up to R2 500 in baby's first year, thereafter at DOH baby clinics\\n- Tetanus diphtheria injection\\n\\nHealth management programmes \\n- Diabetes, Hypertension, HIV/Aids, Oncology, Drug and alcohol rehabilitation, Chronic renal failure, Organ transplants, Cholesterol  \\n\\nHealth education and advice\\n \\n(Refer to member guide for full details)\\n","logo":"momentumMed.png"},{"company":"Momentum","name":"Ingwe Option: Ingwe Network hospitals","planType":"Capitation","coverLevel":"Low","hospital":"Network","chronic":"Network","serviceType":"Network","familyIncome":"R775 - R7 750","mainContribution":"R940","mainCompSavings":"R0.00","mainTotal":"R940","dependendContributionAdult":"R940","dependentCompSavingsAdult":"R0.00","dependentTotalAdult":"R940","dependendContributionChild":"R430","dependentCompSavingsChild":"R0.00","dependentTotalChild":"R430","maxChildContribution":"","mainThreshold":"","dependentThresholdAdult":"","dependentThresholdChild":"","preferedHospitalProvider":"Ingwe Network hospitals","overallLimit":"Unlimited","coPayment":"Use of non-Network hospitals - 30% of the hospital account","rate":"100% Scheme Rate ","generalMedicin":"7 days' supply per event","specialist":"100% of Scheme Rate ","dentistSurgical":"Maxillo-facial surgery: \\nPMBs only, at State facilities","mentalHealth":"Limited to PMBs at State facilities\\nMaximum of 21 days for drug and alcohol rehabilitation","radiology":"Unlimited, subject to protocols","pathology":"Unlimited, subject to protocols","maternityBenefit":"Natural birth: Unlimited \\nCaesareans: Emergency only\\n\\nSubject to registration on maternity  programme: \\n� 7 antenatal visits\\n� 2 growth scans\\n� 1 nurse home visit after discharge from hospital\\n� List of blood test \\n� 1 Paediatric visit in baby�s first year","dialysis":"Limited to PMBs at State facilities","cancer":"Limited to PMBs at State facilities","transplant":"Limited to PMBs at State facilities","mri":"PMBs at State facilities","prosthesisInternal":"Limited to PMBs at State facilities","prosthesisExternal":"Limited to PMBs at State facilities\\nAppliances in hospital: R5 800 per family ","rehab":"\\nHospice care and private nursing: No benefit   \\nR14 200 per beneficiary for rehabilitation and step-down facilities\\n      ","designatedServiceProvider":"Ingwe Primary Care Network","conditionsCovered":"CDL in PMB ","formulary":"Entry-level formulary","partialLimits":"None","preferredProvider":"Ingwe Primary Care Network","overallAnualLimit":"None","medicationOverCounter":"No benefit","medicationPrescribed":"100% Scheme Rate                                                                         Subject to prescribed formulary","practitionersGeneral":"Unlimited at Network GP, pre-authorisation required from 11th visit\\n1 out-of-network visit per person, maximum of 2 visits per family, with R100 co-payment per visit\\nSubject to authorisation within 72 hours otherwise 30% co-payment applies  \\n\\nVirtual GP support:\\nMembers have free, unlimited access to doctors via Hello Doctor, on their phone, anytime, anywhere, in any official South African language, within an hour. Members can speak to the doctor over the phone or chat via text message. They can also get free daily advice with Hello Doctor�s Health Tips and health coaching. Hello Doctor can now prescribe medicine and issue sick notes, where appropriate. Prescribed medicine is covered from HealthSaver, if available.","specialistsCover":"2 visits per family per annum\\nR1 150 per visit, up to R2 300 per family\\nSubject to referral by Network GP and pre-authorisation","dentistryCover":"1 Consultation per beneficiary, fillings and x-rays as per the list of tariff codes at Network dentists\\n Pre-authorisation required if more than 4 fillings and extractions are required","dentistryCoverSpecial":"No benefit","optical":"1 eye test per person; 1 pair of clear standard or bi-focal lenses and frame per person, every two years, at Network optometrists\\nSpectacles will only be granted if refraction measurement is more than 0.5","ambulance":"Netcare 911","international":"No benefit","hospitalCoverAids":"HIV related admissions: R35 000 per family                                                                            Subject to management programme","artTtreatment":"R34 500 per family per annum subject to management programme","preventative":"Health Platform benefits from Chosen Primary Care Network provider\\n\\nEarly detection \\n- Health assessment\\n- Dental check-up\\n- Pap smear consultation and test\\n- Prostate test\\n- General physical examination\\n- Pathology tests: HIV, cholesterol and blood sugar\\n\\nPreventative care \\n- Flu vaccinations\\n-  Baby immunisations covered in private facilities up to R2 500 in baby's first year, thereafter at DOH baby clinics\\n- Tetanus diphtheria injection\\n\\nHealth management programmes \\n- Diabetes, Hypertension, HIV/Aids, Oncology, Drug and alcohol rehabilitation, Chronic renal failure, Organ transplants, Cholesterol  \\n\\nHealth education and advice\\n \\n(Refer to member guide for full details)\\n","logo":"momentumMed.png"},{"company":"Momentum","name":"Ingwe Option: Ingwe Network hospitals","planType":"Capitation","coverLevel":"Low","hospital":"Network","chronic":"Network","serviceType":"Network","familyIncome":"R7 751 - R10250","mainContribution":"R1196","mainCompSavings":"R0.00","mainTotal":"R1196","dependendContributionAdult":"R1196","dependentCompSavingsAdult":"R0.00","dependentTotalAdult":"R1196","dependendContributionChild":"R447","dependentCompSavingsChild":"R0.00","dependentTotalChild":"R447","maxChildContribution":"","mainThreshold":"","dependentThresholdAdult":"","dependentThresholdChild":"","preferedHospitalProvider":"Ingwe Network hospitals","overallLimit":"Unlimited","coPayment":"Use of non-Network hospitals - 30% of the hospital account","rate":"100% Scheme Rate ","generalMedicin":"7 days' supply per event","specialist":"100% of Scheme Rate ","dentistSurgical":"Maxillo-facial surgery: \\nPMBs only, at State facilities","mentalHealth":"Limited to PMBs at State facilities\\nMaximum of 21 days for drug and alcohol rehabilitation","radiology":"Unlimited, subject to protocols","pathology":"Unlimited, subject to protocols","maternityBenefit":"Natural birth: Unlimited \\nCaesareans: Emergency only\\n\\nSubject to registration on maternity  programme: \\n� 7 antenatal visits\\n� 2 growth scans\\n� 1 nurse home visit after discharge from hospital\\n� List of blood test \\n� 1 Paediatric visit in baby�s first year","dialysis":"Limited to PMBs at State facilities","cancer":"Limited to PMBs at State facilities","transplant":"Limited to PMBs at State facilities","mri":"PMBs at State facilities","prosthesisInternal":"Limited to PMBs at State facilities","prosthesisExternal":"Limited to PMBs at State facilities\\nAppliances in hospital: R5 800 per family ","rehab":"\\nHospice care and private nursing: No benefit   \\nR14 200 per beneficiary for rehabilitation and step-down facilities\\n      ","designatedServiceProvider":"Ingwe Primary Care Network","conditionsCovered":"CDL in PMB ","formulary":"Entry-level formulary","partialLimits":"None","preferredProvider":"Ingwe Primary Care Network","overallAnualLimit":"None","medicationOverCounter":"No benefit","medicationPrescribed":"100% Scheme Rate                                                                         Subject to prescribed formulary","practitionersGeneral":"Unlimited at Network GP, pre-authorisation required from 11th visit\\n1 out-of-network visit per person, maximum of 2 visits per family, with R100 co-payment per visit\\nSubject to authorisation within 72 hours otherwise 30% co-payment applies  \\n\\nVirtual GP support:\\nMembers have free, unlimited access to doctors via Hello Doctor, on their phone, anytime, anywhere, in any official South African language, within an hour. Members can speak to the doctor over the phone or chat via text message. They can also get free daily advice with Hello Doctor�s Health Tips and health coaching. Hello Doctor can now prescribe medicine and issue sick notes, where appropriate. Prescribed medicine is covered from HealthSaver, if available.","specialistsCover":"2 visits per family per annum\\nR1 150 per visit, up to R2 300 per family\\nSubject to referral by Network GP and pre-authorisation","dentistryCover":"1 Consultation per beneficiary, fillings and x-rays as per the list of tariff codes at Network dentists\\n Pre-authorisation required if more than 4 fillings and extractions are required","dentistryCoverSpecial":"No benefit","optical":"1 eye test per person; 1 pair of clear standard or bi-focal lenses and frame per person, every two years, at Network optometrists\\nSpectacles will only be granted if refraction measurement is more than 0.5","ambulance":"Netcare 911","international":"No benefit","hospitalCoverAids":"HIV related admissions: R35 000 per family                                                                            Subject to management programme","artTtreatment":"R34 500 per family per annum subject to management programme","preventative":"Health Platform benefits from Chosen Primary Care Network provider\\n\\nEarly detection \\n- Health assessment\\n- Dental check-up\\n- Pap smear consultation and test\\n- Prostate test\\n- General physical examination\\n- Pathology tests: HIV, cholesterol and blood sugar\\n\\nPreventative care \\n- Flu vaccinations\\n-  Baby immunisations covered in private facilities up to R2 500 in baby's first year, thereafter at DOH baby clinics\\n- Tetanus diphtheria injection\\n\\nHealth management programmes \\n- Diabetes, Hypertension, HIV/Aids, Oncology, Drug and alcohol rehabilitation, Chronic renal failure, Organ transplants, Cholesterol  \\n\\nHealth education and advice\\n \\n(Refer to member guide for full details)\\n","logo":"momentumMed.png"},{"company":"Momentum","name":"Ingwe Option: Ingwe Network hospitals","planType":"Capitation","coverLevel":"Low","hospital":"Network","chronic":"Network","serviceType":"Network","familyIncome":"R10250 - R14600","mainContribution":"R1665","mainCompSavings":"R0.00","mainTotal":"R1665","dependendContributionAdult":"R1665","dependentCompSavingsAdult":"R0.00","dependentTotalAdult":"R1665","dependendContributionChild":"R489","dependentCompSavingsChild":"R0.00","dependentTotalChild":"R489","maxChildContribution":"","mainThreshold":"","dependentThresholdAdult":"","dependentThresholdChild":"","preferedHospitalProvider":"Ingwe Network hospitals","overallLimit":"Unlimited","coPayment":"Use of non-Network hospitals - 30% of the hospital account","rate":"100% Scheme Rate ","generalMedicin":"7 days' supply per event","specialist":"100% of Scheme Rate ","dentistSurgical":"Maxillo-facial surgery: \\nPMBs only, at State facilities","mentalHealth":"Limited to PMBs at State facilities\\nMaximum of 21 days for drug and alcohol rehabilitation","radiology":"Unlimited, subject to protocols","pathology":"Unlimited, subject to protocols","maternityBenefit":"Natural birth: Unlimited \\nCaesareans: Emergency only\\n\\nSubject to registration on maternity  programme: \\n� 7 antenatal visits\\n� 2 growth scans\\n� 1 nurse home visit after discharge from hospital\\n� List of blood test \\n� 1 Paediatric visit in baby�s first year","dialysis":"Limited to PMBs at State facilities","cancer":"Limited to PMBs at State facilities","transplant":"Limited to PMBs at State facilities","mri":"PMBs at State facilities","prosthesisInternal":"Limited to PMBs at State facilities","prosthesisExternal":"Limited to PMBs at State facilities\\nAppliances in hospital: R5 800 per family ","rehab":"\\nHospice care and private nursing: No benefit   \\nR14 200 per beneficiary for rehabilitation and step-down facilities\\n      ","designatedServiceProvider":"Ingwe Primary Care Network","conditionsCovered":"CDL in PMB ","formulary":"Entry-level formulary","partialLimits":"None","preferredProvider":"Ingwe Primary Care Network","overallAnualLimit":"None","medicationOverCounter":"No benefit","medicationPrescribed":"100% Scheme Rate                                                                         Subject to prescribed formulary","practitionersGeneral":"Unlimited at Network GP, pre-authorisation required from 11th visit\\n1 out-of-network visit per person, maximum of 2 visits per family, with R100 co-payment per visit\\nSubject to authorisation within 72 hours otherwise 30% co-payment applies  \\n\\nVirtual GP support:\\nMembers have free, unlimited access to doctors via Hello Doctor, on their phone, anytime, anywhere, in any official South African language, within an hour. Members can speak to the doctor over the phone or chat via text message. They can also get free daily advice with Hello Doctor�s Health Tips and health coaching. Hello Doctor can now prescribe medicine and issue sick notes, where appropriate. Prescribed medicine is covered from HealthSaver, if available.","specialistsCover":"2 visits per family per annum\\nR1 150 per visit, up to R2 300 per family\\nSubject to referral by Network GP and pre-authorisation","dentistryCover":"1 Consultation per beneficiary, fillings and x-rays as per the list of tariff codes at Network dentists\\n Pre-authorisation required if more than 4 fillings and extractions are required","dentistryCoverSpecial":"No benefit","optical":"1 eye test per person; 1 pair of clear standard or bi-focal lenses and frame per person, every two years, at Network optometrists\\nSpectacles will only be granted if refraction measurement is more than 0.5","ambulance":"Netcare 911","international":"No benefit","hospitalCoverAids":"HIV related admissions: R35 000 per family                                                                            Subject to management programme","artTtreatment":"R34 500 per family per annum subject to management programme","preventative":"Health Platform benefits from Chosen Primary Care Network provider\\n\\nEarly detection \\n- Health assessment\\n- Dental check-up\\n- Pap smear consultation and test\\n- Prostate test\\n- General physical examination\\n- Pathology tests: HIV, cholesterol and blood sugar\\n\\nPreventative care \\n- Flu vaccinations\\n-  Baby immunisations covered in private facilities up to R2 500 in baby's first year, thereafter at DOH baby clinics\\n- Tetanus diphtheria injection\\n\\nHealth management programmes \\n- Diabetes, Hypertension, HIV/Aids, Oncology, Drug and alcohol rehabilitation, Chronic renal failure, Organ transplants, Cholesterol  \\n\\nHealth education and advice\\n \\n(Refer to member guide for full details)\\n","logo":"momentumMed.png"},{"company":"Momentum","name":"Ingwe Option: Ingwe Network hospitals","planType":"Capitation","coverLevel":"Low","hospital":"Network","chronic":"Network","serviceType":"Network","familyIncome":"R14 601+","mainContribution":"R2358","mainCompSavings":"R0.00","mainTotal":"R2358","dependendContributionAdult":"R2358","dependentCompSavingsAdult":"R0.00","dependentTotalAdult":"R2358","dependendContributionChild":"R694","dependentCompSavingsChild":"R0.00","dependentTotalChild":"R694","maxChildContribution":"","mainThreshold":"","dependentThresholdAdult":"","dependentThresholdChild":"","preferedHospitalProvider":"Ingwe Network hospitals","overallLimit":"Unlimited","coPayment":"Use of non-Network hospitals - 30% of the hospital account","rate":"100% Scheme Rate ","generalMedicin":"7 days' supply per event","specialist":"100% of Scheme Rate ","dentistSurgical":"Maxillo-facial surgery: \\nPMBs only, at State facilities","mentalHealth":"Limited to PMBs at State facilities\\nMaximum of 21 days for drug and alcohol rehabilitation","radiology":"Unlimited, subject to protocols","pathology":"Unlimited, subject to protocols","maternityBenefit":"Natural birth: Unlimited \\nCaesareans: Emergency only\\n\\nSubject to registration on maternity  programme: \\n� 7 antenatal visits\\n� 2 growth scans\\n� 1 nurse home visit after discharge from hospital\\n� List of blood test \\n� 1 Paediatric visit in baby�s first year","dialysis":"Limited to PMBs at State facilities","cancer":"Limited to PMBs at State facilities","transplant":"Limited to PMBs at State facilities","mri":"PMBs at State facilities","prosthesisInternal":"Limited to PMBs at State facilities","prosthesisExternal":"Limited to PMBs at State facilities\\nAppliances in hospital: R5 800 per family ","rehab":"\\nHospice care and private nursing: No benefit   \\nR14 200 per beneficiary for rehabilitation and step-down facilities\\n      ","designatedServiceProvider":"Ingwe Primary Care Network","conditionsCovered":"CDL in PMB ","formulary":"Entry-level formulary","partialLimits":"None","preferredProvider":"Ingwe Primary Care Network","overallAnualLimit":"None","medicationOverCounter":"No benefit","medicationPrescribed":"100% Scheme Rate                                                                         Subject to prescribed formulary","practitionersGeneral":"Unlimited at Network GP, pre-authorisation required from 11th visit\\n1 out-of-network visit per person, maximum of 2 visits per family, with R100 co-payment per visit\\nSubject to authorisation within 72 hours otherwise 30% co-payment applies  \\n\\nVirtual GP support:\\nMembers have free, unlimited access to doctors via Hello Doctor, on their phone, anytime, anywhere, in any official South African language, within an hour. Members can speak to the doctor over the phone or chat via text message. They can also get free daily advice with Hello Doctor�s Health Tips and health coaching. Hello Doctor can now prescribe medicine and issue sick notes, where appropriate. Prescribed medicine is covered from HealthSaver, if available.","specialistsCover":"2 visits per family per annum\\nR1 150 per visit, up to R2 300 per family\\nSubject to referral by Network GP and pre-authorisation","dentistryCover":"1 Consultation per beneficiary, fillings and x-rays as per the list of tariff codes at Network dentists\\n Pre-authorisation required if more than 4 fillings and extractions are required","dentistryCoverSpecial":"No benefit","optical":"1 eye test per person; 1 pair of clear standard or bi-focal lenses and frame per person, every two years, at Network optometrists\\nSpectacles will only be granted if refraction measurement is more than 0.5","ambulance":"Netcare 911","international":"No benefit","hospitalCoverAids":"HIV related admissions: R35 000 per family                                                                            Subject to management programme","artTtreatment":"R34 500 per family per annum subject to management programme","preventative":"Health Platform benefits from Chosen Primary Care Network provider\\n\\nEarly detection \\n- Health assessment\\n- Dental check-up\\n- Pap smear consultation and test\\n- Prostate test\\n- General physical examination\\n- Pathology tests: HIV, cholesterol and blood sugar\\n\\nPreventative care \\n- Flu vaccinations\\n-  Baby immunisations covered in private facilities up to R2 500 in baby's first year, thereafter at DOH baby clinics\\n- Tetanus diphtheria injection\\n\\nHealth management programmes \\n- Diabetes, Hypertension, HIV/Aids, Oncology, Drug and alcohol rehabilitation, Chronic renal failure, Organ transplants, Cholesterol  \\n\\nHealth education and advice\\n \\n(Refer to member guide for full details)\\n","logo":"momentumMed.png"},{"company":"Momentum","name":"Ingwe Option: Any hospital ","planType":"Capitation","coverLevel":"Low","hospital":"Any","chronic":"Network","serviceType":"Network","familyIncome":"0 - R775","mainContribution":"R455","mainCompSavings":"R0.00","mainTotal":"R455","dependendContributionAdult":"R455","dependentCompSavingsAdult":"R0.00","dependentTotalAdult":"R455","dependendContributionChild":"R455","dependentCompSavingsChild":"R0.00","dependentTotalChild":"R455","maxChildContribution":"","mainThreshold":"","dependentThresholdAdult":"","dependentThresholdChild":"","preferedHospitalProvider":"Any hospital","overallLimit":"Unlimited","coPayment":"No co-payment","rate":"100% Scheme Rate ","generalMedicin":"7 days' supply per event","specialist":"100% of Scheme Rate ","dentistSurgical":"Maxillo-facial surgery: \\nPMBs only, at State facilities","mentalHealth":"Limited to PMBs at State facilities\\nMaximum of 21 days for drug and alcohol rehabilitation","radiology":"Unlimited, subject to protocols","pathology":"Unlimited, subject to protocols","maternityBenefit":"Natural birth: Unlimited \\nCaesareans: Emergency only\\n\\nSubject to registration on maternity  programme: \\n� 7 antenatal visits\\n� 2 growth scans\\n� 1 nurse home visit after discharge from hospital\\n� List of blood test \\n� 1 Paediatric visit in baby�s first year","dialysis":"Limited to PMBs at State facilities","cancer":"Limited to PMBs at State facilities","transplant":"Limited to PMBs at State facilities","mri":"PMBs at State facilities","prosthesisInternal":"Limited to PMBs at State facilities","prosthesisExternal":"Limited to PMBs at State facilities\\nAppliances in hospital: R5 800 per family ","rehab":"\\nHospice care and private nursing: No benefit   \\nR14 200 per beneficiary for rehabilitation and step-down facilities\\n      ","designatedServiceProvider":" Ingwe Active Network ","conditionsCovered":"CDL in PMB ","formulary":"Entry-level formulary","partialLimits":"None","preferredProvider":" Ingwe Active Network ","overallAnualLimit":"None","medicationOverCounter":"No benefit","medicationPrescribed":"100% Scheme Rate                                                                         Subject to prescribed formulary","practitionersGeneral":"Unlimited at Network GP, pre-authorisation required from 11th visit\\n1 out-of-network visit per person, maximum of 2 visits per family, with R100 co-payment per visit\\nSubject to authorisation within 72 hours otherwise 30% co-payment applies  \\n\\nVirtual GP support:\\nMembers have free, unlimited access to doctors via Hello Doctor, on their phone, anytime, anywhere, in any official South African language, within an hour. Members can speak to the doctor over the phone or chat via text message. They can also get free daily advice with Hello Doctor�s Health Tips and health coaching. Hello Doctor can now prescribe medicine and issue sick notes, where appropriate. Prescribed medicine is covered from HealthSaver, if available.","specialistsCover":"2 visits per family per annum\\nR1 150 per visit, up to R2 300 per family\\nSubject to referral by Network GP and pre-authorisation","dentistryCover":"1 Consultation per beneficiary, fillings and x-rays as per the list of tariff codes at Network dentists\\n Pre-authorisation required if more than 4 fillings and extractions are required","dentistryCoverSpecial":"No benefit","optical":"1 eye test per person; 1 pair of clear standard or bi-focal lenses and frame per person, every two years, at Network optometrists\\nSpectacles will only be granted if refraction measurement is more than 0.5","ambulance":"Netcare 911","international":"No benefit","hospitalCoverAids":"HIV related admissions: R35 000 per family                                                                            Subject to management programme","artTtreatment":"R34 500 per family per annum subject to management programme","preventative":"Health Platform benefits from Chosen Primary Care Network provider\\n\\nEarly detection \\n- Health assessment\\n- Dental check-up\\n- Pap smear consultation and test\\n- Prostate test\\n- General physical examination\\n- Pathology tests: HIV, cholesterol and blood sugar\\n\\nPreventative care \\n- Flu vaccinations\\n-  Baby immunisations covered in private facilities up to R2 500 in baby's first year, thereafter at DOH baby clinics\\n- Tetanus diphtheria injection\\n\\nHealth management programmes \\n- Diabetes, Hypertension, HIV/Aids, Oncology, Drug and alcohol rehabilitation, Chronic renal failure, Organ transplants, Cholesterol  \\n\\nHealth education and advice\\n \\n(Refer to member guide for full details)\\n","logo":"momentumMed.png"},{"company":"Momentum","name":"Ingwe Option: Any hospital ","planType":"Capitation","coverLevel":"Low","hospital":"Any","chronic":"Network","serviceType":"Network","familyIncome":"R775 - R7 750","mainContribution":"R1221","mainCompSavings":"R0.00","mainTotal":"R1221","dependendContributionAdult":"R1221","dependentCompSavingsAdult":"R0.00","dependentTotalAdult":"R1221","dependendContributionChild":"R484","dependentCompSavingsChild":"R0.00","dependentTotalChild":"R484","maxChildContribution":"","mainThreshold":"","dependentThresholdAdult":"","dependentThresholdChild":"","preferedHospitalProvider":"Any hospital","overallLimit":"Unlimited","coPayment":"No co-payment","rate":"100% Scheme Rate ","generalMedicin":"7 days' supply per event","specialist":"100% of Scheme Rate ","dentistSurgical":"Maxillo-facial surgery: \\nPMBs only, at State facilities","mentalHealth":"Limited to PMBs at State facilities\\nMaximum of 21 days for drug and alcohol rehabilitation","radiology":"Unlimited, subject to protocols","pathology":"Unlimited, subject to protocols","maternityBenefit":"Natural birth: Unlimited \\nCaesareans: Emergency only\\n\\nSubject to registration on maternity  programme: \\n� 7 antenatal visits\\n� 2 growth scans\\n� 1 nurse home visit after discharge from hospital\\n� List of blood test \\n� 1 Paediatric visit in baby�s first year","dialysis":"Limited to PMBs at State facilities","cancer":"Limited to PMBs at State facilities","transplant":"Limited to PMBs at State facilities","mri":"PMBs at State facilities","prosthesisInternal":"Limited to PMBs at State facilities","prosthesisExternal":"Limited to PMBs at State facilities\\nAppliances in hospital: R5 800 per family ","rehab":"\\nHospice care and private nursing: No benefit   \\nR14 200 per beneficiary for rehabilitation and step-down facilities\\n      ","designatedServiceProvider":" Ingwe Active Network ","conditionsCovered":"CDL in PMB ","formulary":"Entry-level formulary","partialLimits":"None","preferredProvider":" Ingwe Active Network ","overallAnualLimit":"None","medicationOverCounter":"No benefit","medicationPrescribed":"100% Scheme Rate                                                                         Subject to prescribed formulary","practitionersGeneral":"Unlimited at Network GP, pre-authorisation required from 11th visit\\n1 out-of-network visit per person, maximum of 2 visits per family, with R100 co-payment per visit\\nSubject to authorisation within 72 hours otherwise 30% co-payment applies  \\n\\nVirtual GP support:\\nMembers have free, unlimited access to doctors via Hello Doctor, on their phone, anytime, anywhere, in any official South African language, within an hour. Members can speak to the doctor over the phone or chat via text message. They can also get free daily advice with Hello Doctor�s Health Tips and health coaching. Hello Doctor can now prescribe medicine and issue sick notes, where appropriate. Prescribed medicine is covered from HealthSaver, if available.","specialistsCover":"2 visits per family per annum\\nR1 150 per visit, up to R2 300 per family\\nSubject to referral by Network GP and pre-authorisation","dentistryCover":"1 Consultation per beneficiary, fillings and x-rays as per the list of tariff codes at Network dentists\\n Pre-authorisation required if more than 4 fillings and extractions are required","dentistryCoverSpecial":"No benefit","optical":"1 eye test per person; 1 pair of clear standard or bi-focal lenses and frame per person, every two years, at Network optometrists\\nSpectacles will only be granted if refraction measurement is more than 0.5","ambulance":"Netcare 911","international":"No benefit","hospitalCoverAids":"HIV related admissions: R35 000 per family                                                                            Subject to management programme","artTtreatment":"R34 500 per family per annum subject to management programme","preventative":"Health Platform benefits from Chosen Primary Care Network provider\\n\\nEarly detection \\n- Health assessment\\n- Dental check-up\\n- Pap smear consultation and test\\n- Prostate test\\n- General physical examination\\n- Pathology tests: HIV, cholesterol and blood sugar\\n\\nPreventative care \\n- Flu vaccinations\\n-  Baby immunisations covered in private facilities up to R2 500 in baby's first year, thereafter at DOH baby clinics\\n- Tetanus diphtheria injection\\n\\nHealth management programmes \\n- Diabetes, Hypertension, HIV/Aids, Oncology, Drug and alcohol rehabilitation, Chronic renal failure, Organ transplants, Cholesterol  \\n\\nHealth education and advice\\n \\n(Refer to member guide for full details)\\n","logo":"momentumMed.png"},{"company":"Momentum","name":"Ingwe Option: Any hospital ","planType":"Capitation","coverLevel":"Low","hospital":"Any","chronic":"Network","serviceType":"Network","familyIncome":"R7 751 - R10250","mainContribution":"R1708","mainCompSavings":"R0.00","mainTotal":"R1708","dependendContributionAdult":"R1708","dependentCompSavingsAdult":"R0.00","dependentTotalAdult":"R1708","dependendContributionChild":"R516","dependentCompSavingsChild":"R0.00","dependentTotalChild":"R516","maxChildContribution":"","mainThreshold":"","dependentThresholdAdult":"","dependentThresholdChild":"","preferedHospitalProvider":"Any hospital","overallLimit":"Unlimited","coPayment":"No co-payment","rate":"100% Scheme Rate ","generalMedicin":"7 days' supply per event","specialist":"100% of Scheme Rate ","dentistSurgical":"Maxillo-facial surgery: \\nPMBs only, at State facilities","mentalHealth":"Limited to PMBs at State facilities\\nMaximum of 21 days for drug and alcohol rehabilitation","radiology":"Unlimited, subject to protocols","pathology":"Unlimited, subject to protocols","maternityBenefit":"Natural birth: Unlimited \\nCaesareans: Emergency only\\n\\nSubject to registration on maternity  programme: \\n� 7 antenatal visits\\n� 2 growth scans\\n� 1 nurse home visit after discharge from hospital\\n� List of blood test \\n� 1 Paediatric visit in baby�s first year","dialysis":"Limited to PMBs at State facilities","cancer":"Limited to PMBs at State facilities","transplant":"Limited to PMBs at State facilities","mri":"PMBs at State facilities","prosthesisInternal":"Limited to PMBs at State facilities","prosthesisExternal":"Limited to PMBs at State facilities\\nAppliances in hospital: R5 800 per family ","rehab":"\\nHospice care and private nursing: No benefit   \\nR14 200 per beneficiary for rehabilitation and step-down facilities\\n      ","designatedServiceProvider":" Ingwe Active Network ","conditionsCovered":"CDL in PMB ","formulary":"Entry-level formulary","partialLimits":"None","preferredProvider":" Ingwe Active Network ","overallAnualLimit":"None","medicationOverCounter":"No benefit","medicationPrescribed":"100% Scheme Rate                                                                         Subject to prescribed formulary","practitionersGeneral":"Unlimited at Network GP, pre-authorisation required from 11th visit\\n1 out-of-network visit per person, maximum of 2 visits per family, with R100 co-payment per visit\\nSubject to authorisation within 72 hours otherwise 30% co-payment applies  \\n\\nVirtual GP support:\\nMembers have free, unlimited access to doctors via Hello Doctor, on their phone, anytime, anywhere, in any official South African language, within an hour. Members can speak to the doctor over the phone or chat via text message. They can also get free daily advice with Hello Doctor�s Health Tips and health coaching. Hello Doctor can now prescribe medicine and issue sick notes, where appropriate. Prescribed medicine is covered from HealthSaver, if available.","specialistsCover":"2 visits per family per annum\\nR1 150 per visit, up to R2 300 per family\\nSubject to referral by Network GP and pre-authorisation","dentistryCover":"1 Consultation per beneficiary, fillings and x-rays as per the list of tariff codes at Network dentists\\n Pre-authorisation required if more than 4 fillings and extractions are required","dentistryCoverSpecial":"No benefit","optical":"1 eye test per person; 1 pair of clear standard or bi-focal lenses and frame per person, every two years, at Network optometrists\\nSpectacles will only be granted if refraction measurement is more than 0.5","ambulance":"Netcare 911","international":"No benefit","hospitalCoverAids":"HIV related admissions: R35 000 per family                                                                            Subject to management programme","artTtreatment":"R34 500 per family per annum subject to management programme","preventative":"Health Platform benefits from Chosen Primary Care Network provider\\n\\nEarly detection \\n- Health assessment\\n- Dental check-up\\n- Pap smear consultation and test\\n- Prostate test\\n- General physical examination\\n- Pathology tests: HIV, cholesterol and blood sugar\\n\\nPreventative care \\n- Flu vaccinations\\n-  Baby immunisations covered in private facilities up to R2 500 in baby's first year, thereafter at DOH baby clinics\\n- Tetanus diphtheria injection\\n\\nHealth management programmes \\n- Diabetes, Hypertension, HIV/Aids, Oncology, Drug and alcohol rehabilitation, Chronic renal failure, Organ transplants, Cholesterol  \\n\\nHealth education and advice\\n \\n(Refer to member guide for full details)\\n","logo":"momentumMed.png"},{"company":"Momentum","name":"Ingwe Option: Any hospital ","planType":"Capitation","coverLevel":"Low","hospital":"Any","chronic":"Network","serviceType":"Network","familyIncome":"R10250 - R14600","mainContribution":"R2326","mainCompSavings":"R0.00","mainTotal":"R2326","dependendContributionAdult":"R2326","dependentCompSavingsAdult":"R0.00","dependentTotalAdult":"R2326","dependendContributionChild":"R543","dependentCompSavingsChild":"R0.00","dependentTotalChild":"R543","maxChildContribution":"","mainThreshold":"","dependentThresholdAdult":"","dependentThresholdChild":"","preferedHospitalProvider":"Any hospital","overallLimit":"Unlimited","coPayment":"No co-payment","rate":"100% Scheme Rate ","generalMedicin":"7 days' supply per event","specialist":"100% of Scheme Rate ","dentistSurgical":"Maxillo-facial surgery: \\nPMBs only, at State facilities","mentalHealth":"Limited to PMBs at State facilities\\nMaximum of 21 days for drug and alcohol rehabilitation","radiology":"Unlimited, subject to protocols","pathology":"Unlimited, subject to protocols","maternityBenefit":"Natural birth: Unlimited \\nCaesareans: Emergency only\\n\\nSubject to registration on maternity  programme: \\n� 7 antenatal visits\\n� 2 growth scans\\n� 1 nurse home visit after discharge from hospital\\n� List of blood test \\n� 1 Paediatric visit in baby�s first year","dialysis":"Limited to PMBs at State facilities","cancer":"Limited to PMBs at State facilities","transplant":"Limited to PMBs at State facilities","mri":"PMBs at State facilities","prosthesisInternal":"Limited to PMBs at State facilities","prosthesisExternal":"Limited to PMBs at State facilities\\nAppliances in hospital: R5 800 per family ","rehab":"\\nHospice care and private nursing: No benefit   \\nR14 200 per beneficiary for rehabilitation and step-down facilities\\n      ","designatedServiceProvider":" Ingwe Active Network ","conditionsCovered":"CDL in PMB ","formulary":"Entry-level formulary","partialLimits":"None","preferredProvider":" Ingwe Active Network ","overallAnualLimit":"None","medicationOverCounter":"No benefit","medicationPrescribed":"100% Scheme Rate                                                                         Subject to prescribed formulary","practitionersGeneral":"Unlimited at Network GP, pre-authorisation required from 11th visit\\n1 out-of-network visit per person, maximum of 2 visits per family, with R100 co-payment per visit\\nSubject to authorisation within 72 hours otherwise 30% co-payment applies  \\n\\nVirtual GP support:\\nMembers have free, unlimited access to doctors via Hello Doctor, on their phone, anytime, anywhere, in any official South African language, within an hour. Members can speak to the doctor over the phone or chat via text message. They can also get free daily advice with Hello Doctor�s Health Tips and health coaching. Hello Doctor can now prescribe medicine and issue sick notes, where appropriate. Prescribed medicine is covered from HealthSaver, if available.","specialistsCover":"2 visits per family per annum\\nR1 150 per visit, up to R2 300 per family\\nSubject to referral by Network GP and pre-authorisation","dentistryCover":"1 Consultation per beneficiary, fillings and x-rays as per the list of tariff codes at Network dentists\\n Pre-authorisation required if more than 4 fillings and extractions are required","dentistryCoverSpecial":"No benefit","optical":"1 eye test per person; 1 pair of clear standard or bi-focal lenses and frame per person, every two years, at Network optometrists\\nSpectacles will only be granted if refraction measurement is more than 0.5","ambulance":"Netcare 911","international":"No benefit","hospitalCoverAids":"HIV related admissions: R35 000 per family                                                                            Subject to management programme","artTtreatment":"R34 500 per family per annum subject to management programme","preventative":"Health Platform benefits from Chosen Primary Care Network provider\\n\\nEarly detection \\n- Health assessment\\n- Dental check-up\\n- Pap smear consultation and test\\n- Prostate test\\n- General physical examination\\n- Pathology tests: HIV, cholesterol and blood sugar\\n\\nPreventative care \\n- Flu vaccinations\\n-  Baby immunisations covered in private facilities up to R2 500 in baby's first year, thereafter at DOH baby clinics\\n- Tetanus diphtheria injection\\n\\nHealth management programmes \\n- Diabetes, Hypertension, HIV/Aids, Oncology, Drug and alcohol rehabilitation, Chronic renal failure, Organ transplants, Cholesterol  \\n\\nHealth education and advice\\n \\n(Refer to member guide for full details)\\n","logo":"momentumMed.png"},{"company":"Momentum","name":"Ingwe Option: Any hospital ","planType":"Capitation","coverLevel":"Low","hospital":"Any","chronic":"Network","serviceType":"Network","familyIncome":"R14 601+","mainContribution":"R2984","mainCompSavings":"R0.00","mainTotal":"R2984","dependendContributionAdult":"R2984","dependentCompSavingsAdult":"R0.00","dependentTotalAdult":"R2984","dependendContributionChild":"R866","dependentCompSavingsChild":"R0.00","dependentTotalChild":"R866","maxChildContribution":"","mainThreshold":"","dependentThresholdAdult":"","dependentThresholdChild":"","preferedHospitalProvider":"Any hospital","overallLimit":"Unlimited","coPayment":"No co-payment","rate":"100% Scheme Rate ","generalMedicin":"7 days' supply per event","specialist":"100% of Scheme Rate ","dentistSurgical":"Maxillo-facial surgery: \\nPMBs only, at State facilities","mentalHealth":"Limited to PMBs at State facilities\\nMaximum of 21 days for drug and alcohol rehabilitation","radiology":"Unlimited, subject to protocols","pathology":"Unlimited, subject to protocols","maternityBenefit":"Natural birth: Unlimited \\nCaesareans: Emergency only\\n\\nSubject to registration on maternity  programme: \\n� 7 antenatal visits\\n� 2 growth scans\\n� 1 nurse home visit after discharge from hospital\\n� List of blood test \\n� 1 Paediatric visit in baby�s first year","dialysis":"Limited to PMBs at State facilities","cancer":"Limited to PMBs at State facilities","transplant":"Limited to PMBs at State facilities","mri":"PMBs at State facilities","prosthesisInternal":"Limited to PMBs at State facilities","prosthesisExternal":"Limited to PMBs at State facilities\\nAppliances in hospital: R5 800 per family ","rehab":"\\nHospice care and private nursing: No benefit   \\nR14 200 per beneficiary for rehabilitation and step-down facilities\\n      ","designatedServiceProvider":" Ingwe Active Network ","conditionsCovered":"CDL in PMB ","formulary":"Entry-level formulary","partialLimits":"None","preferredProvider":" Ingwe Active Network ","overallAnualLimit":"None","medicationOverCounter":"No benefit","medicationPrescribed":"100% Scheme Rate                                                                         Subject to prescribed formulary","practitionersGeneral":"Unlimited at Network GP, pre-authorisation required from 11th visit\\n1 out-of-network visit per person, maximum of 2 visits per family, with R100 co-payment per visit\\nSubject to authorisation within 72 hours otherwise 30% co-payment applies  \\n\\nVirtual GP support:\\nMembers have free, unlimited access to doctors via Hello Doctor, on their phone, anytime, anywhere, in any official South African language, within an hour. Members can speak to the doctor over the phone or chat via text message. They can also get free daily advice with Hello Doctor�s Health Tips and health coaching. Hello Doctor can now prescribe medicine and issue sick notes, where appropriate. Prescribed medicine is covered from HealthSaver, if available.","specialistsCover":"2 visits per family per annum\\nR1 150 per visit, up to R2 300 per family\\nSubject to referral by Network GP and pre-authorisation","dentistryCover":"1 Consultation per beneficiary, fillings and x-rays as per the list of tariff codes at Network dentists\\n Pre-authorisation required if more than 4 fillings and extractions are required","dentistryCoverSpecial":"No benefit","optical":"1 eye test per person; 1 pair of clear standard or bi-focal lenses and frame per person, every two years, at Network optometrists\\nSpectacles will only be granted if refraction measurement is more than 0.5","ambulance":"Netcare 911","international":"No benefit","hospitalCoverAids":"HIV related admissions: R35 000 per family                                                                            Subject to management programme","artTtreatment":"R34 500 per family per annum subject to management programme","preventative":"Health Platform benefits from Chosen Primary Care Network provider\\n\\nEarly detection \\n- Health assessment\\n- Dental check-up\\n- Pap smear consultation and test\\n- Prostate test\\n- General physical examination\\n- Pathology tests: HIV, cholesterol and blood sugar\\n\\nPreventative care \\n- Flu vaccinations\\n-  Baby immunisations covered in private facilities up to R2 500 in baby's first year, thereafter at DOH baby clinics\\n- Tetanus diphtheria injection\\n\\nHealth management programmes \\n- Diabetes, Hypertension, HIV/Aids, Oncology, Drug and alcohol rehabilitation, Chronic renal failure, Organ transplants, Cholesterol  \\n\\nHealth education and advice\\n \\n(Refer to member guide for full details)\\n","logo":"momentumMed.png"},{"company":"Profmed","name":"ProPinnacle","planType":"Traditional option","coverLevel":"High","hospital":"Any","chronic":"Network","serviceType":"Any","familyIncome":"","mainContribution":"R8741","mainCompSavings":"R0.00","mainTotal":"R8741","dependendContributionAdult":"R8108","dependentCompSavingsAdult":"R0.00","dependentTotalAdult":"R8108","dependendContributionChild":"R2622","dependentCompSavingsChild":"R0.00","dependentTotalChild":"R2622","maxChildContribution":"#N/A","mainThreshold":"","dependentThresholdAdult":"","dependentThresholdChild":"","preferedHospitalProvider":"#N/A","overallLimit":"#N/A","coPayment":"#N/A","rate":"#N/A","generalMedicin":"#N/A","specialist":"#N/A","dentistSurgical":"#N/A","mentalHealth":"#N/A","radiology":"#N/A","pathology":"#N/A","maternityBenefit":"#N/A","dialysis":"#N/A","cancer":"#N/A","transplant":"#N/A","mri":"#N/A","prosthesisInternal":"#N/A","prosthesisExternal":"#N/A","rehab":"#N/A","designatedServiceProvider":"#N/A","conditionsCovered":"#N/A","formulary":"#N/A","partialLimits":"#N/A","preferredProvider":"#N/A","overallAnualLimit":"#N/A","medicationOverCounter":"#N/A","medicationPrescribed":"#N/A","practitionersGeneral":"#N/A","specialistsCover":"#N/A","dentistryCover":"#N/A","dentistryCoverSpecial":"#N/A","optical":"#N/A","ambulance":"#N/A","international":"#N/A","hospitalCoverAids":"#N/A","artTtreatment":"#N/A","preventative":"#N/A","logo":"profmed.jpg"},{"company":"Profmed","name":"ProPinnacle Savvy","planType":"Traditional option","coverLevel":"High","hospital":"Network","chronic":"Network","serviceType":"Any","familyIncome":"","mainContribution":"R7867","mainCompSavings":"R0.00","mainTotal":"R7867","dependendContributionAdult":"R7293","dependentCompSavingsAdult":"R0.00","dependentTotalAdult":"R7293","dependendContributionChild":"R2360","dependentCompSavingsChild":"R0.00","dependentTotalChild":"R2360","maxChildContribution":"#N/A","mainThreshold":"","dependentThresholdAdult":"","dependentThresholdChild":"","preferedHospitalProvider":"#N/A","overallLimit":"#N/A","coPayment":"#N/A","rate":"#N/A","generalMedicin":"#N/A","specialist":"#N/A","dentistSurgical":"#N/A","mentalHealth":"#N/A","radiology":"#N/A","pathology":"#N/A","maternityBenefit":"#N/A","dialysis":"#N/A","cancer":"#N/A","transplant":"#N/A","mri":"#N/A","prosthesisInternal":"#N/A","prosthesisExternal":"#N/A","rehab":"#N/A","designatedServiceProvider":"#N/A","conditionsCovered":"#N/A","formulary":"#N/A","partialLimits":"#N/A","preferredProvider":"#N/A","overallAnualLimit":"#N/A","medicationOverCounter":"#N/A","medicationPrescribed":"#N/A","practitionersGeneral":"#N/A","specialistsCover":"#N/A","dentistryCover":"#N/A","dentistryCoverSpecial":"#N/A","optical":"#N/A","ambulance":"#N/A","international":"#N/A","hospitalCoverAids":"#N/A","artTtreatment":"#N/A","preventative":"#N/A","logo":"profmed.jpg"},{"company":"Profmed","name":"ProSecure Plus","planType":"Traditional option","coverLevel":"Mid","hospital":"Any","chronic":"Network","serviceType":"Any","familyIncome":"","mainContribution":"R4980","mainCompSavings":"R0.00","mainTotal":"R4980","dependendContributionAdult":"R4607","dependentCompSavingsAdult":"R0.00","dependentTotalAdult":"R4607","dependendContributionChild":"R1940","dependentCompSavingsChild":"R0.00","dependentTotalChild":"R1940","maxChildContribution":"#N/A","mainThreshold":"","dependentThresholdAdult":"","dependentThresholdChild":"","preferedHospitalProvider":"#N/A","overallLimit":"#N/A","coPayment":"#N/A","rate":"#N/A","generalMedicin":"#N/A","specialist":"#N/A","dentistSurgical":"#N/A","mentalHealth":"#N/A","radiology":"#N/A","pathology":"#N/A","maternityBenefit":"#N/A","dialysis":"#N/A","cancer":"#N/A","transplant":"#N/A","mri":"#N/A","prosthesisInternal":"#N/A","prosthesisExternal":"#N/A","rehab":"#N/A","designatedServiceProvider":"#N/A","conditionsCovered":"#N/A","formulary":"#N/A","partialLimits":"#N/A","preferredProvider":"#N/A","overallAnualLimit":"#N/A","medicationOverCounter":"#N/A","medicationPrescribed":"#N/A","practitionersGeneral":"#N/A","specialistsCover":"#N/A","dentistryCover":"#N/A","dentistryCoverSpecial":"#N/A","optical":"#N/A","ambulance":"#N/A","international":"#N/A","hospitalCoverAids":"#N/A","artTtreatment":"#N/A","preventative":"#N/A","logo":"profmed.jpg"},{"company":"Profmed","name":"ProSecure Plus Savvy","planType":"Traditional option","coverLevel":"Mid","hospital":"Network","chronic":"Network","serviceType":"Any","familyIncome":"","mainContribution":"R4481","mainCompSavings":"R0.00","mainTotal":"R4481","dependendContributionAdult":"R4174","dependentCompSavingsAdult":"R0.00","dependentTotalAdult":"R4174","dependendContributionChild":"R1747","dependentCompSavingsChild":"R0.00","dependentTotalChild":"R1747","maxChildContribution":"#N/A","mainThreshold":"","dependentThresholdAdult":"","dependentThresholdChild":"","preferedHospitalProvider":"#N/A","overallLimit":"#N/A","coPayment":"#N/A","rate":"#N/A","generalMedicin":"#N/A","specialist":"#N/A","dentistSurgical":"#N/A","mentalHealth":"#N/A","radiology":"#N/A","pathology":"#N/A","maternityBenefit":"#N/A","dialysis":"#N/A","cancer":"#N/A","transplant":"#N/A","mri":"#N/A","prosthesisInternal":"#N/A","prosthesisExternal":"#N/A","rehab":"#N/A","designatedServiceProvider":"#N/A","conditionsCovered":"#N/A","formulary":"#N/A","partialLimits":"#N/A","preferredProvider":"#N/A","overallAnualLimit":"#N/A","medicationOverCounter":"#N/A","medicationPrescribed":"#N/A","practitionersGeneral":"#N/A","specialistsCover":"#N/A","dentistryCover":"#N/A","dentistryCoverSpecial":"#N/A","optical":"#N/A","ambulance":"#N/A","international":"#N/A","hospitalCoverAids":"#N/A","artTtreatment":"#N/A","preventative":"#N/A","logo":"profmed.jpg"},{"company":"Profmed","name":"ProSecure","planType":"Traditional option","coverLevel":"Mid","hospital":"Any","chronic":"Network","serviceType":"Any","familyIncome":"","mainContribution":"R4079","mainCompSavings":"R0.00","mainTotal":"R4079","dependendContributionAdult":"R3777","dependentCompSavingsAdult":"R0.00","dependentTotalAdult":"R3777","dependendContributionChild":"R1594","dependentCompSavingsChild":"R0.00","dependentTotalChild":"R1594","maxChildContribution":"#N/A","mainThreshold":"","dependentThresholdAdult":"","dependentThresholdChild":"","preferedHospitalProvider":"#N/A","overallLimit":"#N/A","coPayment":"#N/A","rate":"#N/A","generalMedicin":"#N/A","specialist":"#N/A","dentistSurgical":"#N/A","mentalHealth":"#N/A","radiology":"#N/A","pathology":"#N/A","maternityBenefit":"#N/A","dialysis":"#N/A","cancer":"#N/A","transplant":"#N/A","mri":"#N/A","prosthesisInternal":"#N/A","prosthesisExternal":"#N/A","rehab":"#N/A","designatedServiceProvider":"#N/A","conditionsCovered":"#N/A","formulary":"#N/A","partialLimits":"#N/A","preferredProvider":"#N/A","overallAnualLimit":"#N/A","medicationOverCounter":"#N/A","medicationPrescribed":"#N/A","practitionersGeneral":"#N/A","specialistsCover":"#N/A","dentistryCover":"#N/A","dentistryCoverSpecial":"#N/A","optical":"#N/A","ambulance":"#N/A","international":"#N/A","hospitalCoverAids":"#N/A","artTtreatment":"#N/A","preventative":"#N/A","logo":"profmed.jpg"},{"company":"Profmed","name":"ProSecure Savvy","planType":"Traditional option","coverLevel":"Mid","hospital":"Network","chronic":"Network","serviceType":"Any","familyIncome":"0 - R11 000","mainContribution":"R2641","mainCompSavings":"R0.00","mainTotal":"R2641","dependendContributionAdult":"R2641","dependentCompSavingsAdult":"R0.00","dependentTotalAdult":"R2641","dependendContributionChild":"R1197","dependentCompSavingsChild":"R0.00","dependentTotalChild":"R1197","maxChildContribution":"#N/A","mainThreshold":"","dependentThresholdAdult":"","dependentThresholdChild":"","preferedHospitalProvider":"#N/A","overallLimit":"#N/A","coPayment":"#N/A","rate":"#N/A","generalMedicin":"#N/A","specialist":"#N/A","dentistSurgical":"#N/A","mentalHealth":"#N/A","radiology":"#N/A","pathology":"#N/A","maternityBenefit":"#N/A","dialysis":"#N/A","cancer":"#N/A","transplant":"#N/A","mri":"#N/A","prosthesisInternal":"#N/A","prosthesisExternal":"#N/A","rehab":"#N/A","designatedServiceProvider":"#N/A","conditionsCovered":"#N/A","formulary":"#N/A","partialLimits":"#N/A","preferredProvider":"#N/A","overallAnualLimit":"#N/A","medicationOverCounter":"#N/A","medicationPrescribed":"#N/A","practitionersGeneral":"#N/A","specialistsCover":"#N/A","dentistryCover":"#N/A","dentistryCoverSpecial":"#N/A","optical":"#N/A","ambulance":"#N/A","international":"#N/A","hospitalCoverAids":"#N/A","artTtreatment":"#N/A","preventative":"#N/A","logo":"profmed.jpg"},{"company":"Profmed","name":"ProSecure Savvy","planType":"Traditional option","coverLevel":"Mid","hospital":"Network","chronic":"Network","serviceType":"Any","familyIncome":"R11 001+","mainContribution":"R3672","mainCompSavings":"R0.00","mainTotal":"R3672","dependendContributionAdult":"R3399","dependentCompSavingsAdult":"R0.00","dependentTotalAdult":"R3399","dependendContributionChild":"R1434","dependentCompSavingsChild":"R0.00","dependentTotalChild":"R1434","maxChildContribution":"#N/A","mainThreshold":"","dependentThresholdAdult":"","dependentThresholdChild":"","preferedHospitalProvider":"#N/A","overallLimit":"#N/A","coPayment":"#N/A","rate":"#N/A","generalMedicin":"#N/A","specialist":"#N/A","dentistSurgical":"#N/A","mentalHealth":"#N/A","radiology":"#N/A","pathology":"#N/A","maternityBenefit":"#N/A","dialysis":"#N/A","cancer":"#N/A","transplant":"#N/A","mri":"#N/A","prosthesisInternal":"#N/A","prosthesisExternal":"#N/A","rehab":"#N/A","designatedServiceProvider":"#N/A","conditionsCovered":"#N/A","formulary":"#N/A","partialLimits":"#N/A","preferredProvider":"#N/A","overallAnualLimit":"#N/A","medicationOverCounter":"#N/A","medicationPrescribed":"#N/A","practitionersGeneral":"#N/A","specialistsCover":"#N/A","dentistryCover":"#N/A","dentistryCoverSpecial":"#N/A","optical":"#N/A","ambulance":"#N/A","international":"#N/A","hospitalCoverAids":"#N/A","artTtreatment":"#N/A","preventative":"#N/A","logo":"profmed.jpg"},{"company":"Profmed","name":"ProActive Plus","planType":"Traditional option","coverLevel":"Mid","hospital":"Any","chronic":"Network","serviceType":"N/A","familyIncome":"","mainContribution":"R2283","mainCompSavings":"R0.00","mainTotal":"R2283","dependendContributionAdult":"R2123","dependentCompSavingsAdult":"R0.00","dependentTotalAdult":"R2123","dependendContributionChild":"R830","dependentCompSavingsChild":"R0.00","dependentTotalChild":"R830","maxChildContribution":"#N/A","mainThreshold":"","dependentThresholdAdult":"","dependentThresholdChild":"","preferedHospitalProvider":"#N/A","overallLimit":"#N/A","coPayment":"#N/A","rate":"#N/A","generalMedicin":"#N/A","specialist":"#N/A","dentistSurgical":"#N/A","mentalHealth":"#N/A","radiology":"#N/A","pathology":"#N/A","maternityBenefit":"#N/A","dialysis":"#N/A","cancer":"#N/A","transplant":"#N/A","mri":"#N/A","prosthesisInternal":"#N/A","prosthesisExternal":"#N/A","rehab":"#N/A","designatedServiceProvider":"#N/A","conditionsCovered":"#N/A","formulary":"#N/A","partialLimits":"#N/A","preferredProvider":"#N/A","overallAnualLimit":"#N/A","medicationOverCounter":"#N/A","medicationPrescribed":"#N/A","practitionersGeneral":"#N/A","specialistsCover":"#N/A","dentistryCover":"#N/A","dentistryCoverSpecial":"#N/A","optical":"#N/A","ambulance":"#N/A","international":"#N/A","hospitalCoverAids":"#N/A","artTtreatment":"#N/A","preventative":"#N/A","logo":"profmed.jpg"},{"company":"Profmed","name":"ProActive Plus Savvy","planType":"Traditional option","coverLevel":"Mid","hospital":"Network","chronic":"Network","serviceType":"N/A","familyIncome":"","mainContribution":"R2055","mainCompSavings":"R0.00","mainTotal":"R2055","dependendContributionAdult":"R1910","dependentCompSavingsAdult":"R0.00","dependentTotalAdult":"R1910","dependendContributionChild":"R802","dependentCompSavingsChild":"R0.00","dependentTotalChild":"R802","maxChildContribution":"#N/A","mainThreshold":"","dependentThresholdAdult":"","dependentThresholdChild":"","preferedHospitalProvider":"#N/A","overallLimit":"#N/A","coPayment":"#N/A","rate":"#N/A","generalMedicin":"#N/A","specialist":"#N/A","dentistSurgical":"#N/A","mentalHealth":"#N/A","radiology":"#N/A","pathology":"#N/A","maternityBenefit":"#N/A","dialysis":"#N/A","cancer":"#N/A","transplant":"#N/A","mri":"#N/A","prosthesisInternal":"#N/A","prosthesisExternal":"#N/A","rehab":"#N/A","designatedServiceProvider":"#N/A","conditionsCovered":"#N/A","formulary":"#N/A","partialLimits":"#N/A","preferredProvider":"#N/A","overallAnualLimit":"#N/A","medicationOverCounter":"#N/A","medicationPrescribed":"#N/A","practitionersGeneral":"#N/A","specialistsCover":"#N/A","dentistryCover":"#N/A","dentistryCoverSpecial":"#N/A","optical":"#N/A","ambulance":"#N/A","international":"#N/A","hospitalCoverAids":"#N/A","artTtreatment":"#N/A","preventative":"#N/A","logo":"profmed.jpg"},{"company":"Profmed","name":"ProActive","planType":"Traditional option","coverLevel":"Mid","hospital":"Any","chronic":"Network","serviceType":"N/A","familyIncome":"","mainContribution":"R1923","mainCompSavings":"R0.00","mainTotal":"R1923","dependendContributionAdult":"R1777","dependentCompSavingsAdult":"R0.00","dependentTotalAdult":"R1777","dependendContributionChild":"R749","dependentCompSavingsChild":"R0.00","dependentTotalChild":"R749","maxChildContribution":"#N/A","mainThreshold":"","dependentThresholdAdult":"","dependentThresholdChild":"","preferedHospitalProvider":"#N/A","overallLimit":"#N/A","coPayment":"#N/A","rate":"#N/A","generalMedicin":"#N/A","specialist":"#N/A","dentistSurgical":"#N/A","mentalHealth":"#N/A","radiology":"#N/A","pathology":"#N/A","maternityBenefit":"#N/A","dialysis":"#N/A","cancer":"#N/A","transplant":"#N/A","mri":"#N/A","prosthesisInternal":"#N/A","prosthesisExternal":"#N/A","rehab":"#N/A","designatedServiceProvider":"#N/A","conditionsCovered":"#N/A","formulary":"#N/A","partialLimits":"#N/A","preferredProvider":"#N/A","overallAnualLimit":"#N/A","medicationOverCounter":"#N/A","medicationPrescribed":"#N/A","practitionersGeneral":"#N/A","specialistsCover":"#N/A","dentistryCover":"#N/A","dentistryCoverSpecial":"#N/A","optical":"#N/A","ambulance":"#N/A","international":"#N/A","hospitalCoverAids":"#N/A","artTtreatment":"#N/A","preventative":"#N/A","logo":"profmed.jpg"},{"company":"Profmed","name":"ProActive Savvy","planType":"Traditional option","coverLevel":"Mid","hospital":"Network","chronic":"Network","serviceType":"N/A","familyIncome":"0 - R7 000","mainContribution":"R717","mainCompSavings":"R0.00","mainTotal":"R717","dependendContributionAdult":"R660","dependentCompSavingsAdult":"R0.00","dependentTotalAdult":"R660","dependendContributionChild":"R576","dependentCompSavingsChild":"R0.00","dependentTotalChild":"R576","maxChildContribution":"#N/A","mainThreshold":"","dependentThresholdAdult":"","dependentThresholdChild":"","preferedHospitalProvider":"#N/A","overallLimit":"#N/A","coPayment":"#N/A","rate":"#N/A","generalMedicin":"#N/A","specialist":"#N/A","dentistSurgical":"#N/A","mentalHealth":"#N/A","radiology":"#N/A","pathology":"#N/A","maternityBenefit":"#N/A","dialysis":"#N/A","cancer":"#N/A","transplant":"#N/A","mri":"#N/A","prosthesisInternal":"#N/A","prosthesisExternal":"#N/A","rehab":"#N/A","designatedServiceProvider":"#N/A","conditionsCovered":"#N/A","formulary":"#N/A","partialLimits":"#N/A","preferredProvider":"#N/A","overallAnualLimit":"#N/A","medicationOverCounter":"#N/A","medicationPrescribed":"#N/A","practitionersGeneral":"#N/A","specialistsCover":"#N/A","dentistryCover":"#N/A","dentistryCoverSpecial":"#N/A","optical":"#N/A","ambulance":"#N/A","international":"#N/A","hospitalCoverAids":"#N/A","artTtreatment":"#N/A","preventative":"#N/A","logo":"profmed.jpg"},{"company":"Profmed","name":"ProActive Savvy","planType":"Traditional option","coverLevel":"Mid","hospital":"Network","chronic":"Network","serviceType":"N/A","familyIncome":"R7 001 - R11 000","mainContribution":"R1290","mainCompSavings":"R0.00","mainTotal":"R1290","dependendContributionAdult":"R1290","dependentCompSavingsAdult":"R0.00","dependentTotalAdult":"R1290","dependendContributionChild":"R577","dependentCompSavingsChild":"R0.00","dependentTotalChild":"R577","maxChildContribution":"#N/A","mainThreshold":"","dependentThresholdAdult":"","dependentThresholdChild":"","preferedHospitalProvider":"#N/A","overallLimit":"#N/A","coPayment":"#N/A","rate":"#N/A","generalMedicin":"#N/A","specialist":"#N/A","dentistSurgical":"#N/A","mentalHealth":"#N/A","radiology":"#N/A","pathology":"#N/A","maternityBenefit":"#N/A","dialysis":"#N/A","cancer":"#N/A","transplant":"#N/A","mri":"#N/A","prosthesisInternal":"#N/A","prosthesisExternal":"#N/A","rehab":"#N/A","designatedServiceProvider":"#N/A","conditionsCovered":"#N/A","formulary":"#N/A","partialLimits":"#N/A","preferredProvider":"#N/A","overallAnualLimit":"#N/A","medicationOverCounter":"#N/A","medicationPrescribed":"#N/A","practitionersGeneral":"#N/A","specialistsCover":"#N/A","dentistryCover":"#N/A","dentistryCoverSpecial":"#N/A","optical":"#N/A","ambulance":"#N/A","international":"#N/A","hospitalCoverAids":"#N/A","artTtreatment":"#N/A","preventative":"#N/A","logo":"profmed.jpg"},{"company":"Profmed","name":"ProActive Savvy","planType":"Traditional option","coverLevel":"Mid","hospital":"Network","chronic":"Network","serviceType":"N/A","familyIncome":"R11 001+","mainContribution":"R1730","mainCompSavings":"R0.00","mainTotal":"R1730","dependendContributionAdult":"R1599","dependentCompSavingsAdult":"R0.00","dependentTotalAdult":"R1599","dependendContributionChild":"R674","dependentCompSavingsChild":"R0.00","dependentTotalChild":"R674","maxChildContribution":"#N/A","mainThreshold":"","dependentThresholdAdult":"","dependentThresholdChild":"","preferedHospitalProvider":"#N/A","overallLimit":"#N/A","coPayment":"#N/A","rate":"#N/A","generalMedicin":"#N/A","specialist":"#N/A","dentistSurgical":"#N/A","mentalHealth":"#N/A","radiology":"#N/A","pathology":"#N/A","maternityBenefit":"#N/A","dialysis":"#N/A","cancer":"#N/A","transplant":"#N/A","mri":"#N/A","prosthesisInternal":"#N/A","prosthesisExternal":"#N/A","rehab":"#N/A","designatedServiceProvider":"#N/A","conditionsCovered":"#N/A","formulary":"#N/A","partialLimits":"#N/A","preferredProvider":"#N/A","overallAnualLimit":"#N/A","medicationOverCounter":"#N/A","medicationPrescribed":"#N/A","practitionersGeneral":"#N/A","specialistsCover":"#N/A","dentistryCover":"#N/A","dentistryCoverSpecial":"#N/A","optical":"#N/A","ambulance":"#N/A","international":"#N/A","hospitalCoverAids":"#N/A","artTtreatment":"#N/A","preventative":"#N/A","logo":"profmed.jpg"},{"company":"Siswe","name":"Silver Hospital","planType":"New generation","coverLevel":"Mid","hospital":"Network","chronic":"Network","serviceType":"Network","familyIncome":"","mainContribution":"R1916","mainCompSavings":"R0.00","mainTotal":"R1916","dependendContributionAdult":"R1650","dependentCompSavingsAdult":"R0.00","dependentTotalAdult":"R1650","dependendContributionChild":"R382","dependentCompSavingsChild":"R0.00","dependentTotalChild":"R382","maxChildContribution":"3","mainThreshold":"","dependentThresholdAdult":"","dependentThresholdChild":"","preferedHospitalProvider":"DSP Network hospitals","overallLimit":"Unlimited","coPayment":"\\nR12 000 co-payment for non-network hospital \\nView brochure for Day Hospital Procedures\\n","rate":"100%  Scheme Rate","generalMedicin":"7 days' supply per event","specialist":"100%  Scheme Rate","dentistSurgical":"R1 000 co-pay per hospital admission (no-co-pay if day hospital is used depending on availability)\\n- 20% co-payment if authorisation was obtained after procedure has been done\\n- General anaesthetic for children under 5yrs and removal of impacted teeth\\nMaxillo-facial and Oral Surgery: no benefit\\nSubject to PMBs pre-authorisation and treatment protocols","mentalHealth":"Psychiatric Hospitalisation (PMB)\\n- 21 days per beneficiary, \\n-Includes (6) in-hospital psychiatrist consultations                   \\n- 4 additional out of hospital visits in lieu of hospitalisation \\nAlcoholism and drug addiction: \\n- PMB at DSP \\n- 3-day withdrawal treatment plus\\n- 21 days rehabilitation \\n\\nSubject to PMBs and managed care protocols","radiology":"100%  Scheme Rate","pathology":"100%  Scheme Rate","maternityBenefit":"In-Hospital admission: \\n- Delivery by a GP, Specialist or Midwife\\n \\nSubject to registration on maternity programme \\n- 9 antenatal visits with GP / Midwife or Specialist\\n- 2 visits with Obstetrician, subject to referral from GP or Midwife\\n- 2 x 2D sonar scans per pregnancy\\n(excludes diagnostic sonars)\\n- 2 x Haemoglobin Measurement tests\\n- 1 x Blood Grouping test\\n -1 x VDRL test for Syphilis\\n- 2 x HIV Blood tests\\n- 12 x Urine Analysis tests\\n- 1 x Full Blood Count (FBC) test\\n- Vitamins worth R114\\n ","dialysis":"PMBs at DSP","cancer":"\\n100% of DSP Tariff\\nStandard protocols at (DSP)\\n","transplant":"100% of Scheme rate\\nHarvesting, transport and donor fees - PMB only","mri":"In and out of hospital\\nR29 182 per family per annum","prosthesisInternal":"Subject to pre-authorisation, treatment protocols, DSPs and PMBs\\nSurgical and non-surgical prosthesis\\n- Joints: hip and knee (partial and total). Only\\none prosthesis and joint per beneficiary cycle\\nis permitted.\\n- Spine: two levels performed in one procedure\\nper year is permitted. Should more than two\\nlevels be required, approval will be granted\\nsubject to managed care protocols.\\n- Cardiac: pacemaker, internal defibrillators,\\ngrafts and valves.\\n- Stents: Vascular stents: 2 per family per year.\\n- Cardiac stents: 3 per family per year.\\n","prosthesisExternal":"General appliances: PMBs","rehab":"Private Nursing: PMBs only            \\n","designatedServiceProvider":"Preferred provider","conditionsCovered":"CDL in PMB","formulary":"Yes","partialLimits":"None","preferredProvider":"None","overallAnualLimit":"None","medicationOverCounter":"No benefit","medicationPrescribed":"No benefit","practitionersGeneral":"No benefit","specialistsCover":"No benefit","dentistryCover":"Dental benefits are paid at Scheme Dental Tariff","dentistryCoverSpecial":"Dental benefits are paid at Scheme Dental Tariff","optical":"No benefit","ambulance":"Europ Assistance South Africa","international":"100% of Scheme rates payable in RSA currency\\nSubject to approval by Scheme","hospitalCoverAids":"Subject to registration on Disease Management Programme and PMB ","artTtreatment":"Subject to treatment protocols and registration on Disease Management Programme","preventative":"Wellness Programme  \\n- Limit of R2 342 per family per year\\n\\nWellness screening tests: \\n( blood sugar, cholesterol, blood pressure, BMI and HIV screening test)\\n- 1 GP visit limited to R361 per beneficiary\\n\\nVaccines and preventative screening:\\n- mammogram for woman older than 40\\n- Pap smears for women older than 21\\n- PSA for men older than 40\\n- Flue vaccine\\n- Pneumococcal vaccine\\n- HPV vaccine\\n- Childhood immunisation (up to age of 6\\n- Subject to wellness screening limit\\n\\n \\nOral contraceptives:\\n- R3 021 per family \\n\\nChiropractors and Homeopathy treatment:  \\n- R1 161 per beneficiary","logo":"Sizwe.jpg"},{"company":"Siswe","name":"Gold Ascend Option","planType":"Traditional","coverLevel":"Mid","hospital":"Any","chronic":"Network","serviceType":"Network","familyIncome":"","mainContribution":"R2819","mainCompSavings":"R0.00","mainTotal":"R2819","dependendContributionAdult":"R2380","dependentCompSavingsAdult":"R0.00","dependentTotalAdult":"R2380","dependendContributionChild":"R824","dependentCompSavingsChild":"R0.00","dependentTotalChild":"R824","maxChildContribution":"3","mainThreshold":"","dependentThresholdAdult":"","dependentThresholdChild":"","preferedHospitalProvider":"Any hospital","overallLimit":"Unlimited","coPayment":"View brochure for Day Hospital Procedures","rate":"100%  Scheme Rate","generalMedicin":"7 days' supply per event","specialist":"100%  Scheme Rate","dentistSurgical":"R1 000 co-pay per hospital admission (no-co-pay if day hospital is used depending on availability)\\n- 20% co-payment if authorisation was obtained after procedure has been done\\n- General anaesthetic for children under 5yrs and removal of impacted teeth\\nMaxillo-facial and Oral Surgery: 100% of Negotiated Tariff \\nSubject to PMBs pre-authorisation and treatment protocols","mentalHealth":"Psychiatric Hospitalisation (PMB)\\nLimited to R35 700 per member per admission at\\nR1 700 per day.\\n- 21 days per beneficiary, \\n                  \\n- 4 additional out of hospital visits in lieu of hospitalisation \\n\\nAlcoholism and drug addiction: \\n- PMB at DSP \\n- 3-day withdrawal treatment plus\\n- 21 days rehabilitation ","radiology":"100%  Scheme Rate","pathology":"100%  Scheme Rate","maternityBenefit":"In-Hospital admission: \\n- 100% of Scheme rate at DSP\\n- Delivery by a GP, Specialist or Midwife\\n \\nSubject to registration on maternity programme \\n- 9 antenatal visits with GP / Midwife or Specialist\\n- 2 visits with Obstetrician, subject to referral from GP or Midwife\\n- 2 x 2D sonar scans per pregnancy\\n(excludes diagnostic sonars)\\n- 2 x Haemoglobin Measurement tests\\n- 1 x Blood Grouping test\\n -1 x VDRL test for Syphilis\\n- 2 x HIV Blood tests\\n- 12 x Urine Analysis tests\\n- 1 x Full Blood Count (FBC) test\\n- Vitamins worth R114\\n ","dialysis":"PMBs at DSP","cancer":"\\n\\nR208 000 per beneficiary, thereafter with a 20% co-payment. Subject to PMBs, pre-authorisation and treatment protocols\\n","transplant":"100% of Scheme rate\\nHarvesting, transport and donor fees - PMB only","mri":"In and out of hospital: \\nR21 575 per family per annum","prosthesisInternal":"\\nSubject to pre-authorisation, treatment protocols, DSPs and PMBs\\nSurgical and non-surgical prosthesis\\n- R29 565 per family\\n","prosthesisExternal":"External prosthesis \\n- subject to Internal Prosthesis benefit limit\\n\\nGeneral appliances:\\n- M : R1 171 \\n- M1+ : R1 882\\n\\nHearing aids: \\n- R8 658 per family, every 4 yrs\\n\\nNon-motorised wheelchairs:  \\n- R2 167 per family, every 4 yrs ","rehab":"Private Nursing: R5 243 per family","designatedServiceProvider":"Yes","conditionsCovered":"CDL in PMB ","formulary":"Yes ","partialLimits":"None","preferredProvider":"DSP Providers","overallAnualLimit":"GP and Specialist visits, Acute Medicines, Pathology, Radiology and Physiotherapy limited to the following sub-limits:\\nM - R6 556\\nM+1 - R9 709\\nM+2 - R11 362\\nM+3 - R12 993\\nM+4 - R14 645\\nM+5 - R16 287\\nM+6 - R17 918\\n\\n","medicationOverCounter":"Included in Acute Medication limit","medicationPrescribed":"\\nSubject to the day-to-day limit with the following sub-limits: 100% SEP\\nM: R2 047\\nM+1: R3 689\\nM+2: R4 105\\nM+3: R4 652\\nM+4: R4 783\\nM+5: R5 046\\nM+6+: R5 462","practitionersGeneral":"Subject to the day-to-day benefit. Shared number of visits between GP and specialist visits:\\nM: 6\\nM+1: 9\\nM+2: 12\\nM+3: 14\\nM+4: 15\\nM+5: 16\\nM+6+: 17","specialistsCover":"0","dentistryCover":"Consultations: 2 General check-ups per beneficiary\\nPlastic Dentures: 1 set per beneficiary per 4 year cycle\\nExtra Oral X-rays: 1 per beneficiary per 3 year cycle\\nFillings: Once per tooth in 720 days\\n\\nSubject to managed care protocols and pre-authorisation\\n\\n","dentistryCoverSpecial":"No benefit","optical":"\\nBenefits in a 2 year period per beneficiary:\\n- 1 eye test at any PPN optometrist  \\n- Frames: R629                                                                 \\n- Single vision: R202 per lens\\n- Bifocal: R438 per lens\\n- Multifocal: R438 per lens OR\\n- Contact Lenses: R1 387\\n","ambulance":"Europ Assistance South Africa","international":"100% of Scheme rates payable in RSA currency\\nSubject to approval by Scheme","hospitalCoverAids":"Subject to registration on Disease Management Programme and PMB ","artTtreatment":"Subject to treatment protocols and registration on Disease Management Programme","preventative":"Wellness Programme  \\n- Limit of R1 161 per family per year\\n\\nWellness screening tests: \\n- Limited to R2 332 per family\\n( blood sugar, cholesterol, blood pressure, BMI and HIV screening test)\\n- 1 GP visit limited to R295 per beneficiary\\n\\nVaccines and preventative screening:\\n- mammogram for woman older than 40\\n- Pap smears for women older than 21\\n- PSA for men older than 40\\n- Subject to wellness screening limit\\n \\nOral contraceptives:\\n- R3 021 per family \\n\\nChiropractors and Homeopathy treatment:  \\n- R1 161 per beneficiary","logo":"Sizwe.jpg"},{"company":"Siswe","name":"Gold Ascend EDO","planType":"Traditional","coverLevel":"Mid","hospital":"Network","chronic":"Network","serviceType":"Network","familyIncome":"","mainContribution":"R2679","mainCompSavings":"R0.00","mainTotal":"R2679","dependendContributionAdult":"R2261","dependentCompSavingsAdult":"R0.00","dependentTotalAdult":"R2261","dependendContributionChild":"R783","dependentCompSavingsChild":"R0.00","dependentTotalChild":"R783","maxChildContribution":"3","mainThreshold":"","dependentThresholdAdult":"","dependentThresholdChild":"","preferedHospitalProvider":"DSP Network hospitals","overallLimit":"Unlimited","coPayment":"\\nR12 000 co-payment for non-network hospital \\nView brochure for Day Hospital Procedures","rate":"100%  Scheme Rate","generalMedicin":"7 days' supply per event","specialist":"100%  Scheme Rate","dentistSurgical":"R1 000 co-pay per hospital admission (no-co-pay if day hospital is used depending on availability)\\n- 20% co-payment if authorisation was obtained after procedure has been done\\n- General anaesthetic for children under 5yrs and removal of impacted teeth\\nMaxillo-facial and Oral Surgery: 100% of Negotiated Tariff \\nSubject to PMBs pre-authorisation and treatment protocols","mentalHealth":"Psychiatric Hospitalisation (PMB)\\nLimited to R35 700 per member per admission at\\nR1 700 per day.\\n- 21 days per beneficiary, \\n                  \\n- 4 additional out of hospital visits in lieu of hospitalisation \\n\\nAlcoholism and drug addiction: \\n- PMB at DSP \\n- 3-day withdrawal treatment plus\\n- 21 days rehabilitation ","radiology":"100%  Scheme Rate","pathology":"100%  Scheme Rate","maternityBenefit":"In-Hospital admission: \\n- 100% of Scheme rate at DSP\\n- Delivery by a GP, Specialist or Midwife\\n \\nSubject to registration on maternity programme \\n- 9 antenatal visits with GP / Midwife or Specialist\\n- 2 visits with Obstetrician, subject to referral from GP or Midwife\\n- 2 x 2D sonar scans per pregnancy\\n(excludes diagnostic sonars)\\n- 2 x Haemoglobin Measurement tests\\n- 1 x Blood Grouping test\\n -1 x VDRL test for Syphilis\\n- 2 x HIV Blood tests\\n- 12 x Urine Analysis tests\\n- 1 x Full Blood Count (FBC) test\\n- Vitamins worth R114\\n ","dialysis":"PMBs at DSP","cancer":"\\n\\nR208 000 per beneficiary, thereafter with a 20% co-payment. Subject to PMBs, pre-authorisation and treatment protocols\\n","transplant":"100% of Scheme rate\\nHarvesting, transport and donor fees - PMB only","mri":"In and out of hospital: \\nR21 575 per family per annum","prosthesisInternal":"\\nSubject to pre-authorisation, treatment protocols, DSPs and PMBs\\nSurgical and non-surgical prosthesis\\n- R29 565 per family\\n","prosthesisExternal":"External prosthesis \\n- subject to Internal Prosthesis benefit limit\\n\\nGeneral appliances:\\n- M : R1 171 \\n- M1+ : R1 882\\n\\nHearing aids: \\n- R8 658 per family, every 4 yrs\\n\\nNon-motorised wheelchairs:  \\n- R2 167 per family, every 4 yrs ","rehab":"Private Nursing: R5 243 per family","designatedServiceProvider":"Yes","conditionsCovered":"CDL in PMB ","formulary":"Yes ","partialLimits":"None","preferredProvider":"DSP Providers","overallAnualLimit":"GP an d Specialist visits, Acute Medicines, Pathology, Radiology and Physiotherapy limited to the following sub-limits:\\nM - R6 556\\nM+1 - R9 709\\nM+2 - R11 362\\nM+3 - R12 993\\nM+4 - R14 645\\nM+5 - R16 287\\nM+6 - R17 918\\n\\n","medicationOverCounter":"Included in Acute Medication limit","medicationPrescribed":"\\nSubject to the day-to-day limit with the following sub-limits: 100% SEP\\nM: R2 047\\nM+1: R3 689\\nM+2: R4 105\\nM+3: R4 652\\nM+4: R4 783\\nM+5: R5 046\\nM+6+: R5 462","practitionersGeneral":"Subject to the day-to-day benefit. Shared number of visits between GP and specialist visits:\\nM: 6\\nM+1: 9\\nM+2: 12\\nM+3: 14\\nM+4: 15\\nM+5: 16\\nM+6+: 17","specialistsCover":"0","dentistryCover":"Consultations: 2 General check-ups per beneficiary\\nPlastic Dentures: 1 set per beneficiary per 4 year cycle\\nExtra Oral X-rays: 1 per beneficiary per 3 year cycle\\nFillings: Once per tooth in 720 days\\n\\nSubject to managed care protocols and pre-authorisation\\n \\n\\n","dentistryCoverSpecial":"No benefit","optical":"\\nBenefits in a 2 year period per beneficiary:\\n- 1 eye test at any PPN optometrist  \\n- Frames: R629                                                                 \\n- Single vision: R202 per lens\\n- Bifocal: R438 per lens\\n- Multifocal: R438 per lens OR\\n- Contact Lenses: R1 387\\n","ambulance":"Europ Assistance South Africa","international":"100% of Scheme rates payable in RSA currency\\nSubject to approval by Scheme","hospitalCoverAids":"Subject to registration on Disease Management Programme and PMB ","artTtreatment":"Subject to treatment protocols and registration on Disease Management Programme","preventative":"Wellness Programme  \\n- Limit of R1 161 per family per year\\n\\nWellness screening tests: \\n- Limited to R2 332 per family\\n( blood sugar, cholesterol, blood pressure, BMI and HIV screening test)\\n- 1 GP visit limited to R295 per beneficiary\\n\\nVaccines and preventative screening:\\n- mammogram for woman older than 40\\n- Pap smears for women older than 21\\n- PSA for men older than 40\\n- Subject to wellness screening limit\\n \\nOral contraceptives:\\n- R3 021 per family \\n\\nChiropractors and Homeopathy treatment:  \\n- R1 161 per beneficiary","logo":"Sizwe.jpg"},{"company":"Siswe","name":"Platinum Enhanced Option","planType":"Traditional","coverLevel":"Mid","hospital":"Any","chronic":"Network","serviceType":"Network","familyIncome":"","mainContribution":"R3871","mainCompSavings":"R0.00","mainTotal":"R3871","dependendContributionAdult":"R3703","dependentCompSavingsAdult":"R0.00","dependentTotalAdult":"R3703","dependendContributionChild":"R986","dependentCompSavingsChild":"R0.00","dependentTotalChild":"R986","maxChildContribution":"3","mainThreshold":"","dependentThresholdAdult":"","dependentThresholdChild":"","preferedHospitalProvider":"Any hospital","overallLimit":"Unlimited","coPayment":"View brochure for Day Hospital Procedures\\n ","rate":"100% of Negotiated Tariff","generalMedicin":"7 days' supply per event","specialist":"100%  Scheme Rate","dentistSurgical":"R1 000 co-pay per hospital admission (no-co-pay if day hospital is used depending on availability)\\n- 20% co-payment if authorisation was obtained after procedure has been done\\n- General anaesthetic for children under 5yrs and removal of impacted teeth\\nMaxillo-facial and Oral Surgery: 100% of Negotiated Tariff \\nSubject to PMBs pre-authorisation and treatment protocols","mentalHealth":"Psychiatric Hospitalisation (PMB)\\nLimited to R42 000 per member per admission at\\nR2 000 per day.\\n- 21 days per beneficiary, \\n- Includes (6) in-hospital psychiatrist consultations                 \\n- 4 additional out of hospital visits in lieu of hospitalisation \\n\\nAlcoholism and drug addiction: \\n- PMB at DSP \\n- 3-day withdrawal treatment plus\\n- 21 days rehabilitation ","radiology":"100%  Scheme Rate","pathology":"100%  Scheme Rate","maternityBenefit":"In-Hospital admission: \\n- 100% of Scheme Rate\\n- Delivery by a GP, Specialist or Midwife\\n\\n Subject to registration on maternity programme \\n- 9 antenatal visits with GP / Midwife or Specialist\\n- 4 visits with Obstetrician, subject to referral from GP or Midwife\\n- 2 x 2D scans per pregnancy\\n- 2 x Haemoglobin Measurement tests\\n- 1 x Blood Grouping test\\n -1 x VDRL test for Syphilis\\n- 2 x HIV Blood tests\\n- 12 x Urine Analysis tests\\n- 1 x Full Blood Count (FBC) test\\n- Vitamins worth R114 (subject to day-to-day benefits) \\n ","dialysis":"PMBs at DSP","cancer":"\\n\\nR520 000 per beneficiary, thereafter with a 20% co-payment. Subject to PMBs, pre-authorisation and treatment protocols\\n","transplant":"100% of Scheme rate\\nHarvesting, transport and donor fees - PMB only","mri":"In and out of hospital: \\nR32 794 per family per annum","prosthesisInternal":"\\nSubject to pre-authorisation, treatment protocols, DSPs and PMBs\\nSurgical and non-surgical prosthesis\\n- R65 052 per family \\n","prosthesisExternal":"External prosthesis: \\n- subject to Internal Prosthesis benefit limit\\n\\nGeneral appliances:\\n- M: R1 751\\n- M1+ : R3 065\\n\\nHearing aids: \\n- R13 858 per family, every 3 yrs\\n\\nNon-motorised wheelchairs: \\n- R3 634 per family, every 4 yrs ","rehab":"Private Nursing: R7 826 per family","designatedServiceProvider":"Yes","conditionsCovered":"CDL in PMB + 13 conditions","formulary":"Yes","partialLimits":"non-CDL conditions \\nOverall Family Limit:\\nMember: R 6 393\\nMember+1: R 12 807\\nMember+2: R 19 221\\nMember+3: R 25 625\\nMember+4: R 32 028\\nMember+5: R 38 453\\nMember+6+: R 44 868\\nPer Beneficiary sub-limit: R6 393\\n","preferredProvider":"DSP Providers","overallAnualLimit":"\\nGP and Specialist visits, Acute Medicines, Pathology, Radiology and Physiotherapy limited to the following sub-limits:\\nM - R11 362\\nM+1 - R16 287\\nM+2 - R18 740\\nM+3 - R20 392\\nM+4 - R22 855\\nM+5 - R25 329\\nM+6 - R27 639\\n\\n\\n","medicationOverCounter":"Included in Acute Medication limit","medicationPrescribed":"Subject to the day-to-day limit with the following sub-limits: 100% SEP  \\nM+1: R6 021\\nM+2: R7 115\\nM+3: R7 651\\nM+4: R8 757\\nM+5: R9 030\\nM+6+: R9 304","practitionersGeneral":"Subject to day-to-day benefit. Limited number of visits:\\nM: 7\\nM+1: 14\\nM+2: 16\\nM+3: 18\\nM+4: 20\\nM+5: 21\\nM+6+: 22","specialistsCover":"Subject to Overall day-to-day benefit and GP referral with the exception of: Gynaecologist and Paediatrician for kids up to 1 year\\nLimited number of visits:\\nM: 4\\nM+1: 8\\nM+2: 9\\nM+3: 10\\nM+4: 11\\nM+5: 12\\nM+6+: 13","dentistryCover":"Consultations: 2 General check-ups per beneficiary\\nPlastic Dentures: 1 set per beneficiary per 4 year cycle\\nExtra Oral X-rays: 1 per beneficiary per 3 year cycle\\nFillings: Once per tooth in 720 days\\n\\nSubject to managed care protocols and pre-authorisation\\n \\n\\n","dentistryCoverSpecial":"20% co-payment apply to all related claims if authorisation is obtained after the procedure\\nCrowns and Bridges: \\n- 1 crown per family, once per tooth(5 year cycle)\\nImplants: no benefit\\nOrthodontic treatment: \\n- beneficiaries between 9-18 years old\\n- subject to pre-auth and clinical protocols\\n- 35% co-payment applies  \\nMetal frames: \\n- 2 partial frames per beneficiary\\n- every 5 years\\n- 1 per family per annum","optical":"Benefits in a 2 year period per beneficiary:\\n- 1 eye test at any PPN optometrist  \\n- Frames: R959                      \\n- Single vision: R202 per lens\\n- Bifocal: R438 per lens\\n- Multifocal: R804 per lens\\n- Contact Lenses: R1 738\\n","ambulance":"Europ Assistance South Africa","international":"100% of Scheme rates payable in RSA currency\\nSubject to approval by Scheme","hospitalCoverAids":"Subject to registration on Disease Management Programme and PMB ","artTtreatment":"Subject to treatment protocols and registration on Disease Management Programme","preventative":"Wellness Programme  \\n- Limit of R1 696 per family per year\\n\\nWellness screening tests: \\n- Limited to R2 332 per family\\n( blood sugar, cholesterol, blood pressure, BMI and HIV screening test)\\n- 1 GP visit limited to R295 per beneficiary\\n\\nVaccines and preventative screening:\\n- mammogram for woman older than 40\\n- Pap smears for women older than 21\\n- PSA for men older than 40\\n- Subject to wellness screening limit\\n \\nOral contraceptives:\\n- R3 021 per family \\n\\nChiropractors and Homeopathy treatment:  \\n- R1 500 per beneficiary","logo":"Sizwe.jpg"},{"company":"Siswe","name":"Platinum Enhanced EDO","planType":"Traditional","coverLevel":"Mid","hospital":"Network","chronic":"Network","serviceType":"Network","familyIncome":"","mainContribution":"R3678","mainCompSavings":"R0.00","mainTotal":"R3678","dependendContributionAdult":"R3518","dependentCompSavingsAdult":"R0.00","dependentTotalAdult":"R3518","dependendContributionChild":"R937","dependentCompSavingsChild":"R0.00","dependentTotalChild":"R937","maxChildContribution":"3","mainThreshold":"","dependentThresholdAdult":"","dependentThresholdChild":"","preferedHospitalProvider":"DSP Network hospitals","overallLimit":"Unlimited","coPayment":"R12 000 co-payment for non-network hospital\\nView brochure for Day Hospital Procedures","rate":"100% of DSP Tariff","generalMedicin":"7 days' supply per event","specialist":"100%  Scheme Rate","dentistSurgical":"R1 000 co-pay per hospital admission (no-co-pay if day hospital is used depending on availability)\\n- 20% co-payment if authorisation was obtained after procedure has been done\\n- General anaesthetic for children under 5yrs and removal of impacted teeth\\nMaxillo-facial and Oral Surgery: 100% of Negotiated Tariff \\nSubject to PMBs pre-authorisation and treatment protocols","mentalHealth":"Psychiatric Hospitalisation (PMB)\\nLimited to R42 000 per member per admission at\\nR2 000 per day.\\n- 21 days per beneficiary, \\n- Includes (6) in-hospital psychiatrist consultations                 \\n- 4 additional out of hospital visits in lieu of hospitalisation \\n\\nAlcoholism and drug addiction: \\n- PMB at DSP \\n- 3-day withdrawal treatment plus\\n- 21 days rehabilitation ","radiology":"100%  Scheme Rate","pathology":"100%  Scheme Rate","maternityBenefit":"In-Hospital admission: \\n- 100% of Scheme Rate\\n- Delivery by a GP, Specialist or Midwife\\n\\n Subject to registration on maternity programme \\n- 9 antenatal visits with GP / Midwife or Specialist\\n- 4 visits with Obstetrician, subject to referral from GP or Midwife\\n- 2 x 2D scans per pregnancy\\n- 2 x Haemoglobin Measurement tests\\n- 1 x Blood Grouping test\\n -1 x VDRL test for Syphilis\\n- 2 x HIV Blood tests\\n- 12 x Urine Analysis tests\\n- 1 x Full Blood Count (FBC) test\\n- Vitamins worth R114 (subject to day-to-day benefits) \\n ","dialysis":"PMBs at DSP","cancer":"\\n\\nR520 000 per beneficiary, thereafter with a 20% co-payment. Subject to PMBs, pre-authorisation and treatment protocols\\n","transplant":"100% of Scheme rate\\nHarvesting, transport and donor fees - PMB only","mri":"In and out of hospital: \\nR32 794 per family per annum","prosthesisInternal":"\\nSubject to pre-authorisation, treatment protocols, DSPs and PMBs\\nSurgical and non-surgical prosthesis\\n- R65 052 per family \\n","prosthesisExternal":"External prosthesis: \\n- subject to Internal Prosthesis benefit limit\\n\\nGeneral appliances:\\n- M: R1 751\\n- M1+ : R3 065\\n\\nHearing aids: \\n- R13 858 per family, every 3 yrs\\n\\nNon-motorised wheelchairs: \\n- R3 634 per family, every 4 yrs ","rehab":"Private Nursing: R7 826 per family","designatedServiceProvider":"Yes","conditionsCovered":"CDL in PMB + 13 conditions","formulary":"Yes","partialLimits":"non-CDL conditions \\nOverall Family Limit:\\nMember: R 6 393\\nMember+1: R 12 807\\nMember+2: R 19 221\\nMember+3: R 25 625\\nMember+4: R 32 028\\nMember+5: R 38 453\\nMember+6+: R 44 868\\nPer Beneficiary sub-limit: R6 393\\n","preferredProvider":"DSP Providers","overallAnualLimit":"\\nGP and Specialist visits, Acute Medicines, Pathology, Radiology and Physiotherapy limited to the following sub-limits:\\nM - R11 362\\nM+1 - R16 287\\nM+2 - R18 740\\nM+3 - R20 392\\nM+4 - R22 855\\nM+5 - R25 329\\nM+6 - R27 639\\n\\n\\n","medicationOverCounter":"Included in Acute Medication limit","medicationPrescribed":"Subject to the day-to-day limit with the following sub-limits: 100% SEP plus\\nM  : R3 952\\nM+1: R6 021\\nM+2: R7 115\\nM+3: R7 651\\nM+4: R8 757\\nM+5: R9 030\\nM+6+: R9 304","practitionersGeneral":"Subject to day-to-day benefit. Limited number of visits:\\nM: 7\\nM+1: 14\\nM+2: 16\\nM+3: 18\\nM+4: 20\\nM+5: 21\\nM+6+: 22","specialistsCover":"Subject to Overall day-to-day benefit and GP referral with the exception of: Gynaecologist and Paediatrician for kids up to 1 year\\nLimited number of visits:\\nM: 4\\nM+1: 8\\nM+2: 9\\nM+3: 10\\nM+4: 11\\nM+5: 12\\nM+6+: 13","dentistryCover":"Consultations: 2 General check-ups per beneficiary\\nPlastic Dentures: 1 set per beneficiary per 4 year cycle\\nExtra Oral X-rays: 1 per beneficiary per 3 year cycle\\nFillings: Once per tooth in 720 days\\n\\nSubject to managed care protocols and pre-authorisation\\n \\n\\n","dentistryCoverSpecial":"20% co-payment apply to all related claims if authorisation is obtained after the procedure\\nCrowns and Bridges: \\n- 1 crown per family, once per tooth(5 year cycle)\\nImplants: no benefit\\nOrthodontic treatment: \\n- beneficiaries between 9-18 years old\\n- subject to pre-auth and clinical protocols\\n- 35% co-payment applies  \\nMetal frames: \\n- 2 partial frames per beneficiary\\n- every 5 years\\n- 1 per family per annum","optical":"Benefits in a 2 year period per beneficiary:\\n- 1 eye test at any PPN optometrist  \\n- Frames: R959                      \\n- Single vision: R202 per lens\\n- Bifocal: R438 per lens\\n- Multifocal: R804 per lens\\n- Contact Lenses: R1 738\\n","ambulance":"Europ Assistance South Africa","international":"100% of Scheme rates payable in RSA currency\\nSubject to approval by Scheme","hospitalCoverAids":"Subject to registration on Disease Management Programme and PMB ","artTtreatment":"Subject to treatment protocols and registration on Disease Management Programme","preventative":"Wellness Programme  \\n- Limit of R1 696 per family per year\\n\\nWellness screening tests: \\n- Limited to R2 332 per family\\n( blood sugar, cholesterol, blood pressure, BMI and HIV screening test)\\n- 1 GP visit limited to R295 per beneficiary\\n\\nVaccines and preventative screening:\\n- mammogram for woman older than 40\\n- Pap smears for women older than 21\\n- PSA for men older than 40\\n- Subject to wellness screening limit\\n \\nOral contraceptives:\\n- R3 021 per family \\n\\nChiropractors and Homeopathy treatment:  \\n- R1 500 per beneficiary","logo":"Sizwe.jpg"},{"company":"Siswe","name":"Titanium Executive Option","planType":"Traditional","coverLevel":"Mid","hospital":"Any","chronic":"Network","serviceType":"Network","familyIncome":"","mainContribution":"R6585","mainCompSavings":"R0.00","mainTotal":"R6585","dependendContributionAdult":"R5981","dependentCompSavingsAdult":"R0.00","dependentTotalAdult":"R5981","dependendContributionChild":"R1343","dependentCompSavingsChild":"R0.00","dependentTotalChild":"R1343","maxChildContribution":"3","mainThreshold":"","dependentThresholdAdult":"","dependentThresholdChild":"","preferedHospitalProvider":"Any hospital","overallLimit":"Unlimited","coPayment":"View brochure for Day Hospital Procedures\\n ","rate":"100% of Negotiated Tariff","generalMedicin":"7 days' supply per event","specialist":"100% Scheme Rate + 200% for hospitalisation and surgical procedures                  ","dentistSurgical":"R1 000 co-pay per hospital admission (no-co-pay if day hospital is used depending on availability)\\n- 20% co-payment if authorisation was obtained after procedure has been done\\n- General anaesthetic for children under 5yrs and removal of impacted teeth\\nMaxillo-facial and Oral Surgery: 100% of Negotiated Tariff \\nSubject to PMBs pre-authorisation and treatment protocols","mentalHealth":"Psychiatric Hospitalisation (PMB)\\nLimited to R48 300 per member per admission at\\nR2 300 per day.\\n- 21 days per beneficiary, \\n- Includes (6) in-hospital psychiatrist consultations                  \\n- 4 additional out of hospital visits in lieu of hospitalisation \\nnon-PMB- limited to psychiatric emergencies and failed out-patient management\\nAlcoholism and drug addiction: \\n- PMB at DSP \\n- 3-day withdrawal treatment plus\\n- 21 days rehabilitation ","radiology":"100%  Scheme Rate","pathology":"100%  Scheme Rate","maternityBenefit":"In-Hospital admission: \\n- 100% of Scheme Rate\\n- Delivery by a GP, Specialist or Midwife\\n \\nSubject to registration on maternity programme \\n- 9 antenatal visits with GP / Midwife or Specialist\\n- 6 visits with Obstetrician, subject to referral from GP or Midwife\\n- 2 x 2D scans per pregnancy\\n- 2 x Haemoglobin Measurement tests\\n- 1 x Blood Grouping test\\n -1 x VDRL test for Syphilis\\n- 2 x HIV Blood tests\\n- 12 x Urine Analysis tests\\n- 1 x Full Blood Count (FBC) test\\n- Vitamins worth R114 (subject to day-to-day benefits) \\n ","dialysis":"PMBs at DSP","cancer":"\\n\\nR650 000 per beneficiary, thereafter with a 20% co-payment. Subject to PMBs, pre-authorisation and treatment protocols\\nNon-Cancer Specialised Drug Benefits (incl.\\nBiologics) : R130 000 per beneficiary p.a.\\n","transplant":"100% of Scheme rate\\nHarvesting, transport and donor fees - PMB only","mri":"In and out of hospital:\\nR43 138 per family per annum","prosthesisInternal":"\\nSubject to pre-authorisation, treatment protocols, DSPs and PMBs\\nSurgical and non-surgical prosthesis\\n- R65 052 per family \\n- 100% Scheme Rate","prosthesisExternal":"External prosthesis: \\n- subject to Internal Prosthesis benefit limit\\n\\nGeneral appliances:\\n- M: R3 196\\n- M1+ : R5 385\\n\\nHearing aids: \\n- R20 786 per family, every 3 yrs\\n\\nNon-motorised wheelchairs: \\n- R5 068 per family, every 4 yrs ","rehab":"Private Nursing: R10 486 per family","designatedServiceProvider":"Preferred provider","conditionsCovered":"CDL in PMB + 33 conditions","formulary":"Yes","partialLimits":"non-CDL conditions  \\nOverall Family Limit:\\nMember: R12 664\\nMember+1: R 25 361\\nMember+2: R 37 906\\nMember+3: R 50 581\\nMember+4: R 63 257\\nMember+5: R 75 943\\nMember+6+: R 88 630\\nPer Beneficiary sub-limit: R12 664\\n","preferredProvider":"DSP Providers","overallAnualLimit":"GP and Specialist visits, Acute Medicines, Pathology, Radiology and Physiotherapy limited to the following sub-limits:\\nM - R18 740\\nM+1 - R25 329\\nM+2 - R28 471\\nM+3 - R31 744\\nM+4 - R35 049\\nM+5 - R38 333\\nM+6 - R41 595\\n\\n","medicationOverCounter":"Included in Acute Medication limit","medicationPrescribed":"Subject to the day-to-day limit with the following sub-limits: 100% SEP plus SEP\\nM: R5 331\\nM+1: R9 436\\nM+2: R10 946\\nM+3: R12 456\\nM+4: R13 256\\nM+5: R13 956\\nM+6+: R14 645","practitionersGeneral":"Subject to the day-to-day benefit. Shared number of visits between GP and specialist visits:\\nM:12\\nM+1: 20\\nM+2: 25\\nM+3: 29\\nM+4: 30\\nM+5: 31\\nM+6+: 32","specialistsCover":"0","dentistryCover":"Consultations: 2 General check-ups per beneficiary\\nPlastic Dentures: 1 set per beneficiary per 4 year cycle\\nExtra Oral X-rays: 1 per beneficiary per 3 year cycle\\nFillings: Once per tooth in 720 days\\n\\nSubject to managed care protocols and pre-authorisation\\n \\n\\n","dentistryCoverSpecial":"20% co-payment apply to all related claims if authorisation is obtained after the procedure\\nCrowns and Bridges: \\n- 3 crowns per family, once per tooth in 5 year cycle\\nImplants: \\n- 2 implants p.b up to a max of R5 175 per implant over a 5 year period\\nOrthodontic treatment: \\n- beneficiaries between 9-18 years old\\n- subject to pre-auth and clinical protocols. \\nMetal frames: \\n- 2 partial frames per beneficiary\\n- every 5 years\\n- 2 per family per annum","optical":"Benefits in a 2 year period per beneficiary:\\n- 1 eye test at any PPN optometrist  \\n- Frames: R1 216                      \\n- Single vision: R202 per lens\\n- Bifocal: R438 per lens\\n- Multifocal: R804 per lens\\n- Contact Lenses: R1 984\\n\\n","ambulance":"Europ Assistance South Africa","international":"100% of Scheme rates payable in RSA currency\\nSubject to approval by Scheme","hospitalCoverAids":"Subject to registration on Disease Management Programme and PMB ","artTtreatment":"Subject to treatment protocols and registration on Disease Management Programme","preventative":"Wellness Programme\\n- Limit of  R1 631 per family per year\\n\\nWellness screening tests: \\n- Limited to R2 242 per family\\n- Limited to R284 per beneficiary\\n-  blood sugar, cholesterol, blood pressure, BMI and HIV screening test\\n\\nVaccines and preventative screening:\\n- mammogram for woman older than 40\\n- Pap smears for women older than 21\\n- PSA for men older than 40\\n- Subject to wellness screening limit\\n \\nOral contraceptives:\\n- R3 021 per family \\n\\nChiropractors and Homeopathy treatment: \\n- R2 310 per beneficiary","logo":"Sizwe.jpg"},{"company":"Siswe","name":"Essential Copper Option","planType":"Capitation","coverLevel":"Low","hospital":"Network","chronic":"Network","serviceType":"Network","familyIncome":"0 - R8500","mainContribution":"R1480","mainCompSavings":"R0.00","mainTotal":"R1480","dependendContributionAdult":"R1480","dependentCompSavingsAdult":"R0.00","dependentTotalAdult":"R1480","dependendContributionChild":"R510","dependentCompSavingsChild":"R0.00","dependentTotalChild":"R510","maxChildContribution":"3","mainThreshold":"","dependentThresholdAdult":"","dependentThresholdChild":"","preferedHospitalProvider":"PMB only � Network Option\\nView brochure for Day Hospital Procedures","overallLimit":"Unlimited ","coPayment":"10% co-payment if DSP is not used","rate":"100% of DSP Tariff","generalMedicin":"7 days' supply","specialist":"100% of Negotiated Tariff","dentistSurgical":"PMBs only\\nMaxillo-facial and oral surgery: no benefit","mentalHealth":"\\nPMB - 21 days per beneficiary per annum, OR 15 days out-of-hospital\\nDrug and Alcohol Rehabilitation\\n�PMB based on clinical protocols\\n�R12 855 per family per annum\\n\\n","radiology":"Limited to PMBs\\nOut-of-hosp: R898 per beneficiary per annum","pathology":"Limited to PMBs\\nOut-of-hosp: R898 per beneficiary per annum","maternityBenefit":"\\nIn-hospital: 100% Scheme Rate\\nNVD - 1 night and 2 days\\nEmergency Caesar - 2 nights and 3 days\\nHome Delivery : 100% of Negotiated Tariff\\nOut-of-hospital\\nSubject to DSP GP and Specialist consultation limit\\n3 x 2D scans per pregnancy\\n\\n ","dialysis":"100% of Negotiated Tariff, limited to PMBs","cancer":"100% of DSP Tariff\\nEnhanced protocols and PMB level of Care","transplant":"Limited to PMBs","mri":"In and out of hospital: PMBs only\\n�2 per beneficiary per annum\\n (10% co-payment for non-PMBs)","prosthesisInternal":"100% of Negotiated Tariff\\nShared limit with External Prosthesis\\nR20 435 per family, limited to PMB","prosthesisExternal":"Artificial limbs and external prostheses\\n(including artificial eyes)\\n- R9 705 subject to overall prosthesis limit\\n\\nGeneral Appliances:\\n- R3 035 per family - PMBs only \\nBlood pressure monitors - sub limit of R570 \\n(beneficiaries registered for Hypertension)","rehab":"In lieu of hospitalisation\\n100% of Negotiated Tariff\\n14 days per beneficiary per annum\\nSubject to PMB�s, pre-authorisation and protocols","designatedServiceProvider":"Yes","conditionsCovered":"CDL in PMB + 8 conditions","formulary":"Yes","partialLimits":"Subject to designated service providers, treatment protocols, medicine formulary and registration of the chronic medicine by DSP GP","preferredProvider":"DSP Network","overallAnualLimit":"None","medicationOverCounter":"None","medicationPrescribed":"R675 per family per annum, max of R105 per script","practitionersGeneral":"\\n\\n100% of Reference Price - unlimited Acute medication dispensed by the DSP GP \\nAcute medication obtained from DSP  pharmacy: \\nBeneficiary - R1 320  \\nFamily - R3 680 ","specialistsCover":"100% of DSP Tariff\\nUnlimited visits and medication dispensed by the DSP GP and medicine formulary\\n30% co-payment for GP consultations outside the DSP Network","dentistryCover":"Limited to 3 visits per family per annum on referral from DSP GP. PMB only","dentistryCoverSpecial":"100% of Negotiated Tariff\\nSubject to Dental Protocol and pre-auth","optical":"PMBs","ambulance":"100% of DSP Tariff comprehensive consultation per beneficiary\\n\\nFrames: R300 per beneficiary\\nR210 per lens - single vision or\\nR445 per lens - bifocal vision or multifocal vision\\nOR Contact Lenses: R645 per beneficiary\\nEvery 24 months","international":"Air/Road Ambulance and Emergency\\nSubject to preferred provider  ","hospitalCoverAids":"100% of Scheme rates payable in RSA currency\\nSubject to approval by Scheme","artTtreatment":"100% of Scheme Rate\\nTreatment is subject to the treatment Care plan and clinical protocols per CDL","preventative":"See Above","logo":"Sizwe.jpg"},{"company":"Siswe","name":"Essential Copper Option","planType":"Capitation","coverLevel":"Low","hospital":"Network","chronic":"Network","serviceType":"Network","familyIncome":"R8501 - R13000","mainContribution":"R1773","mainCompSavings":"R0.00","mainTotal":"R1773","dependendContributionAdult":"R1773","dependentCompSavingsAdult":"R0.00","dependentTotalAdult":"R1773","dependendContributionChild":"R655","dependentCompSavingsChild":"R0.00","dependentTotalChild":"R655","maxChildContribution":"3","mainThreshold":"","dependentThresholdAdult":"","dependentThresholdChild":"","preferedHospitalProvider":"PMB only � Network Option\\nView brochure for Day Hospital Procedures","overallLimit":"Unlimited ","coPayment":"10% co-payment if DSP is not used","rate":"100% of DSP Tariff","generalMedicin":"7 days' supply","specialist":"100% of Negotiated Tariff","dentistSurgical":"PMBs only\\nMaxillo-facial and oral surgery: no benefit","mentalHealth":"\\nPMB - 21 days per beneficiary per annum, OR 15 days out-of-hospital\\nDrug and Alcohol Rehabilitation\\n�PMB based on clinical protocols\\n�R12 855 per family per annum\\n\\n","radiology":"Limited to PMBs\\nOut-of-hosp: R898 per beneficiary per annum","pathology":"Limited to PMBs\\nOut-of-hosp: R898 per beneficiary per annum","maternityBenefit":"\\nIn-hospital: 100% Scheme Rate\\nNVD - 1 night and 2 days\\nEmergency Caesar - 2 nights and 3 days\\nHome Delivery : 100% of Negotiated Tariff\\nOut-of-hospital\\nSubject to DSP GP and Specialist consultation limit\\n3 x 2D scans per pregnancy\\n\\n ","dialysis":"100% of Negotiated Tariff, limited to PMBs","cancer":"100% of DSP Tariff\\nEnhanced protocols and PMB level of Care","transplant":"Limited to PMBs","mri":"In and out of hospital: PMBs only\\n�2 per beneficiary per annum\\n (10% co-payment for non-PMBs)","prosthesisInternal":"100% of Negotiated Tariff\\nShared limit with External Prosthesis\\nR20 435 per family, limited to PMB","prosthesisExternal":"Artificial limbs and external prostheses\\n(including artificial eyes)\\n- R9 705 subject to overall prosthesis limit\\n\\nGeneral Appliances:\\n- R3 035 per family - PMBs only \\nBlood pressure monitors - sub limit of R570 \\n(beneficiaries registered for Hypertension)","rehab":"In lieu of hospitalisation\\n100% of Negotiated Tariff\\n14 days per beneficiary per annum\\nSubject to PMB�s, pre-authorisation and protocols","designatedServiceProvider":"Yes","conditionsCovered":"CDL in PMB + 8 conditions","formulary":"Yes","partialLimits":"Subject to designated service providers, treatment protocols, medicine formulary and registration of the chronic medicine by DSP GP","preferredProvider":"DSP Network","overallAnualLimit":"None","medicationOverCounter":"None","medicationPrescribed":"R675 per family per annum, max of R105 per script","practitionersGeneral":"\\n\\n100% of Reference Price - unlimited Acute medication dispensed by the DSP GP \\nAcute medication obtained from DSP  pharmacy: \\nBeneficiary - R1 320  \\nFamily - R3 680 ","specialistsCover":"100% of DSP Tariff\\nUnlimited visits and medication dispensed by the DSP GP and medicine formulary\\n30% co-payment for GP consultations outside the DSP Network","dentistryCover":"Limited to 3 visits per family per annum on referral from DSP GP. PMB only","dentistryCoverSpecial":"100% of Negotiated Tariff\\nSubject to Dental Protocol and pre-auth","optical":"PMBs","ambulance":"100% of DSP Tariff comprehensive consultation per beneficiary\\n\\nFrames: R300 per beneficiary\\nR210 per lens - single vision or\\nR445 per lens - bifocal vision or multifocal vision\\nOR Contact Lenses: R645 per beneficiary\\nEvery 24 months","international":"Air/Road Ambulance and Emergency\\nSubject to preferred provider  ","hospitalCoverAids":"100% of Scheme rates payable in RSA currency\\nSubject to approval by Scheme","artTtreatment":"100% of Scheme Rate\\nTreatment is subject to the treatment Care plan and clinical protocols per CDL","preventative":"See Above","logo":"Sizwe.jpg"},{"company":"Siswe","name":"Essential Copper Option","planType":"Capitation","coverLevel":"Low","hospital":"Network","chronic":"Network","serviceType":"Network","familyIncome":"R13 001+","mainContribution":"R2250","mainCompSavings":"R0.00","mainTotal":"R2250","dependendContributionAdult":"R2250","dependentCompSavingsAdult":"R0.00","dependentTotalAdult":"R2250","dependendContributionChild":"R670","dependentCompSavingsChild":"R0.00","dependentTotalChild":"R670","maxChildContribution":"3","mainThreshold":"","dependentThresholdAdult":"","dependentThresholdChild":"","preferedHospitalProvider":"PMB only � Network Option\\nView brochure for Day Hospital Procedures","overallLimit":"Unlimited ","coPayment":"10% co-payment if DSP is not used","rate":"100% of DSP Tariff","generalMedicin":"7 days' supply","specialist":"100% of Negotiated Tariff","dentistSurgical":"PMBs only\\nMaxillo-facial and oral surgery: no benefit","mentalHealth":"\\nPMB - 21 days per beneficiary per annum, OR 15 days out-of-hospital\\nDrug and Alcohol Rehabilitation\\n�PMB based on clinical protocols\\n�R12 855 per family per annum\\n\\n","radiology":"Limited to PMBs\\nOut-of-hosp: R898 per beneficiary per annum","pathology":"Limited to PMBs\\nOut-of-hosp: R898 per beneficiary per annum","maternityBenefit":"\\nIn-hospital: 100% Scheme Rate\\nNVD - 1 night and 2 days\\nEmergency Caesar - 2 nights and 3 days\\nHome Delivery : 100% of Negotiated Tariff\\nOut-of-hospital\\nSubject to DSP GP and Specialist consultation limit\\n3 x 2D scans per pregnancy\\n\\n ","dialysis":"100% of Negotiated Tariff, limited to PMBs","cancer":"100% of DSP Tariff\\nEnhanced protocols and PMB level of Care","transplant":"Limited to PMBs","mri":"In and out of hospital: PMBs only\\n�2 per beneficiary per annum\\n (10% co-payment for non-PMBs)","prosthesisInternal":"100% of Negotiated Tariff\\nShared limit with External Prosthesis\\nR20 435 per family, limited to PMB","prosthesisExternal":"Artificial limbs and external prostheses\\n(including artificial eyes)\\n- R9 705 subject to overall prosthesis limit\\n\\nGeneral Appliances:\\n- R3 035 per family - PMBs only \\nBlood pressure monitors - sub limit of R570 \\n(beneficiaries registered for Hypertension)","rehab":"In lieu of hospitalisation\\n100% of Negotiated Tariff\\n14 days per beneficiary per annum\\nSubject to PMB�s, pre-authorisation and protocols","designatedServiceProvider":"Yes","conditionsCovered":"CDL in PMB + 8 conditions","formulary":"Yes","partialLimits":"Subject to designated service providers, treatment protocols, medicine formulary and registration of the chronic medicine by DSP GP","preferredProvider":"DSP Network","overallAnualLimit":"None","medicationOverCounter":"None","medicationPrescribed":"R675 per family per annum, max of R105 per script","practitionersGeneral":"\\n\\n100% of Reference Price - unlimited Acute medication dispensed by the DSP GP \\nAcute medication obtained from DSP  pharmacy: \\nBeneficiary - R1 320  \\nFamily - R3 680 ","specialistsCover":"100% of DSP Tariff\\nUnlimited visits and medication dispensed by the DSP GP and medicine formulary\\n30% co-payment for GP consultations outside the DSP Network","dentistryCover":"Limited to 3 visits per family per annum on referral from DSP GP. PMB only","dentistryCoverSpecial":"100% of Negotiated Tariff\\nSubject to Dental Protocol and pre-auth","optical":"PMBs","ambulance":"100% of DSP Tariff comprehensive consultation per beneficiary\\n\\nFrames: R300 per beneficiary\\nR210 per lens - single vision or\\nR445 per lens - bifocal vision or multifocal vision\\nOR Contact Lenses: R645 per beneficiary\\nEvery 24 months","international":"Air/Road Ambulance and Emergency\\nSubject to preferred provider  ","hospitalCoverAids":"100% of Scheme rates payable in RSA currency\\nSubject to approval by Scheme","artTtreatment":"100% of Scheme Rate\\nTreatment is subject to the treatment Care plan and clinical protocols per CDL","preventative":"See Above","logo":"Sizwe.jpg"}];

/***/ }),
/* 743 */
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 744 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return gapDetails; });
var gapDetails=[{"company":"Agility (Health Squared)","plan":"Gap 200","coPay":"Gap","level":200,"age":"o,<,65","single":"R88","family":"R88","logo":"agility.png"},{"company":"Agility (Health Squared)","plan":"Gap 200","coPay":"Gap","level":200,"age":"o,>,64","single":"R149","family":"R149","logo":"agility.png"},{"company":"Agility (Health Squared)","plan":"Gap 500","coPay":"Gap","level":500,"age":"o,<,65","single":"R180","family":"R180","logo":"agility.png"},{"company":"Agility (Health Squared)","plan":"Gap 500","coPay":"Gap","level":500,"age":"o,>,64","single":"R242","family":"R242","logo":"agility.png"},{"company":"Agility (Health Squared)","plan":"Combined 200","coPay":"Gap + co","level":200,"age":"o,<,65","single":"R148","family":"R148","logo":"agility.png"},{"company":"Agility (Health Squared)","plan":"Combined 200","coPay":"Gap + co","level":200,"age":"o,>,64","single":"R207","family":"R207","logo":"agility.png"},{"company":"Agility (Health Squared)","plan":"Combined 350","coPay":"Gap + co","level":350,"age":"o,<,65","single":"R230","family":"R230","logo":"agility.png"},{"company":"Agility (Health Squared)","plan":"Combined 350","coPay":"Gap + co","level":350,"age":"o,>,64","single":"R288","family":"R288","logo":"agility.png"},{"company":"Agility (Health Squared)","plan":"Combined 500","coPay":"Gap + co","level":500,"age":"o,<,65","single":"R303","family":"R303","logo":"agility.png"},{"company":"Agility (Health Squared)","plan":"Combined 500","coPay":"Gap + co","level":500,"age":"o,>,64","single":"R353","family":"R353","logo":"agility.png"},{"company":"Agility (Health Squared)","plan":"Combined ultra","coPay":"Gap + co","level":500,"age":"o,<,65","single":"R437","family":"R437","logo":"agility.png"},{"company":"Agility (Health Squared)","plan":"Combined ultra","coPay":"Gap + co","level":500,"age":"o,>,64","single":"R502","family":"R502","logo":"agility.png"},{"company":"Curemed","plan":"Basic cover 300 (Curemed)","coPay":"Gap","level":300,"age":"p,<,65","single":"R99","family":"R165","logo":"curemed.png"},{"company":"Curemed","plan":"Basic cover 300 (Curemed)","coPay":"Gap","level":300,"age":"p,>,64","single":"R330","family":"R330","logo":"curemed.png"},{"company":"Curemed","plan":"Vital cover plus","coPay":"Gap + co","level":700,"age":"p,<,65","single":"R220","family":"R220","logo":"curemed.png"},{"company":"Curemed","plan":"Vital cover plus","coPay":"Gap + co","level":700,"age":"p,>,64","single":"R330","family":"R330","logo":"curemed.png"},{"company":"Curemed","plan":"Super cover plus","coPay":"Gap + co","level":700,"age":"p,<,65","single":"R250","family":"R250","logo":"curemed.png"},{"company":"Curemed","plan":"Super cover plus","coPay":"Gap + co","level":700,"age":"p,>,64","single":"R360","family":"R360","logo":"curemed.png"},{"company":"Curemed","plan":"Absolute cover plus","coPay":"Gap + co","level":700,"age":"p,<,65","single":"R450","family":"R450","logo":"curemed.png"},{"company":"Curemed","plan":"Absolute cover plus","coPay":"Gap + co","level":700,"age":"p,>,64","single":"R550","family":"R550","logo":"curemed.png"},{"company":"Discovery","plan":"Comprehensive (Exclusive and classic Plans)","coPay":"Gap + co","level":500,"age":"o,<,45","single":"R159","family":"R270","logo":"Discovery.png"},{"company":"Discovery","plan":"Comprehensive (Exclusive and classic Plans)","coPay":"Gap + co","level":500,"age":"o,<,65","single":"R270","family":"R410","logo":"Discovery.png"},{"company":"Discovery","plan":"Comprehensive (Exclusive and classic Plans)","coPay":"Gap + co","level":500,"age":"o,>,64","single":"R345","family":"R570","logo":"Discovery.png"},{"company":"Discovery","plan":"Comprehensive (Essencial and coastal plans)","coPay":"Gap + co","level":500,"age":"o,<,45","single":"R300","family":"R685","logo":"Discovery.png"},{"company":"Discovery","plan":"Comprehensive (Essencial and coastal plans)","coPay":"Gap + co","level":500,"age":"o,<,65","single":"R549","family":"R1,045","logo":"Discovery.png"},{"company":"Discovery","plan":"Comprehensive (Essencial and coastal plans)","coPay":"Gap + co","level":500,"age":"o,>,64","single":"R730","family":"R1,375","logo":"Discovery.png"},{"company":"Discovery","plan":"Core (Exclusive and classic Plans)","coPay":"Gap + co","level":250,"age":"o,<,45","single":"R100","family":"R175","logo":"Discovery.png"},{"company":"Discovery","plan":"Core (Exclusive and classic Plans)","coPay":"Gap + co","level":250,"age":"o,<,65","single":"R180","family":"R215","logo":"Discovery.png"},{"company":"Discovery","plan":"Core (Exclusive and classic Plans)","coPay":"Gap + co","level":250,"age":"o,>,64","single":"R210","family":"R315","logo":"Discovery.png"},{"company":"Discovery","plan":"Core (Essencial and coastal plans)","coPay":"Gap + co","level":250,"age":"o,<,45","single":"R205","family":"R480","logo":"Discovery.png"},{"company":"Discovery","plan":"Core (Essencial and coastal plans)","coPay":"Gap + co","level":250,"age":"o,<,65","single":"R465","family":"R699","logo":"Discovery.png"},{"company":"Discovery","plan":"Core (Essencial and coastal plans)","coPay":"Gap + co","level":250,"age":"o,>,64","single":"R695","family":"R1,115","logo":"Discovery.png"},{"company":"Liberty (Zest)","plan":"Essential","coPay":"Gap","level":300,"age":"p,<,45","single":"R296","family":"R372","logo":"zest.jpg"},{"company":"Liberty (Zest)","plan":"Essential","coPay":"Gap","level":300,"age":"p,<,65","single":"R372","family":"R372","logo":"zest.jpg"},{"company":"Liberty (Zest)","plan":"Essential","coPay":"Gap","level":300,"age":"p,>,64","single":"R424","family":"R424","logo":"zest.jpg"},{"company":"Liberty (Zest)","plan":"Univesal","coPay":"Gap + co","level":500,"age":"p,<,45","single":"R401","family":"R506","logo":"zest.jpg"},{"company":"Liberty (Zest)","plan":"Univesal","coPay":"Gap + co","level":500,"age":"p,<,65","single":"R506","family":"R506","logo":"zest.jpg"},{"company":"Liberty (Zest)","plan":"Univesal","coPay":"Gap + co","level":500,"age":"p,>,64","single":"R568","family":"R568","logo":"zest.jpg"},{"company":"Medgap (Bonitas)","plan":"Primary ","coPay":"Gap + co","level":300,"age":"p,<,31","single":"R185","family":"N/A","logo":"medgap.png"},{"company":"Medgap (Bonitas)","plan":"Primary","coPay":"Gap + co","level":300,"age":"p,<,65","single":"R305","family":"R305","logo":"medgap.png"},{"company":"Medgap (Bonitas)","plan":"Primary","coPay":"Gap + co","level":300,"age":"p,>,64","single":"R529","family":"R529","logo":"medgap.png"},{"company":"Medgap (Bonitas)","plan":"Supreme ","coPay":"Gap + co","level":300,"age":"p,<,31","single":"R230","family":"N/A","logo":"medgap.png"},{"company":"Medgap (Bonitas)","plan":"Supreme","coPay":"Gap + co","level":300,"age":"p,<,65","single":"R382","family":"R382","logo":"medgap.png"},{"company":"Medgap (Bonitas)","plan":"Supreme","coPay":"Gap + co","level":300,"age":"p,>,64","single":"R562","family":"R562","logo":"medgap.png"},{"company":"Momentum","plan":"Momentum Gap cover","coPay":"Gap + co","level":300,"age":"p,<,43","single":"R296","family":"R296","logo":"momentumMed.png"},{"company":"Momentum","plan":"Momentum Gap cover","coPay":"Gap + co","level":300,"age":"p,<,42","single":"R417","family":"R417","logo":"momentumMed.png"},{"company":"Momentum","plan":"Momentum Gap cover","coPay":"Gap + co","level":300,"age":"p,>,64","single":"R537","family":"R537","logo":"momentumMed.png"},{"company":"Sirago","plan":"Ultimate gap cover","coPay":"Gap + co","level":500,"age":"o,<,55","single":"R413","family":"R467","logo":"sirago.png"},{"company":"Sirago","plan":"Ultimate gap cover","coPay":"Gap + co","level":500,"age":"o,<,65","single":"R491","family":"R556","logo":"sirago.png"},{"company":"Sirago","plan":"Ultimate gap cover","coPay":"Gap + co","level":500,"age":"o,>,64","single":"R569","family":"R645","logo":"sirago.png"},{"company":"Sirago","plan":"Plus gap cover","coPay":"Gap + co","level":500,"age":"o,<,55","single":"R324","family":"R370","logo":"sirago.png"},{"company":"Sirago","plan":"Plus gap cover","coPay":"Gap + co","level":500,"age":"o,<,65","single":"R400","family":"R457","logo":"sirago.png"},{"company":"Sirago","plan":"Plus gap cover","coPay":"Gap + co","level":500,"age":"o,>,64","single":"R475","family":"R543","logo":"sirago.png"},{"company":"Sirago","plan":"Gap assist cover","coPay":"Gap + co","level":500,"age":"o,<,55","single":"R278","family":"R299","logo":"sirago.png"},{"company":"Sirago","plan":"Gap assist cover","coPay":"Gap + co","level":500,"age":"o,<,65","single":"R344","family":"R371","logo":"sirago.png"},{"company":"Sirago","plan":"Gap assist cover","coPay":"Gap + co","level":500,"age":"o,>,64","single":"R409","family":"R443","logo":"sirago.png"},{"company":"Sirago","plan":"Gap life cover","coPay":"Gap + co","level":200,"age":"o,<,55","single":"R203","family":"R218","logo":"sirago.png"},{"company":"Sirago","plan":"Gap life cover","coPay":"Gap + co","level":200,"age":"o,<,65","single":"R244","family":"R272","logo":"sirago.png"},{"company":"Sirago","plan":"Gap life cover","coPay":"Gap + co","level":200,"age":"o,>,64","single":"R285","family":"R325","logo":"sirago.png"},{"company":"Stratum","plan":"Elite","coPay":"Gap","level":500,"age":"o,<,65","single":"R342","family":"R420","logo":"stratum.jpg"},{"company":"Stratum","plan":"Elite","coPay":"Gap","level":500,"age":"o,>,64","single":"R555","family":"R679","logo":"stratum.jpg"},{"company":"Stratum","plan":"Co-evolution","coPay":"Gap + co","level":500,"age":"o,<,65","single":"R236","family":"R306","logo":"stratum.jpg"},{"company":"Stratum","plan":"Co-evolution","coPay":"Gap + co","level":500,"age":"o,>,64","single":"R473","family":"R473","logo":"stratum.jpg"},{"company":"Stratum","plan":"Base","coPay":"Gap","level":500,"age":"o,<,65","single":"R213","family":"R250","logo":"stratum.jpg"},{"company":"Stratum","plan":"Base","coPay":"Gap","level":500,"age":"o,>,64","single":"R414","family":"R414","logo":"stratum.jpg"},{"company":"Stratum","plan":"Compact 200","coPay":"Gap + co","level":200,"age":"o,<,65","single":"R213","family":"R248","logo":"stratum.jpg"},{"company":"Stratum","plan":"Compact 200","coPay":"Gap + co","level":200,"age":"o,>,64","single":"R414","family":"R414","logo":"stratum.jpg"},{"company":"Stratum","plan":"Access optimiser plus","coPay":"Gap","level":200,"age":"o,<,65","single":"R299","family":"R345","logo":"stratum.jpg"},{"company":"Stratum","plan":"Access optimiser plus","coPay":"Gap","level":200,"age":"o,>,64","single":"R383","family":"R467","logo":"stratum.jpg"},{"company":"TRA (Total risk administrators)","plan":"Basic cover 300","coPay":"Gap","level":300,"age":"p,<,65","single":"R99","family":"R165","logo":"tra.svg"},{"company":"TRA (Total risk administrators)","plan":"Basic cover 300","coPay":"Gap","level":300,"age":"p,>,64","single":"R330","family":"R330","logo":"tra.svg"},{"company":"TRA (Total risk administrators)","plan":"Vital cover plus","coPay":"Gap + co","level":700,"age":"p,<,65","single":"R220","family":"R220","logo":"tra.svg"},{"company":"TRA (Total risk administrators)","plan":"Vital cover plus","coPay":"Gap + co","level":700,"age":"p,>,64","single":"R330","family":"R330","logo":"tra.svg"},{"company":"TRA (Total risk administrators)","plan":"Super cover plus","coPay":"Gap + co","level":700,"age":"p,<,65","single":"R250","family":"R250","logo":"tra.svg"},{"company":"TRA (Total risk administrators)","plan":"Super cover plus","coPay":"Gap + co","level":700,"age":"p,>,64","single":"R360","family":"R360","logo":"tra.svg"},{"company":"TRA (Total risk administrators)","plan":"Absolute cover plus","coPay":"Gap + co","level":700,"age":"p,<,65","single":"R450","family":"R450","logo":"tra.svg"},{"company":"TRA (Total risk administrators)","plan":"Absolute cover plus","coPay":"Gap + co","level":700,"age":"p,>,64","single":"R550","family":"R550","logo":"tra.svg"},{"company":"Turnberry","plan":"Premier","coPay":"Gap + co","level":600,"age":"p,<,65","single":"R421","family":"R421","logo":"turnberry.png"},{"company":"Turnberry","plan":"Premier","coPay":"Gap + co","level":600,"age":"p,>,64","single":"R592","family":"R592","logo":"turnberry.png"},{"company":"Turnberry","plan":"Optimal","coPay":"Gap + co","level":500,"age":"p,<,65","single":"R341","family":"R341","logo":"turnberry.png"},{"company":"Turnberry","plan":"Optimal","coPay":"Gap + co","level":500,"age":"p,>,64","single":"R451","family":"R451","logo":"turnberry.png"},{"company":"Turnberry","plan":"Synergy","coPay":"Gap + co","level":500,"age":"p,<,65","single":"R268","family":"R268","logo":"turnberry.png"},{"company":"Turnberry","plan":"Synergy","coPay":"Gap + co","level":500,"age":"p,>,64","single":"R367","family":"R367","logo":"turnberry.png"},{"company":"Turnberry","plan":"Launch","coPay":"Gap","level":350,"age":"p,<,65","single":"R121","family":"R121","logo":"turnberry.png"},{"company":"Turnberry","plan":"Launch","coPay":"Gap","level":350,"age":"p,>,64","single":"R214","family":"R214","logo":"turnberry.png"}];

/***/ }),
/* 745 */
/***/ (function(module, exports, __webpack_require__) {

var sax = __webpack_require__(2840);
var expat /*= require('node-expat');*/ = { on: function () { }, parse: function () { } };
var helper = __webpack_require__(429);
var isArray = __webpack_require__(430).isArray;

var options;
var pureJsParser = true;
var currentElement;

function validateOptions(userOptions) {
  options = helper.copyOptions(userOptions);
  helper.ensureFlagExists('ignoreDeclaration', options);
  helper.ensureFlagExists('ignoreInstruction', options);
  helper.ensureFlagExists('ignoreAttributes', options);
  helper.ensureFlagExists('ignoreText', options);
  helper.ensureFlagExists('ignoreComment', options);
  helper.ensureFlagExists('ignoreCdata', options);
  helper.ensureFlagExists('ignoreDoctype', options);
  helper.ensureFlagExists('compact', options);
  helper.ensureFlagExists('alwaysChildren', options);
  helper.ensureFlagExists('addParent', options);
  helper.ensureFlagExists('trim', options);
  helper.ensureFlagExists('nativeType', options);
  helper.ensureFlagExists('nativeTypeAttributes', options);
  helper.ensureFlagExists('sanitize', options);
  helper.ensureFlagExists('instructionHasAttributes', options);
  helper.ensureFlagExists('captureSpacesBetweenElements', options);
  helper.ensureAlwaysArrayExists(options);
  helper.ensureKeyExists('declaration', options);
  helper.ensureKeyExists('instruction', options);
  helper.ensureKeyExists('attributes', options);
  helper.ensureKeyExists('text', options);
  helper.ensureKeyExists('comment', options);
  helper.ensureKeyExists('cdata', options);
  helper.ensureKeyExists('doctype', options);
  helper.ensureKeyExists('type', options);
  helper.ensureKeyExists('name', options);
  helper.ensureKeyExists('elements', options);
  helper.ensureKeyExists('parent', options);
  helper.checkFnExists('doctype', options);
  helper.checkFnExists('instruction', options);
  helper.checkFnExists('cdata', options);
  helper.checkFnExists('comment', options);
  helper.checkFnExists('text', options);
  helper.checkFnExists('instructionName', options);
  helper.checkFnExists('elementName', options);
  helper.checkFnExists('attributeName', options);
  helper.checkFnExists('attributeValue', options);
  helper.checkFnExists('attributes', options);
  return options;
}

function nativeType(value) {
  var nValue = Number(value);
  if (!isNaN(nValue)) {
    return nValue;
  }
  var bValue = value.toLowerCase();
  if (bValue === 'true') {
    return true;
  } else if (bValue === 'false') {
    return false;
  }
  return value;
}

function addField(type, value) {
  var key;
  if (options.compact) {
    if (
      !currentElement[options[type + 'Key']] &&
      (isArray(options.alwaysArray) ? options.alwaysArray.indexOf(options[type + 'Key']) !== -1 : options.alwaysArray)
    ) {
      currentElement[options[type + 'Key']] = [];
    }
    if (currentElement[options[type + 'Key']] && !isArray(currentElement[options[type + 'Key']])) {
      currentElement[options[type + 'Key']] = [currentElement[options[type + 'Key']]];
    }
    if (type + 'Fn' in options && typeof value === 'string') {
      value = options[type + 'Fn'](value, currentElement);
    }
    if (type === 'instruction' && ('instructionFn' in options || 'instructionNameFn' in options)) {
      for (key in value) {
        if (value.hasOwnProperty(key)) {
          if ('instructionFn' in options) {
            value[key] = options.instructionFn(value[key], key, currentElement);
          } else {
            var temp = value[key];
            delete value[key];
            value[options.instructionNameFn(key, temp, currentElement)] = temp;
          }
        }
      }
    }
    if (isArray(currentElement[options[type + 'Key']])) {
      currentElement[options[type + 'Key']].push(value);
    } else {
      currentElement[options[type + 'Key']] = value;
    }
  } else {
    if (!currentElement[options.elementsKey]) {
      currentElement[options.elementsKey] = [];
    }
    var element = {};
    element[options.typeKey] = type;
    if (type === 'instruction') {
      for (key in value) {
        if (value.hasOwnProperty(key)) {
          break;
        }
      }
      element[options.nameKey] = 'instructionNameFn' in options ? options.instructionNameFn(key, value, currentElement) : key;
      if (options.instructionHasAttributes) {
        element[options.attributesKey] = value[key][options.attributesKey];
        if ('instructionFn' in options) {
          element[options.attributesKey] = options.instructionFn(element[options.attributesKey], key, currentElement);
        }
      } else {
        if ('instructionFn' in options) {
          value[key] = options.instructionFn(value[key], key, currentElement);
        }
        element[options.instructionKey] = value[key];
      }
    } else {
      if (type + 'Fn' in options) {
        value = options[type + 'Fn'](value, currentElement);
      }
      element[options[type + 'Key']] = value;
    }
    if (options.addParent) {
      element[options.parentKey] = currentElement;
    }
    currentElement[options.elementsKey].push(element);
  }
}

function manipulateAttributes(attributes) {
  if ('attributesFn' in options && attributes) {
    attributes = options.attributesFn(attributes, currentElement);
  }
  if ((options.trim || 'attributeValueFn' in options || 'attributeNameFn' in options || options.nativeTypeAttributes) && attributes) {
    var key;
    for (key in attributes) {
      if (attributes.hasOwnProperty(key)) {
        if (options.trim) attributes[key] = attributes[key].trim();
        if (options.nativeTypeAttributes) {
          attributes[key] = nativeType(attributes[key]);
        }
        if ('attributeValueFn' in options) attributes[key] = options.attributeValueFn(attributes[key], key, currentElement);
        if ('attributeNameFn' in options) {
          var temp = attributes[key];
          delete attributes[key];
          attributes[options.attributeNameFn(key, attributes[key], currentElement)] = temp;
        }
      }
    }
  }
  return attributes;
}

function onInstruction(instruction) {
  var attributes = {};
  if (instruction.body && (instruction.name.toLowerCase() === 'xml' || options.instructionHasAttributes)) {
    var attrsRegExp = /([\w:-]+)\s*=\s*(?:"([^"]*)"|'([^']*)'|(\w+))\s*/g;
    var match;
    while ((match = attrsRegExp.exec(instruction.body)) !== null) {
      attributes[match[1]] = match[2] || match[3] || match[4];
    }
    attributes = manipulateAttributes(attributes);
  }
  if (instruction.name.toLowerCase() === 'xml') {
    if (options.ignoreDeclaration) {
      return;
    }
    currentElement[options.declarationKey] = {};
    if (Object.keys(attributes).length) {
      currentElement[options.declarationKey][options.attributesKey] = attributes;
    }
    if (options.addParent) {
      currentElement[options.declarationKey][options.parentKey] = currentElement;
    }
  } else {
    if (options.ignoreInstruction) {
      return;
    }
    if (options.trim) {
      instruction.body = instruction.body.trim();
    }
    var value = {};
    if (options.instructionHasAttributes && Object.keys(attributes).length) {
      value[instruction.name] = {};
      value[instruction.name][options.attributesKey] = attributes;
    } else {
      value[instruction.name] = instruction.body;
    }
    addField('instruction', value);
  }
}

function onStartElement(name, attributes) {
  var element;
  if (typeof name === 'object') {
    attributes = name.attributes;
    name = name.name;
  }
  attributes = manipulateAttributes(attributes);
  if ('elementNameFn' in options) {
    name = options.elementNameFn(name, currentElement);
  }
  if (options.compact) {
    element = {};
    if (!options.ignoreAttributes && attributes && Object.keys(attributes).length) {
      element[options.attributesKey] = {};
      var key;
      for (key in attributes) {
        if (attributes.hasOwnProperty(key)) {
          element[options.attributesKey][key] = attributes[key];
        }
      }
    }
    if (
      !(name in currentElement) &&
      (isArray(options.alwaysArray) ? options.alwaysArray.indexOf(name) !== -1 : options.alwaysArray)
    ) {
      currentElement[name] = [];
    }
    if (currentElement[name] && !isArray(currentElement[name])) {
      currentElement[name] = [currentElement[name]];
    }
    if (isArray(currentElement[name])) {
      currentElement[name].push(element);
    } else {
      currentElement[name] = element;
    }
  } else {
    if (!currentElement[options.elementsKey]) {
      currentElement[options.elementsKey] = [];
    }
    element = {};
    element[options.typeKey] = 'element';
    element[options.nameKey] = name;
    if (!options.ignoreAttributes && attributes && Object.keys(attributes).length) {
      element[options.attributesKey] = attributes;
    }
    if (options.alwaysChildren) {
      element[options.elementsKey] = [];
    }
    currentElement[options.elementsKey].push(element);
  }
  element[options.parentKey] = currentElement; // will be deleted in onEndElement() if !options.addParent
  currentElement = element;
}

function onText(text) {
  if (options.ignoreText) {
    return;
  }
  if (!text.trim() && !options.captureSpacesBetweenElements) {
    return;
  }
  if (options.trim) {
    text = text.trim();
  }
  if (options.nativeType) {
    text = nativeType(text);
  }
  if (options.sanitize) {
    text = text.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }
  addField('text', text);
}

function onComment(comment) {
  if (options.ignoreComment) {
    return;
  }
  if (options.trim) {
    comment = comment.trim();
  }
  addField('comment', comment);
}

function onEndElement(name) {
  var parentElement = currentElement[options.parentKey];
  if (!options.addParent) {
    delete currentElement[options.parentKey];
  }
  currentElement = parentElement;
}

function onCdata(cdata) {
  if (options.ignoreCdata) {
    return;
  }
  if (options.trim) {
    cdata = cdata.trim();
  }
  addField('cdata', cdata);
}

function onDoctype(doctype) {
  if (options.ignoreDoctype) {
    return;
  }
  doctype = doctype.replace(/^ /, '');
  if (options.trim) {
    doctype = doctype.trim();
  }
  addField('doctype', doctype);
}

function onError(error) {
  error.note = error; //console.error(error);
}

module.exports = function (xml, userOptions) {

  var parser = pureJsParser ? sax.parser(true, {}) : parser = new expat.Parser('UTF-8');
  var result = {};
  currentElement = result;

  options = validateOptions(userOptions);

  if (pureJsParser) {
    parser.opt = {strictEntities: true};
    parser.onopentag = onStartElement;
    parser.ontext = onText;
    parser.oncomment = onComment;
    parser.onclosetag = onEndElement;
    parser.onerror = onError;
    parser.oncdata = onCdata;
    parser.ondoctype = onDoctype;
    parser.onprocessinginstruction = onInstruction;
  } else {
    parser.on('startElement', onStartElement);
    parser.on('text', onText);
    parser.on('comment', onComment);
    parser.on('endElement', onEndElement);
    parser.on('error', onError);
    //parser.on('startCdata', onStartCdata);
    //parser.on('endCdata', onEndCdata);
    //parser.on('entityDecl', onEntityDecl);
  }

  if (pureJsParser) {
    parser.write(xml).close();
  } else {
    if (!parser.parse(xml)) {
      throw new Error('XML parsing error: ' + parser.getError());
    }
  }

  if (result[options.elementsKey]) {
    var temp = result[options.elementsKey];
    delete result[options.elementsKey];
    result[options.elementsKey] = temp;
    delete result.text;
  }

  return result;

};


/***/ }),
/* 746 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, process) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



/*<replacement>*/

var pna = __webpack_require__(288);
/*</replacement>*/

module.exports = Readable;

/*<replacement>*/
var isArray = __webpack_require__(695);
/*</replacement>*/

/*<replacement>*/
var Duplex;
/*</replacement>*/

Readable.ReadableState = ReadableState;

/*<replacement>*/
var EE = __webpack_require__(425).EventEmitter;

var EElistenerCount = function (emitter, type) {
  return emitter.listeners(type).length;
};
/*</replacement>*/

/*<replacement>*/
var Stream = __webpack_require__(747);
/*</replacement>*/

/*<replacement>*/

var Buffer = __webpack_require__(289).Buffer;
var OurUint8Array = global.Uint8Array || function () {};
function _uint8ArrayToBuffer(chunk) {
  return Buffer.from(chunk);
}
function _isUint8Array(obj) {
  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
}

/*</replacement>*/

/*<replacement>*/
var util = __webpack_require__(208);
util.inherits = __webpack_require__(118);
/*</replacement>*/

/*<replacement>*/
var debugUtil = __webpack_require__(2842);
var debug = void 0;
if (debugUtil && debugUtil.debuglog) {
  debug = debugUtil.debuglog('stream');
} else {
  debug = function () {};
}
/*</replacement>*/

var BufferList = __webpack_require__(2843);
var destroyImpl = __webpack_require__(748);
var StringDecoder;

util.inherits(Readable, Stream);

var kProxyEvents = ['error', 'close', 'destroy', 'pause', 'resume'];

function prependListener(emitter, event, fn) {
  // Sadly this is not cacheable as some libraries bundle their own
  // event emitter implementation with them.
  if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);

  // This is a hack to make sure that our error handler is attached before any
  // userland ones.  NEVER DO THIS. This is here only because this code needs
  // to continue to work with older versions of Node.js that do not include
  // the prependListener() method. The goal is to eventually remove this hack.
  if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);else if (isArray(emitter._events[event])) emitter._events[event].unshift(fn);else emitter._events[event] = [fn, emitter._events[event]];
}

function ReadableState(options, stream) {
  Duplex = Duplex || __webpack_require__(124);

  options = options || {};

  // Duplex streams are both readable and writable, but share
  // the same options object.
  // However, some cases require setting options to different
  // values for the readable and the writable sides of the duplex stream.
  // These options can be provided separately as readableXXX and writableXXX.
  var isDuplex = stream instanceof Duplex;

  // object stream flag. Used to make read(n) ignore n and to
  // make all the buffer merging and length checks go away
  this.objectMode = !!options.objectMode;

  if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;

  // the point at which it stops calling _read() to fill the buffer
  // Note: 0 is a valid value, means "don't call _read preemptively ever"
  var hwm = options.highWaterMark;
  var readableHwm = options.readableHighWaterMark;
  var defaultHwm = this.objectMode ? 16 : 16 * 1024;

  if (hwm || hwm === 0) this.highWaterMark = hwm;else if (isDuplex && (readableHwm || readableHwm === 0)) this.highWaterMark = readableHwm;else this.highWaterMark = defaultHwm;

  // cast to ints.
  this.highWaterMark = Math.floor(this.highWaterMark);

  // A linked list is used to store data chunks instead of an array because the
  // linked list can remove elements from the beginning faster than
  // array.shift()
  this.buffer = new BufferList();
  this.length = 0;
  this.pipes = null;
  this.pipesCount = 0;
  this.flowing = null;
  this.ended = false;
  this.endEmitted = false;
  this.reading = false;

  // a flag to be able to tell if the event 'readable'/'data' is emitted
  // immediately, or on a later tick.  We set this to true at first, because
  // any actions that shouldn't happen until "later" should generally also
  // not happen before the first read call.
  this.sync = true;

  // whenever we return null, then we set a flag to say
  // that we're awaiting a 'readable' event emission.
  this.needReadable = false;
  this.emittedReadable = false;
  this.readableListening = false;
  this.resumeScheduled = false;

  // has it been destroyed
  this.destroyed = false;

  // Crypto is kind of old and crusty.  Historically, its default string
  // encoding is 'binary' so we have to make this configurable.
  // Everything else in the universe uses 'utf8', though.
  this.defaultEncoding = options.defaultEncoding || 'utf8';

  // the number of writers that are awaiting a drain event in .pipe()s
  this.awaitDrain = 0;

  // if true, a maybeReadMore has been scheduled
  this.readingMore = false;

  this.decoder = null;
  this.encoding = null;
  if (options.encoding) {
    if (!StringDecoder) StringDecoder = __webpack_require__(428).StringDecoder;
    this.decoder = new StringDecoder(options.encoding);
    this.encoding = options.encoding;
  }
}

function Readable(options) {
  Duplex = Duplex || __webpack_require__(124);

  if (!(this instanceof Readable)) return new Readable(options);

  this._readableState = new ReadableState(options, this);

  // legacy
  this.readable = true;

  if (options) {
    if (typeof options.read === 'function') this._read = options.read;

    if (typeof options.destroy === 'function') this._destroy = options.destroy;
  }

  Stream.call(this);
}

Object.defineProperty(Readable.prototype, 'destroyed', {
  get: function () {
    if (this._readableState === undefined) {
      return false;
    }
    return this._readableState.destroyed;
  },
  set: function (value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (!this._readableState) {
      return;
    }

    // backward compatibility, the user is explicitly
    // managing destroyed
    this._readableState.destroyed = value;
  }
});

Readable.prototype.destroy = destroyImpl.destroy;
Readable.prototype._undestroy = destroyImpl.undestroy;
Readable.prototype._destroy = function (err, cb) {
  this.push(null);
  cb(err);
};

// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
Readable.prototype.push = function (chunk, encoding) {
  var state = this._readableState;
  var skipChunkCheck;

  if (!state.objectMode) {
    if (typeof chunk === 'string') {
      encoding = encoding || state.defaultEncoding;
      if (encoding !== state.encoding) {
        chunk = Buffer.from(chunk, encoding);
        encoding = '';
      }
      skipChunkCheck = true;
    }
  } else {
    skipChunkCheck = true;
  }

  return readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
};

// Unshift should *always* be something directly out of read()
Readable.prototype.unshift = function (chunk) {
  return readableAddChunk(this, chunk, null, true, false);
};

function readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
  var state = stream._readableState;
  if (chunk === null) {
    state.reading = false;
    onEofChunk(stream, state);
  } else {
    var er;
    if (!skipChunkCheck) er = chunkInvalid(state, chunk);
    if (er) {
      stream.emit('error', er);
    } else if (state.objectMode || chunk && chunk.length > 0) {
      if (typeof chunk !== 'string' && !state.objectMode && Object.getPrototypeOf(chunk) !== Buffer.prototype) {
        chunk = _uint8ArrayToBuffer(chunk);
      }

      if (addToFront) {
        if (state.endEmitted) stream.emit('error', new Error('stream.unshift() after end event'));else addChunk(stream, state, chunk, true);
      } else if (state.ended) {
        stream.emit('error', new Error('stream.push() after EOF'));
      } else {
        state.reading = false;
        if (state.decoder && !encoding) {
          chunk = state.decoder.write(chunk);
          if (state.objectMode || chunk.length !== 0) addChunk(stream, state, chunk, false);else maybeReadMore(stream, state);
        } else {
          addChunk(stream, state, chunk, false);
        }
      }
    } else if (!addToFront) {
      state.reading = false;
    }
  }

  return needMoreData(state);
}

function addChunk(stream, state, chunk, addToFront) {
  if (state.flowing && state.length === 0 && !state.sync) {
    stream.emit('data', chunk);
    stream.read(0);
  } else {
    // update the buffer info.
    state.length += state.objectMode ? 1 : chunk.length;
    if (addToFront) state.buffer.unshift(chunk);else state.buffer.push(chunk);

    if (state.needReadable) emitReadable(stream);
  }
  maybeReadMore(stream, state);
}

function chunkInvalid(state, chunk) {
  var er;
  if (!_isUint8Array(chunk) && typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
    er = new TypeError('Invalid non-string/buffer chunk');
  }
  return er;
}

// if it's past the high water mark, we can push in some more.
// Also, if we have no data yet, we can stand some
// more bytes.  This is to work around cases where hwm=0,
// such as the repl.  Also, if the push() triggered a
// readable event, and the user called read(largeNumber) such that
// needReadable was set, then we ought to push more, so that another
// 'readable' event will be triggered.
function needMoreData(state) {
  return !state.ended && (state.needReadable || state.length < state.highWaterMark || state.length === 0);
}

Readable.prototype.isPaused = function () {
  return this._readableState.flowing === false;
};

// backwards compatibility.
Readable.prototype.setEncoding = function (enc) {
  if (!StringDecoder) StringDecoder = __webpack_require__(428).StringDecoder;
  this._readableState.decoder = new StringDecoder(enc);
  this._readableState.encoding = enc;
  return this;
};

// Don't raise the hwm > 8MB
var MAX_HWM = 0x800000;
function computeNewHighWaterMark(n) {
  if (n >= MAX_HWM) {
    n = MAX_HWM;
  } else {
    // Get the next highest power of 2 to prevent increasing hwm excessively in
    // tiny amounts
    n--;
    n |= n >>> 1;
    n |= n >>> 2;
    n |= n >>> 4;
    n |= n >>> 8;
    n |= n >>> 16;
    n++;
  }
  return n;
}

// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function howMuchToRead(n, state) {
  if (n <= 0 || state.length === 0 && state.ended) return 0;
  if (state.objectMode) return 1;
  if (n !== n) {
    // Only flow one buffer at a time
    if (state.flowing && state.length) return state.buffer.head.data.length;else return state.length;
  }
  // If we're asking for more than the current hwm, then raise the hwm.
  if (n > state.highWaterMark) state.highWaterMark = computeNewHighWaterMark(n);
  if (n <= state.length) return n;
  // Don't have enough
  if (!state.ended) {
    state.needReadable = true;
    return 0;
  }
  return state.length;
}

// you can override either this method, or the async _read(n) below.
Readable.prototype.read = function (n) {
  debug('read', n);
  n = parseInt(n, 10);
  var state = this._readableState;
  var nOrig = n;

  if (n !== 0) state.emittedReadable = false;

  // if we're doing read(0) to trigger a readable event, but we
  // already have a bunch of data in the buffer, then just trigger
  // the 'readable' event and move on.
  if (n === 0 && state.needReadable && (state.length >= state.highWaterMark || state.ended)) {
    debug('read: emitReadable', state.length, state.ended);
    if (state.length === 0 && state.ended) endReadable(this);else emitReadable(this);
    return null;
  }

  n = howMuchToRead(n, state);

  // if we've ended, and we're now clear, then finish it up.
  if (n === 0 && state.ended) {
    if (state.length === 0) endReadable(this);
    return null;
  }

  // All the actual chunk generation logic needs to be
  // *below* the call to _read.  The reason is that in certain
  // synthetic stream cases, such as passthrough streams, _read
  // may be a completely synchronous operation which may change
  // the state of the read buffer, providing enough data when
  // before there was *not* enough.
  //
  // So, the steps are:
  // 1. Figure out what the state of things will be after we do
  // a read from the buffer.
  //
  // 2. If that resulting state will trigger a _read, then call _read.
  // Note that this may be asynchronous, or synchronous.  Yes, it is
  // deeply ugly to write APIs this way, but that still doesn't mean
  // that the Readable class should behave improperly, as streams are
  // designed to be sync/async agnostic.
  // Take note if the _read call is sync or async (ie, if the read call
  // has returned yet), so that we know whether or not it's safe to emit
  // 'readable' etc.
  //
  // 3. Actually pull the requested chunks out of the buffer and return.

  // if we need a readable event, then we need to do some reading.
  var doRead = state.needReadable;
  debug('need readable', doRead);

  // if we currently have less than the highWaterMark, then also read some
  if (state.length === 0 || state.length - n < state.highWaterMark) {
    doRead = true;
    debug('length less than watermark', doRead);
  }

  // however, if we've ended, then there's no point, and if we're already
  // reading, then it's unnecessary.
  if (state.ended || state.reading) {
    doRead = false;
    debug('reading or ended', doRead);
  } else if (doRead) {
    debug('do read');
    state.reading = true;
    state.sync = true;
    // if the length is currently zero, then we *need* a readable event.
    if (state.length === 0) state.needReadable = true;
    // call internal read method
    this._read(state.highWaterMark);
    state.sync = false;
    // If _read pushed data synchronously, then `reading` will be false,
    // and we need to re-evaluate how much data we can return to the user.
    if (!state.reading) n = howMuchToRead(nOrig, state);
  }

  var ret;
  if (n > 0) ret = fromList(n, state);else ret = null;

  if (ret === null) {
    state.needReadable = true;
    n = 0;
  } else {
    state.length -= n;
  }

  if (state.length === 0) {
    // If we have nothing in the buffer, then we want to know
    // as soon as we *do* get something into the buffer.
    if (!state.ended) state.needReadable = true;

    // If we tried to read() past the EOF, then emit end on the next tick.
    if (nOrig !== n && state.ended) endReadable(this);
  }

  if (ret !== null) this.emit('data', ret);

  return ret;
};

function onEofChunk(stream, state) {
  if (state.ended) return;
  if (state.decoder) {
    var chunk = state.decoder.end();
    if (chunk && chunk.length) {
      state.buffer.push(chunk);
      state.length += state.objectMode ? 1 : chunk.length;
    }
  }
  state.ended = true;

  // emit 'readable' now to make sure it gets picked up.
  emitReadable(stream);
}

// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function emitReadable(stream) {
  var state = stream._readableState;
  state.needReadable = false;
  if (!state.emittedReadable) {
    debug('emitReadable', state.flowing);
    state.emittedReadable = true;
    if (state.sync) pna.nextTick(emitReadable_, stream);else emitReadable_(stream);
  }
}

function emitReadable_(stream) {
  debug('emit readable');
  stream.emit('readable');
  flow(stream);
}

// at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function maybeReadMore(stream, state) {
  if (!state.readingMore) {
    state.readingMore = true;
    pna.nextTick(maybeReadMore_, stream, state);
  }
}

function maybeReadMore_(stream, state) {
  var len = state.length;
  while (!state.reading && !state.flowing && !state.ended && state.length < state.highWaterMark) {
    debug('maybeReadMore read 0');
    stream.read(0);
    if (len === state.length)
      // didn't get any data, stop spinning.
      break;else len = state.length;
  }
  state.readingMore = false;
}

// abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
Readable.prototype._read = function (n) {
  this.emit('error', new Error('_read() is not implemented'));
};

Readable.prototype.pipe = function (dest, pipeOpts) {
  var src = this;
  var state = this._readableState;

  switch (state.pipesCount) {
    case 0:
      state.pipes = dest;
      break;
    case 1:
      state.pipes = [state.pipes, dest];
      break;
    default:
      state.pipes.push(dest);
      break;
  }
  state.pipesCount += 1;
  debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);

  var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== process.stdout && dest !== process.stderr;

  var endFn = doEnd ? onend : unpipe;
  if (state.endEmitted) pna.nextTick(endFn);else src.once('end', endFn);

  dest.on('unpipe', onunpipe);
  function onunpipe(readable, unpipeInfo) {
    debug('onunpipe');
    if (readable === src) {
      if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
        unpipeInfo.hasUnpiped = true;
        cleanup();
      }
    }
  }

  function onend() {
    debug('onend');
    dest.end();
  }

  // when the dest drains, it reduces the awaitDrain counter
  // on the source.  This would be more elegant with a .once()
  // handler in flow(), but adding and removing repeatedly is
  // too slow.
  var ondrain = pipeOnDrain(src);
  dest.on('drain', ondrain);

  var cleanedUp = false;
  function cleanup() {
    debug('cleanup');
    // cleanup event handlers once the pipe is broken
    dest.removeListener('close', onclose);
    dest.removeListener('finish', onfinish);
    dest.removeListener('drain', ondrain);
    dest.removeListener('error', onerror);
    dest.removeListener('unpipe', onunpipe);
    src.removeListener('end', onend);
    src.removeListener('end', unpipe);
    src.removeListener('data', ondata);

    cleanedUp = true;

    // if the reader is waiting for a drain event from this
    // specific writer, then it would cause it to never start
    // flowing again.
    // So, if this is awaiting a drain, then we just call it now.
    // If we don't know, then assume that we are waiting for one.
    if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
  }

  // If the user pushes more data while we're writing to dest then we'll end up
  // in ondata again. However, we only want to increase awaitDrain once because
  // dest will only emit one 'drain' event for the multiple writes.
  // => Introduce a guard on increasing awaitDrain.
  var increasedAwaitDrain = false;
  src.on('data', ondata);
  function ondata(chunk) {
    debug('ondata');
    increasedAwaitDrain = false;
    var ret = dest.write(chunk);
    if (false === ret && !increasedAwaitDrain) {
      // If the user unpiped during `dest.write()`, it is possible
      // to get stuck in a permanently paused state if that write
      // also returned false.
      // => Check whether `dest` is still a piping destination.
      if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
        debug('false write response, pause', src._readableState.awaitDrain);
        src._readableState.awaitDrain++;
        increasedAwaitDrain = true;
      }
      src.pause();
    }
  }

  // if the dest has an error, then stop piping into it.
  // however, don't suppress the throwing behavior for this.
  function onerror(er) {
    debug('onerror', er);
    unpipe();
    dest.removeListener('error', onerror);
    if (EElistenerCount(dest, 'error') === 0) dest.emit('error', er);
  }

  // Make sure our error handler is attached before userland ones.
  prependListener(dest, 'error', onerror);

  // Both close and finish should trigger unpipe, but only once.
  function onclose() {
    dest.removeListener('finish', onfinish);
    unpipe();
  }
  dest.once('close', onclose);
  function onfinish() {
    debug('onfinish');
    dest.removeListener('close', onclose);
    unpipe();
  }
  dest.once('finish', onfinish);

  function unpipe() {
    debug('unpipe');
    src.unpipe(dest);
  }

  // tell the dest that it's being piped to
  dest.emit('pipe', src);

  // start the flow if it hasn't been started already.
  if (!state.flowing) {
    debug('pipe resume');
    src.resume();
  }

  return dest;
};

function pipeOnDrain(src) {
  return function () {
    var state = src._readableState;
    debug('pipeOnDrain', state.awaitDrain);
    if (state.awaitDrain) state.awaitDrain--;
    if (state.awaitDrain === 0 && EElistenerCount(src, 'data')) {
      state.flowing = true;
      flow(src);
    }
  };
}

Readable.prototype.unpipe = function (dest) {
  var state = this._readableState;
  var unpipeInfo = { hasUnpiped: false };

  // if we're not piping anywhere, then do nothing.
  if (state.pipesCount === 0) return this;

  // just one destination.  most common case.
  if (state.pipesCount === 1) {
    // passed in one, but it's not the right one.
    if (dest && dest !== state.pipes) return this;

    if (!dest) dest = state.pipes;

    // got a match.
    state.pipes = null;
    state.pipesCount = 0;
    state.flowing = false;
    if (dest) dest.emit('unpipe', this, unpipeInfo);
    return this;
  }

  // slow case. multiple pipe destinations.

  if (!dest) {
    // remove all.
    var dests = state.pipes;
    var len = state.pipesCount;
    state.pipes = null;
    state.pipesCount = 0;
    state.flowing = false;

    for (var i = 0; i < len; i++) {
      dests[i].emit('unpipe', this, unpipeInfo);
    }return this;
  }

  // try to find the right one.
  var index = indexOf(state.pipes, dest);
  if (index === -1) return this;

  state.pipes.splice(index, 1);
  state.pipesCount -= 1;
  if (state.pipesCount === 1) state.pipes = state.pipes[0];

  dest.emit('unpipe', this, unpipeInfo);

  return this;
};

// set up data events if they are asked for
// Ensure readable listeners eventually get something
Readable.prototype.on = function (ev, fn) {
  var res = Stream.prototype.on.call(this, ev, fn);

  if (ev === 'data') {
    // Start flowing on next tick if stream isn't explicitly paused
    if (this._readableState.flowing !== false) this.resume();
  } else if (ev === 'readable') {
    var state = this._readableState;
    if (!state.endEmitted && !state.readableListening) {
      state.readableListening = state.needReadable = true;
      state.emittedReadable = false;
      if (!state.reading) {
        pna.nextTick(nReadingNextTick, this);
      } else if (state.length) {
        emitReadable(this);
      }
    }
  }

  return res;
};
Readable.prototype.addListener = Readable.prototype.on;

function nReadingNextTick(self) {
  debug('readable nexttick read 0');
  self.read(0);
}

// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
Readable.prototype.resume = function () {
  var state = this._readableState;
  if (!state.flowing) {
    debug('resume');
    state.flowing = true;
    resume(this, state);
  }
  return this;
};

function resume(stream, state) {
  if (!state.resumeScheduled) {
    state.resumeScheduled = true;
    pna.nextTick(resume_, stream, state);
  }
}

function resume_(stream, state) {
  if (!state.reading) {
    debug('resume read 0');
    stream.read(0);
  }

  state.resumeScheduled = false;
  state.awaitDrain = 0;
  stream.emit('resume');
  flow(stream);
  if (state.flowing && !state.reading) stream.read(0);
}

Readable.prototype.pause = function () {
  debug('call pause flowing=%j', this._readableState.flowing);
  if (false !== this._readableState.flowing) {
    debug('pause');
    this._readableState.flowing = false;
    this.emit('pause');
  }
  return this;
};

function flow(stream) {
  var state = stream._readableState;
  debug('flow', state.flowing);
  while (state.flowing && stream.read() !== null) {}
}

// wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
Readable.prototype.wrap = function (stream) {
  var _this = this;

  var state = this._readableState;
  var paused = false;

  stream.on('end', function () {
    debug('wrapped end');
    if (state.decoder && !state.ended) {
      var chunk = state.decoder.end();
      if (chunk && chunk.length) _this.push(chunk);
    }

    _this.push(null);
  });

  stream.on('data', function (chunk) {
    debug('wrapped data');
    if (state.decoder) chunk = state.decoder.write(chunk);

    // don't skip over falsy values in objectMode
    if (state.objectMode && (chunk === null || chunk === undefined)) return;else if (!state.objectMode && (!chunk || !chunk.length)) return;

    var ret = _this.push(chunk);
    if (!ret) {
      paused = true;
      stream.pause();
    }
  });

  // proxy all the other methods.
  // important when wrapping filters and duplexes.
  for (var i in stream) {
    if (this[i] === undefined && typeof stream[i] === 'function') {
      this[i] = function (method) {
        return function () {
          return stream[method].apply(stream, arguments);
        };
      }(i);
    }
  }

  // proxy certain important events.
  for (var n = 0; n < kProxyEvents.length; n++) {
    stream.on(kProxyEvents[n], this.emit.bind(this, kProxyEvents[n]));
  }

  // when we try to consume some more bytes, simply unpause the
  // underlying stream.
  this._read = function (n) {
    debug('wrapped _read', n);
    if (paused) {
      paused = false;
      stream.resume();
    }
  };

  return this;
};

Object.defineProperty(Readable.prototype, 'readableHighWaterMark', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function () {
    return this._readableState.highWaterMark;
  }
});

// exposed for testing purposes only.
Readable._fromList = fromList;

// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function fromList(n, state) {
  // nothing buffered
  if (state.length === 0) return null;

  var ret;
  if (state.objectMode) ret = state.buffer.shift();else if (!n || n >= state.length) {
    // read it all, truncate the list
    if (state.decoder) ret = state.buffer.join('');else if (state.buffer.length === 1) ret = state.buffer.head.data;else ret = state.buffer.concat(state.length);
    state.buffer.clear();
  } else {
    // read part of list
    ret = fromListPartial(n, state.buffer, state.decoder);
  }

  return ret;
}

// Extracts only enough buffered data to satisfy the amount requested.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function fromListPartial(n, list, hasStrings) {
  var ret;
  if (n < list.head.data.length) {
    // slice is the same for buffers and strings
    ret = list.head.data.slice(0, n);
    list.head.data = list.head.data.slice(n);
  } else if (n === list.head.data.length) {
    // first chunk is a perfect match
    ret = list.shift();
  } else {
    // result spans more than one buffer
    ret = hasStrings ? copyFromBufferString(n, list) : copyFromBuffer(n, list);
  }
  return ret;
}

// Copies a specified amount of characters from the list of buffered data
// chunks.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function copyFromBufferString(n, list) {
  var p = list.head;
  var c = 1;
  var ret = p.data;
  n -= ret.length;
  while (p = p.next) {
    var str = p.data;
    var nb = n > str.length ? str.length : n;
    if (nb === str.length) ret += str;else ret += str.slice(0, n);
    n -= nb;
    if (n === 0) {
      if (nb === str.length) {
        ++c;
        if (p.next) list.head = p.next;else list.head = list.tail = null;
      } else {
        list.head = p;
        p.data = str.slice(nb);
      }
      break;
    }
    ++c;
  }
  list.length -= c;
  return ret;
}

// Copies a specified amount of bytes from the list of buffered data chunks.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function copyFromBuffer(n, list) {
  var ret = Buffer.allocUnsafe(n);
  var p = list.head;
  var c = 1;
  p.data.copy(ret);
  n -= p.data.length;
  while (p = p.next) {
    var buf = p.data;
    var nb = n > buf.length ? buf.length : n;
    buf.copy(ret, ret.length - n, 0, nb);
    n -= nb;
    if (n === 0) {
      if (nb === buf.length) {
        ++c;
        if (p.next) list.head = p.next;else list.head = list.tail = null;
      } else {
        list.head = p;
        p.data = buf.slice(nb);
      }
      break;
    }
    ++c;
  }
  list.length -= c;
  return ret;
}

function endReadable(stream) {
  var state = stream._readableState;

  // If we get here before consuming all the bytes, then that is a
  // bug in node.  Should never happen.
  if (state.length > 0) throw new Error('"endReadable()" called on non-empty stream');

  if (!state.endEmitted) {
    state.ended = true;
    pna.nextTick(endReadableNT, state, stream);
  }
}

function endReadableNT(state, stream) {
  // Check that we didn't get one last unshift.
  if (!state.endEmitted && state.length === 0) {
    state.endEmitted = true;
    stream.readable = false;
    stream.emit('end');
  }
}

function indexOf(xs, x) {
  for (var i = 0, l = xs.length; i < l; i++) {
    if (xs[i] === x) return i;
  }
  return -1;
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(26), __webpack_require__(74)))

/***/ }),
/* 747 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(425).EventEmitter;


/***/ }),
/* 748 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*<replacement>*/

var pna = __webpack_require__(288);
/*</replacement>*/

// undocumented cb() API, needed for core, not for public API
function destroy(err, cb) {
  var _this = this;

  var readableDestroyed = this._readableState && this._readableState.destroyed;
  var writableDestroyed = this._writableState && this._writableState.destroyed;

  if (readableDestroyed || writableDestroyed) {
    if (cb) {
      cb(err);
    } else if (err && (!this._writableState || !this._writableState.errorEmitted)) {
      pna.nextTick(emitErrorNT, this, err);
    }
    return this;
  }

  // we set destroyed to true before firing error callbacks in order
  // to make it re-entrance safe in case destroy() is called within callbacks

  if (this._readableState) {
    this._readableState.destroyed = true;
  }

  // if this is a duplex stream mark the writable part as destroyed as well
  if (this._writableState) {
    this._writableState.destroyed = true;
  }

  this._destroy(err || null, function (err) {
    if (!cb && err) {
      pna.nextTick(emitErrorNT, _this, err);
      if (_this._writableState) {
        _this._writableState.errorEmitted = true;
      }
    } else if (cb) {
      cb(err);
    }
  });

  return this;
}

function undestroy() {
  if (this._readableState) {
    this._readableState.destroyed = false;
    this._readableState.reading = false;
    this._readableState.ended = false;
    this._readableState.endEmitted = false;
  }

  if (this._writableState) {
    this._writableState.destroyed = false;
    this._writableState.ended = false;
    this._writableState.ending = false;
    this._writableState.finished = false;
    this._writableState.errorEmitted = false;
  }
}

function emitErrorNT(self, err) {
  self.emit('error', err);
}

module.exports = {
  destroy: destroy,
  undestroy: undestroy
};

/***/ }),
/* 749 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.



module.exports = Transform;

var Duplex = __webpack_require__(124);

/*<replacement>*/
var util = __webpack_require__(208);
util.inherits = __webpack_require__(118);
/*</replacement>*/

util.inherits(Transform, Duplex);

function afterTransform(er, data) {
  var ts = this._transformState;
  ts.transforming = false;

  var cb = ts.writecb;

  if (!cb) {
    return this.emit('error', new Error('write callback called multiple times'));
  }

  ts.writechunk = null;
  ts.writecb = null;

  if (data != null) // single equals check for both `null` and `undefined`
    this.push(data);

  cb(er);

  var rs = this._readableState;
  rs.reading = false;
  if (rs.needReadable || rs.length < rs.highWaterMark) {
    this._read(rs.highWaterMark);
  }
}

function Transform(options) {
  if (!(this instanceof Transform)) return new Transform(options);

  Duplex.call(this, options);

  this._transformState = {
    afterTransform: afterTransform.bind(this),
    needTransform: false,
    transforming: false,
    writecb: null,
    writechunk: null,
    writeencoding: null
  };

  // start out asking for a readable event once data is transformed.
  this._readableState.needReadable = true;

  // we have implemented the _read method, and done the other things
  // that Readable wants before the first _read call, so unset the
  // sync guard flag.
  this._readableState.sync = false;

  if (options) {
    if (typeof options.transform === 'function') this._transform = options.transform;

    if (typeof options.flush === 'function') this._flush = options.flush;
  }

  // When the writable side finishes, then flush out anything remaining.
  this.on('prefinish', prefinish);
}

function prefinish() {
  var _this = this;

  if (typeof this._flush === 'function') {
    this._flush(function (er, data) {
      done(_this, er, data);
    });
  } else {
    done(this, null, null);
  }
}

Transform.prototype.push = function (chunk, encoding) {
  this._transformState.needTransform = false;
  return Duplex.prototype.push.call(this, chunk, encoding);
};

// This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
Transform.prototype._transform = function (chunk, encoding, cb) {
  throw new Error('_transform() is not implemented');
};

Transform.prototype._write = function (chunk, encoding, cb) {
  var ts = this._transformState;
  ts.writecb = cb;
  ts.writechunk = chunk;
  ts.writeencoding = encoding;
  if (!ts.transforming) {
    var rs = this._readableState;
    if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
  }
};

// Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
Transform.prototype._read = function (n) {
  var ts = this._transformState;

  if (ts.writechunk !== null && ts.writecb && !ts.transforming) {
    ts.transforming = true;
    this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
  } else {
    // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
  }
};

Transform.prototype._destroy = function (err, cb) {
  var _this2 = this;

  Duplex.prototype._destroy.call(this, err, function (err2) {
    cb(err2);
    _this2.emit('close');
  });
};

function done(stream, er, data) {
  if (er) return stream.emit('error', er);

  if (data != null) // single equals check for both `null` and `undefined`
    stream.push(data);

  // if there's nothing in the write buffer, then that means
  // that nothing more will ever be provided
  if (stream._writableState.length) throw new Error('Calling transform done when ws.length != 0');

  if (stream._transformState.transforming) throw new Error('Calling transform done when still transforming');

  return stream.push(null);
}

/***/ }),
/* 750 */
/***/ (function(module, exports, __webpack_require__) {

var helper = __webpack_require__(429);
var isArray = __webpack_require__(430).isArray;

var currentElement, currentElementName;

function validateOptions(userOptions) {
  var options = helper.copyOptions(userOptions);
  helper.ensureFlagExists('ignoreDeclaration', options);
  helper.ensureFlagExists('ignoreInstruction', options);
  helper.ensureFlagExists('ignoreAttributes', options);
  helper.ensureFlagExists('ignoreText', options);
  helper.ensureFlagExists('ignoreComment', options);
  helper.ensureFlagExists('ignoreCdata', options);
  helper.ensureFlagExists('ignoreDoctype', options);
  helper.ensureFlagExists('compact', options);
  helper.ensureFlagExists('indentText', options);
  helper.ensureFlagExists('indentCdata', options);
  helper.ensureFlagExists('indentAttributes', options);
  helper.ensureFlagExists('indentInstruction', options);
  helper.ensureFlagExists('fullTagEmptyElement', options);
  helper.ensureFlagExists('noQuotesForNativeAttributes', options);
  helper.ensureSpacesExists(options);
  if (typeof options.spaces === 'number') {
    options.spaces = Array(options.spaces + 1).join(' ');
  }
  helper.ensureKeyExists('declaration', options);
  helper.ensureKeyExists('instruction', options);
  helper.ensureKeyExists('attributes', options);
  helper.ensureKeyExists('text', options);
  helper.ensureKeyExists('comment', options);
  helper.ensureKeyExists('cdata', options);
  helper.ensureKeyExists('doctype', options);
  helper.ensureKeyExists('type', options);
  helper.ensureKeyExists('name', options);
  helper.ensureKeyExists('elements', options);
  helper.checkFnExists('doctype', options);
  helper.checkFnExists('instruction', options);
  helper.checkFnExists('cdata', options);
  helper.checkFnExists('comment', options);
  helper.checkFnExists('text', options);
  helper.checkFnExists('instructionName', options);
  helper.checkFnExists('elementName', options);
  helper.checkFnExists('attributeName', options);
  helper.checkFnExists('attributeValue', options);
  helper.checkFnExists('attributes', options);
  helper.checkFnExists('fullTagEmptyElement', options);
  return options;
}

function writeIndentation(options, depth, firstLine) {
  return (!firstLine && options.spaces ? '\n' : '') + Array(depth + 1).join(options.spaces);
}

function writeAttributes(attributes, options, depth) {
  if (options.ignoreAttributes) {
    return '';
  }
  if ('attributesFn' in options) {
    attributes = options.attributesFn(attributes, currentElementName, currentElement);
  }
  var key, attr, attrName, quote, result = [];
  for (key in attributes) {
    if (attributes.hasOwnProperty(key) && attributes[key] !== null && attributes[key] !== undefined) {
      quote = options.noQuotesForNativeAttributes && typeof attributes[key] !== 'string' ? '' : '"';
      attr = '' + attributes[key]; // ensure number and boolean are converted to String
      attr = attr.replace(/"/g, '&quot;');
      attrName = 'attributeNameFn' in options ? options.attributeNameFn(key, attr, currentElementName, currentElement) : key;
      result.push((options.spaces && options.indentAttributes? writeIndentation(options, depth+1, false) : ' '));
      result.push(attrName + '=' + quote + ('attributeValueFn' in options ? options.attributeValueFn(attr, key, currentElementName, currentElement) : attr) + quote);
    }
  }
  if (attributes && Object.keys(attributes).length && options.spaces && options.indentAttributes) {
    result.push(writeIndentation(options, depth, false));
  }
  return result.join('');
}

function writeDeclaration(declaration, options, depth) {
  currentElement = declaration;
  currentElementName = 'xml';
  return options.ignoreDeclaration ? '' :  '<?' + 'xml' + writeAttributes(declaration[options.attributesKey], options, depth) + '?>';
}

function writeInstruction(instruction, options, depth) {
  if (options.ignoreInstruction) {
    return '';
  }
  var key;
  for (key in instruction) {
    if (instruction.hasOwnProperty(key)) {
      break;
    }
  }
  var instructionName = 'instructionNameFn' in options ? options.instructionNameFn(key, instruction[key], currentElementName, currentElement) : key;
  if (typeof instruction[key] === 'object') {
    currentElement = instruction;
    currentElementName = instructionName;
    return '<?' + instructionName + writeAttributes(instruction[key][options.attributesKey], options, depth) + '?>';
  } else {
    var instructionValue = instruction[key] ? instruction[key] : '';
    if ('instructionFn' in options) instructionValue = options.instructionFn(instructionValue, key, currentElementName, currentElement);
    return '<?' + instructionName + (instructionValue ? ' ' + instructionValue : '') + '?>';
  }
}

function writeComment(comment, options) {
  return options.ignoreComment ? '' : '<!--' + ('commentFn' in options ? options.commentFn(comment, currentElementName, currentElement) : comment) + '-->';
}

function writeCdata(cdata, options) {
  return options.ignoreCdata ? '' : '<![CDATA[' + ('cdataFn' in options ? options.cdataFn(cdata, currentElementName, currentElement) : cdata) + ']]>';
}

function writeDoctype(doctype, options) {
  return options.ignoreDoctype ? '' : '<!DOCTYPE ' + ('doctypeFn' in options ? options.doctypeFn(doctype, currentElementName, currentElement) : doctype) + '>';
}

function writeText(text, options) {
  if (options.ignoreText) return '';
  text = '' + text; // ensure Number and Boolean are converted to String
  text = text.replace(/&amp;/g, '&'); // desanitize to avoid double sanitization
  text = text.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  return 'textFn' in options ? options.textFn(text, currentElementName, currentElement) : text;
}

function hasContent(element, options) {
  var i;
  if (element.elements && element.elements.length) {
    for (i = 0; i < element.elements.length; ++i) {
      switch (element.elements[i][options.typeKey]) {
      case 'text':
        if (options.indentText) {
          return true;
        }
        break; // skip to next key
      case 'cdata':
        if (options.indentCdata) {
          return true;
        }
        break; // skip to next key
      case 'instruction':
        if (options.indentInstruction) {
          return true;
        }
        break; // skip to next key
      case 'doctype':
      case 'comment':
      case 'element':
        return true;
      default:
        return true;
      }
    }
  }
  return false;
}

function writeElement(element, options, depth) {
  currentElement = element;
  currentElementName = element.name;
  var xml = [], elementName = 'elementNameFn' in options ? options.elementNameFn(element.name, element) : element.name;
  xml.push('<' + elementName);
  if (element[options.attributesKey]) {
    xml.push(writeAttributes(element[options.attributesKey], options, depth));
  }
  var withClosingTag = element[options.elementsKey] && element[options.elementsKey].length || element[options.attributesKey] && element[options.attributesKey]['xml:space'] === 'preserve';
  if (!withClosingTag) {
    if ('fullTagEmptyElementFn' in options) {
      withClosingTag = options.fullTagEmptyElementFn(element.name, element);
    } else {
      withClosingTag = options.fullTagEmptyElement;
    }
  }
  if (withClosingTag) {
    xml.push('>');
    if (element[options.elementsKey] && element[options.elementsKey].length) {
      xml.push(writeElements(element[options.elementsKey], options, depth + 1));
      currentElement = element;
      currentElementName = element.name;
    }
    xml.push(options.spaces && hasContent(element, options) ? '\n' + Array(depth + 1).join(options.spaces) : '');
    xml.push('</' + elementName + '>');
  } else {
    xml.push('/>');
  }
  return xml.join('');
}

function writeElements(elements, options, depth, firstLine) {
  return elements.reduce(function (xml, element) {
    var indent = writeIndentation(options, depth, firstLine && !xml);
    switch (element.type) {
    case 'element': return xml + indent + writeElement(element, options, depth);
    case 'comment': return xml + indent + writeComment(element[options.commentKey], options);
    case 'doctype': return xml + indent + writeDoctype(element[options.doctypeKey], options);
    case 'cdata': return xml + (options.indentCdata ? indent : '') + writeCdata(element[options.cdataKey], options);
    case 'text': return xml + (options.indentText ? indent : '') + writeText(element[options.textKey], options);
    case 'instruction':
      var instruction = {};
      instruction[element[options.nameKey]] = element[options.attributesKey] ? element : element[options.instructionKey];
      return xml + (options.indentInstruction ? indent : '') + writeInstruction(instruction, options, depth);
    }
  }, '');
}

function hasContentCompact(element, options, anyContent) {
  var key;
  for (key in element) {
    if (element.hasOwnProperty(key)) {
      switch (key) {
      case options.parentKey:
      case options.attributesKey:
        break; // skip to next key
      case options.textKey:
        if (options.indentText || anyContent) {
          return true;
        }
        break; // skip to next key
      case options.cdataKey:
        if (options.indentCdata || anyContent) {
          return true;
        }
        break; // skip to next key
      case options.instructionKey:
        if (options.indentInstruction || anyContent) {
          return true;
        }
        break; // skip to next key
      case options.doctypeKey:
      case options.commentKey:
        return true;
      default:
        return true;
      }
    }
  }
  return false;
}

function writeElementCompact(element, name, options, depth, indent) {
  currentElement = element;
  currentElementName = name;
  var elementName = 'elementNameFn' in options ? options.elementNameFn(name, element) : name;
  if (typeof element === 'undefined' || element === null || element === '') {
    return 'fullTagEmptyElementFn' in options && options.fullTagEmptyElementFn(name, element) || options.fullTagEmptyElement ? '<' + elementName + '></' + elementName + '>' : '<' + elementName + '/>';
  }
  var xml = [];
  if (name) {
    xml.push('<' + elementName);
    if (typeof element !== 'object') {
      xml.push('>' + writeText(element,options) + '</' + elementName + '>');
      return xml.join('');
    }
    if (element[options.attributesKey]) {
      xml.push(writeAttributes(element[options.attributesKey], options, depth));
    }
    var withClosingTag = hasContentCompact(element, options, true) || element[options.attributesKey] && element[options.attributesKey]['xml:space'] === 'preserve';
    if (!withClosingTag) {
      if ('fullTagEmptyElementFn' in options) {
        withClosingTag = options.fullTagEmptyElementFn(name, element);
      } else {
        withClosingTag = options.fullTagEmptyElement;
      }
    }
    if (withClosingTag) {
      xml.push('>');
    } else {
      xml.push('/>');
      return xml.join('');
    }
  }
  xml.push(writeElementsCompact(element, options, depth + 1, false));
  currentElement = element;
  currentElementName = name;
  if (name) {
    xml.push((indent ? writeIndentation(options, depth, false) : '') + '</' + elementName + '>');
  }
  return xml.join('');
}

function writeElementsCompact(element, options, depth, firstLine) {
  var i, key, nodes, xml = [];
  for (key in element) {
    if (element.hasOwnProperty(key)) {
      nodes = isArray(element[key]) ? element[key] : [element[key]];
      for (i = 0; i < nodes.length; ++i) {
        switch (key) {
        case options.declarationKey: xml.push(writeDeclaration(nodes[i], options, depth)); break;
        case options.instructionKey: xml.push((options.indentInstruction ? writeIndentation(options, depth, firstLine) : '') + writeInstruction(nodes[i], options, depth)); break;
        case options.attributesKey: case options.parentKey: break; // skip
        case options.textKey: xml.push((options.indentText ? writeIndentation(options, depth, firstLine) : '') + writeText(nodes[i], options)); break;
        case options.cdataKey: xml.push((options.indentCdata ? writeIndentation(options, depth, firstLine) : '') + writeCdata(nodes[i], options)); break;
        case options.doctypeKey: xml.push(writeIndentation(options, depth, firstLine) + writeDoctype(nodes[i], options)); break;
        case options.commentKey: xml.push(writeIndentation(options, depth, firstLine) + writeComment(nodes[i], options)); break;
        default: xml.push(writeIndentation(options, depth, firstLine) + writeElementCompact(nodes[i], key, options, depth, hasContentCompact(nodes[i], options)));
        }
        firstLine = firstLine && !xml.length;
      }
    }
  }
  return xml.join('');
}

module.exports = function (js, options) {
  options = validateOptions(options);
  var xml = [];
  currentElement = js;
  currentElementName = '_root_';
  if (options.compact) {
    xml.push(writeElementsCompact(js, options, 0, true));
  } else {
    if (js[options.declarationKey]) {
      xml.push(writeDeclaration(js[options.declarationKey], options, 0));
    }
    if (js[options.elementsKey] && js[options.elementsKey].length) {
      xml.push(writeElements(js[options.elementsKey], options, 0, !xml.length));
    }
  }
  return xml.join('');
};


/***/ }),
/* 751 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(43);
var misc_1 = __webpack_require__(158);
var object_1 = __webpack_require__(290);
/**
 * Holds additional event information. {@link Scope.applyToEvent} will be
 * called by the client before an event will be sent.
 */
var Scope = /** @class */ (function () {
    function Scope() {
        /** Flag if notifiying is happening. */
        this.notifyingListeners = false;
        /** Callback for client to receive scope changes. */
        this.scopeListeners = [];
        /** Callback list that will be called after {@link applyToEvent}. */
        this.eventProcessors = [];
        /** Array of breadcrumbs. */
        this.breadcrumbs = [];
        /** User */
        this.user = {};
        /** Tags */
        this.tags = {};
        /** Extra */
        this.extra = {};
    }
    /** Add internal on change listener. */
    Scope.prototype.addScopeListener = function (callback) {
        this.scopeListeners.push(callback);
    };
    /** Add new event processor that will be called after {@link applyToEvent}. */
    Scope.prototype.addEventProcessor = function (callback) {
        this.eventProcessors.push(callback);
        return this;
    };
    /**
     * This will be called on every set call.
     */
    Scope.prototype.notifyScopeListeners = function () {
        var _this = this;
        if (!this.notifyingListeners) {
            this.notifyingListeners = true;
            setTimeout(function () {
                _this.scopeListeners.forEach(function (callback) {
                    callback(_this);
                });
                _this.notifyingListeners = false;
            }, 0);
        }
    };
    /**
     * This will be called after {@link applyToEvent} is finished.
     */
    Scope.prototype.notifyEventProcessors = function (event, hint) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var e_1, _a, processedEvent, _b, _c, processor, e_2, e_1_1;
            return tslib_1.__generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        processedEvent = event;
                        _d.label = 1;
                    case 1:
                        _d.trys.push([1, 8, 9, 10]);
                        _b = tslib_1.__values(tslib_1.__spread(getGlobalEventProcessors(), this.eventProcessors)), _c = _b.next();
                        _d.label = 2;
                    case 2:
                        if (!!_c.done) return [3 /*break*/, 7];
                        processor = _c.value;
                        _d.label = 3;
                    case 3:
                        _d.trys.push([3, 5, , 6]);
                        return [4 /*yield*/, processor(tslib_1.__assign({}, processedEvent), hint)];
                    case 4:
                        processedEvent = _d.sent();
                        if (processedEvent === null) {
                            return [2 /*return*/, null];
                        }
                        return [3 /*break*/, 6];
                    case 5:
                        e_2 = _d.sent();
                        return [3 /*break*/, 6];
                    case 6:
                        _c = _b.next();
                        return [3 /*break*/, 2];
                    case 7: return [3 /*break*/, 10];
                    case 8:
                        e_1_1 = _d.sent();
                        e_1 = { error: e_1_1 };
                        return [3 /*break*/, 10];
                    case 9:
                        try {
                            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                        }
                        finally { if (e_1) throw e_1.error; }
                        return [7 /*endfinally*/];
                    case 10: return [2 /*return*/, processedEvent];
                }
            });
        });
    };
    /**
     * Updates user context information for future events.
     * @param user User context object to merge into current context.
     */
    Scope.prototype.setUser = function (user) {
        this.user = object_1.safeNormalize(user);
        this.notifyScopeListeners();
        return this;
    };
    /**
     * Updates tags context information for future events.
     * @param tags Tags context object to merge into current context.
     */
    Scope.prototype.setTag = function (key, value) {
        var _a;
        this.tags = tslib_1.__assign({}, this.tags, (_a = {}, _a[key] = object_1.safeNormalize(value), _a));
        this.notifyScopeListeners();
        return this;
    };
    /**
     * Updates extra context information for future events.
     * @param extra context object to merge into current context.
     */
    Scope.prototype.setExtra = function (key, extra) {
        var _a;
        this.extra = tslib_1.__assign({}, this.extra, (_a = {}, _a[key] = object_1.safeNormalize(extra), _a));
        this.notifyScopeListeners();
        return this;
    };
    /**
     * Sets the fingerprint on the scope to send with the events.
     * @param fingerprint string[] to group events in Sentry.
     */
    Scope.prototype.setFingerprint = function (fingerprint) {
        this.fingerprint = object_1.safeNormalize(fingerprint);
        this.notifyScopeListeners();
        return this;
    };
    /**
     * Sets the level on the scope for future events.
     * @param level string {@link Severity}
     */
    Scope.prototype.setLevel = function (level) {
        this.level = object_1.safeNormalize(level);
        this.notifyScopeListeners();
        return this;
    };
    /**
     * Inherit values from the parent scope.
     * @param scope to clone.
     */
    Scope.clone = function (scope) {
        var newScope = new Scope();
        object_1.assign(newScope, scope, {
            scopeListeners: [],
        });
        if (scope) {
            newScope.extra = object_1.assign(scope.extra);
            newScope.tags = object_1.assign(scope.tags);
            newScope.breadcrumbs = tslib_1.__spread(scope.breadcrumbs);
            newScope.eventProcessors = tslib_1.__spread(scope.eventProcessors);
        }
        return newScope;
    };
    /** Clears the current scope and resets its properties. */
    Scope.prototype.clear = function () {
        this.breadcrumbs = [];
        this.tags = {};
        this.extra = {};
        this.user = {};
        this.level = undefined;
        this.fingerprint = undefined;
        this.notifyScopeListeners();
    };
    /**
     * Sets the breadcrumbs in the scope
     * @param breadcrumbs Breadcrumb
     * @param maxBreadcrumbs number of max breadcrumbs to merged into event.
     */
    Scope.prototype.addBreadcrumb = function (breadcrumb, maxBreadcrumbs) {
        this.breadcrumbs =
            maxBreadcrumbs !== undefined && maxBreadcrumbs >= 0
                ? tslib_1.__spread(this.breadcrumbs, [object_1.safeNormalize(breadcrumb)]).slice(-maxBreadcrumbs)
                : tslib_1.__spread(this.breadcrumbs, [object_1.safeNormalize(breadcrumb)]);
        this.notifyScopeListeners();
    };
    /**
     * Applies fingerprint from the scope to the event if there's one,
     * uses message if there's one instead or get rid of empty fingerprint
     */
    Scope.prototype.applyFingerprint = function (event) {
        // Make sure it's an array first and we actually have something in place
        event.fingerprint = event.fingerprint
            ? Array.isArray(event.fingerprint)
                ? event.fingerprint
                : [event.fingerprint]
            : [];
        // If we have something on the scope, then merge it with event
        if (this.fingerprint) {
            event.fingerprint = event.fingerprint.concat(this.fingerprint);
        }
        else if (event.message) {
            // If not, but we have message, use it instead
            event.fingerprint = event.fingerprint.concat(event.message);
        }
        // If we have no data at all, remove empty array default
        if (event.fingerprint && !event.fingerprint.length) {
            delete event.fingerprint;
        }
    };
    /**
     * Applies the current context and fingerprint to the event.
     * Note that breadcrumbs will be added by the client.
     * Also if the event has already breadcrumbs on it, we do not merge them.
     * @param event SentryEvent
     * @param hint May contain additional informartion about the original exception.
     * @param maxBreadcrumbs number of max breadcrumbs to merged into event.
     */
    Scope.prototype.applyToEvent = function (event, hint, maxBreadcrumbs) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var hasNoBreadcrumbs;
            return tslib_1.__generator(this, function (_a) {
                if (this.extra && Object.keys(this.extra).length) {
                    event.extra = tslib_1.__assign({}, this.extra, event.extra);
                }
                if (this.tags && Object.keys(this.tags).length) {
                    event.tags = tslib_1.__assign({}, this.tags, event.tags);
                }
                if (this.user && Object.keys(this.user).length) {
                    event.user = tslib_1.__assign({}, this.user, event.user);
                }
                if (this.level) {
                    event.level = this.level;
                }
                this.applyFingerprint(event);
                hasNoBreadcrumbs = !event.breadcrumbs || event.breadcrumbs.length === 0;
                if (hasNoBreadcrumbs && this.breadcrumbs.length > 0) {
                    event.breadcrumbs =
                        maxBreadcrumbs !== undefined && maxBreadcrumbs >= 0
                            ? this.breadcrumbs.slice(-maxBreadcrumbs)
                            : this.breadcrumbs;
                }
                return [2 /*return*/, this.notifyEventProcessors(event, hint)];
            });
        });
    };
    return Scope;
}());
exports.Scope = Scope;
/**
 * Retruns the global event processors.
 */
function getGlobalEventProcessors() {
    var global = misc_1.getGlobalObject();
    global.__SENTRY__ = global.__SENTRY__ || {};
    global.__SENTRY__.globalEventProcessors = global.__SENTRY__.globalEventProcessors || [];
    return global.__SENTRY__.globalEventProcessors;
}
/**
 * Add a EventProcessor to be kept globally.
 * @param callback EventProcessor to add
 */
function addGlobalEventProcessor(callback) {
    getGlobalEventProcessors().push(callback);
}
exports.addGlobalEventProcessor = addGlobalEventProcessor;
//# sourceMappingURL=scope.js.map

/***/ }),
/* 752 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/** JSDoc */
var Severity;
(function (Severity) {
    /** JSDoc */
    Severity["Fatal"] = "fatal";
    /** JSDoc */
    Severity["Error"] = "error";
    /** JSDoc */
    Severity["Warning"] = "warning";
    /** JSDoc */
    Severity["Log"] = "log";
    /** JSDoc */
    Severity["Info"] = "info";
    /** JSDoc */
    Severity["Debug"] = "debug";
    /** JSDoc */
    Severity["Critical"] = "critical";
})(Severity = exports.Severity || (exports.Severity = {}));
// tslint:disable:no-unnecessary-qualifier no-namespace
(function (Severity) {
    /**
     * Converts a string-based level into a {@link Severity}.
     *
     * @param level string representation of Severity
     * @returns Severity
     */
    function fromString(level) {
        switch (level) {
            case 'debug':
                return Severity.Debug;
            case 'info':
                return Severity.Info;
            case 'warn':
            case 'warning':
                return Severity.Warning;
            case 'error':
                return Severity.Error;
            case 'fatal':
                return Severity.Fatal;
            case 'critical':
                return Severity.Critical;
            case 'log':
            default:
                return Severity.Log;
        }
    }
    Severity.fromString = fromString;
})(Severity = exports.Severity || (exports.Severity = {}));
/** The status of an event. */
var Status;
(function (Status) {
    /** The status could not be determined. */
    Status["Unknown"] = "unknown";
    /** The event was skipped due to configuration or callbacks. */
    Status["Skipped"] = "skipped";
    /** The event was sent to Sentry successfully. */
    Status["Success"] = "success";
    /** The client is currently rate limited and will try again later. */
    Status["RateLimit"] = "rate_limit";
    /** The event could not be processed. */
    Status["Invalid"] = "invalid";
    /** A server-side error ocurred during submission. */
    Status["Failed"] = "failed";
})(Status = exports.Status || (exports.Status = {}));
// tslint:disable:no-unnecessary-qualifier no-namespace
(function (Status) {
    /**
     * Converts a HTTP status code into a {@link Status}.
     *
     * @param code The HTTP response status code.
     * @returns The send status or {@link Status.Unknown}.
     */
    function fromHttpCode(code) {
        if (code >= 200 && code < 300) {
            return Status.Success;
        }
        if (code === 429) {
            return Status.RateLimit;
        }
        if (code >= 400 && code < 500) {
            return Status.Invalid;
        }
        if (code >= 500) {
            return Status.Failed;
        }
        return Status.Unknown;
    }
    Status.fromHttpCode = fromHttpCode;
})(Status = exports.Status || (exports.Status = {}));
//# sourceMappingURL=index.js.map

/***/ }),
/* 753 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(43);
var error_1 = __webpack_require__(291);
/** A simple queue that holds promises. */
var PromiseBuffer = /** @class */ (function () {
    function PromiseBuffer(limit) {
        this.limit = limit;
        /** Internal set of queued Promises */
        this.buffer = [];
    }
    /**
     * Says if the buffer is ready to take more requests
     */
    PromiseBuffer.prototype.isReady = function () {
        return this.limit === undefined || this.length() < this.limit;
    };
    /**
     * Add a promise to the queue.
     *
     * @param task Can be any Promise<T>
     * @returns The original promise.
     */
    PromiseBuffer.prototype.add = function (task) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                if (!this.isReady()) {
                    return [2 /*return*/, Promise.reject(new error_1.SentryError('Not adding Promise due to buffer limit reached.'))];
                }
                if (this.buffer.indexOf(task) === -1) {
                    this.buffer.push(task);
                }
                task
                    .then(function () { return tslib_1.__awaiter(_this, void 0, void 0, function () { return tslib_1.__generator(this, function (_a) {
                    return [2 /*return*/, this.remove(task)];
                }); }); })
                    .catch(function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                    return tslib_1.__generator(this, function (_a) {
                        return [2 /*return*/, this.remove(task).catch(function () {
                                // We have to add this catch here otherwise we have an unhandledPromiseRejection
                                // because it's a new Promise chain.
                            })];
                    });
                }); });
                return [2 /*return*/, task];
            });
        });
    };
    /**
     * Remove a promise to the queue.
     *
     * @param task Can be any Promise<T>
     * @returns Removed promise.
     */
    PromiseBuffer.prototype.remove = function (task) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var removedTask;
            return tslib_1.__generator(this, function (_a) {
                removedTask = this.buffer.splice(this.buffer.indexOf(task), 1)[0];
                return [2 /*return*/, removedTask];
            });
        });
    };
    /**
     * This function returns the number of unresolved promises in the queue.
     */
    PromiseBuffer.prototype.length = function () {
        return this.buffer.length;
    };
    /**
     * This will drain the whole queue, returns true if queue is empty or drained.
     * If timeout is provided and the queue takes longer to drain, the promise still resolves but with false.
     *
     * @param timeout Number in ms to wait until it resolves with false.
     */
    PromiseBuffer.prototype.drain = function (timeout) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve) {
                        var capturedSetTimeout = setTimeout(function () {
                            if (timeout && timeout > 0) {
                                resolve(false);
                            }
                        }, timeout);
                        Promise.all(_this.buffer)
                            .then(function () {
                            clearTimeout(capturedSetTimeout);
                            resolve(true);
                        })
                            .catch(function () {
                            resolve(true);
                        });
                    })];
            });
        });
    };
    return PromiseBuffer;
}());
exports.PromiseBuffer = PromiseBuffer;
//# sourceMappingURL=promisebuffer.js.map

/***/ }),
/* 754 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(43);
var types_1 = __webpack_require__(752);
/** Noop transport */
var NoopTransport = /** @class */ (function () {
    function NoopTransport() {
    }
    /**
     * @inheritDoc
     */
    NoopTransport.prototype.sendEvent = function (_) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, Promise.resolve({
                        reason: "NoopTransport: Event has been skipped because no Dsn is configured.",
                        status: types_1.Status.Skipped,
                    })];
            });
        });
    };
    /**
     * @inheritDoc
     */
    NoopTransport.prototype.close = function (_) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, Promise.resolve(true)];
            });
        });
    };
    return NoopTransport;
}());
exports.NoopTransport = NoopTransport;
//# sourceMappingURL=noop.js.map

/***/ }),
/* 755 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(756);
module.exports = __webpack_require__(760);


/***/ }),
/* 756 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// @remove-on-eject-begin
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
// @remove-on-eject-end


if (typeof Promise === 'undefined') {
  // Rejection tracking prevents a common issue where React gets into an
  // inconsistent state due to an error, but it gets swallowed by a Promise,
  // and the user has no idea what causes React's erratic future behavior.
  __webpack_require__(757).enable();
  window.Promise = __webpack_require__(758);
}

// fetch() polyfill for making API calls.
__webpack_require__(759);

// Object.assign() is commonly used with React.
// It will use the native implementation if it's present and isn't buggy.
Object.assign = __webpack_require__(57);

// In tests, polyfill requestAnimationFrame since jsdom doesn't provide it yet.
// We don't polyfill it in the browser--this is user's responsibility.
if (false) {
  require('raf').polyfill(global);
}


/***/ }),
/* 757 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Promise = __webpack_require__(434);

var DEFAULT_WHITELIST = [
  ReferenceError,
  TypeError,
  RangeError
];

var enabled = false;
exports.disable = disable;
function disable() {
  enabled = false;
  Promise._47 = null;
  Promise._71 = null;
}

exports.enable = enable;
function enable(options) {
  options = options || {};
  if (enabled) disable();
  enabled = true;
  var id = 0;
  var displayId = 0;
  var rejections = {};
  Promise._47 = function (promise) {
    if (
      promise._83 === 2 && // IS REJECTED
      rejections[promise._56]
    ) {
      if (rejections[promise._56].logged) {
        onHandled(promise._56);
      } else {
        clearTimeout(rejections[promise._56].timeout);
      }
      delete rejections[promise._56];
    }
  };
  Promise._71 = function (promise, err) {
    if (promise._75 === 0) { // not yet handled
      promise._56 = id++;
      rejections[promise._56] = {
        displayId: null,
        error: err,
        timeout: setTimeout(
          onUnhandled.bind(null, promise._56),
          // For reference errors and type errors, this almost always
          // means the programmer made a mistake, so log them after just
          // 100ms
          // otherwise, wait 2 seconds to see if they get handled
          matchWhitelist(err, DEFAULT_WHITELIST)
            ? 100
            : 2000
        ),
        logged: false
      };
    }
  };
  function onUnhandled(id) {
    if (
      options.allRejections ||
      matchWhitelist(
        rejections[id].error,
        options.whitelist || DEFAULT_WHITELIST
      )
    ) {
      rejections[id].displayId = displayId++;
      if (options.onUnhandled) {
        rejections[id].logged = true;
        options.onUnhandled(
          rejections[id].displayId,
          rejections[id].error
        );
      } else {
        rejections[id].logged = true;
        logError(
          rejections[id].displayId,
          rejections[id].error
        );
      }
    }
  }
  function onHandled(id) {
    if (rejections[id].logged) {
      if (options.onHandled) {
        options.onHandled(rejections[id].displayId, rejections[id].error);
      } else if (!rejections[id].onUnhandled) {
        console.warn(
          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
        );
        console.warn(
          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
          rejections[id].displayId + '.'
        );
      }
    }
  }
}

function logError(id, error) {
  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
  var errStr = (error && (error.stack || error)) + '';
  errStr.split('\n').forEach(function (line) {
    console.warn('  ' + line);
  });
}

function matchWhitelist(error, list) {
  return list.some(function (cls) {
    return error instanceof cls;
  });
}

/***/ }),
/* 758 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//This file contains the ES6 extensions to the core Promises/A+ API

var Promise = __webpack_require__(434);

module.exports = Promise;

/* Static Functions */

var TRUE = valuePromise(true);
var FALSE = valuePromise(false);
var NULL = valuePromise(null);
var UNDEFINED = valuePromise(undefined);
var ZERO = valuePromise(0);
var EMPTYSTRING = valuePromise('');

function valuePromise(value) {
  var p = new Promise(Promise._44);
  p._83 = 1;
  p._18 = value;
  return p;
}
Promise.resolve = function (value) {
  if (value instanceof Promise) return value;

  if (value === null) return NULL;
  if (value === undefined) return UNDEFINED;
  if (value === true) return TRUE;
  if (value === false) return FALSE;
  if (value === 0) return ZERO;
  if (value === '') return EMPTYSTRING;

  if (typeof value === 'object' || typeof value === 'function') {
    try {
      var then = value.then;
      if (typeof then === 'function') {
        return new Promise(then.bind(value));
      }
    } catch (ex) {
      return new Promise(function (resolve, reject) {
        reject(ex);
      });
    }
  }
  return valuePromise(value);
};

Promise.all = function (arr) {
  var args = Array.prototype.slice.call(arr);

  return new Promise(function (resolve, reject) {
    if (args.length === 0) return resolve([]);
    var remaining = args.length;
    function res(i, val) {
      if (val && (typeof val === 'object' || typeof val === 'function')) {
        if (val instanceof Promise && val.then === Promise.prototype.then) {
          while (val._83 === 3) {
            val = val._18;
          }
          if (val._83 === 1) return res(i, val._18);
          if (val._83 === 2) reject(val._18);
          val.then(function (val) {
            res(i, val);
          }, reject);
          return;
        } else {
          var then = val.then;
          if (typeof then === 'function') {
            var p = new Promise(then.bind(val));
            p.then(function (val) {
              res(i, val);
            }, reject);
            return;
          }
        }
      }
      args[i] = val;
      if (--remaining === 0) {
        resolve(args);
      }
    }
    for (var i = 0; i < args.length; i++) {
      res(i, args[i]);
    }
  });
};

Promise.reject = function (value) {
  return new Promise(function (resolve, reject) {
    reject(value);
  });
};

Promise.race = function (values) {
  return new Promise(function (resolve, reject) {
    values.forEach(function(value){
      Promise.resolve(value).then(resolve, reject);
    });
  });
};

/* Prototype Methods */

Promise.prototype['catch'] = function (onRejected) {
  return this.then(null, onRejected);
};


/***/ }),
/* 759 */
/***/ (function(module, exports) {

(function(self) {
  'use strict';

  if (self.fetch) {
    return
  }

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob: 'FileReader' in self && 'Blob' in self && (function() {
      try {
        new Blob()
        return true
      } catch(e) {
        return false
      }
    })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ]

    var isDataView = function(obj) {
      return obj && DataView.prototype.isPrototypeOf(obj)
    }

    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name)
    }
    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value)
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift()
        return {done: value === undefined, value: value}
      }
    }

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      }
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {}

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value)
      }, this)
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1])
      }, this)
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name])
      }, this)
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name)
    value = normalizeValue(value)
    var oldValue = this.map[name]
    this.map[name] = oldValue ? oldValue+','+value : value
  }

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)]
  }

  Headers.prototype.get = function(name) {
    name = normalizeName(name)
    return this.has(name) ? this.map[name] : null
  }

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  }

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value)
  }

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this)
      }
    }
  }

  Headers.prototype.keys = function() {
    var items = []
    this.forEach(function(value, name) { items.push(name) })
    return iteratorFor(items)
  }

  Headers.prototype.values = function() {
    var items = []
    this.forEach(function(value) { items.push(value) })
    return iteratorFor(items)
  }

  Headers.prototype.entries = function() {
    var items = []
    this.forEach(function(value, name) { items.push([name, value]) })
    return iteratorFor(items)
  }

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result)
      }
      reader.onerror = function() {
        reject(reader.error)
      }
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsArrayBuffer(blob)
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsText(blob)
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf)
    var chars = new Array(view.length)

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i])
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength)
      view.set(new Uint8Array(buf))
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false

    this._initBody = function(body) {
      this._bodyInit = body
      if (!body) {
        this._bodyText = ''
      } else if (typeof body === 'string') {
        this._bodyText = body
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString()
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer)
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer])
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body)
      } else {
        throw new Error('unsupported BodyInit type')
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8')
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type)
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
        }
      }
    }

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this)
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      }

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      }
    }

    this.text = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    }

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      }
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    }

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

  function normalizeMethod(method) {
    var upcased = method.toUpperCase()
    return (methods.indexOf(upcased) > -1) ? upcased : method
  }

  function Request(input, options) {
    options = options || {}
    var body = options.body

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url
      this.credentials = input.credentials
      if (!options.headers) {
        this.headers = new Headers(input.headers)
      }
      this.method = input.method
      this.mode = input.mode
      if (!body && input._bodyInit != null) {
        body = input._bodyInit
        input.bodyUsed = true
      }
    } else {
      this.url = String(input)
    }

    this.credentials = options.credentials || this.credentials || 'omit'
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers)
    }
    this.method = normalizeMethod(options.method || this.method || 'GET')
    this.mode = options.mode || this.mode || null
    this.referrer = null

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body)
  }

  Request.prototype.clone = function() {
    return new Request(this, { body: this._bodyInit })
  }

  function decode(body) {
    var form = new FormData()
    body.trim().split('&').forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers()
    rawHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':')
      var key = parts.shift().trim()
      if (key) {
        var value = parts.join(':').trim()
        headers.append(key, value)
      }
    })
    return headers
  }

  Body.call(Request.prototype)

  function Response(bodyInit, options) {
    if (!options) {
      options = {}
    }

    this.type = 'default'
    this.status = 'status' in options ? options.status : 200
    this.ok = this.status >= 200 && this.status < 300
    this.statusText = 'statusText' in options ? options.statusText : 'OK'
    this.headers = new Headers(options.headers)
    this.url = options.url || ''
    this._initBody(bodyInit)
  }

  Body.call(Response.prototype)

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  }

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''})
    response.type = 'error'
    return response
  }

  var redirectStatuses = [301, 302, 303, 307, 308]

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  }

  self.Headers = Headers
  self.Request = Request
  self.Response = Response

  self.fetch = function(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init)
      var xhr = new XMLHttpRequest()

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        }
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
        var body = 'response' in xhr ? xhr.response : xhr.responseText
        resolve(new Response(body, options))
      }

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.open(request.method, request.url, true)

      if (request.credentials === 'include') {
        xhr.withCredentials = true
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob'
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
    })
  }
  self.fetch.polyfill = true
})(typeof self !== 'undefined' ? self : this);


/***/ }),
/* 760 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_history__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_routes_index_jsx__ = __webpack_require__(785);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_apollo_client__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_apollo_link_http__ = __webpack_require__(2860);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_apollo_cache_inmemory__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_apollo__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_assets_scss_material_dashboard_pro_react_css_v_1_2_0__ = __webpack_require__(2862);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_assets_scss_material_dashboard_pro_react_css_v_1_2_0___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_assets_scss_material_dashboard_pro_react_css_v_1_2_0__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_index_css__ = __webpack_require__(2863);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_helpers_UserHelper__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_helpers_DateHelpers__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_apollo_link_error__ = __webpack_require__(2864);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__sentry_browser__ = __webpack_require__(2865);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__sentry_browser___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__sentry_browser__);
__WEBPACK_IMPORTED_MODULE_17__sentry_browser__["init"]({dsn:"https://caabdd4285d44278afd12fc7691cc3d2@sentry.io/1330570",defaultIntegrations:false});var theme=Object(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["_0" /* createMuiTheme */])({palette:{primary:{main:"#555270",light:"#827e9e",dark:"#2b2a45"},secondary:{main:"#6c5cab",light:"#9d89dd",dark:"#3d327b"},grey:{main:"#607d8b",light:"#8eacbb",dark:"#34515e"}}});var hist=Object(__WEBPACK_IMPORTED_MODULE_2_history__["a" /* createBrowserHistory */])();var logToSentry=true;var sendToLogger=function sendToLogger(graphQLErrors){__WEBPACK_IMPORTED_MODULE_17__sentry_browser__["withScope"](function(scope){var token=Object(__WEBPACK_IMPORTED_MODULE_14_helpers_UserHelper__["c" /* GetUserToken */])();if(token&&token.trim()!==""){scope.setUser({Email:Object(__WEBPACK_IMPORTED_MODULE_14_helpers_UserHelper__["b" /* GetUserKey */])("userEmail"),Name:Object(__WEBPACK_IMPORTED_MODULE_14_helpers_UserHelper__["b" /* GetUserKey */])("name"),Surname:Object(__WEBPACK_IMPORTED_MODULE_14_helpers_UserHelper__["b" /* GetUserKey */])("surname"),UserId:Object(__WEBPACK_IMPORTED_MODULE_14_helpers_UserHelper__["b" /* GetUserKey */])("userID")});}scope.setTag("ErrorType","GraphQL");scope.setTag("Platform","Web");scope.setLevel("fatal");scope.setExtra("Errors:",graphQLErrors);scope.setExtra("Url:",window.location.href);var now=Object(__WEBPACK_IMPORTED_MODULE_15_helpers_DateHelpers__["e" /* createCustomDateString1 */])();__WEBPACK_IMPORTED_MODULE_17__sentry_browser__["captureException"]("GraphqlError "+now);});};var requestLink=Object(__WEBPACK_IMPORTED_MODULE_8_apollo_link_http__["a" /* createHttpLink */])({uri:"http://rhlm.co.za/api/graphql"});var errorLink=Object(__WEBPACK_IMPORTED_MODULE_16_apollo_link_error__["a" /* onError */])(function(_ref){var networkError=_ref.networkError,graphQLErrors=_ref.graphQLErrors;if(logToSentry){if(graphQLErrors)sendToLogger(graphQLErrors);}});var link=errorLink.concat(requestLink);var client=new __WEBPACK_IMPORTED_MODULE_7_apollo_client__["ApolloClient"]({link:link,cache:new __WEBPACK_IMPORTED_MODULE_9_apollo_cache_inmemory__["a" /* InMemoryCache */]()});__WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.render(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_redux__["a" /* Provider */],{store:__WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react_apollo__["ApolloProvider"],{client:client},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["H" /* MuiThemeProvider */],{theme:theme},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["d" /* Router */],{history:hist},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["e" /* Switch */],null,__WEBPACK_IMPORTED_MODULE_4_routes_index_jsx__["a" /* default */].map(function(prop,key){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["c" /* Route */],{path:prop.path,component:prop.component,key:key});})))))),document.getElementById("root"));

/***/ }),
/* 761 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.4.0
 * react.production.min.js
 *
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var k=__webpack_require__(57),n=__webpack_require__(292),p=__webpack_require__(293),q=__webpack_require__(294),r="function"===typeof Symbol&&Symbol.for,t=r?Symbol.for("react.element"):60103,u=r?Symbol.for("react.portal"):60106,v=r?Symbol.for("react.fragment"):60107,w=r?Symbol.for("react.strict_mode"):60108,x=r?Symbol.for("react.profiler"):60114,y=r?Symbol.for("react.provider"):60109,z=r?Symbol.for("react.context"):60110,A=r?Symbol.for("react.async_mode"):60111,B=
r?Symbol.for("react.forward_ref"):60112;r&&Symbol.for("react.timeout");var C="function"===typeof Symbol&&Symbol.iterator;function D(a){for(var b=arguments.length-1,e="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=0;c<b;c++)e+="&args[]="+encodeURIComponent(arguments[c+1]);n(!1,"Minified React error #"+a+"; visit %s for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ",e)}
var E={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}};function F(a,b,e){this.props=a;this.context=b;this.refs=p;this.updater=e||E}F.prototype.isReactComponent={};F.prototype.setState=function(a,b){"object"!==typeof a&&"function"!==typeof a&&null!=a?D("85"):void 0;this.updater.enqueueSetState(this,a,b,"setState")};F.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};function G(){}
G.prototype=F.prototype;function H(a,b,e){this.props=a;this.context=b;this.refs=p;this.updater=e||E}var I=H.prototype=new G;I.constructor=H;k(I,F.prototype);I.isPureReactComponent=!0;var J={current:null},K=Object.prototype.hasOwnProperty,L={key:!0,ref:!0,__self:!0,__source:!0};
function M(a,b,e){var c=void 0,d={},g=null,h=null;if(null!=b)for(c in void 0!==b.ref&&(h=b.ref),void 0!==b.key&&(g=""+b.key),b)K.call(b,c)&&!L.hasOwnProperty(c)&&(d[c]=b[c]);var f=arguments.length-2;if(1===f)d.children=e;else if(1<f){for(var l=Array(f),m=0;m<f;m++)l[m]=arguments[m+2];d.children=l}if(a&&a.defaultProps)for(c in f=a.defaultProps,f)void 0===d[c]&&(d[c]=f[c]);return{$$typeof:t,type:a,key:g,ref:h,props:d,_owner:J.current}}
function N(a){return"object"===typeof a&&null!==a&&a.$$typeof===t}function escape(a){var b={"=":"=0",":":"=2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var O=/\/+/g,P=[];function Q(a,b,e,c){if(P.length){var d=P.pop();d.result=a;d.keyPrefix=b;d.func=e;d.context=c;d.count=0;return d}return{result:a,keyPrefix:b,func:e,context:c,count:0}}function R(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>P.length&&P.push(a)}
function S(a,b,e,c){var d=typeof a;if("undefined"===d||"boolean"===d)a=null;var g=!1;if(null===a)g=!0;else switch(d){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case t:case u:g=!0}}if(g)return e(c,a,""===b?"."+T(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var h=0;h<a.length;h++){d=a[h];var f=b+T(d,h);g+=S(d,f,e,c)}else if(null===a||"undefined"===typeof a?f=null:(f=C&&a[C]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=f.call(a),
h=0;!(d=a.next()).done;)d=d.value,f=b+T(d,h++),g+=S(d,f,e,c);else"object"===d&&(e=""+a,D("31","[object Object]"===e?"object with keys {"+Object.keys(a).join(", ")+"}":e,""));return g}function T(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function U(a,b){a.func.call(a.context,b,a.count++)}
function V(a,b,e){var c=a.result,d=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?W(a,c,e,q.thatReturnsArgument):null!=a&&(N(a)&&(b=d+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(O,"$&/")+"/")+e,a={$$typeof:t,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}),c.push(a))}function W(a,b,e,c,d){var g="";null!=e&&(g=(""+e).replace(O,"$&/")+"/");b=Q(b,g,c,d);null==a||S(a,"",V,b);R(b)}
var X={Children:{map:function(a,b,e){if(null==a)return a;var c=[];W(a,c,null,b,e);return c},forEach:function(a,b,e){if(null==a)return a;b=Q(null,null,b,e);null==a||S(a,"",U,b);R(b)},count:function(a){return null==a?0:S(a,"",q.thatReturnsNull,null)},toArray:function(a){var b=[];W(a,b,null,q.thatReturnsArgument);return b},only:function(a){N(a)?void 0:D("143");return a}},createRef:function(){return{current:null}},Component:F,PureComponent:H,createContext:function(a,b){void 0===b&&(b=null);a={$$typeof:z,
_calculateChangedBits:b,_defaultValue:a,_currentValue:a,_currentValue2:a,_changedBits:0,_changedBits2:0,Provider:null,Consumer:null};a.Provider={$$typeof:y,_context:a};return a.Consumer=a},forwardRef:function(a){return{$$typeof:B,render:a}},Fragment:v,StrictMode:w,unstable_AsyncMode:A,unstable_Profiler:x,createElement:M,cloneElement:function(a,b,e){null===a||void 0===a?D("267",a):void 0;var c=void 0,d=k({},a.props),g=a.key,h=a.ref,f=a._owner;if(null!=b){void 0!==b.ref&&(h=b.ref,f=J.current);void 0!==
b.key&&(g=""+b.key);var l=void 0;a.type&&a.type.defaultProps&&(l=a.type.defaultProps);for(c in b)K.call(b,c)&&!L.hasOwnProperty(c)&&(d[c]=void 0===b[c]&&void 0!==l?l[c]:b[c])}c=arguments.length-2;if(1===c)d.children=e;else if(1<c){l=Array(c);for(var m=0;m<c;m++)l[m]=arguments[m+2];d.children=l}return{$$typeof:t,type:a.type,key:g,ref:h,props:d,_owner:f}},createFactory:function(a){var b=M.bind(null,a);b.type=a;return b},isValidElement:N,version:"16.4.0",__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{ReactCurrentOwner:J,
assign:k}},Y={default:X},Z=Y&&X||Y;module.exports=Z.default?Z.default:Z;


/***/ }),
/* 762 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.4.0
 * react-dom.production.min.js
 *
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/
var aa=__webpack_require__(292),ca=__webpack_require__(0),m=__webpack_require__(763),p=__webpack_require__(57),v=__webpack_require__(294),da=__webpack_require__(764),ea=__webpack_require__(295),fa=__webpack_require__(765),ha=__webpack_require__(293);
function A(a){for(var b=arguments.length-1,c="https://reactjs.org/docs/error-decoder.html?invariant="+a,d=0;d<b;d++)c+="&args[]="+encodeURIComponent(arguments[d+1]);aa(!1,"Minified React error #"+a+"; visit %s for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ",c)}ca?void 0:A("227");
function ia(a,b,c,d,e,f,g,h,k){this._hasCaughtError=!1;this._caughtError=null;var n=Array.prototype.slice.call(arguments,3);try{b.apply(c,n)}catch(r){this._caughtError=r,this._hasCaughtError=!0}}
var B={_caughtError:null,_hasCaughtError:!1,_rethrowError:null,_hasRethrowError:!1,invokeGuardedCallback:function(a,b,c,d,e,f,g,h,k){ia.apply(B,arguments)},invokeGuardedCallbackAndCatchFirstError:function(a,b,c,d,e,f,g,h,k){B.invokeGuardedCallback.apply(this,arguments);if(B.hasCaughtError()){var n=B.clearCaughtError();B._hasRethrowError||(B._hasRethrowError=!0,B._rethrowError=n)}},rethrowCaughtError:function(){return ka.apply(B,arguments)},hasCaughtError:function(){return B._hasCaughtError},clearCaughtError:function(){if(B._hasCaughtError){var a=
B._caughtError;B._caughtError=null;B._hasCaughtError=!1;return a}A("198")}};function ka(){if(B._hasRethrowError){var a=B._rethrowError;B._rethrowError=null;B._hasRethrowError=!1;throw a;}}var la=null,ma={};
function na(){if(la)for(var a in ma){var b=ma[a],c=la.indexOf(a);-1<c?void 0:A("96",a);if(!oa[c]){b.extractEvents?void 0:A("97",a);oa[c]=b;c=b.eventTypes;for(var d in c){var e=void 0;var f=c[d],g=b,h=d;pa.hasOwnProperty(h)?A("99",h):void 0;pa[h]=f;var k=f.phasedRegistrationNames;if(k){for(e in k)k.hasOwnProperty(e)&&qa(k[e],g,h);e=!0}else f.registrationName?(qa(f.registrationName,g,h),e=!0):e=!1;e?void 0:A("98",d,a)}}}}
function qa(a,b,c){ra[a]?A("100",a):void 0;ra[a]=b;sa[a]=b.eventTypes[c].dependencies}var oa=[],pa={},ra={},sa={};function ta(a){la?A("101"):void 0;la=Array.prototype.slice.call(a);na()}function ua(a){var b=!1,c;for(c in a)if(a.hasOwnProperty(c)){var d=a[c];ma.hasOwnProperty(c)&&ma[c]===d||(ma[c]?A("102",c):void 0,ma[c]=d,b=!0)}b&&na()}
var va={plugins:oa,eventNameDispatchConfigs:pa,registrationNameModules:ra,registrationNameDependencies:sa,possibleRegistrationNames:null,injectEventPluginOrder:ta,injectEventPluginsByName:ua},wa=null,xa=null,ya=null;function za(a,b,c,d){b=a.type||"unknown-event";a.currentTarget=ya(d);B.invokeGuardedCallbackAndCatchFirstError(b,c,void 0,a);a.currentTarget=null}
function Aa(a,b){null==b?A("30"):void 0;if(null==a)return b;if(Array.isArray(a)){if(Array.isArray(b))return a.push.apply(a,b),a;a.push(b);return a}return Array.isArray(b)?[a].concat(b):[a,b]}function Ba(a,b,c){Array.isArray(a)?a.forEach(b,c):a&&b.call(c,a)}var Ca=null;
function Da(a,b){if(a){var c=a._dispatchListeners,d=a._dispatchInstances;if(Array.isArray(c))for(var e=0;e<c.length&&!a.isPropagationStopped();e++)za(a,b,c[e],d[e]);else c&&za(a,b,c,d);a._dispatchListeners=null;a._dispatchInstances=null;a.isPersistent()||a.constructor.release(a)}}function Ea(a){return Da(a,!0)}function Fa(a){return Da(a,!1)}var Ga={injectEventPluginOrder:ta,injectEventPluginsByName:ua};
function Ha(a,b){var c=a.stateNode;if(!c)return null;var d=wa(c);if(!d)return null;c=d[b];a:switch(b){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":(d=!d.disabled)||(a=a.type,d=!("button"===a||"input"===a||"select"===a||"textarea"===a));a=!d;break a;default:a=!1}if(a)return null;c&&"function"!==typeof c?A("231",b,typeof c):void 0;
return c}function Ia(a,b){null!==a&&(Ca=Aa(Ca,a));a=Ca;Ca=null;a&&(b?Ba(a,Ea):Ba(a,Fa),Ca?A("95"):void 0,B.rethrowCaughtError())}function Ja(a,b,c,d){for(var e=null,f=0;f<oa.length;f++){var g=oa[f];g&&(g=g.extractEvents(a,b,c,d))&&(e=Aa(e,g))}Ia(e,!1)}var Ka={injection:Ga,getListener:Ha,runEventsInBatch:Ia,runExtractedEventsInBatch:Ja},La=Math.random().toString(36).slice(2),C="__reactInternalInstance$"+La,Ma="__reactEventHandlers$"+La;
function Na(a){if(a[C])return a[C];for(;!a[C];)if(a.parentNode)a=a.parentNode;else return null;a=a[C];return 5===a.tag||6===a.tag?a:null}function Oa(a){if(5===a.tag||6===a.tag)return a.stateNode;A("33")}function Pa(a){return a[Ma]||null}var Qa={precacheFiberNode:function(a,b){b[C]=a},getClosestInstanceFromNode:Na,getInstanceFromNode:function(a){a=a[C];return!a||5!==a.tag&&6!==a.tag?null:a},getNodeFromInstance:Oa,getFiberCurrentPropsFromNode:Pa,updateFiberProps:function(a,b){a[Ma]=b}};
function F(a){do a=a.return;while(a&&5!==a.tag);return a?a:null}function Ra(a,b,c){for(var d=[];a;)d.push(a),a=F(a);for(a=d.length;0<a--;)b(d[a],"captured",c);for(a=0;a<d.length;a++)b(d[a],"bubbled",c)}function Sa(a,b,c){if(b=Ha(a,c.dispatchConfig.phasedRegistrationNames[b]))c._dispatchListeners=Aa(c._dispatchListeners,b),c._dispatchInstances=Aa(c._dispatchInstances,a)}function Ta(a){a&&a.dispatchConfig.phasedRegistrationNames&&Ra(a._targetInst,Sa,a)}
function Ua(a){if(a&&a.dispatchConfig.phasedRegistrationNames){var b=a._targetInst;b=b?F(b):null;Ra(b,Sa,a)}}function Va(a,b,c){a&&c&&c.dispatchConfig.registrationName&&(b=Ha(a,c.dispatchConfig.registrationName))&&(c._dispatchListeners=Aa(c._dispatchListeners,b),c._dispatchInstances=Aa(c._dispatchInstances,a))}function Xa(a){a&&a.dispatchConfig.registrationName&&Va(a._targetInst,null,a)}function Ya(a){Ba(a,Ta)}
function Za(a,b,c,d){if(c&&d)a:{var e=c;for(var f=d,g=0,h=e;h;h=F(h))g++;h=0;for(var k=f;k;k=F(k))h++;for(;0<g-h;)e=F(e),g--;for(;0<h-g;)f=F(f),h--;for(;g--;){if(e===f||e===f.alternate)break a;e=F(e);f=F(f)}e=null}else e=null;f=e;for(e=[];c&&c!==f;){g=c.alternate;if(null!==g&&g===f)break;e.push(c);c=F(c)}for(c=[];d&&d!==f;){g=d.alternate;if(null!==g&&g===f)break;c.push(d);d=F(d)}for(d=0;d<e.length;d++)Va(e[d],"bubbled",a);for(a=c.length;0<a--;)Va(c[a],"captured",b)}
var $a={accumulateTwoPhaseDispatches:Ya,accumulateTwoPhaseDispatchesSkipTarget:function(a){Ba(a,Ua)},accumulateEnterLeaveDispatches:Za,accumulateDirectDispatches:function(a){Ba(a,Xa)}};function ab(a,b){var c={};c[a.toLowerCase()]=b.toLowerCase();c["Webkit"+a]="webkit"+b;c["Moz"+a]="moz"+b;c["ms"+a]="MS"+b;c["O"+a]="o"+b.toLowerCase();return c}
var bb={animationend:ab("Animation","AnimationEnd"),animationiteration:ab("Animation","AnimationIteration"),animationstart:ab("Animation","AnimationStart"),transitionend:ab("Transition","TransitionEnd")},cb={},db={};m.canUseDOM&&(db=document.createElement("div").style,"AnimationEvent"in window||(delete bb.animationend.animation,delete bb.animationiteration.animation,delete bb.animationstart.animation),"TransitionEvent"in window||delete bb.transitionend.transition);
function eb(a){if(cb[a])return cb[a];if(!bb[a])return a;var b=bb[a],c;for(c in b)if(b.hasOwnProperty(c)&&c in db)return cb[a]=b[c];return a}var fb=eb("animationend"),gb=eb("animationiteration"),hb=eb("animationstart"),ib=eb("transitionend"),jb="abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "),kb=null;
function lb(){!kb&&m.canUseDOM&&(kb="textContent"in document.documentElement?"textContent":"innerText");return kb}var G={_root:null,_startText:null,_fallbackText:null};function mb(){if(G._fallbackText)return G._fallbackText;var a,b=G._startText,c=b.length,d,e=nb(),f=e.length;for(a=0;a<c&&b[a]===e[a];a++);var g=c-a;for(d=1;d<=g&&b[c-d]===e[f-d];d++);G._fallbackText=e.slice(a,1<d?1-d:void 0);return G._fallbackText}function nb(){return"value"in G._root?G._root.value:G._root[lb()]}
var ob="dispatchConfig _targetInst nativeEvent isDefaultPrevented isPropagationStopped _dispatchListeners _dispatchInstances".split(" "),pb={type:null,target:null,currentTarget:v.thatReturnsNull,eventPhase:null,bubbles:null,cancelable:null,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:null,isTrusted:null};
function H(a,b,c,d){this.dispatchConfig=a;this._targetInst=b;this.nativeEvent=c;a=this.constructor.Interface;for(var e in a)a.hasOwnProperty(e)&&((b=a[e])?this[e]=b(c):"target"===e?this.target=d:this[e]=c[e]);this.isDefaultPrevented=(null!=c.defaultPrevented?c.defaultPrevented:!1===c.returnValue)?v.thatReturnsTrue:v.thatReturnsFalse;this.isPropagationStopped=v.thatReturnsFalse;return this}
p(H.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&(a.returnValue=!1),this.isDefaultPrevented=v.thatReturnsTrue)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=v.thatReturnsTrue)},persist:function(){this.isPersistent=v.thatReturnsTrue},isPersistent:v.thatReturnsFalse,
destructor:function(){var a=this.constructor.Interface,b;for(b in a)this[b]=null;for(a=0;a<ob.length;a++)this[ob[a]]=null}});H.Interface=pb;H.extend=function(a){function b(){}function c(){return d.apply(this,arguments)}var d=this;b.prototype=d.prototype;var e=new b;p(e,c.prototype);c.prototype=e;c.prototype.constructor=c;c.Interface=p({},d.Interface,a);c.extend=d.extend;qb(c);return c};qb(H);
function rb(a,b,c,d){if(this.eventPool.length){var e=this.eventPool.pop();this.call(e,a,b,c,d);return e}return new this(a,b,c,d)}function sb(a){a instanceof this?void 0:A("223");a.destructor();10>this.eventPool.length&&this.eventPool.push(a)}function qb(a){a.eventPool=[];a.getPooled=rb;a.release=sb}var tb=H.extend({data:null}),ub=H.extend({data:null}),vb=[9,13,27,32],wb=m.canUseDOM&&"CompositionEvent"in window,xb=null;m.canUseDOM&&"documentMode"in document&&(xb=document.documentMode);
var yb=m.canUseDOM&&"TextEvent"in window&&!xb,zb=m.canUseDOM&&(!wb||xb&&8<xb&&11>=xb),Ab=String.fromCharCode(32),Bb={beforeInput:{phasedRegistrationNames:{bubbled:"onBeforeInput",captured:"onBeforeInputCapture"},dependencies:["compositionend","keypress","textInput","paste"]},compositionEnd:{phasedRegistrationNames:{bubbled:"onCompositionEnd",captured:"onCompositionEndCapture"},dependencies:"blur compositionend keydown keypress keyup mousedown".split(" ")},compositionStart:{phasedRegistrationNames:{bubbled:"onCompositionStart",
captured:"onCompositionStartCapture"},dependencies:"blur compositionstart keydown keypress keyup mousedown".split(" ")},compositionUpdate:{phasedRegistrationNames:{bubbled:"onCompositionUpdate",captured:"onCompositionUpdateCapture"},dependencies:"blur compositionupdate keydown keypress keyup mousedown".split(" ")}},Cb=!1;
function Db(a,b){switch(a){case "keyup":return-1!==vb.indexOf(b.keyCode);case "keydown":return 229!==b.keyCode;case "keypress":case "mousedown":case "blur":return!0;default:return!1}}function Eb(a){a=a.detail;return"object"===typeof a&&"data"in a?a.data:null}var Fb=!1;function Gb(a,b){switch(a){case "compositionend":return Eb(b);case "keypress":if(32!==b.which)return null;Cb=!0;return Ab;case "textInput":return a=b.data,a===Ab&&Cb?null:a;default:return null}}
function Hb(a,b){if(Fb)return"compositionend"===a||!wb&&Db(a,b)?(a=mb(),G._root=null,G._startText=null,G._fallbackText=null,Fb=!1,a):null;switch(a){case "paste":return null;case "keypress":if(!(b.ctrlKey||b.altKey||b.metaKey)||b.ctrlKey&&b.altKey){if(b.char&&1<b.char.length)return b.char;if(b.which)return String.fromCharCode(b.which)}return null;case "compositionend":return zb?null:b.data;default:return null}}
var Ib={eventTypes:Bb,extractEvents:function(a,b,c,d){var e=void 0;var f=void 0;if(wb)b:{switch(a){case "compositionstart":e=Bb.compositionStart;break b;case "compositionend":e=Bb.compositionEnd;break b;case "compositionupdate":e=Bb.compositionUpdate;break b}e=void 0}else Fb?Db(a,c)&&(e=Bb.compositionEnd):"keydown"===a&&229===c.keyCode&&(e=Bb.compositionStart);e?(zb&&(Fb||e!==Bb.compositionStart?e===Bb.compositionEnd&&Fb&&(f=mb()):(G._root=d,G._startText=nb(),Fb=!0)),e=tb.getPooled(e,b,c,d),f?e.data=
f:(f=Eb(c),null!==f&&(e.data=f)),Ya(e),f=e):f=null;(a=yb?Gb(a,c):Hb(a,c))?(b=ub.getPooled(Bb.beforeInput,b,c,d),b.data=a,Ya(b)):b=null;return null===f?b:null===b?f:[f,b]}},Jb=null,Kb={injectFiberControlledHostComponent:function(a){Jb=a}},Lb=null,Mb=null;function Nb(a){if(a=xa(a)){Jb&&"function"===typeof Jb.restoreControlledState?void 0:A("194");var b=wa(a.stateNode);Jb.restoreControlledState(a.stateNode,a.type,b)}}function Ob(a){Lb?Mb?Mb.push(a):Mb=[a]:Lb=a}
function Pb(){return null!==Lb||null!==Mb}function Qb(){if(Lb){var a=Lb,b=Mb;Mb=Lb=null;Nb(a);if(b)for(a=0;a<b.length;a++)Nb(b[a])}}var Rb={injection:Kb,enqueueStateRestore:Ob,needsStateRestore:Pb,restoreStateIfNeeded:Qb};function Sb(a,b){return a(b)}function Tb(a,b,c){return a(b,c)}function Ub(){}var Vb=!1;function Wb(a,b){if(Vb)return a(b);Vb=!0;try{return Sb(a,b)}finally{Vb=!1,Pb()&&(Ub(),Qb())}}
var Xb={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};function Yb(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return"input"===b?!!Xb[a.type]:"textarea"===b?!0:!1}function Zb(a){a=a.target||window;a.correspondingUseElement&&(a=a.correspondingUseElement);return 3===a.nodeType?a.parentNode:a}
function $b(a,b){if(!m.canUseDOM||b&&!("addEventListener"in document))return!1;a="on"+a;b=a in document;b||(b=document.createElement("div"),b.setAttribute(a,"return;"),b="function"===typeof b[a]);return b}function ac(a){var b=a.type;return(a=a.nodeName)&&"input"===a.toLowerCase()&&("checkbox"===b||"radio"===b)}
function bc(a){var b=ac(a)?"checked":"value",c=Object.getOwnPropertyDescriptor(a.constructor.prototype,b),d=""+a[b];if(!a.hasOwnProperty(b)&&"undefined"!==typeof c&&"function"===typeof c.get&&"function"===typeof c.set){var e=c.get,f=c.set;Object.defineProperty(a,b,{configurable:!0,get:function(){return e.call(this)},set:function(a){d=""+a;f.call(this,a)}});Object.defineProperty(a,b,{enumerable:c.enumerable});return{getValue:function(){return d},setValue:function(a){d=""+a},stopTracking:function(){a._valueTracker=
null;delete a[b]}}}}function cc(a){a._valueTracker||(a._valueTracker=bc(a))}function dc(a){if(!a)return!1;var b=a._valueTracker;if(!b)return!0;var c=b.getValue();var d="";a&&(d=ac(a)?a.checked?"true":"false":a.value);a=d;return a!==c?(b.setValue(a),!0):!1}
var ec=ca.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner,I="function"===typeof Symbol&&Symbol.for,fc=I?Symbol.for("react.element"):60103,gc=I?Symbol.for("react.portal"):60106,hc=I?Symbol.for("react.fragment"):60107,ic=I?Symbol.for("react.strict_mode"):60108,jc=I?Symbol.for("react.profiler"):60114,mc=I?Symbol.for("react.provider"):60109,nc=I?Symbol.for("react.context"):60110,oc=I?Symbol.for("react.async_mode"):60111,pc=I?Symbol.for("react.forward_ref"):60112,qc=I?Symbol.for("react.timeout"):
60113,rc="function"===typeof Symbol&&Symbol.iterator;function sc(a){if(null===a||"undefined"===typeof a)return null;a=rc&&a[rc]||a["@@iterator"];return"function"===typeof a?a:null}
function tc(a){var b=a.type;if("function"===typeof b)return b.displayName||b.name;if("string"===typeof b)return b;switch(b){case oc:return"AsyncMode";case nc:return"Context.Consumer";case hc:return"ReactFragment";case gc:return"ReactPortal";case jc:return"Profiler("+a.pendingProps.id+")";case mc:return"Context.Provider";case ic:return"StrictMode";case qc:return"Timeout"}if("object"===typeof b&&null!==b)switch(b.$$typeof){case pc:return a=b.render.displayName||b.render.name||"",""!==a?"ForwardRef("+
a+")":"ForwardRef"}return null}function vc(a){var b="";do{a:switch(a.tag){case 0:case 1:case 2:case 5:var c=a._debugOwner,d=a._debugSource;var e=tc(a);var f=null;c&&(f=tc(c));c=d;e="\n    in "+(e||"Unknown")+(c?" (at "+c.fileName.replace(/^.*[\\\/]/,"")+":"+c.lineNumber+")":f?" (created by "+f+")":"");break a;default:e=""}b+=e;a=a.return}while(a);return b}
var wc=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,xc={},yc={};function zc(a){if(yc.hasOwnProperty(a))return!0;if(xc.hasOwnProperty(a))return!1;if(wc.test(a))return yc[a]=!0;xc[a]=!0;return!1}
function Ac(a,b,c,d){if(null!==c&&0===c.type)return!1;switch(typeof b){case "function":case "symbol":return!0;case "boolean":if(d)return!1;if(null!==c)return!c.acceptsBooleans;a=a.toLowerCase().slice(0,5);return"data-"!==a&&"aria-"!==a;default:return!1}}function Bc(a,b,c,d){if(null===b||"undefined"===typeof b||Ac(a,b,c,d))return!0;if(d)return!1;if(null!==c)switch(c.type){case 3:return!b;case 4:return!1===b;case 5:return isNaN(b);case 6:return isNaN(b)||1>b}return!1}
function J(a,b,c,d,e){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=d;this.attributeNamespace=e;this.mustUseProperty=c;this.propertyName=a;this.type=b}var K={};"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){K[a]=new J(a,0,!1,a,null)});
[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];K[b]=new J(b,1,!1,a[1],null)});["contentEditable","draggable","spellCheck","value"].forEach(function(a){K[a]=new J(a,2,!1,a.toLowerCase(),null)});["autoReverse","externalResourcesRequired","preserveAlpha"].forEach(function(a){K[a]=new J(a,2,!1,a,null)});
"allowFullScreen async autoFocus autoPlay controls default defer disabled formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){K[a]=new J(a,3,!1,a.toLowerCase(),null)});["checked","multiple","muted","selected"].forEach(function(a){K[a]=new J(a,3,!0,a.toLowerCase(),null)});["capture","download"].forEach(function(a){K[a]=new J(a,4,!1,a.toLowerCase(),null)});
["cols","rows","size","span"].forEach(function(a){K[a]=new J(a,6,!1,a.toLowerCase(),null)});["rowSpan","start"].forEach(function(a){K[a]=new J(a,5,!1,a.toLowerCase(),null)});var Cc=/[\-:]([a-z])/g;function Dc(a){return a[1].toUpperCase()}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(Cc,
Dc);K[b]=new J(b,1,!1,a,null)});"xlink:actuate xlink:arcrole xlink:href xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(Cc,Dc);K[b]=new J(b,1,!1,a,"http://www.w3.org/1999/xlink")});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(Cc,Dc);K[b]=new J(b,1,!1,a,"http://www.w3.org/XML/1998/namespace")});K.tabIndex=new J("tabIndex",1,!1,"tabindex",null);
function Ec(a,b,c,d){var e=K.hasOwnProperty(b)?K[b]:null;var f=null!==e?0===e.type:d?!1:!(2<b.length)||"o"!==b[0]&&"O"!==b[0]||"n"!==b[1]&&"N"!==b[1]?!1:!0;f||(Bc(b,c,e,d)&&(c=null),d||null===e?zc(b)&&(null===c?a.removeAttribute(b):a.setAttribute(b,""+c)):e.mustUseProperty?a[e.propertyName]=null===c?3===e.type?!1:"":c:(b=e.attributeName,d=e.attributeNamespace,null===c?a.removeAttribute(b):(e=e.type,c=3===e||4===e&&!0===c?"":""+c,d?a.setAttributeNS(d,b,c):a.setAttribute(b,c))))}
function Fc(a,b){var c=b.checked;return p({},b,{defaultChecked:void 0,defaultValue:void 0,value:void 0,checked:null!=c?c:a._wrapperState.initialChecked})}function Gc(a,b){var c=null==b.defaultValue?"":b.defaultValue,d=null!=b.checked?b.checked:b.defaultChecked;c=Hc(null!=b.value?b.value:c);a._wrapperState={initialChecked:d,initialValue:c,controlled:"checkbox"===b.type||"radio"===b.type?null!=b.checked:null!=b.value}}function Ic(a,b){b=b.checked;null!=b&&Ec(a,"checked",b,!1)}
function Jc(a,b){Ic(a,b);var c=Hc(b.value);if(null!=c)if("number"===b.type){if(0===c&&""===a.value||a.value!=c)a.value=""+c}else a.value!==""+c&&(a.value=""+c);b.hasOwnProperty("value")?Kc(a,b.type,c):b.hasOwnProperty("defaultValue")&&Kc(a,b.type,Hc(b.defaultValue));null==b.checked&&null!=b.defaultChecked&&(a.defaultChecked=!!b.defaultChecked)}
function Lc(a,b){if(b.hasOwnProperty("value")||b.hasOwnProperty("defaultValue"))""===a.value&&(a.value=""+a._wrapperState.initialValue),a.defaultValue=""+a._wrapperState.initialValue;b=a.name;""!==b&&(a.name="");a.defaultChecked=!a.defaultChecked;a.defaultChecked=!a.defaultChecked;""!==b&&(a.name=b)}function Kc(a,b,c){if("number"!==b||a.ownerDocument.activeElement!==a)null==c?a.defaultValue=""+a._wrapperState.initialValue:a.defaultValue!==""+c&&(a.defaultValue=""+c)}
function Hc(a){switch(typeof a){case "boolean":case "number":case "object":case "string":case "undefined":return a;default:return""}}var Mc={change:{phasedRegistrationNames:{bubbled:"onChange",captured:"onChangeCapture"},dependencies:"blur change click focus input keydown keyup selectionchange".split(" ")}};function Nc(a,b,c){a=H.getPooled(Mc.change,a,b,c);a.type="change";Ob(c);Ya(a);return a}var Oc=null,Pc=null;function Qc(a){Ia(a,!1)}function Rc(a){var b=Oa(a);if(dc(b))return a}
function Sc(a,b){if("change"===a)return b}var Tc=!1;m.canUseDOM&&(Tc=$b("input")&&(!document.documentMode||9<document.documentMode));function Uc(){Oc&&(Oc.detachEvent("onpropertychange",Vc),Pc=Oc=null)}function Vc(a){"value"===a.propertyName&&Rc(Pc)&&(a=Nc(Pc,a,Zb(a)),Wb(Qc,a))}function Wc(a,b,c){"focus"===a?(Uc(),Oc=b,Pc=c,Oc.attachEvent("onpropertychange",Vc)):"blur"===a&&Uc()}function Xc(a){if("selectionchange"===a||"keyup"===a||"keydown"===a)return Rc(Pc)}
function Yc(a,b){if("click"===a)return Rc(b)}function Zc(a,b){if("input"===a||"change"===a)return Rc(b)}
var $c={eventTypes:Mc,_isInputEventSupported:Tc,extractEvents:function(a,b,c,d){var e=b?Oa(b):window,f=void 0,g=void 0,h=e.nodeName&&e.nodeName.toLowerCase();"select"===h||"input"===h&&"file"===e.type?f=Sc:Yb(e)?Tc?f=Zc:(f=Xc,g=Wc):(h=e.nodeName)&&"input"===h.toLowerCase()&&("checkbox"===e.type||"radio"===e.type)&&(f=Yc);if(f&&(f=f(a,b)))return Nc(f,c,d);g&&g(a,e,b);"blur"===a&&null!=b&&(a=b._wrapperState||e._wrapperState)&&a.controlled&&"number"===e.type&&Kc(e,"number",e.value)}},ad=H.extend({view:null,
detail:null}),bd={Alt:"altKey",Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function cd(a){var b=this.nativeEvent;return b.getModifierState?b.getModifierState(a):(a=bd[a])?!!b[a]:!1}function dd(){return cd}
var ed=ad.extend({screenX:null,screenY:null,clientX:null,clientY:null,pageX:null,pageY:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,getModifierState:dd,button:null,buttons:null,relatedTarget:function(a){return a.relatedTarget||(a.fromElement===a.srcElement?a.toElement:a.fromElement)}}),fd=ed.extend({pointerId:null,width:null,height:null,pressure:null,tiltX:null,tiltY:null,pointerType:null,isPrimary:null}),gd={mouseEnter:{registrationName:"onMouseEnter",dependencies:["mouseout","mouseover"]},
mouseLeave:{registrationName:"onMouseLeave",dependencies:["mouseout","mouseover"]},pointerEnter:{registrationName:"onPointerEnter",dependencies:["pointerout","pointerover"]},pointerLeave:{registrationName:"onPointerLeave",dependencies:["pointerout","pointerover"]}},hd={eventTypes:gd,extractEvents:function(a,b,c,d){var e="mouseover"===a||"pointerover"===a,f="mouseout"===a||"pointerout"===a;if(e&&(c.relatedTarget||c.fromElement)||!f&&!e)return null;e=d.window===d?d:(e=d.ownerDocument)?e.defaultView||
e.parentWindow:window;f?(f=b,b=(b=c.relatedTarget||c.toElement)?Na(b):null):f=null;if(f===b)return null;var g=void 0,h=void 0,k=void 0,n=void 0;if("mouseout"===a||"mouseover"===a)g=ed,h=gd.mouseLeave,k=gd.mouseEnter,n="mouse";else if("pointerout"===a||"pointerover"===a)g=fd,h=gd.pointerLeave,k=gd.pointerEnter,n="pointer";a=null==f?e:Oa(f);e=null==b?e:Oa(b);h=g.getPooled(h,f,c,d);h.type=n+"leave";h.target=a;h.relatedTarget=e;c=g.getPooled(k,b,c,d);c.type=n+"enter";c.target=e;c.relatedTarget=a;Za(h,
c,f,b);return[h,c]}};function id(a){var b=a;if(a.alternate)for(;b.return;)b=b.return;else{if(0!==(b.effectTag&2))return 1;for(;b.return;)if(b=b.return,0!==(b.effectTag&2))return 1}return 3===b.tag?2:3}function jd(a){2!==id(a)?A("188"):void 0}
function kd(a){var b=a.alternate;if(!b)return b=id(a),3===b?A("188"):void 0,1===b?null:a;for(var c=a,d=b;;){var e=c.return,f=e?e.alternate:null;if(!e||!f)break;if(e.child===f.child){for(var g=e.child;g;){if(g===c)return jd(e),a;if(g===d)return jd(e),b;g=g.sibling}A("188")}if(c.return!==d.return)c=e,d=f;else{g=!1;for(var h=e.child;h;){if(h===c){g=!0;c=e;d=f;break}if(h===d){g=!0;d=e;c=f;break}h=h.sibling}if(!g){for(h=f.child;h;){if(h===c){g=!0;c=f;d=e;break}if(h===d){g=!0;d=f;c=e;break}h=h.sibling}g?
void 0:A("189")}}c.alternate!==d?A("190"):void 0}3!==c.tag?A("188"):void 0;return c.stateNode.current===c?a:b}function ld(a){a=kd(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child)b.child.return=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}}return null}
function md(a){a=kd(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child&&4!==b.tag)b.child.return=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}}return null}var nd=H.extend({animationName:null,elapsedTime:null,pseudoElement:null}),od=H.extend({clipboardData:function(a){return"clipboardData"in a?a.clipboardData:window.clipboardData}}),pd=ad.extend({relatedTarget:null});
function qd(a){var b=a.keyCode;"charCode"in a?(a=a.charCode,0===a&&13===b&&(a=13)):a=b;10===a&&(a=13);return 32<=a||13===a?a:0}
var rd={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},sd={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",
116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"},td=ad.extend({key:function(a){if(a.key){var b=rd[a.key]||a.key;if("Unidentified"!==b)return b}return"keypress"===a.type?(a=qd(a),13===a?"Enter":String.fromCharCode(a)):"keydown"===a.type||"keyup"===a.type?sd[a.keyCode]||"Unidentified":""},location:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,repeat:null,locale:null,getModifierState:dd,charCode:function(a){return"keypress"===
a.type?qd(a):0},keyCode:function(a){return"keydown"===a.type||"keyup"===a.type?a.keyCode:0},which:function(a){return"keypress"===a.type?qd(a):"keydown"===a.type||"keyup"===a.type?a.keyCode:0}}),ud=ed.extend({dataTransfer:null}),vd=ad.extend({touches:null,targetTouches:null,changedTouches:null,altKey:null,metaKey:null,ctrlKey:null,shiftKey:null,getModifierState:dd}),wd=H.extend({propertyName:null,elapsedTime:null,pseudoElement:null}),xd=ed.extend({deltaX:function(a){return"deltaX"in a?a.deltaX:"wheelDeltaX"in
a?-a.wheelDeltaX:0},deltaY:function(a){return"deltaY"in a?a.deltaY:"wheelDeltaY"in a?-a.wheelDeltaY:"wheelDelta"in a?-a.wheelDelta:0},deltaZ:null,deltaMode:null}),yd=[["abort","abort"],[fb,"animationEnd"],[gb,"animationIteration"],[hb,"animationStart"],["canplay","canPlay"],["canplaythrough","canPlayThrough"],["drag","drag"],["dragenter","dragEnter"],["dragexit","dragExit"],["dragleave","dragLeave"],["dragover","dragOver"],["durationchange","durationChange"],["emptied","emptied"],["encrypted","encrypted"],
["ended","ended"],["error","error"],["gotpointercapture","gotPointerCapture"],["load","load"],["loadeddata","loadedData"],["loadedmetadata","loadedMetadata"],["loadstart","loadStart"],["lostpointercapture","lostPointerCapture"],["mousemove","mouseMove"],["mouseout","mouseOut"],["mouseover","mouseOver"],["playing","playing"],["pointermove","pointerMove"],["pointerout","pointerOut"],["pointerover","pointerOver"],["progress","progress"],["scroll","scroll"],["seeking","seeking"],["stalled","stalled"],
["suspend","suspend"],["timeupdate","timeUpdate"],["toggle","toggle"],["touchmove","touchMove"],[ib,"transitionEnd"],["waiting","waiting"],["wheel","wheel"]],zd={},Ad={};function Bd(a,b){var c=a[0];a=a[1];var d="on"+(a[0].toUpperCase()+a.slice(1));b={phasedRegistrationNames:{bubbled:d,captured:d+"Capture"},dependencies:[c],isInteractive:b};zd[a]=b;Ad[c]=b}
[["blur","blur"],["cancel","cancel"],["click","click"],["close","close"],["contextmenu","contextMenu"],["copy","copy"],["cut","cut"],["dblclick","doubleClick"],["dragend","dragEnd"],["dragstart","dragStart"],["drop","drop"],["focus","focus"],["input","input"],["invalid","invalid"],["keydown","keyDown"],["keypress","keyPress"],["keyup","keyUp"],["mousedown","mouseDown"],["mouseup","mouseUp"],["paste","paste"],["pause","pause"],["play","play"],["pointercancel","pointerCancel"],["pointerdown","pointerDown"],
["pointerup","pointerUp"],["ratechange","rateChange"],["reset","reset"],["seeked","seeked"],["submit","submit"],["touchcancel","touchCancel"],["touchend","touchEnd"],["touchstart","touchStart"],["volumechange","volumeChange"]].forEach(function(a){Bd(a,!0)});yd.forEach(function(a){Bd(a,!1)});
var Cd={eventTypes:zd,isInteractiveTopLevelEventType:function(a){a=Ad[a];return void 0!==a&&!0===a.isInteractive},extractEvents:function(a,b,c,d){var e=Ad[a];if(!e)return null;switch(a){case "keypress":if(0===qd(c))return null;case "keydown":case "keyup":a=td;break;case "blur":case "focus":a=pd;break;case "click":if(2===c.button)return null;case "dblclick":case "mousedown":case "mousemove":case "mouseup":case "mouseout":case "mouseover":case "contextmenu":a=ed;break;case "drag":case "dragend":case "dragenter":case "dragexit":case "dragleave":case "dragover":case "dragstart":case "drop":a=
ud;break;case "touchcancel":case "touchend":case "touchmove":case "touchstart":a=vd;break;case fb:case gb:case hb:a=nd;break;case ib:a=wd;break;case "scroll":a=ad;break;case "wheel":a=xd;break;case "copy":case "cut":case "paste":a=od;break;case "gotpointercapture":case "lostpointercapture":case "pointercancel":case "pointerdown":case "pointermove":case "pointerout":case "pointerover":case "pointerup":a=fd;break;default:a=H}b=a.getPooled(e,b,c,d);Ya(b);return b}},Dd=Cd.isInteractiveTopLevelEventType,
Ed=[];function Fd(a){var b=a.targetInst;do{if(!b){a.ancestors.push(b);break}var c;for(c=b;c.return;)c=c.return;c=3!==c.tag?null:c.stateNode.containerInfo;if(!c)break;a.ancestors.push(b);b=Na(c)}while(b);for(c=0;c<a.ancestors.length;c++)b=a.ancestors[c],Ja(a.topLevelType,b,a.nativeEvent,Zb(a.nativeEvent))}var Gd=!0;function Id(a){Gd=!!a}function L(a,b){if(!b)return null;var c=(Dd(a)?Jd:Kd).bind(null,a);b.addEventListener(a,c,!1)}
function Ld(a,b){if(!b)return null;var c=(Dd(a)?Jd:Kd).bind(null,a);b.addEventListener(a,c,!0)}function Jd(a,b){Tb(Kd,a,b)}function Kd(a,b){if(Gd){var c=Zb(b);c=Na(c);null===c||"number"!==typeof c.tag||2===id(c)||(c=null);if(Ed.length){var d=Ed.pop();d.topLevelType=a;d.nativeEvent=b;d.targetInst=c;a=d}else a={topLevelType:a,nativeEvent:b,targetInst:c,ancestors:[]};try{Wb(Fd,a)}finally{a.topLevelType=null,a.nativeEvent=null,a.targetInst=null,a.ancestors.length=0,10>Ed.length&&Ed.push(a)}}}
var Md={get _enabled(){return Gd},setEnabled:Id,isEnabled:function(){return Gd},trapBubbledEvent:L,trapCapturedEvent:Ld,dispatchEvent:Kd},Nd={},Od=0,Pd="_reactListenersID"+(""+Math.random()).slice(2);function Qd(a){Object.prototype.hasOwnProperty.call(a,Pd)||(a[Pd]=Od++,Nd[a[Pd]]={});return Nd[a[Pd]]}function Rd(a){for(;a&&a.firstChild;)a=a.firstChild;return a}
function Sd(a,b){var c=Rd(a);a=0;for(var d;c;){if(3===c.nodeType){d=a+c.textContent.length;if(a<=b&&d>=b)return{node:c,offset:b-a};a=d}a:{for(;c;){if(c.nextSibling){c=c.nextSibling;break a}c=c.parentNode}c=void 0}c=Rd(c)}}function Td(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return b&&("input"===b&&"text"===a.type||"textarea"===b||"true"===a.contentEditable)}
var Ud=m.canUseDOM&&"documentMode"in document&&11>=document.documentMode,Vd={select:{phasedRegistrationNames:{bubbled:"onSelect",captured:"onSelectCapture"},dependencies:"blur contextmenu focus keydown keyup mousedown mouseup selectionchange".split(" ")}},Wd=null,Xd=null,Yd=null,Zd=!1;
function $d(a,b){if(Zd||null==Wd||Wd!==da())return null;var c=Wd;"selectionStart"in c&&Td(c)?c={start:c.selectionStart,end:c.selectionEnd}:window.getSelection?(c=window.getSelection(),c={anchorNode:c.anchorNode,anchorOffset:c.anchorOffset,focusNode:c.focusNode,focusOffset:c.focusOffset}):c=void 0;return Yd&&ea(Yd,c)?null:(Yd=c,a=H.getPooled(Vd.select,Xd,a,b),a.type="select",a.target=Wd,Ya(a),a)}
var ae={eventTypes:Vd,extractEvents:function(a,b,c,d){var e=d.window===d?d.document:9===d.nodeType?d:d.ownerDocument,f;if(!(f=!e)){a:{e=Qd(e);f=sa.onSelect;for(var g=0;g<f.length;g++){var h=f[g];if(!e.hasOwnProperty(h)||!e[h]){e=!1;break a}}e=!0}f=!e}if(f)return null;e=b?Oa(b):window;switch(a){case "focus":if(Yb(e)||"true"===e.contentEditable)Wd=e,Xd=b,Yd=null;break;case "blur":Yd=Xd=Wd=null;break;case "mousedown":Zd=!0;break;case "contextmenu":case "mouseup":return Zd=!1,$d(c,d);case "selectionchange":if(Ud)break;
case "keydown":case "keyup":return $d(c,d)}return null}};Ga.injectEventPluginOrder("ResponderEventPlugin SimpleEventPlugin TapEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));wa=Qa.getFiberCurrentPropsFromNode;xa=Qa.getInstanceFromNode;ya=Qa.getNodeFromInstance;Ga.injectEventPluginsByName({SimpleEventPlugin:Cd,EnterLeaveEventPlugin:hd,ChangeEventPlugin:$c,SelectEventPlugin:ae,BeforeInputEventPlugin:Ib});var be=void 0;
be="object"===typeof performance&&"function"===typeof performance.now?function(){return performance.now()}:function(){return Date.now()};var ce=void 0,de=void 0;
if(m.canUseDOM){var ee=[],fe=0,ge={},he=-1,ie=!1,je=!1,ke=0,le=33,me=33,ne={didTimeout:!1,timeRemaining:function(){var a=ke-be();return 0<a?a:0}},oe=function(a,b){if(ge[b])try{a(ne)}finally{delete ge[b]}},pe="__reactIdleCallback$"+Math.random().toString(36).slice(2);window.addEventListener("message",function(a){if(a.source===window&&a.data===pe&&(ie=!1,0!==ee.length)){if(0!==ee.length&&(a=be(),!(-1===he||he>a))){he=-1;ne.didTimeout=!0;for(var b=0,c=ee.length;b<c;b++){var d=ee[b],e=d.timeoutTime;-1!==
e&&e<=a?oe(d.scheduledCallback,d.callbackId):-1!==e&&(-1===he||e<he)&&(he=e)}}for(a=be();0<ke-a&&0<ee.length;)a=ee.shift(),ne.didTimeout=!1,oe(a.scheduledCallback,a.callbackId),a=be();0<ee.length&&!je&&(je=!0,requestAnimationFrame(qe))}},!1);var qe=function(a){je=!1;var b=a-ke+me;b<me&&le<me?(8>b&&(b=8),me=b<le?le:b):le=b;ke=a+me;ie||(ie=!0,window.postMessage(pe,"*"))};ce=function(a,b){var c=-1;null!=b&&"number"===typeof b.timeout&&(c=be()+b.timeout);if(-1===he||-1!==c&&c<he)he=c;fe++;b=fe;ee.push({scheduledCallback:a,
callbackId:b,timeoutTime:c});ge[b]=!0;je||(je=!0,requestAnimationFrame(qe));return b};de=function(a){delete ge[a]}}else{var re=0,se={};ce=function(a){var b=re++,c=setTimeout(function(){a({timeRemaining:function(){return Infinity},didTimeout:!1})});se[b]=c;return b};de=function(a){var b=se[a];delete se[a];clearTimeout(b)}}function te(a){var b="";ca.Children.forEach(a,function(a){null==a||"string"!==typeof a&&"number"!==typeof a||(b+=a)});return b}
function ue(a,b){a=p({children:void 0},b);if(b=te(b.children))a.children=b;return a}function ve(a,b,c,d){a=a.options;if(b){b={};for(var e=0;e<c.length;e++)b["$"+c[e]]=!0;for(c=0;c<a.length;c++)e=b.hasOwnProperty("$"+a[c].value),a[c].selected!==e&&(a[c].selected=e),e&&d&&(a[c].defaultSelected=!0)}else{c=""+c;b=null;for(e=0;e<a.length;e++){if(a[e].value===c){a[e].selected=!0;d&&(a[e].defaultSelected=!0);return}null!==b||a[e].disabled||(b=a[e])}null!==b&&(b.selected=!0)}}
function we(a,b){var c=b.value;a._wrapperState={initialValue:null!=c?c:b.defaultValue,wasMultiple:!!b.multiple}}function xe(a,b){null!=b.dangerouslySetInnerHTML?A("91"):void 0;return p({},b,{value:void 0,defaultValue:void 0,children:""+a._wrapperState.initialValue})}function ye(a,b){var c=b.value;null==c&&(c=b.defaultValue,b=b.children,null!=b&&(null!=c?A("92"):void 0,Array.isArray(b)&&(1>=b.length?void 0:A("93"),b=b[0]),c=""+b),null==c&&(c=""));a._wrapperState={initialValue:""+c}}
function ze(a,b){var c=b.value;null!=c&&(c=""+c,c!==a.value&&(a.value=c),null==b.defaultValue&&(a.defaultValue=c));null!=b.defaultValue&&(a.defaultValue=b.defaultValue)}function Ae(a){var b=a.textContent;b===a._wrapperState.initialValue&&(a.value=b)}var Be={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
function Ce(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}function De(a,b){return null==a||"http://www.w3.org/1999/xhtml"===a?Ce(b):"http://www.w3.org/2000/svg"===a&&"foreignObject"===b?"http://www.w3.org/1999/xhtml":a}
var Ee=void 0,Fe=function(a){return"undefined"!==typeof MSApp&&MSApp.execUnsafeLocalFunction?function(b,c,d,e){MSApp.execUnsafeLocalFunction(function(){return a(b,c,d,e)})}:a}(function(a,b){if(a.namespaceURI!==Be.svg||"innerHTML"in a)a.innerHTML=b;else{Ee=Ee||document.createElement("div");Ee.innerHTML="<svg>"+b+"</svg>";for(b=Ee.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;b.firstChild;)a.appendChild(b.firstChild)}});
function Ge(a,b){if(b){var c=a.firstChild;if(c&&c===a.lastChild&&3===c.nodeType){c.nodeValue=b;return}}a.textContent=b}
var He={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,floodOpacity:!0,
stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},Ie=["Webkit","ms","Moz","O"];Object.keys(He).forEach(function(a){Ie.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);He[b]=He[a]})});
function Je(a,b){a=a.style;for(var c in b)if(b.hasOwnProperty(c)){var d=0===c.indexOf("--");var e=c;var f=b[c];e=null==f||"boolean"===typeof f||""===f?"":d||"number"!==typeof f||0===f||He.hasOwnProperty(e)&&He[e]?(""+f).trim():f+"px";"float"===c&&(c="cssFloat");d?a.setProperty(c,e):a[c]=e}}var Ke=p({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});
function Le(a,b,c){b&&(Ke[a]&&(null!=b.children||null!=b.dangerouslySetInnerHTML?A("137",a,c()):void 0),null!=b.dangerouslySetInnerHTML&&(null!=b.children?A("60"):void 0,"object"===typeof b.dangerouslySetInnerHTML&&"__html"in b.dangerouslySetInnerHTML?void 0:A("61")),null!=b.style&&"object"!==typeof b.style?A("62",c()):void 0)}
function Me(a,b){if(-1===a.indexOf("-"))return"string"===typeof b.is;switch(a){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return!1;default:return!0}}var Ne=v.thatReturns("");
function Oe(a,b){a=9===a.nodeType||11===a.nodeType?a:a.ownerDocument;var c=Qd(a);b=sa[b];for(var d=0;d<b.length;d++){var e=b[d];if(!c.hasOwnProperty(e)||!c[e]){switch(e){case "scroll":Ld("scroll",a);break;case "focus":case "blur":Ld("focus",a);Ld("blur",a);c.blur=!0;c.focus=!0;break;case "cancel":case "close":$b(e,!0)&&Ld(e,a);break;case "invalid":case "submit":case "reset":break;default:-1===jb.indexOf(e)&&L(e,a)}c[e]=!0}}}
function Pe(a,b,c,d){c=9===c.nodeType?c:c.ownerDocument;d===Be.html&&(d=Ce(a));d===Be.html?"script"===a?(a=c.createElement("div"),a.innerHTML="<script>\x3c/script>",a=a.removeChild(a.firstChild)):a="string"===typeof b.is?c.createElement(a,{is:b.is}):c.createElement(a):a=c.createElementNS(d,a);return a}function Qe(a,b){return(9===b.nodeType?b:b.ownerDocument).createTextNode(a)}
function Re(a,b,c,d){var e=Me(b,c);switch(b){case "iframe":case "object":L("load",a);var f=c;break;case "video":case "audio":for(f=0;f<jb.length;f++)L(jb[f],a);f=c;break;case "source":L("error",a);f=c;break;case "img":case "image":case "link":L("error",a);L("load",a);f=c;break;case "form":L("reset",a);L("submit",a);f=c;break;case "details":L("toggle",a);f=c;break;case "input":Gc(a,c);f=Fc(a,c);L("invalid",a);Oe(d,"onChange");break;case "option":f=ue(a,c);break;case "select":we(a,c);f=p({},c,{value:void 0});
L("invalid",a);Oe(d,"onChange");break;case "textarea":ye(a,c);f=xe(a,c);L("invalid",a);Oe(d,"onChange");break;default:f=c}Le(b,f,Ne);var g=f,h;for(h in g)if(g.hasOwnProperty(h)){var k=g[h];"style"===h?Je(a,k,Ne):"dangerouslySetInnerHTML"===h?(k=k?k.__html:void 0,null!=k&&Fe(a,k)):"children"===h?"string"===typeof k?("textarea"!==b||""!==k)&&Ge(a,k):"number"===typeof k&&Ge(a,""+k):"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&"autoFocus"!==h&&(ra.hasOwnProperty(h)?null!=k&&Oe(d,
h):null!=k&&Ec(a,h,k,e))}switch(b){case "input":cc(a);Lc(a,c);break;case "textarea":cc(a);Ae(a,c);break;case "option":null!=c.value&&a.setAttribute("value",c.value);break;case "select":a.multiple=!!c.multiple;b=c.value;null!=b?ve(a,!!c.multiple,b,!1):null!=c.defaultValue&&ve(a,!!c.multiple,c.defaultValue,!0);break;default:"function"===typeof f.onClick&&(a.onclick=v)}}
function Se(a,b,c,d,e){var f=null;switch(b){case "input":c=Fc(a,c);d=Fc(a,d);f=[];break;case "option":c=ue(a,c);d=ue(a,d);f=[];break;case "select":c=p({},c,{value:void 0});d=p({},d,{value:void 0});f=[];break;case "textarea":c=xe(a,c);d=xe(a,d);f=[];break;default:"function"!==typeof c.onClick&&"function"===typeof d.onClick&&(a.onclick=v)}Le(b,d,Ne);b=a=void 0;var g=null;for(a in c)if(!d.hasOwnProperty(a)&&c.hasOwnProperty(a)&&null!=c[a])if("style"===a){var h=c[a];for(b in h)h.hasOwnProperty(b)&&(g||
(g={}),g[b]="")}else"dangerouslySetInnerHTML"!==a&&"children"!==a&&"suppressContentEditableWarning"!==a&&"suppressHydrationWarning"!==a&&"autoFocus"!==a&&(ra.hasOwnProperty(a)?f||(f=[]):(f=f||[]).push(a,null));for(a in d){var k=d[a];h=null!=c?c[a]:void 0;if(d.hasOwnProperty(a)&&k!==h&&(null!=k||null!=h))if("style"===a)if(h){for(b in h)!h.hasOwnProperty(b)||k&&k.hasOwnProperty(b)||(g||(g={}),g[b]="");for(b in k)k.hasOwnProperty(b)&&h[b]!==k[b]&&(g||(g={}),g[b]=k[b])}else g||(f||(f=[]),f.push(a,g)),
g=k;else"dangerouslySetInnerHTML"===a?(k=k?k.__html:void 0,h=h?h.__html:void 0,null!=k&&h!==k&&(f=f||[]).push(a,""+k)):"children"===a?h===k||"string"!==typeof k&&"number"!==typeof k||(f=f||[]).push(a,""+k):"suppressContentEditableWarning"!==a&&"suppressHydrationWarning"!==a&&(ra.hasOwnProperty(a)?(null!=k&&Oe(e,a),f||h===k||(f=[])):(f=f||[]).push(a,k))}g&&(f=f||[]).push("style",g);return f}
function Te(a,b,c,d,e){"input"===c&&"radio"===e.type&&null!=e.name&&Ic(a,e);Me(c,d);d=Me(c,e);for(var f=0;f<b.length;f+=2){var g=b[f],h=b[f+1];"style"===g?Je(a,h,Ne):"dangerouslySetInnerHTML"===g?Fe(a,h):"children"===g?Ge(a,h):Ec(a,g,h,d)}switch(c){case "input":Jc(a,e);break;case "textarea":ze(a,e);break;case "select":a._wrapperState.initialValue=void 0,b=a._wrapperState.wasMultiple,a._wrapperState.wasMultiple=!!e.multiple,c=e.value,null!=c?ve(a,!!e.multiple,c,!1):b!==!!e.multiple&&(null!=e.defaultValue?
ve(a,!!e.multiple,e.defaultValue,!0):ve(a,!!e.multiple,e.multiple?[]:"",!1))}}
function Ue(a,b,c,d,e){switch(b){case "iframe":case "object":L("load",a);break;case "video":case "audio":for(d=0;d<jb.length;d++)L(jb[d],a);break;case "source":L("error",a);break;case "img":case "image":case "link":L("error",a);L("load",a);break;case "form":L("reset",a);L("submit",a);break;case "details":L("toggle",a);break;case "input":Gc(a,c);L("invalid",a);Oe(e,"onChange");break;case "select":we(a,c);L("invalid",a);Oe(e,"onChange");break;case "textarea":ye(a,c),L("invalid",a),Oe(e,"onChange")}Le(b,
c,Ne);d=null;for(var f in c)if(c.hasOwnProperty(f)){var g=c[f];"children"===f?"string"===typeof g?a.textContent!==g&&(d=["children",g]):"number"===typeof g&&a.textContent!==""+g&&(d=["children",""+g]):ra.hasOwnProperty(f)&&null!=g&&Oe(e,f)}switch(b){case "input":cc(a);Lc(a,c);break;case "textarea":cc(a);Ae(a,c);break;case "select":case "option":break;default:"function"===typeof c.onClick&&(a.onclick=v)}return d}function Ve(a,b){return a.nodeValue!==b}
var We={createElement:Pe,createTextNode:Qe,setInitialProperties:Re,diffProperties:Se,updateProperties:Te,diffHydratedProperties:Ue,diffHydratedText:Ve,warnForUnmatchedText:function(){},warnForDeletedHydratableElement:function(){},warnForDeletedHydratableText:function(){},warnForInsertedHydratedElement:function(){},warnForInsertedHydratedText:function(){},restoreControlledState:function(a,b,c){switch(b){case "input":Jc(a,c);b=c.name;if("radio"===c.type&&null!=b){for(c=a;c.parentNode;)c=c.parentNode;
c=c.querySelectorAll("input[name="+JSON.stringify(""+b)+'][type="radio"]');for(b=0;b<c.length;b++){var d=c[b];if(d!==a&&d.form===a.form){var e=Pa(d);e?void 0:A("90");dc(d);Jc(d,e)}}}break;case "textarea":ze(a,c);break;case "select":b=c.value,null!=b&&ve(a,!!c.multiple,b,!1)}}},Xe=null,Ye=null;function Ze(a,b){switch(a){case "button":case "input":case "select":case "textarea":return!!b.autoFocus}return!1}
function $e(a,b){return"textarea"===a||"string"===typeof b.children||"number"===typeof b.children||"object"===typeof b.dangerouslySetInnerHTML&&null!==b.dangerouslySetInnerHTML&&"string"===typeof b.dangerouslySetInnerHTML.__html}var af=be,bf=ce,cf=de;function df(a){for(a=a.nextSibling;a&&1!==a.nodeType&&3!==a.nodeType;)a=a.nextSibling;return a}function ef(a){for(a=a.firstChild;a&&1!==a.nodeType&&3!==a.nodeType;)a=a.nextSibling;return a}new Set;var ff=[],gf=-1;function hf(a){return{current:a}}
function M(a){0>gf||(a.current=ff[gf],ff[gf]=null,gf--)}function N(a,b){gf++;ff[gf]=a.current;a.current=b}var jf=hf(ha),O=hf(!1),kf=ha;function lf(a){return mf(a)?kf:jf.current}
function nf(a,b){var c=a.type.contextTypes;if(!c)return ha;var d=a.stateNode;if(d&&d.__reactInternalMemoizedUnmaskedChildContext===b)return d.__reactInternalMemoizedMaskedChildContext;var e={},f;for(f in c)e[f]=b[f];d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=b,a.__reactInternalMemoizedMaskedChildContext=e);return e}function mf(a){return 2===a.tag&&null!=a.type.childContextTypes}function of(a){mf(a)&&(M(O,a),M(jf,a))}function pf(a){M(O,a);M(jf,a)}
function qf(a,b,c){jf.current!==ha?A("168"):void 0;N(jf,b,a);N(O,c,a)}function rf(a,b){var c=a.stateNode,d=a.type.childContextTypes;if("function"!==typeof c.getChildContext)return b;c=c.getChildContext();for(var e in c)e in d?void 0:A("108",tc(a)||"Unknown",e);return p({},b,c)}function sf(a){if(!mf(a))return!1;var b=a.stateNode;b=b&&b.__reactInternalMemoizedMergedChildContext||ha;kf=jf.current;N(jf,b,a);N(O,O.current,a);return!0}
function tf(a,b){var c=a.stateNode;c?void 0:A("169");if(b){var d=rf(a,kf);c.__reactInternalMemoizedMergedChildContext=d;M(O,a);M(jf,a);N(jf,d,a)}else M(O,a);N(O,b,a)}
function uf(a,b,c,d){this.tag=a;this.key=c;this.sibling=this.child=this.return=this.stateNode=this.type=null;this.index=0;this.ref=null;this.pendingProps=b;this.memoizedState=this.updateQueue=this.memoizedProps=null;this.mode=d;this.effectTag=0;this.lastEffect=this.firstEffect=this.nextEffect=null;this.expirationTime=0;this.alternate=null}
function vf(a,b,c){var d=a.alternate;null===d?(d=new uf(a.tag,b,a.key,a.mode),d.type=a.type,d.stateNode=a.stateNode,d.alternate=a,a.alternate=d):(d.pendingProps=b,d.effectTag=0,d.nextEffect=null,d.firstEffect=null,d.lastEffect=null);d.expirationTime=c;d.child=a.child;d.memoizedProps=a.memoizedProps;d.memoizedState=a.memoizedState;d.updateQueue=a.updateQueue;d.sibling=a.sibling;d.index=a.index;d.ref=a.ref;return d}
function wf(a,b,c){var d=a.type,e=a.key;a=a.props;if("function"===typeof d)var f=d.prototype&&d.prototype.isReactComponent?2:0;else if("string"===typeof d)f=5;else switch(d){case hc:return xf(a.children,b,c,e);case oc:f=11;b|=3;break;case ic:f=11;b|=2;break;case jc:return d=new uf(15,a,e,b|4),d.type=jc,d.expirationTime=c,d;case qc:f=16;b|=2;break;default:a:{switch("object"===typeof d&&null!==d?d.$$typeof:null){case mc:f=13;break a;case nc:f=12;break a;case pc:f=14;break a;default:A("130",null==d?
d:typeof d,"")}f=void 0}}b=new uf(f,a,e,b);b.type=d;b.expirationTime=c;return b}function xf(a,b,c,d){a=new uf(10,a,d,b);a.expirationTime=c;return a}function yf(a,b,c){a=new uf(6,a,null,b);a.expirationTime=c;return a}function zf(a,b,c){b=new uf(4,null!==a.children?a.children:[],a.key,b);b.expirationTime=c;b.stateNode={containerInfo:a.containerInfo,pendingChildren:null,implementation:a.implementation};return b}
function Af(a,b,c){b=new uf(3,null,null,b?3:0);a={current:b,containerInfo:a,pendingChildren:null,earliestPendingTime:0,latestPendingTime:0,earliestSuspendedTime:0,latestSuspendedTime:0,latestPingedTime:0,pendingCommitExpirationTime:0,finishedWork:null,context:null,pendingContext:null,hydrate:c,remainingExpirationTime:0,firstBatch:null,nextScheduledRoot:null};return b.stateNode=a}var Bf=null,Cf=null;function Df(a){return function(b){try{return a(b)}catch(c){}}}
function Ef(a){if("undefined"===typeof __REACT_DEVTOOLS_GLOBAL_HOOK__)return!1;var b=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(b.isDisabled||!b.supportsFiber)return!0;try{var c=b.inject(a);Bf=Df(function(a){return b.onCommitFiberRoot(c,a)});Cf=Df(function(a){return b.onCommitFiberUnmount(c,a)})}catch(d){}return!0}function Ff(a){"function"===typeof Bf&&Bf(a)}function Gf(a){"function"===typeof Cf&&Cf(a)}var Hf=!1;
function If(a){return{expirationTime:0,baseState:a,firstUpdate:null,lastUpdate:null,firstCapturedUpdate:null,lastCapturedUpdate:null,firstEffect:null,lastEffect:null,firstCapturedEffect:null,lastCapturedEffect:null}}function Jf(a){return{expirationTime:a.expirationTime,baseState:a.baseState,firstUpdate:a.firstUpdate,lastUpdate:a.lastUpdate,firstCapturedUpdate:null,lastCapturedUpdate:null,firstEffect:null,lastEffect:null,firstCapturedEffect:null,lastCapturedEffect:null}}
function Kf(a){return{expirationTime:a,tag:0,payload:null,callback:null,next:null,nextEffect:null}}function Lf(a,b,c){null===a.lastUpdate?a.firstUpdate=a.lastUpdate=b:(a.lastUpdate.next=b,a.lastUpdate=b);if(0===a.expirationTime||a.expirationTime>c)a.expirationTime=c}
function Mf(a,b,c){var d=a.alternate;if(null===d){var e=a.updateQueue;var f=null;null===e&&(e=a.updateQueue=If(a.memoizedState))}else e=a.updateQueue,f=d.updateQueue,null===e?null===f?(e=a.updateQueue=If(a.memoizedState),f=d.updateQueue=If(d.memoizedState)):e=a.updateQueue=Jf(f):null===f&&(f=d.updateQueue=Jf(e));null===f||e===f?Lf(e,b,c):null===e.lastUpdate||null===f.lastUpdate?(Lf(e,b,c),Lf(f,b,c)):(Lf(e,b,c),f.lastUpdate=b)}
function Nf(a,b,c){var d=a.updateQueue;d=null===d?a.updateQueue=If(a.memoizedState):Of(a,d);null===d.lastCapturedUpdate?d.firstCapturedUpdate=d.lastCapturedUpdate=b:(d.lastCapturedUpdate.next=b,d.lastCapturedUpdate=b);if(0===d.expirationTime||d.expirationTime>c)d.expirationTime=c}function Of(a,b){var c=a.alternate;null!==c&&b===c.updateQueue&&(b=a.updateQueue=Jf(b));return b}
function Pf(a,b,c,d,e,f){switch(c.tag){case 1:return a=c.payload,"function"===typeof a?a.call(f,d,e):a;case 3:a.effectTag=a.effectTag&-1025|64;case 0:a=c.payload;e="function"===typeof a?a.call(f,d,e):a;if(null===e||void 0===e)break;return p({},d,e);case 2:Hf=!0}return d}
function Qf(a,b,c,d,e){Hf=!1;if(!(0===b.expirationTime||b.expirationTime>e)){b=Of(a,b);for(var f=b.baseState,g=null,h=0,k=b.firstUpdate,n=f;null!==k;){var r=k.expirationTime;if(r>e){if(null===g&&(g=k,f=n),0===h||h>r)h=r}else n=Pf(a,b,k,n,c,d),null!==k.callback&&(a.effectTag|=32,k.nextEffect=null,null===b.lastEffect?b.firstEffect=b.lastEffect=k:(b.lastEffect.nextEffect=k,b.lastEffect=k));k=k.next}r=null;for(k=b.firstCapturedUpdate;null!==k;){var w=k.expirationTime;if(w>e){if(null===r&&(r=k,null===
g&&(f=n)),0===h||h>w)h=w}else n=Pf(a,b,k,n,c,d),null!==k.callback&&(a.effectTag|=32,k.nextEffect=null,null===b.lastCapturedEffect?b.firstCapturedEffect=b.lastCapturedEffect=k:(b.lastCapturedEffect.nextEffect=k,b.lastCapturedEffect=k));k=k.next}null===g&&(b.lastUpdate=null);null===r?b.lastCapturedUpdate=null:a.effectTag|=32;null===g&&null===r&&(f=n);b.baseState=f;b.firstUpdate=g;b.firstCapturedUpdate=r;b.expirationTime=h;a.memoizedState=n}}
function Rf(a,b){"function"!==typeof a?A("191",a):void 0;a.call(b)}
function Sf(a,b,c){null!==b.firstCapturedUpdate&&(null!==b.lastUpdate&&(b.lastUpdate.next=b.firstCapturedUpdate,b.lastUpdate=b.lastCapturedUpdate),b.firstCapturedUpdate=b.lastCapturedUpdate=null);a=b.firstEffect;for(b.firstEffect=b.lastEffect=null;null!==a;){var d=a.callback;null!==d&&(a.callback=null,Rf(d,c));a=a.nextEffect}a=b.firstCapturedEffect;for(b.firstCapturedEffect=b.lastCapturedEffect=null;null!==a;)b=a.callback,null!==b&&(a.callback=null,Rf(b,c)),a=a.nextEffect}
function Tf(a,b){return{value:a,source:b,stack:vc(b)}}var Uf=hf(null),Vf=hf(null),Wf=hf(0);function Xf(a){var b=a.type._context;N(Wf,b._changedBits,a);N(Vf,b._currentValue,a);N(Uf,a,a);b._currentValue=a.pendingProps.value;b._changedBits=a.stateNode}function Yf(a){var b=Wf.current,c=Vf.current;M(Uf,a);M(Vf,a);M(Wf,a);a=a.type._context;a._currentValue=c;a._changedBits=b}var Zf={},$f=hf(Zf),ag=hf(Zf),bg=hf(Zf);function cg(a){a===Zf?A("174"):void 0;return a}
function dg(a,b){N(bg,b,a);N(ag,a,a);N($f,Zf,a);var c=b.nodeType;switch(c){case 9:case 11:b=(b=b.documentElement)?b.namespaceURI:De(null,"");break;default:c=8===c?b.parentNode:b,b=c.namespaceURI||null,c=c.tagName,b=De(b,c)}M($f,a);N($f,b,a)}function eg(a){M($f,a);M(ag,a);M(bg,a)}function fg(a){ag.current===a&&(M($f,a),M(ag,a))}function hg(a,b,c){var d=a.memoizedState;b=b(c,d);d=null===b||void 0===b?d:p({},d,b);a.memoizedState=d;a=a.updateQueue;null!==a&&0===a.expirationTime&&(a.baseState=d)}
var lg={isMounted:function(a){return(a=a._reactInternalFiber)?2===id(a):!1},enqueueSetState:function(a,b,c){a=a._reactInternalFiber;var d=ig();d=jg(d,a);var e=Kf(d);e.payload=b;void 0!==c&&null!==c&&(e.callback=c);Mf(a,e,d);kg(a,d)},enqueueReplaceState:function(a,b,c){a=a._reactInternalFiber;var d=ig();d=jg(d,a);var e=Kf(d);e.tag=1;e.payload=b;void 0!==c&&null!==c&&(e.callback=c);Mf(a,e,d);kg(a,d)},enqueueForceUpdate:function(a,b){a=a._reactInternalFiber;var c=ig();c=jg(c,a);var d=Kf(c);d.tag=2;void 0!==
b&&null!==b&&(d.callback=b);Mf(a,d,c);kg(a,c)}};function mg(a,b,c,d,e,f){var g=a.stateNode;a=a.type;return"function"===typeof g.shouldComponentUpdate?g.shouldComponentUpdate(c,e,f):a.prototype&&a.prototype.isPureReactComponent?!ea(b,c)||!ea(d,e):!0}
function ng(a,b,c,d){a=b.state;"function"===typeof b.componentWillReceiveProps&&b.componentWillReceiveProps(c,d);"function"===typeof b.UNSAFE_componentWillReceiveProps&&b.UNSAFE_componentWillReceiveProps(c,d);b.state!==a&&lg.enqueueReplaceState(b,b.state,null)}
function og(a,b){var c=a.type,d=a.stateNode,e=a.pendingProps,f=lf(a);d.props=e;d.state=a.memoizedState;d.refs=ha;d.context=nf(a,f);f=a.updateQueue;null!==f&&(Qf(a,f,e,d,b),d.state=a.memoizedState);f=a.type.getDerivedStateFromProps;"function"===typeof f&&(hg(a,f,e),d.state=a.memoizedState);"function"===typeof c.getDerivedStateFromProps||"function"===typeof d.getSnapshotBeforeUpdate||"function"!==typeof d.UNSAFE_componentWillMount&&"function"!==typeof d.componentWillMount||(c=d.state,"function"===typeof d.componentWillMount&&
d.componentWillMount(),"function"===typeof d.UNSAFE_componentWillMount&&d.UNSAFE_componentWillMount(),c!==d.state&&lg.enqueueReplaceState(d,d.state,null),f=a.updateQueue,null!==f&&(Qf(a,f,e,d,b),d.state=a.memoizedState));"function"===typeof d.componentDidMount&&(a.effectTag|=4)}var pg=Array.isArray;
function qg(a,b,c){a=c.ref;if(null!==a&&"function"!==typeof a&&"object"!==typeof a){if(c._owner){c=c._owner;var d=void 0;c&&(2!==c.tag?A("110"):void 0,d=c.stateNode);d?void 0:A("147",a);var e=""+a;if(null!==b&&null!==b.ref&&"function"===typeof b.ref&&b.ref._stringRef===e)return b.ref;b=function(a){var b=d.refs===ha?d.refs={}:d.refs;null===a?delete b[e]:b[e]=a};b._stringRef=e;return b}"string"!==typeof a?A("148"):void 0;c._owner?void 0:A("254",a)}return a}
function rg(a,b){"textarea"!==a.type&&A("31","[object Object]"===Object.prototype.toString.call(b)?"object with keys {"+Object.keys(b).join(", ")+"}":b,"")}
function sg(a){function b(b,c){if(a){var d=b.lastEffect;null!==d?(d.nextEffect=c,b.lastEffect=c):b.firstEffect=b.lastEffect=c;c.nextEffect=null;c.effectTag=8}}function c(c,d){if(!a)return null;for(;null!==d;)b(c,d),d=d.sibling;return null}function d(a,b){for(a=new Map;null!==b;)null!==b.key?a.set(b.key,b):a.set(b.index,b),b=b.sibling;return a}function e(a,b,c){a=vf(a,b,c);a.index=0;a.sibling=null;return a}function f(b,c,d){b.index=d;if(!a)return c;d=b.alternate;if(null!==d)return d=d.index,d<c?(b.effectTag=
2,c):d;b.effectTag=2;return c}function g(b){a&&null===b.alternate&&(b.effectTag=2);return b}function h(a,b,c,d){if(null===b||6!==b.tag)return b=yf(c,a.mode,d),b.return=a,b;b=e(b,c,d);b.return=a;return b}function k(a,b,c,d){if(null!==b&&b.type===c.type)return d=e(b,c.props,d),d.ref=qg(a,b,c),d.return=a,d;d=wf(c,a.mode,d);d.ref=qg(a,b,c);d.return=a;return d}function n(a,b,c,d){if(null===b||4!==b.tag||b.stateNode.containerInfo!==c.containerInfo||b.stateNode.implementation!==c.implementation)return b=
zf(c,a.mode,d),b.return=a,b;b=e(b,c.children||[],d);b.return=a;return b}function r(a,b,c,d,f){if(null===b||10!==b.tag)return b=xf(c,a.mode,d,f),b.return=a,b;b=e(b,c,d);b.return=a;return b}function w(a,b,c){if("string"===typeof b||"number"===typeof b)return b=yf(""+b,a.mode,c),b.return=a,b;if("object"===typeof b&&null!==b){switch(b.$$typeof){case fc:return c=wf(b,a.mode,c),c.ref=qg(a,null,b),c.return=a,c;case gc:return b=zf(b,a.mode,c),b.return=a,b}if(pg(b)||sc(b))return b=xf(b,a.mode,c,null),b.return=
a,b;rg(a,b)}return null}function P(a,b,c,d){var e=null!==b?b.key:null;if("string"===typeof c||"number"===typeof c)return null!==e?null:h(a,b,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case fc:return c.key===e?c.type===hc?r(a,b,c.props.children,d,e):k(a,b,c,d):null;case gc:return c.key===e?n(a,b,c,d):null}if(pg(c)||sc(c))return null!==e?null:r(a,b,c,d,null);rg(a,c)}return null}function kc(a,b,c,d,e){if("string"===typeof d||"number"===typeof d)return a=a.get(c)||null,h(b,a,""+d,e);
if("object"===typeof d&&null!==d){switch(d.$$typeof){case fc:return a=a.get(null===d.key?c:d.key)||null,d.type===hc?r(b,a,d.props.children,e,d.key):k(b,a,d,e);case gc:return a=a.get(null===d.key?c:d.key)||null,n(b,a,d,e)}if(pg(d)||sc(d))return a=a.get(c)||null,r(b,a,d,e,null);rg(b,d)}return null}function Hd(e,g,h,k){for(var u=null,x=null,t=g,q=g=0,n=null;null!==t&&q<h.length;q++){t.index>q?(n=t,t=null):n=t.sibling;var l=P(e,t,h[q],k);if(null===l){null===t&&(t=n);break}a&&t&&null===l.alternate&&b(e,
t);g=f(l,g,q);null===x?u=l:x.sibling=l;x=l;t=n}if(q===h.length)return c(e,t),u;if(null===t){for(;q<h.length;q++)if(t=w(e,h[q],k))g=f(t,g,q),null===x?u=t:x.sibling=t,x=t;return u}for(t=d(e,t);q<h.length;q++)if(n=kc(t,e,q,h[q],k))a&&null!==n.alternate&&t.delete(null===n.key?q:n.key),g=f(n,g,q),null===x?u=n:x.sibling=n,x=n;a&&t.forEach(function(a){return b(e,a)});return u}function E(e,g,h,k){var t=sc(h);"function"!==typeof t?A("150"):void 0;h=t.call(h);null==h?A("151"):void 0;for(var u=t=null,n=g,x=
g=0,y=null,l=h.next();null!==n&&!l.done;x++,l=h.next()){n.index>x?(y=n,n=null):y=n.sibling;var r=P(e,n,l.value,k);if(null===r){n||(n=y);break}a&&n&&null===r.alternate&&b(e,n);g=f(r,g,x);null===u?t=r:u.sibling=r;u=r;n=y}if(l.done)return c(e,n),t;if(null===n){for(;!l.done;x++,l=h.next())l=w(e,l.value,k),null!==l&&(g=f(l,g,x),null===u?t=l:u.sibling=l,u=l);return t}for(n=d(e,n);!l.done;x++,l=h.next())l=kc(n,e,x,l.value,k),null!==l&&(a&&null!==l.alternate&&n.delete(null===l.key?x:l.key),g=f(l,g,x),null===
u?t=l:u.sibling=l,u=l);a&&n.forEach(function(a){return b(e,a)});return t}return function(a,d,f,h){"object"===typeof f&&null!==f&&f.type===hc&&null===f.key&&(f=f.props.children);var k="object"===typeof f&&null!==f;if(k)switch(f.$$typeof){case fc:a:{var n=f.key;for(k=d;null!==k;){if(k.key===n)if(10===k.tag?f.type===hc:k.type===f.type){c(a,k.sibling);d=e(k,f.type===hc?f.props.children:f.props,h);d.ref=qg(a,k,f);d.return=a;a=d;break a}else{c(a,k);break}else b(a,k);k=k.sibling}f.type===hc?(d=xf(f.props.children,
a.mode,h,f.key),d.return=a,a=d):(h=wf(f,a.mode,h),h.ref=qg(a,d,f),h.return=a,a=h)}return g(a);case gc:a:{for(k=f.key;null!==d;){if(d.key===k)if(4===d.tag&&d.stateNode.containerInfo===f.containerInfo&&d.stateNode.implementation===f.implementation){c(a,d.sibling);d=e(d,f.children||[],h);d.return=a;a=d;break a}else{c(a,d);break}else b(a,d);d=d.sibling}d=zf(f,a.mode,h);d.return=a;a=d}return g(a)}if("string"===typeof f||"number"===typeof f)return f=""+f,null!==d&&6===d.tag?(c(a,d.sibling),d=e(d,f,h),d.return=
a,a=d):(c(a,d),d=yf(f,a.mode,h),d.return=a,a=d),g(a);if(pg(f))return Hd(a,d,f,h);if(sc(f))return E(a,d,f,h);k&&rg(a,f);if("undefined"===typeof f)switch(a.tag){case 2:case 1:h=a.type,A("152",h.displayName||h.name||"Component")}return c(a,d)}}var tg=sg(!0),ug=sg(!1),vg=null,wg=null,xg=!1;function yg(a,b){var c=new uf(5,null,null,0);c.type="DELETED";c.stateNode=b;c.return=a;c.effectTag=8;null!==a.lastEffect?(a.lastEffect.nextEffect=c,a.lastEffect=c):a.firstEffect=a.lastEffect=c}
function zg(a,b){switch(a.tag){case 5:var c=a.type;b=1!==b.nodeType||c.toLowerCase()!==b.nodeName.toLowerCase()?null:b;return null!==b?(a.stateNode=b,!0):!1;case 6:return b=""===a.pendingProps||3!==b.nodeType?null:b,null!==b?(a.stateNode=b,!0):!1;default:return!1}}function Ag(a){if(xg){var b=wg;if(b){var c=b;if(!zg(a,b)){b=df(c);if(!b||!zg(a,b)){a.effectTag|=2;xg=!1;vg=a;return}yg(vg,c)}vg=a;wg=ef(b)}else a.effectTag|=2,xg=!1,vg=a}}
function Bg(a){for(a=a.return;null!==a&&5!==a.tag&&3!==a.tag;)a=a.return;vg=a}function Cg(a){if(a!==vg)return!1;if(!xg)return Bg(a),xg=!0,!1;var b=a.type;if(5!==a.tag||"head"!==b&&"body"!==b&&!$e(b,a.memoizedProps))for(b=wg;b;)yg(a,b),b=df(b);Bg(a);wg=vg?df(a.stateNode):null;return!0}function Dg(){wg=vg=null;xg=!1}function Q(a,b,c){Eg(a,b,c,b.expirationTime)}function Eg(a,b,c,d){b.child=null===a?ug(b,null,c,d):tg(b,a.child,c,d)}
function Fg(a,b){var c=b.ref;if(null===a&&null!==c||null!==a&&a.ref!==c)b.effectTag|=128}function Gg(a,b,c,d,e){Fg(a,b);var f=0!==(b.effectTag&64);if(!c&&!f)return d&&tf(b,!1),R(a,b);c=b.stateNode;ec.current=b;var g=f?null:c.render();b.effectTag|=1;f&&(Eg(a,b,null,e),b.child=null);Eg(a,b,g,e);b.memoizedState=c.state;b.memoizedProps=c.props;d&&tf(b,!0);return b.child}
function Hg(a){var b=a.stateNode;b.pendingContext?qf(a,b.pendingContext,b.pendingContext!==b.context):b.context&&qf(a,b.context,!1);dg(a,b.containerInfo)}
function Ig(a,b,c,d){var e=a.child;null!==e&&(e.return=a);for(;null!==e;){switch(e.tag){case 12:var f=e.stateNode|0;if(e.type===b&&0!==(f&c)){for(f=e;null!==f;){var g=f.alternate;if(0===f.expirationTime||f.expirationTime>d)f.expirationTime=d,null!==g&&(0===g.expirationTime||g.expirationTime>d)&&(g.expirationTime=d);else if(null!==g&&(0===g.expirationTime||g.expirationTime>d))g.expirationTime=d;else break;f=f.return}f=null}else f=e.child;break;case 13:f=e.type===a.type?null:e.child;break;default:f=
e.child}if(null!==f)f.return=e;else for(f=e;null!==f;){if(f===a){f=null;break}e=f.sibling;if(null!==e){e.return=f.return;f=e;break}f=f.return}e=f}}
function Jg(a,b,c){var d=b.type._context,e=b.pendingProps,f=b.memoizedProps,g=!0;if(O.current)g=!1;else if(f===e)return b.stateNode=0,Xf(b),R(a,b);var h=e.value;b.memoizedProps=e;if(null===f)h=1073741823;else if(f.value===e.value){if(f.children===e.children&&g)return b.stateNode=0,Xf(b),R(a,b);h=0}else{var k=f.value;if(k===h&&(0!==k||1/k===1/h)||k!==k&&h!==h){if(f.children===e.children&&g)return b.stateNode=0,Xf(b),R(a,b);h=0}else if(h="function"===typeof d._calculateChangedBits?d._calculateChangedBits(k,
h):1073741823,h|=0,0===h){if(f.children===e.children&&g)return b.stateNode=0,Xf(b),R(a,b)}else Ig(b,d,h,c)}b.stateNode=h;Xf(b);Q(a,b,e.children);return b.child}function R(a,b){null!==a&&b.child!==a.child?A("153"):void 0;if(null!==b.child){a=b.child;var c=vf(a,a.pendingProps,a.expirationTime);b.child=c;for(c.return=b;null!==a.sibling;)a=a.sibling,c=c.sibling=vf(a,a.pendingProps,a.expirationTime),c.return=b;c.sibling=null}return b.child}
function Kg(a,b,c){if(0===b.expirationTime||b.expirationTime>c){switch(b.tag){case 3:Hg(b);break;case 2:sf(b);break;case 4:dg(b,b.stateNode.containerInfo);break;case 13:Xf(b)}return null}switch(b.tag){case 0:null!==a?A("155"):void 0;var d=b.type,e=b.pendingProps,f=lf(b);f=nf(b,f);d=d(e,f);b.effectTag|=1;"object"===typeof d&&null!==d&&"function"===typeof d.render&&void 0===d.$$typeof?(f=b.type,b.tag=2,b.memoizedState=null!==d.state&&void 0!==d.state?d.state:null,f=f.getDerivedStateFromProps,"function"===
typeof f&&hg(b,f,e),e=sf(b),d.updater=lg,b.stateNode=d,d._reactInternalFiber=b,og(b,c),a=Gg(a,b,!0,e,c)):(b.tag=1,Q(a,b,d),b.memoizedProps=e,a=b.child);return a;case 1:return e=b.type,c=b.pendingProps,O.current||b.memoizedProps!==c?(d=lf(b),d=nf(b,d),e=e(c,d),b.effectTag|=1,Q(a,b,e),b.memoizedProps=c,a=b.child):a=R(a,b),a;case 2:e=sf(b);if(null===a)if(null===b.stateNode){var g=b.pendingProps,h=b.type;d=lf(b);var k=2===b.tag&&null!=b.type.contextTypes;f=k?nf(b,d):ha;g=new h(g,f);b.memoizedState=null!==
g.state&&void 0!==g.state?g.state:null;g.updater=lg;b.stateNode=g;g._reactInternalFiber=b;k&&(k=b.stateNode,k.__reactInternalMemoizedUnmaskedChildContext=d,k.__reactInternalMemoizedMaskedChildContext=f);og(b,c);d=!0}else{h=b.type;d=b.stateNode;k=b.memoizedProps;f=b.pendingProps;d.props=k;var n=d.context;g=lf(b);g=nf(b,g);var r=h.getDerivedStateFromProps;(h="function"===typeof r||"function"===typeof d.getSnapshotBeforeUpdate)||"function"!==typeof d.UNSAFE_componentWillReceiveProps&&"function"!==typeof d.componentWillReceiveProps||
(k!==f||n!==g)&&ng(b,d,f,g);Hf=!1;var w=b.memoizedState;n=d.state=w;var P=b.updateQueue;null!==P&&(Qf(b,P,f,d,c),n=b.memoizedState);k!==f||w!==n||O.current||Hf?("function"===typeof r&&(hg(b,r,f),n=b.memoizedState),(k=Hf||mg(b,k,f,w,n,g))?(h||"function"!==typeof d.UNSAFE_componentWillMount&&"function"!==typeof d.componentWillMount||("function"===typeof d.componentWillMount&&d.componentWillMount(),"function"===typeof d.UNSAFE_componentWillMount&&d.UNSAFE_componentWillMount()),"function"===typeof d.componentDidMount&&
(b.effectTag|=4)):("function"===typeof d.componentDidMount&&(b.effectTag|=4),b.memoizedProps=f,b.memoizedState=n),d.props=f,d.state=n,d.context=g,d=k):("function"===typeof d.componentDidMount&&(b.effectTag|=4),d=!1)}else h=b.type,d=b.stateNode,f=b.memoizedProps,k=b.pendingProps,d.props=f,n=d.context,g=lf(b),g=nf(b,g),r=h.getDerivedStateFromProps,(h="function"===typeof r||"function"===typeof d.getSnapshotBeforeUpdate)||"function"!==typeof d.UNSAFE_componentWillReceiveProps&&"function"!==typeof d.componentWillReceiveProps||
(f!==k||n!==g)&&ng(b,d,k,g),Hf=!1,n=b.memoizedState,w=d.state=n,P=b.updateQueue,null!==P&&(Qf(b,P,k,d,c),w=b.memoizedState),f!==k||n!==w||O.current||Hf?("function"===typeof r&&(hg(b,r,k),w=b.memoizedState),(r=Hf||mg(b,f,k,n,w,g))?(h||"function"!==typeof d.UNSAFE_componentWillUpdate&&"function"!==typeof d.componentWillUpdate||("function"===typeof d.componentWillUpdate&&d.componentWillUpdate(k,w,g),"function"===typeof d.UNSAFE_componentWillUpdate&&d.UNSAFE_componentWillUpdate(k,w,g)),"function"===typeof d.componentDidUpdate&&
(b.effectTag|=4),"function"===typeof d.getSnapshotBeforeUpdate&&(b.effectTag|=256)):("function"!==typeof d.componentDidUpdate||f===a.memoizedProps&&n===a.memoizedState||(b.effectTag|=4),"function"!==typeof d.getSnapshotBeforeUpdate||f===a.memoizedProps&&n===a.memoizedState||(b.effectTag|=256),b.memoizedProps=k,b.memoizedState=w),d.props=k,d.state=w,d.context=g,d=r):("function"!==typeof d.componentDidUpdate||f===a.memoizedProps&&n===a.memoizedState||(b.effectTag|=4),"function"!==typeof d.getSnapshotBeforeUpdate||
f===a.memoizedProps&&n===a.memoizedState||(b.effectTag|=256),d=!1);return Gg(a,b,d,e,c);case 3:Hg(b);e=b.updateQueue;if(null!==e)if(d=b.memoizedState,d=null!==d?d.element:null,Qf(b,e,b.pendingProps,null,c),e=b.memoizedState.element,e===d)Dg(),a=R(a,b);else{d=b.stateNode;if(d=(null===a||null===a.child)&&d.hydrate)wg=ef(b.stateNode.containerInfo),vg=b,d=xg=!0;d?(b.effectTag|=2,b.child=ug(b,null,e,c)):(Dg(),Q(a,b,e));a=b.child}else Dg(),a=R(a,b);return a;case 5:a:{cg(bg.current);e=cg($f.current);d=De(e,
b.type);e!==d&&(N(ag,b,b),N($f,d,b));null===a&&Ag(b);e=b.type;k=b.memoizedProps;d=b.pendingProps;f=null!==a?a.memoizedProps:null;if(!O.current&&k===d){if(k=b.mode&1&&!!d.hidden)b.expirationTime=1073741823;if(!k||1073741823!==c){a=R(a,b);break a}}k=d.children;$e(e,d)?k=null:f&&$e(e,f)&&(b.effectTag|=16);Fg(a,b);1073741823!==c&&b.mode&1&&d.hidden?(b.expirationTime=1073741823,b.memoizedProps=d,a=null):(Q(a,b,k),b.memoizedProps=d,a=b.child)}return a;case 6:return null===a&&Ag(b),b.memoizedProps=b.pendingProps,
null;case 16:return null;case 4:return dg(b,b.stateNode.containerInfo),e=b.pendingProps,O.current||b.memoizedProps!==e?(null===a?b.child=tg(b,null,e,c):Q(a,b,e),b.memoizedProps=e,a=b.child):a=R(a,b),a;case 14:return e=b.type.render,c=b.pendingProps,d=b.ref,O.current||b.memoizedProps!==c||d!==(null!==a?a.ref:null)?(e=e(c,d),Q(a,b,e),b.memoizedProps=c,a=b.child):a=R(a,b),a;case 10:return c=b.pendingProps,O.current||b.memoizedProps!==c?(Q(a,b,c),b.memoizedProps=c,a=b.child):a=R(a,b),a;case 11:return c=
b.pendingProps.children,O.current||null!==c&&b.memoizedProps!==c?(Q(a,b,c),b.memoizedProps=c,a=b.child):a=R(a,b),a;case 15:return c=b.pendingProps,b.memoizedProps===c?a=R(a,b):(Q(a,b,c.children),b.memoizedProps=c,a=b.child),a;case 13:return Jg(a,b,c);case 12:a:if(d=b.type,f=b.pendingProps,k=b.memoizedProps,e=d._currentValue,g=d._changedBits,O.current||0!==g||k!==f){b.memoizedProps=f;h=f.unstable_observedBits;if(void 0===h||null===h)h=1073741823;b.stateNode=h;if(0!==(g&h))Ig(b,d,g,c);else if(k===f){a=
R(a,b);break a}c=f.children;c=c(e);b.effectTag|=1;Q(a,b,c);a=b.child}else a=R(a,b);return a;default:A("156")}}function Lg(a){a.effectTag|=4}var Pg=void 0,Qg=void 0,Rg=void 0;Pg=function(){};Qg=function(a,b,c){(b.updateQueue=c)&&Lg(b)};Rg=function(a,b,c,d){c!==d&&Lg(b)};
function Sg(a,b){var c=b.pendingProps;switch(b.tag){case 1:return null;case 2:return of(b),null;case 3:eg(b);pf(b);var d=b.stateNode;d.pendingContext&&(d.context=d.pendingContext,d.pendingContext=null);if(null===a||null===a.child)Cg(b),b.effectTag&=-3;Pg(b);return null;case 5:fg(b);d=cg(bg.current);var e=b.type;if(null!==a&&null!=b.stateNode){var f=a.memoizedProps,g=b.stateNode,h=cg($f.current);g=Se(g,e,f,c,d);Qg(a,b,g,e,f,c,d,h);a.ref!==b.ref&&(b.effectTag|=128)}else{if(!c)return null===b.stateNode?
A("166"):void 0,null;a=cg($f.current);if(Cg(b))c=b.stateNode,e=b.type,f=b.memoizedProps,c[C]=b,c[Ma]=f,d=Ue(c,e,f,a,d),b.updateQueue=d,null!==d&&Lg(b);else{a=Pe(e,c,d,a);a[C]=b;a[Ma]=c;a:for(f=b.child;null!==f;){if(5===f.tag||6===f.tag)a.appendChild(f.stateNode);else if(4!==f.tag&&null!==f.child){f.child.return=f;f=f.child;continue}if(f===b)break;for(;null===f.sibling;){if(null===f.return||f.return===b)break a;f=f.return}f.sibling.return=f.return;f=f.sibling}Re(a,e,c,d);Ze(e,c)&&Lg(b);b.stateNode=
a}null!==b.ref&&(b.effectTag|=128)}return null;case 6:if(a&&null!=b.stateNode)Rg(a,b,a.memoizedProps,c);else{if("string"!==typeof c)return null===b.stateNode?A("166"):void 0,null;d=cg(bg.current);cg($f.current);Cg(b)?(d=b.stateNode,c=b.memoizedProps,d[C]=b,Ve(d,c)&&Lg(b)):(d=Qe(c,d),d[C]=b,b.stateNode=d)}return null;case 14:return null;case 16:return null;case 10:return null;case 11:return null;case 15:return null;case 4:return eg(b),Pg(b),null;case 13:return Yf(b),null;case 12:return null;case 0:A("167");
default:A("156")}}function Tg(a,b){var c=b.source;null===b.stack&&null!==c&&vc(c);null!==c&&tc(c);b=b.value;null!==a&&2===a.tag&&tc(a);try{b&&b.suppressReactErrorLogging||console.error(b)}catch(d){d&&d.suppressReactErrorLogging||console.error(d)}}function Ug(a){var b=a.ref;if(null!==b)if("function"===typeof b)try{b(null)}catch(c){Vg(a,c)}else b.current=null}
function Wg(a){"function"===typeof Gf&&Gf(a);switch(a.tag){case 2:Ug(a);var b=a.stateNode;if("function"===typeof b.componentWillUnmount)try{b.props=a.memoizedProps,b.state=a.memoizedState,b.componentWillUnmount()}catch(c){Vg(a,c)}break;case 5:Ug(a);break;case 4:Xg(a)}}function Yg(a){return 5===a.tag||3===a.tag||4===a.tag}
function Zg(a){a:{for(var b=a.return;null!==b;){if(Yg(b)){var c=b;break a}b=b.return}A("160");c=void 0}var d=b=void 0;switch(c.tag){case 5:b=c.stateNode;d=!1;break;case 3:b=c.stateNode.containerInfo;d=!0;break;case 4:b=c.stateNode.containerInfo;d=!0;break;default:A("161")}c.effectTag&16&&(Ge(b,""),c.effectTag&=-17);a:b:for(c=a;;){for(;null===c.sibling;){if(null===c.return||Yg(c.return)){c=null;break a}c=c.return}c.sibling.return=c.return;for(c=c.sibling;5!==c.tag&&6!==c.tag;){if(c.effectTag&2)continue b;
if(null===c.child||4===c.tag)continue b;else c.child.return=c,c=c.child}if(!(c.effectTag&2)){c=c.stateNode;break a}}for(var e=a;;){if(5===e.tag||6===e.tag)if(c)if(d){var f=b,g=e.stateNode,h=c;8===f.nodeType?f.parentNode.insertBefore(g,h):f.insertBefore(g,h)}else b.insertBefore(e.stateNode,c);else d?(f=b,g=e.stateNode,8===f.nodeType?f.parentNode.insertBefore(g,f):f.appendChild(g)):b.appendChild(e.stateNode);else if(4!==e.tag&&null!==e.child){e.child.return=e;e=e.child;continue}if(e===a)break;for(;null===
e.sibling;){if(null===e.return||e.return===a)return;e=e.return}e.sibling.return=e.return;e=e.sibling}}
function Xg(a){for(var b=a,c=!1,d=void 0,e=void 0;;){if(!c){c=b.return;a:for(;;){null===c?A("160"):void 0;switch(c.tag){case 5:d=c.stateNode;e=!1;break a;case 3:d=c.stateNode.containerInfo;e=!0;break a;case 4:d=c.stateNode.containerInfo;e=!0;break a}c=c.return}c=!0}if(5===b.tag||6===b.tag){a:for(var f=b,g=f;;)if(Wg(g),null!==g.child&&4!==g.tag)g.child.return=g,g=g.child;else{if(g===f)break;for(;null===g.sibling;){if(null===g.return||g.return===f)break a;g=g.return}g.sibling.return=g.return;g=g.sibling}e?
(f=d,g=b.stateNode,8===f.nodeType?f.parentNode.removeChild(g):f.removeChild(g)):d.removeChild(b.stateNode)}else if(4===b.tag?d=b.stateNode.containerInfo:Wg(b),null!==b.child){b.child.return=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b.return||b.return===a)return;b=b.return;4===b.tag&&(c=!1)}b.sibling.return=b.return;b=b.sibling}}
function $g(a,b){switch(b.tag){case 2:break;case 5:var c=b.stateNode;if(null!=c){var d=b.memoizedProps;a=null!==a?a.memoizedProps:d;var e=b.type,f=b.updateQueue;b.updateQueue=null;null!==f&&(c[Ma]=d,Te(c,f,e,a,d))}break;case 6:null===b.stateNode?A("162"):void 0;b.stateNode.nodeValue=b.memoizedProps;break;case 3:break;case 15:break;case 16:break;default:A("163")}}function ah(a,b,c){c=Kf(c);c.tag=3;c.payload={element:null};var d=b.value;c.callback=function(){bh(d);Tg(a,b)};return c}
function ch(a,b,c){c=Kf(c);c.tag=3;var d=a.stateNode;null!==d&&"function"===typeof d.componentDidCatch&&(c.callback=function(){null===dh?dh=new Set([this]):dh.add(this);var c=b.value,d=b.stack;Tg(a,b);this.componentDidCatch(c,{componentStack:null!==d?d:""})});return c}
function eh(a,b,c,d,e,f){c.effectTag|=512;c.firstEffect=c.lastEffect=null;d=Tf(d,c);a=b;do{switch(a.tag){case 3:a.effectTag|=1024;d=ah(a,d,f);Nf(a,d,f);return;case 2:if(b=d,c=a.stateNode,0===(a.effectTag&64)&&null!==c&&"function"===typeof c.componentDidCatch&&(null===dh||!dh.has(c))){a.effectTag|=1024;d=ch(a,b,f);Nf(a,d,f);return}}a=a.return}while(null!==a)}
function fh(a){switch(a.tag){case 2:of(a);var b=a.effectTag;return b&1024?(a.effectTag=b&-1025|64,a):null;case 3:return eg(a),pf(a),b=a.effectTag,b&1024?(a.effectTag=b&-1025|64,a):null;case 5:return fg(a),null;case 16:return b=a.effectTag,b&1024?(a.effectTag=b&-1025|64,a):null;case 4:return eg(a),null;case 13:return Yf(a),null;default:return null}}var gh=af(),hh=2,ih=gh,jh=0,kh=0,lh=!1,S=null,mh=null,T=0,nh=-1,oh=!1,U=null,ph=!1,qh=!1,dh=null;
function rh(){if(null!==S)for(var a=S.return;null!==a;){var b=a;switch(b.tag){case 2:of(b);break;case 3:eg(b);pf(b);break;case 5:fg(b);break;case 4:eg(b);break;case 13:Yf(b)}a=a.return}mh=null;T=0;nh=-1;oh=!1;S=null;qh=!1}
function sh(a){for(;;){var b=a.alternate,c=a.return,d=a.sibling;if(0===(a.effectTag&512)){b=Sg(b,a,T);var e=a;if(1073741823===T||1073741823!==e.expirationTime){var f=0;switch(e.tag){case 3:case 2:var g=e.updateQueue;null!==g&&(f=g.expirationTime)}for(g=e.child;null!==g;)0!==g.expirationTime&&(0===f||f>g.expirationTime)&&(f=g.expirationTime),g=g.sibling;e.expirationTime=f}if(null!==b)return b;null!==c&&0===(c.effectTag&512)&&(null===c.firstEffect&&(c.firstEffect=a.firstEffect),null!==a.lastEffect&&
(null!==c.lastEffect&&(c.lastEffect.nextEffect=a.firstEffect),c.lastEffect=a.lastEffect),1<a.effectTag&&(null!==c.lastEffect?c.lastEffect.nextEffect=a:c.firstEffect=a,c.lastEffect=a));if(null!==d)return d;if(null!==c)a=c;else{qh=!0;break}}else{a=fh(a,oh,T);if(null!==a)return a.effectTag&=511,a;null!==c&&(c.firstEffect=c.lastEffect=null,c.effectTag|=512);if(null!==d)return d;if(null!==c)a=c;else break}}return null}
function th(a){var b=Kg(a.alternate,a,T);null===b&&(b=sh(a));ec.current=null;return b}
function uh(a,b,c){lh?A("243"):void 0;lh=!0;if(b!==T||a!==mh||null===S)rh(),mh=a,T=b,nh=-1,S=vf(mh.current,null,T),a.pendingCommitExpirationTime=0;var d=!1;oh=!c||T<=hh;do{try{if(c)for(;null!==S&&!vh();)S=th(S);else for(;null!==S;)S=th(S)}catch(f){if(null===S)d=!0,bh(f);else{null===S?A("271"):void 0;c=S;var e=c.return;if(null===e){d=!0;bh(f);break}eh(a,e,c,f,oh,T,ih);S=sh(c)}}break}while(1);lh=!1;if(d)return null;if(null===S){if(qh)return a.pendingCommitExpirationTime=b,a.current.alternate;oh?A("262"):
void 0;0<=nh&&setTimeout(function(){var b=a.current.expirationTime;0!==b&&(0===a.remainingExpirationTime||a.remainingExpirationTime<b)&&wh(a,b)},nh);xh(a.current.expirationTime)}return null}
function Vg(a,b){var c;a:{lh&&!ph?A("263"):void 0;for(c=a.return;null!==c;){switch(c.tag){case 2:var d=c.stateNode;if("function"===typeof c.type.getDerivedStateFromCatch||"function"===typeof d.componentDidCatch&&(null===dh||!dh.has(d))){a=Tf(b,a);a=ch(c,a,1);Mf(c,a,1);kg(c,1);c=void 0;break a}break;case 3:a=Tf(b,a);a=ah(c,a,1);Mf(c,a,1);kg(c,1);c=void 0;break a}c=c.return}3===a.tag&&(c=Tf(b,a),c=ah(a,c,1),Mf(a,c,1),kg(a,1));c=void 0}return c}
function yh(){var a=2+25*(((ig()-2+500)/25|0)+1);a<=jh&&(a=jh+1);return jh=a}function jg(a,b){a=0!==kh?kh:lh?ph?1:T:b.mode&1?zh?2+10*(((a-2+15)/10|0)+1):2+25*(((a-2+500)/25|0)+1):1;zh&&(0===Ah||a>Ah)&&(Ah=a);return a}
function kg(a,b){for(;null!==a;){if(0===a.expirationTime||a.expirationTime>b)a.expirationTime=b;null!==a.alternate&&(0===a.alternate.expirationTime||a.alternate.expirationTime>b)&&(a.alternate.expirationTime=b);if(null===a.return)if(3===a.tag){var c=a.stateNode;!lh&&0!==T&&b<T&&rh();var d=c.current.expirationTime;lh&&!ph&&mh===c||wh(c,d);Bh>Ch&&A("185")}else break;a=a.return}}function ig(){ih=af()-gh;return hh=(ih/10|0)+2}
function Dh(a){var b=kh;kh=2+25*(((ig()-2+500)/25|0)+1);try{return a()}finally{kh=b}}function Eh(a,b,c,d,e){var f=kh;kh=1;try{return a(b,c,d,e)}finally{kh=f}}var Fh=null,V=null,Gh=0,Hh=-1,W=!1,X=null,Y=0,Ah=0,Ih=!1,Jh=!1,Kh=null,Lh=null,Z=!1,Mh=!1,zh=!1,Nh=null,Ch=1E3,Bh=0,Oh=1;function Ph(a){if(0!==Gh){if(a>Gh)return;cf(Hh)}var b=af()-gh;Gh=a;Hh=bf(Qh,{timeout:10*(a-2)-b})}
function wh(a,b){if(null===a.nextScheduledRoot)a.remainingExpirationTime=b,null===V?(Fh=V=a,a.nextScheduledRoot=a):(V=V.nextScheduledRoot=a,V.nextScheduledRoot=Fh);else{var c=a.remainingExpirationTime;if(0===c||b<c)a.remainingExpirationTime=b}W||(Z?Mh&&(X=a,Y=1,Rh(a,1,!1)):1===b?Sh():Ph(b))}
function Th(){var a=0,b=null;if(null!==V)for(var c=V,d=Fh;null!==d;){var e=d.remainingExpirationTime;if(0===e){null===c||null===V?A("244"):void 0;if(d===d.nextScheduledRoot){Fh=V=d.nextScheduledRoot=null;break}else if(d===Fh)Fh=e=d.nextScheduledRoot,V.nextScheduledRoot=e,d.nextScheduledRoot=null;else if(d===V){V=c;V.nextScheduledRoot=Fh;d.nextScheduledRoot=null;break}else c.nextScheduledRoot=d.nextScheduledRoot,d.nextScheduledRoot=null;d=c.nextScheduledRoot}else{if(0===a||e<a)a=e,b=d;if(d===V)break;
c=d;d=d.nextScheduledRoot}}c=X;null!==c&&c===b&&1===a?Bh++:Bh=0;X=b;Y=a}function Qh(a){Uh(0,!0,a)}function Sh(){Uh(1,!1,null)}function Uh(a,b,c){Lh=c;Th();if(b)for(;null!==X&&0!==Y&&(0===a||a>=Y)&&(!Ih||ig()>=Y);)ig(),Rh(X,Y,!Ih),Th();else for(;null!==X&&0!==Y&&(0===a||a>=Y);)Rh(X,Y,!1),Th();null!==Lh&&(Gh=0,Hh=-1);0!==Y&&Ph(Y);Lh=null;Ih=!1;Vh()}function Wh(a,b){W?A("253"):void 0;X=a;Y=b;Rh(a,b,!1);Sh();Vh()}
function Vh(){Bh=0;if(null!==Nh){var a=Nh;Nh=null;for(var b=0;b<a.length;b++){var c=a[b];try{c._onComplete()}catch(d){Jh||(Jh=!0,Kh=d)}}}if(Jh)throw a=Kh,Kh=null,Jh=!1,a;}function Rh(a,b,c){W?A("245"):void 0;W=!0;c?(c=a.finishedWork,null!==c?Xh(a,c,b):(a.finishedWork=null,c=uh(a,b,!0),null!==c&&(vh()?a.finishedWork=c:Xh(a,c,b)))):(c=a.finishedWork,null!==c?Xh(a,c,b):(a.finishedWork=null,c=uh(a,b,!1),null!==c&&Xh(a,c,b)));W=!1}
function Xh(a,b,c){var d=a.firstBatch;if(null!==d&&d._expirationTime<=c&&(null===Nh?Nh=[d]:Nh.push(d),d._defer)){a.finishedWork=b;a.remainingExpirationTime=0;return}a.finishedWork=null;ph=lh=!0;c=b.stateNode;c.current===b?A("177"):void 0;d=c.pendingCommitExpirationTime;0===d?A("261"):void 0;c.pendingCommitExpirationTime=0;ig();ec.current=null;if(1<b.effectTag)if(null!==b.lastEffect){b.lastEffect.nextEffect=b;var e=b.firstEffect}else e=b;else e=b.firstEffect;Xe=Gd;var f=da();if(Td(f)){if("selectionStart"in
f)var g={start:f.selectionStart,end:f.selectionEnd};else a:{var h=window.getSelection&&window.getSelection();if(h&&0!==h.rangeCount){g=h.anchorNode;var k=h.anchorOffset,n=h.focusNode;h=h.focusOffset;try{g.nodeType,n.nodeType}catch(Wa){g=null;break a}var r=0,w=-1,P=-1,kc=0,Hd=0,E=f,t=null;b:for(;;){for(var x;;){E!==g||0!==k&&3!==E.nodeType||(w=r+k);E!==n||0!==h&&3!==E.nodeType||(P=r+h);3===E.nodeType&&(r+=E.nodeValue.length);if(null===(x=E.firstChild))break;t=E;E=x}for(;;){if(E===f)break b;t===g&&
++kc===k&&(w=r);t===n&&++Hd===h&&(P=r);if(null!==(x=E.nextSibling))break;E=t;t=E.parentNode}E=x}g=-1===w||-1===P?null:{start:w,end:P}}else g=null}g=g||{start:0,end:0}}else g=null;Ye={focusedElem:f,selectionRange:g};Id(!1);for(U=e;null!==U;){f=!1;g=void 0;try{for(;null!==U;){if(U.effectTag&256){var u=U.alternate;k=U;switch(k.tag){case 2:if(k.effectTag&256&&null!==u){var y=u.memoizedProps,D=u.memoizedState,ja=k.stateNode;ja.props=k.memoizedProps;ja.state=k.memoizedState;var hi=ja.getSnapshotBeforeUpdate(y,
D);ja.__reactInternalSnapshotBeforeUpdate=hi}break;case 3:case 5:case 6:case 4:break;default:A("163")}}U=U.nextEffect}}catch(Wa){f=!0,g=Wa}f&&(null===U?A("178"):void 0,Vg(U,g),null!==U&&(U=U.nextEffect))}for(U=e;null!==U;){u=!1;y=void 0;try{for(;null!==U;){var q=U.effectTag;q&16&&Ge(U.stateNode,"");if(q&128){var z=U.alternate;if(null!==z){var l=z.ref;null!==l&&("function"===typeof l?l(null):l.current=null)}}switch(q&14){case 2:Zg(U);U.effectTag&=-3;break;case 6:Zg(U);U.effectTag&=-3;$g(U.alternate,
U);break;case 4:$g(U.alternate,U);break;case 8:D=U,Xg(D),D.return=null,D.child=null,D.alternate&&(D.alternate.child=null,D.alternate.return=null)}U=U.nextEffect}}catch(Wa){u=!0,y=Wa}u&&(null===U?A("178"):void 0,Vg(U,y),null!==U&&(U=U.nextEffect))}l=Ye;z=da();q=l.focusedElem;u=l.selectionRange;if(z!==q&&fa(document.documentElement,q)){Td(q)&&(z=u.start,l=u.end,void 0===l&&(l=z),"selectionStart"in q?(q.selectionStart=z,q.selectionEnd=Math.min(l,q.value.length)):window.getSelection&&(z=window.getSelection(),
y=q[lb()].length,l=Math.min(u.start,y),u=void 0===u.end?l:Math.min(u.end,y),!z.extend&&l>u&&(y=u,u=l,l=y),y=Sd(q,l),D=Sd(q,u),y&&D&&(1!==z.rangeCount||z.anchorNode!==y.node||z.anchorOffset!==y.offset||z.focusNode!==D.node||z.focusOffset!==D.offset)&&(ja=document.createRange(),ja.setStart(y.node,y.offset),z.removeAllRanges(),l>u?(z.addRange(ja),z.extend(D.node,D.offset)):(ja.setEnd(D.node,D.offset),z.addRange(ja)))));z=[];for(l=q;l=l.parentNode;)1===l.nodeType&&z.push({element:l,left:l.scrollLeft,
top:l.scrollTop});q.focus();for(q=0;q<z.length;q++)l=z[q],l.element.scrollLeft=l.left,l.element.scrollTop=l.top}Ye=null;Id(Xe);Xe=null;c.current=b;for(U=e;null!==U;){e=!1;q=void 0;try{for(z=d;null!==U;){var gg=U.effectTag;if(gg&36){var lc=U.alternate;l=U;u=z;switch(l.tag){case 2:var ba=l.stateNode;if(l.effectTag&4)if(null===lc)ba.props=l.memoizedProps,ba.state=l.memoizedState,ba.componentDidMount();else{var ri=lc.memoizedProps,si=lc.memoizedState;ba.props=l.memoizedProps;ba.state=l.memoizedState;
ba.componentDidUpdate(ri,si,ba.__reactInternalSnapshotBeforeUpdate)}var Mg=l.updateQueue;null!==Mg&&(ba.props=l.memoizedProps,ba.state=l.memoizedState,Sf(l,Mg,ba,u));break;case 3:var Ng=l.updateQueue;if(null!==Ng){y=null;if(null!==l.child)switch(l.child.tag){case 5:y=l.child.stateNode;break;case 2:y=l.child.stateNode}Sf(l,Ng,y,u)}break;case 5:var ti=l.stateNode;null===lc&&l.effectTag&4&&Ze(l.type,l.memoizedProps)&&ti.focus();break;case 6:break;case 4:break;case 15:break;case 16:break;default:A("163")}}if(gg&
128){l=void 0;var uc=U.ref;if(null!==uc){var Og=U.stateNode;switch(U.tag){case 5:l=Og;break;default:l=Og}"function"===typeof uc?uc(l):uc.current=l}}var ui=U.nextEffect;U.nextEffect=null;U=ui}}catch(Wa){e=!0,q=Wa}e&&(null===U?A("178"):void 0,Vg(U,q),null!==U&&(U=U.nextEffect))}lh=ph=!1;"function"===typeof Ff&&Ff(b.stateNode);b=c.current.expirationTime;0===b&&(dh=null);a.remainingExpirationTime=b}function vh(){return null===Lh||Lh.timeRemaining()>Oh?!1:Ih=!0}
function bh(a){null===X?A("246"):void 0;X.remainingExpirationTime=0;Jh||(Jh=!0,Kh=a)}function xh(a){null===X?A("246"):void 0;X.remainingExpirationTime=a}function Yh(a,b){var c=Z;Z=!0;try{return a(b)}finally{(Z=c)||W||Sh()}}function Zh(a,b){if(Z&&!Mh){Mh=!0;try{return a(b)}finally{Mh=!1}}return a(b)}function $h(a,b){W?A("187"):void 0;var c=Z;Z=!0;try{return Eh(a,b)}finally{Z=c,Sh()}}function ai(a){var b=Z;Z=!0;try{Eh(a)}finally{(Z=b)||W||Uh(1,!1,null)}}
function bi(a,b,c,d,e){var f=b.current;if(c){c=c._reactInternalFiber;var g;b:{2===id(c)&&2===c.tag?void 0:A("170");for(g=c;3!==g.tag;){if(mf(g)){g=g.stateNode.__reactInternalMemoizedMergedChildContext;break b}(g=g.return)?void 0:A("171")}g=g.stateNode.context}c=mf(c)?rf(c,g):g}else c=ha;null===b.context?b.context=c:b.pendingContext=c;b=e;e=Kf(d);e.payload={element:a};b=void 0===b?null:b;null!==b&&(e.callback=b);Mf(f,e,d);kg(f,d);return d}
function ci(a){var b=a._reactInternalFiber;void 0===b&&("function"===typeof a.render?A("188"):A("268",Object.keys(a)));a=ld(b);return null===a?null:a.stateNode}function di(a,b,c,d){var e=b.current,f=ig();e=jg(f,e);return bi(a,b,c,e,d)}function ei(a){a=a.current;if(!a.child)return null;switch(a.child.tag){case 5:return a.child.stateNode;default:return a.child.stateNode}}
function fi(a){var b=a.findFiberByHostInstance;return Ef(p({},a,{findHostInstanceByFiber:function(a){a=ld(a);return null===a?null:a.stateNode},findFiberByHostInstance:function(a){return b?b(a):null}}))}
var gi={updateContainerAtExpirationTime:bi,createContainer:function(a,b,c){return Af(a,b,c)},updateContainer:di,flushRoot:Wh,requestWork:wh,computeUniqueAsyncExpiration:yh,batchedUpdates:Yh,unbatchedUpdates:Zh,deferredUpdates:Dh,syncUpdates:Eh,interactiveUpdates:function(a,b,c){if(zh)return a(b,c);Z||W||0===Ah||(Uh(Ah,!1,null),Ah=0);var d=zh,e=Z;Z=zh=!0;try{return a(b,c)}finally{zh=d,(Z=e)||W||Sh()}},flushInteractiveUpdates:function(){W||0===Ah||(Uh(Ah,!1,null),Ah=0)},flushControlled:ai,flushSync:$h,
getPublicRootInstance:ei,findHostInstance:ci,findHostInstanceWithNoPortals:function(a){a=md(a);return null===a?null:a.stateNode},injectIntoDevTools:fi};function ii(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:gc,key:null==d?null:""+d,children:a,containerInfo:b,implementation:c}}Kb.injectFiberControlledHostComponent(We);
function ji(a){this._expirationTime=yh();this._root=a;this._callbacks=this._next=null;this._hasChildren=this._didComplete=!1;this._children=null;this._defer=!0}ji.prototype.render=function(a){this._defer?void 0:A("250");this._hasChildren=!0;this._children=a;var b=this._root._internalRoot,c=this._expirationTime,d=new ki;bi(a,b,null,c,d._onCommit);return d};ji.prototype.then=function(a){if(this._didComplete)a();else{var b=this._callbacks;null===b&&(b=this._callbacks=[]);b.push(a)}};
ji.prototype.commit=function(){var a=this._root._internalRoot,b=a.firstBatch;this._defer&&null!==b?void 0:A("251");if(this._hasChildren){var c=this._expirationTime;if(b!==this){this._hasChildren&&(c=this._expirationTime=b._expirationTime,this.render(this._children));for(var d=null,e=b;e!==this;)d=e,e=e._next;null===d?A("251"):void 0;d._next=e._next;this._next=b;a.firstBatch=this}this._defer=!1;Wh(a,c);b=this._next;this._next=null;b=a.firstBatch=b;null!==b&&b._hasChildren&&b.render(b._children)}else this._next=
null,this._defer=!1};ji.prototype._onComplete=function(){if(!this._didComplete){this._didComplete=!0;var a=this._callbacks;if(null!==a)for(var b=0;b<a.length;b++)(0,a[b])()}};function ki(){this._callbacks=null;this._didCommit=!1;this._onCommit=this._onCommit.bind(this)}ki.prototype.then=function(a){if(this._didCommit)a();else{var b=this._callbacks;null===b&&(b=this._callbacks=[]);b.push(a)}};
ki.prototype._onCommit=function(){if(!this._didCommit){this._didCommit=!0;var a=this._callbacks;if(null!==a)for(var b=0;b<a.length;b++){var c=a[b];"function"!==typeof c?A("191",c):void 0;c()}}};function li(a,b,c){this._internalRoot=Af(a,b,c)}li.prototype.render=function(a,b){var c=this._internalRoot,d=new ki;b=void 0===b?null:b;null!==b&&d.then(b);di(a,c,null,d._onCommit);return d};
li.prototype.unmount=function(a){var b=this._internalRoot,c=new ki;a=void 0===a?null:a;null!==a&&c.then(a);di(null,b,null,c._onCommit);return c};li.prototype.legacy_renderSubtreeIntoContainer=function(a,b,c){var d=this._internalRoot,e=new ki;c=void 0===c?null:c;null!==c&&e.then(c);di(b,d,a,e._onCommit);return e};
li.prototype.createBatch=function(){var a=new ji(this),b=a._expirationTime,c=this._internalRoot,d=c.firstBatch;if(null===d)c.firstBatch=a,a._next=null;else{for(c=null;null!==d&&d._expirationTime<=b;)c=d,d=d._next;a._next=d;null!==c&&(c._next=a)}return a};function mi(a){return!(!a||1!==a.nodeType&&9!==a.nodeType&&11!==a.nodeType&&(8!==a.nodeType||" react-mount-point-unstable "!==a.nodeValue))}Sb=gi.batchedUpdates;Tb=gi.interactiveUpdates;Ub=gi.flushInteractiveUpdates;
function ni(a,b){b||(b=a?9===a.nodeType?a.documentElement:a.firstChild:null,b=!(!b||1!==b.nodeType||!b.hasAttribute("data-reactroot")));if(!b)for(var c;c=a.lastChild;)a.removeChild(c);return new li(a,!1,b)}
function oi(a,b,c,d,e){mi(c)?void 0:A("200");var f=c._reactRootContainer;if(f){if("function"===typeof e){var g=e;e=function(){var a=ei(f._internalRoot);g.call(a)}}null!=a?f.legacy_renderSubtreeIntoContainer(a,b,e):f.render(b,e)}else{f=c._reactRootContainer=ni(c,d);if("function"===typeof e){var h=e;e=function(){var a=ei(f._internalRoot);h.call(a)}}Zh(function(){null!=a?f.legacy_renderSubtreeIntoContainer(a,b,e):f.render(b,e)})}return ei(f._internalRoot)}
function pi(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;mi(b)?void 0:A("200");return ii(a,b,null,c)}
var qi={createPortal:pi,findDOMNode:function(a){return null==a?null:1===a.nodeType?a:ci(a)},hydrate:function(a,b,c){return oi(null,a,b,!0,c)},render:function(a,b,c){return oi(null,a,b,!1,c)},unstable_renderSubtreeIntoContainer:function(a,b,c,d){null==a||void 0===a._reactInternalFiber?A("38"):void 0;return oi(a,b,c,!1,d)},unmountComponentAtNode:function(a){mi(a)?void 0:A("40");return a._reactRootContainer?(Zh(function(){oi(null,null,a,!1,function(){a._reactRootContainer=null})}),!0):!1},unstable_createPortal:function(){return pi.apply(void 0,
arguments)},unstable_batchedUpdates:Yh,unstable_deferredUpdates:Dh,flushSync:$h,unstable_flushControlled:ai,__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{EventPluginHub:Ka,EventPluginRegistry:va,EventPropagators:$a,ReactControlledComponent:Rb,ReactDOMComponentTree:Qa,ReactDOMEventListener:Md},unstable_createRoot:function(a,b){return new li(a,!0,null!=b&&!0===b.hydrate)}};fi({findFiberByHostInstance:Na,bundleType:0,version:"16.4.0",rendererPackageName:"react-dom"});
var vi={default:qi},wi=vi&&qi||vi;module.exports=wi.default?wi.default:wi;


/***/ }),
/* 763 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/**
 * Simple, lightweight module assisting with the detection and context of
 * Worker. Helps avoid circular dependencies and allows code to reason about
 * whether or not they are in a Worker, even if they never include the main
 * `ReactWorker` dependency.
 */
var ExecutionEnvironment = {

  canUseDOM: canUseDOM,

  canUseWorkers: typeof Worker !== 'undefined',

  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),

  canUseViewport: canUseDOM && !!window.screen,

  isInWorker: !canUseDOM // For now, this is true - might change in the future.

};

module.exports = ExecutionEnvironment;

/***/ }),
/* 764 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/* eslint-disable fb-www/typeof-undefined */

/**
 * Same as document.activeElement but wraps in a try-catch block. In IE it is
 * not safe to call document.activeElement if there is nothing focused.
 *
 * The activeElement will be null only if the document or document body is not
 * yet defined.
 *
 * @param {?DOMDocument} doc Defaults to current document.
 * @return {?DOMElement}
 */
function getActiveElement(doc) /*?DOMElement*/{
  doc = doc || (typeof document !== 'undefined' ? document : undefined);
  if (typeof doc === 'undefined') {
    return null;
  }
  try {
    return doc.activeElement || doc.body;
  } catch (e) {
    return doc.body;
  }
}

module.exports = getActiveElement;

/***/ }),
/* 765 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

var isTextNode = __webpack_require__(766);

/*eslint-disable no-bitwise */

/**
 * Checks if a given DOM node contains or is another DOM node.
 */
function containsNode(outerNode, innerNode) {
  if (!outerNode || !innerNode) {
    return false;
  } else if (outerNode === innerNode) {
    return true;
  } else if (isTextNode(outerNode)) {
    return false;
  } else if (isTextNode(innerNode)) {
    return containsNode(outerNode, innerNode.parentNode);
  } else if ('contains' in outerNode) {
    return outerNode.contains(innerNode);
  } else if (outerNode.compareDocumentPosition) {
    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
  } else {
    return false;
  }
}

module.exports = containsNode;

/***/ }),
/* 766 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var isNode = __webpack_require__(767);

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM text node.
 */
function isTextNode(object) {
  return isNode(object) && object.nodeType == 3;
}

module.exports = isTextNode;

/***/ }),
/* 767 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM node.
 */
function isNode(object) {
  var doc = object ? object.ownerDocument || object : document;
  var defaultView = doc.defaultView || window;
  return !!(object && (typeof defaultView.Node === 'function' ? object instanceof defaultView.Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
}

module.exports = isNode;

/***/ }),
/* 768 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LocationUtils__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PathUtils__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__createTransitionManager__ = __webpack_require__(296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DOMUtils__ = __webpack_require__(438);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };








var PopStateEvent = 'popstate';
var HashChangeEvent = 'hashchange';

var getHistoryState = function getHistoryState() {
  try {
    return window.history.state || {};
  } catch (e) {
    // IE 11 sometimes throws when accessing window.history.state
    // See https://github.com/ReactTraining/history/pull/289
    return {};
  }
};

/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */
var createBrowserHistory = function createBrowserHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  __WEBPACK_IMPORTED_MODULE_1_invariant___default()(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["b" /* canUseDOM */], 'Browser history needs a DOM');

  var globalHistory = window.history;
  var canUseHistory = Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["g" /* supportsHistory */])();
  var needsHashChangeListener = !Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["h" /* supportsPopStateOnHashChange */])();

  var _props$forceRefresh = props.forceRefresh,
      forceRefresh = _props$forceRefresh === undefined ? false : _props$forceRefresh,
      _props$getUserConfirm = props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === undefined ? __WEBPACK_IMPORTED_MODULE_5__DOMUtils__["c" /* getConfirmation */] : _props$getUserConfirm,
      _props$keyLength = props.keyLength,
      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;

  var basename = props.basename ? Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["g" /* stripTrailingSlash */])(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* addLeadingSlash */])(props.basename)) : '';

  var getDOMLocation = function getDOMLocation(historyState) {
    var _ref = historyState || {},
        key = _ref.key,
        state = _ref.state;

    var _window$location = window.location,
        pathname = _window$location.pathname,
        search = _window$location.search,
        hash = _window$location.hash;


    var path = pathname + search + hash;

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!basename || Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["c" /* hasBasename */])(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".');

    if (basename) path = Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["e" /* stripBasename */])(path, basename);

    return Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, key);
  };

  var createKey = function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  };

  var transitionManager = Object(__WEBPACK_IMPORTED_MODULE_4__createTransitionManager__["a" /* default */])();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = globalHistory.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var handlePopState = function handlePopState(event) {
    // Ignore extraneous popstate events in WebKit.
    if (Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["d" /* isExtraneousPopstateEvent */])(event)) return;

    handlePop(getDOMLocation(event.state));
  };

  var handleHashChange = function handleHashChange() {
    handlePop(getDOMLocation(getHistoryState()));
  };

  var forceNextPop = false;

  var handlePop = function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';

      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({ action: action, location: location });
        } else {
          revertPop(location);
        }
      });
    }
  };

  var revertPop = function revertPop(fromLocation) {
    var toLocation = history.location;

    // TODO: We could probably make this more reliable by
    // keeping a list of keys we've seen in sessionStorage.
    // Instead, we just default to 0 for keys we don't know.

    var toIndex = allKeys.indexOf(toLocation.key);

    if (toIndex === -1) toIndex = 0;

    var fromIndex = allKeys.indexOf(fromLocation.key);

    if (fromIndex === -1) fromIndex = 0;

    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  };

  var initialLocation = getDOMLocation(getHistoryState());
  var allKeys = [initialLocation.key];

  // Public interface

  var createHref = function createHref(location) {
    return basename + Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(location);
  };

  var push = function push(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'PUSH';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var href = createHref(location);
      var key = location.key,
          state = location.state;


      if (canUseHistory) {
        globalHistory.pushState({ key: key, state: state }, null, href);

        if (forceRefresh) {
          window.location.href = href;
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          var nextKeys = allKeys.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);

          nextKeys.push(location.key);
          allKeys = nextKeys;

          setState({ action: action, location: location });
        }
      } else {
        __WEBPACK_IMPORTED_MODULE_0_warning___default()(state === undefined, 'Browser history cannot push state in browsers that do not support HTML5 history');

        window.location.href = href;
      }
    });
  };

  var replace = function replace(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'REPLACE';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var href = createHref(location);
      var key = location.key,
          state = location.state;


      if (canUseHistory) {
        globalHistory.replaceState({ key: key, state: state }, null, href);

        if (forceRefresh) {
          window.location.replace(href);
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);

          if (prevIndex !== -1) allKeys[prevIndex] = location.key;

          setState({ action: action, location: location });
        }
      } else {
        __WEBPACK_IMPORTED_MODULE_0_warning___default()(state === undefined, 'Browser history cannot replace state in browsers that do not support HTML5 history');

        window.location.replace(href);
      }
    });
  };

  var go = function go(n) {
    globalHistory.go(n);
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var listenerCount = 0;

  var checkDOMListeners = function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1) {
      Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["a" /* addEventListener */])(window, PopStateEvent, handlePopState);

      if (needsHashChangeListener) Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["a" /* addEventListener */])(window, HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["e" /* removeEventListener */])(window, PopStateEvent, handlePopState);

      if (needsHashChangeListener) Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["e" /* removeEventListener */])(window, HashChangeEvent, handleHashChange);
    }
  };

  var isBlocked = false;

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  };

  var listen = function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);

    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  };

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };

  return history;
};

/* harmony default export */ __webpack_exports__["a"] = (createBrowserHistory);

/***/ }),
/* 769 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LocationUtils__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PathUtils__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__createTransitionManager__ = __webpack_require__(296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DOMUtils__ = __webpack_require__(438);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };








var HashChangeEvent = 'hashchange';

var HashPathCoders = {
  hashbang: {
    encodePath: function encodePath(path) {
      return path.charAt(0) === '!' ? path : '!/' + Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["f" /* stripLeadingSlash */])(path);
    },
    decodePath: function decodePath(path) {
      return path.charAt(0) === '!' ? path.substr(1) : path;
    }
  },
  noslash: {
    encodePath: __WEBPACK_IMPORTED_MODULE_3__PathUtils__["f" /* stripLeadingSlash */],
    decodePath: __WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* addLeadingSlash */]
  },
  slash: {
    encodePath: __WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* addLeadingSlash */],
    decodePath: __WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* addLeadingSlash */]
  }
};

var getHashPath = function getHashPath() {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var hashIndex = href.indexOf('#');
  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
};

var pushHashPath = function pushHashPath(path) {
  return window.location.hash = path;
};

var replaceHashPath = function replaceHashPath(path) {
  var hashIndex = window.location.href.indexOf('#');

  window.location.replace(window.location.href.slice(0, hashIndex >= 0 ? hashIndex : 0) + '#' + path);
};

var createHashHistory = function createHashHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  __WEBPACK_IMPORTED_MODULE_1_invariant___default()(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["b" /* canUseDOM */], 'Hash history needs a DOM');

  var globalHistory = window.history;
  var canGoWithoutReload = Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["f" /* supportsGoWithoutReloadUsingHash */])();

  var _props$getUserConfirm = props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === undefined ? __WEBPACK_IMPORTED_MODULE_5__DOMUtils__["c" /* getConfirmation */] : _props$getUserConfirm,
      _props$hashType = props.hashType,
      hashType = _props$hashType === undefined ? 'slash' : _props$hashType;

  var basename = props.basename ? Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["g" /* stripTrailingSlash */])(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* addLeadingSlash */])(props.basename)) : '';

  var _HashPathCoders$hashT = HashPathCoders[hashType],
      encodePath = _HashPathCoders$hashT.encodePath,
      decodePath = _HashPathCoders$hashT.decodePath;


  var getDOMLocation = function getDOMLocation() {
    var path = decodePath(getHashPath());

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!basename || Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["c" /* hasBasename */])(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".');

    if (basename) path = Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["e" /* stripBasename */])(path, basename);

    return Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path);
  };

  var transitionManager = Object(__WEBPACK_IMPORTED_MODULE_4__createTransitionManager__["a" /* default */])();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = globalHistory.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var forceNextPop = false;
  var ignorePath = null;

  var handleHashChange = function handleHashChange() {
    var path = getHashPath();
    var encodedPath = encodePath(path);

    if (path !== encodedPath) {
      // Ensure we always have a properly-encoded hash.
      replaceHashPath(encodedPath);
    } else {
      var location = getDOMLocation();
      var prevLocation = history.location;

      if (!forceNextPop && Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["b" /* locationsAreEqual */])(prevLocation, location)) return; // A hashchange doesn't always == location change.

      if (ignorePath === Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(location)) return; // Ignore this change; we already setState in push/replace.

      ignorePath = null;

      handlePop(location);
    }
  };

  var handlePop = function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';

      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({ action: action, location: location });
        } else {
          revertPop(location);
        }
      });
    }
  };

  var revertPop = function revertPop(fromLocation) {
    var toLocation = history.location;

    // TODO: We could probably make this more reliable by
    // keeping a list of paths we've seen in sessionStorage.
    // Instead, we just default to 0 for paths we don't know.

    var toIndex = allPaths.lastIndexOf(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(toLocation));

    if (toIndex === -1) toIndex = 0;

    var fromIndex = allPaths.lastIndexOf(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(fromLocation));

    if (fromIndex === -1) fromIndex = 0;

    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  };

  // Ensure the hash is encoded properly before doing anything else.
  var path = getHashPath();
  var encodedPath = encodePath(path);

  if (path !== encodedPath) replaceHashPath(encodedPath);

  var initialLocation = getDOMLocation();
  var allPaths = [Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(initialLocation)];

  // Public interface

  var createHref = function createHref(location) {
    return '#' + encodePath(basename + Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(location));
  };

  var push = function push(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(state === undefined, 'Hash history cannot push state; it is ignored');

    var action = 'PUSH';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, undefined, undefined, history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var path = Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a PUSH, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        pushHashPath(encodedPath);

        var prevIndex = allPaths.lastIndexOf(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(history.location));
        var nextPaths = allPaths.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);

        nextPaths.push(path);
        allPaths = nextPaths;

        setState({ action: action, location: location });
      } else {
        __WEBPACK_IMPORTED_MODULE_0_warning___default()(false, 'Hash history cannot PUSH the same path; a new entry will not be added to the history stack');

        setState();
      }
    });
  };

  var replace = function replace(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(state === undefined, 'Hash history cannot replace state; it is ignored');

    var action = 'REPLACE';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, undefined, undefined, history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var path = Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a REPLACE, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        replaceHashPath(encodedPath);
      }

      var prevIndex = allPaths.indexOf(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(history.location));

      if (prevIndex !== -1) allPaths[prevIndex] = path;

      setState({ action: action, location: location });
    });
  };

  var go = function go(n) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(canGoWithoutReload, 'Hash history go(n) causes a full page reload in this browser');

    globalHistory.go(n);
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var listenerCount = 0;

  var checkDOMListeners = function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1) {
      Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["a" /* addEventListener */])(window, HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["e" /* removeEventListener */])(window, HashChangeEvent, handleHashChange);
    }
  };

  var isBlocked = false;

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  };

  var listen = function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);

    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  };

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };

  return history;
};

/* unused harmony default export */ var _unused_webpack_default_export = (createHashHistory);

/***/ }),
/* 770 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PathUtils__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LocationUtils__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__createTransitionManager__ = __webpack_require__(296);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };






var clamp = function clamp(n, lowerBound, upperBound) {
  return Math.min(Math.max(n, lowerBound), upperBound);
};

/**
 * Creates a history object that stores locations in memory.
 */
var createMemoryHistory = function createMemoryHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var getUserConfirmation = props.getUserConfirmation,
      _props$initialEntries = props.initialEntries,
      initialEntries = _props$initialEntries === undefined ? ['/'] : _props$initialEntries,
      _props$initialIndex = props.initialIndex,
      initialIndex = _props$initialIndex === undefined ? 0 : _props$initialIndex,
      _props$keyLength = props.keyLength,
      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;


  var transitionManager = Object(__WEBPACK_IMPORTED_MODULE_3__createTransitionManager__["a" /* default */])();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = history.entries.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var createKey = function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  };

  var index = clamp(initialIndex, 0, initialEntries.length - 1);
  var entries = initialEntries.map(function (entry) {
    return typeof entry === 'string' ? Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(entry, undefined, createKey()) : Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(entry, undefined, entry.key || createKey());
  });

  // Public interface

  var createHref = __WEBPACK_IMPORTED_MODULE_1__PathUtils__["b" /* createPath */];

  var push = function push(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'PUSH';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var prevIndex = history.index;
      var nextIndex = prevIndex + 1;

      var nextEntries = history.entries.slice(0);
      if (nextEntries.length > nextIndex) {
        nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
      } else {
        nextEntries.push(location);
      }

      setState({
        action: action,
        location: location,
        index: nextIndex,
        entries: nextEntries
      });
    });
  };

  var replace = function replace(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'REPLACE';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      history.entries[history.index] = location;

      setState({ action: action, location: location });
    });
  };

  var go = function go(n) {
    var nextIndex = clamp(history.index + n, 0, history.entries.length - 1);

    var action = 'POP';
    var location = history.entries[nextIndex];

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (ok) {
        setState({
          action: action,
          location: location,
          index: nextIndex
        });
      } else {
        // Mimic the behavior of DOM histories by
        // causing a render after a cancelled POP.
        setState();
      }
    });
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var canGo = function canGo(n) {
    var nextIndex = history.index + n;
    return nextIndex >= 0 && nextIndex < history.entries.length;
  };

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    return transitionManager.setPrompt(prompt);
  };

  var listen = function listen(listener) {
    return transitionManager.appendListener(listener);
  };

  var history = {
    length: entries.length,
    action: 'POP',
    location: entries[index],
    index: index,
    entries: entries,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    canGo: canGo,
    block: block,
    listen: listen
  };

  return history;
};

/* harmony default export */ __webpack_exports__["a"] = (createMemoryHistory);

/***/ }),
/* 771 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(439);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history_createBrowserHistory__ = __webpack_require__(440);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history_createBrowserHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_history_createBrowserHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(298);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that uses HTML5 history.
 */

var BrowserRouter = function (_React$Component) {
  _inherits(BrowserRouter, _React$Component);

  function BrowserRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, BrowserRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = __WEBPACK_IMPORTED_MODULE_3_history_createBrowserHistory___default()(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  BrowserRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, '<BrowserRouter> ignores the history prop. To use a custom history, ' + 'use `import { Router }` instead of `import { BrowserRouter as Router }`.');
  };

  BrowserRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return BrowserRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

BrowserRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  forceRefresh: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  keyLength: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* unused harmony default export */ var _unused_webpack_default_export = (BrowserRouter);

/***/ }),
/* 772 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(773);

function emptyFunction() {}

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 773 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 774 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(439);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history_createHashHistory__ = __webpack_require__(775);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history_createHashHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_history_createHashHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(298);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that uses window.location.hash.
 */

var HashRouter = function (_React$Component) {
  _inherits(HashRouter, _React$Component);

  function HashRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, HashRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = __WEBPACK_IMPORTED_MODULE_3_history_createHashHistory___default()(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  HashRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, '<HashRouter> ignores the history prop. To use a custom history, ' + 'use `import { Router }` instead of `import { HashRouter as Router }`.');
  };

  HashRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return HashRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

HashRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  hashType: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(['hashbang', 'noslash', 'slash']),
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* unused harmony default export */ var _unused_webpack_default_export = (HashRouter);

/***/ }),
/* 775 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _warning = __webpack_require__(103);

var _warning2 = _interopRequireDefault(_warning);

var _invariant = __webpack_require__(35);

var _invariant2 = _interopRequireDefault(_invariant);

var _LocationUtils = __webpack_require__(441);

var _PathUtils = __webpack_require__(297);

var _createTransitionManager = __webpack_require__(442);

var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);

var _DOMUtils = __webpack_require__(443);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HashChangeEvent = 'hashchange';

var HashPathCoders = {
  hashbang: {
    encodePath: function encodePath(path) {
      return path.charAt(0) === '!' ? path : '!/' + (0, _PathUtils.stripLeadingSlash)(path);
    },
    decodePath: function decodePath(path) {
      return path.charAt(0) === '!' ? path.substr(1) : path;
    }
  },
  noslash: {
    encodePath: _PathUtils.stripLeadingSlash,
    decodePath: _PathUtils.addLeadingSlash
  },
  slash: {
    encodePath: _PathUtils.addLeadingSlash,
    decodePath: _PathUtils.addLeadingSlash
  }
};

var getHashPath = function getHashPath() {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var hashIndex = href.indexOf('#');
  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
};

var pushHashPath = function pushHashPath(path) {
  return window.location.hash = path;
};

var replaceHashPath = function replaceHashPath(path) {
  var hashIndex = window.location.href.indexOf('#');

  window.location.replace(window.location.href.slice(0, hashIndex >= 0 ? hashIndex : 0) + '#' + path);
};

var createHashHistory = function createHashHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  (0, _invariant2.default)(_DOMUtils.canUseDOM, 'Hash history needs a DOM');

  var globalHistory = window.history;
  var canGoWithoutReload = (0, _DOMUtils.supportsGoWithoutReloadUsingHash)();

  var _props$getUserConfirm = props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === undefined ? _DOMUtils.getConfirmation : _props$getUserConfirm,
      _props$hashType = props.hashType,
      hashType = _props$hashType === undefined ? 'slash' : _props$hashType;

  var basename = props.basename ? (0, _PathUtils.stripTrailingSlash)((0, _PathUtils.addLeadingSlash)(props.basename)) : '';

  var _HashPathCoders$hashT = HashPathCoders[hashType],
      encodePath = _HashPathCoders$hashT.encodePath,
      decodePath = _HashPathCoders$hashT.decodePath;


  var getDOMLocation = function getDOMLocation() {
    var path = decodePath(getHashPath());

    (0, _warning2.default)(!basename || (0, _PathUtils.hasBasename)(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".');

    if (basename) path = (0, _PathUtils.stripBasename)(path, basename);

    return (0, _LocationUtils.createLocation)(path);
  };

  var transitionManager = (0, _createTransitionManager2.default)();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = globalHistory.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var forceNextPop = false;
  var ignorePath = null;

  var handleHashChange = function handleHashChange() {
    var path = getHashPath();
    var encodedPath = encodePath(path);

    if (path !== encodedPath) {
      // Ensure we always have a properly-encoded hash.
      replaceHashPath(encodedPath);
    } else {
      var location = getDOMLocation();
      var prevLocation = history.location;

      if (!forceNextPop && (0, _LocationUtils.locationsAreEqual)(prevLocation, location)) return; // A hashchange doesn't always == location change.

      if (ignorePath === (0, _PathUtils.createPath)(location)) return; // Ignore this change; we already setState in push/replace.

      ignorePath = null;

      handlePop(location);
    }
  };

  var handlePop = function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';

      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({ action: action, location: location });
        } else {
          revertPop(location);
        }
      });
    }
  };

  var revertPop = function revertPop(fromLocation) {
    var toLocation = history.location;

    // TODO: We could probably make this more reliable by
    // keeping a list of paths we've seen in sessionStorage.
    // Instead, we just default to 0 for paths we don't know.

    var toIndex = allPaths.lastIndexOf((0, _PathUtils.createPath)(toLocation));

    if (toIndex === -1) toIndex = 0;

    var fromIndex = allPaths.lastIndexOf((0, _PathUtils.createPath)(fromLocation));

    if (fromIndex === -1) fromIndex = 0;

    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  };

  // Ensure the hash is encoded properly before doing anything else.
  var path = getHashPath();
  var encodedPath = encodePath(path);

  if (path !== encodedPath) replaceHashPath(encodedPath);

  var initialLocation = getDOMLocation();
  var allPaths = [(0, _PathUtils.createPath)(initialLocation)];

  // Public interface

  var createHref = function createHref(location) {
    return '#' + encodePath(basename + (0, _PathUtils.createPath)(location));
  };

  var push = function push(path, state) {
    (0, _warning2.default)(state === undefined, 'Hash history cannot push state; it is ignored');

    var action = 'PUSH';
    var location = (0, _LocationUtils.createLocation)(path, undefined, undefined, history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var path = (0, _PathUtils.createPath)(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a PUSH, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        pushHashPath(encodedPath);

        var prevIndex = allPaths.lastIndexOf((0, _PathUtils.createPath)(history.location));
        var nextPaths = allPaths.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);

        nextPaths.push(path);
        allPaths = nextPaths;

        setState({ action: action, location: location });
      } else {
        (0, _warning2.default)(false, 'Hash history cannot PUSH the same path; a new entry will not be added to the history stack');

        setState();
      }
    });
  };

  var replace = function replace(path, state) {
    (0, _warning2.default)(state === undefined, 'Hash history cannot replace state; it is ignored');

    var action = 'REPLACE';
    var location = (0, _LocationUtils.createLocation)(path, undefined, undefined, history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var path = (0, _PathUtils.createPath)(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a REPLACE, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        replaceHashPath(encodedPath);
      }

      var prevIndex = allPaths.indexOf((0, _PathUtils.createPath)(history.location));

      if (prevIndex !== -1) allPaths[prevIndex] = path;

      setState({ action: action, location: location });
    });
  };

  var go = function go(n) {
    (0, _warning2.default)(canGoWithoutReload, 'Hash history go(n) causes a full page reload in this browser');

    globalHistory.go(n);
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var listenerCount = 0;

  var checkDOMListeners = function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1) {
      (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleHashChange);
    }
  };

  var isBlocked = false;

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  };

  var listen = function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);

    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  };

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };

  return history;
};

exports.default = createHashHistory;

/***/ }),
/* 776 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_MemoryRouter__ = __webpack_require__(445);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_MemoryRouter__["a" /* default */]);

/***/ }),
/* 777 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Route__ = __webpack_require__(446);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Link__ = __webpack_require__(444);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






/**
 * A <Link> wrapper that knows if it's "active" or not.
 */
var NavLink = function NavLink(_ref) {
  var to = _ref.to,
      exact = _ref.exact,
      strict = _ref.strict,
      location = _ref.location,
      activeClassName = _ref.activeClassName,
      className = _ref.className,
      activeStyle = _ref.activeStyle,
      style = _ref.style,
      getIsActive = _ref.isActive,
      ariaCurrent = _ref.ariaCurrent,
      rest = _objectWithoutProperties(_ref, ['to', 'exact', 'strict', 'location', 'activeClassName', 'className', 'activeStyle', 'style', 'isActive', 'ariaCurrent']);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Route__["a" /* default */], {
    path: (typeof to === 'undefined' ? 'undefined' : _typeof(to)) === 'object' ? to.pathname : to,
    exact: exact,
    strict: strict,
    location: location,
    children: function children(_ref2) {
      var location = _ref2.location,
          match = _ref2.match;

      var isActive = !!(getIsActive ? getIsActive(match, location) : match);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Link__["a" /* default */], _extends({
        to: to,
        className: isActive ? [className, activeClassName].filter(function (i) {
          return i;
        }).join(' ') : className,
        style: isActive ? _extends({}, style, activeStyle) : style,
        'aria-current': isActive && ariaCurrent
      }, rest));
    }
  });
};

NavLink.propTypes = {
  to: __WEBPACK_IMPORTED_MODULE_3__Link__["a" /* default */].propTypes.to,
  exact: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  strict: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  activeClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  activeStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  isActive: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  ariaCurrent: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['page', 'step', 'location', 'true'])
};

NavLink.defaultProps = {
  activeClassName: 'active',
  ariaCurrent: 'true'
};

/* harmony default export */ __webpack_exports__["a"] = (NavLink);

/***/ }),
/* 778 */
/***/ (function(module, exports) {

module.exports = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};


/***/ }),
/* 779 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Prompt__ = __webpack_require__(448);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Prompt__["a" /* default */]);

/***/ }),
/* 780 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Redirect__ = __webpack_require__(449);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Redirect__["a" /* default */]);

/***/ }),
/* 781 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_StaticRouter__ = __webpack_require__(451);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_StaticRouter__["a" /* default */]);

/***/ }),
/* 782 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Switch__ = __webpack_require__(452);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Switch__["a" /* default */]);

/***/ }),
/* 783 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_matchPath__ = __webpack_require__(212);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_matchPath__["a" /* default */]);

/***/ }),
/* 784 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_withRouter__ = __webpack_require__(453);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_withRouter__["a" /* default */]);

/***/ }),
/* 785 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_layouts_BasicPages__ = __webpack_require__(786);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_layouts_Dashboard_jsx__ = __webpack_require__(1335);
var indexRoutes=[{path:"/app/portal",name:"Basic",component:__WEBPACK_IMPORTED_MODULE_0_layouts_BasicPages__["a" /* default */]},{path:"/app",name:"Home",component:__WEBPACK_IMPORTED_MODULE_1_layouts_Dashboard_jsx__["a" /* default */]}];/* harmony default export */ __webpack_exports__["a"] = (indexRoutes);

/***/ }),
/* 786 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_routes_basicPages_jsx__ = __webpack_require__(830);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_assets_jss_material_dashboard_pro_react_layouts_pagesStyle_jsx__ = __webpack_require__(1323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_assets_img_web_background2_jpg__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_assets_img_web_background2_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_assets_img_web_background2_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__hoc_NotificationWrapper__ = __webpack_require__(244);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// @material-ui/core components
// core components
var BasicPages=function(_React$Component){_inherits(BasicPages,_React$Component);function BasicPages(){_classCallCheck(this,BasicPages);return _possibleConstructorReturn(this,(BasicPages.__proto__||Object.getPrototypeOf(BasicPages)).apply(this,arguments));}_createClass(BasicPages,[{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__hoc_NotificationWrapper__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:{backgroundImage:"url("+__WEBPACK_IMPORTED_MODULE_6_assets_img_web_background2_jpg___default.a+")",backgroundSize:"cover",height:"100vh",width:"100vw"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["e" /* Switch */],null,__WEBPACK_IMPORTED_MODULE_4_routes_basicPages_jsx__["a" /* default */].map(function(prop,key){if(prop.collapse){return null;}if(prop.redirect){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["b" /* Redirect */],{from:prop.path,to:prop.pathTo,key:key});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["c" /* Route */],{path:prop.path,component:prop.component,key:key});}))));}}]);return BasicPages;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);BasicPages.propTypes={classes:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired};/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles___default()(__WEBPACK_IMPORTED_MODULE_5_assets_jss_material_dashboard_pro_react_layouts_pagesStyle_jsx__["a" /* default */])(BasicPages));

/***/ }),
/* 787 */
/***/ (function(module, exports) {

function _setPrototypeOf(o, p) {
  module.exports = _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

module.exports = _setPrototypeOf;

/***/ }),
/* 788 */
/***/ (function(module, exports) {

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

module.exports = _objectWithoutPropertiesLoose;

/***/ }),
/* 789 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ns$jss$ns$sheetOptio;

var _propTypes = __webpack_require__(3);

var _ns = __webpack_require__(456);

var ns = _interopRequireWildcard(_ns);

var _propTypes2 = __webpack_require__(790);

var _propTypes3 = _interopRequireDefault(_propTypes2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

exports['default'] = (_ns$jss$ns$sheetOptio = {}, _defineProperty(_ns$jss$ns$sheetOptio, ns.jss, _propTypes3['default'].jss), _defineProperty(_ns$jss$ns$sheetOptio, ns.sheetOptions, _propTypes.object), _defineProperty(_ns$jss$ns$sheetOptio, ns.sheetsRegistry, _propTypes3['default'].registry), _defineProperty(_ns$jss$ns$sheetOptio, ns.managers, _propTypes.object), _ns$jss$ns$sheetOptio);

/***/ }),
/* 790 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__(3);

exports['default'] = {
  jss: (0, _propTypes.shape)({
    options: (0, _propTypes.shape)({
      createGenerateClassName: _propTypes.func.isRequired
    }).isRequired,
    createStyleSheet: _propTypes.func.isRequired,
    removeStyleSheet: _propTypes.func.isRequired
  }),
  registry: (0, _propTypes.shape)({
    add: _propTypes.func.isRequired,
    toString: _propTypes.func.isRequired
  })
};

/***/ }),
/* 791 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports['default'] = getDynamicStyles;
/**
 * Extracts a styles object with only props that contain function values.
 */
function getDynamicStyles(styles) {
  var to = null;

  for (var key in styles) {
    var value = styles[key];
    var type = typeof value === 'undefined' ? 'undefined' : _typeof(value);

    if (type === 'function') {
      if (!to) to = {};
      to[key] = value;
    } else if (type === 'object' && value !== null && !Array.isArray(value)) {
      var extracted = getDynamicStyles(value);
      if (extracted) {
        if (!to) to = {};
        to[key] = extracted;
      }
    }
  }

  return to;
}

/***/ }),
/* 792 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _warning = __webpack_require__(128);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * SheetsManager is like a WeakMap which is designed to count StyleSheet
 * instances and attach/detach automatically.
 */
var SheetsManager = function () {
  function SheetsManager() {
    _classCallCheck(this, SheetsManager);

    this.sheets = [];
    this.refs = [];
    this.keys = [];
  }

  _createClass(SheetsManager, [{
    key: 'get',
    value: function get(key) {
      var index = this.keys.indexOf(key);
      return this.sheets[index];
    }
  }, {
    key: 'add',
    value: function add(key, sheet) {
      var sheets = this.sheets,
          refs = this.refs,
          keys = this.keys;

      var index = sheets.indexOf(sheet);

      if (index !== -1) return index;

      sheets.push(sheet);
      refs.push(0);
      keys.push(key);

      return sheets.length - 1;
    }
  }, {
    key: 'manage',
    value: function manage(key) {
      var index = this.keys.indexOf(key);
      var sheet = this.sheets[index];
      if (this.refs[index] === 0) sheet.attach();
      this.refs[index]++;
      if (!this.keys[index]) this.keys.splice(index, 0, key);
      return sheet;
    }
  }, {
    key: 'unmanage',
    value: function unmanage(key) {
      var index = this.keys.indexOf(key);
      if (index === -1) {
        // eslint-ignore-next-line no-console
        (0, _warning2['default'])(false, "SheetsManager: can't find sheet to unmanage");
        return;
      }
      if (this.refs[index] > 0) {
        this.refs[index]--;
        if (this.refs[index] === 0) this.sheets[index].detach();
      }
    }
  }, {
    key: 'size',
    get: function get() {
      return this.keys.length;
    }
  }]);

  return SheetsManager;
}();

exports['default'] = SheetsManager;

/***/ }),
/* 793 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports['default'] = cloneStyle;

var _isObservable = __webpack_require__(459);

var _isObservable2 = _interopRequireDefault(_isObservable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var isArray = Array.isArray;
function cloneStyle(style) {
  // Support empty values in case user ends up with them by accident.
  if (style == null) return style;

  // Support string value for SimpleRule.
  var typeOfStyle = typeof style === 'undefined' ? 'undefined' : _typeof(style);

  if (typeOfStyle === 'string' || typeOfStyle === 'number' || typeOfStyle === 'function') {
    return style;
  }

  // Support array for FontFaceRule.
  if (isArray(style)) return style.map(cloneStyle);

  // Support Observable styles.  Observables are immutable, so we don't need to
  // copy them.
  if ((0, _isObservable2['default'])(style)) return style;

  var newStyle = {};
  for (var name in style) {
    var value = style[name];
    if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object') {
      newStyle[name] = cloneStyle(value);
      continue;
    }
    newStyle[name] = value;
  }

  return newStyle;
}

/***/ }),
/* 794 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = symbolObservablePonyfill;
function symbolObservablePonyfill(root) {
	var result;
	var Symbol = root.Symbol;

	if (typeof Symbol === 'function') {
		if (Symbol.observable) {
			result = Symbol.observable;
		} else {
			result = Symbol('observable');
			Symbol.observable = result;
		}
	} else {
		result = '@@observable';
	}

	return result;
};


/***/ }),
/* 795 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
var CSS = global.CSS;

var env = "production";

var escapeRegex = /([[\].#*$><+~=|^:(),"'`])/g;

exports['default'] = function (str) {
  // We don't need to escape it in production, because we are not using user's
  // input for selectors, we are generating a valid selector.
  if (env === 'production') return str;

  if (!CSS || !CSS.escape) {
    return str.replace(escapeRegex, '\\$1');
  }

  return CSS.escape(str);
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(26)))

/***/ }),
/* 796 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
var ns = '2f1acc6c3a606b082e5eef5e54414ffb';
if (global[ns] == null) global[ns] = 0;

// Bundle may contain multiple JSS versions at the same time. In order to identify
// the current version with just one short number and use it for classes generation
// we use a counter. Also it is more accurate, because user can manually reevaluate
// the module.
exports['default'] = global[ns]++;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(26)))

/***/ }),
/* 797 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _isInBrowser = __webpack_require__(215);

var _isInBrowser2 = _interopRequireDefault(_isInBrowser);

var _StyleSheet = __webpack_require__(462);

var _StyleSheet2 = _interopRequireDefault(_StyleSheet);

var _PluginsRegistry = __webpack_require__(798);

var _PluginsRegistry2 = _interopRequireDefault(_PluginsRegistry);

var _rules = __webpack_require__(799);

var _rules2 = _interopRequireDefault(_rules);

var _observables = __webpack_require__(805);

var _observables2 = _interopRequireDefault(_observables);

var _functions = __webpack_require__(806);

var _functions2 = _interopRequireDefault(_functions);

var _sheets = __webpack_require__(302);

var _sheets2 = _interopRequireDefault(_sheets);

var _StyleRule = __webpack_require__(129);

var _StyleRule2 = _interopRequireDefault(_StyleRule);

var _createGenerateClassName = __webpack_require__(461);

var _createGenerateClassName2 = _interopRequireDefault(_createGenerateClassName);

var _createRule2 = __webpack_require__(214);

var _createRule3 = _interopRequireDefault(_createRule2);

var _DomRenderer = __webpack_require__(807);

var _DomRenderer2 = _interopRequireDefault(_DomRenderer);

var _VirtualRenderer = __webpack_require__(808);

var _VirtualRenderer2 = _interopRequireDefault(_VirtualRenderer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var defaultPlugins = _rules2['default'].concat([_observables2['default'], _functions2['default']]);

var instanceCounter = 0;

var Jss = function () {
  function Jss(options) {
    _classCallCheck(this, Jss);

    this.id = instanceCounter++;
    this.version = "9.8.7";
    this.plugins = new _PluginsRegistry2['default']();
    this.options = {
      createGenerateClassName: _createGenerateClassName2['default'],
      Renderer: _isInBrowser2['default'] ? _DomRenderer2['default'] : _VirtualRenderer2['default'],
      plugins: []
    };
    this.generateClassName = (0, _createGenerateClassName2['default'])();

    // eslint-disable-next-line prefer-spread
    this.use.apply(this, defaultPlugins);
    this.setup(options);
  }

  _createClass(Jss, [{
    key: 'setup',
    value: function setup() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      if (options.createGenerateClassName) {
        this.options.createGenerateClassName = options.createGenerateClassName;
        // $FlowFixMe
        this.generateClassName = options.createGenerateClassName();
      }

      if (options.insertionPoint != null) this.options.insertionPoint = options.insertionPoint;
      if (options.virtual || options.Renderer) {
        this.options.Renderer = options.Renderer || (options.virtual ? _VirtualRenderer2['default'] : _DomRenderer2['default']);
      }

      // eslint-disable-next-line prefer-spread
      if (options.plugins) this.use.apply(this, options.plugins);

      return this;
    }

    /**
     * Create a Style Sheet.
     */

  }, {
    key: 'createStyleSheet',
    value: function createStyleSheet(styles) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var index = options.index;
      if (typeof index !== 'number') {
        index = _sheets2['default'].index === 0 ? 0 : _sheets2['default'].index + 1;
      }
      var sheet = new _StyleSheet2['default'](styles, _extends({}, options, {
        jss: this,
        generateClassName: options.generateClassName || this.generateClassName,
        insertionPoint: this.options.insertionPoint,
        Renderer: this.options.Renderer,
        index: index
      }));
      this.plugins.onProcessSheet(sheet);

      return sheet;
    }

    /**
     * Detach the Style Sheet and remove it from the registry.
     */

  }, {
    key: 'removeStyleSheet',
    value: function removeStyleSheet(sheet) {
      sheet.detach();
      _sheets2['default'].remove(sheet);
      return this;
    }

    /**
     * Create a rule without a Style Sheet.
     */

  }, {
    key: 'createRule',
    value: function createRule(name) {
      var style = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      // Enable rule without name for inline styles.
      if ((typeof name === 'undefined' ? 'undefined' : _typeof(name)) === 'object') {
        options = style;
        style = name;
        name = undefined;
      }

      // Cast from RuleFactoryOptions to RuleOptions
      // https://stackoverflow.com/questions/41328728/force-casting-in-flow
      var ruleOptions = options;

      ruleOptions.jss = this;
      ruleOptions.Renderer = this.options.Renderer;
      if (!ruleOptions.generateClassName) ruleOptions.generateClassName = this.generateClassName;
      if (!ruleOptions.classes) ruleOptions.classes = {};
      var rule = (0, _createRule3['default'])(name, style, ruleOptions);

      if (!ruleOptions.selector && rule instanceof _StyleRule2['default']) {
        rule.selector = '.' + ruleOptions.generateClassName(rule);
      }

      this.plugins.onProcessRule(rule);

      return rule;
    }

    /**
     * Register plugin. Passed function will be invoked with a rule instance.
     */

  }, {
    key: 'use',
    value: function use() {
      var _this = this;

      for (var _len = arguments.length, plugins = Array(_len), _key = 0; _key < _len; _key++) {
        plugins[_key] = arguments[_key];
      }

      plugins.forEach(function (plugin) {
        // Avoids applying same plugin twice, at least based on ref.
        if (_this.options.plugins.indexOf(plugin) === -1) {
          _this.options.plugins.push(plugin);
          _this.plugins.use(plugin);
        }
      });

      return this;
    }
  }]);

  return Jss;
}();

exports['default'] = Jss;

/***/ }),
/* 798 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _warning = __webpack_require__(128);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PluginsRegistry = function () {
  function PluginsRegistry() {
    _classCallCheck(this, PluginsRegistry);

    this.hooks = {
      onCreateRule: [],
      onProcessRule: [],
      onProcessStyle: [],
      onProcessSheet: [],
      onChangeValue: [],
      onUpdate: []

      /**
       * Call `onCreateRule` hooks and return an object if returned by a hook.
       */
    };
  }

  _createClass(PluginsRegistry, [{
    key: 'onCreateRule',
    value: function onCreateRule(name, decl, options) {
      for (var i = 0; i < this.hooks.onCreateRule.length; i++) {
        var rule = this.hooks.onCreateRule[i](name, decl, options);
        if (rule) return rule;
      }
      return null;
    }

    /**
     * Call `onProcessRule` hooks.
     */

  }, {
    key: 'onProcessRule',
    value: function onProcessRule(rule) {
      if (rule.isProcessed) return;
      var sheet = rule.options.sheet;

      for (var i = 0; i < this.hooks.onProcessRule.length; i++) {
        this.hooks.onProcessRule[i](rule, sheet);
      }

      // $FlowFixMe
      if (rule.style) this.onProcessStyle(rule.style, rule, sheet);

      rule.isProcessed = true;
    }

    /**
     * Call `onProcessStyle` hooks.
     */

  }, {
    key: 'onProcessStyle',
    value: function onProcessStyle(style, rule, sheet) {
      var nextStyle = style;

      for (var i = 0; i < this.hooks.onProcessStyle.length; i++) {
        nextStyle = this.hooks.onProcessStyle[i](nextStyle, rule, sheet);
        // $FlowFixMe
        rule.style = nextStyle;
      }
    }

    /**
     * Call `onProcessSheet` hooks.
     */

  }, {
    key: 'onProcessSheet',
    value: function onProcessSheet(sheet) {
      for (var i = 0; i < this.hooks.onProcessSheet.length; i++) {
        this.hooks.onProcessSheet[i](sheet);
      }
    }

    /**
     * Call `onUpdate` hooks.
     */

  }, {
    key: 'onUpdate',
    value: function onUpdate(data, rule, sheet) {
      for (var i = 0; i < this.hooks.onUpdate.length; i++) {
        this.hooks.onUpdate[i](data, rule, sheet);
      }
    }

    /**
     * Call `onChangeValue` hooks.
     */

  }, {
    key: 'onChangeValue',
    value: function onChangeValue(value, prop, rule) {
      var processedValue = value;
      for (var i = 0; i < this.hooks.onChangeValue.length; i++) {
        processedValue = this.hooks.onChangeValue[i](processedValue, prop, rule);
      }
      return processedValue;
    }

    /**
     * Register a plugin.
     * If function is passed, it is a shortcut for `{onProcessRule}`.
     */

  }, {
    key: 'use',
    value: function use(plugin) {
      for (var name in plugin) {
        if (this.hooks[name]) this.hooks[name].push(plugin[name]);else (0, _warning2['default'])(false, '[JSS] Unknown hook "%s".', name);
      }
    }
  }]);

  return PluginsRegistry;
}();

exports['default'] = PluginsRegistry;

/***/ }),
/* 799 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _SimpleRule = __webpack_require__(800);

var _SimpleRule2 = _interopRequireDefault(_SimpleRule);

var _KeyframesRule = __webpack_require__(801);

var _KeyframesRule2 = _interopRequireDefault(_KeyframesRule);

var _ConditionalRule = __webpack_require__(802);

var _ConditionalRule2 = _interopRequireDefault(_ConditionalRule);

var _FontFaceRule = __webpack_require__(803);

var _FontFaceRule2 = _interopRequireDefault(_FontFaceRule);

var _ViewportRule = __webpack_require__(804);

var _ViewportRule2 = _interopRequireDefault(_ViewportRule);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var classes = {
  '@charset': _SimpleRule2['default'],
  '@import': _SimpleRule2['default'],
  '@namespace': _SimpleRule2['default'],
  '@keyframes': _KeyframesRule2['default'],
  '@media': _ConditionalRule2['default'],
  '@supports': _ConditionalRule2['default'],
  '@font-face': _FontFaceRule2['default'],
  '@viewport': _ViewportRule2['default'],
  '@-ms-viewport': _ViewportRule2['default']

  /**
   * Generate plugins which will register all rules.
   */
};
var plugins = Object.keys(classes).map(function (key) {
  // https://jsperf.com/indexof-vs-substr-vs-regex-at-the-beginning-3
  var re = new RegExp('^' + key);
  var RuleClass = classes[key];
  var onCreateRule = function onCreateRule(name, decl, options) {
    return re.test(name) ? new RuleClass(name, decl, options) : null;
  };
  return { onCreateRule: onCreateRule };
});

exports['default'] = plugins;

/***/ }),
/* 800 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SimpleRule = function () {
  function SimpleRule(key, value, options) {
    _classCallCheck(this, SimpleRule);

    this.type = 'simple';
    this.isProcessed = false;

    this.key = key;
    this.value = value;
    this.options = options;
  }

  /**
   * Generates a CSS string.
   */
  // eslint-disable-next-line no-unused-vars


  _createClass(SimpleRule, [{
    key: 'toString',
    value: function toString(options) {
      if (Array.isArray(this.value)) {
        var str = '';
        for (var index = 0; index < this.value.length; index++) {
          str += this.key + ' ' + this.value[index] + ';';
          if (this.value[index + 1]) str += '\n';
        }
        return str;
      }

      return this.key + ' ' + this.value + ';';
    }
  }]);

  return SimpleRule;
}();

exports['default'] = SimpleRule;

/***/ }),
/* 801 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _RuleList = __webpack_require__(163);

var _RuleList2 = _interopRequireDefault(_RuleList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Rule for @keyframes
 */
var KeyframesRule = function () {
  function KeyframesRule(key, frames, options) {
    _classCallCheck(this, KeyframesRule);

    this.type = 'keyframes';
    this.isProcessed = false;

    this.key = key;
    this.options = options;
    this.rules = new _RuleList2['default'](_extends({}, options, { parent: this }));

    for (var name in frames) {
      this.rules.add(name, frames[name], _extends({}, this.options, {
        parent: this,
        selector: name
      }));
    }

    this.rules.process();
  }

  /**
   * Generates a CSS string.
   */


  _createClass(KeyframesRule, [{
    key: 'toString',
    value: function toString() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { indent: 1 };

      var inner = this.rules.toString(options);
      if (inner) inner += '\n';
      return this.key + ' {\n' + inner + '}';
    }
  }]);

  return KeyframesRule;
}();

exports['default'] = KeyframesRule;

/***/ }),
/* 802 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _RuleList = __webpack_require__(163);

var _RuleList2 = _interopRequireDefault(_RuleList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Conditional rule for @media, @supports
 */
var ConditionalRule = function () {
  function ConditionalRule(key, styles, options) {
    _classCallCheck(this, ConditionalRule);

    this.type = 'conditional';
    this.isProcessed = false;

    this.key = key;
    this.options = options;
    this.rules = new _RuleList2['default'](_extends({}, options, { parent: this }));

    for (var name in styles) {
      this.rules.add(name, styles[name]);
    }

    this.rules.process();
  }

  /**
   * Get a rule.
   */


  _createClass(ConditionalRule, [{
    key: 'getRule',
    value: function getRule(name) {
      return this.rules.get(name);
    }

    /**
     * Get index of a rule.
     */

  }, {
    key: 'indexOf',
    value: function indexOf(rule) {
      return this.rules.indexOf(rule);
    }

    /**
     * Create and register rule, run plugins.
     */

  }, {
    key: 'addRule',
    value: function addRule(name, style, options) {
      var rule = this.rules.add(name, style, options);
      this.options.jss.plugins.onProcessRule(rule);
      return rule;
    }

    /**
     * Generates a CSS string.
     */

  }, {
    key: 'toString',
    value: function toString() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { indent: 1 };

      var inner = this.rules.toString(options);
      return inner ? this.key + ' {\n' + inner + '\n}' : '';
    }
  }]);

  return ConditionalRule;
}();

exports['default'] = ConditionalRule;

/***/ }),
/* 803 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _toCss = __webpack_require__(300);

var _toCss2 = _interopRequireDefault(_toCss);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var FontFaceRule = function () {
  function FontFaceRule(key, style, options) {
    _classCallCheck(this, FontFaceRule);

    this.type = 'font-face';
    this.isProcessed = false;

    this.key = key;
    this.style = style;
    this.options = options;
  }

  /**
   * Generates a CSS string.
   */


  _createClass(FontFaceRule, [{
    key: 'toString',
    value: function toString(options) {
      if (Array.isArray(this.style)) {
        var str = '';
        for (var index = 0; index < this.style.length; index++) {
          str += (0, _toCss2['default'])(this.key, this.style[index]);
          if (this.style[index + 1]) str += '\n';
        }
        return str;
      }

      return (0, _toCss2['default'])(this.key, this.style, options);
    }
  }]);

  return FontFaceRule;
}();

exports['default'] = FontFaceRule;

/***/ }),
/* 804 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _toCss = __webpack_require__(300);

var _toCss2 = _interopRequireDefault(_toCss);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ViewportRule = function () {
  function ViewportRule(key, style, options) {
    _classCallCheck(this, ViewportRule);

    this.type = 'viewport';
    this.isProcessed = false;

    this.key = key;
    this.style = style;
    this.options = options;
  }

  /**
   * Generates a CSS string.
   */


  _createClass(ViewportRule, [{
    key: 'toString',
    value: function toString(options) {
      return (0, _toCss2['default'])(this.key, this.style, options);
    }
  }]);

  return ViewportRule;
}();

exports['default'] = ViewportRule;

/***/ }),
/* 805 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _StyleRule = __webpack_require__(129);

var _StyleRule2 = _interopRequireDefault(_StyleRule);

var _createRule = __webpack_require__(214);

var _createRule2 = _interopRequireDefault(_createRule);

var _isObservable = __webpack_require__(459);

var _isObservable2 = _interopRequireDefault(_isObservable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = {
  onCreateRule: function onCreateRule(name, decl, options) {
    if (!(0, _isObservable2['default'])(decl)) return null;

    // Cast `decl` to `Observable`, since it passed the type guard.
    var style$ = decl;

    var rule = (0, _createRule2['default'])(name, {}, options);

    // TODO
    // Call `stream.subscribe()` returns a subscription, which should be explicitly
    // unsubscribed from when we know this sheet is no longer needed.
    style$.subscribe(function (style) {
      for (var prop in style) {
        rule.prop(prop, style[prop]);
      }
    });

    return rule;
  },
  onProcessRule: function onProcessRule(rule) {
    if (!(rule instanceof _StyleRule2['default'])) return;
    var styleRule = rule;
    var style = styleRule.style;

    var _loop = function _loop(prop) {
      var value = style[prop];
      if (!(0, _isObservable2['default'])(value)) return 'continue';
      delete style[prop];
      value.subscribe({
        next: function next(nextValue) {
          styleRule.prop(prop, nextValue);
        }
      });
    };

    for (var prop in style) {
      var _ret = _loop(prop);

      if (_ret === 'continue') continue;
    }
  }
};

/***/ }),
/* 806 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _RuleList = __webpack_require__(163);

var _RuleList2 = _interopRequireDefault(_RuleList);

var _StyleRule = __webpack_require__(129);

var _StyleRule2 = _interopRequireDefault(_StyleRule);

var _createRule = __webpack_require__(214);

var _createRule2 = _interopRequireDefault(_createRule);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

// A symbol replacement.
var now = Date.now();

var fnValuesNs = 'fnValues' + now;
var fnStyleNs = 'fnStyle' + ++now;

exports['default'] = {
  onCreateRule: function onCreateRule(name, decl, options) {
    if (typeof decl !== 'function') return null;
    var rule = (0, _createRule2['default'])(name, {}, options);
    rule[fnStyleNs] = decl;
    return rule;
  },
  onProcessStyle: function onProcessStyle(style, rule) {
    var fn = {};
    for (var prop in style) {
      var value = style[prop];
      if (typeof value !== 'function') continue;
      delete style[prop];
      fn[prop] = value;
    }
    rule = rule;
    rule[fnValuesNs] = fn;
    return style;
  },
  onUpdate: function onUpdate(data, rule) {
    // It is a rules container like for e.g. ConditionalRule.
    if (rule.rules instanceof _RuleList2['default']) {
      rule.rules.update(data);
      return;
    }
    if (!(rule instanceof _StyleRule2['default'])) return;

    rule = rule;

    // If we have a fn values map, it is a rule with function values.
    if (rule[fnValuesNs]) {
      for (var prop in rule[fnValuesNs]) {
        rule.prop(prop, rule[fnValuesNs][prop](data));
      }
    }

    rule = rule;

    var fnStyle = rule[fnStyleNs];

    // If we have a style function, the entire rule is dynamic and style object
    // will be returned from that function.
    if (fnStyle) {
      var style = fnStyle(data);
      for (var _prop in style) {
        rule.prop(_prop, style[_prop]);
      }
    }
  }
};

/***/ }),
/* 807 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _warning = __webpack_require__(128);

var _warning2 = _interopRequireDefault(_warning);

var _sheets = __webpack_require__(302);

var _sheets2 = _interopRequireDefault(_sheets);

var _StyleRule = __webpack_require__(129);

var _StyleRule2 = _interopRequireDefault(_StyleRule);

var _toCssValue = __webpack_require__(213);

var _toCssValue2 = _interopRequireDefault(_toCssValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Cache the value from the first time a function is called.
 */
var memoize = function memoize(fn) {
  var value = void 0;
  return function () {
    if (!value) value = fn();
    return value;
  };
};

/**
 * Get a style property value.
 */
function getPropertyValue(cssRule, prop) {
  try {
    return cssRule.style.getPropertyValue(prop);
  } catch (err) {
    // IE may throw if property is unknown.
    return '';
  }
}

/**
 * Set a style property.
 */
function setProperty(cssRule, prop, value) {
  try {
    var cssValue = value;

    if (Array.isArray(value)) {
      cssValue = (0, _toCssValue2['default'])(value, true);

      if (value[value.length - 1] === '!important') {
        cssRule.style.setProperty(prop, cssValue, 'important');
        return true;
      }
    }

    cssRule.style.setProperty(prop, cssValue);
  } catch (err) {
    // IE may throw if property is unknown.
    return false;
  }
  return true;
}

/**
 * Remove a style property.
 */
function removeProperty(cssRule, prop) {
  try {
    cssRule.style.removeProperty(prop);
  } catch (err) {
    (0, _warning2['default'])(false, '[JSS] DOMException "%s" was thrown. Tried to remove property "%s".', err.message, prop);
  }
}

var CSSRuleTypes = {
  STYLE_RULE: 1,
  KEYFRAMES_RULE: 7

  /**
   * Get the CSS Rule key.
   */

};var getKey = function () {
  var extractKey = function extractKey(cssText) {
    var from = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    return cssText.substr(from, cssText.indexOf('{') - 1);
  };

  return function (cssRule) {
    if (cssRule.type === CSSRuleTypes.STYLE_RULE) return cssRule.selectorText;
    if (cssRule.type === CSSRuleTypes.KEYFRAMES_RULE) {
      var name = cssRule.name;

      if (name) return '@keyframes ' + name;

      // There is no rule.name in the following browsers:
      // - IE 9
      // - Safari 7.1.8
      // - Mobile Safari 9.0.0
      var cssText = cssRule.cssText;

      return '@' + extractKey(cssText, cssText.indexOf('keyframes'));
    }

    // Conditionals.
    return extractKey(cssRule.cssText);
  };
}();

/**
 * Set the selector.
 */
function setSelector(cssRule, selectorText) {
  cssRule.selectorText = selectorText;

  // Return false if setter was not successful.
  // Currently works in chrome only.
  return cssRule.selectorText === selectorText;
}

/**
 * Gets the `head` element upon the first call and caches it.
 */
var getHead = memoize(function () {
  return document.head || document.getElementsByTagName('head')[0];
});

/**
 * Gets a map of rule keys, where the property is an unescaped key and value
 * is a potentially escaped one.
 * It is used to identify CSS rules and the corresponding JSS rules. As an identifier
 * for CSSStyleRule we normally use `selectorText`. Though if original selector text
 * contains escaped code points e.g. `:not(#\\20)`, CSSOM will compile it to `:not(# )`
 * and so CSS rule's `selectorText` won't match JSS rule selector.
 *
 * https://www.w3.org/International/questions/qa-escapes#cssescapes
 */
var getUnescapedKeysMap = function () {
  var style = void 0;
  var isAttached = false;

  return function (rules) {
    var map = {};
    // https://github.com/facebook/flow/issues/2696
    if (!style) style = document.createElement('style');
    for (var i = 0; i < rules.length; i++) {
      var rule = rules[i];
      if (!(rule instanceof _StyleRule2['default'])) continue;
      var selector = rule.selector;
      // Only unescape selector over CSSOM if it contains a back slash.

      if (selector && selector.indexOf('\\') !== -1) {
        // Lazilly attach when needed.
        if (!isAttached) {
          getHead().appendChild(style);
          isAttached = true;
        }
        style.textContent = selector + ' {}';
        var _style = style,
            sheet = _style.sheet;

        if (sheet) {
          var cssRules = sheet.cssRules;

          if (cssRules) map[cssRules[0].selectorText] = rule.key;
        }
      }
    }
    if (isAttached) {
      getHead().removeChild(style);
      isAttached = false;
    }
    return map;
  };
}();

/**
 * Find attached sheet with an index higher than the passed one.
 */
function findHigherSheet(registry, options) {
  for (var i = 0; i < registry.length; i++) {
    var sheet = registry[i];
    if (sheet.attached && sheet.options.index > options.index && sheet.options.insertionPoint === options.insertionPoint) {
      return sheet;
    }
  }
  return null;
}

/**
 * Find attached sheet with the highest index.
 */
function findHighestSheet(registry, options) {
  for (var i = registry.length - 1; i >= 0; i--) {
    var sheet = registry[i];
    if (sheet.attached && sheet.options.insertionPoint === options.insertionPoint) {
      return sheet;
    }
  }
  return null;
}

/**
 * Find a comment with "jss" inside.
 */
function findCommentNode(text) {
  var head = getHead();
  for (var i = 0; i < head.childNodes.length; i++) {
    var node = head.childNodes[i];
    if (node.nodeType === 8 && node.nodeValue.trim() === text) {
      return node;
    }
  }
  return null;
}

/**
 * Find a node before which we can insert the sheet.
 */
function findPrevNode(options) {
  var registry = _sheets2['default'].registry;


  if (registry.length > 0) {
    // Try to insert before the next higher sheet.
    var sheet = findHigherSheet(registry, options);
    if (sheet) return sheet.renderer.element;

    // Otherwise insert after the last attached.
    sheet = findHighestSheet(registry, options);
    if (sheet) return sheet.renderer.element.nextElementSibling;
  }

  // Try to find a comment placeholder if registry is empty.
  var insertionPoint = options.insertionPoint;

  if (insertionPoint && typeof insertionPoint === 'string') {
    var comment = findCommentNode(insertionPoint);
    if (comment) return comment.nextSibling;
    // If user specifies an insertion point and it can't be found in the document -
    // bad specificity issues may appear.
    (0, _warning2['default'])(insertionPoint === 'jss', '[JSS] Insertion point "%s" not found.', insertionPoint);
  }

  return null;
}

/**
 * Insert style element into the DOM.
 */
function insertStyle(style, options) {
  var insertionPoint = options.insertionPoint;

  var prevNode = findPrevNode(options);

  if (prevNode) {
    var parentNode = prevNode.parentNode;

    if (parentNode) parentNode.insertBefore(style, prevNode);
    return;
  }

  // Works with iframes and any node types.
  if (insertionPoint && typeof insertionPoint.nodeType === 'number') {
    // https://stackoverflow.com/questions/41328728/force-casting-in-flow
    var insertionPointElement = insertionPoint;
    var _parentNode = insertionPointElement.parentNode;

    if (_parentNode) _parentNode.insertBefore(style, insertionPointElement.nextSibling);else (0, _warning2['default'])(false, '[JSS] Insertion point is not in the DOM.');
    return;
  }

  getHead().insertBefore(style, prevNode);
}

/**
 * Read jss nonce setting from the page if the user has set it.
 */
var getNonce = memoize(function () {
  var node = document.querySelector('meta[property="csp-nonce"]');
  return node ? node.getAttribute('content') : null;
});

var DomRenderer = function () {
  function DomRenderer(sheet) {
    _classCallCheck(this, DomRenderer);

    this.getPropertyValue = getPropertyValue;
    this.setProperty = setProperty;
    this.removeProperty = removeProperty;
    this.setSelector = setSelector;
    this.getKey = getKey;
    this.getUnescapedKeysMap = getUnescapedKeysMap;
    this.hasInsertedRules = false;

    // There is no sheet when the renderer is used from a standalone StyleRule.
    if (sheet) _sheets2['default'].add(sheet);

    this.sheet = sheet;

    var _ref = this.sheet ? this.sheet.options : {},
        media = _ref.media,
        meta = _ref.meta,
        element = _ref.element;

    this.element = element || document.createElement('style');
    this.element.setAttribute('data-jss', '');
    if (media) this.element.setAttribute('media', media);
    if (meta) this.element.setAttribute('data-meta', meta);
    var nonce = getNonce();
    if (nonce) this.element.setAttribute('nonce', nonce);
  }

  /**
   * Insert style element into render tree.
   */


  // HTMLStyleElement needs fixing https://github.com/facebook/flow/issues/2696


  _createClass(DomRenderer, [{
    key: 'attach',
    value: function attach() {
      // In the case the element node is external and it is already in the DOM.
      if (this.element.parentNode || !this.sheet) return;

      // When rules are inserted using `insertRule` API, after `sheet.detach().attach()`
      // browsers remove those rules.
      // TODO figure out if its a bug and if it is known.
      // Workaround is to redeploy the sheet before attaching as a string.
      if (this.hasInsertedRules) {
        this.deploy();
        this.hasInsertedRules = false;
      }

      insertStyle(this.element, this.sheet.options);
    }

    /**
     * Remove style element from render tree.
     */

  }, {
    key: 'detach',
    value: function detach() {
      this.element.parentNode.removeChild(this.element);
    }

    /**
     * Inject CSS string into element.
     */

  }, {
    key: 'deploy',
    value: function deploy() {
      if (!this.sheet) return;
      this.element.textContent = '\n' + this.sheet.toString() + '\n';
    }

    /**
     * Insert a rule into element.
     */

  }, {
    key: 'insertRule',
    value: function insertRule(rule, index) {
      var sheet = this.element.sheet;
      var cssRules = sheet.cssRules;

      var str = rule.toString();
      if (!index) index = cssRules.length;

      if (!str) return false;

      try {
        sheet.insertRule(str, index);
      } catch (err) {
        (0, _warning2['default'])(false, '[JSS] Can not insert an unsupported rule \n\r%s', rule);
        return false;
      }
      this.hasInsertedRules = true;

      return cssRules[index];
    }

    /**
     * Delete a rule.
     */

  }, {
    key: 'deleteRule',
    value: function deleteRule(cssRule) {
      var sheet = this.element.sheet;

      var index = this.indexOf(cssRule);
      if (index === -1) return false;
      sheet.deleteRule(index);
      return true;
    }

    /**
     * Get index of a CSS Rule.
     */

  }, {
    key: 'indexOf',
    value: function indexOf(cssRule) {
      var cssRules = this.element.sheet.cssRules;

      for (var _index = 0; _index < cssRules.length; _index++) {
        if (cssRule === cssRules[_index]) return _index;
      }
      return -1;
    }

    /**
     * Generate a new CSS rule and replace the existing one.
     */

  }, {
    key: 'replaceRule',
    value: function replaceRule(cssRule, rule) {
      var index = this.indexOf(cssRule);
      var newCssRule = this.insertRule(rule, index);
      this.element.sheet.deleteRule(index);
      return newCssRule;
    }

    /**
     * Get all rules elements.
     */

  }, {
    key: 'getRules',
    value: function getRules() {
      return this.element.sheet.cssRules;
    }
  }]);

  return DomRenderer;
}();

exports['default'] = DomRenderer;

/***/ }),
/* 808 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint-disable class-methods-use-this */

/**
 * Rendering backend to do nothing in nodejs.
 */
var VirtualRenderer = function () {
  function VirtualRenderer() {
    _classCallCheck(this, VirtualRenderer);
  }

  _createClass(VirtualRenderer, [{
    key: 'setProperty',
    value: function setProperty() {
      return true;
    }
  }, {
    key: 'getPropertyValue',
    value: function getPropertyValue() {
      return '';
    }
  }, {
    key: 'removeProperty',
    value: function removeProperty() {}
  }, {
    key: 'setSelector',
    value: function setSelector() {
      return true;
    }
  }, {
    key: 'getKey',
    value: function getKey() {
      return '';
    }
  }, {
    key: 'attach',
    value: function attach() {}
  }, {
    key: 'detach',
    value: function detach() {}
  }, {
    key: 'deploy',
    value: function deploy() {}
  }, {
    key: 'insertRule',
    value: function insertRule() {
      return false;
    }
  }, {
    key: 'deleteRule',
    value: function deleteRule() {
      return true;
    }
  }, {
    key: 'replaceRule',
    value: function replaceRule() {
      return false;
    }
  }, {
    key: 'getRules',
    value: function getRules() {}
  }, {
    key: 'indexOf',
    value: function indexOf() {
      return -1;
    }
  }]);

  return VirtualRenderer;
}();

exports['default'] = VirtualRenderer;

/***/ }),
/* 809 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports['default'] = jssGlobal;

var _jss = __webpack_require__(457);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var propKey = '@global';
var prefixKey = '@global ';

var GlobalContainerRule = function () {
  function GlobalContainerRule(key, styles, options) {
    _classCallCheck(this, GlobalContainerRule);

    this.type = 'global';

    this.key = key;
    this.options = options;
    this.rules = new _jss.RuleList(_extends({}, options, {
      parent: this
    }));

    for (var selector in styles) {
      this.rules.add(selector, styles[selector], { selector: selector });
    }

    this.rules.process();
  }

  /**
   * Get a rule.
   */


  _createClass(GlobalContainerRule, [{
    key: 'getRule',
    value: function getRule(name) {
      return this.rules.get(name);
    }

    /**
     * Create and register rule, run plugins.
     */

  }, {
    key: 'addRule',
    value: function addRule(name, style, options) {
      var rule = this.rules.add(name, style, options);
      this.options.jss.plugins.onProcessRule(rule);
      return rule;
    }

    /**
     * Get index of a rule.
     */

  }, {
    key: 'indexOf',
    value: function indexOf(rule) {
      return this.rules.indexOf(rule);
    }

    /**
     * Generates a CSS string.
     */

  }, {
    key: 'toString',
    value: function toString() {
      return this.rules.toString();
    }
  }]);

  return GlobalContainerRule;
}();

var GlobalPrefixedRule = function () {
  function GlobalPrefixedRule(name, style, options) {
    _classCallCheck(this, GlobalPrefixedRule);

    this.name = name;
    this.options = options;
    var selector = name.substr(prefixKey.length);
    this.rule = options.jss.createRule(selector, style, _extends({}, options, {
      parent: this,
      selector: selector
    }));
  }

  _createClass(GlobalPrefixedRule, [{
    key: 'toString',
    value: function toString(options) {
      return this.rule.toString(options);
    }
  }]);

  return GlobalPrefixedRule;
}();

var separatorRegExp = /\s*,\s*/g;

function addScope(selector, scope) {
  var parts = selector.split(separatorRegExp);
  var scoped = '';
  for (var i = 0; i < parts.length; i++) {
    scoped += scope + ' ' + parts[i].trim();
    if (parts[i + 1]) scoped += ', ';
  }
  return scoped;
}

function handleNestedGlobalContainerRule(rule) {
  var options = rule.options,
      style = rule.style;

  var rules = style[propKey];

  if (!rules) return;

  for (var name in rules) {
    options.sheet.addRule(name, rules[name], _extends({}, options, {
      selector: addScope(name, rule.selector)
    }));
  }

  delete style[propKey];
}

function handlePrefixedGlobalRule(rule) {
  var options = rule.options,
      style = rule.style;

  for (var prop in style) {
    if (prop.substr(0, propKey.length) !== propKey) continue;

    var selector = addScope(prop.substr(propKey.length), rule.selector);
    options.sheet.addRule(selector, style[prop], _extends({}, options, {
      selector: selector
    }));
    delete style[prop];
  }
}

/**
 * Convert nested rules to separate, remove them from original styles.
 *
 * @param {Rule} rule
 * @api public
 */
function jssGlobal() {
  function onCreateRule(name, styles, options) {
    if (name === propKey) {
      return new GlobalContainerRule(name, styles, options);
    }

    if (name[0] === '@' && name.substr(0, prefixKey.length) === prefixKey) {
      return new GlobalPrefixedRule(name, styles, options);
    }

    var parent = options.parent;


    if (parent) {
      if (parent.type === 'global' || parent.options.parent.type === 'global') {
        options.global = true;
      }
    }

    if (options.global) options.selector = name;

    return null;
  }

  function onProcessRule(rule) {
    if (rule.type !== 'style') return;

    handleNestedGlobalContainerRule(rule);
    handlePrefixedGlobalRule(rule);
  }

  return { onCreateRule: onCreateRule, onProcessRule: onProcessRule };
}

/***/ }),
/* 810 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = jssNested;

var _warning = __webpack_require__(811);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var separatorRegExp = /\s*,\s*/g;
var parentRegExp = /&/g;
var refRegExp = /\$([\w-]+)/g;

/**
 * Convert nested rules to separate, remove them from original styles.
 *
 * @param {Rule} rule
 * @api public
 */
function jssNested() {
  // Get a function to be used for $ref replacement.
  function getReplaceRef(container) {
    return function (match, key) {
      var rule = container.getRule(key);
      if (rule) return rule.selector;
      (0, _warning2.default)(false, '[JSS] Could not find the referenced rule %s in %s.', key, container.options.meta || container);
      return key;
    };
  }

  var hasAnd = function hasAnd(str) {
    return str.indexOf('&') !== -1;
  };

  function replaceParentRefs(nestedProp, parentProp) {
    var parentSelectors = parentProp.split(separatorRegExp);
    var nestedSelectors = nestedProp.split(separatorRegExp);

    var result = '';

    for (var i = 0; i < parentSelectors.length; i++) {
      var parent = parentSelectors[i];

      for (var j = 0; j < nestedSelectors.length; j++) {
        var nested = nestedSelectors[j];
        if (result) result += ', ';
        // Replace all & by the parent or prefix & with the parent.
        result += hasAnd(nested) ? nested.replace(parentRegExp, parent) : parent + ' ' + nested;
      }
    }

    return result;
  }

  function getOptions(rule, container, options) {
    // Options has been already created, now we only increase index.
    if (options) return _extends({}, options, { index: options.index + 1 });

    var nestingLevel = rule.options.nestingLevel;

    nestingLevel = nestingLevel === undefined ? 1 : nestingLevel + 1;

    return _extends({}, rule.options, {
      nestingLevel: nestingLevel,
      index: container.indexOf(rule) + 1
    });
  }

  function onProcessStyle(style, rule) {
    if (rule.type !== 'style') return style;
    var container = rule.options.parent;
    var options = void 0;
    var replaceRef = void 0;
    for (var prop in style) {
      var isNested = hasAnd(prop);
      var isNestedConditional = prop[0] === '@';

      if (!isNested && !isNestedConditional) continue;

      options = getOptions(rule, container, options);

      if (isNested) {
        var selector = replaceParentRefs(prop, rule.selector
        // Lazily create the ref replacer function just once for
        // all nested rules within the sheet.
        );if (!replaceRef) replaceRef = getReplaceRef(container
        // Replace all $refs.
        );selector = selector.replace(refRegExp, replaceRef);

        container.addRule(selector, style[prop], _extends({}, options, { selector: selector }));
      } else if (isNestedConditional) {
        container
        // Place conditional right after the parent rule to ensure right ordering.
        .addRule(prop, null, options).addRule(rule.key, style[prop], { selector: rule.selector });
      }

      delete style[prop];
    }

    return style;
  }

  return { onProcessStyle: onProcessStyle };
}

/***/ }),
/* 811 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = function() {};

if (false) {
  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
        '`warning(condition, format, ...args)` requires a warning ' +
        'message argument'
      );
    }

    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
      throw new Error(
        'The warning format should be able to uniquely identify this ' +
        'warning. Please, use a more descriptive format than: ' + format
      );
    }

    if (!condition) {
      var argIndex = 0;
      var message = 'Warning: ' +
        format.replace(/%s/g, function() {
          return args[argIndex++];
        });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch(x) {}
    }
  };
}

module.exports = warning;


/***/ }),
/* 812 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = camelCase;

var _hyphenateStyleName = __webpack_require__(813);

var _hyphenateStyleName2 = _interopRequireDefault(_hyphenateStyleName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 * Convert camel cased property names to dash separated.
 *
 * @param {Object} style
 * @return {Object}
 */
function convertCase(style) {
  var converted = {};

  for (var prop in style) {
    converted[(0, _hyphenateStyleName2['default'])(prop)] = style[prop];
  }

  if (style.fallbacks) {
    if (Array.isArray(style.fallbacks)) converted.fallbacks = style.fallbacks.map(convertCase);else converted.fallbacks = convertCase(style.fallbacks);
  }

  return converted;
}

/**
 * Allow camel cased property names by converting them back to dasherized.
 *
 * @param {Rule} rule
 */
function camelCase() {
  function onProcessStyle(style) {
    if (Array.isArray(style)) {
      // Handle rules like @font-face, which can have multiple styles in an array
      for (var index = 0; index < style.length; index++) {
        style[index] = convertCase(style[index]);
      }
      return style;
    }

    return convertCase(style);
  }

  function onChangeValue(value, prop, rule) {
    var hyphenatedProp = (0, _hyphenateStyleName2['default'])(prop);

    // There was no camel case in place
    if (prop === hyphenatedProp) return value;

    rule.prop(hyphenatedProp, value);

    // Core will ignore that property value we set the proper one above.
    return null;
  }

  return { onProcessStyle: onProcessStyle, onChangeValue: onChangeValue };
}

/***/ }),
/* 813 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var uppercasePattern = /[A-Z]/g;
var msPattern = /^ms-/;
var cache = {};

function hyphenateStyleName(string) {
    return string in cache
    ? cache[string]
    : cache[string] = string
      .replace(uppercasePattern, '-$&')
      .toLowerCase()
      .replace(msPattern, '-ms-');
}

module.exports = hyphenateStyleName;


/***/ }),
/* 814 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports['default'] = defaultUnit;

var _defaultUnits = __webpack_require__(815);

var _defaultUnits2 = _interopRequireDefault(_defaultUnits);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 * Clones the object and adds a camel cased property version.
 */
function addCamelCasedVersion(obj) {
  var regExp = /(-[a-z])/g;
  var replace = function replace(str) {
    return str[1].toUpperCase();
  };
  var newObj = {};
  for (var key in obj) {
    newObj[key] = obj[key];
    newObj[key.replace(regExp, replace)] = obj[key];
  }
  return newObj;
}

var units = addCamelCasedVersion(_defaultUnits2['default']);

/**
 * Recursive deep style passing function
 *
 * @param {String} current property
 * @param {(Object|Array|Number|String)} property value
 * @param {Object} options
 * @return {(Object|Array|Number|String)} resulting value
 */
function iterate(prop, value, options) {
  if (!value) return value;

  var convertedValue = value;

  var type = typeof value === 'undefined' ? 'undefined' : _typeof(value);
  if (type === 'object' && Array.isArray(value)) type = 'array';

  switch (type) {
    case 'object':
      if (prop === 'fallbacks') {
        for (var innerProp in value) {
          value[innerProp] = iterate(innerProp, value[innerProp], options);
        }
        break;
      }
      for (var _innerProp in value) {
        value[_innerProp] = iterate(prop + '-' + _innerProp, value[_innerProp], options);
      }
      break;
    case 'array':
      for (var i = 0; i < value.length; i++) {
        value[i] = iterate(prop, value[i], options);
      }
      break;
    case 'number':
      if (value !== 0) {
        convertedValue = value + (options[prop] || units[prop] || '');
      }
      break;
    default:
      break;
  }

  return convertedValue;
}

/**
 * Add unit to numeric values.
 */
function defaultUnit() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var camelCasedOptions = addCamelCasedVersion(options);

  function onProcessStyle(style, rule) {
    if (rule.type !== 'style') return style;

    for (var prop in style) {
      style[prop] = iterate(prop, style[prop], camelCasedOptions);
    }

    return style;
  }

  function onChangeValue(value, prop) {
    return iterate(prop, value, camelCasedOptions);
  }

  return { onProcessStyle: onProcessStyle, onChangeValue: onChangeValue };
}

/***/ }),
/* 815 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Generated jss-default-unit CSS property units
 *
 * @type object
 */
exports['default'] = {
  'animation-delay': 'ms',
  'animation-duration': 'ms',
  'background-position': 'px',
  'background-position-x': 'px',
  'background-position-y': 'px',
  'background-size': 'px',
  border: 'px',
  'border-bottom': 'px',
  'border-bottom-left-radius': 'px',
  'border-bottom-right-radius': 'px',
  'border-bottom-width': 'px',
  'border-left': 'px',
  'border-left-width': 'px',
  'border-radius': 'px',
  'border-right': 'px',
  'border-right-width': 'px',
  'border-spacing': 'px',
  'border-top': 'px',
  'border-top-left-radius': 'px',
  'border-top-right-radius': 'px',
  'border-top-width': 'px',
  'border-width': 'px',
  'border-after-width': 'px',
  'border-before-width': 'px',
  'border-end-width': 'px',
  'border-horizontal-spacing': 'px',
  'border-start-width': 'px',
  'border-vertical-spacing': 'px',
  bottom: 'px',
  'box-shadow': 'px',
  'column-gap': 'px',
  'column-rule': 'px',
  'column-rule-width': 'px',
  'column-width': 'px',
  'flex-basis': 'px',
  'font-size': 'px',
  'font-size-delta': 'px',
  height: 'px',
  left: 'px',
  'letter-spacing': 'px',
  'logical-height': 'px',
  'logical-width': 'px',
  margin: 'px',
  'margin-after': 'px',
  'margin-before': 'px',
  'margin-bottom': 'px',
  'margin-left': 'px',
  'margin-right': 'px',
  'margin-top': 'px',
  'max-height': 'px',
  'max-width': 'px',
  'margin-end': 'px',
  'margin-start': 'px',
  'mask-position-x': 'px',
  'mask-position-y': 'px',
  'mask-size': 'px',
  'max-logical-height': 'px',
  'max-logical-width': 'px',
  'min-height': 'px',
  'min-width': 'px',
  'min-logical-height': 'px',
  'min-logical-width': 'px',
  motion: 'px',
  'motion-offset': 'px',
  outline: 'px',
  'outline-offset': 'px',
  'outline-width': 'px',
  padding: 'px',
  'padding-bottom': 'px',
  'padding-left': 'px',
  'padding-right': 'px',
  'padding-top': 'px',
  'padding-after': 'px',
  'padding-before': 'px',
  'padding-end': 'px',
  'padding-start': 'px',
  'perspective-origin-x': '%',
  'perspective-origin-y': '%',
  perspective: 'px',
  right: 'px',
  'shape-margin': 'px',
  size: 'px',
  'text-indent': 'px',
  'text-stroke': 'px',
  'text-stroke-width': 'px',
  top: 'px',
  'transform-origin': '%',
  'transform-origin-x': '%',
  'transform-origin-y': '%',
  'transform-origin-z': '%',
  'transition-delay': 'ms',
  'transition-duration': 'ms',
  'vertical-align': 'px',
  width: 'px',
  'word-spacing': 'px',
  // Not existing properties.
  // Used to avoid issues with jss-expand intergration.
  'box-shadow-x': 'px',
  'box-shadow-y': 'px',
  'box-shadow-blur': 'px',
  'box-shadow-spread': 'px',
  'font-line-height': 'px',
  'text-shadow-x': 'px',
  'text-shadow-y': 'px',
  'text-shadow-blur': 'px'
};

/***/ }),
/* 816 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = jssVendorPrefixer;

var _cssVendor = __webpack_require__(817);

var vendor = _interopRequireWildcard(_cssVendor);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

/**
 * Add vendor prefix to a property name when needed.
 *
 * @param {Rule} rule
 * @api public
 */
function jssVendorPrefixer() {
  function onProcessRule(rule) {
    if (rule.type === 'keyframes') {
      rule.key = '@' + vendor.prefix.css + rule.key.substr(1);
    }
  }

  function onProcessStyle(style, rule) {
    if (rule.type !== 'style') return style;

    for (var prop in style) {
      var value = style[prop];

      var changeProp = false;
      var supportedProp = vendor.supportedProperty(prop);
      if (supportedProp && supportedProp !== prop) changeProp = true;

      var changeValue = false;
      var supportedValue = vendor.supportedValue(supportedProp, value);
      if (supportedValue && supportedValue !== value) changeValue = true;

      if (changeProp || changeValue) {
        if (changeProp) delete style[prop];
        style[supportedProp || prop] = supportedValue || value;
      }
    }

    return style;
  }

  function onChangeValue(value, prop) {
    return vendor.supportedValue(prop, value);
  }

  return { onProcessRule: onProcessRule, onProcessStyle: onProcessStyle, onChangeValue: onChangeValue };
}

/***/ }),
/* 817 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.supportedValue = exports.supportedProperty = exports.prefix = undefined;

var _prefix = __webpack_require__(303);

var _prefix2 = _interopRequireDefault(_prefix);

var _supportedProperty = __webpack_require__(818);

var _supportedProperty2 = _interopRequireDefault(_supportedProperty);

var _supportedValue = __webpack_require__(820);

var _supportedValue2 = _interopRequireDefault(_supportedValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = {
  prefix: _prefix2['default'],
  supportedProperty: _supportedProperty2['default'],
  supportedValue: _supportedValue2['default']
}; /**
    * CSS Vendor prefix detection and property feature testing.
    *
    * @copyright Oleg Slobodskoi 2015
    * @website https://github.com/jsstyles/css-vendor
    * @license MIT
    */

exports.prefix = _prefix2['default'];
exports.supportedProperty = _supportedProperty2['default'];
exports.supportedValue = _supportedValue2['default'];

/***/ }),
/* 818 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = supportedProperty;

var _isInBrowser = __webpack_require__(215);

var _isInBrowser2 = _interopRequireDefault(_isInBrowser);

var _prefix = __webpack_require__(303);

var _prefix2 = _interopRequireDefault(_prefix);

var _camelize = __webpack_require__(819);

var _camelize2 = _interopRequireDefault(_camelize);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var el = void 0;
var cache = {};

if (_isInBrowser2['default']) {
  el = document.createElement('p');

  /**
   * We test every property on vendor prefix requirement.
   * Once tested, result is cached. It gives us up to 70% perf boost.
   * http://jsperf.com/element-style-object-access-vs-plain-object
   *
   * Prefill cache with known css properties to reduce amount of
   * properties we need to feature test at runtime.
   * http://davidwalsh.name/vendor-prefix
   */
  var computed = window.getComputedStyle(document.documentElement, '');
  for (var key in computed) {
    if (!isNaN(key)) cache[computed[key]] = computed[key];
  }
}

/**
 * Test if a property is supported, returns supported property with vendor
 * prefix if required. Returns `false` if not supported.
 *
 * @param {String} prop dash separated
 * @return {String|Boolean}
 * @api public
 */
function supportedProperty(prop) {
  // For server-side rendering.
  if (!el) return prop;

  // We have not tested this prop yet, lets do the test.
  if (cache[prop] != null) return cache[prop];

  // Camelization is required because we can't test using
  // css syntax for e.g. in FF.
  // Test if property is supported as it is.
  if ((0, _camelize2['default'])(prop) in el.style) {
    cache[prop] = prop;
  }
  // Test if property is supported with vendor prefix.
  else if (_prefix2['default'].js + (0, _camelize2['default'])('-' + prop) in el.style) {
      cache[prop] = _prefix2['default'].css + prop;
    } else {
      cache[prop] = false;
    }

  return cache[prop];
}

/***/ }),
/* 819 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = camelize;
var regExp = /[-\s]+(.)?/g;

/**
 * Convert dash separated strings to camel cased.
 *
 * @param {String} str
 * @return {String}
 */
function camelize(str) {
  return str.replace(regExp, toUpper);
}

function toUpper(match, c) {
  return c ? c.toUpperCase() : '';
}

/***/ }),
/* 820 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = supportedValue;

var _isInBrowser = __webpack_require__(215);

var _isInBrowser2 = _interopRequireDefault(_isInBrowser);

var _prefix = __webpack_require__(303);

var _prefix2 = _interopRequireDefault(_prefix);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var cache = {};
var el = void 0;

if (_isInBrowser2['default']) el = document.createElement('p');

/**
 * Returns prefixed value if needed. Returns `false` if value is not supported.
 *
 * @param {String} property
 * @param {String} value
 * @return {String|Boolean}
 * @api public
 */
function supportedValue(property, value) {
  // For server-side rendering.
  if (!el) return value;

  // It is a string or a number as a string like '1'.
  // We want only prefixable values here.
  if (typeof value !== 'string' || !isNaN(parseInt(value, 10))) return value;

  var cacheKey = property + value;

  if (cache[cacheKey] != null) return cache[cacheKey];

  // IE can even throw an error in some cases, for e.g. style.content = 'bar'
  try {
    // Test value as it is.
    el.style[property] = value;
  } catch (err) {
    cache[cacheKey] = false;
    return false;
  }

  // Value is supported as it is.
  if (el.style[property] !== '') {
    cache[cacheKey] = value;
  } else {
    // Test value with vendor prefix.
    value = _prefix2['default'].css + value;

    // Hardcode test to convert "flex" to "-ms-flexbox" for IE10.
    if (value === '-ms-flex') value = '-ms-flexbox';

    el.style[property] = value;

    // Value is supported with vendor prefix.
    if (el.style[property] !== '') cache[cacheKey] = value;
  }

  if (!cache[cacheKey]) cache[cacheKey] = false;

  // Reset style value.
  el.style[property] = '';

  return cache[cacheKey];
}

/***/ }),
/* 821 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = jssPropsSort;
/**
 * Sort props by length.
 */
function jssPropsSort() {
  function sort(prop0, prop1) {
    return prop0.length - prop1.length;
  }

  function onProcessStyle(style, rule) {
    if (rule.type !== 'style') return style;

    var newStyle = {};
    var props = Object.keys(style).sort(sort);
    for (var prop in props) {
      newStyle[props[prop]] = style[props[prop]];
    }
    return newStyle;
  }

  return { onProcessStyle: onProcessStyle };
}

/***/ }),
/* 822 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createTypography;

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _deepmerge = _interopRequireDefault(__webpack_require__(216));

// < 1kb payload overhead when lodash/merge is > 3kb.
function round(value) {
  return Math.round(value * 1e5) / 1e5;
}

function createTypography(palette, typography) {
  var _ref = typeof typography === 'function' ? typography(palette) : typography,
      _ref$fontFamily = _ref.fontFamily,
      fontFamily = _ref$fontFamily === void 0 ? '"Roboto", "Helvetica", "Arial", sans-serif' : _ref$fontFamily,
      _ref$fontSize = _ref.fontSize,
      fontSize = _ref$fontSize === void 0 ? 14 : _ref$fontSize,
      _ref$fontWeightLight = _ref.fontWeightLight,
      fontWeightLight = _ref$fontWeightLight === void 0 ? 300 : _ref$fontWeightLight,
      _ref$fontWeightRegula = _ref.fontWeightRegular,
      fontWeightRegular = _ref$fontWeightRegula === void 0 ? 400 : _ref$fontWeightRegula,
      _ref$fontWeightMedium = _ref.fontWeightMedium,
      fontWeightMedium = _ref$fontWeightMedium === void 0 ? 500 : _ref$fontWeightMedium,
      _ref$htmlFontSize = _ref.htmlFontSize,
      htmlFontSize = _ref$htmlFontSize === void 0 ? 16 : _ref$htmlFontSize,
      other = (0, _objectWithoutProperties2.default)(_ref, ["fontFamily", "fontSize", "fontWeightLight", "fontWeightRegular", "fontWeightMedium", "htmlFontSize"]);

  var coef = fontSize / 14;

  function pxToRem(value) {
    return "".concat(value / htmlFontSize * coef, "rem");
  }

  return (0, _deepmerge.default)({
    pxToRem: pxToRem,
    round: round,
    fontFamily: fontFamily,
    fontSize: fontSize,
    fontWeightLight: fontWeightLight,
    fontWeightRegular: fontWeightRegular,
    fontWeightMedium: fontWeightMedium,
    display4: {
      fontSize: pxToRem(112),
      fontWeight: fontWeightLight,
      fontFamily: fontFamily,
      letterSpacing: '-.04em',
      lineHeight: "".concat(round(128 / 112), "em"),
      marginLeft: '-.04em',
      color: palette.text.secondary
    },
    display3: {
      fontSize: pxToRem(56),
      fontWeight: fontWeightRegular,
      fontFamily: fontFamily,
      letterSpacing: '-.02em',
      lineHeight: "".concat(round(73 / 56), "em"),
      marginLeft: '-.02em',
      color: palette.text.secondary
    },
    display2: {
      fontSize: pxToRem(45),
      fontWeight: fontWeightRegular,
      fontFamily: fontFamily,
      lineHeight: "".concat(round(48 / 45), "em"),
      marginLeft: '-.02em',
      color: palette.text.secondary
    },
    display1: {
      fontSize: pxToRem(34),
      fontWeight: fontWeightRegular,
      fontFamily: fontFamily,
      lineHeight: "".concat(round(41 / 34), "em"),
      color: palette.text.secondary
    },
    headline: {
      fontSize: pxToRem(24),
      fontWeight: fontWeightRegular,
      fontFamily: fontFamily,
      lineHeight: "".concat(round(32.5 / 24), "em"),
      color: palette.text.primary
    },
    title: {
      fontSize: pxToRem(21),
      fontWeight: fontWeightMedium,
      fontFamily: fontFamily,
      lineHeight: "".concat(round(24.5 / 21), "em"),
      color: palette.text.primary
    },
    subheading: {
      fontSize: pxToRem(16),
      fontWeight: fontWeightRegular,
      fontFamily: fontFamily,
      lineHeight: "".concat(round(24 / 16), "em"),
      color: palette.text.primary
    },
    body2: {
      fontSize: pxToRem(14),
      fontWeight: fontWeightMedium,
      fontFamily: fontFamily,
      lineHeight: "".concat(round(24 / 14), "em"),
      color: palette.text.primary
    },
    body1: {
      fontSize: pxToRem(14),
      fontWeight: fontWeightRegular,
      fontFamily: fontFamily,
      lineHeight: "".concat(round(20.5 / 14), "em"),
      color: palette.text.primary
    },
    caption: {
      fontSize: pxToRem(12),
      fontWeight: fontWeightRegular,
      fontFamily: fontFamily,
      lineHeight: "".concat(round(16.5 / 12), "em"),
      color: palette.text.secondary
    },
    button: {
      fontSize: pxToRem(14),
      textTransform: 'uppercase',
      fontWeight: fontWeightMedium,
      fontFamily: fontFamily,
      color: palette.text.primary
    }
  }, other, {
    clone: false // No need to clone deep

  });
}

/***/ }),
/* 823 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createPalette;
exports.dark = exports.light = void 0;

var _objectSpread2 = _interopRequireDefault(__webpack_require__(23));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _warning = _interopRequireDefault(__webpack_require__(32));

var _deepmerge = _interopRequireDefault(__webpack_require__(216));

var _indigo = _interopRequireDefault(__webpack_require__(464));

var _pink = _interopRequireDefault(__webpack_require__(465));

var _grey = _interopRequireDefault(__webpack_require__(466));

var _red = _interopRequireDefault(__webpack_require__(467));

var _common = _interopRequireDefault(__webpack_require__(305));

var _colorManipulator = __webpack_require__(90);

// < 1kb payload overhead when lodash/merge is > 3kb.
var light = {
  // The colors used to style the text.
  text: {
    // The most important text.
    primary: 'rgba(0, 0, 0, 0.87)',
    // Secondary text.
    secondary: 'rgba(0, 0, 0, 0.54)',
    // Disabled text have even lower visual prominence.
    disabled: 'rgba(0, 0, 0, 0.38)',
    // Text hints.
    hint: 'rgba(0, 0, 0, 0.38)'
  },
  // The color used to divide different elements.
  divider: 'rgba(0, 0, 0, 0.12)',
  // The background colors used to style the surfaces.
  // Consistency between these values is important.
  background: {
    paper: _common.default.white,
    default: _grey.default[50]
  },
  // The colors used to style the action elements.
  action: {
    // The color of an active action like an icon button.
    active: 'rgba(0, 0, 0, 0.54)',
    // The color of an hovered action.
    hover: 'rgba(0, 0, 0, 0.08)',
    hoverOpacity: 0.08,
    // The color of a selected action.
    selected: 'rgba(0, 0, 0, 0.14)',
    // The color of a disabled action.
    disabled: 'rgba(0, 0, 0, 0.26)',
    // The background color of a disabled action.
    disabledBackground: 'rgba(0, 0, 0, 0.12)'
  }
};
exports.light = light;
var dark = {
  text: {
    primary: _common.default.white,
    secondary: 'rgba(255, 255, 255, 0.7)',
    disabled: 'rgba(255, 255, 255, 0.5)',
    hint: 'rgba(255, 255, 255, 0.5)',
    icon: 'rgba(255, 255, 255, 0.5)'
  },
  divider: 'rgba(255, 255, 255, 0.12)',
  background: {
    paper: _grey.default[800],
    default: '#303030'
  },
  action: {
    active: _common.default.white,
    hover: 'rgba(255, 255, 255, 0.1)',
    hoverOpacity: 0.1,
    selected: 'rgba(255, 255, 255, 0.2)',
    disabled: 'rgba(255, 255, 255, 0.3)',
    disabledBackground: 'rgba(255, 255, 255, 0.12)'
  }
};
exports.dark = dark;

function addLightOrDark(intent, direction, shade, tonalOffset) {
  if (!intent[direction]) {
    if (intent.hasOwnProperty(shade)) {
      intent[direction] = intent[shade];
    } else if (direction === 'light') {
      intent.light = (0, _colorManipulator.lighten)(intent.main, tonalOffset);
    } else if (direction === 'dark') {
      intent.dark = (0, _colorManipulator.darken)(intent.main, tonalOffset * 1.5);
    }
  }
}

function createPalette(palette) {
  var _palette$primary = palette.primary,
      primary = _palette$primary === void 0 ? {
    light: _indigo.default[300],
    main: _indigo.default[500],
    dark: _indigo.default[700]
  } : _palette$primary,
      _palette$secondary = palette.secondary,
      secondary = _palette$secondary === void 0 ? {
    light: _pink.default.A200,
    main: _pink.default.A400,
    dark: _pink.default.A700
  } : _palette$secondary,
      _palette$error = palette.error,
      error = _palette$error === void 0 ? {
    light: _red.default[300],
    main: _red.default[500],
    dark: _red.default[700]
  } : _palette$error,
      _palette$type = palette.type,
      type = _palette$type === void 0 ? 'light' : _palette$type,
      _palette$contrastThre = palette.contrastThreshold,
      contrastThreshold = _palette$contrastThre === void 0 ? 3 : _palette$contrastThre,
      _palette$tonalOffset = palette.tonalOffset,
      tonalOffset = _palette$tonalOffset === void 0 ? 0.2 : _palette$tonalOffset,
      other = (0, _objectWithoutProperties2.default)(palette, ["primary", "secondary", "error", "type", "contrastThreshold", "tonalOffset"]);

  function getContrastText(background) {
    // Use the same logic as
    // Bootstrap: https://github.com/twbs/bootstrap/blob/1d6e3710dd447de1a200f29e8fa521f8a0908f70/scss/_functions.scss#L59
    // and material-components-web https://github.com/material-components/material-components-web/blob/ac46b8863c4dab9fc22c4c662dc6bd1b65dd652f/packages/mdc-theme/_functions.scss#L54
    var contrastText = (0, _colorManipulator.getContrastRatio)(background, dark.text.primary) >= contrastThreshold ? dark.text.primary : light.text.primary;

    if (false) {
      var contrast = (0, _colorManipulator.getContrastRatio)(background, contrastText);
      process.env.NODE_ENV !== "production" ? (0, _warning.default)(contrast >= 3, ["Material-UI: the contrast ratio of ".concat(contrast, ":1 for ").concat(contrastText, " on ").concat(background), 'falls below the WACG recommended absolute minimum contrast ratio of 3:1.', 'https://www.w3.org/TR/2008/REC-WCAG20-20081211/#visual-audio-contrast-contrast'].join('\n')) : void 0;
    }

    return contrastText;
  }

  function augmentColor(color, mainShade, lightShade, darkShade) {
    if (!color.main && color[mainShade]) {
      color.main = color[mainShade];
    }

    addLightOrDark(color, 'light', lightShade, tonalOffset);
    addLightOrDark(color, 'dark', darkShade, tonalOffset);

    if (!color.contrastText) {
      color.contrastText = getContrastText(color.main);
    }
  }

  augmentColor(primary, 500, 300, 700);
  augmentColor(secondary, 'A400', 'A200', 'A700');
  augmentColor(error, 500, 300, 700);
  var types = {
    dark: dark,
    light: light
  };
   false ? (0, _warning.default)(types[type], "Material-UI: the palette type `".concat(type, "` is not supported.")) : void 0;
  var paletteOutput = (0, _deepmerge.default)((0, _objectSpread2.default)({
    // A collection of common colors.
    common: _common.default,
    // The palette type, can be light or dark.
    type: type,
    // The colors used to represent primary interface elements for a user.
    primary: primary,
    // The colors used to represent secondary interface elements for a user.
    secondary: secondary,
    // The colors used to represent interface elements that the user should be made aware of.
    error: error,
    // The grey colors.
    grey: _grey.default,
    // Used by `getContrastText()` to maximize the contrast between the background and
    // the text.
    contrastThreshold: contrastThreshold,
    // Take a background color and return the color of the text to maximize the contrast.
    getContrastText: getContrastText,
    // Generate a rich color object.
    augmentColor: augmentColor,
    // Used by the functions below to shift a color's luminance by approximately
    // two indexes within its tonal palette.
    // E.g., shift from Red 500 to Red 300 or Red 700.
    tonalOffset: tonalOffset
  }, types[type]), other, {
    clone: false // No need to clone deep

  });
  return paletteOutput;
}

/***/ }),
/* 824 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createMixins;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(11));

var _objectSpread3 = _interopRequireDefault(__webpack_require__(23));

function createMixins(breakpoints, spacing, mixins) {
  var _toolbar;

  return (0, _objectSpread3.default)({
    gutters: function gutters() {
      var styles = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return (0, _objectSpread3.default)({
        paddingLeft: spacing.unit * 2,
        paddingRight: spacing.unit * 2
      }, styles, (0, _defineProperty2.default)({}, breakpoints.up('sm'), (0, _objectSpread3.default)({
        paddingLeft: spacing.unit * 3,
        paddingRight: spacing.unit * 3
      }, styles[breakpoints.up('sm')])));
    },
    toolbar: (_toolbar = {
      minHeight: 56
    }, (0, _defineProperty2.default)(_toolbar, "".concat(breakpoints.up('xs'), " and (orientation: landscape)"), {
      minHeight: 48
    }), (0, _defineProperty2.default)(_toolbar, breakpoints.up('sm'), {
      minHeight: 64
    }), _toolbar)
  }, mixins);
}

/***/ }),
/* 825 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var shadowKeyUmbraOpacity = 0.2;
var shadowKeyPenumbraOpacity = 0.14;
var shadowAmbientShadowOpacity = 0.12;

function createShadow() {
  return ["".concat(arguments.length <= 0 ? undefined : arguments[0], "px ").concat(arguments.length <= 1 ? undefined : arguments[1], "px ").concat(arguments.length <= 2 ? undefined : arguments[2], "px ").concat(arguments.length <= 3 ? undefined : arguments[3], "px rgba(0, 0, 0, ").concat(shadowKeyUmbraOpacity, ")"), "".concat(arguments.length <= 4 ? undefined : arguments[4], "px ").concat(arguments.length <= 5 ? undefined : arguments[5], "px ").concat(arguments.length <= 6 ? undefined : arguments[6], "px ").concat(arguments.length <= 7 ? undefined : arguments[7], "px rgba(0, 0, 0, ").concat(shadowKeyPenumbraOpacity, ")"), "".concat(arguments.length <= 8 ? undefined : arguments[8], "px ").concat(arguments.length <= 9 ? undefined : arguments[9], "px ").concat(arguments.length <= 10 ? undefined : arguments[10], "px ").concat(arguments.length <= 11 ? undefined : arguments[11], "px rgba(0, 0, 0, ").concat(shadowAmbientShadowOpacity, ")")].join(',');
}

var shadows = ['none', createShadow(0, 1, 3, 0, 0, 1, 1, 0, 0, 2, 1, -1), createShadow(0, 1, 5, 0, 0, 2, 2, 0, 0, 3, 1, -2), createShadow(0, 1, 8, 0, 0, 3, 4, 0, 0, 3, 3, -2), createShadow(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0), createShadow(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0), createShadow(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0), createShadow(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1), createShadow(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2), createShadow(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2), createShadow(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3), createShadow(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3), createShadow(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4), createShadow(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4), createShadow(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4), createShadow(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5), createShadow(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5), createShadow(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5), createShadow(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6), createShadow(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6), createShadow(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7), createShadow(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7), createShadow(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7), createShadow(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8), createShadow(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)];
var _default = shadows;
exports.default = _default;

/***/ }),
/* 826 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
// We need to centralize the zIndex definitions as they work
// like global values in the browser.
var zIndex = {
  mobileStepper: 1000,
  appBar: 1100,
  drawer: 1200,
  modal: 1300,
  snackbar: 1400,
  tooltip: 1500
};
var _default = zIndex;
exports.default = _default;

/***/ }),
/* 827 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  // All components align to an 8dp square baseline grid for mobile, tablet, and desktop.
  // https://material.io/guidelines/layout/metrics-keylines.html#metrics-keylines-baseline-grids
  unit: 8
};
exports.default = _default;

/***/ }),
/* 828 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectSpread2 = _interopRequireDefault(__webpack_require__(23));

var _warning = _interopRequireDefault(__webpack_require__(32));

var _deepmerge = _interopRequireDefault(__webpack_require__(216));

// < 1kb payload overhead when lodash/merge is > 3kb.
// Support for the jss-expand plugin.
function arrayMerge(destination, source) {
  return source;
}

function getStylesCreator(stylesOrCreator) {
  var themingEnabled = typeof stylesOrCreator === 'function';

  function create(theme, name) {
    var styles = themingEnabled ? stylesOrCreator(theme) : stylesOrCreator;

    if (!name || !theme.overrides || !theme.overrides[name]) {
      return styles;
    }

    var overrides = theme.overrides[name];
    var stylesWithOverrides = (0, _objectSpread2.default)({}, styles);
    Object.keys(overrides).forEach(function (key) {
       false ? (0, _warning.default)(stylesWithOverrides[key], ['Material-UI: you are trying to override a style that does not exist.', "Fix the `".concat(key, "` key of `theme.overrides.").concat(name, "`.")].join('\n')) : void 0;
      stylesWithOverrides[key] = (0, _deepmerge.default)(stylesWithOverrides[key], overrides[key], {
        arrayMerge: arrayMerge
      });
    });
    return stylesWithOverrides;
  }

  return {
    create: create,
    options: {},
    themingEnabled: themingEnabled
  };
}

var _default = getStylesCreator;
exports.default = _default;

/***/ }),
/* 829 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function getThemeProps(params) {
  var theme = params.theme,
      name = params.name;

  if (!name || !theme.props || !theme.props[name]) {
    return {};
  }

  return theme.props[name];
}

var _default = getThemeProps;
exports.default = _default;

/***/ }),
/* 830 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_views_Login_Login_jsx__ = __webpack_require__(831);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_icons_LockOpen__ = __webpack_require__(572);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_icons_LockOpen___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__material_ui_icons_LockOpen__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_views_Register_components_AssistantRegister_jsx__ = __webpack_require__(1318);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_views_Register_components_BrokerSignup_jsx__ = __webpack_require__(1319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_views_Register_components_BrokerageSignup_jsx__ = __webpack_require__(1320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_views_Portal_ForgotPassword_jsx__ = __webpack_require__(1321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_views_Portal_ResetPassword_jsx__ = __webpack_require__(1322);
var pagesRoutes=[{path:"/app/portal/login",name:"Login",short:"Login",mini:"L",icon:__WEBPACK_IMPORTED_MODULE_1__material_ui_icons_LockOpen___default.a,component:__WEBPACK_IMPORTED_MODULE_0_views_Login_Login_jsx__["a" /* default */]},{path:"/app/portal/signupbrokerage",name:"Signup as a Brokerage",short:"Register",mini:"R",icon:__WEBPACK_IMPORTED_MODULE_1__material_ui_icons_LockOpen___default.a,component:__WEBPACK_IMPORTED_MODULE_4_views_Register_components_BrokerageSignup_jsx__["a" /* default */]},{path:"/app/portal/signupbroker",name:"Signup as a Broker",short:"Register",mini:"R",icon:__WEBPACK_IMPORTED_MODULE_1__material_ui_icons_LockOpen___default.a,component:__WEBPACK_IMPORTED_MODULE_3_views_Register_components_BrokerSignup_jsx__["a" /* default */]},{path:"/app/portal/signupassistant",name:"Signup as an Assistant",short:"Register",mini:"R",icon:__WEBPACK_IMPORTED_MODULE_1__material_ui_icons_LockOpen___default.a,component:__WEBPACK_IMPORTED_MODULE_2_views_Register_components_AssistantRegister_jsx__["a" /* default */]},{path:"/app/portal/forgotpassword",name:"Forgot Password",short:"Forgot Password",mini:"FP",icon:__WEBPACK_IMPORTED_MODULE_1__material_ui_icons_LockOpen___default.a,component:__WEBPACK_IMPORTED_MODULE_5_views_Portal_ForgotPassword_jsx__["a" /* default */]},{path:"/app/portal/resetpassword",name:"Reset Password",short:"Reset Password",mini:"RP",icon:__WEBPACK_IMPORTED_MODULE_1__material_ui_icons_LockOpen___default.a,component:__WEBPACK_IMPORTED_MODULE_6_views_Portal_ResetPassword_jsx__["a" /* default */]}];/* harmony default export */ __webpack_exports__["a"] = (pagesRoutes);

/***/ }),
/* 831 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_core__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_Button__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_assets_img_sure_quote_website_logo_png__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_assets_img_sure_quote_website_logo_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_assets_img_sure_quote_website_logo_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_assets_img_web_background2_jpg__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_assets_img_web_background2_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_assets_img_web_background2_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Snackbar_Snackbar_jsx__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_Wrappers_materialUIWrappers_components_FormInput__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_Wrappers_materialUIWrappers_components_FormInputPassword__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_graphql_tag__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_graphql_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_graphql_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_apollo__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_reducers_LoginReducer__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_redux_form__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__store__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__login_css__ = __webpack_require__(1317);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__login_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__login_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_helpers_UserHelper_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_reducers_NotificationReducer__ = __webpack_require__(30);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n\tmutation login($input: LoginMInput!) {\n\t\tLoginM(input: $input) {\n\t\t\tid\n\t\t\ttoken\n\t\t\tname\n\t\t\tsurname\n\t\t\tavatar\n\t\t\tuserType\n\t\t\taccountStatus\n\t\t\terror\n\t\t}\n\t}\n'],['\n\tmutation login($input: LoginMInput!) {\n\t\tLoginM(input: $input) {\n\t\t\tid\n\t\t\ttoken\n\t\t\tname\n\t\t\tsurname\n\t\t\tavatar\n\t\t\tuserType\n\t\t\taccountStatus\n\t\t\terror\n\t\t}\n\t}\n']);function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}/*eslint-disable*///import { ParseUriParams } from "helpers/UriReader";
var required=function required(value){return value?undefined:'Required';};var CLICK='sure-quote/Login/CLICK';var loginM=__WEBPACK_IMPORTED_MODULE_7_graphql_tag___default()(_templateObject);var Login=function(_React$Component){_inherits(Login,_React$Component);function Login(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Login);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Login.__proto__||Object.getPrototypeOf(Login)).call.apply(_ref,[this].concat(args))),_this),_this.state={checkValidation:false,loading:false},_this.handleClick=function(){if(__WEBPACK_IMPORTED_MODULE_12__store__["a" /* default */].getState().form.login.syncErrors){__WEBPACK_IMPORTED_MODULE_12__store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_15_reducers_NotificationReducer__["d" /* showSnack */])({message:'Invalid data.',color:'danger'}));_this.setState({checkValidation:true});_this.forceUpdate();}else{_this.setState({checkValidation:false,loading:true});var input={userEmail:__WEBPACK_IMPORTED_MODULE_12__store__["a" /* default */].getState().form.login.values.username,userPassword:__WEBPACK_IMPORTED_MODULE_12__store__["a" /* default */].getState().form.login.values.password};_this.props.mutate({variables:{input:input}}).then(function(response){var obj=response.data.LoginM;if(obj.error){__WEBPACK_IMPORTED_MODULE_12__store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_15_reducers_NotificationReducer__["d" /* showSnack */])({message:obj.error,color:'danger'}));_this.setState({loading:false});return;}obj.userName=__WEBPACK_IMPORTED_MODULE_12__store__["a" /* default */].getState().form.login.values.username;__WEBPACK_IMPORTED_MODULE_12__store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_10_reducers_LoginReducer__["b" /* Click */])({type:CLICK,props:response.data.LoginM}));var keys=Object.keys(response.data.LoginM).filter(function(k){return k!=='__typename';});keys.map(function(k){if(response.data.LoginM[k]&&response.data.LoginM[k]!==null){localStorage.setItem(k,response.data.LoginM[k].toString());}});_this.setState({loading:false});if(response.data.LoginM.token!=''){switch(response.data.LoginM.userType){case'1':_this.props.history.push('/app/brokerageAdminProfile');break;case'2'||'3':_this.props.history.push('/app/home');break;case'3':_this.props.history.push('/app/home');break;case'6':_this.props.history.push('/app/home');break;default:break;}}}).catch(function(error){_this.setState({loading:false});var err=error.toString().split('Error: GraphQL error: ')[1];__WEBPACK_IMPORTED_MODULE_12__store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_15_reducers_NotificationReducer__["d" /* showSnack */])({message:err,color:'danger'}));});}},_this.passwordKeyPressed=function(e){if(e.key==='Enter'){_this.handleClick();}return;},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Login,[{key:'componentDidMount',value:function componentDidMount(){Object(__WEBPACK_IMPORTED_MODULE_14_helpers_UserHelper_js__["d" /* Logout */])();}},{key:'render',value:function render(){var _React$createElement,_this2=this;var validate=[];validate.push(required);return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('div',{className:'loginContainer',style:{backgroundImage:'url('+__WEBPACK_IMPORTED_MODULE_3_assets_img_web_background2_jpg___default.a+')'}},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["e" /* Card */],{className:'loginCard'},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('div',{className:'loginBox'},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('div',{className:'sqLogoContainer'},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('img',{className:'sqLogo',src:__WEBPACK_IMPORTED_MODULE_2_assets_img_sure_quote_website_logo_png___default.a,alt:'sqLogo'})),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["t" /* FormControl */],{fullWidth:true},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_5_components_Wrappers_materialUIWrappers_components_FormInput__["a" /* default */],isrequired:true,validate:[].concat(validate),checkValidation:this.state.checkValidation,name:'username',label:'Username'})),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["t" /* FormControl */],{fullWidth:true},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_6_components_Wrappers_materialUIWrappers_components_FormInputPassword__["a" /* default */],isrequired:true,validate:[].concat(validate),checkValidation:this.state.checkValidation,name:'password',label:'Password',handleKeyPress:this.passwordKeyPressed})),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Button___default.a,(_React$createElement={variant:'outlined',className:'outlinedButton',color:'primary',style:{margin:'auto',marginTop:'8vh',marginBottom:'15px'}},_defineProperty(_React$createElement,'color','primary'),_defineProperty(_React$createElement,'fullWidth',true),_defineProperty(_React$createElement,'onClick',!this.state.loading?this.handleClick:{}),_React$createElement),this.state.loading?__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["j" /* CircularProgress */],{size:20}):'Sign In'),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{variant:'body1',style:{color:'#0000008a',marginBottom:'15vh'},className:'typographyLinkBasic',onClick:function onClick(){_this2.props.history.push('/app/portal/forgotpassword');}},'Forgot Password?'))));}}]);return Login;}(__WEBPACK_IMPORTED_MODULE_8_react___default.a.Component);Login=Object(__WEBPACK_IMPORTED_MODULE_9_react_apollo__["graphql"])(loginM)(Login);Login=Object(__WEBPACK_IMPORTED_MODULE_11_redux_form__["e" /* reduxForm */])({form:'login',destroyOnUnmount:true})(Login);/* harmony default export */ __webpack_exports__["a"] = (Login);

/***/ }),
/* 832 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "common", {
  enumerable: true,
  get: function get() {
    return _common.default;
  }
});
Object.defineProperty(exports, "red", {
  enumerable: true,
  get: function get() {
    return _red.default;
  }
});
Object.defineProperty(exports, "pink", {
  enumerable: true,
  get: function get() {
    return _pink.default;
  }
});
Object.defineProperty(exports, "purple", {
  enumerable: true,
  get: function get() {
    return _purple.default;
  }
});
Object.defineProperty(exports, "deepPurple", {
  enumerable: true,
  get: function get() {
    return _deepPurple.default;
  }
});
Object.defineProperty(exports, "indigo", {
  enumerable: true,
  get: function get() {
    return _indigo.default;
  }
});
Object.defineProperty(exports, "blue", {
  enumerable: true,
  get: function get() {
    return _blue.default;
  }
});
Object.defineProperty(exports, "lightBlue", {
  enumerable: true,
  get: function get() {
    return _lightBlue.default;
  }
});
Object.defineProperty(exports, "cyan", {
  enumerable: true,
  get: function get() {
    return _cyan.default;
  }
});
Object.defineProperty(exports, "teal", {
  enumerable: true,
  get: function get() {
    return _teal.default;
  }
});
Object.defineProperty(exports, "green", {
  enumerable: true,
  get: function get() {
    return _green.default;
  }
});
Object.defineProperty(exports, "lightGreen", {
  enumerable: true,
  get: function get() {
    return _lightGreen.default;
  }
});
Object.defineProperty(exports, "lime", {
  enumerable: true,
  get: function get() {
    return _lime.default;
  }
});
Object.defineProperty(exports, "yellow", {
  enumerable: true,
  get: function get() {
    return _yellow.default;
  }
});
Object.defineProperty(exports, "amber", {
  enumerable: true,
  get: function get() {
    return _amber.default;
  }
});
Object.defineProperty(exports, "orange", {
  enumerable: true,
  get: function get() {
    return _orange.default;
  }
});
Object.defineProperty(exports, "deepOrange", {
  enumerable: true,
  get: function get() {
    return _deepOrange.default;
  }
});
Object.defineProperty(exports, "brown", {
  enumerable: true,
  get: function get() {
    return _brown.default;
  }
});
Object.defineProperty(exports, "grey", {
  enumerable: true,
  get: function get() {
    return _grey.default;
  }
});
Object.defineProperty(exports, "blueGrey", {
  enumerable: true,
  get: function get() {
    return _blueGrey.default;
  }
});

var _common = _interopRequireDefault(__webpack_require__(305));

var _red = _interopRequireDefault(__webpack_require__(467));

var _pink = _interopRequireDefault(__webpack_require__(465));

var _purple = _interopRequireDefault(__webpack_require__(833));

var _deepPurple = _interopRequireDefault(__webpack_require__(834));

var _indigo = _interopRequireDefault(__webpack_require__(464));

var _blue = _interopRequireDefault(__webpack_require__(835));

var _lightBlue = _interopRequireDefault(__webpack_require__(836));

var _cyan = _interopRequireDefault(__webpack_require__(837));

var _teal = _interopRequireDefault(__webpack_require__(838));

var _green = _interopRequireDefault(__webpack_require__(839));

var _lightGreen = _interopRequireDefault(__webpack_require__(840));

var _lime = _interopRequireDefault(__webpack_require__(841));

var _yellow = _interopRequireDefault(__webpack_require__(842));

var _amber = _interopRequireDefault(__webpack_require__(843));

var _orange = _interopRequireDefault(__webpack_require__(844));

var _deepOrange = _interopRequireDefault(__webpack_require__(845));

var _brown = _interopRequireDefault(__webpack_require__(846));

var _grey = _interopRequireDefault(__webpack_require__(466));

var _blueGrey = _interopRequireDefault(__webpack_require__(847));

/***/ }),
/* 833 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var purple = {
  50: '#f3e5f5',
  100: '#e1bee7',
  200: '#ce93d8',
  300: '#ba68c8',
  400: '#ab47bc',
  500: '#9c27b0',
  600: '#8e24aa',
  700: '#7b1fa2',
  800: '#6a1b9a',
  900: '#4a148c',
  A100: '#ea80fc',
  A200: '#e040fb',
  A400: '#d500f9',
  A700: '#aa00ff'
};
var _default = purple;
exports.default = _default;

/***/ }),
/* 834 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var deepPurple = {
  50: '#ede7f6',
  100: '#d1c4e9',
  200: '#b39ddb',
  300: '#9575cd',
  400: '#7e57c2',
  500: '#673ab7',
  600: '#5e35b1',
  700: '#512da8',
  800: '#4527a0',
  900: '#311b92',
  A100: '#b388ff',
  A200: '#7c4dff',
  A400: '#651fff',
  A700: '#6200ea'
};
var _default = deepPurple;
exports.default = _default;

/***/ }),
/* 835 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var blue = {
  50: '#e3f2fd',
  100: '#bbdefb',
  200: '#90caf9',
  300: '#64b5f6',
  400: '#42a5f5',
  500: '#2196f3',
  600: '#1e88e5',
  700: '#1976d2',
  800: '#1565c0',
  900: '#0d47a1',
  A100: '#82b1ff',
  A200: '#448aff',
  A400: '#2979ff',
  A700: '#2962ff'
};
var _default = blue;
exports.default = _default;

/***/ }),
/* 836 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var lightBlue = {
  50: '#e1f5fe',
  100: '#b3e5fc',
  200: '#81d4fa',
  300: '#4fc3f7',
  400: '#29b6f6',
  500: '#03a9f4',
  600: '#039be5',
  700: '#0288d1',
  800: '#0277bd',
  900: '#01579b',
  A100: '#80d8ff',
  A200: '#40c4ff',
  A400: '#00b0ff',
  A700: '#0091ea'
};
var _default = lightBlue;
exports.default = _default;

/***/ }),
/* 837 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var cyan = {
  50: '#e0f7fa',
  100: '#b2ebf2',
  200: '#80deea',
  300: '#4dd0e1',
  400: '#26c6da',
  500: '#00bcd4',
  600: '#00acc1',
  700: '#0097a7',
  800: '#00838f',
  900: '#006064',
  A100: '#84ffff',
  A200: '#18ffff',
  A400: '#00e5ff',
  A700: '#00b8d4'
};
var _default = cyan;
exports.default = _default;

/***/ }),
/* 838 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var teal = {
  50: '#e0f2f1',
  100: '#b2dfdb',
  200: '#80cbc4',
  300: '#4db6ac',
  400: '#26a69a',
  500: '#009688',
  600: '#00897b',
  700: '#00796b',
  800: '#00695c',
  900: '#004d40',
  A100: '#a7ffeb',
  A200: '#64ffda',
  A400: '#1de9b6',
  A700: '#00bfa5'
};
var _default = teal;
exports.default = _default;

/***/ }),
/* 839 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var green = {
  50: '#e8f5e9',
  100: '#c8e6c9',
  200: '#a5d6a7',
  300: '#81c784',
  400: '#66bb6a',
  500: '#4caf50',
  600: '#43a047',
  700: '#388e3c',
  800: '#2e7d32',
  900: '#1b5e20',
  A100: '#b9f6ca',
  A200: '#69f0ae',
  A400: '#00e676',
  A700: '#00c853'
};
var _default = green;
exports.default = _default;

/***/ }),
/* 840 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var lightGreen = {
  50: '#f1f8e9',
  100: '#dcedc8',
  200: '#c5e1a5',
  300: '#aed581',
  400: '#9ccc65',
  500: '#8bc34a',
  600: '#7cb342',
  700: '#689f38',
  800: '#558b2f',
  900: '#33691e',
  A100: '#ccff90',
  A200: '#b2ff59',
  A400: '#76ff03',
  A700: '#64dd17'
};
var _default = lightGreen;
exports.default = _default;

/***/ }),
/* 841 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var lime = {
  50: '#f9fbe7',
  100: '#f0f4c3',
  200: '#e6ee9c',
  300: '#dce775',
  400: '#d4e157',
  500: '#cddc39',
  600: '#c0ca33',
  700: '#afb42b',
  800: '#9e9d24',
  900: '#827717',
  A100: '#f4ff81',
  A200: '#eeff41',
  A400: '#c6ff00',
  A700: '#aeea00'
};
var _default = lime;
exports.default = _default;

/***/ }),
/* 842 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var yellow = {
  50: '#fffde7',
  100: '#fff9c4',
  200: '#fff59d',
  300: '#fff176',
  400: '#ffee58',
  500: '#ffeb3b',
  600: '#fdd835',
  700: '#fbc02d',
  800: '#f9a825',
  900: '#f57f17',
  A100: '#ffff8d',
  A200: '#ffff00',
  A400: '#ffea00',
  A700: '#ffd600'
};
var _default = yellow;
exports.default = _default;

/***/ }),
/* 843 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var amber = {
  50: '#fff8e1',
  100: '#ffecb3',
  200: '#ffe082',
  300: '#ffd54f',
  400: '#ffca28',
  500: '#ffc107',
  600: '#ffb300',
  700: '#ffa000',
  800: '#ff8f00',
  900: '#ff6f00',
  A100: '#ffe57f',
  A200: '#ffd740',
  A400: '#ffc400',
  A700: '#ffab00'
};
var _default = amber;
exports.default = _default;

/***/ }),
/* 844 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var orange = {
  50: '#fff3e0',
  100: '#ffe0b2',
  200: '#ffcc80',
  300: '#ffb74d',
  400: '#ffa726',
  500: '#ff9800',
  600: '#fb8c00',
  700: '#f57c00',
  800: '#ef6c00',
  900: '#e65100',
  A100: '#ffd180',
  A200: '#ffab40',
  A400: '#ff9100',
  A700: '#ff6d00'
};
var _default = orange;
exports.default = _default;

/***/ }),
/* 845 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var deepOrange = {
  50: '#fbe9e7',
  100: '#ffccbc',
  200: '#ffab91',
  300: '#ff8a65',
  400: '#ff7043',
  500: '#ff5722',
  600: '#f4511e',
  700: '#e64a19',
  800: '#d84315',
  900: '#bf360c',
  A100: '#ff9e80',
  A200: '#ff6e40',
  A400: '#ff3d00',
  A700: '#dd2c00'
};
var _default = deepOrange;
exports.default = _default;

/***/ }),
/* 846 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var brown = {
  50: '#efebe9',
  100: '#d7ccc8',
  200: '#bcaaa4',
  300: '#a1887f',
  400: '#8d6e63',
  500: '#795548',
  600: '#6d4c41',
  700: '#5d4037',
  800: '#4e342e',
  900: '#3e2723',
  A100: '#d7ccc8',
  A200: '#bcaaa4',
  A400: '#8d6e63',
  A700: '#5d4037'
};
var _default = brown;
exports.default = _default;

/***/ }),
/* 847 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var blueGrey = {
  50: '#eceff1',
  100: '#cfd8dc',
  200: '#b0bec5',
  300: '#90a4ae',
  400: '#78909c',
  500: '#607d8b',
  600: '#546e7a',
  700: '#455a64',
  800: '#37474f',
  900: '#263238',
  A100: '#cfd8dc',
  A200: '#b0bec5',
  A400: '#78909c',
  A700: '#455a64'
};
var _default = blueGrey;
exports.default = _default;

/***/ }),
/* 848 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(161);

var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectSpread2 = _interopRequireDefault(__webpack_require__(23));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(11));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(18));

var _createClass2 = _interopRequireDefault(__webpack_require__(19));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(20));

var _inherits2 = _interopRequireDefault(__webpack_require__(21));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _warning = _interopRequireDefault(__webpack_require__(32));

var _brcast = _interopRequireDefault(__webpack_require__(849));

var _themeListener = _interopRequireWildcard(__webpack_require__(306));

var _exactProp = _interopRequireDefault(__webpack_require__(166));

/**
 * This component takes a `theme` property.
 * It makes the `theme` available down the React tree thanks to React context.
 * This component should preferably be used at **the root of your component tree**.
 */
var MuiThemeProvider =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(MuiThemeProvider, _React$Component);

  function MuiThemeProvider(props, context) {
    var _this;

    (0, _classCallCheck2.default)(this, MuiThemeProvider);
    _this = (0, _possibleConstructorReturn2.default)(this, (MuiThemeProvider.__proto__ || Object.getPrototypeOf(MuiThemeProvider)).call(this, props, context)); // Get the outer theme from the context, can be null

    _this.broadcast = (0, _brcast.default)();
    _this.unsubscribeId = null;
    _this.outerTheme = null;
    _this.outerTheme = _themeListener.default.initial(context); // Propagate the theme so it can be accessed by the children

    _this.broadcast.setState(_this.mergeOuterLocalTheme(_this.props.theme));

    return _this;
  }

  (0, _createClass2.default)(MuiThemeProvider, [{
    key: "getChildContext",
    value: function getChildContext() {
      var _ref;

      var _props = this.props,
          sheetsManager = _props.sheetsManager,
          disableStylesGeneration = _props.disableStylesGeneration;
      var muiThemeProviderOptions = this.context.muiThemeProviderOptions || {};

      if (sheetsManager !== undefined) {
        muiThemeProviderOptions.sheetsManager = sheetsManager;
      }

      if (disableStylesGeneration !== undefined) {
        muiThemeProviderOptions.disableStylesGeneration = disableStylesGeneration;
      }

      return _ref = {}, (0, _defineProperty2.default)(_ref, _themeListener.CHANNEL, this.broadcast), (0, _defineProperty2.default)(_ref, "muiThemeProviderOptions", muiThemeProviderOptions), _ref;
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      // Subscribe on the outer theme, if present
      this.unsubscribeId = _themeListener.default.subscribe(this.context, function (outerTheme) {
        _this2.outerTheme = outerTheme; // Forward the parent theme update to the children

        _this2.broadcast.setState(_this2.mergeOuterLocalTheme(_this2.props.theme));
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      // Propagate a local theme update
      if (this.props.theme !== prevProps.theme) {
        this.broadcast.setState(this.mergeOuterLocalTheme(this.props.theme));
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.unsubscribeId !== null) {
        _themeListener.default.unsubscribe(this.context, this.unsubscribeId);
      }
    }
  }, {
    key: "mergeOuterLocalTheme",
    // Simple merge between the outer theme and the local theme
    value: function mergeOuterLocalTheme(localTheme) {
      // To support composition of theme.
      if (typeof localTheme === 'function') {
         false ? (0, _warning.default)(this.outerTheme, ['Material-UI: you are providing a theme function property ' + 'to the MuiThemeProvider component:', '<MuiThemeProvider theme={outerTheme => outerTheme} />', '', 'However, no outer theme is present.', 'Make sure a theme is already injected higher in the React tree ' + 'or provide a theme object.'].join('\n')) : void 0;
        return localTheme(this.outerTheme);
      }

      if (!this.outerTheme) {
        return localTheme;
      }

      return (0, _objectSpread2.default)({}, this.outerTheme, localTheme);
    }
  }, {
    key: "render",
    value: function render() {
      // TODO move the sheetsManager property to a different component.
      // warning(
      //   typeof window !== 'undefined' || this.props.sheetsManager,
      //   [
      //     'Material-UI: you need to provide a sheetsManager to the MuiThemeProvider ' +
      //       'when rendering on the server.',
      //     'If you do not, you might experience a memory leak',
      //   ].join('\n'),
      // );
      return this.props.children;
    }
  }]);
  return MuiThemeProvider;
}(_react.default.Component);

MuiThemeProvider.propTypes =  false ? {
  /**
   * You can wrap a node.
   */
  children: _propTypes.default.node.isRequired,

  /**
   * You can disable the generation of the styles with this option.
   * It can be useful when traversing the React tree outside of the HTML
   * rendering step on the server.
   * Let's say you are using react-apollo to extract all
   * the queries made by the interface server side.
   * You can significantly speed up the traversal with this property.
   */
  disableStylesGeneration: _propTypes.default.bool,

  /**
   * The sheetsManager is used to deduplicate style sheet injection in the page.
   * It's deduplicating using the (theme, styles) couple.
   * On the server, you should provide a new instance for each request.
   */
  sheetsManager: _propTypes.default.object,

  /**
   * A theme object.
   */
  theme: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.func]).isRequired
} : {};
MuiThemeProvider.propTypes =  false ? (0, _exactProp.default)(MuiThemeProvider.propTypes, 'MuiThemeProvider') : {};
MuiThemeProvider.childContextTypes = (0, _objectSpread2.default)({}, _themeListener.default.contextTypes, {
  muiThemeProviderOptions: _propTypes.default.object
});
MuiThemeProvider.contextTypes = (0, _objectSpread2.default)({}, _themeListener.default.contextTypes, {
  muiThemeProviderOptions: _propTypes.default.object
});
var _default = MuiThemeProvider;
exports.default = _default;

/***/ }),
/* 849 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
function createBroadcast (initialState) {
  var listeners = {};
  var id = 1;
  var _state = initialState;

  function getState () {
    return _state
  }

  function setState (state) {
    _state = state;
    var keys = Object.keys(listeners);
    var i = 0;
    var len = keys.length;
    for (; i < len; i++) {
      // if a listener gets unsubscribed during setState we just skip it
      if (listeners[keys[i]]) { listeners[keys[i]](state); }
    }
  }

  // subscribe to changes and return the subscriptionId
  function subscribe (listener) {
    if (typeof listener !== 'function') {
      throw new Error('listener must be a function.')
    }
    var currentId = id;
    listeners[currentId] = listener;
    id += 1;
    return currentId
  }

  // remove subscription by removing the listener function
  function unsubscribe (id) {
    listeners[id] = undefined;
  }

  return { getState: getState, setState: setState, subscribe: subscribe, unsubscribe: unsubscribe }
}

/* harmony default export */ __webpack_exports__["default"] = (createBroadcast);


/***/ }),
/* 850 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createStyles;

function createStyles(s) {
  return s;
}

/***/ }),
/* 851 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(8));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(11));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _classnames = _interopRequireDefault(__webpack_require__(6));

var _withStyles = _interopRequireDefault(__webpack_require__(5));

var _helpers = __webpack_require__(36);

var _Paper = _interopRequireDefault(__webpack_require__(69));

// @inheritedComponent Paper
var styles = function styles(theme) {
  var backgroundColorDefault = theme.palette.type === 'light' ? theme.palette.grey[100] : theme.palette.grey[900];
  return {
    root: {
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
      boxSizing: 'border-box',
      // Prevent padding issue with the Modal and fixed positioned AppBar.
      zIndex: theme.zIndex.appBar,
      flexShrink: 0
    },
    positionFixed: {
      position: 'fixed',
      top: 0,
      left: 'auto',
      right: 0
    },
    positionAbsolute: {
      position: 'absolute',
      top: 0,
      left: 'auto',
      right: 0
    },
    positionSticky: {
      position: 'sticky',
      top: 0,
      left: 'auto',
      right: 0
    },
    positionStatic: {
      position: 'static'
    },
    colorDefault: {
      backgroundColor: backgroundColorDefault,
      color: theme.palette.getContrastText(backgroundColorDefault)
    },
    colorPrimary: {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.primary.contrastText
    },
    colorSecondary: {
      backgroundColor: theme.palette.secondary.main,
      color: theme.palette.secondary.contrastText
    }
  };
};

exports.styles = styles;

function AppBar(props) {
  var _classNames;

  var children = props.children,
      classes = props.classes,
      classNameProp = props.className,
      color = props.color,
      position = props.position,
      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "color", "position"]);
  var className = (0, _classnames.default)(classes.root, classes["position".concat((0, _helpers.capitalize)(position))], (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes["color".concat((0, _helpers.capitalize)(color))], color !== 'inherit'), (0, _defineProperty2.default)(_classNames, 'mui-fixed', position === 'fixed'), _classNames), classNameProp);
  return _react.default.createElement(_Paper.default, (0, _extends2.default)({
    square: true,
    component: "header",
    elevation: 4,
    className: className
  }, other), children);
}

AppBar.propTypes =  false ? {
  /**
   * The content of the component.
   */
  children: _propTypes.default.node.isRequired,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: _propTypes.default.oneOf(['inherit', 'primary', 'secondary', 'default']),

  /**
   * The positioning type. The behavior of the different options is described
   * [here](https://developer.mozilla.org/en-US/docs/Learn/CSS/CSS_layout/Positioning).
   * Note: `sticky` is not universally supported and will fall back to `static` when unavailable.
   */
  position: _propTypes.default.oneOf(['fixed', 'absolute', 'sticky', 'static'])
} : {};
AppBar.defaultProps = {
  color: 'primary',
  position: 'fixed'
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiAppBar'
})(AppBar);

exports.default = _default;

/***/ }),
/* 852 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(8));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(11));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _objectSpread2 = _interopRequireDefault(__webpack_require__(23));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _classnames = _interopRequireDefault(__webpack_require__(6));

var _warning = _interopRequireDefault(__webpack_require__(32));

var _withStyles = _interopRequireDefault(__webpack_require__(5));

var styles = function styles(theme) {
  var elevations = {};
  theme.shadows.forEach(function (shadow, index) {
    elevations["elevation".concat(index)] = {
      boxShadow: shadow
    };
  });
  return (0, _objectSpread2.default)({
    root: {
      backgroundColor: theme.palette.background.paper
    },
    rounded: {
      borderRadius: 2
    }
  }, elevations);
};

exports.styles = styles;

function Paper(props) {
  var classes = props.classes,
      classNameProp = props.className,
      Component = props.component,
      square = props.square,
      elevation = props.elevation,
      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "component", "square", "elevation"]);
   false ? (0, _warning.default)(elevation >= 0 && elevation < 25, "Material-UI: this elevation `".concat(elevation, "` is not implemented.")) : void 0;
  var className = (0, _classnames.default)(classes.root, classes["elevation".concat(elevation)], (0, _defineProperty2.default)({}, classes.rounded, !square), classNameProp);
  return _react.default.createElement(Component, (0, _extends2.default)({
    className: className
  }, other));
}

Paper.propTypes =  false ? {
  /**
   * The content of the component.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func]),

  /**
   * Shadow depth, corresponds to `dp` in the spec.
   * It's accepting values between 0 and 24 inclusive.
   */
  elevation: _propTypes.default.number,

  /**
   * If `true`, rounded corners are disabled.
   */
  square: _propTypes.default.bool
} : {};
Paper.defaultProps = {
  component: 'div',
  elevation: 2,
  square: false
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiPaper'
})(Paper);

exports.default = _default;

/***/ }),
/* 853 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Avatar.default;
  }
});

var _Avatar = _interopRequireDefault(__webpack_require__(470));

/***/ }),
/* 854 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(8));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(11));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _classnames = _interopRequireDefault(__webpack_require__(6));

var _withStyles = _interopRequireDefault(__webpack_require__(5));

var _Fade = _interopRequireDefault(__webpack_require__(307));

var styles = {
  root: {
    zIndex: -1,
    width: '100%',
    height: '100%',
    position: 'fixed',
    top: 0,
    left: 0,
    // Remove grey highlight
    WebkitTapHighlightColor: 'transparent',
    backgroundColor: 'rgba(0, 0, 0, 0.5)'
  },
  invisible: {
    backgroundColor: 'transparent'
  }
};
exports.styles = styles;

function Backdrop(props) {
  var classes = props.classes,
      className = props.className,
      invisible = props.invisible,
      open = props.open,
      transitionDuration = props.transitionDuration,
      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "invisible", "open", "transitionDuration"]);
  return _react.default.createElement(_Fade.default, (0, _extends2.default)({
    appear: true,
    "in": open,
    timeout: transitionDuration
  }, other), _react.default.createElement("div", {
    className: (0, _classnames.default)(classes.root, (0, _defineProperty2.default)({}, classes.invisible, invisible), className),
    "aria-hidden": "true"
  }));
}

Backdrop.propTypes =  false ? {
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * If `true`, the backdrop is invisible.
   * It can be used when rendering a popover or a custom select component.
   */
  invisible: _propTypes.default.bool,

  /**
   * If `true`, the backdrop is open.
   */
  open: _propTypes.default.bool.isRequired,

  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   */
  transitionDuration: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
    enter: _propTypes.default.number,
    exit: _propTypes.default.number
  })])
} : {};
Backdrop.defaultProps = {
  invisible: false
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiBackdrop'
})(Backdrop);

exports.default = _default;

/***/ }),
/* 855 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(8));

var _objectSpread2 = _interopRequireDefault(__webpack_require__(23));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(18));

var _createClass2 = _interopRequireDefault(__webpack_require__(19));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(20));

var _inherits2 = _interopRequireDefault(__webpack_require__(21));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _Transition = _interopRequireDefault(__webpack_require__(131));

var _transitions = __webpack_require__(78);

var _withTheme = _interopRequireDefault(__webpack_require__(91));

var _utils = __webpack_require__(132);

// @inheritedComponent Transition
var styles = {
  entering: {
    opacity: 1
  },
  entered: {
    opacity: 1
  }
};
/**
 * The Fade transition is used by the [Modal](/utils/modals) component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */

var Fade =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(Fade, _React$Component);

  function Fade() {
    var _ref;

    var _temp, _this;

    (0, _classCallCheck2.default)(this, Fade);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return (0, _possibleConstructorReturn2.default)(_this, (_temp = _this = (0, _possibleConstructorReturn2.default)(this, (_ref = Fade.__proto__ || Object.getPrototypeOf(Fade)).call.apply(_ref, [this].concat(args))), _this.handleEnter = function (node) {
      var theme = _this.props.theme;
      (0, _utils.reflow)(node); // So the animation always start from the start.

      var transitionProps = (0, _utils.getTransitionProps)(_this.props, {
        mode: 'enter'
      });
      node.style.webkitTransition = theme.transitions.create('opacity', transitionProps);
      node.style.transition = theme.transitions.create('opacity', transitionProps);

      if (_this.props.onEnter) {
        _this.props.onEnter(node);
      }
    }, _this.handleExit = function (node) {
      var theme = _this.props.theme;
      var transitionProps = (0, _utils.getTransitionProps)(_this.props, {
        mode: 'exit'
      });
      node.style.webkitTransition = theme.transitions.create('opacity', transitionProps);
      node.style.transition = theme.transitions.create('opacity', transitionProps);

      if (_this.props.onExit) {
        _this.props.onExit(node);
      }
    }, _temp));
  }

  (0, _createClass2.default)(Fade, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          children = _props.children,
          onEnter = _props.onEnter,
          onExit = _props.onExit,
          styleProp = _props.style,
          theme = _props.theme,
          other = (0, _objectWithoutProperties2.default)(_props, ["children", "onEnter", "onExit", "style", "theme"]);
      var style = (0, _objectSpread2.default)({}, styleProp, _react.default.isValidElement(children) ? children.props.style : {});
      return _react.default.createElement(_Transition.default, (0, _extends2.default)({
        appear: true,
        onEnter: this.handleEnter,
        onExit: this.handleExit
      }, other), function (state, childProps) {
        return _react.default.cloneElement(children, (0, _objectSpread2.default)({
          style: (0, _objectSpread2.default)({
            opacity: 0,
            willChange: 'opacity'
          }, styles[state], style)
        }, childProps));
      });
    }
  }]);
  return Fade;
}(_react.default.Component);

Fade.propTypes =  false ? {
  /**
   * A single child content element.
   */
  children: _propTypes.default.oneOfType([_propTypes.default.element, _propTypes.default.func]),

  /**
   * If `true`, the component will transition in.
   */
  in: _propTypes.default.bool,

  /**
   * @ignore
   */
  onEnter: _propTypes.default.func,

  /**
   * @ignore
   */
  onExit: _propTypes.default.func,

  /**
   * @ignore
   */
  style: _propTypes.default.object,

  /**
   * @ignore
   */
  theme: _propTypes.default.object.isRequired,

  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   */
  timeout: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
    enter: _propTypes.default.number,
    exit: _propTypes.default.number
  })])
} : {};
Fade.defaultProps = {
  timeout: {
    enter: _transitions.duration.enteringScreen,
    exit: _transitions.duration.leavingScreen
  }
};

var _default = (0, _withTheme.default)()(Fade);

exports.default = _default;

/***/ }),
/* 856 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.classNamesShape = exports.timeoutsShape = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(3));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var timeoutsShape =  false ? _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
  enter: _propTypes.default.number,
  exit: _propTypes.default.number
}).isRequired]) : null;
exports.timeoutsShape = timeoutsShape;
var classNamesShape =  false ? _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.shape({
  enter: _propTypes.default.string,
  exit: _propTypes.default.string,
  active: _propTypes.default.string
}), _propTypes.default.shape({
  enter: _propTypes.default.string,
  enterDone: _propTypes.default.string,
  enterActive: _propTypes.default.string,
  exit: _propTypes.default.string,
  exitDone: _propTypes.default.string,
  exitActive: _propTypes.default.string
})]) : null;
exports.classNamesShape = classNamesShape;

/***/ }),
/* 857 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Badge.default;
  }
});

var _Badge = _interopRequireDefault(__webpack_require__(858));

/***/ }),
/* 858 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(8));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(11));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _classnames = _interopRequireDefault(__webpack_require__(6));

var _withStyles = _interopRequireDefault(__webpack_require__(5));

var _helpers = __webpack_require__(36);

var RADIUS = 12;

var styles = function styles(theme) {
  return {
    root: {
      position: 'relative',
      display: 'inline-flex',
      // For correct alignment with the text.
      verticalAlign: 'middle'
    },
    badge: {
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'wrap',
      justifyContent: 'center',
      alignContent: 'center',
      alignItems: 'center',
      position: 'absolute',
      top: -RADIUS,
      right: -RADIUS,
      fontFamily: theme.typography.fontFamily,
      fontWeight: theme.typography.fontWeight,
      fontSize: theme.typography.pxToRem(RADIUS),
      width: RADIUS * 2,
      height: RADIUS * 2,
      borderRadius: '50%',
      backgroundColor: theme.palette.color,
      color: theme.palette.textColor,
      zIndex: 1 // Render the badge on top of potential ripples.

    },
    colorPrimary: {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.primary.contrastText
    },
    colorSecondary: {
      backgroundColor: theme.palette.secondary.main,
      color: theme.palette.secondary.contrastText
    },
    colorError: {
      backgroundColor: theme.palette.error.main,
      color: theme.palette.error.contrastText
    }
  };
};

exports.styles = styles;

function Badge(props) {
  var badgeContent = props.badgeContent,
      children = props.children,
      classes = props.classes,
      classNameProp = props.className,
      color = props.color,
      ComponentProp = props.component,
      other = (0, _objectWithoutProperties2.default)(props, ["badgeContent", "children", "classes", "className", "color", "component"]);
  var badgeClassName = (0, _classnames.default)(classes.badge, (0, _defineProperty2.default)({}, classes["color".concat((0, _helpers.capitalize)(color))], color !== 'default'));
  return _react.default.createElement(ComponentProp, (0, _extends2.default)({
    className: (0, _classnames.default)(classes.root, classNameProp)
  }, other), children, _react.default.createElement("span", {
    className: badgeClassName
  }, badgeContent));
}

Badge.propTypes =  false ? {
  /**
   * The content rendered within the badge.
   */
  badgeContent: _propTypes.default.node.isRequired,

  /**
   * The badge will be added relative to this node.
   */
  children: _propTypes.default.node.isRequired,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: _propTypes.default.oneOf(['default', 'primary', 'secondary', 'error']),

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func])
} : {};
Badge.defaultProps = {
  color: 'default',
  component: 'span'
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiBadge'
})(Badge);

exports.default = _default;

/***/ }),
/* 859 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _BottomNavigation.default;
  }
});

var _BottomNavigation = _interopRequireDefault(__webpack_require__(860));

/***/ }),
/* 860 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(8));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _classnames = _interopRequireDefault(__webpack_require__(6));

var _withStyles = _interopRequireDefault(__webpack_require__(5));

var styles = function styles(theme) {
  return {
    root: {
      display: 'flex',
      justifyContent: 'center',
      height: 56,
      backgroundColor: theme.palette.background.paper
    }
  };
};

exports.styles = styles;

function BottomNavigation(props) {
  var childrenProp = props.children,
      classes = props.classes,
      classNameProp = props.className,
      onChange = props.onChange,
      showLabels = props.showLabels,
      value = props.value,
      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "onChange", "showLabels", "value"]);
  var className = (0, _classnames.default)(classes.root, classNameProp);

  var children = _react.default.Children.map(childrenProp, function (child, childIndex) {
    if (!_react.default.isValidElement(child)) {
      return null;
    }

    var childValue = child.props.value === undefined ? childIndex : child.props.value;
    return _react.default.cloneElement(child, {
      selected: childValue === value,
      showLabel: child.props.showLabel !== undefined ? child.props.showLabel : showLabels,
      value: childValue,
      onChange: onChange
    });
  });

  return _react.default.createElement("div", (0, _extends2.default)({
    className: className
  }, other), children);
}

BottomNavigation.propTypes =  false ? {
  /**
   * The content of the component.
   */
  children: _propTypes.default.node.isRequired,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * Callback fired when the value changes.
   *
   * @param {object} event The event source of the callback
   * @param {any} value We default to the index of the child
   */
  onChange: _propTypes.default.func,

  /**
   * If `true`, all `BottomNavigationAction`s will show their labels.
   * By default, only the selected `BottomNavigationAction` will show its label.
   */
  showLabels: _propTypes.default.bool,

  /**
   * The value of the currently selected `BottomNavigationAction`.
   */
  value: _propTypes.default.any
} : {};
BottomNavigation.defaultProps = {
  showLabels: false
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiBottomNavigation'
})(BottomNavigation);

exports.default = _default;

/***/ }),
/* 861 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _BottomNavigationAction.default;
  }
});

var _BottomNavigationAction = _interopRequireDefault(__webpack_require__(862));

/***/ }),
/* 862 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(8));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(11));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(18));

var _createClass2 = _interopRequireDefault(__webpack_require__(19));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(20));

var _inherits2 = _interopRequireDefault(__webpack_require__(21));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _classnames = _interopRequireDefault(__webpack_require__(6));

var _withStyles = _interopRequireDefault(__webpack_require__(5));

var _ButtonBase = _interopRequireDefault(__webpack_require__(70));

// @inheritedComponent ButtonBase
var styles = function styles(theme) {
  return {
    root: {
      transition: theme.transitions.create(['color', 'padding-top'], {
        duration: theme.transitions.duration.short
      }),
      paddingTop: theme.spacing.unit,
      paddingBottom: 10,
      paddingLeft: 12,
      paddingRight: 12,
      minWidth: 80,
      maxWidth: 168,
      color: theme.palette.text.secondary,
      flex: '1',
      '&$iconOnly': {
        paddingTop: theme.spacing.unit * 2
      },
      '&$selected': {
        paddingTop: 6,
        color: theme.palette.primary.main
      }
    },
    selected: {},
    iconOnly: {},
    wrapper: {
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '100%',
      flexDirection: 'column'
    },
    label: {
      fontFamily: theme.typography.fontFamily,
      fontSize: theme.typography.pxToRem(12),
      opacity: 1,
      transition: 'font-size 0.2s, opacity 0.2s',
      transitionDelay: '0.1s',
      '&$iconOnly': {
        opacity: 0,
        transitionDelay: '0s'
      },
      '&$selected': {
        fontSize: theme.typography.pxToRem(14)
      }
    }
  };
};

exports.styles = styles;

var BottomNavigationAction =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(BottomNavigationAction, _React$Component);

  function BottomNavigationAction() {
    var _ref;

    var _temp, _this;

    (0, _classCallCheck2.default)(this, BottomNavigationAction);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return (0, _possibleConstructorReturn2.default)(_this, (_temp = _this = (0, _possibleConstructorReturn2.default)(this, (_ref = BottomNavigationAction.__proto__ || Object.getPrototypeOf(BottomNavigationAction)).call.apply(_ref, [this].concat(args))), _this.handleChange = function (event) {
      var _this$props = _this.props,
          onChange = _this$props.onChange,
          value = _this$props.value,
          onClick = _this$props.onClick;

      if (onChange) {
        onChange(event, value);
      }

      if (onClick) {
        onClick(event);
      }
    }, _temp));
  }

  (0, _createClass2.default)(BottomNavigationAction, [{
    key: "render",
    value: function render() {
      var _classNames, _classNames2;

      var _props = this.props,
          classes = _props.classes,
          classNameProp = _props.className,
          icon = _props.icon,
          label = _props.label,
          onChange = _props.onChange,
          onClick = _props.onClick,
          selected = _props.selected,
          showLabelProp = _props.showLabel,
          value = _props.value,
          other = (0, _objectWithoutProperties2.default)(_props, ["classes", "className", "icon", "label", "onChange", "onClick", "selected", "showLabel", "value"]);
      var className = (0, _classnames.default)(classes.root, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes.selected, selected), (0, _defineProperty2.default)(_classNames, classes.iconOnly, !showLabelProp && !selected), _classNames), classNameProp);
      var labelClassName = (0, _classnames.default)(classes.label, (_classNames2 = {}, (0, _defineProperty2.default)(_classNames2, classes.selected, selected), (0, _defineProperty2.default)(_classNames2, classes.iconOnly, !showLabelProp && !selected), _classNames2));
      return _react.default.createElement(_ButtonBase.default, (0, _extends2.default)({
        className: className,
        focusRipple: true,
        onClick: this.handleChange
      }, other), _react.default.createElement("span", {
        className: classes.wrapper
      }, icon, _react.default.createElement("span", {
        className: labelClassName
      }, label)));
    }
  }]);
  return BottomNavigationAction;
}(_react.default.Component);

BottomNavigationAction.propTypes =  false ? {
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The icon element.
   */
  icon: _propTypes.default.node,

  /**
   * The label element.
   */
  label: _propTypes.default.node,

  /**
   * @ignore
   */
  onChange: _propTypes.default.func,

  /**
   * @ignore
   */
  onClick: _propTypes.default.func,

  /**
   * @ignore
   */
  selected: _propTypes.default.bool,

  /**
   * If `true`, the BottomNavigationAction will show its label.
   */
  showLabel: _propTypes.default.bool,

  /**
   * You can provide your own value. Otherwise, we fallback to the child position index.
   */
  value: _propTypes.default.any
} : {};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiBottomNavigationAction'
})(BottomNavigationAction);

exports.default = _default;

/***/ }),
/* 863 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(8));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(11));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(18));

var _createClass2 = _interopRequireDefault(__webpack_require__(19));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(20));

var _inherits2 = _interopRequireDefault(__webpack_require__(21));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(127));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _reactDom = _interopRequireDefault(__webpack_require__(45));

var _classnames = _interopRequireDefault(__webpack_require__(6));

var _keycode = _interopRequireDefault(__webpack_require__(133));

var _ownerWindow = _interopRequireDefault(__webpack_require__(217));

var _withStyles = _interopRequireDefault(__webpack_require__(5));

var _focusVisible = __webpack_require__(864);

var _TouchRipple = _interopRequireDefault(__webpack_require__(865));

var _createRippleHandler = _interopRequireDefault(__webpack_require__(872));

var styles = {
  root: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    // Remove grey highlight
    WebkitTapHighlightColor: 'transparent',
    backgroundColor: 'transparent',
    // Reset default value
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 'none',
    border: 0,
    margin: 0,
    // Remove the margin in Safari
    borderRadius: 0,
    padding: 0,
    // Remove the padding in Firefox
    cursor: 'pointer',
    userSelect: 'none',
    verticalAlign: 'middle',
    '-moz-appearance': 'none',
    // Reset
    '-webkit-appearance': 'none',
    // Reset
    textDecoration: 'none',
    // So we take precedent over the style of a native <a /> element.
    color: 'inherit',
    '&::-moz-focus-inner': {
      borderStyle: 'none' // Remove Firefox dotted outline.

    },
    '&$disabled': {
      pointerEvents: 'none',
      // Disable link interactions
      cursor: 'default'
    }
  },
  disabled: {},
  focusVisible: {}
};
/**
 * `ButtonBase` contains as few styles as possible.
 * It aims to be a simple building block for creating a button.
 * It contains a load of style reset and some focus/ripple logic.
 */

exports.styles = styles;

var ButtonBase =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(ButtonBase, _React$Component);

  function ButtonBase() {
    var _ref;

    var _temp, _this;

    (0, _classCallCheck2.default)(this, ButtonBase);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return (0, _possibleConstructorReturn2.default)(_this, (_temp = _this = (0, _possibleConstructorReturn2.default)(this, (_ref = ButtonBase.__proto__ || Object.getPrototypeOf(ButtonBase)).call.apply(_ref, [this].concat(args))), _this.state = {}, _this.onFocusVisibleHandler = function (event) {
      _this.keyDown = false;

      _this.setState({
        focusVisible: true
      });

      if (_this.props.onFocusVisible) {
        _this.props.onFocusVisible(event);
      }
    }, _this.onRippleRef = function (node) {
      _this.ripple = node;
    }, _this.ripple = null, _this.keyDown = false, _this.button = null, _this.focusVisibleTimeout = null, _this.focusVisibleCheckTime = 50, _this.focusVisibleMaxCheckTimes = 5, _this.handleKeyDown = function (event) {
      var _this$props = _this.props,
          component = _this$props.component,
          focusRipple = _this$props.focusRipple,
          onKeyDown = _this$props.onKeyDown,
          onClick = _this$props.onClick;
      var key = (0, _keycode.default)(event); // Check if key is already down to avoid repeats being counted as multiple activations

      if (focusRipple && !_this.keyDown && _this.state.focusVisible && _this.ripple && key === 'space') {
        _this.keyDown = true;
        event.persist();

        _this.ripple.stop(event, function () {
          _this.ripple.start(event);
        });
      }

      if (onKeyDown) {
        onKeyDown(event);
      } // Keyboard accessibility for non interactive elements


      if (event.target === event.currentTarget && component && component !== 'button' && (key === 'space' || key === 'enter') && !(_this.button.tagName === 'A' && _this.button.href)) {
        event.preventDefault();

        if (onClick) {
          onClick(event);
        }
      }
    }, _this.handleKeyUp = function (event) {
      if (_this.props.focusRipple && (0, _keycode.default)(event) === 'space' && _this.ripple && _this.state.focusVisible) {
        _this.keyDown = false;
        event.persist();

        _this.ripple.stop(event, function () {
          _this.ripple.pulsate(event);
        });
      }

      if (_this.props.onKeyUp) {
        _this.props.onKeyUp(event);
      }
    }, _this.handleMouseDown = (0, _createRippleHandler.default)((0, _assertThisInitialized2.default)(_this), 'MouseDown', 'start', function () {
      clearTimeout(_this.focusVisibleTimeout);

      if (_this.state.focusVisible) {
        _this.setState({
          focusVisible: false
        });
      }
    }), _this.handleMouseUp = (0, _createRippleHandler.default)((0, _assertThisInitialized2.default)(_this), 'MouseUp', 'stop'), _this.handleMouseLeave = (0, _createRippleHandler.default)((0, _assertThisInitialized2.default)(_this), 'MouseLeave', 'stop', function (event) {
      if (_this.state.focusVisible) {
        event.preventDefault();
      }
    }), _this.handleTouchStart = (0, _createRippleHandler.default)((0, _assertThisInitialized2.default)(_this), 'TouchStart', 'start'), _this.handleTouchEnd = (0, _createRippleHandler.default)((0, _assertThisInitialized2.default)(_this), 'TouchEnd', 'stop'), _this.handleTouchMove = (0, _createRippleHandler.default)((0, _assertThisInitialized2.default)(_this), 'TouchMove', 'stop'), _this.handleBlur = (0, _createRippleHandler.default)((0, _assertThisInitialized2.default)(_this), 'Blur', 'stop', function () {
      clearTimeout(_this.focusVisibleTimeout);

      if (_this.state.focusVisible) {
        _this.setState({
          focusVisible: false
        });
      }
    }), _this.handleFocus = function (event) {
      if (_this.props.disabled) {
        return;
      } // Fix for https://github.com/facebook/react/issues/7769


      if (!_this.button) {
        _this.button = event.currentTarget;
      }

      event.persist();
      (0, _focusVisible.detectFocusVisible)((0, _assertThisInitialized2.default)(_this), _this.button, function () {
        _this.onFocusVisibleHandler(event);
      });

      if (_this.props.onFocus) {
        _this.props.onFocus(event);
      }
    }, _temp));
  }

  (0, _createClass2.default)(ButtonBase, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      this.button = _reactDom.default.findDOMNode(this);
      (0, _focusVisible.listenForFocusKeys)((0, _ownerWindow.default)(this.button));

      if (this.props.action) {
        this.props.action({
          focusVisible: function focusVisible() {
            _this2.setState({
              focusVisible: true
            });

            _this2.button.focus();
          }
        });
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.props.focusRipple && !this.props.disableRipple && !prevState.focusVisible && this.state.focusVisible) {
        this.ripple.pulsate();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.button = null;
      clearTimeout(this.focusVisibleTimeout);
    }
  }, {
    key: "render",
    value: function render() {
      var _classNames;

      var _props = this.props,
          action = _props.action,
          buttonRef = _props.buttonRef,
          centerRipple = _props.centerRipple,
          children = _props.children,
          classes = _props.classes,
          classNameProp = _props.className,
          component = _props.component,
          disabled = _props.disabled,
          disableRipple = _props.disableRipple,
          focusRipple = _props.focusRipple,
          focusVisibleClassName = _props.focusVisibleClassName,
          onBlur = _props.onBlur,
          onFocus = _props.onFocus,
          onFocusVisible = _props.onFocusVisible,
          onKeyDown = _props.onKeyDown,
          onKeyUp = _props.onKeyUp,
          onMouseDown = _props.onMouseDown,
          onMouseLeave = _props.onMouseLeave,
          onMouseUp = _props.onMouseUp,
          onTouchEnd = _props.onTouchEnd,
          onTouchMove = _props.onTouchMove,
          onTouchStart = _props.onTouchStart,
          tabIndex = _props.tabIndex,
          TouchRippleProps = _props.TouchRippleProps,
          type = _props.type,
          other = (0, _objectWithoutProperties2.default)(_props, ["action", "buttonRef", "centerRipple", "children", "classes", "className", "component", "disabled", "disableRipple", "focusRipple", "focusVisibleClassName", "onBlur", "onFocus", "onFocusVisible", "onKeyDown", "onKeyUp", "onMouseDown", "onMouseLeave", "onMouseUp", "onTouchEnd", "onTouchMove", "onTouchStart", "tabIndex", "TouchRippleProps", "type"]);
      var className = (0, _classnames.default)(classes.root, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes.disabled, disabled), (0, _defineProperty2.default)(_classNames, classes.focusVisible, this.state.focusVisible), (0, _defineProperty2.default)(_classNames, focusVisibleClassName, this.state.focusVisible), _classNames), classNameProp);
      var buttonProps = {};
      var ComponentProp = component;

      if (ComponentProp === 'button' && other.href) {
        ComponentProp = 'a';
      }

      if (ComponentProp === 'button') {
        buttonProps.type = type || 'button';
        buttonProps.disabled = disabled;
      } else {
        buttonProps.role = 'button';
      }

      return _react.default.createElement(ComponentProp, (0, _extends2.default)({
        onBlur: this.handleBlur,
        onFocus: this.handleFocus,
        onKeyDown: this.handleKeyDown,
        onKeyUp: this.handleKeyUp,
        onMouseDown: this.handleMouseDown,
        onMouseLeave: this.handleMouseLeave,
        onMouseUp: this.handleMouseUp,
        onTouchEnd: this.handleTouchEnd,
        onTouchMove: this.handleTouchMove,
        onTouchStart: this.handleTouchStart,
        tabIndex: disabled ? '-1' : tabIndex,
        className: className,
        ref: buttonRef
      }, buttonProps, other), children, !disableRipple && !disabled ? _react.default.createElement(_TouchRipple.default, (0, _extends2.default)({
        innerRef: this.onRippleRef,
        center: centerRipple
      }, TouchRippleProps)) : null);
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      if (typeof prevState.focusVisible === 'undefined') {
        return {
          focusVisible: false,
          lastDisabled: nextProps.disabled
        };
      } // The blur won't fire when the disabled state is set on a focused input.
      // We need to book keep the focused state manually.


      if (!prevState.prevState && nextProps.disabled && prevState.focusVisible) {
        return {
          focusVisible: false,
          lastDisabled: nextProps.disabled
        };
      }

      return {
        lastDisabled: nextProps.disabled
      };
    }
  }]);
  return ButtonBase;
}(_react.default.Component);

ButtonBase.propTypes =  false ? {
  /**
   * Callback fired when the component mounts.
   * This is useful when you want to trigger an action programmatically.
   * It currently only supports `focusVisible()` action.
   *
   * @param {object} actions This object contains all possible actions
   * that can be triggered programmatically.
   */
  action: _propTypes.default.func,

  /**
   * Use that property to pass a ref callback to the native button component.
   */
  buttonRef: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.object]),

  /**
   * If `true`, the ripples will be centered.
   * They won't start at the cursor interaction position.
   */
  centerRipple: _propTypes.default.bool,

  /**
   * The content of the component.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func]),

  /**
   * If `true`, the base button will be disabled.
   */
  disabled: _propTypes.default.bool,

  /**
   * If `true`, the ripple effect will be disabled.
   */
  disableRipple: _propTypes.default.bool,

  /**
   * If `true`, the base button will have a keyboard focus ripple.
   * `disableRipple` must also be `false`.
   */
  focusRipple: _propTypes.default.bool,

  /**
   * This property can help a person know which element has the keyboard focus.
   * The class name will be applied when the element gain the focus throught a keyboard interaction.
   * It's a polyfill for the [CSS :focus-visible feature](https://drafts.csswg.org/selectors-4/#the-focus-visible-pseudo).
   * The rational for using this feature [is explain here](https://github.com/WICG/focus-visible/blob/master/explainer.md).
   */
  focusVisibleClassName: _propTypes.default.string,

  /**
   * @ignore
   */
  onBlur: _propTypes.default.func,

  /**
   * @ignore
   */
  onClick: _propTypes.default.func,

  /**
   * @ignore
   */
  onFocus: _propTypes.default.func,

  /**
   * Callback fired when the component is focused with a keyboard.
   * We trigger a `onFocus` callback too.
   */
  onFocusVisible: _propTypes.default.func,

  /**
   * @ignore
   */
  onKeyDown: _propTypes.default.func,

  /**
   * @ignore
   */
  onKeyUp: _propTypes.default.func,

  /**
   * @ignore
   */
  onMouseDown: _propTypes.default.func,

  /**
   * @ignore
   */
  onMouseLeave: _propTypes.default.func,

  /**
   * @ignore
   */
  onMouseUp: _propTypes.default.func,

  /**
   * @ignore
   */
  onTouchEnd: _propTypes.default.func,

  /**
   * @ignore
   */
  onTouchMove: _propTypes.default.func,

  /**
   * @ignore
   */
  onTouchStart: _propTypes.default.func,

  /**
   * @ignore
   */
  role: _propTypes.default.string,

  /**
   * @ignore
   */
  tabIndex: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),

  /**
   * Properties applied to the `TouchRipple` element.
   */
  TouchRippleProps: _propTypes.default.object,

  /**
   * @ignore
   */
  type: _propTypes.default.string
} : {};
ButtonBase.defaultProps = {
  centerRipple: false,
  component: 'button',
  disableRipple: false,
  focusRipple: false,
  tabIndex: '0',
  type: 'button'
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiButtonBase'
})(ButtonBase);

exports.default = _default;

/***/ }),
/* 864 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.detectFocusVisible = detectFocusVisible;
exports.listenForFocusKeys = listenForFocusKeys;

var _keycode = _interopRequireDefault(__webpack_require__(133));

var _warning = _interopRequireDefault(__webpack_require__(32));

var _contains = _interopRequireDefault(__webpack_require__(218));

var _ownerDocument = _interopRequireDefault(__webpack_require__(71));

//  weak
var internal = {
  focusKeyPressed: false,
  keyUpEventTimeout: -1
};

function detectFocusVisible(instance, element, callback) {
  var attempt = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
   false ? (0, _warning.default)(instance.focusVisibleCheckTime, 'Material-UI: missing instance.focusVisibleCheckTime.') : void 0;
   false ? (0, _warning.default)(instance.focusVisibleMaxCheckTimes, 'Material-UI: missing instance.focusVisibleMaxCheckTimes.') : void 0;
  instance.focusVisibleTimeout = setTimeout(function () {
    var doc = (0, _ownerDocument.default)(element);

    if (internal.focusKeyPressed && (doc.activeElement === element || (0, _contains.default)(element, doc.activeElement))) {
      callback();
    } else if (attempt < instance.focusVisibleMaxCheckTimes) {
      detectFocusVisible(instance, element, callback, attempt + 1);
    }
  }, instance.focusVisibleCheckTime);
}

var FOCUS_KEYS = ['tab', 'enter', 'space', 'esc', 'up', 'down', 'left', 'right'];

function isFocusKey(event) {
  return FOCUS_KEYS.indexOf((0, _keycode.default)(event)) > -1;
}

var handleKeyUpEvent = function handleKeyUpEvent(event) {
  if (isFocusKey(event)) {
    internal.focusKeyPressed = true; // Let's consider that the user is using a keyboard during a window frame of 1s.

    clearTimeout(internal.keyUpEventTimeout);
    internal.keyUpEventTimeout = setTimeout(function () {
      internal.focusKeyPressed = false;
    }, 1e3);
  }
};

function listenForFocusKeys(win) {
  // The event listener will only be added once per window.
  // Duplicate event listeners will be ignored by addEventListener.
  // Also, this logic is client side only, we don't need a teardown.
  win.addEventListener('keyup', handleKeyUpEvent);
}

/***/ }),
/* 865 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = exports.DELAY_RIPPLE = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(8));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(219));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(18));

var _createClass2 = _interopRequireDefault(__webpack_require__(19));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(20));

var _inherits2 = _interopRequireDefault(__webpack_require__(21));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(127));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _reactDom = _interopRequireDefault(__webpack_require__(45));

var _TransitionGroup = _interopRequireDefault(__webpack_require__(869));

var _classnames = _interopRequireDefault(__webpack_require__(6));

var _withStyles = _interopRequireDefault(__webpack_require__(5));

var _Ripple = _interopRequireDefault(__webpack_require__(871));

var DURATION = 550;
var DELAY_RIPPLE = 80;
exports.DELAY_RIPPLE = DELAY_RIPPLE;

var styles = function styles(theme) {
  return {
    root: {
      display: 'block',
      position: 'absolute',
      overflow: 'hidden',
      borderRadius: 'inherit',
      width: '100%',
      height: '100%',
      left: 0,
      top: 0,
      pointerEvents: 'none',
      zIndex: 0
    },
    ripple: {
      width: 50,
      height: 50,
      left: 0,
      top: 0,
      opacity: 0,
      position: 'absolute'
    },
    rippleVisible: {
      opacity: 0.3,
      transform: 'scale(1)',
      animation: "mui-ripple-enter ".concat(DURATION, "ms ").concat(theme.transitions.easing.easeInOut)
    },
    ripplePulsate: {
      animationDuration: "".concat(theme.transitions.duration.shorter, "ms")
    },
    child: {
      opacity: 1,
      display: 'block',
      width: '100%',
      height: '100%',
      borderRadius: '50%',
      backgroundColor: 'currentColor'
    },
    childLeaving: {
      opacity: 0,
      animation: "mui-ripple-exit ".concat(DURATION, "ms ").concat(theme.transitions.easing.easeInOut)
    },
    childPulsate: {
      position: 'absolute',
      left: 0,
      top: 0,
      animation: "mui-ripple-pulsate 2500ms ".concat(theme.transitions.easing.easeInOut, " 200ms infinite")
    },
    '@keyframes mui-ripple-enter': {
      '0%': {
        transform: 'scale(0)',
        opacity: 0.1
      },
      '100%': {
        transform: 'scale(1)',
        opacity: 0.3
      }
    },
    '@keyframes mui-ripple-exit': {
      '0%': {
        opacity: 1
      },
      '100%': {
        opacity: 0
      }
    },
    '@keyframes mui-ripple-pulsate': {
      '0%': {
        transform: 'scale(1)'
      },
      '50%': {
        transform: 'scale(0.92)'
      },
      '100%': {
        transform: 'scale(1)'
      }
    }
  };
};

exports.styles = styles;

var TouchRipple =
/*#__PURE__*/
function (_React$PureComponent) {
  (0, _inherits2.default)(TouchRipple, _React$PureComponent);

  function TouchRipple() {
    var _ref;

    var _temp, _this;

    (0, _classCallCheck2.default)(this, TouchRipple);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return (0, _possibleConstructorReturn2.default)(_this, (_temp = _this = (0, _possibleConstructorReturn2.default)(this, (_ref = TouchRipple.__proto__ || Object.getPrototypeOf(TouchRipple)).call.apply(_ref, [this].concat(args))), _this.state = {
      nextKey: 0,
      ripples: []
    }, _this.ignoringMouseDown = false, _this.startTimer = null, _this.startTimerCommit = null, _this.pulsate = function () {
      _this.start({}, {
        pulsate: true
      });
    }, _this.start = function () {
      var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var cb = arguments.length > 2 ? arguments[2] : undefined;
      var _options$pulsate = options.pulsate,
          pulsate = _options$pulsate === void 0 ? false : _options$pulsate,
          _options$center = options.center,
          center = _options$center === void 0 ? _this.props.center || options.pulsate : _options$center,
          _options$fakeElement = options.fakeElement,
          fakeElement = _options$fakeElement === void 0 ? false : _options$fakeElement;

      if (event.type === 'mousedown' && _this.ignoringMouseDown) {
        _this.ignoringMouseDown = false;
        return;
      }

      if (event.type === 'touchstart') {
        _this.ignoringMouseDown = true;
      }

      var element = fakeElement ? null : _reactDom.default.findDOMNode((0, _assertThisInitialized2.default)(_this));
      var rect = element ? element.getBoundingClientRect() : {
        width: 0,
        height: 0,
        left: 0,
        top: 0
      }; // Get the size of the ripple

      var rippleX;
      var rippleY;
      var rippleSize;

      if (center || event.clientX === 0 && event.clientY === 0 || !event.clientX && !event.touches) {
        rippleX = Math.round(rect.width / 2);
        rippleY = Math.round(rect.height / 2);
      } else {
        var clientX = event.clientX ? event.clientX : event.touches[0].clientX;
        var clientY = event.clientY ? event.clientY : event.touches[0].clientY;
        rippleX = Math.round(clientX - rect.left);
        rippleY = Math.round(clientY - rect.top);
      }

      if (center) {
        rippleSize = Math.sqrt((2 * Math.pow(rect.width, 2) + Math.pow(rect.height, 2)) / 3); // For some reason the animation is broken on Mobile Chrome if the size if even.

        if (rippleSize % 2 === 0) {
          rippleSize += 1;
        }
      } else {
        var sizeX = Math.max(Math.abs((element ? element.clientWidth : 0) - rippleX), rippleX) * 2 + 2;
        var sizeY = Math.max(Math.abs((element ? element.clientHeight : 0) - rippleY), rippleY) * 2 + 2;
        rippleSize = Math.sqrt(Math.pow(sizeX, 2) + Math.pow(sizeY, 2));
      } // Touche devices


      if (event.touches) {
        // Prepare the ripple effect.
        _this.startTimerCommit = function () {
          _this.startCommit({
            pulsate: pulsate,
            rippleX: rippleX,
            rippleY: rippleY,
            rippleSize: rippleSize,
            cb: cb
          });
        }; // Deplay the execution of the ripple effect.


        _this.startTimer = setTimeout(function () {
          _this.startTimerCommit();

          _this.startTimerCommit = null;
        }, DELAY_RIPPLE); // We have to make a tradeoff with this value.
      } else {
        _this.startCommit({
          pulsate: pulsate,
          rippleX: rippleX,
          rippleY: rippleY,
          rippleSize: rippleSize,
          cb: cb
        });
      }
    }, _this.startCommit = function (params) {
      var pulsate = params.pulsate,
          rippleX = params.rippleX,
          rippleY = params.rippleY,
          rippleSize = params.rippleSize,
          cb = params.cb;
      var ripples = _this.state.ripples; // Add a ripple to the ripples array.

      ripples = (0, _toConsumableArray2.default)(ripples).concat([_react.default.createElement(_Ripple.default, {
        key: _this.state.nextKey,
        classes: _this.props.classes,
        timeout: {
          exit: DURATION,
          enter: DURATION
        },
        pulsate: pulsate,
        rippleX: rippleX,
        rippleY: rippleY,
        rippleSize: rippleSize
      })]);

      _this.setState({
        nextKey: _this.state.nextKey + 1,
        ripples: ripples
      }, cb);
    }, _this.stop = function (event, cb) {
      clearTimeout(_this.startTimer);
      var ripples = _this.state.ripples; // The touch interaction occures to quickly.
      // We still want to show ripple effect.

      if (event.type === 'touchend' && _this.startTimerCommit) {
        event.persist();

        _this.startTimerCommit();

        _this.startTimerCommit = null;
        _this.startTimer = setTimeout(function () {
          _this.stop(event, cb);
        }, 0);
        return;
      }

      _this.startTimerCommit = null;

      if (ripples && ripples.length) {
        _this.setState({
          ripples: ripples.slice(1)
        }, cb);
      }
    }, _temp));
  }

  (0, _createClass2.default)(TouchRipple, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearTimeout(this.startTimer);
    } // Used to filter out mouse emulated events on mobile.

  }, {
    key: "render",
    value: function render() {
      var _props = this.props,
          center = _props.center,
          classes = _props.classes,
          className = _props.className,
          other = (0, _objectWithoutProperties2.default)(_props, ["center", "classes", "className"]);
      return _react.default.createElement(_TransitionGroup.default, (0, _extends2.default)({
        component: "span",
        enter: true,
        exit: true,
        className: (0, _classnames.default)(classes.root, className)
      }, other), this.state.ripples);
    }
  }]);
  return TouchRipple;
}(_react.default.PureComponent);

TouchRipple.propTypes =  false ? {
  /**
   * If `true`, the ripple starts at the center of the component
   * rather than at the point of interaction.
   */
  center: _propTypes.default.bool,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string
} : {};
TouchRipple.defaultProps = {
  center: false
};

var _default = (0, _withStyles.default)(styles, {
  flip: false,
  name: 'MuiTouchRipple'
})(TouchRipple);

exports.default = _default;

/***/ }),
/* 866 */
/***/ (function(module, exports) {

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}

module.exports = _arrayWithoutHoles;

/***/ }),
/* 867 */
/***/ (function(module, exports) {

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

module.exports = _iterableToArray;

/***/ }),
/* 868 */
/***/ (function(module, exports) {

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

module.exports = _nonIterableSpread;

/***/ }),
/* 869 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactLifecyclesCompat = __webpack_require__(104);

var _ChildMapping = __webpack_require__(870);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

var values = Object.values || function (obj) {
  return Object.keys(obj).map(function (k) {
    return obj[k];
  });
};

var defaultProps = {
  component: 'div',
  childFactory: function childFactory(child) {
    return child;
  }
  /**
   * The `<TransitionGroup>` component manages a set of transition components
   * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
   * components, `<TransitionGroup>` is a state machine for managing the mounting
   * and unmounting of components over time.
   *
   * Consider the example below. As items are removed or added to the TodoList the
   * `in` prop is toggled automatically by the `<TransitionGroup>`.
   *
   * Note that `<TransitionGroup>`  does not define any animation behavior!
   * Exactly _how_ a list item animates is up to the individual transition
   * component. This means you can mix and match animations across different list
   * items.
   */

};

var TransitionGroup =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(TransitionGroup, _React$Component);

  function TransitionGroup(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;

    var handleExited = _this.handleExited.bind(_assertThisInitialized(_assertThisInitialized(_this))); // Initial children should all be entering, dependent on appear


    _this.state = {
      handleExited: handleExited,
      firstRender: true
    };
    return _this;
  }

  var _proto = TransitionGroup.prototype;

  _proto.getChildContext = function getChildContext() {
    return {
      transitionGroup: {
        isMounting: !this.appeared
      }
    };
  };

  _proto.componentDidMount = function componentDidMount() {
    this.appeared = true;
    this.mounted = true;
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.mounted = false;
  };

  TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
    var prevChildMapping = _ref.children,
        handleExited = _ref.handleExited,
        firstRender = _ref.firstRender;
    return {
      children: firstRender ? (0, _ChildMapping.getInitialChildMapping)(nextProps, handleExited) : (0, _ChildMapping.getNextChildMapping)(nextProps, prevChildMapping, handleExited),
      firstRender: false
    };
  };

  _proto.handleExited = function handleExited(child, node) {
    var currentChildMapping = (0, _ChildMapping.getChildMapping)(this.props.children);
    if (child.key in currentChildMapping) return;

    if (child.props.onExited) {
      child.props.onExited(node);
    }

    if (this.mounted) {
      this.setState(function (state) {
        var children = _extends({}, state.children);

        delete children[child.key];
        return {
          children: children
        };
      });
    }
  };

  _proto.render = function render() {
    var _this$props = this.props,
        Component = _this$props.component,
        childFactory = _this$props.childFactory,
        props = _objectWithoutPropertiesLoose(_this$props, ["component", "childFactory"]);

    var children = values(this.state.children).map(childFactory);
    delete props.appear;
    delete props.enter;
    delete props.exit;

    if (Component === null) {
      return children;
    }

    return _react.default.createElement(Component, props, children);
  };

  return TransitionGroup;
}(_react.default.Component);

TransitionGroup.childContextTypes = {
  transitionGroup: _propTypes.default.object.isRequired
};
TransitionGroup.propTypes =  false ? {
  /**
   * `<TransitionGroup>` renders a `<div>` by default. You can change this
   * behavior by providing a `component` prop.
   * If you use React v16+ and would like to avoid a wrapping `<div>` element
   * you can pass in `component={null}`. This is useful if the wrapping div
   * borks your css styles.
   */
  component: _propTypes.default.any,

  /**
   * A set of `<Transition>` components, that are toggled `in` and out as they
   * leave. the `<TransitionGroup>` will inject specific transition props, so
   * remember to spread them through if you are wrapping the `<Transition>` as
   * with our `<Fade>` example.
   */
  children: _propTypes.default.node,

  /**
   * A convenience prop that enables or disables appear animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  appear: _propTypes.default.bool,

  /**
   * A convenience prop that enables or disables enter animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  enter: _propTypes.default.bool,

  /**
   * A convenience prop that enables or disables exit animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  exit: _propTypes.default.bool,

  /**
   * You may need to apply reactive updates to a child as it is exiting.
   * This is generally done by using `cloneElement` however in the case of an exiting
   * child the element has already been removed and not accessible to the consumer.
   *
   * If you do need to update a child as it leaves you can provide a `childFactory`
   * to wrap every child, even the ones that are leaving.
   *
   * @type Function(child: ReactElement) -> ReactElement
   */
  childFactory: _propTypes.default.func
} : {};
TransitionGroup.defaultProps = defaultProps;

var _default = (0, _reactLifecyclesCompat.polyfill)(TransitionGroup);

exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 870 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.getChildMapping = getChildMapping;
exports.mergeChildMappings = mergeChildMappings;
exports.getInitialChildMapping = getInitialChildMapping;
exports.getNextChildMapping = getNextChildMapping;

var _react = __webpack_require__(0);

/**
 * Given `this.props.children`, return an object mapping key to child.
 *
 * @param {*} children `this.props.children`
 * @return {object} Mapping of key to child
 */
function getChildMapping(children, mapFn) {
  var mapper = function mapper(child) {
    return mapFn && (0, _react.isValidElement)(child) ? mapFn(child) : child;
  };

  var result = Object.create(null);
  if (children) _react.Children.map(children, function (c) {
    return c;
  }).forEach(function (child) {
    // run the map function here instead so that the key is the computed one
    result[child.key] = mapper(child);
  });
  return result;
}
/**
 * When you're adding or removing children some may be added or removed in the
 * same render pass. We want to show *both* since we want to simultaneously
 * animate elements in and out. This function takes a previous set of keys
 * and a new set of keys and merges them with its best guess of the correct
 * ordering. In the future we may expose some of the utilities in
 * ReactMultiChild to make this easy, but for now React itself does not
 * directly have this concept of the union of prevChildren and nextChildren
 * so we implement it here.
 *
 * @param {object} prev prev children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @param {object} next next children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @return {object} a key set that contains all keys in `prev` and all keys
 * in `next` in a reasonable order.
 */


function mergeChildMappings(prev, next) {
  prev = prev || {};
  next = next || {};

  function getValueForKey(key) {
    return key in next ? next[key] : prev[key];
  } // For each key of `next`, the list of keys to insert before that key in
  // the combined list


  var nextKeysPending = Object.create(null);
  var pendingKeys = [];

  for (var prevKey in prev) {
    if (prevKey in next) {
      if (pendingKeys.length) {
        nextKeysPending[prevKey] = pendingKeys;
        pendingKeys = [];
      }
    } else {
      pendingKeys.push(prevKey);
    }
  }

  var i;
  var childMapping = {};

  for (var nextKey in next) {
    if (nextKeysPending[nextKey]) {
      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
        var pendingNextKey = nextKeysPending[nextKey][i];
        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
      }
    }

    childMapping[nextKey] = getValueForKey(nextKey);
  } // Finally, add the keys which didn't appear before any key in `next`


  for (i = 0; i < pendingKeys.length; i++) {
    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
  }

  return childMapping;
}

function getProp(child, prop, props) {
  return props[prop] != null ? props[prop] : child.props[prop];
}

function getInitialChildMapping(props, onExited) {
  return getChildMapping(props.children, function (child) {
    return (0, _react.cloneElement)(child, {
      onExited: onExited.bind(null, child),
      in: true,
      appear: getProp(child, 'appear', props),
      enter: getProp(child, 'enter', props),
      exit: getProp(child, 'exit', props)
    });
  });
}

function getNextChildMapping(nextProps, prevChildMapping, onExited) {
  var nextChildMapping = getChildMapping(nextProps.children);
  var children = mergeChildMappings(prevChildMapping, nextChildMapping);
  Object.keys(children).forEach(function (key) {
    var child = children[key];
    if (!(0, _react.isValidElement)(child)) return;
    var hasPrev = key in prevChildMapping;
    var hasNext = key in nextChildMapping;
    var prevChild = prevChildMapping[key];
    var isLeaving = (0, _react.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)

    if (hasNext && (!hasPrev || isLeaving)) {
      // console.log('entering', key)
      children[key] = (0, _react.cloneElement)(child, {
        onExited: onExited.bind(null, child),
        in: true,
        exit: getProp(child, 'exit', nextProps),
        enter: getProp(child, 'enter', nextProps)
      });
    } else if (!hasNext && hasPrev && !isLeaving) {
      // item is old (exiting)
      // console.log('leaving', key)
      children[key] = (0, _react.cloneElement)(child, {
        in: false
      });
    } else if (hasNext && hasPrev && (0, _react.isValidElement)(prevChild)) {
      // item hasn't changed transition states
      // copy over the last transition props;
      // console.log('unchanged', key)
      children[key] = (0, _react.cloneElement)(child, {
        onExited: onExited.bind(null, child),
        in: prevChild.props.in,
        exit: getProp(child, 'exit', nextProps),
        enter: getProp(child, 'enter', nextProps)
      });
    }
  });
  return children;
}

/***/ }),
/* 871 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(8));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(11));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(18));

var _createClass2 = _interopRequireDefault(__webpack_require__(19));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(20));

var _inherits2 = _interopRequireDefault(__webpack_require__(21));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _classnames = _interopRequireDefault(__webpack_require__(6));

var _Transition = _interopRequireDefault(__webpack_require__(131));

/**
 * @ignore - internal component.
 */
var Ripple =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(Ripple, _React$Component);

  function Ripple() {
    var _ref;

    var _temp, _this;

    (0, _classCallCheck2.default)(this, Ripple);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return (0, _possibleConstructorReturn2.default)(_this, (_temp = _this = (0, _possibleConstructorReturn2.default)(this, (_ref = Ripple.__proto__ || Object.getPrototypeOf(Ripple)).call.apply(_ref, [this].concat(args))), _this.state = {
      visible: false,
      leaving: false
    }, _this.handleEnter = function () {
      _this.setState({
        visible: true
      });
    }, _this.handleExit = function () {
      _this.setState({
        leaving: true
      });
    }, _temp));
  }

  (0, _createClass2.default)(Ripple, [{
    key: "render",
    value: function render() {
      var _classNames, _classNames2;

      var _props = this.props,
          classes = _props.classes,
          classNameProp = _props.className,
          pulsate = _props.pulsate,
          rippleX = _props.rippleX,
          rippleY = _props.rippleY,
          rippleSize = _props.rippleSize,
          other = (0, _objectWithoutProperties2.default)(_props, ["classes", "className", "pulsate", "rippleX", "rippleY", "rippleSize"]);
      var _state = this.state,
          visible = _state.visible,
          leaving = _state.leaving;
      var rippleClassName = (0, _classnames.default)(classes.ripple, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes.rippleVisible, visible), (0, _defineProperty2.default)(_classNames, classes.ripplePulsate, pulsate), _classNames), classNameProp);
      var rippleStyles = {
        width: rippleSize,
        height: rippleSize,
        top: -(rippleSize / 2) + rippleY,
        left: -(rippleSize / 2) + rippleX
      };
      var childClassName = (0, _classnames.default)(classes.child, (_classNames2 = {}, (0, _defineProperty2.default)(_classNames2, classes.childLeaving, leaving), (0, _defineProperty2.default)(_classNames2, classes.childPulsate, pulsate), _classNames2));
      return _react.default.createElement(_Transition.default, (0, _extends2.default)({
        onEnter: this.handleEnter,
        onExit: this.handleExit
      }, other), _react.default.createElement("span", {
        className: rippleClassName,
        style: rippleStyles
      }, _react.default.createElement("span", {
        className: childClassName
      })));
    }
  }]);
  return Ripple;
}(_react.default.Component);

Ripple.propTypes =  false ? {
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * If `true`, the ripple pulsates, typically indicating the keyboard focus state of an element.
   */
  pulsate: _propTypes.default.bool,

  /**
   * Diameter of the ripple.
   */
  rippleSize: _propTypes.default.number,

  /**
   * Horizontal position of the ripple center.
   */
  rippleX: _propTypes.default.number,

  /**
   * Vertical position of the ripple center.
   */
  rippleY: _propTypes.default.number
} : {};
Ripple.defaultProps = {
  pulsate: false
};
var _default = Ripple;
exports.default = _default;

/***/ }),
/* 872 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function createRippleHandler(instance, eventName, action, cb) {
  return function handleEvent(event) {
    if (cb) {
      cb.call(instance, event);
    }

    if (event.defaultPrevented) {
      return false;
    }

    if (instance.ripple) {
      instance.ripple[action](event);
    }

    if (instance.props && typeof instance.props["on".concat(eventName)] === 'function') {
      instance.props["on".concat(eventName)](event);
    }

    return true;
  };
}

var _default = createRippleHandler;
exports.default = _default;

/***/ }),
/* 873 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(8));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(11));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _objectSpread2 = _interopRequireDefault(__webpack_require__(23));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _classnames = _interopRequireDefault(__webpack_require__(6));

var _withStyles = _interopRequireDefault(__webpack_require__(5));

var _colorManipulator = __webpack_require__(90);

var _ButtonBase = _interopRequireDefault(__webpack_require__(70));

var _helpers = __webpack_require__(36);

// @inheritedComponent ButtonBase
var styles = function styles(theme) {
  return {
    root: (0, _objectSpread2.default)({}, theme.typography.button, {
      lineHeight: '1.4em',
      // Improve readability for multiline button.
      boxSizing: 'border-box',
      minWidth: theme.spacing.unit * 11,
      minHeight: 36,
      padding: "".concat(theme.spacing.unit, "px ").concat(theme.spacing.unit * 2, "px"),
      borderRadius: 4,
      color: theme.palette.text.primary,
      transition: theme.transitions.create(['background-color', 'box-shadow'], {
        duration: theme.transitions.duration.short
      }),
      '&:hover': {
        textDecoration: 'none',
        backgroundColor: (0, _colorManipulator.fade)(theme.palette.text.primary, theme.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        },
        '&$disabled': {
          backgroundColor: 'transparent'
        }
      },
      '&$disabled': {
        color: theme.palette.action.disabled
      }
    }),
    label: {
      width: '100%',
      display: 'inherit',
      alignItems: 'inherit',
      justifyContent: 'inherit'
    },
    textPrimary: {
      color: theme.palette.primary.main,
      '&:hover': {
        backgroundColor: (0, _colorManipulator.fade)(theme.palette.primary.main, theme.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        }
      }
    },
    textSecondary: {
      color: theme.palette.secondary.main,
      '&:hover': {
        backgroundColor: (0, _colorManipulator.fade)(theme.palette.secondary.main, theme.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        }
      }
    },
    flat: {},
    flatPrimary: {},
    flatSecondary: {},
    outlined: {
      border: "1px solid ".concat(theme.palette.type === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)')
    },
    colorInherit: {
      color: 'inherit'
    },
    contained: {
      color: theme.palette.getContrastText(theme.palette.grey[300]),
      backgroundColor: theme.palette.grey[300],
      boxShadow: theme.shadows[2],
      '&$focusVisible': {
        boxShadow: theme.shadows[6]
      },
      '&:active': {
        boxShadow: theme.shadows[8]
      },
      '&$disabled': {
        color: theme.palette.action.disabled,
        boxShadow: theme.shadows[0],
        backgroundColor: theme.palette.action.disabledBackground
      },
      '&:hover': {
        backgroundColor: theme.palette.grey.A100,
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: theme.palette.grey[300]
        },
        '&$disabled': {
          backgroundColor: theme.palette.action.disabledBackground
        }
      }
    },
    containedPrimary: {
      color: theme.palette.primary.contrastText,
      backgroundColor: theme.palette.primary.main,
      '&:hover': {
        backgroundColor: theme.palette.primary.dark,
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: theme.palette.primary.main
        }
      }
    },
    containedSecondary: {
      color: theme.palette.secondary.contrastText,
      backgroundColor: theme.palette.secondary.main,
      '&:hover': {
        backgroundColor: theme.palette.secondary.dark,
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: theme.palette.secondary.main
        }
      }
    },
    raised: {},
    raisedPrimary: {},
    raisedSecondary: {},
    focusVisible: {},
    disabled: {},
    fab: {
      borderRadius: '50%',
      padding: 0,
      minWidth: 0,
      width: 56,
      fontSize: 24,
      height: 56,
      boxShadow: theme.shadows[6],
      '&:active': {
        boxShadow: theme.shadows[12]
      }
    },
    mini: {
      width: 40,
      height: 40
    },
    sizeSmall: {
      padding: "".concat(theme.spacing.unit - 1, "px ").concat(theme.spacing.unit, "px"),
      minWidth: theme.spacing.unit * 8,
      minHeight: 32,
      fontSize: theme.typography.pxToRem(13)
    },
    sizeLarge: {
      padding: "".concat(theme.spacing.unit, "px ").concat(theme.spacing.unit * 3, "px"),
      minWidth: theme.spacing.unit * 14,
      minHeight: 40,
      fontSize: theme.typography.pxToRem(15)
    },
    fullWidth: {
      width: '100%'
    }
  };
};

exports.styles = styles;

function Button(props) {
  var _classNames;

  var children = props.children,
      classes = props.classes,
      classNameProp = props.className,
      color = props.color,
      disabled = props.disabled,
      disableFocusRipple = props.disableFocusRipple,
      fullWidth = props.fullWidth,
      focusVisibleClassName = props.focusVisibleClassName,
      mini = props.mini,
      size = props.size,
      variant = props.variant,
      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "color", "disabled", "disableFocusRipple", "fullWidth", "focusVisibleClassName", "mini", "size", "variant"]);
  var fab = variant === 'fab';
  var contained = variant === 'contained' || variant === 'raised';
  var text = !contained && !fab;
  var className = (0, _classnames.default)(classes.root, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes.contained, contained || fab), (0, _defineProperty2.default)(_classNames, classes.fab, fab), (0, _defineProperty2.default)(_classNames, classes.mini, fab && mini), (0, _defineProperty2.default)(_classNames, classes.colorInherit, color === 'inherit'), (0, _defineProperty2.default)(_classNames, classes.textPrimary, text && color === 'primary'), (0, _defineProperty2.default)(_classNames, classes.textSecondary, text && color === 'secondary'), (0, _defineProperty2.default)(_classNames, classes.flat, text), (0, _defineProperty2.default)(_classNames, classes.flatPrimary, text && color === 'primary'), (0, _defineProperty2.default)(_classNames, classes.flatSecondary, text && color === 'secondary'), (0, _defineProperty2.default)(_classNames, classes.containedPrimary, !text && color === 'primary'), (0, _defineProperty2.default)(_classNames, classes.containedSecondary, !text && color === 'secondary'), (0, _defineProperty2.default)(_classNames, classes.raised, contained || fab), (0, _defineProperty2.default)(_classNames, classes.raisedPrimary, (contained || fab) && color === 'primary'), (0, _defineProperty2.default)(_classNames, classes.raisedSecondary, (contained || fab) && color === 'secondary'), (0, _defineProperty2.default)(_classNames, classes.text, variant === 'text'), (0, _defineProperty2.default)(_classNames, classes.outlined, variant === 'outlined'), (0, _defineProperty2.default)(_classNames, classes["size".concat((0, _helpers.capitalize)(size))], size !== 'medium'), (0, _defineProperty2.default)(_classNames, classes.disabled, disabled), (0, _defineProperty2.default)(_classNames, classes.fullWidth, fullWidth), _classNames), classNameProp);
  return _react.default.createElement(_ButtonBase.default, (0, _extends2.default)({
    className: className,
    disabled: disabled,
    focusRipple: !disableFocusRipple,
    focusVisibleClassName: (0, _classnames.default)(classes.focusVisible, focusVisibleClassName)
  }, other), _react.default.createElement("span", {
    className: classes.label
  }, children));
}

Button.propTypes =  false ? {
  /**
   * The content of the button.
   */
  children: _propTypes.default.node.isRequired,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: _propTypes.default.oneOf(['default', 'inherit', 'primary', 'secondary']),

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func]),

  /**
   * If `true`, the button will be disabled.
   */
  disabled: _propTypes.default.bool,

  /**
   * If `true`, the  keyboard focus ripple will be disabled.
   * `disableRipple` must also be true.
   */
  disableFocusRipple: _propTypes.default.bool,

  /**
   * If `true`, the ripple effect will be disabled.
   */
  disableRipple: _propTypes.default.bool,

  /**
   * @ignore
   */
  focusVisibleClassName: _propTypes.default.string,

  /**
   * If `true`, the button will take up the full width of its container.
   */
  fullWidth: _propTypes.default.bool,

  /**
   * The URL to link to when the button is clicked.
   * If defined, an `a` element will be used as the root node.
   */
  href: _propTypes.default.string,

  /**
   * If `true`, and `variant` is `'fab'`, will use mini floating action button styling.
   */
  mini: _propTypes.default.bool,

  /**
   * The size of the button.
   * `small` is equivalent to the dense button styling.
   */
  size: _propTypes.default.oneOf(['small', 'medium', 'large']),

  /**
   * @ignore
   */
  type: _propTypes.default.string,

  /**
   * The type of button.
   */
  variant: _propTypes.default.oneOf(['text', 'flat', 'outlined', 'contained', 'raised', 'fab'])
} : {};
Button.defaultProps = {
  color: 'default',
  component: 'button',
  disabled: false,
  disableFocusRipple: false,
  fullWidth: false,
  mini: false,
  size: 'medium',
  type: 'button',
  variant: 'text'
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiButton'
})(Button);

exports.default = _default;

/***/ }),
/* 874 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Card.default;
  }
});

var _Card = _interopRequireDefault(__webpack_require__(875));

/***/ }),
/* 875 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(8));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _classnames = _interopRequireDefault(__webpack_require__(6));

var _Paper = _interopRequireDefault(__webpack_require__(69));

var _withStyles = _interopRequireDefault(__webpack_require__(5));

// @inheritedComponent Paper
var styles = {
  root: {
    overflow: 'hidden'
  }
};
exports.styles = styles;

function Card(props) {
  var classes = props.classes,
      className = props.className,
      raised = props.raised,
      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "raised"]);
  return _react.default.createElement(_Paper.default, (0, _extends2.default)({
    className: (0, _classnames.default)(classes.root, className),
    elevation: raised ? 8 : 2
  }, other));
}

Card.propTypes =  false ? {
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * If `true`, the card will use raised styling.
   */
  raised: _propTypes.default.bool
} : {};
Card.defaultProps = {
  raised: false
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiCard'
})(Card);

exports.default = _default;

/***/ }),
/* 876 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _CardActions.default;
  }
});

var _CardActions = _interopRequireDefault(__webpack_require__(877));

/***/ }),
/* 877 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(8));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(11));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _classnames = _interopRequireDefault(__webpack_require__(6));

var _withStyles = _interopRequireDefault(__webpack_require__(5));

var _reactHelpers = __webpack_require__(105);

__webpack_require__(58);

// So we don't have any override priority issue.
var styles = function styles(theme) {
  return {
    root: (0, _defineProperty2.default)({
      display: 'flex',
      alignItems: 'center',
      boxSizing: 'border-box',
      padding: "".concat(theme.spacing.unit, "px ").concat(theme.spacing.unit / 2, "px")
    }, theme.breakpoints.up('sm'), {
      padding: "".concat(theme.spacing.unit, "px ").concat(theme.spacing.unit * 1.5, "px")
    }),
    action: {
      margin: "0 ".concat(theme.spacing.unit / 2, "px")
    }
  };
};

exports.styles = styles;

function CardActions(props) {
  var disableActionSpacing = props.disableActionSpacing,
      children = props.children,
      classes = props.classes,
      className = props.className,
      other = (0, _objectWithoutProperties2.default)(props, ["disableActionSpacing", "children", "classes", "className"]);
  return _react.default.createElement("div", (0, _extends2.default)({
    className: (0, _classnames.default)(classes.root, className)
  }, other), disableActionSpacing ? children : (0, _reactHelpers.cloneChildrenWithClassName)(children, classes.action));
}

CardActions.propTypes =  false ? {
  /**
   * The content of the component.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * If `true`, the card actions do not have additional margin.
   */
  disableActionSpacing: _propTypes.default.bool
} : {};
CardActions.defaultProps = {
  disableActionSpacing: false
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiCardActions'
})(CardActions);

exports.default = _default;

/***/ }),
/* 878 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _CardContent.default;
  }
});

var _CardContent = _interopRequireDefault(__webpack_require__(879));

/***/ }),
/* 879 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(8));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _classnames = _interopRequireDefault(__webpack_require__(6));

var _withStyles = _interopRequireDefault(__webpack_require__(5));

var styles = function styles(theme) {
  return {
    root: theme.mixins.gutters({
      paddingTop: theme.spacing.unit * 2,
      paddingBottom: theme.spacing.unit * 2,
      '&:last-child': {
        paddingBottom: theme.spacing.unit * 3
      }
    })
  };
};

exports.styles = styles;

function CardContent(props) {
  var classes = props.classes,
      className = props.className,
      Component = props.component,
      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "component"]);
  return _react.default.createElement(Component, (0, _extends2.default)({
    className: (0, _classnames.default)(classes.root, className)
  }, other));
}

CardContent.propTypes =  false ? {
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func])
} : {};
CardContent.defaultProps = {
  component: 'div'
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiCardContent'
})(CardContent);

exports.default = _default;

/***/ }),
/* 880 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _CardHeader.default;
  }
});

var _CardHeader = _interopRequireDefault(__webpack_require__(881));

/***/ }),
/* 881 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(8));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _classnames = _interopRequireDefault(__webpack_require__(6));

var _withStyles = _interopRequireDefault(__webpack_require__(5));

var _Typography = _interopRequireDefault(__webpack_require__(46));

var styles = function styles(theme) {
  return {
    root: theme.mixins.gutters({
      display: 'flex',
      alignItems: 'center',
      paddingTop: theme.spacing.unit * 2,
      paddingBottom: theme.spacing.unit * 2
    }),
    avatar: {
      flex: '0 0 auto',
      marginRight: theme.spacing.unit * 2
    },
    action: {
      flex: '0 0 auto',
      alignSelf: 'flex-start',
      marginTop: theme.spacing.unit * -1,
      marginRight: theme.spacing.unit * -2
    },
    content: {
      flex: '1 1 auto'
    },
    title: {},
    subheader: {}
  };
};

exports.styles = styles;

function CardHeader(props) {
  var action = props.action,
      avatar = props.avatar,
      classes = props.classes,
      classNameProp = props.className,
      Component = props.component,
      subheader = props.subheader,
      title = props.title,
      other = (0, _objectWithoutProperties2.default)(props, ["action", "avatar", "classes", "className", "component", "subheader", "title"]);
  return _react.default.createElement(Component, (0, _extends2.default)({
    className: (0, _classnames.default)(classes.root, classNameProp)
  }, other), avatar && _react.default.createElement("div", {
    className: classes.avatar
  }, avatar), _react.default.createElement("div", {
    className: classes.content
  }, _react.default.createElement(_Typography.default, {
    variant: avatar ? 'body2' : 'headline',
    component: "span",
    className: classes.title
  }, title), subheader && _react.default.createElement(_Typography.default, {
    variant: avatar ? 'body2' : 'body1',
    component: "span",
    color: "textSecondary",
    className: classes.subheader
  }, subheader)), action && _react.default.createElement("div", {
    className: classes.action
  }, action));
}

CardHeader.propTypes =  false ? {
  /**
   * The action to display in the card header.
   */
  action: _propTypes.default.node,

  /**
   * The Avatar for the Card Header.
   */
  avatar: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func]),

  /**
   * The content of the component.
   */
  subheader: _propTypes.default.node,

  /**
   * The content of the Card Title.
   */
  title: _propTypes.default.node
} : {};
CardHeader.defaultProps = {
  component: 'div'
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiCardHeader'
})(CardHeader);

exports.default = _default;

/***/ }),
/* 882 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(8));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(11));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _classnames = _interopRequireDefault(__webpack_require__(6));

var _withStyles = _interopRequireDefault(__webpack_require__(5));

var _helpers = __webpack_require__(36);

var styles = function styles(theme) {
  return {
    root: {
      display: 'block',
      margin: 0
    },
    display4: theme.typography.display4,
    display3: theme.typography.display3,
    display2: theme.typography.display2,
    display1: theme.typography.display1,
    headline: theme.typography.headline,
    title: theme.typography.title,
    subheading: theme.typography.subheading,
    body2: theme.typography.body2,
    body1: theme.typography.body1,
    caption: theme.typography.caption,
    button: theme.typography.button,
    alignLeft: {
      textAlign: 'left'
    },
    alignCenter: {
      textAlign: 'center'
    },
    alignRight: {
      textAlign: 'right'
    },
    alignJustify: {
      textAlign: 'justify'
    },
    noWrap: {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap'
    },
    gutterBottom: {
      marginBottom: '0.35em'
    },
    paragraph: {
      marginBottom: theme.spacing.unit * 2
    },
    colorInherit: {
      color: 'inherit'
    },
    colorPrimary: {
      color: theme.palette.primary.main
    },
    colorSecondary: {
      color: theme.palette.secondary.main
    },
    colorTextSecondary: {
      color: theme.palette.text.secondary
    },
    colorError: {
      color: theme.palette.error.main
    }
  };
};

exports.styles = styles;

function Typography(props) {
  var _classNames;

  var align = props.align,
      classes = props.classes,
      classNameProp = props.className,
      componentProp = props.component,
      color = props.color,
      gutterBottom = props.gutterBottom,
      headlineMapping = props.headlineMapping,
      noWrap = props.noWrap,
      paragraph = props.paragraph,
      variant = props.variant,
      other = (0, _objectWithoutProperties2.default)(props, ["align", "classes", "className", "component", "color", "gutterBottom", "headlineMapping", "noWrap", "paragraph", "variant"]);
  var className = (0, _classnames.default)(classes.root, classes[variant], (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes["color".concat((0, _helpers.capitalize)(color))], color !== 'default'), (0, _defineProperty2.default)(_classNames, classes.noWrap, noWrap), (0, _defineProperty2.default)(_classNames, classes.gutterBottom, gutterBottom), (0, _defineProperty2.default)(_classNames, classes.paragraph, paragraph), (0, _defineProperty2.default)(_classNames, classes["align".concat((0, _helpers.capitalize)(align))], align !== 'inherit'), _classNames), classNameProp);
  var Component = componentProp || (paragraph ? 'p' : headlineMapping[variant]) || 'span';
  return _react.default.createElement(Component, (0, _extends2.default)({
    className: className
  }, other));
}

Typography.propTypes =  false ? {
  /**
   * Set the text-align on the component.
   */
  align: _propTypes.default.oneOf(['inherit', 'left', 'center', 'right', 'justify']),

  /**
   * The content of the component.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: _propTypes.default.oneOf(['inherit', 'primary', 'textSecondary', 'secondary', 'error', 'default']),

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   * By default, it maps the variant to a good default headline component.
   */
  component: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func]),

  /**
   * If `true`, the text will have a bottom margin.
   */
  gutterBottom: _propTypes.default.bool,

  /**
   * We are empirically mapping the variant property to a range of different DOM element types.
   * For instance, h1 to h6. If you wish to change that mapping, you can provide your own.
   * Alternatively, you can use the `component` property.
   */
  headlineMapping: _propTypes.default.object,

  /**
   * If `true`, the text will not wrap, but instead will truncate with an ellipsis.
   */
  noWrap: _propTypes.default.bool,

  /**
   * If `true`, the text will have a bottom margin.
   */
  paragraph: _propTypes.default.bool,

  /**
   * Applies the theme typography styles.
   */
  variant: _propTypes.default.oneOf(['display4', 'display3', 'display2', 'display1', 'headline', 'title', 'subheading', 'body2', 'body1', 'caption', 'button'])
} : {};
Typography.defaultProps = {
  align: 'inherit',
  color: 'default',
  gutterBottom: false,
  headlineMapping: {
    display4: 'h1',
    display3: 'h1',
    display2: 'h1',
    display1: 'h1',
    headline: 'h1',
    title: 'h2',
    subheading: 'h3',
    body2: 'aside',
    body1: 'p'
  },
  noWrap: false,
  paragraph: false,
  variant: 'body1'
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiTypography'
})(Typography);

exports.default = _default;

/***/ }),
/* 883 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _CardMedia.default;
  }
});

var _CardMedia = _interopRequireDefault(__webpack_require__(884));

/***/ }),
/* 884 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(8));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(11));

var _objectSpread2 = _interopRequireDefault(__webpack_require__(23));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _classnames = _interopRequireDefault(__webpack_require__(6));

var _warning = _interopRequireDefault(__webpack_require__(32));

var _withStyles = _interopRequireDefault(__webpack_require__(5));

var styles = {
  root: {
    display: 'block',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center'
  },
  media: {
    width: '100%'
  }
};
exports.styles = styles;
var MEDIA_COMPONENTS = ['video', 'audio', 'picture', 'iframe', 'img'];

function CardMedia(props) {
  var classes = props.classes,
      className = props.className,
      Component = props.component,
      image = props.image,
      src = props.src,
      style = props.style,
      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "component", "image", "src", "style"]);
   false ? (0, _warning.default)(Boolean(image || src), 'Material-UI: either `image` or `src` property must be specified.') : void 0;
  var isMediaComponent = MEDIA_COMPONENTS.indexOf(Component) !== -1;
  var composedStyle = !isMediaComponent && image ? (0, _objectSpread2.default)({
    backgroundImage: "url(\"".concat(image, "\")")
  }, style) : style;
  return _react.default.createElement(Component, (0, _extends2.default)({
    className: (0, _classnames.default)(classes.root, (0, _defineProperty2.default)({}, classes.media, isMediaComponent), className),
    style: composedStyle,
    src: isMediaComponent ? image || src : undefined
  }, other));
}

CardMedia.propTypes =  false ? {
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * Component for rendering image.
   * Either a string to use a DOM element or a component.
   */
  component: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func]),

  /**
   * Image to be displayed as a background image.
   * Either `image` or `src` prop must be specified.
   * Note that caller must specify height otherwise the image will not be visible.
   */
  image: _propTypes.default.string,

  /**
   * An alias for `image` property.
   * Available only with media components.
   * Media components: `video`, `audio`, `picture`, `iframe`, `img`.
   */
  src: _propTypes.default.string,

  /**
   * @ignore
   */
  style: _propTypes.default.object
} : {};
CardMedia.defaultProps = {
  component: 'div'
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiCardMedia'
})(CardMedia);

exports.default = _default;

/***/ }),
/* 885 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Checkbox.default;
  }
});

var _Checkbox = _interopRequireDefault(__webpack_require__(886));

/***/ }),
/* 886 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(8));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _classnames = _interopRequireDefault(__webpack_require__(6));

var _SwitchBase = _interopRequireDefault(__webpack_require__(308));

var _CheckBoxOutlineBlank = _interopRequireDefault(__webpack_require__(888));

var _CheckBox = _interopRequireDefault(__webpack_require__(931));

var _IndeterminateCheckBox = _interopRequireDefault(__webpack_require__(932));

var _helpers = __webpack_require__(36);

var _withStyles = _interopRequireDefault(__webpack_require__(5));

var styles = function styles(theme) {
  return {
    root: {
      color: theme.palette.text.secondary
    },
    checked: {},
    disabled: {},
    colorPrimary: {
      '&$checked': {
        color: theme.palette.primary.main
      },
      '&$disabled': {
        color: theme.palette.action.disabled
      }
    },
    colorSecondary: {
      '&$checked': {
        color: theme.palette.secondary.main
      },
      '&$disabled': {
        color: theme.palette.action.disabled
      }
    }
  };
};

exports.styles = styles;

function Checkbox(props) {
  var checkedIcon = props.checkedIcon,
      classes = props.classes,
      color = props.color,
      icon = props.icon,
      indeterminate = props.indeterminate,
      indeterminateIcon = props.indeterminateIcon,
      other = (0, _objectWithoutProperties2.default)(props, ["checkedIcon", "classes", "color", "icon", "indeterminate", "indeterminateIcon"]);
  return _react.default.createElement(_SwitchBase.default, (0, _extends2.default)({
    checkedIcon: indeterminate ? indeterminateIcon : checkedIcon,
    classes: {
      root: (0, _classnames.default)(classes.root, classes["color".concat((0, _helpers.capitalize)(color))]),
      checked: classes.checked,
      disabled: classes.disabled
    },
    icon: indeterminate ? indeterminateIcon : icon
  }, other));
}

Checkbox.propTypes =  false ? {
  /**
   * If `true`, the component is checked.
   */
  checked: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.string]),

  /**
   * The icon to display when the component is checked.
   */
  checkedIcon: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: _propTypes.default.oneOf(['primary', 'secondary', 'default']),

  /**
   * If `true`, the switch will be disabled.
   */
  disabled: _propTypes.default.bool,

  /**
   * If `true`, the ripple effect will be disabled.
   */
  disableRipple: _propTypes.default.bool,

  /**
   * The icon to display when the component is unchecked.
   */
  icon: _propTypes.default.node,

  /**
   * The id of the `input` element.
   */
  id: _propTypes.default.string,

  /**
   * If `true`, the component appears indeterminate.
   */
  indeterminate: _propTypes.default.bool,

  /**
   * The icon to display when the component is indeterminate.
   */
  indeterminateIcon: _propTypes.default.node,

  /**
   * Properties applied to the `input` element.
   */
  inputProps: _propTypes.default.object,

  /**
   * Use that property to pass a ref callback to the native input component.
   */
  inputRef: _propTypes.default.func,

  /**
   * Callback fired when the state is changed.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.checked`.
   * @param {boolean} checked The `checked` value of the switch
   */
  onChange: _propTypes.default.func,

  /**
   * The input component property `type`.
   */
  type: _propTypes.default.string,

  /**
   * The value of the component.
   */
  value: _propTypes.default.string
} : {};
Checkbox.defaultProps = {
  checkedIcon: _react.default.createElement(_CheckBox.default, null),
  color: 'secondary',
  icon: _react.default.createElement(_CheckBoxOutlineBlank.default, null),
  indeterminate: false,
  indeterminateIcon: _react.default.createElement(_IndeterminateCheckBox.default, null)
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiCheckbox'
})(Checkbox);

exports.default = _default;

/***/ }),
/* 887 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(8));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(11));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _classnames = _interopRequireDefault(__webpack_require__(6));

var _withStyles = _interopRequireDefault(__webpack_require__(5));

var _colorManipulator = __webpack_require__(90);

var _ButtonBase = _interopRequireDefault(__webpack_require__(70));

var _helpers = __webpack_require__(36);

// @inheritedComponent ButtonBase
var styles = function styles(theme) {
  return {
    root: {
      textAlign: 'center',
      flex: '0 0 auto',
      fontSize: theme.typography.pxToRem(24),
      width: 48,
      height: 48,
      padding: 0,
      borderRadius: '50%',
      color: theme.palette.action.active,
      transition: theme.transitions.create('background-color', {
        duration: theme.transitions.duration.shortest
      }),
      '&:hover': {
        backgroundColor: (0, _colorManipulator.fade)(theme.palette.action.active, theme.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        },
        '&$disabled': {
          backgroundColor: 'transparent'
        }
      },
      '&$disabled': {
        color: theme.palette.action.disabled
      }
    },
    colorInherit: {
      color: 'inherit'
    },
    colorPrimary: {
      color: theme.palette.primary.main,
      '&:hover': {
        backgroundColor: (0, _colorManipulator.fade)(theme.palette.primary.main, theme.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        }
      }
    },
    colorSecondary: {
      color: theme.palette.secondary.main,
      '&:hover': {
        backgroundColor: (0, _colorManipulator.fade)(theme.palette.secondary.main, theme.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        }
      }
    },
    disabled: {},
    label: {
      width: '100%',
      display: 'flex',
      alignItems: 'inherit',
      justifyContent: 'inherit'
    }
  };
};
/**
 * Refer to the [Icons](/style/icons) section of the documentation
 * regarding the available icon options.
 */


exports.styles = styles;

function IconButton(props) {
  var _classNames;

  var children = props.children,
      classes = props.classes,
      className = props.className,
      color = props.color,
      disabled = props.disabled,
      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "color", "disabled"]);
  return _react.default.createElement(_ButtonBase.default, (0, _extends2.default)({
    className: (0, _classnames.default)(classes.root, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes["color".concat((0, _helpers.capitalize)(color))], color !== 'default'), (0, _defineProperty2.default)(_classNames, classes.disabled, disabled), _classNames), className),
    centerRipple: true,
    focusRipple: true,
    disabled: disabled
  }, other), _react.default.createElement("span", {
    className: classes.label
  }, children));
}

IconButton.propTypes =  false ? {
  /**
   * The icon element.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: _propTypes.default.oneOf(['default', 'inherit', 'primary', 'secondary']),

  /**
   * If `true`, the button will be disabled.
   */
  disabled: _propTypes.default.bool,

  /**
   * If `true`, the ripple will be disabled.
   */
  disableRipple: _propTypes.default.bool
} : {};
IconButton.defaultProps = {
  color: 'default',
  disabled: false
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiIconButton'
})(IconButton);

exports.default = _default;

/***/ }),
/* 888 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _pure = _interopRequireDefault(__webpack_require__(52));

var _SvgIcon = _interopRequireDefault(__webpack_require__(47));

var _ref = _react.default.createElement("path", {
  d: "M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
});

/**
 * @ignore - internal component.
 */
var CheckBoxOutlineBlank = function CheckBoxOutlineBlank(props) {
  return _react.default.createElement(_SvgIcon.default, props, _ref);
};

CheckBoxOutlineBlank = (0, _pure.default)(CheckBoxOutlineBlank);
CheckBoxOutlineBlank.muiName = 'SvgIcon';
var _default = CheckBoxOutlineBlank;
exports.default = _default;

/***/ }),
/* 889 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(890);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(891);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(920);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _setDisplayName = __webpack_require__(483);

var _setDisplayName2 = _interopRequireDefault(_setDisplayName);

var _wrapDisplayName = __webpack_require__(162);

var _wrapDisplayName2 = _interopRequireDefault(_wrapDisplayName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var shouldUpdate = function shouldUpdate(test) {
  return function (BaseComponent) {
    var factory = (0, _react.createFactory)(BaseComponent);

    var ShouldUpdate = function (_Component) {
      (0, _inherits3.default)(ShouldUpdate, _Component);

      function ShouldUpdate() {
        (0, _classCallCheck3.default)(this, ShouldUpdate);
        return (0, _possibleConstructorReturn3.default)(this, _Component.apply(this, arguments));
      }

      ShouldUpdate.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
        return test(this.props, nextProps);
      };

      ShouldUpdate.prototype.render = function render() {
        return factory(this.props);
      };

      return ShouldUpdate;
    }(_react.Component);

    if (false) {
      return (0, _setDisplayName2.default)((0, _wrapDisplayName2.default)(BaseComponent, 'shouldUpdate'))(ShouldUpdate);
    }
    return ShouldUpdate;
  };
};

exports.default = shouldUpdate;

/***/ }),
/* 890 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

/***/ }),
/* 891 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof2 = __webpack_require__(472);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
};

/***/ }),
/* 892 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(893), __esModule: true };

/***/ }),
/* 893 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(894);
__webpack_require__(906);
module.exports = __webpack_require__(319).f('iterator');


/***/ }),
/* 894 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(895)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(473)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 895 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(309);
var defined = __webpack_require__(310);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 896 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 897 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(313);
var descriptor = __webpack_require__(223);
var setToStringTag = __webpack_require__(318);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(135)(IteratorPrototype, __webpack_require__(140)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 898 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(136);
var anObject = __webpack_require__(169);
var getKeys = __webpack_require__(314);

module.exports = __webpack_require__(138) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 899 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(479);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 900 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(139);
var toLength = __webpack_require__(901);
var toAbsoluteIndex = __webpack_require__(902);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 901 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(309);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 902 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(309);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 903 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(92).document;
module.exports = document && document.documentElement;


/***/ }),
/* 904 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(106);
var toObject = __webpack_require__(905);
var IE_PROTO = __webpack_require__(315)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 905 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(310);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 906 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(907);
var global = __webpack_require__(92);
var hide = __webpack_require__(135);
var Iterators = __webpack_require__(312);
var TO_STRING_TAG = __webpack_require__(140)('toStringTag');

var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
  'TextTrackList,TouchList').split(',');

for (var i = 0; i < DOMIterables.length; i++) {
  var NAME = DOMIterables[i];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}


/***/ }),
/* 907 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(908);
var step = __webpack_require__(909);
var Iterators = __webpack_require__(312);
var toIObject = __webpack_require__(139);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(473)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 908 */
/***/ (function(module, exports) {

module.exports = function () { /* empty */ };


/***/ }),
/* 909 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 910 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(911), __esModule: true };

/***/ }),
/* 911 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(912);
__webpack_require__(917);
__webpack_require__(918);
__webpack_require__(919);
module.exports = __webpack_require__(134).Symbol;


/***/ }),
/* 912 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(92);
var has = __webpack_require__(106);
var DESCRIPTORS = __webpack_require__(138);
var $export = __webpack_require__(221);
var redefine = __webpack_require__(477);
var META = __webpack_require__(913).KEY;
var $fails = __webpack_require__(222);
var shared = __webpack_require__(316);
var setToStringTag = __webpack_require__(318);
var uid = __webpack_require__(224);
var wks = __webpack_require__(140);
var wksExt = __webpack_require__(319);
var wksDefine = __webpack_require__(320);
var enumKeys = __webpack_require__(914);
var isArray = __webpack_require__(915);
var anObject = __webpack_require__(169);
var isObject = __webpack_require__(137);
var toIObject = __webpack_require__(139);
var toPrimitive = __webpack_require__(311);
var createDesc = __webpack_require__(223);
var _create = __webpack_require__(313);
var gOPNExt = __webpack_require__(916);
var $GOPD = __webpack_require__(482);
var $DP = __webpack_require__(136);
var $keys = __webpack_require__(314);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function';
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(481).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(321).f = $propertyIsEnumerable;
  __webpack_require__(480).f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(220)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(135)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 913 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(224)('meta');
var isObject = __webpack_require__(137);
var has = __webpack_require__(106);
var setDesc = __webpack_require__(136).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(222)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 914 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(314);
var gOPS = __webpack_require__(480);
var pIE = __webpack_require__(321);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 915 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(479);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 916 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(139);
var gOPN = __webpack_require__(481).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 917 */
/***/ (function(module, exports) {



/***/ }),
/* 918 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(320)('asyncIterator');


/***/ }),
/* 919 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(320)('observable');


/***/ }),
/* 920 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _setPrototypeOf = __webpack_require__(921);

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = __webpack_require__(925);

var _create2 = _interopRequireDefault(_create);

var _typeof2 = __webpack_require__(472);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
  }

  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};

/***/ }),
/* 921 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(922), __esModule: true };

/***/ }),
/* 922 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(923);
module.exports = __webpack_require__(134).Object.setPrototypeOf;


/***/ }),
/* 923 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(221);
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(924).set });


/***/ }),
/* 924 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(137);
var anObject = __webpack_require__(169);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(474)(Function.call, __webpack_require__(482).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),
/* 925 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(926), __esModule: true };

/***/ }),
/* 926 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(927);
var $Object = __webpack_require__(134).Object;
module.exports = function create(P, D) {
  return $Object.create(P, D);
};


/***/ }),
/* 927 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(221);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__(313) });


/***/ }),
/* 928 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var setStatic = function setStatic(key, value) {
  return function (BaseComponent) {
    /* eslint-disable no-param-reassign */
    BaseComponent[key] = value;
    /* eslint-enable no-param-reassign */
    return BaseComponent;
  };
};

exports.default = setStatic;

/***/ }),
/* 929 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _shallowEqual = __webpack_require__(295);

var _shallowEqual2 = _interopRequireDefault(_shallowEqual);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _shallowEqual2.default;

/***/ }),
/* 930 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(8));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(11));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _classnames = _interopRequireDefault(__webpack_require__(6));

var _withStyles = _interopRequireDefault(__webpack_require__(5));

var _helpers = __webpack_require__(36);

var styles = function styles(theme) {
  return {
    root: {
      userSelect: 'none',
      fontSize: 24,
      width: '1em',
      height: '1em',
      display: 'inline-block',
      fill: 'currentColor',
      flexShrink: 0,
      transition: theme.transitions.create('fill', {
        duration: theme.transitions.duration.shorter
      })
    },
    colorPrimary: {
      color: theme.palette.primary.main
    },
    colorSecondary: {
      color: theme.palette.secondary.main
    },
    colorAction: {
      color: theme.palette.action.active
    },
    colorError: {
      color: theme.palette.error.main
    },
    colorDisabled: {
      color: theme.palette.action.disabled
    }
  };
};

exports.styles = styles;

function SvgIcon(props) {
  var children = props.children,
      classes = props.classes,
      classNameProp = props.className,
      color = props.color,
      nativeColor = props.nativeColor,
      titleAccess = props.titleAccess,
      viewBox = props.viewBox,
      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "color", "nativeColor", "titleAccess", "viewBox"]);
  var className = (0, _classnames.default)(classes.root, (0, _defineProperty2.default)({}, classes["color".concat((0, _helpers.capitalize)(color))], color !== 'inherit'), classNameProp);
  return _react.default.createElement("svg", (0, _extends2.default)({
    className: className,
    focusable: "false",
    viewBox: viewBox,
    color: nativeColor,
    "aria-hidden": titleAccess ? 'false' : 'true'
  }, other), titleAccess ? _react.default.createElement("title", null, titleAccess) : null, children);
}

SvgIcon.propTypes =  false ? {
  /**
   * Node passed into the SVG element.
   */
  children: _propTypes.default.node.isRequired,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   * You can use the `nativeColor` property to apply a color attribute to the SVG element.
   */
  color: _propTypes.default.oneOf(['inherit', 'primary', 'secondary', 'action', 'error', 'disabled']),

  /**
   * Applies a color attribute to the SVG element.
   */
  nativeColor: _propTypes.default.string,

  /**
   * Provides a human-readable title for the element that contains it.
   * https://www.w3.org/TR/SVG-access/#Equivalent
   */
  titleAccess: _propTypes.default.string,

  /**
   * Allows you to redefine what the coordinates without units mean inside an SVG element.
   * For example, if the SVG element is 500 (width) by 200 (height),
   * and you pass viewBox="0 0 50 20",
   * this means that the coordinates inside the SVG will go from the top left corner (0,0)
   * to bottom right (50,20) and each unit will be worth 10px.
   */
  viewBox: _propTypes.default.string
} : {};
SvgIcon.defaultProps = {
  color: 'inherit',
  viewBox: '0 0 24 24'
};
SvgIcon.muiName = 'SvgIcon';

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiSvgIcon'
})(SvgIcon);

exports.default = _default;

/***/ }),
/* 931 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _pure = _interopRequireDefault(__webpack_require__(52));

var _SvgIcon = _interopRequireDefault(__webpack_require__(47));

var _ref = _react.default.createElement("path", {
  d: "M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
});

/**
 * @ignore - internal component.
 */
var CheckBox = function CheckBox(props) {
  return _react.default.createElement(_SvgIcon.default, props, _ref);
};

CheckBox = (0, _pure.default)(CheckBox);
CheckBox.muiName = 'SvgIcon';
var _default = CheckBox;
exports.default = _default;

/***/ }),
/* 932 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _pure = _interopRequireDefault(__webpack_require__(52));

var _SvgIcon = _interopRequireDefault(__webpack_require__(47));

var _ref = _react.default.createElement("path", {
  d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 10H7v-2h10v2z"
});

/**
 * @ignore - internal component.
 */
var IndeterminateCheckBox = function IndeterminateCheckBox(props) {
  return _react.default.createElement(_SvgIcon.default, props, _ref);
};

IndeterminateCheckBox = (0, _pure.default)(IndeterminateCheckBox);
IndeterminateCheckBox.muiName = 'SvgIcon';
var _default = IndeterminateCheckBox;
exports.default = _default;

/***/ }),
/* 933 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Chip.default;
  }
});

var _Chip = _interopRequireDefault(__webpack_require__(934));

/***/ }),
/* 934 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(8));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(11));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(18));

var _createClass2 = _interopRequireDefault(__webpack_require__(19));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(20));

var _inherits2 = _interopRequireDefault(__webpack_require__(21));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _classnames = _interopRequireDefault(__webpack_require__(6));

var _keycode = _interopRequireDefault(__webpack_require__(133));

var _Cancel = _interopRequireDefault(__webpack_require__(935));

var _withStyles = _interopRequireDefault(__webpack_require__(5));

var _colorManipulator = __webpack_require__(90);

__webpack_require__(470);

// So we don't have any override priority issue.
var styles = function styles(theme) {
  var height = 32;
  var backgroundColor = theme.palette.type === 'light' ? theme.palette.grey[300] : theme.palette.grey[700];
  var deleteIconColor = (0, _colorManipulator.fade)(theme.palette.text.primary, 0.26);
  return {
    root: {
      fontFamily: theme.typography.fontFamily,
      fontSize: theme.typography.pxToRem(13),
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      height: height,
      color: theme.palette.getContrastText(backgroundColor),
      backgroundColor: backgroundColor,
      borderRadius: height / 2,
      whiteSpace: 'nowrap',
      transition: theme.transitions.create(['background-color', 'box-shadow']),
      // label will inherit this from root, then `clickable` class overrides this for both
      cursor: 'default',
      // We disable the focus ring for mouse, touch and keyboard users.
      outline: 'none',
      textDecoration: 'none',
      border: 'none',
      // Remove `button` border
      padding: 0 // Remove `button` padding

    },
    clickable: {
      // Remove grey highlight
      WebkitTapHighlightColor: 'transparent',
      cursor: 'pointer',
      '&:hover, &:focus': {
        backgroundColor: (0, _colorManipulator.emphasize)(backgroundColor, 0.08)
      },
      '&:active': {
        boxShadow: theme.shadows[1],
        backgroundColor: (0, _colorManipulator.emphasize)(backgroundColor, 0.12)
      }
    },
    deletable: {
      '&:focus': {
        backgroundColor: (0, _colorManipulator.emphasize)(backgroundColor, 0.08)
      }
    },
    avatar: {
      marginRight: -4,
      width: height,
      height: height,
      color: theme.palette.type === 'light' ? theme.palette.grey[700] : theme.palette.grey[300],
      fontSize: theme.typography.pxToRem(16)
    },
    avatarChildren: {
      width: 19,
      height: 19
    },
    label: {
      display: 'flex',
      alignItems: 'center',
      paddingLeft: 12,
      paddingRight: 12,
      userSelect: 'none',
      whiteSpace: 'nowrap',
      cursor: 'inherit'
    },
    deleteIcon: {
      // Remove grey highlight
      WebkitTapHighlightColor: 'transparent',
      color: deleteIconColor,
      cursor: 'pointer',
      height: 'auto',
      margin: '0 4px 0 -8px',
      '&:hover': {
        color: (0, _colorManipulator.fade)(deleteIconColor, 0.4)
      }
    }
  };
};
/**
 * Chips represent complex entities in small blocks, such as a contact.
 */


exports.styles = styles;

var Chip =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(Chip, _React$Component);

  function Chip() {
    var _ref;

    var _temp, _this;

    (0, _classCallCheck2.default)(this, Chip);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return (0, _possibleConstructorReturn2.default)(_this, (_temp = _this = (0, _possibleConstructorReturn2.default)(this, (_ref = Chip.__proto__ || Object.getPrototypeOf(Chip)).call.apply(_ref, [this].concat(args))), _this.chipRef = null, _this.handleDeleteIconClick = function (event) {
      // Stop the event from bubbling up to the `Chip`
      event.stopPropagation();
      var onDelete = _this.props.onDelete;

      if (onDelete) {
        onDelete(event);
      }
    }, _this.handleKeyDown = function (event) {
      // Ignore events from children of `Chip`.
      if (event.currentTarget !== event.target) {
        return;
      }

      var _this$props = _this.props,
          onClick = _this$props.onClick,
          onDelete = _this$props.onDelete,
          onKeyDown = _this$props.onKeyDown;
      var key = (0, _keycode.default)(event);

      if (onClick && (key === 'space' || key === 'enter')) {
        event.preventDefault();
        onClick(event);
      } else if (onDelete && key === 'backspace') {
        event.preventDefault();
        onDelete(event);
      } else if (key === 'esc') {
        event.preventDefault();

        if (_this.chipRef) {
          _this.chipRef.blur();
        }
      }

      if (onKeyDown) {
        onKeyDown(event);
      }
    }, _temp));
  }

  (0, _createClass2.default)(Chip, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          avatarProp = _props.avatar,
          classes = _props.classes,
          classNameProp = _props.className,
          clickable = _props.clickable,
          Component = _props.component,
          deleteIconProp = _props.deleteIcon,
          label = _props.label,
          onClick = _props.onClick,
          onDelete = _props.onDelete,
          onKeyDown = _props.onKeyDown,
          tabIndexProp = _props.tabIndex,
          other = (0, _objectWithoutProperties2.default)(_props, ["avatar", "classes", "className", "clickable", "component", "deleteIcon", "label", "onClick", "onDelete", "onKeyDown", "tabIndex"]);
      var className = (0, _classnames.default)(classes.root, (0, _defineProperty2.default)({}, classes.clickable, onClick || clickable), (0, _defineProperty2.default)({}, classes.deletable, onDelete), classNameProp);
      var deleteIcon = null;

      if (onDelete) {
        deleteIcon = deleteIconProp && _react.default.isValidElement(deleteIconProp) ? _react.default.cloneElement(deleteIconProp, {
          className: (0, _classnames.default)(deleteIconProp.props.className, classes.deleteIcon),
          onClick: this.handleDeleteIconClick
        }) : _react.default.createElement(_Cancel.default, {
          className: classes.deleteIcon,
          onClick: this.handleDeleteIconClick
        });
      }

      var avatar = null;

      if (avatarProp && _react.default.isValidElement(avatarProp)) {
        avatar = _react.default.cloneElement(avatarProp, {
          className: (0, _classnames.default)(classes.avatar, avatarProp.props.className),
          childrenClassName: (0, _classnames.default)(classes.avatarChildren, avatarProp.props.childrenClassName)
        });
      }

      var tabIndex = tabIndexProp;

      if (!tabIndex) {
        tabIndex = onClick || onDelete || clickable ? 0 : -1;
      }

      return _react.default.createElement(Component, (0, _extends2.default)({
        role: "button",
        className: className,
        tabIndex: tabIndex,
        onClick: onClick,
        onKeyDown: this.handleKeyDown,
        ref: function ref(node) {
          _this2.chipRef = node;
        }
      }, other), avatar, _react.default.createElement("span", {
        className: classes.label
      }, label), deleteIcon);
    }
  }]);
  return Chip;
}(_react.default.Component);

Chip.propTypes =  false ? {
  /**
   * Avatar element.
   */
  avatar: _propTypes.default.element,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * If true, the chip will appear clickable, and will raise when pressed,
   * even if the onClick property is not defined. This can be used, for example,
   * along with the component property to indicate an anchor Chip is clickable.
   */
  clickable: _propTypes.default.bool,

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func]),

  /**
   * Override the default delete icon element. Shown only if `onDelete` is set.
   */
  deleteIcon: _propTypes.default.element,

  /**
   * The content of the label.
   */
  label: _propTypes.default.node,

  /**
   * @ignore
   */
  onClick: _propTypes.default.func,

  /**
   * Callback function fired when the delete icon is clicked.
   * If set, the delete icon will be shown.
   */
  onDelete: _propTypes.default.func,

  /**
   * @ignore
   */
  onKeyDown: _propTypes.default.func,

  /**
   * @ignore
   */
  tabIndex: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string])
} : {};
Chip.defaultProps = {
  clickable: false,
  component: 'div'
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiChip'
})(Chip);

exports.default = _default;

/***/ }),
/* 935 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _pure = _interopRequireDefault(__webpack_require__(52));

var _SvgIcon = _interopRequireDefault(__webpack_require__(47));

var _ref = _react.default.createElement("path", {
  d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"
});

/**
 * @ignore - internal component.
 */
var Cancel = function Cancel(props) {
  return _react.default.createElement(_SvgIcon.default, props, _ref);
};

Cancel = (0, _pure.default)(Cancel);
Cancel.muiName = 'SvgIcon';
var _default = Cancel;
exports.default = _default;

/***/ }),
/* 936 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(8));

var _objectSpread2 = _interopRequireDefault(__webpack_require__(23));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(11));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _classnames = _interopRequireDefault(__webpack_require__(6));

var _withStyles = _interopRequireDefault(__webpack_require__(5));

var _helpers = __webpack_require__(36);

var SIZE = 50;

function getRelativeValue(value, min, max) {
  var clampedValue = Math.min(Math.max(min, value), max);
  return (clampedValue - min) / (max - min);
}

function easeOut(t) {
  t = getRelativeValue(t, 0, 1); // https://gist.github.com/gre/1650294

  t = (t -= 1) * t * t + 1;
  return t;
}

function easeIn(t) {
  return t * t;
}

var styles = function styles(theme) {
  return {
    root: {
      display: 'inline-block'
    },
    static: {
      transition: theme.transitions.create('transform')
    },
    indeterminate: {
      animation: 'mui-progress-circular-rotate 1.4s linear infinite'
    },
    colorPrimary: {
      color: theme.palette.primary.main
    },
    colorSecondary: {
      color: theme.palette.secondary.main
    },
    svg: {},
    circle: {
      stroke: 'currentColor',
      strokeLinecap: 'round'
    },
    circleStatic: {
      transition: theme.transitions.create('stroke-dashoffset')
    },
    circleIndeterminate: {
      animation: 'mui-progress-circular-dash 1.4s ease-in-out infinite',
      // Some default value that looks fine waiting for the animation to kicks in.
      strokeDasharray: '80px, 200px',
      strokeDashoffset: '0px' // Add the unit to fix a Edge 16 and below bug.

    },
    '@keyframes mui-progress-circular-rotate': {
      '100%': {
        transform: 'rotate(360deg)'
      }
    },
    '@keyframes mui-progress-circular-dash': {
      '0%': {
        strokeDasharray: '1px, 200px',
        strokeDashoffset: '0px'
      },
      '50%': {
        strokeDasharray: '100px, 200px',
        strokeDashoffset: '-15px'
      },
      '100%': {
        strokeDasharray: '100px, 200px',
        strokeDashoffset: '-120px'
      }
    }
  };
};
/**
 * ## ARIA
 *
 * If the progress bar is describing the loading progress of a particular region of a page,
 * you should use `aria-describedby` to point to the progress bar, and set the `aria-busy`
 * attribute to `true` on that region until it has finished loading.
 */


exports.styles = styles;

function CircularProgress(props) {
  var _classNames, _classNames2;

  var classes = props.classes,
      className = props.className,
      color = props.color,
      size = props.size,
      style = props.style,
      thickness = props.thickness,
      value = props.value,
      variant = props.variant,
      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "color", "size", "style", "thickness", "value", "variant"]);
  var circleStyle = {};
  var rootStyle = {};
  var rootProps = {};

  if (variant === 'determinate' || variant === 'static') {
    var circumference = 2 * Math.PI * (SIZE / 2 - 5);
    circleStyle.strokeDasharray = circumference.toFixed(3);
    rootProps['aria-valuenow'] = Math.round(value);

    if (variant === 'static') {
      circleStyle.strokeDashoffset = "".concat(((100 - value) / 100 * circumference).toFixed(3), "px");
      rootStyle.transform = 'rotate(-90deg)';
    } else {
      circleStyle.strokeDashoffset = "".concat((easeIn((100 - value) / 100) * circumference).toFixed(3), "px");
      rootStyle.transform = "rotate(".concat((easeOut(value / 70) * 270).toFixed(3), "deg)");
    }
  }

  return _react.default.createElement("div", (0, _extends2.default)({
    className: (0, _classnames.default)(classes.root, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes["color".concat((0, _helpers.capitalize)(color))], color !== 'inherit'), (0, _defineProperty2.default)(_classNames, classes.indeterminate, variant === 'indeterminate'), (0, _defineProperty2.default)(_classNames, classes.static, variant === 'static'), _classNames), className),
    style: (0, _objectSpread2.default)({
      width: size,
      height: size
    }, rootStyle, style),
    role: "progressbar"
  }, rootProps, other), _react.default.createElement("svg", {
    className: classes.svg,
    viewBox: "0 0 ".concat(SIZE, " ").concat(SIZE)
  }, _react.default.createElement("circle", {
    className: (0, _classnames.default)(classes.circle, (_classNames2 = {}, (0, _defineProperty2.default)(_classNames2, classes.circleIndeterminate, variant === 'indeterminate'), (0, _defineProperty2.default)(_classNames2, classes.circleStatic, variant === 'static'), _classNames2)),
    style: circleStyle,
    cx: SIZE / 2,
    cy: SIZE / 2,
    r: SIZE / 2 - 5,
    fill: "none",
    strokeWidth: thickness
  })));
}

CircularProgress.propTypes =  false ? {
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: _propTypes.default.oneOf(['primary', 'secondary', 'inherit']),

  /**
   * The size of the circle.
   */
  size: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),

  /**
   * @ignore
   */
  style: _propTypes.default.object,

  /**
   * The thickness of the circle.
   */
  thickness: _propTypes.default.number,

  /**
   * The value of the progress indicator for the determinate and static variants.
   * Value between 0 and 100.
   */
  value: _propTypes.default.number,

  /**
   * The variant of progress indicator. Use indeterminate
   * when there is no progress value.
   */
  variant: _propTypes.default.oneOf(['determinate', 'indeterminate', 'static'])
} : {};
CircularProgress.defaultProps = {
  color: 'primary',
  size: 40,
  thickness: 3.6,
  value: 0,
  variant: 'indeterminate'
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiCircularProgress',
  flip: false
})(CircularProgress);

exports.default = _default;

/***/ }),
/* 937 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(8));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(18));

var _createClass2 = _interopRequireDefault(__webpack_require__(19));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(20));

var _inherits2 = _interopRequireDefault(__webpack_require__(21));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(127));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _reactDom = _interopRequireDefault(__webpack_require__(45));

var _reactEventListener = _interopRequireDefault(__webpack_require__(73));

var _ownerDocument = _interopRequireDefault(__webpack_require__(71));

// @inheritedComponent EventListener
var isDescendant = function isDescendant(el, target) {
  if (target !== null && target.parentNode) {
    return el === target || isDescendant(el, target.parentNode);
  }

  return false;
};
/**
 * Listen for click events that are triggered outside of the component children.
 */


var ClickAwayListener =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(ClickAwayListener, _React$Component);

  function ClickAwayListener() {
    var _ref;

    var _temp, _this;

    (0, _classCallCheck2.default)(this, ClickAwayListener);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return (0, _possibleConstructorReturn2.default)(_this, (_temp = _this = (0, _possibleConstructorReturn2.default)(this, (_ref = ClickAwayListener.__proto__ || Object.getPrototypeOf(ClickAwayListener)).call.apply(_ref, [this].concat(args))), _this.mounted = false, _this.handleClickAway = function (event) {
      // Ignore events that have been `event.preventDefault()` marked.
      if (event.defaultPrevented) {
        return;
      } // IE11 support, which trigger the handleClickAway even after the unbind


      if (!_this.mounted) {
        return;
      }

      var el = _reactDom.default.findDOMNode((0, _assertThisInitialized2.default)(_this));

      var doc = (0, _ownerDocument.default)(el);

      if (doc.documentElement && doc.documentElement.contains(event.target) && !isDescendant(el, event.target)) {
        _this.props.onClickAway(event);
      }
    }, _temp));
  }

  (0, _createClass2.default)(ClickAwayListener, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.mounted = true;
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.mounted = false;
    }
  }, {
    key: "render",
    value: function render() {
      var _props = this.props,
          children = _props.children,
          mouseEvent = _props.mouseEvent,
          touchEvent = _props.touchEvent,
          onClickAway = _props.onClickAway,
          other = (0, _objectWithoutProperties2.default)(_props, ["children", "mouseEvent", "touchEvent", "onClickAway"]);
      var listenerProps = {};

      if (mouseEvent !== false) {
        listenerProps[mouseEvent] = this.handleClickAway;
      }

      if (touchEvent !== false) {
        listenerProps[touchEvent] = this.handleClickAway;
      }

      return _react.default.createElement(_reactEventListener.default, (0, _extends2.default)({
        target: "document"
      }, listenerProps, other), children);
    }
  }]);
  return ClickAwayListener;
}(_react.default.Component);

ClickAwayListener.propTypes =  false ? {
  children: _propTypes.default.node.isRequired,
  mouseEvent: _propTypes.default.oneOf(['onClick', 'onMouseDown', 'onMouseUp', false]),
  onClickAway: _propTypes.default.func.isRequired,
  touchEvent: _propTypes.default.oneOf(['onTouchStart', 'onTouchEnd', false])
} : {};
ClickAwayListener.defaultProps = {
  mouseEvent: 'onMouseUp',
  touchEvent: 'onTouchEnd'
};
var _default = ClickAwayListener;
exports.default = _default;

/***/ }),
/* 938 */
/***/ (function(module, exports) {

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

module.exports = _classCallCheck;

/***/ }),
/* 939 */
/***/ (function(module, exports) {

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

module.exports = _createClass;

/***/ }),
/* 940 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = __webpack_require__(486);

var assertThisInitialized = __webpack_require__(941);

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return assertThisInitialized(self);
}

module.exports = _possibleConstructorReturn;

/***/ }),
/* 941 */
/***/ (function(module, exports) {

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

module.exports = _assertThisInitialized;

/***/ }),
/* 942 */
/***/ (function(module, exports) {

function _getPrototypeOf(o) {
  module.exports = _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

module.exports = _getPrototypeOf;

/***/ }),
/* 943 */
/***/ (function(module, exports, __webpack_require__) {

var setPrototypeOf = __webpack_require__(944);

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) setPrototypeOf(subClass, superClass);
}

module.exports = _inherits;

/***/ }),
/* 944 */
/***/ (function(module, exports) {

function _setPrototypeOf(o, p) {
  module.exports = _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

module.exports = _setPrototypeOf;

/***/ }),
/* 945 */
/***/ (function(module, exports, __webpack_require__) {

var objectWithoutPropertiesLoose = __webpack_require__(946);

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

module.exports = _objectWithoutProperties;

/***/ }),
/* 946 */
/***/ (function(module, exports) {

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

module.exports = _objectWithoutPropertiesLoose;

/***/ }),
/* 947 */
/***/ (function(module, exports) {

function _extends() {
  module.exports = _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

module.exports = _extends;

/***/ }),
/* 948 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(8));

var _objectSpread2 = _interopRequireDefault(__webpack_require__(23));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(11));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(18));

var _createClass2 = _interopRequireDefault(__webpack_require__(19));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(20));

var _inherits2 = _interopRequireDefault(__webpack_require__(21));

var _react = _interopRequireDefault(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(6));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _Transition = _interopRequireDefault(__webpack_require__(131));

var _withStyles = _interopRequireDefault(__webpack_require__(5));

var _transitions = __webpack_require__(78);

var _utils = __webpack_require__(132);

// @inheritedComponent Transition
var styles = function styles(theme) {
  return {
    container: {
      height: 0,
      overflow: 'hidden',
      transition: theme.transitions.create('height')
    },
    entered: {
      height: 'auto'
    },
    wrapper: {
      // Hack to get children with a negative margin to not falsify the height computation.
      display: 'flex'
    },
    wrapperInner: {
      width: '100%'
    }
  };
};
/**
 * The Collapse transition is used by the
 * [Vertical Stepper](/demos/steppers#vertical-stepper) StepContent component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */


exports.styles = styles;

var Collapse =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(Collapse, _React$Component);

  function Collapse() {
    var _ref;

    var _temp, _this;

    (0, _classCallCheck2.default)(this, Collapse);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return (0, _possibleConstructorReturn2.default)(_this, (_temp = _this = (0, _possibleConstructorReturn2.default)(this, (_ref = Collapse.__proto__ || Object.getPrototypeOf(Collapse)).call.apply(_ref, [this].concat(args))), _this.wrapper = null, _this.autoTransitionDuration = undefined, _this.timer = null, _this.handleEnter = function (node) {
      node.style.height = _this.props.collapsedHeight;

      if (_this.props.onEnter) {
        _this.props.onEnter(node);
      }
    }, _this.handleEntering = function (node) {
      var _this$props = _this.props,
          timeout = _this$props.timeout,
          theme = _this$props.theme;
      var wrapperHeight = _this.wrapper ? _this.wrapper.clientHeight : 0;

      var _getTransitionProps = (0, _utils.getTransitionProps)(_this.props, {
        mode: 'enter'
      }),
          transitionDuration = _getTransitionProps.duration;

      if (timeout === 'auto') {
        var duration2 = theme.transitions.getAutoHeightDuration(wrapperHeight);
        node.style.transitionDuration = "".concat(duration2, "ms");
        _this.autoTransitionDuration = duration2;
      } else {
        node.style.transitionDuration = typeof transitionDuration === 'string' ? transitionDuration : "".concat(transitionDuration, "ms");
      }

      node.style.height = "".concat(wrapperHeight, "px");

      if (_this.props.onEntering) {
        _this.props.onEntering(node);
      }
    }, _this.handleEntered = function (node) {
      node.style.height = 'auto';

      if (_this.props.onEntered) {
        _this.props.onEntered(node);
      }
    }, _this.handleExit = function (node) {
      var wrapperHeight = _this.wrapper ? _this.wrapper.clientHeight : 0;
      node.style.height = "".concat(wrapperHeight, "px");

      if (_this.props.onExit) {
        _this.props.onExit(node);
      }
    }, _this.handleExiting = function (node) {
      var _this$props2 = _this.props,
          timeout = _this$props2.timeout,
          theme = _this$props2.theme;
      var wrapperHeight = _this.wrapper ? _this.wrapper.clientHeight : 0;

      var _getTransitionProps2 = (0, _utils.getTransitionProps)(_this.props, {
        mode: 'exit'
      }),
          transitionDuration = _getTransitionProps2.duration;

      if (timeout === 'auto') {
        var duration2 = theme.transitions.getAutoHeightDuration(wrapperHeight);
        node.style.transitionDuration = "".concat(duration2, "ms");
        _this.autoTransitionDuration = duration2;
      } else {
        node.style.transitionDuration = typeof transitionDuration === 'string' ? transitionDuration : "".concat(transitionDuration, "ms");
      }

      node.style.height = _this.props.collapsedHeight;

      if (_this.props.onExiting) {
        _this.props.onExiting(node);
      }
    }, _this.addEndListener = function (_, next) {
      if (_this.props.timeout === 'auto') {
        _this.timer = setTimeout(next, _this.autoTransitionDuration || 0);
      }
    }, _temp));
  }

  (0, _createClass2.default)(Collapse, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearTimeout(this.timer);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          children = _props.children,
          classes = _props.classes,
          className = _props.className,
          collapsedHeight = _props.collapsedHeight,
          Component = _props.component,
          onEnter = _props.onEnter,
          onEntered = _props.onEntered,
          onEntering = _props.onEntering,
          onExit = _props.onExit,
          onExiting = _props.onExiting,
          style = _props.style,
          theme = _props.theme,
          timeout = _props.timeout,
          other = (0, _objectWithoutProperties2.default)(_props, ["children", "classes", "className", "collapsedHeight", "component", "onEnter", "onEntered", "onEntering", "onExit", "onExiting", "style", "theme", "timeout"]);
      return _react.default.createElement(_Transition.default, (0, _extends2.default)({
        onEnter: this.handleEnter,
        onEntered: this.handleEntered,
        onEntering: this.handleEntering,
        onExit: this.handleExit,
        onExiting: this.handleExiting,
        addEndListener: this.addEndListener,
        timeout: timeout === 'auto' ? null : timeout
      }, other), function (state, childProps) {
        return _react.default.createElement(Component, (0, _extends2.default)({
          className: (0, _classnames.default)(classes.container, (0, _defineProperty2.default)({}, classes.entered, state === 'entered'), className),
          style: (0, _objectSpread2.default)({}, style, {
            minHeight: collapsedHeight
          })
        }, childProps), _react.default.createElement("div", {
          className: classes.wrapper,
          ref: function ref(node) {
            _this2.wrapper = node;
          }
        }, _react.default.createElement("div", {
          className: classes.wrapperInner
        }, children)));
      });
    }
  }]);
  return Collapse;
}(_react.default.Component);

Collapse.propTypes =  false ? {
  /**
   * The content node to be collapsed.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The height of the container when collapsed.
   */
  collapsedHeight: _propTypes.default.string,

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func]),

  /**
   * If `true`, the component will transition in.
   */
  in: _propTypes.default.bool,

  /**
   * @ignore
   */
  onEnter: _propTypes.default.func,

  /**
   * @ignore
   */
  onEntered: _propTypes.default.func,

  /**
   * @ignore
   */
  onEntering: _propTypes.default.func,

  /**
   * @ignore
   */
  onExit: _propTypes.default.func,

  /**
   * @ignore
   */
  onExiting: _propTypes.default.func,

  /**
   * @ignore
   */
  style: _propTypes.default.object,

  /**
   * @ignore
   */
  theme: _propTypes.default.object.isRequired,

  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   *
   * Set to 'auto' to automatically calculate transition time based on height.
   */
  timeout: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
    enter: _propTypes.default.number,
    exit: _propTypes.default.number
  }), _propTypes.default.oneOf(['auto'])])
} : {};
Collapse.defaultProps = {
  collapsedHeight: '0px',
  component: 'div',
  timeout: _transitions.duration.standard
};

var _default = (0, _withStyles.default)(styles, {
  withTheme: true,
  name: 'MuiCollapse'
})(Collapse);

exports.default = _default;

/***/ }),
/* 949 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _CssBaseline.default;
  }
});

var _CssBaseline = _interopRequireDefault(__webpack_require__(950));

/***/ }),
/* 950 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(18));

var _createClass2 = _interopRequireDefault(__webpack_require__(19));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(20));

var _inherits2 = _interopRequireDefault(__webpack_require__(21));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _styles = __webpack_require__(469);

var _exactProp = _interopRequireDefault(__webpack_require__(166));

var styles = function styles(theme) {
  return {
    '@global': {
      html: {
        WebkitFontSmoothing: 'antialiased',
        // Antialiasing.
        MozOsxFontSmoothing: 'grayscale',
        // Antialiasing.
        // Change from `box-sizing: content-box` so that `width`
        // is not affected by `padding` or `border`.
        boxSizing: 'border-box'
      },
      '*, *::before, *::after': {
        boxSizing: 'inherit'
      },
      body: {
        margin: 0,
        // Remove the margin in all browsers.
        backgroundColor: theme.palette.background.default,
        '@media print': {
          // Save printer ink.
          backgroundColor: theme.palette.common.white
        }
      }
    }
  };
};
/**
 * Kickstart an elegant, consistent, and simple baseline to build upon.
 */


var CssBaseline =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(CssBaseline, _React$Component);

  function CssBaseline() {
    (0, _classCallCheck2.default)(this, CssBaseline);
    return (0, _possibleConstructorReturn2.default)(this, (CssBaseline.__proto__ || Object.getPrototypeOf(CssBaseline)).apply(this, arguments));
  }

  (0, _createClass2.default)(CssBaseline, [{
    key: "render",
    value: function render() {
      return this.props.children;
    }
  }]);
  return CssBaseline;
}(_react.default.Component);

CssBaseline.propTypes =  false ? {
  /**
   * You can wrap a node.
   */
  children: _propTypes.default.node,

  /**
   * @ignore
   */
  classes: _propTypes.default.object.isRequired
} : {};
CssBaseline.propTypes =  false ? (0, _exactProp.default)(CssBaseline.propTypes, 'CssBaseline') : {};
CssBaseline.defaultProps = {
  children: null
};

var _default = (0, _styles.withStyles)(styles, {
  name: 'MuiCssBaseline'
})(CssBaseline);

exports.default = _default;

/***/ }),
/* 951 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Dialog.default;
  }
});

var _Dialog = _interopRequireDefault(__webpack_require__(952));

/***/ }),
/* 952 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(8));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(11));

var _objectSpread2 = _interopRequireDefault(__webpack_require__(23));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _classnames = _interopRequireDefault(__webpack_require__(6));

var _withStyles = _interopRequireDefault(__webpack_require__(5));

var _helpers = __webpack_require__(36);

var _Modal = _interopRequireDefault(__webpack_require__(226));

var _Fade = _interopRequireDefault(__webpack_require__(307));

var _transitions = __webpack_require__(78);

var _Paper = _interopRequireDefault(__webpack_require__(69));

// @inheritedComponent Modal
var styles = function styles(theme) {
  return {
    root: {
      justifyContent: 'center',
      alignItems: 'center'
    },
    paper: {
      display: 'flex',
      margin: theme.spacing.unit * 4,
      flexDirection: 'column',
      flex: '0 1 auto',
      position: 'relative',
      maxHeight: '90vh',
      overflowY: 'auto',
      // Fix IE11 issue, to remove at some point.
      // We disable the focus ring for mouse, touch and keyboard users.
      outline: 'none'
    },
    paperWidthXs: {
      maxWidth: Math.max(theme.breakpoints.values.xs, 360)
    },
    paperWidthSm: {
      maxWidth: theme.breakpoints.values.sm
    },
    paperWidthMd: {
      maxWidth: theme.breakpoints.values.md
    },
    paperFullWidth: {
      width: '100%'
    },
    paperFullScreen: {
      margin: 0,
      width: '100%',
      maxWidth: '100%',
      height: '100%',
      maxHeight: '100%',
      borderRadius: 0
    }
  };
};
/**
 * Dialogs are overlaid modal paper based components with a backdrop.
 */


exports.styles = styles;

function Dialog(props) {
  var _classNames;

  var BackdropProps = props.BackdropProps,
      children = props.children,
      classes = props.classes,
      className = props.className,
      disableBackdropClick = props.disableBackdropClick,
      disableEscapeKeyDown = props.disableEscapeKeyDown,
      fullScreen = props.fullScreen,
      fullWidth = props.fullWidth,
      maxWidth = props.maxWidth,
      onBackdropClick = props.onBackdropClick,
      onClose = props.onClose,
      onEnter = props.onEnter,
      onEntered = props.onEntered,
      onEntering = props.onEntering,
      onEscapeKeyDown = props.onEscapeKeyDown,
      onExit = props.onExit,
      onExited = props.onExited,
      onExiting = props.onExiting,
      open = props.open,
      PaperProps = props.PaperProps,
      TransitionComponent = props.TransitionComponent,
      transitionDuration = props.transitionDuration,
      TransitionProps = props.TransitionProps,
      other = (0, _objectWithoutProperties2.default)(props, ["BackdropProps", "children", "classes", "className", "disableBackdropClick", "disableEscapeKeyDown", "fullScreen", "fullWidth", "maxWidth", "onBackdropClick", "onClose", "onEnter", "onEntered", "onEntering", "onEscapeKeyDown", "onExit", "onExited", "onExiting", "open", "PaperProps", "TransitionComponent", "transitionDuration", "TransitionProps"]);
  return _react.default.createElement(_Modal.default, (0, _extends2.default)({
    className: (0, _classnames.default)(classes.root, className),
    BackdropProps: (0, _objectSpread2.default)({
      transitionDuration: transitionDuration
    }, BackdropProps),
    disableBackdropClick: disableBackdropClick,
    disableEscapeKeyDown: disableEscapeKeyDown,
    onBackdropClick: onBackdropClick,
    onEscapeKeyDown: onEscapeKeyDown,
    onClose: onClose,
    open: open,
    role: "dialog"
  }, other), _react.default.createElement(TransitionComponent, (0, _extends2.default)({
    appear: true,
    "in": open,
    timeout: transitionDuration,
    onEnter: onEnter,
    onEntering: onEntering,
    onEntered: onEntered,
    onExit: onExit,
    onExiting: onExiting,
    onExited: onExited
  }, TransitionProps), _react.default.createElement(_Paper.default, (0, _extends2.default)({
    elevation: 24,
    className: (0, _classnames.default)(classes.paper, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes["paperWidth".concat(maxWidth ? (0, _helpers.capitalize)(maxWidth) : '')], maxWidth), (0, _defineProperty2.default)(_classNames, classes.paperFullScreen, fullScreen), (0, _defineProperty2.default)(_classNames, classes.paperFullWidth, fullWidth), _classNames))
  }, PaperProps), children)));
}

Dialog.propTypes =  false ? {
  /**
   * @ignore
   */
  BackdropProps: _propTypes.default.object,

  /**
   * Dialog children, usually the included sub-components.
   */
  children: _propTypes.default.node.isRequired,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * If `true`, clicking the backdrop will not fire the `onClose` callback.
   */
  disableBackdropClick: _propTypes.default.bool,

  /**
   * If `true`, hitting escape will not fire the `onClose` callback.
   */
  disableEscapeKeyDown: _propTypes.default.bool,

  /**
   * If `true`, the dialog will be full-screen
   */
  fullScreen: _propTypes.default.bool,

  /**
   * If `true`, the dialog stretches to `maxWidth`.
   */
  fullWidth: _propTypes.default.bool,

  /**
   * Determine the max width of the dialog.
   * The dialog width grows with the size of the screen, this property is useful
   * on the desktop where you might need some coherent different width size across your
   * application. Set to `false` to disable `maxWidth`.
   */
  maxWidth: _propTypes.default.oneOf(['xs', 'sm', 'md', false]),

  /**
   * Callback fired when the backdrop is clicked.
   */
  onBackdropClick: _propTypes.default.func,

  /**
   * Callback fired when the component requests to be closed.
   *
   * @param {object} event The event source of the callback
   */
  onClose: _propTypes.default.func,

  /**
   * Callback fired before the dialog enters.
   */
  onEnter: _propTypes.default.func,

  /**
   * Callback fired when the dialog has entered.
   */
  onEntered: _propTypes.default.func,

  /**
   * Callback fired when the dialog is entering.
   */
  onEntering: _propTypes.default.func,

  /**
   * Callback fired when the escape key is pressed,
   * `disableKeyboard` is false and the modal is in focus.
   */
  onEscapeKeyDown: _propTypes.default.func,

  /**
   * Callback fired before the dialog exits.
   */
  onExit: _propTypes.default.func,

  /**
   * Callback fired when the dialog has exited.
   */
  onExited: _propTypes.default.func,

  /**
   * Callback fired when the dialog is exiting.
   */
  onExiting: _propTypes.default.func,

  /**
   * If `true`, the Dialog is open.
   */
  open: _propTypes.default.bool.isRequired,

  /**
   * Properties applied to the `Paper` element.
   */
  PaperProps: _propTypes.default.object,

  /**
   * Transition component.
   */
  TransitionComponent: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func]),

  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   */
  transitionDuration: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
    enter: _propTypes.default.number,
    exit: _propTypes.default.number
  })]),

  /**
   * Properties applied to the `Transition` element.
   */
  TransitionProps: _propTypes.default.object
} : {};
Dialog.defaultProps = {
  disableBackdropClick: false,
  disableEscapeKeyDown: false,
  fullScreen: false,
  fullWidth: false,
  maxWidth: 'sm',
  TransitionComponent: _Fade.default,
  transitionDuration: {
    enter: _transitions.duration.enteringScreen,
    exit: _transitions.duration.leavingScreen
  }
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiDialog'
})(Dialog);

exports.default = _default;

/***/ }),
/* 953 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(8));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(11));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(18));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(20));

var _createClass2 = _interopRequireDefault(__webpack_require__(19));

var _inherits2 = _interopRequireDefault(__webpack_require__(21));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(127));

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactDom = _interopRequireDefault(__webpack_require__(45));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _classnames = _interopRequireDefault(__webpack_require__(6));

var _warning = _interopRequireDefault(__webpack_require__(32));

var _keycode = _interopRequireDefault(__webpack_require__(133));

var _activeElement = _interopRequireDefault(__webpack_require__(487));

var _contains = _interopRequireDefault(__webpack_require__(218));

var _inDOM = _interopRequireDefault(__webpack_require__(167));

var _ownerDocument = _interopRequireDefault(__webpack_require__(71));

var _RootRef = _interopRequireDefault(__webpack_require__(488));

var _Portal = _interopRequireDefault(__webpack_require__(322));

var _helpers = __webpack_require__(36);

var _withStyles = _interopRequireDefault(__webpack_require__(5));

var _ModalManager = _interopRequireDefault(__webpack_require__(489));

var _Backdrop = _interopRequireDefault(__webpack_require__(471));

// @inheritedComponent Portal
function getContainer(container, defaultContainer) {
  container = typeof container === 'function' ? container() : container;
  return _reactDom.default.findDOMNode(container) || defaultContainer;
}

function getHasTransition(props) {
  return props.children ? props.children.props.hasOwnProperty('in') : false;
}

var styles = function styles(theme) {
  return {
    root: {
      display: 'flex',
      width: '100%',
      height: '100%',
      position: 'fixed',
      zIndex: theme.zIndex.modal,
      top: 0,
      left: 0
    },
    hidden: {
      visibility: 'hidden'
    }
  };
};

exports.styles = styles;

var Modal =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(Modal, _React$Component);
  (0, _createClass2.default)(Modal, null, [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps) {
      if (nextProps.open) {
        return {
          exited: false
        };
      } else if (!getHasTransition(nextProps)) {
        // Otherwise let handleExited take care of marking exited.
        return {
          exited: true
        };
      }

      return null;
    }
  }]);

  function Modal(props) {
    var _this;

    (0, _classCallCheck2.default)(this, Modal);
    _this = (0, _possibleConstructorReturn2.default)(this, (Modal.__proto__ || Object.getPrototypeOf(Modal)).call(this, props));
    _this.dialogElement = null;
    _this.mounted = false;
    _this.mountNode = null;

    _this.handleRendered = function () {
      _this.autoFocus();

      if (_this.props.onRendered) {
        _this.props.onRendered();
      }
    };

    _this.handleOpen = function () {
      var doc = (0, _ownerDocument.default)(_this.mountNode);
      var container = getContainer(_this.props.container, doc.body);

      _this.props.manager.add((0, _assertThisInitialized2.default)(_this), container);

      doc.addEventListener('keydown', _this.handleDocumentKeyDown);
      doc.addEventListener('focus', _this.enforceFocus, true);
    };

    _this.handleClose = function () {
      _this.props.manager.remove((0, _assertThisInitialized2.default)(_this));

      var doc = (0, _ownerDocument.default)(_this.mountNode);
      doc.removeEventListener('keydown', _this.handleDocumentKeyDown);
      doc.removeEventListener('focus', _this.enforceFocus);

      _this.restoreLastFocus();
    };

    _this.handleExited = function () {
      _this.setState({
        exited: true
      });

      _this.handleClose();
    };

    _this.handleBackdropClick = function (event) {
      if (event.target !== event.currentTarget) {
        return;
      }

      if (_this.props.onBackdropClick) {
        _this.props.onBackdropClick(event);
      }

      if (!_this.props.disableBackdropClick && _this.props.onClose) {
        _this.props.onClose(event, 'backdropClick');
      }
    };

    _this.handleDocumentKeyDown = function (event) {
      if (!_this.isTopModal() || (0, _keycode.default)(event) !== 'esc') {
        return;
      }

      if (_this.props.onEscapeKeyDown) {
        _this.props.onEscapeKeyDown(event);
      }

      if (!_this.props.disableEscapeKeyDown && _this.props.onClose) {
        _this.props.onClose(event, 'escapeKeyDown');
      }
    };

    _this.checkForFocus = function () {
      if (_inDOM.default) {
        _this.lastFocus = (0, _activeElement.default)();
      }
    };

    _this.enforceFocus = function () {
      if (_this.props.disableEnforceFocus || !_this.mounted || !_this.isTopModal()) {
        return;
      }

      var currentActiveElement = (0, _activeElement.default)((0, _ownerDocument.default)(_this.mountNode));

      if (_this.dialogElement && !(0, _contains.default)(_this.dialogElement, currentActiveElement)) {
        _this.dialogElement.focus();
      }
    };

    _this.state = {
      exited: !_this.props.open
    };
    return _this;
  }

  (0, _createClass2.default)(Modal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.mounted = true;

      if (this.props.open) {
        this.handleOpen();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (!prevProps.open && this.props.open) {
        this.checkForFocus();
      }

      if (prevProps.open && !this.props.open && !getHasTransition(this.props)) {
        // Otherwise handleExited will call this.
        this.handleClose();
      } else if (!prevProps.open && this.props.open) {
        this.handleOpen();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.mounted = false;

      if (this.props.open || getHasTransition(this.props) && !this.state.exited) {
        this.handleClose();
      }
    }
  }, {
    key: "autoFocus",
    value: function autoFocus() {
      if (this.props.disableAutoFocus) {
        return;
      }

      var currentActiveElement = (0, _activeElement.default)((0, _ownerDocument.default)(this.mountNode));

      if (this.dialogElement && !(0, _contains.default)(this.dialogElement, currentActiveElement)) {
        this.lastFocus = currentActiveElement;

        if (!this.dialogElement.hasAttribute('tabIndex')) {
           false ? (0, _warning.default)(false, ['Material-UI: the modal content node does not accept focus.', 'For the benefit of assistive technologies, ' + 'the tabIndex of the node is being set to "-1".'].join('\n')) : void 0;
          this.dialogElement.setAttribute('tabIndex', -1);
        }

        this.dialogElement.focus();
      }
    }
  }, {
    key: "restoreLastFocus",
    value: function restoreLastFocus() {
      if (this.props.disableRestoreFocus) {
        return;
      }

      if (this.lastFocus) {
        // Not all elements in IE11 have a focus method.
        // Because IE11 market share is low, we accept the restore focus being broken
        // and we silent the issue.
        if (this.lastFocus.focus) {
          this.lastFocus.focus();
        }

        this.lastFocus = null;
      }
    }
  }, {
    key: "isTopModal",
    value: function isTopModal() {
      return this.props.manager.isTopModal(this);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          BackdropComponent = _props.BackdropComponent,
          BackdropProps = _props.BackdropProps,
          children = _props.children,
          classes = _props.classes,
          className = _props.className,
          container = _props.container,
          disableAutoFocus = _props.disableAutoFocus,
          disableBackdropClick = _props.disableBackdropClick,
          disableEnforceFocus = _props.disableEnforceFocus,
          disableEscapeKeyDown = _props.disableEscapeKeyDown,
          disableRestoreFocus = _props.disableRestoreFocus,
          hideBackdrop = _props.hideBackdrop,
          keepMounted = _props.keepMounted,
          onBackdropClick = _props.onBackdropClick,
          onClose = _props.onClose,
          onEscapeKeyDown = _props.onEscapeKeyDown,
          onRendered = _props.onRendered,
          open = _props.open,
          manager = _props.manager,
          other = (0, _objectWithoutProperties2.default)(_props, ["BackdropComponent", "BackdropProps", "children", "classes", "className", "container", "disableAutoFocus", "disableBackdropClick", "disableEnforceFocus", "disableEscapeKeyDown", "disableRestoreFocus", "hideBackdrop", "keepMounted", "onBackdropClick", "onClose", "onEscapeKeyDown", "onRendered", "open", "manager"]);
      var exited = this.state.exited;
      var hasTransition = getHasTransition(this.props);
      var childProps = {};

      if (!keepMounted && !open && (!hasTransition || exited)) {
        return null;
      } // It's a Transition like component


      if (hasTransition) {
        childProps.onExited = (0, _helpers.createChainedFunction)(this.handleExited, children.props.onExited);
      }

      if (children.props.role === undefined) {
        childProps.role = children.props.role || 'document';
      }

      if (children.props.tabIndex === undefined) {
        childProps.tabIndex = children.props.tabIndex || '-1';
      }

      return _react.default.createElement(_Portal.default, {
        ref: function ref(node) {
          _this2.mountNode = node ? node.getMountNode() : node;
        },
        container: container,
        onRendered: this.handleRendered
      }, _react.default.createElement("div", (0, _extends2.default)({
        className: (0, _classnames.default)(classes.root, className, (0, _defineProperty2.default)({}, classes.hidden, exited))
      }, other), hideBackdrop ? null : _react.default.createElement(BackdropComponent, (0, _extends2.default)({
        open: open,
        onClick: this.handleBackdropClick
      }, BackdropProps)), _react.default.createElement(_RootRef.default, {
        rootRef: function rootRef(node) {
          _this2.dialogElement = node;
        }
      }, _react.default.cloneElement(children, childProps))));
    }
  }]);
  return Modal;
}(_react.default.Component);

Modal.propTypes =  false ? {
  /**
   * A backdrop component. This property enables custom backdrop rendering.
   */
  BackdropComponent: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func]),

  /**
   * Properties applied to the `Backdrop` element.
   */
  BackdropProps: _propTypes.default.object,

  /**
   * A single child content element.
   */
  children: _propTypes.default.element,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * A node, component instance, or function that returns either.
   * The `container` will have the portal children appended to it.
   */
  container: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.func]),

  /**
   * If `true`, the modal will not automatically shift focus to itself when it opens, and
   * replace it to the last focused element when it closes.
   * This also works correctly with any modal children that have the `disableAutoFocus` prop.
   *
   * Generally this should never be set to `true` as it makes the modal less
   * accessible to assistive technologies, like screen readers.
   */
  disableAutoFocus: _propTypes.default.bool,

  /**
   * If `true`, clicking the backdrop will not fire any callback.
   */
  disableBackdropClick: _propTypes.default.bool,

  /**
   * If `true`, the modal will not prevent focus from leaving the modal while open.
   *
   * Generally this should never be set to `true` as it makes the modal less
   * accessible to assistive technologies, like screen readers.
   */
  disableEnforceFocus: _propTypes.default.bool,

  /**
   * If `true`, hitting escape will not fire any callback.
   */
  disableEscapeKeyDown: _propTypes.default.bool,

  /**
   * If `true`, the modal will not restore focus to previously focused element once
   * modal is hidden.
   */
  disableRestoreFocus: _propTypes.default.bool,

  /**
   * If `true`, the backdrop is not rendered.
   */
  hideBackdrop: _propTypes.default.bool,

  /**
   * Always keep the children in the DOM.
   * This property can be useful in SEO situation or
   * when you want to maximize the responsiveness of the Modal.
   */
  keepMounted: _propTypes.default.bool,

  /**
   * A modal manager used to track and manage the state of open
   * Modals. This enables customizing how modals interact within a container.
   */
  manager: _propTypes.default.object,

  /**
   * Callback fired when the backdrop is clicked.
   */
  onBackdropClick: _propTypes.default.func,

  /**
   * Callback fired when the component requests to be closed.
   * The `reason` parameter can optionally be used to control the response to `onClose`.
   *
   * @param {object} event The event source of the callback
   * @param {string} reason Can be:`"escapeKeyDown"`, `"backdropClick"`
   */
  onClose: _propTypes.default.func,

  /**
   * Callback fired when the escape key is pressed,
   * `disableEscapeKeyDown` is false and the modal is in focus.
   */
  onEscapeKeyDown: _propTypes.default.func,

  /**
   * Callback fired once the children has been mounted into the `container`.
   * It signals that the `open={true}` property took effect.
   */
  onRendered: _propTypes.default.func,

  /**
   * If `true`, the modal is open.
   */
  open: _propTypes.default.bool.isRequired
} : {};
Modal.defaultProps = {
  disableAutoFocus: false,
  disableBackdropClick: false,
  disableEnforceFocus: false,
  disableEscapeKeyDown: false,
  disableRestoreFocus: false,
  hideBackdrop: false,
  keepMounted: false,
  // Modals don't open on the server so this won't conflict with concurrent requests.
  manager: new _ModalManager.default(),
  BackdropComponent: _Backdrop.default
};

var _default = (0, _withStyles.default)(styles, {
  flip: false,
  name: 'MuiModal'
})(Modal);

exports.default = _default;

/***/ }),
/* 954 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(18));

var _createClass2 = _interopRequireDefault(__webpack_require__(19));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(20));

var _inherits2 = _interopRequireDefault(__webpack_require__(21));

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactDom = _interopRequireDefault(__webpack_require__(45));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _exactProp = _interopRequireDefault(__webpack_require__(166));

/**
 * Helper component to allow attaching a ref to a
 * wrapped element to access the underlying DOM element.
 *
 * It's higly inspired by https://github.com/facebook/react/issues/11401#issuecomment-340543801.
 * For example:
 * ```jsx
 * import React from 'react';
 * import RootRef from '@material-ui/core/RootRef';
 *
 * class MyComponent extends React.Component {
 *   constructor(props) {
 *     super(props);
 *     this.domRef = React.createRef();
 *   }
 *
 *   componentDidMount() {
 *     console.log(this.domRef.current); // DOM node
 *   }
 *
 *   render() {
 *     return (
 *       <RootRef rootRef={this.domRef}>
 *         <SomeChildComponent />
 *       </RootRef>
 *     );
 *   }
 * }
 * ```
 */
var RootRef =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(RootRef, _React$Component);

  function RootRef() {
    (0, _classCallCheck2.default)(this, RootRef);
    return (0, _possibleConstructorReturn2.default)(this, (RootRef.__proto__ || Object.getPrototypeOf(RootRef)).apply(this, arguments));
  }

  (0, _createClass2.default)(RootRef, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var rootRef = this.props.rootRef;

      var node = _reactDom.default.findDOMNode(this);

      if (typeof rootRef === 'function') {
        rootRef(node);
      } else if (rootRef) {
        rootRef.current = node;
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var rootRef = this.props.rootRef;

      if (typeof rootRef === 'function') {
        rootRef(null);
      } else if (rootRef) {
        rootRef.current = null;
      }
    }
  }, {
    key: "render",
    value: function render() {
      return this.props.children;
    }
  }]);
  return RootRef;
}(_react.default.Component);

RootRef.propTypes =  false ? {
  /**
   * The wrapped element.
   */
  children: _propTypes.default.element.isRequired,

  /**
   * Provide a way to access the DOM node of the wrapped element.
   * You can provide a callback ref or a `React.createRef()` ref.
   */
  rootRef: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.object]).isRequired
} : {};
RootRef.propTypes =  false ? (0, _exactProp.default)(RootRef.propTypes, 'RootRef') : {};
var _default = RootRef;
exports.default = _default;

/***/ }),
/* 955 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(18));

var _createClass2 = _interopRequireDefault(__webpack_require__(19));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(20));

var _inherits2 = _interopRequireDefault(__webpack_require__(21));

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactDom = _interopRequireDefault(__webpack_require__(45));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _ownerDocument = _interopRequireDefault(__webpack_require__(71));

var _exactProp = _interopRequireDefault(__webpack_require__(166));

function getContainer(container, defaultContainer) {
  container = typeof container === 'function' ? container() : container;
  return _reactDom.default.findDOMNode(container) || defaultContainer;
}

function getOwnerDocument(element) {
  return (0, _ownerDocument.default)(_reactDom.default.findDOMNode(element));
}
/**
 * This component shares many concepts with
 * [react-overlays](https://react-bootstrap.github.io/react-overlays/#portals)
 * But has been forked in order to fix some bugs, reduce the number of dependencies
 * and take the control of our destiny.
 */


var Portal =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(Portal, _React$Component);

  function Portal() {
    var _ref;

    var _temp, _this;

    (0, _classCallCheck2.default)(this, Portal);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return (0, _possibleConstructorReturn2.default)(_this, (_temp = _this = (0, _possibleConstructorReturn2.default)(this, (_ref = Portal.__proto__ || Object.getPrototypeOf(Portal)).call.apply(_ref, [this].concat(args))), _this.getMountNode = function () {
      return _this.mountNode;
    }, _temp));
  }

  (0, _createClass2.default)(Portal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setContainer(this.props.container);
      this.forceUpdate(this.props.onRendered);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.container !== this.props.container) {
        this.setContainer(this.props.container);
        this.forceUpdate();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.mountNode = null;
    }
  }, {
    key: "setContainer",
    value: function setContainer(container) {
      this.mountNode = getContainer(container, getOwnerDocument(this).body);
    }
    /**
     * @public
     */

  }, {
    key: "render",
    value: function render() {
      var children = this.props.children;
      return this.mountNode ? _reactDom.default.createPortal(children, this.mountNode) : null;
    }
  }]);
  return Portal;
}(_react.default.Component);

Portal.propTypes =  false ? {
  /**
   * The children to render into the `container`.
   */
  children: _propTypes.default.node.isRequired,

  /**
   * A node, component instance, or function that returns either.
   * The `container` will have the portal children appended to it.
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.func]),

  /**
   * Callback fired once the children has been mounted into the `container`.
   */
  onRendered: _propTypes.default.func
} : {};
Portal.propTypes =  false ? (0, _exactProp.default)(Portal.propTypes, 'Portal') : {};
var _default = Portal;
exports.default = _default;

/***/ }),
/* 956 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(72);

exports.__esModule = true;
exports.default = style;

var _camelizeStyle = _interopRequireDefault(__webpack_require__(490));

var _hyphenateStyle = _interopRequireDefault(__webpack_require__(958));

var _getComputedStyle2 = _interopRequireDefault(__webpack_require__(960));

var _removeStyle = _interopRequireDefault(__webpack_require__(961));

var _properties = __webpack_require__(491);

var _isTransform = _interopRequireDefault(__webpack_require__(962));

function style(node, property, value) {
  var css = '';
  var transforms = '';
  var props = property;

  if (typeof property === 'string') {
    if (value === undefined) {
      return node.style[(0, _camelizeStyle.default)(property)] || (0, _getComputedStyle2.default)(node).getPropertyValue((0, _hyphenateStyle.default)(property));
    } else {
      (props = {})[property] = value;
    }
  }

  Object.keys(props).forEach(function (key) {
    var value = props[key];

    if (!value && value !== 0) {
      (0, _removeStyle.default)(node, (0, _hyphenateStyle.default)(key));
    } else if ((0, _isTransform.default)(key)) {
      transforms += key + "(" + value + ") ";
    } else {
      css += (0, _hyphenateStyle.default)(key) + ": " + value + ";";
    }
  });

  if (transforms) {
    css += _properties.transform + ": " + transforms + ";";
  }

  node.style.cssText += ';' + css;
}

module.exports = exports["default"];

/***/ }),
/* 957 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = camelize;
var rHyphen = /-(.)/g;

function camelize(string) {
  return string.replace(rHyphen, function (_, chr) {
    return chr.toUpperCase();
  });
}

module.exports = exports["default"];

/***/ }),
/* 958 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(72);

exports.__esModule = true;
exports.default = hyphenateStyleName;

var _hyphenate = _interopRequireDefault(__webpack_require__(959));

/**
 * Copyright 2013-2014, Facebook, Inc.
 * All rights reserved.
 * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/hyphenateStyleName.js
 */
var msPattern = /^ms-/;

function hyphenateStyleName(string) {
  return (0, _hyphenate.default)(string).replace(msPattern, '-ms-');
}

module.exports = exports["default"];

/***/ }),
/* 959 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = hyphenate;
var rUpper = /([A-Z])/g;

function hyphenate(string) {
  return string.replace(rUpper, '-$1').toLowerCase();
}

module.exports = exports["default"];

/***/ }),
/* 960 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(72);

exports.__esModule = true;
exports.default = _getComputedStyle;

var _camelizeStyle = _interopRequireDefault(__webpack_require__(490));

var rposition = /^(top|right|bottom|left)$/;
var rnumnonpx = /^([+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|))(?!px)[a-z%]+$/i;

function _getComputedStyle(node) {
  if (!node) throw new TypeError('No Element passed to `getComputedStyle()`');
  var doc = node.ownerDocument;
  return 'defaultView' in doc ? doc.defaultView.opener ? node.ownerDocument.defaultView.getComputedStyle(node, null) : window.getComputedStyle(node, null) : {
    //ie 8 "magic" from: https://github.com/jquery/jquery/blob/1.11-stable/src/css/curCSS.js#L72
    getPropertyValue: function getPropertyValue(prop) {
      var style = node.style;
      prop = (0, _camelizeStyle.default)(prop);
      if (prop == 'float') prop = 'styleFloat';
      var current = node.currentStyle[prop] || null;
      if (current == null && style && style[prop]) current = style[prop];

      if (rnumnonpx.test(current) && !rposition.test(prop)) {
        // Remember the original values
        var left = style.left;
        var runStyle = node.runtimeStyle;
        var rsLeft = runStyle && runStyle.left; // Put in the new values to get a computed value out

        if (rsLeft) runStyle.left = node.currentStyle.left;
        style.left = prop === 'fontSize' ? '1em' : current;
        current = style.pixelLeft + 'px'; // Revert the changed values

        style.left = left;
        if (rsLeft) runStyle.left = rsLeft;
      }

      return current;
    }
  };
}

module.exports = exports["default"];

/***/ }),
/* 961 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = removeStyle;

function removeStyle(node, key) {
  return 'removeProperty' in node.style ? node.style.removeProperty(key) : node.style.removeAttribute(key);
}

module.exports = exports["default"];

/***/ }),
/* 962 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = isTransform;
var supportedTransforms = /^((translate|rotate|scale)(X|Y|Z|3d)?|matrix(3d)?|perspective|skew(X|Y)?)$/i;

function isTransform(property) {
  return !!(property && supportedTransforms.test(property));
}

module.exports = exports["default"];

/***/ }),
/* 963 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isBody = isBody;
exports.default = isOverflowing;

var _isWindow = _interopRequireDefault(__webpack_require__(964));

var _ownerDocument = _interopRequireDefault(__webpack_require__(71));

var _ownerWindow = _interopRequireDefault(__webpack_require__(217));

function isBody(node) {
  return node && node.tagName.toLowerCase() === 'body';
} // Do we have a scroll bar?


function isOverflowing(container) {
  var doc = (0, _ownerDocument.default)(container);
  var win = (0, _ownerWindow.default)(doc);
  /* istanbul ignore next */

  if (!(0, _isWindow.default)(doc) && !isBody(container)) {
    return container.scrollHeight > container.clientHeight;
  } // Takes in account potential non zero margin on the body.


  var style = win.getComputedStyle(doc.body);
  var marginLeft = parseInt(style.getPropertyValue('margin-left'), 10);
  var marginRight = parseInt(style.getPropertyValue('margin-right'), 10);
  return marginLeft + doc.body.clientWidth + marginRight < win.innerWidth;
}

/***/ }),
/* 964 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = getWindow;

function getWindow(node) {
  return node === node.window ? node : node.nodeType === 9 ? node.defaultView || node.parentWindow : false;
}

module.exports = exports["default"];

/***/ }),
/* 965 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ariaHidden = ariaHidden;
exports.hideSiblings = hideSiblings;
exports.showSiblings = showSiblings;
var BLACKLIST = ['template', 'script', 'style'];

function isHidable(node) {
  return node.nodeType === 1 && BLACKLIST.indexOf(node.tagName.toLowerCase()) === -1;
}

function siblings(container, mount, callback) {
  mount = [].concat(mount); // eslint-disable-line no-param-reassign

  [].forEach.call(container.children, function (node) {
    if (mount.indexOf(node) === -1 && isHidable(node)) {
      callback(node);
    }
  });
}

function ariaHidden(show, node) {
  if (!node) {
    return;
  }

  if (show) {
    node.setAttribute('aria-hidden', 'true');
  } else {
    node.removeAttribute('aria-hidden');
  }
}

function hideSiblings(container, mountNode) {
  siblings(container, mountNode, function (node) {
    return ariaHidden(true, node);
  });
}

function showSiblings(container, mountNode) {
  siblings(container, mountNode, function (node) {
    return ariaHidden(false, node);
  });
}

/***/ }),
/* 966 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _DialogActions.default;
  }
});

var _DialogActions = _interopRequireDefault(__webpack_require__(967));

/***/ }),
/* 967 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(8));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _classnames = _interopRequireDefault(__webpack_require__(6));

var _withStyles = _interopRequireDefault(__webpack_require__(5));

var _reactHelpers = __webpack_require__(105);

__webpack_require__(58);

// So we don't have any override priority issue.
var styles = function styles(theme) {
  return {
    root: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-end',
      flex: '0 0 auto',
      margin: "".concat(theme.spacing.unit, "px ").concat(theme.spacing.unit / 2, "px")
    },
    action: {
      margin: "0 ".concat(theme.spacing.unit / 2, "px"),
      minWidth: 64
    }
  };
};

exports.styles = styles;

function DialogActions(props) {
  var disableActionSpacing = props.disableActionSpacing,
      children = props.children,
      classes = props.classes,
      className = props.className,
      other = (0, _objectWithoutProperties2.default)(props, ["disableActionSpacing", "children", "classes", "className"]);
  return _react.default.createElement("div", (0, _extends2.default)({
    className: (0, _classnames.default)(classes.root, className)
  }, other), disableActionSpacing ? children : (0, _reactHelpers.cloneChildrenWithClassName)(children, classes.action));
}

DialogActions.propTypes =  false ? {
  /**
   * The content of the component.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * If `true`, the dialog actions do not have additional margin.
   */
  disableActionSpacing: _propTypes.default.bool
} : {};
DialogActions.defaultProps = {
  disableActionSpacing: false
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiDialogActions'
})(DialogActions);

exports.default = _default;

/***/ }),
/* 968 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _DialogContent.default;
  }
});

var _DialogContent = _interopRequireDefault(__webpack_require__(969));

/***/ }),
/* 969 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(8));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _classnames = _interopRequireDefault(__webpack_require__(6));

var _withStyles = _interopRequireDefault(__webpack_require__(5));

var styles = function styles(theme) {
  var spacing = theme.spacing.unit * 3;
  return {
    root: {
      flex: '1 1 auto',
      overflowY: 'auto',
      WebkitOverflowScrolling: 'touch',
      // Add iOS momentum scrolling.
      padding: "0 ".concat(spacing, "px ").concat(spacing, "px ").concat(spacing, "px"),
      '&:first-child': {
        paddingTop: spacing
      }
    }
  };
};

exports.styles = styles;

function DialogContent(props) {
  var classes = props.classes,
      children = props.children,
      className = props.className,
      other = (0, _objectWithoutProperties2.default)(props, ["classes", "children", "className"]);
  return _react.default.createElement("div", (0, _extends2.default)({
    className: (0, _classnames.default)(classes.root, className)
  }, other), children);
}

DialogContent.propTypes =  false ? {
  /**
   * The content of the component.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string
} : {};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiDialogContent'
})(DialogContent);

exports.default = _default;

/***/ }),
/* 970 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _DialogContentText.default;
  }
});

var _DialogContentText = _interopRequireDefault(__webpack_require__(971));

/***/ }),
/* 971 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(8));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _classnames = _interopRequireDefault(__webpack_require__(6));

var _withStyles = _interopRequireDefault(__webpack_require__(5));

var _Typography = _interopRequireDefault(__webpack_require__(46));

// @inheritedComponent Typography
var styles = function styles(theme) {
  return {
    root: {
      color: theme.palette.text.secondary
    }
  };
};

exports.styles = styles;

function DialogContentText(props) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className"]);
  return _react.default.createElement(_Typography.default, (0, _extends2.default)({
    component: "p",
    variant: "subheading",
    className: (0, _classnames.default)(classes.root, className)
  }, other), children);
}

DialogContentText.propTypes =  false ? {
  /**
   * The content of the component.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string
} : {};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiDialogContentText'
})(DialogContentText);

exports.default = _default;

/***/ }),
/* 972 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _DialogTitle.default;
  }
});

var _DialogTitle = _interopRequireDefault(__webpack_require__(973));

/***/ }),
/* 973 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(8));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _classnames = _interopRequireDefault(__webpack_require__(6));

var _withStyles = _interopRequireDefault(__webpack_require__(5));

var _Typography = _interopRequireDefault(__webpack_require__(46));

var styles = function styles(theme) {
  return {
    root: {
      margin: 0,
      padding: "".concat(theme.spacing.unit * 3, "px ").concat(theme.spacing.unit * 3, "px       20px ").concat(theme.spacing.unit * 3, "px"),
      flex: '0 0 auto'
    }
  };
};

exports.styles = styles;

function DialogTitle(props) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      disableTypography = props.disableTypography,
      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "disableTypography"]);
  return _react.default.createElement("div", (0, _extends2.default)({
    className: (0, _classnames.default)(classes.root, className)
  }, other), disableTypography ? children : _react.default.createElement(_Typography.default, {
    variant: "title"
  }, children));
}

DialogTitle.propTypes =  false ? {
  /**
   * The content of the component.
   */
  children: _propTypes.default.node.isRequired,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * If `true`, the children won't be wrapped by a typography component.
   * For instance, this can be useful to render an h4 instead of the default h2.
   */
  disableTypography: _propTypes.default.bool
} : {};
DialogTitle.defaultProps = {
  disableTypography: false
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiDialogTitle'
})(DialogTitle);

exports.default = _default;

/***/ }),
/* 974 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(8));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(11));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _classnames = _interopRequireDefault(__webpack_require__(6));

var _withStyles = _interopRequireDefault(__webpack_require__(5));

var _colorManipulator = __webpack_require__(90);

var styles = function styles(theme) {
  return {
    root: {
      height: 1,
      margin: 0,
      // Reset browser default style.
      border: 'none',
      flexShrink: 0,
      backgroundColor: theme.palette.divider
    },
    absolute: {
      position: 'absolute',
      bottom: 0,
      left: 0,
      width: '100%'
    },
    inset: {
      marginLeft: theme.spacing.unit * 9
    },
    light: {
      backgroundColor: (0, _colorManipulator.fade)(theme.palette.divider, 0.08)
    }
  };
};

exports.styles = styles;

function Divider(props) {
  var _classNames;

  var absolute = props.absolute,
      classes = props.classes,
      classNameProp = props.className,
      Component = props.component,
      inset = props.inset,
      light = props.light,
      other = (0, _objectWithoutProperties2.default)(props, ["absolute", "classes", "className", "component", "inset", "light"]);
  var className = (0, _classnames.default)(classes.root, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes.absolute, absolute), (0, _defineProperty2.default)(_classNames, classes.inset, inset), (0, _defineProperty2.default)(_classNames, classes.light, light), _classNames), classNameProp);
  return _react.default.createElement(Component, (0, _extends2.default)({
    className: className
  }, other));
}

Divider.propTypes =  false ? {
  absolute: _propTypes.default.bool,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func]),

  /**
   * If `true`, the divider will be indented.
   */
  inset: _propTypes.default.bool,

  /**
   * If `true`, the divider will have a lighter color.
   */
  light: _propTypes.default.bool
} : {};
Divider.defaultProps = {
  absolute: false,
  component: 'hr',
  inset: false,
  light: false
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiDivider'
})(Divider);

exports.default = _default;

/***/ }),
/* 975 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setTranslateValue = setTranslateValue;
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(8));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _objectSpread2 = _interopRequireDefault(__webpack_require__(23));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(18));

var _createClass2 = _interopRequireDefault(__webpack_require__(19));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(20));

var _inherits2 = _interopRequireDefault(__webpack_require__(21));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _reactDom = _interopRequireDefault(__webpack_require__(45));

var _reactEventListener = _interopRequireDefault(__webpack_require__(73));

var _debounce = _interopRequireDefault(__webpack_require__(93));

var _Transition = _interopRequireDefault(__webpack_require__(131));

var _ownerWindow = _interopRequireDefault(__webpack_require__(217));

var _withTheme = _interopRequireDefault(__webpack_require__(91));

var _transitions = __webpack_require__(78);

var _utils = __webpack_require__(132);

// @inheritedComponent Transition
var GUTTER = 24; // Translate the node so he can't be seen on the screen.
// Later, we gonna translate back the node to his original location
// with `translate3d(0, 0, 0)`.`

function getTranslateValue(props, node) {
  var direction = props.direction;
  var rect = node.getBoundingClientRect();
  var transform;

  if (node.fakeTransform) {
    transform = node.fakeTransform;
  } else {
    var computedStyle = (0, _ownerWindow.default)(node).getComputedStyle(node);
    transform = computedStyle.getPropertyValue('-webkit-transform') || computedStyle.getPropertyValue('transform');
  }

  var offsetX = 0;
  var offsetY = 0;

  if (transform && transform !== 'none' && typeof transform === 'string') {
    var transformValues = transform.split('(')[1].split(')')[0].split(',');
    offsetX = parseInt(transformValues[4], 10);
    offsetY = parseInt(transformValues[5], 10);
  }

  if (direction === 'left') {
    return "translateX(100vw) translateX(-".concat(rect.left - offsetX, "px)");
  } else if (direction === 'right') {
    return "translateX(-".concat(rect.left + rect.width + GUTTER - offsetX, "px)");
  } else if (direction === 'up') {
    return "translateY(100vh) translateY(-".concat(rect.top - offsetY, "px)");
  } // direction === 'down'


  return "translateY(-".concat(rect.top + rect.height + GUTTER - offsetY, "px)");
}

function setTranslateValue(props, node) {
  var transform = getTranslateValue(props, node);

  if (transform) {
    node.style.webkitTransform = transform;
    node.style.transform = transform;
  }
}
/**
 * The Slide transition is used by the [Snackbar](/demos/snackbars) component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */


var Slide =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(Slide, _React$Component);

  function Slide() {
    var _ref;

    var _temp, _this;

    (0, _classCallCheck2.default)(this, Slide);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return (0, _possibleConstructorReturn2.default)(_this, (_temp = _this = (0, _possibleConstructorReturn2.default)(this, (_ref = Slide.__proto__ || Object.getPrototypeOf(Slide)).call.apply(_ref, [this].concat(args))), _this.mounted = false, _this.transition = null, _this.handleResize = (0, _debounce.default)(function () {
      // Skip configuration where the position is screen size invariant.
      if (_this.props.in || _this.props.direction === 'down' || _this.props.direction === 'right') {
        return;
      }

      var node = _reactDom.default.findDOMNode(_this.transition);

      if (node) {
        setTranslateValue(_this.props, node);
      }
    }, 166), _this.handleEnter = function (node) {
      setTranslateValue(_this.props, node);
      (0, _utils.reflow)(node);

      if (_this.props.onEnter) {
        _this.props.onEnter(node);
      }
    }, _this.handleEntering = function (node) {
      var theme = _this.props.theme;
      var transitionProps = (0, _utils.getTransitionProps)(_this.props, {
        mode: 'enter'
      });
      node.style.webkitTransition = theme.transitions.create('-webkit-transform', (0, _objectSpread2.default)({}, transitionProps, {
        easing: theme.transitions.easing.easeOut
      }));
      node.style.transition = theme.transitions.create('transform', (0, _objectSpread2.default)({}, transitionProps, {
        easing: theme.transitions.easing.easeOut
      }));
      node.style.webkitTransform = 'translate(0, 0)';
      node.style.transform = 'translate(0, 0)';

      if (_this.props.onEntering) {
        _this.props.onEntering(node);
      }
    }, _this.handleExit = function (node) {
      var theme = _this.props.theme;
      var transitionProps = (0, _utils.getTransitionProps)(_this.props, {
        mode: 'exit'
      });
      node.style.webkitTransition = theme.transitions.create('-webkit-transform', (0, _objectSpread2.default)({}, transitionProps, {
        easing: theme.transitions.easing.sharp
      }));
      node.style.transition = theme.transitions.create('transform', (0, _objectSpread2.default)({}, transitionProps, {
        easing: theme.transitions.easing.sharp
      }));
      setTranslateValue(_this.props, node);

      if (_this.props.onExit) {
        _this.props.onExit(node);
      }
    }, _this.handleExited = function (node) {
      // No need for transitions when the component is hidden
      node.style.webkitTransition = '';
      node.style.transition = '';

      if (_this.props.onExited) {
        _this.props.onExited(node);
      }
    }, _temp));
  }

  (0, _createClass2.default)(Slide, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // state.mounted handle SSR, once the component is mounted, we need
      // to properly hide it.
      if (!this.props.in) {
        // We need to set initial translate values of transition element
        // otherwise component will be shown when in=false.
        this.updatePosition();
      }

      this.mounted = true;
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.direction !== this.props.direction && !this.props.in) {
        // We need to update the position of the drawer when the direction change and
        // when it's hidden.
        this.updatePosition();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.handleResize.clear();
    }
  }, {
    key: "updatePosition",
    value: function updatePosition() {
      var node = _reactDom.default.findDOMNode(this.transition);

      if (node) {
        node.style.visibility = 'inherit';
        setTranslateValue(this.props, node);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          children = _props.children,
          onEnter = _props.onEnter,
          onEntering = _props.onEntering,
          onExit = _props.onExit,
          onExited = _props.onExited,
          styleProp = _props.style,
          theme = _props.theme,
          other = (0, _objectWithoutProperties2.default)(_props, ["children", "onEnter", "onEntering", "onExit", "onExited", "style", "theme"]);
      var style = {}; // We use this state to handle the server-side rendering.
      // We don't know the width of the children ahead of time.
      // We need to render it.

      if (!this.props.in && !this.mounted) {
        style.visibility = 'hidden';
      }

      style = (0, _objectSpread2.default)({}, style, styleProp, _react.default.isValidElement(children) ? children.props.style : {});
      return _react.default.createElement(_reactEventListener.default, {
        target: "window",
        onResize: this.handleResize
      }, _react.default.createElement(_Transition.default, (0, _extends2.default)({
        onEnter: this.handleEnter,
        onEntering: this.handleEntering,
        onExit: this.handleExit,
        onExited: this.handleExited,
        appear: true,
        style: style,
        ref: function ref(node) {
          _this2.transition = node;
        }
      }, other), children));
    }
  }]);
  return Slide;
}(_react.default.Component);

Slide.propTypes =  false ? {
  /**
   * A single child content element.
   */
  children: _propTypes.default.oneOfType([_propTypes.default.element, _propTypes.default.func]),

  /**
   * Direction the child node will enter from.
   */
  direction: _propTypes.default.oneOf(['left', 'right', 'up', 'down']),

  /**
   * If `true`, show the component; triggers the enter or exit animation.
   */
  in: _propTypes.default.bool,

  /**
   * @ignore
   */
  onEnter: _propTypes.default.func,

  /**
   * @ignore
   */
  onEntering: _propTypes.default.func,

  /**
   * @ignore
   */
  onExit: _propTypes.default.func,

  /**
   * @ignore
   */
  onExited: _propTypes.default.func,

  /**
   * @ignore
   */
  style: _propTypes.default.object,

  /**
   * @ignore
   */
  theme: _propTypes.default.object.isRequired,

  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   */
  timeout: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
    enter: _propTypes.default.number,
    exit: _propTypes.default.number
  })])
} : {};
Slide.defaultProps = {
  direction: 'down',
  timeout: {
    enter: _transitions.duration.enteringScreen,
    exit: _transitions.duration.leavingScreen
  }
};

var _default = (0, _withTheme.default)()(Slide);

exports.default = _default;

/***/ }),
/* 976 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _ExpansionPanel.default;
  }
});

var _ExpansionPanel = _interopRequireDefault(__webpack_require__(977));

/***/ }),
/* 977 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(8));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(11));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(18));

var _createClass2 = _interopRequireDefault(__webpack_require__(19));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(20));

var _inherits2 = _interopRequireDefault(__webpack_require__(21));

var _objectSpread2 = _interopRequireDefault(__webpack_require__(23));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _classnames = _interopRequireDefault(__webpack_require__(6));

var _Collapse = _interopRequireDefault(__webpack_require__(225));

var _Paper = _interopRequireDefault(__webpack_require__(69));

var _withStyles = _interopRequireDefault(__webpack_require__(5));

var _reactHelpers = __webpack_require__(105);

// @inheritedComponent Paper
// Workaround https://github.com/jsdom/jsdom/issues/2026
var edgeFix = typeof window !== 'undefined' && /jsdom/.test(window.navigator.userAgent) ? {} : {
  // Fix a rendering issue on Edge
  '@supports (-ms-ime-align: auto)': {
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0
  }
};

var styles = function styles(theme) {
  var transition = {
    duration: theme.transitions.duration.shortest
  };
  return {
    root: {
      position: 'relative',
      transition: theme.transitions.create(['margin'], transition),
      '&:before': {
        position: 'absolute',
        left: 0,
        top: -1,
        right: 0,
        height: 1,
        content: '""',
        opacity: 1,
        backgroundColor: theme.palette.divider,
        transition: theme.transitions.create(['opacity', 'background-color'], transition)
      },
      '&:first-child': {
        borderTopLeftRadius: 2,
        borderTopRightRadius: 2,
        '&:before': {
          display: 'none'
        }
      },
      '&:last-child': (0, _objectSpread2.default)({
        borderBottomLeftRadius: 2,
        borderBottomRightRadius: 2
      }, edgeFix),
      '&$expanded + &': {
        '&:before': {
          display: 'none'
        }
      }
    },
    expanded: {
      margin: "".concat(theme.spacing.unit * 2, "px 0"),
      '&:first-child': {
        marginTop: 0
      },
      '&:last-child': {
        marginBottom: 0
      },
      '&:before': {
        opacity: 0
      }
    },
    disabled: {
      backgroundColor: theme.palette.action.disabledBackground
    }
  };
};

exports.styles = styles;

var ExpansionPanel =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(ExpansionPanel, _React$Component);

  function ExpansionPanel(props) {
    var _this;

    (0, _classCallCheck2.default)(this, ExpansionPanel);
    _this = (0, _possibleConstructorReturn2.default)(this, (ExpansionPanel.__proto__ || Object.getPrototypeOf(ExpansionPanel)).call(this, props));
    _this.state = {};
    _this.isControlled = null;

    _this.handleChange = function (event) {
      var expanded = _this.isControlled ? _this.props.expanded : _this.state.expanded;

      if (!_this.isControlled) {
        _this.setState({
          expanded: !expanded
        });
      }

      if (_this.props.onChange) {
        _this.props.onChange(event, !expanded);
      }
    };

    _this.isControlled = props.expanded != null;

    if (!_this.isControlled) {
      // not controlled, use internal state
      _this.state.expanded = props.defaultExpanded !== undefined ? props.defaultExpanded : false;
    }

    return _this;
  }

  (0, _createClass2.default)(ExpansionPanel, [{
    key: "render",
    value: function render() {
      var _classNames,
          _this2 = this;

      var _props = this.props,
          childrenProp = _props.children,
          classes = _props.classes,
          classNameProp = _props.className,
          CollapsePropsProp = _props.CollapseProps,
          defaultExpanded = _props.defaultExpanded,
          disabled = _props.disabled,
          expandedProp = _props.expanded,
          onChange = _props.onChange,
          other = (0, _objectWithoutProperties2.default)(_props, ["children", "classes", "className", "CollapseProps", "defaultExpanded", "disabled", "expanded", "onChange"]);
      var expanded = this.isControlled ? expandedProp : this.state.expanded;
      var className = (0, _classnames.default)(classes.root, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes.expanded, expanded), (0, _defineProperty2.default)(_classNames, classes.disabled, disabled), _classNames), classNameProp);
      var summary = null;

      var children = _react.default.Children.map(childrenProp, function (child) {
        if (!_react.default.isValidElement(child)) {
          return null;
        }

        if ((0, _reactHelpers.isMuiElement)(child, ['ExpansionPanelSummary'])) {
          summary = _react.default.cloneElement(child, {
            disabled: disabled,
            expanded: expanded,
            onChange: _this2.handleChange
          });
          return null;
        }

        return child;
      });

      var CollapseProps = !expanded ? {
        'aria-hidden': 'true'
      } : null;
      return _react.default.createElement(_Paper.default, (0, _extends2.default)({
        className: className,
        elevation: 1,
        square: true
      }, other), summary, _react.default.createElement(_Collapse.default, (0, _extends2.default)({
        "in": expanded,
        timeout: "auto"
      }, CollapseProps, CollapsePropsProp), children));
    }
  }]);
  return ExpansionPanel;
}(_react.default.Component);

ExpansionPanel.propTypes =  false ? {
  /**
   * The content of the expansion panel.
   */
  children: _propTypes.default.node.isRequired,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * Properties applied to the `Collapse` element.
   */
  CollapseProps: _propTypes.default.object,

  /**
   * If `true`, expands the panel by default.
   */
  defaultExpanded: _propTypes.default.bool,

  /**
   * If `true`, the panel will be displayed in a disabled state.
   */
  disabled: _propTypes.default.bool,

  /**
   * If `true`, expands the panel, otherwise collapse it.
   * Setting this prop enables control over the panel.
   */
  expanded: _propTypes.default.bool,

  /**
   * Callback fired when the expand/collapse state is changed.
   *
   * @param {object} event The event source of the callback
   * @param {boolean} expanded The `expanded` state of the panel
   */
  onChange: _propTypes.default.func
} : {};
ExpansionPanel.defaultProps = {
  defaultExpanded: false,
  disabled: false
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiExpansionPanel'
})(ExpansionPanel);

exports.default = _default;

/***/ }),
/* 978 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _ExpansionPanelActions.default;
  }
});

var _ExpansionPanelActions = _interopRequireDefault(__webpack_require__(979));

/***/ }),
/* 979 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(8));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _classnames = _interopRequireDefault(__webpack_require__(6));

var _withStyles = _interopRequireDefault(__webpack_require__(5));

var _reactHelpers = __webpack_require__(105);

__webpack_require__(58);

// So we don't have any override priority issue.
var styles = function styles(theme) {
  return {
    root: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-end',
      padding: "".concat(theme.spacing.unit * 2, "px ").concat(theme.spacing.unit, "px")
    },
    action: {
      marginLeft: theme.spacing.unit
    }
  };
};

exports.styles = styles;

function ExpansionPanelActions(props) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className"]);
  return _react.default.createElement("div", (0, _extends2.default)({
    className: (0, _classnames.default)(classes.root, className)
  }, other), (0, _reactHelpers.cloneChildrenWithClassName)(children, classes.action));
}

ExpansionPanelActions.propTypes =  false ? {
  /**
   * The content of the component.
   */
  children: _propTypes.default.node.isRequired,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string
} : {};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiExpansionPanelActions'
})(ExpansionPanelActions);

exports.default = _default;

/***/ }),
/* 980 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _ExpansionPanelDetails.default;
  }
});

var _ExpansionPanelDetails = _interopRequireDefault(__webpack_require__(981));

/***/ }),
/* 981 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(8));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _classnames = _interopRequireDefault(__webpack_require__(6));

var _withStyles = _interopRequireDefault(__webpack_require__(5));

var styles = function styles(theme) {
  return {
    root: {
      display: 'flex',
      padding: "".concat(theme.spacing.unit, "px ").concat(theme.spacing.unit * 3, "px ").concat(theme.spacing.unit * 3, "px")
    }
  };
};

exports.styles = styles;

function ExpansionPanelDetails(props) {
  var classes = props.classes,
      children = props.children,
      className = props.className,
      other = (0, _objectWithoutProperties2.default)(props, ["classes", "children", "className"]);
  return _react.default.createElement("div", (0, _extends2.default)({
    className: (0, _classnames.default)(classes.root, className)
  }, other), children);
}

ExpansionPanelDetails.propTypes =  false ? {
  /**
   * The content of the expansion panel details.
   */
  children: _propTypes.default.node.isRequired,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string
} : {};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiExpansionPanelDetails'
})(ExpansionPanelDetails);

exports.default = _default;

/***/ }),
/* 982 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _ExpansionPanelSummary.default;
  }
});

var _ExpansionPanelSummary = _interopRequireDefault(__webpack_require__(983));

/***/ }),
/* 983 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(8));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(11));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(18));

var _createClass2 = _interopRequireDefault(__webpack_require__(19));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(20));

var _inherits2 = _interopRequireDefault(__webpack_require__(21));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _classnames = _interopRequireDefault(__webpack_require__(6));

var _ButtonBase = _interopRequireDefault(__webpack_require__(70));

var _IconButton = _interopRequireDefault(__webpack_require__(168));

var _withStyles = _interopRequireDefault(__webpack_require__(5));

// @inheritedComponent ButtonBase
var styles = function styles(theme) {
  var transition = {
    duration: theme.transitions.duration.shortest
  };
  return {
    root: {
      display: 'flex',
      minHeight: theme.spacing.unit * 6,
      transition: theme.transitions.create(['min-height', 'background-color'], transition),
      padding: "0 ".concat(theme.spacing.unit * 3, "px 0 ").concat(theme.spacing.unit * 3, "px"),
      '&:hover:not($disabled)': {
        cursor: 'pointer'
      },
      '&$expanded': {
        minHeight: 64
      },
      '&$focused': {
        backgroundColor: theme.palette.grey[300]
      },
      '&$disabled': {
        opacity: 0.38
      }
    },
    expanded: {},
    focused: {},
    disabled: {},
    content: {
      display: 'flex',
      flexGrow: 1,
      transition: theme.transitions.create(['margin'], transition),
      margin: '12px 0',
      '& > :last-child': {
        paddingRight: theme.spacing.unit * 4
      },
      '&$expanded': {
        margin: '20px 0'
      }
    },
    expandIcon: {
      position: 'absolute',
      top: '50%',
      right: theme.spacing.unit,
      transform: 'translateY(-50%) rotate(0deg)',
      transition: theme.transitions.create('transform', transition),
      '&:hover': {
        // Disable the hover effect for the IconButton,
        // because a hover effect should apply to the entire Expand button and
        // not only to the IconButton.
        backgroundColor: 'transparent'
      },
      '&$expanded': {
        transform: 'translateY(-50%) rotate(180deg)'
      }
    }
  };
};

exports.styles = styles;

var ExpansionPanelSummary =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(ExpansionPanelSummary, _React$Component);

  function ExpansionPanelSummary() {
    var _ref;

    var _temp, _this;

    (0, _classCallCheck2.default)(this, ExpansionPanelSummary);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return (0, _possibleConstructorReturn2.default)(_this, (_temp = _this = (0, _possibleConstructorReturn2.default)(this, (_ref = ExpansionPanelSummary.__proto__ || Object.getPrototypeOf(ExpansionPanelSummary)).call.apply(_ref, [this].concat(args))), _this.state = {
      focused: false
    }, _this.handleFocus = function () {
      _this.setState({
        focused: true
      });
    }, _this.handleBlur = function () {
      _this.setState({
        focused: false
      });
    }, _this.handleChange = function (event) {
      var _this$props = _this.props,
          onChange = _this$props.onChange,
          onClick = _this$props.onClick;

      if (onChange) {
        onChange(event);
      }

      if (onClick) {
        onClick(event);
      }
    }, _temp));
  }

  (0, _createClass2.default)(ExpansionPanelSummary, [{
    key: "render",
    value: function render() {
      var _classNames;

      var _props = this.props,
          children = _props.children,
          classes = _props.classes,
          className = _props.className,
          disabled = _props.disabled,
          expanded = _props.expanded,
          expandIcon = _props.expandIcon,
          onChange = _props.onChange,
          other = (0, _objectWithoutProperties2.default)(_props, ["children", "classes", "className", "disabled", "expanded", "expandIcon", "onChange"]);
      var focused = this.state.focused;
      return _react.default.createElement(_ButtonBase.default, (0, _extends2.default)({
        focusRipple: false,
        disableRipple: true,
        disabled: disabled,
        component: "div",
        "aria-expanded": expanded,
        className: (0, _classnames.default)(classes.root, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes.disabled, disabled), (0, _defineProperty2.default)(_classNames, classes.expanded, expanded), (0, _defineProperty2.default)(_classNames, classes.focused, focused), _classNames), className)
      }, other, {
        onFocusVisible: this.handleFocus,
        onBlur: this.handleBlur,
        onClick: this.handleChange
      }), _react.default.createElement("div", {
        className: (0, _classnames.default)(classes.content, (0, _defineProperty2.default)({}, classes.expanded, expanded))
      }, children), expandIcon && _react.default.createElement(_IconButton.default, {
        disabled: disabled,
        className: (0, _classnames.default)(classes.expandIcon, (0, _defineProperty2.default)({}, classes.expanded, expanded)),
        component: "div",
        tabIndex: -1,
        "aria-hidden": "true"
      }, expandIcon));
    }
  }]);
  return ExpansionPanelSummary;
}(_react.default.Component);

ExpansionPanelSummary.propTypes =  false ? {
  /**
   * The content of the expansion panel summary.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * @ignore
   * If `true`, the summary will be displayed in a disabled state.
   */
  disabled: _propTypes.default.bool,

  /**
   * @ignore
   * If `true`, expands the summary, otherwise collapse it.
   */
  expanded: _propTypes.default.bool,

  /**
   * The icon to display as the expand indicator.
   */
  expandIcon: _propTypes.default.node,

  /**
   * @ignore
   */
  onChange: _propTypes.default.func,

  /**
   * @ignore
   */
  onClick: _propTypes.default.func
} : {};
ExpansionPanelSummary.defaultProps = {
  disabled: false
};
ExpansionPanelSummary.muiName = 'ExpansionPanelSummary';

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiExpansionPanelSummary'
})(ExpansionPanelSummary);

exports.default = _default;

/***/ }),
/* 984 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(8));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(11));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(18));

var _createClass2 = _interopRequireDefault(__webpack_require__(19));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(20));

var _inherits2 = _interopRequireDefault(__webpack_require__(21));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _classnames = _interopRequireDefault(__webpack_require__(6));

var _withStyles = _interopRequireDefault(__webpack_require__(5));

var _Input = __webpack_require__(326);

var _helpers = __webpack_require__(36);

var _reactHelpers = __webpack_require__(105);

var styles = function styles(theme) {
  return {
    root: {
      display: 'inline-flex',
      flexDirection: 'column',
      position: 'relative',
      // Reset fieldset default style
      minWidth: 0,
      padding: 0,
      margin: 0,
      border: 0
    },
    marginNormal: {
      marginTop: theme.spacing.unit * 2,
      marginBottom: theme.spacing.unit
    },
    marginDense: {
      marginTop: theme.spacing.unit,
      marginBottom: theme.spacing.unit / 2
    },
    fullWidth: {
      width: '100%'
    }
  };
};
/**
 * Provides context such as filled/focused/error/required for form inputs.
 * Relying on the context provides high flexibilty and ensures that the state always stays
 * consitent across the children of the `FormControl`.
 * This context is used by the following components:
 *  - FormLabel
 *  - FormHelperText
 *  - Input
 *  - InputLabel
 */


exports.styles = styles;

var FormControl =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(FormControl, _React$Component);

  function FormControl(props) {
    var _this;

    (0, _classCallCheck2.default)(this, FormControl);
    _this = (0, _possibleConstructorReturn2.default)(this, (FormControl.__proto__ || Object.getPrototypeOf(FormControl)).call(this, props)); // We need to iterate through the children and find the Input in order
    // to fully support server side rendering.

    _this.state = {
      adornedStart: false,
      filled: false,
      focused: false
    };

    _this.handleFocus = function (event) {
      if (_this.props.onFocus) {
        _this.props.onFocus(event);
      }

      _this.setState(function (state) {
        return !state.focused ? {
          focused: true
        } : null;
      });
    };

    _this.handleBlur = function (event) {
      // The event might be undefined.
      // For instance, a child component might call this hook
      // when an input is disabled but still having the focus.
      if (_this.props.onBlur && event) {
        _this.props.onBlur(event);
      }

      _this.setState(function (state) {
        return state.focused ? {
          focused: false
        } : null;
      });
    };

    _this.handleDirty = function () {
      if (!_this.state.filled) {
        _this.setState({
          filled: true
        });
      }
    };

    _this.handleClean = function () {
      if (_this.state.filled) {
        _this.setState({
          filled: false
        });
      }
    };

    var children = _this.props.children;

    if (children) {
      _react.default.Children.forEach(children, function (child) {
        if (!(0, _reactHelpers.isMuiElement)(child, ['Input', 'Select', 'NativeSelect'])) {
          return;
        }

        if ((0, _Input.isFilled)(child.props, true)) {
          _this.state.filled = true;
        }

        var input = (0, _reactHelpers.isMuiElement)(child, ['Select', 'NativeSelect']) ? child.props.input : child;

        if (input && (0, _Input.isAdornedStart)(input.props)) {
          _this.state.adornedStart = true;
        }
      });
    }

    return _this;
  }

  (0, _createClass2.default)(FormControl, [{
    key: "getChildContext",
    value: function getChildContext() {
      var _props = this.props,
          disabled = _props.disabled,
          error = _props.error,
          required = _props.required,
          margin = _props.margin;
      var _state = this.state,
          adornedStart = _state.adornedStart,
          filled = _state.filled,
          focused = _state.focused;
      return {
        muiFormControl: {
          adornedStart: adornedStart,
          disabled: disabled,
          error: error,
          filled: filled,
          focused: focused,
          margin: margin,
          onBlur: this.handleBlur,
          onEmpty: this.handleClean,
          onFilled: this.handleDirty,
          onFocus: this.handleFocus,
          required: required
        }
      };
    }
  }, {
    key: "render",
    value: function render() {
      var _classNames;

      var _props2 = this.props,
          classes = _props2.classes,
          className = _props2.className,
          Component = _props2.component,
          disabled = _props2.disabled,
          error = _props2.error,
          fullWidth = _props2.fullWidth,
          margin = _props2.margin,
          required = _props2.required,
          other = (0, _objectWithoutProperties2.default)(_props2, ["classes", "className", "component", "disabled", "error", "fullWidth", "margin", "required"]);
      return _react.default.createElement(Component, (0, _extends2.default)({
        className: (0, _classnames.default)(classes.root, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes["margin".concat((0, _helpers.capitalize)(margin))], margin !== 'none'), (0, _defineProperty2.default)(_classNames, classes.fullWidth, fullWidth), _classNames), className)
      }, other, {
        onFocus: this.handleFocus,
        onBlur: this.handleBlur
      }));
    }
  }]);
  return FormControl;
}(_react.default.Component);

FormControl.propTypes =  false ? {
  /**
   * The contents of the form control.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func]),

  /**
   * If `true`, the label, input and helper text should be displayed in a disabled state.
   */
  disabled: _propTypes.default.bool,

  /**
   * If `true`, the label should be displayed in an error state.
   */
  error: _propTypes.default.bool,

  /**
   * If `true`, the component will take up the full width of its container.
   */
  fullWidth: _propTypes.default.bool,

  /**
   * If `dense` or `normal`, will adjust vertical spacing of this and contained components.
   */
  margin: _propTypes.default.oneOf(['none', 'dense', 'normal']),

  /**
   * @ignore
   */
  onBlur: _propTypes.default.func,

  /**
   * @ignore
   */
  onFocus: _propTypes.default.func,

  /**
   * If `true`, the label will indicate that the input is required.
   */
  required: _propTypes.default.bool
} : {};
FormControl.defaultProps = {
  component: 'div',
  disabled: false,
  error: false,
  fullWidth: false,
  margin: 'none',
  required: false
};
FormControl.childContextTypes = {
  muiFormControl: _propTypes.default.object
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiFormControl'
})(FormControl);

exports.default = _default;

/***/ }),
/* 985 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(8));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(18));

var _createClass2 = _interopRequireDefault(__webpack_require__(19));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(20));

var _inherits2 = _interopRequireDefault(__webpack_require__(21));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _classnames = _interopRequireDefault(__webpack_require__(6));

var _debounce = _interopRequireDefault(__webpack_require__(93));

var _reactEventListener = _interopRequireDefault(__webpack_require__(73));

var _withStyles = _interopRequireDefault(__webpack_require__(5));

var ROWS_HEIGHT = 19;
var styles = {
  root: {
    position: 'relative',
    // because the shadow has position: 'absolute',
    width: '100%'
  },
  textarea: {
    width: '100%',
    height: '100%',
    resize: 'none',
    font: 'inherit',
    padding: 0,
    cursor: 'inherit',
    boxSizing: 'border-box',
    lineHeight: 'inherit',
    border: 'none',
    outline: 'none',
    background: 'transparent'
  },
  shadow: {
    resize: 'none',
    // Overflow also needed to here to remove the extra row
    // added to textareas in Firefox.
    overflow: 'hidden',
    // Visibility needed to hide the extra text area on ipads
    visibility: 'hidden',
    position: 'absolute',
    height: 'auto',
    whiteSpace: 'pre-wrap'
  }
};
/**
 * @ignore - internal component.
 */

exports.styles = styles;

var Textarea =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(Textarea, _React$Component);

  function Textarea(props) {
    var _this;

    (0, _classCallCheck2.default)(this, Textarea);
    _this = (0, _possibleConstructorReturn2.default)(this, (Textarea.__proto__ || Object.getPrototypeOf(Textarea)).call(this, props)); // <Input> expects the components it renders to respond to 'value'
    // so that it can check whether they are filled.

    _this.state = {
      height: null
    };
    _this.shadow = null;
    _this.singlelineShadow = null;
    _this.input = null;
    _this.value = null;
    _this.handleResize = (0, _debounce.default)(function () {
      _this.syncHeightWithShadow();
    }, 166);

    _this.handleRefInput = function (node) {
      _this.input = node;

      if (_this.props.textareaRef) {
        _this.props.textareaRef(node);
      }
    };

    _this.handleRefSinglelineShadow = function (node) {
      _this.singlelineShadow = node;
    };

    _this.handleRefShadow = function (node) {
      _this.shadow = node;
    };

    _this.handleChange = function (event) {
      _this.value = event.target.value;

      if (typeof _this.props.value === 'undefined' && _this.shadow) {
        // The component is not controlled, we need to update the shallow value.
        _this.shadow.value = _this.value;

        _this.syncHeightWithShadow();
      }

      if (_this.props.onChange) {
        _this.props.onChange(event);
      }
    };

    _this.value = props.value || props.defaultValue || '';
    _this.state = {
      height: Number(props.rows) * ROWS_HEIGHT
    };
    return _this;
  }

  (0, _createClass2.default)(Textarea, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.syncHeightWithShadow();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.syncHeightWithShadow();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.handleResize.clear();
    }
  }, {
    key: "syncHeightWithShadow",
    // Corresponds to 10 frames at 60 Hz.
    value: function syncHeightWithShadow() {
      var props = this.props;

      if (!this.shadow || !this.singlelineShadow) {
        return;
      } // The component is controlled, we need to update the shallow value.


      if (typeof props.value !== 'undefined') {
        this.shadow.value = props.value == null ? '' : String(props.value);
      }

      var lineHeight = this.singlelineShadow.scrollHeight;
      var newHeight = this.shadow.scrollHeight; // Guarding for jsdom, where scrollHeight isn't present.
      // See https://github.com/tmpvar/jsdom/issues/1013

      if (newHeight === undefined) {
        return;
      }

      if (Number(props.rowsMax) >= Number(props.rows)) {
        newHeight = Math.min(Number(props.rowsMax) * lineHeight, newHeight);
      }

      newHeight = Math.max(newHeight, lineHeight); // Need a large enough different to update the height.
      // This prevents infinite rendering loop.

      if (Math.abs(this.state.height - newHeight) > 1) {
        this.setState({
          height: newHeight
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _props = this.props,
          classes = _props.classes,
          className = _props.className,
          defaultValue = _props.defaultValue,
          onChange = _props.onChange,
          rows = _props.rows,
          rowsMax = _props.rowsMax,
          textareaRef = _props.textareaRef,
          value = _props.value,
          other = (0, _objectWithoutProperties2.default)(_props, ["classes", "className", "defaultValue", "onChange", "rows", "rowsMax", "textareaRef", "value"]);
      return _react.default.createElement("div", {
        className: classes.root,
        style: {
          height: this.state.height
        }
      }, _react.default.createElement(_reactEventListener.default, {
        target: "window",
        onResize: this.handleResize
      }), _react.default.createElement("textarea", {
        ref: this.handleRefSinglelineShadow,
        className: (0, _classnames.default)(classes.shadow, classes.textarea),
        tabIndex: -1,
        rows: "1",
        readOnly: true,
        "aria-hidden": "true",
        value: ""
      }), _react.default.createElement("textarea", {
        ref: this.handleRefShadow,
        className: (0, _classnames.default)(classes.shadow, classes.textarea),
        tabIndex: -1,
        rows: rows,
        "aria-hidden": "true",
        readOnly: true,
        defaultValue: defaultValue,
        value: value
      }), _react.default.createElement("textarea", (0, _extends2.default)({
        rows: rows,
        className: (0, _classnames.default)(classes.textarea, className),
        defaultValue: defaultValue,
        value: value,
        onChange: this.handleChange,
        ref: this.handleRefInput
      }, other)));
    }
  }]);
  return Textarea;
}(_react.default.Component);

Textarea.propTypes =  false ? {
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * @ignore
   */
  defaultValue: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),

  /**
   * @ignore
   */
  disabled: _propTypes.default.bool,

  /**
   * @ignore
   */
  onChange: _propTypes.default.func,

  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),

  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  rowsMax: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),

  /**
   * Use that property to pass a ref callback to the native textarea element.
   */
  textareaRef: _propTypes.default.func,

  /**
   * @ignore
   */
  value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number])
} : {};
Textarea.defaultProps = {
  rows: 1
};

var _default = (0, _withStyles.default)(styles)(Textarea);

exports.default = _default;

/***/ }),
/* 986 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _FormControlLabel.default;
  }
});

var _FormControlLabel = _interopRequireDefault(__webpack_require__(987));

/***/ }),
/* 987 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(8));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(11));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _classnames = _interopRequireDefault(__webpack_require__(6));

var _withStyles = _interopRequireDefault(__webpack_require__(5));

var _Typography = _interopRequireDefault(__webpack_require__(46));

/* eslint-disable jsx-a11y/label-has-for */
var styles = function styles(theme) {
  return {
    root: {
      display: 'inline-flex',
      alignItems: 'center',
      cursor: 'pointer',
      // For correct alignment with the text.
      verticalAlign: 'middle',
      // Remove grey highlight
      WebkitTapHighlightColor: 'transparent',
      marginLeft: -14,
      marginRight: theme.spacing.unit * 2,
      // used for row presentation of radio/checkbox
      '&$disabled': {
        cursor: 'default'
      }
    },
    disabled: {},
    label: {
      '&$disabled': {
        color: theme.palette.text.disabled
      }
    }
  };
};
/**
 * Drop in replacement of the `Radio`, `Switch` and `Checkbox` component.
 * Use this component if you want to display an extra label.
 */


exports.styles = styles;

function FormControlLabel(props, context) {
  var checked = props.checked,
      classes = props.classes,
      classNameProp = props.className,
      control = props.control,
      disabledProp = props.disabled,
      inputRef = props.inputRef,
      label = props.label,
      name = props.name,
      onChange = props.onChange,
      value = props.value,
      other = (0, _objectWithoutProperties2.default)(props, ["checked", "classes", "className", "control", "disabled", "inputRef", "label", "name", "onChange", "value"]);
  var muiFormControl = context.muiFormControl;
  var disabled = disabledProp;

  if (typeof control.props.disabled !== 'undefined') {
    if (typeof disabled === 'undefined') {
      disabled = control.props.disabled;
    }
  }

  if (muiFormControl) {
    if (typeof disabled === 'undefined') {
      disabled = muiFormControl.disabled;
    }
  }

  var className = (0, _classnames.default)(classes.root, (0, _defineProperty2.default)({}, classes.disabled, disabled), classNameProp);
  return _react.default.createElement("label", (0, _extends2.default)({
    className: className
  }, other), _react.default.cloneElement(control, {
    disabled: disabled,
    checked: typeof control.props.checked === 'undefined' ? checked : control.props.checked,
    name: control.props.name || name,
    onChange: control.props.onChange || onChange,
    value: control.props.value || value,
    inputRef: control.props.inputRef || inputRef
  }), _react.default.createElement(_Typography.default, {
    component: "span",
    className: (0, _classnames.default)(classes.label, (0, _defineProperty2.default)({}, classes.disabled, disabled))
  }, label));
}

FormControlLabel.propTypes =  false ? {
  /**
   * If `true`, the component appears selected.
   */
  checked: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.string]),

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * A control element. For instance, it can be be a `Radio`, a `Switch` or a `Checkbox`.
   */
  control: _propTypes.default.element,

  /**
   * If `true`, the control will be disabled.
   */
  disabled: _propTypes.default.bool,

  /**
   * Use that property to pass a ref callback to the native input component.
   */
  inputRef: _propTypes.default.func,

  /**
   * The text to be used in an enclosing label element.
   */
  label: _propTypes.default.node,

  /*
   * @ignore
   */
  name: _propTypes.default.string,

  /**
   * Callback fired when the state is changed.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.checked`.
   * @param {boolean} checked The `checked` value of the switch
   */
  onChange: _propTypes.default.func,

  /**
   * The value of the component.
   */
  value: _propTypes.default.string
} : {};
FormControlLabel.contextTypes = {
  muiFormControl: _propTypes.default.object
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiFormControlLabel'
})(FormControlLabel);

exports.default = _default;

/***/ }),
/* 988 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(8));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(11));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _classnames = _interopRequireDefault(__webpack_require__(6));

var _withStyles = _interopRequireDefault(__webpack_require__(5));

var styles = {
  root: {
    display: 'flex',
    flexDirection: 'column',
    flexWrap: 'wrap'
  },
  row: {
    flexDirection: 'row'
  }
};
/**
 * `FormGroup` wraps controls such as `Checkbox` and `Switch`.
 * It provides compact row layout.
 * For the `Radio`, you should be using the `RadioGroup` component instead of this one.
 */

exports.styles = styles;

function FormGroup(props) {
  var classes = props.classes,
      className = props.className,
      children = props.children,
      row = props.row,
      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "children", "row"]);
  return _react.default.createElement("div", (0, _extends2.default)({
    className: (0, _classnames.default)(classes.root, (0, _defineProperty2.default)({}, classes.row, row), className)
  }, other), children);
}

FormGroup.propTypes =  false ? {
  /**
   * The content of the component.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * Display group of elements in a compact row.
   */
  row: _propTypes.default.bool
} : {};
FormGroup.defaultProps = {
  row: false
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiFormGroup'
})(FormGroup);

exports.default = _default;

/***/ }),
/* 989 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(8));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(11));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _classnames = _interopRequireDefault(__webpack_require__(6));

var _withStyles = _interopRequireDefault(__webpack_require__(5));

var styles = function styles(theme) {
  return {
    root: {
      color: theme.palette.text.secondary,
      fontFamily: theme.typography.fontFamily,
      fontSize: theme.typography.pxToRem(12),
      textAlign: 'left',
      marginTop: theme.spacing.unit,
      lineHeight: '1em',
      minHeight: '1em',
      margin: 0,
      '&$error': {
        color: theme.palette.error.main
      },
      '&$disabled': {
        color: theme.palette.text.disabled
      }
    },
    error: {},
    disabled: {},
    marginDense: {
      marginTop: theme.spacing.unit / 2
    }
  };
};

exports.styles = styles;

function FormHelperText(props, context) {
  var _classNames;

  var classes = props.classes,
      classNameProp = props.className,
      disabledProp = props.disabled,
      errorProp = props.error,
      marginProp = props.margin,
      Component = props.component,
      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "disabled", "error", "margin", "component"]);
  var muiFormControl = context.muiFormControl;
  var disabled = disabledProp;
  var error = errorProp;
  var margin = marginProp;

  if (muiFormControl) {
    if (typeof disabled === 'undefined') {
      disabled = muiFormControl.disabled;
    }

    if (typeof error === 'undefined') {
      error = muiFormControl.error;
    }

    if (typeof margin === 'undefined') {
      margin = muiFormControl.margin;
    }
  }

  var className = (0, _classnames.default)(classes.root, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes.disabled, disabled), (0, _defineProperty2.default)(_classNames, classes.error, error), (0, _defineProperty2.default)(_classNames, classes.marginDense, margin === 'dense'), _classNames), classNameProp);
  return _react.default.createElement(Component, (0, _extends2.default)({
    className: className
  }, other));
}

FormHelperText.propTypes =  false ? {
  /**
   * The content of the component.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func]),

  /**
   * If `true`, the helper text should be displayed in a disabled state.
   */
  disabled: _propTypes.default.bool,

  /**
   * If `true`, helper text should be displayed in an error state.
   */
  error: _propTypes.default.bool,

  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   */
  margin: _propTypes.default.oneOf(['dense'])
} : {};
FormHelperText.defaultProps = {
  component: 'p'
};
FormHelperText.contextTypes = {
  muiFormControl: _propTypes.default.object
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiFormHelperText'
})(FormHelperText);

exports.default = _default;

/***/ }),
/* 990 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(8));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(11));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _classnames = _interopRequireDefault(__webpack_require__(6));

var _withStyles = _interopRequireDefault(__webpack_require__(5));

var styles = function styles(theme) {
  return {
    root: {
      fontFamily: theme.typography.fontFamily,
      color: theme.palette.text.secondary,
      fontSize: theme.typography.pxToRem(16),
      lineHeight: 1,
      padding: 0,
      '&$focused': {
        color: theme.palette.primary[theme.palette.type === 'light' ? 'dark' : 'light']
      },
      '&$disabled': {
        color: theme.palette.text.disabled
      },
      '&$error': {
        color: theme.palette.error.main
      }
    },
    focused: {},
    disabled: {},
    error: {},
    asterisk: {
      '&$error': {
        color: theme.palette.error.main
      }
    }
  };
};

exports.styles = styles;

function FormLabel(props, context) {
  var _classNames;

  var children = props.children,
      classes = props.classes,
      classNameProp = props.className,
      Component = props.component,
      disabledProp = props.disabled,
      errorProp = props.error,
      focusedProp = props.focused,
      requiredProp = props.required,
      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "component", "disabled", "error", "focused", "required"]);
  var muiFormControl = context.muiFormControl;
  var required = requiredProp;
  var focused = focusedProp;
  var disabled = disabledProp;
  var error = errorProp;

  if (muiFormControl) {
    if (typeof required === 'undefined') {
      required = muiFormControl.required;
    }

    if (typeof focused === 'undefined') {
      focused = muiFormControl.focused;
    }

    if (typeof disabled === 'undefined') {
      disabled = muiFormControl.disabled;
    }

    if (typeof error === 'undefined') {
      error = muiFormControl.error;
    }
  }

  var className = (0, _classnames.default)(classes.root, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes.focused, focused), (0, _defineProperty2.default)(_classNames, classes.disabled, disabled), (0, _defineProperty2.default)(_classNames, classes.error, error), _classNames), classNameProp);
  return _react.default.createElement(Component, (0, _extends2.default)({
    className: className
  }, other), children, required && _react.default.createElement("span", {
    className: (0, _classnames.default)(classes.asterisk, (0, _defineProperty2.default)({}, classes.error, error))
  }, "\u2009*"));
}

FormLabel.propTypes =  false ? {
  /**
   * The content of the component.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func]),

  /**
   * If `true`, the label should be displayed in a disabled state.
   */
  disabled: _propTypes.default.bool,

  /**
   * If `true`, the label should be displayed in an error state.
   */
  error: _propTypes.default.bool,

  /**
   * If `true`, the input of this label is focused (used by `FormGroup` components).
   */
  focused: _propTypes.default.bool,

  /**
   * If `true`, the label will indicate that the input is required.
   */
  required: _propTypes.default.bool
} : {};
FormLabel.defaultProps = {
  component: 'label'
};
FormLabel.contextTypes = {
  muiFormControl: _propTypes.default.object
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiFormLabel'
})(FormLabel);

exports.default = _default;

/***/ }),
/* 991 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _objectSpread2 = _interopRequireDefault(__webpack_require__(23));

var _extends2 = _interopRequireDefault(__webpack_require__(8));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(11));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _classnames = _interopRequireDefault(__webpack_require__(6));

var _withStyles = _interopRequireDefault(__webpack_require__(5));

var _createBreakpoints = __webpack_require__(165);

var _requirePropFactory = _interopRequireDefault(__webpack_require__(992));

// A grid component using the following libs as inspiration.
//
// For the implementation:
// - http://v4-alpha.getbootstrap.com/layout/flexbox-grid/
// - https://github.com/kristoferjoseph/flexboxgrid/blob/master/src/css/flexboxgrid.css
// - https://github.com/roylee0704/react-flexbox-grid
// - https://material.angularjs.org/latest/layout/introduction
//
// Follow this flexbox Guide to better understand the underlying model:
// - https://css-tricks.com/snippets/css/a-guide-to-flexbox/
var GUTTERS = [0, 8, 16, 24, 32, 40];
var GRID_SIZES = [true, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];

function generateGrid(globalStyles, theme, breakpoint) {
  // For the auto layouting
  var styles = (0, _defineProperty2.default)({}, "grid-".concat(breakpoint), {
    flexBasis: 0,
    flexGrow: 1,
    maxWidth: '100%'
  });
  GRID_SIZES.forEach(function (size) {
    if (typeof size === 'boolean') {
      // Skip the first one as handle above.
      return;
    } // Only keep 6 significant numbers.


    var width = "".concat(Math.round(size / 12 * 10e6) / 10e4, "%");
    /* eslint-disable max-len */
    // Close to the bootstrap implementation:
    // https://github.com/twbs/bootstrap/blob/8fccaa2439e97ec72a4b7dc42ccc1f649790adb0/scss/mixins/_grid.scss#L41

    /* eslint-enable max-len */

    styles["grid-".concat(breakpoint, "-").concat(size)] = {
      flexBasis: width,
      maxWidth: width
    };
  }); // No need for a media query for the first size.

  if (breakpoint === 'xs') {
    (0, _extends2.default)(globalStyles, styles);
  } else {
    globalStyles[theme.breakpoints.up(breakpoint)] = styles;
  }
}

function generateGutter(theme, breakpoint) {
  var styles = {};
  GUTTERS.forEach(function (spacing, index) {
    if (index === 0) {
      // Skip the default style.
      return;
    }

    styles["spacing-".concat(breakpoint, "-").concat(spacing)] = {
      margin: -spacing / 2,
      width: "calc(100% + ".concat(spacing, "px)"),
      '& > $item': {
        padding: spacing / 2
      }
    };
  });
  return styles;
} // Default CSS values
// flex: '0 1 auto',
// flexDirection: 'row',
// alignItems: 'flex-start',
// flexWrap: 'nowrap',
// justifyContent: 'flex-start',


var styles = function styles(theme) {
  return (0, _objectSpread2.default)({
    container: {
      boxSizing: 'border-box',
      display: 'flex',
      flexWrap: 'wrap',
      width: '100%'
    },
    item: {
      boxSizing: 'border-box',
      margin: '0' // For instance, it's useful when used with a `figure` element.

    },
    zeroMinWidth: {
      minWidth: 0
    },
    'direction-xs-column': {
      flexDirection: 'column'
    },
    'direction-xs-column-reverse': {
      flexDirection: 'column-reverse'
    },
    'direction-xs-row-reverse': {
      flexDirection: 'row-reverse'
    },
    'wrap-xs-nowrap': {
      flexWrap: 'nowrap'
    },
    'wrap-xs-wrap-reverse': {
      flexWrap: 'wrap-reverse'
    },
    'align-items-xs-center': {
      alignItems: 'center'
    },
    'align-items-xs-flex-start': {
      alignItems: 'flex-start'
    },
    'align-items-xs-flex-end': {
      alignItems: 'flex-end'
    },
    'align-items-xs-baseline': {
      alignItems: 'baseline'
    },
    'align-content-xs-center': {
      alignContent: 'center'
    },
    'align-content-xs-flex-start': {
      alignContent: 'flex-start'
    },
    'align-content-xs-flex-end': {
      alignContent: 'flex-end'
    },
    'align-content-xs-space-between': {
      alignContent: 'space-between'
    },
    'align-content-xs-space-around': {
      alignContent: 'space-around'
    },
    'justify-xs-center': {
      justifyContent: 'center'
    },
    'justify-xs-flex-end': {
      justifyContent: 'flex-end'
    },
    'justify-xs-space-between': {
      justifyContent: 'space-between'
    },
    'justify-xs-space-around': {
      justifyContent: 'space-around'
    }
  }, generateGutter(theme, 'xs'), _createBreakpoints.keys.reduce(function (accumulator, key) {
    // Use side effect over immutability for better performance.
    generateGrid(accumulator, theme, key);
    return accumulator;
  }, {}));
};

exports.styles = styles;

function Grid(props) {
  var _classNames;

  var alignContent = props.alignContent,
      alignItems = props.alignItems,
      classes = props.classes,
      classNameProp = props.className,
      Component = props.component,
      container = props.container,
      direction = props.direction,
      item = props.item,
      justify = props.justify,
      lg = props.lg,
      md = props.md,
      sm = props.sm,
      spacing = props.spacing,
      wrap = props.wrap,
      xl = props.xl,
      xs = props.xs,
      zeroMinWidth = props.zeroMinWidth,
      other = (0, _objectWithoutProperties2.default)(props, ["alignContent", "alignItems", "classes", "className", "component", "container", "direction", "item", "justify", "lg", "md", "sm", "spacing", "wrap", "xl", "xs", "zeroMinWidth"]);
  var className = (0, _classnames.default)((_classNames = {}, (0, _defineProperty2.default)(_classNames, classes.container, container), (0, _defineProperty2.default)(_classNames, classes.item, item), (0, _defineProperty2.default)(_classNames, classes.zeroMinWidth, zeroMinWidth), (0, _defineProperty2.default)(_classNames, classes["spacing-xs-".concat(String(spacing))], container && spacing !== 0), (0, _defineProperty2.default)(_classNames, classes["direction-xs-".concat(String(direction))], direction !== Grid.defaultProps.direction), (0, _defineProperty2.default)(_classNames, classes["wrap-xs-".concat(String(wrap))], wrap !== Grid.defaultProps.wrap), (0, _defineProperty2.default)(_classNames, classes["align-items-xs-".concat(String(alignItems))], alignItems !== Grid.defaultProps.alignItems), (0, _defineProperty2.default)(_classNames, classes["align-content-xs-".concat(String(alignContent))], alignContent !== Grid.defaultProps.alignContent), (0, _defineProperty2.default)(_classNames, classes["justify-xs-".concat(String(justify))], justify !== Grid.defaultProps.justify), (0, _defineProperty2.default)(_classNames, classes['grid-xs'], xs === true), (0, _defineProperty2.default)(_classNames, classes["grid-xs-".concat(String(xs))], xs && xs !== true), (0, _defineProperty2.default)(_classNames, classes['grid-sm'], sm === true), (0, _defineProperty2.default)(_classNames, classes["grid-sm-".concat(String(sm))], sm && sm !== true), (0, _defineProperty2.default)(_classNames, classes['grid-md'], md === true), (0, _defineProperty2.default)(_classNames, classes["grid-md-".concat(String(md))], md && md !== true), (0, _defineProperty2.default)(_classNames, classes['grid-lg'], lg === true), (0, _defineProperty2.default)(_classNames, classes["grid-lg-".concat(String(lg))], lg && lg !== true), (0, _defineProperty2.default)(_classNames, classes['grid-xl'], xl === true), (0, _defineProperty2.default)(_classNames, classes["grid-xl-".concat(String(xl))], xl && xl !== true), _classNames), classNameProp);
  return _react.default.createElement(Component, (0, _extends2.default)({
    className: className
  }, other));
}

Grid.propTypes =  false ? {
  /**
   * Defines the `align-content` style property.
   * It's applied for all screen sizes.
   */
  alignContent: _propTypes.default.oneOf(['stretch', 'center', 'flex-start', 'flex-end', 'space-between', 'space-around']),

  /**
   * Defines the `align-items` style property.
   * It's applied for all screen sizes.
   */
  alignItems: _propTypes.default.oneOf(['flex-start', 'center', 'flex-end', 'stretch', 'baseline']),

  /**
   * The content of the component.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func]),

  /**
   * If `true`, the component will have the flex *container* behavior.
   * You should be wrapping *items* with a *container*.
   */
  container: _propTypes.default.bool,

  /**
   * Defines the `flex-direction` style property.
   * It is applied for all screen sizes.
   */
  direction: _propTypes.default.oneOf(['row', 'row-reverse', 'column', 'column-reverse']),

  /**
   * If `true`, the component will have the flex *item* behavior.
   * You should be wrapping *items* with a *container*.
   */
  item: _propTypes.default.bool,

  /**
   * Defines the `justify-content` style property.
   * It is applied for all screen sizes.
   */
  justify: _propTypes.default.oneOf(['flex-start', 'center', 'flex-end', 'space-between', 'space-around']),

  /**
   * Defines the number of grids the component is going to use.
   * It's applied for the `lg` breakpoint and wider screens if not overridden.
   */
  lg: _propTypes.default.oneOf([false, true, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),

  /**
   * Defines the number of grids the component is going to use.
   * It's applied for the `md` breakpoint and wider screens if not overridden.
   */
  md: _propTypes.default.oneOf([false, true, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),

  /**
   * Defines the number of grids the component is going to use.
   * It's applied for the `sm` breakpoint and wider screens if not overridden.
   */
  sm: _propTypes.default.oneOf([false, true, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),

  /**
   * Defines the space between the type `item` component.
   * It can only be used on a type `container` component.
   */
  spacing: _propTypes.default.oneOf(GUTTERS),

  /**
   * Defines the `flex-wrap` style property.
   * It's applied for all screen sizes.
   */
  wrap: _propTypes.default.oneOf(['nowrap', 'wrap', 'wrap-reverse']),

  /**
   * Defines the number of grids the component is going to use.
   * It's applied for the `xl` breakpoint and wider screens.
   */
  xl: _propTypes.default.oneOf([false, true, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),

  /**
   * Defines the number of grids the component is going to use.
   * It's applied for all the screen sizes with the lowest priority.
   */
  xs: _propTypes.default.oneOf([false, true, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),

  /**
   * If `true`, it sets `min-width: 0` on the item.
   * Refer to the limitations section of the documentation to better understand the use case.
   */
  zeroMinWidth: _propTypes.default.bool
} : {};
Grid.defaultProps = {
  alignContent: 'stretch',
  alignItems: 'stretch',
  component: 'div',
  container: false,
  direction: 'row',
  item: false,
  justify: 'flex-start',
  lg: false,
  md: false,
  sm: false,
  spacing: 0,
  wrap: 'wrap',
  xl: false,
  xs: false,
  zeroMinWidth: false
}; // Add a wrapper component to generate some helper messages in the development
// environment.

/* eslint-disable react/no-multi-comp */
// eslint-disable-next-line import/no-mutable-exports

var GridWrapper = (0, _withStyles.default)(styles, {
  name: 'MuiGrid'
})(Grid);

if (false) {
  var GridStyled = GridWrapper;

  GridWrapper = function GridWrapper(props) {
    return _react.default.createElement(GridStyled, props);
  };

  var requireProp = (0, _requirePropFactory.default)('Grid');
  GridWrapper.propTypes = {
    alignContent: requireProp('container'),
    alignItems: requireProp('container'),
    direction: requireProp('container'),
    justify: requireProp('container'),
    lg: requireProp('item'),
    md: requireProp('item'),
    sm: requireProp('item'),
    spacing: requireProp('container'),
    wrap: requireProp('container'),
    xs: requireProp('item'),
    zeroMinWidth: requireProp('zeroMinWidth')
  };
  GridWrapper.Naked = GridStyled;
  GridWrapper.options = GridStyled.options;
}

var _default = GridWrapper;
exports.default = _default;

/***/ }),
/* 992 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

//  weak
var requirePropFactory = function requirePropFactory(componentNameInError) {
  var requireProp = function requireProp(requiredProp) {
    return function (props, propName, componentName, location, propFullName) {
      var propFullNameSafe = propFullName || propName;

      if (typeof props[propName] !== 'undefined' && !props[requiredProp]) {
        return new Error("The property `".concat(propFullNameSafe, "` of ") + "`".concat(componentNameInError, "` must be used on `").concat(requiredProp, "`."));
      }

      return null;
    };
  };

  return requireProp;
};

var _default = requirePropFactory;
exports.default = _default;

/***/ }),
/* 993 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _GridList.default;
  }
});

var _GridList = _interopRequireDefault(__webpack_require__(994));

/***/ }),
/* 994 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(8));

var _objectSpread2 = _interopRequireDefault(__webpack_require__(23));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _classnames = _interopRequireDefault(__webpack_require__(6));

var _withStyles = _interopRequireDefault(__webpack_require__(5));

var styles = {
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    overflowY: 'auto',
    listStyle: 'none',
    padding: 0,
    WebkitOverflowScrolling: 'touch' // Add iOS momentum scrolling.

  }
};
exports.styles = styles;

function GridList(props) {
  var cellHeight = props.cellHeight,
      children = props.children,
      classes = props.classes,
      classNameProp = props.className,
      cols = props.cols,
      Component = props.component,
      spacing = props.spacing,
      style = props.style,
      other = (0, _objectWithoutProperties2.default)(props, ["cellHeight", "children", "classes", "className", "cols", "component", "spacing", "style"]);
  return _react.default.createElement(Component, (0, _extends2.default)({
    className: (0, _classnames.default)(classes.root, classNameProp),
    style: (0, _objectSpread2.default)({
      margin: -spacing / 2
    }, style)
  }, other), _react.default.Children.map(children, function (currentChild) {
    if (!_react.default.isValidElement(currentChild)) {
      return null;
    }

    var childCols = currentChild.props.cols || 1;
    var childRows = currentChild.props.rows || 1;
    return _react.default.cloneElement(currentChild, {
      style: (0, _extends2.default)({
        width: "".concat(100 / cols * childCols, "%"),
        height: cellHeight === 'auto' ? 'auto' : cellHeight * childRows + spacing,
        padding: spacing / 2
      }, currentChild.props.style)
    });
  }));
}

GridList.propTypes =  false ? {
  /**
   * Number of px for one cell height.
   * You can set `'auto'` if you want to let the children determine the height.
   */
  cellHeight: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.oneOf(['auto'])]),

  /**
   * Grid Tiles that will be in Grid List.
   */
  children: _propTypes.default.node.isRequired,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * Number of columns.
   */
  cols: _propTypes.default.number,

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func]),

  /**
   * Number of px for the spacing between tiles.
   */
  spacing: _propTypes.default.number,

  /**
   * @ignore
   */
  style: _propTypes.default.object
} : {};
GridList.defaultProps = {
  cellHeight: 180,
  cols: 2,
  component: 'ul',
  spacing: 4
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiGridList'
})(GridList);

exports.default = _default;

/***/ }),
/* 995 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _GridListTile.default;
  }
});

var _GridListTile = _interopRequireDefault(__webpack_require__(996));

/***/ }),
/* 996 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(8));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(219));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(18));

var _createClass2 = _interopRequireDefault(__webpack_require__(19));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(20));

var _inherits2 = _interopRequireDefault(__webpack_require__(21));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _classnames = _interopRequireDefault(__webpack_require__(6));

var _reactEventListener = _interopRequireDefault(__webpack_require__(73));

var _debounce = _interopRequireDefault(__webpack_require__(93));

var _withStyles = _interopRequireDefault(__webpack_require__(5));

var styles = {
  root: {
    boxSizing: 'border-box',
    flexShrink: 0
  },
  tile: {
    position: 'relative',
    display: 'block',
    // In case it's not renderd with a div.
    height: '100%',
    overflow: 'hidden'
  },
  imgFullHeight: {
    height: '100%',
    transform: 'translateX(-50%)',
    position: 'relative',
    left: '50%'
  },
  imgFullWidth: {
    width: '100%',
    position: 'relative',
    transform: 'translateY(-50%)',
    top: '50%'
  }
};
exports.styles = styles;

var GridListTile =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(GridListTile, _React$Component);

  function GridListTile() {
    var _ref;

    var _temp, _this;

    (0, _classCallCheck2.default)(this, GridListTile);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return (0, _possibleConstructorReturn2.default)(_this, (_temp = _this = (0, _possibleConstructorReturn2.default)(this, (_ref = GridListTile.__proto__ || Object.getPrototypeOf(GridListTile)).call.apply(_ref, [this].concat(args))), _this.imgElement = null, _this.handleResize = (0, _debounce.default)(function () {
      _this.fit();
    }, 166), _this.fit = function () {
      var imgElement = _this.imgElement;

      if (!imgElement) {
        return;
      }

      if (!imgElement.complete) {
        return;
      }

      if (imgElement.width / imgElement.height > imgElement.parentNode.offsetWidth / imgElement.parentNode.offsetHeight) {
        var _imgElement$classList, _imgElement$classList2;

        (_imgElement$classList = imgElement.classList).remove.apply(_imgElement$classList, (0, _toConsumableArray2.default)(_this.props.classes.imgFullWidth.split(' ')));

        (_imgElement$classList2 = imgElement.classList).add.apply(_imgElement$classList2, (0, _toConsumableArray2.default)(_this.props.classes.imgFullHeight.split(' ')));
      } else {
        var _imgElement$classList3, _imgElement$classList4;

        (_imgElement$classList3 = imgElement.classList).remove.apply(_imgElement$classList3, (0, _toConsumableArray2.default)(_this.props.classes.imgFullHeight.split(' ')));

        (_imgElement$classList4 = imgElement.classList).add.apply(_imgElement$classList4, (0, _toConsumableArray2.default)(_this.props.classes.imgFullWidth.split(' ')));
      }

      imgElement.removeEventListener('load', _this.fit);
    }, _temp));
  }

  (0, _createClass2.default)(GridListTile, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.ensureImageCover();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.ensureImageCover();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.handleResize.clear();
    }
  }, {
    key: "ensureImageCover",
    value: function ensureImageCover() {
      if (!this.imgElement) {
        return;
      }

      if (this.imgElement.complete) {
        this.fit();
      } else {
        this.imgElement.addEventListener('load', this.fit);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          children = _props.children,
          classes = _props.classes,
          className = _props.className,
          cols = _props.cols,
          Component = _props.component,
          rows = _props.rows,
          other = (0, _objectWithoutProperties2.default)(_props, ["children", "classes", "className", "cols", "component", "rows"]);
      return _react.default.createElement(Component, (0, _extends2.default)({
        className: (0, _classnames.default)(classes.root, className)
      }, other), _react.default.createElement(_reactEventListener.default, {
        target: "window",
        onResize: this.handleResize
      }), _react.default.createElement("div", {
        className: classes.tile
      }, _react.default.Children.map(children, function (child) {
        if (child && child.type === 'img') {
          return _react.default.cloneElement(child, {
            key: 'img',
            ref: function ref(node) {
              _this2.imgElement = node;
            }
          });
        }

        return child;
      })));
    }
  }]);
  return GridListTile;
}(_react.default.Component);

GridListTile.propTypes =  false ? {
  /**
   * Theoretically you can pass any node as children, but the main use case is to pass an img,
   * in which case GridListTile takes care of making the image "cover" available space
   * (similar to `background-size: cover` or to `object-fit: cover`).
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * Width of the tile in number of grid cells.
   */
  cols: _propTypes.default.number,

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func]),

  /**
   * Height of the tile in number of grid cells.
   */
  rows: _propTypes.default.number
} : {};
GridListTile.defaultProps = {
  cols: 1,
  component: 'li',
  rows: 1
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiGridListTile'
})(GridListTile);

exports.default = _default;

/***/ }),
/* 997 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _GridListTileBar.default;
  }
});

var _GridListTileBar = _interopRequireDefault(__webpack_require__(998));

/***/ }),
/* 998 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(8));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(11));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _classnames = _interopRequireDefault(__webpack_require__(6));

var _withStyles = _interopRequireDefault(__webpack_require__(5));

var styles = function styles(theme) {
  return {
    root: {
      position: 'absolute',
      left: 0,
      right: 0,
      height: 48,
      background: 'rgba(0, 0, 0, 0.4)',
      display: 'flex',
      alignItems: 'center',
      fontFamily: theme.typography.fontFamily
    },
    titlePositionBottom: {
      bottom: 0
    },
    titlePositionTop: {
      top: 0
    },
    rootSubtitle: {
      height: 68
    },
    titleWrap: {
      flexGrow: 1,
      marginLeft: theme.mixins.gutters().paddingLeft,
      marginRight: theme.mixins.gutters().paddingRight,
      color: theme.palette.common.white,
      overflow: 'hidden'
    },
    titleWrapActionPosLeft: {
      marginLeft: 0
    },
    titleWrapActionPosRight: {
      marginRight: 0
    },
    title: {
      fontSize: theme.typography.pxToRem(16),
      lineHeight: '24px',
      textOverflow: 'ellipsis',
      overflow: 'hidden',
      whiteSpace: 'nowrap'
    },
    subtitle: {
      fontSize: theme.typography.pxToRem(12),
      lineHeight: 1,
      textOverflow: 'ellipsis',
      overflow: 'hidden',
      whiteSpace: 'nowrap'
    },
    actionIcon: {},
    actionIconActionPosLeft: {
      order: -1
    }
  };
};

exports.styles = styles;

function GridListTileBar(props) {
  var _classNames, _classNames2;

  var actionIcon = props.actionIcon,
      actionPosition = props.actionPosition,
      classes = props.classes,
      classNameProp = props.className,
      subtitle = props.subtitle,
      title = props.title,
      titlePosition = props.titlePosition,
      other = (0, _objectWithoutProperties2.default)(props, ["actionIcon", "actionPosition", "classes", "className", "subtitle", "title", "titlePosition"]);
  var actionPos = actionIcon && actionPosition;
  var className = (0, _classnames.default)(classes.root, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes.titlePositionBottom, titlePosition === 'bottom'), (0, _defineProperty2.default)(_classNames, classes.titlePositionTop, titlePosition === 'top'), (0, _defineProperty2.default)(_classNames, classes.rootSubtitle, subtitle), _classNames), classNameProp); // Remove the margin between the title / subtitle wrapper, and the Action Icon

  var titleWrapClassName = (0, _classnames.default)(classes.titleWrap, (_classNames2 = {}, (0, _defineProperty2.default)(_classNames2, classes.titleWrapActionPosLeft, actionPos === 'left'), (0, _defineProperty2.default)(_classNames2, classes.titleWrapActionPosRight, actionPos === 'right'), _classNames2));
  return _react.default.createElement("div", (0, _extends2.default)({
    className: className
  }, other), _react.default.createElement("div", {
    className: titleWrapClassName
  }, _react.default.createElement("div", {
    className: classes.title
  }, title), subtitle ? _react.default.createElement("div", {
    className: classes.subtitle
  }, subtitle) : null), actionIcon ? _react.default.createElement("div", {
    className: (0, _classnames.default)(classes.actionIcon, (0, _defineProperty2.default)({}, classes.actionIconActionPosLeft, actionPos === 'left'))
  }, actionIcon) : null);
}

GridListTileBar.propTypes =  false ? {
  /**
   * An IconButton element to be used as secondary action target
   * (primary action target is the tile itself).
   */
  actionIcon: _propTypes.default.node,

  /**
   * Position of secondary action IconButton.
   */
  actionPosition: _propTypes.default.oneOf(['left', 'right']),

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * String or element serving as subtitle (support text).
   */
  subtitle: _propTypes.default.node,

  /**
   * Title to be displayed on tile.
   */
  title: _propTypes.default.node,

  /**
   * Position of the title bar.
   */
  titlePosition: _propTypes.default.oneOf(['top', 'bottom'])
} : {};
GridListTileBar.defaultProps = {
  actionPosition: 'right',
  titlePosition: 'bottom'
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiGridListTileBar'
})(GridListTileBar);

exports.default = _default;

/***/ }),
/* 999 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(8));

var _objectSpread2 = _interopRequireDefault(__webpack_require__(23));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(18));

var _createClass2 = _interopRequireDefault(__webpack_require__(19));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(20));

var _inherits2 = _interopRequireDefault(__webpack_require__(21));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _Transition = _interopRequireDefault(__webpack_require__(131));

var _withTheme = _interopRequireDefault(__webpack_require__(91));

var _utils = __webpack_require__(132);

// @inheritedComponent Transition
function getScale(value) {
  return "scale(".concat(value, ", ").concat(Math.pow(value, 2), ")");
}

var styles = {
  entering: {
    opacity: 1,
    transform: getScale(1)
  },
  entered: {
    opacity: 1,
    transform: getScale(1)
  }
};
/**
 * The Grow transition is used by the [Popover](/utils/popovers) component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */

var Grow =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(Grow, _React$Component);

  function Grow() {
    var _ref;

    var _temp, _this;

    (0, _classCallCheck2.default)(this, Grow);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return (0, _possibleConstructorReturn2.default)(_this, (_temp = _this = (0, _possibleConstructorReturn2.default)(this, (_ref = Grow.__proto__ || Object.getPrototypeOf(Grow)).call.apply(_ref, [this].concat(args))), _this.autoTimeout = undefined, _this.timer = null, _this.handleEnter = function (node) {
      var _this$props = _this.props,
          theme = _this$props.theme,
          timeout = _this$props.timeout;
      (0, _utils.reflow)(node); // So the animation always start from the start.

      var _getTransitionProps = (0, _utils.getTransitionProps)(_this.props, {
        mode: 'enter'
      }),
          transitionDuration = _getTransitionProps.duration,
          delay = _getTransitionProps.delay;

      var duration = 0;

      if (timeout === 'auto') {
        duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
        _this.autoTimeout = duration;
      } else {
        duration = transitionDuration;
      }

      node.style.transition = [theme.transitions.create('opacity', {
        duration: duration,
        delay: delay
      }), theme.transitions.create('transform', {
        duration: duration * 0.666,
        delay: delay
      })].join(',');

      if (_this.props.onEnter) {
        _this.props.onEnter(node);
      }
    }, _this.handleExit = function (node) {
      var _this$props2 = _this.props,
          theme = _this$props2.theme,
          timeout = _this$props2.timeout;
      var duration = 0;

      var _getTransitionProps2 = (0, _utils.getTransitionProps)(_this.props, {
        mode: 'exit'
      }),
          transitionDuration = _getTransitionProps2.duration,
          delay = _getTransitionProps2.delay;

      if (timeout === 'auto') {
        duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
        _this.autoTimeout = duration;
      } else {
        duration = transitionDuration;
      }

      node.style.transition = [theme.transitions.create('opacity', {
        duration: duration,
        delay: delay
      }), theme.transitions.create('transform', {
        duration: duration * 0.666,
        delay: delay || duration * 0.333
      })].join(',');
      node.style.opacity = '0';
      node.style.transform = getScale(0.75);

      if (_this.props.onExit) {
        _this.props.onExit(node);
      }
    }, _this.addEndListener = function (_, next) {
      if (_this.props.timeout === 'auto') {
        _this.timer = setTimeout(next, _this.autoTimeout || 0);
      }
    }, _temp));
  }

  (0, _createClass2.default)(Grow, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearTimeout(this.timer);
    }
  }, {
    key: "render",
    value: function render() {
      var _props = this.props,
          children = _props.children,
          onEnter = _props.onEnter,
          onExit = _props.onExit,
          styleProp = _props.style,
          theme = _props.theme,
          timeout = _props.timeout,
          other = (0, _objectWithoutProperties2.default)(_props, ["children", "onEnter", "onExit", "style", "theme", "timeout"]);
      var style = (0, _objectSpread2.default)({}, styleProp, _react.default.isValidElement(children) ? children.props.style : {});
      return _react.default.createElement(_Transition.default, (0, _extends2.default)({
        appear: true,
        onEnter: this.handleEnter,
        onExit: this.handleExit,
        addEndListener: this.addEndListener,
        timeout: timeout === 'auto' ? null : timeout
      }, other), function (state, childProps) {
        return _react.default.cloneElement(children, (0, _objectSpread2.default)({
          style: (0, _objectSpread2.default)({
            opacity: 0,
            transform: getScale(0.75)
          }, styles[state], style)
        }, childProps));
      });
    }
  }]);
  return Grow;
}(_react.default.Component);

Grow.propTypes =  false ? {
  /**
   * A single child content element.
   */
  children: _propTypes.default.oneOfType([_propTypes.default.element, _propTypes.default.func]),

  /**
   * If `true`, show the component; triggers the enter or exit animation.
   */
  in: _propTypes.default.bool,

  /**
   * @ignore
   */
  onEnter: _propTypes.default.func,

  /**
   * @ignore
   */
  onExit: _propTypes.default.func,

  /**
   * @ignore
   */
  style: _propTypes.default.object,

  /**
   * @ignore
   */
  theme: _propTypes.default.object.isRequired,

  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   *
   * Set to 'auto' to automatically calculate transition time based on height.
   */
  timeout: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
    enter: _propTypes.default.number,
    exit: _propTypes.default.number
  }), _propTypes.default.oneOf(['auto'])])
} : {};
Grow.defaultProps = {
  timeout: 'auto'
};

var _default = (0, _withTheme.default)()(Grow);

exports.default = _default;

/***/ }),
/* 1000 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _HiddenJs = _interopRequireDefault(__webpack_require__(1001));

var _HiddenCss = _interopRequireDefault(__webpack_require__(1003));

/**
 * Responsively hides children based on the selected implementation.
 */
function Hidden(props) {
  var implementation = props.implementation,
      other = (0, _objectWithoutProperties2.default)(props, ["implementation"]);

  if (implementation === 'js') {
    return _react.default.createElement(_HiddenJs.default, other);
  }

  return _react.default.createElement(_HiddenCss.default, other);
}

Hidden.propTypes =  false ? {
  /**
   * The content of the component.
   */
  children: _propTypes.default.node,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * Specify which implementation to use.  'js' is the default, 'css' works better for server
   * side rendering.
   */
  implementation: _propTypes.default.oneOf(['js', 'css']),

  /**
   * You can use this property when choosing the `js` implementation with server side rendering.
   *
   * As `window.innerWidth` is unavailable on the server,
   * we default to rendering an empty componenent during the first mount.
   * In some situation you might want to use an heristic to approximate
   * the screen width of the client browser screen width.
   *
   * For instance, you could be using the user-agent or the client-hints.
   * http://caniuse.com/#search=client%20hint
   */
  initialWidth: _propTypes.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl']),

  /**
   * If true, screens this size and down will be hidden.
   */
  lgDown: _propTypes.default.bool,

  /**
   * If true, screens this size and up will be hidden.
   */
  lgUp: _propTypes.default.bool,

  /**
   * If true, screens this size and down will be hidden.
   */
  mdDown: _propTypes.default.bool,

  /**
   * If true, screens this size and up will be hidden.
   */
  mdUp: _propTypes.default.bool,

  /**
   * Hide the given breakpoint(s).
   */
  only: _propTypes.default.oneOfType([_propTypes.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl']), _propTypes.default.arrayOf(_propTypes.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl']))]),

  /**
   * If true, screens this size and down will be hidden.
   */
  smDown: _propTypes.default.bool,

  /**
   * If true, screens this size and up will be hidden.
   */
  smUp: _propTypes.default.bool,

  /**
   * If true, screens this size and down will be hidden.
   */
  xlDown: _propTypes.default.bool,

  /**
   * If true, screens this size and up will be hidden.
   */
  xlUp: _propTypes.default.bool,

  /**
   * If true, screens this size and down will be hidden.
   */
  xsDown: _propTypes.default.bool,

  /**
   * If true, screens this size and up will be hidden.
   */
  xsUp: _propTypes.default.bool
} : {};
Hidden.defaultProps = {
  implementation: 'js',
  lgDown: false,
  lgUp: false,
  mdDown: false,
  mdUp: false,
  smDown: false,
  smUp: false,
  xlDown: false,
  xlUp: false,
  xsDown: false,
  xsUp: false
};
var _default = Hidden;
exports.default = _default;

/***/ }),
/* 1001 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(161);

var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _createBreakpoints = __webpack_require__(165);

var _withWidth = _interopRequireWildcard(__webpack_require__(328));

var _exactProp = _interopRequireDefault(__webpack_require__(166));

/**
 * @ignore - internal component.
 */
function HiddenJs(props) {
  var children = props.children,
      only = props.only,
      width = props.width;
  var visible = true; // `only` check is faster to get out sooner if used.

  if (only) {
    if (Array.isArray(only)) {
      for (var i = 0; i < only.length; i += 1) {
        var breakpoint = only[i];

        if (width === breakpoint) {
          visible = false;
          break;
        }
      }
    } else if (only && width === only) {
      visible = false;
    }
  } // Allow `only` to be combined with other props. If already hidden, no need to check others.


  if (visible) {
    // determine visibility based on the smallest size up
    for (var _i = 0; _i < _createBreakpoints.keys.length; _i += 1) {
      var _breakpoint = _createBreakpoints.keys[_i];
      var breakpointUp = props["".concat(_breakpoint, "Up")];
      var breakpointDown = props["".concat(_breakpoint, "Down")];

      if (breakpointUp && (0, _withWidth.isWidthUp)(_breakpoint, width) || breakpointDown && (0, _withWidth.isWidthDown)(_breakpoint, width)) {
        visible = false;
        break;
      }
    }
  }

  if (!visible) {
    return null;
  }

  return children;
}

HiddenJs.propTypes = {
  /**
   * The content of the component.
   */
  children: _propTypes.default.node,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * Specify which implementation to use.  'js' is the default, 'css' works better for server
   * side rendering.
   */
  implementation: _propTypes.default.oneOf(['js', 'css']),

  /**
   * You can use this property when choosing the `js` implementation with server side rendering.
   *
   * As `window.innerWidth` is unavailable on the server,
   * we default to rendering an empty componenent during the first mount.
   * In some situation you might want to use an heristic to approximate
   * the screen width of the client browser screen width.
   *
   * For instance, you could be using the user-agent or the client-hints.
   * http://caniuse.com/#search=client%20hint
   */
  initialWidth: _propTypes.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl']),

  /**
   * If true, screens this size and down will be hidden.
   */
  lgDown: _propTypes.default.bool,

  /**
   * If true, screens this size and up will be hidden.
   */
  lgUp: _propTypes.default.bool,

  /**
   * If true, screens this size and down will be hidden.
   */
  mdDown: _propTypes.default.bool,

  /**
   * If true, screens this size and up will be hidden.
   */
  mdUp: _propTypes.default.bool,

  /**
   * Hide the given breakpoint(s).
   */
  only: _propTypes.default.oneOfType([_propTypes.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl']), _propTypes.default.arrayOf(_propTypes.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl']))]),

  /**
   * If true, screens this size and down will be hidden.
   */
  smDown: _propTypes.default.bool,

  /**
   * If true, screens this size and up will be hidden.
   */
  smUp: _propTypes.default.bool,

  /**
   * @ignore
   * width prop provided by withWidth decorator.
   */
  width: _propTypes.default.string.isRequired,

  /**
   * If true, screens this size and down will be hidden.
   */
  xlDown: _propTypes.default.bool,

  /**
   * If true, screens this size and up will be hidden.
   */
  xlUp: _propTypes.default.bool,

  /**
   * If true, screens this size and down will be hidden.
   */
  xsDown: _propTypes.default.bool,

  /**
   * If true, screens this size and up will be hidden.
   */
  xsUp: _propTypes.default.bool
};
HiddenJs.propTypes = (0, _exactProp.default)(HiddenJs.propTypes, 'HiddenJs');

var _default = (0, _withWidth.default)()(HiddenJs);

exports.default = _default;

/***/ }),
/* 1002 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.isWidthDown = exports.isWidthUp = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(8));

var _objectSpread2 = _interopRequireDefault(__webpack_require__(23));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(18));

var _createClass2 = _interopRequireDefault(__webpack_require__(19));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(20));

var _inherits2 = _interopRequireDefault(__webpack_require__(21));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _reactEventListener = _interopRequireDefault(__webpack_require__(73));

var _debounce = _interopRequireDefault(__webpack_require__(93));

var _wrapDisplayName = _interopRequireDefault(__webpack_require__(162));

var _hoistNonReactStatics = _interopRequireDefault(__webpack_require__(160));

var _withTheme = _interopRequireDefault(__webpack_require__(91));

var _createBreakpoints = __webpack_require__(165);

// By default, returns true if screen width is the same or greater than the given breakpoint.
var isWidthUp = function isWidthUp(breakpoint, width) {
  var inclusive = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

  if (inclusive) {
    return _createBreakpoints.keys.indexOf(breakpoint) <= _createBreakpoints.keys.indexOf(width);
  }

  return _createBreakpoints.keys.indexOf(breakpoint) < _createBreakpoints.keys.indexOf(width);
}; // By default, returns true if screen width is the same or less than the given breakpoint.


exports.isWidthUp = isWidthUp;

var isWidthDown = function isWidthDown(breakpoint, width) {
  var inclusive = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

  if (inclusive) {
    return _createBreakpoints.keys.indexOf(width) <= _createBreakpoints.keys.indexOf(breakpoint);
  }

  return _createBreakpoints.keys.indexOf(width) < _createBreakpoints.keys.indexOf(breakpoint);
};

exports.isWidthDown = isWidthDown;

var withWidth = function withWidth() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return function (Component) {
    var _options$resizeInterv = options.resizeInterval,
        resizeInterval = _options$resizeInterv === void 0 ? 166 : _options$resizeInterv,
        _options$withTheme = options.withTheme,
        withThemeOption = _options$withTheme === void 0 ? false : _options$withTheme;

    var WithWidth =
    /*#__PURE__*/
    function (_React$Component) {
      (0, _inherits2.default)(WithWidth, _React$Component);

      function WithWidth() {
        var _ref;

        var _temp, _this;

        (0, _classCallCheck2.default)(this, WithWidth);

        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return (0, _possibleConstructorReturn2.default)(_this, (_temp = _this = (0, _possibleConstructorReturn2.default)(this, (_ref = WithWidth.__proto__ || Object.getPrototypeOf(WithWidth)).call.apply(_ref, [this].concat(args))), _this.state = {
          width: undefined
        }, _this.handleResize = (0, _debounce.default)(function () {
          _this.updateWidth(window.innerWidth);
        }, resizeInterval), _temp));
      }

      (0, _createClass2.default)(WithWidth, [{
        key: "componentDidMount",
        value: function componentDidMount() {
          this.updateWidth(window.innerWidth);
        }
      }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
          this.handleResize.clear();
        }
      }, {
        key: "updateWidth",
        value: function updateWidth(innerWidth) {
          var breakpoints = this.props.theme.breakpoints;
          var width = null;
          /**
           * Start with the slowest value as low end devices often have a small screen.
           *
           * innerWidth |xs      sm      md      lg      xl
           *            |-------|-------|-------|-------|------>
           * width      |  xs   |  sm   |  md   |  lg   |  xl
           */

          var index = 1;

          while (width === null && index < _createBreakpoints.keys.length) {
            var currentWidth = _createBreakpoints.keys[index]; // @media are inclusive, so reproduce the behavior here.

            if (innerWidth < breakpoints.values[currentWidth]) {
              width = _createBreakpoints.keys[index - 1];
              break;
            }

            index += 1;
          }

          width = width || 'xl';

          if (width !== this.state.width) {
            this.setState({
              width: width
            });
          }
        }
      }, {
        key: "render",
        value: function render() {
          var _props = this.props,
              initialWidth = _props.initialWidth,
              theme = _props.theme,
              width = _props.width,
              other = (0, _objectWithoutProperties2.default)(_props, ["initialWidth", "theme", "width"]);
          var props = (0, _objectSpread2.default)({
            width: width || this.state.width || initialWidth
          }, other);
          var more = {};

          if (withThemeOption) {
            more.theme = theme;
          } // When rendering the component on the server,
          // we have no idea about the client browser screen width.
          // In order to prevent blinks and help the reconciliation of the React tree
          // we are not rendering the child component.
          //
          // An alternative is to use the `initialWidth` property.


          if (props.width === undefined) {
            return null;
          }

          return _react.default.createElement(_reactEventListener.default, {
            target: "window",
            onResize: this.handleResize
          }, _react.default.createElement(Component, (0, _extends2.default)({}, more, props)));
        }
      }]);
      return WithWidth;
    }(_react.default.Component);

    WithWidth.propTypes =  false ? {
      /**
       * As `window.innerWidth` is unavailable on the server,
       * we default to rendering an empty componenent during the first mount.
       * In some situation you might want to use an heristic to approximate
       * the screen width of the client browser screen width.
       *
       * For instance, you could be using the user-agent or the client-hints.
       * http://caniuse.com/#search=client%20hint
       */
      initialWidth: _propTypes.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl']),

      /**
       * @ignore
       */
      theme: _propTypes.default.object.isRequired,

      /**
       * Bypass the width calculation logic.
       */
      width: _propTypes.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl'])
    } : {};

    if (false) {
      WithWidth.displayName = (0, _wrapDisplayName.default)(Component, 'WithWidth');
    }

    (0, _hoistNonReactStatics.default)(WithWidth, Component);
    return (0, _withTheme.default)()(WithWidth);
  };
};

var _default = withWidth;
exports.default = _default;

/***/ }),
/* 1003 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(11));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _warning = _interopRequireDefault(__webpack_require__(32));

var _createBreakpoints = __webpack_require__(165);

var _helpers = __webpack_require__(36);

var _withStyles = _interopRequireDefault(__webpack_require__(5));

var styles = function styles(theme) {
  var hidden = {
    display: 'none'
  };
  return _createBreakpoints.keys.reduce(function (acc, key) {
    acc["only".concat((0, _helpers.capitalize)(key))] = (0, _defineProperty2.default)({}, theme.breakpoints.only(key), hidden);
    acc["".concat(key, "Up")] = (0, _defineProperty2.default)({}, theme.breakpoints.up(key), hidden);
    acc["".concat(key, "Down")] = (0, _defineProperty2.default)({}, theme.breakpoints.down(key), hidden);
    return acc;
  }, {});
};
/**
 * @ignore - internal component.
 */


function HiddenCss(props) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      lgDown = props.lgDown,
      lgUp = props.lgUp,
      mdDown = props.mdDown,
      mdUp = props.mdUp,
      only = props.only,
      smDown = props.smDown,
      smUp = props.smUp,
      xlDown = props.xlDown,
      xlUp = props.xlUp,
      xsDown = props.xsDown,
      xsUp = props.xsUp,
      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "lgDown", "lgUp", "mdDown", "mdUp", "only", "smDown", "smUp", "xlDown", "xlUp", "xsDown", "xsUp"]);
   false ? (0, _warning.default)(Object.keys(other).length === 0 || Object.keys(other).length === 1 && other.hasOwnProperty('ref'), "Material-UI: unsupported properties received ".concat(Object.keys(other).join(', '), " by `<Hidden />`.")) : void 0;
  var classNames = [];

  if (className) {
    classNames.push(className);
  }

  for (var i = 0; i < _createBreakpoints.keys.length; i += 1) {
    var breakpoint = _createBreakpoints.keys[i];
    var breakpointUp = props["".concat(breakpoint, "Up")];
    var breakpointDown = props["".concat(breakpoint, "Down")];

    if (breakpointUp) {
      classNames.push(classes["".concat(breakpoint, "Up")]);
    }

    if (breakpointDown) {
      classNames.push(classes["".concat(breakpoint, "Down")]);
    }
  }

  if (only) {
    var onlyBreakpoints = Array.isArray(only) ? only : [only];
    onlyBreakpoints.forEach(function (breakpoint) {
      classNames.push(classes["only".concat((0, _helpers.capitalize)(breakpoint))]);
    });
  }

  return _react.default.createElement("div", {
    className: classNames.join(' ')
  }, children);
}

HiddenCss.propTypes =  false ? {
  /**
   * The content of the component.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * Specify which implementation to use.  'js' is the default, 'css' works better for server
   * side rendering.
   */
  implementation: _propTypes.default.oneOf(['js', 'css']),

  /**
   * If true, screens this size and down will be hidden.
   */
  lgDown: _propTypes.default.bool,

  /**
   * If true, screens this size and up will be hidden.
   */
  lgUp: _propTypes.default.bool,

  /**
   * If true, screens this size and down will be hidden.
   */
  mdDown: _propTypes.default.bool,

  /**
   * If true, screens this size and up will be hidden.
   */
  mdUp: _propTypes.default.bool,

  /**
   * Hide the given breakpoint(s).
   */
  only: _propTypes.default.oneOfType([_propTypes.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl']), _propTypes.default.arrayOf(_propTypes.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl']))]),

  /**
   * If true, screens this size and down will be hidden.
   */
  smDown: _propTypes.default.bool,

  /**
   * If true, screens this size and up will be hidden.
   */
  smUp: _propTypes.default.bool,

  /**
   * If true, screens this size and down will be hidden.
   */
  xlDown: _propTypes.default.bool,

  /**
   * If true, screens this size and up will be hidden.
   */
  xlUp: _propTypes.default.bool,

  /**
   * If true, screens this size and down will be hidden.
   */
  xsDown: _propTypes.default.bool,

  /**
   * If true, screens this size and up will be hidden.
   */
  xsUp: _propTypes.default.bool
} : {};

var _default = (0, _withStyles.default)(styles)(HiddenCss);

exports.default = _default;

/***/ }),
/* 1004 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Icon.default;
  }
});

var _Icon = _interopRequireDefault(__webpack_require__(1005));

/***/ }),
/* 1005 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(8));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(11));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _classnames = _interopRequireDefault(__webpack_require__(6));

var _withStyles = _interopRequireDefault(__webpack_require__(5));

var _helpers = __webpack_require__(36);

var styles = function styles(theme) {
  return {
    root: {
      userSelect: 'none',
      fontSize: 24,
      width: '1em',
      height: '1em',
      // Chrome fix for https://bugs.chromium.org/p/chromium/issues/detail?id=820541
      // To remove at some point.
      overflow: 'hidden',
      flexShrink: 0
    },
    colorPrimary: {
      color: theme.palette.primary.main
    },
    colorSecondary: {
      color: theme.palette.secondary.main
    },
    colorAction: {
      color: theme.palette.action.active
    },
    colorError: {
      color: theme.palette.error.main
    },
    colorDisabled: {
      color: theme.palette.action.disabled
    }
  };
};

exports.styles = styles;

function Icon(props) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      color = props.color,
      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "color"]);
  return _react.default.createElement("span", (0, _extends2.default)({
    className: (0, _classnames.default)('material-icons', classes.root, (0, _defineProperty2.default)({}, classes["color".concat((0, _helpers.capitalize)(color))], color !== 'inherit'), className),
    "aria-hidden": "true"
  }, other), children);
}

Icon.propTypes =  false ? {
  /**
   * The name of the icon font ligature.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: _propTypes.default.oneOf(['inherit', 'primary', 'secondary', 'action', 'error', 'disabled'])
} : {};
Icon.defaultProps = {
  color: 'inherit'
};
Icon.muiName = 'Icon';

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiIcon'
})(Icon);

exports.default = _default;

/***/ }),
/* 1006 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _InputAdornment.default;
  }
});

var _InputAdornment = _interopRequireDefault(__webpack_require__(1007));

/***/ }),
/* 1007 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(8));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(11));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _classnames = _interopRequireDefault(__webpack_require__(6));

var _Typography = _interopRequireDefault(__webpack_require__(46));

var _withStyles = _interopRequireDefault(__webpack_require__(5));

var styles = function styles(theme) {
  return {
    root: {
      display: 'flex',
      maxHeight: '2em',
      alignItems: 'center'
    },
    positionStart: {
      marginRight: theme.spacing.unit
    },
    positionEnd: {
      marginLeft: theme.spacing.unit
    }
  };
};

exports.styles = styles;

function InputAdornment(props) {
  var _classNames;

  var children = props.children,
      Component = props.component,
      classes = props.classes,
      className = props.className,
      disableTypography = props.disableTypography,
      position = props.position,
      other = (0, _objectWithoutProperties2.default)(props, ["children", "component", "classes", "className", "disableTypography", "position"]);
  return _react.default.createElement(Component, (0, _extends2.default)({
    className: (0, _classnames.default)(classes.root, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes.positionStart, position === 'start'), (0, _defineProperty2.default)(_classNames, classes.positionEnd, position === 'end'), _classNames), className)
  }, other), typeof children === 'string' && !disableTypography ? _react.default.createElement(_Typography.default, {
    color: "textSecondary"
  }, children) : children);
}

InputAdornment.propTypes =  false ? {
  /**
   * The content of the component, normally an `IconButton` or string.
   */
  children: _propTypes.default.node.isRequired,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func]),

  /**
   * If children is a string then disable wrapping in a Typography component.
   */
  disableTypography: _propTypes.default.bool,

  /**
   * The position this adornment should appear relative to the `Input`.
   */
  position: _propTypes.default.oneOf(['start', 'end'])
} : {};
InputAdornment.defaultProps = {
  component: 'div',
  disableTypography: false
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiInputAdornment'
})(InputAdornment);

exports.default = _default;

/***/ }),
/* 1008 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(8));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(11));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _classnames = _interopRequireDefault(__webpack_require__(6));

var _withStyles = _interopRequireDefault(__webpack_require__(5));

var _FormLabel = _interopRequireDefault(__webpack_require__(496));

// @inheritedComponent FormLabel
var styles = function styles(theme) {
  return {
    root: {
      transformOrigin: 'top left'
    },
    formControl: {
      position: 'absolute',
      left: 0,
      top: 0,
      // slight alteration to spec spacing to match visual spec result
      transform: "translate(0, ".concat(theme.spacing.unit * 3, "px) scale(1)")
    },
    marginDense: {
      // Compensation for the `Input.inputDense` style.
      transform: "translate(0, ".concat(theme.spacing.unit * 2.5 + 1, "px) scale(1)")
    },
    shrink: {
      transform: 'translate(0, 1.5px) scale(0.75)',
      transformOrigin: 'top left'
    },
    animated: {
      transition: theme.transitions.create('transform', {
        duration: theme.transitions.duration.shorter,
        easing: theme.transitions.easing.easeOut
      })
    }
  };
};

exports.styles = styles;

function InputLabel(props, context) {
  var _classNames;

  var children = props.children,
      classes = props.classes,
      classNameProp = props.className,
      disableAnimation = props.disableAnimation,
      FormLabelClasses = props.FormLabelClasses,
      marginProp = props.margin,
      shrinkProp = props.shrink,
      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "disableAnimation", "FormLabelClasses", "margin", "shrink"]);
  var muiFormControl = context.muiFormControl;
  var shrink = shrinkProp;

  if (typeof shrink === 'undefined' && muiFormControl) {
    shrink = muiFormControl.filled || muiFormControl.focused || muiFormControl.adornedStart;
  }

  var margin = marginProp;

  if (typeof margin === 'undefined' && muiFormControl) {
    margin = muiFormControl.margin;
  }

  var className = (0, _classnames.default)(classes.root, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes.formControl, muiFormControl), (0, _defineProperty2.default)(_classNames, classes.animated, !disableAnimation), (0, _defineProperty2.default)(_classNames, classes.shrink, shrink), (0, _defineProperty2.default)(_classNames, classes.marginDense, margin === 'dense'), _classNames), classNameProp);
  return _react.default.createElement(_FormLabel.default, (0, _extends2.default)({
    "data-shrink": shrink,
    className: className,
    classes: FormLabelClasses
  }, other), children);
}

InputLabel.propTypes =  false ? {
  /**
   * The contents of the `InputLabel`.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * If `true`, the transition animation is disabled.
   */
  disableAnimation: _propTypes.default.bool,

  /**
   * If `true`, apply disabled class.
   */
  disabled: _propTypes.default.bool,

  /**
   * If `true`, the label will be displayed in an error state.
   */
  error: _propTypes.default.bool,

  /**
   * If `true`, the input of this label is focused.
   */
  focused: _propTypes.default.bool,

  /**
   * `classes` property applied to the `FormLabel` element.
   */
  FormLabelClasses: _propTypes.default.object,

  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   */
  margin: _propTypes.default.oneOf(['dense']),

  /**
   * if `true`, the label will indicate that the input is required.
   */
  required: _propTypes.default.bool,

  /**
   * If `true`, the label is shrunk.
   */
  shrink: _propTypes.default.bool
} : {};
InputLabel.defaultProps = {
  disableAnimation: false
};
InputLabel.contextTypes = {
  muiFormControl: _propTypes.default.object
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiInputLabel'
})(InputLabel);

exports.default = _default;

/***/ }),
/* 1009 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(8));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(11));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _classnames = _interopRequireDefault(__webpack_require__(6));

var _warning = _interopRequireDefault(__webpack_require__(32));

var _withStyles = _interopRequireDefault(__webpack_require__(5));

var _colorManipulator = __webpack_require__(90);

var TRANSITION_DURATION = 4; // seconds

var styles = function styles(theme) {
  return {
    root: {
      position: 'relative',
      overflow: 'hidden',
      height: 5
    },
    colorPrimary: {
      backgroundColor: (0, _colorManipulator.lighten)(theme.palette.primary.light, 0.6)
    },
    colorSecondary: {
      backgroundColor: (0, _colorManipulator.lighten)(theme.palette.secondary.light, 0.4)
    },
    buffer: {
      backgroundColor: 'transparent'
    },
    query: {
      transform: 'rotate(180deg)'
    },
    dashed: {
      position: 'absolute',
      marginTop: 0,
      height: '100%',
      width: '100%',
      animation: 'buffer 3s infinite linear'
    },
    dashedColorPrimary: {
      backgroundImage: "radial-gradient(".concat((0, _colorManipulator.lighten)(theme.palette.primary.light, 0.6), " 0%, ").concat((0, _colorManipulator.lighten)(theme.palette.primary.light, 0.6), " 16%, transparent 42%)"),
      backgroundSize: '10px 10px',
      backgroundPosition: '0px -23px'
    },
    dashedColorSecondary: {
      backgroundImage: "radial-gradient(".concat((0, _colorManipulator.lighten)(theme.palette.secondary.light, 0.4), " 0%, ").concat((0, _colorManipulator.lighten)(theme.palette.secondary.light, 0.6), " 16%, transparent 42%)"),
      backgroundSize: '10px 10px',
      backgroundPosition: '0px -23px'
    },
    bar: {
      width: '100%',
      position: 'absolute',
      left: 0,
      bottom: 0,
      top: 0,
      transition: 'transform 0.2s linear',
      transformOrigin: 'left'
    },
    barColorPrimary: {
      backgroundColor: theme.palette.primary.main
    },
    barColorSecondary: {
      backgroundColor: theme.palette.secondary.main
    },
    bar1Indeterminate: {
      width: 'auto',
      willChange: 'left, right',
      animation: 'mui-indeterminate1 2.1s cubic-bezier(0.65, 0.815, 0.735, 0.395) infinite'
    },
    bar2Indeterminate: {
      width: 'auto',
      willChange: 'left, right',
      animation: 'mui-indeterminate2 2.1s cubic-bezier(0.165, 0.84, 0.44, 1) infinite',
      animationDelay: '1.15s'
    },
    bar1Determinate: {
      willChange: 'transform',
      transition: "transform .".concat(TRANSITION_DURATION, "s linear")
    },
    bar1Buffer: {
      zIndex: 1,
      transition: "transform .".concat(TRANSITION_DURATION, "s linear")
    },
    bar2Buffer: {
      transition: "transform .".concat(TRANSITION_DURATION, "s linear")
    },
    // Legends:
    // || represents the viewport
    // -  represents a light background
    // x  represents a dark background
    '@keyframes mui-indeterminate1': {
      //  |-----|---x-||-----||-----|
      '0%': {
        left: '-35%',
        right: '100%'
      },
      //  |-----|-----||-----||xxxx-|
      '60%': {
        left: '100%',
        right: '-90%'
      },
      '100%': {
        left: '100%',
        right: '-90%'
      }
    },
    '@keyframes mui-indeterminate2': {
      //  |xxxxx|xxxxx||-----||-----|
      '0%': {
        left: '-200%',
        right: '100%'
      },
      //  |-----|-----||-----||-x----|
      '60%': {
        left: '107%',
        right: '-8%'
      },
      '100%': {
        left: '107%',
        right: '-8%'
      }
    },
    '@keyframes buffer': {
      '0%': {
        opacity: 1,
        backgroundPosition: '0px -23px'
      },
      '50%': {
        opacity: 0,
        backgroundPosition: '0px -23px'
      },
      '100%': {
        opacity: 1,
        backgroundPosition: '-200px -23px'
      }
    }
  };
};
/**
 * ## ARIA
 *
 * If the progress bar is describing the loading progress of a particular region of a page,
 * you should use `aria-describedby` to point to the progress bar, and set the `aria-busy`
 * attribute to `true` on that region until it has finished loading.
 */


exports.styles = styles;

function LinearProgress(props) {
  var _classNames, _classNames2, _classNames3, _classNames4;

  var classes = props.classes,
      classNameProp = props.className,
      color = props.color,
      value = props.value,
      valueBuffer = props.valueBuffer,
      variant = props.variant,
      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "color", "value", "valueBuffer", "variant"]);
  var className = (0, _classnames.default)(classes.root, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes.colorPrimary, color === 'primary'), (0, _defineProperty2.default)(_classNames, classes.colorSecondary, color === 'secondary'), (0, _defineProperty2.default)(_classNames, classes.buffer, variant === 'buffer'), (0, _defineProperty2.default)(_classNames, classes.query, variant === 'query'), _classNames), classNameProp);
  var dashedClass = (0, _classnames.default)(classes.dashed, (_classNames2 = {}, (0, _defineProperty2.default)(_classNames2, classes.dashedColorPrimary, color === 'primary'), (0, _defineProperty2.default)(_classNames2, classes.dashedColorSecondary, color === 'secondary'), _classNames2));
  var bar1ClassName = (0, _classnames.default)(classes.bar, (_classNames3 = {}, (0, _defineProperty2.default)(_classNames3, classes.barColorPrimary, color === 'primary'), (0, _defineProperty2.default)(_classNames3, classes.barColorSecondary, color === 'secondary'), (0, _defineProperty2.default)(_classNames3, classes.bar1Indeterminate, variant === 'indeterminate' || variant === 'query'), (0, _defineProperty2.default)(_classNames3, classes.bar1Determinate, variant === 'determinate'), (0, _defineProperty2.default)(_classNames3, classes.bar1Buffer, variant === 'buffer'), _classNames3));
  var bar2ClassName = (0, _classnames.default)(classes.bar, (_classNames4 = {}, (0, _defineProperty2.default)(_classNames4, classes.barColorPrimary, color === 'primary' && variant !== 'buffer'), (0, _defineProperty2.default)(_classNames4, classes.colorPrimary, color === 'primary' && variant === 'buffer'), (0, _defineProperty2.default)(_classNames4, classes.barColorSecondary, color === 'secondary' && variant !== 'buffer'), (0, _defineProperty2.default)(_classNames4, classes.colorSecondary, color === 'secondary' && variant === 'buffer'), (0, _defineProperty2.default)(_classNames4, classes.bar2Indeterminate, variant === 'indeterminate' || variant === 'query'), (0, _defineProperty2.default)(_classNames4, classes.bar2Buffer, variant === 'buffer'), _classNames4));
  var rootProps = {};
  var inlineStyles = {
    bar1: {},
    bar2: {}
  };

  if (variant === 'determinate' || variant === 'buffer') {
    if (value !== undefined) {
      rootProps['aria-valuenow'] = Math.round(value);
      inlineStyles.bar1.transform = "scaleX(".concat(value / 100, ")");
    } else {
       false ? (0, _warning.default)(false, 'Material-UI: you need to provide a value property ' + 'when using the determinate or buffer variant of LinearProgress .') : void 0;
    }
  }

  if (variant === 'buffer') {
    if (valueBuffer !== undefined) {
      inlineStyles.bar2.transform = "scaleX(".concat((valueBuffer || 0) / 100, ")");
    } else {
       false ? (0, _warning.default)(false, 'Material-UI: you need to provide a valueBuffer property ' + 'when using the buffer variant of LinearProgress.') : void 0;
    }
  }

  return _react.default.createElement("div", (0, _extends2.default)({
    className: className,
    role: "progressbar"
  }, rootProps, other), variant === 'buffer' ? _react.default.createElement("div", {
    className: dashedClass
  }) : null, _react.default.createElement("div", {
    className: bar1ClassName,
    style: inlineStyles.bar1
  }), variant === 'determinate' ? null : _react.default.createElement("div", {
    className: bar2ClassName,
    style: inlineStyles.bar2
  }));
}

LinearProgress.propTypes =  false ? {
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: _propTypes.default.oneOf(['primary', 'secondary']),

  /**
   * The value of the progress indicator for the determinate and buffer variants.
   * Value between 0 and 100.
   */
  value: _propTypes.default.number,

  /**
   * The value for the buffer variant.
   * Value between 0 and 100.
   */
  valueBuffer: _propTypes.default.number,

  /**
   * The variant of progress indicator. Use indeterminate or query
   * when there is no progress value.
   */
  variant: _propTypes.default.oneOf(['determinate', 'indeterminate', 'buffer', 'query'])
} : {};
LinearProgress.defaultProps = {
  color: 'primary',
  variant: 'indeterminate'
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiLinearProgress'
})(LinearProgress);

exports.default = _default;

/***/ }),
/* 1010 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(8));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(11));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(18));

var _createClass2 = _interopRequireDefault(__webpack_require__(19));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(20));

var _inherits2 = _interopRequireDefault(__webpack_require__(21));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _classnames = _interopRequireDefault(__webpack_require__(6));

var _withStyles = _interopRequireDefault(__webpack_require__(5));

var styles = function styles(theme) {
  return {
    root: {
      listStyle: 'none',
      margin: 0,
      padding: 0,
      position: 'relative'
    },
    padding: {
      paddingTop: theme.spacing.unit,
      paddingBottom: theme.spacing.unit
    },
    dense: {
      paddingTop: theme.spacing.unit / 2,
      paddingBottom: theme.spacing.unit / 2
    },
    subheader: {
      paddingTop: 0
    }
  };
};

exports.styles = styles;

var List =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(List, _React$Component);

  function List() {
    (0, _classCallCheck2.default)(this, List);
    return (0, _possibleConstructorReturn2.default)(this, (List.__proto__ || Object.getPrototypeOf(List)).apply(this, arguments));
  }

  (0, _createClass2.default)(List, [{
    key: "getChildContext",
    value: function getChildContext() {
      return {
        dense: this.props.dense
      };
    }
  }, {
    key: "render",
    value: function render() {
      var _classNames;

      var _props = this.props,
          children = _props.children,
          classes = _props.classes,
          classNameProp = _props.className,
          Component = _props.component,
          dense = _props.dense,
          disablePadding = _props.disablePadding,
          subheader = _props.subheader,
          other = (0, _objectWithoutProperties2.default)(_props, ["children", "classes", "className", "component", "dense", "disablePadding", "subheader"]);
      var className = (0, _classnames.default)(classes.root, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes.dense, dense && !disablePadding), (0, _defineProperty2.default)(_classNames, classes.padding, !disablePadding), (0, _defineProperty2.default)(_classNames, classes.subheader, subheader), _classNames), classNameProp);
      return _react.default.createElement(Component, (0, _extends2.default)({
        className: className
      }, other), subheader, children);
    }
  }]);
  return List;
}(_react.default.Component);

List.propTypes =  false ? {
  /**
   * The content of the component.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func]),

  /**
   * If `true`, compact vertical padding designed for keyboard and mouse input will be used for
   * the list and list items. The property is available to descendant components as the
   * `dense` context.
   */
  dense: _propTypes.default.bool,

  /**
   * If `true`, vertical padding will be removed from the list.
   */
  disablePadding: _propTypes.default.bool,

  /**
   * The content of the subheader, normally `ListSubheader`.
   */
  subheader: _propTypes.default.node
} : {};
List.defaultProps = {
  component: 'ul',
  dense: false,
  disablePadding: false
};
List.childContextTypes = {
  dense: _propTypes.default.bool
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiList'
})(List);

exports.default = _default;

/***/ }),
/* 1011 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(8));

var _objectSpread2 = _interopRequireDefault(__webpack_require__(23));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(11));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(18));

var _createClass2 = _interopRequireDefault(__webpack_require__(19));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(20));

var _inherits2 = _interopRequireDefault(__webpack_require__(21));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _classnames = _interopRequireDefault(__webpack_require__(6));

var _withStyles = _interopRequireDefault(__webpack_require__(5));

var _ButtonBase = _interopRequireDefault(__webpack_require__(70));

var _reactHelpers = __webpack_require__(105);

var styles = function styles(theme) {
  return {
    root: {
      display: 'flex',
      justifyContent: 'flex-start',
      alignItems: 'center',
      position: 'relative',
      textDecoration: 'none',
      width: '100%',
      boxSizing: 'border-box',
      textAlign: 'left'
    },
    container: {
      position: 'relative'
    },
    focusVisible: {
      backgroundColor: theme.palette.action.hover
    },
    default: {
      paddingTop: 12,
      paddingBottom: 12
    },
    dense: {
      paddingTop: theme.spacing.unit,
      paddingBottom: theme.spacing.unit
    },
    disabled: {
      opacity: 0.5
    },
    divider: {
      borderBottom: "1px solid ".concat(theme.palette.divider),
      backgroundClip: 'padding-box'
    },
    gutters: theme.mixins.gutters(),
    button: {
      transition: theme.transitions.create('background-color', {
        duration: theme.transitions.duration.shortest
      }),
      '&:hover': {
        textDecoration: 'none',
        backgroundColor: theme.palette.action.hover,
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        }
      }
    },
    secondaryAction: {
      // Add some space to avoid collision as `ListItemSecondaryAction`
      // is absolutely positionned.
      paddingRight: theme.spacing.unit * 4
    }
  };
};

exports.styles = styles;

var ListItem =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(ListItem, _React$Component);

  function ListItem() {
    (0, _classCallCheck2.default)(this, ListItem);
    return (0, _possibleConstructorReturn2.default)(this, (ListItem.__proto__ || Object.getPrototypeOf(ListItem)).apply(this, arguments));
  }

  (0, _createClass2.default)(ListItem, [{
    key: "getChildContext",
    value: function getChildContext() {
      return {
        dense: this.props.dense || this.context.dense || false
      };
    }
  }, {
    key: "render",
    value: function render() {
      var _classNames;

      var _props = this.props,
          button = _props.button,
          childrenProp = _props.children,
          classes = _props.classes,
          classNameProp = _props.className,
          componentProp = _props.component,
          ContainerComponent = _props.ContainerComponent,
          _props$ContainerProps = _props.ContainerProps;
      _props$ContainerProps = _props$ContainerProps === void 0 ? {} : _props$ContainerProps;
      var ContainerClassName = _props$ContainerProps.className,
          ContainerProps = (0, _objectWithoutProperties2.default)(_props$ContainerProps, ["className"]),
          dense = _props.dense,
          disabled = _props.disabled,
          disableGutters = _props.disableGutters,
          divider = _props.divider,
          focusVisibleClassName = _props.focusVisibleClassName,
          other = (0, _objectWithoutProperties2.default)(_props, ["button", "children", "classes", "className", "component", "ContainerComponent", "ContainerProps", "dense", "disabled", "disableGutters", "divider", "focusVisibleClassName"]);
      var isDense = dense || this.context.dense || false;

      var children = _react.default.Children.toArray(childrenProp);

      var hasAvatar = children.some(function (value) {
        return (0, _reactHelpers.isMuiElement)(value, ['ListItemAvatar']);
      });
      var hasSecondaryAction = children.length && (0, _reactHelpers.isMuiElement)(children[children.length - 1], ['ListItemSecondaryAction']);
      var className = (0, _classnames.default)(classes.root, isDense || hasAvatar ? classes.dense : classes.default, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes.gutters, !disableGutters), (0, _defineProperty2.default)(_classNames, classes.divider, divider), (0, _defineProperty2.default)(_classNames, classes.disabled, disabled), (0, _defineProperty2.default)(_classNames, classes.button, button), (0, _defineProperty2.default)(_classNames, classes.secondaryAction, hasSecondaryAction), _classNames), classNameProp);
      var componentProps = (0, _objectSpread2.default)({
        className: className,
        disabled: disabled
      }, other);
      var Component = componentProp || 'li';

      if (button) {
        componentProps.component = componentProp || 'div';
        componentProps.focusVisibleClassName = (0, _classnames.default)(classes.focusVisible, focusVisibleClassName);
        Component = _ButtonBase.default;
      }

      if (hasSecondaryAction) {
        // Use div by default.
        Component = !componentProps.component && !componentProp ? 'div' : Component; // Avoid nesting of li > li.

        if (ContainerComponent === 'li') {
          if (Component === 'li') {
            Component = 'div';
          } else if (componentProps.component === 'li') {
            componentProps.component = 'div';
          }
        }

        return _react.default.createElement(ContainerComponent, (0, _extends2.default)({
          className: (0, _classnames.default)(classes.container, ContainerClassName)
        }, ContainerProps), _react.default.createElement(Component, componentProps, children), children.pop());
      }

      return _react.default.createElement(Component, componentProps, children);
    }
  }]);
  return ListItem;
}(_react.default.Component);

ListItem.propTypes =  false ? {
  /**
   * If `true`, the list item will be a button (using `ButtonBase`).
   */
  button: _propTypes.default.bool,

  /**
   * The content of the component.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   * By default, it's a `li` when `button` is `false` and a `div` when `button` is `true`.
   */
  component: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func]),

  /**
   * The container component used when a `ListItemSecondaryAction` is rendered.
   */
  ContainerComponent: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func]),

  /**
   * Properties applied to the container element when the component
   * is used to display a `ListItemSecondaryAction`.
   */
  ContainerProps: _propTypes.default.object,

  /**
   * If `true`, compact vertical padding designed for keyboard and mouse input will be used.
   */
  dense: _propTypes.default.bool,

  /**
   * @ignore
   */
  disabled: _propTypes.default.bool,

  /**
   * If `true`, the left and right padding is removed.
   */
  disableGutters: _propTypes.default.bool,

  /**
   * If `true`, a 1px light border is added to the bottom of the list item.
   */
  divider: _propTypes.default.bool,

  /**
   * @ignore
   */
  focusVisibleClassName: _propTypes.default.string
} : {};
ListItem.defaultProps = {
  button: false,
  ContainerComponent: 'li',
  dense: false,
  disabled: false,
  disableGutters: false,
  divider: false
};
ListItem.contextTypes = {
  dense: _propTypes.default.bool
};
ListItem.childContextTypes = {
  dense: _propTypes.default.bool
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiListItem'
})(ListItem);

exports.default = _default;

/***/ }),
/* 1012 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _ListItemAvatar.default;
  }
});

var _ListItemAvatar = _interopRequireDefault(__webpack_require__(1013));

/***/ }),
/* 1013 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(11));

var _objectSpread2 = _interopRequireDefault(__webpack_require__(23));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _classnames = _interopRequireDefault(__webpack_require__(6));

var _warning = _interopRequireDefault(__webpack_require__(32));

var _withStyles = _interopRequireDefault(__webpack_require__(5));

var styles = function styles(theme) {
  return {
    root: {
      width: 36,
      height: 36,
      fontSize: theme.typography.pxToRem(18),
      marginRight: 4
    },
    icon: {
      width: 20,
      height: 20,
      fontSize: theme.typography.pxToRem(20)
    }
  };
};
/**
 * It's a simple wrapper to apply the `dense` mode styles to `Avatar`.
 */


exports.styles = styles;

function ListItemAvatar(props, context) {
  var children = props.children,
      classes = props.classes,
      classNameProp = props.className,
      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className"]);

  if (context.dense === undefined) {
     false ? (0, _warning.default)(false, "Material-UI: <ListItemAvatar> is a simple wrapper to apply the dense styles\n      to <Avatar>. You do not need it unless you are controlling the <List> dense property.") : void 0;
    return props.children;
  }

  return _react.default.cloneElement(children, (0, _objectSpread2.default)({
    className: (0, _classnames.default)((0, _defineProperty2.default)({}, classes.root, context.dense), classNameProp, children.props.className),
    childrenClassName: (0, _classnames.default)((0, _defineProperty2.default)({}, classes.icon, context.dense), children.props.childrenClassName)
  }, other));
}

ListItemAvatar.propTypes =  false ? {
  /**
   * The content of the component, normally `Avatar`.
   */
  children: _propTypes.default.element.isRequired,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string
} : {};
ListItemAvatar.contextTypes = {
  dense: _propTypes.default.bool
};
ListItemAvatar.muiName = 'ListItemAvatar';

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiListItemAvatar'
})(ListItemAvatar);

exports.default = _default;

/***/ }),
/* 1014 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _objectSpread2 = _interopRequireDefault(__webpack_require__(23));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _classnames = _interopRequireDefault(__webpack_require__(6));

var _withStyles = _interopRequireDefault(__webpack_require__(5));

var styles = function styles(theme) {
  return {
    root: {
      marginRight: theme.spacing.unit * 2,
      color: theme.palette.action.active,
      flexShrink: 0
    }
  };
};
/**
 * A simple wrapper to apply `List` styles to an `Icon` or `SvgIcon`.
 */


exports.styles = styles;

function ListItemIcon(props) {
  var children = props.children,
      classes = props.classes,
      classNameProp = props.className,
      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className"]);
  return _react.default.cloneElement(children, (0, _objectSpread2.default)({
    className: (0, _classnames.default)(classes.root, classNameProp, children.props.className)
  }, other));
}

ListItemIcon.propTypes =  false ? {
  /**
   * The content of the component, normally `Icon`, `SvgIcon`,
   * or a `@material-ui/icons` SVG icon element.
   */
  children: _propTypes.default.element.isRequired,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string
} : {};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiListItemIcon'
})(ListItemIcon);

exports.default = _default;

/***/ }),
/* 1015 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _ListItemSecondaryAction.default;
  }
});

var _ListItemSecondaryAction = _interopRequireDefault(__webpack_require__(1016));

/***/ }),
/* 1016 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(8));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _classnames = _interopRequireDefault(__webpack_require__(6));

var _withStyles = _interopRequireDefault(__webpack_require__(5));

var styles = {
  root: {
    position: 'absolute',
    right: 4,
    top: '50%',
    transform: 'translateY(-50%)'
  }
};
exports.styles = styles;

function ListItemSecondaryAction(props) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className"]);
  return _react.default.createElement("div", (0, _extends2.default)({
    className: (0, _classnames.default)(classes.root, className)
  }, other), children);
}

ListItemSecondaryAction.propTypes =  false ? {
  /**
   * The content of the component, normally an `IconButton` or selection control.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string
} : {};
ListItemSecondaryAction.muiName = 'ListItemSecondaryAction';

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiListItemSecondaryAction'
})(ListItemSecondaryAction);

exports.default = _default;

/***/ }),
/* 1017 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(8));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(11));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _classnames = _interopRequireDefault(__webpack_require__(6));

var _withStyles = _interopRequireDefault(__webpack_require__(5));

var _Typography = _interopRequireDefault(__webpack_require__(46));

var styles = function styles(theme) {
  return {
    root: {
      flex: '1 1 auto',
      minWidth: 0,
      padding: "0 ".concat(theme.spacing.unit * 2, "px"),
      '&:first-child': {
        paddingLeft: 0
      }
    },
    inset: {
      '&:first-child': {
        paddingLeft: theme.spacing.unit * 7
      }
    },
    dense: {
      fontSize: theme.typography.pxToRem(13)
    },
    primary: {
      '&$textDense': {
        fontSize: 'inherit'
      }
    },
    secondary: {
      '&$textDense': {
        fontSize: 'inherit'
      }
    },
    textDense: {}
  };
};

exports.styles = styles;

function ListItemText(props, context) {
  var _classNames3;

  var children = props.children,
      classes = props.classes,
      classNameProp = props.className,
      disableTypography = props.disableTypography,
      inset = props.inset,
      primaryProp = props.primary,
      secondaryProp = props.secondary,
      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "disableTypography", "inset", "primary", "secondary"]);
  var dense = context.dense;
  var primary = primaryProp != null ? primaryProp : children;

  if (primary != null && !disableTypography) {
    primary = _react.default.createElement(_Typography.default, {
      variant: "subheading",
      className: (0, _classnames.default)(classes.primary, (0, _defineProperty2.default)({}, classes.textDense, dense)),
      component: "span"
    }, primary);
  }

  var secondary = secondaryProp;

  if (secondary != null && !disableTypography) {
    secondary = _react.default.createElement(_Typography.default, {
      variant: "body1",
      className: (0, _classnames.default)(classes.secondary, (0, _defineProperty2.default)({}, classes.textDense, dense)),
      color: "textSecondary"
    }, secondary);
  }

  return _react.default.createElement("div", (0, _extends2.default)({
    className: (0, _classnames.default)(classes.root, (_classNames3 = {}, (0, _defineProperty2.default)(_classNames3, classes.dense, dense), (0, _defineProperty2.default)(_classNames3, classes.inset, inset), _classNames3), classNameProp)
  }, other), primary, secondary);
}

ListItemText.propTypes =  false ? {
  /**
   * Alias for the `primary` property.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * If `true`, the children won't be wrapped by a Typography component.
   * This can be useful to render an alternative Typography variant by wrapping
   * the `children` (or `primary`) text, and optional `secondary` text
   * with the Typography component.
   */
  disableTypography: _propTypes.default.bool,

  /**
   * If `true`, the children will be indented.
   * This should be used if there is no left avatar or left icon.
   */
  inset: _propTypes.default.bool,

  /**
   * The main content element.
   */
  primary: _propTypes.default.node,

  /**
   * The secondary content element.
   */
  secondary: _propTypes.default.node
} : {};
ListItemText.defaultProps = {
  disableTypography: false,
  inset: false
};
ListItemText.contextTypes = {
  dense: _propTypes.default.bool
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiListItemText'
})(ListItemText);

exports.default = _default;

/***/ }),
/* 1018 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _ListSubheader.default;
  }
});

var _ListSubheader = _interopRequireDefault(__webpack_require__(1019));

/***/ }),
/* 1019 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(8));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(11));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _classnames = _interopRequireDefault(__webpack_require__(6));

var _withStyles = _interopRequireDefault(__webpack_require__(5));

var _helpers = __webpack_require__(36);

var styles = function styles(theme) {
  return {
    root: theme.mixins.gutters({
      boxSizing: 'border-box',
      lineHeight: '48px',
      listStyle: 'none',
      color: theme.palette.text.secondary,
      fontFamily: theme.typography.fontFamily,
      fontWeight: theme.typography.fontWeightMedium,
      fontSize: theme.typography.pxToRem(14)
    }),
    colorPrimary: {
      color: theme.palette.primary.main
    },
    colorInherit: {
      color: 'inherit'
    },
    inset: {
      paddingLeft: theme.spacing.unit * 9
    },
    sticky: {
      position: 'sticky',
      top: 0,
      zIndex: 1,
      backgroundColor: 'inherit'
    }
  };
};

exports.styles = styles;

function ListSubheader(props) {
  var _classNames;

  var classes = props.classes,
      className = props.className,
      color = props.color,
      Component = props.component,
      disableSticky = props.disableSticky,
      inset = props.inset,
      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "color", "component", "disableSticky", "inset"]);
  return _react.default.createElement(Component, (0, _extends2.default)({
    className: (0, _classnames.default)(classes.root, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes["color".concat((0, _helpers.capitalize)(color))], color !== 'default'), (0, _defineProperty2.default)(_classNames, classes.inset, inset), (0, _defineProperty2.default)(_classNames, classes.sticky, !disableSticky), _classNames), className)
  }, other));
}

ListSubheader.propTypes =  false ? {
  /**
   * The content of the component.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: _propTypes.default.oneOf(['default', 'primary', 'inherit']),

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func]),

  /**
   * If `true`, the List Subheader will not stick to the top during scroll.
   */
  disableSticky: _propTypes.default.bool,

  /**
   * If `true`, the List Subheader will be indented.
   */
  inset: _propTypes.default.bool
} : {};
ListSubheader.defaultProps = {
  color: 'default',
  component: 'li',
  disableSticky: false,
  inset: false
};
ListSubheader.muiName = 'ListSubheader';

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiListSubheader'
})(ListSubheader);

exports.default = _default;

/***/ }),
/* 1020 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Menu.default;
  }
});

var _Menu = _interopRequireDefault(__webpack_require__(501));

/***/ }),
/* 1021 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(8));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(18));

var _createClass2 = _interopRequireDefault(__webpack_require__(19));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(20));

var _inherits2 = _interopRequireDefault(__webpack_require__(21));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _reactDom = _interopRequireDefault(__webpack_require__(45));

var _warning = _interopRequireDefault(__webpack_require__(32));

var _contains = _interopRequireDefault(__webpack_require__(218));

var _ownerDocument = _interopRequireDefault(__webpack_require__(71));

var _debounce = _interopRequireDefault(__webpack_require__(93));

var _reactEventListener = _interopRequireDefault(__webpack_require__(73));

var _ownerWindow = _interopRequireDefault(__webpack_require__(217));

var _withStyles = _interopRequireDefault(__webpack_require__(5));

var _Modal = _interopRequireDefault(__webpack_require__(226));

var _Grow = _interopRequireDefault(__webpack_require__(497));

var _Paper = _interopRequireDefault(__webpack_require__(69));

// @inheritedComponent Modal
function getOffsetTop(rect, vertical) {
  var offset = 0;

  if (typeof vertical === 'number') {
    offset = vertical;
  } else if (vertical === 'center') {
    offset = rect.height / 2;
  } else if (vertical === 'bottom') {
    offset = rect.height;
  }

  return offset;
}

function getOffsetLeft(rect, horizontal) {
  var offset = 0;

  if (typeof horizontal === 'number') {
    offset = horizontal;
  } else if (horizontal === 'center') {
    offset = rect.width / 2;
  } else if (horizontal === 'right') {
    offset = rect.width;
  }

  return offset;
}

function getTransformOriginValue(transformOrigin) {
  return [transformOrigin.horizontal, transformOrigin.vertical].map(function (n) {
    return typeof n === 'number' ? "".concat(n, "px") : n;
  }).join(' ');
} // Sum the scrollTop between two elements.


function getScrollParent(parent, child) {
  var element = child;
  var scrollTop = 0;

  while (element && element !== parent) {
    element = element.parentNode;
    scrollTop += element.scrollTop;
  }

  return scrollTop;
}

function getAnchorEl(anchorEl) {
  return typeof anchorEl === 'function' ? anchorEl() : anchorEl;
}

var styles = {
  paper: {
    position: 'absolute',
    overflowY: 'auto',
    overflowX: 'hidden',
    // So we see the popover when it's empty.
    // It's most likely on issue on userland.
    minWidth: 16,
    minHeight: 16,
    maxWidth: 'calc(100% - 32px)',
    maxHeight: 'calc(100% - 32px)',
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 'none'
  }
};
exports.styles = styles;

var Popover =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(Popover, _React$Component);

  function Popover() {
    var _ref;

    var _temp, _this;

    (0, _classCallCheck2.default)(this, Popover);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return (0, _possibleConstructorReturn2.default)(_this, (_temp = _this = (0, _possibleConstructorReturn2.default)(this, (_ref = Popover.__proto__ || Object.getPrototypeOf(Popover)).call.apply(_ref, [this].concat(args))), _this.componentWillUnmount = function () {
      _this.handleResize.clear();
    }, _this.setPositioningStyles = function (element) {
      if (element && element.style) {
        var positioning = _this.getPositioningStyle(element);

        if (positioning.top !== null) {
          element.style.top = positioning.top;
        }

        if (positioning.left !== null) {
          element.style.left = positioning.left;
        }

        element.style.transformOrigin = positioning.transformOrigin;
      }
    }, _this.getPositioningStyle = function (element) {
      var _this$props = _this.props,
          anchorEl = _this$props.anchorEl,
          anchorReference = _this$props.anchorReference,
          marginThreshold = _this$props.marginThreshold; // Check if the parent has requested anchoring on an inner content node

      var contentAnchorOffset = _this.getContentAnchorOffset(element);

      var elemRect = {
        width: element.clientWidth,
        height: element.clientHeight
      }; // Get the transform origin point on the element itself

      var transformOrigin = _this.getTransformOrigin(elemRect, contentAnchorOffset);

      if (anchorReference === 'none') {
        return {
          top: null,
          left: null,
          transformOrigin: getTransformOriginValue(transformOrigin)
        };
      } // Get the offset of of the anchoring element


      var anchorOffset = _this.getAnchorOffset(contentAnchorOffset); // Calculate element positioning


      var top = anchorOffset.top - transformOrigin.vertical;
      var left = anchorOffset.left - transformOrigin.horizontal;
      var bottom = top + elemRect.height;
      var right = left + elemRect.width; // Use the parent window of the anchorEl if provided

      var containerWindow = (0, _ownerWindow.default)(getAnchorEl(anchorEl)); // Window thresholds taking required margin into account

      var heightThreshold = containerWindow.innerHeight - marginThreshold;
      var widthThreshold = containerWindow.innerWidth - marginThreshold; // Check if the vertical axis needs shifting

      if (top < marginThreshold) {
        var diff = top - marginThreshold;
        top -= diff;
        transformOrigin.vertical += diff;
      } else if (bottom > heightThreshold) {
        var _diff = bottom - heightThreshold;

        top -= _diff;
        transformOrigin.vertical += _diff;
      }

       false ? (0, _warning.default)(elemRect.height < heightThreshold || !elemRect.height || !heightThreshold, ['Material-UI: the popover component is too tall.', "Some part of it can not be seen on the screen (".concat(elemRect.height - heightThreshold, "px)."), 'Please consider adding a `max-height` to improve the user-experience.'].join('\n')) : void 0; // Check if the horizontal axis needs shifting

      if (left < marginThreshold) {
        var _diff2 = left - marginThreshold;

        left -= _diff2;
        transformOrigin.horizontal += _diff2;
      } else if (right > widthThreshold) {
        var _diff3 = right - widthThreshold;

        left -= _diff3;
        transformOrigin.horizontal += _diff3;
      }

      return {
        top: "".concat(top, "px"),
        left: "".concat(left, "px"),
        transformOrigin: getTransformOriginValue(transformOrigin)
      };
    }, _this.transitionEl = undefined, _this.handleGetOffsetTop = getOffsetTop, _this.handleGetOffsetLeft = getOffsetLeft, _this.handleEnter = function (element) {
      if (_this.props.onEnter) {
        _this.props.onEnter(element);
      }

      _this.setPositioningStyles(element);
    }, _this.handleResize = (0, _debounce.default)(function () {
      var element = _reactDom.default.findDOMNode(_this.transitionEl);

      _this.setPositioningStyles(element);
    }, 166), _temp));
  }

  (0, _createClass2.default)(Popover, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.action) {
        this.props.action({
          updatePosition: this.handleResize
        });
      }
    }
  }, {
    key: "getAnchorOffset",
    // Returns the top/left offset of the position
    // to attach to on the anchor element (or body if none is provided)
    value: function getAnchorOffset(contentAnchorOffset) {
      var _props = this.props,
          anchorEl = _props.anchorEl,
          anchorOrigin = _props.anchorOrigin,
          anchorReference = _props.anchorReference,
          anchorPosition = _props.anchorPosition;

      if (anchorReference === 'anchorPosition') {
         false ? (0, _warning.default)(anchorPosition, 'Material-UI: you need to provide a `anchorPosition` property when using ' + '<Popover anchorReference="anchorPosition" />.') : void 0;
        return anchorPosition;
      } // If an anchor element wasn't provided, just use the parent body element of this Popover


      var anchorElement = getAnchorEl(anchorEl) || (0, _ownerDocument.default)(_reactDom.default.findDOMNode(this.transitionEl)).body;
      var anchorRect = anchorElement.getBoundingClientRect();
      var anchorVertical = contentAnchorOffset === 0 ? anchorOrigin.vertical : 'center';
      return {
        top: anchorRect.top + this.handleGetOffsetTop(anchorRect, anchorVertical),
        left: anchorRect.left + this.handleGetOffsetLeft(anchorRect, anchorOrigin.horizontal)
      };
    } // Returns the vertical offset of inner content to anchor the transform on if provided

  }, {
    key: "getContentAnchorOffset",
    value: function getContentAnchorOffset(element) {
      var _props2 = this.props,
          getContentAnchorEl = _props2.getContentAnchorEl,
          anchorReference = _props2.anchorReference;
      var contentAnchorOffset = 0;

      if (getContentAnchorEl && anchorReference === 'anchorEl') {
        var contentAnchorEl = getContentAnchorEl(element);

        if (contentAnchorEl && (0, _contains.default)(element, contentAnchorEl)) {
          var scrollTop = getScrollParent(element, contentAnchorEl);
          contentAnchorOffset = contentAnchorEl.offsetTop + contentAnchorEl.clientHeight / 2 - scrollTop || 0;
        } // != the default value


         false ? (0, _warning.default)(this.props.anchorOrigin.vertical === 'top', ['Material-UI: you can not change the default `anchorOrigin.vertical` value ', 'when also providing the `getContentAnchorEl` property to the popover component.', 'Only use one of the two properties.', 'Set `getContentAnchorEl` to null or left `anchorOrigin.vertical` unchanged.'].join('\n')) : void 0;
      }

      return contentAnchorOffset;
    } // Return the base transform origin using the element
    // and taking the content anchor offset into account if in use

  }, {
    key: "getTransformOrigin",
    value: function getTransformOrigin(elemRect) {
      var contentAnchorOffset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var transformOrigin = this.props.transformOrigin;
      return {
        vertical: this.handleGetOffsetTop(elemRect, transformOrigin.vertical) + contentAnchorOffset,
        horizontal: this.handleGetOffsetLeft(elemRect, transformOrigin.horizontal)
      };
    }
  }, {
    key: "render",
    // Corresponds to 10 frames at 60 Hz.
    value: function render() {
      var _this2 = this;

      var _props3 = this.props,
          action = _props3.action,
          anchorEl = _props3.anchorEl,
          anchorOrigin = _props3.anchorOrigin,
          anchorPosition = _props3.anchorPosition,
          anchorReference = _props3.anchorReference,
          children = _props3.children,
          classes = _props3.classes,
          containerProp = _props3.container,
          elevation = _props3.elevation,
          getContentAnchorEl = _props3.getContentAnchorEl,
          marginThreshold = _props3.marginThreshold,
          onEnter = _props3.onEnter,
          onEntered = _props3.onEntered,
          onEntering = _props3.onEntering,
          onExit = _props3.onExit,
          onExited = _props3.onExited,
          onExiting = _props3.onExiting,
          open = _props3.open,
          PaperProps = _props3.PaperProps,
          role = _props3.role,
          transformOrigin = _props3.transformOrigin,
          TransitionComponent = _props3.TransitionComponent,
          transitionDuration = _props3.transitionDuration,
          TransitionProps = _props3.TransitionProps,
          other = (0, _objectWithoutProperties2.default)(_props3, ["action", "anchorEl", "anchorOrigin", "anchorPosition", "anchorReference", "children", "classes", "container", "elevation", "getContentAnchorEl", "marginThreshold", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "open", "PaperProps", "role", "transformOrigin", "TransitionComponent", "transitionDuration", "TransitionProps"]); // If the container prop is provided, use that
      // If the anchorEl prop is provided, use its parent body element as the container
      // If neither are provided let the Modal take care of choosing the container

      var container = containerProp || (anchorEl ? (0, _ownerDocument.default)(getAnchorEl(anchorEl)).body : undefined);
      return _react.default.createElement(_Modal.default, (0, _extends2.default)({
        container: container,
        open: open,
        BackdropProps: {
          invisible: true
        }
      }, other), _react.default.createElement(TransitionComponent, (0, _extends2.default)({
        appear: true,
        "in": open,
        onEnter: this.handleEnter,
        onEntered: onEntered,
        onEntering: onEntering,
        onExit: onExit,
        onExited: onExited,
        onExiting: onExiting,
        role: role,
        ref: function ref(node) {
          _this2.transitionEl = node;
        },
        timeout: transitionDuration
      }, TransitionProps), _react.default.createElement(_Paper.default, (0, _extends2.default)({
        className: classes.paper,
        elevation: elevation
      }, PaperProps), _react.default.createElement(_reactEventListener.default, {
        target: "window",
        onResize: this.handleResize
      }), children)));
    }
  }]);
  return Popover;
}(_react.default.Component);

Popover.propTypes =  false ? {
  /**
   * This is callback property. It's called by the component on mount.
   * This is useful when you want to trigger an action programmatically.
   * It currently only supports updatePosition() action.
   *
   * @param {object} actions This object contains all posible actions
   * that can be triggered programmatically.
   */
  action: _propTypes.default.func,

  /**
   * This is the DOM element, or a function that returns the DOM element,
   * that may be used to set the position of the popover.
   */
  anchorEl: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.func]),

  /**
   * This is the point on the anchor where the popover's
   * `anchorEl` will attach to. This is not used when the
   * anchorReference is 'anchorPosition'.
   *
   * Options:
   * vertical: [top, center, bottom];
   * horizontal: [left, center, right].
   */
  anchorOrigin: _propTypes.default.shape({
    horizontal: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.oneOf(['left', 'center', 'right'])]),
    vertical: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.oneOf(['top', 'center', 'bottom'])])
  }),

  /**
   * This is the position that may be used
   * to set the position of the popover.
   * The coordinates are relative to
   * the application's client area.
   */
  anchorPosition: _propTypes.default.shape({
    top: _propTypes.default.number,
    left: _propTypes.default.number
  }),

  /*
   * This determines which anchor prop to refer to to set
   * the position of the popover.
   */
  anchorReference: _propTypes.default.oneOf(['anchorEl', 'anchorPosition', 'none']),

  /**
   * The content of the component.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * A node, component instance, or function that returns either.
   * The `container` will passed to the Modal component.
   * By default, it uses the body of the anchorEl's top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.func]),

  /**
   * The elevation of the popover.
   */
  elevation: _propTypes.default.number,

  /**
   * This function is called in order to retrieve the content anchor element.
   * It's the opposite of the `anchorEl` property.
   * The content anchor element should be an element inside the popover.
   * It's used to correctly scroll and set the position of the popover.
   * The positioning strategy tries to make the content anchor element just above the
   * anchor element.
   */
  getContentAnchorEl: _propTypes.default.func,

  /**
   * Specifies how close to the edge of the window the popover can appear.
   */
  marginThreshold: _propTypes.default.number,

  /**
   * Callback fired when the component requests to be closed.
   *
   * @param {object} event The event source of the callback.
   */
  onClose: _propTypes.default.func,

  /**
   * Callback fired before the component is entering.
   */
  onEnter: _propTypes.default.func,

  /**
   * Callback fired when the component has entered.
   */
  onEntered: _propTypes.default.func,

  /**
   * Callback fired when the component is entering.
   */
  onEntering: _propTypes.default.func,

  /**
   * Callback fired before the component is exiting.
   */
  onExit: _propTypes.default.func,

  /**
   * Callback fired when the component has exited.
   */
  onExited: _propTypes.default.func,

  /**
   * Callback fired when the component is exiting.
   */
  onExiting: _propTypes.default.func,

  /**
   * If `true`, the popover is visible.
   */
  open: _propTypes.default.bool.isRequired,

  /**
   * Properties applied to the `Paper` element.
   */
  PaperProps: _propTypes.default.object,

  /**
   * @ignore
   */
  role: _propTypes.default.string,

  /**
   * This is the point on the popover which
   * will attach to the anchor's origin.
   *
   * Options:
   * vertical: [top, center, bottom, x(px)];
   * horizontal: [left, center, right, x(px)].
   */
  transformOrigin: _propTypes.default.shape({
    horizontal: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.oneOf(['left', 'center', 'right'])]),
    vertical: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.oneOf(['top', 'center', 'bottom'])])
  }),

  /**
   * Transition component.
   */
  TransitionComponent: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func]),

  /**
   * Set to 'auto' to automatically calculate transition time based on height.
   */
  transitionDuration: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
    enter: _propTypes.default.number,
    exit: _propTypes.default.number
  }), _propTypes.default.oneOf(['auto'])]),

  /**
   * Properties applied to the `Transition` element.
   */
  TransitionProps: _propTypes.default.object
} : {};
Popover.defaultProps = {
  anchorReference: 'anchorEl',
  anchorOrigin: {
    vertical: 'top',
    horizontal: 'left'
  },
  elevation: 8,
  marginThreshold: 16,
  transformOrigin: {
    vertical: 'top',
    horizontal: 'left'
  },
  TransitionComponent: _Grow.default,
  transitionDuration: 'auto'
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiPopover'
})(Popover);

exports.default = _default;

/***/ }),
/* 1022 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(8));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(18));

var _createClass2 = _interopRequireDefault(__webpack_require__(19));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(20));

var _inherits2 = _interopRequireDefault(__webpack_require__(21));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _reactDom = _interopRequireDefault(__webpack_require__(45));

var _keycode = _interopRequireDefault(__webpack_require__(133));

var _contains = _interopRequireDefault(__webpack_require__(218));

var _activeElement = _interopRequireDefault(__webpack_require__(487));

var _ownerDocument = _interopRequireDefault(__webpack_require__(71));

var _List = _interopRequireDefault(__webpack_require__(107));

// @inheritedComponent List
var MenuList =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(MenuList, _React$Component);

  function MenuList() {
    var _ref;

    var _temp, _this;

    (0, _classCallCheck2.default)(this, MenuList);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return (0, _possibleConstructorReturn2.default)(_this, (_temp = _this = (0, _possibleConstructorReturn2.default)(this, (_ref = MenuList.__proto__ || Object.getPrototypeOf(MenuList)).call.apply(_ref, [this].concat(args))), _this.state = {
      currentTabIndex: undefined
    }, _this.list = undefined, _this.selectedItem = undefined, _this.blurTimer = undefined, _this.handleBlur = function (event) {
      _this.blurTimer = setTimeout(function () {
        if (_this.list) {
          var list = _reactDom.default.findDOMNode(_this.list);

          var currentFocus = (0, _activeElement.default)((0, _ownerDocument.default)(list));

          if (!(0, _contains.default)(list, currentFocus)) {
            _this.resetTabIndex();
          }
        }
      }, 30);

      if (_this.props.onBlur) {
        _this.props.onBlur(event);
      }
    }, _this.handleKeyDown = function (event) {
      var list = _reactDom.default.findDOMNode(_this.list);

      var key = (0, _keycode.default)(event);
      var currentFocus = (0, _activeElement.default)((0, _ownerDocument.default)(list));

      if ((key === 'up' || key === 'down') && (!currentFocus || currentFocus && !(0, _contains.default)(list, currentFocus))) {
        if (_this.selectedItem) {
          _reactDom.default.findDOMNode(_this.selectedItem).focus();
        } else {
          list.firstChild.focus();
        }
      } else if (key === 'down') {
        event.preventDefault();

        if (currentFocus.nextElementSibling) {
          currentFocus.nextElementSibling.focus();
        }
      } else if (key === 'up') {
        event.preventDefault();

        if (currentFocus.previousElementSibling) {
          currentFocus.previousElementSibling.focus();
        }
      }

      if (_this.props.onKeyDown) {
        _this.props.onKeyDown(event, key);
      }
    }, _this.handleItemFocus = function (event) {
      var list = _reactDom.default.findDOMNode(_this.list);

      if (list) {
        for (var i = 0; i < list.children.length; i += 1) {
          if (list.children[i] === event.currentTarget) {
            _this.setTabIndex(i);

            break;
          }
        }
      }
    }, _temp));
  }

  (0, _createClass2.default)(MenuList, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.resetTabIndex();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearTimeout(this.blurTimer);
    }
  }, {
    key: "setTabIndex",
    value: function setTabIndex(index) {
      this.setState({
        currentTabIndex: index
      });
    }
  }, {
    key: "focus",
    value: function focus() {
      var currentTabIndex = this.state.currentTabIndex;

      var list = _reactDom.default.findDOMNode(this.list);

      if (!list || !list.children || !list.firstChild) {
        return;
      }

      if (currentTabIndex && currentTabIndex >= 0) {
        list.children[currentTabIndex].focus();
      } else {
        list.firstChild.focus();
      }
    }
  }, {
    key: "resetTabIndex",
    value: function resetTabIndex() {
      var list = _reactDom.default.findDOMNode(this.list);

      var currentFocus = (0, _activeElement.default)((0, _ownerDocument.default)(list));
      var items = [];

      for (var i = 0; i < list.children.length; i += 1) {
        items.push(list.children[i]);
      }

      var currentFocusIndex = items.indexOf(currentFocus);

      if (currentFocusIndex !== -1) {
        return this.setTabIndex(currentFocusIndex);
      }

      if (this.selectedItem) {
        return this.setTabIndex(items.indexOf(_reactDom.default.findDOMNode(this.selectedItem)));
      }

      return this.setTabIndex(0);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          children = _props.children,
          className = _props.className,
          onBlur = _props.onBlur,
          onKeyDown = _props.onKeyDown,
          other = (0, _objectWithoutProperties2.default)(_props, ["children", "className", "onBlur", "onKeyDown"]);
      return _react.default.createElement(_List.default, (0, _extends2.default)({
        role: "menu",
        ref: function ref(node) {
          _this2.list = node;
        },
        className: className,
        onKeyDown: this.handleKeyDown,
        onBlur: this.handleBlur
      }, other), _react.default.Children.map(children, function (child, index) {
        if (!_react.default.isValidElement(child)) {
          return null;
        }

        return _react.default.cloneElement(child, {
          tabIndex: index === _this2.state.currentTabIndex ? 0 : -1,
          ref: child.props.selected ? function (node) {
            _this2.selectedItem = node;
          } : undefined,
          onFocus: _this2.handleItemFocus
        });
      }));
    }
  }]);
  return MenuList;
}(_react.default.Component);

MenuList.propTypes =  false ? {
  /**
   * MenuList contents, normally `MenuItem`s.
   */
  children: _propTypes.default.node,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * @ignore
   */
  onBlur: _propTypes.default.func,

  /**
   * @ignore
   */
  onKeyDown: _propTypes.default.func
} : {};
var _default = MenuList;
exports.default = _default;

/***/ }),
/* 1023 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(8));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(11));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _objectSpread2 = _interopRequireDefault(__webpack_require__(23));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _classnames = _interopRequireDefault(__webpack_require__(6));

var _withStyles = _interopRequireDefault(__webpack_require__(5));

var _ListItem = _interopRequireDefault(__webpack_require__(108));

// @inheritedComponent ListItem
var styles = function styles(theme) {
  return {
    root: (0, _objectSpread2.default)({}, theme.typography.subheading, {
      height: theme.spacing.unit * 3,
      boxSizing: 'content-box',
      width: 'auto',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      paddingLeft: theme.spacing.unit * 2,
      paddingRight: theme.spacing.unit * 2,
      '&$selected': {
        backgroundColor: theme.palette.action.selected
      }
    }),
    selected: {}
  };
};

exports.styles = styles;

function MenuItem(props) {
  var classes = props.classes,
      className = props.className,
      component = props.component,
      selected = props.selected,
      role = props.role,
      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "component", "selected", "role"]);
  return _react.default.createElement(_ListItem.default, (0, _extends2.default)({
    button: true,
    role: role,
    tabIndex: -1,
    className: (0, _classnames.default)(classes.root, (0, _defineProperty2.default)({}, classes.selected, selected), className),
    component: component
  }, other));
}

MenuItem.propTypes =  false ? {
  /**
   * Menu item contents.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func]),

  /**
   * @ignore
   */
  role: _propTypes.default.string,

  /**
   * Use to apply selected styling.
   */
  selected: _propTypes.default.bool
} : {};
MenuItem.defaultProps = {
  component: 'li',
  role: 'menuitem',
  selected: false
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiMenuItem'
})(MenuItem);

exports.default = _default;

/***/ }),
/* 1024 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(8));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(11));

var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(219));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _classnames = _interopRequireDefault(__webpack_require__(6));

var _withStyles = _interopRequireDefault(__webpack_require__(5));

var _Paper = _interopRequireDefault(__webpack_require__(69));

var _helpers = __webpack_require__(36);

var _LinearProgress = _interopRequireDefault(__webpack_require__(499));

// @inheritedComponent Paper
var styles = function styles(theme) {
  return {
    root: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      background: theme.palette.background.default,
      padding: theme.spacing.unit
    },
    positionBottom: {
      position: 'fixed',
      bottom: 0,
      left: 0,
      right: 0,
      zIndex: theme.zIndex.mobileStepper
    },
    positionTop: {
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      zIndex: theme.zIndex.mobileStepper
    },
    positionStatic: {},
    dots: {
      display: 'flex',
      flexDirection: 'row'
    },
    dot: {
      backgroundColor: theme.palette.action.disabled,
      borderRadius: '50%',
      width: theme.spacing.unit,
      height: theme.spacing.unit,
      margin: '0 2px'
    },
    dotActive: {
      backgroundColor: theme.palette.primary.main
    },
    progress: {
      width: '50%'
    }
  };
};

exports.styles = styles;

function MobileStepper(props) {
  var activeStep = props.activeStep,
      backButton = props.backButton,
      classes = props.classes,
      classNameProp = props.className,
      nextButton = props.nextButton,
      position = props.position,
      steps = props.steps,
      variant = props.variant,
      other = (0, _objectWithoutProperties2.default)(props, ["activeStep", "backButton", "classes", "className", "nextButton", "position", "steps", "variant"]);
  var className = (0, _classnames.default)(classes.root, classes["position".concat((0, _helpers.capitalize)(position))], classNameProp);
  return _react.default.createElement(_Paper.default, (0, _extends2.default)({
    square: true,
    elevation: 0,
    className: className
  }, other), backButton, variant === 'dots' && _react.default.createElement("div", {
    className: classes.dots
  }, (0, _toConsumableArray2.default)(new Array(steps)).map(function (_, step) {
    var dotClassName = (0, _classnames.default)(classes.dot, (0, _defineProperty2.default)({}, classes.dotActive, step === activeStep)); // eslint-disable-next-line react/no-array-index-key

    return _react.default.createElement("div", {
      key: step,
      className: dotClassName
    });
  })), variant === 'progress' && _react.default.createElement(_LinearProgress.default, {
    className: classes.progress,
    variant: "determinate",
    value: Math.ceil(activeStep / (steps - 1) * 100)
  }), nextButton);
}

MobileStepper.propTypes =  false ? {
  /**
   * Set the active step (zero based index).
   * Defines which dot is highlighted when the variant is 'dots'.
   */
  activeStep: _propTypes.default.number,

  /**
   * A back button element. For instance, it can be be a `Button` or a `IconButton`.
   */
  backButton: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * A next button element. For instance, it can be be a `Button` or a `IconButton`.
   */
  nextButton: _propTypes.default.node,

  /**
   * Set the positioning type.
   */
  position: _propTypes.default.oneOf(['bottom', 'top', 'static']),

  /**
   * The total steps.
   */
  steps: _propTypes.default.number.isRequired,

  /**
   * The type of mobile stepper to use.
   */
  variant: _propTypes.default.oneOf(['text', 'dots', 'progress'])
} : {};
MobileStepper.defaultProps = {
  activeStep: 0,
  position: 'bottom',
  variant: 'dots'
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiMobileStepper'
})(MobileStepper);

exports.default = _default;

/***/ }),
/* 1025 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _NativeSelect.default;
  }
});

var _NativeSelect = _interopRequireDefault(__webpack_require__(505));

/***/ }),
/* 1026 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Radio.default;
  }
});

var _Radio = _interopRequireDefault(__webpack_require__(1027));

/***/ }),
/* 1027 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(8));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _classnames = _interopRequireDefault(__webpack_require__(6));

var _SwitchBase = _interopRequireDefault(__webpack_require__(308));

var _RadioButtonUnchecked = _interopRequireDefault(__webpack_require__(1028));

var _RadioButtonChecked = _interopRequireDefault(__webpack_require__(1029));

var _helpers = __webpack_require__(36);

var _withStyles = _interopRequireDefault(__webpack_require__(5));

var styles = function styles(theme) {
  return {
    root: {
      color: theme.palette.text.secondary
    },
    checked: {},
    disabled: {},
    colorPrimary: {
      '&$checked': {
        color: theme.palette.primary.main
      },
      '&$disabled': {
        color: theme.palette.action.disabled
      }
    },
    colorSecondary: {
      '&$checked': {
        color: theme.palette.secondary.main
      },
      '&$disabled': {
        color: theme.palette.action.disabled
      }
    }
  };
};

exports.styles = styles;

var _ref = _react.default.createElement(_RadioButtonUnchecked.default, null);

var _ref2 = _react.default.createElement(_RadioButtonChecked.default, null);

function Radio(props) {
  var classes = props.classes,
      color = props.color,
      other = (0, _objectWithoutProperties2.default)(props, ["classes", "color"]);
  return _react.default.createElement(_SwitchBase.default, (0, _extends2.default)({
    type: "radio",
    icon: _ref,
    checkedIcon: _ref2,
    classes: {
      root: (0, _classnames.default)(classes.root, classes["color".concat((0, _helpers.capitalize)(color))]),
      checked: classes.checked,
      disabled: classes.disabled
    }
  }, other));
}

Radio.propTypes =  false ? {
  /**
   * If `true`, the component is checked.
   */
  checked: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.string]),

  /**
   * The icon to display when the component is checked.
   */
  checkedIcon: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: _propTypes.default.oneOf(['primary', 'secondary', 'default']),

  /**
   * If `true`, the switch will be disabled.
   */
  disabled: _propTypes.default.bool,

  /**
   * If `true`, the ripple effect will be disabled.
   */
  disableRipple: _propTypes.default.bool,

  /**
   * The icon to display when the component is unchecked.
   */
  icon: _propTypes.default.node,

  /**
   * The id of the `input` element.
   */
  id: _propTypes.default.string,

  /**
   * Properties applied to the `input` element.
   */
  inputProps: _propTypes.default.object,

  /**
   * Use that property to pass a ref callback to the native input component.
   */
  inputRef: _propTypes.default.func,

  /**
   * Callback fired when the state is changed.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value`.
   * @param {boolean} checked The `checked` value of the switch
   */
  onChange: _propTypes.default.func,

  /**
   * The input component property `type`.
   */
  type: _propTypes.default.string,

  /**
   * The value of the component.
   */
  value: _propTypes.default.string
} : {};
Radio.defaultProps = {
  color: 'secondary'
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiRadio'
})(Radio);

exports.default = _default;

/***/ }),
/* 1028 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _pure = _interopRequireDefault(__webpack_require__(52));

var _SvgIcon = _interopRequireDefault(__webpack_require__(47));

var _ref = _react.default.createElement("path", {
  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
});

/**
 * @ignore - internal component.
 */
var RadioButtonUnchecked = function RadioButtonUnchecked(props) {
  return _react.default.createElement(_SvgIcon.default, props, _ref);
};

RadioButtonUnchecked = (0, _pure.default)(RadioButtonUnchecked);
RadioButtonUnchecked.muiName = 'SvgIcon';
var _default = RadioButtonUnchecked;
exports.default = _default;

/***/ }),
/* 1029 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _pure = _interopRequireDefault(__webpack_require__(52));

var _SvgIcon = _interopRequireDefault(__webpack_require__(47));

var _ref = _react.default.createElement("path", {
  d: "M12 7c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5zm0-5C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
});

/**
 * @ignore - internal component.
 */
var RadioButtonChecked = function RadioButtonChecked(props) {
  return _react.default.createElement(_SvgIcon.default, props, _ref);
};

RadioButtonChecked = (0, _pure.default)(RadioButtonChecked);
RadioButtonChecked.muiName = 'SvgIcon';
var _default = RadioButtonChecked;
exports.default = _default;

/***/ }),
/* 1030 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _RadioGroup.default;
  }
});

var _RadioGroup = _interopRequireDefault(__webpack_require__(1031));

/***/ }),
/* 1031 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(8));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(18));

var _createClass2 = _interopRequireDefault(__webpack_require__(19));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(20));

var _inherits2 = _interopRequireDefault(__webpack_require__(21));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _FormGroup = _interopRequireDefault(__webpack_require__(494));

var _helpers = __webpack_require__(36);

// @inheritedComponent FormGroup
var RadioGroup =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(RadioGroup, _React$Component);

  function RadioGroup() {
    var _ref;

    var _temp, _this;

    (0, _classCallCheck2.default)(this, RadioGroup);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return (0, _possibleConstructorReturn2.default)(_this, (_temp = _this = (0, _possibleConstructorReturn2.default)(this, (_ref = RadioGroup.__proto__ || Object.getPrototypeOf(RadioGroup)).call.apply(_ref, [this].concat(args))), _this.radios = [], _this.focus = function () {
      if (!_this.radios || !_this.radios.length) {
        return;
      }

      var focusRadios = _this.radios.filter(function (n) {
        return !n.disabled;
      });

      if (!focusRadios.length) {
        return;
      }

      var selectedRadio = (0, _helpers.find)(focusRadios, function (n) {
        return n.checked;
      });

      if (selectedRadio) {
        selectedRadio.focus();
        return;
      }

      focusRadios[0].focus();
    }, _this.handleRadioChange = function (event, checked) {
      if (checked && _this.props.onChange) {
        _this.props.onChange(event, event.target.value);
      }
    }, _temp));
  }

  (0, _createClass2.default)(RadioGroup, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          children = _props.children,
          name = _props.name,
          value = _props.value,
          onChange = _props.onChange,
          other = (0, _objectWithoutProperties2.default)(_props, ["children", "name", "value", "onChange"]);
      this.radios = [];
      return _react.default.createElement(_FormGroup.default, (0, _extends2.default)({
        role: "radiogroup"
      }, other), _react.default.Children.map(children, function (child, index) {
        if (!_react.default.isValidElement(child)) {
          return null;
        }

        return _react.default.cloneElement(child, {
          key: index,
          name: name,
          inputRef: function inputRef(node) {
            if (node) {
              _this2.radios.push(node);
            }
          },
          checked: value === child.props.value,
          onChange: _this2.handleRadioChange
        });
      }));
    }
  }]);
  return RadioGroup;
}(_react.default.Component);

RadioGroup.propTypes =  false ? {
  /**
   * The content of the component.
   */
  children: _propTypes.default.node,

  /**
   * The name used to reference the value of the control.
   */
  name: _propTypes.default.string,

  /**
   * @ignore
   */
  onBlur: _propTypes.default.func,

  /**
   * Callback fired when a radio button is selected.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value`.
   * @param {string} value The `value` of the selected radio button
   */
  onChange: _propTypes.default.func,

  /**
   * @ignore
   */
  onKeyDown: _propTypes.default.func,

  /**
   * Value of the selected radio button.
   */
  value: _propTypes.default.string
} : {};
var _default = RadioGroup;
exports.default = _default;

/***/ }),
/* 1032 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _objectSpread2 = _interopRequireDefault(__webpack_require__(23));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _SelectInput = _interopRequireDefault(__webpack_require__(1033));

var _withStyles = _interopRequireDefault(__webpack_require__(5));

var _ArrowDropDown = _interopRequireDefault(__webpack_require__(507));

var _Input = _interopRequireDefault(__webpack_require__(171));

var _NativeSelect = __webpack_require__(505);

var _NativeSelectInput = _interopRequireDefault(__webpack_require__(506));

// @inheritedComponent Input
var styles = _NativeSelect.styles;
exports.styles = styles;

function Select(props) {
  var autoWidth = props.autoWidth,
      children = props.children,
      classes = props.classes,
      displayEmpty = props.displayEmpty,
      IconComponent = props.IconComponent,
      input = props.input,
      inputProps = props.inputProps,
      MenuProps = props.MenuProps,
      multiple = props.multiple,
      native = props.native,
      onClose = props.onClose,
      onOpen = props.onOpen,
      open = props.open,
      renderValue = props.renderValue,
      SelectDisplayProps = props.SelectDisplayProps,
      other = (0, _objectWithoutProperties2.default)(props, ["autoWidth", "children", "classes", "displayEmpty", "IconComponent", "input", "inputProps", "MenuProps", "multiple", "native", "onClose", "onOpen", "open", "renderValue", "SelectDisplayProps"]);
  var inputComponent = native ? _NativeSelectInput.default : _SelectInput.default;
  var inputNativeProps = {
    children: children,
    classes: classes,
    IconComponent: IconComponent,
    type: undefined // We render a select. We can ignore the type provided by the `Input`.

  };
  return _react.default.cloneElement(input, (0, _objectSpread2.default)({
    // Most of the logic is implemented in `SelectInput`.
    // The `Select` component is a simple API wrapper to expose something better to play with.
    inputComponent: inputComponent,
    inputProps: (0, _objectSpread2.default)({}, inputNativeProps, native ? {} : {
      autoWidth: autoWidth,
      children: children,
      classes: classes,
      displayEmpty: displayEmpty,
      MenuProps: MenuProps,
      multiple: multiple,
      onClose: onClose,
      onOpen: onOpen,
      open: open,
      renderValue: renderValue,
      SelectDisplayProps: SelectDisplayProps
    }, inputProps, input ? input.props.inputProps : {})
  }, other));
}

Select.propTypes =  false ? {
  /**
   * If true, the width of the popover will automatically be set according to the items inside the
   * menu, otherwise it will be at least the width of the select input.
   */
  autoWidth: _propTypes.default.bool,

  /**
   * The option elements to populate the select with.
   * Can be some `MenuItem` when `native` is false and `option` when `native` is true.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * If `true`, the selected item is displayed even if its value is empty.
   * You can only use it when the `native` property is `false` (default).
   */
  displayEmpty: _propTypes.default.bool,

  /**
   * The icon that displays the arrow.
   */
  IconComponent: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func]),

  /**
   * An `Input` element; does not have to be a material-ui specific `Input`.
   */
  input: _propTypes.default.element,

  /**
   * Properties applied to the `input` element.
   * When `native` is `true`, the properties are applied on the `select` element.
   */
  inputProps: _propTypes.default.object,

  /**
   * Properties applied to the `Menu` element.
   */
  MenuProps: _propTypes.default.object,

  /**
   * If true, `value` must be an array and the menu will support multiple selections.
   * You can only use it when the `native` property is `false` (default).
   */
  multiple: _propTypes.default.bool,

  /**
   * If `true`, the component will be using a native `select` element.
   */
  native: _propTypes.default.bool,

  /**
   * Callback function fired when a menu item is selected.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value`.
   * @param {object} [child] The react element that was selected when `native` is `false` (default).
   */
  onChange: _propTypes.default.func,

  /**
   * Callback fired when the component requests to be closed.
   * Use in controlled mode (see open).
   *
   * @param {object} event The event source of the callback
   */
  onClose: _propTypes.default.func,

  /**
   * Callback fired when the component requests to be opened.
   * Use in controlled mode (see open).
   *
   * @param {object} event The event source of the callback
   */
  onOpen: _propTypes.default.func,

  /**
   * Control `select` open state.
   * You can only use it when the `native` property is `false` (default).
   */
  open: _propTypes.default.bool,

  /**
   * Render the selected value.
   * You can only use it when the `native` property is `false` (default).
   *
   * @param {*} value The `value` provided to the component.
   * @returns {ReactElement}
   */
  renderValue: _propTypes.default.func,

  /**
   * Properties applied to the clickable div element.
   */
  SelectDisplayProps: _propTypes.default.object,

  /**
   * The input value.
   * This property is required when the `native` property is `false` (default).
   */
  value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number, _propTypes.default.arrayOf(_propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]))])
} : {};
Select.defaultProps = {
  autoWidth: false,
  displayEmpty: false,
  IconComponent: _ArrowDropDown.default,
  input: _react.default.createElement(_Input.default, null),
  multiple: false,
  native: false
};
Select.muiName = 'Select';

var _default = (0, _withStyles.default)(_NativeSelect.styles, {
  name: 'MuiSelect'
})(Select);

exports.default = _default;

/***/ }),
/* 1033 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(8));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(11));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _objectSpread2 = _interopRequireDefault(__webpack_require__(23));

var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(219));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(18));

var _createClass2 = _interopRequireDefault(__webpack_require__(19));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(20));

var _inherits2 = _interopRequireDefault(__webpack_require__(21));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _classnames = _interopRequireDefault(__webpack_require__(6));

var _keycode = _interopRequireDefault(__webpack_require__(133));

var _Menu = _interopRequireDefault(__webpack_require__(501));

var _Input = __webpack_require__(326);

/**
 * @ignore - internal component.
 */
var SelectInput =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(SelectInput, _React$Component);

  function SelectInput() {
    var _ref;

    var _temp, _this;

    (0, _classCallCheck2.default)(this, SelectInput);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return (0, _possibleConstructorReturn2.default)(_this, (_temp = _this = (0, _possibleConstructorReturn2.default)(this, (_ref = SelectInput.__proto__ || Object.getPrototypeOf(SelectInput)).call.apply(_ref, [this].concat(args))), _this.state = {
      open: false
    }, _this.ignoreNextBlur = false, _this.displayNode = null, _this.displayWidth = null, _this.isOpenControlled = _this.props.open !== undefined, _this.updateDisplayWidth = function () {
      // Perfom the layout computation outside of the render method.
      if (_this.displayNode) {
        _this.displayWidth = _this.displayNode.clientWidth;
      }
    }, _this.update = _this.isOpenControlled ? function (_ref2) {
      var event = _ref2.event,
          open = _ref2.open;

      if (open) {
        _this.props.onOpen(event);
      } else {
        _this.props.onClose(event);
      }
    } : function (_ref3) {
      var open = _ref3.open;
      return _this.setState({
        open: open
      });
    }, _this.handleClick = function (event) {
      // Opening the menu is going to blur the. It will be focused back when closed.
      _this.ignoreNextBlur = true;

      _this.update({
        open: true,
        event: event
      });
    }, _this.handleClose = function (event) {
      _this.update({
        open: false,
        event: event
      });
    }, _this.handleItemClick = function (child) {
      return function (event) {
        if (!_this.props.multiple) {
          _this.update({
            open: false,
            event: event
          });
        }

        var _this$props = _this.props,
            onChange = _this$props.onChange,
            name = _this$props.name;

        if (onChange) {
          var value;
          var target;

          if (event.target) {
            target = event.target;
          }

          if (_this.props.multiple) {
            value = Array.isArray(_this.props.value) ? (0, _toConsumableArray2.default)(_this.props.value) : [];
            var itemIndex = value.indexOf(child.props.value);

            if (itemIndex === -1) {
              value.push(child.props.value);
            } else {
              value.splice(itemIndex, 1);
            }
          } else {
            value = child.props.value;
          }

          event.persist();
          event.target = (0, _objectSpread2.default)({}, target, {
            value: value,
            name: name
          });
          onChange(event, child);
        }
      };
    }, _this.handleBlur = function (event) {
      if (_this.ignoreNextBlur === true) {
        // The parent components are relying on the bubbling of the event.
        event.stopPropagation();
        _this.ignoreNextBlur = false;
        return;
      }

      if (_this.props.onBlur) {
        _this.props.onBlur(event);
      }
    }, _this.handleKeyDown = function (event) {
      if (_this.props.readOnly) {
        return;
      }

      if (['space', 'up', 'down'].indexOf((0, _keycode.default)(event)) !== -1) {
        event.preventDefault(); // Opening the menu is going to blur the. It will be focused back when closed.

        _this.ignoreNextBlur = true;

        _this.update({
          open: true,
          event: event
        });
      }
    }, _this.handleDisplayRef = function (node) {
      _this.displayNode = node;

      _this.updateDisplayWidth();
    }, _this.handleSelectRef = function (node) {
      if (!_this.props.inputRef) {
        return;
      }

      _this.props.inputRef({
        node: node,
        // By pass the native input as we expose a rich object (array).
        value: _this.props.value
      });
    }, _temp));
  }

  (0, _createClass2.default)(SelectInput, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.isOpenControlled && this.props.open) {
        // Focus the display node so the focus is restored on this element once
        // the menu is closed.
        this.displayNode.focus(); // Rerender with the resolve `displayNode` reference.

        this.forceUpdate();
      }

      if (this.props.autoFocus) {
        this.displayNode.focus();
      }
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate() {
      this.updateDisplayWidth();
      return true;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          autoWidth = _props.autoWidth,
          children = _props.children,
          classes = _props.classes,
          className = _props.className,
          disabled = _props.disabled,
          displayEmpty = _props.displayEmpty,
          IconComponent = _props.IconComponent,
          inputRef = _props.inputRef,
          _props$MenuProps = _props.MenuProps,
          MenuProps = _props$MenuProps === void 0 ? {} : _props$MenuProps,
          multiple = _props.multiple,
          name = _props.name,
          onBlur = _props.onBlur,
          onChange = _props.onChange,
          onClose = _props.onClose,
          onFocus = _props.onFocus,
          onOpen = _props.onOpen,
          openProp = _props.open,
          readOnly = _props.readOnly,
          renderValue = _props.renderValue,
          SelectDisplayProps = _props.SelectDisplayProps,
          tabIndexProp = _props.tabIndex,
          _props$type = _props.type,
          type = _props$type === void 0 ? 'hidden' : _props$type,
          value = _props.value,
          other = (0, _objectWithoutProperties2.default)(_props, ["autoWidth", "children", "classes", "className", "disabled", "displayEmpty", "IconComponent", "inputRef", "MenuProps", "multiple", "name", "onBlur", "onChange", "onClose", "onFocus", "onOpen", "open", "readOnly", "renderValue", "SelectDisplayProps", "tabIndex", "type", "value"]);
      var open = this.isOpenControlled && this.displayNode ? openProp : this.state.open;
      var display;
      var displaySingle = '';
      var displayMultiple = [];
      var computeDisplay = false; // No need to display any value if the field is empty.

      if ((0, _Input.isFilled)(this.props) || displayEmpty) {
        if (renderValue) {
          display = renderValue(value);
        } else {
          computeDisplay = true;
        }
      }

      var items = _react.default.Children.map(children, function (child) {
        if (!_react.default.isValidElement(child)) {
          return null;
        }

        var selected;

        if (multiple) {
          if (!Array.isArray(value)) {
            throw new Error('Material-UI: the `value` property must be an array ' + 'when using the `Select` component with `multiple`.');
          }

          selected = value.indexOf(child.props.value) !== -1;

          if (selected && computeDisplay) {
            displayMultiple.push(child.props.children);
          }
        } else {
          selected = value === child.props.value;

          if (selected && computeDisplay) {
            displaySingle = child.props.children;
          }
        }

        return _react.default.cloneElement(child, {
          onClick: _this2.handleItemClick(child),
          role: 'option',
          selected: selected,
          value: undefined,
          // The value is most likely not a valid HTML attribute.
          'data-value': child.props.value // Instead, we provide it as a data attribute.

        });
      });

      if (computeDisplay) {
        display = multiple ? displayMultiple.join(', ') : displaySingle;
      }

      var MenuMinWidth = this.displayNode && !autoWidth ? this.displayWidth : undefined;
      var tabIndex;

      if (typeof tabIndexProp !== 'undefined') {
        tabIndex = tabIndexProp;
      } else {
        tabIndex = disabled ? null : 0;
      }

      return _react.default.createElement("div", {
        className: classes.root
      }, _react.default.createElement("div", (0, _extends2.default)({
        className: (0, _classnames.default)(classes.select, classes.selectMenu, (0, _defineProperty2.default)({}, classes.disabled, disabled), className),
        ref: this.handleDisplayRef,
        "aria-pressed": open ? 'true' : 'false',
        tabIndex: tabIndex,
        role: "button",
        "aria-owns": open ? "menu-".concat(name || '') : null,
        "aria-haspopup": "true",
        onKeyDown: this.handleKeyDown,
        onBlur: this.handleBlur,
        onClick: disabled || readOnly ? null : this.handleClick,
        onFocus: onFocus
      }, SelectDisplayProps), display || _react.default.createElement("span", {
        dangerouslySetInnerHTML: {
          __html: '&#8203'
        }
      })), _react.default.createElement("input", (0, _extends2.default)({
        value: Array.isArray(value) ? value.join(',') : value,
        name: name,
        readOnly: readOnly,
        ref: this.handleSelectRef,
        type: type
      }, other)), _react.default.createElement(IconComponent, {
        className: classes.icon
      }), _react.default.createElement(_Menu.default, (0, _extends2.default)({
        id: "menu-".concat(name || ''),
        anchorEl: this.displayNode,
        open: open,
        onClose: this.handleClose
      }, MenuProps, {
        MenuListProps: (0, _objectSpread2.default)({
          role: 'listbox'
        }, MenuProps.MenuListProps),
        PaperProps: (0, _objectSpread2.default)({}, MenuProps.PaperProps, {
          style: (0, _objectSpread2.default)({
            minWidth: MenuMinWidth
          }, MenuProps.PaperProps != null ? MenuProps.PaperProps.style : null)
        })
      }), items));
    }
  }]);
  return SelectInput;
}(_react.default.Component);

SelectInput.propTypes =  false ? {
  /**
   * @ignore
   */
  autoFocus: _propTypes.default.bool,

  /**
   * If true, the width of the popover will automatically be set according to the items inside the
   * menu, otherwise it will be at least the width of the select input.
   */
  autoWidth: _propTypes.default.bool,

  /**
   * The option elements to populate the select with.
   * Can be some `<MenuItem>` elements.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * The CSS class name of the select element.
   */
  className: _propTypes.default.string,

  /**
   * If `true`, the select will be disabled.
   */
  disabled: _propTypes.default.bool,

  /**
   * If `true`, the selected item is displayed even if its value is empty.
   */
  displayEmpty: _propTypes.default.bool,

  /**
   * The icon that displays the arrow.
   */
  IconComponent: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func]),

  /**
   * Use that property to pass a ref callback to the native select element.
   */
  inputRef: _propTypes.default.func,

  /**
   * Properties applied to the `Menu` element.
   */
  MenuProps: _propTypes.default.object,

  /**
   * If true, `value` must be an array and the menu will support multiple selections.
   */
  multiple: _propTypes.default.bool,

  /**
   * Name attribute of the `select` or hidden `input` element.
   */
  name: _propTypes.default.string,

  /**
   * @ignore
   */
  onBlur: _propTypes.default.func,

  /**
   * Callback function fired when a menu item is selected.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value`.
   * @param {object} [child] The react element that was selected.
   */
  onChange: _propTypes.default.func,

  /**
   * Callback fired when the component requests to be closed.
   * Use in controlled mode (see open).
   *
   * @param {object} event The event source of the callback
   */
  onClose: _propTypes.default.func,

  /**
   * @ignore
   */
  onFocus: _propTypes.default.func,

  /**
   * Callback fired when the component requests to be opened.
   * Use in controlled mode (see open).
   *
   * @param {object} event The event source of the callback
   */
  onOpen: _propTypes.default.func,

  /**
   * Control `select` open state.
   */
  open: _propTypes.default.bool,

  /**
   * @ignore
   */
  readOnly: _propTypes.default.bool,

  /**
   * Render the selected value.
   *
   * @param {*} value The `value` provided to the component.
   * @returns {ReactElement}
   */
  renderValue: _propTypes.default.func,

  /**
   * Properties applied to the clickable div element.
   */
  SelectDisplayProps: _propTypes.default.object,

  /**
   * @ignore
   */
  tabIndex: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),

  /**
   * @ignore
   */
  type: _propTypes.default.string,

  /**
   * The input value.
   */
  value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number, _propTypes.default.arrayOf(_propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]))]).isRequired
} : {};
var _default = SelectInput;
exports.default = _default;

/***/ }),
/* 1034 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(8));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(18));

var _createClass2 = _interopRequireDefault(__webpack_require__(19));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(20));

var _inherits2 = _interopRequireDefault(__webpack_require__(21));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(11));

var _objectSpread8 = _interopRequireDefault(__webpack_require__(23));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _classnames = _interopRequireDefault(__webpack_require__(6));

var _reactEventListener = _interopRequireDefault(__webpack_require__(73));

var _withStyles = _interopRequireDefault(__webpack_require__(5));

var _transitions = __webpack_require__(78);

var _ClickAwayListener = _interopRequireDefault(__webpack_require__(485));

var _helpers = __webpack_require__(36);

var _Slide = _interopRequireDefault(__webpack_require__(325));

var _SnackbarContent = _interopRequireDefault(__webpack_require__(509));

var styles = function styles(theme) {
  var gutter = theme.spacing.unit * 3;
  var top = {
    top: 0
  };
  var bottom = {
    bottom: 0
  };
  var right = {
    justifyContent: 'flex-end'
  };
  var left = {
    justifyContent: 'flex-start'
  };
  var topSpace = {
    top: gutter
  };
  var bottomSpace = {
    bottom: gutter
  };
  var rightSpace = {
    right: gutter
  };
  var leftSpace = {
    left: gutter
  };
  var center = {
    left: '50%',
    right: 'auto',
    transform: 'translateX(-50%)'
  };
  return {
    root: {
      zIndex: theme.zIndex.snackbar,
      position: 'fixed',
      display: 'flex',
      left: 0,
      right: 0,
      justifyContent: 'center',
      alignItems: 'center'
    },
    anchorOriginTopCenter: (0, _objectSpread8.default)({}, top, (0, _defineProperty2.default)({}, theme.breakpoints.up('md'), (0, _objectSpread8.default)({}, center))),
    anchorOriginBottomCenter: (0, _objectSpread8.default)({}, bottom, (0, _defineProperty2.default)({}, theme.breakpoints.up('md'), (0, _objectSpread8.default)({}, center))),
    anchorOriginTopRight: (0, _objectSpread8.default)({}, top, right, (0, _defineProperty2.default)({}, theme.breakpoints.up('md'), (0, _objectSpread8.default)({
      left: 'auto'
    }, topSpace, rightSpace))),
    anchorOriginBottomRight: (0, _objectSpread8.default)({}, bottom, right, (0, _defineProperty2.default)({}, theme.breakpoints.up('md'), (0, _objectSpread8.default)({
      left: 'auto'
    }, bottomSpace, rightSpace))),
    anchorOriginTopLeft: (0, _objectSpread8.default)({}, top, left, (0, _defineProperty2.default)({}, theme.breakpoints.up('md'), (0, _objectSpread8.default)({
      right: 'auto'
    }, topSpace, leftSpace))),
    anchorOriginBottomLeft: (0, _objectSpread8.default)({}, bottom, left, (0, _defineProperty2.default)({}, theme.breakpoints.up('md'), (0, _objectSpread8.default)({
      right: 'auto'
    }, bottomSpace, leftSpace)))
  };
};

exports.styles = styles;

var Snackbar =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(Snackbar, _React$Component);

  function Snackbar() {
    var _ref;

    var _temp, _this;

    (0, _classCallCheck2.default)(this, Snackbar);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return (0, _possibleConstructorReturn2.default)(_this, (_temp = _this = (0, _possibleConstructorReturn2.default)(this, (_ref = Snackbar.__proto__ || Object.getPrototypeOf(Snackbar)).call.apply(_ref, [this].concat(args))), _this.state = {}, _this.timerAutoHide = null, _this.handleMouseEnter = function (event) {
      if (_this.props.onMouseEnter) {
        _this.props.onMouseEnter(event);
      }

      _this.handlePause();
    }, _this.handleMouseLeave = function (event) {
      if (_this.props.onMouseLeave) {
        _this.props.onMouseLeave(event);
      }

      _this.handleResume();
    }, _this.handleClickAway = function (event) {
      if (_this.props.onClose) {
        _this.props.onClose(event, 'clickaway');
      }
    }, _this.handlePause = function () {
      clearTimeout(_this.timerAutoHide);
    }, _this.handleResume = function () {
      if (_this.props.autoHideDuration != null) {
        if (_this.props.resumeHideDuration !== undefined) {
          _this.setAutoHideTimer(_this.props.resumeHideDuration);

          return;
        }

        _this.setAutoHideTimer((_this.props.autoHideDuration || 0) * 0.5);
      }
    }, _this.handleExited = function () {
      _this.setState({
        exited: true
      });
    }, _temp));
  }

  (0, _createClass2.default)(Snackbar, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.open) {
        this.setAutoHideTimer();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.open !== this.props.open) {
        if (this.props.open) {
          this.setAutoHideTimer();
        } else {
          clearTimeout(this.timerAutoHide);
        }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearTimeout(this.timerAutoHide);
    } // Timer that controls delay before snackbar auto hides

  }, {
    key: "setAutoHideTimer",
    value: function setAutoHideTimer() {
      var _this2 = this;

      var autoHideDuration = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      if (!this.props.onClose || this.props.autoHideDuration == null) {
        return;
      }

      clearTimeout(this.timerAutoHide);
      this.timerAutoHide = setTimeout(function () {
        if (!_this2.props.onClose || _this2.props.autoHideDuration == null) {
          return;
        }

        _this2.props.onClose(null, 'timeout');
      }, autoHideDuration || this.props.autoHideDuration || 0);
    }
  }, {
    key: "render",
    value: function render() {
      var _props = this.props,
          action = _props.action,
          _props$anchorOrigin = _props.anchorOrigin,
          vertical = _props$anchorOrigin.vertical,
          horizontal = _props$anchorOrigin.horizontal,
          autoHideDuration = _props.autoHideDuration,
          children = _props.children,
          classes = _props.classes,
          className = _props.className,
          ContentProps = _props.ContentProps,
          disableWindowBlurListener = _props.disableWindowBlurListener,
          message = _props.message,
          onClose = _props.onClose,
          onEnter = _props.onEnter,
          onEntered = _props.onEntered,
          onEntering = _props.onEntering,
          onExit = _props.onExit,
          onExited = _props.onExited,
          onExiting = _props.onExiting,
          onMouseEnter = _props.onMouseEnter,
          onMouseLeave = _props.onMouseLeave,
          open = _props.open,
          resumeHideDuration = _props.resumeHideDuration,
          TransitionComponent = _props.TransitionComponent,
          transitionDuration = _props.transitionDuration,
          TransitionProps = _props.TransitionProps,
          other = (0, _objectWithoutProperties2.default)(_props, ["action", "anchorOrigin", "autoHideDuration", "children", "classes", "className", "ContentProps", "disableWindowBlurListener", "message", "onClose", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "onMouseEnter", "onMouseLeave", "open", "resumeHideDuration", "TransitionComponent", "transitionDuration", "TransitionProps"]); // So we only render active snackbars.

      if (!open && this.state.exited) {
        return null;
      }

      return _react.default.createElement(_ClickAwayListener.default, {
        onClickAway: this.handleClickAway
      }, _react.default.createElement("div", (0, _extends2.default)({
        className: (0, _classnames.default)(classes.root, classes["anchorOrigin".concat((0, _helpers.capitalize)(vertical)).concat((0, _helpers.capitalize)(horizontal))], className),
        onMouseEnter: this.handleMouseEnter,
        onMouseLeave: this.handleMouseLeave
      }, other), _react.default.createElement(_reactEventListener.default, {
        target: "window",
        onFocus: disableWindowBlurListener ? undefined : this.handleResume,
        onBlur: disableWindowBlurListener ? undefined : this.handlePause
      }), _react.default.createElement(TransitionComponent, (0, _extends2.default)({
        appear: true,
        "in": open,
        onEnter: onEnter,
        onEntered: onEntered,
        onEntering: onEntering,
        onExit: onExit,
        onExited: (0, _helpers.createChainedFunction)(this.handleExited, onExited),
        onExiting: onExiting,
        timeout: transitionDuration,
        direction: vertical === 'top' ? 'down' : 'up'
      }, TransitionProps), children || _react.default.createElement(_SnackbarContent.default, (0, _extends2.default)({
        message: message,
        action: action
      }, ContentProps)))));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      if (typeof prevState.exited === 'undefined') {
        return {
          exited: !nextProps.open
        };
      }

      if (nextProps.open) {
        return {
          exited: false
        };
      }

      return null;
    }
  }]);
  return Snackbar;
}(_react.default.Component);

Snackbar.propTypes =  false ? {
  /**
   * The action to display.
   */
  action: _propTypes.default.node,

  /**
   * The anchor of the `Snackbar`.
   */
  anchorOrigin: _propTypes.default.shape({
    horizontal: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.oneOf(['left', 'center', 'right'])]),
    vertical: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.oneOf(['top', 'center', 'bottom'])])
  }),

  /**
   * The number of milliseconds to wait before automatically calling the
   * `onClose` function. `onClose` should then set the state of the `open`
   * prop to hide the Snackbar. This behavior is disabled by default with
   * the `null` value.
   */
  autoHideDuration: _propTypes.default.number,

  /**
   * If you wish the take control over the children of the component you can use this property.
   * When used, you replace the `SnackbarContent` component with the children.
   */
  children: _propTypes.default.element,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * Properties applied to the `SnackbarContent` element.
   */
  ContentProps: _propTypes.default.object,

  /**
   * If `true`, the `autoHideDuration` timer will expire even if the window is not focused.
   */
  disableWindowBlurListener: _propTypes.default.bool,

  /**
   * When displaying multiple consecutive Snackbars from a parent rendering a single
   * <Snackbar/>, add the key property to ensure independent treatment of each message.
   * e.g. <Snackbar key={message} />, otherwise, the message may update-in-place and
   * features such as autoHideDuration may be canceled.
   */
  key: _propTypes.default.any,

  /**
   * The message to display.
   */
  message: _propTypes.default.node,

  /**
   * Callback fired when the component requests to be closed.
   * Typically `onClose` is used to set state in the parent component,
   * which is used to control the `Snackbar` `open` prop.
   * The `reason` parameter can optionally be used to control the response to `onClose`,
   * for example ignoring `clickaway`.
   *
   * @param {object} event The event source of the callback
   * @param {string} reason Can be:`"timeout"` (`autoHideDuration` expired) or: `"clickaway"`
   */
  onClose: _propTypes.default.func,

  /**
   * Callback fired before the transition is entering.
   */
  onEnter: _propTypes.default.func,

  /**
   * Callback fired when the transition has entered.
   */
  onEntered: _propTypes.default.func,

  /**
   * Callback fired when the transition is entering.
   */
  onEntering: _propTypes.default.func,

  /**
   * Callback fired before the transition is exiting.
   */
  onExit: _propTypes.default.func,

  /**
   * Callback fired when the transition has exited.
   */
  onExited: _propTypes.default.func,

  /**
   * Callback fired when the transition is exiting.
   */
  onExiting: _propTypes.default.func,

  /**
   * @ignore
   */
  onMouseEnter: _propTypes.default.func,

  /**
   * @ignore
   */
  onMouseLeave: _propTypes.default.func,

  /**
   * If true, `Snackbar` is open.
   */
  open: _propTypes.default.bool,

  /**
   * The number of milliseconds to wait before dismissing after user interaction.
   * If `autoHideDuration` property isn't specified, it does nothing.
   * If `autoHideDuration` property is specified but `resumeHideDuration` isn't,
   * we default to `autoHideDuration / 2` ms.
   */
  resumeHideDuration: _propTypes.default.number,

  /**
   * Transition component.
   */
  TransitionComponent: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func]),

  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   */
  transitionDuration: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
    enter: _propTypes.default.number,
    exit: _propTypes.default.number
  })]),

  /**
   * Properties applied to the `Transition` element.
   */
  TransitionProps: _propTypes.default.object
} : {};
Snackbar.defaultProps = {
  anchorOrigin: {
    vertical: 'bottom',
    horizontal: 'center'
  },
  disableWindowBlurListener: false,
  TransitionComponent: _Slide.default,
  transitionDuration: {
    enter: _transitions.duration.enteringScreen,
    exit: _transitions.duration.leavingScreen
  }
};

var _default = (0, _withStyles.default)(styles, {
  flip: false,
  name: 'MuiSnackbar'
})(Snackbar);

exports.default = _default;

/***/ }),
/* 1035 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(8));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(11));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _classnames = _interopRequireDefault(__webpack_require__(6));

var _withStyles = _interopRequireDefault(__webpack_require__(5));

var _Paper = _interopRequireDefault(__webpack_require__(69));

var _Typography = _interopRequireDefault(__webpack_require__(46));

var _colorManipulator = __webpack_require__(90);

// @inheritedComponent Paper
var styles = function styles(theme) {
  var _root;

  var emphasis = theme.palette.type === 'light' ? 0.8 : 0.98;
  var backgroundColor = (0, _colorManipulator.emphasize)(theme.palette.background.default, emphasis);
  return {
    root: (_root = {
      pointerEvents: 'initial',
      color: theme.palette.getContrastText(backgroundColor),
      backgroundColor: backgroundColor,
      display: 'flex',
      alignItems: 'center',
      flexWrap: 'wrap',
      padding: "6px ".concat(theme.spacing.unit * 3, "px")
    }, (0, _defineProperty2.default)(_root, theme.breakpoints.up('md'), {
      minWidth: 288,
      maxWidth: 568,
      borderRadius: 2
    }), (0, _defineProperty2.default)(_root, theme.breakpoints.down('sm'), {
      flexGrow: 1
    }), _root),
    message: {
      padding: "".concat(theme.spacing.unit, "px 0")
    },
    action: {
      display: 'flex',
      alignItems: 'center',
      marginLeft: 'auto',
      paddingLeft: theme.spacing.unit * 3,
      marginRight: -theme.spacing.unit
    }
  };
};

exports.styles = styles;

function SnackbarContent(props) {
  var action = props.action,
      classes = props.classes,
      className = props.className,
      message = props.message,
      other = (0, _objectWithoutProperties2.default)(props, ["action", "classes", "className", "message"]);
  return _react.default.createElement(_Paper.default, (0, _extends2.default)({
    component: _Typography.default,
    headlineMapping: {
      body1: 'div'
    },
    role: "alertdialog",
    square: true,
    elevation: 6,
    className: (0, _classnames.default)(classes.root, className)
  }, other), _react.default.createElement("div", {
    className: classes.message
  }, message), action ? _react.default.createElement("div", {
    className: classes.action
  }, action) : null);
}

SnackbarContent.propTypes =  false ? {
  /**
   * The action to display.
   */
  action: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The message to display.
   */
  message: _propTypes.default.node
} : {};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiSnackbarContent'
})(SnackbarContent);

exports.default = _default;

/***/ }),
/* 1036 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Step.default;
  }
});

var _Step = _interopRequireDefault(__webpack_require__(1037));

/***/ }),
/* 1037 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(8));

var _objectSpread2 = _interopRequireDefault(__webpack_require__(23));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(11));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _classnames = _interopRequireDefault(__webpack_require__(6));

var _withStyles = _interopRequireDefault(__webpack_require__(5));

var styles = function styles(theme) {
  return {
    root: {},
    horizontal: {
      paddingLeft: theme.spacing.unit,
      paddingRight: theme.spacing.unit,
      '&:first-child': {
        paddingLeft: 0
      },
      '&:last-child': {
        paddingRight: 0
      }
    },
    vertical: {},
    alternativeLabel: {
      flex: 1,
      position: 'relative'
    }
  };
};

exports.styles = styles;

function Step(props) {
  var active = props.active,
      alternativeLabel = props.alternativeLabel,
      children = props.children,
      classes = props.classes,
      classNameProp = props.className,
      completed = props.completed,
      connector = props.connector,
      disabled = props.disabled,
      index = props.index,
      last = props.last,
      orientation = props.orientation,
      other = (0, _objectWithoutProperties2.default)(props, ["active", "alternativeLabel", "children", "classes", "className", "completed", "connector", "disabled", "index", "last", "orientation"]);
  var className = (0, _classnames.default)(classes.root, classes[orientation], (0, _defineProperty2.default)({}, classes.alternativeLabel, alternativeLabel), classNameProp);
  return _react.default.createElement("div", (0, _extends2.default)({
    className: className
  }, other), _react.default.Children.map(children, function (child) {
    return _react.default.cloneElement(child, (0, _objectSpread2.default)({
      active: active,
      alternativeLabel: alternativeLabel,
      completed: completed,
      disabled: disabled,
      icon: index + 1,
      last: last,
      orientation: orientation
    }, child.props));
  }), connector && alternativeLabel && !last && _react.default.cloneElement(connector, {
    orientation: orientation,
    alternativeLabel: alternativeLabel
  }));
}

Step.propTypes =  false ? {
  /**
   * Sets the step as active. Is passed to child components.
   */
  active: _propTypes.default.bool,

  /**
   * @ignore
   * Set internally by Stepper when it's supplied with the alternativeLabel property.
   */
  alternativeLabel: _propTypes.default.bool,

  /**
   * Should be `Step` sub-components such as `StepLabel`, `StepContent`.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * Mark the step as completed. Is passed to child components.
   */
  completed: _propTypes.default.bool,

  /**
   * @ignore
   * Passed down from Stepper if alternativeLabel is also set.
   */
  connector: _propTypes.default.element,

  /**
   * Mark the step as disabled, will also disable the button if
   * `StepButton` is a child of `Step`. Is passed to child components.
   */
  disabled: _propTypes.default.bool,

  /**
   * @ignore
   * Used internally for numbering.
   */
  index: _propTypes.default.number,

  /**
   * @ignore
   */
  last: _propTypes.default.bool,

  /**
   * @ignore
   */
  orientation: _propTypes.default.oneOf(['horizontal', 'vertical'])
} : {};
Step.defaultProps = {
  active: false,
  completed: false,
  disabled: false
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiStep'
})(Step);

exports.default = _default;

/***/ }),
/* 1038 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _StepButton.default;
  }
});

var _StepButton = _interopRequireDefault(__webpack_require__(1039));

/***/ }),
/* 1039 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(8));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(11));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _classnames = _interopRequireDefault(__webpack_require__(6));

var _withStyles = _interopRequireDefault(__webpack_require__(5));

var _ButtonBase = _interopRequireDefault(__webpack_require__(70));

var _StepLabel = _interopRequireDefault(__webpack_require__(510));

var _reactHelpers = __webpack_require__(105);

// @inheritedComponent ButtonBase
var styles = function styles(theme) {
  return {
    root: {
      width: '100%',
      padding: "".concat(theme.spacing.unit * 3, "px ").concat(theme.spacing.unit * 2, "px"),
      margin: "".concat(-theme.spacing.unit * 3, "px ").concat(-theme.spacing.unit * 2, "px"),
      boxSizing: 'content-box'
    },
    vertical: {
      justifyContent: 'left'
    },
    touchRipple: {
      color: 'rgba(0, 0, 0, 0.3)'
    }
  };
};

exports.styles = styles;

function StepButton(props) {
  var active = props.active,
      alternativeLabel = props.alternativeLabel,
      children = props.children,
      classes = props.classes,
      classNameProp = props.className,
      completed = props.completed,
      disabled = props.disabled,
      icon = props.icon,
      last = props.last,
      optional = props.optional,
      orientation = props.orientation,
      other = (0, _objectWithoutProperties2.default)(props, ["active", "alternativeLabel", "children", "classes", "className", "completed", "disabled", "icon", "last", "optional", "orientation"]);
  var childProps = {
    active: active,
    alternativeLabel: alternativeLabel,
    completed: completed,
    disabled: disabled,
    icon: icon,
    optional: optional,
    orientation: orientation
  };
  var child = (0, _reactHelpers.isMuiElement)(children, ['StepLabel']) ? _react.default.cloneElement(children, childProps) : _react.default.createElement(_StepLabel.default, childProps, children);
  return _react.default.createElement(_ButtonBase.default, (0, _extends2.default)({
    disabled: disabled,
    TouchRippleProps: {
      className: classes.touchRipple
    },
    className: (0, _classnames.default)(classes.root, (0, _defineProperty2.default)({}, classes.vertical, orientation === 'vertical'), classNameProp)
  }, other), child);
}

StepButton.propTypes =  false ? {
  /**
   * @ignore
   * Passed in via `Step` - passed through to `StepLabel`.
   */
  active: _propTypes.default.bool,

  /**
   * @ignore
   * Set internally by Stepper when it's supplied with the alternativeLabel property.
   */
  alternativeLabel: _propTypes.default.bool,

  /**
   * Can be a `StepLabel` or a node to place inside `StepLabel` as children.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * @ignore
   * Sets completed styling. Is passed to StepLabel.
   */
  completed: _propTypes.default.bool,

  /**
   * @ignore
   * Disables the button and sets disabled styling. Is passed to StepLabel.
   */
  disabled: _propTypes.default.bool,

  /**
   * The icon displayed by the step label.
   */
  icon: _propTypes.default.node,

  /**
   * @ignore
   */
  last: _propTypes.default.bool,

  /**
   * The optional node to display.
   */
  optional: _propTypes.default.node,

  /**
   * @ignore
   */
  orientation: _propTypes.default.oneOf(['horizontal', 'vertical'])
} : {};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiStepButton'
})(StepButton);

exports.default = _default;

/***/ }),
/* 1040 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(8));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(11));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _classnames = _interopRequireDefault(__webpack_require__(6));

var _withStyles = _interopRequireDefault(__webpack_require__(5));

var _Typography = _interopRequireDefault(__webpack_require__(46));

var _StepIcon = _interopRequireDefault(__webpack_require__(511));

var styles = function styles(theme) {
  return {
    root: {
      display: 'flex',
      alignItems: 'center',
      '&$alternativeLabel': {
        flexDirection: 'column'
      },
      '&$disabled': {
        cursor: 'default'
      }
    },
    horizontal: {},
    vertical: {},
    active: {},
    completed: {},
    alternativeLabel: {},
    error: {},
    disabled: {},
    label: {
      color: theme.palette.text.secondary,
      '&$active': {
        color: theme.palette.text.primary,
        fontWeight: 500
      },
      '&$completed': {
        color: theme.palette.text.primary,
        fontWeight: 500
      },
      '&$alternativeLabel': {
        textAlign: 'center',
        marginTop: theme.spacing.unit * 2
      },
      '&$error': {
        color: theme.palette.error.main
      }
    },
    iconContainer: {
      paddingRight: theme.spacing.unit,
      '&$alternativeLabel': {
        paddingRight: 0
      }
    },
    labelContainer: {
      width: '100%'
    }
  };
};

exports.styles = styles;

function StepLabel(props) {
  var _classNames, _classNames3;

  var active = props.active,
      alternativeLabel = props.alternativeLabel,
      children = props.children,
      classes = props.classes,
      classNameProp = props.className,
      completed = props.completed,
      disabled = props.disabled,
      error = props.error,
      icon = props.icon,
      last = props.last,
      optional = props.optional,
      orientation = props.orientation,
      StepIconProps = props.StepIconProps,
      other = (0, _objectWithoutProperties2.default)(props, ["active", "alternativeLabel", "children", "classes", "className", "completed", "disabled", "error", "icon", "last", "optional", "orientation", "StepIconProps"]);
  return _react.default.createElement("span", (0, _extends2.default)({
    className: (0, _classnames.default)(classes.root, classes[orientation], (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes.disabled, disabled), (0, _defineProperty2.default)(_classNames, classes.alternativeLabel, alternativeLabel), (0, _defineProperty2.default)(_classNames, classes.error, error), _classNames), classNameProp)
  }, other), icon && _react.default.createElement("span", {
    className: (0, _classnames.default)(classes.iconContainer, (0, _defineProperty2.default)({}, classes.alternativeLabel, alternativeLabel))
  }, _react.default.createElement(_StepIcon.default, (0, _extends2.default)({
    completed: completed,
    active: active,
    error: error,
    icon: icon
  }, StepIconProps))), _react.default.createElement("span", {
    className: classes.labelContainer
  }, _react.default.createElement(_Typography.default, {
    variant: "body1",
    component: "span",
    className: (0, _classnames.default)(classes.label, (_classNames3 = {}, (0, _defineProperty2.default)(_classNames3, classes.alternativeLabel, alternativeLabel), (0, _defineProperty2.default)(_classNames3, classes.completed, completed), (0, _defineProperty2.default)(_classNames3, classes.active, active), (0, _defineProperty2.default)(_classNames3, classes.error, error), _classNames3))
  }, children), optional));
}

StepLabel.propTypes =  false ? {
  /**
   * @ignore
   * Sets the step as active. Is passed to child components.
   */
  active: _propTypes.default.bool,

  /**
   * @ignore
   * Set internally by Stepper when it's supplied with the alternativeLabel property.
   */
  alternativeLabel: _propTypes.default.bool,

  /**
   * In most cases will simply be a string containing a title for the label.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * @ignore
   * Mark the step as completed. Is passed to child components.
   */
  completed: _propTypes.default.bool,

  /**
   * Mark the step as disabled, will also disable the button if
   * `StepLabelButton` is a child of `StepLabel`. Is passed to child components.
   */
  disabled: _propTypes.default.bool,

  /**
   * Mark the step as failed.
   */
  error: _propTypes.default.bool,

  /**
   * Override the default icon.
   */
  icon: _propTypes.default.node,

  /**
   * @ignore
   */
  last: _propTypes.default.bool,

  /**
   * The optional node to display.
   */
  optional: _propTypes.default.node,

  /**
   * @ignore
   */
  orientation: _propTypes.default.oneOf(['horizontal', 'vertical']),

  /**
   * Properties applied to the `StepIcon` element.
   */
  StepIconProps: _propTypes.default.object
} : {};
StepLabel.defaultProps = {
  active: false,
  alternativeLabel: false,
  completed: false,
  disabled: false,
  error: false,
  last: false,
  orientation: 'horizontal'
};
StepLabel.muiName = 'StepLabel';

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiStepLabel'
})(StepLabel);

exports.default = _default;

/***/ }),
/* 1041 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(11));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _classnames = _interopRequireDefault(__webpack_require__(6));

var _CheckCircle = _interopRequireDefault(__webpack_require__(1042));

var _Warning = _interopRequireDefault(__webpack_require__(1043));

var _withStyles = _interopRequireDefault(__webpack_require__(5));

var _StepPositionIcon = _interopRequireDefault(__webpack_require__(1044));

var styles = function styles(theme) {
  return {
    root: {
      display: 'block',
      '&$active': {
        color: theme.palette.primary.main
      },
      '&$completed': {
        color: theme.palette.primary.main
      },
      '&$error': {
        color: theme.palette.error.main
      }
    },
    active: {},
    completed: {},
    error: {}
  };
};

exports.styles = styles;

function StepIcon(props) {
  var completed = props.completed,
      icon = props.icon,
      active = props.active,
      error = props.error,
      classes = props.classes;

  if (typeof icon === 'number' || typeof icon === 'string') {
    if (error) {
      return _react.default.createElement(_Warning.default, {
        className: (0, _classnames.default)(classes.root, classes.error)
      });
    }

    if (completed) {
      return _react.default.createElement(_CheckCircle.default, {
        className: (0, _classnames.default)(classes.root, classes.completed)
      });
    }

    return _react.default.createElement(_StepPositionIcon.default, {
      className: (0, _classnames.default)(classes.root, (0, _defineProperty2.default)({}, classes.active, active)),
      position: icon
    });
  }

  return icon;
}

StepIcon.propTypes =  false ? {
  /**
   * Whether this step is active.
   */
  active: _propTypes.default.bool,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * Mark the step as completed. Is passed to child components.
   */
  completed: _propTypes.default.bool,

  /**
   * Mark the step as failed.
   */
  error: _propTypes.default.bool,

  /**
   * The icon displayed by the step label.
   */
  icon: _propTypes.default.node.isRequired
} : {};
StepIcon.defaultProps = {
  active: false,
  completed: false,
  error: false
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiStepIcon'
})(StepIcon);

exports.default = _default;

/***/ }),
/* 1042 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _pure = _interopRequireDefault(__webpack_require__(52));

var _SvgIcon = _interopRequireDefault(__webpack_require__(47));

var _ref = _react.default.createElement("path", {
  d: "M12 0a12 12 0 1 0 0 24 12 12 0 0 0 0-24zm-2 17l-5-5 1.4-1.4 3.6 3.6 7.6-7.6L19 8l-9 9z"
});

/**
 * @ignore - internal component.
 */
var CheckCircle = function CheckCircle(props) {
  return _react.default.createElement(_SvgIcon.default, props, _ref);
};

CheckCircle = (0, _pure.default)(CheckCircle);
CheckCircle.muiName = 'SvgIcon';
var _default = CheckCircle;
exports.default = _default;

/***/ }),
/* 1043 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _pure = _interopRequireDefault(__webpack_require__(52));

var _SvgIcon = _interopRequireDefault(__webpack_require__(47));

var _ref = _react.default.createElement("path", {
  d: "M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"
});

/**
 * @ignore - internal component.
 */
var Warning = function Warning(props) {
  return _react.default.createElement(_SvgIcon.default, props, _ref);
};

Warning = (0, _pure.default)(Warning);
Warning.muiName = 'SvgIcon';
var _default = Warning;
exports.default = _default;

/***/ }),
/* 1044 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _classnames = _interopRequireDefault(__webpack_require__(6));

var _withStyles = _interopRequireDefault(__webpack_require__(5));

var _SvgIcon = _interopRequireDefault(__webpack_require__(47));

var styles = function styles(theme) {
  return {
    root: {
      color: theme.palette.text.disabled
    },
    text: {
      fill: theme.palette.primary.contrastText,
      fontSize: theme.typography.caption.fontSize,
      fontFamily: theme.typography.fontFamily
    }
  };
};
/**
 * @ignore - internal component.
 */


exports.styles = styles;

var _ref = _react.default.createElement("circle", {
  cx: "12",
  cy: "12",
  r: "12"
});

function StepPositionIcon(props) {
  var position = props.position,
      classes = props.classes,
      className = props.className;
  return _react.default.createElement(_SvgIcon.default, {
    className: (0, _classnames.default)(classes.root, className)
  }, _ref, _react.default.createElement("text", {
    className: classes.text,
    x: "12",
    y: "16",
    textAnchor: "middle"
  }, position));
}

StepPositionIcon.propTypes =  false ? {
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The step position as a number.
   */
  position: _propTypes.default.node
} : {};

var _default = (0, _withStyles.default)(styles)(StepPositionIcon);

exports.default = _default;

/***/ }),
/* 1045 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(8));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(11));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _classnames = _interopRequireDefault(__webpack_require__(6));

var _withStyles = _interopRequireDefault(__webpack_require__(5));

var styles = function styles(theme) {
  return {
    root: {
      flex: '1 1 auto'
    },
    horizontal: {},
    vertical: {
      marginLeft: 12,
      // half icon
      padding: "0 0 ".concat(theme.spacing.unit, "px")
    },
    alternativeLabel: {
      position: 'absolute',
      top: theme.spacing.unit + 4,
      left: 'calc(50% + 20px)',
      right: 'calc(-50% + 20px)'
    },
    line: {
      display: 'block',
      borderColor: theme.palette.type === 'light' ? theme.palette.grey[400] : theme.palette.grey[600]
    },
    lineHorizontal: {
      borderTopStyle: 'solid',
      borderTopWidth: 1
    },
    lineVertical: {
      borderLeftStyle: 'solid',
      borderLeftWidth: 1,
      minHeight: theme.spacing.unit * 3
    }
  };
};

exports.styles = styles;

function StepConnector(props) {
  var _classNames2;

  var alternativeLabel = props.alternativeLabel,
      classNameProp = props.className,
      classes = props.classes,
      orientation = props.orientation,
      other = (0, _objectWithoutProperties2.default)(props, ["alternativeLabel", "className", "classes", "orientation"]);
  var className = (0, _classnames.default)(classes.root, classes[orientation], (0, _defineProperty2.default)({}, classes.alternativeLabel, alternativeLabel), classNameProp);
  var lineClassName = (0, _classnames.default)(classes.line, (_classNames2 = {}, (0, _defineProperty2.default)(_classNames2, classes.lineHorizontal, orientation === 'horizontal'), (0, _defineProperty2.default)(_classNames2, classes.lineVertical, orientation === 'vertical'), _classNames2));
  return _react.default.createElement("div", (0, _extends2.default)({
    className: className
  }, other), _react.default.createElement("span", {
    className: lineClassName
  }));
}

StepConnector.propTypes =  false ? {
  /**
   * @ignore
   * Set internally by Step when it's supplied with the alternativeLabel property.
   */
  alternativeLabel: _propTypes.default.bool,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * @ignore
   */
  orientation: _propTypes.default.oneOf(['horizontal', 'vertical'])
} : {};
StepConnector.defaultProps = {
  alternativeLabel: false,
  orientation: 'horizontal'
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiStepConnector'
})(StepConnector);

exports.default = _default;

/***/ }),
/* 1046 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _StepContent.default;
  }
});

var _StepContent = _interopRequireDefault(__webpack_require__(1047));

/***/ }),
/* 1047 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(8));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(11));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _warning = _interopRequireDefault(__webpack_require__(32));

var _classnames = _interopRequireDefault(__webpack_require__(6));

var _Collapse = _interopRequireDefault(__webpack_require__(225));

var _withStyles = _interopRequireDefault(__webpack_require__(5));

var styles = function styles(theme) {
  return {
    root: {
      marginTop: theme.spacing.unit,
      marginLeft: 12,
      // half icon
      paddingLeft: theme.spacing.unit + 12,
      // margin + half icon
      paddingRight: theme.spacing.unit,
      borderLeft: "1px solid ".concat(theme.palette.type === 'light' ? theme.palette.grey[400] : theme.palette.grey[600])
    },
    last: {
      borderLeft: 'none'
    },
    transition: {}
  };
};

exports.styles = styles;

function StepContent(props) {
  var active = props.active,
      alternativeLabel = props.alternativeLabel,
      children = props.children,
      classes = props.classes,
      className = props.className,
      completed = props.completed,
      last = props.last,
      optional = props.optional,
      orientation = props.orientation,
      TransitionComponent = props.TransitionComponent,
      transitionDuration = props.transitionDuration,
      TransitionProps = props.TransitionProps,
      other = (0, _objectWithoutProperties2.default)(props, ["active", "alternativeLabel", "children", "classes", "className", "completed", "last", "optional", "orientation", "TransitionComponent", "transitionDuration", "TransitionProps"]);
   false ? (0, _warning.default)(orientation === 'vertical', 'Material-UI: <StepContent /> is only designed for use with the vertical stepper.') : void 0;
  return _react.default.createElement("div", (0, _extends2.default)({
    className: (0, _classnames.default)(classes.root, (0, _defineProperty2.default)({}, classes.last, last), className)
  }, other), _react.default.createElement(TransitionComponent, (0, _extends2.default)({
    "in": active,
    className: classes.transition,
    timeout: transitionDuration,
    unmountOnExit: true
  }, TransitionProps), children));
}

StepContent.propTypes =  false ? {
  /**
   * @ignore
   * Expands the content.
   */
  active: _propTypes.default.bool,

  /**
   * @ignore
   * Set internally by Step when it's supplied with the alternativeLabel property.
   */
  alternativeLabel: _propTypes.default.bool,

  /**
   * Step content.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * @ignore
   */
  completed: _propTypes.default.bool,

  /**
   * @ignore
   */
  last: _propTypes.default.bool,

  /**
   * @ignore
   * Set internally by Step when it's supplied with the optional property.
   */
  optional: _propTypes.default.bool,

  /**
   * @ignore
   */
  orientation: _propTypes.default.oneOf(['horizontal', 'vertical']),

  /**
   * Collapse component.
   */
  TransitionComponent: _propTypes.default.func,

  /**
   * Adjust the duration of the content expand transition.
   * Passed as a property to the transition component.
   *
   * Set to 'auto' to automatically calculate transition time based on height.
   */
  transitionDuration: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
    enter: _propTypes.default.number,
    exit: _propTypes.default.number
  }), _propTypes.default.oneOf(['auto'])]),

  /**
   * Properties applied to the `Transition` element.
   */
  TransitionProps: _propTypes.default.object
} : {};
StepContent.defaultProps = {
  TransitionComponent: _Collapse.default,
  transitionDuration: 'auto'
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiStepContent'
})(StepContent);

exports.default = _default;

/***/ }),
/* 1048 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Stepper.default;
  }
});

var _Stepper = _interopRequireDefault(__webpack_require__(1049));

/***/ }),
/* 1049 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(8));

var _objectSpread2 = _interopRequireDefault(__webpack_require__(23));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(11));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _classnames = _interopRequireDefault(__webpack_require__(6));

var _withStyles = _interopRequireDefault(__webpack_require__(5));

var _Paper = _interopRequireDefault(__webpack_require__(69));

var _StepConnector = _interopRequireDefault(__webpack_require__(512));

// @inheritedComponent Paper
var styles = function styles(theme) {
  return {
    root: {
      display: 'flex',
      padding: theme.spacing.unit * 3
    },
    horizontal: {
      flexDirection: 'row',
      alignItems: 'center'
    },
    vertical: {
      flexDirection: 'column'
    },
    alternativeLabel: {
      alignItems: 'flex-start'
    }
  };
};

exports.styles = styles;

function Stepper(props) {
  var activeStep = props.activeStep,
      alternativeLabel = props.alternativeLabel,
      children = props.children,
      classes = props.classes,
      classNameProp = props.className,
      connectorProp = props.connector,
      nonLinear = props.nonLinear,
      orientation = props.orientation,
      other = (0, _objectWithoutProperties2.default)(props, ["activeStep", "alternativeLabel", "children", "classes", "className", "connector", "nonLinear", "orientation"]);
  var className = (0, _classnames.default)(classes.root, classes[orientation], (0, _defineProperty2.default)({}, classes.alternativeLabel, alternativeLabel), classNameProp);
  var connector = _react.default.isValidElement(connectorProp) ? _react.default.cloneElement(connectorProp, {
    orientation: orientation
  }) : null;

  var childrenArray = _react.default.Children.toArray(children);

  var steps = childrenArray.map(function (step, index) {
    var controlProps = {
      index: index,
      orientation: orientation,
      active: false,
      completed: false,
      disabled: false,
      last: index + 1 === childrenArray.length,
      alternativeLabel: alternativeLabel,
      connector: connectorProp
    };

    if (activeStep === index) {
      controlProps.active = true;
    } else if (!nonLinear && activeStep > index) {
      controlProps.completed = true;
    } else if (!nonLinear && activeStep < index) {
      controlProps.disabled = true;
    }

    return [!alternativeLabel && connector && index > 0 && _react.default.cloneElement(connector, {
      key: index // eslint-disable-line react/no-array-index-key

    }), _react.default.cloneElement(step, (0, _objectSpread2.default)({}, controlProps, step.props))];
  });
  return _react.default.createElement(_Paper.default, (0, _extends2.default)({
    square: true,
    elevation: 0,
    className: className
  }, other), steps);
}

Stepper.propTypes =  false ? {
  /**
   * Set the active step (zero based index).
   */
  activeStep: _propTypes.default.number,

  /**
   * If set to 'true' and orientation is horizontal,
   * then the step label will be positioned under the icon.
   */
  alternativeLabel: _propTypes.default.bool,

  /**
   * Two or more `<Step />` components.
   */
  children: _propTypes.default.node.isRequired,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * A component to be placed between each step.
   */
  connector: _propTypes.default.element,

  /**
   * If set the `Stepper` will not assist in controlling steps for linear flow.
   */
  nonLinear: _propTypes.default.bool,

  /**
   * The stepper orientation (layout flow direction).
   */
  orientation: _propTypes.default.oneOf(['horizontal', 'vertical'])
} : {};
Stepper.defaultProps = {
  activeStep: 0,
  alternativeLabel: false,
  connector: _react.default.createElement(_StepConnector.default, null),
  nonLinear: false,
  orientation: 'horizontal'
};
Stepper.muiName = 'Stepper';

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiStepper'
})(Stepper);

exports.default = _default;

/***/ }),
/* 1050 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _SwipeableDrawer.default;
  }
});

var _SwipeableDrawer = _interopRequireDefault(__webpack_require__(1051));

/***/ }),
/* 1051 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(161);

var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reset = reset;
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(8));

var _objectSpread2 = _interopRequireDefault(__webpack_require__(23));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(18));

var _createClass2 = _interopRequireDefault(__webpack_require__(19));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(20));

var _inherits2 = _interopRequireDefault(__webpack_require__(21));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(127));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _reactDom = _interopRequireDefault(__webpack_require__(45));

var _Drawer = _interopRequireWildcard(__webpack_require__(324));

var _transitions = __webpack_require__(78);

var _withTheme = _interopRequireDefault(__webpack_require__(91));

var _utils = __webpack_require__(132);

var _SwipeArea = _interopRequireDefault(__webpack_require__(1052));

/* eslint-disable consistent-this */
// @inheritedComponent Drawer
// This value is closed to what browsers are using internally to
// trigger a native scroll.
var UNCERTAINTY_THRESHOLD = 3; // px
// We can only have one node at the time claiming ownership for handling the swipe.
// Otherwise, the UX would be confusing.
// That's why we use a singleton here.

var nodeThatClaimedTheSwipe = null; // Exported for test purposes.

function reset() {
  nodeThatClaimedTheSwipe = null;
}

var SwipeableDrawer =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(SwipeableDrawer, _React$Component);

  function SwipeableDrawer() {
    var _ref;

    var _temp, _this;

    (0, _classCallCheck2.default)(this, SwipeableDrawer);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return (0, _possibleConstructorReturn2.default)(_this, (_temp = _this = (0, _possibleConstructorReturn2.default)(this, (_ref = SwipeableDrawer.__proto__ || Object.getPrototypeOf(SwipeableDrawer)).call.apply(_ref, [this].concat(args))), _this.state = {}, _this.handleBodyTouchStart = function (event) {
      // We are not supposed to hanlde this touch move.
      if (nodeThatClaimedTheSwipe !== null && nodeThatClaimedTheSwipe !== (0, _assertThisInitialized2.default)(_this)) {
        return;
      }

      var _this$props = _this.props,
          disableDiscovery = _this$props.disableDiscovery,
          disableSwipeToOpen = _this$props.disableSwipeToOpen,
          open = _this$props.open,
          swipeAreaWidth = _this$props.swipeAreaWidth;
      var anchor = (0, _Drawer.getAnchor)(_this.props);
      var currentX = anchor === 'right' ? document.body.offsetWidth - event.touches[0].pageX : event.touches[0].pageX;
      var currentY = anchor === 'bottom' ? window.innerHeight - event.touches[0].clientY : event.touches[0].clientY;

      if (!open) {
        if (disableSwipeToOpen) {
          return;
        }

        if ((0, _Drawer.isHorizontal)(_this.props)) {
          if (currentX > swipeAreaWidth) {
            return;
          }
        } else if (currentY > swipeAreaWidth) {
          return;
        }
      }

      nodeThatClaimedTheSwipe = (0, _assertThisInitialized2.default)(_this);
      _this.startX = currentX;
      _this.startY = currentY;

      _this.setState({
        maybeSwiping: true
      });

      if (!open && _this.paper) {
        // the ref may be null when a parent component updates while swiping
        _this.setPosition(_this.getMaxTranslate() + (disableDiscovery ? 20 : -swipeAreaWidth), {
          changeTransition: false
        });
      }

      document.body.addEventListener('touchmove', _this.handleBodyTouchMove, {
        passive: false
      });
      document.body.addEventListener('touchend', _this.handleBodyTouchEnd); // https://plus.google.com/+PaulIrish/posts/KTwfn1Y2238

      document.body.addEventListener('touchcancel', _this.handleBodyTouchEnd);
    }, _this.handleBodyTouchMove = function (event) {
      // the ref may be null when a parent component updates while swiping
      if (!_this.paper) return;
      var anchor = (0, _Drawer.getAnchor)(_this.props);
      var horizontalSwipe = (0, _Drawer.isHorizontal)(_this.props);
      var currentX = anchor === 'right' ? document.body.offsetWidth - event.touches[0].pageX : event.touches[0].pageX;
      var currentY = anchor === 'bottom' ? window.innerHeight - event.touches[0].clientY : event.touches[0].clientY; // We don't know yet.

      if (_this.isSwiping == null) {
        var dx = Math.abs(currentX - _this.startX);
        var dy = Math.abs(currentY - _this.startY); // We are likely to be swiping, let's prevent the scroll event on iOS.

        if (dx > dy) {
          event.preventDefault();
        }

        var isSwiping = horizontalSwipe ? dx > dy && dx > UNCERTAINTY_THRESHOLD : dy > dx && dy > UNCERTAINTY_THRESHOLD;

        if (isSwiping === true || (horizontalSwipe ? dy > UNCERTAINTY_THRESHOLD : dx > UNCERTAINTY_THRESHOLD)) {
          _this.isSwiping = isSwiping;

          if (!isSwiping) {
            _this.handleBodyTouchEnd(event);

            return;
          } // Shift the starting point.


          _this.startX = currentX;
          _this.startY = currentY; // Compensate for the part of the drawer displayed on touch start.

          if (!_this.props.disableDiscovery && !_this.props.open) {
            if (horizontalSwipe) {
              _this.startX -= _this.props.swipeAreaWidth;
            } else {
              _this.startY -= _this.props.swipeAreaWidth;
            }
          }
        }
      }

      if (!_this.isSwiping) {
        return;
      } // We are swiping, let's prevent the scroll event on iOS.


      event.preventDefault();

      _this.setPosition(_this.getTranslate(horizontalSwipe ? currentX : currentY));
    }, _this.handleBodyTouchEnd = function (event) {
      nodeThatClaimedTheSwipe = null;

      _this.removeBodyTouchListeners();

      _this.setState({
        maybeSwiping: false
      }); // The swipe wasn't started.


      if (!_this.isSwiping) {
        _this.isSwiping = null;
        return;
      }

      var anchor = (0, _Drawer.getAnchor)(_this.props);
      var current;

      if ((0, _Drawer.isHorizontal)(_this.props)) {
        current = anchor === 'right' ? document.body.offsetWidth - event.changedTouches[0].pageX : event.changedTouches[0].pageX;
      } else {
        current = anchor === 'bottom' ? window.innerHeight - event.changedTouches[0].clientY : event.changedTouches[0].clientY;
      }

      var translateRatio = _this.getTranslate(current) / _this.getMaxTranslate(); // We have to open or close after setting swiping to null,
      // because only then CSS transition is enabled.


      if (translateRatio > 0.5) {
        if (_this.isSwiping && !_this.props.open) {
          // Reset the position, the swipe was aborted.
          _this.setPosition(_this.getMaxTranslate(), {
            mode: 'enter'
          });
        } else {
          _this.props.onClose();
        }
      } else if (_this.isSwiping && !_this.props.open) {
        _this.props.onOpen();
      } else {
        // Reset the position, the swipe was aborted.
        _this.setPosition(0, {
          mode: 'exit'
        });
      }

      _this.isSwiping = null;
    }, _this.backdrop = null, _this.paper = null, _this.isSwiping = null, _this.startX = null, _this.startY = null, _this.handleBackdropRef = function (node) {
      _this.backdrop = node ? _reactDom.default.findDOMNode(node) : null;
    }, _this.handlePaperRef = function (node) {
      _this.paper = node ? _reactDom.default.findDOMNode(node) : null;
    }, _temp));
  }

  (0, _createClass2.default)(SwipeableDrawer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.variant === 'temporary') {
        this.listenTouchStart();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var variant = this.props.variant;
      var prevVariant = prevProps.variant;

      if (variant !== prevVariant) {
        if (variant === 'temporary') {
          this.listenTouchStart();
        } else if (prevVariant === 'temporary') {
          this.removeTouchStart();
        }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.removeTouchStart();
      this.removeBodyTouchListeners(); // We need to release the lock.

      if (nodeThatClaimedTheSwipe === this) {
        nodeThatClaimedTheSwipe = null;
      }
    }
  }, {
    key: "getMaxTranslate",
    value: function getMaxTranslate() {
      return (0, _Drawer.isHorizontal)(this.props) ? this.paper.clientWidth : this.paper.clientHeight;
    }
  }, {
    key: "getTranslate",
    value: function getTranslate(current) {
      var start = (0, _Drawer.isHorizontal)(this.props) ? this.startX : this.startY;
      return Math.min(Math.max(this.props.open ? start - current : this.getMaxTranslate() + start - current, 0), this.getMaxTranslate());
    }
  }, {
    key: "setPosition",
    value: function setPosition(translate) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var _options$mode = options.mode,
          mode = _options$mode === void 0 ? null : _options$mode,
          _options$changeTransi = options.changeTransition,
          changeTransition = _options$changeTransi === void 0 ? true : _options$changeTransi;
      var anchor = (0, _Drawer.getAnchor)(this.props);
      var rtlTranslateMultiplier = ['right', 'bottom'].indexOf(anchor) !== -1 ? 1 : -1;
      var transform = (0, _Drawer.isHorizontal)(this.props) ? "translate(".concat(rtlTranslateMultiplier * translate, "px, 0)") : "translate(0, ".concat(rtlTranslateMultiplier * translate, "px)");
      var drawerStyle = this.paper.style;
      drawerStyle.webkitTransform = transform;
      drawerStyle.transform = transform;
      var transition = '';

      if (mode) {
        transition = this.props.theme.transitions.create('all', (0, _utils.getTransitionProps)({
          timeout: this.props.transitionDuration
        }, {
          mode: mode
        }));
      }

      if (changeTransition) {
        drawerStyle.webkitTransition = transition;
        drawerStyle.transition = transition;
      }

      if (!this.props.disableBackdropTransition) {
        var backdropStyle = this.backdrop.style;
        backdropStyle.opacity = 1 - translate / this.getMaxTranslate();

        if (changeTransition) {
          backdropStyle.webkitTransition = transition;
          backdropStyle.transition = transition;
        }
      }
    }
  }, {
    key: "listenTouchStart",
    value: function listenTouchStart() {
      document.body.addEventListener('touchstart', this.handleBodyTouchStart);
    }
  }, {
    key: "removeTouchStart",
    value: function removeTouchStart() {
      document.body.removeEventListener('touchstart', this.handleBodyTouchStart);
    }
  }, {
    key: "removeBodyTouchListeners",
    value: function removeBodyTouchListeners() {
      document.body.removeEventListener('touchmove', this.handleBodyTouchMove, {
        passive: false
      });
      document.body.removeEventListener('touchend', this.handleBodyTouchEnd);
      document.body.removeEventListener('touchcancel', this.handleBodyTouchEnd);
    }
  }, {
    key: "render",
    value: function render() {
      var _props = this.props,
          disableBackdropTransition = _props.disableBackdropTransition,
          disableDiscovery = _props.disableDiscovery,
          disableSwipeToOpen = _props.disableSwipeToOpen,
          _props$ModalProps = _props.ModalProps;
      _props$ModalProps = _props$ModalProps === void 0 ? {} : _props$ModalProps;
      var BackdropProps = _props$ModalProps.BackdropProps,
          ModalPropsProp = (0, _objectWithoutProperties2.default)(_props$ModalProps, ["BackdropProps"]),
          onOpen = _props.onOpen,
          open = _props.open,
          PaperProps = _props.PaperProps,
          swipeAreaWidth = _props.swipeAreaWidth,
          variant = _props.variant,
          other = (0, _objectWithoutProperties2.default)(_props, ["disableBackdropTransition", "disableDiscovery", "disableSwipeToOpen", "ModalProps", "onOpen", "open", "PaperProps", "swipeAreaWidth", "variant"]);
      var maybeSwiping = this.state.maybeSwiping;
      return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_Drawer.default, (0, _extends2.default)({
        open: variant === 'temporary' && maybeSwiping ? true : open,
        variant: variant,
        ModalProps: (0, _objectSpread2.default)({
          BackdropProps: (0, _objectSpread2.default)({}, BackdropProps, {
            ref: this.handleBackdropRef
          })
        }, ModalPropsProp),
        PaperProps: (0, _objectSpread2.default)({}, PaperProps, {
          style: {
            pointerEvents: variant === 'temporary' && !open ? 'none' : ''
          },
          ref: this.handlePaperRef
        })
      }, other)), !disableDiscovery && !disableSwipeToOpen && variant === 'temporary' && _react.default.createElement(_SwipeArea.default, {
        anchor: other.anchor,
        swipeAreaWidth: swipeAreaWidth
      }));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      if (typeof prevState.maybeSwiping === 'undefined') {
        return {
          maybeSwiping: false,
          open: nextProps.open
        };
      }

      if (!nextProps.open && prevState.open) {
        return {
          maybeSwiping: false,
          open: nextProps.open
        };
      }

      return {
        open: nextProps.open
      };
    }
  }]);
  return SwipeableDrawer;
}(_react.default.Component);

SwipeableDrawer.propTypes =  false ? {
  /**
   * @ignore
   */
  anchor: _propTypes.default.oneOf(['left', 'top', 'right', 'bottom']),

  /**
   * Disable the backdrop transition.
   * This can improve the FPS on low-end devices.
   */
  disableBackdropTransition: _propTypes.default.bool,

  /**
   * If `true`, touching the screen near the edge of the drawer will not slide in the drawer a bit
   * to promote accidental discovery of the swipe gesture.
   */
  disableDiscovery: _propTypes.default.bool,

  /**
   * If `true`, swipe to open is disabled. This is useful in browsers where swiping triggers
   * navigation actions. Swipe to open is disabled on iOS browsers by default.
   */
  disableSwipeToOpen: _propTypes.default.bool,

  /**
   * @ignore
   */
  ModalProps: _propTypes.default.object,

  /**
   * Callback fired when the component requests to be closed.
   *
   * @param {object} event The event source of the callback
   */
  onClose: _propTypes.default.func.isRequired,

  /**
   * Callback fired when the component requests to be opened.
   *
   * @param {object} event The event source of the callback
   */
  onOpen: _propTypes.default.func.isRequired,

  /**
   * If `true`, the drawer is open.
   */
  open: _propTypes.default.bool.isRequired,

  /**
   * @ignore
   */
  PaperProps: _propTypes.default.object,

  /**
   * The width of the left most (or right most) area in pixels where the
   * drawer can be swiped open from.
   */
  swipeAreaWidth: _propTypes.default.number,

  /**
   * @ignore
   */
  theme: _propTypes.default.object.isRequired,

  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   */
  transitionDuration: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
    enter: _propTypes.default.number,
    exit: _propTypes.default.number
  })]),

  /**
   * @ignore
   */
  variant: _propTypes.default.oneOf(['permanent', 'persistent', 'temporary'])
} : {};
SwipeableDrawer.defaultProps = {
  anchor: 'left',
  disableBackdropTransition: false,
  disableDiscovery: false,
  disableSwipeToOpen: typeof navigator !== 'undefined' && /iPad|iPhone|iPod/.test(navigator.userAgent),
  swipeAreaWidth: 20,
  transitionDuration: {
    enter: _transitions.duration.enteringScreen,
    exit: _transitions.duration.leavingScreen
  },
  variant: 'temporary' // Mobile first.

};

var _default = (0, _withTheme.default)()(SwipeableDrawer);

exports.default = _default;

/***/ }),
/* 1052 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(8));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(11));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _classnames = _interopRequireDefault(__webpack_require__(6));

var _withStyles = _interopRequireDefault(__webpack_require__(5));

var _helpers = __webpack_require__(36);

var _Drawer = __webpack_require__(324);

var styles = function styles(theme) {
  return {
    root: {
      position: 'fixed',
      top: 0,
      left: 0,
      height: '100vh',
      zIndex: theme.zIndex.drawer - 1
    },
    discoveryAnchorLeft: {
      right: 'auto'
    },
    discoveryAnchorRight: {
      left: 'auto',
      right: 0
    },
    discoveryAnchorTop: {
      bottom: 'auto',
      right: 0
    },
    discoveryAnchorBottom: {
      top: 'auto',
      bottom: 0,
      right: 0
    }
  };
};
/**
 * @ignore - internal component.
 */


exports.styles = styles;

function SwipeArea(props) {
  var anchor = props.anchor,
      classes = props.classes,
      swipeAreaWidth = props.swipeAreaWidth,
      other = (0, _objectWithoutProperties2.default)(props, ["anchor", "classes", "swipeAreaWidth"]);
  return _react.default.createElement("div", (0, _extends2.default)({
    className: (0, _classnames.default)(classes.root, classes["discoveryAnchor".concat((0, _helpers.capitalize)(anchor))]),
    style: (0, _defineProperty2.default)({}, (0, _Drawer.isHorizontal)(props) ? 'width' : 'height', swipeAreaWidth)
  }, other));
}

SwipeArea.propTypes =  false ? {
  /**
   * Side on which to attach the discovery area.
   */
  anchor: _propTypes.default.oneOf(['left', 'top', 'right', 'bottom']).isRequired,

  /**
   * @ignore
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * The width of the left most (or right most) area in pixels where the
   * drawer can be swiped open from.
   */
  swipeAreaWidth: _propTypes.default.number.isRequired
} : {};

var _default = (0, _withStyles.default)(styles)(SwipeArea);

exports.default = _default;

/***/ }),
/* 1053 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Switch.default;
  }
});

var _Switch = _interopRequireDefault(__webpack_require__(1054));

/***/ }),
/* 1054 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(8));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _classnames = _interopRequireDefault(__webpack_require__(6));

var _withStyles = _interopRequireDefault(__webpack_require__(5));

var _helpers = __webpack_require__(36);

var _SwitchBase = _interopRequireDefault(__webpack_require__(308));

var styles = function styles(theme) {
  return {
    root: {
      display: 'inline-flex',
      width: 62,
      position: 'relative',
      flexShrink: 0,
      // For correct alignment with the text.
      verticalAlign: 'middle'
    },
    icon: {
      boxShadow: theme.shadows[1],
      backgroundColor: 'currentColor',
      width: 20,
      height: 20,
      borderRadius: '50%'
    },
    iconChecked: {
      boxShadow: theme.shadows[2]
    },
    switchBase: {
      zIndex: 1,
      color: theme.palette.type === 'light' ? theme.palette.grey[50] : theme.palette.grey[400],
      transition: theme.transitions.create('transform', {
        duration: theme.transitions.duration.shortest
      })
    },
    checked: {
      transform: 'translateX(14px)',
      '& + $bar': {
        opacity: 0.5
      }
    },
    colorPrimary: {
      '&$checked': {
        color: theme.palette.primary.main,
        '& + $bar': {
          backgroundColor: theme.palette.primary.main
        }
      }
    },
    colorSecondary: {
      '&$checked': {
        color: theme.palette.secondary.main,
        '& + $bar': {
          backgroundColor: theme.palette.secondary.main
        }
      }
    },
    disabled: {
      '& + $bar': {
        opacity: theme.palette.type === 'light' ? 0.12 : 0.1
      },
      '& $icon': {
        boxShadow: theme.shadows[1]
      },
      '&$switchBase': {
        color: theme.palette.type === 'light' ? theme.palette.grey[400] : theme.palette.grey[800],
        '& + $bar': {
          backgroundColor: theme.palette.type === 'light' ? theme.palette.common.black : theme.palette.common.white
        }
      }
    },
    bar: {
      borderRadius: 7,
      display: 'block',
      position: 'absolute',
      width: 34,
      height: 14,
      top: '50%',
      left: '50%',
      marginTop: -7,
      marginLeft: -17,
      transition: theme.transitions.create(['opacity', 'background-color'], {
        duration: theme.transitions.duration.shortest
      }),
      backgroundColor: theme.palette.type === 'light' ? theme.palette.common.black : theme.palette.common.white,
      opacity: theme.palette.type === 'light' ? 0.38 : 0.3
    }
  };
};

exports.styles = styles;

function Switch(props) {
  var classes = props.classes,
      className = props.className,
      color = props.color,
      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "color"]);
  return _react.default.createElement("span", {
    className: (0, _classnames.default)(classes.root, className)
  }, _react.default.createElement(_SwitchBase.default, (0, _extends2.default)({
    icon: _react.default.createElement("span", {
      className: classes.icon
    }),
    classes: {
      root: (0, _classnames.default)(classes.switchBase, classes["color".concat((0, _helpers.capitalize)(color))]),
      checked: classes.checked,
      disabled: classes.disabled
    },
    checkedIcon: _react.default.createElement("span", {
      className: (0, _classnames.default)(classes.icon, classes.iconChecked)
    })
  }, other)), _react.default.createElement("span", {
    className: classes.bar
  }));
}

Switch.propTypes =  false ? {
  /**
   * If `true`, the component is checked.
   */
  checked: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.string]),

  /**
   * The icon to display when the component is checked.
   */
  checkedIcon: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: _propTypes.default.oneOf(['primary', 'secondary', 'default']),

  /**
   * @ignore
   */
  defaultChecked: _propTypes.default.bool,

  /**
   * If `true`, the switch will be disabled.
   */
  disabled: _propTypes.default.bool,

  /**
   * If `true`, the ripple effect will be disabled.
   */
  disableRipple: _propTypes.default.bool,

  /**
   * The icon to display when the component is unchecked.
   */
  icon: _propTypes.default.node,

  /**
   * The id of the `input` element.
   */
  id: _propTypes.default.string,

  /**
   * Properties applied to the `input` element.
   */
  inputProps: _propTypes.default.object,

  /**
   * Use that property to pass a ref callback to the native input component.
   */
  inputRef: _propTypes.default.func,

  /**
   * Callback fired when the state is changed.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.checked`.
   * @param {boolean} checked The `checked` value of the switch
   */
  onChange: _propTypes.default.func,

  /**
   * The input component property `type`.
   */
  type: _propTypes.default.string,

  /**
   * The value of the component.
   */
  value: _propTypes.default.string
} : {};
Switch.defaultProps = {
  color: 'secondary'
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiSwitch'
})(Switch);

exports.default = _default;

/***/ }),
/* 1055 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Table.default;
  }
});

var _Table = _interopRequireDefault(__webpack_require__(1056));

/***/ }),
/* 1056 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(8));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(18));

var _createClass2 = _interopRequireDefault(__webpack_require__(19));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(20));

var _inherits2 = _interopRequireDefault(__webpack_require__(21));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _classnames = _interopRequireDefault(__webpack_require__(6));

var _withStyles = _interopRequireDefault(__webpack_require__(5));

var styles = function styles(theme) {
  return {
    root: {
      display: 'table',
      fontFamily: theme.typography.fontFamily,
      width: '100%',
      borderCollapse: 'collapse',
      borderSpacing: 0
    }
  };
};

exports.styles = styles;

var Table =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(Table, _React$Component);

  function Table() {
    (0, _classCallCheck2.default)(this, Table);
    return (0, _possibleConstructorReturn2.default)(this, (Table.__proto__ || Object.getPrototypeOf(Table)).apply(this, arguments));
  }

  (0, _createClass2.default)(Table, [{
    key: "getChildContext",
    value: function getChildContext() {
      // eslint-disable-line class-methods-use-this
      return {
        table: {}
      };
    }
  }, {
    key: "render",
    value: function render() {
      var _props = this.props,
          classes = _props.classes,
          className = _props.className,
          Component = _props.component,
          other = (0, _objectWithoutProperties2.default)(_props, ["classes", "className", "component"]);
      return _react.default.createElement(Component, (0, _extends2.default)({
        className: (0, _classnames.default)(classes.root, className)
      }, other));
    }
  }]);
  return Table;
}(_react.default.Component);

Table.propTypes =  false ? {
  /**
   * The content of the table, normally `TableHeader` and `TableBody`.
   */
  children: _propTypes.default.node.isRequired,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func])
} : {};
Table.defaultProps = {
  component: 'table'
};
Table.childContextTypes = {
  table: _propTypes.default.object
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiTable'
})(Table);

exports.default = _default;

/***/ }),
/* 1057 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _TableBody.default;
  }
});

var _TableBody = _interopRequireDefault(__webpack_require__(1058));

/***/ }),
/* 1058 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(8));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(18));

var _createClass2 = _interopRequireDefault(__webpack_require__(19));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(20));

var _inherits2 = _interopRequireDefault(__webpack_require__(21));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _classnames = _interopRequireDefault(__webpack_require__(6));

var _withStyles = _interopRequireDefault(__webpack_require__(5));

var styles = {
  root: {
    display: 'table-row-group'
  }
};

var TableBody =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(TableBody, _React$Component);

  function TableBody() {
    (0, _classCallCheck2.default)(this, TableBody);
    return (0, _possibleConstructorReturn2.default)(this, (TableBody.__proto__ || Object.getPrototypeOf(TableBody)).apply(this, arguments));
  }

  (0, _createClass2.default)(TableBody, [{
    key: "getChildContext",
    value: function getChildContext() {
      // eslint-disable-line class-methods-use-this
      return {
        table: {
          body: true
        }
      };
    }
  }, {
    key: "render",
    value: function render() {
      var _props = this.props,
          classes = _props.classes,
          className = _props.className,
          Component = _props.component,
          other = (0, _objectWithoutProperties2.default)(_props, ["classes", "className", "component"]);
      return _react.default.createElement(Component, (0, _extends2.default)({
        className: (0, _classnames.default)(classes.root, className)
      }, other));
    }
  }]);
  return TableBody;
}(_react.default.Component);

TableBody.propTypes =  false ? {
  /**
   * The content of the component, normally `TableRow`.
   */
  children: _propTypes.default.node.isRequired,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func])
} : {};
TableBody.defaultProps = {
  component: 'tbody'
};
TableBody.childContextTypes = {
  table: _propTypes.default.object
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiTableBody'
})(TableBody);

exports.default = _default;

/***/ }),
/* 1059 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(8));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(11));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _classnames = _interopRequireDefault(__webpack_require__(6));

var _withStyles = _interopRequireDefault(__webpack_require__(5));

var _helpers = __webpack_require__(36);

var _colorManipulator = __webpack_require__(90);

var styles = function styles(theme) {
  return {
    root: {
      display: 'table-cell',
      verticalAlign: 'inherit',
      // Workaround for a rendering bug with spanned columns in Chrome 62.0.
      // Removes the alpha (sets it to 1), and lightens or darkens the theme color.
      borderBottom: "1px solid\n    ".concat(theme.palette.type === 'light' ? (0, _colorManipulator.lighten)((0, _colorManipulator.fade)(theme.palette.divider, 1), 0.88) : (0, _colorManipulator.darken)((0, _colorManipulator.fade)(theme.palette.divider, 1), 0.8)),
      textAlign: 'left',
      padding: "".concat(theme.spacing.unit / 2, "px ").concat(theme.spacing.unit * 7, "px ").concat(theme.spacing.unit / 2, "px ").concat(theme.spacing.unit * 3, "px"),
      '&:last-child': {
        paddingRight: theme.spacing.unit * 3
      }
    },
    head: {
      color: theme.palette.text.secondary,
      fontSize: theme.typography.pxToRem(12),
      fontWeight: theme.typography.fontWeightMedium
    },
    body: {
      color: theme.palette.text.primary,
      fontSize: theme.typography.pxToRem(13),
      fontWeight: theme.typography.fontWeightRegular
    },
    footer: {
      borderBottom: 0,
      color: theme.palette.text.secondary,
      fontSize: theme.typography.pxToRem(12)
    },
    numeric: {
      textAlign: 'right',
      flexDirection: 'row-reverse' // can be dynamically inherited at runtime by contents

    },
    paddingDense: {
      paddingRight: theme.spacing.unit * 3
    },
    paddingCheckbox: {
      padding: '0 12px',
      '&:last-child': {
        paddingRight: 12
      }
    },
    paddingNone: {
      padding: 0,
      '&:last-child': {
        padding: 0
      }
    }
  };
};

exports.styles = styles;

function TableCell(props, context) {
  var _classNames;

  var children = props.children,
      classes = props.classes,
      classNameProp = props.className,
      component = props.component,
      sortDirection = props.sortDirection,
      numeric = props.numeric,
      padding = props.padding,
      scopeProp = props.scope,
      variant = props.variant,
      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "component", "sortDirection", "numeric", "padding", "scope", "variant"]);
  var table = context.table;
  var Component;

  if (component) {
    Component = component;
  } else {
    Component = table && table.head ? 'th' : 'td';
  }

  var scope = scopeProp;

  if (!scope && table && table.head) {
    scope = 'col';
  }

  var className = (0, _classnames.default)(classes.root, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes.head, variant ? variant === 'head' : table && table.head), (0, _defineProperty2.default)(_classNames, classes.body, variant ? variant === 'body' : table && table.body), (0, _defineProperty2.default)(_classNames, classes.footer, variant ? variant === 'footer' : table && table.footer), (0, _defineProperty2.default)(_classNames, classes.numeric, numeric), (0, _defineProperty2.default)(_classNames, classes["padding".concat((0, _helpers.capitalize)(padding))], padding !== 'default'), _classNames), classNameProp);
  var ariaSort = null;

  if (sortDirection) {
    ariaSort = sortDirection === 'asc' ? 'ascending' : 'descending';
  }

  return _react.default.createElement(Component, (0, _extends2.default)({
    className: className,
    "aria-sort": ariaSort,
    scope: scope
  }, other), children);
}

TableCell.propTypes =  false ? {
  /**
   * The table cell contents.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func]),

  /**
   * If `true`, content will align to the right.
   */
  numeric: _propTypes.default.bool,

  /**
   * Sets the padding applied to the cell.
   */
  padding: _propTypes.default.oneOf(['default', 'checkbox', 'dense', 'none']),

  /**
   * Set scope attribute.
   */
  scope: _propTypes.default.string,

  /**
   * Set aria-sort direction.
   */
  sortDirection: _propTypes.default.oneOf(['asc', 'desc', false]),

  /**
   * Specify the cell type.
   * By default, the TableHead, TableBody or TableFooter parent component set the value.
   */
  variant: _propTypes.default.oneOf(['head', 'body', 'footer'])
} : {};
TableCell.defaultProps = {
  numeric: false,
  padding: 'default'
};
TableCell.contextTypes = {
  table: _propTypes.default.object.isRequired
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiTableCell'
})(TableCell);

exports.default = _default;

/***/ }),
/* 1060 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _TableFooter.default;
  }
});

var _TableFooter = _interopRequireDefault(__webpack_require__(1061));

/***/ }),
/* 1061 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(8));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(18));

var _createClass2 = _interopRequireDefault(__webpack_require__(19));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(20));

var _inherits2 = _interopRequireDefault(__webpack_require__(21));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _classnames = _interopRequireDefault(__webpack_require__(6));

var _withStyles = _interopRequireDefault(__webpack_require__(5));

var styles = {
  root: {
    display: 'table-footer-group'
  }
};

var TableFooter =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(TableFooter, _React$Component);

  function TableFooter() {
    (0, _classCallCheck2.default)(this, TableFooter);
    return (0, _possibleConstructorReturn2.default)(this, (TableFooter.__proto__ || Object.getPrototypeOf(TableFooter)).apply(this, arguments));
  }

  (0, _createClass2.default)(TableFooter, [{
    key: "getChildContext",
    value: function getChildContext() {
      // eslint-disable-line class-methods-use-this
      return {
        table: {
          footer: true
        }
      };
    }
  }, {
    key: "render",
    value: function render() {
      var _props = this.props,
          classes = _props.classes,
          className = _props.className,
          Component = _props.component,
          other = (0, _objectWithoutProperties2.default)(_props, ["classes", "className", "component"]);
      return _react.default.createElement(Component, (0, _extends2.default)({
        className: (0, _classnames.default)(classes.root, className)
      }, other));
    }
  }]);
  return TableFooter;
}(_react.default.Component);

TableFooter.propTypes =  false ? {
  /**
   * The content of the component, normally `TableRow`.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func])
} : {};
TableFooter.defaultProps = {
  component: 'tfoot'
};
TableFooter.childContextTypes = {
  table: _propTypes.default.object
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiTableFooter'
})(TableFooter);

exports.default = _default;

/***/ }),
/* 1062 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(8));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(18));

var _createClass2 = _interopRequireDefault(__webpack_require__(19));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(20));

var _inherits2 = _interopRequireDefault(__webpack_require__(21));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _classnames = _interopRequireDefault(__webpack_require__(6));

var _withStyles = _interopRequireDefault(__webpack_require__(5));

var styles = {
  root: {
    display: 'table-header-group'
  }
};

var TableHead =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(TableHead, _React$Component);

  function TableHead() {
    (0, _classCallCheck2.default)(this, TableHead);
    return (0, _possibleConstructorReturn2.default)(this, (TableHead.__proto__ || Object.getPrototypeOf(TableHead)).apply(this, arguments));
  }

  (0, _createClass2.default)(TableHead, [{
    key: "getChildContext",
    value: function getChildContext() {
      // eslint-disable-line class-methods-use-this
      return {
        table: {
          head: true
        }
      };
    }
  }, {
    key: "render",
    value: function render() {
      var _props = this.props,
          classes = _props.classes,
          className = _props.className,
          Component = _props.component,
          other = (0, _objectWithoutProperties2.default)(_props, ["classes", "className", "component"]);
      return _react.default.createElement(Component, (0, _extends2.default)({
        className: (0, _classnames.default)(classes.root, className)
      }, other));
    }
  }]);
  return TableHead;
}(_react.default.Component);

TableHead.propTypes =  false ? {
  /**
   * The content of the component, normally `TableRow`.
   */
  children: _propTypes.default.node.isRequired,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func])
} : {};
TableHead.defaultProps = {
  component: 'thead'
};
TableHead.childContextTypes = {
  table: _propTypes.default.object
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiTableHead'
})(TableHead);

exports.default = _default;

/***/ }),
/* 1063 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _TablePagination.default;
  }
});

var _TablePagination = _interopRequireDefault(__webpack_require__(1064));

/***/ }),
/* 1064 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(8));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(18));

var _createClass2 = _interopRequireDefault(__webpack_require__(19));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(20));

var _inherits2 = _interopRequireDefault(__webpack_require__(21));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _withStyles = _interopRequireDefault(__webpack_require__(5));

var _Input = _interopRequireDefault(__webpack_require__(171));

var _MenuItem = _interopRequireDefault(__webpack_require__(504));

var _Select = _interopRequireDefault(__webpack_require__(329));

var _TableCell = _interopRequireDefault(__webpack_require__(227));

var _Toolbar = _interopRequireDefault(__webpack_require__(331));

var _Typography = _interopRequireDefault(__webpack_require__(46));

var _TablePaginationActions = _interopRequireDefault(__webpack_require__(1066));

// @inheritedComponent TableCell
var styles = function styles(theme) {
  return {
    root: {
      fontSize: theme.typography.pxToRem(12),
      // Increase the specificity to override TableCell.
      '&:last-child': {
        padding: 0
      }
    },
    toolbar: {
      height: 56,
      minHeight: 56,
      paddingRight: 2
    },
    spacer: {
      flex: '1 1 100%'
    },
    menuItem: {},
    caption: {
      flexShrink: 0
    },
    input: {
      fontSize: 'inherit',
      flexShrink: 0
    },
    selectRoot: {
      marginRight: theme.spacing.unit * 4,
      marginLeft: theme.spacing.unit,
      color: theme.palette.text.secondary
    },
    select: {
      paddingLeft: theme.spacing.unit,
      paddingRight: theme.spacing.unit * 2
    },
    selectIcon: {
      top: 1
    },
    actions: {
      flexShrink: 0,
      color: theme.palette.text.secondary,
      marginLeft: theme.spacing.unit * 2.5
    }
  };
};
/**
 * A `TableCell` based component for placing inside `TableFooter` for pagination.
 */


exports.styles = styles;

var TablePagination =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(TablePagination, _React$Component);

  function TablePagination() {
    (0, _classCallCheck2.default)(this, TablePagination);
    return (0, _possibleConstructorReturn2.default)(this, (TablePagination.__proto__ || Object.getPrototypeOf(TablePagination)).apply(this, arguments));
  }

  (0, _createClass2.default)(TablePagination, [{
    key: "componentDidUpdate",
    // This logic would be better handled on userside.
    // However, we have it just in case.
    value: function componentDidUpdate() {
      var _props = this.props,
          count = _props.count,
          onChangePage = _props.onChangePage,
          page = _props.page,
          rowsPerPage = _props.rowsPerPage;
      var newLastPage = Math.max(0, Math.ceil(count / rowsPerPage) - 1);

      if (page > newLastPage) {
        onChangePage(null, newLastPage);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _props2 = this.props,
          ActionsComponent = _props2.ActionsComponent,
          backIconButtonProps = _props2.backIconButtonProps,
          classes = _props2.classes,
          colSpanProp = _props2.colSpan,
          Component = _props2.component,
          count = _props2.count,
          labelDisplayedRows = _props2.labelDisplayedRows,
          labelRowsPerPage = _props2.labelRowsPerPage,
          nextIconButtonProps = _props2.nextIconButtonProps,
          onChangePage = _props2.onChangePage,
          onChangeRowsPerPage = _props2.onChangeRowsPerPage,
          page = _props2.page,
          rowsPerPage = _props2.rowsPerPage,
          rowsPerPageOptions = _props2.rowsPerPageOptions,
          SelectProps = _props2.SelectProps,
          other = (0, _objectWithoutProperties2.default)(_props2, ["ActionsComponent", "backIconButtonProps", "classes", "colSpan", "component", "count", "labelDisplayedRows", "labelRowsPerPage", "nextIconButtonProps", "onChangePage", "onChangeRowsPerPage", "page", "rowsPerPage", "rowsPerPageOptions", "SelectProps"]);
      var colSpan;

      if (Component === _TableCell.default || Component === 'td') {
        colSpan = colSpanProp || 1000; // col-span over everything
      }

      return _react.default.createElement(Component, (0, _extends2.default)({
        className: classes.root,
        colSpan: colSpan
      }, other), _react.default.createElement(_Toolbar.default, {
        className: classes.toolbar
      }, _react.default.createElement("div", {
        className: classes.spacer
      }), rowsPerPageOptions.length > 1 && _react.default.createElement(_Typography.default, {
        variant: "caption",
        className: classes.caption
      }, labelRowsPerPage), rowsPerPageOptions.length > 1 && _react.default.createElement(_Select.default, (0, _extends2.default)({
        classes: {
          root: classes.selectRoot,
          select: classes.select,
          icon: classes.selectIcon
        },
        input: _react.default.createElement(_Input.default, {
          className: classes.input,
          disableUnderline: true
        }),
        value: rowsPerPage,
        onChange: onChangeRowsPerPage
      }, SelectProps), rowsPerPageOptions.map(function (rowsPerPageOption) {
        return _react.default.createElement(_MenuItem.default, {
          className: classes.menuItem,
          key: rowsPerPageOption,
          value: rowsPerPageOption
        }, rowsPerPageOption);
      })), _react.default.createElement(_Typography.default, {
        variant: "caption",
        className: classes.caption
      }, labelDisplayedRows({
        from: count === 0 ? 0 : page * rowsPerPage + 1,
        to: Math.min(count, (page + 1) * rowsPerPage),
        count: count,
        page: page
      })), _react.default.createElement(ActionsComponent, {
        className: classes.actions,
        backIconButtonProps: backIconButtonProps,
        count: count,
        nextIconButtonProps: nextIconButtonProps,
        onChangePage: onChangePage,
        page: page,
        rowsPerPage: rowsPerPage
      })));
    }
  }]);
  return TablePagination;
}(_react.default.Component);

TablePagination.propTypes =  false ? {
  /**
   * The component used for displaying the actions.
   * Either a string to use a DOM element or a component.
   */
  ActionsComponent: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func]),

  /**
   * Properties applied to the back arrow `IconButton` component.
   */
  backIconButtonProps: _propTypes.default.object,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  colSpan: _propTypes.default.number,

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func]),

  /**
   * The total number of rows.
   */
  count: _propTypes.default.number.isRequired,

  /**
   * Customize the displayed rows label.
   */
  labelDisplayedRows: _propTypes.default.func,

  /**
   * Customize the rows per page label. Invoked with a `{ from, to, count, page }`
   * object.
   */
  labelRowsPerPage: _propTypes.default.node,

  /**
   * Properties applied to the next arrow `IconButton` element.
   */
  nextIconButtonProps: _propTypes.default.object,

  /**
   * Callback fired when the page is changed.
   *
   * @param {object} event The event source of the callback
   * @param {number} page The page selected
   */
  onChangePage: _propTypes.default.func.isRequired,

  /**
   * Callback fired when the number of rows per page is changed.
   *
   * @param {object} event The event source of the callback
   */
  onChangeRowsPerPage: _propTypes.default.func,

  /**
   * The zero-based index of the current page.
   */
  page: _propTypes.default.number.isRequired,

  /**
   * The number of rows per page.
   */
  rowsPerPage: _propTypes.default.number.isRequired,

  /**
   * Customizes the options of the rows per page select field. If less than two options are
   * available, no select field will be displayed.
   */
  rowsPerPageOptions: _propTypes.default.array,

  /**
   * Properties applied to the rows per page `Select` element.
   */
  SelectProps: _propTypes.default.object
} : {};
TablePagination.defaultProps = {
  ActionsComponent: _TablePaginationActions.default,
  component: _TableCell.default,
  labelDisplayedRows: function labelDisplayedRows(_ref) {
    var from = _ref.from,
        to = _ref.to,
        count = _ref.count;
    return "".concat(from, "-").concat(to, " of ").concat(count);
  },
  labelRowsPerPage: 'Rows per page:',
  rowsPerPageOptions: [5, 10, 25]
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiTablePagination'
})(TablePagination);

exports.default = _default;

/***/ }),
/* 1065 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(8));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(11));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _objectSpread2 = _interopRequireDefault(__webpack_require__(23));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _classnames = _interopRequireDefault(__webpack_require__(6));

var _withStyles = _interopRequireDefault(__webpack_require__(5));

var styles = function styles(theme) {
  return {
    root: (0, _objectSpread2.default)({}, theme.mixins.toolbar, {
      position: 'relative',
      display: 'flex',
      alignItems: 'center'
    }),
    gutters: theme.mixins.gutters()
  };
};

exports.styles = styles;

function Toolbar(props) {
  var children = props.children,
      classes = props.classes,
      classNameProp = props.className,
      disableGutters = props.disableGutters,
      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "disableGutters"]);
  var className = (0, _classnames.default)(classes.root, (0, _defineProperty2.default)({}, classes.gutters, !disableGutters), classNameProp);
  return _react.default.createElement("div", (0, _extends2.default)({
    className: className
  }, other), children);
}

Toolbar.propTypes =  false ? {
  /**
   * Toolbar children, usually a mixture of `IconButton`, `Button` and `Typography`.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * If `true`, disables gutter padding.
   */
  disableGutters: _propTypes.default.bool
} : {};
Toolbar.defaultProps = {
  disableGutters: false
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiToolbar'
})(Toolbar);

exports.default = _default;

/***/ }),
/* 1066 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _TablePaginationActions.default;
  }
});

var _TablePaginationActions = _interopRequireDefault(__webpack_require__(1067));

/***/ }),
/* 1067 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(8));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(18));

var _createClass2 = _interopRequireDefault(__webpack_require__(19));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(20));

var _inherits2 = _interopRequireDefault(__webpack_require__(21));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _KeyboardArrowLeft = _interopRequireDefault(__webpack_require__(513));

var _KeyboardArrowRight = _interopRequireDefault(__webpack_require__(514));

var _withTheme = _interopRequireDefault(__webpack_require__(91));

var _IconButton = _interopRequireDefault(__webpack_require__(168));

var _ref2 = _react.default.createElement(_KeyboardArrowRight.default, null);

var _ref3 = _react.default.createElement(_KeyboardArrowLeft.default, null);

var _ref4 = _react.default.createElement(_KeyboardArrowLeft.default, null);

var _ref5 = _react.default.createElement(_KeyboardArrowRight.default, null);

/**
 * @ignore - internal component.
 */
var TablePaginationActions =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(TablePaginationActions, _React$Component);

  function TablePaginationActions() {
    var _ref;

    var _temp, _this;

    (0, _classCallCheck2.default)(this, TablePaginationActions);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return (0, _possibleConstructorReturn2.default)(_this, (_temp = _this = (0, _possibleConstructorReturn2.default)(this, (_ref = TablePaginationActions.__proto__ || Object.getPrototypeOf(TablePaginationActions)).call.apply(_ref, [this].concat(args))), _this.handleBackButtonClick = function (event) {
      _this.props.onChangePage(event, _this.props.page - 1);
    }, _this.handleNextButtonClick = function (event) {
      _this.props.onChangePage(event, _this.props.page + 1);
    }, _temp));
  }

  (0, _createClass2.default)(TablePaginationActions, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          backIconButtonProps = _props.backIconButtonProps,
          count = _props.count,
          nextIconButtonProps = _props.nextIconButtonProps,
          onChangePage = _props.onChangePage,
          page = _props.page,
          rowsPerPage = _props.rowsPerPage,
          theme = _props.theme,
          other = (0, _objectWithoutProperties2.default)(_props, ["backIconButtonProps", "count", "nextIconButtonProps", "onChangePage", "page", "rowsPerPage", "theme"]);
      return _react.default.createElement("div", other, _react.default.createElement(_IconButton.default, (0, _extends2.default)({
        onClick: this.handleBackButtonClick,
        disabled: page === 0
      }, backIconButtonProps), theme.direction === 'rtl' ? _ref2 : _ref3), _react.default.createElement(_IconButton.default, (0, _extends2.default)({
        onClick: this.handleNextButtonClick,
        disabled: page >= Math.ceil(count / rowsPerPage) - 1
      }, nextIconButtonProps), theme.direction === 'rtl' ? _ref4 : _ref5));
    }
  }]);
  return TablePaginationActions;
}(_react.default.Component);

TablePaginationActions.propTypes =  false ? {
  /**
   * Properties applied to the back arrow `IconButton` element.
   */
  backIconButtonProps: _propTypes.default.object,

  /**
   * The total number of rows.
   */
  count: _propTypes.default.number.isRequired,

  /**
   * Properties applied to the next arrow `IconButton` element.
   */
  nextIconButtonProps: _propTypes.default.object,

  /**
   * Callback fired when the page is changed.
   *
   * @param {object} event The event source of the callback
   * @param {number} page The page selected
   */
  onChangePage: _propTypes.default.func.isRequired,

  /**
   * The zero-based index of the current page.
   */
  page: _propTypes.default.number.isRequired,

  /**
   * The number of rows per page.
   */
  rowsPerPage: _propTypes.default.number.isRequired,

  /**
   * @ignore
   */
  theme: _propTypes.default.object.isRequired
} : {};

var _default = (0, _withTheme.default)()(TablePaginationActions);

exports.default = _default;

/***/ }),
/* 1068 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(8));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(11));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _classnames = _interopRequireDefault(__webpack_require__(6));

var _withStyles = _interopRequireDefault(__webpack_require__(5));

var styles = function styles(theme) {
  return {
    root: {
      color: 'inherit',
      display: 'table-row',
      height: 48,
      verticalAlign: 'middle',
      // We disable the focus ring for mouse, touch and keyboard users.
      outline: 'none',
      '&$selected': {
        backgroundColor: theme.palette.type === 'light' ? 'rgba(0, 0, 0, 0.04)' // grey[100]
        : 'rgba(255, 255, 255, 0.08)'
      },
      '&$hover:hover': {
        backgroundColor: theme.palette.type === 'light' ? 'rgba(0, 0, 0, 0.07)' // grey[200]
        : 'rgba(255, 255, 255, 0.14)'
      }
    },
    selected: {},
    hover: {},
    head: {
      height: 56
    },
    footer: {
      height: 56
    }
  };
};
/**
 * Will automatically set dynamic row height
 * based on the material table element parent (head, body, etc).
 */


exports.styles = styles;

function TableRow(props, context) {
  var _classNames;

  var classes = props.classes,
      classNameProp = props.className,
      Component = props.component,
      hover = props.hover,
      selected = props.selected,
      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "component", "hover", "selected"]);
  var table = context.table;
  var className = (0, _classnames.default)(classes.root, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes.head, table && table.head), (0, _defineProperty2.default)(_classNames, classes.footer, table && table.footer), (0, _defineProperty2.default)(_classNames, classes.hover, table && hover), (0, _defineProperty2.default)(_classNames, classes.selected, table && selected), _classNames), classNameProp);
  return _react.default.createElement(Component, (0, _extends2.default)({
    className: className
  }, other));
}

TableRow.propTypes =  false ? {
  /**
   * Should be valid <tr> children such as `TableCell`.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func]),

  /**
   * If `true`, the table row will shade on hover.
   */
  hover: _propTypes.default.bool,

  /**
   * If `true`, the table row will have the selected shading.
   */
  selected: _propTypes.default.bool
} : {};
TableRow.defaultProps = {
  component: 'tr',
  hover: false,
  selected: false
};
TableRow.contextTypes = {
  table: _propTypes.default.object
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiTableRow'
})(TableRow);

exports.default = _default;

/***/ }),
/* 1069 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(8));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(11));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _classnames = _interopRequireDefault(__webpack_require__(6));

var _ArrowDownward = _interopRequireDefault(__webpack_require__(1070));

var _withStyles = _interopRequireDefault(__webpack_require__(5));

var _ButtonBase = _interopRequireDefault(__webpack_require__(70));

var _helpers = __webpack_require__(36);

// @inheritedComponent ButtonBase
var styles = function styles(theme) {
  return {
    root: {
      cursor: 'pointer',
      display: 'inline-flex',
      justifyContent: 'flex-start',
      flexDirection: 'inherit',
      alignItems: 'center',
      '&:hover': {
        color: theme.palette.text.primary
      },
      '&:focus': {
        color: theme.palette.text.primary
      }
    },
    active: {
      color: theme.palette.text.primary,
      '& $icon': {
        opacity: 1
      }
    },
    icon: {
      height: 16,
      marginRight: 4,
      marginLeft: 4,
      opacity: 0,
      transition: theme.transitions.create(['opacity', 'transform'], {
        duration: theme.transitions.duration.shorter
      }),
      userSelect: 'none',
      width: 16
    },
    iconDirectionDesc: {
      transform: 'rotate(0deg)'
    },
    iconDirectionAsc: {
      transform: 'rotate(180deg)'
    }
  };
};
/**
 * A button based label for placing inside `TableCell` for column sorting.
 */


exports.styles = styles;

function TableSortLabel(props) {
  var active = props.active,
      classes = props.classes,
      className = props.className,
      children = props.children,
      direction = props.direction,
      other = (0, _objectWithoutProperties2.default)(props, ["active", "classes", "className", "children", "direction"]);
  return _react.default.createElement(_ButtonBase.default, (0, _extends2.default)({
    className: (0, _classnames.default)(classes.root, (0, _defineProperty2.default)({}, classes.active, active), className),
    component: "span",
    disableRipple: true
  }, other), children, _react.default.createElement(_ArrowDownward.default, {
    className: (0, _classnames.default)(classes.icon, classes["iconDirection".concat((0, _helpers.capitalize)(direction))])
  }));
}

TableSortLabel.propTypes =  false ? {
  /**
   * If `true`, the label will have the active styling (should be true for the sorted column).
   */
  active: _propTypes.default.bool,

  /**
   * Label contents, the arrow will be appended automatically.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The current sort direction.
   */
  direction: _propTypes.default.oneOf(['asc', 'desc'])
} : {};
TableSortLabel.defaultProps = {
  active: false,
  direction: 'desc'
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiTableSortLabel'
})(TableSortLabel);

exports.default = _default;

/***/ }),
/* 1070 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _pure = _interopRequireDefault(__webpack_require__(52));

var _SvgIcon = _interopRequireDefault(__webpack_require__(47));

var _ref = _react.default.createElement("path", {
  d: "M20 12l-1.41-1.41L13 16.17V4h-2v12.17l-5.58-5.59L4 12l8 8 8-8z"
});

/**
 * @ignore - internal component.
 */
var ArrowDownward = function ArrowDownward(props) {
  return _react.default.createElement(_SvgIcon.default, props, _ref);
};

ArrowDownward = (0, _pure.default)(ArrowDownward);
ArrowDownward.muiName = 'SvgIcon';
var _default = ArrowDownward;
exports.default = _default;

/***/ }),
/* 1071 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(8));

var _objectSpread2 = _interopRequireDefault(__webpack_require__(23));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(18));

var _createClass2 = _interopRequireDefault(__webpack_require__(19));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(20));

var _inherits2 = _interopRequireDefault(__webpack_require__(21));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(11));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _warning = _interopRequireDefault(__webpack_require__(32));

var _classnames = _interopRequireDefault(__webpack_require__(6));

var _reactEventListener = _interopRequireDefault(__webpack_require__(73));

var _debounce = _interopRequireDefault(__webpack_require__(93));

var _normalizeScrollLeft = __webpack_require__(1072);

var _scroll = _interopRequireDefault(__webpack_require__(1073));

var _ScrollbarSize = _interopRequireDefault(__webpack_require__(1076));

var _withStyles = _interopRequireDefault(__webpack_require__(5));

var _TabIndicator = _interopRequireDefault(__webpack_require__(1077));

var _TabScrollButton = _interopRequireDefault(__webpack_require__(1078));

var styles = function styles(theme) {
  return {
    root: {
      overflow: 'hidden',
      minHeight: 48,
      WebkitOverflowScrolling: 'touch' // Add iOS momentum scrolling.

    },
    flexContainer: {
      display: 'flex'
    },
    scroller: {
      position: 'relative',
      display: 'inline-block',
      flex: '1 1 auto',
      whiteSpace: 'nowrap'
    },
    fixed: {
      overflowX: 'hidden',
      width: '100%'
    },
    scrollable: {
      overflowX: 'scroll'
    },
    centered: {
      justifyContent: 'center'
    },
    scrollButtons: {},
    scrollButtonsAuto: (0, _defineProperty2.default)({}, theme.breakpoints.down('xs'), {
      display: 'none'
    }),
    indicator: {}
  };
};

exports.styles = styles;

var Tabs =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(Tabs, _React$Component);

  function Tabs() {
    var _ref;

    var _temp, _this;

    (0, _classCallCheck2.default)(this, Tabs);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return (0, _possibleConstructorReturn2.default)(_this, (_temp = _this = (0, _possibleConstructorReturn2.default)(this, (_ref = Tabs.__proto__ || Object.getPrototypeOf(Tabs)).call.apply(_ref, [this].concat(args))), _this.state = {
      indicatorStyle: {},
      scrollerStyle: {
        marginBottom: 0
      },
      showLeftScroll: false,
      showRightScroll: false,
      mounted: false
    }, _this.getConditionalElements = function () {
      var _this$props = _this.props,
          classes = _this$props.classes,
          scrollable = _this$props.scrollable,
          ScrollButtonComponent = _this$props.ScrollButtonComponent,
          scrollButtons = _this$props.scrollButtons,
          theme = _this$props.theme;
      var conditionalElements = {};
      conditionalElements.scrollbarSizeListener = scrollable ? _react.default.createElement(_ScrollbarSize.default, {
        onLoad: _this.handleScrollbarSizeChange,
        onChange: _this.handleScrollbarSizeChange
      }) : null;
      var showScrollButtons = scrollable && (scrollButtons === 'auto' || scrollButtons === 'on');
      conditionalElements.scrollButtonLeft = showScrollButtons ? _react.default.createElement(ScrollButtonComponent, {
        direction: theme && theme.direction === 'rtl' ? 'right' : 'left',
        onClick: _this.handleLeftScrollClick,
        visible: _this.state.showLeftScroll,
        className: (0, _classnames.default)(classes.scrollButtons, (0, _defineProperty2.default)({}, classes.scrollButtonsAuto, scrollButtons === 'auto'))
      }) : null;
      conditionalElements.scrollButtonRight = showScrollButtons ? _react.default.createElement(ScrollButtonComponent, {
        direction: theme && theme.direction === 'rtl' ? 'left' : 'right',
        onClick: _this.handleRightScrollClick,
        visible: _this.state.showRightScroll,
        className: (0, _classnames.default)(classes.scrollButtons, (0, _defineProperty2.default)({}, classes.scrollButtonsAuto, scrollButtons === 'auto'))
      }) : null;
      return conditionalElements;
    }, _this.getTabsMeta = function (value, direction) {
      var tabsMeta;

      if (_this.tabs) {
        var rect = _this.tabs.getBoundingClientRect(); // create a new object with ClientRect class props + scrollLeft


        tabsMeta = {
          clientWidth: _this.tabs ? _this.tabs.clientWidth : 0,
          scrollLeft: _this.tabs ? _this.tabs.scrollLeft : 0,
          scrollLeftNormalized: _this.tabs ? (0, _normalizeScrollLeft.getNormalizedScrollLeft)(_this.tabs, direction) : 0,
          scrollWidth: _this.tabs ? _this.tabs.scrollWidth : 0,
          left: rect.left,
          right: rect.right
        };
      }

      var tabMeta;

      if (_this.tabs && value !== false) {
        var children = _this.tabs.children[0].children;

        if (children.length > 0) {
          var tab = children[_this.valueToIndex[value]];
           false ? (0, _warning.default)(tab, "Material-UI: the value provided `".concat(value, "` is invalid")) : void 0;
          tabMeta = tab ? tab.getBoundingClientRect() : null;
        }
      }

      return {
        tabsMeta: tabsMeta,
        tabMeta: tabMeta
      };
    }, _this.tabs = undefined, _this.valueToIndex = {}, _this.handleResize = (0, _debounce.default)(function () {
      _this.updateIndicatorState(_this.props);

      _this.updateScrollButtonState();
    }, 166), _this.handleLeftScrollClick = function () {
      if (_this.tabs) {
        _this.moveTabsScroll(-_this.tabs.clientWidth);
      }
    }, _this.handleRightScrollClick = function () {
      if (_this.tabs) {
        _this.moveTabsScroll(_this.tabs.clientWidth);
      }
    }, _this.handleScrollbarSizeChange = function (_ref2) {
      var scrollbarHeight = _ref2.scrollbarHeight;

      _this.setState({
        scrollerStyle: {
          marginBottom: -scrollbarHeight
        }
      });
    }, _this.handleTabsScroll = (0, _debounce.default)(function () {
      _this.updateScrollButtonState();
    }, 166), _this.moveTabsScroll = function (delta) {
      var theme = _this.props.theme;

      if (_this.tabs) {
        var multiplier = theme.direction === 'rtl' ? -1 : 1;
        var nextScrollLeft = _this.tabs.scrollLeft + delta * multiplier; // Fix for Edge

        var invert = theme.direction === 'rtl' && (0, _normalizeScrollLeft.detectScrollType)() === 'reverse' ? -1 : 1;

        _scroll.default.left(_this.tabs, invert * nextScrollLeft);
      }
    }, _this.scrollSelectedIntoView = function () {
      var _this$props2 = _this.props,
          theme = _this$props2.theme,
          value = _this$props2.value;

      var _this$getTabsMeta = _this.getTabsMeta(value, theme.direction),
          tabsMeta = _this$getTabsMeta.tabsMeta,
          tabMeta = _this$getTabsMeta.tabMeta;

      if (!tabMeta || !tabsMeta) {
        return;
      }

      if (tabMeta.left < tabsMeta.left) {
        // left side of button is out of view
        var nextScrollLeft = tabsMeta.scrollLeft + (tabMeta.left - tabsMeta.left);

        _scroll.default.left(_this.tabs, nextScrollLeft);
      } else if (tabMeta.right > tabsMeta.right) {
        // right side of button is out of view
        var _nextScrollLeft = tabsMeta.scrollLeft + (tabMeta.right - tabsMeta.right);

        _scroll.default.left(_this.tabs, _nextScrollLeft);
      }
    }, _this.updateScrollButtonState = function () {
      var _this$props3 = _this.props,
          scrollable = _this$props3.scrollable,
          scrollButtons = _this$props3.scrollButtons,
          theme = _this$props3.theme;

      if (_this.tabs && scrollable && scrollButtons !== 'off') {
        var _this$tabs = _this.tabs,
            scrollWidth = _this$tabs.scrollWidth,
            clientWidth = _this$tabs.clientWidth;
        var scrollLeft = (0, _normalizeScrollLeft.getNormalizedScrollLeft)(_this.tabs, theme.direction);
        var showLeftScroll = theme.direction === 'rtl' ? scrollWidth > clientWidth + scrollLeft : scrollLeft > 0;
        var showRightScroll = theme.direction === 'rtl' ? scrollLeft > 0 : scrollWidth > clientWidth + scrollLeft;

        if (showLeftScroll !== _this.state.showLeftScroll || showRightScroll !== _this.state.showRightScroll) {
          _this.setState({
            showLeftScroll: showLeftScroll,
            showRightScroll: showRightScroll
          });
        }
      }
    }, _temp));
  }

  (0, _createClass2.default)(Tabs, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // eslint-disable-next-line react/no-did-mount-set-state
      this.setState({
        mounted: true
      });
      this.updateIndicatorState(this.props);
      this.updateScrollButtonState();

      if (this.props.action) {
        this.props.action({
          updateIndicator: this.handleResize
        });
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      this.updateScrollButtonState(); // The index might have changed at the same time.
      // We need to check again the right indicator position.

      this.updateIndicatorState(this.props);

      if (this.state.indicatorStyle !== prevState.indicatorStyle) {
        this.scrollSelectedIntoView();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.handleResize.clear();
      this.handleTabsScroll.clear();
    }
  }, {
    key: "updateIndicatorState",
    value: function updateIndicatorState(props) {
      var theme = props.theme,
          value = props.value;

      var _getTabsMeta = this.getTabsMeta(value, theme.direction),
          tabsMeta = _getTabsMeta.tabsMeta,
          tabMeta = _getTabsMeta.tabMeta;

      var left = 0;

      if (tabMeta && tabsMeta) {
        var correction = theme.direction === 'rtl' ? tabsMeta.scrollLeftNormalized + tabsMeta.clientWidth - tabsMeta.scrollWidth : tabsMeta.scrollLeft;
        left = tabMeta.left - tabsMeta.left + correction;
      }

      var indicatorStyle = {
        left: left,
        // May be wrong until the font is loaded.
        width: tabMeta ? tabMeta.width : 0
      };

      if ((indicatorStyle.left !== this.state.indicatorStyle.left || indicatorStyle.width !== this.state.indicatorStyle.width) && !Number.isNaN(indicatorStyle.left) && !Number.isNaN(indicatorStyle.width)) {
        this.setState({
          indicatorStyle: indicatorStyle
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _classNames3,
          _this2 = this;

      var _props = this.props,
          action = _props.action,
          centered = _props.centered,
          childrenProp = _props.children,
          classes = _props.classes,
          classNameProp = _props.className,
          fullWidth = _props.fullWidth,
          indicatorColor = _props.indicatorColor,
          onChange = _props.onChange,
          scrollable = _props.scrollable,
          ScrollButtonComponent = _props.ScrollButtonComponent,
          scrollButtons = _props.scrollButtons,
          _props$TabIndicatorPr = _props.TabIndicatorProps,
          TabIndicatorProps = _props$TabIndicatorPr === void 0 ? {} : _props$TabIndicatorPr,
          textColor = _props.textColor,
          theme = _props.theme,
          value = _props.value,
          other = (0, _objectWithoutProperties2.default)(_props, ["action", "centered", "children", "classes", "className", "fullWidth", "indicatorColor", "onChange", "scrollable", "ScrollButtonComponent", "scrollButtons", "TabIndicatorProps", "textColor", "theme", "value"]);
       false ? (0, _warning.default)(!centered || !scrollable, 'Material-UI: you can not use the `centered={true}` and `scrollable={true}` properties ' + 'at the same time on a `Tabs` component.') : void 0;
      var className = (0, _classnames.default)(classes.root, classNameProp);
      var scrollerClassName = (0, _classnames.default)(classes.scroller, (_classNames3 = {}, (0, _defineProperty2.default)(_classNames3, classes.fixed, !scrollable), (0, _defineProperty2.default)(_classNames3, classes.scrollable, scrollable), _classNames3));
      var flexContainerClassName = (0, _classnames.default)(classes.flexContainer, (0, _defineProperty2.default)({}, classes.centered, centered && !scrollable));

      var indicator = _react.default.createElement(_TabIndicator.default, (0, _extends2.default)({
        className: classes.indicator,
        color: indicatorColor
      }, TabIndicatorProps, {
        style: (0, _objectSpread2.default)({}, this.state.indicatorStyle, TabIndicatorProps.style)
      }));

      this.valueToIndex = {};
      var childIndex = 0;

      var children = _react.default.Children.map(childrenProp, function (child) {
        if (!_react.default.isValidElement(child)) {
          return null;
        }

        var childValue = child.props.value === undefined ? childIndex : child.props.value;
        _this2.valueToIndex[childValue] = childIndex;
        var selected = childValue === value;
        childIndex += 1;
        return _react.default.cloneElement(child, {
          fullWidth: fullWidth,
          indicator: selected && !_this2.state.mounted && indicator,
          selected: selected,
          onChange: onChange,
          textColor: textColor,
          value: childValue
        });
      });

      var conditionalElements = this.getConditionalElements();
      return _react.default.createElement("div", (0, _extends2.default)({
        className: className
      }, other), _react.default.createElement(_reactEventListener.default, {
        target: "window",
        onResize: this.handleResize
      }), conditionalElements.scrollbarSizeListener, _react.default.createElement("div", {
        className: classes.flexContainer
      }, conditionalElements.scrollButtonLeft, _react.default.createElement("div", {
        className: scrollerClassName,
        style: this.state.scrollerStyle,
        ref: function ref(node) {
          _this2.tabs = node;
        },
        role: "tablist",
        onScroll: this.handleTabsScroll
      }, _react.default.createElement("div", {
        className: flexContainerClassName
      }, children), this.state.mounted && indicator), conditionalElements.scrollButtonRight));
    }
  }]);
  return Tabs;
}(_react.default.Component);

Tabs.propTypes =  false ? {
  /**
   * Callback fired when the component mounts.
   * This is useful when you want to trigger an action programmatically.
   * It currently only supports `updateIndicator()` action.
   *
   * @param {object} actions This object contains all possible actions
   * that can be triggered programmatically.
   */
  action: _propTypes.default.func,

  /**
   * If `true`, the tabs will be centered.
   * This property is intended for large views.
   */
  centered: _propTypes.default.bool,

  /**
   * The content of the component.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * If `true`, the tabs will grow to use all the available space.
   * This property is intended for small views, like on mobile.
   */
  fullWidth: _propTypes.default.bool,

  /**
   * Determines the color of the indicator.
   */
  indicatorColor: _propTypes.default.oneOf(['secondary', 'primary']),

  /**
   * Callback fired when the value changes.
   *
   * @param {object} event The event source of the callback
   * @param {number} value We default to the index of the child
   */
  onChange: _propTypes.default.func,

  /**
   * True invokes scrolling properties and allow for horizontally scrolling
   * (or swiping) the tab bar.
   */
  scrollable: _propTypes.default.bool,

  /**
   * The component used to render the scroll buttons.
   */
  ScrollButtonComponent: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func]),

  /**
   * Determine behavior of scroll buttons when tabs are set to scroll
   * `auto` will only present them on medium and larger viewports
   * `on` will always present them
   * `off` will never present them
   */
  scrollButtons: _propTypes.default.oneOf(['auto', 'on', 'off']),

  /**
   * Properties applied to the `TabIndicator` element.
   */
  TabIndicatorProps: _propTypes.default.object,

  /**
   * Determines the color of the `Tab`.
   */
  textColor: _propTypes.default.oneOf(['secondary', 'primary', 'inherit']),

  /**
   * @ignore
   */
  theme: _propTypes.default.object.isRequired,

  /**
   * The value of the currently selected `Tab`.
   * If you don't want any selected `Tab`, you can set this property to `false`.
   */
  value: _propTypes.default.any
} : {};
Tabs.defaultProps = {
  centered: false,
  fullWidth: false,
  indicatorColor: 'secondary',
  scrollable: false,
  ScrollButtonComponent: _TabScrollButton.default,
  scrollButtons: 'auto',
  textColor: 'inherit'
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiTabs',
  withTheme: true
})(Tabs);

exports.default = _default;

/***/ }),
/* 1072 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
// Based on https://github.com/react-bootstrap/dom-helpers/blob/master/src/util/inDOM.js
var inDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
var cachedType;
function _setScrollType(type) {
    cachedType = type;
}
exports._setScrollType = _setScrollType;
// Based on the jquery plugin https://github.com/othree/jquery.rtl-scroll-type
function detectScrollType() {
    if (cachedType) {
        return cachedType;
    }
    if (!inDOM || !window.document.body) {
        return 'indeterminate';
    }
    var dummy = window.document.createElement('div');
    dummy.appendChild(document.createTextNode('ABCD'));
    dummy.dir = 'rtl';
    dummy.style.fontSize = '14px';
    dummy.style.width = '4px';
    dummy.style.height = '1px';
    dummy.style.position = 'absolute';
    dummy.style.top = '-1000px';
    dummy.style.overflow = 'scroll';
    document.body.appendChild(dummy);
    cachedType = 'reverse';
    if (dummy.scrollLeft > 0) {
        cachedType = 'default';
    }
    else {
        dummy.scrollLeft = 1;
        if (dummy.scrollLeft === 0) {
            cachedType = 'negative';
        }
    }
    document.body.removeChild(dummy);
    return cachedType;
}
exports.detectScrollType = detectScrollType;
// Based on https://stackoverflow.com/a/24394376
function getNormalizedScrollLeft(element, direction) {
    var scrollLeft = element.scrollLeft;
    // Perform the calculations only when direction is rtl to avoid messing up the ltr bahavior
    if (direction !== 'rtl') {
        return scrollLeft;
    }
    var type = detectScrollType();
    if (type === 'indeterminate') {
        return Number.NaN;
    }
    switch (type) {
        case 'negative':
            return element.scrollWidth - element.clientWidth + scrollLeft;
        case 'reverse':
            return element.scrollWidth - element.clientWidth - scrollLeft;
    }
    return scrollLeft;
}
exports.getNormalizedScrollLeft = getNormalizedScrollLeft;
function setNormalizedScrollLeft(element, scrollLeft, direction) {
    // Perform the calculations only when direction is rtl to avoid messing up the ltr bahavior
    if (direction !== 'rtl') {
        element.scrollLeft = scrollLeft;
        return;
    }
    var type = detectScrollType();
    if (type === 'indeterminate') {
        return;
    }
    switch (type) {
        case 'negative':
            element.scrollLeft = element.clientWidth - element.scrollWidth + scrollLeft;
            break;
        case 'reverse':
            element.scrollLeft = element.scrollWidth - element.clientWidth - scrollLeft;
            break;
        default:
            element.scrollLeft = scrollLeft;
            break;
    }
}
exports.setNormalizedScrollLeft = setNormalizedScrollLeft;


/***/ }),
/* 1073 */
/***/ (function(module, exports, __webpack_require__) {

var raf = __webpack_require__(1074)
var E_NOSCROLL = new Error('Element already at target scroll position')
var E_CANCELLED = new Error('Scroll cancelled')
var min = Math.min

module.exports = {
  left: make('scrollLeft'),
  top: make('scrollTop')
}

function make (prop) {
  return function scroll (el, to, opts, cb) {
    opts = opts || {}

    if (typeof opts == 'function') cb = opts, opts = {}
    if (typeof cb != 'function') cb = noop

    var start = +new Date
    var from = el[prop]
    var ease = opts.ease || inOutSine
    var duration = !isNaN(opts.duration) ? +opts.duration : 350
    var cancelled = false

    return from === to ?
      cb(E_NOSCROLL, el[prop]) :
      raf(animate), cancel

    function cancel () {
      cancelled = true
    }

    function animate (timestamp) {
      if (cancelled) return cb(E_CANCELLED, el[prop])

      var now = +new Date
      var time = min(1, ((now - start) / duration))
      var eased = ease(time)

      el[prop] = (eased * (to - from)) + from

      time < 1 ? raf(animate) : raf(function () {
        cb(null, el[prop])
      })
    }
  }
}

function inOutSine (n) {
  return 0.5 * (1 - Math.cos(Math.PI * n))
}

function noop () {}


/***/ }),
/* 1074 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(1075)

/**
 * `requestAnimationFrame()`
 */

var request = global.requestAnimationFrame
  || global.webkitRequestAnimationFrame
  || global.mozRequestAnimationFrame
  || fallback

var prev = +new Date
function fallback (fn) {
  var curr = +new Date
  var ms = Math.max(0, 16 - (curr - prev))
  var req = setTimeout(fn, ms)
  return prev = curr, req
}

/**
 * `cancelAnimationFrame()`
 */

var cancel = global.cancelAnimationFrame
  || global.webkitCancelAnimationFrame
  || global.mozCancelAnimationFrame
  || clearTimeout

if (Function.prototype.bind) {
  request = request.bind(global)
  cancel = cancel.bind(global)
}

exports = module.exports = request
exports.cancel = cancel


/***/ }),
/* 1075 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var win;

if (typeof window !== "undefined") {
    win = window;
} else if (typeof global !== "undefined") {
    win = global;
} else if (typeof self !== "undefined"){
    win = self;
} else {
    win = {};
}

module.exports = win;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(26)))

/***/ }),
/* 1076 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(18));

var _createClass2 = _interopRequireDefault(__webpack_require__(19));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(20));

var _inherits2 = _interopRequireDefault(__webpack_require__(21));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _reactEventListener = _interopRequireDefault(__webpack_require__(73));

var _debounce = _interopRequireDefault(__webpack_require__(93));

var styles = {
  width: '100px',
  height: '100px',
  position: 'absolute',
  top: '-10000px',
  overflow: 'scroll',
  msOverflowStyle: 'scrollbar'
};
/**
 * @ignore - internal component.
 * The component is originates from https://github.com/STORIS/react-scrollbar-size.
 * It has been moved into the core in order to minimize the bundle size.
 */

var ScrollbarSize =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(ScrollbarSize, _React$Component);

  function ScrollbarSize() {
    var _ref;

    var _temp, _this;

    (0, _classCallCheck2.default)(this, ScrollbarSize);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return (0, _possibleConstructorReturn2.default)(_this, (_temp = _this = (0, _possibleConstructorReturn2.default)(this, (_ref = ScrollbarSize.__proto__ || Object.getPrototypeOf(ScrollbarSize)).call.apply(_ref, [this].concat(args))), _this.setMeasurements = function () {
      if (!_this.node) {
        return;
      }

      _this.scrollbarHeight = _this.node.offsetHeight - _this.node.clientHeight;
      _this.scrollbarWidth = _this.node.offsetWidth - _this.node.clientWidth;
    }, _this.handleResize = (0, _debounce.default)(function () {
      var onChange = _this.props.onChange;
      var prevHeight = _this.scrollbarHeight;
      var prevWidth = _this.scrollbarWidth;

      _this.setMeasurements();

      if (prevHeight !== _this.scrollbarHeight || prevWidth !== _this.scrollbarWidth) {
        onChange({
          scrollbarHeight: _this.scrollbarHeight,
          scrollbarWidth: _this.scrollbarWidth
        });
      }
    }, 166), _temp));
  }

  (0, _createClass2.default)(ScrollbarSize, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setMeasurements();
      this.props.onLoad({
        scrollbarHeight: this.scrollbarHeight,
        scrollbarWidth: this.scrollbarWidth
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.handleResize.clear();
    }
  }, {
    key: "render",
    // Corresponds to 10 frames at 60 Hz.
    value: function render() {
      var _this2 = this;

      var onChange = this.props.onChange;
      return _react.default.createElement("div", null, onChange ? _react.default.createElement(_reactEventListener.default, {
        target: "window",
        onResize: this.handleResize
      }) : null, _react.default.createElement("div", {
        style: styles,
        ref: function ref(node) {
          _this2.node = node;
        }
      }));
    }
  }]);
  return ScrollbarSize;
}(_react.default.Component);

ScrollbarSize.propTypes =  false ? {
  onChange: _propTypes.default.func.isRequired,
  onLoad: _propTypes.default.func.isRequired
} : {};
var _default = ScrollbarSize;
exports.default = _default;

/***/ }),
/* 1077 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(8));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _classnames = _interopRequireDefault(__webpack_require__(6));

var _withStyles = _interopRequireDefault(__webpack_require__(5));

var _helpers = __webpack_require__(36);

var styles = function styles(theme) {
  return {
    root: {
      position: 'absolute',
      height: 2,
      bottom: 0,
      width: '100%',
      transition: theme.transitions.create(),
      willChange: 'left, width'
    },
    colorPrimary: {
      backgroundColor: theme.palette.primary.main
    },
    colorSecondary: {
      backgroundColor: theme.palette.secondary.main
    }
  };
};
/**
 * @ignore - internal component.
 */


exports.styles = styles;

function TabIndicator(props) {
  var classes = props.classes,
      className = props.className,
      color = props.color,
      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "color"]);
  return _react.default.createElement("span", (0, _extends2.default)({
    className: (0, _classnames.default)(classes.root, classes["color".concat((0, _helpers.capitalize)(color))], className)
  }, other));
}

TabIndicator.propTypes =  false ? {
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * @ignore
   * The color of the tab indicator.
   */
  color: _propTypes.default.oneOf(['primary', 'secondary'])
} : {};

var _default = (0, _withStyles.default)(styles)(TabIndicator);

exports.default = _default;

/***/ }),
/* 1078 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(8));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _classnames = _interopRequireDefault(__webpack_require__(6));

var _KeyboardArrowLeft = _interopRequireDefault(__webpack_require__(513));

var _KeyboardArrowRight = _interopRequireDefault(__webpack_require__(514));

var _withStyles = _interopRequireDefault(__webpack_require__(5));

var _ButtonBase = _interopRequireDefault(__webpack_require__(70));

var styles = function styles(theme) {
  return {
    root: {
      color: 'inherit',
      flex: "0 0 ".concat(theme.spacing.unit * 7, "px")
    }
  };
};
/**
 * @ignore - internal component.
 */


exports.styles = styles;

var _ref = _react.default.createElement(_KeyboardArrowLeft.default, null);

var _ref2 = _react.default.createElement(_KeyboardArrowRight.default, null);

function TabScrollButton(props) {
  var classes = props.classes,
      classNameProp = props.className,
      direction = props.direction,
      onClick = props.onClick,
      visible = props.visible,
      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "direction", "onClick", "visible"]);
  var className = (0, _classnames.default)(classes.root, classNameProp);

  if (!visible) {
    return _react.default.createElement("div", {
      className: className
    });
  }

  return _react.default.createElement(_ButtonBase.default, (0, _extends2.default)({
    className: className,
    onClick: onClick,
    tabIndex: -1
  }, other), direction === 'left' ? _ref : _ref2);
}

TabScrollButton.propTypes =  false ? {
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * Which direction should the button indicate?
   */
  direction: _propTypes.default.oneOf(['left', 'right']),

  /**
   * Callback to execute for button press.
   */
  onClick: _propTypes.default.func,

  /**
   * Should the button be present or just consume space.
   */
  visible: _propTypes.default.bool
} : {};
TabScrollButton.defaultProps = {
  visible: true
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiTabScrollButton'
})(TabScrollButton);

exports.default = _default;

/***/ }),
/* 1079 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(8));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(18));

var _createClass2 = _interopRequireDefault(__webpack_require__(19));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(20));

var _inherits2 = _interopRequireDefault(__webpack_require__(21));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(11));

var _objectSpread3 = _interopRequireDefault(__webpack_require__(23));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _classnames = _interopRequireDefault(__webpack_require__(6));

var _withStyles = _interopRequireDefault(__webpack_require__(5));

var _ButtonBase = _interopRequireDefault(__webpack_require__(70));

var _helpers = __webpack_require__(36);

// @inheritedComponent ButtonBase
var styles = function styles(theme) {
  return {
    root: (0, _objectSpread3.default)({}, theme.typography.button, (0, _defineProperty2.default)({
      maxWidth: 264,
      position: 'relative',
      minWidth: 72,
      padding: 0,
      height: 48,
      flex: 'none',
      overflow: 'hidden'
    }, theme.breakpoints.up('md'), {
      minWidth: 160
    })),
    labelIcon: {
      height: 72
    },
    textColorInherit: {
      color: 'inherit',
      opacity: 0.7,
      '&$selected': {
        opacity: 1
      },
      '&$disabled': {
        opacity: 0.4
      }
    },
    textColorPrimary: {
      color: theme.palette.text.secondary,
      '&$selected': {
        color: theme.palette.primary.main
      },
      '&$disabled': {
        color: theme.palette.text.disabled
      }
    },
    textColorSecondary: {
      color: theme.palette.text.secondary,
      '&$selected': {
        color: theme.palette.secondary.main
      },
      '&$disabled': {
        color: theme.palette.text.disabled
      }
    },
    selected: {},
    disabled: {},
    fullWidth: {
      flexGrow: 1
    },
    wrapper: {
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '100%',
      flexDirection: 'column'
    },
    labelContainer: (0, _defineProperty2.default)({
      paddingTop: 6,
      paddingBottom: 6,
      paddingLeft: 12,
      paddingRight: 12
    }, theme.breakpoints.up('md'), {
      paddingLeft: theme.spacing.unit * 3,
      paddingRight: theme.spacing.unit * 3
    }),
    label: (0, _defineProperty2.default)({
      fontSize: theme.typography.pxToRem(14),
      whiteSpace: 'normal'
    }, theme.breakpoints.up('md'), {
      fontSize: theme.typography.pxToRem(13)
    }),
    labelWrapped: (0, _defineProperty2.default)({}, theme.breakpoints.down('sm'), {
      fontSize: theme.typography.pxToRem(12)
    })
  };
};

exports.styles = styles;

var Tab =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(Tab, _React$Component);

  function Tab() {
    var _ref;

    var _temp, _this;

    (0, _classCallCheck2.default)(this, Tab);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return (0, _possibleConstructorReturn2.default)(_this, (_temp = _this = (0, _possibleConstructorReturn2.default)(this, (_ref = Tab.__proto__ || Object.getPrototypeOf(Tab)).call.apply(_ref, [this].concat(args))), _this.state = {
      labelWrapped: false
    }, _this.handleChange = function (event) {
      var _this$props = _this.props,
          onChange = _this$props.onChange,
          value = _this$props.value,
          onClick = _this$props.onClick;

      if (onChange) {
        onChange(event, value);
      }

      if (onClick) {
        onClick(event);
      }
    }, _this.label = undefined, _this.checkTextWrap = function () {
      if (_this.label) {
        var labelWrapped = _this.label.getClientRects().length > 1;

        if (_this.state.labelWrapped !== labelWrapped) {
          _this.setState({
            labelWrapped: labelWrapped
          });
        }
      }
    }, _temp));
  }

  (0, _createClass2.default)(Tab, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.checkTextWrap();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.state.labelWrapped === prevState.labelWrapped) {
        /**
         * At certain text and tab lengths, a larger font size may wrap to two lines while the smaller
         * font size still only requires one line.  This check will prevent an infinite render loop
         * fron occurring in that scenario.
         */
        this.checkTextWrap();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this,
          _classNames2;

      var _props = this.props,
          classes = _props.classes,
          classNameProp = _props.className,
          disabled = _props.disabled,
          fullWidth = _props.fullWidth,
          icon = _props.icon,
          indicator = _props.indicator,
          labelProp = _props.label,
          onChange = _props.onChange,
          selected = _props.selected,
          textColor = _props.textColor,
          value = _props.value,
          other = (0, _objectWithoutProperties2.default)(_props, ["classes", "className", "disabled", "fullWidth", "icon", "indicator", "label", "onChange", "selected", "textColor", "value"]);
      var label;

      if (labelProp !== undefined) {
        label = _react.default.createElement("span", {
          className: classes.labelContainer
        }, _react.default.createElement("span", {
          className: (0, _classnames.default)(classes.label, (0, _defineProperty2.default)({}, classes.labelWrapped, this.state.labelWrapped)),
          ref: function ref(node) {
            _this2.label = node;
          }
        }, labelProp));
      }

      var className = (0, _classnames.default)(classes.root, classes["textColor".concat((0, _helpers.capitalize)(textColor))], (_classNames2 = {}, (0, _defineProperty2.default)(_classNames2, classes.disabled, disabled), (0, _defineProperty2.default)(_classNames2, classes.selected, selected), (0, _defineProperty2.default)(_classNames2, classes.labelIcon, icon && label), (0, _defineProperty2.default)(_classNames2, classes.fullWidth, fullWidth), _classNames2), classNameProp);
      return _react.default.createElement(_ButtonBase.default, (0, _extends2.default)({
        focusRipple: true,
        className: className,
        role: "tab",
        "aria-selected": selected,
        disabled: disabled
      }, other, {
        onClick: this.handleChange
      }), _react.default.createElement("span", {
        className: classes.wrapper
      }, icon, label), indicator);
    }
  }]);
  return Tab;
}(_react.default.Component);

Tab.propTypes =  false ? {
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * If `true`, the tab will be disabled.
   */
  disabled: _propTypes.default.bool,

  /**
   * @ignore
   */
  fullWidth: _propTypes.default.bool,

  /**
   * The icon element.
   */
  icon: _propTypes.default.node,

  /**
   * @ignore
   * For server side rendering consideration, we let the selected tab
   * render the indicator.
   */
  indicator: _propTypes.default.node,

  /**
   * The label element.
   */
  label: _propTypes.default.node,

  /**
   * @ignore
   */
  onChange: _propTypes.default.func,

  /**
   * @ignore
   */
  onClick: _propTypes.default.func,

  /**
   * @ignore
   */
  selected: _propTypes.default.bool,

  /**
   * @ignore
   */
  textColor: _propTypes.default.oneOf(['secondary', 'primary', 'inherit']),

  /**
   * You can provide your own value. Otherwise, we fallback to the child position index.
   */
  value: _propTypes.default.any
} : {};
Tab.defaultProps = {
  disabled: false,
  textColor: 'inherit'
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiTab'
})(Tab);

exports.default = _default;

/***/ }),
/* 1080 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _TextField.default;
  }
});

var _TextField = _interopRequireDefault(__webpack_require__(1081));

/***/ }),
/* 1081 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(8));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _react = _interopRequireDefault(__webpack_require__(0));

var _warning = _interopRequireDefault(__webpack_require__(32));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _Input = _interopRequireDefault(__webpack_require__(171));

var _InputLabel = _interopRequireDefault(__webpack_require__(498));

var _FormControl = _interopRequireDefault(__webpack_require__(493));

var _FormHelperText = _interopRequireDefault(__webpack_require__(495));

var _Select = _interopRequireDefault(__webpack_require__(329));

// @inheritedComponent FormControl

/**
 * The `TextField` is a convenience wrapper for the most common cases (80%).
 * It cannot be all things to all people, otherwise the API would grow out of control.
 *
 * ## Advanced Configuration
 *
 * It's important to understand that the text field is a simple abstraction
 * on top of the following components:
 * - [FormControl](/api/form-control)
 * - [InputLabel](/api/input-label)
 * - [Input](/api/input)
 * - [FormHelperText](/api/form-helper-text)
 *
 * If you wish to alter the properties applied to the native input, you can do so as follows:
 *
 * ```jsx
 * const inputProps = {
 *   step: 300,
 * };
 *
 * return <TextField id="time" type="time" inputProps={inputProps} />;
 * ```
 *
 * For advanced cases, please look at the source of TextField by clicking on the
 * "Edit this page" button above. Consider either:
 * - using the upper case props for passing values directly to the components
 * - using the underlying components directly as shown in the demos
 */
function TextField(props) {
  var autoComplete = props.autoComplete,
      autoFocus = props.autoFocus,
      children = props.children,
      className = props.className,
      defaultValue = props.defaultValue,
      disabled = props.disabled,
      error = props.error,
      FormHelperTextProps = props.FormHelperTextProps,
      fullWidth = props.fullWidth,
      helperText = props.helperText,
      id = props.id,
      InputLabelProps = props.InputLabelProps,
      inputProps = props.inputProps,
      InputProps = props.InputProps,
      inputRef = props.inputRef,
      label = props.label,
      multiline = props.multiline,
      name = props.name,
      onBlur = props.onBlur,
      onChange = props.onChange,
      onFocus = props.onFocus,
      placeholder = props.placeholder,
      required = props.required,
      rows = props.rows,
      rowsMax = props.rowsMax,
      select = props.select,
      SelectProps = props.SelectProps,
      type = props.type,
      value = props.value,
      other = (0, _objectWithoutProperties2.default)(props, ["autoComplete", "autoFocus", "children", "className", "defaultValue", "disabled", "error", "FormHelperTextProps", "fullWidth", "helperText", "id", "InputLabelProps", "inputProps", "InputProps", "inputRef", "label", "multiline", "name", "onBlur", "onChange", "onFocus", "placeholder", "required", "rows", "rowsMax", "select", "SelectProps", "type", "value"]);
   false ? (0, _warning.default)(!select || Boolean(children), 'Material-UI: `children` must be passed when using the `TextField` component with `select`.') : void 0;
  var helperTextId = helperText && id ? "".concat(id, "-helper-text") : undefined;

  var InputElement = _react.default.createElement(_Input.default, (0, _extends2.default)({
    autoComplete: autoComplete,
    autoFocus: autoFocus,
    defaultValue: defaultValue,
    disabled: disabled,
    fullWidth: fullWidth,
    multiline: multiline,
    name: name,
    rows: rows,
    rowsMax: rowsMax,
    type: type,
    value: value,
    id: id,
    inputRef: inputRef,
    onBlur: onBlur,
    onChange: onChange,
    onFocus: onFocus,
    placeholder: placeholder,
    inputProps: inputProps
  }, InputProps));

  return _react.default.createElement(_FormControl.default, (0, _extends2.default)({
    "aria-describedby": helperTextId,
    className: className,
    error: error,
    fullWidth: fullWidth,
    required: required
  }, other), label && _react.default.createElement(_InputLabel.default, (0, _extends2.default)({
    htmlFor: id
  }, InputLabelProps), label), select ? _react.default.createElement(_Select.default, (0, _extends2.default)({
    value: value,
    input: InputElement
  }, SelectProps), children) : InputElement, helperText && _react.default.createElement(_FormHelperText.default, (0, _extends2.default)({
    id: helperTextId
  }, FormHelperTextProps), helperText));
}

TextField.propTypes =  false ? {
  /**
   * This property helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it here:
   * https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill
   */
  autoComplete: _propTypes.default.string,

  /**
   * If `true`, the input will be focused during the first mount.
   */
  autoFocus: _propTypes.default.bool,

  /**
   * @ignore
   */
  children: _propTypes.default.node,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The default value of the `Input` element.
   */
  defaultValue: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),

  /**
   * If `true`, the input will be disabled.
   */
  disabled: _propTypes.default.bool,

  /**
   * If `true`, the label will be displayed in an error state.
   */
  error: _propTypes.default.bool,

  /**
   * Properties applied to the `FormHelperText` element.
   */
  FormHelperTextProps: _propTypes.default.object,

  /**
   * If `true`, the input will take up the full width of its container.
   */
  fullWidth: _propTypes.default.bool,

  /**
   * The helper text content.
   */
  helperText: _propTypes.default.node,

  /**
   * The id of the `input` element.
   * Use that property to make `label` and `helperText` accessible for screen readers.
   */
  id: _propTypes.default.string,

  /**
   * Properties applied to the `InputLabel` element.
   */
  InputLabelProps: _propTypes.default.object,

  /**
   * Properties applied to the `Input` element.
   */
  InputProps: _propTypes.default.object,

  /**
   * Properties applied to the native `input` element.
   */
  inputProps: _propTypes.default.object,

  /**
   * Use that property to pass a ref callback to the native input component.
   */
  inputRef: _propTypes.default.func,

  /**
   * The label content.
   */
  label: _propTypes.default.node,

  /**
   * If `dense` or `normal`, will adjust vertical spacing of this and contained components.
   */
  margin: _propTypes.default.oneOf(['none', 'dense', 'normal']),

  /**
   * If `true`, a textarea element will be rendered instead of an input.
   */
  multiline: _propTypes.default.bool,

  /**
   * Name attribute of the `input` element.
   */
  name: _propTypes.default.string,

  /**
   * @ignore
   */
  onBlur: _propTypes.default.func,

  /**
   * Callback fired when the value is changed.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value`.
   */
  onChange: _propTypes.default.func,

  /**
   * @ignore
   */
  onFocus: _propTypes.default.func,

  /**
   * The short hint displayed in the input before the user enters a value.
   */
  placeholder: _propTypes.default.string,

  /**
   * If `true`, the label is displayed as required.
   */
  required: _propTypes.default.bool,

  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),

  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  rowsMax: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),

  /**
   * Render a `Select` element while passing the `Input` element to `Select` as `input` parameter.
   * If this option is set you must pass the options of the select as children.
   */
  select: _propTypes.default.bool,

  /**
   * Properties applied to the `Select` element.
   */
  SelectProps: _propTypes.default.object,

  /**
   * Type attribute of the `Input` element. It should be a valid HTML5 input type.
   */
  type: _propTypes.default.string,

  /**
   * The value of the `Input` element, required for a controlled component.
   */
  value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number, _propTypes.default.arrayOf(_propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]))])
} : {};
TextField.defaultProps = {
  required: false,
  select: false
};
var _default = TextField;
exports.default = _default;

/***/ }),
/* 1082 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(8));

var _objectSpread2 = _interopRequireDefault(__webpack_require__(23));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(18));

var _createClass2 = _interopRequireDefault(__webpack_require__(19));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(20));

var _inherits2 = _interopRequireDefault(__webpack_require__(21));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(11));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _reactEventListener = _interopRequireDefault(__webpack_require__(73));

var _debounce = _interopRequireDefault(__webpack_require__(93));

var _warning = _interopRequireDefault(__webpack_require__(32));

var _classnames = _interopRequireDefault(__webpack_require__(6));

var _reactPopper = __webpack_require__(1083);

var _helpers = __webpack_require__(36);

var _RootRef = _interopRequireDefault(__webpack_require__(488));

var _Portal = _interopRequireDefault(__webpack_require__(322));

var _common = _interopRequireDefault(__webpack_require__(305));

var _withStyles = _interopRequireDefault(__webpack_require__(5));

/* eslint-disable react/no-multi-comp, no-underscore-dangle */
var styles = function styles(theme) {
  return {
    popper: {
      zIndex: theme.zIndex.tooltip,
      pointerEvents: 'none',
      '&$open': {
        pointerEvents: 'auto'
      }
    },
    open: {},
    tooltip: {
      backgroundColor: theme.palette.grey[700],
      borderRadius: 2,
      color: _common.default.white,
      fontFamily: theme.typography.fontFamily,
      opacity: 0,
      transform: 'scale(0)',
      transition: theme.transitions.create(['opacity', 'transform'], {
        duration: theme.transitions.duration.shortest,
        easing: theme.transitions.easing.easeIn
      }),
      minHeight: 0,
      padding: "".concat(theme.spacing.unit / 2, "px ").concat(theme.spacing.unit, "px"),
      fontSize: theme.typography.pxToRem(10),
      lineHeight: "".concat(theme.typography.round(14 / 10), "em"),
      '&$open': {
        opacity: 0.9,
        transform: 'scale(1)',
        transition: theme.transitions.create(['opacity', 'transform'], {
          duration: theme.transitions.duration.shortest,
          easing: theme.transitions.easing.easeOut
        })
      }
    },
    touch: {
      padding: "".concat(theme.spacing.unit, "px ").concat(theme.spacing.unit * 2, "px"),
      fontSize: theme.typography.pxToRem(14),
      lineHeight: "".concat(theme.typography.round(16 / 14), "em")
    },
    tooltipPlacementLeft: (0, _defineProperty2.default)({
      transformOrigin: 'right center',
      margin: "0 ".concat(theme.spacing.unit * 3, "px")
    }, theme.breakpoints.up('sm'), {
      margin: '0 14px'
    }),
    tooltipPlacementRight: (0, _defineProperty2.default)({
      transformOrigin: 'left center',
      margin: "0 ".concat(theme.spacing.unit * 3, "px")
    }, theme.breakpoints.up('sm'), {
      margin: '0 14px'
    }),
    tooltipPlacementTop: (0, _defineProperty2.default)({
      transformOrigin: 'center bottom',
      margin: "".concat(theme.spacing.unit * 3, "px 0")
    }, theme.breakpoints.up('sm'), {
      margin: '14px 0'
    }),
    tooltipPlacementBottom: (0, _defineProperty2.default)({
      transformOrigin: 'center top',
      margin: "".concat(theme.spacing.unit * 3, "px 0")
    }, theme.breakpoints.up('sm'), {
      margin: '14px 0'
    })
  };
};

exports.styles = styles;

function flipPlacement(placement) {
  switch (placement) {
    case 'bottom-end':
      return 'bottom-start';

    case 'bottom-start':
      return 'bottom-end';

    case 'top-end':
      return 'top-start';

    case 'top-start':
      return 'top-end';

    default:
      return placement;
  }
}

var Tooltip =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(Tooltip, _React$Component);

  function Tooltip(props) {
    var _this;

    (0, _classCallCheck2.default)(this, Tooltip);
    _this = (0, _possibleConstructorReturn2.default)(this, (Tooltip.__proto__ || Object.getPrototypeOf(Tooltip)).call(this, props));
    _this.state = {};
    _this.enterTimer = null;
    _this.leaveTimer = null;
    _this.touchTimer = null;
    _this.closeTimer = null;
    _this.isControlled = null;
    _this.popper = null;
    _this.children = null;
    _this.ignoreNonTouchEvents = false;
    _this.handleResize = (0, _debounce.default)(function () {
      if (_this.popper) {
        _this.popper._popper.scheduleUpdate();
      }
    }, 166);

    _this.handleEnter = function (event) {
      var _this$props = _this.props,
          children = _this$props.children,
          enterDelay = _this$props.enterDelay;
      var childrenProps = children.props;

      if (event.type === 'focus' && childrenProps.onFocus) {
        childrenProps.onFocus(event);
      }

      if (event.type === 'mouseover' && childrenProps.onMouseOver) {
        childrenProps.onMouseOver(event);
      }

      if (_this.ignoreNonTouchEvents && event.type !== 'touchstart') {
        return;
      }

      clearTimeout(_this.enterTimer);
      clearTimeout(_this.leaveTimer);

      if (enterDelay) {
        event.persist();
        _this.enterTimer = setTimeout(function () {
          _this.handleOpen(event);
        }, enterDelay);
      } else {
        _this.handleOpen(event);
      }
    };

    _this.handleOpen = function (event) {
      if (!_this.isControlled) {
        _this.setState({
          open: true
        });
      }

      if (_this.props.onOpen) {
        _this.props.onOpen(event, true);
      }
    };

    _this.handleLeave = function (event) {
      var _this$props2 = _this.props,
          children = _this$props2.children,
          leaveDelay = _this$props2.leaveDelay;
      var childrenProps = children.props;

      if (event.type === 'blur' && childrenProps.onBlur) {
        childrenProps.onBlur(event);
      }

      if (event.type === 'mouseleave' && childrenProps.onMouseLeave) {
        childrenProps.onMouseLeave(event);
      }

      clearTimeout(_this.enterTimer);
      clearTimeout(_this.leaveTimer);

      if (leaveDelay) {
        event.persist();
        _this.leaveTimer = setTimeout(function () {
          _this.handleClose(event);
        }, leaveDelay);
      } else {
        _this.handleClose(event);
      }
    };

    _this.handleClose = function (event) {
      if (!_this.isControlled) {
        _this.setState({
          open: false
        });
      }

      if (_this.props.onClose) {
        _this.props.onClose(event, false);
      }

      clearTimeout(_this.closeTimer);
      _this.closeTimer = setTimeout(function () {
        _this.ignoreNonTouchEvents = false;
      }, _this.props.theme.transitions.duration.shortest);
    };

    _this.handleTouchStart = function (event) {
      _this.ignoreNonTouchEvents = true;
      var _this$props3 = _this.props,
          children = _this$props3.children,
          enterTouchDelay = _this$props3.enterTouchDelay;
      var childrenProps = children.props;

      if (childrenProps.onTouchStart) {
        childrenProps.onTouchStart(event);
      }

      clearTimeout(_this.leaveTimer);
      clearTimeout(_this.closeTimer);
      clearTimeout(_this.touchTimer);
      event.persist();
      _this.touchTimer = setTimeout(function () {
        _this.handleEnter(event);
      }, enterTouchDelay);
    };

    _this.handleTouchEnd = function (event) {
      var _this$props4 = _this.props,
          children = _this$props4.children,
          leaveTouchDelay = _this$props4.leaveTouchDelay;
      var childrenProps = children.props;

      if (childrenProps.onTouchEnd) {
        childrenProps.onTouchEnd(event);
      }

      clearTimeout(_this.touchTimer);
      clearTimeout(_this.leaveTimer);
      event.persist();
      _this.leaveTimer = setTimeout(function () {
        _this.handleClose(event);
      }, leaveTouchDelay);
    };

    _this.isControlled = props.open != null;

    if (!_this.isControlled) {
      // not controlled, use internal state
      _this.state.open = false;
    }

    return _this;
  }

  (0, _createClass2.default)(Tooltip, [{
    key: "componentDidMount",
    value: function componentDidMount() {
       false ? (0, _warning.default)(!this.children || !this.children.disabled || !this.children.tagName.toLowerCase() === 'button', ['Material-UI: you are providing a disabled `button` child to the Tooltip component.', 'A disabled element does not fire events.', "Tooltip needs to listen to the child element's events to display the title.", '', 'Place a `div` container on top of the element.'].join('\n')) : void 0;
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearTimeout(this.enterTimer);
      clearTimeout(this.leaveTimer);
      clearTimeout(this.touchTimer);
      clearTimeout(this.closeTimer);
      this.handleResize.clear();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          children = _props.children,
          classes = _props.classes,
          className = _props.className,
          disableFocusListener = _props.disableFocusListener,
          disableHoverListener = _props.disableHoverListener,
          disableTouchListener = _props.disableTouchListener,
          enterDelay = _props.enterDelay,
          enterTouchDelay = _props.enterTouchDelay,
          id = _props.id,
          leaveDelay = _props.leaveDelay,
          leaveTouchDelay = _props.leaveTouchDelay,
          onClose = _props.onClose,
          onOpen = _props.onOpen,
          openProp = _props.open,
          placementProp = _props.placement,
          _props$PopperProps = _props.PopperProps;
      _props$PopperProps = _props$PopperProps === void 0 ? {} : _props$PopperProps;
      var PopperClassName = _props$PopperProps.className,
          PopperProps = (0, _objectWithoutProperties2.default)(_props$PopperProps, ["className"]),
          theme = _props.theme,
          title = _props.title,
          other = (0, _objectWithoutProperties2.default)(_props, ["children", "classes", "className", "disableFocusListener", "disableHoverListener", "disableTouchListener", "enterDelay", "enterTouchDelay", "id", "leaveDelay", "leaveTouchDelay", "onClose", "onOpen", "open", "placement", "PopperProps", "theme", "title"]);
      var placement = theme.direction === 'rtl' ? flipPlacement(placementProp) : placementProp;
      var open = this.isControlled ? openProp : this.state.open;
      var childrenProps = {
        'aria-describedby': id
      }; // There is no point at displaying an empty tooltip.

      if (title === '') {
        open = false;
      }

      if (!disableTouchListener) {
        childrenProps.onTouchStart = this.handleTouchStart;
        childrenProps.onTouchEnd = this.handleTouchEnd;
      }

      if (!disableHoverListener) {
        childrenProps.onMouseOver = this.handleEnter;
        childrenProps.onMouseLeave = this.handleLeave;
      }

      if (!disableFocusListener) {
        childrenProps.onFocus = this.handleEnter;
        childrenProps.onBlur = this.handleLeave;
      }

       false ? (0, _warning.default)(!children.props.title, ['Material-UI: you have been providing a `title` property to the child of <Tooltip />.', "Remove this title property `".concat(children.props.title, "` or the Tooltip component.")].join('\n')) : void 0;
      return _react.default.createElement(_reactPopper.Manager, (0, _extends2.default)({
        tag: false
      }, other), _react.default.createElement(_reactEventListener.default, {
        target: "window",
        onResize: this.handleResize
      }), _react.default.createElement(_reactPopper.Target, null, function (_ref) {
        var targetProps = _ref.targetProps;
        return _react.default.createElement(_RootRef.default, {
          rootRef: function rootRef(node) {
            _this2.children = node;
            targetProps.ref(_this2.children);
          }
        }, _react.default.cloneElement(children, childrenProps));
      }), _react.default.createElement(_Portal.default, null, _react.default.createElement(_reactPopper.Popper, (0, _extends2.default)({
        placement: placement,
        eventsEnabled: open,
        className: (0, _classnames.default)(classes.popper, (0, _defineProperty2.default)({}, classes.open, open), PopperClassName),
        ref: function ref(node) {
          _this2.popper = node;
        }
      }, PopperProps), function (_ref2) {
        var popperProps = _ref2.popperProps,
            restProps = _ref2.restProps;
        var actualPlacement = (popperProps['data-placement'] || placement).split('-')[0];
        return _react.default.createElement("div", (0, _extends2.default)({}, popperProps, restProps, {
          style: (0, _objectSpread2.default)({}, popperProps.style, {
            top: popperProps.style.top || 0,
            left: popperProps.style.left || 0
          }, restProps.style)
        }), _react.default.createElement("div", {
          id: id,
          role: "tooltip",
          "aria-hidden": !open,
          className: (0, _classnames.default)(classes.tooltip, (0, _defineProperty2.default)({}, classes.open, open), (0, _defineProperty2.default)({}, classes.touch, _this2.ignoreNonTouchEvents), classes["tooltipPlacement".concat((0, _helpers.capitalize)(actualPlacement))])
        }, title));
      })));
    }
  }]);
  return Tooltip;
}(_react.default.Component);

Tooltip.propTypes =  false ? {
  /**
   * Tooltip reference element.
   */
  children: _propTypes.default.element.isRequired,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * Do not respond to focus events.
   */
  disableFocusListener: _propTypes.default.bool,

  /**
   * Do not respond to hover events.
   */
  disableHoverListener: _propTypes.default.bool,

  /**
   * Do not respond to long press touch events.
   */
  disableTouchListener: _propTypes.default.bool,

  /**
   * The number of milliseconds to wait before showing the tooltip.
   * This property won't impact the enter touch delay (`enterTouchDelay`).
   */
  enterDelay: _propTypes.default.number,

  /**
   * The number of milliseconds a user must touch the element before showing the tooltip.
   */
  enterTouchDelay: _propTypes.default.number,

  /**
   * The relationship between the tooltip and the wrapper component is not clear from the DOM.
   * By providing this property, we can use aria-describedby to solve the accessibility issue.
   */
  id: _propTypes.default.string,

  /**
   * The number of milliseconds to wait before hiding the tooltip.
   * This property won't impact the leave touch delay (`leaveTouchDelay`).
   */
  leaveDelay: _propTypes.default.number,

  /**
   * The number of milliseconds after the user stops touching an element before hiding the tooltip.
   */
  leaveTouchDelay: _propTypes.default.number,

  /**
   * Callback fired when the tooltip requests to be closed.
   *
   * @param {object} event The event source of the callback
   */
  onClose: _propTypes.default.func,

  /**
   * Callback fired when the tooltip requests to be open.
   *
   * @param {object} event The event source of the callback
   */
  onOpen: _propTypes.default.func,

  /**
   * If `true`, the tooltip is shown.
   */
  open: _propTypes.default.bool,

  /**
   * Tooltip placement
   */
  placement: _propTypes.default.oneOf(['bottom-end', 'bottom-start', 'bottom', 'left-end', 'left-start', 'left', 'right-end', 'right-start', 'right', 'top-end', 'top-start', 'top']),

  /**
   * Properties applied to the `Popper` element.
   */
  PopperProps: _propTypes.default.object,

  /**
   * @ignore
   */
  theme: _propTypes.default.object.isRequired,

  /**
   * Tooltip title. Zero-length titles string are never displayed.
   */
  title: _propTypes.default.node.isRequired
} : {};
Tooltip.defaultProps = {
  disableFocusListener: false,
  disableHoverListener: false,
  disableTouchListener: false,
  enterDelay: 0,
  enterTouchDelay: 1000,
  leaveDelay: 0,
  leaveTouchDelay: 1500,
  placement: 'bottom'
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiTooltip',
  withTheme: true
})(Tooltip);

exports.default = _default;

/***/ }),
/* 1083 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Manager__ = __webpack_require__(1084);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Manager", function() { return __WEBPACK_IMPORTED_MODULE_0__Manager__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Target__ = __webpack_require__(1085);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Target", function() { return __WEBPACK_IMPORTED_MODULE_1__Target__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Popper__ = __webpack_require__(1086);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Popper", function() { return __WEBPACK_IMPORTED_MODULE_2__Popper__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "placements", function() { return __WEBPACK_IMPORTED_MODULE_2__Popper__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Arrow__ = __webpack_require__(1088);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Arrow", function() { return __WEBPACK_IMPORTED_MODULE_3__Arrow__["a"]; });





/***/ }),
/* 1084 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var Manager = function (_Component) {
  _inherits(Manager, _Component);

  function Manager() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Manager);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Manager.__proto__ || Object.getPrototypeOf(Manager)).call.apply(_ref, [this].concat(args))), _this), _this._setTargetNode = function (node) {
      _this._targetNode = node;
    }, _this._getTargetNode = function () {
      return _this._targetNode;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Manager, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return {
        popperManager: {
          setTargetNode: this._setTargetNode,
          getTargetNode: this._getTargetNode
        }
      };
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          tag = _props.tag,
          children = _props.children,
          restProps = _objectWithoutProperties(_props, ['tag', 'children']);

      if (tag !== false) {
        return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(tag, restProps, children);
      } else {
        return children;
      }
    }
  }]);

  return Manager;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Manager.childContextTypes = {
  popperManager: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
};
Manager.propTypes = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool]),
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func])
};
Manager.defaultProps = {
  tag: 'div'
};


/* harmony default export */ __webpack_exports__["a"] = (Manager);

/***/ }),
/* 1085 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }




var Target = function Target(props, context) {
  var _props$component = props.component,
      component = _props$component === undefined ? 'div' : _props$component,
      innerRef = props.innerRef,
      children = props.children,
      restProps = _objectWithoutProperties(props, ['component', 'innerRef', 'children']);

  var popperManager = context.popperManager;

  var targetRef = function targetRef(node) {
    popperManager.setTargetNode(node);
    if (typeof innerRef === 'function') {
      innerRef(node);
    }
  };

  if (typeof children === 'function') {
    var targetProps = { ref: targetRef };
    return children({ targetProps: targetProps, restProps: restProps });
  }

  var componentProps = _extends({}, restProps);

  if (typeof component === 'string') {
    componentProps.ref = targetRef;
  } else {
    componentProps.innerRef = targetRef;
  }

  return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(component, componentProps, children);
};

Target.contextTypes = {
  popperManager: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
};

Target.propTypes = {
  component: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func]),
  innerRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func])
};

/* harmony default export */ __webpack_exports__["a"] = (Target);

/***/ }),
/* 1086 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return placements; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_popper_js__ = __webpack_require__(1087);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var placements = __WEBPACK_IMPORTED_MODULE_2_popper_js__["a" /* default */].placements;

var Popper = function (_Component) {
  _inherits(Popper, _Component);

  function Popper() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Popper);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Popper.__proto__ || Object.getPrototypeOf(Popper)).call.apply(_ref, [this].concat(args))), _this), _this.state = {}, _this._setArrowNode = function (node) {
      _this._arrowNode = node;
    }, _this._getTargetNode = function () {
      if (_this.props.target) {
        return _this.props.target;
      } else if (!_this.context.popperManager || !_this.context.popperManager.getTargetNode()) {
        throw new Error('Target missing. Popper must be given a target from the Popper Manager, or as a prop.');
      }
      return _this.context.popperManager.getTargetNode();
    }, _this._getOffsets = function (data) {
      return Object.keys(data.offsets).map(function (key) {
        return data.offsets[key];
      });
    }, _this._isDataDirty = function (data) {
      if (_this.state.data) {
        return JSON.stringify(_this._getOffsets(_this.state.data)) !== JSON.stringify(_this._getOffsets(data));
      } else {
        return true;
      }
    }, _this._updateStateModifier = {
      enabled: true,
      order: 900,
      fn: function fn(data) {
        if (_this._isDataDirty(data)) {
          _this.setState({ data: data });
        }
        return data;
      }
    }, _this._getPopperStyle = function () {
      var data = _this.state.data;


      if (!_this._popper || !data) {
        return {
          position: 'absolute',
          pointerEvents: 'none',
          opacity: 0
        };
      }

      return _extends({
        position: data.offsets.popper.position
      }, data.styles);
    }, _this._getPopperPlacement = function () {
      return _this.state.data ? _this.state.data.placement : undefined;
    }, _this._getPopperHide = function () {
      return !!_this.state.data && _this.state.data.hide ? '' : undefined;
    }, _this._getArrowStyle = function () {
      if (!_this.state.data || !_this.state.data.offsets.arrow) {
        return {};
      } else {
        var _this$state$data$offs = _this.state.data.offsets.arrow,
            top = _this$state$data$offs.top,
            left = _this$state$data$offs.left;

        return { top: top, left: left };
      }
    }, _this._handlePopperRef = function (node) {
      _this._popperNode = node;
      if (node) {
        _this._createPopper();
      } else {
        _this._destroyPopper();
      }
      if (_this.props.innerRef) {
        _this.props.innerRef(node);
      }
    }, _this._scheduleUpdate = function () {
      _this._popper && _this._popper.scheduleUpdate();
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Popper, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return {
        popper: {
          setArrowNode: this._setArrowNode,
          getArrowStyle: this._getArrowStyle
        }
      };
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(lastProps) {
      if (lastProps.placement !== this.props.placement || lastProps.eventsEnabled !== this.props.eventsEnabled || lastProps.target !== this.props.target) {
        this._destroyPopper();
        this._createPopper();
      }
      if (lastProps.children !== this.props.children) {
        this._scheduleUpdate();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this._destroyPopper();
    }
  }, {
    key: '_createPopper',
    value: function _createPopper() {
      var _this2 = this;

      var _props = this.props,
          placement = _props.placement,
          eventsEnabled = _props.eventsEnabled,
          positionFixed = _props.positionFixed;

      var modifiers = _extends({}, this.props.modifiers, {
        applyStyle: { enabled: false },
        updateState: this._updateStateModifier
      });
      if (this._arrowNode) {
        modifiers.arrow = _extends({}, this.props.modifiers.arrow || {}, {
          element: this._arrowNode
        });
      }
      this._popper = new __WEBPACK_IMPORTED_MODULE_2_popper_js__["a" /* default */](this._getTargetNode(), this._popperNode, {
        placement: placement,
        positionFixed: positionFixed,
        eventsEnabled: eventsEnabled,
        modifiers: modifiers
      });

      // TODO: look into setTimeout scheduleUpdate call, without it, the popper will not position properly on creation
      setTimeout(function () {
        return _this2._scheduleUpdate();
      });
    }
  }, {
    key: '_destroyPopper',
    value: function _destroyPopper() {
      if (this._popper) {
        this._popper.destroy();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          component = _props2.component,
          innerRef = _props2.innerRef,
          placement = _props2.placement,
          eventsEnabled = _props2.eventsEnabled,
          positionFixed = _props2.positionFixed,
          modifiers = _props2.modifiers,
          children = _props2.children,
          restProps = _objectWithoutProperties(_props2, ['component', 'innerRef', 'placement', 'eventsEnabled', 'positionFixed', 'modifiers', 'children']);

      var popperStyle = this._getPopperStyle();
      var popperPlacement = this._getPopperPlacement();
      var popperHide = this._getPopperHide();

      if (typeof children === 'function') {
        var popperProps = {
          ref: this._handlePopperRef,
          style: popperStyle,
          'data-placement': popperPlacement,
          'data-x-out-of-boundaries': popperHide
        };
        return children({
          popperProps: popperProps,
          restProps: restProps,
          scheduleUpdate: this._scheduleUpdate
        });
      }

      var componentProps = _extends({}, restProps, {
        style: _extends({}, restProps.style, popperStyle),
        'data-placement': popperPlacement,
        'data-x-out-of-boundaries': popperHide
      });

      if (typeof component === 'string') {
        componentProps.ref = this._handlePopperRef;
      } else {
        componentProps.innerRef = this._handlePopperRef;
      }

      return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(component, componentProps, children);
    }
  }]);

  return Popper;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Popper.contextTypes = {
  popperManager: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};
Popper.childContextTypes = {
  popper: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
};
Popper.propTypes = {
  component: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func]),
  innerRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  placement: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(placements),
  eventsEnabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  positionFixed: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  modifiers: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func]),
  target: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([
  // the following check is needed for SSR
  __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(typeof Element !== 'undefined' ? Element : Object), __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    getBoundingClientRect: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
    clientWidth: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
    clientHeight: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired
  })])
};
Popper.defaultProps = {
  component: 'div',
  placement: 'bottom',
  eventsEnabled: true,
  positionFixed: false,
  modifiers: {}
};


/* harmony default export */ __webpack_exports__["a"] = (Popper);

/***/ }),
/* 1087 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/**!
 * @fileOverview Kickass library to create and place poppers near their reference elements.
 * @version 1.14.6
 * @license
 * Copyright (c) 2016 Federico Zivolo and contributors
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined';

var longerTimeoutBrowsers = ['Edge', 'Trident', 'Firefox'];
var timeoutDuration = 0;
for (var i = 0; i < longerTimeoutBrowsers.length; i += 1) {
  if (isBrowser && navigator.userAgent.indexOf(longerTimeoutBrowsers[i]) >= 0) {
    timeoutDuration = 1;
    break;
  }
}

function microtaskDebounce(fn) {
  var called = false;
  return function () {
    if (called) {
      return;
    }
    called = true;
    window.Promise.resolve().then(function () {
      called = false;
      fn();
    });
  };
}

function taskDebounce(fn) {
  var scheduled = false;
  return function () {
    if (!scheduled) {
      scheduled = true;
      setTimeout(function () {
        scheduled = false;
        fn();
      }, timeoutDuration);
    }
  };
}

var supportsMicroTasks = isBrowser && window.Promise;

/**
* Create a debounced version of a method, that's asynchronously deferred
* but called in the minimum time possible.
*
* @method
* @memberof Popper.Utils
* @argument {Function} fn
* @returns {Function}
*/
var debounce = supportsMicroTasks ? microtaskDebounce : taskDebounce;

/**
 * Check if the given variable is a function
 * @method
 * @memberof Popper.Utils
 * @argument {Any} functionToCheck - variable to check
 * @returns {Boolean} answer to: is a function?
 */
function isFunction(functionToCheck) {
  var getType = {};
  return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
}

/**
 * Get CSS computed property of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Eement} element
 * @argument {String} property
 */
function getStyleComputedProperty(element, property) {
  if (element.nodeType !== 1) {
    return [];
  }
  // NOTE: 1 DOM access here
  var window = element.ownerDocument.defaultView;
  var css = window.getComputedStyle(element, null);
  return property ? css[property] : css;
}

/**
 * Returns the parentNode or the host of the element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} parent
 */
function getParentNode(element) {
  if (element.nodeName === 'HTML') {
    return element;
  }
  return element.parentNode || element.host;
}

/**
 * Returns the scrolling parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} scroll parent
 */
function getScrollParent(element) {
  // Return body, `getScroll` will take care to get the correct `scrollTop` from it
  if (!element) {
    return document.body;
  }

  switch (element.nodeName) {
    case 'HTML':
    case 'BODY':
      return element.ownerDocument.body;
    case '#document':
      return element.body;
  }

  // Firefox want us to check `-x` and `-y` variations as well

  var _getStyleComputedProp = getStyleComputedProperty(element),
      overflow = _getStyleComputedProp.overflow,
      overflowX = _getStyleComputedProp.overflowX,
      overflowY = _getStyleComputedProp.overflowY;

  if (/(auto|scroll|overlay)/.test(overflow + overflowY + overflowX)) {
    return element;
  }

  return getScrollParent(getParentNode(element));
}

var isIE11 = isBrowser && !!(window.MSInputMethodContext && document.documentMode);
var isIE10 = isBrowser && /MSIE 10/.test(navigator.userAgent);

/**
 * Determines if the browser is Internet Explorer
 * @method
 * @memberof Popper.Utils
 * @param {Number} version to check
 * @returns {Boolean} isIE
 */
function isIE(version) {
  if (version === 11) {
    return isIE11;
  }
  if (version === 10) {
    return isIE10;
  }
  return isIE11 || isIE10;
}

/**
 * Returns the offset parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} offset parent
 */
function getOffsetParent(element) {
  if (!element) {
    return document.documentElement;
  }

  var noOffsetParent = isIE(10) ? document.body : null;

  // NOTE: 1 DOM access here
  var offsetParent = element.offsetParent || null;
  // Skip hidden elements which don't have an offsetParent
  while (offsetParent === noOffsetParent && element.nextElementSibling) {
    offsetParent = (element = element.nextElementSibling).offsetParent;
  }

  var nodeName = offsetParent && offsetParent.nodeName;

  if (!nodeName || nodeName === 'BODY' || nodeName === 'HTML') {
    return element ? element.ownerDocument.documentElement : document.documentElement;
  }

  // .offsetParent will return the closest TH, TD or TABLE in case
  // no offsetParent is present, I hate this job...
  if (['TH', 'TD', 'TABLE'].indexOf(offsetParent.nodeName) !== -1 && getStyleComputedProperty(offsetParent, 'position') === 'static') {
    return getOffsetParent(offsetParent);
  }

  return offsetParent;
}

function isOffsetContainer(element) {
  var nodeName = element.nodeName;

  if (nodeName === 'BODY') {
    return false;
  }
  return nodeName === 'HTML' || getOffsetParent(element.firstElementChild) === element;
}

/**
 * Finds the root node (document, shadowDOM root) of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} node
 * @returns {Element} root node
 */
function getRoot(node) {
  if (node.parentNode !== null) {
    return getRoot(node.parentNode);
  }

  return node;
}

/**
 * Finds the offset parent common to the two provided nodes
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element1
 * @argument {Element} element2
 * @returns {Element} common offset parent
 */
function findCommonOffsetParent(element1, element2) {
  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
  if (!element1 || !element1.nodeType || !element2 || !element2.nodeType) {
    return document.documentElement;
  }

  // Here we make sure to give as "start" the element that comes first in the DOM
  var order = element1.compareDocumentPosition(element2) & Node.DOCUMENT_POSITION_FOLLOWING;
  var start = order ? element1 : element2;
  var end = order ? element2 : element1;

  // Get common ancestor container
  var range = document.createRange();
  range.setStart(start, 0);
  range.setEnd(end, 0);
  var commonAncestorContainer = range.commonAncestorContainer;

  // Both nodes are inside #document

  if (element1 !== commonAncestorContainer && element2 !== commonAncestorContainer || start.contains(end)) {
    if (isOffsetContainer(commonAncestorContainer)) {
      return commonAncestorContainer;
    }

    return getOffsetParent(commonAncestorContainer);
  }

  // one of the nodes is inside shadowDOM, find which one
  var element1root = getRoot(element1);
  if (element1root.host) {
    return findCommonOffsetParent(element1root.host, element2);
  } else {
    return findCommonOffsetParent(element1, getRoot(element2).host);
  }
}

/**
 * Gets the scroll value of the given element in the given side (top and left)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {String} side `top` or `left`
 * @returns {number} amount of scrolled pixels
 */
function getScroll(element) {
  var side = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top';

  var upperSide = side === 'top' ? 'scrollTop' : 'scrollLeft';
  var nodeName = element.nodeName;

  if (nodeName === 'BODY' || nodeName === 'HTML') {
    var html = element.ownerDocument.documentElement;
    var scrollingElement = element.ownerDocument.scrollingElement || html;
    return scrollingElement[upperSide];
  }

  return element[upperSide];
}

/*
 * Sum or subtract the element scroll values (left and top) from a given rect object
 * @method
 * @memberof Popper.Utils
 * @param {Object} rect - Rect object you want to change
 * @param {HTMLElement} element - The element from the function reads the scroll values
 * @param {Boolean} subtract - set to true if you want to subtract the scroll values
 * @return {Object} rect - The modifier rect object
 */
function includeScroll(rect, element) {
  var subtract = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var scrollTop = getScroll(element, 'top');
  var scrollLeft = getScroll(element, 'left');
  var modifier = subtract ? -1 : 1;
  rect.top += scrollTop * modifier;
  rect.bottom += scrollTop * modifier;
  rect.left += scrollLeft * modifier;
  rect.right += scrollLeft * modifier;
  return rect;
}

/*
 * Helper to detect borders of a given element
 * @method
 * @memberof Popper.Utils
 * @param {CSSStyleDeclaration} styles
 * Result of `getStyleComputedProperty` on the given element
 * @param {String} axis - `x` or `y`
 * @return {number} borders - The borders size of the given axis
 */

function getBordersSize(styles, axis) {
  var sideA = axis === 'x' ? 'Left' : 'Top';
  var sideB = sideA === 'Left' ? 'Right' : 'Bottom';

  return parseFloat(styles['border' + sideA + 'Width'], 10) + parseFloat(styles['border' + sideB + 'Width'], 10);
}

function getSize(axis, body, html, computedStyle) {
  return Math.max(body['offset' + axis], body['scroll' + axis], html['client' + axis], html['offset' + axis], html['scroll' + axis], isIE(10) ? parseInt(html['offset' + axis]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Top' : 'Left')]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Bottom' : 'Right')]) : 0);
}

function getWindowSizes(document) {
  var body = document.body;
  var html = document.documentElement;
  var computedStyle = isIE(10) && getComputedStyle(html);

  return {
    height: getSize('Height', body, html, computedStyle),
    width: getSize('Width', body, html, computedStyle)
  };
}

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();





var defineProperty = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/**
 * Given element offsets, generate an output similar to getBoundingClientRect
 * @method
 * @memberof Popper.Utils
 * @argument {Object} offsets
 * @returns {Object} ClientRect like output
 */
function getClientRect(offsets) {
  return _extends({}, offsets, {
    right: offsets.left + offsets.width,
    bottom: offsets.top + offsets.height
  });
}

/**
 * Get bounding client rect of given element
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} element
 * @return {Object} client rect
 */
function getBoundingClientRect(element) {
  var rect = {};

  // IE10 10 FIX: Please, don't ask, the element isn't
  // considered in DOM in some circumstances...
  // This isn't reproducible in IE10 compatibility mode of IE11
  try {
    if (isIE(10)) {
      rect = element.getBoundingClientRect();
      var scrollTop = getScroll(element, 'top');
      var scrollLeft = getScroll(element, 'left');
      rect.top += scrollTop;
      rect.left += scrollLeft;
      rect.bottom += scrollTop;
      rect.right += scrollLeft;
    } else {
      rect = element.getBoundingClientRect();
    }
  } catch (e) {}

  var result = {
    left: rect.left,
    top: rect.top,
    width: rect.right - rect.left,
    height: rect.bottom - rect.top
  };

  // subtract scrollbar size from sizes
  var sizes = element.nodeName === 'HTML' ? getWindowSizes(element.ownerDocument) : {};
  var width = sizes.width || element.clientWidth || result.right - result.left;
  var height = sizes.height || element.clientHeight || result.bottom - result.top;

  var horizScrollbar = element.offsetWidth - width;
  var vertScrollbar = element.offsetHeight - height;

  // if an hypothetical scrollbar is detected, we must be sure it's not a `border`
  // we make this check conditional for performance reasons
  if (horizScrollbar || vertScrollbar) {
    var styles = getStyleComputedProperty(element);
    horizScrollbar -= getBordersSize(styles, 'x');
    vertScrollbar -= getBordersSize(styles, 'y');

    result.width -= horizScrollbar;
    result.height -= vertScrollbar;
  }

  return getClientRect(result);
}

function getOffsetRectRelativeToArbitraryNode(children, parent) {
  var fixedPosition = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var isIE10 = isIE(10);
  var isHTML = parent.nodeName === 'HTML';
  var childrenRect = getBoundingClientRect(children);
  var parentRect = getBoundingClientRect(parent);
  var scrollParent = getScrollParent(children);

  var styles = getStyleComputedProperty(parent);
  var borderTopWidth = parseFloat(styles.borderTopWidth, 10);
  var borderLeftWidth = parseFloat(styles.borderLeftWidth, 10);

  // In cases where the parent is fixed, we must ignore negative scroll in offset calc
  if (fixedPosition && isHTML) {
    parentRect.top = Math.max(parentRect.top, 0);
    parentRect.left = Math.max(parentRect.left, 0);
  }
  var offsets = getClientRect({
    top: childrenRect.top - parentRect.top - borderTopWidth,
    left: childrenRect.left - parentRect.left - borderLeftWidth,
    width: childrenRect.width,
    height: childrenRect.height
  });
  offsets.marginTop = 0;
  offsets.marginLeft = 0;

  // Subtract margins of documentElement in case it's being used as parent
  // we do this only on HTML because it's the only element that behaves
  // differently when margins are applied to it. The margins are included in
  // the box of the documentElement, in the other cases not.
  if (!isIE10 && isHTML) {
    var marginTop = parseFloat(styles.marginTop, 10);
    var marginLeft = parseFloat(styles.marginLeft, 10);

    offsets.top -= borderTopWidth - marginTop;
    offsets.bottom -= borderTopWidth - marginTop;
    offsets.left -= borderLeftWidth - marginLeft;
    offsets.right -= borderLeftWidth - marginLeft;

    // Attach marginTop and marginLeft because in some circumstances we may need them
    offsets.marginTop = marginTop;
    offsets.marginLeft = marginLeft;
  }

  if (isIE10 && !fixedPosition ? parent.contains(scrollParent) : parent === scrollParent && scrollParent.nodeName !== 'BODY') {
    offsets = includeScroll(offsets, parent);
  }

  return offsets;
}

function getViewportOffsetRectRelativeToArtbitraryNode(element) {
  var excludeScroll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var html = element.ownerDocument.documentElement;
  var relativeOffset = getOffsetRectRelativeToArbitraryNode(element, html);
  var width = Math.max(html.clientWidth, window.innerWidth || 0);
  var height = Math.max(html.clientHeight, window.innerHeight || 0);

  var scrollTop = !excludeScroll ? getScroll(html) : 0;
  var scrollLeft = !excludeScroll ? getScroll(html, 'left') : 0;

  var offset = {
    top: scrollTop - relativeOffset.top + relativeOffset.marginTop,
    left: scrollLeft - relativeOffset.left + relativeOffset.marginLeft,
    width: width,
    height: height
  };

  return getClientRect(offset);
}

/**
 * Check if the given element is fixed or is inside a fixed parent
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {Element} customContainer
 * @returns {Boolean} answer to "isFixed?"
 */
function isFixed(element) {
  var nodeName = element.nodeName;
  if (nodeName === 'BODY' || nodeName === 'HTML') {
    return false;
  }
  if (getStyleComputedProperty(element, 'position') === 'fixed') {
    return true;
  }
  return isFixed(getParentNode(element));
}

/**
 * Finds the first parent of an element that has a transformed property defined
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} first transformed parent or documentElement
 */

function getFixedPositionOffsetParent(element) {
  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
  if (!element || !element.parentElement || isIE()) {
    return document.documentElement;
  }
  var el = element.parentElement;
  while (el && getStyleComputedProperty(el, 'transform') === 'none') {
    el = el.parentElement;
  }
  return el || document.documentElement;
}

/**
 * Computed the boundaries limits and return them
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} popper
 * @param {HTMLElement} reference
 * @param {number} padding
 * @param {HTMLElement} boundariesElement - Element used to define the boundaries
 * @param {Boolean} fixedPosition - Is in fixed position mode
 * @returns {Object} Coordinates of the boundaries
 */
function getBoundaries(popper, reference, padding, boundariesElement) {
  var fixedPosition = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

  // NOTE: 1 DOM access here

  var boundaries = { top: 0, left: 0 };
  var offsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, reference);

  // Handle viewport case
  if (boundariesElement === 'viewport') {
    boundaries = getViewportOffsetRectRelativeToArtbitraryNode(offsetParent, fixedPosition);
  } else {
    // Handle other cases based on DOM element used as boundaries
    var boundariesNode = void 0;
    if (boundariesElement === 'scrollParent') {
      boundariesNode = getScrollParent(getParentNode(reference));
      if (boundariesNode.nodeName === 'BODY') {
        boundariesNode = popper.ownerDocument.documentElement;
      }
    } else if (boundariesElement === 'window') {
      boundariesNode = popper.ownerDocument.documentElement;
    } else {
      boundariesNode = boundariesElement;
    }

    var offsets = getOffsetRectRelativeToArbitraryNode(boundariesNode, offsetParent, fixedPosition);

    // In case of HTML, we need a different computation
    if (boundariesNode.nodeName === 'HTML' && !isFixed(offsetParent)) {
      var _getWindowSizes = getWindowSizes(popper.ownerDocument),
          height = _getWindowSizes.height,
          width = _getWindowSizes.width;

      boundaries.top += offsets.top - offsets.marginTop;
      boundaries.bottom = height + offsets.top;
      boundaries.left += offsets.left - offsets.marginLeft;
      boundaries.right = width + offsets.left;
    } else {
      // for all the other DOM elements, this one is good
      boundaries = offsets;
    }
  }

  // Add paddings
  padding = padding || 0;
  var isPaddingNumber = typeof padding === 'number';
  boundaries.left += isPaddingNumber ? padding : padding.left || 0;
  boundaries.top += isPaddingNumber ? padding : padding.top || 0;
  boundaries.right -= isPaddingNumber ? padding : padding.right || 0;
  boundaries.bottom -= isPaddingNumber ? padding : padding.bottom || 0;

  return boundaries;
}

function getArea(_ref) {
  var width = _ref.width,
      height = _ref.height;

  return width * height;
}

/**
 * Utility used to transform the `auto` placement to the placement with more
 * available space.
 * @method
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function computeAutoPlacement(placement, refRect, popper, reference, boundariesElement) {
  var padding = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;

  if (placement.indexOf('auto') === -1) {
    return placement;
  }

  var boundaries = getBoundaries(popper, reference, padding, boundariesElement);

  var rects = {
    top: {
      width: boundaries.width,
      height: refRect.top - boundaries.top
    },
    right: {
      width: boundaries.right - refRect.right,
      height: boundaries.height
    },
    bottom: {
      width: boundaries.width,
      height: boundaries.bottom - refRect.bottom
    },
    left: {
      width: refRect.left - boundaries.left,
      height: boundaries.height
    }
  };

  var sortedAreas = Object.keys(rects).map(function (key) {
    return _extends({
      key: key
    }, rects[key], {
      area: getArea(rects[key])
    });
  }).sort(function (a, b) {
    return b.area - a.area;
  });

  var filteredAreas = sortedAreas.filter(function (_ref2) {
    var width = _ref2.width,
        height = _ref2.height;
    return width >= popper.clientWidth && height >= popper.clientHeight;
  });

  var computedPlacement = filteredAreas.length > 0 ? filteredAreas[0].key : sortedAreas[0].key;

  var variation = placement.split('-')[1];

  return computedPlacement + (variation ? '-' + variation : '');
}

/**
 * Get offsets to the reference element
 * @method
 * @memberof Popper.Utils
 * @param {Object} state
 * @param {Element} popper - the popper element
 * @param {Element} reference - the reference element (the popper will be relative to this)
 * @param {Element} fixedPosition - is in fixed position mode
 * @returns {Object} An object containing the offsets which will be applied to the popper
 */
function getReferenceOffsets(state, popper, reference) {
  var fixedPosition = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

  var commonOffsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, reference);
  return getOffsetRectRelativeToArbitraryNode(reference, commonOffsetParent, fixedPosition);
}

/**
 * Get the outer sizes of the given element (offset size + margins)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Object} object containing width and height properties
 */
function getOuterSizes(element) {
  var window = element.ownerDocument.defaultView;
  var styles = window.getComputedStyle(element);
  var x = parseFloat(styles.marginTop || 0) + parseFloat(styles.marginBottom || 0);
  var y = parseFloat(styles.marginLeft || 0) + parseFloat(styles.marginRight || 0);
  var result = {
    width: element.offsetWidth + y,
    height: element.offsetHeight + x
  };
  return result;
}

/**
 * Get the opposite placement of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement
 * @returns {String} flipped placement
 */
function getOppositePlacement(placement) {
  var hash = { left: 'right', right: 'left', bottom: 'top', top: 'bottom' };
  return placement.replace(/left|right|bottom|top/g, function (matched) {
    return hash[matched];
  });
}

/**
 * Get offsets to the popper
 * @method
 * @memberof Popper.Utils
 * @param {Object} position - CSS position the Popper will get applied
 * @param {HTMLElement} popper - the popper element
 * @param {Object} referenceOffsets - the reference offsets (the popper will be relative to this)
 * @param {String} placement - one of the valid placement options
 * @returns {Object} popperOffsets - An object containing the offsets which will be applied to the popper
 */
function getPopperOffsets(popper, referenceOffsets, placement) {
  placement = placement.split('-')[0];

  // Get popper node sizes
  var popperRect = getOuterSizes(popper);

  // Add position, width and height to our offsets object
  var popperOffsets = {
    width: popperRect.width,
    height: popperRect.height
  };

  // depending by the popper placement we have to compute its offsets slightly differently
  var isHoriz = ['right', 'left'].indexOf(placement) !== -1;
  var mainSide = isHoriz ? 'top' : 'left';
  var secondarySide = isHoriz ? 'left' : 'top';
  var measurement = isHoriz ? 'height' : 'width';
  var secondaryMeasurement = !isHoriz ? 'height' : 'width';

  popperOffsets[mainSide] = referenceOffsets[mainSide] + referenceOffsets[measurement] / 2 - popperRect[measurement] / 2;
  if (placement === secondarySide) {
    popperOffsets[secondarySide] = referenceOffsets[secondarySide] - popperRect[secondaryMeasurement];
  } else {
    popperOffsets[secondarySide] = referenceOffsets[getOppositePlacement(secondarySide)];
  }

  return popperOffsets;
}

/**
 * Mimics the `find` method of Array
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */
function find(arr, check) {
  // use native find if supported
  if (Array.prototype.find) {
    return arr.find(check);
  }

  // use `filter` to obtain the same behavior of `find`
  return arr.filter(check)[0];
}

/**
 * Return the index of the matching object
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */
function findIndex(arr, prop, value) {
  // use native findIndex if supported
  if (Array.prototype.findIndex) {
    return arr.findIndex(function (cur) {
      return cur[prop] === value;
    });
  }

  // use `find` + `indexOf` if `findIndex` isn't supported
  var match = find(arr, function (obj) {
    return obj[prop] === value;
  });
  return arr.indexOf(match);
}

/**
 * Loop trough the list of modifiers and run them in order,
 * each of them will then edit the data object.
 * @method
 * @memberof Popper.Utils
 * @param {dataObject} data
 * @param {Array} modifiers
 * @param {String} ends - Optional modifier name used as stopper
 * @returns {dataObject}
 */
function runModifiers(modifiers, data, ends) {
  var modifiersToRun = ends === undefined ? modifiers : modifiers.slice(0, findIndex(modifiers, 'name', ends));

  modifiersToRun.forEach(function (modifier) {
    if (modifier['function']) {
      // eslint-disable-line dot-notation
      console.warn('`modifier.function` is deprecated, use `modifier.fn`!');
    }
    var fn = modifier['function'] || modifier.fn; // eslint-disable-line dot-notation
    if (modifier.enabled && isFunction(fn)) {
      // Add properties to offsets to make them a complete clientRect object
      // we do this before each modifier to make sure the previous one doesn't
      // mess with these values
      data.offsets.popper = getClientRect(data.offsets.popper);
      data.offsets.reference = getClientRect(data.offsets.reference);

      data = fn(data, modifier);
    }
  });

  return data;
}

/**
 * Updates the position of the popper, computing the new offsets and applying
 * the new style.<br />
 * Prefer `scheduleUpdate` over `update` because of performance reasons.
 * @method
 * @memberof Popper
 */
function update() {
  // if popper is destroyed, don't perform any further update
  if (this.state.isDestroyed) {
    return;
  }

  var data = {
    instance: this,
    styles: {},
    arrowStyles: {},
    attributes: {},
    flipped: false,
    offsets: {}
  };

  // compute reference element offsets
  data.offsets.reference = getReferenceOffsets(this.state, this.popper, this.reference, this.options.positionFixed);

  // compute auto placement, store placement inside the data object,
  // modifiers will be able to edit `placement` if needed
  // and refer to originalPlacement to know the original value
  data.placement = computeAutoPlacement(this.options.placement, data.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding);

  // store the computed placement inside `originalPlacement`
  data.originalPlacement = data.placement;

  data.positionFixed = this.options.positionFixed;

  // compute the popper offsets
  data.offsets.popper = getPopperOffsets(this.popper, data.offsets.reference, data.placement);

  data.offsets.popper.position = this.options.positionFixed ? 'fixed' : 'absolute';

  // run the modifiers
  data = runModifiers(this.modifiers, data);

  // the first `update` will call `onCreate` callback
  // the other ones will call `onUpdate` callback
  if (!this.state.isCreated) {
    this.state.isCreated = true;
    this.options.onCreate(data);
  } else {
    this.options.onUpdate(data);
  }
}

/**
 * Helper used to know if the given modifier is enabled.
 * @method
 * @memberof Popper.Utils
 * @returns {Boolean}
 */
function isModifierEnabled(modifiers, modifierName) {
  return modifiers.some(function (_ref) {
    var name = _ref.name,
        enabled = _ref.enabled;
    return enabled && name === modifierName;
  });
}

/**
 * Get the prefixed supported property name
 * @method
 * @memberof Popper.Utils
 * @argument {String} property (camelCase)
 * @returns {String} prefixed property (camelCase or PascalCase, depending on the vendor prefix)
 */
function getSupportedPropertyName(property) {
  var prefixes = [false, 'ms', 'Webkit', 'Moz', 'O'];
  var upperProp = property.charAt(0).toUpperCase() + property.slice(1);

  for (var i = 0; i < prefixes.length; i++) {
    var prefix = prefixes[i];
    var toCheck = prefix ? '' + prefix + upperProp : property;
    if (typeof document.body.style[toCheck] !== 'undefined') {
      return toCheck;
    }
  }
  return null;
}

/**
 * Destroys the popper.
 * @method
 * @memberof Popper
 */
function destroy() {
  this.state.isDestroyed = true;

  // touch DOM only if `applyStyle` modifier is enabled
  if (isModifierEnabled(this.modifiers, 'applyStyle')) {
    this.popper.removeAttribute('x-placement');
    this.popper.style.position = '';
    this.popper.style.top = '';
    this.popper.style.left = '';
    this.popper.style.right = '';
    this.popper.style.bottom = '';
    this.popper.style.willChange = '';
    this.popper.style[getSupportedPropertyName('transform')] = '';
  }

  this.disableEventListeners();

  // remove the popper if user explicity asked for the deletion on destroy
  // do not use `remove` because IE11 doesn't support it
  if (this.options.removeOnDestroy) {
    this.popper.parentNode.removeChild(this.popper);
  }
  return this;
}

/**
 * Get the window associated with the element
 * @argument {Element} element
 * @returns {Window}
 */
function getWindow(element) {
  var ownerDocument = element.ownerDocument;
  return ownerDocument ? ownerDocument.defaultView : window;
}

function attachToScrollParents(scrollParent, event, callback, scrollParents) {
  var isBody = scrollParent.nodeName === 'BODY';
  var target = isBody ? scrollParent.ownerDocument.defaultView : scrollParent;
  target.addEventListener(event, callback, { passive: true });

  if (!isBody) {
    attachToScrollParents(getScrollParent(target.parentNode), event, callback, scrollParents);
  }
  scrollParents.push(target);
}

/**
 * Setup needed event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */
function setupEventListeners(reference, options, state, updateBound) {
  // Resize event listener on window
  state.updateBound = updateBound;
  getWindow(reference).addEventListener('resize', state.updateBound, { passive: true });

  // Scroll event listener on scroll parents
  var scrollElement = getScrollParent(reference);
  attachToScrollParents(scrollElement, 'scroll', state.updateBound, state.scrollParents);
  state.scrollElement = scrollElement;
  state.eventsEnabled = true;

  return state;
}

/**
 * It will add resize/scroll events and start recalculating
 * position of the popper element when they are triggered.
 * @method
 * @memberof Popper
 */
function enableEventListeners() {
  if (!this.state.eventsEnabled) {
    this.state = setupEventListeners(this.reference, this.options, this.state, this.scheduleUpdate);
  }
}

/**
 * Remove event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */
function removeEventListeners(reference, state) {
  // Remove resize event listener on window
  getWindow(reference).removeEventListener('resize', state.updateBound);

  // Remove scroll event listener on scroll parents
  state.scrollParents.forEach(function (target) {
    target.removeEventListener('scroll', state.updateBound);
  });

  // Reset state
  state.updateBound = null;
  state.scrollParents = [];
  state.scrollElement = null;
  state.eventsEnabled = false;
  return state;
}

/**
 * It will remove resize/scroll events and won't recalculate popper position
 * when they are triggered. It also won't trigger `onUpdate` callback anymore,
 * unless you call `update` method manually.
 * @method
 * @memberof Popper
 */
function disableEventListeners() {
  if (this.state.eventsEnabled) {
    cancelAnimationFrame(this.scheduleUpdate);
    this.state = removeEventListeners(this.reference, this.state);
  }
}

/**
 * Tells if a given input is a number
 * @method
 * @memberof Popper.Utils
 * @param {*} input to check
 * @return {Boolean}
 */
function isNumeric(n) {
  return n !== '' && !isNaN(parseFloat(n)) && isFinite(n);
}

/**
 * Set the style to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the style to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */
function setStyles(element, styles) {
  Object.keys(styles).forEach(function (prop) {
    var unit = '';
    // add unit if the value is numeric and is one of the following
    if (['width', 'height', 'top', 'right', 'bottom', 'left'].indexOf(prop) !== -1 && isNumeric(styles[prop])) {
      unit = 'px';
    }
    element.style[prop] = styles[prop] + unit;
  });
}

/**
 * Set the attributes to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the attributes to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */
function setAttributes(element, attributes) {
  Object.keys(attributes).forEach(function (prop) {
    var value = attributes[prop];
    if (value !== false) {
      element.setAttribute(prop, attributes[prop]);
    } else {
      element.removeAttribute(prop);
    }
  });
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} data.styles - List of style properties - values to apply to popper element
 * @argument {Object} data.attributes - List of attribute properties - values to apply to popper element
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The same data object
 */
function applyStyle(data) {
  // any property present in `data.styles` will be applied to the popper,
  // in this way we can make the 3rd party modifiers add custom styles to it
  // Be aware, modifiers could override the properties defined in the previous
  // lines of this modifier!
  setStyles(data.instance.popper, data.styles);

  // any property present in `data.attributes` will be applied to the popper,
  // they will be set as HTML attributes of the element
  setAttributes(data.instance.popper, data.attributes);

  // if arrowElement is defined and arrowStyles has some properties
  if (data.arrowElement && Object.keys(data.arrowStyles).length) {
    setStyles(data.arrowElement, data.arrowStyles);
  }

  return data;
}

/**
 * Set the x-placement attribute before everything else because it could be used
 * to add margins to the popper margins needs to be calculated to get the
 * correct popper offsets.
 * @method
 * @memberof Popper.modifiers
 * @param {HTMLElement} reference - The reference element used to position the popper
 * @param {HTMLElement} popper - The HTML element used as popper
 * @param {Object} options - Popper.js options
 */
function applyStyleOnLoad(reference, popper, options, modifierOptions, state) {
  // compute reference element offsets
  var referenceOffsets = getReferenceOffsets(state, popper, reference, options.positionFixed);

  // compute auto placement, store placement inside the data object,
  // modifiers will be able to edit `placement` if needed
  // and refer to originalPlacement to know the original value
  var placement = computeAutoPlacement(options.placement, referenceOffsets, popper, reference, options.modifiers.flip.boundariesElement, options.modifiers.flip.padding);

  popper.setAttribute('x-placement', placement);

  // Apply `position` to popper before anything else because
  // without the position applied we can't guarantee correct computations
  setStyles(popper, { position: options.positionFixed ? 'fixed' : 'absolute' });

  return options;
}

/**
 * @function
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Boolean} shouldRound - If the offsets should be rounded at all
 * @returns {Object} The popper's position offsets rounded
 *
 * The tale of pixel-perfect positioning. It's still not 100% perfect, but as
 * good as it can be within reason.
 * Discussion here: https://github.com/FezVrasta/popper.js/pull/715
 *
 * Low DPI screens cause a popper to be blurry if not using full pixels (Safari
 * as well on High DPI screens).
 *
 * Firefox prefers no rounding for positioning and does not have blurriness on
 * high DPI screens.
 *
 * Only horizontal placement and left/right values need to be considered.
 */
function getRoundedOffsets(data, shouldRound) {
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;


  var isVertical = ['left', 'right'].indexOf(data.placement) !== -1;
  var isVariation = data.placement.indexOf('-') !== -1;
  var sameWidthOddness = reference.width % 2 === popper.width % 2;
  var bothOddWidth = reference.width % 2 === 1 && popper.width % 2 === 1;
  var noRound = function noRound(v) {
    return v;
  };

  var horizontalToInteger = !shouldRound ? noRound : isVertical || isVariation || sameWidthOddness ? Math.round : Math.floor;
  var verticalToInteger = !shouldRound ? noRound : Math.round;

  return {
    left: horizontalToInteger(bothOddWidth && !isVariation && shouldRound ? popper.left - 1 : popper.left),
    top: verticalToInteger(popper.top),
    bottom: verticalToInteger(popper.bottom),
    right: horizontalToInteger(popper.right)
  };
}

var isFirefox = isBrowser && /Firefox/i.test(navigator.userAgent);

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function computeStyle(data, options) {
  var x = options.x,
      y = options.y;
  var popper = data.offsets.popper;

  // Remove this legacy support in Popper.js v2

  var legacyGpuAccelerationOption = find(data.instance.modifiers, function (modifier) {
    return modifier.name === 'applyStyle';
  }).gpuAcceleration;
  if (legacyGpuAccelerationOption !== undefined) {
    console.warn('WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!');
  }
  var gpuAcceleration = legacyGpuAccelerationOption !== undefined ? legacyGpuAccelerationOption : options.gpuAcceleration;

  var offsetParent = getOffsetParent(data.instance.popper);
  var offsetParentRect = getBoundingClientRect(offsetParent);

  // Styles
  var styles = {
    position: popper.position
  };

  var offsets = getRoundedOffsets(data, window.devicePixelRatio < 2 || !isFirefox);

  var sideA = x === 'bottom' ? 'top' : 'bottom';
  var sideB = y === 'right' ? 'left' : 'right';

  // if gpuAcceleration is set to `true` and transform is supported,
  //  we use `translate3d` to apply the position to the popper we
  // automatically use the supported prefixed version if needed
  var prefixedProperty = getSupportedPropertyName('transform');

  // now, let's make a step back and look at this code closely (wtf?)
  // If the content of the popper grows once it's been positioned, it
  // may happen that the popper gets misplaced because of the new content
  // overflowing its reference element
  // To avoid this problem, we provide two options (x and y), which allow
  // the consumer to define the offset origin.
  // If we position a popper on top of a reference element, we can set
  // `x` to `top` to make the popper grow towards its top instead of
  // its bottom.
  var left = void 0,
      top = void 0;
  if (sideA === 'bottom') {
    // when offsetParent is <html> the positioning is relative to the bottom of the screen (excluding the scrollbar)
    // and not the bottom of the html element
    if (offsetParent.nodeName === 'HTML') {
      top = -offsetParent.clientHeight + offsets.bottom;
    } else {
      top = -offsetParentRect.height + offsets.bottom;
    }
  } else {
    top = offsets.top;
  }
  if (sideB === 'right') {
    if (offsetParent.nodeName === 'HTML') {
      left = -offsetParent.clientWidth + offsets.right;
    } else {
      left = -offsetParentRect.width + offsets.right;
    }
  } else {
    left = offsets.left;
  }
  if (gpuAcceleration && prefixedProperty) {
    styles[prefixedProperty] = 'translate3d(' + left + 'px, ' + top + 'px, 0)';
    styles[sideA] = 0;
    styles[sideB] = 0;
    styles.willChange = 'transform';
  } else {
    // othwerise, we use the standard `top`, `left`, `bottom` and `right` properties
    var invertTop = sideA === 'bottom' ? -1 : 1;
    var invertLeft = sideB === 'right' ? -1 : 1;
    styles[sideA] = top * invertTop;
    styles[sideB] = left * invertLeft;
    styles.willChange = sideA + ', ' + sideB;
  }

  // Attributes
  var attributes = {
    'x-placement': data.placement
  };

  // Update `data` attributes, styles and arrowStyles
  data.attributes = _extends({}, attributes, data.attributes);
  data.styles = _extends({}, styles, data.styles);
  data.arrowStyles = _extends({}, data.offsets.arrow, data.arrowStyles);

  return data;
}

/**
 * Helper used to know if the given modifier depends from another one.<br />
 * It checks if the needed modifier is listed and enabled.
 * @method
 * @memberof Popper.Utils
 * @param {Array} modifiers - list of modifiers
 * @param {String} requestingName - name of requesting modifier
 * @param {String} requestedName - name of requested modifier
 * @returns {Boolean}
 */
function isModifierRequired(modifiers, requestingName, requestedName) {
  var requesting = find(modifiers, function (_ref) {
    var name = _ref.name;
    return name === requestingName;
  });

  var isRequired = !!requesting && modifiers.some(function (modifier) {
    return modifier.name === requestedName && modifier.enabled && modifier.order < requesting.order;
  });

  if (!isRequired) {
    var _requesting = '`' + requestingName + '`';
    var requested = '`' + requestedName + '`';
    console.warn(requested + ' modifier is required by ' + _requesting + ' modifier in order to work, be sure to include it before ' + _requesting + '!');
  }
  return isRequired;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function arrow(data, options) {
  var _data$offsets$arrow;

  // arrow depends on keepTogether in order to work
  if (!isModifierRequired(data.instance.modifiers, 'arrow', 'keepTogether')) {
    return data;
  }

  var arrowElement = options.element;

  // if arrowElement is a string, suppose it's a CSS selector
  if (typeof arrowElement === 'string') {
    arrowElement = data.instance.popper.querySelector(arrowElement);

    // if arrowElement is not found, don't run the modifier
    if (!arrowElement) {
      return data;
    }
  } else {
    // if the arrowElement isn't a query selector we must check that the
    // provided DOM node is child of its popper node
    if (!data.instance.popper.contains(arrowElement)) {
      console.warn('WARNING: `arrow.element` must be child of its popper element!');
      return data;
    }
  }

  var placement = data.placement.split('-')[0];
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var isVertical = ['left', 'right'].indexOf(placement) !== -1;

  var len = isVertical ? 'height' : 'width';
  var sideCapitalized = isVertical ? 'Top' : 'Left';
  var side = sideCapitalized.toLowerCase();
  var altSide = isVertical ? 'left' : 'top';
  var opSide = isVertical ? 'bottom' : 'right';
  var arrowElementSize = getOuterSizes(arrowElement)[len];

  //
  // extends keepTogether behavior making sure the popper and its
  // reference have enough pixels in conjunction
  //

  // top/left side
  if (reference[opSide] - arrowElementSize < popper[side]) {
    data.offsets.popper[side] -= popper[side] - (reference[opSide] - arrowElementSize);
  }
  // bottom/right side
  if (reference[side] + arrowElementSize > popper[opSide]) {
    data.offsets.popper[side] += reference[side] + arrowElementSize - popper[opSide];
  }
  data.offsets.popper = getClientRect(data.offsets.popper);

  // compute center of the popper
  var center = reference[side] + reference[len] / 2 - arrowElementSize / 2;

  // Compute the sideValue using the updated popper offsets
  // take popper margin in account because we don't have this info available
  var css = getStyleComputedProperty(data.instance.popper);
  var popperMarginSide = parseFloat(css['margin' + sideCapitalized], 10);
  var popperBorderSide = parseFloat(css['border' + sideCapitalized + 'Width'], 10);
  var sideValue = center - data.offsets.popper[side] - popperMarginSide - popperBorderSide;

  // prevent arrowElement from being placed not contiguously to its popper
  sideValue = Math.max(Math.min(popper[len] - arrowElementSize, sideValue), 0);

  data.arrowElement = arrowElement;
  data.offsets.arrow = (_data$offsets$arrow = {}, defineProperty(_data$offsets$arrow, side, Math.round(sideValue)), defineProperty(_data$offsets$arrow, altSide, ''), _data$offsets$arrow);

  return data;
}

/**
 * Get the opposite placement variation of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement variation
 * @returns {String} flipped placement variation
 */
function getOppositeVariation(variation) {
  if (variation === 'end') {
    return 'start';
  } else if (variation === 'start') {
    return 'end';
  }
  return variation;
}

/**
 * List of accepted placements to use as values of the `placement` option.<br />
 * Valid placements are:
 * - `auto`
 * - `top`
 * - `right`
 * - `bottom`
 * - `left`
 *
 * Each placement can have a variation from this list:
 * - `-start`
 * - `-end`
 *
 * Variations are interpreted easily if you think of them as the left to right
 * written languages. Horizontally (`top` and `bottom`), `start` is left and `end`
 * is right.<br />
 * Vertically (`left` and `right`), `start` is top and `end` is bottom.
 *
 * Some valid examples are:
 * - `top-end` (on top of reference, right aligned)
 * - `right-start` (on right of reference, top aligned)
 * - `bottom` (on bottom, centered)
 * - `auto-end` (on the side with more space available, alignment depends by placement)
 *
 * @static
 * @type {Array}
 * @enum {String}
 * @readonly
 * @method placements
 * @memberof Popper
 */
var placements = ['auto-start', 'auto', 'auto-end', 'top-start', 'top', 'top-end', 'right-start', 'right', 'right-end', 'bottom-end', 'bottom', 'bottom-start', 'left-end', 'left', 'left-start'];

// Get rid of `auto` `auto-start` and `auto-end`
var validPlacements = placements.slice(3);

/**
 * Given an initial placement, returns all the subsequent placements
 * clockwise (or counter-clockwise).
 *
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement - A valid placement (it accepts variations)
 * @argument {Boolean} counter - Set to true to walk the placements counterclockwise
 * @returns {Array} placements including their variations
 */
function clockwise(placement) {
  var counter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var index = validPlacements.indexOf(placement);
  var arr = validPlacements.slice(index + 1).concat(validPlacements.slice(0, index));
  return counter ? arr.reverse() : arr;
}

var BEHAVIORS = {
  FLIP: 'flip',
  CLOCKWISE: 'clockwise',
  COUNTERCLOCKWISE: 'counterclockwise'
};

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function flip(data, options) {
  // if `inner` modifier is enabled, we can't use the `flip` modifier
  if (isModifierEnabled(data.instance.modifiers, 'inner')) {
    return data;
  }

  if (data.flipped && data.placement === data.originalPlacement) {
    // seems like flip is trying to loop, probably there's not enough space on any of the flippable sides
    return data;
  }

  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, options.boundariesElement, data.positionFixed);

  var placement = data.placement.split('-')[0];
  var placementOpposite = getOppositePlacement(placement);
  var variation = data.placement.split('-')[1] || '';

  var flipOrder = [];

  switch (options.behavior) {
    case BEHAVIORS.FLIP:
      flipOrder = [placement, placementOpposite];
      break;
    case BEHAVIORS.CLOCKWISE:
      flipOrder = clockwise(placement);
      break;
    case BEHAVIORS.COUNTERCLOCKWISE:
      flipOrder = clockwise(placement, true);
      break;
    default:
      flipOrder = options.behavior;
  }

  flipOrder.forEach(function (step, index) {
    if (placement !== step || flipOrder.length === index + 1) {
      return data;
    }

    placement = data.placement.split('-')[0];
    placementOpposite = getOppositePlacement(placement);

    var popperOffsets = data.offsets.popper;
    var refOffsets = data.offsets.reference;

    // using floor because the reference offsets may contain decimals we are not going to consider here
    var floor = Math.floor;
    var overlapsRef = placement === 'left' && floor(popperOffsets.right) > floor(refOffsets.left) || placement === 'right' && floor(popperOffsets.left) < floor(refOffsets.right) || placement === 'top' && floor(popperOffsets.bottom) > floor(refOffsets.top) || placement === 'bottom' && floor(popperOffsets.top) < floor(refOffsets.bottom);

    var overflowsLeft = floor(popperOffsets.left) < floor(boundaries.left);
    var overflowsRight = floor(popperOffsets.right) > floor(boundaries.right);
    var overflowsTop = floor(popperOffsets.top) < floor(boundaries.top);
    var overflowsBottom = floor(popperOffsets.bottom) > floor(boundaries.bottom);

    var overflowsBoundaries = placement === 'left' && overflowsLeft || placement === 'right' && overflowsRight || placement === 'top' && overflowsTop || placement === 'bottom' && overflowsBottom;

    // flip the variation if required
    var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
    var flippedVariation = !!options.flipVariations && (isVertical && variation === 'start' && overflowsLeft || isVertical && variation === 'end' && overflowsRight || !isVertical && variation === 'start' && overflowsTop || !isVertical && variation === 'end' && overflowsBottom);

    if (overlapsRef || overflowsBoundaries || flippedVariation) {
      // this boolean to detect any flip loop
      data.flipped = true;

      if (overlapsRef || overflowsBoundaries) {
        placement = flipOrder[index + 1];
      }

      if (flippedVariation) {
        variation = getOppositeVariation(variation);
      }

      data.placement = placement + (variation ? '-' + variation : '');

      // this object contains `position`, we want to preserve it along with
      // any additional property we may add in the future
      data.offsets.popper = _extends({}, data.offsets.popper, getPopperOffsets(data.instance.popper, data.offsets.reference, data.placement));

      data = runModifiers(data.instance.modifiers, data, 'flip');
    }
  });
  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function keepTogether(data) {
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var placement = data.placement.split('-')[0];
  var floor = Math.floor;
  var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
  var side = isVertical ? 'right' : 'bottom';
  var opSide = isVertical ? 'left' : 'top';
  var measurement = isVertical ? 'width' : 'height';

  if (popper[side] < floor(reference[opSide])) {
    data.offsets.popper[opSide] = floor(reference[opSide]) - popper[measurement];
  }
  if (popper[opSide] > floor(reference[side])) {
    data.offsets.popper[opSide] = floor(reference[side]);
  }

  return data;
}

/**
 * Converts a string containing value + unit into a px value number
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} str - Value + unit string
 * @argument {String} measurement - `height` or `width`
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @returns {Number|String}
 * Value in pixels, or original string if no values were extracted
 */
function toValue(str, measurement, popperOffsets, referenceOffsets) {
  // separate value from unit
  var split = str.match(/((?:\-|\+)?\d*\.?\d*)(.*)/);
  var value = +split[1];
  var unit = split[2];

  // If it's not a number it's an operator, I guess
  if (!value) {
    return str;
  }

  if (unit.indexOf('%') === 0) {
    var element = void 0;
    switch (unit) {
      case '%p':
        element = popperOffsets;
        break;
      case '%':
      case '%r':
      default:
        element = referenceOffsets;
    }

    var rect = getClientRect(element);
    return rect[measurement] / 100 * value;
  } else if (unit === 'vh' || unit === 'vw') {
    // if is a vh or vw, we calculate the size based on the viewport
    var size = void 0;
    if (unit === 'vh') {
      size = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
    } else {
      size = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    }
    return size / 100 * value;
  } else {
    // if is an explicit pixel unit, we get rid of the unit and keep the value
    // if is an implicit unit, it's px, and we return just the value
    return value;
  }
}

/**
 * Parse an `offset` string to extrapolate `x` and `y` numeric offsets.
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} offset
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @argument {String} basePlacement
 * @returns {Array} a two cells array with x and y offsets in numbers
 */
function parseOffset(offset, popperOffsets, referenceOffsets, basePlacement) {
  var offsets = [0, 0];

  // Use height if placement is left or right and index is 0 otherwise use width
  // in this way the first offset will use an axis and the second one
  // will use the other one
  var useHeight = ['right', 'left'].indexOf(basePlacement) !== -1;

  // Split the offset string to obtain a list of values and operands
  // The regex addresses values with the plus or minus sign in front (+10, -20, etc)
  var fragments = offset.split(/(\+|\-)/).map(function (frag) {
    return frag.trim();
  });

  // Detect if the offset string contains a pair of values or a single one
  // they could be separated by comma or space
  var divider = fragments.indexOf(find(fragments, function (frag) {
    return frag.search(/,|\s/) !== -1;
  }));

  if (fragments[divider] && fragments[divider].indexOf(',') === -1) {
    console.warn('Offsets separated by white space(s) are deprecated, use a comma (,) instead.');
  }

  // If divider is found, we divide the list of values and operands to divide
  // them by ofset X and Y.
  var splitRegex = /\s*,\s*|\s+/;
  var ops = divider !== -1 ? [fragments.slice(0, divider).concat([fragments[divider].split(splitRegex)[0]]), [fragments[divider].split(splitRegex)[1]].concat(fragments.slice(divider + 1))] : [fragments];

  // Convert the values with units to absolute pixels to allow our computations
  ops = ops.map(function (op, index) {
    // Most of the units rely on the orientation of the popper
    var measurement = (index === 1 ? !useHeight : useHeight) ? 'height' : 'width';
    var mergeWithPrevious = false;
    return op
    // This aggregates any `+` or `-` sign that aren't considered operators
    // e.g.: 10 + +5 => [10, +, +5]
    .reduce(function (a, b) {
      if (a[a.length - 1] === '' && ['+', '-'].indexOf(b) !== -1) {
        a[a.length - 1] = b;
        mergeWithPrevious = true;
        return a;
      } else if (mergeWithPrevious) {
        a[a.length - 1] += b;
        mergeWithPrevious = false;
        return a;
      } else {
        return a.concat(b);
      }
    }, [])
    // Here we convert the string values into number values (in px)
    .map(function (str) {
      return toValue(str, measurement, popperOffsets, referenceOffsets);
    });
  });

  // Loop trough the offsets arrays and execute the operations
  ops.forEach(function (op, index) {
    op.forEach(function (frag, index2) {
      if (isNumeric(frag)) {
        offsets[index] += frag * (op[index2 - 1] === '-' ? -1 : 1);
      }
    });
  });
  return offsets;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @argument {Number|String} options.offset=0
 * The offset value as described in the modifier description
 * @returns {Object} The data object, properly modified
 */
function offset(data, _ref) {
  var offset = _ref.offset;
  var placement = data.placement,
      _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var basePlacement = placement.split('-')[0];

  var offsets = void 0;
  if (isNumeric(+offset)) {
    offsets = [+offset, 0];
  } else {
    offsets = parseOffset(offset, popper, reference, basePlacement);
  }

  if (basePlacement === 'left') {
    popper.top += offsets[0];
    popper.left -= offsets[1];
  } else if (basePlacement === 'right') {
    popper.top += offsets[0];
    popper.left += offsets[1];
  } else if (basePlacement === 'top') {
    popper.left += offsets[0];
    popper.top -= offsets[1];
  } else if (basePlacement === 'bottom') {
    popper.left += offsets[0];
    popper.top += offsets[1];
  }

  data.popper = popper;
  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function preventOverflow(data, options) {
  var boundariesElement = options.boundariesElement || getOffsetParent(data.instance.popper);

  // If offsetParent is the reference element, we really want to
  // go one step up and use the next offsetParent as reference to
  // avoid to make this modifier completely useless and look like broken
  if (data.instance.reference === boundariesElement) {
    boundariesElement = getOffsetParent(boundariesElement);
  }

  // NOTE: DOM access here
  // resets the popper's position so that the document size can be calculated excluding
  // the size of the popper element itself
  var transformProp = getSupportedPropertyName('transform');
  var popperStyles = data.instance.popper.style; // assignment to help minification
  var top = popperStyles.top,
      left = popperStyles.left,
      transform = popperStyles[transformProp];

  popperStyles.top = '';
  popperStyles.left = '';
  popperStyles[transformProp] = '';

  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, boundariesElement, data.positionFixed);

  // NOTE: DOM access here
  // restores the original style properties after the offsets have been computed
  popperStyles.top = top;
  popperStyles.left = left;
  popperStyles[transformProp] = transform;

  options.boundaries = boundaries;

  var order = options.priority;
  var popper = data.offsets.popper;

  var check = {
    primary: function primary(placement) {
      var value = popper[placement];
      if (popper[placement] < boundaries[placement] && !options.escapeWithReference) {
        value = Math.max(popper[placement], boundaries[placement]);
      }
      return defineProperty({}, placement, value);
    },
    secondary: function secondary(placement) {
      var mainSide = placement === 'right' ? 'left' : 'top';
      var value = popper[mainSide];
      if (popper[placement] > boundaries[placement] && !options.escapeWithReference) {
        value = Math.min(popper[mainSide], boundaries[placement] - (placement === 'right' ? popper.width : popper.height));
      }
      return defineProperty({}, mainSide, value);
    }
  };

  order.forEach(function (placement) {
    var side = ['left', 'top'].indexOf(placement) !== -1 ? 'primary' : 'secondary';
    popper = _extends({}, popper, check[side](placement));
  });

  data.offsets.popper = popper;

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function shift(data) {
  var placement = data.placement;
  var basePlacement = placement.split('-')[0];
  var shiftvariation = placement.split('-')[1];

  // if shift shiftvariation is specified, run the modifier
  if (shiftvariation) {
    var _data$offsets = data.offsets,
        reference = _data$offsets.reference,
        popper = _data$offsets.popper;

    var isVertical = ['bottom', 'top'].indexOf(basePlacement) !== -1;
    var side = isVertical ? 'left' : 'top';
    var measurement = isVertical ? 'width' : 'height';

    var shiftOffsets = {
      start: defineProperty({}, side, reference[side]),
      end: defineProperty({}, side, reference[side] + reference[measurement] - popper[measurement])
    };

    data.offsets.popper = _extends({}, popper, shiftOffsets[shiftvariation]);
  }

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function hide(data) {
  if (!isModifierRequired(data.instance.modifiers, 'hide', 'preventOverflow')) {
    return data;
  }

  var refRect = data.offsets.reference;
  var bound = find(data.instance.modifiers, function (modifier) {
    return modifier.name === 'preventOverflow';
  }).boundaries;

  if (refRect.bottom < bound.top || refRect.left > bound.right || refRect.top > bound.bottom || refRect.right < bound.left) {
    // Avoid unnecessary DOM access if visibility hasn't changed
    if (data.hide === true) {
      return data;
    }

    data.hide = true;
    data.attributes['x-out-of-boundaries'] = '';
  } else {
    // Avoid unnecessary DOM access if visibility hasn't changed
    if (data.hide === false) {
      return data;
    }

    data.hide = false;
    data.attributes['x-out-of-boundaries'] = false;
  }

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function inner(data) {
  var placement = data.placement;
  var basePlacement = placement.split('-')[0];
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var isHoriz = ['left', 'right'].indexOf(basePlacement) !== -1;

  var subtractLength = ['top', 'left'].indexOf(basePlacement) === -1;

  popper[isHoriz ? 'left' : 'top'] = reference[basePlacement] - (subtractLength ? popper[isHoriz ? 'width' : 'height'] : 0);

  data.placement = getOppositePlacement(placement);
  data.offsets.popper = getClientRect(popper);

  return data;
}

/**
 * Modifier function, each modifier can have a function of this type assigned
 * to its `fn` property.<br />
 * These functions will be called on each update, this means that you must
 * make sure they are performant enough to avoid performance bottlenecks.
 *
 * @function ModifierFn
 * @argument {dataObject} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {dataObject} The data object, properly modified
 */

/**
 * Modifiers are plugins used to alter the behavior of your poppers.<br />
 * Popper.js uses a set of 9 modifiers to provide all the basic functionalities
 * needed by the library.
 *
 * Usually you don't want to override the `order`, `fn` and `onLoad` props.
 * All the other properties are configurations that could be tweaked.
 * @namespace modifiers
 */
var modifiers = {
  /**
   * Modifier used to shift the popper on the start or end of its reference
   * element.<br />
   * It will read the variation of the `placement` property.<br />
   * It can be one either `-end` or `-start`.
   * @memberof modifiers
   * @inner
   */
  shift: {
    /** @prop {number} order=100 - Index used to define the order of execution */
    order: 100,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: shift
  },

  /**
   * The `offset` modifier can shift your popper on both its axis.
   *
   * It accepts the following units:
   * - `px` or unit-less, interpreted as pixels
   * - `%` or `%r`, percentage relative to the length of the reference element
   * - `%p`, percentage relative to the length of the popper element
   * - `vw`, CSS viewport width unit
   * - `vh`, CSS viewport height unit
   *
   * For length is intended the main axis relative to the placement of the popper.<br />
   * This means that if the placement is `top` or `bottom`, the length will be the
   * `width`. In case of `left` or `right`, it will be the `height`.
   *
   * You can provide a single value (as `Number` or `String`), or a pair of values
   * as `String` divided by a comma or one (or more) white spaces.<br />
   * The latter is a deprecated method because it leads to confusion and will be
   * removed in v2.<br />
   * Additionally, it accepts additions and subtractions between different units.
   * Note that multiplications and divisions aren't supported.
   *
   * Valid examples are:
   * ```
   * 10
   * '10%'
   * '10, 10'
   * '10%, 10'
   * '10 + 10%'
   * '10 - 5vh + 3%'
   * '-10px + 5vh, 5px - 6%'
   * ```
   * > **NB**: If you desire to apply offsets to your poppers in a way that may make them overlap
   * > with their reference element, unfortunately, you will have to disable the `flip` modifier.
   * > You can read more on this at this [issue](https://github.com/FezVrasta/popper.js/issues/373).
   *
   * @memberof modifiers
   * @inner
   */
  offset: {
    /** @prop {number} order=200 - Index used to define the order of execution */
    order: 200,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: offset,
    /** @prop {Number|String} offset=0
     * The offset value as described in the modifier description
     */
    offset: 0
  },

  /**
   * Modifier used to prevent the popper from being positioned outside the boundary.
   *
   * A scenario exists where the reference itself is not within the boundaries.<br />
   * We can say it has "escaped the boundaries" — or just "escaped".<br />
   * In this case we need to decide whether the popper should either:
   *
   * - detach from the reference and remain "trapped" in the boundaries, or
   * - if it should ignore the boundary and "escape with its reference"
   *
   * When `escapeWithReference` is set to`true` and reference is completely
   * outside its boundaries, the popper will overflow (or completely leave)
   * the boundaries in order to remain attached to the edge of the reference.
   *
   * @memberof modifiers
   * @inner
   */
  preventOverflow: {
    /** @prop {number} order=300 - Index used to define the order of execution */
    order: 300,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: preventOverflow,
    /**
     * @prop {Array} [priority=['left','right','top','bottom']]
     * Popper will try to prevent overflow following these priorities by default,
     * then, it could overflow on the left and on top of the `boundariesElement`
     */
    priority: ['left', 'right', 'top', 'bottom'],
    /**
     * @prop {number} padding=5
     * Amount of pixel used to define a minimum distance between the boundaries
     * and the popper. This makes sure the popper always has a little padding
     * between the edges of its container
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='scrollParent'
     * Boundaries used by the modifier. Can be `scrollParent`, `window`,
     * `viewport` or any DOM element.
     */
    boundariesElement: 'scrollParent'
  },

  /**
   * Modifier used to make sure the reference and its popper stay near each other
   * without leaving any gap between the two. Especially useful when the arrow is
   * enabled and you want to ensure that it points to its reference element.
   * It cares only about the first axis. You can still have poppers with margin
   * between the popper and its reference element.
   * @memberof modifiers
   * @inner
   */
  keepTogether: {
    /** @prop {number} order=400 - Index used to define the order of execution */
    order: 400,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: keepTogether
  },

  /**
   * This modifier is used to move the `arrowElement` of the popper to make
   * sure it is positioned between the reference element and its popper element.
   * It will read the outer size of the `arrowElement` node to detect how many
   * pixels of conjunction are needed.
   *
   * It has no effect if no `arrowElement` is provided.
   * @memberof modifiers
   * @inner
   */
  arrow: {
    /** @prop {number} order=500 - Index used to define the order of execution */
    order: 500,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: arrow,
    /** @prop {String|HTMLElement} element='[x-arrow]' - Selector or node used as arrow */
    element: '[x-arrow]'
  },

  /**
   * Modifier used to flip the popper's placement when it starts to overlap its
   * reference element.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   *
   * **NOTE:** this modifier will interrupt the current update cycle and will
   * restart it if it detects the need to flip the placement.
   * @memberof modifiers
   * @inner
   */
  flip: {
    /** @prop {number} order=600 - Index used to define the order of execution */
    order: 600,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: flip,
    /**
     * @prop {String|Array} behavior='flip'
     * The behavior used to change the popper's placement. It can be one of
     * `flip`, `clockwise`, `counterclockwise` or an array with a list of valid
     * placements (with optional variations)
     */
    behavior: 'flip',
    /**
     * @prop {number} padding=5
     * The popper will flip if it hits the edges of the `boundariesElement`
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='viewport'
     * The element which will define the boundaries of the popper position.
     * The popper will never be placed outside of the defined boundaries
     * (except if `keepTogether` is enabled)
     */
    boundariesElement: 'viewport'
  },

  /**
   * Modifier used to make the popper flow toward the inner of the reference element.
   * By default, when this modifier is disabled, the popper will be placed outside
   * the reference element.
   * @memberof modifiers
   * @inner
   */
  inner: {
    /** @prop {number} order=700 - Index used to define the order of execution */
    order: 700,
    /** @prop {Boolean} enabled=false - Whether the modifier is enabled or not */
    enabled: false,
    /** @prop {ModifierFn} */
    fn: inner
  },

  /**
   * Modifier used to hide the popper when its reference element is outside of the
   * popper boundaries. It will set a `x-out-of-boundaries` attribute which can
   * be used to hide with a CSS selector the popper when its reference is
   * out of boundaries.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   * @memberof modifiers
   * @inner
   */
  hide: {
    /** @prop {number} order=800 - Index used to define the order of execution */
    order: 800,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: hide
  },

  /**
   * Computes the style that will be applied to the popper element to gets
   * properly positioned.
   *
   * Note that this modifier will not touch the DOM, it just prepares the styles
   * so that `applyStyle` modifier can apply it. This separation is useful
   * in case you need to replace `applyStyle` with a custom implementation.
   *
   * This modifier has `850` as `order` value to maintain backward compatibility
   * with previous versions of Popper.js. Expect the modifiers ordering method
   * to change in future major versions of the library.
   *
   * @memberof modifiers
   * @inner
   */
  computeStyle: {
    /** @prop {number} order=850 - Index used to define the order of execution */
    order: 850,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: computeStyle,
    /**
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */
    gpuAcceleration: true,
    /**
     * @prop {string} [x='bottom']
     * Where to anchor the X axis (`bottom` or `top`). AKA X offset origin.
     * Change this if your popper should grow in a direction different from `bottom`
     */
    x: 'bottom',
    /**
     * @prop {string} [x='left']
     * Where to anchor the Y axis (`left` or `right`). AKA Y offset origin.
     * Change this if your popper should grow in a direction different from `right`
     */
    y: 'right'
  },

  /**
   * Applies the computed styles to the popper element.
   *
   * All the DOM manipulations are limited to this modifier. This is useful in case
   * you want to integrate Popper.js inside a framework or view library and you
   * want to delegate all the DOM manipulations to it.
   *
   * Note that if you disable this modifier, you must make sure the popper element
   * has its position set to `absolute` before Popper.js can do its work!
   *
   * Just disable this modifier and define your own to achieve the desired effect.
   *
   * @memberof modifiers
   * @inner
   */
  applyStyle: {
    /** @prop {number} order=900 - Index used to define the order of execution */
    order: 900,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: applyStyle,
    /** @prop {Function} */
    onLoad: applyStyleOnLoad,
    /**
     * @deprecated since version 1.10.0, the property moved to `computeStyle` modifier
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */
    gpuAcceleration: undefined
  }
};

/**
 * The `dataObject` is an object containing all the information used by Popper.js.
 * This object is passed to modifiers and to the `onCreate` and `onUpdate` callbacks.
 * @name dataObject
 * @property {Object} data.instance The Popper.js instance
 * @property {String} data.placement Placement applied to popper
 * @property {String} data.originalPlacement Placement originally defined on init
 * @property {Boolean} data.flipped True if popper has been flipped by flip modifier
 * @property {Boolean} data.hide True if the reference element is out of boundaries, useful to know when to hide the popper
 * @property {HTMLElement} data.arrowElement Node used as arrow by arrow modifier
 * @property {Object} data.styles Any CSS property defined here will be applied to the popper. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.arrowStyles Any CSS property defined here will be applied to the popper arrow. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.boundaries Offsets of the popper boundaries
 * @property {Object} data.offsets The measurements of popper, reference and arrow elements
 * @property {Object} data.offsets.popper `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.reference `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.arrow] `top` and `left` offsets, only one of them will be different from 0
 */

/**
 * Default options provided to Popper.js constructor.<br />
 * These can be overridden using the `options` argument of Popper.js.<br />
 * To override an option, simply pass an object with the same
 * structure of the `options` object, as the 3rd argument. For example:
 * ```
 * new Popper(ref, pop, {
 *   modifiers: {
 *     preventOverflow: { enabled: false }
 *   }
 * })
 * ```
 * @type {Object}
 * @static
 * @memberof Popper
 */
var Defaults = {
  /**
   * Popper's placement.
   * @prop {Popper.placements} placement='bottom'
   */
  placement: 'bottom',

  /**
   * Set this to true if you want popper to position it self in 'fixed' mode
   * @prop {Boolean} positionFixed=false
   */
  positionFixed: false,

  /**
   * Whether events (resize, scroll) are initially enabled.
   * @prop {Boolean} eventsEnabled=true
   */
  eventsEnabled: true,

  /**
   * Set to true if you want to automatically remove the popper when
   * you call the `destroy` method.
   * @prop {Boolean} removeOnDestroy=false
   */
  removeOnDestroy: false,

  /**
   * Callback called when the popper is created.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onCreate}
   */
  onCreate: function onCreate() {},

  /**
   * Callback called when the popper is updated. This callback is not called
   * on the initialization/creation of the popper, but only on subsequent
   * updates.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onUpdate}
   */
  onUpdate: function onUpdate() {},

  /**
   * List of modifiers used to modify the offsets before they are applied to the popper.
   * They provide most of the functionalities of Popper.js.
   * @prop {modifiers}
   */
  modifiers: modifiers
};

/**
 * @callback onCreate
 * @param {dataObject} data
 */

/**
 * @callback onUpdate
 * @param {dataObject} data
 */

// Utils
// Methods
var Popper = function () {
  /**
   * Creates a new Popper.js instance.
   * @class Popper
   * @param {HTMLElement|referenceObject} reference - The reference element used to position the popper
   * @param {HTMLElement} popper - The HTML element used as the popper
   * @param {Object} options - Your custom options to override the ones defined in [Defaults](#defaults)
   * @return {Object} instance - The generated Popper.js instance
   */
  function Popper(reference, popper) {
    var _this = this;

    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    classCallCheck(this, Popper);

    this.scheduleUpdate = function () {
      return requestAnimationFrame(_this.update);
    };

    // make update() debounced, so that it only runs at most once-per-tick
    this.update = debounce(this.update.bind(this));

    // with {} we create a new object with the options inside it
    this.options = _extends({}, Popper.Defaults, options);

    // init state
    this.state = {
      isDestroyed: false,
      isCreated: false,
      scrollParents: []
    };

    // get reference and popper elements (allow jQuery wrappers)
    this.reference = reference && reference.jquery ? reference[0] : reference;
    this.popper = popper && popper.jquery ? popper[0] : popper;

    // Deep merge modifiers options
    this.options.modifiers = {};
    Object.keys(_extends({}, Popper.Defaults.modifiers, options.modifiers)).forEach(function (name) {
      _this.options.modifiers[name] = _extends({}, Popper.Defaults.modifiers[name] || {}, options.modifiers ? options.modifiers[name] : {});
    });

    // Refactoring modifiers' list (Object => Array)
    this.modifiers = Object.keys(this.options.modifiers).map(function (name) {
      return _extends({
        name: name
      }, _this.options.modifiers[name]);
    })
    // sort the modifiers by order
    .sort(function (a, b) {
      return a.order - b.order;
    });

    // modifiers have the ability to execute arbitrary code when Popper.js get inited
    // such code is executed in the same order of its modifier
    // they could add new properties to their options configuration
    // BE AWARE: don't add options to `options.modifiers.name` but to `modifierOptions`!
    this.modifiers.forEach(function (modifierOptions) {
      if (modifierOptions.enabled && isFunction(modifierOptions.onLoad)) {
        modifierOptions.onLoad(_this.reference, _this.popper, _this.options, modifierOptions, _this.state);
      }
    });

    // fire the first update to position the popper in the right place
    this.update();

    var eventsEnabled = this.options.eventsEnabled;
    if (eventsEnabled) {
      // setup event listeners, they will take care of update the position in specific situations
      this.enableEventListeners();
    }

    this.state.eventsEnabled = eventsEnabled;
  }

  // We can't use class properties because they don't get listed in the
  // class prototype and break stuff like Sinon stubs


  createClass(Popper, [{
    key: 'update',
    value: function update$$1() {
      return update.call(this);
    }
  }, {
    key: 'destroy',
    value: function destroy$$1() {
      return destroy.call(this);
    }
  }, {
    key: 'enableEventListeners',
    value: function enableEventListeners$$1() {
      return enableEventListeners.call(this);
    }
  }, {
    key: 'disableEventListeners',
    value: function disableEventListeners$$1() {
      return disableEventListeners.call(this);
    }

    /**
     * Schedules an update. It will run on the next UI update available.
     * @method scheduleUpdate
     * @memberof Popper
     */


    /**
     * Collection of utilities useful when writing custom modifiers.
     * Starting from version 1.7, this method is available only if you
     * include `popper-utils.js` before `popper.js`.
     *
     * **DEPRECATION**: This way to access PopperUtils is deprecated
     * and will be removed in v2! Use the PopperUtils module directly instead.
     * Due to the high instability of the methods contained in Utils, we can't
     * guarantee them to follow semver. Use them at your own risk!
     * @static
     * @private
     * @type {Object}
     * @deprecated since version 1.8
     * @member Utils
     * @memberof Popper
     */

  }]);
  return Popper;
}();

/**
 * The `referenceObject` is an object that provides an interface compatible with Popper.js
 * and lets you use it as replacement of a real DOM node.<br />
 * You can use this method to position a popper relatively to a set of coordinates
 * in case you don't have a DOM node to use as reference.
 *
 * ```
 * new Popper(referenceObject, popperNode);
 * ```
 *
 * NB: This feature isn't supported in Internet Explorer 10.
 * @name referenceObject
 * @property {Function} data.getBoundingClientRect
 * A function that returns a set of coordinates compatible with the native `getBoundingClientRect` method.
 * @property {number} data.clientWidth
 * An ES6 getter that will return the width of the virtual reference element.
 * @property {number} data.clientHeight
 * An ES6 getter that will return the height of the virtual reference element.
 */


Popper.Utils = (typeof window !== 'undefined' ? window : global).PopperUtils;
Popper.placements = placements;
Popper.Defaults = Defaults;

/* harmony default export */ __webpack_exports__["a"] = (Popper);
//# sourceMappingURL=popper.js.map

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(26)))

/***/ }),
/* 1088 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }




var Arrow = function Arrow(props, context) {
  var _props$component = props.component,
      component = _props$component === undefined ? 'span' : _props$component,
      innerRef = props.innerRef,
      children = props.children,
      restProps = _objectWithoutProperties(props, ['component', 'innerRef', 'children']);

  var popper = context.popper;

  var arrowRef = function arrowRef(node) {
    popper.setArrowNode(node);
    if (typeof innerRef === 'function') {
      innerRef(node);
    }
  };
  var arrowStyle = popper.getArrowStyle();

  if (typeof children === 'function') {
    var arrowProps = {
      ref: arrowRef,
      style: arrowStyle
    };
    return children({ arrowProps: arrowProps, restProps: restProps });
  }

  var componentProps = _extends({}, restProps, {
    style: _extends({}, arrowStyle, restProps.style)
  });

  if (typeof component === 'string') {
    componentProps.ref = arrowRef;
  } else {
    componentProps.innerRef = arrowRef;
  }

  return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(component, componentProps, children);
};

Arrow.contextTypes = {
  popper: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
};

Arrow.propTypes = {
  component: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func]),
  innerRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func])
};

/* harmony default export */ __webpack_exports__["a"] = (Arrow);

/***/ }),
/* 1089 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _withMobileDialog.default;
  }
});

var _withMobileDialog = _interopRequireDefault(__webpack_require__(1090));

/***/ }),
/* 1090 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(161);

var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(8));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _withWidth = _interopRequireWildcard(__webpack_require__(328));

/**
 * Dialog will responsively be full screen *at or below* the given breakpoint
 * (defaults to 'sm' for mobile devices).
 * Notice that this Higher-order Component is incompatible with server side rendering.
 */
var withMobileDialog = function withMobileDialog() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return function (Component) {
    var _options$breakpoint = options.breakpoint,
        breakpoint = _options$breakpoint === void 0 ? 'sm' : _options$breakpoint;

    function WithMobileDialog(props) {
      return _react.default.createElement(Component, (0, _extends2.default)({
        fullScreen: (0, _withWidth.isWidthDown)(breakpoint, props.width)
      }, props));
    }

    WithMobileDialog.propTypes =  false ? {
      width: _propTypes.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl']).isRequired
    } : {};
    return (0, _withWidth.default)()(WithMobileDialog);
  };
};

var _default = withMobileDialog;
exports.default = _default;

/***/ }),
/* 1091 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Zoom.default;
  }
});

var _Zoom = _interopRequireDefault(__webpack_require__(1092));

/***/ }),
/* 1092 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(8));

var _objectSpread2 = _interopRequireDefault(__webpack_require__(23));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(7));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(18));

var _createClass2 = _interopRequireDefault(__webpack_require__(19));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(20));

var _inherits2 = _interopRequireDefault(__webpack_require__(21));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _Transition = _interopRequireDefault(__webpack_require__(131));

var _transitions = __webpack_require__(78);

var _withTheme = _interopRequireDefault(__webpack_require__(91));

var _utils = __webpack_require__(132);

// @inheritedComponent Transition
var styles = {
  entering: {
    transform: 'scale(1)'
  },
  entered: {
    transform: 'scale(1)'
  }
};
/**
 * The Zoom transition can be used for the floating variant of the
 * [Button](https://material-ui.com/demos/buttons/#floating-action-buttons) component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */

var Zoom =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(Zoom, _React$Component);

  function Zoom() {
    var _ref;

    var _temp, _this;

    (0, _classCallCheck2.default)(this, Zoom);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return (0, _possibleConstructorReturn2.default)(_this, (_temp = _this = (0, _possibleConstructorReturn2.default)(this, (_ref = Zoom.__proto__ || Object.getPrototypeOf(Zoom)).call.apply(_ref, [this].concat(args))), _this.handleEnter = function (node) {
      var theme = _this.props.theme;
      (0, _utils.reflow)(node); // So the animation always start from the start.

      var transitionProps = (0, _utils.getTransitionProps)(_this.props, {
        mode: 'enter'
      });
      node.style.webkitTransition = theme.transitions.create('transform', transitionProps);
      node.style.transition = theme.transitions.create('transform', transitionProps);

      if (_this.props.onEnter) {
        _this.props.onEnter(node);
      }
    }, _this.handleExit = function (node) {
      var theme = _this.props.theme;
      var transitionProps = (0, _utils.getTransitionProps)(_this.props, {
        mode: 'exit'
      });
      node.style.webkitTransition = theme.transitions.create('transform', transitionProps);
      node.style.transition = theme.transitions.create('transform', transitionProps);

      if (_this.props.onExit) {
        _this.props.onExit(node);
      }
    }, _temp));
  }

  (0, _createClass2.default)(Zoom, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          children = _props.children,
          onEnter = _props.onEnter,
          onExit = _props.onExit,
          styleProp = _props.style,
          theme = _props.theme,
          other = (0, _objectWithoutProperties2.default)(_props, ["children", "onEnter", "onExit", "style", "theme"]);
      var style = (0, _objectSpread2.default)({}, styleProp, _react.default.isValidElement(children) ? children.props.style : {});
      return _react.default.createElement(_Transition.default, (0, _extends2.default)({
        appear: true,
        onEnter: this.handleEnter,
        onExit: this.handleExit
      }, other), function (state, childProps) {
        return _react.default.cloneElement(children, (0, _objectSpread2.default)({
          style: (0, _objectSpread2.default)({
            transform: 'scale(0)',
            willChange: 'transform'
          }, styles[state], style)
        }, childProps));
      });
    }
  }]);
  return Zoom;
}(_react.default.Component);

Zoom.propTypes =  false ? {
  /**
   * A single child content element.
   */
  children: _propTypes.default.oneOfType([_propTypes.default.element, _propTypes.default.func]),

  /**
   * If `true`, the component will transition in.
   */
  in: _propTypes.default.bool,

  /**
   * @ignore
   */
  onEnter: _propTypes.default.func,

  /**
   * @ignore
   */
  onExit: _propTypes.default.func,

  /**
   * @ignore
   */
  style: _propTypes.default.object,

  /**
   * @ignore
   */
  theme: _propTypes.default.object.isRequired,

  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   */
  timeout: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
    enter: _propTypes.default.number,
    exit: _propTypes.default.number
  })])
} : {};
Zoom.defaultProps = {
  timeout: {
    enter: _transitions.duration.enteringScreen,
    exit: _transitions.duration.leavingScreen
  }
};

var _default = (0, _withTheme.default)()(Zoom);

exports.default = _default;

/***/ }),
/* 1093 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__ = __webpack_require__(65);
// ##############################
// // // SnackbarContent styles
// #############################
var snackbarContentStyle={root:Object.assign({},__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["j" /* defaultFont */],{flexWrap:"unset",position:"relative",padding:"20px 15px",lineHeight:"20px",marginBottom:"20px",fontSize:"14px",backgroundColor:"white",color:"#555555",borderRadius:"3px",boxShadow:"0 12px 20px -10px rgba(255, 255, 255, 0.28), 0 4px 20px 0px rgba(0, 0, 0, 0.12), 0 7px 8px -5px rgba(255, 255, 255, 0.2)"}),top20:{top:"20px"},top40:{top:"40px"},info:Object.assign({backgroundColor:"#00d3ee",color:"#ffffff"},__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["o" /* infoBoxShadow */]),success:Object.assign({backgroundColor:"#5cb860",color:"#ffffff"},__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["B" /* successBoxShadow */]),warning:Object.assign({backgroundColor:"#ffa21a",color:"#ffffff"},__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["G" /* warningBoxShadow */]),danger:Object.assign({backgroundColor:"#f55a4e",color:"#ffffff"},__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["e" /* dangerBoxShadow */]),primary:Object.assign({backgroundColor:"#af2cc5",color:"#ffffff"},__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["r" /* primaryBoxShadow */]),rose:Object.assign({backgroundColor:"#eb3573",color:"#ffffff"},__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["u" /* roseBoxShadow */]),message:{padding:"0",display:"block",maxWidth:"89%"},close:{width:"11px",height:"11px"},iconButton:{width:"24px",height:"24px"},icon:{// display: "block",
// left: "15px",
// position: "absolute",
// top: "50%",
// marginTop: "-15px",
width:"38px",height:"38px",display:"block",left:"15px",position:"absolute",marginTop:"-39px",fontSize:"20px",backgroundColor:"#FFFFFF",padding:"9px",borderRadius:"50%",maxWidth:"38px",boxShadow:"0 10px 30px -12px rgba(0, 0, 0, 0.42), 0 4px 25px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(0, 0, 0, 0.2)"},infoIcon:{color:"#00d3ee"},successIcon:{color:"#5cb860"},warningIcon:{color:"#ffa21a"},dangerIcon:{color:"#f55a4e"},primaryIcon:{color:"#af2cc5"},roseIcon:{color:"#eb3573"},iconMessage:{paddingLeft:"50px",display:"block"}};/* harmony default export */ __webpack_exports__["a"] = (snackbarContentStyle);

/***/ }),
/* 1094 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["parse"] = parse;
/* harmony export (immutable) */ __webpack_exports__["parseValue"] = parseValue;
/* harmony export (immutable) */ __webpack_exports__["parseType"] = parseType;
/* harmony export (immutable) */ __webpack_exports__["parseConstValue"] = parseConstValue;
/* harmony export (immutable) */ __webpack_exports__["parseTypeReference"] = parseTypeReference;
/* harmony export (immutable) */ __webpack_exports__["parseNamedType"] = parseNamedType;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__source__ = __webpack_require__(1095);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__error__ = __webpack_require__(519);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lexer__ = __webpack_require__(1099);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__kinds__ = __webpack_require__(1101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__directiveLocation__ = __webpack_require__(1102);
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */










/**
 * Configuration options to control parser behavior
 */


/**
 * Given a GraphQL source, parses it into a Document.
 * Throws GraphQLError if a syntax error is encountered.
 */
function parse(source, options) {
  var sourceObj = typeof source === 'string' ? new __WEBPACK_IMPORTED_MODULE_0__source__["a" /* Source */](source) : source;
  if (!(sourceObj instanceof __WEBPACK_IMPORTED_MODULE_0__source__["a" /* Source */])) {
    throw new TypeError('Must provide Source. Received: ' + String(sourceObj));
  }
  var lexer = Object(__WEBPACK_IMPORTED_MODULE_2__lexer__["b" /* createLexer */])(sourceObj, options || {});
  return parseDocument(lexer);
}

/**
 * Given a string containing a GraphQL value (ex. `[42]`), parse the AST for
 * that value.
 * Throws GraphQLError if a syntax error is encountered.
 *
 * This is useful within tools that operate upon GraphQL Values directly and
 * in isolation of complete GraphQL documents.
 *
 * Consider providing the results to the utility function: valueFromAST().
 */
function parseValue(source, options) {
  var sourceObj = typeof source === 'string' ? new __WEBPACK_IMPORTED_MODULE_0__source__["a" /* Source */](source) : source;
  var lexer = Object(__WEBPACK_IMPORTED_MODULE_2__lexer__["b" /* createLexer */])(sourceObj, options || {});
  expect(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].SOF);
  var value = parseValueLiteral(lexer, false);
  expect(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].EOF);
  return value;
}

/**
 * Given a string containing a GraphQL Type (ex. `[Int!]`), parse the AST for
 * that type.
 * Throws GraphQLError if a syntax error is encountered.
 *
 * This is useful within tools that operate upon GraphQL Types directly and
 * in isolation of complete GraphQL documents.
 *
 * Consider providing the results to the utility function: typeFromAST().
 */
function parseType(source, options) {
  var sourceObj = typeof source === 'string' ? new __WEBPACK_IMPORTED_MODULE_0__source__["a" /* Source */](source) : source;
  var lexer = Object(__WEBPACK_IMPORTED_MODULE_2__lexer__["b" /* createLexer */])(sourceObj, options || {});
  expect(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].SOF);
  var type = parseTypeReference(lexer);
  expect(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].EOF);
  return type;
}

/**
 * Converts a name lex token into a name parse node.
 */
function parseName(lexer) {
  var token = expect(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].NAME);
  return {
    kind: __WEBPACK_IMPORTED_MODULE_3__kinds__["a" /* Kind */].NAME,
    value: token.value,
    loc: loc(lexer, token)
  };
}

// Implements the parsing rules in the Document section.

/**
 * Document : Definition+
 */
function parseDocument(lexer) {
  var start = lexer.token;
  expect(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].SOF);
  var definitions = [];
  do {
    definitions.push(parseDefinition(lexer));
  } while (!skip(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].EOF));

  return {
    kind: __WEBPACK_IMPORTED_MODULE_3__kinds__["a" /* Kind */].DOCUMENT,
    definitions: definitions,
    loc: loc(lexer, start)
  };
}

/**
 * Definition :
 *   - ExecutableDefinition
 *   - TypeSystemDefinition
 */
function parseDefinition(lexer) {
  if (peek(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].NAME)) {
    switch (lexer.token.value) {
      case 'query':
      case 'mutation':
      case 'subscription':
      case 'fragment':
        return parseExecutableDefinition(lexer);
      case 'schema':
      case 'scalar':
      case 'type':
      case 'interface':
      case 'union':
      case 'enum':
      case 'input':
      case 'extend':
      case 'directive':
        // Note: The schema definition language is an experimental addition.
        return parseTypeSystemDefinition(lexer);
    }
  } else if (peek(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].BRACE_L)) {
    return parseExecutableDefinition(lexer);
  } else if (peekDescription(lexer)) {
    // Note: The schema definition language is an experimental addition.
    return parseTypeSystemDefinition(lexer);
  }

  throw unexpected(lexer);
}

/**
 * ExecutableDefinition :
 *   - OperationDefinition
 *   - FragmentDefinition
 */
function parseExecutableDefinition(lexer) {
  if (peek(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].NAME)) {
    switch (lexer.token.value) {
      case 'query':
      case 'mutation':
      case 'subscription':
        return parseOperationDefinition(lexer);

      case 'fragment':
        return parseFragmentDefinition(lexer);
    }
  } else if (peek(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].BRACE_L)) {
    return parseOperationDefinition(lexer);
  }

  throw unexpected(lexer);
}

// Implements the parsing rules in the Operations section.

/**
 * OperationDefinition :
 *  - SelectionSet
 *  - OperationType Name? VariableDefinitions? Directives? SelectionSet
 */
function parseOperationDefinition(lexer) {
  var start = lexer.token;
  if (peek(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].BRACE_L)) {
    return {
      kind: __WEBPACK_IMPORTED_MODULE_3__kinds__["a" /* Kind */].OPERATION_DEFINITION,
      operation: 'query',
      name: undefined,
      variableDefinitions: [],
      directives: [],
      selectionSet: parseSelectionSet(lexer),
      loc: loc(lexer, start)
    };
  }
  var operation = parseOperationType(lexer);
  var name = void 0;
  if (peek(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].NAME)) {
    name = parseName(lexer);
  }
  return {
    kind: __WEBPACK_IMPORTED_MODULE_3__kinds__["a" /* Kind */].OPERATION_DEFINITION,
    operation: operation,
    name: name,
    variableDefinitions: parseVariableDefinitions(lexer),
    directives: parseDirectives(lexer, false),
    selectionSet: parseSelectionSet(lexer),
    loc: loc(lexer, start)
  };
}

/**
 * OperationType : one of query mutation subscription
 */
function parseOperationType(lexer) {
  var operationToken = expect(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].NAME);
  switch (operationToken.value) {
    case 'query':
      return 'query';
    case 'mutation':
      return 'mutation';
    case 'subscription':
      return 'subscription';
  }

  throw unexpected(lexer, operationToken);
}

/**
 * VariableDefinitions : ( VariableDefinition+ )
 */
function parseVariableDefinitions(lexer) {
  return peek(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].PAREN_L) ? many(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].PAREN_L, parseVariableDefinition, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].PAREN_R) : [];
}

/**
 * VariableDefinition : Variable : Type DefaultValue?
 */
function parseVariableDefinition(lexer) {
  var start = lexer.token;
  return {
    kind: __WEBPACK_IMPORTED_MODULE_3__kinds__["a" /* Kind */].VARIABLE_DEFINITION,
    variable: parseVariable(lexer),
    type: (expect(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].COLON), parseTypeReference(lexer)),
    defaultValue: skip(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].EQUALS) ? parseValueLiteral(lexer, true) : undefined,
    loc: loc(lexer, start)
  };
}

/**
 * Variable : $ Name
 */
function parseVariable(lexer) {
  var start = lexer.token;
  expect(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].DOLLAR);
  return {
    kind: __WEBPACK_IMPORTED_MODULE_3__kinds__["a" /* Kind */].VARIABLE,
    name: parseName(lexer),
    loc: loc(lexer, start)
  };
}

/**
 * SelectionSet : { Selection+ }
 */
function parseSelectionSet(lexer) {
  var start = lexer.token;
  return {
    kind: __WEBPACK_IMPORTED_MODULE_3__kinds__["a" /* Kind */].SELECTION_SET,
    selections: many(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].BRACE_L, parseSelection, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].BRACE_R),
    loc: loc(lexer, start)
  };
}

/**
 * Selection :
 *   - Field
 *   - FragmentSpread
 *   - InlineFragment
 */
function parseSelection(lexer) {
  return peek(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].SPREAD) ? parseFragment(lexer) : parseField(lexer);
}

/**
 * Field : Alias? Name Arguments? Directives? SelectionSet?
 *
 * Alias : Name :
 */
function parseField(lexer) {
  var start = lexer.token;

  var nameOrAlias = parseName(lexer);
  var alias = void 0;
  var name = void 0;
  if (skip(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].COLON)) {
    alias = nameOrAlias;
    name = parseName(lexer);
  } else {
    name = nameOrAlias;
  }

  return {
    kind: __WEBPACK_IMPORTED_MODULE_3__kinds__["a" /* Kind */].FIELD,
    alias: alias,
    name: name,
    arguments: parseArguments(lexer, false),
    directives: parseDirectives(lexer, false),
    selectionSet: peek(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].BRACE_L) ? parseSelectionSet(lexer) : undefined,
    loc: loc(lexer, start)
  };
}

/**
 * Arguments[Const] : ( Argument[?Const]+ )
 */
function parseArguments(lexer, isConst) {
  var item = isConst ? parseConstArgument : parseArgument;
  return peek(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].PAREN_L) ? many(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].PAREN_L, item, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].PAREN_R) : [];
}

/**
 * Argument[Const] : Name : Value[?Const]
 */
function parseArgument(lexer) {
  var start = lexer.token;
  return {
    kind: __WEBPACK_IMPORTED_MODULE_3__kinds__["a" /* Kind */].ARGUMENT,
    name: parseName(lexer),
    value: (expect(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].COLON), parseValueLiteral(lexer, false)),
    loc: loc(lexer, start)
  };
}

function parseConstArgument(lexer) {
  var start = lexer.token;
  return {
    kind: __WEBPACK_IMPORTED_MODULE_3__kinds__["a" /* Kind */].ARGUMENT,
    name: parseName(lexer),
    value: (expect(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].COLON), parseConstValue(lexer)),
    loc: loc(lexer, start)
  };
}

// Implements the parsing rules in the Fragments section.

/**
 * Corresponds to both FragmentSpread and InlineFragment in the spec.
 *
 * FragmentSpread : ... FragmentName Directives?
 *
 * InlineFragment : ... TypeCondition? Directives? SelectionSet
 */
function parseFragment(lexer) {
  var start = lexer.token;
  expect(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].SPREAD);
  if (peek(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].NAME) && lexer.token.value !== 'on') {
    return {
      kind: __WEBPACK_IMPORTED_MODULE_3__kinds__["a" /* Kind */].FRAGMENT_SPREAD,
      name: parseFragmentName(lexer),
      directives: parseDirectives(lexer, false),
      loc: loc(lexer, start)
    };
  }
  var typeCondition = void 0;
  if (lexer.token.value === 'on') {
    lexer.advance();
    typeCondition = parseNamedType(lexer);
  }
  return {
    kind: __WEBPACK_IMPORTED_MODULE_3__kinds__["a" /* Kind */].INLINE_FRAGMENT,
    typeCondition: typeCondition,
    directives: parseDirectives(lexer, false),
    selectionSet: parseSelectionSet(lexer),
    loc: loc(lexer, start)
  };
}

/**
 * FragmentDefinition :
 *   - fragment FragmentName on TypeCondition Directives? SelectionSet
 *
 * TypeCondition : NamedType
 */
function parseFragmentDefinition(lexer) {
  var start = lexer.token;
  expectKeyword(lexer, 'fragment');
  // Experimental support for defining variables within fragments changes
  // the grammar of FragmentDefinition:
  //   - fragment FragmentName VariableDefinitions? on TypeCondition Directives? SelectionSet
  if (lexer.options.experimentalFragmentVariables) {
    return {
      kind: __WEBPACK_IMPORTED_MODULE_3__kinds__["a" /* Kind */].FRAGMENT_DEFINITION,
      name: parseFragmentName(lexer),
      variableDefinitions: parseVariableDefinitions(lexer),
      typeCondition: (expectKeyword(lexer, 'on'), parseNamedType(lexer)),
      directives: parseDirectives(lexer, false),
      selectionSet: parseSelectionSet(lexer),
      loc: loc(lexer, start)
    };
  }
  return {
    kind: __WEBPACK_IMPORTED_MODULE_3__kinds__["a" /* Kind */].FRAGMENT_DEFINITION,
    name: parseFragmentName(lexer),
    typeCondition: (expectKeyword(lexer, 'on'), parseNamedType(lexer)),
    directives: parseDirectives(lexer, false),
    selectionSet: parseSelectionSet(lexer),
    loc: loc(lexer, start)
  };
}

/**
 * FragmentName : Name but not `on`
 */
function parseFragmentName(lexer) {
  if (lexer.token.value === 'on') {
    throw unexpected(lexer);
  }
  return parseName(lexer);
}

// Implements the parsing rules in the Values section.

/**
 * Value[Const] :
 *   - [~Const] Variable
 *   - IntValue
 *   - FloatValue
 *   - StringValue
 *   - BooleanValue
 *   - NullValue
 *   - EnumValue
 *   - ListValue[?Const]
 *   - ObjectValue[?Const]
 *
 * BooleanValue : one of `true` `false`
 *
 * NullValue : `null`
 *
 * EnumValue : Name but not `true`, `false` or `null`
 */
function parseValueLiteral(lexer, isConst) {
  var token = lexer.token;
  switch (token.kind) {
    case __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].BRACKET_L:
      return parseList(lexer, isConst);
    case __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].BRACE_L:
      return parseObject(lexer, isConst);
    case __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].INT:
      lexer.advance();
      return {
        kind: __WEBPACK_IMPORTED_MODULE_3__kinds__["a" /* Kind */].INT,
        value: token.value,
        loc: loc(lexer, token)
      };
    case __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].FLOAT:
      lexer.advance();
      return {
        kind: __WEBPACK_IMPORTED_MODULE_3__kinds__["a" /* Kind */].FLOAT,
        value: token.value,
        loc: loc(lexer, token)
      };
    case __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].STRING:
    case __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].BLOCK_STRING:
      return parseStringLiteral(lexer);
    case __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].NAME:
      if (token.value === 'true' || token.value === 'false') {
        lexer.advance();
        return {
          kind: __WEBPACK_IMPORTED_MODULE_3__kinds__["a" /* Kind */].BOOLEAN,
          value: token.value === 'true',
          loc: loc(lexer, token)
        };
      } else if (token.value === 'null') {
        lexer.advance();
        return {
          kind: __WEBPACK_IMPORTED_MODULE_3__kinds__["a" /* Kind */].NULL,
          loc: loc(lexer, token)
        };
      }
      lexer.advance();
      return {
        kind: __WEBPACK_IMPORTED_MODULE_3__kinds__["a" /* Kind */].ENUM,
        value: token.value,
        loc: loc(lexer, token)
      };
    case __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].DOLLAR:
      if (!isConst) {
        return parseVariable(lexer);
      }
      break;
  }
  throw unexpected(lexer);
}

function parseStringLiteral(lexer) {
  var token = lexer.token;
  lexer.advance();
  return {
    kind: __WEBPACK_IMPORTED_MODULE_3__kinds__["a" /* Kind */].STRING,
    value: token.value,
    block: token.kind === __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].BLOCK_STRING,
    loc: loc(lexer, token)
  };
}

function parseConstValue(lexer) {
  return parseValueLiteral(lexer, true);
}

function parseValueValue(lexer) {
  return parseValueLiteral(lexer, false);
}

/**
 * ListValue[Const] :
 *   - [ ]
 *   - [ Value[?Const]+ ]
 */
function parseList(lexer, isConst) {
  var start = lexer.token;
  var item = isConst ? parseConstValue : parseValueValue;
  return {
    kind: __WEBPACK_IMPORTED_MODULE_3__kinds__["a" /* Kind */].LIST,
    values: any(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].BRACKET_L, item, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].BRACKET_R),
    loc: loc(lexer, start)
  };
}

/**
 * ObjectValue[Const] :
 *   - { }
 *   - { ObjectField[?Const]+ }
 */
function parseObject(lexer, isConst) {
  var start = lexer.token;
  expect(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].BRACE_L);
  var fields = [];
  while (!skip(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].BRACE_R)) {
    fields.push(parseObjectField(lexer, isConst));
  }
  return {
    kind: __WEBPACK_IMPORTED_MODULE_3__kinds__["a" /* Kind */].OBJECT,
    fields: fields,
    loc: loc(lexer, start)
  };
}

/**
 * ObjectField[Const] : Name : Value[?Const]
 */
function parseObjectField(lexer, isConst) {
  var start = lexer.token;
  return {
    kind: __WEBPACK_IMPORTED_MODULE_3__kinds__["a" /* Kind */].OBJECT_FIELD,
    name: parseName(lexer),
    value: (expect(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].COLON), parseValueLiteral(lexer, isConst)),
    loc: loc(lexer, start)
  };
}

// Implements the parsing rules in the Directives section.

/**
 * Directives[Const] : Directive[?Const]+
 */
function parseDirectives(lexer, isConst) {
  var directives = [];
  while (peek(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].AT)) {
    directives.push(parseDirective(lexer, isConst));
  }
  return directives;
}

/**
 * Directive[Const] : @ Name Arguments[?Const]?
 */
function parseDirective(lexer, isConst) {
  var start = lexer.token;
  expect(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].AT);
  return {
    kind: __WEBPACK_IMPORTED_MODULE_3__kinds__["a" /* Kind */].DIRECTIVE,
    name: parseName(lexer),
    arguments: parseArguments(lexer, isConst),
    loc: loc(lexer, start)
  };
}

// Implements the parsing rules in the Types section.

/**
 * Type :
 *   - NamedType
 *   - ListType
 *   - NonNullType
 */
function parseTypeReference(lexer) {
  var start = lexer.token;
  var type = void 0;
  if (skip(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].BRACKET_L)) {
    type = parseTypeReference(lexer);
    expect(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].BRACKET_R);
    type = {
      kind: __WEBPACK_IMPORTED_MODULE_3__kinds__["a" /* Kind */].LIST_TYPE,
      type: type,
      loc: loc(lexer, start)
    };
  } else {
    type = parseNamedType(lexer);
  }
  if (skip(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].BANG)) {
    return {
      kind: __WEBPACK_IMPORTED_MODULE_3__kinds__["a" /* Kind */].NON_NULL_TYPE,
      type: type,
      loc: loc(lexer, start)
    };
  }
  return type;
}

/**
 * NamedType : Name
 */
function parseNamedType(lexer) {
  var start = lexer.token;
  return {
    kind: __WEBPACK_IMPORTED_MODULE_3__kinds__["a" /* Kind */].NAMED_TYPE,
    name: parseName(lexer),
    loc: loc(lexer, start)
  };
}

// Implements the parsing rules in the Type Definition section.

/**
 * TypeSystemDefinition :
 *   - SchemaDefinition
 *   - TypeDefinition
 *   - TypeExtension
 *   - DirectiveDefinition
 *
 * TypeDefinition :
 *   - ScalarTypeDefinition
 *   - ObjectTypeDefinition
 *   - InterfaceTypeDefinition
 *   - UnionTypeDefinition
 *   - EnumTypeDefinition
 *   - InputObjectTypeDefinition
 */
function parseTypeSystemDefinition(lexer) {
  // Many definitions begin with a description and require a lookahead.
  var keywordToken = peekDescription(lexer) ? lexer.lookahead() : lexer.token;

  if (keywordToken.kind === __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].NAME) {
    switch (keywordToken.value) {
      case 'schema':
        return parseSchemaDefinition(lexer);
      case 'scalar':
        return parseScalarTypeDefinition(lexer);
      case 'type':
        return parseObjectTypeDefinition(lexer);
      case 'interface':
        return parseInterfaceTypeDefinition(lexer);
      case 'union':
        return parseUnionTypeDefinition(lexer);
      case 'enum':
        return parseEnumTypeDefinition(lexer);
      case 'input':
        return parseInputObjectTypeDefinition(lexer);
      case 'extend':
        return parseTypeExtension(lexer);
      case 'directive':
        return parseDirectiveDefinition(lexer);
    }
  }

  throw unexpected(lexer, keywordToken);
}

function peekDescription(lexer) {
  return peek(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].STRING) || peek(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].BLOCK_STRING);
}

/**
 * Description : StringValue
 */
function parseDescription(lexer) {
  if (peekDescription(lexer)) {
    return parseStringLiteral(lexer);
  }
}

/**
 * SchemaDefinition : schema Directives[Const]? { OperationTypeDefinition+ }
 */
function parseSchemaDefinition(lexer) {
  var start = lexer.token;
  expectKeyword(lexer, 'schema');
  var directives = parseDirectives(lexer, true);
  var operationTypes = many(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].BRACE_L, parseOperationTypeDefinition, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].BRACE_R);
  return {
    kind: __WEBPACK_IMPORTED_MODULE_3__kinds__["a" /* Kind */].SCHEMA_DEFINITION,
    directives: directives,
    operationTypes: operationTypes,
    loc: loc(lexer, start)
  };
}

/**
 * OperationTypeDefinition : OperationType : NamedType
 */
function parseOperationTypeDefinition(lexer) {
  var start = lexer.token;
  var operation = parseOperationType(lexer);
  expect(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].COLON);
  var type = parseNamedType(lexer);
  return {
    kind: __WEBPACK_IMPORTED_MODULE_3__kinds__["a" /* Kind */].OPERATION_TYPE_DEFINITION,
    operation: operation,
    type: type,
    loc: loc(lexer, start)
  };
}

/**
 * ScalarTypeDefinition : Description? scalar Name Directives[Const]?
 */
function parseScalarTypeDefinition(lexer) {
  var start = lexer.token;
  var description = parseDescription(lexer);
  expectKeyword(lexer, 'scalar');
  var name = parseName(lexer);
  var directives = parseDirectives(lexer, true);
  return {
    kind: __WEBPACK_IMPORTED_MODULE_3__kinds__["a" /* Kind */].SCALAR_TYPE_DEFINITION,
    description: description,
    name: name,
    directives: directives,
    loc: loc(lexer, start)
  };
}

/**
 * ObjectTypeDefinition :
 *   Description?
 *   type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition?
 */
function parseObjectTypeDefinition(lexer) {
  var start = lexer.token;
  var description = parseDescription(lexer);
  expectKeyword(lexer, 'type');
  var name = parseName(lexer);
  var interfaces = parseImplementsInterfaces(lexer);
  var directives = parseDirectives(lexer, true);
  var fields = parseFieldsDefinition(lexer);
  return {
    kind: __WEBPACK_IMPORTED_MODULE_3__kinds__["a" /* Kind */].OBJECT_TYPE_DEFINITION,
    description: description,
    name: name,
    interfaces: interfaces,
    directives: directives,
    fields: fields,
    loc: loc(lexer, start)
  };
}

/**
 * ImplementsInterfaces :
 *   - implements `&`? NamedType
 *   - ImplementsInterfaces & NamedType
 */
function parseImplementsInterfaces(lexer) {
  var types = [];
  if (lexer.token.value === 'implements') {
    lexer.advance();
    // Optional leading ampersand
    skip(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].AMP);
    do {
      types.push(parseNamedType(lexer));
    } while (skip(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].AMP) ||
    // Legacy support for the SDL?
    lexer.options.allowLegacySDLImplementsInterfaces && peek(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].NAME));
  }
  return types;
}

/**
 * FieldsDefinition : { FieldDefinition+ }
 */
function parseFieldsDefinition(lexer) {
  // Legacy support for the SDL?
  if (lexer.options.allowLegacySDLEmptyFields && peek(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].BRACE_L) && lexer.lookahead().kind === __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].BRACE_R) {
    lexer.advance();
    lexer.advance();
    return [];
  }
  return peek(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].BRACE_L) ? many(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].BRACE_L, parseFieldDefinition, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].BRACE_R) : [];
}

/**
 * FieldDefinition :
 *   - Description? Name ArgumentsDefinition? : Type Directives[Const]?
 */
function parseFieldDefinition(lexer) {
  var start = lexer.token;
  var description = parseDescription(lexer);
  var name = parseName(lexer);
  var args = parseArgumentDefs(lexer);
  expect(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].COLON);
  var type = parseTypeReference(lexer);
  var directives = parseDirectives(lexer, true);
  return {
    kind: __WEBPACK_IMPORTED_MODULE_3__kinds__["a" /* Kind */].FIELD_DEFINITION,
    description: description,
    name: name,
    arguments: args,
    type: type,
    directives: directives,
    loc: loc(lexer, start)
  };
}

/**
 * ArgumentsDefinition : ( InputValueDefinition+ )
 */
function parseArgumentDefs(lexer) {
  if (!peek(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].PAREN_L)) {
    return [];
  }
  return many(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].PAREN_L, parseInputValueDef, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].PAREN_R);
}

/**
 * InputValueDefinition :
 *   - Description? Name : Type DefaultValue? Directives[Const]?
 */
function parseInputValueDef(lexer) {
  var start = lexer.token;
  var description = parseDescription(lexer);
  var name = parseName(lexer);
  expect(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].COLON);
  var type = parseTypeReference(lexer);
  var defaultValue = void 0;
  if (skip(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].EQUALS)) {
    defaultValue = parseConstValue(lexer);
  }
  var directives = parseDirectives(lexer, true);
  return {
    kind: __WEBPACK_IMPORTED_MODULE_3__kinds__["a" /* Kind */].INPUT_VALUE_DEFINITION,
    description: description,
    name: name,
    type: type,
    defaultValue: defaultValue,
    directives: directives,
    loc: loc(lexer, start)
  };
}

/**
 * InterfaceTypeDefinition :
 *   - Description? interface Name Directives[Const]? FieldsDefinition?
 */
function parseInterfaceTypeDefinition(lexer) {
  var start = lexer.token;
  var description = parseDescription(lexer);
  expectKeyword(lexer, 'interface');
  var name = parseName(lexer);
  var directives = parseDirectives(lexer, true);
  var fields = parseFieldsDefinition(lexer);
  return {
    kind: __WEBPACK_IMPORTED_MODULE_3__kinds__["a" /* Kind */].INTERFACE_TYPE_DEFINITION,
    description: description,
    name: name,
    directives: directives,
    fields: fields,
    loc: loc(lexer, start)
  };
}

/**
 * UnionTypeDefinition :
 *   - Description? union Name Directives[Const]? UnionMemberTypes?
 */
function parseUnionTypeDefinition(lexer) {
  var start = lexer.token;
  var description = parseDescription(lexer);
  expectKeyword(lexer, 'union');
  var name = parseName(lexer);
  var directives = parseDirectives(lexer, true);
  var types = parseUnionMemberTypes(lexer);
  return {
    kind: __WEBPACK_IMPORTED_MODULE_3__kinds__["a" /* Kind */].UNION_TYPE_DEFINITION,
    description: description,
    name: name,
    directives: directives,
    types: types,
    loc: loc(lexer, start)
  };
}

/**
 * UnionMemberTypes :
 *   - = `|`? NamedType
 *   - UnionMemberTypes | NamedType
 */
function parseUnionMemberTypes(lexer) {
  var types = [];
  if (skip(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].EQUALS)) {
    // Optional leading pipe
    skip(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].PIPE);
    do {
      types.push(parseNamedType(lexer));
    } while (skip(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].PIPE));
  }
  return types;
}

/**
 * EnumTypeDefinition :
 *   - Description? enum Name Directives[Const]? EnumValuesDefinition?
 */
function parseEnumTypeDefinition(lexer) {
  var start = lexer.token;
  var description = parseDescription(lexer);
  expectKeyword(lexer, 'enum');
  var name = parseName(lexer);
  var directives = parseDirectives(lexer, true);
  var values = parseEnumValuesDefinition(lexer);
  return {
    kind: __WEBPACK_IMPORTED_MODULE_3__kinds__["a" /* Kind */].ENUM_TYPE_DEFINITION,
    description: description,
    name: name,
    directives: directives,
    values: values,
    loc: loc(lexer, start)
  };
}

/**
 * EnumValuesDefinition : { EnumValueDefinition+ }
 */
function parseEnumValuesDefinition(lexer) {
  return peek(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].BRACE_L) ? many(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].BRACE_L, parseEnumValueDefinition, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].BRACE_R) : [];
}

/**
 * EnumValueDefinition : Description? EnumValue Directives[Const]?
 *
 * EnumValue : Name
 */
function parseEnumValueDefinition(lexer) {
  var start = lexer.token;
  var description = parseDescription(lexer);
  var name = parseName(lexer);
  var directives = parseDirectives(lexer, true);
  return {
    kind: __WEBPACK_IMPORTED_MODULE_3__kinds__["a" /* Kind */].ENUM_VALUE_DEFINITION,
    description: description,
    name: name,
    directives: directives,
    loc: loc(lexer, start)
  };
}

/**
 * InputObjectTypeDefinition :
 *   - Description? input Name Directives[Const]? InputFieldsDefinition?
 */
function parseInputObjectTypeDefinition(lexer) {
  var start = lexer.token;
  var description = parseDescription(lexer);
  expectKeyword(lexer, 'input');
  var name = parseName(lexer);
  var directives = parseDirectives(lexer, true);
  var fields = parseInputFieldsDefinition(lexer);
  return {
    kind: __WEBPACK_IMPORTED_MODULE_3__kinds__["a" /* Kind */].INPUT_OBJECT_TYPE_DEFINITION,
    description: description,
    name: name,
    directives: directives,
    fields: fields,
    loc: loc(lexer, start)
  };
}

/**
 * InputFieldsDefinition : { InputValueDefinition+ }
 */
function parseInputFieldsDefinition(lexer) {
  return peek(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].BRACE_L) ? many(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].BRACE_L, parseInputValueDef, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].BRACE_R) : [];
}

/**
 * TypeExtension :
 *   - ScalarTypeExtension
 *   - ObjectTypeExtension
 *   - InterfaceTypeExtension
 *   - UnionTypeExtension
 *   - EnumTypeExtension
 *   - InputObjectTypeDefinition
 */
function parseTypeExtension(lexer) {
  var keywordToken = lexer.lookahead();

  if (keywordToken.kind === __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].NAME) {
    switch (keywordToken.value) {
      case 'scalar':
        return parseScalarTypeExtension(lexer);
      case 'type':
        return parseObjectTypeExtension(lexer);
      case 'interface':
        return parseInterfaceTypeExtension(lexer);
      case 'union':
        return parseUnionTypeExtension(lexer);
      case 'enum':
        return parseEnumTypeExtension(lexer);
      case 'input':
        return parseInputObjectTypeExtension(lexer);
    }
  }

  throw unexpected(lexer, keywordToken);
}

/**
 * ScalarTypeExtension :
 *   - extend scalar Name Directives[Const]
 */
function parseScalarTypeExtension(lexer) {
  var start = lexer.token;
  expectKeyword(lexer, 'extend');
  expectKeyword(lexer, 'scalar');
  var name = parseName(lexer);
  var directives = parseDirectives(lexer, true);
  if (directives.length === 0) {
    throw unexpected(lexer);
  }
  return {
    kind: __WEBPACK_IMPORTED_MODULE_3__kinds__["a" /* Kind */].SCALAR_TYPE_EXTENSION,
    name: name,
    directives: directives,
    loc: loc(lexer, start)
  };
}

/**
 * ObjectTypeExtension :
 *  - extend type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
 *  - extend type Name ImplementsInterfaces? Directives[Const]
 *  - extend type Name ImplementsInterfaces
 */
function parseObjectTypeExtension(lexer) {
  var start = lexer.token;
  expectKeyword(lexer, 'extend');
  expectKeyword(lexer, 'type');
  var name = parseName(lexer);
  var interfaces = parseImplementsInterfaces(lexer);
  var directives = parseDirectives(lexer, true);
  var fields = parseFieldsDefinition(lexer);
  if (interfaces.length === 0 && directives.length === 0 && fields.length === 0) {
    throw unexpected(lexer);
  }
  return {
    kind: __WEBPACK_IMPORTED_MODULE_3__kinds__["a" /* Kind */].OBJECT_TYPE_EXTENSION,
    name: name,
    interfaces: interfaces,
    directives: directives,
    fields: fields,
    loc: loc(lexer, start)
  };
}

/**
 * InterfaceTypeExtension :
 *   - extend interface Name Directives[Const]? FieldsDefinition
 *   - extend interface Name Directives[Const]
 */
function parseInterfaceTypeExtension(lexer) {
  var start = lexer.token;
  expectKeyword(lexer, 'extend');
  expectKeyword(lexer, 'interface');
  var name = parseName(lexer);
  var directives = parseDirectives(lexer, true);
  var fields = parseFieldsDefinition(lexer);
  if (directives.length === 0 && fields.length === 0) {
    throw unexpected(lexer);
  }
  return {
    kind: __WEBPACK_IMPORTED_MODULE_3__kinds__["a" /* Kind */].INTERFACE_TYPE_EXTENSION,
    name: name,
    directives: directives,
    fields: fields,
    loc: loc(lexer, start)
  };
}

/**
 * UnionTypeExtension :
 *   - extend union Name Directives[Const]? UnionMemberTypes
 *   - extend union Name Directives[Const]
 */
function parseUnionTypeExtension(lexer) {
  var start = lexer.token;
  expectKeyword(lexer, 'extend');
  expectKeyword(lexer, 'union');
  var name = parseName(lexer);
  var directives = parseDirectives(lexer, true);
  var types = parseUnionMemberTypes(lexer);
  if (directives.length === 0 && types.length === 0) {
    throw unexpected(lexer);
  }
  return {
    kind: __WEBPACK_IMPORTED_MODULE_3__kinds__["a" /* Kind */].UNION_TYPE_EXTENSION,
    name: name,
    directives: directives,
    types: types,
    loc: loc(lexer, start)
  };
}

/**
 * EnumTypeExtension :
 *   - extend enum Name Directives[Const]? EnumValuesDefinition
 *   - extend enum Name Directives[Const]
 */
function parseEnumTypeExtension(lexer) {
  var start = lexer.token;
  expectKeyword(lexer, 'extend');
  expectKeyword(lexer, 'enum');
  var name = parseName(lexer);
  var directives = parseDirectives(lexer, true);
  var values = parseEnumValuesDefinition(lexer);
  if (directives.length === 0 && values.length === 0) {
    throw unexpected(lexer);
  }
  return {
    kind: __WEBPACK_IMPORTED_MODULE_3__kinds__["a" /* Kind */].ENUM_TYPE_EXTENSION,
    name: name,
    directives: directives,
    values: values,
    loc: loc(lexer, start)
  };
}

/**
 * InputObjectTypeExtension :
 *   - extend input Name Directives[Const]? InputFieldsDefinition
 *   - extend input Name Directives[Const]
 */
function parseInputObjectTypeExtension(lexer) {
  var start = lexer.token;
  expectKeyword(lexer, 'extend');
  expectKeyword(lexer, 'input');
  var name = parseName(lexer);
  var directives = parseDirectives(lexer, true);
  var fields = parseInputFieldsDefinition(lexer);
  if (directives.length === 0 && fields.length === 0) {
    throw unexpected(lexer);
  }
  return {
    kind: __WEBPACK_IMPORTED_MODULE_3__kinds__["a" /* Kind */].INPUT_OBJECT_TYPE_EXTENSION,
    name: name,
    directives: directives,
    fields: fields,
    loc: loc(lexer, start)
  };
}

/**
 * DirectiveDefinition :
 *   - Description? directive @ Name ArgumentsDefinition? on DirectiveLocations
 */
function parseDirectiveDefinition(lexer) {
  var start = lexer.token;
  var description = parseDescription(lexer);
  expectKeyword(lexer, 'directive');
  expect(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].AT);
  var name = parseName(lexer);
  var args = parseArgumentDefs(lexer);
  expectKeyword(lexer, 'on');
  var locations = parseDirectiveLocations(lexer);
  return {
    kind: __WEBPACK_IMPORTED_MODULE_3__kinds__["a" /* Kind */].DIRECTIVE_DEFINITION,
    description: description,
    name: name,
    arguments: args,
    locations: locations,
    loc: loc(lexer, start)
  };
}

/**
 * DirectiveLocations :
 *   - `|`? DirectiveLocation
 *   - DirectiveLocations | DirectiveLocation
 */
function parseDirectiveLocations(lexer) {
  // Optional leading pipe
  skip(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].PIPE);
  var locations = [];
  do {
    locations.push(parseDirectiveLocation(lexer));
  } while (skip(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].PIPE));
  return locations;
}

/*
 * DirectiveLocation :
 *   - ExecutableDirectiveLocation
 *   - TypeSystemDirectiveLocation
 *
 * ExecutableDirectiveLocation : one of
 *   `QUERY`
 *   `MUTATION`
 *   `SUBSCRIPTION`
 *   `FIELD`
 *   `FRAGMENT_DEFINITION`
 *   `FRAGMENT_SPREAD`
 *   `INLINE_FRAGMENT`
 *
 * TypeSystemDirectiveLocation : one of
 *   `SCHEMA`
 *   `SCALAR`
 *   `OBJECT`
 *   `FIELD_DEFINITION`
 *   `ARGUMENT_DEFINITION`
 *   `INTERFACE`
 *   `UNION`
 *   `ENUM`
 *   `ENUM_VALUE`
 *   `INPUT_OBJECT`
 *   `INPUT_FIELD_DEFINITION`
 */
function parseDirectiveLocation(lexer) {
  var start = lexer.token;
  var name = parseName(lexer);
  if (__WEBPACK_IMPORTED_MODULE_4__directiveLocation__["a" /* DirectiveLocation */].hasOwnProperty(name.value)) {
    return name;
  }
  throw unexpected(lexer, start);
}

// Core parsing utility functions

/**
 * Returns a location object, used to identify the place in
 * the source that created a given parsed object.
 */
function loc(lexer, startToken) {
  if (!lexer.options.noLocation) {
    return new Loc(startToken, lexer.lastToken, lexer.source);
  }
}

function Loc(startToken, endToken, source) {
  this.start = startToken.start;
  this.end = endToken.end;
  this.startToken = startToken;
  this.endToken = endToken;
  this.source = source;
}

// Print a simplified form when appearing in JSON/util.inspect.
Loc.prototype.toJSON = Loc.prototype.inspect = function toJSON() {
  return { start: this.start, end: this.end };
};

/**
 * Determines if the next token is of a given kind
 */
function peek(lexer, kind) {
  return lexer.token.kind === kind;
}

/**
 * If the next token is of the given kind, return true after advancing
 * the lexer. Otherwise, do not change the parser state and return false.
 */
function skip(lexer, kind) {
  var match = lexer.token.kind === kind;
  if (match) {
    lexer.advance();
  }
  return match;
}

/**
 * If the next token is of the given kind, return that token after advancing
 * the lexer. Otherwise, do not change the parser state and throw an error.
 */
function expect(lexer, kind) {
  var token = lexer.token;
  if (token.kind === kind) {
    lexer.advance();
    return token;
  }
  throw Object(__WEBPACK_IMPORTED_MODULE_1__error__["a" /* syntaxError */])(lexer.source, token.start, 'Expected ' + kind + ', found ' + Object(__WEBPACK_IMPORTED_MODULE_2__lexer__["c" /* getTokenDesc */])(token));
}

/**
 * If the next token is a keyword with the given value, return that token after
 * advancing the lexer. Otherwise, do not change the parser state and return
 * false.
 */
function expectKeyword(lexer, value) {
  var token = lexer.token;
  if (token.kind === __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].NAME && token.value === value) {
    lexer.advance();
    return token;
  }
  throw Object(__WEBPACK_IMPORTED_MODULE_1__error__["a" /* syntaxError */])(lexer.source, token.start, 'Expected "' + value + '", found ' + Object(__WEBPACK_IMPORTED_MODULE_2__lexer__["c" /* getTokenDesc */])(token));
}

/**
 * Helper function for creating an error when an unexpected lexed token
 * is encountered.
 */
function unexpected(lexer, atToken) {
  var token = atToken || lexer.token;
  return Object(__WEBPACK_IMPORTED_MODULE_1__error__["a" /* syntaxError */])(lexer.source, token.start, 'Unexpected ' + Object(__WEBPACK_IMPORTED_MODULE_2__lexer__["c" /* getTokenDesc */])(token));
}

/**
 * Returns a possibly empty list of parse nodes, determined by
 * the parseFn. This list begins with a lex token of openKind
 * and ends with a lex token of closeKind. Advances the parser
 * to the next lex token after the closing token.
 */
function any(lexer, openKind, parseFn, closeKind) {
  expect(lexer, openKind);
  var nodes = [];
  while (!skip(lexer, closeKind)) {
    nodes.push(parseFn(lexer));
  }
  return nodes;
}

/**
 * Returns a non-empty list of parse nodes, determined by
 * the parseFn. This list begins with a lex token of openKind
 * and ends with a lex token of closeKind. Advances the parser
 * to the next lex token after the closing token.
 */
function many(lexer, openKind, parseFn, closeKind) {
  expect(lexer, openKind);
  var nodes = [parseFn(lexer)];
  while (!skip(lexer, closeKind)) {
    nodes.push(parseFn(lexer));
  }
  return nodes;
}

/***/ }),
/* 1095 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Source; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__jsutils_invariant__ = __webpack_require__(518);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */



/**
 * A representation of source input to GraphQL.
 * `name` and `locationOffset` are optional. They are useful for clients who
 * store GraphQL documents in source files; for example, if the GraphQL input
 * starts at line 40 in a file named Foo.graphql, it might be useful for name to
 * be "Foo.graphql" and location to be `{ line: 40, column: 0 }`.
 * line and column in locationOffset are 1-indexed
 */
var Source = function Source(body, name, locationOffset) {
  _classCallCheck(this, Source);

  this.body = body;
  this.name = name || 'GraphQL request';
  this.locationOffset = locationOffset || { line: 1, column: 1 };
  !(this.locationOffset.line > 0) ? Object(__WEBPACK_IMPORTED_MODULE_0__jsutils_invariant__["a" /* default */])(0, 'line in locationOffset is 1-indexed and must be positive') : void 0;
  !(this.locationOffset.column > 0) ? Object(__WEBPACK_IMPORTED_MODULE_0__jsutils_invariant__["a" /* default */])(0, 'column in locationOffset is 1-indexed and must be positive') : void 0;
};

/***/ }),
/* 1096 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = syntaxError;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__GraphQLError__ = __webpack_require__(335);



/**
 * Produces a GraphQLError representing a syntax error, containing useful
 * descriptive information about the syntax error's position in the source.
 */
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */

function syntaxError(source, position, description) {
  return new __WEBPACK_IMPORTED_MODULE_0__GraphQLError__["a" /* GraphQLError */]('Syntax Error: ' + description, undefined, source, [position]);
}

/***/ }),
/* 1097 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export locatedError */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__GraphQLError__ = __webpack_require__(335);
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */




/**
 * Given an arbitrary Error, presumably thrown while attempting to execute a
 * GraphQL operation, produce a new GraphQLError aware of the location in the
 * document responsible for the original Error.
 */
function locatedError(originalError, nodes, path) {
  // Note: this uses a brand-check to support GraphQL errors originating from
  // other contexts.
  // $FlowFixMe(>=0.68.0)
  if (originalError && Array.isArray(originalError.path)) {
    return originalError;
  }

  return new __WEBPACK_IMPORTED_MODULE_0__GraphQLError__["a" /* GraphQLError */](originalError && originalError.message, originalError && originalError.nodes || nodes, originalError && originalError.source, originalError && originalError.positions, path, originalError);
}

/***/ }),
/* 1098 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export formatError */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__jsutils_invariant__ = __webpack_require__(518);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */




/**
 * Given a GraphQLError, format it according to the rules described by the
 * Response Format, Errors section of the GraphQL Specification.
 */
function formatError(error) {
  !error ? Object(__WEBPACK_IMPORTED_MODULE_0__jsutils_invariant__["a" /* default */])(0, 'Received null or undefined error.') : void 0;
  return _extends({}, error.extensions, {
    message: error.message || 'An unknown error occurred.',
    locations: error.locations,
    path: error.path
  });
}

/***/ }),
/* 1099 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = createLexer;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TokenKind; });
/* harmony export (immutable) */ __webpack_exports__["c"] = getTokenDesc;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__error__ = __webpack_require__(519);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__blockStringValue__ = __webpack_require__(1100);
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */




/**
 * Given a Source object, this returns a Lexer for that source.
 * A Lexer is a stateful stream generator in that every time
 * it is advanced, it returns the next token in the Source. Assuming the
 * source lexes, the final Token emitted by the lexer will be of kind
 * EOF, after which the lexer will repeatedly return the same EOF token
 * whenever called.
 */
function createLexer(source, options) {
  var startOfFileToken = new Tok(TokenKind.SOF, 0, 0, 0, 0, null);
  var lexer = {
    source: source,
    options: options,
    lastToken: startOfFileToken,
    token: startOfFileToken,
    line: 1,
    lineStart: 0,
    advance: advanceLexer,
    lookahead: lookahead
  };
  return lexer;
}

function advanceLexer() {
  this.lastToken = this.token;
  var token = this.token = this.lookahead();
  return token;
}

function lookahead() {
  var token = this.token;
  if (token.kind !== TokenKind.EOF) {
    do {
      // Note: next is only mutable during parsing, so we cast to allow this.
      token = token.next || (token.next = readToken(this, token));
    } while (token.kind === TokenKind.COMMENT);
  }
  return token;
}

/**
 * The return type of createLexer.
 */


/**
 * An exported enum describing the different kinds of tokens that the
 * lexer emits.
 */
var TokenKind = Object.freeze({
  SOF: '<SOF>',
  EOF: '<EOF>',
  BANG: '!',
  DOLLAR: '$',
  AMP: '&',
  PAREN_L: '(',
  PAREN_R: ')',
  SPREAD: '...',
  COLON: ':',
  EQUALS: '=',
  AT: '@',
  BRACKET_L: '[',
  BRACKET_R: ']',
  BRACE_L: '{',
  PIPE: '|',
  BRACE_R: '}',
  NAME: 'Name',
  INT: 'Int',
  FLOAT: 'Float',
  STRING: 'String',
  BLOCK_STRING: 'BlockString',
  COMMENT: 'Comment'
});

/**
 * The enum type representing the token kinds values.
 */


/**
 * A helper function to describe a token as a string for debugging
 */
function getTokenDesc(token) {
  var value = token.value;
  return value ? token.kind + ' "' + value + '"' : token.kind;
}

var charCodeAt = String.prototype.charCodeAt;
var slice = String.prototype.slice;

/**
 * Helper function for constructing the Token object.
 */
function Tok(kind, start, end, line, column, prev, value) {
  this.kind = kind;
  this.start = start;
  this.end = end;
  this.line = line;
  this.column = column;
  this.value = value;
  this.prev = prev;
  this.next = null;
}

// Print a simplified form when appearing in JSON/util.inspect.
Tok.prototype.toJSON = Tok.prototype.inspect = function toJSON() {
  return {
    kind: this.kind,
    value: this.value,
    line: this.line,
    column: this.column
  };
};

function printCharCode(code) {
  return (
    // NaN/undefined represents access beyond the end of the file.
    isNaN(code) ? TokenKind.EOF : // Trust JSON for ASCII.
    code < 0x007f ? JSON.stringify(String.fromCharCode(code)) : // Otherwise print the escaped form.
    '"\\u' + ('00' + code.toString(16).toUpperCase()).slice(-4) + '"'
  );
}

/**
 * Gets the next token from the source starting at the given position.
 *
 * This skips over whitespace and comments until it finds the next lexable
 * token, then lexes punctuators immediately or calls the appropriate helper
 * function for more complicated tokens.
 */
function readToken(lexer, prev) {
  var source = lexer.source;
  var body = source.body;
  var bodyLength = body.length;

  var pos = positionAfterWhitespace(body, prev.end, lexer);
  var line = lexer.line;
  var col = 1 + pos - lexer.lineStart;

  if (pos >= bodyLength) {
    return new Tok(TokenKind.EOF, bodyLength, bodyLength, line, col, prev);
  }

  var code = charCodeAt.call(body, pos);

  // SourceCharacter
  if (code < 0x0020 && code !== 0x0009 && code !== 0x000a && code !== 0x000d) {
    throw Object(__WEBPACK_IMPORTED_MODULE_0__error__["a" /* syntaxError */])(source, pos, 'Cannot contain the invalid character ' + printCharCode(code) + '.');
  }

  switch (code) {
    // !
    case 33:
      return new Tok(TokenKind.BANG, pos, pos + 1, line, col, prev);
    // #
    case 35:
      return readComment(source, pos, line, col, prev);
    // $
    case 36:
      return new Tok(TokenKind.DOLLAR, pos, pos + 1, line, col, prev);
    // &
    case 38:
      return new Tok(TokenKind.AMP, pos, pos + 1, line, col, prev);
    // (
    case 40:
      return new Tok(TokenKind.PAREN_L, pos, pos + 1, line, col, prev);
    // )
    case 41:
      return new Tok(TokenKind.PAREN_R, pos, pos + 1, line, col, prev);
    // .
    case 46:
      if (charCodeAt.call(body, pos + 1) === 46 && charCodeAt.call(body, pos + 2) === 46) {
        return new Tok(TokenKind.SPREAD, pos, pos + 3, line, col, prev);
      }
      break;
    // :
    case 58:
      return new Tok(TokenKind.COLON, pos, pos + 1, line, col, prev);
    // =
    case 61:
      return new Tok(TokenKind.EQUALS, pos, pos + 1, line, col, prev);
    // @
    case 64:
      return new Tok(TokenKind.AT, pos, pos + 1, line, col, prev);
    // [
    case 91:
      return new Tok(TokenKind.BRACKET_L, pos, pos + 1, line, col, prev);
    // ]
    case 93:
      return new Tok(TokenKind.BRACKET_R, pos, pos + 1, line, col, prev);
    // {
    case 123:
      return new Tok(TokenKind.BRACE_L, pos, pos + 1, line, col, prev);
    // |
    case 124:
      return new Tok(TokenKind.PIPE, pos, pos + 1, line, col, prev);
    // }
    case 125:
      return new Tok(TokenKind.BRACE_R, pos, pos + 1, line, col, prev);
    // A-Z _ a-z
    case 65:
    case 66:
    case 67:
    case 68:
    case 69:
    case 70:
    case 71:
    case 72:
    case 73:
    case 74:
    case 75:
    case 76:
    case 77:
    case 78:
    case 79:
    case 80:
    case 81:
    case 82:
    case 83:
    case 84:
    case 85:
    case 86:
    case 87:
    case 88:
    case 89:
    case 90:
    case 95:
    case 97:
    case 98:
    case 99:
    case 100:
    case 101:
    case 102:
    case 103:
    case 104:
    case 105:
    case 106:
    case 107:
    case 108:
    case 109:
    case 110:
    case 111:
    case 112:
    case 113:
    case 114:
    case 115:
    case 116:
    case 117:
    case 118:
    case 119:
    case 120:
    case 121:
    case 122:
      return readName(source, pos, line, col, prev);
    // - 0-9
    case 45:
    case 48:
    case 49:
    case 50:
    case 51:
    case 52:
    case 53:
    case 54:
    case 55:
    case 56:
    case 57:
      return readNumber(source, pos, code, line, col, prev);
    // "
    case 34:
      if (charCodeAt.call(body, pos + 1) === 34 && charCodeAt.call(body, pos + 2) === 34) {
        return readBlockString(source, pos, line, col, prev);
      }
      return readString(source, pos, line, col, prev);
  }

  throw Object(__WEBPACK_IMPORTED_MODULE_0__error__["a" /* syntaxError */])(source, pos, unexpectedCharacterMessage(code));
}

/**
 * Report a message that an unexpected character was encountered.
 */
function unexpectedCharacterMessage(code) {
  if (code === 39) {
    // '
    return "Unexpected single quote character ('), did you mean to use " + 'a double quote (")?';
  }

  return 'Cannot parse the unexpected character ' + printCharCode(code) + '.';
}

/**
 * Reads from body starting at startPosition until it finds a non-whitespace
 * or commented character, then returns the position of that character for
 * lexing.
 */
function positionAfterWhitespace(body, startPosition, lexer) {
  var bodyLength = body.length;
  var position = startPosition;
  while (position < bodyLength) {
    var code = charCodeAt.call(body, position);
    // tab | space | comma | BOM
    if (code === 9 || code === 32 || code === 44 || code === 0xfeff) {
      ++position;
    } else if (code === 10) {
      // new line
      ++position;
      ++lexer.line;
      lexer.lineStart = position;
    } else if (code === 13) {
      // carriage return
      if (charCodeAt.call(body, position + 1) === 10) {
        position += 2;
      } else {
        ++position;
      }
      ++lexer.line;
      lexer.lineStart = position;
    } else {
      break;
    }
  }
  return position;
}

/**
 * Reads a comment token from the source file.
 *
 * #[\u0009\u0020-\uFFFF]*
 */
function readComment(source, start, line, col, prev) {
  var body = source.body;
  var code = void 0;
  var position = start;

  do {
    code = charCodeAt.call(body, ++position);
  } while (code !== null && (
  // SourceCharacter but not LineTerminator
  code > 0x001f || code === 0x0009));

  return new Tok(TokenKind.COMMENT, start, position, line, col, prev, slice.call(body, start + 1, position));
}

/**
 * Reads a number token from the source file, either a float
 * or an int depending on whether a decimal point appears.
 *
 * Int:   -?(0|[1-9][0-9]*)
 * Float: -?(0|[1-9][0-9]*)(\.[0-9]+)?((E|e)(+|-)?[0-9]+)?
 */
function readNumber(source, start, firstCode, line, col, prev) {
  var body = source.body;
  var code = firstCode;
  var position = start;
  var isFloat = false;

  if (code === 45) {
    // -
    code = charCodeAt.call(body, ++position);
  }

  if (code === 48) {
    // 0
    code = charCodeAt.call(body, ++position);
    if (code >= 48 && code <= 57) {
      throw Object(__WEBPACK_IMPORTED_MODULE_0__error__["a" /* syntaxError */])(source, position, 'Invalid number, unexpected digit after 0: ' + printCharCode(code) + '.');
    }
  } else {
    position = readDigits(source, position, code);
    code = charCodeAt.call(body, position);
  }

  if (code === 46) {
    // .
    isFloat = true;

    code = charCodeAt.call(body, ++position);
    position = readDigits(source, position, code);
    code = charCodeAt.call(body, position);
  }

  if (code === 69 || code === 101) {
    // E e
    isFloat = true;

    code = charCodeAt.call(body, ++position);
    if (code === 43 || code === 45) {
      // + -
      code = charCodeAt.call(body, ++position);
    }
    position = readDigits(source, position, code);
  }

  return new Tok(isFloat ? TokenKind.FLOAT : TokenKind.INT, start, position, line, col, prev, slice.call(body, start, position));
}

/**
 * Returns the new position in the source after reading digits.
 */
function readDigits(source, start, firstCode) {
  var body = source.body;
  var position = start;
  var code = firstCode;
  if (code >= 48 && code <= 57) {
    // 0 - 9
    do {
      code = charCodeAt.call(body, ++position);
    } while (code >= 48 && code <= 57); // 0 - 9
    return position;
  }
  throw Object(__WEBPACK_IMPORTED_MODULE_0__error__["a" /* syntaxError */])(source, position, 'Invalid number, expected digit but got: ' + printCharCode(code) + '.');
}

/**
 * Reads a string token from the source file.
 *
 * "([^"\\\u000A\u000D]|(\\(u[0-9a-fA-F]{4}|["\\/bfnrt])))*"
 */
function readString(source, start, line, col, prev) {
  var body = source.body;
  var position = start + 1;
  var chunkStart = position;
  var code = 0;
  var value = '';

  while (position < body.length && (code = charCodeAt.call(body, position)) !== null &&
  // not LineTerminator
  code !== 0x000a && code !== 0x000d) {
    // Closing Quote (")
    if (code === 34) {
      value += slice.call(body, chunkStart, position);
      return new Tok(TokenKind.STRING, start, position + 1, line, col, prev, value);
    }

    // SourceCharacter
    if (code < 0x0020 && code !== 0x0009) {
      throw Object(__WEBPACK_IMPORTED_MODULE_0__error__["a" /* syntaxError */])(source, position, 'Invalid character within String: ' + printCharCode(code) + '.');
    }

    ++position;
    if (code === 92) {
      // \
      value += slice.call(body, chunkStart, position - 1);
      code = charCodeAt.call(body, position);
      switch (code) {
        case 34:
          value += '"';
          break;
        case 47:
          value += '/';
          break;
        case 92:
          value += '\\';
          break;
        case 98:
          value += '\b';
          break;
        case 102:
          value += '\f';
          break;
        case 110:
          value += '\n';
          break;
        case 114:
          value += '\r';
          break;
        case 116:
          value += '\t';
          break;
        case 117:
          // u
          var charCode = uniCharCode(charCodeAt.call(body, position + 1), charCodeAt.call(body, position + 2), charCodeAt.call(body, position + 3), charCodeAt.call(body, position + 4));
          if (charCode < 0) {
            throw Object(__WEBPACK_IMPORTED_MODULE_0__error__["a" /* syntaxError */])(source, position, 'Invalid character escape sequence: ' + ('\\u' + body.slice(position + 1, position + 5) + '.'));
          }
          value += String.fromCharCode(charCode);
          position += 4;
          break;
        default:
          throw Object(__WEBPACK_IMPORTED_MODULE_0__error__["a" /* syntaxError */])(source, position, 'Invalid character escape sequence: \\' + String.fromCharCode(code) + '.');
      }
      ++position;
      chunkStart = position;
    }
  }

  throw Object(__WEBPACK_IMPORTED_MODULE_0__error__["a" /* syntaxError */])(source, position, 'Unterminated string.');
}

/**
 * Reads a block string token from the source file.
 *
 * """("?"?(\\"""|\\(?!=""")|[^"\\]))*"""
 */
function readBlockString(source, start, line, col, prev) {
  var body = source.body;
  var position = start + 3;
  var chunkStart = position;
  var code = 0;
  var rawValue = '';

  while (position < body.length && (code = charCodeAt.call(body, position)) !== null) {
    // Closing Triple-Quote (""")
    if (code === 34 && charCodeAt.call(body, position + 1) === 34 && charCodeAt.call(body, position + 2) === 34) {
      rawValue += slice.call(body, chunkStart, position);
      return new Tok(TokenKind.BLOCK_STRING, start, position + 3, line, col, prev, Object(__WEBPACK_IMPORTED_MODULE_1__blockStringValue__["a" /* default */])(rawValue));
    }

    // SourceCharacter
    if (code < 0x0020 && code !== 0x0009 && code !== 0x000a && code !== 0x000d) {
      throw Object(__WEBPACK_IMPORTED_MODULE_0__error__["a" /* syntaxError */])(source, position, 'Invalid character within String: ' + printCharCode(code) + '.');
    }

    // Escape Triple-Quote (\""")
    if (code === 92 && charCodeAt.call(body, position + 1) === 34 && charCodeAt.call(body, position + 2) === 34 && charCodeAt.call(body, position + 3) === 34) {
      rawValue += slice.call(body, chunkStart, position) + '"""';
      position += 4;
      chunkStart = position;
    } else {
      ++position;
    }
  }

  throw Object(__WEBPACK_IMPORTED_MODULE_0__error__["a" /* syntaxError */])(source, position, 'Unterminated string.');
}

/**
 * Converts four hexidecimal chars to the integer that the
 * string represents. For example, uniCharCode('0','0','0','f')
 * will return 15, and uniCharCode('0','0','f','f') returns 255.
 *
 * Returns a negative number on error, if a char was invalid.
 *
 * This is implemented by noting that char2hex() returns -1 on error,
 * which means the result of ORing the char2hex() will also be negative.
 */
function uniCharCode(a, b, c, d) {
  return char2hex(a) << 12 | char2hex(b) << 8 | char2hex(c) << 4 | char2hex(d);
}

/**
 * Converts a hex character to its integer value.
 * '0' becomes 0, '9' becomes 9
 * 'A' becomes 10, 'F' becomes 15
 * 'a' becomes 10, 'f' becomes 15
 *
 * Returns -1 on error.
 */
function char2hex(a) {
  return a >= 48 && a <= 57 ? a - 48 // 0-9
  : a >= 65 && a <= 70 ? a - 55 // A-F
  : a >= 97 && a <= 102 ? a - 87 // a-f
  : -1;
}

/**
 * Reads an alphanumeric + underscore name from the source.
 *
 * [_A-Za-z][_0-9A-Za-z]*
 */
function readName(source, start, line, col, prev) {
  var body = source.body;
  var bodyLength = body.length;
  var position = start + 1;
  var code = 0;
  while (position !== bodyLength && (code = charCodeAt.call(body, position)) !== null && (code === 95 || // _
  code >= 48 && code <= 57 || // 0-9
  code >= 65 && code <= 90 || // A-Z
  code >= 97 && code <= 122) // a-z
  ) {
    ++position;
  }
  return new Tok(TokenKind.NAME, start, position, line, col, prev, slice.call(body, start, position));
}

/***/ }),
/* 1100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = blockStringValue;
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */

/**
 * Produces the value of a block string from its parsed raw value, similar to
 * Coffeescript's block string, Python's docstring trim or Ruby's strip_heredoc.
 *
 * This implements the GraphQL spec's BlockStringValue() static algorithm.
 */
function blockStringValue(rawString) {
  // Expand a block string's raw value into independent lines.
  var lines = rawString.split(/\r\n|[\n\r]/g);

  // Remove common indentation from all lines but first.
  var commonIndent = null;
  for (var i = 1; i < lines.length; i++) {
    var line = lines[i];
    var indent = leadingWhitespace(line);
    if (indent < line.length && (commonIndent === null || indent < commonIndent)) {
      commonIndent = indent;
      if (commonIndent === 0) {
        break;
      }
    }
  }

  if (commonIndent) {
    for (var _i = 1; _i < lines.length; _i++) {
      lines[_i] = lines[_i].slice(commonIndent);
    }
  }

  // Remove leading and trailing blank lines.
  while (lines.length > 0 && isBlank(lines[0])) {
    lines.shift();
  }
  while (lines.length > 0 && isBlank(lines[lines.length - 1])) {
    lines.pop();
  }

  // Return a string of the lines joined with U+000A.
  return lines.join('\n');
}

function leadingWhitespace(str) {
  var i = 0;
  while (i < str.length && (str[i] === ' ' || str[i] === '\t')) {
    i++;
  }
  return i;
}

function isBlank(str) {
  return leadingWhitespace(str) === str.length;
}

/***/ }),
/* 1101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Kind; });
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */

/**
 * The set of allowed kind values for AST nodes.
 */
var Kind = Object.freeze({
  // Name
  NAME: 'Name',

  // Document
  DOCUMENT: 'Document',
  OPERATION_DEFINITION: 'OperationDefinition',
  VARIABLE_DEFINITION: 'VariableDefinition',
  VARIABLE: 'Variable',
  SELECTION_SET: 'SelectionSet',
  FIELD: 'Field',
  ARGUMENT: 'Argument',

  // Fragments
  FRAGMENT_SPREAD: 'FragmentSpread',
  INLINE_FRAGMENT: 'InlineFragment',
  FRAGMENT_DEFINITION: 'FragmentDefinition',

  // Values
  INT: 'IntValue',
  FLOAT: 'FloatValue',
  STRING: 'StringValue',
  BOOLEAN: 'BooleanValue',
  NULL: 'NullValue',
  ENUM: 'EnumValue',
  LIST: 'ListValue',
  OBJECT: 'ObjectValue',
  OBJECT_FIELD: 'ObjectField',

  // Directives
  DIRECTIVE: 'Directive',

  // Types
  NAMED_TYPE: 'NamedType',
  LIST_TYPE: 'ListType',
  NON_NULL_TYPE: 'NonNullType',

  // Type System Definitions
  SCHEMA_DEFINITION: 'SchemaDefinition',
  OPERATION_TYPE_DEFINITION: 'OperationTypeDefinition',

  // Type Definitions
  SCALAR_TYPE_DEFINITION: 'ScalarTypeDefinition',
  OBJECT_TYPE_DEFINITION: 'ObjectTypeDefinition',
  FIELD_DEFINITION: 'FieldDefinition',
  INPUT_VALUE_DEFINITION: 'InputValueDefinition',
  INTERFACE_TYPE_DEFINITION: 'InterfaceTypeDefinition',
  UNION_TYPE_DEFINITION: 'UnionTypeDefinition',
  ENUM_TYPE_DEFINITION: 'EnumTypeDefinition',
  ENUM_VALUE_DEFINITION: 'EnumValueDefinition',
  INPUT_OBJECT_TYPE_DEFINITION: 'InputObjectTypeDefinition',

  // Type Extensions
  SCALAR_TYPE_EXTENSION: 'ScalarTypeExtension',
  OBJECT_TYPE_EXTENSION: 'ObjectTypeExtension',
  INTERFACE_TYPE_EXTENSION: 'InterfaceTypeExtension',
  UNION_TYPE_EXTENSION: 'UnionTypeExtension',
  ENUM_TYPE_EXTENSION: 'EnumTypeExtension',
  INPUT_OBJECT_TYPE_EXTENSION: 'InputObjectTypeExtension',

  // Directive Definitions
  DIRECTIVE_DEFINITION: 'DirectiveDefinition'
});

/**
 * The enum type representing the possible kind values of AST nodes.
 */

/***/ }),
/* 1102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DirectiveLocation; });
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */

/**
 * The set of allowed directive location values.
 */
var DirectiveLocation = Object.freeze({
  // Request Definitions
  QUERY: 'QUERY',
  MUTATION: 'MUTATION',
  SUBSCRIPTION: 'SUBSCRIPTION',
  FIELD: 'FIELD',
  FRAGMENT_DEFINITION: 'FRAGMENT_DEFINITION',
  FRAGMENT_SPREAD: 'FRAGMENT_SPREAD',
  INLINE_FRAGMENT: 'INLINE_FRAGMENT',
  // Type System Definitions
  SCHEMA: 'SCHEMA',
  SCALAR: 'SCALAR',
  OBJECT: 'OBJECT',
  FIELD_DEFINITION: 'FIELD_DEFINITION',
  ARGUMENT_DEFINITION: 'ARGUMENT_DEFINITION',
  INTERFACE: 'INTERFACE',
  UNION: 'UNION',
  ENUM: 'ENUM',
  ENUM_VALUE: 'ENUM_VALUE',
  INPUT_OBJECT: 'INPUT_OBJECT',
  INPUT_FIELD_DEFINITION: 'INPUT_FIELD_DEFINITION'
});

/**
 * The enum type representing the directive location values.
 */

/***/ }),
/* 1103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getDirectiveInfoFromField;
/* harmony export (immutable) */ __webpack_exports__["c"] = shouldInclude;
/* unused harmony export flattenSelections */
/* unused harmony export getDirectiveNames */
/* harmony export (immutable) */ __webpack_exports__["b"] = hasDirectives;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__storeUtils__ = __webpack_require__(337);

function getDirectiveInfoFromField(field, variables) {
    if (field.directives && field.directives.length) {
        var directiveObj_1 = {};
        field.directives.forEach(function (directive) {
            directiveObj_1[directive.name.value] = Object(__WEBPACK_IMPORTED_MODULE_0__storeUtils__["a" /* argumentsObjectFromField */])(directive, variables);
        });
        return directiveObj_1;
    }
    return null;
}
function shouldInclude(selection, variables) {
    if (variables === void 0) { variables = {}; }
    if (!selection.directives) {
        return true;
    }
    var res = true;
    selection.directives.forEach(function (directive) {
        if (directive.name.value !== 'skip' && directive.name.value !== 'include') {
            return;
        }
        var directiveArguments = directive.arguments || [];
        var directiveName = directive.name.value;
        if (directiveArguments.length !== 1) {
            throw new Error("Incorrect number of arguments for the @" + directiveName + " directive.");
        }
        var ifArgument = directiveArguments[0];
        if (!ifArgument.name || ifArgument.name.value !== 'if') {
            throw new Error("Invalid argument for the @" + directiveName + " directive.");
        }
        var ifValue = directiveArguments[0].value;
        var evaledValue = false;
        if (!ifValue || ifValue.kind !== 'BooleanValue') {
            if (ifValue.kind !== 'Variable') {
                throw new Error("Argument for the @" + directiveName + " directive must be a variable or a boolean value.");
            }
            else {
                evaledValue = variables[ifValue.name.value];
                if (evaledValue === undefined) {
                    throw new Error("Invalid variable referenced in @" + directiveName + " directive.");
                }
            }
        }
        else {
            evaledValue = ifValue.value;
        }
        if (directiveName === 'skip') {
            evaledValue = !evaledValue;
        }
        if (!evaledValue) {
            res = false;
        }
    });
    return res;
}
function flattenSelections(selection) {
    if (!selection.selectionSet ||
        !(selection.selectionSet.selections.length > 0))
        return [selection];
    return [selection].concat(selection.selectionSet.selections
        .map(function (selectionNode) {
        return [selectionNode].concat(flattenSelections(selectionNode));
    })
        .reduce(function (selections, selected) { return selections.concat(selected); }, []));
}
function getDirectiveNames(doc) {
    var directiveNames = doc.definitions
        .filter(function (definition) {
        return definition.selectionSet && definition.selectionSet.selections;
    })
        .map(function (x) { return flattenSelections(x); })
        .reduce(function (selections, selected) { return selections.concat(selected); }, [])
        .filter(function (selection) {
        return selection.directives && selection.directives.length > 0;
    })
        .map(function (selection) { return selection.directives; })
        .reduce(function (directives, directive) { return directives.concat(directive); }, [])
        .map(function (directive) { return directive.name.value; });
    return directiveNames;
}
function hasDirectives(names, doc) {
    return getDirectiveNames(doc).some(function (name) { return names.indexOf(name) > -1; });
}
//# sourceMappingURL=directives.js.map

/***/ }),
/* 1104 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (data, opts) {
    if (!opts) opts = {};
    if (typeof opts === 'function') opts = { cmp: opts };
    var cycles = (typeof opts.cycles === 'boolean') ? opts.cycles : false;

    var cmp = opts.cmp && (function (f) {
        return function (node) {
            return function (a, b) {
                var aobj = { key: a, value: node[a] };
                var bobj = { key: b, value: node[b] };
                return f(aobj, bobj);
            };
        };
    })(opts.cmp);

    var seen = [];
    return (function stringify (node) {
        if (node && node.toJSON && typeof node.toJSON === 'function') {
            node = node.toJSON();
        }

        if (node === undefined) return;
        if (typeof node == 'number') return isFinite(node) ? '' + node : 'null';
        if (typeof node !== 'object') return JSON.stringify(node);

        var i, out;
        if (Array.isArray(node)) {
            out = '[';
            for (i = 0; i < node.length; i++) {
                if (i) out += ',';
                out += stringify(node[i]) || 'null';
            }
            return out + ']';
        }

        if (node === null) return 'null';

        if (seen.indexOf(node) !== -1) {
            if (cycles) return JSON.stringify('__cycle__');
            throw new TypeError('Converting circular structure to JSON');
        }

        var seenIndex = seen.push(node) - 1;
        var keys = Object.keys(node).sort(cmp && cmp(node));
        out = '';
        for (i = 0; i < keys.length; i++) {
            var key = keys[i];
            var value = stringify(node[key]);

            if (!value) continue;
            if (out) out += ',';
            out += JSON.stringify(key) + ':' + value;
        }
        seen.splice(seenIndex, 1);
        return '{' + out + '}';
    })(data);
};


/***/ }),
/* 1105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getFragmentQueryDocument;
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function getFragmentQueryDocument(document, fragmentName) {
    var actualFragmentName = fragmentName;
    var fragments = [];
    document.definitions.forEach(function (definition) {
        if (definition.kind === 'OperationDefinition') {
            throw new Error("Found a " + definition.operation + " operation" + (definition.name ? " named '" + definition.name.value + "'" : '') + ". " +
                'No operations are allowed when using a fragment as a query. Only fragments are allowed.');
        }
        if (definition.kind === 'FragmentDefinition') {
            fragments.push(definition);
        }
    });
    if (typeof actualFragmentName === 'undefined') {
        if (fragments.length !== 1) {
            throw new Error("Found " + fragments.length + " fragments. `fragmentName` must be provided when there is not exactly 1 fragment.");
        }
        actualFragmentName = fragments[0].name.value;
    }
    var query = __assign({}, document, { definitions: [
            {
                kind: 'OperationDefinition',
                operation: 'query',
                selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                        {
                            kind: 'FragmentSpread',
                            name: {
                                kind: 'Name',
                                value: actualFragmentName,
                            },
                        },
                    ],
                },
            }
        ].concat(document.definitions) });
    return query;
}
//# sourceMappingURL=fragments.js.map

/***/ }),
/* 1106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export removeDirectivesFromDocument */
/* harmony export (immutable) */ __webpack_exports__["a"] = addTypenameToDocument;
/* harmony export (immutable) */ __webpack_exports__["b"] = removeConnectionDirectiveFromDocument;
/* unused harmony export getDirectivesFromDocument */
/* unused harmony export removeArgumentsFromDocument */
/* unused harmony export removeFragmentSpreadFromDocument */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_cloneDeep__ = __webpack_require__(525);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getFromAST__ = __webpack_require__(523);


var TYPENAME_FIELD = {
    kind: 'Field',
    name: {
        kind: 'Name',
        value: '__typename',
    },
};
function isNotEmpty(op, fragments) {
    return (op.selectionSet.selections.filter(function (selectionSet) {
        return !(selectionSet &&
            selectionSet.kind === 'FragmentSpread' &&
            !isNotEmpty(fragments[selectionSet.name.value], fragments));
    }).length > 0);
}
function getDirectiveMatcher(directives) {
    return function directiveMatcher(directive) {
        return directives.some(function (dir) {
            if (dir.name && dir.name === directive.name.value)
                return true;
            if (dir.test && dir.test(directive))
                return true;
            return false;
        });
    };
}
function addTypenameToSelectionSet(selectionSet, isRoot) {
    if (isRoot === void 0) { isRoot = false; }
    if (selectionSet.selections) {
        if (!isRoot) {
            var alreadyHasThisField = selectionSet.selections.some(function (selection) {
                return (selection.kind === 'Field' &&
                    selection.name.value === '__typename');
            });
            if (!alreadyHasThisField) {
                selectionSet.selections.push(TYPENAME_FIELD);
            }
        }
        selectionSet.selections.forEach(function (selection) {
            if (selection.kind === 'Field') {
                if (selection.name.value.lastIndexOf('__', 0) !== 0 &&
                    selection.selectionSet) {
                    addTypenameToSelectionSet(selection.selectionSet);
                }
            }
            else if (selection.kind === 'InlineFragment') {
                if (selection.selectionSet) {
                    addTypenameToSelectionSet(selection.selectionSet);
                }
            }
        });
    }
}
function getSelectionsMatchingDirectiveFromSelectionSet(directives, selectionSet, invert, fieldsOnly) {
    if (invert === void 0) { invert = false; }
    if (fieldsOnly === void 0) { fieldsOnly = false; }
    return selectionSet.selections
        .map(function (selection) {
        if (selection.kind !== 'Field' ||
            !selection ||
            !selection.directives) {
            return fieldsOnly ? null : selection;
        }
        var isMatch;
        var directiveMatcher = getDirectiveMatcher(directives);
        selection.directives = selection.directives.filter(function (directive) {
            var shouldKeep = !directiveMatcher(directive);
            if (!isMatch && !shouldKeep) {
                isMatch = true;
            }
            return shouldKeep;
        });
        return isMatch && invert ? null : selection;
    })
        .filter(function (s) { return !!s; });
}
function removeDirectivesFromSelectionSet(directives, selectionSet) {
    if (!selectionSet.selections)
        return selectionSet;
    var agressiveRemove = directives.some(function (dir) { return dir.remove; });
    selectionSet.selections = getSelectionsMatchingDirectiveFromSelectionSet(directives, selectionSet, agressiveRemove);
    selectionSet.selections.forEach(function (selection) {
        if ((selection.kind === 'Field' || selection.kind === 'InlineFragment') &&
            selection.selectionSet) {
            removeDirectivesFromSelectionSet(directives, selection.selectionSet);
        }
    });
    return selectionSet;
}
function removeDirectivesFromDocument(directives, doc) {
    var docClone = Object(__WEBPACK_IMPORTED_MODULE_0__util_cloneDeep__["a" /* cloneDeep */])(doc);
    var removedArguments = [];
    var removedFragments = [];
    var aggressiveRemove = directives.some(function (directive) { return directive.remove; });
    docClone.definitions.forEach(function (definition) {
        var operationDefinition = definition;
        var originalSelectionSet = Object(__WEBPACK_IMPORTED_MODULE_0__util_cloneDeep__["a" /* cloneDeep */])(operationDefinition.selectionSet);
        var newSelectionSet = removeDirectivesFromSelectionSet(directives, operationDefinition.selectionSet);
        if (aggressiveRemove && !!docClone) {
            var matchingSelections = getSelectionsMatchingDirectiveFromSelectionSet(directives.map(function (config) { return ({
                name: config.name,
                test: config.test,
            }); }), originalSelectionSet);
            var remainingArguments_1 = getAllArgumentsFromSelectionSet(newSelectionSet);
            removedArguments = removedArguments.concat(matchingSelections
                .map(getAllArgumentsFromSelection)
                .reduce(function (allArguments, selectionArguments) { return allArguments.concat(selectionArguments); }, [])
                .filter(function (removedArg) {
                return !remainingArguments_1.some(function (remainingArg) {
                    if (remainingArg.value.kind !== 'Variable' ||
                        !remainingArg.value)
                        return false;
                    if (removedArg.value.kind !== 'Variable' ||
                        !removedArg.value)
                        return false;
                    return (remainingArg.value.name.value === removedArg.value.name.value);
                });
            })
                .map(function (argument) {
                if (argument.value.kind !== 'Variable' ||
                    !argument.value)
                    return null;
                return {
                    name: argument.value.name.value,
                    remove: aggressiveRemove,
                };
            })
                .filter(function (node) { return !!node; }));
            var remainingFragmentSpreads_1 = getAllFragmentSpreadsFromSelectionSet(newSelectionSet);
            removedFragments = removedFragments.concat(matchingSelections
                .map(getAllFragmentSpreadsFromSelection)
                .reduce(function (allFragments, selectionFragments) { return allFragments.concat(selectionFragments); }, [])
                .filter(function (removedFragment) {
                return !remainingFragmentSpreads_1.some(function (remainingFragment) {
                    return remainingFragment.name.value === removedFragment.name.value;
                });
            })
                .map(function (fragment) { return ({
                name: fragment.name.value,
                remove: aggressiveRemove,
            }); }));
        }
    });
    if (!docClone) {
        return null;
    }
    if (removedFragments.length > 0) {
        docClone = removeFragmentSpreadFromDocument(removedFragments, docClone);
        if (!docClone) {
            return null;
        }
    }
    if (removedArguments.length > 0) {
        docClone = removeArgumentsFromDocument(removedArguments, docClone);
        if (!docClone) {
            return null;
        }
    }
    var operation = Object(__WEBPACK_IMPORTED_MODULE_1__getFromAST__["h" /* getOperationDefinitionOrDie */])(docClone);
    var fragments = Object(__WEBPACK_IMPORTED_MODULE_1__getFromAST__["b" /* createFragmentMap */])(Object(__WEBPACK_IMPORTED_MODULE_1__getFromAST__["d" /* getFragmentDefinitions */])(docClone));
    return isNotEmpty(operation, fragments) ? docClone : null;
}
function addTypenameToDocument(doc) {
    Object(__WEBPACK_IMPORTED_MODULE_1__getFromAST__["a" /* checkDocument */])(doc);
    var docClone = Object(__WEBPACK_IMPORTED_MODULE_0__util_cloneDeep__["a" /* cloneDeep */])(doc);
    docClone.definitions.forEach(function (definition) {
        var isRoot = definition.kind === 'OperationDefinition';
        addTypenameToSelectionSet(definition.selectionSet, isRoot);
    });
    return docClone;
}
var connectionRemoveConfig = {
    test: function (directive) {
        var willRemove = directive.name.value === 'connection';
        if (willRemove) {
            if (!directive.arguments ||
                !directive.arguments.some(function (arg) { return arg.name.value === 'key'; })) {
                console.warn('Removing an @connection directive even though it does not have a key. ' +
                    'You may want to use the key parameter to specify a store key.');
            }
        }
        return willRemove;
    },
};
function removeConnectionDirectiveFromDocument(doc) {
    Object(__WEBPACK_IMPORTED_MODULE_1__getFromAST__["a" /* checkDocument */])(doc);
    return removeDirectivesFromDocument([connectionRemoveConfig], doc);
}
function hasDirectivesInSelectionSet(directives, selectionSet, nestedCheck) {
    if (nestedCheck === void 0) { nestedCheck = true; }
    return filterSelectionSet(selectionSet, function (selection) {
        return hasDirectivesInSelection(directives, selection, nestedCheck);
    });
}
function hasDirectivesInSelection(directives, selection, nestedCheck) {
    if (nestedCheck === void 0) { nestedCheck = true; }
    if (selection.kind !== 'Field' || !selection) {
        return true;
    }
    if (!selection.directives) {
        return false;
    }
    var directiveMatcher = getDirectiveMatcher(directives);
    var matchedDirectives = selection.directives.filter(directiveMatcher);
    var hasMatches = matchedDirectives.length > 0;
    return (hasMatches ||
        (nestedCheck &&
            hasDirectivesInSelectionSet(directives, selection.selectionSet, nestedCheck)));
}
function getDirectivesFromSelectionSet(directives, selectionSet) {
    selectionSet.selections = selectionSet.selections
        .filter(function (selection) {
        return hasDirectivesInSelection(directives, selection, true);
    })
        .map(function (selection) {
        if (hasDirectivesInSelection(directives, selection, false)) {
            return selection;
        }
        if ((selection.kind === 'Field' || selection.kind === 'InlineFragment') &&
            selection.selectionSet) {
            selection.selectionSet = getDirectivesFromSelectionSet(directives, selection.selectionSet);
        }
        return selection;
    });
    return selectionSet;
}
function getDirectivesFromDocument(directives, doc, includeAllFragments) {
    if (includeAllFragments === void 0) { includeAllFragments = false; }
    Object(__WEBPACK_IMPORTED_MODULE_1__getFromAST__["a" /* checkDocument */])(doc);
    var docClone = Object(__WEBPACK_IMPORTED_MODULE_0__util_cloneDeep__["a" /* cloneDeep */])(doc);
    docClone.definitions = docClone.definitions.map(function (definition) {
        if ((definition.kind === 'OperationDefinition' ||
            (definition.kind === 'FragmentDefinition' && !includeAllFragments)) &&
            definition.selectionSet) {
            definition.selectionSet = getDirectivesFromSelectionSet(directives, definition.selectionSet);
        }
        return definition;
    });
    var operation = Object(__WEBPACK_IMPORTED_MODULE_1__getFromAST__["h" /* getOperationDefinitionOrDie */])(docClone);
    var fragments = Object(__WEBPACK_IMPORTED_MODULE_1__getFromAST__["b" /* createFragmentMap */])(Object(__WEBPACK_IMPORTED_MODULE_1__getFromAST__["d" /* getFragmentDefinitions */])(docClone));
    return isNotEmpty(operation, fragments) ? docClone : null;
}
function getArgumentMatcher(config) {
    return function (argument) {
        return config.some(function (aConfig) {
            if (argument.value.kind !== 'Variable' ||
                !argument.value)
                return false;
            if (!argument.value.name)
                return false;
            if (aConfig.name === argument.value.name.value)
                return true;
            if (aConfig.test && aConfig.test(argument))
                return true;
            return false;
        });
    };
}
function hasArgumentsInSelectionSet(config, selectionSet, nestedCheck) {
    if (nestedCheck === void 0) { nestedCheck = false; }
    return filterSelectionSet(selectionSet, function (selection) {
        return hasArgumentsInSelection(config, selection, nestedCheck);
    });
}
function hasArgumentsInSelection(config, selection, nestedCheck) {
    if (nestedCheck === void 0) { nestedCheck = false; }
    if (selection.kind !== 'Field' || !selection) {
        return true;
    }
    if (!selection.arguments) {
        return false;
    }
    var matcher = getArgumentMatcher(config);
    var matchedArguments = selection.arguments.filter(matcher);
    return (matchedArguments.length > 0 ||
        (nestedCheck &&
            hasArgumentsInSelectionSet(config, selection.selectionSet, nestedCheck)));
}
function getAllArgumentsFromSelectionSet(selectionSet) {
    return selectionSet.selections
        .map(getAllArgumentsFromSelection)
        .reduce(function (allArguments, selectionArguments) {
        return allArguments.concat(selectionArguments);
    }, []);
}
function getAllArgumentsFromSelection(selection) {
    if (selection.kind !== 'Field' || !selection) {
        return [];
    }
    return selection.arguments || [];
}
function removeArgumentsFromDocument(config, query) {
    var docClone = Object(__WEBPACK_IMPORTED_MODULE_0__util_cloneDeep__["a" /* cloneDeep */])(query);
    docClone.definitions.forEach(function (definition) {
        var operationDefinition = definition;
        var removeVariableConfig = config
            .filter(function (aConfig) { return !!aConfig.name; })
            .map(function (aConfig) { return ({
            name: aConfig.name,
            remove: aConfig.remove,
        }); });
        removeArgumentsFromSelectionSet(config, operationDefinition.selectionSet);
        removeArgumentsFromOperationDefinition(removeVariableConfig, operationDefinition);
    });
    var operation = Object(__WEBPACK_IMPORTED_MODULE_1__getFromAST__["h" /* getOperationDefinitionOrDie */])(docClone);
    var fragments = Object(__WEBPACK_IMPORTED_MODULE_1__getFromAST__["b" /* createFragmentMap */])(Object(__WEBPACK_IMPORTED_MODULE_1__getFromAST__["d" /* getFragmentDefinitions */])(docClone));
    return isNotEmpty(operation, fragments) ? docClone : null;
}
function removeArgumentsFromOperationDefinition(config, definition) {
    if (!definition.variableDefinitions)
        return definition;
    var aggressiveRemove = config.some(function (aConfig) { return aConfig.remove; });
    var remove;
    definition.variableDefinitions = definition.variableDefinitions.filter(function (aDefinition) {
        var shouldKeep = !config.some(function (aConfig) {
            if (aConfig.name === aDefinition.variable.name.value)
                return true;
            if (aConfig.test && aConfig.test(aDefinition))
                return true;
            return false;
        });
        if (!remove && !shouldKeep && aggressiveRemove) {
            remove = true;
        }
        return shouldKeep;
    });
    return definition;
}
function removeArgumentsFromSelectionSet(config, selectionSet) {
    if (!selectionSet.selections)
        return selectionSet;
    var aggressiveRemove = config.some(function (aConfig) { return aConfig.remove; });
    selectionSet.selections = selectionSet.selections
        .map(function (selection) {
        if (selection.kind !== 'Field' ||
            !selection ||
            !selection.arguments) {
            return selection;
        }
        var remove;
        var argumentMatcher = getArgumentMatcher(config);
        selection.arguments = selection.arguments.filter(function (argument) {
            var shouldKeep = !argumentMatcher(argument);
            if (!remove && !shouldKeep && aggressiveRemove) {
                remove = true;
            }
            return shouldKeep;
        });
        return remove ? null : selection;
    })
        .filter(function (x) { return !!x; });
    selectionSet.selections.forEach(function (selection) {
        if ((selection.kind === 'Field' || selection.kind === 'InlineFragment') &&
            selection.selectionSet) {
            removeArgumentsFromSelectionSet(config, selection.selectionSet);
        }
    });
    return selectionSet;
}
function hasFragmentSpreadInSelection(config, selection) {
    if (selection.kind !== 'FragmentSpread' ||
        !selection) {
        return false;
    }
    return config.some(function (aConfig) {
        if (aConfig.name === selection.name.value)
            return true;
        if (aConfig.test && aConfig.test(selection))
            return true;
        return false;
    });
}
function removeFragmentSpreadFromDocument(config, query) {
    var docClone = Object(__WEBPACK_IMPORTED_MODULE_0__util_cloneDeep__["a" /* cloneDeep */])(query);
    docClone.definitions.forEach(function (definition) {
        removeFragmentSpreadFromSelectionSet(config, definition.selectionSet);
    });
    docClone.definitions = removeFragmentSpreadFromDefinitions(config
        .filter(function (aConfig) { return !!aConfig.name; })
        .map(function (aConfig) { return ({ name: aConfig.name }); }), docClone.definitions);
    var operation = Object(__WEBPACK_IMPORTED_MODULE_1__getFromAST__["h" /* getOperationDefinitionOrDie */])(docClone);
    var fragments = Object(__WEBPACK_IMPORTED_MODULE_1__getFromAST__["b" /* createFragmentMap */])(Object(__WEBPACK_IMPORTED_MODULE_1__getFromAST__["d" /* getFragmentDefinitions */])(docClone));
    return isNotEmpty(operation, fragments) ? docClone : null;
}
function removeFragmentSpreadFromDefinitions(config, definitions) {
    return definitions.filter(function (definition) {
        if (definition.kind !== 'FragmentDefinition' ||
            !definition) {
            return true;
        }
        return !config.some(function (aConfig) {
            if (aConfig.name && aConfig.name === definition.name.value)
                return true;
            if (aConfig.test && aConfig.test(definition))
                return true;
            return false;
        });
    });
}
function removeFragmentSpreadFromSelectionSet(config, selectionSet) {
    if (!selectionSet.selections)
        return selectionSet;
    selectionSet.selections = selectionSet.selections.filter(function (selection) { return !hasFragmentSpreadInSelection(config, selection); });
    selectionSet.selections.forEach(function (selection) {
        if ((selection.kind === 'Field' || selection.kind === 'InlineFragment') &&
            selection.selectionSet) {
            removeFragmentSpreadFromSelectionSet(config, selection.selectionSet);
        }
    });
    return selectionSet;
}
function getAllFragmentSpreadsFromSelectionSet(selectionSet) {
    return selectionSet.selections
        .map(getAllFragmentSpreadsFromSelection)
        .reduce(function (allFragments, selectionFragments) { return allFragments.concat(selectionFragments); }, []);
}
function getAllFragmentSpreadsFromSelection(selection) {
    if ((selection.kind === 'Field' || selection.kind === 'InlineFragment') &&
        selection.selectionSet) {
        return getAllFragmentSpreadsFromSelectionSet(selection.selectionSet);
    }
    else if (selection.kind === 'FragmentSpread' &&
        selection) {
        return [selection];
    }
    return [];
}
function filterSelectionSet(selectionSet, filter) {
    if (!(selectionSet && selectionSet.selections)) {
        return false;
    }
    return selectionSet.selections.filter(filter).length > 0;
}
//# sourceMappingURL=transform.js.map

/***/ }),
/* 1107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = tryFunctionOrLogError;
/* harmony export (immutable) */ __webpack_exports__["a"] = graphQLResultHasError;
function tryFunctionOrLogError(f) {
    try {
        return f();
    }
    catch (e) {
        if (console.error) {
            console.error(e);
        }
    }
}
function graphQLResultHasError(result) {
    return result.errors && result.errors.length;
}
//# sourceMappingURL=errorHandling.js.map

/***/ }),
/* 1108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isEqual;
function isEqual(a, b) {
    if (a === b) {
        return true;
    }
    if (a instanceof Date && b instanceof Date) {
        return a.getTime() === b.getTime();
    }
    if (a != null &&
        typeof a === 'object' &&
        b != null &&
        typeof b === 'object') {
        for (var key in a) {
            if (Object.prototype.hasOwnProperty.call(a, key)) {
                if (!Object.prototype.hasOwnProperty.call(b, key)) {
                    return false;
                }
                if (!isEqual(a[key], b[key])) {
                    return false;
                }
            }
        }
        for (var key in b) {
            if (Object.prototype.hasOwnProperty.call(b, key) &&
                !Object.prototype.hasOwnProperty.call(a, key)) {
                return false;
            }
        }
        return true;
    }
    return false;
}
//# sourceMappingURL=isEqual.js.map

/***/ }),
/* 1109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export maybeDeepFreeze */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__environment__ = __webpack_require__(338);

function deepFreeze(o) {
    Object.freeze(o);
    Object.getOwnPropertyNames(o).forEach(function (prop) {
        if (o[prop] !== null &&
            (typeof o[prop] === 'object' || typeof o[prop] === 'function') &&
            !Object.isFrozen(o[prop])) {
            deepFreeze(o[prop]);
        }
    });
    return o;
}
function maybeDeepFreeze(obj) {
    if (Object(__WEBPACK_IMPORTED_MODULE_0__environment__["a" /* isDevelopment */])() || Object(__WEBPACK_IMPORTED_MODULE_0__environment__["c" /* isTest */])()) {
        var symbolIsPolyfilled = typeof Symbol === 'function' && typeof Symbol('') === 'string';
        if (!symbolIsPolyfilled) {
            return deepFreeze(obj);
        }
    }
    return obj;
}
//# sourceMappingURL=maybeDeepFreeze.js.map

/***/ }),
/* 1110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = warnOnceInDevelopment;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__environment__ = __webpack_require__(338);

var haveWarned = Object.create({});
function warnOnceInDevelopment(msg, type) {
    if (type === void 0) { type = 'warn'; }
    if (Object(__WEBPACK_IMPORTED_MODULE_0__environment__["b" /* isProduction */])()) {
        return;
    }
    if (!haveWarned[msg]) {
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__environment__["c" /* isTest */])()) {
            haveWarned[msg] = true;
        }
        switch (type) {
            case 'error':
                console.error(msg);
                break;
            default:
                console.warn(msg);
        }
    }
}
//# sourceMappingURL=warnOnce.js.map

/***/ }),
/* 1111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export stripSymbols */
function stripSymbols(data) {
    return JSON.parse(JSON.stringify(data));
}
//# sourceMappingURL=stripSymbols.js.map

/***/ }),
/* 1112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return empty; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return from; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return split; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return concat; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ApolloLink; });
/* harmony export (immutable) */ __webpack_exports__["d"] = execute;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zen_observable_ts__ = __webpack_require__(339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__linkUtils__ = __webpack_require__(528);


var passthrough = function (op, forward) { return (forward ? forward(op) : __WEBPACK_IMPORTED_MODULE_0_zen_observable_ts__["a" /* default */].of()); };
var toLink = function (handler) {
    return typeof handler === 'function' ? new ApolloLink(handler) : handler;
};
var empty = function () {
    return new ApolloLink(function (op, forward) { return __WEBPACK_IMPORTED_MODULE_0_zen_observable_ts__["a" /* default */].of(); });
};
var from = function (links) {
    if (links.length === 0)
        return empty();
    return links.map(toLink).reduce(function (x, y) { return x.concat(y); });
};
var split = function (test, left, right) {
    if (right === void 0) { right = new ApolloLink(passthrough); }
    var leftLink = toLink(left);
    var rightLink = toLink(right);
    if (Object(__WEBPACK_IMPORTED_MODULE_1__linkUtils__["e" /* isTerminating */])(leftLink) && Object(__WEBPACK_IMPORTED_MODULE_1__linkUtils__["e" /* isTerminating */])(rightLink)) {
        return new ApolloLink(function (operation) {
            return test(operation)
                ? leftLink.request(operation) || __WEBPACK_IMPORTED_MODULE_0_zen_observable_ts__["a" /* default */].of()
                : rightLink.request(operation) || __WEBPACK_IMPORTED_MODULE_0_zen_observable_ts__["a" /* default */].of();
        });
    }
    else {
        return new ApolloLink(function (operation, forward) {
            return test(operation)
                ? leftLink.request(operation, forward) || __WEBPACK_IMPORTED_MODULE_0_zen_observable_ts__["a" /* default */].of()
                : rightLink.request(operation, forward) || __WEBPACK_IMPORTED_MODULE_0_zen_observable_ts__["a" /* default */].of();
        });
    }
};
// join two Links together
var concat = function (first, second) {
    var firstLink = toLink(first);
    if (Object(__WEBPACK_IMPORTED_MODULE_1__linkUtils__["e" /* isTerminating */])(firstLink)) {
        console.warn(new __WEBPACK_IMPORTED_MODULE_1__linkUtils__["a" /* LinkError */]("You are calling concat on a terminating link, which will have no effect", firstLink));
        return firstLink;
    }
    var nextLink = toLink(second);
    if (Object(__WEBPACK_IMPORTED_MODULE_1__linkUtils__["e" /* isTerminating */])(nextLink)) {
        return new ApolloLink(function (operation) {
            return firstLink.request(operation, function (op) { return nextLink.request(op) || __WEBPACK_IMPORTED_MODULE_0_zen_observable_ts__["a" /* default */].of(); }) || __WEBPACK_IMPORTED_MODULE_0_zen_observable_ts__["a" /* default */].of();
        });
    }
    else {
        return new ApolloLink(function (operation, forward) {
            return (firstLink.request(operation, function (op) {
                return nextLink.request(op, forward) || __WEBPACK_IMPORTED_MODULE_0_zen_observable_ts__["a" /* default */].of();
            }) || __WEBPACK_IMPORTED_MODULE_0_zen_observable_ts__["a" /* default */].of());
        });
    }
};
var ApolloLink = /** @class */ (function () {
    function ApolloLink(request) {
        if (request)
            this.request = request;
    }
    ApolloLink.prototype.split = function (test, left, right) {
        if (right === void 0) { right = new ApolloLink(passthrough); }
        return this.concat(split(test, left, right));
    };
    ApolloLink.prototype.concat = function (next) {
        return concat(this, next);
    };
    ApolloLink.prototype.request = function (operation, forward) {
        throw new Error('request is not implemented');
    };
    ApolloLink.empty = empty;
    ApolloLink.from = from;
    ApolloLink.split = split;
    ApolloLink.execute = execute;
    return ApolloLink;
}());

function execute(link, operation) {
    return (link.request(Object(__WEBPACK_IMPORTED_MODULE_1__linkUtils__["b" /* createOperation */])(operation.context, Object(__WEBPACK_IMPORTED_MODULE_1__linkUtils__["h" /* transformOperation */])(Object(__WEBPACK_IMPORTED_MODULE_1__linkUtils__["i" /* validateOperation */])(operation)))) || __WEBPACK_IMPORTED_MODULE_0_zen_observable_ts__["a" /* default */].of());
}
//# sourceMappingURL=link.js.map

/***/ }),
/* 1113 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1114).Observable;


/***/ }),
/* 1114 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// === Symbol Support ===

var hasSymbols = function () {
  return typeof Symbol === 'function';
};
var hasSymbol = function (name) {
  return hasSymbols() && Boolean(Symbol[name]);
};
var getSymbol = function (name) {
  return hasSymbol(name) ? Symbol[name] : '@@' + name;
};

if (hasSymbols() && !hasSymbol('observable')) {
  Symbol.observable = Symbol('observable');
}

var SymbolIterator = getSymbol('iterator');
var SymbolObservable = getSymbol('observable');
var SymbolSpecies = getSymbol('species');

// === Abstract Operations ===

function getMethod(obj, key) {
  var value = obj[key];

  if (value == null) return undefined;

  if (typeof value !== 'function') throw new TypeError(value + ' is not a function');

  return value;
}

function getSpecies(obj) {
  var ctor = obj.constructor;
  if (ctor !== undefined) {
    ctor = ctor[SymbolSpecies];
    if (ctor === null) {
      ctor = undefined;
    }
  }
  return ctor !== undefined ? ctor : Observable;
}

function isObservable(x) {
  return x instanceof Observable; // SPEC: Brand check
}

function hostReportError(e) {
  if (hostReportError.log) {
    hostReportError.log(e);
  } else {
    setTimeout(function () {
      throw e;
    });
  }
}

function enqueue(fn) {
  Promise.resolve().then(function () {
    try {
      fn();
    } catch (e) {
      hostReportError(e);
    }
  });
}

function cleanupSubscription(subscription) {
  var cleanup = subscription._cleanup;
  if (cleanup === undefined) return;

  subscription._cleanup = undefined;

  if (!cleanup) {
    return;
  }

  try {
    if (typeof cleanup === 'function') {
      cleanup();
    } else {
      var unsubscribe = getMethod(cleanup, 'unsubscribe');
      if (unsubscribe) {
        unsubscribe.call(cleanup);
      }
    }
  } catch (e) {
    hostReportError(e);
  }
}

function closeSubscription(subscription) {
  subscription._observer = undefined;
  subscription._queue = undefined;
  subscription._state = 'closed';
}

function flushSubscription(subscription) {
  var queue = subscription._queue;
  if (!queue) {
    return;
  }
  subscription._queue = undefined;
  subscription._state = 'ready';
  for (var i = 0; i < queue.length; ++i) {
    notifySubscription(subscription, queue[i].type, queue[i].value);
    if (subscription._state === 'closed') break;
  }
}

function notifySubscription(subscription, type, value) {
  subscription._state = 'running';

  var observer = subscription._observer;

  try {
    var m = getMethod(observer, type);
    switch (type) {
      case 'next':
        if (m) m.call(observer, value);
        break;
      case 'error':
        closeSubscription(subscription);
        if (m) m.call(observer, value);else throw value;
        break;
      case 'complete':
        closeSubscription(subscription);
        if (m) m.call(observer);
        break;
    }
  } catch (e) {
    hostReportError(e);
  }

  if (subscription._state === 'closed') cleanupSubscription(subscription);else if (subscription._state === 'running') subscription._state = 'ready';
}

function onNotify(subscription, type, value) {
  if (subscription._state === 'closed') return;

  if (subscription._state === 'buffering') {
    subscription._queue.push({ type: type, value: value });
    return;
  }

  if (subscription._state !== 'ready') {
    subscription._state = 'buffering';
    subscription._queue = [{ type: type, value: value }];
    enqueue(function () {
      return flushSubscription(subscription);
    });
    return;
  }

  notifySubscription(subscription, type, value);
}

var Subscription = function () {
  function Subscription(observer, subscriber) {
    _classCallCheck(this, Subscription);

    // ASSERT: observer is an object
    // ASSERT: subscriber is callable

    this._cleanup = undefined;
    this._observer = observer;
    this._queue = undefined;
    this._state = 'initializing';

    var subscriptionObserver = new SubscriptionObserver(this);

    try {
      this._cleanup = subscriber.call(undefined, subscriptionObserver);
    } catch (e) {
      subscriptionObserver.error(e);
    }

    if (this._state === 'initializing') this._state = 'ready';
  }

  _createClass(Subscription, [{
    key: 'unsubscribe',
    value: function unsubscribe() {
      if (this._state !== 'closed') {
        closeSubscription(this);
        cleanupSubscription(this);
      }
    }
  }, {
    key: 'closed',
    get: function () {
      return this._state === 'closed';
    }
  }]);

  return Subscription;
}();

var SubscriptionObserver = function () {
  function SubscriptionObserver(subscription) {
    _classCallCheck(this, SubscriptionObserver);

    this._subscription = subscription;
  }

  _createClass(SubscriptionObserver, [{
    key: 'next',
    value: function next(value) {
      onNotify(this._subscription, 'next', value);
    }
  }, {
    key: 'error',
    value: function error(value) {
      onNotify(this._subscription, 'error', value);
    }
  }, {
    key: 'complete',
    value: function complete() {
      onNotify(this._subscription, 'complete');
    }
  }, {
    key: 'closed',
    get: function () {
      return this._subscription._state === 'closed';
    }
  }]);

  return SubscriptionObserver;
}();

var Observable = exports.Observable = function () {
  function Observable(subscriber) {
    _classCallCheck(this, Observable);

    if (!(this instanceof Observable)) throw new TypeError('Observable cannot be called as a function');

    if (typeof subscriber !== 'function') throw new TypeError('Observable initializer must be a function');

    this._subscriber = subscriber;
  }

  _createClass(Observable, [{
    key: 'subscribe',
    value: function subscribe(observer) {
      if (typeof observer !== 'object' || observer === null) {
        observer = {
          next: observer,
          error: arguments[1],
          complete: arguments[2]
        };
      }
      return new Subscription(observer, this._subscriber);
    }
  }, {
    key: 'forEach',
    value: function forEach(fn) {
      var _this = this;

      return new Promise(function (resolve, reject) {
        if (typeof fn !== 'function') {
          reject(new TypeError(fn + ' is not a function'));
          return;
        }

        function done() {
          subscription.unsubscribe();
          resolve();
        }

        var subscription = _this.subscribe({
          next: function (value) {
            try {
              fn(value, done);
            } catch (e) {
              reject(e);
              subscription.unsubscribe();
            }
          },

          error: reject,
          complete: resolve
        });
      });
    }
  }, {
    key: 'map',
    value: function map(fn) {
      var _this2 = this;

      if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');

      var C = getSpecies(this);

      return new C(function (observer) {
        return _this2.subscribe({
          next: function (value) {
            try {
              value = fn(value);
            } catch (e) {
              return observer.error(e);
            }
            observer.next(value);
          },
          error: function (e) {
            observer.error(e);
          },
          complete: function () {
            observer.complete();
          }
        });
      });
    }
  }, {
    key: 'filter',
    value: function filter(fn) {
      var _this3 = this;

      if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');

      var C = getSpecies(this);

      return new C(function (observer) {
        return _this3.subscribe({
          next: function (value) {
            try {
              if (!fn(value)) return;
            } catch (e) {
              return observer.error(e);
            }
            observer.next(value);
          },
          error: function (e) {
            observer.error(e);
          },
          complete: function () {
            observer.complete();
          }
        });
      });
    }
  }, {
    key: 'reduce',
    value: function reduce(fn) {
      var _this4 = this;

      if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');

      var C = getSpecies(this);
      var hasSeed = arguments.length > 1;
      var hasValue = false;
      var seed = arguments[1];
      var acc = seed;

      return new C(function (observer) {
        return _this4.subscribe({
          next: function (value) {
            var first = !hasValue;
            hasValue = true;

            if (!first || hasSeed) {
              try {
                acc = fn(acc, value);
              } catch (e) {
                return observer.error(e);
              }
            } else {
              acc = value;
            }
          },
          error: function (e) {
            observer.error(e);
          },
          complete: function () {
            if (!hasValue && !hasSeed) return observer.error(new TypeError('Cannot reduce an empty sequence'));

            observer.next(acc);
            observer.complete();
          }
        });
      });
    }
  }, {
    key: 'concat',
    value: function concat() {
      var _this5 = this;

      for (var _len = arguments.length, sources = Array(_len), _key = 0; _key < _len; _key++) {
        sources[_key] = arguments[_key];
      }

      var C = getSpecies(this);

      return new C(function (observer) {
        var subscription = void 0;
        var index = 0;

        function startNext(next) {
          subscription = next.subscribe({
            next: function (v) {
              observer.next(v);
            },
            error: function (e) {
              observer.error(e);
            },
            complete: function () {
              if (index === sources.length) {
                subscription = undefined;
                observer.complete();
              } else {
                startNext(C.from(sources[index++]));
              }
            }
          });
        }

        startNext(_this5);

        return function () {
          if (subscription) {
            subscription.unsubscribe();
            subscription = undefined;
          }
        };
      });
    }
  }, {
    key: 'flatMap',
    value: function flatMap(fn) {
      var _this6 = this;

      if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');

      var C = getSpecies(this);

      return new C(function (observer) {
        var subscriptions = [];

        var outer = _this6.subscribe({
          next: function (value) {
            if (fn) {
              try {
                value = fn(value);
              } catch (e) {
                return observer.error(e);
              }
            }

            var inner = C.from(value).subscribe({
              next: function (value) {
                observer.next(value);
              },
              error: function (e) {
                observer.error(e);
              },
              complete: function () {
                var i = subscriptions.indexOf(inner);
                if (i >= 0) subscriptions.splice(i, 1);
                completeIfDone();
              }
            });

            subscriptions.push(inner);
          },
          error: function (e) {
            observer.error(e);
          },
          complete: function () {
            completeIfDone();
          }
        });

        function completeIfDone() {
          if (outer.closed && subscriptions.length === 0) observer.complete();
        }

        return function () {
          subscriptions.forEach(function (s) {
            return s.unsubscribe();
          });
          outer.unsubscribe();
        };
      });
    }
  }, {
    key: SymbolObservable,
    value: function () {
      return this;
    }
  }], [{
    key: 'from',
    value: function from(x) {
      var C = typeof this === 'function' ? this : Observable;

      if (x == null) throw new TypeError(x + ' is not an object');

      var method = getMethod(x, SymbolObservable);
      if (method) {
        var observable = method.call(x);

        if (Object(observable) !== observable) throw new TypeError(observable + ' is not an object');

        if (isObservable(observable) && observable.constructor === C) return observable;

        return new C(function (observer) {
          return observable.subscribe(observer);
        });
      }

      if (hasSymbol('iterator')) {
        method = getMethod(x, SymbolIterator);
        if (method) {
          return new C(function (observer) {
            enqueue(function () {
              if (observer.closed) return;
              var _iteratorNormalCompletion = true;
              var _didIteratorError = false;
              var _iteratorError = undefined;

              try {
                for (var _iterator = method.call(x)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                  var item = _step.value;

                  observer.next(item);
                  if (observer.closed) return;
                }
              } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion && _iterator.return) {
                    _iterator.return();
                  }
                } finally {
                  if (_didIteratorError) {
                    throw _iteratorError;
                  }
                }
              }

              observer.complete();
            });
          });
        }
      }

      if (Array.isArray(x)) {
        return new C(function (observer) {
          enqueue(function () {
            if (observer.closed) return;
            for (var i = 0; i < x.length; ++i) {
              observer.next(x[i]);
              if (observer.closed) return;
            }
            observer.complete();
          });
        });
      }

      throw new TypeError(x + ' is not observable');
    }
  }, {
    key: 'of',
    value: function of() {
      for (var _len2 = arguments.length, items = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        items[_key2] = arguments[_key2];
      }

      var C = typeof this === 'function' ? this : Observable;

      return new C(function (observer) {
        enqueue(function () {
          if (observer.closed) return;
          for (var i = 0; i < items.length; ++i) {
            observer.next(items[i]);
            if (observer.closed) return;
          }
          observer.complete();
        });
      });
    }
  }, {
    key: SymbolSpecies,
    get: function () {
      return this;
    }
  }]);

  return Observable;
}();

if (hasSymbols()) {
  Object.defineProperty(Observable, Symbol('extensions'), {
    value: {
      symbol: SymbolObservable,
      hostReportError: hostReportError
    },
    configurable: true
  });
}

/***/ }),
/* 1115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_apollo_link__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_apollo_utilities__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_QueryManager__ = __webpack_require__(1116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__data_store__ = __webpack_require__(1122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__version__ = __webpack_require__(1123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__version___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__version__);
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};





var hasSuggestedDevtools = false;
var ApolloClient = (function () {
    function ApolloClient(options) {
        var _this = this;
        this.defaultOptions = {};
        this.resetStoreCallbacks = [];
        this.clientAwareness = {};
        var link = options.link, cache = options.cache, _a = options.ssrMode, ssrMode = _a === void 0 ? false : _a, _b = options.ssrForceFetchDelay, ssrForceFetchDelay = _b === void 0 ? 0 : _b, connectToDevTools = options.connectToDevTools, _c = options.queryDeduplication, queryDeduplication = _c === void 0 ? true : _c, defaultOptions = options.defaultOptions, clientAwarenessName = options.name, clientAwarenessVersion = options.version;
        if (!link || !cache) {
            throw new Error("\n        In order to initialize Apollo Client, you must specify link & cache properties on the config object.\n        This is part of the required upgrade when migrating from Apollo Client 1.0 to Apollo Client 2.0.\n        For more information, please visit:\n          https://www.apollographql.com/docs/react/basics/setup.html\n        to help you get started.\n      ");
        }
        var supportedCache = new Map();
        var supportedDirectives = new __WEBPACK_IMPORTED_MODULE_0_apollo_link__["ApolloLink"](function (operation, forward) {
            var result = supportedCache.get(operation.query);
            if (!result) {
                result = Object(__WEBPACK_IMPORTED_MODULE_1_apollo_utilities__["y" /* removeConnectionDirectiveFromDocument */])(operation.query);
                supportedCache.set(operation.query, result);
                supportedCache.set(result, result);
            }
            operation.query = result;
            return forward(operation);
        });
        this.link = supportedDirectives.concat(link);
        this.cache = cache;
        this.store = new __WEBPACK_IMPORTED_MODULE_3__data_store__["a" /* DataStore */](cache);
        this.disableNetworkFetches = ssrMode || ssrForceFetchDelay > 0;
        this.queryDeduplication = queryDeduplication;
        this.ssrMode = ssrMode;
        this.defaultOptions = defaultOptions || {};
        if (ssrForceFetchDelay) {
            setTimeout(function () { return (_this.disableNetworkFetches = false); }, ssrForceFetchDelay);
        }
        this.watchQuery = this.watchQuery.bind(this);
        this.query = this.query.bind(this);
        this.mutate = this.mutate.bind(this);
        this.resetStore = this.resetStore.bind(this);
        this.reFetchObservableQueries = this.reFetchObservableQueries.bind(this);
        var defaultConnectToDevTools = !Object(__WEBPACK_IMPORTED_MODULE_1_apollo_utilities__["w" /* isProduction */])() &&
            typeof window !== 'undefined' &&
            !window.__APOLLO_CLIENT__;
        if (typeof connectToDevTools === 'undefined'
            ? defaultConnectToDevTools
            : connectToDevTools && typeof window !== 'undefined') {
            window.__APOLLO_CLIENT__ = this;
        }
        if (!hasSuggestedDevtools && !Object(__WEBPACK_IMPORTED_MODULE_1_apollo_utilities__["w" /* isProduction */])()) {
            hasSuggestedDevtools = true;
            if (typeof window !== 'undefined' &&
                window.document &&
                window.top === window.self) {
                if (typeof window.__APOLLO_DEVTOOLS_GLOBAL_HOOK__ === 'undefined') {
                    if (window.navigator &&
                        window.navigator.userAgent &&
                        window.navigator.userAgent.indexOf('Chrome') > -1) {
                        console.debug('Download the Apollo DevTools ' +
                            'for a better development experience: ' +
                            'https://chrome.google.com/webstore/detail/apollo-client-developer-t/jdkknkkbebbapilgoeccciglkfbmbnfm');
                    }
                }
            }
        }
        this.version = __WEBPACK_IMPORTED_MODULE_4__version__["version"];
        if (clientAwarenessName) {
            this.clientAwareness.name = clientAwarenessName;
        }
        if (clientAwarenessVersion) {
            this.clientAwareness.version = clientAwarenessVersion;
        }
    }
    ApolloClient.prototype.watchQuery = function (options) {
        if (this.defaultOptions.watchQuery) {
            options = __assign({}, this.defaultOptions.watchQuery, options);
        }
        if (this.disableNetworkFetches &&
            (options.fetchPolicy === 'network-only' ||
                options.fetchPolicy === 'cache-and-network')) {
            options = __assign({}, options, { fetchPolicy: 'cache-first' });
        }
        return this.initQueryManager().watchQuery(options);
    };
    ApolloClient.prototype.query = function (options) {
        if (this.defaultOptions.query) {
            options = __assign({}, this.defaultOptions.query, options);
        }
        if (options.fetchPolicy === 'cache-and-network') {
            throw new Error('cache-and-network fetchPolicy can only be used with watchQuery');
        }
        if (this.disableNetworkFetches && options.fetchPolicy === 'network-only') {
            options = __assign({}, options, { fetchPolicy: 'cache-first' });
        }
        return this.initQueryManager().query(options);
    };
    ApolloClient.prototype.mutate = function (options) {
        if (this.defaultOptions.mutate) {
            options = __assign({}, this.defaultOptions.mutate, options);
        }
        return this.initQueryManager().mutate(options);
    };
    ApolloClient.prototype.subscribe = function (options) {
        return this.initQueryManager().startGraphQLSubscription(options);
    };
    ApolloClient.prototype.readQuery = function (options, optimistic) {
        if (optimistic === void 0) { optimistic = false; }
        return this.initProxy().readQuery(options, optimistic);
    };
    ApolloClient.prototype.readFragment = function (options, optimistic) {
        if (optimistic === void 0) { optimistic = false; }
        return this.initProxy().readFragment(options, optimistic);
    };
    ApolloClient.prototype.writeQuery = function (options) {
        var result = this.initProxy().writeQuery(options);
        this.initQueryManager().broadcastQueries();
        return result;
    };
    ApolloClient.prototype.writeFragment = function (options) {
        var result = this.initProxy().writeFragment(options);
        this.initQueryManager().broadcastQueries();
        return result;
    };
    ApolloClient.prototype.writeData = function (options) {
        var result = this.initProxy().writeData(options);
        this.initQueryManager().broadcastQueries();
        return result;
    };
    ApolloClient.prototype.__actionHookForDevTools = function (cb) {
        this.devToolsHookCb = cb;
    };
    ApolloClient.prototype.__requestRaw = function (payload) {
        return Object(__WEBPACK_IMPORTED_MODULE_0_apollo_link__["execute"])(this.link, payload);
    };
    ApolloClient.prototype.initQueryManager = function () {
        var _this = this;
        if (!this.queryManager) {
            this.queryManager = new __WEBPACK_IMPORTED_MODULE_2__core_QueryManager__["a" /* QueryManager */]({
                link: this.link,
                store: this.store,
                queryDeduplication: this.queryDeduplication,
                ssrMode: this.ssrMode,
                clientAwareness: this.clientAwareness,
                onBroadcast: function () {
                    if (_this.devToolsHookCb) {
                        _this.devToolsHookCb({
                            action: {},
                            state: {
                                queries: _this.queryManager
                                    ? _this.queryManager.queryStore.getStore()
                                    : {},
                                mutations: _this.queryManager
                                    ? _this.queryManager.mutationStore.getStore()
                                    : {},
                            },
                            dataWithOptimisticResults: _this.cache.extract(true),
                        });
                    }
                },
            });
        }
        return this.queryManager;
    };
    ApolloClient.prototype.resetStore = function () {
        var _this = this;
        return Promise.resolve()
            .then(function () {
            return _this.queryManager
                ? _this.queryManager.clearStore()
                : Promise.resolve(null);
        })
            .then(function () { return Promise.all(_this.resetStoreCallbacks.map(function (fn) { return fn(); })); })
            .then(function () {
            return _this.queryManager && _this.queryManager.reFetchObservableQueries
                ? _this.queryManager.reFetchObservableQueries()
                : Promise.resolve(null);
        });
    };
    ApolloClient.prototype.clearStore = function () {
        var queryManager = this.queryManager;
        return Promise.resolve().then(function () {
            return queryManager ? queryManager.clearStore() : Promise.resolve(null);
        });
    };
    ApolloClient.prototype.onResetStore = function (cb) {
        var _this = this;
        this.resetStoreCallbacks.push(cb);
        return function () {
            _this.resetStoreCallbacks = _this.resetStoreCallbacks.filter(function (c) { return c !== cb; });
        };
    };
    ApolloClient.prototype.reFetchObservableQueries = function (includeStandby) {
        return this.queryManager
            ? this.queryManager.reFetchObservableQueries(includeStandby)
            : Promise.resolve(null);
    };
    ApolloClient.prototype.extract = function (optimistic) {
        return this.initProxy().extract(optimistic);
    };
    ApolloClient.prototype.restore = function (serializedState) {
        return this.initProxy().restore(serializedState);
    };
    ApolloClient.prototype.initProxy = function () {
        if (!this.proxy) {
            this.initQueryManager();
            this.proxy = this.cache;
        }
        return this.proxy;
    };
    return ApolloClient;
}());
/* harmony default export */ __webpack_exports__["a"] = (ApolloClient);
//# sourceMappingURL=ApolloClient.js.map

/***/ }),
/* 1116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return QueryManager; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_apollo_link__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_graphql_language_printer__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_apollo_link_dedup__ = __webpack_require__(1117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_apollo_utilities__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__scheduler_scheduler__ = __webpack_require__(1119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__errors_ApolloError__ = __webpack_require__(340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_Observable__ = __webpack_require__(526);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__data_mutations__ = __webpack_require__(1120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__data_queries__ = __webpack_require__(1121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ObservableQuery__ = __webpack_require__(336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__networkStatus__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__types__ = __webpack_require__(229);
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};













var QueryManager = (function () {
    function QueryManager(_a) {
        var link = _a.link, _b = _a.queryDeduplication, queryDeduplication = _b === void 0 ? false : _b, store = _a.store, _c = _a.onBroadcast, onBroadcast = _c === void 0 ? function () { return undefined; } : _c, _d = _a.ssrMode, ssrMode = _d === void 0 ? false : _d, _e = _a.clientAwareness, clientAwareness = _e === void 0 ? {} : _e;
        this.mutationStore = new __WEBPACK_IMPORTED_MODULE_7__data_mutations__["a" /* MutationStore */]();
        this.queryStore = new __WEBPACK_IMPORTED_MODULE_8__data_queries__["a" /* QueryStore */]();
        this.clientAwareness = {};
        this.idCounter = 1;
        this.queries = new Map();
        this.fetchQueryPromises = new Map();
        this.queryIdsByName = {};
        this.link = link;
        this.deduplicator = __WEBPACK_IMPORTED_MODULE_0_apollo_link__["ApolloLink"].from([new __WEBPACK_IMPORTED_MODULE_2_apollo_link_dedup__["a" /* DedupLink */](), link]);
        this.queryDeduplication = queryDeduplication;
        this.dataStore = store;
        this.onBroadcast = onBroadcast;
        this.clientAwareness = clientAwareness;
        this.scheduler = new __WEBPACK_IMPORTED_MODULE_4__scheduler_scheduler__["a" /* QueryScheduler */]({ queryManager: this, ssrMode: ssrMode });
    }
    QueryManager.prototype.mutate = function (_a) {
        var _this = this;
        var mutation = _a.mutation, variables = _a.variables, optimisticResponse = _a.optimisticResponse, updateQueriesByName = _a.updateQueries, _b = _a.refetchQueries, refetchQueries = _b === void 0 ? [] : _b, _c = _a.awaitRefetchQueries, awaitRefetchQueries = _c === void 0 ? false : _c, updateWithProxyFn = _a.update, _d = _a.errorPolicy, errorPolicy = _d === void 0 ? 'none' : _d, fetchPolicy = _a.fetchPolicy, _e = _a.context, context = _e === void 0 ? {} : _e;
        if (!mutation) {
            throw new Error('mutation option is required. You must specify your GraphQL document in the mutation option.');
        }
        if (fetchPolicy && fetchPolicy !== 'no-cache') {
            throw new Error("fetchPolicy for mutations currently only supports the 'no-cache' policy");
        }
        var mutationId = this.generateQueryId();
        var cache = this.dataStore.getCache();
        (mutation = cache.transformDocument(mutation)),
            (variables = Object(__WEBPACK_IMPORTED_MODULE_3_apollo_utilities__["c" /* assign */])({}, Object(__WEBPACK_IMPORTED_MODULE_3_apollo_utilities__["f" /* getDefaultValues */])(Object(__WEBPACK_IMPORTED_MODULE_3_apollo_utilities__["k" /* getMutationDefinition */])(mutation)), variables));
        var mutationString = Object(__WEBPACK_IMPORTED_MODULE_1_graphql_language_printer__["a" /* print */])(mutation);
        this.setQuery(mutationId, function () { return ({ document: mutation }); });
        var generateUpdateQueriesInfo = function () {
            var ret = {};
            if (updateQueriesByName) {
                Object.keys(updateQueriesByName).forEach(function (queryName) {
                    return (_this.queryIdsByName[queryName] || []).forEach(function (queryId) {
                        ret[queryId] = {
                            updater: updateQueriesByName[queryName],
                            query: _this.queryStore.get(queryId),
                        };
                    });
                });
            }
            return ret;
        };
        this.mutationStore.initMutation(mutationId, mutationString, variables);
        this.dataStore.markMutationInit({
            mutationId: mutationId,
            document: mutation,
            variables: variables || {},
            updateQueries: generateUpdateQueriesInfo(),
            update: updateWithProxyFn,
            optimisticResponse: optimisticResponse,
        });
        this.broadcastQueries();
        return new Promise(function (resolve, reject) {
            var storeResult;
            var error;
            var operation = _this.buildOperationForLink(mutation, variables, __assign({}, context, { optimisticResponse: optimisticResponse }));
            var completeMutation = function () { return __awaiter(_this, void 0, void 0, function () {
                var refetchQueryPromises, _i, refetchQueries_1, refetchQuery, promise, queryOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (error) {
                                this.mutationStore.markMutationError(mutationId, error);
                            }
                            this.dataStore.markMutationComplete({
                                mutationId: mutationId,
                                optimisticResponse: optimisticResponse,
                            });
                            this.broadcastQueries();
                            if (error) {
                                throw error;
                            }
                            if (typeof refetchQueries === 'function') {
                                refetchQueries = refetchQueries(storeResult);
                            }
                            refetchQueryPromises = [];
                            for (_i = 0, refetchQueries_1 = refetchQueries; _i < refetchQueries_1.length; _i++) {
                                refetchQuery = refetchQueries_1[_i];
                                if (typeof refetchQuery === 'string') {
                                    promise = this.refetchQueryByName(refetchQuery);
                                    if (promise) {
                                        refetchQueryPromises.push(promise);
                                    }
                                    continue;
                                }
                                queryOptions = {
                                    query: refetchQuery.query,
                                    variables: refetchQuery.variables,
                                    fetchPolicy: 'network-only',
                                };
                                if (refetchQuery.context) {
                                    queryOptions.context = refetchQuery.context;
                                }
                                refetchQueryPromises.push(this.query(queryOptions));
                            }
                            if (!awaitRefetchQueries) return [3, 2];
                            return [4, Promise.all(refetchQueryPromises)];
                        case 1:
                            _a.sent();
                            _a.label = 2;
                        case 2:
                            this.setQuery(mutationId, function () { return ({ document: undefined }); });
                            if (errorPolicy === 'ignore' &&
                                storeResult &&
                                Object(__WEBPACK_IMPORTED_MODULE_3_apollo_utilities__["p" /* graphQLResultHasError */])(storeResult)) {
                                delete storeResult.errors;
                            }
                            return [2, storeResult];
                    }
                });
            }); };
            Object(__WEBPACK_IMPORTED_MODULE_0_apollo_link__["execute"])(_this.link, operation).subscribe({
                next: function (result) {
                    if (Object(__WEBPACK_IMPORTED_MODULE_3_apollo_utilities__["p" /* graphQLResultHasError */])(result) && errorPolicy === 'none') {
                        error = new __WEBPACK_IMPORTED_MODULE_5__errors_ApolloError__["a" /* ApolloError */]({
                            graphQLErrors: result.errors,
                        });
                        return;
                    }
                    _this.mutationStore.markMutationResult(mutationId);
                    if (fetchPolicy !== 'no-cache') {
                        _this.dataStore.markMutationResult({
                            mutationId: mutationId,
                            result: result,
                            document: mutation,
                            variables: variables || {},
                            updateQueries: generateUpdateQueriesInfo(),
                            update: updateWithProxyFn,
                        });
                    }
                    storeResult = result;
                },
                error: function (err) {
                    _this.mutationStore.markMutationError(mutationId, err);
                    _this.dataStore.markMutationComplete({
                        mutationId: mutationId,
                        optimisticResponse: optimisticResponse,
                    });
                    _this.broadcastQueries();
                    _this.setQuery(mutationId, function () { return ({ document: undefined }); });
                    reject(new __WEBPACK_IMPORTED_MODULE_5__errors_ApolloError__["a" /* ApolloError */]({
                        networkError: err,
                    }));
                },
                complete: function () { return completeMutation().then(resolve, reject); },
            });
        });
    };
    QueryManager.prototype.fetchQuery = function (queryId, options, fetchType, fetchMoreForQueryId) {
        var _this = this;
        var _a = options.variables, variables = _a === void 0 ? {} : _a, _b = options.metadata, metadata = _b === void 0 ? null : _b, _c = options.fetchPolicy, fetchPolicy = _c === void 0 ? 'cache-first' : _c;
        var cache = this.dataStore.getCache();
        var query = cache.transformDocument(options.query);
        var storeResult;
        var needToFetch = fetchPolicy === 'network-only' || fetchPolicy === 'no-cache';
        if (fetchType !== __WEBPACK_IMPORTED_MODULE_11__types__["a" /* FetchType */].refetch &&
            fetchPolicy !== 'network-only' &&
            fetchPolicy !== 'no-cache') {
            var _d = this.dataStore.getCache().diff({
                query: query,
                variables: variables,
                returnPartialData: true,
                optimistic: false,
            }), complete = _d.complete, result = _d.result;
            needToFetch = !complete || fetchPolicy === 'cache-and-network';
            storeResult = result;
        }
        var shouldFetch = needToFetch && fetchPolicy !== 'cache-only' && fetchPolicy !== 'standby';
        if (Object(__WEBPACK_IMPORTED_MODULE_3_apollo_utilities__["q" /* hasDirectives */])(['live'], query))
            shouldFetch = true;
        var requestId = this.generateRequestId();
        var cancel = this.updateQueryWatch(queryId, query, options);
        this.setQuery(queryId, function () { return ({
            document: query,
            lastRequestId: requestId,
            invalidated: true,
            cancel: cancel,
        }); });
        this.invalidate(true, fetchMoreForQueryId);
        this.queryStore.initQuery({
            queryId: queryId,
            document: query,
            storePreviousVariables: shouldFetch,
            variables: variables,
            isPoll: fetchType === __WEBPACK_IMPORTED_MODULE_11__types__["a" /* FetchType */].poll,
            isRefetch: fetchType === __WEBPACK_IMPORTED_MODULE_11__types__["a" /* FetchType */].refetch,
            metadata: metadata,
            fetchMoreForQueryId: fetchMoreForQueryId,
        });
        this.broadcastQueries();
        var shouldDispatchClientResult = !shouldFetch || fetchPolicy === 'cache-and-network';
        if (shouldDispatchClientResult) {
            this.queryStore.markQueryResultClient(queryId, !shouldFetch);
            this.invalidate(true, queryId, fetchMoreForQueryId);
            this.broadcastQueries();
        }
        if (shouldFetch) {
            var networkResult = this.fetchRequest({
                requestId: requestId,
                queryId: queryId,
                document: query,
                options: options,
                fetchMoreForQueryId: fetchMoreForQueryId,
            }).catch(function (error) {
                if (Object(__WEBPACK_IMPORTED_MODULE_5__errors_ApolloError__["b" /* isApolloError */])(error)) {
                    throw error;
                }
                else {
                    var lastRequestId = _this.getQuery(queryId).lastRequestId;
                    if (requestId >= (lastRequestId || 1)) {
                        _this.queryStore.markQueryError(queryId, error, fetchMoreForQueryId);
                        _this.invalidate(true, queryId, fetchMoreForQueryId);
                        _this.broadcastQueries();
                    }
                    _this.removeFetchQueryPromise(requestId);
                    throw new __WEBPACK_IMPORTED_MODULE_5__errors_ApolloError__["a" /* ApolloError */]({ networkError: error });
                }
            });
            if (fetchPolicy !== 'cache-and-network') {
                return networkResult;
            }
            else {
                networkResult.catch(function () { });
            }
        }
        return Promise.resolve({ data: storeResult });
    };
    QueryManager.prototype.queryListenerForObserver = function (queryId, options, observer) {
        var _this = this;
        var previouslyHadError = false;
        return function (queryStoreValue, newData) {
            _this.invalidate(false, queryId);
            if (!queryStoreValue)
                return;
            var observableQuery = _this.getQuery(queryId).observableQuery;
            var fetchPolicy = observableQuery
                ? observableQuery.options.fetchPolicy
                : options.fetchPolicy;
            if (fetchPolicy === 'standby')
                return;
            var errorPolicy = observableQuery
                ? observableQuery.options.errorPolicy
                : options.errorPolicy;
            var lastResult = observableQuery
                ? observableQuery.getLastResult()
                : null;
            var lastError = observableQuery ? observableQuery.getLastError() : null;
            var shouldNotifyIfLoading = (!newData && queryStoreValue.previousVariables != null) ||
                fetchPolicy === 'cache-only' ||
                fetchPolicy === 'cache-and-network';
            var networkStatusChanged = Boolean(lastResult &&
                queryStoreValue.networkStatus !== lastResult.networkStatus);
            var errorStatusChanged = errorPolicy &&
                (lastError && lastError.graphQLErrors) !==
                    queryStoreValue.graphQLErrors &&
                errorPolicy !== 'none';
            if (!Object(__WEBPACK_IMPORTED_MODULE_10__networkStatus__["b" /* isNetworkRequestInFlight */])(queryStoreValue.networkStatus) ||
                (networkStatusChanged && options.notifyOnNetworkStatusChange) ||
                shouldNotifyIfLoading) {
                if (((!errorPolicy || errorPolicy === 'none') &&
                    queryStoreValue.graphQLErrors &&
                    queryStoreValue.graphQLErrors.length > 0) ||
                    queryStoreValue.networkError) {
                    var apolloError_1 = new __WEBPACK_IMPORTED_MODULE_5__errors_ApolloError__["a" /* ApolloError */]({
                        graphQLErrors: queryStoreValue.graphQLErrors,
                        networkError: queryStoreValue.networkError,
                    });
                    previouslyHadError = true;
                    if (observer.error) {
                        try {
                            observer.error(apolloError_1);
                        }
                        catch (e) {
                            setTimeout(function () {
                                throw e;
                            }, 0);
                        }
                    }
                    else {
                        setTimeout(function () {
                            throw apolloError_1;
                        }, 0);
                        if (!Object(__WEBPACK_IMPORTED_MODULE_3_apollo_utilities__["w" /* isProduction */])()) {
                            console.info('An unhandled error was thrown because no error handler is registered ' +
                                'for the query ' +
                                Object(__WEBPACK_IMPORTED_MODULE_1_graphql_language_printer__["a" /* print */])(queryStoreValue.document));
                        }
                    }
                    return;
                }
                try {
                    var data = void 0;
                    var isMissing = void 0;
                    if (newData) {
                        if (fetchPolicy !== 'no-cache') {
                            _this.setQuery(queryId, function () { return ({ newData: null }); });
                        }
                        data = newData.result;
                        isMissing = !newData.complete || false;
                    }
                    else {
                        if (lastResult && lastResult.data && !errorStatusChanged) {
                            data = lastResult.data;
                            isMissing = false;
                        }
                        else {
                            var document_1 = _this.getQuery(queryId).document;
                            var readResult = _this.dataStore.getCache().diff({
                                query: document_1,
                                variables: queryStoreValue.previousVariables ||
                                    queryStoreValue.variables,
                                optimistic: true,
                            });
                            data = readResult.result;
                            isMissing = !readResult.complete;
                        }
                    }
                    var resultFromStore = void 0;
                    if (isMissing && fetchPolicy !== 'cache-only') {
                        resultFromStore = {
                            data: lastResult && lastResult.data,
                            loading: Object(__WEBPACK_IMPORTED_MODULE_10__networkStatus__["b" /* isNetworkRequestInFlight */])(queryStoreValue.networkStatus),
                            networkStatus: queryStoreValue.networkStatus,
                            stale: true,
                        };
                    }
                    else {
                        resultFromStore = {
                            data: data,
                            loading: Object(__WEBPACK_IMPORTED_MODULE_10__networkStatus__["b" /* isNetworkRequestInFlight */])(queryStoreValue.networkStatus),
                            networkStatus: queryStoreValue.networkStatus,
                            stale: false,
                        };
                    }
                    if (errorPolicy === 'all' &&
                        queryStoreValue.graphQLErrors &&
                        queryStoreValue.graphQLErrors.length > 0) {
                        resultFromStore.errors = queryStoreValue.graphQLErrors;
                    }
                    if (observer.next) {
                        if (previouslyHadError ||
                            !observableQuery ||
                            observableQuery.isDifferentFromLastResult(resultFromStore)) {
                            try {
                                observer.next(resultFromStore);
                            }
                            catch (e) {
                                setTimeout(function () {
                                    throw e;
                                }, 0);
                            }
                        }
                    }
                    previouslyHadError = false;
                }
                catch (error) {
                    previouslyHadError = true;
                    if (observer.error)
                        observer.error(new __WEBPACK_IMPORTED_MODULE_5__errors_ApolloError__["a" /* ApolloError */]({ networkError: error }));
                    return;
                }
            }
        };
    };
    QueryManager.prototype.watchQuery = function (options, shouldSubscribe) {
        if (shouldSubscribe === void 0) { shouldSubscribe = true; }
        if (options.fetchPolicy === 'standby') {
            throw new Error('client.watchQuery cannot be called with fetchPolicy set to "standby"');
        }
        var queryDefinition = Object(__WEBPACK_IMPORTED_MODULE_3_apollo_utilities__["n" /* getQueryDefinition */])(options.query);
        if (queryDefinition.variableDefinitions &&
            queryDefinition.variableDefinitions.length) {
            var defaultValues = Object(__WEBPACK_IMPORTED_MODULE_3_apollo_utilities__["f" /* getDefaultValues */])(queryDefinition);
            options.variables = Object(__WEBPACK_IMPORTED_MODULE_3_apollo_utilities__["c" /* assign */])({}, defaultValues, options.variables);
        }
        if (typeof options.notifyOnNetworkStatusChange === 'undefined') {
            options.notifyOnNetworkStatusChange = false;
        }
        var transformedOptions = __assign({}, options);
        return new __WEBPACK_IMPORTED_MODULE_9__ObservableQuery__["a" /* ObservableQuery */]({
            scheduler: this.scheduler,
            options: transformedOptions,
            shouldSubscribe: shouldSubscribe,
        });
    };
    QueryManager.prototype.query = function (options) {
        var _this = this;
        if (!options.query) {
            throw new Error('query option is required. You must specify your GraphQL document ' +
                'in the query option.');
        }
        if (options.query.kind !== 'Document') {
            throw new Error('You must wrap the query string in a "gql" tag.');
        }
        if (options.returnPartialData) {
            throw new Error('returnPartialData option only supported on watchQuery.');
        }
        if (options.pollInterval) {
            throw new Error('pollInterval option only supported on watchQuery.');
        }
        var requestId = this.idCounter;
        return new Promise(function (resolve, reject) {
            _this.addFetchQueryPromise(requestId, resolve, reject);
            return _this.watchQuery(options, false)
                .result()
                .then(function (result) {
                _this.removeFetchQueryPromise(requestId);
                resolve(result);
            })
                .catch(function (error) {
                _this.removeFetchQueryPromise(requestId);
                reject(error);
            });
        });
    };
    QueryManager.prototype.generateQueryId = function () {
        var queryId = this.idCounter.toString();
        this.idCounter++;
        return queryId;
    };
    QueryManager.prototype.stopQueryInStore = function (queryId) {
        this.queryStore.stopQuery(queryId);
        this.invalidate(true, queryId);
        this.broadcastQueries();
    };
    QueryManager.prototype.addQueryListener = function (queryId, listener) {
        this.setQuery(queryId, function (_a) {
            var _b = _a.listeners, listeners = _b === void 0 ? [] : _b;
            return ({
                listeners: listeners.concat([listener]),
                invalidate: false,
            });
        });
    };
    QueryManager.prototype.updateQueryWatch = function (queryId, document, options) {
        var _this = this;
        var cancel = this.getQuery(queryId).cancel;
        if (cancel)
            cancel();
        var previousResult = function () {
            var previousResult = null;
            var observableQuery = _this.getQuery(queryId).observableQuery;
            if (observableQuery) {
                var lastResult = observableQuery.getLastResult();
                if (lastResult) {
                    previousResult = lastResult.data;
                }
            }
            return previousResult;
        };
        return this.dataStore.getCache().watch({
            query: document,
            variables: options.variables,
            optimistic: true,
            previousResult: previousResult,
            callback: function (newData) {
                _this.setQuery(queryId, function () { return ({ invalidated: true, newData: newData }); });
            },
        });
    };
    QueryManager.prototype.addFetchQueryPromise = function (requestId, resolve, reject) {
        this.fetchQueryPromises.set(requestId.toString(), {
            resolve: resolve,
            reject: reject,
        });
    };
    QueryManager.prototype.removeFetchQueryPromise = function (requestId) {
        this.fetchQueryPromises.delete(requestId.toString());
    };
    QueryManager.prototype.addObservableQuery = function (queryId, observableQuery) {
        this.setQuery(queryId, function () { return ({ observableQuery: observableQuery }); });
        var queryDef = Object(__WEBPACK_IMPORTED_MODULE_3_apollo_utilities__["n" /* getQueryDefinition */])(observableQuery.options.query);
        if (queryDef.name && queryDef.name.value) {
            var queryName = queryDef.name.value;
            this.queryIdsByName[queryName] = this.queryIdsByName[queryName] || [];
            this.queryIdsByName[queryName].push(observableQuery.queryId);
        }
    };
    QueryManager.prototype.removeObservableQuery = function (queryId) {
        var _a = this.getQuery(queryId), observableQuery = _a.observableQuery, cancel = _a.cancel;
        if (cancel)
            cancel();
        if (!observableQuery)
            return;
        var definition = Object(__WEBPACK_IMPORTED_MODULE_3_apollo_utilities__["n" /* getQueryDefinition */])(observableQuery.options.query);
        var queryName = definition.name ? definition.name.value : null;
        this.setQuery(queryId, function () { return ({ observableQuery: null }); });
        if (queryName) {
            this.queryIdsByName[queryName] = this.queryIdsByName[queryName].filter(function (val) {
                return !(observableQuery.queryId === val);
            });
        }
    };
    QueryManager.prototype.clearStore = function () {
        this.fetchQueryPromises.forEach(function (_a) {
            var reject = _a.reject;
            reject(new Error('Store reset while query was in flight(not completed in link chain)'));
        });
        var resetIds = [];
        this.queries.forEach(function (_a, queryId) {
            var observableQuery = _a.observableQuery;
            if (observableQuery)
                resetIds.push(queryId);
        });
        this.queryStore.reset(resetIds);
        this.mutationStore.reset();
        var reset = this.dataStore.reset();
        return reset;
    };
    QueryManager.prototype.resetStore = function () {
        var _this = this;
        return this.clearStore().then(function () {
            return _this.reFetchObservableQueries();
        });
    };
    QueryManager.prototype.reFetchObservableQueries = function (includeStandby) {
        var observableQueryPromises = this.getObservableQueryPromises(includeStandby);
        this.broadcastQueries();
        return Promise.all(observableQueryPromises);
    };
    QueryManager.prototype.startQuery = function (queryId, options, listener) {
        this.addQueryListener(queryId, listener);
        this.fetchQuery(queryId, options)
            .catch(function () { return undefined; });
        return queryId;
    };
    QueryManager.prototype.startGraphQLSubscription = function (options) {
        var _this = this;
        var query = options.query;
        var isCacheEnabled = !(options.fetchPolicy && options.fetchPolicy === 'no-cache');
        var cache = this.dataStore.getCache();
        var transformedDoc = cache.transformDocument(query);
        var variables = Object(__WEBPACK_IMPORTED_MODULE_3_apollo_utilities__["c" /* assign */])({}, Object(__WEBPACK_IMPORTED_MODULE_3_apollo_utilities__["f" /* getDefaultValues */])(Object(__WEBPACK_IMPORTED_MODULE_3_apollo_utilities__["l" /* getOperationDefinition */])(query)), options.variables);
        var sub;
        var observers = [];
        return new __WEBPACK_IMPORTED_MODULE_6__util_Observable__["a" /* Observable */](function (observer) {
            observers.push(observer);
            if (observers.length === 1) {
                var handler = {
                    next: function (result) {
                        if (isCacheEnabled) {
                            _this.dataStore.markSubscriptionResult(result, transformedDoc, variables);
                            _this.broadcastQueries();
                        }
                        observers.forEach(function (obs) {
                            if (Object(__WEBPACK_IMPORTED_MODULE_3_apollo_utilities__["p" /* graphQLResultHasError */])(result) && obs.error) {
                                obs.error(new __WEBPACK_IMPORTED_MODULE_5__errors_ApolloError__["a" /* ApolloError */]({
                                    graphQLErrors: result.errors,
                                }));
                            }
                            else if (obs.next) {
                                obs.next(result);
                            }
                        });
                    },
                    error: function (error) {
                        observers.forEach(function (obs) {
                            if (obs.error) {
                                obs.error(error);
                            }
                        });
                    },
                };
                var operation = _this.buildOperationForLink(transformedDoc, variables);
                sub = Object(__WEBPACK_IMPORTED_MODULE_0_apollo_link__["execute"])(_this.link, operation).subscribe(handler);
            }
            return function () {
                observers = observers.filter(function (obs) { return obs !== observer; });
                if (observers.length === 0 && sub) {
                    sub.unsubscribe();
                }
            };
        });
    };
    QueryManager.prototype.stopQuery = function (queryId) {
        this.stopQueryInStore(queryId);
        this.removeQuery(queryId);
    };
    QueryManager.prototype.removeQuery = function (queryId) {
        var subscriptions = this.getQuery(queryId).subscriptions;
        subscriptions.forEach(function (x) { return x.unsubscribe(); });
        this.queries.delete(queryId);
    };
    QueryManager.prototype.getCurrentQueryResult = function (observableQuery, optimistic) {
        if (optimistic === void 0) { optimistic = true; }
        var _a = observableQuery.options, variables = _a.variables, query = _a.query;
        var lastResult = observableQuery.getLastResult();
        var newData = this.getQuery(observableQuery.queryId).newData;
        if (newData && newData.complete) {
            return { data: newData.result, partial: false };
        }
        else {
            try {
                var data = this.dataStore.getCache().read({
                    query: query,
                    variables: variables,
                    previousResult: lastResult ? lastResult.data : undefined,
                    optimistic: optimistic,
                });
                return { data: data, partial: false };
            }
            catch (e) {
                return { data: {}, partial: true };
            }
        }
    };
    QueryManager.prototype.getQueryWithPreviousResult = function (queryIdOrObservable) {
        var observableQuery;
        if (typeof queryIdOrObservable === 'string') {
            var foundObserveableQuery = this.getQuery(queryIdOrObservable).observableQuery;
            if (!foundObserveableQuery) {
                throw new Error("ObservableQuery with this id doesn't exist: " + queryIdOrObservable);
            }
            observableQuery = foundObserveableQuery;
        }
        else {
            observableQuery = queryIdOrObservable;
        }
        var _a = observableQuery.options, variables = _a.variables, query = _a.query;
        var data = this.getCurrentQueryResult(observableQuery, false).data;
        return {
            previousResult: data,
            variables: variables,
            document: query,
        };
    };
    QueryManager.prototype.broadcastQueries = function () {
        var _this = this;
        this.onBroadcast();
        this.queries.forEach(function (info, id) {
            if (!info.invalidated || !info.listeners)
                return;
            info.listeners
                .filter(function (x) { return !!x; })
                .forEach(function (listener) {
                listener(_this.queryStore.get(id), info.newData);
            });
        });
    };
    QueryManager.prototype.getObservableQueryPromises = function (includeStandby) {
        var _this = this;
        var observableQueryPromises = [];
        this.queries.forEach(function (_a, queryId) {
            var observableQuery = _a.observableQuery;
            if (!observableQuery)
                return;
            var fetchPolicy = observableQuery.options.fetchPolicy;
            observableQuery.resetLastResults();
            if (fetchPolicy !== 'cache-only' &&
                (includeStandby || fetchPolicy !== 'standby')) {
                observableQueryPromises.push(observableQuery.refetch());
            }
            _this.setQuery(queryId, function () { return ({ newData: null }); });
            _this.invalidate(true, queryId);
        });
        return observableQueryPromises;
    };
    QueryManager.prototype.fetchRequest = function (_a) {
        var _this = this;
        var requestId = _a.requestId, queryId = _a.queryId, document = _a.document, options = _a.options, fetchMoreForQueryId = _a.fetchMoreForQueryId;
        var variables = options.variables, context = options.context, _b = options.errorPolicy, errorPolicy = _b === void 0 ? 'none' : _b, fetchPolicy = options.fetchPolicy;
        var operation = this.buildOperationForLink(document, variables, __assign({}, context, { forceFetch: !this.queryDeduplication }));
        var resultFromStore;
        var errorsFromStore;
        return new Promise(function (resolve, reject) {
            _this.addFetchQueryPromise(requestId, resolve, reject);
            var subscription = Object(__WEBPACK_IMPORTED_MODULE_0_apollo_link__["execute"])(_this.deduplicator, operation).subscribe({
                next: function (result) {
                    var lastRequestId = _this.getQuery(queryId).lastRequestId;
                    if (requestId >= (lastRequestId || 1)) {
                        if (fetchPolicy !== 'no-cache') {
                            try {
                                _this.dataStore.markQueryResult(result, document, variables, fetchMoreForQueryId, errorPolicy === 'ignore' || errorPolicy === 'all');
                            }
                            catch (e) {
                                reject(e);
                                return;
                            }
                        }
                        else {
                            _this.setQuery(queryId, function () { return ({
                                newData: { result: result.data, complete: true },
                            }); });
                        }
                        _this.queryStore.markQueryResult(queryId, result, fetchMoreForQueryId);
                        _this.invalidate(true, queryId, fetchMoreForQueryId);
                        _this.broadcastQueries();
                    }
                    if (result.errors && errorPolicy === 'none') {
                        reject(new __WEBPACK_IMPORTED_MODULE_5__errors_ApolloError__["a" /* ApolloError */]({
                            graphQLErrors: result.errors,
                        }));
                        return;
                    }
                    else if (errorPolicy === 'all') {
                        errorsFromStore = result.errors;
                    }
                    if (fetchMoreForQueryId || fetchPolicy === 'no-cache') {
                        resultFromStore = result.data;
                    }
                    else {
                        try {
                            resultFromStore = _this.dataStore.getCache().read({
                                variables: variables,
                                query: document,
                                optimistic: false,
                            });
                        }
                        catch (e) { }
                    }
                },
                error: function (error) {
                    _this.removeFetchQueryPromise(requestId);
                    _this.setQuery(queryId, function (_a) {
                        var subscriptions = _a.subscriptions;
                        return ({
                            subscriptions: subscriptions.filter(function (x) { return x !== subscription; }),
                        });
                    });
                    reject(error);
                },
                complete: function () {
                    _this.removeFetchQueryPromise(requestId);
                    _this.setQuery(queryId, function (_a) {
                        var subscriptions = _a.subscriptions;
                        return ({
                            subscriptions: subscriptions.filter(function (x) { return x !== subscription; }),
                        });
                    });
                    resolve({
                        data: resultFromStore,
                        errors: errorsFromStore,
                        loading: false,
                        networkStatus: __WEBPACK_IMPORTED_MODULE_10__networkStatus__["a" /* NetworkStatus */].ready,
                        stale: false,
                    });
                },
            });
            _this.setQuery(queryId, function (_a) {
                var subscriptions = _a.subscriptions;
                return ({
                    subscriptions: subscriptions.concat([subscription]),
                });
            });
        });
    };
    QueryManager.prototype.refetchQueryByName = function (queryName) {
        var _this = this;
        var refetchedQueries = this.queryIdsByName[queryName];
        if (refetchedQueries === undefined)
            return;
        return Promise.all(refetchedQueries
            .map(function (id) { return _this.getQuery(id).observableQuery; })
            .filter(function (x) { return !!x; })
            .map(function (x) { return x.refetch(); }));
    };
    QueryManager.prototype.generateRequestId = function () {
        var requestId = this.idCounter;
        this.idCounter++;
        return requestId;
    };
    QueryManager.prototype.getQuery = function (queryId) {
        return (this.queries.get(queryId) || {
            listeners: [],
            invalidated: false,
            document: null,
            newData: null,
            lastRequestId: null,
            observableQuery: null,
            subscriptions: [],
        });
    };
    QueryManager.prototype.setQuery = function (queryId, updater) {
        var prev = this.getQuery(queryId);
        var newInfo = __assign({}, prev, updater(prev));
        this.queries.set(queryId, newInfo);
    };
    QueryManager.prototype.invalidate = function (invalidated, queryId, fetchMoreForQueryId) {
        if (queryId)
            this.setQuery(queryId, function () { return ({ invalidated: invalidated }); });
        if (fetchMoreForQueryId) {
            this.setQuery(fetchMoreForQueryId, function () { return ({ invalidated: invalidated }); });
        }
    };
    QueryManager.prototype.buildOperationForLink = function (document, variables, extraContext) {
        var cache = this.dataStore.getCache();
        return {
            query: cache.transformForLink
                ? cache.transformForLink(document)
                : document,
            variables: variables,
            operationName: Object(__WEBPACK_IMPORTED_MODULE_3_apollo_utilities__["m" /* getOperationName */])(document) || undefined,
            context: __assign({}, extraContext, { cache: cache, getCacheKey: function (obj) {
                    if (cache.config) {
                        return cache.config.dataIdFromObject(obj);
                    }
                    else {
                        throw new Error('To use context.getCacheKey, you need to use a cache that has a configurable dataIdFromObject, like apollo-cache-inmemory.');
                    }
                }, clientAwareness: this.clientAwareness }),
        };
    };
    return QueryManager;
}());

//# sourceMappingURL=QueryManager.js.map

/***/ }),
/* 1117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dedupLink__ = __webpack_require__(1118);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__dedupLink__["a"]; });

//# sourceMappingURL=index.js.map

/***/ }),
/* 1118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DedupLink; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_apollo_link__ = __webpack_require__(95);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

/*
 * Expects context to contain the forceFetch field if no dedup
 */
var DedupLink = /** @class */ (function (_super) {
    __extends(DedupLink, _super);
    function DedupLink() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.inFlightRequestObservables = new Map();
        _this.subscribers = new Map();
        return _this;
    }
    DedupLink.prototype.request = function (operation, forward) {
        var _this = this;
        // sometimes we might not want to deduplicate a request, for example when we want to force fetch it.
        if (operation.getContext().forceFetch) {
            return forward(operation);
        }
        var key = operation.toKey();
        var cleanup = function (operationKey) {
            _this.inFlightRequestObservables.delete(operationKey);
            var prev = _this.subscribers.get(operationKey);
            return prev;
        };
        if (!this.inFlightRequestObservables.get(key)) {
            // this is a new request, i.e. we haven't deduplicated it yet
            // call the next link
            var singleObserver_1 = forward(operation);
            var subscription_1;
            var sharedObserver = new __WEBPACK_IMPORTED_MODULE_0_apollo_link__["Observable"](function (observer) {
                // this will still be called by each subscriber regardless of
                // deduplication status
                var prev = _this.subscribers.get(key);
                if (!prev)
                    prev = { next: [], error: [], complete: [] };
                _this.subscribers.set(key, {
                    next: prev.next.concat([observer.next.bind(observer)]),
                    error: prev.error.concat([observer.error.bind(observer)]),
                    complete: prev.complete.concat([observer.complete.bind(observer)]),
                });
                if (!subscription_1) {
                    subscription_1 = singleObserver_1.subscribe({
                        next: function (result) {
                            var previous = cleanup(key);
                            _this.subscribers.delete(key);
                            if (previous) {
                                previous.next.forEach(function (next) { return next(result); });
                                previous.complete.forEach(function (complete) { return complete(); });
                            }
                        },
                        error: function (error) {
                            var previous = cleanup(key);
                            _this.subscribers.delete(key);
                            if (previous)
                                previous.error.forEach(function (err) { return err(error); });
                        },
                    });
                }
                return function () {
                    if (subscription_1)
                        subscription_1.unsubscribe();
                    _this.inFlightRequestObservables.delete(key);
                };
            });
            this.inFlightRequestObservables.set(key, sharedObserver);
        }
        // return shared Observable
        return this.inFlightRequestObservables.get(key);
    };
    return DedupLink;
}(__WEBPACK_IMPORTED_MODULE_0_apollo_link__["ApolloLink"]));

//# sourceMappingURL=dedupLink.js.map

/***/ }),
/* 1119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return QueryScheduler; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_types__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_ObservableQuery__ = __webpack_require__(336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_networkStatus__ = __webpack_require__(175);
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};



var QueryScheduler = (function () {
    function QueryScheduler(_a) {
        var queryManager = _a.queryManager, ssrMode = _a.ssrMode;
        this.inFlightQueries = {};
        this.registeredQueries = {};
        this.intervalQueries = {};
        this.pollingTimers = {};
        this.ssrMode = false;
        this.queryManager = queryManager;
        this.ssrMode = ssrMode || false;
    }
    QueryScheduler.prototype.checkInFlight = function (queryId) {
        var query = this.queryManager.queryStore.get(queryId);
        return (query &&
            query.networkStatus !== __WEBPACK_IMPORTED_MODULE_2__core_networkStatus__["a" /* NetworkStatus */].ready &&
            query.networkStatus !== __WEBPACK_IMPORTED_MODULE_2__core_networkStatus__["a" /* NetworkStatus */].error);
    };
    QueryScheduler.prototype.fetchQuery = function (queryId, options, fetchType) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.queryManager
                .fetchQuery(queryId, options, fetchType)
                .then(function (result) {
                resolve(result);
            })
                .catch(function (error) {
                reject(error);
            });
        });
    };
    QueryScheduler.prototype.startPollingQuery = function (options, queryId, listener) {
        if (!options.pollInterval) {
            throw new Error('Attempted to start a polling query without a polling interval.');
        }
        if (this.ssrMode)
            return queryId;
        this.registeredQueries[queryId] = options;
        if (listener) {
            this.queryManager.addQueryListener(queryId, listener);
        }
        this.addQueryOnInterval(queryId, options);
        return queryId;
    };
    QueryScheduler.prototype.stopPollingQuery = function (queryId) {
        delete this.registeredQueries[queryId];
    };
    QueryScheduler.prototype.fetchQueriesOnInterval = function (interval) {
        var _this = this;
        this.intervalQueries[interval] = this.intervalQueries[interval].filter(function (queryId) {
            if (!(_this.registeredQueries.hasOwnProperty(queryId) &&
                _this.registeredQueries[queryId].pollInterval === interval)) {
                return false;
            }
            if (_this.checkInFlight(queryId)) {
                return true;
            }
            var queryOptions = _this.registeredQueries[queryId];
            var pollingOptions = __assign({}, queryOptions);
            pollingOptions.fetchPolicy = 'network-only';
            _this.fetchQuery(queryId, pollingOptions, __WEBPACK_IMPORTED_MODULE_0__core_types__["a" /* FetchType */].poll).catch(function () { });
            return true;
        });
        if (this.intervalQueries[interval].length === 0) {
            clearInterval(this.pollingTimers[interval]);
            delete this.intervalQueries[interval];
        }
    };
    QueryScheduler.prototype.addQueryOnInterval = function (queryId, queryOptions) {
        var _this = this;
        var interval = queryOptions.pollInterval;
        if (!interval) {
            throw new Error("A poll interval is required to start polling query with id '" + queryId + "'.");
        }
        if (this.intervalQueries.hasOwnProperty(interval.toString()) &&
            this.intervalQueries[interval].length > 0) {
            this.intervalQueries[interval].push(queryId);
        }
        else {
            this.intervalQueries[interval] = [queryId];
            this.pollingTimers[interval] = setInterval(function () {
                _this.fetchQueriesOnInterval(interval);
            }, interval);
        }
    };
    QueryScheduler.prototype.registerPollingQuery = function (queryOptions) {
        if (!queryOptions.pollInterval) {
            throw new Error('Attempted to register a non-polling query with the scheduler.');
        }
        return new __WEBPACK_IMPORTED_MODULE_1__core_ObservableQuery__["a" /* ObservableQuery */]({
            scheduler: this,
            options: queryOptions,
        });
    };
    return QueryScheduler;
}());

//# sourceMappingURL=scheduler.js.map

/***/ }),
/* 1120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MutationStore; });
var MutationStore = (function () {
    function MutationStore() {
        this.store = {};
    }
    MutationStore.prototype.getStore = function () {
        return this.store;
    };
    MutationStore.prototype.get = function (mutationId) {
        return this.store[mutationId];
    };
    MutationStore.prototype.initMutation = function (mutationId, mutationString, variables) {
        this.store[mutationId] = {
            mutationString: mutationString,
            variables: variables || {},
            loading: true,
            error: null,
        };
    };
    MutationStore.prototype.markMutationError = function (mutationId, error) {
        var mutation = this.store[mutationId];
        if (!mutation) {
            return;
        }
        mutation.loading = false;
        mutation.error = error;
    };
    MutationStore.prototype.markMutationResult = function (mutationId) {
        var mutation = this.store[mutationId];
        if (!mutation) {
            return;
        }
        mutation.loading = false;
        mutation.error = null;
    };
    MutationStore.prototype.reset = function () {
        this.store = {};
    };
    return MutationStore;
}());

//# sourceMappingURL=mutations.js.map

/***/ }),
/* 1121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return QueryStore; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_graphql_language_printer__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_apollo_utilities__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_networkStatus__ = __webpack_require__(175);
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};



var QueryStore = (function () {
    function QueryStore() {
        this.store = {};
    }
    QueryStore.prototype.getStore = function () {
        return this.store;
    };
    QueryStore.prototype.get = function (queryId) {
        return this.store[queryId];
    };
    QueryStore.prototype.initQuery = function (query) {
        var previousQuery = this.store[query.queryId];
        if (previousQuery &&
            previousQuery.document !== query.document &&
            Object(__WEBPACK_IMPORTED_MODULE_0_graphql_language_printer__["a" /* print */])(previousQuery.document) !== Object(__WEBPACK_IMPORTED_MODULE_0_graphql_language_printer__["a" /* print */])(query.document)) {
            throw new Error('Internal Error: may not update existing query string in store');
        }
        var isSetVariables = false;
        var previousVariables = null;
        if (query.storePreviousVariables &&
            previousQuery &&
            previousQuery.networkStatus !== __WEBPACK_IMPORTED_MODULE_2__core_networkStatus__["a" /* NetworkStatus */].loading) {
            if (!Object(__WEBPACK_IMPORTED_MODULE_1_apollo_utilities__["r" /* isEqual */])(previousQuery.variables, query.variables)) {
                isSetVariables = true;
                previousVariables = previousQuery.variables;
            }
        }
        var networkStatus;
        if (isSetVariables) {
            networkStatus = __WEBPACK_IMPORTED_MODULE_2__core_networkStatus__["a" /* NetworkStatus */].setVariables;
        }
        else if (query.isPoll) {
            networkStatus = __WEBPACK_IMPORTED_MODULE_2__core_networkStatus__["a" /* NetworkStatus */].poll;
        }
        else if (query.isRefetch) {
            networkStatus = __WEBPACK_IMPORTED_MODULE_2__core_networkStatus__["a" /* NetworkStatus */].refetch;
        }
        else {
            networkStatus = __WEBPACK_IMPORTED_MODULE_2__core_networkStatus__["a" /* NetworkStatus */].loading;
        }
        var graphQLErrors = [];
        if (previousQuery && previousQuery.graphQLErrors) {
            graphQLErrors = previousQuery.graphQLErrors;
        }
        this.store[query.queryId] = {
            document: query.document,
            variables: query.variables,
            previousVariables: previousVariables,
            networkError: null,
            graphQLErrors: graphQLErrors,
            networkStatus: networkStatus,
            metadata: query.metadata,
        };
        if (typeof query.fetchMoreForQueryId === 'string' &&
            this.store[query.fetchMoreForQueryId]) {
            this.store[query.fetchMoreForQueryId].networkStatus =
                __WEBPACK_IMPORTED_MODULE_2__core_networkStatus__["a" /* NetworkStatus */].fetchMore;
        }
    };
    QueryStore.prototype.markQueryResult = function (queryId, result, fetchMoreForQueryId) {
        if (!this.store || !this.store[queryId])
            return;
        this.store[queryId].networkError = null;
        this.store[queryId].graphQLErrors =
            result.errors && result.errors.length ? result.errors : [];
        this.store[queryId].previousVariables = null;
        this.store[queryId].networkStatus = __WEBPACK_IMPORTED_MODULE_2__core_networkStatus__["a" /* NetworkStatus */].ready;
        if (typeof fetchMoreForQueryId === 'string' &&
            this.store[fetchMoreForQueryId]) {
            this.store[fetchMoreForQueryId].networkStatus = __WEBPACK_IMPORTED_MODULE_2__core_networkStatus__["a" /* NetworkStatus */].ready;
        }
    };
    QueryStore.prototype.markQueryError = function (queryId, error, fetchMoreForQueryId) {
        if (!this.store || !this.store[queryId])
            return;
        this.store[queryId].networkError = error;
        this.store[queryId].networkStatus = __WEBPACK_IMPORTED_MODULE_2__core_networkStatus__["a" /* NetworkStatus */].error;
        if (typeof fetchMoreForQueryId === 'string') {
            this.markQueryResultClient(fetchMoreForQueryId, true);
        }
    };
    QueryStore.prototype.markQueryResultClient = function (queryId, complete) {
        if (!this.store || !this.store[queryId])
            return;
        this.store[queryId].networkError = null;
        this.store[queryId].previousVariables = null;
        this.store[queryId].networkStatus = complete
            ? __WEBPACK_IMPORTED_MODULE_2__core_networkStatus__["a" /* NetworkStatus */].ready
            : __WEBPACK_IMPORTED_MODULE_2__core_networkStatus__["a" /* NetworkStatus */].loading;
    };
    QueryStore.prototype.stopQuery = function (queryId) {
        delete this.store[queryId];
    };
    QueryStore.prototype.reset = function (observableQueryIds) {
        var _this = this;
        this.store = Object.keys(this.store)
            .filter(function (queryId) {
            return observableQueryIds.indexOf(queryId) > -1;
        })
            .reduce(function (res, key) {
            res[key] = __assign({}, _this.store[key], { networkStatus: __WEBPACK_IMPORTED_MODULE_2__core_networkStatus__["a" /* NetworkStatus */].loading });
            return res;
        }, {});
    };
    return QueryStore;
}());

//# sourceMappingURL=queries.js.map

/***/ }),
/* 1122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DataStore; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_apollo_utilities__ = __webpack_require__(59);

var DataStore = (function () {
    function DataStore(initialCache) {
        this.cache = initialCache;
    }
    DataStore.prototype.getCache = function () {
        return this.cache;
    };
    DataStore.prototype.markQueryResult = function (result, document, variables, fetchMoreForQueryId, ignoreErrors) {
        if (ignoreErrors === void 0) { ignoreErrors = false; }
        var writeWithErrors = !Object(__WEBPACK_IMPORTED_MODULE_0_apollo_utilities__["p" /* graphQLResultHasError */])(result);
        if (ignoreErrors && Object(__WEBPACK_IMPORTED_MODULE_0_apollo_utilities__["p" /* graphQLResultHasError */])(result) && result.data) {
            writeWithErrors = true;
        }
        if (!fetchMoreForQueryId && writeWithErrors) {
            this.cache.write({
                result: result.data,
                dataId: 'ROOT_QUERY',
                query: document,
                variables: variables,
            });
        }
    };
    DataStore.prototype.markSubscriptionResult = function (result, document, variables) {
        if (!Object(__WEBPACK_IMPORTED_MODULE_0_apollo_utilities__["p" /* graphQLResultHasError */])(result)) {
            this.cache.write({
                result: result.data,
                dataId: 'ROOT_SUBSCRIPTION',
                query: document,
                variables: variables,
            });
        }
    };
    DataStore.prototype.markMutationInit = function (mutation) {
        var _this = this;
        if (mutation.optimisticResponse) {
            var optimistic_1;
            if (typeof mutation.optimisticResponse === 'function') {
                optimistic_1 = mutation.optimisticResponse(mutation.variables);
            }
            else {
                optimistic_1 = mutation.optimisticResponse;
            }
            var changeFn_1 = function () {
                _this.markMutationResult({
                    mutationId: mutation.mutationId,
                    result: { data: optimistic_1 },
                    document: mutation.document,
                    variables: mutation.variables,
                    updateQueries: mutation.updateQueries,
                    update: mutation.update,
                });
            };
            this.cache.recordOptimisticTransaction(function (c) {
                var orig = _this.cache;
                _this.cache = c;
                try {
                    changeFn_1();
                }
                finally {
                    _this.cache = orig;
                }
            }, mutation.mutationId);
        }
    };
    DataStore.prototype.markMutationResult = function (mutation) {
        var _this = this;
        if (!Object(__WEBPACK_IMPORTED_MODULE_0_apollo_utilities__["p" /* graphQLResultHasError */])(mutation.result)) {
            var cacheWrites_1 = [];
            cacheWrites_1.push({
                result: mutation.result.data,
                dataId: 'ROOT_MUTATION',
                query: mutation.document,
                variables: mutation.variables,
            });
            if (mutation.updateQueries) {
                Object.keys(mutation.updateQueries)
                    .filter(function (id) { return mutation.updateQueries[id]; })
                    .forEach(function (queryId) {
                    var _a = mutation.updateQueries[queryId], query = _a.query, updater = _a.updater;
                    var _b = _this.cache.diff({
                        query: query.document,
                        variables: query.variables,
                        returnPartialData: true,
                        optimistic: false,
                    }), currentQueryResult = _b.result, complete = _b.complete;
                    if (!complete) {
                        return;
                    }
                    var nextQueryResult = Object(__WEBPACK_IMPORTED_MODULE_0_apollo_utilities__["D" /* tryFunctionOrLogError */])(function () {
                        return updater(currentQueryResult, {
                            mutationResult: mutation.result,
                            queryName: Object(__WEBPACK_IMPORTED_MODULE_0_apollo_utilities__["m" /* getOperationName */])(query.document) || undefined,
                            queryVariables: query.variables,
                        });
                    });
                    if (nextQueryResult) {
                        cacheWrites_1.push({
                            result: nextQueryResult,
                            dataId: 'ROOT_QUERY',
                            query: query.document,
                            variables: query.variables,
                        });
                    }
                });
            }
            this.cache.performTransaction(function (c) {
                cacheWrites_1.forEach(function (write) { return c.write(write); });
            });
            var update_1 = mutation.update;
            if (update_1) {
                this.cache.performTransaction(function (c) {
                    Object(__WEBPACK_IMPORTED_MODULE_0_apollo_utilities__["D" /* tryFunctionOrLogError */])(function () { return update_1(c, mutation.result); });
                });
            }
        }
    };
    DataStore.prototype.markMutationComplete = function (_a) {
        var mutationId = _a.mutationId, optimisticResponse = _a.optimisticResponse;
        if (!optimisticResponse)
            return;
        this.cache.removeOptimistic(mutationId);
    };
    DataStore.prototype.markUpdateQueryResult = function (document, variables, newResult) {
        this.cache.write({
            result: newResult,
            dataId: 'ROOT_QUERY',
            variables: variables,
            query: document,
        });
    };
    DataStore.prototype.reset = function () {
        return this.cache.reset();
    };
    return DataStore;
}());

//# sourceMappingURL=store.js.map

/***/ }),
/* 1123 */
/***/ (function(module, exports) {

exports.version = "2.4.8"

/***/ }),
/* 1124 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.4.0
 * react-dom-server.browser.production.min.js
 *
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var p=__webpack_require__(292),r=__webpack_require__(57),t=__webpack_require__(0),w=__webpack_require__(294),x=__webpack_require__(293),y=__webpack_require__(1125),z=__webpack_require__(1127);
function A(a){for(var b=arguments.length-1,d="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=0;c<b;c++)d+="&args[]="+encodeURIComponent(arguments[c+1]);p(!1,"Minified React error #"+a+"; visit %s for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ",d)}
var C="function"===typeof Symbol&&Symbol.for,aa=C?Symbol.for("react.portal"):60106,E=C?Symbol.for("react.fragment"):60107,ba=C?Symbol.for("react.strict_mode"):60108,ca=C?Symbol.for("react.profiler"):60114,F=C?Symbol.for("react.provider"):60109,da=C?Symbol.for("react.context"):60110,ea=C?Symbol.for("react.async_mode"):60111,fa=C?Symbol.for("react.forward_ref"):60112,ha=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,
G={},H={};function ia(a){if(H.hasOwnProperty(a))return!0;if(G.hasOwnProperty(a))return!1;if(ha.test(a))return H[a]=!0;G[a]=!0;return!1}function ja(a,b,d,c){if(null!==d&&0===d.type)return!1;switch(typeof b){case "function":case "symbol":return!0;case "boolean":if(c)return!1;if(null!==d)return!d.acceptsBooleans;a=a.toLowerCase().slice(0,5);return"data-"!==a&&"aria-"!==a;default:return!1}}
function ka(a,b,d,c){if(null===b||"undefined"===typeof b||ja(a,b,d,c))return!0;if(c)return!1;if(null!==d)switch(d.type){case 3:return!b;case 4:return!1===b;case 5:return isNaN(b);case 6:return isNaN(b)||1>b}return!1}function I(a,b,d,c,k){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=c;this.attributeNamespace=k;this.mustUseProperty=d;this.propertyName=a;this.type=b}var J={};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){J[a]=new I(a,0,!1,a,null)});[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];J[b]=new I(b,1,!1,a[1],null)});["contentEditable","draggable","spellCheck","value"].forEach(function(a){J[a]=new I(a,2,!1,a.toLowerCase(),null)});
["autoReverse","externalResourcesRequired","preserveAlpha"].forEach(function(a){J[a]=new I(a,2,!1,a,null)});"allowFullScreen async autoFocus autoPlay controls default defer disabled formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){J[a]=new I(a,3,!1,a.toLowerCase(),null)});["checked","multiple","muted","selected"].forEach(function(a){J[a]=new I(a,3,!0,a.toLowerCase(),null)});
["capture","download"].forEach(function(a){J[a]=new I(a,4,!1,a.toLowerCase(),null)});["cols","rows","size","span"].forEach(function(a){J[a]=new I(a,6,!1,a.toLowerCase(),null)});["rowSpan","start"].forEach(function(a){J[a]=new I(a,5,!1,a.toLowerCase(),null)});var K=/[\-:]([a-z])/g;function L(a){return a[1].toUpperCase()}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(K,
L);J[b]=new I(b,1,!1,a,null)});"xlink:actuate xlink:arcrole xlink:href xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(K,L);J[b]=new I(b,1,!1,a,"http://www.w3.org/1999/xlink")});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(K,L);J[b]=new I(b,1,!1,a,"http://www.w3.org/XML/1998/namespace")});J.tabIndex=new I("tabIndex",1,!1,"tabindex",null);var la=/["'&<>]/;
function M(a){if("boolean"===typeof a||"number"===typeof a)return""+a;a=""+a;var b=la.exec(a);if(b){var d="",c,k=0;for(c=b.index;c<a.length;c++){switch(a.charCodeAt(c)){case 34:b="&quot;";break;case 38:b="&amp;";break;case 39:b="&#x27;";break;case 60:b="&lt;";break;case 62:b="&gt;";break;default:continue}k!==c&&(d+=a.substring(k,c));k=c+1;d+=b}a=k!==c?d+a.substring(k,c):d}return a}var N={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
function O(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}
var P={area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0},ma=r({menuitem:!0},P),Q={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,
fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,floodOpacity:!0,stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},na=["Webkit","ms","Moz","O"];Object.keys(Q).forEach(function(a){na.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);Q[b]=Q[a]})});var R=t.Children.toArray,S=w.thatReturns("");w.thatReturns("");var oa={listing:!0,pre:!0,textarea:!0};
function T(a){return"string"===typeof a?a:"function"===typeof a?a.displayName||a.name:null}var pa=/^[a-zA-Z][a-zA-Z:_\.\-\d]*$/,U={},qa=z(function(a){return y(a)});function ra(a){var b="";t.Children.forEach(a,function(a){null==a||"string"!==typeof a&&"number"!==typeof a||(b+=a)});return b}function sa(a,b){if(a=a.contextTypes){var d={},c;for(c in a)d[c]=b[c];b=d}else b=x;return b}var ta={children:null,dangerouslySetInnerHTML:null,suppressContentEditableWarning:null,suppressHydrationWarning:null};
function V(a,b){void 0===a&&A("152",T(b)||"Component")}
function ua(a,b){function d(c,k){var d=sa(k,b),f=[],h=!1,g={isMounted:function(){return!1},enqueueForceUpdate:function(){if(null===f)return null},enqueueReplaceState:function(a,b){h=!0;f=[b]},enqueueSetState:function(a,b){if(null===f)return null;f.push(b)}},e=void 0;if(k.prototype&&k.prototype.isReactComponent){if(e=new k(c.props,d,g),"function"===typeof k.getDerivedStateFromProps){var v=k.getDerivedStateFromProps.call(null,c.props,e.state);null!=v&&(e.state=r({},e.state,v))}}else if(e=k(c.props,
d,g),null==e||null==e.render){a=e;V(a,k);return}e.props=c.props;e.context=d;e.updater=g;g=e.state;void 0===g&&(e.state=g=null);if("function"===typeof e.UNSAFE_componentWillMount||"function"===typeof e.componentWillMount)if("function"===typeof e.componentWillMount&&"function"!==typeof k.getDerivedStateFromProps&&e.componentWillMount(),"function"===typeof e.UNSAFE_componentWillMount&&"function"!==typeof k.getDerivedStateFromProps&&e.UNSAFE_componentWillMount(),f.length){g=f;var u=h;f=null;h=!1;if(u&&
1===g.length)e.state=g[0];else{v=u?g[0]:e.state;var m=!0;for(u=u?1:0;u<g.length;u++){var n=g[u];n="function"===typeof n?n.call(e,v,c.props,d):n;null!=n&&(m?(m=!1,v=r({},v,n)):r(v,n))}e.state=v}}else f=null;a=e.render();V(a,k);c=void 0;if("function"===typeof e.getChildContext&&(d=k.childContextTypes,"object"===typeof d)){c=e.getChildContext();for(var q in c)q in d?void 0:A("108",T(k)||"Unknown",q)}c&&(b=r({},b,c))}for(;t.isValidElement(a);){var c=a,k=c.type;if("function"!==typeof k)break;d(c,k)}return{child:a,
context:b}}
var W=function(){function a(b,d){if(!(this instanceof a))throw new TypeError("Cannot call a class as a function");t.isValidElement(b)?b.type!==E?b=[b]:(b=b.props.children,b=t.isValidElement(b)?[b]:R(b)):b=R(b);this.stack=[{type:null,domNamespace:N.html,children:b,childIndex:0,context:x,footer:""}];this.exhausted=!1;this.currentSelectValue=null;this.previousWasTextNode=!1;this.makeStaticMarkup=d;this.providerStack=[];this.providerIndex=-1}a.prototype.pushProvider=function(a){this.providerIndex+=1;
this.providerStack[this.providerIndex]=a;a.type._context._currentValue=a.props.value};a.prototype.popProvider=function(a){this.providerStack[this.providerIndex]=null;--this.providerIndex;a=a.type._context;a._currentValue=0>this.providerIndex?a._defaultValue:this.providerStack[this.providerIndex].props.value};a.prototype.read=function(a){if(this.exhausted)return null;for(var b="";b.length<a;){if(0===this.stack.length){this.exhausted=!0;break}var c=this.stack[this.stack.length-1];if(c.childIndex>=c.children.length){var k=
c.footer;b+=k;""!==k&&(this.previousWasTextNode=!1);this.stack.pop();"select"===c.type?this.currentSelectValue=null:null!=c.type&&null!=c.type.type&&c.type.type.$$typeof===F&&this.popProvider(c.type)}else k=c.children[c.childIndex++],b+=this.render(k,c.context,c.domNamespace)}return b};a.prototype.render=function(a,d,c){if("string"===typeof a||"number"===typeof a){c=""+a;if(""===c)return"";if(this.makeStaticMarkup)return M(c);if(this.previousWasTextNode)return"\x3c!-- --\x3e"+M(c);this.previousWasTextNode=
!0;return M(c)}d=ua(a,d);a=d.child;d=d.context;if(null===a||!1===a)return"";if(!t.isValidElement(a)){if(null!=a&&null!=a.$$typeof){var b=a.$$typeof;b===aa?A("257"):void 0;A("258",b.toString())}a=R(a);this.stack.push({type:null,domNamespace:c,children:a,childIndex:0,context:d,footer:""});return""}b=a.type;if("string"===typeof b)return this.renderDOM(a,d,c);switch(b){case ba:case ea:case ca:case E:return a=R(a.props.children),this.stack.push({type:null,domNamespace:c,children:a,childIndex:0,context:d,
footer:""}),""}if("object"===typeof b&&null!==b)switch(b.$$typeof){case fa:return a=R(b.render(a.props,a.ref)),this.stack.push({type:null,domNamespace:c,children:a,childIndex:0,context:d,footer:""}),"";case F:return b=R(a.props.children),c={type:a,domNamespace:c,children:b,childIndex:0,context:d,footer:""},this.pushProvider(a),this.stack.push(c),"";case da:return b=R(a.props.children(a.type._currentValue)),this.stack.push({type:a,domNamespace:c,children:b,childIndex:0,context:d,footer:""}),""}A("130",
null==b?b:typeof b,"")};a.prototype.renderDOM=function(a,d,c){var b=a.type.toLowerCase();c===N.html&&O(b);U.hasOwnProperty(b)||(pa.test(b)?void 0:A("65",b),U[b]=!0);var f=a.props;if("input"===b)f=r({type:void 0},f,{defaultChecked:void 0,defaultValue:void 0,value:null!=f.value?f.value:f.defaultValue,checked:null!=f.checked?f.checked:f.defaultChecked});else if("textarea"===b){var h=f.value;if(null==h){h=f.defaultValue;var l=f.children;null!=l&&(null!=h?A("92"):void 0,Array.isArray(l)&&(1>=l.length?
void 0:A("93"),l=l[0]),h=""+l);null==h&&(h="")}f=r({},f,{value:void 0,children:""+h})}else if("select"===b)this.currentSelectValue=null!=f.value?f.value:f.defaultValue,f=r({},f,{value:void 0});else if("option"===b){l=this.currentSelectValue;var D=ra(f.children);if(null!=l){var B=null!=f.value?f.value+"":D;h=!1;if(Array.isArray(l))for(var g=0;g<l.length;g++){if(""+l[g]===B){h=!0;break}}else h=""+l===B;f=r({selected:void 0,children:void 0},f,{selected:h,children:D})}}if(h=f)ma[b]&&(null!=h.children||
null!=h.dangerouslySetInnerHTML?A("137",b,S()):void 0),null!=h.dangerouslySetInnerHTML&&(null!=h.children?A("60"):void 0,"object"===typeof h.dangerouslySetInnerHTML&&"__html"in h.dangerouslySetInnerHTML?void 0:A("61")),null!=h.style&&"object"!==typeof h.style?A("62",S()):void 0;h=f;l=this.makeStaticMarkup;D=1===this.stack.length;B="<"+a.type;for(q in h)if(h.hasOwnProperty(q)){var e=h[q];if(null!=e){if("style"===q){g=void 0;var v="",u="";for(g in e)if(e.hasOwnProperty(g)){var m=0===g.indexOf("--"),
n=e[g];null!=n&&(v+=u+qa(g)+":",u=g,m=null==n||"boolean"===typeof n||""===n?"":m||"number"!==typeof n||0===n||Q.hasOwnProperty(u)&&Q[u]?(""+n).trim():n+"px",v+=m,u=";")}e=v||null}g=null;b:if(m=b,n=h,-1===m.indexOf("-"))m="string"===typeof n.is;else switch(m){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":m=!1;break b;default:m=!0}if(m)ta.hasOwnProperty(q)||(g=q,g=ia(g)&&null!=
e?g+"="+('"'+M(e)+'"'):"");else{m=q;g=e;e=J.hasOwnProperty(m)?J[m]:null;if(n="style"!==m)n=null!==e?0===e.type:!(2<m.length)||"o"!==m[0]&&"O"!==m[0]||"n"!==m[1]&&"N"!==m[1]?!1:!0;n||ka(m,g,e,!1)?g="":null!==e?(m=e.attributeName,e=e.type,g=3===e||4===e&&!0===g?m+'=""':m+"="+('"'+M(g)+'"')):g=m+"="+('"'+M(g)+'"')}g&&(B+=" "+g)}}l||D&&(B+=' data-reactroot=""');var q=B;h="";P.hasOwnProperty(b)?q+="/>":(q+=">",h="</"+a.type+">");a:{l=f.dangerouslySetInnerHTML;if(null!=l){if(null!=l.__html){l=l.__html;
break a}}else if(l=f.children,"string"===typeof l||"number"===typeof l){l=M(l);break a}l=null}null!=l?(f=[],oa[b]&&"\n"===l.charAt(0)&&(q+="\n"),q+=l):f=R(f.children);a=a.type;c=null==c||"http://www.w3.org/1999/xhtml"===c?O(a):"http://www.w3.org/2000/svg"===c&&"foreignObject"===a?"http://www.w3.org/1999/xhtml":c;this.stack.push({domNamespace:c,type:b,children:f,childIndex:0,context:d,footer:h});this.previousWasTextNode=!1;return q};return a}(),X={renderToString:function(a){return(new W(a,!1)).read(Infinity)},
renderToStaticMarkup:function(a){return(new W(a,!0)).read(Infinity)},renderToNodeStream:function(){A("207")},renderToStaticNodeStream:function(){A("208")},version:"16.4.0"},Y={default:X},Z=Y&&X||Y;module.exports=Z.default?Z.default:Z;


/***/ }),
/* 1125 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */



var hyphenate = __webpack_require__(1126);

var msPattern = /^ms-/;

/**
 * Hyphenates a camelcased CSS property name, for example:
 *
 *   > hyphenateStyleName('backgroundColor')
 *   < "background-color"
 *   > hyphenateStyleName('MozTransition')
 *   < "-moz-transition"
 *   > hyphenateStyleName('msTransition')
 *   < "-ms-transition"
 *
 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
 * is converted to `-ms-`.
 *
 * @param {string} string
 * @return {string}
 */
function hyphenateStyleName(string) {
  return hyphenate(string).replace(msPattern, '-ms-');
}

module.exports = hyphenateStyleName;

/***/ }),
/* 1126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var _uppercasePattern = /([A-Z])/g;

/**
 * Hyphenates a camelcased string, for example:
 *
 *   > hyphenate('backgroundColor')
 *   < "background-color"
 *
 * For CSS style names, use `hyphenateStyleName` instead which works properly
 * with all vendor prefixes, including `ms`.
 *
 * @param {string} string
 * @return {string}
 */
function hyphenate(string) {
  return string.replace(_uppercasePattern, '-$1').toLowerCase();
}

module.exports = hyphenate;

/***/ }),
/* 1127 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @typechecks static-only
 */



/**
 * Memoizes the return value of a function that accepts one string argument.
 */

function memoizeStringOnly(callback) {
  var cache = {};
  return function (string) {
    if (!cache.hasOwnProperty(string)) {
      cache[string] = callback.call(this, string);
    }
    return cache[string];
  };
}

module.exports = memoizeStringOnly;

/***/ }),
/* 1128 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.7.0
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

Object.defineProperty(exports,"__esModule",{value:!0});
var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?Symbol.for("react.memo"):
60115,r=b?Symbol.for("react.lazy"):60116;function t(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case h:return a;default:return u}}case r:case q:case d:return u}}}function v(a){return t(a)===m}exports.typeOf=t;exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;
exports.Fragment=e;exports.Lazy=r;exports.Memo=q;exports.Portal=d;exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||"object"===typeof a&&null!==a&&(a.$$typeof===r||a.$$typeof===q||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n)};exports.isAsyncMode=function(a){return v(a)||t(a)===l};exports.isConcurrentMode=v;exports.isContextConsumer=function(a){return t(a)===k};
exports.isContextProvider=function(a){return t(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return t(a)===n};exports.isFragment=function(a){return t(a)===e};exports.isLazy=function(a){return t(a)===r};exports.isMemo=function(a){return t(a)===q};exports.isPortal=function(a){return t(a)===d};exports.isProfiler=function(a){return t(a)===g};exports.isStrictMode=function(a){return t(a)===f};
exports.isSuspense=function(a){return t(a)===p};


/***/ }),
/* 1129 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]';

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Built-in value references. */
var Symbol = root.Symbol,
    propertyIsEnumerable = objectProto.propertyIsEnumerable,
    spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */
function baseFlatten(array, depth, predicate, isStrict, result) {
  var index = -1,
      length = array.length;

  predicate || (predicate = isFlattenable);
  result || (result = []);

  while (++index < length) {
    var value = array[index];
    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        // Recursively flatten arrays (susceptible to call stack limits).
        baseFlatten(value, depth - 1, predicate, isStrict, result);
      } else {
        arrayPush(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }
  return result;
}

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = array;
    return apply(func, this, otherArgs);
  };
}

/**
 * Creates a `_.flow` or `_.flowRight` function.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new flow function.
 */
function createFlow(fromRight) {
  return baseRest(function(funcs) {
    funcs = baseFlatten(funcs, 1);

    var length = funcs.length,
        index = length;

    if (fromRight) {
      funcs.reverse();
    }
    while (index--) {
      if (typeof funcs[index] != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
    }
    return function() {
      var index = 0,
          result = length ? funcs[index].apply(this, arguments) : arguments[0];

      while (++index < length) {
        result = funcs[index].call(this, result);
      }
      return result;
    };
  });
}

/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */
function isFlattenable(value) {
  return isArray(value) || isArguments(value) ||
    !!(spreadableSymbol && value && value[spreadableSymbol]);
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments(value) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * This method is like `_.flow` except that it creates a function that
 * invokes the given functions from right to left.
 *
 * @static
 * @since 3.0.0
 * @memberOf _
 * @category Util
 * @param {...(Function|Function[])} [funcs] The functions to invoke.
 * @returns {Function} Returns the new composite function.
 * @see _.flow
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * var addSquare = _.flowRight([square, _.add]);
 * addSquare(1, 2);
 * // => 9
 */
var flowRight = createFlow(true);

module.exports = flowRight;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(26)))

/***/ }),
/* 1130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_lifecycles_compat__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var Form = function (_Component) {
  _inherits(Form, _Component);

  function Form(props, context) {
    _classCallCheck(this, Form);

    var _this = _possibleConstructorReturn(this, (Form.__proto__ || Object.getPrototypeOf(Form)).call(this, props, context));

    if (!context._reduxForm) {
      throw new Error('Form must be inside a component decorated with reduxForm()');
    }
    return _this;
  }

  _createClass(Form, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.context._reduxForm.registerInnerOnSubmit(this.props.onSubmit);
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form', this.props);
    }
  }]);

  return Form;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Form.propTypes = {
  onSubmit: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired
};
Form.contextTypes = {
  _reduxForm: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object
};

Object(__WEBPACK_IMPORTED_MODULE_1_react_lifecycles_compat__["polyfill"])(Form);
/* unused harmony default export */ var _unused_webpack_default_export = (Form);

/***/ }),
/* 1131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);




var FormName = function FormName(_ref, _ref2) {
  var children = _ref.children;
  var _reduxForm = _ref2._reduxForm;
  return children({ form: _reduxForm && _reduxForm.form });
};
FormName.contextTypes = {
  _reduxForm: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    form: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired
  }).isRequired
};

/* unused harmony default export */ var _unused_webpack_default_export = (FormName);

/***/ }),
/* 1132 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_prefixName__ = __webpack_require__(176);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var FormSection = function (_Component) {
  _inherits(FormSection, _Component);

  function FormSection(props, context) {
    _classCallCheck(this, FormSection);

    var _this = _possibleConstructorReturn(this, (FormSection.__proto__ || Object.getPrototypeOf(FormSection)).call(this, props, context));

    if (!context._reduxForm) {
      throw new Error('FormSection must be inside a component decorated with reduxForm()');
    }
    return _this;
  }

  _createClass(FormSection, [{
    key: 'getChildContext',
    value: function getChildContext() {
      var context = this.context,
          name = this.props.name;

      return {
        _reduxForm: _extends({}, context._reduxForm, {
          sectionPrefix: Object(__WEBPACK_IMPORTED_MODULE_2__util_prefixName__["a" /* default */])(context, name)
        })
      };
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          name = _props.name,
          component = _props.component,
          rest = _objectWithoutProperties(_props, ['children', 'name', 'component']);

      if (__WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(children)) {
        return children;
      }

      return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(component, _extends({}, rest, {
        children: children
      }));
    }
  }]);

  return FormSection;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

FormSection.propTypes = {
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  component: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node])
};

FormSection.defaultProps = {
  component: 'div'
};

FormSection.childContextTypes = {
  _reduxForm: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
};

FormSection.contextTypes = {
  _reduxForm: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

/* unused harmony default export */ var _unused_webpack_default_export = (FormSection);

/***/ }),
/* 1133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _extendableBuiltin(cls) {
  function ExtendableBuiltin() {
    cls.apply(this, arguments);
  }

  ExtendableBuiltin.prototype = Object.create(cls.prototype, {
    constructor: {
      value: cls,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });

  if (Object.setPrototypeOf) {
    Object.setPrototypeOf(ExtendableBuiltin, cls);
  } else {
    ExtendableBuiltin.__proto__ = cls;
  }

  return ExtendableBuiltin;
}

var ExtendableError = function (_extendableBuiltin2) {
  _inherits(ExtendableError, _extendableBuiltin2);

  function ExtendableError() {
    var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

    _classCallCheck(this, ExtendableError);

    // extending Error is weird and does not propagate `message`
    var _this = _possibleConstructorReturn(this, (ExtendableError.__proto__ || Object.getPrototypeOf(ExtendableError)).call(this, message));

    Object.defineProperty(_this, 'message', {
      configurable: true,
      enumerable: false,
      value: message,
      writable: true
    });

    Object.defineProperty(_this, 'name', {
      configurable: true,
      enumerable: false,
      value: _this.constructor.name,
      writable: true
    });

    if (Error.hasOwnProperty('captureStackTrace')) {
      Error.captureStackTrace(_this, _this.constructor);
      return _possibleConstructorReturn(_this);
    }

    Object.defineProperty(_this, 'stack', {
      configurable: true,
      enumerable: false,
      value: new Error(message).stack,
      writable: true
    });
    return _this;
  }

  return ExtendableError;
}(_extendableBuiltin(Error));

/* harmony default export */ __webpack_exports__["a"] = (ExtendableError);


/***/ }),
/* 1134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export formPropTypes */
/* unused harmony export fieldInputPropTypes */
/* unused harmony export fieldMetaPropTypes */
/* unused harmony export fieldArrayMetaPropTypes */
/* unused harmony export fieldArrayFieldsPropTypes */
/* unused harmony export fieldPropTypes */
/* unused harmony export fieldArrayPropTypes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);


var any = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.any,
    bool = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
    func = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
    shape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape,
    string = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
    oneOfType = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOfType,
    object = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object,
    number = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number;


var formPropTypes = {
  // State:
  anyTouched: bool.isRequired, // true if any of the fields have been marked as touched
  asyncValidating: oneOfType([bool, string]).isRequired, // true if async validation is running, a string if a field triggered async validation
  dirty: bool.isRequired, // true if any values are different from initialValues
  error: any, // form-wide error from '_error' key in validation result
  form: string.isRequired, // the name of the form
  invalid: bool.isRequired, // true if there are any validation errors
  initialized: bool.isRequired, // true if the form has been initialized
  initialValues: object, // the initialValues object passed to reduxForm
  pristine: bool.isRequired, // true if the values are the same as initialValues
  pure: bool.isRequired, // if true, implements shouldComponentUpdate
  submitting: bool.isRequired, // true if the form is in the process of being submitted
  submitFailed: bool.isRequired, // true if the form was submitted and failed for any reason
  submitSucceeded: bool.isRequired, // true if the form was successfully submitted
  valid: bool.isRequired, // true if there are no validation errors
  warning: any, // form-wide warning from '_warning' key in validation result
  // Actions:
  array: shape({
    insert: func.isRequired, // function to insert a value into an array field
    move: func.isRequired, // function to move a value within an array field
    pop: func.isRequired, // function to pop a value off of an array field
    push: func.isRequired, // function to push a value onto an array field
    remove: func.isRequired, // function to remove a value from an array field
    removeAll: func.isRequired, // function to remove all the values from an array field
    shift: func.isRequired, // function to shift a value out of an array field
    splice: func.isRequired, // function to splice a value into an array field
    swap: func.isRequired, // function to swap values in an array field
    unshift: func.isRequired // function to unshift a value into an array field
  }),
  asyncValidate: func.isRequired, // function to trigger async validation
  autofill: func.isRequired, // action to set a value of a field and mark it as autofilled
  blur: func.isRequired, // action to mark a field as blurred
  change: func.isRequired, // action to change the value of a field
  clearAsyncError: func.isRequired, // action to clear the async error of a field
  clearFields: func.isRequired, // action to clean fields values for all fields
  clearSubmitErrors: func.isRequired, // action to remove submitErrors and error
  destroy: func.isRequired, // action to destroy the form's data in Redux
  dispatch: func.isRequired, // the Redux dispatch action
  handleSubmit: func.isRequired, // function to submit the form
  initialize: func.isRequired, // action to initialize form data
  reset: func.isRequired, // action to reset the form data to previously initialized values
  resetSection: func.isRequired, // action to reset the form sections data to previously initialized values
  touch: func.isRequired, // action to mark fields as touched
  submit: func.isRequired, // action to trigger a submission of the specified form
  untouch: func.isRequired, // action to mark fields as untouched

  // triggerSubmit
  triggerSubmit: bool, // if true, submits the form on componentWillReceiveProps
  clearSubmit: func.isRequired // called before a triggered submit, by default clears triggerSubmit
};

var fieldInputPropTypes = {
  checked: bool,
  name: string.isRequired,
  onBlur: func.isRequired,
  onChange: func.isRequired,
  onDragStart: func.isRequired,
  onDrop: func.isRequired,
  onFocus: func.isRequired,
  value: any
};

var fieldMetaPropTypes = {
  active: bool.isRequired,
  asyncValidating: bool.isRequired,
  autofilled: bool.isRequired,
  dirty: bool.isRequired,
  dispatch: func.isRequired,
  error: any,
  form: string.isRequired,
  invalid: bool.isRequired,
  pristine: bool.isRequired,
  submitting: bool.isRequired,
  submitFailed: bool.isRequired,
  touched: bool.isRequired,
  valid: bool.isRequired,
  visited: bool.isRequired,
  warning: string
};

var fieldArrayMetaPropTypes = {
  dirty: bool.isRequired,
  error: any,
  form: string.isRequired,
  invalid: bool.isRequired,
  pristine: bool.isRequired,
  submitFailed: bool,
  submitting: bool,
  valid: bool.isRequired,
  warning: string
};

var fieldArrayFieldsPropTypes = {
  name: string.isRequired,
  forEach: func.isRequired,
  get: func.isRequired,
  getAll: func.isRequired,
  insert: func.isRequired,
  length: number.isRequired,
  map: func.isRequired,
  move: func.isRequired,
  pop: func.isRequired,
  push: func.isRequired,
  reduce: func.isRequired,
  remove: func.isRequired,
  removeAll: func.isRequired,
  shift: func.isRequired,
  swap: func.isRequired,
  unshift: func.isRequired
};

var fieldPropTypes = {
  input: shape(fieldInputPropTypes).isRequired,
  meta: shape(fieldMetaPropTypes).isRequired
};

var fieldArrayPropTypes = {
  fields: shape(fieldArrayFieldsPropTypes).isRequired,
  meta: shape(fieldArrayMetaPropTypes).isRequired
};

/* unused harmony default export */ var _unused_webpack_default_export = (formPropTypes);

/***/ }),
/* 1135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createField__ = __webpack_require__(1136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(28);



/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__createField__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 1136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_lifecycles_compat__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ConnectedField__ = __webpack_require__(1137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_shallowCompare__ = __webpack_require__(557);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_prefixName__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__structure_plain__ = __webpack_require__(28);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var createField = function createField(structure) {
  var ConnectedField = Object(__WEBPACK_IMPORTED_MODULE_4__ConnectedField__["a" /* default */])(structure);

  var setIn = structure.setIn;

  var Field = function (_Component) {
    _inherits(Field, _Component);

    function Field(props, context) {
      _classCallCheck(this, Field);

      var _this = _possibleConstructorReturn(this, (Field.__proto__ || Object.getPrototypeOf(Field)).call(this, props, context));

      _this.saveRef = function (ref) {
        return _this.ref = ref;
      };

      _this.normalize = function (name, value) {
        var normalize = _this.props.normalize;

        if (!normalize) {
          return value;
        }
        var previousValues = _this.context._reduxForm.getValues();
        var previousValue = _this.value;
        var nextValues = setIn(previousValues, name, value);
        return normalize(value, previousValue, nextValues, previousValues);
      };

      if (!context._reduxForm) {
        throw new Error('Field must be inside a component decorated with reduxForm()');
      }
      return _this;
    }

    _createClass(Field, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        var _this2 = this;

        this.context._reduxForm.register(this.name, 'Field', function () {
          return _this2.props.validate;
        }, function () {
          return _this2.props.warn;
        });
      }
    }, {
      key: 'shouldComponentUpdate',
      value: function shouldComponentUpdate(nextProps, nextState) {
        return Object(__WEBPACK_IMPORTED_MODULE_5__util_shallowCompare__["a" /* default */])(this, nextProps, nextState);
      }
    }, {
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(nextProps, nextContext) {
        var oldName = Object(__WEBPACK_IMPORTED_MODULE_6__util_prefixName__["a" /* default */])(this.context, this.props.name);
        var newName = Object(__WEBPACK_IMPORTED_MODULE_6__util_prefixName__["a" /* default */])(nextContext, nextProps.name);

        if (oldName !== newName ||
        // use deepEqual here because they could be a function or an array of functions
        !__WEBPACK_IMPORTED_MODULE_7__structure_plain__["a" /* default */].deepEqual(this.props.validate, nextProps.validate) || !__WEBPACK_IMPORTED_MODULE_7__structure_plain__["a" /* default */].deepEqual(this.props.warn, nextProps.warn)) {
          // unregister old name
          this.context._reduxForm.unregister(oldName);
          // register new name
          this.context._reduxForm.register(newName, 'Field', function () {
            return nextProps.validate;
          }, function () {
            return nextProps.warn;
          });
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        this.context._reduxForm.unregister(this.name);
      }
    }, {
      key: 'getRenderedComponent',
      value: function getRenderedComponent() {
        __WEBPACK_IMPORTED_MODULE_3_invariant___default()(this.props.withRef, 'If you want to access getRenderedComponent(), ' + 'you must specify a withRef prop to Field');
        return this.ref ? this.ref.getWrappedInstance().getRenderedComponent() : undefined;
      }
    }, {
      key: 'render',
      value: function render() {
        return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(ConnectedField, _extends({}, this.props, {
          name: this.name,
          normalize: this.normalize,
          _reduxForm: this.context._reduxForm,
          ref: this.saveRef
        }));
      }
    }, {
      key: 'name',
      get: function get() {
        return Object(__WEBPACK_IMPORTED_MODULE_6__util_prefixName__["a" /* default */])(this.context, this.props.name);
      }
    }, {
      key: 'dirty',
      get: function get() {
        return !this.pristine;
      }
    }, {
      key: 'pristine',
      get: function get() {
        return !!(this.ref && this.ref.getWrappedInstance().isPristine());
      }
    }, {
      key: 'value',
      get: function get() {
        return this.ref && this.ref.getWrappedInstance().getValue();
      }
    }]);

    return Field;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

  Field.propTypes = {
    name: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,
    component: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node]).isRequired,
    format: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
    normalize: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
    onBlur: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
    onChange: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
    onFocus: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
    onDragStart: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
    onDrop: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
    parse: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
    props: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,
    validate: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func)]),
    warn: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func)]),
    withRef: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
    immutableProps: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string)
  };
  Field.contextTypes = {
    _reduxForm: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object
  };

  Object(__WEBPACK_IMPORTED_MODULE_1_react_lifecycles_compat__["polyfill"])(Field);
  return Field;
};

/* harmony default export */ __webpack_exports__["a"] = (createField);

/***/ }),
/* 1137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__createFieldProps__ = __webpack_require__(540);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__events_onChangeValue__ = __webpack_require__(541);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_eventConsts__ = __webpack_require__(1151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__structure_plain__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__isReactNative__ = __webpack_require__(543);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var propsToNotUpdateFor = ['_reduxForm'];

var isObject = function isObject(entity) {
  return entity && (typeof entity === 'undefined' ? 'undefined' : _typeof(entity)) === 'object';
};

var isFunction = function isFunction(entity) {
  return entity && typeof entity === 'function';
};

var eventPreventDefault = function eventPreventDefault(event) {
  if (isObject(event) && isFunction(event.preventDefault)) {
    event.preventDefault();
  }
};

var eventDataTransferGetData = function eventDataTransferGetData(event, key) {
  if (isObject(event) && isObject(event.dataTransfer) && isFunction(event.dataTransfer.getData)) {
    return event.dataTransfer.getData(key);
  }
};

var eventDataTransferSetData = function eventDataTransferSetData(event, key, value) {
  if (isObject(event) && isObject(event.dataTransfer) && isFunction(event.dataTransfer.setData)) {
    event.dataTransfer.setData(key, value);
  }
};

var createConnectedField = function createConnectedField(structure) {
  var deepEqual = structure.deepEqual,
      getIn = structure.getIn;

  var getSyncError = function getSyncError(syncErrors, name) {
    var error = __WEBPACK_IMPORTED_MODULE_6__structure_plain__["a" /* default */].getIn(syncErrors, name);
    // Because the error for this field might not be at a level in the error structure where
    // it can be set directly, it might need to be unwrapped from the _error property
    return error && error._error ? error._error : error;
  };

  var getSyncWarning = function getSyncWarning(syncWarnings, name) {
    var warning = getIn(syncWarnings, name);
    // Because the warning for this field might not be at a level in the warning structure where
    // it can be set directly, it might need to be unwrapped from the _warning property
    return warning && warning._warning ? warning._warning : warning;
  };

  var ConnectedField = function (_Component) {
    _inherits(ConnectedField, _Component);

    function ConnectedField() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, ConnectedField);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ConnectedField.__proto__ || Object.getPrototypeOf(ConnectedField)).call.apply(_ref, [this].concat(args))), _this), _this.saveRef = function (ref) {
        return _this.ref = ref;
      }, _this.isPristine = function () {
        return _this.props.pristine;
      }, _this.getValue = function () {
        return _this.props.value;
      }, _this.handleChange = function (event) {
        var _this$props = _this.props,
            name = _this$props.name,
            dispatch = _this$props.dispatch,
            parse = _this$props.parse,
            normalize = _this$props.normalize,
            onChange = _this$props.onChange,
            _reduxForm = _this$props._reduxForm,
            previousValue = _this$props.value;

        var newValue = Object(__WEBPACK_IMPORTED_MODULE_4__events_onChangeValue__["a" /* default */])(event, { name: name, parse: parse, normalize: normalize });

        var defaultPrevented = false;
        if (onChange) {
          // Can't seem to find a way to extend Event in React Native,
          // thus I simply avoid adding preventDefault() in a RN environment
          // to prevent the following error:
          // `One of the sources for assign has an enumerable key on the prototype chain`
          // Reference: https://github.com/facebook/react-native/issues/5507
          if (!__WEBPACK_IMPORTED_MODULE_7__isReactNative__["a" /* default */]) {
            onChange(_extends({}, event, {
              preventDefault: function preventDefault() {
                defaultPrevented = true;
                return eventPreventDefault(event);
              }
            }), newValue, previousValue, name);
          } else {
            onChange(event, newValue, previousValue, name);
          }
        }
        if (!defaultPrevented) {
          // dispatch change action
          dispatch(_reduxForm.change(name, newValue));

          // call post-change callback
          if (_reduxForm.asyncValidate) {
            _reduxForm.asyncValidate(name, newValue, 'change');
          }
        }
      }, _this.handleFocus = function (event) {
        var _this$props2 = _this.props,
            name = _this$props2.name,
            dispatch = _this$props2.dispatch,
            onFocus = _this$props2.onFocus,
            _reduxForm = _this$props2._reduxForm;


        var defaultPrevented = false;
        if (onFocus) {
          if (!__WEBPACK_IMPORTED_MODULE_7__isReactNative__["a" /* default */]) {
            onFocus(_extends({}, event, {
              preventDefault: function preventDefault() {
                defaultPrevented = true;
                return eventPreventDefault(event);
              }
            }), name);
          } else {
            onFocus(event, name);
          }
        }

        if (!defaultPrevented) {
          dispatch(_reduxForm.focus(name));
        }
      }, _this.handleBlur = function (event) {
        var _this$props3 = _this.props,
            name = _this$props3.name,
            dispatch = _this$props3.dispatch,
            parse = _this$props3.parse,
            normalize = _this$props3.normalize,
            onBlur = _this$props3.onBlur,
            _reduxForm = _this$props3._reduxForm,
            _value = _this$props3._value,
            previousValue = _this$props3.value;

        var newValue = Object(__WEBPACK_IMPORTED_MODULE_4__events_onChangeValue__["a" /* default */])(event, { name: name, parse: parse, normalize: normalize });

        // for checkbox and radio, if the value property of checkbox or radio equals
        // the value passed by blur event, then fire blur action with previousValue.
        if (newValue === _value && _value !== undefined) {
          newValue = previousValue;
        }

        var defaultPrevented = false;
        if (onBlur) {
          if (!__WEBPACK_IMPORTED_MODULE_7__isReactNative__["a" /* default */]) {
            onBlur(_extends({}, event, {
              preventDefault: function preventDefault() {
                defaultPrevented = true;
                return eventPreventDefault(event);
              }
            }), newValue, previousValue, name);
          } else {
            onBlur(event, newValue, previousValue, name);
          }
        }

        if (!defaultPrevented) {
          // dispatch blur action
          dispatch(_reduxForm.blur(name, newValue));

          // call post-blur callback
          if (_reduxForm.asyncValidate) {
            _reduxForm.asyncValidate(name, newValue, 'blur');
          }
        }
      }, _this.handleDragStart = function (event) {
        var _this$props4 = _this.props,
            name = _this$props4.name,
            onDragStart = _this$props4.onDragStart,
            value = _this$props4.value;

        eventDataTransferSetData(event, __WEBPACK_IMPORTED_MODULE_5__util_eventConsts__["a" /* dataKey */], value == null ? '' : value);

        if (onDragStart) {
          onDragStart(event, name);
        }
      }, _this.handleDrop = function (event) {
        var _this$props5 = _this.props,
            name = _this$props5.name,
            dispatch = _this$props5.dispatch,
            onDrop = _this$props5.onDrop,
            _reduxForm = _this$props5._reduxForm,
            previousValue = _this$props5.value;

        var newValue = eventDataTransferGetData(event, __WEBPACK_IMPORTED_MODULE_5__util_eventConsts__["a" /* dataKey */]);

        var defaultPrevented = false;
        if (onDrop) {
          onDrop(_extends({}, event, {
            preventDefault: function preventDefault() {
              defaultPrevented = true;
              return eventPreventDefault(event);
            }
          }), newValue, previousValue, name);
        }

        if (!defaultPrevented) {
          // dispatch change action
          dispatch(_reduxForm.change(name, newValue));
          eventPreventDefault(event);
        }
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(ConnectedField, [{
      key: 'shouldComponentUpdate',
      value: function shouldComponentUpdate(nextProps) {
        var _this2 = this;

        var nextPropsKeys = Object.keys(nextProps);
        var thisPropsKeys = Object.keys(this.props);
        // if we have children, we MUST update in React 16
        // https://twitter.com/erikras/status/915866544558788608
        return !!(this.props.children || nextProps.children || nextPropsKeys.length !== thisPropsKeys.length || nextPropsKeys.some(function (prop) {
          if (~(nextProps.immutableProps || []).indexOf(prop)) {
            return _this2.props[prop] !== nextProps[prop];
          }
          return !~propsToNotUpdateFor.indexOf(prop) && !deepEqual(_this2.props[prop], nextProps[prop]);
        }));
      }
    }, {
      key: 'getRenderedComponent',
      value: function getRenderedComponent() {
        return this.ref;
      }
    }, {
      key: 'render',
      value: function render() {
        var _props = this.props,
            component = _props.component,
            withRef = _props.withRef,
            name = _props.name,
            _reduxForm = _props._reduxForm,
            normalize = _props.normalize,
            onBlur = _props.onBlur,
            onChange = _props.onChange,
            onFocus = _props.onFocus,
            onDragStart = _props.onDragStart,
            onDrop = _props.onDrop,
            immutableProps = _props.immutableProps,
            rest = _objectWithoutProperties(_props, ['component', 'withRef', 'name', '_reduxForm', 'normalize', 'onBlur', 'onChange', 'onFocus', 'onDragStart', 'onDrop', 'immutableProps']);

        var _createFieldProps = Object(__WEBPACK_IMPORTED_MODULE_3__createFieldProps__["a" /* default */])(structure, name, _extends({}, rest, {
          form: _reduxForm.form,
          onBlur: this.handleBlur,
          onChange: this.handleChange,
          onDrop: this.handleDrop,
          onDragStart: this.handleDragStart,
          onFocus: this.handleFocus
        })),
            custom = _createFieldProps.custom,
            props = _objectWithoutProperties(_createFieldProps, ['custom']);

        if (withRef) {
          custom.ref = this.saveRef;
        }
        if (typeof component === 'string') {
          var input = props.input,
              meta = props.meta; // eslint-disable-line no-unused-vars
          // flatten input into other props

          return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(component, _extends({}, input, custom));
        } else {
          return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(component, _extends({}, props, custom));
        }
      }
    }]);

    return ConnectedField;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

  ConnectedField.propTypes = {
    component: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node]).isRequired,
    props: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
  };

  var connector = Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(function (state, ownProps) {
    var name = ownProps.name,
        _ownProps$_reduxForm = ownProps._reduxForm,
        initialValues = _ownProps$_reduxForm.initialValues,
        getFormState = _ownProps$_reduxForm.getFormState;

    var formState = getFormState(state);
    var initialState = getIn(formState, 'initial.' + name);
    var initial = initialState !== undefined ? initialState : initialValues && getIn(initialValues, name);
    var value = getIn(formState, 'values.' + name);
    var submitting = getIn(formState, 'submitting');
    var syncError = getSyncError(getIn(formState, 'syncErrors'), name);
    var syncWarning = getSyncWarning(getIn(formState, 'syncWarnings'), name);
    var pristine = deepEqual(value, initial);
    return {
      asyncError: getIn(formState, 'asyncErrors.' + name),
      asyncValidating: getIn(formState, 'asyncValidating') === name,
      dirty: !pristine,
      pristine: pristine,
      state: getIn(formState, 'fields.' + name),
      submitError: getIn(formState, 'submitErrors.' + name),
      submitFailed: getIn(formState, 'submitFailed'),
      submitting: submitting,
      syncError: syncError,
      syncWarning: syncWarning,
      initial: initial,
      value: value,
      _value: ownProps.value // save value passed in (for checkboxes)
    };
  }, undefined, undefined, { withRef: true });
  return connector(ConnectedField);
};

/* harmony default export */ __webpack_exports__["a"] = (createConnectedField);

/***/ }),
/* 1138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createProvider */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(535);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_PropTypes__ = __webpack_require__(536);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_warning__ = __webpack_require__(345);





var didWarnAboutReceivingStore = false;

function warnAboutReceivingStore() {
  if (didWarnAboutReceivingStore) {
    return;
  }

  didWarnAboutReceivingStore = true;
  Object(__WEBPACK_IMPORTED_MODULE_4__utils_warning__["a" /* default */])('<Provider> does not support changing `store` on the fly. ' + 'It is most likely that you see this error because you updated to ' + 'Redux 2.x and React Redux 2.x which no longer hot reload reducers ' + 'automatically. See https://github.com/reduxjs/react-redux/releases/' + 'tag/v2.0.0 for the migration instructions.');
}

function createProvider(storeKey) {
  var _Provider$childContex;

  if (storeKey === void 0) {
    storeKey = 'store';
  }

  var subscriptionKey = storeKey + "Subscription";

  var Provider =
  /*#__PURE__*/
  function (_Component) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Provider, _Component);

    var _proto = Provider.prototype;

    _proto.getChildContext = function getChildContext() {
      var _ref;

      return _ref = {}, _ref[storeKey] = this[storeKey], _ref[subscriptionKey] = null, _ref;
    };

    function Provider(props, context) {
      var _this;

      _this = _Component.call(this, props, context) || this;
      _this[storeKey] = props.store;
      return _this;
    }

    _proto.render = function render() {
      return __WEBPACK_IMPORTED_MODULE_1_react__["Children"].only(this.props.children);
    };

    return Provider;
  }(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

  if (false) {
    Provider.prototype.componentWillReceiveProps = function (nextProps) {
      if (this[storeKey] !== nextProps.store) {
        warnAboutReceivingStore();
      }
    };
  }

  Provider.propTypes = {
    store: __WEBPACK_IMPORTED_MODULE_3__utils_PropTypes__["a" /* storeShape */].isRequired,
    children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.element.isRequired
  };
  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[storeKey] = __WEBPACK_IMPORTED_MODULE_3__utils_PropTypes__["a" /* storeShape */].isRequired, _Provider$childContex[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_3__utils_PropTypes__["b" /* subscriptionShape */], _Provider$childContex);
  return Provider;
}
/* harmony default export */ __webpack_exports__["a"] = (createProvider());

/***/ }),
/* 1139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _assertThisInitialized;
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

/***/ }),
/* 1140 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var ReactIs = __webpack_require__(343);
var REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};

var FORWARD_REF_STATICS = {
    '$$typeof': true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};

var TYPE_STATICS = {};
TYPE_STATICS[ReactIs.ForwardRef] = FORWARD_REF_STATICS;

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;

function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components

        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) {
                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
            }
        }

        var keys = getOwnPropertyNames(sourceComponent);

        if (getOwnPropertySymbols) {
            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        }

        var targetStatics = TYPE_STATICS[targetComponent['$$typeof']] || REACT_STATICS;
        var sourceStatics = TYPE_STATICS[sourceComponent['$$typeof']] || REACT_STATICS;

        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }

        return targetComponent;
    }

    return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 1141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Subscription; });
// encapsulates the subscription logic for connecting a component to the redux store, as
// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants
var CLEARED = null;
var nullListeners = {
  notify: function notify() {}
};

function createListenerCollection() {
  // the current/next pattern is copied from redux's createStore code.
  // TODO: refactor+expose that code to be reusable here?
  var current = [];
  var next = [];
  return {
    clear: function clear() {
      next = CLEARED;
      current = CLEARED;
    },
    notify: function notify() {
      var listeners = current = next;

      for (var i = 0; i < listeners.length; i++) {
        listeners[i]();
      }
    },
    get: function get() {
      return next;
    },
    subscribe: function subscribe(listener) {
      var isSubscribed = true;
      if (next === current) next = current.slice();
      next.push(listener);
      return function unsubscribe() {
        if (!isSubscribed || current === CLEARED) return;
        isSubscribed = false;
        if (next === current) next = current.slice();
        next.splice(next.indexOf(listener), 1);
      };
    }
  };
}

var Subscription =
/*#__PURE__*/
function () {
  function Subscription(store, parentSub, onStateChange) {
    this.store = store;
    this.parentSub = parentSub;
    this.onStateChange = onStateChange;
    this.unsubscribe = null;
    this.listeners = nullListeners;
  }

  var _proto = Subscription.prototype;

  _proto.addNestedSub = function addNestedSub(listener) {
    this.trySubscribe();
    return this.listeners.subscribe(listener);
  };

  _proto.notifyNestedSubs = function notifyNestedSubs() {
    this.listeners.notify();
  };

  _proto.isSubscribed = function isSubscribed() {
    return Boolean(this.unsubscribe);
  };

  _proto.trySubscribe = function trySubscribe() {
    if (!this.unsubscribe) {
      this.unsubscribe = this.parentSub ? this.parentSub.addNestedSub(this.onStateChange) : this.store.subscribe(this.onStateChange);
      this.listeners = createListenerCollection();
    }
  };

  _proto.tryUnsubscribe = function tryUnsubscribe() {
    if (this.unsubscribe) {
      this.unsubscribe();
      this.unsubscribe = null;
      this.listeners.clear();
      this.listeners = nullListeners;
    }
  };

  return Subscription;
}();



/***/ }),
/* 1142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createConnect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_connectAdvanced__ = __webpack_require__(537);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__ = __webpack_require__(1143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mapDispatchToProps__ = __webpack_require__(1144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mapStateToProps__ = __webpack_require__(1146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mergeProps__ = __webpack_require__(1147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__selectorFactory__ = __webpack_require__(1148);








/*
  connect is a facade over connectAdvanced. It turns its args into a compatible
  selectorFactory, which has the signature:

    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
  
  connect passes its args to connectAdvanced as options, which will in turn pass them to
  selectorFactory each time a Connect component instance is instantiated or hot reloaded.

  selectorFactory returns a final props selector from its mapStateToProps,
  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
  mergePropsFactories, and pure args.

  The resulting final props selector is called by the Connect component instance whenever
  it receives new props or store state.
 */

function match(arg, factories, name) {
  for (var i = factories.length - 1; i >= 0; i--) {
    var result = factories[i](arg);
    if (result) return result;
  }

  return function (dispatch, options) {
    throw new Error("Invalid value of type " + typeof arg + " for " + name + " argument when connecting component " + options.wrappedComponentName + ".");
  };
}

function strictEqual(a, b) {
  return a === b;
} // createConnect with default args builds the 'official' connect behavior. Calling it with
// different options opens up some testing and extensibility scenarios


function createConnect(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      _ref$connectHOC = _ref.connectHOC,
      connectHOC = _ref$connectHOC === void 0 ? __WEBPACK_IMPORTED_MODULE_2__components_connectAdvanced__["a" /* default */] : _ref$connectHOC,
      _ref$mapStateToPropsF = _ref.mapStateToPropsFactories,
      mapStateToPropsFactories = _ref$mapStateToPropsF === void 0 ? __WEBPACK_IMPORTED_MODULE_5__mapStateToProps__["a" /* default */] : _ref$mapStateToPropsF,
      _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories,
      mapDispatchToPropsFactories = _ref$mapDispatchToPro === void 0 ? __WEBPACK_IMPORTED_MODULE_4__mapDispatchToProps__["a" /* default */] : _ref$mapDispatchToPro,
      _ref$mergePropsFactor = _ref.mergePropsFactories,
      mergePropsFactories = _ref$mergePropsFactor === void 0 ? __WEBPACK_IMPORTED_MODULE_6__mergeProps__["a" /* default */] : _ref$mergePropsFactor,
      _ref$selectorFactory = _ref.selectorFactory,
      selectorFactory = _ref$selectorFactory === void 0 ? __WEBPACK_IMPORTED_MODULE_7__selectorFactory__["a" /* default */] : _ref$selectorFactory;

  return function connect(mapStateToProps, mapDispatchToProps, mergeProps, _ref2) {
    if (_ref2 === void 0) {
      _ref2 = {};
    }

    var _ref3 = _ref2,
        _ref3$pure = _ref3.pure,
        pure = _ref3$pure === void 0 ? true : _ref3$pure,
        _ref3$areStatesEqual = _ref3.areStatesEqual,
        areStatesEqual = _ref3$areStatesEqual === void 0 ? strictEqual : _ref3$areStatesEqual,
        _ref3$areOwnPropsEqua = _ref3.areOwnPropsEqual,
        areOwnPropsEqual = _ref3$areOwnPropsEqua === void 0 ? __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__["a" /* default */] : _ref3$areOwnPropsEqua,
        _ref3$areStatePropsEq = _ref3.areStatePropsEqual,
        areStatePropsEqual = _ref3$areStatePropsEq === void 0 ? __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__["a" /* default */] : _ref3$areStatePropsEq,
        _ref3$areMergedPropsE = _ref3.areMergedPropsEqual,
        areMergedPropsEqual = _ref3$areMergedPropsE === void 0 ? __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__["a" /* default */] : _ref3$areMergedPropsE,
        extraOptions = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref3, ["pure", "areStatesEqual", "areOwnPropsEqual", "areStatePropsEqual", "areMergedPropsEqual"]);

    var initMapStateToProps = match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
    var initMapDispatchToProps = match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
    var initMergeProps = match(mergeProps, mergePropsFactories, 'mergeProps');
    return connectHOC(selectorFactory, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      // used in error messages
      methodName: 'connect',
      // used to compute Connect's displayName from the wrapped component's displayName.
      getDisplayName: function getDisplayName(name) {
        return "Connect(" + name + ")";
      },
      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
      shouldHandleStateChanges: Boolean(mapStateToProps),
      // passed through to selectorFactory
      initMapStateToProps: initMapStateToProps,
      initMapDispatchToProps: initMapDispatchToProps,
      initMergeProps: initMergeProps,
      pure: pure,
      areStatesEqual: areStatesEqual,
      areOwnPropsEqual: areOwnPropsEqual,
      areStatePropsEqual: areStatePropsEqual,
      areMergedPropsEqual: areMergedPropsEqual
    }, extraOptions));
  };
}
/* harmony default export */ __webpack_exports__["a"] = (createConnect());

/***/ }),
/* 1143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = shallowEqual;
var hasOwn = Object.prototype.hasOwnProperty;

function is(x, y) {
  if (x === y) {
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

function shallowEqual(objA, objB) {
  if (is(objA, objB)) return true;

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);
  if (keysA.length !== keysB.length) return false;

  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwn.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

/***/ }),
/* 1144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapDispatchToPropsIsFunction */
/* unused harmony export whenMapDispatchToPropsIsMissing */
/* unused harmony export whenMapDispatchToPropsIsObject */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__ = __webpack_require__(538);


function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
  return typeof mapDispatchToProps === 'function' ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["b" /* wrapMapToPropsFunc */])(mapDispatchToProps, 'mapDispatchToProps') : undefined;
}
function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
  return !mapDispatchToProps ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function (dispatch) {
    return {
      dispatch: dispatch
    };
  }) : undefined;
}
function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
  return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_redux__["b" /* bindActionCreators */])(mapDispatchToProps, dispatch);
  }) : undefined;
}
/* harmony default export */ __webpack_exports__["a"] = ([whenMapDispatchToPropsIsFunction, whenMapDispatchToPropsIsMissing, whenMapDispatchToPropsIsObject]);

/***/ }),
/* 1145 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isPlainObject;
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */
function isPlainObject(obj) {
  if (typeof obj !== 'object' || obj === null) return false;
  var proto = Object.getPrototypeOf(obj);
  if (proto === null) return true;
  var baseProto = proto;

  while (Object.getPrototypeOf(baseProto) !== null) {
    baseProto = Object.getPrototypeOf(baseProto);
  }

  return proto === baseProto;
}

/***/ }),
/* 1146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapStateToPropsIsFunction */
/* unused harmony export whenMapStateToPropsIsMissing */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__ = __webpack_require__(538);

function whenMapStateToPropsIsFunction(mapStateToProps) {
  return typeof mapStateToProps === 'function' ? Object(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["b" /* wrapMapToPropsFunc */])(mapStateToProps, 'mapStateToProps') : undefined;
}
function whenMapStateToPropsIsMissing(mapStateToProps) {
  return !mapStateToProps ? Object(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function () {
    return {};
  }) : undefined;
}
/* harmony default export */ __webpack_exports__["a"] = ([whenMapStateToPropsIsFunction, whenMapStateToPropsIsMissing]);

/***/ }),
/* 1147 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export defaultMergeProps */
/* unused harmony export wrapMergePropsFunc */
/* unused harmony export whenMergePropsIsFunction */
/* unused harmony export whenMergePropsIsOmitted */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_verifyPlainObject__ = __webpack_require__(539);


function defaultMergeProps(stateProps, dispatchProps, ownProps) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, ownProps, stateProps, dispatchProps);
}
function wrapMergePropsFunc(mergeProps) {
  return function initMergePropsProxy(dispatch, _ref) {
    var displayName = _ref.displayName,
        pure = _ref.pure,
        areMergedPropsEqual = _ref.areMergedPropsEqual;
    var hasRunOnce = false;
    var mergedProps;
    return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
      var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);

      if (hasRunOnce) {
        if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
      } else {
        hasRunOnce = true;
        mergedProps = nextMergedProps;
        if (false) verifyPlainObject(mergedProps, displayName, 'mergeProps');
      }

      return mergedProps;
    };
  };
}
function whenMergePropsIsFunction(mergeProps) {
  return typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : undefined;
}
function whenMergePropsIsOmitted(mergeProps) {
  return !mergeProps ? function () {
    return defaultMergeProps;
  } : undefined;
}
/* harmony default export */ __webpack_exports__["a"] = ([whenMergePropsIsFunction, whenMergePropsIsOmitted]);

/***/ }),
/* 1148 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export impureFinalPropsSelectorFactory */
/* unused harmony export pureFinalPropsSelectorFactory */
/* harmony export (immutable) */ __webpack_exports__["a"] = finalPropsSelectorFactory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__verifySubselectors__ = __webpack_require__(1149);


function impureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
  return function impureFinalPropsSelector(state, ownProps) {
    return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
  };
}
function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
  var areStatesEqual = _ref.areStatesEqual,
      areOwnPropsEqual = _ref.areOwnPropsEqual,
      areStatePropsEqual = _ref.areStatePropsEqual;
  var hasRunAtLeastOnce = false;
  var state;
  var ownProps;
  var stateProps;
  var dispatchProps;
  var mergedProps;

  function handleFirstCall(firstState, firstOwnProps) {
    state = firstState;
    ownProps = firstOwnProps;
    stateProps = mapStateToProps(state, ownProps);
    dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    hasRunAtLeastOnce = true;
    return mergedProps;
  }

  function handleNewPropsAndNewState() {
    stateProps = mapStateToProps(state, ownProps);
    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewProps() {
    if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewState() {
    var nextStateProps = mapStateToProps(state, ownProps);
    var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
    stateProps = nextStateProps;
    if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleSubsequentCalls(nextState, nextOwnProps) {
    var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
    var stateChanged = !areStatesEqual(nextState, state);
    state = nextState;
    ownProps = nextOwnProps;
    if (propsChanged && stateChanged) return handleNewPropsAndNewState();
    if (propsChanged) return handleNewProps();
    if (stateChanged) return handleNewState();
    return mergedProps;
  }

  return function pureFinalPropsSelector(nextState, nextOwnProps) {
    return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
  };
} // TODO: Add more comments
// If pure is true, the selector returned by selectorFactory will memoize its results,
// allowing connectAdvanced's shouldComponentUpdate to return false if final
// props have not changed. If false, the selector will always return a new
// object and shouldComponentUpdate will always return true.

function finalPropsSelectorFactory(dispatch, _ref2) {
  var initMapStateToProps = _ref2.initMapStateToProps,
      initMapDispatchToProps = _ref2.initMapDispatchToProps,
      initMergeProps = _ref2.initMergeProps,
      options = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref2, ["initMapStateToProps", "initMapDispatchToProps", "initMergeProps"]);

  var mapStateToProps = initMapStateToProps(dispatch, options);
  var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
  var mergeProps = initMergeProps(dispatch, options);

  if (false) {
    verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, options.displayName);
  }

  var selectorFactory = options.pure ? pureFinalPropsSelectorFactory : impureFinalPropsSelectorFactory;
  return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}

/***/ }),
/* 1149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_warning__ = __webpack_require__(345);


function verify(selector, methodName, displayName) {
  if (!selector) {
    throw new Error("Unexpected value for " + methodName + " in " + displayName + ".");
  } else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
    if (!selector.hasOwnProperty('dependsOnOwnProps')) {
      Object(__WEBPACK_IMPORTED_MODULE_0__utils_warning__["a" /* default */])("The selector for " + methodName + " of " + displayName + " did not specify a value for dependsOnOwnProps.");
    }
  }
}

function verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
  verify(mapStateToProps, 'mapStateToProps', displayName);
  verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
  verify(mergeProps, 'mergeProps', displayName);
}

/***/ }),
/* 1150 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isEvent__ = __webpack_require__(542);



var getSelectedValues = function getSelectedValues(options) {
  var result = [];
  if (options) {
    for (var index = 0; index < options.length; index++) {
      var option = options[index];
      if (option.selected) {
        result.push(option.value);
      }
    }
  }
  return result;
};

var getValue = function getValue(event, isReactNative) {
  if (Object(__WEBPACK_IMPORTED_MODULE_0__isEvent__["a" /* default */])(event)) {
    if (!isReactNative && event.nativeEvent && event.nativeEvent.text !== undefined) {
      return event.nativeEvent.text;
    }
    if (isReactNative && event.nativeEvent !== undefined) {
      return event.nativeEvent.text;
    }
    var detypedEvent = event;
    var _detypedEvent$target = detypedEvent.target,
        type = _detypedEvent$target.type,
        value = _detypedEvent$target.value,
        checked = _detypedEvent$target.checked,
        files = _detypedEvent$target.files,
        dataTransfer = detypedEvent.dataTransfer;

    if (type === 'checkbox') {
      return !!checked;
    }
    if (type === 'file') {
      return files || dataTransfer && dataTransfer.files;
    }
    if (type === 'select-multiple') {
      return getSelectedValues(event.target.options);
    }
    return value;
  }
  return event;
};

/* harmony default export */ __webpack_exports__["a"] = (getValue);

/***/ }),
/* 1151 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return dataKey; });
var dataKey = 'text';

/***/ }),
/* 1152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var splice = function splice(array, index, removeNum, value) {
  array = array || [];

  if (index < array.length) {
    if (value === undefined && !removeNum) {
      // inserting undefined
      var _copy2 = [].concat(_toConsumableArray(array));
      _copy2.splice(index, 0, true); // temporary placeholder
      _copy2[index] = undefined; // set to undefined
      return _copy2;
    }
    if (value != null) {
      var _copy3 = [].concat(_toConsumableArray(array));
      _copy3.splice(index, removeNum, value); // removing and adding
      return _copy3;
    }
    var _copy = [].concat(_toConsumableArray(array));
    _copy.splice(index, removeNum); // removing
    return _copy;
  }
  if (removeNum) {
    // trying to remove non-existant item: return original array
    return array;
  }
  // trying to add outside of range: just set value
  var copy = [].concat(_toConsumableArray(array));
  copy[index] = value;
  return copy;
};

/* harmony default export */ __webpack_exports__["a"] = (splice);

/***/ }),
/* 1153 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_toPath__ = __webpack_require__(231);



var getIn = function getIn(state, field) {
  if (!state) {
    return state;
  }

  var path = Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_toPath__["a" /* default */])(field);
  var length = path.length;
  if (!length) {
    return undefined;
  }

  var result = state;
  for (var i = 0; i < length && result; ++i) {
    result = result[path[i]];
  }

  return result;
};

/* harmony default export */ __webpack_exports__["a"] = (getIn);

/***/ }),
/* 1154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(233);


/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (getRawTag);


/***/ }),
/* 1155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

/* harmony default export */ __webpack_exports__["a"] = (objectToString);


/***/ }),
/* 1156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__memoize_js__ = __webpack_require__(1157);


/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = Object(__WEBPACK_IMPORTED_MODULE_0__memoize_js__["a" /* default */])(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (memoizeCapped);


/***/ }),
/* 1157 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MapCache_js__ = __webpack_require__(348);


/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || __WEBPACK_IMPORTED_MODULE_0__MapCache_js__["a" /* default */]);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = __WEBPACK_IMPORTED_MODULE_0__MapCache_js__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (memoize);


/***/ }),
/* 1158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Hash_js__ = __webpack_require__(1159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ListCache_js__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Map_js__ = __webpack_require__(350);




/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new __WEBPACK_IMPORTED_MODULE_0__Hash_js__["a" /* default */],
    'map': new (__WEBPACK_IMPORTED_MODULE_2__Map_js__["a" /* default */] || __WEBPACK_IMPORTED_MODULE_1__ListCache_js__["a" /* default */]),
    'string': new __WEBPACK_IMPORTED_MODULE_0__Hash_js__["a" /* default */]
  };
}

/* harmony default export */ __webpack_exports__["a"] = (mapCacheClear);


/***/ }),
/* 1159 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__hashClear_js__ = __webpack_require__(1160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__hashDelete_js__ = __webpack_require__(1165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__hashGet_js__ = __webpack_require__(1166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__hashHas_js__ = __webpack_require__(1167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__hashSet_js__ = __webpack_require__(1168);






/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = __WEBPACK_IMPORTED_MODULE_0__hashClear_js__["a" /* default */];
Hash.prototype['delete'] = __WEBPACK_IMPORTED_MODULE_1__hashDelete_js__["a" /* default */];
Hash.prototype.get = __WEBPACK_IMPORTED_MODULE_2__hashGet_js__["a" /* default */];
Hash.prototype.has = __WEBPACK_IMPORTED_MODULE_3__hashHas_js__["a" /* default */];
Hash.prototype.set = __WEBPACK_IMPORTED_MODULE_4__hashSet_js__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (Hash);


/***/ }),
/* 1160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nativeCreate_js__ = __webpack_require__(234);


/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = __WEBPACK_IMPORTED_MODULE_0__nativeCreate_js__["a" /* default */] ? Object(__WEBPACK_IMPORTED_MODULE_0__nativeCreate_js__["a" /* default */])(null) : {};
  this.size = 0;
}

/* harmony default export */ __webpack_exports__["a"] = (hashClear);


/***/ }),
/* 1161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isFunction_js__ = __webpack_require__(349);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isMasked_js__ = __webpack_require__(1162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isObject_js__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__toSource_js__ = __webpack_require__(548);





/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_2__isObject_js__["a" /* default */])(value) || Object(__WEBPACK_IMPORTED_MODULE_1__isMasked_js__["a" /* default */])(value)) {
    return false;
  }
  var pattern = Object(__WEBPACK_IMPORTED_MODULE_0__isFunction_js__["a" /* default */])(value) ? reIsNative : reIsHostCtor;
  return pattern.test(Object(__WEBPACK_IMPORTED_MODULE_3__toSource_js__["a" /* default */])(value));
}

/* harmony default export */ __webpack_exports__["a"] = (baseIsNative);


/***/ }),
/* 1162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__coreJsData_js__ = __webpack_require__(1163);


/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(__WEBPACK_IMPORTED_MODULE_0__coreJsData_js__["a" /* default */] && __WEBPACK_IMPORTED_MODULE_0__coreJsData_js__["a" /* default */].keys && __WEBPACK_IMPORTED_MODULE_0__coreJsData_js__["a" /* default */].keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/* harmony default export */ __webpack_exports__["a"] = (isMasked);


/***/ }),
/* 1163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_js__ = __webpack_require__(75);


/** Used to detect overreaching core-js shims. */
var coreJsData = __WEBPACK_IMPORTED_MODULE_0__root_js__["a" /* default */]['__core-js_shared__'];

/* harmony default export */ __webpack_exports__["a"] = (coreJsData);


/***/ }),
/* 1164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/* harmony default export */ __webpack_exports__["a"] = (getValue);


/***/ }),
/* 1165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (hashDelete);


/***/ }),
/* 1166 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nativeCreate_js__ = __webpack_require__(234);


/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (__WEBPACK_IMPORTED_MODULE_0__nativeCreate_js__["a" /* default */]) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = (hashGet);


/***/ }),
/* 1167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nativeCreate_js__ = __webpack_require__(234);


/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return __WEBPACK_IMPORTED_MODULE_0__nativeCreate_js__["a" /* default */] ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

/* harmony default export */ __webpack_exports__["a"] = (hashHas);


/***/ }),
/* 1168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nativeCreate_js__ = __webpack_require__(234);


/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (__WEBPACK_IMPORTED_MODULE_0__nativeCreate_js__["a" /* default */] && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

/* harmony default export */ __webpack_exports__["a"] = (hashSet);


/***/ }),
/* 1169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

/* harmony default export */ __webpack_exports__["a"] = (listCacheClear);


/***/ }),
/* 1170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assocIndexOf_js__ = __webpack_require__(236);


/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = Object(__WEBPACK_IMPORTED_MODULE_0__assocIndexOf_js__["a" /* default */])(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

/* harmony default export */ __webpack_exports__["a"] = (listCacheDelete);


/***/ }),
/* 1171 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assocIndexOf_js__ = __webpack_require__(236);


/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = Object(__WEBPACK_IMPORTED_MODULE_0__assocIndexOf_js__["a" /* default */])(data, key);

  return index < 0 ? undefined : data[index][1];
}

/* harmony default export */ __webpack_exports__["a"] = (listCacheGet);


/***/ }),
/* 1172 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assocIndexOf_js__ = __webpack_require__(236);


/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__assocIndexOf_js__["a" /* default */])(this.__data__, key) > -1;
}

/* harmony default export */ __webpack_exports__["a"] = (listCacheHas);


/***/ }),
/* 1173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assocIndexOf_js__ = __webpack_require__(236);


/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = Object(__WEBPACK_IMPORTED_MODULE_0__assocIndexOf_js__["a" /* default */])(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

/* harmony default export */ __webpack_exports__["a"] = (listCacheSet);


/***/ }),
/* 1174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getMapData_js__ = __webpack_require__(237);


/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = Object(__WEBPACK_IMPORTED_MODULE_0__getMapData_js__["a" /* default */])(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (mapCacheDelete);


/***/ }),
/* 1175 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/* harmony default export */ __webpack_exports__["a"] = (isKeyable);


/***/ }),
/* 1176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getMapData_js__ = __webpack_require__(237);


/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__getMapData_js__["a" /* default */])(this, key).get(key);
}

/* harmony default export */ __webpack_exports__["a"] = (mapCacheGet);


/***/ }),
/* 1177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getMapData_js__ = __webpack_require__(237);


/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__getMapData_js__["a" /* default */])(this, key).has(key);
}

/* harmony default export */ __webpack_exports__["a"] = (mapCacheHas);


/***/ }),
/* 1178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getMapData_js__ = __webpack_require__(237);


/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = Object(__WEBPACK_IMPORTED_MODULE_0__getMapData_js__["a" /* default */])(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

/* harmony default export */ __webpack_exports__["a"] = (mapCacheSet);


/***/ }),
/* 1179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__arrayMap_js__ = __webpack_require__(544);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isArray_js__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isSymbol_js__ = __webpack_require__(232);





/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (Object(__WEBPACK_IMPORTED_MODULE_2__isArray_js__["a" /* default */])(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return Object(__WEBPACK_IMPORTED_MODULE_1__arrayMap_js__["a" /* default */])(value, baseToString) + '';
  }
  if (Object(__WEBPACK_IMPORTED_MODULE_3__isSymbol_js__["a" /* default */])(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/* harmony default export */ __webpack_exports__["a"] = (baseToString);


/***/ }),
/* 1180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_toPath__ = __webpack_require__(231);


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var setInWithPath = function setInWithPath(state, value, path, pathIndex) {
  if (pathIndex >= path.length) {
    return value;
  }

  var first = path[pathIndex];
  var firstState = state && (Array.isArray(state) ? state[Number(first)] : state[first]);
  var next = setInWithPath(firstState, value, path, pathIndex + 1);

  if (!state) {
    if (isNaN(first)) {
      return _defineProperty({}, first, next);
    }
    var initialized = [];
    initialized[parseInt(first, 10)] = next;
    return initialized;
  }

  if (Array.isArray(state)) {
    var copy = [].concat(state);
    copy[parseInt(first, 10)] = next;
    return copy;
  }

  return _extends({}, state, _defineProperty({}, first, next));
};

var setIn = function setIn(state, field, value) {
  return setInWithPath(state, value, Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_toPath__["a" /* default */])(field), 0);
};

/* harmony default export */ __webpack_exports__["a"] = (setIn);

/***/ }),
/* 1181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_isEqualWith__ = __webpack_require__(550);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);




var customizer = function customizer(obj, other) {
  if (obj === other) return true;

  if (!obj && !other) {
    var objIsEmpty = obj === null || obj === undefined || obj === '';
    var otherIsEmpty = other === null || other === undefined || other === '';
    return objIsEmpty === otherIsEmpty;
  }

  if (obj && other && obj._error !== other._error) return false;
  if (obj && other && obj._warning !== other._warning) return false;
  if (__WEBPACK_IMPORTED_MODULE_1_react___default.a.isValidElement(obj) || __WEBPACK_IMPORTED_MODULE_1_react___default.a.isValidElement(other)) return false;
};

var deepEqual = function deepEqual(a, b) {
  return Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_isEqualWith__["a" /* default */])(a, b, customizer);
};

/* harmony default export */ __webpack_exports__["a"] = (deepEqual);

/***/ }),
/* 1182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Stack_js__ = __webpack_require__(351);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__equalArrays_js__ = __webpack_require__(551);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__equalByTag_js__ = __webpack_require__(1193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__equalObjects_js__ = __webpack_require__(1196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__getTag_js__ = __webpack_require__(556);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__isArray_js__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__isBuffer_js__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__isTypedArray_js__ = __webpack_require__(241);









/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = Object(__WEBPACK_IMPORTED_MODULE_5__isArray_js__["a" /* default */])(object),
      othIsArr = Object(__WEBPACK_IMPORTED_MODULE_5__isArray_js__["a" /* default */])(other),
      objTag = objIsArr ? arrayTag : Object(__WEBPACK_IMPORTED_MODULE_4__getTag_js__["a" /* default */])(object),
      othTag = othIsArr ? arrayTag : Object(__WEBPACK_IMPORTED_MODULE_4__getTag_js__["a" /* default */])(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && Object(__WEBPACK_IMPORTED_MODULE_6__isBuffer_js__["a" /* default */])(object)) {
    if (!Object(__WEBPACK_IMPORTED_MODULE_6__isBuffer_js__["a" /* default */])(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new __WEBPACK_IMPORTED_MODULE_0__Stack_js__["a" /* default */]);
    return (objIsArr || Object(__WEBPACK_IMPORTED_MODULE_7__isTypedArray_js__["a" /* default */])(object))
      ? Object(__WEBPACK_IMPORTED_MODULE_1__equalArrays_js__["a" /* default */])(object, other, bitmask, customizer, equalFunc, stack)
      : Object(__WEBPACK_IMPORTED_MODULE_2__equalByTag_js__["a" /* default */])(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new __WEBPACK_IMPORTED_MODULE_0__Stack_js__["a" /* default */]);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new __WEBPACK_IMPORTED_MODULE_0__Stack_js__["a" /* default */]);
  return Object(__WEBPACK_IMPORTED_MODULE_3__equalObjects_js__["a" /* default */])(object, other, bitmask, customizer, equalFunc, stack);
}

/* harmony default export */ __webpack_exports__["a"] = (baseIsEqualDeep);


/***/ }),
/* 1183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ListCache_js__ = __webpack_require__(235);


/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new __WEBPACK_IMPORTED_MODULE_0__ListCache_js__["a" /* default */];
  this.size = 0;
}

/* harmony default export */ __webpack_exports__["a"] = (stackClear);


/***/ }),
/* 1184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (stackDelete);


/***/ }),
/* 1185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

/* harmony default export */ __webpack_exports__["a"] = (stackGet);


/***/ }),
/* 1186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

/* harmony default export */ __webpack_exports__["a"] = (stackHas);


/***/ }),
/* 1187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ListCache_js__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Map_js__ = __webpack_require__(350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MapCache_js__ = __webpack_require__(348);




/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof __WEBPACK_IMPORTED_MODULE_0__ListCache_js__["a" /* default */]) {
    var pairs = data.__data__;
    if (!__WEBPACK_IMPORTED_MODULE_1__Map_js__["a" /* default */] || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new __WEBPACK_IMPORTED_MODULE_2__MapCache_js__["a" /* default */](pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

/* harmony default export */ __webpack_exports__["a"] = (stackSet);


/***/ }),
/* 1188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MapCache_js__ = __webpack_require__(348);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__setCacheAdd_js__ = __webpack_require__(1189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__setCacheHas_js__ = __webpack_require__(1190);




/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new __WEBPACK_IMPORTED_MODULE_0__MapCache_js__["a" /* default */];
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = __WEBPACK_IMPORTED_MODULE_1__setCacheAdd_js__["a" /* default */];
SetCache.prototype.has = __WEBPACK_IMPORTED_MODULE_2__setCacheHas_js__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (SetCache);


/***/ }),
/* 1189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

/* harmony default export */ __webpack_exports__["a"] = (setCacheAdd);


/***/ }),
/* 1190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

/* harmony default export */ __webpack_exports__["a"] = (setCacheHas);


/***/ }),
/* 1191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

/* harmony default export */ __webpack_exports__["a"] = (arraySome);


/***/ }),
/* 1192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

/* harmony default export */ __webpack_exports__["a"] = (cacheHas);


/***/ }),
/* 1193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Uint8Array_js__ = __webpack_require__(552);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__eq_js__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__equalArrays_js__ = __webpack_require__(551);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mapToArray_js__ = __webpack_require__(1194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__setToArray_js__ = __webpack_require__(1195);







/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new __WEBPACK_IMPORTED_MODULE_1__Uint8Array_js__["a" /* default */](object), new __WEBPACK_IMPORTED_MODULE_1__Uint8Array_js__["a" /* default */](other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return Object(__WEBPACK_IMPORTED_MODULE_2__eq_js__["a" /* default */])(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = __WEBPACK_IMPORTED_MODULE_4__mapToArray_js__["a" /* default */];

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = __WEBPACK_IMPORTED_MODULE_5__setToArray_js__["a" /* default */]);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = Object(__WEBPACK_IMPORTED_MODULE_3__equalArrays_js__["a" /* default */])(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

/* harmony default export */ __webpack_exports__["a"] = (equalByTag);


/***/ }),
/* 1194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (mapToArray);


/***/ }),
/* 1195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (setToArray);


/***/ }),
/* 1196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getAllKeys_js__ = __webpack_require__(1197);


/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = Object(__WEBPACK_IMPORTED_MODULE_0__getAllKeys_js__["a" /* default */])(object),
      objLength = objProps.length,
      othProps = Object(__WEBPACK_IMPORTED_MODULE_0__getAllKeys_js__["a" /* default */])(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(object);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (equalObjects);


/***/ }),
/* 1197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetAllKeys_js__ = __webpack_require__(1198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getSymbols_js__ = __webpack_require__(1200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__keys_js__ = __webpack_require__(352);




/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__baseGetAllKeys_js__["a" /* default */])(object, __WEBPACK_IMPORTED_MODULE_2__keys_js__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__getSymbols_js__["a" /* default */]);
}

/* harmony default export */ __webpack_exports__["a"] = (getAllKeys);


/***/ }),
/* 1198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayPush_js__ = __webpack_require__(1199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isArray_js__ = __webpack_require__(66);



/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return Object(__WEBPACK_IMPORTED_MODULE_1__isArray_js__["a" /* default */])(object) ? result : Object(__WEBPACK_IMPORTED_MODULE_0__arrayPush_js__["a" /* default */])(result, symbolsFunc(object));
}

/* harmony default export */ __webpack_exports__["a"] = (baseGetAllKeys);


/***/ }),
/* 1199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

/* harmony default export */ __webpack_exports__["a"] = (arrayPush);


/***/ }),
/* 1200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayFilter_js__ = __webpack_require__(1201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__stubArray_js__ = __webpack_require__(1202);



/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? __WEBPACK_IMPORTED_MODULE_1__stubArray_js__["a" /* default */] : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return Object(__WEBPACK_IMPORTED_MODULE_0__arrayFilter_js__["a" /* default */])(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

/* harmony default export */ __webpack_exports__["a"] = (getSymbols);


/***/ }),
/* 1201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (arrayFilter);


/***/ }),
/* 1202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

/* harmony default export */ __webpack_exports__["a"] = (stubArray);


/***/ }),
/* 1203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (baseTimes);


/***/ }),
/* 1204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__ = __webpack_require__(110);



/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__["a" /* default */])(value) && Object(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value) == argsTag;
}

/* harmony default export */ __webpack_exports__["a"] = (baseIsArguments);


/***/ }),
/* 1205 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

/* harmony default export */ __webpack_exports__["a"] = (stubFalse);


/***/ }),
/* 1206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isLength_js__ = __webpack_require__(354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__ = __webpack_require__(110);




/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return Object(__WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__["a" /* default */])(value) &&
    Object(__WEBPACK_IMPORTED_MODULE_1__isLength_js__["a" /* default */])(value.length) && !!typedArrayTags[Object(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value)];
}

/* harmony default export */ __webpack_exports__["a"] = (baseIsTypedArray);


/***/ }),
/* 1207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

/* harmony default export */ __webpack_exports__["a"] = (baseUnary);


/***/ }),
/* 1208 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__ = __webpack_require__(546);


/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__["a" /* default */].process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

/* harmony default export */ __webpack_exports__["a"] = (nodeUtil);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(164)(module)))

/***/ }),
/* 1209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__overArg_js__ = __webpack_require__(555);


/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = Object(__WEBPACK_IMPORTED_MODULE_0__overArg_js__["a" /* default */])(Object.keys, Object);

/* harmony default export */ __webpack_exports__["a"] = (nativeKeys);


/***/ }),
/* 1210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getNative_js__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__root_js__ = __webpack_require__(75);



/* Built-in method references that are verified to be native. */
var DataView = Object(__WEBPACK_IMPORTED_MODULE_0__getNative_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__root_js__["a" /* default */], 'DataView');

/* harmony default export */ __webpack_exports__["a"] = (DataView);


/***/ }),
/* 1211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getNative_js__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__root_js__ = __webpack_require__(75);



/* Built-in method references that are verified to be native. */
var Promise = Object(__WEBPACK_IMPORTED_MODULE_0__getNative_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__root_js__["a" /* default */], 'Promise');

/* harmony default export */ __webpack_exports__["a"] = (Promise);


/***/ }),
/* 1212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getNative_js__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__root_js__ = __webpack_require__(75);



/* Built-in method references that are verified to be native. */
var Set = Object(__WEBPACK_IMPORTED_MODULE_0__getNative_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__root_js__["a" /* default */], 'Set');

/* harmony default export */ __webpack_exports__["a"] = (Set);


/***/ }),
/* 1213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getNative_js__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__root_js__ = __webpack_require__(75);



/* Built-in method references that are verified to be native. */
var WeakMap = Object(__WEBPACK_IMPORTED_MODULE_0__getNative_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__root_js__["a" /* default */], 'WeakMap');

/* harmony default export */ __webpack_exports__["a"] = (WeakMap);


/***/ }),
/* 1214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_toPath__ = __webpack_require__(231);


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function deleteInWithPath(state, first) {
  if (state === undefined || state === null || first === undefined || first === null) {
    return state;
  }

  for (var _len = arguments.length, rest = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    rest[_key - 2] = arguments[_key];
  }

  if (rest.length) {
    if (Array.isArray(state)) {
      if (isNaN(first)) {
        throw new Error('Must access array elements with a number, not "' + String(first) + '".');
      }
      var firstIndex = Number(first);
      if (firstIndex < state.length) {
        var result = deleteInWithPath.apply(undefined, [state && state[firstIndex]].concat(_toConsumableArray(rest)));
        if (result !== state[firstIndex]) {
          var copy = [].concat(_toConsumableArray(state));
          copy[firstIndex] = result;
          return copy;
        }
      }
      return state;
    }
    if (first in state) {
      var _result = deleteInWithPath.apply(undefined, [state && state[first]].concat(_toConsumableArray(rest)));
      return state[first] === _result ? state : _extends({}, state, _defineProperty({}, first, _result));
    }
    return state;
  }
  if (Array.isArray(state)) {
    if (isNaN(first)) {
      throw new Error('Cannot delete non-numerical index from an array. Given: "' + String(first));
    }
    var _firstIndex = Number(first);
    if (_firstIndex < state.length) {
      var _copy = [].concat(_toConsumableArray(state));
      _copy.splice(_firstIndex, 1);
      return _copy;
    }
    return state;
  }
  if (first in state) {
    var _copy2 = _extends({}, state);
    delete _copy2[first];
    return _copy2;
  }
  return state;
}

var deleteIn = function deleteIn(state, field) {
  return deleteInWithPath.apply(undefined, [state].concat(_toConsumableArray(Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_toPath__["a" /* default */])(field))));
};

/* harmony default export */ __webpack_exports__["a"] = (deleteIn);

/***/ }),
/* 1215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


function keys(value) {
  if (!value) {
    return [];
  }

  if (Array.isArray(value)) {
    return value.map(function (i) {
      return i.name;
    });
  }

  return Object.keys(value);
}


/* harmony default export */ __webpack_exports__["a"] = (keys);

/***/ }),
/* 1216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createFields__ = __webpack_require__(1217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(28);



/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0__createFields__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 1217 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_lifecycles_compat__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ConnectedFields__ = __webpack_require__(1218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_shallowCompare__ = __webpack_require__(557);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__structure_plain__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_prefixName__ = __webpack_require__(176);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var validateNameProp = function validateNameProp(prop) {
  if (!prop) {
    return new Error('No "names" prop was specified <Fields/>');
  }
  if (!Array.isArray(prop) && !prop._isFieldArray) {
    return new Error('Invalid prop "names" supplied to <Fields/>. Must be either an array of strings or the fields array generated by FieldArray.');
  }
};

var createFields = function createFields(structure) {
  var ConnectedFields = Object(__WEBPACK_IMPORTED_MODULE_4__ConnectedFields__["a" /* default */])(structure);

  var Fields = function (_Component) {
    _inherits(Fields, _Component);

    function Fields(props, context) {
      _classCallCheck(this, Fields);

      var _this = _possibleConstructorReturn(this, (Fields.__proto__ || Object.getPrototypeOf(Fields)).call(this, props, context));

      if (!context._reduxForm) {
        throw new Error('Fields must be inside a component decorated with reduxForm()');
      }
      var error = validateNameProp(props.names);
      if (error) {
        throw error;
      }
      return _this;
    }

    _createClass(Fields, [{
      key: 'shouldComponentUpdate',
      value: function shouldComponentUpdate(nextProps) {
        return Object(__WEBPACK_IMPORTED_MODULE_5__util_shallowCompare__["a" /* default */])(this, nextProps);
      }
    }, {
      key: 'componentDidMount',
      value: function componentDidMount() {
        var context = this.context;
        var register = context._reduxForm.register;

        this.names.forEach(function (name) {
          return register(name, 'Field');
        });
      }
    }, {
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(nextProps) {
        if (!__WEBPACK_IMPORTED_MODULE_6__structure_plain__["a" /* default */].deepEqual(this.props.names, nextProps.names)) {
          var context = this.context;
          var _context$_reduxForm = context._reduxForm,
              register = _context$_reduxForm.register,
              unregister = _context$_reduxForm.unregister;
          // unregister old name

          this.props.names.forEach(function (name) {
            return unregister(Object(__WEBPACK_IMPORTED_MODULE_7__util_prefixName__["a" /* default */])(context, name));
          });
          // register new name
          nextProps.names.forEach(function (name) {
            return register(Object(__WEBPACK_IMPORTED_MODULE_7__util_prefixName__["a" /* default */])(context, name), 'Field');
          });
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        var context = this.context;
        var unregister = context._reduxForm.unregister;

        this.props.names.forEach(function (name) {
          return unregister(Object(__WEBPACK_IMPORTED_MODULE_7__util_prefixName__["a" /* default */])(context, name));
        });
      }
    }, {
      key: 'getRenderedComponent',
      value: function getRenderedComponent() {
        __WEBPACK_IMPORTED_MODULE_3_invariant___default()(this.props.withRef, 'If you want to access getRenderedComponent(), ' + 'you must specify a withRef prop to Fields');
        return this.refs.connected.getWrappedInstance().getRenderedComponent();
      }
    }, {
      key: 'render',
      value: function render() {
        var context = this.context;

        return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(ConnectedFields, _extends({}, this.props, {
          names: this.props.names.map(function (name) {
            return Object(__WEBPACK_IMPORTED_MODULE_7__util_prefixName__["a" /* default */])(context, name);
          }),
          _reduxForm: this.context._reduxForm,
          ref: 'connected'
        }));
      }
    }, {
      key: 'names',
      get: function get() {
        var context = this.context;

        return this.props.names.map(function (name) {
          return Object(__WEBPACK_IMPORTED_MODULE_7__util_prefixName__["a" /* default */])(context, name);
        });
      }
    }, {
      key: 'dirty',
      get: function get() {
        return this.refs.connected.getWrappedInstance().isDirty();
      }
    }, {
      key: 'pristine',
      get: function get() {
        return !this.dirty;
      }
    }, {
      key: 'values',
      get: function get() {
        return this.refs.connected && this.refs.connected.getWrappedInstance().getValues();
      }
    }]);

    return Fields;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

  Fields.propTypes = {
    names: function names(props, propName) {
      return validateNameProp(props[propName]);
    },
    component: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node]).isRequired,
    format: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
    parse: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
    props: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,
    withRef: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool
  };
  Fields.contextTypes = {
    _reduxForm: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object
  };

  Object(__WEBPACK_IMPORTED_MODULE_1_react_lifecycles_compat__["polyfill"])(Fields);
  return Fields;
};

/* harmony default export */ __webpack_exports__["a"] = (createFields);

/***/ }),
/* 1218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__createFieldProps__ = __webpack_require__(540);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__structure_plain__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__events_onChangeValue__ = __webpack_require__(541);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var propsToNotUpdateFor = ['_reduxForm'];

var createConnectedFields = function createConnectedFields(structure) {
  var deepEqual = structure.deepEqual,
      getIn = structure.getIn,
      size = structure.size;


  var getSyncError = function getSyncError(syncErrors, name) {
    // Because the error for this field might not be at a level in the error structure where
    // it can be set directly, it might need to be unwrapped from the _error property
    return __WEBPACK_IMPORTED_MODULE_4__structure_plain__["a" /* default */].getIn(syncErrors, name + '._error') || __WEBPACK_IMPORTED_MODULE_4__structure_plain__["a" /* default */].getIn(syncErrors, name);
  };

  var getSyncWarning = function getSyncWarning(syncWarnings, name) {
    var warning = getIn(syncWarnings, name);
    // Because the warning for this field might not be at a level in the warning structure where
    // it can be set directly, it might need to be unwrapped from the _warning property
    return warning && warning._warning ? warning._warning : warning;
  };

  var ConnectedFields = function (_React$Component) {
    _inherits(ConnectedFields, _React$Component);

    function ConnectedFields(props) {
      _classCallCheck(this, ConnectedFields);

      var _this = _possibleConstructorReturn(this, (ConnectedFields.__proto__ || Object.getPrototypeOf(ConnectedFields)).call(this, props));

      _this.onChangeFns = {};
      _this.onFocusFns = {};
      _this.onBlurFns = {};

      _this.prepareEventHandlers = function (_ref) {
        var names = _ref.names;
        return names.forEach(function (name) {
          _this.onChangeFns[name] = function (event) {
            return _this.handleChange(name, event);
          };
          _this.onFocusFns[name] = function () {
            return _this.handleFocus(name);
          };
          _this.onBlurFns[name] = function (event) {
            return _this.handleBlur(name, event);
          };
        });
      };

      _this.handleChange = function (name, event) {
        var _this$props = _this.props,
            dispatch = _this$props.dispatch,
            parse = _this$props.parse,
            _reduxForm = _this$props._reduxForm;

        var value = Object(__WEBPACK_IMPORTED_MODULE_5__events_onChangeValue__["a" /* default */])(event, { name: name, parse: parse });

        dispatch(_reduxForm.change(name, value));

        // call post-change callback
        if (_reduxForm.asyncValidate) {
          _reduxForm.asyncValidate(name, value, 'change');
        }
      };

      _this.handleFocus = function (name) {
        var _this$props2 = _this.props,
            dispatch = _this$props2.dispatch,
            _reduxForm = _this$props2._reduxForm;

        dispatch(_reduxForm.focus(name));
      };

      _this.handleBlur = function (name, event) {
        var _this$props3 = _this.props,
            dispatch = _this$props3.dispatch,
            parse = _this$props3.parse,
            _reduxForm = _this$props3._reduxForm;

        var value = Object(__WEBPACK_IMPORTED_MODULE_5__events_onChangeValue__["a" /* default */])(event, { name: name, parse: parse });

        // dispatch blur action
        dispatch(_reduxForm.blur(name, value));

        // call post-blur callback
        if (_reduxForm.asyncValidate) {
          _reduxForm.asyncValidate(name, value, 'blur');
        }
      };

      _this.saveRef = function (ref) {
        _this.ref = ref;
      };

      _this.prepareEventHandlers(props);
      return _this;
    }

    _createClass(ConnectedFields, [{
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(nextProps) {
        var _this2 = this;

        if (this.props.names !== nextProps.names && (size(this.props.names) !== size(nextProps.names) || nextProps.names.some(function (nextName) {
          return !_this2.props._fields[nextName];
        }))) {
          // names has changed. The cached event handlers need to be updated
          this.prepareEventHandlers(nextProps);
        }
      }
    }, {
      key: 'shouldComponentUpdate',
      value: function shouldComponentUpdate(nextProps) {
        var _this3 = this;

        var nextPropsKeys = Object.keys(nextProps);
        var thisPropsKeys = Object.keys(this.props);
        // if we have children, we MUST update in React 16
        // https://twitter.com/erikras/status/915866544558788608
        return !!(this.props.children || nextProps.children || nextPropsKeys.length !== thisPropsKeys.length || nextPropsKeys.some(function (prop) {
          return !~propsToNotUpdateFor.indexOf(prop) && !deepEqual(_this3.props[prop], nextProps[prop]);
        }));
      }
    }, {
      key: 'isDirty',
      value: function isDirty() {
        var _fields = this.props._fields;

        return Object.keys(_fields).some(function (name) {
          return _fields[name].dirty;
        });
      }
    }, {
      key: 'getValues',
      value: function getValues() {
        var _fields = this.props._fields;

        return Object.keys(_fields).reduce(function (accumulator, name) {
          return __WEBPACK_IMPORTED_MODULE_4__structure_plain__["a" /* default */].setIn(accumulator, name, _fields[name].value);
        }, {});
      }
    }, {
      key: 'getRenderedComponent',
      value: function getRenderedComponent() {
        return this.ref;
      }
    }, {
      key: 'render',
      value: function render() {
        var _this4 = this;

        var _props = this.props,
            component = _props.component,
            withRef = _props.withRef,
            _fields = _props._fields,
            _reduxForm = _props._reduxForm,
            rest = _objectWithoutProperties(_props, ['component', 'withRef', '_fields', '_reduxForm']);

        var sectionPrefix = _reduxForm.sectionPrefix,
            form = _reduxForm.form;

        var _Object$keys$reduce = Object.keys(_fields).reduce(function (accumulator, name) {
          var connectedProps = _fields[name];

          var _createFieldProps = Object(__WEBPACK_IMPORTED_MODULE_3__createFieldProps__["a" /* default */])(structure, name, _extends({}, connectedProps, rest, {
            form: form,
            onBlur: _this4.onBlurFns[name],
            onChange: _this4.onChangeFns[name],
            onFocus: _this4.onFocusFns[name]
          })),
              custom = _createFieldProps.custom,
              fieldProps = _objectWithoutProperties(_createFieldProps, ['custom']);

          accumulator.custom = custom;
          var fieldName = sectionPrefix ? name.replace(sectionPrefix + '.', '') : name;
          return __WEBPACK_IMPORTED_MODULE_4__structure_plain__["a" /* default */].setIn(accumulator, fieldName, fieldProps);
        }, {}),
            custom = _Object$keys$reduce.custom,
            props = _objectWithoutProperties(_Object$keys$reduce, ['custom']);

        if (withRef) {
          props.ref = this.saveRef;
        }

        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](component, _extends({}, props, custom));
      }
    }]);

    return ConnectedFields;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

  ConnectedFields.propTypes = {
    component: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node]).isRequired,
    _fields: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
    props: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
  };

  var connector = Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(function (state, ownProps) {
    var names = ownProps.names,
        _ownProps$_reduxForm = ownProps._reduxForm,
        initialValues = _ownProps$_reduxForm.initialValues,
        getFormState = _ownProps$_reduxForm.getFormState;

    var formState = getFormState(state);
    return {
      _fields: names.reduce(function (accumulator, name) {
        var initialState = getIn(formState, 'initial.' + name);
        var initial = initialState !== undefined ? initialState : initialValues && getIn(initialValues, name);
        var value = getIn(formState, 'values.' + name);
        var syncError = getSyncError(getIn(formState, 'syncErrors'), name);
        var syncWarning = getSyncWarning(getIn(formState, 'syncWarnings'), name);
        var submitting = getIn(formState, 'submitting');
        var pristine = value === initial;
        accumulator[name] = {
          asyncError: getIn(formState, 'asyncErrors.' + name),
          asyncValidating: getIn(formState, 'asyncValidating') === name,
          dirty: !pristine,
          initial: initial,
          pristine: pristine,
          state: getIn(formState, 'fields.' + name),
          submitError: getIn(formState, 'submitErrors.' + name),
          submitFailed: getIn(formState, 'submitFailed'),
          submitting: submitting,
          syncError: syncError,
          syncWarning: syncWarning,
          value: value,
          _value: ownProps.value // save value passed in (for checkboxes)
        };
        return accumulator;
      }, {})
    };
  }, undefined, undefined, { withRef: true });
  return connector(ConnectedFields);
};

/* harmony default export */ __webpack_exports__["a"] = (createConnectedFields);

/***/ }),
/* 1219 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createFieldArray__ = __webpack_require__(1220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(28);



/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0__createFieldArray__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 1220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_lifecycles_compat__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ConnectedFieldArray__ = __webpack_require__(1221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_prefixName__ = __webpack_require__(176);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }









var toArray = function toArray(value) {
  return Array.isArray(value) ? value : [value];
};

var wrapError = function wrapError(fn, key) {
  return fn && function () {
    var validators = toArray(fn);
    for (var i = 0; i < validators.length; i++) {
      var result = validators[i].apply(validators, arguments);
      if (result) {
        return _defineProperty({}, key, result);
      }
    }
  };
};

var createFieldArray = function createFieldArray(structure) {
  var ConnectedFieldArray = Object(__WEBPACK_IMPORTED_MODULE_4__ConnectedFieldArray__["a" /* default */])(structure);

  var FieldArray = function (_Component) {
    _inherits(FieldArray, _Component);

    function FieldArray(props, context) {
      _classCallCheck(this, FieldArray);

      var _this = _possibleConstructorReturn(this, (FieldArray.__proto__ || Object.getPrototypeOf(FieldArray)).call(this, props, context));

      _this.saveRef = function (ref) {
        _this.ref = ref;
      };

      if (!context._reduxForm) {
        throw new Error('FieldArray must be inside a component decorated with reduxForm()');
      }
      return _this;
    }

    _createClass(FieldArray, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        var _this2 = this;

        this.context._reduxForm.register(this.name, 'FieldArray', function () {
          return wrapError(_this2.props.validate, '_error');
        }, function () {
          return wrapError(_this2.props.warn, '_warning');
        });
      }
    }, {
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(nextProps, nextContext) {
        var oldName = Object(__WEBPACK_IMPORTED_MODULE_5__util_prefixName__["a" /* default */])(this.context, this.props.name);
        var newName = Object(__WEBPACK_IMPORTED_MODULE_5__util_prefixName__["a" /* default */])(nextContext, nextProps.name);

        if (oldName !== newName) {
          // unregister old name
          this.context._reduxForm.unregister(oldName);
          // register new name
          this.context._reduxForm.register(newName, 'FieldArray');
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        this.context._reduxForm.unregister(this.name);
      }
    }, {
      key: 'getRenderedComponent',
      value: function getRenderedComponent() {
        __WEBPACK_IMPORTED_MODULE_3_invariant___default()(this.props.withRef, 'If you want to access getRenderedComponent(), ' + 'you must specify a withRef prop to FieldArray');
        return this.ref && this.ref.getWrappedInstance().getRenderedComponent();
      }
    }, {
      key: 'render',
      value: function render() {
        return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(ConnectedFieldArray, _extends({}, this.props, {
          name: this.name,
          _reduxForm: this.context._reduxForm,
          ref: this.saveRef
        }));
      }
    }, {
      key: 'name',
      get: function get() {
        return Object(__WEBPACK_IMPORTED_MODULE_5__util_prefixName__["a" /* default */])(this.context, this.props.name);
      }
    }, {
      key: 'dirty',
      get: function get() {
        return !this.ref || this.ref.getWrappedInstance().dirty;
      }
    }, {
      key: 'pristine',
      get: function get() {
        return !!(this.ref && this.ref.getWrappedInstance().pristine);
      }
    }, {
      key: 'value',
      get: function get() {
        return this.ref ? this.ref.getWrappedInstance().value : undefined;
      }
    }]);

    return FieldArray;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

  FieldArray.propTypes = {
    name: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,
    component: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node]).isRequired,
    props: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,
    validate: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func)]),
    warn: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func)]),
    withRef: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool
  };
  FieldArray.contextTypes = {
    _reduxForm: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object
  };

  Object(__WEBPACK_IMPORTED_MODULE_1_react_lifecycles_compat__["polyfill"])(FieldArray);
  return FieldArray;
};

/* harmony default export */ __webpack_exports__["a"] = (createFieldArray);

/***/ }),
/* 1221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_mapValues__ = __webpack_require__(355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__createFieldArrayProps__ = __webpack_require__(1236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__structure_plain__ = __webpack_require__(28);


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var propsToNotUpdateFor = ['_reduxForm', 'value'];

var createConnectedFieldArray = function createConnectedFieldArray(structure) {
  var deepEqual = structure.deepEqual,
      getIn = structure.getIn,
      size = structure.size;

  var getSyncError = function getSyncError(syncErrors, name) {
    // For an array, the error can _ONLY_ be under _error.
    // This is why this getSyncError is not the same as the
    // one in Field.
    return __WEBPACK_IMPORTED_MODULE_6__structure_plain__["a" /* default */].getIn(syncErrors, name + '._error');
  };

  var getSyncWarning = function getSyncWarning(syncWarnings, name) {
    // For an array, the warning can _ONLY_ be under _warning.
    // This is why this getSyncError is not the same as the
    // one in Field.
    return getIn(syncWarnings, name + '._warning');
  };

  var ConnectedFieldArray = function (_React$Component) {
    _inherits(ConnectedFieldArray, _React$Component);

    function ConnectedFieldArray() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, ConnectedFieldArray);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ConnectedFieldArray.__proto__ || Object.getPrototypeOf(ConnectedFieldArray)).call.apply(_ref, [this].concat(args))), _this), _this.saveRef = function (ref) {
        _this.ref = ref;
      }, _this.getValue = function (index) {
        return _this.props.value && getIn(_this.props.value, String(index));
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(ConnectedFieldArray, [{
      key: 'shouldComponentUpdate',
      value: function shouldComponentUpdate(nextProps) {
        var _this2 = this;

        // Update if the elements of the value array was updated.
        var thisValue = this.props.value;
        var nextValue = nextProps.value;

        if (thisValue && nextValue) {
          var nextValueItemsSame = nextValue.every(function (val) {
            return ~thisValue.indexOf(val);
          });
          var nextValueItemsOrderChanged = nextValue.some(function (val, index) {
            return val !== thisValue[index];
          });
          if (thisValue.length !== nextValue.length || nextValueItemsSame && nextValueItemsOrderChanged || nextProps.rerenderOnEveryChange && thisValue.some(function (val, index) {
            return !deepEqual(val, nextValue[index]);
          })) {
            return true;
          }
        }

        var nextPropsKeys = Object.keys(nextProps);
        var thisPropsKeys = Object.keys(this.props);
        // if we have children, we MUST update in React 16
        // https://twitter.com/erikras/status/915866544558788608
        return !!(this.props.children || nextProps.children || nextPropsKeys.length !== thisPropsKeys.length || nextPropsKeys.some(function (prop) {
          // useful to debug rerenders
          // if (!plain.deepEqual(this.props[ prop ], nextProps[ prop ])) {
          //   console.info(prop, 'changed', this.props[ prop ], '==>', nextProps[ prop ])
          // }
          return !~propsToNotUpdateFor.indexOf(prop) && !deepEqual(_this2.props[prop], nextProps[prop]);
        }));
      }
    }, {
      key: 'getRenderedComponent',
      value: function getRenderedComponent() {
        return this.ref;
      }
    }, {
      key: 'render',
      value: function render() {
        var _props = this.props,
            component = _props.component,
            withRef = _props.withRef,
            name = _props.name,
            _reduxForm = _props._reduxForm,
            validate = _props.validate,
            warn = _props.warn,
            rerenderOnEveryChange = _props.rerenderOnEveryChange,
            rest = _objectWithoutProperties(_props, ['component', 'withRef', 'name', '_reduxForm', 'validate', 'warn', 'rerenderOnEveryChange']);

        var props = Object(__WEBPACK_IMPORTED_MODULE_5__createFieldArrayProps__["a" /* default */])(structure, name, _reduxForm.form, _reduxForm.sectionPrefix, this.getValue, rest);
        if (withRef) {
          props.ref = this.saveRef;
        }
        return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](component, props);
      }
    }, {
      key: 'dirty',
      get: function get() {
        return this.props.dirty;
      }
    }, {
      key: 'pristine',
      get: function get() {
        return this.props.pristine;
      }
    }, {
      key: 'value',
      get: function get() {
        return this.props.value;
      }
    }]);

    return ConnectedFieldArray;
  }(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

  ConnectedFieldArray.propTypes = {
    component: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node]).isRequired,
    props: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,
    rerenderOnEveryChange: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool
  };

  ConnectedFieldArray.defaultProps = {
    rerenderOnEveryChange: false
  };

  ConnectedFieldArray.contextTypes = {
    _reduxForm: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object
  };

  var connector = Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(function (state, ownProps) {
    var name = ownProps.name,
        _ownProps$_reduxForm = ownProps._reduxForm,
        initialValues = _ownProps$_reduxForm.initialValues,
        getFormState = _ownProps$_reduxForm.getFormState;

    var formState = getFormState(state);
    var initial = getIn(formState, 'initial.' + name) || initialValues && getIn(initialValues, name);
    var value = getIn(formState, 'values.' + name);
    var submitting = getIn(formState, 'submitting');
    var syncError = getSyncError(getIn(formState, 'syncErrors'), name);
    var syncWarning = getSyncWarning(getIn(formState, 'syncWarnings'), name);
    var pristine = deepEqual(value, initial);
    return {
      asyncError: getIn(formState, 'asyncErrors.' + name + '._error'),
      dirty: !pristine,
      pristine: pristine,
      state: getIn(formState, 'fields.' + name),
      submitError: getIn(formState, 'submitErrors.' + name + '._error'),
      submitFailed: getIn(formState, 'submitFailed'),
      submitting: submitting,
      syncError: syncError,
      syncWarning: syncWarning,
      value: value,
      length: size(value)
    };
  }, function (dispatch, ownProps) {
    var name = ownProps.name,
        _reduxForm = ownProps._reduxForm;
    var arrayInsert = _reduxForm.arrayInsert,
        arrayMove = _reduxForm.arrayMove,
        arrayPop = _reduxForm.arrayPop,
        arrayPush = _reduxForm.arrayPush,
        arrayRemove = _reduxForm.arrayRemove,
        arrayRemoveAll = _reduxForm.arrayRemoveAll,
        arrayShift = _reduxForm.arrayShift,
        arraySplice = _reduxForm.arraySplice,
        arraySwap = _reduxForm.arraySwap,
        arrayUnshift = _reduxForm.arrayUnshift;

    return Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_mapValues__["a" /* default */])({
      arrayInsert: arrayInsert,
      arrayMove: arrayMove,
      arrayPop: arrayPop,
      arrayPush: arrayPush,
      arrayRemove: arrayRemove,
      arrayRemoveAll: arrayRemoveAll,
      arrayShift: arrayShift,
      arraySplice: arraySplice,
      arraySwap: arraySwap,
      arrayUnshift: arrayUnshift
    }, function (actionCreator) {
      return Object(__WEBPACK_IMPORTED_MODULE_4_redux__["b" /* bindActionCreators */])(actionCreator.bind(null, name), dispatch);
    });
  }, undefined, { withRef: true });
  return connector(ConnectedFieldArray);
};

/* harmony default export */ __webpack_exports__["a"] = (createConnectedFieldArray);

/***/ }),
/* 1222 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseFor_js__ = __webpack_require__(559);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__keys_js__ = __webpack_require__(352);



/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return object && Object(__WEBPACK_IMPORTED_MODULE_0__baseFor_js__["a" /* default */])(object, iteratee, __WEBPACK_IMPORTED_MODULE_1__keys_js__["a" /* default */]);
}

/* harmony default export */ __webpack_exports__["a"] = (baseForOwn);


/***/ }),
/* 1223 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

/* harmony default export */ __webpack_exports__["a"] = (createBaseFor);


/***/ }),
/* 1224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseMatches_js__ = __webpack_require__(1225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseMatchesProperty_js__ = __webpack_require__(1228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__identity_js__ = __webpack_require__(357);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isArray_js__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__property_js__ = __webpack_require__(1233);






/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return __WEBPACK_IMPORTED_MODULE_2__identity_js__["a" /* default */];
  }
  if (typeof value == 'object') {
    return Object(__WEBPACK_IMPORTED_MODULE_3__isArray_js__["a" /* default */])(value)
      ? Object(__WEBPACK_IMPORTED_MODULE_1__baseMatchesProperty_js__["a" /* default */])(value[0], value[1])
      : Object(__WEBPACK_IMPORTED_MODULE_0__baseMatches_js__["a" /* default */])(value);
  }
  return Object(__WEBPACK_IMPORTED_MODULE_4__property_js__["a" /* default */])(value);
}

/* harmony default export */ __webpack_exports__["a"] = (baseIteratee);


/***/ }),
/* 1225 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseIsMatch_js__ = __webpack_require__(1226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getMatchData_js__ = __webpack_require__(1227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__matchesStrictComparable_js__ = __webpack_require__(561);




/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = Object(__WEBPACK_IMPORTED_MODULE_1__getMatchData_js__["a" /* default */])(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return Object(__WEBPACK_IMPORTED_MODULE_2__matchesStrictComparable_js__["a" /* default */])(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || Object(__WEBPACK_IMPORTED_MODULE_0__baseIsMatch_js__["a" /* default */])(object, source, matchData);
  };
}

/* harmony default export */ __webpack_exports__["a"] = (baseMatches);


/***/ }),
/* 1226 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Stack_js__ = __webpack_require__(351);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseIsEqual_js__ = __webpack_require__(238);



/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new __WEBPACK_IMPORTED_MODULE_0__Stack_js__["a" /* default */];
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? Object(__WEBPACK_IMPORTED_MODULE_1__baseIsEqual_js__["a" /* default */])(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

/* harmony default export */ __webpack_exports__["a"] = (baseIsMatch);


/***/ }),
/* 1227 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isStrictComparable_js__ = __webpack_require__(560);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__keys_js__ = __webpack_require__(352);



/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = Object(__WEBPACK_IMPORTED_MODULE_1__keys_js__["a" /* default */])(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, Object(__WEBPACK_IMPORTED_MODULE_0__isStrictComparable_js__["a" /* default */])(value)];
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (getMatchData);


/***/ }),
/* 1228 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseIsEqual_js__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__get_js__ = __webpack_require__(1229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__hasIn_js__ = __webpack_require__(1230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isKey_js__ = __webpack_require__(356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__isStrictComparable_js__ = __webpack_require__(560);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__matchesStrictComparable_js__ = __webpack_require__(561);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__toKey_js__ = __webpack_require__(179);








/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (Object(__WEBPACK_IMPORTED_MODULE_3__isKey_js__["a" /* default */])(path) && Object(__WEBPACK_IMPORTED_MODULE_4__isStrictComparable_js__["a" /* default */])(srcValue)) {
    return Object(__WEBPACK_IMPORTED_MODULE_5__matchesStrictComparable_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_6__toKey_js__["a" /* default */])(path), srcValue);
  }
  return function(object) {
    var objValue = Object(__WEBPACK_IMPORTED_MODULE_1__get_js__["a" /* default */])(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? Object(__WEBPACK_IMPORTED_MODULE_2__hasIn_js__["a" /* default */])(object, path)
      : Object(__WEBPACK_IMPORTED_MODULE_0__baseIsEqual_js__["a" /* default */])(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}

/* harmony default export */ __webpack_exports__["a"] = (baseMatchesProperty);


/***/ }),
/* 1229 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGet_js__ = __webpack_require__(562);


/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : Object(__WEBPACK_IMPORTED_MODULE_0__baseGet_js__["a" /* default */])(object, path);
  return result === undefined ? defaultValue : result;
}

/* harmony default export */ __webpack_exports__["a"] = (get);


/***/ }),
/* 1230 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseHasIn_js__ = __webpack_require__(1231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__hasPath_js__ = __webpack_require__(1232);



/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && Object(__WEBPACK_IMPORTED_MODULE_1__hasPath_js__["a" /* default */])(object, path, __WEBPACK_IMPORTED_MODULE_0__baseHasIn_js__["a" /* default */]);
}

/* harmony default export */ __webpack_exports__["a"] = (hasIn);


/***/ }),
/* 1231 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

/* harmony default export */ __webpack_exports__["a"] = (baseHasIn);


/***/ }),
/* 1232 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__castPath_js__ = __webpack_require__(563);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isArguments_js__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isArray_js__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isIndex_js__ = __webpack_require__(353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__isLength_js__ = __webpack_require__(354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__toKey_js__ = __webpack_require__(179);







/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = Object(__WEBPACK_IMPORTED_MODULE_0__castPath_js__["a" /* default */])(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = Object(__WEBPACK_IMPORTED_MODULE_5__toKey_js__["a" /* default */])(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && Object(__WEBPACK_IMPORTED_MODULE_4__isLength_js__["a" /* default */])(length) && Object(__WEBPACK_IMPORTED_MODULE_3__isIndex_js__["a" /* default */])(key, length) &&
    (Object(__WEBPACK_IMPORTED_MODULE_2__isArray_js__["a" /* default */])(object) || Object(__WEBPACK_IMPORTED_MODULE_1__isArguments_js__["a" /* default */])(object));
}

/* harmony default export */ __webpack_exports__["a"] = (hasPath);


/***/ }),
/* 1233 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseProperty_js__ = __webpack_require__(1234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__basePropertyDeep_js__ = __webpack_require__(1235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isKey_js__ = __webpack_require__(356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__toKey_js__ = __webpack_require__(179);





/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return Object(__WEBPACK_IMPORTED_MODULE_2__isKey_js__["a" /* default */])(path) ? Object(__WEBPACK_IMPORTED_MODULE_0__baseProperty_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__toKey_js__["a" /* default */])(path)) : Object(__WEBPACK_IMPORTED_MODULE_1__basePropertyDeep_js__["a" /* default */])(path);
}

/* harmony default export */ __webpack_exports__["a"] = (property);


/***/ }),
/* 1234 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

/* harmony default export */ __webpack_exports__["a"] = (baseProperty);


/***/ }),
/* 1235 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGet_js__ = __webpack_require__(562);


/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function(object) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__baseGet_js__["a" /* default */])(object, path);
  };
}

/* harmony default export */ __webpack_exports__["a"] = (basePropertyDeep);


/***/ }),
/* 1236 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var createFieldArrayProps = function createFieldArrayProps(_ref2, name, form, sectionPrefix, getValue, _ref) {
  var getIn = _ref2.getIn;

  var arrayInsert = _ref.arrayInsert,
      arrayMove = _ref.arrayMove,
      arrayPop = _ref.arrayPop,
      arrayPush = _ref.arrayPush,
      arrayRemove = _ref.arrayRemove,
      arrayRemoveAll = _ref.arrayRemoveAll,
      arrayShift = _ref.arrayShift,
      arraySplice = _ref.arraySplice,
      arraySwap = _ref.arraySwap,
      arrayUnshift = _ref.arrayUnshift,
      asyncError = _ref.asyncError,
      dirty = _ref.dirty,
      length = _ref.length,
      pristine = _ref.pristine,
      submitError = _ref.submitError,
      state = _ref.state,
      submitFailed = _ref.submitFailed,
      submitting = _ref.submitting,
      syncError = _ref.syncError,
      syncWarning = _ref.syncWarning,
      value = _ref.value,
      props = _ref.props,
      rest = _objectWithoutProperties(_ref, ['arrayInsert', 'arrayMove', 'arrayPop', 'arrayPush', 'arrayRemove', 'arrayRemoveAll', 'arrayShift', 'arraySplice', 'arraySwap', 'arrayUnshift', 'asyncError', 'dirty', 'length', 'pristine', 'submitError', 'state', 'submitFailed', 'submitting', 'syncError', 'syncWarning', 'value', 'props']);

  var error = syncError || asyncError || submitError;
  var warning = syncWarning;
  var fieldName = sectionPrefix ? name.replace(sectionPrefix + '.', '') : name;
  var finalProps = _extends({
    fields: {
      _isFieldArray: true,
      forEach: function forEach(callback) {
        return (value || []).forEach(function (item, index) {
          return callback(fieldName + '[' + index + ']', index, finalProps.fields);
        });
      },
      get: getValue,
      getAll: function getAll() {
        return value;
      },
      insert: arrayInsert,
      length: length,
      map: function map(callback) {
        return (value || []).map(function (item, index) {
          return callback(fieldName + '[' + index + ']', index, finalProps.fields);
        });
      },
      move: arrayMove,
      name: name,
      pop: function pop() {
        arrayPop();
        return getIn(value, String(length - 1));
      },
      push: arrayPush,
      reduce: function reduce(callback, initial) {
        return (value || []).reduce(function (accumulator, item, index) {
          return callback(accumulator, fieldName + '[' + index + ']', index, finalProps.fields);
        }, initial);
      },
      remove: arrayRemove,
      removeAll: arrayRemoveAll,
      shift: function shift() {
        arrayShift();
        return getIn(value, '0');
      },
      splice: arraySplice,
      swap: arraySwap,
      unshift: arrayUnshift
    },
    meta: {
      dirty: dirty,
      error: error,
      form: form,
      warning: warning,
      invalid: !!error,
      pristine: pristine,
      submitting: submitting,
      submitFailed: submitFailed,
      valid: !error
    }
  }, props, rest);
  return finalProps;
};


/* harmony default export */ __webpack_exports__["a"] = (createFieldArrayProps);

/***/ }),
/* 1237 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createFormValueSelector__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(28);



/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0__createFormValueSelector__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 1238 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(28);




var createFormValueSelector = function createFormValueSelector(_ref) {
  var getIn = _ref.getIn;
  return function (form, getFormState) {
    __WEBPACK_IMPORTED_MODULE_0_invariant___default()(form, 'Form value must be specified');
    var nonNullGetFormState = getFormState || function (state) {
      return getIn(state, 'form');
    };
    return function (state) {
      for (var _len = arguments.length, fields = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        fields[_key - 1] = arguments[_key];
      }

      __WEBPACK_IMPORTED_MODULE_0_invariant___default()(fields.length, 'No fields specified');
      return fields.length === 1 ? // only selecting one field, so return its value
      getIn(nonNullGetFormState(state), form + '.values.' + fields[0]) : // selecting many fields, so return an object of field values
      fields.reduce(function (accumulator, field) {
        var value = getIn(nonNullGetFormState(state), form + '.values.' + field);
        return value === undefined ? accumulator : __WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */].setIn(accumulator, field, value);
      }, {});
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createFormValueSelector);

/***/ }),
/* 1239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createFormValues__ = __webpack_require__(1240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(28);



/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0__createFormValues__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 1240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_mapValues__ = __webpack_require__(355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_es_isEqual__ = __webpack_require__(1241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_es_isEmpty__ = __webpack_require__(1242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_prefixName__ = __webpack_require__(176);




var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var createValues = function createValues(_ref) {
  var getIn = _ref.getIn;
  return function (firstArg) {
    for (var _len = arguments.length, rest = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      rest[_key - 1] = arguments[_key];
    }

    // create a class that reads current form name and creates a selector
    // return
    return function (Component) {
      var FormValues = function (_React$Component) {
        _inherits(FormValues, _React$Component);

        function FormValues(props, context) {
          _classCallCheck(this, FormValues);

          var _this = _possibleConstructorReturn(this, (FormValues.__proto__ || Object.getPrototypeOf(FormValues)).call(this, props, context));

          if (!context._reduxForm) {
            throw new Error('formValues() must be used inside a React tree decorated with reduxForm()');
          }
          _this.updateComponent(props);
          return _this;
        }

        _createClass(FormValues, [{
          key: 'componentWillReceiveProps',
          value: function componentWillReceiveProps(props) {
            if (typeof firstArg === 'function') {
              this.updateComponent(props);
            }
          }
        }, {
          key: 'render',
          value: function render() {
            var Component = this.Component;

            return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(Component
            // so that the connected component updates props when sectionPrefix has changed
            , _extends({ sectionPrefix: this.context._reduxForm.sectionPrefix
            }, this.props));
          }
        }, {
          key: 'updateComponent',
          value: function updateComponent(props) {
            var valuesMap = void 0;
            var resolvedFirstArg = typeof firstArg === 'function' ? firstArg(props) : firstArg;
            if (typeof resolvedFirstArg === 'string') {
              valuesMap = rest.reduce(function (result, k) {
                result[k] = k;
                return result;
              }, _defineProperty({}, resolvedFirstArg, resolvedFirstArg));
            } else {
              valuesMap = resolvedFirstArg;
            }
            if (Object(__WEBPACK_IMPORTED_MODULE_2_lodash_es_isEmpty__["a" /* default */])(valuesMap)) {
              // maybe that empty valuesMap is ok if firstArg is a function?
              // if this is the case, we probably should set this.Component = Component
              throw new Error('formValues(): You must specify values to get as formValues(name1, name2, ...) or formValues({propName1: propPath1, ...}) or formValues((props) => name) or formValues((props) => ({propName1: propPath1, ...}))');
            }
            if (Object(__WEBPACK_IMPORTED_MODULE_1_lodash_es_isEqual__["a" /* default */])(valuesMap, this._valuesMap)) {
              // no change in valuesMap
              return;
            }
            this._valuesMap = valuesMap;
            this.setComponent();
          }
        }, {
          key: 'setComponent',
          value: function setComponent() {
            var _this2 = this;

            var formValuesSelector = function formValuesSelector(_, _ref2) {
              var sectionPrefix = _ref2.sectionPrefix;

              // Yes, we're only using connect() for listening to updates.
              // The second argument needs to be there so that connect calls
              // the selector when props change
              var getValues = _this2.context._reduxForm.getValues;

              var values = getValues();
              return Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_mapValues__["a" /* default */])(_this2._valuesMap, function (path) {
                return getIn(values, Object(__WEBPACK_IMPORTED_MODULE_6__util_prefixName__["a" /* default */])(_this2.context, path));
              });
            };
            this.Component = Object(__WEBPACK_IMPORTED_MODULE_5_react_redux__["b" /* connect */])(formValuesSelector, function () {
              return {};
            } // ignore dispatch
            )(function (_ref3) {
              var sectionPrefix = _ref3.sectionPrefix,
                  otherProps = _objectWithoutProperties(_ref3, ['sectionPrefix']);

              return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(Component, otherProps);
            });
          }
        }]);

        return FormValues;
      }(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

      FormValues.contextTypes = {
        _reduxForm: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object
      };
      return FormValues;
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createValues);

/***/ }),
/* 1241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseIsEqual_js__ = __webpack_require__(238);


/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */
function isEqual(value, other) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__baseIsEqual_js__["a" /* default */])(value, other);
}

/* harmony default export */ __webpack_exports__["a"] = (isEqual);


/***/ }),
/* 1242 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseKeys_js__ = __webpack_require__(554);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getTag_js__ = __webpack_require__(556);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isArguments_js__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isArray_js__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__isArrayLike_js__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__isBuffer_js__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__isPrototype_js__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__isTypedArray_js__ = __webpack_require__(241);









/** `Object#toString` result references. */
var mapTag = '[object Map]',
    setTag = '[object Set]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if `value` is an empty object, collection, map, or set.
 *
 * Objects are considered empty if they have no own enumerable string keyed
 * properties.
 *
 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
 * jQuery-like collections are considered empty if they have a `length` of `0`.
 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
 * @example
 *
 * _.isEmpty(null);
 * // => true
 *
 * _.isEmpty(true);
 * // => true
 *
 * _.isEmpty(1);
 * // => true
 *
 * _.isEmpty([1, 2, 3]);
 * // => false
 *
 * _.isEmpty({ 'a': 1 });
 * // => false
 */
function isEmpty(value) {
  if (value == null) {
    return true;
  }
  if (Object(__WEBPACK_IMPORTED_MODULE_4__isArrayLike_js__["a" /* default */])(value) &&
      (Object(__WEBPACK_IMPORTED_MODULE_3__isArray_js__["a" /* default */])(value) || typeof value == 'string' || typeof value.splice == 'function' ||
        Object(__WEBPACK_IMPORTED_MODULE_5__isBuffer_js__["a" /* default */])(value) || Object(__WEBPACK_IMPORTED_MODULE_7__isTypedArray_js__["a" /* default */])(value) || Object(__WEBPACK_IMPORTED_MODULE_2__isArguments_js__["a" /* default */])(value))) {
    return !value.length;
  }
  var tag = Object(__WEBPACK_IMPORTED_MODULE_1__getTag_js__["a" /* default */])(value);
  if (tag == mapTag || tag == setTag) {
    return !value.size;
  }
  if (Object(__WEBPACK_IMPORTED_MODULE_6__isPrototype_js__["a" /* default */])(value)) {
    return !Object(__WEBPACK_IMPORTED_MODULE_0__baseKeys_js__["a" /* default */])(value).length;
  }
  for (var key in value) {
    if (hasOwnProperty.call(value, key)) {
      return false;
    }
  }
  return true;
}

/* harmony default export */ __webpack_exports__["a"] = (isEmpty);


/***/ }),
/* 1243 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selectors_getFormError__ = __webpack_require__(1244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(28);



/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0__selectors_getFormError__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 1244 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var createGetFormError = function createGetFormError(_ref) {
  var getIn = _ref.getIn;
  return function (form, getFormState) {
    return function (state) {
      var nonNullGetFormState = getFormState || function (state) {
        return getIn(state, 'form');
      };
      return getIn(nonNullGetFormState(state), form + '.error');
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createGetFormError);

/***/ }),
/* 1245 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selectors_getFormNames__ = __webpack_require__(1246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(28);



/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0__selectors_getFormNames__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 1246 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function createGetFormNames(_ref) {
  var getIn = _ref.getIn,
      keys = _ref.keys;

  return function (getFormState) {
    return function (state) {
      var nonNullGetFormState = getFormState || function (state) {
        return getIn(state, 'form');
      };
      return keys(nonNullGetFormState(state));
    };
  };
}

/* harmony default export */ __webpack_exports__["a"] = (createGetFormNames);

/***/ }),
/* 1247 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selectors_getFormValues__ = __webpack_require__(1248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(28);



/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0__selectors_getFormValues__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 1248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var createGetFormValues = function createGetFormValues(_ref) {
  var getIn = _ref.getIn;
  return function (form, getFormState) {
    return function (state) {
      var nonNullGetFormState = getFormState || function (state) {
        return getIn(state, 'form');
      };
      return getIn(nonNullGetFormState(state), form + '.values');
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createGetFormValues);

/***/ }),
/* 1249 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selectors_getFormInitialValues__ = __webpack_require__(1250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(28);



/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0__selectors_getFormInitialValues__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 1250 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var createGetFormInitialValues = function createGetFormInitialValues(_ref) {
  var getIn = _ref.getIn;
  return function (form, getFormState) {
    return function (state) {
      var nonNullGetFormState = getFormState || function (state) {
        return getIn(state, 'form');
      };
      return getIn(nonNullGetFormState(state), form + '.initial');
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createGetFormInitialValues);

/***/ }),
/* 1251 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selectors_getFormSyncErrors__ = __webpack_require__(1252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(28);



/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0__selectors_getFormSyncErrors__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 1252 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var createGetFormSyncErrors = function createGetFormSyncErrors(_ref) {
  var getIn = _ref.getIn,
      empty = _ref.empty;
  return function (form, getFormState) {
    return function (state) {
      var nonNullGetFormState = getFormState || function (state) {
        return getIn(state, 'form');
      };
      return getIn(nonNullGetFormState(state), form + '.syncErrors') || empty;
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createGetFormSyncErrors);

/***/ }),
/* 1253 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selectors_getFormMeta__ = __webpack_require__(1254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(28);



/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0__selectors_getFormMeta__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 1254 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var createGetFormMeta = function createGetFormMeta(_ref) {
  var getIn = _ref.getIn,
      empty = _ref.empty;
  return function (form, getFormState) {
    return function (state) {
      var nonNullGetFormState = getFormState || function (state) {
        return getIn(state, 'form');
      };
      return getIn(nonNullGetFormState(state), form + '.fields') || empty;
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createGetFormMeta);

/***/ }),
/* 1255 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selectors_getFormAsyncErrors__ = __webpack_require__(1256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(28);



/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0__selectors_getFormAsyncErrors__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 1256 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var createGetFormAsyncErrors = function createGetFormAsyncErrors(_ref) {
  var getIn = _ref.getIn;
  return function (form, getFormState) {
    return function (state) {
      var nonNullGetFormState = getFormState || function (state) {
        return getIn(state, 'form');
      };
      return getIn(nonNullGetFormState(state), form + '.asyncErrors');
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createGetFormAsyncErrors);

/***/ }),
/* 1257 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selectors_getFormSyncWarnings__ = __webpack_require__(1258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(28);



/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0__selectors_getFormSyncWarnings__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 1258 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var createGetFormSyncWarnings = function createGetFormSyncWarnings(_ref) {
  var getIn = _ref.getIn,
      empty = _ref.empty;
  return function (form, getFormState) {
    return function (state) {
      var nonNullGetFormState = getFormState || function (state) {
        return getIn(state, 'form');
      };
      return getIn(nonNullGetFormState(state), form + '.syncWarnings') || empty;
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createGetFormSyncWarnings);

/***/ }),
/* 1259 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selectors_getFormSubmitErrors__ = __webpack_require__(1260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(28);



/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0__selectors_getFormSubmitErrors__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 1260 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var createGetFormSubmitErrors = function createGetFormSubmitErrors(_ref) {
  var getIn = _ref.getIn,
      empty = _ref.empty;
  return function (form, getFormState) {
    return function (state) {
      var nonNullGetFormState = getFormState || function (state) {
        return getIn(state, 'form');
      };
      return getIn(nonNullGetFormState(state), form + '.submitErrors') || empty;
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createGetFormSubmitErrors);

/***/ }),
/* 1261 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selectors_isAsyncValidating__ = __webpack_require__(1262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(28);



/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0__selectors_isAsyncValidating__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 1262 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var createIsAsyncValidating = function createIsAsyncValidating(_ref) {
  var getIn = _ref.getIn;
  return function (form, getFormState) {
    return function (state) {
      var nonNullGetFormState = getFormState || function (state) {
        return getIn(state, 'form');
      };
      return !!getIn(nonNullGetFormState(state), form + '.asyncValidating');
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createIsAsyncValidating);

/***/ }),
/* 1263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selectors_isDirty__ = __webpack_require__(1264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(28);



/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0__selectors_isDirty__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 1264 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isPristine__ = __webpack_require__(564);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }




var createIsDirty = function createIsDirty(structure) {
  return function (form, getFormState) {
    var isPristine = Object(__WEBPACK_IMPORTED_MODULE_0__isPristine__["a" /* default */])(structure)(form, getFormState);
    return function (state) {
      for (var _len = arguments.length, fields = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        fields[_key - 1] = arguments[_key];
      }

      return !isPristine.apply(undefined, [state].concat(_toConsumableArray(fields)));
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createIsDirty);

/***/ }),
/* 1265 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selectors_isInvalid__ = __webpack_require__(1266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(28);



/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0__selectors_isInvalid__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 1266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isValid__ = __webpack_require__(358);



var createIsInvalid = function createIsInvalid(structure) {
  return function (form, getFormState) {
    var isValid = Object(__WEBPACK_IMPORTED_MODULE_0__isValid__["a" /* default */])(structure)(form, getFormState);
    return function (state) {
      return !isValid(state);
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createIsInvalid);

/***/ }),
/* 1267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


var getErrorKeys = function getErrorKeys(name, type) {
  switch (type) {
    case 'Field':
      return [name, name + '._error'];
    case 'FieldArray':
      return [name + '._error'];
    default:
      throw new Error('Unknown field type');
  }
};


var createHasError = function createHasError(_ref) {
  var getIn = _ref.getIn;

  var hasError = function hasError(field, syncErrors, asyncErrors, submitErrors) {
    if (!syncErrors && !asyncErrors && !submitErrors) {
      return false;
    }

    var name = getIn(field, 'name');
    var type = getIn(field, 'type');
    return getErrorKeys(name, type).some(function (key) {
      return getIn(syncErrors, key) || getIn(asyncErrors, key) || getIn(submitErrors, key);
    });
  };
  return hasError;
};

/* harmony default export */ __webpack_exports__["a"] = (createHasError);

/***/ }),
/* 1268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selectors_isPristine__ = __webpack_require__(564);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(28);



/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0__selectors_isPristine__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 1269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selectors_isValid__ = __webpack_require__(358);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(28);



/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0__selectors_isValid__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 1270 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selectors_isSubmitting__ = __webpack_require__(1271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(28);



/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0__selectors_isSubmitting__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 1271 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var createIsSubmitting = function createIsSubmitting(_ref) {
  var getIn = _ref.getIn;
  return function (form, getFormState) {
    return function (state) {
      var nonNullGetFormState = getFormState || function (state) {
        return getIn(state, 'form');
      };
      return !!getIn(nonNullGetFormState(state), form + '.submitting');
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createIsSubmitting);

/***/ }),
/* 1272 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selectors_hasSubmitSucceeded__ = __webpack_require__(1273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(28);



/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0__selectors_hasSubmitSucceeded__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 1273 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var createHasSubmitSucceeded = function createHasSubmitSucceeded(_ref) {
  var getIn = _ref.getIn;
  return function (form, getFormState) {
    return function (state) {
      var nonNullGetFormState = getFormState || function (state) {
        return getIn(state, 'form');
      };
      return !!getIn(nonNullGetFormState(state), form + '.submitSucceeded');
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createHasSubmitSucceeded);

/***/ }),
/* 1274 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selectors_hasSubmitFailed__ = __webpack_require__(1275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(28);



/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0__selectors_hasSubmitFailed__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 1275 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var createHasSubmitFailed = function createHasSubmitFailed(_ref) {
  var getIn = _ref.getIn;
  return function (form, getFormState) {
    return function (state) {
      var nonNullGetFormState = getFormState || function (state) {
        return getIn(state, 'form');
      };
      return !!getIn(nonNullGetFormState(state), form + '.submitFailed');
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createHasSubmitFailed);

/***/ }),
/* 1276 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createReduxForm__ = __webpack_require__(1277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(28);



/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__createReduxForm__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 1277 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_merge__ = __webpack_require__(1278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_es_mapValues__ = __webpack_require__(355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_lifecycles_compat__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_invariant__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_is_promise__ = __webpack_require__(359);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_is_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_is_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_redux__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_redux__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__actions__ = __webpack_require__(529);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__asyncValidation__ = __webpack_require__(1302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__defaultShouldAsyncValidate__ = __webpack_require__(530);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__defaultShouldValidate__ = __webpack_require__(531);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__defaultShouldError__ = __webpack_require__(532);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__defaultShouldWarn__ = __webpack_require__(533);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__events_silenceEvent__ = __webpack_require__(569);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__events_silenceEvents__ = __webpack_require__(1303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__generateValidator__ = __webpack_require__(1304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__handleSubmit__ = __webpack_require__(1305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__selectors_isValid__ = __webpack_require__(358);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__structure_plain__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__util_getDisplayName__ = __webpack_require__(1306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__util_isHotReloading__ = __webpack_require__(1307);



var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }



























var isClassComponent = function isClassComponent(Component) {
  return Boolean(Component && Component.prototype && _typeof(Component.prototype.isReactComponent) === 'object');
};

// extract field-specific actions

var arrayInsert = __WEBPACK_IMPORTED_MODULE_10__actions__["a" /* default */].arrayInsert,
    arrayMove = __WEBPACK_IMPORTED_MODULE_10__actions__["a" /* default */].arrayMove,
    arrayPop = __WEBPACK_IMPORTED_MODULE_10__actions__["a" /* default */].arrayPop,
    arrayPush = __WEBPACK_IMPORTED_MODULE_10__actions__["a" /* default */].arrayPush,
    arrayRemove = __WEBPACK_IMPORTED_MODULE_10__actions__["a" /* default */].arrayRemove,
    arrayRemoveAll = __WEBPACK_IMPORTED_MODULE_10__actions__["a" /* default */].arrayRemoveAll,
    arrayShift = __WEBPACK_IMPORTED_MODULE_10__actions__["a" /* default */].arrayShift,
    arraySplice = __WEBPACK_IMPORTED_MODULE_10__actions__["a" /* default */].arraySplice,
    arraySwap = __WEBPACK_IMPORTED_MODULE_10__actions__["a" /* default */].arraySwap,
    arrayUnshift = __WEBPACK_IMPORTED_MODULE_10__actions__["a" /* default */].arrayUnshift,
    blur = __WEBPACK_IMPORTED_MODULE_10__actions__["a" /* default */].blur,
    change = __WEBPACK_IMPORTED_MODULE_10__actions__["a" /* default */].change,
    focus = __WEBPACK_IMPORTED_MODULE_10__actions__["a" /* default */].focus,
    formActions = _objectWithoutProperties(__WEBPACK_IMPORTED_MODULE_10__actions__["a" /* default */], ['arrayInsert', 'arrayMove', 'arrayPop', 'arrayPush', 'arrayRemove', 'arrayRemoveAll', 'arrayShift', 'arraySplice', 'arraySwap', 'arrayUnshift', 'blur', 'change', 'focus']);

var arrayActions = {
  arrayInsert: arrayInsert,
  arrayMove: arrayMove,
  arrayPop: arrayPop,
  arrayPush: arrayPush,
  arrayRemove: arrayRemove,
  arrayRemoveAll: arrayRemoveAll,
  arrayShift: arrayShift,
  arraySplice: arraySplice,
  arraySwap: arraySwap,
  arrayUnshift: arrayUnshift
};

var propsToNotUpdateFor = [].concat(_toConsumableArray(Object.keys(__WEBPACK_IMPORTED_MODULE_10__actions__["a" /* default */])), ['array', 'asyncErrors', 'initialValues', 'syncErrors', 'syncWarnings', 'values', 'registeredFields']);

var checkSubmit = function checkSubmit(submit) {
  if (!submit || typeof submit !== 'function') {
    throw new Error('You must either pass handleSubmit() an onSubmit function or pass onSubmit as a prop');
  }
  return submit;
};

/**
 * The decorator that is the main API to redux-form
 */
var createReduxForm = function createReduxForm(structure) {
  var deepEqual = structure.deepEqual,
      empty = structure.empty,
      getIn = structure.getIn,
      setIn = structure.setIn,
      keys = structure.keys,
      fromJS = structure.fromJS;

  var isValid = Object(__WEBPACK_IMPORTED_MODULE_20__selectors_isValid__["a" /* default */])(structure);
  return function (initialConfig) {
    var config = _extends({
      touchOnBlur: true,
      touchOnChange: false,
      persistentSubmitErrors: false,
      destroyOnUnmount: true,
      shouldAsyncValidate: __WEBPACK_IMPORTED_MODULE_12__defaultShouldAsyncValidate__["a" /* default */],
      shouldValidate: __WEBPACK_IMPORTED_MODULE_13__defaultShouldValidate__["a" /* default */],
      shouldError: __WEBPACK_IMPORTED_MODULE_14__defaultShouldError__["a" /* default */],
      shouldWarn: __WEBPACK_IMPORTED_MODULE_15__defaultShouldWarn__["a" /* default */],
      enableReinitialize: false,
      keepDirtyOnReinitialize: false,
      updateUnregisteredFields: false,
      getFormState: function getFormState(state) {
        return getIn(state, 'form');
      },
      pure: true,
      forceUnregisterOnUnmount: false
    }, initialConfig);

    return function (WrappedComponent) {
      var Form = function (_Component) {
        _inherits(Form, _Component);

        function Form() {
          var _ref;

          var _temp, _this, _ret;

          _classCallCheck(this, Form);

          for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }

          return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Form.__proto__ || Object.getPrototypeOf(Form)).call.apply(_ref, [this].concat(args))), _this), _this.destroyed = false, _this.fieldCounts = {}, _this.fieldValidators = {}, _this.lastFieldValidatorKeys = [], _this.fieldWarners = {}, _this.lastFieldWarnerKeys = [], _this.innerOnSubmit = undefined, _this.submitPromise = undefined, _this.getValues = function () {
            return _this.props.values;
          }, _this.isValid = function () {
            return _this.props.valid;
          }, _this.isPristine = function () {
            return _this.props.pristine;
          }, _this.register = function (name, type, getValidator, getWarner) {
            var lastCount = _this.fieldCounts[name];
            var nextCount = (lastCount || 0) + 1;
            _this.fieldCounts[name] = nextCount;
            _this.props.registerField(name, type);
            if (getValidator) {
              _this.fieldValidators[name] = getValidator;
            }
            if (getWarner) {
              _this.fieldWarners[name] = getWarner;
            }
          }, _this.unregister = function (name) {
            var lastCount = _this.fieldCounts[name];
            if (lastCount === 1) delete _this.fieldCounts[name];else if (lastCount != null) _this.fieldCounts[name] = lastCount - 1;

            if (!_this.destroyed) {
              var _this$props = _this.props,
                  _destroyOnUnmount = _this$props.destroyOnUnmount,
                  _forceUnregisterOnUnmount = _this$props.forceUnregisterOnUnmount,
                  _unregisterField = _this$props.unregisterField;

              if (_destroyOnUnmount || _forceUnregisterOnUnmount) {
                _unregisterField(name, _destroyOnUnmount);
                if (!_this.fieldCounts[name]) {
                  delete _this.fieldValidators[name];
                  delete _this.fieldWarners[name];
                  _this.lastFieldValidatorKeys = _this.lastFieldValidatorKeys.filter(function (key) {
                    return key !== name;
                  });
                }
              } else {
                _unregisterField(name, false);
              }
            }
          }, _this.getFieldList = function (options) {
            var registeredFields = _this.props.registeredFields;
            var list = [];
            if (!registeredFields) {
              return list;
            }
            var keySeq = keys(registeredFields);
            if (options && options.excludeFieldArray) {
              keySeq = keySeq.filter(function (name) {
                return getIn(registeredFields, '[\'' + name + '\'].type') !== 'FieldArray';
              });
            }
            return fromJS(keySeq.reduce(function (acc, key) {
              acc.push(key);
              return acc;
            }, list));
          }, _this.getValidators = function () {
            var validators = {};
            Object.keys(_this.fieldValidators).forEach(function (name) {
              var validator = _this.fieldValidators[name]();
              if (validator) {
                validators[name] = validator;
              }
            });
            return validators;
          }, _this.generateValidator = function () {
            var validators = _this.getValidators();
            return Object.keys(validators).length ? Object(__WEBPACK_IMPORTED_MODULE_18__generateValidator__["a" /* default */])(validators, structure) : undefined;
          }, _this.getWarners = function () {
            var warners = {};
            Object.keys(_this.fieldWarners).forEach(function (name) {
              var warner = _this.fieldWarners[name]();
              if (warner) {
                warners[name] = warner;
              }
            });
            return warners;
          }, _this.generateWarner = function () {
            var warners = _this.getWarners();
            return Object.keys(warners).length ? Object(__WEBPACK_IMPORTED_MODULE_18__generateValidator__["a" /* default */])(warners, structure) : undefined;
          }, _this.asyncValidate = function (name, value, trigger) {
            var _this$props2 = _this.props,
                asyncBlurFields = _this$props2.asyncBlurFields,
                asyncChangeFields = _this$props2.asyncChangeFields,
                asyncErrors = _this$props2.asyncErrors,
                asyncValidate = _this$props2.asyncValidate,
                dispatch = _this$props2.dispatch,
                initialized = _this$props2.initialized,
                pristine = _this$props2.pristine,
                shouldAsyncValidate = _this$props2.shouldAsyncValidate,
                startAsyncValidation = _this$props2.startAsyncValidation,
                stopAsyncValidation = _this$props2.stopAsyncValidation,
                syncErrors = _this$props2.syncErrors,
                values = _this$props2.values;

            var submitting = !name;

            var fieldNeedsValidation = function fieldNeedsValidation() {
              var fieldNeedsValidationForBlur = asyncBlurFields && name && ~asyncBlurFields.indexOf(name.replace(/\[[0-9]+\]/g, '[]'));
              var fieldNeedsValidationForChange = asyncChangeFields && name && ~asyncChangeFields.indexOf(name.replace(/\[[0-9]+\]/g, '[]'));
              var asyncValidateByDefault = !(asyncBlurFields || asyncChangeFields);

              return submitting || asyncValidateByDefault || (trigger === 'blur' ? fieldNeedsValidationForBlur : fieldNeedsValidationForChange);
            };

            if (asyncValidate) {
              var valuesToValidate = submitting ? values : setIn(values, name, value);
              var syncValidationPasses = submitting || !getIn(syncErrors, name);
              if (fieldNeedsValidation() && shouldAsyncValidate({
                asyncErrors: asyncErrors,
                initialized: initialized,
                trigger: submitting ? 'submit' : trigger,
                blurredField: name,
                pristine: pristine,
                syncValidationPasses: syncValidationPasses
              })) {
                return Object(__WEBPACK_IMPORTED_MODULE_11__asyncValidation__["a" /* default */])(function () {
                  return asyncValidate(valuesToValidate, dispatch, _this.props, name);
                }, startAsyncValidation, stopAsyncValidation, name);
              }
            }
          }, _this.submitCompleted = function (result) {
            delete _this.submitPromise;
            return result;
          }, _this.submitFailed = function (error) {
            delete _this.submitPromise;
            throw error;
          }, _this.listenToSubmit = function (promise) {
            if (!__WEBPACK_IMPORTED_MODULE_6_is_promise___default()(promise)) {
              return promise;
            }
            _this.submitPromise = promise;
            return promise.then(_this.submitCompleted, _this.submitFailed);
          }, _this.submit = function (submitOrEvent) {
            var _this$props3 = _this.props,
                onSubmit = _this$props3.onSubmit,
                blur = _this$props3.blur,
                change = _this$props3.change,
                dispatch = _this$props3.dispatch;


            if (!submitOrEvent || Object(__WEBPACK_IMPORTED_MODULE_16__events_silenceEvent__["a" /* default */])(submitOrEvent)) {
              // submitOrEvent is an event: fire submit if not already submitting
              if (!_this.submitPromise) {
                // avoid recursive stack trace if use Form with onSubmit as handleSubmit
                if (_this.innerOnSubmit && _this.innerOnSubmit !== _this.submit) {
                  // will call "submitOrEvent is the submit function" block below
                  return _this.innerOnSubmit();
                } else {
                  return _this.listenToSubmit(Object(__WEBPACK_IMPORTED_MODULE_19__handleSubmit__["a" /* default */])(checkSubmit(onSubmit), _extends({}, _this.props, Object(__WEBPACK_IMPORTED_MODULE_9_redux__["b" /* bindActionCreators */])({ blur: blur, change: change }, dispatch)), _this.props.validExceptSubmit, _this.asyncValidate, _this.getFieldList({ excludeFieldArray: true })));
                }
              }
            } else {
              // submitOrEvent is the submit function: return deferred submit thunk
              return Object(__WEBPACK_IMPORTED_MODULE_17__events_silenceEvents__["a" /* default */])(function () {
                return !_this.submitPromise && _this.listenToSubmit(Object(__WEBPACK_IMPORTED_MODULE_19__handleSubmit__["a" /* default */])(checkSubmit(submitOrEvent), _extends({}, _this.props, Object(__WEBPACK_IMPORTED_MODULE_9_redux__["b" /* bindActionCreators */])({ blur: blur, change: change }, dispatch)), _this.props.validExceptSubmit, _this.asyncValidate, _this.getFieldList({ excludeFieldArray: true })));
              });
            }
          }, _this.reset = function () {
            return _this.props.reset();
          }, _this.saveRef = function (ref) {
            _this.wrapped = ref;
          }, _temp), _possibleConstructorReturn(_this, _ret);
        }

        _createClass(Form, [{
          key: 'getChildContext',
          value: function getChildContext() {
            var _this2 = this;

            return {
              _reduxForm: _extends({}, this.props, {
                getFormState: function getFormState(state) {
                  return getIn(_this2.props.getFormState(state), _this2.props.form);
                },
                asyncValidate: this.asyncValidate,
                getValues: this.getValues,
                sectionPrefix: undefined,
                register: this.register,
                unregister: this.unregister,
                registerInnerOnSubmit: function registerInnerOnSubmit(innerOnSubmit) {
                  return _this2.innerOnSubmit = innerOnSubmit;
                }
              })
            };
          }
        }, {
          key: 'initIfNeeded',
          value: function initIfNeeded(nextProps) {
            var enableReinitialize = this.props.enableReinitialize;

            if (nextProps) {
              if ((enableReinitialize || !nextProps.initialized) && !deepEqual(this.props.initialValues, nextProps.initialValues)) {
                var _keepDirty = nextProps.initialized && this.props.keepDirtyOnReinitialize;
                this.props.initialize(nextProps.initialValues, _keepDirty, {
                  keepValues: nextProps.keepValues,
                  lastInitialValues: this.props.initialValues,
                  updateUnregisteredFields: nextProps.updateUnregisteredFields
                });
              }
            } else if (this.props.initialValues && (!this.props.initialized || enableReinitialize)) {
              this.props.initialize(this.props.initialValues, this.props.keepDirtyOnReinitialize, {
                keepValues: this.props.keepValues,
                updateUnregisteredFields: this.props.updateUnregisteredFields
              });
            }
          }
        }, {
          key: 'updateSyncErrorsIfNeeded',
          value: function updateSyncErrorsIfNeeded(nextSyncErrors, nextError, lastSyncErrors) {
            var _props = this.props,
                error = _props.error,
                updateSyncErrors = _props.updateSyncErrors;

            var noErrors = (!lastSyncErrors || !Object.keys(lastSyncErrors).length) && !error;
            var nextNoErrors = (!nextSyncErrors || !Object.keys(nextSyncErrors).length) && !nextError;
            if (!(noErrors && nextNoErrors) && (!__WEBPACK_IMPORTED_MODULE_21__structure_plain__["a" /* default */].deepEqual(lastSyncErrors, nextSyncErrors) || !__WEBPACK_IMPORTED_MODULE_21__structure_plain__["a" /* default */].deepEqual(error, nextError))) {
              updateSyncErrors(nextSyncErrors, nextError);
            }
          }
        }, {
          key: 'clearSubmitPromiseIfNeeded',
          value: function clearSubmitPromiseIfNeeded(nextProps) {
            var submitting = this.props.submitting;

            if (this.submitPromise && submitting && !nextProps.submitting) {
              delete this.submitPromise;
            }
          }
        }, {
          key: 'submitIfNeeded',
          value: function submitIfNeeded(nextProps) {
            var _props2 = this.props,
                clearSubmit = _props2.clearSubmit,
                triggerSubmit = _props2.triggerSubmit;

            if (!triggerSubmit && nextProps.triggerSubmit) {
              clearSubmit();
              this.submit();
            }
          }
        }, {
          key: 'shouldErrorFunction',
          value: function shouldErrorFunction() {
            var _props3 = this.props,
                shouldValidate = _props3.shouldValidate,
                shouldError = _props3.shouldError;

            var shouldValidateOverridden = shouldValidate !== __WEBPACK_IMPORTED_MODULE_13__defaultShouldValidate__["a" /* default */];
            var shouldErrorOverridden = shouldError !== __WEBPACK_IMPORTED_MODULE_14__defaultShouldError__["a" /* default */];

            return shouldValidateOverridden && !shouldErrorOverridden ? shouldValidate : shouldError;
          }
        }, {
          key: 'validateIfNeeded',
          value: function validateIfNeeded(nextProps) {
            var _props4 = this.props,
                validate = _props4.validate,
                values = _props4.values;

            var shouldError = this.shouldErrorFunction();
            var fieldLevelValidate = this.generateValidator();
            if (validate || fieldLevelValidate) {
              var initialRender = nextProps === undefined;
              var fieldValidatorKeys = Object.keys(this.getValidators());
              var validateParams = {
                values: values,
                nextProps: nextProps,
                props: this.props,
                initialRender: initialRender,
                lastFieldValidatorKeys: this.lastFieldValidatorKeys,
                fieldValidatorKeys: fieldValidatorKeys,
                structure: structure
              };

              if (shouldError(validateParams)) {
                var propsToValidate = initialRender || !nextProps ? this.props : nextProps;

                var _merge2 = Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_merge__["a" /* default */])(validate ? validate(propsToValidate.values, propsToValidate) || {} : {}, fieldLevelValidate ? fieldLevelValidate(propsToValidate.values, propsToValidate) || {} : {}),
                    _error = _merge2._error,
                    nextSyncErrors = _objectWithoutProperties(_merge2, ['_error']);

                this.lastFieldValidatorKeys = fieldValidatorKeys;
                this.updateSyncErrorsIfNeeded(nextSyncErrors, _error, propsToValidate.syncErrors);
              }
            } else {
              this.lastFieldValidatorKeys = [];
            }
          }
        }, {
          key: 'updateSyncWarningsIfNeeded',
          value: function updateSyncWarningsIfNeeded(nextSyncWarnings, nextWarning, lastSyncWarnings) {
            var _props5 = this.props,
                warning = _props5.warning,
                syncWarnings = _props5.syncWarnings,
                updateSyncWarnings = _props5.updateSyncWarnings;

            var noWarnings = (!syncWarnings || !Object.keys(syncWarnings).length) && !warning;
            var nextNoWarnings = (!nextSyncWarnings || !Object.keys(nextSyncWarnings).length) && !nextWarning;
            if (!(noWarnings && nextNoWarnings) && (!__WEBPACK_IMPORTED_MODULE_21__structure_plain__["a" /* default */].deepEqual(lastSyncWarnings, nextSyncWarnings) || !__WEBPACK_IMPORTED_MODULE_21__structure_plain__["a" /* default */].deepEqual(warning, nextWarning))) {
              updateSyncWarnings(nextSyncWarnings, nextWarning);
            }
          }
        }, {
          key: 'shouldWarnFunction',
          value: function shouldWarnFunction() {
            var _props6 = this.props,
                shouldValidate = _props6.shouldValidate,
                shouldWarn = _props6.shouldWarn;

            var shouldValidateOverridden = shouldValidate !== __WEBPACK_IMPORTED_MODULE_13__defaultShouldValidate__["a" /* default */];
            var shouldWarnOverridden = shouldWarn !== __WEBPACK_IMPORTED_MODULE_15__defaultShouldWarn__["a" /* default */];

            return shouldValidateOverridden && !shouldWarnOverridden ? shouldValidate : shouldWarn;
          }
        }, {
          key: 'warnIfNeeded',
          value: function warnIfNeeded(nextProps) {
            var _props7 = this.props,
                warn = _props7.warn,
                values = _props7.values;

            var shouldWarn = this.shouldWarnFunction();
            var fieldLevelWarn = this.generateWarner();
            if (warn || fieldLevelWarn) {
              var initialRender = nextProps === undefined;
              var fieldWarnerKeys = Object.keys(this.getWarners());
              var validateParams = {
                values: values,
                nextProps: nextProps,
                props: this.props,
                initialRender: initialRender,
                lastFieldValidatorKeys: this.lastFieldWarnerKeys,
                fieldValidatorKeys: fieldWarnerKeys,
                structure: structure
              };

              if (shouldWarn(validateParams)) {
                var propsToWarn = initialRender || !nextProps ? this.props : nextProps;

                var _merge3 = Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_merge__["a" /* default */])(warn ? warn(propsToWarn.values, propsToWarn) : {}, fieldLevelWarn ? fieldLevelWarn(propsToWarn.values, propsToWarn) : {}),
                    _warning = _merge3._warning,
                    nextSyncWarnings = _objectWithoutProperties(_merge3, ['_warning']);

                this.lastFieldWarnerKeys = fieldWarnerKeys;
                this.updateSyncWarningsIfNeeded(nextSyncWarnings, _warning, propsToWarn.syncWarnings);
              }
            }
          }
        }, {
          key: 'componentWillMount',
          value: function componentWillMount() {
            if (!Object(__WEBPACK_IMPORTED_MODULE_23__util_isHotReloading__["a" /* default */])()) {
              this.initIfNeeded();
              this.validateIfNeeded();
              this.warnIfNeeded();
            }
            __WEBPACK_IMPORTED_MODULE_5_invariant___default()(this.props.shouldValidate, 'shouldValidate() is deprecated and will be removed in v8.0.0. Use shouldWarn() or shouldError() instead.');
          }
        }, {
          key: 'componentWillReceiveProps',
          value: function componentWillReceiveProps(nextProps) {
            this.initIfNeeded(nextProps);
            this.validateIfNeeded(nextProps);
            this.warnIfNeeded(nextProps);
            this.clearSubmitPromiseIfNeeded(nextProps);
            this.submitIfNeeded(nextProps);
            var onChange = nextProps.onChange,
                values = nextProps.values,
                dispatch = nextProps.dispatch;

            if (onChange && !deepEqual(values, this.props.values)) {
              onChange(values, dispatch, nextProps, this.props.values);
            }
          }
        }, {
          key: 'shouldComponentUpdate',
          value: function shouldComponentUpdate(nextProps) {
            var _this3 = this;

            if (!this.props.pure) return true;
            var _config$immutableProp = config.immutableProps,
                immutableProps = _config$immutableProp === undefined ? [] : _config$immutableProp;
            // if we have children, we MUST update in React 16
            // https://twitter.com/erikras/status/915866544558788608

            return !!(this.props.children || nextProps.children || Object.keys(nextProps).some(function (prop) {
              // useful to debug rerenders
              // if (!plain.deepEqual(this.props[ prop ], nextProps[ prop ])) {
              //   console.info(prop, 'changed', this.props[ prop ], '==>', nextProps[ prop ])
              // }
              if (~immutableProps.indexOf(prop)) {
                return _this3.props[prop] !== nextProps[prop];
              }
              return !~propsToNotUpdateFor.indexOf(prop) && !deepEqual(_this3.props[prop], nextProps[prop]);
            }));
          }
        }, {
          key: 'componentDidMount',
          value: function componentDidMount() {
            if (!Object(__WEBPACK_IMPORTED_MODULE_23__util_isHotReloading__["a" /* default */])()) {
              this.initIfNeeded(this.props);
              this.validateIfNeeded();
              this.warnIfNeeded();
            }
            __WEBPACK_IMPORTED_MODULE_5_invariant___default()(this.props.shouldValidate, 'shouldValidate() is deprecated and will be removed in v8.0.0. Use shouldWarn() or shouldError() instead.');
          }
        }, {
          key: 'componentWillUnmount',
          value: function componentWillUnmount() {
            var _props8 = this.props,
                destroyOnUnmount = _props8.destroyOnUnmount,
                destroy = _props8.destroy;

            if (destroyOnUnmount && !Object(__WEBPACK_IMPORTED_MODULE_23__util_isHotReloading__["a" /* default */])()) {
              this.destroyed = true;
              destroy();
            }
          }
        }, {
          key: 'render',
          value: function render() {
            // remove some redux-form config-only props
            /* eslint-disable no-unused-vars */
            var _props9 = this.props,
                anyTouched = _props9.anyTouched,
                array = _props9.array,
                arrayInsert = _props9.arrayInsert,
                arrayMove = _props9.arrayMove,
                arrayPop = _props9.arrayPop,
                arrayPush = _props9.arrayPush,
                arrayRemove = _props9.arrayRemove,
                arrayRemoveAll = _props9.arrayRemoveAll,
                arrayShift = _props9.arrayShift,
                arraySplice = _props9.arraySplice,
                arraySwap = _props9.arraySwap,
                arrayUnshift = _props9.arrayUnshift,
                asyncErrors = _props9.asyncErrors,
                asyncValidate = _props9.asyncValidate,
                asyncValidating = _props9.asyncValidating,
                blur = _props9.blur,
                change = _props9.change,
                clearSubmit = _props9.clearSubmit,
                destroy = _props9.destroy,
                destroyOnUnmount = _props9.destroyOnUnmount,
                forceUnregisterOnUnmount = _props9.forceUnregisterOnUnmount,
                dirty = _props9.dirty,
                dispatch = _props9.dispatch,
                enableReinitialize = _props9.enableReinitialize,
                error = _props9.error,
                focus = _props9.focus,
                form = _props9.form,
                getFormState = _props9.getFormState,
                immutableProps = _props9.immutableProps,
                initialize = _props9.initialize,
                initialized = _props9.initialized,
                initialValues = _props9.initialValues,
                invalid = _props9.invalid,
                keepDirtyOnReinitialize = _props9.keepDirtyOnReinitialize,
                keepValues = _props9.keepValues,
                updateUnregisteredFields = _props9.updateUnregisteredFields,
                pristine = _props9.pristine,
                propNamespace = _props9.propNamespace,
                registeredFields = _props9.registeredFields,
                registerField = _props9.registerField,
                reset = _props9.reset,
                resetSection = _props9.resetSection,
                setSubmitFailed = _props9.setSubmitFailed,
                setSubmitSucceeded = _props9.setSubmitSucceeded,
                shouldAsyncValidate = _props9.shouldAsyncValidate,
                shouldValidate = _props9.shouldValidate,
                shouldError = _props9.shouldError,
                shouldWarn = _props9.shouldWarn,
                startAsyncValidation = _props9.startAsyncValidation,
                startSubmit = _props9.startSubmit,
                stopAsyncValidation = _props9.stopAsyncValidation,
                stopSubmit = _props9.stopSubmit,
                submitting = _props9.submitting,
                submitFailed = _props9.submitFailed,
                submitSucceeded = _props9.submitSucceeded,
                touch = _props9.touch,
                touchOnBlur = _props9.touchOnBlur,
                touchOnChange = _props9.touchOnChange,
                persistentSubmitErrors = _props9.persistentSubmitErrors,
                syncErrors = _props9.syncErrors,
                syncWarnings = _props9.syncWarnings,
                unregisterField = _props9.unregisterField,
                untouch = _props9.untouch,
                updateSyncErrors = _props9.updateSyncErrors,
                updateSyncWarnings = _props9.updateSyncWarnings,
                valid = _props9.valid,
                validExceptSubmit = _props9.validExceptSubmit,
                values = _props9.values,
                warning = _props9.warning,
                rest = _objectWithoutProperties(_props9, ['anyTouched', 'array', 'arrayInsert', 'arrayMove', 'arrayPop', 'arrayPush', 'arrayRemove', 'arrayRemoveAll', 'arrayShift', 'arraySplice', 'arraySwap', 'arrayUnshift', 'asyncErrors', 'asyncValidate', 'asyncValidating', 'blur', 'change', 'clearSubmit', 'destroy', 'destroyOnUnmount', 'forceUnregisterOnUnmount', 'dirty', 'dispatch', 'enableReinitialize', 'error', 'focus', 'form', 'getFormState', 'immutableProps', 'initialize', 'initialized', 'initialValues', 'invalid', 'keepDirtyOnReinitialize', 'keepValues', 'updateUnregisteredFields', 'pristine', 'propNamespace', 'registeredFields', 'registerField', 'reset', 'resetSection', 'setSubmitFailed', 'setSubmitSucceeded', 'shouldAsyncValidate', 'shouldValidate', 'shouldError', 'shouldWarn', 'startAsyncValidation', 'startSubmit', 'stopAsyncValidation', 'stopSubmit', 'submitting', 'submitFailed', 'submitSucceeded', 'touch', 'touchOnBlur', 'touchOnChange', 'persistentSubmitErrors', 'syncErrors', 'syncWarnings', 'unregisterField', 'untouch', 'updateSyncErrors', 'updateSyncWarnings', 'valid', 'validExceptSubmit', 'values', 'warning']);
            /* eslint-enable no-unused-vars */


            var reduxFormProps = _extends({
              array: array,
              anyTouched: anyTouched,
              asyncValidate: this.asyncValidate,
              asyncValidating: asyncValidating
            }, Object(__WEBPACK_IMPORTED_MODULE_9_redux__["b" /* bindActionCreators */])({ blur: blur, change: change }, dispatch), {
              clearSubmit: clearSubmit,
              destroy: destroy,
              dirty: dirty,
              dispatch: dispatch,
              error: error,
              form: form,
              handleSubmit: this.submit,
              initialize: initialize,
              initialized: initialized,
              initialValues: initialValues,
              invalid: invalid,
              pristine: pristine,
              reset: reset,
              resetSection: resetSection,
              submitting: submitting,
              submitFailed: submitFailed,
              submitSucceeded: submitSucceeded,
              touch: touch,
              untouch: untouch,
              valid: valid,
              warning: warning
            });
            var propsToPass = _extends({}, propNamespace ? _defineProperty({}, propNamespace, reduxFormProps) : reduxFormProps, rest);
            if (isClassComponent(WrappedComponent)) {
              ;propsToPass.ref = this.saveRef;
            }
            return Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(WrappedComponent, propsToPass);
          }
        }]);

        return Form;
      }(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);

      Form.displayName = 'Form(' + Object(__WEBPACK_IMPORTED_MODULE_22__util_getDisplayName__["a" /* default */])(WrappedComponent) + ')';
      Form.WrappedComponent = WrappedComponent;
      Form.childContextTypes = {
        _reduxForm: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object.isRequired
      };
      Form.propTypes = {
        destroyOnUnmount: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
        forceUnregisterOnUnmount: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
        form: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string.isRequired,
        immutableProps: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string),
        initialValues: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.array, __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object]),
        getFormState: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
        onSubmitFail: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
        onSubmitSuccess: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
        propNamespace: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
        validate: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
        warn: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
        touchOnBlur: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
        touchOnChange: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
        triggerSubmit: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
        persistentSubmitErrors: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
        registeredFields: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.any
      };

      var connector = Object(__WEBPACK_IMPORTED_MODULE_8_react_redux__["b" /* connect */])(function (state, props) {
        var form = props.form,
            getFormState = props.getFormState,
            initialValues = props.initialValues,
            enableReinitialize = props.enableReinitialize,
            keepDirtyOnReinitialize = props.keepDirtyOnReinitialize;

        var formState = getIn(getFormState(state) || empty, form) || empty;
        var stateInitial = getIn(formState, 'initial');
        var initialized = !!stateInitial;

        var shouldUpdateInitialValues = enableReinitialize && initialized && !deepEqual(initialValues, stateInitial);
        var shouldResetValues = shouldUpdateInitialValues && !keepDirtyOnReinitialize;

        var initial = initialValues || stateInitial || empty;

        if (shouldUpdateInitialValues) {
          initial = stateInitial || empty;
        }

        var values = getIn(formState, 'values') || initial;

        if (shouldResetValues) {
          values = initial;
        }

        var pristine = shouldResetValues || deepEqual(initial, values);
        var asyncErrors = getIn(formState, 'asyncErrors');
        var syncErrors = getIn(formState, 'syncErrors') || __WEBPACK_IMPORTED_MODULE_21__structure_plain__["a" /* default */].empty;
        var syncWarnings = getIn(formState, 'syncWarnings') || __WEBPACK_IMPORTED_MODULE_21__structure_plain__["a" /* default */].empty;
        var registeredFields = getIn(formState, 'registeredFields');
        var valid = isValid(form, getFormState, false)(state);
        var validExceptSubmit = isValid(form, getFormState, true)(state);
        var anyTouched = !!getIn(formState, 'anyTouched');
        var submitting = !!getIn(formState, 'submitting');
        var submitFailed = !!getIn(formState, 'submitFailed');
        var submitSucceeded = !!getIn(formState, 'submitSucceeded');
        var error = getIn(formState, 'error');
        var warning = getIn(formState, 'warning');
        var triggerSubmit = getIn(formState, 'triggerSubmit');
        return {
          anyTouched: anyTouched,
          asyncErrors: asyncErrors,
          asyncValidating: getIn(formState, 'asyncValidating') || false,
          dirty: !pristine,
          error: error,
          initialized: initialized,
          invalid: !valid,
          pristine: pristine,
          registeredFields: registeredFields,
          submitting: submitting,
          submitFailed: submitFailed,
          submitSucceeded: submitSucceeded,
          syncErrors: syncErrors,
          syncWarnings: syncWarnings,
          triggerSubmit: triggerSubmit,
          values: values,
          valid: valid,
          validExceptSubmit: validExceptSubmit,
          warning: warning
        };
      }, function (dispatch, initialProps) {
        var bindForm = function bindForm(actionCreator) {
          return actionCreator.bind(null, initialProps.form);
        };

        // Bind the first parameter on `props.form`
        var boundFormACs = Object(__WEBPACK_IMPORTED_MODULE_1_lodash_es_mapValues__["a" /* default */])(formActions, bindForm);
        var boundArrayACs = Object(__WEBPACK_IMPORTED_MODULE_1_lodash_es_mapValues__["a" /* default */])(arrayActions, bindForm);
        var boundBlur = function boundBlur(field, value) {
          return blur(initialProps.form, field, value, !!initialProps.touchOnBlur);
        };
        var boundChange = function boundChange(field, value) {
          return change(initialProps.form, field, value, !!initialProps.touchOnChange, !!initialProps.persistentSubmitErrors);
        };
        var boundFocus = bindForm(focus);

        // Wrap action creators with `dispatch`
        var connectedFormACs = Object(__WEBPACK_IMPORTED_MODULE_9_redux__["b" /* bindActionCreators */])(boundFormACs, dispatch);
        var connectedArrayACs = {
          insert: Object(__WEBPACK_IMPORTED_MODULE_9_redux__["b" /* bindActionCreators */])(boundArrayACs.arrayInsert, dispatch),
          move: Object(__WEBPACK_IMPORTED_MODULE_9_redux__["b" /* bindActionCreators */])(boundArrayACs.arrayMove, dispatch),
          pop: Object(__WEBPACK_IMPORTED_MODULE_9_redux__["b" /* bindActionCreators */])(boundArrayACs.arrayPop, dispatch),
          push: Object(__WEBPACK_IMPORTED_MODULE_9_redux__["b" /* bindActionCreators */])(boundArrayACs.arrayPush, dispatch),
          remove: Object(__WEBPACK_IMPORTED_MODULE_9_redux__["b" /* bindActionCreators */])(boundArrayACs.arrayRemove, dispatch),
          removeAll: Object(__WEBPACK_IMPORTED_MODULE_9_redux__["b" /* bindActionCreators */])(boundArrayACs.arrayRemoveAll, dispatch),
          shift: Object(__WEBPACK_IMPORTED_MODULE_9_redux__["b" /* bindActionCreators */])(boundArrayACs.arrayShift, dispatch),
          splice: Object(__WEBPACK_IMPORTED_MODULE_9_redux__["b" /* bindActionCreators */])(boundArrayACs.arraySplice, dispatch),
          swap: Object(__WEBPACK_IMPORTED_MODULE_9_redux__["b" /* bindActionCreators */])(boundArrayACs.arraySwap, dispatch),
          unshift: Object(__WEBPACK_IMPORTED_MODULE_9_redux__["b" /* bindActionCreators */])(boundArrayACs.arrayUnshift, dispatch)
        };

        var computedActions = _extends({}, connectedFormACs, boundArrayACs, {
          blur: boundBlur,
          change: boundChange,
          array: connectedArrayACs,
          focus: boundFocus,
          dispatch: dispatch
        });

        return function () {
          return computedActions;
        };
      }, undefined, { withRef: true });
      var ConnectedForm = __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics___default()(connector(Form), WrappedComponent);
      ConnectedForm.defaultProps = config;

      // build outer component to expose instance api

      var ReduxForm = function (_Component2) {
        _inherits(ReduxForm, _Component2);

        function ReduxForm() {
          _classCallCheck(this, ReduxForm);

          return _possibleConstructorReturn(this, (ReduxForm.__proto__ || Object.getPrototypeOf(ReduxForm)).apply(this, arguments));
        }

        _createClass(ReduxForm, [{
          key: 'submit',
          value: function submit() {
            return this.ref && this.ref.getWrappedInstance().submit();
          }
        }, {
          key: 'reset',
          value: function reset() {
            if (this.ref) {
              this.ref.getWrappedInstance().reset();
            }
          }
        }, {
          key: 'render',
          value: function render() {
            var _this5 = this;

            var _props10 = this.props,
                initialValues = _props10.initialValues,
                rest = _objectWithoutProperties(_props10, ['initialValues']);

            return Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(ConnectedForm, _extends({}, rest, {
              ref: function ref(_ref3) {
                _this5.ref = _ref3;
              },
              // convert initialValues if need to
              initialValues: fromJS(initialValues)
            }));
          }
        }, {
          key: 'valid',
          get: function get() {
            return !!(this.ref && this.ref.getWrappedInstance().isValid());
          }
        }, {
          key: 'invalid',
          get: function get() {
            return !this.valid;
          }
        }, {
          key: 'pristine',
          get: function get() {
            return !!(this.ref && this.ref.getWrappedInstance().isPristine());
          }
        }, {
          key: 'dirty',
          get: function get() {
            return !this.pristine;
          }
        }, {
          key: 'values',
          get: function get() {
            return this.ref ? this.ref.getWrappedInstance().getValues() : empty;
          }
        }, {
          key: 'fieldList',
          get: function get() {
            // mainly provided for testing
            return this.ref ? this.ref.getWrappedInstance().getFieldList() : [];
          }
        }, {
          key: 'wrappedInstance',
          get: function get() {
            // for testing
            return this.ref && this.ref.getWrappedInstance().wrapped;
          }
        }]);

        return ReduxForm;
      }(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);

      Object(__WEBPACK_IMPORTED_MODULE_3_react_lifecycles_compat__["polyfill"])(ReduxForm);
      return __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics___default()(ReduxForm, WrappedComponent);
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createReduxForm);

/***/ }),
/* 1278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseMerge_js__ = __webpack_require__(1279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createAssigner_js__ = __webpack_require__(1293);



/**
 * This method is like `_.assign` except that it recursively merges own and
 * inherited enumerable string keyed properties of source objects into the
 * destination object. Source properties that resolve to `undefined` are
 * skipped if a destination value exists. Array and plain object properties
 * are merged recursively. Other objects and value types are overridden by
 * assignment. Source objects are applied from left to right. Subsequent
 * sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {
 *   'a': [{ 'b': 2 }, { 'd': 4 }]
 * };
 *
 * var other = {
 *   'a': [{ 'c': 3 }, { 'e': 5 }]
 * };
 *
 * _.merge(object, other);
 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
 */
var merge = Object(__WEBPACK_IMPORTED_MODULE_1__createAssigner_js__["a" /* default */])(function(object, source, srcIndex) {
  Object(__WEBPACK_IMPORTED_MODULE_0__baseMerge_js__["a" /* default */])(object, source, srcIndex);
});

/* harmony default export */ __webpack_exports__["a"] = (merge);


/***/ }),
/* 1279 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Stack_js__ = __webpack_require__(351);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assignMergeValue_js__ = __webpack_require__(565);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__baseFor_js__ = __webpack_require__(559);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__baseMergeDeep_js__ = __webpack_require__(1280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__isObject_js__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__keysIn_js__ = __webpack_require__(568);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__safeGet_js__ = __webpack_require__(567);








/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMerge(object, source, srcIndex, customizer, stack) {
  if (object === source) {
    return;
  }
  Object(__WEBPACK_IMPORTED_MODULE_2__baseFor_js__["a" /* default */])(source, function(srcValue, key) {
    if (Object(__WEBPACK_IMPORTED_MODULE_4__isObject_js__["a" /* default */])(srcValue)) {
      stack || (stack = new __WEBPACK_IMPORTED_MODULE_0__Stack_js__["a" /* default */]);
      Object(__WEBPACK_IMPORTED_MODULE_3__baseMergeDeep_js__["a" /* default */])(object, source, key, srcIndex, baseMerge, customizer, stack);
    }
    else {
      var newValue = customizer
        ? customizer(Object(__WEBPACK_IMPORTED_MODULE_6__safeGet_js__["a" /* default */])(object, key), srcValue, (key + ''), object, source, stack)
        : undefined;

      if (newValue === undefined) {
        newValue = srcValue;
      }
      Object(__WEBPACK_IMPORTED_MODULE_1__assignMergeValue_js__["a" /* default */])(object, key, newValue);
    }
  }, __WEBPACK_IMPORTED_MODULE_5__keysIn_js__["a" /* default */]);
}

/* harmony default export */ __webpack_exports__["a"] = (baseMerge);


/***/ }),
/* 1280 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assignMergeValue_js__ = __webpack_require__(565);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cloneBuffer_js__ = __webpack_require__(1281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cloneTypedArray_js__ = __webpack_require__(1282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__copyArray_js__ = __webpack_require__(545);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__initCloneObject_js__ = __webpack_require__(1284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__isArguments_js__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__isArray_js__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__isArrayLikeObject_js__ = __webpack_require__(1286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__isBuffer_js__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__isFunction_js__ = __webpack_require__(349);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__isObject_js__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__isPlainObject_js__ = __webpack_require__(1287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__isTypedArray_js__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__safeGet_js__ = __webpack_require__(567);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__toPlainObject_js__ = __webpack_require__(1288);
















/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
  var objValue = Object(__WEBPACK_IMPORTED_MODULE_13__safeGet_js__["a" /* default */])(object, key),
      srcValue = Object(__WEBPACK_IMPORTED_MODULE_13__safeGet_js__["a" /* default */])(source, key),
      stacked = stack.get(srcValue);

  if (stacked) {
    Object(__WEBPACK_IMPORTED_MODULE_0__assignMergeValue_js__["a" /* default */])(object, key, stacked);
    return;
  }
  var newValue = customizer
    ? customizer(objValue, srcValue, (key + ''), object, source, stack)
    : undefined;

  var isCommon = newValue === undefined;

  if (isCommon) {
    var isArr = Object(__WEBPACK_IMPORTED_MODULE_6__isArray_js__["a" /* default */])(srcValue),
        isBuff = !isArr && Object(__WEBPACK_IMPORTED_MODULE_8__isBuffer_js__["a" /* default */])(srcValue),
        isTyped = !isArr && !isBuff && Object(__WEBPACK_IMPORTED_MODULE_12__isTypedArray_js__["a" /* default */])(srcValue);

    newValue = srcValue;
    if (isArr || isBuff || isTyped) {
      if (Object(__WEBPACK_IMPORTED_MODULE_6__isArray_js__["a" /* default */])(objValue)) {
        newValue = objValue;
      }
      else if (Object(__WEBPACK_IMPORTED_MODULE_7__isArrayLikeObject_js__["a" /* default */])(objValue)) {
        newValue = Object(__WEBPACK_IMPORTED_MODULE_3__copyArray_js__["a" /* default */])(objValue);
      }
      else if (isBuff) {
        isCommon = false;
        newValue = Object(__WEBPACK_IMPORTED_MODULE_1__cloneBuffer_js__["a" /* default */])(srcValue, true);
      }
      else if (isTyped) {
        isCommon = false;
        newValue = Object(__WEBPACK_IMPORTED_MODULE_2__cloneTypedArray_js__["a" /* default */])(srcValue, true);
      }
      else {
        newValue = [];
      }
    }
    else if (Object(__WEBPACK_IMPORTED_MODULE_11__isPlainObject_js__["a" /* default */])(srcValue) || Object(__WEBPACK_IMPORTED_MODULE_5__isArguments_js__["a" /* default */])(srcValue)) {
      newValue = objValue;
      if (Object(__WEBPACK_IMPORTED_MODULE_5__isArguments_js__["a" /* default */])(objValue)) {
        newValue = Object(__WEBPACK_IMPORTED_MODULE_14__toPlainObject_js__["a" /* default */])(objValue);
      }
      else if (!Object(__WEBPACK_IMPORTED_MODULE_10__isObject_js__["a" /* default */])(objValue) || Object(__WEBPACK_IMPORTED_MODULE_9__isFunction_js__["a" /* default */])(objValue)) {
        newValue = Object(__WEBPACK_IMPORTED_MODULE_4__initCloneObject_js__["a" /* default */])(srcValue);
      }
    }
    else {
      isCommon = false;
    }
  }
  if (isCommon) {
    // Recursively merge objects and arrays (susceptible to call stack limits).
    stack.set(srcValue, newValue);
    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
    stack['delete'](srcValue);
  }
  Object(__WEBPACK_IMPORTED_MODULE_0__assignMergeValue_js__["a" /* default */])(object, key, newValue);
}

/* harmony default export */ __webpack_exports__["a"] = (baseMergeDeep);


/***/ }),
/* 1281 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_js__ = __webpack_require__(75);


/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? __WEBPACK_IMPORTED_MODULE_0__root_js__["a" /* default */].Buffer : undefined,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

  buffer.copy(result);
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (cloneBuffer);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(164)(module)))

/***/ }),
/* 1282 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cloneArrayBuffer_js__ = __webpack_require__(1283);


/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? Object(__WEBPACK_IMPORTED_MODULE_0__cloneArrayBuffer_js__["a" /* default */])(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

/* harmony default export */ __webpack_exports__["a"] = (cloneTypedArray);


/***/ }),
/* 1283 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Uint8Array_js__ = __webpack_require__(552);


/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new __WEBPACK_IMPORTED_MODULE_0__Uint8Array_js__["a" /* default */](result).set(new __WEBPACK_IMPORTED_MODULE_0__Uint8Array_js__["a" /* default */](arrayBuffer));
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (cloneArrayBuffer);


/***/ }),
/* 1284 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseCreate_js__ = __webpack_require__(1285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getPrototype_js__ = __webpack_require__(566);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isPrototype_js__ = __webpack_require__(242);




/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !Object(__WEBPACK_IMPORTED_MODULE_2__isPrototype_js__["a" /* default */])(object))
    ? Object(__WEBPACK_IMPORTED_MODULE_0__baseCreate_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1__getPrototype_js__["a" /* default */])(object))
    : {};
}

/* harmony default export */ __webpack_exports__["a"] = (initCloneObject);


/***/ }),
/* 1285 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isObject_js__ = __webpack_require__(97);


/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = (function() {
  function object() {}
  return function(proto) {
    if (!Object(__WEBPACK_IMPORTED_MODULE_0__isObject_js__["a" /* default */])(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

/* harmony default export */ __webpack_exports__["a"] = (baseCreate);


/***/ }),
/* 1286 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isArrayLike_js__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__ = __webpack_require__(110);



/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__["a" /* default */])(value) && Object(__WEBPACK_IMPORTED_MODULE_0__isArrayLike_js__["a" /* default */])(value);
}

/* harmony default export */ __webpack_exports__["a"] = (isArrayLikeObject);


/***/ }),
/* 1287 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getPrototype_js__ = __webpack_require__(566);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__ = __webpack_require__(110);




/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__["a" /* default */])(value) || Object(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value) != objectTag) {
    return false;
  }
  var proto = Object(__WEBPACK_IMPORTED_MODULE_1__getPrototype_js__["a" /* default */])(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

/* harmony default export */ __webpack_exports__["a"] = (isPlainObject);


/***/ }),
/* 1288 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__copyObject_js__ = __webpack_require__(1289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__keysIn_js__ = __webpack_require__(568);



/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */
function toPlainObject(value) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__copyObject_js__["a" /* default */])(value, Object(__WEBPACK_IMPORTED_MODULE_1__keysIn_js__["a" /* default */])(value));
}

/* harmony default export */ __webpack_exports__["a"] = (toPlainObject);


/***/ }),
/* 1289 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assignValue_js__ = __webpack_require__(1290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseAssignValue_js__ = __webpack_require__(243);



/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      Object(__WEBPACK_IMPORTED_MODULE_1__baseAssignValue_js__["a" /* default */])(object, key, newValue);
    } else {
      Object(__WEBPACK_IMPORTED_MODULE_0__assignValue_js__["a" /* default */])(object, key, newValue);
    }
  }
  return object;
}

/* harmony default export */ __webpack_exports__["a"] = (copyObject);


/***/ }),
/* 1290 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseAssignValue_js__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__eq_js__ = __webpack_require__(178);



/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && Object(__WEBPACK_IMPORTED_MODULE_1__eq_js__["a" /* default */])(objValue, value)) ||
      (value === undefined && !(key in object))) {
    Object(__WEBPACK_IMPORTED_MODULE_0__baseAssignValue_js__["a" /* default */])(object, key, value);
  }
}

/* harmony default export */ __webpack_exports__["a"] = (assignValue);


/***/ }),
/* 1291 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isObject_js__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isPrototype_js__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__nativeKeysIn_js__ = __webpack_require__(1292);




/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_0__isObject_js__["a" /* default */])(object)) {
    return Object(__WEBPACK_IMPORTED_MODULE_2__nativeKeysIn_js__["a" /* default */])(object);
  }
  var isProto = Object(__WEBPACK_IMPORTED_MODULE_1__isPrototype_js__["a" /* default */])(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (baseKeysIn);


/***/ }),
/* 1292 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (nativeKeysIn);


/***/ }),
/* 1293 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseRest_js__ = __webpack_require__(1294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isIterateeCall_js__ = __webpack_require__(1301);



/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__baseRest_js__["a" /* default */])(function(object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = (assigner.length > 3 && typeof customizer == 'function')
      ? (length--, customizer)
      : undefined;

    if (guard && Object(__WEBPACK_IMPORTED_MODULE_1__isIterateeCall_js__["a" /* default */])(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

/* harmony default export */ __webpack_exports__["a"] = (createAssigner);


/***/ }),
/* 1294 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__identity_js__ = __webpack_require__(357);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__overRest_js__ = __webpack_require__(1295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__setToString_js__ = __webpack_require__(1297);




/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  return Object(__WEBPACK_IMPORTED_MODULE_2__setToString_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1__overRest_js__["a" /* default */])(func, start, __WEBPACK_IMPORTED_MODULE_0__identity_js__["a" /* default */]), func + '');
}

/* harmony default export */ __webpack_exports__["a"] = (baseRest);


/***/ }),
/* 1295 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__apply_js__ = __webpack_require__(1296);


/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return Object(__WEBPACK_IMPORTED_MODULE_0__apply_js__["a" /* default */])(func, this, otherArgs);
  };
}

/* harmony default export */ __webpack_exports__["a"] = (overRest);


/***/ }),
/* 1296 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

/* harmony default export */ __webpack_exports__["a"] = (apply);


/***/ }),
/* 1297 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseSetToString_js__ = __webpack_require__(1298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shortOut_js__ = __webpack_require__(1300);



/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = Object(__WEBPACK_IMPORTED_MODULE_1__shortOut_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0__baseSetToString_js__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (setToString);


/***/ }),
/* 1298 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constant_js__ = __webpack_require__(1299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__defineProperty_js__ = __webpack_require__(558);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__identity_js__ = __webpack_require__(357);




/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !__WEBPACK_IMPORTED_MODULE_1__defineProperty_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_2__identity_js__["a" /* default */] : function(func, string) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__defineProperty_js__["a" /* default */])(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': Object(__WEBPACK_IMPORTED_MODULE_0__constant_js__["a" /* default */])(string),
    'writable': true
  });
};

/* harmony default export */ __webpack_exports__["a"] = (baseSetToString);


/***/ }),
/* 1299 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

/* harmony default export */ __webpack_exports__["a"] = (constant);


/***/ }),
/* 1300 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

/* harmony default export */ __webpack_exports__["a"] = (shortOut);


/***/ }),
/* 1301 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__eq_js__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isArrayLike_js__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isIndex_js__ = __webpack_require__(353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isObject_js__ = __webpack_require__(97);





/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_3__isObject_js__["a" /* default */])(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (Object(__WEBPACK_IMPORTED_MODULE_1__isArrayLike_js__["a" /* default */])(object) && Object(__WEBPACK_IMPORTED_MODULE_2__isIndex_js__["a" /* default */])(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__eq_js__["a" /* default */])(object[index], value);
  }
  return false;
}

/* harmony default export */ __webpack_exports__["a"] = (isIterateeCall);


/***/ }),
/* 1302 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_is_promise__ = __webpack_require__(359);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_is_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_is_promise__);


var asyncValidation = function asyncValidation(fn, start, stop, field) {
  start(field);
  var promise = fn();
  if (!__WEBPACK_IMPORTED_MODULE_0_is_promise___default()(promise)) {
    throw new Error('asyncValidate function passed to reduxForm must return a promise');
  }
  var handleErrors = function handleErrors(rejected) {
    return function (errors) {
      if (rejected) {
        if (errors && Object.keys(errors).length) {
          stop(errors);
          return errors;
        } else {
          stop();
          throw new Error('Asynchronous validation promise was rejected without errors.');
        }
      }
      stop();
      return Promise.resolve();
    };
  };
  return promise.then(handleErrors(false), handleErrors(true));
};

/* harmony default export */ __webpack_exports__["a"] = (asyncValidation);

/***/ }),
/* 1303 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__silenceEvent__ = __webpack_require__(569);


var silenceEvents = function silenceEvents(fn) {
  return function (event) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return Object(__WEBPACK_IMPORTED_MODULE_0__silenceEvent__["a" /* default */])(event) ? fn.apply(undefined, args) : fn.apply(undefined, [event].concat(args));
  };
};

/* harmony default export */ __webpack_exports__["a"] = (silenceEvents);

/***/ }),
/* 1304 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__structure_plain__ = __webpack_require__(28);



var toArray = function toArray(value) {
  return Array.isArray(value) ? value : [value];
};

var getError = function getError(value, values, props, validators, name) {
  var array = toArray(validators);
  for (var i = 0; i < array.length; i++) {
    var error = array[i](value, values, props, name);
    if (error) {
      return error;
    }
  }
};

var generateValidator = function generateValidator(validators, _ref) {
  var getIn = _ref.getIn;
  return function (values, props) {
    var errors = {};
    Object.keys(validators).forEach(function (name) {
      var value = getIn(values, name);
      var error = getError(value, values, props, validators[name], name);
      if (error) {
        errors = __WEBPACK_IMPORTED_MODULE_0__structure_plain__["a" /* default */].setIn(errors, name, error);
      }
    });
    return errors;
  };
};

/* harmony default export */ __webpack_exports__["a"] = (generateValidator);

/***/ }),
/* 1305 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_is_promise__ = __webpack_require__(359);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_is_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_is_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SubmissionError__ = __webpack_require__(534);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }





var handleSubmit = function handleSubmit(submit, props, valid, asyncValidate, fields) {
  var dispatch = props.dispatch,
      onSubmitFail = props.onSubmitFail,
      onSubmitSuccess = props.onSubmitSuccess,
      startSubmit = props.startSubmit,
      stopSubmit = props.stopSubmit,
      setSubmitFailed = props.setSubmitFailed,
      setSubmitSucceeded = props.setSubmitSucceeded,
      syncErrors = props.syncErrors,
      asyncErrors = props.asyncErrors,
      touch = props.touch,
      values = props.values,
      persistentSubmitErrors = props.persistentSubmitErrors;


  touch.apply(undefined, _toConsumableArray(fields)); // mark all fields as touched

  if (valid || persistentSubmitErrors) {
    var doSubmit = function doSubmit() {
      var result = void 0;
      try {
        result = submit(values, dispatch, props);
      } catch (submitError) {
        var error = submitError instanceof __WEBPACK_IMPORTED_MODULE_1__SubmissionError__["a" /* default */] ? submitError.errors : undefined;
        stopSubmit(error);
        setSubmitFailed.apply(undefined, _toConsumableArray(fields));
        if (onSubmitFail) {
          onSubmitFail(error, dispatch, submitError, props);
        }
        if (error || onSubmitFail) {
          // if you've provided an onSubmitFail callback, don't re-throw the error
          return error;
        } else {
          throw submitError;
        }
      }
      if (__WEBPACK_IMPORTED_MODULE_0_is_promise___default()(result)) {
        startSubmit();
        return result.then(function (submitResult) {
          stopSubmit();
          setSubmitSucceeded();
          if (onSubmitSuccess) {
            onSubmitSuccess(submitResult, dispatch, props);
          }
          return submitResult;
        }, function (submitError) {
          var error = submitError instanceof __WEBPACK_IMPORTED_MODULE_1__SubmissionError__["a" /* default */] ? submitError.errors : undefined;
          stopSubmit(error);
          setSubmitFailed.apply(undefined, _toConsumableArray(fields));
          if (onSubmitFail) {
            onSubmitFail(error, dispatch, submitError, props);
          }
          if (error || onSubmitFail) {
            // if you've provided an onSubmitFail callback, don't re-throw the error
            return error;
          } else {
            throw submitError;
          }
        });
      } else {
        setSubmitSucceeded();
        if (onSubmitSuccess) {
          onSubmitSuccess(result, dispatch, props);
        }
      }
      return result;
    };

    var asyncValidateResult = asyncValidate && asyncValidate();
    if (asyncValidateResult) {
      return asyncValidateResult.then(function (asyncErrors) {
        if (asyncErrors) {
          throw asyncErrors;
        }
        return doSubmit();
      }).catch(function (asyncErrors) {
        setSubmitFailed.apply(undefined, _toConsumableArray(fields));
        if (onSubmitFail) {
          onSubmitFail(asyncErrors, dispatch, null, props);
        }
        return Promise.reject(asyncErrors);
      });
    } else {
      return doSubmit();
    }
  } else {
    setSubmitFailed.apply(undefined, _toConsumableArray(fields));
    var errors = _extends({}, asyncErrors, syncErrors);
    if (onSubmitFail) {
      onSubmitFail(errors, dispatch, null, props);
    }
    return errors;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (handleSubmit);

/***/ }),
/* 1306 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


var getDisplayName = function getDisplayName(Comp) {
  return Comp.displayName || Comp.name || 'Component';
};


/* harmony default export */ __webpack_exports__["a"] = (getDisplayName);

/***/ }),
/* 1307 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {var isHotReloading = function isHotReloading() {
  return !!(typeof module !== 'undefined' && module.hot && typeof module.hot.status === 'function' && module.hot.status() === 'apply');
};

/* harmony default export */ __webpack_exports__["a"] = (isHotReloading);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(164)(module)))

/***/ }),
/* 1308 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createReducer__ = __webpack_require__(1309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(28);



/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__createReducer__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 1309 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actionTypes__ = __webpack_require__(344);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__deleteInWithCleanUp__ = __webpack_require__(1310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__structure_plain__ = __webpack_require__(28);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






var shouldDelete = function shouldDelete(_ref) {
  var getIn = _ref.getIn;
  return function (state, path) {
    var initialValuesPath = null;

    if (path.startsWith('values')) {
      initialValuesPath = path.replace('values', 'initial');
    }

    var initialValueComparison = initialValuesPath ? getIn(state, initialValuesPath) === undefined : true;

    return getIn(state, path) !== undefined && initialValueComparison;
  };
};

var isReduxFormAction = function isReduxFormAction(action) {
  return action && action.type && action.type.length > __WEBPACK_IMPORTED_MODULE_0__actionTypes__["prefix"].length && action.type.substring(0, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["prefix"].length) === __WEBPACK_IMPORTED_MODULE_0__actionTypes__["prefix"];
};

function createReducer(structure) {
  var _behaviors;

  var deepEqual = structure.deepEqual,
      empty = structure.empty,
      forEach = structure.forEach,
      getIn = structure.getIn,
      setIn = structure.setIn,
      deleteIn = structure.deleteIn,
      fromJS = structure.fromJS,
      keys = structure.keys,
      size = structure.size,
      some = structure.some,
      splice = structure.splice;

  var deleteInWithCleanUp = Object(__WEBPACK_IMPORTED_MODULE_1__deleteInWithCleanUp__["a" /* default */])(structure)(shouldDelete);
  var plainDeleteInWithCleanUp = Object(__WEBPACK_IMPORTED_MODULE_1__deleteInWithCleanUp__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_2__structure_plain__["a" /* default */])(shouldDelete);
  var doSplice = function doSplice(state, key, field, index, removeNum, value, force) {
    var existing = getIn(state, key + '.' + field);
    return existing || force ? setIn(state, key + '.' + field, splice(existing, index, removeNum, value)) : state;
  };
  var doPlainSplice = function doPlainSplice(state, key, field, index, removeNum, value, force) {
    var slice = getIn(state, key);
    var existing = __WEBPACK_IMPORTED_MODULE_2__structure_plain__["a" /* default */].getIn(slice, field);
    return existing || force ? setIn(state, key, __WEBPACK_IMPORTED_MODULE_2__structure_plain__["a" /* default */].setIn(slice, field, __WEBPACK_IMPORTED_MODULE_2__structure_plain__["a" /* default */].splice(existing, index, removeNum, value))) : state;
  };
  var rootKeys = ['values', 'fields', 'submitErrors', 'asyncErrors'];
  var arraySplice = function arraySplice(state, field, index, removeNum, value) {
    var result = state;
    var nonValuesValue = value != null ? empty : undefined;
    result = doSplice(result, 'values', field, index, removeNum, value, true);
    result = doSplice(result, 'fields', field, index, removeNum, nonValuesValue);
    result = doPlainSplice(result, 'syncErrors', field, index, removeNum, undefined);
    result = doPlainSplice(result, 'syncWarnings', field, index, removeNum, undefined);
    result = doSplice(result, 'submitErrors', field, index, removeNum, undefined);
    result = doSplice(result, 'asyncErrors', field, index, removeNum, undefined);
    return result;
  };

  var behaviors = (_behaviors = {}, _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["ARRAY_INSERT"], function (state, _ref2) {
    var _ref2$meta = _ref2.meta,
        field = _ref2$meta.field,
        index = _ref2$meta.index,
        payload = _ref2.payload;

    return arraySplice(state, field, index, 0, payload);
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["ARRAY_MOVE"], function (state, _ref3) {
    var _ref3$meta = _ref3.meta,
        field = _ref3$meta.field,
        from = _ref3$meta.from,
        to = _ref3$meta.to;

    var array = getIn(state, 'values.' + field);
    var length = array ? size(array) : 0;
    var result = state;
    if (length) {
      rootKeys.forEach(function (key) {
        var path = key + '.' + field;
        if (getIn(result, path)) {
          var value = getIn(result, path + '[' + from + ']');
          result = setIn(result, path, splice(getIn(result, path), from, 1)); // remove
          result = setIn(result, path, splice(getIn(result, path), to, 0, value)); // insert
        }
      });
    }
    return result;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["ARRAY_POP"], function (state, _ref4) {
    var field = _ref4.meta.field;

    var array = getIn(state, 'values.' + field);
    var length = array ? size(array) : 0;
    return length ? arraySplice(state, field, length - 1, 1) : state;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["ARRAY_PUSH"], function (state, _ref5) {
    var field = _ref5.meta.field,
        payload = _ref5.payload;

    var array = getIn(state, 'values.' + field);
    var length = array ? size(array) : 0;
    return arraySplice(state, field, length, 0, payload);
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["ARRAY_REMOVE"], function (state, _ref6) {
    var _ref6$meta = _ref6.meta,
        field = _ref6$meta.field,
        index = _ref6$meta.index;

    return arraySplice(state, field, index, 1);
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["ARRAY_REMOVE_ALL"], function (state, _ref7) {
    var field = _ref7.meta.field;

    var array = getIn(state, 'values.' + field);
    var length = array ? size(array) : 0;
    return length ? arraySplice(state, field, 0, length) : state;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["ARRAY_SHIFT"], function (state, _ref8) {
    var field = _ref8.meta.field;

    return arraySplice(state, field, 0, 1);
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["ARRAY_SPLICE"], function (state, _ref9) {
    var _ref9$meta = _ref9.meta,
        field = _ref9$meta.field,
        index = _ref9$meta.index,
        removeNum = _ref9$meta.removeNum,
        payload = _ref9.payload;

    return arraySplice(state, field, index, removeNum, payload);
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["ARRAY_SWAP"], function (state, _ref10) {
    var _ref10$meta = _ref10.meta,
        field = _ref10$meta.field,
        indexA = _ref10$meta.indexA,
        indexB = _ref10$meta.indexB;

    var result = state;
    rootKeys.forEach(function (key) {
      var valueA = getIn(result, key + '.' + field + '[' + indexA + ']');
      var valueB = getIn(result, key + '.' + field + '[' + indexB + ']');
      if (valueA !== undefined || valueB !== undefined) {
        result = setIn(result, key + '.' + field + '[' + indexA + ']', valueB);
        result = setIn(result, key + '.' + field + '[' + indexB + ']', valueA);
      }
    });
    return result;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["ARRAY_UNSHIFT"], function (state, _ref11) {
    var field = _ref11.meta.field,
        payload = _ref11.payload;

    return arraySplice(state, field, 0, 0, payload);
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["AUTOFILL"], function (state, _ref12) {
    var field = _ref12.meta.field,
        payload = _ref12.payload;

    var result = state;
    result = deleteInWithCleanUp(result, 'asyncErrors.' + field);
    result = deleteInWithCleanUp(result, 'submitErrors.' + field);
    result = setIn(result, 'fields.' + field + '.autofilled', true);
    result = setIn(result, 'values.' + field, payload);
    return result;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["BLUR"], function (state, _ref13) {
    var _ref13$meta = _ref13.meta,
        field = _ref13$meta.field,
        touch = _ref13$meta.touch,
        payload = _ref13.payload;

    var result = state;
    var initial = getIn(result, 'initial.' + field);
    if (initial === undefined && payload === '') {
      result = deleteInWithCleanUp(result, 'values.' + field);
    } else if (payload !== undefined) {
      result = setIn(result, 'values.' + field, payload);
    }
    if (field === getIn(result, 'active')) {
      result = deleteIn(result, 'active');
    }
    result = deleteIn(result, 'fields.' + field + '.active');
    if (touch) {
      result = setIn(result, 'fields.' + field + '.touched', true);
      result = setIn(result, 'anyTouched', true);
    }
    return result;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["CHANGE"], function (state, _ref14) {
    var _ref14$meta = _ref14.meta,
        field = _ref14$meta.field,
        touch = _ref14$meta.touch,
        persistentSubmitErrors = _ref14$meta.persistentSubmitErrors,
        payload = _ref14.payload;

    var result = state;
    var initial = getIn(result, 'initial.' + field);
    if (initial === undefined && payload === '') {
      result = deleteInWithCleanUp(result, 'values.' + field);
    } else if (payload !== undefined) {
      result = setIn(result, 'values.' + field, payload);
    }
    result = deleteInWithCleanUp(result, 'asyncErrors.' + field);
    if (!persistentSubmitErrors) {
      result = deleteInWithCleanUp(result, 'submitErrors.' + field);
    }
    result = deleteInWithCleanUp(result, 'fields.' + field + '.autofilled');
    if (touch) {
      result = setIn(result, 'fields.' + field + '.touched', true);
      result = setIn(result, 'anyTouched', true);
    }
    return result;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["CLEAR_SUBMIT"], function (state) {
    return deleteIn(state, 'triggerSubmit');
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["CLEAR_SUBMIT_ERRORS"], function (state) {
    var result = state;
    result = deleteInWithCleanUp(result, 'submitErrors');
    result = deleteIn(result, 'error');
    return result;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["CLEAR_ASYNC_ERROR"], function (state, _ref15) {
    var field = _ref15.meta.field;

    return deleteIn(state, 'asyncErrors.' + field);
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["CLEAR_FIELDS"], function (state, _ref16) {
    var _ref16$meta = _ref16.meta,
        keepTouched = _ref16$meta.keepTouched,
        persistentSubmitErrors = _ref16$meta.persistentSubmitErrors,
        fields = _ref16$meta.fields;

    var result = state;
    fields.forEach(function (field) {
      result = deleteInWithCleanUp(result, 'values.' + field);
      result = deleteInWithCleanUp(result, 'asyncErrors.' + field);
      if (!persistentSubmitErrors) {
        result = deleteInWithCleanUp(result, 'submitErrors.' + field);
      }
      result = deleteInWithCleanUp(result, 'fields.' + field + '.autofilled');
      if (!keepTouched) {
        result = deleteIn(result, 'fields.' + field + '.touched');
      }
    });
    var anyTouched = some(keys(getIn(result, 'registeredFields')), function (key) {
      return getIn(result, 'fields.' + key + '.touched');
    });
    result = anyTouched ? setIn(result, 'anyTouched', true) : deleteIn(result, 'anyTouched');
    return result;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["FOCUS"], function (state, _ref17) {
    var field = _ref17.meta.field;

    var result = state;
    var previouslyActive = getIn(state, 'active');
    result = deleteIn(result, 'fields.' + previouslyActive + '.active');
    result = setIn(result, 'fields.' + field + '.visited', true);
    result = setIn(result, 'fields.' + field + '.active', true);
    result = setIn(result, 'active', field);
    return result;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["INITIALIZE"], function (state, _ref18) {
    var payload = _ref18.payload,
        _ref18$meta = _ref18.meta,
        keepDirty = _ref18$meta.keepDirty,
        keepSubmitSucceeded = _ref18$meta.keepSubmitSucceeded,
        updateUnregisteredFields = _ref18$meta.updateUnregisteredFields,
        keepValues = _ref18$meta.keepValues;

    var mapData = fromJS(payload);
    var result = empty; // clean all field state

    // persist old warnings, they will get recalculated if the new form values are different from the old values
    var warning = getIn(state, 'warning');
    if (warning) {
      result = setIn(result, 'warning', warning);
    }
    var syncWarnings = getIn(state, 'syncWarnings');
    if (syncWarnings) {
      result = setIn(result, 'syncWarnings', syncWarnings);
    }

    // persist old errors, they will get recalculated if the new form values are different from the old values
    var error = getIn(state, 'error');
    if (error) {
      result = setIn(result, 'error', error);
    }
    var syncErrors = getIn(state, 'syncErrors');
    if (syncErrors) {
      result = setIn(result, 'syncErrors', syncErrors);
    }

    var registeredFields = getIn(state, 'registeredFields');
    if (registeredFields) {
      result = setIn(result, 'registeredFields', registeredFields);
    }

    var previousValues = getIn(state, 'values');
    var previousInitialValues = getIn(state, 'initial');

    var newInitialValues = mapData;
    var newValues = previousValues;

    if (keepDirty && registeredFields) {
      if (!deepEqual(newInitialValues, previousInitialValues)) {
        //
        // Keep the value of dirty fields while updating the value of
        // pristine fields. This way, apps can reinitialize forms while
        // avoiding stomping on user edits.
        //
        // Note 1: The initialize action replaces all initial values
        // regardless of keepDirty.
        //
        // Note 2: When a field is dirty, keepDirty is enabled, and the field
        // value is the same as the new initial value for the field, the
        // initialize action causes the field to become pristine. That effect
        // is what we want.
        //
        var overwritePristineValue = function overwritePristineValue(name) {
          var previousInitialValue = getIn(previousInitialValues, name);
          var previousValue = getIn(previousValues, name);

          if (deepEqual(previousValue, previousInitialValue)) {
            // Overwrite the old pristine value with the new pristine value
            var newInitialValue = getIn(newInitialValues, name);

            // This check prevents any 'setIn' call that would create useless
            // nested objects, since the path to the new field value would
            // evaluate to the same (especially for undefined values)
            if (getIn(newValues, name) !== newInitialValue) {
              newValues = setIn(newValues, name, newInitialValue);
            }
          }
        };

        if (!updateUnregisteredFields) {
          forEach(keys(registeredFields), function (name) {
            return overwritePristineValue(name);
          });
        }

        forEach(keys(newInitialValues), function (name) {
          var previousInitialValue = getIn(previousInitialValues, name);
          if (typeof previousInitialValue === 'undefined') {
            // Add new values at the root level.
            var newInitialValue = getIn(newInitialValues, name);
            newValues = setIn(newValues, name, newInitialValue);
          }

          if (updateUnregisteredFields) {
            overwritePristineValue(name);
          }
        });
      }
    } else {
      newValues = newInitialValues;
    }

    if (keepValues) {
      forEach(keys(previousValues), function (name) {
        var previousValue = getIn(previousValues, name);

        newValues = setIn(newValues, name, previousValue);
      });

      forEach(keys(previousInitialValues), function (name) {
        var previousInitialValue = getIn(previousInitialValues, name);

        newInitialValues = setIn(newInitialValues, name, previousInitialValue);
      });
    }

    if (keepSubmitSucceeded && getIn(state, 'submitSucceeded')) {
      result = setIn(result, 'submitSucceeded', true);
    }
    result = setIn(result, 'values', newValues);
    result = setIn(result, 'initial', newInitialValues);
    return result;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["REGISTER_FIELD"], function (state, _ref19) {
    var _ref19$payload = _ref19.payload,
        name = _ref19$payload.name,
        type = _ref19$payload.type;

    var key = 'registeredFields[\'' + name + '\']';
    var field = getIn(state, key);
    if (field) {
      var count = getIn(field, 'count') + 1;
      field = setIn(field, 'count', count);
    } else {
      field = fromJS({ name: name, type: type, count: 1 });
    }
    return setIn(state, key, field);
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["RESET"], function (state) {
    var result = empty;
    var registeredFields = getIn(state, 'registeredFields');
    if (registeredFields) {
      result = setIn(result, 'registeredFields', registeredFields);
    }
    var values = getIn(state, 'initial');
    if (values) {
      result = setIn(result, 'values', values);
      result = setIn(result, 'initial', values);
    }
    return result;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["RESET_SECTION"], function (state, _ref20) {
    var sections = _ref20.meta.sections;

    var result = state;

    sections.forEach(function (section) {
      result = deleteInWithCleanUp(result, 'asyncErrors.' + section);
      result = deleteInWithCleanUp(result, 'submitErrors.' + section);
      result = deleteInWithCleanUp(result, 'fields.' + section);

      var values = getIn(state, 'initial.' + section);
      result = values ? setIn(result, 'values.' + section, values) : deleteInWithCleanUp(result, 'values.' + section);
    });

    var anyTouched = some(keys(getIn(result, 'registeredFields')), function (key) {
      return getIn(result, 'fields.' + key + '.touched');
    });
    result = anyTouched ? setIn(result, 'anyTouched', true) : deleteIn(result, 'anyTouched');

    return result;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["SUBMIT"], function (state) {
    return setIn(state, 'triggerSubmit', true);
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["START_ASYNC_VALIDATION"], function (state, _ref21) {
    var field = _ref21.meta.field;

    return setIn(state, 'asyncValidating', field || true);
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["START_SUBMIT"], function (state) {
    return setIn(state, 'submitting', true);
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["STOP_ASYNC_VALIDATION"], function (state, _ref22) {
    var payload = _ref22.payload;

    var result = state;
    result = deleteIn(result, 'asyncValidating');
    if (payload && Object.keys(payload).length) {
      var _error = payload._error,
          fieldErrors = _objectWithoutProperties(payload, ['_error']);

      if (_error) {
        result = setIn(result, 'error', _error);
      }
      if (Object.keys(fieldErrors).length) {
        result = setIn(result, 'asyncErrors', fromJS(fieldErrors));
      }
    } else {
      result = deleteIn(result, 'error');
      result = deleteIn(result, 'asyncErrors');
    }
    return result;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["STOP_SUBMIT"], function (state, _ref23) {
    var payload = _ref23.payload;

    var result = state;
    result = deleteIn(result, 'submitting');
    result = deleteIn(result, 'submitFailed');
    result = deleteIn(result, 'submitSucceeded');
    if (payload && Object.keys(payload).length) {
      var _error = payload._error,
          fieldErrors = _objectWithoutProperties(payload, ['_error']);

      if (_error) {
        result = setIn(result, 'error', _error);
      } else {
        result = deleteIn(result, 'error');
      }
      if (Object.keys(fieldErrors).length) {
        result = setIn(result, 'submitErrors', fromJS(fieldErrors));
      } else {
        result = deleteIn(result, 'submitErrors');
      }
      result = setIn(result, 'submitFailed', true);
    } else {
      result = deleteIn(result, 'error');
      result = deleteIn(result, 'submitErrors');
    }
    return result;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["SET_SUBMIT_FAILED"], function (state, _ref24) {
    var fields = _ref24.meta.fields;

    var result = state;
    result = setIn(result, 'submitFailed', true);
    result = deleteIn(result, 'submitSucceeded');
    result = deleteIn(result, 'submitting');
    fields.forEach(function (field) {
      return result = setIn(result, 'fields.' + field + '.touched', true);
    });
    if (fields.length) {
      result = setIn(result, 'anyTouched', true);
    }
    return result;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["SET_SUBMIT_SUCCEEDED"], function (state) {
    var result = state;
    result = deleteIn(result, 'submitFailed');
    result = setIn(result, 'submitSucceeded', true);
    return result;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["TOUCH"], function (state, _ref25) {
    var fields = _ref25.meta.fields;

    var result = state;
    fields.forEach(function (field) {
      return result = setIn(result, 'fields.' + field + '.touched', true);
    });
    result = setIn(result, 'anyTouched', true);
    return result;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["UNREGISTER_FIELD"], function (state, _ref26) {
    var _ref26$payload = _ref26.payload,
        name = _ref26$payload.name,
        destroyOnUnmount = _ref26$payload.destroyOnUnmount;

    var result = state;
    var key = 'registeredFields[\'' + name + '\']';
    var field = getIn(result, key);
    if (!field) {
      return result;
    }

    var count = getIn(field, 'count') - 1;
    if (count <= 0 && destroyOnUnmount) {
      // Note: Cannot use deleteWithCleanUp here because of the flat nature of registeredFields
      result = deleteIn(result, key);
      if (deepEqual(getIn(result, 'registeredFields'), empty)) {
        result = deleteIn(result, 'registeredFields');
      }
      var syncErrors = getIn(result, 'syncErrors');
      if (syncErrors) {
        syncErrors = plainDeleteInWithCleanUp(syncErrors, name);
        if (__WEBPACK_IMPORTED_MODULE_2__structure_plain__["a" /* default */].deepEqual(syncErrors, __WEBPACK_IMPORTED_MODULE_2__structure_plain__["a" /* default */].empty)) {
          result = deleteIn(result, 'syncErrors');
        } else {
          result = setIn(result, 'syncErrors', syncErrors);
        }
      }
      var syncWarnings = getIn(result, 'syncWarnings');
      if (syncWarnings) {
        syncWarnings = plainDeleteInWithCleanUp(syncWarnings, name);
        if (__WEBPACK_IMPORTED_MODULE_2__structure_plain__["a" /* default */].deepEqual(syncWarnings, __WEBPACK_IMPORTED_MODULE_2__structure_plain__["a" /* default */].empty)) {
          result = deleteIn(result, 'syncWarnings');
        } else {
          result = setIn(result, 'syncWarnings', syncWarnings);
        }
      }
      result = deleteInWithCleanUp(result, 'submitErrors.' + name);
      result = deleteInWithCleanUp(result, 'asyncErrors.' + name);
    } else {
      field = setIn(field, 'count', count);
      result = setIn(result, key, field);
    }
    return result;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["UNTOUCH"], function (state, _ref27) {
    var fields = _ref27.meta.fields;

    var result = state;
    fields.forEach(function (field) {
      return result = deleteIn(result, 'fields.' + field + '.touched');
    });
    var anyTouched = some(keys(getIn(result, 'registeredFields')), function (key) {
      return getIn(result, 'fields.' + key + '.touched');
    });
    result = anyTouched ? setIn(result, 'anyTouched', true) : deleteIn(result, 'anyTouched');
    return result;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["UPDATE_SYNC_ERRORS"], function (state, _ref28) {
    var _ref28$payload = _ref28.payload,
        syncErrors = _ref28$payload.syncErrors,
        error = _ref28$payload.error;

    var result = state;
    if (error) {
      result = setIn(result, 'error', error);
      result = setIn(result, 'syncError', true);
    } else {
      result = deleteIn(result, 'error');
      result = deleteIn(result, 'syncError');
    }
    if (Object.keys(syncErrors).length) {
      result = setIn(result, 'syncErrors', syncErrors);
    } else {
      result = deleteIn(result, 'syncErrors');
    }
    return result;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["UPDATE_SYNC_WARNINGS"], function (state, _ref29) {
    var _ref29$payload = _ref29.payload,
        syncWarnings = _ref29$payload.syncWarnings,
        warning = _ref29$payload.warning;

    var result = state;
    if (warning) {
      result = setIn(result, 'warning', warning);
    } else {
      result = deleteIn(result, 'warning');
    }
    if (Object.keys(syncWarnings).length) {
      result = setIn(result, 'syncWarnings', syncWarnings);
    } else {
      result = deleteIn(result, 'syncWarnings');
    }
    return result;
  }), _behaviors);

  var reducer = function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : empty;
    var action = arguments[1];

    var behavior = behaviors[action.type];
    return behavior ? behavior(state, action) : state;
  };

  var byForm = function byForm(reducer) {
    return function () {
      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : empty;
      var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { type: 'NONE' };

      var form = action && action.meta && action.meta.form;
      if (!form || !isReduxFormAction(action)) {
        return state;
      }
      if (action.type === __WEBPACK_IMPORTED_MODULE_0__actionTypes__["DESTROY"] && action.meta && action.meta.form) {
        return action.meta.form.reduce(function (result, form) {
          return deleteInWithCleanUp(result, form);
        }, state);
      }
      var formState = getIn(state, form);
      var result = reducer(formState, action);
      return result === formState ? state : setIn(state, form, result);
    };
  };

  /**
   * Adds additional functionality to the reducer
   */
  function decorate(target) {
    target.plugin = function (reducers) {
      var _this = this;

      // use 'function' keyword to enable 'this'
      return decorate(function () {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : empty;
        var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { type: 'NONE' };

        var callPlugin = function callPlugin(processed, key) {
          var previousState = getIn(processed, key);
          var nextState = reducers[key](previousState, action, getIn(state, key));
          return nextState !== previousState ? setIn(processed, key, nextState) : processed;
        };

        var processed = _this(state, action); // run through redux-form reducer
        var form = action && action.meta && action.meta.form;

        if (form) {
          // this is an action aimed at forms, so only give it to the specified form's plugin
          return reducers[form] ? callPlugin(processed, form) : processed;
        } else {
          // this is not a form-specific action, so send it to all the plugins
          return Object.keys(reducers).reduce(callPlugin, processed);
        }
      });
    };

    return target;
  }

  return decorate(byForm(reducer));
}

/* harmony default export */ __webpack_exports__["a"] = (createReducer);

/***/ }),
/* 1310 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_toPath__ = __webpack_require__(231);



function createDeleteInWithCleanUp(structure) {
  var shouldDeleteDefault = function shouldDeleteDefault(structure) {
    return function (state, path) {
      return structure.getIn(state, path) !== undefined;
    };
  };

  var deepEqual = structure.deepEqual,
      empty = structure.empty,
      getIn = structure.getIn,
      deleteIn = structure.deleteIn,
      setIn = structure.setIn;


  return function () {
    var shouldDelete = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : shouldDeleteDefault;

    var deleteInWithCleanUp = function deleteInWithCleanUp(state, path) {
      if (path[path.length - 1] === ']') {
        // array path
        var pathTokens = Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_toPath__["a" /* default */])(path);
        pathTokens.pop();
        var parent = getIn(state, pathTokens.join('.'));
        return parent ? setIn(state, path) : state;
      }

      var result = state;

      if (shouldDelete(structure)(state, path)) {
        result = deleteIn(state, path);
      }

      var dotIndex = path.lastIndexOf('.');
      if (dotIndex > 0) {
        var parentPath = path.substring(0, dotIndex);
        if (parentPath[parentPath.length - 1] !== ']') {
          var _parent = getIn(result, parentPath);
          if (deepEqual(_parent, empty)) {
            return deleteInWithCleanUp(result, parentPath);
          }
        }
      }
      return result;
    };

    return deleteInWithCleanUp;
  };
}

/* harmony default export */ __webpack_exports__["a"] = (createDeleteInWithCleanUp);

/***/ }),
/* 1311 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createValues__ = __webpack_require__(1312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(28);



/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0__createValues__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 1312 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(37);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




var createValues = function createValues(_ref) {
  var getIn = _ref.getIn;
  return function (config) {
    var _prop$getFormState$co = _extends({
      prop: 'values',
      getFormState: function getFormState(state) {
        return getIn(state, 'form');
      }
    }, config),
        form = _prop$getFormState$co.form,
        prop = _prop$getFormState$co.prop,
        getFormState = _prop$getFormState$co.getFormState;

    return Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(function (state) {
      return _defineProperty({}, prop, getIn(getFormState(state), form + '.values'));
    }
    // ignore dispatch
    );
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createValues);

/***/ }),
/* 1313 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.routerMiddleware = exports.routerActions = exports.goForward = exports.goBack = exports.go = exports.replace = exports.push = exports.CALL_HISTORY_METHOD = exports.routerReducer = exports.LOCATION_CHANGE = exports.syncHistoryWithStore = undefined;

var _reducer = __webpack_require__(570);

Object.defineProperty(exports, 'LOCATION_CHANGE', {
  enumerable: true,
  get: function get() {
    return _reducer.LOCATION_CHANGE;
  }
});
Object.defineProperty(exports, 'routerReducer', {
  enumerable: true,
  get: function get() {
    return _reducer.routerReducer;
  }
});

var _actions = __webpack_require__(571);

Object.defineProperty(exports, 'CALL_HISTORY_METHOD', {
  enumerable: true,
  get: function get() {
    return _actions.CALL_HISTORY_METHOD;
  }
});
Object.defineProperty(exports, 'push', {
  enumerable: true,
  get: function get() {
    return _actions.push;
  }
});
Object.defineProperty(exports, 'replace', {
  enumerable: true,
  get: function get() {
    return _actions.replace;
  }
});
Object.defineProperty(exports, 'go', {
  enumerable: true,
  get: function get() {
    return _actions.go;
  }
});
Object.defineProperty(exports, 'goBack', {
  enumerable: true,
  get: function get() {
    return _actions.goBack;
  }
});
Object.defineProperty(exports, 'goForward', {
  enumerable: true,
  get: function get() {
    return _actions.goForward;
  }
});
Object.defineProperty(exports, 'routerActions', {
  enumerable: true,
  get: function get() {
    return _actions.routerActions;
  }
});

var _sync = __webpack_require__(1314);

var _sync2 = _interopRequireDefault(_sync);

var _middleware = __webpack_require__(1315);

var _middleware2 = _interopRequireDefault(_middleware);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports.syncHistoryWithStore = _sync2['default'];
exports.routerMiddleware = _middleware2['default'];

/***/ }),
/* 1314 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports['default'] = syncHistoryWithStore;

var _reducer = __webpack_require__(570);

var defaultSelectLocationState = function defaultSelectLocationState(state) {
  return state.routing;
};

/**
 * This function synchronizes your history state with the Redux store.
 * Location changes flow from history to the store. An enhanced history is
 * returned with a listen method that responds to store updates for location.
 *
 * When this history is provided to the router, this means the location data
 * will flow like this:
 * history.push -> store.dispatch -> enhancedHistory.listen -> router
 * This ensures that when the store state changes due to a replay or other
 * event, the router will be updated appropriately and can transition to the
 * correct router state.
 */
function syncHistoryWithStore(history, store) {
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      _ref$selectLocationSt = _ref.selectLocationState,
      selectLocationState = _ref$selectLocationSt === undefined ? defaultSelectLocationState : _ref$selectLocationSt,
      _ref$adjustUrlOnRepla = _ref.adjustUrlOnReplay,
      adjustUrlOnReplay = _ref$adjustUrlOnRepla === undefined ? true : _ref$adjustUrlOnRepla;

  // Ensure that the reducer is mounted on the store and functioning properly.
  if (typeof selectLocationState(store.getState()) === 'undefined') {
    throw new Error('Expected the routing state to be available either as `state.routing` ' + 'or as the custom expression you can specify as `selectLocationState` ' + 'in the `syncHistoryWithStore()` options. ' + 'Ensure you have added the `routerReducer` to your store\'s ' + 'reducers via `combineReducers` or whatever method you use to isolate ' + 'your reducers.');
  }

  var initialLocation = void 0;
  var isTimeTraveling = void 0;
  var unsubscribeFromStore = void 0;
  var unsubscribeFromHistory = void 0;
  var currentLocation = void 0;

  // What does the store say about current location?
  var getLocationInStore = function getLocationInStore(useInitialIfEmpty) {
    var locationState = selectLocationState(store.getState());
    return locationState.locationBeforeTransitions || (useInitialIfEmpty ? initialLocation : undefined);
  };

  // Init initialLocation with potential location in store
  initialLocation = getLocationInStore();

  // If the store is replayed, update the URL in the browser to match.
  if (adjustUrlOnReplay) {
    var handleStoreChange = function handleStoreChange() {
      var locationInStore = getLocationInStore(true);
      if (currentLocation === locationInStore || initialLocation === locationInStore) {
        return;
      }

      // Update address bar to reflect store state
      isTimeTraveling = true;
      currentLocation = locationInStore;
      history.transitionTo(_extends({}, locationInStore, {
        action: 'PUSH'
      }));
      isTimeTraveling = false;
    };

    unsubscribeFromStore = store.subscribe(handleStoreChange);
    handleStoreChange();
  }

  // Whenever location changes, dispatch an action to get it in the store
  var handleLocationChange = function handleLocationChange(location) {
    // ... unless we just caused that location change
    if (isTimeTraveling) {
      return;
    }

    // Remember where we are
    currentLocation = location;

    // Are we being called for the first time?
    if (!initialLocation) {
      // Remember as a fallback in case state is reset
      initialLocation = location;

      // Respect persisted location, if any
      if (getLocationInStore()) {
        return;
      }
    }

    // Tell the store to update by dispatching an action
    store.dispatch({
      type: _reducer.LOCATION_CHANGE,
      payload: location
    });
  };
  unsubscribeFromHistory = history.listen(handleLocationChange);

  // History 3.x doesn't call listen synchronously, so fire the initial location change ourselves
  if (history.getCurrentLocation) {
    handleLocationChange(history.getCurrentLocation());
  }

  // The enhanced history uses store as source of truth
  return _extends({}, history, {
    // The listeners are subscribed to the store instead of history
    listen: function listen(listener) {
      // Copy of last location.
      var lastPublishedLocation = getLocationInStore(true);

      // Keep track of whether we unsubscribed, as Redux store
      // only applies changes in subscriptions on next dispatch
      var unsubscribed = false;
      var unsubscribeFromStore = store.subscribe(function () {
        var currentLocation = getLocationInStore(true);
        if (currentLocation === lastPublishedLocation) {
          return;
        }
        lastPublishedLocation = currentLocation;
        if (!unsubscribed) {
          listener(lastPublishedLocation);
        }
      });

      // History 2.x listeners expect a synchronous call. Make the first call to the
      // listener after subscribing to the store, in case the listener causes a
      // location change (e.g. when it redirects)
      if (!history.getCurrentLocation) {
        listener(lastPublishedLocation);
      }

      // Let user unsubscribe later
      return function () {
        unsubscribed = true;
        unsubscribeFromStore();
      };
    },


    // It also provides a way to destroy internal listeners
    unsubscribe: function unsubscribe() {
      if (adjustUrlOnReplay) {
        unsubscribeFromStore();
      }
      unsubscribeFromHistory();
    }
  });
}

/***/ }),
/* 1315 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = routerMiddleware;

var _actions = __webpack_require__(571);

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/**
 * This middleware captures CALL_HISTORY_METHOD actions to redirect to the
 * provided history object. This will prevent these actions from reaching your
 * reducer or any middleware that comes after this one.
 */
function routerMiddleware(history) {
  return function () {
    return function (next) {
      return function (action) {
        if (action.type !== _actions.CALL_HISTORY_METHOD) {
          return next(action);
        }

        var _action$payload = action.payload,
            method = _action$payload.method,
            args = _action$payload.args;

        history[method].apply(history, _toConsumableArray(args));
      };
    };
  };
}

/***/ }),
/* 1316 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function createThunkMiddleware(extraArgument) {
  return function (_ref) {
    var dispatch = _ref.dispatch,
        getState = _ref.getState;
    return function (next) {
      return function (action) {
        if (typeof action === 'function') {
          return action(dispatch, getState, extraArgument);
        }

        return next(action);
      };
    };
  };
}

var thunk = createThunkMiddleware();
thunk.withExtraArgument = createThunkMiddleware;

/* harmony default export */ __webpack_exports__["a"] = (thunk);

/***/ }),
/* 1317 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1318 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_apollo__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Wrappers_materialUIWrappers_components_FormInput__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Wrappers_materialUIWrappers_components_FormInputPassword__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux_form__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_store__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_reducers_NotificationReducer__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_assets_img_sure_quote_website_logo_png__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_assets_img_sure_quote_website_logo_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_assets_img_sure_quote_website_logo_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Register_css__ = __webpack_require__(361);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Register_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__Register_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_helpers_ValidationHelpers__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__RegisterMutations__ = __webpack_require__(362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_CustomFields_CustomFields_jsx__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_helpers_UriReader__ = __webpack_require__(41);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var form='assistant';var AssistantRegister=function(_React$Component){_inherits(AssistantRegister,_React$Component);function AssistantRegister(){var _ref;var _temp,_this,_ret;_classCallCheck(this,AssistantRegister);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=AssistantRegister.__proto__||Object.getPrototypeOf(AssistantRegister)).call.apply(_ref,[this].concat(args))),_this),_this.state={checkValidation:false,loading:false},_this.passwordMatch=function(value){if(Object(__WEBPACK_IMPORTED_MODULE_11_helpers_ValidationHelpers__["c" /* isEmptyOrSpaces */])(value))return undefined;if(__WEBPACK_IMPORTED_MODULE_7_store__["a" /* default */].getState().form[form].values['su_password']!==value){return'Does not match password';}return undefined;},_this.emailMatch=function(value){if(Object(__WEBPACK_IMPORTED_MODULE_11_helpers_ValidationHelpers__["c" /* isEmptyOrSpaces */])(value))return undefined;if(__WEBPACK_IMPORTED_MODULE_7_store__["a" /* default */].getState().form[form].values['su_email']!==value){return'Does not match email';}return undefined;},_this.submit=function(){if(__WEBPACK_IMPORTED_MODULE_7_store__["a" /* default */].getState().form[form].syncErrors){__WEBPACK_IMPORTED_MODULE_7_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_8_reducers_NotificationReducer__["d" /* showSnack */])({message:'Invalid data.',color:'danger'}));_this.setState({checkValidation:true});return;}_this.setState({loading:true});var input={clientMutationId:'123',type:6,data:__WEBPACK_IMPORTED_MODULE_7_store__["a" /* default */].getState().form[form].values};_this.props.mutate({variables:{input:input}}).then(function(resp){_this.setState({loading:false});var data=resp.data.Register;if(data.error){__WEBPACK_IMPORTED_MODULE_7_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_8_reducers_NotificationReducer__["d" /* showSnack */])({message:data.error,color:'danger'}));}else{__WEBPACK_IMPORTED_MODULE_7_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_8_reducers_NotificationReducer__["e" /* successWarning */])({open:true,title:'Assistant Profile Successfully Created.',onConfirm:function onConfirm(){return _this.props.history.push({pathname:'/app/portal/login'});}}));}}).catch(function(error){_this.setState({loading:false});__WEBPACK_IMPORTED_MODULE_7_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_8_reducers_NotificationReducer__["d" /* showSnack */])({message:'Unfortunately an error occured. We have captured the error and will notify our developers. Sorry for the inconvenience!',color:'danger'}));});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(AssistantRegister,[{key:'componentDidMount',value:function componentDidMount(){var params=Object(__WEBPACK_IMPORTED_MODULE_14_helpers_UriReader__["a" /* ParseUriParams */])(this.props.location.search);var brokerage_code=params.brokerage_code,email=params.email;this.props.initialize({su_email:email,su_email_confirm:email,sac_code:brokerage_code});}},{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["e" /* Card */],{className:'registerContainer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["f" /* CardContent */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{textAlign:'center',marginTop:'3vh'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'sqLogoR',src:__WEBPACK_IMPORTED_MODULE_9_assets_img_sure_quote_website_logo_png___default.a,alt:'SureQuote Logo'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'sqHeadingCenter'},'Register as an Assistant'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["v" /* Grid */],{container:true,spacing:24},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_CustomFields_CustomFields_jsx__["b" /* HalfFieldSmall */],{name:'sac_code',component:__WEBPACK_IMPORTED_MODULE_3_components_Wrappers_materialUIWrappers_components_FormInput__["a" /* default */],label:'Brokerage Code *',validate:[__WEBPACK_IMPORTED_MODULE_11_helpers_ValidationHelpers__["g" /* required */]],checkValidation:this.state.checkValidation}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_CustomFields_CustomFields_jsx__["b" /* HalfFieldSmall */],{name:'su_email',component:__WEBPACK_IMPORTED_MODULE_3_components_Wrappers_materialUIWrappers_components_FormInput__["a" /* default */],label:'Email Address *',validate:[__WEBPACK_IMPORTED_MODULE_11_helpers_ValidationHelpers__["g" /* required */],__WEBPACK_IMPORTED_MODULE_11_helpers_ValidationHelpers__["b" /* email */]],checkValidation:this.state.checkValidation}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_CustomFields_CustomFields_jsx__["b" /* HalfFieldSmall */],{name:'su_email_confirm',component:__WEBPACK_IMPORTED_MODULE_3_components_Wrappers_materialUIWrappers_components_FormInput__["a" /* default */],label:'Confirm Email Address *',validate:[__WEBPACK_IMPORTED_MODULE_11_helpers_ValidationHelpers__["g" /* required */],__WEBPACK_IMPORTED_MODULE_11_helpers_ValidationHelpers__["b" /* email */],this.emailMatch],checkValidation:this.state.checkValidation}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_CustomFields_CustomFields_jsx__["b" /* HalfFieldSmall */],{name:'su_password',component:__WEBPACK_IMPORTED_MODULE_4_components_Wrappers_materialUIWrappers_components_FormInputPassword__["a" /* default */],label:'Password *',checkValidation:this.state.checkValidation,validate:[__WEBPACK_IMPORTED_MODULE_11_helpers_ValidationHelpers__["g" /* required */]]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_CustomFields_CustomFields_jsx__["b" /* HalfFieldSmall */],{name:'confirm_password',component:__WEBPACK_IMPORTED_MODULE_4_components_Wrappers_materialUIWrappers_components_FormInputPassword__["a" /* default */],label:'Confirm Password *',validate:[__WEBPACK_IMPORTED_MODULE_11_helpers_ValidationHelpers__["g" /* required */],this.passwordMatch],checkValidation:this.state.checkValidation}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_CustomFields_CustomFields_jsx__["b" /* HalfFieldSmall */],{name:'su_name',component:__WEBPACK_IMPORTED_MODULE_3_components_Wrappers_materialUIWrappers_components_FormInput__["a" /* default */],label:'Name *',validate:[__WEBPACK_IMPORTED_MODULE_11_helpers_ValidationHelpers__["g" /* required */]],checkValidation:this.state.checkValidation}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_CustomFields_CustomFields_jsx__["b" /* HalfFieldSmall */],{name:'su_surname',component:__WEBPACK_IMPORTED_MODULE_3_components_Wrappers_materialUIWrappers_components_FormInput__["a" /* default */],label:'Surname *',validate:[__WEBPACK_IMPORTED_MODULE_11_helpers_ValidationHelpers__["g" /* required */]],checkValidation:this.state.checkValidation}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_CustomFields_CustomFields_jsx__["b" /* HalfFieldSmall */],{name:'su_saID',component:__WEBPACK_IMPORTED_MODULE_3_components_Wrappers_materialUIWrappers_components_FormInput__["a" /* default */],label:'South African Id *',validate:[__WEBPACK_IMPORTED_MODULE_11_helpers_ValidationHelpers__["g" /* required */],__WEBPACK_IMPORTED_MODULE_11_helpers_ValidationHelpers__["e" /* number */],__WEBPACK_IMPORTED_MODULE_11_helpers_ValidationHelpers__["i" /* saId */]],checkValidation:this.state.checkValidation,onValueChange:function onValueChange(e){return _this2.props.idChangeHandler(e);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_CustomFields_CustomFields_jsx__["b" /* HalfFieldSmall */],{name:'su_cellNumber',component:__WEBPACK_IMPORTED_MODULE_3_components_Wrappers_materialUIWrappers_components_FormInput__["a" /* default */],label:'Phone Number *',validate:[__WEBPACK_IMPORTED_MODULE_11_helpers_ValidationHelpers__["g" /* required */],__WEBPACK_IMPORTED_MODULE_11_helpers_ValidationHelpers__["e" /* number */]],checkValidation:this.state.checkValidation})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["d" /* Button */],{fullWidth:true,variant:'outlined',className:'outlinedButton',color:'primary',onClick:function onClick(){return!_this2.state.loading?_this2.submit():{};},style:{margin:'auto',marginTop:'8vh',marginBottom:'15px'}},this.state.loading?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["j" /* CircularProgress */],{size:20}):'REGISTER NOW')));}}]);return AssistantRegister;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);AssistantRegister=Object(__WEBPACK_IMPORTED_MODULE_5_redux_form__["e" /* reduxForm */])({form:form,destroyOnUnmount:false})(AssistantRegister);AssistantRegister=Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{};})(AssistantRegister);AssistantRegister=Object(__WEBPACK_IMPORTED_MODULE_2_react_apollo__["graphql"])(__WEBPACK_IMPORTED_MODULE_12__RegisterMutations__["a" /* submitSignup */])(AssistantRegister);/* harmony default export */ __webpack_exports__["a"] = (AssistantRegister);

/***/ }),
/* 1319 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_core__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_assets_img_sure_quote_website_logo_png__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_assets_img_sure_quote_website_logo_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_assets_img_sure_quote_website_logo_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_Wrappers_materialUIWrappers_components_FormInput__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Wrappers_materialUIWrappers_components_FormInputPassword__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_apollo__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_redux__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_reducers_NotificationReducer__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_redux_form__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_store__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Register_css__ = __webpack_require__(361);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Register_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__Register_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_helpers_UriReader__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_helpers_ValidationHelpers__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__RegisterMutations__ = __webpack_require__(362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_components_CustomFields_CustomFields_jsx__ = __webpack_require__(38);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var form='broker';var BrokerSignup=function(_React$Component){_inherits(BrokerSignup,_React$Component);function BrokerSignup(){var _ref;var _temp,_this,_ret;_classCallCheck(this,BrokerSignup);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=BrokerSignup.__proto__||Object.getPrototypeOf(BrokerSignup)).call.apply(_ref,[this].concat(args))),_this),_this.state={loading:false,checkValidation:false},_this.passwordMatch=function(value){if(Object(__WEBPACK_IMPORTED_MODULE_12_helpers_ValidationHelpers__["c" /* isEmptyOrSpaces */])(value))return undefined;if(__WEBPACK_IMPORTED_MODULE_9_store__["a" /* default */].getState().form[form].values['su_password']!==value){return'Does not match password';}return undefined;},_this.emailMatch=function(value){if(Object(__WEBPACK_IMPORTED_MODULE_12_helpers_ValidationHelpers__["c" /* isEmptyOrSpaces */])(value))return undefined;if(__WEBPACK_IMPORTED_MODULE_9_store__["a" /* default */].getState().form[form].values['su_email']!==value){return'Does not match email';}return undefined;},_this.submit=function(){if(__WEBPACK_IMPORTED_MODULE_9_store__["a" /* default */].getState().form[form].syncErrors){_this.setState({checkValidation:true});__WEBPACK_IMPORTED_MODULE_9_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_7_reducers_NotificationReducer__["d" /* showSnack */])({message:'Invalid data.',color:'danger'}));}else{_this.setState({loading:true});var input={type:2,data:__WEBPACK_IMPORTED_MODULE_9_store__["a" /* default */].getState().form[form].values};_this.props.mutate({variables:{input:input}}).then(function(resp){_this.setState({loading:false});var data=resp.data.Register;if(data.error){__WEBPACK_IMPORTED_MODULE_9_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_7_reducers_NotificationReducer__["d" /* showSnack */])({message:data.error,color:'danger'}));}else{__WEBPACK_IMPORTED_MODULE_9_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_7_reducers_NotificationReducer__["e" /* successWarning */])({open:true,title:'Broker Profile Successfully Created.',onConfirm:function onConfirm(){return _this.props.history.push({pathname:'/app/portal/login'});}}));}}).catch(function(error){_this.setState({loading:false});__WEBPACK_IMPORTED_MODULE_9_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_7_reducers_NotificationReducer__["d" /* showSnack */])({message:'Unfortunately an error occured. We have captured the error and will notify our developers. Sorry for the inconvenience!',color:'danger'}));});}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(BrokerSignup,[{key:'componentDidMount',value:function componentDidMount(){var params=Object(__WEBPACK_IMPORTED_MODULE_11_helpers_UriReader__["a" /* ParseUriParams */])(this.props.location.search);var brokerage_code=params.brokerage_code,email=params.email;this.props.initialize({su_email:email,su_email_confirm:email,sac_code:brokerage_code});}},{key:'render',value:function render(){var _this2=this;var checkValidation=this.state.checkValidation;return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["e" /* Card */],{className:'registerContainer'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["f" /* CardContent */],null,__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{style:{textAlign:'center',marginTop:'3vh'}},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('img',{className:'sqLogoR',src:__WEBPACK_IMPORTED_MODULE_1_assets_img_sure_quote_website_logo_png___default.a,alt:'SureQuote Logo'})),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h3',{className:'sqHeadingCenter'},'Register as a Broker'),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{container:true,spacing:24},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_CustomFields_CustomFields_jsx__["b" /* HalfFieldSmall */],{name:'sac_code',component:__WEBPACK_IMPORTED_MODULE_2_components_Wrappers_materialUIWrappers_components_FormInput__["a" /* default */],label:'Brokerage Code *',validate:[__WEBPACK_IMPORTED_MODULE_12_helpers_ValidationHelpers__["g" /* required */]],checkValidation:checkValidation}),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_CustomFields_CustomFields_jsx__["b" /* HalfFieldSmall */],{name:'su_email',component:__WEBPACK_IMPORTED_MODULE_2_components_Wrappers_materialUIWrappers_components_FormInput__["a" /* default */],label:'Email Address *',validate:[__WEBPACK_IMPORTED_MODULE_12_helpers_ValidationHelpers__["g" /* required */],__WEBPACK_IMPORTED_MODULE_12_helpers_ValidationHelpers__["b" /* email */]],checkValidation:checkValidation}),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_CustomFields_CustomFields_jsx__["b" /* HalfFieldSmall */],{name:'su_email_confirm',component:__WEBPACK_IMPORTED_MODULE_2_components_Wrappers_materialUIWrappers_components_FormInput__["a" /* default */],label:'Confirm Email Address *',validate:[__WEBPACK_IMPORTED_MODULE_12_helpers_ValidationHelpers__["g" /* required */],__WEBPACK_IMPORTED_MODULE_12_helpers_ValidationHelpers__["b" /* email */],this.emailMatch],checkValidation:this.state.checkValidation}),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_CustomFields_CustomFields_jsx__["b" /* HalfFieldSmall */],{name:'su_password',component:__WEBPACK_IMPORTED_MODULE_3_components_Wrappers_materialUIWrappers_components_FormInputPassword__["a" /* default */],label:'Password *',validate:[__WEBPACK_IMPORTED_MODULE_12_helpers_ValidationHelpers__["g" /* required */]],checkValidation:checkValidation}),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_CustomFields_CustomFields_jsx__["b" /* HalfFieldSmall */],{name:'confirm_password',component:__WEBPACK_IMPORTED_MODULE_3_components_Wrappers_materialUIWrappers_components_FormInputPassword__["a" /* default */],label:'Confirm Password *',validate:[__WEBPACK_IMPORTED_MODULE_12_helpers_ValidationHelpers__["g" /* required */],this.passwordMatch],checkValidation:checkValidation}),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_CustomFields_CustomFields_jsx__["b" /* HalfFieldSmall */],{name:'su_name',component:__WEBPACK_IMPORTED_MODULE_2_components_Wrappers_materialUIWrappers_components_FormInput__["a" /* default */],label:'Name *',validate:[__WEBPACK_IMPORTED_MODULE_12_helpers_ValidationHelpers__["g" /* required */]],checkValidation:checkValidation}),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_CustomFields_CustomFields_jsx__["b" /* HalfFieldSmall */],{name:'su_surname',component:__WEBPACK_IMPORTED_MODULE_2_components_Wrappers_materialUIWrappers_components_FormInput__["a" /* default */],label:'Surname *',validate:[__WEBPACK_IMPORTED_MODULE_12_helpers_ValidationHelpers__["g" /* required */]],checkValidation:checkValidation}),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_CustomFields_CustomFields_jsx__["b" /* HalfFieldSmall */],{name:'su_saID',component:__WEBPACK_IMPORTED_MODULE_2_components_Wrappers_materialUIWrappers_components_FormInput__["a" /* default */],label:'South African Id *',validate:[__WEBPACK_IMPORTED_MODULE_12_helpers_ValidationHelpers__["g" /* required */],__WEBPACK_IMPORTED_MODULE_12_helpers_ValidationHelpers__["e" /* number */],__WEBPACK_IMPORTED_MODULE_12_helpers_ValidationHelpers__["i" /* saId */]],checkValidation:checkValidation}),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_CustomFields_CustomFields_jsx__["b" /* HalfFieldSmall */],{name:'su_cellNumber',component:__WEBPACK_IMPORTED_MODULE_2_components_Wrappers_materialUIWrappers_components_FormInput__["a" /* default */],label:'Phone Number *',validate:[__WEBPACK_IMPORTED_MODULE_12_helpers_ValidationHelpers__["g" /* required */],__WEBPACK_IMPORTED_MODULE_12_helpers_ValidationHelpers__["e" /* number */]],checkValidation:checkValidation})),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["d" /* Button */],{fullWidth:true,variant:'outlined',className:'outlinedButton',color:'primary',onClick:function onClick(){return!_this2.state.loading?_this2.submit():{};},style:{margin:'auto',marginTop:'8vh',marginBottom:'15px'}},this.state.loading?__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["j" /* CircularProgress */],{size:20}):'REGISTER NOW')));}}]);return BrokerSignup;}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);BrokerSignup=Object(__WEBPACK_IMPORTED_MODULE_8_redux_form__["e" /* reduxForm */])({form:form,destroyOnUnmount:false})(BrokerSignup);BrokerSignup=Object(__WEBPACK_IMPORTED_MODULE_6_react_redux__["b" /* connect */])(function(state){return{};})(BrokerSignup);BrokerSignup=Object(__WEBPACK_IMPORTED_MODULE_5_react_apollo__["graphql"])(__WEBPACK_IMPORTED_MODULE_13__RegisterMutations__["a" /* submitSignup */])(BrokerSignup);/* harmony default export */ __webpack_exports__["a"] = (BrokerSignup);

/***/ }),
/* 1320 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_core__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_assets_img_sure_quote_website_logo_png__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_assets_img_sure_quote_website_logo_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_assets_img_sure_quote_website_logo_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_Wrappers_materialUIWrappers_components_FormInput__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Wrappers_materialUIWrappers_components_FormInputPassword__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_apollo__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_redux__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_reducers_NotificationReducer__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_redux_form__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_store__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Register_css__ = __webpack_require__(361);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Register_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__Register_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_helpers_ValidationHelpers__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__RegisterMutations__ = __webpack_require__(362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_CustomFields_CustomFields_jsx__ = __webpack_require__(38);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var form='brokerage';var BrokerageSignup=function(_React$Component){_inherits(BrokerageSignup,_React$Component);function BrokerageSignup(){var _ref;var _temp,_this,_ret;_classCallCheck(this,BrokerageSignup);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=BrokerageSignup.__proto__||Object.getPrototypeOf(BrokerageSignup)).call.apply(_ref,[this].concat(args))),_this),_this.state={brokerUser:true,checkValidation:false,loading:false},_this.passwordMatch=function(value){if(Object(__WEBPACK_IMPORTED_MODULE_11_helpers_ValidationHelpers__["c" /* isEmptyOrSpaces */])(value))return undefined;if(__WEBPACK_IMPORTED_MODULE_9_store__["a" /* default */].getState().form[form].values['su_password']!==value){return'Does not match password';}return undefined;},_this.emailMatch=function(value){if(Object(__WEBPACK_IMPORTED_MODULE_11_helpers_ValidationHelpers__["c" /* isEmptyOrSpaces */])(value))return undefined;if(__WEBPACK_IMPORTED_MODULE_9_store__["a" /* default */].getState().form[form].values['su_email']!==value){return'Does not match email';}return undefined;},_this.submit=function(){if(__WEBPACK_IMPORTED_MODULE_9_store__["a" /* default */].getState().form[form].syncErrors){_this.setState({checkValidation:true});__WEBPACK_IMPORTED_MODULE_9_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_7_reducers_NotificationReducer__["d" /* showSnack */])({message:'Invalid data.',color:'danger'}));return;}_this.setState({loading:true});var dat=__WEBPACK_IMPORTED_MODULE_9_store__["a" /* default */].getState().form[form].values;dat.brokerUser=_this.state.brokerUser;var input={clientMutationId:'helloFudger',type:1,data:dat};_this.props.mutate({variables:{input:input}}).then(function(resp){_this.setState({loading:false});var data=resp.data.Register;if(data.error){__WEBPACK_IMPORTED_MODULE_9_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_7_reducers_NotificationReducer__["d" /* showSnack */])({message:data.error,color:'danger'}));}else{__WEBPACK_IMPORTED_MODULE_9_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_7_reducers_NotificationReducer__["e" /* successWarning */])({open:true,title:'Brokerage Profile Successfully Created.',onConfirm:function onConfirm(){return _this.props.history.push({pathname:'/app/portal/login'});}}));}}).catch(function(error){_this.setState({loading:false});__WEBPACK_IMPORTED_MODULE_9_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_7_reducers_NotificationReducer__["d" /* showSnack */])({message:'Unfortunately an error occured. We have captured the error and will notify our developers. Sorry for the inconvenience!',color:'danger'}));});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(BrokerageSignup,[{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["e" /* Card */],{className:'registerContainer'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["f" /* CardContent */],null,__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{style:{textAlign:'center',marginTop:'3vh'}},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('img',{className:'sqLogoR',src:__WEBPACK_IMPORTED_MODULE_1_assets_img_sure_quote_website_logo_png___default.a,alt:'SureQuote Logo'})),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h3',{className:'sqHeadingCenter'},'Register as a Brokerage'),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h5',{className:'sqHeadingCenter'},'Try Sure Quote for free and see how easy it will make your life'),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],null,'*Simply fill in your details in the form below, and we will set you up with free access to try it out for yourself.'),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{container:true,spacing:24},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_CustomFields_CustomFields_jsx__["b" /* HalfFieldSmall */],{name:'sbad_name',component:__WEBPACK_IMPORTED_MODULE_2_components_Wrappers_materialUIWrappers_components_FormInput__["a" /* default */],label:'Name *',validate:[__WEBPACK_IMPORTED_MODULE_11_helpers_ValidationHelpers__["g" /* required */]],checkValidation:this.state.checkValidation}),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_CustomFields_CustomFields_jsx__["b" /* HalfFieldSmall */],{name:'sbad_surname',component:__WEBPACK_IMPORTED_MODULE_2_components_Wrappers_materialUIWrappers_components_FormInput__["a" /* default */],label:'Surname *',validate:[__WEBPACK_IMPORTED_MODULE_11_helpers_ValidationHelpers__["g" /* required */]],checkValidation:this.state.checkValidation}),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_CustomFields_CustomFields_jsx__["b" /* HalfFieldSmall */],{name:'sbad_id_number',component:__WEBPACK_IMPORTED_MODULE_2_components_Wrappers_materialUIWrappers_components_FormInput__["a" /* default */],label:'Id Number *',validate:[__WEBPACK_IMPORTED_MODULE_11_helpers_ValidationHelpers__["g" /* required */],__WEBPACK_IMPORTED_MODULE_11_helpers_ValidationHelpers__["e" /* number */],__WEBPACK_IMPORTED_MODULE_11_helpers_ValidationHelpers__["i" /* saId */]],checkValidation:this.state.checkValidation}),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_CustomFields_CustomFields_jsx__["b" /* HalfFieldSmall */],{name:'sbad_brokerageName',component:__WEBPACK_IMPORTED_MODULE_2_components_Wrappers_materialUIWrappers_components_FormInput__["a" /* default */],label:'Brokerage Name *',validate:[__WEBPACK_IMPORTED_MODULE_11_helpers_ValidationHelpers__["g" /* required */]],checkValidation:this.state.checkValidation}),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_CustomFields_CustomFields_jsx__["b" /* HalfFieldSmall */],{name:'sbad_fsb',component:__WEBPACK_IMPORTED_MODULE_2_components_Wrappers_materialUIWrappers_components_FormInput__["a" /* default */],label:'FSB Registration Number *',validate:[__WEBPACK_IMPORTED_MODULE_11_helpers_ValidationHelpers__["g" /* required */]],checkValidation:this.state.checkValidation}),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_CustomFields_CustomFields_jsx__["b" /* HalfFieldSmall */],{name:'su_email',component:__WEBPACK_IMPORTED_MODULE_2_components_Wrappers_materialUIWrappers_components_FormInput__["a" /* default */],label:'Email Address *',validate:[__WEBPACK_IMPORTED_MODULE_11_helpers_ValidationHelpers__["g" /* required */],__WEBPACK_IMPORTED_MODULE_11_helpers_ValidationHelpers__["b" /* email */]],checkValidation:this.state.checkValidation}),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_CustomFields_CustomFields_jsx__["b" /* HalfFieldSmall */],{name:'su_email_confirm',component:__WEBPACK_IMPORTED_MODULE_2_components_Wrappers_materialUIWrappers_components_FormInput__["a" /* default */],label:'Confirm Email Address *',validate:[__WEBPACK_IMPORTED_MODULE_11_helpers_ValidationHelpers__["g" /* required */],__WEBPACK_IMPORTED_MODULE_11_helpers_ValidationHelpers__["b" /* email */],this.emailMatch],checkValidation:this.state.checkValidation}),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_CustomFields_CustomFields_jsx__["b" /* HalfFieldSmall */],{name:'su_password',component:__WEBPACK_IMPORTED_MODULE_3_components_Wrappers_materialUIWrappers_components_FormInputPassword__["a" /* default */],label:'Password *',validate:[__WEBPACK_IMPORTED_MODULE_11_helpers_ValidationHelpers__["g" /* required */]],checkValidation:this.state.checkValidation}),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_CustomFields_CustomFields_jsx__["b" /* HalfFieldSmall */],{name:'confirm_password',component:__WEBPACK_IMPORTED_MODULE_3_components_Wrappers_materialUIWrappers_components_FormInputPassword__["a" /* default */],label:'Confirm Password *',validate:[__WEBPACK_IMPORTED_MODULE_11_helpers_ValidationHelpers__["g" /* required */],this.passwordMatch],checkValidation:this.state.checkValidation}),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_CustomFields_CustomFields_jsx__["b" /* HalfFieldSmall */],{name:'su_cellNumber',component:__WEBPACK_IMPORTED_MODULE_2_components_Wrappers_materialUIWrappers_components_FormInput__["a" /* default */],label:'Phone Number *',validate:[__WEBPACK_IMPORTED_MODULE_11_helpers_ValidationHelpers__["g" /* required */],__WEBPACK_IMPORTED_MODULE_11_helpers_ValidationHelpers__["e" /* number */]],checkValidation:this.state.checkValidation}),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_CustomFields_CustomFields_jsx__["b" /* HalfFieldSmall */],{name:'sbad_streetAddress',component:__WEBPACK_IMPORTED_MODULE_2_components_Wrappers_materialUIWrappers_components_FormInput__["a" /* default */],label:'Office Address *',validate:[__WEBPACK_IMPORTED_MODULE_11_helpers_ValidationHelpers__["g" /* required */]],checkValidation:this.state.checkValidation})),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["d" /* Button */],{fullWidth:true,variant:'outlined',className:'outlinedButton',color:'primary',onClick:function onClick(){return!_this2.state.loading?_this2.submit():{};},style:{margin:'auto',marginTop:'8vh',marginBottom:'15px'}},this.state.loading?__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["j" /* CircularProgress */],{size:20}):'REGISTER NOW')));}}]);return BrokerageSignup;}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);BrokerageSignup=Object(__WEBPACK_IMPORTED_MODULE_8_redux_form__["e" /* reduxForm */])({form:form,destroyOnUnmount:false})(BrokerageSignup);BrokerageSignup=Object(__WEBPACK_IMPORTED_MODULE_6_react_redux__["b" /* connect */])(function(){return{};})(BrokerageSignup);BrokerageSignup=Object(__WEBPACK_IMPORTED_MODULE_5_react_apollo__["graphql"])(__WEBPACK_IMPORTED_MODULE_12__RegisterMutations__["a" /* submitSignup */])(BrokerageSignup);/* harmony default export */ __webpack_exports__["a"] = (BrokerageSignup);

/***/ }),
/* 1321 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_core__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_Button__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_assets_img_sure_quote_website_logo_png__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_assets_img_sure_quote_website_logo_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_assets_img_sure_quote_website_logo_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_assets_img_web_background2_jpg__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_assets_img_web_background2_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_assets_img_web_background2_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Wrappers_materialUIWrappers_components_FormInput__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_Wrappers_materialUIWrappers_components_FormInputPassword__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_redux_form__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_queries_portal_mutations__ = __webpack_require__(573);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_reducers_NotificationReducer__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_store__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_apollo__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react_apollo__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/*eslint-disable*/var required=function required(value){return value?undefined:"Required";};var email=function email(value){var mailformat=/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;return value.match(mailformat)?undefined:"Not a Valid Email Addres";};var ForgotPassword=function(_React$Component){_inherits(ForgotPassword,_React$Component);function ForgotPassword(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ForgotPassword);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ForgotPassword.__proto__||Object.getPrototypeOf(ForgotPassword)).call.apply(_ref,[this].concat(args))),_this),_this.state={checkValidation:false,loading:false},_this.submit=function(){if(__WEBPACK_IMPORTED_MODULE_10_store__["a" /* default */].getState().form.forgotpassword.values["email"]!==__WEBPACK_IMPORTED_MODULE_10_store__["a" /* default */].getState().form.forgotpassword.values["email_confirm"]){__WEBPACK_IMPORTED_MODULE_10_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_9_reducers_NotificationReducer__["d" /* showSnack */])({message:"Emails do not match",color:"danger"}));}else if(__WEBPACK_IMPORTED_MODULE_10_store__["a" /* default */].getState().form.forgotpassword.syncErrors){_this.setState({checkValidation:true});__WEBPACK_IMPORTED_MODULE_10_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_9_reducers_NotificationReducer__["d" /* showSnack */])({message:"Invalid data.",color:"danger"}));}else{_this.setState({loading:true});var data=__WEBPACK_IMPORTED_MODULE_10_store__["a" /* default */].getState().form.forgotpassword.values;var input={email:data.email};_this.props.mutate({variables:{input:input}}).then(function(){_this.setState({loading:false});__WEBPACK_IMPORTED_MODULE_10_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_9_reducers_NotificationReducer__["e" /* successWarning */])({open:true,title:"Password Reset email has been sent to you",onConfirm:function onConfirm(){return _this.props.history.push({pathname:"/app/portal/login"});}}));}).catch(function(error){_this.setState({loading:false});__WEBPACK_IMPORTED_MODULE_10_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_9_reducers_NotificationReducer__["d" /* showSnack */])({message:"There was an error : "+error,color:"danger"}));});}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ForgotPassword,[{key:"render",value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement("div",{className:"loginContainer",style:{backgroundImage:"url("+__WEBPACK_IMPORTED_MODULE_3_assets_img_web_background2_jpg___default.a+")"}},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["e" /* Card */],{className:"loginCard"},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement("div",{className:"loginBox"},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement("div",{style:{margin:"40px auto 40px auto"}},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement("img",{className:"sqLogo",src:__WEBPACK_IMPORTED_MODULE_2_assets_img_sure_quote_website_logo_png___default.a,alt:"sqLogo"})),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{variant:"title",className:"centerCell",style:{marginBottom:"15px"}},"Forgot Password"),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{variant:"body1",className:"centerCell"},"We will send you an email containing a link to reset your password"),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["t" /* FormControl */],{fullWidth:true},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_4_components_Wrappers_materialUIWrappers_components_FormInput__["a" /* default */],isrequired:true,validate:[required,email],checkValidation:this.state.checkValidation,name:"email",label:"Email *"})),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["t" /* FormControl */],{fullWidth:true},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_4_components_Wrappers_materialUIWrappers_components_FormInput__["a" /* default */],isrequired:true,validate:[required,email],checkValidation:this.state.checkValidation,name:"email_confirm",label:"Confirm Email *",handleKeyPress:this.passwordKeyPressed})),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Button___default.a,{variant:"outlined",className:"outlinedButton",color:"primary",style:{margin:"auto",marginTop:"8vh",marginBottom:"15vh"},onClick:function onClick(){return!_this2.state.loading?_this2.submit():{};},fullWidth:true},this.state.loading?__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["j" /* CircularProgress */],{size:20}):"SUBMIT"))));}}]);return ForgotPassword;}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);ForgotPassword=Object(__WEBPACK_IMPORTED_MODULE_7_redux_form__["e" /* reduxForm */])({form:"forgotpassword",destroyOnUnmount:true})(ForgotPassword);ForgotPassword=Object(__WEBPACK_IMPORTED_MODULE_11_react_apollo__["graphql"])(__WEBPACK_IMPORTED_MODULE_8_queries_portal_mutations__["b" /* SetForgotPassword */])(ForgotPassword);/* harmony default export */ __webpack_exports__["a"] = (ForgotPassword);

/***/ }),
/* 1322 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_core__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_Button__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_assets_img_sure_quote_website_logo_png__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_assets_img_sure_quote_website_logo_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_assets_img_sure_quote_website_logo_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_assets_img_web_background2_jpg__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_assets_img_web_background2_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_assets_img_web_background2_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Wrappers_materialUIWrappers_components_FormInput__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_Wrappers_materialUIWrappers_components_FormInputPassword__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_redux_form__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_queries_portal_mutations__ = __webpack_require__(573);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_reducers_NotificationReducer__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_store__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_apollo__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_helpers_UriReader__ = __webpack_require__(41);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/*eslint-disable*/var required=function required(value){return value?undefined:"Required";};var ResetPassword=function(_React$Component){_inherits(ResetPassword,_React$Component);function ResetPassword(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ResetPassword);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ResetPassword.__proto__||Object.getPrototypeOf(ResetPassword)).call.apply(_ref,[this].concat(args))),_this),_this.state={checkValidation:false,loading:false,email:null,code:null},_this.submit=function(){if(__WEBPACK_IMPORTED_MODULE_10_store__["a" /* default */].getState().form.resetpassword.values["new_password"]!==__WEBPACK_IMPORTED_MODULE_10_store__["a" /* default */].getState().form.resetpassword.values["password_confirm"]){__WEBPACK_IMPORTED_MODULE_10_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_9_reducers_NotificationReducer__["d" /* showSnack */])({message:"Passwords do not match",color:"danger"}));}else if(__WEBPACK_IMPORTED_MODULE_10_store__["a" /* default */].getState().form.resetpassword.syncErrors){_this.setState({checkValidation:true});__WEBPACK_IMPORTED_MODULE_10_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_9_reducers_NotificationReducer__["d" /* showSnack */])({message:"Invalid data.",color:"danger"}));}else{_this.setState({loading:true});var data=__WEBPACK_IMPORTED_MODULE_10_store__["a" /* default */].getState().form.resetpassword.values;var input={code:_this.state.code,email:_this.state.email,newPassword:data.new_password};_this.props.mutate({variables:{input:input}}).then(function(){_this.setState({loading:false});__WEBPACK_IMPORTED_MODULE_10_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_9_reducers_NotificationReducer__["e" /* successWarning */])({open:true,title:"Password Reset Successfull",onConfirm:function onConfirm(){return _this.props.history.push({pathname:"/app/portal/login"});}}));}).catch(function(error){_this.setState({loading:false});__WEBPACK_IMPORTED_MODULE_10_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_9_reducers_NotificationReducer__["d" /* showSnack */])({message:"There was an error : "+error,color:"danger"}));});}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ResetPassword,[{key:"componentDidMount",value:function componentDidMount(){var params=Object(__WEBPACK_IMPORTED_MODULE_12_helpers_UriReader__["a" /* ParseUriParams */])(this.props.location.search);var email=params.email,code=params.code;if(!email||!code){this.props.history.push({pathname:"/app/portal/login"});}this.setState({email:email,code:code});}},{key:"render",value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement("div",{className:"loginContainer",style:{backgroundImage:"url("+__WEBPACK_IMPORTED_MODULE_3_assets_img_web_background2_jpg___default.a+")"}},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["e" /* Card */],{className:"loginCard"},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement("div",{className:"loginBox"},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement("div",{style:{margin:"40px auto 40px auto"}},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement("img",{className:"sqLogo",src:__WEBPACK_IMPORTED_MODULE_2_assets_img_sure_quote_website_logo_png___default.a,alt:"sqLogo"})),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{variant:"title",className:"centerCell",style:{marginBottom:"15px"}},"Reset Password"),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["t" /* FormControl */],{fullWidth:true},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_5_components_Wrappers_materialUIWrappers_components_FormInputPassword__["a" /* default */],isrequired:true,validate:[required],checkValidation:this.state.checkValidation,name:"new_password",label:"New Password *"})),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["t" /* FormControl */],{fullWidth:true},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_5_components_Wrappers_materialUIWrappers_components_FormInputPassword__["a" /* default */],isrequired:true,validate:[required],checkValidation:this.state.checkValidation,name:"password_confirm",label:"Confirm New Password *",handleKeyPress:this.passwordKeyPressed})),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Button___default.a,{variant:"outlined",className:"outlinedButton",color:"primary",style:{margin:"auto",marginTop:"8vh",marginBottom:"15vh"},onClick:function onClick(){return!_this2.state.loading?_this2.submit():{};},fullWidth:true},this.state.loading?__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["j" /* CircularProgress */],{size:20}):"RESET PASSWORD"))));}}]);return ResetPassword;}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);ResetPassword=Object(__WEBPACK_IMPORTED_MODULE_7_redux_form__["e" /* reduxForm */])({form:"resetpassword",destroyOnUnmount:true})(ResetPassword);ResetPassword=Object(__WEBPACK_IMPORTED_MODULE_11_react_apollo__["graphql"])(__WEBPACK_IMPORTED_MODULE_8_queries_portal_mutations__["a" /* ResetForgotPassword */])(ResetPassword);/* harmony default export */ __webpack_exports__["a"] = (ResetPassword);

/***/ }),
/* 1323 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ##############################
// // // Pages Layout styles
// #############################
// import {
//
// } from "assets/jss/material-dashboard-pro-react.jsx";
var pagesStyle={wrapper:{height:"auto",minHeight:"100vh",position:"relative",top:"0",overflow:"hidden"},fullPage:{"&:before":{backgroundColor:"rgba(0, 0, 0, 0.65)"},"&:before,&:after":{display:"block",content:'""',position:"absolute",width:"100%",height:"100%",top:"0",left:"0",zIndex:"2"}},fullPageBackground:{position:"absolute",zIndex:"1",height:"100%",width:"100%",display:"block",top:"0",left:"0",backgroundSize:"cover",backgroundPosition:"center center"}};/* harmony default export */ __webpack_exports__["a"] = (pagesStyle);

/***/ }),
/* 1324 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// third-party

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _objectAssign = __webpack_require__(57);

var _objectAssign2 = _interopRequireDefault(_objectAssign);

var _SuccessIcon = __webpack_require__(1325);

var _SuccessIcon2 = _interopRequireDefault(_SuccessIcon);

var _ErrorIcon = __webpack_require__(1326);

var _ErrorIcon2 = _interopRequireDefault(_ErrorIcon);

var _InfoIcon = __webpack_require__(1327);

var _InfoIcon2 = _interopRequireDefault(_InfoIcon);

var _WarningIcon = __webpack_require__(1328);

var _WarningIcon2 = _interopRequireDefault(_WarningIcon);

var _CustomIcon = __webpack_require__(1329);

var _CustomIcon2 = _interopRequireDefault(_CustomIcon);

var _Buttons = __webpack_require__(1330);

var _Buttons2 = _interopRequireDefault(_Buttons);

var _Input = __webpack_require__(1331);

var _Input2 = _interopRequireDefault(_Input);

var _ValidationMessage = __webpack_require__(1332);

var _ValidationMessage2 = _interopRequireDefault(_ValidationMessage);

var _Title = __webpack_require__(1333);

var _Title2 = _interopRequireDefault(_Title);

var _Content = __webpack_require__(1334);

var _Content2 = _interopRequireDefault(_Content);

var _SweetAlertStyles = __webpack_require__(80);

var _SweetAlertStyles2 = _interopRequireDefault(_SweetAlertStyles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// components


// styles


var defaultRegex = /^.+$/;
var emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

var style = _SweetAlertStyles2.default.sweetAlert;

if (typeof window !== 'undefined') {
  if (window && window.innerWidth && window.innerWidth < 767) {
    style = (0, _objectAssign2.default)({}, style, _SweetAlertStyles2.default.sweetAlertMobile);
  }
}

var SweetAlert = function (_React$Component) {
  _inherits(SweetAlert, _React$Component);

  function SweetAlert() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, SweetAlert);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SweetAlert.__proto__ || Object.getPrototypeOf(SweetAlert)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      type: 'default',
      focusConfirmBtn: true,
      inputValue: '',
      showValidationMessage: false,
      timer: null
    }, _this.setStateFromProps = function (props) {
      props = props || _this.props;
      var type = _this.getTypeFromProps(props);
      _this.setState({
        type: type,
        focusConfirmBtn: props.focusConfirmBtn && type !== 'input'
      });
    }, _this.getTypeFromProps = function (props) {
      if (props.type) return props.type;
      if (props.info) return 'info';
      if (props.success) return 'success';
      if (props.warning) return 'warning';
      if (props.danger || props.error) return 'danger';
      if (props.input) return 'input';
      if (props.custom) return 'custom';
      return _this.state.type;
    }, _this.unsupportedProp = function (oldProp, message) {
      try {
        console.warn('react-bootstrap-sweetalert: Unsupported prop \'' + oldProp + '\'. Please ' + message);
      } catch (e) {}
    }, _this.getIcon = function () {
      switch (_this.state.type) {
        case 'danger':
        case 'error':
          return _react2.default.createElement(_ErrorIcon2.default, null);
        case 'warning':
          return _react2.default.createElement(_WarningIcon2.default, null);
        case 'info':
          return _react2.default.createElement(_InfoIcon2.default, null);
        case 'success':
          return _react2.default.createElement(_SuccessIcon2.default, null);
        case 'custom':
          if (_this.props.customIcon) {
            if (typeof _this.props.customIcon == 'string') {
              return _react2.default.createElement(_CustomIcon2.default, { iconUrl: _this.props.customIcon });
            } else {
              return _this.props.customIcon;
            }
          }
      }
    }, _this.onChangeInput = function (e) {
      _this.setState({
        inputValue: e.target.value,
        showValidationMessage: false
      });
    }, _this.isValidInput = function () {
      if (!_this.props.required) {
        return true;
      }
      var regex = _this.props.validationRegex || (_this.props.inputType === 'email' ? emailRegex : defaultRegex);
      return regex.test(_this.state.inputValue);
    }, _this.onConfirm = function () {
      if (_this.state.type === 'input') {
        if (_this.isValidInput()) {
          _this.props.onConfirm(_this.state.inputValue);
        } else {
          _this.setState({
            showValidationMessage: true
          });
        }
      } else {
        _this.props.onConfirm();
      }
    }, _this.onInputKeyDown = function (e) {
      if (e.keyCode == 13) {
        if (_this.props.onConfirm) {
          _this.onConfirm();
          e.stopPropagation();
        }
      }
    }, _this.onKeyDown = function (e) {
      if (e.keyCode == 27) {
        if (_this.props.allowEscape && _this.props.onCancel) {
          _this.props.onCancel();
          e.stopPropagation();
        }
      }
    }, _this.onClickOutside = function () {
      if (_this.props.closeOnClickOutside && _this.props.onCancel) {
        _this.props.onCancel();
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(SweetAlert, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      if (this.props.inputPlaceHolder) {
        this.unsupportedProp('inputPlaceHolder', 'use props.placeholder');
      }
      if (this.props.inputValidationMsg) {
        this.unsupportedProp('inputValidationMsg', 'use props.validationMsg');
      }
      if (this.props.content) {
        this.unsupportedProp('content', 'use props.children <SweetAlert>your content</SweetAlert>');
      }
      if (this.props.defaultValue != null) {
        this.setState({
          inputValue: this.props.defaultValue
        });
      }

      this.setStateFromProps();

      this.props.beforeMount();
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.props.afterMount();
      this.handleTimeout();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.getTypeFromProps(this.props) !== this.getTypeFromProps(nextProps)) {
        this.setStateFromProps(nextProps);
        this.handleTimeout(nextProps);
      } else if (this.props.timeout !== nextProps.timeout) {
        this.handleTimeout(nextProps);
      }
    }
  }, {
    key: 'componentWillUpdate',
    value: function componentWillUpdate(nextProps, nextState) {
      this.props.beforeUpdate(nextProps, nextState);
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      this.props.afterUpdate(prevProps, prevState);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.props.beforeUnmount();
    }
  }, {
    key: 'handleTimeout',
    value: function handleTimeout(props) {
      props = props || this.props;

      if (this.state.timer) {
        clearTimeout(this.state.timer);
      }

      if (props.timeout && props.timeout > 0) {
        var timer = setTimeout(function () {
          return props.onConfirm();
        }, props.timeout);

        this.setState({ timer: timer });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      if (!this.props.show) {
        return false;
      }
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'style',
          { type: 'text/css', scoped: true },
          '@-webkit-keyframes showSweetAlert {\n                      0% {\n                        transform: scale(0.7);\n                        -webkit-transform: scale(0.7);\n                      }\n                      45% {\n                        transform: scale(1.05);\n                        -webkit-transform: scale(1.05);\n                      }\n                      80% {\n                        transform: scale(0.95);\n                        -webkit-tranform: scale(0.95);\n                      }\n                      100% {\n                        transform: scale(1);\n                        -webkit-transform: scale(1);\n                      }\n                    }\n                    @keyframes showSweetAlert {\n                      0% {\n                        transform: scale(0.7);\n                        -webkit-transform: scale(0.7);\n                      }\n                      45% {\n                        transform: scale(1.05);\n                        -webkit-transform: scale(1.05);\n                      }\n                      80% {\n                        transform: scale(0.95);\n                        -webkit-tranform: scale(0.95);\n                      }\n                      100% {\n                        transform: scale(1);\n                        -webkit-transform: scale(1);\n                      }\n                    }\n                    @-webkit-keyframes hideSweetAlert {\n                      0% {\n                        transform: scale(1);\n                        -webkit-transform: scale(1);\n                      }\n                      100% {\n                        transform: scale(0.5);\n                        -webkit-transform: scale(0.5);\n                      }\n                    }\n                    @keyframes hideSweetAlert {\n                      0% {\n                        transform: scale(1);\n                        -webkit-transform: scale(1);\n                      }\n                      100% {\n                        transform: scale(0.5);\n                        -webkit-transform: scale(0.5);\n                      }\n                    }\n                    @-webkit-keyframes animateSuccessTip {\n                      0% {\n                        width: 0;\n                        left: 1px;\n                        top: 19px;\n                      }\n                      54% {\n                        width: 0;\n                        left: 1px;\n                        top: 19px;\n                      }\n                      70% {\n                        width: 50px;\n                        left: -8px;\n                        top: 37px;\n                      }\n                      84% {\n                        width: 17px;\n                        left: 21px;\n                        top: 48px;\n                      }\n                      100% {\n                        width: 25px;\n                        left: 14px;\n                        top: 45px;\n                      }\n                    }\n                    @keyframes animateSuccessTip {\n                      0% {\n                        width: 0;\n                        left: 1px;\n                        top: 19px;\n                      }\n                      54% {\n                        width: 0;\n                        left: 1px;\n                        top: 19px;\n                      }\n                      70% {\n                        width: 50px;\n                        left: -8px;\n                        top: 37px;\n                      }\n                      84% {\n                        width: 17px;\n                        left: 21px;\n                        top: 48px;\n                      }\n                      100% {\n                        width: 25px;\n                        left: 14px;\n                        top: 45px;\n                      }\n                    }\n                    @-webkit-keyframes animateSuccessLong {\n                      0% {\n                        width: 0;\n                        right: 46px;\n                        top: 54px;\n                      }\n                      65% {\n                        width: 0;\n                        right: 46px;\n                        top: 54px;\n                      }\n                      84% {\n                        width: 55px;\n                        right: 0px;\n                        top: 35px;\n                      }\n                      100% {\n                        width: 47px;\n                        right: 8px;\n                        top: 38px;\n                      }\n                    }\n                    @keyframes animateSuccessLong {\n                      0% {\n                        width: 0;\n                        right: 46px;\n                        top: 54px;\n                      }\n                      65% {\n                        width: 0;\n                        right: 46px;\n                        top: 54px;\n                      }\n                      84% {\n                        width: 55px;\n                        right: 0px;\n                        top: 35px;\n                      }\n                      100% {\n                        width: 47px;\n                        right: 8px;\n                        top: 38px;\n                      }\n                    }\n                    @-webkit-keyframes rotatePlaceholder {\n                      0% {\n                        transform: rotate(-45deg);\n                        -webkit-transform: rotate(-45deg);\n                      }\n                      5% {\n                        transform: rotate(-45deg);\n                        -webkit-transform: rotate(-45deg);\n                      }\n                      12% {\n                        transform: rotate(-405deg);\n                        -webkit-transform: rotate(-405deg);\n                      }\n                      100% {\n                        transform: rotate(-405deg);\n                        -webkit-transform: rotate(-405deg);\n                      }\n                    }\n                    @keyframes rotatePlaceholder {\n                      0% {\n                        transform: rotate(-45deg);\n                        -webkit-transform: rotate(-45deg);\n                      }\n                      5% {\n                        transform: rotate(-45deg);\n                        -webkit-transform: rotate(-45deg);\n                      }\n                      12% {\n                        transform: rotate(-405deg);\n                        -webkit-transform: rotate(-405deg);\n                      }\n                      100% {\n                        transform: rotate(-405deg);\n                        -webkit-transform: rotate(-405deg);\n                      }\n                    }\n                    @-webkit-keyframes animateErrorIcon {\n                      0% {\n                        transform: rotateX(100deg);\n                        -webkit-transform: rotateX(100deg);\n                        opacity: 0;\n                      }\n                      100% {\n                        transform: rotateX(0deg);\n                        -webkit-transform: rotateX(0deg);\n                        opacity: 1;\n                      }\n                    }\n                    @keyframes animateErrorIcon {\n                      0% {\n                        transform: rotateX(100deg);\n                        -webkit-transform: rotateX(100deg);\n                        opacity: 0;\n                      }\n                      100% {\n                        transform: rotateX(0deg);\n                        -webkit-transform: rotateX(0deg);\n                        opacity: 1;\n                      }\n                    }\n                    @-webkit-keyframes animateXMark {\n                      0% {\n                        transform: scale(0.4);\n                        -webkit-transform: scale(0.4);\n                        margin-top: 26px;\n                        opacity: 0;\n                      }\n                      50% {\n                        transform: scale(0.4);\n                        -webkit-transform: scale(0.4);\n                        margin-top: 26px;\n                        opacity: 0;\n                      }\n                      80% {\n                        transform: scale(1.15);\n                        -webkit-transform: scale(1.15);\n                        margin-top: -6px;\n                      }\n                      100% {\n                        transform: scale(1);\n                        -webkit-transform: scale(1);\n                        margin-top: 0;\n                        opacity: 1;\n                      }\n                    }\n                    @keyframes animateXMark {\n                      0% {\n                        transform: scale(0.4);\n                        -webkit-transform: scale(0.4);\n                        margin-top: 26px;\n                        opacity: 0;\n                      }\n                      50% {\n                        transform: scale(0.4);\n                        -webkit-transform: scale(0.4);\n                        margin-top: 26px;\n                        opacity: 0;\n                      }\n                      80% {\n                        transform: scale(1.15);\n                        -webkit-transform: scale(1.15);\n                        margin-top: -6px;\n                      }\n                      100% {\n                        transform: scale(1);\n                        -webkit-transform: scale(1);\n                        margin-top: 0;\n                        opacity: 1;\n                      }\n                    }\n                    @-webkit-keyframes pulseWarning {\n                      0% {\n                        border-color: #F8D486;\n                      }\n                      100% {\n                        border-color: #F8BB86;\n                      }\n                    }\n                    @keyframes pulseWarning {\n                      0% {\n                        border-color: #F8D486;\n                      }\n                      100% {\n                        border-color: #F8BB86;\n                      }\n                    }\n                    @-webkit-keyframes pulseWarningIns {\n                      0% {\n                        background-color: #F8D486;\n                      }\n                      100% {\n                        background-color: #F8BB86;\n                      }\n                    }\n                    @keyframes pulseWarningIns {\n                      0% {\n                        background-color: #F8D486;\n                      }\n                      100% {\n                        background-color: #F8BB86;\n                      }\n                    }'
        ),
        !this.props.hideOverlay && _react2.default.createElement('div', { style: _SweetAlertStyles2.default.overlay, onClick: this.onClickOutside }),
        _react2.default.createElement(
          'div',
          {
            style: (0, _objectAssign2.default)({}, style, this.props.style),
            tabIndex: '0',
            ref: 'container',
            onKeyDown: this.onKeyDown,
            className: 'sweet-alert ' + this.props.customClass
          },
          this.getIcon(),
          _react2.default.createElement(
            _Title2.default,
            null,
            this.props.title
          ),
          _react2.default.createElement(
            _Content2.default,
            null,
            this.props.children
          ),
          this.state.type === 'input' && _react2.default.createElement(_Input2.default, _extends({}, this.props, this.state, {
            type: this.state.type,
            onInputKeyDown: this.onInputKeyDown,
            onChangeInput: this.onChangeInput
          })),
          this.state.showValidationMessage && _react2.default.createElement(_ValidationMessage2.default, this.props),
          _react2.default.createElement(_Buttons2.default, _extends({}, this.props, {
            type: this.state.type,
            onConfirm: this.onConfirm,
            focusConfirmBtn: this.state.focusConfirmBtn
          }))
        )
      );
    }
  }]);

  return SweetAlert;
}(_react2.default.Component);

SweetAlert.propTypes = {
  type: _propTypes2.default.oneOf(['default', 'info', 'success', 'warning', 'danger', 'error', 'input', 'custom']),
  title: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.string]).isRequired,
  onCancel: _propTypes2.default.func,
  onConfirm: _propTypes2.default.func.isRequired,
  confirmBtnText: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.string]),
  confirmBtnBsStyle: _propTypes2.default.oneOf(['default', 'primary', 'link', 'info', 'success', 'warning', 'danger']),
  confirmBtnCssClass: _propTypes2.default.string,
  confirmBtnStyle: _propTypes2.default.object,
  cancelBtnText: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.string]),
  cancelBtnBsStyle: _propTypes2.default.oneOf(['default', 'primary', 'link', 'info', 'success', 'warning', 'danger']),
  cancelBtnCssClass: _propTypes2.default.string,
  cancelBtnStyle: _propTypes2.default.object,
  btnSize: _propTypes2.default.string,
  customIcon: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.string]),
  show: _propTypes2.default.bool,
  required: _propTypes2.default.bool,
  placeholder: _propTypes2.default.string,
  validationMsg: _propTypes2.default.string,
  validationRegex: _propTypes2.default.object,
  defaultValue: _propTypes2.default.string,
  inputType: _propTypes2.default.string,
  style: _propTypes2.default.object,
  customClass: _propTypes2.default.string,
  showConfirm: _propTypes2.default.bool,
  showCancel: _propTypes2.default.bool,
  allowEscape: _propTypes2.default.bool,
  closeOnClickOutside: _propTypes2.default.bool,
  hideOverlay: _propTypes2.default.bool,
  disabled: _propTypes2.default.bool,
  focusConfirmBtn: _propTypes2.default.bool,
  beforeMount: _propTypes2.default.func,
  afterMount: _propTypes2.default.func,
  beforeUpdate: _propTypes2.default.func,
  afterUpdate: _propTypes2.default.func,
  beforeUnmount: _propTypes2.default.func,
  timeout: _propTypes2.default.number
};
SweetAlert.defaultProps = {
  allowEscape: true,
  closeOnClickOutside: true,
  validationMsg: null,
  validationRegex: null,
  inputType: 'text',
  customClass: '',
  hideOverlay: false,
  show: true,
  required: true,
  disabled: false,
  focusConfirmBtn: true,
  beforeMount: function beforeMount() {},
  afterMount: function afterMount() {},
  beforeUpdate: function beforeUpdate() {},
  afterUpdate: function afterUpdate() {},
  beforeUnmount: function beforeUnmount() {},
  timeout: 0
};
SweetAlert.SuccessIcon = _SuccessIcon2.default;
SweetAlert.ErrorIcon = _ErrorIcon2.default;
SweetAlert.InfoIcon = _InfoIcon2.default;
SweetAlert.WarningIcon = _WarningIcon2.default;
SweetAlert.CustomIcon = _CustomIcon2.default;
SweetAlert.Buttons = _Buttons2.default;
SweetAlert.Input = _Input2.default;
SweetAlert.ValidationMessage = _ValidationMessage2.default;
SweetAlert.Title = _Title2.default;
SweetAlert.Content = _Content2.default;
exports.default = SweetAlert;

/***/ }),
/* 1325 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _objectAssign = __webpack_require__(57);

var _objectAssign2 = _interopRequireDefault(_objectAssign);

var _SweetAlertStyles = __webpack_require__(80);

var _SweetAlertStyles2 = _interopRequireDefault(_SweetAlertStyles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
    return _react2.default.createElement(
        'div',
        { style: (0, _objectAssign2.default)({}, _SweetAlertStyles2.default.icon, _SweetAlertStyles2.default.iconSuccess) },
        _react2.default.createElement('div', { style: (0, _objectAssign2.default)({}, _SweetAlertStyles2.default.iconSuccessBeforeAfter, _SweetAlertStyles2.default.iconSuccessBefore) }),
        _react2.default.createElement('span', { style: (0, _objectAssign2.default)({}, _SweetAlertStyles2.default.iconSuccessLine, _SweetAlertStyles2.default.iconSuccessLineTip) }),
        _react2.default.createElement('span', { style: (0, _objectAssign2.default)({}, _SweetAlertStyles2.default.iconSuccessLine, _SweetAlertStyles2.default.iconSuccessLineLong) }),
        _react2.default.createElement('div', { style: _SweetAlertStyles2.default.iconSuccessPlaceholder }),
        _react2.default.createElement('div', { style: _SweetAlertStyles2.default.iconSuccessFix }),
        _react2.default.createElement('div', { style: (0, _objectAssign2.default)({}, _SweetAlertStyles2.default.iconSuccessBeforeAfter, _SweetAlertStyles2.default.iconSuccessAfter) })
    );
};

/***/ }),
/* 1326 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _objectAssign = __webpack_require__(57);

var _objectAssign2 = _interopRequireDefault(_objectAssign);

var _SweetAlertStyles = __webpack_require__(80);

var _SweetAlertStyles2 = _interopRequireDefault(_SweetAlertStyles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
	return _react2.default.createElement(
		'div',
		{ style: (0, _objectAssign2.default)({}, _SweetAlertStyles2.default.icon, _SweetAlertStyles2.default.iconError) },
		_react2.default.createElement(
			'span',
			{ style: _SweetAlertStyles2.default.iconErrorX },
			_react2.default.createElement('span', { style: (0, _objectAssign2.default)({}, _SweetAlertStyles2.default.iconErrorLine, _SweetAlertStyles2.default.iconErrorLineLeft) }),
			_react2.default.createElement('span', { style: (0, _objectAssign2.default)({}, _SweetAlertStyles2.default.iconErrorLine, _SweetAlertStyles2.default.iconErrorLineRight) })
		)
	);
};

/***/ }),
/* 1327 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
       value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _objectAssign = __webpack_require__(57);

var _objectAssign2 = _interopRequireDefault(_objectAssign);

var _SweetAlertStyles = __webpack_require__(80);

var _SweetAlertStyles2 = _interopRequireDefault(_SweetAlertStyles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
       return _react2.default.createElement(
              'div',
              { style: (0, _objectAssign2.default)({}, _SweetAlertStyles2.default.icon, _SweetAlertStyles2.default.iconInfo) },
              _react2.default.createElement('div', { style: _SweetAlertStyles2.default.iconInfoBefore }),
              _react2.default.createElement('div', { style: _SweetAlertStyles2.default.iconInfoAfter })
       );
};

/***/ }),
/* 1328 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _objectAssign = __webpack_require__(57);

var _objectAssign2 = _interopRequireDefault(_objectAssign);

var _SweetAlertStyles = __webpack_require__(80);

var _SweetAlertStyles2 = _interopRequireDefault(_SweetAlertStyles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
	return _react2.default.createElement(
		'div',
		{ style: (0, _objectAssign2.default)({}, _SweetAlertStyles2.default.icon, _SweetAlertStyles2.default.iconWarning) },
		_react2.default.createElement('span', { style: _SweetAlertStyles2.default.iconWarningBody }),
		_react2.default.createElement('span', { style: _SweetAlertStyles2.default.iconWarningDot })
	);
};

/***/ }),
/* 1329 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _objectAssign = __webpack_require__(57);

var _objectAssign2 = _interopRequireDefault(_objectAssign);

var _SweetAlertStyles = __webpack_require__(80);

var _SweetAlertStyles2 = _interopRequireDefault(_SweetAlertStyles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var style = (0, _objectAssign2.default)({}, _SweetAlertStyles2.default.icon, _SweetAlertStyles2.default.iconCustom);

exports.default = function (_ref) {
    var iconUrl = _ref.iconUrl;
    return _react2.default.createElement('div', { style: (0, _objectAssign2.default)({}, style, { backgroundImage: 'url(' + iconUrl + ')' }) });
};

/***/ }),
/* 1330 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _objectAssign = __webpack_require__(57);

var _objectAssign2 = _interopRequireDefault(_objectAssign);

var _SweetAlertStyles = __webpack_require__(80);

var _SweetAlertStyles2 = _interopRequireDefault(_SweetAlertStyles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Buttons = function (_React$Component) {
    _inherits(Buttons, _React$Component);

    function Buttons() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, Buttons);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Buttons.__proto__ || Object.getPrototypeOf(Buttons)).call.apply(_ref, [this].concat(args))), _this), _this.buttonStyles = {}, _this.getButtonStyle = function (bsStyle) {
            if (bsStyle === 'error') bsStyle = 'danger';
            if (_this.buttonStyles[bsStyle] == null) {
                var style = Buttons.styles[bsStyle] || Buttons.styles.default;
                var borderColor = 'borderColor: ' + style.borderColor + ' !important';
                var boxShadow = 'boxShadow: inset 0 1px 1px rgba(0,0,0,.075), 0 0 8px ' + style.shadowColor + ' !important;';
                _this.buttonStyles[bsStyle] = ' ' + borderColor + ' ' + boxShadow;
            }
            return _this.buttonStyles[bsStyle];
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(Buttons, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.focusButton();
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps, prevState) {
            var _this2 = this;

            // when displaying back to back alerts React will treat this
            // as an update to the same alert. this causes componentDidMount
            // to not be called for the subsequent alerts. i hope to find a better
            // way to handle this in the future, but for now i'm checking if the
            // title, type, or button text has changed
            if (prevProps.type !== this.props.type || prevProps.confirmBtnText !== this.props.confirmBtnText || prevProps.title !== this.props.title) {
                setTimeout(function () {
                    return _this2.focusButton();
                }, 0);
            }
        }
    }, {
        key: 'focusButton',
        value: function focusButton() {
            if (this.props.focusConfirmBtn && this.refs.confirmBtn) {
                try {
                    this.refs.confirmBtn.focus();
                } catch (e) {
                    // whoops
                }
            }
        }
    }, {
        key: 'render',
        value: function render() {
            if (!this.props.showConfirm && !this.props.showCancel) {
                return false;
            }
            var cancelBtnBsStyle = this.props.cancelBtnBsStyle === 'error' ? 'danger' : this.props.cancelBtnBsStyle;
            var confirmBtnBsStyle = this.props.confirmBtnBsStyle === 'error' ? 'danger' : this.props.confirmBtnBsStyle;
            return _react2.default.createElement(
                'p',
                { style: { marginTop: 20 } },
                this.props.showCancel && _react2.default.createElement(
                    'span',
                    null,
                    _react2.default.createElement(
                        'style',
                        { type: 'text/css', scoped: true },
                        'button { outline: 0 !important; ' + this.getButtonStyle(cancelBtnBsStyle) + '}'
                    ),
                    _react2.default.createElement(
                        'button',
                        {
                            style: (0, _objectAssign2.default)({}, _SweetAlertStyles2.default.button, this.props.cancelBtnStyle),
                            className: 'btn btn-' + this.props.btnSize + ' btn-' + cancelBtnBsStyle + ' ' + this.props.cancelBtnCssClass,
                            onClick: this.props.onCancel,
                            type: 'button' },
                        this.props.cancelBtnText
                    )
                ),
                this.props.showConfirm && _react2.default.createElement(
                    'span',
                    null,
                    _react2.default.createElement(
                        'style',
                        { type: 'text/css', scoped: true },
                        'button { outline: 0 !important; ' + this.getButtonStyle(confirmBtnBsStyle) + '}'
                    ),
                    _react2.default.createElement(
                        'button',
                        {
                            ref: 'confirmBtn',
                            disabled: this.props.disabled,
                            style: (0, _objectAssign2.default)({}, _SweetAlertStyles2.default.button, this.props.confirmBtnStyle),
                            className: 'btn btn-' + this.props.btnSize + ' btn-' + confirmBtnBsStyle + ' ' + this.props.confirmBtnCssClass,
                            onClick: this.props.onConfirm,
                            type: 'button' },
                        this.props.confirmBtnText
                    )
                )
            );
        }
    }]);

    return Buttons;
}(_react2.default.Component);

Buttons.propTypes = {
    confirmBtnText: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.string]),
    confirmBtnBsStyle: _propTypes2.default.oneOf(['default', 'primary', 'link', 'info', 'success', 'warning', 'danger']),
    confirmBtnCssClass: _propTypes2.default.string,
    confirmBtnStyle: _propTypes2.default.object,
    cancelBtnText: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.string]),
    cancelBtnBsStyle: _propTypes2.default.oneOf(['default', 'primary', 'link', 'info', 'success', 'warning', 'danger']),
    cancelBtnCssClass: _propTypes2.default.string,
    cancelBtnStyle: _propTypes2.default.object,
    btnSize: _propTypes2.default.string,
    onCancel: _propTypes2.default.func,
    onConfirm: _propTypes2.default.func,
    showConfirm: _propTypes2.default.bool,
    showCancel: _propTypes2.default.bool,
    focusConfirmBtn: _propTypes2.default.bool
};
Buttons.defaultProps = {
    confirmBtnText: 'OK',
    confirmBtnBsStyle: 'primary',
    confirmBtnCssClass: '',
    confirmBtnStyle: {},
    cancelBtnText: 'Cancel',
    cancelBtnBsStyle: 'link',
    cancelBtnCssClass: '',
    cancelBtnStyle: {},
    focusConfirmBtn: true,
    showConfirm: true,
    showCancel: false,
    btnSize: 'lg'
};
Buttons.styles = {
    primary: {
        borderColor: '#286090',
        shadowColor: 'rgb(165, 202, 234)'
    },
    success: {
        borderColor: '#4cae4c',
        shadowColor: 'rgba(76, 174, 76, 0.6)'
    },
    info: {
        borderColor: '#46b8da',
        shadowColor: 'rgba(70, 184, 218, 0.6)'
    },
    danger: {
        borderColor: '#d43f3a',
        shadowColor: 'rgba(212, 63, 58, 0.6)'
    },
    warning: {
        borderColor: '#eea236',
        shadowColor: 'rgba(238, 162, 54, 0.6)'
    },
    default: {
        borderColor: '#cccccc',
        shadowColor: 'rgba(204, 204, 204, 0.6)'
    }
};
exports.default = Buttons;

/***/ }),
/* 1331 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _objectAssign = __webpack_require__(57);

var _objectAssign2 = _interopRequireDefault(_objectAssign);

var _SweetAlertStyles = __webpack_require__(80);

var _SweetAlertStyles2 = _interopRequireDefault(_SweetAlertStyles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Input = function (_React$Component) {
	_inherits(Input, _React$Component);

	function Input() {
		_classCallCheck(this, Input);

		return _possibleConstructorReturn(this, (Input.__proto__ || Object.getPrototypeOf(Input)).apply(this, arguments));
	}

	_createClass(Input, [{
		key: 'componentDidMount',
		value: function componentDidMount() {
			if (this.props.type === 'input') {
				try {
					this.refs.input.focus();
				} catch (e) {
					// whoops
				}
			}
		}
	}, {
		key: 'render',
		value: function render() {
			return _react2.default.createElement(
				'div',
				{ style: { position: 'relative' } },
				this.props.inputType === 'textarea' ? _react2.default.createElement('textarea', {
					ref: 'input',
					rows: 4,
					className: 'form-control',
					value: this.props.inputValue || '',
					onChange: this.props.onChangeInput,
					onKeyDown: this.props.onInputKeyDown,
					placeholder: this.props.placeholder }) : _react2.default.createElement('input', {
					type: this.props.inputType,
					ref: 'input',
					className: 'form-control',
					value: this.props.inputValue || '',
					onChange: this.props.onChangeInput,
					onKeyDown: this.props.onInputKeyDown,
					placeholder: this.props.placeholder }),
				this.props.showValidationMessage && _react2.default.createElement(
					'div',
					{ style: _SweetAlertStyles2.default.inputErrorIcon },
					_react2.default.createElement('div', { style: (0, _objectAssign2.default)({}, _SweetAlertStyles2.default.inputErrorIconBeforeAfter, _SweetAlertStyles2.default.inputErrorIconBefore) }),
					_react2.default.createElement('div', { style: (0, _objectAssign2.default)({}, _SweetAlertStyles2.default.inputErrorIconBeforeAfter, _SweetAlertStyles2.default.inputErrorIconAfter) })
				)
			);
		}
	}]);

	return Input;
}(_react2.default.Component);

exports.default = Input;

/***/ }),
/* 1332 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _SweetAlertStyles = __webpack_require__(80);

var _SweetAlertStyles2 = _interopRequireDefault(_SweetAlertStyles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultMessage = 'Please enter a response!';
var emailMessage = 'Please enter a valid email!';

exports.default = function (_ref) {
    var validationMsg = _ref.validationMsg,
        inputType = _ref.inputType;

    var message = validationMsg || (inputType === 'email' ? emailMessage : defaultMessage);

    return _react2.default.createElement(
        'div',
        { style: _SweetAlertStyles2.default.validationMessage },
        _react2.default.createElement(
            'div',
            { style: _SweetAlertStyles2.default.exclamationIcon },
            '!'
        ),
        message
    );
};

/***/ }),
/* 1333 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (_ref) {
  var children = _ref.children;
  return _react2.default.createElement(
    'h2',
    null,
    children
  );
};

/***/ }),
/* 1334 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (_ref) {
    var children = _ref.children;
    return _react2.default.createElement(
        'div',
        { className: 'text-muted lead' },
        children
    );
};

/***/ }),
/* 1335 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_perfect_scrollbar__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_perfect_scrollbar_css_perfect_scrollbar_css__ = __webpack_require__(363);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_perfect_scrollbar_css_perfect_scrollbar_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_perfect_scrollbar_css_perfect_scrollbar_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_styles_withStyles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_styles_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_styles_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_Header_Header_jsx__ = __webpack_require__(1336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_Footer_Footer_jsx__ = __webpack_require__(588);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_Sidebar_Sidebar_jsx__ = __webpack_require__(2321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_routes_dashboard_jsx__ = __webpack_require__(2324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_assets_jss_material_dashboard_pro_react_layouts_dashboardStyle_jsx__ = __webpack_require__(2858);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_assets_img_sureqoute2_png__ = __webpack_require__(2859);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_assets_img_sureqoute2_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_assets_img_sureqoute2_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_reducers_LoginReducer__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__store__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_helpers_UserHelper__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__hoc_NotificationWrapper__ = __webpack_require__(244);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// creates a beautiful scrollbar
// @material-ui/core components
// core components
var CLICK="sure-quote/Login/CLICK";var switchRoutes=function switchRoutes(scrollMethod){if(!localStorage.getItem("token")&&__WEBPACK_IMPORTED_MODULE_14__store__["a" /* default */].getState().login.token===""){Object(__WEBPACK_IMPORTED_MODULE_15_helpers_UserHelper__["d" /* Logout */])();return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["b" /* Redirect */],{to:"/app/portal/login"});}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["e" /* Switch */],null,__WEBPACK_IMPORTED_MODULE_10_routes_dashboard_jsx__["a" /* default */].map(function(prop,key){if(prop.redirect)return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["b" /* Redirect */],{from:prop.path,to:prop.pathTo,key:key});if(prop.collapse)return prop.views.map(function(prop,key){var Component=prop.component;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["c" /* Route */],{path:prop.path,key:key,render:function render(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component,Object.assign({},props,{scrollMeBar:scrollMethod}));}});});var Component=prop.component;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["c" /* Route */],{path:prop.path,key:key,render:function render(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component,Object.assign({},props,{scrollMeBar:scrollMethod}));}});}));}};var ps;var Dashboard=function(_React$Component){_inherits(Dashboard,_React$Component);function Dashboard(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Dashboard);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Dashboard.__proto__||Object.getPrototypeOf(Dashboard)).call.apply(_ref,[this].concat(args))),_this),_this.state={mobileOpen:false,miniActive:false,cookieTimeout:false},_this.handleDrawerToggle=function(){_this.setState({mobileOpen:!_this.state.mobileOpen});},_this.scrollMeBar=function(){if(ps){_this.refs.mainPanel.scrollTop=0;ps.update();}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Dashboard,[{key:"getRoute",value:function getRoute(){return this.props.location.pathname!=="/maps/full-screen-maps";}},{key:"componentDidMount",value:function componentDidMount(){if(navigator.platform.indexOf("Win")>-1){ps=new __WEBPACK_IMPORTED_MODULE_4_perfect_scrollbar__["a" /* default */](this.refs.mainPanel,{suppressScrollX:true,suppressScrollY:false});document.body.style.overflow="hidden";}__WEBPACK_IMPORTED_MODULE_14__store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_13_reducers_LoginReducer__["b" /* Click */])({type:CLICK,props:localStorage}));var hours=4;// Reset when storage is more than 24hours
var now=new Date().getTime();var setupTime=localStorage.getItem("setupTime");if(setupTime==null){localStorage.setItem("setupTime",now);}else{if(now-setupTime>hours*60*60*1000){Object(__WEBPACK_IMPORTED_MODULE_15_helpers_UserHelper__["d" /* Logout */])();localStorage.setItem("setupTime",now);this.setState({cookieTimeout:false});}}}},{key:"componentWillUnmount",value:function componentWillUnmount(){if(navigator.platform.indexOf("Win")>-1){ps.destroy();}}},{key:"componentDidUpdate",value:function componentDidUpdate(e){if(e.history.location.pathname!==e.location.pathname){this.refs.mainPanel.scrollTop=0;if(this.state.mobileOpen){this.setState({mobileOpen:false});}}}},{key:"sidebarMinimize",value:function sidebarMinimize(){this.setState({miniActive:!this.state.miniActive});}},{key:"render",value:function render(){var _cx;if(this.state.cookieTimeout){this.setState({cookieTimeout:false});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["b" /* Redirect */],{to:"/app/portal/login"});}var _props=this.props,classes=_props.classes,rest=_objectWithoutProperties(_props,["classes"]);var mainPanel=classes.mainPanel+" mainPanelYes "+__WEBPACK_IMPORTED_MODULE_1_classnames___default()((_cx={},_defineProperty(_cx,classes.mainPanelSidebarMini,this.state.miniActive),_defineProperty(_cx,classes.mainPanelWithPerfectScrollbar,navigator.platform.indexOf("Win")>-1),_cx));return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__hoc_NotificationWrapper__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:classes.wrapper},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Sidebar_Sidebar_jsx__["a" /* default */],Object.assign({routes:__WEBPACK_IMPORTED_MODULE_10_routes_dashboard_jsx__["a" /* default */],logoText:"Creative Tim",logo:__WEBPACK_IMPORTED_MODULE_12_assets_img_sureqoute2_png___default.a,handleDrawerToggle:this.handleDrawerToggle,open:this.state.mobileOpen,color:"deepPurple",bgColor:"black",miniActive:this.state.miniActive},rest)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:mainPanel,ref:"mainPanel"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_Header_Header_jsx__["a" /* default */],Object.assign({logo:__WEBPACK_IMPORTED_MODULE_12_assets_img_sureqoute2_png___default.a,logoText:"SureQuote",sidebarMinimize:this.sidebarMinimize.bind(this),miniActive:this.state.miniActive,routes:__WEBPACK_IMPORTED_MODULE_10_routes_dashboard_jsx__["a" /* default */],handleDrawerToggle:this.handleDrawerToggle},rest)),this.getRoute()?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:classes.content},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:classes.container},switchRoutes(this.scrollMeBar))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:classes.map},switchRoutes(this.scrollMeBar)),this.getRoute()?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_Footer_Footer_jsx__["a" /* default */],{fluid:true}):null)));}}]);return Dashboard;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);Dashboard.propTypes={classes:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired};/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_6__material_ui_core_styles_withStyles___default()(__WEBPACK_IMPORTED_MODULE_11_assets_jss_material_dashboard_pro_react_layouts_dashboardStyle_jsx__["a" /* default */])(Dashboard));

/***/ }),
/* 1336 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_core__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_AppBar__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_AppBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_AppBar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_Hidden__ = __webpack_require__(327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_Hidden___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Hidden__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Toolbar__ = __webpack_require__(331);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Toolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Toolbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_icons__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_icons_Menu__ = __webpack_require__(577);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_icons_Menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_icons_Menu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_assets_jss_material_dashboard_pro_react_components_headerStyle_jsx__ = __webpack_require__(2288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_CustomButtons_Button_jsx__ = __webpack_require__(2289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_SqTasks_TaskList_jsx__ = __webpack_require__(579);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_reducers_TasksReducer__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_store__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Header_css__ = __webpack_require__(2317);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Header_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__Header_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__HeaderLinks__ = __webpack_require__(2318);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}// @material-ui/core components
// material-ui icons
// core components
function Header(_ref){var props=_objectWithoutProperties(_ref,[]);var logo=props.logo;function handleOpenTask(){__WEBPACK_IMPORTED_MODULE_14_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_13_reducers_TasksReducer__["h" /* toggleProgressOpen */])());}function goToHome(e){props.history.push({pathname:'/app/home'});}var classes=props.classes,color=props.color,rtlActive=props.rtlActive;var appBarClasses=__WEBPACK_IMPORTED_MODULE_8_classnames___default()(_defineProperty({},' '+classes[color],color));var sidebarMinimize=classes.sidebarMinimize+' '+__WEBPACK_IMPORTED_MODULE_8_classnames___default()(_defineProperty({},classes.sidebarMinimizeRTL,rtlActive));var brand=__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div',{className:'logoContainer'},__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div',{className:classes.logo},__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('a',{href:'',onClick:function onClick(e){return goToHome(e);},className:classes.logoMini},__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('img',{src:logo,alt:'logo',className:classes.img,style:{marginTop:'-30px',width:'125px',marginBottom:'8px'}}))));return __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div',{className:'appBarHeaderSQ'},__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_AppBar___default.a,{className:classes.appBar+appBarClasses},__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Toolbar___default.a,{className:classes.container},__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Hidden___default.a,{smDown:true},__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div',{className:sidebarMinimize})),__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div',{className:classes.flex,style:{textAlign:'center',display:'flex'}},brand),__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Hidden___default.a,{smDown:true,implementation:'css'},__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__HeaderLinks__["a" /* default */],{rtlActive:rtlActive})),__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Hidden___default.a,{mdUp:true},__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["x" /* IconButton */],{onClick:function onClick(){return handleOpenTask();}},__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_icons__["b" /* Assessment */],null)),__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_SqTasks_TaskList_jsx__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_CustomButtons_Button_jsx__["a" /* default */],{className:classes.appResponsive,color:'transparent',justIcon:true,'aria-label':'open drawer',onClick:props.handleDrawerToggle},__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_icons_Menu___default.a,null))))));}Header.propTypes={classes:__WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.object.isRequired,color:__WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.oneOf(['primary','info','success','warning','danger']),rtlActive:__WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.bool};/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles___default()(__WEBPACK_IMPORTED_MODULE_7_assets_jss_material_dashboard_pro_react_components_headerStyle_jsx__["a" /* default */])(Header));

/***/ }),
/* 1337 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M22 5.72l-4.6-3.86-1.29 1.53 4.6 3.86L22 5.72zM7.88 3.39L6.6 1.86 2 5.71l1.29 1.53 4.59-3.85zM12.5 8H11v6l4.75 2.85.75-1.23-4-2.37V8zM12 4c-4.97 0-9 4.03-9 9s4.02 9 9 9c4.97 0 9-4.03 9-9s-4.03-9-9-9zm0 16c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z"
})), 'AccessAlarm');

exports.default = _default;

/***/ }),
/* 1338 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M22 5.7l-4.6-3.9-1.3 1.5 4.6 3.9L22 5.7zM7.9 3.4L6.6 1.9 2 5.7l1.3 1.5 4.6-3.8zM12.5 8H11v6l4.7 2.9.8-1.2-4-2.4V8zM12 4c-5 0-9 4-9 9s4 9 9 9 9-4 9-9-4-9-9-9zm0 16c-3.9 0-7-3.1-7-7s3.1-7 7-7 7 3.1 7 7-3.1 7-7 7z"
})), 'AccessAlarms');

exports.default = _default;

/***/ }),
/* 1339 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 2c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zm9 7h-6v13h-2v-6h-2v6H9V9H3V7h18v2z"
})), 'Accessibility');

exports.default = _default;

/***/ }),
/* 1340 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("circle", {
  cx: "12",
  cy: "4",
  r: "2"
}), _react.default.createElement("path", {
  d: "M19 13v-2c-1.54.02-3.09-.75-4.07-1.83l-1.29-1.43c-.17-.19-.38-.34-.61-.45-.01 0-.01-.01-.02-.01H13c-.35-.2-.75-.3-1.19-.26C10.76 7.11 10 8.04 10 9.09V15c0 1.1.9 2 2 2h5v5h2v-5.5c0-1.1-.9-2-2-2h-3v-3.45c1.29 1.07 3.25 1.94 5 1.95zm-6.17 5c-.41 1.16-1.52 2-2.83 2-1.66 0-3-1.34-3-3 0-1.31.84-2.41 2-2.83V12.1c-2.28.46-4 2.48-4 4.9 0 2.76 2.24 5 5 5 2.42 0 4.44-1.72 4.9-4h-2.07z"
})), 'Accessible');

exports.default = _default;

/***/ }),
/* 1341 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67z"
})), 'AccessTime');

exports.default = _default;

/***/ }),
/* 1342 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M4 10v7h3v-7H4zm6 0v7h3v-7h-3zM2 22h19v-3H2v3zm14-12v7h3v-7h-3zm-4.5-9L2 6v2h19V6l-9.5-5z"
})), 'AccountBalance');

exports.default = _default;

/***/ }),
/* 1343 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M21 18v1c0 1.1-.9 2-2 2H5c-1.11 0-2-.9-2-2V5c0-1.1.89-2 2-2h14c1.1 0 2 .9 2 2v1h-9c-1.11 0-2 .9-2 2v8c0 1.1.89 2 2 2h9zm-9-2h10V8H12v8zm4-2.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"
})), 'AccountBalanceWallet');

exports.default = _default;

/***/ }),
/* 1344 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M3 5v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2H5c-1.11 0-2 .9-2 2zm12 4c0 1.66-1.34 3-3 3s-3-1.34-3-3 1.34-3 3-3 3 1.34 3 3zm-9 8c0-2 4-3.1 6-3.1s6 1.1 6 3.1v1H6v-1z"
})), 'AccountBox');

exports.default = _default;

/***/ }),
/* 1345 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 3c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm0 14.2c-2.5 0-4.71-1.28-6-3.22.03-1.99 4-3.08 6-3.08 1.99 0 5.97 1.09 6 3.08-1.29 1.94-3.5 3.22-6 3.22z"
})), 'AccountCircle');

exports.default = _default;

/***/ }),
/* 1346 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M22 11h-4.17l3.24-3.24-1.41-1.42L15 11h-2V9l4.66-4.66-1.42-1.41L13 6.17V2h-2v4.17L7.76 2.93 6.34 4.34 11 9v2H9L4.34 6.34 2.93 7.76 6.17 11H2v2h4.17l-3.24 3.24 1.41 1.42L9 13h2v2l-4.66 4.66 1.42 1.41L11 17.83V22h2v-4.17l3.24 3.24 1.42-1.41L13 15v-2h2l4.66 4.66 1.41-1.42L17.83 13H22z"
})), 'AcUnit');

exports.default = _default;

/***/ }),
/* 1347 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M5 16c0 3.87 3.13 7 7 7s7-3.13 7-7v-4H5v4zM16.12 4.37l2.1-2.1-.82-.83-2.3 2.31C14.16 3.28 13.12 3 12 3s-2.16.28-3.09.75L6.6 1.44l-.82.83 2.1 2.1C6.14 5.64 5 7.68 5 10v1h14v-1c0-2.32-1.14-4.36-2.88-5.63zM9 9c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm6 0c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"
})), 'Adb');

exports.default = _default;

/***/ }),
/* 1348 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"
})), 'Add');

exports.default = _default;

/***/ }),
/* 1349 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M7.88 3.39L6.6 1.86 2 5.71l1.29 1.53 4.59-3.85zM22 5.72l-4.6-3.86-1.29 1.53 4.6 3.86L22 5.72zM12 4c-4.97 0-9 4.03-9 9s4.02 9 9 9c4.97 0 9-4.03 9-9s-4.03-9-9-9zm0 16c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7zm1-11h-2v3H8v2h3v3h2v-3h3v-2h-3V9z"
})), 'AddAlarm');

exports.default = _default;

/***/ }),
/* 1350 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M10.01 21.01c0 1.1.89 1.99 1.99 1.99s1.99-.89 1.99-1.99h-3.98zm8.87-4.19V11c0-3.25-2.25-5.97-5.29-6.69v-.72C13.59 2.71 12.88 2 12 2s-1.59.71-1.59 1.59v.72C7.37 5.03 5.12 7.75 5.12 11v5.82L3 18.94V20h18v-1.06l-2.12-2.12zM16 13.01h-3v3h-2v-3H8V11h3V8h2v3h3v2.01z"
})), 'AddAlert');

exports.default = _default;

/***/ }),
/* 1351 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M3 4V1h2v3h3v2H5v3H3V6H0V4h3zm3 6V7h3V4h7l1.83 2H21c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H5c-1.1 0-2-.9-2-2V10h3zm7 9c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm-3.2-5c0 1.77 1.43 3.2 3.2 3.2s3.2-1.43 3.2-3.2-1.43-3.2-3.2-3.2-3.2 1.43-3.2 3.2z"
})), 'AddAPhoto');

exports.default = _default;

/***/ }),
/* 1352 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 10h-4v4h-2v-4H7v-2h4V7h2v4h4v2z"
})), 'AddBox');

exports.default = _default;

/***/ }),
/* 1353 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm5 11h-4v4h-2v-4H7v-2h4V7h2v4h4v2z"
})), 'AddCircle');

exports.default = _default;

/***/ }),
/* 1354 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M13 7h-2v4H7v2h4v4h2v-4h4v-2h-4V7zm-1-5C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
})), 'AddCircleOutline');

exports.default = _default;

/***/ }),
/* 1355 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 2C8.14 2 5 5.14 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.86-3.14-7-7-7zm4 8h-3v3h-2v-3H8V8h3V5h2v3h3v2z"
})), 'AddLocation');

exports.default = _default;

/***/ }),
/* 1356 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M11 9h2V6h3V4h-3V1h-2v3H8v2h3v3zm-4 9c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2zm10 0c-1.1 0-1.99.9-1.99 2s.89 2 1.99 2 2-.9 2-2-.9-2-2-2zm-9.83-3.25l.03-.12.9-1.63h7.45c.75 0 1.41-.41 1.75-1.03l3.86-7.01L19.42 4h-.01l-1.1 2-2.76 5H8.53l-.13-.27L6.16 6l-.95-2-.94-2H1v2h2l3.6 7.59-1.35 2.45c-.16.28-.25.61-.25.96 0 1.1.9 2 2 2h12v-2H7.42c-.13 0-.25-.11-.25-.25z"
})), 'AddShoppingCart');

exports.default = _default;

/***/ }),
/* 1357 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm16-4H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-1 9h-4v4h-2v-4H9V9h4V5h2v4h4v2z"
})), 'AddToPhotos');

exports.default = _default;

/***/ }),
/* 1358 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M21 3H3c-1.11 0-2 .89-2 2v12c0 1.1.89 2 2 2h5v2h8v-2h5c1.1 0 1.99-.9 1.99-2L23 5c0-1.11-.9-2-2-2zm0 14H3V5h18v12zm-5-7v2h-3v3h-2v-3H8v-2h3V7h2v3h3z"
})), 'AddToQueue');

exports.default = _default;

/***/ }),
/* 1359 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 2C6.49 2 2 6.49 2 12s4.49 10 10 10 10-4.49 10-10S17.51 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm3-8c0 1.66-1.34 3-3 3s-3-1.34-3-3 1.34-3 3-3 3 1.34 3 3z"
})), 'Adjust');

exports.default = _default;

/***/ }),
/* 1360 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M22 11v2H9V7h9c2.21 0 4 1.79 4 4zM2 14v2h6v2h8v-2h6v-2H2zm5.14-1.9c1.16-1.19 1.14-3.08-.04-4.24-1.19-1.16-3.08-1.14-4.24.04-1.16 1.19-1.14 3.08.04 4.24 1.19 1.16 3.08 1.14 4.24-.04z"
})), 'AirlineSeatFlat');

exports.default = _default;

/***/ }),
/* 1361 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M22.25 14.29l-.69 1.89L9.2 11.71l2.08-5.66 8.56 3.09c2.1.76 3.18 3.06 2.41 5.15zM1.5 12.14L8 14.48V19h8v-1.63L20.52 19l.69-1.89-19.02-6.86-.69 1.89zm5.8-1.94c1.49-.72 2.12-2.51 1.41-4C7.99 4.71 6.2 4.08 4.7 4.8c-1.49.71-2.12 2.5-1.4 4 .71 1.49 2.5 2.12 4 1.4z"
})), 'AirlineSeatFlatAngled');

exports.default = _default;

/***/ }),
/* 1362 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M7 13c1.65 0 3-1.35 3-3S8.65 7 7 7s-3 1.35-3 3 1.35 3 3 3zm12-6h-8v7H3V7H1v10h22v-6c0-2.21-1.79-4-4-4z"
})), 'AirlineSeatIndividualSuite');

exports.default = _default;

/***/ }),
/* 1363 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M4 12V3H2v9c0 2.76 2.24 5 5 5h6v-2H7c-1.66 0-3-1.34-3-3zm18.83 5.24c-.38-.72-1.29-.97-2.03-.63l-1.09.5-3.41-6.98c-.34-.68-1.03-1.12-1.79-1.12L11 9V3H5v8c0 1.66 1.34 3 3 3h7l3.41 7 3.72-1.7c.77-.36 1.1-1.3.7-2.06z"
})), 'AirlineSeatLegroomExtra');

exports.default = _default;

/***/ }),
/* 1364 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M5 12V3H3v9c0 2.76 2.24 5 5 5h6v-2H8c-1.66 0-3-1.34-3-3zm15.5 6H19v-7c0-1.1-.9-2-2-2h-5V3H6v8c0 1.65 1.35 3 3 3h7v7h4.5c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5z"
})), 'AirlineSeatLegroomNormal');

exports.default = _default;

/***/ }),
/* 1365 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M19.97 19.2c.18.96-.55 1.8-1.47 1.8H14v-3l1-4H9c-1.65 0-3-1.35-3-3V3h6v6h5c1.1 0 2 .9 2 2l-2 7h1.44c.73 0 1.39.49 1.53 1.2zM5 12V3H3v9c0 2.76 2.24 5 5 5h4v-2H8c-1.66 0-3-1.34-3-3z"
})), 'AirlineSeatLegroomReduced');

exports.default = _default;

/***/ }),
/* 1366 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M5.35 5.64c-.9-.64-1.12-1.88-.49-2.79.63-.9 1.88-1.12 2.79-.49.9.64 1.12 1.88.49 2.79-.64.9-1.88 1.12-2.79.49zM16 19H8.93c-1.48 0-2.74-1.08-2.96-2.54L4 7H2l1.99 9.76C4.37 19.2 6.47 21 8.94 21H16v-2zm.23-4h-4.88l-1.03-4.1c1.58.89 3.28 1.54 5.15 1.22V9.99c-1.63.31-3.44-.27-4.69-1.25L9.14 7.47c-.23-.18-.49-.3-.76-.38-.32-.09-.66-.12-.99-.06h-.02c-1.23.22-2.05 1.39-1.84 2.61l1.35 5.92C7.16 16.98 8.39 18 9.83 18h6.85l3.82 3 1.5-1.5-5.77-4.5z"
})), 'AirlineSeatReclineExtra');

exports.default = _default;

/***/ }),
/* 1367 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M7.59 5.41c-.78-.78-.78-2.05 0-2.83.78-.78 2.05-.78 2.83 0 .78.78.78 2.05 0 2.83-.79.79-2.05.79-2.83 0zM6 16V7H4v9c0 2.76 2.24 5 5 5h6v-2H9c-1.66 0-3-1.34-3-3zm14 4.07L14.93 15H11.5v-3.68c1.4 1.15 3.6 2.16 5.5 2.16v-2.16c-1.66.02-3.61-.87-4.67-2.04l-1.4-1.55c-.19-.21-.43-.38-.69-.5-.29-.14-.62-.23-.96-.23h-.03C8.01 7 7 8.01 7 9.25V15c0 1.66 1.34 3 3 3h5.07l3.5 3.5L20 20.07z"
})), 'AirlineSeatReclineNormal');

exports.default = _default;

/***/ }),
/* 1368 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M10.18 9"
}), _react.default.createElement("path", {
  d: "M21 16v-2l-8-5V3.5c0-.83-.67-1.5-1.5-1.5S10 2.67 10 3.5V9l-8 5v2l8-2.5V19l-2 1.5V22l3.5-1 3.5 1v-1.5L13 19v-5.5l8 2.5z"
})), 'AirplanemodeActive');

exports.default = _default;

/***/ }),
/* 1369 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M13 9V3.5c0-.83-.67-1.5-1.5-1.5S10 2.67 10 3.5v3.68l7.83 7.83L21 16v-2l-8-5zM3 5.27l4.99 4.99L2 14v2l8-2.5V19l-2 1.5V22l3.5-1 3.5 1v-1.5L13 19v-3.73L18.73 21 20 19.73 4.27 4 3 5.27z"
})), 'AirplanemodeInactive');

exports.default = _default;

/***/ }),
/* 1370 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M6 22h12l-6-6zM21 3H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h4v-2H3V5h18v12h-4v2h4c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
})), 'Airplay');

exports.default = _default;

/***/ }),
/* 1371 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M17 5H3c-1.1 0-2 .89-2 2v9h2c0 1.65 1.34 3 3 3s3-1.35 3-3h5.5c0 1.65 1.34 3 3 3s3-1.35 3-3H23v-5l-6-6zM3 11V7h4v4H3zm3 6.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm7-6.5H9V7h4v4zm4.5 6.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM15 11V7h1l4 4h-5z"
})), 'AirportShuttle');

exports.default = _default;

/***/ }),
/* 1372 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M22 5.72l-4.6-3.86-1.29 1.53 4.6 3.86L22 5.72zM7.88 3.39L6.6 1.86 2 5.71l1.29 1.53 4.59-3.85zM12.5 8H11v6l4.75 2.85.75-1.23-4-2.37V8zM12 4c-4.97 0-9 4.03-9 9s4.02 9 9 9c4.97 0 9-4.03 9-9s-4.03-9-9-9zm0 16c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z"
})), 'Alarm');

exports.default = _default;

/***/ }),
/* 1373 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M7.88 3.39L6.6 1.86 2 5.71l1.29 1.53 4.59-3.85zM22 5.72l-4.6-3.86-1.29 1.53 4.6 3.86L22 5.72zM12 4c-4.97 0-9 4.03-9 9s4.02 9 9 9c4.97 0 9-4.03 9-9s-4.03-9-9-9zm0 16c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7zm1-11h-2v3H8v2h3v3h2v-3h3v-2h-3V9z"
})), 'AlarmAdd');

exports.default = _default;

/***/ }),
/* 1374 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 6c3.87 0 7 3.13 7 7 0 .84-.16 1.65-.43 2.4l1.52 1.52c.58-1.19.91-2.51.91-3.92 0-4.97-4.03-9-9-9-1.41 0-2.73.33-3.92.91L9.6 6.43C10.35 6.16 11.16 6 12 6zm10-.28l-4.6-3.86-1.29 1.53 4.6 3.86L22 5.72zM2.92 2.29L1.65 3.57 2.98 4.9l-1.11.93 1.42 1.42 1.11-.94.8.8C3.83 8.69 3 10.75 3 13c0 4.97 4.02 9 9 9 2.25 0 4.31-.83 5.89-2.2l2.2 2.2 1.27-1.27L3.89 3.27l-.97-.98zm13.55 16.1C15.26 19.39 13.7 20 12 20c-3.87 0-7-3.13-7-7 0-1.7.61-3.26 1.61-4.47l9.86 9.86zM8.02 3.28L6.6 1.86l-.86.71 1.42 1.42.86-.71z"
})), 'AlarmOff');

exports.default = _default;

/***/ }),
/* 1375 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M22 5.72l-4.6-3.86-1.29 1.53 4.6 3.86L22 5.72zM7.88 3.39L6.6 1.86 2 5.71l1.29 1.53 4.59-3.85zM12 4c-4.97 0-9 4.03-9 9s4.02 9 9 9c4.97 0 9-4.03 9-9s-4.03-9-9-9zm0 16c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7zm-1.46-5.47L8.41 12.4l-1.06 1.06 3.18 3.18 6-6-1.06-1.06-4.93 4.95z"
})), 'AlarmOn');

exports.default = _default;

/***/ }),
/* 1376 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 14.5c-2.49 0-4.5-2.01-4.5-4.5S9.51 7.5 12 7.5s4.5 2.01 4.5 4.5-2.01 4.5-4.5 4.5zm0-5.5c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1z"
})), 'Album');

exports.default = _default;

/***/ }),
/* 1377 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M18.6 6.62c-1.44 0-2.8.56-3.77 1.53L12 10.66 10.48 12h.01L7.8 14.39c-.64.64-1.49.99-2.4.99-1.87 0-3.39-1.51-3.39-3.38S3.53 8.62 5.4 8.62c.91 0 1.76.35 2.44 1.03l1.13 1 1.51-1.34L9.22 8.2C8.2 7.18 6.84 6.62 5.4 6.62 2.42 6.62 0 9.04 0 12s2.42 5.38 5.4 5.38c1.44 0 2.8-.56 3.77-1.53l2.83-2.5.01.01L13.52 12h-.01l2.69-2.39c.64-.64 1.49-.99 2.4-.99 1.87 0 3.39 1.51 3.39 3.38s-1.52 3.38-3.39 3.38c-.9 0-1.76-.35-2.44-1.03l-1.14-1.01-1.51 1.34 1.27 1.12c1.02 1.01 2.37 1.57 3.82 1.57 2.98 0 5.4-2.41 5.4-5.38s-2.42-5.37-5.4-5.37z"
})), 'AllInclusive');

exports.default = _default;

/***/ }),
/* 1378 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M16.21 4.16l4 4v-4zm4 12l-4 4h4zm-12 4l-4-4v4zm-4-12l4-4h-4zm12.95-.95c-2.73-2.73-7.17-2.73-9.9 0s-2.73 7.17 0 9.9 7.17 2.73 9.9 0 2.73-7.16 0-9.9zm-1.1 8.8c-2.13 2.13-5.57 2.13-7.7 0s-2.13-5.57 0-7.7 5.57-2.13 7.7 0 2.13 5.57 0 7.7z"
})), 'AllOut');

exports.default = _default;

/***/ }),
/* 1379 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M6 18c0 .55.45 1 1 1h1v3.5c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5V19h2v3.5c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5V19h1c.55 0 1-.45 1-1V8H6v10zM3.5 8C2.67 8 2 8.67 2 9.5v7c0 .83.67 1.5 1.5 1.5S5 17.33 5 16.5v-7C5 8.67 4.33 8 3.5 8zm17 0c-.83 0-1.5.67-1.5 1.5v7c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5v-7c0-.83-.67-1.5-1.5-1.5zm-4.97-5.84l1.3-1.3c.2-.2.2-.51 0-.71-.2-.2-.51-.2-.71 0l-1.48 1.48C13.85 1.23 12.95 1 12 1c-.96 0-1.86.23-2.66.63L7.85.15c-.2-.2-.51-.2-.71 0-.2.2-.2.51 0 .71l1.31 1.31C6.97 3.26 6 5.01 6 7h12c0-1.99-.97-3.75-2.47-4.84zM10 5H9V4h1v1zm5 0h-1V4h1v1z"
})), 'Android');

exports.default = _default;

/***/ }),
/* 1380 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-7 9h-2V5h2v6zm0 4h-2v-2h2v2z"
})), 'Announcement');

exports.default = _default;

/***/ }),
/* 1381 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M4 8h4V4H4v4zm6 12h4v-4h-4v4zm-6 0h4v-4H4v4zm0-6h4v-4H4v4zm6 0h4v-4h-4v4zm6-10v4h4V4h-4zm-6 4h4V4h-4v4zm6 6h4v-4h-4v4zm0 6h4v-4h-4v4z"
})), 'Apps');

exports.default = _default;

/***/ }),
/* 1382 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20.54 5.23l-1.39-1.68C18.88 3.21 18.47 3 18 3H6c-.47 0-.88.21-1.16.55L3.46 5.23C3.17 5.57 3 6.02 3 6.5V19c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V6.5c0-.48-.17-.93-.46-1.27zM12 17.5L6.5 12H10v-2h4v2h3.5L12 17.5zM5.12 5l.81-1h12l.94 1H5.12z"
})), 'Archive');

exports.default = _default;

/***/ }),
/* 1383 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"
})), 'ArrowBack');

exports.default = _default;

/***/ }),
/* 1384 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20 12l-1.41-1.41L13 16.17V4h-2v12.17l-5.58-5.59L4 12l8 8 8-8z"
})), 'ArrowDownward');

exports.default = _default;

/***/ }),
/* 1385 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M7 10l5 5 5-5z"
})), 'ArrowDropDown');

exports.default = _default;

/***/ }),
/* 1386 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 12l-4-4h8l-4 4z"
})), 'ArrowDropDownCircle');

exports.default = _default;

/***/ }),
/* 1387 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M7 14l5-5 5 5z"
})), 'ArrowDropUp');

exports.default = _default;

/***/ }),
/* 1388 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z"
})), 'ArrowForward');

exports.default = _default;

/***/ }),
/* 1389 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M4 12l1.41 1.41L11 7.83V20h2V7.83l5.58 5.59L20 12l-8-8-8 8z"
})), 'ArrowUpward');

exports.default = _default;

/***/ }),
/* 1390 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M22 13h-8v-2h8v2zm0-6h-8v2h8V7zm-8 10h8v-2h-8v2zm-2-8v6c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V9c0-1.1.9-2 2-2h6c1.1 0 2 .9 2 2zm-1.5 6l-2.25-3-1.75 2.26-1.25-1.51L3.5 15h7z"
})), 'ArtTrack');

exports.default = _default;

/***/ }),
/* 1391 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M19 12h-2v3h-3v2h5v-5zM7 9h3V7H5v5h2V9zm14-6H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16.01H3V4.99h18v14.02z"
})), 'AspectRatio');

exports.default = _default;

/***/ }),
/* 1392 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM9 17H7v-7h2v7zm4 0h-2V7h2v10zm4 0h-2v-4h2v4z"
})), 'Assessment');

exports.default = _default;

/***/ }),
/* 1393 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M19 3h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm2 14H7v-2h7v2zm3-4H7v-2h10v2zm0-4H7V7h10v2z"
})), 'Assignment');

exports.default = _default;

/***/ }),
/* 1394 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M19 3h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm0 4c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm6 12H6v-1.4c0-2 4-3.1 6-3.1s6 1.1 6 3.1V19z"
})), 'AssignmentInd');

exports.default = _default;

/***/ }),
/* 1395 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M19 3h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-6 15h-2v-2h2v2zm0-4h-2V8h2v6zm-1-9c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"
})), 'AssignmentLate');

exports.default = _default;

/***/ }),
/* 1396 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M19 3h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm4 12h-4v3l-5-5 5-5v3h4v4z"
})), 'AssignmentReturn');

exports.default = _default;

/***/ }),
/* 1397 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M19 3h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm0 15l-5-5h3V9h4v4h3l-5 5z"
})), 'AssignmentReturned');

exports.default = _default;

/***/ }),
/* 1398 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M19 3h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm-2 14l-4-4 1.41-1.41L10 14.17l6.59-6.59L18 9l-8 8z"
})), 'AssignmentTurnedIn');

exports.default = _default;

/***/ }),
/* 1399 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M19 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h4l3 3 3-3h4c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-5.12 10.88L12 17l-1.88-4.12L6 11l4.12-1.88L12 5l1.88 4.12L18 11l-4.12 1.88z"
})), 'Assistant');

exports.default = _default;

/***/ }),
/* 1400 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M14.4 6L14 4H5v17h2v-7h5.6l.4 2h7V6z"
})), 'AssistantPhoto');

exports.default = _default;

/***/ }),
/* 1401 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M16.5 6v11.5c0 2.21-1.79 4-4 4s-4-1.79-4-4V5c0-1.38 1.12-2.5 2.5-2.5s2.5 1.12 2.5 2.5v10.5c0 .55-.45 1-1 1s-1-.45-1-1V6H10v9.5c0 1.38 1.12 2.5 2.5 2.5s2.5-1.12 2.5-2.5V5c0-2.21-1.79-4-4-4S7 2.79 7 5v12.5c0 3.04 2.46 5.5 5.5 5.5s5.5-2.46 5.5-5.5V6h-1.5z"
})), 'AttachFile');

exports.default = _default;

/***/ }),
/* 1402 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M2 12.5C2 9.46 4.46 7 7.5 7H18c2.21 0 4 1.79 4 4s-1.79 4-4 4H9.5C8.12 15 7 13.88 7 12.5S8.12 10 9.5 10H17v2H9.41c-.55 0-.55 1 0 1H18c1.1 0 2-.9 2-2s-.9-2-2-2H7.5C5.57 9 4 10.57 4 12.5S5.57 16 7.5 16H17v2H7.5C4.46 18 2 15.54 2 12.5z"
})), 'Attachment');

exports.default = _default;

/***/ }),
/* 1403 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 3v9.28c-.47-.17-.97-.28-1.5-.28C8.01 12 6 14.01 6 16.5S8.01 21 10.5 21c2.31 0 4.2-1.75 4.45-4H15V6h4V3h-7z"
})), 'Audiotrack');

exports.default = _default;

/***/ }),
/* 1404 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 6v3l4-4-4-4v3c-4.42 0-8 3.58-8 8 0 1.57.46 3.03 1.24 4.26L6.7 14.8c-.45-.83-.7-1.79-.7-2.8 0-3.31 2.69-6 6-6zm6.76 1.74L17.3 9.2c.44.84.7 1.79.7 2.8 0 3.31-2.69 6-6 6v-3l-4 4 4 4v-3c4.42 0 8-3.58 8-8 0-1.57-.46-3.03-1.24-4.26z"
})), 'Autorenew');

exports.default = _default;

/***/ }),
/* 1405 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M11 17c0 .55.45 1 1 1s1-.45 1-1-.45-1-1-1-1 .45-1 1zm0-14v4h2V5.08c3.39.49 6 3.39 6 6.92 0 3.87-3.13 7-7 7s-7-3.13-7-7c0-1.68.59-3.22 1.58-4.42L12 13l1.41-1.41-6.8-6.8v.02C4.42 6.45 3 9.05 3 12c0 4.97 4.02 9 9 9 4.97 0 9-4.03 9-9s-4.03-9-9-9h-1zm7 9c0-.55-.45-1-1-1s-1 .45-1 1 .45 1 1 1 1-.45 1-1zM6 12c0 .55.45 1 1 1s1-.45 1-1-.45-1-1-1-1 .45-1 1z"
})), 'AvTimer');

exports.default = _default;

/***/ }),
/* 1406 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M22 3H7c-.69 0-1.23.35-1.59.88L0 12l5.41 8.11c.36.53.9.89 1.59.89h15c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-3 12.59L17.59 17 14 13.41 10.41 17 9 15.59 12.59 12 9 8.41 10.41 7 14 10.59 17.59 7 19 8.41 15.41 12 19 15.59z"
})), 'Backspace');

exports.default = _default;

/***/ }),
/* 1407 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM14 13v4h-4v-4H7l5-5 5 5h-3z"
})), 'Backup');

exports.default = _default;

/***/ }),
/* 1408 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M7 17v3.67C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V17H7z"
}), _react.default.createElement("path", {
  fillOpacity: ".3",
  d: "M17 5.33C17 4.6 16.4 4 15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33V17h10V5.33z"
})), 'Battery20');

exports.default = _default;

/***/ }),
/* 1409 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  fillOpacity: ".3",
  d: "M17 5.33C17 4.6 16.4 4 15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33V15h10V5.33z"
}), _react.default.createElement("path", {
  d: "M7 15v5.67C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V15H7z"
})), 'Battery30');

exports.default = _default;

/***/ }),
/* 1410 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  fillOpacity: ".3",
  d: "M17 5.33C17 4.6 16.4 4 15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33V13h10V5.33z"
}), _react.default.createElement("path", {
  d: "M7 13v7.67C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V13H7z"
})), 'Battery50');

exports.default = _default;

/***/ }),
/* 1411 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  fillOpacity: ".3",
  d: "M17 5.33C17 4.6 16.4 4 15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33V11h10V5.33z"
}), _react.default.createElement("path", {
  d: "M7 11v9.67C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V11H7z"
})), 'Battery60');

exports.default = _default;

/***/ }),
/* 1412 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  fillOpacity: ".3",
  d: "M17 5.33C17 4.6 16.4 4 15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33V9h10V5.33z"
}), _react.default.createElement("path", {
  d: "M7 9v11.67C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V9H7z"
})), 'Battery80');

exports.default = _default;

/***/ }),
/* 1413 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  fillOpacity: ".3",
  d: "M17 5.33C17 4.6 16.4 4 15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33V8h10V5.33z"
}), _react.default.createElement("path", {
  d: "M7 8v12.67C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V8H7z"
})), 'Battery90');

exports.default = _default;

/***/ }),
/* 1414 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33v15.33C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V5.33C17 4.6 16.4 4 15.67 4zM13 18h-2v-2h2v2zm0-4h-2V9h2v5z"
})), 'BatteryAlert');

exports.default = _default;

/***/ }),
/* 1415 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M11 20v-3H7v3.67C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V17h-4.4L11 20z"
}), _react.default.createElement("path", {
  fillOpacity: ".3",
  d: "M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33V17h4v-2.5H9L13 7v5.5h2L12.6 17H17V5.33C17 4.6 16.4 4 15.67 4z"
})), 'BatteryCharging20');

exports.default = _default;

/***/ }),
/* 1416 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  fillOpacity: ".3",
  d: "M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33v9.17h2L13 7v5.5h2l-1.07 2H17V5.33C17 4.6 16.4 4 15.67 4z"
}), _react.default.createElement("path", {
  d: "M11 20v-5.5H7v6.17C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V14.5h-3.07L11 20z"
})), 'BatteryCharging30');

exports.default = _default;

/***/ }),
/* 1417 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M14.47 13.5L11 20v-5.5H9l.53-1H7v7.17C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V13.5h-2.53z"
}), _react.default.createElement("path", {
  fillOpacity: ".3",
  d: "M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33v8.17h2.53L13 7v5.5h2l-.53 1H17V5.33C17 4.6 16.4 4 15.67 4z"
})), 'BatteryCharging50');

exports.default = _default;

/***/ }),
/* 1418 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  fillOpacity: ".3",
  d: "M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33V11h3.87L13 7v4h4V5.33C17 4.6 16.4 4 15.67 4z"
}), _react.default.createElement("path", {
  d: "M13 12.5h2L11 20v-5.5H9l1.87-3.5H7v9.67C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V11h-4v1.5z"
})), 'BatteryCharging60');

exports.default = _default;

/***/ }),
/* 1419 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  fillOpacity: ".3",
  d: "M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33V9h4.93L13 7v2h4V5.33C17 4.6 16.4 4 15.67 4z"
}), _react.default.createElement("path", {
  d: "M13 12.5h2L11 20v-5.5H9L11.93 9H7v11.67C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V9h-4v3.5z"
})), 'BatteryCharging80');

exports.default = _default;

/***/ }),
/* 1420 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  fillOpacity: ".3",
  d: "M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33V8h5.47L13 7v1h4V5.33C17 4.6 16.4 4 15.67 4z"
}), _react.default.createElement("path", {
  d: "M13 12.5h2L11 20v-5.5H9L12.47 8H7v12.67C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V8h-4v4.5z"
})), 'BatteryCharging90');

exports.default = _default;

/***/ }),
/* 1421 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33v15.33C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V5.33C17 4.6 16.4 4 15.67 4zM11 20v-5.5H9L13 7v5.5h2L11 20z"
})), 'BatteryChargingFull');

exports.default = _default;

/***/ }),
/* 1422 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33v15.33C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V5.33C17 4.6 16.4 4 15.67 4z"
})), 'BatteryFull');

exports.default = _default;

/***/ }),
/* 1423 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33v15.33C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V5.33C17 4.6 16.4 4 15.67 4z"
})), 'BatteryStd');

exports.default = _default;

/***/ }),
/* 1424 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33v15.33C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V5.33C17 4.6 16.4 4 15.67 4zm-2.72 13.95h-1.9v-1.9h1.9v1.9zm1.35-5.26s-.38.42-.67.71c-.48.48-.83 1.15-.83 1.6h-1.6c0-.83.46-1.52.93-2l.93-.94c.27-.27.44-.65.44-1.06 0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5H9c0-1.66 1.34-3 3-3s3 1.34 3 3c0 .66-.27 1.26-.7 1.69z"
})), 'BatteryUnknown');

exports.default = _default;

/***/ }),
/* 1425 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M13.127 14.56l1.43-1.43 6.44 6.443L19.57 21zm4.293-5.73l2.86-2.86c-3.95-3.95-10.35-3.96-14.3-.02 3.93-1.3 8.31-.25 11.44 2.88zM5.95 5.98c-3.94 3.95-3.93 10.35.02 14.3l2.86-2.86C5.7 14.29 4.65 9.91 5.95 5.98zm.02-.02l-.01.01c-.38 3.01 1.17 6.88 4.3 10.02l5.73-5.73c-3.13-3.13-7.01-4.68-10.02-4.3z"
})), 'BeachAccess');

exports.default = _default;

/***/ }),
/* 1426 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M19 1H5c-1.1 0-1.99.9-1.99 2L3 15.93c0 .69.35 1.3.88 1.66L12 23l8.11-5.41c.53-.36.88-.97.88-1.66L21 3c0-1.1-.9-2-2-2zm-9 15l-5-5 1.41-1.41L10 13.17l7.59-7.59L19 7l-9 9z"
})), 'Beenhere');

exports.default = _default;

/***/ }),
/* 1427 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zM4 12c0-4.42 3.58-8 8-8 1.85 0 3.55.63 4.9 1.69L5.69 16.9C4.63 15.55 4 13.85 4 12zm8 8c-1.85 0-3.55-.63-4.9-1.69L18.31 7.1C19.37 8.45 20 10.15 20 12c0 4.42-3.58 8-8 8z"
})), 'Block');

exports.default = _default;

/***/ }),
/* 1428 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M17.71 7.71L12 2h-1v7.59L6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 11 14.41V22h1l5.71-5.71-4.3-4.29 4.3-4.29zM13 5.83l1.88 1.88L13 9.59V5.83zm1.88 10.46L13 18.17v-3.76l1.88 1.88z"
})), 'Bluetooth');

exports.default = _default;

/***/ }),
/* 1429 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M14.24 12.01l2.32 2.32c.28-.72.44-1.51.44-2.33 0-.82-.16-1.59-.43-2.31l-2.33 2.32zm5.29-5.3l-1.26 1.26c.63 1.21.98 2.57.98 4.02s-.36 2.82-.98 4.02l1.2 1.2c.97-1.54 1.54-3.36 1.54-5.31-.01-1.89-.55-3.67-1.48-5.19zm-3.82 1L10 2H9v7.59L4.41 5 3 6.41 8.59 12 3 17.59 4.41 19 9 14.41V22h1l5.71-5.71-4.3-4.29 4.3-4.29zM11 5.83l1.88 1.88L11 9.59V5.83zm1.88 10.46L11 18.17v-3.76l1.88 1.88z"
})), 'BluetoothAudio');

exports.default = _default;

/***/ }),
/* 1430 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M7 12l-2-2-2 2 2 2 2-2zm10.71-4.29L12 2h-1v7.59L6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 11 14.41V22h1l5.71-5.71-4.3-4.29 4.3-4.29zM13 5.83l1.88 1.88L13 9.59V5.83zm1.88 10.46L13 18.17v-3.76l1.88 1.88zM19 10l-2 2 2 2 2-2-2-2z"
})), 'BluetoothConnected');

exports.default = _default;

/***/ }),
/* 1431 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M13 5.83l1.88 1.88-1.6 1.6 1.41 1.41 3.02-3.02L12 2h-1v5.03l2 2v-3.2zM5.41 4L4 5.41 10.59 12 5 17.59 6.41 19 11 14.41V22h1l4.29-4.29 2.3 2.29L20 18.59 5.41 4zM13 18.17v-3.76l1.88 1.88L13 18.17z"
})), 'BluetoothDisabled');

exports.default = _default;

/***/ }),
/* 1432 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M14.24 12.01l2.32 2.32c.28-.72.44-1.51.44-2.33 0-.82-.16-1.59-.43-2.31l-2.33 2.32zm5.29-5.3l-1.26 1.26c.63 1.21.98 2.57.98 4.02s-.36 2.82-.98 4.02l1.2 1.2c.97-1.54 1.54-3.36 1.54-5.31-.01-1.89-.55-3.67-1.48-5.19zm-3.82 1L10 2H9v7.59L4.41 5 3 6.41 8.59 12 3 17.59 4.41 19 9 14.41V22h1l5.71-5.71-4.3-4.29 4.3-4.29zM11 5.83l1.88 1.88L11 9.59V5.83zm1.88 10.46L11 18.17v-3.76l1.88 1.88z"
})), 'BluetoothSearching');

exports.default = _default;

/***/ }),
/* 1433 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M10 9c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0 4c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zM7 9.5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm3 7c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm-3-3c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm3-6c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zM14 9c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0-1.5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zm3 6c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm0-4c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm2-3.5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm0-3.5c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1z"
})), 'BlurCircular');

exports.default = _default;

/***/ }),
/* 1434 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M5 17.5c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5-1.5.67-1.5 1.5.67 1.5 1.5 1.5zM9 13c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm0-4c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zM3 21h18v-2H3v2zM5 9.5c.83 0 1.5-.67 1.5-1.5S5.83 6.5 5 6.5 3.5 7.17 3.5 8 4.17 9.5 5 9.5zm0 4c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5-1.5.67-1.5 1.5.67 1.5 1.5 1.5zM9 17c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm8-.5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zM3 3v2h18V3H3zm14 5.5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zm0 4c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zM13 9c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm0 4c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm0 4c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1z"
})), 'BlurLinear');

exports.default = _default;

/***/ }),
/* 1435 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M14 7c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm-.2 4.48l.2.02c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5-1.5.67-1.5 1.5l.02.2c.09.67.61 1.19 1.28 1.28zM14 3.5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zm-4 0c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zm11 7c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zM10 7c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm8 8c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm0-4c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm0-4c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm-4 13.5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zM2.5 5.27l3.78 3.78L6 9c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1c0-.1-.03-.19-.06-.28l2.81 2.81c-.71.11-1.25.73-1.25 1.47 0 .83.67 1.5 1.5 1.5.74 0 1.36-.54 1.47-1.25l2.81 2.81c-.09-.03-.18-.06-.28-.06-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1c0-.1-.03-.19-.06-.28l3.78 3.78L20 20.23 3.77 4 2.5 5.27zM10 17c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm11-3.5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zM6 13c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zM3 9.5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm7 11c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zM6 17c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm-3-3.5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5z"
})), 'BlurOff');

exports.default = _default;

/***/ }),
/* 1436 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M6 13c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0 4c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0-8c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm-3 .5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zM6 5c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm15 5.5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zM14 7c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm0-3.5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zm-11 10c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm7 7c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm0-17c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zM10 7c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm0 5.5c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5zm8 .5c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0 4c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0-8c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0-4c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm3 8.5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zM14 17c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0 3.5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm-4-12c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5zm0 8.5c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm4-4.5c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5zm0-4c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5z"
})), 'BlurOn');

exports.default = _default;

/***/ }),
/* 1437 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M18 2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM6 4h5v8l-2.5-1.5L6 12V4z"
})), 'Book');

exports.default = _default;

/***/ }),
/* 1438 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M17 3H7c-1.1 0-1.99.9-1.99 2L5 21l7-3 7 3V5c0-1.1-.9-2-2-2z"
})), 'Bookmark');

exports.default = _default;

/***/ }),
/* 1439 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M17 3H7c-1.1 0-1.99.9-1.99 2L5 21l7-3 7 3V5c0-1.1-.9-2-2-2zm0 15l-5-2.18L7 18V5h10v13z"
})), 'BookmarkBorder');

exports.default = _default;

/***/ }),
/* 1440 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M3 3v18h18V3H3zm8 16H5v-6h6v6zm0-8H5V5h6v6zm8 8h-6v-6h6v6zm0-8h-6V5h6v6z"
})), 'BorderAll');

exports.default = _default;

/***/ }),
/* 1441 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M9 11H7v2h2v-2zm4 4h-2v2h2v-2zM9 3H7v2h2V3zm4 8h-2v2h2v-2zM5 3H3v2h2V3zm8 4h-2v2h2V7zm4 4h-2v2h2v-2zm-4-8h-2v2h2V3zm4 0h-2v2h2V3zm2 10h2v-2h-2v2zm0 4h2v-2h-2v2zM5 7H3v2h2V7zm14-4v2h2V3h-2zm0 6h2V7h-2v2zM5 11H3v2h2v-2zM3 21h18v-2H3v2zm2-6H3v2h2v-2z"
})), 'BorderBottom');

exports.default = _default;

/***/ }),
/* 1442 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M7 5h2V3H7v2zm0 8h2v-2H7v2zm0 8h2v-2H7v2zm4-4h2v-2h-2v2zm0 4h2v-2h-2v2zm-8 0h2v-2H3v2zm0-4h2v-2H3v2zm0-4h2v-2H3v2zm0-4h2V7H3v2zm0-4h2V3H3v2zm8 8h2v-2h-2v2zm8 4h2v-2h-2v2zm0-4h2v-2h-2v2zm0 8h2v-2h-2v2zm0-12h2V7h-2v2zm-8 0h2V7h-2v2zm8-6v2h2V3h-2zm-8 2h2V3h-2v2zm4 16h2v-2h-2v2zm0-8h2v-2h-2v2zm0-8h2V3h-2v2z"
})), 'BorderClear');

exports.default = _default;

/***/ }),
/* 1443 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M17.75 7L14 3.25l-10 10V17h3.75l10-10zm2.96-2.96c.39-.39.39-1.02 0-1.41L18.37.29c-.39-.39-1.02-.39-1.41 0L15 2.25 18.75 6l1.96-1.96z"
}), _react.default.createElement("path", {
  fillOpacity: ".36",
  d: "M0 20h24v4H0z"
})), 'BorderColor');

exports.default = _default;

/***/ }),
/* 1444 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M3 21h2v-2H3v2zM5 7H3v2h2V7zM3 17h2v-2H3v2zm4 4h2v-2H7v2zM5 3H3v2h2V3zm4 0H7v2h2V3zm8 0h-2v2h2V3zm-4 4h-2v2h2V7zm0-4h-2v2h2V3zm6 14h2v-2h-2v2zm-8 4h2v-2h-2v2zm-8-8h18v-2H3v2zM19 3v2h2V3h-2zm0 6h2V7h-2v2zm-8 8h2v-2h-2v2zm4 4h2v-2h-2v2zm4 0h2v-2h-2v2z"
})), 'BorderHorizontal');

exports.default = _default;

/***/ }),
/* 1445 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M3 21h2v-2H3v2zm4 0h2v-2H7v2zM5 7H3v2h2V7zM3 17h2v-2H3v2zM9 3H7v2h2V3zM5 3H3v2h2V3zm12 0h-2v2h2V3zm2 6h2V7h-2v2zm0-6v2h2V3h-2zm-4 18h2v-2h-2v2zM13 3h-2v8H3v2h8v8h2v-8h8v-2h-8V3zm6 18h2v-2h-2v2zm0-4h2v-2h-2v2z"
})), 'BorderInner');

exports.default = _default;

/***/ }),
/* 1446 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M11 21h2v-2h-2v2zm0-4h2v-2h-2v2zm0-12h2V3h-2v2zm0 4h2V7h-2v2zm0 4h2v-2h-2v2zm-4 8h2v-2H7v2zM7 5h2V3H7v2zm0 8h2v-2H7v2zm-4 8h2V3H3v18zM19 9h2V7h-2v2zm-4 12h2v-2h-2v2zm4-4h2v-2h-2v2zm0-14v2h2V3h-2zm0 10h2v-2h-2v2zm0 8h2v-2h-2v2zm-4-8h2v-2h-2v2zm0-8h2V3h-2v2z"
})), 'BorderLeft');

exports.default = _default;

/***/ }),
/* 1447 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M13 7h-2v2h2V7zm0 4h-2v2h2v-2zm4 0h-2v2h2v-2zM3 3v18h18V3H3zm16 16H5V5h14v14zm-6-4h-2v2h2v-2zm-4-4H7v2h2v-2z"
})), 'BorderOuter');

exports.default = _default;

/***/ }),
/* 1448 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M7 21h2v-2H7v2zM3 5h2V3H3v2zm4 0h2V3H7v2zm0 8h2v-2H7v2zm-4 8h2v-2H3v2zm8 0h2v-2h-2v2zm-8-8h2v-2H3v2zm0 4h2v-2H3v2zm0-8h2V7H3v2zm8 8h2v-2h-2v2zm4-4h2v-2h-2v2zm4-10v18h2V3h-2zm-4 18h2v-2h-2v2zm0-16h2V3h-2v2zm-4 8h2v-2h-2v2zm0-8h2V3h-2v2zm0 4h2V7h-2v2z"
})), 'BorderRight');

exports.default = _default;

/***/ }),
/* 1449 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M15 21h2v-2h-2v2zm4 0h2v-2h-2v2zM7 21h2v-2H7v2zm4 0h2v-2h-2v2zm8-4h2v-2h-2v2zm0-4h2v-2h-2v2zM3 3v18h2V5h16V3H3zm16 6h2V7h-2v2z"
})), 'BorderStyle');

exports.default = _default;

/***/ }),
/* 1450 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M7 21h2v-2H7v2zm0-8h2v-2H7v2zm4 0h2v-2h-2v2zm0 8h2v-2h-2v2zm-8-4h2v-2H3v2zm0 4h2v-2H3v2zm0-8h2v-2H3v2zm0-4h2V7H3v2zm8 8h2v-2h-2v2zm8-8h2V7h-2v2zm0 4h2v-2h-2v2zM3 3v2h18V3H3zm16 14h2v-2h-2v2zm-4 4h2v-2h-2v2zM11 9h2V7h-2v2zm8 12h2v-2h-2v2zm-4-8h2v-2h-2v2z"
})), 'BorderTop');

exports.default = _default;

/***/ }),
/* 1451 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M3 9h2V7H3v2zm0-4h2V3H3v2zm4 16h2v-2H7v2zm0-8h2v-2H7v2zm-4 0h2v-2H3v2zm0 8h2v-2H3v2zm0-4h2v-2H3v2zM7 5h2V3H7v2zm12 12h2v-2h-2v2zm-8 4h2V3h-2v18zm8 0h2v-2h-2v2zm0-8h2v-2h-2v2zm0-10v2h2V3h-2zm0 6h2V7h-2v2zm-4-4h2V3h-2v2zm0 16h2v-2h-2v2zm0-8h2v-2h-2v2z"
})), 'BorderVertical');

exports.default = _default;

/***/ }),
/* 1452 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16h-9v-6h9v6z"
})), 'BrandingWatermark');

exports.default = _default;

/***/ }),
/* 1453 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("circle", {
  cx: "12",
  cy: "12",
  r: "10"
})), 'Brightness1');

exports.default = _default;

/***/ }),
/* 1454 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M10 2c-1.82 0-3.53.5-5 1.35C7.99 5.08 10 8.3 10 12s-2.01 6.92-5 8.65C6.47 21.5 8.18 22 10 22c5.52 0 10-4.48 10-10S15.52 2 10 2z"
})), 'Brightness2');

exports.default = _default;

/***/ }),
/* 1455 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M9 2c-1.05 0-2.05.16-3 .46 4.06 1.27 7 5.06 7 9.54 0 4.48-2.94 8.27-7 9.54.95.3 1.95.46 3 .46 5.52 0 10-4.48 10-10S14.52 2 9 2z"
})), 'Brightness3');

exports.default = _default;

/***/ }),
/* 1456 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20 8.69V4h-4.69L12 .69 8.69 4H4v4.69L.69 12 4 15.31V20h4.69L12 23.31 15.31 20H20v-4.69L23.31 12 20 8.69zM12 18c-.89 0-1.74-.2-2.5-.55C11.56 16.5 13 14.42 13 12s-1.44-4.5-3.5-5.45C10.26 6.2 11.11 6 12 6c3.31 0 6 2.69 6 6s-2.69 6-6 6z"
})), 'Brightness4');

exports.default = _default;

/***/ }),
/* 1457 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20 15.31L23.31 12 20 8.69V4h-4.69L12 .69 8.69 4H4v4.69L.69 12 4 15.31V20h4.69L12 23.31 15.31 20H20v-4.69zM12 18c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6z"
})), 'Brightness5');

exports.default = _default;

/***/ }),
/* 1458 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20 15.31L23.31 12 20 8.69V4h-4.69L12 .69 8.69 4H4v4.69L.69 12 4 15.31V20h4.69L12 23.31 15.31 20H20v-4.69zM12 18V6c3.31 0 6 2.69 6 6s-2.69 6-6 6z"
})), 'Brightness6');

exports.default = _default;

/***/ }),
/* 1459 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20 8.69V4h-4.69L12 .69 8.69 4H4v4.69L.69 12 4 15.31V20h4.69L12 23.31 15.31 20H20v-4.69L23.31 12 20 8.69zM12 18c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6zm0-10c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4z"
})), 'Brightness7');

exports.default = _default;

/***/ }),
/* 1460 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M10.85 12.65h2.3L12 9l-1.15 3.65zM20 8.69V4h-4.69L12 .69 8.69 4H4v4.69L.69 12 4 15.31V20h4.69L12 23.31 15.31 20H20v-4.69L23.31 12 20 8.69zM14.3 16l-.7-2h-3.2l-.7 2H7.8L11 7h2l3.2 9h-1.9z"
})), 'BrightnessAuto');

exports.default = _default;

/***/ }),
/* 1461 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20 8.69V4h-4.69L12 .69 8.69 4H4v4.69L.69 12 4 15.31V20h4.69L12 23.31 15.31 20H20v-4.69L23.31 12 20 8.69zM12 18c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6zm0-10c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4z"
})), 'BrightnessHigh');

exports.default = _default;

/***/ }),
/* 1462 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20 15.31L23.31 12 20 8.69V4h-4.69L12 .69 8.69 4H4v4.69L.69 12 4 15.31V20h4.69L12 23.31 15.31 20H20v-4.69zM12 18c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6z"
})), 'BrightnessLow');

exports.default = _default;

/***/ }),
/* 1463 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20 15.31L23.31 12 20 8.69V4h-4.69L12 .69 8.69 4H4v4.69L.69 12 4 15.31V20h4.69L12 23.31 15.31 20H20v-4.69zM12 18V6c3.31 0 6 2.69 6 6s-2.69 6-6 6z"
})), 'BrightnessMedium');

exports.default = _default;

/***/ }),
/* 1464 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M21 5v6.59l-3-3.01-4 4.01-4-4-4 4-3-3.01V5c0-1.1.9-2 2-2h14c1.1 0 2 .9 2 2zm-3 6.42l3 3.01V19c0 1.1-.9 2-2 2H5c-1.1 0-2-.9-2-2v-6.58l3 2.99 4-4 4 4 4-3.99z"
})), 'BrokenImage');

exports.default = _default;

/***/ }),
/* 1465 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M7 14c-1.66 0-3 1.34-3 3 0 1.31-1.16 2-2 2 .92 1.22 2.49 2 4 2 2.21 0 4-1.79 4-4 0-1.66-1.34-3-3-3zm13.71-9.37l-1.34-1.34c-.39-.39-1.02-.39-1.41 0L9 12.25 11.75 15l8.96-8.96c.39-.39.39-1.02 0-1.41z"
})), 'Brush');

exports.default = _default;

/***/ }),
/* 1466 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("circle", {
  cx: "7.2",
  cy: "14.4",
  r: "3.2"
}), _react.default.createElement("circle", {
  cx: "14.8",
  cy: "18",
  r: "2"
}), _react.default.createElement("circle", {
  cx: "15.2",
  cy: "8.8",
  r: "4.8"
})), 'BubbleChart');

exports.default = _default;

/***/ }),
/* 1467 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20 8h-2.81c-.45-.78-1.07-1.45-1.82-1.96L17 4.41 15.59 3l-2.17 2.17C12.96 5.06 12.49 5 12 5c-.49 0-.96.06-1.41.17L8.41 3 7 4.41l1.62 1.63C7.88 6.55 7.26 7.22 6.81 8H4v2h2.09c-.05.33-.09.66-.09 1v1H4v2h2v1c0 .34.04.67.09 1H4v2h2.81c1.04 1.79 2.97 3 5.19 3s4.15-1.21 5.19-3H20v-2h-2.09c.05-.33.09-.66.09-1v-1h2v-2h-2v-1c0-.34-.04-.67-.09-1H20V8zm-6 8h-4v-2h4v2zm0-4h-4v-2h4v2z"
})), 'BugReport');

exports.default = _default;

/***/ }),
/* 1468 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M22.7 19l-9.1-9.1c.9-2.3.4-5-1.5-6.9-2-2-5-2.4-7.4-1.3L9 6 6 9 1.6 4.7C.4 7.1.9 10.1 2.9 12.1c1.9 1.9 4.6 2.4 6.9 1.5l9.1 9.1c.4.4 1 .4 1.4 0l2.3-2.3c.5-.4.5-1.1.1-1.4z"
})), 'Build');

exports.default = _default;

/***/ }),
/* 1469 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M1 5h2v14H1zm4 0h2v14H5zm17 0H10c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h12c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1zM11 17l2.5-3.15L15.29 16l2.5-3.22L21 17H11z"
})), 'BurstMode');

exports.default = _default;

/***/ }),
/* 1470 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 7V3H2v18h20V7H12zM6 19H4v-2h2v2zm0-4H4v-2h2v2zm0-4H4V9h2v2zm0-4H4V5h2v2zm4 12H8v-2h2v2zm0-4H8v-2h2v2zm0-4H8V9h2v2zm0-4H8V5h2v2zm10 12h-8v-2h2v-2h-2v-2h2v-2h-2V9h8v10zm-2-8h-2v2h2v-2zm0 4h-2v2h2v-2z"
})), 'Business');

exports.default = _default;

/***/ }),
/* 1471 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M10 16v-1H3.01L3 19c0 1.11.89 2 2 2h14c1.11 0 2-.89 2-2v-4h-7v1h-4zm10-9h-4.01V5l-2-2h-4l-2 2v2H4c-1.1 0-2 .9-2 2v3c0 1.11.89 2 2 2h6v-2h4v2h6c1.1 0 2-.9 2-2V9c0-1.1-.9-2-2-2zm-6 0h-4V5h4v2z"
})), 'BusinessCenter');

exports.default = _default;

/***/ }),
/* 1472 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M19 8l-4 4h3c0 3.31-2.69 6-6 6-1.01 0-1.97-.25-2.8-.7l-1.46 1.46C8.97 19.54 10.43 20 12 20c4.42 0 8-3.58 8-8h3l-4-4zM6 12c0-3.31 2.69-6 6-6 1.01 0 1.97.25 2.8.7l1.46-1.46C15.03 4.46 13.57 4 12 4c-4.42 0-8 3.58-8 8H1l4 4 4-4H6z"
})), 'Cached');

exports.default = _default;

/***/ }),
/* 1473 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 6c1.11 0 2-.9 2-2 0-.38-.1-.73-.29-1.03L12 0l-1.71 2.97c-.19.3-.29.65-.29 1.03 0 1.1.9 2 2 2zm4.6 9.99l-1.07-1.07-1.08 1.07c-1.3 1.3-3.58 1.31-4.89 0l-1.07-1.07-1.09 1.07C6.75 16.64 5.88 17 4.96 17c-.73 0-1.4-.23-1.96-.61V21c0 .55.45 1 1 1h16c.55 0 1-.45 1-1v-4.61c-.56.38-1.23.61-1.96.61-.92 0-1.79-.36-2.44-1.01zM18 9h-5V7h-2v2H6c-1.66 0-3 1.34-3 3v1.54c0 1.08.88 1.96 1.96 1.96.52 0 1.02-.2 1.38-.57l2.14-2.13 2.13 2.13c.74.74 2.03.74 2.77 0l2.14-2.13 2.13 2.13c.37.37.86.57 1.38.57 1.08 0 1.96-.88 1.96-1.96V12C21 10.34 19.66 9 18 9z"
})), 'Cake');

exports.default = _default;

/***/ }),
/* 1474 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"
})), 'Call');

exports.default = _default;

/***/ }),
/* 1475 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 9c-1.6 0-3.15.25-4.6.72v3.1c0 .39-.23.74-.56.9-.98.49-1.87 1.12-2.66 1.85-.18.18-.43.28-.7.28-.28 0-.53-.11-.71-.29L.29 13.08c-.18-.17-.29-.42-.29-.7 0-.28.11-.53.29-.71C3.34 8.78 7.46 7 12 7s8.66 1.78 11.71 4.67c.18.18.29.43.29.71 0 .28-.11.53-.29.71l-2.48 2.48c-.18.18-.43.29-.71.29-.27 0-.52-.11-.7-.28-.79-.74-1.69-1.36-2.67-1.85-.33-.16-.56-.5-.56-.9v-3.1C15.15 9.25 13.6 9 12 9z"
})), 'CallEnd');

exports.default = _default;

/***/ }),
/* 1476 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M9 5v2h6.59L4 18.59 5.41 20 17 8.41V15h2V5z"
})), 'CallMade');

exports.default = _default;

/***/ }),
/* 1477 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M17 20.41L18.41 19 15 15.59 13.59 17 17 20.41zM7.5 8H11v5.59L5.59 19 7 20.41l6-6V8h3.5L12 3.5 7.5 8z"
})), 'CallMerge');

exports.default = _default;

/***/ }),
/* 1478 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M19.59 7L12 14.59 6.41 9H11V7H3v8h2v-4.59l7 7 9-9z"
})), 'CallMissed');

exports.default = _default;

/***/ }),
/* 1479 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M3 8.41l9 9 7-7V15h2V7h-8v2h4.59L12 14.59 4.41 7 3 8.41z"
})), 'CallMissedOutgoing');

exports.default = _default;

/***/ }),
/* 1480 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20 5.41L18.59 4 7 15.59V9H5v10h10v-2H8.41z"
})), 'CallReceived');

exports.default = _default;

/***/ }),
/* 1481 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M14 4l2.29 2.29-2.88 2.88 1.42 1.42 2.88-2.88L20 10V4zm-4 0H4v6l2.29-2.29 4.71 4.7V20h2v-8.41l-5.29-5.3z"
})), 'CallSplit');

exports.default = _default;

/***/ }),
/* 1482 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H3v-3h18v3z"
})), 'CallToAction');

exports.default = _default;

/***/ }),
/* 1483 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M9.4 10.5l4.77-8.26C13.47 2.09 12.75 2 12 2c-2.4 0-4.6.85-6.32 2.25l3.66 6.35.06-.1zM21.54 9c-.92-2.92-3.15-5.26-6-6.34L11.88 9h9.66zm.26 1h-7.49l.29.5 4.76 8.25C21 16.97 22 14.61 22 12c0-.69-.07-1.35-.2-2zM8.54 12l-3.9-6.75C3.01 7.03 2 9.39 2 12c0 .69.07 1.35.2 2h7.49l-1.15-2zm-6.08 3c.92 2.92 3.15 5.26 6 6.34L12.12 15H2.46zm11.27 0l-3.9 6.76c.7.15 1.42.24 2.17.24 2.4 0 4.6-.85 6.32-2.25l-3.66-6.35-.93 1.6z"
})), 'Camera');

exports.default = _default;

/***/ }),
/* 1484 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("circle", {
  cx: "12",
  cy: "12",
  r: "3.2"
}), _react.default.createElement("path", {
  d: "M9 2L7.17 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2h-3.17L15 2H9zm3 15c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5z"
})), 'CameraAlt');

exports.default = _default;

/***/ }),
/* 1485 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M9 3L7.17 5H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2h-3.17L15 3H9zm3 15c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-1l1.25-2.75L16 13l-2.75-1.25L12 9l-1.25 2.75L8 13l2.75 1.25z"
})), 'CameraEnhance');

exports.default = _default;

/***/ }),
/* 1486 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M10 20H5v2h5v2l3-3-3-3v2zm4 0v2h5v-2h-5zM12 8c1.1 0 2-.9 2-2s-.9-2-2-2-1.99.9-1.99 2S10.9 8 12 8zm5-8H7C5.9 0 5 .9 5 2v14c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V2c0-1.1-.9-2-2-2zM7 2h10v10.5c0-1.67-3.33-2.5-5-2.5s-5 .83-5 2.5V2z"
})), 'CameraFront');

exports.default = _default;

/***/ }),
/* 1487 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M10 20H5v2h5v2l3-3-3-3v2zm4 0v2h5v-2h-5zm3-20H7C5.9 0 5 .9 5 2v14c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V2c0-1.1-.9-2-2-2zm-5 6c-1.11 0-2-.9-2-2s.89-2 1.99-2 2 .9 2 2C14 5.1 13.1 6 12 6z"
})), 'CameraRear');

exports.default = _default;

/***/ }),
/* 1488 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M14 5c0-1.1-.9-2-2-2h-1V2c0-.55-.45-1-1-1H6c-.55 0-1 .45-1 1v1H4c-1.1 0-2 .9-2 2v15c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2h8V5h-8zm-2 13h-2v-2h2v2zm0-9h-2V7h2v2zm4 9h-2v-2h2v2zm0-9h-2V7h2v2zm4 9h-2v-2h2v2zm0-9h-2V7h2v2z"
})), 'CameraRoll');

exports.default = _default;

/***/ }),
/* 1489 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"
})), 'Cancel');

exports.default = _default;

/***/ }),
/* 1490 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20 6h-2.18c.11-.31.18-.65.18-1 0-1.66-1.34-3-3-3-1.05 0-1.96.54-2.5 1.35l-.5.67-.5-.68C10.96 2.54 10.05 2 9 2 7.34 2 6 3.34 6 5c0 .35.07.69.18 1H4c-1.11 0-1.99.89-1.99 2L2 19c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zm-5-2c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zM9 4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm11 15H4v-2h16v2zm0-5H4V8h5.08L7 10.83 8.62 12 11 8.76l1-1.36 1 1.36L15.38 12 17 10.83 14.92 8H20v6z"
})), 'CardGiftcard');

exports.default = _default;

/***/ }),
/* 1491 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20 2H4c-1.11 0-2 .89-2 2v11c0 1.11.89 2 2 2h4v5l4-2 4 2v-5h4c1.11 0 2-.89 2-2V4c0-1.11-.89-2-2-2zm0 13H4v-2h16v2zm0-5H4V4h16v6z"
})), 'CardMembership');

exports.default = _default;

/***/ }),
/* 1492 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20 6h-3V4c0-1.11-.89-2-2-2H9c-1.11 0-2 .89-2 2v2H4c-1.11 0-2 .89-2 2v11c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zM9 4h6v2H9V4zm11 15H4v-2h16v2zm0-5H4V8h3v2h2V8h6v2h2V8h3v6z"
})), 'CardTravel');

exports.default = _default;

/***/ }),
/* 1493 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM7.5 18c-.83 0-1.5-.67-1.5-1.5S6.67 15 7.5 15s1.5.67 1.5 1.5S8.33 18 7.5 18zm0-9C6.67 9 6 8.33 6 7.5S6.67 6 7.5 6 9 6.67 9 7.5 8.33 9 7.5 9zm4.5 4.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm4.5 4.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm0-9c-.83 0-1.5-.67-1.5-1.5S15.67 6 16.5 6s1.5.67 1.5 1.5S17.33 9 16.5 9z"
})), 'Casino');

exports.default = _default;

/***/ }),
/* 1494 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M21 3H3c-1.1 0-2 .9-2 2v3h2V5h18v14h-7v2h7c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM1 18v3h3c0-1.66-1.34-3-3-3zm0-4v2c2.76 0 5 2.24 5 5h2c0-3.87-3.13-7-7-7zm0-4v2c4.97 0 9 4.03 9 9h2c0-6.08-4.93-11-11-11z"
})), 'Cast');

exports.default = _default;

/***/ }),
/* 1495 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M1 18v3h3c0-1.66-1.34-3-3-3zm0-4v2c2.76 0 5 2.24 5 5h2c0-3.87-3.13-7-7-7zm18-7H5v1.63c3.96 1.28 7.09 4.41 8.37 8.37H19V7zM1 10v2c4.97 0 9 4.03 9 9h2c0-6.08-4.93-11-11-11zm20-7H3c-1.1 0-2 .9-2 2v3h2V5h18v14h-7v2h7c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
})), 'CastConnected');

exports.default = _default;

/***/ }),
/* 1496 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm-7 7H3v4c0 1.1.9 2 2 2h4v-2H5v-4zM5 5h4V3H5c-1.1 0-2 .9-2 2v4h2V5zm14-2h-4v2h4v4h2V5c0-1.1-.9-2-2-2zm0 16h-4v2h4c1.1 0 2-.9 2-2v-4h-2v4z"
})), 'CenterFocusStrong');

exports.default = _default;

/***/ }),
/* 1497 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M5 15H3v4c0 1.1.9 2 2 2h4v-2H5v-4zM5 5h4V3H5c-1.1 0-2 .9-2 2v4h2V5zm14-2h-4v2h4v4h2V5c0-1.1-.9-2-2-2zm0 16h-4v2h4c1.1 0 2-.9 2-2v-4h-2v4zM12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 6c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"
})), 'CenterFocusWeak');

exports.default = _default;

/***/ }),
/* 1498 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 7.77L18.39 18H5.61L12 7.77M12 4L2 20h20L12 4z"
})), 'ChangeHistory');

exports.default = _default;

/***/ }),
/* 1499 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM6 9h12v2H6V9zm8 5H6v-2h8v2zm4-6H6V6h12v2z"
})), 'Chat');

exports.default = _default;

/***/ }),
/* 1500 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2z"
})), 'ChatBubble');

exports.default = _default;

/***/ }),
/* 1501 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H6l-2 2V4h16v12z"
})), 'ChatBubbleOutline');

exports.default = _default;

/***/ }),
/* 1502 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"
})), 'Check');

exports.default = _default;

/***/ }),
/* 1503 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
})), 'CheckBox');

exports.default = _default;

/***/ }),
/* 1504 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
})), 'CheckBoxOutlineBlank');

exports.default = _default;

/***/ }),
/* 1505 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
})), 'CheckCircle');

exports.default = _default;

/***/ }),
/* 1506 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"
})), 'ChevronLeft');

exports.default = _default;

/***/ }),
/* 1507 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"
})), 'ChevronRight');

exports.default = _default;

/***/ }),
/* 1508 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("circle", {
  cx: "14.5",
  cy: "10.5",
  r: "1.25"
}), _react.default.createElement("circle", {
  cx: "9.5",
  cy: "10.5",
  r: "1.25"
}), _react.default.createElement("path", {
  d: "M22.94 12.66c.04-.21.06-.43.06-.66s-.02-.45-.06-.66c-.25-1.51-1.36-2.74-2.81-3.17-.53-1.12-1.28-2.1-2.19-2.91C16.36 3.85 14.28 3 12 3s-4.36.85-5.94 2.26c-.92.81-1.67 1.8-2.19 2.91-1.45.43-2.56 1.65-2.81 3.17-.04.21-.06.43-.06.66s.02.45.06.66c.25 1.51 1.36 2.74 2.81 3.17.52 1.11 1.27 2.09 2.17 2.89C7.62 20.14 9.71 21 12 21s4.38-.86 5.97-2.28c.9-.8 1.65-1.79 2.17-2.89 1.44-.43 2.55-1.65 2.8-3.17zM19 14c-.1 0-.19-.02-.29-.03-.2.67-.49 1.29-.86 1.86C16.6 17.74 14.45 19 12 19s-4.6-1.26-5.85-3.17c-.37-.57-.66-1.19-.86-1.86-.1.01-.19.03-.29.03-1.1 0-2-.9-2-2s.9-2 2-2c.1 0 .19.02.29.03.2-.67.49-1.29.86-1.86C7.4 6.26 9.55 5 12 5s4.6 1.26 5.85 3.17c.37.57.66 1.19.86 1.86.1-.01.19-.03.29-.03 1.1 0 2 .9 2 2s-.9 2-2 2zM7.5 14c.76 1.77 2.49 3 4.5 3s3.74-1.23 4.5-3h-9z"
})), 'ChildCare');

exports.default = _default;

/***/ }),
/* 1509 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M13 2v8h8c0-4.42-3.58-8-8-8zm6.32 13.89C20.37 14.54 21 12.84 21 11H6.44l-.95-2H2v2h2.22s1.89 4.07 2.12 4.42c-1.1.59-1.84 1.75-1.84 3.08C4.5 20.43 6.07 22 8 22c1.76 0 3.22-1.3 3.46-3h2.08c.24 1.7 1.7 3 3.46 3 1.93 0 3.5-1.57 3.5-3.5 0-1.04-.46-1.97-1.18-2.61zM8 20c-.83 0-1.5-.67-1.5-1.5S7.17 17 8 17s1.5.67 1.5 1.5S8.83 20 8 20zm9 0c-.83 0-1.5-.67-1.5-1.5S16.17 17 17 17s1.5.67 1.5 1.5S17.83 20 17 20z"
})), 'ChildFriendly');

exports.default = _default;

/***/ }),
/* 1510 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M13 12h7v1.5h-7zm0-2.5h7V11h-7zm0 5h7V16h-7zM21 4H3c-1.1 0-2 .9-2 2v13c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 15h-9V6h9v13z"
})), 'ChromeReaderMode');

exports.default = _default;

/***/ }),
/* 1511 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M18 2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM6 4h5v8l-2.5-1.5L6 12V4z"
})), 'Class');

exports.default = _default;

/***/ }),
/* 1512 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
})), 'Clear');

exports.default = _default;

/***/ }),
/* 1513 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M5 13h14v-2H5v2zm-2 4h14v-2H3v2zM7 7v2h14V7H7z"
})), 'ClearAll');

exports.default = _default;

/***/ }),
/* 1514 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M19 4H5c-1.11 0-2 .9-2 2v12c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-8 7H9.5v-.5h-2v3h2V13H11v1c0 .55-.45 1-1 1H7c-.55 0-1-.45-1-1v-4c0-.55.45-1 1-1h3c.55 0 1 .45 1 1v1zm7 0h-1.5v-.5h-2v3h2V13H18v1c0 .55-.45 1-1 1h-3c-.55 0-1-.45-1-1v-4c0-.55.45-1 1-1h3c.55 0 1 .45 1 1v1z"
})), 'ClosedCaption');

exports.default = _default;

/***/ }),
/* 1515 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96z"
})), 'Cloud');

exports.default = _default;

/***/ }),
/* 1516 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm4.5 14H8c-1.66 0-3-1.34-3-3s1.34-3 3-3l.14.01C8.58 8.28 10.13 7 12 7c2.21 0 4 1.79 4 4h.5c1.38 0 2.5 1.12 2.5 2.5S17.88 16 16.5 16z"
})), 'CloudCircle');

exports.default = _default;

/***/ }),
/* 1517 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM10 17l-3.5-3.5 1.41-1.41L10 14.17 15.18 9l1.41 1.41L10 17z"
})), 'CloudDone');

exports.default = _default;

/***/ }),
/* 1518 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM17 13l-5 5-5-5h3V9h4v4h3z"
})), 'CloudDownload');

exports.default = _default;

/***/ }),
/* 1519 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M19.35 10.04C18.67 6.59 15.64 4 12 4c-1.48 0-2.85.43-4.01 1.17l1.46 1.46C10.21 6.23 11.08 6 12 6c3.04 0 5.5 2.46 5.5 5.5v.5H19c1.66 0 3 1.34 3 3 0 1.13-.64 2.11-1.56 2.62l1.45 1.45C23.16 18.16 24 16.68 24 15c0-2.64-2.05-4.78-4.65-4.96zM3 5.27l2.75 2.74C2.56 8.15 0 10.77 0 14c0 3.31 2.69 6 6 6h11.73l2 2L21 20.73 4.27 4 3 5.27zM7.73 10l8 8H6c-2.21 0-4-1.79-4-4s1.79-4 4-4h1.73z"
})), 'CloudOff');

exports.default = _default;

/***/ }),
/* 1520 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM19 18H6c-2.21 0-4-1.79-4-4s1.79-4 4-4h.71C7.37 7.69 9.48 6 12 6c3.04 0 5.5 2.46 5.5 5.5v.5H19c1.66 0 3 1.34 3 3s-1.34 3-3 3z"
})), 'CloudQueue');

exports.default = _default;

/***/ }),
/* 1521 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM14 13v4h-4v-4H7l5-5 5 5h-3z"
})), 'CloudUpload');

exports.default = _default;

/***/ }),
/* 1522 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M9.4 16.6L4.8 12l4.6-4.6L8 6l-6 6 6 6 1.4-1.4zm5.2 0l4.6-4.6-4.6-4.6L16 6l6 6-6 6-1.4-1.4z"
})), 'Code');

exports.default = _default;

/***/ }),
/* 1523 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M22 16V4c0-1.1-.9-2-2-2H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2zm-11-4l2.03 2.71L16 11l4 5H8l3-4zM2 6v14c0 1.1.9 2 2 2h14v-2H4V6H2z"
})), 'Collections');

exports.default = _default;

/***/ }),
/* 1524 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm16-4H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 10l-2.5-1.5L15 12V4h5v8z"
})), 'CollectionsBookmark');

exports.default = _default;

/***/ }),
/* 1525 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20.71 5.63l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-3.12 3.12-1.93-1.91-1.41 1.41 1.42 1.42L3 16.25V21h4.75l8.92-8.92 1.42 1.42 1.41-1.41-1.92-1.92 3.12-3.12c.4-.4.4-1.03.01-1.42zM6.92 19L5 17.08l8.06-8.06 1.92 1.92L6.92 19z"
})), 'Colorize');

exports.default = _default;

/***/ }),
/* 1526 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 3c-4.97 0-9 4.03-9 9s4.03 9 9 9c.83 0 1.5-.67 1.5-1.5 0-.39-.15-.74-.39-1.01-.23-.26-.38-.61-.38-.99 0-.83.67-1.5 1.5-1.5H16c2.76 0 5-2.24 5-5 0-4.42-4.03-8-9-8zm-5.5 9c-.83 0-1.5-.67-1.5-1.5S5.67 9 6.5 9 8 9.67 8 10.5 7.33 12 6.5 12zm3-4C8.67 8 8 7.33 8 6.5S8.67 5 9.5 5s1.5.67 1.5 1.5S10.33 8 9.5 8zm5 0c-.83 0-1.5-.67-1.5-1.5S13.67 5 14.5 5s1.5.67 1.5 1.5S15.33 8 14.5 8zm3 4c-.83 0-1.5-.67-1.5-1.5S16.67 9 17.5 9s1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"
})), 'ColorLens');

exports.default = _default;

/***/ }),
/* 1527 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M21.99 4c0-1.1-.89-2-1.99-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h14l4 4-.01-18zM18 14H6v-2h12v2zm0-3H6V9h12v2zm0-3H6V6h12v2z"
})), 'Comment');

exports.default = _default;

/***/ }),
/* 1528 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M10 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h5v2h2V1h-2v2zm0 15H5l5-6v6zm9-15h-5v2h5v13l-5-6v9h5c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
})), 'Compare');

exports.default = _default;

/***/ }),
/* 1529 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M9.01 14H2v2h7.01v3L13 15l-3.99-4v3zm5.98-1v-3H22V8h-7.01V5L11 9l3.99 4z"
})), 'CompareArrows');

exports.default = _default;

/***/ }),
/* 1530 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20 18c1.1 0 1.99-.9 1.99-2L22 6c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2H0v2h24v-2h-4zM4 6h16v10H4V6z"
})), 'Computer');

exports.default = _default;

/***/ }),
/* 1531 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M22 10V6c0-1.11-.9-2-2-2H4c-1.1 0-1.99.89-1.99 2v4c1.1 0 1.99.9 1.99 2s-.89 2-2 2v4c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2v-4c-1.1 0-2-.9-2-2s.9-2 2-2zm-9 7.5h-2v-2h2v2zm0-4.5h-2v-2h2v2zm0-4.5h-2v-2h2v2z"
})), 'ConfirmationNumber');

exports.default = _default;

/***/ }),
/* 1532 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M21 8V7l-3 2-3-2v1l3 2 3-2zm1-5H2C.9 3 0 3.9 0 5v14c0 1.1.9 2 2 2h20c1.1 0 1.99-.9 1.99-2L24 5c0-1.1-.9-2-2-2zM8 6c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm6 12H2v-1c0-2 4-3.1 6-3.1s6 1.1 6 3.1v1zm8-6h-8V6h8v6z"
})), 'ContactMail');

exports.default = _default;

/***/ }),
/* 1533 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M22 3H2C.9 3 0 3.9 0 5v14c0 1.1.9 2 2 2h20c1.1 0 1.99-.9 1.99-2L24 5c0-1.1-.9-2-2-2zM8 6c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm6 12H2v-1c0-2 4-3.1 6-3.1s6 1.1 6 3.1v1zm3.85-4h1.64L21 16l-1.99 1.99c-1.31-.98-2.28-2.38-2.73-3.99-.18-.64-.28-1.31-.28-2s.1-1.36.28-2c.45-1.62 1.42-3.01 2.73-3.99L21 8l-1.51 2h-1.64c-.22.63-.35 1.3-.35 2s.13 1.37.35 2z"
})), 'ContactPhone');

exports.default = _default;

/***/ }),
/* 1534 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20 0H4v2h16V0zM4 24h16v-2H4v2zM20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-8 2.75c1.24 0 2.25 1.01 2.25 2.25s-1.01 2.25-2.25 2.25S9.75 10.24 9.75 9 10.76 6.75 12 6.75zM17 17H7v-1.5c0-1.67 3.33-2.5 5-2.5s5 .83 5 2.5V17z"
})), 'Contacts');

exports.default = _default;

/***/ }),
/* 1535 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z"
})), 'ContentCopy');

exports.default = _default;

/***/ }),
/* 1536 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M9.64 7.64c.23-.5.36-1.05.36-1.64 0-2.21-1.79-4-4-4S2 3.79 2 6s1.79 4 4 4c.59 0 1.14-.13 1.64-.36L10 12l-2.36 2.36C7.14 14.13 6.59 14 6 14c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4c0-.59-.13-1.14-.36-1.64L12 14l7 7h3v-1L9.64 7.64zM6 8c-1.1 0-2-.89-2-2s.9-2 2-2 2 .89 2 2-.9 2-2 2zm0 12c-1.1 0-2-.89-2-2s.9-2 2-2 2 .89 2 2-.9 2-2 2zm6-7.5c-.28 0-.5-.22-.5-.5s.22-.5.5-.5.5.22.5.5-.22.5-.5.5zM19 3l-6 6 2 2 7-7V3z"
})), 'ContentCut');

exports.default = _default;

/***/ }),
/* 1537 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M19 2h-4.18C14.4.84 13.3 0 12 0c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm7 18H5V4h2v3h10V4h2v16z"
})), 'ContentPaste');

exports.default = _default;

/***/ }),
/* 1538 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M13 7h-2v4H7v2h4v4h2v-4h4v-2h-4V7zm-1-5C6.49 2 2 6.49 2 12s4.49 10 10 10 10-4.49 10-10S17.51 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
})), 'ControlPoint');

exports.default = _default;

/***/ }),
/* 1539 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M16 8h-2v3h-3v2h3v3h2v-3h3v-2h-3zM2 12c0-2.79 1.64-5.2 4.01-6.32V3.52C2.52 4.76 0 8.09 0 12s2.52 7.24 6.01 8.48v-2.16C3.64 17.2 2 14.79 2 12zm13-9c-4.96 0-9 4.04-9 9s4.04 9 9 9 9-4.04 9-9-4.04-9-9-9zm0 16c-3.86 0-7-3.14-7-7s3.14-7 7-7 7 3.14 7 7-3.14 7-7 7z"
})), 'ControlPointDuplicate');

exports.default = _default;

/***/ }),
/* 1540 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M10.08 10.86c.05-.33.16-.62.3-.87s.34-.46.59-.62c.24-.15.54-.22.91-.23.23.01.44.05.63.13.2.09.38.21.52.36s.25.33.34.53.13.42.14.64h1.79c-.02-.47-.11-.9-.28-1.29s-.4-.73-.7-1.01-.66-.5-1.08-.66-.88-.23-1.39-.23c-.65 0-1.22.11-1.7.34s-.88.53-1.2.92-.56.84-.71 1.36S8 11.29 8 11.87v.27c0 .58.08 1.12.23 1.64s.39.97.71 1.35.72.69 1.2.91 1.05.34 1.7.34c.47 0 .91-.08 1.32-.23s.77-.36 1.08-.63.56-.58.74-.94.29-.74.3-1.15h-1.79c-.01.21-.06.4-.15.58s-.21.33-.36.46-.32.23-.52.3c-.19.07-.39.09-.6.1-.36-.01-.66-.08-.89-.23-.25-.16-.45-.37-.59-.62s-.25-.55-.3-.88-.08-.67-.08-1v-.27c0-.35.03-.68.08-1.01zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
})), 'Copyright');

exports.default = _default;

/***/ }),
/* 1541 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"
})), 'Create');

exports.default = _default;

/***/ }),
/* 1542 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20 6h-8l-2-2H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zm-1 8h-3v3h-2v-3h-3v-2h3V9h2v3h3v2z"
})), 'CreateNewFolder');

exports.default = _default;

/***/ }),
/* 1543 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20 4H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zm0 14H4v-6h16v6zm0-10H4V6h16v2z"
})), 'CreditCard');

exports.default = _default;

/***/ }),
/* 1544 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M17 15h2V7c0-1.1-.9-2-2-2H9v2h8v8zM7 17V1H5v4H1v2h4v10c0 1.1.9 2 2 2h10v4h2v-4h4v-2H7z"
})), 'Crop');

exports.default = _default;

/***/ }),
/* 1545 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M19 6H5c-1.1 0-2 .9-2 2v8c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm0 10H5V8h14v8z"
})), 'Crop169');

exports.default = _default;

/***/ }),
/* 1546 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M19 4H5c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H5V6h14v12z"
})), 'Crop32');

exports.default = _default;

/***/ }),
/* 1547 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M19 5H5c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 12H5V7h14v10z"
})), 'Crop54');

exports.default = _default;

/***/ }),
/* 1548 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M19 7H5c-1.1 0-2 .9-2 2v6c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V9c0-1.1-.9-2-2-2zm0 8H5V9h14v6z"
})), 'Crop75');

exports.default = _default;

/***/ }),
/* 1549 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14z"
})), 'CropDin');

exports.default = _default;

/***/ }),
/* 1550 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M3 5v4h2V5h4V3H5c-1.1 0-2 .9-2 2zm2 10H3v4c0 1.1.9 2 2 2h4v-2H5v-4zm14 4h-4v2h4c1.1 0 2-.9 2-2v-4h-2v4zm0-16h-4v2h4v4h2V5c0-1.1-.9-2-2-2z"
})), 'CropFree');

exports.default = _default;

/***/ }),
/* 1551 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M19 5H5c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 12H5V7h14v10z"
})), 'CropLandscape');

exports.default = _default;

/***/ }),
/* 1552 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14zm-5.04-6.71l-2.75 3.54-1.96-2.36L6.5 17h11l-3.54-4.71z"
})), 'CropOriginal');

exports.default = _default;

/***/ }),
/* 1553 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M17 3H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H7V5h10v14z"
})), 'CropPortrait');

exports.default = _default;

/***/ }),
/* 1554 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M7.47 21.49C4.2 19.93 1.86 16.76 1.5 13H0c.51 6.16 5.66 11 11.95 11 .23 0 .44-.02.66-.03L8.8 20.15l-1.33 1.34zM12.05 0c-.23 0-.44.02-.66.04l3.81 3.81 1.33-1.33C19.8 4.07 22.14 7.24 22.5 11H24c-.51-6.16-5.66-11-11.95-11zM16 14h2V8c0-1.11-.9-2-2-2h-6v2h6v6zm-8 2V4H6v2H4v2h2v8c0 1.1.89 2 2 2h8v2h2v-2h2v-2H8z"
})), 'CropRotate');

exports.default = _default;

/***/ }),
/* 1555 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M18 4H6c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H6V6h12v12z"
})), 'CropSquare');

exports.default = _default;

/***/ }),
/* 1556 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M3 13h8V3H3v10zm0 8h8v-6H3v6zm10 0h8V11h-8v10zm0-18v6h8V3h-8z"
})), 'Dashboard');

exports.default = _default;

/***/ }),
/* 1557 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M13 2.05v3.03c3.39.49 6 3.39 6 6.92 0 .9-.18 1.75-.48 2.54l2.6 1.53c.56-1.24.88-2.62.88-4.07 0-5.18-3.95-9.45-9-9.95zM12 19c-3.87 0-7-3.13-7-7 0-3.53 2.61-6.43 6-6.92V2.05c-5.06.5-9 4.76-9 9.95 0 5.52 4.47 10 9.99 10 3.31 0 6.24-1.61 8.06-4.09l-2.6-1.53C16.17 17.98 14.21 19 12 19z"
})), 'DataUsage');

exports.default = _default;

/***/ }),
/* 1558 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M9 11H7v2h2v-2zm4 0h-2v2h2v-2zm4 0h-2v2h2v-2zm2-7h-1V2h-2v2H8V2H6v2H5c-1.11 0-1.99.9-1.99 2L3 20c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H5V9h14v11z"
})), 'DateRange');

exports.default = _default;

/***/ }),
/* 1559 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M2 15.5v2h20v-2H2zm0-5v2h20v-2H2zm0-5v2h20v-2H2z"
})), 'Dehaze');

exports.default = _default;

/***/ }),
/* 1560 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z"
})), 'Delete');

exports.default = _default;

/***/ }),
/* 1561 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zm2.46-7.12l1.41-1.41L12 12.59l2.12-2.12 1.41 1.41L13.41 14l2.12 2.12-1.41 1.41L12 15.41l-2.12 2.12-1.41-1.41L10.59 14l-2.13-2.12zM15.5 4l-1-1h-5l-1 1H5v2h14V4z"
})), 'DeleteForever');

exports.default = _default;

/***/ }),
/* 1562 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M15 16h4v2h-4zm0-8h7v2h-7zm0 4h6v2h-6zM3 18c0 1.1.9 2 2 2h6c1.1 0 2-.9 2-2V8H3v10zM14 5h-3l-1-1H6L5 5H2v2h12z"
})), 'DeleteSweep');

exports.default = _default;

/***/ }),
/* 1563 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm2 16H8v-2h8v2zm0-4H8v-2h8v2zm-3-5V3.5L18.5 9H13z"
})), 'Description');

exports.default = _default;

/***/ }),
/* 1564 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M21 2H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h7l-2 3v1h8v-1l-2-3h7c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 12H3V4h18v10z"
})), 'DesktopMac');

exports.default = _default;

/***/ }),
/* 1565 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M21 2H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h7v2H8v2h8v-2h-2v-2h7c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H3V4h18v12z"
})), 'DesktopWindows');

exports.default = _default;

/***/ }),
/* 1566 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M3 4l9 16 9-16H3zm3.38 2h11.25L12 16 6.38 6z"
})), 'Details');

exports.default = _default;

/***/ }),
/* 1567 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M22 9V7h-2V5c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-2h2v-2h-2v-2h2v-2h-2V9h2zm-4 10H4V5h14v14zM6 13h5v4H6zm6-6h4v3h-4zM6 7h5v5H6zm6 4h4v6h-4z"
})), 'DeveloperBoard');

exports.default = _default;

/***/ }),
/* 1568 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M7 5h10v2h2V3c0-1.1-.9-1.99-2-1.99L7 1c-1.1 0-2 .9-2 2v4h2V5zm8.41 11.59L20 12l-4.59-4.59L14 8.83 17.17 12 14 15.17l1.41 1.42zM10 15.17L6.83 12 10 8.83 8.59 7.41 4 12l4.59 4.59L10 15.17zM17 19H7v-2H5v4c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2v-4h-2v2z"
})), 'DeveloperMode');

exports.default = _default;

/***/ }),
/* 1569 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M17 16l-4-4V8.82C14.16 8.4 15 7.3 15 6c0-1.66-1.34-3-3-3S9 4.34 9 6c0 1.3.84 2.4 2 2.82V12l-4 4H3v5h5v-3.05l4-4.2 4 4.2V21h5v-5h-4z"
})), 'DeviceHub');

exports.default = _default;

/***/ }),
/* 1570 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M4 6h18V4H4c-1.1 0-2 .9-2 2v11H0v3h14v-3H4V6zm19 2h-6c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h6c.55 0 1-.45 1-1V9c0-.55-.45-1-1-1zm-1 9h-4v-7h4v7z"
})), 'Devices');

exports.default = _default;

/***/ }),
/* 1571 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M3 6h18V4H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h4v-2H3V6zm10 6H9v1.78c-.61.55-1 1.33-1 2.22s.39 1.67 1 2.22V20h4v-1.78c.61-.55 1-1.34 1-2.22s-.39-1.67-1-2.22V12zm-2 5.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM22 8h-6c-.5 0-1 .5-1 1v10c0 .5.5 1 1 1h6c.5 0 1-.5 1-1V9c0-.5-.5-1-1-1zm-1 10h-4v-8h4v8z"
})), 'DevicesOther');

exports.default = _default;

/***/ }),
/* 1572 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M17 3h-1v5h1V3zm-2 2h-2V4h2V3h-3v3h2v1h-2v1h3V5zm3-2v5h1V6h2V3h-3zm2 2h-1V4h1v1zm0 10.5c-1.25 0-2.45-.2-3.57-.57-.35-.11-.74-.03-1.01.24l-2.2 2.2c-2.83-1.44-5.15-3.75-6.59-6.59l2.2-2.21c.27-.26.35-.65.24-1C8.7 6.45 8.5 5.25 8.5 4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.5c0-.55-.45-1-1-1z"
})), 'DialerSip');

exports.default = _default;

/***/ }),
/* 1573 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 19c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zM6 1c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12-8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm-6 8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
})), 'Dialpad');

exports.default = _default;

/***/ }),
/* 1574 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M21.71 11.29l-9-9c-.39-.39-1.02-.39-1.41 0l-9 9c-.39.39-.39 1.02 0 1.41l9 9c.39.39 1.02.39 1.41 0l9-9c.39-.38.39-1.01 0-1.41zM14 14.5V12h-4v3H8v-4c0-.55.45-1 1-1h5V7.5l3.5 3.5-3.5 3.5z"
})), 'Directions');

exports.default = _default;

/***/ }),
/* 1575 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M15.5 5.5c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zM5 12c-2.8 0-5 2.2-5 5s2.2 5 5 5 5-2.2 5-5-2.2-5-5-5zm0 8.5c-1.9 0-3.5-1.6-3.5-3.5s1.6-3.5 3.5-3.5 3.5 1.6 3.5 3.5-1.6 3.5-3.5 3.5zm5.8-10l2.4-2.4.8.8c1.3 1.3 3 2.1 5.1 2.1V9c-1.5 0-2.7-.6-3.6-1.5l-1.9-1.9c-.5-.4-1-.6-1.6-.6s-1.1.2-1.4.6L7.8 8.4c-.4.4-.6.9-.6 1.4 0 .6.2 1.1.6 1.4L11 14v5h2v-6.2l-2.2-2.3zM19 12c-2.8 0-5 2.2-5 5s2.2 5 5 5 5-2.2 5-5-2.2-5-5-5zm0 8.5c-1.9 0-3.5-1.6-3.5-3.5s1.6-3.5 3.5-3.5 3.5 1.6 3.5 3.5-1.6 3.5-3.5 3.5z"
})), 'DirectionsBike');

exports.default = _default;

/***/ }),
/* 1576 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20 21c-1.39 0-2.78-.47-4-1.32-2.44 1.71-5.56 1.71-8 0C6.78 20.53 5.39 21 4 21H2v2h2c1.38 0 2.74-.35 4-.99 2.52 1.29 5.48 1.29 8 0 1.26.65 2.62.99 4 .99h2v-2h-2zM3.95 19H4c1.6 0 3.02-.88 4-2 .98 1.12 2.4 2 4 2s3.02-.88 4-2c.98 1.12 2.4 2 4 2h.05l1.89-6.68c.08-.26.06-.54-.06-.78s-.34-.42-.6-.5L20 10.62V6c0-1.1-.9-2-2-2h-3V1H9v3H6c-1.1 0-2 .9-2 2v4.62l-1.29.42c-.26.08-.48.26-.6.5s-.15.52-.06.78L3.95 19zM6 6h12v3.97L12 8 6 9.97V6z"
})), 'DirectionsBoat');

exports.default = _default;

/***/ }),
/* 1577 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M4 16c0 .88.39 1.67 1 2.22V20c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h8v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1.78c.61-.55 1-1.34 1-2.22V6c0-3.5-3.58-4-8-4s-8 .5-8 4v10zm3.5 1c-.83 0-1.5-.67-1.5-1.5S6.67 14 7.5 14s1.5.67 1.5 1.5S8.33 17 7.5 17zm9 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm1.5-6H6V6h12v5z"
})), 'DirectionsBus');

exports.default = _default;

/***/ }),
/* 1578 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M18.92 6.01C18.72 5.42 18.16 5 17.5 5h-11c-.66 0-1.21.42-1.42 1.01L3 12v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-8l-2.08-5.99zM6.5 16c-.83 0-1.5-.67-1.5-1.5S5.67 13 6.5 13s1.5.67 1.5 1.5S7.33 16 6.5 16zm11 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM5 11l1.5-4.5h11L19 11H5z"
})), 'DirectionsCar');

exports.default = _default;

/***/ }),
/* 1579 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M4 15.5C4 17.43 5.57 19 7.5 19L6 20.5v.5h12v-.5L16.5 19c1.93 0 3.5-1.57 3.5-3.5V5c0-3.5-3.58-4-8-4s-8 .5-8 4v10.5zm8 1.5c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm6-7H6V5h12v5z"
})), 'DirectionsRailway');

exports.default = _default;

/***/ }),
/* 1580 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M13.49 5.48c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm-3.6 13.9l1-4.4 2.1 2v6h2v-7.5l-2.1-2 .6-3c1.3 1.5 3.3 2.5 5.5 2.5v-2c-1.9 0-3.5-1-4.3-2.4l-1-1.6c-.4-.6-1-1-1.7-1-.3 0-.5.1-.8.1l-5.2 2.2v4.7h2v-3.4l1.8-.7-1.6 8.1-4.9-1-.4 2 7 1.4z"
})), 'DirectionsRun');

exports.default = _default;

/***/ }),
/* 1581 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 2c-4.42 0-8 .5-8 4v9.5C4 17.43 5.57 19 7.5 19L6 20.5v.5h12v-.5L16.5 19c1.93 0 3.5-1.57 3.5-3.5V6c0-3.5-3.58-4-8-4zM7.5 17c-.83 0-1.5-.67-1.5-1.5S6.67 14 7.5 14s1.5.67 1.5 1.5S8.33 17 7.5 17zm3.5-6H6V6h5v5zm5.5 6c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm1.5-6h-5V6h5v5z"
})), 'DirectionsSubway');

exports.default = _default;

/***/ }),
/* 1582 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 2c-4.42 0-8 .5-8 4v9.5C4 17.43 5.57 19 7.5 19L6 20.5v.5h12v-.5L16.5 19c1.93 0 3.5-1.57 3.5-3.5V6c0-3.5-3.58-4-8-4zM7.5 17c-.83 0-1.5-.67-1.5-1.5S6.67 14 7.5 14s1.5.67 1.5 1.5S8.33 17 7.5 17zm3.5-6H6V6h5v5zm5.5 6c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm1.5-6h-5V6h5v5z"
})), 'DirectionsTransit');

exports.default = _default;

/***/ }),
/* 1583 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M13.5 5.5c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zM9.8 8.9L7 23h2.1l1.8-8 2.1 2v6h2v-7.5l-2.1-2 .6-3C14.8 12 16.8 13 19 13v-2c-1.9 0-3.5-1-4.3-2.4l-1-1.6c-.4-.6-1-1-1.7-1-.3 0-.5.1-.8.1L6 8.3V13h2V9.6l1.8-.7"
})), 'DirectionsWalk');

exports.default = _default;

/***/ }),
/* 1584 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20 16h2v-2h-2v2zm0-9v5h2V7h-2zM10 4c-4.42 0-8 3.58-8 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8zm0 10c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"
})), 'DiscFull');

exports.default = _default;

/***/ }),
/* 1585 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20 13H4c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1h16c.55 0 1-.45 1-1v-6c0-.55-.45-1-1-1zM7 19c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zM20 3H4c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1h16c.55 0 1-.45 1-1V4c0-.55-.45-1-1-1zM7 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"
})), 'Dns');

exports.default = _default;

/***/ }),
/* 1586 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M8 23h8v-2H8v2zm8-21.99L8 1c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM16 15H8V5h8v10z"
})), 'Dock');

exports.default = _default;

/***/ }),
/* 1587 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 7V3H2v18h20V7H12zM6 19H4v-2h2v2zm0-4H4v-2h2v2zm0-4H4V9h2v2zm0-4H4V5h2v2zm4 12H8v-2h2v2zm0-4H8v-2h2v2zm0-4H8V9h2v2zm0-4H8V5h2v2zm10 12h-8v-2h2v-2h-2v-2h2v-2h-2V9h8v10zm-2-8h-2v2h2v-2zm0 4h-2v2h2v-2z"
})), 'Domain');

exports.default = _default;

/***/ }),
/* 1588 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z"
})), 'Done');

exports.default = _default;

/***/ }),
/* 1589 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M18 7l-1.41-1.41-6.34 6.34 1.41 1.41L18 7zm4.24-1.41L11.66 16.17 7.48 12l-1.41 1.41L11.66 19l12-12-1.42-1.41zM.41 13.41L6 19l1.41-1.41L1.83 12 .41 13.41z"
})), 'DoneAll');

exports.default = _default;

/***/ }),
/* 1590 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8 0-1.85.63-3.55 1.69-4.9L16.9 18.31C15.55 19.37 13.85 20 12 20zm6.31-3.1L7.1 5.69C8.45 4.63 10.15 4 12 4c4.42 0 8 3.58 8 8 0 1.85-.63 3.55-1.69 4.9z"
})), 'DoNotDisturb');

exports.default = _default;

/***/ }),
/* 1591 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10S17.5 2 12 2zM4 12c0-4.4 3.6-8 8-8 1.8 0 3.5.6 4.9 1.7L5.7 16.9C4.6 15.5 4 13.8 4 12zm8 8c-1.8 0-3.5-.6-4.9-1.7L18.3 7.1C19.4 8.5 20 10.2 20 12c0 4.4-3.6 8-8 8z"
})), 'DoNotDisturbAlt');

exports.default = _default;

/***/ }),
/* 1592 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M17 11v2h-1.46l4.68 4.68C21.34 16.07 22 14.11 22 12c0-5.52-4.48-10-10-10-2.11 0-4.07.66-5.68 1.78L13.54 11H17zM2.27 2.27L1 3.54l2.78 2.78C2.66 7.93 2 9.89 2 12c0 5.52 4.48 10 10 10 2.11 0 4.07-.66 5.68-1.78L20.46 23l1.27-1.27L11 11 2.27 2.27zM7 13v-2h1.46l2 2H7z"
})), 'DoNotDisturbOff');

exports.default = _default;

/***/ }),
/* 1593 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm5 11H7v-2h10v2z"
})), 'DoNotDisturbOn');

exports.default = _default;

/***/ }),
/* 1594 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M11 5.08V2c-5 .5-9 4.81-9 10s4 9.5 9 10v-3.08c-3-.48-6-3.4-6-6.92s3-6.44 6-6.92zM18.97 11H22c-.47-5-4-8.53-9-9v3.08C16 5.51 18.54 8 18.97 11zM13 18.92V22c5-.47 8.53-4 9-9h-3.03c-.43 3-2.97 5.49-5.97 5.92z"
})), 'DonutLarge');

exports.default = _default;

/***/ }),
/* 1595 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M11 9.16V2c-5 .5-9 4.79-9 10s4 9.5 9 10v-7.16c-1-.41-2-1.52-2-2.84s1-2.43 2-2.84zM14.86 11H22c-.48-4.75-4-8.53-9-9v7.16c1 .3 1.52.98 1.86 1.84zM13 14.84V22c5-.47 8.52-4.25 9-9h-7.14c-.34.86-.86 1.54-1.86 1.84z"
})), 'DonutSmall');

exports.default = _default;

/***/ }),
/* 1596 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M21.99 8c0-.72-.37-1.35-.94-1.7L12 1 2.95 6.3C2.38 6.65 2 7.28 2 8v10c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2l-.01-10zM12 13L3.74 7.84 12 3l8.26 4.84L12 13z"
})), 'Drafts');

exports.default = _default;

/***/ }),
/* 1597 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20 9H4v2h16V9zM4 15h16v-2H4v2z"
})), 'DragHandle');

exports.default = _default;

/***/ }),
/* 1598 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M18.92 5.01C18.72 4.42 18.16 4 17.5 4h-11c-.66 0-1.21.42-1.42 1.01L3 11v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-8l-2.08-5.99zM6.5 15c-.83 0-1.5-.67-1.5-1.5S5.67 12 6.5 12s1.5.67 1.5 1.5S7.33 15 6.5 15zm11 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM5 10l1.5-4.5h11L19 10H5z"
})), 'DriveEta');

exports.default = _default;

/***/ }),
/* 1599 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M21 3H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h5v2h8v-2h5c1.1 0 1.99-.9 1.99-2L23 5c0-1.1-.9-2-2-2zm0 14H3V5h18v12zm-2-9H8v2h11V8zm0 4H8v2h11v-2zM7 8H5v2h2V8zm0 4H5v2h2v-2z"
})), 'Dvr');

exports.default = _default;

/***/ }),
/* 1600 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"
})), 'Edit');

exports.default = _default;

/***/ }),
/* 1601 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 2C8.14 2 5 5.14 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.86-3.14-7-7-7zm-1.56 10H9v-1.44l3.35-3.34 1.43 1.43L10.44 12zm4.45-4.45l-.7.7-1.44-1.44.7-.7c.15-.15.39-.15.54 0l.9.9c.15.15.15.39 0 .54z"
})), 'EditLocation');

exports.default = _default;

/***/ }),
/* 1602 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M5 17h14v2H5zm7-12L5.33 15h13.34z"
})), 'Eject');

exports.default = _default;

/***/ }),
/* 1603 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"
})), 'Email');

exports.default = _default;

/***/ }),
/* 1604 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zM8.9 6c0-1.71 1.39-3.1 3.1-3.1s3.1 1.39 3.1 3.1v2H8.9V6zM16 16h-3v3h-2v-3H8v-2h3v-3h2v3h3v2z"
})), 'EnhancedEncryption');

exports.default = _default;

/***/ }),
/* 1605 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M10 20h4V4h-4v16zm-6 0h4v-8H4v8zM16 9v11h4V9h-4z"
})), 'Equalizer');

exports.default = _default;

/***/ }),
/* 1606 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"
})), 'Error');

exports.default = _default;

/***/ }),
/* 1607 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M11 15h2v2h-2zm0-8h2v6h-2zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
})), 'ErrorOutline');

exports.default = _default;

/***/ }),
/* 1608 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M15 18.5c-2.51 0-4.68-1.42-5.76-3.5H15v-2H8.58c-.05-.33-.08-.66-.08-1s.03-.67.08-1H15V9H9.24C10.32 6.92 12.5 5.5 15 5.5c1.61 0 3.09.59 4.23 1.57L21 5.3C19.41 3.87 17.3 3 15 3c-3.92 0-7.24 2.51-8.48 6H3v2h3.06c-.04.33-.06.66-.06 1 0 .34.02.67.06 1H3v2h3.52c1.24 3.49 4.56 6 8.48 6 2.31 0 4.41-.87 6-2.3l-1.78-1.77c-1.13.98-2.6 1.57-4.22 1.57z"
})), 'EuroSymbol');

exports.default = _default;

/***/ }),
/* 1609 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M17 12h-5v5h5v-5zM16 1v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2h-1V1h-2zm3 18H5V8h14v11z"
})), 'Event');

exports.default = _default;

/***/ }),
/* 1610 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M16.53 11.06L15.47 10l-4.88 4.88-2.12-2.12-1.06 1.06L10.59 17l5.94-5.94zM19 3h-1V1h-2v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V8h14v11z"
})), 'EventAvailable');

exports.default = _default;

/***/ }),
/* 1611 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M9.31 17l2.44-2.44L14.19 17l1.06-1.06-2.44-2.44 2.44-2.44L14.19 10l-2.44 2.44L9.31 10l-1.06 1.06 2.44 2.44-2.44 2.44L9.31 17zM19 3h-1V1h-2v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V8h14v11z"
})), 'EventBusy');

exports.default = _default;

/***/ }),
/* 1612 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M17 10H7v2h10v-2zm2-7h-1V1h-2v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V8h14v11zm-5-5H7v2h7v-2z"
})), 'EventNote');

exports.default = _default;

/***/ }),
/* 1613 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M4 18v3h3v-3h10v3h3v-6H4zm15-8h3v3h-3zM2 10h3v3H2zm15 3H7V5c0-1.1.9-2 2-2h6c1.1 0 2 .9 2 2v8z"
})), 'EventSeat');

exports.default = _default;

/***/ }),
/* 1614 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M19.77 7.23l.01-.01-3.72-3.72L15 4.56l2.11 2.11c-.94.36-1.61 1.26-1.61 2.33 0 1.38 1.12 2.5 2.5 2.5.36 0 .69-.08 1-.21v7.21c0 .55-.45 1-1 1s-1-.45-1-1V14c0-1.1-.9-2-2-2h-1V5c0-1.1-.9-2-2-2H6c-1.1 0-2 .9-2 2v16h10v-7.5h1.5v5c0 1.38 1.12 2.5 2.5 2.5s2.5-1.12 2.5-2.5V9c0-.69-.28-1.32-.73-1.77zM18 10c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zM8 18v-4.5H6L10 6v5h2l-4 7z"
})), 'EvStation');

exports.default = _default;

/***/ }),
/* 1615 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M10.09 15.59L11.5 17l5-5-5-5-1.41 1.41L12.67 11H3v2h9.67l-2.58 2.59zM19 3H5c-1.11 0-2 .9-2 2v4h2V5h14v14H5v-4H3v4c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
})), 'ExitToApp');

exports.default = _default;

/***/ }),
/* 1616 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 8l-6 6 1.41 1.41L12 10.83l4.59 4.58L18 14z"
})), 'ExpandLess');

exports.default = _default;

/***/ }),
/* 1617 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-4 6h-4v2h4v2h-4v2h4v2H9V7h6v2z"
})), 'Explicit');

exports.default = _default;

/***/ }),
/* 1618 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 10.9c-.61 0-1.1.49-1.1 1.1s.49 1.1 1.1 1.1c.61 0 1.1-.49 1.1-1.1s-.49-1.1-1.1-1.1zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm2.19 12.19L6 18l3.81-8.19L18 6l-3.81 8.19z"
})), 'Explore');

exports.default = _default;

/***/ }),
/* 1619 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M15 17v2h2v-2h2v-2h-2v-2h-2v2h-2v2h2zm5-15H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM5 5h6v2H5V5zm15 15H4L20 4v16z"
})), 'Exposure');

exports.default = _default;

/***/ }),
/* 1620 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M4 11v2h8v-2H4zm15 7h-2V7.38L14 8.4V6.7L18.7 5h.3v13z"
})), 'ExposureNeg1');

exports.default = _default;

/***/ }),
/* 1621 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M15.05 16.29l2.86-3.07c.38-.39.72-.79 1.04-1.18.32-.39.59-.78.82-1.17.23-.39.41-.78.54-1.17s.19-.79.19-1.18c0-.53-.09-1.02-.27-1.46-.18-.44-.44-.81-.78-1.11-.34-.31-.77-.54-1.26-.71-.51-.16-1.08-.24-1.72-.24-.69 0-1.31.11-1.85.32-.54.21-1 .51-1.36.88-.37.37-.65.8-.84 1.3-.18.47-.27.97-.28 1.5h2.14c.01-.31.05-.6.13-.87.09-.29.23-.54.4-.75.18-.21.41-.37.68-.49.27-.12.6-.18.96-.18.31 0 .58.05.81.15.23.1.43.25.59.43.16.18.28.4.37.65.08.25.13.52.13.81 0 .22-.03.43-.08.65-.06.22-.15.45-.29.7-.14.25-.32.53-.56.83-.23.3-.52.65-.88 1.03l-4.17 4.55V18H21v-1.71h-5.95zM2 11v2h8v-2H2z"
})), 'ExposureNeg2');

exports.default = _default;

/***/ }),
/* 1622 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M10 7H8v4H4v2h4v4h2v-4h4v-2h-4V7zm10 11h-2V7.38L15 8.4V6.7L19.7 5h.3v13z"
})), 'ExposurePlus1');

exports.default = _default;

/***/ }),
/* 1623 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M16.05 16.29l2.86-3.07c.38-.39.72-.79 1.04-1.18.32-.39.59-.78.82-1.17.23-.39.41-.78.54-1.17.13-.39.19-.79.19-1.18 0-.53-.09-1.02-.27-1.46-.18-.44-.44-.81-.78-1.11-.34-.31-.77-.54-1.26-.71-.51-.16-1.08-.24-1.72-.24-.69 0-1.31.11-1.85.32-.54.21-1 .51-1.36.88-.37.37-.65.8-.84 1.3-.18.47-.27.97-.28 1.5h2.14c.01-.31.05-.6.13-.87.09-.29.23-.54.4-.75.18-.21.41-.37.68-.49.27-.12.6-.18.96-.18.31 0 .58.05.81.15.23.1.43.25.59.43.16.18.28.4.37.65.08.25.13.52.13.81 0 .22-.03.43-.08.65-.06.22-.15.45-.29.7-.14.25-.32.53-.56.83-.23.3-.52.65-.88 1.03l-4.17 4.55V18H22v-1.71h-5.95zM8 7H6v4H2v2h4v4h2v-4h4v-2H8V7z"
})), 'ExposurePlus2');

exports.default = _default;

/***/ }),
/* 1624 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M16.14 12.5c0 1-.1 1.85-.3 2.55-.2.7-.48 1.27-.83 1.7-.36.44-.79.75-1.3.95-.51.2-1.07.3-1.7.3-.62 0-1.18-.1-1.69-.3-.51-.2-.95-.51-1.31-.95-.36-.44-.65-1.01-.85-1.7-.2-.7-.3-1.55-.3-2.55v-2.04c0-1 .1-1.85.3-2.55.2-.7.48-1.26.84-1.69.36-.43.8-.74 1.31-.93C10.81 5.1 11.38 5 12 5c.63 0 1.19.1 1.7.29.51.19.95.5 1.31.93.36.43.64.99.84 1.69.2.7.3 1.54.3 2.55v2.04zm-2.11-2.36c0-.64-.05-1.18-.13-1.62-.09-.44-.22-.79-.4-1.06-.17-.27-.39-.46-.64-.58-.25-.13-.54-.19-.86-.19-.32 0-.61.06-.86.18s-.47.31-.64.58c-.17.27-.31.62-.4 1.06s-.13.98-.13 1.62v2.67c0 .64.05 1.18.14 1.62.09.45.23.81.4 1.09s.39.48.64.61.54.19.87.19c.33 0 .62-.06.87-.19s.46-.33.63-.61c.17-.28.3-.64.39-1.09.09-.45.13-.99.13-1.62v-2.66z"
})), 'ExposureZero');

exports.default = _default;

/***/ }),
/* 1625 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20.5 11H19V7c0-1.1-.9-2-2-2h-4V3.5C13 2.12 11.88 1 10.5 1S8 2.12 8 3.5V5H4c-1.1 0-1.99.9-1.99 2v3.8H3.5c1.49 0 2.7 1.21 2.7 2.7s-1.21 2.7-2.7 2.7H2V20c0 1.1.9 2 2 2h3.8v-1.5c0-1.49 1.21-2.7 2.7-2.7 1.49 0 2.7 1.21 2.7 2.7V22H17c1.1 0 2-.9 2-2v-4h1.5c1.38 0 2.5-1.12 2.5-2.5S21.88 11 20.5 11z"
})), 'Extension');

exports.default = _default;

/***/ }),
/* 1626 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M9 11.75c-.69 0-1.25.56-1.25 1.25s.56 1.25 1.25 1.25 1.25-.56 1.25-1.25-.56-1.25-1.25-1.25zm6 0c-.69 0-1.25.56-1.25 1.25s.56 1.25 1.25 1.25 1.25-.56 1.25-1.25-.56-1.25-1.25-1.25zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8 0-.29.02-.58.05-.86 2.36-1.05 4.23-2.98 5.21-5.37C11.07 8.33 14.05 10 17.42 10c.78 0 1.53-.09 2.25-.26.21.71.33 1.47.33 2.26 0 4.41-3.59 8-8 8z"
})), 'Face');

exports.default = _default;

/***/ }),
/* 1627 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M4 18l8.5-6L4 6v12zm9-12v12l8.5-6L13 6z"
})), 'FastForward');

exports.default = _default;

/***/ }),
/* 1628 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M11 18V6l-8.5 6 8.5 6zm.5-6l8.5 6V6l-8.5 6z"
})), 'FastRewind');

exports.default = _default;

/***/ }),
/* 1629 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"
})), 'Favorite');

exports.default = _default;

/***/ }),
/* 1630 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M16.5 3c-1.74 0-3.41.81-4.5 2.09C10.91 3.81 9.24 3 7.5 3 4.42 3 2 5.42 2 8.5c0 3.78 3.4 6.86 8.55 11.54L12 21.35l1.45-1.32C18.6 15.36 22 12.28 22 8.5 22 5.42 19.58 3 16.5 3zm-4.4 15.55l-.1.1-.1-.1C7.14 14.24 4 11.39 4 8.5 4 6.5 5.5 5 7.5 5c1.54 0 3.04.99 3.57 2.36h1.87C13.46 5.99 14.96 5 16.5 5c2 0 3.5 1.5 3.5 3.5 0 2.89-3.14 5.74-7.9 10.05z"
})), 'FavoriteBorder');

exports.default = _default;

/***/ }),
/* 1631 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-9 8H3V9h9v2zm0-4H3V5h9v2z"
})), 'FeaturedPlayList');

exports.default = _default;

/***/ }),
/* 1632 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-9 9H3V5h9v7z"
})), 'FeaturedVideo');

exports.default = _default;

/***/ }),
/* 1633 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-7 12h-2v-2h2v2zm0-4h-2V6h2v4z"
})), 'Feedback');

exports.default = _default;

/***/ }),
/* 1634 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M17.5 10.5h2v1h-2zm-13 0h2v3h-2zM21 3H3c-1.11 0-2 .89-2 2v14c0 1.1.89 2 2 2h18c1.11 0 2-.9 2-2V5c0-1.11-.89-2-2-2zM8 13.5c0 .85-.65 1.5-1.5 1.5H3V9h3.5c.85 0 1.5.65 1.5 1.5v3zm4.62 1.5h-1.5L9.37 9h1.5l1 3.43 1-3.43h1.5l-1.75 6zM21 11.5c0 .6-.4 1.15-.9 1.4L21 15h-1.5l-.85-2H17.5v2H16V9h3.5c.85 0 1.5.65 1.5 1.5v1z"
})), 'FiberDvr');

exports.default = _default;

/***/ }),
/* 1635 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("circle", {
  cx: "12",
  cy: "12",
  r: "8"
})), 'FiberManualRecord');

exports.default = _default;

/***/ }),
/* 1636 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20 4H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zM8.5 15H7.3l-2.55-3.5V15H3.5V9h1.25l2.5 3.5V9H8.5v6zm5-4.74H11v1.12h2.5v1.26H11v1.11h2.5V15h-4V9h4v1.26zm7 3.74c0 .55-.45 1-1 1h-4c-.55 0-1-.45-1-1V9h1.25v4.51h1.13V9.99h1.25v3.51h1.12V9h1.25v5z"
})), 'FiberNew');

exports.default = _default;

/***/ }),
/* 1637 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M5.5 10.5h2v1h-2zM20 4H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zM9 11.5c0 .85-.65 1.5-1.5 1.5h-2v2H4V9h3.5c.85 0 1.5.65 1.5 1.5v1zm3.5 3.5H11V9h1.5v6zm7.5 0h-1.2l-2.55-3.5V15H15V9h1.25l2.5 3.5V9H20v6z"
})), 'FiberPin');

exports.default = _default;

/***/ }),
/* 1638 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("g", null, _react.default.createElement("circle", {
  cx: "9",
  cy: "12",
  r: "8"
}), _react.default.createElement("path", {
  d: "M17 4.26v2.09c2.33.82 4 3.04 4 5.65s-1.67 4.83-4 5.65v2.09c3.45-.89 6-4.01 6-7.74s-2.55-6.85-6-7.74z"
}))), 'FiberSmartRecord');

exports.default = _default;

/***/ }),
/* 1639 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z"
})), 'FileDownload');

exports.default = _default;

/***/ }),
/* 1640 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M9 16h6v-6h4l-7-7-7 7h4zm-4 2h14v2H5z"
})), 'FileUpload');

exports.default = _default;

/***/ }),
/* 1641 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M15.96 10.29l-2.75 3.54-1.96-2.36L8.5 15h11l-3.54-4.71zM3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm18-4H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14z"
})), 'Filter');

exports.default = _default;

/***/ }),
/* 1642 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm11 10h2V5h-4v2h2v8zm7-14H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14z"
})), 'Filter1');

exports.default = _default;

/***/ }),
/* 1643 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm18-4H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14zm-4-4h-4v-2h2c1.1 0 2-.89 2-2V7c0-1.11-.9-2-2-2h-4v2h4v2h-2c-1.1 0-2 .89-2 2v4h6v-2z"
})), 'Filter2');

exports.default = _default;

/***/ }),
/* 1644 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M21 1H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14zM3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm14 8v-1.5c0-.83-.67-1.5-1.5-1.5.83 0 1.5-.67 1.5-1.5V7c0-1.11-.9-2-2-2h-4v2h4v2h-2v2h2v2h-4v2h4c1.1 0 2-.89 2-2z"
})), 'Filter3');

exports.default = _default;

/***/ }),
/* 1645 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm12 10h2V5h-2v4h-2V5h-2v6h4v4zm6-14H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14z"
})), 'Filter4');

exports.default = _default;

/***/ }),
/* 1646 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M21 1H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14zM3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm14 8v-2c0-1.11-.9-2-2-2h-2V7h4V5h-6v6h4v2h-4v2h4c1.1 0 2-.89 2-2z"
})), 'Filter5');

exports.default = _default;

/***/ }),
/* 1647 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm18-4H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14zm-8-2h2c1.1 0 2-.89 2-2v-2c0-1.11-.9-2-2-2h-2V7h4V5h-4c-1.1 0-2 .89-2 2v6c0 1.11.9 2 2 2zm0-4h2v2h-2v-2z"
})), 'Filter6');

exports.default = _default;

/***/ }),
/* 1648 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm18-4H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14zm-8-2l4-8V5h-6v2h4l-4 8h2z"
})), 'Filter7');

exports.default = _default;

/***/ }),
/* 1649 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm18-4H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14zm-8-2h2c1.1 0 2-.89 2-2v-1.5c0-.83-.67-1.5-1.5-1.5.83 0 1.5-.67 1.5-1.5V7c0-1.11-.9-2-2-2h-2c-1.1 0-2 .89-2 2v1.5c0 .83.67 1.5 1.5 1.5-.83 0-1.5.67-1.5 1.5V13c0 1.11.9 2 2 2zm0-8h2v2h-2V7zm0 4h2v2h-2v-2z"
})), 'Filter8');

exports.default = _default;

/***/ }),
/* 1650 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm18-4H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14zM15 5h-2c-1.1 0-2 .89-2 2v2c0 1.11.9 2 2 2h2v2h-4v2h4c1.1 0 2-.89 2-2V7c0-1.11-.9-2-2-2zm0 4h-2V7h2v2z"
})), 'Filter9');

exports.default = _default;

/***/ }),
/* 1651 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm11 7V8c0-1.11-.9-2-2-2h-1c-1.1 0-2 .89-2 2v1c0 1.11.9 2 2 2h1v1H9v2h3c1.1 0 2-.89 2-2zm-3-3V8h1v1h-1zm10-8H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 8h-2V7h-2v2h-2v2h2v2h2v-2h2v6H7V3h14v6z"
})), 'Filter9Plus');

exports.default = _default;

/***/ }),
/* 1652 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16l-7-8v8H5l7-8V5h7v14z"
})), 'FilterBAndW');

exports.default = _default;

/***/ }),
/* 1653 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M5 15H3v4c0 1.1.9 2 2 2h4v-2H5v-4zM5 5h4V3H5c-1.1 0-2 .9-2 2v4h2V5zm14-2h-4v2h4v4h2V5c0-1.1-.9-2-2-2zm0 16h-4v2h4c1.1 0 2-.9 2-2v-4h-2v4zM12 9c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"
})), 'FilterCenterFocus');

exports.default = _default;

/***/ }),
/* 1654 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.61 5.64 5.36 8.04 2.35 8.36 0 10.9 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM19 18H6c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4h2c0-2.76-1.86-5.08-4.4-5.78C8.61 6.88 10.2 6 12 6c3.03 0 5.5 2.47 5.5 5.5v.5H19c1.65 0 3 1.35 3 3s-1.35 3-3 3z"
})), 'FilterDrama');

exports.default = _default;

/***/ }),
/* 1655 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20 4h-4l-4-4-4 4H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H4V6h4.52l3.52-3.5L15.52 6H20v14zM18 8H6v10h12"
})), 'FilterFrames');

exports.default = _default;

/***/ }),
/* 1656 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M14 6l-3.75 5 2.85 3.8-1.6 1.2C9.81 13.75 7 10 7 10l-6 8h22L14 6z"
})), 'FilterHdr');

exports.default = _default;

/***/ }),
/* 1657 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M10 18h4v-2h-4v2zM3 6v2h18V6H3zm3 7h12v-2H6v2z"
})), 'FilterList');

exports.default = _default;

/***/ }),
/* 1658 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm18-4H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14z"
})), 'FilterNone');

exports.default = _default;

/***/ }),
/* 1659 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M11 4.07V2.05c-2.01.2-3.84 1-5.32 2.21L7.1 5.69c1.11-.86 2.44-1.44 3.9-1.62zm7.32.19C16.84 3.05 15.01 2.25 13 2.05v2.02c1.46.18 2.79.76 3.9 1.62l1.42-1.43zM19.93 11h2.02c-.2-2.01-1-3.84-2.21-5.32L18.31 7.1c.86 1.11 1.44 2.44 1.62 3.9zM5.69 7.1L4.26 5.68C3.05 7.16 2.25 8.99 2.05 11h2.02c.18-1.46.76-2.79 1.62-3.9zM4.07 13H2.05c.2 2.01 1 3.84 2.21 5.32l1.43-1.43c-.86-1.1-1.44-2.43-1.62-3.89zM15 12c0-1.66-1.34-3-3-3s-3 1.34-3 3 1.34 3 3 3 3-1.34 3-3zm3.31 4.9l1.43 1.43c1.21-1.48 2.01-3.32 2.21-5.32h-2.02c-.18 1.45-.76 2.78-1.62 3.89zM13 19.93v2.02c2.01-.2 3.84-1 5.32-2.21l-1.43-1.43c-1.1.86-2.43 1.44-3.89 1.62zm-7.32-.19C7.16 20.95 9 21.75 11 21.95v-2.02c-1.46-.18-2.79-.76-3.9-1.62l-1.42 1.43z"
})), 'FilterTiltShift');

exports.default = _default;

/***/ }),
/* 1660 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M18.7 12.4c-.28-.16-.57-.29-.86-.4.29-.11.58-.24.86-.4 1.92-1.11 2.99-3.12 3-5.19-1.79-1.03-4.07-1.11-6 0-.28.16-.54.35-.78.54.05-.31.08-.63.08-.95 0-2.22-1.21-4.15-3-5.19C10.21 1.85 9 3.78 9 6c0 .32.03.64.08.95-.24-.2-.5-.39-.78-.55-1.92-1.11-4.2-1.03-6 0 0 2.07 1.07 4.08 3 5.19.28.16.57.29.86.4-.29.11-.58.24-.86.4-1.92 1.11-2.99 3.12-3 5.19 1.79 1.03 4.07 1.11 6 0 .28-.16.54-.35.78-.54-.05.32-.08.64-.08.96 0 2.22 1.21 4.15 3 5.19 1.79-1.04 3-2.97 3-5.19 0-.32-.03-.64-.08-.95.24.2.5.38.78.54 1.92 1.11 4.2 1.03 6 0-.01-2.07-1.08-4.08-3-5.19zM12 16c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4z"
})), 'FilterVintage');

exports.default = _default;

/***/ }),
/* 1661 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20 19.59V8l-6-6H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c.45 0 .85-.15 1.19-.4l-4.43-4.43c-.8.52-1.74.83-2.76.83-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5c0 1.02-.31 1.96-.83 2.75L20 19.59zM9 13c0 1.66 1.34 3 3 3s3-1.34 3-3-1.34-3-3-3-3 1.34-3 3z"
})), 'FindInPage');

exports.default = _default;

/***/ }),
/* 1662 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M11 6c1.38 0 2.63.56 3.54 1.46L12 10h6V4l-2.05 2.05C14.68 4.78 12.93 4 11 4c-3.53 0-6.43 2.61-6.92 6H6.1c.46-2.28 2.48-4 4.9-4zm5.64 9.14c.66-.9 1.12-1.97 1.28-3.14H15.9c-.46 2.28-2.48 4-4.9 4-1.38 0-2.63-.56-3.54-1.46L10 12H4v6l2.05-2.05C7.32 17.22 9.07 18 11 18c1.55 0 2.98-.51 4.14-1.36L20 21.49 21.49 20l-4.85-4.86z"
})), 'FindReplace');

exports.default = _default;

/***/ }),
/* 1663 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M17.81 4.47c-.08 0-.16-.02-.23-.06C15.66 3.42 14 3 12.01 3c-1.98 0-3.86.47-5.57 1.41-.24.13-.54.04-.68-.2-.13-.24-.04-.55.2-.68C7.82 2.52 9.86 2 12.01 2c2.13 0 3.99.47 6.03 1.52.25.13.34.43.21.67-.09.18-.26.28-.44.28zM3.5 9.72c-.1 0-.2-.03-.29-.09-.23-.16-.28-.47-.12-.7.99-1.4 2.25-2.5 3.75-3.27C9.98 4.04 14 4.03 17.15 5.65c1.5.77 2.76 1.86 3.75 3.25.16.22.11.54-.12.7-.23.16-.54.11-.7-.12-.9-1.26-2.04-2.25-3.39-2.94-2.87-1.47-6.54-1.47-9.4.01-1.36.7-2.5 1.7-3.4 2.96-.08.14-.23.21-.39.21zm6.25 12.07c-.13 0-.26-.05-.35-.15-.87-.87-1.34-1.43-2.01-2.64-.69-1.23-1.05-2.73-1.05-4.34 0-2.97 2.54-5.39 5.66-5.39s5.66 2.42 5.66 5.39c0 .28-.22.5-.5.5s-.5-.22-.5-.5c0-2.42-2.09-4.39-4.66-4.39-2.57 0-4.66 1.97-4.66 4.39 0 1.44.32 2.77.93 3.85.64 1.15 1.08 1.64 1.85 2.42.19.2.19.51 0 .71-.11.1-.24.15-.37.15zm7.17-1.85c-1.19 0-2.24-.3-3.1-.89-1.49-1.01-2.38-2.65-2.38-4.39 0-.28.22-.5.5-.5s.5.22.5.5c0 1.41.72 2.74 1.94 3.56.71.48 1.54.71 2.54.71.24 0 .64-.03 1.04-.1.27-.05.53.13.58.41.05.27-.13.53-.41.58-.57.11-1.07.12-1.21.12zM14.91 22c-.04 0-.09-.01-.13-.02-1.59-.44-2.63-1.03-3.72-2.1-1.4-1.39-2.17-3.24-2.17-5.22 0-1.62 1.38-2.94 3.08-2.94 1.7 0 3.08 1.32 3.08 2.94 0 1.07.93 1.94 2.08 1.94s2.08-.87 2.08-1.94c0-3.77-3.25-6.83-7.25-6.83-2.84 0-5.44 1.58-6.61 4.03-.39.81-.59 1.76-.59 2.8 0 .78.07 2.01.67 3.61.1.26-.03.55-.29.64-.26.1-.55-.04-.64-.29-.49-1.31-.73-2.61-.73-3.96 0-1.2.23-2.29.68-3.24 1.33-2.79 4.28-4.6 7.51-4.6 4.55 0 8.25 3.51 8.25 7.83 0 1.62-1.38 2.94-3.08 2.94s-3.08-1.32-3.08-2.94c0-1.07-.93-1.94-2.08-1.94s-2.08.87-2.08 1.94c0 1.71.66 3.31 1.87 4.51.95.94 1.86 1.46 3.27 1.85.27.07.42.35.35.61-.05.23-.26.38-.47.38z"
})), 'Fingerprint');

exports.default = _default;

/***/ }),
/* 1664 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M18.41 16.59L13.82 12l4.59-4.59L17 6l-6 6 6 6zM6 6h2v12H6z"
})), 'FirstPage');

exports.default = _default;

/***/ }),
/* 1665 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20.57 14.86L22 13.43 20.57 12 17 15.57 8.43 7 12 3.43 10.57 2 9.14 3.43 7.71 2 5.57 4.14 4.14 2.71 2.71 4.14l1.43 1.43L2 7.71l1.43 1.43L2 10.57 3.43 12 7 8.43 15.57 17 12 20.57 13.43 22l1.43-1.43L16.29 22l2.14-2.14 1.43 1.43 1.43-1.43-1.43-1.43L22 16.29z"
})), 'FitnessCenter');

exports.default = _default;

/***/ }),
/* 1666 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M14.4 6L14 4H5v17h2v-7h5.6l.4 2h7V6z"
})), 'Flag');

exports.default = _default;

/***/ }),
/* 1667 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M7 11H1v2h6v-2zm2.17-3.24L7.05 5.64 5.64 7.05l2.12 2.12 1.41-1.41zM13 1h-2v6h2V1zm5.36 6.05l-1.41-1.41-2.12 2.12 1.41 1.41 2.12-2.12zM17 11v2h6v-2h-6zm-5-2c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3zm2.83 7.24l2.12 2.12 1.41-1.41-2.12-2.12-1.41 1.41zm-9.19.71l1.41 1.41 2.12-2.12-1.41-1.41-2.12 2.12zM11 23h2v-6h-2v6z"
})), 'Flare');

exports.default = _default;

/***/ }),
/* 1668 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M3 2v12h3v9l7-12H9l4-9H3zm16 0h-2l-3.2 9h1.9l.7-2h3.2l.7 2h1.9L19 2zm-2.15 5.65L18 4l1.15 3.65h-2.3z"
})), 'FlashAuto');

exports.default = _default;

/***/ }),
/* 1669 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M3.27 3L2 4.27l5 5V13h3v9l3.58-6.14L17.73 20 19 18.73 3.27 3zM17 10h-4l4-8H7v2.18l8.46 8.46L17 10z"
})), 'FlashOff');

exports.default = _default;

/***/ }),
/* 1670 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M7 2v11h3v9l7-12h-4l4-8z"
})), 'FlashOn');

exports.default = _default;

/***/ }),
/* 1671 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M10.18 9"
}), _react.default.createElement("path", {
  d: "M21 16v-2l-8-5V3.5c0-.83-.67-1.5-1.5-1.5S10 2.67 10 3.5V9l-8 5v2l8-2.5V19l-2 1.5V22l3.5-1 3.5 1v-1.5L13 19v-5.5l8 2.5z"
})), 'Flight');

exports.default = _default;

/***/ }),
/* 1672 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M2.5 19h19v2h-19zm7.18-5.73l4.35 1.16 5.31 1.42c.8.21 1.62-.26 1.84-1.06.21-.8-.26-1.62-1.06-1.84l-5.31-1.42-2.76-9.02L10.12 2v8.28L5.15 8.95l-.93-2.32-1.45-.39v5.17l1.6.43 5.31 1.43z"
})), 'FlightLand');

exports.default = _default;

/***/ }),
/* 1673 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M2.5 19h19v2h-19zm19.57-9.36c-.21-.8-1.04-1.28-1.84-1.06L14.92 10l-6.9-6.43-1.93.51 4.14 7.17-4.97 1.33-1.97-1.54-1.45.39 1.82 3.16.77 1.33 1.6-.43 5.31-1.42 4.35-1.16L21 11.49c.81-.23 1.28-1.05 1.07-1.85z"
})), 'FlightTakeoff');

exports.default = _default;

/***/ }),
/* 1674 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M15 21h2v-2h-2v2zm4-12h2V7h-2v2zM3 5v14c0 1.1.9 2 2 2h4v-2H5V5h4V3H5c-1.1 0-2 .9-2 2zm16-2v2h2c0-1.1-.9-2-2-2zm-8 20h2V1h-2v22zm8-6h2v-2h-2v2zM15 5h2V3h-2v2zm4 8h2v-2h-2v2zm0 8c1.1 0 2-.9 2-2h-2v2z"
})), 'Flip');

exports.default = _default;

/***/ }),
/* 1675 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M9 7H7v2h2V7zm0 4H7v2h2v-2zm0-8c-1.11 0-2 .9-2 2h2V3zm4 12h-2v2h2v-2zm6-12v2h2c0-1.1-.9-2-2-2zm-6 0h-2v2h2V3zM9 17v-2H7c0 1.1.89 2 2 2zm10-4h2v-2h-2v2zm0-4h2V7h-2v2zm0 8c1.1 0 2-.9 2-2h-2v2zM5 7H3v12c0 1.1.89 2 2 2h12v-2H5V7zm10-2h2V3h-2v2zm0 12h2v-2h-2v2z"
})), 'FlipToBack');

exports.default = _default;

/***/ }),
/* 1676 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M3 13h2v-2H3v2zm0 4h2v-2H3v2zm2 4v-2H3c0 1.1.89 2 2 2zM3 9h2V7H3v2zm12 12h2v-2h-2v2zm4-18H9c-1.11 0-2 .9-2 2v10c0 1.1.89 2 2 2h10c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 12H9V5h10v10zm-8 6h2v-2h-2v2zm-4 0h2v-2H7v2z"
})), 'FlipToFront');

exports.default = _default;

/***/ }),
/* 1677 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M10 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2h-8l-2-2z"
})), 'Folder');

exports.default = _default;

/***/ }),
/* 1678 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20 6h-8l-2-2H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm0 12H4V8h16v10z"
})), 'FolderOpen');

exports.default = _default;

/***/ }),
/* 1679 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20 6h-8l-2-2H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm-5 3c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zm4 8h-8v-1c0-1.33 2.67-2 4-2s4 .67 4 2v1z"
})), 'FolderShared');

exports.default = _default;

/***/ }),
/* 1680 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20 6h-8l-2-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm-2.06 11L15 15.28 12.06 17l.78-3.33-2.59-2.24 3.41-.29L15 8l1.34 3.14 3.41.29-2.59 2.24.78 3.33z"
})), 'FolderSpecial');

exports.default = _default;

/***/ }),
/* 1681 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M9.93 13.5h4.14L12 7.98zM20 2H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-4.05 16.5l-1.14-3H9.17l-1.12 3H5.96l5.11-13h1.86l5.11 13h-2.09z"
})), 'FontDownload');

exports.default = _default;

/***/ }),
/* 1682 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M7 15v2h10v-2H7zm-4 6h18v-2H3v2zm0-8h18v-2H3v2zm4-6v2h10V7H7zM3 3v2h18V3H3z"
})), 'FormatAlignCenter');

exports.default = _default;

/***/ }),
/* 1683 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M3 21h18v-2H3v2zm0-4h18v-2H3v2zm0-4h18v-2H3v2zm0-4h18V7H3v2zm0-6v2h18V3H3z"
})), 'FormatAlignJustify');

exports.default = _default;

/***/ }),
/* 1684 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M15 15H3v2h12v-2zm0-8H3v2h12V7zM3 13h18v-2H3v2zm0 8h18v-2H3v2zM3 3v2h18V3H3z"
})), 'FormatAlignLeft');

exports.default = _default;

/***/ }),
/* 1685 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M3 21h18v-2H3v2zm6-4h12v-2H9v2zm-6-4h18v-2H3v2zm6-4h12V7H9v2zM3 3v2h18V3H3z"
})), 'FormatAlignRight');

exports.default = _default;

/***/ }),
/* 1686 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M15.6 10.79c.97-.67 1.65-1.77 1.65-2.79 0-2.26-1.75-4-4-4H7v14h7.04c2.09 0 3.71-1.7 3.71-3.79 0-1.52-.86-2.82-2.15-3.42zM10 6.5h3c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5h-3v-3zm3.5 9H10v-3h3.5c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5z"
})), 'FormatBold');

exports.default = _default;

/***/ }),
/* 1687 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M3.27 5L2 6.27l6.97 6.97L6.5 19h3l1.57-3.66L16.73 21 18 19.73 3.55 5.27 3.27 5zM6 5v.18L8.82 8h2.4l-.72 1.68 2.1 2.1L14.21 8H20V5H6z"
})), 'FormatClear');

exports.default = _default;

/***/ }),
/* 1688 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M16.56 8.94L7.62 0 6.21 1.41l2.38 2.38-5.15 5.15c-.59.59-.59 1.54 0 2.12l5.5 5.5c.29.29.68.44 1.06.44s.77-.15 1.06-.44l5.5-5.5c.59-.58.59-1.53 0-2.12zM5.21 10L10 5.21 14.79 10H5.21zM19 11.5s-2 2.17-2 3.5c0 1.1.9 2 2 2s2-.9 2-2c0-1.33-2-3.5-2-3.5z"
}), _react.default.createElement("path", {
  fillOpacity: ".36",
  d: "M0 20h24v4H0z"
})), 'FormatColorFill');

exports.default = _default;

/***/ }),
/* 1689 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M18 14c0-4-6-10.8-6-10.8s-1.33 1.51-2.73 3.52l8.59 8.59c.09-.42.14-.86.14-1.31zm-.88 3.12L12.5 12.5 5.27 5.27 4 6.55l3.32 3.32C6.55 11.32 6 12.79 6 14c0 3.31 2.69 6 6 6 1.52 0 2.9-.57 3.96-1.5l2.63 2.63 1.27-1.27-2.74-2.74z"
})), 'FormatColorReset');

exports.default = _default;

/***/ }),
/* 1690 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  fillOpacity: ".36",
  d: "M0 20h24v4H0z"
}), _react.default.createElement("path", {
  d: "M11 3L5.5 17h2.25l1.12-3h6.25l1.12 3h2.25L13 3h-2zm-1.38 9L12 5.67 14.38 12H9.62z"
})), 'FormatColorText');

exports.default = _default;

/***/ }),
/* 1691 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M11 17h10v-2H11v2zm-8-5l4 4V8l-4 4zm0 9h18v-2H3v2zM3 3v2h18V3H3zm8 6h10V7H11v2zm0 4h10v-2H11v2z"
})), 'FormatIndentDecrease');

exports.default = _default;

/***/ }),
/* 1692 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M3 21h18v-2H3v2zM3 8v8l4-4-4-4zm8 9h10v-2H11v2zM3 3v2h18V3H3zm8 6h10V7H11v2zm0 4h10v-2H11v2z"
})), 'FormatIndentIncrease');

exports.default = _default;

/***/ }),
/* 1693 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M10 4v3h2.21l-3.42 8H6v3h8v-3h-2.21l3.42-8H18V4z"
})), 'FormatItalic');

exports.default = _default;

/***/ }),
/* 1694 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M6 7h2.5L5 3.5 1.5 7H4v10H1.5L5 20.5 8.5 17H6V7zm4-2v2h12V5H10zm0 14h12v-2H10v2zm0-6h12v-2H10v2z"
})), 'FormatLineSpacing');

exports.default = _default;

/***/ }),
/* 1695 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M4 10.5c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5zm0-6c-.83 0-1.5.67-1.5 1.5S3.17 7.5 4 7.5 5.5 6.83 5.5 6 4.83 4.5 4 4.5zm0 12c-.83 0-1.5.68-1.5 1.5s.68 1.5 1.5 1.5 1.5-.68 1.5-1.5-.67-1.5-1.5-1.5zM7 19h14v-2H7v2zm0-6h14v-2H7v2zm0-8v2h14V5H7z"
})), 'FormatListBulleted');

exports.default = _default;

/***/ }),
/* 1696 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M2 17h2v.5H3v1h1v.5H2v1h3v-4H2v1zm1-9h1V4H2v1h1v3zm-1 3h1.8L2 13.1v.9h3v-1H3.2L5 10.9V10H2v1zm5-6v2h14V5H7zm0 14h14v-2H7v2zm0-6h14v-2H7v2z"
})), 'FormatListNumbered');

exports.default = _default;

/***/ }),
/* 1697 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M18 4V3c0-.55-.45-1-1-1H5c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1h12c.55 0 1-.45 1-1V6h1v4H9v11c0 .55.45 1 1 1h2c.55 0 1-.45 1-1v-9h8V4h-3z"
})), 'FormatPaint');

exports.default = _default;

/***/ }),
/* 1698 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M6 17h3l2-4V7H5v6h3zm8 0h3l2-4V7h-6v6h3z"
})), 'FormatQuote');

exports.default = _default;

/***/ }),
/* 1699 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M23 7V1h-6v2H7V1H1v6h2v10H1v6h6v-2h10v2h6v-6h-2V7h2zM3 3h2v2H3V3zm2 18H3v-2h2v2zm12-2H7v-2H5V7h2V5h10v2h2v10h-2v2zm4 2h-2v-2h2v2zM19 5V3h2v2h-2zm-5.27 9h-3.49l-.73 2H7.89l3.4-9h1.4l3.41 9h-1.63l-.74-2zm-3.04-1.26h2.61L12 8.91l-1.31 3.83z"
})), 'FormatShapes');

exports.default = _default;

/***/ }),
/* 1700 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M9 4v3h5v12h3V7h5V4H9zm-6 8h3v7h3v-7h3V9H3v3z"
})), 'FormatSize');

exports.default = _default;

/***/ }),
/* 1701 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M10 19h4v-3h-4v3zM5 4v3h5v3h4V7h5V4H5zM3 14h18v-2H3v2z"
})), 'FormatStrikethrough');

exports.default = _default;

/***/ }),
/* 1702 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M9 10v5h2V4h2v11h2V4h2V2H9C6.79 2 5 3.79 5 6s1.79 4 4 4zm12 8l-4-4v3H5v2h12v3l4-4z"
})), 'FormatTextdirectionLToR');

exports.default = _default;

/***/ }),
/* 1703 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M10 10v5h2V4h2v11h2V4h2V2h-8C7.79 2 6 3.79 6 6s1.79 4 4 4zm-2 7v-3l-4 4 4 4v-3h12v-2H8z"
})), 'FormatTextdirectionRToL');

exports.default = _default;

/***/ }),
/* 1704 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 17c3.31 0 6-2.69 6-6V3h-2.5v8c0 1.93-1.57 3.5-3.5 3.5S8.5 12.93 8.5 11V3H6v8c0 3.31 2.69 6 6 6zm-7 2v2h14v-2H5z"
})), 'FormatUnderlined');

exports.default = _default;

/***/ }),
/* 1705 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M21 6h-2v9H6v2c0 .55.45 1 1 1h11l4 4V7c0-.55-.45-1-1-1zm-4 6V3c0-.55-.45-1-1-1H3c-.55 0-1 .45-1 1v14l4-4h10c.55 0 1-.45 1-1z"
})), 'Forum');

exports.default = _default;

/***/ }),
/* 1706 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 8V4l8 8-8 8v-4H4V8z"
})), 'Forward');

exports.default = _default;

/***/ }),
/* 1707 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M4 13c0 4.4 3.6 8 8 8s8-3.6 8-8h-2c0 3.3-2.7 6-6 6s-6-2.7-6-6 2.7-6 6-6v4l5-5-5-5v4c-4.4 0-8 3.6-8 8zm6.8 3H10v-3.3L9 13v-.7l1.8-.6h.1V16zm4.3-1.8c0 .3 0 .6-.1.8l-.3.6s-.3.3-.5.3-.4.1-.6.1-.4 0-.6-.1-.3-.2-.5-.3-.2-.3-.3-.6-.1-.5-.1-.8v-.7c0-.3 0-.6.1-.8l.3-.6s.3-.3.5-.3.4-.1.6-.1.4 0 .6.1.3.2.5.3.2.3.3.6.1.5.1.8v.7zm-.8-.8v-.5s-.1-.2-.1-.3-.1-.1-.2-.2-.2-.1-.3-.1-.2 0-.3.1l-.2.2s-.1.2-.1.3v2s.1.2.1.3.1.1.2.2.2.1.3.1.2 0 .3-.1l.2-.2s.1-.2.1-.3v-1.5z"
})), 'Forward10');

exports.default = _default;

/***/ }),
/* 1708 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M9.6 13.5h.4c.2 0 .4-.1.5-.2s.2-.2.2-.4v-.2s-.1-.1-.1-.2-.1-.1-.2-.1h-.5s-.1.1-.2.1-.1.1-.1.2v.2h-1c0-.2 0-.3.1-.5s.2-.3.3-.4.3-.2.4-.2.4-.1.5-.1c.2 0 .4 0 .6.1s.3.1.5.2.2.2.3.4.1.3.1.5v.3s-.1.2-.1.3-.1.2-.2.2-.2.1-.3.2c.2.1.4.2.5.4s.2.4.2.6c0 .2 0 .4-.1.5s-.2.3-.3.4-.3.2-.5.2-.4.1-.6.1c-.2 0-.4 0-.5-.1s-.3-.1-.5-.2-.2-.2-.3-.4-.1-.4-.1-.6h.8v.2s.1.1.1.2.1.1.2.1h.5s.1-.1.2-.1.1-.1.1-.2v-.5s-.1-.1-.1-.2-.1-.1-.2-.1h-.6v-.7zm5.7.7c0 .3 0 .6-.1.8l-.3.6s-.3.3-.5.3-.4.1-.6.1-.4 0-.6-.1-.3-.2-.5-.3-.2-.3-.3-.6-.1-.5-.1-.8v-.7c0-.3 0-.6.1-.8l.3-.6s.3-.3.5-.3.4-.1.6-.1.4 0 .6.1.3.2.5.3.2.3.3.6.1.5.1.8v.7zm-.9-.8v-.5s-.1-.2-.1-.3-.1-.1-.2-.2-.2-.1-.3-.1-.2 0-.3.1l-.2.2s-.1.2-.1.3v2s.1.2.1.3.1.1.2.2.2.1.3.1.2 0 .3-.1l.2-.2s.1-.2.1-.3v-1.5zM4 13c0 4.4 3.6 8 8 8s8-3.6 8-8h-2c0 3.3-2.7 6-6 6s-6-2.7-6-6 2.7-6 6-6v4l5-5-5-5v4c-4.4 0-8 3.6-8 8z"
})), 'Forward30');

exports.default = _default;

/***/ }),
/* 1709 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M4 13c0 4.4 3.6 8 8 8s8-3.6 8-8h-2c0 3.3-2.7 6-6 6s-6-2.7-6-6 2.7-6 6-6v4l5-5-5-5v4c-4.4 0-8 3.6-8 8zm6.7.9l.2-2.2h2.4v.7h-1.7l-.1.9s.1 0 .1-.1.1 0 .1-.1.1 0 .2 0h.2c.2 0 .4 0 .5.1s.3.2.4.3.2.3.3.5.1.4.1.6c0 .2 0 .4-.1.5s-.1.3-.3.5-.3.2-.5.3-.4.1-.6.1c-.2 0-.4 0-.5-.1s-.3-.1-.5-.2-.2-.2-.3-.4-.1-.3-.1-.5h.8c0 .2.1.3.2.4s.2.1.4.1c.1 0 .2 0 .3-.1l.2-.2s.1-.2.1-.3v-.6l-.1-.2-.2-.2s-.2-.1-.3-.1h-.2s-.1 0-.2.1-.1 0-.1.1-.1.1-.1.1h-.6z"
})), 'Forward5');

exports.default = _default;

/***/ }),
/* 1710 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20 3H4v10c0 2.21 1.79 4 4 4h6c2.21 0 4-1.79 4-4v-3h2c1.11 0 2-.9 2-2V5c0-1.11-.89-2-2-2zm0 5h-2V5h2v3zM4 19h16v2H4z"
})), 'FreeBreakfast');

exports.default = _default;

/***/ }),
/* 1711 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M7 14H5v5h5v-2H7v-3zm-2-4h2V7h3V5H5v5zm12 7h-3v2h5v-5h-2v3zM14 5v2h3v3h2V5h-5z"
})), 'Fullscreen');

exports.default = _default;

/***/ }),
/* 1712 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M5 16h3v3h2v-5H5v2zm3-8H5v2h5V5H8v3zm6 11h2v-3h3v-2h-5v5zm2-11V5h-2v5h5V8h-3z"
})), 'FullscreenExit');

exports.default = _default;

/***/ }),
/* 1713 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M18 4H6v2l6.5 6L6 18v2h12v-3h-7l5-5-5-5h7z"
})), 'Functions');

exports.default = _default;

/***/ }),
/* 1714 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M15 7.5V2H9v5.5l3 3 3-3zM7.5 9H2v6h5.5l3-3-3-3zM9 16.5V22h6v-5.5l-3-3-3 3zM16.5 9l-3 3 3 3H22V9h-5.5z"
})), 'Gamepad');

exports.default = _default;

/***/ }),
/* 1715 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M15 7.5V2H9v5.5l3 3 3-3zM7.5 9H2v6h5.5l3-3-3-3zM9 16.5V22h6v-5.5l-3-3-3 3zM16.5 9l-3 3 3 3H22V9h-5.5z"
})), 'Games');

exports.default = _default;

/***/ }),
/* 1716 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M1 21h12v2H1zM5.245 8.07l2.83-2.827 14.14 14.142-2.828 2.828zM12.317 1l5.657 5.656-2.83 2.83-5.654-5.66zM3.825 9.485l5.657 5.657-2.828 2.828-5.657-5.657z"
})), 'Gavel');

exports.default = _default;

/***/ }),
/* 1717 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M4.59 6.89c.7-.71 1.4-1.35 1.71-1.22.5.2 0 1.03-.3 1.52-.25.42-2.86 3.89-2.86 6.31 0 1.28.48 2.34 1.34 2.98.75.56 1.74.73 2.64.46 1.07-.31 1.95-1.4 3.06-2.77 1.21-1.49 2.83-3.44 4.08-3.44 1.63 0 1.65 1.01 1.76 1.79-3.78.64-5.38 3.67-5.38 5.37 0 1.7 1.44 3.09 3.21 3.09 1.63 0 4.29-1.33 4.69-6.1H21v-2.5h-2.47c-.15-1.65-1.09-4.2-4.03-4.2-2.25 0-4.18 1.91-4.94 2.84-.58.73-2.06 2.48-2.29 2.72-.25.3-.68.84-1.11.84-.45 0-.72-.83-.36-1.92.35-1.09 1.4-2.86 1.85-3.52.78-1.14 1.3-1.92 1.3-3.28C8.95 3.69 7.31 3 6.44 3 5.12 3 3.97 4 3.72 4.25c-.36.36-.66.66-.88.93l1.75 1.71zm9.29 11.66c-.31 0-.74-.26-.74-.72 0-.6.73-2.2 2.87-2.76-.3 2.69-1.43 3.48-2.13 3.48z"
})), 'Gesture');

exports.default = _default;

/***/ }),
/* 1718 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z"
})), 'GetApp');

exports.default = _default;

/***/ }),
/* 1719 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M11.5 9H13v6h-1.5zM9 9H6c-.6 0-1 .5-1 1v4c0 .5.4 1 1 1h3c.6 0 1-.5 1-1v-2H8.5v1.5h-2v-3H10V10c0-.5-.4-1-1-1zm10 1.5V9h-4.5v6H16v-2h2v-1.5h-2v-1z"
})), 'Gif');

exports.default = _default;

/***/ }),
/* 1720 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("circle", {
  cx: "19.5",
  cy: "19.5",
  r: "1.5"
}), _react.default.createElement("path", {
  d: "M17 5.92L9 2v18H7v-1.73c-1.79.35-3 .99-3 1.73 0 1.1 2.69 2 6 2s6-.9 6-2c0-.99-2.16-1.81-5-1.97V8.98l6-3.06z"
})), 'GolfCourse');

exports.default = _default;

/***/ }),
/* 1721 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm8.94 3c-.46-4.17-3.77-7.48-7.94-7.94V1h-2v2.06C6.83 3.52 3.52 6.83 3.06 11H1v2h2.06c.46 4.17 3.77 7.48 7.94 7.94V23h2v-2.06c4.17-.46 7.48-3.77 7.94-7.94H23v-2h-2.06zM12 19c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z"
})), 'GpsFixed');

exports.default = _default;

/***/ }),
/* 1722 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20.94 11c-.46-4.17-3.77-7.48-7.94-7.94V1h-2v2.06C6.83 3.52 3.52 6.83 3.06 11H1v2h2.06c.46 4.17 3.77 7.48 7.94 7.94V23h2v-2.06c4.17-.46 7.48-3.77 7.94-7.94H23v-2h-2.06zM12 19c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z"
})), 'GpsNotFixed');

exports.default = _default;

/***/ }),
/* 1723 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20.94 11c-.46-4.17-3.77-7.48-7.94-7.94V1h-2v2.06c-1.13.12-2.19.46-3.16.97l1.5 1.5C10.16 5.19 11.06 5 12 5c3.87 0 7 3.13 7 7 0 .94-.19 1.84-.52 2.65l1.5 1.5c.5-.96.84-2.02.97-3.15H23v-2h-2.06zM3 4.27l2.04 2.04C3.97 7.62 3.25 9.23 3.06 11H1v2h2.06c.46 4.17 3.77 7.48 7.94 7.94V23h2v-2.06c1.77-.2 3.38-.91 4.69-1.98L19.73 21 21 19.73 4.27 3 3 4.27zm13.27 13.27C15.09 18.45 13.61 19 12 19c-3.87 0-7-3.13-7-7 0-1.61.55-3.09 1.46-4.27l9.81 9.81z"
})), 'GpsOff');

exports.default = _default;

/***/ }),
/* 1724 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"
})), 'Grade');

exports.default = _default;

/***/ }),
/* 1725 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M11 9h2v2h-2zm-2 2h2v2H9zm4 0h2v2h-2zm2-2h2v2h-2zM7 9h2v2H7zm12-6H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM9 18H7v-2h2v2zm4 0h-2v-2h2v2zm4 0h-2v-2h2v2zm2-7h-2v2h2v2h-2v-2h-2v2h-2v-2h-2v2H9v-2H7v2H5v-2h2v-2H5V5h14v6z"
})), 'Gradient');

exports.default = _default;

/***/ }),
/* 1726 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M10 12c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zM6 8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12-8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm-4 8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm4-4c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-4-4c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-4-4c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
})), 'Grain');

exports.default = _default;

/***/ }),
/* 1727 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M7 18h2V6H7v12zm4 4h2V2h-2v20zm-8-8h2v-4H3v4zm12 4h2V6h-2v12zm4-8v4h2v-4h-2z"
})), 'GraphicEq');

exports.default = _default;

/***/ }),
/* 1728 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M8 4v1.45l2 2V4h4v4h-3.45l2 2H14v1.45l2 2V10h4v4h-3.45l2 2H20v1.45l2 2V4c0-1.1-.9-2-2-2H4.55l2 2H8zm8 0h4v4h-4V4zM1.27 1.27L0 2.55l2 2V20c0 1.1.9 2 2 2h15.46l2 2 1.27-1.27L1.27 1.27zM10 12.55L11.45 14H10v-1.45zm-6-6L5.45 8H4V6.55zM8 20H4v-4h4v4zm0-6H4v-4h3.45l.55.55V14zm6 6h-4v-4h3.45l.55.54V20zm2 0v-1.46L17.46 20H16z"
})), 'GridOff');

exports.default = _default;

/***/ }),
/* 1729 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20 2H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM8 20H4v-4h4v4zm0-6H4v-4h4v4zm0-6H4V4h4v4zm6 12h-4v-4h4v4zm0-6h-4v-4h4v4zm0-6h-4V4h4v4zm6 12h-4v-4h4v4zm0-6h-4v-4h4v4zm0-6h-4V4h4v4z"
})), 'GridOn');

exports.default = _default;

/***/ }),
/* 1730 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z"
})), 'Group');

exports.default = _default;

/***/ }),
/* 1731 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M8 10H5V7H3v3H0v2h3v3h2v-3h3v-2zm10 1c1.66 0 2.99-1.34 2.99-3S19.66 5 18 5c-.32 0-.63.05-.91.14.57.81.9 1.79.9 2.86s-.34 2.04-.9 2.86c.28.09.59.14.91.14zm-5 0c1.66 0 2.99-1.34 2.99-3S14.66 5 13 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm6.62 2.16c.83.73 1.38 1.66 1.38 2.84v2h3v-2c0-1.54-2.37-2.49-4.38-2.84zM13 13c-2 0-6 1-6 3v2h12v-2c0-2-4-3-6-3z"
})), 'GroupAdd');

exports.default = _default;

/***/ }),
/* 1732 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zM8 17.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5zM9.5 8c0-1.38 1.12-2.5 2.5-2.5s2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5S9.5 9.38 9.5 8zm6.5 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"
})), 'GroupWork');

exports.default = _default;

/***/ }),
/* 1733 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20 5h-9.12L10 2H4c-1.1 0-2 .9-2 2v13c0 1.1.9 2 2 2h7l1 3h8c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zM7.17 14.59c-2.25 0-4.09-1.83-4.09-4.09s1.83-4.09 4.09-4.09c1.04 0 1.99.37 2.74 1.07l.07.06-1.23 1.18-.06-.05c-.29-.27-.78-.59-1.52-.59-1.31 0-2.38 1.09-2.38 2.42s1.07 2.42 2.38 2.42c1.37 0 1.96-.87 2.12-1.46H7.08V9.91h3.95l.01.07c.04.21.05.4.05.61 0 2.35-1.61 4-3.92 4zm6.03-1.71c.33.6.74 1.18 1.19 1.7l-.54.53-.65-2.23zm.77-.76h-.99l-.31-1.04h3.99s-.34 1.31-1.56 2.74c-.52-.62-.89-1.23-1.13-1.7zM21 20c0 .55-.45 1-1 1h-7l2-2-.81-2.77.92-.92L17.79 18l.73-.73-2.71-2.68c.9-1.03 1.6-2.25 1.92-3.51H19v-1.04h-3.64V9h-1.04v1.04h-1.96L11.18 6H20c.55 0 1 .45 1 1v13z"
})), 'GTranslate');

exports.default = _default;

/***/ }),
/* 1734 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-8 12H9.5v-2h-2v2H6V9h1.5v2.5h2V9H11v6zm2-6h4c.55 0 1 .45 1 1v4c0 .55-.45 1-1 1h-4V9zm1.5 4.5h2v-3h-2v3z"
})), 'Hd');

exports.default = _default;

/***/ }),
/* 1735 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M17.5 15v-2h1.1l.9 2H21l-.9-2.1c.5-.2.9-.8.9-1.4v-1c0-.8-.7-1.5-1.5-1.5H16v4.9l1.1 1.1h.4zm0-4.5h2v1h-2v-1zm-4.5 0v.4l1.5 1.5v-1.9c0-.8-.7-1.5-1.5-1.5h-1.9l1.5 1.5h.4zm-3.5-1l-7-7-1.1 1L6.9 9h-.4v2h-2V9H3v6h1.5v-2.5h2V15H8v-4.9l1.5 1.5V15h3.4l7.6 7.6 1.1-1.1-12.1-12z"
})), 'HdrOff');

exports.default = _default;

/***/ }),
/* 1736 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M21 11.5v-1c0-.8-.7-1.5-1.5-1.5H16v6h1.5v-2h1.1l.9 2H21l-.9-2.1c.5-.3.9-.8.9-1.4zm-1.5 0h-2v-1h2v1zm-13-.5h-2V9H3v6h1.5v-2.5h2V15H8V9H6.5v2zM13 9H9.5v6H13c.8 0 1.5-.7 1.5-1.5v-3c0-.8-.7-1.5-1.5-1.5zm0 4.5h-2v-3h2v3z"
})), 'HdrOn');

exports.default = _default;

/***/ }),
/* 1737 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M17 6c-3.31 0-6 2.69-6 6s2.69 6 6 6 6-2.69 6-6-2.69-6-6-6zM5 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 6c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"
})), 'HdrStrong');

exports.default = _default;

/***/ }),
/* 1738 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M5 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm12-2c-3.31 0-6 2.69-6 6s2.69 6 6 6 6-2.69 6-6-2.69-6-6-6zm0 10c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4z"
})), 'HdrWeak');

exports.default = _default;

/***/ }),
/* 1739 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 1c-4.97 0-9 4.03-9 9v7c0 1.66 1.34 3 3 3h3v-8H5v-2c0-3.87 3.13-7 7-7s7 3.13 7 7v2h-4v8h3c1.66 0 3-1.34 3-3v-7c0-4.97-4.03-9-9-9z"
})), 'Headset');

exports.default = _default;

/***/ }),
/* 1740 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 1c-4.97 0-9 4.03-9 9v7c0 1.66 1.34 3 3 3h3v-8H5v-2c0-3.87 3.13-7 7-7s7 3.13 7 7v2h-4v8h4v1h-7v2h6c1.66 0 3-1.34 3-3V10c0-4.97-4.03-9-9-9z"
})), 'HeadsetMic');

exports.default = _default;

/***/ }),
/* 1741 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M17.73 12.02l3.98-3.98c.39-.39.39-1.02 0-1.41l-4.34-4.34c-.39-.39-1.02-.39-1.41 0l-3.98 3.98L8 2.29C7.8 2.1 7.55 2 7.29 2c-.25 0-.51.1-.7.29L2.25 6.63c-.39.39-.39 1.02 0 1.41l3.98 3.98L2.25 16c-.39.39-.39 1.02 0 1.41l4.34 4.34c.39.39 1.02.39 1.41 0l3.98-3.98 3.98 3.98c.2.2.45.29.71.29.26 0 .51-.1.71-.29l4.34-4.34c.39-.39.39-1.02 0-1.41l-3.99-3.98zM12 9c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm-4.71 1.96L3.66 7.34l3.63-3.63 3.62 3.62-3.62 3.63zM10 13c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm2 2c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm2-4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm2.66 9.34l-3.63-3.62 3.63-3.63 3.62 3.62-3.62 3.63z"
})), 'Healing');

exports.default = _default;

/***/ }),
/* 1742 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M17 20c-.29 0-.56-.06-.76-.15-.71-.37-1.21-.88-1.71-2.38-.51-1.56-1.47-2.29-2.39-3-.79-.61-1.61-1.24-2.32-2.53C9.29 10.98 9 9.93 9 9c0-2.8 2.2-5 5-5s5 2.2 5 5h2c0-3.93-3.07-7-7-7S7 5.07 7 9c0 1.26.38 2.65 1.07 3.9.91 1.65 1.98 2.48 2.85 3.15.81.62 1.39 1.07 1.71 2.05.6 1.82 1.37 2.84 2.73 3.55.51.23 1.07.35 1.64.35 2.21 0 4-1.79 4-4h-2c0 1.1-.9 2-2 2zM7.64 2.64L6.22 1.22C4.23 3.21 3 5.96 3 9s1.23 5.79 3.22 7.78l1.41-1.41C6.01 13.74 5 11.49 5 9s1.01-4.74 2.64-6.36zM11.5 9c0 1.38 1.12 2.5 2.5 2.5s2.5-1.12 2.5-2.5-1.12-2.5-2.5-2.5-2.5 1.12-2.5 2.5z"
})), 'Hearing');

exports.default = _default;

/***/ }),
/* 1743 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 17h-2v-2h2v2zm2.07-7.75l-.9.92C13.45 12.9 13 13.5 13 15h-2v-.5c0-1.1.45-2.1 1.17-2.83l1.24-1.26c.37-.36.59-.86.59-1.41 0-1.1-.9-2-2-2s-2 .9-2 2H8c0-2.21 1.79-4 4-4s4 1.79 4 4c0 .88-.36 1.68-.93 2.25z"
})), 'Help');

exports.default = _default;

/***/ }),
/* 1744 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M11 18h2v-2h-2v2zm1-16C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm0-14c-2.21 0-4 1.79-4 4h2c0-1.1.9-2 2-2s2 .9 2 2c0 2-3 1.75-3 5h2c0-2.25 3-2.5 3-5 0-2.21-1.79-4-4-4z"
})), 'HelpOutline');

exports.default = _default;

/***/ }),
/* 1745 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M6 14l3 3v5h6v-5l3-3V9H6zm5-12h2v3h-2zM3.5 5.875L4.914 4.46l2.12 2.122L5.62 7.997zm13.46.71l2.123-2.12 1.414 1.414L18.375 8z"
})), 'Highlight');

exports.default = _default;

/***/ }),
/* 1746 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M14.59 8L12 10.59 9.41 8 8 9.41 10.59 12 8 14.59 9.41 16 12 13.41 14.59 16 16 14.59 13.41 12 16 9.41 14.59 8zM12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
})), 'HighlightOff');

exports.default = _default;

/***/ }),
/* 1747 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M19 4H5c-1.11 0-2 .9-2 2v12c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-8 11H9.5v-2h-2v2H6V9h1.5v2.5h2V9H11v6zm7-1c0 .55-.45 1-1 1h-.75v1.5h-1.5V15H14c-.55 0-1-.45-1-1v-4c0-.55.45-1 1-1h3c.55 0 1 .45 1 1v4zm-3.5-.5h2v-3h-2v3z"
})), 'HighQuality');

exports.default = _default;

/***/ }),
/* 1748 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M13 3c-4.97 0-9 4.03-9 9H1l3.89 3.89.07.14L9 12H6c0-3.87 3.13-7 7-7s7 3.13 7 7-3.13 7-7 7c-1.93 0-3.68-.79-4.94-2.06l-1.42 1.42C8.27 19.99 10.51 21 13 21c4.97 0 9-4.03 9-9s-4.03-9-9-9zm-1 5v5l4.28 2.54.72-1.21-3.5-2.08V8H12z"
})), 'History');

exports.default = _default;

/***/ }),
/* 1749 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z"
})), 'Home');

exports.default = _default;

/***/ }),
/* 1750 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M7 13c1.66 0 3-1.34 3-3S8.66 7 7 7s-3 1.34-3 3 1.34 3 3 3zm12-6h-8v7H3V5H1v15h2v-3h18v3h2v-9c0-2.21-1.79-4-4-4z"
})), 'Hotel');

exports.default = _default;

/***/ }),
/* 1751 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("circle", {
  cx: "7",
  cy: "6",
  r: "2"
}), _react.default.createElement("path", {
  d: "M11.15 12c-.31-.22-.59-.46-.82-.72l-1.4-1.55c-.19-.21-.43-.38-.69-.5-.29-.14-.62-.23-.96-.23h-.03C6.01 9 5 10.01 5 11.25V12H2v8c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2v-8H11.15zM7 20H5v-6h2v6zm4 0H9v-6h2v6zm4 0h-2v-6h2v6zm4 0h-2v-6h2v6zm-.35-14.14l-.07-.07c-.57-.62-.82-1.41-.67-2.2L18 3h-1.89l-.06.43c-.2 1.36.27 2.71 1.3 3.72l.07.06c.57.62.82 1.41.67 2.2l-.11.59h1.91l.06-.43c.21-1.36-.27-2.71-1.3-3.71zm-4 0l-.07-.07c-.57-.62-.82-1.41-.67-2.2L14 3h-1.89l-.06.43c-.2 1.36.27 2.71 1.3 3.72l.07.06c.57.62.82 1.41.67 2.2l-.11.59h1.91l.06-.43c.21-1.36-.27-2.71-1.3-3.71z"
})), 'HotTub');

exports.default = _default;

/***/ }),
/* 1752 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M6 2v6h.01L6 8.01 10 12l-4 4 .01.01H6V22h12v-5.99h-.01L18 16l-4-4 4-3.99-.01-.01H18V2H6zm10 14.5V20H8v-3.5l4-4 4 4zm-4-5l-4-4V4h8v3.5l-4 4z"
})), 'HourglassEmpty');

exports.default = _default;

/***/ }),
/* 1753 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M6 2v6h.01L6 8.01 10 12l-4 4 .01.01H6V22h12v-5.99h-.01L18 16l-4-4 4-3.99-.01-.01H18V2H6z"
})), 'HourglassFull');

exports.default = _default;

/***/ }),
/* 1754 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M4.5 11h-2V9H1v6h1.5v-2.5h2V15H6V9H4.5v2zm2.5-.5h1.5V15H10v-4.5h1.5V9H7v1.5zm5.5 0H14V15h1.5v-4.5H17V9h-4.5v1.5zm9-1.5H18v6h1.5v-2h2c.8 0 1.5-.7 1.5-1.5v-1c0-.8-.7-1.5-1.5-1.5zm0 2.5h-2v-1h2v1z"
})), 'Http');

exports.default = _default;

/***/ }),
/* 1755 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z"
})), 'Https');

exports.default = _default;

/***/ }),
/* 1756 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M21 19V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2zM8.5 13.5l2.5 3.01L14.5 12l4.5 6H5l3.5-4.5z"
})), 'Image');

exports.default = _default;

/***/ }),
/* 1757 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M16 10h-2v2h2v-2zm0 4h-2v2h2v-2zm-8-4H6v2h2v-2zm4 0h-2v2h2v-2zm8-6H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H4V6h16v12z"
})), 'ImageAspectRatio');

exports.default = _default;

/***/ }),
/* 1758 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M23 11.01L18 11c-.55 0-1 .45-1 1v9c0 .55.45 1 1 1h5c.55 0 1-.45 1-1v-9c0-.55-.45-.99-1-.99zM23 20h-5v-7h5v7zM20 2H2C.89 2 0 2.89 0 4v12c0 1.1.89 2 2 2h7v2H7v2h8v-2h-2v-2h2v-2H2V4h18v5h2V4c0-1.11-.9-2-2-2zm-8.03 7L11 6l-.97 3H7l2.47 1.76-.94 2.91 2.47-1.8 2.47 1.8-.94-2.91L15 9h-3.03z"
})), 'ImportantDevices');

exports.default = _default;

/***/ }),
/* 1759 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M21 5c-1.11-.35-2.33-.5-3.5-.5-1.95 0-4.05.4-5.5 1.5-1.45-1.1-3.55-1.5-5.5-1.5S2.45 4.9 1 6v14.65c0 .25.25.5.5.5.1 0 .15-.05.25-.05C3.1 20.45 5.05 20 6.5 20c1.95 0 4.05.4 5.5 1.5 1.35-.85 3.8-1.5 5.5-1.5 1.65 0 3.35.3 4.75 1.05.1.05.15.05.25.05.25 0 .5-.25.5-.5V6c-.6-.45-1.25-.75-2-1zm0 13.5c-1.1-.35-2.3-.5-3.5-.5-1.7 0-4.15.65-5.5 1.5V8c1.35-.85 3.8-1.5 5.5-1.5 1.2 0 2.4.15 3.5.5v11.5z"
})), 'ImportContacts');

exports.default = _default;

/***/ }),
/* 1760 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M9 3L5 6.99h3V14h2V6.99h3L9 3zm7 14.01V10h-2v7.01h-3L15 21l4-3.99h-3z"
})), 'ImportExport');

exports.default = _default;

/***/ }),
/* 1761 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M19 3H4.99c-1.11 0-1.98.89-1.98 2L3 19c0 1.1.88 2 1.99 2H19c1.1 0 2-.9 2-2V5c0-1.11-.9-2-2-2zm0 12h-4c0 1.66-1.35 3-3 3s-3-1.34-3-3H4.99V5H19v10z"
})), 'Inbox');

exports.default = _default;

/***/ }),
/* 1762 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 10H7v-2h10v2z"
})), 'IndeterminateCheckBox');

exports.default = _default;

/***/ }),
/* 1763 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z"
})), 'Info');

exports.default = _default;

/***/ }),
/* 1764 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M11 17h2v-6h-2v6zm1-15C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zM11 9h2V7h-2v2z"
})), 'InfoOutline');

exports.default = _default;

/***/ }),
/* 1765 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M21 3.01H3c-1.1 0-2 .9-2 2V9h2V4.99h18v14.03H3V15H1v4.01c0 1.1.9 1.98 2 1.98h18c1.1 0 2-.88 2-1.98v-14c0-1.11-.9-2-2-2zM11 16l4-4-4-4v3H1v2h10v3z"
})), 'Input');

exports.default = _default;

/***/ }),
/* 1766 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM9 17H7v-7h2v7zm4 0h-2V7h2v10zm4 0h-2v-4h2v4z"
})), 'InsertChart');

exports.default = _default;

/***/ }),
/* 1767 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20 2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h14l4 4V4c0-1.1-.9-2-2-2zm-2 12H6v-2h12v2zm0-3H6V9h12v2zm0-3H6V6h12v2z"
})), 'InsertComment');

exports.default = _default;

/***/ }),
/* 1768 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M6 2c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6H6zm7 7V3.5L18.5 9H13z"
})), 'InsertDriveFile');

exports.default = _default;

/***/ }),
/* 1769 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm3.5-9c.83 0 1.5-.67 1.5-1.5S16.33 8 15.5 8 14 8.67 14 9.5s.67 1.5 1.5 1.5zm-7 0c.83 0 1.5-.67 1.5-1.5S9.33 8 8.5 8 7 8.67 7 9.5 7.67 11 8.5 11zm3.5 6.5c2.33 0 4.31-1.46 5.11-3.5H6.89c.8 2.04 2.78 3.5 5.11 3.5z"
})), 'InsertEmoticon');

exports.default = _default;

/***/ }),
/* 1770 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M17 12h-5v5h5v-5zM16 1v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2h-1V1h-2zm3 18H5V8h14v11z"
})), 'InsertInvitation');

exports.default = _default;

/***/ }),
/* 1771 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M3.9 12c0-1.71 1.39-3.1 3.1-3.1h4V7H7c-2.76 0-5 2.24-5 5s2.24 5 5 5h4v-1.9H7c-1.71 0-3.1-1.39-3.1-3.1zM8 13h8v-2H8v2zm9-6h-4v1.9h4c1.71 0 3.1 1.39 3.1 3.1s-1.39 3.1-3.1 3.1h-4V17h4c2.76 0 5-2.24 5-5s-2.24-5-5-5z"
})), 'InsertLink');

exports.default = _default;

/***/ }),
/* 1772 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M21 19V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2zM8.5 13.5l2.5 3.01L14.5 12l4.5 6H5l3.5-4.5z"
})), 'InsertPhoto');

exports.default = _default;

/***/ }),
/* 1773 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M17.66 7.93L12 2.27 6.34 7.93c-3.12 3.12-3.12 8.19 0 11.31C7.9 20.8 9.95 21.58 12 21.58c2.05 0 4.1-.78 5.66-2.34 3.12-3.12 3.12-8.19 0-11.31zM12 19.59c-1.6 0-3.11-.62-4.24-1.76C6.62 16.69 6 15.19 6 13.59s.62-3.11 1.76-4.24L12 5.1v14.49z"
})), 'InvertColors');

exports.default = _default;

/***/ }),
/* 1774 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20.65 20.87l-2.35-2.35-6.3-6.29-3.56-3.57-1.42-1.41L4.27 4.5 3 5.77l2.78 2.78c-2.55 3.14-2.36 7.76.56 10.69C7.9 20.8 9.95 21.58 12 21.58c1.79 0 3.57-.59 5.03-1.78l2.7 2.7L21 21.23l-.35-.36zM12 19.59c-1.6 0-3.11-.62-4.24-1.76C6.62 16.69 6 15.19 6 13.59c0-1.32.43-2.57 1.21-3.6L12 14.77v4.82zM12 5.1v4.58l7.25 7.26c1.37-2.96.84-6.57-1.6-9.01L12 2.27l-3.7 3.7 1.41 1.41L12 5.1z"
})), 'InvertColorsOff');

exports.default = _default;

/***/ }),
/* 1775 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM5.5 7.5h2v-2H9v2h2V9H9v2H7.5V9h-2V7.5zM19 19H5L19 5v14zm-2-2v-1.5h-5V17h5z"
})), 'Iso');

exports.default = _default;

/***/ }),
/* 1776 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20 5H4c-1.1 0-1.99.9-1.99 2L2 17c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm-9 3h2v2h-2V8zm0 3h2v2h-2v-2zM8 8h2v2H8V8zm0 3h2v2H8v-2zm-1 2H5v-2h2v2zm0-3H5V8h2v2zm9 7H8v-2h8v2zm0-4h-2v-2h2v2zm0-3h-2V8h2v2zm3 3h-2v-2h2v2zm0-3h-2V8h2v2z"
})), 'Keyboard');

exports.default = _default;

/***/ }),
/* 1777 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M7.41 7.84L12 12.42l4.59-4.58L18 9.25l-6 6-6-6z"
})), 'KeyboardArrowDown');

exports.default = _default;

/***/ }),
/* 1778 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M15.41 16.09l-4.58-4.59 4.58-4.59L14 5.5l-6 6 6 6z"
})), 'KeyboardArrowLeft');

exports.default = _default;

/***/ }),
/* 1779 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z"
})), 'KeyboardArrowRight');

exports.default = _default;

/***/ }),
/* 1780 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M7.41 15.41L12 10.83l4.59 4.58L18 14l-6-6-6 6z"
})), 'KeyboardArrowUp');

exports.default = _default;

/***/ }),
/* 1781 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M21 11H6.83l3.58-3.59L9 6l-6 6 6 6 1.41-1.41L6.83 13H21z"
})), 'KeyboardBackspace');

exports.default = _default;

/***/ }),
/* 1782 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 8.41L16.59 13 18 11.59l-6-6-6 6L7.41 13 12 8.41zM6 18h12v-2H6v2z"
})), 'KeyboardCapslock');

exports.default = _default;

/***/ }),
/* 1783 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20 3H4c-1.1 0-1.99.9-1.99 2L2 15c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-9 3h2v2h-2V6zm0 3h2v2h-2V9zM8 6h2v2H8V6zm0 3h2v2H8V9zm-1 2H5V9h2v2zm0-3H5V6h2v2zm9 7H8v-2h8v2zm0-4h-2V9h2v2zm0-3h-2V6h2v2zm3 3h-2V9h2v2zm0-3h-2V6h2v2zm-7 15l4-4H8l4 4z"
})), 'KeyboardHide');

exports.default = _default;

/***/ }),
/* 1784 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M19 7v4H5.83l3.58-3.59L8 6l-6 6 6 6 1.41-1.41L5.83 13H21V7z"
})), 'KeyboardReturn');

exports.default = _default;

/***/ }),
/* 1785 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M11.59 7.41L15.17 11H1v2h14.17l-3.59 3.59L13 18l6-6-6-6-1.41 1.41zM20 6v12h2V6h-2z"
})), 'KeyboardTab');

exports.default = _default;

/***/ }),
/* 1786 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 15c1.66 0 2.99-1.34 2.99-3L15 6c0-1.66-1.34-3-3-3S9 4.34 9 6v6c0 1.66 1.34 3 3 3zm5.3-3c0 3-2.54 5.1-5.3 5.1S6.7 15 6.7 12H5c0 3.42 2.72 6.23 6 6.72V22h2v-3.28c3.28-.48 6-3.3 6-6.72h-1.7z"
})), 'KeyboardVoice');

exports.default = _default;

/***/ }),
/* 1787 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M18 2.01L6 2c-1.1 0-2 .89-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.11-.9-1.99-2-1.99zM18 20H6v-9.02h12V20zm0-11H6V4h12v5zM8 5h2v3H8zm0 7h2v5H8z"
})), 'Kitchen');

exports.default = _default;

/***/ }),
/* 1788 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M17.63 5.84C17.27 5.33 16.67 5 16 5L5 5.01C3.9 5.01 3 5.9 3 7v10c0 1.1.9 1.99 2 1.99L16 19c.67 0 1.27-.33 1.63-.84L22 12l-4.37-6.16z"
})), 'Label');

exports.default = _default;

/***/ }),
/* 1789 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M17.63 5.84C17.27 5.33 16.67 5 16 5L5 5.01C3.9 5.01 3 5.9 3 7v10c0 1.1.9 1.99 2 1.99L16 19c.67 0 1.27-.33 1.63-.84L22 12l-4.37-6.16zM16 17H5V7h11l3.55 5L16 17z"
})), 'LabelOutline');

exports.default = _default;

/***/ }),
/* 1790 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M14 6l-3.75 5 2.85 3.8-1.6 1.2C9.81 13.75 7 10 7 10l-6 8h22L14 6z"
})), 'Landscape');

exports.default = _default;

/***/ }),
/* 1791 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zm6.93 6h-2.95c-.32-1.25-.78-2.45-1.38-3.56 1.84.63 3.37 1.91 4.33 3.56zM12 4.04c.83 1.2 1.48 2.53 1.91 3.96h-3.82c.43-1.43 1.08-2.76 1.91-3.96zM4.26 14C4.1 13.36 4 12.69 4 12s.1-1.36.26-2h3.38c-.08.66-.14 1.32-.14 2 0 .68.06 1.34.14 2H4.26zm.82 2h2.95c.32 1.25.78 2.45 1.38 3.56-1.84-.63-3.37-1.9-4.33-3.56zm2.95-8H5.08c.96-1.66 2.49-2.93 4.33-3.56C8.81 5.55 8.35 6.75 8.03 8zM12 19.96c-.83-1.2-1.48-2.53-1.91-3.96h3.82c-.43 1.43-1.08 2.76-1.91 3.96zM14.34 14H9.66c-.09-.66-.16-1.32-.16-2 0-.68.07-1.35.16-2h4.68c.09.65.16 1.32.16 2 0 .68-.07 1.34-.16 2zm.25 5.56c.6-1.11 1.06-2.31 1.38-3.56h2.95c-.96 1.65-2.49 2.93-4.33 3.56zM16.36 14c.08-.66.14-1.32.14-2 0-.68-.06-1.34-.14-2h3.38c.16.64.26 1.31.26 2s-.1 1.36-.26 2h-3.38z"
})), 'Language');

exports.default = _default;

/***/ }),
/* 1792 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20 18c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2H0v2h24v-2h-4zM4 6h16v10H4V6z"
})), 'Laptop');

exports.default = _default;

/***/ }),
/* 1793 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M22 18V3H2v15H0v2h24v-2h-2zm-8 0h-4v-1h4v1zm6-3H4V5h16v10z"
})), 'LaptopChromebook');

exports.default = _default;

/***/ }),
/* 1794 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20 18c1.1 0 1.99-.9 1.99-2L22 5c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v11c0 1.1.9 2 2 2H0c0 1.1.9 2 2 2h20c1.1 0 2-.9 2-2h-4zM4 5h16v11H4V5zm8 14c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"
})), 'LaptopMac');

exports.default = _default;

/***/ }),
/* 1795 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20 18v-1c1.1 0 1.99-.9 1.99-2L22 5c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2v1H0v2h24v-2h-4zM4 5h16v10H4V5z"
})), 'LaptopWindows');

exports.default = _default;

/***/ }),
/* 1796 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M5.59 7.41L10.18 12l-4.59 4.59L7 18l6-6-6-6zM16 6h2v12h-2z"
})), 'LastPage');

exports.default = _default;

/***/ }),
/* 1797 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M19 19H5V5h7V3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2v-7h-2v7zM14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3h-7z"
})), 'Launch');

exports.default = _default;

/***/ }),
/* 1798 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M11.99 18.54l-7.37-5.73L3 14.07l9 7 9-7-1.63-1.27-7.38 5.74zM12 16l7.36-5.73L21 9l-9-7-9 7 1.63 1.27L12 16z"
})), 'Layers');

exports.default = _default;

/***/ }),
/* 1799 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M19.81 14.99l1.19-.92-1.43-1.43-1.19.92 1.43 1.43zm-.45-4.72L21 9l-9-7-2.91 2.27 7.87 7.88 2.4-1.88zM3.27 1L2 2.27l4.22 4.22L3 9l1.63 1.27L12 16l2.1-1.63 1.43 1.43L12 18.54l-7.37-5.73L3 14.07l9 7 4.95-3.85L20.73 21 22 19.73 3.27 1z"
})), 'LayersClear');

exports.default = _default;

/***/ }),
/* 1800 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M6 3H3v3c1.66 0 3-1.34 3-3zm8 0h-2c0 4.97-4.03 9-9 9v2c6.08 0 11-4.93 11-11zm-4 0H8c0 2.76-2.24 5-5 5v2c3.87 0 7-3.13 7-7zm0 18h2c0-4.97 4.03-9 9-9v-2c-6.07 0-11 4.93-11 11zm8 0h3v-3c-1.66 0-3 1.34-3 3zm-4 0h2c0-2.76 2.24-5 5-5v-2c-3.87 0-7 3.13-7 7z"
})), 'LeakAdd');

exports.default = _default;

/***/ }),
/* 1801 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M10 3H8c0 .37-.04.72-.12 1.06l1.59 1.59C9.81 4.84 10 3.94 10 3zM3 4.27l2.84 2.84C5.03 7.67 4.06 8 3 8v2c1.61 0 3.09-.55 4.27-1.46L8.7 9.97C7.14 11.24 5.16 12 3 12v2c2.71 0 5.19-.99 7.11-2.62l2.5 2.5C10.99 15.81 10 18.29 10 21h2c0-2.16.76-4.14 2.03-5.69l1.43 1.43C14.55 17.91 14 19.39 14 21h2c0-1.06.33-2.03.89-2.84L19.73 21 21 19.73 4.27 3 3 4.27zM14 3h-2c0 1.5-.37 2.91-1.02 4.16l1.46 1.46C13.42 6.98 14 5.06 14 3zm5.94 13.12c.34-.08.69-.12 1.06-.12v-2c-.94 0-1.84.19-2.66.52l1.6 1.6zm-4.56-4.56l1.46 1.46C18.09 12.37 19.5 12 21 12v-2c-2.06 0-3.98.58-5.62 1.56z"
})), 'LeakRemove');

exports.default = _default;

/***/ }),
/* 1802 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2z"
})), 'Lens');

exports.default = _default;

/***/ }),
/* 1803 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm16-4H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-1 9h-4v4h-2v-4H9V9h4V5h2v4h4v2z"
})), 'LibraryAdd');

exports.default = _default;

/***/ }),
/* 1804 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm16-4H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-1 9H9V9h10v2zm-4 4H9v-2h6v2zm4-8H9V5h10v2z"
})), 'LibraryBooks');

exports.default = _default;

/***/ }),
/* 1805 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20 2H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-2 5h-3v5.5c0 1.38-1.12 2.5-2.5 2.5S10 13.88 10 12.5s1.12-2.5 2.5-2.5c.57 0 1.08.19 1.5.51V5h4v2zM4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6z"
})), 'LibraryMusic');

exports.default = _default;

/***/ }),
/* 1806 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M9 21c0 .55.45 1 1 1h4c.55 0 1-.45 1-1v-1H9v1zm3-19C8.14 2 5 5.14 5 9c0 2.38 1.19 4.47 3 5.74V17c0 .55.45 1 1 1h6c.55 0 1-.45 1-1v-2.26c1.81-1.27 3-3.36 3-5.74 0-3.86-3.14-7-7-7zm2.85 11.1l-.85.6V16h-4v-2.3l-.85-.6C7.8 12.16 7 10.63 7 9c0-2.76 2.24-5 5-5s5 2.24 5 5c0 1.63-.8 3.16-2.15 4.1z"
})), 'LightbulbOutline');

exports.default = _default;

/***/ }),
/* 1807 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M19.5 9.5c-1.03 0-1.9.62-2.29 1.5h-2.92c-.39-.88-1.26-1.5-2.29-1.5s-1.9.62-2.29 1.5H6.79c-.39-.88-1.26-1.5-2.29-1.5C3.12 9.5 2 10.62 2 12s1.12 2.5 2.5 2.5c1.03 0 1.9-.62 2.29-1.5h2.92c.39.88 1.26 1.5 2.29 1.5s1.9-.62 2.29-1.5h2.92c.39.88 1.26 1.5 2.29 1.5 1.38 0 2.5-1.12 2.5-2.5s-1.12-2.5-2.5-2.5z"
})), 'LinearScale');

exports.default = _default;

/***/ }),
/* 1808 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M3 16h5v-2H3v2zm6.5 0h5v-2h-5v2zm6.5 0h5v-2h-5v2zM3 20h2v-2H3v2zm4 0h2v-2H7v2zm4 0h2v-2h-2v2zm4 0h2v-2h-2v2zm4 0h2v-2h-2v2zM3 12h8v-2H3v2zm10 0h8v-2h-8v2zM3 4v4h18V4H3z"
})), 'LineStyle');

exports.default = _default;

/***/ }),
/* 1809 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M3 17h18v-2H3v2zm0 3h18v-1H3v1zm0-7h18v-3H3v3zm0-9v4h18V4H3z"
})), 'LineWeight');

exports.default = _default;

/***/ }),
/* 1810 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M3.9 12c0-1.71 1.39-3.1 3.1-3.1h4V7H7c-2.76 0-5 2.24-5 5s2.24 5 5 5h4v-1.9H7c-1.71 0-3.1-1.39-3.1-3.1zM8 13h8v-2H8v2zm9-6h-4v1.9h4c1.71 0 3.1 1.39 3.1 3.1s-1.39 3.1-3.1 3.1h-4V17h4c2.76 0 5-2.24 5-5s-2.24-5-5-5z"
})), 'Link');

exports.default = _default;

/***/ }),
/* 1811 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("circle", {
  cx: "12",
  cy: "14",
  r: "3.2"
}), _react.default.createElement("path", {
  d: "M16 3.33c2.58 0 4.67 2.09 4.67 4.67H22c0-3.31-2.69-6-6-6v1.33M16 6c1.11 0 2 .89 2 2h1.33c0-1.84-1.49-3.33-3.33-3.33V6"
}), _react.default.createElement("path", {
  d: "M17 9c0-1.11-.89-2-2-2V4H9L7.17 6H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V9h-5zm-5 10c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5z"
})), 'LinkedCamera');

exports.default = _default;

/***/ }),
/* 1812 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M3 13h2v-2H3v2zm0 4h2v-2H3v2zm0-8h2V7H3v2zm4 4h14v-2H7v2zm0 4h14v-2H7v2zM7 7v2h14V7H7z"
})), 'List');

exports.default = _default;

/***/ }),
/* 1813 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M19 2H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h4l3 3 3-3h4c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-6 16h-2v-2h2v2zm2.07-7.75l-.9.92C13.45 11.9 13 12.5 13 14h-2v-.5c0-1.1.45-2.1 1.17-2.83l1.24-1.26c.37-.36.59-.86.59-1.41 0-1.1-.9-2-2-2s-2 .9-2 2H8c0-2.21 1.79-4 4-4s4 1.79 4 4c0 .88-.36 1.68-.93 2.25z"
})), 'LiveHelp');

exports.default = _default;

/***/ }),
/* 1814 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M21 6h-7.59l3.29-3.29L16 2l-4 4-4-4-.71.71L10.59 6H3c-1.1 0-2 .89-2 2v12c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V8c0-1.11-.9-2-2-2zm0 14H3V8h18v12zM9 10v8l7-4z"
})), 'LiveTv');

exports.default = _default;

/***/ }),
/* 1815 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20 12c0-1.1.9-2 2-2V6c0-1.1-.9-2-2-2H4c-1.1 0-1.99.9-1.99 2v4c1.1 0 1.99.9 1.99 2s-.89 2-2 2v4c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2v-4c-1.1 0-2-.9-2-2zm-4.42 4.8L12 14.5l-3.58 2.3 1.08-4.12-3.29-2.69 4.24-.25L12 5.8l1.54 3.95 4.24.25-3.29 2.69 1.09 4.11z"
})), 'LocalActivity');

exports.default = _default;

/***/ }),
/* 1816 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M21 16v-2l-8-5V3.5c0-.83-.67-1.5-1.5-1.5S10 2.67 10 3.5V9l-8 5v2l8-2.5V19l-2 1.5V22l3.5-1 3.5 1v-1.5L13 19v-5.5l8 2.5z"
})), 'LocalAirport');

exports.default = _default;

/***/ }),
/* 1817 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M11 17h2v-1h1c.55 0 1-.45 1-1v-3c0-.55-.45-1-1-1h-3v-1h4V8h-2V7h-2v1h-1c-.55 0-1 .45-1 1v3c0 .55.45 1 1 1h3v1H9v2h2v1zm9-13H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zm0 14H4V6h16v12z"
})), 'LocalAtm');

exports.default = _default;

/***/ }),
/* 1818 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M21 5V3H3v2l8 9v5H6v2h12v-2h-5v-5l8-9zM7.43 7L5.66 5h12.69l-1.78 2H7.43z"
})), 'LocalBar');

exports.default = _default;

/***/ }),
/* 1819 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20 3H4v10c0 2.21 1.79 4 4 4h6c2.21 0 4-1.79 4-4v-3h2c1.11 0 2-.89 2-2V5c0-1.11-.89-2-2-2zm0 5h-2V5h2v3zM2 21h18v-2H2v2z"
})), 'LocalCafe');

exports.default = _default;

/***/ }),
/* 1820 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M17 5c.83 0 1.5-.67 1.5-1.5 0-1-1.5-2.7-1.5-2.7s-1.5 1.7-1.5 2.7c0 .83.67 1.5 1.5 1.5zm-5 0c.83 0 1.5-.67 1.5-1.5 0-1-1.5-2.7-1.5-2.7s-1.5 1.7-1.5 2.7c0 .83.67 1.5 1.5 1.5zM7 5c.83 0 1.5-.67 1.5-1.5C8.5 2.5 7 .8 7 .8S5.5 2.5 5.5 3.5C5.5 4.33 6.17 5 7 5zm11.92 3.01C18.72 7.42 18.16 7 17.5 7h-11c-.66 0-1.21.42-1.42 1.01L3 14v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-8l-2.08-5.99zM6.5 18c-.83 0-1.5-.67-1.5-1.5S5.67 15 6.5 15s1.5.67 1.5 1.5S7.33 18 6.5 18zm11 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM5 13l1.5-4.5h11L19 13H5z"
})), 'LocalCarWash');

exports.default = _default;

/***/ }),
/* 1821 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M19 7V4H5v3H2v13h8v-4h4v4h8V7h-3zm-8 3H9v1h2v1H8V9h2V8H8V7h3v3zm5 2h-1v-2h-2V7h1v2h1V7h1v5z"
})), 'LocalConvenienceStore');

exports.default = _default;

/***/ }),
/* 1822 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M8.1 13.34l2.83-2.83L3.91 3.5c-1.56 1.56-1.56 4.09 0 5.66l4.19 4.18zm6.78-1.81c1.53.71 3.68.21 5.27-1.38 1.91-1.91 2.28-4.65.81-6.12-1.46-1.46-4.2-1.1-6.12.81-1.59 1.59-2.09 3.74-1.38 5.27L3.7 19.87l1.41 1.41L12 14.41l6.88 6.88 1.41-1.41L13.41 13l1.47-1.47z"
})), 'LocalDining');

exports.default = _default;

/***/ }),
/* 1823 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M3 2l2.01 18.23C5.13 21.23 5.97 22 7 22h10c1.03 0 1.87-.77 1.99-1.77L21 2H3zm9 17c-1.66 0-3-1.34-3-3 0-2 3-5.4 3-5.4s3 3.4 3 5.4c0 1.66-1.34 3-3 3zm6.33-11H5.67l-.44-4h13.53l-.43 4z"
})), 'LocalDrink');

exports.default = _default;

/***/ }),
/* 1824 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 22c4.97 0 9-4.03 9-9-4.97 0-9 4.03-9 9zM5.6 10.25c0 1.38 1.12 2.5 2.5 2.5.53 0 1.01-.16 1.42-.44l-.02.19c0 1.38 1.12 2.5 2.5 2.5s2.5-1.12 2.5-2.5l-.02-.19c.4.28.89.44 1.42.44 1.38 0 2.5-1.12 2.5-2.5 0-1-.59-1.85-1.43-2.25.84-.4 1.43-1.25 1.43-2.25 0-1.38-1.12-2.5-2.5-2.5-.53 0-1.01.16-1.42.44l.02-.19C14.5 2.12 13.38 1 12 1S9.5 2.12 9.5 3.5l.02.19c-.4-.28-.89-.44-1.42-.44-1.38 0-2.5 1.12-2.5 2.5 0 1 .59 1.85 1.43 2.25-.84.4-1.43 1.25-1.43 2.25zM12 5.5c1.38 0 2.5 1.12 2.5 2.5s-1.12 2.5-2.5 2.5S9.5 9.38 9.5 8s1.12-2.5 2.5-2.5zM3 13c0 4.97 4.03 9 9 9 0-4.97-4.03-9-9-9z"
})), 'LocalFlorist');

exports.default = _default;

/***/ }),
/* 1825 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M19.77 7.23l.01-.01-3.72-3.72L15 4.56l2.11 2.11c-.94.36-1.61 1.26-1.61 2.33 0 1.38 1.12 2.5 2.5 2.5.36 0 .69-.08 1-.21v7.21c0 .55-.45 1-1 1s-1-.45-1-1V14c0-1.1-.9-2-2-2h-1V5c0-1.1-.9-2-2-2H6c-1.1 0-2 .9-2 2v16h10v-7.5h1.5v5c0 1.38 1.12 2.5 2.5 2.5s2.5-1.12 2.5-2.5V9c0-.69-.28-1.32-.73-1.77zM12 10H6V5h6v5zm6 0c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"
})), 'LocalGasStation');

exports.default = _default;

/***/ }),
/* 1826 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M7 18c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2zM1 2v2h2l3.6 7.59-1.35 2.45c-.16.28-.25.61-.25.96 0 1.1.9 2 2 2h12v-2H7.42c-.14 0-.25-.11-.25-.25l.03-.12.9-1.63h7.45c.75 0 1.41-.41 1.75-1.03l3.58-6.49c.08-.14.12-.31.12-.48 0-.55-.45-1-1-1H5.21l-.94-2H1zm16 16c-1.1 0-1.99.9-1.99 2s.89 2 1.99 2 2-.9 2-2-.9-2-2-2z"
})), 'LocalGroceryStore');

exports.default = _default;

/***/ }),
/* 1827 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M19 3H5c-1.1 0-1.99.9-1.99 2L3 19c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-1 11h-4v4h-4v-4H6v-4h4V6h4v4h4v4z"
})), 'LocalHospital');

exports.default = _default;

/***/ }),
/* 1828 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M7 13c1.66 0 3-1.34 3-3S8.66 7 7 7s-3 1.34-3 3 1.34 3 3 3zm12-6h-8v7H3V5H1v15h2v-3h18v3h2v-9c0-2.21-1.79-4-4-4z"
})), 'LocalHotel');

exports.default = _default;

/***/ }),
/* 1829 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M9.17 16.83c1.56 1.56 4.1 1.56 5.66 0 1.56-1.56 1.56-4.1 0-5.66l-5.66 5.66zM18 2.01L6 2c-1.11 0-2 .89-2 2v16c0 1.11.89 2 2 2h12c1.11 0 2-.89 2-2V4c0-1.11-.89-1.99-2-1.99zM10 4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zM7 4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm5 16c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6z"
})), 'LocalLaundryService');

exports.default = _default;

/***/ }),
/* 1830 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 11.55C9.64 9.35 6.48 8 3 8v11c3.48 0 6.64 1.35 9 3.55 2.36-2.19 5.52-3.55 9-3.55V8c-3.48 0-6.64 1.35-9 3.55zM12 8c1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3 1.34 3 3 3z"
})), 'LocalLibrary');

exports.default = _default;

/***/ }),
/* 1831 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M19 6h-2c0-2.76-2.24-5-5-5S7 3.24 7 6H5c-1.1 0-1.99.9-1.99 2L3 20c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm-7-3c1.66 0 3 1.34 3 3H9c0-1.66 1.34-3 3-3zm0 10c-2.76 0-5-2.24-5-5h2c0 1.66 1.34 3 3 3s3-1.34 3-3h2c0 2.76-2.24 5-5 5z"
})), 'LocalMall');

exports.default = _default;

/***/ }),
/* 1832 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M18 3v2h-2V3H8v2H6V3H4v18h2v-2h2v2h8v-2h2v2h2V3h-2zM8 17H6v-2h2v2zm0-4H6v-2h2v2zm0-4H6V7h2v2zm10 8h-2v-2h2v2zm0-4h-2v-2h2v2zm0-4h-2V7h2v2z"
})), 'LocalMovies');

exports.default = _default;

/***/ }),
/* 1833 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M21.41 11.58l-9-9C12.05 2.22 11.55 2 11 2H4c-1.1 0-2 .9-2 2v7c0 .55.22 1.05.59 1.42l9 9c.36.36.86.58 1.41.58.55 0 1.05-.22 1.41-.59l7-7c.37-.36.59-.86.59-1.41 0-.55-.23-1.06-.59-1.42zM5.5 7C4.67 7 4 6.33 4 5.5S4.67 4 5.5 4 7 4.67 7 5.5 6.33 7 5.5 7z"
})), 'LocalOffer');

exports.default = _default;

/***/ }),
/* 1834 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M13 3H6v18h4v-6h3c3.31 0 6-2.69 6-6s-2.69-6-6-6zm.2 8H10V7h3.2c1.1 0 2 .9 2 2s-.9 2-2 2z"
})), 'LocalParking');

exports.default = _default;

/***/ }),
/* 1835 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M21 5h-2.64l1.14-3.14L17.15 1l-1.46 4H3v2l2 6-2 6v2h18v-2l-2-6 2-6V5zm-5 9h-3v3h-2v-3H8v-2h3V9h2v3h3v2z"
})), 'LocalPharmacy');

exports.default = _default;

/***/ }),
/* 1836 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"
})), 'LocalPhone');

exports.default = _default;

/***/ }),
/* 1837 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 2C8.43 2 5.23 3.54 3.01 6L12 22l8.99-16C18.78 3.55 15.57 2 12 2zM7 7c0-1.1.9-2 2-2s2 .9 2 2-.9 2-2 2-2-.9-2-2zm5 8c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"
})), 'LocalPizza');

exports.default = _default;

/***/ }),
/* 1838 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20 12c0-1.1.9-2 2-2V6c0-1.1-.9-2-2-2H4c-1.1 0-1.99.9-1.99 2v4c1.1 0 1.99.9 1.99 2s-.89 2-2 2v4c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2v-4c-1.1 0-2-.9-2-2zm-4.42 4.8L12 14.5l-3.58 2.3 1.08-4.12-3.29-2.69 4.24-.25L12 5.8l1.54 3.95 4.24.25-3.29 2.69 1.09 4.11z"
})), 'LocalPlay');

exports.default = _default;

/***/ }),
/* 1839 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"
})), 'LocalPostOffice');

exports.default = _default;

/***/ }),
/* 1840 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M19 8H5c-1.66 0-3 1.34-3 3v6h4v4h12v-4h4v-6c0-1.66-1.34-3-3-3zm-3 11H8v-5h8v5zm3-7c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm-1-9H6v4h12V3z"
})), 'LocalPrintshop');

exports.default = _default;

/***/ }),
/* 1841 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("circle", {
  cx: "12",
  cy: "12",
  r: "3.2"
}), _react.default.createElement("path", {
  d: "M9 2L7.17 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2h-3.17L15 2H9zm3 15c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5z"
})), 'LocalSee');

exports.default = _default;

/***/ }),
/* 1842 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20 8h-3V4H3c-1.1 0-2 .9-2 2v11h2c0 1.66 1.34 3 3 3s3-1.34 3-3h6c0 1.66 1.34 3 3 3s3-1.34 3-3h2v-5l-3-4zM6 18.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm13.5-9l1.96 2.5H17V9.5h2.5zm-1.5 9c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"
})), 'LocalShipping');

exports.default = _default;

/***/ }),
/* 1843 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M18.92 6.01C18.72 5.42 18.16 5 17.5 5H15V3H9v2H6.5c-.66 0-1.21.42-1.42 1.01L3 12v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-8l-2.08-5.99zM6.5 16c-.83 0-1.5-.67-1.5-1.5S5.67 13 6.5 13s1.5.67 1.5 1.5S7.33 16 6.5 16zm11 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM5 11l1.5-4.5h11L19 11H5z"
})), 'LocalTaxi');

exports.default = _default;

/***/ }),
/* 1844 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M15 11V5l-3-3-3 3v2H3v14h18V11h-6zm-8 8H5v-2h2v2zm0-4H5v-2h2v2zm0-4H5V9h2v2zm6 8h-2v-2h2v2zm0-4h-2v-2h2v2zm0-4h-2V9h2v2zm0-4h-2V5h2v2zm6 12h-2v-2h2v2zm0-4h-2v-2h2v2z"
})), 'LocationCity');

exports.default = _default;

/***/ }),
/* 1845 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20.94 11c-.46-4.17-3.77-7.48-7.94-7.94V1h-2v2.06c-1.13.12-2.19.46-3.16.97l1.5 1.5C10.16 5.19 11.06 5 12 5c3.87 0 7 3.13 7 7 0 .94-.19 1.84-.52 2.65l1.5 1.5c.5-.96.84-2.02.97-3.15H23v-2h-2.06zM3 4.27l2.04 2.04C3.97 7.62 3.25 9.23 3.06 11H1v2h2.06c.46 4.17 3.77 7.48 7.94 7.94V23h2v-2.06c1.77-.2 3.38-.91 4.69-1.98L19.73 21 21 19.73 4.27 3 3 4.27zm13.27 13.27C15.09 18.45 13.61 19 12 19c-3.87 0-7-3.13-7-7 0-1.61.55-3.09 1.46-4.27l9.81 9.81z"
})), 'LocationDisabled');

exports.default = _default;

/***/ }),
/* 1846 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 6.5c1.38 0 2.5 1.12 2.5 2.5 0 .74-.33 1.39-.83 1.85l3.63 3.63c.98-1.86 1.7-3.8 1.7-5.48 0-3.87-3.13-7-7-7-1.98 0-3.76.83-5.04 2.15l3.19 3.19c.46-.52 1.11-.84 1.85-.84zm4.37 9.6l-4.63-4.63-.11-.11L3.27 3 2 4.27l3.18 3.18C5.07 7.95 5 8.47 5 9c0 5.25 7 13 7 13s1.67-1.85 3.38-4.35L18.73 21 20 19.73l-3.63-3.63z"
})), 'LocationOff');

exports.default = _default;

/***/ }),
/* 1847 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"
})), 'LocationOn');

exports.default = _default;

/***/ }),
/* 1848 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20.94 11c-.46-4.17-3.77-7.48-7.94-7.94V1h-2v2.06C6.83 3.52 3.52 6.83 3.06 11H1v2h2.06c.46 4.17 3.77 7.48 7.94 7.94V23h2v-2.06c4.17-.46 7.48-3.77 7.94-7.94H23v-2h-2.06zM12 19c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z"
})), 'LocationSearching');

exports.default = _default;

/***/ }),
/* 1849 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z"
})), 'Lock');

exports.default = _default;

/***/ }),
/* 1850 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 17c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm6-9h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zM8.9 6c0-1.71 1.39-3.1 3.1-3.1s3.1 1.39 3.1 3.1v2H8.9V6zM18 20H6V10h12v10z"
})), 'LockOutline');

exports.default = _default;

/***/ }),
/* 1851 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 10c-3.86 0-7 3.14-7 7h2c0-2.76 2.24-5 5-5s5 2.24 5 5h2c0-3.86-3.14-7-7-7zm0-4C5.93 6 1 10.93 1 17h2c0-4.96 4.04-9 9-9s9 4.04 9 9h2c0-6.07-4.93-11-11-11z"
})), 'Looks');

exports.default = _default;

/***/ }),
/* 1852 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M19.01 3h-14c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-4 7.5c0 .83-.67 1.5-1.5 1.5.83 0 1.5.67 1.5 1.5V15c0 1.11-.9 2-2 2h-4v-2h4v-2h-2v-2h2V9h-4V7h4c1.1 0 2 .89 2 2v1.5z"
})), 'Looks3');

exports.default = _default;

/***/ }),
/* 1853 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-4 14h-2v-4H9V7h2v4h2V7h2v10z"
})), 'Looks4');

exports.default = _default;

/***/ }),
/* 1854 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-4 6h-4v2h2c1.1 0 2 .89 2 2v2c0 1.11-.9 2-2 2H9v-2h4v-2H9V7h6v2z"
})), 'Looks5');

exports.default = _default;

/***/ }),
/* 1855 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M11 15h2v-2h-2v2zm8-12H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-4 6h-4v2h2c1.1 0 2 .89 2 2v2c0 1.11-.9 2-2 2h-2c-1.1 0-2-.89-2-2V9c0-1.11.9-2 2-2h4v2z"
})), 'Looks6');

exports.default = _default;

/***/ }),
/* 1856 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-5 14h-2V9h-2V7h4v10z"
})), 'LooksOne');

exports.default = _default;

/***/ }),
/* 1857 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-4 8c0 1.11-.9 2-2 2h-2v2h4v2H9v-4c0-1.11.9-2 2-2h2V9H9V7h4c1.1 0 2 .89 2 2v2z"
})), 'LooksTwo');

exports.default = _default;

/***/ }),
/* 1858 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 4V1L8 5l4 4V6c3.31 0 6 2.69 6 6 0 1.01-.25 1.97-.7 2.8l1.46 1.46C19.54 15.03 20 13.57 20 12c0-4.42-3.58-8-8-8zm0 14c-3.31 0-6-2.69-6-6 0-1.01.25-1.97.7-2.8L5.24 7.74C4.46 8.97 4 10.43 4 12c0 4.42 3.58 8 8 8v3l4-4-4-4v3z"
})), 'Loop');

exports.default = _default;

/***/ }),
/* 1859 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M13 7h-2v4H7v2h4v4h2v-4h4v-2h-4V7zm-1-5C6.49 2 2 6.49 2 12s4.49 10 10 10h8c1.1 0 2-.9 2-2v-8c0-5.51-4.49-10-10-10zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
})), 'Loupe');

exports.default = _default;

/***/ }),
/* 1860 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M14 5h8v2h-8zm0 5.5h8v2h-8zm0 5.5h8v2h-8zM2 11.5C2 15.08 4.92 18 8.5 18H9v2l3-3-3-3v2h-.5C6.02 16 4 13.98 4 11.5S6.02 7 8.5 7H12V5H8.5C4.92 5 2 7.92 2 11.5z"
})), 'LowPriority');

exports.default = _default;

/***/ }),
/* 1861 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M21.41 11.58l-9-9C12.05 2.22 11.55 2 11 2H4c-1.1 0-2 .9-2 2v7c0 .55.22 1.05.59 1.42l9 9c.36.36.86.58 1.41.58.55 0 1.05-.22 1.41-.59l7-7c.37-.36.59-.86.59-1.41 0-.55-.23-1.06-.59-1.42zM5.5 7C4.67 7 4 6.33 4 5.5S4.67 4 5.5 4 7 4.67 7 5.5 6.33 7 5.5 7zm11.77 8.27L13 19.54l-4.27-4.27C8.28 14.81 8 14.19 8 13.5c0-1.38 1.12-2.5 2.5-2.5.69 0 1.32.28 1.77.74l.73.72.73-.73c.45-.45 1.08-.73 1.77-.73 1.38 0 2.5 1.12 2.5 2.5 0 .69-.28 1.32-.73 1.77z"
})), 'Loyalty');

exports.default = _default;

/***/ }),
/* 1862 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"
})), 'Mail');

exports.default = _default;

/***/ }),
/* 1863 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H4V8l8 5 8-5v10zm-8-7L4 6h16l-8 5z"
})), 'MailOutline');

exports.default = _default;

/***/ }),
/* 1864 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20.5 3l-.16.03L15 5.1 9 3 3.36 4.9c-.21.07-.36.25-.36.48V20.5c0 .28.22.5.5.5l.16-.03L9 18.9l6 2.1 5.64-1.9c.21-.07.36-.25.36-.48V3.5c0-.28-.22-.5-.5-.5zM15 19l-6-2.11V5l6 2.11V19z"
})), 'Map');

exports.default = _default;

/***/ }),
/* 1865 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"
})), 'Markunread');

exports.default = _default;

/***/ }),
/* 1866 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20 6H10v6H8V4h6V0H6v6H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2z"
})), 'MarkunreadMailbox');

exports.default = _default;

/***/ }),
/* 1867 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M15 9H9v6h6V9zm-2 4h-2v-2h2v2zm8-2V9h-2V7c0-1.1-.9-2-2-2h-2V3h-2v2h-2V3H9v2H7c-1.1 0-2 .9-2 2v2H3v2h2v2H3v2h2v2c0 1.1.9 2 2 2h2v2h2v-2h2v2h2v-2h2c1.1 0 2-.9 2-2v-2h2v-2h-2v-2h2zm-4 6H7V7h10v10z"
})), 'Memory');

exports.default = _default;

/***/ }),
/* 1868 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M17 20.41L18.41 19 15 15.59 13.59 17 17 20.41zM7.5 8H11v5.59L5.59 19 7 20.41l6-6V8h3.5L12 3.5 7.5 8z"
})), 'MergeType');

exports.default = _default;

/***/ }),
/* 1869 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-2 12H6v-2h12v2zm0-3H6V9h12v2zm0-3H6V6h12v2z"
})), 'Message');

exports.default = _default;

/***/ }),
/* 1870 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 14c1.66 0 2.99-1.34 2.99-3L15 5c0-1.66-1.34-3-3-3S9 3.34 9 5v6c0 1.66 1.34 3 3 3zm5.3-3c0 3-2.54 5.1-5.3 5.1S6.7 14 6.7 11H5c0 3.41 2.72 6.23 6 6.72V21h2v-3.28c3.28-.48 6-3.3 6-6.72h-1.7z"
})), 'Mic');

exports.default = _default;

/***/ }),
/* 1871 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 14c1.66 0 2.99-1.34 2.99-3L15 5c0-1.66-1.34-3-3-3S9 3.34 9 5v6c0 1.66 1.34 3 3 3zm-1.2-9.1c0-.66.54-1.2 1.2-1.2.66 0 1.2.54 1.2 1.2l-.01 6.2c0 .66-.53 1.2-1.19 1.2-.66 0-1.2-.54-1.2-1.2V4.9zm6.5 6.1c0 3-2.54 5.1-5.3 5.1S6.7 14 6.7 11H5c0 3.41 2.72 6.23 6 6.72V21h2v-3.28c3.28-.48 6-3.3 6-6.72h-1.7z"
})), 'MicNone');

exports.default = _default;

/***/ }),
/* 1872 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M19 11h-1.7c0 .74-.16 1.43-.43 2.05l1.23 1.23c.56-.98.9-2.09.9-3.28zm-4.02.17c0-.06.02-.11.02-.17V5c0-1.66-1.34-3-3-3S9 3.34 9 5v.18l5.98 5.99zM4.27 3L3 4.27l6.01 6.01V11c0 1.66 1.33 3 2.99 3 .22 0 .44-.03.65-.08l1.66 1.66c-.71.33-1.5.52-2.31.52-2.76 0-5.3-2.1-5.3-5.1H5c0 3.41 2.72 6.23 6 6.72V21h2v-3.28c.91-.13 1.77-.45 2.54-.9L19.73 21 21 19.73 4.27 3z"
})), 'MicOff');

exports.default = _default;

/***/ }),
/* 1873 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM5 14l3.5-4.5 2.5 3.01L14.5 8l4.5 6H5z"
})), 'Mms');

exports.default = _default;

/***/ }),
/* 1874 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M21.99 4c0-1.1-.89-2-1.99-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h14l4 4-.01-18z"
})), 'ModeComment');

exports.default = _default;

/***/ }),
/* 1875 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"
})), 'ModeEdit');

exports.default = _default;

/***/ }),
/* 1876 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1.41 16.09V20h-2.67v-1.93c-1.71-.36-3.16-1.46-3.27-3.4h1.96c.1 1.05.82 1.87 2.65 1.87 1.96 0 2.4-.98 2.4-1.59 0-.83-.44-1.61-2.67-2.14-2.48-.6-4.18-1.62-4.18-3.67 0-1.72 1.39-2.84 3.11-3.21V4h2.67v1.95c1.86.45 2.79 1.86 2.85 3.39H14.3c-.05-1.11-.64-1.87-2.22-1.87-1.5 0-2.4.68-2.4 1.64 0 .84.65 1.39 2.67 1.91s4.18 1.39 4.18 3.91c-.01 1.83-1.38 2.83-3.12 3.16z"
})), 'MonetizationOn');

exports.default = _default;

/***/ }),
/* 1877 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12.5 6.9c1.78 0 2.44.85 2.5 2.1h2.21c-.07-1.72-1.12-3.3-3.21-3.81V3h-3v2.16c-.53.12-1.03.3-1.48.54l1.47 1.47c.41-.17.91-.27 1.51-.27zM5.33 4.06L4.06 5.33 7.5 8.77c0 2.08 1.56 3.21 3.91 3.91l3.51 3.51c-.34.48-1.05.91-2.42.91-2.06 0-2.87-.92-2.98-2.1h-2.2c.12 2.19 1.76 3.42 3.68 3.83V21h3v-2.15c.96-.18 1.82-.55 2.45-1.12l2.22 2.22 1.27-1.27L5.33 4.06z"
})), 'MoneyOff');

exports.default = _default;

/***/ }),
/* 1878 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20 5h-3.2L15 3H9L7.2 5H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 14h-8v-1c-2.8 0-5-2.2-5-5s2.2-5 5-5V7h8v12zm-3-6c0-2.8-2.2-5-5-5v1.8c1.8 0 3.2 1.4 3.2 3.2s-1.4 3.2-3.2 3.2V18c2.8 0 5-2.2 5-5zm-8.2 0c0 1.8 1.4 3.2 3.2 3.2V9.8c-1.8 0-3.2 1.4-3.2 3.2z"
})), 'MonochromePhotos');

exports.default = _default;

/***/ }),
/* 1879 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm3.5-9c.83 0 1.5-.67 1.5-1.5S16.33 8 15.5 8 14 8.67 14 9.5s.67 1.5 1.5 1.5zm-7 0c.83 0 1.5-.67 1.5-1.5S9.33 8 8.5 8 7 8.67 7 9.5 7.67 11 8.5 11zm3.5 6.5c2.33 0 4.31-1.46 5.11-3.5H6.89c.8 2.04 2.78 3.5 5.11 3.5z"
})), 'Mood');

exports.default = _default;

/***/ }),
/* 1880 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm3.5-9c.83 0 1.5-.67 1.5-1.5S16.33 8 15.5 8 14 8.67 14 9.5s.67 1.5 1.5 1.5zm-7 0c.83 0 1.5-.67 1.5-1.5S9.33 8 8.5 8 7 8.67 7 9.5 7.67 11 8.5 11zm3.5 3c-2.33 0-4.31 1.46-5.11 3.5h10.22c-.8-2.04-2.78-3.5-5.11-3.5z"
})), 'MoodBad');

exports.default = _default;

/***/ }),
/* 1881 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M22 3H7c-.69 0-1.23.35-1.59.88L0 12l5.41 8.11c.36.53.97.89 1.66.89H22c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM9 13.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm5 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm5 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"
})), 'More');

exports.default = _default;

/***/ }),
/* 1882 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M6 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
})), 'MoreHoriz');

exports.default = _default;

/***/ }),
/* 1883 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
})), 'MoreVert');

exports.default = _default;

/***/ }),
/* 1884 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M19.44 9.03L15.41 5H11v2h3.59l2 2H5c-2.8 0-5 2.2-5 5s2.2 5 5 5c2.46 0 4.45-1.69 4.9-4h1.65l2.77-2.77c-.21.54-.32 1.14-.32 1.77 0 2.8 2.2 5 5 5s5-2.2 5-5c0-2.65-1.97-4.77-4.56-4.97zM7.82 15C7.4 16.15 6.28 17 5 17c-1.63 0-3-1.37-3-3s1.37-3 3-3c1.28 0 2.4.85 2.82 2H5v2h2.82zM19 17c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3z"
})), 'Motorcycle');

exports.default = _default;

/***/ }),
/* 1885 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M13 1.07V9h7c0-4.08-3.05-7.44-7-7.93zM4 15c0 4.42 3.58 8 8 8s8-3.58 8-8v-4H4v4zm7-13.93C7.05 1.56 4 4.92 4 9h7V1.07z"
})), 'Mouse');

exports.default = _default;

/***/ }),
/* 1886 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M19 3H4.99c-1.11 0-1.98.9-1.98 2L3 19c0 1.1.88 2 1.99 2H19c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 12h-4c0 1.66-1.35 3-3 3s-3-1.34-3-3H4.99V5H19v10zm-3-5h-2V7h-4v3H8l4 4 4-4z"
})), 'MoveToInbox');

exports.default = _default;

/***/ }),
/* 1887 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M18 4l2 4h-3l-2-4h-2l2 4h-3l-2-4H8l2 4H7L5 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4h-4z"
})), 'Movie');

exports.default = _default;

/***/ }),
/* 1888 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M18 4l2 4h-3l-2-4h-2l2 4h-3l-2-4H8l2 4H7L5 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4h-4z"
})), 'MovieCreation');

exports.default = _default;

/***/ }),
/* 1889 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M18 4l2 3h-3l-2-3h-2l2 3h-3l-2-3H8l2 3H7L5 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4h-4zm-6.75 11.25L10 18l-1.25-2.75L6 14l2.75-1.25L10 10l1.25 2.75L14 14l-2.75 1.25zm5.69-3.31L16 14l-.94-2.06L13 11l2.06-.94L16 8l.94 2.06L19 11l-2.06.94z"
})), 'MovieFilter');

exports.default = _default;

/***/ }),
/* 1890 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M22 6.92l-1.41-1.41-2.85 3.21C15.68 6.4 12.83 5 9.61 5 6.72 5 4.07 6.16 2 8l1.42 1.42C5.12 7.93 7.27 7 9.61 7c2.74 0 5.09 1.26 6.77 3.24l-2.88 3.24-4-4L2 16.99l1.5 1.5 6-6.01 4 4 4.05-4.55c.75 1.35 1.25 2.9 1.44 4.55H21c-.22-2.3-.95-4.39-2.04-6.14L22 6.92z"
})), 'MultilineChart');

exports.default = _default;

/***/ }),
/* 1891 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 3v10.55c-.59-.34-1.27-.55-2-.55-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4V7h4V3h-6z"
})), 'MusicNote');

exports.default = _default;

/***/ }),
/* 1892 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H3V5h18v14zM8 15c0-1.66 1.34-3 3-3 .35 0 .69.07 1 .18V6h5v2h-3v7.03c-.02 1.64-1.35 2.97-3 2.97-1.66 0-3-1.34-3-3z"
})), 'MusicVideo');

exports.default = _default;

/***/ }),
/* 1893 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm8.94 3c-.46-4.17-3.77-7.48-7.94-7.94V1h-2v2.06C6.83 3.52 3.52 6.83 3.06 11H1v2h2.06c.46 4.17 3.77 7.48 7.94 7.94V23h2v-2.06c4.17-.46 7.48-3.77 7.94-7.94H23v-2h-2.06zM12 19c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z"
})), 'MyLocation');

exports.default = _default;

/***/ }),
/* 1894 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M13 16.12c3.47-.41 6.17-3.36 6.17-6.95 0-3.87-3.13-7-7-7s-7 3.13-7 7c0 3.47 2.52 6.34 5.83 6.89V20H5v2h14v-2h-6v-3.88z"
})), 'Nature');

exports.default = _default;

/***/ }),
/* 1895 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M22.17 9.17c0-3.87-3.13-7-7-7s-7 3.13-7 7c0 3.47 2.52 6.34 5.83 6.89V20H6v-3h1v-4c0-.55-.45-1-1-1H3c-.55 0-1 .45-1 1v4h1v5h16v-2h-3v-3.88c3.47-.41 6.17-3.36 6.17-6.95zM4.5 11c.83 0 1.5-.67 1.5-1.5S5.33 8 4.5 8 3 8.67 3 9.5 3.67 11 4.5 11z"
})), 'NaturePeople');

exports.default = _default;

/***/ }),
/* 1896 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"
})), 'NavigateBefore');

exports.default = _default;

/***/ }),
/* 1897 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"
})), 'NavigateNext');

exports.default = _default;

/***/ }),
/* 1898 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 2L4.5 20.29l.71.71L12 18l6.79 3 .71-.71z"
})), 'Navigation');

exports.default = _default;

/***/ }),
/* 1899 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M21 3L3 10.53v.98l6.84 2.65L12.48 21h.98L21 3z"
})), 'NearMe');

exports.default = _default;

/***/ }),
/* 1900 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  fillOpacity: ".3",
  d: "M2 22h20V2z"
}), _react.default.createElement("path", {
  d: "M17 7L2 22h15z"
})), 'NetworkCell');

exports.default = _default;

/***/ }),
/* 1901 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M15.9 5c-.17 0-.32.09-.41.23l-.07.15-5.18 11.65c-.16.29-.26.61-.26.96 0 1.11.9 2.01 2.01 2.01.96 0 1.77-.68 1.96-1.59l.01-.03L16.4 5.5c0-.28-.22-.5-.5-.5zM1 9l2 2c2.88-2.88 6.79-4.08 10.53-3.62l1.19-2.68C9.89 3.84 4.74 5.27 1 9zm20 2l2-2c-1.64-1.64-3.55-2.82-5.59-3.57l-.53 2.82c1.5.62 2.9 1.53 4.12 2.75zm-4 4l2-2c-.8-.8-1.7-1.42-2.66-1.89l-.55 2.92c.42.27.83.59 1.21.97zM5 13l2 2c1.13-1.13 2.56-1.79 4.03-2l1.28-2.88c-2.63-.08-5.3.87-7.31 2.88z"
})), 'NetworkCheck');

exports.default = _default;

/***/ }),
/* 1902 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M19.5 10c.17 0 .33.03.5.05V1L1 20h13v-3c0-.89.39-1.68 1-2.23v-.27c0-2.48 2.02-4.5 4.5-4.5zm2.5 6v-1.5c0-1.38-1.12-2.5-2.5-2.5S17 13.12 17 14.5V16c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1h5c.55 0 1-.45 1-1v-4c0-.55-.45-1-1-1zm-1 0h-3v-1.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5V16z"
})), 'NetworkLocked');

exports.default = _default;

/***/ }),
/* 1903 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  fillOpacity: ".3",
  d: "M12.01 21.49L23.64 7c-.45-.34-4.93-4-11.64-4C5.28 3 .81 6.66.36 7l11.63 14.49.01.01.01-.01z"
}), _react.default.createElement("path", {
  d: "M3.53 10.95l8.46 10.54.01.01.01-.01 8.46-10.54C20.04 10.62 16.81 8 12 8c-4.81 0-8.04 2.62-8.47 2.95z"
})), 'NetworkWifi');

exports.default = _default;

/***/ }),
/* 1904 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M23 12l-2.44-2.78.34-3.68-3.61-.82-1.89-3.18L12 3 8.6 1.54 6.71 4.72l-3.61.81.34 3.68L1 12l2.44 2.78-.34 3.69 3.61.82 1.89 3.18L12 21l3.4 1.46 1.89-3.18 3.61-.82-.34-3.68L23 12zm-10 5h-2v-2h2v2zm0-4h-2V7h2v6z"
})), 'NewReleases');

exports.default = _default;

/***/ }),
/* 1905 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20 7h-4V5c0-.55-.22-1.05-.59-1.41C15.05 3.22 14.55 3 14 3h-4c-1.1 0-2 .9-2 2v2H4c-1.1 0-2 .9-2 2v11c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V9c0-1.1-.9-2-2-2zM10 5h4v2h-4V5zm1 13.5l-1-1 3-3-3-3 1-1 4 4-4 4z"
})), 'NextWeek');

exports.default = _default;

/***/ }),
/* 1906 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20 2H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 18H4V4h16v16zM18 6h-5c-1.1 0-2 .9-2 2v2.28c-.6.35-1 .98-1 1.72 0 1.1.9 2 2 2s2-.9 2-2c0-.74-.4-1.38-1-1.72V8h3v8H8V8h2V6H6v12h12V6z"
})), 'Nfc');

exports.default = _default;

/***/ }),
/* 1907 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M21 21.78L4.22 5 3 6.22l2.04 2.04C4.42 8.6 4 9.25 4 10v10c0 1.1.9 2 2 2h12c.23 0 .45-.05.66-.12L19.78 23 21 21.78zM8.9 6c0-1.71 1.39-3.1 3.1-3.1s3.1 1.39 3.1 3.1v2H9.66L20 18.34V10c0-1.1-.9-2-2-2h-1V6c0-2.76-2.24-5-5-5-2.56 0-4.64 1.93-4.94 4.4L8.9 7.24V6z"
})), 'NoEncryption');

exports.default = _default;

/***/ }),
/* 1908 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M18.99 5c0-1.1-.89-2-1.99-2h-7L7.66 5.34 19 16.68 18.99 5zM3.65 3.88L2.38 5.15 5 7.77V19c0 1.1.9 2 2 2h10.01c.35 0 .67-.1.96-.26l1.88 1.88 1.27-1.27L3.65 3.88z"
})), 'NoSim');

exports.default = _default;

/***/ }),
/* 1909 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M22 10l-6-6H4c-1.1 0-2 .9-2 2v12.01c0 1.1.9 1.99 2 1.99l16-.01c1.1 0 2-.89 2-1.99v-8zm-7-4.5l5.5 5.5H15V5.5z"
})), 'Note');

exports.default = _default;

/***/ }),
/* 1910 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm2 14h-3v3h-2v-3H8v-2h3v-3h2v3h3v2zm-3-7V3.5L18.5 9H13z"
})), 'NoteAdd');

exports.default = _default;

/***/ }),
/* 1911 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 22c1.1 0 2-.9 2-2h-4c0 1.1.89 2 2 2zm6-6v-5c0-3.07-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.63 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2z"
})), 'Notifications');

exports.default = _default;

/***/ }),
/* 1912 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M7.58 4.08L6.15 2.65C3.75 4.48 2.17 7.3 2.03 10.5h2c.15-2.65 1.51-4.97 3.55-6.42zm12.39 6.42h2c-.15-3.2-1.73-6.02-4.12-7.85l-1.42 1.43c2.02 1.45 3.39 3.77 3.54 6.42zM18 11c0-3.07-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.63 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2v-5zm-6 11c.14 0 .27-.01.4-.04.65-.14 1.18-.58 1.44-1.18.1-.24.15-.5.15-.78h-4c.01 1.1.9 2 2.01 2z"
})), 'NotificationsActive');

exports.default = _default;

/***/ }),
/* 1913 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 22c1.1 0 2-.9 2-2h-4c0 1.1.9 2 2 2zm6-6v-5c0-3.07-1.63-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.64 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2zm-2 1H8v-6c0-2.48 1.51-4.5 4-4.5s4 2.02 4 4.5v6z"
})), 'NotificationsNone');

exports.default = _default;

/***/ }),
/* 1914 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20 18.69L7.84 6.14 5.27 3.49 4 4.76l2.8 2.8v.01c-.52.99-.8 2.16-.8 3.42v5l-2 2v1h13.73l2 2L21 19.72l-1-1.03zM12 22c1.11 0 2-.89 2-2h-4c0 1.11.89 2 2 2zm6-7.32V11c0-3.08-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68c-.15.03-.29.08-.42.12-.1.03-.2.07-.3.11h-.01c-.01 0-.01 0-.02.01-.23.09-.46.2-.68.31 0 0-.01 0-.01.01L18 14.68z"
})), 'NotificationsOff');

exports.default = _default;

/***/ }),
/* 1915 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 22c1.1 0 2-.9 2-2h-4c0 1.1.89 2 2 2zm6-6v-5c0-3.07-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.63 5.36 6 7.93 6 11v5l-2 2v1h16v-1l-2-2zm-3.5-6.2l-2.8 3.4h2.8V15h-5v-1.8l2.8-3.4H9.5V8h5v1.8z"
})), 'NotificationsPaused');

exports.default = _default;

/***/ }),
/* 1916 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8 0-1.85.63-3.55 1.69-4.9L16.9 18.31C15.55 19.37 13.85 20 12 20zm6.31-3.1L7.1 5.69C8.45 4.63 10.15 4 12 4c4.42 0 8 3.58 8 8 0 1.85-.63 3.55-1.69 4.9z"
})), 'NotInterested');

exports.default = _default;

/***/ }),
/* 1917 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10S17.5 2 12 2zm5 16H7v-2h10v2zm-6.7-4L7 10.7l1.4-1.4 1.9 1.9 5.3-5.3L17 7.3 10.3 14z"
})), 'OfflinePin');

exports.default = _default;

/***/ }),
/* 1918 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M21 3H3c-1.11 0-2 .89-2 2v12c0 1.1.89 2 2 2h5v2h8v-2h5c1.1 0 1.99-.9 1.99-2L23 5c0-1.11-.9-2-2-2zm0 14H3V5h18v12zm-5-6l-7 4V7z"
})), 'OndemandVideo');

exports.default = _default;

/***/ }),
/* 1919 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M17.66 8L12 2.35 6.34 8C4.78 9.56 4 11.64 4 13.64s.78 4.11 2.34 5.67 3.61 2.35 5.66 2.35 4.1-.79 5.66-2.35S20 15.64 20 13.64 19.22 9.56 17.66 8zM6 14c.01-2 .62-3.27 1.76-4.4L12 5.27l4.24 4.38C17.38 10.77 17.99 12 18 14H6z"
})), 'Opacity');

exports.default = _default;

/***/ }),
/* 1920 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M19 4H5c-1.11 0-2 .9-2 2v12c0 1.1.89 2 2 2h4v-2H5V8h14v10h-4v2h4c1.1 0 2-.9 2-2V6c0-1.1-.89-2-2-2zm-7 6l-4 4h3v6h2v-6h3l-4-4z"
})), 'OpenInBrowser');

exports.default = _default;

/***/ }),
/* 1921 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M19 19H5V5h7V3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2v-7h-2v7zM14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3h-7z"
})), 'OpenInNew');

exports.default = _default;

/***/ }),
/* 1922 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M10 9h4V6h3l-5-5-5 5h3v3zm-1 1H6V7l-5 5 5 5v-3h3v-4zm14 2l-5-5v3h-3v4h3v3l5-5zm-9 3h-4v3H7l5 5 5-5h-3v-3z"
})), 'OpenWith');

exports.default = _default;

/***/ }),
/* 1923 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M3 5v6h5L7 7l4 1V3H5c-1.1 0-2 .9-2 2zm5 8H3v6c0 1.1.9 2 2 2h6v-5l-4 1 1-4zm9 4l-4-1v5h6c1.1 0 2-.9 2-2v-6h-5l1 4zm2-14h-6v5l4-1-1 4h5V5c0-1.1-.9-2-2-2z"
})), 'Pages');

exports.default = _default;

/***/ }),
/* 1924 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M11.5 9C10.12 9 9 10.12 9 11.5s1.12 2.5 2.5 2.5 2.5-1.12 2.5-2.5S12.88 9 11.5 9zM20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-3.21 14.21l-2.91-2.91c-.69.44-1.51.7-2.39.7C9.01 16 7 13.99 7 11.5S9.01 7 11.5 7 16 9.01 16 11.5c0 .88-.26 1.69-.7 2.39l2.91 2.9-1.42 1.42z"
})), 'Pageview');

exports.default = _default;

/***/ }),
/* 1925 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 3c-4.97 0-9 4.03-9 9s4.03 9 9 9c.83 0 1.5-.67 1.5-1.5 0-.39-.15-.74-.39-1.01-.23-.26-.38-.61-.38-.99 0-.83.67-1.5 1.5-1.5H16c2.76 0 5-2.24 5-5 0-4.42-4.03-8-9-8zm-5.5 9c-.83 0-1.5-.67-1.5-1.5S5.67 9 6.5 9 8 9.67 8 10.5 7.33 12 6.5 12zm3-4C8.67 8 8 7.33 8 6.5S8.67 5 9.5 5s1.5.67 1.5 1.5S10.33 8 9.5 8zm5 0c-.83 0-1.5-.67-1.5-1.5S13.67 5 14.5 5s1.5.67 1.5 1.5S15.33 8 14.5 8zm3 4c-.83 0-1.5-.67-1.5-1.5S16.67 9 17.5 9s1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"
})), 'Palette');

exports.default = _default;

/***/ }),
/* 1926 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M23 18V6c0-1.1-.9-2-2-2H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2zM8.5 12.5l2.5 3.01L14.5 11l4.5 6H5l3.5-4.5z"
})), 'Panorama');

exports.default = _default;

/***/ }),
/* 1927 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
})), 'PanoramaFishEye');

exports.default = _default;

/***/ }),
/* 1928 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20 6.54v10.91c-2.6-.77-5.28-1.16-8-1.16-2.72 0-5.4.39-8 1.16V6.54c2.6.77 5.28 1.16 8 1.16 2.72.01 5.4-.38 8-1.16M21.43 4c-.1 0-.2.02-.31.06C18.18 5.16 15.09 5.7 12 5.7c-3.09 0-6.18-.55-9.12-1.64-.11-.04-.22-.06-.31-.06-.34 0-.57.23-.57.63v14.75c0 .39.23.62.57.62.1 0 .2-.02.31-.06 2.94-1.1 6.03-1.64 9.12-1.64 3.09 0 6.18.55 9.12 1.64.11.04.21.06.31.06.33 0 .57-.23.57-.63V4.63c0-.4-.24-.63-.57-.63z"
})), 'PanoramaHorizontal');

exports.default = _default;

/***/ }),
/* 1929 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M19.94 21.12c-1.1-2.94-1.64-6.03-1.64-9.12 0-3.09.55-6.18 1.64-9.12.04-.11.06-.22.06-.31 0-.34-.23-.57-.63-.57H4.63c-.4 0-.63.23-.63.57 0 .1.02.2.06.31C5.16 5.82 5.71 8.91 5.71 12c0 3.09-.55 6.18-1.64 9.12-.05.11-.07.22-.07.31 0 .33.23.57.63.57h14.75c.39 0 .63-.24.63-.57-.01-.1-.03-.2-.07-.31zM6.54 20c.77-2.6 1.16-5.28 1.16-8 0-2.72-.39-5.4-1.16-8h10.91c-.77 2.6-1.16 5.28-1.16 8 0 2.72.39 5.4 1.16 8H6.54z"
})), 'PanoramaVertical');

exports.default = _default;

/***/ }),
/* 1930 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 6c2.45 0 4.71.2 7.29.64.47 1.78.71 3.58.71 5.36 0 1.78-.24 3.58-.71 5.36-2.58.44-4.84.64-7.29.64s-4.71-.2-7.29-.64C4.24 15.58 4 13.78 4 12c0-1.78.24-3.58.71-5.36C7.29 6.2 9.55 6 12 6m0-2c-2.73 0-5.22.24-7.95.72l-.93.16-.25.9C2.29 7.85 2 9.93 2 12s.29 4.15.87 6.22l.25.89.93.16c2.73.49 5.22.73 7.95.73s5.22-.24 7.95-.72l.93-.16.25-.89c.58-2.08.87-4.16.87-6.23s-.29-4.15-.87-6.22l-.25-.89-.93-.16C17.22 4.24 14.73 4 12 4z"
})), 'PanoramaWideAngle');

exports.default = _default;

/***/ }),
/* 1931 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M23 5.5V20c0 2.2-1.8 4-4 4h-7.3c-1.08 0-2.1-.43-2.85-1.19L1 14.83s1.26-1.23 1.3-1.25c.22-.19.49-.29.79-.29.22 0 .42.06.6.16.04.01 4.31 2.46 4.31 2.46V4c0-.83.67-1.5 1.5-1.5S11 3.17 11 4v7h1V1.5c0-.83.67-1.5 1.5-1.5S15 .67 15 1.5V11h1V2.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5V11h1V5.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5z"
})), 'PanTool');

exports.default = _default;

/***/ }),
/* 1932 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20 4h-3.17L15 2H9L7.17 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-8 3c1.63 0 3.06.79 3.98 2H12c-1.66 0-3 1.34-3 3 0 .35.07.69.18 1H7.1c-.06-.32-.1-.66-.1-1 0-2.76 2.24-5 5-5zm0 10c-1.63 0-3.06-.79-3.98-2H12c1.66 0 3-1.34 3-3 0-.35-.07-.69-.18-1h2.08c.07.32.1.66.1 1 0 2.76-2.24 5-5 5z"
})), 'PartyMode');

exports.default = _default;

/***/ }),
/* 1933 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M6 19h4V5H6v14zm8-14v14h4V5h-4z"
})), 'Pause');

exports.default = _default;

/***/ }),
/* 1934 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 14H9V8h2v8zm4 0h-2V8h2v8z"
})), 'PauseCircleFilled');

exports.default = _default;

/***/ }),
/* 1935 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M9 16h2V8H9v8zm3-14C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm1-4h2V8h-2v8z"
})), 'PauseCircleOutline');

exports.default = _default;

/***/ }),
/* 1936 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20 4H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zm0 14H4v-6h16v6zm0-10H4V6h16v2z"
})), 'Payment');

exports.default = _default;

/***/ }),
/* 1937 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z"
})), 'People');

exports.default = _default;

/***/ }),
/* 1938 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M16.5 13c-1.2 0-3.07.34-4.5 1-1.43-.67-3.3-1-4.5-1C5.33 13 1 14.08 1 16.25V19h22v-2.75c0-2.17-4.33-3.25-6.5-3.25zm-4 4.5h-10v-1.25c0-.54 2.56-1.75 5-1.75s5 1.21 5 1.75v1.25zm9 0H14v-1.25c0-.46-.2-.86-.52-1.22.88-.3 1.96-.53 3.02-.53 2.44 0 5 1.21 5 1.75v1.25zM7.5 12c1.93 0 3.5-1.57 3.5-3.5S9.43 5 7.5 5 4 6.57 4 8.5 5.57 12 7.5 12zm0-5.5c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zm9 5.5c1.93 0 3.5-1.57 3.5-3.5S18.43 5 16.5 5 13 6.57 13 8.5s1.57 3.5 3.5 3.5zm0-5.5c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2z"
})), 'PeopleOutline');

exports.default = _default;

/***/ }),
/* 1939 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20 5h-3.17L15 3H9L7.17 5H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h7v-2.09c-2.83-.48-5-2.94-5-5.91h2c0 2.21 1.79 4 4 4s4-1.79 4-4h2c0 2.97-2.17 5.43-5 5.91V21h7c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm-6 8c0 1.1-.9 2-2 2s-2-.9-2-2V9c0-1.1.9-2 2-2s2 .9 2 2v4z"
})), 'PermCameraMic');

exports.default = _default;

/***/ }),
/* 1940 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M19 3h-1V1h-2v2H8V1H6v2H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 3c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm6 12H6v-1c0-2 4-3.1 6-3.1s6 1.1 6 3.1v1z"
})), 'PermContactCalendar');

exports.default = _default;

/***/ }),
/* 1941 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M18.99 11.5c.34 0 .67.03 1 .07L20 0 0 20h11.56c-.04-.33-.07-.66-.07-1 0-4.14 3.36-7.5 7.5-7.5zm3.71 7.99c.02-.16.04-.32.04-.49 0-.17-.01-.33-.04-.49l1.06-.83c.09-.08.12-.21.06-.32l-1-1.73c-.06-.11-.19-.15-.31-.11l-1.24.5c-.26-.2-.54-.37-.85-.49l-.19-1.32c-.01-.12-.12-.21-.24-.21h-2c-.12 0-.23.09-.25.21l-.19 1.32c-.3.13-.59.29-.85.49l-1.24-.5c-.11-.04-.24 0-.31.11l-1 1.73c-.06.11-.04.24.06.32l1.06.83c-.02.16-.03.32-.03.49 0 .17.01.33.03.49l-1.06.83c-.09.08-.12.21-.06.32l1 1.73c.06.11.19.15.31.11l1.24-.5c.26.2.54.37.85.49l.19 1.32c.02.12.12.21.25.21h2c.12 0 .23-.09.25-.21l.19-1.32c.3-.13.59-.29.84-.49l1.25.5c.11.04.24 0 .31-.11l1-1.73c.06-.11.03-.24-.06-.32l-1.07-.83zm-3.71 1.01c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"
})), 'PermDataSetting');

exports.default = _default;

/***/ }),
/* 1942 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M13 7h-2v2h2V7zm0 4h-2v6h2v-6zm4-9.99L7 1c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM17 19H7V5h10v14z"
})), 'PermDeviceInformation');

exports.default = _default;

/***/ }),
/* 1943 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M2 6H0v5h.01L0 20c0 1.1.9 2 2 2h18v-2H2V6zm20-2h-8l-2-2H6c-1.1 0-1.99.9-1.99 2L4 16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zM7 15l4.5-6 3.5 4.51 2.5-3.01L21 15H7z"
})), 'PermMedia');

exports.default = _default;

/***/ }),
/* 1944 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20 15.5c-1.25 0-2.45-.2-3.57-.57-.35-.11-.74-.03-1.02.24l-2.2 2.2c-2.83-1.44-5.15-3.75-6.59-6.58l2.2-2.21c.28-.27.36-.66.25-1.01C8.7 6.45 8.5 5.25 8.5 4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.5c0-.55-.45-1-1-1zM12 3v10l3-3h6V3h-9z"
})), 'PermPhoneMsg');

exports.default = _default;

/***/ }),
/* 1945 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 3C6.95 3 3.15 4.85 0 7.23L12 22 24 7.25C20.85 4.87 17.05 3 12 3zm1 13h-2v-6h2v6zm-2-8V6h2v2h-2z"
})), 'PermScanWifi');

exports.default = _default;

/***/ }),
/* 1946 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"
})), 'Person');

exports.default = _default;

/***/ }),
/* 1947 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M15 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm-9-2V7H4v3H1v2h3v3h2v-3h3v-2H6zm9 4c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"
})), 'PersonAdd');

exports.default = _default;

/***/ }),
/* 1948 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M21 3H3c-1.11 0-2 .89-2 2v12c0 1.1.89 2 2 2h5v2h8v-2h5c1.1 0 1.99-.9 1.99-2L23 5c0-1.11-.9-2-2-2zm0 14H3V5h18v12z"
})), 'PersonalVideo');

exports.default = _default;

/***/ }),
/* 1949 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 5.9c1.16 0 2.1.94 2.1 2.1s-.94 2.1-2.1 2.1S9.9 9.16 9.9 8s.94-2.1 2.1-2.1m0 9c2.97 0 6.1 1.46 6.1 2.1v1.1H5.9V17c0-.64 3.13-2.1 6.1-2.1M12 4C9.79 4 8 5.79 8 8s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 9c-2.67 0-8 1.34-8 4v3h16v-3c0-2.66-5.33-4-8-4z"
})), 'PersonOutline');

exports.default = _default;

/***/ }),
/* 1950 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M19 2H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h4l3 3 3-3h4c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-7 3.3c1.49 0 2.7 1.21 2.7 2.7 0 1.49-1.21 2.7-2.7 2.7-1.49 0-2.7-1.21-2.7-2.7 0-1.49 1.21-2.7 2.7-2.7zM18 16H6v-.9c0-2 4-3.1 6-3.1s6 1.1 6 3.1v.9z"
})), 'PersonPin');

exports.default = _default;

/***/ }),
/* 1951 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 2C8.14 2 5 5.14 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.86-3.14-7-7-7zm0 2c1.1 0 2 .9 2 2 0 1.11-.9 2-2 2s-2-.89-2-2c0-1.1.9-2 2-2zm0 10c-1.67 0-3.14-.85-4-2.15.02-1.32 2.67-2.05 4-2.05s3.98.73 4 2.05c-.86 1.3-2.33 2.15-4 2.15z"
})), 'PersonPinCircle');

exports.default = _default;

/***/ }),
/* 1952 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("circle", {
  cx: "4.5",
  cy: "9.5",
  r: "2.5"
}), _react.default.createElement("circle", {
  cx: "9",
  cy: "5.5",
  r: "2.5"
}), _react.default.createElement("circle", {
  cx: "15",
  cy: "5.5",
  r: "2.5"
}), _react.default.createElement("circle", {
  cx: "19.5",
  cy: "9.5",
  r: "2.5"
}), _react.default.createElement("path", {
  d: "M17.34 14.86c-.87-1.02-1.6-1.89-2.48-2.91-.46-.54-1.05-1.08-1.75-1.32-.11-.04-.22-.07-.33-.09-.25-.04-.52-.04-.78-.04s-.53 0-.79.05c-.11.02-.22.05-.33.09-.7.24-1.28.78-1.75 1.32-.87 1.02-1.6 1.89-2.48 2.91-1.31 1.31-2.92 2.76-2.62 4.79.29 1.02 1.02 2.03 2.33 2.32.73.15 3.06-.44 5.54-.44h.18c2.48 0 4.81.58 5.54.44 1.31-.29 2.04-1.31 2.33-2.32.31-2.04-1.3-3.49-2.61-4.8z"
})), 'Pets');

exports.default = _default;

/***/ }),
/* 1953 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"
})), 'Phone');

exports.default = _default;

/***/ }),
/* 1954 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M16 1H8C6.34 1 5 2.34 5 4v16c0 1.66 1.34 3 3 3h8c1.66 0 3-1.34 3-3V4c0-1.66-1.34-3-3-3zm-2 20h-4v-1h4v1zm3.25-3H6.75V4h10.5v14z"
})), 'PhoneAndroid');

exports.default = _default;

/***/ }),
/* 1955 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M14.71 9.5L17 7.21V11h.5l2.85-2.85L18.21 6l2.15-2.15L17.5 1H17v3.79L14.71 2.5l-.71.71L16.79 6 14 8.79l.71.71zM18 2.91l.94.94-.94.94V2.91zm0 4.3l.94.94-.94.94V7.21zm2 8.29c-1.25 0-2.45-.2-3.57-.57-.35-.11-.74-.03-1.02.24l-2.2 2.2c-2.83-1.44-5.15-3.75-6.59-6.59l2.2-2.21c.28-.26.36-.65.25-1C8.7 6.45 8.5 5.25 8.5 4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.5c0-.55-.45-1-1-1z"
})), 'PhoneBluetoothSpeaker');

exports.default = _default;

/***/ }),
/* 1956 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M18 11l5-5-5-5v3h-4v4h4v3zm2 4.5c-1.25 0-2.45-.2-3.57-.57-.35-.11-.74-.03-1.02.24l-2.2 2.2c-2.83-1.44-5.15-3.75-6.59-6.59l2.2-2.21c.28-.26.36-.65.25-1C8.7 6.45 8.5 5.25 8.5 4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.5c0-.55-.45-1-1-1z"
})), 'PhoneForwarded');

exports.default = _default;

/***/ }),
/* 1957 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20 15.5c-1.25 0-2.45-.2-3.57-.57-.35-.11-.74-.03-1.02.24l-2.2 2.2c-2.83-1.44-5.15-3.75-6.59-6.59l2.2-2.21c.28-.26.36-.65.25-1C8.7 6.45 8.5 5.25 8.5 4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.5c0-.55-.45-1-1-1zM19 12h2c0-4.97-4.03-9-9-9v2c3.87 0 7 3.13 7 7zm-4 0h2c0-2.76-2.24-5-5-5v2c1.66 0 3 1.34 3 3z"
})), 'PhoneInTalk');

exports.default = _default;

/***/ }),
/* 1958 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M15.5 1h-8C6.12 1 5 2.12 5 3.5v17C5 21.88 6.12 23 7.5 23h8c1.38 0 2.5-1.12 2.5-2.5v-17C18 2.12 16.88 1 15.5 1zm-4 21c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm4.5-4H7V4h9v14z"
})), 'PhoneIphone');

exports.default = _default;

/***/ }),
/* 1959 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M4 6h18V4H4c-1.1 0-2 .9-2 2v11H0v3h14v-3H4V6zm19 2h-6c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h6c.55 0 1-.45 1-1V9c0-.55-.45-1-1-1zm-1 9h-4v-7h4v7z"
})), 'Phonelink');

exports.default = _default;

/***/ }),
/* 1960 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M13 8.2l-1-1-4 4-4-4-1 1 4 4-4 4 1 1 4-4 4 4 1-1-4-4 4-4zM19 1H9c-1.1 0-2 .9-2 2v3h2V4h10v16H9v-2H7v3c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2z"
})), 'PhonelinkErase');

exports.default = _default;

/***/ }),
/* 1961 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M19 1H9c-1.1 0-2 .9-2 2v3h2V4h10v16H9v-2H7v3c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm-8.2 10V9.5C10.8 8.1 9.4 7 8 7S5.2 8.1 5.2 9.5V11c-.6 0-1.2.6-1.2 1.2v3.5c0 .7.6 1.3 1.2 1.3h5.5c.7 0 1.3-.6 1.3-1.2v-3.5c0-.7-.6-1.3-1.2-1.3zm-1.3 0h-3V9.5c0-.8.7-1.3 1.5-1.3s1.5.5 1.5 1.3V11z"
})), 'PhonelinkLock');

exports.default = _default;

/***/ }),
/* 1962 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M22 6V4H6.82l2 2H22zM1.92 1.65L.65 2.92l1.82 1.82C2.18 5.08 2 5.52 2 6v11H0v3h17.73l2.35 2.35 1.27-1.27L3.89 3.62 1.92 1.65zM4 6.27L14.73 17H4V6.27zM23 8h-6c-.55 0-1 .45-1 1v4.18l2 2V10h4v7h-2.18l3 3H23c.55 0 1-.45 1-1V9c0-.55-.45-1-1-1z"
})), 'PhonelinkOff');

exports.default = _default;

/***/ }),
/* 1963 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20.1 7.7l-1 1c1.8 1.8 1.8 4.6 0 6.5l1 1c2.5-2.3 2.5-6.1 0-8.5zM18 9.8l-1 1c.5.7.5 1.6 0 2.3l1 1c1.2-1.2 1.2-3 0-4.3zM14 1H4c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 19H4V4h10v16z"
})), 'PhonelinkRing');

exports.default = _default;

/***/ }),
/* 1964 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M11.8 12.5v-1l1.1-.8c.1-.1.1-.2.1-.3l-1-1.7c-.1-.1-.2-.2-.3-.1l-1.3.4c-.3-.2-.6-.4-.9-.5l-.2-1.3c0-.1-.1-.2-.3-.2H7c-.1 0-.2.1-.3.2l-.2 1.3c-.3.1-.6.3-.9.5l-1.3-.5c-.1 0-.2 0-.3.1l-1 1.7c-.1.1 0 .2.1.3l1.1.8v1l-1.1.8c-.1.2-.1.3-.1.4l1 1.7c.1.1.2.2.3.1l1.4-.4c.3.2.6.4.9.5l.2 1.3c-.1.1.1.2.2.2h2c.1 0 .2-.1.3-.2l.2-1.3c.3-.1.6-.3.9-.5l1.3.5c.1 0 .2 0 .3-.1l1-1.7c.1-.1 0-.2-.1-.3l-1.1-.9zM8 14c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zM19 1H9c-1.1 0-2 .9-2 2v3h2V4h10v16H9v-2H7v3c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2z"
})), 'PhonelinkSetup');

exports.default = _default;

/***/ }),
/* 1965 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20 15.5c-1.25 0-2.45-.2-3.57-.57-.35-.11-.74-.03-1.02.24l-2.2 2.2c-2.83-1.44-5.15-3.75-6.59-6.59l2.2-2.21c.28-.26.36-.65.25-1C8.7 6.45 8.5 5.25 8.5 4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.5c0-.55-.45-1-1-1zM20 4v-.5C20 2.12 18.88 1 17.5 1S15 2.12 15 3.5V4c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1h5c.55 0 1-.45 1-1V5c0-.55-.45-1-1-1zm-.8 0h-3.4v-.5c0-.94.76-1.7 1.7-1.7s1.7.76 1.7 1.7V4z"
})), 'PhoneLocked');

exports.default = _default;

/***/ }),
/* 1966 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M6.5 5.5L12 11l7-7-1-1-6 6-4.5-4.5H11V3H5v6h1.5V5.5zm17.21 11.17C20.66 13.78 16.54 12 12 12 7.46 12 3.34 13.78.29 16.67c-.18.18-.29.43-.29.71s.11.53.29.71l2.48 2.48c.18.18.43.29.71.29.27 0 .52-.11.7-.28.79-.74 1.69-1.36 2.66-1.85.33-.16.56-.5.56-.9v-3.1c1.45-.48 3-.73 4.6-.73 1.6 0 3.15.25 4.6.72v3.1c0 .39.23.74.56.9.98.49 1.87 1.12 2.67 1.85.18.18.43.28.7.28.28 0 .53-.11.71-.29l2.48-2.48c.18-.18.29-.43.29-.71s-.12-.52-.3-.7z"
})), 'PhoneMissed');

exports.default = _default;

/***/ }),
/* 1967 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M17 3h-2v7h2V3zm3 12.5c-1.25 0-2.45-.2-3.57-.57-.35-.11-.74-.03-1.02.24l-2.2 2.2c-2.83-1.44-5.15-3.75-6.59-6.59l2.2-2.21c.28-.26.36-.65.25-1C8.7 6.45 8.5 5.25 8.5 4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.5c0-.55-.45-1-1-1zM19 3v7h2V3h-2z"
})), 'PhonePaused');

exports.default = _default;

/***/ }),
/* 1968 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M21 19V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2zM8.5 13.5l2.5 3.01L14.5 12l4.5 6H5l3.5-4.5z"
})), 'Photo');

exports.default = _default;

/***/ }),
/* 1969 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M18 2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM6 4h5v8l-2.5-1.5L6 12V4zm0 15l3-3.86 2.14 2.58 3-3.86L18 19H6z"
})), 'PhotoAlbum');

exports.default = _default;

/***/ }),
/* 1970 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("circle", {
  cx: "12",
  cy: "12",
  r: "3.2"
}), _react.default.createElement("path", {
  d: "M9 2L7.17 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2h-3.17L15 2H9zm3 15c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5z"
})), 'PhotoCamera');

exports.default = _default;

/***/ }),
/* 1971 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M19.02 10v9H5V5h9V3H5.02c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-9h-2zM17 10l.94-2.06L20 7l-2.06-.94L17 4l-.94 2.06L14 7l2.06.94zm-3.75.75L12 8l-1.25 2.75L8 12l2.75 1.25L12 16l1.25-2.75L16 12z"
})), 'PhotoFilter');

exports.default = _default;

/***/ }),
/* 1972 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M22 16V4c0-1.1-.9-2-2-2H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2zm-11-4l2.03 2.71L16 11l4 5H8l3-4zM2 6v14c0 1.1.9 2 2 2h14v-2H4V6H2z"
})), 'PhotoLibrary');

exports.default = _default;

/***/ }),
/* 1973 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M21 3H3C2 3 1 4 1 5v14c0 1.1.9 2 2 2h18c1 0 2-1 2-2V5c0-1-1-2-2-2zM5 17l3.5-4.5 2.5 3.01L14.5 11l4.5 6H5z"
})), 'PhotoSizeSelectActual');

exports.default = _default;

/***/ }),
/* 1974 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M21 15h2v2h-2v-2zm0-4h2v2h-2v-2zm2 8h-2v2c1 0 2-1 2-2zM13 3h2v2h-2V3zm8 4h2v2h-2V7zm0-4v2h2c0-1-1-2-2-2zM1 7h2v2H1V7zm16-4h2v2h-2V3zm0 16h2v2h-2v-2zM3 3C2 3 1 4 1 5h2V3zm6 0h2v2H9V3zM5 3h2v2H5V3zm-4 8v8c0 1.1.9 2 2 2h12V11H1zm2 8l2.5-3.21 1.79 2.15 2.5-3.22L13 19H3z"
})), 'PhotoSizeSelectLarge');

exports.default = _default;

/***/ }),
/* 1975 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M23 15h-2v2h2v-2zm0-4h-2v2h2v-2zm0 8h-2v2c1 0 2-1 2-2zM15 3h-2v2h2V3zm8 4h-2v2h2V7zm-2-4v2h2c0-1-1-2-2-2zM3 21h8v-6H1v4c0 1.1.9 2 2 2zM3 7H1v2h2V7zm12 12h-2v2h2v-2zm4-16h-2v2h2V3zm0 16h-2v2h2v-2zM3 3C2 3 1 4 1 5h2V3zm0 8H1v2h2v-2zm8-8H9v2h2V3zM7 3H5v2h2V3z"
})), 'PhotoSizeSelectSmall');

exports.default = _default;

/***/ }),
/* 1976 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20 2H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-8.5 7.5c0 .83-.67 1.5-1.5 1.5H9v2H7.5V7H10c.83 0 1.5.67 1.5 1.5v1zm5 2c0 .83-.67 1.5-1.5 1.5h-2.5V7H15c.83 0 1.5.67 1.5 1.5v3zm4-3H19v1h1.5V11H19v2h-1.5V7h3v1.5zM9 9.5h1v-1H9v1zM4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm10 5.5h1v-3h-1v3z"
})), 'PictureAsPdf');

exports.default = _default;

/***/ }),
/* 1977 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M19 7h-8v6h8V7zm2-4H3c-1.1 0-2 .9-2 2v14c0 1.1.9 1.98 2 1.98h18c1.1 0 2-.88 2-1.98V5c0-1.1-.9-2-2-2zm0 16.01H3V4.98h18v14.03z"
})), 'PictureInPicture');

exports.default = _default;

/***/ }),
/* 1978 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M19 11h-8v6h8v-6zm4 8V4.98C23 3.88 22.1 3 21 3H3c-1.1 0-2 .88-2 1.98V19c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2zm-2 .02H3V4.97h18v14.05z"
})), 'PictureInPictureAlt');

exports.default = _default;

/***/ }),
/* 1979 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M11 2v20c-5.07-.5-9-4.79-9-10s3.93-9.5 9-10zm2.03 0v8.99H22c-.47-4.74-4.24-8.52-8.97-8.99zm0 11.01V22c4.74-.47 8.5-4.25 8.97-8.99h-8.97z"
})), 'PieChart');

exports.default = _default;

/***/ }),
/* 1980 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10S17.5 2 12 2zm1 2.07c3.61.45 6.48 3.33 6.93 6.93H13V4.07zM4 12c0-4.06 3.07-7.44 7-7.93v15.87c-3.93-.5-7-3.88-7-7.94zm9 7.93V13h6.93c-.45 3.61-3.32 6.48-6.93 6.93z"
})), 'PieChartOutlined');

exports.default = _default;

/***/ }),
/* 1981 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M18 8c0-3.31-2.69-6-6-6S6 4.69 6 8c0 4.5 6 11 6 11s6-6.5 6-11zm-8 0c0-1.1.9-2 2-2s2 .9 2 2-.89 2-2 2c-1.1 0-2-.9-2-2zM5 20v2h14v-2H5z"
})), 'PinDrop');

exports.default = _default;

/***/ }),
/* 1982 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"
})), 'Place');

exports.default = _default;

/***/ }),
/* 1983 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M8 5v14l11-7z"
})), 'PlayArrow');

exports.default = _default;

/***/ }),
/* 1984 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 14.5v-9l6 4.5-6 4.5z"
})), 'PlayCircleFilled');

exports.default = _default;

/***/ }),
/* 1985 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M10 16.5l6-4.5-6-4.5v9zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
})), 'PlayCircleOutline');

exports.default = _default;

/***/ }),
/* 1986 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M11 5v5.59H7.5l4.5 4.5 4.5-4.5H13V5h-2zm-5 9c0 3.31 2.69 6 6 6s6-2.69 6-6h-2c0 2.21-1.79 4-4 4s-4-1.79-4-4H6z"
})), 'PlayForWork');

exports.default = _default;

/***/ }),
/* 1987 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M14 10H2v2h12v-2zm0-4H2v2h12V6zm4 8v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zM2 16h8v-2H2v2z"
})), 'PlaylistAdd');

exports.default = _default;

/***/ }),
/* 1988 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M14 10H2v2h12v-2zm0-4H2v2h12V6zM2 16h8v-2H2v2zm19.5-4.5L23 13l-6.99 7-4.51-4.5L13 14l3.01 3 5.49-5.5z"
})), 'PlaylistAddCheck');

exports.default = _default;

/***/ }),
/* 1989 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M19 9H2v2h17V9zm0-4H2v2h17V5zM2 15h13v-2H2v2zm15-2v6l5-3-5-3z"
})), 'PlaylistPlay');

exports.default = _default;

/***/ }),
/* 1990 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M10 8H8v4H4v2h4v4h2v-4h4v-2h-4zm4.5-1.92V7.9l2.5-.5V18h2V5z"
})), 'PlusOne');

exports.default = _default;

/***/ }),
/* 1991 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM9 17H7v-7h2v7zm4 0h-2V7h2v10zm4 0h-2v-4h2v4z"
})), 'Poll');

exports.default = _default;

/***/ }),
/* 1992 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M19 4h-4L7.11 16.63 4.5 12 9 4H5L.5 12 5 20h4l7.89-12.63L19.5 12 15 20h4l4.5-8z"
})), 'Polymer');

exports.default = _default;

/***/ }),
/* 1993 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M22 21c-1.11 0-1.73-.37-2.18-.64-.37-.22-.6-.36-1.15-.36-.56 0-.78.13-1.15.36-.46.27-1.07.64-2.18.64s-1.73-.37-2.18-.64c-.37-.22-.6-.36-1.15-.36-.56 0-.78.13-1.15.36-.46.27-1.08.64-2.19.64-1.11 0-1.73-.37-2.18-.64-.37-.23-.6-.36-1.15-.36s-.78.13-1.15.36c-.46.27-1.08.64-2.19.64v-2c.56 0 .78-.13 1.15-.36.46-.27 1.08-.64 2.19-.64s1.73.37 2.18.64c.37.23.59.36 1.15.36.56 0 .78-.13 1.15-.36.46-.27 1.08-.64 2.19-.64 1.11 0 1.73.37 2.18.64.37.22.6.36 1.15.36s.78-.13 1.15-.36c.45-.27 1.07-.64 2.18-.64s1.73.37 2.18.64c.37.23.59.36 1.15.36v2zm0-4.5c-1.11 0-1.73-.37-2.18-.64-.37-.22-.6-.36-1.15-.36-.56 0-.78.13-1.15.36-.45.27-1.07.64-2.18.64s-1.73-.37-2.18-.64c-.37-.22-.6-.36-1.15-.36-.56 0-.78.13-1.15.36-.45.27-1.07.64-2.18.64s-1.73-.37-2.18-.64c-.37-.22-.6-.36-1.15-.36s-.78.13-1.15.36c-.47.27-1.09.64-2.2.64v-2c.56 0 .78-.13 1.15-.36.45-.27 1.07-.64 2.18-.64s1.73.37 2.18.64c.37.22.6.36 1.15.36.56 0 .78-.13 1.15-.36.45-.27 1.07-.64 2.18-.64s1.73.37 2.18.64c.37.22.6.36 1.15.36s.78-.13 1.15-.36c.45-.27 1.07-.64 2.18-.64s1.73.37 2.18.64c.37.22.6.36 1.15.36v2zM8.67 12c.56 0 .78-.13 1.15-.36.46-.27 1.08-.64 2.19-.64 1.11 0 1.73.37 2.18.64.37.22.6.36 1.15.36s.78-.13 1.15-.36c.12-.07.26-.15.41-.23L10.48 5C8.93 3.45 7.5 2.99 5 3v2.5c1.82-.01 2.89.39 4 1.5l1 1-3.25 3.25c.31.12.56.27.77.39.37.23.59.36 1.15.36z"
}), _react.default.createElement("circle", {
  cx: "16.5",
  cy: "5.5",
  r: "2.5"
})), 'Pool');

exports.default = _default;

/***/ }),
/* 1994 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M17.56 14.24c.28-.69.44-1.45.44-2.24 0-3.31-2.69-6-6-6-.79 0-1.55.16-2.24.44l1.62 1.62c.2-.03.41-.06.62-.06 2.21 0 4 1.79 4 4 0 .21-.02.42-.05.63l1.61 1.61zM12 4c4.42 0 8 3.58 8 8 0 1.35-.35 2.62-.95 3.74l1.47 1.47C21.46 15.69 22 13.91 22 12c0-5.52-4.48-10-10-10-1.91 0-3.69.55-5.21 1.47l1.46 1.46C9.37 4.34 10.65 4 12 4zM3.27 2.5L2 3.77l2.1 2.1C2.79 7.57 2 9.69 2 12c0 3.7 2.01 6.92 4.99 8.65l1-1.73C5.61 17.53 4 14.96 4 12c0-1.76.57-3.38 1.53-4.69l1.43 1.44C6.36 9.68 6 10.8 6 12c0 2.22 1.21 4.15 3 5.19l1-1.74c-1.19-.7-2-1.97-2-3.45 0-.65.17-1.25.44-1.79l1.58 1.58L10 12c0 1.1.9 2 2 2l.21-.02.01.01 7.51 7.51L21 20.23 4.27 3.5l-1-1z"
})), 'PortableWifiOff');

exports.default = _default;

/***/ }),
/* 1995 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 12.25c1.24 0 2.25-1.01 2.25-2.25S13.24 7.75 12 7.75 9.75 8.76 9.75 10s1.01 2.25 2.25 2.25zm4.5 4c0-1.5-3-2.25-4.5-2.25s-4.5.75-4.5 2.25V17h9v-.75zM19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14z"
})), 'Portrait');

exports.default = _default;

/***/ }),
/* 1996 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M16.01 7L16 3h-2v4h-4V3H8v4h-.01C7 6.99 6 7.99 6 8.99v5.49L9.5 18v3h5v-3l3.5-3.51v-5.5c0-1-1-2-1.99-1.99z"
})), 'Power');

exports.default = _default;

/***/ }),
/* 1997 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M2 9v2h19V9H2zm0 6h5v-2H2v2zm7 0h5v-2H9v2zm7 0h5v-2h-5v2z"
})), 'PowerInput');

exports.default = _default;

/***/ }),
/* 1998 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M13 3h-2v10h2V3zm4.83 2.17l-1.42 1.42C17.99 7.86 19 9.81 19 12c0 3.87-3.13 7-7 7s-7-3.13-7-7c0-2.19 1.01-4.14 2.58-5.42L6.17 5.17C4.23 6.82 3 9.26 3 12c0 4.97 4.03 9 9 9s9-4.03 9-9c0-2.74-1.23-5.18-3.17-6.83z"
})), 'PowerSettingsNew');

exports.default = _default;

/***/ }),
/* 1999 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M9 4c0-1.11.89-2 2-2s2 .89 2 2-.89 2-2 2-2-.89-2-2zm7 9c-.01-1.34-.83-2.51-2-3 0-1.66-1.34-3-3-3s-3 1.34-3 3v7h2v5h3v-5h3v-4z"
})), 'PregnantWoman');

exports.default = _default;

/***/ }),
/* 2000 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M21 3H3c-1.11 0-2 .89-2 2v14c0 1.11.89 2 2 2h18c1.11 0 2-.89 2-2V5c0-1.11-.89-2-2-2zm0 16.02H3V4.98h18v14.04zM10 12H8l4-4 4 4h-2v4h-4v-4z"
})), 'PresentToAll');

exports.default = _default;

/***/ }),
/* 2001 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M19 8H5c-1.66 0-3 1.34-3 3v6h4v4h12v-4h4v-6c0-1.66-1.34-3-3-3zm-3 11H8v-5h8v5zm3-7c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm-1-9H6v4h12V3z"
})), 'Print');

exports.default = _default;

/***/ }),
/* 2002 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("circle", {
  cx: "12",
  cy: "19",
  r: "2"
}), _react.default.createElement("path", {
  d: "M10 3h4v12h-4z"
})), 'PriorityHigh');

exports.default = _default;

/***/ }),
/* 2003 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.95-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L9 15v1c0 1.1.9 2 2 2v1.93zm6.9-2.54c-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H8v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41c2.93 1.19 5 4.06 5 7.41 0 2.08-.8 3.97-2.1 5.39z"
})), 'Public');

exports.default = _default;

/***/ }),
/* 2004 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M5 4v2h14V4H5zm0 10h4v6h6v-6h4l-7-7-7 7z"
})), 'Publish');

exports.default = _default;

/***/ }),
/* 2005 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67z"
})), 'QueryBuilder');

exports.default = _default;

/***/ }),
/* 2006 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M21 6h-2v9H6v2c0 .55.45 1 1 1h11l4 4V7c0-.55-.45-1-1-1zm-4 6V3c0-.55-.45-1-1-1H3c-.55 0-1 .45-1 1v14l4-4h10c.55 0 1-.45 1-1z"
})), 'QuestionAnswer');

exports.default = _default;

/***/ }),
/* 2007 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm16-4H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-1 9h-4v4h-2v-4H9V9h4V5h2v4h4v2z"
})), 'Queue');

exports.default = _default;

/***/ }),
/* 2008 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M15 6H3v2h12V6zm0 4H3v2h12v-2zM3 16h8v-2H3v2zM17 6v8.18c-.31-.11-.65-.18-1-.18-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3V8h3V6h-5z"
})), 'QueueMusic');

exports.default = _default;

/***/ }),
/* 2009 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M21 3H3c-1.11 0-2 .89-2 2v12c0 1.1.89 2 2 2h5v2h8v-2h2v-2H3V5h18v8h2V5c0-1.11-.9-2-2-2zm-8 7V7h-2v3H8v2h3v3h2v-3h3v-2h-3zm11 8l-4.5 4.5L18 21l3-3-3-3 1.5-1.5L24 18z"
})), 'QueuePlayNext');

exports.default = _default;

/***/ }),
/* 2010 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M3.24 6.15C2.51 6.43 2 7.17 2 8v12c0 1.1.89 2 2 2h16c1.11 0 2-.9 2-2V8c0-1.11-.89-2-2-2H8.3l8.26-3.34L15.88 1 3.24 6.15zM7 20c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3zm13-8h-2v-2h-2v2H4V8h16v4z"
})), 'Radio');

exports.default = _default;

/***/ }),
/* 2011 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 7c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5zm0-5C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
})), 'RadioButtonChecked');

exports.default = _default;

/***/ }),
/* 2012 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
})), 'RadioButtonUnchecked');

exports.default = _default;

/***/ }),
/* 2013 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM6 14v-2.47l6.88-6.88c.2-.2.51-.2.71 0l1.77 1.77c.2.2.2.51 0 .71L8.47 14H6zm12 0h-7.5l2-2H18v2z"
})), 'RateReview');

exports.default = _default;

/***/ }),
/* 2014 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M18 17H6v-2h12v2zm0-4H6v-2h12v2zm0-4H6V7h12v2zM3 22l1.5-1.5L6 22l1.5-1.5L9 22l1.5-1.5L12 22l1.5-1.5L15 22l1.5-1.5L18 22l1.5-1.5L21 22V2l-1.5 1.5L18 2l-1.5 1.5L15 2l-1.5 1.5L12 2l-1.5 1.5L9 2 7.5 3.5 6 2 4.5 3.5 3 2v20z"
})), 'Receipt');

exports.default = _default;

/***/ }),
/* 2015 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M21 5v14h2V5h-2zm-4 14h2V5h-2v14zM14 5H2c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h12c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1zM8 7.75c1.24 0 2.25 1.01 2.25 2.25S9.24 12.25 8 12.25 5.75 11.24 5.75 10 6.76 7.75 8 7.75zM12.5 17h-9v-.75c0-1.5 3-2.25 4.5-2.25s4.5.75 4.5 2.25V17z"
})), 'RecentActors');

exports.default = _default;

/***/ }),
/* 2016 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("circle", {
  cx: "9",
  cy: "9",
  r: "4"
}), _react.default.createElement("path", {
  d: "M9 15c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4zm7.76-9.64l-1.68 1.69c.84 1.18.84 2.71 0 3.89l1.68 1.69c2.02-2.02 2.02-5.07 0-7.27zM20.07 2l-1.63 1.63c2.77 3.02 2.77 7.56 0 10.74L20.07 16c3.9-3.89 3.91-9.95 0-14z"
})), 'RecordVoiceOver');

exports.default = _default;

/***/ }),
/* 2017 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20 6h-2.18c.11-.31.18-.65.18-1 0-1.66-1.34-3-3-3-1.05 0-1.96.54-2.5 1.35l-.5.67-.5-.68C10.96 2.54 10.05 2 9 2 7.34 2 6 3.34 6 5c0 .35.07.69.18 1H4c-1.11 0-1.99.89-1.99 2L2 19c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zm-5-2c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zM9 4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm11 15H4v-2h16v2zm0-5H4V8h5.08L7 10.83 8.62 12 11 8.76l1-1.36 1 1.36L15.38 12 17 10.83 14.92 8H20v6z"
})), 'Redeem');

exports.default = _default;

/***/ }),
/* 2018 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M18.4 10.6C16.55 8.99 14.15 8 11.5 8c-4.65 0-8.58 3.03-9.96 7.22L3.9 16c1.05-3.19 4.05-5.5 7.6-5.5 1.95 0 3.73.72 5.12 1.88L13 16h9V7l-3.6 3.6z"
})), 'Redo');

exports.default = _default;

/***/ }),
/* 2019 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M17.65 6.35C16.2 4.9 14.21 4 12 4c-4.42 0-7.99 3.58-7.99 8s3.57 8 7.99 8c3.73 0 6.84-2.55 7.73-6h-2.08c-.82 2.33-3.04 4-5.65 4-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0 3.14.69 4.22 1.78L13 11h7V4l-2.35 2.35z"
})), 'Refresh');

exports.default = _default;

/***/ }),
/* 2020 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M19 13H5v-2h14v2z"
})), 'Remove');

exports.default = _default;

/***/ }),
/* 2021 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm5 11H7v-2h10v2z"
})), 'RemoveCircle');

exports.default = _default;

/***/ }),
/* 2022 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M7 11v2h10v-2H7zm5-9C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
})), 'RemoveCircleOutline');

exports.default = _default;

/***/ }),
/* 2023 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M21 3H3c-1.11 0-2 .89-2 2v12c0 1.1.89 2 2 2h5v2h8v-2h5c1.1 0 1.99-.9 1.99-2L23 5c0-1.11-.9-2-2-2zm0 14H3V5h18v12zm-5-7v2H8v-2h8z"
})), 'RemoveFromQueue');

exports.default = _default;

/***/ }),
/* 2024 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"
})), 'RemoveRedEye');

exports.default = _default;

/***/ }),
/* 2025 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M22.73 22.73L2.77 2.77 2 2l-.73-.73L0 2.54l4.39 4.39 2.21 4.66-1.35 2.45c-.16.28-.25.61-.25.96 0 1.1.9 2 2 2h7.46l1.38 1.38c-.5.36-.83.95-.83 1.62 0 1.1.89 2 1.99 2 .67 0 1.26-.33 1.62-.84L21.46 24l1.27-1.27zM7.42 15c-.14 0-.25-.11-.25-.25l.03-.12.9-1.63h2.36l2 2H7.42zm8.13-2c.75 0 1.41-.41 1.75-1.03l3.58-6.49c.08-.14.12-.31.12-.48 0-.55-.45-1-1-1H6.54l9.01 9zM7 18c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2z"
})), 'RemoveShoppingCart');

exports.default = _default;

/***/ }),
/* 2026 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M3 15h18v-2H3v2zm0 4h18v-2H3v2zm0-8h18V9H3v2zm0-6v2h18V5H3z"
})), 'Reorder');

exports.default = _default;

/***/ }),
/* 2027 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M7 7h10v3l4-4-4-4v3H5v6h2V7zm10 10H7v-3l-4 4 4 4v-3h12v-6h-2v4z"
})), 'Repeat');

exports.default = _default;

/***/ }),
/* 2028 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M7 7h10v3l4-4-4-4v3H5v6h2V7zm10 10H7v-3l-4 4 4 4v-3h12v-6h-2v4zm-4-2V9h-1l-2 1v1h1.5v4H13z"
})), 'RepeatOne');

exports.default = _default;

/***/ }),
/* 2029 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 5V1L7 6l5 5V7c3.31 0 6 2.69 6 6s-2.69 6-6 6-6-2.69-6-6H4c0 4.42 3.58 8 8 8s8-3.58 8-8-3.58-8-8-8z"
})), 'Replay');

exports.default = _default;

/***/ }),
/* 2030 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 5V1L7 6l5 5V7c3.3 0 6 2.7 6 6s-2.7 6-6 6-6-2.7-6-6H4c0 4.4 3.6 8 8 8s8-3.6 8-8-3.6-8-8-8zm-1.1 11H10v-3.3L9 13v-.7l1.8-.6h.1V16zm4.3-1.8c0 .3 0 .6-.1.8l-.3.6s-.3.3-.5.3-.4.1-.6.1-.4 0-.6-.1-.3-.2-.5-.3-.2-.3-.3-.6-.1-.5-.1-.8v-.7c0-.3 0-.6.1-.8l.3-.6s.3-.3.5-.3.4-.1.6-.1.4 0 .6.1c.2.1.3.2.5.3s.2.3.3.6.1.5.1.8v.7zm-.9-.8v-.5s-.1-.2-.1-.3-.1-.1-.2-.2-.2-.1-.3-.1-.2 0-.3.1l-.2.2s-.1.2-.1.3v2s.1.2.1.3.1.1.2.2.2.1.3.1.2 0 .3-.1l.2-.2s.1-.2.1-.3v-1.5z"
})), 'Replay10');

exports.default = _default;

/***/ }),
/* 2031 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 5V1L7 6l5 5V7c3.3 0 6 2.7 6 6s-2.7 6-6 6-6-2.7-6-6H4c0 4.4 3.6 8 8 8s8-3.6 8-8-3.6-8-8-8zm-2.4 8.5h.4c.2 0 .4-.1.5-.2s.2-.2.2-.4v-.2s-.1-.1-.1-.2-.1-.1-.2-.1h-.5s-.1.1-.2.1-.1.1-.1.2v.2h-1c0-.2 0-.3.1-.5s.2-.3.3-.4.3-.2.4-.2.4-.1.5-.1c.2 0 .4 0 .6.1s.3.1.5.2.2.2.3.4.1.3.1.5v.3s-.1.2-.1.3-.1.2-.2.2-.2.1-.3.2c.2.1.4.2.5.4s.2.4.2.6c0 .2 0 .4-.1.5s-.2.3-.3.4-.3.2-.5.2-.4.1-.6.1c-.2 0-.4 0-.5-.1s-.3-.1-.5-.2-.2-.2-.3-.4-.1-.4-.1-.6h.8v.2s.1.1.1.2.1.1.2.1h.5s.1-.1.2-.1.1-.1.1-.2v-.5s-.1-.1-.1-.2-.1-.1-.2-.1h-.6v-.7zm5.7.7c0 .3 0 .6-.1.8l-.3.6s-.3.3-.5.3-.4.1-.6.1-.4 0-.6-.1-.3-.2-.5-.3-.2-.3-.3-.6-.1-.5-.1-.8v-.7c0-.3 0-.6.1-.8l.3-.6s.3-.3.5-.3.4-.1.6-.1.4 0 .6.1.3.2.5.3.2.3.3.6.1.5.1.8v.7zm-.8-.8v-.5c0-.1-.1-.2-.1-.3s-.1-.1-.2-.2-.2-.1-.3-.1-.2 0-.3.1l-.2.2s-.1.2-.1.3v2s.1.2.1.3.1.1.2.2.2.1.3.1.2 0 .3-.1l.2-.2s.1-.2.1-.3v-1.5z"
})), 'Replay30');

exports.default = _default;

/***/ }),
/* 2032 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 5V1L7 6l5 5V7c3.3 0 6 2.7 6 6s-2.7 6-6 6-6-2.7-6-6H4c0 4.4 3.6 8 8 8s8-3.6 8-8-3.6-8-8-8zm-1.3 8.9l.2-2.2h2.4v.7h-1.7l-.1.9s.1 0 .1-.1.1 0 .1-.1.1 0 .2 0h.2c.2 0 .4 0 .5.1s.3.2.4.3.2.3.3.5.1.4.1.6c0 .2 0 .4-.1.5s-.1.3-.3.5-.3.2-.4.3-.4.1-.6.1c-.2 0-.4 0-.5-.1s-.3-.1-.5-.2-.2-.2-.3-.4-.1-.3-.1-.5h.8c0 .2.1.3.2.4s.2.1.4.1c.1 0 .2 0 .3-.1l.2-.2s.1-.2.1-.3v-.6l-.1-.2-.2-.2s-.2-.1-.3-.1h-.2s-.1 0-.2.1-.1 0-.1.1-.1.1-.1.1h-.7z"
})), 'Replay5');

exports.default = _default;

/***/ }),
/* 2033 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M10 9V5l-7 7 7 7v-4.1c5 0 8.5 1.6 11 5.1-1-5-4-10-11-11z"
})), 'Reply');

exports.default = _default;

/***/ }),
/* 2034 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M7 8V5l-7 7 7 7v-3l-4-4 4-4zm6 1V5l-7 7 7 7v-4.1c5 0 8.5 1.6 11 5.1-1-5-4-10-11-11z"
})), 'ReplyAll');

exports.default = _default;

/***/ }),
/* 2035 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M15.73 3H8.27L3 8.27v7.46L8.27 21h7.46L21 15.73V8.27L15.73 3zM12 17.3c-.72 0-1.3-.58-1.3-1.3 0-.72.58-1.3 1.3-1.3.72 0 1.3.58 1.3 1.3 0 .72-.58 1.3-1.3 1.3zm1-4.3h-2V7h2v6z"
})), 'Report');

exports.default = _default;

/***/ }),
/* 2036 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"
})), 'ReportProblem');

exports.default = _default;

/***/ }),
/* 2037 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M11 9H9V2H7v7H5V2H3v7c0 2.12 1.66 3.84 3.75 3.97V22h2.5v-9.03C11.34 12.84 13 11.12 13 9V2h-2v7zm5-3v8h2.5v8H21V2c-2.76 0-5 2.24-5 4z"
})), 'Restaurant');

exports.default = _default;

/***/ }),
/* 2038 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M8.1 13.34l2.83-2.83L3.91 3.5c-1.56 1.56-1.56 4.09 0 5.66l4.19 4.18zm6.78-1.81c1.53.71 3.68.21 5.27-1.38 1.91-1.91 2.28-4.65.81-6.12-1.46-1.46-4.2-1.1-6.12.81-1.59 1.59-2.09 3.74-1.38 5.27L3.7 19.87l1.41 1.41L12 14.41l6.88 6.88 1.41-1.41L13.41 13l1.47-1.47z"
})), 'RestaurantMenu');

exports.default = _default;

/***/ }),
/* 2039 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M13 3c-4.97 0-9 4.03-9 9H1l3.89 3.89.07.14L9 12H6c0-3.87 3.13-7 7-7s7 3.13 7 7-3.13 7-7 7c-1.93 0-3.68-.79-4.94-2.06l-1.42 1.42C8.27 19.99 10.51 21 13 21c4.97 0 9-4.03 9-9s-4.03-9-9-9zm-1 5v5l4.28 2.54.72-1.21-3.5-2.08V8H12z"
})), 'Restore');

exports.default = _default;

/***/ }),
/* 2040 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm-2 16c-2.05 0-3.81-1.24-4.58-3h1.71c.63.9 1.68 1.5 2.87 1.5 1.93 0 3.5-1.57 3.5-3.5S13.93 9.5 12 9.5c-1.35 0-2.52.78-3.1 1.9l1.6 1.6h-4V9l1.3 1.3C8.69 8.92 10.23 8 12 8c2.76 0 5 2.24 5 5s-2.24 5-5 5z"
})), 'RestorePage');

exports.default = _default;

/***/ }),
/* 2041 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M23.71 16.67C20.66 13.78 16.54 12 12 12 7.46 12 3.34 13.78.29 16.67c-.18.18-.29.43-.29.71 0 .28.11.53.29.71l2.48 2.48c.18.18.43.29.71.29.27 0 .52-.11.7-.28.79-.74 1.69-1.36 2.66-1.85.33-.16.56-.5.56-.9v-3.1c1.45-.48 3-.73 4.6-.73s3.15.25 4.6.72v3.1c0 .39.23.74.56.9.98.49 1.87 1.12 2.66 1.85.18.18.43.28.7.28.28 0 .53-.11.71-.29l2.48-2.48c.18-.18.29-.43.29-.71 0-.27-.11-.52-.29-.7zM21.16 6.26l-1.41-1.41-3.56 3.55 1.41 1.41s3.45-3.52 3.56-3.55zM13 2h-2v5h2V2zM6.4 9.81L7.81 8.4 4.26 4.84 2.84 6.26c.11.03 3.56 3.55 3.56 3.55z"
})), 'RingVolume');

exports.default = _default;

/***/ }),
/* 2042 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"
})), 'Room');

exports.default = _default;

/***/ }),
/* 2043 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M2 17h20v2H2zm11.84-9.21c.1-.24.16-.51.16-.79 0-1.1-.9-2-2-2s-2 .9-2 2c0 .28.06.55.16.79C6.25 8.6 3.27 11.93 3 16h18c-.27-4.07-3.25-7.4-7.16-8.21z"
})), 'RoomService');

exports.default = _default;

/***/ }),
/* 2044 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M7.34 6.41L.86 12.9l6.49 6.48 6.49-6.48-6.5-6.49zM3.69 12.9l3.66-3.66L11 12.9l-3.66 3.66-3.65-3.66zm15.67-6.26C17.61 4.88 15.3 4 13 4V.76L8.76 5 13 9.24V6c1.79 0 3.58.68 4.95 2.05 2.73 2.73 2.73 7.17 0 9.9C16.58 19.32 14.79 20 13 20c-.97 0-1.94-.21-2.84-.61l-1.49 1.49C10.02 21.62 11.51 22 13 22c2.3 0 4.61-.88 6.36-2.64 3.52-3.51 3.52-9.21 0-12.72z"
})), 'Rotate90DegreesCcw');

exports.default = _default;

/***/ }),
/* 2045 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M7.11 8.53L5.7 7.11C4.8 8.27 4.24 9.61 4.07 11h2.02c.14-.87.49-1.72 1.02-2.47zM6.09 13H4.07c.17 1.39.72 2.73 1.62 3.89l1.41-1.42c-.52-.75-.87-1.59-1.01-2.47zm1.01 5.32c1.16.9 2.51 1.44 3.9 1.61V17.9c-.87-.15-1.71-.49-2.46-1.03L7.1 18.32zM13 4.07V1L8.45 5.55 13 10V6.09c2.84.48 5 2.94 5 5.91s-2.16 5.43-5 5.91v2.02c3.95-.49 7-3.85 7-7.93s-3.05-7.44-7-7.93z"
})), 'RotateLeft');

exports.default = _default;

/***/ }),
/* 2046 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M15.55 5.55L11 1v3.07C7.06 4.56 4 7.92 4 12s3.05 7.44 7 7.93v-2.02c-2.84-.48-5-2.94-5-5.91s2.16-5.43 5-5.91V10l4.55-4.45zM19.93 11c-.17-1.39-.72-2.73-1.62-3.89l-1.42 1.42c.54.75.88 1.6 1.02 2.47h2.02zM13 17.9v2.02c1.39-.17 2.74-.71 3.9-1.61l-1.44-1.44c-.75.54-1.59.89-2.46 1.03zm3.89-2.42l1.42 1.41c.9-1.16 1.45-2.5 1.62-3.89h-2.02c-.14.87-.48 1.72-1.02 2.48z"
})), 'RotateRight');

exports.default = _default;

/***/ }),
/* 2047 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M19 19h2v2h-2v-2zm0-2h2v-2h-2v2zM3 13h2v-2H3v2zm0 4h2v-2H3v2zm0-8h2V7H3v2zm0-4h2V3H3v2zm4 0h2V3H7v2zm8 16h2v-2h-2v2zm-4 0h2v-2h-2v2zm4 0h2v-2h-2v2zm-8 0h2v-2H7v2zm-4 0h2v-2H3v2zM21 8c0-2.76-2.24-5-5-5h-5v2h5c1.65 0 3 1.35 3 3v5h2V8z"
})), 'RoundedCorner');

exports.default = _default;

/***/ }),
/* 2048 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20.2 5.9l.8-.8C19.6 3.7 17.8 3 16 3s-3.6.7-5 2.1l.8.8C13 4.8 14.5 4.2 16 4.2s3 .6 4.2 1.7zm-.9.8c-.9-.9-2.1-1.4-3.3-1.4s-2.4.5-3.3 1.4l.8.8c.7-.7 1.6-1 2.5-1 .9 0 1.8.3 2.5 1l.8-.8zM19 13h-2V9h-2v4H5c-1.1 0-2 .9-2 2v4c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-4c0-1.1-.9-2-2-2zM8 18H6v-2h2v2zm3.5 0h-2v-2h2v2zm3.5 0h-2v-2h2v2z"
})), 'Router');

exports.default = _default;

/***/ }),
/* 2049 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M8.5 14.5L4 19l1.5 1.5L9 17h2l-2.5-2.5zM15 1c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm6 20.01L18 24l-2.99-3.01V19.5l-7.1-7.09c-.31.05-.61.07-.91.07v-2.16c1.66.03 3.61-.87 4.67-2.04l1.4-1.55c.19-.21.43-.38.69-.5.29-.14.62-.23.96-.23h.03C15.99 6.01 17 7.02 17 8.26v5.75c0 .84-.35 1.61-.92 2.16l-3.58-3.58v-2.27c-.63.52-1.43 1.02-2.29 1.39L16.5 18H18l3 3.01z"
})), 'Rowing');

exports.default = _default;

/***/ }),
/* 2050 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("circle", {
  cx: "6.18",
  cy: "17.82",
  r: "2.18"
}), _react.default.createElement("path", {
  d: "M4 4.44v2.83c7.03 0 12.73 5.7 12.73 12.73h2.83c0-8.59-6.97-15.56-15.56-15.56zm0 5.66v2.83c3.9 0 7.07 3.17 7.07 7.07h2.83c0-5.47-4.43-9.9-9.9-9.9z"
})), 'RssFeed');

exports.default = _default;

/***/ }),
/* 2051 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20 17v-6c0-1.1-.9-2-2-2H7V7l-3 3 3 3v-2h4v3H4v3c0 1.1.9 2 2 2h2c0 1.66 1.34 3 3 3s3-1.34 3-3h8v-2h-2zm-9 3c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm7-6h-4v-3h4v3zM17 2v2H9v2h8v2l3-3z"
})), 'RvHookup');

exports.default = _default;

/***/ }),
/* 2052 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM5 4.99h3C8 6.65 6.66 8 5 8V4.99zM5 12v-2c2.76 0 5-2.25 5-5.01h2C12 8.86 8.87 12 5 12zm0 6l3.5-4.5 2.5 3.01L14.5 12l4.5 6H5z"
})), 'Satellite');

exports.default = _default;

/***/ }),
/* 2053 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M17 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V7l-4-4zm-5 16c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3zm3-10H5V5h10v4z"
})), 'Save');

exports.default = _default;

/***/ }),
/* 2054 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M19.8 10.7L4.2 5l-.7 1.9L17.6 12H5c-1.1 0-2 .9-2 2v4c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-5.5c0-.8-.5-1.6-1.2-1.8zM7 17H5v-2h2v2zm12 0H9v-2h10v2z"
})), 'Scanner');

exports.default = _default;

/***/ }),
/* 2055 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67z"
})), 'Schedule');

exports.default = _default;

/***/ }),
/* 2056 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M5 13.18v4L12 21l7-3.82v-4L12 17l-7-3.82zM12 3L1 9l11 6 9-4.91V17h2V9L12 3z"
})), 'School');

exports.default = _default;

/***/ }),
/* 2057 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M21 5H3c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm-2 12H5V7h14v10zm-9-1h4c.55 0 1-.45 1-1v-3c0-.55-.45-1-1-1v-1c0-1.11-.9-2-2-2-1.11 0-2 .9-2 2v1c-.55 0-1 .45-1 1v3c0 .55.45 1 1 1zm.8-6c0-.66.54-1.2 1.2-1.2.66 0 1.2.54 1.2 1.2v1h-2.4v-1z"
})), 'ScreenLockLandscape');

exports.default = _default;

/***/ }),
/* 2058 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M10 16h4c.55 0 1-.45 1-1v-3c0-.55-.45-1-1-1v-1c0-1.11-.9-2-2-2-1.11 0-2 .9-2 2v1c-.55 0-1 .45-1 1v3c0 .55.45 1 1 1zm.8-6c0-.66.54-1.2 1.2-1.2.66 0 1.2.54 1.2 1.2v1h-2.4v-1zM17 1H7c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 18H7V5h10v14z"
})), 'ScreenLockPortrait');

exports.default = _default;

/***/ }),
/* 2059 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M23.25 12.77l-2.57-2.57-1.41 1.41 2.22 2.22-5.66 5.66L4.51 8.17l5.66-5.66 2.1 2.1 1.41-1.41L11.23.75c-.59-.59-1.54-.59-2.12 0L2.75 7.11c-.59.59-.59 1.54 0 2.12l12.02 12.02c.59.59 1.54.59 2.12 0l6.36-6.36c.59-.59.59-1.54 0-2.12zM8.47 20.48C5.2 18.94 2.86 15.76 2.5 12H1c.51 6.16 5.66 11 11.95 11l.66-.03-3.81-3.82-1.33 1.33zM16 9h5c.55 0 1-.45 1-1V4c0-.55-.45-1-1-1v-.5C21 1.12 19.88 0 18.5 0S16 1.12 16 2.5V3c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1zm.8-6.5c0-.94.76-1.7 1.7-1.7s1.7.76 1.7 1.7V3h-3.4v-.5z"
})), 'ScreenLockRotation');

exports.default = _default;

/***/ }),
/* 2060 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M16.48 2.52c3.27 1.55 5.61 4.72 5.97 8.48h1.5C23.44 4.84 18.29 0 12 0l-.66.03 3.81 3.81 1.33-1.32zm-6.25-.77c-.59-.59-1.54-.59-2.12 0L1.75 8.11c-.59.59-.59 1.54 0 2.12l12.02 12.02c.59.59 1.54.59 2.12 0l6.36-6.36c.59-.59.59-1.54 0-2.12L10.23 1.75zm4.6 19.44L2.81 9.17l6.36-6.36 12.02 12.02-6.36 6.36zm-7.31.29C4.25 19.94 1.91 16.76 1.55 13H.05C.56 19.16 5.71 24 12 24l.66-.03-3.81-3.81-1.33 1.32z"
})), 'ScreenRotation');

exports.default = _default;

/***/ }),
/* 2061 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20 18c1.1 0 1.99-.9 1.99-2L22 6c0-1.11-.9-2-2-2H4c-1.11 0-2 .89-2 2v10c0 1.1.89 2 2 2H0v2h24v-2h-4zm-7-3.53v-2.19c-2.78 0-4.61.85-6 2.72.56-2.67 2.11-5.33 6-5.87V7l4 3.73-4 3.74z"
})), 'ScreenShare');

exports.default = _default;

/***/ }),
/* 2062 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M18 2h-8L4.02 8 4 20c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-6 6h-2V4h2v4zm3 0h-2V4h2v4zm3 0h-2V4h2v4z"
})), 'SdCard');

exports.default = _default;

/***/ }),
/* 2063 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M18 2h-8L4.02 8 4 20c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-6 6h-2V4h2v4zm3 0h-2V4h2v4zm3 0h-2V4h2v4z"
})), 'SdStorage');

exports.default = _default;

/***/ }),
/* 2064 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"
})), 'Search');

exports.default = _default;

/***/ }),
/* 2065 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm0 10.99h7c-.53 4.12-3.28 7.79-7 8.94V12H5V6.3l7-3.11v8.8z"
})), 'Security');

exports.default = _default;

/***/ }),
/* 2066 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M3 5h2V3c-1.1 0-2 .9-2 2zm0 8h2v-2H3v2zm4 8h2v-2H7v2zM3 9h2V7H3v2zm10-6h-2v2h2V3zm6 0v2h2c0-1.1-.9-2-2-2zM5 21v-2H3c0 1.1.9 2 2 2zm-2-4h2v-2H3v2zM9 3H7v2h2V3zm2 18h2v-2h-2v2zm8-8h2v-2h-2v2zm0 8c1.1 0 2-.9 2-2h-2v2zm0-12h2V7h-2v2zm0 8h2v-2h-2v2zm-4 4h2v-2h-2v2zm0-16h2V3h-2v2zM7 17h10V7H7v10zm2-8h6v6H9V9z"
})), 'SelectAll');

exports.default = _default;

/***/ }),
/* 2067 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M2.01 21L23 12 2.01 3 2 10l15 2-15 2z"
})), 'Send');

exports.default = _default;

/***/ }),
/* 2068 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("circle", {
  cx: "15.5",
  cy: "9.5",
  r: "1.5"
}), _react.default.createElement("circle", {
  cx: "8.5",
  cy: "9.5",
  r: "1.5"
}), _react.default.createElement("path", {
  d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm0-6c-2.33 0-4.32 1.45-5.12 3.5h1.67c.69-1.19 1.97-2 3.45-2s2.75.81 3.45 2h1.67c-.8-2.05-2.79-3.5-5.12-3.5z"
})), 'SentimentDissatisfied');

exports.default = _default;

/***/ }),
/* 2069 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M9 14h6v1.5H9z"
}), _react.default.createElement("circle", {
  cx: "15.5",
  cy: "9.5",
  r: "1.5"
}), _react.default.createElement("circle", {
  cx: "8.5",
  cy: "9.5",
  r: "1.5"
}), _react.default.createElement("path", {
  d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
})), 'SentimentNeutral');

exports.default = _default;

/***/ }),
/* 2070 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("circle", {
  cx: "15.5",
  cy: "9.5",
  r: "1.5"
}), _react.default.createElement("circle", {
  cx: "8.5",
  cy: "9.5",
  r: "1.5"
}), _react.default.createElement("path", {
  d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm0-4c-1.48 0-2.75-.81-3.45-2H6.88c.8 2.05 2.79 3.5 5.12 3.5s4.32-1.45 5.12-3.5h-1.67c-.7 1.19-1.97 2-3.45 2z"
})), 'SentimentSatisfied');

exports.default = _default;

/***/ }),
/* 2071 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M11.99 2C6.47 2 2 6.47 2 12s4.47 10 9.99 10S22 17.53 22 12 17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm4.18-12.24l-1.06 1.06-1.06-1.06L13 8.82l1.06 1.06L13 10.94 14.06 12l1.06-1.06L16.18 12l1.06-1.06-1.06-1.06 1.06-1.06zM7.82 12l1.06-1.06L9.94 12 11 10.94 9.94 9.88 11 8.82 9.94 7.76 8.88 8.82 7.82 7.76 6.76 8.82l1.06 1.06-1.06 1.06zM12 14c-2.33 0-4.31 1.46-5.11 3.5h10.22c-.8-2.04-2.78-3.5-5.11-3.5z"
})), 'SentimentVeryDissatisfied');

exports.default = _default;

/***/ }),
/* 2072 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M11.99 2C6.47 2 2 6.47 2 12s4.47 10 9.99 10S22 17.53 22 12 17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm1-10.06L14.06 11l1.06-1.06L16.18 11l1.06-1.06-2.12-2.12zm-4.12 0L9.94 11 11 9.94 8.88 7.82 6.76 9.94 7.82 11zM12 17.5c2.33 0 4.31-1.46 5.11-3.5H6.89c.8 2.04 2.78 3.5 5.11 3.5z"
})), 'SentimentVerySatisfied');

exports.default = _default;

/***/ }),
/* 2073 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M19.43 12.98c.04-.32.07-.64.07-.98s-.03-.66-.07-.98l2.11-1.65c.19-.15.24-.42.12-.64l-2-3.46c-.12-.22-.39-.3-.61-.22l-2.49 1c-.52-.4-1.08-.73-1.69-.98l-.38-2.65C14.46 2.18 14.25 2 14 2h-4c-.25 0-.46.18-.49.42l-.38 2.65c-.61.25-1.17.59-1.69.98l-2.49-1c-.23-.09-.49 0-.61.22l-2 3.46c-.13.22-.07.49.12.64l2.11 1.65c-.04.32-.07.65-.07.98s.03.66.07.98l-2.11 1.65c-.19.15-.24.42-.12.64l2 3.46c.12.22.39.3.61.22l2.49-1c.52.4 1.08.73 1.69.98l.38 2.65c.03.24.24.42.49.42h4c.25 0 .46-.18.49-.42l.38-2.65c.61-.25 1.17-.59 1.69-.98l2.49 1c.23.09.49 0 .61-.22l2-3.46c.12-.22.07-.49-.12-.64l-2.11-1.65zM12 15.5c-1.93 0-3.5-1.57-3.5-3.5s1.57-3.5 3.5-3.5 3.5 1.57 3.5 3.5-1.57 3.5-3.5 3.5z"
})), 'Settings');

exports.default = _default;

/***/ }),
/* 2074 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm7-7H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-1.75 9c0 .23-.02.46-.05.68l1.48 1.16c.13.11.17.3.08.45l-1.4 2.42c-.09.15-.27.21-.43.15l-1.74-.7c-.36.28-.76.51-1.18.69l-.26 1.85c-.03.17-.18.3-.35.3h-2.8c-.17 0-.32-.13-.35-.29l-.26-1.85c-.43-.18-.82-.41-1.18-.69l-1.74.7c-.16.06-.34 0-.43-.15l-1.4-2.42c-.09-.15-.05-.34.08-.45l1.48-1.16c-.03-.23-.05-.46-.05-.69 0-.23.02-.46.05-.68l-1.48-1.16c-.13-.11-.17-.3-.08-.45l1.4-2.42c.09-.15.27-.21.43-.15l1.74.7c.36-.28.76-.51 1.18-.69l.26-1.85c.03-.17.18-.3.35-.3h2.8c.17 0 .32.13.35.29l.26 1.85c.43.18.82.41 1.18.69l1.74-.7c.16-.06.34 0 .43.15l1.4 2.42c.09.15.05.34-.08.45l-1.48 1.16c.03.23.05.46.05.69z"
})), 'SettingsApplications');

exports.default = _default;

/***/ }),
/* 2075 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M14 12c0-1.1-.9-2-2-2s-2 .9-2 2 .9 2 2 2 2-.9 2-2zm-2-9c-4.97 0-9 4.03-9 9H0l4 4 4-4H5c0-3.87 3.13-7 7-7s7 3.13 7 7-3.13 7-7 7c-1.51 0-2.91-.49-4.06-1.3l-1.42 1.44C8.04 20.3 9.94 21 12 21c4.97 0 9-4.03 9-9s-4.03-9-9-9z"
})), 'SettingsBackupRestore');

exports.default = _default;

/***/ }),
/* 2076 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M11 24h2v-2h-2v2zm-4 0h2v-2H7v2zm8 0h2v-2h-2v2zm2.71-18.29L12 0h-1v7.59L6.41 3 5 4.41 10.59 10 5 15.59 6.41 17 11 12.41V20h1l5.71-5.71-4.3-4.29 4.3-4.29zM13 3.83l1.88 1.88L13 7.59V3.83zm1.88 10.46L13 16.17v-3.76l1.88 1.88z"
})), 'SettingsBluetooth');

exports.default = _default;

/***/ }),
/* 2077 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16.01H3V4.99h18v14.02zM8 16h2.5l1.5 1.5 1.5-1.5H16v-2.5l1.5-1.5-1.5-1.5V8h-2.5L12 6.5 10.5 8H8v2.5L6.5 12 8 13.5V16zm4-7c1.66 0 3 1.34 3 3s-1.34 3-3 3V9z"
})), 'SettingsBrightness');

exports.default = _default;

/***/ }),
/* 2078 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M7 24h2v-2H7v2zm4 0h2v-2h-2v2zm4 0h2v-2h-2v2zM16 .01L8 0C6.9 0 6 .9 6 2v16c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V2c0-1.1-.9-1.99-2-1.99zM16 16H8V4h8v12z"
})), 'SettingsCell');

exports.default = _default;

/***/ }),
/* 2079 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M7.77 6.76L6.23 5.48.82 12l5.41 6.52 1.54-1.28L3.42 12l4.35-5.24zM7 13h2v-2H7v2zm10-2h-2v2h2v-2zm-6 2h2v-2h-2v2zm6.77-7.52l-1.54 1.28L20.58 12l-4.35 5.24 1.54 1.28L23.18 12l-5.41-6.52z"
})), 'SettingsEthernet');

exports.default = _default;

/***/ }),
/* 2080 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 5c-3.87 0-7 3.13-7 7h2c0-2.76 2.24-5 5-5s5 2.24 5 5h2c0-3.87-3.13-7-7-7zm1 9.29c.88-.39 1.5-1.26 1.5-2.29 0-1.38-1.12-2.5-2.5-2.5S9.5 10.62 9.5 12c0 1.02.62 1.9 1.5 2.29v3.3L7.59 21 9 22.41l3-3 3 3L16.41 21 13 17.59v-3.3zM12 1C5.93 1 1 5.93 1 12h2c0-4.97 4.03-9 9-9s9 4.03 9 9h2c0-6.07-4.93-11-11-11z"
})), 'SettingsInputAntenna');

exports.default = _default;

/***/ }),
/* 2081 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M5 2c0-.55-.45-1-1-1s-1 .45-1 1v4H1v6h6V6H5V2zm4 14c0 1.3.84 2.4 2 2.82V23h2v-4.18c1.16-.41 2-1.51 2-2.82v-2H9v2zm-8 0c0 1.3.84 2.4 2 2.82V23h2v-4.18C6.16 18.4 7 17.3 7 16v-2H1v2zM21 6V2c0-.55-.45-1-1-1s-1 .45-1 1v4h-2v6h6V6h-2zm-8-4c0-.55-.45-1-1-1s-1 .45-1 1v4H9v6h6V6h-2V2zm4 14c0 1.3.84 2.4 2 2.82V23h2v-4.18c1.16-.41 2-1.51 2-2.82v-2h-6v2z"
})), 'SettingsInputComponent');

exports.default = _default;

/***/ }),
/* 2082 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M5 2c0-.55-.45-1-1-1s-1 .45-1 1v4H1v6h6V6H5V2zm4 14c0 1.3.84 2.4 2 2.82V23h2v-4.18c1.16-.41 2-1.51 2-2.82v-2H9v2zm-8 0c0 1.3.84 2.4 2 2.82V23h2v-4.18C6.16 18.4 7 17.3 7 16v-2H1v2zM21 6V2c0-.55-.45-1-1-1s-1 .45-1 1v4h-2v6h6V6h-2zm-8-4c0-.55-.45-1-1-1s-1 .45-1 1v4H9v6h6V6h-2V2zm4 14c0 1.3.84 2.4 2 2.82V23h2v-4.18c1.16-.41 2-1.51 2-2.82v-2h-6v2z"
})), 'SettingsInputComposite');

exports.default = _default;

/***/ }),
/* 2083 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M18 7V4c0-1.1-.9-2-2-2H8c-1.1 0-2 .9-2 2v3H5v6l3 6v3h8v-3l3-6V7h-1zM8 4h8v3h-2V5h-1v2h-2V5h-1v2H8V4z"
})), 'SettingsInputHdmi');

exports.default = _default;

/***/ }),
/* 2084 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M8 11.5c0-.83-.67-1.5-1.5-1.5S5 10.67 5 11.5 5.67 13 6.5 13 8 12.33 8 11.5zm7-5c0-.83-.67-1.5-1.5-1.5h-3C9.67 5 9 5.67 9 6.5S9.67 8 10.5 8h3c.83 0 1.5-.67 1.5-1.5zM8.5 15c-.83 0-1.5.67-1.5 1.5S7.67 18 8.5 18s1.5-.67 1.5-1.5S9.33 15 8.5 15zM12 1C5.93 1 1 5.93 1 12s4.93 11 11 11 11-4.93 11-11S18.07 1 12 1zm0 20c-4.96 0-9-4.04-9-9s4.04-9 9-9 9 4.04 9 9-4.04 9-9 9zm5.5-11c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5zm-2 5c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5z"
})), 'SettingsInputSvideo');

exports.default = _default;

/***/ }),
/* 2085 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12.01 5.5L10 8h4l-1.99-2.5zM18 10v4l2.5-1.99L18 10zM6 10l-2.5 2.01L6 14v-4zm8 6h-4l2.01 2.5L14 16zm7-13H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16.01H3V4.99h18v14.02z"
})), 'SettingsOverscan');

exports.default = _default;

/***/ }),
/* 2086 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M13 9h-2v2h2V9zm4 0h-2v2h2V9zm3 6.5c-1.25 0-2.45-.2-3.57-.57-.35-.11-.74-.03-1.02.24l-2.2 2.2c-2.83-1.44-5.15-3.75-6.59-6.58l2.2-2.21c.28-.27.36-.66.25-1.01C8.7 6.45 8.5 5.25 8.5 4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.5c0-.55-.45-1-1-1zM19 9v2h2V9h-2z"
})), 'SettingsPhone');

exports.default = _default;

/***/ }),
/* 2087 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M7 24h2v-2H7v2zm4 0h2v-2h-2v2zm2-22h-2v10h2V2zm3.56 2.44l-1.45 1.45C16.84 6.94 18 8.83 18 11c0 3.31-2.69 6-6 6s-6-2.69-6-6c0-2.17 1.16-4.06 2.88-5.12L7.44 4.44C5.36 5.88 4 8.28 4 11c0 4.42 3.58 8 8 8s8-3.58 8-8c0-2.72-1.36-5.12-3.44-6.56zM15 24h2v-2h-2v2z"
})), 'SettingsPower');

exports.default = _default;

/***/ }),
/* 2088 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M15 9H9c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h6c.55 0 1-.45 1-1V10c0-.55-.45-1-1-1zm-3 6c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zM7.05 6.05l1.41 1.41C9.37 6.56 10.62 6 12 6s2.63.56 3.54 1.46l1.41-1.41C15.68 4.78 13.93 4 12 4s-3.68.78-4.95 2.05zM12 0C8.96 0 6.21 1.23 4.22 3.22l1.41 1.41C7.26 3.01 9.51 2 12 2s4.74 1.01 6.36 2.64l1.41-1.41C17.79 1.23 15.04 0 12 0z"
})), 'SettingsRemote');

exports.default = _default;

/***/ }),
/* 2089 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M9 16h6.5c1.38 0 2.5-1.12 2.5-2.5S16.88 11 15.5 11h-.05c-.24-1.69-1.69-3-3.45-3-1.4 0-2.6.83-3.16 2.02h-.16C7.17 10.18 6 11.45 6 13c0 1.66 1.34 3 3 3zM21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16.01H3V4.99h18v14.02z"
})), 'SettingsSystemDaydream');

exports.default = _default;

/***/ }),
/* 2090 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M7 24h2v-2H7v2zm5-11c1.66 0 2.99-1.34 2.99-3L15 4c0-1.66-1.34-3-3-3S9 2.34 9 4v6c0 1.66 1.34 3 3 3zm-1 11h2v-2h-2v2zm4 0h2v-2h-2v2zm4-14h-1.7c0 3-2.54 5.1-5.3 5.1S6.7 13 6.7 10H5c0 3.41 2.72 6.23 6 6.72V20h2v-3.28c3.28-.49 6-3.31 6-6.72z"
})), 'SettingsVoice');

exports.default = _default;

/***/ }),
/* 2091 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M18 16.08c-.76 0-1.44.3-1.96.77L8.91 12.7c.05-.23.09-.46.09-.7s-.04-.47-.09-.7l7.05-4.11c.54.5 1.25.81 2.04.81 1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3c0 .24.04.47.09.7L8.04 9.81C7.5 9.31 6.79 9 6 9c-1.66 0-3 1.34-3 3s1.34 3 3 3c.79 0 1.5-.31 2.04-.81l7.12 4.16c-.05.21-.08.43-.08.65 0 1.61 1.31 2.92 2.92 2.92 1.61 0 2.92-1.31 2.92-2.92s-1.31-2.92-2.92-2.92z"
})), 'Share');

exports.default = _default;

/***/ }),
/* 2092 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M16 6V4c0-1.11-.89-2-2-2h-4c-1.11 0-2 .89-2 2v2H2v13c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6h-6zm-6-2h4v2h-4V4zM9 18V9l7.5 4L9 18z"
})), 'Shop');

exports.default = _default;

/***/ }),
/* 2093 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M17.21 9l-4.38-6.56c-.19-.28-.51-.42-.83-.42-.32 0-.64.14-.83.43L6.79 9H2c-.55 0-1 .45-1 1 0 .09.01.18.04.27l2.54 9.27c.23.84 1 1.46 1.92 1.46h13c.92 0 1.69-.62 1.93-1.46l2.54-9.27L23 10c0-.55-.45-1-1-1h-4.79zM9 9l3-4.4L15 9H9zm3 8c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"
})), 'ShoppingBasket');

exports.default = _default;

/***/ }),
/* 2094 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M7 18c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2zM1 2v2h2l3.6 7.59-1.35 2.45c-.16.28-.25.61-.25.96 0 1.1.9 2 2 2h12v-2H7.42c-.14 0-.25-.11-.25-.25l.03-.12.9-1.63h7.45c.75 0 1.41-.41 1.75-1.03l3.58-6.49c.08-.14.12-.31.12-.48 0-.55-.45-1-1-1H5.21l-.94-2H1zm16 16c-1.1 0-1.99.9-1.99 2s.89 2 1.99 2 2-.9 2-2-.9-2-2-2z"
})), 'ShoppingCart');

exports.default = _default;

/***/ }),
/* 2095 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M3 9H1v11c0 1.11.89 2 2 2h14c1.11 0 2-.89 2-2H3V9zm15-4V3c0-1.11-.89-2-2-2h-4c-1.11 0-2 .89-2 2v2H5v11c0 1.11.89 2 2 2h14c1.11 0 2-.89 2-2V5h-5zm-6-2h4v2h-4V3zm0 12V8l5.5 3-5.5 4z"
})), 'ShopTwo');

exports.default = _default;

/***/ }),
/* 2096 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M4 9h16v2H4zm0 4h10v2H4z"
})), 'ShortText');

exports.default = _default;

/***/ }),
/* 2097 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M3.5 18.49l6-6.01 4 4L22 6.92l-1.41-1.41-7.09 7.97-4-4L2 16.99z"
})), 'ShowChart');

exports.default = _default;

/***/ }),
/* 2098 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M10.59 9.17L5.41 4 4 5.41l5.17 5.17 1.42-1.41zM14.5 4l2.04 2.04L4 18.59 5.41 20 17.96 7.46 20 9.5V4h-5.5zm.33 9.41l-1.41 1.41 3.13 3.13L14.5 20H20v-5.5l-2.04 2.04-3.13-3.13z"
})), 'Shuffle');

exports.default = _default;

/***/ }),
/* 2099 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  fillOpacity: ".3",
  d: "M2 22h20V2z"
})), 'SignalCellular0Bar');

exports.default = _default;

/***/ }),
/* 2100 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  fillOpacity: ".3",
  d: "M2 22h20V2z"
}), _react.default.createElement("path", {
  d: "M12 12L2 22h10z"
})), 'SignalCellular1Bar');

exports.default = _default;

/***/ }),
/* 2101 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  fillOpacity: ".3",
  d: "M2 22h20V2z"
}), _react.default.createElement("path", {
  d: "M14 10L2 22h12z"
})), 'SignalCellular2Bar');

exports.default = _default;

/***/ }),
/* 2102 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  fillOpacity: ".3",
  d: "M2 22h20V2z"
}), _react.default.createElement("path", {
  d: "M17 7L2 22h15z"
})), 'SignalCellular3Bar');

exports.default = _default;

/***/ }),
/* 2103 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M2 22h20V2z"
})), 'SignalCellular4Bar');

exports.default = _default;

/***/ }),
/* 2104 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  fillOpacity: ".3",
  d: "M22 8V2L2 22h16V8z"
}), _react.default.createElement("path", {
  d: "M20 22h2v-2h-2v2zm0-12v8h2v-8h-2z"
})), 'SignalCellularConnectedNoInternet0Bar');

exports.default = _default;

/***/ }),
/* 2105 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  fillOpacity: ".3",
  d: "M22 8V2L2 22h16V8z"
}), _react.default.createElement("path", {
  d: "M20 10v8h2v-8h-2zm-8 12V12L2 22h10zm8 0h2v-2h-2v2z"
})), 'SignalCellularConnectedNoInternet1Bar');

exports.default = _default;

/***/ }),
/* 2106 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  fillOpacity: ".3",
  d: "M22 8V2L2 22h16V8z"
}), _react.default.createElement("path", {
  d: "M14 22V10L2 22h12zm6-12v8h2v-8h-2zm0 12h2v-2h-2v2z"
})), 'SignalCellularConnectedNoInternet2Bar');

exports.default = _default;

/***/ }),
/* 2107 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  fillOpacity: ".3",
  d: "M22 8V2L2 22h16V8z"
}), _react.default.createElement("path", {
  d: "M17 22V7L2 22h15zm3-12v8h2v-8h-2zm0 12h2v-2h-2v2z"
})), 'SignalCellularConnectedNoInternet3Bar');

exports.default = _default;

/***/ }),
/* 2108 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20 18h2v-8h-2v8zm0 4h2v-2h-2v2zM2 22h16V8h4V2L2 22z"
})), 'SignalCellularConnectedNoInternet4Bar');

exports.default = _default;

/***/ }),
/* 2109 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M18.99 5c0-1.1-.89-2-1.99-2h-7L7.66 5.34 19 16.68 18.99 5zM3.65 3.88L2.38 5.15 5 7.77V19c0 1.1.9 2 2 2h10.01c.35 0 .67-.1.96-.26l1.88 1.88 1.27-1.27L3.65 3.88z"
})), 'SignalCellularNoSim');

exports.default = _default;

/***/ }),
/* 2110 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20 6.83V20H6.83L20 6.83M22 2L2 22h20V2z"
})), 'SignalCellularNull');

exports.default = _default;

/***/ }),
/* 2111 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M21 1l-8.59 8.59L21 18.18V1zM4.77 4.5L3.5 5.77l6.36 6.36L1 21h17.73l2 2L22 21.73 4.77 4.5z"
})), 'SignalCellularOff');

exports.default = _default;

/***/ }),
/* 2112 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  fillOpacity: ".3",
  d: "M12.01 21.49L23.64 7c-.45-.34-4.93-4-11.64-4C5.28 3 .81 6.66.36 7l11.63 14.49.01.01.01-.01z"
})), 'SignalWifi0Bar');

exports.default = _default;

/***/ }),
/* 2113 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  fillOpacity: ".3",
  d: "M12.01 21.49L23.64 7c-.45-.34-4.93-4-11.64-4C5.28 3 .81 6.66.36 7l11.63 14.49.01.01.01-.01z"
}), _react.default.createElement("path", {
  d: "M6.67 14.86L12 21.49v.01l.01-.01 5.33-6.63C17.06 14.65 15.03 13 12 13s-5.06 1.65-5.33 1.86z"
})), 'SignalWifi1Bar');

exports.default = _default;

/***/ }),
/* 2114 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M23 16v-1.5c0-1.4-1.1-2.5-2.5-2.5S18 13.1 18 14.5V16c-.5 0-1 .5-1 1v4c0 .5.5 1 1 1h5c.5 0 1-.5 1-1v-4c0-.5-.5-1-1-1zm-1 0h-3v-1.5c0-.8.7-1.5 1.5-1.5s1.5.7 1.5 1.5V16z"
}), _react.default.createElement("path", {
  d: "M15.5 14.5c0-2.8 2.2-5 5-5 .4 0 .7 0 1 .1L23.6 7c-.4-.3-4.9-4-11.6-4C5.3 3 .8 6.7.4 7L12 21.5l3.5-4.3v-2.7z",
  opacity: ".3"
}), _react.default.createElement("path", {
  d: "M6.7 14.9l5.3 6.6 3.5-4.3v-2.6c0-.2 0-.5.1-.7-.9-.5-2.2-.9-3.6-.9-3 0-5.1 1.7-5.3 1.9z"
})), 'SignalWifi1BarLock');

exports.default = _default;

/***/ }),
/* 2115 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  fillOpacity: ".3",
  d: "M12.01 21.49L23.64 7c-.45-.34-4.93-4-11.64-4C5.28 3 .81 6.66.36 7l11.63 14.49.01.01.01-.01z"
}), _react.default.createElement("path", {
  d: "M4.79 12.52l7.2 8.98H12l.01-.01 7.2-8.98C18.85 12.24 16.1 10 12 10s-6.85 2.24-7.21 2.52z"
})), 'SignalWifi2Bar');

exports.default = _default;

/***/ }),
/* 2116 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M23 16v-1.5c0-1.4-1.1-2.5-2.5-2.5S18 13.1 18 14.5V16c-.5 0-1 .5-1 1v4c0 .5.5 1 1 1h5c.5 0 1-.5 1-1v-4c0-.5-.5-1-1-1zm-1 0h-3v-1.5c0-.8.7-1.5 1.5-1.5s1.5.7 1.5 1.5V16z"
}), _react.default.createElement("path", {
  d: "M15.5 14.5c0-2.8 2.2-5 5-5 .4 0 .7 0 1 .1L23.6 7c-.4-.3-4.9-4-11.6-4C5.3 3 .8 6.7.4 7L12 21.5l3.5-4.3v-2.7z",
  opacity: ".3"
}), _react.default.createElement("path", {
  d: "M4.8 12.5l7.2 9 3.5-4.4v-2.6c0-1.3.5-2.5 1.4-3.4C15.6 10.5 14 10 12 10c-4.1 0-6.8 2.2-7.2 2.5z"
})), 'SignalWifi2BarLock');

exports.default = _default;

/***/ }),
/* 2117 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  fillOpacity: ".3",
  d: "M12.01 21.49L23.64 7c-.45-.34-4.93-4-11.64-4C5.28 3 .81 6.66.36 7l11.63 14.49.01.01.01-.01z"
}), _react.default.createElement("path", {
  d: "M3.53 10.95l8.46 10.54.01.01.01-.01 8.46-10.54C20.04 10.62 16.81 8 12 8c-4.81 0-8.04 2.62-8.47 2.95z"
})), 'SignalWifi3Bar');

exports.default = _default;

/***/ }),
/* 2118 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  opacity: ".3",
  d: "M12 3C5.3 3 .8 6.7.4 7l3.2 3.9L12 21.5l3.5-4.3v-2.6c0-2.2 1.4-4 3.3-4.7.3-.1.5-.2.8-.2.3-.1.6-.1.9-.1.4 0 .7 0 1 .1L23.6 7c-.4-.3-4.9-4-11.6-4z"
}), _react.default.createElement("path", {
  d: "M23 16v-1.5c0-1.4-1.1-2.5-2.5-2.5S18 13.1 18 14.5V16c-.5 0-1 .5-1 1v4c0 .5.5 1 1 1h5c.5 0 1-.5 1-1v-4c0-.5-.5-1-1-1zm-1 0h-3v-1.5c0-.8.7-1.5 1.5-1.5s1.5.7 1.5 1.5V16zm-10 5.5l3.5-4.3v-2.6c0-2.2 1.4-4 3.3-4.7C17.3 9 14.9 8 12 8c-4.8 0-8 2.6-8.5 2.9"
})), 'SignalWifi3BarLock');

exports.default = _default;

/***/ }),
/* 2119 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12.01 21.49L23.64 7c-.45-.34-4.93-4-11.64-4C5.28 3 .81 6.66.36 7l11.63 14.49.01.01.01-.01z"
})), 'SignalWifi4Bar');

exports.default = _default;

/***/ }),
/* 2120 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M23 16v-1.5c0-1.4-1.1-2.5-2.5-2.5S18 13.1 18 14.5V16c-.5 0-1 .5-1 1v4c0 .5.5 1 1 1h5c.5 0 1-.5 1-1v-4c0-.5-.5-1-1-1zm-1 0h-3v-1.5c0-.8.7-1.5 1.5-1.5s1.5.7 1.5 1.5V16zm-6.5-1.5c0-2.8 2.2-5 5-5 .4 0 .7 0 1 .1L23.6 7c-.4-.3-4.9-4-11.6-4C5.3 3 .8 6.7.4 7L12 21.5l3.5-4.4v-2.6z"
})), 'SignalWifi4BarLock');

exports.default = _default;

/***/ }),
/* 2121 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M23.64 7c-.45-.34-4.93-4-11.64-4-1.5 0-2.89.19-4.15.48L18.18 13.8 23.64 7zm-6.6 8.22L3.27 1.44 2 2.72l2.05 2.06C1.91 5.76.59 6.82.36 7l11.63 14.49.01.01.01-.01 3.9-4.86 3.32 3.32 1.27-1.27-3.46-3.46z"
})), 'SignalWifiOff');

exports.default = _default;

/***/ }),
/* 2122 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M19.99 4c0-1.1-.89-2-1.99-2h-8L4 8v12c0 1.1.9 2 2 2h12.01c1.1 0 1.99-.9 1.99-2l-.01-16zM9 19H7v-2h2v2zm8 0h-2v-2h2v2zm-8-4H7v-4h2v4zm4 4h-2v-4h2v4zm0-6h-2v-2h2v2zm4 2h-2v-4h2v4z"
})), 'SimCard');

exports.default = _default;

/***/ }),
/* 2123 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M18 2h-8L4.02 8 4 20c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-5 15h-2v-2h2v2zm0-4h-2V8h2v5z"
})), 'SimCardAlert');

exports.default = _default;

/***/ }),
/* 2124 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M6 18l8.5-6L6 6v12zM16 6v12h2V6h-2z"
})), 'SkipNext');

exports.default = _default;

/***/ }),
/* 2125 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M6 6h2v12H6zm3.5 6l8.5 6V6z"
})), 'SkipPrevious');

exports.default = _default;

/***/ }),
/* 2126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M10 8v8l5-4-5-4zm9-5H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14z"
})), 'Slideshow');

exports.default = _default;

/***/ }),
/* 2127 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M13.05 9.79L10 7.5v9l3.05-2.29L16 12zm0 0L10 7.5v9l3.05-2.29L16 12zm0 0L10 7.5v9l3.05-2.29L16 12zM11 4.07V2.05c-2.01.2-3.84 1-5.32 2.21L7.1 5.69c1.11-.86 2.44-1.44 3.9-1.62zM5.69 7.1L4.26 5.68C3.05 7.16 2.25 8.99 2.05 11h2.02c.18-1.46.76-2.79 1.62-3.9zM4.07 13H2.05c.2 2.01 1 3.84 2.21 5.32l1.43-1.43c-.86-1.1-1.44-2.43-1.62-3.89zm1.61 6.74C7.16 20.95 9 21.75 11 21.95v-2.02c-1.46-.18-2.79-.76-3.9-1.62l-1.42 1.43zM22 12c0 5.16-3.92 9.42-8.95 9.95v-2.02C16.97 19.41 20 16.05 20 12s-3.03-7.41-6.95-7.93V2.05C18.08 2.58 22 6.84 22 12z"
})), 'SlowMotionVideo');

exports.default = _default;

/***/ }),
/* 2128 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M17 1.01L7 1c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM17 19H7V5h10v14z"
})), 'Smartphone');

exports.default = _default;

/***/ }),
/* 2129 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M2 6l6.99 7H2v3h9.99l7 7 1.26-1.25-17-17zm18.5 7H22v3h-1.5zM18 13h1.5v3H18zm.85-8.12c.62-.61 1-1.45 1-2.38h-1.5c0 1.02-.83 1.85-1.85 1.85v1.5c2.24 0 4 1.83 4 4.07V12H22V9.92c0-2.23-1.28-4.15-3.15-5.04zM14.5 8.7h1.53c1.05 0 1.97.74 1.97 2.05V12h1.5v-1.59c0-1.8-1.6-3.16-3.47-3.16H14.5c-1.02 0-1.85-.98-1.85-2s.83-1.75 1.85-1.75V2c-1.85 0-3.35 1.5-3.35 3.35s1.5 3.35 3.35 3.35zm2.5 7.23V13h-2.93z"
})), 'SmokeFree');

exports.default = _default;

/***/ }),
/* 2130 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M2 16h15v3H2zm18.5 0H22v3h-1.5zM18 16h1.5v3H18zm.85-8.27c.62-.61 1-1.45 1-2.38C19.85 3.5 18.35 2 16.5 2v1.5c1.02 0 1.85.83 1.85 1.85S17.52 7.2 16.5 7.2v1.5c2.24 0 4 1.83 4 4.07V15H22v-2.24c0-2.22-1.28-4.14-3.15-5.03zm-2.82 2.47H14.5c-1.02 0-1.85-.98-1.85-2s.83-1.75 1.85-1.75v-1.5c-1.85 0-3.35 1.5-3.35 3.35s1.5 3.35 3.35 3.35h1.53c1.05 0 1.97.74 1.97 2.05V15h1.5v-1.64c0-1.81-1.6-3.16-3.47-3.16z"
})), 'SmokingRooms');

exports.default = _default;

/***/ }),
/* 2131 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM9 11H7V9h2v2zm4 0h-2V9h2v2zm4 0h-2V9h2v2z"
})), 'Sms');

exports.default = _default;

/***/ }),
/* 2132 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-7 12h-2v-2h2v2zm0-4h-2V6h2v4z"
})), 'SmsFailed');

exports.default = _default;

/***/ }),
/* 2133 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M7.88 3.39L6.6 1.86 2 5.71l1.29 1.53 4.59-3.85zM22 5.72l-4.6-3.86-1.29 1.53 4.6 3.86L22 5.72zM12 4c-4.97 0-9 4.03-9 9s4.02 9 9 9c4.97 0 9-4.03 9-9s-4.03-9-9-9zm0 16c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7zm-3-9h3.63L9 15.2V17h6v-2h-3.63L15 10.8V9H9v2z"
})), 'Snooze');

exports.default = _default;

/***/ }),
/* 2134 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M3 18h6v-2H3v2zM3 6v2h18V6H3zm0 7h12v-2H3v2z"
})), 'Sort');

exports.default = _default;

/***/ }),
/* 2135 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M14.94 4.66h-4.72l2.36-2.36zm-4.69 14.71h4.66l-2.33 2.33zM6.1 6.27L1.6 17.73h1.84l.92-2.45h5.11l.92 2.45h1.84L7.74 6.27H6.1zm-1.13 7.37l1.94-5.18 1.94 5.18H4.97zm10.76 2.5h6.12v1.59h-8.53v-1.29l5.92-8.56h-5.88v-1.6h8.3v1.26l-5.93 8.6z"
})), 'SortByAlpha');

exports.default = _default;

/***/ }),
/* 2136 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M8.55 12c-1.07-.71-2.25-1.27-3.53-1.61 1.28.34 2.46.9 3.53 1.61zm10.43-1.61c-1.29.34-2.49.91-3.57 1.64 1.08-.73 2.28-1.3 3.57-1.64z"
}), _react.default.createElement("path", {
  d: "M15.49 9.63c-.18-2.79-1.31-5.51-3.43-7.63-2.14 2.14-3.32 4.86-3.55 7.63 1.28.68 2.46 1.56 3.49 2.63 1.03-1.06 2.21-1.94 3.49-2.63zm-6.5 2.65c-.14-.1-.3-.19-.45-.29.15.11.31.19.45.29zm6.42-.25c-.13.09-.27.16-.4.26.13-.1.27-.17.4-.26zM12 15.45C9.85 12.17 6.18 10 2 10c0 5.32 3.36 9.82 8.03 11.49.63.23 1.29.4 1.97.51.68-.12 1.33-.29 1.97-.51C18.64 19.82 22 15.32 22 10c-4.18 0-7.85 2.17-10 5.45z"
})), 'Spa');

exports.default = _default;

/***/ }),
/* 2137 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M18 9v4H6V9H4v6h16V9z"
})), 'SpaceBar');

exports.default = _default;

/***/ }),
/* 2138 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M17 2H7c-1.1 0-2 .9-2 2v16c0 1.1.9 1.99 2 1.99L17 22c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-5 2c1.1 0 2 .9 2 2s-.9 2-2 2c-1.11 0-2-.9-2-2s.89-2 2-2zm0 16c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"
})), 'Speaker');

exports.default = _default;

/***/ }),
/* 2139 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M18.2 1H9.8C8.81 1 8 1.81 8 2.8v14.4c0 .99.81 1.79 1.8 1.79l8.4.01c.99 0 1.8-.81 1.8-1.8V2.8c0-.99-.81-1.8-1.8-1.8zM14 3c1.1 0 2 .89 2 2s-.9 2-2 2-2-.89-2-2 .9-2 2-2zm0 13.5c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4z"
}), _react.default.createElement("circle", {
  cx: "14",
  cy: "12.5",
  r: "2.5"
}), _react.default.createElement("path", {
  d: "M6 5H4v16c0 1.1.89 2 2 2h10v-2H6V5z"
})), 'SpeakerGroup');

exports.default = _default;

/***/ }),
/* 2140 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM8 14H6v-2h2v2zm0-3H6V9h2v2zm0-3H6V6h2v2zm7 6h-5v-2h5v2zm3-3h-8V9h8v2zm0-3h-8V6h8v2z"
})), 'SpeakerNotes');

exports.default = _default;

/***/ }),
/* 2141 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M10.54 11l-.54-.54L7.54 8 6 6.46 2.38 2.84 1.27 1.73 0 3l2.01 2.01L2 22l4-4h9l5.73 5.73L22 22.46 17.54 18l-7-7zM8 14H6v-2h2v2zm-2-3V9l2 2H6zm14-9H4.08L10 7.92V6h8v2h-7.92l1 1H18v2h-4.92l6.99 6.99C21.14 17.95 22 17.08 22 16V4c0-1.1-.9-2-2-2z"
})), 'SpeakerNotesOff');

exports.default = _default;

/***/ }),
/* 2142 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M7 7.07L8.43 8.5c.91-.91 2.18-1.48 3.57-1.48s2.66.57 3.57 1.48L17 7.07C15.72 5.79 13.95 5 12 5s-3.72.79-5 2.07zM12 1C8.98 1 6.24 2.23 4.25 4.21l1.41 1.41C7.28 4 9.53 3 12 3s4.72 1 6.34 2.62l1.41-1.41C17.76 2.23 15.02 1 12 1zm2.86 9.01L9.14 10C8.51 10 8 10.51 8 11.14v9.71c0 .63.51 1.14 1.14 1.14h5.71c.63 0 1.14-.51 1.14-1.14v-9.71c.01-.63-.5-1.13-1.13-1.13zM15 20H9v-8h6v8z"
})), 'SpeakerPhone');

exports.default = _default;

/***/ }),
/* 2143 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12.45 16h2.09L9.43 3H7.57L2.46 16h2.09l1.12-3h5.64l1.14 3zm-6.02-5L8.5 5.48 10.57 11H6.43zm15.16.59l-8.09 8.09L9.83 16l-1.41 1.41 5.09 5.09L23 13l-1.41-1.41z"
})), 'Spellcheck');

exports.default = _default;

/***/ }),
/* 2144 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"
})), 'Star');

exports.default = _default;

/***/ }),
/* 2145 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M22 9.24l-7.19-.62L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21 12 17.27 18.18 21l-1.63-7.03L22 9.24zM12 15.4l-3.76 2.27 1-4.28-3.32-2.88 4.38-.38L12 6.1l1.71 4.04 4.38.38-3.32 2.88 1 4.28L12 15.4z"
})), 'StarBorder');

exports.default = _default;

/***/ }),
/* 2146 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M22 9.24l-7.19-.62L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21 12 17.27 18.18 21l-1.63-7.03L22 9.24zM12 15.4V6.1l1.71 4.04 4.38.38-3.32 2.88 1 4.28L12 15.4z"
})), 'StarHalf');

exports.default = _default;

/***/ }),
/* 2147 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zm4.24 16L12 15.45 7.77 18l1.12-4.81-3.73-3.23 4.92-.42L12 5l1.92 4.53 4.92.42-3.73 3.23L16.23 18z"
})), 'Stars');

exports.default = _default;

/***/ }),
/* 2148 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M1.01 7L1 17c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2H3c-1.1 0-1.99.9-1.99 2zM19 7v10H5V7h14z"
})), 'StayCurrentLandscape');

exports.default = _default;

/***/ }),
/* 2149 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M17 1.01L7 1c-1.1 0-1.99.9-1.99 2v18c0 1.1.89 2 1.99 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM17 19H7V5h10v14z"
})), 'StayCurrentPortrait');

exports.default = _default;

/***/ }),
/* 2150 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M1.01 7L1 17c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2H3c-1.1 0-1.99.9-1.99 2zM19 7v10H5V7h14z"
})), 'StayPrimaryLandscape');

exports.default = _default;

/***/ }),
/* 2151 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M17 1.01L7 1c-1.1 0-1.99.9-1.99 2v18c0 1.1.89 2 1.99 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM17 19H7V5h10v14z"
})), 'StayPrimaryPortrait');

exports.default = _default;

/***/ }),
/* 2152 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M6 6h12v12H6z"
})), 'Stop');

exports.default = _default;

/***/ }),
/* 2153 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M21.22 18.02l2 2H24v-2h-2.78zm.77-2l.01-10c0-1.11-.9-2-2-2H7.22l5.23 5.23c.18-.04.36-.07.55-.1V7.02l4 3.73-1.58 1.47 5.54 5.54c.61-.33 1.03-.99 1.03-1.74zM2.39 1.73L1.11 3l1.54 1.54c-.4.36-.65.89-.65 1.48v10c0 1.1.89 2 2 2H0v2h18.13l2.71 2.71 1.27-1.27L2.39 1.73zM7 15.02c.31-1.48.92-2.95 2.07-4.06l1.59 1.59c-1.54.38-2.7 1.18-3.66 2.47z"
})), 'StopScreenShare');

exports.default = _default;

/***/ }),
/* 2154 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M2 20h20v-4H2v4zm2-3h2v2H4v-2zM2 4v4h20V4H2zm4 3H4V5h2v2zm-4 7h20v-4H2v4zm2-3h2v2H4v-2z"
})), 'Storage');

exports.default = _default;

/***/ }),
/* 2155 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20 4H4v2h16V4zm1 10v-2l-1-5H4l-1 5v2h1v6h10v-6h4v6h2v-6h1zm-9 4H6v-4h6v4z"
})), 'Store');

exports.default = _default;

/***/ }),
/* 2156 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20 4H4v2h16V4zm1 10v-2l-1-5H4l-1 5v2h1v6h10v-6h4v6h2v-6h1zm-9 4H6v-4h6v4z"
})), 'StoreMallDirectory');

exports.default = _default;

/***/ }),
/* 2157 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M21 6H3c-1.1 0-2 .9-2 2v8c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm0 10H3V8h2v4h2V8h2v4h2V8h2v4h2V8h2v4h2V8h2v8z"
})), 'Straighten');

exports.default = _default;

/***/ }),
/* 2158 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12.56 14.33c-.34.27-.56.7-.56 1.17V21h7c1.1 0 2-.9 2-2v-5.98c-.94-.33-1.95-.52-3-.52-2.03 0-3.93.7-5.44 1.83z"
}), _react.default.createElement("circle", {
  cx: "18",
  cy: "6",
  r: "5"
}), _react.default.createElement("path", {
  d: "M11.5 6c0-1.08.27-2.1.74-3H5c-1.1 0-2 .9-2 2v14c0 .55.23 1.05.59 1.41l9.82-9.82C12.23 9.42 11.5 7.8 11.5 6z"
})), 'Streetview');

exports.default = _default;

/***/ }),
/* 2159 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M7.24 8.75c-.26-.48-.39-1.03-.39-1.67 0-.61.13-1.16.4-1.67.26-.5.63-.93 1.11-1.29.48-.35 1.05-.63 1.7-.83.66-.19 1.39-.29 2.18-.29.81 0 1.54.11 2.21.34.66.22 1.23.54 1.69.94.47.4.83.88 1.08 1.43.25.55.38 1.15.38 1.81h-3.01c0-.31-.05-.59-.15-.85-.09-.27-.24-.49-.44-.68-.2-.19-.45-.33-.75-.44-.3-.1-.66-.16-1.06-.16-.39 0-.74.04-1.03.13-.29.09-.53.21-.72.36-.19.16-.34.34-.44.55-.1.21-.15.43-.15.66 0 .48.25.88.74 1.21.38.25.77.48 1.41.7H7.39c-.05-.08-.11-.17-.15-.25zM21 12v-2H3v2h9.62c.18.07.4.14.55.2.37.17.66.34.87.51.21.17.35.36.43.57.07.2.11.43.11.69 0 .23-.05.45-.14.66-.09.2-.23.38-.42.53-.19.15-.42.26-.71.35-.29.08-.63.13-1.01.13-.43 0-.83-.04-1.18-.13s-.66-.23-.91-.42c-.25-.19-.45-.44-.59-.75-.14-.31-.25-.76-.25-1.21H6.4c0 .55.08 1.13.24 1.58.16.45.37.85.65 1.21.28.35.6.66.98.92.37.26.78.48 1.22.65.44.17.9.3 1.38.39.48.08.96.13 1.44.13.8 0 1.53-.09 2.18-.28s1.21-.45 1.67-.79c.46-.34.82-.77 1.07-1.27s.38-1.07.38-1.71c0-.6-.1-1.14-.31-1.61-.05-.11-.11-.23-.17-.33H21z"
})), 'StrikethroughS');

exports.default = _default;

/***/ }),
/* 2160 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M2.53 19.65l1.34.56v-9.03l-2.43 5.86c-.41 1.02.08 2.19 1.09 2.61zm19.5-3.7L17.07 3.98c-.31-.75-1.04-1.21-1.81-1.23-.26 0-.53.04-.79.15L7.1 5.95c-.75.31-1.21 1.03-1.23 1.8-.01.27.04.54.15.8l4.96 11.97c.31.76 1.05 1.22 1.83 1.23.26 0 .52-.05.77-.15l7.36-3.05c1.02-.42 1.51-1.59 1.09-2.6zM7.88 8.75c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm-2 11c0 1.1.9 2 2 2h1.45l-3.45-8.34v6.34z"
})), 'Style');

exports.default = _default;

/***/ }),
/* 2161 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M11 9l1.42 1.42L8.83 14H18V4h2v12H8.83l3.59 3.58L11 21l-6-6 6-6z"
})), 'SubdirectoryArrowLeft');

exports.default = _default;

/***/ }),
/* 2162 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M19 15l-6 6-1.42-1.42L15.17 16H4V4h2v10h9.17l-3.59-3.58L13 9l6 6z"
})), 'SubdirectoryArrowRight');

exports.default = _default;

/***/ }),
/* 2163 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M14 17H4v2h10v-2zm6-8H4v2h16V9zM4 15h16v-2H4v2zM4 5v2h16V5H4z"
})), 'Subject');

exports.default = _default;

/***/ }),
/* 2164 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20 8H4V6h16v2zm-2-6H6v2h12V2zm4 10v8c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2v-8c0-1.1.9-2 2-2h16c1.1 0 2 .9 2 2zm-6 4l-6-3.27v6.53L16 16z"
})), 'Subscriptions');

exports.default = _default;

/***/ }),
/* 2165 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zM4 12h4v2H4v-2zm10 6H4v-2h10v2zm6 0h-4v-2h4v2zm0-4H10v-2h10v2z"
})), 'Subtitles');

exports.default = _default;

/***/ }),
/* 2166 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("circle", {
  cx: "15.5",
  cy: "16",
  r: "1"
}), _react.default.createElement("circle", {
  cx: "8.5",
  cy: "16",
  r: "1"
}), _react.default.createElement("path", {
  d: "M7.01 9h10v5h-10zM17.8 2.8C16 2.09 13.86 2 12 2c-1.86 0-4 .09-5.8.8C3.53 3.84 2 6.05 2 8.86V22h20V8.86c0-2.81-1.53-5.02-4.2-6.06zm.2 13.08c0 1.45-1.18 2.62-2.63 2.62l1.13 1.12V20H15l-1.5-1.5h-2.83L9.17 20H7.5v-.38l1.12-1.12C7.18 18.5 6 17.32 6 15.88V9c0-2.63 3-3 6-3 3.32 0 6 .38 6 3v6.88z"
})), 'Subway');

exports.default = _default;

/***/ }),
/* 2167 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M16.5 12c1.38 0 2.49-1.12 2.49-2.5S17.88 7 16.5 7C15.12 7 14 8.12 14 9.5s1.12 2.5 2.5 2.5zM9 11c1.66 0 2.99-1.34 2.99-3S10.66 5 9 5C7.34 5 6 6.34 6 8s1.34 3 3 3zm7.5 3c-1.83 0-5.5.92-5.5 2.75V19h11v-2.25c0-1.83-3.67-2.75-5.5-2.75zM9 13c-2.33 0-7 1.17-7 3.5V19h7v-2.25c0-.85.33-2.34 2.37-3.47C10.5 13.1 9.66 13 9 13z"
})), 'SupervisorAccount');

exports.default = _default;

/***/ }),
/* 2168 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zM7.76 16.24l-1.41 1.41C4.78 16.1 4 14.05 4 12c0-2.05.78-4.1 2.34-5.66l1.41 1.41C6.59 8.93 6 10.46 6 12s.59 3.07 1.76 4.24zM12 16c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4zm5.66 1.66l-1.41-1.41C17.41 15.07 18 13.54 18 12s-.59-3.07-1.76-4.24l1.41-1.41C19.22 7.9 20 9.95 20 12c0 2.05-.78 4.1-2.34 5.66zM12 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
})), 'SurroundSound');

exports.default = _default;

/***/ }),
/* 2169 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M18 4l-4 4h3v7c0 1.1-.9 2-2 2s-2-.9-2-2V8c0-2.21-1.79-4-4-4S5 5.79 5 8v7H2l4 4 4-4H7V8c0-1.1.9-2 2-2s2 .9 2 2v7c0 2.21 1.79 4 4 4s4-1.79 4-4V8h3l-4-4z"
})), 'SwapCalls');

exports.default = _default;

/***/ }),
/* 2170 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M6.99 11L3 15l3.99 4v-3H14v-2H6.99v-3zM21 9l-3.99-4v3H10v2h7.01v3L21 9z"
})), 'SwapHoriz');

exports.default = _default;

/***/ }),
/* 2171 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M16 17.01V10h-2v7.01h-3L15 21l4-3.99h-3zM9 3L5 6.99h3V14h2V6.99h3L9 3z"
})), 'SwapVert');

exports.default = _default;

/***/ }),
/* 2172 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zM6.5 9L10 5.5 13.5 9H11v4H9V9H6.5zm11 6L14 18.5 10.5 15H13v-4h2v4h2.5z"
})), 'SwapVerticalCircle');

exports.default = _default;

/***/ }),
/* 2173 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20 4h-3.17L15 2H9L7.17 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-5 11.5V13H9v2.5L5.5 12 9 8.5V11h6V8.5l3.5 3.5-3.5 3.5z"
})), 'SwitchCamera');

exports.default = _default;

/***/ }),
/* 2174 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M18 9.5V6c0-.55-.45-1-1-1H3c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h14c.55 0 1-.45 1-1v-3.5l4 4v-13l-4 4zm-5 6V13H7v2.5L3.5 12 7 8.5V11h6V8.5l3.5 3.5-3.5 3.5z"
})), 'SwitchVideo');

exports.default = _default;

/***/ }),
/* 2175 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 4V1L8 5l4 4V6c3.31 0 6 2.69 6 6 0 1.01-.25 1.97-.7 2.8l1.46 1.46C19.54 15.03 20 13.57 20 12c0-4.42-3.58-8-8-8zm0 14c-3.31 0-6-2.69-6-6 0-1.01.25-1.97.7-2.8L5.24 7.74C4.46 8.97 4 10.43 4 12c0 4.42 3.58 8 8 8v3l4-4-4-4v3z"
})), 'Sync');

exports.default = _default;

/***/ }),
/* 2176 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M10 6.35V4.26c-.8.21-1.55.54-2.23.96l1.46 1.46c.25-.12.5-.24.77-.33zm-7.14-.94l2.36 2.36C4.45 8.99 4 10.44 4 12c0 2.21.91 4.2 2.36 5.64L4 20h6v-6l-2.24 2.24C6.68 15.15 6 13.66 6 12c0-1 .25-1.94.68-2.77l8.08 8.08c-.25.13-.5.25-.77.34v2.09c.8-.21 1.55-.54 2.23-.96l2.36 2.36 1.27-1.27L4.14 4.14 2.86 5.41zM20 4h-6v6l2.24-2.24C17.32 8.85 18 10.34 18 12c0 1-.25 1.94-.68 2.77l1.46 1.46C19.55 15.01 20 13.56 20 12c0-2.21-.91-4.2-2.36-5.64L20 4z"
})), 'SyncDisabled');

exports.default = _default;

/***/ }),
/* 2177 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M3 12c0 2.21.91 4.2 2.36 5.64L3 20h6v-6l-2.24 2.24C5.68 15.15 5 13.66 5 12c0-2.61 1.67-4.83 4-5.65V4.26C5.55 5.15 3 8.27 3 12zm8 5h2v-2h-2v2zM21 4h-6v6l2.24-2.24C18.32 8.85 19 10.34 19 12c0 2.61-1.67 4.83-4 5.65v2.09c3.45-.89 6-4.01 6-7.74 0-2.21-.91-4.2-2.36-5.64L21 4zm-10 9h2V7h-2v6z"
})), 'SyncProblem');

exports.default = _default;

/***/ }),
/* 2178 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M17 1.01L7 1c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM17 19H7V5h10v14zm-1-6h-3V8h-2v5H8l4 4 4-4z"
})), 'SystemUpdate');

exports.default = _default;

/***/ }),
/* 2179 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 16.5l4-4h-3v-9h-2v9H8l4 4zm9-13h-6v1.99h6v14.03H3V5.49h6V3.5H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2v-14c0-1.1-.9-2-2-2z"
})), 'SystemUpdateAlt');

exports.default = _default;

/***/ }),
/* 2180 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H3V5h10v4h8v10z"
})), 'Tab');

exports.default = _default;

/***/ }),
/* 2181 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M21 4H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h18c1.1 0 1.99-.9 1.99-2L23 6c0-1.1-.9-2-2-2zm-2 14H5V6h14v12z"
})), 'Tablet');

exports.default = _default;

/***/ }),
/* 2182 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M18 0H6C4.34 0 3 1.34 3 3v18c0 1.66 1.34 3 3 3h12c1.66 0 3-1.34 3-3V3c0-1.66-1.34-3-3-3zm-4 22h-4v-1h4v1zm5.25-3H4.75V3h14.5v16z"
})), 'TabletAndroid');

exports.default = _default;

/***/ }),
/* 2183 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M18.5 0h-14C3.12 0 2 1.12 2 2.5v19C2 22.88 3.12 24 4.5 24h14c1.38 0 2.5-1.12 2.5-2.5v-19C21 1.12 19.88 0 18.5 0zm-7 23c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm7.5-4H4V3h15v16z"
})), 'TabletMac');

exports.default = _default;

/***/ }),
/* 2184 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M1 9h2V7H1v2zm0 4h2v-2H1v2zm0-8h2V3c-1.1 0-2 .9-2 2zm8 16h2v-2H9v2zm-8-4h2v-2H1v2zm2 4v-2H1c0 1.1.9 2 2 2zM21 3h-8v6h10V5c0-1.1-.9-2-2-2zm0 14h2v-2h-2v2zM9 5h2V3H9v2zM5 21h2v-2H5v2zM5 5h2V3H5v2zm16 16c1.1 0 2-.9 2-2h-2v2zm0-8h2v-2h-2v2zm-8 8h2v-2h-2v2zm4 0h2v-2h-2v2z"
})), 'TabUnselected');

exports.default = _default;

/***/ }),
/* 2185 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm3.5-9c.83 0 1.5-.67 1.5-1.5S16.33 8 15.5 8 14 8.67 14 9.5s.67 1.5 1.5 1.5zm-7 0c.83 0 1.5-.67 1.5-1.5S9.33 8 8.5 8 7 8.67 7 9.5 7.67 11 8.5 11zm3.5 6.5c2.33 0 4.31-1.46 5.11-3.5H6.89c.8 2.04 2.78 3.5 5.11 3.5z"
})), 'TagFaces');

exports.default = _default;

/***/ }),
/* 2186 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M2 16v2c2.76 0 5 2.24 5 5h2c0-3.87-3.13-7-7-7zm0 4v3h3c0-1.66-1.34-3-3-3zm0-8v2c4.97 0 9 4.03 9 9h2c0-6.08-4.92-11-11-11zM17 1.01L7 1c-1.1 0-2 .9-2 2v7.37c.69.16 1.36.37 2 .64V5h10v13h-3.03c.52 1.25.84 2.59.95 4H17c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99z"
})), 'TapAndPlay');

exports.default = _default;

/***/ }),
/* 2187 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M14 6l-3.75 5 2.85 3.8-1.6 1.2C9.81 13.75 7 10 7 10l-6 8h22L14 6z"
})), 'Terrain');

exports.default = _default;

/***/ }),
/* 2188 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M2.5 4v3h5v12h3V7h5V4h-13zm19 5h-9v3h3v7h3v-7h3V9z"
})), 'TextFields');

exports.default = _default;

/***/ }),
/* 2189 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M5 17v2h14v-2H5zm4.5-4.2h5l.9 2.2h2.1L12.75 4h-1.5L6.5 15h2.1l.9-2.2zM12 5.98L13.87 11h-3.74L12 5.98z"
})), 'TextFormat');

exports.default = _default;

/***/ }),
/* 2190 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM9 11H7V9h2v2zm4 0h-2V9h2v2zm4 0h-2V9h2v2z"
})), 'Textsms');

exports.default = _default;

/***/ }),
/* 2191 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M19.51 3.08L3.08 19.51c.09.34.27.65.51.9.25.24.56.42.9.51L20.93 4.49c-.19-.69-.73-1.23-1.42-1.41zM11.88 3L3 11.88v2.83L14.71 3h-2.83zM5 3c-1.1 0-2 .9-2 2v2l4-4H5zm14 18c.55 0 1.05-.22 1.41-.59.37-.36.59-.86.59-1.41v-2l-4 4h2zm-9.71 0h2.83L21 12.12V9.29L9.29 21z"
})), 'Texture');

exports.default = _default;

/***/ }),
/* 2192 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M18 3v2h-2V3H8v2H6V3H4v18h2v-2h2v2h8v-2h2v2h2V3h-2zM8 17H6v-2h2v2zm0-4H6v-2h2v2zm0-4H6V7h2v2zm10 8h-2v-2h2v2zm0-4h-2v-2h2v2zm0-4h-2V7h2v2z"
})), 'Theaters');

exports.default = _default;

/***/ }),
/* 2193 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M7.52 21.48C4.25 19.94 1.91 16.76 1.55 13H.05C.56 19.16 5.71 24 12 24l.66-.03-3.81-3.81-1.33 1.32zm.89-6.52c-.19 0-.37-.03-.52-.08-.16-.06-.29-.13-.4-.24-.11-.1-.2-.22-.26-.37-.06-.14-.09-.3-.09-.47h-1.3c0 .36.07.68.21.95.14.27.33.5.56.69.24.18.51.32.82.41.3.1.62.15.96.15.37 0 .72-.05 1.03-.15.32-.1.6-.25.83-.44s.42-.43.55-.72c.13-.29.2-.61.2-.97 0-.19-.02-.38-.07-.56-.05-.18-.12-.35-.23-.51-.1-.16-.24-.3-.4-.43-.17-.13-.37-.23-.61-.31.2-.09.37-.2.52-.33.15-.13.27-.27.37-.42.1-.15.17-.3.22-.46.05-.16.07-.32.07-.48 0-.36-.06-.68-.18-.96-.12-.28-.29-.51-.51-.69-.2-.19-.47-.33-.77-.43C9.1 8.05 8.76 8 8.39 8c-.36 0-.69.05-1 .16-.3.11-.57.26-.79.45-.21.19-.38.41-.51.67-.12.26-.18.54-.18.85h1.3c0-.17.03-.32.09-.45s.14-.25.25-.34c.11-.09.23-.17.38-.22.15-.05.3-.08.48-.08.4 0 .7.1.89.31.19.2.29.49.29.86 0 .18-.03.34-.08.49-.05.15-.14.27-.25.37-.11.1-.25.18-.41.24-.16.06-.36.09-.58.09H7.5v1.03h.77c.22 0 .42.02.6.07s.33.13.45.23c.12.11.22.24.29.4.07.16.1.35.1.57 0 .41-.12.72-.35.93-.23.23-.55.33-.95.33zm8.55-5.92c-.32-.33-.7-.59-1.14-.77-.43-.18-.92-.27-1.46-.27H12v8h2.3c.55 0 1.06-.09 1.51-.27.45-.18.84-.43 1.16-.76.32-.33.57-.73.74-1.19.17-.47.26-.99.26-1.57v-.4c0-.58-.09-1.1-.26-1.57-.18-.47-.43-.87-.75-1.2zm-.39 3.16c0 .42-.05.79-.14 1.13-.1.33-.24.62-.43.85-.19.23-.43.41-.71.53-.29.12-.62.18-.99.18h-.91V9.12h.97c.72 0 1.27.23 1.64.69.38.46.57 1.12.57 1.99v.4zM12 0l-.66.03 3.81 3.81 1.33-1.33c3.27 1.55 5.61 4.72 5.96 8.48h1.5C23.44 4.84 18.29 0 12 0z"
})), 'ThreeDRotation');

exports.default = _default;

/***/ }),
/* 2194 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M15 3H6c-.83 0-1.54.5-1.84 1.22l-3.02 7.05c-.09.23-.14.47-.14.73v1.91l.01.01L1 14c0 1.1.9 2 2 2h6.31l-.95 4.57-.03.32c0 .41.17.79.44 1.06L9.83 23l6.59-6.59c.36-.36.58-.86.58-1.41V5c0-1.1-.9-2-2-2zm4 0v12h4V3h-4z"
})), 'ThumbDown');

exports.default = _default;

/***/ }),
/* 2195 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 6c0-.55-.45-1-1-1H5.82l.66-3.18.02-.23c0-.31-.13-.59-.33-.8L5.38 0 .44 4.94C.17 5.21 0 5.59 0 6v6.5c0 .83.67 1.5 1.5 1.5h6.75c.62 0 1.15-.38 1.38-.91l2.26-5.29c.07-.17.11-.36.11-.55V6zm10.5 4h-6.75c-.62 0-1.15.38-1.38.91l-2.26 5.29c-.07.17-.11.36-.11.55V18c0 .55.45 1 1 1h5.18l-.66 3.18-.02.24c0 .31.13.59.33.8l.79.78 4.94-4.94c.27-.27.44-.65.44-1.06v-6.5c0-.83-.67-1.5-1.5-1.5z"
})), 'ThumbsUpDown');

exports.default = _default;

/***/ }),
/* 2196 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M1 21h4V9H1v12zm22-11c0-1.1-.9-2-2-2h-6.31l.95-4.57.03-.32c0-.41-.17-.79-.44-1.06L14.17 1 7.59 7.59C7.22 7.95 7 8.45 7 9v10c0 1.1.9 2 2 2h9c.83 0 1.54-.5 1.84-1.22l3.02-7.05c.09-.23.14-.47.14-.73v-1.91l-.01-.01L23 10z"
})), 'ThumbUp');

exports.default = _default;

/***/ }),
/* 2197 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M16.24 7.76C15.07 6.59 13.54 6 12 6v6l-4.24 4.24c2.34 2.34 6.14 2.34 8.49 0 2.34-2.34 2.34-6.14-.01-8.48zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
})), 'Timelapse');

exports.default = _default;

/***/ }),
/* 2198 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M23 8c0 1.1-.9 2-2 2-.18 0-.35-.02-.51-.07l-3.56 3.55c.05.16.07.34.07.52 0 1.1-.9 2-2 2s-2-.9-2-2c0-.18.02-.36.07-.52l-2.55-2.55c-.16.05-.34.07-.52.07s-.36-.02-.52-.07l-4.55 4.56c.05.16.07.33.07.51 0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2c.18 0 .35.02.51.07l4.56-4.55C8.02 9.36 8 9.18 8 9c0-1.1.9-2 2-2s2 .9 2 2c0 .18-.02.36-.07.52l2.55 2.55c.16-.05.34-.07.52-.07s.36.02.52.07l3.55-3.56C19.02 8.35 19 8.18 19 8c0-1.1.9-2 2-2s2 .9 2 2z"
})), 'Timeline');

exports.default = _default;

/***/ }),
/* 2199 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M15 1H9v2h6V1zm-4 13h2V8h-2v6zm8.03-6.61l1.42-1.42c-.43-.51-.9-.99-1.41-1.41l-1.42 1.42C16.07 4.74 14.12 4 12 4c-4.97 0-9 4.03-9 9s4.02 9 9 9 9-4.03 9-9c0-2.12-.74-4.07-1.97-5.61zM12 20c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z"
})), 'Timer');

exports.default = _default;

/***/ }),
/* 2200 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M0 7.72V9.4l3-1V18h2V6h-.25L0 7.72zm23.78 6.65c-.14-.28-.35-.53-.63-.74-.28-.21-.61-.39-1.01-.53s-.85-.27-1.35-.38c-.35-.07-.64-.15-.87-.23-.23-.08-.41-.16-.55-.25-.14-.09-.23-.19-.28-.3-.05-.11-.08-.24-.08-.39 0-.14.03-.28.09-.41.06-.13.15-.25.27-.34.12-.1.27-.18.45-.24s.4-.09.64-.09c.25 0 .47.04.66.11.19.07.35.17.48.29.13.12.22.26.29.42.06.16.1.32.1.49h1.95c0-.39-.08-.75-.24-1.09-.16-.34-.39-.63-.69-.88-.3-.25-.66-.44-1.09-.59C21.49 9.07 21 9 20.46 9c-.51 0-.98.07-1.39.21-.41.14-.77.33-1.06.57-.29.24-.51.52-.67.84-.16.32-.23.65-.23 1.01s.08.69.23.96c.15.28.36.52.64.73.27.21.6.38.98.53.38.14.81.26 1.27.36.39.08.71.17.95.26s.43.19.57.29c.13.1.22.22.27.34.05.12.07.25.07.39 0 .32-.13.57-.4.77-.27.2-.66.29-1.17.29-.22 0-.43-.02-.64-.08-.21-.05-.4-.13-.56-.24-.17-.11-.3-.26-.41-.44-.11-.18-.17-.41-.18-.67h-1.89c0 .36.08.71.24 1.05.16.34.39.65.7.93.31.27.69.49 1.15.66.46.17.98.25 1.58.25.53 0 1.01-.06 1.44-.19.43-.13.8-.31 1.11-.54.31-.23.54-.51.71-.83.17-.32.25-.67.25-1.06-.02-.4-.09-.74-.24-1.02zm-9.96-7.32c-.34-.4-.75-.7-1.23-.88-.47-.18-1.01-.27-1.59-.27-.58 0-1.11.09-1.59.27-.48.18-.89.47-1.23.88-.34.41-.6.93-.79 1.59-.18.65-.28 1.45-.28 2.39v1.92c0 .94.09 1.74.28 2.39.19.66.45 1.19.8 1.6.34.41.75.71 1.23.89.48.18 1.01.28 1.59.28.59 0 1.12-.09 1.59-.28.48-.18.88-.48 1.22-.89.34-.41.6-.94.78-1.6.18-.65.28-1.45.28-2.39v-1.92c0-.94-.09-1.74-.28-2.39-.18-.66-.44-1.19-.78-1.59zm-.92 6.17c0 .6-.04 1.11-.12 1.53-.08.42-.2.76-.36 1.02-.16.26-.36.45-.59.57-.23.12-.51.18-.82.18-.3 0-.58-.06-.82-.18s-.44-.31-.6-.57c-.16-.26-.29-.6-.38-1.02-.09-.42-.13-.93-.13-1.53v-2.5c0-.6.04-1.11.13-1.52.09-.41.21-.74.38-1 .16-.25.36-.43.6-.55.24-.11.51-.17.81-.17.31 0 .58.06.81.17.24.11.44.29.6.55.16.25.29.58.37.99.08.41.13.92.13 1.52v2.51z"
})), 'Timer10');

exports.default = _default;

/***/ }),
/* 2201 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M11.61 12.97c-.16-.24-.36-.46-.62-.65-.25-.19-.56-.35-.93-.48.3-.14.57-.3.8-.5.23-.2.42-.41.57-.64.15-.23.27-.46.34-.71.08-.24.11-.49.11-.73 0-.55-.09-1.04-.28-1.46-.18-.42-.44-.77-.78-1.06-.33-.28-.73-.5-1.2-.64-.45-.13-.97-.2-1.53-.2-.55 0-1.06.08-1.52.24-.47.17-.87.4-1.2.69-.33.29-.6.63-.78 1.03-.2.39-.29.83-.29 1.29h1.98c0-.26.05-.49.14-.69.09-.2.22-.38.38-.52.17-.14.36-.25.58-.33.22-.08.46-.12.73-.12.61 0 1.06.16 1.36.47.3.31.44.75.44 1.32 0 .27-.04.52-.12.74-.08.22-.21.41-.38.57-.17.16-.38.28-.63.37-.25.09-.55.13-.89.13H6.72v1.57H7.9c.34 0 .64.04.91.11.27.08.5.19.69.35.19.16.34.36.44.61.1.24.16.54.16.87 0 .62-.18 1.09-.53 1.42-.35.33-.84.49-1.45.49-.29 0-.56-.04-.8-.13-.24-.08-.44-.2-.61-.36-.17-.16-.3-.34-.39-.56-.09-.22-.14-.46-.14-.72H4.19c0 .55.11 1.03.32 1.45.21.42.5.77.86 1.05s.77.49 1.24.63.96.21 1.48.21c.57 0 1.09-.08 1.58-.23.49-.15.91-.38 1.26-.68.36-.3.64-.66.84-1.1.2-.43.3-.93.3-1.48 0-.29-.04-.58-.11-.86-.08-.25-.19-.51-.35-.76zm9.26 1.4c-.14-.28-.35-.53-.63-.74-.28-.21-.61-.39-1.01-.53s-.85-.27-1.35-.38c-.35-.07-.64-.15-.87-.23-.23-.08-.41-.16-.55-.25-.14-.09-.23-.19-.28-.3-.05-.11-.08-.24-.08-.39s.03-.28.09-.41c.06-.13.15-.25.27-.34.12-.1.27-.18.45-.24s.4-.09.64-.09c.25 0 .47.04.66.11.19.07.35.17.48.29.13.12.22.26.29.42.06.16.1.32.1.49h1.95c0-.39-.08-.75-.24-1.09-.16-.34-.39-.63-.69-.88-.3-.25-.66-.44-1.09-.59-.43-.15-.92-.22-1.46-.22-.51 0-.98.07-1.39.21-.41.14-.77.33-1.06.57-.29.24-.51.52-.67.84-.16.32-.23.65-.23 1.01s.08.68.23.96c.15.28.37.52.64.73.27.21.6.38.98.53.38.14.81.26 1.27.36.39.08.71.17.95.26s.43.19.57.29c.13.1.22.22.27.34.05.12.07.25.07.39 0 .32-.13.57-.4.77-.27.2-.66.29-1.17.29-.22 0-.43-.02-.64-.08-.21-.05-.4-.13-.56-.24-.17-.11-.3-.26-.41-.44-.11-.18-.17-.41-.18-.67h-1.89c0 .36.08.71.24 1.05.16.34.39.65.7.93.31.27.69.49 1.15.66.46.17.98.25 1.58.25.53 0 1.01-.06 1.44-.19.43-.13.8-.31 1.11-.54.31-.23.54-.51.71-.83.17-.32.25-.67.25-1.06-.02-.4-.09-.74-.24-1.02z"
})), 'Timer3');

exports.default = _default;

/***/ }),
/* 2202 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M19.04 4.55l-1.42 1.42C16.07 4.74 14.12 4 12 4c-1.83 0-3.53.55-4.95 1.48l1.46 1.46C9.53 6.35 10.73 6 12 6c3.87 0 7 3.13 7 7 0 1.27-.35 2.47-.94 3.49l1.45 1.45C20.45 16.53 21 14.83 21 13c0-2.12-.74-4.07-1.97-5.61l1.42-1.42-1.41-1.42zM15 1H9v2h6V1zm-4 8.44l2 2V8h-2v1.44zM3.02 4L1.75 5.27 4.5 8.03C3.55 9.45 3 11.16 3 13c0 4.97 4.02 9 9 9 1.84 0 3.55-.55 4.98-1.5l2.5 2.5 1.27-1.27-7.71-7.71L3.02 4zM12 20c-3.87 0-7-3.13-7-7 0-1.28.35-2.48.95-3.52l9.56 9.56c-1.03.61-2.23.96-3.51.96z"
})), 'TimerOff');

exports.default = _default;

/***/ }),
/* 2203 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M18.92 5.01C18.72 4.42 18.16 4 17.5 4h-11c-.66 0-1.21.42-1.42 1.01L3 11v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-8l-2.08-5.99zM6.5 15c-.83 0-1.5-.67-1.5-1.5S5.67 12 6.5 12s1.5.67 1.5 1.5S7.33 15 6.5 15zm11 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM5 10l1.5-4.5h11L19 10H5z"
})), 'TimeToLeave');

exports.default = _default;

/***/ }),
/* 2204 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M5 4v3h5.5v12h3V7H19V4z"
})), 'Title');

exports.default = _default;

/***/ }),
/* 2205 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M3 9h14V7H3v2zm0 4h14v-2H3v2zm0 4h14v-2H3v2zm16 0h2v-2h-2v2zm0-10v2h2V7h-2zm0 6h2v-2h-2v2z"
})), 'Toc');

exports.default = _default;

/***/ }),
/* 2206 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M19 3h-1V1h-2v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V8h14v11zM7 10h5v5H7z"
})), 'Today');

exports.default = _default;

/***/ }),
/* 2207 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M15 4c-4.42 0-8 3.58-8 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8zm0 14c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6zM3 12c0-2.61 1.67-4.83 4-5.65V4.26C3.55 5.15 1 8.27 1 12s2.55 6.85 6 7.74v-2.09c-2.33-.82-4-3.04-4-5.65z"
})), 'Toll');

exports.default = _default;

/***/ }),
/* 2208 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.94-.49-7-3.85-7-7.93s3.05-7.44 7-7.93v15.86zm2-15.86c1.03.13 2 .45 2.87.93H13v-.93zM13 7h5.24c.25.31.48.65.68 1H13V7zm0 3h6.74c.08.33.15.66.19 1H13v-1zm0 9.93V19h2.87c-.87.48-1.84.8-2.87.93zM18.24 17H13v-1h5.92c-.2.35-.43.69-.68 1zm1.5-3H13v-1h6.93c-.04.34-.11.67-.19 1z"
})), 'Tonality');

exports.default = _default;

/***/ }),
/* 2209 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M9 11.24V7.5C9 6.12 10.12 5 11.5 5S14 6.12 14 7.5v3.74c1.21-.81 2-2.18 2-3.74C16 5.01 13.99 3 11.5 3S7 5.01 7 7.5c0 1.56.79 2.93 2 3.74zm9.84 4.63l-4.54-2.26c-.17-.07-.35-.11-.54-.11H13v-6c0-.83-.67-1.5-1.5-1.5S10 6.67 10 7.5v10.74l-3.43-.72c-.08-.01-.15-.03-.24-.03-.31 0-.59.13-.79.33l-.79.8 4.94 4.94c.27.27.65.44 1.06.44h6.79c.75 0 1.33-.55 1.44-1.28l.75-5.27c.01-.07.02-.14.02-.2 0-.62-.38-1.16-.91-1.38z"
})), 'TouchApp');

exports.default = _default;

/***/ }),
/* 2210 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 12c0-3 2.5-5.5 5.5-5.5S23 9 23 12H12zm0 0c0 3-2.5 5.5-5.5 5.5S1 15 1 12h11zm0 0c-3 0-5.5-2.5-5.5-5.5S9 1 12 1v11zm0 0c3 0 5.5 2.5 5.5 5.5S15 23 12 23V12z"
})), 'Toys');

exports.default = _default;

/***/ }),
/* 2211 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M19.07 4.93l-1.41 1.41C19.1 7.79 20 9.79 20 12c0 4.42-3.58 8-8 8s-8-3.58-8-8c0-4.08 3.05-7.44 7-7.93v2.02C8.16 6.57 6 9.03 6 12c0 3.31 2.69 6 6 6s6-2.69 6-6c0-1.66-.67-3.16-1.76-4.24l-1.41 1.41C15.55 9.9 16 10.9 16 12c0 2.21-1.79 4-4 4s-4-1.79-4-4c0-1.86 1.28-3.41 3-3.86v2.14c-.6.35-1 .98-1 1.72 0 1.1.9 2 2 2s2-.9 2-2c0-.74-.4-1.38-1-1.72V2h-1C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10c0-2.76-1.12-5.26-2.93-7.07z"
})), 'TrackChanges');

exports.default = _default;

/***/ }),
/* 2212 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20 10h-3V8.86c1.72-.45 3-2 3-3.86h-3V4c0-.55-.45-1-1-1H8c-.55 0-1 .45-1 1v1H4c0 1.86 1.28 3.41 3 3.86V10H4c0 1.86 1.28 3.41 3 3.86V15H4c0 1.86 1.28 3.41 3 3.86V20c0 .55.45 1 1 1h8c.55 0 1-.45 1-1v-1.14c1.72-.45 3-2 3-3.86h-3v-1.14c1.72-.45 3-2 3-3.86zm-8 9c-1.11 0-2-.9-2-2s.89-2 2-2c1.1 0 2 .9 2 2s-.89 2-2 2zm0-5c-1.11 0-2-.9-2-2s.89-2 2-2c1.1 0 2 .9 2 2s-.89 2-2 2zm0-5c-1.11 0-2-.9-2-2 0-1.11.89-2 2-2 1.1 0 2 .89 2 2 0 1.1-.89 2-2 2z"
})), 'Traffic');

exports.default = _default;

/***/ }),
/* 2213 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 2c-4 0-8 .5-8 4v9.5C4 17.43 5.57 19 7.5 19L6 20.5v.5h2.23l2-2H14l2 2h2v-.5L16.5 19c1.93 0 3.5-1.57 3.5-3.5V6c0-3.5-3.58-4-8-4zM7.5 17c-.83 0-1.5-.67-1.5-1.5S6.67 14 7.5 14s1.5.67 1.5 1.5S8.33 17 7.5 17zm3.5-7H6V6h5v4zm2 0V6h5v4h-5zm3.5 7c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"
})), 'Train');

exports.default = _default;

/***/ }),
/* 2214 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M19 16.94V8.5c0-2.79-2.61-3.4-6.01-3.49l.76-1.51H17V2H7v1.5h4.75l-.76 1.52C7.86 5.11 5 5.73 5 8.5v8.44c0 1.45 1.19 2.66 2.59 2.97L6 21.5v.5h2.23l2-2H14l2 2h2v-.5L16.5 20h-.08c1.69 0 2.58-1.37 2.58-3.06zm-7 1.56c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm5-4.5H7V9h10v5z"
})), 'Tram');

exports.default = _default;

/***/ }),
/* 2215 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M16.49 15.5v-1.75L14 16.25l2.49 2.5V17H22v-1.5zm3.02 4.25H14v1.5h5.51V23L22 20.5 19.51 18zM9.5 5.5c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zM5.75 8.9L3 23h2.1l1.75-8L9 17v6h2v-7.55L8.95 13.4l.6-3C10.85 12 12.8 13 15 13v-2c-1.85 0-3.45-1-4.35-2.45l-.95-1.6C9.35 6.35 8.7 6 8 6c-.25 0-.5.05-.75.15L2 8.3V13h2V9.65l1.75-.75"
})), 'TransferWithinAStation');

exports.default = _default;

/***/ }),
/* 2216 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M22 18v-2H8V4h2L7 1 4 4h2v2H2v2h4v8c0 1.1.9 2 2 2h8v2h-2l3 3 3-3h-2v-2h4zM10 8h6v6h2V8c0-1.1-.9-2-2-2h-6v2z"
})), 'Transform');

exports.default = _default;

/***/ }),
/* 2217 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12.87 15.07l-2.54-2.51.03-.03c1.74-1.94 2.98-4.17 3.71-6.53H17V4h-7V2H8v2H1v1.99h11.17C11.5 7.92 10.44 9.75 9 11.35 8.07 10.32 7.3 9.19 6.69 8h-2c.73 1.63 1.73 3.17 2.98 4.56l-5.09 5.02L4 19l5-5 3.11 3.11.76-2.04zM18.5 10h-2L12 22h2l1.12-3h4.75L21 22h2l-4.5-12zm-2.62 7l1.62-4.33L19.12 17h-3.24z"
})), 'Translate');

exports.default = _default;

/***/ }),
/* 2218 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M16 18l2.29-2.29-4.88-4.88-4 4L2 7.41 3.41 6l6 6 4-4 6.3 6.29L22 12v6z"
})), 'TrendingDown');

exports.default = _default;

/***/ }),
/* 2219 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M22 12l-4-4v3H3v2h15v3z"
})), 'TrendingFlat');

exports.default = _default;

/***/ }),
/* 2220 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M16 6l2.29 2.29-4.88 4.88-4-4L2 16.59 3.41 18l6-6 4 4 6.3-6.29L22 12V6z"
})), 'TrendingUp');

exports.default = _default;

/***/ }),
/* 2221 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M3 17v2h6v-2H3zM3 5v2h10V5H3zm10 16v-2h8v-2h-8v-2h-2v6h2zM7 9v2H3v2h4v2h2V9H7zm14 4v-2H11v2h10zm-6-4h2V7h4V5h-4V3h-2v6z"
})), 'Tune');

exports.default = _default;

/***/ }),
/* 2222 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M17 3H7c-1.1 0-1.99.9-1.99 2L5 21l7-3 7 3V5c0-1.1-.9-2-2-2z"
})), 'TurnedIn');

exports.default = _default;

/***/ }),
/* 2223 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M17 3H7c-1.1 0-1.99.9-1.99 2L5 21l7-3 7 3V5c0-1.1-.9-2-2-2zm0 15l-5-2.18L7 18V5h10v13z"
})), 'TurnedInNot');

exports.default = _default;

/***/ }),
/* 2224 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M21 3H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h5v2h8v-2h5c1.1 0 1.99-.9 1.99-2L23 5c0-1.1-.9-2-2-2zm0 14H3V5h18v12z"
})), 'Tv');

exports.default = _default;

/***/ }),
/* 2225 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20.55 5.22l-1.39-1.68C18.88 3.21 18.47 3 18 3H6c-.47 0-.88.21-1.15.55L3.46 5.22C3.17 5.57 3 6.01 3 6.5V19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6.5c0-.49-.17-.93-.45-1.28zM12 9.5l5.5 5.5H14v2h-4v-2H6.5L12 9.5zM5.12 5l.82-1h12l.93 1H5.12z"
})), 'Unarchive');

exports.default = _default;

/***/ }),
/* 2226 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12.5 8c-2.65 0-5.05.99-6.9 2.6L2 7v9h9l-3.62-3.62c1.39-1.16 3.16-1.88 5.12-1.88 3.54 0 6.55 2.31 7.6 5.5l2.37-.78C21.08 11.03 17.15 8 12.5 8z"
})), 'Undo');

exports.default = _default;

/***/ }),
/* 2227 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M7.41 18.59L8.83 20 12 16.83 15.17 20l1.41-1.41L12 14l-4.59 4.59zm9.18-13.18L15.17 4 12 7.17 8.83 4 7.41 5.41 12 10l4.59-4.59z"
})), 'UnfoldLess');

exports.default = _default;

/***/ }),
/* 2228 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 5.83L15.17 9l1.41-1.41L12 3 7.41 7.59 8.83 9 12 5.83zm0 12.34L8.83 15l-1.41 1.41L12 21l4.59-4.59L15.17 15 12 18.17z"
})), 'UnfoldMore');

exports.default = _default;

/***/ }),
/* 2229 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M21 10.12h-6.78l2.74-2.82c-2.73-2.7-7.15-2.8-9.88-.1-2.73 2.71-2.73 7.08 0 9.79 2.73 2.71 7.15 2.71 9.88 0C18.32 15.65 19 14.08 19 12.1h2c0 1.98-.88 4.55-2.64 6.29-3.51 3.48-9.21 3.48-12.72 0-3.5-3.47-3.53-9.11-.02-12.58 3.51-3.47 9.14-3.47 12.65 0L21 3v7.12zM12.5 8v4.25l3.5 2.08-.72 1.21L11 13V8h1.5z"
})), 'Update');

exports.default = _default;

/***/ }),
/* 2230 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M15 7v4h1v2h-3V5h2l-3-4-3 4h2v8H8v-2.07c.7-.37 1.2-1.08 1.2-1.93 0-1.21-.99-2.2-2.2-2.2-1.21 0-2.2.99-2.2 2.2 0 .85.5 1.56 1.2 1.93V13c0 1.11.89 2 2 2h3v3.05c-.71.37-1.2 1.1-1.2 1.95 0 1.22.99 2.2 2.2 2.2 1.21 0 2.2-.98 2.2-2.2 0-.85-.49-1.58-1.2-1.95V15h3c1.11 0 2-.89 2-2v-2h1V7h-4z"
})), 'Usb');

exports.default = _default;

/***/ }),
/* 2231 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm-2 16l-4-4 1.41-1.41L10 14.17l6.59-6.59L18 9l-8 8z"
})), 'VerifiedUser');

exports.default = _default;

/***/ }),
/* 2232 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M16 13h-3V3h-2v10H8l4 4 4-4zM4 19v2h16v-2H4z"
})), 'VerticalAlignBottom');

exports.default = _default;

/***/ }),
/* 2233 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M8 19h3v4h2v-4h3l-4-4-4 4zm8-14h-3V1h-2v4H8l4 4 4-4zM4 11v2h16v-2H4z"
})), 'VerticalAlignCenter');

exports.default = _default;

/***/ }),
/* 2234 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M8 11h3v10h2V11h3l-4-4-4 4zM4 3v2h16V3H4z"
})), 'VerticalAlignTop');

exports.default = _default;

/***/ }),
/* 2235 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M0 15h2V9H0v6zm3 2h2V7H3v10zm19-8v6h2V9h-2zm-3 8h2V7h-2v10zM16.5 3h-9C6.67 3 6 3.67 6 4.5v15c0 .83.67 1.5 1.5 1.5h9c.83 0 1.5-.67 1.5-1.5v-15c0-.83-.67-1.5-1.5-1.5zM16 19H8V5h8v14z"
})), 'Vibration');

exports.default = _default;

/***/ }),
/* 2236 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M17 10.5V7c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h12c.55 0 1-.45 1-1v-3.5l4 4v-11l-4 4zM14 13h-3v3H9v-3H6v-2h3V8h2v3h3v2z"
})), 'VideoCall');

exports.default = _default;

/***/ }),
/* 2237 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M17 10.5V7c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h12c.55 0 1-.45 1-1v-3.5l4 4v-11l-4 4z"
})), 'Videocam');

exports.default = _default;

/***/ }),
/* 2238 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M21 6.5l-4 4V7c0-.55-.45-1-1-1H9.82L21 17.18V6.5zM3.27 2L2 3.27 4.73 6H4c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h12c.21 0 .39-.08.54-.18L19.73 21 21 19.73 3.27 2z"
})), 'VideocamOff');

exports.default = _default;

/***/ }),
/* 2239 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M21 6H3c-1.1 0-2 .9-2 2v8c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm-10 7H8v3H6v-3H3v-2h3V8h2v3h3v2zm4.5 2c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm4-3c-.83 0-1.5-.67-1.5-1.5S18.67 9 19.5 9s1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"
})), 'VideogameAsset');

exports.default = _default;

/***/ }),
/* 2240 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 13H3V5h18v11z"
})), 'VideoLabel');

exports.default = _default;

/***/ }),
/* 2241 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm16-4H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-8 12.5v-9l6 4.5-6 4.5z"
})), 'VideoLibrary');

exports.default = _default;

/***/ }),
/* 2242 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20 13H3c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1h17c.55 0 1-.45 1-1v-6c0-.55-.45-1-1-1zm0-10H3c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1h17c.55 0 1-.45 1-1V4c0-.55-.45-1-1-1z"
})), 'ViewAgenda');

exports.default = _default;

/***/ }),
/* 2243 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M4 18h3V5H4v13zM18 5v13h3V5h-3zM8 18h9V5H8v13z"
})), 'ViewArray');

exports.default = _default;

/***/ }),
/* 2244 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M7 19h10V4H7v15zm-5-2h4V6H2v11zM18 6v11h4V6h-4z"
})), 'ViewCarousel');

exports.default = _default;

/***/ }),
/* 2245 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M10 18h5V5h-5v13zm-6 0h5V5H4v13zM16 5v13h5V5h-5z"
})), 'ViewColumn');

exports.default = _default;

/***/ }),
/* 2246 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M3 9h4V5H3v4zm0 5h4v-4H3v4zm5 0h4v-4H8v4zm5 0h4v-4h-4v4zM8 9h4V5H8v4zm5-4v4h4V5h-4zm5 9h4v-4h-4v4zM3 19h4v-4H3v4zm5 0h4v-4H8v4zm5 0h4v-4h-4v4zm5 0h4v-4h-4v4zm0-14v4h4V5h-4z"
})), 'ViewComfy');

exports.default = _default;

/***/ }),
/* 2247 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M3 19h6v-7H3v7zm7 0h12v-7H10v7zM3 5v6h19V5H3z"
})), 'ViewCompact');

exports.default = _default;

/***/ }),
/* 2248 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M2 21h19v-3H2v3zM20 8H3c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1h17c.55 0 1-.45 1-1V9c0-.55-.45-1-1-1zM2 3v3h19V3H2z"
})), 'ViewDay');

exports.default = _default;

/***/ }),
/* 2249 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M4 15h16v-2H4v2zm0 4h16v-2H4v2zm0-8h16V9H4v2zm0-6v2h16V5H4z"
})), 'ViewHeadline');

exports.default = _default;

/***/ }),
/* 2250 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M4 14h4v-4H4v4zm0 5h4v-4H4v4zM4 9h4V5H4v4zm5 5h12v-4H9v4zm0 5h12v-4H9v4zM9 5v4h12V5H9z"
})), 'ViewList');

exports.default = _default;

/***/ }),
/* 2251 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M4 11h5V5H4v6zm0 7h5v-6H4v6zm6 0h5v-6h-5v6zm6 0h5v-6h-5v6zm-6-7h5V5h-5v6zm6-6v6h5V5h-5z"
})), 'ViewModule');

exports.default = _default;

/***/ }),
/* 2252 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M10 18h5v-6h-5v6zm-6 0h5V5H4v13zm12 0h5v-6h-5v6zM10 5v6h11V5H10z"
})), 'ViewQuilt');

exports.default = _default;

/***/ }),
/* 2253 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M4 18h17v-6H4v6zM4 5v6h17V5H4z"
})), 'ViewStream');

exports.default = _default;

/***/ }),
/* 2254 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M6 5H3c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h3c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1zm14 0h-3c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h3c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1zm-7 0h-3c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h3c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1z"
})), 'ViewWeek');

exports.default = _default;

/***/ }),
/* 2255 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-9 15c-4.42 0-8-2.69-8-6s3.58-6 8-6 8 2.69 8 6-3.58 6-8 6z"
})), 'Vignette');

exports.default = _default;

/***/ }),
/* 2256 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-2 12l-4-3.2V14H6V6h8v3.2L18 6v8z"
})), 'VoiceChat');

exports.default = _default;

/***/ }),
/* 2257 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M18.5 6C15.46 6 13 8.46 13 11.5c0 1.33.47 2.55 1.26 3.5H9.74c.79-.95 1.26-2.17 1.26-3.5C11 8.46 8.54 6 5.5 6S0 8.46 0 11.5 2.46 17 5.5 17h13c3.04 0 5.5-2.46 5.5-5.5S21.54 6 18.5 6zm-13 9C3.57 15 2 13.43 2 11.5S3.57 8 5.5 8 9 9.57 9 11.5 7.43 15 5.5 15zm13 0c-1.93 0-3.5-1.57-3.5-3.5S16.57 8 18.5 8 22 9.57 22 11.5 20.43 15 18.5 15z"
})), 'Voicemail');

exports.default = _default;

/***/ }),
/* 2258 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M18.5 12c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02zM5 9v6h4l5 5V4L9 9H5z"
})), 'VolumeDown');

exports.default = _default;

/***/ }),
/* 2259 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M7 9v6h4l5 5V4l-5 5H7z"
})), 'VolumeMute');

exports.default = _default;

/***/ }),
/* 2260 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M16.5 12c0-1.77-1.02-3.29-2.5-4.03v2.21l2.45 2.45c.03-.2.05-.41.05-.63zm2.5 0c0 .94-.2 1.82-.54 2.64l1.51 1.51C20.63 14.91 21 13.5 21 12c0-4.28-2.99-7.86-7-8.77v2.06c2.89.86 5 3.54 5 6.71zM4.27 3L3 4.27 7.73 9H3v6h4l5 5v-6.73l4.25 4.25c-.67.52-1.42.93-2.25 1.18v2.06c1.38-.31 2.63-.95 3.69-1.81L19.73 21 21 19.73l-9-9L4.27 3zM12 4L9.91 6.09 12 8.18V4z"
})), 'VolumeOff');

exports.default = _default;

/***/ }),
/* 2261 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M3 9v6h4l5 5V4L7 9H3zm13.5 3c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02zM14 3.23v2.06c2.89.86 5 3.54 5 6.71s-2.11 5.85-5 6.71v2.06c4.01-.91 7-4.49 7-8.77s-2.99-7.86-7-8.77z"
})), 'VolumeUp');

exports.default = _default;

/***/ }),
/* 2262 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12.65 10C11.83 7.67 9.61 6 7 6c-3.31 0-6 2.69-6 6s2.69 6 6 6c2.61 0 4.83-1.67 5.65-4H17v4h4v-4h2v-4H12.65zM7 14c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"
})), 'VpnKey');

exports.default = _default;

/***/ }),
/* 2263 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M22 4v-.5C22 2.12 20.88 1 19.5 1S17 2.12 17 3.5V4c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1h5c.55 0 1-.45 1-1V5c0-.55-.45-1-1-1zm-.8 0h-3.4v-.5c0-.94.76-1.7 1.7-1.7s1.7.76 1.7 1.7V4zm-2.28 8c.04.33.08.66.08 1 0 2.08-.8 3.97-2.1 5.39-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H7v-2h2c.55 0 1-.45 1-1V8h2c1.1 0 2-.9 2-2V3.46c-.95-.3-1.95-.46-3-.46C5.48 3 1 7.48 1 13s4.48 10 10 10 10-4.48 10-10c0-.34-.02-.67-.05-1h-2.03zM10 20.93c-3.95-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L8 16v1c0 1.1.9 2 2 2v1.93z"
})), 'VpnLock');

exports.default = _default;

/***/ }),
/* 2264 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M4 4h7V2H4c-1.1 0-2 .9-2 2v7h2V4zm6 9l-4 5h12l-3-4-2.03 2.71L10 13zm7-4.5c0-.83-.67-1.5-1.5-1.5S14 7.67 14 8.5s.67 1.5 1.5 1.5S17 9.33 17 8.5zM20 2h-7v2h7v7h2V4c0-1.1-.9-2-2-2zm0 18h-7v2h7c1.1 0 2-.9 2-2v-7h-2v7zM4 13H2v7c0 1.1.9 2 2 2h7v-2H4v-7z"
})), 'Wallpaper');

exports.default = _default;

/***/ }),
/* 2265 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"
})), 'Warning');

exports.default = _default;

/***/ }),
/* 2266 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20 12c0-2.54-1.19-4.81-3.04-6.27L16 0H8l-.95 5.73C5.19 7.19 4 9.45 4 12s1.19 4.81 3.05 6.27L8 24h8l.96-5.73C18.81 16.81 20 14.54 20 12zM6 12c0-3.31 2.69-6 6-6s6 2.69 6 6-2.69 6-6 6-6-2.69-6-6z"
})), 'Watch');

exports.default = _default;

/***/ }),
/* 2267 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10S17.5 2 12 2zm4.2 14.2L11 13V7h1.5v5.2l4.5 2.7-.8 1.3z"
})), 'WatchLater');

exports.default = _default;

/***/ }),
/* 2268 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M6.85 12.65h2.3L8 9l-1.15 3.65zM22 7l-1.2 6.29L19.3 7h-1.6l-1.49 6.29L15 7h-.76C12.77 5.17 10.53 4 8 4c-4.42 0-8 3.58-8 8s3.58 8 8 8c3.13 0 5.84-1.81 7.15-4.43l.1.43H17l1.5-6.1L20 16h1.75l2.05-9H22zm-11.7 9l-.7-2H6.4l-.7 2H3.8L7 7h2l3.2 9h-1.9z"
})), 'WbAuto');

exports.default = _default;

/***/ }),
/* 2269 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M19.36 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.64-4.96z"
})), 'WbCloudy');

exports.default = _default;

/***/ }),
/* 2270 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M3.55 18.54l1.41 1.41 1.79-1.8-1.41-1.41-1.79 1.8zM11 22.45h2V19.5h-2v2.95zM4 10.5H1v2h3v-2zm11-4.19V1.5H9v4.81C7.21 7.35 6 9.28 6 11.5c0 3.31 2.69 6 6 6s6-2.69 6-6c0-2.22-1.21-4.15-3-5.19zm5 4.19v2h3v-2h-3zm-2.76 7.66l1.79 1.8 1.41-1.41-1.8-1.79-1.4 1.4z"
})), 'WbIncandescent');

exports.default = _default;

/***/ }),
/* 2271 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M5 14.5h14v-6H5v6zM11 .55V3.5h2V.55h-2zm8.04 2.5l-1.79 1.79 1.41 1.41 1.8-1.79-1.42-1.41zM13 22.45V19.5h-2v2.95h2zm7.45-3.91l-1.8-1.79-1.41 1.41 1.79 1.8 1.42-1.42zM3.55 4.46l1.79 1.79 1.41-1.41-1.79-1.79-1.41 1.41zm1.41 15.49l1.79-1.8-1.41-1.41-1.79 1.79 1.41 1.42z"
})), 'WbIridescent');

exports.default = _default;

/***/ }),
/* 2272 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M6.76 4.84l-1.8-1.79-1.41 1.41 1.79 1.79 1.42-1.41zM4 10.5H1v2h3v-2zm9-9.95h-2V3.5h2V.55zm7.45 3.91l-1.41-1.41-1.79 1.79 1.41 1.41 1.79-1.79zm-3.21 13.7l1.79 1.8 1.41-1.41-1.8-1.79-1.4 1.4zM20 10.5v2h3v-2h-3zm-8-5c-3.31 0-6 2.69-6 6s2.69 6 6 6 6-2.69 6-6-2.69-6-6-6zm-1 16.95h2V19.5h-2v2.95zm-7.45-3.91l1.41 1.41 1.79-1.8-1.41-1.41-1.79 1.8z"
})), 'WbSunny');

exports.default = _default;

/***/ }),
/* 2273 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M5.5 22v-7.5H4V9c0-1.1.9-2 2-2h3c1.1 0 2 .9 2 2v5.5H9.5V22h-4zM18 22v-6h3l-2.54-7.63C18.18 7.55 17.42 7 16.56 7h-.12c-.86 0-1.63.55-1.9 1.37L12 16h3v6h3zM7.5 6c1.11 0 2-.89 2-2s-.89-2-2-2-2 .89-2 2 .89 2 2 2zm9 0c1.11 0 2-.89 2-2s-.89-2-2-2-2 .89-2 2 .89 2 2 2z"
})), 'Wc');

exports.default = _default;

/***/ }),
/* 2274 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-5 14H4v-4h11v4zm0-5H4V9h11v4zm5 5h-4V9h4v9z"
})), 'Web');

exports.default = _default;

/***/ }),
/* 2275 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M19 4H5c-1.11 0-2 .9-2 2v12c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.89-2-2-2zm0 14H5V8h14v10z"
})), 'WebAsset');

exports.default = _default;

/***/ }),
/* 2276 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M21 10c-1.1 0-2 .9-2 2v3H5v-3c0-1.1-.9-2-2-2s-2 .9-2 2v5c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2v-5c0-1.1-.9-2-2-2zm-3-5H6c-1.1 0-2 .9-2 2v2.15c1.16.41 2 1.51 2 2.82V14h12v-2.03c0-1.3.84-2.4 2-2.82V7c0-1.1-.9-2-2-2z"
})), 'Weekend');

exports.default = _default;

/***/ }),
/* 2277 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M13.5.67s.74 2.65.74 4.8c0 2.06-1.35 3.73-3.41 3.73-2.07 0-3.63-1.67-3.63-3.73l.03-.36C5.21 7.51 4 10.62 4 14c0 4.42 3.58 8 8 8s8-3.58 8-8C20 8.61 17.41 3.8 13.5.67zM11.71 19c-1.78 0-3.22-1.4-3.22-3.14 0-1.62 1.05-2.76 2.81-3.12 1.77-.36 3.6-1.21 4.62-2.58.39 1.29.59 2.65.59 4.04 0 2.65-2.15 4.8-4.8 4.8z"
})), 'Whatshot');

exports.default = _default;

/***/ }),
/* 2278 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M13 13v8h8v-8h-8zM3 21h8v-8H3v8zM3 3v8h8V3H3zm13.66-1.31L11 7.34 16.66 13l5.66-5.66-5.66-5.65z"
})), 'Widgets');

exports.default = _default;

/***/ }),
/* 2279 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M1 9l2 2c4.97-4.97 13.03-4.97 18 0l2-2C16.93 2.93 7.08 2.93 1 9zm8 8l3 3 3-3c-1.65-1.66-4.34-1.66-6 0zm-4-4l2 2c2.76-2.76 7.24-2.76 10 0l2-2C15.14 9.14 8.87 9.14 5 13z"
})), 'Wifi');

exports.default = _default;

/***/ }),
/* 2280 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20.5 9.5c.28 0 .55.04.81.08L24 6c-3.34-2.51-7.5-4-12-4S3.34 3.49 0 6l12 16 3.5-4.67V14.5c0-2.76 2.24-5 5-5zM23 16v-1.5c0-1.38-1.12-2.5-2.5-2.5S18 13.12 18 14.5V16c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1h5c.55 0 1-.45 1-1v-4c0-.55-.45-1-1-1zm-1 0h-3v-1.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5V16z"
})), 'WifiLock');

exports.default = _default;

/***/ }),
/* 2281 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 11c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm6 2c0-3.31-2.69-6-6-6s-6 2.69-6 6c0 2.22 1.21 4.15 3 5.19l1-1.74c-1.19-.7-2-1.97-2-3.45 0-2.21 1.79-4 4-4s4 1.79 4 4c0 1.48-.81 2.75-2 3.45l1 1.74c1.79-1.04 3-2.97 3-5.19zM12 3C6.48 3 2 7.48 2 13c0 3.7 2.01 6.92 4.99 8.65l1-1.73C5.61 18.53 4 15.96 4 13c0-4.42 3.58-8 8-8s8 3.58 8 8c0 2.96-1.61 5.53-4 6.92l1 1.73c2.99-1.73 5-4.95 5-8.65 0-5.52-4.48-10-10-10z"
})), 'WifiTethering');

exports.default = _default;

/***/ }),
/* 2282 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20 6h-4V4c0-1.11-.89-2-2-2h-4c-1.11 0-2 .89-2 2v2H4c-1.11 0-1.99.89-1.99 2L2 19c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zm-6 0h-4V4h4v2z"
})), 'Work');

exports.default = _default;

/***/ }),
/* 2283 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M4 19h6v-2H4v2zM20 5H4v2h16V5zm-3 6H4v2h13.25c1.1 0 2 .9 2 2s-.9 2-2 2H15v-2l-3 3 3 3v-2h2c2.21 0 4-1.79 4-4s-1.79-4-4-4z"
})), 'WrapText');

exports.default = _default;

/***/ }),
/* 2284 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M17.01 14h-.8l-.27-.27c.98-1.14 1.57-2.61 1.57-4.23 0-3.59-2.91-6.5-6.5-6.5s-6.5 3-6.5 6.5H2l3.84 4 4.16-4H6.51C6.51 7 8.53 5 11.01 5s4.5 2.01 4.5 4.5c0 2.48-2.02 4.5-4.5 4.5-.65 0-1.26-.14-1.82-.38L7.71 15.1c.97.57 2.09.9 3.3.9 1.61 0 3.08-.59 4.22-1.57l.27.27v.79l5.01 4.99L22 19l-4.99-5z"
})), 'YoutubeSearchedFor');

exports.default = _default;

/***/ }),
/* 2285 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14zm2.5-4h-2v2H9v-2H7V9h2V7h1v2h2v1z"
})), 'ZoomIn');

exports.default = _default;

/***/ }),
/* 2286 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14zM7 9h5v1H7z"
})), 'ZoomOut');

exports.default = _default;

/***/ }),
/* 2287 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M15 3l2.3 2.3-2.89 2.87 1.42 1.42L18.7 6.7 21 9V3zM3 9l2.3-2.3 2.87 2.89 1.42-1.42L6.7 5.3 9 3H3zm6 12l-2.3-2.3 2.89-2.87-1.42-1.42L5.3 17.3 3 15v6zm12-6l-2.3 2.3-2.87-2.89-1.42 1.42 2.89 2.87L15 21h6z"
})), 'ZoomOutMap');

exports.default = _default;

/***/ }),
/* 2288 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__ = __webpack_require__(65);
// ##############################
// // // Header styles
// #############################
var headerStyle=function headerStyle(theme){return{appBar:{backgroundColor:"#eeeeee",boxShadow:"none",borderBottom:"0",marginBottom:"0",position:"relative",width:"100%",left:"5%",paddingTop:"10px",zIndex:"1029",color:"#555555",border:"0",borderRadius:"3px",padding:"10px 0",transition:"all 150ms ease 0s",minHeight:"50px",display:"block"},container:Object.assign({},__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["d" /* containerFluid */],{minHeight:"50px"}),flex:{flex:1},title:Object.assign({},__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["j" /* defaultFont */],{lineHeight:"30px",fontSize:"18px",borderRadius:"3px",textTransform:"none",color:"inherit",paddingTop:"0.625rem",paddingBottom:"0.625rem","&:hover,&:focus":{background:"transparent"}}),primary:Object.assign({backgroundColor:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["t" /* primaryColor */],color:"#FFFFFF"},__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["i" /* defaultBoxShadow */]),info:Object.assign({backgroundColor:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["q" /* infoColor */],color:"#FFFFFF"},__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["i" /* defaultBoxShadow */]),success:Object.assign({backgroundColor:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["D" /* successColor */],color:"#FFFFFF"},__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["i" /* defaultBoxShadow */]),warning:Object.assign({backgroundColor:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["I" /* warningColor */],color:"#FFFFFF"},__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["i" /* defaultBoxShadow */]),danger:Object.assign({backgroundColor:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["g" /* dangerColor */],color:"#FFFFFF"},__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["i" /* defaultBoxShadow */]),sidebarMinimize:{float:"left",padding:"0 0 0 15px",display:"block",color:"#555555"},sidebarMinimizeRTL:{padding:"0 15px 0 0 !important"},sidebarMiniIcon:{width:"20px",height:"17px"},logo:{padding:"15px 0px",margin:"0",display:"block",position:"relative",zIndex:"4"},logoMini:{transition:"all 300ms linear",opacity:1,float:"left",textAlign:"center",width:"30px",display:"inline-block",maxHeight:"30px",marginLeft:"22px",marginRight:"18px",marginTop:"7px",color:"inherit"},logoMiniRTL:{float:"right",marginRight:"30px",marginLeft:"26px"},logoNormal:Object.assign({},__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["j" /* defaultFont */],{transition:"all 300ms linear",display:"block",opacity:"1",transform:"translate3d(0px, 0, 0)",textTransform:"uppercase",padding:"5px 0px",fontSize:"18px",whiteSpace:"nowrap",fontWeight:"400",lineHeight:"30px",overflow:"hidden","&,&:hover,&:focus":{color:"inherit"}}),logoNormalRTL:{textAlign:"right"},logoNormalSidebarMini:{opacity:"0",transform:"translate3d(-25px, 0, 0)"},logoNormalSidebarMiniRTL:{transform:"translate3d(25px, 0, 0)"}};};/* harmony default export */ __webpack_exports__["a"] = (headerStyle);

/***/ }),
/* 2289 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Button__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_assets_jss_material_dashboard_pro_react_components_buttonStyle_jsx__ = __webpack_require__(574);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}// nodejs library that concatenates classes
// nodejs library to set properties for components
// material-ui components
function RegularButton(_ref){var _classNames;var props=_objectWithoutProperties(_ref,[]);var classes=props.classes,color=props.color,round=props.round,children=props.children,fullWidth=props.fullWidth,disabled=props.disabled,simple=props.simple,size=props.size,block=props.block,link=props.link,justIcon=props.justIcon,className=props.className,muiClasses=props.muiClasses,rest=_objectWithoutProperties(props,["classes","color","round","children","fullWidth","disabled","simple","size","block","link","justIcon","className","muiClasses"]);var btnClasses=__WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classNames={},_defineProperty(_classNames,classes.button,true),_defineProperty(_classNames,classes[size],size),_defineProperty(_classNames,classes[color],color),_defineProperty(_classNames,classes.round,round),_defineProperty(_classNames,classes.fullWidth,fullWidth),_defineProperty(_classNames,classes.disabled,disabled),_defineProperty(_classNames,classes.simple,simple),_defineProperty(_classNames,classes.block,block),_defineProperty(_classNames,classes.link,link),_defineProperty(_classNames,classes.justIcon,justIcon),_defineProperty(_classNames,className,className),_classNames));return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Button___default.a,Object.assign({},rest,{classes:muiClasses,className:btnClasses}),children);}RegularButton.propTypes={classes:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,color:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(["primary","info","success","warning","danger","rose","white","twitter","facebook","google","linkedin","pinterest","youtube","tumblr","github","behance","dribbble","reddit","transparent"]),size:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(["sm","lg"]),simple:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,round:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,fullWidth:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,disabled:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,block:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,link:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,justIcon:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,className:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,muiClasses:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object};/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles___default()(__WEBPACK_IMPORTED_MODULE_5_assets_jss_material_dashboard_pro_react_components_buttonStyle_jsx__["a" /* default */])(RegularButton));

/***/ }),
/* 2290 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 2291 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 2292 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/liberty-small.5b530929.jpg";

/***/ }),
/* 2293 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/momentum-small.f89a93cd.jpg";

/***/ }),
/* 2294 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/sanlam-small.f5577731.png";

/***/ }),
/* 2295 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/pps.76b71252.png";

/***/ }),
/* 2296 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/oldmutual.b4a27254.png";

/***/ }),
/* 2297 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getTargets; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_graphql_tag__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_graphql_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_graphql_tag__);
var _templateObject=_taggedTemplateLiteral(['\n{\n  targets (first: 500) {\n    edges {\n      node {\n        id\n        name\n        logo\n        enabled\n      }\n    }\n  }\n}\n'],['\n{\n  targets (first: 500) {\n    edges {\n      node {\n        id\n        name\n        logo\n        enabled\n      }\n    }\n  }\n}\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var getTargets=__WEBPACK_IMPORTED_MODULE_0_graphql_tag___default()(_templateObject);

/***/ }),
/* 2298 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__FayeMessager__ = __webpack_require__(2299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_store__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reducers_TasksReducer__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_helpers_UserHelper__ = __webpack_require__(16);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var NEW_TASK='sure-quote/tasks/task/NEW_TASK';var PUSH_TO_API='/Result/';var GET_USER_TASKS='/task/getUserTasks';// var RESULT_UDATE  -- percentasge complete
// var RESULT_INFO -- final infromaton of task
var TaskManager=function(){function TaskManager(){_classCallCheck(this,TaskManager);var faye=new __WEBPACK_IMPORTED_MODULE_0__FayeMessager__["a" /* default */]();this.messager=faye;global.messager=faye;this.handlerFactoryFuncs=new Map();}_createClass(TaskManager,[{key:'initialFetch',value:function initialFetch(){global.messager.publish(GET_USER_TASKS,{uid:Object(__WEBPACK_IMPORTED_MODULE_3_helpers_UserHelper__["a" /* GetUserId */])()});this.messager.subscribe(GET_USER_TASKS+'/'+Object(__WEBPACK_IMPORTED_MODULE_3_helpers_UserHelper__["a" /* GetUserId */])(),function(data){__WEBPACK_IMPORTED_MODULE_1_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_2_reducers_TasksReducer__["d" /* initialFetch */])({tasks:data}));});}},{key:'start',value:function start(){var _this=this;if(!global.glob&&Object(__WEBPACK_IMPORTED_MODULE_3_helpers_UserHelper__["c" /* GetUserToken */])()!=='')this.messager.subscribe(PUSH_TO_API+Object(__WEBPACK_IMPORTED_MODULE_3_helpers_UserHelper__["a" /* GetUserId */])(),function(msg){_this.onNewResult(msg);});}},{key:'stop',value:function stop(){}// Here we recieve results from the scraping server
},{key:'onNewResult',value:function onNewResult(msg){__WEBPACK_IMPORTED_MODULE_1_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_2_reducers_TasksReducer__["e" /* newTask */])({type:NEW_TASK,props:msg}));return msg;}}]);return TaskManager;}();/* harmony default export */ __webpack_exports__["a"] = (TaskManager);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(26)))

/***/ }),
/* 2299 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Messager__ = __webpack_require__(2300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_faye__ = __webpack_require__(2301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_faye___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_faye__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var client=new __WEBPACK_IMPORTED_MODULE_1_faye___default.a.Client('http://www.rhlm.co.za/message');//var client = new Faye.Client('http://102.133.234.18:443/');
var FayeMessager=function(_Messager){_inherits(FayeMessager,_Messager);function FayeMessager(){_classCallCheck(this,FayeMessager);return _possibleConstructorReturn(this,(FayeMessager.__proto__||Object.getPrototypeOf(FayeMessager)).apply(this,arguments));}_createClass(FayeMessager,[{key:'subscribe',value:function subscribe(topic,fn){client.subscribe(topic,fn);}},{key:'unsubscribe',value:function unsubscribe(topic){client.unsubscribe(topic);}},{key:'publish',value:function publish(topic,info){client.publish(topic,info);}}]);return FayeMessager;}(__WEBPACK_IMPORTED_MODULE_0__Messager__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (FayeMessager);

/***/ }),
/* 2300 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var Messager=function(){function Messager(){_classCallCheck(this,Messager);this.subscribers=new Map();}_createClass(Messager,[{key:"subscribe",value:function subscribe(topic,fn){var list=this.subscribers.get(topic);if(!list)list=[];list.push(fn);this.subscribers.set(topic,list);}},{key:"unsubscribe",value:function unsubscribe(){}},{key:"publish",value:function publish(topic,info){var list=this.subscribers.get(topic);if(!list)return;var _iteratorNormalCompletion=true;var _didIteratorError=false;var _iteratorError=undefined;try{for(var _iterator=list[Symbol.iterator](),_step;!(_iteratorNormalCompletion=(_step=_iterator.next()).done);_iteratorNormalCompletion=true){var fn=_step.value;fn(info);}}catch(err){_didIteratorError=true;_iteratorError=err;}finally{try{if(!_iteratorNormalCompletion&&_iterator.return){_iterator.return();}}finally{if(_didIteratorError){throw _iteratorError;}}}}}]);return Messager;}();/* harmony default export */ __webpack_exports__["a"] = (Messager);

/***/ }),
/* 2301 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var constants = __webpack_require__(580),
    Logging   = __webpack_require__(181);

var Faye = {
  VERSION:    constants.VERSION,

  Client:     __webpack_require__(2302),
  Scheduler:  __webpack_require__(587)
};

Logging.wrapper = Faye;

module.exports = Faye;


/***/ }),
/* 2302 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var asap            = __webpack_require__(581),
    Class           = __webpack_require__(53),
    Promise         = __webpack_require__(246),
    URI             = __webpack_require__(98),
    array           = __webpack_require__(364),
    browser         = __webpack_require__(365),
    constants       = __webpack_require__(580),
    extend          = __webpack_require__(51),
    validateOptions = __webpack_require__(2303),
    Deferrable      = __webpack_require__(183),
    Logging         = __webpack_require__(181),
    Publisher       = __webpack_require__(366),
    Channel         = __webpack_require__(582),
    Dispatcher      = __webpack_require__(2305),
    Error           = __webpack_require__(2313),
    Extensible      = __webpack_require__(2314),
    Publication     = __webpack_require__(2315),
    Subscription    = __webpack_require__(2316);

var Client = Class({ className: 'Client',
  UNCONNECTED:        1,
  CONNECTING:         2,
  CONNECTED:          3,
  DISCONNECTED:       4,

  HANDSHAKE:          'handshake',
  RETRY:              'retry',
  NONE:               'none',

  CONNECTION_TIMEOUT: 60,

  DEFAULT_ENDPOINT:   '/bayeux',
  INTERVAL:           0,

  initialize: function(endpoint, options) {
    this.info('New client created for ?', endpoint);
    options = options || {};

    validateOptions(options, ['interval', 'timeout', 'endpoints', 'proxy', 'retry', 'scheduler', 'websocketExtensions', 'tls', 'ca']);

    this._channels   = new Channel.Set();
    this._dispatcher = Dispatcher.create(this, endpoint || this.DEFAULT_ENDPOINT, options);

    this._messageId = 0;
    this._state     = this.UNCONNECTED;

    this._responseCallbacks = {};

    this._advice = {
      reconnect: this.RETRY,
      interval:  1000 * (options.interval || this.INTERVAL),
      timeout:   1000 * (options.timeout  || this.CONNECTION_TIMEOUT)
    };
    this._dispatcher.timeout = this._advice.timeout / 1000;

    this._dispatcher.bind('message', this._receiveMessage, this);

    if (browser.Event && global.onbeforeunload !== undefined)
      browser.Event.on(global, 'beforeunload', function() {
        if (array.indexOf(this._dispatcher._disabled, 'autodisconnect') < 0)
          this.disconnect();
      }, this);
  },

  addWebsocketExtension: function(extension) {
    return this._dispatcher.addWebsocketExtension(extension);
  },

  disable: function(feature) {
    return this._dispatcher.disable(feature);
  },

  setHeader: function(name, value) {
    return this._dispatcher.setHeader(name, value);
  },

  // Request
  // MUST include:  * channel
  //                * version
  //                * supportedConnectionTypes
  // MAY include:   * minimumVersion
  //                * ext
  //                * id
  //
  // Success Response                             Failed Response
  // MUST include:  * channel                     MUST include:  * channel
  //                * version                                    * successful
  //                * supportedConnectionTypes                   * error
  //                * clientId                    MAY include:   * supportedConnectionTypes
  //                * successful                                 * advice
  // MAY include:   * minimumVersion                             * version
  //                * advice                                     * minimumVersion
  //                * ext                                        * ext
  //                * id                                         * id
  //                * authSuccessful
  handshake: function(callback, context) {
    if (this._advice.reconnect === this.NONE) return;
    if (this._state !== this.UNCONNECTED) return;

    this._state = this.CONNECTING;
    var self = this;

    this.info('Initiating handshake with ?', URI.stringify(this._dispatcher.endpoint));
    this._dispatcher.selectTransport(constants.MANDATORY_CONNECTION_TYPES);

    this._sendMessage({
      channel:                  Channel.HANDSHAKE,
      version:                  constants.BAYEUX_VERSION,
      supportedConnectionTypes: this._dispatcher.getConnectionTypes()

    }, {}, function(response) {

      if (response.successful) {
        this._state = this.CONNECTED;
        this._dispatcher.clientId  = response.clientId;

        this._dispatcher.selectTransport(response.supportedConnectionTypes);

        this.info('Handshake successful: ?', this._dispatcher.clientId);

        this.subscribe(this._channels.getKeys(), true);
        if (callback) asap(function() { callback.call(context) });

      } else {
        this.info('Handshake unsuccessful');
        global.setTimeout(function() { self.handshake(callback, context) }, this._dispatcher.retry * 1000);
        this._state = this.UNCONNECTED;
      }
    }, this);
  },

  // Request                              Response
  // MUST include:  * channel             MUST include:  * channel
  //                * clientId                           * successful
  //                * connectionType                     * clientId
  // MAY include:   * ext                 MAY include:   * error
  //                * id                                 * advice
  //                                                     * ext
  //                                                     * id
  //                                                     * timestamp
  connect: function(callback, context) {
    if (this._advice.reconnect === this.NONE) return;
    if (this._state === this.DISCONNECTED) return;

    if (this._state === this.UNCONNECTED)
      return this.handshake(function() { this.connect(callback, context) }, this);

    this.callback(callback, context);
    if (this._state !== this.CONNECTED) return;

    this.info('Calling deferred actions for ?', this._dispatcher.clientId);
    this.setDeferredStatus('succeeded');
    this.setDeferredStatus('unknown');

    if (this._connectRequest) return;
    this._connectRequest = true;

    this.info('Initiating connection for ?', this._dispatcher.clientId);

    this._sendMessage({
      channel:        Channel.CONNECT,
      clientId:       this._dispatcher.clientId,
      connectionType: this._dispatcher.connectionType

    }, {}, this._cycleConnection, this);
  },

  // Request                              Response
  // MUST include:  * channel             MUST include:  * channel
  //                * clientId                           * successful
  // MAY include:   * ext                                * clientId
  //                * id                  MAY include:   * error
  //                                                     * ext
  //                                                     * id
  disconnect: function() {
    if (this._state !== this.CONNECTED) return;
    this._state = this.DISCONNECTED;

    this.info('Disconnecting ?', this._dispatcher.clientId);
    var promise = new Publication();

    this._sendMessage({
      channel:  Channel.DISCONNECT,
      clientId: this._dispatcher.clientId

    }, {}, function(response) {
      if (response.successful) {
        this._dispatcher.close();
        promise.setDeferredStatus('succeeded');
      } else {
        promise.setDeferredStatus('failed', Error.parse(response.error));
      }
    }, this);

    this.info('Clearing channel listeners for ?', this._dispatcher.clientId);
    this._channels = new Channel.Set();

    return promise;
  },

  // Request                              Response
  // MUST include:  * channel             MUST include:  * channel
  //                * clientId                           * successful
  //                * subscription                       * clientId
  // MAY include:   * ext                                * subscription
  //                * id                  MAY include:   * error
  //                                                     * advice
  //                                                     * ext
  //                                                     * id
  //                                                     * timestamp
  subscribe: function(channel, callback, context) {
    if (channel instanceof Array)
      return array.map(channel, function(c) {
        return this.subscribe(c, callback, context);
      }, this);

    var subscription = new Subscription(this, channel, callback, context),
        force        = (callback === true),
        hasSubscribe = this._channels.hasSubscription(channel);

    if (hasSubscribe && !force) {
      this._channels.subscribe([channel], subscription);
      subscription.setDeferredStatus('succeeded');
      return subscription;
    }

    this.connect(function() {
      this.info('Client ? attempting to subscribe to ?', this._dispatcher.clientId, channel);
      if (!force) this._channels.subscribe([channel], subscription);

      this._sendMessage({
        channel:      Channel.SUBSCRIBE,
        clientId:     this._dispatcher.clientId,
        subscription: channel

      }, {}, function(response) {
        if (!response.successful) {
          subscription.setDeferredStatus('failed', Error.parse(response.error));
          return this._channels.unsubscribe(channel, subscription);
        }

        var channels = [].concat(response.subscription);
        this.info('Subscription acknowledged for ? to ?', this._dispatcher.clientId, channels);
        subscription.setDeferredStatus('succeeded');
      }, this);
    }, this);

    return subscription;
  },

  // Request                              Response
  // MUST include:  * channel             MUST include:  * channel
  //                * clientId                           * successful
  //                * subscription                       * clientId
  // MAY include:   * ext                                * subscription
  //                * id                  MAY include:   * error
  //                                                     * advice
  //                                                     * ext
  //                                                     * id
  //                                                     * timestamp
  unsubscribe: function(channel, subscription) {
    if (channel instanceof Array)
      return array.map(channel, function(c) {
        return this.unsubscribe(c, subscription);
      }, this);

    var dead = this._channels.unsubscribe(channel, subscription);
    if (!dead) return;

    this.connect(function() {
      this.info('Client ? attempting to unsubscribe from ?', this._dispatcher.clientId, channel);

      this._sendMessage({
        channel:      Channel.UNSUBSCRIBE,
        clientId:     this._dispatcher.clientId,
        subscription: channel

      }, {}, function(response) {
        if (!response.successful) return;

        var channels = [].concat(response.subscription);
        this.info('Unsubscription acknowledged for ? from ?', this._dispatcher.clientId, channels);
      }, this);
    }, this);
  },

  // Request                              Response
  // MUST include:  * channel             MUST include:  * channel
  //                * data                               * successful
  // MAY include:   * clientId            MAY include:   * id
  //                * id                                 * error
  //                * ext                                * ext
  publish: function(channel, data, options) {
    validateOptions(options || {}, ['attempts', 'deadline']);
    var publication = new Publication();

    this.connect(function() {
      this.info('Client ? queueing published message to ?: ?', this._dispatcher.clientId, channel, data);

      this._sendMessage({
        channel:  channel,
        data:     data,
        clientId: this._dispatcher.clientId

      }, options, function(response) {
        if (response.successful)
          publication.setDeferredStatus('succeeded');
        else
          publication.setDeferredStatus('failed', Error.parse(response.error));
      }, this);
    }, this);

    return publication;
  },

  _sendMessage: function(message, options, callback, context) {
    message.id = this._generateMessageId();

    var timeout = this._advice.timeout
                ? 1.2 * this._advice.timeout / 1000
                : 1.2 * this._dispatcher.retry;

    this.pipeThroughExtensions('outgoing', message, null, function(message) {
      if (!message) return;
      if (callback) this._responseCallbacks[message.id] = [callback, context];
      this._dispatcher.sendMessage(message, timeout, options || {});
    }, this);
  },

  _generateMessageId: function() {
    this._messageId += 1;
    if (this._messageId >= Math.pow(2,32)) this._messageId = 0;
    return this._messageId.toString(36);
  },

  _receiveMessage: function(message) {
    var id = message.id, callback;

    if (message.successful !== undefined) {
      callback = this._responseCallbacks[id];
      delete this._responseCallbacks[id];
    }

    this.pipeThroughExtensions('incoming', message, null, function(message) {
      if (!message) return;
      if (message.advice) this._handleAdvice(message.advice);
      this._deliverMessage(message);
      if (callback) callback[0].call(callback[1], message);
    }, this);
  },

  _handleAdvice: function(advice) {
    extend(this._advice, advice);
    this._dispatcher.timeout = this._advice.timeout / 1000;

    if (this._advice.reconnect === this.HANDSHAKE && this._state !== this.DISCONNECTED) {
      this._state = this.UNCONNECTED;
      this._dispatcher.clientId = null;
      this._cycleConnection();
    }
  },

  _deliverMessage: function(message) {
    if (!message.channel || message.data === undefined) return;
    this.info('Client ? calling listeners for ? with ?', this._dispatcher.clientId, message.channel, message.data);
    this._channels.distributeMessage(message);
  },

  _cycleConnection: function() {
    if (this._connectRequest) {
      this._connectRequest = null;
      this.info('Closed connection for ?', this._dispatcher.clientId);
    }
    var self = this;
    global.setTimeout(function() { self.connect() }, this._advice.interval);
  }
});

extend(Client.prototype, Deferrable);
extend(Client.prototype, Publisher);
extend(Client.prototype, Logging);
extend(Client.prototype, Extensible);

module.exports = Client;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(26)))

/***/ }),
/* 2303 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var array = __webpack_require__(364);

module.exports = function(options, validKeys) {
  for (var key in options) {
    if (array.indexOf(validKeys, key) < 0)
      throw new Error('Unrecognized option: ' + key);
  }
};


/***/ }),
/* 2304 */
/***/ (function(module, exports) {

/*
Copyright Joyent, Inc. and other Node contributors. All rights reserved.
Permission is hereby granted, free of charge, to any person obtaining a copy of
this software and associated documentation files (the "Software"), to deal in
the Software without restriction, including without limitation the rights to
use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies
of the Software, and to permit persons to whom the Software is furnished to do
so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all
copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
SOFTWARE.
*/

var isArray = typeof Array.isArray === 'function'
    ? Array.isArray
    : function (xs) {
        return Object.prototype.toString.call(xs) === '[object Array]'
    }
;
function indexOf (xs, x) {
    if (xs.indexOf) return xs.indexOf(x);
    for (var i = 0; i < xs.length; i++) {
        if (x === xs[i]) return i;
    }
    return -1;
}

function EventEmitter() {}
module.exports = EventEmitter;

EventEmitter.prototype.emit = function(type) {
  // If there is no 'error' event listener then throw.
  if (type === 'error') {
    if (!this._events || !this._events.error ||
        (isArray(this._events.error) && !this._events.error.length))
    {
      if (arguments[1] instanceof Error) {
        throw arguments[1]; // Unhandled 'error' event
      } else {
        throw new Error("Uncaught, unspecified 'error' event.");
      }
      return false;
    }
  }

  if (!this._events) return false;
  var handler = this._events[type];
  if (!handler) return false;

  if (typeof handler == 'function') {
    switch (arguments.length) {
      // fast cases
      case 1:
        handler.call(this);
        break;
      case 2:
        handler.call(this, arguments[1]);
        break;
      case 3:
        handler.call(this, arguments[1], arguments[2]);
        break;
      // slower
      default:
        var args = Array.prototype.slice.call(arguments, 1);
        handler.apply(this, args);
    }
    return true;

  } else if (isArray(handler)) {
    var args = Array.prototype.slice.call(arguments, 1);

    var listeners = handler.slice();
    for (var i = 0, l = listeners.length; i < l; i++) {
      listeners[i].apply(this, args);
    }
    return true;

  } else {
    return false;
  }
};

// EventEmitter is defined in src/node_events.cc
// EventEmitter.prototype.emit() is also defined there.
EventEmitter.prototype.addListener = function(type, listener) {
  if ('function' !== typeof listener) {
    throw new Error('addListener only takes instances of Function');
  }

  if (!this._events) this._events = {};

  // To avoid recursion in the case that type == "newListeners"! Before
  // adding it to the listeners, first emit "newListeners".
  this.emit('newListener', type, listener);

  if (!this._events[type]) {
    // Optimize the case of one listener. Don't need the extra array object.
    this._events[type] = listener;
  } else if (isArray(this._events[type])) {
    // If we've already got an array, just append.
    this._events[type].push(listener);
  } else {
    // Adding the second element, need to change to array.
    this._events[type] = [this._events[type], listener];
  }

  return this;
};

EventEmitter.prototype.on = EventEmitter.prototype.addListener;

EventEmitter.prototype.once = function(type, listener) {
  var self = this;
  self.on(type, function g() {
    self.removeListener(type, g);
    listener.apply(this, arguments);
  });

  return this;
};

EventEmitter.prototype.removeListener = function(type, listener) {
  if ('function' !== typeof listener) {
    throw new Error('removeListener only takes instances of Function');
  }

  // does not use listeners(), so no side effect of creating _events[type]
  if (!this._events || !this._events[type]) return this;

  var list = this._events[type];

  if (isArray(list)) {
    var i = indexOf(list, listener);
    if (i < 0) return this;
    list.splice(i, 1);
    if (list.length == 0)
      delete this._events[type];
  } else if (this._events[type] === listener) {
    delete this._events[type];
  }

  return this;
};

EventEmitter.prototype.removeAllListeners = function(type) {
  if (arguments.length === 0) {
    this._events = {};
    return this;
  }

  // does not use listeners(), so no side effect of creating _events[type]
  if (type && this._events && this._events[type]) this._events[type] = null;
  return this;
};

EventEmitter.prototype.listeners = function(type) {
  if (!this._events) this._events = {};
  if (!this._events[type]) this._events[type] = [];
  if (!isArray(this._events[type])) {
    this._events[type] = [this._events[type]];
  }
  return this._events[type];
};


/***/ }),
/* 2305 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var Class     = __webpack_require__(53),
    URI       = __webpack_require__(98),
    cookies   = __webpack_require__(584),
    extend    = __webpack_require__(51),
    Logging   = __webpack_require__(181),
    Publisher = __webpack_require__(366),
    Transport = __webpack_require__(2306),
    Scheduler = __webpack_require__(587);

var Dispatcher = Class({ className: 'Dispatcher',
  MAX_REQUEST_SIZE: 2048,
  DEFAULT_RETRY:    5,

  UP:   1,
  DOWN: 2,

  initialize: function(client, endpoint, options) {
    this._client     = client;
    this.endpoint    = URI.parse(endpoint);
    this._alternates = options.endpoints || {};

    this.cookies      = cookies.CookieJar && new cookies.CookieJar();
    this._disabled    = [];
    this._envelopes   = {};
    this.headers      = {};
    this.retry        = options.retry || this.DEFAULT_RETRY;
    this._scheduler   = options.scheduler || Scheduler;
    this._state       = 0;
    this.transports   = {};
    this.wsExtensions = [];

    this.proxy = options.proxy || {};
    if (typeof this._proxy === 'string') this._proxy = {origin: this._proxy};

    var exts = options.websocketExtensions;
    if (exts) {
      exts = [].concat(exts);
      for (var i = 0, n = exts.length; i < n; i++)
        this.addWebsocketExtension(exts[i]);
    }

    this.tls = options.tls || {};
    this.tls.ca = this.tls.ca || options.ca;

    for (var type in this._alternates)
      this._alternates[type] = URI.parse(this._alternates[type]);

    this.maxRequestSize = this.MAX_REQUEST_SIZE;
  },

  endpointFor: function(connectionType) {
    return this._alternates[connectionType] || this.endpoint;
  },

  addWebsocketExtension: function(extension) {
    this.wsExtensions.push(extension);
  },

  disable: function(feature) {
    this._disabled.push(feature);
  },

  setHeader: function(name, value) {
    this.headers[name] = value;
  },

  close: function() {
    var transport = this._transport;
    delete this._transport;
    if (transport) transport.close();
  },

  getConnectionTypes: function() {
    return Transport.getConnectionTypes();
  },

  selectTransport: function(transportTypes) {
    Transport.get(this, transportTypes, this._disabled, function(transport) {
      this.debug('Selected ? transport for ?', transport.connectionType, URI.stringify(transport.endpoint));

      if (transport === this._transport) return;
      if (this._transport) this._transport.close();

      this._transport = transport;
      this.connectionType = transport.connectionType;
    }, this);
  },

  sendMessage: function(message, timeout, options) {
    options = options || {};

    var id       = message.id,
        attempts = options.attempts,
        deadline = options.deadline && new Date().getTime() + (options.deadline * 1000),
        envelope = this._envelopes[id],
        scheduler;

    if (!envelope) {
      scheduler = new this._scheduler(message, {timeout: timeout, interval: this.retry, attempts: attempts, deadline: deadline});
      envelope  = this._envelopes[id] = {message: message, scheduler: scheduler};
    }

    this._sendEnvelope(envelope);
  },

  _sendEnvelope: function(envelope) {
    if (!this._transport) return;
    if (envelope.request || envelope.timer) return;

    var message   = envelope.message,
        scheduler = envelope.scheduler,
        self      = this;

    if (!scheduler.isDeliverable()) {
      scheduler.abort();
      delete this._envelopes[message.id];
      return;
    }

    envelope.timer = global.setTimeout(function() {
      self.handleError(message);
    }, scheduler.getTimeout() * 1000);

    scheduler.send();
    envelope.request = this._transport.sendMessage(message);
  },

  handleResponse: function(reply) {
    var envelope = this._envelopes[reply.id];

    if (reply.successful !== undefined && envelope) {
      envelope.scheduler.succeed();
      delete this._envelopes[reply.id];
      global.clearTimeout(envelope.timer);
    }

    this.trigger('message', reply);

    if (this._state === this.UP) return;
    this._state = this.UP;
    this._client.trigger('transport:up');
  },

  handleError: function(message, immediate) {
    var envelope = this._envelopes[message.id],
        request  = envelope && envelope.request,
        self     = this;

    if (!request) return;

    request.then(function(req) {
      if (req && req.abort) req.abort();
    });

    var scheduler = envelope.scheduler;
    scheduler.fail();

    global.clearTimeout(envelope.timer);
    envelope.request = envelope.timer = null;

    if (immediate) {
      this._sendEnvelope(envelope);
    } else {
      envelope.timer = global.setTimeout(function() {
        envelope.timer = null;
        self._sendEnvelope(envelope);
      }, scheduler.getInterval() * 1000);
    }

    if (this._state === this.DOWN) return;
    this._state = this.DOWN;
    this._client.trigger('transport:down');
  }
});

Dispatcher.create = function(client, endpoint, options) {
  return new Dispatcher(client, endpoint, options);
};

extend(Dispatcher.prototype, Publisher);
extend(Dispatcher.prototype, Logging);

module.exports = Dispatcher;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(26)))

/***/ }),
/* 2306 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Transport = __webpack_require__(145);

Transport.register('websocket', __webpack_require__(2308));
Transport.register('eventsource', __webpack_require__(2310));
Transport.register('long-polling', __webpack_require__(586));
Transport.register('cross-origin-long-polling', __webpack_require__(2311));
Transport.register('callback-polling', __webpack_require__(2312));

module.exports = Transport;


/***/ }),
/* 2307 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

module.exports = {
  addTimeout: function(name, delay, callback, context) {
    this._timeouts = this._timeouts || {};
    if (this._timeouts.hasOwnProperty(name)) return;
    var self = this;
    this._timeouts[name] = global.setTimeout(function() {
      delete self._timeouts[name];
      callback.call(context);
    }, 1000 * delay);
  },

  removeTimeout: function(name) {
    this._timeouts = this._timeouts || {};
    var timeout = this._timeouts[name];
    if (!timeout) return;
    global.clearTimeout(timeout);
    delete this._timeouts[name];
  },

  removeAllTimeouts: function() {
    this._timeouts = this._timeouts || {};
    for (var name in this._timeouts) this.removeTimeout(name);
  }
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(26)))

/***/ }),
/* 2308 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var Class      = __webpack_require__(53),
    Promise    = __webpack_require__(246),
    Set        = __webpack_require__(585),
    URI        = __webpack_require__(98),
    browser    = __webpack_require__(365),
    copyObject = __webpack_require__(367),
    extend     = __webpack_require__(51),
    toJSON     = __webpack_require__(182),
    ws         = __webpack_require__(2309),
    Deferrable = __webpack_require__(183),
    Transport  = __webpack_require__(145);

var WebSocket = extend(Class(Transport, {
  UNCONNECTED:  1,
  CONNECTING:   2,
  CONNECTED:    3,

  batching:     false,

  isUsable: function(callback, context) {
    this.callback(function() { callback.call(context, true) });
    this.errback(function() { callback.call(context, false) });
    this.connect();
  },

  request: function(messages) {
    this._pending = this._pending || new Set();
    for (var i = 0, n = messages.length; i < n; i++) this._pending.add(messages[i]);

    var self = this;

    var promise = new Promise(function(resolve, reject) {
      self.callback(function(socket) {
        if (!socket || socket.readyState !== 1) return;
        socket.send(toJSON(messages));
        resolve(socket);
      });

      self.connect();
    });

    return {
      abort: function() { promise.then(function(ws) { ws.close() }) }
    };
  },

  connect: function() {
    if (WebSocket._unloaded) return;

    this._state = this._state || this.UNCONNECTED;
    if (this._state !== this.UNCONNECTED) return;
    this._state = this.CONNECTING;

    var socket = this._createSocket();
    if (!socket) return this.setDeferredStatus('failed');

    var self = this;

    socket.onopen = function() {
      if (socket.headers) self._storeCookies(socket.headers['set-cookie']);
      self._socket = socket;
      self._state = self.CONNECTED;
      self._everConnected = true;
      self._ping();
      self.setDeferredStatus('succeeded', socket);
    };

    var closed = false;
    socket.onclose = socket.onerror = function() {
      if (closed) return;
      closed = true;

      var wasConnected = (self._state === self.CONNECTED);
      socket.onopen = socket.onclose = socket.onerror = socket.onmessage = null;

      delete self._socket;
      self._state = self.UNCONNECTED;
      self.removeTimeout('ping');

      var pending = self._pending ? self._pending.toArray() : [];
      delete self._pending;

      if (wasConnected || self._everConnected) {
        self.setDeferredStatus('unknown');
        self._handleError(pending, wasConnected);
      } else {
        self.setDeferredStatus('failed');
      }
    };

    socket.onmessage = function(event) {
      var replies;
      try { replies = JSON.parse(event.data) } catch (error) {}

      if (!replies) return;

      replies = [].concat(replies);

      for (var i = 0, n = replies.length; i < n; i++) {
        if (replies[i].successful === undefined) continue;
        self._pending.remove(replies[i]);
      }
      self._receive(replies);
    };
  },

  close: function() {
    if (!this._socket) return;
    this._socket.close();
  },

  _createSocket: function() {
    var url        = WebSocket.getSocketUrl(this.endpoint),
        headers    = this._dispatcher.headers,
        extensions = this._dispatcher.wsExtensions,
        cookie     = this._getCookies(),
        tls        = this._dispatcher.tls,
        options    = {extensions: extensions, headers: headers, proxy: this._proxy, tls: tls};

    if (cookie !== '') options.headers['Cookie'] = cookie;

    return ws.create(url, [], options);
  },

  _ping: function() {
    if (!this._socket || this._socket.readyState !== 1) return;
    this._socket.send('[]');
    this.addTimeout('ping', this._dispatcher.timeout / 2, this._ping, this);
  }

}), {
  PROTOCOLS: {
    'http:':  'ws:',
    'https:': 'wss:'
  },

  create: function(dispatcher, endpoint) {
    var sockets = dispatcher.transports.websocket = dispatcher.transports.websocket || {};
    sockets[endpoint.href] = sockets[endpoint.href] || new this(dispatcher, endpoint);
    return sockets[endpoint.href];
  },

  getSocketUrl: function(endpoint) {
    endpoint = copyObject(endpoint);
    endpoint.protocol = this.PROTOCOLS[endpoint.protocol];
    return URI.stringify(endpoint);
  },

  isUsable: function(dispatcher, endpoint, callback, context) {
    this.create(dispatcher, endpoint).isUsable(callback, context);
  }
});

extend(WebSocket.prototype, Deferrable);

if (browser.Event && global.onbeforeunload !== undefined)
  browser.Event.on(global, 'beforeunload', function() { WebSocket._unloaded = true });

module.exports = WebSocket;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(26)))

/***/ }),
/* 2309 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var WS = global.MozWebSocket || global.WebSocket;

module.exports = {
  create: function(url, protocols, options) {
    if (typeof WS !== 'function') return null;
    return new WS(url);
  }
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(26)))

/***/ }),
/* 2310 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var Class      = __webpack_require__(53),
    URI        = __webpack_require__(98),
    copyObject = __webpack_require__(367),
    extend     = __webpack_require__(51),
    Deferrable = __webpack_require__(183),
    Transport  = __webpack_require__(145),
    XHR        = __webpack_require__(586);

var EventSource = extend(Class(Transport, {
  initialize: function(dispatcher, endpoint) {
    Transport.prototype.initialize.call(this, dispatcher, endpoint);
    if (!global.EventSource) return this.setDeferredStatus('failed');

    this._xhr = new XHR(dispatcher, endpoint);

    endpoint = copyObject(endpoint);
    endpoint.pathname += '/' + dispatcher.clientId;

    var socket = new global.EventSource(URI.stringify(endpoint)),
        self   = this;

    socket.onopen = function() {
      self._everConnected = true;
      self.setDeferredStatus('succeeded');
    };

    socket.onerror = function() {
      if (self._everConnected) {
        self._handleError([]);
      } else {
        self.setDeferredStatus('failed');
        socket.close();
      }
    };

    socket.onmessage = function(event) {
      var replies;
      try { replies = JSON.parse(event.data) } catch (error) {}

      if (replies)
        self._receive(replies);
      else
        self._handleError([]);
    };

    this._socket = socket;
  },

  close: function() {
    if (!this._socket) return;
    this._socket.onopen = this._socket.onerror = this._socket.onmessage = null;
    this._socket.close();
    delete this._socket;
  },

  isUsable: function(callback, context) {
    this.callback(function() { callback.call(context, true) });
    this.errback(function() { callback.call(context, false) });
  },

  encode: function(messages) {
    return this._xhr.encode(messages);
  },

  request: function(messages) {
    return this._xhr.request(messages);
  }

}), {
  isUsable: function(dispatcher, endpoint, callback, context) {
    var id = dispatcher.clientId;
    if (!id) return callback.call(context, false);

    XHR.isUsable(dispatcher, endpoint, function(usable) {
      if (!usable) return callback.call(context, false);
      this.create(dispatcher, endpoint).isUsable(callback, context);
    }, this);
  },

  create: function(dispatcher, endpoint) {
    var sockets = dispatcher.transports.eventsource = dispatcher.transports.eventsource || {},
        id      = dispatcher.clientId;

    var url = copyObject(endpoint);
    url.pathname += '/' + (id || '');
    url = URI.stringify(url);

    sockets[url] = sockets[url] || new this(dispatcher, endpoint);
    return sockets[url];
  }
});

extend(EventSource.prototype, Deferrable);

module.exports = EventSource;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(26)))

/***/ }),
/* 2311 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var Class     = __webpack_require__(53),
    Set       = __webpack_require__(585),
    URI       = __webpack_require__(98),
    extend    = __webpack_require__(51),
    toJSON    = __webpack_require__(182),
    Transport = __webpack_require__(145);

var CORS = extend(Class(Transport, {
  encode: function(messages) {
    return 'message=' + encodeURIComponent(toJSON(messages));
  },

  request: function(messages) {
    var xhrClass = global.XDomainRequest ? XDomainRequest : XMLHttpRequest,
        xhr      = new xhrClass(),
        id       = ++CORS._id,
        headers  = this._dispatcher.headers,
        self     = this,
        key;

    xhr.open('POST', URI.stringify(this.endpoint), true);

    if (xhr.setRequestHeader) {
      xhr.setRequestHeader('Pragma', 'no-cache');
      for (key in headers) {
        if (!headers.hasOwnProperty(key)) continue;
        xhr.setRequestHeader(key, headers[key]);
      }
    }

    var cleanUp = function() {
      if (!xhr) return false;
      CORS._pending.remove(id);
      xhr.onload = xhr.onerror = xhr.ontimeout = xhr.onprogress = null;
      xhr = null;
    };

    xhr.onload = function() {
      var replies;
      try { replies = JSON.parse(xhr.responseText) } catch (error) {}

      cleanUp();

      if (replies)
        self._receive(replies);
      else
        self._handleError(messages);
    };

    xhr.onerror = xhr.ontimeout = function() {
      cleanUp();
      self._handleError(messages);
    };

    xhr.onprogress = function() {};

    if (xhrClass === global.XDomainRequest)
      CORS._pending.add({id: id, xhr: xhr});

    xhr.send(this.encode(messages));
    return xhr;
  }
}), {
  _id:      0,
  _pending: new Set(),

  isUsable: function(dispatcher, endpoint, callback, context) {
    if (URI.isSameOrigin(endpoint))
      return callback.call(context, false);

    if (global.XDomainRequest)
      return callback.call(context, endpoint.protocol === location.protocol);

    if (global.XMLHttpRequest) {
      var xhr = new XMLHttpRequest();
      return callback.call(context, xhr.withCredentials !== undefined);
    }
    return callback.call(context, false);
  }
});

module.exports = CORS;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(26)))

/***/ }),
/* 2312 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var Class      = __webpack_require__(53),
    URI        = __webpack_require__(98),
    copyObject = __webpack_require__(367),
    extend     = __webpack_require__(51),
    toJSON     = __webpack_require__(182),
    Transport  = __webpack_require__(145);

var JSONP = extend(Class(Transport, {
 encode: function(messages) {
    var url = copyObject(this.endpoint);
    url.query.message = toJSON(messages);
    url.query.jsonp   = '__jsonp' + JSONP._cbCount + '__';
    return URI.stringify(url);
  },

  request: function(messages) {
    var head         = document.getElementsByTagName('head')[0],
        script       = document.createElement('script'),
        callbackName = JSONP.getCallbackName(),
        endpoint     = copyObject(this.endpoint),
        self         = this;

    endpoint.query.message = toJSON(messages);
    endpoint.query.jsonp   = callbackName;

    var cleanup = function() {
      if (!global[callbackName]) return false;
      global[callbackName] = undefined;
      try { delete global[callbackName] } catch (error) {}
      script.parentNode.removeChild(script);
    };

    global[callbackName] = function(replies) {
      cleanup();
      self._receive(replies);
    };

    script.type = 'text/javascript';
    script.src  = URI.stringify(endpoint);
    head.appendChild(script);

    script.onerror = function() {
      cleanup();
      self._handleError(messages);
    };

    return {abort: cleanup};
  }
}), {
  _cbCount: 0,

  getCallbackName: function() {
    this._cbCount += 1;
    return '__jsonp' + this._cbCount + '__';
  },

  isUsable: function(dispatcher, endpoint, callback, context) {
    callback.call(context, true);
  }
});

module.exports = JSONP;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(26)))

/***/ }),
/* 2313 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Class   = __webpack_require__(53),
    Grammar = __webpack_require__(583);

var Error = Class({
  initialize: function(code, params, message) {
    this.code    = code;
    this.params  = Array.prototype.slice.call(params);
    this.message = message;
  },

  toString: function() {
    return this.code + ':' +
           this.params.join(',') + ':' +
           this.message;
  }
});

Error.parse = function(message) {
  message = message || '';
  if (!Grammar.ERROR.test(message)) return new Error(null, [], message);

  var parts   = message.split(':'),
      code    = parseInt(parts[0]),
      params  = parts[1].split(','),
      message = parts[2];

  return new Error(code, params, message);
};

// http://code.google.com/p/cometd/wiki/BayeuxCodes
var errors = {
  versionMismatch:  [300, 'Version mismatch'],
  conntypeMismatch: [301, 'Connection types not supported'],
  extMismatch:      [302, 'Extension mismatch'],
  badRequest:       [400, 'Bad request'],
  clientUnknown:    [401, 'Unknown client'],
  parameterMissing: [402, 'Missing required parameter'],
  channelForbidden: [403, 'Forbidden channel'],
  channelUnknown:   [404, 'Unknown channel'],
  channelInvalid:   [405, 'Invalid channel'],
  extUnknown:       [406, 'Unknown extension'],
  publishFailed:    [407, 'Failed to publish'],
  serverError:      [500, 'Internal server error']
};

for (var name in errors)
  (function(name) {
    Error[name] = function() {
      return new Error(errors[name][0], arguments, errors[name][1]).toString();
    };
  })(name);

module.exports = Error;


/***/ }),
/* 2314 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var extend  = __webpack_require__(51),
    Logging = __webpack_require__(181);

var Extensible = {
  addExtension: function(extension) {
    this._extensions = this._extensions || [];
    this._extensions.push(extension);
    if (extension.added) extension.added(this);
  },

  removeExtension: function(extension) {
    if (!this._extensions) return;
    var i = this._extensions.length;
    while (i--) {
      if (this._extensions[i] !== extension) continue;
      this._extensions.splice(i,1);
      if (extension.removed) extension.removed(this);
    }
  },

  pipeThroughExtensions: function(stage, message, request, callback, context) {
    this.debug('Passing through ? extensions: ?', stage, message);

    if (!this._extensions) return callback.call(context, message);
    var extensions = this._extensions.slice();

    var pipe = function(message) {
      if (!message) return callback.call(context, message);

      var extension = extensions.shift();
      if (!extension) return callback.call(context, message);

      var fn = extension[stage];
      if (!fn) return pipe(message);

      if (fn.length >= 3) extension[stage](message, request, pipe);
      else                extension[stage](message, pipe);
    };
    pipe(message);
  }
};

extend(Extensible, Logging);

module.exports = Extensible;


/***/ }),
/* 2315 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Class      = __webpack_require__(53),
    Deferrable = __webpack_require__(183);

module.exports = Class(Deferrable);


/***/ }),
/* 2316 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Class      = __webpack_require__(53),
    extend     = __webpack_require__(51),
    Deferrable = __webpack_require__(183);

var Subscription = Class({
  initialize: function(client, channels, callback, context) {
    this._client    = client;
    this._channels  = channels;
    this._callback  = callback;
    this._context   = context;
    this._cancelled = false;
  },

  withChannel: function(callback, context) {
    this._withChannel = [callback, context];
    return this;
  },

  apply: function(context, args) {
    var message = args[0];

    if (this._callback)
      this._callback.call(this._context, message.data);

    if (this._withChannel)
      this._withChannel[0].call(this._withChannel[1], message.channel, message.data);
  },

  cancel: function() {
    if (this._cancelled) return;
    this._client.unsubscribe(this._channels, this);
    this._cancelled = true;
  },

  unsubscribe: function() {
    this.cancel();
  }
});

extend(Subscription.prototype, Deferrable);

module.exports = Subscription;


/***/ }),
/* 2317 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2318 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_core__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_styles_withStyles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_styles_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_styles_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_icons__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_assets_jss_material_dashboard_pro_react_components_headerLinksStyle__ = __webpack_require__(2319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_SqTasks_TaskList_jsx__ = __webpack_require__(579);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_reducers_TasksReducer__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_store__ = __webpack_require__(10);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// @material-ui/core components
var HeaderLinks=function(_React$Component){_inherits(HeaderLinks,_React$Component);function HeaderLinks(){var _ref;var _temp,_this,_ret;_classCallCheck(this,HeaderLinks);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=HeaderLinks.__proto__||Object.getPrototypeOf(HeaderLinks)).call.apply(_ref,[this].concat(args))),_this),_this.state={open:false},_this.handleClick=function(){_this.setState({open:!_this.state.open});},_this.handleClose=function(){_this.setState({open:false});},_this.handleOpenTasks=function(){__WEBPACK_IMPORTED_MODULE_9_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_8_reducers_TasksReducer__["h" /* toggleProgressOpen */])());},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(HeaderLinks,[{key:'render',value:function render(){var _this2=this;var _props=this.props,classes=_props.classes,rtlActive=_props.rtlActive;var wrapper=__WEBPACK_IMPORTED_MODULE_4_classnames___default()(_defineProperty({},classes.wrapperRTL,rtlActive));return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('div',{className:wrapper},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["d" /* Button */],{onClick:function onClick(){return _this2.handleOpenTasks();},style:{marginRight:'15px',textTransform:'none'}},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{variant:'caption',style:{marginRight:'10px'}},'Quote Progress'),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_icons__["b" /* Assessment */],{style:{color:'#555270'}})),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_SqTasks_TaskList_jsx__["a" /* default */],null));}}]);return HeaderLinks;}(__WEBPACK_IMPORTED_MODULE_7_react___default.a.Component);HeaderLinks.propTypes={classes:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object.isRequired,rtlActive:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool};/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1__material_ui_core_styles_withStyles___default()(__WEBPACK_IMPORTED_MODULE_3_assets_jss_material_dashboard_pro_react_components_headerLinksStyle__["a" /* default */])(HeaderLinks));

/***/ }),
/* 2319 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__ = __webpack_require__(65);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}// ##############################
// // // HeaderLinks styles
// #############################
var headerLinksStyle=function headerLinksStyle(theme){var _searchRTL,_notifications;return{popperClose:{pointerEvents:"none"},search:_defineProperty({},theme.breakpoints.down("sm"),{margin:"10px 15px",float:"none !important",paddingTop:"1px",paddingBottom:"1px",padding:"10px 15px",width:"auto"}),searchInput:{paddingTop:"2px"},searchRTL:(_searchRTL={},_defineProperty(_searchRTL,theme.breakpoints.down("sm"),{marginRight:"18px !important"}),_defineProperty(_searchRTL,theme.breakpoints.up("md"),{marginLeft:"12px"}),_searchRTL),linkText:Object.assign({zIndex:"4"},__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["j" /* defaultFont */],{fontSize:"14px",margin:"0!important",textTransform:"none"}),buttonLink:_defineProperty({},theme.breakpoints.down("sm"),{display:"flex",margin:"5px 15px 0",width:"auto",height:"auto","& svg":{width:"30px",height:"24px",marginRight:"19px",marginLeft:"3px"}}),searchButton:_defineProperty({},theme.breakpoints.down("sm"),{top:"-50px !important",marginRight:"38px",float:"right"}),top:{zIndex:"4"},searchIcon:{width:"17px",zIndex:"4"},links:_defineProperty({width:"20px",height:"20px",zIndex:"4"},theme.breakpoints.down("sm"),{display:"block",width:"30px",height:"30px",color:"inherit",opacity:"0.8",marginRight:"16px",marginLeft:"-5px"}),notifications:(_notifications={zIndex:"4"},_defineProperty(_notifications,theme.breakpoints.up("md"),{position:"absolute",top:"5px",border:"1px solid #FFF",right:"5px",fontSize:"9px",background:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["g" /* dangerColor */],color:"#FFFFFF",minWidth:"16px",height:"16px",borderRadius:"10px",textAlign:"center",lineHeight:"14px",verticalAlign:"middle",display:"block"}),_defineProperty(_notifications,theme.breakpoints.down("sm"),Object.assign({},__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["j" /* defaultFont */],{fontSize:"14px",marginRight:"8px"})),_notifications),dropdown:{borderRadius:"3px",border:"0",boxShadow:"0 2px 5px 0 rgba(0, 0, 0, 0.26)",top:"100%",zIndex:"1000",minWidth:"160px",padding:"5px 0",margin:"2px 0 0",fontSize:"14px",textAlign:"left",listStyle:"none",backgroundColor:"#fff",backgroundClip:"padding-box"},pooperResponsive:_defineProperty({},theme.breakpoints.down("sm"),{zIndex:"1640",position:"static",float:"none",width:"auto",marginTop:"0",backgroundColor:"transparent",border:"0",boxShadow:"none",color:"black"}),dropdownItem:Object.assign({},__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["j" /* defaultFont */],{fontSize:"13px",padding:"10px 20px",margin:"0 5px",borderRadius:"2px",position:"relative",transition:"all 150ms linear",display:"block",clear:"both",fontWeight:"400",height:"fit-content",color:"#333",whiteSpace:"nowrap","&:hover":Object.assign({backgroundColor:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["t" /* primaryColor */],color:"#FFFFFF"},__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["r" /* primaryBoxShadow */])}),dropdownItemRTL:{textAlign:"right !important"},wrapperRTL:_defineProperty({},theme.breakpoints.up("md"),{paddingLeft:"16px"}),buttonLinkRTL:_defineProperty({},theme.breakpoints.down("sm"),{alignItems:"center",justifyContent:"flex-end",width:"-webkit-fill-available",margin:"10px 15px 0",padding:"10px 15px",display:"block",position:"relative"}),labelRTL:_defineProperty({},theme.breakpoints.down("sm"),{flexDirection:"row-reverse",justifyContent:"initial",display:"flex"}),linksRTL:_defineProperty({},theme.breakpoints.down("sm"),{marginRight:"-5px !important",marginLeft:"16px !important"}),managerClasses:_defineProperty({},theme.breakpoints.up("md"),{display:"inline-block"}),headerLinksSvg:{width:"20px !important",height:"20px !important"}};};/* harmony default export */ __webpack_exports__["a"] = (headerLinksStyle);

/***/ }),
/* 2320 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__ = __webpack_require__(65);
// ##############################
// // // Footer styles
// #############################
var footerStyle={block:{},left:{float:"left!important",display:"block"},right:{margin:"0",fontSize:"14px",float:"right!important",padding:"15px"},footer:Object.assign({bottom:"0",borderTop:"1px solid #e7e7e7",padding:"15px 0"},__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["j" /* defaultFont */],{zIndex:4}),container:Object.assign({zIndex:3},__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["c" /* container */],{position:"relative"}),containerFluid:Object.assign({zIndex:3},__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["d" /* containerFluid */],{position:"relative"}),a:{color:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["t" /* primaryColor */],textDecoration:"none",backgroundColor:"transparent"},list:{marginBottom:"0",padding:"0",marginTop:"0"},inlineBlock:{display:"inline-block",padding:"0",width:"auto"},whiteColor:{"&,&:hover,&:focus":{color:"#FFFFFF"}}};/* harmony default export */ __webpack_exports__["a"] = (footerStyle);

/***/ }),
/* 2321 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_perfect_scrollbar__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_styles_withStyles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_styles_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_styles_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_Drawer__ = __webpack_require__(492);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_Drawer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Drawer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_List__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_List___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_List__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_ListItem__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_ListItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_ListItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_ListItemIcon__ = __webpack_require__(500);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_ListItemIcon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_ListItemIcon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_ListItemText__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_ListItemText___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_ListItemText__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_Hidden__ = __webpack_require__(327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_Hidden___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_Hidden__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_core_Collapse__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_core_Collapse___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_Collapse__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_router__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_components_Footer_Footer_jsx__ = __webpack_require__(588);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__material_ui_icons__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_assets_jss_material_dashboard_pro_react_components_sidebarStyle_jsx__ = __webpack_require__(2322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_assets_img_faces_avatar1_jpg__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_assets_img_faces_avatar1_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_assets_img_faces_avatar1_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_helpers_UserHelper__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__material_ui_core__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_assets_img_sidebars_1_jpg__ = __webpack_require__(2323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_assets_img_sidebars_1_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_assets_img_sidebars_1_jpg__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// javascript plugin used to create scrollbars on windows
// @material-ui/core components
// core components
var ps;// We've created this component so we can have a ref to the wrapper of the links that appears in our sidebar.
// This was necessary so that we could initialize PerfectScrollbar on the links.
// There might be something with the Hidden component from material-ui, and we didn't have access to
// the links, and couldn't initialize the plugin.
var SidebarWrapper=function(_React$Component){_inherits(SidebarWrapper,_React$Component);function SidebarWrapper(){var _ref;var _temp,_this,_ret;_classCallCheck(this,SidebarWrapper);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=SidebarWrapper.__proto__||Object.getPrototypeOf(SidebarWrapper)).call.apply(_ref,[this].concat(args))),_this),_this.state={logoutClicked:false},_this.handleLogout=function(){Object(__WEBPACK_IMPORTED_MODULE_18_helpers_UserHelper__["d" /* Logout */])();_this.setState({logoutClicked:true});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(SidebarWrapper,[{key:'componentDidMount',value:function componentDidMount(){if(navigator.platform.indexOf('Win')>-1){ps=new __WEBPACK_IMPORTED_MODULE_2_perfect_scrollbar__["a" /* default */](this.refs.sidebarWrapper,{suppressScrollX:true,suppressScrollY:false});}}},{key:'componentWillUnmount',value:function componentWillUnmount(){if(navigator.platform.indexOf('Win')>-1){ps.destroy();}}},{key:'render',value:function render(){if(this.state.logoutClicked){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_react_router__["a" /* Redirect */],{to:'/app/portal/login'});}var _props=this.props,className=_props.className,user=_props.user,links=_props.links;var logoutRender=function logoutRender(){if(localStorage.getItem('userType')=='')return"none";else return"";};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:className,ref:'sidebarWrapper'},user,links,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_Footer_Footer_jsx__["a" /* default */],{fluid:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{width:'80%',margin:'auto',borderTop:'1px solid #f5f5f530',zIndex:'500'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{width:'80%',margin:'auto'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__material_ui_core__["d" /* Button */],{onClick:this.handleLogout,style:{zIndex:'500',fontWeight:'300',color:'white',textTransform:'none',display:logoutRender()},className:'signOutButton'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__material_ui_icons__["h" /* ExitToApp */],{style:{fontWeight:'300',marginRight:'15px'}}),'Sign Out')));}}]);return SidebarWrapper;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var Sidebar=function(_React$Component2){_inherits(Sidebar,_React$Component2);function Sidebar(props){_classCallCheck(this,Sidebar);var _this2=_possibleConstructorReturn(this,(Sidebar.__proto__||Object.getPrototypeOf(Sidebar)).call(this,props));_this2.openCollapse=function(collapse){var st={};st[collapse]=!_this2.state[collapse];_this2.setState(st);ps.update();};_this2.state={openAvatar:true,openComponents:_this2.activeRoute('/components'),openProfile:_this2.activeRoute('/profile'),openClients:_this2.activeRoute('/app/clients'),openQuotes:_this2.activeRoute('/quotes'),openFna:_this2.activeRoute('/fna'),openForms:_this2.activeRoute('/forms'),openTables:_this2.activeRoute('/tables'),openMaps:_this2.activeRoute('/maps'),openPages:_this2.activeRoute('-page'),openBrokers:_this2.activeRoute('/brokers'),openAssistants:_this2.activeRoute('/assistants'),miniActive:false,userType:'',name:'',surname:''};_this2.activeRoute.bind(_this2);return _this2;}_createClass(Sidebar,[{key:'componentDidMount',value:function componentDidMount(){this.setState({userType:Object(__WEBPACK_IMPORTED_MODULE_18_helpers_UserHelper__["b" /* GetUserKey */])('userType'),name:Object(__WEBPACK_IMPORTED_MODULE_18_helpers_UserHelper__["b" /* GetUserKey */])('name'),surname:Object(__WEBPACK_IMPORTED_MODULE_18_helpers_UserHelper__["b" /* GetUserKey */])('surname')});}// verifies if routeName is the one active (in browser input)
},{key:'activeRoute',value:function activeRoute(routeName){return this.props.location.pathname.indexOf(routeName)>-1?true:false;}},{key:'activeRouteAlt',value:function activeRouteAlt(prop){var mainRoute=this.props.location.pathname.indexOf(prop.path)>-1?true:false;if(!mainRoute&&prop.alternate){return this.props.location.pathname.indexOf(prop.alternate)>-1?true:false;}return mainRoute;}},{key:'render',value:function render(){var _this3=this,_cx,_cx2,_cx17,_cx18;var _props2=this.props,classes=_props2.classes,color=_props2.color,routes=_props2.routes,bgColor=_props2.bgColor,rtlActive=_props2.rtlActive;var image=__WEBPACK_IMPORTED_MODULE_20_assets_img_sidebars_1_jpg___default.a;var userRoutes=routes.slice();userRoutes=userRoutes.filter(function(r){return r.userTypes.includes(_this3.state.userType);});var itemText=classes.itemText+' '+__WEBPACK_IMPORTED_MODULE_4_classnames___default()((_cx={},_defineProperty(_cx,classes.itemTextMini,this.props.miniActive&&this.state.miniActive),_defineProperty(_cx,classes.itemTextMiniRTL,rtlActive&&this.props.miniActive&&this.state.miniActive),_defineProperty(_cx,classes.itemTextRTL,rtlActive),_cx));var collapseItemText=classes.collapseItemText+' '+__WEBPACK_IMPORTED_MODULE_4_classnames___default()((_cx2={},_defineProperty(_cx2,classes.collapseItemTextMini,this.props.miniActive&&this.state.miniActive),_defineProperty(_cx2,classes.collapseItemTextMiniRTL,rtlActive&&this.props.miniActive&&this.state.miniActive),_defineProperty(_cx2,classes.collapseItemTextRTL,rtlActive),_cx2));var userWrapperClass=classes.user+' '+__WEBPACK_IMPORTED_MODULE_4_classnames___default()(_defineProperty({},classes.whiteAfter,bgColor==='white'));var caret=classes.caret+' '+__WEBPACK_IMPORTED_MODULE_4_classnames___default()(_defineProperty({},classes.caretRTL,rtlActive));var photo=classes.photo+' '+__WEBPACK_IMPORTED_MODULE_4_classnames___default()(_defineProperty({},classes.photoRTL,rtlActive));var user=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:userWrapperClass},this.state.userType!=='1'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:photo},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:Object(__WEBPACK_IMPORTED_MODULE_18_helpers_UserHelper__["b" /* GetUserKey */])('avatar')?Object(__WEBPACK_IMPORTED_MODULE_18_helpers_UserHelper__["b" /* GetUserKey */])('avatar'):__WEBPACK_IMPORTED_MODULE_17_assets_img_faces_avatar1_jpg___default.a,className:classes.avatarImg,alt:'...',style:{width:'34px',height:'34px'}})):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_List___default.a,{className:classes.list},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_ListItem___default.a,{className:classes.item+' '+classes.userItem},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["a" /* NavLink */],{to:'#',className:classes.itemLink+' '+classes.userCollapseButton,onClick:function onClick(e){e.preventDefault();_this3.openCollapse('openAvatar');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_ListItemText___default.a,{primary:this.state.name+' '+this.state.surname,secondary:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',{className:caret+' '+classes.userCaret+' '+(this.state.openAvatar?classes.caretActive:'')}),disableTypography:true,className:itemText+' '+classes.userItemText})),this.state.userType!=='1'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_Collapse___default.a,{'in':this.state.openAvatar,unmountOnExit:true,className:'mpContainer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_List___default.a,{className:classes.list+' '+classes.collapseList},userRoutes.length>0?userRoutes.filter(function(u){return u.name==='Profile';})[0].views.filter(function(v){return v.userTypes.includes(_this3.state.userType);}).map(function(prop,key){if(!prop.hidden){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_ListItem___default.a,{className:classes.collapseItem,key:key},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["a" /* NavLink */],{to:prop.path,style:{marginTop:'25px'},className:classes.itemLink+__WEBPACK_IMPORTED_MODULE_4_classnames___default()(_defineProperty({},' '+classes[color],_this3.activeRouteAlt(prop)))+' '+classes.userCollapseLinks},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_ListItemText___default.a,{primary:prop.name,disableTypography:true,className:collapseItemText})));}else{return null;}}):null)):'')));var links=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_List___default.a,{className:classes.list},userRoutes.length>0?userRoutes.filter(function(u){return u.name!=='Profile';}).map(function(prop,key){var _cx15;if(prop.redirect||prop.hidden){return null;}if(prop.collapse){var _cx8,_cx9;var _navLinkClasses=classes.itemLink+' '+__WEBPACK_IMPORTED_MODULE_4_classnames___default()(_defineProperty({},' '+classes.collapseActive,_this3.activeRoute(prop.path)));var _itemText=classes.itemText+' '+__WEBPACK_IMPORTED_MODULE_4_classnames___default()((_cx8={},_defineProperty(_cx8,classes.itemTextMini,_this3.props.miniActive&&_this3.state.miniActive),_defineProperty(_cx8,classes.itemTextMiniRTL,rtlActive&&_this3.props.miniActive&&_this3.state.miniActive),_defineProperty(_cx8,classes.itemTextRTL,rtlActive),_cx8));var _collapseItemText=classes.collapseItemText+' '+__WEBPACK_IMPORTED_MODULE_4_classnames___default()((_cx9={},_defineProperty(_cx9,classes.collapseItemTextMini,_this3.props.miniActive&&_this3.state.miniActive),_defineProperty(_cx9,classes.collapseItemTextMiniRTL,rtlActive&&_this3.props.miniActive&&_this3.state.miniActive),_defineProperty(_cx9,classes.collapseItemTextRTL,rtlActive),_cx9));var _itemIcon=classes.itemIcon+' '+__WEBPACK_IMPORTED_MODULE_4_classnames___default()(_defineProperty({},classes.itemIconRTL,rtlActive));var _caret=classes.caret+' '+__WEBPACK_IMPORTED_MODULE_4_classnames___default()(_defineProperty({},classes.caretRTL,rtlActive));return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_ListItem___default.a,{key:key,className:classes.item},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["a" /* NavLink */],{to:'#',className:_navLinkClasses,onClick:function onClick(e){e.preventDefault();_this3.openCollapse(prop.state);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_ListItemIcon___default.a,{className:_itemIcon},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(prop.icon,null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_ListItemText___default.a,{primary:prop.name,secondary:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',{className:_caret+' '+(_this3.state[prop.state]?classes.caretActive:'')}),disableTypography:true,className:_itemText})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_Collapse___default.a,{'in':_this3.state[prop.state],unmountOnExit:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_List___default.a,{className:classes.list+' '+classes.collapseList},(prop.views.length>0&&prop.views.filter(function(v){return v.userTypes.includes(_this3.state.userType);})).map(function(prop,key){if(prop.redirect||prop.hidden){return null;}var navLinkClasses=classes.collapseItemLink+' '+__WEBPACK_IMPORTED_MODULE_4_classnames___default()(_defineProperty({},' '+classes[color],_this3.activeRouteAlt(prop)));var collapseItemMini=classes.collapseItemMini+' '+__WEBPACK_IMPORTED_MODULE_4_classnames___default()(_defineProperty({},classes.collapseItemMiniRTL,rtlActive));return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_ListItem___default.a,{key:key,className:classes.collapseItem},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["a" /* NavLink */],{to:prop.path,className:navLinkClasses},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:collapseItemMini},prop.mini),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_ListItemText___default.a,{primary:prop.name,disableTypography:true,className:_collapseItemText})));}))));}var navLinkClasses=classes.itemLink+' '+__WEBPACK_IMPORTED_MODULE_4_classnames___default()(_defineProperty({},' '+classes[color],_this3.activeRoute(prop.path)));var itemText=classes.itemText+' '+__WEBPACK_IMPORTED_MODULE_4_classnames___default()((_cx15={},_defineProperty(_cx15,classes.itemTextMini,_this3.props.miniActive&&_this3.state.miniActive),_defineProperty(_cx15,classes.itemTextMiniRTL,rtlActive&&_this3.props.miniActive&&_this3.state.miniActive),_defineProperty(_cx15,classes.itemTextRTL,rtlActive),_cx15));var itemIcon=classes.itemIcon+' '+__WEBPACK_IMPORTED_MODULE_4_classnames___default()(_defineProperty({},classes.itemIconRTL,rtlActive));return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_ListItem___default.a,{key:key,className:classes.item},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["a" /* NavLink */],{to:prop.path,className:navLinkClasses},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_ListItemIcon___default.a,{className:itemIcon},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(prop.icon,null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_ListItemText___default.a,{primary:prop.name,disableTypography:true,className:itemText})));}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null));var drawerPaper=classes.drawerPaper+' '+__WEBPACK_IMPORTED_MODULE_4_classnames___default()((_cx17={},_defineProperty(_cx17,classes.drawerPaperMini,this.props.miniActive&&this.state.miniActive),_defineProperty(_cx17,classes.drawerPaperRTL,rtlActive),_cx17));var sidebarWrapper=classes.sidebarWrapper+' '+__WEBPACK_IMPORTED_MODULE_4_classnames___default()((_cx18={},_defineProperty(_cx18,classes.drawerPaperMini,this.props.miniActive&&this.state.miniActive),_defineProperty(_cx18,classes.sidebarWrapperWithPerfectScrollbar,navigator.platform.indexOf('Win')>-1),_cx18));return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{ref:'mainPanel'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_Hidden___default.a,{mdUp:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Drawer___default.a,{variant:'temporary',anchor:rtlActive?'left':'right',open:this.props.open,classes:{paper:drawerPaper+' '+classes[bgColor+'Background']},onClose:this.props.handleDrawerToggle,ModalProps:{keepMounted:true// Better open performance on mobile.
}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SidebarWrapper,{className:sidebarWrapper,user:user,links:links}),image!==undefined?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:classes.background,style:{backgroundImage:'url('+image+')'}}):null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_Hidden___default.a,{smDown:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Drawer___default.a,{onMouseOver:function onMouseOver(){return _this3.setState({miniActive:false});},onMouseOut:function onMouseOut(){return _this3.setState({miniActive:true});},anchor:rtlActive?'right':'left',variant:'permanent',open:true,classes:{paper:drawerPaper+' '+classes[bgColor+'Background']}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SidebarWrapper,{className:sidebarWrapper,user:user,links:links}),image!==undefined?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:classes.background,style:{backgroundImage:'url('+image+')'}}):null)));}}]);return Sidebar;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);Sidebar.defaultProps={bgColor:'blue'};Sidebar.propTypes={classes:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,bgColor:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['white','black','blue','purple']),rtlActive:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,color:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['white','red','orange','green','blue','purple','deepPurple','rose']),logo:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,logoText:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,image:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,routes:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object)};/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_5__material_ui_core_styles_withStyles___default()(__WEBPACK_IMPORTED_MODULE_16_assets_jss_material_dashboard_pro_react_components_sidebarStyle_jsx__["a" /* default */])(Sidebar));

/***/ }),
/* 2322 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__ = __webpack_require__(65);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}// ##############################
// // // Sidebar styles
// #############################
var deepPurpleBoxShadow={boxShadow:"0 12px 20px -10px rgba(84, 82, 110, 0.48), 0 4px 20px 0 rgba(0,0,0,.12), 0 7px 8px -5px rgba(84, 82, 110, 0.48)"};var sidebarStyle=function sidebarStyle(theme){var _drawerPaperRTL,_Object$assign;return{drawerPaperRTL:(_drawerPaperRTL={},_defineProperty(_drawerPaperRTL,theme.breakpoints.up("md"),{left:"auto !important",right:"0 !important"}),_defineProperty(_drawerPaperRTL,theme.breakpoints.down("sm"),{left:"0  !important",right:"auto !important"}),_drawerPaperRTL),drawerPaper:Object.assign({border:"none",position:"fixed",top:"0",bottom:"0",left:"0",zIndex:"1032",transitionProperty:"top, bottom, width",transitionDuration:".2s, .2s, .35s",transitionTimingFunction:"linear, linear, ease"},__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["a" /* boxShadow */],(_Object$assign={},_defineProperty(_Object$assign,theme.breakpoints.up("md"),{width:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["l" /* drawerWidth */],position:"fixed",height:"100%"}),_defineProperty(_Object$assign,theme.breakpoints.down("sm"),Object.assign({width:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["l" /* drawerWidth */]},__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["a" /* boxShadow */],{position:"fixed",display:"block",top:"0",height:"100vh",right:"0",left:"auto",zIndex:"1032",visibility:"visible",overflowY:"visible",borderTop:"none",textAlign:"left",paddingRight:"0px",paddingLeft:"0",transform:"translate3d("+__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["l" /* drawerWidth */]+"px, 0, 0)"},__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["F" /* transition */])),_defineProperty(_Object$assign,"&:before,&:after",{position:"absolute",zIndex:"3",width:"100%",height:"100%",content:'""',display:"block",top:"0"}),_Object$assign)),blackBackground:{color:"#FFFFFF","&:after":{background:"#000",opacity:".8"}},blueBackground:{color:"#FFFFFF","&:after":{background:"#00acc1",opacity:".93"}},whiteBackground:{color:"#3C4858","&:after":{background:"#FFFFFF",opacity:".93"}},whiteAfter:{"&:after":{backgroundColor:"hsla(0,0%,71%,.3) !important"}},drawerPaperMini:{width:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["k" /* drawerMiniWidth */]+"px!important"},logo:{padding:"15px 0px",margin:"0",display:"block",position:"relative",zIndex:"4","&:after":{content:'""',position:"absolute",bottom:"0",height:"1px",right:"15px",width:"calc(100% - 30px)",backgroundColor:"hsla(0,0%,100%,.3)"}},logoMini:{transition:"all 300ms linear",opacity:1,float:"left",textAlign:"center",width:"30px",display:"inline-block",maxHeight:"30px",marginLeft:"22px",marginRight:"18px",marginTop:"7px",color:"inherit"},logoMiniRTL:{float:"right",marginRight:"30px",marginLeft:"26px"},logoNormal:Object.assign({},__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["j" /* defaultFont */],{transition:"all 300ms linear",display:"block",opacity:"1",transform:"translate3d(0px, 0, 0)",textTransform:"uppercase",padding:"5px 0px",fontSize:"18px",whiteSpace:"nowrap",fontWeight:"400",lineHeight:"30px",overflow:"hidden","&,&:hover,&:focus":{color:"inherit"}}),logoNormalRTL:{textAlign:"right"},logoNormalSidebarMini:{opacity:"0",transform:"translate3d(-25px, 0, 0)"},logoNormalSidebarMiniRTL:{transform:"translate3d(25px, 0, 0)"},img:{width:"35px",verticalAlign:"middle",border:"0"},background:{position:"absolute",zIndex:"1",height:"100%",width:"100%",display:"block",top:"0",left:"0",backgroundSize:"cover",backgroundPosition:"center center",transition:"all 300ms linear"},list:{marginTop:"15px",paddingLeft:"0",paddingTop:"0",paddingBottom:"0",marginBottom:"0",listStyle:"none",color:"inherit","&:before,&:after":{display:"table",content:'" "'},"&:after":{clear:"both"}},item:{color:"inherit",position:"relative",display:"block",textDecoration:"none",margin:"0",padding:"0"},userItem:{"&:last-child":{paddingBottom:"0px"}},itemLink:Object.assign({paddingLeft:"10px",paddingRight:"10px",transition:"all 300ms linear",margin:"10px 15px 0",borderRadius:"3px",position:"relative",display:"block",padding:"10px 15px",backgroundColor:"transparent"},__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["j" /* defaultFont */],{width:"auto","&:hover":{outline:"none",backgroundColor:"rgba(200, 200, 200, 0.2)",boxShadow:"none"},"&,&:hover,&:focus":{color:"inherit"}}),itemIcon:{color:"inherit",width:"30px",height:"24px",float:"left",position:"inherit",top:"3px",marginRight:"15px",textAlign:"center",verticalAlign:"middle",opacity:"0.8"},itemIconRTL:{float:"right",marginLeft:"15px",marginRight:"1px"},itemText:Object.assign({color:"inherit"},__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["j" /* defaultFont */],{margin:"0",lineHeight:"30px",fontSize:"14px",transform:"translate3d(0px, 0, 0)",opacity:"1",transition:"transform 300ms ease 0s, opacity 300ms ease 0s",position:"relative",display:"block",height:"auto",whiteSpace:"nowrap"}),userItemText:{lineHeight:"22px"},itemTextRTL:{marginRight:"45px",textAlign:"right"},itemTextMini:{transform:"translate3d(-25px, 0, 0)",opacity:"0"},itemTextMiniRTL:{transform:"translate3d(25px, 0, 0) !important"},collapseList:{marginTop:"0"},collapseItem:{position:"relative",display:"block",textDecoration:"none",margin:"10px 0 0 0",padding:"0"},collapseActive:{outline:"none",backgroundColor:"rgba(200, 200, 200, 0.2)",boxShadow:"none"},collapseItemLink:Object.assign({transition:"all 300ms linear",margin:"0 15px",borderRadius:"3px",position:"relative",display:"block",padding:"10px",backgroundColor:"transparent"},__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["j" /* defaultFont */],{width:"auto","&:hover":{outline:"none",backgroundColor:"rgba(200, 200, 200, 0.2)",boxShadow:"none"},"&,&:hover,&:focus":{color:"inherit"}}),collapseItemMini:Object.assign({color:"inherit"},__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["j" /* defaultFont */],{textTransform:"uppercase",width:"30px",marginRight:"15px",textAlign:"center",letterSpacing:"1px",position:"relative",float:"left",display:"inherit",transition:"transform 300ms ease 0s, opacity 300ms ease 0s",fontSize:"14px"}),collapseItemMiniRTL:{float:"right",marginLeft:"30px",marginRight:"1px"},collapseItemText:Object.assign({color:"inherit"},__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["j" /* defaultFont */],{margin:"0",position:"relative",transform:"translateX(0px)",opacity:"1",whiteSpace:"nowrap",display:"block",transition:"transform 300ms ease 0s, opacity 300ms ease 0s",fontSize:"14px"}),collapseItemTextRTL:{textAlign:"right"},collapseItemTextMiniRTL:{transform:"translate3d(25px, 0, 0) !important"},collapseItemTextMini:{transform:"translate3d(-25px, 0, 0)",opacity:"0"},caret:{marginTop:"13px",position:"absolute",right:"18px",transition:"all 150ms ease-in",display:"inline-block",width:"0",height:"0",marginLeft:"2px",verticalAlign:"middle",borderTop:"4px solid",borderRight:"4px solid transparent",borderLeft:"4px solid transparent"},userCaret:{marginTop:"10px"},caretRTL:{left:"11px",right:"auto"},caretActive:{transform:"rotate(180deg)"},purple:{"&,&:hover,&:focus":Object.assign({color:"#FFFFFF",backgroundColor:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["t" /* primaryColor */]},__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["r" /* primaryBoxShadow */])},deepPurple:{"&,&:hover,&:focus":Object.assign({color:"#FFFFFF",backgroundColor:"#6c5cab"},deepPurpleBoxShadow)},blue:{"&,&:hover,&:focus":{color:"#FFFFFF",backgroundColor:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["q" /* infoColor */],boxShadow:"0 12px 20px -10px rgba(0,188,212,.28), 0 4px 20px 0 rgba(0,0,0,.12), 0 7px 8px -5px rgba(0,188,212,.2)"}},green:{"&,&:hover,&:focus":{color:"#FFFFFF",backgroundColor:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["D" /* successColor */],boxShadow:"0 12px 20px -10px rgba(76,175,80,.28), 0 4px 20px 0 rgba(0,0,0,.12), 0 7px 8px -5px rgba(76,175,80,.2)"}},orange:{"&,&:hover,&:focus":{color:"#FFFFFF",backgroundColor:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["I" /* warningColor */],boxShadow:"0 12px 20px -10px rgba(255,152,0,.28), 0 4px 20px 0 rgba(0,0,0,.12), 0 7px 8px -5px rgba(255,152,0,.2)"}},red:{"&,&:hover,&:focus":{color:"#FFFFFF",backgroundColor:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["g" /* dangerColor */],boxShadow:"0 12px 20px -10px rgba(244,67,54,.28), 0 4px 20px 0 rgba(0,0,0,.12), 0 7px 8px -5px rgba(244,67,54,.2)"}},white:{"&,&:hover,&:focus":{color:"#3C4858",backgroundColor:"#FFFFFF",boxShadow:"0 4px 20px 0 rgba(0,0,0,.14), 0 7px 10px -5px rgba(60,72,88,.4)"}},rose:{"&,&:hover,&:focus":{color:"#FFFFFF",backgroundColor:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["w" /* roseColor */],boxShadow:"0 4px 20px 0 rgba(0,0,0,.14), 0 7px 10px -5px rgba(233,30,99,.4)"}},sidebarWrapper:{position:"relative",height:"92vh",overflow:"auto",width:"15%",maxWidth:"260px",minWidth:"200px",zIndex:"4",overflowScrolling:"touch",transitionProperty:"top, bottom, width",transitionDuration:".2s, .2s, .35s",transitionTimingFunction:"linear, linear, ease",color:"inherit",paddingBottom:"30px"},sidebarWrapperWithPerfectScrollbar:{overflow:"hidden !important"},user:{paddingBottom:"20px",margin:"20px auto 0",position:"relative","&:after":{content:'""',position:"absolute",bottom:"0",right:"15px",height:"1px",width:"calc(100% - 30px)",backgroundColor:"hsla(0,0%,100%,.3)"}},photo:Object.assign({transition:"all 300ms linear",width:"34px",height:"34px",overflow:"hidden",float:"left",zIndex:"5",marginRight:"11px",borderRadius:"50%",marginLeft:"23px"},__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["a" /* boxShadow */]),photoRTL:{float:"right",marginLeft:"12px",marginRight:"24px"},avatarImg:{width:"100%",verticalAlign:"middle",border:"0"},userCollapseButton:{margin:"0",padding:"6px 15px","&:hover":{background:"none"}},userCollapseLinks:{marginTop:"-4px","&:hover,&:focus":{color:"#FFFFFF"}}};};/* harmony default export */ __webpack_exports__["a"] = (sidebarStyle);

/***/ }),
/* 2323 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/1.61c4c50e.jpg";

/***/ }),
/* 2324 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_views_Dashboard_Dashboard_jsx__ = __webpack_require__(2325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_icons__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_views_Profile_Profile_jsx__ = __webpack_require__(2342);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_views_Clients_components_ClientForm_jsx__ = __webpack_require__(2380);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_views_Clients_components_ManageClients_jsx__ = __webpack_require__(2434);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_views_Clients_components_ClientEditForm_jsx__ = __webpack_require__(2442);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_views_Clients_components_ClientEditForm_EliteWealth_jsx__ = __webpack_require__(2443);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_views_Clients_components_ClientHistory_EliteWealth_jsx__ = __webpack_require__(2445);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_views_Clients_components_ClientForQuote_jsx__ = __webpack_require__(2446);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_views_Quote_QuoteHistory_jsx__ = __webpack_require__(2447);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_views_Quote_ResultsPage_jsx__ = __webpack_require__(2449);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_views_Brokers_AssistantAssignment_jsx__ = __webpack_require__(2455);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_views_Profile_BrokerageAdminProfile_jsx__ = __webpack_require__(2459);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_views_Profile_BrokerageBrokerProfile_jsx__ = __webpack_require__(2462);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_views_Subscription_Subscription_jsx__ = __webpack_require__(2465);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_views_UserManagement_UserManagement_jsx__ = __webpack_require__(2466);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_views_Profile_Assistant_AssistantProfile_jsx__ = __webpack_require__(2470);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_views_Assistant_BrokerAssignment_jsx__ = __webpack_require__(2471);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_views_Assistant_ManageClients_jsx__ = __webpack_require__(2473);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_views_Assistant_AddClient_jsx__ = __webpack_require__(2474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_views_Assistant_QuoteHistory_jsx__ = __webpack_require__(2475);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_views_Profile_CompanyLoginDetails_jsx__ = __webpack_require__(2476);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_views_Fna_fna_wizard_jsx__ = __webpack_require__(2478);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_views_Fna_ResultsPage_FnaResultsPage_jsx__ = __webpack_require__(634);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_views_Fna_FnaResultsJson_jsx__ = __webpack_require__(2601);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_views_Fna_FnaHistory_jsx__ = __webpack_require__(2603);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_views_Fna_ClientForFna_jsx__ = __webpack_require__(2606);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_views_Bna_bna_wizard_jsx__ = __webpack_require__(2607);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_views_Messaging_ClientMessages_jsx__ = __webpack_require__(690);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_views_Messaging_ClientMessageHistory_jsx__ = __webpack_require__(2642);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_views_Todos_UserTodos_jsx__ = __webpack_require__(2644);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_views_Payment_PaymentPlayground_jsx__ = __webpack_require__(2650);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_views_Payment_PaymentSuccess_jsx__ = __webpack_require__(2651);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_views_Payment_PaymentFailed_jsx__ = __webpack_require__(2652);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_views_Clients_ClientDetail_ClientDetailView_jsx__ = __webpack_require__(2653);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35_views_Subscription_EditSubscription_jsx__ = __webpack_require__(2663);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36_views_Quote_QuoteWizard_QuoteWizard_jsx__ = __webpack_require__(2666);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37_views_MedicalAidQuote_QuoteWizard_QuoteWizardMedical_jsx__ = __webpack_require__(2775);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38_views_Clients_components_advanced_search_AdvancedSearch_jsx__ = __webpack_require__(2855);
/*eslint-disable*/// @material-ui/icons
// Broker views
//Brokerage views
//Assistant views
//FNA
//BNA
//Messaging
//Payment
//
var dashRoutes=[{path:'/app/home',name:'Home',icon:__WEBPACK_IMPORTED_MODULE_1__material_ui_icons__["g" /* Dashboard */],component:__WEBPACK_IMPORTED_MODULE_0_views_Dashboard_Dashboard_jsx__["a" /* default */],userTypes:['2','3','6']},{path:'/app/paymentplayground',name:'Todo',hidden:true,icon:__WEBPACK_IMPORTED_MODULE_1__material_ui_icons__["m" /* PlaylistAddCheck */],component:__WEBPACK_IMPORTED_MODULE_31_views_Payment_PaymentPlayground_jsx__["a" /* default */],userTypes:['2','3']},{path:'/app/paymentsuccess',name:'Todo',hidden:true,icon:__WEBPACK_IMPORTED_MODULE_1__material_ui_icons__["m" /* PlaylistAddCheck */],component:__WEBPACK_IMPORTED_MODULE_32_views_Payment_PaymentSuccess_jsx__["a" /* default */],userTypes:['2','3']},{path:'/app/paymentfailed',name:'Todo',hidden:true,icon:__WEBPACK_IMPORTED_MODULE_1__material_ui_icons__["m" /* PlaylistAddCheck */],component:__WEBPACK_IMPORTED_MODULE_33_views_Payment_PaymentFailed_jsx__["a" /* default */],userTypes:['2','3']},{path:'/app/clientdetail',name:'Client Detail View',hidden:true,icon:__WEBPACK_IMPORTED_MODULE_1__material_ui_icons__["m" /* PlaylistAddCheck */],component:__WEBPACK_IMPORTED_MODULE_34_views_Clients_ClientDetail_ClientDetailView_jsx__["a" /* default */],userTypes:['2','3','6']},{path:'/app/brokerageAdminProfile',name:'Profile',icon:__WEBPACK_IMPORTED_MODULE_1__material_ui_icons__["l" /* Person */],component:__WEBPACK_IMPORTED_MODULE_12_views_Profile_BrokerageAdminProfile_jsx__["a" /* default */],userTypes:['1']},{collapse:true,path:'/app/profile',name:'Profile',state:'openProfile',icon:__WEBPACK_IMPORTED_MODULE_1__material_ui_icons__["a" /* Apps */],userTypes:['1','2','3','6',''],views:[{path:'/app/userProfile',name:'Profile',component:__WEBPACK_IMPORTED_MODULE_2_views_Profile_Profile_jsx__["a" /* default */],userTypes:['2']},{path:'/app/brokerageBrokerProfile',name:'Profile',component:__WEBPACK_IMPORTED_MODULE_13_views_Profile_BrokerageBrokerProfile_jsx__["a" /* default */],userTypes:['3']},{path:'/app/subscription',name:'Subscription',hidden:true,component:__WEBPACK_IMPORTED_MODULE_14_views_Subscription_Subscription_jsx__["a" /* default */],userTypes:['3']},{path:'/app/editsubscription',name:'Edit Subscription',hidden:true,component:__WEBPACK_IMPORTED_MODULE_35_views_Subscription_EditSubscription_jsx__["a" /* default */],userTypes:['3']},{path:'/app/AssistantProfile',name:'Profile',component:__WEBPACK_IMPORTED_MODULE_16_views_Profile_Assistant_AssistantProfile_jsx__["a" /* default */],userTypes:['6']},{path:'/app/companylogindetails',name:'FSP Login Detail',component:__WEBPACK_IMPORTED_MODULE_21_views_Profile_CompanyLoginDetails_jsx__["a" /* default */],userTypes:['2','3','6','']},{path:'/app/usermanagement',name:'Brokerage Users',component:__WEBPACK_IMPORTED_MODULE_15_views_UserManagement_UserManagement_jsx__["a" /* default */],userTypes:['1','3']},{path:'/app/assistantassignment',name:'Assistant Assignment',component:__WEBPACK_IMPORTED_MODULE_11_views_Brokers_AssistantAssignment_jsx__["a" /* default */],userTypes:['2','3']},{path:'/app/brokerassignment',name:'Broker Assignment',component:__WEBPACK_IMPORTED_MODULE_17_views_Assistant_BrokerAssignment_jsx__["a" /* default */],userTypes:['6']}]},{path:'/app/clientmessagehistory',name:'Client Messages',icon:__WEBPACK_IMPORTED_MODULE_1__material_ui_icons__["e" /* Chat */],component:__WEBPACK_IMPORTED_MODULE_29_views_Messaging_ClientMessageHistory_jsx__["a" /* default */],userTypes:['2','3','6']},{path:'/app/ManageClients',name:'Clients',icon:__WEBPACK_IMPORTED_MODULE_1__material_ui_icons__["k" /* People */],component:__WEBPACK_IMPORTED_MODULE_4_views_Clients_components_ManageClients_jsx__["a" /* default */],userTypes:['2','3']},{path:'/app/manageclientsassistant',name:'Clients',icon:__WEBPACK_IMPORTED_MODULE_1__material_ui_icons__["k" /* People */],component:__WEBPACK_IMPORTED_MODULE_18_views_Assistant_ManageClients_jsx__["a" /* default */],userTypes:['6']},{collapse:true,path:'/app/clients',hidden:true,name:'Clients',state:'openClients',icon:__WEBPACK_IMPORTED_MODULE_1__material_ui_icons__["k" /* People */],userTypes:['2','3','6'],views:[{path:'/app/CreateClient',alternate:'/app/ManageClients',name:'Add Client',mini:'+',component:__WEBPACK_IMPORTED_MODULE_3_views_Clients_components_ClientForm_jsx__["a" /* default */],userTypes:['2','3']},{path:'/app/ManageClients',name:'Manage Clients',mini:'-',component:__WEBPACK_IMPORTED_MODULE_4_views_Clients_components_ManageClients_jsx__["a" /* default */],userTypes:['2','3']},{path:'/app/createclientassistant',alternate:'/app/CreateClient',name:'Add Client',mini:'+',component:__WEBPACK_IMPORTED_MODULE_19_views_Assistant_AddClient_jsx__["a" /* default */],userTypes:['6']},{path:'/app/manageclientsassistant',alternate:'/app/ManageClients',name:'Manage Clients',mini:'-',component:__WEBPACK_IMPORTED_MODULE_18_views_Assistant_ManageClients_jsx__["a" /* default */],userTypes:['6']}]},{path:'/app/EditClient',name:'Edit Client',icon:__WEBPACK_IMPORTED_MODULE_1__material_ui_icons__["g" /* Dashboard */],component:__WEBPACK_IMPORTED_MODULE_5_views_Clients_components_ClientEditForm_jsx__["a" /* default */],hidden:true,userTypes:['2','3']},{path:'/app/EditClientEliteWealth',name:'Edit Client Elite',icon:__WEBPACK_IMPORTED_MODULE_1__material_ui_icons__["g" /* Dashboard */],component:__WEBPACK_IMPORTED_MODULE_6_views_Clients_components_ClientEditForm_EliteWealth_jsx__["a" /* default */],hidden:true,userTypes:['2','3']},{path:'/app/ClientHistoryEliteWealth',name:'Edit Client Elite',icon:__WEBPACK_IMPORTED_MODULE_1__material_ui_icons__["g" /* Dashboard */],component:__WEBPACK_IMPORTED_MODULE_7_views_Clients_components_ClientHistory_EliteWealth_jsx__["a" /* default */],hidden:true,userTypes:['2','3']},{path:'/app/advancedsearch',name:'Advanced Search',icon:__WEBPACK_IMPORTED_MODULE_1__material_ui_icons__["g" /* Dashboard */],component:__WEBPACK_IMPORTED_MODULE_38_views_Clients_components_advanced_search_AdvancedSearch_jsx__["a" /* default */],hidden:true,userTypes:['2','3','6']},{path:'/app/history',name:'Quotes',icon:__WEBPACK_IMPORTED_MODULE_1__material_ui_icons__["c" /* Assignment */],component:__WEBPACK_IMPORTED_MODULE_9_views_Quote_QuoteHistory_jsx__["a" /* default */],userTypes:['2','3']},{path:'/app/quotehistoryassistant',alternate:'/app/history',name:'Quotes',icon:__WEBPACK_IMPORTED_MODULE_1__material_ui_icons__["c" /* Assignment */],component:__WEBPACK_IMPORTED_MODULE_20_views_Assistant_QuoteHistory_jsx__["a" /* default */],userTypes:['6']},{path:'/app/new',name:'New Quote',hidden:true,component:__WEBPACK_IMPORTED_MODULE_8_views_Clients_components_ClientForQuote_jsx__["a" /* default */],userTypes:['2','3','6']},{path:'/app/usertodos',name:'To Do',hidden:false,icon:__WEBPACK_IMPORTED_MODULE_1__material_ui_icons__["m" /* PlaylistAddCheck */],component:__WEBPACK_IMPORTED_MODULE_30_views_Todos_UserTodos_jsx__["a" /* default */],userTypes:['2','3','6']},{path:'/app/quote',name:'New Quote',hidden:true,icon:__WEBPACK_IMPORTED_MODULE_1__material_ui_icons__["c" /* Assignment */],component:__WEBPACK_IMPORTED_MODULE_36_views_Quote_QuoteWizard_QuoteWizard_jsx__["a" /* default */],userTypes:['2','3','6']},{path:'/app/quotemedical',name:'New Quote',hidden:true,icon:__WEBPACK_IMPORTED_MODULE_1__material_ui_icons__["c" /* Assignment */],component:__WEBPACK_IMPORTED_MODULE_37_views_MedicalAidQuote_QuoteWizard_QuoteWizardMedical_jsx__["a" /* default */],userTypes:['2','3','6']},{path:'/app/newfna',name:'FNA (in construction)',hidden:true,icon:__WEBPACK_IMPORTED_MODULE_1__material_ui_icons__["d" /* BubbleChart */],component:__WEBPACK_IMPORTED_MODULE_22_views_Fna_fna_wizard_jsx__["a" /* default */],userTypes:['2','3','6']},{path:'/app/fnahistory',name:'FNA (ALPHA)',hidden:false,icon:__WEBPACK_IMPORTED_MODULE_1__material_ui_icons__["d" /* BubbleChart */],component:__WEBPACK_IMPORTED_MODULE_25_views_Fna_FnaHistory_jsx__["a" /* default */],userTypes:['2','3','6']},{path:'/app/clientforfna',name:'clientforfna',hidden:true,icon:__WEBPACK_IMPORTED_MODULE_1__material_ui_icons__["d" /* BubbleChart */],component:__WEBPACK_IMPORTED_MODULE_26_views_Fna_ClientForFna_jsx__["a" /* default */],userTypes:['2','3','6']},{path:'/app/fnaresults',name:'FNA (in construction)',hidden:true,icon:__WEBPACK_IMPORTED_MODULE_1__material_ui_icons__["d" /* BubbleChart */],component:__WEBPACK_IMPORTED_MODULE_23_views_Fna_ResultsPage_FnaResultsPage_jsx__["a" /* default */],userTypes:['2','3']},{path:'/app/fnaresultsjson',name:'FNA',hidden:true,icon:__WEBPACK_IMPORTED_MODULE_1__material_ui_icons__["d" /* BubbleChart */],component:__WEBPACK_IMPORTED_MODULE_24_views_Fna_FnaResultsJson_jsx__["a" /* default */],userTypes:['2','3']},{path:'/app/newbna',name:'BNA (in EARLY construction)',hidden:false,icon:__WEBPACK_IMPORTED_MODULE_1__material_ui_icons__["d" /* BubbleChart */],component:__WEBPACK_IMPORTED_MODULE_27_views_Bna_bna_wizard_jsx__["a" /* default */],userTypes:['2','3','6']},{path:'/app/quoteresult',name:'Quote Result',icon:__WEBPACK_IMPORTED_MODULE_1__material_ui_icons__["g" /* Dashboard */],component:__WEBPACK_IMPORTED_MODULE_10_views_Quote_ResultsPage_jsx__["a" /* default */],hidden:true,userTypes:['2','3']},{path:'/app/clientmessages',name:'Client Messages',icon:__WEBPACK_IMPORTED_MODULE_1__material_ui_icons__["g" /* Dashboard */],component:__WEBPACK_IMPORTED_MODULE_28_views_Messaging_ClientMessages_jsx__["a" /* default */],hidden:true,userTypes:['2','3','6']},{path:'/app/',name:'Home',hidden:true,icon:__WEBPACK_IMPORTED_MODULE_1__material_ui_icons__["g" /* Dashboard */],component:__WEBPACK_IMPORTED_MODULE_0_views_Dashboard_Dashboard_jsx__["a" /* default */],userTypes:['2','3','6']}];/* harmony default export */ __webpack_exports__["a"] = (dashRoutes);

/***/ }),
/* 2325 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_core__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_styles_withStyles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_styles_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_styles_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_icons__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_assets_jss_material_dashboard_pro_react_views_dashboardStyle__ = __webpack_require__(2326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Card_Card_jsx__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_Card_CardBody_jsx__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_Card_CardFooter_jsx__ = __webpack_require__(2330);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_Card_CardHeader_jsx__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_Card_CardIcon_jsx__ = __webpack_require__(247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_Grid_GridContainer_jsx__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_Grid_GridItem_jsx__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_helpers_UserHelper__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_perfect_scrollbar__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_perfect_scrollbar_css_perfect_scrollbar_css__ = __webpack_require__(363);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_perfect_scrollbar_css_perfect_scrollbar_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_perfect_scrollbar_css_perfect_scrollbar_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_queries_dashboardQuery__ = __webpack_require__(2334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react_apollo__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_react_redux__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_react_responsive_carousel_lib_styles_carousel_min_css__ = __webpack_require__(2335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_react_responsive_carousel_lib_styles_carousel_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_react_responsive_carousel_lib_styles_carousel_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_react_router__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__node_modules_graphql_tag__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__node_modules_graphql_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__node_modules_graphql_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_Birthdays_jsx__ = __webpack_require__(2336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_NewsList_jsx__ = __webpack_require__(2338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__Dashboard_css__ = __webpack_require__(2339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__Dashboard_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__Dashboard_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__queries_clientBirthdays__ = __webpack_require__(2340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__mutations_SendEmail__ = __webpack_require__(2341);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  {\n    NewsRss {\n      feed\n    }\n  }\n'],['\n  {\n    NewsRss {\n      feed\n    }\n  }\n']);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}// @material-ui/core components
// @material-ui/icons
// core components
//Data
//import { Carousel } from "react-responsive-carousel";
//import { Paper } from "@material-ui/core"
var newsQuery=__WEBPACK_IMPORTED_MODULE_21__node_modules_graphql_tag___default()(_templateObject);// const productNewsData = [
//   {
//     imageUrl: "https://economictimes.indiatimes.com/photo/61639321.cms"
//   },
//   {
//     imageUrl:
//       "https://yw553ftvhw1iqegz29fycoyw-wpengine.netdna-ssl.com/wp-content/uploads/2017/10/Insurance.jpg"
//   },
//   {
//     imageUrl:
//       "http://www.thecheaperinsurance.com/wp-content/uploads/2015/08/17121703798_63f339f34a_o.jpg"
//   }
// ];
var ps;var Dashboard=function(_React$Component){_inherits(Dashboard,_React$Component);function Dashboard(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Dashboard);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Dashboard.__proto__||Object.getPrototypeOf(Dashboard)).call.apply(_ref,[this].concat(args))),_this),_this.updatePs=function(){if(ps){ps.update();}},_this.updatePs2=function(){/* 	if (ps2) {
			ps2.update();
		} */},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Dashboard,[{key:'componentWillUnmount',value:function componentWillUnmount(){if(navigator.platform.indexOf('Win')>-1){if(this.refs.newsList){ps.destroy();}/* 	if (this.refs.birthdays) {
				ps2.destroy();
			} */}}},{key:'componentDidUpdate',value:function componentDidUpdate(e){if(navigator.platform.indexOf('Win')>-1){if(this.refs.newsList){ps=new __WEBPACK_IMPORTED_MODULE_12_perfect_scrollbar__["a" /* default */](this.refs.newsList,{wheelSpeed:0.5,wheelPropagation:true,minScrollbarLength:20});}/* if (this.refs.birthdays) {
				ps2 = new PerfectScrollbar(this.refs.birthdays, {
					wheelSpeed: 0.5,
					wheelPropagation: true,
					minScrollbarLength: 20,
					suppressScrollX: true
				});
			} */}}},{key:'render',value:function render(){var _this2=this;var classes=this.props.classes;if(this.props.data.loading){return __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["B" /* LinearProgress */],null);}var data=this.props.data;if(data.error&&data.error.message&&data.error.message==='GraphQL error: invalid token'){Object(__WEBPACK_IMPORTED_MODULE_11_helpers_UserHelper__["d" /* Logout */])();return __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20_react_router__["a" /* Redirect */],{to:'/app/portal/login'});}console.log(data);var quotes=JSON.parse(data.Dashboard[0].quotes);var clients=JSON.parse(data.Dashboard[0].clients);var unreadMessages=JSON.parse(data.Dashboard[0].unreadMessages);var dueTodos=JSON.parse(data.Dashboard[0].dueTodos);return __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Grid_GridContainer_jsx__["a" /* default */],null,Object(__WEBPACK_IMPORTED_MODULE_11_helpers_UserHelper__["b" /* GetUserKey */])('userType')!=='6'?__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:6,lg:6,xl:3},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Card_Card_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_Card_CardHeader_jsx__["a" /* default */],{color:'danger',stats:true,icon:true},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_Card_CardIcon_jsx__["a" /* default */],{color:'sqOrange',style:{padding:'10px'}},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_icons__["e" /* Chat */],null)),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement('div',{style:{float:'left',marginLeft:'10px'}},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement('p',{className:classes.cardCategory},'Unread Messages'),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement('h3',{className:classes.cardTitle,style:{float:'left'}},unreadMessages))),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Card_CardFooter_jsx__["a" /* default */],{stats:true},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement('div',{className:classes.stats,style:{margin:'auto',textAlign:'center'}},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["d" /* Button */],{variant:'outlined',className:'outlinedButton',style:{float:'left'},onClick:function onClick(){return _this2.props.history.push('/app/clientmessagehistory');}},'Go to messages'))))),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:6,lg:6,xl:3},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Card_Card_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_Card_CardHeader_jsx__["a" /* default */],{color:'success',stats:true,icon:true},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_Card_CardIcon_jsx__["a" /* default */],{color:'sqPurple',style:{padding:'10px'}},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_icons__["c" /* Assignment */],null)),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement('div',{style:{float:'left',marginLeft:'10px'}},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement('p',{className:classes.cardCategory},'My Quotes'),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement('h3',{className:classes.cardTitle,style:{float:'left'}},quotes.count)),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement('div',{style:{float:'right'}},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement('p',{className:classes.cardCategory},'This Week: ',__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement('b',null,quotes.lastWeek)),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement('p',{className:classes.cardCategory},'This Month: ',__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement('b',null,quotes.lastMonth)))),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Card_CardFooter_jsx__["a" /* default */],{stats:true},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement('div',{className:classes.stats,style:{margin:'auto',textAlign:'center'}},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["d" /* Button */],{variant:'outlined',className:'outlinedButton',style:{float:'left'},onClick:function onClick(){return _this2.props.history.push('/app/new');}},'New Quote'))))),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:6,lg:6,xl:3},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Card_Card_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_Card_CardHeader_jsx__["a" /* default */],{color:'warning',stats:true,icon:true},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_Card_CardIcon_jsx__["a" /* default */],{color:'sqPurpleSecond',style:{padding:'10px'}},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_icons__["k" /* People */],null)),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement('div',{style:{float:'left',marginLeft:'10px'}},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement('p',{className:classes.cardCategory},'My Clients'),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement('h3',{className:classes.cardTitle,style:{float:'left'}},clients.count)),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement('div',{style:{float:'right'}},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement('p',{className:classes.cardCategory},'This Week: ',__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement('b',null,clients.lastWeek)))),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Card_CardFooter_jsx__["a" /* default */],{stats:true},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement('div',{className:classes.stats,style:{margin:'auto',textAlign:'center'}},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["d" /* Button */],{variant:'outlined',className:'outlinedButton',style:{float:'left'},onClick:function onClick(){return _this2.props.history.push('/app/ManageClients');}},'Manage Clients')))))):null,__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:6,lg:6,xl:3},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Card_Card_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_Card_CardHeader_jsx__["a" /* default */],{color:'danger',stats:true,icon:true},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_Card_CardIcon_jsx__["a" /* default */],{color:'sqPurple',style:{padding:'10px'}},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_icons__["m" /* PlaylistAddCheck */],null)),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement('div',{style:{float:'left',marginLeft:'10px'}},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement('p',{className:classes.cardCategory},'Due To Do Items'),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement('h3',{className:classes.cardTitle,style:{float:'left'}},dueTodos))),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Card_CardFooter_jsx__["a" /* default */],{stats:true},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement('div',{className:classes.stats,style:{margin:'auto',textAlign:'center'}},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["d" /* Button */],{variant:'outlined',className:'outlinedButton',style:{float:'left'},onClick:function onClick(){return _this2.props.history.push('/app/usertodos');}},'View To Do')))))),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Grid_GridContainer_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:6},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Card_Card_jsx__["a" /* default */],{style:{height:'325px'}},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_Card_CardHeader_jsx__["a" /* default */],{color:'success',icon:true},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_Card_CardIcon_jsx__["a" /* default */],{color:'sqLightBlue'},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_icons__["j" /* Notifications */],null)),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement('h4',{className:classes.cardIconTitle},'Latest News')),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Card_CardBody_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Grid_GridContainer_jsx__["a" /* default */],{justify:'space-between'},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:12},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Card_Card_jsx__["a" /* default */],{style:{margin:'0px'}},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement('div',{ref:'newsList',style:{height:'250px',position:'relative',overflow:'scroll',zIndex:'2'},className:'newsList'},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_react_apollo__["Query"],{query:newsQuery,fetchPolicy:'network-only'},function(_ref2){var loading=_ref2.loading,error=_ref2.error,data=_ref2.data;if(loading)return __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["B" /* LinearProgress */],null));if(error){return __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],null,'Could not load news resources');}var NewsDataString=data.NewsRss[0].feed;var NewsDataObj=JSON.parse(NewsDataString);return NewsDataString&&NewsDataObj?__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__components_NewsList_jsx__["a" /* default */],{NewsDataObj:NewsDataObj,updatePs:_this2.updatePs}):null;})))))))),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:6},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Card_Card_jsx__["a" /* default */],{style:{height:'325px'}},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_Card_CardHeader_jsx__["a" /* default */],{color:'success',icon:true},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_Card_CardIcon_jsx__["a" /* default */],{color:'sqPurpleSecond'},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["w" /* Icon */],null,'cake')),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement('h4',{className:classes.cardIconTitle},'Birthdays')),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Card_CardBody_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Card_Card_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement('div',{/* ref="birthdays" */style:{height:'225px',position:'relative',overflowY:'auto',overflowX:'hidden',zIndex:'2'},className:'birthdaysCard'},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_react_apollo__["Query"],{query:__WEBPACK_IMPORTED_MODULE_25__queries_clientBirthdays__["a" /* ClientByBirthday */],variables:{brokerId:Object(__WEBPACK_IMPORTED_MODULE_11_helpers_UserHelper__["a" /* GetUserId */])(),token:Object(__WEBPACK_IMPORTED_MODULE_11_helpers_UserHelper__["c" /* GetUserToken */])()}},function(_ref3){var loading=_ref3.loading,error=_ref3.error,data=_ref3.data;if(loading)return __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["B" /* LinearProgress */],null));if(error){console.log(error);return __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],null,'Could not load Birthdays');}return __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__components_Birthdays_jsx__["a" /* default */],{data:data,updatePs2:function updatePs2(){},SendBirthdayWishes:_this2.props.SendBirthdayWishes});}))))))));}}]);return Dashboard;}(__WEBPACK_IMPORTED_MODULE_16_react___default.a.Component);Dashboard.propTypes={classes:__WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.object.isRequired};Dashboard=Object(__WEBPACK_IMPORTED_MODULE_17_react_apollo__["graphql"])(__WEBPACK_IMPORTED_MODULE_15_queries_dashboardQuery__["a" /* dashboardQuery */],{options:function options(){return{fetchPolicy:'network-only'};},props:function props(_props){return Object.assign({},_props);}})(Dashboard);Dashboard=Object(__WEBPACK_IMPORTED_MODULE_18_react_redux__["b" /* connect */])(function(state){return{brokerId:Object(__WEBPACK_IMPORTED_MODULE_11_helpers_UserHelper__["a" /* GetUserId */])(),token:Object(__WEBPACK_IMPORTED_MODULE_11_helpers_UserHelper__["c" /* GetUserToken */])()};})(Dashboard);Dashboard=Object(__WEBPACK_IMPORTED_MODULE_17_react_apollo__["compose"])(Object(__WEBPACK_IMPORTED_MODULE_17_react_apollo__["graphql"])(__WEBPACK_IMPORTED_MODULE_26__mutations_SendEmail__["a" /* SendBirthdayWishes */],{name:'SendBirthdayWishes'}))(Dashboard);/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1__material_ui_core_styles_withStyles___default()(__WEBPACK_IMPORTED_MODULE_3_assets_jss_material_dashboard_pro_react_views_dashboardStyle__["a" /* default */])(Dashboard));

/***/ }),
/* 2326 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_assets_jss_material_dashboard_pro_react_hoverCardStyle_jsx__ = __webpack_require__(2327);
// ##############################
// // // Dashboard View styles
// #############################
var dashboardStyle=Object.assign({},__WEBPACK_IMPORTED_MODULE_1_assets_jss_material_dashboard_pro_react_hoverCardStyle_jsx__["a" /* default */],{tooltip:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["E" /* tooltip */],cardTitle:Object.assign({},__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["b" /* cardTitle */],{marginTop:"0px",marginBottom:"3px"}),cardIconTitle:Object.assign({},__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["b" /* cardTitle */],{marginTop:"15px",marginBottom:"0px"}),cardProductTitle:Object.assign({},__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["b" /* cardTitle */],{marginTop:"0px",marginBottom:"3px",textAlign:"center"}),cardCategory:{color:"#999999",fontSize:"14px",paddingTop:"10px",marginBottom:"0",marginTop:"0",margin:"0"},cardProductDesciprion:{textAlign:"center",color:"#999999"},stats:{color:"#999999",fontSize:"12px",lineHeight:"22px",display:"inline-flex","& svg":{position:"relative",top:"4px",width:"16px",height:"16px",marginRight:"3px"},"& i":{position:"relative",top:"4px",fontSize:"16px",marginRight:"3px"}},productStats:{paddingTop:"7px",paddingBottom:"7px",margin:"0"},successText:{color:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["D" /* successColor */]},upArrowCardCategory:{width:14,height:14},underChartIcons:{width:"17px",height:"17px"},price:{color:"inherit","& h4":{marginBottom:"0px",marginTop:"0px"}}});/* harmony default export */ __webpack_exports__["a"] = (dashboardStyle);

/***/ }),
/* 2327 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var hoverCardStyle={cardHover:{"&:hover":{"& $cardHeaderHover":{transform:"translate3d(0, -50px, 0)"}}},cardHeaderHover:{transition:"all 300ms cubic-bezier(0.34, 1.61, 0.7, 1)"},cardHoverUnder:{position:"absolute",zIndex:"1",top:"-50px",width:"calc(100% - 30px)",left:"17px",right:"17px",textAlign:"center"}};/* harmony default export */ __webpack_exports__["a"] = (hoverCardStyle);

/***/ }),
/* 2328 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// import {
//
// } from "assets/jss/material-dashboard-pro-react.jsx";
var cardStyle={card:{border:"0",marginBottom:"30px",marginTop:"30px",borderRadius:"6px",color:"rgba(0, 0, 0, 0.87)",background:"#fff",width:"100%",boxShadow:"0 1px 4px 0 rgba(0, 0, 0, 0.14)",position:"relative",display:"flex",flexDirection:"column",minWidth:"0",wordWrap:"break-word",fontSize:".875rem"},cardPlain:{background:"transparent",boxShadow:"none"},cardProfile:{marginTop:"30px",textAlign:"center"},cardBlog:{marginTop:"60px"},cardRaised:{boxShadow:"0 16px 38px -12px rgba(0, 0, 0, 0.56), 0 4px 25px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(0, 0, 0, 0.2)"},cardBackground:{backgroundPosition:"center center",backgroundSize:"cover",textAlign:"center","&:after":{position:"absolute",zIndex:"1",width:"100%",height:"100%",display:"block",left:"0",top:"0",content:'""',backgroundColor:"rgba(0, 0, 0, 0.56)",borderRadius:"6px"},"& small":{color:"rgba(255, 255, 255, 0.7) !important"}},cardPricing:{textAlign:"center","&:after":{backgroundColor:"rgba(0, 0, 0, 0.7) !important"},"& ul":{listStyle:"none",padding:0,maxWidth:"240px",margin:"10px auto"},"& ul li":{color:"#999999",textAlign:"center",padding:"12px 0px",borderBottom:"1px solid rgba(153,153,153,0.3)"},"& ul li:last-child":{border:0},"& ul li b":{color:"#3c4858"},"& h1":{marginTop:"30px"},"& h1 small":{display:"inline-flex",height:0,fontSize:"18px"},"& h1 small:first-child":{position:"relative",top:"-17px",fontSize:"26px"},"& ul li svg":{position:"relative",top:"7px"}},cardPricingColor:{"& ul li":{color:"#fff",borderColor:"rgba(255,255,255,0.3)","& b, & svg":{color:"#fff",fontWeight:"700"}}},cardProduct:{marginTop:"30px"},primary:{background:"linear-gradient(60deg,#ab47bc,#7b1fa2)","& h1 small":{color:"rgba(255, 255, 255, 0.8)"},color:"#FFFFFF"},info:{background:"linear-gradient(60deg,#26c6da,#0097a7)","& h1 small":{color:"rgba(255, 255, 255, 0.8)"},color:"#FFFFFF"},success:{background:"linear-gradient(60deg,#66bb6a,#388e3c)","& h1 small":{color:"rgba(255, 255, 255, 0.8)"},color:"#FFFFFF"},warning:{background:"linear-gradient(60deg,#ffa726,#f57c00)","& h1 small":{color:"rgba(255, 255, 255, 0.8)"},color:"#FFFFFF"},danger:{background:"linear-gradient(60deg,#ef5350,#d32f2f)","& h1 small":{color:"rgba(255, 255, 255, 0.8)"},color:"#FFFFFF"},rose:{background:"linear-gradient(60deg,#ec407a,#c2185b)","& h1 small":{color:"rgba(255, 255, 255, 0.8)"},color:"#FFFFFF"},deepPurple:{background:"linear-gradient(60deg,#55526f,#c2185b)","& h1 small":{color:"rgba(255, 255, 255, 0.8)"},color:"#FFFFFF"},cardChart:{"& p":{marginTop:"0px",paddingTop:"0px"}},cardLogin:{transform:"translate3d(0, 0, 0)",transition:"all 300ms linear"}};/* harmony default export */ __webpack_exports__["a"] = (cardStyle);

/***/ }),
/* 2329 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var cardBodyStyle={cardBody:{padding:"0.9375rem 20px",flex:"1 1 auto",WebkitBoxFlex:"1",position:"relative"},cardBodyBackground:{position:"relative",zIndex:"2",minHeight:"280px",paddingTop:"40px",paddingBottom:"40px",maxWidth:"440px",margin:"0 auto"},cardBodyPlain:{paddingLeft:"5px",paddingRight:"5px"},cardBodyFormHorizontal:{paddingLeft:"15px",paddingRight:"15px","& form":{margin:"0"}},cardPricing:{padding:"15px!important",margin:"0px!important"},cardSignup:{padding:"0px 30px 0px 30px"},cardBodyColor:{borderRadius:"6px","&":{"h1, h2, h3":{"& small":{color:"rgba(255, 255, 255, 0.8)"}}}},cardBodyProfile:{marginTop:"15px"},cardBodyCalendar:{padding:"0px !important"}};/* harmony default export */ __webpack_exports__["a"] = (cardBodyStyle);

/***/ }),
/* 2330 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_assets_jss_material_dashboard_pro_react_components_cardFooterStyle_jsx__ = __webpack_require__(2331);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}// nodejs library that concatenates classes
// nodejs library to set properties for components
// @material-ui/core components
// @material-ui/icons
// core components
function CardFooter(_ref){var _classNames;var props=_objectWithoutProperties(_ref,[]);var classes=props.classes,className=props.className,children=props.children,plain=props.plain,profile=props.profile,pricing=props.pricing,testimonial=props.testimonial,stats=props.stats,chart=props.chart,product=props.product,rest=_objectWithoutProperties(props,["classes","className","children","plain","profile","pricing","testimonial","stats","chart","product"]);var cardFooterClasses=__WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classNames={},_defineProperty(_classNames,classes.cardFooter,true),_defineProperty(_classNames,classes.cardFooterPlain,plain),_defineProperty(_classNames,classes.cardFooterProfile,profile||testimonial),_defineProperty(_classNames,classes.cardFooterPricing,pricing),_defineProperty(_classNames,classes.cardFooterTestimonial,testimonial),_defineProperty(_classNames,classes.cardFooterStats,stats),_defineProperty(_classNames,classes.cardFooterChart,chart||product),_defineProperty(_classNames,className,className!==undefined),_classNames));return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",Object.assign({className:cardFooterClasses},rest),children);}CardFooter.propTypes={classes:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,className:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,plain:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,profile:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,pricing:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,testimonial:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,stats:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,chart:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,product:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool};/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles___default()(__WEBPACK_IMPORTED_MODULE_4_assets_jss_material_dashboard_pro_react_components_cardFooterStyle_jsx__["a" /* default */])(CardFooter));

/***/ }),
/* 2331 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var cardFooterStyle={cardFooter:{padding:"0",paddingTop:"10px",margin:"0 15px 10px",borderRadius:"0",justifyContent:"space-between",alignItems:"center",display:"flex",backgroundColor:"transparent",border:"0"},cardFooterProfile:{marginTop:"-15px"},cardFooterPlain:{paddingLeft:"5px",paddingRight:"5px",backgroundColor:"transparent"},cardFooterPricing:{zIndex:"2"},cardFooterTestimonial:{display:"block"},cardFooterStats:{borderTop:"1px solid #eee",marginTop:"20px","& svg":{position:"relative",top:"4px",marginRight:"3px",marginLeft:"3px",width:"16px",height:"16px"}},cardFooterChart:{borderTop:"1px solid #eee"}};/* harmony default export */ __webpack_exports__["a"] = (cardFooterStyle);

/***/ }),
/* 2332 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__ = __webpack_require__(65);
var cardHeaderStyle={cardHeader:{padding:"0.75rem 1.25rem",marginBottom:"0",borderBottom:"none",background:"transparent",zIndex:"3 !important","&$cardHeaderPlain,&$cardHeaderImage,&$cardHeaderContact,&$cardHeaderSignup,&$cardHeaderIcon,&$cardHeaderStats,&$warningCardHeader,&$successCardHeader,&$dangerCardHeader,&$infoCardHeader,&$primaryCardHeader,&$roseCardHeader":{margin:"0 15px",padding:"0",position:"relative",color:"#FFFFFF"},"&:first-child":{borderRadius:"calc(.25rem - 1px) calc(.25rem - 1px) 0 0"},"&$warningCardHeader,&$successCardHeader,&$dangerCardHeader,&$infoCardHeader,&$primaryCardHeader,&$roseCardHeader":{"&:not($cardHeaderIcon):not($cardHeaderImage):not($cardHeaderText)":{borderRadius:"3px",marginTop:"-20px",padding:"15px"}},"&$cardHeaderStats svg":{fontSize:"36px",lineHeight:"56px",textAlign:"center",width:"36px",height:"36px",margin:"10px 10px 4px"},"&$cardHeaderStats i":{fontSize:"36px",lineHeight:"56px",width:"56px",height:"56px",textAlign:"center"},"&$cardHeaderStats$cardHeaderIcon":{textAlign:"right"},"&$cardHeaderImage":{marginLeft:"15px",marginRight:"15px",marginTop:"-30px",borderRadius:"6px"},"&$cardHeaderText":{display:"inline-block"}},cardHeaderPlain:{marginLeft:"0px",marginRight:"0px","&$cardHeaderImage":{margin:"0 !important"}},cardHeaderImage:{position:"relative",padding:"0",zIndex:"1","& img":{width:"100%",borderRadius:"6px",pointerEvents:"none",boxShadow:"0 5px 15px -8px rgba(0, 0, 0, 0.24), 0 8px 10px -5px rgba(0, 0, 0, 0.2)"},"& a":{display:"block"}},cardHeaderContact:{margin:"0 15px",marginTop:"-20px"},cardHeaderSignup:{marginLeft:"20px",marginRight:"20px",marginTop:"-40px",padding:"20px 0",width:"100%",marginBottom:"15px"},cardHeaderStats:{"& $cardHeaderIcon":{textAlign:"right"},"& h1,& h2,& h3,& h4,& h5,& h6":{margin:"0 !important"}},cardHeaderIcon:{"&$warningCardHeader,&$successCardHeader,&$dangerCardHeader,&$infoCardHeader,&$primaryCardHeader,&$roseCardHeader":{background:"transparent",boxShadow:"none"},"& i":{width:"33px",height:"33px",textAlign:"center",lineHeight:"33px"},"& svg":{width:"24px",height:"24px",textAlign:"center",lineHeight:"33px",margin:"5px 4px 0px"}},cardHeaderText:{},warningCardHeader:{color:"#FFFFFF","&:not($cardHeaderText):not($cardHeaderIcon)":Object.assign({},__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["H" /* warningCardHeader */])},successCardHeader:{color:"#FFFFFF","&:not($cardHeaderText):not($cardHeaderIcon)":Object.assign({},__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["C" /* successCardHeader */])},dangerCardHeader:{color:"#FFFFFF","&:not($cardHeaderText):not($cardHeaderIcon)":Object.assign({},__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["f" /* dangerCardHeader */])},infoCardHeader:{color:"#FFFFFF","&:not($cardHeaderText):not($cardHeaderIcon)":Object.assign({},__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["p" /* infoCardHeader */])},primaryCardHeader:{color:"#FFFFFF","&:not($cardHeaderText):not($cardHeaderIcon)":Object.assign({},__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["s" /* primaryCardHeader */])},roseCardHeader:{color:"#FFFFFF","&:not($cardHeaderText):not($cardHeaderIcon)":Object.assign({},__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["v" /* roseCardHeader */])}};/* harmony default export */ __webpack_exports__["a"] = (cardHeaderStyle);

/***/ }),
/* 2333 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__ = __webpack_require__(65);
var cardIconStyle={cardIcon:{"&$warningCardHeader,&$successCardHeader,&$dangerCardHeader,&$infoCardHeader,&$primaryCardHeader,&$roseCardHeader,&$deepPurpleCardHeader,&$yellowCardHeader,&$grayBlueCardHeader,&$sqPurpleCardHeader,&$sqOrangeCardHeader,&$sqLightBlueCardHeader,&$sqPurpleSecondCardHeader":{borderRadius:"3px",backgroundColor:"#999",padding:"15px",marginTop:"-20px",marginRight:"15px",float:"left"}},warningCardHeader:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["H" /* warningCardHeader */],successCardHeader:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["C" /* successCardHeader */],dangerCardHeader:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["f" /* dangerCardHeader */],infoCardHeader:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["p" /* infoCardHeader */],primaryCardHeader:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["s" /* primaryCardHeader */],roseCardHeader:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["v" /* roseCardHeader */],deepPurpleCardHeader:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["h" /* deepPurpleCardHeader */],yellowCardHeader:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["J" /* yellowCardHeader */],grayBlueCardHeader:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["m" /* grayBlueCardHeader */],sqPurpleCardHeader:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["z" /* sqPurpleCardHeader */],sqPurpleSecondCardHeader:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["A" /* sqPurpleSecondCardHeader */],sqOrangeCardHeader:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["y" /* sqOrangeCardHeader */],sqLightBlueCardHeader:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["x" /* sqLightBlueCardHeader */]};/* harmony default export */ __webpack_exports__["a"] = (cardIconStyle);

/***/ }),
/* 2334 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return dashboardQuery; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_graphql_tag__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_graphql_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_graphql_tag__);
var _templateObject=_taggedTemplateLiteral(["\n  query dashboardQuery($brokerId: String!,$token:String!) {\n    Dashboard(brokerId:$brokerId,token:$token){\n      quotes,\n      clients,\n      unreadMessages\n      dueTodos\n    }\n  }\n"],["\n  query dashboardQuery($brokerId: String!,$token:String!) {\n    Dashboard(brokerId:$brokerId,token:$token){\n      quotes,\n      clients,\n      unreadMessages\n      dueTodos\n    }\n  }\n"]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var dashboardQuery=__WEBPACK_IMPORTED_MODULE_0_graphql_tag___default()(_templateObject);

/***/ }),
/* 2335 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2336 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_Grid_GridContainer_jsx__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Grid_GridItem_jsx__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_helpers_UserHelper__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_helpers_BirthdayTemplates__ = __webpack_require__(2337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Birthdays=function(_React$Component){_inherits(Birthdays,_React$Component);function Birthdays(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Birthdays);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Birthdays.__proto__||Object.getPrototypeOf(Birthdays)).call.apply(_ref,[this].concat(args))),_this),_this.state={bdDialog:false,clientEmail:'',clientName:'',messageFormality:'formal',language:'eng',phoneNumber:'',message:__WEBPACK_IMPORTED_MODULE_5_helpers_BirthdayTemplates__["a" /* BirthdayTemplates */]['formal']['eng']},_this.handleBirthdayOpen=function(email,name,phone,formality,language){_this.setState({bdDialog:true,clientEmail:email,clientName:name,messageFormality:formality,language:language?language.substring(0,3):'eng',phoneNumber:phone});console.log('Email : ',email);},_this.handleBirthdayClose=function(){_this.setState({bdDialog:false,clientEmail:'',clientName:'',messageFormality:'',language:'',message:''});},_this.handleSendBDEmail=function(){var input={clientId:4,brokerId:Object(__WEBPACK_IMPORTED_MODULE_4_helpers_UserHelper__["a" /* GetUserId */])(),token:Object(__WEBPACK_IMPORTED_MODULE_4_helpers_UserHelper__["c" /* GetUserToken */])(),clientEmail:_this.state.clientEmail,message:_this.state.message};_this.props.SendBirthdayWishes({variables:{input:input}}).then(function(resp){//refetch();
// this.showNotification("br");
// this.setState({
//   snackBarColor: "success",
//   snackBarText: "Birthday Wish Sent"
// });
_this.setState({bdDialog:false,clientEmail:'',clientName:'',messageFormality:'',language:'',message:''});}).catch(function(error){console.log('err',error);});},_this.handleChangeMessageFormality=function(event){_this.setState({messageFormality:event.target.value,message:__WEBPACK_IMPORTED_MODULE_5_helpers_BirthdayTemplates__["a" /* BirthdayTemplates */][event.target.value][_this.state.language]});},_this.handleChangeLanguage=function(event){_this.setState({language:event.target.value,message:__WEBPACK_IMPORTED_MODULE_5_helpers_BirthdayTemplates__["a" /* BirthdayTemplates */][_this.state.messageFormality][event.target.value]});},_this.handleChangeMessage=function(event){_this.setState({message:event.target.value});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Birthdays,[{key:'componentDidMount',value:function componentDidMount(){this.props.updatePs2();}},{key:'componentDidUpdate',value:function componentDidUpdate(){this.props.updatePs2();}},{key:'render',value:function render(){var _this2=this;var birthdaysToday=this.props.data.ClientByBirthday.today;var thisWeek=this.props.data.ClientByBirthday.week;var BirthdayWish=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["k" /* Dialog */],{open:this.state.bdDialog,onClose:this.handleBirthdayClose},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["o" /* DialogTitle */],null,'Happy Birthday Wishes!'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["m" /* DialogContent */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{textAlign:'center'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Wish '+this.state.clientName+' a Happy Birthday!'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'You can give '+this.state.clientName+' a call at '+this.state.phoneNumber),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Or send them a Message or Email.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{display:'flex'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["L" /* RadioGroup */],{'aria-label':'Message Type',name:'messageFormality',value:this.state.messageFormality,onChange:this.handleChangeMessageFormality},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["u" /* FormControlLabel */],{value:'formal',control:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["K" /* Radio */],null),label:'Formal'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["u" /* FormControlLabel */],{value:'informal',control:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["K" /* Radio */],null),label:'Informal'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["L" /* RadioGroup */],{'aria-label':'Language',name:'language',value:this.state.language,onChange:this.handleChangeLanguage},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["u" /* FormControlLabel */],{value:'afr',control:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["K" /* Radio */],null),label:'Afrikaans'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["u" /* FormControlLabel */],{value:'eng',control:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["K" /* Radio */],null),label:'English'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["X" /* TextField */],{style:{width:'40vw'},id:'birthday-wish',label:'Birthday Wish',multiline:true,rowsMax:'4',value:this.state.message,onChange:this.handleChangeMessage,margin:'normal',variant:'outlined'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["l" /* DialogActions */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["d" /* Button */],{onClick:this.handleSendBDEmail,color:'secondary'},'Send Message'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["d" /* Button */],{onClick:this.handleBirthdayClose,color:'secondary',autoFocus:true},'Close')));return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["Z" /* Typography */],{variant:'subheading',className:'centerCell'},'Today'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{borderBottom:'1px solid #cccccc69',margin:'5px auto',width:'25%',marginBottom:'20px'}}),Object(__WEBPACK_IMPORTED_MODULE_6_lodash__["uniqWith"])(birthdaysToday,__WEBPACK_IMPORTED_MODULE_6_lodash__["isEqual"]).map(function(c,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_Grid_GridContainer_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Grid_GridItem_jsx__["a" /* default */],{xs:9,sm:9,md:9,style:{position:'relative',borderTop:'1px solid #eeeeee',borderBottom:'1px solid #eeeeee'},className:i%2===0?'':'disabledRow'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["Z" /* Typography */],{style:{position:'absolute',top:'25%',paddingLeft:'15px'}},c.scd_nickName?c.scd_nickName:c.scd_name?c.scd_name:'',' '+c.scd_surname+' ','('+c.scd_dateOfBirth.age+')')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Grid_GridItem_jsx__["a" /* default */],{xs:3,sm:3,md:3,className:i%2===0?'':'disabledRow',style:{position:'relative',borderTop:'1px solid #eeeeee',borderBottom:'1px solid #eeeeee'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["x" /* IconButton */],{color:'secondary',onClick:function onClick(){return _this2.handleBirthdayOpen(c.scd_email,c.scd_name,c.scd_phoneNumber,c.scd_correspondenceFormality,c.scd_correspondenceLanguage);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["w" /* Icon */],null,'mail_outline'))));}),birthdaysToday.length<1?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["Z" /* Typography */],{variant:'caption',style:{textAlign:'center'}},'No Birthdays Today'):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["Z" /* Typography */],{variant:'subheading',className:'centerCell',style:{marginTop:'24px'}},'This Coming Week'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{borderBottom:'1px solid #cccccc69',margin:'5px auto',width:'25%',marginBottom:'20px'}}),Object(__WEBPACK_IMPORTED_MODULE_6_lodash__["uniqWith"])(thisWeek,__WEBPACK_IMPORTED_MODULE_6_lodash__["isEqual"]).map(function(c,i){var birthdayDate='';if(c.scd_dateOfBirth.basicDate.includes('-')){var splitDate=c.scd_dateOfBirth.basicDate.split('-');birthdayDate=splitDate[2]+'/'+splitDate[1];}else if(c.scd_dateOfBirth.basicDate.includes('/')){var _splitDate=c.scd_dateOfBirth.basicDate.split('/');birthdayDate=_splitDate[1]+'/'+_splitDate[0];}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_Grid_GridContainer_jsx__["a" /* default */],{style:{marginBottom:'15px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Grid_GridItem_jsx__["a" /* default */],{xs:7,sm:7,md:9,style:{borderTop:'1px solid #eeeeee',borderBottom:'1px solid #eeeeee'},className:i%2===0?'':'disabledRow'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["Z" /* Typography */],{style:{padding:'15px'}},c.scd_nickName?c.scd_nickName:c.scd_name?c.scd_name:'',' '+c.scd_surname+' ','('+c.scd_dateOfBirth.age+')')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Grid_GridItem_jsx__["a" /* default */],{xs:5,sm:5,md:3,className:i%2===0?'':'disabledRow',style:{borderTop:'1px solid #eeeeee',borderBottom:'1px solid #eeeeee'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["Z" /* Typography */],{style:{padding:'15px'}},birthdayDate)));}),thisWeek.length<1?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["Z" /* Typography */],{variant:'caption',style:{textAlign:'center'}},'No Birthdays This Coming Week'):null,this.state.bdDialog&&BirthdayWish);}}]);return Birthdays;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Birthdays);

/***/ }),
/* 2337 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BirthdayTemplates; });
var BirthdayTemplates={formal:{afr:"Goeie dag. Baie geluk met jou verjaarsdag. Vriendelike Groete.",eng:"Good day. A warm and happy Birthday to you. Kind Regards."},informal:{afr:"Lekker verjaar. Ek hoop dis 'n baie lekker dag en jaar wat voorle.",eng:"Happy Birthday. I hope it's a awesome day and year ahead of you."}};

/***/ }),
/* 2338 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_List__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_List___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_List__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_ListItem__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_ListItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_ListItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_ListItemText__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_ListItemText___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_ListItemText__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Divider__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Divider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Divider__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var NewsList=function(_React$Component){_inherits(NewsList,_React$Component);function NewsList(){_classCallCheck(this,NewsList);return _possibleConstructorReturn(this,(NewsList.__proto__||Object.getPrototypeOf(NewsList)).apply(this,arguments));}_createClass(NewsList,[{key:"componentDidMount",value:function componentDidMount(){this.props.updatePs();}},{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_List___default.a,null,this.props.NewsDataObj.map(function(newsItem,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{key:index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_ListItem___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_ListItemText___default.a,{primary:newsItem.title?newsItem.title.toString().replace("Fin24.com | ",""):"",secondary:newsItem.description?newsItem.description.toString().replace("</strong>","").replace("<strong>",""):""}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:newsItem.link?newsItem.link:"#",target:"_blank"},"View")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Divider___default.a,{inset:true,component:"li",style:{marginLeft:"0px"}}));}));}}]);return NewsList;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (NewsList);

/***/ }),
/* 2339 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2340 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ClientByBirthday; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_graphql_tag__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_graphql_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_graphql_tag__);
var _templateObject=_taggedTemplateLiteral(["\n  query clientBirthdays($brokerId: String!, $token: String!) {\n    ClientByBirthday(brokerId: $brokerId, token: $token) {\n      today {\n        scd_name,\n        scd_surname,\n        scd_dateOfBirth,\n        scd_email,\n        scd_nickName,\n        scd_correspondenceFormality,\n        scd_correspondenceLanguage,\n        scd_phoneNumber\n      }\n      week {\n        scd_name,\n        scd_surname,\n        scd_dateOfBirth,\n        scd_nickName\n      }\n    }\n  }\n"],["\n  query clientBirthdays($brokerId: String!, $token: String!) {\n    ClientByBirthday(brokerId: $brokerId, token: $token) {\n      today {\n        scd_name,\n        scd_surname,\n        scd_dateOfBirth,\n        scd_email,\n        scd_nickName,\n        scd_correspondenceFormality,\n        scd_correspondenceLanguage,\n        scd_phoneNumber\n      }\n      week {\n        scd_name,\n        scd_surname,\n        scd_dateOfBirth,\n        scd_nickName\n      }\n    }\n  }\n"]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var ClientByBirthday=__WEBPACK_IMPORTED_MODULE_0_graphql_tag___default()(_templateObject);

/***/ }),
/* 2341 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SendBirthdayWishes; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_graphql_tag__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_graphql_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_graphql_tag__);
var _templateObject=_taggedTemplateLiteral(["\n  mutation sendBirthdayWishes($input: SendBirthdayWishesInput!) {\n    SendBirthdayWishes(input: $input) {\n      clientMutationId\n    }\n  }\n"],["\n  mutation sendBirthdayWishes($input: SendBirthdayWishesInput!) {\n    SendBirthdayWishes(input: $input) {\n      clientMutationId\n    }\n  }\n"]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var SendBirthdayWishes=__WEBPACK_IMPORTED_MODULE_0_graphql_tag___default()(_templateObject);

/***/ }),
/* 2342 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_core__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles_withStyles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_apollo_cache_inmemory__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_apollo_client__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_apollo_upload_client__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_assets_img_faces_avatar1_jpg__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_assets_img_faces_avatar1_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_assets_img_faces_avatar1_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_assets_jss_material_dashboard_pro_react_views_userProfileStyles_jsx__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_Card_Card_jsx__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_Card_CardAvatar_jsx__ = __webpack_require__(382);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_Card_CardBody_jsx__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_Grid_GridItem_jsx__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_Wrappers_materialUIWrappers_components_FormInput__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_constants_js__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_graphql_tag__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_graphql_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_graphql_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_helpers_UserHelper__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_queries_Profile_mutations__ = __webpack_require__(252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_queries_profileQuery__ = __webpack_require__(605);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_queries_updatePassword__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_react_apollo__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_react_dropzone__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_react_redux__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_react_router__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_reducers_LoginReducer__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_reducers_NotificationReducer__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_redux_form__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_store__ = __webpack_require__(10);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(["\n  mutation($file: Upload!, $id: String!) {\n    uploadFileWithId(file: $file, id: $id)\n  }\n"],["\n  mutation($file: Upload!, $id: String!) {\n    uploadFileWithId(file: $file, id: $id)\n  }\n"]);function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}/*eslint-disable*/// @material-ui/core components
// core components
var CHANGEAVATAR="sure-quote/Login/CHANGEAVATAR";var client=new __WEBPACK_IMPORTED_MODULE_4_apollo_client__["ApolloClient"]({link:Object(__WEBPACK_IMPORTED_MODULE_5_apollo_upload_client__["a" /* createUploadLink */])({uri:"http://www.rhlm.co.za/upload"}),cache:new __WEBPACK_IMPORTED_MODULE_3_apollo_cache_inmemory__["a" /* InMemoryCache */]()});var uploadFileMutation=__WEBPACK_IMPORTED_MODULE_14_graphql_tag___default()(_templateObject);function isEmptyOrSpaces(str){return str===undefined||str===null||str.match(/^ *$/)!==null;}var required=function required(value){return value?undefined:"Required";};var Profile=function(_Component){_inherits(Profile,_Component);function Profile(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Profile);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Profile.__proto__||Object.getPrototypeOf(Profile)).call.apply(_ref,[this].concat(args))),_this),_this.state={value:0,open:false,avatarPath:"",oldPassword:"",newPassword:"",confirmNewPassword:"",showInfo:false,formInitiazed:false,checkValidation:false},_this.handleStateChange=function(event,prop){_this.setState(_defineProperty({},prop,event.target.value));},_this.handleClickOpenDialog=function(){_this.setState({open:true});},_this.handleCloseDialog=function(){_this.setState({open:false,confirmNewPassword:"",newPassword:"",oldPassword:""});},_this.openShowInfo=function(){console.log("showInfo: true");_this.setState({showInfo:true});},_this.closeShowInfo=function(){console.log("showInfo: false");_this.setState({showInfo:false});},_this.handleResetPassword=function(){if(isEmptyOrSpaces(_this.state.newPassword)||isEmptyOrSpaces(_this.state.confirmNewPassword)||isEmptyOrSpaces(_this.state.oldPassword)){__WEBPACK_IMPORTED_MODULE_27_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_25_reducers_NotificationReducer__["d" /* showSnack */])({message:"Password cannot be empty.",color:"danger"}));}else if(_this.state.newPassword!==_this.state.confirmNewPassword){__WEBPACK_IMPORTED_MODULE_27_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_25_reducers_NotificationReducer__["d" /* showSnack */])({message:"Password do not match.",color:"danger"}));}else{var input={oldPass:_this.state.oldPassword,newPass:_this.state.newPassword,brokerId:Object(__WEBPACK_IMPORTED_MODULE_15_helpers_UserHelper__["a" /* GetUserId */])(),token:Object(__WEBPACK_IMPORTED_MODULE_15_helpers_UserHelper__["c" /* GetUserToken */])()};_this.props.UpdatePassword({variables:{input:input}}).then(function(resp){__WEBPACK_IMPORTED_MODULE_27_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_25_reducers_NotificationReducer__["e" /* successWarning */])({open:true,title:"Password Updated",onConfirm:function onConfirm(){return _this.setState({open:false});}}));}).catch(function(error){__WEBPACK_IMPORTED_MODULE_27_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_25_reducers_NotificationReducer__["d" /* showSnack */])({message:"There was an error updating your password : "+error,color:"danger"}));});}},_this.saveChanges=function(){if(__WEBPACK_IMPORTED_MODULE_27_store__["a" /* default */].getState().form.BrokerProfile.syncErrors){__WEBPACK_IMPORTED_MODULE_27_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_25_reducers_NotificationReducer__["d" /* showSnack */])({message:"Invalid Information",color:"danger"}));_this.setState({checkValidation:true});_this.forceUpdate();}else{_this.setState({checkValidation:false});var input={userId:Object(__WEBPACK_IMPORTED_MODULE_15_helpers_UserHelper__["a" /* GetUserId */])(),data:__WEBPACK_IMPORTED_MODULE_27_store__["a" /* default */].getState().form.BrokerProfile.values,token:Object(__WEBPACK_IMPORTED_MODULE_15_helpers_UserHelper__["c" /* GetUserToken */])()};_this.props.BrokerProfileUpdate({variables:{input:input}}).then(function(resp){__WEBPACK_IMPORTED_MODULE_27_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_25_reducers_NotificationReducer__["e" /* successWarning */])({open:true,title:"Profile Updated."}));}).catch(function(error){__WEBPACK_IMPORTED_MODULE_27_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_25_reducers_NotificationReducer__["d" /* showSnack */])({message:"There was an error updating your profile : "+error,color:"danger"}));});}},_this.initializeForm=function(profile){_this.props.initialize({email:profile.email,name:profile.name,surname:profile.surname,contactPhoneNumber:profile.sbd_contact_phone,contactEmail:profile.sbd_contact_email});_this.setState({formInitiazed:true});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Profile,[{key:"render",value:function render(){var _this2=this;var value=this.state.value;var classes=this.props.classes;if(this.props.data.loading){return __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["B" /* LinearProgress */],null);}var data=this.props.data;if(data.error&&data.error.message&&data.error.message==="GraphQL error: invalid token"){Object(__WEBPACK_IMPORTED_MODULE_15_helpers_UserHelper__["d" /* Logout */])();return __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23_react_router__["a" /* Redirect */],{to:"/app/portal/login"});}var profile=JSON.parse(data.BrokerProfile[0].profile);if(!this.state.formInitiazed){this.initializeForm(profile);}var avatarPath=__WEBPACK_IMPORTED_MODULE_6_assets_img_faces_avatar1_jpg___default.a;if(this.state.avatarPath!==""){avatarPath=this.state.avatarPath;}else if(profile.su_pp_path!==null&&profile.su_pp_path!==""){avatarPath=profile.su_pp_path;}return __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{container:true},__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:10,md:8,style:{flexBasis:"100%",maxWidth:"100%",margin:'auto'}},__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_Card_Card_jsx__["a" /* default */],{profile:true},__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Card_CardAvatar_jsx__["a" /* default */],{profile:true,className:"avatarBackground"},__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement("img",{src:avatarPath,alt:"...",style:{width:"130px",height:"130px"}})),__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_Card_CardBody_jsx__["a" /* default */],{profile:true},__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20_react_apollo__["Mutation"],{client:client,mutation:uploadFileMutation,onCompleted:function onCompleted(data){_this2.setState({avatarPath:data.uploadFileWithId});__WEBPACK_IMPORTED_MODULE_27_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_24_reducers_LoginReducer__["c" /* changeAvatar */])({type:CHANGEAVATAR,props:data.uploadFileWithId}));}},function(mutate){return __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement("div",{style:{width:"100%",textAlign:"center",display:"block"}},__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21_react_dropzone__["a" /* default */],{style:{width:"fit-content",height:"fit-content",border:"none",margin:"0px auto"},onDrop:function onDrop(_ref2){var _ref3=_slicedToArray(_ref2,1),file=_ref3[0];return mutate({variables:{file:file,id:__WEBPACK_IMPORTED_MODULE_27_store__["a" /* default */].getState().login.userID}});}},__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Y" /* Tooltip */],{title:"Edit Profile Picture",placement:"right"},__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["i" /* Chip */],{avatar:__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["b" /* Avatar */],{style:{backgroundColor:"#6c5cab",color:"white"}},__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["w" /* Icon */],null,"edit")),variant:"outlined",label:__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{color:"white"}},"Edit Picture"),color:"secondary",style:{backgroundColor:"#a59fff",color:"white",position:"relative",top:"-38px",cursor:"pointer"}}))));}),__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement("h2",{className:classes.cardTitle},profile.name," ",profile.surname),__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement("h4",{className:classes.cardTitle,style:{color:"#858a90"}},profile.brokerage),__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{container:true},__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:6},__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["t" /* FormControl */],{fullWidth:true,className:"spacedFormControl"},__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_12_components_Wrappers_materialUIWrappers_components_FormInput__["a" /* default */],checkValidation:this.state.checkValidation,name:"email",label:"User Email",readOnly:true}))),__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:6},__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["t" /* FormControl */],{fullWidth:true,className:"spacedFormControl"},__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_12_components_Wrappers_materialUIWrappers_components_FormInput__["a" /* default */],checkValidation:this.state.checkValidation,name:"name",label:"Name",validate:[required]}))),__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:6},__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["t" /* FormControl */],{fullWidth:true,className:"spacedFormControl"},__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_12_components_Wrappers_materialUIWrappers_components_FormInput__["a" /* default */],checkValidation:this.state.checkValidation,name:"surname",label:"Surname",validate:[required]}))),__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:6},__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["t" /* FormControl */],{fullWidth:true,className:"spacedFormControl"},__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_12_components_Wrappers_materialUIWrappers_components_FormInput__["a" /* default */],checkValidation:this.state.checkValidation,name:"contactPhoneNumber",label:"Contact Phone Number"}))),__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:6},__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["t" /* FormControl */],{fullWidth:true,className:"spacedFormControl"},__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_12_components_Wrappers_materialUIWrappers_components_FormInput__["a" /* default */],checkValidation:this.state.checkValidation,name:"contactEmail",label:"Contact Email"}))),__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:6,style:{marginTop:"16px"}},__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{container:true},__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{item:true,xs:12,sm:6,md:6,style:{textAlign:"left"}},__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{variant:"subheading"},"Sure Quote App Code"),__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{variant:"caption",className:"typographyLinkBasic",onClick:this.openShowInfo},"What's this?"),__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["k" /* Dialog */],{open:this.state.showInfo,onClose:this.closeShowInfo},__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["o" /* DialogTitle */],null,"Sure Quote App Code?"),__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["m" /* DialogContent */],null,__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["n" /* DialogContentText */],null,"This is the code Sure Quote sends to your clients which they register with to link them to you.")),__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["l" /* DialogActions */],null,__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["d" /* Button */],{onClick:this.closeShowInfo,color:"primary",autoFocus:true},"Ok")))),__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{item:true,xs:12,sm:6,md:6},__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["X" /* TextField */],{fullWidth:true,defaultValue:profile.sbd_broker_app_code,InputProps:{readOnly:true}})))),__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:12,style:{marginTop:"50px",textAlign:"center"}},__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["d" /* Button */],{variant:"outlined",className:"outlinedButton",onClick:function onClick(){return _this2.saveChanges();},style:{color:"#55526f",margin:"0px auto"}},"Save Changes",__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["w" /* Icon */],{style:{marginLeft:"5px"}},"check"))),__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:12,style:{marginTop:"35px",textAlign:"center"}},__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{variant:"body1",style:{color:"#0000008a"},className:"typographyLinkBasic",onClick:this.handleClickOpenDialog},"Reset Password"),__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["k" /* Dialog */],{open:this.state.open,onClose:this.handleCloseDialog,"aria-labelledby":"form-dialog-title",className:"centerFixedDialog"},__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["o" /* DialogTitle */],{id:"form-dialog-title"},"Reset Password"),__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["m" /* DialogContent */],null,__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["X" /* TextField */],{label:"Old Password",fullWidth:true,onChange:function onChange(e){return _this2.handleStateChange(e,"oldPassword");},value:this.state.oldPassword,autoComplete:"off",type:"password"}),__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["X" /* TextField */],{label:"New Password",fullWidth:true,onChange:function onChange(e){return _this2.handleStateChange(e,"newPassword");},value:this.state.newPassword,autoComplete:"off",type:"password"}),__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["X" /* TextField */],{label:"Confirm New Password",fullWidth:true,onChange:function onChange(e){return _this2.handleStateChange(e,"confirmNewPassword");},value:this.state.confirmNewPassword,autoComplete:"off",type:"password"})),__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["l" /* DialogActions */],null,__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["d" /* Button */],{onClick:this.handleCloseDialog,color:"primary"},"Cancel"),__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["d" /* Button */],{onClick:this.handleResetPassword,color:"primary"},"SAVE"))))))))));}}]);return Profile;}(__WEBPACK_IMPORTED_MODULE_19_react__["Component"]);Profile=Object(__WEBPACK_IMPORTED_MODULE_20_react_apollo__["graphql"])(__WEBPACK_IMPORTED_MODULE_17_queries_profileQuery__["b" /* profileQuery */],{options:function options(){return{fetchPolicy:"network-only"};},props:function props(_props){if(_props.data.error){}return Object.assign({},_props);}})(Profile);Profile=Object(__WEBPACK_IMPORTED_MODULE_22_react_redux__["b" /* connect */])(function(state){return{brokerId:Object(__WEBPACK_IMPORTED_MODULE_15_helpers_UserHelper__["a" /* GetUserId */])(),token:Object(__WEBPACK_IMPORTED_MODULE_15_helpers_UserHelper__["c" /* GetUserToken */])()};})(Profile);Profile=Object(__WEBPACK_IMPORTED_MODULE_20_react_apollo__["graphql"])(__WEBPACK_IMPORTED_MODULE_18_queries_updatePassword__["a" /* updatePassword */])(Profile);Profile=Object(__WEBPACK_IMPORTED_MODULE_26_redux_form__["e" /* reduxForm */])({form:"BrokerProfile",destroyOnUnmount:true})(Profile);Profile=Object(__WEBPACK_IMPORTED_MODULE_20_react_apollo__["compose"])(Object(__WEBPACK_IMPORTED_MODULE_20_react_apollo__["graphql"])(__WEBPACK_IMPORTED_MODULE_18_queries_updatePassword__["a" /* updatePassword */],{name:"UpdatePassword"}),Object(__WEBPACK_IMPORTED_MODULE_20_react_apollo__["graphql"])(__WEBPACK_IMPORTED_MODULE_16_queries_Profile_mutations__["b" /* BrokerProfileUpdate */],{name:"BrokerProfileUpdate"}))(Profile);/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles_withStyles___default()(__WEBPACK_IMPORTED_MODULE_7_assets_jss_material_dashboard_pro_react_views_userProfileStyles_jsx__["a" /* default */])(Profile));

/***/ }),
/* 2343 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export defaultDataIdFromObject */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return InMemoryCache; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__fixPolyfills__ = __webpack_require__(2344);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__fixPolyfills___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__fixPolyfills__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_apollo_cache__ = __webpack_require__(2345);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_apollo_utilities__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__fragmentMatcher__ = __webpack_require__(589);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__readFromStore__ = __webpack_require__(590);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__writeToStore__ = __webpack_require__(592);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__depTrackingCache__ = __webpack_require__(369);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__optimism__ = __webpack_require__(368);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__objectCache__ = __webpack_require__(370);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__recordingCache__ = __webpack_require__(593);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};










var defaultConfig = {
    fragmentMatcher: new __WEBPACK_IMPORTED_MODULE_3__fragmentMatcher__["a" /* HeuristicFragmentMatcher */](),
    dataIdFromObject: defaultDataIdFromObject,
    addTypename: true,
    resultCaching: true,
};
function defaultDataIdFromObject(result) {
    if (result.__typename) {
        if (result.id !== undefined) {
            return result.__typename + ":" + result.id;
        }
        if (result._id !== undefined) {
            return result.__typename + ":" + result._id;
        }
    }
    return null;
}
var InMemoryCache = (function (_super) {
    __extends(InMemoryCache, _super);
    function InMemoryCache(config) {
        if (config === void 0) { config = {}; }
        var _this = _super.call(this) || this;
        _this.optimistic = [];
        _this.watches = new Set();
        _this.typenameDocumentCache = new Map();
        _this.cacheKeyRoot = new __WEBPACK_IMPORTED_MODULE_7__optimism__["a" /* CacheKeyNode */]();
        _this.silenceBroadcast = false;
        _this.config = __assign({}, defaultConfig, config);
        if (_this.config.customResolvers) {
            console.warn('customResolvers have been renamed to cacheRedirects. Please update your config as we will be deprecating customResolvers in the next major version.');
            _this.config.cacheRedirects = _this.config.customResolvers;
        }
        if (_this.config.cacheResolvers) {
            console.warn('cacheResolvers have been renamed to cacheRedirects. Please update your config as we will be deprecating cacheResolvers in the next major version.');
            _this.config.cacheRedirects = _this.config.cacheResolvers;
        }
        _this.addTypename = _this.config.addTypename;
        _this.data = _this.config.resultCaching
            ? new __WEBPACK_IMPORTED_MODULE_6__depTrackingCache__["a" /* DepTrackingCache */]()
            : new __WEBPACK_IMPORTED_MODULE_8__objectCache__["a" /* ObjectCache */]();
        _this.storeReader = new __WEBPACK_IMPORTED_MODULE_4__readFromStore__["a" /* StoreReader */](_this.cacheKeyRoot);
        _this.storeWriter = new __WEBPACK_IMPORTED_MODULE_5__writeToStore__["a" /* StoreWriter */]();
        var cache = _this;
        var maybeBroadcastWatch = cache.maybeBroadcastWatch;
        _this.maybeBroadcastWatch = Object(__WEBPACK_IMPORTED_MODULE_7__optimism__["b" /* wrap */])(function (c) {
            return maybeBroadcastWatch.call(_this, c);
        }, {
            makeCacheKey: function (c) {
                if (c.optimistic && cache.optimistic.length > 0) {
                    return;
                }
                if (c.previousResult) {
                    return;
                }
                if (cache.data instanceof __WEBPACK_IMPORTED_MODULE_6__depTrackingCache__["a" /* DepTrackingCache */]) {
                    return cache.cacheKeyRoot.lookup(c.query, JSON.stringify(c.variables));
                }
            }
        });
        return _this;
    }
    InMemoryCache.prototype.restore = function (data) {
        if (data)
            this.data.replace(data);
        return this;
    };
    InMemoryCache.prototype.extract = function (optimistic) {
        if (optimistic === void 0) { optimistic = false; }
        if (optimistic && this.optimistic.length > 0) {
            var patches = this.optimistic.map(function (opt) { return opt.data; });
            return Object.assign.apply(Object, [{}, this.data.toObject()].concat(patches));
        }
        return this.data.toObject();
    };
    InMemoryCache.prototype.read = function (query) {
        if (query.rootId && this.data.get(query.rootId) === undefined) {
            return null;
        }
        var store = query.optimistic && this.optimistic.length
            ? new __WEBPACK_IMPORTED_MODULE_8__objectCache__["a" /* ObjectCache */](this.extract(true))
            : this.data;
        return this.storeReader.readQueryFromStore({
            store: store,
            query: this.transformDocument(query.query),
            variables: query.variables,
            rootId: query.rootId,
            fragmentMatcherFunction: this.config.fragmentMatcher.match,
            previousResult: query.previousResult,
            config: this.config,
        });
    };
    InMemoryCache.prototype.write = function (write) {
        this.storeWriter.writeResultToStore({
            dataId: write.dataId,
            result: write.result,
            variables: write.variables,
            document: this.transformDocument(write.query),
            store: this.data,
            dataIdFromObject: this.config.dataIdFromObject,
            fragmentMatcherFunction: this.config.fragmentMatcher.match,
        });
        this.broadcastWatches();
    };
    InMemoryCache.prototype.diff = function (query) {
        var store = query.optimistic && this.optimistic.length
            ? new __WEBPACK_IMPORTED_MODULE_8__objectCache__["a" /* ObjectCache */](this.extract(true))
            : this.data;
        return this.storeReader.diffQueryAgainstStore({
            store: store,
            query: this.transformDocument(query.query),
            variables: query.variables,
            returnPartialData: query.returnPartialData,
            previousResult: query.previousResult,
            fragmentMatcherFunction: this.config.fragmentMatcher.match,
            config: this.config,
        });
    };
    InMemoryCache.prototype.watch = function (watch) {
        var _this = this;
        this.watches.add(watch);
        return function () {
            _this.watches.delete(watch);
        };
    };
    InMemoryCache.prototype.evict = function (query) {
        throw new Error("eviction is not implemented on InMemory Cache");
    };
    InMemoryCache.prototype.reset = function () {
        this.data.clear();
        this.broadcastWatches();
        return Promise.resolve();
    };
    InMemoryCache.prototype.removeOptimistic = function (id) {
        var _this = this;
        var toPerform = this.optimistic.filter(function (item) { return item.id !== id; });
        this.optimistic = [];
        toPerform.forEach(function (change) {
            _this.recordOptimisticTransaction(change.transaction, change.id);
        });
        this.broadcastWatches();
    };
    InMemoryCache.prototype.performTransaction = function (transaction) {
        var alreadySilenced = this.silenceBroadcast;
        this.silenceBroadcast = true;
        transaction(this);
        if (!alreadySilenced) {
            this.silenceBroadcast = false;
        }
        this.broadcastWatches();
    };
    InMemoryCache.prototype.recordOptimisticTransaction = function (transaction, id) {
        var _this = this;
        this.silenceBroadcast = true;
        var patch = Object(__WEBPACK_IMPORTED_MODULE_9__recordingCache__["a" /* record */])(this.extract(true), function (recordingCache) {
            var dataCache = _this.data;
            _this.data = recordingCache;
            _this.performTransaction(transaction);
            _this.data = dataCache;
        });
        this.optimistic.push({
            id: id,
            transaction: transaction,
            data: patch,
        });
        this.silenceBroadcast = false;
        this.broadcastWatches();
    };
    InMemoryCache.prototype.transformDocument = function (document) {
        if (this.addTypename) {
            var result = this.typenameDocumentCache.get(document);
            if (!result) {
                result = Object(__WEBPACK_IMPORTED_MODULE_2_apollo_utilities__["a" /* addTypenameToDocument */])(document);
                this.typenameDocumentCache.set(document, result);
                this.typenameDocumentCache.set(result, result);
            }
            return result;
        }
        return document;
    };
    InMemoryCache.prototype.readQuery = function (options, optimistic) {
        if (optimistic === void 0) { optimistic = false; }
        return this.read({
            query: options.query,
            variables: options.variables,
            optimistic: optimistic,
        });
    };
    InMemoryCache.prototype.readFragment = function (options, optimistic) {
        if (optimistic === void 0) { optimistic = false; }
        return this.read({
            query: this.transformDocument(Object(__WEBPACK_IMPORTED_MODULE_2_apollo_utilities__["i" /* getFragmentQueryDocument */])(options.fragment, options.fragmentName)),
            variables: options.variables,
            rootId: options.id,
            optimistic: optimistic,
        });
    };
    InMemoryCache.prototype.writeQuery = function (options) {
        this.write({
            dataId: 'ROOT_QUERY',
            result: options.data,
            query: this.transformDocument(options.query),
            variables: options.variables,
        });
    };
    InMemoryCache.prototype.writeFragment = function (options) {
        this.write({
            dataId: options.id,
            result: options.data,
            query: this.transformDocument(Object(__WEBPACK_IMPORTED_MODULE_2_apollo_utilities__["i" /* getFragmentQueryDocument */])(options.fragment, options.fragmentName)),
            variables: options.variables,
        });
    };
    InMemoryCache.prototype.broadcastWatches = function () {
        var _this = this;
        if (!this.silenceBroadcast) {
            var optimistic_1 = this.optimistic.length > 0;
            this.watches.forEach(function (c) {
                _this.maybeBroadcastWatch(c);
                if (optimistic_1) {
                    _this.maybeBroadcastWatch.dirty(c);
                }
            });
        }
    };
    InMemoryCache.prototype.maybeBroadcastWatch = function (c) {
        c.callback(this.diff({
            query: c.query,
            variables: c.variables,
            previousResult: c.previousResult && c.previousResult(),
            optimistic: c.optimistic,
        }));
    };
    return InMemoryCache;
}(__WEBPACK_IMPORTED_MODULE_1_apollo_cache__["a" /* ApolloCache */]));

//# sourceMappingURL=inMemoryCache.js.map

/***/ }),
/* 2344 */
/***/ (function(module, exports) {

var testMap = new Map();
if (testMap.set(1, 2) !== testMap) {
    var set_1 = testMap.set;
    Map.prototype.set = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        set_1.apply(this, args);
        return this;
    };
}
var testSet = new Set();
if (testSet.add(3) !== testSet) {
    var add_1 = testSet.add;
    Set.prototype.add = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        add_1.apply(this, args);
        return this;
    };
}
var frozen = {};
if (typeof Object.freeze === 'function') {
    Object.freeze(frozen);
}
try {
    testMap.set(frozen, frozen).delete(frozen);
}
catch (_a) {
    var wrap = function (method) {
        return method && (function (obj) {
            try {
                testMap.set(obj, obj).delete(obj);
            }
            finally {
                return method.call(Object, obj);
            }
        });
    };
    Object.freeze = wrap(Object.freeze);
    Object.seal = wrap(Object.seal);
    Object.preventExtensions = wrap(Object.preventExtensions);
}
//# sourceMappingURL=fixPolyfills.js.map

/***/ }),
/* 2345 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cache__ = __webpack_require__(2346);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__cache__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(2348);
/* unused harmony namespace reexport */


//# sourceMappingURL=index.js.map

/***/ }),
/* 2346 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ApolloCache; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_apollo_utilities__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(2347);


var ApolloCache = (function () {
    function ApolloCache() {
    }
    ApolloCache.prototype.transformDocument = function (document) {
        return document;
    };
    ApolloCache.prototype.transformForLink = function (document) {
        return document;
    };
    ApolloCache.prototype.readQuery = function (options, optimistic) {
        if (optimistic === void 0) { optimistic = false; }
        return this.read({
            query: options.query,
            variables: options.variables,
            optimistic: optimistic,
        });
    };
    ApolloCache.prototype.readFragment = function (options, optimistic) {
        if (optimistic === void 0) { optimistic = false; }
        return this.read({
            query: Object(__WEBPACK_IMPORTED_MODULE_0_apollo_utilities__["i" /* getFragmentQueryDocument */])(options.fragment, options.fragmentName),
            variables: options.variables,
            rootId: options.id,
            optimistic: optimistic,
        });
    };
    ApolloCache.prototype.writeQuery = function (options) {
        this.write({
            dataId: 'ROOT_QUERY',
            result: options.data,
            query: options.query,
            variables: options.variables,
        });
    };
    ApolloCache.prototype.writeFragment = function (options) {
        this.write({
            dataId: options.id,
            result: options.data,
            variables: options.variables,
            query: Object(__WEBPACK_IMPORTED_MODULE_0_apollo_utilities__["i" /* getFragmentQueryDocument */])(options.fragment, options.fragmentName),
        });
    };
    ApolloCache.prototype.writeData = function (_a) {
        var id = _a.id, data = _a.data;
        if (typeof id !== 'undefined') {
            var typenameResult = null;
            try {
                typenameResult = this.read({
                    rootId: id,
                    optimistic: false,
                    query: __WEBPACK_IMPORTED_MODULE_1__utils__["b" /* justTypenameQuery */],
                });
            }
            catch (e) {
            }
            var __typename = (typenameResult && typenameResult.__typename) || '__ClientData';
            var dataToWrite = Object.assign({ __typename: __typename }, data);
            this.writeFragment({
                id: id,
                fragment: Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* fragmentFromPojo */])(dataToWrite, __typename),
                data: dataToWrite,
            });
        }
        else {
            this.writeQuery({ query: Object(__WEBPACK_IMPORTED_MODULE_1__utils__["c" /* queryFromPojo */])(data), data: data });
        }
    };
    return ApolloCache;
}());

//# sourceMappingURL=cache.js.map

/***/ }),
/* 2347 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = queryFromPojo;
/* harmony export (immutable) */ __webpack_exports__["a"] = fragmentFromPojo;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return justTypenameQuery; });
function queryFromPojo(obj) {
    var op = {
        kind: 'OperationDefinition',
        operation: 'query',
        name: {
            kind: 'Name',
            value: 'GeneratedClientQuery',
        },
        selectionSet: selectionSetFromObj(obj),
    };
    var out = {
        kind: 'Document',
        definitions: [op],
    };
    return out;
}
function fragmentFromPojo(obj, typename) {
    var frag = {
        kind: 'FragmentDefinition',
        typeCondition: {
            kind: 'NamedType',
            name: {
                kind: 'Name',
                value: typename || '__FakeType',
            },
        },
        name: {
            kind: 'Name',
            value: 'GeneratedClientQuery',
        },
        selectionSet: selectionSetFromObj(obj),
    };
    var out = {
        kind: 'Document',
        definitions: [frag],
    };
    return out;
}
function selectionSetFromObj(obj) {
    if (typeof obj === 'number' ||
        typeof obj === 'boolean' ||
        typeof obj === 'string' ||
        typeof obj === 'undefined' ||
        obj === null) {
        return null;
    }
    if (Array.isArray(obj)) {
        return selectionSetFromObj(obj[0]);
    }
    var selections = [];
    Object.keys(obj).forEach(function (key) {
        var field = {
            kind: 'Field',
            name: {
                kind: 'Name',
                value: key,
            },
        };
        var nestedSelSet = selectionSetFromObj(obj[key]);
        if (nestedSelSet) {
            field.selectionSet = nestedSelSet;
        }
        selections.push(field);
    });
    var selectionSet = {
        kind: 'SelectionSet',
        selections: selections,
    };
    return selectionSet;
}
var justTypenameQuery = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: null,
            variableDefinitions: null,
            directives: [],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        alias: null,
                        name: {
                            kind: 'Name',
                            value: '__typename',
                        },
                        arguments: [],
                        directives: [],
                        selectionSet: null,
                    },
                ],
            },
        },
    ],
};
//# sourceMappingURL=utils.js.map

/***/ }),
/* 2348 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Cache__ = __webpack_require__(2349);
/* unused harmony namespace reexport */

//# sourceMappingURL=index.js.map

/***/ }),
/* 2349 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Cache */
var Cache;
(function (Cache) {
})(Cache || (Cache = {}));
//# sourceMappingURL=Cache.js.map

/***/ }),
/* 2350 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Cache = __webpack_require__(2351).Cache;
var tuple = __webpack_require__(2352).tuple;
var Entry = __webpack_require__(2353).Entry;
var getLocal = __webpack_require__(591).get;

// Exported so that custom makeCacheKey functions can easily reuse the
// default implementation (with different arguments).
exports.defaultMakeCacheKey = tuple;

function normalizeOptions(options) {
  options = options || Object.create(null);

  if (typeof options.makeCacheKey !== "function") {
    options.makeCacheKey = tuple;
  }

  if (typeof options.max !== "number") {
    options.max = Math.pow(2, 16);
  }

  return options;
}

function wrap(fn, options) {
  options = normalizeOptions(options);

  // If this wrapped function is disposable, then its creator does not
  // care about its return value, and it should be removed from the cache
  // immediately when it no longer has any parents that depend on it.
  var disposable = !! options.disposable;

  var cache = new Cache({
    max: options.max,
    dispose: function (key, entry) {
      entry.dispose();
    }
  });

  function reportOrphan(entry) {
    if (disposable) {
      // Triggers the entry.dispose() call above.
      cache.delete(entry.key);
      return true;
    }
  }

  function optimistic() {
    if (disposable && ! getLocal().currentParentEntry) {
      // If there's no current parent computation, and this wrapped
      // function is disposable (meaning we don't care about entry.value,
      // just dependency tracking), then we can short-cut everything else
      // in this function, because entry.recompute() is going to recycle
      // the entry object without recomputing anything, anyway.
      return;
    }

    var key = options.makeCacheKey.apply(null, arguments);
    if (! key) {
      return fn.apply(null, arguments);
    }

    var args = [], len = arguments.length;
    while (len--) args[len] = arguments[len];

    var entry = cache.get(key);
    if (entry) {
      entry.args = args;
    } else {
      cache.set(key, entry = Entry.acquire(fn, key, args));
      entry.subscribe = options.subscribe;
      if (disposable) {
        entry.reportOrphan = reportOrphan;
      }
    }

    var value = entry.recompute();

    // Move this entry to the front of the least-recently used queue,
    // since we just finished computing its value.
    cache.set(key, entry);

    // Clean up any excess entries in the cache, but only if this entry
    // has no parents, which means we're not in the middle of a larger
    // computation that might be flummoxed by the cleaning.
    if (entry.parents.size === 0) {
      cache.clean();
    }

    // If options.disposable is truthy, the caller of wrap is telling us
    // they don't care about the result of entry.recompute(), so we should
    // avoid returning the value, so it won't be accidentally used.
    if (! disposable) {
      return value;
    }
  }

  optimistic.dirty = function () {
    var key = options.makeCacheKey.apply(null, arguments);
    if (! key) {
      return;
    }

    if (! cache.has(key)) {
      return;
    }

    cache.get(key).setDirty();
  };

  return optimistic;
}

exports.wrap = wrap;


/***/ }),
/* 2351 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function Cache(options) {
  this.map = new Map;
  this.newest = null;
  this.oldest = null;
  this.max = options && options.max;
  this.dispose = options && options.dispose;
}

exports.Cache = Cache;

var Cp = Cache.prototype;

Cp.has = function (key) {
  return this.map.has(key);
};

Cp.get = function (key) {
  var entry = getEntry(this, key);
  return entry && entry.value;
};

function getEntry(cache, key) {
  var entry = cache.map.get(key);
  if (entry &&
      entry !== cache.newest) {
    var older = entry.older;
    var newer = entry.newer;

    if (newer) {
      newer.older = older;
    }

    if (older) {
      older.newer = newer;
    }

    entry.older = cache.newest;
    entry.older.newer = entry;

    entry.newer = null;
    cache.newest = entry;

    if (entry === cache.oldest) {
      cache.oldest = newer;
    }
  }

  return entry;
}

Cp.set = function (key, value) {
  var entry = getEntry(this, key);
  if (entry) {
    return entry.value = value;
  }

  entry = {
    key: key,
    value: value,
    newer: null,
    older: this.newest
  };

  if (this.newest) {
    this.newest.newer = entry;
  }

  this.newest = entry;
  this.oldest = this.oldest || entry;

  this.map.set(key, entry);

  return entry.value;
};

Cp.clean = function () {
  if (typeof this.max === "number") {
    while (this.oldest &&
           this.map.size > this.max) {
      this.delete(this.oldest.key);
    }
  }
};

Cp.delete = function (key) {
  var entry = this.map.get(key);
  if (entry) {
    if (entry === this.newest) {
      this.newest = entry.older;
    }

    if (entry === this.oldest) {
      this.oldest = entry.newer;
    }

    if (entry.newer) {
      entry.newer.older = entry.older;
    }

    if (entry.older) {
      entry.older.newer = entry.newer;
    }

    this.map.delete(key);

    if (typeof this.dispose === "function") {
      this.dispose(key, entry.value);
    }

    return true;
  }

  return false;
};


/***/ }),
/* 2352 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "tuple", function() { return tuple; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "lookup", function() { return lookup; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "lookupArray", function() { return lookupArray; });
// Although `Symbol` is widely supported these days, we can safely fall
// back to using a non-enumerable string property without violating any
// assumptions elsewhere in the implementation.
var useSymbol = typeof Symbol === "function";

// Used to mark `tuple.prototype` so that all objects that inherit from
// any `tuple.prototype` object (there could be more than one) will test
// positive according to `tuple.isTuple`.
var brand = useSymbol
  ? Symbol.for("immutable-tuple")
  : "@@__IMMUTABLE_TUPLE__@@";

// Used to save a reference to the globally shared `UniversalWeakMap` that
// stores all known `tuple` objects.
var globalKey = useSymbol
  ? Symbol.for("immutable-tuple-root")
  : "@@__IMMUTABLE_TUPLE_ROOT__@@";

// Convenient helper for defining hidden immutable properties.
function def(obj, name, value, enumerable) {
  Object.defineProperty(obj, name, {
    value: value,
    enumerable: !! enumerable,
    writable: false,
    configurable: false
  });
  return value;
}

var freeze = Object.freeze || function (obj) {
  return obj;
};

function isObjRef(value) {
  switch (typeof value) {
  case "object":
    if (value === null) {
      return false;
    }
  case "function":
    return true;
  default:
    return false;
  }
}

// The `mustConvertThisToArray` value is true when the corresponding
// `Array` method does not attempt to modify `this`, which means we can
// pass a `tuple` object as `this` without first converting it to an
// `Array`.
function forEachArrayMethod(fn) {
  function call(name, mustConvertThisToArray) {
    var desc = Object.getOwnPropertyDescriptor(Array.prototype, name);
    fn(name, desc, !! mustConvertThisToArray);
  }

  call("every");
  call("filter");
  call("find");
  call("findIndex");
  call("forEach");
  call("includes");
  call("indexOf");
  call("join");
  call("lastIndexOf");
  call("map");
  call("reduce");
  call("reduceRight");
  call("slice");
  call("some");
  call("toLocaleString");
  call("toString");

  // The `reverse` and `sort` methods are usually destructive, but for
  // `tuple` objects they return a new `tuple` object that has been
  // appropriately reversed/sorted.
  call("reverse", true);
  call("sort", true);

  // Make `[...someTuple]` work.
  call(useSymbol && Symbol.iterator || "@@iterator");
}

// A map data structure that holds object keys weakly, yet can also hold
// non-object keys, unlike the native `WeakMap`.
var UniversalWeakMap = function UniversalWeakMap() {
  // Since a `WeakMap` cannot hold primitive values as keys, we need a
  // backup `Map` instance to hold primitive keys. Both `this._weakMap`
  // and `this._strongMap` are lazily initialized.
  this._weakMap = null;
  this._strongMap = null;
  this.data = null;
};

// Since `get` and `set` are the only methods used, that's all I've
// implemented here.

UniversalWeakMap.prototype.get = function get (key) {
  var map = this._getMap(key, false);
  if (map) {
    return map.get(key);
  }
};

UniversalWeakMap.prototype.set = function set (key, value) {
  this._getMap(key, true).set(key, value);
  // An actual `Map` or `WeakMap` would return `this` here, but
  // returning the `value` is more convenient for the `tuple`
  // implementation.
  return value;
};

UniversalWeakMap.prototype._getMap = function _getMap (key, canCreate) {
  if (! canCreate) {
    return isObjRef(key) ? this._weakMap : this._strongMap;
  }
  if (isObjRef(key)) {
    return this._weakMap || (this._weakMap = new WeakMap);
  }
  return this._strongMap || (this._strongMap = new Map);
};

// See [`universal-weak-map.js`](universal-weak-map.html).
// See [`util.js`](util.html).
// If this package is installed multiple times, there could be mutiple
// implementations of the `tuple` function with distinct `tuple.prototype`
// objects, but the shared pool of `tuple` objects must be the same across
// all implementations. While it would be ideal to use the `global`
// object, there's no reliable way to get the global object across all JS
// environments without using the `Function` constructor, so instead we
// use the global `Array` constructor as a shared namespace.
var root = Array[globalKey] || def(Array, globalKey, new UniversalWeakMap, false);

function lookup() {
  return lookupArray(arguments);
}

function lookupArray(array) {
  var node = root;

  // Because we are building a tree of *weak* maps, the tree will not
  // prevent objects in tuples from being garbage collected, since the
  // tree itself will be pruned over time when the corresponding `tuple`
  // objects become unreachable. In addition to internalization, this
  // property is a key advantage of the `immutable-tuple` package.
  var len = array.length;
  for (var i = 0; i < len; ++i) {
    var item = array[i];
    node = node.get(item) || node.set(item, new UniversalWeakMap);
  }

  // Return node.data rather than node itself to prevent tampering with
  // the UniversalWeakMap tree.
  return node.data || (node.data = Object.create(null));
}

// See [`lookup.js`](lookup.html).
// See [`util.js`](util.html).
// When called with any number of arguments, this function returns an
// object that inherits from `tuple.prototype` and is guaranteed to be
// `===` any other `tuple` object that has exactly the same items. In
// computer science jargon, `tuple` instances are "internalized" or just
// "interned," which allows for constant-time equality checking, and makes
// it possible for tuple objects to be used as `Map` or `WeakMap` keys, or
// stored in a `Set`.
function tuple() {
  var arguments$1 = arguments;

  var node = lookup.apply(null, arguments);

  if (node.tuple) {
    return node.tuple;
  }

  var t = Object.create(tuple.prototype);

  // Define immutable items with numeric indexes, and permanently fix the
  // `.length` property.
  var argc = arguments.length;
  for (var i = 0; i < argc; ++i) {
    t[i] = arguments$1[i];
  }

  def(t, "length", argc, false);

  // Remember this new `tuple` object so that we can return the same object
  // earlier next time.
  return freeze(node.tuple = t);
}

// Since the `immutable-tuple` package could be installed multiple times
// in an application, there is no guarantee that the `tuple` constructor
// or `tuple.prototype` will be unique, so `value instanceof tuple` is
// unreliable. Instead, to test if a value is a tuple, you should use
// `tuple.isTuple(value)`.
def(tuple.prototype, brand, true, false);
function isTuple(that) {
  return !! (that && that[brand] === true);
}

tuple.isTuple = isTuple;

function toArray(tuple) {
  var array = [];
  var i = tuple.length;
  while (i--) { array[i] = tuple[i]; }
  return array;
}

// Copy all generic non-destructive Array methods to `tuple.prototype`.
// This works because (for example) `Array.prototype.slice` can be invoked
// against any `Array`-like object.
forEachArrayMethod(function (name, desc, mustConvertThisToArray) {
  var method = desc && desc.value;
  if (typeof method === "function") {
    desc.value = function () {
      var args = [], len = arguments.length;
      while ( len-- ) args[ len ] = arguments[ len ];

      var result = method.apply(
        mustConvertThisToArray ? toArray(this) : this,
        args
      );
      // Of course, `tuple.prototype.slice` should return a `tuple` object,
      // not a new `Array`.
      return Array.isArray(result) ? tuple.apply(void 0, result) : result;
    };
    Object.defineProperty(tuple.prototype, name, desc);
  }
});

// Like `Array.prototype.concat`, except for the extra effort required to
// convert any tuple arguments to arrays, so that
// ```
// tuple(1).concat(tuple(2), 3) === tuple(1, 2, 3)
// ```
var ref = Array.prototype;
var concat = ref.concat;
tuple.prototype.concat = function () {
  var args = [], len = arguments.length;
  while ( len-- ) args[ len ] = arguments[ len ];

  return tuple.apply(void 0, concat.apply(toArray(this), args.map(
    function (item) { return isTuple(item) ? toArray(item) : item; }
  )));
};

/* harmony default export */ __webpack_exports__["default"] = (tuple);



/***/ }),
/* 2353 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var getLocal = __webpack_require__(591).get;
var UNKNOWN_VALUE = Object.create(null);
var emptySetPool = [];
var entryPool = [];

// Don't let the emptySetPool or entryPool grow larger than this size,
// since unconstrained pool growth could lead to memory leaks.
exports.POOL_TARGET_SIZE = 100;

// Since this package might be used browsers, we should avoid using the
// Node built-in assert module.
function assert(condition, optionalMessage) {
  if (! condition) {
    throw new Error(optionalMessage || "assertion failure");
  }
}

function Entry(fn, key, args) {
  this.parents = new Set;
  this.childValues = new Map;

  // When this Entry has children that are dirty, this property becomes
  // a Set containing other Entry objects, borrowed from emptySetPool.
  // When the set becomes empty, it gets recycled back to emptySetPool.
  this.dirtyChildren = null;

  reset(this, fn, key, args);

  ++Entry.count;
}

Entry.count = 0;

function reset(entry, fn, key, args) {
  entry.fn = fn;
  entry.key = key;
  entry.args = args;
  entry.value = UNKNOWN_VALUE;
  entry.dirty = true;
  entry.subscribe = null;
  entry.unsubscribe = null;
  entry.recomputing = false;
  // Optional callback that will be invoked when entry.parents becomes
  // empty. The Entry object is given as the first parameter. If the
  // callback returns true, then this entry can be removed from the graph
  // and safely recycled into the entryPool.
  entry.reportOrphan = null;
}

Entry.acquire = function (fn, key, args) {
  var entry = entryPool.pop();
  if (entry) {
    reset(entry, fn, key, args);
    return entry;
  }
  return new Entry(fn, key, args);
};

function release(entry) {
  assert(entry.parents.size === 0);
  assert(entry.childValues.size === 0);
  assert(entry.dirtyChildren === null);
  if (entryPool.length < exports.POOL_TARGET_SIZE) {
    entryPool.push(entry);
  }
}

exports.Entry = Entry;

var Ep = Entry.prototype;

// The public API of Entry objects consists of the Entry constructor,
// along with the recompute, setDirty, and dispose methods.

Ep.recompute = function recompute() {
  if (! rememberParent(this) &&
      maybeReportOrphan(this)) {
    // The recipient of the entry.reportOrphan callback decided to dispose
    // of this orphan entry by calling entry.dispos(), which recycles it
    // into the entryPool, so we don't need to (and should not) proceed
    // with the recomputation.
    return;
  }

  return recomputeIfDirty(this);
};

// If the given entry has a reportOrphan method, and no remaining parents,
// call entry.reportOrphan and return true iff it returns true. The
// reportOrphan function should return true to indicate entry.dispose()
// has been called, and the entry has been removed from any other caches
// (see index.js for the only current example).
function maybeReportOrphan(entry) {
  var report = entry.reportOrphan;
  return typeof report === "function" &&
    entry.parents.size === 0 &&
    report(entry) === true;
}

Ep.setDirty = function setDirty() {
  if (this.dirty) return;
  this.dirty = true;
  this.value = UNKNOWN_VALUE;
  reportDirty(this);
  // We can go ahead and unsubscribe here, since any further dirty
  // notifications we receive will be redundant, and unsubscribing may
  // free up some resources, e.g. file watchers.
  unsubscribe(this);
};

Ep.dispose = function dispose() {
  var entry = this;
  forgetChildren(entry).forEach(maybeReportOrphan);
  unsubscribe(entry);

  // Because this entry has been kicked out of the cache (in index.js),
  // we've lost the ability to find out if/when this entry becomes dirty,
  // whether that happens through a subscription, because of a direct call
  // to entry.setDirty(), or because one of its children becomes dirty.
  // Because of this loss of future information, we have to assume the
  // worst (that this entry might have become dirty very soon), so we must
  // immediately mark this entry's parents as dirty. Normally we could
  // just call entry.setDirty() rather than calling parent.setDirty() for
  // each parent, but that would leave this entry in parent.childValues
  // and parent.dirtyChildren, which would prevent the child from being
  // truly forgotten.
  entry.parents.forEach(function (parent) {
    parent.setDirty();
    forgetChild(parent, entry);
  });

  // Since this entry has no parents and no children anymore, and the
  // caller of Entry#dispose has indicated that entry.value no longer
  // matters, we can safely recycle this Entry object for later use.
  release(entry);
};

function setClean(entry) {
  entry.dirty = false;

  if (mightBeDirty(entry)) {
    // This Entry may still have dirty children, in which case we can't
    // let our parents know we're clean just yet.
    return;
  }

  reportClean(entry);
}

function reportDirty(entry) {
  entry.parents.forEach(function (parent) {
    reportDirtyChild(parent, entry);
  });
}

function reportClean(entry) {
  entry.parents.forEach(function (parent) {
    reportCleanChild(parent, entry);
  });
}

function mightBeDirty(entry) {
  return entry.dirty ||
    (entry.dirtyChildren &&
     entry.dirtyChildren.size);
}

// Let a parent Entry know that one of its children may be dirty.
function reportDirtyChild(entry, child) {
  // Must have called rememberParent(child) before calling
  // reportDirtyChild(parent, child).
  assert(entry.childValues.has(child));
  assert(mightBeDirty(child));

  if (! entry.dirtyChildren) {
    entry.dirtyChildren = emptySetPool.pop() || new Set;

  } else if (entry.dirtyChildren.has(child)) {
    // If we already know this child is dirty, then we must have already
    // informed our own parents that we are dirty, so we can terminate
    // the recursion early.
    return;
  }

  entry.dirtyChildren.add(child);
  reportDirty(entry);
}

// Let a parent Entry know that one of its children is no longer dirty.
function reportCleanChild(entry, child) {
  var cv = entry.childValues;

  // Must have called rememberChild(child) before calling
  // reportCleanChild(parent, child).
  assert(cv.has(child));
  assert(! mightBeDirty(child));

  var childValue = cv.get(child);
  if (childValue === UNKNOWN_VALUE) {
    cv.set(child, child.value);
  } else if (childValue !== child.value) {
    entry.setDirty();
  }

  removeDirtyChild(entry, child);

  if (mightBeDirty(entry)) {
    return;
  }

  reportClean(entry);
}

function removeDirtyChild(entry, child) {
  var dc = entry.dirtyChildren;
  if (dc) {
    dc.delete(child);
    if (dc.size === 0) {
      if (emptySetPool.length < exports.POOL_TARGET_SIZE) {
        emptySetPool.push(dc);
      }
      entry.dirtyChildren = null;
    }
  }
}

function rememberParent(entry) {
  var local = getLocal();
  var parent = local.currentParentEntry;
  if (parent) {
    entry.parents.add(parent);

    if (! parent.childValues.has(entry)) {
      parent.childValues.set(entry, UNKNOWN_VALUE);
    }

    if (mightBeDirty(entry)) {
      reportDirtyChild(parent, entry);
    } else {
      reportCleanChild(parent, entry);
    }

    return parent;
  }
}

// This is the most important method of the Entry API, because it
// determines whether the cached entry.value can be returned immediately,
// or must be recomputed. The overall performance of the caching system
// depends on the truth of the following observations: (1) this.dirty is
// usually false, (2) this.dirtyChildren is usually null/empty, and thus
// (3) this.value is usally returned very quickly, without recomputation.
function recomputeIfDirty(entry) {
  if (entry.dirty) {
    // If this Entry is explicitly dirty because someone called
    // entry.setDirty(), recompute.
    return reallyRecompute(entry);
  }

  if (mightBeDirty(entry)) {
    // Get fresh values for any dirty children, and if those values
    // disagree with this.childValues, mark this Entry explicitly dirty.
    entry.dirtyChildren.forEach(function (child) {
      assert(entry.childValues.has(child));
      try {
        recomputeIfDirty(child);
      } catch (e) {
        entry.setDirty();
      }
    });

    if (entry.dirty) {
      // If this Entry has become explicitly dirty after comparing the fresh
      // values of its dirty children against this.childValues, recompute.
      return reallyRecompute(entry);
    }
  }

  assert(entry.value !== UNKNOWN_VALUE);

  return entry.value;
}

function reallyRecompute(entry) {
  assert(! entry.recomputing, "already recomputing");
  entry.recomputing = true;

  // Since this recomputation is likely to re-remember some of this
  // entry's children, we forget our children here but do not call
  // maybeReportOrphan until after the recomputation finishes.
  var originalChildren = forgetChildren(entry);

  var local = getLocal();
  var parent = local.currentParentEntry;
  local.currentParentEntry = entry;

  var threw = true;
  try {
    entry.value = entry.fn.apply(null, entry.args);
    threw = false;

  } finally {
    entry.recomputing = false;

    assert(local.currentParentEntry === entry);
    local.currentParentEntry = parent;

    if (threw || ! subscribe(entry)) {
      // Mark this Entry dirty if entry.fn threw or we failed to
      // resubscribe. This is important because, if we have a subscribe
      // function and it failed, then we're going to miss important
      // notifications about the potential dirtiness of entry.value.
      entry.setDirty();
    } else {
      // If we successfully recomputed entry.value and did not fail to
      // (re)subscribe, then this Entry is no longer explicitly dirty.
      setClean(entry);
    }
  }

  // Now that we've had a chance to re-remember any children that were
  // involved in the recomputation, we can safely report any orphan
  // children that remain.
  originalChildren.forEach(maybeReportOrphan);

  return entry.value;
}

var reusableEmptyArray = [];

// Removes all children from this entry and returns an array of the
// removed children.
function forgetChildren(entry) {
  var children = reusableEmptyArray;

  if (entry.childValues.size > 0) {
    children = [];
    entry.childValues.forEach(function (value, child) {
      forgetChild(entry, child);
      children.push(child);
    });
  }

  // After we forget all our children, this.dirtyChildren must be empty
  // and therefor must have been reset to null.
  assert(entry.dirtyChildren === null);

  return children;
}

function forgetChild(entry, child) {
  child.parents.delete(entry);
  entry.childValues.delete(child);
  removeDirtyChild(entry, child);
}

function subscribe(entry) {
  if (typeof entry.subscribe === "function") {
    try {
      unsubscribe(entry); // Prevent double subscriptions.
      entry.unsubscribe = entry.subscribe.apply(null, entry.args);
    } catch (e) {
      // If this Entry has a subscribe function and it threw an exception
      // (or an unsubscribe function it previously returned now throws),
      // return false to indicate that we were not able to subscribe (or
      // unsubscribe), and this Entry should remain dirty.
      entry.setDirty();
      return false;
    }
  }

  // Returning true indicates either that there was no entry.subscribe
  // function or that it succeeded.
  return true;
}

function unsubscribe(entry) {
  var unsub = entry.unsubscribe;
  if (typeof unsub === "function") {
    entry.unsubscribe = null;
    unsub();
  }
}


/***/ }),
/* 2354 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return QueryKeyMaker; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_graphql_language_visitor__ = __webpack_require__(522);
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

var CIRCULAR = Object.create(null);
var objToStr = Object.prototype.toString;
var QueryKeyMaker = (function () {
    function QueryKeyMaker(cacheKeyRoot) {
        this.cacheKeyRoot = cacheKeyRoot;
        this.perQueryKeyMakers = new Map();
    }
    QueryKeyMaker.prototype.forQuery = function (document) {
        if (!this.perQueryKeyMakers.has(document)) {
            this.perQueryKeyMakers.set(document, new PerQueryKeyMaker(this.cacheKeyRoot, document));
        }
        return this.perQueryKeyMakers.get(document);
    };
    return QueryKeyMaker;
}());

var PerQueryKeyMaker = (function () {
    function PerQueryKeyMaker(cacheKeyRoot, query) {
        this.cacheKeyRoot = cacheKeyRoot;
        this.query = query;
        this.cache = new Map;
        this.lookupArray = this.cacheMethod(this.lookupArray);
        this.lookupObject = this.cacheMethod(this.lookupObject);
        this.lookupFragmentSpread = this.cacheMethod(this.lookupFragmentSpread);
    }
    PerQueryKeyMaker.prototype.cacheMethod = function (method) {
        var _this = this;
        return function (value) {
            if (_this.cache.has(value)) {
                var cached = _this.cache.get(value);
                if (cached === CIRCULAR) {
                    throw new Error("QueryKeyMaker cannot handle circular query structures");
                }
                return cached;
            }
            _this.cache.set(value, CIRCULAR);
            try {
                var result = method.call(_this, value);
                _this.cache.set(value, result);
                return result;
            }
            catch (e) {
                _this.cache.delete(value);
                throw e;
            }
        };
    };
    PerQueryKeyMaker.prototype.lookupQuery = function (document) {
        return this.lookupObject(document);
    };
    PerQueryKeyMaker.prototype.lookupSelectionSet = function (selectionSet) {
        return this.lookupObject(selectionSet);
    };
    PerQueryKeyMaker.prototype.lookupFragmentSpread = function (fragmentSpread) {
        var name = fragmentSpread.name.value;
        var fragment = null;
        this.query.definitions.some(function (definition) {
            if (definition.kind === "FragmentDefinition" &&
                definition.name.value === name) {
                fragment = definition;
                return true;
            }
            return false;
        });
        return this.lookupObject(__assign({}, fragmentSpread, { fragment: fragment }));
    };
    PerQueryKeyMaker.prototype.lookupAny = function (value) {
        if (Array.isArray(value)) {
            return this.lookupArray(value);
        }
        if (typeof value === "object" && value !== null) {
            if (value.kind === "FragmentSpread") {
                return this.lookupFragmentSpread(value);
            }
            return this.lookupObject(value);
        }
        return value;
    };
    PerQueryKeyMaker.prototype.lookupArray = function (array) {
        var elements = array.map(this.lookupAny, this);
        return this.cacheKeyRoot.lookup(objToStr.call(array), this.cacheKeyRoot.lookupArray(elements));
    };
    PerQueryKeyMaker.prototype.lookupObject = function (object) {
        var _this = this;
        var keys = safeSortedKeys(object);
        var values = keys.map(function (key) { return _this.lookupAny(object[key]); });
        return this.cacheKeyRoot.lookup(objToStr.call(object), this.cacheKeyRoot.lookupArray(keys), this.cacheKeyRoot.lookupArray(values));
    };
    return PerQueryKeyMaker;
}());
var queryKeyMap = Object.create(null);
Object.keys(__WEBPACK_IMPORTED_MODULE_0_graphql_language_visitor__["a" /* QueryDocumentKeys */]).forEach(function (parentKind) {
    var childKeys = queryKeyMap[parentKind] = Object.create(null);
    __WEBPACK_IMPORTED_MODULE_0_graphql_language_visitor__["a" /* QueryDocumentKeys */][parentKind].forEach(function (childKey) {
        childKeys[childKey] = true;
    });
    if (parentKind === "FragmentSpread") {
        childKeys["fragment"] = true;
    }
});
function safeSortedKeys(object) {
    var keys = Object.keys(object);
    var keyCount = keys.length;
    var knownKeys = typeof object.kind === "string" && queryKeyMap[object.kind];
    var target = 0;
    for (var source = target; source < keyCount; ++source) {
        var key = keys[source];
        var value = object[key];
        var isObjectOrArray = value !== null && typeof value === "object";
        if (!isObjectOrArray || !knownKeys || knownKeys[key] === true) {
            keys[target++] = key;
        }
    }
    keys.length = target;
    return keys.sort();
}
//# sourceMappingURL=queryKeyMaker.js.map

/***/ }),
/* 2355 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(187) && !__webpack_require__(594)(function () {
  return Object.defineProperty(__webpack_require__(595)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 2356 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(373);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 2357 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(2358);
var step = __webpack_require__(2359);
var Iterators = __webpack_require__(376);
var toIObject = __webpack_require__(377);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(2362)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 2358 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.31 Array.prototype[@@unscopables]
var UNSCOPABLES = __webpack_require__(188)('unscopables');
var ArrayProto = Array.prototype;
if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__(146)(ArrayProto, UNSCOPABLES, {});
module.exports = function (key) {
  ArrayProto[UNSCOPABLES][key] = true;
};


/***/ }),
/* 2359 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 2360 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(2361);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 2361 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 2362 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(598);
var $export = __webpack_require__(2363);
var redefine = __webpack_require__(378);
var hide = __webpack_require__(146);
var Iterators = __webpack_require__(376);
var $iterCreate = __webpack_require__(2366);
var setToStringTag = __webpack_require__(604);
var getPrototypeOf = __webpack_require__(2374);
var ITERATOR = __webpack_require__(188)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 2363 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(112);
var core = __webpack_require__(374);
var hide = __webpack_require__(146);
var redefine = __webpack_require__(378);
var ctx = __webpack_require__(2364);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
  var key, own, out, exp;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    // export native or passed
    out = (own ? target : source)[key];
    // bind timers to global for call from export context
    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // extend global
    if (target) redefine(target, key, out, type & $export.U);
    // export
    if (exports[key] != out) hide(exports, key, exp);
    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
  }
};
global.core = core;
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 2364 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(2365);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 2365 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 2366 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(2367);
var descriptor = __webpack_require__(599);
var setToStringTag = __webpack_require__(604);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(146)(IteratorPrototype, __webpack_require__(188)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 2367 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(372);
var dPs = __webpack_require__(2368);
var enumBugKeys = __webpack_require__(603);
var IE_PROTO = __webpack_require__(379)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(595)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(2373).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 2368 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(249);
var anObject = __webpack_require__(372);
var getKeys = __webpack_require__(601);

module.exports = __webpack_require__(187) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 2369 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(250);
var toIObject = __webpack_require__(377);
var arrayIndexOf = __webpack_require__(2370)(false);
var IE_PROTO = __webpack_require__(379)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 2370 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(377);
var toLength = __webpack_require__(2371);
var toAbsoluteIndex = __webpack_require__(2372);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 2371 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(602);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 2372 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(602);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 2373 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(112).document;
module.exports = document && document.documentElement;


/***/ }),
/* 2374 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(250);
var toObject = __webpack_require__(2375);
var IE_PROTO = __webpack_require__(379)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 2375 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(600);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 2376 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var cardAvatarStyle={cardAvatar:{"&$cardAvatarProfile img,&$cardAvatarTestimonial img":{width:"100%",height:"auto"}},cardAvatarProfile:{maxWidth:"130px",maxHeight:"130px",margin:"-50px auto 0",borderRadius:"50%",overflow:"hidden",padding:"0",boxShadow:"0 16px 38px -12px rgba(0, 0, 0, 0.56), 0 4px 25px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(0, 0, 0, 0.2)","&$cardAvatarPlain":{marginTop:"0"}},cardAvatarPlain:{},cardAvatarTestimonial:{margin:"-50px auto 0",maxWidth:"100px",maxHeight:"100px",borderRadius:"50%",overflow:"hidden",padding:"0",boxShadow:"0 16px 38px -12px rgba(0, 0, 0, 0.56), 0 4px 25px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(0, 0, 0, 0.2)","&$cardAvatarPlain":{marginTop:"0"}},cardAvatarTestimonialFooter:{marginBottom:"-50px",marginTop:"10px"}};/* harmony default export */ __webpack_exports__["a"] = (cardAvatarStyle);

/***/ }),
/* 2377 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return supportMultiple; });
/* harmony export (immutable) */ __webpack_exports__["d"] = getDataTransferItems;
/* harmony export (immutable) */ __webpack_exports__["b"] = fileAccepted;
/* harmony export (immutable) */ __webpack_exports__["c"] = fileMatchSize;
/* harmony export (immutable) */ __webpack_exports__["a"] = allFilesAccepted;
/* harmony export (immutable) */ __webpack_exports__["f"] = onDocumentDragOver;
/* harmony export (immutable) */ __webpack_exports__["e"] = isIeOrEdge;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_attr_accept__ = __webpack_require__(2378);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_attr_accept___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_attr_accept__);


var supportMultiple = typeof document !== 'undefined' && document && document.createElement ? 'multiple' in document.createElement('input') : true;

function getDataTransferItems(event) {
  var dataTransferItemsList = [];
  if (event.dataTransfer) {
    var dt = event.dataTransfer;

    if (dt.files && dt.files.length) {
      dataTransferItemsList = dt.files;
    } else if (dt.items && dt.items.length) {
      // During the drag even the dataTransfer.files is null
      // but Chrome implements some drag store, which is accesible via dataTransfer.items
      dataTransferItemsList = dt.items;
    }
  } else if (event.target && event.target.files) {
    dataTransferItemsList = event.target.files;
  }

  // Convert from DataTransferItemsList to the native Array
  return Array.prototype.slice.call(dataTransferItemsList);
}

// Firefox versions prior to 53 return a bogus MIME type for every file drag, so dragovers with
// that MIME type will always be accepted
function fileAccepted(file, accept) {
  return file.type === 'application/x-moz-file' || __WEBPACK_IMPORTED_MODULE_0_attr_accept___default()(file, accept);
}

function fileMatchSize(file, maxSize, minSize) {
  return file.size <= maxSize && file.size >= minSize;
}

function allFilesAccepted(files, accept) {
  return files.every(function (file) {
    return fileAccepted(file, accept);
  });
}

// allow the entire document to be a drag target
function onDocumentDragOver(evt) {
  evt.preventDefault();
}

function isIe(userAgent) {
  return userAgent.indexOf('MSIE') !== -1 || userAgent.indexOf('Trident/') !== -1;
}

function isEdge(userAgent) {
  return userAgent.indexOf('Edge/') !== -1;
}

function isIeOrEdge() {
  var userAgent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.navigator.userAgent;

  return isIe(userAgent) || isEdge(userAgent);
}

/***/ }),
/* 2378 */
/***/ (function(module, exports) {

module.exports=function(t){function n(e){if(r[e])return r[e].exports;var o=r[e]={i:e,l:!1,exports:{}};return t[e].call(o.exports,o,o.exports,n),o.l=!0,o.exports}var r={};return n.m=t,n.c=r,n.d=function(t,r,e){n.o(t,r)||Object.defineProperty(t,r,{configurable:!1,enumerable:!0,get:e})},n.n=function(t){var r=t&&t.__esModule?function(){return t.default}:function(){return t};return n.d(r,"a",r),r},n.o=function(t,n){return Object.prototype.hasOwnProperty.call(t,n)},n.p="",n(n.s=13)}([function(t,n){var r=t.exports="undefined"!=typeof window&&window.Math==Math?window:"undefined"!=typeof self&&self.Math==Math?self:Function("return this")();"number"==typeof __g&&(__g=r)},function(t,n){t.exports=function(t){return"object"==typeof t?null!==t:"function"==typeof t}},function(t,n){var r=t.exports={version:"2.5.0"};"number"==typeof __e&&(__e=r)},function(t,n,r){t.exports=!r(4)(function(){return 7!=Object.defineProperty({},"a",{get:function(){return 7}}).a})},function(t,n){t.exports=function(t){try{return!!t()}catch(t){return!0}}},function(t,n){var r={}.toString;t.exports=function(t){return r.call(t).slice(8,-1)}},function(t,n,r){var e=r(32)("wks"),o=r(9),i=r(0).Symbol,u="function"==typeof i;(t.exports=function(t){return e[t]||(e[t]=u&&i[t]||(u?i:o)("Symbol."+t))}).store=e},function(t,n,r){var e=r(0),o=r(2),i=r(8),u=r(22),c=r(10),f=function(t,n,r){var a,s,p,l,v=t&f.F,y=t&f.G,h=t&f.S,d=t&f.P,x=t&f.B,g=y?e:h?e[n]||(e[n]={}):(e[n]||{}).prototype,m=y?o:o[n]||(o[n]={}),b=m.prototype||(m.prototype={});y&&(r=n);for(a in r)s=!v&&g&&void 0!==g[a],p=(s?g:r)[a],l=x&&s?c(p,e):d&&"function"==typeof p?c(Function.call,p):p,g&&u(g,a,p,t&f.U),m[a]!=p&&i(m,a,l),d&&b[a]!=p&&(b[a]=p)};e.core=o,f.F=1,f.G=2,f.S=4,f.P=8,f.B=16,f.W=32,f.U=64,f.R=128,t.exports=f},function(t,n,r){var e=r(16),o=r(21);t.exports=r(3)?function(t,n,r){return e.f(t,n,o(1,r))}:function(t,n,r){return t[n]=r,t}},function(t,n){var r=0,e=Math.random();t.exports=function(t){return"Symbol(".concat(void 0===t?"":t,")_",(++r+e).toString(36))}},function(t,n,r){var e=r(24);t.exports=function(t,n,r){if(e(t),void 0===n)return t;switch(r){case 1:return function(r){return t.call(n,r)};case 2:return function(r,e){return t.call(n,r,e)};case 3:return function(r,e,o){return t.call(n,r,e,o)}}return function(){return t.apply(n,arguments)}}},function(t,n){t.exports=function(t){if(void 0==t)throw TypeError("Can't call method on  "+t);return t}},function(t,n,r){var e=r(28),o=Math.min;t.exports=function(t){return t>0?o(e(t),9007199254740991):0}},function(t,n,r){"use strict";n.__esModule=!0,n.default=function(t,n){if(t&&n){var r=Array.isArray(n)?n:n.split(","),e=t.name||"",o=t.type||"",i=o.replace(/\/.*$/,"");return r.some(function(t){var n=t.trim();return"."===n.charAt(0)?e.toLowerCase().endsWith(n.toLowerCase()):n.endsWith("/*")?i===n.replace(/\/.*$/,""):o===n})}return!0},r(14),r(34)},function(t,n,r){r(15),t.exports=r(2).Array.some},function(t,n,r){"use strict";var e=r(7),o=r(25)(3);e(e.P+e.F*!r(33)([].some,!0),"Array",{some:function(t){return o(this,t,arguments[1])}})},function(t,n,r){var e=r(17),o=r(18),i=r(20),u=Object.defineProperty;n.f=r(3)?Object.defineProperty:function(t,n,r){if(e(t),n=i(n,!0),e(r),o)try{return u(t,n,r)}catch(t){}if("get"in r||"set"in r)throw TypeError("Accessors not supported!");return"value"in r&&(t[n]=r.value),t}},function(t,n,r){var e=r(1);t.exports=function(t){if(!e(t))throw TypeError(t+" is not an object!");return t}},function(t,n,r){t.exports=!r(3)&&!r(4)(function(){return 7!=Object.defineProperty(r(19)("div"),"a",{get:function(){return 7}}).a})},function(t,n,r){var e=r(1),o=r(0).document,i=e(o)&&e(o.createElement);t.exports=function(t){return i?o.createElement(t):{}}},function(t,n,r){var e=r(1);t.exports=function(t,n){if(!e(t))return t;var r,o;if(n&&"function"==typeof(r=t.toString)&&!e(o=r.call(t)))return o;if("function"==typeof(r=t.valueOf)&&!e(o=r.call(t)))return o;if(!n&&"function"==typeof(r=t.toString)&&!e(o=r.call(t)))return o;throw TypeError("Can't convert object to primitive value")}},function(t,n){t.exports=function(t,n){return{enumerable:!(1&t),configurable:!(2&t),writable:!(4&t),value:n}}},function(t,n,r){var e=r(0),o=r(8),i=r(23),u=r(9)("src"),c=Function.toString,f=(""+c).split("toString");r(2).inspectSource=function(t){return c.call(t)},(t.exports=function(t,n,r,c){var a="function"==typeof r;a&&(i(r,"name")||o(r,"name",n)),t[n]!==r&&(a&&(i(r,u)||o(r,u,t[n]?""+t[n]:f.join(String(n)))),t===e?t[n]=r:c?t[n]?t[n]=r:o(t,n,r):(delete t[n],o(t,n,r)))})(Function.prototype,"toString",function(){return"function"==typeof this&&this[u]||c.call(this)})},function(t,n){var r={}.hasOwnProperty;t.exports=function(t,n){return r.call(t,n)}},function(t,n){t.exports=function(t){if("function"!=typeof t)throw TypeError(t+" is not a function!");return t}},function(t,n,r){var e=r(10),o=r(26),i=r(27),u=r(12),c=r(29);t.exports=function(t,n){var r=1==t,f=2==t,a=3==t,s=4==t,p=6==t,l=5==t||p,v=n||c;return function(n,c,y){for(var h,d,x=i(n),g=o(x),m=e(c,y,3),b=u(g.length),_=0,w=r?v(n,b):f?v(n,0):void 0;b>_;_++)if((l||_ in g)&&(h=g[_],d=m(h,_,x),t))if(r)w[_]=d;else if(d)switch(t){case 3:return!0;case 5:return h;case 6:return _;case 2:w.push(h)}else if(s)return!1;return p?-1:a||s?s:w}}},function(t,n,r){var e=r(5);t.exports=Object("z").propertyIsEnumerable(0)?Object:function(t){return"String"==e(t)?t.split(""):Object(t)}},function(t,n,r){var e=r(11);t.exports=function(t){return Object(e(t))}},function(t,n){var r=Math.ceil,e=Math.floor;t.exports=function(t){return isNaN(t=+t)?0:(t>0?e:r)(t)}},function(t,n,r){var e=r(30);t.exports=function(t,n){return new(e(t))(n)}},function(t,n,r){var e=r(1),o=r(31),i=r(6)("species");t.exports=function(t){var n;return o(t)&&(n=t.constructor,"function"!=typeof n||n!==Array&&!o(n.prototype)||(n=void 0),e(n)&&null===(n=n[i])&&(n=void 0)),void 0===n?Array:n}},function(t,n,r){var e=r(5);t.exports=Array.isArray||function(t){return"Array"==e(t)}},function(t,n,r){var e=r(0),o=e["__core-js_shared__"]||(e["__core-js_shared__"]={});t.exports=function(t){return o[t]||(o[t]={})}},function(t,n,r){"use strict";var e=r(4);t.exports=function(t,n){return!!t&&e(function(){n?t.call(null,function(){},1):t.call(null)})}},function(t,n,r){r(35),t.exports=r(2).String.endsWith},function(t,n,r){"use strict";var e=r(7),o=r(12),i=r(36),u="".endsWith;e(e.P+e.F*r(38)("endsWith"),"String",{endsWith:function(t){var n=i(this,t,"endsWith"),r=arguments.length>1?arguments[1]:void 0,e=o(n.length),c=void 0===r?e:Math.min(o(r),e),f=String(t);return u?u.call(n,f,c):n.slice(c-f.length,c)===f}})},function(t,n,r){var e=r(37),o=r(11);t.exports=function(t,n,r){if(e(n))throw TypeError("String#"+r+" doesn't accept regex!");return String(o(t))}},function(t,n,r){var e=r(1),o=r(5),i=r(6)("match");t.exports=function(t){var n;return e(t)&&(void 0!==(n=t[i])?!!n:"RegExp"==o(t))}},function(t,n,r){var e=r(6)("match");t.exports=function(t){var n=/./;try{"/./"[t](n)}catch(r){try{return n[e]=!1,!"/./"[t](n)}catch(t){}}return!0}}]);

/***/ }),
/* 2379 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  rejected: {
    borderStyle: 'solid',
    borderColor: '#c66',
    backgroundColor: '#eee'
  },
  disabled: {
    opacity: 0.5
  },
  active: {
    borderStyle: 'solid',
    borderColor: '#6c6',
    backgroundColor: '#eee'
  },
  default: {
    width: 200,
    height: 200,
    borderWidth: 2,
    borderColor: '#666',
    borderStyle: 'dashed',
    borderRadius: 5
  }
});

/***/ }),
/* 2380 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_core_Button__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_core_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__material_ui_core_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_MobileStepper__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_MobileStepper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_MobileStepper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Grid_GridItem_jsx__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_graphql_tag__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_graphql_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_graphql_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_helpers_UserHelper__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_helpers_TaxCalculator__ = __webpack_require__(254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_apollo__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_reducers_NotificationReducer__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_redux_form__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_store__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__CC_bankDetail_jsx__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__CC_clientForm_jsx__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__CC_clientOccForm_jsx__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__CC_contactDetails_jsx__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__CC_healthInfo_jsx__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__CC_willDetail_jsx__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_queries_clientsByBroker__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_helpers_Documents_js__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_constants_js__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_apollo_client__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_apollo_cache_inmemory__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_apollo_upload_client__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_helpers_DateHelpers__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_lodash__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26_lodash__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(["\n  mutation clientCreate($input: ClientCreateInput!) {\n    ClientCreate(input: $input) {\n      clientMutationId\n      client {\n        id\n        scd_name\n        scd_surname\n        scd_email\n        date_created\n        scd_clientType\n        scd_registered\n        invite_sent\n        app_info_complete\n        status\n      }\n      clientId\n    }\n  }\n"],["\n  mutation clientCreate($input: ClientCreateInput!) {\n    ClientCreate(input: $input) {\n      clientMutationId\n      client {\n        id\n        scd_name\n        scd_surname\n        scd_email\n        date_created\n        scd_clientType\n        scd_registered\n        invite_sent\n        app_info_complete\n        status\n      }\n      clientId\n    }\n  }\n"]),_templateObject2=_taggedTemplateLiteral(["\n  mutation($file: Upload!, $id: String!) {\n    uploadClientAvatar(file: $file, id: $id)\n  }\n"],["\n  mutation($file: Upload!, $id: String!) {\n    uploadClientAvatar(file: $file, id: $id)\n  }\n"]);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}/*eslint-disable*/var uploadClient=new __WEBPACK_IMPORTED_MODULE_22_apollo_client__["ApolloClient"]({link:Object(__WEBPACK_IMPORTED_MODULE_24_apollo_upload_client__["a" /* createUploadLink */])({uri:__WEBPACK_IMPORTED_MODULE_21_constants_js__["d" /* fileUploadServerPath */]}),cache:new __WEBPACK_IMPORTED_MODULE_23_apollo_cache_inmemory__["a" /* InMemoryCache */]()});var form="client";var clientCreate=__WEBPACK_IMPORTED_MODULE_4_graphql_tag___default()(_templateObject);var uploadFileMutation=__WEBPACK_IMPORTED_MODULE_4_graphql_tag___default()(_templateObject2);var ClientForm=function(_Component){_inherits(ClientForm,_Component);function ClientForm(props){_classCallCheck(this,ClientForm);var _this=_possibleConstructorReturn(this,(ClientForm.__proto__||Object.getPrototypeOf(ClientForm)).call(this,props));_this.toggleOccupationValid=function(valid){_this.setState({occupationValid:valid});};_this.getBrokerId=function(){var brokerId=Object(__WEBPACK_IMPORTED_MODULE_5_helpers_UserHelper__["a" /* GetUserId */])();if(_this.checkAssistantActive()){brokerId=sessionStorage.getItem("ActiveBrokerId");}return brokerId;};_this.submit=function(){if(_this.state.page===2&&!_this.state.occupationValid){__WEBPACK_IMPORTED_MODULE_12_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_10_reducers_NotificationReducer__["d" /* showSnack */])({message:"Invalid Occupation",color:"danger"}));return;}if(__WEBPACK_IMPORTED_MODULE_12_store__["a" /* default */].getState().form[form].syncErrors){__WEBPACK_IMPORTED_MODULE_12_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_10_reducers_NotificationReducer__["d" /* showSnack */])({message:"Invalid Information",color:"danger"}));_this.setState({checkValidation:true});_this.forceUpdate();}else if(_this.checkOccupationDuties()){__WEBPACK_IMPORTED_MODULE_12_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_10_reducers_NotificationReducer__["d" /* showSnack */])({message:"Occupational Duties must add up to 100%",color:"danger"}));}else{_this.setState({checkValidation:false});var dat=__WEBPACK_IMPORTED_MODULE_12_store__["a" /* default */].getState().form[form].values;dat.calculatedMonthlyIncomeAT=_this.state.afterTaxIncome;dat.actualMonthlyIncomeAT=_this.state.afterTaxIncome;var input={data:dat,token:Object(__WEBPACK_IMPORTED_MODULE_5_helpers_UserHelper__["c" /* GetUserToken */])()};input.data["brokerId"]=_this.getBrokerId();_this.props.mutate({variables:{input:input}}).then(function(resp){var clientId=resp.data.ClientCreate.clientId;__WEBPACK_IMPORTED_MODULE_12_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_10_reducers_NotificationReducer__["e" /* successWarning */])({open:true,title:"Client Created.",onConfirm:function onConfirm(){return _this.props.history.push({pathname:"/app/ManageClients"});}}));if(_this.state.file!==null){uploadClient.mutate({mutation:uploadFileMutation,variables:{file:_this.state.file,id:clientId}}).then(console.log("profile picture updated"));}}).catch(function(error){if(error.toString().includes("invalid token")){Object(__WEBPACK_IMPORTED_MODULE_5_helpers_UserHelper__["d" /* Logout */])();_this.props.history.push({pathname:"/app/portal/login"});}__WEBPACK_IMPORTED_MODULE_12_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_10_reducers_NotificationReducer__["d" /* showSnack */])({message:"There was an error creating this new client : "+error,color:"danger"}));});}};_this.checkOccupationDuties=function(){var clientForm=__WEBPACK_IMPORTED_MODULE_12_store__["a" /* default */].getState().form[form].values;if(_this.state.page===2&&parseInt(clientForm.Admin)+parseInt(clientForm.Travel)+parseInt(clientForm.ManualLabour)+parseInt(clientForm.Supervision)!==100){return true;}return false;};_this.maritalChangeHandler=function(value){if(value==="Married"){_this.setState({married:true});if(__WEBPACK_IMPORTED_MODULE_12_store__["a" /* default */].getState().form.client.values.title==="MISS"){__WEBPACK_IMPORTED_MODULE_12_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_11_redux_form__["b" /* change */])("client","title","MRS"));}}else{if(value!=="validationError"){if(__WEBPACK_IMPORTED_MODULE_12_store__["a" /* default */].getState().form.client.values.title==="MRS"){__WEBPACK_IMPORTED_MODULE_12_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_11_redux_form__["b" /* change */])("client","title","MISS"));}}__WEBPACK_IMPORTED_MODULE_12_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_11_redux_form__["b" /* change */])("client","spouseIncome",""));_this.setState({married:false});}};_this.idChangeHandler=function(value){if(value==="idNumber"){if(!_this.state.saCitizen){_this.resetclientIdDetails();}_this.setState({saCitizen:true});}else{if(_this.state.saCitizen){_this.resetclientIdDetails();}_this.setState({saCitizen:false});}};_this.dobChanged=function(val){try{if(val.length!==10)throw"Too short";var dob=Object(__WEBPACK_IMPORTED_MODULE_25_helpers_DateHelpers__["b" /* ParseDMYwSlashes */])(val);var age=__WEBPACK_IMPORTED_MODULE_7_moment___default()().diff(dob,"years");__WEBPACK_IMPORTED_MODULE_12_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_11_redux_form__["b" /* change */])("client","age",age));}catch(error){__WEBPACK_IMPORTED_MODULE_12_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_11_redux_form__["b" /* change */])("client","age",""));}_this.forceUpdate();};_this.fileAttached=function(file){var valid=Object(__WEBPACK_IMPORTED_MODULE_20_helpers_Documents_js__["d" /* validateFile */])(file.name,__WEBPACK_IMPORTED_MODULE_20_helpers_Documents_js__["c" /* imageTypes */]);if(!valid){__WEBPACK_IMPORTED_MODULE_12_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_10_reducers_NotificationReducer__["d" /* showSnack */])({message:"Invalid file type.",color:"danger"}));}else{_this.setState({file:file,imgSrc:URL.createObjectURL(file)});}};_this.nextPage=_this.nextPage.bind(_this);_this.previousPage=_this.previousPage.bind(_this);_this.state={firstName:"",lastName:"",secondName:"",initials:"",page:0,pageCount:6,checkValidation:false,afterTaxIncome:"0",married:false,saCitizen:true,file:null,imgSrc:null,initialId:"",occupationValid:true};return _this;}_createClass(ClientForm,[{key:"componentDidMount",value:function componentDidMount(){this.props.initialize({Admin:"100",Travel:"0",ManualLabour:"0",Supervision:"0",idType:"idNumber"});}},{key:"componentWillUnmount",value:function componentWillUnmount(){__WEBPACK_IMPORTED_MODULE_12_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_11_redux_form__["f" /* reset */])("client"));__WEBPACK_IMPORTED_MODULE_12_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_10_reducers_NotificationReducer__["d" /* showSnack */])({open:false}));}},{key:"changeFirstName",value:function changeFirstName(name){if(name&&name!==""){var initials="";initials=name.substring(0,1).toUpperCase()+this.state.secondName.substring(0,1).toUpperCase();__WEBPACK_IMPORTED_MODULE_12_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_11_redux_form__["b" /* change */])("client","initials",initials));this.setState({firstName:name});}}},{key:"changeSecondName",value:function changeSecondName(name){if(name&&name!==""){var initials="";initials=this.state.firstName.substring(0,1).toUpperCase()+name.substring(0,1).toUpperCase();__WEBPACK_IMPORTED_MODULE_12_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_11_redux_form__["b" /* change */])("client","initials",initials));this.setState({secondName:name});}}},{key:"changeLastName",value:function changeLastName(name){this.setState({lastName:name});}},{key:"checkAssistantActive",value:function checkAssistantActive(){return Object(__WEBPACK_IMPORTED_MODULE_5_helpers_UserHelper__["b" /* GetUserKey */])("userType")==="6"?true:false;}},{key:"nextPage",value:function nextPage(){if(this.state.page===2&&!this.state.occupationValid){__WEBPACK_IMPORTED_MODULE_12_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_10_reducers_NotificationReducer__["d" /* showSnack */])({message:"Invalid Occupation",color:"danger"}));return;}if(this.checkOccupationDuties()){__WEBPACK_IMPORTED_MODULE_12_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_10_reducers_NotificationReducer__["d" /* showSnack */])({message:"Occupational Duties must add up to 100%.",color:"danger"}));}else{if(__WEBPACK_IMPORTED_MODULE_12_store__["a" /* default */].getState().form[form].syncErrors){__WEBPACK_IMPORTED_MODULE_12_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_10_reducers_NotificationReducer__["d" /* showSnack */])({message:"Invalid Information.",color:"danger"}));this.setState({checkValidation:true});this.forceUpdate();}else{this.setState({page:this.state.page+1,checkValidation:false});this.forceUpdate();}}}},{key:"previousPage",value:function previousPage(){if(this.state.page===2&&!this.state.occupationValid){__WEBPACK_IMPORTED_MODULE_12_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_10_reducers_NotificationReducer__["d" /* showSnack */])({message:"Invalid Occupation",color:"danger"}));return;}this.setState({page:this.state.page-1});}},{key:"onSalaryChange",value:function onSalaryChange(value){value=value.toString().replace(/,/g,"").replace(/ /g,"");if(value===""||isNaN(Number(value))){return;}var x=Object(__WEBPACK_IMPORTED_MODULE_6_helpers_TaxCalculator__["a" /* default */])(parseFloat(value),__WEBPACK_IMPORTED_MODULE_26_lodash___default.a.get(__WEBPACK_IMPORTED_MODULE_12_store__["a" /* default */].getState().form,"client.values.age",null));x=x.toString();//let parsed = parseFloat(val);
this.setState({afterTaxIncome:x.toString()});this.forceUpdate();if(__WEBPACK_IMPORTED_MODULE_12_store__["a" /* default */].getState().form.client.fields&&__WEBPACK_IMPORTED_MODULE_12_store__["a" /* default */].getState().form.client.fields.actualMonthlyIncomeAT&&__WEBPACK_IMPORTED_MODULE_12_store__["a" /* default */].getState().form.client.fields.actualMonthlyIncomeAT.touched){return;}else{__WEBPACK_IMPORTED_MODULE_12_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_11_redux_form__["b" /* change */])("client","actualMonthlyIncomeAT",x.toString()));__WEBPACK_IMPORTED_MODULE_12_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_11_redux_form__["h" /* untouch */])("client","actualMonthlyIncomeAT"));}}},{key:"resetclientIdDetails",value:function resetclientIdDetails(){__WEBPACK_IMPORTED_MODULE_12_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_11_redux_form__["b" /* change */])("client","said",""));__WEBPACK_IMPORTED_MODULE_12_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_11_redux_form__["h" /* untouch */])("client","said"));__WEBPACK_IMPORTED_MODULE_12_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_11_redux_form__["b" /* change */])("client","passportNumber",""));__WEBPACK_IMPORTED_MODULE_12_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_11_redux_form__["h" /* untouch */])("client","passportNumber"));}},{key:"withoutClasses",value:function withoutClasses(props){var newProps=Object.assign({},props);delete newProps.classes;return newProps;}},{key:"render",value:function render(){var _this2=this;var page=this.state.page;return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{container:true},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:10,style:{margin:"auto",width:"100%"}},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("div",{className:"fixedStepper"},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{container:true},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:10,style:{flexBasis:"100%",maxWidth:"100%",margin:'auto'}},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("div",{className:"stepperDiv"},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_MobileStepper___default.a,{type:"progress",steps:this.state.pageCount,position:"static",activeStep:this.state.page,nextButton:__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("div",{style:{display:"flex"}},this.state.page>1?__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core_Button___default.a,{variant:"outlined",className:"outlinedButton",color:"secondary",style:{marginRight:"10px"},onClick:function onClick(){return _this2.submit();}},"Submit"):__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("div",null),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core_Button___default.a,{variant:"outlined",className:"outlinedButton",color:"secondary",style:{marginRight:"10px"},onClick:function onClick(){return _this2.nextPage();},disabled:this.state.page===this.state.pageCount-1?true:false},"Next")),backButton:__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core_Button___default.a,{variant:"outlined",className:"outlinedButton",color:"secondary",style:{marginLeft:"10px"},onClick:function onClick(){return _this2.previousPage();},disabled:this.state.page===0?true:false},"Back")}))))),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("br",null),page===0&&__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__CC_clientForm_jsx__["a" /* default */],Object.assign({previousPage:this.previousPage,changeFirstName:this.changeFirstName.bind(this),changeLastName:this.changeLastName.bind(this),changeSecondName:this.changeSecondName.bind(this),idChangeHandler:this.idChangeHandler.bind(this),maritalChangeHandler:this.maritalChangeHandler.bind(this),fileAttached:this.fileAttached,dobChanged:this.dobChanged},this.withoutClasses(this.props),this.state)),page===1&&__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__CC_contactDetails_jsx__["a" /* default */],Object.assign({previousPage:this.previousPage,checkValidation:this.state.checkValidation},this.withoutClasses(this.props))),page===2&&__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__CC_clientOccForm_jsx__["a" /* default */],Object.assign({previousPage:this.previousPage,onSubmit:this.submit,salaryChangeHandler:this.onSalaryChange.bind(this),toggleOccupationValid:this.toggleOccupationValid},this.withoutClasses(this.props),this.state)),page===3&&__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__CC_bankDetail_jsx__["a" /* default */],Object.assign({previousPage:this.previousPage,onSubmit:this.submit},this.withoutClasses(this.props),this.state)),page===4&&__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__CC_healthInfo_jsx__["a" /* default */],Object.assign({previousPage:this.previousPage,onSubmit:this.submit},this.withoutClasses(this.props),this.state)),page===5&&__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__CC_willDetail_jsx__["a" /* default */],Object.assign({previousPage:this.previousPage,onSubmit:this.submit},this.withoutClasses(this.props),this.state))));}}]);return ClientForm;}(__WEBPACK_IMPORTED_MODULE_8_react__["Component"]);ClientForm=Object(__WEBPACK_IMPORTED_MODULE_11_redux_form__["e" /* reduxForm */])({form:form,destroyOnUnmount:true})(ClientForm);ClientForm=Object(__WEBPACK_IMPORTED_MODULE_9_react_apollo__["graphql"])(clientCreate,{options:{update:function update(proxy,_ref){var clientCreate=_ref.data.clientCreate;var _proxy$readQuery=proxy.readQuery({query:__WEBPACK_IMPORTED_MODULE_19_queries_clientsByBroker__["a" /* getClientsByBroker */]}),clients=_proxy$readQuery.clients;proxy.writeQuery({getClientsByBroker:__WEBPACK_IMPORTED_MODULE_19_queries_clientsByBroker__["a" /* getClientsByBroker */],data:clients.concat(clientCreate.client)});}}})(ClientForm);/* harmony default export */ __webpack_exports__["a"] = (ClientForm);

/***/ }),
/* 2381 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DefaultCalendar; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Calendar__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Calendar_withDateSelection__ = __webpack_require__(614);
/* unused harmony reexport Calendar */
/* unused harmony reexport withDateSelection */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Calendar_withKeyboardSupport__ = __webpack_require__(2413);
/* unused harmony reexport withKeyboardSupport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Calendar_withMultipleDates__ = __webpack_require__(2415);
/* unused harmony reexport withMultipleDates */
/* unused harmony reexport defaultMultipleDateInterpolation */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Calendar_withRange__ = __webpack_require__(2418);
/* unused harmony reexport withRange */
/* unused harmony reexport EVENT_TYPE */
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _class, _temp2;

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











/*
 * By default, Calendar is a controlled component.
 * Export a sensible default for minimal setup
 */
var DefaultCalendar = (_temp2 = _class = function (_Component) {
  _inherits(DefaultCalendar, _Component);

  function DefaultCalendar() {
    var _temp, _this, _ret;

    _classCallCheck(this, DefaultCalendar);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
      selected: typeof _this.props.selected !== 'undefined' ? _this.props.selected : new Date()
    }, _this.handleSelect = function (selected) {
      var _this$props = _this.props,
          onSelect = _this$props.onSelect,
          interpolateSelection = _this$props.interpolateSelection;


      if (typeof onSelect === 'function') {
        onSelect(selected);
      }

      _this.setState({ selected: interpolateSelection(selected, _this.state.selected) });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  DefaultCalendar.prototype.componentWillReceiveProps = function componentWillReceiveProps(_ref) {
    var selected = _ref.selected;

    if (selected !== this.props.selected) {
      this.setState({ selected: selected });
    }
  };

  DefaultCalendar.prototype.render = function render() {
    // eslint-disable-next-line no-unused-vars
    var _props = this.props,
        Component = _props.Component,
        interpolateSelection = _props.interpolateSelection,
        props = _objectWithoutProperties(_props, ['Component', 'interpolateSelection']);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component, _extends({}, props, {
      onSelect: this.handleSelect,
      selected: this.state.selected
    }));
  };

  return DefaultCalendar;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class.defaultProps = {
  Component: Object(__WEBPACK_IMPORTED_MODULE_2__Calendar_withDateSelection__["a" /* withDateSelection */])(__WEBPACK_IMPORTED_MODULE_1__Calendar__["a" /* default */]),
  interpolateSelection: function interpolateSelection(selected) {
    return selected;
  }
}, _temp2);


/***/ }),
/* 2382 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _createHelper = __webpack_require__(147);

var _createHelper2 = _interopRequireDefault(_createHelper);

var _createEagerFactory = __webpack_require__(190);

var _createEagerFactory2 = _interopRequireDefault(_createEagerFactory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultProps = function defaultProps(props) {
  return function (BaseComponent) {
    var factory = (0, _createEagerFactory2.default)(BaseComponent);
    var DefaultProps = function DefaultProps(ownerProps) {
      return factory(ownerProps);
    };
    DefaultProps.defaultProps = props;
    return DefaultProps;
  };
};

exports.default = (0, _createHelper2.default)(defaultProps, 'defaultProps');

/***/ }),
/* 2383 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createEagerElementUtil = function createEagerElementUtil(hasKey, isReferentiallyTransparent, type, props, children) {
  if (!hasKey && isReferentiallyTransparent) {
    if (children) {
      return type(_extends({}, props, { children: children }));
    }
    return type(props);
  }

  var Component = type;

  if (children) {
    return _react2.default.createElement(
      Component,
      props,
      children
    );
  }

  return _react2.default.createElement(Component, props);
};

exports.default = createEagerElementUtil;

/***/ }),
/* 2384 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _isClassComponent = __webpack_require__(2385);

var _isClassComponent2 = _interopRequireDefault(_isClassComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isReferentiallyTransparentFunctionComponent = function isReferentiallyTransparentFunctionComponent(Component) {
  return Boolean(typeof Component === 'function' && !(0, _isClassComponent2.default)(Component) && !Component.defaultProps && !Component.contextTypes && ("production" === 'production' || !Component.propTypes));
};

exports.default = isReferentiallyTransparentFunctionComponent;

/***/ }),
/* 2385 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var isClassComponent = function isClassComponent(Component) {
  return Boolean(Component && Component.prototype && typeof Component.prototype.isReactComponent === 'object');
};

exports.default = isClassComponent;

/***/ }),
/* 2386 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var pick = function pick(obj, keys) {
  var result = {};
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (obj.hasOwnProperty(key)) {
      result[key] = obj[key];
    }
  }
  return result;
};

exports.default = pick;

/***/ }),
/* 2387 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _shallowEqual = __webpack_require__(295);

var _shallowEqual2 = _interopRequireDefault(_shallowEqual);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _shallowEqual2.default;

/***/ }),
/* 2388 */
/***/ (function(module, exports) {

var MILLISECONDS_IN_MINUTE = 60000

/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */
module.exports = function getTimezoneOffsetInMilliseconds (dirtyDate) {
  var date = new Date(dirtyDate.getTime())
  var baseTimezoneOffset = date.getTimezoneOffset()
  date.setSeconds(0, 0)
  var millisecondsPartOfTimezoneOffset = date.getTime() % MILLISECONDS_IN_MINUTE

  return baseTimezoneOffset * MILLISECONDS_IN_MINUTE + millisecondsPartOfTimezoneOffset
}


/***/ }),
/* 2389 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = animate;
function easing(time) {
  return 1 - --time * time * time * time;
};

/**
 * Given a start/end point of a scroll and time elapsed, calculate the scroll position we should be at
 * @param {Number} start - the initial value
 * @param {Number} stop - the final desired value
 * @param {Number} elapsed - the amount of time elapsed since we started animating
 * @param {Number} - duration - the duration of the animation
 * @return {Number} - The value we should use on the next tick
 */
function getValue(start, end, elapsed, duration) {
  if (elapsed > duration) return end;
  return start + (end - start) * easing(elapsed / duration);
};

/**
 * Smoothly animate between two values
 * @param {Number} fromValue - the initial value
 * @param {Function} onUpdate - A function that is called on each tick
 * @param {Function} onComplete - A callback that is fired once the scroll animation ends
 * @param {Number} duration - the desired duration of the scroll animation
 */
function animate(_ref) {
  var fromValue = _ref.fromValue,
      toValue = _ref.toValue,
      onUpdate = _ref.onUpdate,
      onComplete = _ref.onComplete,
      _ref$duration = _ref.duration,
      duration = _ref$duration === undefined ? 600 : _ref$duration;

  var startTime = performance.now();

  var tick = function tick() {
    var elapsed = performance.now() - startTime;

    window.requestAnimationFrame(function () {
      return onUpdate(getValue(fromValue, toValue, elapsed, duration),
      // Callback
      elapsed <= duration ? tick : onComplete);
    });
  };

  tick();
};

/***/ }),
/* 2390 */
/***/ (function(module, exports) {

module.exports = {
  hideYearsOnSelect: true,
  layout: 'portrait',
  overscanMonthCount: 2,
  shouldHeaderAnimate: true,
  showHeader: true,
  showMonthsForYears: true,
  showOverlay: true,
  showTodayHelper: true,
  showWeekdays: true,
  todayHelperRowOffset: 4
};

/***/ }),
/* 2391 */
/***/ (function(module, exports) {

module.exports = {
  blank: 'Select a date...',
  headerFormat: 'ddd, MMM Do',
  todayLabel: {
    long: 'Today'
  },
  weekdays: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
  weekStartsOn: 0
};

/***/ }),
/* 2392 */
/***/ (function(module, exports) {

module.exports = {
  accentColor: '#448AFF',
  floatingNav: {
    background: 'rgba(56, 87, 138, 0.94)',
    chevron: '#FFA726',
    color: '#FFF'
  },
  headerColor: '#448AFF',
  selectionColor: '#559FFF',
  textColor: {
    active: '#FFF',
    default: '#333'
  },
  todayColor: '#FFA726',
  weekdayColor: '#559FFF'
};

/***/ }),
/* 2393 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DIRECTION_UP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DIRECTION_DOWN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Today; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var styles = {
  'root': 'Cal__Today__root',
  'show': 'Cal__Today__show',
  'chevron': 'Cal__Today__chevron',
  'chevronUp': 'Cal__Today__chevronUp',
  'chevronDown': 'Cal__Today__chevronDown'
};


var DIRECTION_UP = 1;
var DIRECTION_DOWN = -1;
var CHEVRON = 'M256,298.3L256,298.3L256,298.3l174.2-167.2c4.3-4.2,11.4-4.1,15.8,0.2l30.6,29.9c4.4,4.3,4.5,11.3,0.2,15.5L264.1,380.9 c-2.2,2.2-5.2,3.2-8.1,3c-3,0.1-5.9-0.9-8.1-3L35.2,176.7c-4.3-4.2-4.2-11.2,0.2-15.5L66,131.3c4.4-4.3,11.5-4.4,15.8-0.2L256,298.3 z';

var Today = function (_PureComponent) {
  _inherits(Today, _PureComponent);

  function Today() {
    var _temp, _this, _ret;

    _classCallCheck(this, Today);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _PureComponent.call.apply(_PureComponent, [this].concat(args))), _this), _this.scrollToToday = function () {
      var scrollToDate = _this.props.scrollToDate;


      scrollToDate(new Date(), -40, true);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Today.prototype.render = function render() {
    var _classNames;

    var _props = this.props,
        todayLabel = _props.todayLabel,
        show = _props.show,
        theme = _props.theme;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      {
        className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(styles.root, (_classNames = {}, _classNames[styles.show] = show, _classNames[styles.chevronUp] = show === DIRECTION_UP, _classNames[styles.chevronDown] = show === DIRECTION_DOWN, _classNames)),
        style: {
          backgroundColor: theme.floatingNav.background,
          color: theme.floatingNav.color
        },
        onClick: this.scrollToToday,
        ref: 'node'
      },
      todayLabel,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'svg',
        {
          className: styles.chevron,
          x: '0px',
          y: '0px',
          width: '14px',
          height: '14px',
          viewBox: '0 0 512 512'
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', {
          fill: theme.floatingNav.chevron || theme.floatingNav.color,
          d: CHEVRON
        })
      )
    );
  };

  return Today;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);


 false ? Today.propTypes = {
  scrollToDate: PropTypes.func,
  show: PropTypes.oneOfType([PropTypes.number, PropTypes.bool]),
  theme: PropTypes.object,
  todayLabel: PropTypes.string
} : void 0;

/***/ }),
/* 2394 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Header; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__defaultSelectionRenderer__ = __webpack_require__(385);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var styles = {
  'root': 'Cal__Header__root',
  'landscape': 'Cal__Header__landscape',
  'dateWrapper': 'Cal__Header__dateWrapper',
  'day': 'Cal__Header__day',
  'wrapper': 'Cal__Header__wrapper',
  'blank': 'Cal__Header__blank',
  'active': 'Cal__Header__active',
  'year': 'Cal__Header__year',
  'date': 'Cal__Header__date',
  'range': 'Cal__Header__range'
};
var Header = (_temp = _class = function (_PureComponent) {
  _inherits(Header, _PureComponent);

  function Header() {
    _classCallCheck(this, Header);

    return _possibleConstructorReturn(this, _PureComponent.apply(this, arguments));
  }

  Header.prototype.render = function render() {
    var _classNames;

    var _props = this.props,
        layout = _props.layout,
        blank = _props.locale.blank,
        selected = _props.selected,
        renderSelection = _props.renderSelection,
        theme = _props.theme;


    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      {
        className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()(styles.root, (_classNames = {}, _classNames[styles.landscape] = layout === 'landscape', _classNames)),
        style: {
          backgroundColor: theme.headerColor,
          color: theme.textColor.active
        }
      },
      selected && renderSelection(selected, this.props) || __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()(styles.wrapper, styles.blank) },
        blank
      )
    );
  };

  return Header;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]), _class.defaultProps = {
  onYearClick: __WEBPACK_IMPORTED_MODULE_2__utils__["d" /* emptyFn */],
  renderSelection: __WEBPACK_IMPORTED_MODULE_3__defaultSelectionRenderer__["a" /* default */]
}, _temp);

 false ? Header.propTypes = {
  dateFormat: PropTypes.string,
  display: PropTypes.string,
  layout: PropTypes.string,
  locale: PropTypes.object,
  onYearClick: PropTypes.func,
  selected: PropTypes.any,
  shouldAnimate: PropTypes.bool,
  theme: PropTypes.object
} : void 0;

/***/ }),
/* 2395 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _chainFunction = __webpack_require__(2396);

var _chainFunction2 = _interopRequireDefault(_chainFunction);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _warning = __webpack_require__(2397);

var _warning2 = _interopRequireDefault(_warning);

var _ChildMapping = __webpack_require__(2398);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  component: _propTypes2.default.any,
  childFactory: _propTypes2.default.func,
  children: _propTypes2.default.node
};

var defaultProps = {
  component: 'span',
  childFactory: function childFactory(child) {
    return child;
  }
};

var TransitionGroup = function (_React$Component) {
  _inherits(TransitionGroup, _React$Component);

  function TransitionGroup(props, context) {
    _classCallCheck(this, TransitionGroup);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));

    _this.performAppear = function (key, component) {
      _this.currentlyTransitioningKeys[key] = true;

      if (component.componentWillAppear) {
        component.componentWillAppear(_this._handleDoneAppearing.bind(_this, key, component));
      } else {
        _this._handleDoneAppearing(key, component);
      }
    };

    _this._handleDoneAppearing = function (key, component) {
      if (component.componentDidAppear) {
        component.componentDidAppear();
      }

      delete _this.currentlyTransitioningKeys[key];

      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);

      if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
        // This was removed before it had fully appeared. Remove it.
        _this.performLeave(key, component);
      }
    };

    _this.performEnter = function (key, component) {
      _this.currentlyTransitioningKeys[key] = true;

      if (component.componentWillEnter) {
        component.componentWillEnter(_this._handleDoneEntering.bind(_this, key, component));
      } else {
        _this._handleDoneEntering(key, component);
      }
    };

    _this._handleDoneEntering = function (key, component) {
      if (component.componentDidEnter) {
        component.componentDidEnter();
      }

      delete _this.currentlyTransitioningKeys[key];

      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);

      if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
        // This was removed before it had fully entered. Remove it.
        _this.performLeave(key, component);
      }
    };

    _this.performLeave = function (key, component) {
      _this.currentlyTransitioningKeys[key] = true;

      if (component.componentWillLeave) {
        component.componentWillLeave(_this._handleDoneLeaving.bind(_this, key, component));
      } else {
        // Note that this is somewhat dangerous b/c it calls setState()
        // again, effectively mutating the component before all the work
        // is done.
        _this._handleDoneLeaving(key, component);
      }
    };

    _this._handleDoneLeaving = function (key, component) {
      if (component.componentDidLeave) {
        component.componentDidLeave();
      }

      delete _this.currentlyTransitioningKeys[key];

      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);

      if (currentChildMapping && currentChildMapping.hasOwnProperty(key)) {
        // This entered again before it fully left. Add it again.
        _this.keysToEnter.push(key);
      } else {
        _this.setState(function (state) {
          var newChildren = _extends({}, state.children);
          delete newChildren[key];
          return { children: newChildren };
        });
      }
    };

    _this.childRefs = Object.create(null);

    _this.state = {
      children: (0, _ChildMapping.getChildMapping)(props.children)
    };
    return _this;
  }

  TransitionGroup.prototype.componentWillMount = function componentWillMount() {
    this.currentlyTransitioningKeys = {};
    this.keysToEnter = [];
    this.keysToLeave = [];
  };

  TransitionGroup.prototype.componentDidMount = function componentDidMount() {
    var initialChildMapping = this.state.children;
    for (var key in initialChildMapping) {
      if (initialChildMapping[key]) {
        this.performAppear(key, this.childRefs[key]);
      }
    }
  };

  TransitionGroup.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var nextChildMapping = (0, _ChildMapping.getChildMapping)(nextProps.children);
    var prevChildMapping = this.state.children;

    this.setState({
      children: (0, _ChildMapping.mergeChildMappings)(prevChildMapping, nextChildMapping)
    });

    for (var key in nextChildMapping) {
      var hasPrev = prevChildMapping && prevChildMapping.hasOwnProperty(key);
      if (nextChildMapping[key] && !hasPrev && !this.currentlyTransitioningKeys[key]) {
        this.keysToEnter.push(key);
      }
    }

    for (var _key in prevChildMapping) {
      var hasNext = nextChildMapping && nextChildMapping.hasOwnProperty(_key);
      if (prevChildMapping[_key] && !hasNext && !this.currentlyTransitioningKeys[_key]) {
        this.keysToLeave.push(_key);
      }
    }

    // If we want to someday check for reordering, we could do it here.
  };

  TransitionGroup.prototype.componentDidUpdate = function componentDidUpdate() {
    var _this2 = this;

    var keysToEnter = this.keysToEnter;
    this.keysToEnter = [];
    keysToEnter.forEach(function (key) {
      return _this2.performEnter(key, _this2.childRefs[key]);
    });

    var keysToLeave = this.keysToLeave;
    this.keysToLeave = [];
    keysToLeave.forEach(function (key) {
      return _this2.performLeave(key, _this2.childRefs[key]);
    });
  };

  TransitionGroup.prototype.render = function render() {
    var _this3 = this;

    // TODO: we could get rid of the need for the wrapper node
    // by cloning a single child
    var childrenToRender = [];

    var _loop = function _loop(key) {
      var child = _this3.state.children[key];
      if (child) {
        var isCallbackRef = typeof child.ref !== 'string';
        var factoryChild = _this3.props.childFactory(child);
        var ref = function ref(r) {
          _this3.childRefs[key] = r;
        };

         false ? (0, _warning2.default)(isCallbackRef, 'string refs are not supported on children of TransitionGroup and will be ignored. ' + 'Please use a callback ref instead: https://facebook.github.io/react/docs/refs-and-the-dom.html#the-ref-callback-attribute') : void 0;

        // Always chaining the refs leads to problems when the childFactory
        // wraps the child. The child ref callback gets called twice with the
        // wrapper and the child. So we only need to chain the ref if the
        // factoryChild is not different from child.
        if (factoryChild === child && isCallbackRef) {
          ref = (0, _chainFunction2.default)(child.ref, ref);
        }

        // You may need to apply reactive updates to a child as it is leaving.
        // The normal React way to do it won't work since the child will have
        // already been removed. In case you need this behavior you can provide
        // a childFactory function to wrap every child, even the ones that are
        // leaving.
        childrenToRender.push(_react2.default.cloneElement(factoryChild, {
          key: key,
          ref: ref
        }));
      }
    };

    for (var key in this.state.children) {
      _loop(key);
    }

    // Do not forward TransitionGroup props to primitive DOM nodes
    var props = _extends({}, this.props);
    delete props.transitionLeave;
    delete props.transitionName;
    delete props.transitionAppear;
    delete props.transitionEnter;
    delete props.childFactory;
    delete props.transitionLeaveTimeout;
    delete props.transitionEnterTimeout;
    delete props.transitionAppearTimeout;
    delete props.component;

    return _react2.default.createElement(this.props.component, props, childrenToRender);
  };

  return TransitionGroup;
}(_react2.default.Component);

TransitionGroup.displayName = 'TransitionGroup';


TransitionGroup.propTypes =  false ? propTypes : {};
TransitionGroup.defaultProps = defaultProps;

exports.default = TransitionGroup;
module.exports = exports['default'];

/***/ }),
/* 2396 */
/***/ (function(module, exports) {


module.exports = function chain(){
  var len = arguments.length
  var args = [];

  for (var i = 0; i < len; i++)
    args[i] = arguments[i]

  args = args.filter(function(fn){ return fn != null })

  if (args.length === 0) return undefined
  if (args.length === 1) return args[0]

  return args.reduce(function(current, next){
    return function chainedFunction() {
      current.apply(this, arguments);
      next.apply(this, arguments);
    };
  })
}


/***/ }),
/* 2397 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = function() {};

if (false) {
  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
        '`warning(condition, format, ...args)` requires a warning ' +
        'message argument'
      );
    }

    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
      throw new Error(
        'The warning format should be able to uniquely identify this ' +
        'warning. Please, use a more descriptive format than: ' + format
      );
    }

    if (!condition) {
      var argIndex = 0;
      var message = 'Warning: ' +
        format.replace(/%s/g, function() {
          return args[argIndex++];
        });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch(x) {}
    }
  };
}

module.exports = warning;


/***/ }),
/* 2398 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.getChildMapping = getChildMapping;
exports.mergeChildMappings = mergeChildMappings;

var _react = __webpack_require__(0);

/**
 * Given `this.props.children`, return an object mapping key to child.
 *
 * @param {*} children `this.props.children`
 * @return {object} Mapping of key to child
 */
function getChildMapping(children) {
  if (!children) {
    return children;
  }
  var result = {};
  _react.Children.map(children, function (child) {
    return child;
  }).forEach(function (child) {
    result[child.key] = child;
  });
  return result;
}

/**
 * When you're adding or removing children some may be added or removed in the
 * same render pass. We want to show *both* since we want to simultaneously
 * animate elements in and out. This function takes a previous set of keys
 * and a new set of keys and merges them with its best guess of the correct
 * ordering. In the future we may expose some of the utilities in
 * ReactMultiChild to make this easy, but for now React itself does not
 * directly have this concept of the union of prevChildren and nextChildren
 * so we implement it here.
 *
 * @param {object} prev prev children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @param {object} next next children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @return {object} a key set that contains all keys in `prev` and all keys
 * in `next` in a reasonable order.
 */
function mergeChildMappings(prev, next) {
  prev = prev || {};
  next = next || {};

  function getValueForKey(key) {
    if (next.hasOwnProperty(key)) {
      return next[key];
    }

    return prev[key];
  }

  // For each key of `next`, the list of keys to insert before that key in
  // the combined list
  var nextKeysPending = {};

  var pendingKeys = [];
  for (var prevKey in prev) {
    if (next.hasOwnProperty(prevKey)) {
      if (pendingKeys.length) {
        nextKeysPending[prevKey] = pendingKeys;
        pendingKeys = [];
      }
    } else {
      pendingKeys.push(prevKey);
    }
  }

  var i = void 0;
  var childMapping = {};
  for (var nextKey in next) {
    if (nextKeysPending.hasOwnProperty(nextKey)) {
      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
        var pendingNextKey = nextKeysPending[nextKey][i];
        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
      }
    }
    childMapping[nextKey] = getValueForKey(nextKey);
  }

  // Finally, add the keys which didn't appear before any key in `next`
  for (i = 0; i < pendingKeys.length; i++) {
    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
  }

  return childMapping;
}

/***/ }),
/* 2399 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _addClass = __webpack_require__(2400);

var _addClass2 = _interopRequireDefault(_addClass);

var _removeClass = __webpack_require__(2402);

var _removeClass2 = _interopRequireDefault(_removeClass);

var _requestAnimationFrame = __webpack_require__(2403);

var _requestAnimationFrame2 = _interopRequireDefault(_requestAnimationFrame);

var _properties = __webpack_require__(491);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(45);

var _PropTypes = __webpack_require__(608);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var events = [];
if (_properties.transitionEnd) events.push(_properties.transitionEnd);
if (_properties.animationEnd) events.push(_properties.animationEnd);

function addEndListener(node, listener) {
  if (events.length) {
    events.forEach(function (e) {
      return node.addEventListener(e, listener, false);
    });
  } else {
    setTimeout(listener, 0);
  }

  return function () {
    if (!events.length) return;
    events.forEach(function (e) {
      return node.removeEventListener(e, listener, false);
    });
  };
}

var propTypes = {
  children: _propTypes2.default.node,
  name: _PropTypes.nameShape.isRequired,

  // Once we require timeouts to be specified, we can remove the
  // boolean flags (appear etc.) and just accept a number
  // or a bool for the timeout flags (appearTimeout etc.)
  appear: _propTypes2.default.bool,
  enter: _propTypes2.default.bool,
  leave: _propTypes2.default.bool,
  appearTimeout: _propTypes2.default.number,
  enterTimeout: _propTypes2.default.number,
  leaveTimeout: _propTypes2.default.number
};

var CSSTransitionGroupChild = function (_React$Component) {
  _inherits(CSSTransitionGroupChild, _React$Component);

  function CSSTransitionGroupChild() {
    var _temp, _this, _ret;

    _classCallCheck(this, CSSTransitionGroupChild);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.componentWillAppear = function (done) {
      if (_this.props.appear) {
        _this.transition('appear', done, _this.props.appearTimeout);
      } else {
        done();
      }
    }, _this.componentWillEnter = function (done) {
      if (_this.props.enter) {
        _this.transition('enter', done, _this.props.enterTimeout);
      } else {
        done();
      }
    }, _this.componentWillLeave = function (done) {
      if (_this.props.leave) {
        _this.transition('leave', done, _this.props.leaveTimeout);
      } else {
        done();
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  CSSTransitionGroupChild.prototype.componentWillMount = function componentWillMount() {
    this.classNameAndNodeQueue = [];
    this.transitionTimeouts = [];
  };

  CSSTransitionGroupChild.prototype.componentWillUnmount = function componentWillUnmount() {
    this.unmounted = true;

    if (this.timeout) {
      clearTimeout(this.timeout);
    }
    this.transitionTimeouts.forEach(function (timeout) {
      clearTimeout(timeout);
    });

    this.classNameAndNodeQueue.length = 0;
  };

  CSSTransitionGroupChild.prototype.transition = function transition(animationType, finishCallback, timeout) {
    var node = (0, _reactDom.findDOMNode)(this);

    if (!node) {
      if (finishCallback) {
        finishCallback();
      }
      return;
    }

    var className = this.props.name[animationType] || this.props.name + '-' + animationType;
    var activeClassName = this.props.name[animationType + 'Active'] || className + '-active';
    var timer = null;
    var removeListeners = void 0;

    (0, _addClass2.default)(node, className);

    // Need to do this to actually trigger a transition.
    this.queueClassAndNode(activeClassName, node);

    // Clean-up the animation after the specified delay
    var finish = function finish(e) {
      if (e && e.target !== node) {
        return;
      }

      clearTimeout(timer);
      if (removeListeners) removeListeners();

      (0, _removeClass2.default)(node, className);
      (0, _removeClass2.default)(node, activeClassName);

      if (removeListeners) removeListeners();

      // Usually this optional callback is used for informing an owner of
      // a leave animation and telling it to remove the child.
      if (finishCallback) {
        finishCallback();
      }
    };

    if (timeout) {
      timer = setTimeout(finish, timeout);
      this.transitionTimeouts.push(timer);
    } else if (_properties.transitionEnd) {
      removeListeners = addEndListener(node, finish);
    }
  };

  CSSTransitionGroupChild.prototype.queueClassAndNode = function queueClassAndNode(className, node) {
    var _this2 = this;

    this.classNameAndNodeQueue.push({
      className: className,
      node: node
    });

    if (!this.rafHandle) {
      this.rafHandle = (0, _requestAnimationFrame2.default)(function () {
        return _this2.flushClassNameAndNodeQueue();
      });
    }
  };

  CSSTransitionGroupChild.prototype.flushClassNameAndNodeQueue = function flushClassNameAndNodeQueue() {
    if (!this.unmounted) {
      this.classNameAndNodeQueue.forEach(function (obj) {
        // This is for to force a repaint,
        // which is necessary in order to transition styles when adding a class name.
        /* eslint-disable no-unused-expressions */
        obj.node.scrollTop;
        /* eslint-enable no-unused-expressions */
        (0, _addClass2.default)(obj.node, obj.className);
      });
    }
    this.classNameAndNodeQueue.length = 0;
    this.rafHandle = null;
  };

  CSSTransitionGroupChild.prototype.render = function render() {
    var props = _extends({}, this.props);
    delete props.name;
    delete props.appear;
    delete props.enter;
    delete props.leave;
    delete props.appearTimeout;
    delete props.enterTimeout;
    delete props.leaveTimeout;
    delete props.children;
    return _react2.default.cloneElement(_react2.default.Children.only(this.props.children), props);
  };

  return CSSTransitionGroupChild;
}(_react2.default.Component);

CSSTransitionGroupChild.displayName = 'CSSTransitionGroupChild';


CSSTransitionGroupChild.propTypes =  false ? propTypes : {};

exports.default = CSSTransitionGroupChild;
module.exports = exports['default'];

/***/ }),
/* 2400 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(72);

exports.__esModule = true;
exports.default = addClass;

var _hasClass = _interopRequireDefault(__webpack_require__(2401));

function addClass(element, className) {
  if (element.classList) element.classList.add(className);else if (!(0, _hasClass.default)(element, className)) if (typeof element.className === 'string') element.className = element.className + ' ' + className;else element.setAttribute('class', (element.className && element.className.baseVal || '') + ' ' + className);
}

module.exports = exports["default"];

/***/ }),
/* 2401 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = hasClass;

function hasClass(element, className) {
  if (element.classList) return !!className && element.classList.contains(className);else return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}

module.exports = exports["default"];

/***/ }),
/* 2402 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function replaceClassName(origClass, classToRemove) {
  return origClass.replace(new RegExp('(^|\\s)' + classToRemove + '(?:\\s|$)', 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}

module.exports = function removeClass(element, className) {
  if (element.classList) element.classList.remove(className);else if (typeof element.className === 'string') element.className = replaceClassName(element.className, className);else element.setAttribute('class', replaceClassName(element.className && element.className.baseVal || '', className));
};

/***/ }),
/* 2403 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(72);

exports.__esModule = true;
exports.default = void 0;

var _inDOM = _interopRequireDefault(__webpack_require__(167));

var vendors = ['', 'webkit', 'moz', 'o', 'ms'];
var cancel = 'clearTimeout';
var raf = fallback;
var compatRaf;

var getKey = function getKey(vendor, k) {
  return vendor + (!vendor ? k : k[0].toUpperCase() + k.substr(1)) + 'AnimationFrame';
};

if (_inDOM.default) {
  vendors.some(function (vendor) {
    var rafKey = getKey(vendor, 'request');

    if (rafKey in window) {
      cancel = getKey(vendor, 'cancel');
      return raf = function raf(cb) {
        return window[rafKey](cb);
      };
    }
  });
}
/* https://github.com/component/raf */


var prev = new Date().getTime();

function fallback(fn) {
  var curr = new Date().getTime(),
      ms = Math.max(0, 16 - (curr - prev)),
      req = setTimeout(fn, ms);
  prev = curr;
  return req;
}

compatRaf = function compatRaf(cb) {
  return raf(cb);
};

compatRaf.cancel = function (id) {
  window[cancel] && typeof window[cancel] === 'function' && window[cancel](id);
};

var _default = compatRaf;
exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 2404 */
/***/ (function(module, exports) {

function buildDistanceInWordsLocale () {
  var distanceInWordsLocale = {
    lessThanXSeconds: {
      one: 'less than a second',
      other: 'less than {{count}} seconds'
    },

    xSeconds: {
      one: '1 second',
      other: '{{count}} seconds'
    },

    halfAMinute: 'half a minute',

    lessThanXMinutes: {
      one: 'less than a minute',
      other: 'less than {{count}} minutes'
    },

    xMinutes: {
      one: '1 minute',
      other: '{{count}} minutes'
    },

    aboutXHours: {
      one: 'about 1 hour',
      other: 'about {{count}} hours'
    },

    xHours: {
      one: '1 hour',
      other: '{{count}} hours'
    },

    xDays: {
      one: '1 day',
      other: '{{count}} days'
    },

    aboutXMonths: {
      one: 'about 1 month',
      other: 'about {{count}} months'
    },

    xMonths: {
      one: '1 month',
      other: '{{count}} months'
    },

    aboutXYears: {
      one: 'about 1 year',
      other: 'about {{count}} years'
    },

    xYears: {
      one: '1 year',
      other: '{{count}} years'
    },

    overXYears: {
      one: 'over 1 year',
      other: 'over {{count}} years'
    },

    almostXYears: {
      one: 'almost 1 year',
      other: 'almost {{count}} years'
    }
  }

  function localize (token, count, options) {
    options = options || {}

    var result
    if (typeof distanceInWordsLocale[token] === 'string') {
      result = distanceInWordsLocale[token]
    } else if (count === 1) {
      result = distanceInWordsLocale[token].one
    } else {
      result = distanceInWordsLocale[token].other.replace('{{count}}', count)
    }

    if (options.addSuffix) {
      if (options.comparison > 0) {
        return 'in ' + result
      } else {
        return result + ' ago'
      }
    }

    return result
  }

  return {
    localize: localize
  }
}

module.exports = buildDistanceInWordsLocale


/***/ }),
/* 2405 */
/***/ (function(module, exports, __webpack_require__) {

var buildFormattingTokensRegExp = __webpack_require__(2406)

function buildFormatLocale () {
  // Note: in English, the names of days of the week and months are capitalized.
  // If you are making a new locale based on this one, check if the same is true for the language you're working on.
  // Generally, formatted dates should look like they are in the middle of a sentence,
  // e.g. in Spanish language the weekdays and months should be in the lowercase.
  var months3char = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
  var monthsFull = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
  var weekdays2char = ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa']
  var weekdays3char = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']
  var weekdaysFull = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
  var meridiemUppercase = ['AM', 'PM']
  var meridiemLowercase = ['am', 'pm']
  var meridiemFull = ['a.m.', 'p.m.']

  var formatters = {
    // Month: Jan, Feb, ..., Dec
    'MMM': function (date) {
      return months3char[date.getMonth()]
    },

    // Month: January, February, ..., December
    'MMMM': function (date) {
      return monthsFull[date.getMonth()]
    },

    // Day of week: Su, Mo, ..., Sa
    'dd': function (date) {
      return weekdays2char[date.getDay()]
    },

    // Day of week: Sun, Mon, ..., Sat
    'ddd': function (date) {
      return weekdays3char[date.getDay()]
    },

    // Day of week: Sunday, Monday, ..., Saturday
    'dddd': function (date) {
      return weekdaysFull[date.getDay()]
    },

    // AM, PM
    'A': function (date) {
      return (date.getHours() / 12) >= 1 ? meridiemUppercase[1] : meridiemUppercase[0]
    },

    // am, pm
    'a': function (date) {
      return (date.getHours() / 12) >= 1 ? meridiemLowercase[1] : meridiemLowercase[0]
    },

    // a.m., p.m.
    'aa': function (date) {
      return (date.getHours() / 12) >= 1 ? meridiemFull[1] : meridiemFull[0]
    }
  }

  // Generate ordinal version of formatters: M -> Mo, D -> Do, etc.
  var ordinalFormatters = ['M', 'D', 'DDD', 'd', 'Q', 'W']
  ordinalFormatters.forEach(function (formatterToken) {
    formatters[formatterToken + 'o'] = function (date, formatters) {
      return ordinal(formatters[formatterToken](date))
    }
  })

  return {
    formatters: formatters,
    formattingTokensRegExp: buildFormattingTokensRegExp(formatters)
  }
}

function ordinal (number) {
  var rem100 = number % 100
  if (rem100 > 20 || rem100 < 10) {
    switch (rem100 % 10) {
      case 1:
        return number + 'st'
      case 2:
        return number + 'nd'
      case 3:
        return number + 'rd'
    }
  }
  return number + 'th'
}

module.exports = buildFormatLocale


/***/ }),
/* 2406 */
/***/ (function(module, exports) {

var commonFormatterKeys = [
  'M', 'MM', 'Q', 'D', 'DD', 'DDD', 'DDDD', 'd',
  'E', 'W', 'WW', 'YY', 'YYYY', 'GG', 'GGGG',
  'H', 'HH', 'h', 'hh', 'm', 'mm',
  's', 'ss', 'S', 'SS', 'SSS',
  'Z', 'ZZ', 'X', 'x'
]

function buildFormattingTokensRegExp (formatters) {
  var formatterKeys = []
  for (var key in formatters) {
    if (formatters.hasOwnProperty(key)) {
      formatterKeys.push(key)
    }
  }

  var formattingTokens = commonFormatterKeys
    .concat(formatterKeys)
    .sort()
    .reverse()
  var formattingTokensRegExp = new RegExp(
    '(\\[[^\\[]*\\])|(\\\\)?' + '(' + formattingTokens.join('|') + '|.)', 'g'
  )

  return formattingTokensRegExp
}

module.exports = buildFormattingTokensRegExp


/***/ }),
/* 2407 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MonthList; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_tiny_virtual_list__ = __webpack_require__(612);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_date_fns_parse__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_date_fns_parse___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_date_fns_parse__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_date_fns_start_of_month__ = __webpack_require__(613);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_date_fns_start_of_month___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_date_fns_start_of_month__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Month__ = __webpack_require__(2408);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var styles = {
  'root': 'Cal__MonthList__root',
  'scrolling': 'Cal__MonthList__scrolling'
};


var AVERAGE_ROWS_PER_MONTH = 5;

var MonthList = function (_Component) {
  _inherits(MonthList, _Component);

  function MonthList() {
    var _temp, _this, _ret;

    _classCallCheck(this, MonthList);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
      scrollTop: _this.getDateOffset(_this.props.scrollDate)
    }, _this.cache = {}, _this.memoize = function (param) {
      if (!this.cache[param]) {
        var weekStartsOn = this.props.locale.weekStartsOn;

        var _param$split = param.split(':'),
            year = _param$split[0],
            month = _param$split[1];

        var result = Object(__WEBPACK_IMPORTED_MODULE_4__utils__["f" /* getMonth */])(year, month, weekStartsOn);
        this.cache[param] = result;
      }
      return this.cache[param];
    }, _this.monthHeights = [], _this._getRef = function (instance) {
      _this.VirtualList = instance;
    }, _this.getMonthHeight = function (index) {
      if (!_this.monthHeights[index]) {
        var _this$props = _this.props,
            weekStartsOn = _this$props.locale.weekStartsOn,
            months = _this$props.months,
            rowHeight = _this$props.rowHeight;
        var _months$index = months[index],
            month = _months$index.month,
            year = _months$index.year;

        var weeks = Object(__WEBPACK_IMPORTED_MODULE_4__utils__["i" /* getWeeksInMonth */])(month, year, weekStartsOn, index === months.length - 1);
        var height = weeks * rowHeight;
        _this.monthHeights[index] = height;
      }

      return _this.monthHeights[index];
    }, _this.scrollToDate = function (date) {
      for (var _len2 = arguments.length, rest = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        rest[_key2 - 2] = arguments[_key2];
      }

      var _this2;

      var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      var offsetTop = _this.getDateOffset(date);
      (_this2 = _this).scrollTo.apply(_this2, [offsetTop + offset].concat(rest));
    }, _this.scrollTo = function () {
      var scrollTop = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var shouldAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var onScrollEnd = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : __WEBPACK_IMPORTED_MODULE_4__utils__["d" /* emptyFn */];

      var onComplete = function onComplete() {
        return setTimeout(function () {
          _this.scrollEl.style.overflowY = 'auto';
          onScrollEnd();
        });
      };

      // Interrupt iOS Momentum scroll
      _this.scrollEl.style.overflowY = 'hidden';

      if (shouldAnimate) {
        /* eslint-disable sort-keys */
        Object(__WEBPACK_IMPORTED_MODULE_4__utils__["b" /* animate */])({
          fromValue: _this.scrollEl.scrollTop,
          toValue: scrollTop,
          onUpdate: function onUpdate(scrollTop, callback) {
            return _this.setState({ scrollTop: scrollTop }, callback);
          },
          onComplete: onComplete
        });
      } else {
        window.requestAnimationFrame(function () {
          _this.scrollEl.scrollTop = scrollTop;
          onComplete();
        });
      }
    }, _this.renderMonth = function (_ref) {
      var index = _ref.index,
          style = _ref.style;
      var _this$props2 = _this.props,
          DayComponent = _this$props2.DayComponent,
          disabledDates = _this$props2.disabledDates,
          disabledDays = _this$props2.disabledDays,
          locale = _this$props2.locale,
          maxDate = _this$props2.maxDate,
          minDate = _this$props2.minDate,
          months = _this$props2.months,
          passThrough = _this$props2.passThrough,
          rowHeight = _this$props2.rowHeight,
          selected = _this$props2.selected,
          showOverlay = _this$props2.showOverlay,
          theme = _this$props2.theme,
          today = _this$props2.today;
      var _months$index2 = months[index],
          month = _months$index2.month,
          year = _months$index2.year;

      var key = year + ':' + month;

      var _this$memoize = _this.memoize(key),
          date = _this$memoize.date,
          rows = _this$memoize.rows;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Month__["a" /* default */], _extends({
        key: key,
        selected: selected,
        DayComponent: DayComponent,
        monthDate: date,
        disabledDates: disabledDates,
        disabledDays: disabledDays,
        maxDate: maxDate,
        minDate: minDate,
        rows: rows,
        rowHeight: rowHeight,
        isScrolling: false,
        showOverlay: showOverlay,
        today: today,
        theme: theme,
        style: style,
        locale: locale,
        passThrough: passThrough
      }, passThrough.Month));
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  MonthList.prototype.componentDidMount = function componentDidMount() {
    this.scrollEl = this.VirtualList.rootNode;
  };

  MonthList.prototype.componentWillReceiveProps = function componentWillReceiveProps(_ref2) {
    var scrollDate = _ref2.scrollDate;

    if (scrollDate !== this.props.scrollDate) {
      this.setState({
        scrollTop: this.getDateOffset(scrollDate)
      });
    }
  };

  MonthList.prototype.getDateOffset = function getDateOffset(date) {
    var _props = this.props,
        min = _props.min,
        rowHeight = _props.rowHeight,
        weekStartsOn = _props.locale.weekStartsOn,
        height = _props.height;

    var weeks = Object(__WEBPACK_IMPORTED_MODULE_4__utils__["h" /* getWeek */])(__WEBPACK_IMPORTED_MODULE_6_date_fns_start_of_month___default()(min), __WEBPACK_IMPORTED_MODULE_5_date_fns_parse___default()(date), weekStartsOn);

    return weeks * rowHeight - (height - rowHeight / 2) / 2;
  };

  MonthList.prototype.render = function render() {
    var _classNames;

    var _props2 = this.props,
        height = _props2.height,
        isScrolling = _props2.isScrolling,
        onScroll = _props2.onScroll,
        overscanMonthCount = _props2.overscanMonthCount,
        months = _props2.months,
        rowHeight = _props2.rowHeight,
        width = _props2.width;
    var scrollTop = this.state.scrollTop;


    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_tiny_virtual_list__["a" /* default */], {
      ref: this._getRef,
      width: width,
      height: height,
      itemCount: months.length,
      itemSize: this.getMonthHeight,
      estimatedItemSize: rowHeight * AVERAGE_ROWS_PER_MONTH,
      renderItem: this.renderMonth,
      onScroll: onScroll,
      scrollOffset: scrollTop,
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(styles.root, (_classNames = {}, _classNames[styles.scrolling] = isScrolling, _classNames)),
      style: { lineHeight: rowHeight + 'px' },
      overscanCount: overscanMonthCount
    });
  };

  return MonthList;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);


 false ? MonthList.propTypes = {
  disabledDates: PropTypes.arrayOf(PropTypes.string),
  disabledDays: PropTypes.arrayOf(PropTypes.number),
  height: PropTypes.number,
  isScrolling: PropTypes.bool,
  locale: PropTypes.object,
  maxDate: PropTypes.instanceOf(Date),
  min: PropTypes.instanceOf(Date),
  minDate: PropTypes.instanceOf(Date),
  months: PropTypes.arrayOf(PropTypes.object),
  onDaySelect: PropTypes.func,
  onScroll: PropTypes.func,
  overscanMonthCount: PropTypes.number,
  rowHeight: PropTypes.number,
  selectedDate: PropTypes.instanceOf(Date),
  showOverlay: PropTypes.bool,
  theme: PropTypes.object,
  today: PropTypes.instanceOf(Date),
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
} : void 0;

/***/ }),
/* 2408 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Month; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_date_fns_format__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_date_fns_format___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_date_fns_format__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_date_fns_get_day__ = __webpack_require__(384);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_date_fns_get_day___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_date_fns_get_day__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_date_fns_is_same_year__ = __webpack_require__(388);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_date_fns_is_same_year___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_date_fns_is_same_year__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var styles = {
  'rows': 'Cal__Month__rows',
  'row': 'Cal__Month__row',
  'partial': 'Cal__Month__partial',
  'label': 'Cal__Month__label',
  'partialFirstRow': 'Cal__Month__partialFirstRow'
};

var Month = function (_PureComponent) {
  _inherits(Month, _PureComponent);

  function Month() {
    _classCallCheck(this, Month);

    return _possibleConstructorReturn(this, _PureComponent.apply(this, arguments));
  }

  Month.prototype.renderRows = function renderRows() {
    var _props = this.props,
        DayComponent = _props.DayComponent,
        disabledDates = _props.disabledDates,
        disabledDays = _props.disabledDays,
        monthDate = _props.monthDate,
        locale = _props.locale,
        maxDate = _props.maxDate,
        minDate = _props.minDate,
        rowHeight = _props.rowHeight,
        rows = _props.rows,
        selected = _props.selected,
        today = _props.today,
        theme = _props.theme,
        passThrough = _props.passThrough;

    var currentYear = today.getFullYear();
    var year = monthDate.getFullYear();
    var month = monthDate.getMonth();
    var monthShort = __WEBPACK_IMPORTED_MODULE_3_date_fns_format___default()(monthDate, 'MMM', { locale: locale.locale });
    var monthRows = [];
    var day = 0;
    var isDisabled = false;
    var isToday = false;
    var date = void 0,
        days = void 0,
        dow = void 0,
        row = void 0;

    // Used for faster comparisons
    var _today = __WEBPACK_IMPORTED_MODULE_3_date_fns_format___default()(today, 'YYYY-MM-DD');
    var _minDate = __WEBPACK_IMPORTED_MODULE_3_date_fns_format___default()(minDate, 'YYYY-MM-DD');
    var _maxDate = __WEBPACK_IMPORTED_MODULE_3_date_fns_format___default()(maxDate, 'YYYY-MM-DD');

    // Oh the things we do in the name of performance...
    for (var i = 0, len = rows.length; i < len; i++) {
      var _classNames;

      row = rows[i];
      days = [];
      dow = __WEBPACK_IMPORTED_MODULE_4_date_fns_get_day___default()(new Date(year, month, row[0]));

      for (var k = 0, _len = row.length; k < _len; k++) {
        day = row[k];

        date = Object(__WEBPACK_IMPORTED_MODULE_2__utils__["e" /* getDateString */])(year, month, day);
        isToday = date === _today;

        isDisabled = minDate && date < _minDate || maxDate && date > _maxDate || disabledDays && disabledDays.length && disabledDays.indexOf(dow) !== -1 || disabledDates && disabledDates.length && disabledDates.indexOf(date) !== -1;

        days[k] = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DayComponent, _extends({
          key: 'day-' + day,
          currentYear: currentYear,
          date: date,
          day: day,
          selected: selected,
          isDisabled: isDisabled,
          isToday: isToday,
          locale: locale,
          month: month,
          monthShort: monthShort,
          theme: theme,
          year: year
        }, passThrough.Day));

        dow += 1;
      }
      monthRows[i] = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'ul',
        {
          key: 'Row-' + i,
          className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()(styles.row, (_classNames = {}, _classNames[styles.partial] = row.length !== 7, _classNames)),
          style: { height: rowHeight },
          role: 'row',
          'aria-label': 'Week ' + (i + 1)
        },
        days
      );
    }

    return monthRows;
  };

  Month.prototype.render = function render() {
    var _classNames2;

    var _props2 = this.props,
        locale = _props2.locale.locale,
        monthDate = _props2.monthDate,
        today = _props2.today,
        rows = _props2.rows,
        rowHeight = _props2.rowHeight,
        showOverlay = _props2.showOverlay,
        style = _props2.style,
        theme = _props2.theme;

    var dateFormat = __WEBPACK_IMPORTED_MODULE_5_date_fns_is_same_year___default()(monthDate, today) ? 'MMMM' : 'MMMM YYYY';

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: styles.root, style: _extends({}, style, { lineHeight: rowHeight + 'px' }) },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: styles.rows },
        this.renderRows(),
        showOverlay && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'label',
          {
            className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()(styles.label, (_classNames2 = {}, _classNames2[styles.partialFirstRow] = rows[0].length !== 7, _classNames2)),
            style: { backgroundColor: theme.overlayColor }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            null,
            __WEBPACK_IMPORTED_MODULE_3_date_fns_format___default()(monthDate, dateFormat, { locale: locale })
          )
        )
      )
    );
  };

  return Month;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);



/***/ }),
/* 2409 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Weekdays; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(61);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var styles = {
  'root': 'Cal__Weekdays__root',
  'day': 'Cal__Weekdays__day'
};

var Weekdays = function (_PureComponent) {
  _inherits(Weekdays, _PureComponent);

  function Weekdays() {
    _classCallCheck(this, Weekdays);

    return _possibleConstructorReturn(this, _PureComponent.apply(this, arguments));
  }

  Weekdays.prototype.render = function render() {
    var _props = this.props,
        weekdays = _props.weekdays,
        weekStartsOn = _props.weekStartsOn,
        theme = _props.theme;

    var orderedWeekdays = [].concat(weekdays.slice(weekStartsOn, 7), weekdays.slice(0, weekStartsOn));

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'ul',
      {
        className: styles.root,
        style: {
          backgroundColor: theme.weekdayColor,
          color: theme.textColor.active,
          paddingRight: __WEBPACK_IMPORTED_MODULE_2__utils__["m" /* scrollbarSize */]
        },
        'aria-hidden': true
      },
      orderedWeekdays.map(function (val, index) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'li',
          { key: 'Weekday-' + index, className: styles.day },
          val
        );
      })
    );
  };

  return Weekdays;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);


 false ? Weekdays.propTypes = {
  locale: PropTypes.object,
  theme: PropTypes.object
} : void 0;

/***/ }),
/* 2410 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Years; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_tiny_virtual_list__ = __webpack_require__(612);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_date_fns_format__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_date_fns_format___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_date_fns_format__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_date_fns_is_after__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_date_fns_is_after___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_date_fns_is_after__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_date_fns_is_before__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_date_fns_is_before___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_date_fns_is_before__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_date_fns_is_same_month__ = __webpack_require__(389);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_date_fns_is_same_month___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_date_fns_is_same_month__);
var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var styles = {
  'root': 'Cal__Years__root',
  'list': 'Cal__Years__list',
  'center': 'Cal__Years__center',
  'year': 'Cal__Years__year',
  'withMonths': 'Cal__Years__withMonths',
  'currentMonth': 'Cal__Years__currentMonth',
  'selected': 'Cal__Years__selected',
  'disabled': 'Cal__Years__disabled',
  'active': 'Cal__Years__active',
  'currentYear': 'Cal__Years__currentYear',
  'first': 'Cal__Years__first',
  'last': 'Cal__Years__last'
};


var SPACING = 40;

var Years = (_temp = _class = function (_Component) {
  _inherits(Years, _Component);

  function Years() {
    _classCallCheck(this, Years);

    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  Years.prototype.handleClick = function handleClick(date, e) {
    var _props = this.props,
        hideOnSelect = _props.hideOnSelect,
        onSelect = _props.onSelect,
        setDisplay = _props.setDisplay,
        scrollToDate = _props.scrollToDate;


    onSelect(date, e, function (date) {
      return scrollToDate(date);
    });

    if (hideOnSelect) {
      window.requestAnimationFrame(function () {
        return setDisplay('days');
      });
    }
  };

  Years.prototype.renderMonths = function renderMonths(year) {
    var _this2 = this;

    var _props2 = this.props,
        locale = _props2.locale.locale,
        selected = _props2.selected,
        theme = _props2.theme,
        today = _props2.today,
        min = _props2.min,
        max = _props2.max,
        minDate = _props2.minDate,
        maxDate = _props2.maxDate;

    var months = Object(__WEBPACK_IMPORTED_MODULE_4__utils__["g" /* getMonthsForYear */])(year, selected.getDate());

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'ol',
      null,
      months.map(function (date, index) {
        var _classNames;

        var isSelected = __WEBPACK_IMPORTED_MODULE_8_date_fns_is_same_month___default()(date, selected);
        var isCurrentMonth = __WEBPACK_IMPORTED_MODULE_8_date_fns_is_same_month___default()(date, today);
        var isDisabled = __WEBPACK_IMPORTED_MODULE_7_date_fns_is_before___default()(date, min) || __WEBPACK_IMPORTED_MODULE_7_date_fns_is_before___default()(date, minDate) || __WEBPACK_IMPORTED_MODULE_6_date_fns_is_after___default()(date, max) || __WEBPACK_IMPORTED_MODULE_6_date_fns_is_after___default()(date, maxDate);
        var style = Object.assign({}, isSelected && {
          backgroundColor: typeof theme.selectionColor === 'function' ? theme.selectionColor(date) : theme.selectionColor
        }, isCurrentMonth && {
          borderColor: theme.todayColor
        });

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'li',
          {
            key: index,
            onClick: function onClick(e) {
              e.stopPropagation();

              if (!isDisabled) {
                _this2.handleClick(date, e);
              }
            },
            className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(styles.month, (_classNames = {}, _classNames[styles.selected] = isSelected, _classNames[styles.currentMonth] = isCurrentMonth, _classNames[styles.disabled] = isDisabled, _classNames)),
            style: style,
            title: 'Set date to ' + __WEBPACK_IMPORTED_MODULE_5_date_fns_format___default()(date, 'MMMM Do, YYYY')
          },
          __WEBPACK_IMPORTED_MODULE_5_date_fns_format___default()(date, 'MMM', { locale: locale })
        );
      })
    );
  };

  Years.prototype.render = function render() {
    var _this3 = this;

    var _props3 = this.props,
        height = _props3.height,
        selected = _props3.selected,
        showMonths = _props3.showMonths,
        theme = _props3.theme,
        today = _props3.today,
        width = _props3.width;

    var currentYear = today.getFullYear();
    var years = this.props.years.slice(0, this.props.years.length);
    var selectedYearIndex = years.indexOf(selected.getFullYear());
    var rowHeight = showMonths ? 110 : 50;
    var heights = years.map(function (val, index) {
      return index === 0 || index === years.length - 1 ? rowHeight + SPACING : rowHeight;
    });
    var containerHeight = years.length * rowHeight < height + 50 ? years.length * rowHeight : height + 50;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      {
        className: styles.root,
        style: { color: theme.selectionColor, height: height + 50 }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_tiny_virtual_list__["a" /* default */], {
        ref: 'List',
        className: styles.list,
        width: width,
        height: containerHeight,
        itemCount: years.length,
        estimatedItemSize: rowHeight,
        itemSize: function itemSize(index) {
          return heights[index];
        },
        scrollToIndex: selectedYearIndex !== -1 ? selectedYearIndex : null,
        scrollToAlignment: 'center',
        renderItem: function renderItem(_ref) {
          var _classNames2;

          var index = _ref.index,
              style = _ref.style;

          var year = years[index];
          var isActive = index === selectedYearIndex;

          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            {
              key: index,
              className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(styles.year, (_classNames2 = {}, _classNames2[styles.active] = !showMonths && isActive, _classNames2[styles.currentYear] = !showMonths && year === currentYear, _classNames2[styles.withMonths] = showMonths, _classNames2[styles.first] = index === 0, _classNames2[styles.last] = index === years.length - 1, _classNames2)),
              onClick: function onClick() {
                return _this3.handleClick(new Date(selected).setYear(year));
              },
              title: 'Set year to ' + year,
              'data-year': year,
              style: Object.assign({}, style, {
                color: typeof theme.selectionColor === 'function' ? theme.selectionColor(new Date(year, 0, 1)) : theme.selectionColor
              })
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'label',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                {
                  style: !showMonths && year === currentYear ? { borderColor: theme.todayColor } : null
                },
                year
              )
            ),
            showMonths && _this3.renderMonths(year)
          );
        }
      })
    );
  };

  return Years;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class.defaultProps = {
  onSelect: __WEBPACK_IMPORTED_MODULE_4__utils__["d" /* emptyFn */],
  showMonths: true
}, _temp);

 false ? Years.propTypes = {
  height: PropTypes.number,
  hideOnSelect: PropTypes.bool,
  locale: PropTypes.object,
  max: PropTypes.object,
  maxDate: PropTypes.object,
  min: PropTypes.object,
  minDate: PropTypes.object,
  onSelect: PropTypes.func,
  scrollToDate: PropTypes.func,
  selectedYear: PropTypes.number,
  setDisplay: PropTypes.func,
  theme: PropTypes.object,
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  years: PropTypes.array
} : void 0;

/***/ }),
/* 2411 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Day; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_date_fns_parse__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_date_fns_parse___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_date_fns_parse__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var styles = {
  'root': 'Cal__Day__root',
  'enabled': 'Cal__Day__enabled',
  'highlighted': 'Cal__Day__highlighted',
  'today': 'Cal__Day__today',
  'disabled': 'Cal__Day__disabled',
  'selected': 'Cal__Day__selected',
  'month': 'Cal__Day__month',
  'year': 'Cal__Day__year',
  'selection': 'Cal__Day__selection',
  'day': 'Cal__Day__day',
  'range': 'Cal__Day__range',
  'start': 'Cal__Day__start',
  'end': 'Cal__Day__end',
  'betweenRange': 'Cal__Day__betweenRange'
};

var Day = function (_PureComponent) {
  _inherits(Day, _PureComponent);

  function Day() {
    var _temp, _this, _ret;

    _classCallCheck(this, Day);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _PureComponent.call.apply(_PureComponent, [this].concat(args))), _this), _this.handleClick = function () {
      var _this$props = _this.props,
          date = _this$props.date,
          isDisabled = _this$props.isDisabled,
          onClick = _this$props.onClick;


      if (!isDisabled && typeof onClick === 'function') {
        onClick(__WEBPACK_IMPORTED_MODULE_2_date_fns_parse___default()(date));
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Day.prototype.renderSelection = function renderSelection(selectionColor) {
    var _props = this.props,
        day = _props.day,
        date = _props.date,
        isToday = _props.isToday,
        todayLabel = _props.locale.todayLabel,
        monthShort = _props.monthShort,
        textColor = _props.theme.textColor,
        selectionStyle = _props.selectionStyle;


    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      {
        className: styles.selection,
        'data-date': date,
        style: _extends({
          backgroundColor: this.selectionColor,
          color: textColor.active
        }, selectionStyle)
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        { className: styles.month },
        isToday ? todayLabel.short || todayLabel.long : monthShort
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        { className: styles.day },
        day
      )
    );
  };

  Day.prototype.render = function render() {
    var _classNames;

    var _props2 = this.props,
        className = _props2.className,
        currentYear = _props2.currentYear,
        date = _props2.date,
        day = _props2.day,
        handlers = _props2.handlers,
        isDisabled = _props2.isDisabled,
        isHighlighted = _props2.isHighlighted,
        isToday = _props2.isToday,
        isSelected = _props2.isSelected,
        monthShort = _props2.monthShort,
        _props2$theme = _props2.theme,
        selectionColor = _props2$theme.selectionColor,
        todayColor = _props2$theme.todayColor,
        year = _props2.year;

    var color = void 0;

    if (isSelected) {
      color = this.selectionColor = typeof selectionColor === 'function' ? selectionColor(date) : selectionColor;
    } else if (isToday) {
      color = todayColor;
    }

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'li',
      _extends({
        style: color ? { color: color } : null,
        className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()(styles.root, (_classNames = {}, _classNames[styles.today] = isToday, _classNames[styles.highlighted] = isHighlighted, _classNames[styles.selected] = isSelected, _classNames[styles.disabled] = isDisabled, _classNames[styles.enabled] = !isDisabled, _classNames), className),
        onClick: this.handleClick,
        'data-date': date
      }, handlers),
      day === 1 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        { className: styles.month },
        monthShort
      ),
      isToday ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        null,
        day
      ) : day,
      day === 1 && currentYear !== year && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        { className: styles.year },
        year
      ),
      isSelected && this.renderSelection()
    );
  };

  return Day;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);



/***/ }),
/* 2412 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _createHelper = __webpack_require__(147);

var _createHelper2 = _interopRequireDefault(_createHelper);

var _createEagerFactory = __webpack_require__(190);

var _createEagerFactory2 = _interopRequireDefault(_createEagerFactory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapProps = function mapProps(propsMapper) {
  return function (BaseComponent) {
    var factory = (0, _createEagerFactory2.default)(BaseComponent);
    return function (props) {
      return factory(propsMapper(props));
    };
  };
};

exports.default = (0, _createHelper2.default)(mapProps, 'mapProps');

/***/ }),
/* 2413 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export withKeyboardSupport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_recompose_withState__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_recompose_withState___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_recompose_withState__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_recompose_withProps__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_recompose_withProps___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_recompose_withProps__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_recompose_withHandlers__ = __webpack_require__(2414);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_recompose_withHandlers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_recompose_withHandlers__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_recompose_compose__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_recompose_compose___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_recompose_compose__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_date_fns_add_days__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_date_fns_add_days___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_date_fns_add_days__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_date_fns_format__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_date_fns_format___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_date_fns_format__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_date_fns_is_after__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_date_fns_is_after___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_date_fns_is_after__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_date_fns_is_before__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_date_fns_is_before___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_date_fns_is_before__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils__ = __webpack_require__(61);





var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };







var enhanceDay = __WEBPACK_IMPORTED_MODULE_1_recompose_withProps___default()(function (props) {
  return {
    isHighlighted: props.highlightedDate === props.date
  };
});

var withKeyboardSupport = __WEBPACK_IMPORTED_MODULE_3_recompose_compose___default()(__WEBPACK_IMPORTED_MODULE_0_recompose_withState___default()('highlightedDate', 'setHighlight'), Object(__WEBPACK_IMPORTED_MODULE_8__utils__["n" /* withImmutableProps */])(function (_ref) {
  var DayComponent = _ref.DayComponent;
  return {
    DayComponent: enhanceDay(DayComponent)
  };
}), __WEBPACK_IMPORTED_MODULE_2_recompose_withHandlers___default()({
  onKeyDown: function onKeyDown(props) {
    return function (e) {
      return handleKeyDown(e, props);
    };
  }
}), __WEBPACK_IMPORTED_MODULE_1_recompose_withProps___default()(function (_ref2) {
  var highlightedDate = _ref2.highlightedDate,
      onKeyDown = _ref2.onKeyDown,
      onSelect = _ref2.onSelect,
      passThrough = _ref2.passThrough,
      setHighlight = _ref2.setHighlight;
  return {
    passThrough: _extends({}, passThrough, {
      Day: _extends({}, passThrough.Day, {
        highlightedDate: __WEBPACK_IMPORTED_MODULE_5_date_fns_format___default()(highlightedDate, 'YYYY-MM-DD'),
        onClick: function onClick(date) {
          setHighlight(null);
          passThrough.Day.onClick(date);
        }
      }),
      rootNode: { onKeyDown: onKeyDown }
    })
  };
}));

function handleKeyDown(e, props) {
  var minDate = props.minDate,
      maxDate = props.maxDate,
      onClick = props.passThrough.Day.onClick,
      setScrollDate = props.setScrollDate,
      setHighlight = props.setHighlight;

  var highlightedDate = getInitialDate(props);
  var delta = 0;

  if ([__WEBPACK_IMPORTED_MODULE_8__utils__["j" /* keyCodes */].left, __WEBPACK_IMPORTED_MODULE_8__utils__["j" /* keyCodes */].up, __WEBPACK_IMPORTED_MODULE_8__utils__["j" /* keyCodes */].right, __WEBPACK_IMPORTED_MODULE_8__utils__["j" /* keyCodes */].down].indexOf(e.keyCode) > -1 && typeof e.preventDefault === 'function') {
    e.preventDefault();
  }

  switch (e.keyCode) {
    case __WEBPACK_IMPORTED_MODULE_8__utils__["j" /* keyCodes */].enter:
      onClick && onClick(highlightedDate);
      return;
    case __WEBPACK_IMPORTED_MODULE_8__utils__["j" /* keyCodes */].left:
      delta = -1;
      break;
    case __WEBPACK_IMPORTED_MODULE_8__utils__["j" /* keyCodes */].right:
      delta = +1;
      break;
    case __WEBPACK_IMPORTED_MODULE_8__utils__["j" /* keyCodes */].down:
      delta = +7;
      break;
    case __WEBPACK_IMPORTED_MODULE_8__utils__["j" /* keyCodes */].up:
      delta = -7;
      break;
    default:
      delta = 0;
  }

  if (delta) {
    var newHighlightedDate = __WEBPACK_IMPORTED_MODULE_4_date_fns_add_days___default()(highlightedDate, delta);

    // Make sure the new highlighted date isn't before min / max
    if (__WEBPACK_IMPORTED_MODULE_7_date_fns_is_before___default()(newHighlightedDate, minDate)) {
      newHighlightedDate = new Date(minDate);
    } else if (__WEBPACK_IMPORTED_MODULE_6_date_fns_is_after___default()(newHighlightedDate, maxDate)) {
      newHighlightedDate = new Date(maxDate);
    }

    setScrollDate(newHighlightedDate);
    setHighlight(newHighlightedDate);
  }
}

function getInitialDate(_ref3) {
  var highlightedDate = _ref3.highlightedDate,
      selected = _ref3.selected,
      displayDate = _ref3.displayDate;

  return highlightedDate || selected.start || displayDate || selected || new Date();
}

/***/ }),
/* 2414 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _createEagerFactory = __webpack_require__(190);

var _createEagerFactory2 = _interopRequireDefault(_createEagerFactory);

var _createHelper = __webpack_require__(147);

var _createHelper2 = _interopRequireDefault(_createHelper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var mapValues = function mapValues(obj, func) {
  var result = {};
  /* eslint-disable no-restricted-syntax */
  for (var key in obj) {
    if (obj.hasOwnProperty(key)) {
      result[key] = func(obj[key], key);
    }
  }
  /* eslint-enable no-restricted-syntax */
  return result;
};

var withHandlers = function withHandlers(handlers) {
  return function (BaseComponent) {
    var _class, _temp2, _initialiseProps;

    var factory = (0, _createEagerFactory2.default)(BaseComponent);
    return _temp2 = _class = function (_Component) {
      _inherits(_class, _Component);

      function _class() {
        var _temp, _this, _ret;

        _classCallCheck(this, _class);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _initialiseProps.call(_this), _temp), _possibleConstructorReturn(_this, _ret);
      }

      _class.prototype.componentWillReceiveProps = function componentWillReceiveProps() {
        this.cachedHandlers = {};
      };

      _class.prototype.render = function render() {
        return factory(_extends({}, this.props, this.handlers));
      };

      return _class;
    }(_react.Component), _initialiseProps = function _initialiseProps() {
      var _this2 = this;

      this.cachedHandlers = {};
      this.handlers = mapValues(typeof handlers === 'function' ? handlers(this.props) : handlers, function (createHandler, handlerName) {
        return function () {
          var cachedHandler = _this2.cachedHandlers[handlerName];
          if (cachedHandler) {
            return cachedHandler.apply(undefined, arguments);
          }

          var handler = createHandler(_this2.props);
          _this2.cachedHandlers[handlerName] = handler;

          if (false) {
            console.error( // eslint-disable-line no-console
            'withHandlers(): Expected a map of higher-order functions. ' + 'Refer to the docs for more info.');
          }

          return handler.apply(undefined, arguments);
        };
      });
    }, _temp2;
  };
};

exports.default = (0, _createHelper2.default)(withHandlers, 'withHandlers');

/***/ }),
/* 2415 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export enhanceDay */
/* unused harmony export withMultipleDates */
/* unused harmony export defaultMultipleDateInterpolation */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_recompose_withState__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_recompose_withState___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_recompose_withState__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_recompose_withPropsOnChange__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_recompose_withPropsOnChange___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_recompose_withPropsOnChange__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_recompose_withProps__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_recompose_withProps___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_recompose_withProps__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_recompose_compose__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_recompose_compose___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_recompose_compose__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4____ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Header_withMultipleDates__ = __webpack_require__(2416);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_date_fns_format__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_date_fns_format___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_date_fns_format__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_date_fns_parse__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_date_fns_parse___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_date_fns_parse__);





function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }







// Enhance Day component to display selected state based on an array of selected dates
var enhanceDay = __WEBPACK_IMPORTED_MODULE_1_recompose_withPropsOnChange___default()(['selected'], function (props) {
  return {
    isSelected: props.selected.indexOf(props.date) !== -1
  };
});

// Enhance year component
var enhanceYears = __WEBPACK_IMPORTED_MODULE_2_recompose_withProps___default()(function (_ref) {
  var displayDate = _ref.displayDate;
  return {
    selected: displayDate ? __WEBPACK_IMPORTED_MODULE_8_date_fns_parse___default()(displayDate) : null
  };
});

// Enhancer to handle selecting and displaying multiple dates
var withMultipleDates = __WEBPACK_IMPORTED_MODULE_3_recompose_compose___default()(__WEBPACK_IMPORTED_MODULE_4____["b" /* withDefaultProps */], __WEBPACK_IMPORTED_MODULE_0_recompose_withState___default()('scrollDate', 'setScrollDate', getInitialDate), __WEBPACK_IMPORTED_MODULE_0_recompose_withState___default()('displayDate', 'setDisplayDate', getInitialDate), Object(__WEBPACK_IMPORTED_MODULE_5__utils__["n" /* withImmutableProps */])(function (_ref2) {
  var DayComponent = _ref2.DayComponent,
      HeaderComponent = _ref2.HeaderComponent,
      YearsComponent = _ref2.YearsComponent;
  return {
    DayComponent: enhanceDay(DayComponent),
    HeaderComponent: Object(__WEBPACK_IMPORTED_MODULE_6__Header_withMultipleDates__["a" /* default */])(HeaderComponent),
    YearsComponent: enhanceYears(YearsComponent)
  };
}), __WEBPACK_IMPORTED_MODULE_2_recompose_withProps___default()(function (_ref3) {
  var displayDate = _ref3.displayDate,
      onSelect = _ref3.onSelect,
      setDisplayDate = _ref3.setDisplayDate,
      scrollToDate = _ref3.scrollToDate,
      props = _objectWithoutProperties(_ref3, ['displayDate', 'onSelect', 'setDisplayDate', 'scrollToDate']);

  return {
    passThrough: {
      Day: {
        onClick: function onClick(date) {
          return handleSelect(date, { onSelect: onSelect, setDisplayDate: setDisplayDate });
        }
      },
      Header: {
        setDisplayDate: setDisplayDate
      },
      Years: {
        displayDate: displayDate,
        onSelect: function onSelect(year, e, callback) {
          return handleYearSelect(year, callback);
        },
        selected: displayDate
      }
    },
    selected: props.selected.filter(function (date) {
      return Object(__WEBPACK_IMPORTED_MODULE_5__utils__["l" /* sanitizeDate */])(date, props);
    }).map(function (date) {
      return __WEBPACK_IMPORTED_MODULE_7_date_fns_format___default()(date, 'YYYY-MM-DD');
    })
  };
}));


function handleSelect(date, _ref4) {
  var onSelect = _ref4.onSelect,
      setDisplayDate = _ref4.setDisplayDate;

  onSelect(date);
  setDisplayDate(date);
}

function handleYearSelect(date, callback) {
  callback(__WEBPACK_IMPORTED_MODULE_8_date_fns_parse___default()(date));
}

function getInitialDate(_ref5) {
  var selected = _ref5.selected;

  return selected.length ? selected[0] : new Date();
}

function defaultMultipleDateInterpolation(date, selected) {
  var selectedMap = selected.map(function (date) {
    return __WEBPACK_IMPORTED_MODULE_7_date_fns_format___default()(date, 'YYYY-MM-DD');
  });
  var index = selectedMap.indexOf(__WEBPACK_IMPORTED_MODULE_7_date_fns_format___default()(date, 'YYYY-MM-DD'));

  return index === -1 ? [].concat(selected, [date]) : [].concat(selected.slice(0, index), selected.slice(index + 1));
}

/***/ }),
/* 2416 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__defaultSelectionRenderer__ = __webpack_require__(385);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Slider__ = __webpack_require__(2417);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_date_fns_parse__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_date_fns_parse___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_date_fns_parse__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_date_fns_format__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_date_fns_format___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_date_fns_format__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }








/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__utils__["n" /* withImmutableProps */])(function (_ref) {
  var renderSelection = _ref.renderSelection,
      setDisplayDate = _ref.setDisplayDate;
  return {
    renderSelection: function renderSelection(values, _ref2) {
      var scrollToDate = _ref2.scrollToDate,
          displayDate = _ref2.displayDate,
          props = _objectWithoutProperties(_ref2, ['scrollToDate', 'displayDate']);

      if (!values.length) {
        return null;
      }

      var dates = values.sort();
      var index = values.indexOf(__WEBPACK_IMPORTED_MODULE_5_date_fns_format___default()(__WEBPACK_IMPORTED_MODULE_4_date_fns_parse___default()(displayDate), 'YYYY-MM-DD'));

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3__Slider__["a" /* default */],
        {
          index: index !== -1 ? index : dates.length - 1,
          onChange: function onChange(index) {
            return setDisplayDate(dates[index], function () {
              return setTimeout(function () {
                return scrollToDate(dates[index], 0, true);
              }, 50);
            });
          }
        },
        dates.map(function (value) {
          return Object(__WEBPACK_IMPORTED_MODULE_2__defaultSelectionRenderer__["a" /* default */])(value, _extends({}, props, {
            key: index,
            scrollToDate: scrollToDate,
            shouldAnimate: false
          }));
        })
      );
    }
  };
}));

/***/ }),
/* 2417 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Slider; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_transition_group_CSSTransitionGroup__ = __webpack_require__(607);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_transition_group_CSSTransitionGroup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_transition_group_CSSTransitionGroup__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var styles = {
  'root': 'Cal__Slider__root',
  'slide': 'Cal__Slider__slide',
  'wrapper': 'Cal__Slider__wrapper',
  'arrow': 'Cal__Slider__arrow',
  'arrowRight': 'Cal__Slider__arrowRight',
  'arrowLeft': 'Cal__Slider__arrowLeft'
};
var transition = {
  'enter': 'Cal__transition__enter',
  'enterActive': 'Cal__transition__enterActive',
  'leave': 'Cal__transition__leave',
  'leaveActive': 'Cal__transition__leaveActive'
};


var DIRECTIONS = {
  LEFT: 0,
  RIGHT: 1
};

var Arrow = function Arrow(_ref) {
  var _classNames;

  var direction = _ref.direction,
      _onClick = _ref.onClick;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    {
      className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(styles.arrow, (_classNames = {}, _classNames[styles.arrowLeft] = direction === DIRECTIONS.LEFT, _classNames[styles.arrowRight] = direction === DIRECTIONS.RIGHT, _classNames)),
      onClick: function onClick() {
        return _onClick(direction);
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'svg',
      {
        x: '0px',
        y: '0px',
        viewBox: '0 0 26 46'
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { d: 'M31.232233,34.767767 C32.2085438,35.7440777 33.7914562,35.7440777 34.767767,34.767767 C35.7440777,33.7914562 35.7440777,32.2085438 34.767767,31.232233 L14.767767,11.232233 C13.7914562,10.2559223 12.2085438,10.2559223 11.232233,11.232233 L-8.767767,31.232233 C-9.7440777,32.2085438 -9.7440777,33.7914562 -8.767767,34.767767 C-7.7914562,35.7440777 -6.2085438,35.7440777 -5.232233,34.767767 L12.9997921,16.5357418 L31.232233,34.767767 Z', id: 'Shape', fill: '#FFF', transform: 'translate(13.000000, 23.000000) rotate(90.000000) translate(-13.000000, -23.000000) ' })
    )
  );
};

var Slider = function (_PureComponent) {
  _inherits(Slider, _PureComponent);

  function Slider() {
    var _temp, _this, _ret;

    _classCallCheck(this, Slider);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _PureComponent.call.apply(_PureComponent, [this].concat(args))), _this), _this.handleClick = function (direction) {
      var _this$props = _this.props,
          children = _this$props.children,
          index = _this$props.index,
          onChange = _this$props.onChange;


      switch (direction) {
        case DIRECTIONS.LEFT:
          index = Math.max(0, index - 1);
          break;
        case DIRECTIONS.RIGHT:
          index = Math.min(index + 1, children.length);
          break;
        default:
          return;
      }

      onChange(index);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Slider.prototype.render = function render() {
    var _props = this.props,
        children = _props.children,
        index = _props.index;


    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: styles.root },
      index !== 0 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Arrow, { onClick: this.handleClick, direction: DIRECTIONS.LEFT }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_1_react_transition_group_CSSTransitionGroup___default.a,
        {
          className: styles.wrapper,
          component: 'div',
          style: {
            transform: 'translate3d(-' + 100 * index + '%, 0, 0)'
          },
          transitionName: transition,
          transitionEnterTimeout: 300,
          transitionLeaveTimeout: 300
        },
        __WEBPACK_IMPORTED_MODULE_0_react__["Children"].map(children, function (child, i) {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            {
              key: i,
              className: styles.slide,
              style: { transform: 'translateX(' + 100 * i + '%)' }
            },
            child
          );
        })
      ),
      index !== children.length - 1 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Arrow, { onClick: this.handleClick, direction: DIRECTIONS.RIGHT })
    );
  };

  return Slider;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);



/***/ }),
/* 2418 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export EVENT_TYPE */
/* unused harmony export enhanceDay */
/* unused harmony export withRange */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_recompose_withState__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_recompose_withState___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_recompose_withState__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_recompose_withPropsOnChange__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_recompose_withPropsOnChange___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_recompose_withPropsOnChange__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_recompose_withProps__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_recompose_withProps___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_recompose_withProps__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_recompose_compose__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_recompose_compose___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_recompose_compose__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5____ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_date_fns_is_before__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_date_fns_is_before___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_date_fns_is_before__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Header_withRange__ = __webpack_require__(2419);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_date_fns_format__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_date_fns_format___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_date_fns_format__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_date_fns_parse__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_date_fns_parse___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_date_fns_parse__);





var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }








var styles = {
  'root': 'Cal__Day__root',
  'enabled': 'Cal__Day__enabled',
  'highlighted': 'Cal__Day__highlighted',
  'today': 'Cal__Day__today',
  'disabled': 'Cal__Day__disabled',
  'selected': 'Cal__Day__selected',
  'month': 'Cal__Day__month',
  'year': 'Cal__Day__year',
  'selection': 'Cal__Day__selection',
  'day': 'Cal__Day__day',
  'range': 'Cal__Day__range',
  'start': 'Cal__Day__start',
  'end': 'Cal__Day__end',
  'betweenRange': 'Cal__Day__betweenRange'
};


var isTouchDevice = false;

var EVENT_TYPE = {
  END: 3,
  HOVER: 2,
  START: 1
};

// Enhance Day component to display selected state based on an array of selected dates
var enhanceDay = __WEBPACK_IMPORTED_MODULE_1_recompose_withPropsOnChange___default()(['selected'], function (_ref) {
  var _classNames;

  var date = _ref.date,
      selected = _ref.selected,
      theme = _ref.theme;

  var isSelected = date >= selected.start && date <= selected.end;
  var isStart = date === selected.start;
  var isEnd = date === selected.end;
  var isRange = !(isStart && isEnd);
  var style = isRange && (isStart && { backgroundColor: theme.accentColor } || isEnd && { borderColor: theme.accentColor });

  return {
    className: isSelected && isRange && __WEBPACK_IMPORTED_MODULE_4_classnames___default()(styles.range, (_classNames = {}, _classNames[styles.start] = isStart, _classNames[styles.betweenRange] = !isStart && !isEnd, _classNames[styles.end] = isEnd, _classNames)),
    isSelected: isSelected,
    selectionStyle: style
  };
});

// Enhancer to handle selecting and displaying multiple dates
var withRange = __WEBPACK_IMPORTED_MODULE_3_recompose_compose___default()(__WEBPACK_IMPORTED_MODULE_5____["b" /* withDefaultProps */], __WEBPACK_IMPORTED_MODULE_0_recompose_withState___default()('scrollDate', 'setScrollDate', getInitialDate), __WEBPACK_IMPORTED_MODULE_0_recompose_withState___default()('displayKey', 'setDisplayKey', getInitialDate), __WEBPACK_IMPORTED_MODULE_0_recompose_withState___default()('selectionStart', 'setSelectionStart', null), Object(__WEBPACK_IMPORTED_MODULE_6__utils__["n" /* withImmutableProps */])(function (_ref2) {
  var DayComponent = _ref2.DayComponent,
      HeaderComponent = _ref2.HeaderComponent,
      YearsComponent = _ref2.YearsComponent;
  return {
    DayComponent: enhanceDay(DayComponent),
    HeaderComponent: Object(__WEBPACK_IMPORTED_MODULE_8__Header_withRange__["a" /* default */])(HeaderComponent)
  };
}), __WEBPACK_IMPORTED_MODULE_2_recompose_withProps___default()(function (_ref3) {
  var displayKey = _ref3.displayKey,
      passThrough = _ref3.passThrough,
      selected = _ref3.selected,
      setDisplayKey = _ref3.setDisplayKey,
      props = _objectWithoutProperties(_ref3, ['displayKey', 'passThrough', 'selected', 'setDisplayKey']);

  return {
    /* eslint-disable sort-keys */
    passThrough: _extends({}, passThrough, {
      Day: {
        onClick: function onClick(date) {
          return handleSelect(date, _extends({ selected: selected }, props));
        },
        handlers: {
          onMouseOver: !isTouchDevice && props.selectionStart ? function (e) {
            return handleMouseOver(e, _extends({ selected: selected }, props));
          } : null
        }
      },
      Years: {
        selected: selected && selected[displayKey],
        onSelect: function onSelect(date) {
          return handleYearSelect(date, _extends({ displayKey: displayKey, selected: selected }, props));
        }
      },
      Header: {
        onYearClick: function onYearClick(date, e, key) {
          return setDisplayKey(key || 'start');
        }
      }
    }),
    selected: {
      start: selected && __WEBPACK_IMPORTED_MODULE_9_date_fns_format___default()(selected.start, 'YYYY-MM-DD'),
      end: selected && __WEBPACK_IMPORTED_MODULE_9_date_fns_format___default()(selected.end, 'YYYY-MM-DD')
    }
  };
}));


function getSortedSelection(_ref4) {
  var start = _ref4.start,
      end = _ref4.end;

  return __WEBPACK_IMPORTED_MODULE_7_date_fns_is_before___default()(start, end) ? { start: start, end: end } : { start: end, end: start };
}

function handleSelect(date, _ref5) {
  var onSelect = _ref5.onSelect,
      selected = _ref5.selected,
      selectionStart = _ref5.selectionStart,
      setSelectionStart = _ref5.setSelectionStart;

  if (selectionStart) {
    onSelect(_extends({
      eventType: EVENT_TYPE.END
    }, getSortedSelection({
      start: selectionStart,
      end: date
    })));
    setSelectionStart(null);
  } else {
    onSelect({ eventType: EVENT_TYPE.START, start: date, end: date });
    setSelectionStart(date);
  }
}

function handleMouseOver(e, _ref6) {
  var onSelect = _ref6.onSelect,
      selectionStart = _ref6.selectionStart;

  var dateStr = e.target.getAttribute('data-date');
  var date = dateStr && __WEBPACK_IMPORTED_MODULE_10_date_fns_parse___default()(dateStr);

  if (!date) {
    return;
  }

  onSelect(_extends({
    eventType: EVENT_TYPE.HOVER
  }, getSortedSelection({
    start: selectionStart,
    end: date
  })));
}

function handleYearSelect(date, _ref7) {
  var _Object$assign;

  var displayKey = _ref7.displayKey,
      onSelect = _ref7.onSelect,
      selected = _ref7.selected,
      setScrollDate = _ref7.setScrollDate;


  setScrollDate(date);
  onSelect(getSortedSelection(Object.assign({}, selected, (_Object$assign = {}, _Object$assign[displayKey] = __WEBPACK_IMPORTED_MODULE_10_date_fns_parse___default()(date), _Object$assign))));
}

function getInitialDate(_ref8) {
  var selected = _ref8.selected;

  return selected && selected.start || new Date();
}

if (typeof window !== 'undefined') {
  window.addEventListener('touchstart', function onTouch() {
    isTouchDevice = true;

    window.removeEventListener('touchstart', onTouch, false);
  });
}

/***/ }),
/* 2419 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__defaultSelectionRenderer__ = __webpack_require__(385);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




var styles = {
  'root': 'Cal__Header__root',
  'landscape': 'Cal__Header__landscape',
  'dateWrapper': 'Cal__Header__dateWrapper',
  'day': 'Cal__Header__day',
  'wrapper': 'Cal__Header__wrapper',
  'blank': 'Cal__Header__blank',
  'active': 'Cal__Header__active',
  'year': 'Cal__Header__year',
  'date': 'Cal__Header__date',
  'range': 'Cal__Header__range'
};


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__utils__["n" /* withImmutableProps */])(function (_ref) {
  var renderSelection = _ref.renderSelection;
  return {
    renderSelection: function renderSelection(values, props) {
      if (!values || !values.start && !values.end) {
        return null;
      }
      if (values.start === values.end) {
        return Object(__WEBPACK_IMPORTED_MODULE_2__defaultSelectionRenderer__["a" /* default */])(values.start, props);
      }

      var dateFormat = props.locale && props.locale.headerFormat || 'MMM Do';

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: styles.range, style: { color: props.theme.headerColor } },
        Object(__WEBPACK_IMPORTED_MODULE_2__defaultSelectionRenderer__["a" /* default */])(values.start, _extends({}, props, { dateFormat: dateFormat, key: 'start', shouldAnimate: false })),
        Object(__WEBPACK_IMPORTED_MODULE_2__defaultSelectionRenderer__["a" /* default */])(values.end, _extends({}, props, { dateFormat: dateFormat, key: 'end', shouldAnimate: false }))
      );
    }
  };
}));

/***/ }),
/* 2420 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2421 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(2422).default;

/***/ }),
/* 2422 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _arrays = __webpack_require__(2423);

var _arrays2 = _interopRequireDefault(_arrays);

var _reactAutowhatever = __webpack_require__(2424);

var _reactAutowhatever2 = _interopRequireDefault(_reactAutowhatever);

var _theme = __webpack_require__(2432);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var alwaysTrue = function alwaysTrue() {
  return true;
};
var defaultShouldRenderSuggestions = function defaultShouldRenderSuggestions(value) {
  return value.trim().length > 0;
};
var defaultRenderSuggestionsContainer = function defaultRenderSuggestionsContainer(_ref) {
  var containerProps = _ref.containerProps,
      children = _ref.children;
  return _react2.default.createElement(
    'div',
    containerProps,
    children
  );
};

var Autosuggest = function (_Component) {
  _inherits(Autosuggest, _Component);

  function Autosuggest(_ref2) {
    var alwaysRenderSuggestions = _ref2.alwaysRenderSuggestions;

    _classCallCheck(this, Autosuggest);

    var _this = _possibleConstructorReturn(this, (Autosuggest.__proto__ || Object.getPrototypeOf(Autosuggest)).call(this));

    _initialiseProps.call(_this);

    _this.state = {
      isFocused: false,
      isCollapsed: !alwaysRenderSuggestions,
      highlightedSectionIndex: null,
      highlightedSuggestionIndex: null,
      highlightedSuggestion: null,
      valueBeforeUpDown: null
    };

    _this.justPressedUpDown = false;
    _this.justMouseEntered = false;

    _this.pressedSuggestion = null;
    return _this;
  }

  _createClass(Autosuggest, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      document.addEventListener('mousedown', this.onDocumentMouseDown);
      document.addEventListener('mouseup', this.onDocumentMouseUp);

      this.input = this.autowhatever.input;
      this.suggestionsContainer = this.autowhatever.itemsContainer;
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if ((0, _arrays2.default)(nextProps.suggestions, this.props.suggestions)) {
        if (nextProps.highlightFirstSuggestion && nextProps.suggestions.length > 0 && this.justPressedUpDown === false && this.justMouseEntered === false) {
          this.highlightFirstSuggestion();
        }
      } else {
        if (this.willRenderSuggestions(nextProps)) {
          if (this.state.isCollapsed && !this.justSelectedSuggestion) {
            this.revealSuggestions();
          }
        } else {
          this.resetHighlightedSuggestion();
        }
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      var _props = this.props,
          suggestions = _props.suggestions,
          onSuggestionHighlighted = _props.onSuggestionHighlighted,
          highlightFirstSuggestion = _props.highlightFirstSuggestion;


      if (!(0, _arrays2.default)(suggestions, prevProps.suggestions) && suggestions.length > 0 && highlightFirstSuggestion) {
        this.highlightFirstSuggestion();
        return;
      }

      if (onSuggestionHighlighted) {
        var highlightedSuggestion = this.getHighlightedSuggestion();
        var prevHighlightedSuggestion = prevState.highlightedSuggestion;

        if (highlightedSuggestion != prevHighlightedSuggestion) {
          onSuggestionHighlighted({
            suggestion: highlightedSuggestion
          });
        }
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      document.removeEventListener('mousedown', this.onDocumentMouseDown);
      document.removeEventListener('mouseup', this.onDocumentMouseUp);
    }
  }, {
    key: 'updateHighlightedSuggestion',
    value: function updateHighlightedSuggestion(sectionIndex, suggestionIndex, prevValue) {
      var _this2 = this;

      this.setState(function (state) {
        var valueBeforeUpDown = state.valueBeforeUpDown;


        if (suggestionIndex === null) {
          valueBeforeUpDown = null;
        } else if (valueBeforeUpDown === null && typeof prevValue !== 'undefined') {
          valueBeforeUpDown = prevValue;
        }

        return {
          highlightedSectionIndex: sectionIndex,
          highlightedSuggestionIndex: suggestionIndex,
          highlightedSuggestion: suggestionIndex === null ? null : _this2.getSuggestion(sectionIndex, suggestionIndex),
          valueBeforeUpDown: valueBeforeUpDown
        };
      });
    }
  }, {
    key: 'resetHighlightedSuggestion',
    value: function resetHighlightedSuggestion() {
      var shouldResetValueBeforeUpDown = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      this.setState(function (state) {
        var valueBeforeUpDown = state.valueBeforeUpDown;


        return {
          highlightedSectionIndex: null,
          highlightedSuggestionIndex: null,
          highlightedSuggestion: null,
          valueBeforeUpDown: shouldResetValueBeforeUpDown ? null : valueBeforeUpDown
        };
      });
    }
  }, {
    key: 'revealSuggestions',
    value: function revealSuggestions() {
      this.setState({
        isCollapsed: false
      });
    }
  }, {
    key: 'closeSuggestions',
    value: function closeSuggestions() {
      this.setState({
        highlightedSectionIndex: null,
        highlightedSuggestionIndex: null,
        highlightedSuggestion: null,
        valueBeforeUpDown: null,
        isCollapsed: true
      });
    }
  }, {
    key: 'getSuggestion',
    value: function getSuggestion(sectionIndex, suggestionIndex) {
      var _props2 = this.props,
          suggestions = _props2.suggestions,
          multiSection = _props2.multiSection,
          getSectionSuggestions = _props2.getSectionSuggestions;


      if (multiSection) {
        return getSectionSuggestions(suggestions[sectionIndex])[suggestionIndex];
      }

      return suggestions[suggestionIndex];
    }
  }, {
    key: 'getHighlightedSuggestion',
    value: function getHighlightedSuggestion() {
      var _state = this.state,
          highlightedSectionIndex = _state.highlightedSectionIndex,
          highlightedSuggestionIndex = _state.highlightedSuggestionIndex;


      if (highlightedSuggestionIndex === null) {
        return null;
      }

      return this.getSuggestion(highlightedSectionIndex, highlightedSuggestionIndex);
    }
  }, {
    key: 'getSuggestionValueByIndex',
    value: function getSuggestionValueByIndex(sectionIndex, suggestionIndex) {
      var getSuggestionValue = this.props.getSuggestionValue;


      return getSuggestionValue(this.getSuggestion(sectionIndex, suggestionIndex));
    }
  }, {
    key: 'getSuggestionIndices',
    value: function getSuggestionIndices(suggestionElement) {
      var sectionIndex = suggestionElement.getAttribute('data-section-index');
      var suggestionIndex = suggestionElement.getAttribute('data-suggestion-index');

      return {
        sectionIndex: typeof sectionIndex === 'string' ? parseInt(sectionIndex, 10) : null,
        suggestionIndex: parseInt(suggestionIndex, 10)
      };
    }
  }, {
    key: 'findSuggestionElement',
    value: function findSuggestionElement(startNode) {
      var node = startNode;

      do {
        if (node.getAttribute('data-suggestion-index') !== null) {
          return node;
        }

        node = node.parentNode;
      } while (node !== null);

      console.error('Clicked element:', startNode); // eslint-disable-line no-console
      throw new Error("Couldn't find suggestion element");
    }
  }, {
    key: 'maybeCallOnChange',
    value: function maybeCallOnChange(event, newValue, method) {
      var _props$inputProps = this.props.inputProps,
          value = _props$inputProps.value,
          onChange = _props$inputProps.onChange;


      if (newValue !== value) {
        onChange(event, { newValue: newValue, method: method });
      }
    }
  }, {
    key: 'willRenderSuggestions',
    value: function willRenderSuggestions(props) {
      var suggestions = props.suggestions,
          inputProps = props.inputProps,
          shouldRenderSuggestions = props.shouldRenderSuggestions;
      var value = inputProps.value;


      return suggestions.length > 0 && shouldRenderSuggestions(value);
    }
  }, {
    key: 'getQuery',
    value: function getQuery() {
      var inputProps = this.props.inputProps;
      var value = inputProps.value;
      var valueBeforeUpDown = this.state.valueBeforeUpDown;


      return (valueBeforeUpDown === null ? value : valueBeforeUpDown).trim();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props3 = this.props,
          suggestions = _props3.suggestions,
          renderInputComponent = _props3.renderInputComponent,
          onSuggestionsFetchRequested = _props3.onSuggestionsFetchRequested,
          renderSuggestion = _props3.renderSuggestion,
          inputProps = _props3.inputProps,
          multiSection = _props3.multiSection,
          renderSectionTitle = _props3.renderSectionTitle,
          id = _props3.id,
          getSectionSuggestions = _props3.getSectionSuggestions,
          theme = _props3.theme,
          getSuggestionValue = _props3.getSuggestionValue,
          alwaysRenderSuggestions = _props3.alwaysRenderSuggestions,
          highlightFirstSuggestion = _props3.highlightFirstSuggestion;
      var _state2 = this.state,
          isFocused = _state2.isFocused,
          isCollapsed = _state2.isCollapsed,
          highlightedSectionIndex = _state2.highlightedSectionIndex,
          highlightedSuggestionIndex = _state2.highlightedSuggestionIndex,
          valueBeforeUpDown = _state2.valueBeforeUpDown;

      var shouldRenderSuggestions = alwaysRenderSuggestions ? alwaysTrue : this.props.shouldRenderSuggestions;
      var value = inputProps.value,
          _onFocus = inputProps.onFocus,
          _onKeyDown = inputProps.onKeyDown;

      var willRenderSuggestions = this.willRenderSuggestions(this.props);
      var isOpen = alwaysRenderSuggestions || isFocused && !isCollapsed && willRenderSuggestions;
      var items = isOpen ? suggestions : [];
      var autowhateverInputProps = _extends({}, inputProps, {
        onFocus: function onFocus(event) {
          if (!_this3.justSelectedSuggestion && !_this3.justClickedOnSuggestionsContainer) {
            var shouldRender = shouldRenderSuggestions(value);

            _this3.setState({
              isFocused: true,
              isCollapsed: !shouldRender
            });

            _onFocus && _onFocus(event);

            if (shouldRender) {
              onSuggestionsFetchRequested({ value: value, reason: 'input-focused' });
            }
          }
        },
        onBlur: function onBlur(event) {
          if (_this3.justClickedOnSuggestionsContainer) {
            _this3.input.focus();
            return;
          }

          _this3.blurEvent = event;

          if (!_this3.justSelectedSuggestion) {
            _this3.onBlur();
            _this3.onSuggestionsClearRequested();
          }
        },
        onChange: function onChange(event) {
          var value = event.target.value;

          var shouldRender = shouldRenderSuggestions(value);

          _this3.maybeCallOnChange(event, value, 'type');

          if (_this3.suggestionsContainer) {
            _this3.suggestionsContainer.scrollTop = 0;
          }

          _this3.setState(_extends({}, highlightFirstSuggestion ? {} : {
            highlightedSectionIndex: null,
            highlightedSuggestionIndex: null,
            highlightedSuggestion: null
          }, {
            valueBeforeUpDown: null,
            isCollapsed: !shouldRender
          }));

          if (shouldRender) {
            onSuggestionsFetchRequested({ value: value, reason: 'input-changed' });
          } else {
            _this3.onSuggestionsClearRequested();
          }
        },
        onKeyDown: function onKeyDown(event, data) {
          var keyCode = event.keyCode;


          switch (keyCode) {
            case 40: // ArrowDown
            case 38:
              // ArrowUp
              if (isCollapsed) {
                if (shouldRenderSuggestions(value)) {
                  onSuggestionsFetchRequested({
                    value: value,
                    reason: 'suggestions-revealed'
                  });
                  _this3.revealSuggestions();
                }
              } else if (suggestions.length > 0) {
                var newHighlightedSectionIndex = data.newHighlightedSectionIndex,
                    newHighlightedItemIndex = data.newHighlightedItemIndex;


                var newValue = void 0;

                if (newHighlightedItemIndex === null) {
                  // valueBeforeUpDown can be null if, for example, user
                  // hovers on the first suggestion and then pressed Up.
                  // If that happens, use the original input value.
                  newValue = valueBeforeUpDown === null ? value : valueBeforeUpDown;
                } else {
                  newValue = _this3.getSuggestionValueByIndex(newHighlightedSectionIndex, newHighlightedItemIndex);
                }

                _this3.updateHighlightedSuggestion(newHighlightedSectionIndex, newHighlightedItemIndex, value);
                _this3.maybeCallOnChange(event, newValue, keyCode === 40 ? 'down' : 'up');
              }

              event.preventDefault(); // Prevents the cursor from moving

              _this3.justPressedUpDown = true;

              setTimeout(function () {
                _this3.justPressedUpDown = false;
              });

              break;

            // Enter
            case 13:
              {
                // See #388
                if (event.keyCode === 229) {
                  break;
                }

                var highlightedSuggestion = _this3.getHighlightedSuggestion();

                if (isOpen && !alwaysRenderSuggestions) {
                  _this3.closeSuggestions();
                }

                if (highlightedSuggestion != null) {
                  var _newValue = getSuggestionValue(highlightedSuggestion);

                  _this3.maybeCallOnChange(event, _newValue, 'enter');

                  _this3.onSuggestionSelected(event, {
                    suggestion: highlightedSuggestion,
                    suggestionValue: _newValue,
                    suggestionIndex: highlightedSuggestionIndex,
                    sectionIndex: highlightedSectionIndex,
                    method: 'enter'
                  });

                  _this3.justSelectedSuggestion = true;

                  setTimeout(function () {
                    _this3.justSelectedSuggestion = false;
                  });
                }

                break;
              }

            // Escape
            case 27:
              {
                if (isOpen) {
                  // If input.type === 'search', the browser clears the input
                  // when Escape is pressed. We want to disable this default
                  // behaviour so that, when suggestions are shown, we just hide
                  // them, without clearing the input.
                  event.preventDefault();
                }

                var willCloseSuggestions = isOpen && !alwaysRenderSuggestions;

                if (valueBeforeUpDown === null) {
                  // Didn't interact with Up/Down
                  if (!willCloseSuggestions) {
                    var _newValue2 = '';

                    _this3.maybeCallOnChange(event, _newValue2, 'escape');

                    if (shouldRenderSuggestions(_newValue2)) {
                      onSuggestionsFetchRequested({
                        value: _newValue2,
                        reason: 'escape-pressed'
                      });
                    } else {
                      _this3.onSuggestionsClearRequested();
                    }
                  }
                } else {
                  // Interacted with Up/Down
                  _this3.maybeCallOnChange(event, valueBeforeUpDown, 'escape');
                }

                if (willCloseSuggestions) {
                  _this3.onSuggestionsClearRequested();
                  _this3.closeSuggestions();
                } else {
                  _this3.resetHighlightedSuggestion();
                }

                break;
              }
          }

          _onKeyDown && _onKeyDown(event);
        }
      });
      var renderSuggestionData = {
        query: this.getQuery()
      };

      return _react2.default.createElement(_reactAutowhatever2.default, {
        multiSection: multiSection,
        items: items,
        renderInputComponent: renderInputComponent,
        renderItemsContainer: this.renderSuggestionsContainer,
        renderItem: renderSuggestion,
        renderItemData: renderSuggestionData,
        renderSectionTitle: renderSectionTitle,
        getSectionItems: getSectionSuggestions,
        highlightedSectionIndex: highlightedSectionIndex,
        highlightedItemIndex: highlightedSuggestionIndex,
        inputProps: autowhateverInputProps,
        itemProps: this.itemProps,
        theme: (0, _theme.mapToAutowhateverTheme)(theme),
        id: id,
        ref: this.storeAutowhateverRef
      });
    }
  }]);

  return Autosuggest;
}(_react.Component);

Autosuggest.propTypes = {
  suggestions: _propTypes2.default.array.isRequired,
  onSuggestionsFetchRequested: function onSuggestionsFetchRequested(props, propName) {
    var onSuggestionsFetchRequested = props[propName];

    if (typeof onSuggestionsFetchRequested !== 'function') {
      throw new Error("'onSuggestionsFetchRequested' must be implemented. See: https://github.com/moroshko/react-autosuggest#onSuggestionsFetchRequestedProp");
    }
  },
  onSuggestionsClearRequested: function onSuggestionsClearRequested(props, propName) {
    var onSuggestionsClearRequested = props[propName];

    if (props.alwaysRenderSuggestions === false && typeof onSuggestionsClearRequested !== 'function') {
      throw new Error("'onSuggestionsClearRequested' must be implemented. See: https://github.com/moroshko/react-autosuggest#onSuggestionsClearRequestedProp");
    }
  },
  onSuggestionSelected: _propTypes2.default.func,
  onSuggestionHighlighted: _propTypes2.default.func,
  renderInputComponent: _propTypes2.default.func,
  renderSuggestionsContainer: _propTypes2.default.func,
  getSuggestionValue: _propTypes2.default.func.isRequired,
  renderSuggestion: _propTypes2.default.func.isRequired,
  inputProps: function inputProps(props, propName) {
    var inputProps = props[propName];

    if (!inputProps.hasOwnProperty('value')) {
      throw new Error("'inputProps' must have 'value'.");
    }

    if (!inputProps.hasOwnProperty('onChange')) {
      throw new Error("'inputProps' must have 'onChange'.");
    }
  },
  shouldRenderSuggestions: _propTypes2.default.func,
  alwaysRenderSuggestions: _propTypes2.default.bool,
  multiSection: _propTypes2.default.bool,
  renderSectionTitle: function renderSectionTitle(props, propName) {
    var renderSectionTitle = props[propName];

    if (props.multiSection === true && typeof renderSectionTitle !== 'function') {
      throw new Error("'renderSectionTitle' must be implemented. See: https://github.com/moroshko/react-autosuggest#renderSectionTitleProp");
    }
  },
  getSectionSuggestions: function getSectionSuggestions(props, propName) {
    var getSectionSuggestions = props[propName];

    if (props.multiSection === true && typeof getSectionSuggestions !== 'function') {
      throw new Error("'getSectionSuggestions' must be implemented. See: https://github.com/moroshko/react-autosuggest#getSectionSuggestionsProp");
    }
  },
  focusInputOnSuggestionClick: _propTypes2.default.bool,
  highlightFirstSuggestion: _propTypes2.default.bool,
  theme: _propTypes2.default.object,
  id: _propTypes2.default.string
};
Autosuggest.defaultProps = {
  renderSuggestionsContainer: defaultRenderSuggestionsContainer,
  shouldRenderSuggestions: defaultShouldRenderSuggestions,
  alwaysRenderSuggestions: false,
  multiSection: false,
  focusInputOnSuggestionClick: true,
  highlightFirstSuggestion: false,
  theme: _theme.defaultTheme,
  id: '1'
};

var _initialiseProps = function _initialiseProps() {
  var _this4 = this;

  this.onDocumentMouseDown = function (event) {
    _this4.justClickedOnSuggestionsContainer = false;

    var node = event.detail && event.detail.target || // This is for testing only. Please show me a better way to emulate this.
    event.target;

    while (node !== null && node !== document) {
      if (node.getAttribute('data-suggestion-index') !== null) {
        // Suggestion was clicked
        return;
      }

      if (node === _this4.suggestionsContainer) {
        // Something else inside suggestions container was clicked
        _this4.justClickedOnSuggestionsContainer = true;
        return;
      }

      node = node.parentNode;
    }
  };

  this.storeAutowhateverRef = function (autowhatever) {
    if (autowhatever !== null) {
      _this4.autowhatever = autowhatever;
    }
  };

  this.onSuggestionMouseEnter = function (event, _ref3) {
    var sectionIndex = _ref3.sectionIndex,
        itemIndex = _ref3.itemIndex;

    _this4.updateHighlightedSuggestion(sectionIndex, itemIndex);

    if (event.target === _this4.pressedSuggestion) {
      _this4.justSelectedSuggestion = true;
    }

    _this4.justMouseEntered = true;

    setTimeout(function () {
      _this4.justMouseEntered = false;
    });
  };

  this.highlightFirstSuggestion = function () {
    _this4.updateHighlightedSuggestion(_this4.props.multiSection ? 0 : null, 0);
  };

  this.onDocumentMouseUp = function () {
    if (_this4.pressedSuggestion && !_this4.justSelectedSuggestion) {
      _this4.input.focus();
    }
    _this4.pressedSuggestion = null;
  };

  this.onSuggestionMouseDown = function (event) {
    // Checking if this.justSelectedSuggestion is already true to not duplicate touch events in chrome
    // See: https://github.com/facebook/react/issues/9809#issuecomment-413978405
    if (!_this4.justSelectedSuggestion) {
      _this4.justSelectedSuggestion = true;
      _this4.pressedSuggestion = event.target;
    }
  };

  this.onSuggestionsClearRequested = function () {
    var onSuggestionsClearRequested = _this4.props.onSuggestionsClearRequested;


    onSuggestionsClearRequested && onSuggestionsClearRequested();
  };

  this.onSuggestionSelected = function (event, data) {
    var _props4 = _this4.props,
        alwaysRenderSuggestions = _props4.alwaysRenderSuggestions,
        onSuggestionSelected = _props4.onSuggestionSelected,
        onSuggestionsFetchRequested = _props4.onSuggestionsFetchRequested;


    onSuggestionSelected && onSuggestionSelected(event, data);

    if (alwaysRenderSuggestions) {
      onSuggestionsFetchRequested({
        value: data.suggestionValue,
        reason: 'suggestion-selected'
      });
    } else {
      _this4.onSuggestionsClearRequested();
    }

    _this4.resetHighlightedSuggestion();
  };

  this.onSuggestionClick = function (event) {
    var _props5 = _this4.props,
        alwaysRenderSuggestions = _props5.alwaysRenderSuggestions,
        focusInputOnSuggestionClick = _props5.focusInputOnSuggestionClick;

    var _getSuggestionIndices = _this4.getSuggestionIndices(_this4.findSuggestionElement(event.target)),
        sectionIndex = _getSuggestionIndices.sectionIndex,
        suggestionIndex = _getSuggestionIndices.suggestionIndex;

    var clickedSuggestion = _this4.getSuggestion(sectionIndex, suggestionIndex);
    var clickedSuggestionValue = _this4.props.getSuggestionValue(clickedSuggestion);

    _this4.maybeCallOnChange(event, clickedSuggestionValue, 'click');
    _this4.onSuggestionSelected(event, {
      suggestion: clickedSuggestion,
      suggestionValue: clickedSuggestionValue,
      suggestionIndex: suggestionIndex,
      sectionIndex: sectionIndex,
      method: 'click'
    });

    if (!alwaysRenderSuggestions) {
      _this4.closeSuggestions();
    }

    if (focusInputOnSuggestionClick === true) {
      _this4.input.focus();
    } else {
      _this4.onBlur();
    }

    setTimeout(function () {
      _this4.justSelectedSuggestion = false;
    });
  };

  this.onBlur = function () {
    var _props6 = _this4.props,
        inputProps = _props6.inputProps,
        shouldRenderSuggestions = _props6.shouldRenderSuggestions;
    var value = inputProps.value,
        onBlur = inputProps.onBlur;

    var highlightedSuggestion = _this4.getHighlightedSuggestion();
    var shouldRender = shouldRenderSuggestions(value);

    _this4.setState({
      isFocused: false,
      highlightedSectionIndex: null,
      highlightedSuggestionIndex: null,
      highlightedSuggestion: null,
      valueBeforeUpDown: null,
      isCollapsed: !shouldRender
    });

    onBlur && onBlur(_this4.blurEvent, { highlightedSuggestion: highlightedSuggestion });
  };

  this.onSuggestionMouseLeave = function (event) {
    _this4.resetHighlightedSuggestion(false); // shouldResetValueBeforeUpDown

    if (_this4.justSelectedSuggestion && event.target === _this4.pressedSuggestion) {
      _this4.justSelectedSuggestion = false;
    }
  };

  this.onSuggestionTouchStart = function () {
    _this4.justSelectedSuggestion = true;
    // todo: event.preventDefault when https://github.com/facebook/react/issues/2043
    // todo: gets released so onSuggestionMouseDown won't fire in chrome
  };

  this.onSuggestionTouchMove = function () {
    _this4.justSelectedSuggestion = false;
    _this4.pressedSuggestion = null;
    _this4.input.focus();
  };

  this.itemProps = function (_ref4) {
    var sectionIndex = _ref4.sectionIndex,
        itemIndex = _ref4.itemIndex;

    return {
      'data-section-index': sectionIndex,
      'data-suggestion-index': itemIndex,
      onMouseEnter: _this4.onSuggestionMouseEnter,
      onMouseLeave: _this4.onSuggestionMouseLeave,
      onMouseDown: _this4.onSuggestionMouseDown,
      onTouchStart: _this4.onSuggestionTouchStart,
      onTouchMove: _this4.onSuggestionTouchMove,
      onClick: _this4.onSuggestionClick
    };
  };

  this.renderSuggestionsContainer = function (_ref5) {
    var containerProps = _ref5.containerProps,
        children = _ref5.children;
    var renderSuggestionsContainer = _this4.props.renderSuggestionsContainer;


    return renderSuggestionsContainer({
      containerProps: containerProps,
      children: children,
      query: _this4.getQuery()
    });
  };
};

exports.default = Autosuggest;

/***/ }),
/* 2423 */
/***/ (function(module, exports) {

module.exports = function shallowEqualArrays(arrA, arrB) {
  if (arrA === arrB) {
    return true;
  }

  var len = arrA.length;

  if (arrB.length !== len) {
    return false;
  }

  for (var i = 0; i < len; i++) {
    if (arrA[i] !== arrB[i]) {
      return false;
    }
  }

  return true;
};


/***/ }),
/* 2424 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(2425).default;

/***/ }),
/* 2425 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _sectionIterator = __webpack_require__(2426);

var _sectionIterator2 = _interopRequireDefault(_sectionIterator);

var _reactThemeable = __webpack_require__(2427);

var _reactThemeable2 = _interopRequireDefault(_reactThemeable);

var _SectionTitle = __webpack_require__(2429);

var _SectionTitle2 = _interopRequireDefault(_SectionTitle);

var _ItemsList = __webpack_require__(2430);

var _ItemsList2 = _interopRequireDefault(_ItemsList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var emptyObject = {};
var defaultRenderInputComponent = function defaultRenderInputComponent(props) {
  return _react2.default.createElement('input', props);
};
var defaultRenderItemsContainer = function defaultRenderItemsContainer(_ref) {
  var containerProps = _ref.containerProps,
      children = _ref.children;
  return _react2.default.createElement(
    'div',
    containerProps,
    children
  );
};
var defaultTheme = {
  container: 'react-autowhatever__container',
  containerOpen: 'react-autowhatever__container--open',
  input: 'react-autowhatever__input',
  inputOpen: 'react-autowhatever__input--open',
  inputFocused: 'react-autowhatever__input--focused',
  itemsContainer: 'react-autowhatever__items-container',
  itemsContainerOpen: 'react-autowhatever__items-container--open',
  itemsList: 'react-autowhatever__items-list',
  item: 'react-autowhatever__item',
  itemFirst: 'react-autowhatever__item--first',
  itemHighlighted: 'react-autowhatever__item--highlighted',
  sectionContainer: 'react-autowhatever__section-container',
  sectionContainerFirst: 'react-autowhatever__section-container--first',
  sectionTitle: 'react-autowhatever__section-title'
};

var Autowhatever = function (_Component) {
  _inherits(Autowhatever, _Component);

  function Autowhatever(props) {
    _classCallCheck(this, Autowhatever);

    var _this = _possibleConstructorReturn(this, (Autowhatever.__proto__ || Object.getPrototypeOf(Autowhatever)).call(this, props));

    _this.storeInputReference = function (input) {
      if (input !== null) {
        _this.input = input;
      }
    };

    _this.storeItemsContainerReference = function (itemsContainer) {
      if (itemsContainer !== null) {
        _this.itemsContainer = itemsContainer;
      }
    };

    _this.onHighlightedItemChange = function (highlightedItem) {
      _this.highlightedItem = highlightedItem;
    };

    _this.getItemId = function (sectionIndex, itemIndex) {
      if (itemIndex === null) {
        return null;
      }

      var id = _this.props.id;

      var section = sectionIndex === null ? '' : 'section-' + sectionIndex;

      return 'react-autowhatever-' + id + '-' + section + '-item-' + itemIndex;
    };

    _this.onFocus = function (event) {
      var inputProps = _this.props.inputProps;


      _this.setState({
        isInputFocused: true
      });

      inputProps.onFocus && inputProps.onFocus(event);
    };

    _this.onBlur = function (event) {
      var inputProps = _this.props.inputProps;


      _this.setState({
        isInputFocused: false
      });

      inputProps.onBlur && inputProps.onBlur(event);
    };

    _this.onKeyDown = function (event) {
      var _this$props = _this.props,
          inputProps = _this$props.inputProps,
          highlightedSectionIndex = _this$props.highlightedSectionIndex,
          highlightedItemIndex = _this$props.highlightedItemIndex;


      switch (event.key) {
        case 'ArrowDown':
        case 'ArrowUp':
          {
            var nextPrev = event.key === 'ArrowDown' ? 'next' : 'prev';

            var _this$sectionIterator = _this.sectionIterator[nextPrev]([highlightedSectionIndex, highlightedItemIndex]),
                _this$sectionIterator2 = _slicedToArray(_this$sectionIterator, 2),
                newHighlightedSectionIndex = _this$sectionIterator2[0],
                newHighlightedItemIndex = _this$sectionIterator2[1];

            inputProps.onKeyDown(event, { newHighlightedSectionIndex: newHighlightedSectionIndex, newHighlightedItemIndex: newHighlightedItemIndex });
            break;
          }

        default:
          inputProps.onKeyDown(event, { highlightedSectionIndex: highlightedSectionIndex, highlightedItemIndex: highlightedItemIndex });
      }
    };

    _this.highlightedItem = null;

    _this.state = {
      isInputFocused: false
    };

    _this.setSectionsItems(props);
    _this.setSectionIterator(props);
    _this.setTheme(props);
    return _this;
  }

  _createClass(Autowhatever, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.ensureHighlightedItemIsVisible();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.items !== this.props.items) {
        this.setSectionsItems(nextProps);
      }

      if (nextProps.items !== this.props.items || nextProps.multiSection !== this.props.multiSection) {
        this.setSectionIterator(nextProps);
      }

      if (nextProps.theme !== this.props.theme) {
        this.setTheme(nextProps);
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.ensureHighlightedItemIsVisible();
    }
  }, {
    key: 'setSectionsItems',
    value: function setSectionsItems(props) {
      if (props.multiSection) {
        this.sectionsItems = props.items.map(function (section) {
          return props.getSectionItems(section);
        });
        this.sectionsLengths = this.sectionsItems.map(function (items) {
          return items.length;
        });
        this.allSectionsAreEmpty = this.sectionsLengths.every(function (itemsCount) {
          return itemsCount === 0;
        });
      }
    }
  }, {
    key: 'setSectionIterator',
    value: function setSectionIterator(props) {
      this.sectionIterator = (0, _sectionIterator2.default)({
        multiSection: props.multiSection,
        data: props.multiSection ? this.sectionsLengths : props.items.length
      });
    }
  }, {
    key: 'setTheme',
    value: function setTheme(props) {
      this.theme = (0, _reactThemeable2.default)(props.theme);
    }
  }, {
    key: 'renderSections',
    value: function renderSections() {
      var _this2 = this;

      if (this.allSectionsAreEmpty) {
        return null;
      }

      var theme = this.theme;
      var _props = this.props,
          id = _props.id,
          items = _props.items,
          renderItem = _props.renderItem,
          renderItemData = _props.renderItemData,
          renderSectionTitle = _props.renderSectionTitle,
          highlightedSectionIndex = _props.highlightedSectionIndex,
          highlightedItemIndex = _props.highlightedItemIndex,
          itemProps = _props.itemProps;


      return items.map(function (section, sectionIndex) {
        var keyPrefix = 'react-autowhatever-' + id + '-';
        var sectionKeyPrefix = keyPrefix + 'section-' + sectionIndex + '-';
        var isFirstSection = sectionIndex === 0;

        // `key` is provided by theme()
        /* eslint-disable react/jsx-key */
        return _react2.default.createElement(
          'div',
          theme(sectionKeyPrefix + 'container', 'sectionContainer', isFirstSection && 'sectionContainerFirst'),
          _react2.default.createElement(_SectionTitle2.default, {
            section: section,
            renderSectionTitle: renderSectionTitle,
            theme: theme,
            sectionKeyPrefix: sectionKeyPrefix
          }),
          _react2.default.createElement(_ItemsList2.default, {
            items: _this2.sectionsItems[sectionIndex],
            itemProps: itemProps,
            renderItem: renderItem,
            renderItemData: renderItemData,
            sectionIndex: sectionIndex,
            highlightedItemIndex: highlightedSectionIndex === sectionIndex ? highlightedItemIndex : null,
            onHighlightedItemChange: _this2.onHighlightedItemChange,
            getItemId: _this2.getItemId,
            theme: theme,
            keyPrefix: keyPrefix,
            ref: _this2.storeItemsListReference
          })
        );
        /* eslint-enable react/jsx-key */
      });
    }
  }, {
    key: 'renderItems',
    value: function renderItems() {
      var items = this.props.items;


      if (items.length === 0) {
        return null;
      }

      var theme = this.theme;
      var _props2 = this.props,
          id = _props2.id,
          renderItem = _props2.renderItem,
          renderItemData = _props2.renderItemData,
          highlightedSectionIndex = _props2.highlightedSectionIndex,
          highlightedItemIndex = _props2.highlightedItemIndex,
          itemProps = _props2.itemProps;


      return _react2.default.createElement(_ItemsList2.default, {
        items: items,
        itemProps: itemProps,
        renderItem: renderItem,
        renderItemData: renderItemData,
        highlightedItemIndex: highlightedSectionIndex === null ? highlightedItemIndex : null,
        onHighlightedItemChange: this.onHighlightedItemChange,
        getItemId: this.getItemId,
        theme: theme,
        keyPrefix: 'react-autowhatever-' + id + '-'
      });
    }
  }, {
    key: 'ensureHighlightedItemIsVisible',
    value: function ensureHighlightedItemIsVisible() {
      var highlightedItem = this.highlightedItem;


      if (!highlightedItem) {
        return;
      }

      var itemsContainer = this.itemsContainer;

      var itemOffsetRelativeToContainer = highlightedItem.offsetParent === itemsContainer ? highlightedItem.offsetTop : highlightedItem.offsetTop - itemsContainer.offsetTop;

      var scrollTop = itemsContainer.scrollTop; // Top of the visible area

      if (itemOffsetRelativeToContainer < scrollTop) {
        // Item is off the top of the visible area
        scrollTop = itemOffsetRelativeToContainer;
      } else if (itemOffsetRelativeToContainer + highlightedItem.offsetHeight > scrollTop + itemsContainer.offsetHeight) {
        // Item is off the bottom of the visible area
        scrollTop = itemOffsetRelativeToContainer + highlightedItem.offsetHeight - itemsContainer.offsetHeight;
      }

      if (scrollTop !== itemsContainer.scrollTop) {
        itemsContainer.scrollTop = scrollTop;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var theme = this.theme;
      var _props3 = this.props,
          id = _props3.id,
          multiSection = _props3.multiSection,
          renderInputComponent = _props3.renderInputComponent,
          renderItemsContainer = _props3.renderItemsContainer,
          highlightedSectionIndex = _props3.highlightedSectionIndex,
          highlightedItemIndex = _props3.highlightedItemIndex;
      var isInputFocused = this.state.isInputFocused;

      var renderedItems = multiSection ? this.renderSections() : this.renderItems();
      var isOpen = renderedItems !== null;
      var ariaActivedescendant = this.getItemId(highlightedSectionIndex, highlightedItemIndex);
      var itemsContainerId = 'react-autowhatever-' + id;
      var containerProps = _extends({
        role: 'combobox',
        'aria-haspopup': 'listbox',
        'aria-owns': itemsContainerId,
        'aria-expanded': isOpen
      }, theme('react-autowhatever-' + id + '-container', 'container', isOpen && 'containerOpen'), this.props.containerProps);
      var inputComponent = renderInputComponent(_extends({
        type: 'text',
        value: '',
        autoComplete: 'off',
        'aria-autocomplete': 'list',
        'aria-controls': itemsContainerId,
        'aria-activedescendant': ariaActivedescendant
      }, theme('react-autowhatever-' + id + '-input', 'input', isOpen && 'inputOpen', isInputFocused && 'inputFocused'), this.props.inputProps, {
        onFocus: this.onFocus,
        onBlur: this.onBlur,
        onKeyDown: this.props.inputProps.onKeyDown && this.onKeyDown,
        ref: this.storeInputReference
      }));
      var itemsContainer = renderItemsContainer({
        containerProps: _extends({
          id: itemsContainerId,
          role: 'listbox'
        }, theme('react-autowhatever-' + id + '-items-container', 'itemsContainer', isOpen && 'itemsContainerOpen'), {
          ref: this.storeItemsContainerReference
        }),
        children: renderedItems
      });

      return _react2.default.createElement(
        'div',
        containerProps,
        inputComponent,
        itemsContainer
      );
    }
  }]);

  return Autowhatever;
}(_react.Component);

Autowhatever.propTypes = {
  id: _propTypes2.default.string, // Used in aria-* attributes. If multiple Autowhatever's are rendered on a page, they must have unique ids.
  multiSection: _propTypes2.default.bool, // Indicates whether a multi section layout should be rendered.
  renderInputComponent: _propTypes2.default.func, // When specified, it is used to render the input element.
  renderItemsContainer: _propTypes2.default.func, // Renders the items container.
  items: _propTypes2.default.array.isRequired, // Array of items or sections to render.
  renderItem: _propTypes2.default.func, // This function renders a single item.
  renderItemData: _propTypes2.default.object, // Arbitrary data that will be passed to renderItem()
  renderSectionTitle: _propTypes2.default.func, // This function gets a section and renders its title.
  getSectionItems: _propTypes2.default.func, // This function gets a section and returns its items, which will be passed into `renderItem` for rendering.
  containerProps: _propTypes2.default.object, // Arbitrary container props
  inputProps: _propTypes2.default.object, // Arbitrary input props
  itemProps: _propTypes2.default.oneOfType([// Arbitrary item props
  _propTypes2.default.object, _propTypes2.default.func]),
  highlightedSectionIndex: _propTypes2.default.number, // Section index of the highlighted item
  highlightedItemIndex: _propTypes2.default.number, // Highlighted item index (within a section)
  theme: _propTypes2.default.oneOfType([// Styles. See: https://github.com/markdalgleish/react-themeable
  _propTypes2.default.object, _propTypes2.default.array])
};
Autowhatever.defaultProps = {
  id: '1',
  multiSection: false,
  renderInputComponent: defaultRenderInputComponent,
  renderItemsContainer: defaultRenderItemsContainer,
  renderItem: function renderItem() {
    throw new Error('`renderItem` must be provided');
  },
  renderItemData: emptyObject,
  renderSectionTitle: function renderSectionTitle() {
    throw new Error('`renderSectionTitle` must be provided');
  },
  getSectionItems: function getSectionItems() {
    throw new Error('`getSectionItems` must be provided');
  },
  containerProps: emptyObject,
  inputProps: emptyObject,
  itemProps: emptyObject,
  highlightedSectionIndex: null,
  highlightedItemIndex: null,
  theme: defaultTheme
};
exports.default = Autowhatever;

/***/ }),
/* 2426 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

module.exports = function (_ref) {
  var data = _ref.data;
  var multiSection = _ref.multiSection;

  function nextNonEmptySectionIndex(sectionIndex) {
    if (sectionIndex === null) {
      sectionIndex = 0;
    } else {
      sectionIndex++;
    }

    while (sectionIndex < data.length && data[sectionIndex] === 0) {
      sectionIndex++;
    }

    return sectionIndex === data.length ? null : sectionIndex;
  }

  function prevNonEmptySectionIndex(sectionIndex) {
    if (sectionIndex === null) {
      sectionIndex = data.length - 1;
    } else {
      sectionIndex--;
    }

    while (sectionIndex >= 0 && data[sectionIndex] === 0) {
      sectionIndex--;
    }

    return sectionIndex === -1 ? null : sectionIndex;
  }

  function next(position) {
    var _position = _slicedToArray(position, 2);

    var sectionIndex = _position[0];
    var itemIndex = _position[1];


    if (multiSection) {
      if (itemIndex === null || itemIndex === data[sectionIndex] - 1) {
        sectionIndex = nextNonEmptySectionIndex(sectionIndex);

        if (sectionIndex === null) {
          return [null, null];
        }

        return [sectionIndex, 0];
      }

      return [sectionIndex, itemIndex + 1];
    }

    if (data === 0 || itemIndex === data - 1) {
      return [null, null];
    }

    if (itemIndex === null) {
      return [null, 0];
    }

    return [null, itemIndex + 1];
  }

  function prev(position) {
    var _position2 = _slicedToArray(position, 2);

    var sectionIndex = _position2[0];
    var itemIndex = _position2[1];


    if (multiSection) {
      if (itemIndex === null || itemIndex === 0) {
        sectionIndex = prevNonEmptySectionIndex(sectionIndex);

        if (sectionIndex === null) {
          return [null, null];
        }

        return [sectionIndex, data[sectionIndex] - 1];
      }

      return [sectionIndex, itemIndex - 1];
    }

    if (data === 0 || itemIndex === 0) {
      return [null, null];
    }

    if (itemIndex === null) {
      return [null, data - 1];
    }

    return [null, itemIndex - 1];
  }

  function isLast(position) {
    return next(position)[1] === null;
  }

  return {
    next: next,
    prev: prev,
    isLast: isLast
  };
};


/***/ }),
/* 2427 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
  value: true
});

var _slicedToArray = (function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i['return']) _i['return'](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError('Invalid attempt to destructure non-iterable instance'); } }; })();

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i]; return arr2; } else { return Array.from(arr); } }

var _objectAssign = __webpack_require__(2428);

var _objectAssign2 = _interopRequireDefault(_objectAssign);

var truthy = function truthy(x) {
  return x;
};

exports['default'] = function (input) {
  var _ref = Array.isArray(input) && input.length === 2 ? input : [input, null];

  var _ref2 = _slicedToArray(_ref, 2);

  var theme = _ref2[0];
  var classNameDecorator = _ref2[1];

  return function (key) {
    for (var _len = arguments.length, names = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      names[_key - 1] = arguments[_key];
    }

    var styles = names.map(function (name) {
      return theme[name];
    }).filter(truthy);

    return typeof styles[0] === 'string' || typeof classNameDecorator === 'function' ? { key: key, className: classNameDecorator ? classNameDecorator.apply(undefined, _toConsumableArray(styles)) : styles.join(' ') } : { key: key, style: _objectAssign2['default'].apply(undefined, [{}].concat(_toConsumableArray(styles))) };
  };
};

module.exports = exports['default'];

/***/ }),
/* 2428 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function ToObject(val) {
	if (val == null) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function ownEnumerableKeys(obj) {
	var keys = Object.getOwnPropertyNames(obj);

	if (Object.getOwnPropertySymbols) {
		keys = keys.concat(Object.getOwnPropertySymbols(obj));
	}

	return keys.filter(function (key) {
		return propIsEnumerable.call(obj, key);
	});
}

module.exports = Object.assign || function (target, source) {
	var from;
	var keys;
	var to = ToObject(target);

	for (var s = 1; s < arguments.length; s++) {
		from = arguments[s];
		keys = ownEnumerableKeys(Object(from));

		for (var i = 0; i < keys.length; i++) {
			to[keys[i]] = from[keys[i]];
		}
	}

	return to;
};


/***/ }),
/* 2429 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _compareObjects = __webpack_require__(390);

var _compareObjects2 = _interopRequireDefault(_compareObjects);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SectionTitle = function (_Component) {
  _inherits(SectionTitle, _Component);

  function SectionTitle() {
    _classCallCheck(this, SectionTitle);

    return _possibleConstructorReturn(this, (SectionTitle.__proto__ || Object.getPrototypeOf(SectionTitle)).apply(this, arguments));
  }

  _createClass(SectionTitle, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      return (0, _compareObjects2.default)(nextProps, this.props);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          section = _props.section,
          renderSectionTitle = _props.renderSectionTitle,
          theme = _props.theme,
          sectionKeyPrefix = _props.sectionKeyPrefix;

      var sectionTitle = renderSectionTitle(section);

      if (!sectionTitle) {
        return null;
      }

      return _react2.default.createElement(
        'div',
        theme(sectionKeyPrefix + 'title', 'sectionTitle'),
        sectionTitle
      );
    }
  }]);

  return SectionTitle;
}(_react.Component);

SectionTitle.propTypes = {
  section: _propTypes2.default.any.isRequired,
  renderSectionTitle: _propTypes2.default.func.isRequired,
  theme: _propTypes2.default.func.isRequired,
  sectionKeyPrefix: _propTypes2.default.string.isRequired
};
exports.default = SectionTitle;

/***/ }),
/* 2430 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Item = __webpack_require__(2431);

var _Item2 = _interopRequireDefault(_Item);

var _compareObjects = __webpack_require__(390);

var _compareObjects2 = _interopRequireDefault(_compareObjects);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ItemsList = function (_Component) {
  _inherits(ItemsList, _Component);

  function ItemsList() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ItemsList);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ItemsList.__proto__ || Object.getPrototypeOf(ItemsList)).call.apply(_ref, [this].concat(args))), _this), _this.storeHighlightedItemReference = function (highlightedItem) {
      _this.props.onHighlightedItemChange(highlightedItem === null ? null : highlightedItem.item);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ItemsList, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      return (0, _compareObjects2.default)(nextProps, this.props, ['itemProps']);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          items = _props.items,
          itemProps = _props.itemProps,
          renderItem = _props.renderItem,
          renderItemData = _props.renderItemData,
          sectionIndex = _props.sectionIndex,
          highlightedItemIndex = _props.highlightedItemIndex,
          getItemId = _props.getItemId,
          theme = _props.theme,
          keyPrefix = _props.keyPrefix;

      var sectionPrefix = sectionIndex === null ? keyPrefix : keyPrefix + 'section-' + sectionIndex + '-';
      var isItemPropsFunction = typeof itemProps === 'function';

      return _react2.default.createElement(
        'ul',
        _extends({ role: 'listbox' }, theme(sectionPrefix + 'items-list', 'itemsList')),
        items.map(function (item, itemIndex) {
          var isFirst = itemIndex === 0;
          var isHighlighted = itemIndex === highlightedItemIndex;
          var itemKey = sectionPrefix + 'item-' + itemIndex;
          var itemPropsObj = isItemPropsFunction ? itemProps({ sectionIndex: sectionIndex, itemIndex: itemIndex }) : itemProps;
          var allItemProps = _extends({
            id: getItemId(sectionIndex, itemIndex),
            'aria-selected': isHighlighted
          }, theme(itemKey, 'item', isFirst && 'itemFirst', isHighlighted && 'itemHighlighted'), itemPropsObj);

          if (isHighlighted) {
            allItemProps.ref = _this2.storeHighlightedItemReference;
          }

          // `key` is provided by theme()
          /* eslint-disable react/jsx-key */
          return _react2.default.createElement(_Item2.default, _extends({}, allItemProps, {
            sectionIndex: sectionIndex,
            isHighlighted: isHighlighted,
            itemIndex: itemIndex,
            item: item,
            renderItem: renderItem,
            renderItemData: renderItemData
          }));
          /* eslint-enable react/jsx-key */
        })
      );
    }
  }]);

  return ItemsList;
}(_react.Component);

ItemsList.propTypes = {
  items: _propTypes2.default.array.isRequired,
  itemProps: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.func]),
  renderItem: _propTypes2.default.func.isRequired,
  renderItemData: _propTypes2.default.object.isRequired,
  sectionIndex: _propTypes2.default.number,
  highlightedItemIndex: _propTypes2.default.number,
  onHighlightedItemChange: _propTypes2.default.func.isRequired,
  getItemId: _propTypes2.default.func.isRequired,
  theme: _propTypes2.default.func.isRequired,
  keyPrefix: _propTypes2.default.string.isRequired
};
ItemsList.defaultProps = {
  sectionIndex: null
};
exports.default = ItemsList;

/***/ }),
/* 2431 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _compareObjects = __webpack_require__(390);

var _compareObjects2 = _interopRequireDefault(_compareObjects);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Item = function (_Component) {
  _inherits(Item, _Component);

  function Item() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Item);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Item.__proto__ || Object.getPrototypeOf(Item)).call.apply(_ref, [this].concat(args))), _this), _this.storeItemReference = function (item) {
      if (item !== null) {
        _this.item = item;
      }
    }, _this.onMouseEnter = function (event) {
      var _this$props = _this.props,
          sectionIndex = _this$props.sectionIndex,
          itemIndex = _this$props.itemIndex;


      _this.props.onMouseEnter(event, { sectionIndex: sectionIndex, itemIndex: itemIndex });
    }, _this.onMouseLeave = function (event) {
      var _this$props2 = _this.props,
          sectionIndex = _this$props2.sectionIndex,
          itemIndex = _this$props2.itemIndex;


      _this.props.onMouseLeave(event, { sectionIndex: sectionIndex, itemIndex: itemIndex });
    }, _this.onMouseDown = function (event) {
      var _this$props3 = _this.props,
          sectionIndex = _this$props3.sectionIndex,
          itemIndex = _this$props3.itemIndex;


      _this.props.onMouseDown(event, { sectionIndex: sectionIndex, itemIndex: itemIndex });
    }, _this.onClick = function (event) {
      var _this$props4 = _this.props,
          sectionIndex = _this$props4.sectionIndex,
          itemIndex = _this$props4.itemIndex;


      _this.props.onClick(event, { sectionIndex: sectionIndex, itemIndex: itemIndex });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Item, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      return (0, _compareObjects2.default)(nextProps, this.props, ['renderItemData']);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          isHighlighted = _props.isHighlighted,
          item = _props.item,
          renderItem = _props.renderItem,
          renderItemData = _props.renderItemData,
          restProps = _objectWithoutProperties(_props, ['isHighlighted', 'item', 'renderItem', 'renderItemData']);

      delete restProps.sectionIndex;
      delete restProps.itemIndex;

      if (typeof restProps.onMouseEnter === 'function') {
        restProps.onMouseEnter = this.onMouseEnter;
      }

      if (typeof restProps.onMouseLeave === 'function') {
        restProps.onMouseLeave = this.onMouseLeave;
      }

      if (typeof restProps.onMouseDown === 'function') {
        restProps.onMouseDown = this.onMouseDown;
      }

      if (typeof restProps.onClick === 'function') {
        restProps.onClick = this.onClick;
      }

      return _react2.default.createElement(
        'li',
        _extends({ role: 'option' }, restProps, { ref: this.storeItemReference }),
        renderItem(item, _extends({ isHighlighted: isHighlighted }, renderItemData))
      );
    }
  }]);

  return Item;
}(_react.Component);

Item.propTypes = {
  sectionIndex: _propTypes2.default.number,
  isHighlighted: _propTypes2.default.bool.isRequired,
  itemIndex: _propTypes2.default.number.isRequired,
  item: _propTypes2.default.any.isRequired,
  renderItem: _propTypes2.default.func.isRequired,
  renderItemData: _propTypes2.default.object.isRequired,
  onMouseEnter: _propTypes2.default.func,
  onMouseLeave: _propTypes2.default.func,
  onMouseDown: _propTypes2.default.func,
  onClick: _propTypes2.default.func
};
exports.default = Item;

/***/ }),
/* 2432 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var defaultTheme = exports.defaultTheme = {
  container: 'react-autosuggest__container',
  containerOpen: 'react-autosuggest__container--open',
  input: 'react-autosuggest__input',
  inputOpen: 'react-autosuggest__input--open',
  inputFocused: 'react-autosuggest__input--focused',
  suggestionsContainer: 'react-autosuggest__suggestions-container',
  suggestionsContainerOpen: 'react-autosuggest__suggestions-container--open',
  suggestionsList: 'react-autosuggest__suggestions-list',
  suggestion: 'react-autosuggest__suggestion',
  suggestionFirst: 'react-autosuggest__suggestion--first',
  suggestionHighlighted: 'react-autosuggest__suggestion--highlighted',
  sectionContainer: 'react-autosuggest__section-container',
  sectionContainerFirst: 'react-autosuggest__section-container--first',
  sectionTitle: 'react-autosuggest__section-title'
};

var mapToAutowhateverTheme = exports.mapToAutowhateverTheme = function mapToAutowhateverTheme(theme) {
  var result = {};

  for (var key in theme) {
    switch (key) {
      case 'suggestionsContainer':
        result['itemsContainer'] = theme[key];
        break;

      case 'suggestionsContainerOpen':
        result['itemsContainerOpen'] = theme[key];
        break;

      case 'suggestion':
        result['item'] = theme[key];
        break;

      case 'suggestionFirst':
        result['itemFirst'] = theme[key];
        break;

      case 'suggestionHighlighted':
        result['itemHighlighted'] = theme[key];
        break;

      case 'suggestionsList':
        result['itemsList'] = theme[key];
        break;

      default:
        result[key] = theme[key];
    }
  }

  return result;
};

/***/ }),
/* 2433 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2434 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ImportClients */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_core__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles_withStyles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_icons__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_assets_jss_material_dashboard_pro_react_views_sweetAlertStyle_jsx__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_EnhancedTableHead_EnhancedTableHead_jsx__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_Grid_GridItem_jsx__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_ManageClientsLegend_ManageClientsLegend_jsx__ = __webpack_require__(2435);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_graphql_tag__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_graphql_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_graphql_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_helpers_DateHelpers__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_helpers_ErrorHelper__ = __webpack_require__(391);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_helpers_Search__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_helpers_UserHelper__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_queries_clients_mutations__ = __webpack_require__(619);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_queries_clientsByBroker__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_queries_QuoteEligibility__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_queries_Submit__ = __webpack_require__(392);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_react_apollo__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_react_bootstrap_sweetalert__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_react_bootstrap_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_react_bootstrap_sweetalert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_react_router__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_reducers_NotificationReducer__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_reducers_TasksReducer__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_store__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__ClientImportModal_jsx__ = __webpack_require__(2436);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__advanced_search_SearchDialog_jsx__ = __webpack_require__(2439);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n\tmutation importClients($input: ImportClientsInput!) {\n\t\tImportClients(input: $input) {\n\t\t\tclientMutationId\n\t\t}\n\t}\n'],['\n\tmutation importClients($input: ImportClientsInput!) {\n\t\tImportClients(input: $input) {\n\t\t\tclientMutationId\n\t\t}\n\t}\n']),_templateObject2=_taggedTemplateLiteral(['\n\tmutation exportClients($input: ExportClientsInput!) {\n\t\tExportClients(input: $input) {\n\t\t\tpath\n\t\t\tclientMutationId\n\t\t}\n\t}\n'],['\n\tmutation exportClients($input: ExportClientsInput!) {\n\t\tExportClients(input: $input) {\n\t\t\tpath\n\t\t\tclientMutationId\n\t\t}\n\t}\n']),_templateObject3=_taggedTemplateLiteral(['\n\tmutation updateClientStatus($input: UpdateClientStatusInput!) {\n\t\tUpdateClientStatus(input: $input) {\n\t\t\tclientMutationId\n\t\t}\n\t}\n'],['\n\tmutation updateClientStatus($input: UpdateClientStatusInput!) {\n\t\tUpdateClientStatus(input: $input) {\n\t\t\tclientMutationId\n\t\t}\n\t}\n']),_templateObject4=_taggedTemplateLiteral(['\n\tmutation deleteClient($input: DeleteClientInput!) {\n\t\tDeleteClient(input: $input) {\n\t\t\tclientMutationId\n\t\t}\n\t}\n'],['\n\tmutation deleteClient($input: DeleteClientInput!) {\n\t\tDeleteClient(input: $input) {\n\t\t\tclientMutationId\n\t\t}\n\t}\n']);function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}/*eslint-disable*/var columnData=[{id:'edit',numeric:false,disablePadding:true,label:'',noSort:true,width:'30px'},{id:'clientType',numeric:false,disablePadding:true,label:'',noSort:true},{id:'scd_name',numeric:false,disablePadding:true,label:'Name'},{id:'scd_email',numeric:false,disablePadding:true,label:'Email'},{id:'date_modified',numeric:false,disablePadding:true,label:'Date Created / Modified'}];var isEmptyOrSpaces=function isEmptyOrSpaces(str){return str===undefined||str===null||str.match(/^ *$/)!==null;};var ImportClients=__WEBPACK_IMPORTED_MODULE_8_graphql_tag___default()(_templateObject);var exportClients=__WEBPACK_IMPORTED_MODULE_8_graphql_tag___default()(_templateObject2);var updateClientStatus=__WEBPACK_IMPORTED_MODULE_8_graphql_tag___default()(_templateObject3);var deleteClient=__WEBPACK_IMPORTED_MODULE_8_graphql_tag___default()(_templateObject4);var ManageClients=function(_React$Component){_inherits(ManageClients,_React$Component);function ManageClients(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ManageClients);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ManageClients.__proto__||Object.getPrototypeOf(ManageClients)).call.apply(_ref,[this].concat(args))),_this),_this.state={loading:true,page:0,rowsPerPage:5,order:'desc',orderBy:'date_modified',searchTerm:'',loadingSearch:false,searchData:[],openActions:false,statusEl:null,actionsEl:null,legendEl:null,handleStatusEl:null,openLoadingSnack:false,loadingSnackText:'',openMenus:[],anchorTop:0,anchorLeft:0,popoverOpen:false,clientStatus:'own',data:[],openDialog:false,assistantActive:false,alert:false,eligibilityDialogOpen:false,invalidFields:[],selectedClient:{},openSearchDialog:false},_this.exportPDF=function(){_this.pdf.save();},_this.handleSearch=function(event){_this.setState({searchTerm:event.target.value});var values=event.target.value.split(' ');var brokers=_this.state.data;var inc=['scd_name','scd_surname','scd_email','date_created'];var filteredData=Object(__WEBPACK_IMPORTED_MODULE_11_helpers_Search__["a" /* SearchDataSet */])(brokers,values,inc);_this.setState({searchData:filteredData});},_this.handleChangePage=function(event,page){_this.setState({page:page});},_this.handleChangeRowsPerPage=function(event){_this.setState({rowsPerPage:event.target.value});},_this.handleRequestSort=function(event,property){if(property==='clientType')return;var orderBy=property;var order='desc';if(_this.state.orderBy===property&&_this.state.order==='desc'){order='asc';}_this.setState({order:order,orderBy:orderBy});},_this.handlePopoverOpen=function(event,name){_this.setState(_defineProperty({},name,event.currentTarget));},_this.handlePopoverClose=function(name){_this.setState(_defineProperty({},name,null));},_this.loadingSnack=function(open,text){_this.setState({openLoadingSnack:open,loadingSnackText:text});},_this.handleClick=function(event,id){_this.setState({anchorTop:event.clientY,anchorLeft:event.clientX});var openMenus=_this.state.openMenus.slice();openMenus.filter(function(x){return x.id===id;})[0].open=true;_this.setState({openMenus:openMenus,popoverOpen:true});},_this.handleClose=function(id){var openMenus=_this.state.openMenus.slice();openMenus.filter(function(x){return x.id===id;})[0].open=false;_this.setState({openMenus:openMenus,popoverOpen:false});},_this.handleImport=function(){_this.setState({openDialog:true});},_this.handleCloseClientImport=function(){_this.setState({openDialog:false});},_this.getBrokerId=function(){var brokerId=Object(__WEBPACK_IMPORTED_MODULE_12_helpers_UserHelper__["a" /* GetUserId */])();if(_this.checkAssistantActive()){brokerId=sessionStorage.getItem('ActiveBrokerId');}return brokerId;},_this.getBrokerName=function(){return sessionStorage.getItem('ActiveBrokerName');},_this.sortDateDesc=function(a,b){return new Date(b.date_modified)-new Date(a.date_modified);},_this.sortDateAsc=function(a,b){return new Date(a.date_modified)-new Date(b.date_modified);},_this.handleNewQuote=function(id){_this.props.history.push({pathname:'/app/quote',search:'clientId='+atob(id).split(':')[1]});},_this.handleViewQuote=function(client){var clientId=atob(client.id).split(':')[1];var clientFullName=client.scd_name+' '+client.scd_surname;_this.props.history.push({pathname:'/app/history',search:'clientId='+clientId+'&clientName='+clientFullName});},_this.handleSendMessage=function(id){alert('Send a message to a client with id : '+id);alert('THIS DOES NOTHING YET!');},_this.handleSendAppInvite=function(id,email,refetch){if(isEmptyOrSpaces(email)){__WEBPACK_IMPORTED_MODULE_23_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_21_reducers_NotificationReducer__["d" /* showSnack */])({message:'Client must have email address',color:'danger'}));return;}var input={clientId:atob(id).split(':')[1],clientEmail:email,brokerId:_this.getBrokerId(),token:Object(__WEBPACK_IMPORTED_MODULE_12_helpers_UserHelper__["c" /* GetUserToken */])()};_this.props.SendAppInvite({variables:{input:input}}).then(function(resp){refetch();__WEBPACK_IMPORTED_MODULE_23_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_21_reducers_NotificationReducer__["d" /* showSnack */])({message:'Invite Sent!',color:'success'}));}).catch(function(error){__WEBPACK_IMPORTED_MODULE_23_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_21_reducers_NotificationReducer__["d" /* showSnack */])({message:'Error: '+Object(__WEBPACK_IMPORTED_MODULE_10_helpers_ErrorHelper__["a" /* ParseGraphqlError */])(error),color:'danger'}));});},_this.handleRequestAstute=function(id){var input={token:Object(__WEBPACK_IMPORTED_MODULE_12_helpers_UserHelper__["c" /* GetUserToken */])(),userId:_this.getBrokerId(),clientId:atob(id).split(':')[1],benefits:[3],assistantId:Object(__WEBPACK_IMPORTED_MODULE_12_helpers_UserHelper__["b" /* GetUserKey */])('userType')==='6'?Object(__WEBPACK_IMPORTED_MODULE_12_helpers_UserHelper__["a" /* GetUserId */])():null,targets:[7],data:{},requestAstute:true,astuteData:{}};_this.props.newQuoteMutation({variables:{input:input}}).then(function(resp){__WEBPACK_IMPORTED_MODULE_23_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_21_reducers_NotificationReducer__["e" /* successWarning */])({open:true,title:'Astute Requested'}));__WEBPACK_IMPORTED_MODULE_23_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_22_reducers_TasksReducer__["f" /* openProgress */])());}).catch(function(error){__WEBPACK_IMPORTED_MODULE_23_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_21_reducers_NotificationReducer__["d" /* showSnack */])({message:'There was an error requesting Astute for this client: '+Object(__WEBPACK_IMPORTED_MODULE_10_helpers_ErrorHelper__["a" /* ParseGraphqlError */])(error),color:'danger'}));});},_this.openSearchDialog=function(){_this.setState({openSearchDialog:true});},_this.closeSearchDialog=function(){_this.setState({openSearchDialog:false});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ManageClients,[{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,newState){var _this2=this;var comparedState=false;Object.keys(this.state).map(function(s){if(_this2.state[s]!==newState[s]){comparedState=true;}return s;});return comparedState;}},{key:'getSorting',value:function getSorting(order,orderBy){return order==='desc'?function(a,b){return b[orderBy]<a[orderBy]?-1:1;}:function(a,b){return a[orderBy]<b[orderBy]?-1:1;};}},{key:'handleEdit',value:function handleEdit(client){var tab=arguments.length>1&&arguments[1]!==undefined?arguments[1]:null;this.props.history.push({pathname:'/app/clientdetail',search:'clientId='+atob(client.id).split(':')[1]+'&clientName='+((client.scd_name?client.scd_name:'')+' '+(client.scd_surname?client.scd_surname:''))+(tab?'&tab='+tab:'')});}},{key:'handleMedical',value:function handleMedical(client){var tab=arguments.length>1&&arguments[1]!==undefined?arguments[1]:null;this.props.history.push({pathname:'/app/quotemedical',search:'clientId='+atob(client.id).split(':')[1]});}},{key:'checkAssistantActive',value:function checkAssistantActive(){if(Object(__WEBPACK_IMPORTED_MODULE_12_helpers_UserHelper__["b" /* GetUserKey */])('userType')==='6'){if(!this.state.assistantActive){this.setState({assistantActive:true});}return true;}return false;}},{key:'render',value:function render(){var _this3=this;var brokerId=this.getBrokerId();return __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_react_apollo__["Query"],{query:__WEBPACK_IMPORTED_MODULE_14_queries_clientsByBroker__["a" /* getClientsByBroker */],variables:{brokerId:brokerId,token:Object(__WEBPACK_IMPORTED_MODULE_12_helpers_UserHelper__["b" /* GetUserKey */])('token'),status:this.state.clientStatus,userType:Object(__WEBPACK_IMPORTED_MODULE_12_helpers_UserHelper__["b" /* GetUserKey */])('userType')},fetchPolicy:'cache-and-network'},function(_ref2){var loading=_ref2.loading,error=_ref2.error,data=_ref2.data,refetch=_ref2.refetch;if(loading){return __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["B" /* LinearProgress */],null);}else{if(_this3.state.loading)_this3.setState({loading:false});}if(error&&error.message&&error.message==='GraphQL error: invalid token'){Object(__WEBPACK_IMPORTED_MODULE_12_helpers_UserHelper__["d" /* Logout */])();return __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20_react_router__["a" /* Redirect */],{to:'/app/portal/login'});}if(_this3.state.data.length!==data.getClientsByBroker.length){_this3.setState({data:data.getClientsByBroker});}var qData=[];if(_this3.state.searchData.length>0&&_this3.state.searchTerm!==''){qData=_this3.state.searchData.slice();}else{qData=data.getClientsByBroker.slice();}if(_this3.state.orderBy==='date_modified'){qData.sort(_this3.state.order==='desc'?_this3.sortDateDesc:_this3.sortDateAsc);}else{qData.sort(_this3.getSorting(_this3.state.order,_this3.state.orderBy));}if(qData&&_this3.state.openMenus.length!==qData.length){var openMenus=[];qData.map(function(c){openMenus.push({open:false,id:c.id});return cancelAnimationFrame;});_this3.setState({openMenus:openMenus});}return __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{container:true},__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:10,style:{margin:'auto'}},__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["e" /* Card */],null,__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["f" /* CardContent */],null,__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement('div',null,_this3.checkAssistantActive()?__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{variant:'headline',className:'centerCell'},_this3.getBrokerName(),'\'s Clients'):__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{variant:'headline',className:'centerCell'},'Your Clients'),__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement('div',{style:{borderBottom:'1px solid #cccccc69',margin:'5px auto',width:'25%',marginBottom:'20px'}})),__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{container:true,style:{marginBottom:'15px'}},__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{item:true,xs:6,sm:6,md:6},__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["I" /* Paper */],{className:'flabButton',onClick:function onClick(e){return _this3.handlePopoverOpen(e,'statusEl');}},__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement('div',{style:{display:'flex'}},__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],null,'Own / Unassigned'),__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["w" /* Icon */],null,'arrow_drop_down'))),__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["J" /* Popover */],{open:Boolean(_this3.state.statusEl),anchorEl:_this3.state.statusEl,onClose:function onClose(){return _this3.handlePopoverClose('statusEl');},anchorOrigin:{vertical:'bottom',horizontal:'center'},transformOrigin:{vertical:'top',horizontal:'center'}},__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["C" /* List */],{component:'nav'},__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["D" /* ListItem */],{button:true,onClick:function onClick(e){_this3.setState({clientStatus:'own'});_this3.handlePopoverClose('statusEl');refetch();}},_this3.state.clientStatus==='own'?__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["w" /* Icon */],null,'check'):__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement('div',{style:{width:'24px'}}),__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{variant:'subheading',style:{marginLeft:'10px',marginRight:'10px'}},'Own')),__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["p" /* Divider */],null),__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["D" /* ListItem */],{button:true,onClick:function onClick(e){_this3.setState({clientStatus:'shared'});_this3.handlePopoverClose('statusEl');refetch();}},_this3.state.clientStatus==='shared'?__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["w" /* Icon */],null,'check'):__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement('div',{style:{width:'24px'}}),__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{variant:'subheading',style:{marginLeft:'10px',marginRight:'10px'}},'Unassigned')),__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["p" /* Divider */],null),__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["D" /* ListItem */],{button:true,onClick:function onClick(e){_this3.setState({clientStatus:'deleted'});_this3.handlePopoverClose('statusEl');refetch();}},_this3.state.clientStatus==='deleted'?__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["w" /* Icon */],null,'check'):__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement('div',{style:{width:'24px'}}),__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{variant:'subheading',style:{marginLeft:'10px',marginRight:'10px'}},'Deleted'))))),__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{item:true,xs:6,sm:6,md:6},__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["I" /* Paper */],{className:'flabButton',onClick:function onClick(e){return _this3.handlePopoverOpen(e,'legendEl');}},__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement('div',{style:{display:'flex'}},__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],null,'Legend'),__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["w" /* Icon */],null,'arrow_drop_down'))),__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["J" /* Popover */],{id:'simple-popper',open:Boolean(_this3.state.legendEl),anchorEl:_this3.state.legendEl,onClose:function onClose(){return _this3.handlePopoverClose('legendEl');},anchorOrigin:{vertical:'bottom',horizontal:'center'},transformOrigin:{vertical:'top',horizontal:'right'}},__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_ManageClientsLegend_ManageClientsLegend_jsx__["a" /* default */],null)))),__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["I" /* Paper */],{style:{overflowX:'auto'}},__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{container:true},__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{item:true,xs:6,sm:4,md:3,style:{margin:'25px auto 10px auto'}},__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["i" /* Chip */],{avatar:__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["b" /* Avatar */],{style:{backgroundColor:'#6c5cab',color:'white'}},__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["w" /* Icon */],null,'add')),className:'customChip',variant:'outlined',label:__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{color:'white'}},'Add Client'),color:'secondary',style:{backgroundColor:'#4239d659',color:'white',width:'100%'},onClick:function onClick(){_this3.props.history.push({pathname:'/app/CreateClient'});}})),__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{item:true,xs:6,sm:4,md:3,style:{margin:'25px auto 10px auto',textAlign:'center'}},__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["d" /* Button */],{variant:'outlined',style:{borderRadius:'20px',border:'1px solid #6c5cab',color:'#6c5cab'},onClick:_this3.openSearchDialog},'Advanced search')),__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{item:true,xs:12,sm:12,md:10,style:{margin:'0 auto'}},__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["X" /* TextField */],{id:'input-with-icon-textfield',fullWidth:true,style:{padding:'30px 0px 0px 0px'},placeholder:'Search Client by Name, Surname,Email or Date Created(YYYY/MM/DD)',onChange:_this3.handleSearch,InputProps:{startAdornment:__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["z" /* InputAdornment */],{position:'start'},__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_icons__["n" /* Search */],null))}}))),__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Q" /* Table */],null,__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_EnhancedTableHead_EnhancedTableHead_jsx__["a" /* default */],{order:_this3.state.order,orderBy:_this3.state.orderBy,onRequestSort:_this3.handleRequestSort,rowCount:_this3.state.searchData.length<1&&_this3.state.searchTerm!==''?_this3.state.searchData.length:qData.length,columnData:columnData}),__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["R" /* TableBody */],null,_this3.state.searchData.length<1&&_this3.state.searchTerm!==''?__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement('h3',null,'No results found'))):qData.slice(_this3.state.page*_this3.state.rowsPerPage,_this3.state.page*_this3.state.rowsPerPage+_this3.state.rowsPerPage).map(function(client){return(//Hierso moet die mutation begin
__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],{key:client.id,className:'sqDataTable',onClick:function onClick(e){return _this3.state.popoverOpen===false?_this3.handleClick(e,client.id):null;},style:_this3.state.openMenus.length>0&&_this3.state.openMenus.filter(function(m){return m.id===client.id;})[0]&&_this3.state.openMenus.filter(function(m){return m.id===client.id;})[0].open?{backgroundColor:'#dedede'}:{}},__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{style:{padding:'0px',borderRight:'1px solid #e0e0e0',backgroundColor:'white'}},__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["x" /* IconButton */],{onClick:function onClick(e){return _this3.state.popoverOpen===false?_this3.handleClick(e,client.id):null;}},__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["w" /* Icon */],null,'more_vert'))),__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{style:{borderTop:'1px solid rgba(224, 224, 224, 1)',width:'28px'}},__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement('div',{style:{display:'flex'}},__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["w" /* Icon */],{style:client.scd_clientType==='active'?{color:'#00ce00'}:client.scd_clientType==='prospect'?{color:'#fbbb00'}:{color:'red'}},'person_outline'),__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["w" /* Icon */],{style:client.app_info_complete===1?{color:'#00ce00',fontSize:'21px'}:client.scd_registered===1?{color:'#fbbb00',fontSize:'21px'}:client.invite_sent===1?{color:'red',fontSize:'21px'}:{display:'none'}},'smartphone'),!client.terrorCheck&&__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["w" /* Icon */],{style:{color:'#fbbb00',fontSize:'21px'}},'warning'),client.terrorStatus&&__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["w" /* Icon */],{style:{color:'red',fontSize:'21px'}},'fingerprint'))),__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,client.scd_name,' ',client.scd_surname),__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,client.scd_email),__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,Object(__WEBPACK_IMPORTED_MODULE_9_helpers_DateHelpers__["a" /* DateTimeFormatter */])(client.date_modified)),__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["J" /* Popover */],{open:_this3.state.openMenus.length>0&&_this3.state.openMenus.filter(function(m){return m.id===client.id;})[0]?_this3.state.openMenus.filter(function(m){return m.id===client.id;})[0].open:false,anchorReference:'anchorPosition',anchorPosition:{left:_this3.state.anchorLeft,top:_this3.state.anchorTop},onClose:function onClose(){return _this3.handleClose(client.id);}},__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["C" /* List */],{component:'nav'},_this3.state.clientStatus==='own'?__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["D" /* ListItem */],{button:true,onClick:function onClick(){return _this3.handleEdit(client);}},__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["E" /* ListItemText */],{primary:'View/Edit Client'})),__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["p" /* Divider */],null),__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["D" /* ListItem */],{button:true,onClick:function onClick(){_this3.handleSendAppInvite(client.id,client.scd_email,refetch);_this3.handleClose(client.id);}},__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["E" /* ListItemText */],{primary:'Send App Invite'})),__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["p" /* Divider */],null),__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["D" /* ListItem */],{button:true,onClick:function onClick(){return _this3.handleEdit(client,'documents');}},__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["E" /* ListItemText */],{primary:'View/Add Documents'})),__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["p" /* Divider */],null),__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_react_apollo__["Mutation"],{mutation:__WEBPACK_IMPORTED_MODULE_15_queries_QuoteEligibility__["a" /* QuoteEligibility */],onCompleted:function onCompleted(data){var quoteEligibility=data.QuoteEligibility;if(!quoteEligibility.valid){var invalidFields=quoteEligibility.invalidFields.split(',');_this3.setState({eligibilityDialogOpen:true,invalidFields:invalidFields,selectedClient:client});}else{_this3.handleNewQuote(client.id);}},onError:function onError(error){}},function(mutate){return __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["D" /* ListItem */],{button:true,onClick:function onClick(){return mutate({variables:{input:{clientId:atob(client.id).split(':')[1]}}});}},__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["E" /* ListItemText */],{primary:'New Quote'}));}),__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["p" /* Divider */],null),__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["D" /* ListItem */],{button:true,onClick:function onClick(){return _this3.handleViewQuote(client);}},__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["E" /* ListItemText */],{primary:'View Previous Quotes'})),__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["p" /* Divider */],null),__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["D" /* ListItem */],{button:true,onClick:function onClick(){return _this3.handleRequestAstute(client.id);}},__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["E" /* ListItemText */],{primary:'Request Astute'})),__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["p" /* Divider */],null),__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["D" /* ListItem */],{button:true,onClick:function onClick(){return _this3.handleMedical(client);}},__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["E" /* ListItemText */],{primary:'New Medical Aid Quote'})),__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["p" /* Divider */],null),__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_react_apollo__["Mutation"],{mutation:updateClientStatus,onCompleted:function onCompleted(data){__WEBPACK_IMPORTED_MODULE_23_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_21_reducers_NotificationReducer__["e" /* successWarning */])({open:true,title:'Client Deleted.'})),refetch();},onError:function onError(error){__WEBPACK_IMPORTED_MODULE_23_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_21_reducers_NotificationReducer__["d" /* showSnack */])({message:'There was an error deleting the client.'+error,color:'danger'}));}},function(statusMutation){return __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["D" /* ListItem */],{button:true,onClick:function onClick(){_this3.handleClose(client.id);statusMutation({variables:{input:{brokerId:Object(__WEBPACK_IMPORTED_MODULE_12_helpers_UserHelper__["a" /* GetUserId */])(),token:Object(__WEBPACK_IMPORTED_MODULE_12_helpers_UserHelper__["c" /* GetUserToken */])(),clientId:atob(client.id).split(':')[1],status:'deleted'}}});}},__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["E" /* ListItemText */],{primary:'Delete Client'}));})):_this3.state.clientStatus==='shared'?__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_react_apollo__["Mutation"],{mutation:updateClientStatus,onCompleted:function onCompleted(data){__WEBPACK_IMPORTED_MODULE_23_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_21_reducers_NotificationReducer__["e" /* successWarning */])({open:true,title:'Client Claimed.'})),refetch();},onError:function onError(error){__WEBPACK_IMPORTED_MODULE_23_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_21_reducers_NotificationReducer__["d" /* showSnack */])({message:'There was an error claiming this client.'+error,color:'danger'}));}},function(statusMutation){return __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["D" /* ListItem */],{button:true,onClick:function onClick(){_this3.handleClose(client.id);statusMutation({variables:{input:{brokerId:Object(__WEBPACK_IMPORTED_MODULE_12_helpers_UserHelper__["a" /* GetUserId */])(),token:Object(__WEBPACK_IMPORTED_MODULE_12_helpers_UserHelper__["c" /* GetUserToken */])(),clientId:atob(client.id).split(':')[1],status:'own'}}});}},__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["E" /* ListItemText */],{primary:'Claim Client'}));}):__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_react_apollo__["Mutation"],{mutation:updateClientStatus,onCompleted:function onCompleted(data){__WEBPACK_IMPORTED_MODULE_23_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_21_reducers_NotificationReducer__["e" /* successWarning */])({open:true,title:'Client Reclaimed.'})),refetch();},onError:function onError(error){__WEBPACK_IMPORTED_MODULE_23_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_21_reducers_NotificationReducer__["d" /* showSnack */])({message:'There was an error reclaiming this client.'+error,color:'danger'}));}},function(statusMutation){return __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["D" /* ListItem */],{button:true,onClick:function onClick(){_this3.handleClose(client.id);statusMutation({variables:{input:{brokerId:Object(__WEBPACK_IMPORTED_MODULE_12_helpers_UserHelper__["a" /* GetUserId */])(),token:Object(__WEBPACK_IMPORTED_MODULE_12_helpers_UserHelper__["c" /* GetUserToken */])(),clientId:atob(client.id).split(':')[1],status:'own'}}});}},__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["E" /* ListItemText */],{primary:'Reclaim Client'}));}),__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["p" /* Divider */],null),__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_react_apollo__["Mutation"],{mutation:deleteClient,onCompleted:function onCompleted(data){__WEBPACK_IMPORTED_MODULE_23_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_21_reducers_NotificationReducer__["e" /* successWarning */])({open:true,title:'Client Permanently Deleted.'})),refetch();},onError:function onError(error){__WEBPACK_IMPORTED_MODULE_23_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_21_reducers_NotificationReducer__["d" /* showSnack */])({message:'There was an error permanently deleting this client.'+error,color:'danger'}));}},function(deleteClientMutation){return __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["D" /* ListItem */],{button:true,onClick:function onClick(){_this3.handleClose(client.id);deleteClientMutation({variables:{input:{token:Object(__WEBPACK_IMPORTED_MODULE_12_helpers_UserHelper__["c" /* GetUserToken */])(),clientId:atob(client.id).split(':')[1]}}});}},__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["E" /* ListItemText */],{primary:'Permanently Delete Client'}));}))))));}),__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["U" /* TablePagination */],{count:_this3.state.searchData.length<1&&_this3.state.searchTerm!==''?_this3.state.searchData.length:qData.length,rowsPerPage:_this3.state.rowsPerPage,page:_this3.state.page,backIconButtonProps:{'aria-label':'Previous Page'},nextIconButtonProps:{'aria-label':'Next Page'},onChangePage:_this3.handleChangePage,onChangeRowsPerPage:_this3.handleChangeRowsPerPage}))))))))),__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["N" /* Snackbar */],{anchorOrigin:{vertical:'bottom',horizontal:'right'},open:_this3.state.openLoadingSnack,ContentProps:{'aria-describedby':'message-id'},message:__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["j" /* CircularProgress */],{color:'secondary',size:20,style:{marginRight:'15px',position:'relative',top:'5px'}}),_this3.state.loadingSnackText)}),__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__ClientImportModal_jsx__["a" /* default */],{open:_this3.state.openDialog,closeDialog:_this3.handleCloseClientImport,userType:Object(__WEBPACK_IMPORTED_MODULE_12_helpers_UserHelper__["b" /* GetUserKey */])('userType'),loadingSnack:_this3.loadingSnack,doneImporting:function doneImporting(){return __WEBPACK_IMPORTED_MODULE_23_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_21_reducers_NotificationReducer__["e" /* successWarning */])({open:true,title:'Clients Imported!',onConfirm:function onConfirm(){return _this3.props.history.push({pathname:'/app/ManageClients'});}}));}}),_this3.state.eligibilityDialogOpen?__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19_react_bootstrap_sweetalert___default.a,{warning:true,style:{wordWrap:'break-word',top:'40%'},title:'Ineligible',confirmBtnCssClass:_this3.props.classes.button+' '+_this3.props.classes.success,cancelBtnCssClass:_this3.props.classes.button+' '+_this3.props.classes.danger,confirmBtnText:'Edit Client',cancelBtnText:'Close',onConfirm:function onConfirm(){_this3.handleEdit(_this3.state.selectedClient);},onCancel:function onCancel(){_this3.setState({eligibilityDialogOpen:false});},showCancel:!_this3.state.loadingDelete,showConfirm:!_this3.state.loadingDelete},__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],null,_this3.state.selectedClient.scd_name+' '+_this3.state.selectedClient.scd_surname+' ','is ineligible for a quote.'),__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],null,'Please update the following fields: '),__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{container:true,className:'invalidListBlock'},_this3.state.invalidFields.map(function(i){return __WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{item:true,xs:12,sm:6,md:6},__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],null,i));}))):null,_this3.state.openSearchDialog?__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__advanced_search_SearchDialog_jsx__["a" /* default */],{history:_this3.props.history,open:true,closeDialog:_this3.closeSearchDialog}):null);});}}]);return ManageClients;}(__WEBPACK_IMPORTED_MODULE_17_react___default.a.Component);ManageClients=Object(__WEBPACK_IMPORTED_MODULE_18_react_apollo__["compose"])(Object(__WEBPACK_IMPORTED_MODULE_18_react_apollo__["graphql"])(__WEBPACK_IMPORTED_MODULE_13_queries_clients_mutations__["a" /* SendAppInvite */],{name:'SendAppInvite'}),Object(__WEBPACK_IMPORTED_MODULE_18_react_apollo__["graphql"])(__WEBPACK_IMPORTED_MODULE_16_queries_Submit__["a" /* newQuoteMutation */],{name:'newQuoteMutation'}))(ManageClients);/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles_withStyles___default()(__WEBPACK_IMPORTED_MODULE_4_assets_jss_material_dashboard_pro_react_views_sweetAlertStyle_jsx__["a" /* default */])(ManageClients));

/***/ }),
/* 2435 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_core__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
var manageClientsLegend=function manageClientsLegend(props){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["e" /* Card */],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["f" /* CardContent */],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{style:{marginBottom:"15px"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{variant:"subheading",gutterBottom:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("strong",null,"Client Status:")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{style:{display:"block"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{style:{display:"flex",marginBottom:"10px"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["w" /* Icon */],{style:{color:"#00ce00",marginRight:"10px"}},"person_outline"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],null," Active")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{style:{display:"flex",marginBottom:"10px"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["w" /* Icon */],{style:{color:"#fbbb00",marginRight:"10px"}},"person_outline"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],null," Prospect")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{style:{display:"flex",marginBottom:"10px"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["w" /* Icon */],{style:{color:"red",marginRight:"10px"}},"person_outline"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],null," NA")))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{variant:"subheading",gutterBottom:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("strong",null,"App Status:")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{style:{display:"block"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{style:{display:"flex",marginBottom:"10px"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["w" /* Icon */],{style:{color:"#00ce00",marginRight:"10px"}},"smartphone"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],null,"Info up to date")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{style:{display:"flex",marginBottom:"10px"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["w" /* Icon */],{style:{color:"#fbbb00",marginRight:"10px"}},"smartphone"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],null,"Registered")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{style:{display:"flex",marginBottom:"10px"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["w" /* Icon */],{style:{color:"red",marginRight:"10px"}},"smartphone"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],null,"Invite Sent")))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{style:{marginBottom:"15px"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{variant:"subheading",gutterBottom:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("strong",null,"Terror Status:")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{style:{display:"block"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{style:{display:"flex",marginBottom:"10px"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["w" /* Icon */],{style:{color:"#fbbb00",marginRight:"10px"}},"warning"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],null," Pending terror list check")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{style:{display:"flex",marginBottom:"10px"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["w" /* Icon */],{style:{color:"red",marginRight:"10px"}},"fingerprint"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],null," Terror list warning"))))));};/* harmony default export */ __webpack_exports__["a"] = (manageClientsLegend);

/***/ }),
/* 2436 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ImportClients */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_apollo__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_graphql_tag__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_graphql_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_graphql_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_store__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dropzone__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_helpers_UserHelper__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_apollo_cache_inmemory__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_apollo_client__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_constants_js__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_apollo_upload_client_lib_main__ = __webpack_require__(2437);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_apollo_upload_client_lib_main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_apollo_upload_client_lib_main__);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(["\n  mutation importClients($input: ImportClientsInput!) {\n    ImportClients(input: $input) {\n      clientMutationId\n    }\n  }\n"],["\n  mutation importClients($input: ImportClientsInput!) {\n    ImportClients(input: $input) {\n      clientMutationId\n    }\n  }\n"]),_templateObject2=_taggedTemplateLiteral(["\n  mutation($file: Upload!, $id: String!) {\n    uploadClientsCsvWithId(file: $file, id: $id)\n  }\n"],["\n  mutation($file: Upload!, $id: String!) {\n    uploadClientsCsvWithId(file: $file, id: $id)\n  }\n"]);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}/*eslint-disable*/var client=new __WEBPACK_IMPORTED_MODULE_8_apollo_client__["ApolloClient"]({link:Object(__WEBPACK_IMPORTED_MODULE_10_apollo_upload_client_lib_main__["createUploadLink"])({uri:__WEBPACK_IMPORTED_MODULE_9_constants_js__["d" /* fileUploadServerPath */]}),cache:new __WEBPACK_IMPORTED_MODULE_7_apollo_cache_inmemory__["a" /* InMemoryCache */]()});var ImportClients=__WEBPACK_IMPORTED_MODULE_2_graphql_tag___default()(_templateObject);var uploadCsvMutation=__WEBPACK_IMPORTED_MODULE_2_graphql_tag___default()(_templateObject2);// "Avalon", "XPlan", "Sanfin", "Momentum"
var crmOptions=["Atwork","Other"];var csOptions=["Own","Shared"];var ClientImportModal=function(_React$PureComponent){_inherits(ClientImportModal,_React$PureComponent);function ClientImportModal(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ClientImportModal);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ClientImportModal.__proto__||Object.getPrototypeOf(ClientImportModal)).call.apply(_ref,[this].concat(args))),_this),_this.state={importClientStatus:"Own",selectedImportComp:"Atwork",openDropzone:false,popoverText:"",dialogTitle:"",popoverOpen:false,newCompImp:null},_this.changeImportProvider=function(event){_this.setState({selectedImportComp:event.target.value});},_this.changeImportStatus=function(event){_this.setState({importClientStatus:_this.props.userType==="3"?event.target.value:"Own"});},_this.handleOtherCompany=function(event){_this.setState({newCompImp:event.target.value});console.log(_this.state.newCompImp);},_this.closeDialog=function(){_this.props.closeDialog(false);},_this.importSuccess=function(){_this.props.loadingSnack(true,"Importing Clients...");_this.props.doneImporting();},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ClientImportModal,[{key:"render",value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_apollo__["Mutation"],{mutation:ImportClients,onCompleted:function onCompleted(data){_this2.importSuccess();_this2.props.loadingSnack(false,"");}},function(mutateClients){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_apollo__["Mutation"],{client:client,mutation:uploadCsvMutation,onCompleted:function onCompleted(data){_this2.setState({});_this2.props.closeDialog(true);_this2.props.loadingSnack(true,"Importing Clients...");mutateClients({variables:{input:{csvPath:data.uploadClientsCsvWithId,brokerId:Object(__WEBPACK_IMPORTED_MODULE_6_helpers_UserHelper__["a" /* GetUserId */])(),clientStatus:_this2.state.importClientStatus,userType:Object(__WEBPACK_IMPORTED_MODULE_6_helpers_UserHelper__["b" /* GetUserKey */])("userType"),importCompany:_this2.state.importClientStatus}}});}},function(mutate){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core__["k" /* Dialog */],{open:_this2.props.open,onClose:function onClose(){return _this2.closeDialog();},className:"importDialog"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core__["o" /* DialogTitle */],null,"Importing Clients"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core__["m" /* DialogContent */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core__["Z" /* Typography */],{variant:"subheading"},"Import Company :"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core__["v" /* Grid */],{container:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core__["v" /* Grid */],{item:true,xs:12,sm:6,md:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core__["M" /* Select */],{style:{position:"relative",top:"17px"},name:"CompanyImport",value:_this2.state.selectedImportComp,onChange:_this2.changeImportProvider},crmOptions.map(function(option){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core__["F" /* MenuItem */],{key:option,value:option},option);}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core__["v" /* Grid */],{item:true,xs:12,sm:6,md:8},_this2.state.selectedImportComp==="Other"&&// <TextField
//   label={"Company Name"}
//   placeholder={"Other"}
//   onChange={(event) => this.handleOtherCompany(event)}
// />
__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Please send us an email with the CSV file you want to import with the company name from who the CSV file is from, and we will add it to our list of Import Companies. info@availsoft.co.za"))),Object(__WEBPACK_IMPORTED_MODULE_6_helpers_UserHelper__["b" /* GetUserKey */])("userType")==="3"?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core__["p" /* Divider */],{style:{marginTop:"27px"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core__["Z" /* Typography */],{variant:"subheading",style:{marginTop:"10px"}},"Status of Clients being Imported :"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core__["L" /* RadioGroup */],{name:"importStatus",value:_this2.state.importClientStatus,onChange:_this2.changeImportStatus},csOptions.map(function(option){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core__["u" /* FormControlLabel */],{value:option,key:option,control:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core__["K" /* Radio */],null),label:option});}))):null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core__["l" /* DialogActions */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core__["d" /* Button */],{onClick:function onClick(){return _this2.closeDialog();},color:"primary"},"Cancel"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_dropzone__["a" /* default */],{style:{width:"fit-content",height:"fit-content",border:"none"},onDrop:function onDrop(_ref2){var _ref3=_slicedToArray(_ref2,1),file=_ref3[0];mutate({variables:{file:file,id:__WEBPACK_IMPORTED_MODULE_3_store__["a" /* default */].getState().login.userID}});}},_this2.state.selectedImportComp==="Other"?null:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core__["d" /* Button */],{color:"primary"},"Import")))));});});}}]);return ClientImportModal;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);/* harmony default export */ __webpack_exports__["a"] = (ClientImportModal);

/***/ }),
/* 2437 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(2438)

Object.defineProperty(exports, '__esModule', {
  value: true
})
Object.defineProperty(exports, 'ReactNativeFile', {
  enumerable: true,
  get: function get() {
    return _extractFiles.ReactNativeFile
  }
})
exports.createUploadLink = void 0

__webpack_require__(371)

__webpack_require__(596)

var _apolloLink = __webpack_require__(95)

var _apolloLinkHttpCommon = __webpack_require__(380)

var _extractFiles = _interopRequireDefault(__webpack_require__(381))

var createUploadLink = function createUploadLink() {
  var _ref =
      arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref$uri = _ref.uri,
    fetchUri = _ref$uri === void 0 ? '/graphql' : _ref$uri,
    _ref$fetch = _ref.fetch,
    linkFetch = _ref$fetch === void 0 ? fetch : _ref$fetch,
    fetchOptions = _ref.fetchOptions,
    credentials = _ref.credentials,
    headers = _ref.headers,
    includeExtensions = _ref.includeExtensions

  var linkConfig = {
    http: {
      includeExtensions: includeExtensions
    },
    options: fetchOptions,
    credentials: credentials,
    headers: headers
  }
  return new _apolloLink.ApolloLink(function(operation) {
    var uri = (0, _apolloLinkHttpCommon.selectURI)(operation, fetchUri)
    var context = operation.getContext()
    var contextConfig = {
      http: context.http,
      options: context.fetchOptions,
      credentials: context.credentials,
      headers: context.headers
    }

    var _selectHttpOptionsAnd = (0,
      _apolloLinkHttpCommon.selectHttpOptionsAndBody)(
        operation,
        _apolloLinkHttpCommon.fallbackHttpConfig,
        linkConfig,
        contextConfig
      ),
      options = _selectHttpOptionsAnd.options,
      body = _selectHttpOptionsAnd.body

    var files = (0, _extractFiles.default)(body)
    var payload = (0, _apolloLinkHttpCommon.serializeFetchParameter)(
      body,
      'Payload'
    )

    if (files.length) {
      delete options.headers['content-type']
      options.body = new FormData()
      options.body.append('operations', payload)
      options.body.append(
        'map',
        JSON.stringify(
          files.reduce(function(map, _ref2, index) {
            var path = _ref2.path
            map[''.concat(index)] = [path]
            return map
          }, {})
        )
      )
      files.forEach(function(_ref3, index) {
        var file = _ref3.file
        return options.body.append(index, file, file.name)
      })
    } else options.body = payload

    return new _apolloLink.Observable(function(observer) {
      var _createSignalIfSuppor = (0,
        _apolloLinkHttpCommon.createSignalIfSupported)(),
        controller = _createSignalIfSuppor.controller,
        signal = _createSignalIfSuppor.signal

      if (controller) options.signal = signal
      linkFetch(uri, options)
        .then(function(response) {
          operation.setContext({
            response: response
          })
          return response
        })
        .then((0, _apolloLinkHttpCommon.parseAndCheckHttpResponse)(operation))
        .then(function(result) {
          observer.next(result)
          observer.complete()
        })
        .catch(function(error) {
          if (error.name === 'AbortError') return
          if (error.result && error.result.errors && error.result.data)
            observer.next(error.result)
          observer.error(error)
        })
      return function() {
        if (controller) controller.abort()
      }
    })
  })
}

exports.createUploadLink = createUploadLink


/***/ }),
/* 2438 */
/***/ (function(module, exports) {

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

module.exports = _interopRequireDefault;

/***/ }),
/* 2439 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_core__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_Wrappers_materialUIWrappers_components_AutofillV3__ = __webpack_require__(620);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Wrappers_materialUIWrappers_components_FormDropDown__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Wrappers_materialUIWrappers_components_FormInput__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_Wrappers_materialUIWrappers_components_DayMonth__ = __webpack_require__(2440);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_helpers_UserHelper__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_queries_OccupationSearch__ = __webpack_require__(2441);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_apollo__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_redux_form__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_store__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_helpers_ValidationHelpers__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_helpers_DateHelpers__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_reducers_NotificationReducer__ = __webpack_require__(30);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var charMin3=function charMin3(value){return!value?undefined:value.length>2?undefined:"Must be at least 3 characters";};var FromToGrid=function FromToGrid(props){return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:6,md:6,style:{marginBottom:"25px"}},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{container:true,style:{border:"1px solid #ccc",position:"relative"}},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{className:"floatyLabelTopLeft"},props.label),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{item:true,xs:6,sm:6,md:6,style:{marginTop:"20px",padding:"10px"}},props.from),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{item:true,xs:6,sm:6,md:6,style:{marginTop:"20px",padding:"10px"}},props.to)));};var SearchDialog=function(_React$Component){_inherits(SearchDialog,_React$Component);function SearchDialog(){var _ref;var _temp,_this,_ret;_classCallCheck(this,SearchDialog);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=SearchDialog.__proto__||Object.getPrototypeOf(SearchDialog)).call.apply(_ref,[this].concat(args))),_this),_this.state={checkValidation:false,loadingSubmit:false,occupation:"",trySubmit:false},_this.birthdayToValid=function(value){if(Object(__WEBPACK_IMPORTED_MODULE_13_helpers_ValidationHelpers__["c" /* isEmptyOrSpaces */])(value)){return undefined;}var birthdayFrom=Object(__WEBPACK_IMPORTED_MODULE_11_lodash__["get"])(__WEBPACK_IMPORTED_MODULE_12_store__["a" /* default */].getState().form.advancedSearch,"values.birthdayFrom",null);if(!birthdayFrom||birthdayFrom.length!==5)return undefined;if(!Object(__WEBPACK_IMPORTED_MODULE_14_helpers_DateHelpers__["f" /* validateDateRange */])(birthdayFrom+"/2018",value+"/2018")){return"Must be later than from date";}return undefined;},_this.anneversaryToValid=function(value){if(Object(__WEBPACK_IMPORTED_MODULE_13_helpers_ValidationHelpers__["c" /* isEmptyOrSpaces */])(value)){return undefined;}var anneversaryFrom=Object(__WEBPACK_IMPORTED_MODULE_11_lodash__["get"])(__WEBPACK_IMPORTED_MODULE_12_store__["a" /* default */].getState().form.advancedSearch,"values.anneversaryFrom",null);if(!anneversaryFrom||anneversaryFrom.length!==5)return undefined;if(!Object(__WEBPACK_IMPORTED_MODULE_14_helpers_DateHelpers__["f" /* validateDateRange */])(anneversaryFrom+"/2018",value+"/2018")){return"Must be later than from date";}return undefined;},_this.incomeToValid=function(value){if(Object(__WEBPACK_IMPORTED_MODULE_13_helpers_ValidationHelpers__["c" /* isEmptyOrSpaces */])(value)){return undefined;}var incomeMin=Object(__WEBPACK_IMPORTED_MODULE_11_lodash__["get"])(__WEBPACK_IMPORTED_MODULE_12_store__["a" /* default */].getState().form.advancedSearch,"values.incomeMin",null);if(!incomeMin)return undefined;if(incomeMin>value){return"Must be greater than minimum";}return undefined;},_this.ageMaxValid=function(value){if(Object(__WEBPACK_IMPORTED_MODULE_13_helpers_ValidationHelpers__["c" /* isEmptyOrSpaces */])(value)){return undefined;}var ageMin=Object(__WEBPACK_IMPORTED_MODULE_11_lodash__["get"])(__WEBPACK_IMPORTED_MODULE_12_store__["a" /* default */].getState().form.advancedSearch,"values.ageMin",null);if(!ageMin)return undefined;if(ageMin>value){return"Must be greater than minimum";}return undefined;},_this.onSubmit=function(){_this.setState({trySubmit:true});if(__WEBPACK_IMPORTED_MODULE_12_store__["a" /* default */].getState().form.advancedSearch.syncErrors){__WEBPACK_IMPORTED_MODULE_12_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_15_reducers_NotificationReducer__["d" /* showSnack */])({message:"Invalid Information",color:"danger"}));_this.setState({checkValidation:true});_this.forceUpdate();return;}var search=Object(__WEBPACK_IMPORTED_MODULE_11_lodash__["get"])(__WEBPACK_IMPORTED_MODULE_12_store__["a" /* default */].getState().form.advancedSearch,"values",null);if(!search)return;var searchString="";searchString+=!Object(__WEBPACK_IMPORTED_MODULE_13_helpers_ValidationHelpers__["c" /* isEmptyOrSpaces */])(search.occupation)?"occupation="+search.occupation:"";searchString+=!Object(__WEBPACK_IMPORTED_MODULE_13_helpers_ValidationHelpers__["c" /* isEmptyOrSpaces */])(_this.dropDownValidate(search.title))?"&title="+search.title:"";searchString+=!Object(__WEBPACK_IMPORTED_MODULE_13_helpers_ValidationHelpers__["c" /* isEmptyOrSpaces */])(_this.dropDownValidate(search.language))?"&language="+search.language:"";searchString+=!Object(__WEBPACK_IMPORTED_MODULE_13_helpers_ValidationHelpers__["c" /* isEmptyOrSpaces */])(_this.dropDownValidate(search.smoker))?"&smoker="+search.smoker:"";searchString+=!Object(__WEBPACK_IMPORTED_MODULE_13_helpers_ValidationHelpers__["c" /* isEmptyOrSpaces */])(search.birthdayFrom)?"&birthdayFrom="+search.birthdayFrom:"";searchString+=!Object(__WEBPACK_IMPORTED_MODULE_13_helpers_ValidationHelpers__["c" /* isEmptyOrSpaces */])(search.birthdayTo)?"&birthdayTo="+search.birthdayTo:"";searchString+=!Object(__WEBPACK_IMPORTED_MODULE_13_helpers_ValidationHelpers__["c" /* isEmptyOrSpaces */])(search.anneversaryFrom)?"&anneversaryFrom="+search.anneversaryFrom:"";searchString+=!Object(__WEBPACK_IMPORTED_MODULE_13_helpers_ValidationHelpers__["c" /* isEmptyOrSpaces */])(search.anneversaryTo)?"&anneversaryTo="+search.anneversaryTo:"";searchString+=!Object(__WEBPACK_IMPORTED_MODULE_13_helpers_ValidationHelpers__["c" /* isEmptyOrSpaces */])(search.incomeMin)?"&incomeFrom="+search.incomeMin:"";searchString+=!Object(__WEBPACK_IMPORTED_MODULE_13_helpers_ValidationHelpers__["c" /* isEmptyOrSpaces */])(search.incomeMax)?"&incomeTo="+search.incomeMax:"";searchString+=!Object(__WEBPACK_IMPORTED_MODULE_13_helpers_ValidationHelpers__["c" /* isEmptyOrSpaces */])(search.ageMin)?"&ageFrom="+search.ageMin:"";searchString+=!Object(__WEBPACK_IMPORTED_MODULE_13_helpers_ValidationHelpers__["c" /* isEmptyOrSpaces */])(search.ageMax)?"&ageTo="+search.ageMax:"";console.log("searchString:",searchString);_this.props.history.push({pathname:"/app/advancedsearch",search:searchString});},_this.dropDownValidate=function(value){return value&&value!=="validationError";},_this.occupationTextChanged=function(event,refetch){if(event&&event.target){_this.setState({occupation:event.target.value});refetch();}},_this.occupationSelected=function(displayText,id,refetch){_this.setState({occupation:displayText});refetch();},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(SearchDialog,[{key:"render",value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["k" /* Dialog */],{open:this.props.open,onClose:this.props.closeDialog,className:"centerFixedDialog"},this.state.loadingSubmit?null:__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["o" /* DialogTitle */],{id:"form-dialog-title",style:{textAlign:"center"}},"Advanced Search"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["m" /* DialogContent */],{style:{paddingTop:"20px"}},this.state.loadingSubmit?__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("div",{style:{textAlign:"center"}},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{marginBottom:"15px"}},"Saving..."),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["j" /* CircularProgress */],{size:25})):__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{container:true},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_apollo__["Query"],{query:__WEBPACK_IMPORTED_MODULE_7_queries_OccupationSearch__["a" /* OccupationSearch */],variables:{search:this.state.occupation.length>2?this.state.occupation:"",token:Object(__WEBPACK_IMPORTED_MODULE_6_helpers_UserHelper__["c" /* GetUserToken */])()},fetchPolicy:"network-only"},function(_ref2){var loading=_ref2.loading,error=_ref2.error,data=_ref2.data,refetch=_ref2.refetch;return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:6,md:6,style:{marginBottom:"10px"}},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["t" /* FormControl */],{fullWidth:true},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_2_components_Wrappers_materialUIWrappers_components_AutofillV3__["a" /* default */],validate:[charMin3],absolute:true,name:"occupation",label:"Occupation",checkValidation:_this2.state.checkValidation,onChange:function onChange(e){return _this2.occupationTextChanged(e,refetch);},onItemSelect:function onItemSelect(displayText,id){return _this2.occupationSelected(displayText,id,refetch);},autoFillList:!loading&&data.OccupationSearch?data.OccupationSearch:[],loading:loading,listName:"Occupations",zIndex:1000,displayText:"name"})));}),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:6,md:6,style:{marginBottom:"10px"}},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["t" /* FormControl */],{fullWidth:true},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_3_components_Wrappers_materialUIWrappers_components_FormDropDown__["a" /* default */],checkValidation:this.state.checkValidation,label:"Title",name:"title",options:[{value:"validationError",displayValue:"Please select"},{value:"MR",displayValue:"MR"},{value:"MRS",displayValue:"MRS"},{value:"MISS",displayValue:"MISS"},{value:"MS",displayValue:"MS"},{value:"ADV",displayValue:"ADV"},{value:"DR",displayValue:"DR"},{value:"JUDG",displayValue:"JUDGE"},{value:"PROF",displayValue:"PROF"}]}))),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:6,md:6,style:{marginBottom:"10px"}},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["t" /* FormControl */],{fullWidth:true},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_3_components_Wrappers_materialUIWrappers_components_FormDropDown__["a" /* default */],label:"Language",name:"language",options:[{value:"validationError",displayValue:"Please select"},{value:"english",displayValue:"English"},{value:"afrikaans",displayValue:"Afrikaans"}]}))),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:6,md:6,style:{marginBottom:"35px"}},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["t" /* FormControl */],{fullWidth:true},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_3_components_Wrappers_materialUIWrappers_components_FormDropDown__["a" /* default */],checkValidation:this.props.checkValidation,label:"Smoker?",name:"smoker",options:[{value:"validationError",displayValue:"Please select"},{value:"N",displayValue:"No"},{value:"Y",displayValue:"Yes"}]}))),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(FromToGrid,{label:"Birthday",from:__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],null,"From"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["t" /* FormControl */],{fullWidth:true},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_5_components_Wrappers_materialUIWrappers_components_DayMonth__["a" /* default */],name:"birthdayFrom",placeholder:"DD/MM",checkValidation:this.state.checkValidation,validate:[__WEBPACK_IMPORTED_MODULE_13_helpers_ValidationHelpers__["d" /* monthDayValid */]]}))),to:__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],null,"To"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["t" /* FormControl */],{fullWidth:true},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_5_components_Wrappers_materialUIWrappers_components_DayMonth__["a" /* default */],name:"birthdayTo",placeholder:"DD/MM",validate:[__WEBPACK_IMPORTED_MODULE_13_helpers_ValidationHelpers__["d" /* monthDayValid */],this.birthdayToValid]})))}),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(FromToGrid,{label:"Anneversary",from:__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],null,"From"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["t" /* FormControl */],{fullWidth:true},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_5_components_Wrappers_materialUIWrappers_components_DayMonth__["a" /* default */],name:"anneversaryFrom",placeholder:"DD/MM",validate:[__WEBPACK_IMPORTED_MODULE_13_helpers_ValidationHelpers__["d" /* monthDayValid */]]}))),to:__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],null,"To"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["t" /* FormControl */],{fullWidth:true},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_5_components_Wrappers_materialUIWrappers_components_DayMonth__["a" /* default */],name:"anneversaryTo",placeholder:"DD/MM",validate:[__WEBPACK_IMPORTED_MODULE_13_helpers_ValidationHelpers__["d" /* monthDayValid */],this.anneversaryToValid]})))}),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(FromToGrid,{label:"Income",from:__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["t" /* FormControl */],{fullWidth:true},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_4_components_Wrappers_materialUIWrappers_components_FormInput__["a" /* default */],label:"Minimum",name:"incomeMin",checkValidation:this.state.checkValidation}))),to:__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["t" /* FormControl */],{fullWidth:true},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_4_components_Wrappers_materialUIWrappers_components_FormInput__["a" /* default */],label:"Maximum",name:"incomeMax",validate:[this.incomeToValid],checkValidation:this.state.checkValidation})))}),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(FromToGrid,{label:"Age",from:__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["t" /* FormControl */],{fullWidth:true},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_4_components_Wrappers_materialUIWrappers_components_FormInput__["a" /* default */],label:"Minimum",name:"ageMin",checkValidation:this.state.checkValidation}))),to:__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["t" /* FormControl */],{fullWidth:true},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_4_components_Wrappers_materialUIWrappers_components_FormInput__["a" /* default */],label:"Maximum",name:"ageMax",validate:[this.ageMaxValid],checkValidation:this.state.checkValidation})))}),this.state.loading?__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{item:true,xs:12,sm:12,style:{textAlign:"center",margin:"40px 0px 0px"}},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["j" /* CircularProgress */],{color:"secondary",size:30})):null)),this.state.loadingSubmit?null:__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["l" /* DialogActions */],null,__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["d" /* Button */],{color:"primary",onClick:this.props.closeDialog},"Cancel"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["d" /* Button */],{color:"primary",onClick:this.onSubmit},"Search")));}}]);return SearchDialog;}(__WEBPACK_IMPORTED_MODULE_8_react___default.a.Component);SearchDialog=Object(__WEBPACK_IMPORTED_MODULE_10_redux_form__["e" /* reduxForm */])({form:"advancedSearch",destroyOnUnmount:true})(SearchDialog);/* harmony default export */ __webpack_exports__["a"] = (SearchDialog);

/***/ }),
/* 2440 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_core__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/*eslint-disable*/var styles=function styles(theme){return{textField:{width:"100%",marginTop:0,marginBottom:0}};};var chars="0123456789/";var FormInputClass=function(_React$Component){_inherits(FormInputClass,_React$Component);function FormInputClass(props){_classCallCheck(this,FormInputClass);var _this=_possibleConstructorReturn(this,(FormInputClass.__proto__||Object.getPrototypeOf(FormInputClass)).call(this,props));_this.handleChange=function(event,value){event.preventDefault();var length=event.target.value.length;if(length==2&&value.length<3){event.target.value=event.target.value+"/";}if(_this.props.input.onChange){_this.props.input.onChange(event);_this.props.input.onBlur(event);}};return _this;}_createClass(FormInputClass,[{key:"shouldComponentUpdate",value:function shouldComponentUpdate(nextProps){var _this2=this;var comparedState=false;Object.keys(this.props).map(function(s){if(_this2.props[s]!==nextProps[s]){comparedState=true;}return s;});return comparedState;}},{key:"render",value:function render(){var _this3=this;this.props.meta.valid=false;var trySubmit=this.props.checkValidation?true:false;var _props$meta=this.props.meta,touched=_props$meta.touched,error=_props$meta.error,warning=_props$meta.warning;var lValue=this.props.fixedValue?this.props.fixedValue:this.props.input.value;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["X" /* TextField */],{onChange:function onChange(e){return _this3.handleChange(e,lValue);},id:this.props.input.name,value:lValue?lValue:"",label:this.props.label,className:this.props.classes.textField,margin:"normal",error:error&&error.length>0&&(touched||this.props.fixedValue)?true:error&&error.length>0&&trySubmit?true:false,helperText:error&&(touched||this.props.fixedValue)||error&&trySubmit?error:null,InputProps:{readOnly:this.props.readOnly?true:false},placeholder:this.props.placeholder});}}]);return FormInputClass;}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["_1" /* withStyles */])(styles)(FormInputClass));

/***/ }),
/* 2441 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return OccupationSearch; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_graphql_tag__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_graphql_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_graphql_tag__);
var _templateObject=_taggedTemplateLiteral(["\n  query cccupationSearch($search: String!, $token: String!) {\n    OccupationSearch(search: $search, token: $token) {\n      id\n      name\n    }\n  }\n"],["\n  query cccupationSearch($search: String!, $token: String!) {\n    OccupationSearch(search: $search, token: $token) {\n      id\n      name\n    }\n  }\n"]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var OccupationSearch=__WEBPACK_IMPORTED_MODULE_0_graphql_tag___default()(_templateObject);

/***/ }),
/* 2442 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_core__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_Button__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_MobileStepper__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_MobileStepper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_MobileStepper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Grid_GridItem_jsx__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_graphql_tag__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_graphql_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_graphql_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_helpers_TaxCalculator__ = __webpack_require__(254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_helpers_UserHelper__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_queries_clientById__ = __webpack_require__(393);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_queries_clientsByBroker__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_apollo__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_redux__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_reducers_NotificationReducer__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_redux_form__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_store__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__helpers_PopulateClient__ = __webpack_require__(394);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__CC_bankDetail_jsx__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__CC_clientForm_jsx__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__CC_clientOccForm_jsx__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__CC_contactDetails_jsx__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__CC_healthInfo_jsx__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__CC_willDetail_jsx__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_helpers_Documents_js__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_constants_js__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_apollo_client__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_apollo_cache_inmemory__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_apollo_upload_client__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_helpers_DateHelpers__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_lodash__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_helpers_UriReader__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__material_ui_core_AppBar__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__material_ui_core_AppBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32__material_ui_core_AppBar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__material_ui_core_Tab__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__material_ui_core_Tab___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33__material_ui_core_Tab__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__material_ui_core_Tabs__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__material_ui_core_Tabs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34__material_ui_core_Tabs__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(["\n  mutation($file: Upload!, $id: String!) {\n    uploadClientAvatar(file: $file, id: $id)\n  }\n"],["\n  mutation($file: Upload!, $id: String!) {\n    uploadClientAvatar(file: $file, id: $id)\n  }\n"]),_templateObject2=_taggedTemplateLiteral(["\n  mutation updateClient($input: UpdateClientInput!) {\n    UpdateClient(input: $input) {\n      clientMutationId\n      client {\n        id\n        scd_name\n        scd_surname\n        scd_email\n        date_created\n        scd_clientType\n        scd_registered\n        invite_sent\n        app_info_complete\n        status\n      }\n    }\n  }\n"],["\n  mutation updateClient($input: UpdateClientInput!) {\n    UpdateClient(input: $input) {\n      clientMutationId\n      client {\n        id\n        scd_name\n        scd_surname\n        scd_email\n        date_created\n        scd_clientType\n        scd_registered\n        invite_sent\n        app_info_complete\n        status\n      }\n    }\n  }\n"]);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}/*eslint-disable*/var tabStyle={color:"white",borderBottom:"2px solid",opacity:"1"};var tabs=["Basic","Contact","Occupation","Bank","Health","Will"];var uploadClient=new __WEBPACK_IMPORTED_MODULE_26_apollo_client__["ApolloClient"]({link:Object(__WEBPACK_IMPORTED_MODULE_28_apollo_upload_client__["a" /* createUploadLink */])({uri:__WEBPACK_IMPORTED_MODULE_25_constants_js__["d" /* fileUploadServerPath */]}),cache:new __WEBPACK_IMPORTED_MODULE_27_apollo_cache_inmemory__["a" /* InMemoryCache */]()});var uploadFileMutation=__WEBPACK_IMPORTED_MODULE_5_graphql_tag___default()(_templateObject);var updateClient=__WEBPACK_IMPORTED_MODULE_5_graphql_tag___default()(_templateObject2);var form="client";var ClientEditForm=function(_Component){_inherits(ClientEditForm,_Component);function ClientEditForm(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ClientEditForm);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ClientEditForm.__proto__||Object.getPrototypeOf(ClientEditForm)).call.apply(_ref,[this].concat(args))),_this),_this.state={page:0,pageCount:6,checkValidation:false,formInitiazed:false,firstName:"",secondName:"",lastName:"",afterTaxIncome:"0",age:0,married:false,saCitizen:true,file:null,imgSrc:null,initialId:"",occupationValid:true,clientId:null},_this.toggleOccupationValid=function(valid){_this.setState({occupationValid:valid});},_this.submit=function(){if(_this.state.page===2&&!_this.state.occupationValid){__WEBPACK_IMPORTED_MODULE_16_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_14_reducers_NotificationReducer__["d" /* showSnack */])({message:"Invalid Occupation",color:"danger"}));return;}if(__WEBPACK_IMPORTED_MODULE_16_store__["a" /* default */].getState().form.client.syncErrors){__WEBPACK_IMPORTED_MODULE_16_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_14_reducers_NotificationReducer__["d" /* showSnack */])({message:"Invalid Information",color:"danger"}));_this.setState({checkValidation:true});_this.forceUpdate();}else if(_this.checkOccupationDuties()){__WEBPACK_IMPORTED_MODULE_16_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_14_reducers_NotificationReducer__["d" /* showSnack */])({message:"Occupational Duties must add up to 100%",color:"danger"}));}else{_this.setState({checkValidation:false});var dat=__WEBPACK_IMPORTED_MODULE_16_store__["a" /* default */].getState().form.client.values;dat.calculatedMonthlyIncomeAT=_this.state.afterTaxIncome;dat.actualMonthlyIncomeAT=_this.state.afterTaxIncome;var input={clientId:_this.state.clientId,data:dat,token:Object(__WEBPACK_IMPORTED_MODULE_7_helpers_UserHelper__["c" /* GetUserToken */])()};_this.props.mutate({variables:{input:input}}).then(function(resp){__WEBPACK_IMPORTED_MODULE_16_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_14_reducers_NotificationReducer__["e" /* successWarning */])({open:true,title:"Client Updated.",onConfirm:function onConfirm(){return _this.props.history.goBack();}}));if(_this.state.file!==null){uploadClient.mutate({mutation:uploadFileMutation,variables:{file:_this.state.file,id:_this.state.clientId}}).then(console.log("profile picture updated"));}}).catch(function(error){__WEBPACK_IMPORTED_MODULE_16_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_14_reducers_NotificationReducer__["d" /* showSnack */])({message:"There was an error updating this client : "+error,color:"danger"}));});}},_this.checkOccupationDuties=function(){var clientForm=__WEBPACK_IMPORTED_MODULE_16_store__["a" /* default */].getState().form.client.values;if(_this.state.page===2&&parseInt(clientForm.Admin)+parseInt(clientForm.Travel)+parseInt(clientForm.ManualLabour)+parseInt(clientForm.Supervision)!==100){return true;}return false;},_this.nextPage=function(){if(_this.state.page===2&&!_this.state.occupationValid){__WEBPACK_IMPORTED_MODULE_16_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_14_reducers_NotificationReducer__["d" /* showSnack */])({message:"Invalid Occupation",color:"danger"}));return;}if(_this.checkOccupationDuties()){__WEBPACK_IMPORTED_MODULE_16_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_14_reducers_NotificationReducer__["d" /* showSnack */])({message:"Occupational Duties must add up to 100%",color:"danger"}));}else{if(__WEBPACK_IMPORTED_MODULE_16_store__["a" /* default */].getState().form.client.syncErrors){__WEBPACK_IMPORTED_MODULE_16_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_14_reducers_NotificationReducer__["d" /* showSnack */])({message:"Invalid Information",color:"danger"}));_this.setState({checkValidation:true});_this.forceUpdate();}else{_this.setState({page:_this.state.page+1,checkValidation:false});_this.forceUpdate();_this.props.scrollMeBar();}}},_this.previousPage=function(){if(_this.state.page===2&&!_this.state.occupationValid){__WEBPACK_IMPORTED_MODULE_16_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_14_reducers_NotificationReducer__["d" /* showSnack */])({message:"Invalid Occupation",color:"danger"}));return;}_this.setState({page:_this.state.page-1});_this.props.scrollMeBar();},_this.dobChanged=function(val){try{if(val.length!==10)throw"Too short";var dob=Object(__WEBPACK_IMPORTED_MODULE_29_helpers_DateHelpers__["b" /* ParseDMYwSlashes */])(val);var age=__WEBPACK_IMPORTED_MODULE_8_moment___default()().diff(dob,"years");__WEBPACK_IMPORTED_MODULE_16_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_15_redux_form__["b" /* change */])("client","age",age));}catch(error){__WEBPACK_IMPORTED_MODULE_16_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_15_redux_form__["b" /* change */])("client","age",""));}_this.forceUpdate();},_this.maritalChangeHandler=function(value){if(value==="Married"){_this.setState({married:true});if(__WEBPACK_IMPORTED_MODULE_16_store__["a" /* default */].getState().form.client.values.title==="MISS"){__WEBPACK_IMPORTED_MODULE_16_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_15_redux_form__["b" /* change */])("client","title","MRS"));}}else{if(value!=="validationError"){if(__WEBPACK_IMPORTED_MODULE_16_store__["a" /* default */].getState().form.client.values.title==="MRS"){__WEBPACK_IMPORTED_MODULE_16_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_15_redux_form__["b" /* change */])("client","title","MISS"));}}__WEBPACK_IMPORTED_MODULE_16_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_15_redux_form__["b" /* change */])("client","spouseIncome",""));_this.setState({married:false});}},_this.idChangeHandler=function(value){if(value==="idNumber"){if(!_this.state.saCitizen){_this.resetclientIdDetails();}_this.setState({saCitizen:true});}else{if(_this.state.saCitizen){_this.resetclientIdDetails();}_this.setState({saCitizen:false});}},_this.fileAttached=function(file){var valid=Object(__WEBPACK_IMPORTED_MODULE_24_helpers_Documents_js__["d" /* validateFile */])(file.name,__WEBPACK_IMPORTED_MODULE_24_helpers_Documents_js__["c" /* imageTypes */]);if(!valid){__WEBPACK_IMPORTED_MODULE_16_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_14_reducers_NotificationReducer__["d" /* showSnack */])({message:"Invalid file type.",color:"danger"}));}else{_this.setState({file:file,imgSrc:URL.createObjectURL(file)});}},_this.handleChangeTab=function(event,value){if(value==0)return;_this.setState({page:value-1});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ClientEditForm,[{key:"componentDidMount",value:function componentDidMount(){var params=Object(__WEBPACK_IMPORTED_MODULE_31_helpers_UriReader__["a" /* ParseUriParams */])(this.props.location.search);var clientId=params.clientId;this.setState({clientId:clientId});}},{key:"initializeForm",value:function initializeForm(data){this.setState({firstName:data.scd_name?data.scd_name:"",lastName:data.scd_surname?data.scd_surname:""});var populatedClient=Object(__WEBPACK_IMPORTED_MODULE_17__helpers_PopulateClient__["a" /* default */])(data);this.props.initialize(Object.assign({},populatedClient));if(data.scd_maritalStatus&&data.scd_maritalStatus==="Married"){this.setState({married:true});}if(data.scd_idType&&data.scd_idType==="passport"){this.setState({saCitizen:false});}if(data.scd_pp_path){this.setState({imgSrc:data.scd_pp_path});}if(data.scd_dateOfBirth){this.dobChanged(data.scd_dateOfBirth.split("T")[0]);}if(data.scd_monthlyIncome){this.onSalaryChange(parseFloat(data.scd_monthlyIncome));}this.setState({formInitiazed:true,initialId:data.scd_saID?data.scd_saID:""});}},{key:"componentWillUnmount",value:function componentWillUnmount(){__WEBPACK_IMPORTED_MODULE_16_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_15_redux_form__["f" /* reset */])("client"));__WEBPACK_IMPORTED_MODULE_16_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_14_reducers_NotificationReducer__["d" /* showSnack */])({open:false}));}},{key:"changeFirstName",value:function changeFirstName(name){if(name&&name!==""){var initials="";initials=name.substring(0,1)+this.state.secondName.substring(0,1);__WEBPACK_IMPORTED_MODULE_16_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_15_redux_form__["b" /* change */])("client","initials",initials));this.setState({firstName:name});}}},{key:"changeSecondName",value:function changeSecondName(name){if(name&&name!==""){var initials="";initials=this.state.firstName.substring(0,1)+name.substring(0,1);__WEBPACK_IMPORTED_MODULE_16_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_15_redux_form__["b" /* change */])("client","initials",initials));this.setState({secondName:name});}}},{key:"changeLastName",value:function changeLastName(name){this.setState({lastName:name});}},{key:"onSalaryChange",value:function onSalaryChange(value){value=value.toString().replace(/,/g,"").replace(/ /g,"");if(value===""||isNaN(Number(value))){return;}var x=Object(__WEBPACK_IMPORTED_MODULE_6_helpers_TaxCalculator__["a" /* default */])(parseFloat(value),__WEBPACK_IMPORTED_MODULE_30_lodash___default.a.get(__WEBPACK_IMPORTED_MODULE_16_store__["a" /* default */].getState().form,"client.values.age",null));x=x.toString();//let parsed = parseFloat(val);
this.setState({afterTaxIncome:x.toString()});this.forceUpdate();if(__WEBPACK_IMPORTED_MODULE_16_store__["a" /* default */].getState().form.client.fields&&__WEBPACK_IMPORTED_MODULE_16_store__["a" /* default */].getState().form.client.fields.actualMonthlyIncomeAT&&__WEBPACK_IMPORTED_MODULE_16_store__["a" /* default */].getState().form.client.fields.actualMonthlyIncomeAT.touched){return;}else{__WEBPACK_IMPORTED_MODULE_16_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_15_redux_form__["b" /* change */])("client","actualMonthlyIncomeAT",x.toString()));__WEBPACK_IMPORTED_MODULE_16_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_15_redux_form__["h" /* untouch */])("client","actualMonthlyIncomeAT"));}}},{key:"resetclientIdDetails",value:function resetclientIdDetails(){__WEBPACK_IMPORTED_MODULE_16_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_15_redux_form__["b" /* change */])("client","said",""));__WEBPACK_IMPORTED_MODULE_16_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_15_redux_form__["h" /* untouch */])("client","said"));__WEBPACK_IMPORTED_MODULE_16_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_15_redux_form__["b" /* change */])("client","passportNumber",""));__WEBPACK_IMPORTED_MODULE_16_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_15_redux_form__["h" /* untouch */])("client","passportNumber"));}},{key:"withoutClasses",value:function withoutClasses(props){var newProps=Object.assign({},props);delete newProps.classes;return newProps;}},{key:"render",value:function render(){var _this2=this;var page=this.state.page;var params=Object(__WEBPACK_IMPORTED_MODULE_31_helpers_UriReader__["a" /* ParseUriParams */])(this.props.location.search);var clientId=params.clientId;return __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react_apollo__["Query"],{query:__WEBPACK_IMPORTED_MODULE_9_queries_clientById__["a" /* ClientById */],variables:{id:clientId,token:Object(__WEBPACK_IMPORTED_MODULE_7_helpers_UserHelper__["c" /* GetUserToken */])()},fetchPolicy:"network-only"},function(_ref2){var loading=_ref2.loading,error=_ref2.error,data=_ref2.data;if(loading)return __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["B" /* LinearProgress */],null));if(error)return"Error! "+error.message;if(!_this2.state.formInitiazed){_this2.initializeForm(data.ClientById[0]);}return __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{container:true},__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:10,style:{flexBasis:"100%",maxWidth:"100%",margin:'auto'}},__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement("div",{className:"fixedStepper"},__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{container:true},__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:10,style:{flexBasis:"100%",maxWidth:"100%",margin:'auto'}},__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement("div",{className:"stepperDiv",style:{position:"relative"}},__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_32__material_ui_core_AppBar___default.a,{position:"static",color:"primary"},__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_34__material_ui_core_Tabs___default.a,{tab:page,onChange:_this2.handleChangeTab,scrollable:true,scrollButtons:"on",classes:{scrollButtons:"scrollButton"}},__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_33__material_ui_core_Tab___default.a,{label:__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement("strong",null,"SAVE"),onClick:function onClick(){return _this2.submit();},className:"saveTab"}),tabs.map(function(t,i){return __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_33__material_ui_core_Tab___default.a,{label:t,style:i===page?tabStyle:{},key:t});}))))))),__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement("br",null),page===0&&__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__CC_clientForm_jsx__["a" /* default */],Object.assign({changeFirstName:_this2.changeFirstName.bind(_this2),changeLastName:_this2.changeLastName.bind(_this2),changeSecondName:_this2.changeSecondName.bind(_this2),dobChanged:_this2.dobChanged,idChangeHandler:_this2.idChangeHandler.bind(_this2),maritalChangeHandler:_this2.maritalChangeHandler.bind(_this2),editMode:true,uploadMutation:uploadFileMutation,fileAttached:_this2.fileAttached},_this2.withoutClasses(_this2.props),_this2.state)),page===1&&__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__CC_contactDetails_jsx__["a" /* default */],Object.assign({checkValidation:_this2.state.checkValidation},_this2.withoutClasses(_this2.props))),page===2&&__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__CC_clientOccForm_jsx__["a" /* default */],Object.assign({salaryChangeHandler:_this2.onSalaryChange.bind(_this2),toggleOccupationValid:_this2.toggleOccupationValid},_this2.withoutClasses(_this2.props),_this2.state)),page===3&&__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__CC_bankDetail_jsx__["a" /* default */],Object.assign({},_this2.withoutClasses(_this2.props),_this2.state)),page===4&&__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__CC_healthInfo_jsx__["a" /* default */],Object.assign({},_this2.withoutClasses(_this2.props),_this2.state)),page===5&&__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__CC_willDetail_jsx__["a" /* default */],Object.assign({},_this2.withoutClasses(_this2.props),_this2.state))));});}}]);return ClientEditForm;}(__WEBPACK_IMPORTED_MODULE_11_react__["Component"]);ClientEditForm=Object(__WEBPACK_IMPORTED_MODULE_15_redux_form__["e" /* reduxForm */])({form:form,destroyOnUnmount:true})(ClientEditForm);ClientEditForm=Object(__WEBPACK_IMPORTED_MODULE_13_react_redux__["b" /* connect */])(function(){return{};})(ClientEditForm);ClientEditForm=Object(__WEBPACK_IMPORTED_MODULE_12_react_apollo__["graphql"])(updateClient,{options:{update:function update(proxy,_ref3){var updateClient=_ref3.data.updateClient;var _proxy$readQuery=proxy.readQuery({query:__WEBPACK_IMPORTED_MODULE_10_queries_clientsByBroker__["a" /* getClientsByBroker */]}),clients=_proxy$readQuery.clients;var targetClientIndex=clients.findIndex(function(c){return c.id===updateClient.client.id;});clients[targetClientIndex]=updateClient.client;proxy.writeQuery({getClientsByBroker:__WEBPACK_IMPORTED_MODULE_10_queries_clientsByBroker__["a" /* getClientsByBroker */],data:clients});}}})(ClientEditForm);/* harmony default export */ __webpack_exports__["a"] = (ClientEditForm);

/***/ }),
/* 2443 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_core__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_EnhancedTableHead_EnhancedTableHead_jsx__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_MobileStepper__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_MobileStepper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_MobileStepper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_Grid_GridItem_jsx__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_graphql_tag__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_graphql_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_graphql_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_helpers_TaxCalculator__ = __webpack_require__(254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_helpers_UserHelper__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_queries_clientById__ = __webpack_require__(393);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_queries_clientsByBroker__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_apollo__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_redux__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_reducers_NotificationReducer__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_redux_form__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_store__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__helpers_PopulateClient__ = __webpack_require__(394);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__CC_bankDetail_jsx__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__CC_clientForm_jsx__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__CC_clientOccForm_jsx__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__CC_contactDetails_jsx__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__CC_healthInfo_jsx__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__CC_willDetail_jsx__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_helpers_Documents_js__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_constants_js__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_apollo_client__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_apollo_cache_inmemory__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_apollo_upload_client__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_helpers_DateHelpers__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_lodash__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_helpers_UriReader__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__material_ui_core_AppBar__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__material_ui_core_AppBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33__material_ui_core_AppBar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__material_ui_core_Tab__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__material_ui_core_Tab___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34__material_ui_core_Tab__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__material_ui_core_Tabs__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__material_ui_core_Tabs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_35__material_ui_core_Tabs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__CC_clientForm_EliteWealth__ = __webpack_require__(622);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__CC_clientOccForm_EliteWealth__ = __webpack_require__(395);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__ClientDetail_tabs_quotes_QuotesTab_EliteWealth_jsx__ = __webpack_require__(623);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39_queries_QuoteEligibility__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40_components_CustomChip_CustomChip_jsx__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41_react_bootstrap_sweetalert__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41_react_bootstrap_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_41_react_bootstrap_sweetalert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42_assets_jss_material_dashboard_pro_react_views_sweetAlertStyle_jsx__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__material_ui_core_styles_withStyles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__material_ui_core_styles_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_43__material_ui_core_styles_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__BaseTablePageContent__ = __webpack_require__(624);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__ManageClients_elite__ = __webpack_require__(2444);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  mutation($file: Upload!, $id: String!) {\n    uploadClientAvatar(file: $file, id: $id)\n  }\n'],['\n  mutation($file: Upload!, $id: String!) {\n    uploadClientAvatar(file: $file, id: $id)\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  mutation updateClient($input: UpdateClientInput!) {\n    UpdateClient(input: $input) {\n      clientMutationId\n      client {\n        id\n        scd_name\n        scd_surname\n        scd_email\n        date_created\n        scd_clientType\n        scd_registered\n        invite_sent\n        app_info_complete\n        status\n      }\n    }\n  }\n'],['\n  mutation updateClient($input: UpdateClientInput!) {\n    UpdateClient(input: $input) {\n      clientMutationId\n      client {\n        id\n        scd_name\n        scd_surname\n        scd_email\n        date_created\n        scd_clientType\n        scd_registered\n        invite_sent\n        app_info_complete\n        status\n      }\n    }\n  }\n']);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}/*eslint-disable*/var tabStyle={color:"white",borderBottom:"2px solid",opacity:"1"};var columnData=[{id:'edit',numeric:false,disablePadding:true,label:'',noSort:true,width:'30px'},{id:'description',numeric:false,disablePadding:true,label:'Description',noSort:true},{id:'t.date_created',numeric:false,disablePadding:true,label:'Date Created',noSort:true}];var tabs=["Basic","Contact","Occupation","Bank","Health","Will"];var uploadClient=new __WEBPACK_IMPORTED_MODULE_27_apollo_client__["ApolloClient"]({link:Object(__WEBPACK_IMPORTED_MODULE_29_apollo_upload_client__["a" /* createUploadLink */])({uri:__WEBPACK_IMPORTED_MODULE_26_constants_js__["d" /* fileUploadServerPath */]}),cache:new __WEBPACK_IMPORTED_MODULE_28_apollo_cache_inmemory__["a" /* InMemoryCache */]()});var uploadFileMutation=__WEBPACK_IMPORTED_MODULE_6_graphql_tag___default()(_templateObject);var updateClient=__WEBPACK_IMPORTED_MODULE_6_graphql_tag___default()(_templateObject2);var form="client";var ClientEditForm_EliteWealth=function(_Component){_inherits(ClientEditForm_EliteWealth,_Component);function ClientEditForm_EliteWealth(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ClientEditForm_EliteWealth);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ClientEditForm_EliteWealth.__proto__||Object.getPrototypeOf(ClientEditForm_EliteWealth)).call.apply(_ref,[this].concat(args))),_this),_this.state={page:0,pageCount:6,checkValidation:true,formInitiazed:false,firstName:"",secondName:"",lastName:"",afterTaxIncome:"0",age:0,married:false,saCitizen:true,file:null,imgSrc:null,initialId:"",occupationValid:true,clientId:null,openMenus:[],openMenusPage:0,anchorTop:0,anchorLeft:0,popoverOpen:false,assistantActive:false,eligibilityDialogOpen:false,invalidFields:[],selectedClient:{},selected:false},_this.toggleOccupationValid=function(valid){_this.setState({occupationValid:valid});},_this.submit=function(){if(_this.state.page===0&&!_this.state.occupationValid){__WEBPACK_IMPORTED_MODULE_17_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_15_reducers_NotificationReducer__["d" /* showSnack */])({message:"Invalid Occupation",color:"danger"}));return;}if(__WEBPACK_IMPORTED_MODULE_17_store__["a" /* default */].getState().form.client.syncErrors){__WEBPACK_IMPORTED_MODULE_17_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_15_reducers_NotificationReducer__["d" /* showSnack */])({message:"Invalid Information",color:"danger"}));_this.setState({checkValidation:true});_this.forceUpdate();}else if(_this.checkOccupationDuties()){__WEBPACK_IMPORTED_MODULE_17_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_15_reducers_NotificationReducer__["d" /* showSnack */])({message:"Occupational Duties must add up to 100%",color:"danger"}));}else{_this.setState({checkValidation:false});var dat=__WEBPACK_IMPORTED_MODULE_17_store__["a" /* default */].getState().form.client.values;dat.calculatedMonthlyIncomeAT=_this.state.afterTaxIncome;dat.actualMonthlyIncomeAT=_this.state.afterTaxIncome;var input={clientId:_this.state.clientId,data:dat,token:Object(__WEBPACK_IMPORTED_MODULE_8_helpers_UserHelper__["c" /* GetUserToken */])()};_this.props.mutate({variables:{input:input}}).then(function(resp){__WEBPACK_IMPORTED_MODULE_17_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_15_reducers_NotificationReducer__["e" /* successWarning */])({open:true,title:"Client Updated.",onConfirm:function onConfirm(){var url='/app/quote?'+window.location.href.substring(window.location.href.indexOf("?")+1);_this.props.history.push(url);}}));if(_this.state.file!==null){uploadClient.mutate({mutation:uploadFileMutation,variables:{file:_this.state.file,id:_this.state.clientId}}).then(console.log("profile picture updated"));}}).catch(function(error){__WEBPACK_IMPORTED_MODULE_17_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_15_reducers_NotificationReducer__["d" /* showSnack */])({message:"There was an error updating this client : "+error,color:"danger"}));});}},_this.submitClient=function(itm){if(_this.state.page===0&&!_this.state.occupationValid){__WEBPACK_IMPORTED_MODULE_17_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_15_reducers_NotificationReducer__["d" /* showSnack */])({message:"Invalid Occupation",color:"danger"}));return;}if((!sessionStorage.getItem("ActiveBrokerId")||sessionStorage.getItem("ActiveBrokerId")==0)&&localStorage.getItem("userType")==6){__WEBPACK_IMPORTED_MODULE_17_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_15_reducers_NotificationReducer__["d" /* showSnack */])({message:"Please select a broker.",color:"danger"}));return;}if(__WEBPACK_IMPORTED_MODULE_17_store__["a" /* default */].getState().form.client.syncErrors){__WEBPACK_IMPORTED_MODULE_17_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_15_reducers_NotificationReducer__["d" /* showSnack */])({message:"Invalid Information",color:"danger"}));_this.setState({checkValidation:true});_this.forceUpdate();}else if(_this.checkOccupationDuties()){__WEBPACK_IMPORTED_MODULE_17_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_15_reducers_NotificationReducer__["d" /* showSnack */])({message:"Occupational Duties must add up to 100%",color:"danger"}));}else{_this.setState({checkValidation:false});var dat=__WEBPACK_IMPORTED_MODULE_17_store__["a" /* default */].getState().form.client.values;dat.calculatedMonthlyIncomeAT=_this.state.afterTaxIncome;dat.actualMonthlyIncomeAT=_this.state.afterTaxIncome;var input={clientId:_this.state.clientId,data:dat,token:Object(__WEBPACK_IMPORTED_MODULE_8_helpers_UserHelper__["c" /* GetUserToken */])()};_this.props.mutate({variables:{input:input}}).then(function(resp){__WEBPACK_IMPORTED_MODULE_17_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_15_reducers_NotificationReducer__["e" /* successWarning */])({open:true,title:"Client Updated.",onConfirm:function onConfirm(){itm();}}));if(_this.state.file!==null){uploadClient.mutate({mutation:uploadFileMutation,variables:{file:_this.state.file,id:_this.state.clientId}}).then(console.log("profile picture updated"));}}).catch(function(error){__WEBPACK_IMPORTED_MODULE_17_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_15_reducers_NotificationReducer__["d" /* showSnack */])({message:"There was an error updating this client : "+error,color:"danger"}));});}},_this.handleSelect=function(broker){sessionStorage.setItem("ActiveBrokerId",broker.su_ID);sessionStorage.setItem("ActiveBrokerName",broker.su_name+" "+broker.su_surname);_this.setState({selected:!_this.props.selected});},_this.checkOccupationDuties=function(){var clientForm=__WEBPACK_IMPORTED_MODULE_17_store__["a" /* default */].getState().form.client.values;if(parseInt(clientForm.Admin)+parseInt(clientForm.Travel)+parseInt(clientForm.ManualLabour)+parseInt(clientForm.Supervision)!==100){return true;}return false;},_this.nextPage=function(){if(_this.state.page===2&&!_this.state.occupationValid){__WEBPACK_IMPORTED_MODULE_17_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_15_reducers_NotificationReducer__["d" /* showSnack */])({message:"Invalid Occupation",color:"danger"}));return;}if((!sessionStorage.getItem("ActiveBrokerId")||sessionStorage.getItem("ActiveBrokerId")==0)&&localStorage.getItem("userType")==6){__WEBPACK_IMPORTED_MODULE_17_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_15_reducers_NotificationReducer__["d" /* showSnack */])({message:"Please select a broker.",color:"danger"}));return;}if(_this.checkOccupationDuties()){__WEBPACK_IMPORTED_MODULE_17_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_15_reducers_NotificationReducer__["d" /* showSnack */])({message:"Occupational Duties must add up to 100%",color:"danger"}));}else{if(__WEBPACK_IMPORTED_MODULE_17_store__["a" /* default */].getState().form.client.syncErrors){__WEBPACK_IMPORTED_MODULE_17_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_15_reducers_NotificationReducer__["d" /* showSnack */])({message:"Invalid Information",color:"danger"}));_this.setState({checkValidation:true});_this.forceUpdate();}else{_this.setState({page:_this.state.page+1,checkValidation:false});_this.forceUpdate();_this.props.scrollMeBar();}}},_this.previousPage=function(){if(_this.state.page===0&&!_this.state.occupationValid){__WEBPACK_IMPORTED_MODULE_17_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_15_reducers_NotificationReducer__["d" /* showSnack */])({message:"Invalid Occupation",color:"danger"}));return;}_this.setState({page:_this.state.page-1});_this.props.scrollMeBar();},_this.dobChanged=function(val){try{if(val.length!==10)throw"Too short";var dob=Object(__WEBPACK_IMPORTED_MODULE_30_helpers_DateHelpers__["b" /* ParseDMYwSlashes */])(val);var age=__WEBPACK_IMPORTED_MODULE_9_moment___default()().diff(dob,"years");__WEBPACK_IMPORTED_MODULE_17_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_16_redux_form__["b" /* change */])("client","age",age));}catch(error){__WEBPACK_IMPORTED_MODULE_17_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_16_redux_form__["b" /* change */])("client","age",""));}_this.forceUpdate();},_this.maritalChangeHandler=function(value){if(value==="Married"){_this.setState({married:true});if(__WEBPACK_IMPORTED_MODULE_17_store__["a" /* default */].getState().form.client.values.title==="MISS"){__WEBPACK_IMPORTED_MODULE_17_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_16_redux_form__["b" /* change */])("client","title","MRS"));}}else{if(value!=="validationError"){if(__WEBPACK_IMPORTED_MODULE_17_store__["a" /* default */].getState().form.client.values.title==="MRS"){__WEBPACK_IMPORTED_MODULE_17_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_16_redux_form__["b" /* change */])("client","title","MISS"));}}__WEBPACK_IMPORTED_MODULE_17_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_16_redux_form__["b" /* change */])("client","spouseIncome",""));_this.setState({married:false});}},_this.idChangeHandler=function(value){if(value==="idNumber"){if(!_this.state.saCitizen){_this.resetclientIdDetails();}_this.setState({saCitizen:true});}else{if(_this.state.saCitizen){_this.resetclientIdDetails();}_this.setState({saCitizen:false});}},_this.fileAttached=function(file){var valid=Object(__WEBPACK_IMPORTED_MODULE_25_helpers_Documents_js__["d" /* validateFile */])(file.name,__WEBPACK_IMPORTED_MODULE_25_helpers_Documents_js__["c" /* imageTypes */]);if(!valid){__WEBPACK_IMPORTED_MODULE_17_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_15_reducers_NotificationReducer__["d" /* showSnack */])({message:"Invalid file type.",color:"danger"}));}else{_this.setState({file:file,imgSrc:URL.createObjectURL(file)});}},_this.handleChangeTab=function(event,value){if(value==0)return;_this.setState({page:value-1});},_this.handleNewQuote=function(clientId){_this.props.history.push({pathname:'/app/quote/',search:'clientId='+clientId});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ClientEditForm_EliteWealth,[{key:'componentDidMount',value:function componentDidMount(){var params=Object(__WEBPACK_IMPORTED_MODULE_32_helpers_UriReader__["a" /* ParseUriParams */])(this.props.location.search);var clientId=params.clientId;this.setState({clientId:clientId});}},{key:'initializeForm',value:function initializeForm(data){this.setState({firstName:data.scd_name?data.scd_name:"",lastName:data.scd_surname?data.scd_surname:""});var populatedClient=Object(__WEBPACK_IMPORTED_MODULE_18__helpers_PopulateClient__["a" /* default */])(data);this.props.initialize(Object.assign({},populatedClient));if(data.scd_maritalStatus&&data.scd_maritalStatus==="Married"){this.setState({married:true});}if(data.scd_idType&&data.scd_idType==="passport"){this.setState({saCitizen:false});}if(data.scd_pp_path){this.setState({imgSrc:data.scd_pp_path});}if(data.scd_dateOfBirth){this.dobChanged(data.scd_dateOfBirth.split("T")[0]);}if(data.scd_monthlyIncome){this.onSalaryChange(parseFloat(data.scd_monthlyIncome));}this.setState({formInitiazed:true,initialId:data.scd_saID?data.scd_saID:""});}},{key:'componentWillUnmount',value:function componentWillUnmount(){__WEBPACK_IMPORTED_MODULE_17_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_16_redux_form__["f" /* reset */])("client"));__WEBPACK_IMPORTED_MODULE_17_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_15_reducers_NotificationReducer__["d" /* showSnack */])({open:false}));}},{key:'changeFirstName',value:function changeFirstName(name){if(name&&name!==""){var initials="";initials=name.substring(0,1)+this.state.secondName.substring(0,1);__WEBPACK_IMPORTED_MODULE_17_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_16_redux_form__["b" /* change */])("client","initials",initials));this.setState({firstName:name});}}},{key:'changeSecondName',value:function changeSecondName(name){if(name&&name!==""){var initials="";initials=this.state.firstName.substring(0,1)+name.substring(0,1);__WEBPACK_IMPORTED_MODULE_17_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_16_redux_form__["b" /* change */])("client","initials",initials));this.setState({secondName:name});}}},{key:'changeLastName',value:function changeLastName(name){this.setState({lastName:name});}},{key:'onSalaryChange',value:function onSalaryChange(value){value=value.toString().replace(/,/g,"").replace(/ /g,"");if(value===""||isNaN(Number(value))){return;}var x=Object(__WEBPACK_IMPORTED_MODULE_7_helpers_TaxCalculator__["a" /* default */])(parseFloat(value),__WEBPACK_IMPORTED_MODULE_31_lodash___default.a.get(__WEBPACK_IMPORTED_MODULE_17_store__["a" /* default */].getState().form,"client.values.age",null));x=x.toString();//let parsed = parseFloat(val);
this.setState({afterTaxIncome:x.toString()});this.forceUpdate();if(__WEBPACK_IMPORTED_MODULE_17_store__["a" /* default */].getState().form.client.fields&&__WEBPACK_IMPORTED_MODULE_17_store__["a" /* default */].getState().form.client.fields.actualMonthlyIncomeAT&&__WEBPACK_IMPORTED_MODULE_17_store__["a" /* default */].getState().form.client.fields.actualMonthlyIncomeAT.touched){return;}else{__WEBPACK_IMPORTED_MODULE_17_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_16_redux_form__["b" /* change */])("client","actualMonthlyIncomeAT",x.toString()));__WEBPACK_IMPORTED_MODULE_17_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_16_redux_form__["h" /* untouch */])("client","actualMonthlyIncomeAT"));}}},{key:'resetclientIdDetails',value:function resetclientIdDetails(){__WEBPACK_IMPORTED_MODULE_17_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_16_redux_form__["b" /* change */])("client","said",""));__WEBPACK_IMPORTED_MODULE_17_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_16_redux_form__["h" /* untouch */])("client","said"));__WEBPACK_IMPORTED_MODULE_17_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_16_redux_form__["b" /* change */])("client","passportNumber",""));__WEBPACK_IMPORTED_MODULE_17_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_16_redux_form__["h" /* untouch */])("client","passportNumber"));}},{key:'withoutClasses',value:function withoutClasses(props){var newProps=Object.assign({},props);delete newProps.classes;return newProps;}},{key:'render',value:function render(){var _this2=this;var page=this.state.page;var params=Object(__WEBPACK_IMPORTED_MODULE_32_helpers_UriReader__["a" /* ParseUriParams */])(this.props.location.search);var clientId=params.clientId;return __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_react_apollo__["Query"],{query:__WEBPACK_IMPORTED_MODULE_10_queries_clientById__["a" /* ClientById */],variables:{id:clientId,token:Object(__WEBPACK_IMPORTED_MODULE_8_helpers_UserHelper__["c" /* GetUserToken */])()},fetchPolicy:'network-only'},function(_ref2){var loading=_ref2.loading,error=_ref2.error,data=_ref2.data;if(loading)return __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["B" /* LinearProgress */],null));if(error)return'Error! '+error.message;if(!_this2.state.formInitiazed){_this2.initializeForm(data.ClientById[0]);}return __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{container:true},__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:10,style:{flexBasis:"100%",maxWidth:"100%",margin:'auto'}},__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div',{className:"fixedStepper"},__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{container:true},__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:10,style:{flexBasis:"100%",maxWidth:"100%",margin:'auto'}},__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div',{className:"stepperDiv",style:{position:"relative"}},__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_33__material_ui_core_AppBar___default.a,{position:'static',color:'primary'},__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_35__material_ui_core_Tabs___default.a,{tab:page,onChange:_this2.handleChangeTab,scrollable:true,scrollButtons:'on',classes:{scrollButtons:"scrollButton"}},__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_react_apollo__["Mutation"],{mutation:__WEBPACK_IMPORTED_MODULE_39_queries_QuoteEligibility__["a" /* QuoteEligibility */],onCompleted:function onCompleted(data){var quoteEligibility=data.QuoteEligibility;if(!quoteEligibility.valid){var invalidFields=quoteEligibility.invalidFields.split(',');_this2.setState({eligibilityDialogOpen:true,invalidFields:invalidFields,selectedClient:_this2.props.clientName});}else{_this2.handleNewQuote(clientId);}}},function(mutate){return __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_34__material_ui_core_Tab___default.a,{className:'saveTab',label:__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('strong',null,'SAVE & Create New Quote '),onClick:function onClick(){return _this2.submitClient(function(){return mutate({variables:{input:{clientId:clientId}}});});}});}),_this2.state.eligibilityDialogOpen?__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_41_react_bootstrap_sweetalert___default.a,{warning:true,style:{wordWrap:'break-word',top:'40%'},title:'Ineligible',confirmBtnCssClass:_this2.props.classes.button+' '+_this2.props.classes.success,cancelBtnCssClass:_this2.props.classes.button+' '+_this2.props.classes.danger,confirmBtnText:'Save',cancelBtnText:'Close',onConfirm:function onConfirm(){_this2.submitClient();_this2.setState({eligibilityDialogOpen:false});},onCancel:function onCancel(){_this2.setState({eligibilityDialogOpen:false});},showCancel:true,showConfirm:false},__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],null,_this2.state.selectedClient,'is ineligible for a quote.'),__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],null,'Please update the following fields: '),__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{container:true,className:'invalidListBlock'},_this2.state.invalidFields.map(function(i){return __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:12,sm:6,md:6},__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],null,i));}))):null)))))),__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('br',null),page===0&&localStorage.getItem("userType")=="6"&&__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_45__ManageClients_elite__["a" /* default */],Object.assign({handleSelect:_this2.handleSelect.bind(_this2)},_this2.withoutClasses(_this2.props),_this2.state)),page===0&&__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_36__CC_clientForm_EliteWealth__["a" /* default */],Object.assign({changeFirstName:_this2.changeFirstName.bind(_this2),changeLastName:_this2.changeLastName.bind(_this2),changeSecondName:_this2.changeSecondName.bind(_this2),dobChanged:_this2.dobChanged,idChangeHandler:_this2.idChangeHandler.bind(_this2),maritalChangeHandler:_this2.maritalChangeHandler.bind(_this2),editMode:true,uploadMutation:uploadFileMutation,fileAttached:_this2.fileAttached,salaryChangeHandler:_this2.onSalaryChange.bind(_this2),toggleOccupationValid:_this2.toggleOccupationValid},_this2.withoutClasses(_this2.props),_this2.state)),page===0&&__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_37__CC_clientOccForm_EliteWealth__["a" /* default */],Object.assign({salaryChangeHandler:_this2.onSalaryChange.bind(_this2),toggleOccupationValid:_this2.toggleOccupationValid},_this2.withoutClasses(_this2.props),_this2.state))),!((!sessionStorage.getItem("ActiveBrokerId")||sessionStorage.getItem("ActiveBrokerId")==0)&&localStorage.getItem("userType")==6)&&__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:10,style:{flexBasis:"100%",maxWidth:"100%",margin:'auto'}},__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_38__ClientDetail_tabs_quotes_QuotesTab_EliteWealth_jsx__["a" /* default */],{clientId:clientId})));});}}]);return ClientEditForm_EliteWealth;}(__WEBPACK_IMPORTED_MODULE_12_react__["Component"]);ClientEditForm_EliteWealth=Object(__WEBPACK_IMPORTED_MODULE_16_redux_form__["e" /* reduxForm */])({form:form,destroyOnUnmount:true})(ClientEditForm_EliteWealth);ClientEditForm_EliteWealth=Object(__WEBPACK_IMPORTED_MODULE_14_react_redux__["b" /* connect */])(function(){return{};})(ClientEditForm_EliteWealth);ClientEditForm_EliteWealth=Object(__WEBPACK_IMPORTED_MODULE_13_react_apollo__["graphql"])(updateClient,{options:{update:function update(proxy,_ref3){var updateClient=_ref3.data.updateClient;var _proxy$readQuery=proxy.readQuery({query:__WEBPACK_IMPORTED_MODULE_11_queries_clientsByBroker__["a" /* getClientsByBroker */]}),clients=_proxy$readQuery.clients;var targetClientIndex=clients.findIndex(function(c){return c.id===updateClient.client.id;});clients[targetClientIndex]=updateClient.client;proxy.writeQuery({getClientsByBroker:__WEBPACK_IMPORTED_MODULE_11_queries_clientsByBroker__["a" /* getClientsByBroker */],data:clients});}}})(ClientEditForm_EliteWealth);/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_43__material_ui_core_styles_withStyles___default()(__WEBPACK_IMPORTED_MODULE_42_assets_jss_material_dashboard_pro_react_views_sweetAlertStyle_jsx__["a" /* default */])(ClientEditForm_EliteWealth));

/***/ }),
/* 2444 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_core__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_EnhancedTableHead_EnhancedTableHead_jsx__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_helpers_UserHelper__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_helpers_Search__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_queries_assistant_Broker_Assignment_BrokerAssignment_js__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_apollo__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_router__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__BaseTablePageContent__ = __webpack_require__(624);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}//Q&Ms
var columnData=[{id:"edit",numeric:false,disablePadding:true,label:"",noSort:true,width:"30px"},{id:"su_name",numeric:false,disablePadding:true,label:"Name"},{id:"su_email",numeric:false,disablePadding:true,label:"Email"}];var ManageClients=function(_Component){_inherits(ManageClients,_Component);function ManageClients(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ManageClients);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ManageClients.__proto__||Object.getPrototypeOf(ManageClients)).call.apply(_ref,[this].concat(args))),_this),_this.state={page:0,rowsPerPage:10,order:"desc",orderBy:"Name",searchTerm:"",loadingSearch:false,data:[],searchData:[]},_this.handleSearch=function(event){_this.setState({searchTerm:event.target.value});var values=event.target.value.split(" ");var brokers=_this.state.data;var inc=["su_name","su_surname","su_email"];var filteredData=Object(__WEBPACK_IMPORTED_MODULE_3_helpers_Search__["a" /* SearchDataSet */])(brokers,values,inc);_this.setState({searchData:filteredData});},_this.handleChangePage=function(event,page){_this.setState({page:page});},_this.handleChangeRowsPerPage=function(event){_this.setState({rowsPerPage:event.target.value});},_this.handleRequestSort=function(event,property){var orderBy=property;var order="desc";if(_this.state.orderBy===property&&_this.state.order==="desc"){order="asc";}_this.setState({order:order,orderBy:orderBy});},_this.handleSelect=function(broker){sessionStorage.setItem("ActiveBrokerId",broker.su_ID);sessionStorage.setItem("ActiveBrokerName",broker.su_name+" "+broker.su_surname);_this.setState();},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ManageClients,[{key:"getSorting",value:function getSorting(order,orderBy){return order==="desc"?function(a,b){return b[orderBy]<a[orderBy]?-1:1;}:function(a,b){return a[orderBy]<b[orderBy]?-1:1;};}},{key:"render",value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_apollo__["Query"],{query:__WEBPACK_IMPORTED_MODULE_4_queries_assistant_Broker_Assignment_BrokerAssignment_js__["a" /* AssistantBrokers */],variables:{userId:Object(__WEBPACK_IMPORTED_MODULE_2_helpers_UserHelper__["a" /* GetUserId */])(),token:Object(__WEBPACK_IMPORTED_MODULE_2_helpers_UserHelper__["c" /* GetUserToken */])(),statuses:[2]},fetchPolicy:"network-only"},function(_ref2){var loading=_ref2.loading,error=_ref2.error,data=_ref2.data,refetch=_ref2.refetch;if(loading)return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__BaseTablePageContent__["a" /* default */],{handleSearch:function handleSearch(e){return;},title:"Manage Clients - Select Broker",hideFilter:true},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["B" /* LinearProgress */],null)));if(error&&error.message&&error.message==="GraphQL error: invalid token"){Object(__WEBPACK_IMPORTED_MODULE_2_helpers_UserHelper__["d" /* Logout */])();return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_router__["a" /* Redirect */],{to:"/app/portal/login"});}if(_this2.state.data.length!==data.AssistantBrokers.length){_this2.setState({data:data.AssistantBrokers});}var qData=[];if(_this2.state.searchData.length>0&&_this2.state.searchTerm!==""){qData=_this2.state.searchData.slice();qData.sort(_this2.getSorting(_this2.state.order,_this2.state.orderBy));}else{qData=data.AssistantBrokers.slice();qData.sort(_this2.getSorting(_this2.state.order,_this2.state.orderBy));}return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__BaseTablePageContent__["a" /* default */],{handleSearch:_this2.handleSearch,changeClaimed:function changeClaimed(e){_this2.setState({onlyClaimed:e.target.checked});refetch();},title:"Select Broker",hideFilter:true},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Q" /* Table */],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_EnhancedTableHead_EnhancedTableHead_jsx__["a" /* default */],{order:_this2.state.order,orderBy:_this2.state.orderBy,onRequestSort:_this2.handleRequestSort,rowCount:_this2.state.searchData.length<1&&_this2.state.searchTerm!==""?_this2.state.searchData.length:qData.length,columnData:columnData}),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["R" /* TableBody */],null,_this2.state.searchData.length<1&&_this2.state.searchTerm!==""?__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("h3",null,"No results found"))):qData.slice(_this2.state.page*_this2.state.rowsPerPage,_this2.state.page*_this2.state.rowsPerPage+_this2.state.rowsPerPage).map(function(broker){return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],{className:"sqDataTable",key:broker.su_ID,onClick:function onClick(e){return _this2.props.handleSelect(broker);},style:sessionStorage.getItem("ActiveBrokerId")==broker.su_ID?{backgroundColor:'#f5f5f5'}:{}},sessionStorage.getItem("ActiveBrokerId")==broker.su_ID?__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{style:{padding:"0px",borderRight:"1px solid #e0e0e0",backgroundColor:"white"}},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["x" /* IconButton */],{onClick:function onClick(e){return _this2.props.handleSelect(broker);}},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["w" /* Icon */],{style:{color:'#6c5cab'}},"check_circle"))):__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{style:{padding:"0px",borderRight:"1px solid #e0e0e0",backgroundColor:"white"}},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["x" /* IconButton */],{onClick:function onClick(e){return _this2.props.handleSelect(broker);}},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["w" /* Icon */],{style:{color:'#6c5cab'}},"radio_button_unchecked"))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,broker.su_name," ",broker.su_surname),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,broker.su_email));}),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["U" /* TablePagination */],{count:_this2.state.searchData.length<1&&_this2.state.searchTerm!==""?_this2.state.searchData.length:qData.length,rowsPerPage:_this2.state.rowsPerPage,page:_this2.state.page,backIconButtonProps:{"aria-label":"Previous Page"},nextIconButtonProps:{"aria-label":"Next Page"},onChangePage:_this2.handleChangePage,onChangeRowsPerPage:_this2.handleChangeRowsPerPage})))));});}}]);return ManageClients;}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (ManageClients);

/***/ }),
/* 2445 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_core__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_Button__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_MobileStepper__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_MobileStepper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_MobileStepper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Grid_GridItem_jsx__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_graphql_tag__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_graphql_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_graphql_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_helpers_TaxCalculator__ = __webpack_require__(254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_helpers_UserHelper__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_queries_clientById__ = __webpack_require__(393);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_queries_clientsByBroker__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_apollo__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_redux__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_reducers_NotificationReducer__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_redux_form__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_store__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__helpers_PopulateClient__ = __webpack_require__(394);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__CC_bankDetail_jsx__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__CC_clientForm_jsx__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__CC_clientOccForm_jsx__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__CC_contactDetails_jsx__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__CC_healthInfo_jsx__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__CC_willDetail_jsx__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_helpers_Documents_js__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_constants_js__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_apollo_client__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_apollo_cache_inmemory__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_apollo_upload_client__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_helpers_DateHelpers__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_lodash__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_helpers_UriReader__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__material_ui_core_AppBar__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__material_ui_core_AppBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32__material_ui_core_AppBar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__material_ui_core_Tab__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__material_ui_core_Tab___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33__material_ui_core_Tab__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__material_ui_core_Tabs__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__material_ui_core_Tabs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34__material_ui_core_Tabs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__CC_clientForm_EliteWealth__ = __webpack_require__(622);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__CC_clientOccForm_EliteWealth__ = __webpack_require__(395);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__ClientDetail_tabs_quotes_QuotesTab_EliteWealth_jsx__ = __webpack_require__(623);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(["\n  mutation($file: Upload!, $id: String!) {\n    uploadClientAvatar(file: $file, id: $id)\n  }\n"],["\n  mutation($file: Upload!, $id: String!) {\n    uploadClientAvatar(file: $file, id: $id)\n  }\n"]),_templateObject2=_taggedTemplateLiteral(["\n  mutation updateClient($input: UpdateClientInput!) {\n    UpdateClient(input: $input) {\n      clientMutationId\n      client {\n        id\n        scd_name\n        scd_surname\n        scd_email\n        date_created\n        scd_clientType\n        scd_registered\n        invite_sent\n        app_info_complete\n        status\n      }\n    }\n  }\n"],["\n  mutation updateClient($input: UpdateClientInput!) {\n    UpdateClient(input: $input) {\n      clientMutationId\n      client {\n        id\n        scd_name\n        scd_surname\n        scd_email\n        date_created\n        scd_clientType\n        scd_registered\n        invite_sent\n        app_info_complete\n        status\n      }\n    }\n  }\n"]);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}/*eslint-disable*/var tabStyle={color:"white",borderBottom:"2px solid",opacity:"1"};var tabs=["Basic","Contact","Occupation","Bank","Health","Will"];var uploadClient=new __WEBPACK_IMPORTED_MODULE_26_apollo_client__["ApolloClient"]({link:Object(__WEBPACK_IMPORTED_MODULE_28_apollo_upload_client__["a" /* createUploadLink */])({uri:__WEBPACK_IMPORTED_MODULE_25_constants_js__["d" /* fileUploadServerPath */]}),cache:new __WEBPACK_IMPORTED_MODULE_27_apollo_cache_inmemory__["a" /* InMemoryCache */]()});var uploadFileMutation=__WEBPACK_IMPORTED_MODULE_5_graphql_tag___default()(_templateObject);var updateClient=__WEBPACK_IMPORTED_MODULE_5_graphql_tag___default()(_templateObject2);var form="client";var ClientHistory_EliteWealth=function(_Component){_inherits(ClientHistory_EliteWealth,_Component);function ClientHistory_EliteWealth(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ClientHistory_EliteWealth);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ClientHistory_EliteWealth.__proto__||Object.getPrototypeOf(ClientHistory_EliteWealth)).call.apply(_ref,[this].concat(args))),_this),_this.state={page:0,pageCount:6,checkValidation:false,formInitiazed:false,firstName:"",secondName:"",lastName:"",afterTaxIncome:"0",age:0,married:false,saCitizen:true,file:null,imgSrc:null,initialId:"",occupationValid:true,clientId:null},_this.toggleOccupationValid=function(valid){_this.setState({occupationValid:valid});},_this.submit=function(){if(_this.state.page===2&&!_this.state.occupationValid){__WEBPACK_IMPORTED_MODULE_16_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_14_reducers_NotificationReducer__["d" /* showSnack */])({message:"Invalid Occupation",color:"danger"}));return;}if(__WEBPACK_IMPORTED_MODULE_16_store__["a" /* default */].getState().form.client.syncErrors){__WEBPACK_IMPORTED_MODULE_16_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_14_reducers_NotificationReducer__["d" /* showSnack */])({message:"Invalid Information",color:"danger"}));_this.setState({checkValidation:true});_this.forceUpdate();}else if(_this.checkOccupationDuties()){__WEBPACK_IMPORTED_MODULE_16_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_14_reducers_NotificationReducer__["d" /* showSnack */])({message:"Occupational Duties must add up to 100%",color:"danger"}));}else{_this.setState({checkValidation:false});var dat=__WEBPACK_IMPORTED_MODULE_16_store__["a" /* default */].getState().form.client.values;dat.calculatedMonthlyIncomeAT=_this.state.afterTaxIncome;dat.actualMonthlyIncomeAT=_this.state.afterTaxIncome;var input={clientId:_this.state.clientId,data:dat,token:Object(__WEBPACK_IMPORTED_MODULE_7_helpers_UserHelper__["c" /* GetUserToken */])()};_this.props.mutate({variables:{input:input}}).then(function(resp){__WEBPACK_IMPORTED_MODULE_16_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_14_reducers_NotificationReducer__["e" /* successWarning */])({open:true,title:"Client Updated.",onConfirm:function onConfirm(){var url='/app/quote?'+window.location.href.substring(window.location.href.indexOf("?")+1);_this.props.history.push(url);}}));if(_this.state.file!==null){uploadClient.mutate({mutation:uploadFileMutation,variables:{file:_this.state.file,id:_this.state.clientId}}).then(console.log("profile picture updated"));}}).catch(function(error){__WEBPACK_IMPORTED_MODULE_16_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_14_reducers_NotificationReducer__["d" /* showSnack */])({message:"There was an error updating this client : "+error,color:"danger"}));});}},_this.checkOccupationDuties=function(){var clientForm=__WEBPACK_IMPORTED_MODULE_16_store__["a" /* default */].getState().form.client.values;if(_this.state.page===2&&parseInt(clientForm.Admin)+parseInt(clientForm.Travel)+parseInt(clientForm.ManualLabour)+parseInt(clientForm.Supervision)!==100){return true;}return false;},_this.nextPage=function(){if(_this.state.page===2&&!_this.state.occupationValid){__WEBPACK_IMPORTED_MODULE_16_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_14_reducers_NotificationReducer__["d" /* showSnack */])({message:"Invalid Occupation",color:"danger"}));return;}if(_this.checkOccupationDuties()){__WEBPACK_IMPORTED_MODULE_16_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_14_reducers_NotificationReducer__["d" /* showSnack */])({message:"Occupational Duties must add up to 100%",color:"danger"}));}else{if(__WEBPACK_IMPORTED_MODULE_16_store__["a" /* default */].getState().form.client.syncErrors){__WEBPACK_IMPORTED_MODULE_16_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_14_reducers_NotificationReducer__["d" /* showSnack */])({message:"Invalid Information",color:"danger"}));_this.setState({checkValidation:true});_this.forceUpdate();}else{_this.setState({page:_this.state.page+1,checkValidation:false});_this.forceUpdate();_this.props.scrollMeBar();}}},_this.previousPage=function(){if(_this.state.page===2&&!_this.state.occupationValid){__WEBPACK_IMPORTED_MODULE_16_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_14_reducers_NotificationReducer__["d" /* showSnack */])({message:"Invalid Occupation",color:"danger"}));return;}_this.setState({page:_this.state.page-1});_this.props.scrollMeBar();},_this.dobChanged=function(val){try{if(val.length!==10)throw"Too short";var dob=Object(__WEBPACK_IMPORTED_MODULE_29_helpers_DateHelpers__["b" /* ParseDMYwSlashes */])(val);var age=__WEBPACK_IMPORTED_MODULE_8_moment___default()().diff(dob,"years");__WEBPACK_IMPORTED_MODULE_16_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_15_redux_form__["b" /* change */])("client","age",age));}catch(error){__WEBPACK_IMPORTED_MODULE_16_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_15_redux_form__["b" /* change */])("client","age",""));}_this.forceUpdate();},_this.maritalChangeHandler=function(value){if(value==="Married"){_this.setState({married:true});if(__WEBPACK_IMPORTED_MODULE_16_store__["a" /* default */].getState().form.client.values.title==="MISS"){__WEBPACK_IMPORTED_MODULE_16_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_15_redux_form__["b" /* change */])("client","title","MRS"));}}else{if(value!=="validationError"){if(__WEBPACK_IMPORTED_MODULE_16_store__["a" /* default */].getState().form.client.values.title==="MRS"){__WEBPACK_IMPORTED_MODULE_16_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_15_redux_form__["b" /* change */])("client","title","MISS"));}}__WEBPACK_IMPORTED_MODULE_16_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_15_redux_form__["b" /* change */])("client","spouseIncome",""));_this.setState({married:false});}},_this.idChangeHandler=function(value){if(value==="idNumber"){if(!_this.state.saCitizen){_this.resetclientIdDetails();}_this.setState({saCitizen:true});}else{if(_this.state.saCitizen){_this.resetclientIdDetails();}_this.setState({saCitizen:false});}},_this.fileAttached=function(file){var valid=Object(__WEBPACK_IMPORTED_MODULE_24_helpers_Documents_js__["d" /* validateFile */])(file.name,__WEBPACK_IMPORTED_MODULE_24_helpers_Documents_js__["c" /* imageTypes */]);if(!valid){__WEBPACK_IMPORTED_MODULE_16_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_14_reducers_NotificationReducer__["d" /* showSnack */])({message:"Invalid file type.",color:"danger"}));}else{_this.setState({file:file,imgSrc:URL.createObjectURL(file)});}},_this.handleChangeTab=function(event,value){if(value==0)return;_this.setState({page:value-1});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ClientHistory_EliteWealth,[{key:"componentDidMount",value:function componentDidMount(){var params=Object(__WEBPACK_IMPORTED_MODULE_31_helpers_UriReader__["a" /* ParseUriParams */])(this.props.location.search);var clientId=params.clientId;this.setState({clientId:clientId});}},{key:"initializeForm",value:function initializeForm(data){this.setState({firstName:data.scd_name?data.scd_name:"",lastName:data.scd_surname?data.scd_surname:""});var populatedClient=Object(__WEBPACK_IMPORTED_MODULE_17__helpers_PopulateClient__["a" /* default */])(data);this.props.initialize(Object.assign({},populatedClient));if(data.scd_maritalStatus&&data.scd_maritalStatus==="Married"){this.setState({married:true});}if(data.scd_idType&&data.scd_idType==="passport"){this.setState({saCitizen:false});}if(data.scd_pp_path){this.setState({imgSrc:data.scd_pp_path});}if(data.scd_dateOfBirth){this.dobChanged(data.scd_dateOfBirth.split("T")[0]);}if(data.scd_monthlyIncome){this.onSalaryChange(parseFloat(data.scd_monthlyIncome));}this.setState({formInitiazed:true,initialId:data.scd_saID?data.scd_saID:""});}},{key:"componentWillUnmount",value:function componentWillUnmount(){__WEBPACK_IMPORTED_MODULE_16_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_15_redux_form__["f" /* reset */])("client"));__WEBPACK_IMPORTED_MODULE_16_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_14_reducers_NotificationReducer__["d" /* showSnack */])({open:false}));}},{key:"changeFirstName",value:function changeFirstName(name){if(name&&name!==""){var initials="";initials=name.substring(0,1)+this.state.secondName.substring(0,1);__WEBPACK_IMPORTED_MODULE_16_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_15_redux_form__["b" /* change */])("client","initials",initials));this.setState({firstName:name});}}},{key:"changeSecondName",value:function changeSecondName(name){if(name&&name!==""){var initials="";initials=this.state.firstName.substring(0,1)+name.substring(0,1);__WEBPACK_IMPORTED_MODULE_16_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_15_redux_form__["b" /* change */])("client","initials",initials));this.setState({secondName:name});}}},{key:"changeLastName",value:function changeLastName(name){this.setState({lastName:name});}},{key:"onSalaryChange",value:function onSalaryChange(value){value=value.toString().replace(/,/g,"").replace(/ /g,"");if(value===""||isNaN(Number(value))){return;}var x=Object(__WEBPACK_IMPORTED_MODULE_6_helpers_TaxCalculator__["a" /* default */])(parseFloat(value),__WEBPACK_IMPORTED_MODULE_30_lodash___default.a.get(__WEBPACK_IMPORTED_MODULE_16_store__["a" /* default */].getState().form,"client.values.age",null));x=x.toString();//let parsed = parseFloat(val);
this.setState({afterTaxIncome:x.toString()});this.forceUpdate();if(__WEBPACK_IMPORTED_MODULE_16_store__["a" /* default */].getState().form.client.fields&&__WEBPACK_IMPORTED_MODULE_16_store__["a" /* default */].getState().form.client.fields.actualMonthlyIncomeAT&&__WEBPACK_IMPORTED_MODULE_16_store__["a" /* default */].getState().form.client.fields.actualMonthlyIncomeAT.touched){return;}else{__WEBPACK_IMPORTED_MODULE_16_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_15_redux_form__["b" /* change */])("client","actualMonthlyIncomeAT",x.toString()));__WEBPACK_IMPORTED_MODULE_16_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_15_redux_form__["h" /* untouch */])("client","actualMonthlyIncomeAT"));}}},{key:"resetclientIdDetails",value:function resetclientIdDetails(){__WEBPACK_IMPORTED_MODULE_16_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_15_redux_form__["b" /* change */])("client","said",""));__WEBPACK_IMPORTED_MODULE_16_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_15_redux_form__["h" /* untouch */])("client","said"));__WEBPACK_IMPORTED_MODULE_16_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_15_redux_form__["b" /* change */])("client","passportNumber",""));__WEBPACK_IMPORTED_MODULE_16_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_15_redux_form__["h" /* untouch */])("client","passportNumber"));}},{key:"withoutClasses",value:function withoutClasses(props){var newProps=Object.assign({},props);delete newProps.classes;return newProps;}},{key:"render",value:function render(){var _this2=this;var page=this.state.page;var params=Object(__WEBPACK_IMPORTED_MODULE_31_helpers_UriReader__["a" /* ParseUriParams */])(this.props.location.search);var clientId=params.clientId;return __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react_apollo__["Query"],{query:__WEBPACK_IMPORTED_MODULE_9_queries_clientById__["a" /* ClientById */],variables:{id:clientId,token:Object(__WEBPACK_IMPORTED_MODULE_7_helpers_UserHelper__["c" /* GetUserToken */])()},fetchPolicy:"network-only"},function(_ref2){var loading=_ref2.loading,error=_ref2.error,data=_ref2.data;if(loading)return __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["B" /* LinearProgress */],null));if(error)return"Error! "+error.message;if(!_this2.state.formInitiazed){_this2.initializeForm(data.ClientById[0]);}return __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{container:true},__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:10,style:{flexBasis:"100%",maxWidth:"100%",margin:'auto'}},__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_37__ClientDetail_tabs_quotes_QuotesTab_EliteWealth_jsx__["a" /* default */],{clientId:clientId})));});}}]);return ClientHistory_EliteWealth;}(__WEBPACK_IMPORTED_MODULE_11_react__["Component"]);ClientHistory_EliteWealth=Object(__WEBPACK_IMPORTED_MODULE_15_redux_form__["e" /* reduxForm */])({form:form,destroyOnUnmount:true})(ClientHistory_EliteWealth);ClientHistory_EliteWealth=Object(__WEBPACK_IMPORTED_MODULE_13_react_redux__["b" /* connect */])(function(){return{};})(ClientHistory_EliteWealth);ClientHistory_EliteWealth=Object(__WEBPACK_IMPORTED_MODULE_12_react_apollo__["graphql"])(updateClient,{options:{update:function update(proxy,_ref3){var updateClient=_ref3.data.updateClient;var _proxy$readQuery=proxy.readQuery({query:__WEBPACK_IMPORTED_MODULE_10_queries_clientsByBroker__["a" /* getClientsByBroker */]}),clients=_proxy$readQuery.clients;var targetClientIndex=clients.findIndex(function(c){return c.id===updateClient.client.id;});clients[targetClientIndex]=updateClient.client;proxy.writeQuery({getClientsByBroker:__WEBPACK_IMPORTED_MODULE_10_queries_clientsByBroker__["a" /* getClientsByBroker */],data:clients});}}})(ClientHistory_EliteWealth);/* harmony default export */ __webpack_exports__["a"] = (ClientHistory_EliteWealth);

/***/ }),
/* 2446 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_core__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_icons__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Grid_GridItem_jsx__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_helpers_UserHelper__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_queries_clientsByBroker__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_apollo__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_redux__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_router__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_EnhancedTableHead_EnhancedTableHead_jsx__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_helpers_Search__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_queries_QuoteEligibility__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_assets_jss_material_dashboard_pro_react_views_sweetAlertStyle_jsx__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__material_ui_core_styles_withStyles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__material_ui_core_styles_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__material_ui_core_styles_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react_bootstrap_sweetalert__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react_bootstrap_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_react_bootstrap_sweetalert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_helpers_DateHelpers__ = __webpack_require__(40);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var columnData=[{id:'edit',numeric:false,disablePadding:true,label:'',noSort:true,width:'30px'},{id:'scd_name',numeric:false,disablePadding:true,label:'Name'},{id:'scd_email',numeric:false,disablePadding:true,label:'Email'},{id:'date_modified',numeric:false,disablePadding:true,label:'Date Created / Modified'}];var ClientForQuote=function(_Component){_inherits(ClientForQuote,_Component);function ClientForQuote(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ClientForQuote);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ClientForQuote.__proto__||Object.getPrototypeOf(ClientForQuote)).call.apply(_ref,[this].concat(args))),_this),_this.state={page:0,rowsPerPage:10,order:'desc',orderBy:'date_modified',searchTerm:'',loadingSearch:false,searchData:[],assistantActive:false,eligibilityDialogOpen:false,invalidFields:[],selectedClient:{}},_this.handleSearch=function(event){_this.setState({searchTerm:event.target.value});var values=event.target.value.split(' ');var data=_this.props.data.getClientsByBroker;var inc=['scd_name','scd_surname','scd_email','date_created'];var filteredData=Object(__WEBPACK_IMPORTED_MODULE_11_helpers_Search__["a" /* SearchDataSet */])(data,values,inc);_this.setState({searchData:filteredData});},_this.handleChangePage=function(event,page){_this.setState({page:page});},_this.handleChangeRowsPerPage=function(event){_this.setState({rowsPerPage:event.target.value});},_this.handleRequestSort=function(event,property){var orderBy=property;var order='desc';if(_this.state.orderBy===property&&_this.state.order==='desc'){order='asc';}_this.setState({order:order,orderBy:orderBy});},_this.getBrokerId=function(){var brokerId=Object(__WEBPACK_IMPORTED_MODULE_4_helpers_UserHelper__["a" /* GetUserId */])();if(_this.checkAssistantActive()){brokerId=sessionStorage.getItem('ActiveBrokerId');}return brokerId;},_this.getBrokerName=function(){return sessionStorage.getItem('ActiveBrokerName');},_this.sortDateDesc=function(a,b){return new Date(b.date_modified)-new Date(a.date_modified);},_this.sortDateAsc=function(a,b){return new Date(a.date_modified)-new Date(b.date_modified);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ClientForQuote,[{key:'componentDidMount',value:function componentDidMount(){this.props.scrollMeBar();}},{key:'getSorting',value:function getSorting(order,orderBy){return order==='desc'?function(a,b){return b[orderBy]<a[orderBy]?-1:1;}:function(a,b){return a[orderBy]<b[orderBy]?-1:1;};}},{key:'handleEdit',value:function handleEdit(id){this.props.history.push({pathname:'/app/quote/',search:'clientId='+atob(id).split(':')[1]});}},{key:'handleEditClient',value:function handleEditClient(){this.props.history.push({pathname:'/app/EditClient',search:'clientId='+atob(this.state.selectedClient.id).split(':')[1]});}},{key:'checkAssistantActive',value:function checkAssistantActive(){if(Object(__WEBPACK_IMPORTED_MODULE_4_helpers_UserHelper__["b" /* GetUserKey */])('userType')==='6'){if(!this.state.assistantActive){this.setState({assistantActive:true});}return true;}return false;}},{key:'render',value:function render(){var _this2=this;this.checkAssistantActive();if(this.props.data.loading){return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["B" /* LinearProgress */],null);}if(this.props.data.error&&this.props.data.error.message&&this.props.data.error.message==='GraphQL error: invalid token'){Object(__WEBPACK_IMPORTED_MODULE_4_helpers_UserHelper__["d" /* Logout */])();return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_router__["a" /* Redirect */],{to:'/app/portal/login'});}var data=[];if(this.state.searchData.length>0&&this.state.searchTerm!==''){data=this.state.searchData.slice();}else{data=this.props.data.getClientsByBroker.slice();}if(this.state.orderBy==='date_modified'){data.sort(this.state.order==='desc'?this.sortDateDesc:this.sortDateAsc);}else{data.sort(this.getSorting(this.state.order,this.state.orderBy));}return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{container:true},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:10,style:{flexBasis:"100%",maxWidth:"100%",margin:'auto'}},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["e" /* Card */],null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["f" /* CardContent */],null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{container:true,justify:'space-between',style:{marginBottom:'15px'}},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{item:true,xs:12,sm:12,md:12},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{variant:'headline'},'Choose Client for Quote'),this.state.assistantActive?__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{variant:'caption',gutterBottom:true},this.getBrokerName()):null)),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["X" /* TextField */],{id:'input-with-icon-textfield',fullWidth:true,style:{marginBottom:'3vh'},placeholder:'Search Client by Name, Surname,Email or Date Created(YYYY/MM/DD)',onChange:this.handleSearch,label:'Search',InputProps:{startAdornment:__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["z" /* InputAdornment */],{position:'start'},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_icons__["n" /* Search */],null))}}),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["I" /* Paper */],{style:{overflowX:'auto'}},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Q" /* Table */],null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_EnhancedTableHead_EnhancedTableHead_jsx__["a" /* default */],{order:this.state.order,orderBy:this.state.orderBy,onRequestSort:this.handleRequestSort,rowCount:this.state.searchData.length<1&&this.state.searchTerm!==''?this.state.searchData.length:data.length,columnData:columnData}),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["R" /* TableBody */],null,this.state.searchData.length<1&&this.state.searchTerm!==''?__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('h3',null,'No results found'))):data.slice(this.state.page*this.state.rowsPerPage,this.state.page*this.state.rowsPerPage+this.state.rowsPerPage).map(function(client){return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_apollo__["Mutation"],{key:client.id,mutation:__WEBPACK_IMPORTED_MODULE_12_queries_QuoteEligibility__["a" /* QuoteEligibility */],onCompleted:function onCompleted(data){var quoteEligibility=data.QuoteEligibility;if(!quoteEligibility.valid){var invalidFields=quoteEligibility.invalidFields.split(',');_this2.setState({eligibilityDialogOpen:true,invalidFields:invalidFields,selectedClient:client});}else{_this2.handleEdit(client.id);}}},function(mutate){return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],{key:client.id,className:'sqDataTable',onClick:function onClick(){return mutate({variables:{input:{clientId:atob(client.id).split(':')[1]}}});}},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{style:{padding:'0px',borderRight:'1px solid #e0e0e0',backgroundColor:'white'}},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["x" /* IconButton */],{onClick:function onClick(){return mutate({variables:{input:{clientId:atob(client.id).split(':')[1]}}});}},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["w" /* Icon */],null,'more_vert'))),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,client.scd_name,' ',client.scd_surname),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,client.scd_email),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,Object(__WEBPACK_IMPORTED_MODULE_16_helpers_DateHelpers__["a" /* DateTimeFormatter */])(client.date_modified)));});}),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["U" /* TablePagination */],{count:this.state.searchData.length<1&&this.state.searchTerm!==''?this.state.searchData.length:data.length,rowsPerPage:this.state.rowsPerPage,page:this.state.page,backIconButtonProps:{'aria-label':'Previous Page'},nextIconButtonProps:{'aria-label':'Next Page'},onChangePage:this.handleChangePage,onChangeRowsPerPage:this.handleChangeRowsPerPage})))))))),this.state.eligibilityDialogOpen?__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_react_bootstrap_sweetalert___default.a,{warning:true,style:{wordWrap:'break-word',top:'40%'},title:'Ineligible',confirmBtnCssClass:this.props.classes.button+' '+this.props.classes.success,cancelBtnCssClass:this.props.classes.button+' '+this.props.classes.danger,confirmBtnText:'Edit Client',cancelBtnText:'Close',onConfirm:function onConfirm(){_this2.handleEditClient();},onCancel:function onCancel(){_this2.setState({eligibilityDialogOpen:false});},showCancel:!this.state.loadingDelete,showConfirm:!this.state.loadingDelete},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],null,this.state.selectedClient.scd_name+' '+this.state.selectedClient.scd_surname+' ','is ineligible for a quote.'),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],null,'Please update the following fields: '),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{container:true,className:'invalidListBlock'},this.state.invalidFields.map(function(i,index){return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{item:true,xs:12,sm:6,md:6,key:index},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],null,i));}))):null);}}]);return ClientForQuote;}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);ClientForQuote=Object(__WEBPACK_IMPORTED_MODULE_7_react_apollo__["graphql"])(__WEBPACK_IMPORTED_MODULE_5_queries_clientsByBroker__["a" /* getClientsByBroker */],{options:function options(){return{fetchPolicy:'cache-and-network'};},props:function props(_props){if(_props.data.error){}return Object.assign({},_props);}})(ClientForQuote);ClientForQuote=Object(__WEBPACK_IMPORTED_MODULE_8_react_redux__["b" /* connect */])(function(state){return{brokerId:Object(__WEBPACK_IMPORTED_MODULE_4_helpers_UserHelper__["b" /* GetUserKey */])('userType')==='6'?sessionStorage.getItem('ActiveBrokerId'):Object(__WEBPACK_IMPORTED_MODULE_4_helpers_UserHelper__["a" /* GetUserId */])(),token:Object(__WEBPACK_IMPORTED_MODULE_4_helpers_UserHelper__["c" /* GetUserToken */])(),status:'own',userType:Object(__WEBPACK_IMPORTED_MODULE_4_helpers_UserHelper__["b" /* GetUserKey */])('userType')};})(ClientForQuote);/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_14__material_ui_core_styles_withStyles___default()(__WEBPACK_IMPORTED_MODULE_13_assets_jss_material_dashboard_pro_react_views_sweetAlertStyle_jsx__["a" /* default */])(ClientForQuote));

/***/ }),
/* 2447 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_core__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_Divider__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_Divider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Divider__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_List__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_List___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_List__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_ListItem__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_ListItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_ListItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_ListItemText__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_ListItemText___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_ListItemText__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_Table_EmptyBody_jsx__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_helpers_UserHelper__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_queries_quotes_queries__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_apollo__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_router__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__containers_QuoteHistoryContainer_jsx__ = __webpack_require__(2448);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_helpers_UriReader__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_queries_QuoteEligibility__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__material_ui_core_Grid__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__material_ui_core_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__material_ui_core_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react_bootstrap_sweetalert__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react_bootstrap_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_react_bootstrap_sweetalert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_assets_jss_material_dashboard_pro_react_views_sweetAlertStyle_jsx__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__material_ui_core_styles_withStyles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__material_ui_core_styles_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__material_ui_core_styles_withStyles__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var columnData=[{id:'edit',numeric:false,disablePadding:true,label:'',noSort:true,width:'30px'},{id:'description',numeric:false,disablePadding:true,label:'Description',noSort:true},{id:'c.scd_surname',numeric:false,disablePadding:true,label:'Client Name'},{id:'t.date_created',numeric:false,disablePadding:true,label:'Date Created'}];var QuoteHistory=function(_Component){_inherits(QuoteHistory,_Component);function QuoteHistory(){var _ref;var _temp,_this,_ret;_classCallCheck(this,QuoteHistory);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=QuoteHistory.__proto__||Object.getPrototypeOf(QuoteHistory)).call.apply(_ref,[this].concat(args))),_this),_this.state={page:0,rowsPerPage:5,order:'desc',orderBy:'t.date_created',searchTerm:'',loadingSearch:false,searchData:[],openMenus:[],openMenusPage:0,anchorTop:0,anchorLeft:0,popoverOpen:false,assistantActive:false,search:null,clientId:null,clientName:null,refresh:false,eligibilityDialogOpen:false,invalidFields:[],selectedClient:{},tab:0},_this.handleSearch=function(event,refetch){_this.handleCloseAll();_this.setState({searchTerm:event.target.value});refetch();},_this.handleChangePage=function(page,refetch){_this.handleCloseAll();_this.setState({page:page});refetch();},_this.handleChangeRowsPerPage=function(event,refetch){_this.handleCloseAll();_this.setState({rowsPerPage:event.target.value});refetch();},_this.handleRequestSort=function(event,property,refetch){_this.handleCloseAll();var orderBy=property;var order='desc';if(_this.state.orderBy===property&&_this.state.order==='desc'){order='asc';}_this.setState({order:order,orderBy:orderBy});refetch();},_this.handleClick=function(event,id){_this.setState({anchorTop:event.clientY,anchorLeft:event.clientX});var openMenus=_this.state.openMenus.slice();//console.log(openMenus)
//console.log(event)
//console.log(id)
openMenus.filter(function(x){return x.id===id;})[0].open=true;_this.setState({openMenus:openMenus,popoverOpen:true});},_this.handleClose=function(id){var openMenus=_this.state.openMenus.slice();openMenus.filter(function(x){return x.id===id;})[0].open=false;_this.setState({openMenus:openMenus,popoverOpen:false});},_this.handleCloseAll=function(){var openMenus=_this.state.openMenus.slice();openMenus=openMenus.map(function(x){return x.open===false;});_this.setState({openMenus:openMenus,popoverOpen:false,refresh:true});},_this.getBrokerId=function(){var brokerId=Object(__WEBPACK_IMPORTED_MODULE_6_helpers_UserHelper__["a" /* GetUserId */])();if(_this.checkAssistantActive()){brokerId=sessionStorage.getItem('ActiveBrokerId');}return brokerId;},_this.getBrokerName=function(){return sessionStorage.getItem('ActiveBrokerName');},_this.handleNewQuote=function(){_this.props.history.push('/app/new');},_this.handleChangeTab=function(tab){if(tab.target.innerHTML.includes("Medical"))_this.setState({tab:1});if(tab.target.innerHTML.includes("Risk"))_this.setState({tab:0});//console.log("tabChange " + tab.target.innerHTML)
//console.log("tabChange " + tab.target.querySelector("span"))
},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(QuoteHistory,[{key:'componentDidMount',value:function componentDidMount(){var params=Object(__WEBPACK_IMPORTED_MODULE_12_helpers_UriReader__["a" /* ParseUriParams */])(this.props.location.search);var clientId=params.clientId,clientName=params.clientName;this.setState({clientId:clientId,clientName:clientName});}},{key:'handleView',value:function handleView(quote){sessionStorage.setItem('QuoteresultId',quote.sq_taskguid);if(this.state.tab==0){this.props.history.push({pathname:'/app/quoteresult',search:'guid='+quote.sq_taskguid});}if(this.state.tab==1){this.props.history.push({pathname:'/app/quotemedical',search:'clientId='+quote.fk_clientID+'&guid='+quote.sq_taskguid+'&page=3'});}}},{key:'handleEdit',value:function handleEdit(clientId,guid){if(this.state.tab==0){this.props.history.push({pathname:'/app/quote/',search:'clientId='+clientId+'&guid='+guid});}if(this.state.tab==1){this.props.history.push({pathname:'/app/quotemedical',search:'clientId='+clientId+'&guid='+guid});}}},{key:'checkAssistantActive',value:function checkAssistantActive(){if(Object(__WEBPACK_IMPORTED_MODULE_6_helpers_UserHelper__["b" /* GetUserKey */])('userType')==='6'){if(!this.state.assistantActive){this.setState({assistantActive:true});}return true;}return false;}},{key:'render',value:function render(){var _this2=this;this.checkAssistantActive();var colSpan=Object.keys(columnData).length;var params=Object(__WEBPACK_IMPORTED_MODULE_12_helpers_UriReader__["a" /* ParseUriParams */])(this.props.location.search);var clientId=params.clientId,clientName=params.clientName;return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_apollo__["Query"],{query:this.state.tab==0?__WEBPACK_IMPORTED_MODULE_7_queries_quotes_queries__["c" /* GetQuoteHistory */]:__WEBPACK_IMPORTED_MODULE_7_queries_quotes_queries__["d" /* GetQuoteHistoryMedical */],variables:{brokerId:this.getBrokerId(),token:Object(__WEBPACK_IMPORTED_MODULE_6_helpers_UserHelper__["c" /* GetUserToken */])(),limit:this.state.rowsPerPage,page:this.state.page,orderBy:this.state.orderBy,direction:this.state.order,search:this.state.searchTerm,clientId:clientId},fetchPolicy:'network-only'},function(_ref2){var loading=_ref2.loading,error=_ref2.error,data=_ref2.data,refetch=_ref2.refetch;if(loading){return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__containers_QuoteHistoryContainer_jsx__["a" /* default */],Object.assign({},_this2.state,{brokerName:_this2.getBrokerName(),handleSearch:function handleSearch(e){return _this2.handleSearch(e,refetch);},handleRequestSort:function handleRequestSort(event,property){return _this2.handleRequestSort(event,property,refetch);},handleChangeTab:function handleChangeTab(e){return _this2.handleChangeTab(e);},clientName:clientName,columnData:columnData,tableBody:__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Table_EmptyBody_jsx__["a" /* default */],{colSpan:colSpan,rowSpan:_this2.state.rowsPerPage,placeHolder:__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["j" /* CircularProgress */],null)}),chipClicked:_this2.handleNewQuote}));}if(error&&error.message&&error.message==='GraphQL error: invalid token'){Object(__WEBPACK_IMPORTED_MODULE_6_helpers_UserHelper__["d" /* Logout */])();return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react_router__["a" /* Redirect */],{to:'/app/portal/login'});}if(error)return'Error! '+error.message;var items=null;var count=null;if(_this2.state.tab==0){items=data.QuoteHistory.Results;count=data.QuoteHistory.Count;}else{items=data.QuoteHistoryMedical.Results;count=data.QuoteHistoryMedical.Count;}if(items&&(_this2.state.refresh||_this2.state.openMenus.length!==items.length||_this2.state.openMenusPage!==_this2.state.page)||_this2.state.openMenus[0].id!=items[0].sq_taskguid){var openMenus=[];items.map(function(q){openMenus.push({open:false,id:q.sq_taskguid});return q;});_this2.setState({openMenus:openMenus,openMenusPage:_this2.state.page,refresh:false});console.log(_this2.state.openMenus);}return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__containers_QuoteHistoryContainer_jsx__["a" /* default */],Object.assign({},_this2.state,{brokerName:_this2.getBrokerName(),handleSearch:function handleSearch(e){return _this2.handleSearch(e,refetch);},handleRequestSort:function handleRequestSort(event,property){return _this2.handleRequestSort(event,property,refetch);},handleChangeTab:function handleChangeTab(e){return _this2.handleChangeTab(e);},clientName:clientName,columnData:columnData,chipClicked:_this2.handleNewQuote,tableBody:__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react___default.a.Fragment,null,items.length<1&&_this2.state.searchTerm!==''?__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Table_EmptyBody_jsx__["a" /* default */],{colSpan:colSpan,rowSpan:_this2.state.rowsPerPage,placeHolder:__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{variant:'subheading'},_this2.state.searchTerm!==''?'No results found':'No Quotes created yet. Click on Create Quote')}):__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react___default.a.Fragment,null,items.map(function(quote){var openMenus=_this2.state.openMenus.length>0;var openMenu=null;if(openMenus){openMenu=_this2.state.openMenus.find(function(m){return m.id===quote.sq_taskguid;});}return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],{className:'sqDataTable',key:quote.id,onClick:function onClick(e){return _this2.state.popoverOpen===false?_this2.handleClick(e,quote.sq_taskguid):null;},style:openMenu&&openMenu.open?{backgroundColor:'#dedede'}:{}},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{style:{padding:'0px',borderRight:'1px solid #e0e0e0',backgroundColor:'white'}},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["x" /* IconButton */],{onClick:function onClick(e){return _this2.state.popoverOpen===false?_this2.handleClick(e,quote.sq_taskguid):null;}},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["w" /* Icon */],null,'more_vert'))),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,quote.description),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,quote.fullName),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,quote.date_created),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["J" /* Popover */],{open:openMenu?openMenu.open:false,anchorReference:'anchorPosition',anchorPosition:{left:_this2.state.anchorLeft,top:_this2.state.anchorTop},onClose:function onClose(){return _this2.handleClose(quote.sq_taskguid);}},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_List___default.a,{component:'nav'},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_ListItem___default.a,{button:true,onClick:function onClick(){return _this2.handleView(quote);}},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_ListItemText___default.a,{primary:'View Results'})),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Divider___default.a,null),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_apollo__["Mutation"],{mutation:__WEBPACK_IMPORTED_MODULE_13_queries_QuoteEligibility__["a" /* QuoteEligibility */],onCompleted:function onCompleted(data){var quoteEligibility=data.QuoteEligibility;if(!quoteEligibility.valid){var invalidFields=quoteEligibility.invalidFields.split(',');_this2.setState({eligibilityDialogOpen:true,invalidFields:invalidFields,selectedClient:quote.fullName});}else{_this2.handleEdit(quote.fk_clientID,quote.sq_taskguid);}}},function(mutate){return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_ListItem___default.a,{button:true,divider:true,onClick:function onClick(){return mutate({variables:{input:{clientId:quote.fk_clientID}}});}},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_ListItemText___default.a,{primary:'Edit Quote'}));}))));}),[].concat(_toConsumableArray(Array(_this2.state.rowsPerPage-items.length))).map(function(a,i){return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],{key:i,colSpan:colSpan});})),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["U" /* TablePagination */],{count:count,rowsPerPage:_this2.state.rowsPerPage,page:_this2.state.page,backIconButtonProps:{'aria-label':'Previous Page'},nextIconButtonProps:{'aria-label':'Next Page'},onChangePage:function onChangePage(event,page){return _this2.handleChangePage(page,refetch);},onChangeRowsPerPage:function onChangeRowsPerPage(event){return _this2.handleChangeRowsPerPage(event,refetch);}})))})),_this2.state.eligibilityDialogOpen?__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_react_bootstrap_sweetalert___default.a,{warning:true,style:{wordWrap:'break-word',top:'40%'},title:'Ineligible',confirmBtnCssClass:_this2.props.classes.button+' '+_this2.props.classes.success,cancelBtnCssClass:_this2.props.classes.button+' '+_this2.props.classes.danger,confirmBtnText:'Edit Client',cancelBtnText:'Close',onConfirm:function onConfirm(){_this2.handleEditClient();},onCancel:function onCancel(){_this2.setState({eligibilityDialogOpen:false});},showCancel:!_this2.state.loadingDelete,showConfirm:!_this2.state.loadingDelete},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],null,_this2.state.selectedClient,'is ineligible for a quote.'),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],null,'Please update the following fields: '),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__material_ui_core_Grid___default.a,{container:true,className:'invalidListBlock'},_this2.state.invalidFields.map(function(i){return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__material_ui_core_Grid___default.a,{item:true,xs:12,sm:6,md:6},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],null,i));}))):null);});}}]);return QuoteHistory;}(__WEBPACK_IMPORTED_MODULE_8_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_17__material_ui_core_styles_withStyles___default()(__WEBPACK_IMPORTED_MODULE_16_assets_jss_material_dashboard_pro_react_views_sweetAlertStyle_jsx__["a" /* default */])(QuoteHistory));

/***/ }),
/* 2448 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_core__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_icons__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Grid_GridItem_jsx__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_EnhancedTableHead_EnhancedTableHead_jsx__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_CustomChip_CustomChip_jsx__ = __webpack_require__(195);
var tabStyle={color:"#6c5cab",borderBottom:"2px solid"};var tabs=["Risk","Medical"];var QuoteHistoryContainer=function QuoteHistoryContainer(props){var tab=props.tab;return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{container:true},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:10,style:{flexBasis:"100%",maxWidth:"100%",margin:'auto'}},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["e" /* Card */],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["f" /* CardContent */],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{item:true,xs:12,sm:12,md:12},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{variant:"headline",className:"centerCell"},props.clientName?props.clientName+"'s Quotes":"Manage Quotes"),props.assistantActive?__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{variant:"caption",className:"centerCell",gutterBottom:true},props.brokerName):null),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("div",{style:{borderBottom:"1px solid #cccccc69",margin:"5px auto",width:"25%",marginBottom:"20px"}})),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["I" /* Paper */],{style:{overflowX:"auto"}},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["a" /* AppBar */],{position:"static",color:"default",style:{marginBottom:"20px"}},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["W" /* Tabs */],{tab:tab,onChange:function onChange(e){return props.handleChangeTab(e);},indicatorColor:"primary",textColor:"secondary",scrollable:true,scrollButtons:"auto"},tabs.map(function(t,i){return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["P" /* Tab */],{label:t,style:i===tab?tabStyle:{},key:t});}))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{container:true},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{item:true,xs:12,sm:12,md:12,style:{textAlign:"center"}},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_CustomChip_CustomChip_jsx__["a" /* default */],{text:"Create Quote",icon:"add",clicked:props.chipClicked,style:{margin:"25px auto 15px auto"}})),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{item:true,xs:10,sm:10,md:10,style:{margin:"0 auto",display:"flex"}},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["X" /* TextField */],{id:"input-with-icon-textfield",fullWidth:true,style:{marginBottom:"30px"},placeholder:"Search Quote by "+(props.clientName?"":"Client")+" or Date Created(DD/MM/YYYY)",value:props.searchTerm,onChange:props.handleSearch,label:"Search",InputProps:{startAdornment:__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["z" /* InputAdornment */],{position:"start"},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_icons__["n" /* Search */],null))}}))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Q" /* Table */],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_EnhancedTableHead_EnhancedTableHead_jsx__["a" /* default */],{order:props.order,orderBy:props.orderBy,onRequestSort:function onRequestSort(event,property){return props.handleRequestSort(event,property);},rowCount:props.items?props.items.length:0,columnData:props.columnData}),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["R" /* TableBody */],null,props.tableBody)))))));};/* harmony default export */ __webpack_exports__["a"] = (QuoteHistoryContainer);

/***/ }),
/* 2449 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export reqResult */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(625);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_apollo__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_store__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Results_css__ = __webpack_require__(2452);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Results_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__Results_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_graphql_tag__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_graphql_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_graphql_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_icons__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_helpers_UserHelper__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_constants_js__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_queries_quotesByBroker__ = __webpack_require__(2453);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_reducers_NotificationReducer__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_queries_quotes_mutations_SaveQuote__ = __webpack_require__(2454);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_helpers_UriReader__ = __webpack_require__(41);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n\tquery getResults($guid: String!, $token: String!) {\n\t\tResults(guid: $guid, token: $token) {\n\t\t\tid\n\t\t\ttoken\n\t\t}\n\t}\n'],['\n\tquery getResults($guid: String!, $token: String!) {\n\t\tResults(guid: $guid, token: $token) {\n\t\t\tid\n\t\t\ttoken\n\t\t}\n\t}\n']),_templateObject2=_taggedTemplateLiteral(['\n\tquery result($path: String!, $content: String!) {\n\t\tResultPdf(path: $path, content: $content) {\n\t\t\tfilename\n\t\t}\n\t}\n'],['\n\tquery result($path: String!, $content: String!) {\n\t\tResultPdf(path: $path, content: $content) {\n\t\t\tfilename\n\t\t}\n\t}\n']);function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}/*eslint-disable*/var reqResult=__WEBPACK_IMPORTED_MODULE_6_graphql_tag___default()(_templateObject);var getResultPdf=__WEBPACK_IMPORTED_MODULE_6_graphql_tag___default()(_templateObject2);var Results=function(_React$Component){_inherits(Results,_React$Component);function Results(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Results);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Results.__proto__||Object.getPrototypeOf(Results)).call.apply(_ref,[this].concat(args))),_this),_this.state={resultsSet:false,popoverText:'',dialogTitle:'',dialogOpen:false,loadingPdf:false,downloadEl:null,anchorTop:0,anchorLeft:0,popoverOpen:false,guid:null},_this.saveQuote=function(quote){var input={taskGuid:quote.sq_taskguid,client_id:quote.fk_clientID,description:quote.desc,token:Object(__WEBPACK_IMPORTED_MODULE_9_helpers_UserHelper__["c" /* GetUserToken */])()};_this.props.mutate({variables:{input:input}}).then(function(resp){__WEBPACK_IMPORTED_MODULE_4_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_12_reducers_NotificationReducer__["e" /* successWarning */])({open:true,title:'Quote Saved!'}));}).catch(function(error){__WEBPACK_IMPORTED_MODULE_4_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_12_reducers_NotificationReducer__["d" /* showSnack */])({message:'An Error has occured.',color:'danger'}));});},_this.handlePopoverClose=function(){_this.setState({popoverOpen:false});},_this.handlePopoverOpen=function(event){_this.setState({anchorTop:event.clientY,anchorLeft:event.clientX,popoverOpen:true});},_this.onPdfGet=function(data){var url=__WEBPACK_IMPORTED_MODULE_10_constants_js__["a" /* QuotePdfUri */]+_this.state.guid+'.pdf';window.open(url,'_blank');},_this.getMultiplePdfs=function(pdfs){pdfs.forEach(function(p){window.open(p,'_blank');});},_this.handleDialogOpen=function(event,text,benefit,target){_this.setState({anchorTop:event.clientY,anchorLeft:event.clientX,dialogOpen:true,popoverText:text,dialogTitle:target+' - '+benefit});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Results,[{key:'componentDidMount',value:function componentDidMount(){var params=Object(__WEBPACK_IMPORTED_MODULE_14_helpers_UriReader__["a" /* ParseUriParams */])(this.props.location.search);var guid=params.guid;this.setState({guid:guid});}},{key:'targeter',value:function targeter(){var res=this.state.results;var col=[];if(this.state.results){res.targets.forEach(function(element){var logo='/assets/logo/'+element+'.png';col.push(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["S" /* TableCell */],{className:'centerCell',key:element},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:logo,alt:element+'logo',style:{maxWidth:'150px',maxHeight:'60px'}})));});}return col;}},{key:'fitter',value:function fitter(){var _this2=this;var col=[];var res=this.state.results;res.benefits.forEach(function(benelement){col.push(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["V" /* TableRow */],{key:benelement},_this2.benefitter(benelement)));});return col;}},{key:'benefitter',value:function benefitter(benelement){var _this3=this;var col=[];var res=this.state.results;var benefitName=benelement.name;var descriptiveName=benelement.descriptiveName;descriptiveName&&descriptiveName!==''?col.push(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["S" /* TableCell */],{style:{width:'275px'},key:benefitName},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["Z" /* Typography */],{gutterBottom:true},descriptiveName))):col.push(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["S" /* TableCell */],{style:{width:'275px'},key:benefitName},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["Z" /* Typography */],{gutterBottom:true},benefitName)));col.push(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["S" /* TableCell */],{className:'centerCell',key:res},'R',benelement.amount));res.targets.forEach(function(element){col.push(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["S" /* TableCell */],{className:'centerCell',key:element},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'description'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h2',{className:'D_Name'},benefitName),' ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'D_Value'},res.results[element][benefitName]?res.results[element][benefitName]['description']:'')),res.results[element][benefitName]&&parseInt(res.results[element][benefitName]['value'])>0?'R'+parseFloat(res.results[element][benefitName]['value']).toFixed(2):'NA',res.results[element][benefitName]&&parseInt(res.results[element][benefitName]['value'])>0&&res.results[element][benefitName]['description']?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_icons__["i" /* Info */],{style:{fontSize:'18px',position:'relative',top:'4px',left:'5px',cursor:'pointer',color:'white',backgroundColor:'black',borderRadius:'50%'},onClick:function onClick(e){var benefitX=res.benefits.filter(function(b){return b.name===benefitName;})[0];var descriptiveName=benefitX.descriptiveName&&benefitX.descriptiveName!==''?benefitX.descriptiveName:benefitX.name;_this3.handleDialogOpen(e,res.results[element][benefitName]['description'],descriptiveName,element);}}):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null)));});return col;}},{key:'makePolicyFee',value:function makePolicyFee(){var col=[];var res=this.state.results;col.push(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["S" /* TableCell */],{key:'MakePolicyFeeHeading'},'Policy Fee'));col.push(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["S" /* TableCell */],{key:'MakePolicyFee'}));res.targets.forEach(function(element){col.push(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["S" /* TableCell */],{className:'centerCell',key:element},element==='Liberty'?'R15':res.results[element]['Policy Fee']?res.results[element]['Momentum Interactive Fee']?'R'+(parseFloat(res.results[element]['Policy Fee']['value'])+parseFloat(res.results[element]['Momentum Interactive Fee']['value'])).toFixed(2):'R'+parseFloat(res.results[element]['Policy Fee']['value']).toFixed(2):'R0'));});return col;}},{key:'makeTotalPremium',value:function makeTotalPremium(){var col=[];var res=this.state.results;col.push(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["S" /* TableCell */],{key:'MakeTotalPremiumHeading'},'Total Premium'));col.push(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["S" /* TableCell */],{key:'MakeTotalPremium'}));res.targets.forEach(function(element){col.push(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["S" /* TableCell */],{className:'centerCell',key:element},res.results[element]['Premium']&&parseInt(res.results[element]['Premium']['value'])>0?'R'+parseFloat(res.results[element]['Premium']['value']).toFixed(2):'NA'));});return col;}},{key:'makeDownloadLinks',value:function makeDownloadLinks(){var _this4=this;var res=this.state.results;var col=[];/////////////////////////////////////////////////
//				client version code
/*
		<Divider />
									<ListItem>
										<Typography
											variant="subheading"
											style={{
												marginLeft: '10px',
												marginRight: '10px'
											}}
										>
											Client Version
										</Typography>
									</ListItem>
									*/col.push(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["S" /* TableCell */],{key:res,style:{paddingRight:'0px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_apollo__["ApolloConsumer"],null,function(client){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,_this4.state.dog&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:_this4.state.dog.displayImage}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["d" /* Button */],{id:'printButton',variant:'outlined',className:'outlinedButton',style:{color:'#55526f',borderRadius:'50px',marginTop:'10px',marginBottom:'10px'},onClick:function onClick(e){return!_this4.state.loadingPdf?_this4.handlePopoverOpen(e,'downloadEl'):{};}},_this4.state.loadingPdf?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["j" /* CircularProgress */],{color:'secondary',size:20}):'Print version'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["J" /* Popover */],{open:_this4.state.popoverOpen,onClose:function onClose(){return _this4.handlePopoverClose();},anchorReference:'anchorPosition',anchorPosition:{left:_this4.state.anchorLeft,top:_this4.state.anchorTop}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["C" /* List */],{component:'nav'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["D" /* ListItem */],{button:true,onClick:_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var _ref3,data,errors;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_this4.setState({loadingPdf:true});_context.next=3;return client.query({query:getResultPdf,variables:{path:_this4.state.guid,content:document.getElementById('resultTable').innerHTML.toString().replace(/"/g,"'")}});case 3:_ref3=_context.sent;data=_ref3.data;errors=_ref3.errors;if(errors){__WEBPACK_IMPORTED_MODULE_4_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_12_reducers_NotificationReducer__["d" /* showSnack */])({message:'Error generating the PDF : '+errors,color:'danger'}));}else{_this4.onPdfGet(data);}_this4.setState({loadingPdf:false});_this4.handlePopoverClose();case 9:case'end':return _context.stop();}}},_callee,_this4);}))},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["Z" /* Typography */],{variant:'subheading',style:{marginLeft:'10px',marginRight:'10px'}},'Print Version')))));})));col.push(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["S" /* TableCell */],{key:'makeDownloadLinksBlank',style:{padding:'0px'}},' '));res.targets.forEach(function(element){if(res.results[element].pdf_list){var list=res.results[element].pdf_list.split(';');list.forEach(function(l,i){var leviosa=l;leviosa=leviosa.replace(__WEBPACK_IMPORTED_MODULE_10_constants_js__["b" /* ResultsPdfPhysicalPath */],__WEBPACK_IMPORTED_MODULE_10_constants_js__["c" /* ResultsPdfUri */]);list[i]=leviosa;});col.push(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["S" /* TableCell */],{className:'centerCell',key:element,style:{padding:'0px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["d" /* Button */],{variant:'outlined',className:'outlinedButton',style:{color:'#55526f',borderRadius:'50px',marginTop:'10px',marginBottom:'10px'},onClick:function onClick(){return _this4.getMultiplePdfs(list);}},'View PDFs')));}else{var leviosa=res.results[element].pdf;leviosa=leviosa.replace(__WEBPACK_IMPORTED_MODULE_10_constants_js__["b" /* ResultsPdfPhysicalPath */],__WEBPACK_IMPORTED_MODULE_10_constants_js__["c" /* ResultsPdfUri */]);col.push(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["S" /* TableCell */],{className:'centerCell',key:element,style:{padding:'0px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{href:leviosa,target:'_blank'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["d" /* Button */],{variant:'outlined',className:'outlinedButton',style:{color:'#55526f',borderRadius:'50px',marginTop:'10px',marginBottom:'10px'}},'View PDF'))));}});return col;}},{key:'makePremiumPayable',value:function makePremiumPayable(){var col=[];var res=this.state.results;col.push(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["S" /* TableCell */],{key:'PremiumPayableHeading'},'Premium Payable'));col.push(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["S" /* TableCell */],{key:'PremiumPayable'}));res.targets.forEach(function(element){col.push(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["S" /* TableCell */],{className:'centerCell',key:element},res.results[element]['Premium']&&parseInt(res.results[element]['Premium']['value'])>0?res.results[element]['Discount']?'R'+parseFloat(parseFloat(res.results[element]['Premium']['value'])-parseFloat(res.results[element]['Discount']['value'])).toFixed(2):'R'+parseFloat(res.results[element]['Premium']['value']).toFixed(2):'NA'));});return col;}},{key:'makeTableHeader',value:function makeTableHeader(){var res=this.state.results;var row=[];var col=[];var temp={};var i=0;if(this.state.results){col.push(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["T" /* TableHead */],{key:this.state.results},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["V" /* TableRow */],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["S" /* TableCell */],{style:{fontSize:'1.4em',fontWeight:'600'}},'Benefit '),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["S" /* TableCell */],{style:{fontSize:'1.4em',fontWeight:'600'},className:'centerCell'},'Amount '),this.targeter())));}return col;}},{key:'download',value:function download(url){document.getElementById('my_iframe').src=url;}},{key:'makeTable',value:function makeTable(){var res=this.state.results;var row=[];var col=[];var temp={};var i=0;if(this.state.results){col.push(this.fitter());var targetEmptyCells=[];var targets=this.state.results.targets;var _iteratorNormalCompletion=true;var _didIteratorError=false;var _iteratorError=undefined;try{for(var _iterator=targets[Symbol.iterator](),_step;!(_iteratorNormalCompletion=(_step=_iterator.next()).done);_iteratorNormalCompletion=true){var t=_step.value;targetEmptyCells.push(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["S" /* TableCell */],{key:t}));}/*col.push(
				<TableRow key={Math.random()}>
					<TableCell />
					<TableCell />
					{targetEmptyCells}
				</TableRow>
			);*/}catch(err){_didIteratorError=true;_iteratorError=err;}finally{try{if(!_iteratorNormalCompletion&&_iterator.return){_iterator.return();}}finally{if(_didIteratorError){throw _iteratorError;}}}col.push(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["V" /* TableRow */],{key:Math.random()},this.makePolicyFee()));col.push(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["V" /* TableRow */],{style:{borderTop:'double'},key:Math.random()},this.makeTotalPremium()));col.push(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["V" /* TableRow */],{key:Math.random()},this.makePremiumPayable()));col.push(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["V" /* TableRow */],{style:{borderTop:'double'},key:Math.random()},this.makeDownloadLinks()));}return col;}},{key:'makeProductInfo',value:function makeProductInfo(){var _this5=this;var div=[];if(this.state.results){this.state.results.benefits.forEach(function(benefit){var benInfo=[];_this5.state.results.targets.forEach(function(target){var res=_this5.state.results.results[target];var targetBen=res[benefit.name];if(targetBen){benInfo.push(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{key:target},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('strong',null,target,':'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{style:{whiteSpace:'pre-line'}},targetBen.description)));}});var descriptiveName=benefit.descriptiveName&&benefit.descriptiveName!==''?benefit.descriptiveName:benefit.name;div.push(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{key:descriptiveName},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h4',null,descriptiveName,' :'),benInfo));});}return div;}},{key:'handleDialogClose',value:function handleDialogClose(){this.setState({dialogOpen:false,popoverText:''});}},{key:'handleEdit',value:function handleEdit(quote){this.props.history.push({pathname:'/app/quote/',search:'clientId='+quote.fk_clientID+'&guid='+this.state.guid});}},{key:'render',value:function render(){var _this6=this;var params=Object(__WEBPACK_IMPORTED_MODULE_14_helpers_UriReader__["a" /* ParseUriParams */])(this.props.location.search);var guid=params.guid;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_apollo__["Query"],{query:reqResult,variables:{guid:guid,token:Object(__WEBPACK_IMPORTED_MODULE_9_helpers_UserHelper__["c" /* GetUserToken */])()},fetchPolicy:'network-only'},function(_ref4){var loading=_ref4.loading,error=_ref4.error,data=_ref4.data;if(loading)return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["B" /* LinearProgress */],null));if(error&&error.message&&error.message==='GraphQL error: invalid token'){Object(__WEBPACK_IMPORTED_MODULE_9_helpers_UserHelper__["d" /* Logout */])();return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["a" /* Redirect */],{to:'/app/portal/login'});}if(error)return'Error! '+error.message;if(!_this6.state.resultsSet){var results=JSON.parse(data.Results[0].token);var targetsArr=[].concat(_toConsumableArray(results.targets));targetsArr.sort();results.targets=targetsArr;var unsortedResults=Object.assign({},results.results);var sortedResults=Object.keys(unsortedResults).sort().reduce(function(acc,key){return Object.assign({},acc,_defineProperty({},key,unsortedResults[key]));},{});results.results=sortedResults;_this6.setState({results:results,resultsSet:true});}if(!_this6.state.results){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["B" /* LinearProgress */],null));}return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{id:'resultTable'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["e" /* Card */],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["f" /* CardContent */],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["v" /* Grid */],{container:true,justify:'space-between',style:{marginBottom:'15px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["v" /* Grid */],{item:true,xs:12,sm:12,md:9,lg:9},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["Z" /* Typography */],{variant:'headline'},'Results'),_this6.state.assistantActive?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["Z" /* Typography */],{variant:'caption',gutterBottom:true},_this6.getBrokerName()):null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["v" /* Grid */],{item:true,xs:12,sm:12,md:1,lg:1},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_apollo__["ApolloConsumer"],null,function(client){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["d" /* Button */],{variant:'outlined',className:'outlinedButton',color:'primary',onClick:_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(){var _ref6,data;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return client.query({query:__WEBPACK_IMPORTED_MODULE_11_queries_quotesByBroker__["a" /* QuoteByGuid */],variables:{guid:_this6.state.guid,token:Object(__WEBPACK_IMPORTED_MODULE_9_helpers_UserHelper__["c" /* GetUserToken */])()}});case 2:_ref6=_context2.sent;data=_ref6.data;_this6.saveQuote(data.QuoteByGuid);case 5:case'end':return _context2.stop();}}},_callee2,_this6);})),id:'editQuoteButton'},'Save');})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["v" /* Grid */],{item:true,xs:12,sm:12,md:1,lg:1},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_apollo__["ApolloConsumer"],null,function(client){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["d" /* Button */],{variant:'outlined',className:'outlinedButton',color:'primary',onClick:_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(){var _ref8,data;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.next=2;return client.query({query:__WEBPACK_IMPORTED_MODULE_11_queries_quotesByBroker__["a" /* QuoteByGuid */],variables:{guid:_this6.state.guid,token:Object(__WEBPACK_IMPORTED_MODULE_9_helpers_UserHelper__["c" /* GetUserToken */])()}});case 2:_ref8=_context3.sent;data=_ref8.data;_this6.handleEdit(data.QuoteByGuid);case 5:case'end':return _context3.stop();}}},_callee3,_this6);})),id:'editQuoteButton'},'Edit Quote');}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["I" /* Paper */],{style:{overflowX:'auto'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["Q" /* Table */],{className:'resultsTable'},_this6.makeTableHeader(),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["R" /* TableBody */],null,_this6.makeTable())),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["k" /* Dialog */],{open:_this6.state.dialogOpen,onClose:function onClose(){return _this6.handleDialogClose();},'aria-labelledby':'form-dialog-title'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["o" /* DialogTitle */],{id:'form-dialog-title'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["Z" /* Typography */],{variant:'title',gutterBottom:true},_this6.state.dialogTitle)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["m" /* DialogContent */],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["Z" /* Typography */],{variant:'body1',gutterBottom:true,style:{whiteSpace:'pre-line'}},_this6.state.popoverText)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["l" /* DialogActions */],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["d" /* Button */],{onClick:function onClick(){return _this6.handleDialogClose();},color:'primary'},'Close')))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{id:'productInfo',style:{display:'none'}},_this6.makeProductInfo()),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{id:'meta',style:{float:'left',width:'fit-content',padding:'24px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["Z" /* Typography */],null,'S/A = Standalone / Accelerator',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),'T/NT = Tapering / Non-tapering')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{float:'right',width:'fit-content',padding:'24px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["Z" /* Typography */],{variant:'caption'},'NB : Please allow popups for this page.'))));});}}]);return Results;}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);Results=Object(__WEBPACK_IMPORTED_MODULE_3_react_apollo__["graphql"])(__WEBPACK_IMPORTED_MODULE_13_queries_quotes_mutations_SaveQuote__["a" /* SaveQuote */])(Results);/* harmony default export */ __webpack_exports__["a"] = (Results);

/***/ }),
/* 2450 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

// This method of obtaining a reference to the global object needs to be
// kept identical to the way it is obtained in runtime.js
var g = (function() { return this })() || Function("return this")();

// Use `getOwnPropertyNames` because not all browsers support calling
// `hasOwnProperty` on the global `self` object in a worker. See #183.
var hadRuntime = g.regeneratorRuntime &&
  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;

// Save the old regeneratorRuntime in case it needs to be restored later.
var oldRuntime = hadRuntime && g.regeneratorRuntime;

// Force reevalutation of runtime.js.
g.regeneratorRuntime = undefined;

module.exports = __webpack_require__(2451);

if (hadRuntime) {
  // Restore the original runtime.
  g.regeneratorRuntime = oldRuntime;
} else {
  // Remove the global property added by runtime.js.
  try {
    delete g.regeneratorRuntime;
  } catch(e) {
    g.regeneratorRuntime = undefined;
  }
}


/***/ }),
/* 2451 */
/***/ (function(module, exports) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // In sloppy mode, unbound `this` refers to the global object, fallback to
  // Function constructor if we're in global strict mode. That is sadly a form
  // of indirect eval which violates Content Security Policy.
  (function() { return this })() || Function("return this")()
);


/***/ }),
/* 2452 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2453 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return QuoteByGuid; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_graphql_tag__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_graphql_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_graphql_tag__);
var _templateObject=_taggedTemplateLiteral(["\n  query quoteByGuid($guid: String!,$token:String!) {\n    QuoteByGuid(guid: $guid,token:$token) {\n      id,\n      description,\n      sq_taskguid,\n      fk_clientID,\n      fk_userId,\n      benefits,\n      date_created,\n      date_created,\n      fullName,\n      values,\n      desc\n    }\n  }\n"],["\n  query quoteByGuid($guid: String!,$token:String!) {\n    QuoteByGuid(guid: $guid,token:$token) {\n      id,\n      description,\n      sq_taskguid,\n      fk_clientID,\n      fk_userId,\n      benefits,\n      date_created,\n      date_created,\n      fullName,\n      values,\n      desc\n    }\n  }\n"]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var QuoteByGuid=__WEBPACK_IMPORTED_MODULE_0_graphql_tag___default()(_templateObject);

/***/ }),
/* 2454 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SaveQuote; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_graphql_tag__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_graphql_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_graphql_tag__);
var _templateObject=_taggedTemplateLiteral(["\n  mutation saveQuote($input: SaveQuoteInput!) {\n    SaveQuote(input: $input) {\n      clientMutationId\n    }\n  }\n  "],["\n  mutation saveQuote($input: SaveQuoteInput!) {\n    SaveQuote(input: $input) {\n      clientMutationId\n    }\n  }\n  "]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var SaveQuote=__WEBPACK_IMPORTED_MODULE_0_graphql_tag___default()(_templateObject);

/***/ }),
/* 2455 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_core__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_EnhancedTableHead_EnhancedTableHead_jsx__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_Snackbar_Snackbar_jsx__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_helpers_UserHelper__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_helpers_Search__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_apollo__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_router__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_BaseTablePageContent_jsx__ = __webpack_require__(2456);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_queries_Assistant_Assignment_BrokerAssistants__ = __webpack_require__(2457);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_queries_Assistant_Assignment_Mutations__ = __webpack_require__(2458);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}//Q&Ms
var columnData=[{id:"edit",numeric:false,disablePadding:true,label:"",noSort:true,width:"30px"},{id:"ab_Id",numeric:false,disablePadding:true,label:"Status",noSort:true},{id:"su_name",numeric:false,disablePadding:true,label:"Name"},{id:"su_email",numeric:false,disablePadding:true,label:"Email"}];var AssistantAssignment=function(_Component){_inherits(AssistantAssignment,_Component);function AssistantAssignment(){var _ref;var _temp,_this,_ret;_classCallCheck(this,AssistantAssignment);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=AssistantAssignment.__proto__||Object.getPrototypeOf(AssistantAssignment)).call.apply(_ref,[this].concat(args))),_this),_this.state={page:0,rowsPerPage:10,order:"desc",orderBy:"Name",searchTerm:"",loadingSearch:false,data:[],searchData:[],openMenus:[],anchorTop:0,anchorLeft:0,popoverOpen:false,br:false,snackBarColor:"",snackBarText:"",statuses:[0,1,2,3]},_this.handleSearch=function(event){_this.setState({searchTerm:event.target.value});var values=event.target.value.split(" ");var brokers=_this.state.data;var inc=["su_name","su_surname","su_email"];var filteredData=Object(__WEBPACK_IMPORTED_MODULE_4_helpers_Search__["a" /* SearchDataSet */])(brokers,values,inc);_this.setState({searchData:filteredData});},_this.handleChangePage=function(event,page){_this.setState({page:page});},_this.handleChangeRowsPerPage=function(event){_this.setState({rowsPerPage:event.target.value});},_this.handleRequestSort=function(event,property){var orderBy=property;var order="desc";if(_this.state.orderBy===property&&_this.state.order==="desc"){order="asc";}_this.setState({order:order,orderBy:orderBy});},_this.handleClaim=function(b){},_this.handleRemove=function(){},_this.handleClick=function(event,id){_this.setState({anchorTop:event.clientY,anchorLeft:event.clientX});var openMenus=_this.state.openMenus.slice();openMenus.filter(function(x){return x.id===id;})[0].open=true;_this.setState({openMenus:openMenus,popoverOpen:true});},_this.handleClose=function(id){var openMenus=_this.state.openMenus.slice();openMenus.filter(function(x){return x.id===id;})[0].open=false;_this.setState({openMenus:openMenus,popoverOpen:false});},_this.showNotification=function(place){if(!_this.state[place]){var x=[];x[place]=true;_this.setState(x);setTimeout(function(){x[place]=false;this.setState(x);}.bind(_this),3000);}},_this.toggleFilterItem=function(refetch,item){if(item!=="all"){var statuses=[].concat(_toConsumableArray(_this.state.statuses));if(statuses.includes(item)){statuses=statuses.filter(function(s){return s!==item;});}else{statuses.push(item);}_this.setState({statuses:statuses});refetch();}},_this.acceptRequest=function(refetch,assistantId){var input={assistantId:assistantId,brokerId:Object(__WEBPACK_IMPORTED_MODULE_3_helpers_UserHelper__["a" /* GetUserId */])(),token:Object(__WEBPACK_IMPORTED_MODULE_3_helpers_UserHelper__["c" /* GetUserToken */])()};_this.props.AA_AcceptRequest({variables:{input:input}}).then(function(resp){refetch();_this.showNotification("br");_this.setState({snackBarColor:"success",snackBarText:"Request Accepted"});}).catch(function(error){console.log("err",error);});},_this.declineRequest=function(refetch,assistantId,messageText){var input={assistantId:assistantId,brokerId:Object(__WEBPACK_IMPORTED_MODULE_3_helpers_UserHelper__["a" /* GetUserId */])(),token:Object(__WEBPACK_IMPORTED_MODULE_3_helpers_UserHelper__["c" /* GetUserToken */])()};_this.props.AA_DeclineRequest({variables:{input:input}}).then(function(resp){refetch();_this.showNotification("br");_this.setState({snackBarColor:"danger",snackBarText:messageText});}).catch(function(error){console.log("err",error);});},_this.sendRequest=function(refetch,assistantId){var input={assistantId:assistantId,brokerId:Object(__WEBPACK_IMPORTED_MODULE_3_helpers_UserHelper__["a" /* GetUserId */])(),token:Object(__WEBPACK_IMPORTED_MODULE_3_helpers_UserHelper__["c" /* GetUserToken */])()};_this.props.AA_SendRequest({variables:{input:input}}).then(function(resp){refetch();_this.showNotification("br");_this.setState({snackBarColor:"success",snackBarText:"Request Sent"});}).catch(function(error){console.log("err",error);});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(AssistantAssignment,[{key:"getSorting",value:function getSorting(order,orderBy){return order==="desc"?function(a,b){return b[orderBy]<a[orderBy]?-1:1;}:function(a,b){return a[orderBy]<b[orderBy]?-1:1;};}},{key:"render",value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_apollo__["Query"],{query:__WEBPACK_IMPORTED_MODULE_9_queries_Assistant_Assignment_BrokerAssistants__["a" /* BrokerAssistants */],variables:{userId:Object(__WEBPACK_IMPORTED_MODULE_3_helpers_UserHelper__["a" /* GetUserId */])(),token:Object(__WEBPACK_IMPORTED_MODULE_3_helpers_UserHelper__["c" /* GetUserToken */])(),statuses:this.state.statuses},fetchPolicy:"network-only"},function(_ref2){var loading=_ref2.loading,error=_ref2.error,data=_ref2.data,refetch=_ref2.refetch;if(loading)return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_BaseTablePageContent_jsx__["a" /* default */],{handleSearch:_this2.handleSearch,title:"Assistant Assignment",toggleFilterItem:function toggleFilterItem(item){return _this2.toggleFilterItem(refetch,item);},filters:_this2.state.statuses},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["B" /* LinearProgress */],null)));if(error&&error.message&&error.message==="GraphQL error: invalid token"){Object(__WEBPACK_IMPORTED_MODULE_3_helpers_UserHelper__["d" /* Logout */])();return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_router__["a" /* Redirect */],{to:"/app/portal/login"});}if(_this2.state.data.length!==data.BrokerAssistants.length){_this2.setState({data:data.BrokerAssistants});}var qData=[];if(_this2.state.searchData.length>0&&_this2.state.searchTerm!==""){qData=_this2.state.searchData.slice();qData.sort(_this2.getSorting(_this2.state.order,_this2.state.orderBy));}else{qData=data.BrokerAssistants.slice();qData.sort(_this2.getSorting(_this2.state.order,_this2.state.orderBy));}if(qData&&_this2.state.openMenus.length!==qData.length){var openMenus=[];qData.map(function(b){openMenus.push({open:false,id:b.su_ID});return b;});_this2.setState({openMenus:openMenus});}return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_BaseTablePageContent_jsx__["a" /* default */],{handleSearch:_this2.handleSearch,title:"Assistant Assignment",toggleFilterItem:function toggleFilterItem(item){return _this2.toggleFilterItem(refetch,item);},filters:_this2.state.statuses},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Q" /* Table */],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_EnhancedTableHead_EnhancedTableHead_jsx__["a" /* default */],{order:_this2.state.order,orderBy:_this2.state.orderBy,onRequestSort:_this2.handleRequestSort,rowCount:_this2.state.searchData.length<1&&_this2.state.searchTerm!==""?_this2.state.searchData.length:qData.length,columnData:columnData}),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["R" /* TableBody */],null,_this2.state.searchData.length<1&&_this2.state.searchTerm!==""?__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("h3",null,"No results found"))):qData.slice(_this2.state.page*_this2.state.rowsPerPage,_this2.state.page*_this2.state.rowsPerPage+_this2.state.rowsPerPage).map(function(assistant){console.log("assistant",assistant);return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],{className:"sqDataTable",key:assistant.su_ID,onClick:function onClick(e){return _this2.state.popoverOpen===false?_this2.handleClick(e,assistant.su_ID):null;}},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{style:{padding:"0px",borderRight:"1px solid #e0e0e0",backgroundColor:"white"}},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["x" /* IconButton */],{onClick:function onClick(e){return _this2.state.popoverOpen===false?_this2.handleClick(e,assistant.su_ID):null;}},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["w" /* Icon */],null,"more_vert"))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{style:{borderTop:"1px solid rgba(224, 224, 224, 1)",width:"160px",paddingRight:"0px"}},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("div",{style:{display:"flex"}},assistant.ab_Id?assistant.status===2?__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["w" /* Icon */],{style:{marginRight:"10px",color:"#00ce00"}},"done_all"),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{variant:"caption",style:{wordWrap:"break-word",position:"relative",top:"3px"}},"Assigned")):assistant.status===1?__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["w" /* Icon */],{style:{marginRight:"10px",color:"#ffae57"}},"priority_high"),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{variant:"caption",style:{wordWrap:"break-word",position:"relative",top:"3px"}},"Request Sent")):assistant.status===0?__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["w" /* Icon */],{style:{marginRight:"10px",color:"#ffae57"}},"priority_high"),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{variant:"caption",style:{wordWrap:"break-word",position:"relative",top:"3px"}},"Request Recieved")):null:__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["w" /* Icon */],{style:{marginRight:"10px",color:"#84848494"}},"help_outline"),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{variant:"caption",style:{wordWrap:"break-word",position:"relative",top:"3px"}},"Unassigned")))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,assistant.su_name," ",assistant.su_surname),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,assistant.su_email),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["J" /* Popover */],{open:_this2.state.openMenus.length>0&&_this2.state.openMenus.filter(function(m){return m.id===assistant.su_ID;}).length>0?_this2.state.openMenus.filter(function(m){return m.id===assistant.su_ID;})[0].open:false,anchorReference:"anchorPosition",anchorPosition:{left:_this2.state.anchorLeft,top:_this2.state.anchorTop},onClose:function onClose(){return _this2.handleClose(assistant.su_ID);}},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["C" /* List */],{component:"nav"},!assistant.ab_Id?__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["D" /* ListItem */],{button:true,onClick:function onClick(){_this2.handleClose(assistant.su_ID);_this2.sendRequest(refetch,assistant.su_ID);}},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["E" /* ListItemText */],{primary:"Request Assignment"})):assistant.status===1?__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["D" /* ListItem */],{button:true,onClick:function onClick(){_this2.handleClose(assistant.su_ID);_this2.declineRequest(refetch,assistant.su_ID,"Request Canceled");}},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["E" /* ListItemText */],{primary:"Cancel Request"})):assistant.status===0?__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["D" /* ListItem */],{button:true,onClick:function onClick(){_this2.handleClose(assistant.su_ID);_this2.acceptRequest(refetch,assistant.su_ID);}},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["E" /* ListItemText */],{primary:"Accept Request"})),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["D" /* ListItem */],{button:true,onClick:function onClick(){_this2.handleClose(assistant.su_ID);_this2.declineRequest(refetch,assistant.su_ID,"Request Declined");}},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["E" /* ListItemText */],{primary:"Decline Request"}))):assistant.status===2?__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["D" /* ListItem */],{button:true,onClick:function onClick(){_this2.handleClose(assistant.su_ID);_this2.declineRequest(refetch,assistant.su_ID,"Assistant Unassigned");}},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["E" /* ListItemText */],{primary:"Unassign"})):null)));}),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["U" /* TablePagination */],{count:_this2.state.searchData.length<1&&_this2.state.searchTerm!==""?_this2.state.searchData.length:qData.length,rowsPerPage:_this2.state.rowsPerPage,page:_this2.state.page,backIconButtonProps:{"aria-label":"Previous Page"},nextIconButtonProps:{"aria-label":"Next Page"},onChangePage:_this2.handleChangePage,onChangeRowsPerPage:_this2.handleChangeRowsPerPage})))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_Snackbar_Snackbar_jsx__["a" /* default */],{anchorOrigin:{vertical:"bottom",horizontal:"right"},place:"br",color:_this2.state.snackBarColor,message:_this2.state.snackBarText,open:_this2.state.br,closeNotification:function closeNotification(){return _this2.setState({br:false});},close:true}));});}}]);return AssistantAssignment;}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]);AssistantAssignment=Object(__WEBPACK_IMPORTED_MODULE_6_react_apollo__["compose"])(Object(__WEBPACK_IMPORTED_MODULE_6_react_apollo__["graphql"])(__WEBPACK_IMPORTED_MODULE_10_queries_Assistant_Assignment_Mutations__["a" /* AA_AcceptRequest */],{name:"AA_AcceptRequest"}),Object(__WEBPACK_IMPORTED_MODULE_6_react_apollo__["graphql"])(__WEBPACK_IMPORTED_MODULE_10_queries_Assistant_Assignment_Mutations__["b" /* AA_DeclineRequest */],{name:"AA_DeclineRequest"}),Object(__WEBPACK_IMPORTED_MODULE_6_react_apollo__["graphql"])(__WEBPACK_IMPORTED_MODULE_10_queries_Assistant_Assignment_Mutations__["c" /* AA_SendRequest */],{name:"AA_SendRequest"}))(AssistantAssignment);/* harmony default export */ __webpack_exports__["a"] = (AssistantAssignment);

/***/ }),
/* 2456 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_core__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_icons__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Grid_GridItem_jsx__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var BaseTablePageContent=function(_React$Component){_inherits(BaseTablePageContent,_React$Component);function BaseTablePageContent(){var _ref;var _temp,_this,_ret;_classCallCheck(this,BaseTablePageContent);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=BaseTablePageContent.__proto__||Object.getPrototypeOf(BaseTablePageContent)).call.apply(_ref,[this].concat(args))),_this),_this.state={filterEl:null},_this.handlePopoverClose=function(name){_this.setState(_defineProperty({},name,null));},_this.handlePopoverOpen=function(event,name){_this.setState(_defineProperty({},name,event.currentTarget));},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(BaseTablePageContent,[{key:"render",value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{container:true},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:10,style:{flexBasis:"100%",maxWidth:"100%",margin:"auto"}},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["e" /* Card */],null,__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["f" /* CardContent */],null,__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{container:true,justify:"space-between",style:{marginBottom:"15px"}},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{item:true,xs:12,sm:12,md:10,lg:10},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{variant:"headline",gutterBottom:true},this.props.title)),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{item:true,xs:12,sm:12,md:2,lg:2},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["d" /* Button */],{fullWidth:true,variant:"outlined",className:"outlinedButton",color:"primary",onClick:function onClick(e){return _this2.handlePopoverOpen(e,"filterEl");}},"Filter",__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["w" /* Icon */],null,"arrow_drop_down")),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["J" /* Popover */],{open:Boolean(this.state.filterEl),anchorEl:this.state.filterEl,onClose:function onClose(){return _this2.handlePopoverClose("filterEl");},anchorOrigin:{vertical:"bottom",horizontal:"center"},transformOrigin:{vertical:"top",horizontal:"center"}},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["C" /* List */],{component:"nav"},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["D" /* ListItem */],{button:true,onClick:function onClick(e){return _this2.props.toggleFilterItem(2);}},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["h" /* Checkbox */],{checked:this.props.filters.includes(2),onChange:function onChange(e){return _this2.props.toggleFilterItem(2);}}),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{variant:"subheading",style:{marginLeft:"10px",marginRight:"10px"}},"Assigned")),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["p" /* Divider */],null),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["D" /* ListItem */],{button:true,onClick:function onClick(e){return _this2.props.toggleFilterItem(3);}},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["h" /* Checkbox */],{checked:this.props.filters.includes(3),onChange:function onChange(e){return _this2.props.toggleFilterItem(3);}}),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{variant:"subheading",style:{marginLeft:"10px",marginRight:"10px"}},"Unassigned")),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["p" /* Divider */],null),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["D" /* ListItem */],{button:true,onClick:function onClick(e){return _this2.props.toggleFilterItem(0);}},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["h" /* Checkbox */],{checked:this.props.filters.includes(0),onChange:function onChange(e){return _this2.props.toggleFilterItem(0);}}),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{variant:"subheading",style:{marginLeft:"10px",marginRight:"10px"}},"Request Recieved")),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["p" /* Divider */],null),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["D" /* ListItem */],{button:true,onClick:function onClick(e){return _this2.props.toggleFilterItem(1);}},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["h" /* Checkbox */],{checked:this.props.filters.includes(1),onChange:function onChange(e){return _this2.props.toggleFilterItem(1);}}),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{variant:"subheading",style:{marginLeft:"10px",marginRight:"10px"}},"Request Sent")))))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["X" /* TextField */],{id:"input-with-icon-textfield",fullWidth:true,style:{marginBottom:"3vh"},placeholder:"Search by Name, Surname, or Email",onChange:this.props.handleSearch,label:"Search",InputProps:{startAdornment:__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["z" /* InputAdornment */],{position:"start"},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_icons__["n" /* Search */],null))}}),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["I" /* Paper */],{style:{overflowX:"auto"}},this.props.children)))));}}]);return BaseTablePageContent;}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (BaseTablePageContent);

/***/ }),
/* 2457 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BrokerAssistants; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_graphql_tag__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_graphql_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_graphql_tag__);
var _templateObject=_taggedTemplateLiteral(["\n  query brokerAssistants($userId: String!,$token:String!,$statuses: [Int]!) {\n    BrokerAssistants(userId:$userId,token:$token,statuses: $statuses){\n      su_ID,\n      su_name,\n      su_surname,\n      su_email,\n      ab_Id,\n      status\n    }\n  }\n"],["\n  query brokerAssistants($userId: String!,$token:String!,$statuses: [Int]!) {\n    BrokerAssistants(userId:$userId,token:$token,statuses: $statuses){\n      su_ID,\n      su_name,\n      su_surname,\n      su_email,\n      ab_Id,\n      status\n    }\n  }\n"]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var BrokerAssistants=__WEBPACK_IMPORTED_MODULE_0_graphql_tag___default()(_templateObject);

/***/ }),
/* 2458 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AA_AcceptRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return AA_DeclineRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return AA_SendRequest; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_graphql_tag__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_graphql_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_graphql_tag__);
var _templateObject=_taggedTemplateLiteral(["\n  mutation aa_AcceptRequest($input: AA_AcceptRequestInput!) {\n    AA_AcceptRequest(input: $input) {\n      clientMutationId\n    }\n  }\n"],["\n  mutation aa_AcceptRequest($input: AA_AcceptRequestInput!) {\n    AA_AcceptRequest(input: $input) {\n      clientMutationId\n    }\n  }\n"]),_templateObject2=_taggedTemplateLiteral(["\n  mutation aa_DeclineRequest($input: AA_DeclineRequestInput!) {\n    AA_DeclineRequest(input: $input) {\n      clientMutationId\n    }\n  }\n"],["\n  mutation aa_DeclineRequest($input: AA_DeclineRequestInput!) {\n    AA_DeclineRequest(input: $input) {\n      clientMutationId\n    }\n  }\n"]),_templateObject3=_taggedTemplateLiteral(["\n  mutation aa_SendRequest($input: AA_SendRequestInput!) {\n    AA_SendRequest(input: $input) {\n      clientMutationId\n    }\n  }\n"],["\n  mutation aa_SendRequest($input: AA_SendRequestInput!) {\n    AA_SendRequest(input: $input) {\n      clientMutationId\n    }\n  }\n"]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var AA_AcceptRequest=__WEBPACK_IMPORTED_MODULE_0_graphql_tag___default()(_templateObject);var AA_DeclineRequest=__WEBPACK_IMPORTED_MODULE_0_graphql_tag___default()(_templateObject2);var AA_SendRequest=__WEBPACK_IMPORTED_MODULE_0_graphql_tag___default()(_templateObject3);

/***/ }),
/* 2459 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_store__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_apollo__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_styles_withStyles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_styles_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_styles_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_Typography__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_Typography___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Typography__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_icons_PermIdentity__ = __webpack_require__(578);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_icons_PermIdentity___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_icons_PermIdentity__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_Grid_GridItem_jsx__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_Clearfix_Clearfix_jsx__ = __webpack_require__(2460);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_Card_Card_jsx__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_Card_CardBody_jsx__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_Card_CardHeader_jsx__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_components_Card_CardIcon_jsx__ = __webpack_require__(247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_components_Card_CardAvatar_jsx__ = __webpack_require__(382);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__material_ui_core__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_assets_jss_material_dashboard_pro_react_views_userProfileStyles_jsx__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_assets_img_faces_avatar1_jpg__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_assets_img_faces_avatar1_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_assets_img_faces_avatar1_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_queries_BrokerageProfile__ = __webpack_require__(2461);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_queries_updatePassword__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_graphql_tag__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_graphql_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_graphql_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_react_dropzone__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_apollo_client__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_apollo_cache_inmemory__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_apollo_upload_client__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_reducers_LoginReducer__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_constants_js__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_helpers_UserHelper__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_reducers_NotificationReducer__ = __webpack_require__(30);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(["\n  mutation($file: Upload!, $id: String!) {\n    uploadFileWithId(file: $file, id: $id)\n  }\n"],["\n  mutation($file: Upload!, $id: String!) {\n    uploadFileWithId(file: $file, id: $id)\n  }\n"]);function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}/*eslint-disable*///import "./profilePage.css";
// @material-ui/core components
// @material-ui/icons
// core components
var CHANGEAVATAR="sure-quote/Login/CHANGEAVATAR";var client=new __WEBPACK_IMPORTED_MODULE_23_apollo_client__["ApolloClient"]({link:Object(__WEBPACK_IMPORTED_MODULE_25_apollo_upload_client__["a" /* createUploadLink */])({uri:__WEBPACK_IMPORTED_MODULE_27_constants_js__["d" /* fileUploadServerPath */]}),cache:new __WEBPACK_IMPORTED_MODULE_24_apollo_cache_inmemory__["a" /* InMemoryCache */]()});var uploadFileMutation=__WEBPACK_IMPORTED_MODULE_21_graphql_tag___default()(_templateObject);var BrokerageAdminProfile=function(_Component){_inherits(BrokerageAdminProfile,_Component);function BrokerageAdminProfile(props){_classCallCheck(this,BrokerageAdminProfile);var _this=_possibleConstructorReturn(this,(BrokerageAdminProfile.__proto__||Object.getPrototypeOf(BrokerageAdminProfile)).call(this,props));_this.state={value:0,open:false,avatarPath:"",user:{name:"",surname:"",Brokerage:"Example Brokerage",pricePlan:{name:"Basic - Trial",price:"R0"},nextPricePlan:{available:true,name:"Basic",amount:"295.00"},payment:{method:"N/A",next:"N/A"}},oldPassword:"",newPassword:"",confirmNewPassword:""};_this.handleChangePasswordOld=function(event){_this.setState({oldPassword:event.target.value});};_this.handleChangePasswordNew=function(event){_this.setState({newPassword:event.target.value});};_this.handleChangePasswordNewConfirm=function(event){_this.setState({confirmNewPassword:event.target.value});};_this.handleClickOpenDialog=function(){_this.setState({open:true});};_this.handleCloseDialog=function(){_this.setState({open:false,confirmNewPassword:"",newPassword:"",oldPassword:""});};_this.handleResetPassword=function(){if(_this.isEmptyOrSpaces(_this.state.newPassword)||_this.isEmptyOrSpaces(_this.state.confirmNewPassword)||_this.isEmptyOrSpaces(_this.state.oldPassword)){__WEBPACK_IMPORTED_MODULE_1_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_29_reducers_NotificationReducer__["d" /* showSnack */])({message:"Password cannot be empty.",color:"danger"}));}else if(_this.state.newPassword!==_this.state.confirmNewPassword){__WEBPACK_IMPORTED_MODULE_1_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_29_reducers_NotificationReducer__["d" /* showSnack */])({message:"Password do not match.",color:"danger"}));}else{var input={oldPass:_this.state.oldPassword,newPass:_this.state.newPassword,clientMutationId:"123",brokerId:Object(__WEBPACK_IMPORTED_MODULE_28_helpers_UserHelper__["a" /* GetUserId */])(),token:Object(__WEBPACK_IMPORTED_MODULE_28_helpers_UserHelper__["c" /* GetUserToken */])()};var miniMe=_this.props;_this.props.mutate({variables:{input:input}}).then(function(resp){__WEBPACK_IMPORTED_MODULE_1_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_29_reducers_NotificationReducer__["e" /* successWarning */])({open:true,title:"Password Updated.",onConfirm:_this.setState({open:false})}));}).catch(function(error){__WEBPACK_IMPORTED_MODULE_1_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_29_reducers_NotificationReducer__["d" /* showSnack */])({message:"Error: "+error,color:"danger"}));});}};return _this;}_createClass(BrokerageAdminProfile,[{key:"isEmptyOrSpaces",value:function isEmptyOrSpaces(str){return str===null||str.match(/^ *$/)!==null;}},{key:"render",value:function render(){var _this2=this;var value=this.state.value;var classes=this.props.classes;if(this.props.data.loading){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__material_ui_core__["B" /* LinearProgress */],null);}var data=this.props.data;if(data.error&&data.error.message&&data.error.message==="GraphQL error: invalid token"){Object(__WEBPACK_IMPORTED_MODULE_28_helpers_UserHelper__["d" /* Logout */])();return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["a" /* Redirect */],{to:"/app/portal/login"});}var profile=JSON.parse(data.BrokerageProfile[0].profile);if(this.state.user.name!==""&&this.state.user.surname!==""){this.setState({user:{name:profile.name,surname:profile.surname}});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default.a,{container:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:10,style:{margin:"auto",marginTop:"55px"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Card_Card_jsx__["a" /* default */],{profile:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_components_Card_CardAvatar_jsx__["a" /* default */],{profile:true,className:"avatarBackground"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_apollo__["Mutation"],{client:client,mutation:uploadFileMutation,onCompleted:function onCompleted(data){_this2.setState({avatarPath:data.uploadFileWithId});__WEBPACK_IMPORTED_MODULE_1_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_26_reducers_LoginReducer__["c" /* changeAvatar */])({type:CHANGEAVATAR,props:data.uploadFileWithId}));}},function(mutate){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22_react_dropzone__["a" /* default */],{style:{width:"fit-content",height:"fit-content",border:"none"},onDrop:function onDrop(_ref){var _ref2=_slicedToArray(_ref,1),file=_ref2[0];return mutate({variables:{file:file,id:__WEBPACK_IMPORTED_MODULE_1_store__["a" /* default */].getState().login.userID}});}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:"#pablo",onClick:function onClick(e){return e.preventDefault();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:profile.su_pp_path===null?__WEBPACK_IMPORTED_MODULE_18_assets_img_faces_avatar1_jpg___default.a:_this2.state.avatarPath!==""?_this2.state.avatarPath:profile.su_pp_path,alt:"...",style:{width:"130px",height:"130px"}})));})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_Card_CardBody_jsx__["a" /* default */],{profile:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h2",{className:classes.cardTitle},profile.name," ",profile.surname),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4",{className:classes.cardTitle,style:{color:"#858a90"}},this.state.user.Brokerage)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Card_Card_jsx__["a" /* default */],{style:{marginBottom:"-15px"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_Card_CardHeader_jsx__["a" /* default */],{color:"rose",icon:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_Card_CardIcon_jsx__["a" /* default */],{color:"sqPurple"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_icons_PermIdentity___default.a,null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Typography___default.a,{variant:"title",className:"typographyTitle",style:{float:"left"}},"Edit Profile"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_Clearfix_Clearfix_jsx__["a" /* default */],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_Card_CardBody_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default.a,{direction:"row",container:true,style:{}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default.a,{direction:"column",container:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:12,style:{marginBottom:"20px"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Typography___default.a,{variant:"headline",className:"typography"},"Account Details")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__material_ui_core__["X" /* TextField */],{label:"Username",fullWidth:true,InputProps:{readOnly:true},defaultValue:profile.email,className:classes.textField,margin:"normal"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__material_ui_core__["X" /* TextField */],{label:"Name",fullWidth:true,defaultValue:profile.name,InputProps:{readOnly:true},className:classes.textField,margin:"normal"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__material_ui_core__["X" /* TextField */],{id:"name",label:"Surname",fullWidth:true,defaultValue:profile.surname,InputProps:{readOnly:true},className:classes.textField,margin:"normal"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__material_ui_core__["X" /* TextField */],{id:"phoneNumber",label:"Phone Number",fullWidth:true,defaultValue:profile.phoneNumber,InputProps:{readOnly:true},className:classes.textField,margin:"normal"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:12,style:{marginTop:"10px"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__material_ui_core__["d" /* Button */],{variant:"outlined",className:"outlinedButton",onClick:this.handleClickOpenDialog,style:{float:"left",color:"#55526f"}},"Reset Password"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__material_ui_core__["k" /* Dialog */],{open:this.state.open,onClose:this.handleCloseDialog,"aria-labelledby":"form-dialog-title"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__material_ui_core__["o" /* DialogTitle */],{id:"form-dialog-title"},"RESET PASSWORD"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__material_ui_core__["m" /* DialogContent */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__material_ui_core__["X" /* TextField */],{margin:"dense",id:"password",label:"Old Password",type:"password",fullWidth:true,onChange:this.handleChangePasswordOld}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__material_ui_core__["X" /* TextField */],{margin:"dense",id:"password",label:"New Password",type:"password",fullWidth:true,onChange:this.handleChangePasswordNew}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__material_ui_core__["X" /* TextField */],{margin:"dense",id:"password",label:"Confirm New Password",type:"password",fullWidth:true,onChange:this.handleChangePasswordNewConfirm})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__material_ui_core__["l" /* DialogActions */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__material_ui_core__["d" /* Button */],{onClick:this.handleCloseDialog,color:"primary"},"Cancel"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__material_ui_core__["d" /* Button */],{onClick:this.handleResetPassword,color:"primary"},"SAVE")))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default.a,{direction:"column",container:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:12,style:{marginBottom:"20px"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Typography___default.a,{variant:"headline",className:"typographyTitle"},"Subscription")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default.a,{direction:"row",container:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:6,style:{marginBottom:"20px"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Card_Card_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:12,style:{marginBottom:"10px"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Typography___default.a,{variant:"subheading",className:"typographyTitle"},"Current Price Plan")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Typography___default.a,{className:"typography",style:{float:"left"}},"Type:"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Typography___default.a,{className:"typography",style:{float:"right",textAlign:"right"}},this.state.user.pricePlan.name)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Typography___default.a,{className:"typography",style:{float:"left"}},"Price:"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Typography___default.a,{className:"typography",style:{float:"right",textAlign:"right"}},this.state.user.pricePlan.price," p/m")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:12,style:{marginTop:"15px",marginBottom:"10px"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__material_ui_core__["d" /* Button */],{variant:"outlined",className:"outlinedButton",style:{float:"left",color:"#55526f"}},"Cancel Subscription")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:6,style:{marginBottom:"20px"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Card_Card_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:12,style:{marginBottom:"10px"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Typography___default.a,{variant:"subheading",className:"typographyTitle"},"Payment Details")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Typography___default.a,{className:"typography",style:{float:"left"}},"Payment method:"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Typography___default.a,{className:"typography",style:{float:"right",textAlign:"right"}},this.state.user.payment.method)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Typography___default.a,{className:"typography",style:{float:"left"}},"Next Payment:"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Typography___default.a,{className:"typography",style:{float:"right",textAlign:"right"}},this.state.user.payment.next)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:12,style:{marginTop:"15px",marginBottom:"10px"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__material_ui_core__["d" /* Button */],{variant:"outlined",className:"outlinedButton",style:{float:"left",color:"#55526f"}},"Update Payment Method"))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:12},this.state.user.nextPricePlan.available?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__material_ui_core__["d" /* Button */],_defineProperty({variant:"outlined",className:"outlinedButton"},"className","buttonPrimary"),"Upgrade From R",this.state.user.nextPricePlan.amount," P/M"):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__material_ui_core__["d" /* Button */],_defineProperty({variant:"outlined",className:"outlinedButton",onClick:this.handleClickOpenDialog},"className","buttonPrimary"),"Downgrade")))))))))));}}]);return BrokerageAdminProfile;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);BrokerageAdminProfile=Object(__WEBPACK_IMPORTED_MODULE_3_react_apollo__["graphql"])(__WEBPACK_IMPORTED_MODULE_19_queries_BrokerageProfile__["a" /* brokerageProfile */],{options:function options(){return{fetchPolicy:"network-only"};},props:function props(_props){if(_props.data.error){}return Object.assign({},_props);}})(BrokerageAdminProfile);BrokerageAdminProfile=Object(__WEBPACK_IMPORTED_MODULE_4_react_redux__["b" /* connect */])(function(state){return{brokerId:Object(__WEBPACK_IMPORTED_MODULE_28_helpers_UserHelper__["a" /* GetUserId */])(),token:Object(__WEBPACK_IMPORTED_MODULE_28_helpers_UserHelper__["c" /* GetUserToken */])()};})(BrokerageAdminProfile);BrokerageAdminProfile=Object(__WEBPACK_IMPORTED_MODULE_3_react_apollo__["graphql"])(__WEBPACK_IMPORTED_MODULE_20_queries_updatePassword__["a" /* updatePassword */])(BrokerageAdminProfile);/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_6__material_ui_core_styles_withStyles___default()(__WEBPACK_IMPORTED_MODULE_17_assets_jss_material_dashboard_pro_react_views_userProfileStyles_jsx__["a" /* default */])(BrokerageAdminProfile));

/***/ }),
/* 2460 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles_withStyles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles_withStyles__);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}// mterial-ui components
var style={clearfix:{"&:after,&:before":{display:"table",content:'" "'},"&:after":{clear:"both"}}};function Clearfix(_ref){var props=_objectWithoutProperties(_ref,[]);var classes=props.classes;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:classes.clearfix});}Clearfix.propTypes={classes:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired};/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles_withStyles___default()(style)(Clearfix));

/***/ }),
/* 2461 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return brokerageProfile; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_graphql_tag__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_graphql_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_graphql_tag__);
var _templateObject=_taggedTemplateLiteral(["\n  query BrokerageProfile($brokerId: String!,$token:String!) {\n    BrokerageProfile(brokerageId:$brokerId,token:$token){\n      profile\n    }\n  }\n"],["\n  query BrokerageProfile($brokerId: String!,$token:String!) {\n    BrokerageProfile(brokerageId:$brokerId,token:$token){\n      profile\n    }\n  }\n"]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var brokerageProfile=__WEBPACK_IMPORTED_MODULE_0_graphql_tag___default()(_templateObject);

/***/ }),
/* 2462 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_core__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_Typography__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_Typography___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Typography__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_apollo_cache_inmemory__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_apollo_client__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_apollo_upload_client__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_assets_img_faces_avatar1_jpg__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_assets_img_faces_avatar1_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_assets_img_faces_avatar1_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_assets_img_imageplaceholder_png__ = __webpack_require__(2463);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_assets_img_imageplaceholder_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_assets_img_imageplaceholder_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_Card_Card_jsx__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_Card_CardHeader_jsx__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_Card_CardIcon_jsx__ = __webpack_require__(247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_Grid_GridItem_jsx__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_Wrappers_materialUIWrappers_components_FormInput__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_constants_js__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_graphql_tag__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_graphql_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_graphql_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_helpers_UserHelper__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_queries_BrokerageBrProfile__ = __webpack_require__(2464);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_queries_Profile_mutations__ = __webpack_require__(252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_queries_updatePassword__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_react_apollo__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_react_dropzone__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_react_redux__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_react_router__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_reducers_LoginReducer__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_reducers_NotificationReducer__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_redux_form__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_store__ = __webpack_require__(10);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(["\n  mutation($file: Upload!, $id: String!) {\n    uploadFileWithId(file: $file, id: $id)\n  }\n"],["\n  mutation($file: Upload!, $id: String!) {\n    uploadFileWithId(file: $file, id: $id)\n  }\n"]),_templateObject2=_taggedTemplateLiteral(["\n  mutation($file: Upload!, $id: String!) {\n    uploadBrokerageImage(file: $file, id: $id)\n  }\n"],["\n  mutation($file: Upload!, $id: String!) {\n    uploadBrokerageImage(file: $file, id: $id)\n  }\n"]);function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}/*eslint-disable*/// core components
var CHANGEAVATAR="sure-quote/Login/CHANGEAVATAR";var client=new __WEBPACK_IMPORTED_MODULE_4_apollo_client__["ApolloClient"]({link:Object(__WEBPACK_IMPORTED_MODULE_5_apollo_upload_client__["a" /* createUploadLink */])({uri:__WEBPACK_IMPORTED_MODULE_13_constants_js__["d" /* fileUploadServerPath */]}),cache:new __WEBPACK_IMPORTED_MODULE_3_apollo_cache_inmemory__["a" /* InMemoryCache */]()});var uploadFileMutation=__WEBPACK_IMPORTED_MODULE_14_graphql_tag___default()(_templateObject);var brokerageImageMutation=__WEBPACK_IMPORTED_MODULE_14_graphql_tag___default()(_templateObject2);var required=function required(value){return value?undefined:"Required";};function isEmptyOrSpaces(str){return str===undefined||str===null||str.match(/^ *$/)!==null;}var BrokerageBrokerProfile=function(_Component){_inherits(BrokerageBrokerProfile,_Component);function BrokerageBrokerProfile(props){_classCallCheck(this,BrokerageBrokerProfile);var _this=_possibleConstructorReturn(this,(BrokerageBrokerProfile.__proto__||Object.getPrototypeOf(BrokerageBrokerProfile)).call(this,props));_this.state={open:false,avatarPath:"",brokerageLogoPath:"",oldPassword:"",newPassword:"",confirmNewPassword:"",formInitiazed:false,checkValidation:false,showInfo:false,dialogTitle:"",dialogText:""};_this.handleStateChange=function(event,prop){_this.setState(_defineProperty({},prop,event.target.value));};_this.handleClickOpenDialog=function(){_this.setState({open:true});};_this.handleCloseDialog=function(){_this.setState({open:false,confirmNewPassword:"",newPassword:"",oldPassword:""});};_this.handleResetPassword=function(){if(isEmptyOrSpaces(_this.state.newPassword)||isEmptyOrSpaces(_this.state.confirmNewPassword)||isEmptyOrSpaces(_this.state.oldPassword)){__WEBPACK_IMPORTED_MODULE_27_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_25_reducers_NotificationReducer__["d" /* showSnack */])({message:"Password cannot be empty.",color:"danger"}));}else if(_this.state.newPassword!==_this.state.confirmNewPassword){__WEBPACK_IMPORTED_MODULE_27_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_25_reducers_NotificationReducer__["d" /* showSnack */])({message:"Password do not match.",color:"danger"}));}else{var input={oldPass:_this.state.oldPassword,newPass:_this.state.newPassword,brokerId:Object(__WEBPACK_IMPORTED_MODULE_15_helpers_UserHelper__["a" /* GetUserId */])(),token:Object(__WEBPACK_IMPORTED_MODULE_15_helpers_UserHelper__["c" /* GetUserToken */])()};var miniMe=_this.props;_this.props.UpdatePassword({variables:{input:input}}).then(function(resp){__WEBPACK_IMPORTED_MODULE_27_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_25_reducers_NotificationReducer__["e" /* successWarning */])({open:true,title:"Updated Successfully.",onConfirm:function onConfirm(){return _this.setState({open:false});}}));}).catch(function(error){__WEBPACK_IMPORTED_MODULE_27_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_25_reducers_NotificationReducer__["d" /* showSnack */])({message:"There was an error updating your information : "+error,color:"danger"}));});}};_this.openShowInfo=function(title,text){_this.setState({showInfo:true,dialogTitle:title,dialogText:text});};_this.closeShowInfo=function(){_this.setState({showInfo:false,dialogTitle:"",dialogText:""});};_this.saveChanges=function(){if(__WEBPACK_IMPORTED_MODULE_27_store__["a" /* default */].getState().form.BrokerageBr.syncErrors){__WEBPACK_IMPORTED_MODULE_27_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_25_reducers_NotificationReducer__["d" /* showSnack */])({message:"Invalid Information",color:"danger"}));_this.setState({checkValidation:true});_this.forceUpdate();}else{_this.setState({checkValidation:false});var input={userId:Object(__WEBPACK_IMPORTED_MODULE_15_helpers_UserHelper__["a" /* GetUserId */])(),data:__WEBPACK_IMPORTED_MODULE_27_store__["a" /* default */].getState().form.BrokerageBr.values,token:Object(__WEBPACK_IMPORTED_MODULE_15_helpers_UserHelper__["c" /* GetUserToken */])()};_this.props.BrokerageBrProfileUpdate({variables:{input:input}}).then(function(resp){__WEBPACK_IMPORTED_MODULE_27_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_25_reducers_NotificationReducer__["e" /* successWarning */])({open:true,title:"Profile Updated."}));}).catch(function(error){__WEBPACK_IMPORTED_MODULE_27_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_25_reducers_NotificationReducer__["d" /* showSnack */])({message:"There was an error updating your profile : "+error,color:"danger"}));});}};_this.initializeForm=function(profile){_this.props.initialize({email:profile.email,name:profile.name,surname:profile.surname,contactPhoneNumber:profile.user_phone_number,contactEmail:profile.sbad_KP_contact_email,brokerageName:profile.sbad_brokerageName,fsbNumber:profile.sbad_fsb,sbad_streetAddress:profile.sbad_streetAddress,brokeragePhoneNumber:profile.sbad_contact_phone,brokerageEmail:profile.sbad_contact_email});_this.setState({formInitiazed:true});};return _this;}_createClass(BrokerageBrokerProfile,[{key:"render",value:function render(){var _this2=this;if(this.props.data.loading){return __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["B" /* LinearProgress */],null);}var data=this.props.data;if(data.error&&data.error.message&&data.error.message==="GraphQL error: invalid token"){Object(__WEBPACK_IMPORTED_MODULE_15_helpers_UserHelper__["d" /* Logout */])();return __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23_react_router__["a" /* Redirect */],{to:"/app/portal/login"});}var profile=data.BrokerageBrProfile;if(!this.state.formInitiazed){this.initializeForm(profile);}var avatarPath=__WEBPACK_IMPORTED_MODULE_6_assets_img_faces_avatar1_jpg___default.a;if(this.state.avatarPath!==""){avatarPath=this.state.avatarPath;}else if(profile.su_pp_path!==null&&profile.su_pp_path!==""){avatarPath=profile.su_pp_path;}var brokerageLogoPath=__WEBPACK_IMPORTED_MODULE_7_assets_img_imageplaceholder_png___default.a;if(this.state.brokerageLogoPath!==""){brokerageLogoPath=this.state.brokerageLogoPath;}else if(profile.sbad_brokerageLogoRef!==null&&profile.sbad_brokerageLogoRef!==""){brokerageLogoPath=profile.sbad_brokerageLogoRef;}return __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{container:true},__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:10,style:{flexBasis:"100%",maxWidth:"100%",margin:'auto'}},__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_Card_Card_jsx__["a" /* default */],{style:{marginTop:"0px"}},__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Card_CardHeader_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_Card_CardIcon_jsx__["a" /* default */],{color:"sqLightBlue",className:"cardIconTopRight"},__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["w" /* Icon */],{style:{color:"white"}},"person")),__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Typography___default.a,{variant:"headline",className:"centerCell"},"Your Profile"),__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement("div",{style:{borderBottom:"1px solid #cccccc69",paddingBottom:"12px",margin:"0px auto",width:"50%"}})),__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["f" /* CardContent */],null,__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{container:true},__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:6,style:{marginBottom:"25px"}},__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_Card_Card_jsx__["a" /* default */],{style:{margin:"0px"}},__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["f" /* CardContent */],null,__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{container:true},__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:12},__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Typography___default.a,{variant:"headline",className:"centerCell"},"Your Details"),__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement("div",{style:{borderBottom:"1px solid #cccccc69",paddingBottom:"12px",margin:"0px auto 15px auto",width:"50%"}})),__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:12,style:{height:"90px"}},__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20_react_apollo__["Mutation"],{client:client,mutation:uploadFileMutation,onCompleted:function onCompleted(data){_this2.setState({avatarPath:data.uploadFileWithId});__WEBPACK_IMPORTED_MODULE_27_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_24_reducers_LoginReducer__["c" /* changeAvatar */])({type:CHANGEAVATAR,props:data.uploadFileWithId}));}},function(mutate){return __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement("div",{style:{textAlign:"center"}},__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement("a",{href:"#pablo",onClick:function onClick(e){return e.preventDefault();}},__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement("img",{className:"avatarImg",src:avatarPath,alt:"...",style:{width:"60px",height:"60px",margin:"0px auto",cursor:"default"}})),__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21_react_dropzone__["a" /* default */],{style:{width:"fit-content",height:"fit-content",border:"none",margin:"0px auto",marginTop:"10px"},onDrop:function onDrop(_ref){var _ref2=_slicedToArray(_ref,1),file=_ref2[0];return mutate({variables:{file:file,id:__WEBPACK_IMPORTED_MODULE_27_store__["a" /* default */].getState().login.userID}});},accept:"image/jpeg, image/png"},__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement("div",{style:{display:"flex",position:"relative"}},__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["i" /* Chip */],{className:"smallChip",avatar:__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["b" /* Avatar */],{style:{backgroundColor:"#6c5cab",color:"white"}},__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["w" /* Icon */],null,"edit")),variant:"outlined",label:__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Typography___default.a,{style:{color:"white"}},"Edit Picture"),color:"secondary",style:{backgroundColor:"#a59fff",color:"white",cursor:"pointer"}}))));})),__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:12,style:{marginTop:"25px"}},__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["t" /* FormControl */],{fullWidth:true,className:"spacedFormControl"},__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_12_components_Wrappers_materialUIWrappers_components_FormInput__["a" /* default */],checkValidation:this.state.checkValidation,name:"email",label:"User Email (used to log in)",readOnly:true}))),__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:6},__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["t" /* FormControl */],{fullWidth:true,className:"spacedFormControl"},__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_12_components_Wrappers_materialUIWrappers_components_FormInput__["a" /* default */],checkValidation:this.state.checkValidation,name:"name",label:"Name",validate:[required]}))),__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:6},__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["t" /* FormControl */],{fullWidth:true,className:"spacedFormControl"},__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_12_components_Wrappers_materialUIWrappers_components_FormInput__["a" /* default */],checkValidation:this.state.checkValidation,name:"surname",label:"Surname",validate:[required]}))),__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:6},__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["t" /* FormControl */],{fullWidth:true,className:"spacedFormControl"},__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_12_components_Wrappers_materialUIWrappers_components_FormInput__["a" /* default */],checkValidation:this.state.checkValidation,name:"contactPhoneNumber",label:"Phone No."}))),__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:6},__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["t" /* FormControl */],{fullWidth:true,className:"spacedFormControl"},__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_12_components_Wrappers_materialUIWrappers_components_FormInput__["a" /* default */],checkValidation:this.state.checkValidation,name:"contactEmail",label:"Contact Email"}))),__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{item:true,xs:12,sm:12,md:12,style:{marginTop:"16px"}},__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{container:true},__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:6,md:6},__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Typography___default.a,{variant:"subheading"},"Sure Quote App Code"),__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Typography___default.a,{variant:"caption",className:"typographyLinkBasic",onClick:function onClick(){return _this2.openShowInfo("Sure Quote App Code?","This is the Code that you send to your Clients when they download the My Broker App to link them with you. This will allow them to actively update their information for you and send you direct Messenges.");}},"What's this?")),__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:6,md:6},__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["X" /* TextField */],{fullWidth:true,defaultValue:profile.sbd_broker_app_code,InputProps:{readOnly:true}})))))))),__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:6,style:{marginBottom:"25px"}},__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_Card_Card_jsx__["a" /* default */],{style:{margin:"0px"}},__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["f" /* CardContent */],null,__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{container:true},__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:12},__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Typography___default.a,{variant:"headline",className:"centerCell"},"Brokerage Details"),__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement("div",{style:{borderBottom:"1px solid #cccccc69",paddingBottom:"12px",margin:"0px auto 15px auto",width:"50%"}})),__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:12,style:{textAlign:"center"}},__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement("img",{src:brokerageLogoPath,alt:"...",style:brokerageLogoPath!==__WEBPACK_IMPORTED_MODULE_7_assets_img_imageplaceholder_png___default.a?{width:"200px",height:"auto",maxHeight:"90px"}:{width:"60px",height:"60px"}})),__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:12},__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20_react_apollo__["Mutation"],{client:client,mutation:brokerageImageMutation,onCompleted:function onCompleted(data){_this2.setState({brokerageLogoPath:data.uploadBrokerageImage});_this2.forceUpdate();}},function(mutate){return __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21_react_dropzone__["a" /* default */],{style:{width:"fit-content",height:"fit-content",border:"none",margin:"0px auto",marginTop:"10px"},onDrop:function onDrop(_ref3){var _ref4=_slicedToArray(_ref3,1),file=_ref4[0];return mutate({variables:{file:file,id:__WEBPACK_IMPORTED_MODULE_27_store__["a" /* default */].getState().login.userID}});},accept:"image/jpeg, image/png"},__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["i" /* Chip */],{className:"smallChip",avatar:__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["b" /* Avatar */],{style:{backgroundColor:"#6c5cab",color:"white"}},__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["w" /* Icon */],null,"edit")),variant:"outlined",label:__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Typography___default.a,{style:{color:"white"}},"Edit Logo"),color:"secondary",style:{backgroundColor:"#a59fff",color:"white",cursor:"pointer"}}));})),__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:12},__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["t" /* FormControl */],{fullWidth:true,className:"spacedFormControl"},__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_12_components_Wrappers_materialUIWrappers_components_FormInput__["a" /* default */],checkValidation:this.state.checkValidation,name:"brokerageName",label:"Brokerage Name",validate:[required]}))),__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:6},__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["t" /* FormControl */],{fullWidth:true,className:"spacedFormControl"},__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_12_components_Wrappers_materialUIWrappers_components_FormInput__["a" /* default */],checkValidation:this.state.checkValidation,name:"fsbNumber",label:"FSB No.",readOnly:true}))),__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:6},__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["t" /* FormControl */],{fullWidth:true,className:"spacedFormControl"},__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_12_components_Wrappers_materialUIWrappers_components_FormInput__["a" /* default */],checkValidation:this.state.checkValidation,name:"sbad_streetAddress",label:"Address"}))),__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:6},__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["t" /* FormControl */],{fullWidth:true,className:"spacedFormControl"},__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_12_components_Wrappers_materialUIWrappers_components_FormInput__["a" /* default */],checkValidation:this.state.checkValidation,name:"brokeragePhoneNumber",label:"Phone No."}))),__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:6},__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["t" /* FormControl */],{fullWidth:true,className:"spacedFormControl"},__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_12_components_Wrappers_materialUIWrappers_components_FormInput__["a" /* default */],checkValidation:this.state.checkValidation,name:"brokerageEmail",label:"Brokerage Email"}))),__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{item:true,xs:12,sm:12,md:12,style:{marginTop:"16px"}},__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{container:true},__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:6,md:6},__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Typography___default.a,{variant:"subheading"},"Brokerage Code"),__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Typography___default.a,{variant:"caption",className:"typographyLinkBasic",onClick:function onClick(){return _this2.openShowInfo("Brokerage Code?","This is the code Sure Quote sends your Brokers and Assistants when you invite them to register on Sure Quote. We use this code to authenticate and link the Brokers and Assistants to your Brokerage.");}},"What's this?"),__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["k" /* Dialog */],{open:this.state.showInfo,onClose:this.closeShowInfo},__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["o" /* DialogTitle */],null,this.state.dialogTitle),__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["m" /* DialogContent */],null,__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["n" /* DialogContentText */],null,this.state.dialogText)),__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["l" /* DialogActions */],null,__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["d" /* Button */],{onClick:this.closeShowInfo,color:"primary",autoFocus:true},"Ok")))),__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:6,md:6},__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["X" /* TextField */],{fullWidth:true,defaultValue:profile.sbad_brokerage_code,InputProps:{readOnly:true}})))))))),__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:12,style:{marginTop:"10px",textAlign:"center"}},__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["d" /* Button */],{variant:"outlined",className:"outlinedButton",onClick:function onClick(){return _this2.saveChanges();},style:{color:"#55526f",margin:"0px auto"}},"Save Changes",__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["w" /* Icon */],{style:{marginLeft:"5px"}},"check"))),__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:12,style:{marginTop:"35px",textAlign:"center"}},__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Typography___default.a,{variant:"body1",style:{color:"#0000008a"},className:"typographyLinkBasic",onClick:this.handleClickOpenDialog},"Reset Password"),__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["k" /* Dialog */],{open:this.state.open,onClose:this.handleCloseDialog,"aria-labelledby":"form-dialog-title",className:"centerFixedDialog"},__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["o" /* DialogTitle */],{id:"form-dialog-title"},"Reset Password"),__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["m" /* DialogContent */],null,__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["X" /* TextField */],{label:"Old Password",fullWidth:true,onChange:function onChange(e){return _this2.handleStateChange(e,"oldPassword");},value:this.state.oldPassword,autoComplete:"off",type:"password"}),__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["X" /* TextField */],{label:"New Password",fullWidth:true,onChange:function onChange(e){return _this2.handleStateChange(e,"newPassword");},value:this.state.newPassword,autoComplete:"off",type:"password"}),__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["X" /* TextField */],{label:"Confirm New Password",fullWidth:true,onChange:function onChange(e){return _this2.handleStateChange(e,"confirmNewPassword");},value:this.state.confirmNewPassword,autoComplete:"off",type:"password"})),__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["l" /* DialogActions */],null,__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["d" /* Button */],{onClick:this.handleCloseDialog,color:"primary"},"Cancel"),__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["d" /* Button */],{onClick:this.handleResetPassword,color:"primary"},"SAVE"))))))))));}}]);return BrokerageBrokerProfile;}(__WEBPACK_IMPORTED_MODULE_19_react__["Component"]);BrokerageBrokerProfile=Object(__WEBPACK_IMPORTED_MODULE_20_react_apollo__["graphql"])(__WEBPACK_IMPORTED_MODULE_16_queries_BrokerageBrProfile__["a" /* brokerageBrProfile */],{options:function options(){return{fetchPolicy:"network-only"};},props:function props(_props){if(_props.data.error){}return Object.assign({},_props);}})(BrokerageBrokerProfile);BrokerageBrokerProfile=Object(__WEBPACK_IMPORTED_MODULE_22_react_redux__["b" /* connect */])(function(state){return{brokerId:Object(__WEBPACK_IMPORTED_MODULE_15_helpers_UserHelper__["a" /* GetUserId */])(),token:Object(__WEBPACK_IMPORTED_MODULE_15_helpers_UserHelper__["c" /* GetUserToken */])()};})(BrokerageBrokerProfile);BrokerageBrokerProfile=Object(__WEBPACK_IMPORTED_MODULE_20_react_apollo__["compose"])(Object(__WEBPACK_IMPORTED_MODULE_20_react_apollo__["graphql"])(__WEBPACK_IMPORTED_MODULE_18_queries_updatePassword__["a" /* updatePassword */],{name:"UpdatePassword"}),Object(__WEBPACK_IMPORTED_MODULE_20_react_apollo__["graphql"])(__WEBPACK_IMPORTED_MODULE_17_queries_Profile_mutations__["c" /* BrokerageBrProfileUpdate */],{name:"BrokerageBrProfileUpdate"}))(BrokerageBrokerProfile);BrokerageBrokerProfile=Object(__WEBPACK_IMPORTED_MODULE_26_redux_form__["e" /* reduxForm */])({form:"BrokerageBr",destroyOnUnmount:true})(BrokerageBrokerProfile);/* harmony default export */ __webpack_exports__["a"] = (BrokerageBrokerProfile);

/***/ }),
/* 2463 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/imageplaceholder.b5f6922b.png";

/***/ }),
/* 2464 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return brokerageBrProfile; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_graphql_tag__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_graphql_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_graphql_tag__);
var _templateObject=_taggedTemplateLiteral(["\n  query brokerageBrProfile($brokerId: String!,$token:String!) {\n    BrokerageBrProfile(brokerageId:$brokerId,token:$token){\n      email,\n      name,\n      surname,\n      phoneNumber,\n      su_pp_path,\n      sbad_brokerageName,\n      sbad_brokerageLogoRef,\n      sbad_fsb,\n      sbad_streetAddress,\n      sbad_contact_email,\n      sbad_contact_phone,\n      sbd_broker_app_code,\n      sbad_brokerage_code,\n      sbad_KP_contact_email,\n      user_phone_number\n    }\n  }\n"],["\n  query brokerageBrProfile($brokerId: String!,$token:String!) {\n    BrokerageBrProfile(brokerageId:$brokerId,token:$token){\n      email,\n      name,\n      surname,\n      phoneNumber,\n      su_pp_path,\n      sbad_brokerageName,\n      sbad_brokerageLogoRef,\n      sbad_fsb,\n      sbad_streetAddress,\n      sbad_contact_email,\n      sbad_contact_phone,\n      sbd_broker_app_code,\n      sbad_brokerage_code,\n      sbad_KP_contact_email,\n      user_phone_number\n    }\n  }\n"]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var brokerageBrProfile=__WEBPACK_IMPORTED_MODULE_0_graphql_tag___default()(_templateObject);

/***/ }),
/* 2465 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_core__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_Typography__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_Typography___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Typography__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_icons_AttachMoney__ = __webpack_require__(575);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_icons_AttachMoney___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_icons_AttachMoney__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Card_Card_jsx__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Card_CardHeader_jsx__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_Card_CardIcon_jsx__ = __webpack_require__(247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_Grid_GridContainer_jsx__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_Grid_GridItem_jsx__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_SpaceDisplay_SpaceDisplay_jsx__ = __webpack_require__(626);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_helpers_UserHelper__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_queries_Subscription_queries__ = __webpack_require__(627);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_apollo__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_react_apollo__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/*eslint-disable*/// @material-ui/icons
// core components
var PricePlanMap={1:"Basic",2:"Standard",3:"Premium",4:"Trial"};var Subscription=function(_Component){_inherits(Subscription,_Component);function Subscription(){_classCallCheck(this,Subscription);return _possibleConstructorReturn(this,(Subscription.__proto__||Object.getPrototypeOf(Subscription)).apply(this,arguments));}_createClass(Subscription,[{key:"render",value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react_apollo__["Query"],{query:__WEBPACK_IMPORTED_MODULE_10_queries_Subscription_queries__["a" /* SubscriptionInfo */],variables:{userId:Object(__WEBPACK_IMPORTED_MODULE_9_helpers_UserHelper__["a" /* GetUserId */])(),token:Object(__WEBPACK_IMPORTED_MODULE_9_helpers_UserHelper__["c" /* GetUserToken */])()},fetchPolicy:"network-only"},function(_ref){var _React$createElement;var loading=_ref.loading,error=_ref.error,data=_ref.data,refetch=_ref.refetch;if(loading){return __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["B" /* LinearProgress */],null);}var subscriptionInfo=data.SubscriptionInfo;return __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Grid_GridContainer_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:12,style:{marginBottom:"20px"}},__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:6,style:{margin:"0px auto"}},__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Card_Card_jsx__["a" /* default */],{style:{paddingBottom:"50px",paddingTop:"25px"}},__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Card_CardHeader_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Card_CardIcon_jsx__["a" /* default */],{color:"sqLightBlue",className:"cardIconTopRight"},__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_icons_AttachMoney___default.a,{style:{color:"white"}})),__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Typography___default.a,{variant:"headline",className:"centerCell"},"Your Subscription"),__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement("div",{style:{borderBottom:"1px solid #cccccc69",paddingBottom:"12px",margin:"10px auto",width:"65%"}})),__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:10,md:10,style:{display:"grid",margin:"0px auto",width:"100%"}},__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_SpaceDisplay_SpaceDisplay_jsx__["a" /* default */],{left:__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Typography___default.a,null,"Your Current Price Plan :"),right:__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Typography___default.a,null,PricePlanMap[subscriptionInfo.sd_brokerage_user_plan])}),__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_SpaceDisplay_SpaceDisplay_jsx__["a" /* default */],{left:__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Typography___default.a,null,"Current Price :"),right:__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Typography___default.a,null,subscriptionInfo.sd_price_pm," p/m")}),__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_SpaceDisplay_SpaceDisplay_jsx__["a" /* default */],{left:__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Typography___default.a,null,"Next Payment :"),right:__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Typography___default.a,null,subscriptionInfo.sd_next_payment)}),__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Typography___default.a,{variant:"subheading",style:_defineProperty({float:"left",textAlign:"left",margin:"20px 0px"},"textAlign","center")},__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement("strong",null,"Brokers")),__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_SpaceDisplay_SpaceDisplay_jsx__["a" /* default */],{left:__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Typography___default.a,null,"Basic:"),right:__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Typography___default.a,null,subscriptionInfo.sd_basic_brokers)}),__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_SpaceDisplay_SpaceDisplay_jsx__["a" /* default */],{left:__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Typography___default.a,null,"Standard :"),right:__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Typography___default.a,null,subscriptionInfo.sd_standard_brokers)}),__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_SpaceDisplay_SpaceDisplay_jsx__["a" /* default */],{left:__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Typography___default.a,null,__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement("strong",null,"Total:")),right:__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Typography___default.a,null,subscriptionInfo.sd_basic_brokers+subscriptionInfo.sd_standard_brokers)}),__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_SpaceDisplay_SpaceDisplay_jsx__["a" /* default */],{style:{margin:"20px 0px"},left:__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Typography___default.a,null,"Assistants :"),right:__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Typography___default.a,null,subscriptionInfo.sd_free_assistants+subscriptionInfo.sd_extra_assistants)})),__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:10,md:6,style:{display:"grid",margin:"0px auto",width:"100%"}},__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement("div",{style:{marginTop:"30px"}},__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["d" /* Button */],(_React$createElement={fullWidth:true,variant:"outlined",className:"outlinedButton"},_defineProperty(_React$createElement,"className","outlinedButton"),_defineProperty(_React$createElement,"color","secondary"),_defineProperty(_React$createElement,"style",{float:"left",marginBottom:"15px"}),_defineProperty(_React$createElement,"onClick",function onClick(){return _this2.props.history.push("/app/editsubscription");}),_React$createElement),"Edit Subscription",__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["w" /* Icon */],{style:{margin:"5px"}},"edit")))),__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Typography___default.a,{variant:"caption",style:{position:"absolute",bottom:"5px",right:"12px",color:"#0000008a"},className:"typographyLinkBasic"},"Want to cancel your subscription?"))))));});}}]);return Subscription;}(__WEBPACK_IMPORTED_MODULE_11_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Subscription);

/***/ }),
/* 2466 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_core__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_EnhancedTableHead_EnhancedTableHead_jsx__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_helpers_Search__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_helpers_UserHelper__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_queries_UserManagement__ = __webpack_require__(2467);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_queries_user_management_ChangeUserStatus__ = __webpack_require__(628);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_apollo__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_router__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_store__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__enums_user_management_js__ = __webpack_require__(629);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__reducers_NotificationReducer__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_BaseTablePageContent_jsx__ = __webpack_require__(2468);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_InviteUsersModal__ = __webpack_require__(2469);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}//Q&Ms
var columnData=[{id:"edit",numeric:false,disablePadding:true,label:"",noSort:true,width:"30px"},{id:"su_ID",numeric:false,disablePadding:true,label:"Status",noSort:true},{id:"su_name",numeric:false,disablePadding:true,label:"Name"},{id:"su_email",numeric:false,disablePadding:true,label:"Email"},{id:"type",numeric:false,disablePadding:true,label:"Type"}];var userLimits={broker:10,assistant:10};var UserManagement=function(_Component){_inherits(UserManagement,_Component);function UserManagement(){var _ref;var _temp,_this,_ret;_classCallCheck(this,UserManagement);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=UserManagement.__proto__||Object.getPrototypeOf(UserManagement)).call.apply(_ref,[this].concat(args))),_this),_this.state={page:0,rowsPerPage:10,order:"desc",orderBy:"",searchTerm:"",loadingSearch:false,refresh:false,data:[],searchData:[],openMenus:[],anchorTop:0,anchorLeft:0,popoverOpen:false,statuses:[__WEBPACK_IMPORTED_MODULE_11__enums_user_management_js__["a" /* UserStatus */].Inactive,__WEBPACK_IMPORTED_MODULE_11__enums_user_management_js__["a" /* UserStatus */].Requested,__WEBPACK_IMPORTED_MODULE_11__enums_user_management_js__["a" /* UserStatus */].Active],activeCount:{broker:0,assistant:0},inviteDialogOpen:false},_this.handleSearch=function(event){_this.setState({searchTerm:event.target.value});var values=event.target.value.split(" ");var brokers=_this.state.data;var inc=["su_name","su_surname","su_email"];var filteredData=Object(__WEBPACK_IMPORTED_MODULE_3_helpers_Search__["a" /* SearchDataSet */])(brokers,values,inc);_this.setState({searchData:filteredData});},_this.handleChangePage=function(event,page){_this.setState({page:page});},_this.handleChangeRowsPerPage=function(event){_this.setState({rowsPerPage:event.target.value});},_this.handleRequestSort=function(event,property){var orderBy=property;var order="desc";if(_this.state.orderBy===property&&_this.state.order==="desc"){order="asc";}_this.setState({order:order,orderBy:orderBy});},_this.handleClaim=function(b){},_this.handleRemove=function(){},_this.handleClick=function(event,id){_this.setState({anchorTop:event.clientY,anchorLeft:event.clientX});var openMenus=_this.state.openMenus.slice();openMenus.filter(function(x){return x.id===id;})[0].open=true;_this.setState({openMenus:openMenus,popoverOpen:true});},_this.handleClose=function(id){var openMenus=_this.state.openMenus.slice();openMenus.filter(function(x){return x.id===id;})[0].open=false;_this.setState({openMenus:openMenus,popoverOpen:false});},_this.toggleFilterItem=function(refetch,item){if(item!=="all"){var statuses=[].concat(_toConsumableArray(_this.state.statuses));if(statuses.includes(item)){statuses=statuses.filter(function(s){return s!==item;});}else{statuses.push(item);}_this.setState({statuses:statuses});refetch();_this.setState({refresh:true});}},_this.activateUser=function(refetch,user){if(!_this.checkAvailableSlots(user))return;var input={userId:user.su_ID,userType:user.type,token:Object(__WEBPACK_IMPORTED_MODULE_4_helpers_UserHelper__["c" /* GetUserToken */])()};_this.props.ActivateUser({variables:{input:input}}).then(function(resp){refetch();_this.setState({refresh:true});__WEBPACK_IMPORTED_MODULE_10_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__reducers_NotificationReducer__["d" /* showSnack */])({message:"User Activated",color:"success"}));}).catch(function(error){console.log("err",error);});},_this.deactivateUser=function(refetch,user){var input={userId:user.su_ID,userType:user.type,token:Object(__WEBPACK_IMPORTED_MODULE_4_helpers_UserHelper__["c" /* GetUserToken */])()};_this.props.DeactivateUser({variables:{input:input}}).then(function(resp){refetch();_this.setState({refresh:true});__WEBPACK_IMPORTED_MODULE_10_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__reducers_NotificationReducer__["d" /* showSnack */])({message:"User De-activated",color:"danger"}));}).catch(function(error){console.log("err",error);});},_this.declineUser=function(refetch,user){var input={userId:user.su_ID,userType:user.type,token:Object(__WEBPACK_IMPORTED_MODULE_4_helpers_UserHelper__["c" /* GetUserToken */])()};_this.props.DeclineUser({variables:{input:input}}).then(function(resp){refetch();_this.setState({refresh:true});__WEBPACK_IMPORTED_MODULE_10_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__reducers_NotificationReducer__["d" /* showSnack */])({message:"User Declined",color:"danger"}));}).catch(function(error){console.log("err",error);});},_this.deleteUser=function(refetch,user){var input={userId:user.su_ID,userType:user.type,token:Object(__WEBPACK_IMPORTED_MODULE_4_helpers_UserHelper__["c" /* GetUserToken */])()};_this.props.DeleteUser({variables:{input:input}}).then(function(resp){refetch();_this.setState({refresh:true});__WEBPACK_IMPORTED_MODULE_10_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__reducers_NotificationReducer__["d" /* showSnack */])({message:"User Deleted",color:"danger"}));}).catch(function(error){console.log("err",error);});},_this.openInviteDialog=function(){_this.setState({inviteDialogOpen:true});},_this.closeInviteDialog=function(refetch,willRefetch){_this.setState({inviteDialogOpen:false});if(willRefetch){refetch();}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(UserManagement,[{key:"getSorting",value:function getSorting(order,orderBy){return order==="desc"?function(a,b){return b[orderBy]<a[orderBy]?-1:1;}:function(a,b){return a[orderBy]<b[orderBy]?-1:1;};}},{key:"checkAvailableSlots",value:function checkAvailableSlots(user){var activeCount=0;var limit=userLimits[user.type];this.state.data.filter(function(u){return u.type===user.type;}).map(function(u){if(u.status===__WEBPACK_IMPORTED_MODULE_11__enums_user_management_js__["a" /* UserStatus */].Active)activeCount++;return u;});if(activeCount===limit){__WEBPACK_IMPORTED_MODULE_10_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__reducers_NotificationReducer__["b" /* alertWarning */])({open:true,title:"Not enough open slots",message:__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("div",{style:{width:"80%",margin:"auto",textAlign:"center"}},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{variant:"body1"},"Please ensure that there are sufficient amount of"," ",__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("strong",null,user.type)," slots available."))}));return false;}return true;}},{key:"render",value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_apollo__["Query"],{query:__WEBPACK_IMPORTED_MODULE_5_queries_UserManagement__["a" /* userManagement */],variables:{brokerageId:Object(__WEBPACK_IMPORTED_MODULE_4_helpers_UserHelper__["a" /* GetUserId */])(),token:Object(__WEBPACK_IMPORTED_MODULE_4_helpers_UserHelper__["c" /* GetUserToken */])(),statuses:this.state.statuses},fetchPolicy:"cache-and-network"},function(_ref2){var loading=_ref2.loading,error=_ref2.error,data=_ref2.data,refetch=_ref2.refetch;if(loading)return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__components_BaseTablePageContent_jsx__["a" /* default */],{handleSearch:function handleSearch(e){return;},title:"Brokerage Management",toggleFilterItem:function toggleFilterItem(item){return _this2.toggleFilterItem(refetch,item);},filters:_this2.state.statuses},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["B" /* LinearProgress */],null)));if(error&&error.message&&error.message==="GraphQL error: invalid token"){Object(__WEBPACK_IMPORTED_MODULE_4_helpers_UserHelper__["d" /* Logout */])();return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_router__["a" /* Redirect */],{to:"/app/portal/login"});}if(_this2.state.data.length!==data.UserManagement.length||_this2.state.refresh){_this2.setState({data:data.UserManagement,refresh:false});}var qData=[];if(_this2.state.searchData.length>0&&_this2.state.searchTerm!==""){qData=_this2.state.searchData.slice();}else{qData=data.UserManagement.slice();}if(_this2.state.orderBy!==""){qData.sort(_this2.getSorting(_this2.state.order,_this2.state.orderBy));}if(qData&&_this2.state.openMenus.length!==qData.length){var openMenus=[];qData.map(function(b){openMenus.push({open:false,id:b.su_ID});return b;});_this2.setState({openMenus:openMenus});}var activeCount={};data.UserManagement.map(function(u){if(u.status===__WEBPACK_IMPORTED_MODULE_11__enums_user_management_js__["a" /* UserStatus */].Active){if(!activeCount[u.type]){activeCount[u.type]=1;}else{activeCount[u.type]=activeCount[u.type]+1;}}return u;});//console.log('activeCount', activeCount);
return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__components_BaseTablePageContent_jsx__["a" /* default */],{handleSearch:_this2.handleSearch,title:"Brokerage Users",toggleFilterItem:function toggleFilterItem(item){return _this2.toggleFilterItem(refetch,item);},filters:_this2.state.statuses,typeDetails:{activeCount:activeCount,userLimits:userLimits},openInviteDialog:_this2.openInviteDialog},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Q" /* Table */],null,__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_EnhancedTableHead_EnhancedTableHead_jsx__["a" /* default */],{order:_this2.state.order,orderBy:_this2.state.orderBy,onRequestSort:_this2.handleRequestSort,rowCount:_this2.state.searchData.length<1&&_this2.state.searchTerm!==""?_this2.state.searchData.length:qData.length,columnData:columnData}),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["R" /* TableBody */],null,_this2.state.searchData.length<1&&_this2.state.searchTerm!==""?__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{colSpan:5},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("h3",null,"No results found"))):__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react___default.a.Fragment,null,_this2.state.searchTerm===""?__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{style:{padding:"0px"}}),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],null,Object(__WEBPACK_IMPORTED_MODULE_4_helpers_UserHelper__["b" /* GetUserKey */])("name")+" "+Object(__WEBPACK_IMPORTED_MODULE_4_helpers_UserHelper__["b" /* GetUserKey */])("surname")+" (You)")),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,Object(__WEBPACK_IMPORTED_MODULE_4_helpers_UserHelper__["b" /* GetUserKey */])("userEmail")),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,"Brokerage Admin")):null,qData.slice(_this2.state.page*_this2.state.rowsPerPage,_this2.state.page*_this2.state.rowsPerPage+_this2.state.rowsPerPage).map(function(user){var openMenu=_this2.state.openMenus.find(function(m){return m.id===user.su_ID;});return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],{key:user.su_ID,onClick:function onClick(e){return _this2.state.popoverOpen===false?_this2.handleClick(e,user.su_ID):null;},className:__WEBPACK_IMPORTED_MODULE_1_classnames___default()("sqDataTable",user.status===__WEBPACK_IMPORTED_MODULE_11__enums_user_management_js__["a" /* UserStatus */].Inactive?"disabledRow":null),style:openMenu&&openMenu.open?{backgroundColor:"#dedede"}:{}},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{style:{padding:"0px",borderRight:"1px solid #e0e0e0",backgroundColor:"white"}},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["x" /* IconButton */],{onClick:function onClick(e){return _this2.state.popoverOpen===false?_this2.handleClick(e,user.su_ID):null;}},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["w" /* Icon */],null,"more_vert"))),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("div",{style:{display:"flex"}},user.status===__WEBPACK_IMPORTED_MODULE_11__enums_user_management_js__["a" /* UserStatus */].Active?__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["w" /* Icon */],{style:{color:"#25b125"}},"account_circle"),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{variant:"caption",style:{marginLeft:"8px",top:"4px",position:"relative"}},"Active")):null,user.status===__WEBPACK_IMPORTED_MODULE_11__enums_user_management_js__["a" /* UserStatus */].Inactive?__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["w" /* Icon */],{style:{color:"#da5858b8"}},"account_circle"),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{variant:"caption",style:{marginLeft:"8px",top:"4px",position:"relative"}},"Inactive")):null,user.status===__WEBPACK_IMPORTED_MODULE_11__enums_user_management_js__["a" /* UserStatus */].Requested?__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["w" /* Icon */],{style:{color:"#84848494"}},"help_outline"),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{variant:"caption",style:{marginLeft:"8px",top:"4px",position:"relative"}},"Requested")):null)),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,user.su_name," ",user.su_surname),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,user.su_email),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,user.type),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["J" /* Popover */],{open:_this2.state.openMenus.length>0&&_this2.state.openMenus.filter(function(m){return m.id===user.su_ID;}).length>0?_this2.state.openMenus.filter(function(m){return m.id===user.su_ID;})[0].open:false,anchorReference:"anchorPosition",anchorPosition:{left:_this2.state.anchorLeft,top:_this2.state.anchorTop},onClose:function onClose(){return _this2.handleClose(user.su_ID);}},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["C" /* List */],{component:"nav"},user.status===__WEBPACK_IMPORTED_MODULE_11__enums_user_management_js__["a" /* UserStatus */].Active?__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["D" /* ListItem */],{button:true,onClick:function onClick(){_this2.handleClose(user.su_ID);_this2.deactivateUser(refetch,user);}},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["E" /* ListItemText */],{primary:"Deactivate"})):user.status===__WEBPACK_IMPORTED_MODULE_11__enums_user_management_js__["a" /* UserStatus */].Requested?__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["D" /* ListItem */],{button:true,onClick:function onClick(){_this2.handleClose(user.su_ID);_this2.activateUser(refetch,user);}},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["E" /* ListItemText */],{primary:"Activate"})),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["D" /* ListItem */],{button:true,onClick:function onClick(){_this2.handleClose(user.su_ID);_this2.declineUser(refetch,user);}},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["E" /* ListItemText */],{primary:"Decline"}))):__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["D" /* ListItem */],{button:true,onClick:function onClick(){_this2.handleClose(user.su_ID);_this2.activateUser(refetch,user);}},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["E" /* ListItemText */],{primary:"Activate"})),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["D" /* ListItem */],{button:true,onClick:function onClick(){_this2.handleClose(user.su_ID);_this2.deleteUser(refetch,user);}},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["E" /* ListItemText */],{primary:"Delete"}))))));})),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["U" /* TablePagination */],{count:_this2.state.searchData.length<1&&_this2.state.searchTerm!==""?_this2.state.searchData.length:qData.length,rowsPerPage:_this2.state.rowsPerPage,page:_this2.state.page,backIconButtonProps:{"aria-label":"Previous Page"},nextIconButtonProps:{"aria-label":"Next Page"},onChangePage:_this2.handleChangePage,onChangeRowsPerPage:_this2.handleChangeRowsPerPage}))))),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__components_InviteUsersModal__["a" /* default */],{open:_this2.state.inviteDialogOpen,onClose:function onClose(willRefetch){return _this2.closeInviteDialog(refetch,willRefetch);},activeCount:{broker:activeCount["broker"]?activeCount["broker"]:0,assistant:activeCount["assistant"]?activeCount["assistant"]:0},userLimits:userLimits}));});}}]);return UserManagement;}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]);UserManagement=Object(__WEBPACK_IMPORTED_MODULE_8_react_apollo__["compose"])(Object(__WEBPACK_IMPORTED_MODULE_8_react_apollo__["graphql"])(__WEBPACK_IMPORTED_MODULE_6_queries_user_management_ChangeUserStatus__["a" /* ActivateUser */],{name:"ActivateUser"}),Object(__WEBPACK_IMPORTED_MODULE_8_react_apollo__["graphql"])(__WEBPACK_IMPORTED_MODULE_6_queries_user_management_ChangeUserStatus__["b" /* DeactivateUser */],{name:"DeactivateUser"}),Object(__WEBPACK_IMPORTED_MODULE_8_react_apollo__["graphql"])(__WEBPACK_IMPORTED_MODULE_6_queries_user_management_ChangeUserStatus__["c" /* DeclineUser */],{name:"DeclineUser"}),Object(__WEBPACK_IMPORTED_MODULE_8_react_apollo__["graphql"])(__WEBPACK_IMPORTED_MODULE_6_queries_user_management_ChangeUserStatus__["d" /* DeleteUser */],{name:"DeleteUser"}))(UserManagement);/* harmony default export */ __webpack_exports__["a"] = (UserManagement);

/***/ }),
/* 2467 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return userManagement; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_graphql_tag__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_graphql_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_graphql_tag__);
var _templateObject=_taggedTemplateLiteral(["\n  query userManagement(\n    $brokerageId: String!\n    $token: String!\n    $statuses: [String]!\n  ) {\n    UserManagement(\n      brokerageId: $brokerageId\n      token: $token\n      statuses: $statuses\n    ) {\n      su_ID\n      su_name\n      su_surname\n      su_email\n      status\n      type\n    }\n  }\n"],["\n  query userManagement(\n    $brokerageId: String!\n    $token: String!\n    $statuses: [String]!\n  ) {\n    UserManagement(\n      brokerageId: $brokerageId\n      token: $token\n      statuses: $statuses\n    ) {\n      su_ID\n      su_name\n      su_surname\n      su_email\n      status\n      type\n    }\n  }\n"]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var userManagement=__WEBPACK_IMPORTED_MODULE_0_graphql_tag___default()(_templateObject);

/***/ }),
/* 2468 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_core__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_icons__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Grid_GridItem_jsx__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__enums_user_management_js__ = __webpack_require__(629);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var BaseTablePageContent=function(_React$Component){_inherits(BaseTablePageContent,_React$Component);function BaseTablePageContent(){var _ref;var _temp,_this,_ret;_classCallCheck(this,BaseTablePageContent);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=BaseTablePageContent.__proto__||Object.getPrototypeOf(BaseTablePageContent)).call.apply(_ref,[this].concat(args))),_this),_this.state={filterEl:null},_this.handlePopoverClose=function(name){_this.setState(_defineProperty({},name,null));},_this.handlePopoverOpen=function(event,name){_this.setState(_defineProperty({},name,event.currentTarget));},_this.calculateUserSlots=function(){var activeCount=Object.assign({},_this.props.typeDetails.activeCount);var limit=Object.assign({},_this.props.typeDetails.userLimits);var userSlots=[];Object.keys(activeCount).map(function(k){var typename=k;typename=typename.charAt(0).toUpperCase()+typename.substring(1);userSlots.push({type:typename,slots:limit[k]-activeCount[k]});return k;});return userSlots;},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(BaseTablePageContent,[{key:"render",value:function render(){var _this2=this;var userSlots=this.props.typeDetails?this.calculateUserSlots():null;return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{container:true},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:10,style:{flexBasis:"100%",maxWidth:"100%",margin:'auto'}},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["e" /* Card */],null,__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["f" /* CardContent */],null,__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{variant:"headline",className:"centerCell"},this.props.title),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div",{style:{borderBottom:"1px solid #cccccc69",margin:"5px auto",width:"25%",marginBottom:"20px"}})),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{container:true,justify:"space-between",style:{marginBottom:"15px"}},this.props.typeDetails?__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{item:true,xs:12,sm:12,md:4},userSlots.map(function(u){return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{variant:"caption",gutterBottom:true},u.type+" ","Slots: ",__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("strong",null," "+u.slots));})):null,__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{item:true,xs:12,sm:12,md:2},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["I" /* Paper */],{className:"flabButton",onClick:function onClick(e){return _this2.handlePopoverOpen(e,"filterEl");}},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div",{style:{display:"flex"}},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],null,"Filter"),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["w" /* Icon */],null,"arrow_drop_down"))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["J" /* Popover */],{open:Boolean(this.state.filterEl),anchorEl:this.state.filterEl,onClose:function onClose(){return _this2.handlePopoverClose("filterEl");},anchorOrigin:{vertical:"bottom",horizontal:"center"},transformOrigin:{vertical:"top",horizontal:"center"}},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["C" /* List */],{component:"nav"},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["D" /* ListItem */],{button:true,onClick:function onClick(e){return _this2.props.toggleFilterItem(__WEBPACK_IMPORTED_MODULE_5__enums_user_management_js__["a" /* UserStatus */].Active);}},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["h" /* Checkbox */],{checked:this.props.filters.includes(__WEBPACK_IMPORTED_MODULE_5__enums_user_management_js__["a" /* UserStatus */].Active),onChange:function onChange(e){return _this2.props.toggleFilterItem(__WEBPACK_IMPORTED_MODULE_5__enums_user_management_js__["a" /* UserStatus */].Active);}}),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{variant:"subheading",style:{marginLeft:"10px",marginRight:"10px"}},"Active")),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["p" /* Divider */],null),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["D" /* ListItem */],{button:true,onClick:function onClick(e){return _this2.props.toggleFilterItem(__WEBPACK_IMPORTED_MODULE_5__enums_user_management_js__["a" /* UserStatus */].Requested);}},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["h" /* Checkbox */],{checked:this.props.filters.includes(__WEBPACK_IMPORTED_MODULE_5__enums_user_management_js__["a" /* UserStatus */].Requested),onChange:function onChange(e){return _this2.props.toggleFilterItem(__WEBPACK_IMPORTED_MODULE_5__enums_user_management_js__["a" /* UserStatus */].Requested);}}),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{variant:"subheading",style:{marginLeft:"10px",marginRight:"10px"}},"Requested")),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["p" /* Divider */],null),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["D" /* ListItem */],{button:true,onClick:function onClick(e){return _this2.props.toggleFilterItem(__WEBPACK_IMPORTED_MODULE_5__enums_user_management_js__["a" /* UserStatus */].Inactive);}},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["h" /* Checkbox */],{checked:this.props.filters.includes(__WEBPACK_IMPORTED_MODULE_5__enums_user_management_js__["a" /* UserStatus */].Inactive),onChange:function onChange(e){return _this2.props.toggleFilterItem(__WEBPACK_IMPORTED_MODULE_5__enums_user_management_js__["a" /* UserStatus */].Inactive);}}),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{variant:"subheading",style:{marginLeft:"10px",marginRight:"10px"}},"Inactive")))))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["I" /* Paper */],{style:{overflowX:"auto"}},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{container:true},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{item:true,xs:12,sm:12,md:10,style:{margin:"0 auto"}},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{container:true},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{item:true,xs:6,sm:4,md:3,style:{margin:"25px auto 0px auto"}},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["i" /* Chip */],{avatar:__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["b" /* Avatar */],{style:{backgroundColor:"#6c5cab",color:"white"}},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["w" /* Icon */],null,"add")),className:"customChip",variant:"outlined",label:__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{color:"white"}},"Invite Users"),color:"secondary",style:{backgroundColor:"#4239d659",color:"white",width:"100%"},onClick:function onClick(){return _this2.props.openInviteDialog();}}))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["X" /* TextField */],{id:"input-with-icon-textfield",fullWidth:true,style:{padding:"30px"},placeholder:"Search by Name, Surname, or Email",onChange:this.props.handleSearch,InputProps:{startAdornment:__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["z" /* InputAdornment */],{position:"start"},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_icons__["n" /* Search */],null))}}))),this.props.children)))));}}]);return BaseTablePageContent;}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (BaseTablePageContent);

/***/ }),
/* 2469 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_core__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_Wrappers_materialUIWrappers_components_FormInput__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_helpers_UserHelper__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_queries_user_management_ChangeUserStatus__ = __webpack_require__(628);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_apollo__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_redux_form__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_store__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__reducers_NotificationReducer__ = __webpack_require__(30);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/*eslint-disable*/var required=function required(value){return value?undefined:"Required";};var email=function email(value){if(!value)return undefined;var mailformat=/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;return value.match(mailformat)?undefined:"Not a Valid Email Addres";};var initialState={users:{brokers:[],assistants:[]},checkValidation:false,addedUsers:{broker:0,assistant:0}};var InviteUsersModal=function(_React$Component){_inherits(InviteUsersModal,_React$Component);function InviteUsersModal(){var _ref;var _temp,_this,_ret;_classCallCheck(this,InviteUsersModal);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=InviteUsersModal.__proto__||Object.getPrototypeOf(InviteUsersModal)).call.apply(_ref,[this].concat(args))),_this),_this.state=Object.assign({},initialState),_this.closeDialog=function(){var willRefetch=arguments.length>0&&arguments[0]!==undefined?arguments[0]:false;_this.setState(Object.assign({},initialState));_this.props.onClose(willRefetch);},_this.addUser=function(userType,userTypeEx){var users=[].concat(_toConsumableArray(_this.state.users[userType]));if(!_this.checkAvailableSlots(userTypeEx,users.length))return;var id=0;if(users.length>0){var max=Math.max.apply(Math,users.map(function(b){return b.id;}));id=max+1;}users.push({id:id,component:function component(checkValidation){return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement("div",{style:{display:"flex"}},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["d" /* Button */],{variant:"fab",mini:true,className:"smallFab",style:{position:"relative",top:"15px",marginRight:"15px"},onClick:function onClick(){return _this.removeUser(id,userType,userTypeEx);}},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["w" /* Icon */],null,"delete")),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["t" /* FormControl */],{fullWidth:true},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_2_components_Wrappers_materialUIWrappers_components_FormInput__["a" /* default */],isrequired:true,validate:[required,email],checkValidation:checkValidation,name:userType+"."+id+".email",label:"Email *"})));}});var usersObj=Object.assign({},_this.state.users);usersObj[userType]=users;var addedUsers=Object.assign({},_this.state.addedUsers);addedUsers[userTypeEx]=addedUsers[userTypeEx]+1;_this.setState({users:usersObj,addedUsers:addedUsers});},_this.removeUser=function(id,userType,userTypeEx){var users=[].concat(_toConsumableArray(_this.state.users[userType]));users=users.filter(function(b){return b.id!==id;});var usersObj=Object.assign({},_this.state.users);usersObj[userType]=users;var addedUsers=Object.assign({},_this.state.addedUsers);addedUsers[userTypeEx]=addedUsers[userTypeEx]-1;_this.setState({users:usersObj,addedUsers:addedUsers});__WEBPACK_IMPORTED_MODULE_9_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_8_redux_form__["g" /* unregisterField */])("InviteUsersModal",userType+"."+id));__WEBPACK_IMPORTED_MODULE_9_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_8_redux_form__["b" /* change */])("InviteUsersModal",userType+"."+id,null));__WEBPACK_IMPORTED_MODULE_9_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_8_redux_form__["h" /* untouch */])("InviteUsersModal",userType+"."+id));},_this.onInvite=function(){if(__WEBPACK_IMPORTED_MODULE_9_store__["a" /* default */].getState().form.InviteUsersModal.syncErrors){__WEBPACK_IMPORTED_MODULE_9_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__reducers_NotificationReducer__["d" /* showSnack */])({message:"Invalid Information",color:"danger"}));_this.setState({checkValidation:true});_this.forceUpdate();return;}var brokers=__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(__WEBPACK_IMPORTED_MODULE_9_store__["a" /* default */].getState().form,"InviteUsersModal.values.brokers",[]);var assistants=__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(__WEBPACK_IMPORTED_MODULE_9_store__["a" /* default */].getState().form,"InviteUsersModal.values.assistants",[]);var input={brokerageId:Object(__WEBPACK_IMPORTED_MODULE_3_helpers_UserHelper__["a" /* GetUserId */])(),token:Object(__WEBPACK_IMPORTED_MODULE_3_helpers_UserHelper__["c" /* GetUserToken */])(),inviteList:{brokers:brokers,assistants:assistants}};_this.props.InviteUsers({variables:{input:input}}).then(function(resp){__WEBPACK_IMPORTED_MODULE_9_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__reducers_NotificationReducer__["e" /* successWarning */])({open:true,title:"Users Invited!",onConfirm:function onConfirm(){return _this.closeDialog(true);}}));}).catch(function(error){console.log("err",error);});},_this.calculateUserSlots=function(){var activeCount=Object.assign({},_this.props.activeCount);var limit=Object.assign({},_this.props.userLimits);var userSlots=[];Object.keys(activeCount).map(function(k){var typename=k;typename=typename.charAt(0).toUpperCase()+typename.substring(1);userSlots.push({type:typename,slots:limit[k]-(activeCount[k]+_this.state.addedUsers[k])});return k;});return userSlots;},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(InviteUsersModal,[{key:"checkAvailableSlots",value:function checkAvailableSlots(userType,addedUsers){var activeCount=this.props.activeCount[userType]+addedUsers;var limit=this.props.userLimits[userType];if(activeCount>=limit){__WEBPACK_IMPORTED_MODULE_9_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__reducers_NotificationReducer__["d" /* showSnack */])({message:"Not enough "+userType+" slots available.",color:"danger"}));return false;}return true;}},{key:"render",value:function render(){var _this2=this;var userSlots=this.calculateUserSlots();return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["k" /* Dialog */],{open:this.props.open,onClose:function onClose(){return _this2.closeDialog();},"aria-labelledby":"form-dialog-title",className:"centerFixedDialog"},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["o" /* DialogTitle */],{id:"form-dialog-title",style:{textAlign:"center"}},"Invite Users",__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement("div",{style:{borderBottom:"1px solid #cccccc69",margin:"5px auto",width:"25%"}}),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{variant:"caption",style:{marginBottom:"5px"}}," Invite Brokers and/or Assistants to your Brokerage to use Sure Quote")),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["m" /* DialogContent */],null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{container:true},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:6,style:{marginBottom:"25px"}},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["e" /* Card */],{style:{height:"300px",maxHeight:"300px",overflowY:"auto"}},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["f" /* CardContent */],null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{container:true},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:12,style:{margin:"0px auto 15px auto",textAlign:"center"}},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{variant:"subheading"},"Brokers"),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{variant:"caption"},"Slots:"," ",userSlots.find(function(u){return u.type==="Broker";}).slots)),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:12,style:{margin:"0px auto",textAlign:"center"}},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["i" /* Chip */],{label:"Add",onClick:function onClick(){return _this2.addUser("brokers","broker");}})),this.state.users.brokers.map(function(b){return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{item:true,xs:12,sm:12,md:12,style:{margin:"0px auto",textAlign:"center"}},b.component(_this2.state.checkValidation));}))))),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:6},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["e" /* Card */],{style:{height:"300px",maxHeight:"300px",overflowY:"auto"}},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["f" /* CardContent */],null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{container:true},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:12,style:{margin:"0px auto 15px auto",textAlign:"center"}},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{variant:"subheading"},"Assistants"),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{variant:"caption"},"Slots:"," ",userSlots.find(function(u){return u.type==="Assistant";}).slots)),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:12,style:{margin:"0px auto",textAlign:"center"}},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["i" /* Chip */],{label:"Add",onClick:function onClick(){return _this2.addUser("assistants","assistant");}})),this.state.users.assistants.map(function(a){return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{item:true,xs:12,sm:12,md:12,style:{margin:"0px auto",textAlign:"center"}},a.component(_this2.state.checkValidation));}))))))),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["l" /* DialogActions */],null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["d" /* Button */],{onClick:function onClick(){return _this2.closeDialog();},color:"primary"},"Cancel"),this.state.users.brokers.length>0||this.state.users.assistants.length>0?__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["d" /* Button */],{color:"primary",onClick:function onClick(){return _this2.onInvite();}}," ","Invite"):null)));}}]);return InviteUsersModal;}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);InviteUsersModal=Object(__WEBPACK_IMPORTED_MODULE_8_redux_form__["e" /* reduxForm */])({form:"InviteUsersModal",destroyOnUnmount:true})(InviteUsersModal);InviteUsersModal=Object(__WEBPACK_IMPORTED_MODULE_7_react_apollo__["compose"])(Object(__WEBPACK_IMPORTED_MODULE_7_react_apollo__["graphql"])(__WEBPACK_IMPORTED_MODULE_5_queries_user_management_ChangeUserStatus__["e" /* InviteUsers */],{name:"InviteUsers"}))(InviteUsersModal);/* harmony default export */ __webpack_exports__["a"] = (InviteUsersModal);

/***/ }),
/* 2470 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_core__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles_withStyles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_Typography__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_Typography___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Typography__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_apollo_cache_inmemory__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_apollo_client__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_apollo_upload_client__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_assets_img_faces_avatar1_jpg__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_assets_img_faces_avatar1_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_assets_img_faces_avatar1_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_assets_jss_material_dashboard_pro_react_views_userProfileStyles_jsx__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_Card_Card_jsx__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_Card_CardAvatar_jsx__ = __webpack_require__(382);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_Card_CardBody_jsx__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_Grid_GridItem_jsx__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_constants_js__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_graphql_tag__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_graphql_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_graphql_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_helpers_UserHelper__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_queries_profileQuery__ = __webpack_require__(605);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_queries_updatePassword__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_queries_Profile_mutations__ = __webpack_require__(252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_react_apollo__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_react_dropzone__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_react_redux__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_react_router__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_reducers_LoginReducer__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_store__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_reducers_NotificationReducer__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_redux_form__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_components_Wrappers_materialUIWrappers_components_FormInput__ = __webpack_require__(24);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(["\n  mutation($file: Upload!, $id: String!) {\n    uploadFileWithId(file: $file, id: $id)\n  }\n"],["\n  mutation($file: Upload!, $id: String!) {\n    uploadFileWithId(file: $file, id: $id)\n  }\n"]);function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}/*eslint-disable*/// @material-ui/core components
// core components
//import "./profilePage.css";
var CHANGEAVATAR="sure-quote/Login/CHANGEAVATAR";var client=new __WEBPACK_IMPORTED_MODULE_5_apollo_client__["ApolloClient"]({link:Object(__WEBPACK_IMPORTED_MODULE_6_apollo_upload_client__["a" /* createUploadLink */])({uri:__WEBPACK_IMPORTED_MODULE_13_constants_js__["d" /* fileUploadServerPath */]}),cache:new __WEBPACK_IMPORTED_MODULE_4_apollo_cache_inmemory__["a" /* InMemoryCache */]()});var uploadFileMutation=__WEBPACK_IMPORTED_MODULE_14_graphql_tag___default()(_templateObject);function isEmptyOrSpaces(str){return str===undefined||str===null||str.match(/^ *$/)!==null;}var required=function required(value){return value?undefined:"Required";};var AssistantProfile=function(_Component){_inherits(AssistantProfile,_Component);function AssistantProfile(){var _ref;var _temp,_this,_ret;_classCallCheck(this,AssistantProfile);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=AssistantProfile.__proto__||Object.getPrototypeOf(AssistantProfile)).call.apply(_ref,[this].concat(args))),_this),_this.state={value:0,open:false,avatarPath:"",oldPassword:"",newPassword:"",confirmNewPassword:""},_this.handleStateChange=function(event,prop){_this.setState(_defineProperty({},prop,event.target.value));},_this.handleChangePasswordOld=function(event){_this.setState({oldPassword:event.target.value});},_this.handleChangePasswordNew=function(event){_this.setState({newPassword:event.target.value});},_this.handleChangePasswordNewConfirm=function(event){_this.setState({confirmNewPassword:event.target.value});},_this.handleClickOpenDialog=function(){_this.setState({open:true});},_this.handleCloseDialog=function(){_this.setState({open:false,confirmNewPassword:"",newPassword:"",oldPassword:""});},_this.initializeForm=function(profile){_this.props.initialize({email:profile.email,name:profile.name,surname:profile.surname,phoneNumber:profile.phoneNumber});_this.setState({formInitiazed:true});},_this.saveChanges=function(){if(__WEBPACK_IMPORTED_MODULE_25_store__["a" /* default */].getState().form.AssistantProfile.syncErrors){__WEBPACK_IMPORTED_MODULE_25_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_26_reducers_NotificationReducer__["d" /* showSnack */])({message:"Invalid Information",color:"danger"}));_this.setState({checkValidation:true});_this.forceUpdate();}else{_this.setState({checkValidation:false});var input={userId:Object(__WEBPACK_IMPORTED_MODULE_15_helpers_UserHelper__["a" /* GetUserId */])(),data:__WEBPACK_IMPORTED_MODULE_25_store__["a" /* default */].getState().form.AssistantProfile.values,token:Object(__WEBPACK_IMPORTED_MODULE_15_helpers_UserHelper__["c" /* GetUserToken */])()};_this.props.AssistantProfileUpdate({variables:{input:input}}).then(function(resp){__WEBPACK_IMPORTED_MODULE_25_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_26_reducers_NotificationReducer__["e" /* successWarning */])({open:true,title:"Profile Updated."}));}).catch(function(error){__WEBPACK_IMPORTED_MODULE_25_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_26_reducers_NotificationReducer__["d" /* showSnack */])({message:"There was an error updating your profile : "+error,color:"danger"}));});}},_this.handleResetPassword=function(){if(isEmptyOrSpaces(_this.state.newPassword)||isEmptyOrSpaces(_this.state.confirmNewPassword)||isEmptyOrSpaces(_this.state.oldPassword)){__WEBPACK_IMPORTED_MODULE_25_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_26_reducers_NotificationReducer__["d" /* showSnack */])({message:"Password cannot be empty.",color:"danger"}));}else if(_this.state.newPassword!==_this.state.confirmNewPassword){__WEBPACK_IMPORTED_MODULE_25_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_26_reducers_NotificationReducer__["d" /* showSnack */])({message:"Password do not match.",color:"danger"}));}else{var input={oldPass:_this.state.oldPassword,newPass:_this.state.newPassword,brokerId:Object(__WEBPACK_IMPORTED_MODULE_15_helpers_UserHelper__["a" /* GetUserId */])(),token:Object(__WEBPACK_IMPORTED_MODULE_15_helpers_UserHelper__["c" /* GetUserToken */])()};_this.props.updatePassword({variables:{input:input}}).then(function(resp){__WEBPACK_IMPORTED_MODULE_25_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_26_reducers_NotificationReducer__["e" /* successWarning */])({open:true,title:"Updated Successfully.",onConfirm:function onConfirm(){return _this.setState({open:false});}}));}).catch(function(error){__WEBPACK_IMPORTED_MODULE_25_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_26_reducers_NotificationReducer__["d" /* showSnack */])({message:"There was an error updating your information : "+error,color:"danger"}));});}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(AssistantProfile,[{key:"render",value:function render(){var _this2=this;var value=this.state.value;var classes=this.props.classes;if(this.props.data.loading){return __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["B" /* LinearProgress */],null);}var data=this.props.data;if(data.error&&data.error.message&&data.error.message==="GraphQL error: invalid token"){Object(__WEBPACK_IMPORTED_MODULE_15_helpers_UserHelper__["d" /* Logout */])();return __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23_react_router__["a" /* Redirect */],{to:"/app/portal/login"});}console.log("data",data);var profile=JSON.parse(data.AssistantProfile[0].profile);if(!this.state.formInitiazed){this.initializeForm(profile);}var avatarPath=__WEBPACK_IMPORTED_MODULE_7_assets_img_faces_avatar1_jpg___default.a;if(this.state.avatarPath!==""){avatarPath=this.state.avatarPath;}else if(profile.su_pp_path!==null&&profile.su_pp_path!==""){avatarPath=profile.su_pp_path;}return __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{container:true},__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:10,md:8,style:{flexBasis:"100%",maxWidth:"100%",margin:'auto'}},__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Card_Card_jsx__["a" /* default */],{profile:true},__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_Card_CardAvatar_jsx__["a" /* default */],{profile:true,className:"avatarBackground"},__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement("img",{src:avatarPath,alt:"...",style:{width:"130px",height:"130px"}})),__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Card_CardBody_jsx__["a" /* default */],{profile:true},__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20_react_apollo__["Mutation"],{client:client,mutation:uploadFileMutation,onCompleted:function onCompleted(data){_this2.setState({avatarPath:data.uploadFileWithId});__WEBPACK_IMPORTED_MODULE_25_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_24_reducers_LoginReducer__["c" /* changeAvatar */])({type:CHANGEAVATAR,props:data.uploadFileWithId}));}},function(mutate){return __WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement("div",{style:{width:"100%",textAlign:"center",display:"block"}},__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21_react_dropzone__["a" /* default */],{style:{width:"fit-content",height:"fit-content",border:"none",margin:"0px auto"},onDrop:function onDrop(_ref2){var _ref3=_slicedToArray(_ref2,1),file=_ref3[0];return mutate({variables:{file:file,id:__WEBPACK_IMPORTED_MODULE_25_store__["a" /* default */].getState().login.userID}});}},__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["i" /* Chip */],{avatar:__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["b" /* Avatar */],{style:{backgroundColor:"#6c5cab",color:"white"}},__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["w" /* Icon */],null,"edit")),variant:"outlined",label:__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Typography___default.a,{style:{color:"white"}},"Edit Picture"),color:"secondary",style:{backgroundColor:"#a59fff",color:"white",position:"relative",top:"-38px",cursor:"pointer"}})));}),__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement("h2",{className:classes.cardTitle},profile.name," ",profile.surname),__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement("h4",{className:classes.cardTitle,style:{color:"#858a90"}},profile.brokerage),__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{direction:"row",container:true,style:{flexBasis:"100%",maxWidth:"100%",margin:'auto'}},__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:8,style:{flexBasis:"100%",maxWidth:"100%",margin:'auto'}},__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{direction:"column",container:true},__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:12},__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["t" /* FormControl */],{fullWidth:true,className:"spacedFormControl"},__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_28_components_Wrappers_materialUIWrappers_components_FormInput__["a" /* default */],checkValidation:this.state.checkValidation,name:"email",label:"User Email",readOnly:true}))),__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:12},__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["t" /* FormControl */],{fullWidth:true,className:"spacedFormControl"},__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_28_components_Wrappers_materialUIWrappers_components_FormInput__["a" /* default */],checkValidation:this.state.checkValidation,name:"name",label:"Name",validate:[required]}))),__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:12},__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["t" /* FormControl */],{fullWidth:true,className:"spacedFormControl"},__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_28_components_Wrappers_materialUIWrappers_components_FormInput__["a" /* default */],checkValidation:this.state.checkValidation,name:"surname",label:"Surname",validate:[required]}))),__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:12},__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["t" /* FormControl */],{fullWidth:true,className:"spacedFormControl"},__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_28_components_Wrappers_materialUIWrappers_components_FormInput__["a" /* default */],checkValidation:this.state.checkValidation,name:"phoneNumber",label:"Phone Number"}))))),__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:12,style:{marginTop:"50px",textAlign:"center"}},__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["d" /* Button */],{variant:"outlined",className:"outlinedButton",onClick:function onClick(){return _this2.saveChanges();},style:{color:"#55526f",margin:"0px auto"}},"Save Changes",__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["w" /* Icon */],{style:{marginLeft:"5px"}},"check"))),__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:12,style:{marginTop:"35px",textAlign:"center"}},__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Typography___default.a,{variant:"body1",style:{color:"#0000008a"},className:"typographyLinkBasic",onClick:this.handleClickOpenDialog},"Reset Password"),__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["k" /* Dialog */],{open:this.state.open,onClose:this.handleCloseDialog,"aria-labelledby":"form-dialog-title",className:"centerFixedDialog"},__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["o" /* DialogTitle */],{id:"form-dialog-title"},"Reset Password"),__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["m" /* DialogContent */],null,__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["X" /* TextField */],{label:"Old Password",fullWidth:true,onChange:function onChange(e){return _this2.handleStateChange(e,"oldPassword");},value:this.state.oldPassword,autoComplete:"off",type:"password"}),__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["X" /* TextField */],{label:"New Password",fullWidth:true,onChange:function onChange(e){return _this2.handleStateChange(e,"newPassword");},value:this.state.newPassword,autoComplete:"off",type:"password"}),__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["X" /* TextField */],{label:"Confirm New Password",fullWidth:true,onChange:function onChange(e){return _this2.handleStateChange(e,"confirmNewPassword");},value:this.state.confirmNewPassword,autoComplete:"off",type:"password"})),__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["l" /* DialogActions */],null,__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["d" /* Button */],{onClick:this.handleCloseDialog,color:"primary"},"Cancel"),__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["d" /* Button */],{onClick:this.handleResetPassword,color:"primary"},"SAVE"))))))))));}}]);return AssistantProfile;}(__WEBPACK_IMPORTED_MODULE_19_react__["Component"]);AssistantProfile=Object(__WEBPACK_IMPORTED_MODULE_20_react_apollo__["graphql"])(__WEBPACK_IMPORTED_MODULE_16_queries_profileQuery__["a" /* assistantProfileQuery */],{options:function options(){return{fetchPolicy:"network-only"};},props:function props(_props){if(_props.data.error){}return Object.assign({},_props);}})(AssistantProfile);AssistantProfile=Object(__WEBPACK_IMPORTED_MODULE_22_react_redux__["b" /* connect */])(function(state){return{userId:Object(__WEBPACK_IMPORTED_MODULE_15_helpers_UserHelper__["a" /* GetUserId */])(),token:Object(__WEBPACK_IMPORTED_MODULE_15_helpers_UserHelper__["c" /* GetUserToken */])()};})(AssistantProfile);AssistantProfile=Object(__WEBPACK_IMPORTED_MODULE_27_redux_form__["e" /* reduxForm */])({form:"AssistantProfile",destroyOnUnmount:true})(AssistantProfile);AssistantProfile=Object(__WEBPACK_IMPORTED_MODULE_20_react_apollo__["compose"])(Object(__WEBPACK_IMPORTED_MODULE_20_react_apollo__["graphql"])(__WEBPACK_IMPORTED_MODULE_17_queries_updatePassword__["a" /* updatePassword */],{name:"updatePassword"}),Object(__WEBPACK_IMPORTED_MODULE_20_react_apollo__["graphql"])(__WEBPACK_IMPORTED_MODULE_18_queries_Profile_mutations__["a" /* AssistantProfileUpdate */],{name:"AssistantProfileUpdate"}))(AssistantProfile);/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles_withStyles___default()(__WEBPACK_IMPORTED_MODULE_8_assets_jss_material_dashboard_pro_react_views_userProfileStyles_jsx__["a" /* default */])(AssistantProfile));

/***/ }),
/* 2471 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_core__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_EnhancedTableHead_EnhancedTableHead_jsx__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_Snackbar_Snackbar_jsx__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_helpers_UserHelper__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_helpers_Search__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_apollo__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_router__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_BaseTablePageContent_jsx__ = __webpack_require__(272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_queries_assistant_Broker_Assignment_BrokerAssignment_js__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_queries_assistant_Broker_Assignment_Mutations__ = __webpack_require__(2472);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}//Q&Ms
var columnData=[{id:"edit",numeric:false,disablePadding:true,label:"",noSort:true,width:"30px"},{id:"ab_Id",numeric:false,disablePadding:true,label:"Status",noSort:true},{id:"su_name",numeric:false,disablePadding:true,label:"Name"},{id:"su_email",numeric:false,disablePadding:true,label:"Email"}];var BrokerAssignment=function(_Component){_inherits(BrokerAssignment,_Component);function BrokerAssignment(){var _ref;var _temp,_this,_ret;_classCallCheck(this,BrokerAssignment);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=BrokerAssignment.__proto__||Object.getPrototypeOf(BrokerAssignment)).call.apply(_ref,[this].concat(args))),_this),_this.state={page:0,rowsPerPage:10,order:"desc",orderBy:"Name",searchTerm:"",loadingSearch:false,data:[],searchData:[],openMenus:[],anchorTop:0,anchorLeft:0,popoverOpen:false,br:false,snackBarColor:"",snackBarText:"",statuses:[0,1,2,3]},_this.handleSearch=function(event){_this.setState({searchTerm:event.target.value});var values=event.target.value.split(" ");var brokers=_this.state.data;var inc=["su_name","su_surname","su_email"];var filteredData=Object(__WEBPACK_IMPORTED_MODULE_4_helpers_Search__["a" /* SearchDataSet */])(brokers,values,inc);_this.setState({searchData:filteredData});},_this.handleChangePage=function(event,page){_this.setState({page:page});},_this.handleChangeRowsPerPage=function(event){_this.setState({rowsPerPage:event.target.value});},_this.handleRequestSort=function(event,property){var orderBy=property;var order="desc";if(_this.state.orderBy===property&&_this.state.order==="desc"){order="asc";}_this.setState({order:order,orderBy:orderBy});},_this.handleClaim=function(b){},_this.handleRemove=function(){},_this.handleClick=function(event,id){_this.setState({anchorTop:event.clientY,anchorLeft:event.clientX});var openMenus=_this.state.openMenus.slice();openMenus.filter(function(x){return x.id===id;})[0].open=true;_this.setState({openMenus:openMenus,popoverOpen:true});},_this.handleClose=function(id){var openMenus=_this.state.openMenus.slice();openMenus.filter(function(x){return x.id===id;})[0].open=false;_this.setState({openMenus:openMenus,popoverOpen:false});},_this.showNotification=function(place){if(!_this.state[place]){var x=[];x[place]=true;_this.setState(x);setTimeout(function(){x[place]=false;this.setState(x);}.bind(_this),3000);}},_this.toggleFilterItem=function(refetch,item){if(item!=="all"){var statuses=[].concat(_toConsumableArray(_this.state.statuses));if(statuses.includes(item)){statuses=statuses.filter(function(s){return s!==item;});}else{statuses.push(item);}_this.setState({statuses:statuses});refetch();}},_this.acceptRequest=function(refetch,brokerId){var input={brokerId:brokerId,assistantId:Object(__WEBPACK_IMPORTED_MODULE_3_helpers_UserHelper__["a" /* GetUserId */])(),token:Object(__WEBPACK_IMPORTED_MODULE_3_helpers_UserHelper__["c" /* GetUserToken */])()};_this.props.BA_AcceptRequest({variables:{input:input}}).then(function(resp){refetch();_this.showNotification("br");_this.setState({snackBarColor:"success",snackBarText:"Request Accepted"});}).catch(function(error){console.log("err",error);});},_this.declineRequest=function(refetch,brokerId,messageText){var input={brokerId:brokerId,assistantId:Object(__WEBPACK_IMPORTED_MODULE_3_helpers_UserHelper__["a" /* GetUserId */])(),token:Object(__WEBPACK_IMPORTED_MODULE_3_helpers_UserHelper__["c" /* GetUserToken */])()};_this.props.BA_DeclineRequest({variables:{input:input}}).then(function(resp){refetch();_this.showNotification("br");_this.setState({snackBarColor:"danger",snackBarText:messageText});}).catch(function(error){console.log("err",error);});},_this.sendRequest=function(refetch,brokerId){var input={brokerId:brokerId,assistantId:Object(__WEBPACK_IMPORTED_MODULE_3_helpers_UserHelper__["a" /* GetUserId */])(),token:Object(__WEBPACK_IMPORTED_MODULE_3_helpers_UserHelper__["c" /* GetUserToken */])()};_this.props.BA_SendRequest({variables:{input:input}}).then(function(resp){refetch();_this.showNotification("br");_this.setState({snackBarColor:"success",snackBarText:"Request Sent"});}).catch(function(error){console.log("err",error);});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(BrokerAssignment,[{key:"getSorting",value:function getSorting(order,orderBy){return order==="desc"?function(a,b){return b[orderBy]<a[orderBy]?-1:1;}:function(a,b){return a[orderBy]<b[orderBy]?-1:1;};}},{key:"render",value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_apollo__["Query"],{query:__WEBPACK_IMPORTED_MODULE_9_queries_assistant_Broker_Assignment_BrokerAssignment_js__["a" /* AssistantBrokers */],variables:{userId:Object(__WEBPACK_IMPORTED_MODULE_3_helpers_UserHelper__["a" /* GetUserId */])(),token:Object(__WEBPACK_IMPORTED_MODULE_3_helpers_UserHelper__["c" /* GetUserToken */])(),statuses:this.state.statuses},fetchPolicy:"network-only"},function(_ref2){var loading=_ref2.loading,error=_ref2.error,data=_ref2.data,refetch=_ref2.refetch;if(loading)return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_BaseTablePageContent_jsx__["a" /* default */],{handleSearch:_this2.handleSearch,title:"Broker Assignment",toggleFilterItem:function toggleFilterItem(item){return _this2.toggleFilterItem(refetch,item);},filters:_this2.state.statuses},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["B" /* LinearProgress */],null)));if(error&&error.message&&error.message==="GraphQL error: invalid token"){Object(__WEBPACK_IMPORTED_MODULE_3_helpers_UserHelper__["d" /* Logout */])();return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_router__["a" /* Redirect */],{to:"/app/portal/login"});}if(_this2.state.data.length!==data.AssistantBrokers.length){_this2.setState({data:data.AssistantBrokers});}var qData=[];if(_this2.state.searchData.length>0&&_this2.state.searchTerm!==""){qData=_this2.state.searchData.slice();qData.sort(_this2.getSorting(_this2.state.order,_this2.state.orderBy));}else{qData=data.AssistantBrokers.slice();qData.sort(_this2.getSorting(_this2.state.order,_this2.state.orderBy));}if(qData&&_this2.state.openMenus.length!==qData.length){var openMenus=[];qData.map(function(b){openMenus.push({open:false,id:b.su_ID});return b;});_this2.setState({openMenus:openMenus});}console.log("qdata",qData);return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_BaseTablePageContent_jsx__["a" /* default */],{handleSearch:_this2.handleSearch,title:"Broker Assignment",toggleFilterItem:function toggleFilterItem(item){return _this2.toggleFilterItem(refetch,item);},filters:_this2.state.statuses},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Q" /* Table */],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_EnhancedTableHead_EnhancedTableHead_jsx__["a" /* default */],{order:_this2.state.order,orderBy:_this2.state.orderBy,onRequestSort:_this2.handleRequestSort,rowCount:_this2.state.searchData.length<1&&_this2.state.searchTerm!==""?_this2.state.searchData.length:qData.length,columnData:columnData}),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["R" /* TableBody */],null,_this2.state.searchData.length<1&&_this2.state.searchTerm!==""?__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("h3",null,"No results found"))):qData.slice(_this2.state.page*_this2.state.rowsPerPage,_this2.state.page*_this2.state.rowsPerPage+_this2.state.rowsPerPage).map(function(Broker){console.log("Broker",Broker);return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],{className:"sqDataTable",key:Broker.su_ID,onClick:function onClick(e){return _this2.state.popoverOpen===false?_this2.handleClick(e,Broker.su_ID):null;}},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{style:{padding:"0px",borderRight:"1px solid #e0e0e0",backgroundColor:"white"}},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["x" /* IconButton */],{onClick:function onClick(e){return _this2.state.popoverOpen===false?_this2.handleClick(e,Broker.su_ID):null;}},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["w" /* Icon */],null,"more_vert"))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{style:{borderTop:"1px solid rgba(224, 224, 224, 1)",width:"160px",paddingRight:"0px"}},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("div",{style:{display:"flex"}},Broker.ab_Id?Broker.status===2?__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["w" /* Icon */],{style:{marginRight:"10px",color:"#00ce00"}},"done_all"),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{variant:"caption",style:{wordWrap:"break-word",position:"relative",top:"3px"}},"Assigned")):Broker.status===1?__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["w" /* Icon */],{style:{marginRight:"10px",color:"#ffae57"}},"priority_high"),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{variant:"caption",style:{wordWrap:"break-word",position:"relative",top:"3px"}},"Request Recieved")):Broker.status===0?__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["w" /* Icon */],{style:{marginRight:"10px",color:"#ffae57"}},"priority_high"),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{variant:"caption",style:{wordWrap:"break-word",position:"relative",top:"3px"}},"Request Sent")):null:__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["w" /* Icon */],{style:{marginRight:"10px",color:"#84848494"}},"help_outline"),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{variant:"caption",style:{wordWrap:"break-word",position:"relative",top:"3px"}},"Unassigned")))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,Broker.su_name," ",Broker.su_surname),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,Broker.su_email),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["J" /* Popover */],{open:_this2.state.openMenus.length>0&&_this2.state.openMenus.filter(function(m){return m.id===Broker.su_ID;}).length>0?_this2.state.openMenus.filter(function(m){return m.id===Broker.su_ID;})[0].open:false,anchorReference:"anchorPosition",anchorPosition:{left:_this2.state.anchorLeft,top:_this2.state.anchorTop},onClose:function onClose(){return _this2.handleClose(Broker.su_ID);}},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["C" /* List */],{component:"nav"},!Broker.ab_Id?__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["D" /* ListItem */],{button:true,onClick:function onClick(){_this2.handleClose(Broker.su_ID);_this2.sendRequest(refetch,Broker.su_ID);}},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["E" /* ListItemText */],{primary:"Request Assignment"})):Broker.status===0?__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["D" /* ListItem */],{button:true,onClick:function onClick(){_this2.handleClose(Broker.su_ID);_this2.declineRequest(refetch,Broker.su_ID,"Request Canceled");}},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["E" /* ListItemText */],{primary:"Cancel Request"})):Broker.status===1?__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["D" /* ListItem */],{button:true,onClick:function onClick(){_this2.handleClose(Broker.su_ID);_this2.acceptRequest(refetch,Broker.su_ID);}},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["E" /* ListItemText */],{primary:"Accept Request"})),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["D" /* ListItem */],{button:true,onClick:function onClick(){_this2.handleClose(Broker.su_ID);_this2.declineRequest(refetch,Broker.su_ID,"Request Declined");}},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["E" /* ListItemText */],{primary:"Decline Request"}))):Broker.status===2?__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["D" /* ListItem */],{button:true,onClick:function onClick(){_this2.handleClose(Broker.su_ID);_this2.declineRequest(refetch,Broker.su_ID,"Broker Unassigned");}},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["E" /* ListItemText */],{primary:"Unassign"})):null)));}),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["U" /* TablePagination */],{count:_this2.state.searchData.length<1&&_this2.state.searchTerm!==""?_this2.state.searchData.length:qData.length,rowsPerPage:_this2.state.rowsPerPage,page:_this2.state.page,backIconButtonProps:{"aria-label":"Previous Page"},nextIconButtonProps:{"aria-label":"Next Page"},onChangePage:_this2.handleChangePage,onChangeRowsPerPage:_this2.handleChangeRowsPerPage})))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_Snackbar_Snackbar_jsx__["a" /* default */],{anchorOrigin:{vertical:"bottom",horizontal:"right"},place:"br",color:_this2.state.snackBarColor,message:_this2.state.snackBarText,open:_this2.state.br,closeNotification:function closeNotification(){return _this2.setState({br:false});},close:true}));});}}]);return BrokerAssignment;}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]);BrokerAssignment=Object(__WEBPACK_IMPORTED_MODULE_6_react_apollo__["compose"])(Object(__WEBPACK_IMPORTED_MODULE_6_react_apollo__["graphql"])(__WEBPACK_IMPORTED_MODULE_10_queries_assistant_Broker_Assignment_Mutations__["a" /* BA_AcceptRequest */],{name:"BA_AcceptRequest"}),Object(__WEBPACK_IMPORTED_MODULE_6_react_apollo__["graphql"])(__WEBPACK_IMPORTED_MODULE_10_queries_assistant_Broker_Assignment_Mutations__["b" /* BA_DeclineRequest */],{name:"BA_DeclineRequest"}),Object(__WEBPACK_IMPORTED_MODULE_6_react_apollo__["graphql"])(__WEBPACK_IMPORTED_MODULE_10_queries_assistant_Broker_Assignment_Mutations__["c" /* BA_SendRequest */],{name:"BA_SendRequest"}))(BrokerAssignment);/* harmony default export */ __webpack_exports__["a"] = (BrokerAssignment);

/***/ }),
/* 2472 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BA_AcceptRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return BA_DeclineRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return BA_SendRequest; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_graphql_tag__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_graphql_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_graphql_tag__);
var _templateObject=_taggedTemplateLiteral(["\n  mutation ba_AcceptRequest($input: BA_AcceptRequestInput!) {\n    BA_AcceptRequest(input: $input) {\n      clientMutationId\n    }\n  }\n"],["\n  mutation ba_AcceptRequest($input: BA_AcceptRequestInput!) {\n    BA_AcceptRequest(input: $input) {\n      clientMutationId\n    }\n  }\n"]),_templateObject2=_taggedTemplateLiteral(["\n  mutation ba_DeclineRequest($input: BA_DeclineRequestInput!) {\n    BA_DeclineRequest(input: $input) {\n      clientMutationId\n    }\n  }\n"],["\n  mutation ba_DeclineRequest($input: BA_DeclineRequestInput!) {\n    BA_DeclineRequest(input: $input) {\n      clientMutationId\n    }\n  }\n"]),_templateObject3=_taggedTemplateLiteral(["\n  mutation ba_SendRequest($input: BA_SendRequestInput!) {\n    BA_SendRequest(input: $input) {\n      clientMutationId\n    }\n  }\n"],["\n  mutation ba_SendRequest($input: BA_SendRequestInput!) {\n    BA_SendRequest(input: $input) {\n      clientMutationId\n    }\n  }\n"]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var BA_AcceptRequest=__WEBPACK_IMPORTED_MODULE_0_graphql_tag___default()(_templateObject);var BA_DeclineRequest=__WEBPACK_IMPORTED_MODULE_0_graphql_tag___default()(_templateObject2);var BA_SendRequest=__WEBPACK_IMPORTED_MODULE_0_graphql_tag___default()(_templateObject3);

/***/ }),
/* 2473 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_core__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_EnhancedTableHead_EnhancedTableHead_jsx__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_helpers_UserHelper__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_helpers_Search__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_queries_assistant_Broker_Assignment_BrokerAssignment_js__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_apollo__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_router__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_BaseTablePageContent__ = __webpack_require__(272);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}//Q&Ms
var columnData=[{id:"edit",numeric:false,disablePadding:true,label:"",noSort:true,width:"30px"},{id:"su_name",numeric:false,disablePadding:true,label:"Name"},{id:"su_email",numeric:false,disablePadding:true,label:"Email"}];var ManageClients=function(_Component){_inherits(ManageClients,_Component);function ManageClients(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ManageClients);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ManageClients.__proto__||Object.getPrototypeOf(ManageClients)).call.apply(_ref,[this].concat(args))),_this),_this.state={page:0,rowsPerPage:10,order:"desc",orderBy:"Name",searchTerm:"",loadingSearch:false,data:[],searchData:[]},_this.handleSearch=function(event){_this.setState({searchTerm:event.target.value});var values=event.target.value.split(" ");var brokers=_this.state.data;var inc=["su_name","su_surname","su_email"];var filteredData=Object(__WEBPACK_IMPORTED_MODULE_3_helpers_Search__["a" /* SearchDataSet */])(brokers,values,inc);_this.setState({searchData:filteredData});},_this.handleChangePage=function(event,page){_this.setState({page:page});},_this.handleChangeRowsPerPage=function(event){_this.setState({rowsPerPage:event.target.value});},_this.handleRequestSort=function(event,property){var orderBy=property;var order="desc";if(_this.state.orderBy===property&&_this.state.order==="desc"){order="asc";}_this.setState({order:order,orderBy:orderBy});},_this.handleSelect=function(broker){_this.props.history.push({pathname:"/app/ManageClients"});sessionStorage.setItem("ActiveBrokerId",broker.su_ID);sessionStorage.setItem("ActiveBrokerName",broker.su_name+" "+broker.su_surname);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ManageClients,[{key:"getSorting",value:function getSorting(order,orderBy){return order==="desc"?function(a,b){return b[orderBy]<a[orderBy]?-1:1;}:function(a,b){return a[orderBy]<b[orderBy]?-1:1;};}},{key:"render",value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_apollo__["Query"],{query:__WEBPACK_IMPORTED_MODULE_4_queries_assistant_Broker_Assignment_BrokerAssignment_js__["a" /* AssistantBrokers */],variables:{userId:Object(__WEBPACK_IMPORTED_MODULE_2_helpers_UserHelper__["a" /* GetUserId */])(),token:Object(__WEBPACK_IMPORTED_MODULE_2_helpers_UserHelper__["c" /* GetUserToken */])(),statuses:[2]},fetchPolicy:"network-only"},function(_ref2){var loading=_ref2.loading,error=_ref2.error,data=_ref2.data,refetch=_ref2.refetch;if(loading)return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_BaseTablePageContent__["a" /* default */],{handleSearch:function handleSearch(e){return;},title:"Manage Clients - Select Broker",hideFilter:true},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["B" /* LinearProgress */],null)));if(error&&error.message&&error.message==="GraphQL error: invalid token"){Object(__WEBPACK_IMPORTED_MODULE_2_helpers_UserHelper__["d" /* Logout */])();return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_router__["a" /* Redirect */],{to:"/app/portal/login"});}if(_this2.state.data.length!==data.AssistantBrokers.length){_this2.setState({data:data.AssistantBrokers});}var qData=[];if(_this2.state.searchData.length>0&&_this2.state.searchTerm!==""){qData=_this2.state.searchData.slice();qData.sort(_this2.getSorting(_this2.state.order,_this2.state.orderBy));}else{qData=data.AssistantBrokers.slice();qData.sort(_this2.getSorting(_this2.state.order,_this2.state.orderBy));}return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_BaseTablePageContent__["a" /* default */],{handleSearch:_this2.handleSearch,changeClaimed:function changeClaimed(e){_this2.setState({onlyClaimed:e.target.checked});refetch();},title:"Manage Clients - Select Broker",hideFilter:true},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Q" /* Table */],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_EnhancedTableHead_EnhancedTableHead_jsx__["a" /* default */],{order:_this2.state.order,orderBy:_this2.state.orderBy,onRequestSort:_this2.handleRequestSort,rowCount:_this2.state.searchData.length<1&&_this2.state.searchTerm!==""?_this2.state.searchData.length:qData.length,columnData:columnData}),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["R" /* TableBody */],null,_this2.state.searchData.length<1&&_this2.state.searchTerm!==""?__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("h3",null,"No results found"))):qData.slice(_this2.state.page*_this2.state.rowsPerPage,_this2.state.page*_this2.state.rowsPerPage+_this2.state.rowsPerPage).map(function(broker){return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],{className:"sqDataTable",key:broker.su_ID,onClick:function onClick(e){return _this2.handleSelect(broker);}},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{style:{padding:"0px",borderRight:"1px solid #e0e0e0",backgroundColor:"white"}},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["x" /* IconButton */],{onClick:function onClick(e){return _this2.handleSelect(broker);}},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["w" /* Icon */],null,"more_vert"))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,broker.su_name," ",broker.su_surname),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,broker.su_email));}),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["U" /* TablePagination */],{count:_this2.state.searchData.length<1&&_this2.state.searchTerm!==""?_this2.state.searchData.length:qData.length,rowsPerPage:_this2.state.rowsPerPage,page:_this2.state.page,backIconButtonProps:{"aria-label":"Previous Page"},nextIconButtonProps:{"aria-label":"Next Page"},onChangePage:_this2.handleChangePage,onChangeRowsPerPage:_this2.handleChangeRowsPerPage})))));});}}]);return ManageClients;}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (ManageClients);

/***/ }),
/* 2474 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_core__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_EnhancedTableHead_EnhancedTableHead_jsx__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_helpers_UserHelper__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_helpers_Search__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_queries_assistant_Broker_Assignment_BrokerAssignment_js__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_apollo__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_router__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_BaseTablePageContent__ = __webpack_require__(272);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}//Q&Ms
var columnData=[{id:"su_name",numeric:false,disablePadding:true,label:"Name"},{id:"su_email",numeric:false,disablePadding:true,label:"Email"}];var AddClient=function(_Component){_inherits(AddClient,_Component);function AddClient(){var _ref;var _temp,_this,_ret;_classCallCheck(this,AddClient);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=AddClient.__proto__||Object.getPrototypeOf(AddClient)).call.apply(_ref,[this].concat(args))),_this),_this.state={page:0,rowsPerPage:10,order:"desc",orderBy:"Name",searchTerm:"",loadingSearch:false,data:[],searchData:[]},_this.handleSearch=function(event){_this.setState({searchTerm:event.target.value});var values=event.target.value.split(" ");var brokers=_this.state.data;var inc=["su_name","su_surname","su_email"];var filteredData=Object(__WEBPACK_IMPORTED_MODULE_3_helpers_Search__["a" /* SearchDataSet */])(brokers,values,inc);_this.setState({searchData:filteredData});},_this.handleChangePage=function(event,page){_this.setState({page:page});},_this.handleChangeRowsPerPage=function(event){_this.setState({rowsPerPage:event.target.value});},_this.handleRequestSort=function(event,property){var orderBy=property;var order="desc";if(_this.state.orderBy===property&&_this.state.order==="desc"){order="asc";}_this.setState({order:order,orderBy:orderBy});},_this.handleSelect=function(broker){_this.props.history.push({pathname:"/app/CreateClient"});sessionStorage.setItem("ActiveBrokerId",broker.su_ID);sessionStorage.setItem("ActiveBrokerName",broker.su_name+" "+broker.su_surname);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(AddClient,[{key:"getSorting",value:function getSorting(order,orderBy){return order==="desc"?function(a,b){return b[orderBy]<a[orderBy]?-1:1;}:function(a,b){return a[orderBy]<b[orderBy]?-1:1;};}},{key:"render",value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_apollo__["Query"],{query:__WEBPACK_IMPORTED_MODULE_4_queries_assistant_Broker_Assignment_BrokerAssignment_js__["a" /* AssistantBrokers */],variables:{userId:Object(__WEBPACK_IMPORTED_MODULE_2_helpers_UserHelper__["a" /* GetUserId */])(),token:Object(__WEBPACK_IMPORTED_MODULE_2_helpers_UserHelper__["c" /* GetUserToken */])(),statuses:[2]},fetchPolicy:"network-only"},function(_ref2){var loading=_ref2.loading,error=_ref2.error,data=_ref2.data,refetch=_ref2.refetch;if(loading)return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_BaseTablePageContent__["a" /* default */],{handleSearch:_this2.handleSearch,title:"Add Client - Select Broker",hideFilter:true},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["B" /* LinearProgress */],null)));if(error&&error.message&&error.message==="GraphQL error: invalid token"){Object(__WEBPACK_IMPORTED_MODULE_2_helpers_UserHelper__["d" /* Logout */])();return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_router__["a" /* Redirect */],{to:"/app/portal/login"});}if(_this2.state.data.length!==data.AssistantBrokers.length){_this2.setState({data:data.AssistantBrokers});}var qData=[];if(_this2.state.searchData.length>0&&_this2.state.searchTerm!==""){qData=_this2.state.searchData.slice();qData.sort(_this2.getSorting(_this2.state.order,_this2.state.orderBy));}else{qData=data.AssistantBrokers.slice();qData.sort(_this2.getSorting(_this2.state.order,_this2.state.orderBy));}return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_BaseTablePageContent__["a" /* default */],{handleSearch:_this2.handleSearch,title:"Add Client - Select Broker",hideFilter:true},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Q" /* Table */],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_EnhancedTableHead_EnhancedTableHead_jsx__["a" /* default */],{order:_this2.state.order,orderBy:_this2.state.orderBy,onRequestSort:_this2.handleRequestSort,rowCount:_this2.state.searchData.length<1&&_this2.state.searchTerm!==""?_this2.state.searchData.length:qData.length,columnData:columnData}),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["R" /* TableBody */],null,_this2.state.searchData.length<1&&_this2.state.searchTerm!==""?__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("h3",null,"No results found"))):qData.slice(_this2.state.page*_this2.state.rowsPerPage,_this2.state.page*_this2.state.rowsPerPage+_this2.state.rowsPerPage).map(function(broker){return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],{className:"sqDataTable",key:broker.su_ID,onClick:function onClick(e){return _this2.handleSelect(broker);}},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,broker.su_name," ",broker.su_surname),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,broker.su_email));}),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["U" /* TablePagination */],{count:_this2.state.searchData.length<1&&_this2.state.searchTerm!==""?_this2.state.searchData.length:qData.length,rowsPerPage:_this2.state.rowsPerPage,page:_this2.state.page,backIconButtonProps:{"aria-label":"Previous Page"},nextIconButtonProps:{"aria-label":"Next Page"},onChangePage:_this2.handleChangePage,onChangeRowsPerPage:_this2.handleChangeRowsPerPage})))));});}}]);return AddClient;}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (AddClient);

/***/ }),
/* 2475 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_core__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_EnhancedTableHead_EnhancedTableHead_jsx__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_helpers_UserHelper__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_helpers_Search__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_queries_assistant_Broker_Assignment_BrokerAssignment_js__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_apollo__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_router__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_BaseTablePageContent__ = __webpack_require__(272);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}//Q&Ms
var columnData=[{id:"edit",numeric:false,disablePadding:true,label:"",noSort:true,width:"30px"},{id:"su_name",numeric:false,disablePadding:true,label:"Name"},{id:"su_email",numeric:false,disablePadding:true,label:"Email"}];var QuoteHistory=function(_Component){_inherits(QuoteHistory,_Component);function QuoteHistory(){var _ref;var _temp,_this,_ret;_classCallCheck(this,QuoteHistory);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=QuoteHistory.__proto__||Object.getPrototypeOf(QuoteHistory)).call.apply(_ref,[this].concat(args))),_this),_this.state={page:0,rowsPerPage:10,order:"desc",orderBy:"Name",searchTerm:"",loadingSearch:false,data:[],searchData:[]},_this.handleSearch=function(event){_this.setState({searchTerm:event.target.value});var values=event.target.value.split(" ");var brokers=_this.state.data;var inc=["su_name","su_surname","su_email"];var filteredData=Object(__WEBPACK_IMPORTED_MODULE_3_helpers_Search__["a" /* SearchDataSet */])(brokers,values,inc);_this.setState({searchData:filteredData});},_this.handleChangePage=function(event,page){_this.setState({page:page});},_this.handleChangeRowsPerPage=function(event){_this.setState({rowsPerPage:event.target.value});},_this.handleRequestSort=function(event,property){var orderBy=property;var order="desc";if(_this.state.orderBy===property&&_this.state.order==="desc"){order="asc";}_this.setState({order:order,orderBy:orderBy});},_this.handleSelect=function(broker){_this.props.history.push({pathname:"/app/history"});sessionStorage.setItem("ActiveBrokerId",broker.su_ID);sessionStorage.setItem("ActiveBrokerName",broker.su_name+" "+broker.su_surname);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(QuoteHistory,[{key:"getSorting",value:function getSorting(order,orderBy){return order==="desc"?function(a,b){return b[orderBy]<a[orderBy]?-1:1;}:function(a,b){return a[orderBy]<b[orderBy]?-1:1;};}},{key:"render",value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_apollo__["Query"],{query:__WEBPACK_IMPORTED_MODULE_4_queries_assistant_Broker_Assignment_BrokerAssignment_js__["a" /* AssistantBrokers */],variables:{userId:Object(__WEBPACK_IMPORTED_MODULE_2_helpers_UserHelper__["a" /* GetUserId */])(),token:Object(__WEBPACK_IMPORTED_MODULE_2_helpers_UserHelper__["c" /* GetUserToken */])(),statuses:[2]},fetchPolicy:"network-only"},function(_ref2){var loading=_ref2.loading,error=_ref2.error,data=_ref2.data,refetch=_ref2.refetch;if(loading)return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_BaseTablePageContent__["a" /* default */],{handleSearch:function handleSearch(e){return;},title:"Quote History - Select Broker",hideFilter:true},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["B" /* LinearProgress */],null)));if(error&&error.message&&error.message==="GraphQL error: invalid token"){Object(__WEBPACK_IMPORTED_MODULE_2_helpers_UserHelper__["d" /* Logout */])();return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_router__["a" /* Redirect */],{to:"/app/portal/login"});}if(_this2.state.data.length!==data.AssistantBrokers.length){_this2.setState({data:data.AssistantBrokers});}var qData=[];if(_this2.state.searchData.length>0&&_this2.state.searchTerm!==""){qData=_this2.state.searchData.slice();qData.sort(_this2.getSorting(_this2.state.order,_this2.state.orderBy));}else{qData=data.AssistantBrokers.slice();qData.sort(_this2.getSorting(_this2.state.order,_this2.state.orderBy));}return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_BaseTablePageContent__["a" /* default */],{handleSearch:_this2.handleSearch,title:"Quote History - Select Broker",hideFilter:true},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Q" /* Table */],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_EnhancedTableHead_EnhancedTableHead_jsx__["a" /* default */],{order:_this2.state.order,orderBy:_this2.state.orderBy,onRequestSort:_this2.handleRequestSort,rowCount:_this2.state.searchData.length<1&&_this2.state.searchTerm!==""?_this2.state.searchData.length:qData.length,columnData:columnData}),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["R" /* TableBody */],null,_this2.state.searchData.length<1&&_this2.state.searchTerm!==""?__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("h3",null,"No results found"))):qData.slice(_this2.state.page*_this2.state.rowsPerPage,_this2.state.page*_this2.state.rowsPerPage+_this2.state.rowsPerPage).map(function(broker){return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],{className:"sqDataTable",key:broker.su_ID,onClick:function onClick(e){return _this2.handleSelect(broker);}},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{style:{padding:"0px",borderRight:"1px solid #e0e0e0",backgroundColor:"white"}},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["x" /* IconButton */],{onClick:function onClick(e){return _this2.handleSelect(broker);}},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["w" /* Icon */],null,"more_vert"))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,broker.su_name," ",broker.su_surname),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,broker.su_email));}),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["U" /* TablePagination */],{count:_this2.state.searchData.length<1&&_this2.state.searchTerm!==""?_this2.state.searchData.length:qData.length,rowsPerPage:_this2.state.rowsPerPage,page:_this2.state.page,backIconButtonProps:{"aria-label":"Previous Page"},nextIconButtonProps:{"aria-label":"Next Page"},onChangePage:_this2.handleChangePage,onChangeRowsPerPage:_this2.handleChangeRowsPerPage})))));});}}]);return QuoteHistory;}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (QuoteHistory);

/***/ }),
/* 2476 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_store__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_apollo__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_Grid_GridItem_jsx__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_Card_Card_jsx__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_Card_CardBody_jsx__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_MobileStepper__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_MobileStepper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_MobileStepper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_assets_jss_material_dashboard_pro_react_views_userProfileStyles_jsx__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_queries_Profile_queries__ = __webpack_require__(2477);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_queries_Profile_mutations__ = __webpack_require__(252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_Wrappers_materialUIWrappers_components_FormInput__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_components_Wrappers_materialUIWrappers_components_FormInputPassword__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_redux_form__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_helpers_UserHelper__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_reducers_NotificationReducer__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_lodash__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_lodash__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/*eslint-disable*///import "./profilePage.css";
// core components
// @material-ui/core components
var required=function required(value){return value?undefined:'Required';};var form='CLD';var isEmptyOrSpaces=function isEmptyOrSpaces(str){return str===undefined||str===null||str.match(/^ *$/)!==null;};var CompanyLoginDetails=function(_Component){_inherits(CompanyLoginDetails,_Component);function CompanyLoginDetails(props){_classCallCheck(this,CompanyLoginDetails);var _this=_possibleConstructorReturn(this,(CompanyLoginDetails.__proto__||Object.getPrototypeOf(CompanyLoginDetails)).call(this,props));_this.state={initialized:false,openDialogs:[],astuteDialog:false,showPasswordAstute:false,showConfrimPasswordAstute:false,showPinAstute:false,showConfirmPinAstute:false,checkValidation:false};_this.handleOpenAstuteDialog=function(){__WEBPACK_IMPORTED_MODULE_1_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_15_redux_form__["b" /* change */])('CLD','astuteDetails.password',''));__WEBPACK_IMPORTED_MODULE_1_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_15_redux_form__["b" /* change */])('CLD','astuteDetails.confirmpassword',''));__WEBPACK_IMPORTED_MODULE_1_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_15_redux_form__["b" /* change */])('CLD','astuteDetails.pin',''));__WEBPACK_IMPORTED_MODULE_1_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_15_redux_form__["b" /* change */])('CLD','astuteDetails.confirmpin',''));_this.setState({astuteDialog:true,showPasswordAstute:false,showConfrimPasswordAstute:false,showPinAstute:false,showConfirmPinAstute:false,checkValidation:false});};_this.handleCloseAstuteDialog=function(){_this.setState({astuteDialog:false});};_this.handleClickOpenDialog=function(target,userTargetDetail){__WEBPACK_IMPORTED_MODULE_1_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_15_redux_form__["b" /* change */])('CLD','companyDetails.'+target+'.username',userTargetDetail&&userTargetDetail.username?userTargetDetail.username:''));if(target!==9){__WEBPACK_IMPORTED_MODULE_1_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_15_redux_form__["b" /* change */])('CLD','companyDetails.'+target+'.password',''));__WEBPACK_IMPORTED_MODULE_1_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_15_redux_form__["b" /* change */])('CLD','companyDetails.'+target+'.confirmpassword',''));}var openDialogs=_this.state.openDialogs.slice();openDialogs.filter(function(x){return x.id===target;})[0].open=true;if(target!==9){openDialogs.filter(function(x){return x.id===target;})[0].showPassword=false;openDialogs.filter(function(x){return x.id===target;})[0].showConfrimPassword=false;}_this.setState({openDialogs:openDialogs,checkValidation:false});};_this.handleCloseDialog=function(id){var openDialogs=_this.state.openDialogs.slice();openDialogs.filter(function(x){return x.id===id;})[0].open=false;_this.setState({openDialogs:openDialogs});};_this.toggleShowPassword=function(id){var openDialogs=_this.state.openDialogs.slice();var showPassword=openDialogs.filter(function(x){return x.id===id;})[0].showPassword;openDialogs.filter(function(x){return x.id===id;})[0].showPassword=!showPassword;_this.setState({openDialogs:openDialogs});};_this.toggleShowConfirmPassword=function(id){var openDialogs=_this.state.openDialogs.slice();var showPassword=openDialogs.filter(function(x){return x.id===id;})[0].showConfrimPassword;openDialogs.filter(function(x){return x.id===id;})[0].showConfrimPassword=!showPassword;_this.setState({openDialogs:openDialogs});};_this.toggleShowPasswordAstute=function(attr){var showPassword=_this.state[attr];_this.setState(_defineProperty({},attr,!showPassword));};_this.updateTargetDetails=function(target,refetch){var pw=__WEBPACK_IMPORTED_MODULE_18_lodash___default.a.get(__WEBPACK_IMPORTED_MODULE_1_store__["a" /* default */].getState().form.CLD,'values.companyDetails.'+target.id+'.password',null);var cpw=__WEBPACK_IMPORTED_MODULE_18_lodash___default.a.get(__WEBPACK_IMPORTED_MODULE_1_store__["a" /* default */].getState().form.CLD,'values.companyDetails.'+target.id+'.confirmpassword',null);var username=__WEBPACK_IMPORTED_MODULE_18_lodash___default.a.get(__WEBPACK_IMPORTED_MODULE_1_store__["a" /* default */].getState().form.CLD,'values.companyDetails.'+target.id+'.username',null);if(isEmptyOrSpaces(username)||target.id!=1&&target.id!=9&&(isEmptyOrSpaces(pw)||isEmptyOrSpaces(cpw))){__WEBPACK_IMPORTED_MODULE_1_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_17_reducers_NotificationReducer__["d" /* showSnack */])({message:'Please fill in all Details.',color:'danger'}));_this.setState({checkValidation:true});return;}if(target.id!=1&&target.id!=9&&pw!==cpw){__WEBPACK_IMPORTED_MODULE_1_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_17_reducers_NotificationReducer__["d" /* showSnack */])({message:'Password do not match.',color:'danger'}));return;}_this.setState({checkValidation:false});var input={userId:Object(__WEBPACK_IMPORTED_MODULE_16_helpers_UserHelper__["a" /* GetUserId */])(),token:Object(__WEBPACK_IMPORTED_MODULE_16_helpers_UserHelper__["c" /* GetUserToken */])(),target:target.id.toString(),username:username,password:pw?pw:''};_this.props.UpdateCompanyDetail({variables:{input:input}}).then(function(resp){__WEBPACK_IMPORTED_MODULE_1_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_17_reducers_NotificationReducer__["e" /* successWarning */])({open:true,title:target.name+' Details Updated!'}));_this.handleCloseDialog(target.id);refetch();}).catch(function(error){__WEBPACK_IMPORTED_MODULE_1_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_17_reducers_NotificationReducer__["d" /* showSnack */])({message:'Unfortunately, an error has occured',color:'danger'}));});};_this.updateAstuteDetails=function(refetch){var pw=__WEBPACK_IMPORTED_MODULE_18_lodash___default.a.get(__WEBPACK_IMPORTED_MODULE_1_store__["a" /* default */].getState().form.CLD,'values.astuteDetails.password',null);var pin=__WEBPACK_IMPORTED_MODULE_18_lodash___default.a.get(__WEBPACK_IMPORTED_MODULE_1_store__["a" /* default */].getState().form.CLD,'values.astuteDetails.pin',null);var cpw=__WEBPACK_IMPORTED_MODULE_18_lodash___default.a.get(__WEBPACK_IMPORTED_MODULE_1_store__["a" /* default */].getState().form.CLD,'values.astuteDetails.confirmpassword',null);var cpin=__WEBPACK_IMPORTED_MODULE_18_lodash___default.a.get(__WEBPACK_IMPORTED_MODULE_1_store__["a" /* default */].getState().form.CLD,'values.astuteDetails.confirmpin',null);var username=__WEBPACK_IMPORTED_MODULE_18_lodash___default.a.get(__WEBPACK_IMPORTED_MODULE_1_store__["a" /* default */].getState().form.CLD,'values.astuteDetails.username',null);if(!isEmptyOrSpaces(pw)&&!isEmptyOrSpaces(cpw)&&!isEmptyOrSpaces(username)&&!isEmptyOrSpaces(pin)&&!isEmptyOrSpaces(cpin)){_this.setState({checkValidation:false});if(pw!==cpw){__WEBPACK_IMPORTED_MODULE_1_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_17_reducers_NotificationReducer__["d" /* showSnack */])({message:'Password do not match.',color:'danger'}));}else if(pin!==cpin){__WEBPACK_IMPORTED_MODULE_1_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_17_reducers_NotificationReducer__["d" /* showSnack */])({message:'Pins do not match.',color:'danger'}));}else{var input={userId:Object(__WEBPACK_IMPORTED_MODULE_16_helpers_UserHelper__["a" /* GetUserId */])(),token:Object(__WEBPACK_IMPORTED_MODULE_16_helpers_UserHelper__["c" /* GetUserToken */])(),username:username,password:pw,pin:pin};_this.props.UpdateAstuteDetails({variables:{input:input}}).then(function(resp){__WEBPACK_IMPORTED_MODULE_1_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_17_reducers_NotificationReducer__["e" /* successWarning */])({open:true,title:'Astute Details Updated!'}));_this.handleCloseAstuteDialog();refetch();}).catch(function(error){__WEBPACK_IMPORTED_MODULE_1_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_17_reducers_NotificationReducer__["d" /* showSnack */])({message:'Unfortunately, an error has occured',color:'danger'}));});}}else{__WEBPACK_IMPORTED_MODULE_1_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_17_reducers_NotificationReducer__["d" /* showSnack */])({message:'Please fill in all Details.',color:'danger'}));_this.setState({checkValidation:true});}};return _this;}_createClass(CompanyLoginDetails,[{key:'initializeForm',value:function initializeForm(EnabledTargets,CompanyLoginD,AstuteDetails){var companyDetails={};var AstuteDetails;EnabledTargets.map(function(target){var usersCompDetail=CompanyLoginD.find(function(c){return c.targetId===target.id;});companyDetails[target.id]={username:usersCompDetail?usersCompDetail.username:null};});this.props.initialize({companyDetails:Object.assign({},companyDetails),astuteDetails:{username:AstuteDetails&&AstuteDetails.username?AstuteDetails.username:null}});this.setState({initialized:true});}},{key:'render',value:function render(){var _this2=this,_React$createElement3;var backRender=function backRender(){if(localStorage.getItem('userType')=='')return"";else return"none";};var validate=[];validate.push(required);if(this.props.data.loading){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["B" /* LinearProgress */],null);}var data=this.props.data;if(data.error&&data.error.message&&data.error.message==='GraphQL error: invalid token'){Object(__WEBPACK_IMPORTED_MODULE_16_helpers_UserHelper__["d" /* Logout */])();return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["a" /* Redirect */],{to:'/app/portal/login'});}var refetch=data.refetch;var CompanyLoginD=data.CompanyLoginD;var EnabledTargets=data.EnabledTargets;var AstuteDetails=data.AstuteDetails;if(!this.state.initialized){this.initializeForm(EnabledTargets,CompanyLoginD,AstuteDetails);}if(this.state.openDialogs.length!==EnabledTargets.length){var openDialogs=[];EnabledTargets.map(function(t){openDialogs.push({open:false,id:t.id,showPassword:false,showConfrimPassword:false});return t;});this.setState({openDialogs:openDialogs});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["v" /* Grid */],{container:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:10,style:{margin:'auto'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:"stepperDiv"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_MobileStepper___default.a,{type:'progress',steps:0,position:'left',style:{display:backRender()},activeStep:this.state.page,backButton:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{display:"flex"}},true?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["d" /* Button */],{variant:'outlined',className:'outlinedButton',color:'secondary',style:{marginLeft:"10px"},onClick:function onClick(){return _this2.props.history.goBack();},disabled:this.state.page===0?true:false},'Back'):React.createElement('div',null))})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Card_Card_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_Card_CardBody_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["v" /* Grid */],{direction:'column',container:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:12,style:{margin:'auto',marginBottom:'50px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["Z" /* Typography */],{variant:'headline',className:'typography',style:{textAlign:'center'}},'FSP Login Detail',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{borderBottom:'1px solid #cccccc69',margin:'5px auto',width:'50%'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["Z" /* Typography */],{variant:'caption'},'This is your Broker login details at the specific FSP\'s'))),EnabledTargets.map(function(t){var _React$createElement;if(t.id==1)return;var dialog=_this2.state.openDialogs.find(function(x){return x.id===t.id;});var openD=dialog?dialog.open:false;var userTargetDetail=CompanyLoginD.find(function(c){return c.targetId===t.id;});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:12,key:t.id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Card_Card_jsx__["a" /* default */],{className:'targetCard',style:{paddingTop:'5px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["v" /* Grid */],{container:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:4,className:'affiliationsGridItem'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'/assets/logo/'+t.name.toLowerCase()+'.png',className:'targetAffiliationLogo',style:{alignSelf:'center'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:6,md:4,className:'affiliationsGridItem'},userTargetDetail&&userTargetDetail.enabled&&userTargetDetail.username?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["Z" /* Typography */],{variant:'caption'},'Username:',' '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["Z" /* Typography */],{variant:'subheading'},userTargetDetail.username)):null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:6,md:4,className:'affiliationsGridItem',style:{textAlign:'center'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["d" /* Button */],(_React$createElement={variant:'outlined',className:'outlinedButton',style:{color:'#55526f',alignSelf:'center',margin:'auto'}},_defineProperty(_React$createElement,'className','passButton'),_defineProperty(_React$createElement,'onClick',function onClick(){return _this2.handleClickOpenDialog(t.id,userTargetDetail);}),_React$createElement),userTargetDetail&&userTargetDetail.enabled?'Update Details':'Activate'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["k" /* Dialog */],{open:openD,onClose:function onClose(){return _this2.handleCloseDialog(t.id);},'aria-labelledby':'form-dialog-title',className:'centerFixedDialog'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["o" /* DialogTitle */],{id:'form-dialog-title'},'Set User Details for '+t.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["m" /* DialogContent */],null,t.name==='Hollard0'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["t" /* FormControl */],{fullWidth:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_13_components_Wrappers_materialUIWrappers_components_FormInput__["a" /* default */],isrequired:true,checkValidation:_this2.state.checkValidation,name:'companyDetails.'+t.id+'.username',label:'Id Number'})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["t" /* FormControl */],{fullWidth:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_13_components_Wrappers_materialUIWrappers_components_FormInput__["a" /* default */],isrequired:true,validate:[required],checkValidation:_this2.state.checkValidation,name:'companyDetails.'+t.id+'.username',label:'Username'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["t" /* FormControl */],{fullWidth:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_14_components_Wrappers_materialUIWrappers_components_FormInputPassword__["a" /* default */],showPassword:dialog?dialog.showPassword:false,handleClickShowPassword:function handleClickShowPassword(){return _this2.toggleShowPassword(t.id);},isrequired:true,checkValidation:_this2.state.checkValidation,name:'companyDetails.'+t.id+'.password',label:'Password'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["t" /* FormControl */],{fullWidth:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_14_components_Wrappers_materialUIWrappers_components_FormInputPassword__["a" /* default */],showPassword:dialog?dialog.showConfrimPassword:false,handleClickShowPassword:function handleClickShowPassword(){return _this2.toggleShowConfirmPassword(t.id);},isrequired:true,checkValidation:_this2.state.checkValidation,name:'companyDetails.'+t.id+'.confirmpassword',label:'Confirm Password'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["l" /* DialogActions */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["d" /* Button */],{color:'primary',onClick:function onClick(){return _this2.handleCloseDialog(t.id);}},'Cancel'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["d" /* Button */],{color:'primary',onClick:function onClick(){return _this2.updateTargetDetails(t,refetch);}},'Save')))))));}),EnabledTargets.map(function(t){var _React$createElement2;if(t.id!=1)return;var dialog=_this2.state.openDialogs.find(function(x){return x.id===t.id;});var openD=dialog?dialog.open:false;var userTargetDetail=CompanyLoginD.find(function(c){return c.targetId===t.id;});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:12,key:1},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Card_Card_jsx__["a" /* default */],{className:'targetCard',style:{paddingTop:'5px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["v" /* Grid */],{container:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:4,className:'affiliationsGridItem'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'/assets/logo/'+t.name.toLowerCase()+'.png',className:'targetAffiliationLogo',style:{alignSelf:'center'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:6,md:4,className:'affiliationsGridItem'},userTargetDetail&&userTargetDetail.enabled&&userTargetDetail.username?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["Z" /* Typography */],{variant:'caption'},'Username:',' '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["Z" /* Typography */],{variant:'subheading'},userTargetDetail.username)):null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:6,md:4,className:'affiliationsGridItem',style:{textAlign:'center'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["d" /* Button */],(_React$createElement2={variant:'outlined',className:'outlinedButton',style:{color:'#55526f',alignSelf:'center',margin:'auto'}},_defineProperty(_React$createElement2,'className','passButton'),_defineProperty(_React$createElement2,'onClick',function onClick(){return _this2.handleClickOpenDialog(t.id,userTargetDetail);}),_React$createElement2),userTargetDetail&&userTargetDetail.enabled?'Update Details':'Activate'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["k" /* Dialog */],{open:openD,onClose:function onClose(){return _this2.handleCloseDialog(t.id);},'aria-labelledby':'form-dialog-title',className:'centerFixedDialog'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["o" /* DialogTitle */],{id:'form-dialog-title'},'Set User Details for '+t.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["m" /* DialogContent */],null,t.name==='Hollard0'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["t" /* FormControl */],{fullWidth:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_13_components_Wrappers_materialUIWrappers_components_FormInput__["a" /* default */],isrequired:true,checkValidation:_this2.state.checkValidation,name:'companyDetails.'+t.id+'.username',label:'Id Number'})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["t" /* FormControl */],{fullWidth:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_13_components_Wrappers_materialUIWrappers_components_FormInput__["a" /* default */],isrequired:true,validate:[required],checkValidation:_this2.state.checkValidation,name:'companyDetails.'+t.id+'.username',label:'Broker Code'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["t" /* FormControl */],{fullWidth:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_13_components_Wrappers_materialUIWrappers_components_FormInput__["a" /* default */],isrequired:true,name:'companyDetails.'+t.id+'.password',label:'House Code'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["l" /* DialogActions */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["d" /* Button */],{color:'primary',onClick:function onClick(){return _this2.handleCloseDialog(t.id);}},'Cancel'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["d" /* Button */],{color:'primary',onClick:function onClick(){return _this2.updateTargetDetails(t,refetch);}},'Save')))))));}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Card_Card_jsx__["a" /* default */],{className:'targetCard',style:{paddingTop:'5px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["v" /* Grid */],{container:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:4,className:'affiliationsGridItem'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'/assets/logo/astute.jpg',className:'targetAffiliationLogo',style:{alignSelf:'center',width:'70px'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:6,md:4,className:'affiliationsGridItem'},AstuteDetails&&AstuteDetails.enabled&&AstuteDetails.username?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["Z" /* Typography */],{variant:'caption'},'Username:',' '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["Z" /* Typography */],{variant:'subheading'},AstuteDetails.username)):null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:6,md:4,className:'affiliationsGridItem',style:{textAlign:'center'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["d" /* Button */],(_React$createElement3={variant:'outlined',className:'outlinedButton',style:{color:'#55526f',alignSelf:'center',margin:'auto'}},_defineProperty(_React$createElement3,'className','passButton'),_defineProperty(_React$createElement3,'onClick',function onClick(){return _this2.handleOpenAstuteDialog();}),_React$createElement3),AstuteDetails&&AstuteDetails.enabled?'Update Details':'Activate'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["k" /* Dialog */],{open:this.state.astuteDialog,onClose:function onClose(){return _this2.handleCloseAstuteDialog();},'aria-labelledby':'form-dialog-title',className:'centerFixedDialog'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["o" /* DialogTitle */],{id:'form-dialog-title'},'Set Password for Astute'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["m" /* DialogContent */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["t" /* FormControl */],{fullWidth:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_13_components_Wrappers_materialUIWrappers_components_FormInput__["a" /* default */],isrequired:true,validate:[required],checkValidation:this.props.checkValidation,name:'astuteDetails.username',label:'Username'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["t" /* FormControl */],{fullWidth:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_14_components_Wrappers_materialUIWrappers_components_FormInputPassword__["a" /* default */],showPassword:this.state.showPasswordAstute,handleClickShowPassword:function handleClickShowPassword(){return _this2.toggleShowPasswordAstute('showPasswordAstute');},name:'astuteDetails.password',label:'Password'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["t" /* FormControl */],{fullWidth:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_14_components_Wrappers_materialUIWrappers_components_FormInputPassword__["a" /* default */],showPassword:this.state.showConfrimPasswordAstute,handleClickShowPassword:function handleClickShowPassword(){return _this2.toggleShowPasswordAstute('showConfrimPasswordAstute');},name:'astuteDetails.confirmpassword',label:'Confirm Password'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["t" /* FormControl */],{fullWidth:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_14_components_Wrappers_materialUIWrappers_components_FormInputPassword__["a" /* default */],showPassword:this.state.showPinAstute,handleClickShowPassword:function handleClickShowPassword(){return _this2.toggleShowPasswordAstute('showPinAstute');},name:'astuteDetails.pin',label:'Pin'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["t" /* FormControl */],{fullWidth:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_14_components_Wrappers_materialUIWrappers_components_FormInputPassword__["a" /* default */],showPassword:this.state.showConfirmPinAstute,handleClickShowPassword:function handleClickShowPassword(){return _this2.toggleShowPasswordAstute('showConfirmPinAstute');},name:'astuteDetails.confirmpin',label:'Confirm Pin'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["l" /* DialogActions */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["d" /* Button */],{color:'primary',onClick:function onClick(){return _this2.handleCloseAstuteDialog();}},'Cancel'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["d" /* Button */],{color:'primary',onClick:function onClick(){return _this2.updateAstuteDetails(refetch);}},'Save')))))))))))));}}]);return CompanyLoginDetails;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);CompanyLoginDetails=Object(__WEBPACK_IMPORTED_MODULE_3_react_apollo__["graphql"])(__WEBPACK_IMPORTED_MODULE_11_queries_Profile_queries__["a" /* companyLoginDetails */],{options:function options(){return{fetchPolicy:'network-only'};},props:function props(_props){if(_props.data.error){}return Object.assign({},_props);}})(CompanyLoginDetails);CompanyLoginDetails=Object(__WEBPACK_IMPORTED_MODULE_4_react_redux__["b" /* connect */])(function(state){return{userId:Object(__WEBPACK_IMPORTED_MODULE_16_helpers_UserHelper__["a" /* GetUserId */])(),token:Object(__WEBPACK_IMPORTED_MODULE_16_helpers_UserHelper__["c" /* GetUserToken */])()};})(CompanyLoginDetails);CompanyLoginDetails=Object(__WEBPACK_IMPORTED_MODULE_3_react_apollo__["compose"])(Object(__WEBPACK_IMPORTED_MODULE_3_react_apollo__["graphql"])(__WEBPACK_IMPORTED_MODULE_12_queries_Profile_mutations__["e" /* UpdateCompanyDetail */],{name:'UpdateCompanyDetail'}),Object(__WEBPACK_IMPORTED_MODULE_3_react_apollo__["graphql"])(__WEBPACK_IMPORTED_MODULE_12_queries_Profile_mutations__["d" /* UpdateAstuteDetails */],{name:'UpdateAstuteDetails'}))(CompanyLoginDetails);CompanyLoginDetails=Object(__WEBPACK_IMPORTED_MODULE_15_redux_form__["e" /* reduxForm */])({form:form,destroyOnUnmount:true})(CompanyLoginDetails);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["_1" /* withStyles */])(__WEBPACK_IMPORTED_MODULE_10_assets_jss_material_dashboard_pro_react_views_userProfileStyles_jsx__["a" /* default */])(CompanyLoginDetails));

/***/ }),
/* 2477 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return companyLoginDetails; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_graphql_tag__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_graphql_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_graphql_tag__);
var _templateObject=_taggedTemplateLiteral(["\n  query companyLoginD($userId: Int!, $token: String!) {\n    CompanyLoginD(userId: $userId, token: $token) {\n      username\n      targetId\n      enabled\n    }\n    EnabledTargets(token: $token) {\n      id\n      name\n      logo\n    }\n    AstuteDetails(userId: $userId, token: $token) {\n      username,\n      enabled\n    }\n  }\n"],["\n  query companyLoginD($userId: Int!, $token: String!) {\n    CompanyLoginD(userId: $userId, token: $token) {\n      username\n      targetId\n      enabled\n    }\n    EnabledTargets(token: $token) {\n      id\n      name\n      logo\n    }\n    AstuteDetails(userId: $userId, token: $token) {\n      username,\n      enabled\n    }\n  }\n"]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var companyLoginDetails=__WEBPACK_IMPORTED_MODULE_0_graphql_tag___default()(_templateObject);

/***/ }),
/* 2478 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_core__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_form__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__steps_Assets__ = __webpack_require__(2479);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__steps_Dependants__ = __webpack_require__(2482);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__steps_MarketValueLiability__ = __webpack_require__(2484);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__steps_Conversion__ = __webpack_require__(2485);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__steps_OtherLiability__ = __webpack_require__(2487);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__steps_OtherIncome__ = __webpack_require__(2488);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__steps_Policies__ = __webpack_require__(2491);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__steps_Retirement__ = __webpack_require__(2493);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__steps_OtherInformation__ = __webpack_require__(2494);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__steps_Assumptions__ = __webpack_require__(632);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__steps_PersonalDetail__ = __webpack_require__(2495);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__steps_RetirementFund_RetirementFund_jsx__ = __webpack_require__(2496);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_store__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_reducers_NotificationReducer__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_helpers_ReduxHelpers__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__fna_init__ = __webpack_require__(2500);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_queries_fna_mutations__ = __webpack_require__(633);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_queries_fna_queries__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_react_apollo__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_lodash__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_helpers_UserHelper__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_helpers_UriReader__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_components_Wrappers_materialUIWrappers_components_FormCheckbox_jsx__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_helpers_DateHelpers__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_moment__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__steps_objects_FNA_result_vars__ = __webpack_require__(397);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__ResultsPage_FnaResultsPage__ = __webpack_require__(634);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/*eslint-disable*///import {FnaResultsPage} from './ResultsPage/FnaResultsPage.jsx'
var tabs=['FNA Details','Assumptions','Assets','Liabilities','Provision & Needs','Policies','Retirement','Asset Distribution','Results'];var tabStyle={color:'#6c5cab',borderBottom:'2px solid'};var checkItem=function checkItem(label,name,changeFunc){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:4,sm:4,md:2},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["t" /* FormControl */],{style:{marginBottom:"-30px",paddingBottom:"-30px"}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_26_components_Wrappers_materialUIWrappers_components_FormCheckbox_jsx__["a" /* default */],name:name,onChange:function onChange(e,f,g,h){changeFunc(h,f);}})));};var FNAWizard=function(_React$Component){_inherits(FNAWizard,_React$Component);function FNAWizard(){var _ref,_this$state;var _temp,_this,_ret;_classCallCheck(this,FNAWizard);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=FNAWizard.__proto__||Object.getPrototypeOf(FNAWizard)).call.apply(_ref,[this].concat(args))),_this),_this.state=(_this$state={messageShown1:false,result:new __WEBPACK_IMPORTED_MODULE_29__steps_objects_FNA_result_vars__["b" /* fnaResult */]().fna,editMode:false,clientId:null,client:null,capitalLoss:false,capitalLossAmount:0,accrualExclution:false,spouseDeath:false,abatementUsed:false,rebateUsed:0.00,execFee:3.5,execTax:true,vat:15,marginalTax:45},_defineProperty(_this$state,"accrualExclution",false),_defineProperty(_this$state,"accrualExcludedClient",0.00),_defineProperty(_this$state,"accrualExcludedMarrageClient",0.00),_defineProperty(_this$state,"accrualExclutionSpouse",false),_defineProperty(_this$state,"accrualExcludedSpouse",0.00),_defineProperty(_this$state,"accrualExcludedMarrageSpouse",0.00),_defineProperty(_this$state,"funeralCost",0),_defineProperty(_this$state,"adminCost",0),_defineProperty(_this$state,"inflation",0),_defineProperty(_this$state,"investmentGrowth",0),_defineProperty(_this$state,"percentageOnFarm",false),_defineProperty(_this$state,"spouseAccrual",true),_defineProperty(_this$state,"spouseAccrualValue",0),_defineProperty(_this$state,"spouseInheritFull",false),_defineProperty(_this$state,"residueAmount",100),_defineProperty(_this$state,"cashBequests",false),_defineProperty(_this$state,"bequestSpouse",0),_defineProperty(_this$state,"bequestChildren",0),_defineProperty(_this$state,"bequestOther",0),_defineProperty(_this$state,"bequestCharity",0),_defineProperty(_this$state,"residueNotTo",false),_defineProperty(_this$state,"page",0),_defineProperty(_this$state,"pageCount",8),_defineProperty(_this$state,"latestPage",0),_defineProperty(_this$state,"stepItems",{dependants:[]}),_defineProperty(_this$state,"checkValidation",false),_defineProperty(_this$state,"ignoreItems",[]),_defineProperty(_this$state,"formInitiazed",false),_defineProperty(_this$state,"assets",[]),_defineProperty(_this$state,"liabilities",[]),_defineProperty(_this$state,"policy",[]),_defineProperty(_this$state,"retirement",[]),_defineProperty(_this$state,"needs",{incomeStreams:[],incomeNeeds:[],capitalNeeds:[],cashBequests:[],totals:{incomeStreams:"R0.00",incomeNeeds:"R0.00",capitalNeeds:"R0.00",cashBequests:"R0.00"},expanded:{incomeStreams:true,incomeNeeds:false,capitalNeeds:false,cashBequests:false}}),_defineProperty(_this$state,"fnaReasons",{death:false,disability:false,retirement:false}),_defineProperty(_this$state,"deathDistribution",{expanded:{fixedAssests:false,liquidAssets:false,policies:false,bequests:false,retirement:false},totals:{fixedAssests:0,liquidAssets:0,policies:0,retirement:0},fixedAssests:[],liquidAssets:[],policies:[],retirement:[]}),_defineProperty(_this$state,"tab",0),_defineProperty(_this$state,"deleted",[]),_this$state),_this.handleChangeTab=function(event,value){if(_this.validationErrors()){return;}else{_this.state.page=value;_this.forceUpdate();}},_this.addNew=function(as){_this.setState({assets:as});console.log(JSON.stringify(as));_this.forceUpdate();},_this.addNewLiability=function(li){_this.setState({liabilities:li});console.log(JSON.stringify(li));_this.forceUpdate();},_this.addNewNeed=function(need){_this.setState({needs:need});_this.forceUpdate();},_this.changeNeedExpansion=function(expansion){_this.setState({needs:expansion});_this.forceUpdate();},_this.changeNeed=function(need){_this.setState({needs:need});_this.forceUpdate();},_this.AddIgnore=function(item){var ignoreItems=[].concat(_toConsumableArray(_this.state.ignoreItems));ignoreItems.push(item);_this.setState({ignoreItems:ignoreItems});},_this.RemoveIgnore=function(item){var ignoreItems=[].concat(_toConsumableArray(_this.state.ignoreItems));ignoreItems=ignoreItems.filter(function(i){return i!==item;});_this.setState({ignoreItems:ignoreItems});},_this.changeAsset=function(assets){_this.setState({assets:assets});_this.forceUpdate();},_this.changeLiability=function(li){_this.setState({liabilities:li});_this.forceUpdate();},_this.changePersonal=function(name,value){//this.setState({name: value})
_this.state[name]=value;/*if(name == "spouseInheritFull")
    {
      if(value == true)
      {
        this.state.residueAmount = 100;
      }
        
    }*/console.log(name);console.log(value);_this.forceUpdate();},_this.changePolicy=function(poli){var polic=[];polic=poli;_this.setState({policy:polic});_this.forceUpdate();},_this.changeRetirement=function(retirements){var ret=retirements;if(!retirements)ret=[];_this.setState({retirement:retirements});console.log();_this.forceUpdate();},_this.deathDistExpand=function(expand){_this.setState({deathDistribution:expand});},_this.changeDeathDist=function(cat,changeObj){_this.setState(_defineProperty({},cat,changeObj));},_this.changeTab=function(){_this.forceUpdate();},_this.whoof=function(){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{color:'white'}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("h4",null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("b",null,"Please note the following changes that might affect the FNA:")," ")),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{color:'white'}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("br",null)," ",__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("b",null,"New changes:")),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{color:'white'}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("br",null)," - Default values has been implemented."),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{color:'white'}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("h4",null,"NOTE: PLEASE CREATE A NEW FNA OR REFILL ALL THE DEFAULT FIELDS. ALL DEFAULT VALUES WILL TAKE EFFECT AS SOON AS CHANGES HAS BEEN ACCEPTED!")),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{color:'white'}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("br",null)," ",__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("b",null,"Previous Changes: ")),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{color:'white'}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("br",null)," - Spouse spelling was corrected, all fields related will have invalid data"),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{color:'white'}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("br",null)," - Death is now the first option"));},_this.showChanges=function(){if(!_this.state.changes1&&!_this.state.messageShown1){__WEBPACK_IMPORTED_MODULE_16_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_17_reducers_NotificationReducer__["d" /* showSnack */])({message:_this.whoof(),color:"danger",timeout:"1"}));_this.state.messageShown1=true;}},_this.validationErrors=function(){if(Object(__WEBPACK_IMPORTED_MODULE_18_helpers_ReduxHelpers__["a" /* FormHasErrors */])("newfna",_this.state.ignoreItems)){__WEBPACK_IMPORTED_MODULE_16_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_17_reducers_NotificationReducer__["d" /* showSnack */])({message:"Invalid Information",color:"danger"}));_this.setState({checkValidation:true});return true;}if(!_this.state.changes1){__WEBPACK_IMPORTED_MODULE_16_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_17_reducers_NotificationReducer__["d" /* showSnack */])({message:"Please accept that You acknowledge the changes.",color:"danger"}));_this.setState({checkValidation:true});return true;}_this.setState({checkValidation:false});return false;},_this.nextPage=function(){if(_this.validationErrors())return;_this.state.pageCount=8;//This must be taken out. Only for testing!!!!
var nextPage=_this.state.page+1;_this.setState({page:nextPage,checkValidation:false});_this.forceUpdate();},_this.previousPage=function(){if(_this.validationErrors())return;//this.setState({ checkValidation: false });
var prevPage=_this.state.page-1;_this.setState({page:prevPage,checkValidation:false});_this.forceUpdate();},_this.setStepItems=function(name,items){_this.setState({stepItems:Object.assign({},_this.state.stepItems,_defineProperty({},name,items))});},_this.initializeForm=function(){var data=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;var editMode=arguments[1];if(data){if(!editMode){_this.props.initialize(Object.assign({},data,__WEBPACK_IMPORTED_MODULE_19__fna_init__["a" /* DefaultInit */]));}else{_this.setState(data.state);_this.props.initialize(data);}}else{_this.props.initialize(__WEBPACK_IMPORTED_MODULE_19__fna_init__["a" /* DefaultInit */]);}if(data.client.dob){_this.clientDobChanged(data.client.dob);}if(!editMode)_this.setState({changes1:true});_this.setState({formInitiazed:true,editMode:data?true:false});},_this.getBrokerId=function(){var brokerId=Object(__WEBPACK_IMPORTED_MODULE_24_helpers_UserHelper__["a" /* GetUserId */])();if(_this.checkAssistantActive()){brokerId=sessionStorage.getItem("ActiveBrokerId");}return brokerId;},_this.clientDobChanged=function(val){try{if(val.length!==10)throw"Too short";var dob=Object(__WEBPACK_IMPORTED_MODULE_27_helpers_DateHelpers__["b" /* ParseDMYwSlashes */])(val);var age=__WEBPACK_IMPORTED_MODULE_28_moment___default()().diff(dob,"years");__WEBPACK_IMPORTED_MODULE_16_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_redux_form__["b" /* change */])("newfna","client.age",age));}catch(error){__WEBPACK_IMPORTED_MODULE_16_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_redux_form__["b" /* change */])("newfna","client.age",""));}_this.forceUpdate();return;},_this.submit=function(){var formValues=Object(__WEBPACK_IMPORTED_MODULE_23_lodash__["get"])(__WEBPACK_IMPORTED_MODULE_16_store__["a" /* default */].getState().form,"newfna.values",{});formValues.state=_this.state;if(_this.validationErrors())return;var input={description:Object(__WEBPACK_IMPORTED_MODULE_23_lodash__["get"])(__WEBPACK_IMPORTED_MODULE_16_store__["a" /* default */].getState().form,"newfna.values.description","Description"),formData:JSON.stringify(Object(__WEBPACK_IMPORTED_MODULE_23_lodash__["get"])(__WEBPACK_IMPORTED_MODULE_16_store__["a" /* default */].getState().form,"newfna.values",{})),brokerId:_this.getBrokerId(),clientId:_this.state.clientId,token:Object(__WEBPACK_IMPORTED_MODULE_24_helpers_UserHelper__["c" /* GetUserToken */])()};_this.props.SubmitFna({variables:{input:input}}).then(function(resp){console.log("resp",resp);__WEBPACK_IMPORTED_MODULE_16_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_17_reducers_NotificationReducer__["e" /* successWarning */])({open:true,title:"FNA Submitted!"/* onConfirm: () =>
            
              this.props.history.push({
                pathname: "/app/fnaresults",
                search: `fnaId=${resp.data.SubmitFna.id}`
              })*/}));_this.nextPage();}).catch(function(error){console.log("err",error);});},_this.update=function(){_this.forceUpdate();},_this.initializeDynamicField=function(initializor,fields){if(!_this.state.changes1)return;/* field object: 
        
        fields = [] // list of fields to place default values
        field = 
        {
          field: "",      // the list that needs to be iterated. IE. the list that dictates the amount of dynamic fields to be initialized.
          fieldName: "",  // the field name that has to have a default value
          fieldVar: "",   // the variable that needs the default value
          value: "",      // the default value
          conditions: []  // optional list of conditions
        }
    *//* Condition object:
      conditions = [] // list of condition objects
      condition = 
      {
        condition: "", // the variable that needs to be compared
        param: ""      // the value to campare with
        falseValue: "" // optional value should comparison be false
      }
      */fields.map(function(e0,i0){if(String(e0.field).split(".").length>1){console.log(e0.field.split(".")[0]);console.log(e0.field.split(".")[1]);console.log(_this.state[e0.field.split(".")[0]]);console.log(_this.state[e0.field.split(".")[0]][e0.field.split(".")[1]]);}else{console.log("WHOOF---"+e0.field);}if(e0.field.split(".").length>1)_this.state[e0.field.split(".")[0]][e0.field.split(".")[1]].map(function(e,i){var fieldName=e0.fieldName+i;if(!e[initializor])e[initializor]=[];if(!e[initializor][i0]){if(e0.conditions==null){_this.props.change(fieldName,e0.value);e[e0.fieldVar]=e0.value;}else{var conditional=false;e0.conditions.map(function(e1,i1){if(e[e1.condition]==e1.param){_this.props.change(fieldName,e0.value);e[e0.fieldVar]=e0.value;conditional=true;return;}if(e1.falseValue!=null&&!conditional){_this.props.change(fieldName,e1.falseValue);e[e0.fieldVar]=e1.falseValue;}});_this.forceUpdate();}e[initializor][i0]=true;}});else _this.state[e0.field].map(function(e,i){var fieldName=e0.fieldName+i;if(!e[initializor])e[initializor]=[];if(!e[initializor][i0]){if(e0.conditions==null){_this.props.change(fieldName,e0.value);e[e0.fieldVar]=e0.value;console.log(fieldName+" ----- "+e0.value+" >>> "+i0);}else{var conditional=false;e0.conditions.map(function(e1,i1){if(e[e1.condition]==e1.param){_this.props.change(fieldName,e0.value);e[e0.fieldVar]=e0.value;conditional=true;return;}if(e1.falseValue!=null&&!conditional){_this.props.change(fieldName,e1.falseValue);e[e0.fieldVar]=e1.falseValue;}});_this.forceUpdate();}e[initializor][i0]=true;}});});},_temp),_possibleConstructorReturn(_this,_ret);}//Many of the defult values are set here, but only for the state object. The form fields' default values are set using the fna_init.js file.
//Some changes will need to be made so as not to have to change the value twice for every default.
//Also aware that this is not strictly the correct way of handling the form, But using the redux store is a pain and overly complex.
//whoof is just a temporary function for alerting changes that might break older FNA's when editing.
_createClass(FNAWizard,[{key:"checkAssistantActive",value:function checkAssistantActive(){if(Object(__WEBPACK_IMPORTED_MODULE_24_helpers_UserHelper__["b" /* GetUserKey */])("userType")==="6"){if(!this.state.assistantActive){this.setState({assistantActive:true});}return true;}return false;}},{key:"render",value:function render(){var _this2=this;var params=Object(__WEBPACK_IMPORTED_MODULE_25_helpers_UriReader__["a" /* ParseUriParams */])(this.props.location.search);this.state.params=params;var id=params.id,clientId=params.clientId;var page=this.state.page;if(!this.state.changes1&&this.state.formInitiazed){this.showChanges();}return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22_react_apollo__["Query"],{query:__WEBPACK_IMPORTED_MODULE_21_queries_fna_queries__["a" /* FnaById */],variables:{clientId:clientId,fnaId:id?id:null},fetchPolicy:"network-only"},function(_ref2){var loading=_ref2.loading,error=_ref2.error,data=_ref2.data;if(loading)return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["B" /* LinearProgress */],null));if(error)return"Error! "+error.message;var form_data=__WEBPACK_IMPORTED_MODULE_23_lodash___default.a.get(data,"FnaById.form_data",null);var editMode=__WEBPACK_IMPORTED_MODULE_23_lodash___default.a.get(data,"FnaById.editMode",false);var formData=form_data?JSON.parse(form_data):null;if(formData)_this2.client=formData.client;console.log(_this2.client);if(!_this2.state.formInitiazed){_this2.initializeForm(formData,editMode);_this2.setState({clientId:clientId});_this2.setState({client:formData.client});}return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{container:true},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:10,style:{margin:"auto",width:"100%"}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div",{className:"fixedStepper"},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{container:true},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:10,style:{flexBasis:"100%",maxWidth:"100%",margin:'auto'}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div",{className:"stepperDiv"},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["G" /* MobileStepper */],{type:"progress",steps:_this2.state.pageCount,position:"static",activeStep:_this2.state.page,nextButton:__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div",{style:{display:"flex"}},_this2.state.page===_this2.state.pageCount-1?__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["d" /* Button */],{variant:"outlined",className:"outlinedButton",color:"secondary",style:{marginRight:"10px"},onClick:function onClick(){return _this2.submit();}},"Submit"):__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div",null),_this2.state.page===_this2.state.pageCount-1?null:__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["d" /* Button */],{variant:"outlined",className:"outlinedButton",color:"secondary",style:{marginRight:"10px"},onClick:function onClick(){return _this2.nextPage();}},"Next")),backButton:__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["d" /* Button */],{variant:"outlined",className:"outlinedButton",color:"secondary",style:{marginLeft:"10px"},onClick:function onClick(){return _this2.previousPage();},disabled:_this2.state.page===0?true:false},"Back")}))))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("br",null),!_this2.state.changes1&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:24,sm:24,md:6,style:{marginBottom:'25px'}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{container:true},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:6,sm:6,md:10,style:{marginBottom:'0px'}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px'}},"Changes to the FNA has been made. Please confirm that all information is correct.")),checkItem("","changes1",_this2.changePersonal))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["a" /* AppBar */],{position:"static",color:"default",style:{marginBottom:'-20px',marginTop:'10px',marginLeft:"25px"}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["W" /* Tabs */],{tab:_this2.state.page,onChange:_this2.handleChangeTab,indicatorColor:"primary",textColor:"secondary",scrollable:true,scrollButtons:"auto"},tabs.map(function(t,i){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["P" /* Tab */],{label:t,style:i===_this2.state.page?tabStyle:{marginRight:"-15px"}});}))),page===0&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__steps_PersonalDetail__["a" /* default */],{checkValidation:_this2.state.checkValidation,scrollMeBar:_this2.props.scrollMeBar,changePersonal:_this2.changePersonal.bind(_this2),fnaReasons:_this2.state.fnaReasons,state:_this2.state}),page===1&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__steps_Assumptions__["a" /* default */],{checkValidation:_this2.state.checkValidation,scrollMeBar:_this2.props.scrollMeBar,state:_this2.state}),page===99&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__steps_Dependants__["a" /* default */],{setStepItems:_this2.setStepItems,dependants:_this2.state.stepItems.dependants,checkValidation:_this2.state.checkValidation,AddIgnore:_this2.AddIgnore,RemoveIgnore:_this2.RemoveIgnore,scrollMeBar:_this2.props.scrollMeBar}),page===2&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__steps_Assets__["a" /* default */],{setStepItems:_this2.setStepItems,checkValidation:_this2.state.checkValidation,initialize:_this2.props.initialize,AddIgnore:_this2.AddIgnore,RemoveIgnore:_this2.RemoveIgnore,scrollMeBar:_this2.props.scrollMeBar,addNew:_this2.addNew.bind(_this2),changeAsset:_this2.changeAsset.bind(_this2),state:_this2.state,assets:_this2.state.assets,initializeDynamicField:_this2.initializeDynamicField.bind(_this2),changeTab:_this2.changeTab.bind(_this2)}),page===3&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__steps_MarketValueLiability__["a" /* default */],{setStepItems:_this2.setStepItems,assets:_this2.state.stepItems.assets,checkValidation:_this2.state.checkValidation,scrollMeBar:_this2.props.scrollMeBar,addNewLiability:_this2.addNewLiability,changeLiability:_this2.changeLiability.bind(_this2),state:_this2.state}),page===4&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__steps_Conversion__["a" /* default */],{setStepItems:_this2.setStepItems,assets:_this2.state.stepItems.assets,checkValidation:_this2.state.checkValidation,AddIgnore:_this2.AddIgnore,RemoveIgnore:_this2.RemoveIgnore,scrollMeBar:_this2.props.scrollMeBar,addNewNeed:_this2.addNewNeed,changeNeedExpansion:_this2.changeNeedExpansion,changeNeed:_this2.changeNeed.bind(_this2),state:_this2.state}),page===99&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__steps_OtherLiability__["a" /* default */],{checkValidation:_this2.state.checkValidation,AddIgnore:_this2.AddIgnore,RemoveIgnore:_this2.RemoveIgnore,scrollMeBar:_this2.props.scrollMeBar}),page===5&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__steps_Policies__["a" /* default */],{checkValidation:_this2.state.checkValidation,AddIgnore:_this2.AddIgnore,RemoveIgnore:_this2.RemoveIgnore,scrollMeBar:_this2.props.scrollMeBar,policy:_this2.state.policy,changePolicy:_this2.changePolicy.bind(),state:_this2.state,initializeDynamicField:_this2.initializeDynamicField.bind(_this2)}),page===6&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__steps_Retirement__["a" /* default */],{checkValidation:_this2.state.checkValidation,scrollMeBar:_this2.props.scrollMeBar,changeRetirement:_this2.changeRetirement.bind(),state:_this2.state}),page===7&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__steps_OtherIncome__["a" /* default */],{checkValidation:_this2.state.checkValidation,AddIgnore:_this2.AddIgnore,RemoveIgnore:_this2.RemoveIgnore,scrollMeBar:_this2.props.scrollMeBar,deathDistExpand:_this2.deathDistExpand.bind(),changeDeathDist:_this2.changeDeathDist.bind(),update:_this2.update.bind(),state:_this2.state,initializeDynamicField:_this2.initializeDynamicField.bind(_this2)}),page===8&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_30__ResultsPage_FnaResultsPage__["a" /* default */],{checkValidation:_this2.state.checkValidation,scrollMeBar:_this2.props.scrollMeBar,changeTab:_this2.changeTab.bind(),state:_this2.state})));});}}]);return FNAWizard;}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);FNAWizard=Object(__WEBPACK_IMPORTED_MODULE_3_redux_form__["e" /* reduxForm */])({form:"newfna",destroyOnUnmount:true})(FNAWizard);FNAWizard=Object(__WEBPACK_IMPORTED_MODULE_22_react_apollo__["compose"])(Object(__WEBPACK_IMPORTED_MODULE_22_react_apollo__["graphql"])(__WEBPACK_IMPORTED_MODULE_20_queries_fna_mutations__["a" /* SubmitFna */],{name:"SubmitFna"}))(FNAWizard);/* harmony default export */ __webpack_exports__["a"] = (FNAWizard);

/***/ }),
/* 2479 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_core__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_Wrappers_materialUIWrappers_components_FormCheckbox_jsx__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_Wrappers_materialUIWrappers_components_FormInput__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Wrappers_materialUIWrappers_components_NumberInput__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_helpers_ReduxHelpers__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_redux_form__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_store__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_CustomCardHeading_jsx__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_DescriptiveRow_jsx__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__objects_assetItems__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_Wrappers_materialUIWrappers_components_FormDropDown__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_Grid_GridItem_jsx__ = __webpack_require__(12);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var colwidth=function colwidth(value){return{width:value,minWidth:value,maxWidth:value,margin:"0px"};};var CustomField=function CustomField(props){return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall"},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["t" /* FormControl */],{fullWidth:true},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_redux_form__["a" /* Field */],props)));};var CustomField2=function CustomField2(props){return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["t" /* FormControl */],{fullWidth:true,style:{bottom:"10px"}},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_redux_form__["a" /* Field */],props));};function isInteger(value){return /^\d+$/.test(value);}var percentage=function percentage(value){if(value===undefined)return undefined;if(isNaN(value)){return"Must be a number";}if(parseInt(value,10)>=101||parseInt(value,10)<0){return"Not a valid Percentage";}return undefined;};var hundred=function hundred(value){if(value===undefined)return undefined;if(isNaN(value)){return"Must be a number";}if(parseInt(value,10)!==100){return"Must add up to 100";}return undefined;};var asset=function asset(value){return{category:"",description:"",ownershipClient:0,ownershipSpouse:0,ownershipOther:0,cgtPayable:false,marketValue:0,baseCost:0,liability:0,liquid:false,estateInherit:0,spouseInherit:0,dependentsInherit:0,trustInherit:0,otherInherit:0,charityInherit:0,deleted:false};};var Assets=function(_React$Component){_inherits(Assets,_React$Component);function Assets(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Assets);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Assets.__proto__||Object.getPrototypeOf(Assets)).call.apply(_ref,[this].concat(args))),_this),_this.required=function(value,a,b,c){_this.props.changeTab();console.log("req check",value," ",a," ",b," ",c," ");var i=c.split(".")[2];console.log(i," --> ",_this.props.state.assets.length," ---> ",_this.props.state.assets[i].deleted," ---> ",a.state.assets[i]," ---> ",JSON.stringify(_this.props.state.deleted));if(_this.props.state.assets[i].deleted){console.log("WE MUST RETURN THE SLAB");return;}return value?undefined:"Required";},_this.mustBeFullPercentage=function(value,a,b,c){var i=c.replace("asset.ownershipClient.","").replace("asset.ownershipSpouse.","").replace("asset.ownershipOther.","");var asset=_this.props.state.assets[i];var fullPercentage=parseInt(asset.ownershipClient)+parseInt(asset.ownershipSpouse)+parseInt(asset.ownershipOther);console.log("Testing persentage "+i+" "+JSON.stringify(asset));if(fullPercentage!=100)return"Must add up to 100";return undefined;},_this.addNew=function(){var assets=_this.props.state.assets;assets.push(asset());_this.props.addNew(assets);console.log("--->} "+JSON.stringify(_this.props.state.assets));},_this.remove=function(n){var assets=_this.props.state.assets;var newAss=[];var node=n.target;while(node.nodeName!="BUTTON"&&node.parentNode!=null){node=node.parentNode;}var i=node.name.replace("remove","");console.log(i);//assets.splice(i, 1)
//assets[i] = null;
assets.map(function(e,k){if(e!=assets[i])newAss[k]=e;if(e==assets[i]){assets[i].deleted=true;_this.props.state.deleted.push(i);}});_this.props.addNew(newAss);},_this.changeCat=function(value,name){var assets=_this.props.state.assets;var asset=name.replace("asset.category.","");assets[asset].category=value;assets[asset].assetsInit[3]=null;_this.props.changeAsset(assets);},_this.changeDesc=function(value,name){var assets=_this.props.state.assets;var asset=name.replace("asset.description.","");assets[asset].description=value;_this.props.changeAsset(assets);},_this.changeOwnerC=function(name,value){var assets=_this.props.state.assets;console.log("---------) "+value+" "+name);var asset=name.replace("asset.ownershipClient.","");assets[asset].ownershipClient=value;_this.props.changeAsset(assets);},_this.changeOwnerS=function(name,value){var assets=_this.props.state.assets;var asset=name.replace("asset.ownershipSpouse.","");assets[asset].ownershipSpouse=value;_this.props.changeAsset(assets);},_this.changeOwnerO=function(name,value){var assets=_this.props.state.assets;var asset=name.replace("asset.ownershipOther.","");assets[asset].ownershipOther=value;_this.props.changeAsset(assets);},_this.changeCgt=function(value,name){var assets=_this.props.state.assets;var asset=name.replace("asset.cgtPayable.","");assets[asset].cgtPayable=value;_this.props.changeAsset(assets);console.log("=====> "+value+" "+JSON.stringify(_this.props.state.assets[asset]));},_this.changeMarket=function(value,name){var assets=_this.props.state.assets;var asset=name.replace("asset.marketValue.","");assets[asset].marketValue=value;_this.props.changeAsset(assets);},_this.changeBase=function(value,name){var assets=_this.props.state.assets;var asset=name.replace("asset.baseValue.","");assets[asset].baseCost=value;_this.props.changeAsset(assets);},_this.changeLiable=function(value,name){var assets=_this.props.state.assets;var asset=name.replace("asset.liability.","");assets[asset].liability=value;_this.props.changeAsset(assets);},_this.checkItem=function(label,name,changeFunc){return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["t" /* FormControl */],{style:{marginBottom:"-30px",paddingBottom:"-30px"}},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_1_components_Wrappers_materialUIWrappers_components_FormCheckbox_jsx__["a" /* default */],name:name,onChange:function onChange(e,f,g,h){changeFunc(f,h);}}));},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Assets,[{key:"componentDidMount",value:function componentDidMount(){this.props.scrollMeBar();}},{key:"componentDidUpdate",value:function componentDidUpdate(){// Initializing dynamic fields. See initializeDynamicField decleration for structure.
var fields=[{field:"assets",fieldName:"asset.ownershipClient.",fieldVar:"ownershipClient",value:"100"},{field:"assets",fieldName:"asset.ownershipSpouse.",fieldVar:"ownershipSpouse",value:"0"},{field:"assets",fieldName:"asset.ownershipOther.",fieldVar:"ownershipOther",value:"0"},{field:"assets",fieldName:"asset.cgtPayable.",fieldVar:"cgtPayable",value:true,conditions:[{condition:"category",param:"other_residential",falseValue:false},{condition:"category",param:"primary_residential",falseValue:false},{condition:"category",param:"jse_shares",falseValue:false},{condition:"category",param:"farms_owned",falseValue:false},{condition:"category",param:"investments",falseValue:false},{condition:"category",param:"interest_in_partnership",falseValue:false},{condition:"category",param:"interest_in_close_corporation",falseValue:false},{condition:"category",param:"shareholding_in_private_company",falseValue:false}]},{field:"assets",fieldName:"asset.liability.",fieldVar:"liability",value:"0"}];if(this.props.state.changes1)this.props.initializeDynamicField("assetsInit",fields);}},{key:"render",value:function render(){var _this2=this;var checkValidation=this.props.checkValidation;var clientD="";if(this.props.state.client)clientD=this.props.state.client.first_name+" "+this.props.state.client.surname;return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement("div",{className:"contentWithStepper",style:{width:"120%",marginLeft:"-10%",height:"fit-content"}},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["e" /* Card */],null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["f" /* CardContent */],null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_CustomCardHeading_jsx__["a" /* default */],{subheading:"Financial Needs Analysis",caption:clientD,headline:"Assets"}),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{container:true,spacing:24,className:"customTableAutoGrid"},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Q" /* Table */],{className:"customTable1"},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["T" /* TableHead */],{className:"fixedHead"},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingTiny",style:colwidth("23em"),rowSpan:2},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center"}},"Category")),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall",style:colwidth("15em"),rowSpan:2},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px'}},"Asset Description")),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingTiny",style:colwidth("16em"),colSpan:3},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center",verticalAlign:'bottom'}},"Ownership")),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall",style:colwidth("6em"),rowSpan:2},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center"}},"CGT Payable?")),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall",style:colwidth("8em"),rowSpan:2},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center"}},"Base Cost")),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall",style:colwidth("8em"),rowSpan:2},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center"}},"Market Value")),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall",style:colwidth("8em"),rowSpan:2},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center"}},"Liability"))),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall"},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center"}},"Client")),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall"},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center"}},"Spouse ")),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall"},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center"}},"Other ")))),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["R" /* TableBody */],null,this.props.state.assets.map(function(e,i){return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],{key:i},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["d" /* Button */],{name:"remove"+i,key:"remove"+i,variant:"fab",mini:true,className:"minifab",color:"primary",style:{left:"-20px",top:"-5px"},onClick:function onClick(e){e.stopPropagation();_this2.remove(e);}},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["w" /* Icon */],{style:{color:"white"}},"remove")),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(CustomField2,{name:"asset.category."+i,component:__WEBPACK_IMPORTED_MODULE_12_components_Wrappers_materialUIWrappers_components_FormDropDown__["a" /* default */],checkValidation:_this2.props.checkValidation,label:'',isrequired:true//validate={[required]}
,options:__WEBPACK_IMPORTED_MODULE_11__objects_assetItems__["a" /* assetItems */],onChange:function onChange(e,value,t,name){return _this2.changeCat(value,name);}})),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(CustomField,{name:'asset.description.'+i,component:__WEBPACK_IMPORTED_MODULE_2_components_Wrappers_materialUIWrappers_components_FormInput__["a" /* default */],checkValidation:_this2.props.checkValidation,label:'description',isrequired:false,validate:[_this2.required],onChange:function onChange(e,value,t,name){return _this2.changeDesc(value,name);}}),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(CustomField,{name:'asset.ownershipClient.'+i,suffix:"%",component:__WEBPACK_IMPORTED_MODULE_3_components_Wrappers_materialUIWrappers_components_NumberInput__["a" /* default */],checkValidation:_this2.props.checkValidation,label:'%*',isrequired:true,validate:[_this2.required,_this2.mustBeFullPercentage],onChange:function onChange(e,f,g,h){_this2.changeOwnerC(h,f);}}),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(CustomField,{name:'asset.ownershipSpouse.'+i,suffix:"%",component:__WEBPACK_IMPORTED_MODULE_3_components_Wrappers_materialUIWrappers_components_NumberInput__["a" /* default */],checkValidation:_this2.props.checkValidation,label:'%*',isrequired:true,validate:[_this2.required,_this2.mustBeFullPercentage],onChange:function onChange(e,f,g,h){_this2.changeOwnerS(h,f);}}),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(CustomField,{name:'asset.ownershipOther.'+i,suffix:"%",component:__WEBPACK_IMPORTED_MODULE_3_components_Wrappers_materialUIWrappers_components_NumberInput__["a" /* default */],checkValidation:_this2.props.checkValidation,label:'%*',isrequired:true,validate:[_this2.required,_this2.mustBeFullPercentage],onChange:function onChange(e,f,g,h){_this2.changeOwnerO(h,f);}}),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall"},_this2.checkItem("","asset.cgtPayable."+i,_this2.changeCgt)),_this2.props.state.assets[i].cgtPayable&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(CustomField,{name:'asset.baseValue.'+i,prefix:"R",component:__WEBPACK_IMPORTED_MODULE_3_components_Wrappers_materialUIWrappers_components_NumberInput__["a" /* default */],checkValidation:_this2.props.checkValidation,label:'R*',isrequired:true,validate:[_this2.required],disabled:true,onChange:function onChange(e,f,g,h){_this2.changeBase(f,h);}}),!_this2.props.state.assets[i].cgtPayable&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall"}),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(CustomField,{name:'asset.marketValue.'+i,prefix:"R",component:__WEBPACK_IMPORTED_MODULE_3_components_Wrappers_materialUIWrappers_components_NumberInput__["a" /* default */],checkValidation:_this2.props.checkValidation,label:'R*',isrequired:false,validate:[_this2.required],onChange:function onChange(e,f,g,h){_this2.changeMarket(f,h);}}),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(CustomField,{name:'asset.liability.'+i,prefix:"R",component:__WEBPACK_IMPORTED_MODULE_3_components_Wrappers_materialUIWrappers_components_NumberInput__["a" /* default */],checkValidation:_this2.props.checkValidation,label:'R*',isrequired:true,validate:[_this2.required],onChange:function onChange(e,f,g,h){_this2.changeLiable(f,h);}}));}),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Q" /* Table */],{style:{width:"10em"}},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_DescriptiveRow_jsx__["a" /* default */],{description:"Add Asset",add:function add(){return _this2.addNew();},extraCells:10})))))))));}}]);return Assets;}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Assets);

/***/ }),
/* 2480 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _react = _interopRequireDefault(__webpack_require__(0));

var _utils = __webpack_require__(2481);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

var propTypes = {
  thousandSeparator: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.oneOf([true])]),
  decimalSeparator: _propTypes.default.string,
  decimalScale: _propTypes.default.number,
  fixedDecimalScale: _propTypes.default.bool,
  displayType: _propTypes.default.oneOf(['input', 'text']),
  prefix: _propTypes.default.string,
  suffix: _propTypes.default.string,
  format: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func]),
  removeFormatting: _propTypes.default.func,
  mask: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.arrayOf(_propTypes.default.string)]),
  value: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
  isNumericString: _propTypes.default.bool,
  customInput: _propTypes.default.func,
  allowNegative: _propTypes.default.bool,
  allowEmptyFormatting: _propTypes.default.bool,
  onValueChange: _propTypes.default.func,
  onKeyDown: _propTypes.default.func,
  onMouseUp: _propTypes.default.func,
  onChange: _propTypes.default.func,
  onFocus: _propTypes.default.func,
  onBlur: _propTypes.default.func,
  type: _propTypes.default.oneOf(['text', 'tel']),
  isAllowed: _propTypes.default.func,
  renderText: _propTypes.default.func,
  getInputRef: _propTypes.default.func
};
var defaultProps = {
  displayType: 'input',
  decimalSeparator: '.',
  fixedDecimalScale: false,
  prefix: '',
  suffix: '',
  allowNegative: true,
  allowEmptyFormatting: false,
  isNumericString: false,
  type: 'text',
  onValueChange: _utils.noop,
  onChange: _utils.noop,
  onKeyDown: _utils.noop,
  onMouseUp: _utils.noop,
  onFocus: _utils.noop,
  onBlur: _utils.noop,
  isAllowed: _utils.returnTrue,
  getInputRef: _utils.noop
};

var NumberFormat =
/*#__PURE__*/
function (_React$Component) {
  _inherits(NumberFormat, _React$Component);

  function NumberFormat(props) {
    var _this;

    _classCallCheck(this, NumberFormat);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(NumberFormat).call(this, props)); //validate props

    _this.validateProps();

    var formattedValue = _this.formatValueProp();

    _this.state = {
      value: formattedValue,
      numAsString: _this.removeFormatting(formattedValue)
    };
    _this.selectionBeforeInput = {
      selectionStart: 0,
      selectionEnd: 0
    };
    _this.onChange = _this.onChange.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.onKeyDown = _this.onKeyDown.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.onMouseUp = _this.onMouseUp.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.onFocus = _this.onFocus.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.onBlur = _this.onBlur.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    return _this;
  }

  _createClass(NumberFormat, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      this.updateValueIfRequired(prevProps);
    }
  }, {
    key: "updateValueIfRequired",
    value: function updateValueIfRequired(prevProps) {
      var props = this.props,
          state = this.state;

      if (prevProps !== props) {
        //validate props
        this.validateProps();
        var stateValue = state.value;
        var lastNumStr = state.numAsString || '';
        var lastValueWithNewFormat = this.formatNumString(lastNumStr);
        var formattedValue = props.value === undefined ? lastValueWithNewFormat : this.formatValueProp();
        var numAsString = this.removeFormatting(formattedValue);
        var floatValue = parseFloat(numAsString);
        var lastFloatValue = parseFloat(lastNumStr);

        if ((!isNaN(floatValue) || !isNaN(lastFloatValue)) && floatValue !== lastFloatValue || lastValueWithNewFormat !== stateValue) {
          this.setState({
            value: formattedValue,
            numAsString: numAsString
          });
        }
      }
    }
    /** Misc methods **/

  }, {
    key: "getFloatString",
    value: function getFloatString() {
      var num = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var decimalScale = this.props.decimalScale;

      var _this$getSeparators = this.getSeparators(),
          decimalSeparator = _this$getSeparators.decimalSeparator;

      var numRegex = this.getNumberRegex(true); //remove negation for regex check

      var hasNegation = num[0] === '-';
      if (hasNegation) num = num.replace('-', ''); //if decimal scale is zero remove decimal and number after decimalSeparator

      if (decimalSeparator && decimalScale === 0) {
        num = num.split(decimalSeparator)[0];
      }

      num = (num.match(numRegex) || []).join('').replace(decimalSeparator, '.'); //remove extra decimals

      var firstDecimalIndex = num.indexOf('.');

      if (firstDecimalIndex !== -1) {
        num = "".concat(num.substring(0, firstDecimalIndex), ".").concat(num.substring(firstDecimalIndex + 1, num.length).replace(new RegExp((0, _utils.escapeRegExp)(decimalSeparator), 'g'), ''));
      } //add negation back


      if (hasNegation) num = '-' + num;
      return num;
    } //returned regex assumes decimalSeparator is as per prop

  }, {
    key: "getNumberRegex",
    value: function getNumberRegex(g, ignoreDecimalSeparator) {
      var _this$props = this.props,
          format = _this$props.format,
          decimalScale = _this$props.decimalScale;

      var _this$getSeparators2 = this.getSeparators(),
          decimalSeparator = _this$getSeparators2.decimalSeparator;

      return new RegExp('\\d' + (decimalSeparator && decimalScale !== 0 && !ignoreDecimalSeparator && !format ? '|' + (0, _utils.escapeRegExp)(decimalSeparator) : ''), g ? 'g' : undefined);
    }
  }, {
    key: "getSeparators",
    value: function getSeparators() {
      var decimalSeparator = this.props.decimalSeparator;
      var thousandSeparator = this.props.thousandSeparator;

      if (thousandSeparator === true) {
        thousandSeparator = ',';
      }

      return {
        decimalSeparator: decimalSeparator,
        thousandSeparator: thousandSeparator
      };
    }
  }, {
    key: "getMaskAtIndex",
    value: function getMaskAtIndex(index) {
      var _this$props$mask = this.props.mask,
          mask = _this$props$mask === void 0 ? ' ' : _this$props$mask;

      if (typeof mask === 'string') {
        return mask;
      }

      return mask[index] || ' ';
    }
  }, {
    key: "getValueObject",
    value: function getValueObject(formattedValue, numAsString) {
      var floatValue = parseFloat(numAsString);
      return {
        formattedValue: formattedValue,
        value: numAsString,
        floatValue: isNaN(floatValue) ? undefined : floatValue
      };
    }
  }, {
    key: "validateProps",
    value: function validateProps() {
      var mask = this.props.mask; //validate decimalSeparator and thousandSeparator

      var _this$getSeparators3 = this.getSeparators(),
          decimalSeparator = _this$getSeparators3.decimalSeparator,
          thousandSeparator = _this$getSeparators3.thousandSeparator;

      if (decimalSeparator === thousandSeparator) {
        throw new Error("\n          Decimal separator can't be same as thousand separator.\n          thousandSeparator: ".concat(thousandSeparator, " (thousandSeparator = {true} is same as thousandSeparator = \",\")\n          decimalSeparator: ").concat(decimalSeparator, " (default value for decimalSeparator is .)\n       "));
      } //validate mask


      if (mask) {
        var maskAsStr = mask === 'string' ? mask : mask.toString();

        if (maskAsStr.match(/\d/g)) {
          throw new Error("\n          Mask ".concat(mask, " should not contain numeric character;\n        "));
        }
      }
    }
    /** Misc methods end **/

    /** caret specific methods **/

  }, {
    key: "setPatchedCaretPosition",
    value: function setPatchedCaretPosition(el, caretPos, currentValue) {
      /* setting caret position within timeout of 0ms is required for mobile chrome,
      otherwise browser resets the caret position after we set it
      We are also setting it without timeout so that in normal browser we don't see the flickering */
      (0, _utils.setCaretPosition)(el, caretPos);
      setTimeout(function () {
        if (el.value === currentValue) (0, _utils.setCaretPosition)(el, caretPos);
      }, 0);
    }
    /* This keeps the caret within typing area so people can't type in between prefix or suffix */

  }, {
    key: "correctCaretPosition",
    value: function correctCaretPosition(value, caretPos, direction) {
      var _this$props2 = this.props,
          prefix = _this$props2.prefix,
          suffix = _this$props2.suffix,
          format = _this$props2.format; //if value is empty return 0

      if (value === '') return 0; //caret position should be between 0 and value length

      caretPos = (0, _utils.clamp)(caretPos, 0, value.length); //in case of format as number limit between prefix and suffix

      if (!format) {
        var hasNegation = value[0] === '-';
        return (0, _utils.clamp)(caretPos, prefix.length + (hasNegation ? 1 : 0), value.length - suffix.length);
      } //in case if custom format method don't do anything


      if (typeof format === 'function') return caretPos;
      /* in case format is string find the closest # position from the caret position */
      //in case the caretPos have input value on it don't do anything

      if (format[caretPos] === '#' && (0, _utils.charIsNumber)(value[caretPos])) return caretPos; //if caretPos is just after input value don't do anything

      if (format[caretPos - 1] === '#' && (0, _utils.charIsNumber)(value[caretPos - 1])) return caretPos; //find the nearest caret position

      var firstHashPosition = format.indexOf('#');
      var lastHashPosition = format.lastIndexOf('#'); //limit the cursor between the first # position and the last # position

      caretPos = (0, _utils.clamp)(caretPos, firstHashPosition, lastHashPosition + 1);
      var nextPos = format.substring(caretPos, format.length).indexOf('#');
      var caretLeftBound = caretPos;
      var caretRightBound = caretPos + (nextPos === -1 ? 0 : nextPos); //get the position where the last number is present

      while (caretLeftBound > firstHashPosition && (format[caretLeftBound] !== '#' || !(0, _utils.charIsNumber)(value[caretLeftBound]))) {
        caretLeftBound -= 1;
      }

      var goToLeft = !(0, _utils.charIsNumber)(value[caretRightBound]) || direction === 'left' && caretPos !== firstHashPosition || caretPos - caretLeftBound < caretRightBound - caretPos;

      if (goToLeft) {
        //check if number should be taken after the bound or after it
        //if number preceding a valid number keep it after
        return (0, _utils.charIsNumber)(value[caretLeftBound]) ? caretLeftBound + 1 : caretLeftBound;
      }

      return caretRightBound;
    }
  }, {
    key: "getCaretPosition",
    value: function getCaretPosition(inputValue, formattedValue, caretPos) {
      var format = this.props.format;
      var stateValue = this.state.value;
      var numRegex = this.getNumberRegex(true);
      var inputNumber = (inputValue.match(numRegex) || []).join('');
      var formattedNumber = (formattedValue.match(numRegex) || []).join('');
      var j, i;
      j = 0;

      for (i = 0; i < caretPos; i++) {
        var currentInputChar = inputValue[i] || '';
        var currentFormatChar = formattedValue[j] || ''; //no need to increase new cursor position if formatted value does not have those characters
        //case inputValue = 1a23 and formattedValue =  123

        if (!currentInputChar.match(numRegex) && currentInputChar !== currentFormatChar) continue; //When we are striping out leading zeros maintain the new cursor position
        //Case inputValue = 00023 and formattedValue = 23;

        if (currentInputChar === '0' && currentFormatChar.match(numRegex) && currentFormatChar !== '0' && inputNumber.length !== formattedNumber.length) continue; //we are not using currentFormatChar because j can change here

        while (currentInputChar !== formattedValue[j] && j < formattedValue.length) {
          j++;
        }

        j++;
      }

      if (typeof format === 'string' && !stateValue) {
        //set it to the maximum value so it goes after the last number
        j = formattedValue.length;
      } //correct caret position if its outside of editable area


      j = this.correctCaretPosition(formattedValue, j);
      return j;
    }
    /** caret specific methods ends **/

    /** methods to remove formattting **/

  }, {
    key: "removePrefixAndSuffix",
    value: function removePrefixAndSuffix(val) {
      var _this$props3 = this.props,
          format = _this$props3.format,
          prefix = _this$props3.prefix,
          suffix = _this$props3.suffix; //remove prefix and suffix

      if (!format && val) {
        var isNegative = val[0] === '-'; //remove negation sign

        if (isNegative) val = val.substring(1, val.length); //remove prefix

        val = prefix && val.indexOf(prefix) === 0 ? val.substring(prefix.length, val.length) : val; //remove suffix

        var suffixLastIndex = val.lastIndexOf(suffix);
        val = suffix && suffixLastIndex !== -1 && suffixLastIndex === val.length - suffix.length ? val.substring(0, suffixLastIndex) : val; //add negation sign back

        if (isNegative) val = '-' + val;
      }

      return val;
    }
  }, {
    key: "removePatternFormatting",
    value: function removePatternFormatting(val) {
      var format = this.props.format;
      var formatArray = format.split('#').filter(function (str) {
        return str !== '';
      });
      var start = 0;
      var numStr = '';

      for (var i = 0, ln = formatArray.length; i <= ln; i++) {
        var part = formatArray[i] || ''; //if i is the last fragment take the index of end of the value
        //For case like +1 (911) 911 91 91 having pattern +1 (###) ### ## ##

        var index = i === ln ? val.length : val.indexOf(part, start);
        /* in any case if we don't find the pattern part in the value assume the val as numeric string
        This will be also in case if user has started typing, in any other case it will not be -1
        unless wrong prop value is provided */

        if (index === -1) {
          numStr = val;
          break;
        } else {
          numStr += val.substring(start, index);
          start = index + part.length;
        }
      }

      return (numStr.match(/\d/g) || []).join('');
    }
  }, {
    key: "removeFormatting",
    value: function removeFormatting(val) {
      var _this$props4 = this.props,
          format = _this$props4.format,
          removeFormatting = _this$props4.removeFormatting;
      if (!val) return val;

      if (!format) {
        val = this.removePrefixAndSuffix(val);
        val = this.getFloatString(val);
      } else if (typeof format === 'string') {
        val = this.removePatternFormatting(val);
      } else if (typeof removeFormatting === 'function') {
        //condition need to be handled if format method is provide,
        val = removeFormatting(val);
      } else {
        val = (val.match(/\d/g) || []).join('');
      }

      return val;
    }
    /** methods to remove formattting end **/

    /*** format specific methods start ***/

    /**
     * Format when # based string is provided
     * @param  {string} numStr Numeric String
     * @return {string}        formatted Value
     */

  }, {
    key: "formatWithPattern",
    value: function formatWithPattern(numStr) {
      var format = this.props.format;
      var hashCount = 0;
      var formattedNumberAry = format.split('');

      for (var i = 0, ln = format.length; i < ln; i++) {
        if (format[i] === '#') {
          formattedNumberAry[i] = numStr[hashCount] || this.getMaskAtIndex(hashCount);
          hashCount += 1;
        }
      }

      return formattedNumberAry.join('');
    }
    /**
     * @param  {string} numStr Numeric string/floatString] It always have decimalSeparator as .
     * @return {string} formatted Value
     */

  }, {
    key: "formatAsNumber",
    value: function formatAsNumber(numStr) {
      var _this$props5 = this.props,
          decimalScale = _this$props5.decimalScale,
          fixedDecimalScale = _this$props5.fixedDecimalScale,
          prefix = _this$props5.prefix,
          suffix = _this$props5.suffix,
          allowNegative = _this$props5.allowNegative;

      var _this$getSeparators4 = this.getSeparators(),
          thousandSeparator = _this$getSeparators4.thousandSeparator,
          decimalSeparator = _this$getSeparators4.decimalSeparator;

      var hasDecimalSeparator = numStr.indexOf('.') !== -1 || decimalScale && fixedDecimalScale;

      var _splitDecimal = (0, _utils.splitDecimal)(numStr, allowNegative),
          beforeDecimal = _splitDecimal.beforeDecimal,
          afterDecimal = _splitDecimal.afterDecimal,
          addNegation = _splitDecimal.addNegation; // eslint-disable-line prefer-const
      //apply decimal precision if its defined


      if (decimalScale !== undefined) afterDecimal = (0, _utils.limitToScale)(afterDecimal, decimalScale, fixedDecimalScale);

      if (thousandSeparator) {
        beforeDecimal = beforeDecimal.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thousandSeparator);
      } //add prefix and suffix


      if (prefix) beforeDecimal = prefix + beforeDecimal;
      if (suffix) afterDecimal = afterDecimal + suffix; //restore negation sign

      if (addNegation) beforeDecimal = '-' + beforeDecimal;
      numStr = beforeDecimal + (hasDecimalSeparator && decimalSeparator || '') + afterDecimal;
      return numStr;
    }
  }, {
    key: "formatNumString",
    value: function formatNumString() {
      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var _this$props6 = this.props,
          format = _this$props6.format,
          allowEmptyFormatting = _this$props6.allowEmptyFormatting;
      var formattedValue = value;

      if (value === '' && !allowEmptyFormatting) {
        formattedValue = '';
      } else if (value === '-' && !format) {
        formattedValue = '-';
        value = '';
      } else if (typeof format === 'string') {
        formattedValue = this.formatWithPattern(formattedValue);
      } else if (typeof format === 'function') {
        formattedValue = format(formattedValue);
      } else {
        formattedValue = this.formatAsNumber(formattedValue);
      }

      return formattedValue;
    }
  }, {
    key: "formatValueProp",
    value: function formatValueProp() {
      var _this$props7 = this.props,
          format = _this$props7.format,
          decimalScale = _this$props7.decimalScale,
          fixedDecimalScale = _this$props7.fixedDecimalScale,
          allowEmptyFormatting = _this$props7.allowEmptyFormatting;
      var _this$props8 = this.props,
          value = _this$props8.value,
          isNumericString = _this$props8.isNumericString;
      var isNonNumericFalsy = !value && value !== 0;

      if (isNonNumericFalsy && allowEmptyFormatting) {
        value = '';
      } // if value is not defined return empty string


      if (isNonNumericFalsy && !allowEmptyFormatting) return '';

      if (typeof value === 'number') {
        value = value.toString();
        isNumericString = true;
      } //round the number based on decimalScale
      //format only if non formatted value is provided


      if (isNumericString && !format && typeof decimalScale === 'number') {
        value = (0, _utils.roundToPrecision)(value, decimalScale, fixedDecimalScale);
      }

      var formattedValue = isNumericString ? this.formatNumString(value) : this.formatInput(value);
      return formattedValue;
    }
  }, {
    key: "formatNegation",
    value: function formatNegation() {
      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var allowNegative = this.props.allowNegative;
      var negationRegex = new RegExp('(-)');
      var doubleNegationRegex = new RegExp('(-)(.)*(-)'); // Check number has '-' value

      var hasNegation = negationRegex.test(value); // Check number has 2 or more '-' values

      var removeNegation = doubleNegationRegex.test(value); //remove negation

      value = value.replace(/-/g, '');

      if (hasNegation && !removeNegation && allowNegative) {
        value = '-' + value;
      }

      return value;
    }
  }, {
    key: "formatInput",
    value: function formatInput() {
      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var format = this.props.format; //format negation only if we are formatting as number

      if (!format) {
        value = this.formatNegation(value);
      } //remove formatting from number


      value = this.removeFormatting(value);
      return this.formatNumString(value);
    }
    /*** format specific methods end ***/

  }, {
    key: "isCharacterAFormat",
    value: function isCharacterAFormat(caretPos, value) {
      var _this$props9 = this.props,
          format = _this$props9.format,
          prefix = _this$props9.prefix,
          suffix = _this$props9.suffix,
          decimalScale = _this$props9.decimalScale,
          fixedDecimalScale = _this$props9.fixedDecimalScale;

      var _this$getSeparators5 = this.getSeparators(),
          decimalSeparator = _this$getSeparators5.decimalSeparator; //check within format pattern


      if (typeof format === 'string' && format[caretPos] !== '#') return true; //check in number format

      if (!format && (caretPos < prefix.length || caretPos >= value.length - suffix.length || decimalScale && fixedDecimalScale && value[caretPos] === decimalSeparator)) {
        return true;
      }

      return false;
    }
  }, {
    key: "checkIfFormatGotDeleted",
    value: function checkIfFormatGotDeleted(start, end, value) {
      for (var i = start; i < end; i++) {
        if (this.isCharacterAFormat(i, value)) return true;
      }

      return false;
    }
    /**
     * This will check if any formatting got removed by the delete or backspace and reset the value
     * It will also work as fallback if android chome keyDown handler does not work
     **/

  }, {
    key: "correctInputValue",
    value: function correctInputValue(caretPos, lastValue, value) {
      var _this$props10 = this.props,
          format = _this$props10.format,
          decimalSeparator = _this$props10.decimalSeparator,
          allowNegative = _this$props10.allowNegative,
          prefix = _this$props10.prefix,
          suffix = _this$props10.suffix;
      var lastNumStr = this.state.numAsString || '';
      var _this$selectionBefore = this.selectionBeforeInput,
          selectionStart = _this$selectionBefore.selectionStart,
          selectionEnd = _this$selectionBefore.selectionEnd;

      var _findChangedIndex = (0, _utils.findChangedIndex)(lastValue, value),
          start = _findChangedIndex.start,
          end = _findChangedIndex.end;
      /* don't do anyhting if something got added,
       or if value is empty string (when whole input is cleared)
       or whole input is replace with a number
      */


      var leftBound = !!format ? 0 : prefix.length;
      var rightBound = lastValue.length - (!!format ? 0 : suffix.length);

      if (value.length > lastValue.length || !value.length || start === end || selectionStart === 0 && selectionEnd === lastValue.length || selectionStart === leftBound && selectionEnd === rightBound) {
        return value;
      } //if format got deleted reset the value to last value


      if (this.checkIfFormatGotDeleted(start, end, lastValue)) {
        value = lastValue;
      } //for numbers check if beforeDecimal got deleted and there is nothing after decimal,
      //clear all numbers in such case while keeping the - sign


      if (!format) {
        var numericString = this.removeFormatting(value);

        var _splitDecimal2 = (0, _utils.splitDecimal)(numericString, allowNegative),
            beforeDecimal = _splitDecimal2.beforeDecimal,
            afterDecimal = _splitDecimal2.afterDecimal,
            addNegation = _splitDecimal2.addNegation; // eslint-disable-line prefer-const
        //clear only if something got deleted


        var isBeforeDecimalPoint = caretPos < value.indexOf(decimalSeparator) + 1;

        if (numericString.length < lastNumStr.length && isBeforeDecimalPoint && beforeDecimal === '' && !parseFloat(afterDecimal)) {
          return addNegation ? '-' : '';
        }
      }

      return value;
    }
  }, {
    key: "onChange",
    value: function onChange(e) {
      e.persist();
      var el = e.target;
      var inputValue = el.value;
      var state = this.state,
          props = this.props;
      var isAllowed = props.isAllowed;
      var lastValue = state.value || '';
      /*Max of selectionStart and selectionEnd is taken for the patch of pixel and other mobile device caret bug*/

      var currentCaretPosition = Math.max(el.selectionStart, el.selectionEnd);
      inputValue = this.correctInputValue(currentCaretPosition, lastValue, inputValue);
      var formattedValue = this.formatInput(inputValue) || '';
      var numAsString = this.removeFormatting(formattedValue);
      var valueObj = this.getValueObject(formattedValue, numAsString);

      if (!isAllowed(valueObj)) {
        formattedValue = lastValue;
      } //set the value imperatively, this is required for IE fix


      el.value = formattedValue; //get the caret position

      var caretPos = this.getCaretPosition(inputValue, formattedValue, currentCaretPosition); //set caret position

      this.setPatchedCaretPosition(el, caretPos, formattedValue); //change the state

      if (formattedValue !== lastValue) {
        this.setState({
          value: formattedValue,
          numAsString: numAsString
        }, function () {
          props.onValueChange(valueObj, e);
          props.onChange(e);
        });
      } else {
        props.onChange(e);
      }
    }
  }, {
    key: "onBlur",
    value: function onBlur(e) {
      var _this2 = this;

      var props = this.props,
          state = this.state;
      var format = props.format,
          onBlur = props.onBlur;
      var numAsString = state.numAsString;
      var lastValue = state.value;

      if (!format) {
        numAsString = (0, _utils.fixLeadingZero)(numAsString);
        var formattedValue = this.formatNumString(numAsString); //change the state

        if (formattedValue !== lastValue) {
          // the event needs to be persisted because its properties can be accessed in an asynchronous way
          e.persist();
          this.setState({
            value: formattedValue,
            numAsString: numAsString
          }, function () {
            var valueObj = _this2.getValueObject(formattedValue, numAsString);

            props.onValueChange(valueObj, e);
            onBlur(e);
          });
          return;
        }
      }

      onBlur(e);
    }
  }, {
    key: "onKeyDown",
    value: function onKeyDown(e) {
      var _this3 = this;

      var el = e.target;
      var key = e.key;
      var selectionStart = el.selectionStart,
          selectionEnd = el.selectionEnd,
          _el$value = el.value,
          value = _el$value === void 0 ? '' : _el$value;
      var expectedCaretPosition;
      var _this$props11 = this.props,
          decimalScale = _this$props11.decimalScale,
          fixedDecimalScale = _this$props11.fixedDecimalScale,
          prefix = _this$props11.prefix,
          suffix = _this$props11.suffix,
          format = _this$props11.format,
          onKeyDown = _this$props11.onKeyDown,
          onValueChange = _this$props11.onValueChange;
      var ignoreDecimalSeparator = decimalScale !== undefined && fixedDecimalScale;
      var numRegex = this.getNumberRegex(false, ignoreDecimalSeparator);
      var negativeRegex = new RegExp('-');
      var isPatternFormat = typeof format === 'string';
      this.selectionBeforeInput = {
        selectionStart: selectionStart,
        selectionEnd: selectionEnd //Handle backspace and delete against non numerical/decimal characters or arrow keys

      };

      if (key === 'ArrowLeft' || key === 'Backspace') {
        expectedCaretPosition = selectionStart - 1;
      } else if (key === 'ArrowRight') {
        expectedCaretPosition = selectionStart + 1;
      } else if (key === 'Delete') {
        expectedCaretPosition = selectionStart;
      } //if expectedCaretPosition is not set it means we don't want to Handle keyDown
      //also if multiple characters are selected don't handle


      if (expectedCaretPosition === undefined || selectionStart !== selectionEnd) {
        onKeyDown(e);
        return;
      }

      var newCaretPosition = expectedCaretPosition;
      var leftBound = isPatternFormat ? format.indexOf('#') : prefix.length;
      var rightBound = isPatternFormat ? format.lastIndexOf('#') + 1 : value.length - suffix.length;

      if (key === 'ArrowLeft' || key === 'ArrowRight') {
        var direction = key === 'ArrowLeft' ? 'left' : 'right';
        newCaretPosition = this.correctCaretPosition(value, expectedCaretPosition, direction);
      } else if (key === 'Delete' && !numRegex.test(value[expectedCaretPosition]) && !negativeRegex.test(value[expectedCaretPosition])) {
        while (!numRegex.test(value[newCaretPosition]) && newCaretPosition < rightBound) {
          newCaretPosition++;
        }
      } else if (key === 'Backspace' && !numRegex.test(value[expectedCaretPosition])) {
        /* NOTE: This is special case when backspace is pressed on a
        negative value while the cursor position is after prefix. We can't handle it on onChange because
        we will not have any information of keyPress
        */
        if (selectionStart <= leftBound + 1 && value[0] === '-' && typeof format === 'undefined') {
          var newValue = value.substring(1);
          var numAsString = this.removeFormatting(newValue);
          var valueObj = this.getValueObject(newValue, numAsString); //persist event before performing async task

          e.persist();
          this.setState({
            value: newValue,
            numAsString: numAsString
          }, function () {
            _this3.setPatchedCaretPosition(el, newCaretPosition, newValue);

            onValueChange(valueObj, e);
          });
        } else if (!negativeRegex.test(value[expectedCaretPosition])) {
          while (!numRegex.test(value[newCaretPosition - 1]) && newCaretPosition > leftBound) {
            newCaretPosition--;
          }

          newCaretPosition = this.correctCaretPosition(value, newCaretPosition, 'left');
        }
      }

      if (newCaretPosition !== expectedCaretPosition || expectedCaretPosition < leftBound || expectedCaretPosition > rightBound) {
        e.preventDefault();
        this.setPatchedCaretPosition(el, newCaretPosition, value);
      }
      /* NOTE: this is just required for unit test as we need to get the newCaretPosition,
              Remove this when you find different solution */


      if (e.isUnitTestRun) {
        this.setPatchedCaretPosition(el, newCaretPosition, value);
      }

      this.props.onKeyDown(e);
    }
    /** required to handle the caret position when click anywhere within the input **/

  }, {
    key: "onMouseUp",
    value: function onMouseUp(e) {
      var el = e.target;
      /**
       * NOTE: we have to give default value for value as in case when custom input is provided
       * value can come as undefined when nothing is provided on value prop.
      */

      var selectionStart = el.selectionStart,
          selectionEnd = el.selectionEnd,
          _el$value2 = el.value,
          value = _el$value2 === void 0 ? '' : _el$value2;

      if (selectionStart === selectionEnd) {
        var caretPosition = this.correctCaretPosition(value, selectionStart);

        if (caretPosition !== selectionStart) {
          this.setPatchedCaretPosition(el, caretPosition, value);
        }
      }

      this.props.onMouseUp(e);
    }
  }, {
    key: "onFocus",
    value: function onFocus(e) {
      var _this4 = this;

      // Workaround Chrome and Safari bug https://bugs.chromium.org/p/chromium/issues/detail?id=779328
      // (onFocus event target selectionStart is always 0 before setTimeout)
      e.persist();
      setTimeout(function () {
        var el = e.target;
        var selectionStart = el.selectionStart,
            selectionEnd = el.selectionEnd,
            _el$value3 = el.value,
            value = _el$value3 === void 0 ? '' : _el$value3;

        var caretPosition = _this4.correctCaretPosition(value, selectionStart); //setPatchedCaretPosition only when everything is not selected on focus (while tabbing into the field)


        if (caretPosition !== selectionStart && !(selectionStart === 0 && selectionEnd === value.length)) {
          _this4.setPatchedCaretPosition(el, caretPosition, value);
        }

        _this4.props.onFocus(e);
      }, 0);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props12 = this.props,
          type = _this$props12.type,
          displayType = _this$props12.displayType,
          customInput = _this$props12.customInput,
          renderText = _this$props12.renderText,
          getInputRef = _this$props12.getInputRef;
      var value = this.state.value;
      var otherProps = (0, _utils.omit)(this.props, propTypes);

      var inputProps = _extends({}, otherProps, {
        type: type,
        value: value,
        onChange: this.onChange,
        onKeyDown: this.onKeyDown,
        onMouseUp: this.onMouseUp,
        onFocus: this.onFocus,
        onBlur: this.onBlur
      });

      if (displayType === 'text') {
        return renderText ? renderText(value) || null : _react.default.createElement("span", _extends({}, otherProps, {
          ref: getInputRef
        }), value);
      } else if (customInput) {
        var CustomInput = customInput;
        return _react.default.createElement(CustomInput, inputProps);
      }

      return _react.default.createElement("input", _extends({}, inputProps, {
        ref: getInputRef
      }));
    }
  }]);

  return NumberFormat;
}(_react.default.Component);

NumberFormat.propTypes = propTypes;
NumberFormat.defaultProps = defaultProps;
var _default = NumberFormat;
exports.default = _default;
module.exports = exports.default;

/***/ }),
/* 2481 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.noop = noop;
exports.returnTrue = returnTrue;
exports.charIsNumber = charIsNumber;
exports.escapeRegExp = escapeRegExp;
exports.splitDecimal = splitDecimal;
exports.fixLeadingZero = fixLeadingZero;
exports.limitToScale = limitToScale;
exports.roundToPrecision = roundToPrecision;
exports.omit = omit;
exports.setCaretPosition = setCaretPosition;
exports.findChangedIndex = findChangedIndex;
exports.clamp = clamp;

// basic noop function
function noop() {}

function returnTrue() {
  return true;
}

function charIsNumber(char) {
  return !!(char || '').match(/\d/);
}

function escapeRegExp(str) {
  return str.replace(/[-[\]/{}()*+?.\\^$|]/g, "\\$&");
} //spilt a float number into different parts beforeDecimal, afterDecimal, and negation


function splitDecimal(numStr) {
  var allowNegative = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var hasNagation = numStr[0] === '-';
  var addNegation = hasNagation && allowNegative;
  numStr = numStr.replace('-', '');
  var parts = numStr.split('.');
  var beforeDecimal = parts[0];
  var afterDecimal = parts[1] || '';
  return {
    beforeDecimal: beforeDecimal,
    afterDecimal: afterDecimal,
    hasNagation: hasNagation,
    addNegation: addNegation
  };
}

function fixLeadingZero(numStr) {
  if (!numStr) return numStr;
  var isNegative = numStr[0] === '-';
  if (isNegative) numStr = numStr.substring(1, numStr.length);
  var parts = numStr.split('.');
  var beforeDecimal = parts[0].replace(/^0+/, '') || '0';
  var afterDecimal = parts[1] || '';
  return "".concat(isNegative ? '-' : '').concat(beforeDecimal).concat(afterDecimal ? ".".concat(afterDecimal) : '');
}
/**
 * limit decimal numbers to given scale
 * Not used .fixedTo because that will break with big numbers
 */


function limitToScale(numStr, scale, fixedDecimalScale) {
  var str = '';
  var filler = fixedDecimalScale ? '0' : '';

  for (var i = 0; i <= scale - 1; i++) {
    str += numStr[i] || filler;
  }

  return str;
}
/**
 * This method is required to round prop value to given scale.
 * Not used .round or .fixedTo because that will break with big numbers
 */


function roundToPrecision(numStr, scale, fixedDecimalScale) {
  //if number is empty don't do anything return empty string
  if (['', '-'].indexOf(numStr) !== -1) return numStr;
  var shoudHaveDecimalSeparator = numStr.indexOf('.') !== -1 && scale;

  var _splitDecimal = splitDecimal(numStr),
      beforeDecimal = _splitDecimal.beforeDecimal,
      afterDecimal = _splitDecimal.afterDecimal,
      hasNagation = _splitDecimal.hasNagation;

  var roundedDecimalParts = parseFloat("0.".concat(afterDecimal || '0')).toFixed(scale).split('.');
  var intPart = beforeDecimal.split('').reverse().reduce(function (roundedStr, current, idx) {
    if (roundedStr.length > idx) {
      return (Number(roundedStr[0]) + Number(current)).toString() + roundedStr.substring(1, roundedStr.length);
    }

    return current + roundedStr;
  }, roundedDecimalParts[0]);
  var decimalPart = limitToScale(roundedDecimalParts[1] || '', Math.min(scale, afterDecimal.length), fixedDecimalScale);
  var negation = hasNagation ? '-' : '';
  var decimalSeparator = shoudHaveDecimalSeparator ? '.' : '';
  return "".concat(negation).concat(intPart).concat(decimalSeparator).concat(decimalPart);
}

function omit(obj, keyMaps) {
  var filteredObj = {};
  Object.keys(obj).forEach(function (key) {
    if (!keyMaps[key]) filteredObj[key] = obj[key];
  });
  return filteredObj;
}
/** set the caret positon in an input field **/


function setCaretPosition(el, caretPos) {
  el.value = el.value; // ^ this is used to not only get "focus", but
  // to make sure we don't have it everything -selected-
  // (it causes an issue in chrome, and having it doesn't hurt any other browser)

  if (el !== null) {
    if (el.createTextRange) {
      var range = el.createTextRange();
      range.move('character', caretPos);
      range.select();
      return true;
    } // (el.selectionStart === 0 added for Firefox bug)


    if (el.selectionStart || el.selectionStart === 0) {
      el.focus();
      el.setSelectionRange(caretPos, caretPos);
      return true;
    } // fail city, fortunately this never happens (as far as I've tested) :)


    el.focus();
    return false;
  }
}
/**
  Given previous value and newValue it returns the index
  start - end to which values have changed.
  This function makes assumption about only consecutive
  characters are changed which is correct assumption for caret input.
*/


function findChangedIndex(prevValue, newValue) {
  var i = 0,
      j = 0;
  var prevLength = prevValue.length;
  var newLength = newValue.length;

  while (prevValue[i] === newValue[i] && i < prevLength) {
    i++;
  } //check what has been changed from last


  while (prevValue[prevLength - 1 - j] === newValue[newLength - 1 - j] && newLength - j > i && prevLength - j > i) {
    j++;
  }

  return {
    start: i,
    end: prevLength - j
  };
}
/*
  Returns a number whose value is limited to the given range
*/


function clamp(num, min, max) {
  return Math.min(Math.max(num, min), max);
}

/***/ }),
/* 2482 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_core__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_Wrappers_materialUIWrappers_components_FormDropDown__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_Wrappers_materialUIWrappers_components_FormInput__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_helpers_ReduxHelpers__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_redux_form__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_store__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_CustomCardHeading_jsx__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__objects_Dependants__ = __webpack_require__(2483);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var required=function required(value){return value?undefined:"Required";};var requiredDropdown=function requiredDropdown(value){if(!value||value==="validationError"){return"Required";}return undefined;};var Dependants=function(_React$Component){_inherits(Dependants,_React$Component);function Dependants(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Dependants);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Dependants.__proto__||Object.getPrototypeOf(Dependants)).call.apply(_ref,[this].concat(args))),_this),_this.add=function(){var dependants=__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(__WEBPACK_IMPORTED_MODULE_7_store__["a" /* default */].getState().form,"newfna.values.dependants",{});var id=0;if(Object.keys(dependants).length>0){var max=Math.max.apply(Math,Object.keys(dependants).map(function(b){return parseInt(b,10);}));id=max+1;}__WEBPACK_IMPORTED_MODULE_7_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_redux_form__["b" /* change */])("newfna","dependants."+id,{id:id}));_this.props.RemoveIgnore("dependants");_this.forceUpdate();},_this.remove=function(id){var fieldParent="dependants";var ignore=Object(__WEBPACK_IMPORTED_MODULE_3_helpers_ReduxHelpers__["b" /* RemoveField */])("newfna","dependants."+id,fieldParent);if(ignore){_this.props.AddIgnore(fieldParent);}_this.forceUpdate();},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Dependants,[{key:"componentDidMount",value:function componentDidMount(){this.props.scrollMeBar();}},{key:"render",value:function render(){var _this2=this;var checkValidation=this.props.checkValidation;var dependants=__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(__WEBPACK_IMPORTED_MODULE_7_store__["a" /* default */].getState().form,"newfna.values.dependants",{});return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("div",{className:"contentWithStepper"},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["e" /* Card */],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["f" /* CardContent */],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_CustomCardHeading_jsx__["a" /* default */],{subheading:"Financial Needs Analysis",caption:"Client Name",headline:"Dependants"}),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{container:true,spacing:24,className:"customTable1Grid"},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Q" /* Table */],{className:"customTable1"},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["T" /* TableHead */],{className:"fixedHead"},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,"First Name"),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,"Surname"),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,"Gender"),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,"Date Of Birth"),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,"Relationship"))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["R" /* TableBody */],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{style:{border:"0px"}},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["i" /* Chip */],{label:"Add",onClick:function onClick(){return _this2.add();}}))),!dependants?null:Object.keys(dependants).map(function(id,i){return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],{key:id},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["d" /* Button */],{variant:"fab",mini:true,className:"smallFab",onClick:function onClick(){return _this2.remove(id);}},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["w" /* Icon */],null,"remove"))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{padding:"none",className:"cellPaddingSmall"},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["t" /* FormControl */],{fullWidth:true},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_2_components_Wrappers_materialUIWrappers_components_FormInput__["a" /* default */],isrequired:false,validate:[required],checkValidation:checkValidation,name:"dependants."+id+".firstname",label:"First Name *"}))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{padding:"none",className:"cellPaddingSmall"},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["t" /* FormControl */],{fullWidth:true},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_2_components_Wrappers_materialUIWrappers_components_FormInput__["a" /* default */],isrequired:false,validate:[required],checkValidation:checkValidation,name:"dependants."+id+".surname",label:"Surname *"}))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{padding:"none",className:"cellPaddingSmall"},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["t" /* FormControl */],{fullWidth:true},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_1_components_Wrappers_materialUIWrappers_components_FormDropDown__["a" /* default */],checkValidation:_this2.props.checkValidation,validate:[required],isrequired:true,label:"Gender",name:"dependants."+id+".gender",options:[{value:"",displayValue:"Empty"},{value:"male",displayValue:"Male"},{value:"female",displayValue:"Female"}]}))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{padding:"none",className:"cellPaddingSmall"},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["t" /* FormControl */],{fullWidth:true},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_2_components_Wrappers_materialUIWrappers_components_FormInput__["a" /* default */],isrequired:false,validate:[required,required],checkValidation:checkValidation,name:"dependants."+id+".dateofbirth",label:"Date Of Birth *"}))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{padding:"none",className:"cellPaddingSmall"},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["t" /* FormControl */],{fullWidth:true},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_1_components_Wrappers_materialUIWrappers_components_FormDropDown__["a" /* default */],checkValidation:_this2.props.checkValidation,isrequired:true,validate:[requiredDropdown],label:"Relationship",name:"dependants."+id+".relationship",options:__WEBPACK_IMPORTED_MODULE_9__objects_Dependants__["a" /* Relationship */]}))));})))))));}}]);return Dependants;}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Dependants);

/***/ }),
/* 2483 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Relationship; });
var Relationship=[{value:"validationError",displayValue:"Please Select"},{value:"spouse",displayValue:"Spouse"},{value:"son",displayValue:"Son"},{value:"daughter",displayValue:"Daughter"},{value:"father",displayValue:"Father"},{value:"mother",displayValue:"Mother"},{value:"brother",displayValue:"Brother"},{value:"sister",displayValue:"Sister"},{value:"in_laws",displayValue:"In Laws"},{value:"other",displayValue:"Other"}];

/***/ }),
/* 2484 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_core__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_Wrappers_materialUIWrappers_components_FormCheckbox_jsx__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_Wrappers_materialUIWrappers_components_FormDropDown__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Wrappers_materialUIWrappers_components_NumberInput__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Wrappers_materialUIWrappers_components_FormInput__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_DescriptiveRow_jsx__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__objects_otherLiabilityItems__ = __webpack_require__(396);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_redux_form__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_store__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_CustomCardHeading_jsx__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__objects_banks__ = __webpack_require__(630);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var required=function required(value){return value?undefined:"Required";};var colwidth=function colwidth(value){return{width:value,minWidth:value,maxWidth:value,margin:"0px"};};var CustomField=function CustomField(props){return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall"},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["t" /* FormControl */],{fullWidth:true},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_redux_form__["a" /* Field */],props)));};var CustomField2=function CustomField2(props){return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["t" /* FormControl */],{fullWidth:true,style:{bottom:"10px"}},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_redux_form__["a" /* Field */],props));};var checkItem=function checkItem(label,name,changeFunc){return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["t" /* FormControl */],{style:{marginBottom:"-30px",paddingBottom:"-30px",marginLeft:"25%"}},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_1_components_Wrappers_materialUIWrappers_components_FormCheckbox_jsx__["a" /* default */],name:name,onChange:function onChange(e,f,g,h){changeFunc(f,h);}}));};function isInteger(value){return /^\d+$/.test(value);}var percentage=function percentage(value){if(value===undefined)return undefined;if(isNaN(value)){return"Must be a number";}if(parseInt(value,10)>=101||parseInt(value,10)<0){return"Not a valid Percentage";}return undefined;};var hundred=function hundred(value){if(value===undefined)return undefined;if(isNaN(value)){return"Must be a number";}if(parseInt(value,10)!==100){return"Must add up to 100";}return undefined;};var liability=function liability(value){return{category:"",description:"",amount:"",party:"",settleAtDeath:""};};var isEmptyOrSpaces=function isEmptyOrSpaces(str){return str===undefined||str===null||str.match(/^ *$/)!==null;};var MarketValueLiability=function(_React$Component){_inherits(MarketValueLiability,_React$Component);function MarketValueLiability(){var _ref;var _temp,_this,_ret;_classCallCheck(this,MarketValueLiability);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=MarketValueLiability.__proto__||Object.getPrototypeOf(MarketValueLiability)).call.apply(_ref,[this].concat(args))),_this),_this.addNew=function(){var liabilities=_this.props.state.liabilities;liabilities.push(liability());_this.props.addNewLiability(liabilities);},_this.remove=function(n){var liabilities=_this.props.state.liabilities;var newLiabilities=[];var node=n.target;while(node.nodeName!="BUTTON"&&node.parentNode!=null){node=node.parentNode;}var i=node.name.replace("removeL","");console.log(i);liabilities.map(function(e,k){if(e!=liabilities[i])newLiabilities[k]=e;});_this.props.addNewLiability(newLiabilities);},_this.changeCat=function(value,name){var liabilities=_this.props.state.liabilities;var liability=name.replace("liability.category.","");liabilities[liability].category=value;_this.props.changeLiability(liabilities);},_this.changeDesc=function(value,name){var liabilities=_this.props.state.liabilities;var liability=name.replace("liability.description.","");liabilities[liability].description=value;_this.props.changeLiability(liabilities);},_this.changeAmount=function(value,name){var liabilities=_this.props.state.liabilities;var liability=name.replace("liability.amount.","");liabilities[liability].amount=value;_this.props.changeLiability(liabilities);},_this.changeParty=function(value,name){var liabilities=_this.props.state.liabilities;var liability=name.replace("liability.liableParty.","");liabilities[liability].party=value;_this.props.changeLiability(liabilities);},_this.changeSettle=function(value,name){var liabilities=_this.props.state.liabilities;var liability=name.replace("liability.settle.","");liabilities[liability].settleAtDeath=value;_this.props.changeLiability(liabilities);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(MarketValueLiability,[{key:"componentDidMount",value:function componentDidMount(){this.props.scrollMeBar();}},{key:"render",value:function render(){var _this2=this;var checkValidation=this.props.checkValidation;var clientD="";if(this.props.state.client)clientD=this.props.state.client.first_name+" "+this.props.state.client.surname;return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("div",{className:"contentWithStepper",style:{width:"120%",marginLeft:"-10%"}},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["e" /* Card */],null,__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["f" /* CardContent */],null,__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_CustomCardHeading_jsx__["a" /* default */],{subheading:"Financial Needs Analysis",caption:clientD,headline:"Liabilities"}),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{container:true,spacing:24,className:"customTableAutoGrid"},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Q" /* Table */],{className:"customTable1"},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["T" /* TableHead */],{className:"fixedHead"},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingTiny",style:colwidth("15em")},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center"}},"Category")),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall",style:colwidth("18em")},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center",verticalAlign:'bottom'}},"Description")),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingTiny",style:colwidth("10em")},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center",verticalAlign:'bottom'}},"Amount")),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall",style:colwidth("12em")},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center"}},"Liable Party")),this.props.state.client!=null&&this.props.state.client.marital_status=="Married"&&__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall",style:colwidth("12em")},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center"}},"Settle At Disability")))),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["R" /* TableBody */],null,this.props.state.liabilities.map(function(e,i){return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["d" /* Button */],{name:"removeL"+i,key:"removeL"+i,variant:"fab",mini:true,className:"tinyfab",color:"primary",style:{left:"-20px",top:"-5px"},onClick:function onClick(e){e.stopPropagation();_this2.remove(e);}},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["w" /* Icon */],{style:{color:"white"}},"remove")),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(CustomField2,{name:"liability.category."+i,component:__WEBPACK_IMPORTED_MODULE_2_components_Wrappers_materialUIWrappers_components_FormDropDown__["a" /* default */],checkValidation:_this2.props.checkValidation,label:'',isrequired:true//validate={[required]}
,options:__WEBPACK_IMPORTED_MODULE_6__objects_otherLiabilityItems__["a" /* otherLiabilityItems */],onChange:function onChange(e,value,t,name){return _this2.changeCat(value,name);}})),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(CustomField,{name:'liability.description.'+i,component:__WEBPACK_IMPORTED_MODULE_4_components_Wrappers_materialUIWrappers_components_FormInput__["a" /* default */],checkValidation:_this2.props.checkValidation,label:'description',isrequired:true,validate:[required],onChange:function onChange(e,value,t,name){return _this2.changeDesc(value,name);}}),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(CustomField,{name:'liability.amount.'+i,prefix:"R",component:__WEBPACK_IMPORTED_MODULE_3_components_Wrappers_materialUIWrappers_components_NumberInput__["a" /* default */],checkValidation:_this2.props.checkValidation,label:'R*',isrequired:true,validate:[required],onChange:function onChange(e,value,t,name){return _this2.changeAmount(value,name);}}),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(CustomField,{name:"liability.liableParty."+i,component:__WEBPACK_IMPORTED_MODULE_2_components_Wrappers_materialUIWrappers_components_FormDropDown__["a" /* default */],checkValidation:_this2.props.checkValidation,label:'',isrequired:true//validate={[required]}
,options:[{displayValue:"Please select",value:" "},{displayValue:"Client",value:"client"},{displayValue:"Spouse",value:"spouse"}],onChange:function onChange(e,value,t,name){return _this2.changeParty(value,name);}}),_this2.props.state.client.marital_status=="Married"&&__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall"},checkItem("","liability.settle."+i,_this2.changeSettle)));}),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Q" /* Table */],{style:{width:"10em"}},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_DescriptiveRow_jsx__["a" /* default */],{description:"Add Liability",add:function add(){return _this2.addNew();},extraCells:10})))))))));}}]);return MarketValueLiability;}(__WEBPACK_IMPORTED_MODULE_8_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (MarketValueLiability);

/***/ }),
/* 2485 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_core__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_DescriptiveRow_jsx__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_DescriptiveCell_jsx__ = __webpack_require__(631);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Wrappers_materialUIWrappers_components_FormCheckbox_jsx__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_helpers_ReduxHelpers__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_redux_form__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_store__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_CustomCardHeading_jsx__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__objects_Conversion__ = __webpack_require__(2486);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_Wrappers_materialUIWrappers_components_FormDropDown__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_Wrappers_materialUIWrappers_components_NumberInput__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_Wrappers_materialUIWrappers_components_FormInput__ = __webpack_require__(24);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}//import FormInput from "components/Wrappers/materialUIWrappers/components/FormInput";
var required=function required(value){return value?undefined:"Required";};var incomeStreamExpander=true;var CustomField=function CustomField(props){return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall"},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["t" /* FormControl */],{fullWidth:true},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_redux_form__["a" /* Field */],props)));};var CustomField2=function CustomField2(props){return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["t" /* FormControl */],{fullWidth:true,style:{bottom:"10px"}},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_redux_form__["a" /* Field */],props));};var requiredDropdown=function requiredDropdown(value){if(!value||value==="validationError"){return"Required";}return undefined;};var percentage=function percentage(value){if(value===undefined)return undefined;if(isNaN(value)){return"Must be a number";}if(parseInt(value,10)>=101||parseInt(value,10)<0){return"Not a valid Percentage";}return undefined;};var checkItem=function checkItem(label,name,changeFunc){return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["t" /* FormControl */],{style:{marginBottom:"-30px",paddingBottom:"-30px"}},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_3_components_Wrappers_materialUIWrappers_components_FormCheckbox_jsx__["a" /* default */],name:name,onChange:function onChange(e,f,g,h){changeFunc(f,h);}}));};var colwidth=function colwidth(value){return{width:value,minWidth:value,maxWidth:value};};var need=function need(value){return{category:"",incomeStream:"",disability:false,death:false,retirement:false,mounthlyAmount:0,yearsPayable:0,annualIncrease:0,estateInherit:0,spouseInherit:0,dependentsInherit:0,trustInherit:0,otherInherit:0,charityInherit:0};};var Conversion=function(_React$Component){_inherits(Conversion,_React$Component);function Conversion(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Conversion);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Conversion.__proto__||Object.getPrototypeOf(Conversion)).call.apply(_ref,[this].concat(args))),_this),_this.addNewIncomeStream=function(){var needs=_this.props.state.needs;var total=0;needs.incomeStreams.push(need());needs.incomeStreams.map(function(e){if(parseFloat(e.mounthlyAmount))if(parseFloat(e.mounthlyAmount.replace()))total+=parseFloat(e.mounthlyAmount.replace());});_this.props.state.needs.totals.incomeStreams="R"+parseFloat(total);_this.props.addNewNeed(needs);},_this.addNewIncomeNeed=function(){var needs=_this.props.state.needs;var total=0;needs.incomeNeeds.push(need());needs.incomeNeeds.map(function(e){if(e.mounthlyAmount)if(parseFloat(e.mounthlyAmount.replace()))total+=parseFloat(e.mounthlyAmount.replace());});_this.props.state.needs.totals.incomeNeeds="R"+parseFloat(total);_this.props.addNewNeed(needs);},_this.addNewCapitalNeed=function(){var needs=_this.props.state.needs;var total=0;needs.capitalNeeds.push(need());needs.capitalNeeds.map(function(e){if(e.mounthlyAmount)if(parseFloat(e.mounthlyAmount.replace()))total+=parseFloat(e.mounthlyAmount.replace());});_this.props.state.needs.totals.capitalNeeds="R"+parseFloat(total);_this.props.addNewNeed(needs);},_this.addNewcashBequest=function(){var needs=_this.props.state.needs;var total=0;needs.cashBequests.push(need());needs.cashBequests.map(function(e){if(e.mounthlyAmount)if(parseFloat(e.mounthlyAmount.replace()))total+=parseFloat(e.mounthlyAmount.replace());});_this.props.state.needs.totals.cashBequests="R"+parseFloat(total);_this.props.addNewNeed(needs);},_this.remove=function(n){var needs=_this.props.state.needs;var newNeeds=[];var node=n.target;while(node.nodeName!="BUTTON"&&node.parentNode!=null){node=node.parentNode;}var i=node.name.replace("removeN","").split(".");console.log(needs[i[0]]);needs[i[0]].map(function(e,k){console.log(JSON.stringify(needs[i[0]][i[1]])+"-----------------------"+JSON.stringify(e));if(e!=needs[i[0]][i[1]])newNeeds[k]=e;});needs[i[0]]=newNeeds;var total=0;needs[i[0]].map(function(e){total+=e.mounthlyAmount;});needs.totals[i[0]]="R"+parseFloat(total);_this.props.addNewNeed(needs);},_this.changeStream=function(value,name){var needs=_this.props.state.needs;var need=name.replace("provision","").split(".");needs[need[0]][need[1]].incomeStream=value;_this.props.changeNeed(needs);},_this.changeCat=function(value,name){var needs=_this.props.state.needs;var need=name.replace("category","").split(".");needs[need[0]][need[1]].category=value;_this.props.changeNeed(needs);},_this.changeDisability=function(value,name){var needs=_this.props.state.needs;var need=name.replace("disability","").split(".");console.log(value);console.log(name);console.log(need);console.log(needs[need[0]]);console.log(needs[need[0]][need[1]]);needs[need[0]][need[1]].disability=value;_this.props.changeNeed(needs);},_this.changeDeath=function(value,name){var needs=_this.props.state.needs;var need=name.replace("death","").split(".");needs[need[0]][need[1]].death=value;_this.props.changeNeed(needs);},_this.changeRetirement=function(value,name){var needs=_this.props.state.needs;var need=name.replace("retirement","").split(".");needs[need[0]][need[1]].retirement=value;_this.props.changeNeed(needs);},_this.changeMounthlyAmount=function(value,name){var needs=_this.props.state.needs;var need=name.replace("mounthlyAmount","").split(".");needs[need[0]][need[1]].mounthlyAmount=value;var total=0;needs[need[0]].map(function(e){if(e.mounthlyAmount)if(parseFloat(e.mounthlyAmount.replace()))total+=parseFloat(e.mounthlyAmount.replace());});needs.totals[need[0]]="R"+parseFloat(total);_this.props.changeNeed(needs);},_this.changeYearsPayable=function(value,name){var needs=_this.props.state.needs;var need=name.replace("yearsPayable","").split(".");needs[need[0]][need[1]].yearsPayable=value;_this.props.changeNeed(needs);},_this.changeAnnualIncrease=function(value,name){var needs=_this.props.state.needs;var need=name.replace("annualIncrease","").split(".");needs[need[0]][need[1]].annualIncrease=value;_this.props.changeNeed(needs);},_this.IncomeNeedExpand=function(expand){var needs=_this.props.state.needs;console.log(expand.target);needs.expanded.incomeNeeds=!needs.expanded.incomeNeeds;_this.props.changeNeedExpansion(needs);},_this.IncomeStreamExpand=function(expand){var needs=_this.props.state.needs;console.log(expand.target);needs.expanded.incomeStreams=!needs.expanded.incomeStreams;_this.props.changeNeedExpansion(needs);},_this.CapitalNeedExpand=function(expand){var needs=_this.props.state.needs;console.log(expand.target);needs.expanded.capitalNeeds=!needs.expanded.capitalNeeds;_this.props.changeNeedExpansion(needs);},_this.cashBequestsExpand=function(expand){var needs=_this.props.state.needs;console.log(expand.target);needs.expanded.cashBequests=!needs.expanded.cashBequests;_this.props.changeNeedExpansion(needs);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Conversion,[{key:"componentDidMount",value:function componentDidMount(){this.props.scrollMeBar();}},{key:"render",value:function render(){var _this2=this;var checkValidation=this.props.checkValidation;var needs=this.props.state.needs;needs.expanded.incomeNeeds=false;needs.expanded.incomeStreams=false;needs.expanded.capitalNeeds=false;needs.expanded.cashBequests=false;var clientD="";if(this.props.state.client)clientD=this.props.state.client.first_name+" "+this.props.state.client.surname;return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement("div",{className:"contentWithStepper",style:{width:"120%",marginLeft:"-10%"}},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["e" /* Card */],null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["f" /* CardContent */],null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_CustomCardHeading_jsx__["a" /* default */],{subheading:"Financial Needs Analysis",caption:clientD,headline:"Current Provision and Needs"}),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["q" /* ExpansionPanel */],{defaultExpanded:0===0,key:1,onClick:function onClick(event){return _this2.IncomeStreamExpand(event);}},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["s" /* ExpansionPanelSummary */],{expandIcon:__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["w" /* Icon */],null,"expand_more")},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Q" /* Table */],null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingTiny",style:colwidth("5em")},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{variant:"title",style:{fontWeight:'bold'}},"Income Provision")),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingTiny",style:colwidth("2em")},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{variant:"title",style:{fontWeight:'bold'}},this.props.state.needs.expanded.incomeStreams==false&&"Total")),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingTiny",style:colwidth("15em")},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{variant:"title",style:{fontWeight:'bold'}},this.props.state.needs.expanded.incomeStreams==false&&this.props.state.needs.totals.incomeStreams))))),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["r" /* ExpansionPanelDetails */],{onClick:function onClick(event){event.stopPropagation();}},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{container:true,spacing:24},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Q" /* Table */],{className:"customTable1"},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["T" /* TableHead */],{className:"fixedHead"},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingTiny",style:colwidth("15em")},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center"}},"Income Stream")),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall",style:colwidth("6em")},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px'}},"Death")),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingTiny",style:colwidth("6em")},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center",verticalAlign:'bottom'}},"Disability")),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall",style:colwidth("6em")},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center"}},"Retirement")),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall",style:colwidth("12em")},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center"}},"Monthly Amount")),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall",style:colwidth("12em")},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center"}},"Years Receivable")),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall",style:colwidth("12em")},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center"}},"Annual Increase")))),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["R" /* TableBody */],null,this.props.state.needs.incomeStreams.map(function(e,i){return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["d" /* Button */],{name:"incomeStreams.removeN"+i,key:"incomeStreams.removeN"+i,variant:"fab",mini:true,className:"tinyfab",color:"primary",style:{left:"-20px",top:"-5px"},onClick:function onClick(e){e.stopPropagation();_this2.remove(e);}},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["w" /* Icon */],{style:{color:"white"}},"remove")),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(CustomField2,{name:'incomeStreams.provision'+i,component:__WEBPACK_IMPORTED_MODULE_13_components_Wrappers_materialUIWrappers_components_FormInput__["a" /* default */],checkValidation:_this2.props.checkValidation,label:'description',isrequired:true//validate={[required]}
,onChange:function onChange(e,value,t,name){return _this2.changeStream(value,name);}})),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,checkItem("","incomeStreams.death"+i,_this2.changeDeath)),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,checkItem("","incomeStreams.disability"+i,_this2.changeDisability)),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null," ",checkItem("","incomeStreams.retirement"+i,_this2.changeRetirement)),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(CustomField,{name:'incomeStreams.mounthlyAmount'+i,prefix:"R",component:__WEBPACK_IMPORTED_MODULE_12_components_Wrappers_materialUIWrappers_components_NumberInput__["a" /* default */],checkValidation:_this2.props.checkValidation,label:'R*',isrequired:true,validate:[required],onChange:function onChange(e,value,t,name){return _this2.changeMounthlyAmount(value,name);}}),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(CustomField,{name:'incomeStreams.yearsPayable'+i,component:__WEBPACK_IMPORTED_MODULE_12_components_Wrappers_materialUIWrappers_components_NumberInput__["a" /* default */],checkValidation:_this2.props.checkValidation,label:'Years*',isrequired:true,validate:[required],onChange:function onChange(e,value,t,name){return _this2.changeYearsPayable(value,name);}}),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(CustomField,{name:'incomeStreams.annualIncrease'+i,suffix:"%",component:__WEBPACK_IMPORTED_MODULE_12_components_Wrappers_materialUIWrappers_components_NumberInput__["a" /* default */],checkValidation:_this2.props.checkValidation,label:'%*',isrequired:true,validate:[required],onChange:function onChange(e,value,t,name){return _this2.changeAnnualIncrease(value,name);}}));}),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_DescriptiveCell_jsx__["a" /* default */],{width:"150em",description:"Add Income",add:function add(){return _this2.addNewIncomeStream();}}),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{variant:"title"})),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{variant:"title"})))))))),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["q" /* ExpansionPanel */],{defaultExpanded:1===0,key:1,onClick:function onClick(event){return _this2.IncomeNeedExpand(event);}},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["s" /* ExpansionPanelSummary */],{expandIcon:__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["w" /* Icon */],null,"expand_more")},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Q" /* Table */],null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingTiny",style:colwidth("5em")},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{variant:"title",style:{fontWeight:'bold'}},"Income Needs")),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingTiny",style:colwidth("2em")},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{variant:"title",style:{fontWeight:'bold'}},this.props.state.needs.expanded.incomeNeeds==false&&"Total")),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingTiny",style:colwidth("15em")},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{variant:"title",style:{fontWeight:'bold'}},this.props.state.needs.expanded.incomeNeeds==false&&this.props.state.needs.totals.incomeNeeds))))),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["r" /* ExpansionPanelDetails */],{onClick:function onClick(event){event.stopPropagation();}},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{container:true,spacing:24},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Q" /* Table */],{className:"customTable1"},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["T" /* TableHead */],{className:"fixedHead"},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingTiny",style:colwidth("15em")},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center"}},"Income Stream")),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall",style:colwidth("6em")},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px'}},"Death")),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingTiny",style:colwidth("6em")},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center",verticalAlign:'bottom'}},"Disability")),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall",style:colwidth("6em")},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center"}},"Retirement")),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall",style:colwidth("12em")},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center"}},"Monthly Amount")),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall",style:colwidth("12em")},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center"}},"Years Receivable")),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall",style:colwidth("12em")},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center"}},"Annual Increase")))),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["R" /* TableBody */],null,this.props.state.needs.incomeNeeds.map(function(e,i){return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["d" /* Button */],{name:"incomeNeeds.removeN"+i,key:"incomeNeeds.removeN"+i,variant:"fab",mini:true,className:"tinyfab",color:"primary",style:{left:"-20px",top:"-5px"},onClick:function onClick(e){e.stopPropagation();_this2.remove(e);}},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["w" /* Icon */],{style:{color:"white"}},"remove")),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(CustomField2,{name:'incomeNeeds.provision'+i,component:__WEBPACK_IMPORTED_MODULE_13_components_Wrappers_materialUIWrappers_components_FormInput__["a" /* default */],checkValidation:_this2.props.checkValidation,label:'description',isrequired:true//validate={[required]}
,onChange:function onChange(e,value,t,name){return _this2.changeStream(value,name);}})),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,checkItem("","incomeNeeds.death"+i,_this2.changeDeath)),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,checkItem("","incomeNeeds.disability"+i,_this2.changeDisability)),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null," ",checkItem("","incomeNeeds.retirement"+i,_this2.changeRetirement)),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(CustomField,{name:'incomeNeeds.mounthlyAmount'+i,prefix:"R",component:__WEBPACK_IMPORTED_MODULE_12_components_Wrappers_materialUIWrappers_components_NumberInput__["a" /* default */],checkValidation:_this2.props.checkValidation,label:'R*',isrequired:true,validate:[required],onChange:function onChange(e,value,t,name){return _this2.changeMounthlyAmount(value,name);}}),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(CustomField,{name:'incomeNeeds.yearsPayable'+i,component:__WEBPACK_IMPORTED_MODULE_12_components_Wrappers_materialUIWrappers_components_NumberInput__["a" /* default */],checkValidation:_this2.props.checkValidation,label:'Years*',isrequired:true,validate:[required],onChange:function onChange(e,value,t,name){return _this2.changeYearsPayable(value,name);}}),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(CustomField,{name:'incomeNeeds.annualIncrease'+i,suffix:"%",component:__WEBPACK_IMPORTED_MODULE_12_components_Wrappers_materialUIWrappers_components_NumberInput__["a" /* default */],checkValidation:_this2.props.checkValidation,label:'%*',isrequired:true,validate:[required],onChange:function onChange(e,value,t,name){return _this2.changeAnnualIncrease(value,name);}}));}),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_DescriptiveCell_jsx__["a" /* default */],{width:"150em",description:"Add Income",add:function add(){return _this2.addNewIncomeNeed();}}),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{variant:"title"})),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{variant:"title"})))))))),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["q" /* ExpansionPanel */],{defaultExpanded:1===0,key:1,onClick:function onClick(event){return _this2.CapitalNeedExpand(event);}},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["s" /* ExpansionPanelSummary */],{expandIcon:__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["w" /* Icon */],null,"expand_more")},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Q" /* Table */],null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingTiny",style:colwidth("5em")},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{variant:"title",style:{fontWeight:'bold'}},"Lumpsum Capital Needs")),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingTiny",style:colwidth("2em")},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{variant:"title",style:{fontWeight:'bold'}},this.props.state.needs.expanded.capitalNeeds==false&&"Total")),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingTiny",style:colwidth("15em")},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{variant:"title",style:{fontWeight:'bold'}},this.props.state.needs.expanded.capitalNeeds==false&&this.props.state.needs.totals.capitalNeeds))))),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["r" /* ExpansionPanelDetails */],{onClick:function onClick(event){event.stopPropagation();}},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{container:true,spacing:24},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Q" /* Table */],{className:"customTable1"},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["T" /* TableHead */],{className:"fixedHead"},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingTiny",style:colwidth("15em")},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center"}},"Category")),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingTiny",style:colwidth("8.5em")},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center"}},"Description")),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall",style:colwidth("6em")},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px'}},"Death")),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingTiny",style:colwidth("6em")},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center",verticalAlign:'bottom'}},"Disability")),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall",style:colwidth("6em")},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center"}},"Retirement")),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall",style:colwidth("12em")},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center"}},"Amount")))),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["R" /* TableBody */],null,this.props.state.needs.capitalNeeds.map(function(e,i){return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["d" /* Button */],{name:"capitalNeeds.removeN"+i,key:"capitalNeeds.removeN"+i,variant:"fab",mini:true,className:"tinyfab",color:"primary",style:{left:"-20px",top:"-5px"},onClick:function onClick(e){e.stopPropagation();_this2.remove(e);}},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["w" /* Icon */],{style:{color:"white"}},"remove")),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(CustomField2,{name:"capitalNeeds.category"+i,component:__WEBPACK_IMPORTED_MODULE_11_components_Wrappers_materialUIWrappers_components_FormDropDown__["a" /* default */],checkValidation:_this2.props.checkValidation,label:'',isrequired:true//validate={[required]}
,options:[{displayValue:"Please Select",value:" ",limit:1},{displayValue:"Education",value:"education"},{displayValue:"Fixed asset",value:"fixedAsset"},{displayValue:"Other asset",value:"otherAsset"},{displayValue:"Other",value:"other"}],onChange:function onChange(e,value,t,name){return _this2.changeCat(value,name);}})),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(CustomField,{name:'capitalNeeds.provision'+i,component:__WEBPACK_IMPORTED_MODULE_13_components_Wrappers_materialUIWrappers_components_FormInput__["a" /* default */],checkValidation:_this2.props.checkValidation,label:'description',isrequired:true//validate={[required]}
,onChange:function onChange(e,value,t,name){return _this2.changeStream(value,name);}})),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,checkItem("","capitalNeeds.death"+i,_this2.changeDeath)),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,checkItem("","capitalNeeds.disability"+i,_this2.changeDisability)),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null," ",checkItem("","capitalNeeds.retirement"+i,_this2.changeRetirement)),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(CustomField,{name:'capitalNeeds.mounthlyAmount'+i,prefix:"R",component:__WEBPACK_IMPORTED_MODULE_12_components_Wrappers_materialUIWrappers_components_NumberInput__["a" /* default */],checkValidation:_this2.props.checkValidation,label:'R*',isrequired:true,validate:[required],onChange:function onChange(e,value,t,name){return _this2.changeMounthlyAmount(value,name);}}));}),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_DescriptiveCell_jsx__["a" /* default */],{width:"150em",description:"Add Income",add:function add(){return _this2.addNewCapitalNeed();}}),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{variant:"title"})),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{variant:"title"})))))))),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["q" /* ExpansionPanel */],{defaultExpanded:1===0,key:1,onClick:function onClick(event){return _this2.cashBequestsExpand(event);}},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["s" /* ExpansionPanelSummary */],{expandIcon:__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["w" /* Icon */],null,"expand_more")},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Q" /* Table */],null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingTiny",style:colwidth("5em")},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{variant:"title",style:{fontWeight:'bold'}},"Cash Bequests")),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingTiny",style:colwidth("2em")},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{variant:"title",style:{fontWeight:'bold'}},this.props.state.needs.expanded.cashBequests==false&&"Total")),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingTiny",style:colwidth("15em")},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{variant:"title",style:{fontWeight:'bold'}},this.props.state.needs.expanded.cashBequests==false&&this.props.state.needs.totals.cashBequests))))),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["r" /* ExpansionPanelDetails */],{onClick:function onClick(event){event.stopPropagation();}},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{container:true,spacing:24},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Q" /* Table */],{className:"customTable1"},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["T" /* TableHead */],{className:"fixedHead"},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingTiny",style:colwidth("15em")},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center"}},"Category")),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingTiny",style:colwidth("8.5em")},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center"}},"Description")),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall",style:colwidth("6em")},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px'}})),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingTiny",style:colwidth("6em")},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center",verticalAlign:'bottom'}})),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall",style:colwidth("6em")},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center"}})),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall",style:colwidth("12em")},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center"}},"Amount")))),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["R" /* TableBody */],null,this.props.state.needs.cashBequests.map(function(e,i){return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["d" /* Button */],{name:"cashBequests.removeN"+i,key:"cashBequests.removeN"+i,variant:"fab",mini:true,className:"tinyfab",color:"primary",style:{left:"-20px",top:"-5px"},onClick:function onClick(e){e.stopPropagation();_this2.remove(e);}},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["w" /* Icon */],{style:{color:"white"}},"remove")),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(CustomField2,{name:"cashBequests.category"+i,component:__WEBPACK_IMPORTED_MODULE_11_components_Wrappers_materialUIWrappers_components_FormDropDown__["a" /* default */],checkValidation:_this2.props.checkValidation,label:'',isrequired:true//validate={[required]}
,options:[{displayValue:"Please Select",value:" ",limit:1},{displayValue:"Cash bequest",value:"cashBequest"},{displayValue:"Cash bequest to charity",value:"cashBequestCharity"}],onChange:function onChange(e,value,t,name){return _this2.changeCat(value,name);}})),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(CustomField,{name:'cashBequests.provision'+i,component:__WEBPACK_IMPORTED_MODULE_13_components_Wrappers_materialUIWrappers_components_FormInput__["a" /* default */],checkValidation:_this2.props.checkValidation,label:'description',isrequired:true//validate={[required]}
,onChange:function onChange(e,value,t,name){return _this2.changeStream(value,name);}})),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(CustomField,{name:'cashBequests.mounthlyAmount'+i,prefix:"R",component:__WEBPACK_IMPORTED_MODULE_12_components_Wrappers_materialUIWrappers_components_NumberInput__["a" /* default */],checkValidation:_this2.props.checkValidation,label:'R*',isrequired:true,validate:[required],onChange:function onChange(e,value,t,name){return _this2.changeMounthlyAmount(value,name);}}));}),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_DescriptiveCell_jsx__["a" /* default */],{width:"150em",description:"Add Bequest",add:function add(){return _this2.addNewcashBequest();}}),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{variant:"title"})))))))))));}}]);return Conversion;}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Conversion);

/***/ }),
/* 2486 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export NameOfBequeath */
var NameOfBequeath=[{value:"",displayValue:"Empty"},{value:"spouse",displayValue:"Spouse"},{value:"son",displayValue:"Son"},{value:"daughter",displayValue:"Daughter"},{value:"father",displayValue:"Father"},{value:"mother",displayValue:"Mother"},{value:"brother",displayValue:"Brother"},{value:"sister",displayValue:"Sister"},{value:"in_laws",displayValue:"In Laws"},{value:"family_trust",displayValue:"Family Trust"},{value:"charity",displayValue:"Charity"},{value:"other",displayValue:"Other"}];

/***/ }),
/* 2487 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_core__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_DescriptiveRow_jsx__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_Wrappers_materialUIWrappers_components_FormCheckbox_jsx__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Wrappers_materialUIWrappers_components_FormDropDown__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Wrappers_materialUIWrappers_components_FormInput__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_helpers_ReduxHelpers__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_redux_form__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_store__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_CustomCardHeading_jsx__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__objects_banks__ = __webpack_require__(630);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__objects_otherLiabilityItems__ = __webpack_require__(396);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_Wrappers_materialUIWrappers_components_NumberInput__ = __webpack_require__(31);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var colwidth=function colwidth(value){return{width:value,minWidth:value,maxWidth:value};};var required=function required(value){return value?undefined:"Required";};var OtherLiability=function(_React$Component){_inherits(OtherLiability,_React$Component);function OtherLiability(){var _ref;var _temp,_this,_ret;_classCallCheck(this,OtherLiability);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=OtherLiability.__proto__||Object.getPrototypeOf(OtherLiability)).call.apply(_ref,[this].concat(args))),_this),_this.add=function(name){var liabilities=__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(__WEBPACK_IMPORTED_MODULE_9_store__["a" /* default */].getState().form,"newfna.values.liabilities."+name,{});var id=0;if(Object.keys(liabilities).length>0){var max=Math.max.apply(Math,Object.keys(liabilities).map(function(b){return parseInt(b,10);}));id=max+1;}__WEBPACK_IMPORTED_MODULE_9_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_8_redux_form__["b" /* change */])("newfna","liabilities."+name+"."+id,{settle_disability:false}));_this.props.RemoveIgnore("liabilities."+name);_this.forceUpdate();},_this.remove=function(name,id){var fieldParent="liabilities."+name;var ignore=Object(__WEBPACK_IMPORTED_MODULE_5_helpers_ReduxHelpers__["b" /* RemoveField */])("newfna",fieldParent+"."+id,fieldParent);if(ignore){_this.props.AddIgnore(fieldParent);}_this.forceUpdate();},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(OtherLiability,[{key:"componentDidMount",value:function componentDidMount(){this.props.scrollMeBar();}},{key:"render",value:function render(){var _this2=this;var checkValidation=this.props.checkValidation;var liabilities=__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(__WEBPACK_IMPORTED_MODULE_9_store__["a" /* default */].getState().form,"newfna.values.liabilities",{});return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("div",{className:"contentWithStepper"},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["e" /* Card */],null,__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["f" /* CardContent */],null,__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_CustomCardHeading_jsx__["a" /* default */],{subheading:"Financial Needs Analysis",caption:"Client Name",headline:"Other Liability"}),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{container:true,spacing:24,className:"customTableAutoGrid"},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Q" /* Table */],{className:"customTable1"},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["T" /* TableHead */],{className:"fixedHead"},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{style:colwidth("15em")},"Liability"),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{style:colwidth("10.5em")},"Amount"),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{style:colwidth("12em")},"To who?"),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{style:colwidth("10.5em")},"Settle at disability?"),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{style:colwidth("12em")},"Who is liable?"))),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["R" /* TableBody */],null,__WEBPACK_IMPORTED_MODULE_12__objects_otherLiabilityItems__["a" /* otherLiabilityItems */].map(function(l){var fieldItems=liabilities&&liabilities[l.name]&&Object.keys(liabilities[l.name]).length>0?liabilities[l.name]:null;return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react___default.a.Fragment,{key:l.name},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__components_DescriptiveRow_jsx__["a" /* default */],{description:l.displayName,add:function add(){return _this2.add(l.name);},count:fieldItems?fieldItems.length:0,extraCells:4}),!fieldItems?null:Object.keys(fieldItems).map(function(id,i){return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],{key:l.name+id},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{style:i!==fieldItems.length-1?{border:"0px"}:{},padding:"none",className:"cellPaddingSmall"},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{container:true},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{item:true,xs:2,sm:2,md:2},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["d" /* Button */],{variant:"fab",mini:true,className:"minifab",style:{top:"18px",backgroundColor:"#ffae4a"},onClick:function onClick(){return _this2.remove(l.name,id);}},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["w" /* Icon */],null,"remove"))),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{item:true,xs:10,sm:10,md:10},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["t" /* FormControl */],{fullWidth:true},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_4_components_Wrappers_materialUIWrappers_components_FormInput__["a" /* default */],isrequired:true,validate:[required],checkValidation:checkValidation,name:"liabilities."+l.name+"."+id+".description",label:"Description"}))))),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{padding:"none",className:"cellPaddingSmall"},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["t" /* FormControl */],{fullWidth:true},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_13_components_Wrappers_materialUIWrappers_components_NumberInput__["a" /* default */],prefix:"R",seperator:" ",isrequired:true,validate:[required],checkValidation:checkValidation,name:"liabilities."+l.name+"."+id+".amount",label:"Amount"}))),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{padding:"none",className:"cellPaddingSmall"},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["t" /* FormControl */],{fullWidth:true},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_3_components_Wrappers_materialUIWrappers_components_FormDropDown__["a" /* default */],checkValidation:_this2.props.checkValidation,label:"To Who?",name:"liabilities."+l.name+"."+id+".towho",options:__WEBPACK_IMPORTED_MODULE_11__objects_banks__["a" /* banks */]}))),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{padding:"none",className:"cellPaddingSmall"},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["t" /* FormControl */],{fullWidth:true},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_2_components_Wrappers_materialUIWrappers_components_FormCheckbox_jsx__["a" /* default */],name:"liabilities."+l.name+"."+id+".settle_disability"}))),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["t" /* FormControl */],{fullWidth:true},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_3_components_Wrappers_materialUIWrappers_components_FormDropDown__["a" /* default */],checkValidation:_this2.props.checkValidation,label:"Who is liable?",name:"liabilities."+l.name+"."+id+".person_liable",options:[{value:"validationError",displayValue:"Please select"},{value:"client",displayValue:"Client"},{value:"spouse",displayValue:"Spouse"}]}))));}));})))))));}}]);return OtherLiability;}(__WEBPACK_IMPORTED_MODULE_7_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (OtherLiability);

/***/ }),
/* 2488 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_core__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_DescriptiveRow_jsx__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_Wrappers_materialUIWrappers_components_FormInput__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_helpers_ReduxHelpers__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_redux_form__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_store__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_CustomCardHeading_jsx__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_Wrappers_materialUIWrappers_components_NumberInput__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_Wrappers_materialUIWrappers_components_FormCheckbox_jsx__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_helpers_ValidationHelpers__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_Wrappers_materialUIWrappers_components_FormDropDown__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_DescriptiveCell_jsx__ = __webpack_require__(631);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__objects_FNA_result_vars_js__ = __webpack_require__(397);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__objects_assumptions_js__ = __webpack_require__(398);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_util__ = __webpack_require__(2489);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_util__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// or directly
var colwidth=function colwidth(value){return{width:value,minWidth:value,maxWidth:value};};var CustomField=function CustomField(props){return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall"},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["t" /* FormControl */],{fullWidth:true},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_redux_form__["a" /* Field */],props)));};var CustomField2=function CustomField2(props){return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["t" /* FormControl */],{fullWidth:true,style:{bottom:"10px"}},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_redux_form__["a" /* Field */],props));};var grandSeperator=function grandSeperator(val){if(!val){return"0.00";}val=val.toString().replace(/,/g,"").replace(/ /g,"");var parsed=parseFloat(val);if(!isNaN(parsed)){return parsed.toLocaleString(undefined,{minimumFractionDigits:2,maximumFractionDigits:2}).replace(/,/g," ");}else{return val;}};var OtherIncome=function(_React$Component){_inherits(OtherIncome,_React$Component);function OtherIncome(){var _ref;var _temp,_this,_ret;_classCallCheck(this,OtherIncome);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=OtherIncome.__proto__||Object.getPrototypeOf(OtherIncome)).call.apply(_ref,[this].concat(args))),_this),_this.mustBeFullPercentage=function(value,a,b,c){var iInit=c.split(".");var iLength=iInit.length-1;var i=iInit[iLength].replace("spouse","").replace("charity","").replace("dependents","").replace("trust","").replace("charity","").replace("other","");var cat=_this.props.state[iInit[0]][i];if(iInit.length>2)cat=_this.props.state[iInit[0]][[iInit[1]]][i];var fullPercentage=parseInt(cat.estateInherit)+parseInt(cat.spouseInherit)+parseInt(cat.dependentsInherit)+parseInt(cat.trustInherit)+parseInt(cat.charityInherit)+parseInt(cat.otherInherit);//console.log("Testing persentage " + i + " " + cat + " " + fullPercentage)
if(fullPercentage!=100||parseInt(cat.estateInherit)<0)return"Must add up to 100";return undefined;},_this.checkItem=function(label,name,changeFunc){return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["t" /* FormControl */],{style:{marginBottom:"-30px",paddingBottom:"-30px",left:"30px"}},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_10_components_Wrappers_materialUIWrappers_components_FormCheckbox_jsx__["a" /* default */],name:name,onChange:function onChange(e,f,g,h){changeFunc(f,h);}}));},_this.changeDutyExcempt=function(value,name){var policies=_this.props.state.policy;var policy=name.replace("dutyExcempt","");policies[policy].dutyExcempt=value;//this.props.changePolicy(policy);
},_this.fixedAssestsExpand=function(expand){var asset=_this.props.state.deathDistribution;asset.expanded.fixedAssests=!asset.expanded.fixedAssests;_this.props.deathDistExpand(asset);},_this.liquidAssestsExpand=function(expand){var asset=_this.props.state.deathDistribution;asset.expanded.liquidAssets=!asset.expanded.liquidAssets;_this.props.deathDistExpand(asset);},_this.policiesExpand=function(expand){var asset=_this.props.state.deathDistribution;asset.expanded.policies=!asset.expanded.policies;_this.props.deathDistExpand(asset);},_this.bequestsExpand=function(expand){var asset=_this.props.state.deathDistribution;asset.expanded.bequests=!asset.expanded.bequests;_this.props.deathDistExpand(asset);},_this.retirementExpand=function(expand){var asset=_this.props.state.deathDistribution;asset.expanded.retirement=!asset.expanded.retirement;_this.props.deathDistExpand(asset);},_this.changeCharity=function(value,name){var cat=name.split(".")[0];var changeObj=_this.props.state[cat];var i=name.split(".")[1].replace("charity","");if(name.split(".").length>2){cat+="."+name.split(".")[1];changeObj=changeObj[name.split(".")[1]];i=name.split(".")[2].replace("charity","");}changeObj[i].charityInherit=value;_this.props.changeDeathDist(cat,changeObj);_this.calcEstateInherit(cat,i);_this.getInheretValue(cat,"charityInherit");},_this.changeEstate=function(value,name){var cat=name.split(".")[0];var changeObj=_this.props.state[cat];var i=name.split(".")[1].replace("estate","");if(name.split(".").length>2){cat+="."+name.split(".")[1];changeObj=changeObj[name.split(".")[1]];i=name.split(".")[2].replace("estate","");}changeObj[i].estateInherit=value;_this.props.changeDeathDist(cat,changeObj);_this.getInheretValue(cat,"estateInherit");},_this.changeSpouse=function(value,name){var cat=name.split(".")[0];var changeObj=_this.props.state[cat];var i=name.split(".")[1].replace("spouse","");if(name.split(".").length>2){cat+="."+name.split(".")[1];changeObj=changeObj[name.split(".")[1]];i=name.split(".")[2].replace("spouse","");}changeObj[i].spouseInherit=value;_this.props.changeDeathDist(cat,changeObj);_this.calcEstateInherit(cat,i);},_this.changeDependents=function(value,name){var cat=name.split(".")[0];var changeObj=_this.props.state[cat];var i=name.split(".")[1].replace("dependents","");if(name.split(".").length>2){cat+="."+name.split(".")[1];changeObj=changeObj[name.split(".")[1]];i=name.split(".")[2].replace("dependents","");}//console.log("->>>>>>>>>>>>>>>>>>> " + cat + " " + changeObj + " " + i)
changeObj[i].dependentsInherit=value;_this.props.changeDeathDist(cat,changeObj);_this.calcEstateInherit(cat,i);},_this.changeTrust=function(value,name){var cat=name.split(".")[0];var changeObj=_this.props.state[cat];var i=name.split(".")[1].replace("trust","");if(name.split(".").length>2){cat+="."+name.split(".")[1];changeObj=changeObj[name.split(".")[1]];i=name.split(".")[2].replace("trust","");}changeObj[i].trustInherit=value;_this.props.changeDeathDist(cat,changeObj);_this.calcEstateInherit(cat,i);},_this.changeOther=function(value,name){var cat=name.split(".")[0];var changeObj=_this.props.state[cat];var i=name.split(".")[1].replace("other","");if(name.split(".").length>2){cat+="."+name.split(".")[1];changeObj=changeObj[name.split(".")[1]];i=name.split(".")[2].replace("other","");}changeObj[i].otherInherit=value;_this.props.changeDeathDist(cat,changeObj);_this.calcEstateInherit(cat,i);},_this.getAssetValue=function(i){_this.calcBalanceSheet();return _this.props.state.assets[i].marketValue*_this.props.state.assets[i].ownershipClient/100;},_this.getAssetTotalValue=function(l){var total=0.00;if(!l)_this.props.state.assets.map(function(e,i){if(!e.liquid)total+=_this.getAssetValue(i);});else _this.props.state.assets.map(function(e,i){if(e.liquid)total+=_this.getAssetValue(i);});_this.props.state.policy.map(function(e,i){if(e.party=="client"&&e.LifeAssured!="client")total+=parseFloat(e.cashValue);});if(!l)_this.props.state.deathDistribution.totals.fixedAssests=total;else _this.props.state.deathDistribution.totals.liquidAssets=total;_this.calcBalanceSheet();return grandSeperator(total);},_this.getPolicyTotalValue=function(){var total=0.00;_this.props.state.policy.map(function(e,i){if(e.LifeAssured=="client")total+=parseFloat(e.death);});_this.calcBalanceSheet();return grandSeperator(total);},_this.getRetirementTotalValue=function(){var total=0.00;_this.props.state.retirement.map(function(e,i){total+=parseFloat(e.value);});_this.calcBalanceSheet();return grandSeperator(total);},_this.getBequestsTotalValue=function(){var total=0.00;_this.props.state.needs.cashBequests.map(function(e,i){if(e.category=="cashBequest"||e.category=="cashBequestCharity")total+=parseFloat(e.mounthlyAmount);});_this.calcBalanceSheet();return grandSeperator(total);},_this.getInheretValue=function(cat,inhereter){var total=0.00;if(cat=="assets")_this.props.state[cat].map(function(e,i){if(!e.liquid)total+=e.marketValue*e.ownershipClient/100*e[inhereter]/100;});if(cat=="assetsL"){cat="assets";_this.props.state[cat].map(function(e,i){if(e.liquid)total+=e.marketValue*e.ownershipClient/100*e[inhereter]/100;});_this.props.state.policy.map(function(e,i){if(e.party=="client"&&e.LifeAssured!="client")total+=parseFloat(e.cashValue*e[inhereter]/100);});}if(cat=="policy")_this.props.state[cat].map(function(e,i){if(e.LifeAssured=="client")if(e[inhereter])total+=parseFloat(e.death)*e[inhereter]/100;});if(cat=="retirement")_this.props.state[cat].map(function(e,i){if(e[inhereter])total+=parseFloat(e.value)*e[inhereter]/100;});if(cat=="needs.cashBequests"){var cat1=cat.split(".")[0];var cat2=cat.split(".")[1];_this.props.state[cat1][cat2].map(function(e,i){if(e.category=="cashBequest"||e.category=="cashBequestCharity")if(e[inhereter])total+=parseFloat(e.mounthlyAmount)*e[inhereter]/100;});}_this.calcBalanceSheet();//console.log(this.props.state)
return grandSeperator(total);},_this.convertAsset=function(e){var assets=_this.props.state.assets;var i=e.currentTarget.name.replace("convert",'');assets[i].liquid=!assets[i].liquid;_this.calcBalanceSheet();_this.props.update();},_this.calcBalanceSheet=function(){_this.props.state.result=new __WEBPACK_IMPORTED_MODULE_14__objects_FNA_result_vars_js__["b" /* fnaResult */]().fna;_this.props.state.assets.map(function(e,i){var balanceSheetAsset={};balanceSheetAsset.description=e.description;balanceSheetAsset.ownershipClient=e.ownershipClient/100*e.marketValue;balanceSheetAsset.ownershipSpouse=e.ownershipSpouse/100*e.marketValue;_this.props.state.result.balanceSheet.netAssetsClient+=balanceSheetAsset.ownershipClient;_this.props.state.result.balanceSheet.netAssetsSpouse+=balanceSheetAsset.ownershipSpouse;_this.props.state.result.balanceSheet.assets.push(balanceSheetAsset);if(e.liability>0){var balanceSheetLiability={};if(e.ownershipClient>0){balanceSheetLiability.description=e.description;balanceSheetLiability.amountClient=parseFloat(e.liability)*e.ownershipClient/100;_this.props.state.result.balanceSheet.netLiabilitiesClient+=parseFloat(balanceSheetLiability.amountClient);}if(e.ownershipSpouse>0){balanceSheetLiability.description=e.description;balanceSheetLiability.amountSpouse=parseFloat(e.liability)*e.ownershipSpouse/100;_this.props.state.result.balanceSheet.netLiabilitiesSpouse+=parseFloat(balanceSheetLiability.amountSpouse);}_this.props.state.result.balanceSheet.liabilities.push(balanceSheetLiability);}});_this.props.state.liabilities.map(function(e,i){var balanceSheetLiability={};balanceSheetLiability.description=e.description;if(e.party=="client"){balanceSheetLiability.amountClient=parseFloat(e.amount);_this.props.state.result.balanceSheet.netLiabilitiesClient+=parseFloat(e.amount);}else{balanceSheetLiability.amountSpouse=parseFloat(e.amount);_this.props.state.result.balanceSheet.netLiabilitiesSpouse+=parseFloat(e.amount);}_this.props.state.result.balanceSheet.liabilities.push(balanceSheetLiability);});var pToEstate=0.00;_this.props.state.policy.map(function(e,i){var balanceSheetPolicy={};balanceSheetPolicy.description=e.description;if(e.LifeAssured=="client"){pToEstate+=parseFloat(e.death)*parseFloat(e.estateInherit)/100;}if(e.party=="client"&&e.LifeAssured!="client"){balanceSheetPolicy.amountClient=parseFloat(e.cashValue);_this.props.state.result.balanceSheet.netPoliciesClient+=parseFloat(e.cashValue);_this.props.state.result.balanceSheet.policies.push(balanceSheetPolicy);}if(e.party=="spouse"&&e.LifeAssured!="spouse"&&e.LifeAssured!="client"){balanceSheetPolicy.amountSpouse=parseFloat(e.cashValue);_this.props.state.result.balanceSheet.netPoliciesSpouse+=parseFloat(e.cashValue);_this.props.state.result.balanceSheet.policies.push(balanceSheetPolicy);}});_this.props.state.result.balanceSheet.netTotalAssetsClient=parseFloat(_this.props.state.result.balanceSheet.netAssetsClient)+parseFloat(_this.props.state.result.balanceSheet.netPoliciesClient)-parseFloat(_this.props.state.result.balanceSheet.netLiabilitiesClient);_this.props.state.result.balanceSheet.netTotalAssetsSpouse=parseFloat(_this.props.state.result.balanceSheet.netAssetsSpouse)+parseFloat(_this.props.state.result.balanceSheet.netPoliciesSpouse)-parseFloat(_this.props.state.result.balanceSheet.netLiabilitiesSpouse);_this.props.state.result.executorFees.percentageApplicable=_this.props.state.execFee;_this.props.state.result.executorFees.vat=_this.props.state.vat;_this.props.state.result.executorFees.pToEstate=pToEstate;_this.props.state.result.executorFees.executorFee=(parseFloat(_this.props.state.result.balanceSheet.netAssetsClient)+pToEstate)*parseFloat(_this.props.state.execFee)/100;if(_this.props.state.execTax)_this.props.state.result.executorFees.executorFee=_this.props.state.result.executorFees.executorFee*(1+parseFloat(_this.props.state.vat)/100);//Need to add Policies to Estate
_this.calcCgt();},_this.calcCgt=function(){_this.props.state.result.cgt.minuspResidence.primaryResidenceExclusion=__WEBPACK_IMPORTED_MODULE_15__objects_assumptions_js__["a" /* default */].primary_residence_exemption;_this.props.state.assets.map(function(e,i){if(e.cgtPayable){var temp={};temp.description=e.description;temp.category=e.category;temp.marketValue=parseFloat(e.marketValue)*parseFloat(e.ownershipClient)/100;temp.baseCost=parseFloat(e.baseCost)*parseFloat(e.ownershipClient)/100;temp.capitalGain=parseFloat(temp.marketValue)-parseFloat(temp.baseCost);//-e.liability;
if(e.category=="farms_owned"&&_this.props.state.percentageOnFarm){temp.marketValue*=0.7;temp.baseCost*=0.7;temp.capitalGain=parseFloat(temp.marketValue)-parseFloat(temp.baseCost);}if(e.category=="primary_residential"){if(temp.capitalGain-parseFloat(_this.props.state.result.cgt.minuspResidence.primaryResidenceExclusion*parseFloat(e.ownershipClient)/100)>0)temp.capitalGain=temp.capitalGain-parseFloat(_this.props.state.result.cgt.minuspResidence.primaryResidenceExclusion*parseFloat(e.ownershipClient)/100);else temp.capitalGain=0.00;_this.props.state.result.cgt.netClientsCapitalGainDisplay+=temp.capitalGain;_this.props.state.result.cgt.pResidence=temp;}else if(e.category!="primary_residential"){_this.props.state.result.cgt.netClientsCapitalGainDisplay+=temp.capitalGain;}temp.bequethedToSpouse=e.spouseInherit/100*temp.capitalGain;if(_this.props.state.spouseInheritFull==false)temp.residueTospouse=_this.props.state.residueAmount/100*parseFloat(temp.capitalGain)*e.estateInherit/100;else if(_this.props.state.spouseInheritFull==true)temp.residueTospouse=parseFloat(temp.capitalGain)*e.estateInherit/100;temp.netGain=temp.capitalGain-temp.bequethedToSpouse-temp.residueTospouse;_this.props.state.result.cgt.netCgtMarketValue+=parseFloat(e.marketValue);_this.props.state.result.cgt.netClientsBaseCost+=parseFloat(e.baseCost);_this.props.state.result.cgt.netClientsCapitalGain+=parseFloat(temp.capitalGain);_this.props.state.result.cgt.netCashBequestTospouse+=parseFloat(temp.bequethedToSpouse);_this.props.state.result.cgt.netResidueTospouse+=parseFloat(temp.residueTospouse);_this.props.state.result.cgt.netSpouseCapitalGain+=parseFloat(temp.netGain);_this.props.state.result.cgt.cgtAssets.push(temp);}if(_this.props.state.result.cgt.netClientsCapitalGain>0)_this.props.state.result.cgt.capitalGain=_this.props.state.result.cgt.netClientsCapitalGain;//Primary residense exlusion
if(e.category=="primary_residential"){if(temp.netGain>__WEBPACK_IMPORTED_MODULE_15__objects_assumptions_js__["a" /* default */].primary_residence_exemption)_this.props.state.result.cgt.minuspResidence.primaryResidence=__WEBPACK_IMPORTED_MODULE_15__objects_assumptions_js__["a" /* default */].primary_residence_exemption;else _this.props.state.result.cgt.minuspResidence.primaryResidence=temp.netGain;if(temp.netGain<-1*__WEBPACK_IMPORTED_MODULE_15__objects_assumptions_js__["a" /* default */].primary_residence_exemption)_this.props.state.result.cgt.minuspResidence.primaryResidenceLoss=-1*__WEBPACK_IMPORTED_MODULE_15__objects_assumptions_js__["a" /* default */].primary_residence_exemption;else _this.props.state.result.cgt.minuspResidence.primaryResidenceLoss=temp.netGain;}});_this.props.state.result.cgt.minuspResidence.primaryResidenceLossExclusion=-1*__WEBPACK_IMPORTED_MODULE_15__objects_assumptions_js__["a" /* default */].primary_residence_exemption;_this.props.state.result.cgt.minuspResidence.netExclusion=_this.props.state.result.cgt.minuspResidence.primaryResidence+_this.props.state.result.cgt.minuspResidence.primaryResidenceLoss;_this.props.state.result.cgt.netMinusExlusion=_this.props.state.result.cgt.netClientsCapitalGain-_this.props.state.result.cgt.minuspResidence.netExclusion;_this.props.state.result.cgt.minusspouseRollOver.portionBequethedTospouse=_this.props.state.result.cgt.netCashBequestTospouse;_this.props.state.result.cgt.minusspouseRollOver.portionResidueTospouse=_this.props.state.result.cgt.netResidueTospouse;_this.props.state.result.cgt.minusspouseRollOver.netRollOver=_this.props.state.result.cgt.minusspouseRollOver.portionBequethedTospouse+_this.props.state.result.cgt.minusspouseRollOver.portionResidueTospouse;_this.props.state.result.cgt.netMinusRollOver=_this.props.state.result.cgt.netClientsCapitalGain-_this.props.state.result.cgt.minusspouseRollOver.netRollOver;_this.props.state.result.cgt.minusPreviousLoss=_this.props.state.capitalLossAmount;_this.props.state.result.cgt.netMinusPreviousLoss=_this.props.state.result.cgt.netMinusRollOver-_this.props.state.result.cgt.minusPreviousLoss;_this.props.state.result.cgt.minusExclusionAtDeath=__WEBPACK_IMPORTED_MODULE_15__objects_assumptions_js__["a" /* default */].cgtExclusionAtDeath;if(_this.props.state.result.cgt.netMinusPreviousLoss>0)_this.props.state.result.cgt.netMinusExlusionAtDeath=_this.props.state.result.cgt.minusExclusionAtDeath;else _this.props.state.result.cgt.netMinusExlusionAtDeath=0;_this.props.state.result.cgt.netCgt=_this.props.state.result.cgt.netMinusPreviousLoss-_this.props.state.result.cgt.netMinusExlusionAtDeath;_this.props.state.result.cgt.marginalTax=_this.props.state.marginalTax;_this.props.state.result.cgt.inclusionRate=__WEBPACK_IMPORTED_MODULE_15__objects_assumptions_js__["a" /* default */].inclusion_rate_for_cgt;if(_this.props.state.result.cgt.netCgt>0)_this.props.state.result.cgt.cgtPayable=_this.props.state.result.cgt.netCgt*_this.props.state.result.cgt.marginalTax/100*_this.props.state.result.cgt.inclusionRate/100;else _this.props.state.result.cgt.cgtPayable=0;//console.log(this.props.state.result)
_this.calcAccrual();},_this.calcEstateDuty=function(){_this.props.state.assets.map(function(e,i){if(e.category=="farms_owned"){if(_this.props.state.percentageOnFarm)_this.props.state.result.estateDuty.assets.netFarms+=e.ownershipClient/100*e.marketValue*0.7;else _this.props.state.result.estateDuty.assets.netFarms+=e.ownershipClient/100*e.marketValue;}else if(e.category=="usufruct_annuity_charged_on_property_or_similar_right")_this.props.state.result.estateDuty.assets.netDeemedAssets+=e.ownershipClient/100*e.marketValue;else _this.props.state.result.estateDuty.assets.netAssets+=e.ownershipClient/100*e.marketValue;});_this.props.state.policy.map(function(e,i){if(!e.dutyExcempt)if(e.LifeAssured=="client"){_this.props.state.result.estateDuty.assets.netPoliciesOnLife+=parseFloat(e.death);_this.props.state.result.estateDuty.deductions.netPoliciesToSpouse+=parseFloat(e.death)*e.spouseInherit/100;}else if(e.party=="client")_this.props.state.result.estateDuty.assets.netPoliciesWithChash+=parseFloat(e.cashValue);});_this.props.state.result.estateDuty.assets.netEstateAssets=parseFloat(_this.props.state.result.estateDuty.assets.netFarms)+parseFloat(_this.props.state.result.estateDuty.assets.netDeemedAssets)+parseFloat(_this.props.state.result.estateDuty.assets.netAssets)+parseFloat(_this.props.state.result.estateDuty.assets.netPoliciesOnLife)+parseFloat(_this.props.state.result.estateDuty.assets.netPoliciesWithChash)+parseFloat(_this.props.state.result.estateDuty.assets.netAccrualClaim);_this.props.state.result.estateDuty.deductions.netLiabilities=_this.props.state.result.balanceSheet.netLiabilitiesClient;_this.props.state.result.estateDuty.deductions.netAdministration=parseFloat(_this.props.state.adminCost);_this.props.state.result.estateDuty.deductions.netFuneral=parseFloat(_this.props.state.funeralCost);_this.props.state.result.estateDuty.deductions.netMastersFee=__WEBPACK_IMPORTED_MODULE_15__objects_assumptions_js__["a" /* default */].masters_fees;_this.props.state.result.estateDuty.deductions.netExectutorsFee=_this.props.state.result.executorFees.executorFee;_this.props.state.result.estateDuty.deductions.netCapitalGainTax=_this.props.state.result.cgt.cgtPayable;_this.props.state.assets.map(function(e,i){if(e.category=="primary_residential"||e.category=="other_residential")_this.props.state.result.estateDuty.deductions.netTransferCosts+=parseFloat(e.marketValue);// * e.ownershipClient/100 //Should this only be the Client's portion??
_this.props.state.result.estateDuty.deductions.netBequethedAssets+=parseFloat(e.marketValue)*e.ownershipClient/100*e.spouseInherit/100;});_this.props.state.result.estateDuty.deductions.netTransferCosts=parseFloat(_this.props.state.result.estateDuty.deductions.netTransferCosts)*parseFloat(__WEBPACK_IMPORTED_MODULE_15__objects_assumptions_js__["a" /* default */].transfer_costs)/100;_this.props.state.needs.cashBequests.map(function(e,i){if(e.category=="cashBequest"||e.category=="cashBequestCharity"){_this.props.state.result.estateDuty.deductions.netCashBequestTospouse+=e.mounthlyAmount*e.spouseInherit/100;_this.props.state.result.estateDuty.deductions.netCashBequestToCharity+=e.mounthlyAmount*e.charityInherit/100;}});_this.calcResidue();if(_this.props.state.spouseInheritFull==false)_this.props.state.result.estateDuty.deductions.netResidueTospouse=_this.props.state.result.residue.residueBeforeEstateDuty*_this.props.state.residueAmount/100;else _this.props.state.result.estateDuty.deductions.netResidueTospouse=_this.props.state.result.residue.residueBeforeEstateDuty;_this.props.state.result.estateDuty.deductions.netAccrualClaim=_this.props.state.result.accrual.clainBySpouse;_this.props.state.result.estateDuty.deductions.netDeductions=parseFloat(_this.props.state.result.estateDuty.deductions.netLiabilities)+parseFloat(_this.props.state.result.estateDuty.deductions.netAdministration)+parseFloat(_this.props.state.result.estateDuty.deductions.netFuneral)+parseFloat(_this.props.state.result.estateDuty.deductions.netMastersFee)+parseFloat(_this.props.state.result.estateDuty.deductions.netExectutorsFee)+parseFloat(_this.props.state.result.estateDuty.deductions.netCapitalGainTax)+parseFloat(_this.props.state.result.estateDuty.deductions.netTransferCosts)+parseFloat(_this.props.state.result.estateDuty.deductions.netBequethedAssets)+parseFloat(_this.props.state.result.estateDuty.deductions.netCashBequestTospouse)+parseFloat(_this.props.state.result.estateDuty.deductions.netCashBequestToCharity)+parseFloat(_this.props.state.result.estateDuty.deductions.netResidueTospouse)+parseFloat(_this.props.state.result.estateDuty.deductions.netPoliciesToSpouse)+parseFloat(_this.props.state.result.estateDuty.deductions.netAccrualClaim);_this.props.state.result.estateDuty.netEstate=_this.props.state.result.estateDuty.assets.netEstateAssets-_this.props.state.result.estateDuty.deductions.netDeductions;_this.props.state.result.estateDuty.minusRebate=__WEBPACK_IMPORTED_MODULE_15__objects_assumptions_js__["a" /* default */].estate_duty_exemption;if(_this.props.state.spouseDeath)_this.props.state.result.estateDuty.minusRebateFromPreviousSpouse=parseFloat(_this.props.state.rebateUsed);else _this.props.state.result.estateDuty.minusRebateFromPreviousSpouse=0.00;//check if correct
_this.props.state.result.estateDuty.taxableEstate=_this.props.state.result.estateDuty.netEstate-_this.props.state.result.estateDuty.minusRebate-_this.props.state.result.estateDuty.minusRebateFromPreviousSpouse;if(_this.props.state.result.estateDuty.taxableEstate<0)_this.props.state.result.estateDuty.taxableEstate=0.00;if(_this.props.state.result.estateDuty.taxableEstate<=30000000)_this.props.state.result.estateDuty.estateDutyPayable=_this.props.state.result.estateDuty.taxableEstate*__WEBPACK_IMPORTED_MODULE_15__objects_assumptions_js__["a" /* default */].estateDutyLT/100;else _this.props.state.result.estateDuty.estateDutyPayable=_this.props.state.result.estateDuty.taxableEstate*__WEBPACK_IMPORTED_MODULE_15__objects_assumptions_js__["a" /* default */].estateDutyGT/100;_this.props.state.policy.map(function(e,i){if(!e.dutyExcempt){_this.props.state.result.estateDuty.payableByOther+=parseFloat(e.death)*e.otherInherit/100;}});if(_this.props.state.result.estateDuty.netEstate*_this.props.state.result.estateDuty.estateDutyPayable!=0)_this.props.state.result.estateDuty.payableByOther=_this.props.state.result.estateDuty.payableByOther/_this.props.state.result.estateDuty.netEstate*_this.props.state.result.estateDuty.estateDutyPayable;else _this.props.state.result.estateDuty.payableByOther=0;_this.props.state.result.estateDuty.payableByEstate=_this.props.state.result.estateDuty.estateDutyPayable-_this.props.state.result.estateDuty.payableByOther;_this.props.state.result.residue.minusEstateDuty=_this.props.state.result.estateDuty.payableByEstate;_this.props.state.result.residue.residue=_this.props.state.result.residue.residueBeforeEstateDuty-_this.props.state.result.residue.minusEstateDuty;if(_this.props.state.result.residue.residue<0)_this.props.state.result.residue.residue=0.00;_this.calcLiquidity();},_this.calcLiquidity=function(){_this.props.state.result.liquidity.cashNeeded.netCgt=_this.props.state.result.cgt.cgtPayable;_this.props.state.result.liquidity.cashNeeded.netLiabilities=_this.props.state.result.balanceSheet.netLiabilitiesClient;_this.props.state.result.liquidity.cashNeeded.netExectutorsFee=_this.props.state.result.executorFees.executorFee;_this.props.state.result.liquidity.cashNeeded.netEstateDuty=_this.props.state.result.estateDuty.payableByEstate;_this.props.state.result.liquidity.cashNeeded.netOtherCosts=parseFloat(_this.props.state.result.estateDuty.deductions.netAdministration)+parseFloat(_this.props.state.result.estateDuty.deductions.netFuneral)+parseFloat(_this.props.state.result.estateDuty.deductions.netMastersFee)+parseFloat(_this.props.state.result.estateDuty.deductions.netTransferCosts);_this.props.state.needs.cashBequests.map(function(e,i){if((e.category=="cashBequest"||e.category=="cashBequestCharity")&&e.death){_this.props.state.result.liquidity.cashNeeded.netCashBequests+=parseFloat(e.mounthlyAmount);}});_this.props.state.result.liquidity.cashNeeded.netAccrualClaim=_this.props.state.result.accrual.clainBySpouse-_this.props.state.result.estateDuty.deductions.netResidueTospouse;//First need to calculate accrual.
//console.log(this.props.state.result.liquidity.cashNeeded)
if(_this.props.state.result.liquidity.cashNeeded.netAccrualClaim<0)_this.props.state.result.liquidity.cashNeeded.netAccrualClaim=0.00;_this.props.state.policy.map(function(e,i){if(e.LifeAssured!="client"&&e.party=="client"){_this.props.state.result.liquidity.cashNeeded.netBequethedLiquidAssets+=parseFloat(e.cashValue)*(1-parseFloat(e.estateInherit)/100);_this.props.state.result.liquidity.cashAvailable.netCashAssets+=parseFloat(e.cashValue);}});_this.props.state.assets.map(function(e,i){if(e.category!="primary_residential"&&e.category!="other_residential"&&e.category!="farms_owned"&&e.category!="usufruct_annuity_charged_on_property_or_similar_right"||e.liquid){if(e.liquid){_this.props.state.result.liquidity.cashAvailable.netCashAssets+=parseFloat(e.marketValue);_this.props.state.result.liquidity.cashNeeded.netBequethedLiquidAssets+=parseFloat(e.marketValue)*(1-e.estateInherit/100);}else if(e.category=="Investments")_this.props.state.result.liquidity.cashAvailable.netLiquidInvestments+=parseFloat(e.marketValue);}});_this.props.state.result.liquidity.cashAvailable.netPolicies+=_this.props.state.result.executorFees.pToEstate;_this.props.state.result.liquidity.cashNeeded.netCashNeeded=parseFloat(_this.props.state.result.liquidity.cashNeeded.netCgt)+parseFloat(_this.props.state.result.liquidity.cashNeeded.netLiabilities)+parseFloat(_this.props.state.result.liquidity.cashNeeded.netExectutorsFee)+parseFloat(_this.props.state.result.liquidity.cashNeeded.netEstateDuty)+parseFloat(_this.props.state.result.liquidity.cashNeeded.netOtherCosts)+parseFloat(_this.props.state.result.liquidity.cashNeeded.netBequethedLiquidAssets)+parseFloat(_this.props.state.result.liquidity.cashNeeded.netCashBequests)+parseFloat(_this.props.state.result.liquidity.cashNeeded.netAccrualClaim);_this.props.state.result.liquidity.cashAvailable.netCashAvailable=_this.props.state.result.liquidity.cashAvailable.netCashAssets+_this.props.state.result.liquidity.cashAvailable.netLiquidInvestments+_this.props.state.result.liquidity.cashAvailable.netPolicies;_this.props.state.result.liquidity.cash=_this.props.state.result.liquidity.cashAvailable.netCashAvailable-_this.props.state.result.liquidity.cashNeeded.netCashNeeded;//this.calcResidue();
_this.calcDeathProv();},_this.calcAccrual=function(){_this.props.state.result.accrual.current.valueOfAssets.client=parseFloat(_this.props.state.result.balanceSheet.netAssetsClient)+parseFloat(_this.props.state.result.balanceSheet.netPoliciesClient);_this.props.state.result.accrual.current.valueOfAssets.spouse=parseFloat(_this.props.state.result.balanceSheet.netAssetsSpouse)+parseFloat(_this.props.state.result.balanceSheet.netPoliciesSpouse);_this.props.state.result.accrual.current.valueOfPolicies=_this.props.state.result.executorFees.pToEstate;/*
    this.props.state.result.balanceSheet.policies.map((e, i) => 
    {
      if(e.amountClient)
        this.props.state.result.accrual.current.valueOfAssets.client += parseFloat(e.amountClient)
      if(e.amountSpouse)
        this.props.state.result.accrual.current.valueOfAssets.spouse += parseFloat(e.amountSpouse)
    })*/_this.props.state.result.accrual.current.minusLiabilities.client=_this.props.state.result.balanceSheet.netLiabilitiesClient;_this.props.state.result.accrual.current.minusLiabilities.spouse=_this.props.state.result.balanceSheet.netLiabilitiesSpouse;_this.props.state.result.accrual.current.netValue.client=parseFloat(_this.props.state.result.accrual.current.valueOfAssets.client)+parseFloat(_this.props.state.result.accrual.current.valueOfPolicies)-parseFloat(_this.props.state.result.accrual.current.minusLiabilities.client);_this.props.state.result.accrual.current.netValue.spouse=parseFloat(_this.props.state.result.accrual.current.valueOfAssets.spouse)-parseFloat(_this.props.state.result.accrual.current.minusLiabilities.spouse);_this.props.state.result.accrual.assetValueExcluded.client=_this.props.state.accrualExcludedClient;_this.props.state.result.accrual.assetValueExcluded.spouse=_this.props.state.accrualExcludedSpouse;_this.props.state.result.accrual.atMarriage.valueANC.client=_this.props.state.accrualExcludedMarrageClient;_this.props.state.result.accrual.atMarriage.valueANC.spouse=_this.props.state.accrualExcludedMarrageSpouse;_this.props.state.result.accrual.netAccrual.client=parseFloat(_this.props.state.result.accrual.current.netValue.client)-parseFloat(_this.props.state.result.accrual.assetValueExcluded.client);_this.props.state.result.accrual.netAccrual.spouse=parseFloat(_this.props.state.result.accrual.current.netValue.spouse)-parseFloat(_this.props.state.result.accrual.assetValueExcluded.spouse);if(_this.props.state.result.accrual.netAccrual.client<0)_this.props.state.result.accrual.netAccrual.client=0.00;if(_this.props.state.result.accrual.netAccrual.spouse<0)_this.props.state.result.accrual.netAccrual.spouse=0.00;if(_this.props.state.result.accrual.netAccrual.spouse-_this.props.state.result.accrual.netAccrual.client>0)_this.props.state.result.accrual.claimAgainstSpouse=(_this.props.state.result.accrual.netAccrual.spouse-_this.props.state.result.accrual.netAccrual.client)/2;if(_this.props.state.result.accrual.netAccrual.client-_this.props.state.result.accrual.netAccrual.spouse>0)_this.props.state.result.accrual.clainBySpouse=(_this.props.state.result.accrual.netAccrual.client-_this.props.state.result.accrual.netAccrual.spouse)/2;_this.calcEstateDuty();},_this.calcResidue=function(){_this.props.state.result.residue.totalAssets=_this.props.state.result.estateDuty.assets.netEstateAssets;//this.props.state.result.residue.policies = 0.00; // take policies excemt no!! and 100% - estate%    
_this.props.state.policy.map(function(e,i){if(!e.dutyExcempt&&e.LifeAssured=="client")_this.props.state.result.residue.policies+=parseFloat(e.death)*(1-e.estateInherit/100);});_this.props.state.assets.map(function(e,i){_this.props.state.result.residue.bequestsToOther+=e.marketValue*e.ownershipClient/100*e.otherInherit/100+e.marketValue*e.ownershipClient/100*e.charityInherit/100;_this.props.state.result.residue.bequestsToSpouse+=e.marketValue*e.ownershipClient/100*e.spouseInherit/100;});_this.props.state.needs.cashBequests.map(function(e,i){if((e.category=="cashBequest"||e.category=="cashBequestCharity")&&e.death){_this.props.state.result.residue.cashBequestsToOther+=e.mounthlyAmount*e.otherInherit/100+e.mounthlyAmount*e.charityInherit/100;_this.props.state.result.residue.cashBequestsToSpouse+=e.mounthlyAmount*e.spouseInherit/100;}});_this.props.state.result.residue.liabilities=_this.props.state.result.balanceSheet.netLiabilitiesClient;_this.props.state.result.residue.costs=parseFloat(_this.props.state.result.estateDuty.deductions.netAdministration)+parseFloat(_this.props.state.result.estateDuty.deductions.netFuneral)+parseFloat(_this.props.state.result.estateDuty.deductions.netMastersFee)+parseFloat(_this.props.state.result.estateDuty.deductions.netExectutorsFee)+parseFloat(_this.props.state.result.estateDuty.deductions.netCapitalGainTax)+parseFloat(_this.props.state.result.estateDuty.deductions.netTransferCosts);_this.props.state.result.residue.accrualClaimBySpouse=_this.props.state.result.accrual.clainBySpouse;_this.props.state.result.residue.minus=parseFloat(_this.props.state.result.residue.policies)+parseFloat(_this.props.state.result.residue.bequestsToOther)+parseFloat(_this.props.state.result.residue.cashBequestsToOther)+parseFloat(_this.props.state.result.residue.bequestsToSpouse)+parseFloat(_this.props.state.result.residue.cashBequestsToSpouse)+parseFloat(_this.props.state.result.residue.liabilities)+parseFloat(_this.props.state.result.residue.costs)+parseFloat(_this.props.state.result.residue.accrualClaimBySpouse);_this.props.state.result.residue.residueBeforeEstateDuty=_this.props.state.result.residue.totalAssets-_this.props.state.result.residue.minus;if(_this.props.state.result.residue.residueBeforeEstateDuty<0)_this.props.state.result.residue.residueBeforeEstateDuty=0.00;},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(OtherIncome,[{key:"componentDidMount",value:function componentDidMount(){this.props.scrollMeBar();var expand=this.props.state.deathDistribution;expand.expanded.fixedAssests=false;expand.expanded.liquidAssets=false;expand.expanded.policies=false;expand.expanded.bequests=false;expand.expanded.retirement=false;this.props.update();}},{key:"componentDidUpdate",value:function componentDidUpdate(){// Initializing dynamic fields. See initializeDynamicField decleration for structure.
var fieldsAssets=[{field:"assets",fieldName:"assets.estate",fieldVar:"estateInherit",value:"100"},{field:"assets",fieldName:"assets.spouse",fieldVar:"spouseInherit",value:"0"},{field:"assets",fieldName:"assets.dependents",fieldVar:"dependentsInherit",value:"0"},{field:"assets",fieldName:"assets.trust",fieldVar:"trustInherit",value:"0"},{field:"assets",fieldName:"assets.other",fieldVar:"otherInherit",value:"0"},{field:"assets",fieldName:"assets.charity",fieldVar:"charityInherit",value:"0"}];var fieldsPolicies=[{field:"policy",fieldName:"policy.estate",fieldVar:"estateInherit",value:"100"},{field:"policy",fieldName:"policy.spouse",fieldVar:"spouseInherit",value:"0"},{field:"policy",fieldName:"policy.dependents",fieldVar:"dependentsInherit",value:"0"},{field:"policy",fieldName:"policy.trust",fieldVar:"trustInherit",value:"0"},{field:"policy",fieldName:"policy.other",fieldVar:"otherInherit",value:"0"},{field:"policy",fieldName:"policy.charity",fieldVar:"charityInherit",value:"0"}];var fieldsCashBequests=[{field:"needs.cashBequests",fieldName:"needs.cashBequests.estate",fieldVar:"estateInherit",value:"0",conditions:[{condition:"category",param:"cashBequestCharity",falseValue:"100"}]},{field:"needs.cashBequests",fieldName:"needs.cashBequests.spouse",fieldVar:"spouseInherit",value:"0"},{field:"needs.cashBequests",fieldName:"needs.cashBequests.dependents",fieldVar:"dependentsInherit",value:"0"},{field:"needs.cashBequests",fieldName:"needs.cashBequests.trust",fieldVar:"trustInherit",value:"0"},{field:"needs.cashBequests",fieldName:"needs.cashBequests.other",fieldVar:"otherInherit",value:"0"},{field:"needs.cashBequests",fieldName:"needs.cashBequests.charity",fieldVar:"charityInherit",value:"100",conditions:[{condition:"category",param:"cashBequestCharity",falseValue:"0"}]}];var fieldsRetirement=[{field:"retirement",fieldName:"retirement.estate",fieldVar:"estateInherit",value:"100"},{field:"retirement",fieldName:"retirement.spouse",fieldVar:"spouseInherit",value:"0"},{field:"retirement",fieldName:"retirement.dependents",fieldVar:"dependentsInherit",value:"0"},{field:"retirement",fieldName:"retirement.trust",fieldVar:"trustInherit",value:"0"},{field:"retirement",fieldName:"retirement.other",fieldVar:"otherInherit",value:"0"},{field:"retirement",fieldName:"retirement.charity",fieldVar:"charityInherit",value:"0"}];this.props.initializeDynamicField("assetsDeathInit",fieldsAssets);this.props.initializeDynamicField("policiesDeathInit",fieldsPolicies);this.props.initializeDynamicField("cashDeathInit",fieldsCashBequests);this.props.initializeDynamicField("retirementDeathInit",fieldsRetirement);}},{key:"calcEstateInherit",value:function calcEstateInherit(cat,i){var cat1=cat.split('.');if(cat1.length>1)this.props.state[cat1[0]][cat1[1]][i].estateInherit=100-this.props.state[cat1[0]][cat1[1]][i].spouseInherit-this.props.state[cat1[0]][cat1[1]][i].dependentsInherit-this.props.state[cat1[0]][cat1[1]][i].trustInherit-this.props.state[cat1[0]][cat1[1]][i].charityInherit-this.props.state[cat1[0]][cat1[1]][i].otherInherit;else{this.props.state[cat][i].estateInherit=100-this.props.state[cat][i].spouseInherit-this.props.state[cat][i].dependentsInherit-this.props.state[cat][i].trustInherit-this.props.state[cat][i].charityInherit-this.props.state[cat][i].otherInherit;}}},{key:"calcDeathProv",value:function calcDeathProv(){var _this2=this;this.props.state.result.deathProvision.liquidity=this.props.state.result.liquidity.cash;this.props.state.result.deathProvision.surplusToOther=this.props.state.result.deathProvision.liquidity*(1-this.props.state.residueAmount/100);if(this.props.state.result.deathProvision.surplusToOther<0)this.props.state.result.deathProvision.surplusToOther=0;this.props.state.needs.capitalNeeds.map(function(e,i){_this2.props.state.result.deathProvision.capitalNeed+=parseFloat(e.mounthlyAmount);});this.props.state.result.deathProvision.netNeed=parseFloat(this.props.state.result.deathProvision.liquidity)-parseFloat(this.props.state.result.deathProvision.surplusToOther)-parseFloat(this.props.state.result.deathProvision.capitalNeed);this.props.state.policy.map(function(e,i){if(e.LifeAssured=="client"){_this2.props.state.result.deathProvision.provision.policies+=e.death*e.spouseInherit/100+e.death*e.dependentsInherit/100;}});this.props.state.needs.cashBequests.map(function(e,i){_this2.props.state.result.deathProvision.provision.cashToSpouse+=e.mounthlyAmount*e.spouseInherit/100+e.mounthlyAmount*e.dependentsInherit/100;});this.props.state.assets.map(function(e,i){if(e.liquid)_this2.props.state.result.deathProvision.provision.cashToSpouse+=e.marketValue*e.spouseInherit/100+e.marketValue*e.dependentsInherit/100;});this.props.state.result.deathProvision.provision.capitalLiquidity=this.props.state.result.deathProvision.provision.cashToSpouse+this.props.state.result.deathProvision.provision.policies+this.props.state.result.deathProvision.netNeed;this.props.state.needs.incomeNeeds.map(function(e,i){var need={};need.mounthlyAmount=parseFloat(e.mounthlyAmount);need.annualIncrease=parseFloat(e.annualIncrease);need.yearsPayable=parseFloat(e.yearsPayable);_this2.props.state.result.deathProvision.needAtDeath.push(need);});this.props.state.needs.incomeStreams.map(function(e,i){var stream={};stream.mounthlyAmount=parseFloat(e.mounthlyAmount);stream.annualIncrease=parseFloat(e.annualIncrease);stream.yearsPayable=parseFloat(e.yearsPayable);_this2.props.state.result.deathProvision.incomeProvision.push(stream);});//this.props.state.result.deathProvision.monthsProvisioned
var capitalProv={};var currentIncome=0.00;var currentNeed=0.00;capitalProv.capital=this.props.state.result.deathProvision.provision.capitalLiquidity;capitalProv.growthP=parseFloat(this.props.state.investmentGrowth);capitalProv.growth=capitalProv.capital*parseFloat(this.props.state.investmentGrowth)/100/12;capitalProv.drawdown=0.00;this.props.state.result.deathProvision.needAtDeath.map(function(e,i){capitalProv.drawdown+=e.mounthlyAmount;currentNeed+=e.mounthlyAmount;});this.props.state.result.deathProvision.incomeProvision.map(function(e,i){capitalProv.drawdown-=e.mounthlyAmount;currentIncome+=e.mounthlyAmount;});if(capitalProv.capital>0){this.props.state.result.deathProvision.capitalProvisioning.push(capitalProv);this.calcTimeProvisioned(currentIncome,currentNeed);}this.props.state.result.deathProvision.monthsProvisioned=this.props.state.result.deathProvision.capitalProvisioning.length;if(this.props.state.result.deathProvision.monthsProvisioned>720)this.props.state.result.deathProvision.monthsProvisioned="> 720";}},{key:"calcTimeProvisioned",value:function calcTimeProvisioned(currentIncome,currentNeed){var capitalProv={};capitalProv.capital=this.props.state.result.deathProvision.capitalProvisioning[this.props.state.result.deathProvision.capitalProvisioning.length-1].capital-this.props.state.result.deathProvision.capitalProvisioning[this.props.state.result.deathProvision.capitalProvisioning.length-1].drawdown;if(capitalProv.capital<0||this.props.state.result.deathProvision.capitalProvisioning.length>720)return;capitalProv.growthP=parseFloat(this.props.state.investmentGrowth);capitalProv.growth=capitalProv.capital*parseFloat(this.props.state.investmentGrowth)/100/12;////console.log(currentNeed + " - " + currentIncome + " = " +  capitalProv.drawdown)
if(this.props.state.result.deathProvision.capitalProvisioning.length%12==0){currentNeed=0.00;this.props.state.result.deathProvision.needAtDeath.map(function(e,i){e.yearsPayable-=1;if(e.yearsPayable<=0)e.mounthlyAmount=0;e.mounthlyAmount=parseFloat(e.mounthlyAmount)+parseFloat(e.mounthlyAmount)*parseFloat(e.annualIncrease)/100;currentNeed+=e.mounthlyAmount;});}if(this.props.state.result.deathProvision.capitalProvisioning.length%12==0){currentIncome=0;this.props.state.result.deathProvision.incomeProvision.map(function(e,i){e.yearsPayable-=1;if(e.yearsPayable<=0)e.mounthlyAmount=0;e.mounthlyAmount=parseFloat(e.mounthlyAmount)+parseFloat(e.mounthlyAmount)*parseFloat(e.annualIncrease)/100;currentIncome+=e.mounthlyAmount;});}capitalProv.drawdown=currentNeed-currentIncome;this.props.state.result.deathProvision.capitalProvisioning.push(capitalProv);this.calcTimeProvisioned(currentIncome,currentNeed);}},{key:"render",value:function render(){var _this3=this,_ref2;var checkValidation=this.props.checkValidation;this.calcBalanceSheet();var clientD="";if(this.props.state.client)clientD=this.props.state.client.first_name+" "+this.props.state.client.surname;console.log(this.props.state);return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("div",{className:"contentWithStepper",style:{width:"120%",marginLeft:"-10%",flex:1,height:"fit-content"}},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["e" /* Card */],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["f" /* CardContent */],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_CustomCardHeading_jsx__["a" /* default */],{subheading:"Financial Needs Analysis",caption:clientD,headline:"Asset Distribution at Death"}),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["q" /* ExpansionPanel */],{defaultExpanded:0===0,key:101},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Q" /* Table */],{className:"customTable1"},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["T" /* TableHead */],{className:"fixedHead"},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingTiny",style:colwidth("0em")},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center"}})),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall",style:colwidth("15em")},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center",verticalAlign:'bottom',fontWeight:"500"}},"Executor's Fee")),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingTiny",style:colwidth("15em")},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center",verticalAlign:'bottom',fontWeight:"500"}},"Estate Duty")),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall",style:colwidth("15em")},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center",fontWeight:"500"}},"CGT")),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall",style:colwidth("15em")},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center",fontWeight:"500"}},"Liquidity")),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall",style:colwidth("15em")},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center",fontWeight:"500"}},"Accrual")),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall",style:colwidth("15em")},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center",fontWeight:"500"}},"Residue")),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall",style:colwidth("15em")},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center",fontWeight:"500"}},"Provisioned for")))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["R" /* TableBody */],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingTiny",style:colwidth("6em")},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center"}})),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall",style:colwidth("10em")},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{textAlign:"center"}},"R ",grandSeperator(this.props.state.result.executorFees.executorFee))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingTiny",style:colwidth("10em")},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{textAlign:"center"}},"R ",grandSeperator(this.props.state.result.estateDuty.estateDutyPayable))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall",style:colwidth("10em")},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{textAlign:"center"}},"R ",grandSeperator(this.props.state.result.cgt.cgtPayable))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall",style:colwidth("10em")},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{textAlign:"center"}},"R ",grandSeperator(this.props.state.result.liquidity.cash))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall",style:colwidth("10em")},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{textAlign:"center"}},"R ",grandSeperator(this.props.state.result.accrual.claimAgainstSpouse-this.props.state.result.accrual.clainBySpouse))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall",style:colwidth("10em")},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{textAlign:"center"}},"R ",grandSeperator(this.props.state.result.residue.residue))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall",style:colwidth("10em")},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{textAlign:"center"}},Object(__WEBPACK_IMPORTED_MODULE_4_lodash__["toInteger"])(this.props.state.result.deathProvision.monthsProvisioned/12),"Y "," ",this.props.state.result.deathProvision.monthsProvisioned%12,"M")))))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["q" /* ExpansionPanel */],{defaultExpanded:0===0,key:101},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["r" /* ExpansionPanelDetails */],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{container:true,spacing:24},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Q" /* Table */],{className:"customTable1"},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["T" /* TableHead */],{className:"fixedHead"},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingTiny",style:colwidth("12em")},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center",fontWeight:"bold"}})),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingTiny",style:colwidth("6em")},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center",fontWeight:"500"}},"Value")),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall",style:colwidth("6em")},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',fontWeight:"500"}},"Estate/Residue")),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingTiny",style:colwidth("6em")},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center",verticalAlign:'bottom',fontWeight:"500"}},"Spouse")),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall",style:colwidth("6em")},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center",fontWeight:"500"}},"Dependents")),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall",style:colwidth("6em")},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center",fontWeight:"500"}},"Trust")),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall",style:colwidth("6em")},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center",fontWeight:"500"}},"Charity ")),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall",style:colwidth("6em")},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center",fontWeight:"500"}},"Other ")),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall",style:colwidth("6em")},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center"}}," ")))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["R" /* TableBody */],null))))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["q" /* ExpansionPanel */],{defaultExpanded:0===1,key:1,onClick:function onClick(event){return _this3.fixedAssestsExpand(event);}},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["s" /* ExpansionPanelSummary */],{expandIcon:__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["w" /* Icon */],null,"expand_more")},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Q" /* Table */],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingTiny",style:colwidth("12em")//colSpan={6}
},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{variant:"title",style:{fontWeight:'bold'}},"Assets")),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall",style:colwidth("6em")},this.props.state.deathDistribution.expanded.fixedAssests==false&&__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center",verticalAlign:'bottom',fontStyle:"oblique",fontWeight:"420"}},"R ",grandSeperator(this.getAssetTotalValue()))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall",style:colwidth("6em")},this.props.state.deathDistribution.expanded.fixedAssests==false&&__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center",verticalAlign:'bottom',fontStyle:"oblique",fontWeight:"420"}},"R ",grandSeperator(this.getInheretValue("assets","estateInherit")))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall",style:colwidth("6em")},this.props.state.deathDistribution.expanded.fixedAssests==false&&__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center",verticalAlign:'bottom',fontStyle:"oblique",fontWeight:"420"}},"R ",grandSeperator(this.getInheretValue("assets","spouseInherit")))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall",style:colwidth("6em")},this.props.state.deathDistribution.expanded.fixedAssests==false&&__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center",verticalAlign:'bottom',fontStyle:"oblique",fontWeight:"420"}},"R ",grandSeperator(this.getInheretValue("assets","dependentsInherit")))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall",style:colwidth("6em")},this.props.state.deathDistribution.expanded.fixedAssests==false&&__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center",verticalAlign:'bottom',fontStyle:"oblique",fontWeight:"420"}},"R ",grandSeperator(this.getInheretValue("assets","trustInherit")))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall",style:colwidth("6em")},this.props.state.deathDistribution.expanded.fixedAssests==false&&__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center",verticalAlign:'bottom',fontStyle:"oblique",fontWeight:"420"}},"R ",grandSeperator(this.getInheretValue("assets","otherInherit")))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall",style:colwidth("6em")},this.props.state.deathDistribution.expanded.fixedAssests==false&&__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center",verticalAlign:'bottom',fontStyle:"oblique",fontWeight:"420"}},"R ",grandSeperator(this.getInheretValue("assets","otherInherit")))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall",style:colwidth("6em")})))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["r" /* ExpansionPanelDetails */],{onClick:function onClick(event){event.stopPropagation();}},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{container:true,spacing:24},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Q" /* Table */],{className:"customTable1"},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["T" /* TableHead */],{className:"fixedHead"},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingTiny",style:colwidth("12em")},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center"}},"Asset")),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall",style:colwidth("6em")},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center",verticalAlign:'bottom',fontWeight:"420"}},"Value")),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingTiny",style:colwidth("6em")},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center",verticalAlign:'bottom',fontWeight:"420"}},"Estate/Residue")),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall",style:colwidth("6em")},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center",fontWeight:"420"}},"Spouse")),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall",style:colwidth("6em")},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center",fontWeight:"420"}},"Dependents")),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall",style:colwidth("6em")},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center",fontWeight:"420"}},"Trust")),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall",style:colwidth("6em")},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center",fontWeight:"420"}},"Charity")),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall",style:colwidth("6em")},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center",fontWeight:"420"}},"Other")),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall",style:colwidth("6em")},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center",fontWeight:"420"}},"Convert To Liquid? ")))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["R" /* TableBody */],null,this.props.state.assets.map(function(e,i){if(!e.liquid&&e.ownershipClient>0)return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],{key:i},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall"},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center",verticalAlign:'bottom'}},_this3.props.state.assets[i].description)),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall"},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center",verticalAlign:'bottom'}},"R ",grandSeperator(_this3.getAssetValue(i)))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall"},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center",verticalAlign:'bottom'}},100-_this3.props.state.assets[i].spouseInherit-_this3.props.state.assets[i].dependentsInherit-_this3.props.state.assets[i].trustInherit-_this3.props.state.assets[i].charityInherit-_this3.props.state.assets[i].otherInherit,"%")),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(CustomField,{name:'assets.spouse'+i,suffix:"%",component:__WEBPACK_IMPORTED_MODULE_9_components_Wrappers_materialUIWrappers_components_NumberInput__["a" /* default */],checkValidation:_this3.props.checkValidation,label:'%*',isrequired:true,validate:[__WEBPACK_IMPORTED_MODULE_11_helpers_ValidationHelpers__["g" /* required */],_this3.mustBeFullPercentage],onChange:function onChange(e,f,g,h){_this3.changeSpouse(f,h);}}),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(CustomField,{name:'assets.dependents'+i,suffix:"%",component:__WEBPACK_IMPORTED_MODULE_9_components_Wrappers_materialUIWrappers_components_NumberInput__["a" /* default */],checkValidation:_this3.props.checkValidation,label:'%*',isrequired:true,validate:[__WEBPACK_IMPORTED_MODULE_11_helpers_ValidationHelpers__["g" /* required */],_this3.mustBeFullPercentage],onChange:function onChange(e,f,g,h){_this3.changeDependents(f,h);}}),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(CustomField,{name:'assets.trust'+i,suffix:"%",component:__WEBPACK_IMPORTED_MODULE_9_components_Wrappers_materialUIWrappers_components_NumberInput__["a" /* default */],checkValidation:_this3.props.checkValidation,label:'%*',isrequired:true,validate:[__WEBPACK_IMPORTED_MODULE_11_helpers_ValidationHelpers__["g" /* required */],_this3.mustBeFullPercentage],onChange:function onChange(e,f,g,h){_this3.changeTrust(f,h);}}),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(CustomField,{name:'assets.charity'+i,suffix:"%",component:__WEBPACK_IMPORTED_MODULE_9_components_Wrappers_materialUIWrappers_components_NumberInput__["a" /* default */],checkValidation:_this3.props.checkValidation,label:'%*',isrequired:true,validate:[__WEBPACK_IMPORTED_MODULE_11_helpers_ValidationHelpers__["g" /* required */],_this3.mustBeFullPercentage],onChange:function onChange(e,f,g,h){_this3.changeCharity(f,h);}}),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(CustomField,{name:'assets.other'+i,suffix:"%",component:__WEBPACK_IMPORTED_MODULE_9_components_Wrappers_materialUIWrappers_components_NumberInput__["a" /* default */],checkValidation:_this3.props.checkValidation,label:'%*',isrequired:true,validate:[__WEBPACK_IMPORTED_MODULE_11_helpers_ValidationHelpers__["g" /* required */],_this3.mustBeFullPercentage],onChange:function onChange(e,f,g,h){_this3.changeOther(f,h);}}),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall"},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["t" /* FormControl */],{fullWidth:true},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["d" /* Button */],{name:"convert"+i,key:"convert"+i,variant:"contained",className:"fab",color:"primary",onClick:function onClick(e){_this3.convertAsset(e);////console.log(inspect(e.currentTarget))
//alert(e.currentTarget.name)
}},"Convert"))));}),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall",style:colwidth("12em")},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center",verticalAlign:'bottom'}})),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall",style:colwidth("6em")},this.props.state.deathDistribution.expanded.fixedAssests==true&&__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center",verticalAlign:'bottom',fontStyle:"oblique",fontWeight:"420"}},"R ",this.getAssetTotalValue())),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall",style:colwidth("6em")},this.props.state.deathDistribution.expanded.fixedAssests==true&&__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center",verticalAlign:'bottom',fontStyle:"oblique",fontWeight:"420"}},"R ",this.getInheretValue("assets","estateInherit"))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall",style:colwidth("6em")},this.props.state.deathDistribution.expanded.fixedAssests==true&&__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center",verticalAlign:'bottom',fontStyle:"oblique",fontWeight:"420"}},"R ",this.getInheretValue("assets","spouseInherit"))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall",style:colwidth("6em")},this.props.state.deathDistribution.expanded.fixedAssests==true&&__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:(_ref2={fontSize:'16px',textAlign:"center",verticalAlign:'bottom',fontStyle:"oblique",fontWeight:"420"},_defineProperty(_ref2,"fontStyle","oblique"),_defineProperty(_ref2,"fontWeight","420"),_ref2)},"R ",this.getInheretValue("assets","dependentsInherit"))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall",style:colwidth("6em")},this.props.state.deathDistribution.expanded.fixedAssests==true&&__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center",verticalAlign:'bottom',fontStyle:"oblique",fontWeight:"420"}},"R ",this.getInheretValue("assets","trustInherit"))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall",style:colwidth("6em")},this.props.state.deathDistribution.expanded.fixedAssests==true&&__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center",verticalAlign:'bottom',fontStyle:"oblique",fontWeight:"420"}},"R ",this.getInheretValue("assets","charityInherit"))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall",style:colwidth("6em")},this.props.state.deathDistribution.expanded.fixedAssests==true&&__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center",verticalAlign:'bottom',fontStyle:"oblique",fontWeight:"420"}},"R ",this.getInheretValue("assets","otherInherit"))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall",style:colwidth("6em")},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center",verticalAlign:'bottom'}})))))))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["q" /* ExpansionPanel */],{defaultExpanded:0===1,key:1,onClick:function onClick(event){return _this3.liquidAssestsExpand(event);}},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["s" /* ExpansionPanelSummary */],{expandIcon:__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["w" /* Icon */],null,"expand_more")},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Q" /* Table */],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingTiny",style:colwidth("12em")//colSpan={6}
},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{variant:"title",style:{fontWeight:'bold'}},"Liquid Assets")),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall",style:colwidth("6em")},this.props.state.deathDistribution.expanded.liquidAssets==false&&__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center",verticalAlign:'bottom',fontStyle:"oblique",fontWeight:"420"}},"R ",this.getAssetTotalValue("l"))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall",style:colwidth("6em")},this.props.state.deathDistribution.expanded.liquidAssets==false&&__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center",verticalAlign:'bottom',fontStyle:"oblique",fontWeight:"420"}},"R ",this.getInheretValue("assetsL","estateInherit"))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall",style:colwidth("6em")},this.props.state.deathDistribution.expanded.liquidAssets==false&&__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center",verticalAlign:'bottom',fontStyle:"oblique",fontWeight:"420"}},"R ",this.getInheretValue("assetsL","spouseInherit"))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall",style:colwidth("6em")},this.props.state.deathDistribution.expanded.liquidAssets==false&&__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center",verticalAlign:'bottom',fontStyle:"oblique",fontWeight:"420"}},"R ",this.getInheretValue("assetsL","dependentsInherit"))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall",style:colwidth("6em")},this.props.state.deathDistribution.expanded.liquidAssets==false&&__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center",verticalAlign:'bottom',fontStyle:"oblique",fontWeight:"420"}},"R ",this.getInheretValue("assetsL","trustInherit"))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall",style:colwidth("6em")},this.props.state.deathDistribution.expanded.liquidAssets==false&&__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center",verticalAlign:'bottom',fontStyle:"oblique",fontWeight:"420"}},"R ",this.getInheretValue("assetsL","charityInherit"))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall",style:colwidth("6em")},this.props.state.deathDistribution.expanded.liquidAssets==false&&__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center",verticalAlign:'bottom',fontStyle:"oblique",fontWeight:"420"}},"R ",this.getInheretValue("assetsL","otherInherit"))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall",style:colwidth("6em")})))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["r" /* ExpansionPanelDetails */],{onClick:function onClick(event){event.stopPropagation();}},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{container:true,spacing:24},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Q" /* Table */],{className:"customTable1"},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["T" /* TableHead */],{className:"fixedHead"},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingTiny",style:colwidth("12em")},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center",fontWeight:"420"}},"Asset")),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall",style:colwidth("6em")},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center",verticalAlign:'bottom',fontWeight:"420"}},"Value")),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingTiny",style:colwidth("6em")},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center",verticalAlign:'bottom',fontWeight:"420"}},"Estate/Residue")),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall",style:colwidth("6em")},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center",fontWeight:"420"}},"Spouse")),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall",style:colwidth("6em")},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center",fontWeight:"420"}},"Dependents")),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall",style:colwidth("6em")},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center",fontWeight:"420"}},"Trust")),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall",style:colwidth("6em")},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center",fontWeight:"420"}},"Charity")),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall",style:colwidth("6em")},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center",fontWeight:"420"}},"Other")),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall",style:colwidth("6em")},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center",fontWeight:"420"}},"Convert To Fixed? ")))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["R" /* TableBody */],null,this.props.state.assets.map(function(e,i){if(e.liquid&&e.ownershipClient>0)return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],{key:i},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall"},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center",verticalAlign:'bottom'}},_this3.props.state.assets[i].description)),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall"},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center",verticalAlign:'bottom'}},"R ",grandSeperator(_this3.getAssetValue(i)))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall"},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center",verticalAlign:'bottom'}},_this3.props.state.assets[i].estateInherit,"%")),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(CustomField,{name:'assets.spouse'+i,suffix:"%",component:__WEBPACK_IMPORTED_MODULE_9_components_Wrappers_materialUIWrappers_components_NumberInput__["a" /* default */],checkValidation:_this3.props.checkValidation,label:'%*',isrequired:true,validate:[__WEBPACK_IMPORTED_MODULE_11_helpers_ValidationHelpers__["g" /* required */],_this3.mustBeFullPercentage],onChange:function onChange(e,f,g,h){_this3.changeSpouse(f,h);}}),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(CustomField,{name:'assets.dependents'+i,suffix:"%",component:__WEBPACK_IMPORTED_MODULE_9_components_Wrappers_materialUIWrappers_components_NumberInput__["a" /* default */],checkValidation:_this3.props.checkValidation,label:'%*',isrequired:true,validate:[__WEBPACK_IMPORTED_MODULE_11_helpers_ValidationHelpers__["g" /* required */],_this3.mustBeFullPercentage],onChange:function onChange(e,f,g,h){_this3.changeDependents(f,h);}}),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(CustomField,{name:'assets.trust'+i,suffix:"%",component:__WEBPACK_IMPORTED_MODULE_9_components_Wrappers_materialUIWrappers_components_NumberInput__["a" /* default */],checkValidation:_this3.props.checkValidation,label:'%*',isrequired:true,validate:[__WEBPACK_IMPORTED_MODULE_11_helpers_ValidationHelpers__["g" /* required */],_this3.mustBeFullPercentage],onChange:function onChange(e,f,g,h){_this3.changeTrust(f,h);}}),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(CustomField,{name:'assets.charity'+i,suffix:"%",component:__WEBPACK_IMPORTED_MODULE_9_components_Wrappers_materialUIWrappers_components_NumberInput__["a" /* default */],checkValidation:_this3.props.checkValidation,label:'%*',isrequired:true,validate:[__WEBPACK_IMPORTED_MODULE_11_helpers_ValidationHelpers__["g" /* required */],_this3.mustBeFullPercentage],onChange:function onChange(e,f,g,h){_this3.changeCharity(f,h);}}),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(CustomField,{name:'assets.other'+i,suffix:"%",component:__WEBPACK_IMPORTED_MODULE_9_components_Wrappers_materialUIWrappers_components_NumberInput__["a" /* default */],checkValidation:_this3.props.checkValidation,label:'%*',isrequired:true,validate:[__WEBPACK_IMPORTED_MODULE_11_helpers_ValidationHelpers__["g" /* required */],_this3.mustBeFullPercentage],onChange:function onChange(e,f,g,h){_this3.changeOther(f,h);}}),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall"},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["t" /* FormControl */],{fullWidth:true},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["d" /* Button */],{name:"convert"+i,key:"convert"+i,variant:"contained",className:"fab",color:"primary",onClick:function onClick(e){_this3.convertAsset(e);////console.log(inspect(e.currentTarget))
//alert(e.currentTarget.name)
}},"Convert"))));}),this.props.state.policy.map(function(e,i){if(e.LifeAssured!="client"&&e.party=="client")return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],{key:i},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall"},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center",verticalAlign:'bottom'}},_this3.props.state.policy[i].description)),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall"},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center",verticalAlign:'bottom'}},"R ",grandSeperator(_this3.props.state.policy[i].cashValue))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall"},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center",verticalAlign:'bottom'}},_this3.props.state.policy[i].estateInherit,"%")),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(CustomField,{name:'policy.spouse'+i,suffix:"%",component:__WEBPACK_IMPORTED_MODULE_9_components_Wrappers_materialUIWrappers_components_NumberInput__["a" /* default */],checkValidation:_this3.props.checkValidation,label:'%*',isrequired:true,validate:[__WEBPACK_IMPORTED_MODULE_11_helpers_ValidationHelpers__["g" /* required */],_this3.mustBeFullPercentage],onChange:function onChange(e,f,g,h){_this3.changeSpouse(f,h);}}),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(CustomField,{name:'policy.dependents'+i,suffix:"%",component:__WEBPACK_IMPORTED_MODULE_9_components_Wrappers_materialUIWrappers_components_NumberInput__["a" /* default */],checkValidation:_this3.props.checkValidation,label:'%*',isrequired:true,validate:[__WEBPACK_IMPORTED_MODULE_11_helpers_ValidationHelpers__["g" /* required */],_this3.mustBeFullPercentage],onChange:function onChange(e,f,g,h){_this3.changeDependents(f,h);}}),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(CustomField,{name:'policy.trust'+i,suffix:"%",component:__WEBPACK_IMPORTED_MODULE_9_components_Wrappers_materialUIWrappers_components_NumberInput__["a" /* default */],checkValidation:_this3.props.checkValidation,label:'%*',isrequired:true,validate:[__WEBPACK_IMPORTED_MODULE_11_helpers_ValidationHelpers__["g" /* required */],_this3.mustBeFullPercentage],onChange:function onChange(e,f,g,h){_this3.changeTrust(f,h);}}),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(CustomField,{name:'policy.charity'+i,suffix:"%",component:__WEBPACK_IMPORTED_MODULE_9_components_Wrappers_materialUIWrappers_components_NumberInput__["a" /* default */],checkValidation:_this3.props.checkValidation,label:'%*',isrequired:true,validate:[__WEBPACK_IMPORTED_MODULE_11_helpers_ValidationHelpers__["g" /* required */],_this3.mustBeFullPercentage],onChange:function onChange(e,f,g,h){_this3.changeCharity(f,h);}}),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(CustomField,{name:'policy.other'+i,suffix:"%",component:__WEBPACK_IMPORTED_MODULE_9_components_Wrappers_materialUIWrappers_components_NumberInput__["a" /* default */],checkValidation:_this3.props.checkValidation,label:'%*',isrequired:true,validate:[__WEBPACK_IMPORTED_MODULE_11_helpers_ValidationHelpers__["g" /* required */],_this3.mustBeFullPercentage],onChange:function onChange(e,f,g,h){_this3.changeOther(f,h);}}),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall"}));}),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall",style:colwidth("12em")},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center",verticalAlign:'bottom'}})),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall",style:colwidth("6em")},this.props.state.deathDistribution.expanded.liquidAssets==true&&__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center",verticalAlign:'bottom',fontStyle:"oblique",fontWeight:"420"}},"R ",this.getAssetTotalValue("l"))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall",style:colwidth("6em")},this.props.state.deathDistribution.expanded.liquidAssets==true&&__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center",verticalAlign:'bottom',fontStyle:"oblique",fontWeight:"420"}},"R ",this.getInheretValue("assetsL","estateInherit"))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall",style:colwidth("6em")},this.props.state.deathDistribution.expanded.liquidAssets==true&&__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center",verticalAlign:'bottom',fontStyle:"oblique",fontWeight:"420"}},"R ",this.getInheretValue("assetsL","spouseInherit"))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall",style:colwidth("6em")},this.props.state.deathDistribution.expanded.liquidAssets==true&&__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center",verticalAlign:'bottom',fontStyle:"oblique",fontWeight:"420"}},"R ",this.getInheretValue("assetsL","dependentsInherit"))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall",style:colwidth("6em")},this.props.state.deathDistribution.expanded.liquidAssets==true&&__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center",verticalAlign:'bottom',fontStyle:"oblique",fontWeight:"420"}},"R ",this.getInheretValue("assetsL","trustInherit"))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall",style:colwidth("6em")},this.props.state.deathDistribution.expanded.liquidAssets==true&&__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center",verticalAlign:'bottom',fontStyle:"oblique",fontWeight:"420"}},"R ",this.getInheretValue("assetsL","charityInherit"))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall",style:colwidth("6em")},this.props.state.deathDistribution.expanded.liquidAssets==true&&__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center",verticalAlign:'bottom',fontStyle:"oblique",fontWeight:"420"}},"R ",this.getInheretValue("assetsL","otherInherit"))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall",style:colwidth("6em")},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center",verticalAlign:'bottom'}})))))))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["q" /* ExpansionPanel */],{defaultExpanded:0===1,key:1,onClick:function onClick(event){return _this3.policiesExpand(event);}},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["s" /* ExpansionPanelSummary */],{expandIcon:__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["w" /* Icon */],null,"expand_more")},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Q" /* Table */],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingTiny",style:colwidth("12em")//colSpan={6}
},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{variant:"title",style:{fontWeight:'bold'}},"Policies")),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall",style:colwidth("6em")},this.props.state.deathDistribution.expanded.policies==false&&__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center",verticalAlign:'bottom',fontStyle:"oblique",fontWeight:"420"}},"R ",this.getPolicyTotalValue())),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall",style:colwidth("6em")},this.props.state.deathDistribution.expanded.policies==false&&__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center",verticalAlign:'bottom',fontStyle:"oblique",fontWeight:"420"}},"R ",this.getInheretValue("policy","estateInherit"))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall",style:colwidth("6em")},this.props.state.deathDistribution.expanded.policies==false&&__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center",verticalAlign:'bottom',fontStyle:"oblique",fontWeight:"420"}},"R ",this.getInheretValue("policy","spouseInherit"))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall",style:colwidth("6em")},this.props.state.deathDistribution.expanded.policies==false&&__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center",verticalAlign:'bottom',fontStyle:"oblique",fontWeight:"420"}},"R ",this.getInheretValue("policy","dependentsInherit"))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall",style:colwidth("6em")},this.props.state.deathDistribution.expanded.policies==false&&__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center",verticalAlign:'bottom',fontStyle:"oblique",fontWeight:"420"}},"R ",this.getInheretValue("policy","trustInherit"))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall",style:colwidth("6em")},this.props.state.deathDistribution.expanded.policies==false&&__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center",verticalAlign:'bottom',fontStyle:"oblique",fontWeight:"420"}},"R ",this.getInheretValue("policy","charityInherit"))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall",style:colwidth("6em")},this.props.state.deathDistribution.expanded.policies==false&&__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center",verticalAlign:'bottom',fontStyle:"oblique",fontWeight:"420"}},"R ",this.getInheretValue("policy","otherInherit"))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall",style:colwidth("6em")})))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["r" /* ExpansionPanelDetails */],{onClick:function onClick(event){event.stopPropagation();}},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{container:true,spacing:24},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Q" /* Table */],{className:"customTable1"},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["T" /* TableHead */],{className:"fixedHead"},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingTiny",style:colwidth("12em")},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center",fontWeight:"420"}},"Policy")),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall",style:colwidth("6em")},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center",verticalAlign:'bottom',fontWeight:"420"}},"Value")),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingTiny",style:colwidth("6em")},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center",verticalAlign:'bottom',fontWeight:"420"}},"Estate/Residue")),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall",style:colwidth("6em")},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center",fontWeight:"420"}},"Spouse")),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall",style:colwidth("6em")},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center",fontWeight:"420"}},"Dependents")),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall",style:colwidth("6em")},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center",fontWeight:"420"}},"Trust")),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall",style:colwidth("6em")},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center",fontWeight:"420"}},"Charity")),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall",style:colwidth("6em")},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center",fontWeight:"420"}},"Other")),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall",style:colwidth("6em")},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center",fontWeight:"420"}},"Estate Duty Exempt ")))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["R" /* TableBody */],null,this.props.state.policy.map(function(e,i){if(e.LifeAssured=="client")return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],{key:i},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall"},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center",verticalAlign:'bottom'}},_this3.props.state.policy[i].description)),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall"},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center",verticalAlign:'bottom'}},"R ",grandSeperator(_this3.props.state.policy[i].death))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall"},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center",verticalAlign:'bottom'}},_this3.props.state.policy[i].estateInherit,"%")),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(CustomField,{name:'policy.spouse'+i,suffix:"%",component:__WEBPACK_IMPORTED_MODULE_9_components_Wrappers_materialUIWrappers_components_NumberInput__["a" /* default */],checkValidation:_this3.props.checkValidation,label:'%*',isrequired:true,validate:[__WEBPACK_IMPORTED_MODULE_11_helpers_ValidationHelpers__["g" /* required */],_this3.mustBeFullPercentage],onChange:function onChange(e,f,g,h){_this3.changeSpouse(f,h);}}),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(CustomField,{name:'policy.dependents'+i,suffix:"%",component:__WEBPACK_IMPORTED_MODULE_9_components_Wrappers_materialUIWrappers_components_NumberInput__["a" /* default */],checkValidation:_this3.props.checkValidation,label:'%*',isrequired:true,validate:[__WEBPACK_IMPORTED_MODULE_11_helpers_ValidationHelpers__["g" /* required */],_this3.mustBeFullPercentage],onChange:function onChange(e,f,g,h){_this3.changeDependents(f,h);}}),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(CustomField,{name:'policy.trust'+i,suffix:"%",component:__WEBPACK_IMPORTED_MODULE_9_components_Wrappers_materialUIWrappers_components_NumberInput__["a" /* default */],checkValidation:_this3.props.checkValidation,label:'%*',isrequired:true,validate:[__WEBPACK_IMPORTED_MODULE_11_helpers_ValidationHelpers__["g" /* required */],_this3.mustBeFullPercentage],onChange:function onChange(e,f,g,h){_this3.changeTrust(f,h);}}),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(CustomField,{name:'policy.charity'+i,suffix:"%",component:__WEBPACK_IMPORTED_MODULE_9_components_Wrappers_materialUIWrappers_components_NumberInput__["a" /* default */],checkValidation:_this3.props.checkValidation,label:'%*',isrequired:true,validate:[__WEBPACK_IMPORTED_MODULE_11_helpers_ValidationHelpers__["g" /* required */],_this3.mustBeFullPercentage],onChange:function onChange(e,f,g,h){_this3.changeCharity(f,h);}}),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(CustomField,{name:'policy.other'+i,suffix:"%",component:__WEBPACK_IMPORTED_MODULE_9_components_Wrappers_materialUIWrappers_components_NumberInput__["a" /* default */],checkValidation:_this3.props.checkValidation,label:'%*',isrequired:true,validate:[__WEBPACK_IMPORTED_MODULE_11_helpers_ValidationHelpers__["g" /* required */],_this3.mustBeFullPercentage],onChange:function onChange(e,f,g,h){_this3.changeOther(f,h);}}),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall"},_this3.checkItem("","dutyExcempt"+i,_this3.changeDutyExcempt)));}),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall",style:colwidth("12em")},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center",verticalAlign:'bottom'}})),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall",style:colwidth("6em")},this.props.state.deathDistribution.expanded.policies==true&&__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center",verticalAlign:'bottom',fontStyle:"oblique",fontWeight:"420"}},"R ",this.getPolicyTotalValue())),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall",style:colwidth("6em")},this.props.state.deathDistribution.expanded.policies==true&&__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center",verticalAlign:'bottom',fontStyle:"oblique",fontWeight:"420"}},"R ",this.getInheretValue("policy","estateInherit"))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall",style:colwidth("6em")},this.props.state.deathDistribution.expanded.policies==true&&__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center",verticalAlign:'bottom',fontStyle:"oblique",fontWeight:"420"}},"R ",this.getInheretValue("policy","spouseInherit"))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall",style:colwidth("6em")},this.props.state.deathDistribution.expanded.policies==true&&__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center",verticalAlign:'bottom',fontStyle:"oblique",fontWeight:"420"}},"R ",this.getInheretValue("policy","dependentsInherit"))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall",style:colwidth("6em")},this.props.state.deathDistribution.expanded.policies==true&&__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center",verticalAlign:'bottom',fontStyle:"oblique",fontWeight:"420"}},"R ",this.getInheretValue("policy","trustInherit"))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall",style:colwidth("6em")},this.props.state.deathDistribution.expanded.policies==true&&__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center",verticalAlign:'bottom',fontStyle:"oblique",fontWeight:"420"}},"R ",this.getInheretValue("policy","charityInherit"))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall",style:colwidth("6em")},this.props.state.deathDistribution.expanded.policies==true&&__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center",verticalAlign:'bottom',fontStyle:"oblique",fontWeight:"420"}},"R ",this.getInheretValue("policy","otherInherit"))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall",style:colwidth("6em")},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center",verticalAlign:'bottom'}})))))))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["q" /* ExpansionPanel */],{defaultExpanded:0===1,key:1,onClick:function onClick(event){return _this3.bequestsExpand(event);}},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["s" /* ExpansionPanelSummary */],{expandIcon:__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["w" /* Icon */],null,"expand_more")},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Q" /* Table */],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingTiny",style:colwidth("12em")//colSpan={6}
},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{variant:"title",style:{fontWeight:'bold'}},"Cash Bequests")),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall",style:colwidth("6em")},this.props.state.deathDistribution.expanded.bequests==false&&__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center",verticalAlign:'bottom',fontStyle:"oblique",fontWeight:"420"}},"R ",this.getBequestsTotalValue())),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall",style:colwidth("6em")},this.props.state.deathDistribution.expanded.bequests==false&&__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center",verticalAlign:'bottom',fontStyle:"oblique",fontWeight:"420"}},"R ",this.getInheretValue("needs.cashBequests","estateInherit"))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall",style:colwidth("6em")},this.props.state.deathDistribution.expanded.bequests==false&&__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center",verticalAlign:'bottom',fontStyle:"oblique",fontWeight:"420"}},"R ",this.getInheretValue("needs.cashBequests","spouseInherit"))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall",style:colwidth("6em")},this.props.state.deathDistribution.expanded.bequests==false&&__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center",verticalAlign:'bottom',fontStyle:"oblique",fontWeight:"420"}},"R ",this.getInheretValue("needs.cashBequests","dependentsInherit"))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall",style:colwidth("6em")},this.props.state.deathDistribution.expanded.bequests==false&&__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center",verticalAlign:'bottom',fontStyle:"oblique",fontWeight:"420"}},"R ",this.getInheretValue("needs.cashBequests","trustInherit"))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall",style:colwidth("6em")},this.props.state.deathDistribution.expanded.bequests==false&&__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center",verticalAlign:'bottom',fontStyle:"oblique",fontWeight:"420"}},"R ",this.getInheretValue("needs.cashBequests","charityInherit"))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall",style:colwidth("6em")},this.props.state.deathDistribution.expanded.bequests==false&&__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center",verticalAlign:'bottom',fontStyle:"oblique",fontWeight:"420"}},"R ",this.getInheretValue("needs.cashBequests","otherInherit"))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall",style:colwidth("6em")})))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["r" /* ExpansionPanelDetails */],{onClick:function onClick(event){event.stopPropagation();}},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{container:true,spacing:24},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Q" /* Table */],{className:"customTable1"},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["T" /* TableHead */],{className:"fixedHead"},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingTiny",style:colwidth("12em")},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center",fontWeight:"420"}},"Fund")),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall",style:colwidth("6em")},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center",verticalAlign:'bottom',fontWeight:"420"}},"Value")),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingTiny",style:colwidth("6em")},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center",verticalAlign:'bottom',fontWeight:"420"}},"Estate/Residue")),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall",style:colwidth("6em")},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center",fontWeight:"420"}},"Spouse")),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall",style:colwidth("6em")},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center",fontWeight:"420"}},"Dependents")),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall",style:colwidth("6em")},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center",fontWeight:"420"}},"Trust")),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall",style:colwidth("6em")},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center",fontWeight:"420"}},"Charity")),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall",style:colwidth("6em")},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center",fontWeight:"420"}},"Other")),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall",style:colwidth("6em")},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center",fontWeight:"420"}}," ")))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["R" /* TableBody */],null,this.props.state.needs.cashBequests.map(function(e,i){if(e.category=="cashBequest"||e.category=="cashBequestCharity")return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],{key:i},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall"},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center",verticalAlign:'bottom'}},_this3.props.state.needs.cashBequests[i].incomeStream)),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall"},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center",verticalAlign:'bottom'}},"R ",grandSeperator(_this3.props.state.needs.cashBequests[i].mounthlyAmount))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall"},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center",verticalAlign:'bottom'}},_this3.props.state.needs.cashBequests[i].estateInherit,"%")),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(CustomField,{name:'needs.cashBequests.spouse'+i,suffix:"%",component:__WEBPACK_IMPORTED_MODULE_9_components_Wrappers_materialUIWrappers_components_NumberInput__["a" /* default */],checkValidation:_this3.props.checkValidation,label:'%*',isrequired:true,validate:[__WEBPACK_IMPORTED_MODULE_11_helpers_ValidationHelpers__["g" /* required */],_this3.mustBeFullPercentage],onChange:function onChange(e,f,g,h){_this3.changeSpouse(f,h);}}),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(CustomField,{name:'needs.cashBequests.dependents'+i,suffix:"%",component:__WEBPACK_IMPORTED_MODULE_9_components_Wrappers_materialUIWrappers_components_NumberInput__["a" /* default */],checkValidation:_this3.props.checkValidation,label:'%*',isrequired:true,validate:[__WEBPACK_IMPORTED_MODULE_11_helpers_ValidationHelpers__["g" /* required */],_this3.mustBeFullPercentage],onChange:function onChange(e,f,g,h){_this3.changeDependents(f,h);}}),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(CustomField,{name:'needs.cashBequests.trust'+i,suffix:"%",component:__WEBPACK_IMPORTED_MODULE_9_components_Wrappers_materialUIWrappers_components_NumberInput__["a" /* default */],checkValidation:_this3.props.checkValidation,label:'%*',isrequired:true,validate:[__WEBPACK_IMPORTED_MODULE_11_helpers_ValidationHelpers__["g" /* required */],_this3.mustBeFullPercentage],onChange:function onChange(e,f,g,h){_this3.changeTrust(f,h);}}),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(CustomField,{name:'needs.cashBequests.charity'+i,suffix:"%",component:__WEBPACK_IMPORTED_MODULE_9_components_Wrappers_materialUIWrappers_components_NumberInput__["a" /* default */],checkValidation:_this3.props.checkValidation,label:'%*',isrequired:true,validate:[__WEBPACK_IMPORTED_MODULE_11_helpers_ValidationHelpers__["g" /* required */],_this3.mustBeFullPercentage],onChange:function onChange(e,f,g,h){_this3.changeCharity(f,h);}}),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(CustomField,{name:'needs.cashBequests.other'+i,suffix:"%",component:__WEBPACK_IMPORTED_MODULE_9_components_Wrappers_materialUIWrappers_components_NumberInput__["a" /* default */],checkValidation:_this3.props.checkValidation,label:'%*',isrequired:true,validate:[__WEBPACK_IMPORTED_MODULE_11_helpers_ValidationHelpers__["g" /* required */],_this3.mustBeFullPercentage],onChange:function onChange(e,f,g,h){_this3.changeOther(f,h);}}),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall"}));}),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall",style:colwidth("12em")},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center",verticalAlign:'bottom'}})),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall",style:colwidth("6em")},this.props.state.deathDistribution.expanded.bequests==true&&__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center",verticalAlign:'bottom',fontStyle:"oblique",fontWeight:"420"}},"R ",this.getBequestsTotalValue())),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall",style:colwidth("6em")},this.props.state.deathDistribution.expanded.bequests==true&&__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center",verticalAlign:'bottom',fontStyle:"oblique",fontWeight:"420"}},"R ",this.getInheretValue("needs.cashBequests","estateInherit"))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall",style:colwidth("6em")},this.props.state.deathDistribution.expanded.bequests==true&&__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center",verticalAlign:'bottom',fontStyle:"oblique",fontWeight:"420"}},"R ",this.getInheretValue("needs.cashBequests","spouseInherit"))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall",style:colwidth("6em")},this.props.state.deathDistribution.expanded.bequests==true&&__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center",verticalAlign:'bottom',fontStyle:"oblique",fontWeight:"420"}},"R ",this.getInheretValue("needs.cashBequests","dependentsInherit"))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall",style:colwidth("6em")},this.props.state.deathDistribution.expanded.bequests==true&&__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center",verticalAlign:'bottom',fontStyle:"oblique",fontWeight:"420"}},"R ",this.getInheretValue("needs.cashBequests","trustInherit"))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall",style:colwidth("6em")},this.props.state.deathDistribution.expanded.bequests==true&&__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center",verticalAlign:'bottom',fontStyle:"oblique",fontWeight:"420"}},"R ",this.getInheretValue("needs.cashBequests","charityInherit"))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall",style:colwidth("6em")},this.props.state.deathDistribution.expanded.bequests==true&&__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center",verticalAlign:'bottom',fontStyle:"oblique",fontWeight:"420"}},"R ",this.getInheretValue("needs.cashBequests","otherInherit"))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall",style:colwidth("6em")},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center",verticalAlign:'bottom'}})))))))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["q" /* ExpansionPanel */],{defaultExpanded:0===1,key:1,onClick:function onClick(event){return _this3.retirementExpand(event);}},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["s" /* ExpansionPanelSummary */],{expandIcon:__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["w" /* Icon */],null,"expand_more")},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Q" /* Table */],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingTiny",style:colwidth("12em")//colSpan={6}
},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{variant:"title",style:{fontWeight:'bold'}},"Retirement Funds")),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall",style:colwidth("6em")},this.props.state.deathDistribution.expanded.retirement==false&&__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center",verticalAlign:'bottom',fontStyle:"oblique",fontWeight:"420"}},"R ",this.getRetirementTotalValue())),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall",style:colwidth("6em")},this.props.state.deathDistribution.expanded.retirement==false&&__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center",verticalAlign:'bottom',fontStyle:"oblique",fontWeight:"420"}},"R ",this.getInheretValue("retirement","estateInherit"))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall",style:colwidth("6em")},this.props.state.deathDistribution.expanded.retirement==false&&__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center",verticalAlign:'bottom',fontStyle:"oblique",fontWeight:"420"}},"R ",this.getInheretValue("retirement","spouseInherit"))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall",style:colwidth("6em")},this.props.state.deathDistribution.expanded.retirement==false&&__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center",verticalAlign:'bottom',fontStyle:"oblique",fontWeight:"420"}},"R ",this.getInheretValue("retirement","dependentsInherit"))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall",style:colwidth("6em")},this.props.state.deathDistribution.expanded.retirement==false&&__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center",verticalAlign:'bottom',fontStyle:"oblique",fontWeight:"420"}},"R ",this.getInheretValue("retirement","trustInherit"))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall",style:colwidth("6em")},this.props.state.deathDistribution.expanded.retirement==false&&__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center",verticalAlign:'bottom',fontStyle:"oblique",fontWeight:"420"}},"R ",this.getInheretValue("retirement","charityInherit"))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall",style:colwidth("6em")},this.props.state.deathDistribution.expanded.retirement==false&&__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center",verticalAlign:'bottom',fontStyle:"oblique",fontWeight:"420"}},"R ",this.getInheretValue("retirement","otherInherit"))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall",style:colwidth("6em")})))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["r" /* ExpansionPanelDetails */],{onClick:function onClick(event){event.stopPropagation();}},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{container:true,spacing:24},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Q" /* Table */],{className:"customTable1"},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["T" /* TableHead */],{className:"fixedHead"},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingTiny",style:colwidth("12em")},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center",fontWeight:"420"}},"Fund")),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall",style:colwidth("6em")},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center",verticalAlign:'bottom',fontWeight:"420"}},"Value")),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingTiny",style:colwidth("6em")},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center",verticalAlign:'bottom',fontWeight:"420"}},"Estate/Residue")),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall",style:colwidth("6em")},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center",fontWeight:"420"}},"Spouse")),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall",style:colwidth("6em")},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center",fontWeight:"420"}},"Dependents")),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall",style:colwidth("6em")},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center",fontWeight:"420"}},"Trust")),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall",style:colwidth("6em")},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center",fontWeight:"420"}},"Charity")),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall",style:colwidth("6em")},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center",fontWeight:"420"}},"Other")),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall",style:colwidth("6em")},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center",fontWeight:"420"}}," ")))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["R" /* TableBody */],null,this.props.state.retirement.map(function(e,i){return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],{key:i},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall"},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center",verticalAlign:'bottom'}},_this3.props.state.retirement[i].description)),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall"},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center",verticalAlign:'bottom'}},"R ",grandSeperator(_this3.props.state.retirement[i].value))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall"},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center",verticalAlign:'bottom'}},_this3.props.state.retirement[i].estateInherit,"%")),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(CustomField,{name:'retirement.spouse'+i,suffix:"%",component:__WEBPACK_IMPORTED_MODULE_9_components_Wrappers_materialUIWrappers_components_NumberInput__["a" /* default */],checkValidation:_this3.props.checkValidation,label:'%*',isrequired:true,validate:[__WEBPACK_IMPORTED_MODULE_11_helpers_ValidationHelpers__["g" /* required */],_this3.mustBeFullPercentage],onChange:function onChange(e,f,g,h){_this3.changeSpouse(f,h);}}),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(CustomField,{name:'retirement.dependents'+i,suffix:"%",component:__WEBPACK_IMPORTED_MODULE_9_components_Wrappers_materialUIWrappers_components_NumberInput__["a" /* default */],checkValidation:_this3.props.checkValidation,label:'%*',isrequired:true,validate:[__WEBPACK_IMPORTED_MODULE_11_helpers_ValidationHelpers__["g" /* required */],_this3.mustBeFullPercentage],onChange:function onChange(e,f,g,h){_this3.changeDependents(f,h);}}),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(CustomField,{name:'retirement.trust'+i,suffix:"%",component:__WEBPACK_IMPORTED_MODULE_9_components_Wrappers_materialUIWrappers_components_NumberInput__["a" /* default */],checkValidation:_this3.props.checkValidation,label:'%*',isrequired:true,validate:[__WEBPACK_IMPORTED_MODULE_11_helpers_ValidationHelpers__["g" /* required */],_this3.mustBeFullPercentage],onChange:function onChange(e,f,g,h){_this3.changeTrust(f,h);}}),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(CustomField,{name:'retirement.charity'+i,suffix:"%",component:__WEBPACK_IMPORTED_MODULE_9_components_Wrappers_materialUIWrappers_components_NumberInput__["a" /* default */],checkValidation:_this3.props.checkValidation,label:'%*',isrequired:true,validate:[__WEBPACK_IMPORTED_MODULE_11_helpers_ValidationHelpers__["g" /* required */],_this3.mustBeFullPercentage],onChange:function onChange(e,f,g,h){_this3.changeCharity(f,h);}}),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(CustomField,{name:'retirement.other'+i,suffix:"%",component:__WEBPACK_IMPORTED_MODULE_9_components_Wrappers_materialUIWrappers_components_NumberInput__["a" /* default */],checkValidation:_this3.props.checkValidation,label:'%*',isrequired:true,validate:[__WEBPACK_IMPORTED_MODULE_11_helpers_ValidationHelpers__["g" /* required */],_this3.mustBeFullPercentage],onChange:function onChange(e,f,g,h){_this3.changeOther(f,h);}}),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall"}));}),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall",style:colwidth("12em")},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center",verticalAlign:'bottom'}})),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall",style:colwidth("6em")},this.props.state.deathDistribution.expanded.retirement==true&&__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center",verticalAlign:'bottom',fontStyle:"oblique",fontWeight:"420"}},"R ",this.getRetirementTotalValue())),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall",style:colwidth("6em")},this.props.state.deathDistribution.expanded.retirement==true&&__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center",verticalAlign:'bottom',fontStyle:"oblique",fontWeight:"420"}},"R ",this.getInheretValue("retirement","estateInherit"))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall",style:colwidth("6em")},this.props.state.deathDistribution.expanded.retirement==true&&__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center",verticalAlign:'bottom',fontStyle:"oblique",fontWeight:"420"}},"R ",this.getInheretValue("retirement","spouseInherit"))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall",style:colwidth("6em")},this.props.state.deathDistribution.expanded.retirement==true&&__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center",verticalAlign:'bottom',fontStyle:"oblique",fontWeight:"420"}},"R ",this.getInheretValue("retirement","dependentsInherit"))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall",style:colwidth("6em")},this.props.state.deathDistribution.expanded.retirement==true&&__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center",verticalAlign:'bottom',fontStyle:"oblique",fontWeight:"420"}},"R ",this.getInheretValue("retirement","trustInherit"))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall",style:colwidth("6em")},this.props.state.deathDistribution.expanded.retirement==true&&__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center",verticalAlign:'bottom',fontStyle:"oblique",fontWeight:"420"}},"R ",this.getInheretValue("retirement","charityInherit"))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall",style:colwidth("6em")},this.props.state.deathDistribution.expanded.retirement==true&&__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center",verticalAlign:'bottom',fontStyle:"oblique",fontWeight:"420"}},"R ",this.getInheretValue("retirement","otherInherit"))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall",style:colwidth("6em")},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center",verticalAlign:'bottom'}})))))))))));}}]);return OtherIncome;}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (OtherIncome);

/***/ }),
/* 2489 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var formatRegExp = /%[sdj%]/g;
exports.format = function(f) {
  if (!isString(f)) {
    var objects = [];
    for (var i = 0; i < arguments.length; i++) {
      objects.push(inspect(arguments[i]));
    }
    return objects.join(' ');
  }

  var i = 1;
  var args = arguments;
  var len = args.length;
  var str = String(f).replace(formatRegExp, function(x) {
    if (x === '%%') return '%';
    if (i >= len) return x;
    switch (x) {
      case '%s': return String(args[i++]);
      case '%d': return Number(args[i++]);
      case '%j':
        try {
          return JSON.stringify(args[i++]);
        } catch (_) {
          return '[Circular]';
        }
      default:
        return x;
    }
  });
  for (var x = args[i]; i < len; x = args[++i]) {
    if (isNull(x) || !isObject(x)) {
      str += ' ' + x;
    } else {
      str += ' ' + inspect(x);
    }
  }
  return str;
};


// Mark that a method should not be used.
// Returns a modified function which warns once by default.
// If --no-deprecation is set, then it is a no-op.
exports.deprecate = function(fn, msg) {
  // Allow for deprecating things in the process of starting up.
  if (isUndefined(global.process)) {
    return function() {
      return exports.deprecate(fn, msg).apply(this, arguments);
    };
  }

  if (process.noDeprecation === true) {
    return fn;
  }

  var warned = false;
  function deprecated() {
    if (!warned) {
      if (process.throwDeprecation) {
        throw new Error(msg);
      } else if (process.traceDeprecation) {
        console.trace(msg);
      } else {
        console.error(msg);
      }
      warned = true;
    }
    return fn.apply(this, arguments);
  }

  return deprecated;
};


var debugs = {};
var debugEnviron;
exports.debuglog = function(set) {
  if (isUndefined(debugEnviron))
    debugEnviron = Object({"NODE_ENV":"production","PUBLIC_URL":"","REACT_APP_API_URL":"127.0.0.1/mailApi","REACT_APP_SMTP_EMAIL":"admin@rhlm.co.za"}).NODE_DEBUG || '';
  set = set.toUpperCase();
  if (!debugs[set]) {
    if (new RegExp('\\b' + set + '\\b', 'i').test(debugEnviron)) {
      var pid = process.pid;
      debugs[set] = function() {
        var msg = exports.format.apply(exports, arguments);
        console.error('%s %d: %s', set, pid, msg);
      };
    } else {
      debugs[set] = function() {};
    }
  }
  return debugs[set];
};


/**
 * Echos the value of a value. Trys to print the value out
 * in the best way possible given the different types.
 *
 * @param {Object} obj The object to print out.
 * @param {Object} opts Optional options object that alters the output.
 */
/* legacy: obj, showHidden, depth, colors*/
function inspect(obj, opts) {
  // default options
  var ctx = {
    seen: [],
    stylize: stylizeNoColor
  };
  // legacy...
  if (arguments.length >= 3) ctx.depth = arguments[2];
  if (arguments.length >= 4) ctx.colors = arguments[3];
  if (isBoolean(opts)) {
    // legacy...
    ctx.showHidden = opts;
  } else if (opts) {
    // got an "options" object
    exports._extend(ctx, opts);
  }
  // set default options
  if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
  if (isUndefined(ctx.depth)) ctx.depth = 2;
  if (isUndefined(ctx.colors)) ctx.colors = false;
  if (isUndefined(ctx.customInspect)) ctx.customInspect = true;
  if (ctx.colors) ctx.stylize = stylizeWithColor;
  return formatValue(ctx, obj, ctx.depth);
}
exports.inspect = inspect;


// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
inspect.colors = {
  'bold' : [1, 22],
  'italic' : [3, 23],
  'underline' : [4, 24],
  'inverse' : [7, 27],
  'white' : [37, 39],
  'grey' : [90, 39],
  'black' : [30, 39],
  'blue' : [34, 39],
  'cyan' : [36, 39],
  'green' : [32, 39],
  'magenta' : [35, 39],
  'red' : [31, 39],
  'yellow' : [33, 39]
};

// Don't use 'blue' not visible on cmd.exe
inspect.styles = {
  'special': 'cyan',
  'number': 'yellow',
  'boolean': 'yellow',
  'undefined': 'grey',
  'null': 'bold',
  'string': 'green',
  'date': 'magenta',
  // "name": intentionally not styling
  'regexp': 'red'
};


function stylizeWithColor(str, styleType) {
  var style = inspect.styles[styleType];

  if (style) {
    return '\u001b[' + inspect.colors[style][0] + 'm' + str +
           '\u001b[' + inspect.colors[style][1] + 'm';
  } else {
    return str;
  }
}


function stylizeNoColor(str, styleType) {
  return str;
}


function arrayToHash(array) {
  var hash = {};

  array.forEach(function(val, idx) {
    hash[val] = true;
  });

  return hash;
}


function formatValue(ctx, value, recurseTimes) {
  // Provide a hook for user-specified inspect functions.
  // Check that value is an object with an inspect function on it
  if (ctx.customInspect &&
      value &&
      isFunction(value.inspect) &&
      // Filter out the util module, it's inspect function is special
      value.inspect !== exports.inspect &&
      // Also filter out any prototype objects using the circular check.
      !(value.constructor && value.constructor.prototype === value)) {
    var ret = value.inspect(recurseTimes, ctx);
    if (!isString(ret)) {
      ret = formatValue(ctx, ret, recurseTimes);
    }
    return ret;
  }

  // Primitive types cannot have properties
  var primitive = formatPrimitive(ctx, value);
  if (primitive) {
    return primitive;
  }

  // Look up the keys of the object.
  var keys = Object.keys(value);
  var visibleKeys = arrayToHash(keys);

  if (ctx.showHidden) {
    keys = Object.getOwnPropertyNames(value);
  }

  // IE doesn't make error fields non-enumerable
  // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
  if (isError(value)
      && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) {
    return formatError(value);
  }

  // Some type of object without properties can be shortcutted.
  if (keys.length === 0) {
    if (isFunction(value)) {
      var name = value.name ? ': ' + value.name : '';
      return ctx.stylize('[Function' + name + ']', 'special');
    }
    if (isRegExp(value)) {
      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
    }
    if (isDate(value)) {
      return ctx.stylize(Date.prototype.toString.call(value), 'date');
    }
    if (isError(value)) {
      return formatError(value);
    }
  }

  var base = '', array = false, braces = ['{', '}'];

  // Make Array say that they are Array
  if (isArray(value)) {
    array = true;
    braces = ['[', ']'];
  }

  // Make functions say that they are functions
  if (isFunction(value)) {
    var n = value.name ? ': ' + value.name : '';
    base = ' [Function' + n + ']';
  }

  // Make RegExps say that they are RegExps
  if (isRegExp(value)) {
    base = ' ' + RegExp.prototype.toString.call(value);
  }

  // Make dates with properties first say the date
  if (isDate(value)) {
    base = ' ' + Date.prototype.toUTCString.call(value);
  }

  // Make error with message first say the error
  if (isError(value)) {
    base = ' ' + formatError(value);
  }

  if (keys.length === 0 && (!array || value.length == 0)) {
    return braces[0] + base + braces[1];
  }

  if (recurseTimes < 0) {
    if (isRegExp(value)) {
      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
    } else {
      return ctx.stylize('[Object]', 'special');
    }
  }

  ctx.seen.push(value);

  var output;
  if (array) {
    output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
  } else {
    output = keys.map(function(key) {
      return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
    });
  }

  ctx.seen.pop();

  return reduceToSingleString(output, base, braces);
}


function formatPrimitive(ctx, value) {
  if (isUndefined(value))
    return ctx.stylize('undefined', 'undefined');
  if (isString(value)) {
    var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '')
                                             .replace(/'/g, "\\'")
                                             .replace(/\\"/g, '"') + '\'';
    return ctx.stylize(simple, 'string');
  }
  if (isNumber(value))
    return ctx.stylize('' + value, 'number');
  if (isBoolean(value))
    return ctx.stylize('' + value, 'boolean');
  // For some reason typeof null is "object", so special case here.
  if (isNull(value))
    return ctx.stylize('null', 'null');
}


function formatError(value) {
  return '[' + Error.prototype.toString.call(value) + ']';
}


function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
  var output = [];
  for (var i = 0, l = value.length; i < l; ++i) {
    if (hasOwnProperty(value, String(i))) {
      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
          String(i), true));
    } else {
      output.push('');
    }
  }
  keys.forEach(function(key) {
    if (!key.match(/^\d+$/)) {
      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
          key, true));
    }
  });
  return output;
}


function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
  var name, str, desc;
  desc = Object.getOwnPropertyDescriptor(value, key) || { value: value[key] };
  if (desc.get) {
    if (desc.set) {
      str = ctx.stylize('[Getter/Setter]', 'special');
    } else {
      str = ctx.stylize('[Getter]', 'special');
    }
  } else {
    if (desc.set) {
      str = ctx.stylize('[Setter]', 'special');
    }
  }
  if (!hasOwnProperty(visibleKeys, key)) {
    name = '[' + key + ']';
  }
  if (!str) {
    if (ctx.seen.indexOf(desc.value) < 0) {
      if (isNull(recurseTimes)) {
        str = formatValue(ctx, desc.value, null);
      } else {
        str = formatValue(ctx, desc.value, recurseTimes - 1);
      }
      if (str.indexOf('\n') > -1) {
        if (array) {
          str = str.split('\n').map(function(line) {
            return '  ' + line;
          }).join('\n').substr(2);
        } else {
          str = '\n' + str.split('\n').map(function(line) {
            return '   ' + line;
          }).join('\n');
        }
      }
    } else {
      str = ctx.stylize('[Circular]', 'special');
    }
  }
  if (isUndefined(name)) {
    if (array && key.match(/^\d+$/)) {
      return str;
    }
    name = JSON.stringify('' + key);
    if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
      name = name.substr(1, name.length - 2);
      name = ctx.stylize(name, 'name');
    } else {
      name = name.replace(/'/g, "\\'")
                 .replace(/\\"/g, '"')
                 .replace(/(^"|"$)/g, "'");
      name = ctx.stylize(name, 'string');
    }
  }

  return name + ': ' + str;
}


function reduceToSingleString(output, base, braces) {
  var numLinesEst = 0;
  var length = output.reduce(function(prev, cur) {
    numLinesEst++;
    if (cur.indexOf('\n') >= 0) numLinesEst++;
    return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
  }, 0);

  if (length > 60) {
    return braces[0] +
           (base === '' ? '' : base + '\n ') +
           ' ' +
           output.join(',\n  ') +
           ' ' +
           braces[1];
  }

  return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
}


// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.
function isArray(ar) {
  return Array.isArray(ar);
}
exports.isArray = isArray;

function isBoolean(arg) {
  return typeof arg === 'boolean';
}
exports.isBoolean = isBoolean;

function isNull(arg) {
  return arg === null;
}
exports.isNull = isNull;

function isNullOrUndefined(arg) {
  return arg == null;
}
exports.isNullOrUndefined = isNullOrUndefined;

function isNumber(arg) {
  return typeof arg === 'number';
}
exports.isNumber = isNumber;

function isString(arg) {
  return typeof arg === 'string';
}
exports.isString = isString;

function isSymbol(arg) {
  return typeof arg === 'symbol';
}
exports.isSymbol = isSymbol;

function isUndefined(arg) {
  return arg === void 0;
}
exports.isUndefined = isUndefined;

function isRegExp(re) {
  return isObject(re) && objectToString(re) === '[object RegExp]';
}
exports.isRegExp = isRegExp;

function isObject(arg) {
  return typeof arg === 'object' && arg !== null;
}
exports.isObject = isObject;

function isDate(d) {
  return isObject(d) && objectToString(d) === '[object Date]';
}
exports.isDate = isDate;

function isError(e) {
  return isObject(e) &&
      (objectToString(e) === '[object Error]' || e instanceof Error);
}
exports.isError = isError;

function isFunction(arg) {
  return typeof arg === 'function';
}
exports.isFunction = isFunction;

function isPrimitive(arg) {
  return arg === null ||
         typeof arg === 'boolean' ||
         typeof arg === 'number' ||
         typeof arg === 'string' ||
         typeof arg === 'symbol' ||  // ES6 symbol
         typeof arg === 'undefined';
}
exports.isPrimitive = isPrimitive;

exports.isBuffer = __webpack_require__(2490);

function objectToString(o) {
  return Object.prototype.toString.call(o);
}


function pad(n) {
  return n < 10 ? '0' + n.toString(10) : n.toString(10);
}


var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep',
              'Oct', 'Nov', 'Dec'];

// 26 Feb 16:19:34
function timestamp() {
  var d = new Date();
  var time = [pad(d.getHours()),
              pad(d.getMinutes()),
              pad(d.getSeconds())].join(':');
  return [d.getDate(), months[d.getMonth()], time].join(' ');
}


// log is just a thin wrapper to console.log that prepends a timestamp
exports.log = function() {
  console.log('%s - %s', timestamp(), exports.format.apply(exports, arguments));
};


/**
 * Inherit the prototype methods from one constructor into another.
 *
 * The Function.prototype.inherits from lang.js rewritten as a standalone
 * function (not on Function.prototype). NOTE: If this file is to be loaded
 * during bootstrapping this function needs to be rewritten using some native
 * functions as prototype setup using normal JavaScript does not work as
 * expected during bootstrapping (see mirror.js in r114903).
 *
 * @param {function} ctor Constructor function which needs to inherit the
 *     prototype.
 * @param {function} superCtor Constructor function to inherit prototype from.
 */
exports.inherits = __webpack_require__(118);

exports._extend = function(origin, add) {
  // Don't do anything if add isn't an object
  if (!add || !isObject(add)) return origin;

  var keys = Object.keys(add);
  var i = keys.length;
  while (i--) {
    origin[keys[i]] = add[keys[i]];
  }
  return origin;
};

function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(26), __webpack_require__(74)))

/***/ }),
/* 2490 */
/***/ (function(module, exports) {

module.exports = function isBuffer(arg) {
  return arg && typeof arg === 'object'
    && typeof arg.copy === 'function'
    && typeof arg.fill === 'function'
    && typeof arg.readUInt8 === 'function';
}

/***/ }),
/* 2491 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_core__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_DescriptiveRow_jsx__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_Wrappers_materialUIWrappers_components_FormCheckbox_jsx__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Wrappers_materialUIWrappers_components_FormDropDown__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Wrappers_materialUIWrappers_components_FormInput__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_helpers_ReduxHelpers__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_redux_form__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_store__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_CustomCardHeading_jsx__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__objects_Policies__ = __webpack_require__(2492);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_Wrappers_materialUIWrappers_components_NumberInput__ = __webpack_require__(31);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var colwidth=function colwidth(value){return{width:value,minWidth:value,maxWidth:value};};var CustomField=function CustomField(props){return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall"},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["t" /* FormControl */],{fullWidth:true},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_redux_form__["a" /* Field */],props)));};var CustomField2=function CustomField2(props){return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["t" /* FormControl */],{fullWidth:true,style:{bottom:"10px"}},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_redux_form__["a" /* Field */],props));};var required=function required(value){return value?undefined:"Required";};var requiredDropdown=function requiredDropdown(value){if(value==="validationError"){return"Required";}else if(value){return undefined;}else{return"Required";}};var emptySelect=function emptySelect(value){if(!value||value==="validationError"){return true;}return false;};var Policy=function Policy(value){return{description:"",estateInherit:0,spouseInherit:0,dependentInherit:0,trustInherit:0.00,otherInherit:0.00,death:0.00,disability:0.00,criticalIllness:0.00,dutyExcempt:false,party:"",LifeAssured:"",cashValue:0.00};};var Policies=function(_React$Component){_inherits(Policies,_React$Component);function Policies(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Policies);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Policies.__proto__||Object.getPrototypeOf(Policies)).call.apply(_ref,[this].concat(args))),_this),_this.state={policyValues:{}},_this.addNew=function(){var policie=_this.props.state.policy;var newPolicy=Policy();policie.push(newPolicy);//console.log("HELLO ", this.props.state.policy, " ", policie)
_this.props.changePolicy(policie);},_this.remove=function(n){var policie=_this.props.state.policy;var newPolicy=[];var node=n.target;while(node.nodeName!="BUTTON"&&node.parentNode!=null){node=node.parentNode;}var i=node.name.replace("remove","");console.log(i);//assets.splice(i, 1)
//assets[i] = null;
policie.map(function(e,k){console.log(policie[i]==e);if(e!=policie[i])newPolicy[k]=e;});policie=newPolicy;_this.props.changePolicy(newPolicy);},_this.checkItem=function(label,name,changeFunc){return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["t" /* FormControl */],{style:{marginBottom:"-30px",paddingBottom:"-30px",left:"30px"}},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_2_components_Wrappers_materialUIWrappers_components_FormCheckbox_jsx__["a" /* default */],name:name,onChange:function onChange(e,f,g,h){changeFunc(f,h);}}));},_this.changeDescription=function(value,name){var policies=_this.props.state.policy;var policy=name.replace("description","");policies[policy].description=value;//this.props.changePolicy(policy);
},_this.changeEstate=function(value,name){//console.log(value + "---" + name)
var policies=_this.props.state.policy;var policy=name.replace("estate","");policies[policy].estate=value;//this.props.changePolicy(policy);
},_this.changeSpouse=function(value,name){var policies=_this.props.state.policy;var policy=name.replace("spouse","");policies[policy].spouse=value;//this.props.changePolicy(policy);
},_this.changeDependent=function(value,name){var policies=_this.props.state.policy;var policy=name.replace("dependent","");policies[policy].dependent=value;//this.props.changePolicy(policy);
},_this.changeTrust=function(value,name){var policies=_this.props.state.policy;var policy=name.replace("trust","");policies[policy].trust=value;//this.props.changePolicy(policy);
},_this.changeOther=function(value,name){var policies=_this.props.state.policy;var policy=name.replace("other","");policies[policy].other=value;//this.props.changePolicy(policy);
},_this.changeDeath=function(value,name){var policies=_this.props.state.policy;var policy=name.replace("death","");policies[policy].death=value;//this.props.changePolicy(policy);
},_this.changeDisability=function(value,name){var policies=_this.props.state.policy;var policy=name.replace("disability","");policies[policy].disability=value;//this.props.changePolicy(policy);
},_this.changeCriticalIllness=function(value,name){var policies=_this.props.state.policy;var policy=name.replace("criticalIllness","");policies[policy].criticalIllness=value;//this.props.changePolicy(policy);
},_this.changeDutyExcempt=function(value,name){var policies=_this.props.state.policy;var policy=name.replace("dutyExcempt","");policies[policy].dutyExcempt=value;//this.props.changePolicy(policy);
},_this.changeParty=function(value,name){var policies=_this.props.state.policy;var polisie=name.replace("owner","");policies[polisie].party=value;},_this.changeAssured=function(value,name){var policies=_this.props.state.policy;var polisie=name.replace("assured","");policies[polisie].LifeAssured=value;},_this.changeCashValue=function(value,name){var policies=_this.props.state.policy;var polisie=name.replace("cashValue","");policies[polisie].cashValue=value;},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Policies,[{key:"componentDidMount",value:function componentDidMount(){this.props.scrollMeBar();}},{key:"componentDidUpdate",value:function componentDidUpdate(){var fieldsPolicies=[{field:"policy",fieldName:"death",fieldVar:"death",value:"0"},{field:"policy",fieldName:"disability",fieldVar:"disability",value:"0"},{field:"policy",fieldName:"criticalIllness",fieldVar:"criticalIllness",value:"0"},{field:"policy",fieldName:"cashValue",fieldVar:"cashValue",value:"0"}];this.props.initializeDynamicField("policiesInit",fieldsPolicies);}},{key:"render",value:function render(){var _this2=this;var checkValidation=this.props.checkValidation;var clientD="";if(this.props.state.client)clientD=this.props.state.client.first_name+" "+this.props.state.client.surname;return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("div",{className:"contentWithStepper",style:{width:"120%",marginLeft:"-10%",flex:1,height:"fit-content"}},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["e" /* Card */],null,__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["f" /* CardContent */],null,__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_CustomCardHeading_jsx__["a" /* default */],{subheading:"Financial Needs Analysis",caption:clientD,headline:"Policies"}),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{container:true,spacing:24,className:"customTableAutoGrid"},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Q" /* Table */],{className:"customTable1"},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["T" /* TableHead */],{className:"fixedHead"},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingTiny",style:colwidth("20em")},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center"}},"Description")),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingTiny",style:colwidth("20em")},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center"}},"Owner")),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingTiny",style:colwidth("20em")},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center"}},"Life Assured")),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingTiny",style:colwidth("12em")},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center"}},"Death")),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall",style:colwidth("12em")},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center"}},"Disability")),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall",style:colwidth("12em")},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center"}},"Critical Illness")),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingTiny",style:colwidth("20em")},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center"}},"Cash Value")))),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["R" /* TableBody */],null,this.props.state.policy.map(function(e,i){return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],{key:i},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["d" /* Button */],{name:"remove"+i,key:"remove"+i,variant:"fab",mini:true,className:"tinyfab",color:"primary",style:{left:"-20px",top:"-5px"},onClick:function onClick(e){e.stopPropagation();_this2.remove(e);}},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["w" /* Icon */],{style:{color:"white"}},"remove")),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(CustomField2,{name:'description'+i,component:__WEBPACK_IMPORTED_MODULE_4_components_Wrappers_materialUIWrappers_components_FormInput__["a" /* default */],checkValidation:_this2.props.checkValidation,label:'Description',isrequired:true,validate:[required],onChange:function onChange(e,value,t,name){return _this2.changeDescription(value,name);}})),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(CustomField,{name:"owner"+i,component:__WEBPACK_IMPORTED_MODULE_3_components_Wrappers_materialUIWrappers_components_FormDropDown__["a" /* default */],checkValidation:_this2.props.checkValidation,label:'',isrequired:true//validate={[required]}
,options:[{displayValue:"Please select",value:" "},{displayValue:"Client",value:"client"},{displayValue:"Spouse",value:"spouse"},{displayValue:"other",value:"other"}],onChange:function onChange(e,value,t,name){return _this2.changeParty(value,name);}}),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(CustomField,{name:"assured"+i,component:__WEBPACK_IMPORTED_MODULE_3_components_Wrappers_materialUIWrappers_components_FormDropDown__["a" /* default */],checkValidation:_this2.props.checkValidation,label:'',isrequired:true//validate={[required]}
,options:[{displayValue:"Please select",value:" "},{displayValue:"Client",value:"client"},{displayValue:"Spouse",value:"spouse"},{displayValue:"other",value:"other"}],onChange:function onChange(e,value,t,name){return _this2.changeAssured(value,name);}}),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(CustomField,{name:'death'+i,prefix:"R",component:__WEBPACK_IMPORTED_MODULE_12_components_Wrappers_materialUIWrappers_components_NumberInput__["a" /* default */],checkValidation:_this2.props.checkValidation,label:'R*',isrequired:true,validate:[required],onChange:function onChange(e,value,t,name){return _this2.changeDeath(value,name);}}),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(CustomField,{name:'disability'+i,prefix:"R",component:__WEBPACK_IMPORTED_MODULE_12_components_Wrappers_materialUIWrappers_components_NumberInput__["a" /* default */],checkValidation:_this2.props.checkValidation,label:'R*',isrequired:true,validate:[required],onChange:function onChange(e,value,t,name){return _this2.changeDisability(value,name);}}),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(CustomField,{name:'criticalIllness'+i,prefix:"R",component:__WEBPACK_IMPORTED_MODULE_12_components_Wrappers_materialUIWrappers_components_NumberInput__["a" /* default */],checkValidation:_this2.props.checkValidation,label:'R*',isrequired:true,validate:[required],onChange:function onChange(e,value,t,name){return _this2.changeCriticalIllness(value,name);}}),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(CustomField,{name:'cashValue'+i,prefix:"R",component:__WEBPACK_IMPORTED_MODULE_12_components_Wrappers_materialUIWrappers_components_NumberInput__["a" /* default */],checkValidation:_this2.props.checkValidation,label:'R*',isrequired:true,validate:[required],onChange:function onChange(e,value,t,name){return _this2.changeCashValue(value,name);}}));}),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Q" /* Table */],{style:{width:"10em"}},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__components_DescriptiveRow_jsx__["a" /* default */],{description:"Add Policy",add:function add(){return _this2.addNew();},extraCells:0})))))))));}}]);return Policies;}(__WEBPACK_IMPORTED_MODULE_7_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Policies);

/***/ }),
/* 2492 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Insurers */
/* unused harmony export LifeAssured */
/* unused harmony export Owner */
/* unused harmony export Benificiary */
/* unused harmony export Combos */
var Insurers=[{value:"validationError",displayValue:"Select"},{value:"Liberty",displayValue:"Liberty"},{value:"Momentum",displayValue:"Momentum"},{value:"Sanlam",displayValue:"Sanlam"},{value:"Old Mutual",displayValue:"Old Mutual"},{value:"Discovery",displayValue:"Discovery"},{value:"Hollard",displayValue:"Hollard"},{value:"PPS",displayValue:"PPS"},{value:"FMI",displayValue:"Bidvest"},{value:"Bright Rock",displayValue:"Bright Rock"},{value:"Other",displayValue:"Other"}];var LifeAssured=[{value:"client",displayValue:"Client"},{value:"spouse",displayValue:"Spouse"},{value:"business_partner",displayValue:"Business Partner"},{value:"other",displayValue:"Other"}];var Owner=[{value:"client",displayValue:"Client"},{value:"spouse",displayValue:"Spouse"},{value:"business_partner",displayValue:"Business Partner"},{value:"business_entity",displayValue:"Business Entity"},{value:"family_company",displayValue:"Family Company"},{value:"other",displayValue:"Other"}];var Benificiary=[{value:"none",displayValue:"None"},{value:"client_estate",displayValue:"Client's Estate"},{value:"spouse",displayValue:"Spouse"},{value:"business_partner",displayValue:"Business Partner"},{value:"business_entity",displayValue:"Business Entity"},{value:"family_company",displayValue:"Family Company"},{value:"trust",displayValue:"Trust"},{value:"other",displayValue:"Other"}];var Combos={// TYPE:LIFE_ASSURED:OWNER:BENIFICIARY => {}
//1
"client:none":{payTo:"Estate"},"client:client_estate":{payTo:"Estate"},"client:spouse":{payTo:"Spouse"},//2
"spouse:none":{payTo:"Spouse"},"spouse:client_estate":{payTo:"Estate"},"spouse:spouse":{payTo:"Spouse"},//3
"therest:client_estate":{payTo:"Estate"},"therest:spouse":{payTo:"Spouse"///
}};

/***/ }),
/* 2493 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_core__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_Wrappers_materialUIWrappers_components_FormCheckbox_jsx__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_Wrappers_materialUIWrappers_components_FormInput__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Wrappers_materialUIWrappers_components_NumberInput__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_helpers_ReduxHelpers__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_redux_form__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_store__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_CustomCardHeading_jsx__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_DescriptiveRow_jsx__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__objects_assetItems__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_Wrappers_materialUIWrappers_components_FormDropDown__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_Grid_GridItem_jsx__ = __webpack_require__(12);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var colwidth=function colwidth(value){return{width:value,minWidth:value,maxWidth:value,margin:"0px"};};var CustomField=function CustomField(props){return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall"},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["t" /* FormControl */],{fullWidth:true},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_redux_form__["a" /* Field */],props)));};var CustomField2=function CustomField2(props){return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["t" /* FormControl */],{fullWidth:true,style:{bottom:"10px"}},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_redux_form__["a" /* Field */],props));};var required=function required(value){console.log("req check",value);return value?undefined:"Required";};function isInteger(value){return /^\d+$/.test(value);}var percentage=function percentage(value){if(value===undefined)return undefined;if(isNaN(value)){return"Must be a number";}if(parseInt(value,10)>=101||parseInt(value,10)<0){return"Not a valid Percentage";}return undefined;};var hundred=function hundred(value){if(value===undefined)return undefined;if(isNaN(value)){return"Must be a number";}if(parseInt(value,10)!==100){return"Must add up to 100";}return undefined;};var retirement=function retirement(value){return{type:"",description:"",value:"",contributions:"",growth:"",return:""};};var Retirenment=function(_React$Component){_inherits(Retirenment,_React$Component);function Retirenment(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Retirenment);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Retirenment.__proto__||Object.getPrototypeOf(Retirenment)).call.apply(_ref,[this].concat(args))),_this),_this.addNew=function(){var retirements=_this.props.state.retirement;retirements.push(retirement());_this.props.changeRetirement(retirements);},_this.remove=function(n){var assets=_this.props.state.retirement;var newAss=[];var node=n.target;while(node.nodeName!="BUTTON"&&node.parentNode!=null){node=node.parentNode;}var i=node.name.replace("remove","");console.log(i);//assets.splice(i, 1)
//assets[i] = null;
assets.map(function(e,k){if(e!=assets[i]){newAss[k]=e;}});console.log(newAss);assets=newAss;_this.props.changeRetirement(assets);},_this.changeType=function(value,name){var retirements=_this.props.state.retirement;var retirement=name.replace("type","");retirements[retirement].type=value;_this.props.changeRetirement(retirements);},_this.changeDescription=function(value,name){var retirements=_this.props.state.retirement;var retirement=name.replace("retirement.description","");retirements[retirement].description=value;_this.props.changeRetirement(retirements);},_this.changeValue=function(value,name){var retirements=_this.props.state.retirement;var retirement=name.replace("retirement.value","");retirements[retirement].value=value;_this.props.changeRetirement(retirements);},_this.changeContributions=function(value,name){var retirements=_this.props.state.retirement;var retirement=name.replace("retirement.contributions","");retirements[retirement].contributions=value;_this.props.changeRetirement(retirements);},_this.changeGrowth=function(value,name){var retirements=_this.props.state.retirement;var retirement=name.replace("retirement.growth","");retirements[retirement].growth=value;_this.props.changeRetirement(retirements);},_this.changeReturn=function(value,name){var retirements=_this.props.state.retirement;var retirement=name.replace("retirement.return","");retirements[retirement].return=value;_this.props.changeRetirement(retirements);},_this.checkItem=function(label,name,changeFunc){return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["t" /* FormControl */],{style:{marginBottom:"-30px",paddingBottom:"-30px"}},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_1_components_Wrappers_materialUIWrappers_components_FormCheckbox_jsx__["a" /* default */],name:name,onChange:function onChange(e,f,g,h){changeFunc(f,h);}}));},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Retirenment,[{key:"componentDidMount",value:function componentDidMount(){this.props.scrollMeBar();}},{key:"render",value:function render(){var _this2=this;var checkValidation=this.props.checkValidation;var clientD="";if(this.props.state.client)clientD=this.props.state.client.first_name+" "+this.props.state.client.surname;return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement("div",{className:"contentWithStepper",style:{width:"120%",marginLeft:"-10%"}},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["e" /* Card */],null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["f" /* CardContent */],null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_CustomCardHeading_jsx__["a" /* default */],{subheading:"Financial Needs Analysis",caption:clientD,headline:"Retirement Fund Provisions"}),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement("h4",{style:{fontWeight:500}},"Retirement Funds"),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{container:true,spacing:24,className:"customTableAutoGrid"},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Q" /* Table */],{className:"customTable1"},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["T" /* TableHead */],{className:"fixedHead"},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingTiny",style:colwidth("20em")},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center"}},"Type")),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall",style:colwidth("15em")},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px'}},"Description")),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingTiny",style:colwidth("16em")},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center",verticalAlign:'bottom'}},"Value")),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall",style:colwidth("16em")},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center"}},"Contributions")),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall",style:colwidth("16em")},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center"}},"Annual Premium Growth")),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall",style:colwidth("16em")},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center"}},"Annual Return")))),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["R" /* TableBody */],null,this.props.state.retirement.map(function(e,i){return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],{key:i},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["d" /* Button */],{name:"remove"+i,key:"remove"+i,variant:"fab",mini:true,className:"tinyfab",color:"primary",style:{left:"-20px",top:"-5px"},onClick:function onClick(e){e.stopPropagation();_this2.remove(e);}},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["w" /* Icon */],{style:{color:"white"}},"remove")),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(CustomField2,{name:"type"+i,component:__WEBPACK_IMPORTED_MODULE_12_components_Wrappers_materialUIWrappers_components_FormDropDown__["a" /* default */],checkValidation:_this2.props.checkValidation,label:'',isrequired:true//validate={[required]}
,options:[{displayValue:"Please Select",value:" "},{displayValue:"Pension Fund",value:"pension"},{displayValue:"RA",value:"RA"},{displayValue:"Provident Fund",value:"provedentFund"},,{displayValue:"Pension Preserver",value:"pensionPreserver"},,{displayValue:"Provident Preserver",value:"provedentPreserver"}],onChange:function onChange(e,value,t,name){return _this2.changeType(value,name);}})),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(CustomField,{name:'retirement.description'+i,component:__WEBPACK_IMPORTED_MODULE_2_components_Wrappers_materialUIWrappers_components_FormInput__["a" /* default */],checkValidation:_this2.props.checkValidation,label:'description',isrequired:true,validate:[required],onChange:function onChange(e,value,t,name){return _this2.changeDescription(value,name);}}),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(CustomField,{name:'retirement.value'+i,prefix:"R",component:__WEBPACK_IMPORTED_MODULE_3_components_Wrappers_materialUIWrappers_components_NumberInput__["a" /* default */],checkValidation:_this2.props.checkValidation,label:'R*',isrequired:true,validate:[required],onChange:function onChange(e,value,t,name){return _this2.changeValue(value,name);}}),String(_this2.props.state.retirement[i].type).includes("Preserver")&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],null),!String(_this2.props.state.retirement[i].type).includes("Preserver")&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(CustomField,{name:'retirement.contributions'+i,prefix:"R",component:__WEBPACK_IMPORTED_MODULE_3_components_Wrappers_materialUIWrappers_components_NumberInput__["a" /* default */],checkValidation:_this2.props.checkValidation,label:'R*',isrequired:true,validate:[required],onChange:function onChange(e,value,t,name){return _this2.changeContributions(value,name);}}),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(CustomField,{name:'retirement.growth'+i,suffix:"%",component:__WEBPACK_IMPORTED_MODULE_3_components_Wrappers_materialUIWrappers_components_NumberInput__["a" /* default */],checkValidation:_this2.props.checkValidation,label:'%*',isrequired:true,validate:[required,percentage],onChange:function onChange(e,value,t,name){return _this2.changeGrowth(value,name);}}),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(CustomField,{name:'retirement.return'+i,suffix:"%",component:__WEBPACK_IMPORTED_MODULE_3_components_Wrappers_materialUIWrappers_components_NumberInput__["a" /* default */],checkValidation:_this2.props.checkValidation,label:'%*',isrequired:true,validate:[required,percentage],onChange:function onChange(e,value,t,name){return _this2.changeReturn(value,name);}}));}),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Q" /* Table */],{style:{width:"10em"}},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_DescriptiveRow_jsx__["a" /* default */],{description:"Add Asset",add:function add(){return _this2.addNew();},extraCells:10})))))))));}}]);return Retirenment;}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Retirenment);

/***/ }),
/* 2494 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_core__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_Wrappers_materialUIWrappers_components_FormCheckbox_jsx__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Wrappers_materialUIWrappers_components_FormInput__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_redux_form__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_store__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_CustomCardHeading_jsx__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_Wrappers_materialUIWrappers_components_NumberInput__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__objects_FNA_result_vars_js__ = __webpack_require__(397);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__objects_assumptions_js__ = __webpack_require__(398);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Assumptions_jsx__ = __webpack_require__(632);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/*eslint-disable*/var colwidth=function colwidth(value){return{width:value,minWidth:value,maxWidth:value};};var required=function required(value){return value?undefined:"Required";};var OtherInformation=function(_React$Component){_inherits(OtherInformation,_React$Component);function OtherInformation(){_classCallCheck(this,OtherInformation);return _possibleConstructorReturn(this,(OtherInformation.__proto__||Object.getPrototypeOf(OtherInformation)).apply(this,arguments));}_createClass(OtherInformation,[{key:"componentDidMount",value:function componentDidMount(){this.props.scrollMeBar();this.props.state.result=new __WEBPACK_IMPORTED_MODULE_10__objects_FNA_result_vars_js__["b" /* fnaResult */]().fna;}},{key:"calcBalanceSheet",value:function calcBalanceSheet(){var _this2=this;this.props.state.assets.map(function(e,i){var balanceSheetAsset={};balanceSheetAsset.description=e.description;balanceSheetAsset.ownershipClient=e.ownershipClient/100*e.marketValue;balanceSheetAsset.ownershipSpouse=e.ownershipSpouse/100*e.marketValue;_this2.props.state.result.balanceSheet.netAssetsClient+=balanceSheetAsset.ownershipClient;_this2.props.state.result.balanceSheet.netAssetsSpouse+=balanceSheetAsset.ownershipSpouse;_this2.props.state.result.balanceSheet.assets.push(balanceSheetAsset);var balanceSheetLiability={};if(e.liability>0){if(e.ownershipClient>0){balanceSheetLiability.description=e.description;balanceSheetLiability.amountClient=parseFloat(e.liability)*e.ownershipClient/100;_this2.props.state.result.balanceSheet.netLiabilitiesClient+=parseFloat(balanceSheetLiability.amountClient);}if(e.ownershipSpouse>0){balanceSheetLiability.description=e.description;balanceSheetLiability.amountSpouse=parseFloat(e.liability)*e.ownershipSpouse/100;_this2.props.state.result.balanceSheet.netLiabilitiesSpouse+=parseFloat(balanceSheetLiability.amountSpouse);}if(e.ownershipSpouse>0||e.ownershipClient>0)_this2.props.state.result.balanceSheet.liabilities.push(balanceSheetLiability);}});this.props.state.liabilities.map(function(e,i){var balanceSheetLiability={};balanceSheetLiability.description=e.description;if(e.party=="client"){balanceSheetLiability.amountClient=parseFloat(e.amount);_this2.props.state.result.balanceSheet.netLiabilitiesClient+=parseFloat(e.amount);}else{balanceSheetLiability.amountSpouse=parseFloat(e.amount);_this2.props.state.result.balanceSheet.netLiabilitiesSpouse+=parseFloat(e.amount);}_this2.props.state.result.balanceSheet.liabilities.push(balanceSheetLiability);});this.props.state.policy.map(function(e,i){if(e.party=="client"){var balanceSheetPolicy={};balanceSheetPolicy.description=e.description;if(e.LifeAssured=="client"){balanceSheetPolicy.amountClient=parseFloat(e.cashValue);_this2.props.state.result.balanceSheet.netPoliciesClient+=parseFloat(e.cashValue);}else{balanceSheetPolicy.amountSpouse=parseFloat(e.cashValue);_this2.props.state.result.balanceSheet.netPoliciesSpouse+=parseFloat(e.cashValue);}_this2.props.state.result.balanceSheet.policies.push(balanceSheetPolicy);}});this.props.state.result.balanceSheet.netTotalAssetsClient=parseFloat(this.props.state.result.balanceSheet.netAssetsClient)+parseFloat(this.props.state.result.balanceSheet.netPoliciesClient)-parseFloat(this.props.state.result.balanceSheet.netLiabilitiesClient);this.props.state.result.balanceSheet.netTotalAssetsSpouse=parseFloat(this.props.state.result.balanceSheet.netAssetsSpouse)+parseFloat(this.props.state.result.balanceSheet.netPoliciesSpouse)-parseFloat(this.props.state.result.balanceSheet.netLiabilitiesSpouse);this.props.state.result.executorFees.percentageApplicable=this.props.state.execFee;this.props.state.result.executorFees.vat=this.props.state.vat;this.props.state.result.executorFees.executorFee=parseFloat(this.props.state.result.balanceSheet.netAsset)*parseFloat(this.props.state.execFee)/100*parseFloat(this.props.state.vat)/100;}},{key:"calcCgt",value:function calcCgt(){var _this3=this;this.props.state.assets.map(function(e,i){if(e.cgtPayable){var temp=__WEBPACK_IMPORTED_MODULE_10__objects_FNA_result_vars_js__["a" /* cgtAsset */];temp.description=e.description;temp.e.category=e.e.category;temp.marketValue=e.marketValue;temp.baseCost=e.baseCost;temp.capitalGain=e.marketValue-e.baseCost;temp.bequethedToSpouse=e.spouseInherit/100*e.marketValue;temp.residueTospouse=_this3.props.state.residueAmount/100*e.marketValue;temp.netGain=temp.capitalGain-temp.bequethedToSpouse-temp.residueTospouse;_this3.props.state.result.cgt.netCgtMarketValue+=e.marketValue;_this3.props.state.result.cgt.netClientsBaseCost+=e.baseCost;_this3.props.state.result.cgt.netClientsCapitalGain+=temp.capitalGain;_this3.props.state.result.cgt.netCashBequestTospouse+=temp.bequethedToSpouse;_this3.props.state.result.cgt.netResidueTospouse+=temp.residueTospouse;_this3.props.state.result.cgt.netSpouseCapitalGain+=temp.netGain;if(e.category!="primary_residential"){_this3.props.state.result.cgt.netClientsCapitalGainDisplay+=temp.capitalGain;}_this3.props.state.result.cgt.cgtAssets.push(temp);if(e.category=="primary_residential"){if(temp.capitalGain-_this3.props.state.result.cgt.minuspResidence.primaryResidenceExclusion>0)temp.capitalGain=temp.capitalGain-_this3.props.state.result.cgt.minuspResidence.primaryResidenceExclusion;else temp.capitalGain=0.00;_this3.props.state.result.cgt.netClientsCapitalGainDisplay+=temp.capitalGain;_this3.props.state.result.cgt.pResidence=temp;}}if(_this3.props.state.result.cgt.netClientsCapitalGain>0)_this3.props.state.result.cgt.capitalGain=_this3.props.state.result.cgt.netClientsCapitalGain;//Primary residense exlusion
if(e.category=="primary_residential"){if(temp.netGain>__WEBPACK_IMPORTED_MODULE_11__objects_assumptions_js__["a" /* default */].primary_residence_exemption)_this3.props.state.result.cgt.minuspResidence.primaryResidence=__WEBPACK_IMPORTED_MODULE_11__objects_assumptions_js__["a" /* default */].primary_residence_exemption;else _this3.props.state.result.cgt.minuspResidence.primaryResidence=temp.netGain;if(temp.netGain<-1*__WEBPACK_IMPORTED_MODULE_11__objects_assumptions_js__["a" /* default */].primary_residence_exemption)_this3.props.state.result.cgt.minuspResidence.primaryResidenceLoss=-1*__WEBPACK_IMPORTED_MODULE_11__objects_assumptions_js__["a" /* default */].primary_residence_exemption;else _this3.props.state.result.cgt.minuspResidence.primaryResidenceLoss=temp.netGain;}});this.props.state.result.cgt.minuspResidence.primaryResidenceExclusion=__WEBPACK_IMPORTED_MODULE_11__objects_assumptions_js__["a" /* default */].primary_residence_exemption;this.props.state.result.cgt.minuspResidence.primaryResidenceLossExclusion=-1*__WEBPACK_IMPORTED_MODULE_11__objects_assumptions_js__["a" /* default */].primary_residence_exemption;this.props.state.result.cgt.minuspResidence.netExclusion=this.props.state.result.cgt.minuspResidence.primaryResidence+this.props.state.result.cgt.minuspResidence.primaryResidenceLoss;this.props.state.result.cgt.netMinusExlusion=this.props.state.result.cgt.netClientsCapitalGain-this.props.state.result.cgt.minuspResidence.netExclusion;this.props.state.result.cgt.minusspouseRollOver.portionBequethedTospouse=this.props.state.result.cgt.netCashBequestTospouse;this.props.state.result.cgt.minusspouseRollOver.portionResidueTospouse=this.props.state.result.cgt.netResidueTospouse;this.props.state.result.cgt.minusspouseRollOver.netRollOver=this.props.state.result.cgt.minusspouseRollOver.portionBequethedTospouse+this.props.state.result.cgt.minusspouseRollOver.portionResidueTospouse;this.props.state.result.cgt.netMinusRollOver=this.props.state.result.cgt.netMinusExlusion-this.props.state.result.cgt.minusspouseRollOver.netRollOver;this.props.state.result.cgt.minusPreviousLoss=this.props.state.capitalLossAmount;this.props.state.result.cgt.netMinusPreviousLoss=this.props.state.result.cgt.netMinusRollOver-this.props.state.result.cgt.minusPreviousLoss;this.props.state.result.cgt.minusExclusionAtDeath=__WEBPACK_IMPORTED_MODULE_11__objects_assumptions_js__["a" /* default */].cgtExclusionAtDeath;if(this.props.state.result.cgt.netMinusPreviousLoss>0)this.props.state.result.cgt.netMinusExlusionAtDeath=this.props.state.result.cgt.minusExclusionAtDeath;else this.props.state.result.cgt.netMinusExlusionAtDeath=0;this.props.state.result.cgt.netCgt=this.props.state.result.cgt.netMinusPreviousLoss-this.props.state.result.cgt.netMinusExlusionAtDeath;this.props.state.result.cgt.marginalTax=this.props.state.marginalTax;this.props.state.result.cgt.inclusionRate=__WEBPACK_IMPORTED_MODULE_11__objects_assumptions_js__["a" /* default */].inclusion_rate_for_cgt;if(this.props.state.result.cgt.netCgt>0)this.props.state.result.cgt.cgtPayable=this.props.state.result.cgt.netCgt*this.props.state.result.cgt.marginalTax/100*this.props.state.result.cgt.inclusionRate/100;else this.props.state.result.cgt.cgtPayable=0;console.log(this.props.state.result);}},{key:"calcEstateDuty",value:function calcEstateDuty(){var _this4=this;this.props.state.assets.map(function(e,i){if(e.category=="farms_owned")_this4.props.state.result.estateDuty.assets.netFarms+=e.ownershipClient/100*marketValue;else if(e.category=="usufruct_annuity_charged_on_property_or_similar_right")_this4.props.state.result.estateDuty.assets.netDeemedAssets+=e.ownershipClient/100*marketValue;else _this4.props.state.result.estateDuty.assets.netAssets+=e.ownershipClient/100*marketValue;});this.props.state.policy.map(function(e,i){if(!e.dutyExcempt)if(e.LifeAssured=="Client"){_this4.props.state.result.estateDuty.assets.netPoliciesOnLife+=e.death;_this4.props.state.result.estateDuty.deductions.netPoliciesToSpouse+=e.death*e.spouse/100;}else if(e.party=="Client")_this4.props.state.result.estateDuty.assets.netPoliciesWithChash+=e.cashValue;});this.props.state.result.estateDuty.assets.netEstateAssets=this.props.state.result.estateDuty.assets.netFarms+this.props.state.result.estateDuty.assets.netDeemedAssets+this.props.state.result.estateDuty.assets.netAssets+this.props.state.result.estateDuty.assets.netPoliciesOnLife+this.props.state.result.estateDuty.assets.netPoliciesWithChash+this.props.state.result.estateDuty.assets.netAccrualClaim;this.props.state.result.estateDuty.deductions.netLiabilities=this.props.state.result.balanceSheet.netLiabilitiesClient;this.props.state.result.estateDuty.deductions.netAdministration=this.props.state.adminCost;this.props.state.result.estateDuty.deductions.netFuneral=this.props.state.funeralCost;this.props.state.result.estateDuty.deductions.netMastersFee=__WEBPACK_IMPORTED_MODULE_11__objects_assumptions_js__["a" /* default */].masters_fees;this.props.state.result.estateDuty.deductions.netExectutorsFee=0.00;//Still need to ass Executor's fee
this.props.state.result.estateDuty.deductions.netCapitalGainTax=this.props.state.result.cgt.cgtPayable;this.props.state.assets.map(function(e,i){if((e.category=="farms_owned"||e.category=="primary_residential"||e.category=="other_residential")&&!e.liquid)_this4.props.state.result.estateDuty.deductions.netTransferCosts+=e.marketValue;//Should this only be the Client's portion??
_this4.props.state.result.estateDuty.deductions.netBequethedAssets+=e.marketValue*e.spouseInherit/100;});this.props.state.result.estateDuty.deductions.netTransferCosts=this.props.state.result.estateDuty.deductions.netTransferCosts*__WEBPACK_IMPORTED_MODULE_11__objects_assumptions_js__["a" /* default */].transfer_costs/100;this.props.state.needs.cashBequests.map(function(e,i){if(e.category=="cashBequest"||e.category=="cashBequestCharity"){_this4.props.state.result.estateDuty.deductions.netCashBequestTospouse+=e.mounthlyAmount*e.spouseInherit/100;_this4.props.state.result.estateDuty.deductions.netCashBequestToCharity+=e.mounthlyAmount*e.charityInherit/100;}});this.props.state.result.estateDuty.deductions.netResidueTospouse=0.00;//Still need to work out Residue first.
this.props.state.result.estateDuty.deductions.netAccrualClaim=this.props.state.spouseAccrualValue;this.props.state.result.estateDuty.deductions.netDeductions=this.props.state.result.estateDuty.deductions.netLiabilities+this.props.state.result.estateDuty.deductions.netAdministration+this.props.state.result.estateDuty.deductions.netFuneral+this.props.state.result.estateDuty.deductions.netMastersFee+this.props.state.result.estateDuty.deductions.netExectutorsFee+this.props.state.result.estateDuty.deductions.netCapitalGainTax+this.props.state.result.estateDuty.deductions.netTransferCosts+this.props.state.result.estateDuty.deductions.netBequethedAssets+this.props.state.result.estateDuty.deductions.netCashBequestTospouse+this.props.state.result.estateDuty.deductions.netCashBequestToCharity+this.props.state.result.estateDuty.deductions.netResidueTospouse+this.props.state.result.estateDuty.deductions.netPoliciesToSpouse+this.props.state.result.estateDuty.deductions.netAccrualClaim;this.props.state.result.estateDuty.netEstate=this.props.state.result.estateDuty.assets.netEstateAssets-this.props.state.result.estateDuty.deductions.netDeductions;this.props.state.result.estateDuty.minusRebate=__WEBPACK_IMPORTED_MODULE_11__objects_assumptions_js__["a" /* default */].estate_duty_exemption;this.props.state.result.estateDuty.minusRebateFromPreviousSpouse=this.props.state.rebateUsed;this.props.state.result.estateDuty.taxableEstate=this.props.state.result.estateDuty.netEstate-this.props.state.result.estateDuty.minusRebate-this.props.state.result.estateDuty.minusRebateFromPreviousSpouse;if(this.props.state.result.estateDuty.taxableEstate<0)this.props.state.result.estateDuty.taxableEstate=0.00;if(this.props.state.result.estateDuty.taxableEstate<=30000000)this.props.state.result.estateDuty.estateDutyPayable=this.props.state.result.estateDuty.taxableEstate*__WEBPACK_IMPORTED_MODULE_11__objects_assumptions_js__["a" /* default */].estateDutyLT/100;else this.props.state.result.estateDuty.estateDutyPayable=this.props.state.result.estateDuty.taxableEstate*__WEBPACK_IMPORTED_MODULE_11__objects_assumptions_js__["a" /* default */].estateDutyGT/100;this.props.state.policy.map(function(e,i){if(!e.dutyExcempt){_this4.props.state.result.estateDuty.payableByOther+=e.death*e.other/100;}});this.props.state.result.estateDuty.payableByOther=this.props.state.result.estateDuty.payableByOther/this.props.state.result.estateDuty.netEstate*this.props.state.result.estateDuty.estateDutyPayable;this.props.state.result.estateDuty.payableByEstate=this.props.state.result.estateDuty.estateDutyPayable-this.props.state.result.estateDuty.payableByOther;}},{key:"calcLiquidity",value:function calcLiquidity(){var _this5=this;this.props.state.result.liquidity.cashNeeded.netCgt=this.props.state.result.cgt.cgtPayable;this.props.state.result.liquidity.cashNeeded.netLiabilities=this.props.state.result.balanceSheet.netLiabilitiesClient;this.props.state.result.liquidity.cashNeeded.netExectutorsFee=this.props.state.result.executorFees.executorFee;this.props.state.result.liquidity.cashNeeded.netEstateDuty=this.props.state.result.estateDuty.payableByEstate;this.props.state.result.liquidity.cashNeeded.netOtherCosts=this.props.state.result.deductions.netAdministration+this.props.state.result.deductions.netFuneral+this.props.state.result.deductions.netMastersFee+this.props.state.result.deductions.netTransferCosts;//this.props.state.result.liquidity.cashNeeded.netBequethedAssets =       //Still need to consult if this needs to be in here.
this.props.state.needs.cashBequests.map(function(e,i){if((e.category=="cashBequest"||e.category=="cashBequestCharity")&&e.death){_this5.props.state.result.liquidity.cashNeeded.netCashBequests+=e.mounthlyAmount;}});//this.props.state.result.liquidity.cashNeeded.netAccrualClaim =                //First need to calculate accrual.
this.props.state.result.liquidity.cashNeeded.netCashNeeded=this.props.state.result.liquidity.cashNeeded.netCgt+this.props.state.result.liquidity.cashNeeded.netLiabilities+this.props.state.result.liquidity.cashNeeded.netExectutorsFee+this.props.state.result.liquidity.cashNeeded.netEstateDuty+this.props.state.result.liquidity.cashNeeded.netOtherCosts+this.props.state.result.liquidity.cashNeeded.netBequethedAssets+this.props.state.result.liquidity.cashNeeded.netCashBequests+this.props.state.result.liquidity.cashNeeded.netAccrualClaim;this.props.state.assets.map(function(e,i){if(e.category!="primary_residential"&&e.category!="other_residential"&&e.category!="farms_owned"&&e.category!="usufruct_annuity_charged_on_property_or_similar_right"||e.liquid){if(e.liquid)_this5.props.state.result.liquidity.cashAvailable.netCashAssets+=e.marketValue;else _this5.props.state.result.liquidity.cashAvailable.netLiquidInvestments=e.marketValue;}});this.props.state.policy.map(function(e,i){if(e.party=="client")_this5.props.state.result.liquidity.cashAvailable.netPolicies+=e.death*estate/100;});this.props.state.result.liquidity.cashAvailable.netCashAvailable=this.props.state.result.liquidity.cashAvailable.netCashAssets+this.props.state.result.liquidity.cashAvailable.netLiquidInvestments+this.props.state.result.liquidity.cashAvailable.netPolicies;this.props.state.result.liquidity.cash=this.props.state.result.liquidity.cashAvailable.netCashAvailable-this.props.state.result.liquidity.cashNeeded.netCashNeeded;}},{key:"calcAccrual",value:function calcAccrual(){var _this6=this;this.props.state.result.accrual.current.valueOfAssets.client=this.props.state.result.balanceSheet.netAssetsClient;this.props.state.result.accrual.current.valueOfAssets.spouse=this.props.state.result.balanceSheet.netAssetsSpouse;this.props.state.policy.map(function(e,i){if(e.LifeAssured=="client")_this6.props.state.result.accrual.current.valueOfAssets.client+=e.cashValue;if(e.LifeAssured=="spouse")_this6.props.state.result.accrual.current.valueOfAssets.spouse+=e.cashValue;if(e.party=="client")_this6.props.state.result.accrual.current.valueOfPolicies+=e.death*e.estate/100;});this.props.state.result.accrual.current.minusLiabilities.client=this.props.state.result.balanceSheet.netLiabilitiesClient;this.props.state.result.accrual.current.minusLiabilities.spouse=this.props.state.result.balanceSheet.netLiabilitiesSpouse;this.props.state.result.accrual.current.netValue.client=this.props.state.result.accrual.current.valueOfAssets.client+this.props.state.result.accrual.current.valueOfPolicies-this.props.state.result.accrual.current.minusLiabilities.client;this.props.state.result.accrual.current.netValue.spouse=this.props.state.result.accrual.current.valueOfAssets.spouse-this.props.state.result.accrual.current.minusLiabilities.spouse;this.props.state.result.accrual.assetValueExcluded.client=this.props.state.accrualExcludedClient;this.props.state.result.accrual.assetValueExcluded.spouse=this.props.state.accrualExcludedSpouse;this.props.state.result.accrual.atMarriage.valueANC.client=this.props.state.accrualExcludedMarrageClient;this.props.state.result.accrual.atMarriage.valueANC.spouse=this.props.state.accrualExcludedMarrageSpouse;this.props.state.result.accrual.netAccrual.client=this.props.state.result.accrual.current.netValue.client-this.props.state.result.accrual.assetValueExcluded.client;this.props.state.result.accrual.netAccrual.spouse=this.props.state.result.accrual.current.netValue.spouse-this.props.state.result.accrual.assetValueExcluded.spouse;if(this.props.state.result.accrual.netAccrual.client<0)this.props.state.result.accrual.netAccrual.client=0.00;if(this.props.state.result.accrual.netAccrual.spouse<0)this.props.state.result.accrual.netAccrual.spouse=0.00;if(this.props.state.result.accrual.netAccrual.spouse-this.props.state.result.accrual.netAccrual.client>0)this.props.state.result.accrual.claimAgainstSpouse=(this.props.state.result.accrual.netAccrual.spouse-this.props.state.result.accrual.netAccrual.client)/2;if(this.props.state.result.accrual.netAccrual.client-this.props.state.result.accrual.netAccrual.spouse>0)this.props.state.result.accrual.clainBySpouse=(this.props.state.result.accrual.netAccrual.client-this.props.state.result.accrual.netAccrual.spouses)/2;}},{key:"calcResidue",value:function calcResidue(){var _this7=this;this.props.state.result.residue.totalAssets=this.props.state.result.estateDuty.assets.netEstateAssets;this.props.state.result.residue.policies=0.00;// Must make sure what policies needs to be used here.
this.props.state.assets.map(function(e,i){_this7.props.state.result.residue.bequestsToOther+=e.marketValue*e.ownershipClient/100*e.otherInherit/100+e.marketValue*e.ownershipClient/100*e.charityInherit/100;_this7.props.state.result.residue.bequestsToSpouse+=e.marketValue*e.ownershipClient/100*e.spouseInherit/100;});this.props.state.needs.cashBequests.map(function(e,i){if((e.category=="cashBequest"||e.category=="cashBequestCharity")&&e.death){_this7.props.state.result.residue.cashBequestsToOther+=e.mounthlyAmount*e.otherInherit/100+e.mounthlyAmount*e.charityInherit/100;_this7.props.state.result.residue.cashBequestsToSpouse+=e.mounthlyAmount*e.spouseInherit/100;}});this.props.state.result.residue.liabilities=this.props.state.result.balanceSheet.netLiabilitiesClient;this.props.state.result.residue.costs=this.props.state.result.estateDuty.deductions.netAdministration+this.props.state.result.estateDuty.deductions.netFuneral+this.props.state.result.estateDuty.deductions.netMastersFee+this.props.state.result.estateDuty.deductions.netExectutorsFee+this.props.state.result.estateDuty.deductions.netCapitalGainTax+this.props.state.result.estateDuty.deductions.netTransferCosts;this.props.state.result.residue.accrualClaimBySpouse=this.props.state.result.accrual.clainBySpouse;this.props.state.result.residue.minus=this.props.state.result.residue.policies+this.props.state.result.residue.bequestsToOther+this.props.state.result.residue.cashBequestsToOther+this.props.state.result.residue.bequestsToSpouse+this.props.state.result.residue.cashBequestsToSpouse+this.props.state.result.residue.liabilities+this.props.state.result.residue.costs+this.props.state.result.residue.accrualClaimBySpouse;this.props.state.result.residue.residueBeforeEstateDuty=this.props.state.result.residue.totalAssets-this.props.state.result.residue.minus;if(this.props.state.result.residue.residueBeforeEstateDuty<0)this.props.state.result.residue.residueBeforeEstateDuty=0.00;this.props.state.result.residue.minusEstateDuty=this.props.state.result.estateDuty.payableByEstate;this.props.state.result.residue.residue=this.props.state.result.residue.residueBeforeEstateDuty-this.props.state.result.residue.minusEstateDuty;if(this.props.state.result.residue.residue<0)this.props.state.result.residue.residue=0.00;}},{key:"calcDeathProvision",value:function calcDeathProvision(){}},{key:"calcDisabilityCgt",value:function calcDisabilityCgt(){}},{key:"disabilityLiquidity",value:function disabilityLiquidity(){}},{key:"calcDisabilityProvision",value:function calcDisabilityProvision(){}},{key:"whoof",value:function whoof(){return JSON.stringify(this.props.state.result);}},{key:"render",value:function render(){var checkValidation=this.props.checkValidation;var other_information=__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(__WEBPACK_IMPORTED_MODULE_7_store__["a" /* default */].getState().form,"newfna.values.other_information",{});return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("div",{className:"contentWithStepper"},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["e" /* Card */],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["f" /* CardContent */],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_CustomCardHeading_jsx__["a" /* default */],{subheading:"Financial Needs Analysis",caption:"Client Name",headline:"Other information"}),this.calcBalanceSheet(),this.calcCgt(),this.calcAccrual(),this.calcEstateDuty(),this.calcLiquidity(),this.calcResidue(),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("h1",null,"Balance Sheet"),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("h2",null,"Assets"),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Q" /* Table */],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["T" /* TableHead */],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,"Description"),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,"Client"),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,"Spouse"))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["R" /* TableBody */],null,this.props.state.result.balanceSheet.assets.map(function(e,i){return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,e.description),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,e.ownershipClient),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,e.ownershipSpouse));}),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("b",null,"Total")),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,this.props.state.result.balanceSheet.netAssetsClient),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,this.props.state.result.balanceSheet.netAssetsSpouse)))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("h3",null,"Cash values of policies"),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Q" /* Table */],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["T" /* TableHead */],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,"Description"),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,"Client"),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,"Spouse"))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["R" /* TableBody */],null,this.props.state.result.balanceSheet.policies.map(function(e,i){return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,e.description),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,e.amountClient),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,e.amountSpouse));}),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("b",null,"Total")),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,this.props.state.result.balanceSheet.netPoliciesClient),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,this.props.state.result.balanceSheet.netPoliciesSpouse)))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("h3",null,"Liabilities"),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Q" /* Table */],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["T" /* TableHead */],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,"Description"),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,"Client"),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,"Spouse"))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["R" /* TableBody */],null,this.props.state.result.balanceSheet.liabilities.map(function(e,i){return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,e.description),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,e.amountClient),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,e.amountSpouse));}),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("h3",null,"Total")),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,this.props.state.result.balanceSheet.netLiabilitiesClient),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,this.props.state.result.balanceSheet.netLiabilitiesSpouse)))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Q" /* Table */],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["T" /* TableHead */],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("h4",null,"Net Asset value")),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,this.props.state.result.balanceSheet.netTotalAssetsClient),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,this.props.state.result.balanceSheet.netTotalAssetsSpouse)))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("h1",null,"Capital Gains Tax"),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("h3",null,"Assets"),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Q" /* Table */],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["T" /* TableHead */],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("b",null,"Type")),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("b",null,"Description")),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("b",null,"Market value of client's share")),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("b",null,"Client's base cost")),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("b",null,"Client's capital gain")))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["R" /* TableBody */],null,this.props.state.assets.cgt.pResidence.description!=""&&__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,this.props.state.assets.cgt.pResidence.category),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,this.props.state.assets.cgt.pResidence.description),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,this.props.state.assets.cgt.pResidence.baseCost),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,this.props.state.assets.cgt.pResidence.capitalGain)),this.props.state.result.cgt.cgtAssets.map(function(e,i){if(e.category!="primary_residential")return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,e.category),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,e.description),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,e.baseCost),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,e.capitalGain));}),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("h4",null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("b",null,"Total"))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,this.props.state.result.cgt.netCgtMarketValue),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,this.props.state.result.cgt.netClientsBaseCost),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,this.props.state.result.cgt.netClientsCapitalGainDisplay)))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Q" /* Table */],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["T" /* TableHead */],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("h4",null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("b",null,"Net Capital Gain"))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("b",null,this.props.state.result.cgt.netMinusExlusion))))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Q" /* Table */],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["T" /* TableHead */],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("h4",null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("b",null,"Minus: Spouse's Roll Over"))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("b",null,this.props.state.result.cgt.minusspouseRollOver.netRollOver)))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["R" /* TableBody */],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,"Portion bequethed to Spouse"),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,this.props.state.result.cgt.minusspouseRollOver.portionBequethedTospouse),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null)),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,"Portion to Spouse as part of residue"),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,this.props.state.result.cgt.minusspouseRollOver.portionResidueTospouse),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null)),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("b",null,this.props.state.result.cgt.netMinusRollOver))))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Q" /* Table */],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["T" /* TableHead */],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("b",null,"Minus: Previous loss carried over")),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("b",null,this.props.state.result.cgt.minusPreviousLoss)),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("b",null,this.props.state.result.cgt.minusPreviousLoss))))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Q" /* Table */],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["T" /* TableHead */],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("b",null,this.props.state.result.cgt.netMinusPreviousLoss))))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Q" /* Table */],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["T" /* TableHead */],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("b",null,"Minus: Exclusion at death")),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,this.props.state.result.cgt.minusExclusionAtDeath),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,this.props.state.result.cgt.netMinusPreviousLoss>0&&this.props.state.result.cgt.netMinusExlusionAtDeath,this.props.state.result.cgt.netMinusPreviousLoss<1&&0.00)))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Q" /* Table */],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["T" /* TableHead */],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("h4",null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("b",null,"Net CGT"))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,this.props.state.result.cgt.netCgt)))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Q" /* Table */],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["R" /* TableBody */],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("h4",null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("b",null,"Marginal Tax Rate"))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,this.props.state.result.cgt.marginalTax)),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("h4",null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("b",null,"Inclusion rate"))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,this.props.state.result.cgt.inclusionRate)))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Q" /* Table */],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["T" /* TableHead */],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("h4",null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("b",null,"CGT Payable"))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,this.props.state.result.cgt.cgtPayable)))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("h1",null,"Estate Duty"),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Q" /* Table */],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["R" /* TableBody */],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("b",null,"Assets")),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,this.props.state.result.estateDuty.assets.netEstateAssets)),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,"Assets from balance sheet"),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,this.props.state.result.estateDuty.assets.netAssets)),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,"Farms"),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,this.props.state.result.estateDuty.assets.netFarms)),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,"Deemed Assets"),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,this.props.state.result.estateDuty.assets.netDeemedAssets)),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,"Policies on your life"),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,this.props.state.result.estateDuty.assets.netPoliciesOnLife)),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,"Policies with cash value"),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,this.props.state.result.estateDuty.assets.netPoliciesWithChash)),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,"Accrual clain against surviving spouse"),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,this.props.state.result.estateDuty.assets.netAccrualClaim)),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("b",null,"Deductions")),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,this.props.state.result.estateDuty.deductions.netDeductions)),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,"Liabilities"),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,this.props.state.result.estateDuty.deductions.netLiabilities)),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,"Administration"),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,this.props.state.result.estateDuty.deductions.netAdministration)),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,"Funeral"),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,this.props.state.result.estateDuty.deductions.netFuneral)),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,"Masters fees"),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,this.props.state.result.estateDuty.deductions.netMastersFee)),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,"Executors fees"),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,this.props.state.result.estateDuty.deductions.netExectutorsFee)),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,"Capital Gains Tax"),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,this.props.state.result.estateDuty.deductions.netCapitalGainTax)),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,"Transfer costs"),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,this.props.state.result.estateDuty.deductions.netTransferCosts)),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,"Value of assets bequethed to surviving spouse"),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,this.props.state.result.estateDuty.deductions.netBequethedAssets)),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,"Cash bequests to spouse"),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,this.props.state.result.estateDuty.deductions.netCashBequestTospouse)),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,"Bequests to charities"),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,this.props.state.result.estateDuty.deductions.netCashBequestToCharity)),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,"Residue to surviving spouse"),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,this.props.state.result.estateDuty.deductions.netResidueTospouse)),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,"Policies to surviving spouse"),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,this.props.state.result.estateDuty.deductions.netPoliciesToSpouse)),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,"Accrual claim"),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,this.props.state.result.estateDuty.deductions.netAccrualClaim)),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null)),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null)),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("b",null,"Nett Estate")),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,this.props.state.result.estateDuty.netEstate)),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,"Minus: Rebate"),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,this.props.state.result.estateDuty.minusRebate)),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,"Minus: Rebate carried from previous spouse"),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,this.props.state.result.estateDuty.minusRebateFromPreviousSpouse)),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("b",null,"Taxable Estate")),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,this.props.state.result.estateDuty.taxableEstate)),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("b",null,"Estate Duty payable")),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,this.props.state.result.estateDuty.estateDutyPayable)))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{container:true},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:6})))));}}]);return OtherInformation;}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);/* unused harmony default export */ var _unused_webpack_default_export = (OtherInformation);

/***/ }),
/* 2495 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_core__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_Wrappers_materialUIWrappers_components_FormCheckbox_jsx__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Wrappers_materialUIWrappers_components_FormDropDown__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Wrappers_materialUIWrappers_components_FormInput__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_redux_form__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_store__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_CustomCardHeading__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_Wrappers_materialUIWrappers_components_NumberInput__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_helpers_ValidationHelpers__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_helpers_DateHelpers__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_helpers_GetIdInformation__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_moment__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_moment__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/*eslint-disable*/var required=function required(value){return value?undefined:"Required";};var CustomFieldMed=function CustomFieldMed(props){return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:4,sm:4,md:2,style:{marginTop:'-25px'}},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["t" /* FormControl */],{fullWidth:true},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_redux_form__["a" /* Field */],props)));};var CustomFieldFullWidth=function CustomFieldFullWidth(props){return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:12,style:{marginBottom:'25px'}},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["t" /* FormControl */],{fullWidth:true},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_redux_form__["a" /* Field */],props)));};var checkItem=function checkItem(label,name,changeFunc){return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:4,sm:4,md:2},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["t" /* FormControl */],{style:{marginBottom:"-30px",paddingBottom:"-30px"}},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_2_components_Wrappers_materialUIWrappers_components_FormCheckbox_jsx__["a" /* default */],name:name,onChange:function onChange(e,f,g,h){changeFunc(h,f);}})));};var PersonalDetail=function(_React$Component){_inherits(PersonalDetail,_React$Component);function PersonalDetail(){_classCallCheck(this,PersonalDetail);return _possibleConstructorReturn(this,(PersonalDetail.__proto__||Object.getPrototypeOf(PersonalDetail)).apply(this,arguments));}_createClass(PersonalDetail,[{key:"componentDidMount",value:function componentDidMount(){this.props.scrollMeBar();}},{key:"changeReason",value:function changeReason(name){var reasons=this.props.fnaReasons;reasons[name]=!reasons[name];console.log(reasons);this.props.changePersonal("fnaReasons",reasons);}},{key:"render",value:function render(){var _this2=this;var clientD="";if(this.props.state.client)clientD=this.props.state.client.first_name+" "+this.props.state.client.surname;return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement("div",{className:"contentWithStepper"},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["e" /* Card */],null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["f" /* CardContent */],null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_CustomCardHeading__["a" /* default */],{subheading:"Financial Needs Analysis",caption:clientD,headline:"FNA Details"}),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{container:true},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(CustomFieldFullWidth,{name:'description',component:__WEBPACK_IMPORTED_MODULE_4_components_Wrappers_materialUIWrappers_components_FormInput__["a" /* default */],checkValidation:this.props.checkValidation,label:'FNA Description *',isrequired:true//validate={[required]}
}),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:12,style:{marginBottom:'25px'}}),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:12,style:{marginBottom:'-8px'}},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px'}},"Please select the reasons for FNA")),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:6,style:{marginBottom:'55px'}},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:4,style:{marginBottom:'-10px'}},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["t" /* FormControl */],{fullWidth:true},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement("div",{key:"Death",className:'checkboxContainerMedical'//style={this.props.fnaReasons["death"] ? { backgroundColor: '#f5f5f5'} : {}}
,onClick:function onClick(){_this2.changeReason("death");}},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["h" /* Checkbox */],{checked:this.props.fnaReasons["death"]}),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{marginTop:'auto',marginBottom:"auto"}},"Death")))),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:4,style:{marginBottom:'-10px'}},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["t" /* FormControl */],{fullWidth:true},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement("div",{key:"Disability",className:'checkboxContainerMedical'//style={this.props.fnaReasons["disability"] ? { backgroundColor: '#f5f5f5'} : {}}
,onClick:function onClick(){_this2.changeReason("disability");}},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["h" /* Checkbox */],{checked:this.props.fnaReasons["disability"]}),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{marginTop:'auto',marginBottom:"auto"}},"Disability")))),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:4,style:{marginBottom:'-10px'}},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["t" /* FormControl */],{fullWidth:true},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement("div",{key:"Retirement",className:'checkboxContainerMedical'//style={this.props.fnaReasons["retirement"] ? { backgroundColor: '#f5f5f5'} : {}}
,onClick:function onClick(){_this2.changeReason("retirement");}},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["h" /* Checkbox */],{checked:this.props.fnaReasons["retirement"]}),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{marginTop:'auto',marginBottom:"auto"}},"Retirement"))))),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:6,style:{marginBottom:'25px',marginTop:'-25px'}},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(CustomFieldFullWidth,{name:'marginalTax',suffix:"%",component:__WEBPACK_IMPORTED_MODULE_10_components_Wrappers_materialUIWrappers_components_NumberInput__["a" /* default */],checkValidation:this.props.checkValidation,label:'Marginal Tax Rate %*',isrequired:true,onChange:function onChange(e,f,g,h){_this2.props.changePersonal(h,f);}//validate={[required]}
}),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{container:true,style:{marginBottom:'0px',marginTop:'50px'}},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:1,sm:1,md:10,style:{marginBottom:'0px',marginTop:'0px'}},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px'}},"Do you have a capital loss for CGT purposes which can be carried forward?")),checkItem("","capitalLoss",this.props.changePersonal),this.props.state.capitalLoss==true&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(CustomFieldFullWidth,{name:'capitalLossAmount',prefix:"R",component:__WEBPACK_IMPORTED_MODULE_10_components_Wrappers_materialUIWrappers_components_NumberInput__["a" /* default */],checkValidation:this.props.checkValidation,label:'Amount*',isrequired:true//validate={[required]}
,onChange:function onChange(e,f,g,h){_this2.props.changePersonal(h,f);}}))),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{container:true},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:24,sm:24,md:6,style:{marginBottom:'25px'}},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{container:true},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:6,sm:6,md:10,style:{marginBottom:'0px'}},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px'}},"Are there any assets which are excluded from accrual? (Client)")),checkItem("","accrualExclution",this.props.changePersonal),this.props.state.accrualExclution&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(CustomFieldFullWidth,{name:'accrualExcludedClient',prefix:"R",component:__WEBPACK_IMPORTED_MODULE_10_components_Wrappers_materialUIWrappers_components_NumberInput__["a" /* default */],checkValidation:this.props.checkValidation,label:'Asset value excluded from accrual (inheritance) R*',isrequired:true//validate={[required]}
,onChange:function onChange(e,f,g,h){_this2.props.changePersonal(h,f);}}),this.props.state.accrualExclution&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(CustomFieldFullWidth,{name:'accrualExcludedMarrageClient',prefix:"R",component:__WEBPACK_IMPORTED_MODULE_10_components_Wrappers_materialUIWrappers_components_NumberInput__["a" /* default */],checkValidation:this.props.checkValidation,label:'Asset value excluded at marriage (in terms of ANC) R*',isrequired:true//validate={[required]}
,onChange:function onChange(e,f,g,h){_this2.props.changePersonal(h,f);}}))),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:24,sm:24,md:6,style:{marginBottom:'25px'}},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{container:true},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:6,sm:6,md:10,style:{marginBottom:'0px'}},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px'}},"Are there any assets which are excluded from accrual? (spouse)")),checkItem("","accrualExclutionSpouse",this.props.changePersonal),this.props.state.accrualExclutionSpouse&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(CustomFieldFullWidth,{name:'accrualExcludedSpouse',prefix:"R",component:__WEBPACK_IMPORTED_MODULE_10_components_Wrappers_materialUIWrappers_components_NumberInput__["a" /* default */],checkValidation:this.props.checkValidation,label:'Asset value excluded from accrual (inheritance) R*',isrequired:true//validate={[required]}
,onChange:function onChange(e,f,g,h){_this2.props.changePersonal(h,f);}}),this.props.state.accrualExclutionSpouse&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(CustomFieldFullWidth,{name:'accrualExcludedMarrageSpouse',prefix:"R",component:__WEBPACK_IMPORTED_MODULE_10_components_Wrappers_materialUIWrappers_components_NumberInput__["a" /* default */],checkValidation:this.props.checkValidation,label:'Asset value excluded at marriage (in terms of ANC) R*',isrequired:true//validate={[required]}
,onChange:function onChange(e,f,g,h){_this2.props.changePersonal(h,f);}})))),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:6,style:{marginBottom:'25px',marginTop:'-25px'}},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(CustomFieldFullWidth,{name:'execFee',suffix:"%",component:__WEBPACK_IMPORTED_MODULE_10_components_Wrappers_materialUIWrappers_components_NumberInput__["a" /* default */],checkValidation:this.props.checkValidation,label:'Executors Fee %*',isrequired:true//validate={[required]}
,onChange:function onChange(e,f,g,h){_this2.props.changePersonal(h,f);}})),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:24,sm:24,md:6,style:{marginBottom:'25px'}},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{container:true},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:6,sm:6,md:10,style:{marginBottom:'0px'}},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px'}},"Include vat on executor's fee?")),checkItem("","execTax",this.props.changePersonal))),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:6,style:{marginBottom:'25px',marginTop:'-25px'}},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(CustomFieldFullWidth,{name:'funeralCost',prefix:"R",component:__WEBPACK_IMPORTED_MODULE_10_components_Wrappers_materialUIWrappers_components_NumberInput__["a" /* default */],checkValidation:this.props.checkValidation,label:'Funeral Costs R*',isrequired:true//validate={[required]}
,onChange:function onChange(e,f,g,h){_this2.props.changePersonal(h,f);}})),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:6,style:{marginBottom:'25px',marginTop:'-25px'}},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(CustomFieldFullWidth,{name:'adminCost',prefix:"R",component:__WEBPACK_IMPORTED_MODULE_10_components_Wrappers_materialUIWrappers_components_NumberInput__["a" /* default */],checkValidation:this.props.checkValidation,label:'Administration Costs R*',isrequired:true//validate={[required]}
,onChange:function onChange(e,f,g,h){_this2.props.changePersonal(h,f);}})),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:6,style:{marginBottom:'25px',marginTop:'-25px'}},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(CustomFieldFullWidth,{name:'inflation',suffix:"%",component:__WEBPACK_IMPORTED_MODULE_10_components_Wrappers_materialUIWrappers_components_NumberInput__["a" /* default */],checkValidation:this.props.checkValidation,label:'Inflation %*',isrequired:true//validate={[required]}
,onChange:function onChange(e,f,g,h){_this2.props.changePersonal(h,f);}})),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:6,style:{marginBottom:'25px',marginTop:'-25px'}},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(CustomFieldFullWidth,{name:'investmentGrowth',suffix:"%",component:__WEBPACK_IMPORTED_MODULE_10_components_Wrappers_materialUIWrappers_components_NumberInput__["a" /* default */],checkValidation:this.props.checkValidation,label:'Net Growth On Investments %*',isrequired:true//validate={[required]}
,onChange:function onChange(e,f,g,h){_this2.props.changePersonal(h,f);}})),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:24,sm:24,md:6,style:{marginBottom:'25px'}},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{container:true},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:6,sm:6,md:10,style:{marginBottom:'0px'}},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px'}},"70% on farm property?")),checkItem("","percentageOnFarm",this.props.changePersonal))),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:24,sm:24,md:6,style:{marginBottom:'25px'}},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{container:true},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:6,sm:6,md:10,style:{marginBottom:'0px'}},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px'}},"Will your spouse claim the accrual value?")),checkItem("","spouseAccrual",this.props.changePersonal))),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:24,sm:24,md:6,style:{marginBottom:'25px'}},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{container:true},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:6,sm:6,md:10,style:{marginBottom:'0px'}},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px'}},"Does your spouse inherit the full residue?")),checkItem("","spouseInheritFull",this.props.changePersonal),!this.props.state.spouseInheritFull&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:24,sm:24,md:12,style:{marginTop:'0px',marginLeft:'-15px'}},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(CustomFieldFullWidth,{name:'residueAmount',suffix:"%",component:__WEBPACK_IMPORTED_MODULE_10_components_Wrappers_materialUIWrappers_components_NumberInput__["a" /* default */],checkValidation:this.props.checkValidation,label:'Spouse Residue Inheretance %*',isrequired:true//validate={[required]}
,onChange:function onChange(e,f,g,h){_this2.props.changePersonal(h,f);}})))),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:24,sm:24,md:6,style:{}},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{container:true},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:6,sm:6,md:10,style:{marginBottom:'0px'}},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px'}},"Did a previous spouse die while married to you?")),checkItem("","spouseDeath",this.props.changePersonal),this.props.state.spouseDeath&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:12,style:{marginBottom:'25px',marginTop:'0px',marginLeft:'-15px'}},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(CustomFieldFullWidth,{name:'rebateUsed',prefix:"R",component:__WEBPACK_IMPORTED_MODULE_10_components_Wrappers_materialUIWrappers_components_NumberInput__["a" /* default */],checkValidation:this.props.checkValidation,label:'Amount estate duty rebate used R*',isrequired:true//validate={[required]}
,onChange:function onChange(e,f,g,h){_this2.props.changePersonal(h,f);}})))),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:24,sm:24,md:6,style:{marginBottom:'25px'}},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{container:true},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:6,sm:6,md:10,style:{marginBottom:'0px'}},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px'}},"Residue not going to spouse, to benefit of dependents?")),checkItem("","residueNotTo",this.props.changePersonal)))))));}}]);return PersonalDetail;}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (PersonalDetail);

/***/ }),
/* 2496 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_core__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_Wrappers_materialUIWrappers_components_FormCheckbox_jsx__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Wrappers_materialUIWrappers_components_FormInput__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_redux_form__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_store__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_CustomCardHeading__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_Wrappers_materialUIWrappers_components_NumberInput__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_helpers_ValidationHelpers__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_GroupBenifits_jsx__ = __webpack_require__(2497);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Retirement_jsx__ = __webpack_require__(2498);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_ApprovedFunds_jsx__ = __webpack_require__(2499);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/*eslint-disable*/var colwidth=function colwidth(value){return{width:value,minWidth:value,maxWidth:value};};var RetirementFund=function(_React$Component){_inherits(RetirementFund,_React$Component);function RetirementFund(){var _ref;var _temp,_this,_ret;_classCallCheck(this,RetirementFund);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=RetirementFund.__proto__||Object.getPrototypeOf(RetirementFund)).call.apply(_ref,[this].concat(args))),_this),_this.checkItem=function(label,name){return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{item:true,xs:12,sm:12,md:12},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{container:true},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:6,style:{marginBottom:"30px",position:"relative"}},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{variant:"body1",style:{position:"absolute",top:"25%"}},label)),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:6,style:{marginBottom:"30px"}},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["t" /* FormControl */],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_2_components_Wrappers_materialUIWrappers_components_FormCheckbox_jsx__["a" /* default */],name:name,onChange:function onChange(){_this.forceUpdate();}}))))));},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(RetirementFund,[{key:"componentDidMount",value:function componentDidMount(){this.props.scrollMeBar();}},{key:"render",value:function render(){var _this2=this;var checkValidation=this.props.checkValidation;var retirement_fund=__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(__WEBPACK_IMPORTED_MODULE_7_store__["a" /* default */].getState().form,"newfna.values.retirement_fund",{});return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("div",{className:"contentWithStepper"},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["e" /* Card */],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["f" /* CardContent */],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_CustomCardHeading__["a" /* default */],{subheading:"Financial Needs Analysis",caption:"Client Name",headline:"Retirement Fund Provisions"}),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{container:true},this.checkItem("Is this an aproved fund?","retirement_fund.approved_fund"),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:12,style:{overflowX:"auto"}},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_GroupBenifits_jsx__["a" /* default */],{checkValidation:checkValidation,forceUpdate:function forceUpdate(){return _this2.forceUpdate();}})),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:12,style:{marginTop:"40px",overflowX:"auto"}},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_Retirement_jsx__["a" /* default */],{checkValidation:checkValidation})),retirement_fund.approved_fund?__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:12,style:{marginTop:"40px",overflowX:"auto"}},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__components_ApprovedFunds_jsx__["a" /* default */],{checkValidation:checkValidation})):null))));}}]);return RetirementFund;}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);/* unused harmony default export */ var _unused_webpack_default_export = (RetirementFund);

/***/ }),
/* 2497 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_core__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_Wrappers_materialUIWrappers_components_NumberInput__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_helpers_ValidationHelpers__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_form__ = __webpack_require__(15);
/*eslint-disable*/var colwidth=function colwidth(value){return{width:value,minWidth:value,maxWidth:value};};var GroupBenefits=function GroupBenefits(props){return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Q" /* Table */],null,__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["T" /* TableHead */],null,__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall",style:colwidth("30em")},"Group / Employer Benefits"),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall",style:colwidth("15em")},"Multiple of Salary (As Capital)"),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall",style:colwidth("15em")},"% of Salary (As Income) "))),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["R" /* TableBody */],null,__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall"},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],null,"Death")),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall"},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],null,__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["t" /* FormControl */],{fullWidth:true},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_1_components_Wrappers_materialUIWrappers_components_NumberInput__["a" /* default */],checkValidation:props.checkValidation,onChange:function onChange(){return props.forceUpdate();},name:"retirement_fund.group_benifits.death.multiple_of_salary",label:"Multiple of Salary"})))),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall"},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["t" /* FormControl */],{fullWidth:true},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_1_components_Wrappers_materialUIWrappers_components_NumberInput__["a" /* default */],suffix:"%",validate:[__WEBPACK_IMPORTED_MODULE_2_helpers_ValidationHelpers__["f" /* percentage */]],checkValidation:props.checkValidation,onChange:function onChange(){return props.forceUpdate();},name:"retirement_fund.group_benifits.death.percent_of_salary",label:"% of Salary"})))),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{padding:"none",className:"cellPaddingSmall"},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],null,"Perm. Disability")),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall"},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],null,__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["t" /* FormControl */],{fullWidth:true},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_1_components_Wrappers_materialUIWrappers_components_NumberInput__["a" /* default */],checkValidation:props.checkValidation,onChange:function onChange(){return props.forceUpdate();},name:"retirement_fund.group_benifits.perm_disability.multiple_of_salary",label:"Multiple of Salary"})))),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall"},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["t" /* FormControl */],{fullWidth:true},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_1_components_Wrappers_materialUIWrappers_components_NumberInput__["a" /* default */],suffix:"%",validate:[__WEBPACK_IMPORTED_MODULE_2_helpers_ValidationHelpers__["f" /* percentage */]],checkValidation:props.checkValidation,onChange:function onChange(){return props.forceUpdate();},name:"retirement_fund.group_benifits.perm_disability.percent_of_salary",label:"% of Salary"})))),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{padding:"none",className:"cellPaddingSmall"},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],null,"Severe Illness")),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall"},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],null,__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["t" /* FormControl */],{fullWidth:true},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_1_components_Wrappers_materialUIWrappers_components_NumberInput__["a" /* default */],checkValidation:props.checkValidation,onChange:function onChange(){return props.forceUpdate();},name:"retirement_fund.group_benifits.severe_illness.multiple_of_salary",label:"Multiple of Salary"})))),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall"}))));};/* harmony default export */ __webpack_exports__["a"] = (GroupBenefits);

/***/ }),
/* 2498 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_core__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_Wrappers_materialUIWrappers_components_NumberInput__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_helpers_ValidationHelpers__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_form__ = __webpack_require__(15);
/*eslint-disable*/var colwidth=function colwidth(value){return{width:value,minWidth:value,maxWidth:value};};var GroupBenefits=function GroupBenefits(props){return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Q" /* Table */],null,__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["T" /* TableHead */],null,__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall",style:colwidth("15em")},"Retirement"),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall",style:colwidth("15em")},"Employee Contribution (%)"),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall",style:colwidth("15em")},"Employer Contribution (%)"),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall",style:colwidth("15em")},"Current Value (R)"))),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["R" /* TableBody */],null,__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall"},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],null,"Provident Fund (if applicable)")),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall"},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["t" /* FormControl */],{fullWidth:true},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_1_components_Wrappers_materialUIWrappers_components_NumberInput__["a" /* default */],suffix:"%",validate:[__WEBPACK_IMPORTED_MODULE_2_helpers_ValidationHelpers__["f" /* percentage */]],checkValidation:props.checkValidation,name:"retirement_fund.retirement.provident_fund.employee_contribution",label:"Employee Contribution"}))),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall"},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["t" /* FormControl */],{fullWidth:true},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_1_components_Wrappers_materialUIWrappers_components_NumberInput__["a" /* default */],suffix:"%",validate:[__WEBPACK_IMPORTED_MODULE_2_helpers_ValidationHelpers__["f" /* percentage */]],checkValidation:props.checkValidation,name:"retirement_fund.retirement.provident_fund.employer_contribution",label:"Employer Contribution"}))),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall"},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["t" /* FormControl */],{fullWidth:true},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_1_components_Wrappers_materialUIWrappers_components_NumberInput__["a" /* default */],prefix:"R",seperator:" ",checkValidation:props.checkValidation,name:"retirement_fund.retirement.provident_fund.current_value",label:"Current Value"})))),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall"},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],null,"Pension Fund (if applicable)")),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall"},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["t" /* FormControl */],{fullWidth:true},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_1_components_Wrappers_materialUIWrappers_components_NumberInput__["a" /* default */],suffix:"%",validate:[__WEBPACK_IMPORTED_MODULE_2_helpers_ValidationHelpers__["f" /* percentage */]],checkValidation:props.checkValidation,name:"retirement_fund.retirement.pension_fund.employee_contribution",label:"Employee Contribution"}))),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall"},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["t" /* FormControl */],{fullWidth:true},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_1_components_Wrappers_materialUIWrappers_components_NumberInput__["a" /* default */],suffix:"%",validate:[__WEBPACK_IMPORTED_MODULE_2_helpers_ValidationHelpers__["f" /* percentage */]],checkValidation:props.checkValidation,name:"retirement_fund.retirement.pension_fund.employer_contribution",label:"Employer Contribution"}))),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall"},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["t" /* FormControl */],{fullWidth:true},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_1_components_Wrappers_materialUIWrappers_components_NumberInput__["a" /* default */],prefix:"R",seperator:" ",checkValidation:props.checkValidation,name:"retirement_fund.retirement.pension_fund.current_value",label:"Current Value"})))),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall"},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],null,"Annual Pensionable Income (if applicable)")),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall"}),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall"}),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall"},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["t" /* FormControl */],{fullWidth:true},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_1_components_Wrappers_materialUIWrappers_components_NumberInput__["a" /* default */],prefix:"R",seperator:" ",checkValidation:props.checkValidation,name:"retirement_fund.annual_pensionable_income",label:"Amount"}))))));};/* harmony default export */ __webpack_exports__["a"] = (GroupBenefits);

/***/ }),
/* 2499 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_core__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_Wrappers_materialUIWrappers_components_NumberInput__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_form__ = __webpack_require__(15);
/*eslint-disable*/var colwidth=function colwidth(value){return{width:value,minWidth:value,maxWidth:value};};var GroupBenefits=function GroupBenefits(props){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Q" /* Table */],{className:"customTable1"},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["T" /* TableHead */],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall",style:colwidth("11em")},"Approved Fund Provisions"),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall",style:colwidth("8em")},"Group Capital"),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall",style:colwidth("8em")},"Provident Capital"),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall",style:colwidth("8em")},"Pension Capital"),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall",style:colwidth("8em")},"Monthly Income"))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["R" /* TableBody */],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall"},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],null,"Death")),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall"},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["t" /* FormControl */],{fullWidth:true},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_1_components_Wrappers_materialUIWrappers_components_NumberInput__["a" /* default */],prefix:"R",seperator:" ",checkValidation:props.checkValidation,name:"retirement_fund.approved_fund_provisions.death.group_capital",label:"Group Capital"}))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall"},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["t" /* FormControl */],{fullWidth:true},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_1_components_Wrappers_materialUIWrappers_components_NumberInput__["a" /* default */],prefix:"R",seperator:" ",checkValidation:props.checkValidation,name:"retirement_fund.approved_fund_provisions.death.provident_capital",label:"Provident Capital"}))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall"},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["t" /* FormControl */],{fullWidth:true},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_1_components_Wrappers_materialUIWrappers_components_NumberInput__["a" /* default */],prefix:"R",seperator:" ",checkValidation:props.checkValidation,name:"retirement_fund.approved_fund_provisions.death.pension_capital",label:"Pension Capital"}))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall"},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["t" /* FormControl */],{fullWidth:true},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_1_components_Wrappers_materialUIWrappers_components_NumberInput__["a" /* default */],prefix:"R",seperator:" ",checkValidation:props.checkValidation,name:"retirement_fund.approved_fund_provisions.death.monthly_income",label:"Monthly Income"})))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall"},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],null,"Perm. Disability")),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall"},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["t" /* FormControl */],{fullWidth:true},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_1_components_Wrappers_materialUIWrappers_components_NumberInput__["a" /* default */],prefix:"R",seperator:" ",checkValidation:props.checkValidation,name:"retirement_fund.approved_fund_provisions.perm_disability.group_capital",label:"Group Capital"}))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall"},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["t" /* FormControl */],{fullWidth:true},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_1_components_Wrappers_materialUIWrappers_components_NumberInput__["a" /* default */],prefix:"R",seperator:" ",checkValidation:props.checkValidation,name:"retirement_fund.approved_fund_provisions.perm_disability.provident_capital",label:"Provident Capital"}))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall"},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["t" /* FormControl */],{fullWidth:true},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_1_components_Wrappers_materialUIWrappers_components_NumberInput__["a" /* default */],prefix:"R",seperator:" ",checkValidation:props.checkValidation,name:"retirement_fund.approved_fund_provisions.perm_disability.pension_capital",label:"Pension Capital"}))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall"},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["t" /* FormControl */],{fullWidth:true},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_1_components_Wrappers_materialUIWrappers_components_NumberInput__["a" /* default */],prefix:"R",seperator:" ",checkValidation:props.checkValidation,name:"retirement_fund.approved_fund_provisions.perm_disability.monthly_income",label:"Monthly Income"})))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall"},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],null,"Severe Illness")),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall"},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["t" /* FormControl */],{fullWidth:true},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_1_components_Wrappers_materialUIWrappers_components_NumberInput__["a" /* default */],prefix:"R",seperator:" ",checkValidation:props.checkValidation,name:"retirement_fund.approved_fund_provisions.severe_illness.group_capital",label:"Group Capital"}))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall"},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["t" /* FormControl */],{fullWidth:true},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_1_components_Wrappers_materialUIWrappers_components_NumberInput__["a" /* default */],prefix:"R",seperator:" ",checkValidation:props.checkValidation,name:"retirement_fund.approved_fund_provisions.severe_illness.provident_capital",label:"Provident Capital"}))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall"},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["t" /* FormControl */],{fullWidth:true},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_1_components_Wrappers_materialUIWrappers_components_NumberInput__["a" /* default */],prefix:"R",seperator:" ",checkValidation:props.checkValidation,name:"retirement_fund.approved_fund_provisions.severe_illness.pension_capital",label:"Pension Capital"}))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall"})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall"},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],null,"Perm. Disability")),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall"},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["t" /* FormControl */],{fullWidth:true},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_1_components_Wrappers_materialUIWrappers_components_NumberInput__["a" /* default */],prefix:"R",seperator:" ",checkValidation:props.checkValidation,name:"retirement_fund.approved_fund_provisions.retirement.group_capital",label:"Group Capital"}))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall"},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["t" /* FormControl */],{fullWidth:true},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_1_components_Wrappers_materialUIWrappers_components_NumberInput__["a" /* default */],prefix:"R",seperator:" ",checkValidation:props.checkValidation,name:"retirement_fund.approved_fund_provisions.retirement.provident_capital",label:"Provident Capital"}))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall"},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["t" /* FormControl */],{fullWidth:true},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_1_components_Wrappers_materialUIWrappers_components_NumberInput__["a" /* default */],prefix:"R",seperator:" ",checkValidation:props.checkValidation,name:"retirement_fund.approved_fund_provisions.retirement.pension_capital",label:"Pension Capital"}))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall"},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["t" /* FormControl */],{fullWidth:true},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_1_components_Wrappers_materialUIWrappers_components_NumberInput__["a" /* default */],prefix:"R",seperator:" ",checkValidation:props.checkValidation,name:"retirement_fund.approved_fund_provisions.retirement.monthly_income",label:"Monthly Income"})))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall"},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],null,"Temp. Disability")),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall"}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall"}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall"}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall"},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["t" /* FormControl */],{fullWidth:true},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_1_components_Wrappers_materialUIWrappers_components_NumberInput__["a" /* default */],prefix:"R",seperator:" ",checkValidation:props.checkValidation,name:"retirement_fund.approved_fund_provisions.temp_disability.monthly_income",label:"Monthly Income"}))))));};/* harmony default export */ __webpack_exports__["a"] = (GroupBenefits);

/***/ }),
/* 2500 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DefaultInit; });
var DefaultInit={//Remember that this only initializes the field values and not the object value. The object values still needs to be initialized in FNA wizzard.
//This should be changed in further updates to simplify the process should a default value change.
marginalTax:45,execFee:3.5,execTax:true,spouseAccrual:true};

/***/ }),
/* 2501 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__progress_kendo_drawing__ = __webpack_require__(636);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__progress_kendo_file_saver__ = __webpack_require__(684);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__getPageMargin__ = __webpack_require__(413);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__KendoDrawingAdapter__ = __webpack_require__(686);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();






/**
 * Represents the KendoReact PDFExport component.
 */
var PDFExport = /** @class */ (function (_super) {
    __extends(PDFExport, _super);
    function PDFExport() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @hidden
     */
    PDFExport.prototype.render = function () {
        var _this = this;
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { ref: function (el) { _this.rootElForPDF = el; } }, this.props.children));
    };
    /**
     * Saves the content as a PDF file.
     *
     * @param callback - The callback to be executed after the PDF is saved.
     */
    PDFExport.prototype.save = function (callback) {
        new __WEBPACK_IMPORTED_MODULE_5__KendoDrawingAdapter__["a" /* default */](__WEBPACK_IMPORTED_MODULE_2__progress_kendo_drawing__["a" /* drawDOM */], __WEBPACK_IMPORTED_MODULE_2__progress_kendo_drawing__["b" /* exportPDF */], __WEBPACK_IMPORTED_MODULE_3__progress_kendo_file_saver__["a" /* saveAs */], this.rootElForPDF, this.getOptions()).savePDF(callback);
    };
    PDFExport.prototype.getOptions = function () {
        return Object.assign({}, this.props, { margin: Object(__WEBPACK_IMPORTED_MODULE_4__getPageMargin__["a" /* getPageMargin */])(this.props) });
    };
    /**
     * @hidden
     */
    PDFExport.propTypes = {
        author: __WEBPACK_IMPORTED_MODULE_1_prop_types__["string"],
        avoidLinks: __WEBPACK_IMPORTED_MODULE_1_prop_types__["oneOfType"]([__WEBPACK_IMPORTED_MODULE_1_prop_types__["bool"], __WEBPACK_IMPORTED_MODULE_1_prop_types__["string"]]),
        forcePageBreak: __WEBPACK_IMPORTED_MODULE_1_prop_types__["string"],
        keepTogether: __WEBPACK_IMPORTED_MODULE_1_prop_types__["string"],
        creator: __WEBPACK_IMPORTED_MODULE_1_prop_types__["string"],
        date: __WEBPACK_IMPORTED_MODULE_1_prop_types__["instanceOf"](Date),
        imageResolution: __WEBPACK_IMPORTED_MODULE_1_prop_types__["number"],
        fileName: __WEBPACK_IMPORTED_MODULE_1_prop_types__["string"],
        forceProxy: __WEBPACK_IMPORTED_MODULE_1_prop_types__["bool"],
        keywords: __WEBPACK_IMPORTED_MODULE_1_prop_types__["string"],
        landscape: __WEBPACK_IMPORTED_MODULE_1_prop_types__["bool"],
        margin: __WEBPACK_IMPORTED_MODULE_1_prop_types__["oneOfType"]([__WEBPACK_IMPORTED_MODULE_1_prop_types__["string"], __WEBPACK_IMPORTED_MODULE_1_prop_types__["number"], __WEBPACK_IMPORTED_MODULE_1_prop_types__["shape"]({
                left: __WEBPACK_IMPORTED_MODULE_1_prop_types__["oneOfType"]([__WEBPACK_IMPORTED_MODULE_1_prop_types__["number"], __WEBPACK_IMPORTED_MODULE_1_prop_types__["string"]]),
                top: __WEBPACK_IMPORTED_MODULE_1_prop_types__["oneOfType"]([__WEBPACK_IMPORTED_MODULE_1_prop_types__["number"], __WEBPACK_IMPORTED_MODULE_1_prop_types__["string"]]),
                right: __WEBPACK_IMPORTED_MODULE_1_prop_types__["oneOfType"]([__WEBPACK_IMPORTED_MODULE_1_prop_types__["number"], __WEBPACK_IMPORTED_MODULE_1_prop_types__["string"]]),
                bottom: __WEBPACK_IMPORTED_MODULE_1_prop_types__["oneOfType"]([__WEBPACK_IMPORTED_MODULE_1_prop_types__["number"], __WEBPACK_IMPORTED_MODULE_1_prop_types__["string"]])
            })]),
        pageTemplate: __WEBPACK_IMPORTED_MODULE_1_prop_types__["any"],
        paperSize: __WEBPACK_IMPORTED_MODULE_1_prop_types__["any"],
        repeatHeaders: __WEBPACK_IMPORTED_MODULE_1_prop_types__["bool"],
        scale: __WEBPACK_IMPORTED_MODULE_1_prop_types__["number"],
        proxyData: __WEBPACK_IMPORTED_MODULE_1_prop_types__["any"],
        proxyURL: __WEBPACK_IMPORTED_MODULE_1_prop_types__["string"],
        proxyTarget: __WEBPACK_IMPORTED_MODULE_1_prop_types__["string"],
        producer: __WEBPACK_IMPORTED_MODULE_1_prop_types__["string"],
        subject: __WEBPACK_IMPORTED_MODULE_1_prop_types__["string"],
        title: __WEBPACK_IMPORTED_MODULE_1_prop_types__["string"]
    };
    return PDFExport;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (PDFExport);
//# sourceMappingURL=PDFExport.js.map

/***/ }),
/* 2502 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = animationFrameProxy;
var wnd = typeof window !== "undefined" ? window : {};

var animationFrame = wnd.requestAnimationFrame ||
                    wnd.webkitRequestAnimationFrame ||
                    wnd.mozRequestAnimationFrame ||
                    wnd.oRequestAnimationFrame ||
                    wnd.msRequestAnimationFrame ||
                    function(callback) { setTimeout(callback, 1000 / 60); };

function animationFrameProxy(callback) {
    animationFrame.call(wnd, callback);
}


/***/ }),
/* 2503 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = htmlEncode;
var ampRegExp = /&/g;
var ltRegExp = /</g;
var quoteRegExp = /"/g;
var aposRegExp = /'/g;
var gtRegExp = />/g;

function htmlEncode(value) {
    return String(value).replace(ampRegExp, "&amp;").replace(ltRegExp, "&lt;").replace(gtRegExp, "&gt;").replace(quoteRegExp, "&quot;").replace(aposRegExp, "&#39;");
}

/***/ }),
/* 2504 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = logToConsole;
/* eslint-disable no-console */

function logToConsole(message) {
    var console = window.console;

    if (typeof(console) != "undefined" && console.log) {
        console.log(message);
    }
}

/***/ }),
/* 2505 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__class__ = __webpack_require__(274);


var Observable = (function (Class) {
    function Observable() {
        Class.call(this);

        this._events = {};
    }

    if ( Class ) Observable.__proto__ = Class;
    Observable.prototype = Object.create( Class && Class.prototype );
    Observable.prototype.constructor = Observable;

    Observable.prototype.bind = function bind (eventName, handlers, one) {
        var arguments$1 = arguments;
        var this$1 = this;

        var eventNames = getArray(eventName);
        var handlersIsFunction = isFunction(handlers);
        var length = eventNames.length;

        if (handlers === undefined) {
            for (var field in eventName) {
                this$1.bind(field, eventName[field]);
            }
            return this;
        }

        var loop = function ( idx ) {
            var eventName$1 = eventNames[idx];

            var handler = handlersIsFunction ? handlers : handlers[eventName$1];

            if (handler) {
                if (one) {
                    var original = handler;
                    handler = function () { // eslint-disable-line no-loop-func
                        this$1.unbind(eventName$1, handler);
                        original.apply(this$1, arguments$1);
                    };
                    handler.original = original;
                }
                var events = this$1._events[eventName$1] = this$1._events[eventName$1] || [];
                events.push(handler);
            }
        };

        for (var idx = 0; idx < length; idx++) loop( idx );

        return this;
    };

    Observable.prototype.one = function one (eventNames, handlers) {
        return this.bind(eventNames, handlers, true);
    };

    Observable.prototype.first = function first (eventName, handlers) {
        var this$1 = this;

        var eventNames = getArray(eventName);
        var handlersIsFunction = isFunction(handlers);

        for (var idx = 0, length = eventNames.length; idx < length; idx++) {
            var eventName$1 = eventNames[idx];

            var handler = handlersIsFunction ? handlers : handlers[eventName$1];

            if (handler) {
                var events = this$1._events[eventName$1] = this$1._events[eventName$1] || [];
                events.unshift(handler);
            }
        }

        return this;
    };

    Observable.prototype.trigger = function trigger (eventName, e) {
        var this$1 = this;
        if ( e === void 0 ) e = {};

        var events = this._events[eventName];

        if (events) {
            var length = events.length;

            e.sender = this;
            e._defaultPrevented = false;
            e.preventDefault = preventDefault;
            e.isDefaultPrevented = isDefaultPrevented;

            events = events.slice();

            for (var idx = 0; idx < length; idx++) {
                events[idx].call(this$1, e);
            }

            return e._defaultPrevented === true;
        }

        return false;
    };

    Observable.prototype.unbind = function unbind (eventName, handler) {
        var events = this._events[eventName];

        if (eventName === undefined) {
            this._events = {};
        } else if (events) {
            if (handler) {
                for (var idx = events.length - 1; idx >= 0; idx--) {
                    if (events[idx] === handler || events[idx].original === handler) {
                        events.splice(idx, 1);
                    }
                }
            } else {
                this._events[eventName] = [];
            }
        }

        return this;
    };

    return Observable;
}(__WEBPACK_IMPORTED_MODULE_0__class__["a" /* default */]));

function isFunction(value) {
    return typeof value === "function";
}

function getArray(value) {
    return typeof value === "string" ? [ value ] : value;
}

function preventDefault() {
    this._defaultPrevented = true;
}

function isDefaultPrevented() {
    return this._defaultPrevented === true;
}

/* harmony default export */ __webpack_exports__["a"] = (Observable);

/***/ }),
/* 2506 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = saveAs;
// XXX: the following will not work with IE9 (requires server proxy).
function saveAs(options) {
    var dataURI = options.dataURI;
    var fileName = options.fileName;
    var data = dataURI;

    if (typeof data == "string" && window.Blob) {
        var parts = data.split(";base64,");
        var contentType = parts[0];
        var base64 = atob(parts[1]);
        var array = new Uint8Array(base64.length);
        for (var idx = 0; idx < base64.length; idx++) {
            array[idx] = base64.charCodeAt(idx);
        }
        data = new Blob([ array.buffer ], { type: contentType });
    }
    if (navigator.msSaveBlob) {
        navigator.msSaveBlob(data, fileName);
    } else {
        var link = document.createElement("a");
        link.download = fileName;
        data = link.href = URL.createObjectURL(data);
        var e = document.createEvent("MouseEvents");
        e.initMouseEvent("click", true, false, window,
                         0, 0, 0, 0, 0, false, false, false, false, 0, null);
        link.dispatchEvent(e);
        setTimeout(function() {
            URL.revokeObjectURL(data);
        });
    }
}

/***/ }),
/* 2507 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = template;
function template() {
    // XXX: no template engine for now
    throw new Error("String template not yet supported.  Pass a function and use your preferred template engine.");
}

/***/ }),
/* 2508 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = throttle;
function now() {
    return new Date().getTime();
}

function throttle(fn, delay) {
    var lastExecTime = 0;
    var timeout;

    if (!delay || delay <= 0) {
        return fn;
    }

    var throttled = function() {
        var elapsed = now() - lastExecTime;
        var args = arguments;

        var exec = function() {
            fn.apply(null, args);
            lastExecTime = now();
        };

        // first execution
        if (!lastExecTime) {
            return exec();
        }

        if (timeout) {
            clearTimeout(timeout);
        }

        if (elapsed > delay) {
            exec();
        } else {
            timeout = setTimeout(exec, delay - elapsed);
        }
    };

    throttled.cancel = function() {
        clearTimeout(timeout);
    };

    return throttled;
}

/***/ }),
/* 2509 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__color_parse_color__ = __webpack_require__(639);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__color_parse_color__["e"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__color_color__ = __webpack_require__(2510);
/* unused harmony reexport Color */



/***/ }),
/* 2510 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__class__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__named_colors__ = __webpack_require__(640);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__parse_color__ = __webpack_require__(639);




var Color = (function (Class) {
    function Color(value) {
        var this$1 = this;

        Class.call(this);

        if (arguments.length === 1) {
            var formats = Color.formats;
            var resolvedColor = this.resolveColor(value);

            for (var idx = 0; idx < formats.length; idx++) {
                var formatRegex = formats[idx].re;
                var processor = formats[idx].process;
                var parts = formatRegex.exec(resolvedColor);

                if (parts) {
                    var channels = processor(parts);
                    this$1.r = channels[0];
                    this$1.g = channels[1];
                    this$1.b = channels[2];
                }
            }
        } else {
            this.r = arguments[0];
            this.g = arguments[1];
            this.b = arguments[2];
        }

        this.r = this.normalizeByte(this.r);
        this.g = this.normalizeByte(this.g);
        this.b = this.normalizeByte(this.b);
    }

    if ( Class ) Color.__proto__ = Class;
    Color.prototype = Object.create( Class && Class.prototype );
    Color.prototype.constructor = Color;

    Color.prototype.toHex = function toHex () {
        var pad = this.padDigit;
        var r = this.r.toString(16);
        var g = this.g.toString(16);
        var b = this.b.toString(16);

        return "#" + pad(r) + pad(g) + pad(b);
    };

    Color.prototype.resolveColor = function resolveColor (value) {
        var color = value || "black";

        if (color.charAt(0) === "#") {
            color = color.substr(1, 6);
        }

        color = color.replace(/ /g, "");
        color = color.toLowerCase();
        color = Color.namedColors[color] || color;

        return color;
    };

    Color.prototype.normalizeByte = function normalizeByte (value) {
        if (value < 0 || isNaN(value)) {
            return 0;
        }

        return value > 255 ? 255 : value;
    };

    Color.prototype.padDigit = function padDigit (value) {
        return (value.length === 1) ? "0" + value : value;
    };

    Color.prototype.brightness = function brightness (value) {
        var round = Math.round;

        this.r = round(this.normalizeByte(this.r * value));
        this.g = round(this.normalizeByte(this.g * value));
        this.b = round(this.normalizeByte(this.b * value));

        return this;
    };

    Color.prototype.percBrightness = function percBrightness () {
        return Math.sqrt(0.241 * this.r * this.r + 0.691 * this.g * this.g + 0.068 * this.b * this.b);
    };

    Color.fromBytes = function fromBytes (r, g, b, a) {
        return new __WEBPACK_IMPORTED_MODULE_2__parse_color__["a" /* Bytes */](r, g, b, a != null ? a : 1);
    };

    Color.fromRGB = function fromRGB (r, g, b, a) {
        return new __WEBPACK_IMPORTED_MODULE_2__parse_color__["d" /* RGB */](r, g, b, a != null ? a : 1);
    };

    Color.fromHSV = function fromHSV (h, s, v, a) {
        return new __WEBPACK_IMPORTED_MODULE_2__parse_color__["c" /* HSV */](h, s, v, a != null ? a : 1);
    };

    Color.fromHSL = function fromHSL (h, s, l, a) {
        return new __WEBPACK_IMPORTED_MODULE_2__parse_color__["b" /* HSL */](h, s, l, a != null ? a : 1);
    };

    return Color;
}(__WEBPACK_IMPORTED_MODULE_0__class__["a" /* default */]));

Color.formats = [ {
    re: /^rgb\((\d{1,3}),\s*(\d{1,3}),\s*(\d{1,3})\)$/,
    process: function(parts) {
        return [
            parseInt(parts[1], 10), parseInt(parts[2], 10), parseInt(parts[3], 10)
        ];
    }
}, {
    re: /^(\w{2})(\w{2})(\w{2})$/,
    process: function(parts) {
        return [
            parseInt(parts[1], 16), parseInt(parts[2], 16), parseInt(parts[3], 16)
        ];
    }
}, {
    re: /^(\w{1})(\w{1})(\w{1})$/,
    process: function(parts) {
        return [
            parseInt(parts[1] + parts[1], 16),
            parseInt(parts[2] + parts[2], 16),
            parseInt(parts[3] + parts[3], 16)
        ];
    }
} ];

Color.namedColors = __WEBPACK_IMPORTED_MODULE_1__named_colors__["a" /* default */];

/* unused harmony default export */ var _unused_webpack_default_export = (Color);

/***/ }),
/* 2511 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = append;
function append(first, second) {
    first.push.apply(first, second);
    return first;
}

/***/ }),
/* 2512 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = arabicToRoman;
/* eslint-disable key-spacing,no-multi-spaces,no-param-reassign */

var literals = {
    1    : "i",       10   : "x",       100  : "c",
    2    : "ii",      20   : "xx",      200  : "cc",
    3    : "iii",     30   : "xxx",     300  : "ccc",
    4    : "iv",      40   : "xl",      400  : "cd",
    5    : "v",       50   : "l",       500  : "d",
    6    : "vi",      60   : "lx",      600  : "dc",
    7    : "vii",     70   : "lxx",     700  : "dcc",
    8    : "viii",    80   : "lxxx",    800  : "dccc",
    9    : "ix",      90   : "xc",      900  : "cm",
    1000 : "m"
};

function arabicToRoman(n) {
    var values = [ 1000,
                   900 , 800, 700, 600, 500, 400, 300, 200, 100,
                   90  , 80 , 70 , 60 , 50 , 40 , 30 , 20 , 10 ,
                   9   , 8  , 7  , 6  , 5  , 4  , 3  , 2  , 1 ];

    var roman = "";
    while (n > 0) {
        if (n < values[0]) {
            values.shift();
        } else {
            roman += literals[values[0]];
            n -= values[0];
        }
    }
    return roman;
}

/***/ }),
/* 2513 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createPromise;
function createPromise() {
    var resolveFn, rejectFn;
    var promise = new Promise(function (resolve, reject) {
        resolveFn = function (data) {
            promise._state = "resolved";
            resolve(data);
            return promise;
        };
        rejectFn = function (data) {
            promise._state = "rejected";
            reject(data);

            return promise;
        };
    });
    promise._state = "pending";
    promise.resolve = resolveFn;
    promise.reject = rejectFn;
    promise.state = function () { return promise._state; };

    return promise;
}


/***/ }),
/* 2514 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = definitionId;
var defId = 1;

function definitionId() {
    return "kdef" + defId++;
}

/***/ }),
/* 2515 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = deg;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(400);


function deg(radians) {
    return radians / __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* DEG_TO_RAD */];
}

/***/ }),
/* 2516 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = encodeBase64;
var KEY_STR = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
var fromCharCode = String.fromCharCode;

function encodeUTF8(input) {
    var output = "";

    for (var i = 0; i < input.length; i++) {
        var c = input.charCodeAt(i);

        if (c < 0x80) {
            // One byte
            output += fromCharCode(c);
        } else if (c < 0x800) {
            // Two bytes
            output += fromCharCode(0xC0 | (c >>> 6));
            output += fromCharCode(0x80 | (c & 0x3f));
        } else if (c < 0x10000) {
            // Three bytes
            output += fromCharCode(0xE0 | (c >>> 12));
            output += fromCharCode(0x80 | (c >>> 6 & 0x3f));
            output += fromCharCode(0x80 | (c & 0x3f));
        }
    }

    return output;
}

function encodeBase64(input) {
    var output = "";
    var i = 0;

    var utfInput = encodeUTF8(input);

    while (i < utfInput.length) {
        var chr1 = utfInput.charCodeAt(i++);
        var chr2 = utfInput.charCodeAt(i++);
        var chr3 = utfInput.charCodeAt(i++);

        var enc1 = chr1 >> 2;
        var enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
        var enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
        var enc4 = chr3 & 63;

        if (isNaN(chr2)) {
            enc3 = enc4 = 64;
        } else if (isNaN(chr3)) {
            enc4 = 64;
        }

        output = output +
            KEY_STR.charAt(enc1) + KEY_STR.charAt(enc2) +
            KEY_STR.charAt(enc3) + KEY_STR.charAt(enc4);
    }

    return output;
}

/***/ }),
/* 2517 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = eventCoordinates;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__defined__ = __webpack_require__(199);


function eventCoordinates(e) {
    if (Object(__WEBPACK_IMPORTED_MODULE_0__defined__["a" /* default */])((e.x || {}).location)) {
        return {
            x: e.x.location,
            y: e.y.location
        };
    }

    return {
        x: e.pageX || e.clientX || 0,
        y: e.pageY || e.clientY || 0
    };
}

/***/ }),
/* 2518 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = eventElement;
function eventElement(e) {
    if ( e === void 0 ) e = {};

    return e.touch ? e.touch.initialTouch : e.target;
}

/***/ }),
/* 2519 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isTransparent;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__defined__ = __webpack_require__(199);


function isTransparent(color) {
    return color === "" || color === null || color === "none" || color === "transparent" || !Object(__WEBPACK_IMPORTED_MODULE_0__defined__["a" /* default */])(color);
}

/***/ }),
/* 2520 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = last;
function last(array) {
    if (array) {
        return array[array.length - 1];
    }
}

/***/ }),
/* 2521 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = limitValue;
function limitValue(value, min, max) {
    return Math.max(Math.min(value, max), min);
}

/***/ }),
/* 2522 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = mergeSort;
/* eslint-disable no-multi-spaces, key-spacing, indent, camelcase, space-before-blocks, eqeqeq, brace-style */
/* eslint-disable space-infix-ops, space-before-function-paren, array-bracket-spacing, object-curly-spacing */
/* eslint-disable no-nested-ternary, max-params, default-case, no-else-return, no-empty */
/* eslint-disable no-param-reassign, no-var, block-scoped-var */

// mergeSort is stable.
function mergeSort(a, cmp) {
    if (a.length < 2) {
        return a.slice();
    }
    function merge(a, b) {
        var r = [], ai = 0, bi = 0, i = 0;
        while (ai < a.length && bi < b.length) {
            if (cmp(a[ai], b[bi]) <= 0) {
                r[i++] = a[ai++];
            } else {
                r[i++] = b[bi++];
            }
        }
        if (ai < a.length) {
            r.push.apply(r, a.slice(ai));
        }
        if (bi < b.length) {
            r.push.apply(r, b.slice(bi));
        }
        return r;
    }
    return (function sort(a) {
        if (a.length <= 1) {
            return a;
        }
        var m = Math.floor(a.length / 2);
        var left = a.slice(0, m);
        var right = a.slice(m);
        left = sort(left);
        right = sort(right);
        return merge(left, right);
    })(a);
}

/***/ }),
/* 2523 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = promiseAll;
function promiseAll(promises) {
    return Promise.all(promises);
}

/***/ }),
/* 2524 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = rad;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(400);


function rad(degrees) {
    return degrees * __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* DEG_TO_RAD */];
}


/***/ }),
/* 2525 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = round;
function pow(p) {
    if (p) {
        return Math.pow(10, p);
    }

    return 1;
}

function round(value, precision) {
    var power = pow(precision);
    return Math.round(value * power) / power;
}

/***/ }),
/* 2526 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = valueOrDefault;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__defined__ = __webpack_require__(199);


function valueOrDefault(value, defaultValue) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__defined__["a" /* default */])(value) ? value : defaultValue;
}

/***/ }),
/* 2527 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = bindEvents;
function bindEvents(element, events) {
    for (var eventName in events) {
        var eventNames = eventName.trim().split(" ");
        for (var idx = 0; idx < eventNames.length; idx++) {
            element.addEventListener(eventNames[idx], events[eventName], false);
        }
    }
}

/***/ }),
/* 2528 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = elementOffset;
function elementOffset(element) {
    var box = element.getBoundingClientRect();

    var documentElement = document.documentElement;

    return {
        top: box.top + (window.pageYOffset || documentElement.scrollTop) - (documentElement.clientTop || 0),
        left: box.left + (window.pageXOffset || documentElement.scrollLeft) - (documentElement.clientLeft || 0)
    };
}

/***/ }),
/* 2529 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = elementSize;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__element_styles__ = __webpack_require__(641);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__defined__ = __webpack_require__(199);



function getPixels(value) {
    if (isNaN(value)) {
        return value;
    }
    return value + "px";
}

function elementSize(element, size) {
    if (size) {
        var width = size.width;
        var height = size.height;

        if (Object(__WEBPACK_IMPORTED_MODULE_1__defined__["a" /* default */])(width)) {
            element.style.width = getPixels(width);
        }

        if (Object(__WEBPACK_IMPORTED_MODULE_1__defined__["a" /* default */])(height)) {
            element.style.height = getPixels(height);
        }

    } else {
        var size$1 = Object(__WEBPACK_IMPORTED_MODULE_0__element_styles__["a" /* default */])(element, [ 'width', 'height' ]);

        return {
            width: parseInt(size$1.width, 10),
            height: parseInt(size$1.height, 10)
        };
    }
}

/***/ }),
/* 2530 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = unbindEvents;
function unbindEvents(element, events) {
    if ( events === void 0 ) events = {};

    for (var name in events) {
        var eventNames = name.trim().split(" ");
        for (var idx = 0; idx < eventNames.length; idx++) {
            element.removeEventListener(eventNames[idx], events[name], false);
        }
    }
}

/***/ }),
/* 2531 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = measureText;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__text_metrics__ = __webpack_require__(644);


function measureText(text, style, measureBox) {
    return __WEBPACK_IMPORTED_MODULE_0__text_metrics__["a" /* default */].current.measure(text, style, measureBox);
}


/***/ }),
/* 2532 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__geometry_circle__ = __webpack_require__(647);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_paintable__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_measurable__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__accessors_define_geometry_accessors__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__element__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util__ = __webpack_require__(22);







var DEFAULT_STROKE = "#000";

var Circle = (function (Element) {
    function Circle(geometry, options) {
        if ( geometry === void 0 ) geometry = new __WEBPACK_IMPORTED_MODULE_0__geometry_circle__["a" /* default */]();
        if ( options === void 0 ) options = {};

        Element.call(this, options);
        this.geometry(geometry);

        if (!Object(__WEBPACK_IMPORTED_MODULE_5__util__["g" /* defined */])(this.options.stroke)) {
            this.stroke(DEFAULT_STROKE);
        }
    }

    if ( Element ) Circle.__proto__ = Element;
    Circle.prototype = Object.create( Element && Element.prototype );
    Circle.prototype.constructor = Circle;

    Circle.prototype.rawBBox = function rawBBox () {
        return this._geometry.bbox();
    };

    Circle.prototype._bbox = function _bbox (matrix) {
        return this._geometry.bbox(matrix);
    };

    Circle.prototype._containsPoint = function _containsPoint (point) {
        return this.geometry().containsPoint(point);
    };

    Circle.prototype._isOnPath = function _isOnPath (point) {
        return this.geometry()._isOnPath(point, this.options.stroke.width / 2);
    };

    return Circle;
}(__WEBPACK_IMPORTED_MODULE_4__element__["a" /* default */]));

Circle.prototype.nodeType = "Circle";

__WEBPACK_IMPORTED_MODULE_1__mixins_paintable__["a" /* default */].extend(Circle.prototype);
__WEBPACK_IMPORTED_MODULE_2__mixins_measurable__["a" /* default */].extend(Circle.prototype);
Object(__WEBPACK_IMPORTED_MODULE_3__accessors_define_geometry_accessors__["a" /* default */])(Circle.prototype, [ "geometry" ]);

/* harmony default export */ __webpack_exports__["a"] = (Circle);

/***/ }),
/* 2533 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__geometry_arc__ = __webpack_require__(401);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__element__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__path__ = __webpack_require__(402);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_paintable__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_measurable__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__accessors_define_geometry_accessors__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util__ = __webpack_require__(22);








var DEFAULT_STROKE = "#000";

var Arc = (function (Element) {
    function Arc(geometry, options) {
        if ( geometry === void 0 ) geometry = new __WEBPACK_IMPORTED_MODULE_0__geometry_arc__["a" /* default */]();
        if ( options === void 0 ) options = {};

        Element.call(this, options);

        this.geometry(geometry);

        if (!Object(__WEBPACK_IMPORTED_MODULE_6__util__["g" /* defined */])(this.options.stroke)) {
            this.stroke(DEFAULT_STROKE);
        }
    }

    if ( Element ) Arc.__proto__ = Element;
    Arc.prototype = Object.create( Element && Element.prototype );
    Arc.prototype.constructor = Arc;

    Arc.prototype._bbox = function _bbox (matrix) {
        return this._geometry.bbox(matrix);
    };

    Arc.prototype.rawBBox = function rawBBox () {
        return this.geometry().bbox();
    };

    Arc.prototype.toPath = function toPath () {
        var path = new __WEBPACK_IMPORTED_MODULE_2__path__["a" /* default */]();
        var curvePoints = this.geometry().curvePoints();

        if (curvePoints.length > 0) {
            path.moveTo(curvePoints[0].x, curvePoints[0].y);

            for (var i = 1; i < curvePoints.length; i += 3) {
                path.curveTo(curvePoints[i], curvePoints[i + 1], curvePoints[i + 2]);
            }
        }

        return path;
    };

    Arc.prototype._containsPoint = function _containsPoint (point) {
        return this.geometry().containsPoint(point);
    };

    Arc.prototype._isOnPath = function _isOnPath (point) {
        return this.geometry()._isOnPath(point, this.options.stroke.width / 2);
    };

    return Arc;
}(__WEBPACK_IMPORTED_MODULE_1__element__["a" /* default */]));

Arc.prototype.nodeType = "Arc";

__WEBPACK_IMPORTED_MODULE_3__mixins_paintable__["a" /* default */].extend(Arc.prototype);
__WEBPACK_IMPORTED_MODULE_4__mixins_measurable__["a" /* default */].extend(Arc.prototype);
Object(__WEBPACK_IMPORTED_MODULE_5__accessors_define_geometry_accessors__["a" /* default */])(Arc.prototype, [ "geometry" ]);

/* unused harmony default export */ var _unused_webpack_default_export = (Arc);

/***/ }),
/* 2534 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = closeOrLess;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__close__ = __webpack_require__(649);


function closeOrLess(a, b, tolerance) {
    return a < b || Object(__WEBPACK_IMPORTED_MODULE_0__close__["a" /* default */])(a, b, tolerance);
}

/***/ }),
/* 2535 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = lineIntersection;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__point__ = __webpack_require__(42);


function lineIntersection(p0, p1, p2, p3) {
    var s1x = p1.x - p0.x;
    var s2x = p3.x - p2.x;
    var s1y = p1.y - p0.y;
    var s2y = p3.y - p2.y;
    var nx = p0.x - p2.x;
    var ny = p0.y - p2.y;
    var d = s1x * s2y - s2x * s1y;
    var s = (s1x * ny - s1y * nx) / d;
    var t = (s2x * ny - s2y * nx) / d;

    if (s >= 0 && s <= 1 && t >= 0 && t <= 1) {
        return new __WEBPACK_IMPORTED_MODULE_0__point__["a" /* default */](p0.x + t * s1x, p0.y + t * s1y);
    }
}

/***/ }),
/* 2536 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isOutOfEndPoint;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__transform__ = __webpack_require__(85);



function isOutOfEndPoint(endPoint, controlPoint, point) {
    var angle = Object(__WEBPACK_IMPORTED_MODULE_0__util__["i" /* deg */])(Math.atan2(controlPoint.y - endPoint.y, controlPoint.x - endPoint.x));
    var rotatedPoint = point.transformCopy(Object(__WEBPACK_IMPORTED_MODULE_1__transform__["a" /* default */])().rotate(-angle, endPoint));

    return rotatedPoint.x < endPoint.x;
}

/***/ }),
/* 2537 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = hasRootsInRange;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__to_cubic_polynomial__ = __webpack_require__(653);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__solve_cubic_equation__ = __webpack_require__(654);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__calculate_curve_at__ = __webpack_require__(403);




function hasRootsInRange(points, point, field, rootField, range) {
    var polynomial = Object(__WEBPACK_IMPORTED_MODULE_0__to_cubic_polynomial__["a" /* default */])(points, rootField);
    var roots = Object(__WEBPACK_IMPORTED_MODULE_1__solve_cubic_equation__["a" /* default */])(polynomial[0], polynomial[1], polynomial[2], polynomial[3] - point[rootField]);
    var intersection;

    for (var idx = 0; idx < roots.length; idx++) {
        if (0 <= roots[idx] && roots[idx] <= 1) {
            intersection = Object(__WEBPACK_IMPORTED_MODULE_2__calculate_curve_at__["a" /* default */])(roots[idx], field, points);
            if (Math.abs(intersection - point[field]) <= range) {
                return true;
            }
        }
    }
}

/***/ }),
/* 2538 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util__ = __webpack_require__(22);




var ComplexNumber = (function (Class) {
    function ComplexNumber(real, img) {
        if ( real === void 0 ) real = 0;
        if ( img === void 0 ) img = 0;

        Class.call(this);

        this.real = real;
        this.img = img;
    }

    if ( Class ) ComplexNumber.__proto__ = Class;
    ComplexNumber.prototype = Object.create( Class && Class.prototype );
    ComplexNumber.prototype.constructor = ComplexNumber;

    ComplexNumber.prototype.add = function add (cNumber) {
        return new ComplexNumber(Object(__WEBPACK_IMPORTED_MODULE_2__util__["w" /* round */])(this.real + cNumber.real, __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* PRECISION */]), Object(__WEBPACK_IMPORTED_MODULE_2__util__["w" /* round */])(this.img + cNumber.img, __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* PRECISION */]));
    };

    ComplexNumber.prototype.addConstant = function addConstant (value) {
        return new ComplexNumber(this.real + value, this.img);
    };

    ComplexNumber.prototype.negate = function negate () {
        return new ComplexNumber(-this.real, -this.img);
    };

    ComplexNumber.prototype.multiply = function multiply (cNumber) {
        return new ComplexNumber(this.real * cNumber.real - this.img * cNumber.img,
            this.real * cNumber.img + this.img * cNumber.real);
    };

    ComplexNumber.prototype.multiplyConstant = function multiplyConstant (value) {
        return new ComplexNumber(this.real * value, this.img * value);
    };

    ComplexNumber.prototype.nthRoot = function nthRoot (n) {
        var rad = Math.atan2(this.img, this.real);
        var r = Math.sqrt(Math.pow(this.img, 2) + Math.pow(this.real, 2));
        var nthR = Math.pow(r, 1 / n);

        return new ComplexNumber(nthR * Math.cos(rad / n), nthR * Math.sin(rad / n)); //Moivre's formula
    };

    ComplexNumber.prototype.equals = function equals (cNumber) {
        return this.real === cNumber.real && this.img === cNumber.img;
    };

    ComplexNumber.prototype.isReal = function isReal () {
        return this.img === 0;
    };

    return ComplexNumber;
}(__WEBPACK_IMPORTED_MODULE_1__common__["a" /* Class */]));

/* harmony default export */ __webpack_exports__["a"] = (ComplexNumber);

/***/ }),
/* 2539 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = curveIntersectionsCount;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__to_cubic_polynomial__ = __webpack_require__(653);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__solve_cubic_equation__ = __webpack_require__(654);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__calculate_curve_at__ = __webpack_require__(403);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__close__ = __webpack_require__(649);





function curveIntersectionsCount(points, point, bbox) {
    var polynomial = Object(__WEBPACK_IMPORTED_MODULE_0__to_cubic_polynomial__["a" /* default */])(points, "x");
    var roots = Object(__WEBPACK_IMPORTED_MODULE_1__solve_cubic_equation__["a" /* default */])(polynomial[0], polynomial[1], polynomial[2], polynomial[3] - point.x);
    var rayIntersection, intersectsRay;
    var count = 0;
    for (var i = 0; i < roots.length; i++) {
        rayIntersection = Object(__WEBPACK_IMPORTED_MODULE_2__calculate_curve_at__["a" /* default */])(roots[i], "y", points);
        intersectsRay = Object(__WEBPACK_IMPORTED_MODULE_3__close__["a" /* default */])(rayIntersection, point.y) || rayIntersection > point.y;
        if (intersectsRay && (((roots[i] === 0 || roots[i] === 1) && bbox.bottomRight().x > point.x) || (0 < roots[i] && roots[i] < 1))) {
            count++;
        }
    }

    return count;
}

/***/ }),
/* 2540 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__geometry_point__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__(22);



var ShapeMap = {
    l: function(path, options) {
        var parameters = options.parameters;
        var position = options.position;

        for (var i = 0; i < parameters.length; i += 2) {
            var point = new __WEBPACK_IMPORTED_MODULE_0__geometry_point__["a" /* default */](parameters[i], parameters[i + 1]);

            if (options.isRelative) {
                point.translateWith(position);
            }

            path.lineTo(point.x, point.y);

            position.x = point.x;
            position.y = point.y;
        }
    },

    c: function(path, options) {
        var parameters = options.parameters;
        var position = options.position;

        for (var i = 0; i < parameters.length; i += 6) {
            var controlOut = new __WEBPACK_IMPORTED_MODULE_0__geometry_point__["a" /* default */](parameters[i], parameters[i + 1]);
            var controlIn = new __WEBPACK_IMPORTED_MODULE_0__geometry_point__["a" /* default */](parameters[i + 2], parameters[i + 3]);
            var point = new __WEBPACK_IMPORTED_MODULE_0__geometry_point__["a" /* default */](parameters[i + 4], parameters[i + 5]);
            if (options.isRelative) {
                controlIn.translateWith(position);
                controlOut.translateWith(position);
                point.translateWith(position);
            }

            path.curveTo(controlOut, controlIn, point);

            position.x = point.x;
            position.y = point.y;
        }
    },

    v: function(path, options) {
        var value = options.isRelative ? 0 : options.position.x;

        toLineParamaters(options.parameters, true, value);
        this.l(path, options);
    },

    h: function(path, options) {
        var value = options.isRelative ? 0 : options.position.y;

        toLineParamaters(options.parameters, false, value);
        this.l(path, options);
    },

    a: function(path, options) {
        var parameters = options.parameters;
        var position = options.position;

        for (var i = 0; i < parameters.length; i += 7) {
            var radiusX = parameters[i];
            var radiusY = parameters[i + 1];
            var rotation = parameters[i + 2];
            var largeArc = parameters[i + 3];
            var swipe = parameters[i + 4];
            var endPoint = new __WEBPACK_IMPORTED_MODULE_0__geometry_point__["a" /* default */](parameters[i + 5], parameters[i + 6]);

            if (options.isRelative) {
                endPoint.translateWith(position);
            }
            if (position.x !== endPoint.x || position.y !== endPoint.y) {
                path.arcTo(endPoint, radiusX, radiusY, largeArc, swipe, rotation);

                position.x = endPoint.x;
                position.y = endPoint.y;
            }
        }
    },

    s: function(path, options) {
        var parameters = options.parameters;
        var position = options.position;
        var previousCommand = options.previousCommand;
        var lastControlIn;

        if (previousCommand === "s" || previousCommand === "c") {
            lastControlIn = Object(__WEBPACK_IMPORTED_MODULE_1__util__["q" /* last */])(Object(__WEBPACK_IMPORTED_MODULE_1__util__["q" /* last */])(path.paths).segments).controlIn();
        }

        for (var i = 0; i < parameters.length; i += 4) {
            var controlIn = new __WEBPACK_IMPORTED_MODULE_0__geometry_point__["a" /* default */](parameters[i], parameters[i + 1]);
            var endPoint = new __WEBPACK_IMPORTED_MODULE_0__geometry_point__["a" /* default */](parameters[i + 2], parameters[i + 3]);
            var controlOut = (void 0);

            if (options.isRelative) {
                controlIn.translateWith(position);
                endPoint.translateWith(position);
            }

            if (lastControlIn) {
                controlOut = reflectionPoint(lastControlIn, position);
            } else {
                controlOut = position.clone();
            }

            lastControlIn = controlIn;

            path.curveTo(controlOut, controlIn, endPoint);

            position.x = endPoint.x;
            position.y = endPoint.y;
        }
    },

    q: function(path, options) {
        var parameters = options.parameters;
        var position = options.position;

        for (var i = 0; i < parameters.length; i += 4) {
            var controlPoint = new __WEBPACK_IMPORTED_MODULE_0__geometry_point__["a" /* default */](parameters[i], parameters[i + 1]);
            var endPoint = new __WEBPACK_IMPORTED_MODULE_0__geometry_point__["a" /* default */](parameters[i + 2], parameters[i + 3]);

            if (options.isRelative) {
                controlPoint.translateWith(position);
                endPoint.translateWith(position);
            }

            var cubicControlPoints = quadraticToCubicControlPoints(position, controlPoint, endPoint);

            path.curveTo(cubicControlPoints.controlOut, cubicControlPoints.controlIn, endPoint);

            position.x = endPoint.x;
            position.y = endPoint.y;
        }
    },

    t: function(path, options) {
        var parameters = options.parameters;
        var position = options.position;
        var previousCommand = options.previousCommand;
        var controlPoint;

        if (previousCommand === "q" || previousCommand === "t") {
            var lastSegment = Object(__WEBPACK_IMPORTED_MODULE_1__util__["q" /* last */])(Object(__WEBPACK_IMPORTED_MODULE_1__util__["q" /* last */])(path.paths).segments);
            controlPoint = lastSegment.controlIn().clone()
                .translateWith(position.scaleCopy(-1 / 3))
                .scale(3 / 2);
        }

        for (var i = 0; i < parameters.length; i += 2) {
            var endPoint = new __WEBPACK_IMPORTED_MODULE_0__geometry_point__["a" /* default */](parameters[i], parameters[i + 1]);
            if (options.isRelative) {
                endPoint.translateWith(position);
            }

            if (controlPoint) {
                controlPoint = reflectionPoint(controlPoint, position);
            } else {
                controlPoint = position.clone();
            }

            var cubicControlPoints = quadraticToCubicControlPoints(position, controlPoint, endPoint);

            path.curveTo(cubicControlPoints.controlOut, cubicControlPoints.controlIn, endPoint);

            position.x = endPoint.x;
            position.y = endPoint.y;
        }
    }
};

function toLineParamaters(parameters, isVertical, value) {
    var insertPosition = isVertical ? 0 : 1;

    for (var i = 0; i < parameters.length; i += 2) {
        parameters.splice(i + insertPosition, 0, value);
    }
}

function reflectionPoint(point, center) {
    if (point && center) {
        return center.scaleCopy(2).translate(-point.x, -point.y);
    }
}

var third = 1 / 3;

function quadraticToCubicControlPoints(position, controlPoint, endPoint) {
    var scaledPoint = controlPoint.clone().scale(2 / 3);
    return {
        controlOut: scaledPoint.clone().translateWith(position.scaleCopy(third)),
        controlIn: scaledPoint.translateWith(endPoint.scaleCopy(third))
    };
}

/* harmony default export */ __webpack_exports__["a"] = (ShapeMap);

/***/ }),
/* 2541 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__element__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__geometry_point__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__geometry_rect__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__geometry_to_matrix__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_paintable__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__accessors_define_point_accessors__ = __webpack_require__(279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util__ = __webpack_require__(22);








var DEFAULT_FONT = "12px sans-serif";
var DEFAULT_FILL = "#000";

var Text = (function (Element) {
    function Text(content, position, options) {
        if ( position === void 0 ) position = new __WEBPACK_IMPORTED_MODULE_1__geometry_point__["a" /* default */]();
        if ( options === void 0 ) options = {};

        Element.call(this, options);

        this.content(content);
        this.position(position);

        if (!this.options.font) {
            this.options.font = DEFAULT_FONT;
        }

        if (!Object(__WEBPACK_IMPORTED_MODULE_6__util__["g" /* defined */])(this.options.fill)) {
            this.fill(DEFAULT_FILL);
        }
    }

    if ( Element ) Text.__proto__ = Element;
    Text.prototype = Object.create( Element && Element.prototype );
    Text.prototype.constructor = Text;

    Text.prototype.content = function content (value) {
        if (Object(__WEBPACK_IMPORTED_MODULE_6__util__["g" /* defined */])(value)) {
            this.options.set("content", value);
            return this;
        }

        return this.options.get("content");
    };

    Text.prototype.measure = function measure () {
        var metrics = Object(__WEBPACK_IMPORTED_MODULE_6__util__["s" /* measureText */])(this.content(), {
            font: this.options.get("font")
        });

        return metrics;
    };

    Text.prototype.rect = function rect () {
        var size = this.measure();
        var pos = this.position().clone();
        return new __WEBPACK_IMPORTED_MODULE_2__geometry_rect__["a" /* default */](pos, [ size.width, size.height ]);
    };

    Text.prototype.bbox = function bbox (transformation) {
        var combinedMatrix = Object(__WEBPACK_IMPORTED_MODULE_3__geometry_to_matrix__["a" /* default */])(this.currentTransform(transformation));
        return this.rect().bbox(combinedMatrix);
    };

    Text.prototype.rawBBox = function rawBBox () {
        return this.rect().bbox();
    };

    Text.prototype._containsPoint = function _containsPoint (point) {
        return this.rect().containsPoint(point);
    };

    return Text;
}(__WEBPACK_IMPORTED_MODULE_0__element__["a" /* default */]));

Text.prototype.nodeType = "Text";

__WEBPACK_IMPORTED_MODULE_4__mixins_paintable__["a" /* default */].extend(Text.prototype);

Object(__WEBPACK_IMPORTED_MODULE_5__accessors_define_point_accessors__["a" /* default */])(Text.prototype, [ "position" ]);

/* harmony default export */ __webpack_exports__["a"] = (Text);

/***/ }),
/* 2542 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__accessors_define_geometry_accessors__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__element__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__geometry_rect__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__geometry_to_matrix__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util__ = __webpack_require__(22);






var Image = (function (Element) {
    function Image(src, rect, options) {
        if ( rect === void 0 ) rect = new __WEBPACK_IMPORTED_MODULE_2__geometry_rect__["a" /* default */]();
        if ( options === void 0 ) options = {};

        Element.call(this, options);

        this.src(src);
        this.rect(rect);
    }

    if ( Element ) Image.__proto__ = Element;
    Image.prototype = Object.create( Element && Element.prototype );
    Image.prototype.constructor = Image;

    Image.prototype.src = function src (value) {
        if (Object(__WEBPACK_IMPORTED_MODULE_4__util__["g" /* defined */])(value)) {
            this.options.set("src", value);
            return this;
        }

        return this.options.get("src");
    };

    Image.prototype.bbox = function bbox (transformation) {
        var combinedMatrix = Object(__WEBPACK_IMPORTED_MODULE_3__geometry_to_matrix__["a" /* default */])(this.currentTransform(transformation));
        return this._rect.bbox(combinedMatrix);
    };

    Image.prototype.rawBBox = function rawBBox () {
        return this._rect.bbox();
    };

    Image.prototype._containsPoint = function _containsPoint (point) {
        return this._rect.containsPoint(point);
    };

    Image.prototype._hasFill = function _hasFill () {
        return this.src();
    };

    return Image;
}(__WEBPACK_IMPORTED_MODULE_1__element__["a" /* default */]));

Image.prototype.nodeType = "Image";

Object(__WEBPACK_IMPORTED_MODULE_0__accessors_define_geometry_accessors__["a" /* default */])(Image.prototype, [ "rect" ]);

/* harmony default export */ __webpack_exports__["a"] = (Image);

/***/ }),
/* 2543 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__group__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__geometry_size__ = __webpack_require__(276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__geometry_rect__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__geometry_point__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__geometry_transform__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__alignment_translate_to_point__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__alignment_align_start__ = __webpack_require__(660);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__alignment_align_start_reverse__ = __webpack_require__(2544);









var DEFAULT_OPTIONS = {
    alignContent: "start",
    justifyContent: "start",
    alignItems: "start",
    spacing: 0,
    orientation: "horizontal",
    lineSpacing: 0,
    wrap: true,
    revers: false
};

var forEach = function (elements, callback) {
    elements.forEach(callback);
};

var forEachReverse = function (elements, callback) {
    var length = elements.length;

    for (var idx = length - 1; idx >= 0; idx--) {
        callback(elements[idx], idx);
    }
};

var Layout = (function (Group) {
    function Layout(rect, options) {
        Group.call(this, Object.assign({}, DEFAULT_OPTIONS, options));
        this._rect = rect;
        this._fieldMap = {};
    }

    if ( Group ) Layout.__proto__ = Group;
    Layout.prototype = Object.create( Group && Group.prototype );
    Layout.prototype.constructor = Layout;

    Layout.prototype.rect = function rect (value) {
        if (value) {
            this._rect = value;
            return this;
        }

        return this._rect;
    };

    Layout.prototype._initMap = function _initMap () {
        var options = this.options;
        var fieldMap = this._fieldMap;
        if (options.orientation === "horizontal") {
            fieldMap.sizeField = "width";
            fieldMap.groupsSizeField = "height";
            fieldMap.groupAxis = "x";
            fieldMap.groupsAxis = "y";
        } else {
            fieldMap.sizeField = "height";
            fieldMap.groupsSizeField = "width";
            fieldMap.groupAxis = "y";
            fieldMap.groupsAxis = "x";
        }

        if (options.reverse) {
            this.forEach = forEachReverse;
            this.justifyAlign = __WEBPACK_IMPORTED_MODULE_7__alignment_align_start_reverse__["a" /* default */];
        } else {
            this.forEach = forEach;
            this.justifyAlign = __WEBPACK_IMPORTED_MODULE_6__alignment_align_start__["a" /* default */];
        }
    };

    Layout.prototype.reflow = function reflow () {
        var this$1 = this;

        if (!this._rect || this.children.length === 0) {
            return;
        }
        this._initMap();

        if (this.options.transform) {
            this.transform(null);
        }

        var options = this.options;
        var rect = this._rect;
        var ref = this._initGroups();
        var groups = ref.groups;
        var groupsSize = ref.groupsSize;
        var ref$1 = this._fieldMap;
        var sizeField = ref$1.sizeField;
        var groupsSizeField = ref$1.groupsSizeField;
        var groupAxis = ref$1.groupAxis;
        var groupsAxis = ref$1.groupsAxis;
        var groupOrigin = new __WEBPACK_IMPORTED_MODULE_3__geometry_point__["a" /* default */]();
        var elementOrigin = new __WEBPACK_IMPORTED_MODULE_3__geometry_point__["a" /* default */]();
        var size = new __WEBPACK_IMPORTED_MODULE_1__geometry_size__["a" /* default */]();
        var groupStart = Object(__WEBPACK_IMPORTED_MODULE_6__alignment_align_start__["a" /* default */])(groupsSize, rect, options.alignContent, groupsAxis, groupsSizeField);
        var elementStart, group, groupBox;

        var arrangeElements = function (bbox, idx) {
            var element = group.elements[idx];

            elementOrigin[groupAxis] = elementStart;
            elementOrigin[groupsAxis] = Object(__WEBPACK_IMPORTED_MODULE_6__alignment_align_start__["a" /* default */])(bbox.size[groupsSizeField], groupBox, options.alignItems, groupsAxis, groupsSizeField);
            Object(__WEBPACK_IMPORTED_MODULE_5__alignment_translate_to_point__["a" /* default */])(elementOrigin, bbox, element);
            elementStart += bbox.size[sizeField] + options.spacing;
        };

        for (var groupIdx = 0; groupIdx < groups.length; groupIdx++) {
            group = groups[groupIdx];
            groupOrigin[groupAxis] = elementStart = this$1.justifyAlign(group.size, rect, options.justifyContent, groupAxis, sizeField);
            groupOrigin[groupsAxis] = groupStart;
            size[sizeField] = group.size;
            size[groupsSizeField] = group.lineSize;
            groupBox = new __WEBPACK_IMPORTED_MODULE_2__geometry_rect__["a" /* default */](groupOrigin, size);
            this$1.forEach(group.bboxes, arrangeElements);

            groupStart += group.lineSize + options.lineSpacing;
        }

        if (!options.wrap && group.size > rect.size[sizeField]) {
            var scale = rect.size[sizeField] / groupBox.size[sizeField];
            var scaledStart = groupBox.topLeft().scale(scale, scale);
            var scaledSize = groupBox.size[groupsSizeField] * scale;
            var newStart = Object(__WEBPACK_IMPORTED_MODULE_6__alignment_align_start__["a" /* default */])(scaledSize, rect, options.alignContent, groupsAxis, groupsSizeField);
            var transform = Object(__WEBPACK_IMPORTED_MODULE_4__geometry_transform__["a" /* default */])();
            if (groupAxis === "x") {
                transform.translate(rect.origin.x - scaledStart.x, newStart - scaledStart.y);
            } else {
                transform.translate(newStart - scaledStart.x, rect.origin.y - scaledStart.y);
            }
            transform.scale(scale, scale);

            this.transform(transform);
        }
    };

    Layout.prototype._initGroups = function _initGroups () {
        var this$1 = this;

        var ref = this;
        var options = ref.options;
        var children = ref.children;
        var lineSpacing = options.lineSpacing;
        var wrap = options.wrap;
        var spacing = options.spacing;
        var sizeField = this._fieldMap.sizeField;
        var group = this._newGroup();
        var groups = [];
        var addGroup = function() {
            groups.push(group);
            groupsSize += group.lineSize + lineSpacing;
        };
        var groupsSize = -lineSpacing;

        for (var idx = 0; idx < children.length; idx++) {
            var element = children[idx];
            var bbox = children[idx].clippedBBox();
            if (element.visible() && bbox) {
                if (wrap && group.size + bbox.size[sizeField] + spacing > this$1._rect.size[sizeField]) {
                    if (group.bboxes.length === 0) {
                        this$1._addToGroup(group, bbox, element);
                        addGroup();
                        group = this$1._newGroup();
                    } else {
                        addGroup();
                        group = this$1._newGroup();
                        this$1._addToGroup(group, bbox, element);
                    }
                } else {
                    this$1._addToGroup(group, bbox, element);
                }
            }
        }

        if (group.bboxes.length) {
            addGroup();
        }

        return {
            groups: groups,
            groupsSize: groupsSize
        };
    };

    Layout.prototype._addToGroup = function _addToGroup (group, bbox, element) {
        group.size += bbox.size[this._fieldMap.sizeField] + this.options.spacing;
        group.lineSize = Math.max(bbox.size[this._fieldMap.groupsSizeField], group.lineSize);
        group.bboxes.push(bbox);
        group.elements.push(element);
    };

    Layout.prototype._newGroup = function _newGroup () {
        return {
            lineSize: 0,
            size: -this.options.spacing,
            bboxes: [],
            elements: []
        };
    };

    return Layout;
}(__WEBPACK_IMPORTED_MODULE_0__group__["a" /* default */]));

/* unused harmony default export */ var _unused_webpack_default_export = (Layout);

/***/ }),
/* 2544 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = alignStartReverse;

function alignStartReverse(size, rect, align, axis, sizeField) {
    var start;
    if (align === "start") {
        start = rect.origin[axis] + rect.size[sizeField] - size;
    } else if (align === "end") {
        start = rect.origin[axis];
    } else {
        start = rect.origin[axis] + (rect.size[sizeField] - size) / 2;
    }

    return start;
}

/***/ }),
/* 2545 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__accessors_define_geometry_accessors__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__element__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_paintable__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_measurable__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__geometry_rect__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util__ = __webpack_require__(22);







var Rect = (function (Element) {
    function Rect(geometry, options) {
        if ( geometry === void 0 ) geometry = new __WEBPACK_IMPORTED_MODULE_4__geometry_rect__["a" /* default */]();
        if ( options === void 0 ) options = {};

        Element.call(this, options);
        this.geometry(geometry);

        if (!Object(__WEBPACK_IMPORTED_MODULE_5__util__["g" /* defined */])(this.options.stroke)) {
            this.stroke("#000");
        }
    }

    if ( Element ) Rect.__proto__ = Element;
    Rect.prototype = Object.create( Element && Element.prototype );
    Rect.prototype.constructor = Rect;

    Rect.prototype._bbox = function _bbox (matrix) {
        return this._geometry.bbox(matrix);
    };

    Rect.prototype.rawBBox = function rawBBox () {
        return this._geometry.bbox();
    };

    Rect.prototype._containsPoint = function _containsPoint (point) {
        return this._geometry.containsPoint(point);
    };

    Rect.prototype._isOnPath = function _isOnPath (point) {
        return this.geometry()._isOnPath(point, this.options.stroke.width / 2);
    };

    return Rect;
}(__WEBPACK_IMPORTED_MODULE_1__element__["a" /* default */]));

Rect.prototype.nodeType = "Rect";

__WEBPACK_IMPORTED_MODULE_2__mixins_paintable__["a" /* default */].extend(Rect.prototype);
__WEBPACK_IMPORTED_MODULE_3__mixins_measurable__["a" /* default */].extend(Rect.prototype);
Object(__WEBPACK_IMPORTED_MODULE_0__accessors_define_geometry_accessors__["a" /* default */])(Rect.prototype, [ "geometry" ]);

/* unused harmony default export */ var _unused_webpack_default_export = (Rect);



/***/ }),
/* 2546 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__alignment_align__ = __webpack_require__(2547);
/* unused harmony reexport align */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__alignment_v_align__ = __webpack_require__(2548);
/* unused harmony reexport vAlign */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__alignment_stack__ = __webpack_require__(2549);
/* unused harmony reexport stack */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__alignment_v_stack__ = __webpack_require__(2550);
/* unused harmony reexport vStack */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__alignment_wrap__ = __webpack_require__(2551);
/* unused harmony reexport wrap */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__alignment_v_wrap__ = __webpack_require__(2552);
/* unused harmony reexport vWrap */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__alignment_fit__ = __webpack_require__(2553);
/* unused harmony reexport fit */








/***/ }),
/* 2547 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__align_elements__ = __webpack_require__(661);



function align(elements, rect, alignment) {
    Object(__WEBPACK_IMPORTED_MODULE_0__align_elements__["a" /* default */])(elements, rect, alignment, "x", "width");
}

/***/ }),
/* 2548 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__align_elements__ = __webpack_require__(661);


function vAlign(elements, rect, alignment) {
    Object(__WEBPACK_IMPORTED_MODULE_0__align_elements__["a" /* default */])(elements, rect, alignment, "y", "height");
}

/***/ }),
/* 2549 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stack_elements__ = __webpack_require__(405);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__create_stack_elements__ = __webpack_require__(662);



function stack(elements) {
    Object(__WEBPACK_IMPORTED_MODULE_0__stack_elements__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1__create_stack_elements__["a" /* default */])(elements), "x", "y", "width");
}

/***/ }),
/* 2550 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stack_elements__ = __webpack_require__(405);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__create_stack_elements__ = __webpack_require__(662);



function vStack(elements) {
    Object(__WEBPACK_IMPORTED_MODULE_0__stack_elements__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1__create_stack_elements__["a" /* default */])(elements), "y", "x", "height");
}

/***/ }),
/* 2551 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__wrap_elements__ = __webpack_require__(663);


function wrap(elements, rect) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__wrap_elements__["a" /* default */])(elements, rect, "x", "y", "width");
}

/***/ }),
/* 2552 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__wrap_elements__ = __webpack_require__(663);


function vWrap(elements, rect) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__wrap_elements__["a" /* default */])(elements, rect, "y", "x", "height");
}

/***/ }),
/* 2553 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__geometry_transform__ = __webpack_require__(85);


function fit(element, rect) {
    var bbox = element.clippedBBox();
    if (bbox) {
        var elementSize = bbox.size;
        var rectSize = rect.size;
        if (rectSize.width < elementSize.width || rectSize.height < elementSize.height) {
            var scale = Math.min(rectSize.width / elementSize.width, rectSize.height / elementSize.height);
            var transform = element.transform() || Object(__WEBPACK_IMPORTED_MODULE_0__geometry_transform__["a" /* default */])();
            transform.scale(scale, scale);
            element.transform(transform);
        }
    }
}

/***/ }),
/* 2554 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__gradients_linear_gradient__ = __webpack_require__(406);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__gradients_linear_gradient__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__gradients_radial_gradient__ = __webpack_require__(408);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__gradients_radial_gradient__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__gradients_gradient_stop__ = __webpack_require__(664);
/* unused harmony reexport GradientStop */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__gradients_gradient__ = __webpack_require__(407);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_3__gradients_gradient__["a"]; });





/***/ }),
/* 2555 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shapes_elements_array__ = __webpack_require__(651);


var StopsArray = (function (ElementsArray) {
    function StopsArray () {
        ElementsArray.apply(this, arguments);
    }

    if ( ElementsArray ) StopsArray.__proto__ = ElementsArray;
    StopsArray.prototype = Object.create( ElementsArray && ElementsArray.prototype );
    StopsArray.prototype.constructor = StopsArray;

    StopsArray.prototype._change = function _change () {
        this.optionsChange({
            field: "stops"
        });
    };

    return StopsArray;
}(__WEBPACK_IMPORTED_MODULE_0__shapes_elements_array__["a" /* default */]));

/* harmony default export */ __webpack_exports__["a"] = (StopsArray);

/***/ }),
/* 2556 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = defineOptionsAccessors;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util__ = __webpack_require__(22);


function optionsAccessor(name) {
    return function(value) {
        if (Object(__WEBPACK_IMPORTED_MODULE_0__util__["g" /* defined */])(value)) {
            this.options.set(name, value);
            return this;
        }

        return this.options.get(name);
    };
}

function defineOptionsAccessors(fn, names) {
    for (var i = 0; i < names.length; i++) {
        fn[names[i]] = optionsAccessor(names[i]);
    }
}

/***/ }),
/* 2557 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__animations_animation__ = __webpack_require__(2558);
/* unused harmony reexport Animation */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__animations_animation_factory__ = __webpack_require__(665);
/* unused harmony reexport AnimationFactory */



/***/ }),
/* 2558 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__easing_functions__ = __webpack_require__(2559);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__animation_factory__ = __webpack_require__(665);





var now = Date.now || function() {
    return new Date().getTime();
};

var Animation = (function (Class) {
    function Animation(element, options) {
        Class.call(this);

        this.options = Object.assign({}, this.options, options);
        this.element = element;
    }

    if ( Class ) Animation.__proto__ = Class;
    Animation.prototype = Object.create( Class && Class.prototype );
    Animation.prototype.constructor = Animation;

    Animation.prototype.setup = function setup () {};
    Animation.prototype.step = function step () {};

    Animation.prototype.play = function play () {
        var this$1 = this;

        var options = this.options;
        var duration = options.duration;
        var delay = options.delay; if ( delay === void 0 ) delay = 0;
        var easing = __WEBPACK_IMPORTED_MODULE_0__easing_functions__[options.easing];
        var start = now() + delay;
        var finish = start + duration;

        if (duration === 0) {
            this.step(1);
            this.abort();
        } else {
            setTimeout(function () {
                var loop = function () {
                    if (this$1._stopped) {
                        return;
                    }

                    var wallTime = now();

                    var time = Object(__WEBPACK_IMPORTED_MODULE_1__util__["r" /* limitValue */])(wallTime - start, 0, duration);
                    var position = time / duration;
                    var easingPosition = easing(position, time, 0, 1, duration);

                    this$1.step(easingPosition);

                    if (wallTime < finish) {
                        Object(__WEBPACK_IMPORTED_MODULE_2__common__["c" /* animationFrame */])(loop);
                    } else {
                        this$1.abort();
                    }
                };

                loop();
            }, delay);
        }
    };

    Animation.prototype.abort = function abort () {
        this._stopped = true;
    };

    Animation.prototype.destroy = function destroy () {
        this.abort();
    };

    return Animation;
}(__WEBPACK_IMPORTED_MODULE_2__common__["a" /* Class */]));

Animation.prototype.options = {
    duration: 500,
    easing: "swing"
};

Animation.create = function(type, element, options) {
    return __WEBPACK_IMPORTED_MODULE_3__animation_factory__["a" /* default */].current.create(type, element, options);
};

/* unused harmony default export */ var _unused_webpack_default_export = (Animation);


/***/ }),
/* 2559 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["swing"] = swing;
/* harmony export (immutable) */ __webpack_exports__["linear"] = linear;
/* harmony export (immutable) */ __webpack_exports__["easeOutElastic"] = easeOutElastic;
function swing(position) {
    return 0.5 - Math.cos(position * Math.PI) / 2;
}

function linear(position) {
    return position;
}

function easeOutElastic(position, time, start, diff) {
    var s = 1.70158,
        p = 0,
        a = diff;

    if (position === 0) {
        return start;
    }

    if (position === 1) {
        return start + diff;
    }

    if (!p) {
        p = 0.5;
    }

    if (a < Math.abs(diff)) {
        a = diff;
        s = p / 4;
    } else {
        s = p / (2 * Math.PI) * Math.asin(diff / a);
    }

    return a * Math.pow(2, -10 * position) *
           Math.sin((Number(position) - s) * (1.1 * Math.PI) / p) + diff + start;
}


/***/ }),
/* 2560 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__svg_surface__ = __webpack_require__(2561);
/* unused harmony reexport Surface */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__svg_root_node__ = __webpack_require__(410);
/* unused harmony reexport RootNode */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__svg_node__ = __webpack_require__(101);
/* unused harmony reexport Node */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__svg_group_node__ = __webpack_require__(2562);
/* unused harmony reexport GroupNode */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__svg_arc_node__ = __webpack_require__(2563);
/* unused harmony reexport ArcNode */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__svg_circle_node__ = __webpack_require__(2564);
/* unused harmony reexport CircleNode */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__svg_rect_node__ = __webpack_require__(2565);
/* unused harmony reexport RectNode */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__svg_image_node__ = __webpack_require__(2566);
/* unused harmony reexport ImageNode */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__svg_text_node__ = __webpack_require__(2567);
/* unused harmony reexport TextNode */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__svg_path_node__ = __webpack_require__(120);
/* unused harmony reexport PathNode */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__svg_multi_path_node__ = __webpack_require__(2568);
/* unused harmony reexport MultiPathNode */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__svg_definition_node__ = __webpack_require__(668);
/* unused harmony reexport DefinitionNode */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__svg_clip_node__ = __webpack_require__(673);
/* unused harmony reexport ClipNode */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__svg_gradient_stop_node__ = __webpack_require__(671);
/* unused harmony reexport GradientStopNode */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__svg_linear_gradient_node__ = __webpack_require__(669);
/* unused harmony reexport LinearGradientNode */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__svg_radial_gradient_node__ = __webpack_require__(672);
/* unused harmony reexport RadialGradientNode */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__svg_export_group__ = __webpack_require__(675);
/* unused harmony reexport exportGroup */





















/***/ }),
/* 2561 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_surface__ = __webpack_require__(409);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_surface_factory__ = __webpack_require__(281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__root_node__ = __webpack_require__(410);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shapes_group__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__geometry_transform__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_render_svg__ = __webpack_require__(667);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util__ = __webpack_require__(22);









var RTL = 'rtl';

function alignToScreen(element) {
    var ctm;

    try {
        ctm = element.getScreenCTM ? element.getScreenCTM() : null;
    } catch (e) { } // eslint-disable-line no-empty

    if (ctm) {
        var left = - ctm.e % 1;
        var top = - ctm.f % 1;
        var style = element.style;

        if (left !== 0 || top !== 0) {
            style.left = left + "px";
            style.top = top + "px";
        }
    }
}

var Surface = (function (BaseSurface) {
    function Surface(element, options) {
        BaseSurface.call(this, element, options);

        this._root = new __WEBPACK_IMPORTED_MODULE_2__root_node__["a" /* default */](Object.assign({
            rtl: Object(__WEBPACK_IMPORTED_MODULE_7__util__["l" /* elementStyles */])(element, 'direction').direction === RTL
        }, this.options));

        Object(__WEBPACK_IMPORTED_MODULE_5__utils_render_svg__["a" /* default */])(this.element, this._template());

        this._rootElement = this.element.firstElementChild;

        alignToScreen(this._rootElement);

        this._root.attachTo(this._rootElement);

        Object(__WEBPACK_IMPORTED_MODULE_7__util__["e" /* bindEvents */])(this.element, {
            click: this._click,
            mouseover: this._mouseenter,
            mouseout: this._mouseleave,
            mousemove: this._mousemove
        });

        this.resize();
    }

    if ( BaseSurface ) Surface.__proto__ = BaseSurface;
    Surface.prototype = Object.create( BaseSurface && BaseSurface.prototype );
    Surface.prototype.constructor = Surface;

    Surface.prototype.destroy = function destroy () {
        if (this._root) {
            this._root.destroy();
            this._root = null;
            this._rootElement = null;
            Object(__WEBPACK_IMPORTED_MODULE_7__util__["x" /* unbindEvents */])(this.element, {
                click: this._click,
                mouseover: this._mouseenter,
                mouseout: this._mouseleave,
                mousemove: this._mousemove
            });
        }

        BaseSurface.prototype.destroy.call(this);
    };

    Surface.prototype.translate = function translate (offset) {
        var viewBox = (Math.round(offset.x)) + " " + (Math.round(offset.y)) + " " + (this._size.width) + " " + (this._size.height);

        this._offset = offset;
        this._rootElement.setAttribute("viewBox", viewBox);
    };

    Surface.prototype.draw = function draw (element) {
        BaseSurface.prototype.draw.call(this, element);
        this._root.load([ element ]);
    };

    Surface.prototype.clear = function clear () {
        BaseSurface.prototype.clear.call(this);
        this._root.clear();
    };

    Surface.prototype.svg = function svg () {
        return "<?xml version='1.0' ?>" + this._template();
    };

    Surface.prototype.exportVisual = function exportVisual () {
        var ref = this;
        var visual = ref._visual;
        var offset = ref._offset;

        if (offset) {
            var wrap = new __WEBPACK_IMPORTED_MODULE_3__shapes_group__["a" /* default */]();
            wrap.children.push(visual);

            wrap.transform(
                Object(__WEBPACK_IMPORTED_MODULE_4__geometry_transform__["a" /* default */])().translate(-offset.x, -offset.y)
            );

            visual = wrap;
        }

        return visual;
    };

    Surface.prototype._resize = function _resize () {
        if (this._offset) {
            this.translate(this._offset);
        }
    };

    Surface.prototype._template = function _template () {
        return ("<svg style='width: 100%; height: 100%; overflow: hidden;' xmlns='" + __WEBPACK_IMPORTED_MODULE_6__constants__["b" /* SVG_NS */] + "' xmlns:xlink='http://www.w3.org/1999/xlink' version='1.1'>" + (this._root.render()) + "</svg>");
    };

    return Surface;
}(__WEBPACK_IMPORTED_MODULE_0__core_surface__["a" /* default */]));

Surface.prototype.type = "svg";

if (typeof document !== "undefined" && document.implementation.hasFeature("http://www.w3.org/TR/SVG11/feature#BasicStructure", "1.1")) {
    __WEBPACK_IMPORTED_MODULE_0__core_surface__["a" /* default */].support.svg = true;
    __WEBPACK_IMPORTED_MODULE_1__core_surface_factory__["a" /* default */].current.register("svg", Surface, 10);
}

/* unused harmony default export */ var _unused_webpack_default_export = (Surface);

/***/ }),
/* 2562 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_map__ = __webpack_require__(86);



var GroupNode = (function (Node) {
    function GroupNode () {
        Node.apply(this, arguments);
    }

    if ( Node ) GroupNode.__proto__ = Node;
    GroupNode.prototype = Object.create( Node && Node.prototype );
    GroupNode.prototype.constructor = GroupNode;

    GroupNode.prototype.template = function template () {
        return ("<g" + (this.renderId() + this.renderTransform() + this.renderStyle() + this.renderOpacity() + this.renderDefinitions()) + ">" + (this.renderChildren()) + "</g>");
    };

    GroupNode.prototype.optionsChange = function optionsChange (e) {
        if (e.field === "transform") {
            this.transformChange(e.value);
        }

        Node.prototype.optionsChange.call(this, e);
    };

    return GroupNode;
}(__WEBPACK_IMPORTED_MODULE_0__node__["a" /* default */]));

__WEBPACK_IMPORTED_MODULE_1__node_map__["a" /* default */].Group = GroupNode;

/* unused harmony default export */ var _unused_webpack_default_export = (GroupNode);

/***/ }),
/* 2563 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__path_node__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_map__ = __webpack_require__(86);



var ArcNode = (function (PathNode) {
    function ArcNode () {
        PathNode.apply(this, arguments);
    }

    if ( PathNode ) ArcNode.__proto__ = PathNode;
    ArcNode.prototype = Object.create( PathNode && PathNode.prototype );
    ArcNode.prototype.constructor = ArcNode;

    ArcNode.prototype.renderData = function renderData () {
        return this.printPath(this.srcElement.toPath());
    };

    return ArcNode;
}(__WEBPACK_IMPORTED_MODULE_0__path_node__["a" /* default */]));

__WEBPACK_IMPORTED_MODULE_1__node_map__["a" /* default */].Arc = ArcNode;

/* unused harmony default export */ var _unused_webpack_default_export = (ArcNode);

/***/ }),
/* 2564 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__path_node__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_map__ = __webpack_require__(86);



var CircleNode = (function (PathNode) {
    function CircleNode () {
        PathNode.apply(this, arguments);
    }

    if ( PathNode ) CircleNode.__proto__ = PathNode;
    CircleNode.prototype = Object.create( PathNode && PathNode.prototype );
    CircleNode.prototype.constructor = CircleNode;

    CircleNode.prototype.geometryChange = function geometryChange () {
        var center = this.center();
        this.attr("cx", center.x);
        this.attr("cy", center.y);
        this.attr("r", this.radius());
        this.invalidate();
    };

    CircleNode.prototype.center = function center () {
        return this.srcElement.geometry().center;
    };

    CircleNode.prototype.radius = function radius () {
        return this.srcElement.geometry().radius;
    };

    CircleNode.prototype.template = function template () {
        return "<circle " + (this.renderId()) + " " + (this.renderStyle()) + " " + (this.renderOpacity()) +
                    "cx='" + (this.center().x) + "' cy='" + (this.center().y) + "' r='" + (this.radius()) + "'" +
                    (this.renderStroke()) + " " + (this.renderFill()) + " " + (this.renderDefinitions()) +
                    (this.renderTransform()) + " ></circle>";
    };

    return CircleNode;
}(__WEBPACK_IMPORTED_MODULE_0__path_node__["a" /* default */]));

__WEBPACK_IMPORTED_MODULE_1__node_map__["a" /* default */].Circle = CircleNode;

/* unused harmony default export */ var _unused_webpack_default_export = (CircleNode);

/***/ }),
/* 2565 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__path_node__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_map__ = __webpack_require__(86);



var RectNode = (function (PathNode) {
    function RectNode () {
        PathNode.apply(this, arguments);
    }

    if ( PathNode ) RectNode.__proto__ = PathNode;
    RectNode.prototype = Object.create( PathNode && PathNode.prototype );
    RectNode.prototype.constructor = RectNode;

    RectNode.prototype.geometryChange = function geometryChange () {
        var geometry = this.srcElement.geometry();
        this.attr("x", geometry.origin.x);
        this.attr("y", geometry.origin.y);
        this.attr("width", geometry.size.width);
        this.attr("height", geometry.size.height);
        this.invalidate();
    };

    RectNode.prototype.size = function size () {
        return this.srcElement.geometry().size;
    };

    RectNode.prototype.origin = function origin () {
        return this.srcElement.geometry().origin;
    };

    RectNode.prototype.template = function template () {
        return "<rect " + (this.renderId()) + " " + (this.renderStyle()) + " " + (this.renderOpacity()) + " x='" + (this.origin().x) + "' y='" + (this.origin().y) + "' " +
                    "width='" + (this.size().width) + "' height='" + (this.size().height) + "' " + (this.renderStroke()) + " " +
                    (this.renderFill()) + " " + (this.renderDefinitions()) + " " + (this.renderTransform()) + " />";
    };

    return RectNode;
}(__WEBPACK_IMPORTED_MODULE_0__path_node__["a" /* default */]));

__WEBPACK_IMPORTED_MODULE_1__node_map__["a" /* default */].Rect = RectNode;

/* unused harmony default export */ var _unused_webpack_default_export = (RectNode);

/***/ }),
/* 2566 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__path_node__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_map__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_render_all_attributes__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common__ = __webpack_require__(29);





var ImageNode = (function (PathNode) {
    function ImageNode () {
        PathNode.apply(this, arguments);
    }

    if ( PathNode ) ImageNode.__proto__ = PathNode;
    ImageNode.prototype = Object.create( PathNode && PathNode.prototype );
    ImageNode.prototype.constructor = ImageNode;

    ImageNode.prototype.geometryChange = function geometryChange () {
        this.allAttr(this.mapPosition());
        this.invalidate();
    };

    ImageNode.prototype.optionsChange = function optionsChange (e) {
        if (e.field === "src") {
            this.allAttr(this.mapSource());
        }

        PathNode.prototype.optionsChange.call(this, e);
    };

    ImageNode.prototype.mapPosition = function mapPosition () {
        var rect = this.srcElement.rect();
        var tl = rect.topLeft();

        return [
            [ "x", tl.x ],
            [ "y", tl.y ],
            [ "width", rect.width() + "px" ],
            [ "height", rect.height() + "px" ]
        ];
    };

    ImageNode.prototype.renderPosition = function renderPosition () {
        return Object(__WEBPACK_IMPORTED_MODULE_2__utils_render_all_attributes__["a" /* default */])(this.mapPosition());
    };

    ImageNode.prototype.mapSource = function mapSource (encode) {
        var src = this.srcElement.src();

        if (encode) {
            src = Object(__WEBPACK_IMPORTED_MODULE_3__common__["d" /* htmlEncode */])(src);
        }

        return [ [ "xlink:href", src ] ];
    };

    ImageNode.prototype.renderSource = function renderSource () {
        return Object(__WEBPACK_IMPORTED_MODULE_2__utils_render_all_attributes__["a" /* default */])(this.mapSource(true));
    };

    ImageNode.prototype.template = function template () {
        return "<image preserveAspectRatio='none' " + (this.renderId()) + " " + (this.renderStyle()) + " " + (this.renderTransform()) + " " + (this.renderOpacity()) +
               (this.renderPosition()) + " " + (this.renderSource()) + " " + (this.renderDefinitions()) + ">" +
               "</image>";
    };

    return ImageNode;
}(__WEBPACK_IMPORTED_MODULE_0__path_node__["a" /* default */]));

__WEBPACK_IMPORTED_MODULE_1__node_map__["a" /* default */].Image = ImageNode;

/* unused harmony default export */ var _unused_webpack_default_export = (ImageNode);

/***/ }),
/* 2567 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__path_node__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_render_style__ = __webpack_require__(666);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_render_attribute__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_map__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__text_metrics__ = __webpack_require__(642);







var ENTITY_REGEX = /&(?:[a-zA-Z]+|#\d+);/g;

function decodeEntities(text) {
    if (!text || typeof text !== "string" || !ENTITY_REGEX.test(text)) {
        return text;
    }

    var element = decodeEntities._element;
    ENTITY_REGEX.lastIndex = 0;

    return text.replace(ENTITY_REGEX, function (match) {
        element.innerHTML = match;

        return element.textContent || element.innerText;
    });
}

if (typeof document !== "undefined") {
    decodeEntities._element = document.createElement("span");
}

var TextNode = (function (PathNode) {
    function TextNode () {
        PathNode.apply(this, arguments);
    }

    if ( PathNode ) TextNode.__proto__ = PathNode;
    TextNode.prototype = Object.create( PathNode && PathNode.prototype );
    TextNode.prototype.constructor = TextNode;

    TextNode.prototype.geometryChange = function geometryChange () {
        var pos = this.pos();
        this.attr("x", pos.x);
        this.attr("y", pos.y);
        this.invalidate();
    };

    TextNode.prototype.optionsChange = function optionsChange (e) {
        if (e.field === "font") {
            this.attr("style", Object(__WEBPACK_IMPORTED_MODULE_1__utils_render_style__["a" /* default */])(this.mapStyle()));
            this.geometryChange();
        } else if (e.field === "content") {
            PathNode.prototype.content.call(this, this.srcElement.content());
        }

        PathNode.prototype.optionsChange.call(this, e);
    };

    TextNode.prototype.mapStyle = function mapStyle (encode) {
        var style = PathNode.prototype.mapStyle.call(this, encode);
        var font = this.srcElement.options.font;

        if (encode) {
            font = Object(__WEBPACK_IMPORTED_MODULE_4__common__["d" /* htmlEncode */])(font);
        }

        style.push([ "font", font ], [ "white-space", "pre" ]);

        return style;
    };

    TextNode.prototype.pos = function pos () {
        var pos = this.srcElement.position();
        var size = this.srcElement.measure();
        return pos.clone().setY(pos.y + size.baseline);
    };

    TextNode.prototype.renderContent = function renderContent () {
        var content = this.srcElement.content();
        content = decodeEntities(content);
        content = Object(__WEBPACK_IMPORTED_MODULE_4__common__["d" /* htmlEncode */])(content);

        return Object(__WEBPACK_IMPORTED_MODULE_5__text_metrics__["b" /* normalizeText */])(content);
    };

    TextNode.prototype.renderTextAnchor = function renderTextAnchor () {
        var anchor;

        if ((this.options || {}).rtl && !(__WEBPACK_IMPORTED_MODULE_4__common__["h" /* support */].browser.msie || __WEBPACK_IMPORTED_MODULE_4__common__["h" /* support */].browser.edge)) {
            anchor = 'end';
        }

        return Object(__WEBPACK_IMPORTED_MODULE_2__utils_render_attribute__["a" /* default */])("text-anchor", anchor);
    };

    TextNode.prototype.template = function template () {
        return "<text " + (this.renderId()) + " " + (this.renderTextAnchor()) + " " + (this.renderStyle()) + " " + (this.renderOpacity()) +
                    "x='" + (this.pos().x) + "' y='" + (this.pos().y) + "' " + (this.renderStroke()) + " " + (this.renderTransform()) + " " + (this.renderDefinitions()) +
                    (this.renderFill()) + ">" + (this.renderContent()) + "</text>";
    };

    return TextNode;
}(__WEBPACK_IMPORTED_MODULE_0__path_node__["a" /* default */]));

__WEBPACK_IMPORTED_MODULE_3__node_map__["a" /* default */].Text = TextNode;

/* unused harmony default export */ var _unused_webpack_default_export = (TextNode);

/***/ }),
/* 2568 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__path_node__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_map__ = __webpack_require__(86);



var MultiPathNode = (function (PathNode) {
    function MultiPathNode () {
        PathNode.apply(this, arguments);
    }

    if ( PathNode ) MultiPathNode.__proto__ = PathNode;
    MultiPathNode.prototype = Object.create( PathNode && PathNode.prototype );
    MultiPathNode.prototype.constructor = MultiPathNode;

    MultiPathNode.prototype.renderData = function renderData () {
        var this$1 = this;

        var paths = this.srcElement.paths;

        if (paths.length > 0) {
            var result = [];

            for (var i = 0; i < paths.length; i++) {
                result.push(this$1.printPath(paths[i]));
            }

            return result.join(" ");
        }
    };

    return MultiPathNode;
}(__WEBPACK_IMPORTED_MODULE_0__path_node__["a" /* default */]));

__WEBPACK_IMPORTED_MODULE_1__node_map__["a" /* default */].MultiPath = MultiPathNode;

/* unused harmony default export */ var _unused_webpack_default_export = (MultiPathNode);

/***/ }),
/* 2569 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__canvas_surface__ = __webpack_require__(676);
/* unused harmony reexport Surface */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__canvas_root_node__ = __webpack_require__(677);
/* unused harmony reexport RootNode */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__canvas_node__ = __webpack_require__(411);
/* unused harmony reexport Node */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__canvas_group_node__ = __webpack_require__(678);
/* unused harmony reexport GroupNode */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__canvas_arc_node__ = __webpack_require__(2571);
/* unused harmony reexport ArcNode */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__canvas_circle_node__ = __webpack_require__(2572);
/* unused harmony reexport CircleNode */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__canvas_rect_node__ = __webpack_require__(2573);
/* unused harmony reexport RectNode */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__canvas_image_node__ = __webpack_require__(2574);
/* unused harmony reexport ImageNode */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__canvas_text_node__ = __webpack_require__(2575);
/* unused harmony reexport TextNode */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__canvas_path_node__ = __webpack_require__(122);
/* unused harmony reexport PathNode */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__canvas_multi_path_node__ = __webpack_require__(2576);
/* unused harmony reexport MultiPathNode */













/***/ }),
/* 2570 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util__ = __webpack_require__(22);


var SurfaceCursor = function SurfaceCursor(surface) {
    surface.bind("mouseenter", this._mouseenter.bind(this));
    surface.bind("mouseleave", this._mouseleave.bind(this));

    this.element = surface.element;
};

SurfaceCursor.prototype.clear = function clear () {
    this._resetCursor();
};

SurfaceCursor.prototype.destroy = function destroy () {
    this._resetCursor();
    delete this.element;
};

SurfaceCursor.prototype._mouseenter = function _mouseenter (e) {
    var cursor = this._shapeCursor(e);

    if (!cursor) {
        this._resetCursor();
    } else {
        if (!this._current) {
            this._defaultCursor = this._getCursor();
        }

        this._setCursor(cursor);
    }
};

SurfaceCursor.prototype._mouseleave = function _mouseleave () {
    this._resetCursor();
};

SurfaceCursor.prototype._shapeCursor = function _shapeCursor (e) {
    var shape = e.element;

    while (shape && !Object(__WEBPACK_IMPORTED_MODULE_0__util__["g" /* defined */])(shape.options.cursor)) {
        shape = shape.parent;
    }

    if (shape) {
        return shape.options.cursor;
    }
};

SurfaceCursor.prototype._getCursor = function _getCursor () {
    if (this.element) {
        return this.element.style.cursor;
    }
};

SurfaceCursor.prototype._setCursor = function _setCursor (cursor) {
    if (this.element) {
        this.element.style.cursor = cursor;
        this._current = cursor;
    }
};

SurfaceCursor.prototype._resetCursor = function _resetCursor () {
    if (this._current) {
        this._setCursor(this._defaultCursor || "");
        delete this._current;
    }
};

/* harmony default export */ __webpack_exports__["a"] = (SurfaceCursor);



/***/ }),
/* 2571 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__path_node__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_map__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_render_path__ = __webpack_require__(283);




var ArcNode = (function (PathNode) {
    function ArcNode () {
        PathNode.apply(this, arguments);
    }

    if ( PathNode ) ArcNode.__proto__ = PathNode;
    ArcNode.prototype = Object.create( PathNode && PathNode.prototype );
    ArcNode.prototype.constructor = ArcNode;

    ArcNode.prototype.renderPoints = function renderPoints (ctx) {
        var path = this.srcElement.toPath();
        Object(__WEBPACK_IMPORTED_MODULE_2__utils_render_path__["a" /* default */])(ctx, path);
    };

    return ArcNode;
}(__WEBPACK_IMPORTED_MODULE_0__path_node__["a" /* default */]));

__WEBPACK_IMPORTED_MODULE_1__node_map__["a" /* default */].Arc = ArcNode;

/* unused harmony default export */ var _unused_webpack_default_export = (ArcNode);

/***/ }),
/* 2572 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__path_node__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_map__ = __webpack_require__(87);



var CircleNode = (function (PathNode) {
    function CircleNode () {
        PathNode.apply(this, arguments);
    }

    if ( PathNode ) CircleNode.__proto__ = PathNode;
    CircleNode.prototype = Object.create( PathNode && PathNode.prototype );
    CircleNode.prototype.constructor = CircleNode;

    CircleNode.prototype.renderPoints = function renderPoints (ctx) {
        var ref = this.srcElement.geometry();
        var center = ref.center;
        var radius = ref.radius;

        ctx.arc(center.x, center.y, radius, 0, Math.PI * 2);
    };

    return CircleNode;
}(__WEBPACK_IMPORTED_MODULE_0__path_node__["a" /* default */]));

__WEBPACK_IMPORTED_MODULE_1__node_map__["a" /* default */].Circle = CircleNode;

/* unused harmony default export */ var _unused_webpack_default_export = (CircleNode);

/***/ }),
/* 2573 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__path_node__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_map__ = __webpack_require__(87);



var RectNode = (function (PathNode) {
    function RectNode () {
        PathNode.apply(this, arguments);
    }

    if ( PathNode ) RectNode.__proto__ = PathNode;
    RectNode.prototype = Object.create( PathNode && PathNode.prototype );
    RectNode.prototype.constructor = RectNode;

    RectNode.prototype.renderPoints = function renderPoints (ctx) {
        var ref = this.srcElement.geometry();
        var origin = ref.origin;
        var size = ref.size;

        ctx.rect(origin.x, origin.y, size.width, size.height);
    };

    return RectNode;
}(__WEBPACK_IMPORTED_MODULE_0__path_node__["a" /* default */]));

__WEBPACK_IMPORTED_MODULE_1__node_map__["a" /* default */].Rect = RectNode;

/* unused harmony default export */ var _unused_webpack_default_export = (RectNode);

/***/ }),
/* 2574 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__path_node__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_map__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util__ = __webpack_require__(22);




var ImageNode = (function (PathNode) {
    function ImageNode(srcElement, cors) {
        PathNode.call(this, srcElement);

        this.onLoad = this.onLoad.bind(this);
        this.onError = this.onError.bind(this);

        this.loading = Object(__WEBPACK_IMPORTED_MODULE_2__util__["f" /* createPromise */])();

        var img = this.img = new Image();

        if (cors && !(/^data:/i.test(srcElement.src()))) {
            img.crossOrigin = cors;
        }

        img.src = srcElement.src();

        if (img.complete) {
            this.onLoad();
        } else {
            img.onload = this.onLoad;
            img.onerror = this.onError;
        }
    }

    if ( PathNode ) ImageNode.__proto__ = PathNode;
    ImageNode.prototype = Object.create( PathNode && PathNode.prototype );
    ImageNode.prototype.constructor = ImageNode;

    ImageNode.prototype.renderTo = function renderTo (ctx) {
        if (this.loading.state() === "resolved") {
            ctx.save();

            this.setTransform(ctx);
            this.setClip(ctx);

            this.drawImage(ctx);

            ctx.restore();
        }
    };

    ImageNode.prototype.optionsChange = function optionsChange (e) {
        if (e.field === "src") {
            this.loading = Object(__WEBPACK_IMPORTED_MODULE_2__util__["f" /* createPromise */])();
            this.img.src = this.srcElement.src();
        } else {
            PathNode.prototype.optionsChange.call(this, e);
        }
    };

    ImageNode.prototype.onLoad = function onLoad () {
        this.loading.resolve();
        this.invalidate();
    };

    ImageNode.prototype.onError = function onError () {
        this.loading.reject(new Error(
            "Unable to load image '" + this.img.src +
            "'. Check for connectivity and verify CORS headers."
        ));
    };

    ImageNode.prototype.drawImage = function drawImage (ctx) {
        var rect = this.srcElement.rect();
        var topLeft = rect.topLeft();

        ctx.drawImage(
            this.img, topLeft.x, topLeft.y, rect.width(), rect.height()
        );
    };

    return ImageNode;
}(__WEBPACK_IMPORTED_MODULE_0__path_node__["a" /* default */]));

__WEBPACK_IMPORTED_MODULE_1__node_map__["a" /* default */].Image = ImageNode;

/* unused harmony default export */ var _unused_webpack_default_export = (ImageNode);

/***/ }),
/* 2575 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__path_node__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_map__ = __webpack_require__(87);



var TextNode = (function (PathNode) {
    function TextNode () {
        PathNode.apply(this, arguments);
    }

    if ( PathNode ) TextNode.__proto__ = PathNode;
    TextNode.prototype = Object.create( PathNode && PathNode.prototype );
    TextNode.prototype.constructor = TextNode;

    TextNode.prototype.renderTo = function renderTo (ctx) {
        var text = this.srcElement;
        var pos = text.position();
        var size = text.measure();

        ctx.save();

        this.setTransform(ctx);
        this.setClip(ctx);
        this.setOpacity(ctx);

        ctx.beginPath();

        ctx.font = text.options.font;
        ctx.textAlign = 'left';

        if (this.setFill(ctx)) {
            ctx.fillText(text.content(), pos.x, pos.y + size.baseline);
        }

        if (this.setStroke(ctx)) {
            this.setLineDash(ctx);
            ctx.strokeText(text.content(), pos.x, pos.y + size.baseline);
        }

        ctx.restore();
    };

    return TextNode;
}(__WEBPACK_IMPORTED_MODULE_0__path_node__["a" /* default */]));


__WEBPACK_IMPORTED_MODULE_1__node_map__["a" /* default */].Text = TextNode;

/* unused harmony default export */ var _unused_webpack_default_export = (TextNode);

/***/ }),
/* 2576 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__path_node__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_map__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_render_path__ = __webpack_require__(283);




var MultiPathNode = (function (PathNode) {
    function MultiPathNode () {
        PathNode.apply(this, arguments);
    }

    if ( PathNode ) MultiPathNode.__proto__ = PathNode;
    MultiPathNode.prototype = Object.create( PathNode && PathNode.prototype );
    MultiPathNode.prototype.constructor = MultiPathNode;

    MultiPathNode.prototype.renderPoints = function renderPoints (ctx) {
        var paths = this.srcElement.paths;
        for (var i = 0; i < paths.length; i++) {
            Object(__WEBPACK_IMPORTED_MODULE_2__utils_render_path__["a" /* default */])(ctx, paths[i]);
        }
    };

    return MultiPathNode;
}(__WEBPACK_IMPORTED_MODULE_0__path_node__["a" /* default */]));

__WEBPACK_IMPORTED_MODULE_1__node_map__["a" /* default */].MultiPath = MultiPathNode;

/* unused harmony default export */ var _unused_webpack_default_export = (MultiPathNode);

/***/ }),
/* 2577 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__surface__ = __webpack_require__(676);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__geometry__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shapes_group__ = __webpack_require__(202);




function exportImage(group, options) {
    var defaults = {
        width: "800px", height: "600px",
        cors: "Anonymous"
    };

    var exportRoot = group;
    var bbox = group.clippedBBox();


    if (bbox) {
        var origin = bbox.getOrigin();
        exportRoot = new __WEBPACK_IMPORTED_MODULE_2__shapes_group__["a" /* default */]();
        exportRoot.transform(Object(__WEBPACK_IMPORTED_MODULE_1__geometry__["e" /* transform */])().translate(-origin.x, -origin.y));
        exportRoot.children.push(group);

        var size = bbox.getSize();
        defaults.width = size.width + "px";
        defaults.height = size.height + "px";
    }

    var surfaceOptions = Object.assign(defaults, options);

    var container = document.createElement("div");
    var style = container.style;

    style.display = "none";
    style.width = surfaceOptions.width;
    style.height = surfaceOptions.height;
    document.body.appendChild(container);

    var surface = new __WEBPACK_IMPORTED_MODULE_0__surface__["a" /* default */](container, surfaceOptions);
    surface.suspendTracking();
    surface.draw(exportRoot);

    var promise = surface.image();
    var destroy = function () {
        surface.destroy();
        document.body.removeChild(container);
    };
    promise.then(destroy, destroy);

    return promise;
}

/***/ }),
/* 2578 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__export_group__ = __webpack_require__(675);



function exportSVG(group, options) {
    var svg = Object(__WEBPACK_IMPORTED_MODULE_1__export_group__["a" /* default */])(group);

    if (!options || !options.raw) {
        svg = "data:image/svg+xml;base64," + Object(__WEBPACK_IMPORTED_MODULE_0__util__["m" /* encodeBase64 */])(svg);
    }

    return Object(__WEBPACK_IMPORTED_MODULE_0__util__["f" /* createPromise */])().resolve(svg);
}


/***/ }),
/* 2579 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TTFFont; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(683);
/* eslint-disable no-multi-spaces, key-spacing, indent, camelcase, space-before-blocks, eqeqeq, brace-style */
/* eslint-disable space-infix-ops, space-before-function-paren, array-bracket-spacing, object-curly-spacing */
/* eslint-disable no-nested-ternary, max-params, default-case, no-else-return, no-empty */
/* eslint-disable no-param-reassign, no-var, block-scoped-var */

/*****************************************************************************\
 *
 * The code in this file, although written from scratch, is influenced by the
 * TrueType parser/encoder in PDFKit -- http://pdfkit.org/ (a CoffeeScript
 * library for producing PDF files).
 *
 * PDFKit is (c) Devon Govett 2014 and released under the MIT License.
 *
\*****************************************************************************/



function hasOwnProperty(obj, key) {
    return Object.prototype.hasOwnProperty.call(obj, key);
}

function sortedKeys(obj) {
    return Object.keys(obj).sort(function(a, b){ return a - b; }).map(parseFloat);
}

///

function Directory(data) {
    this.raw = data;
    this.scalerType = data.readLong();
    this.tableCount = data.readShort();
    this.searchRange = data.readShort();
    this.entrySelector = data.readShort();
    this.rangeShift = data.readShort();

    var tables = this.tables = {};
    for (var i = 0; i < this.tableCount; ++i) {
        var entry = {
            tag      : data.readString(4),
            checksum : data.readLong(),
            offset   : data.readLong(),
            length   : data.readLong()
        };
        tables[entry.tag] = entry;
    }
}

Directory.prototype = {

    readTable: function(name, Ctor) {
        var def = this.tables[name];
        if (!def) {
            throw new Error("Table " + name + " not found in directory");
        }
        return (this[name] = def.table = new Ctor(this, def));
    },

    render: function(tables) {
        var this$1 = this;

        var tableCount = Object.keys(tables).length;

        var maxpow2 = Math.pow(2, Math.floor(Math.log(tableCount) / Math.LN2));
        var searchRange = maxpow2 * 16;
        var entrySelector = Math.floor(Math.log(maxpow2) / Math.LN2);
        var rangeShift = tableCount * 16 - searchRange;

        var out = Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* BinaryStream */])();
        out.writeLong(this.scalerType);
        out.writeShort(tableCount);
        out.writeShort(searchRange);
        out.writeShort(entrySelector);
        out.writeShort(rangeShift);

        var directoryLength = tableCount * 16;
        var offset = out.offset() + directoryLength;
        var headOffset = null;
        var tableData = Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* BinaryStream */])();

        for (var tag in tables) {
            if (hasOwnProperty(tables, tag)) {
                var table = tables[tag];

                out.writeString(tag);
                out.writeLong(this$1.checksum(table));
                out.writeLong(offset);
                out.writeLong(table.length);

                tableData.write(table);
                if (tag == "head") {
                    headOffset = offset;
                }
                offset += table.length;

                while (offset % 4) {
                    tableData.writeByte(0);
                    offset++;
                }
            }
        }

        out.write(tableData.get());
        var sum = this.checksum(out.get());
        var adjustment = 0xB1B0AFBA - sum;

        out.offset(headOffset + 8);
        out.writeLong(adjustment);
        return out.get();
    },

    checksum: function(data) {
        data = Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* BinaryStream */])(data);
        var sum = 0;
        while (!data.eof()) {
            sum += data.readLong();
        }
        return sum & 0xFFFFFFFF;
    }
};

function deftable(methods) {
    function Ctor(file, def) {
        this.definition = def;
        this.length = def.length;
        this.offset = def.offset;
        this.file = file;
        this.rawData = file.raw;
        this.parse(file.raw);
    }
    Ctor.prototype.raw = function() {
        return this.rawData.slice(this.offset, this.length);
    };
    for (var i in methods) {
        if (hasOwnProperty(methods, i)) {
            Ctor[i] = Ctor.prototype[i] = methods[i];
        }
    }
    return Ctor;
}

var HeadTable = deftable({
    parse: function(data) {
        data.offset(this.offset);
        this.version             = data.readLong();
        this.revision            = data.readLong();
        this.checkSumAdjustment  = data.readLong();
        this.magicNumber         = data.readLong();
        this.flags               = data.readShort();
        this.unitsPerEm          = data.readShort();
        this.created             = data.read(8);
        this.modified            = data.read(8);

        this.xMin = data.readShort_();
        this.yMin = data.readShort_();
        this.xMax = data.readShort_();
        this.yMax = data.readShort_();

        this.macStyle           = data.readShort();
        this.lowestRecPPEM      = data.readShort();
        this.fontDirectionHint  = data.readShort_();
        this.indexToLocFormat   = data.readShort_();
        this.glyphDataFormat    = data.readShort_();
    },
    render: function(indexToLocFormat) {
        var out = Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* BinaryStream */])();
        out.writeLong(this.version);
        out.writeLong(this.revision);
        out.writeLong(0);       // checksum adjustment; shall be computed later
        out.writeLong(this.magicNumber);
        out.writeShort(this.flags);
        out.writeShort(this.unitsPerEm);
        out.write(this.created);
        out.write(this.modified);
        out.writeShort_(this.xMin);
        out.writeShort_(this.yMin);
        out.writeShort_(this.xMax);
        out.writeShort_(this.yMax);
        out.writeShort(this.macStyle);
        out.writeShort(this.lowestRecPPEM);
        out.writeShort_(this.fontDirectionHint);
        out.writeShort_(indexToLocFormat); // this will depend on the `loca` table
        out.writeShort_(this.glyphDataFormat);
        return out.get();
    }
});

var LocaTable = deftable({
    parse: function(data) {
        data.offset(this.offset);
        var format = this.file.head.indexToLocFormat;
        if (format === 0) {
            this.offsets = data.times(this.length / 2, function(){
                return 2 * data.readShort();
            });
        } else {
            this.offsets = data.times(this.length / 4, data.readLong);
        }
    },
    offsetOf: function(id) {
        return this.offsets[id];
    },
    lengthOf: function(id) {
        return this.offsets[id + 1] - this.offsets[id];
    },
    render: function(offsets) {
        var out = Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* BinaryStream */])();
        var needsLongFormat = offsets[offsets.length - 1] > 0xFFFF;
        for (var i = 0; i < offsets.length; ++i) {
            if (needsLongFormat) {
                out.writeLong(offsets[i]);
            } else {
                out.writeShort(offsets[i] / 2);
            }
        }
        return {
            format: needsLongFormat ? 1 : 0,
            table: out.get()
        };
    }
});

var HheaTable = deftable({
    parse: function(data) {
        data.offset(this.offset);

        this.version              = data.readLong();
        this.ascent               = data.readShort_();
        this.descent              = data.readShort_();
        this.lineGap              = data.readShort_();
        this.advanceWidthMax      = data.readShort();
        this.minLeftSideBearing   = data.readShort_();
        this.minRightSideBearing  = data.readShort_();
        this.xMaxExtent           = data.readShort_();
        this.caretSlopeRise       = data.readShort_();
        this.caretSlopeRun        = data.readShort_();
        this.caretOffset          = data.readShort_();

        data.skip(4 * 2);       // reserved

        this.metricDataFormat     = data.readShort_();
        this.numOfLongHorMetrics  = data.readShort();
    },
    render: function(ids) {
        var out = Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* BinaryStream */])();
        out.writeLong(this.version);
        out.writeShort_(this.ascent);
        out.writeShort_(this.descent);
        out.writeShort_(this.lineGap);
        out.writeShort(this.advanceWidthMax);
        out.writeShort_(this.minLeftSideBearing);
        out.writeShort_(this.minRightSideBearing);
        out.writeShort_(this.xMaxExtent);
        out.writeShort_(this.caretSlopeRise);
        out.writeShort_(this.caretSlopeRun);
        out.writeShort_(this.caretOffset);

        out.write([ 0, 0, 0, 0, 0, 0, 0, 0 ]); // reserved bytes

        out.writeShort_(this.metricDataFormat);
        out.writeShort(ids.length);
        return out.get();
    }
});

var MaxpTable = deftable({
    parse: function(data) {
        data.offset(this.offset);
        this.version = data.readLong();
        this.numGlyphs = data.readShort();
        this.maxPoints = data.readShort();
        this.maxContours = data.readShort();
        this.maxComponentPoints = data.readShort();
        this.maxComponentContours = data.readShort();
        this.maxZones = data.readShort();
        this.maxTwilightPoints = data.readShort();
        this.maxStorage = data.readShort();
        this.maxFunctionDefs = data.readShort();
        this.maxInstructionDefs = data.readShort();
        this.maxStackElements = data.readShort();
        this.maxSizeOfInstructions = data.readShort();
        this.maxComponentElements = data.readShort();
        this.maxComponentDepth = data.readShort();
    },
    render: function(glyphIds) {
        var out = Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* BinaryStream */])();
        out.writeLong(this.version);
        out.writeShort(glyphIds.length);
        out.writeShort(this.maxPoints);
        out.writeShort(this.maxContours);
        out.writeShort(this.maxComponentPoints);
        out.writeShort(this.maxComponentContours);
        out.writeShort(this.maxZones);
        out.writeShort(this.maxTwilightPoints);
        out.writeShort(this.maxStorage);
        out.writeShort(this.maxFunctionDefs);
        out.writeShort(this.maxInstructionDefs);
        out.writeShort(this.maxStackElements);
        out.writeShort(this.maxSizeOfInstructions);
        out.writeShort(this.maxComponentElements);
        out.writeShort(this.maxComponentDepth);
        return out.get();
    }
});

var HmtxTable = deftable({
    parse: function(data) {
        data.offset(this.offset);
        var dir = this.file, hhea = dir.hhea;
        this.metrics = data.times(hhea.numOfLongHorMetrics, function(){
            return {
                advance: data.readShort(),
                lsb: data.readShort_()
            };
        });
        var lsbCount = dir.maxp.numGlyphs - dir.hhea.numOfLongHorMetrics;
        this.leftSideBearings = data.times(lsbCount, data.readShort_);
    },
    forGlyph: function(id) {
        var metrics = this.metrics;
        var n = metrics.length;
        if (id < n) {
            return metrics[id];
        }
        return {
            advance: metrics[n - 1].advance,
            lsb: this.leftSideBearings[id - n]
        };
    },
    render: function(glyphIds) {
        var this$1 = this;

        var out = Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* BinaryStream */])();
        for (var i = 0; i < glyphIds.length; ++i) {
            var m = this$1.forGlyph(glyphIds[i]);
            out.writeShort(m.advance);
            out.writeShort_(m.lsb);
        }
        return out.get();
    }
});

var GlyfTable = (function(){

    function SimpleGlyph(raw) {
        this.raw = raw;
    }
    SimpleGlyph.prototype = {
        compound: false,
        render: function() {
            return this.raw.get();
        }
    };

    var ARG_1_AND_2_ARE_WORDS     = 0x0001;
    var WE_HAVE_A_SCALE           = 0x0008;
    var MORE_COMPONENTS           = 0x0020;
    var WE_HAVE_AN_X_AND_Y_SCALE  = 0x0040;
    var WE_HAVE_A_TWO_BY_TWO      = 0x0080;
    //var WE_HAVE_INSTRUCTIONS      = 0x0100;

    function CompoundGlyph(data) {
        this.raw = data;
        var ids = this.glyphIds = [];
        var offsets = this.idOffsets = [];
        while (true) {          // eslint-disable-line no-constant-condition
            var flags = data.readShort();
            offsets.push(data.offset());
            ids.push(data.readShort());

            if (!(flags & MORE_COMPONENTS)) {
                break;
            }

            data.skip(flags & ARG_1_AND_2_ARE_WORDS ? 4 : 2);

            if (flags & WE_HAVE_A_TWO_BY_TWO) {
                data.skip(8);
            } else if (flags & WE_HAVE_AN_X_AND_Y_SCALE) {
                data.skip(4);
            } else if (flags & WE_HAVE_A_SCALE) {
                data.skip(2);
            }
        }
    }

    CompoundGlyph.prototype = {
        compound: true,
        render: function(old2new) {
            var this$1 = this;

            var out = Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* BinaryStream */])(this.raw.get());
            for (var i = 0; i < this.glyphIds.length; ++i) {
                var id = this$1.glyphIds[i];
                out.offset(this$1.idOffsets[i]);
                out.writeShort(old2new[id]);
            }
            return out.get();
        }
    };

    return deftable({
        parse: function() {
            this.cache = {};
        },
        glyphFor: function(id) {
            var cache = this.cache;
            if (hasOwnProperty(cache, id)) {
                return cache[id];
            }

            var loca = this.file.loca;
            var length = loca.lengthOf(id);

            if (length === 0) {
                return (cache[id] = null);
            }

            var data = this.rawData;
            var offset = this.offset + loca.offsetOf(id);
            var raw = Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* BinaryStream */])(data.slice(offset, length));

            var numberOfContours = raw.readShort_();
            var xMin = raw.readShort_();
            var yMin = raw.readShort_();
            var xMax = raw.readShort_();
            var yMax = raw.readShort_();

            var glyph = cache[id] = numberOfContours == -1 ? new CompoundGlyph(raw) : new SimpleGlyph(raw);

            glyph.numberOfContours = numberOfContours;
            glyph.xMin = xMin;
            glyph.yMin = yMin;
            glyph.xMax = xMax;
            glyph.yMax = yMax;

            return glyph;
        },
        render: function(glyphs, oldIds, old2new) {
            var out = Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* BinaryStream */])(), offsets = [];
            for (var i = 0; i < oldIds.length; ++i) {
                var id = oldIds[i];
                var glyph = glyphs[id];
                offsets.push(out.offset());
                if (glyph) {
                    out.write(glyph.render(old2new));
                }
            }
            offsets.push(out.offset());
            return {
                table: out.get(),
                offsets: offsets
            };
        }
    });

}());

var NameTable = (function(){

    function NameEntry(text, entry) {
        this.text = text;
        this.length = text.length;
        this.platformID = entry.platformID;
        this.platformSpecificID = entry.platformSpecificID;
        this.languageID = entry.languageID;
        this.nameID = entry.nameID;
    }

    return deftable({
        parse: function(data) {
            data.offset(this.offset);
            data.readShort();   // format
            var count = data.readShort();
            var stringOffset = this.offset + data.readShort();
            var nameRecords = data.times(count, function(){
                return {
                    platformID         : data.readShort(),
                    platformSpecificID : data.readShort(),
                    languageID         : data.readShort(),
                    nameID             : data.readShort(),
                    length             : data.readShort(),
                    offset             : data.readShort() + stringOffset
                };
            });
            var strings = this.strings = {};
            for (var i = 0; i < nameRecords.length; ++i) {
                var rec = nameRecords[i];
                data.offset(rec.offset);
                var text = data.readString(rec.length);
                if (!strings[rec.nameID]) {
                    strings[rec.nameID] = [];
                }
                strings[rec.nameID].push(new NameEntry(text, rec));
            }
            this.postscriptEntry = strings[6][0];
            this.postscriptName = this.postscriptEntry.text.replace(/[^\x20-\x7F]/g, "");
        },

        render: function(psName) {
            var this$1 = this;

            var strings = this.strings;
            var strCount = 0;
            for (var i in strings) {
                if (hasOwnProperty(strings, i)) {
                    strCount += strings[i].length;
                }
            }
            var out = Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* BinaryStream */])();
            var strTable = Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* BinaryStream */])();

            out.writeShort(0);  // format
            out.writeShort(strCount);
            out.writeShort(6 + 12 * strCount); // stringOffset

            for (i in strings) {
                if (hasOwnProperty(strings, i)) {
                    var list = i == 6 ? [
                        new NameEntry(psName, this$1.postscriptEntry)
                    ] : strings[i];
                    for (var j = 0; j < list.length; ++j) {
                        var str = list[j];
                        out.writeShort(str.platformID);
                        out.writeShort(str.platformSpecificID);
                        out.writeShort(str.languageID);
                        out.writeShort(str.nameID);
                        out.writeShort(str.length);
                        out.writeShort(strTable.offset());

                        strTable.writeString(str.text);
                    }
                }
            }

            out.write(strTable.get());

            return out.get();
        }
    });

})();

var PostTable = (function(){

    var POSTSCRIPT_GLYPHS = ".notdef .null nonmarkingreturn space exclam quotedbl numbersign dollar percent ampersand quotesingle parenleft parenright asterisk plus comma hyphen period slash zero one two three four five six seven eight nine colon semicolon less equal greater question at A B C D E F G H I J K L M N O P Q R S T U V W X Y Z bracketleft backslash bracketright asciicircum underscore grave a b c d e f g h i j k l m n o p q r s t u v w x y z braceleft bar braceright asciitilde Adieresis Aring Ccedilla Eacute Ntilde Odieresis Udieresis aacute agrave acircumflex adieresis atilde aring ccedilla eacute egrave ecircumflex edieresis iacute igrave icircumflex idieresis ntilde oacute ograve ocircumflex odieresis otilde uacute ugrave ucircumflex udieresis dagger degree cent sterling section bullet paragraph germandbls registered copyright trademark acute dieresis notequal AE Oslash infinity plusminus lessequal greaterequal yen mu partialdiff summation product pi integral ordfeminine ordmasculine Omega ae oslash questiondown exclamdown logicalnot radical florin approxequal Delta guillemotleft guillemotright ellipsis nonbreakingspace Agrave Atilde Otilde OE oe endash emdash quotedblleft quotedblright quoteleft quoteright divide lozenge ydieresis Ydieresis fraction currency guilsinglleft guilsinglright fi fl daggerdbl periodcentered quotesinglbase quotedblbase perthousand Acircumflex Ecircumflex Aacute Edieresis Egrave Iacute Icircumflex Idieresis Igrave Oacute Ocircumflex apple Ograve Uacute Ucircumflex Ugrave dotlessi circumflex tilde macron breve dotaccent ring cedilla hungarumlaut ogonek caron Lslash lslash Scaron scaron Zcaron zcaron brokenbar Eth eth Yacute yacute Thorn thorn minus multiply onesuperior twosuperior threesuperior onehalf onequarter threequarters franc Gbreve gbreve Idotaccent Scedilla scedilla Cacute cacute Ccaron ccaron dcroat".split(/\s+/g);

    return deftable({
        parse: function(data) {
            var this$1 = this;

            data.offset(this.offset);

            this.format = data.readLong();
            this.italicAngle = data.readFixed_();
            this.underlinePosition = data.readShort_();
            this.underlineThickness = data.readShort_();
            this.isFixedPitch = data.readLong();
            this.minMemType42 = data.readLong();
            this.maxMemType42 = data.readLong();
            this.minMemType1 = data.readLong();
            this.maxMemType1 = data.readLong();

            var numberOfGlyphs;

            switch (this.format) {
              case 0x00010000:
              case 0x00030000:
                break;

              case 0x00020000:
                numberOfGlyphs = data.readShort();
                this.glyphNameIndex = data.times(numberOfGlyphs, data.readShort);
                this.names = [];
                var limit = this.offset + this.length;
                while (data.offset() < limit) {
                    this$1.names.push(data.readString(data.readByte()));
                }
                break;

              case 0x00025000:
                numberOfGlyphs = data.readShort();
                this.offsets = data.read(numberOfGlyphs);
                break;

              case 0x00040000:
                this.map = data.times(this.file.maxp.numGlyphs, data.readShort);
                break;
            }
        },
        glyphFor: function(code) {
            switch (this.format) {
              case 0x00010000:
                return POSTSCRIPT_GLYPHS[code] || ".notdef";

              case 0x00020000:
                var index = this.glyphNameIndex[code];
                if (index < POSTSCRIPT_GLYPHS.length) {
                    return POSTSCRIPT_GLYPHS[index];
                }
                return this.names[index - POSTSCRIPT_GLYPHS.length] || ".notdef";

              case 0x00025000:

              case 0x00030000:
                return ".notdef";

              case 0x00040000:
                return this.map[code] || 0xFFFF;
            }
        },
        render: function(mapping) {
            var this$1 = this;

            if (this.format == 0x00030000) {
                return this.raw();
            }

            // keep original header, but set format to 2.0
            var out = Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* BinaryStream */])(this.rawData.slice(this.offset, 32));
            out.writeLong(0x00020000);
            out.offset(32);

            var indexes = [];
            var strings = [];

            for (var i = 0; i < mapping.length; ++i) {
                var id = mapping[i];
                var post = this$1.glyphFor(id);
                var index = POSTSCRIPT_GLYPHS.indexOf(post);
                if (index >= 0) {
                    indexes.push(index);
                } else {
                    indexes.push(POSTSCRIPT_GLYPHS.length + strings.length);
                    strings.push(post);
                }
            }

            out.writeShort(mapping.length);

            for (i = 0; i < indexes.length; ++i) {
                out.writeShort(indexes[i]);
            }

            for (i = 0; i < strings.length; ++i) {
                out.writeByte(strings[i].length);
                out.writeString(strings[i]);
            }

            return out.get();
        }
    });
})();

var CmapTable = (function(){

    function CmapEntry(data, offset, codeMap) {
        var self = this;
        self.platformID = data.readShort();
        self.platformSpecificID = data.readShort();
        self.offset = offset + data.readLong();

        data.saveExcursion(function(){
            var code;
            data.offset(self.offset);
            self.format = data.readShort();

            switch (self.format) {
              case 0:
                self.length = data.readShort();
                self.language = data.readShort();
                for (var i = 0; i < 256; ++i) {
                    codeMap[i] = data.readByte();
                }
                break;

              case 4:
                self.length = data.readShort();
                self.language = data.readShort();
                var segCount = data.readShort() / 2;

                data.skip(6);       // searchRange, entrySelector, rangeShift
                var endCode = data.times(segCount, data.readShort);
                data.skip(2);       // reserved pad
                var startCode = data.times(segCount, data.readShort);
                var idDelta = data.times(segCount, data.readShort_);
                var idRangeOffset = data.times(segCount, data.readShort);

                var count = (self.length + self.offset - data.offset()) / 2;
                var glyphIds = data.times(count, data.readShort);

                for (i = 0; i < segCount; ++i) {
                    var start = startCode[i], end = endCode[i];
                    for (code = start; code <= end; ++code) {
                        var glyphId;
                        if (idRangeOffset[i] === 0) {
                            glyphId = code + idDelta[i];
                        } else {
                            ///
                            // When non-zero, idRangeOffset contains for each segment the byte offset of the Glyph ID
                            // into the glyphIds table, from the *current* `i` cell of idRangeOffset.  In other words,
                            // this offset spans from the first into the second array.  This works, because the arrays
                            // are consecutive in the TTF file:
                            //
                            //     [ ...idRangeOffset... ][ ...glyphIds... ]
                            //       ...... 48 ......       .... ID ....
                            //              ^----- 48 bytes -----^
                            //
                            // (but I can't stop wondering why is it not just a plain index, possibly incremented by 1
                            // so that we can have that special `zero` value.)
                            //
                            // The elements of idRangeOffset are even numbers, because both arrays contain 16-bit words,
                            // yet the offset is in bytes.  That is why we divide it by 2.  Then we subtract the
                            // remaining segments (segCount-i), and add the code-start offset, to which we need to add
                            // the corresponding delta to get the actual glyph ID.
                            ///
                            var index = idRangeOffset[i] / 2 - (segCount - i) + (code - start);
                            glyphId = glyphIds[index] || 0;
                            if (glyphId !== 0) {
                                glyphId += idDelta[i];
                            }
                        }
                        codeMap[code] = glyphId & 0xFFFF;
                    }
                }
                break;

              case 6:
                self.length = data.readShort();
                self.language = data.readShort();
                code = data.readShort();
                var length = data.readShort();
                while (length-- > 0) {
                    codeMap[code++] = data.readShort();
                }
                break;

              case 12:
                data.readShort(); // reserved
                self.length = data.readLong();
                self.language = data.readLong();
                var ngroups = data.readLong();
                while (ngroups-- > 0) {
                    code = data.readLong();
                    var endCharCode = data.readLong();
                    var glyphCode = data.readLong();
                    while (code <= endCharCode) {
                        codeMap[code++] = glyphCode++;
                    }
                }
                break;

              default:
                if (window.console) {
                    window.console.error("Unhandled CMAP format: " + self.format);
                }
            }
        });
    }

    function renderCharmap(ncid2ogid, ogid2ngid) {
        var codes = sortedKeys(ncid2ogid);
        var startCodes = [];
        var endCodes = [];
        var last = null;
        var diff = null;

        function new_gid(charcode) {
            return ogid2ngid[ncid2ogid[charcode]];
        }

        for (var i = 0; i < codes.length; ++i) {
            var code = codes[i];
            var gid = new_gid(code);
            var delta = gid - code;
            if (last == null || delta !== diff) {
                if (last) {
                    endCodes.push(last);
                }
                startCodes.push(code);
                diff = delta;
            }
            last = code;
        }

        if (last) {
            endCodes.push(last);
        }
        endCodes.push(0xFFFF);
        startCodes.push(0xFFFF);

        var segCount = startCodes.length;
        var segCountX2 = segCount * 2;
        var searchRange = 2 * Math.pow(2, Math.floor(Math.log(segCount) / Math.LN2));
        var entrySelector = Math.log(searchRange / 2) / Math.LN2;
        var rangeShift = segCountX2 - searchRange;

        var deltas = [];
        var rangeOffsets = [];
        var glyphIds = [];

        for (i = 0; i < segCount; ++i) {
            var startCode = startCodes[i];
            var endCode = endCodes[i];
            if (startCode == 0xFFFF) {
                deltas.push(0);
                rangeOffsets.push(0);
                break;
            }
            var startGlyph = new_gid(startCode);
            if (startCode - startGlyph >= 0x8000) {
                deltas.push(0);
                rangeOffsets.push(2 * (glyphIds.length + segCount - i));
                for (var j = startCode; j <= endCode; ++j) {
                    glyphIds.push(new_gid(j));
                }
            } else {
                deltas.push(startGlyph - startCode);
                rangeOffsets.push(0);
            }
        }

        var out = Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* BinaryStream */])();

        out.writeShort(3);      // platformID
        out.writeShort(1);      // platformSpecificID
        out.writeLong(12);      // offset
        out.writeShort(4);      // format
        out.writeShort(16 + segCount * 8 + glyphIds.length * 2); // length
        out.writeShort(0);      // language
        out.writeShort(segCountX2);
        out.writeShort(searchRange);
        out.writeShort(entrySelector);
        out.writeShort(rangeShift);

        endCodes.forEach(out.writeShort);
        out.writeShort(0);      // reserved pad
        startCodes.forEach(out.writeShort);
        deltas.forEach(out.writeShort_);
        rangeOffsets.forEach(out.writeShort);
        glyphIds.forEach(out.writeShort);

        return out.get();
    }

    return deftable({
        parse: function(data) {
            var self = this;
            var offset = self.offset;
            data.offset(offset);
            self.codeMap = {};
            self.version = data.readShort();
            var tableCount = data.readShort();
            self.tables = data.times(tableCount, function(){
                return new CmapEntry(data, offset, self.codeMap);
            });
        },
        render: function(ncid2ogid, ogid2ngid) {
            var out = Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* BinaryStream */])();
            out.writeShort(0);  // version
            out.writeShort(1);  // tableCount
            out.write(renderCharmap(ncid2ogid, ogid2ngid));
            return out.get();
        }
    });

})();

var OS2Table = deftable({
    parse: function(data) {
        data.offset(this.offset);
        this.version = data.readShort();
        this.averageCharWidth = data.readShort_();
        this.weightClass = data.readShort();
        this.widthClass = data.readShort();
        this.type = data.readShort();
        this.ySubscriptXSize = data.readShort_();
        this.ySubscriptYSize = data.readShort_();
        this.ySubscriptXOffset = data.readShort_();
        this.ySubscriptYOffset = data.readShort_();
        this.ySuperscriptXSize = data.readShort_();
        this.ySuperscriptYSize = data.readShort_();
        this.ySuperscriptXOffset = data.readShort_();
        this.ySuperscriptYOffset = data.readShort_();
        this.yStrikeoutSize = data.readShort_();
        this.yStrikeoutPosition = data.readShort_();
        this.familyClass = data.readShort_();

        this.panose = data.times(10, data.readByte);
        this.charRange = data.times(4, data.readLong);

        this.vendorID = data.readString(4);
        this.selection = data.readShort();
        this.firstCharIndex = data.readShort();
        this.lastCharIndex = data.readShort();

        if (this.version > 0) {
            this.ascent = data.readShort_();
            this.descent = data.readShort_();
            this.lineGap = data.readShort_();
            this.winAscent = data.readShort();
            this.winDescent = data.readShort();
            this.codePageRange = data.times(2, data.readLong);

            if (this.version > 1) {
                this.xHeight = data.readShort();
                this.capHeight = data.readShort();
                this.defaultChar = data.readShort();
                this.breakChar = data.readShort();
                this.maxContext = data.readShort();
            }
        }
    },
    render: function() {
        return this.raw();
    }
});

var subsetTag = 100000;

function nextSubsetTag() {
    var ret = "", n = String(subsetTag);
    for (var i = 0; i < n.length; ++i) {
        ret += String.fromCharCode(n.charCodeAt(i) - 48 + 65);
    }
    ++subsetTag;
    return ret;
}

function Subfont(font) {
    this.font = font;
    this.subset = {};
    this.unicodes = {};
    this.ogid2ngid = { 0: 0 };
    this.ngid2ogid = { 0: 0 };
    this.ncid2ogid = {};
    this.next = this.firstChar = 1;
    this.nextGid = 1;
    this.psName = nextSubsetTag() + "+" + this.font.psName;
}

Subfont.prototype = {
    use: function(ch) {
        var self = this;
        if (typeof ch == "string") {
            return Object(__WEBPACK_IMPORTED_MODULE_0__utils__["d" /* ucs2decode */])(ch).reduce(function(ret, code){
                return ret + String.fromCharCode(self.use(code));
            }, "");
        }
        var code = self.unicodes[ch];
        if (!code) {
            code = self.next++;
            self.subset[code] = ch;
            self.unicodes[ch] = code;

            // generate new GID (glyph ID) and maintain newGID ->
            // oldGID and back mappings
            var old_gid = self.font.cmap.codeMap[ch];
            if (old_gid) {
                self.ncid2ogid[code] = old_gid;
                if (self.ogid2ngid[old_gid] == null) {
                    var new_gid = self.nextGid++;
                    self.ogid2ngid[old_gid] = new_gid;
                    self.ngid2ogid[new_gid] = old_gid;
                }
            }
        }
        return code;
    },
    encodeText: function(text) {
        return this.use(text);
    },
    glyphIds: function() {
        return sortedKeys(this.ogid2ngid);
    },
    glyphsFor: function(glyphIds, result) {
        var this$1 = this;

        if (!result) {
            result = {};
        }
        for (var i = 0; i < glyphIds.length; ++i) {
            var id = glyphIds[i];
            if (!result[id]) {
                var glyph = result[id] = this$1.font.glyf.glyphFor(id);
                if (glyph && glyph.compound) {
                    this$1.glyphsFor(glyph.glyphIds, result);
                }
            }
        }
        return result;
    },
    render: function() {
        var this$1 = this;

        var glyphs = this.glyphsFor(this.glyphIds());

        // add missing sub-glyphs
        for (var old_gid in glyphs) {
            if (hasOwnProperty(glyphs, old_gid)) {
                old_gid = parseInt(old_gid, 10);
                if (this$1.ogid2ngid[old_gid] == null) {
                    var new_gid = this$1.nextGid++;
                    this$1.ogid2ngid[old_gid] = new_gid;
                    this$1.ngid2ogid[new_gid] = old_gid;
                }
            }
        }

        // must obtain old_gid_ids in an order matching sorted
        // new_gid_ids
        var new_gid_ids = sortedKeys(this.ngid2ogid);
        var old_gid_ids = new_gid_ids.map(function(id){
            return this.ngid2ogid[id];
        }, this);

        var font = this.font;
        var glyf = font.glyf.render(glyphs, old_gid_ids, this.ogid2ngid);
        var loca = font.loca.render(glyf.offsets);

        this.lastChar = this.next - 1;

        var tables = {
            "cmap" : CmapTable.render(this.ncid2ogid, this.ogid2ngid),
            "glyf" : glyf.table,
            "loca" : loca.table,
            "hmtx" : font.hmtx.render(old_gid_ids),
            "hhea" : font.hhea.render(old_gid_ids),
            "maxp" : font.maxp.render(old_gid_ids),
            "post" : font.post.render(old_gid_ids),
            "name" : font.name.render(this.psName),
            "head" : font.head.render(loca.format),
            "OS/2" : font.os2.render()
        };

        return this.font.directory.render(tables);
    },
    cidToGidMap: function() {
        var this$1 = this;

        var out = Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* BinaryStream */])(), len = 0;
        for (var cid = this.firstChar; cid < this.next; ++cid) {
            while (len < cid) {
                out.writeShort(0);
                len++;
            }
            var old_gid = this$1.ncid2ogid[cid];
            if (old_gid) {
                var new_gid = this$1.ogid2ngid[old_gid];
                out.writeShort(new_gid);
            } else {
                out.writeShort(0);
            }
            len++;
        }
        return out.get();
    }
};

function TTFFont(rawData, name) {
    var self = this;
    var data = self.contents = Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* BinaryStream */])(rawData);
    if (data.readString(4) == "ttcf") {
        var offset;
        var parse = function() {
            data.offset(offset);
            self.parse();
        };
        if (!name) {
            throw new Error("Must specify a name for TTC files");
        }
        data.readLong();        // version
        var numFonts = data.readLong();
        for (var i = 0; i < numFonts; ++i) {
            offset = data.readLong();
            data.saveExcursion(parse);
            if (self.psName == name) {
                return;
            }
        }
        throw new Error("Font " + name + " not found in collection");
    } else {
        data.offset(0);
        self.parse();
    }
}

TTFFont.prototype = {
    parse: function() {
        var dir = this.directory = new Directory(this.contents);

        this.head = dir.readTable("head", HeadTable);
        this.loca = dir.readTable("loca", LocaTable);
        this.hhea = dir.readTable("hhea", HheaTable);
        this.maxp = dir.readTable("maxp", MaxpTable);
        this.hmtx = dir.readTable("hmtx", HmtxTable);
        this.glyf = dir.readTable("glyf", GlyfTable);
        this.name = dir.readTable("name", NameTable);
        this.post = dir.readTable("post", PostTable);
        this.cmap = dir.readTable("cmap", CmapTable);
        this.os2  = dir.readTable("OS/2", OS2Table);

        this.psName = this.name.postscriptName;
        this.ascent = this.os2.ascent || this.hhea.ascent;
        this.descent = this.os2.descent || this.hhea.descent;
        this.lineGap = this.os2.lineGap || this.hhea.lineGap;
        this.scale = 1000 / this.head.unitsPerEm;
    },
    widthOfGlyph: function(glyph) {
        return this.hmtx.forGlyph(glyph).advance * this.scale;
    },
    makeSubset: function() {
        return new Subfont(this);
    }
};




/***/ }),
/* 2580 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return deflate; });
/* harmony export (immutable) */ __webpack_exports__["b"] = supportsDeflate;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_pako_dist_pako_deflate__ = __webpack_require__(2581);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_pako_dist_pako_deflate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_pako_dist_pako_deflate__);


var deflate = __WEBPACK_IMPORTED_MODULE_0_pako_dist_pako_deflate__["deflate"];

function supportsDeflate() {
    return true;
}



/***/ }),
/* 2581 */
/***/ (function(module, exports, __webpack_require__) {

var require;var require;/* pako 1.0.8 nodeca/pako */(function(f){if(true){module.exports=f()}else if(typeof define==="function"&&define.amd){define([],f)}else{var g;if(typeof window!=="undefined"){g=window}else if(typeof global!=="undefined"){g=global}else if(typeof self!=="undefined"){g=self}else{g=this}g.pako = f()}})(function(){var define,module,exports;return (function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return require(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
'use strict';


var TYPED_OK =  (typeof Uint8Array !== 'undefined') &&
                (typeof Uint16Array !== 'undefined') &&
                (typeof Int32Array !== 'undefined');

function _has(obj, key) {
  return Object.prototype.hasOwnProperty.call(obj, key);
}

exports.assign = function (obj /*from1, from2, from3, ...*/) {
  var sources = Array.prototype.slice.call(arguments, 1);
  while (sources.length) {
    var source = sources.shift();
    if (!source) { continue; }

    if (typeof source !== 'object') {
      throw new TypeError(source + 'must be non-object');
    }

    for (var p in source) {
      if (_has(source, p)) {
        obj[p] = source[p];
      }
    }
  }

  return obj;
};


// reduce buffer size, avoiding mem copy
exports.shrinkBuf = function (buf, size) {
  if (buf.length === size) { return buf; }
  if (buf.subarray) { return buf.subarray(0, size); }
  buf.length = size;
  return buf;
};


var fnTyped = {
  arraySet: function (dest, src, src_offs, len, dest_offs) {
    if (src.subarray && dest.subarray) {
      dest.set(src.subarray(src_offs, src_offs + len), dest_offs);
      return;
    }
    // Fallback to ordinary array
    for (var i = 0; i < len; i++) {
      dest[dest_offs + i] = src[src_offs + i];
    }
  },
  // Join array of chunks to single array.
  flattenChunks: function (chunks) {
    var i, l, len, pos, chunk, result;

    // calculate data length
    len = 0;
    for (i = 0, l = chunks.length; i < l; i++) {
      len += chunks[i].length;
    }

    // join chunks
    result = new Uint8Array(len);
    pos = 0;
    for (i = 0, l = chunks.length; i < l; i++) {
      chunk = chunks[i];
      result.set(chunk, pos);
      pos += chunk.length;
    }

    return result;
  }
};

var fnUntyped = {
  arraySet: function (dest, src, src_offs, len, dest_offs) {
    for (var i = 0; i < len; i++) {
      dest[dest_offs + i] = src[src_offs + i];
    }
  },
  // Join array of chunks to single array.
  flattenChunks: function (chunks) {
    return [].concat.apply([], chunks);
  }
};


// Enable/Disable typed arrays use, for testing
//
exports.setTyped = function (on) {
  if (on) {
    exports.Buf8  = Uint8Array;
    exports.Buf16 = Uint16Array;
    exports.Buf32 = Int32Array;
    exports.assign(exports, fnTyped);
  } else {
    exports.Buf8  = Array;
    exports.Buf16 = Array;
    exports.Buf32 = Array;
    exports.assign(exports, fnUntyped);
  }
};

exports.setTyped(TYPED_OK);

},{}],2:[function(require,module,exports){
// String encode/decode helpers
'use strict';


var utils = require('./common');


// Quick check if we can use fast array to bin string conversion
//
// - apply(Array) can fail on Android 2.2
// - apply(Uint8Array) can fail on iOS 5.1 Safari
//
var STR_APPLY_OK = true;
var STR_APPLY_UIA_OK = true;

try { String.fromCharCode.apply(null, [ 0 ]); } catch (__) { STR_APPLY_OK = false; }
try { String.fromCharCode.apply(null, new Uint8Array(1)); } catch (__) { STR_APPLY_UIA_OK = false; }


// Table with utf8 lengths (calculated by first byte of sequence)
// Note, that 5 & 6-byte values and some 4-byte values can not be represented in JS,
// because max possible codepoint is 0x10ffff
var _utf8len = new utils.Buf8(256);
for (var q = 0; q < 256; q++) {
  _utf8len[q] = (q >= 252 ? 6 : q >= 248 ? 5 : q >= 240 ? 4 : q >= 224 ? 3 : q >= 192 ? 2 : 1);
}
_utf8len[254] = _utf8len[254] = 1; // Invalid sequence start


// convert string to array (typed, when possible)
exports.string2buf = function (str) {
  var buf, c, c2, m_pos, i, str_len = str.length, buf_len = 0;

  // count binary size
  for (m_pos = 0; m_pos < str_len; m_pos++) {
    c = str.charCodeAt(m_pos);
    if ((c & 0xfc00) === 0xd800 && (m_pos + 1 < str_len)) {
      c2 = str.charCodeAt(m_pos + 1);
      if ((c2 & 0xfc00) === 0xdc00) {
        c = 0x10000 + ((c - 0xd800) << 10) + (c2 - 0xdc00);
        m_pos++;
      }
    }
    buf_len += c < 0x80 ? 1 : c < 0x800 ? 2 : c < 0x10000 ? 3 : 4;
  }

  // allocate buffer
  buf = new utils.Buf8(buf_len);

  // convert
  for (i = 0, m_pos = 0; i < buf_len; m_pos++) {
    c = str.charCodeAt(m_pos);
    if ((c & 0xfc00) === 0xd800 && (m_pos + 1 < str_len)) {
      c2 = str.charCodeAt(m_pos + 1);
      if ((c2 & 0xfc00) === 0xdc00) {
        c = 0x10000 + ((c - 0xd800) << 10) + (c2 - 0xdc00);
        m_pos++;
      }
    }
    if (c < 0x80) {
      /* one byte */
      buf[i++] = c;
    } else if (c < 0x800) {
      /* two bytes */
      buf[i++] = 0xC0 | (c >>> 6);
      buf[i++] = 0x80 | (c & 0x3f);
    } else if (c < 0x10000) {
      /* three bytes */
      buf[i++] = 0xE0 | (c >>> 12);
      buf[i++] = 0x80 | (c >>> 6 & 0x3f);
      buf[i++] = 0x80 | (c & 0x3f);
    } else {
      /* four bytes */
      buf[i++] = 0xf0 | (c >>> 18);
      buf[i++] = 0x80 | (c >>> 12 & 0x3f);
      buf[i++] = 0x80 | (c >>> 6 & 0x3f);
      buf[i++] = 0x80 | (c & 0x3f);
    }
  }

  return buf;
};

// Helper (used in 2 places)
function buf2binstring(buf, len) {
  // On Chrome, the arguments in a function call that are allowed is `65534`.
  // If the length of the buffer is smaller than that, we can use this optimization,
  // otherwise we will take a slower path.
  if (len < 65534) {
    if ((buf.subarray && STR_APPLY_UIA_OK) || (!buf.subarray && STR_APPLY_OK)) {
      return String.fromCharCode.apply(null, utils.shrinkBuf(buf, len));
    }
  }

  var result = '';
  for (var i = 0; i < len; i++) {
    result += String.fromCharCode(buf[i]);
  }
  return result;
}


// Convert byte array to binary string
exports.buf2binstring = function (buf) {
  return buf2binstring(buf, buf.length);
};


// Convert binary string (typed, when possible)
exports.binstring2buf = function (str) {
  var buf = new utils.Buf8(str.length);
  for (var i = 0, len = buf.length; i < len; i++) {
    buf[i] = str.charCodeAt(i);
  }
  return buf;
};


// convert array to string
exports.buf2string = function (buf, max) {
  var i, out, c, c_len;
  var len = max || buf.length;

  // Reserve max possible length (2 words per char)
  // NB: by unknown reasons, Array is significantly faster for
  //     String.fromCharCode.apply than Uint16Array.
  var utf16buf = new Array(len * 2);

  for (out = 0, i = 0; i < len;) {
    c = buf[i++];
    // quick process ascii
    if (c < 0x80) { utf16buf[out++] = c; continue; }

    c_len = _utf8len[c];
    // skip 5 & 6 byte codes
    if (c_len > 4) { utf16buf[out++] = 0xfffd; i += c_len - 1; continue; }

    // apply mask on first byte
    c &= c_len === 2 ? 0x1f : c_len === 3 ? 0x0f : 0x07;
    // join the rest
    while (c_len > 1 && i < len) {
      c = (c << 6) | (buf[i++] & 0x3f);
      c_len--;
    }

    // terminated by end of string?
    if (c_len > 1) { utf16buf[out++] = 0xfffd; continue; }

    if (c < 0x10000) {
      utf16buf[out++] = c;
    } else {
      c -= 0x10000;
      utf16buf[out++] = 0xd800 | ((c >> 10) & 0x3ff);
      utf16buf[out++] = 0xdc00 | (c & 0x3ff);
    }
  }

  return buf2binstring(utf16buf, out);
};


// Calculate max possible position in utf8 buffer,
// that will not break sequence. If that's not possible
// - (very small limits) return max size as is.
//
// buf[] - utf8 bytes array
// max   - length limit (mandatory);
exports.utf8border = function (buf, max) {
  var pos;

  max = max || buf.length;
  if (max > buf.length) { max = buf.length; }

  // go back from last position, until start of sequence found
  pos = max - 1;
  while (pos >= 0 && (buf[pos] & 0xC0) === 0x80) { pos--; }

  // Very small and broken sequence,
  // return max, because we should return something anyway.
  if (pos < 0) { return max; }

  // If we came to start of buffer - that means buffer is too small,
  // return max too.
  if (pos === 0) { return max; }

  return (pos + _utf8len[buf[pos]] > max) ? pos : max;
};

},{"./common":1}],3:[function(require,module,exports){
'use strict';

// Note: adler32 takes 12% for level 0 and 2% for level 6.
// It isn't worth it to make additional optimizations as in original.
// Small size is preferable.

// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.

function adler32(adler, buf, len, pos) {
  var s1 = (adler & 0xffff) |0,
      s2 = ((adler >>> 16) & 0xffff) |0,
      n = 0;

  while (len !== 0) {
    // Set limit ~ twice less than 5552, to keep
    // s2 in 31-bits, because we force signed ints.
    // in other case %= will fail.
    n = len > 2000 ? 2000 : len;
    len -= n;

    do {
      s1 = (s1 + buf[pos++]) |0;
      s2 = (s2 + s1) |0;
    } while (--n);

    s1 %= 65521;
    s2 %= 65521;
  }

  return (s1 | (s2 << 16)) |0;
}


module.exports = adler32;

},{}],4:[function(require,module,exports){
'use strict';

// Note: we can't get significant speed boost here.
// So write code to minimize size - no pregenerated tables
// and array tools dependencies.

// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.

// Use ordinary array, since untyped makes no boost here
function makeTable() {
  var c, table = [];

  for (var n = 0; n < 256; n++) {
    c = n;
    for (var k = 0; k < 8; k++) {
      c = ((c & 1) ? (0xEDB88320 ^ (c >>> 1)) : (c >>> 1));
    }
    table[n] = c;
  }

  return table;
}

// Create table on load. Just 255 signed longs. Not a problem.
var crcTable = makeTable();


function crc32(crc, buf, len, pos) {
  var t = crcTable,
      end = pos + len;

  crc ^= -1;

  for (var i = pos; i < end; i++) {
    crc = (crc >>> 8) ^ t[(crc ^ buf[i]) & 0xFF];
  }

  return (crc ^ (-1)); // >>> 0;
}


module.exports = crc32;

},{}],5:[function(require,module,exports){
'use strict';

// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.

var utils   = require('../utils/common');
var trees   = require('./trees');
var adler32 = require('./adler32');
var crc32   = require('./crc32');
var msg     = require('./messages');

/* Public constants ==========================================================*/
/* ===========================================================================*/


/* Allowed flush values; see deflate() and inflate() below for details */
var Z_NO_FLUSH      = 0;
var Z_PARTIAL_FLUSH = 1;
//var Z_SYNC_FLUSH    = 2;
var Z_FULL_FLUSH    = 3;
var Z_FINISH        = 4;
var Z_BLOCK         = 5;
//var Z_TREES         = 6;


/* Return codes for the compression/decompression functions. Negative values
 * are errors, positive values are used for special but normal events.
 */
var Z_OK            = 0;
var Z_STREAM_END    = 1;
//var Z_NEED_DICT     = 2;
//var Z_ERRNO         = -1;
var Z_STREAM_ERROR  = -2;
var Z_DATA_ERROR    = -3;
//var Z_MEM_ERROR     = -4;
var Z_BUF_ERROR     = -5;
//var Z_VERSION_ERROR = -6;


/* compression levels */
//var Z_NO_COMPRESSION      = 0;
//var Z_BEST_SPEED          = 1;
//var Z_BEST_COMPRESSION    = 9;
var Z_DEFAULT_COMPRESSION = -1;


var Z_FILTERED            = 1;
var Z_HUFFMAN_ONLY        = 2;
var Z_RLE                 = 3;
var Z_FIXED               = 4;
var Z_DEFAULT_STRATEGY    = 0;

/* Possible values of the data_type field (though see inflate()) */
//var Z_BINARY              = 0;
//var Z_TEXT                = 1;
//var Z_ASCII               = 1; // = Z_TEXT
var Z_UNKNOWN             = 2;


/* The deflate compression method */
var Z_DEFLATED  = 8;

/*============================================================================*/


var MAX_MEM_LEVEL = 9;
/* Maximum value for memLevel in deflateInit2 */
var MAX_WBITS = 15;
/* 32K LZ77 window */
var DEF_MEM_LEVEL = 8;


var LENGTH_CODES  = 29;
/* number of length codes, not counting the special END_BLOCK code */
var LITERALS      = 256;
/* number of literal bytes 0..255 */
var L_CODES       = LITERALS + 1 + LENGTH_CODES;
/* number of Literal or Length codes, including the END_BLOCK code */
var D_CODES       = 30;
/* number of distance codes */
var BL_CODES      = 19;
/* number of codes used to transfer the bit lengths */
var HEAP_SIZE     = 2 * L_CODES + 1;
/* maximum heap size */
var MAX_BITS  = 15;
/* All codes must not exceed MAX_BITS bits */

var MIN_MATCH = 3;
var MAX_MATCH = 258;
var MIN_LOOKAHEAD = (MAX_MATCH + MIN_MATCH + 1);

var PRESET_DICT = 0x20;

var INIT_STATE = 42;
var EXTRA_STATE = 69;
var NAME_STATE = 73;
var COMMENT_STATE = 91;
var HCRC_STATE = 103;
var BUSY_STATE = 113;
var FINISH_STATE = 666;

var BS_NEED_MORE      = 1; /* block not completed, need more input or more output */
var BS_BLOCK_DONE     = 2; /* block flush performed */
var BS_FINISH_STARTED = 3; /* finish started, need only more output at next deflate */
var BS_FINISH_DONE    = 4; /* finish done, accept no more input or output */

var OS_CODE = 0x03; // Unix :) . Don't detect, use this default.

function err(strm, errorCode) {
  strm.msg = msg[errorCode];
  return errorCode;
}

function rank(f) {
  return ((f) << 1) - ((f) > 4 ? 9 : 0);
}

function zero(buf) { var len = buf.length; while (--len >= 0) { buf[len] = 0; } }


/* =========================================================================
 * Flush as much pending output as possible. All deflate() output goes
 * through this function so some applications may wish to modify it
 * to avoid allocating a large strm->output buffer and copying into it.
 * (See also read_buf()).
 */
function flush_pending(strm) {
  var s = strm.state;

  //_tr_flush_bits(s);
  var len = s.pending;
  if (len > strm.avail_out) {
    len = strm.avail_out;
  }
  if (len === 0) { return; }

  utils.arraySet(strm.output, s.pending_buf, s.pending_out, len, strm.next_out);
  strm.next_out += len;
  s.pending_out += len;
  strm.total_out += len;
  strm.avail_out -= len;
  s.pending -= len;
  if (s.pending === 0) {
    s.pending_out = 0;
  }
}


function flush_block_only(s, last) {
  trees._tr_flush_block(s, (s.block_start >= 0 ? s.block_start : -1), s.strstart - s.block_start, last);
  s.block_start = s.strstart;
  flush_pending(s.strm);
}


function put_byte(s, b) {
  s.pending_buf[s.pending++] = b;
}


/* =========================================================================
 * Put a short in the pending buffer. The 16-bit value is put in MSB order.
 * IN assertion: the stream state is correct and there is enough room in
 * pending_buf.
 */
function putShortMSB(s, b) {
//  put_byte(s, (Byte)(b >> 8));
//  put_byte(s, (Byte)(b & 0xff));
  s.pending_buf[s.pending++] = (b >>> 8) & 0xff;
  s.pending_buf[s.pending++] = b & 0xff;
}


/* ===========================================================================
 * Read a new buffer from the current input stream, update the adler32
 * and total number of bytes read.  All deflate() input goes through
 * this function so some applications may wish to modify it to avoid
 * allocating a large strm->input buffer and copying from it.
 * (See also flush_pending()).
 */
function read_buf(strm, buf, start, size) {
  var len = strm.avail_in;

  if (len > size) { len = size; }
  if (len === 0) { return 0; }

  strm.avail_in -= len;

  // zmemcpy(buf, strm->next_in, len);
  utils.arraySet(buf, strm.input, strm.next_in, len, start);
  if (strm.state.wrap === 1) {
    strm.adler = adler32(strm.adler, buf, len, start);
  }

  else if (strm.state.wrap === 2) {
    strm.adler = crc32(strm.adler, buf, len, start);
  }

  strm.next_in += len;
  strm.total_in += len;

  return len;
}


/* ===========================================================================
 * Set match_start to the longest match starting at the given string and
 * return its length. Matches shorter or equal to prev_length are discarded,
 * in which case the result is equal to prev_length and match_start is
 * garbage.
 * IN assertions: cur_match is the head of the hash chain for the current
 *   string (strstart) and its distance is <= MAX_DIST, and prev_length >= 1
 * OUT assertion: the match length is not greater than s->lookahead.
 */
function longest_match(s, cur_match) {
  var chain_length = s.max_chain_length;      /* max hash chain length */
  var scan = s.strstart; /* current string */
  var match;                       /* matched string */
  var len;                           /* length of current match */
  var best_len = s.prev_length;              /* best match length so far */
  var nice_match = s.nice_match;             /* stop if match long enough */
  var limit = (s.strstart > (s.w_size - MIN_LOOKAHEAD)) ?
      s.strstart - (s.w_size - MIN_LOOKAHEAD) : 0/*NIL*/;

  var _win = s.window; // shortcut

  var wmask = s.w_mask;
  var prev  = s.prev;

  /* Stop when cur_match becomes <= limit. To simplify the code,
   * we prevent matches with the string of window index 0.
   */

  var strend = s.strstart + MAX_MATCH;
  var scan_end1  = _win[scan + best_len - 1];
  var scan_end   = _win[scan + best_len];

  /* The code is optimized for HASH_BITS >= 8 and MAX_MATCH-2 multiple of 16.
   * It is easy to get rid of this optimization if necessary.
   */
  // Assert(s->hash_bits >= 8 && MAX_MATCH == 258, "Code too clever");

  /* Do not waste too much time if we already have a good match: */
  if (s.prev_length >= s.good_match) {
    chain_length >>= 2;
  }
  /* Do not look for matches beyond the end of the input. This is necessary
   * to make deflate deterministic.
   */
  if (nice_match > s.lookahead) { nice_match = s.lookahead; }

  // Assert((ulg)s->strstart <= s->window_size-MIN_LOOKAHEAD, "need lookahead");

  do {
    // Assert(cur_match < s->strstart, "no future");
    match = cur_match;

    /* Skip to next match if the match length cannot increase
     * or if the match length is less than 2.  Note that the checks below
     * for insufficient lookahead only occur occasionally for performance
     * reasons.  Therefore uninitialized memory will be accessed, and
     * conditional jumps will be made that depend on those values.
     * However the length of the match is limited to the lookahead, so
     * the output of deflate is not affected by the uninitialized values.
     */

    if (_win[match + best_len]     !== scan_end  ||
        _win[match + best_len - 1] !== scan_end1 ||
        _win[match]                !== _win[scan] ||
        _win[++match]              !== _win[scan + 1]) {
      continue;
    }

    /* The check at best_len-1 can be removed because it will be made
     * again later. (This heuristic is not always a win.)
     * It is not necessary to compare scan[2] and match[2] since they
     * are always equal when the other bytes match, given that
     * the hash keys are equal and that HASH_BITS >= 8.
     */
    scan += 2;
    match++;
    // Assert(*scan == *match, "match[2]?");

    /* We check for insufficient lookahead only every 8th comparison;
     * the 256th check will be made at strstart+258.
     */
    do {
      /*jshint noempty:false*/
    } while (_win[++scan] === _win[++match] && _win[++scan] === _win[++match] &&
             _win[++scan] === _win[++match] && _win[++scan] === _win[++match] &&
             _win[++scan] === _win[++match] && _win[++scan] === _win[++match] &&
             _win[++scan] === _win[++match] && _win[++scan] === _win[++match] &&
             scan < strend);

    // Assert(scan <= s->window+(unsigned)(s->window_size-1), "wild scan");

    len = MAX_MATCH - (strend - scan);
    scan = strend - MAX_MATCH;

    if (len > best_len) {
      s.match_start = cur_match;
      best_len = len;
      if (len >= nice_match) {
        break;
      }
      scan_end1  = _win[scan + best_len - 1];
      scan_end   = _win[scan + best_len];
    }
  } while ((cur_match = prev[cur_match & wmask]) > limit && --chain_length !== 0);

  if (best_len <= s.lookahead) {
    return best_len;
  }
  return s.lookahead;
}


/* ===========================================================================
 * Fill the window when the lookahead becomes insufficient.
 * Updates strstart and lookahead.
 *
 * IN assertion: lookahead < MIN_LOOKAHEAD
 * OUT assertions: strstart <= window_size-MIN_LOOKAHEAD
 *    At least one byte has been read, or avail_in == 0; reads are
 *    performed for at least two bytes (required for the zip translate_eol
 *    option -- not supported here).
 */
function fill_window(s) {
  var _w_size = s.w_size;
  var p, n, m, more, str;

  //Assert(s->lookahead < MIN_LOOKAHEAD, "already enough lookahead");

  do {
    more = s.window_size - s.lookahead - s.strstart;

    // JS ints have 32 bit, block below not needed
    /* Deal with !@#$% 64K limit: */
    //if (sizeof(int) <= 2) {
    //    if (more == 0 && s->strstart == 0 && s->lookahead == 0) {
    //        more = wsize;
    //
    //  } else if (more == (unsigned)(-1)) {
    //        /* Very unlikely, but possible on 16 bit machine if
    //         * strstart == 0 && lookahead == 1 (input done a byte at time)
    //         */
    //        more--;
    //    }
    //}


    /* If the window is almost full and there is insufficient lookahead,
     * move the upper half to the lower one to make room in the upper half.
     */
    if (s.strstart >= _w_size + (_w_size - MIN_LOOKAHEAD)) {

      utils.arraySet(s.window, s.window, _w_size, _w_size, 0);
      s.match_start -= _w_size;
      s.strstart -= _w_size;
      /* we now have strstart >= MAX_DIST */
      s.block_start -= _w_size;

      /* Slide the hash table (could be avoided with 32 bit values
       at the expense of memory usage). We slide even when level == 0
       to keep the hash table consistent if we switch back to level > 0
       later. (Using level 0 permanently is not an optimal usage of
       zlib, so we don't care about this pathological case.)
       */

      n = s.hash_size;
      p = n;
      do {
        m = s.head[--p];
        s.head[p] = (m >= _w_size ? m - _w_size : 0);
      } while (--n);

      n = _w_size;
      p = n;
      do {
        m = s.prev[--p];
        s.prev[p] = (m >= _w_size ? m - _w_size : 0);
        /* If n is not on any hash chain, prev[n] is garbage but
         * its value will never be used.
         */
      } while (--n);

      more += _w_size;
    }
    if (s.strm.avail_in === 0) {
      break;
    }

    /* If there was no sliding:
     *    strstart <= WSIZE+MAX_DIST-1 && lookahead <= MIN_LOOKAHEAD - 1 &&
     *    more == window_size - lookahead - strstart
     * => more >= window_size - (MIN_LOOKAHEAD-1 + WSIZE + MAX_DIST-1)
     * => more >= window_size - 2*WSIZE + 2
     * In the BIG_MEM or MMAP case (not yet supported),
     *   window_size == input_size + MIN_LOOKAHEAD  &&
     *   strstart + s->lookahead <= input_size => more >= MIN_LOOKAHEAD.
     * Otherwise, window_size == 2*WSIZE so more >= 2.
     * If there was sliding, more >= WSIZE. So in all cases, more >= 2.
     */
    //Assert(more >= 2, "more < 2");
    n = read_buf(s.strm, s.window, s.strstart + s.lookahead, more);
    s.lookahead += n;

    /* Initialize the hash value now that we have some input: */
    if (s.lookahead + s.insert >= MIN_MATCH) {
      str = s.strstart - s.insert;
      s.ins_h = s.window[str];

      /* UPDATE_HASH(s, s->ins_h, s->window[str + 1]); */
      s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[str + 1]) & s.hash_mask;
//#if MIN_MATCH != 3
//        Call update_hash() MIN_MATCH-3 more times
//#endif
      while (s.insert) {
        /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */
        s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[str + MIN_MATCH - 1]) & s.hash_mask;

        s.prev[str & s.w_mask] = s.head[s.ins_h];
        s.head[s.ins_h] = str;
        str++;
        s.insert--;
        if (s.lookahead + s.insert < MIN_MATCH) {
          break;
        }
      }
    }
    /* If the whole input has less than MIN_MATCH bytes, ins_h is garbage,
     * but this is not important since only literal bytes will be emitted.
     */

  } while (s.lookahead < MIN_LOOKAHEAD && s.strm.avail_in !== 0);

  /* If the WIN_INIT bytes after the end of the current data have never been
   * written, then zero those bytes in order to avoid memory check reports of
   * the use of uninitialized (or uninitialised as Julian writes) bytes by
   * the longest match routines.  Update the high water mark for the next
   * time through here.  WIN_INIT is set to MAX_MATCH since the longest match
   * routines allow scanning to strstart + MAX_MATCH, ignoring lookahead.
   */
//  if (s.high_water < s.window_size) {
//    var curr = s.strstart + s.lookahead;
//    var init = 0;
//
//    if (s.high_water < curr) {
//      /* Previous high water mark below current data -- zero WIN_INIT
//       * bytes or up to end of window, whichever is less.
//       */
//      init = s.window_size - curr;
//      if (init > WIN_INIT)
//        init = WIN_INIT;
//      zmemzero(s->window + curr, (unsigned)init);
//      s->high_water = curr + init;
//    }
//    else if (s->high_water < (ulg)curr + WIN_INIT) {
//      /* High water mark at or above current data, but below current data
//       * plus WIN_INIT -- zero out to current data plus WIN_INIT, or up
//       * to end of window, whichever is less.
//       */
//      init = (ulg)curr + WIN_INIT - s->high_water;
//      if (init > s->window_size - s->high_water)
//        init = s->window_size - s->high_water;
//      zmemzero(s->window + s->high_water, (unsigned)init);
//      s->high_water += init;
//    }
//  }
//
//  Assert((ulg)s->strstart <= s->window_size - MIN_LOOKAHEAD,
//    "not enough room for search");
}

/* ===========================================================================
 * Copy without compression as much as possible from the input stream, return
 * the current block state.
 * This function does not insert new strings in the dictionary since
 * uncompressible data is probably not useful. This function is used
 * only for the level=0 compression option.
 * NOTE: this function should be optimized to avoid extra copying from
 * window to pending_buf.
 */
function deflate_stored(s, flush) {
  /* Stored blocks are limited to 0xffff bytes, pending_buf is limited
   * to pending_buf_size, and each stored block has a 5 byte header:
   */
  var max_block_size = 0xffff;

  if (max_block_size > s.pending_buf_size - 5) {
    max_block_size = s.pending_buf_size - 5;
  }

  /* Copy as much as possible from input to output: */
  for (;;) {
    /* Fill the window as much as possible: */
    if (s.lookahead <= 1) {

      //Assert(s->strstart < s->w_size+MAX_DIST(s) ||
      //  s->block_start >= (long)s->w_size, "slide too late");
//      if (!(s.strstart < s.w_size + (s.w_size - MIN_LOOKAHEAD) ||
//        s.block_start >= s.w_size)) {
//        throw  new Error("slide too late");
//      }

      fill_window(s);
      if (s.lookahead === 0 && flush === Z_NO_FLUSH) {
        return BS_NEED_MORE;
      }

      if (s.lookahead === 0) {
        break;
      }
      /* flush the current block */
    }
    //Assert(s->block_start >= 0L, "block gone");
//    if (s.block_start < 0) throw new Error("block gone");

    s.strstart += s.lookahead;
    s.lookahead = 0;

    /* Emit a stored block if pending_buf will be full: */
    var max_start = s.block_start + max_block_size;

    if (s.strstart === 0 || s.strstart >= max_start) {
      /* strstart == 0 is possible when wraparound on 16-bit machine */
      s.lookahead = s.strstart - max_start;
      s.strstart = max_start;
      /*** FLUSH_BLOCK(s, 0); ***/
      flush_block_only(s, false);
      if (s.strm.avail_out === 0) {
        return BS_NEED_MORE;
      }
      /***/


    }
    /* Flush if we may have to slide, otherwise block_start may become
     * negative and the data will be gone:
     */
    if (s.strstart - s.block_start >= (s.w_size - MIN_LOOKAHEAD)) {
      /*** FLUSH_BLOCK(s, 0); ***/
      flush_block_only(s, false);
      if (s.strm.avail_out === 0) {
        return BS_NEED_MORE;
      }
      /***/
    }
  }

  s.insert = 0;

  if (flush === Z_FINISH) {
    /*** FLUSH_BLOCK(s, 1); ***/
    flush_block_only(s, true);
    if (s.strm.avail_out === 0) {
      return BS_FINISH_STARTED;
    }
    /***/
    return BS_FINISH_DONE;
  }

  if (s.strstart > s.block_start) {
    /*** FLUSH_BLOCK(s, 0); ***/
    flush_block_only(s, false);
    if (s.strm.avail_out === 0) {
      return BS_NEED_MORE;
    }
    /***/
  }

  return BS_NEED_MORE;
}

/* ===========================================================================
 * Compress as much as possible from the input stream, return the current
 * block state.
 * This function does not perform lazy evaluation of matches and inserts
 * new strings in the dictionary only for unmatched strings or for short
 * matches. It is used only for the fast compression options.
 */
function deflate_fast(s, flush) {
  var hash_head;        /* head of the hash chain */
  var bflush;           /* set if current block must be flushed */

  for (;;) {
    /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the next match, plus MIN_MATCH bytes to insert the
     * string following the next match.
     */
    if (s.lookahead < MIN_LOOKAHEAD) {
      fill_window(s);
      if (s.lookahead < MIN_LOOKAHEAD && flush === Z_NO_FLUSH) {
        return BS_NEED_MORE;
      }
      if (s.lookahead === 0) {
        break; /* flush the current block */
      }
    }

    /* Insert the string window[strstart .. strstart+2] in the
     * dictionary, and set hash_head to the head of the hash chain:
     */
    hash_head = 0/*NIL*/;
    if (s.lookahead >= MIN_MATCH) {
      /*** INSERT_STRING(s, s.strstart, hash_head); ***/
      s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
      hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
      s.head[s.ins_h] = s.strstart;
      /***/
    }

    /* Find the longest match, discarding those <= prev_length.
     * At this point we have always match_length < MIN_MATCH
     */
    if (hash_head !== 0/*NIL*/ && ((s.strstart - hash_head) <= (s.w_size - MIN_LOOKAHEAD))) {
      /* To simplify the code, we prevent matches with the string
       * of window index 0 (in particular we have to avoid a match
       * of the string with itself at the start of the input file).
       */
      s.match_length = longest_match(s, hash_head);
      /* longest_match() sets match_start */
    }
    if (s.match_length >= MIN_MATCH) {
      // check_match(s, s.strstart, s.match_start, s.match_length); // for debug only

      /*** _tr_tally_dist(s, s.strstart - s.match_start,
                     s.match_length - MIN_MATCH, bflush); ***/
      bflush = trees._tr_tally(s, s.strstart - s.match_start, s.match_length - MIN_MATCH);

      s.lookahead -= s.match_length;

      /* Insert new strings in the hash table only if the match length
       * is not too large. This saves time but degrades compression.
       */
      if (s.match_length <= s.max_lazy_match/*max_insert_length*/ && s.lookahead >= MIN_MATCH) {
        s.match_length--; /* string at strstart already in table */
        do {
          s.strstart++;
          /*** INSERT_STRING(s, s.strstart, hash_head); ***/
          s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
          hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
          s.head[s.ins_h] = s.strstart;
          /***/
          /* strstart never exceeds WSIZE-MAX_MATCH, so there are
           * always MIN_MATCH bytes ahead.
           */
        } while (--s.match_length !== 0);
        s.strstart++;
      } else
      {
        s.strstart += s.match_length;
        s.match_length = 0;
        s.ins_h = s.window[s.strstart];
        /* UPDATE_HASH(s, s.ins_h, s.window[s.strstart+1]); */
        s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + 1]) & s.hash_mask;

//#if MIN_MATCH != 3
//                Call UPDATE_HASH() MIN_MATCH-3 more times
//#endif
        /* If lookahead < MIN_MATCH, ins_h is garbage, but it does not
         * matter since it will be recomputed at next deflate call.
         */
      }
    } else {
      /* No match, output a literal byte */
      //Tracevv((stderr,"%c", s.window[s.strstart]));
      /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/
      bflush = trees._tr_tally(s, 0, s.window[s.strstart]);

      s.lookahead--;
      s.strstart++;
    }
    if (bflush) {
      /*** FLUSH_BLOCK(s, 0); ***/
      flush_block_only(s, false);
      if (s.strm.avail_out === 0) {
        return BS_NEED_MORE;
      }
      /***/
    }
  }
  s.insert = ((s.strstart < (MIN_MATCH - 1)) ? s.strstart : MIN_MATCH - 1);
  if (flush === Z_FINISH) {
    /*** FLUSH_BLOCK(s, 1); ***/
    flush_block_only(s, true);
    if (s.strm.avail_out === 0) {
      return BS_FINISH_STARTED;
    }
    /***/
    return BS_FINISH_DONE;
  }
  if (s.last_lit) {
    /*** FLUSH_BLOCK(s, 0); ***/
    flush_block_only(s, false);
    if (s.strm.avail_out === 0) {
      return BS_NEED_MORE;
    }
    /***/
  }
  return BS_BLOCK_DONE;
}

/* ===========================================================================
 * Same as above, but achieves better compression. We use a lazy
 * evaluation for matches: a match is finally adopted only if there is
 * no better match at the next window position.
 */
function deflate_slow(s, flush) {
  var hash_head;          /* head of hash chain */
  var bflush;              /* set if current block must be flushed */

  var max_insert;

  /* Process the input block. */
  for (;;) {
    /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the next match, plus MIN_MATCH bytes to insert the
     * string following the next match.
     */
    if (s.lookahead < MIN_LOOKAHEAD) {
      fill_window(s);
      if (s.lookahead < MIN_LOOKAHEAD && flush === Z_NO_FLUSH) {
        return BS_NEED_MORE;
      }
      if (s.lookahead === 0) { break; } /* flush the current block */
    }

    /* Insert the string window[strstart .. strstart+2] in the
     * dictionary, and set hash_head to the head of the hash chain:
     */
    hash_head = 0/*NIL*/;
    if (s.lookahead >= MIN_MATCH) {
      /*** INSERT_STRING(s, s.strstart, hash_head); ***/
      s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
      hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
      s.head[s.ins_h] = s.strstart;
      /***/
    }

    /* Find the longest match, discarding those <= prev_length.
     */
    s.prev_length = s.match_length;
    s.prev_match = s.match_start;
    s.match_length = MIN_MATCH - 1;

    if (hash_head !== 0/*NIL*/ && s.prev_length < s.max_lazy_match &&
        s.strstart - hash_head <= (s.w_size - MIN_LOOKAHEAD)/*MAX_DIST(s)*/) {
      /* To simplify the code, we prevent matches with the string
       * of window index 0 (in particular we have to avoid a match
       * of the string with itself at the start of the input file).
       */
      s.match_length = longest_match(s, hash_head);
      /* longest_match() sets match_start */

      if (s.match_length <= 5 &&
         (s.strategy === Z_FILTERED || (s.match_length === MIN_MATCH && s.strstart - s.match_start > 4096/*TOO_FAR*/))) {

        /* If prev_match is also MIN_MATCH, match_start is garbage
         * but we will ignore the current match anyway.
         */
        s.match_length = MIN_MATCH - 1;
      }
    }
    /* If there was a match at the previous step and the current
     * match is not better, output the previous match:
     */
    if (s.prev_length >= MIN_MATCH && s.match_length <= s.prev_length) {
      max_insert = s.strstart + s.lookahead - MIN_MATCH;
      /* Do not insert strings in hash table beyond this. */

      //check_match(s, s.strstart-1, s.prev_match, s.prev_length);

      /***_tr_tally_dist(s, s.strstart - 1 - s.prev_match,
                     s.prev_length - MIN_MATCH, bflush);***/
      bflush = trees._tr_tally(s, s.strstart - 1 - s.prev_match, s.prev_length - MIN_MATCH);
      /* Insert in hash table all strings up to the end of the match.
       * strstart-1 and strstart are already inserted. If there is not
       * enough lookahead, the last two strings are not inserted in
       * the hash table.
       */
      s.lookahead -= s.prev_length - 1;
      s.prev_length -= 2;
      do {
        if (++s.strstart <= max_insert) {
          /*** INSERT_STRING(s, s.strstart, hash_head); ***/
          s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
          hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
          s.head[s.ins_h] = s.strstart;
          /***/
        }
      } while (--s.prev_length !== 0);
      s.match_available = 0;
      s.match_length = MIN_MATCH - 1;
      s.strstart++;

      if (bflush) {
        /*** FLUSH_BLOCK(s, 0); ***/
        flush_block_only(s, false);
        if (s.strm.avail_out === 0) {
          return BS_NEED_MORE;
        }
        /***/
      }

    } else if (s.match_available) {
      /* If there was no match at the previous position, output a
       * single literal. If there was a match but the current match
       * is longer, truncate the previous match to a single literal.
       */
      //Tracevv((stderr,"%c", s->window[s->strstart-1]));
      /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/
      bflush = trees._tr_tally(s, 0, s.window[s.strstart - 1]);

      if (bflush) {
        /*** FLUSH_BLOCK_ONLY(s, 0) ***/
        flush_block_only(s, false);
        /***/
      }
      s.strstart++;
      s.lookahead--;
      if (s.strm.avail_out === 0) {
        return BS_NEED_MORE;
      }
    } else {
      /* There is no previous match to compare with, wait for
       * the next step to decide.
       */
      s.match_available = 1;
      s.strstart++;
      s.lookahead--;
    }
  }
  //Assert (flush != Z_NO_FLUSH, "no flush?");
  if (s.match_available) {
    //Tracevv((stderr,"%c", s->window[s->strstart-1]));
    /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/
    bflush = trees._tr_tally(s, 0, s.window[s.strstart - 1]);

    s.match_available = 0;
  }
  s.insert = s.strstart < MIN_MATCH - 1 ? s.strstart : MIN_MATCH - 1;
  if (flush === Z_FINISH) {
    /*** FLUSH_BLOCK(s, 1); ***/
    flush_block_only(s, true);
    if (s.strm.avail_out === 0) {
      return BS_FINISH_STARTED;
    }
    /***/
    return BS_FINISH_DONE;
  }
  if (s.last_lit) {
    /*** FLUSH_BLOCK(s, 0); ***/
    flush_block_only(s, false);
    if (s.strm.avail_out === 0) {
      return BS_NEED_MORE;
    }
    /***/
  }

  return BS_BLOCK_DONE;
}


/* ===========================================================================
 * For Z_RLE, simply look for runs of bytes, generate matches only of distance
 * one.  Do not maintain a hash table.  (It will be regenerated if this run of
 * deflate switches away from Z_RLE.)
 */
function deflate_rle(s, flush) {
  var bflush;            /* set if current block must be flushed */
  var prev;              /* byte at distance one to match */
  var scan, strend;      /* scan goes up to strend for length of run */

  var _win = s.window;

  for (;;) {
    /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the longest run, plus one for the unrolled loop.
     */
    if (s.lookahead <= MAX_MATCH) {
      fill_window(s);
      if (s.lookahead <= MAX_MATCH && flush === Z_NO_FLUSH) {
        return BS_NEED_MORE;
      }
      if (s.lookahead === 0) { break; } /* flush the current block */
    }

    /* See how many times the previous byte repeats */
    s.match_length = 0;
    if (s.lookahead >= MIN_MATCH && s.strstart > 0) {
      scan = s.strstart - 1;
      prev = _win[scan];
      if (prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan]) {
        strend = s.strstart + MAX_MATCH;
        do {
          /*jshint noempty:false*/
        } while (prev === _win[++scan] && prev === _win[++scan] &&
                 prev === _win[++scan] && prev === _win[++scan] &&
                 prev === _win[++scan] && prev === _win[++scan] &&
                 prev === _win[++scan] && prev === _win[++scan] &&
                 scan < strend);
        s.match_length = MAX_MATCH - (strend - scan);
        if (s.match_length > s.lookahead) {
          s.match_length = s.lookahead;
        }
      }
      //Assert(scan <= s->window+(uInt)(s->window_size-1), "wild scan");
    }

    /* Emit match if have run of MIN_MATCH or longer, else emit literal */
    if (s.match_length >= MIN_MATCH) {
      //check_match(s, s.strstart, s.strstart - 1, s.match_length);

      /*** _tr_tally_dist(s, 1, s.match_length - MIN_MATCH, bflush); ***/
      bflush = trees._tr_tally(s, 1, s.match_length - MIN_MATCH);

      s.lookahead -= s.match_length;
      s.strstart += s.match_length;
      s.match_length = 0;
    } else {
      /* No match, output a literal byte */
      //Tracevv((stderr,"%c", s->window[s->strstart]));
      /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/
      bflush = trees._tr_tally(s, 0, s.window[s.strstart]);

      s.lookahead--;
      s.strstart++;
    }
    if (bflush) {
      /*** FLUSH_BLOCK(s, 0); ***/
      flush_block_only(s, false);
      if (s.strm.avail_out === 0) {
        return BS_NEED_MORE;
      }
      /***/
    }
  }
  s.insert = 0;
  if (flush === Z_FINISH) {
    /*** FLUSH_BLOCK(s, 1); ***/
    flush_block_only(s, true);
    if (s.strm.avail_out === 0) {
      return BS_FINISH_STARTED;
    }
    /***/
    return BS_FINISH_DONE;
  }
  if (s.last_lit) {
    /*** FLUSH_BLOCK(s, 0); ***/
    flush_block_only(s, false);
    if (s.strm.avail_out === 0) {
      return BS_NEED_MORE;
    }
    /***/
  }
  return BS_BLOCK_DONE;
}

/* ===========================================================================
 * For Z_HUFFMAN_ONLY, do not look for matches.  Do not maintain a hash table.
 * (It will be regenerated if this run of deflate switches away from Huffman.)
 */
function deflate_huff(s, flush) {
  var bflush;             /* set if current block must be flushed */

  for (;;) {
    /* Make sure that we have a literal to write. */
    if (s.lookahead === 0) {
      fill_window(s);
      if (s.lookahead === 0) {
        if (flush === Z_NO_FLUSH) {
          return BS_NEED_MORE;
        }
        break;      /* flush the current block */
      }
    }

    /* Output a literal byte */
    s.match_length = 0;
    //Tracevv((stderr,"%c", s->window[s->strstart]));
    /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/
    bflush = trees._tr_tally(s, 0, s.window[s.strstart]);
    s.lookahead--;
    s.strstart++;
    if (bflush) {
      /*** FLUSH_BLOCK(s, 0); ***/
      flush_block_only(s, false);
      if (s.strm.avail_out === 0) {
        return BS_NEED_MORE;
      }
      /***/
    }
  }
  s.insert = 0;
  if (flush === Z_FINISH) {
    /*** FLUSH_BLOCK(s, 1); ***/
    flush_block_only(s, true);
    if (s.strm.avail_out === 0) {
      return BS_FINISH_STARTED;
    }
    /***/
    return BS_FINISH_DONE;
  }
  if (s.last_lit) {
    /*** FLUSH_BLOCK(s, 0); ***/
    flush_block_only(s, false);
    if (s.strm.avail_out === 0) {
      return BS_NEED_MORE;
    }
    /***/
  }
  return BS_BLOCK_DONE;
}

/* Values for max_lazy_match, good_match and max_chain_length, depending on
 * the desired pack level (0..9). The values given below have been tuned to
 * exclude worst case performance for pathological files. Better values may be
 * found for specific files.
 */
function Config(good_length, max_lazy, nice_length, max_chain, func) {
  this.good_length = good_length;
  this.max_lazy = max_lazy;
  this.nice_length = nice_length;
  this.max_chain = max_chain;
  this.func = func;
}

var configuration_table;

configuration_table = [
  /*      good lazy nice chain */
  new Config(0, 0, 0, 0, deflate_stored),          /* 0 store only */
  new Config(4, 4, 8, 4, deflate_fast),            /* 1 max speed, no lazy matches */
  new Config(4, 5, 16, 8, deflate_fast),           /* 2 */
  new Config(4, 6, 32, 32, deflate_fast),          /* 3 */

  new Config(4, 4, 16, 16, deflate_slow),          /* 4 lazy matches */
  new Config(8, 16, 32, 32, deflate_slow),         /* 5 */
  new Config(8, 16, 128, 128, deflate_slow),       /* 6 */
  new Config(8, 32, 128, 256, deflate_slow),       /* 7 */
  new Config(32, 128, 258, 1024, deflate_slow),    /* 8 */
  new Config(32, 258, 258, 4096, deflate_slow)     /* 9 max compression */
];


/* ===========================================================================
 * Initialize the "longest match" routines for a new zlib stream
 */
function lm_init(s) {
  s.window_size = 2 * s.w_size;

  /*** CLEAR_HASH(s); ***/
  zero(s.head); // Fill with NIL (= 0);

  /* Set the default configuration parameters:
   */
  s.max_lazy_match = configuration_table[s.level].max_lazy;
  s.good_match = configuration_table[s.level].good_length;
  s.nice_match = configuration_table[s.level].nice_length;
  s.max_chain_length = configuration_table[s.level].max_chain;

  s.strstart = 0;
  s.block_start = 0;
  s.lookahead = 0;
  s.insert = 0;
  s.match_length = s.prev_length = MIN_MATCH - 1;
  s.match_available = 0;
  s.ins_h = 0;
}


function DeflateState() {
  this.strm = null;            /* pointer back to this zlib stream */
  this.status = 0;            /* as the name implies */
  this.pending_buf = null;      /* output still pending */
  this.pending_buf_size = 0;  /* size of pending_buf */
  this.pending_out = 0;       /* next pending byte to output to the stream */
  this.pending = 0;           /* nb of bytes in the pending buffer */
  this.wrap = 0;              /* bit 0 true for zlib, bit 1 true for gzip */
  this.gzhead = null;         /* gzip header information to write */
  this.gzindex = 0;           /* where in extra, name, or comment */
  this.method = Z_DEFLATED; /* can only be DEFLATED */
  this.last_flush = -1;   /* value of flush param for previous deflate call */

  this.w_size = 0;  /* LZ77 window size (32K by default) */
  this.w_bits = 0;  /* log2(w_size)  (8..16) */
  this.w_mask = 0;  /* w_size - 1 */

  this.window = null;
  /* Sliding window. Input bytes are read into the second half of the window,
   * and move to the first half later to keep a dictionary of at least wSize
   * bytes. With this organization, matches are limited to a distance of
   * wSize-MAX_MATCH bytes, but this ensures that IO is always
   * performed with a length multiple of the block size.
   */

  this.window_size = 0;
  /* Actual size of window: 2*wSize, except when the user input buffer
   * is directly used as sliding window.
   */

  this.prev = null;
  /* Link to older string with same hash index. To limit the size of this
   * array to 64K, this link is maintained only for the last 32K strings.
   * An index in this array is thus a window index modulo 32K.
   */

  this.head = null;   /* Heads of the hash chains or NIL. */

  this.ins_h = 0;       /* hash index of string to be inserted */
  this.hash_size = 0;   /* number of elements in hash table */
  this.hash_bits = 0;   /* log2(hash_size) */
  this.hash_mask = 0;   /* hash_size-1 */

  this.hash_shift = 0;
  /* Number of bits by which ins_h must be shifted at each input
   * step. It must be such that after MIN_MATCH steps, the oldest
   * byte no longer takes part in the hash key, that is:
   *   hash_shift * MIN_MATCH >= hash_bits
   */

  this.block_start = 0;
  /* Window position at the beginning of the current output block. Gets
   * negative when the window is moved backwards.
   */

  this.match_length = 0;      /* length of best match */
  this.prev_match = 0;        /* previous match */
  this.match_available = 0;   /* set if previous match exists */
  this.strstart = 0;          /* start of string to insert */
  this.match_start = 0;       /* start of matching string */
  this.lookahead = 0;         /* number of valid bytes ahead in window */

  this.prev_length = 0;
  /* Length of the best match at previous step. Matches not greater than this
   * are discarded. This is used in the lazy match evaluation.
   */

  this.max_chain_length = 0;
  /* To speed up deflation, hash chains are never searched beyond this
   * length.  A higher limit improves compression ratio but degrades the
   * speed.
   */

  this.max_lazy_match = 0;
  /* Attempt to find a better match only when the current match is strictly
   * smaller than this value. This mechanism is used only for compression
   * levels >= 4.
   */
  // That's alias to max_lazy_match, don't use directly
  //this.max_insert_length = 0;
  /* Insert new strings in the hash table only if the match length is not
   * greater than this length. This saves time but degrades compression.
   * max_insert_length is used only for compression levels <= 3.
   */

  this.level = 0;     /* compression level (1..9) */
  this.strategy = 0;  /* favor or force Huffman coding*/

  this.good_match = 0;
  /* Use a faster search when the previous match is longer than this */

  this.nice_match = 0; /* Stop searching when current match exceeds this */

              /* used by trees.c: */

  /* Didn't use ct_data typedef below to suppress compiler warning */

  // struct ct_data_s dyn_ltree[HEAP_SIZE];   /* literal and length tree */
  // struct ct_data_s dyn_dtree[2*D_CODES+1]; /* distance tree */
  // struct ct_data_s bl_tree[2*BL_CODES+1];  /* Huffman tree for bit lengths */

  // Use flat array of DOUBLE size, with interleaved fata,
  // because JS does not support effective
  this.dyn_ltree  = new utils.Buf16(HEAP_SIZE * 2);
  this.dyn_dtree  = new utils.Buf16((2 * D_CODES + 1) * 2);
  this.bl_tree    = new utils.Buf16((2 * BL_CODES + 1) * 2);
  zero(this.dyn_ltree);
  zero(this.dyn_dtree);
  zero(this.bl_tree);

  this.l_desc   = null;         /* desc. for literal tree */
  this.d_desc   = null;         /* desc. for distance tree */
  this.bl_desc  = null;         /* desc. for bit length tree */

  //ush bl_count[MAX_BITS+1];
  this.bl_count = new utils.Buf16(MAX_BITS + 1);
  /* number of codes at each bit length for an optimal tree */

  //int heap[2*L_CODES+1];      /* heap used to build the Huffman trees */
  this.heap = new utils.Buf16(2 * L_CODES + 1);  /* heap used to build the Huffman trees */
  zero(this.heap);

  this.heap_len = 0;               /* number of elements in the heap */
  this.heap_max = 0;               /* element of largest frequency */
  /* The sons of heap[n] are heap[2*n] and heap[2*n+1]. heap[0] is not used.
   * The same heap array is used to build all trees.
   */

  this.depth = new utils.Buf16(2 * L_CODES + 1); //uch depth[2*L_CODES+1];
  zero(this.depth);
  /* Depth of each subtree used as tie breaker for trees of equal frequency
   */

  this.l_buf = 0;          /* buffer index for literals or lengths */

  this.lit_bufsize = 0;
  /* Size of match buffer for literals/lengths.  There are 4 reasons for
   * limiting lit_bufsize to 64K:
   *   - frequencies can be kept in 16 bit counters
   *   - if compression is not successful for the first block, all input
   *     data is still in the window so we can still emit a stored block even
   *     when input comes from standard input.  (This can also be done for
   *     all blocks if lit_bufsize is not greater than 32K.)
   *   - if compression is not successful for a file smaller than 64K, we can
   *     even emit a stored file instead of a stored block (saving 5 bytes).
   *     This is applicable only for zip (not gzip or zlib).
   *   - creating new Huffman trees less frequently may not provide fast
   *     adaptation to changes in the input data statistics. (Take for
   *     example a binary file with poorly compressible code followed by
   *     a highly compressible string table.) Smaller buffer sizes give
   *     fast adaptation but have of course the overhead of transmitting
   *     trees more frequently.
   *   - I can't count above 4
   */

  this.last_lit = 0;      /* running index in l_buf */

  this.d_buf = 0;
  /* Buffer index for distances. To simplify the code, d_buf and l_buf have
   * the same number of elements. To use different lengths, an extra flag
   * array would be necessary.
   */

  this.opt_len = 0;       /* bit length of current block with optimal trees */
  this.static_len = 0;    /* bit length of current block with static trees */
  this.matches = 0;       /* number of string matches in current block */
  this.insert = 0;        /* bytes at end of window left to insert */


  this.bi_buf = 0;
  /* Output buffer. bits are inserted starting at the bottom (least
   * significant bits).
   */
  this.bi_valid = 0;
  /* Number of valid bits in bi_buf.  All bits above the last valid bit
   * are always zero.
   */

  // Used for window memory init. We safely ignore it for JS. That makes
  // sense only for pointers and memory check tools.
  //this.high_water = 0;
  /* High water mark offset in window for initialized bytes -- bytes above
   * this are set to zero in order to avoid memory check warnings when
   * longest match routines access bytes past the input.  This is then
   * updated to the new high water mark.
   */
}


function deflateResetKeep(strm) {
  var s;

  if (!strm || !strm.state) {
    return err(strm, Z_STREAM_ERROR);
  }

  strm.total_in = strm.total_out = 0;
  strm.data_type = Z_UNKNOWN;

  s = strm.state;
  s.pending = 0;
  s.pending_out = 0;

  if (s.wrap < 0) {
    s.wrap = -s.wrap;
    /* was made negative by deflate(..., Z_FINISH); */
  }
  s.status = (s.wrap ? INIT_STATE : BUSY_STATE);
  strm.adler = (s.wrap === 2) ?
    0  // crc32(0, Z_NULL, 0)
  :
    1; // adler32(0, Z_NULL, 0)
  s.last_flush = Z_NO_FLUSH;
  trees._tr_init(s);
  return Z_OK;
}


function deflateReset(strm) {
  var ret = deflateResetKeep(strm);
  if (ret === Z_OK) {
    lm_init(strm.state);
  }
  return ret;
}


function deflateSetHeader(strm, head) {
  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
  if (strm.state.wrap !== 2) { return Z_STREAM_ERROR; }
  strm.state.gzhead = head;
  return Z_OK;
}


function deflateInit2(strm, level, method, windowBits, memLevel, strategy) {
  if (!strm) { // === Z_NULL
    return Z_STREAM_ERROR;
  }
  var wrap = 1;

  if (level === Z_DEFAULT_COMPRESSION) {
    level = 6;
  }

  if (windowBits < 0) { /* suppress zlib wrapper */
    wrap = 0;
    windowBits = -windowBits;
  }

  else if (windowBits > 15) {
    wrap = 2;           /* write gzip wrapper instead */
    windowBits -= 16;
  }


  if (memLevel < 1 || memLevel > MAX_MEM_LEVEL || method !== Z_DEFLATED ||
    windowBits < 8 || windowBits > 15 || level < 0 || level > 9 ||
    strategy < 0 || strategy > Z_FIXED) {
    return err(strm, Z_STREAM_ERROR);
  }


  if (windowBits === 8) {
    windowBits = 9;
  }
  /* until 256-byte window bug fixed */

  var s = new DeflateState();

  strm.state = s;
  s.strm = strm;

  s.wrap = wrap;
  s.gzhead = null;
  s.w_bits = windowBits;
  s.w_size = 1 << s.w_bits;
  s.w_mask = s.w_size - 1;

  s.hash_bits = memLevel + 7;
  s.hash_size = 1 << s.hash_bits;
  s.hash_mask = s.hash_size - 1;
  s.hash_shift = ~~((s.hash_bits + MIN_MATCH - 1) / MIN_MATCH);

  s.window = new utils.Buf8(s.w_size * 2);
  s.head = new utils.Buf16(s.hash_size);
  s.prev = new utils.Buf16(s.w_size);

  // Don't need mem init magic for JS.
  //s.high_water = 0;  /* nothing written to s->window yet */

  s.lit_bufsize = 1 << (memLevel + 6); /* 16K elements by default */

  s.pending_buf_size = s.lit_bufsize * 4;

  //overlay = (ushf *) ZALLOC(strm, s->lit_bufsize, sizeof(ush)+2);
  //s->pending_buf = (uchf *) overlay;
  s.pending_buf = new utils.Buf8(s.pending_buf_size);

  // It is offset from `s.pending_buf` (size is `s.lit_bufsize * 2`)
  //s->d_buf = overlay + s->lit_bufsize/sizeof(ush);
  s.d_buf = 1 * s.lit_bufsize;

  //s->l_buf = s->pending_buf + (1+sizeof(ush))*s->lit_bufsize;
  s.l_buf = (1 + 2) * s.lit_bufsize;

  s.level = level;
  s.strategy = strategy;
  s.method = method;

  return deflateReset(strm);
}

function deflateInit(strm, level) {
  return deflateInit2(strm, level, Z_DEFLATED, MAX_WBITS, DEF_MEM_LEVEL, Z_DEFAULT_STRATEGY);
}


function deflate(strm, flush) {
  var old_flush, s;
  var beg, val; // for gzip header write only

  if (!strm || !strm.state ||
    flush > Z_BLOCK || flush < 0) {
    return strm ? err(strm, Z_STREAM_ERROR) : Z_STREAM_ERROR;
  }

  s = strm.state;

  if (!strm.output ||
      (!strm.input && strm.avail_in !== 0) ||
      (s.status === FINISH_STATE && flush !== Z_FINISH)) {
    return err(strm, (strm.avail_out === 0) ? Z_BUF_ERROR : Z_STREAM_ERROR);
  }

  s.strm = strm; /* just in case */
  old_flush = s.last_flush;
  s.last_flush = flush;

  /* Write the header */
  if (s.status === INIT_STATE) {

    if (s.wrap === 2) { // GZIP header
      strm.adler = 0;  //crc32(0L, Z_NULL, 0);
      put_byte(s, 31);
      put_byte(s, 139);
      put_byte(s, 8);
      if (!s.gzhead) { // s->gzhead == Z_NULL
        put_byte(s, 0);
        put_byte(s, 0);
        put_byte(s, 0);
        put_byte(s, 0);
        put_byte(s, 0);
        put_byte(s, s.level === 9 ? 2 :
                    (s.strategy >= Z_HUFFMAN_ONLY || s.level < 2 ?
                     4 : 0));
        put_byte(s, OS_CODE);
        s.status = BUSY_STATE;
      }
      else {
        put_byte(s, (s.gzhead.text ? 1 : 0) +
                    (s.gzhead.hcrc ? 2 : 0) +
                    (!s.gzhead.extra ? 0 : 4) +
                    (!s.gzhead.name ? 0 : 8) +
                    (!s.gzhead.comment ? 0 : 16)
        );
        put_byte(s, s.gzhead.time & 0xff);
        put_byte(s, (s.gzhead.time >> 8) & 0xff);
        put_byte(s, (s.gzhead.time >> 16) & 0xff);
        put_byte(s, (s.gzhead.time >> 24) & 0xff);
        put_byte(s, s.level === 9 ? 2 :
                    (s.strategy >= Z_HUFFMAN_ONLY || s.level < 2 ?
                     4 : 0));
        put_byte(s, s.gzhead.os & 0xff);
        if (s.gzhead.extra && s.gzhead.extra.length) {
          put_byte(s, s.gzhead.extra.length & 0xff);
          put_byte(s, (s.gzhead.extra.length >> 8) & 0xff);
        }
        if (s.gzhead.hcrc) {
          strm.adler = crc32(strm.adler, s.pending_buf, s.pending, 0);
        }
        s.gzindex = 0;
        s.status = EXTRA_STATE;
      }
    }
    else // DEFLATE header
    {
      var header = (Z_DEFLATED + ((s.w_bits - 8) << 4)) << 8;
      var level_flags = -1;

      if (s.strategy >= Z_HUFFMAN_ONLY || s.level < 2) {
        level_flags = 0;
      } else if (s.level < 6) {
        level_flags = 1;
      } else if (s.level === 6) {
        level_flags = 2;
      } else {
        level_flags = 3;
      }
      header |= (level_flags << 6);
      if (s.strstart !== 0) { header |= PRESET_DICT; }
      header += 31 - (header % 31);

      s.status = BUSY_STATE;
      putShortMSB(s, header);

      /* Save the adler32 of the preset dictionary: */
      if (s.strstart !== 0) {
        putShortMSB(s, strm.adler >>> 16);
        putShortMSB(s, strm.adler & 0xffff);
      }
      strm.adler = 1; // adler32(0L, Z_NULL, 0);
    }
  }

//#ifdef GZIP
  if (s.status === EXTRA_STATE) {
    if (s.gzhead.extra/* != Z_NULL*/) {
      beg = s.pending;  /* start of bytes to update crc */

      while (s.gzindex < (s.gzhead.extra.length & 0xffff)) {
        if (s.pending === s.pending_buf_size) {
          if (s.gzhead.hcrc && s.pending > beg) {
            strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
          }
          flush_pending(strm);
          beg = s.pending;
          if (s.pending === s.pending_buf_size) {
            break;
          }
        }
        put_byte(s, s.gzhead.extra[s.gzindex] & 0xff);
        s.gzindex++;
      }
      if (s.gzhead.hcrc && s.pending > beg) {
        strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
      }
      if (s.gzindex === s.gzhead.extra.length) {
        s.gzindex = 0;
        s.status = NAME_STATE;
      }
    }
    else {
      s.status = NAME_STATE;
    }
  }
  if (s.status === NAME_STATE) {
    if (s.gzhead.name/* != Z_NULL*/) {
      beg = s.pending;  /* start of bytes to update crc */
      //int val;

      do {
        if (s.pending === s.pending_buf_size) {
          if (s.gzhead.hcrc && s.pending > beg) {
            strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
          }
          flush_pending(strm);
          beg = s.pending;
          if (s.pending === s.pending_buf_size) {
            val = 1;
            break;
          }
        }
        // JS specific: little magic to add zero terminator to end of string
        if (s.gzindex < s.gzhead.name.length) {
          val = s.gzhead.name.charCodeAt(s.gzindex++) & 0xff;
        } else {
          val = 0;
        }
        put_byte(s, val);
      } while (val !== 0);

      if (s.gzhead.hcrc && s.pending > beg) {
        strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
      }
      if (val === 0) {
        s.gzindex = 0;
        s.status = COMMENT_STATE;
      }
    }
    else {
      s.status = COMMENT_STATE;
    }
  }
  if (s.status === COMMENT_STATE) {
    if (s.gzhead.comment/* != Z_NULL*/) {
      beg = s.pending;  /* start of bytes to update crc */
      //int val;

      do {
        if (s.pending === s.pending_buf_size) {
          if (s.gzhead.hcrc && s.pending > beg) {
            strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
          }
          flush_pending(strm);
          beg = s.pending;
          if (s.pending === s.pending_buf_size) {
            val = 1;
            break;
          }
        }
        // JS specific: little magic to add zero terminator to end of string
        if (s.gzindex < s.gzhead.comment.length) {
          val = s.gzhead.comment.charCodeAt(s.gzindex++) & 0xff;
        } else {
          val = 0;
        }
        put_byte(s, val);
      } while (val !== 0);

      if (s.gzhead.hcrc && s.pending > beg) {
        strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
      }
      if (val === 0) {
        s.status = HCRC_STATE;
      }
    }
    else {
      s.status = HCRC_STATE;
    }
  }
  if (s.status === HCRC_STATE) {
    if (s.gzhead.hcrc) {
      if (s.pending + 2 > s.pending_buf_size) {
        flush_pending(strm);
      }
      if (s.pending + 2 <= s.pending_buf_size) {
        put_byte(s, strm.adler & 0xff);
        put_byte(s, (strm.adler >> 8) & 0xff);
        strm.adler = 0; //crc32(0L, Z_NULL, 0);
        s.status = BUSY_STATE;
      }
    }
    else {
      s.status = BUSY_STATE;
    }
  }
//#endif

  /* Flush as much pending output as possible */
  if (s.pending !== 0) {
    flush_pending(strm);
    if (strm.avail_out === 0) {
      /* Since avail_out is 0, deflate will be called again with
       * more output space, but possibly with both pending and
       * avail_in equal to zero. There won't be anything to do,
       * but this is not an error situation so make sure we
       * return OK instead of BUF_ERROR at next call of deflate:
       */
      s.last_flush = -1;
      return Z_OK;
    }

    /* Make sure there is something to do and avoid duplicate consecutive
     * flushes. For repeated and useless calls with Z_FINISH, we keep
     * returning Z_STREAM_END instead of Z_BUF_ERROR.
     */
  } else if (strm.avail_in === 0 && rank(flush) <= rank(old_flush) &&
    flush !== Z_FINISH) {
    return err(strm, Z_BUF_ERROR);
  }

  /* User must not provide more input after the first FINISH: */
  if (s.status === FINISH_STATE && strm.avail_in !== 0) {
    return err(strm, Z_BUF_ERROR);
  }

  /* Start a new block or continue the current one.
   */
  if (strm.avail_in !== 0 || s.lookahead !== 0 ||
    (flush !== Z_NO_FLUSH && s.status !== FINISH_STATE)) {
    var bstate = (s.strategy === Z_HUFFMAN_ONLY) ? deflate_huff(s, flush) :
      (s.strategy === Z_RLE ? deflate_rle(s, flush) :
        configuration_table[s.level].func(s, flush));

    if (bstate === BS_FINISH_STARTED || bstate === BS_FINISH_DONE) {
      s.status = FINISH_STATE;
    }
    if (bstate === BS_NEED_MORE || bstate === BS_FINISH_STARTED) {
      if (strm.avail_out === 0) {
        s.last_flush = -1;
        /* avoid BUF_ERROR next call, see above */
      }
      return Z_OK;
      /* If flush != Z_NO_FLUSH && avail_out == 0, the next call
       * of deflate should use the same flush parameter to make sure
       * that the flush is complete. So we don't have to output an
       * empty block here, this will be done at next call. This also
       * ensures that for a very small output buffer, we emit at most
       * one empty block.
       */
    }
    if (bstate === BS_BLOCK_DONE) {
      if (flush === Z_PARTIAL_FLUSH) {
        trees._tr_align(s);
      }
      else if (flush !== Z_BLOCK) { /* FULL_FLUSH or SYNC_FLUSH */

        trees._tr_stored_block(s, 0, 0, false);
        /* For a full flush, this empty block will be recognized
         * as a special marker by inflate_sync().
         */
        if (flush === Z_FULL_FLUSH) {
          /*** CLEAR_HASH(s); ***/             /* forget history */
          zero(s.head); // Fill with NIL (= 0);

          if (s.lookahead === 0) {
            s.strstart = 0;
            s.block_start = 0;
            s.insert = 0;
          }
        }
      }
      flush_pending(strm);
      if (strm.avail_out === 0) {
        s.last_flush = -1; /* avoid BUF_ERROR at next call, see above */
        return Z_OK;
      }
    }
  }
  //Assert(strm->avail_out > 0, "bug2");
  //if (strm.avail_out <= 0) { throw new Error("bug2");}

  if (flush !== Z_FINISH) { return Z_OK; }
  if (s.wrap <= 0) { return Z_STREAM_END; }

  /* Write the trailer */
  if (s.wrap === 2) {
    put_byte(s, strm.adler & 0xff);
    put_byte(s, (strm.adler >> 8) & 0xff);
    put_byte(s, (strm.adler >> 16) & 0xff);
    put_byte(s, (strm.adler >> 24) & 0xff);
    put_byte(s, strm.total_in & 0xff);
    put_byte(s, (strm.total_in >> 8) & 0xff);
    put_byte(s, (strm.total_in >> 16) & 0xff);
    put_byte(s, (strm.total_in >> 24) & 0xff);
  }
  else
  {
    putShortMSB(s, strm.adler >>> 16);
    putShortMSB(s, strm.adler & 0xffff);
  }

  flush_pending(strm);
  /* If avail_out is zero, the application will call deflate again
   * to flush the rest.
   */
  if (s.wrap > 0) { s.wrap = -s.wrap; }
  /* write the trailer only once! */
  return s.pending !== 0 ? Z_OK : Z_STREAM_END;
}

function deflateEnd(strm) {
  var status;

  if (!strm/*== Z_NULL*/ || !strm.state/*== Z_NULL*/) {
    return Z_STREAM_ERROR;
  }

  status = strm.state.status;
  if (status !== INIT_STATE &&
    status !== EXTRA_STATE &&
    status !== NAME_STATE &&
    status !== COMMENT_STATE &&
    status !== HCRC_STATE &&
    status !== BUSY_STATE &&
    status !== FINISH_STATE
  ) {
    return err(strm, Z_STREAM_ERROR);
  }

  strm.state = null;

  return status === BUSY_STATE ? err(strm, Z_DATA_ERROR) : Z_OK;
}


/* =========================================================================
 * Initializes the compression dictionary from the given byte
 * sequence without producing any compressed output.
 */
function deflateSetDictionary(strm, dictionary) {
  var dictLength = dictionary.length;

  var s;
  var str, n;
  var wrap;
  var avail;
  var next;
  var input;
  var tmpDict;

  if (!strm/*== Z_NULL*/ || !strm.state/*== Z_NULL*/) {
    return Z_STREAM_ERROR;
  }

  s = strm.state;
  wrap = s.wrap;

  if (wrap === 2 || (wrap === 1 && s.status !== INIT_STATE) || s.lookahead) {
    return Z_STREAM_ERROR;
  }

  /* when using zlib wrappers, compute Adler-32 for provided dictionary */
  if (wrap === 1) {
    /* adler32(strm->adler, dictionary, dictLength); */
    strm.adler = adler32(strm.adler, dictionary, dictLength, 0);
  }

  s.wrap = 0;   /* avoid computing Adler-32 in read_buf */

  /* if dictionary would fill window, just replace the history */
  if (dictLength >= s.w_size) {
    if (wrap === 0) {            /* already empty otherwise */
      /*** CLEAR_HASH(s); ***/
      zero(s.head); // Fill with NIL (= 0);
      s.strstart = 0;
      s.block_start = 0;
      s.insert = 0;
    }
    /* use the tail */
    // dictionary = dictionary.slice(dictLength - s.w_size);
    tmpDict = new utils.Buf8(s.w_size);
    utils.arraySet(tmpDict, dictionary, dictLength - s.w_size, s.w_size, 0);
    dictionary = tmpDict;
    dictLength = s.w_size;
  }
  /* insert dictionary into window and hash */
  avail = strm.avail_in;
  next = strm.next_in;
  input = strm.input;
  strm.avail_in = dictLength;
  strm.next_in = 0;
  strm.input = dictionary;
  fill_window(s);
  while (s.lookahead >= MIN_MATCH) {
    str = s.strstart;
    n = s.lookahead - (MIN_MATCH - 1);
    do {
      /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */
      s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[str + MIN_MATCH - 1]) & s.hash_mask;

      s.prev[str & s.w_mask] = s.head[s.ins_h];

      s.head[s.ins_h] = str;
      str++;
    } while (--n);
    s.strstart = str;
    s.lookahead = MIN_MATCH - 1;
    fill_window(s);
  }
  s.strstart += s.lookahead;
  s.block_start = s.strstart;
  s.insert = s.lookahead;
  s.lookahead = 0;
  s.match_length = s.prev_length = MIN_MATCH - 1;
  s.match_available = 0;
  strm.next_in = next;
  strm.input = input;
  strm.avail_in = avail;
  s.wrap = wrap;
  return Z_OK;
}


exports.deflateInit = deflateInit;
exports.deflateInit2 = deflateInit2;
exports.deflateReset = deflateReset;
exports.deflateResetKeep = deflateResetKeep;
exports.deflateSetHeader = deflateSetHeader;
exports.deflate = deflate;
exports.deflateEnd = deflateEnd;
exports.deflateSetDictionary = deflateSetDictionary;
exports.deflateInfo = 'pako deflate (from Nodeca project)';

/* Not implemented
exports.deflateBound = deflateBound;
exports.deflateCopy = deflateCopy;
exports.deflateParams = deflateParams;
exports.deflatePending = deflatePending;
exports.deflatePrime = deflatePrime;
exports.deflateTune = deflateTune;
*/

},{"../utils/common":1,"./adler32":3,"./crc32":4,"./messages":6,"./trees":7}],6:[function(require,module,exports){
'use strict';

// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.

module.exports = {
  2:      'need dictionary',     /* Z_NEED_DICT       2  */
  1:      'stream end',          /* Z_STREAM_END      1  */
  0:      '',                    /* Z_OK              0  */
  '-1':   'file error',          /* Z_ERRNO         (-1) */
  '-2':   'stream error',        /* Z_STREAM_ERROR  (-2) */
  '-3':   'data error',          /* Z_DATA_ERROR    (-3) */
  '-4':   'insufficient memory', /* Z_MEM_ERROR     (-4) */
  '-5':   'buffer error',        /* Z_BUF_ERROR     (-5) */
  '-6':   'incompatible version' /* Z_VERSION_ERROR (-6) */
};

},{}],7:[function(require,module,exports){
'use strict';

// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.

/* eslint-disable space-unary-ops */

var utils = require('../utils/common');

/* Public constants ==========================================================*/
/* ===========================================================================*/


//var Z_FILTERED          = 1;
//var Z_HUFFMAN_ONLY      = 2;
//var Z_RLE               = 3;
var Z_FIXED               = 4;
//var Z_DEFAULT_STRATEGY  = 0;

/* Possible values of the data_type field (though see inflate()) */
var Z_BINARY              = 0;
var Z_TEXT                = 1;
//var Z_ASCII             = 1; // = Z_TEXT
var Z_UNKNOWN             = 2;

/*============================================================================*/


function zero(buf) { var len = buf.length; while (--len >= 0) { buf[len] = 0; } }

// From zutil.h

var STORED_BLOCK = 0;
var STATIC_TREES = 1;
var DYN_TREES    = 2;
/* The three kinds of block type */

var MIN_MATCH    = 3;
var MAX_MATCH    = 258;
/* The minimum and maximum match lengths */

// From deflate.h
/* ===========================================================================
 * Internal compression state.
 */

var LENGTH_CODES  = 29;
/* number of length codes, not counting the special END_BLOCK code */

var LITERALS      = 256;
/* number of literal bytes 0..255 */

var L_CODES       = LITERALS + 1 + LENGTH_CODES;
/* number of Literal or Length codes, including the END_BLOCK code */

var D_CODES       = 30;
/* number of distance codes */

var BL_CODES      = 19;
/* number of codes used to transfer the bit lengths */

var HEAP_SIZE     = 2 * L_CODES + 1;
/* maximum heap size */

var MAX_BITS      = 15;
/* All codes must not exceed MAX_BITS bits */

var Buf_size      = 16;
/* size of bit buffer in bi_buf */


/* ===========================================================================
 * Constants
 */

var MAX_BL_BITS = 7;
/* Bit length codes must not exceed MAX_BL_BITS bits */

var END_BLOCK   = 256;
/* end of block literal code */

var REP_3_6     = 16;
/* repeat previous bit length 3-6 times (2 bits of repeat count) */

var REPZ_3_10   = 17;
/* repeat a zero length 3-10 times  (3 bits of repeat count) */

var REPZ_11_138 = 18;
/* repeat a zero length 11-138 times  (7 bits of repeat count) */

/* eslint-disable comma-spacing,array-bracket-spacing */
var extra_lbits =   /* extra bits for each length code */
  [0,0,0,0,0,0,0,0,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,5,5,5,5,0];

var extra_dbits =   /* extra bits for each distance code */
  [0,0,0,0,1,1,2,2,3,3,4,4,5,5,6,6,7,7,8,8,9,9,10,10,11,11,12,12,13,13];

var extra_blbits =  /* extra bits for each bit length code */
  [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2,3,7];

var bl_order =
  [16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15];
/* eslint-enable comma-spacing,array-bracket-spacing */

/* The lengths of the bit length codes are sent in order of decreasing
 * probability, to avoid transmitting the lengths for unused bit length codes.
 */

/* ===========================================================================
 * Local data. These are initialized only once.
 */

// We pre-fill arrays with 0 to avoid uninitialized gaps

var DIST_CODE_LEN = 512; /* see definition of array dist_code below */

// !!!! Use flat array instead of structure, Freq = i*2, Len = i*2+1
var static_ltree  = new Array((L_CODES + 2) * 2);
zero(static_ltree);
/* The static literal tree. Since the bit lengths are imposed, there is no
 * need for the L_CODES extra codes used during heap construction. However
 * The codes 286 and 287 are needed to build a canonical tree (see _tr_init
 * below).
 */

var static_dtree  = new Array(D_CODES * 2);
zero(static_dtree);
/* The static distance tree. (Actually a trivial tree since all codes use
 * 5 bits.)
 */

var _dist_code    = new Array(DIST_CODE_LEN);
zero(_dist_code);
/* Distance codes. The first 256 values correspond to the distances
 * 3 .. 258, the last 256 values correspond to the top 8 bits of
 * the 15 bit distances.
 */

var _length_code  = new Array(MAX_MATCH - MIN_MATCH + 1);
zero(_length_code);
/* length code for each normalized match length (0 == MIN_MATCH) */

var base_length   = new Array(LENGTH_CODES);
zero(base_length);
/* First normalized length for each code (0 = MIN_MATCH) */

var base_dist     = new Array(D_CODES);
zero(base_dist);
/* First normalized distance for each code (0 = distance of 1) */


function StaticTreeDesc(static_tree, extra_bits, extra_base, elems, max_length) {

  this.static_tree  = static_tree;  /* static tree or NULL */
  this.extra_bits   = extra_bits;   /* extra bits for each code or NULL */
  this.extra_base   = extra_base;   /* base index for extra_bits */
  this.elems        = elems;        /* max number of elements in the tree */
  this.max_length   = max_length;   /* max bit length for the codes */

  // show if `static_tree` has data or dummy - needed for monomorphic objects
  this.has_stree    = static_tree && static_tree.length;
}


var static_l_desc;
var static_d_desc;
var static_bl_desc;


function TreeDesc(dyn_tree, stat_desc) {
  this.dyn_tree = dyn_tree;     /* the dynamic tree */
  this.max_code = 0;            /* largest code with non zero frequency */
  this.stat_desc = stat_desc;   /* the corresponding static tree */
}



function d_code(dist) {
  return dist < 256 ? _dist_code[dist] : _dist_code[256 + (dist >>> 7)];
}


/* ===========================================================================
 * Output a short LSB first on the stream.
 * IN assertion: there is enough room in pendingBuf.
 */
function put_short(s, w) {
//    put_byte(s, (uch)((w) & 0xff));
//    put_byte(s, (uch)((ush)(w) >> 8));
  s.pending_buf[s.pending++] = (w) & 0xff;
  s.pending_buf[s.pending++] = (w >>> 8) & 0xff;
}


/* ===========================================================================
 * Send a value on a given number of bits.
 * IN assertion: length <= 16 and value fits in length bits.
 */
function send_bits(s, value, length) {
  if (s.bi_valid > (Buf_size - length)) {
    s.bi_buf |= (value << s.bi_valid) & 0xffff;
    put_short(s, s.bi_buf);
    s.bi_buf = value >> (Buf_size - s.bi_valid);
    s.bi_valid += length - Buf_size;
  } else {
    s.bi_buf |= (value << s.bi_valid) & 0xffff;
    s.bi_valid += length;
  }
}


function send_code(s, c, tree) {
  send_bits(s, tree[c * 2]/*.Code*/, tree[c * 2 + 1]/*.Len*/);
}


/* ===========================================================================
 * Reverse the first len bits of a code, using straightforward code (a faster
 * method would use a table)
 * IN assertion: 1 <= len <= 15
 */
function bi_reverse(code, len) {
  var res = 0;
  do {
    res |= code & 1;
    code >>>= 1;
    res <<= 1;
  } while (--len > 0);
  return res >>> 1;
}


/* ===========================================================================
 * Flush the bit buffer, keeping at most 7 bits in it.
 */
function bi_flush(s) {
  if (s.bi_valid === 16) {
    put_short(s, s.bi_buf);
    s.bi_buf = 0;
    s.bi_valid = 0;

  } else if (s.bi_valid >= 8) {
    s.pending_buf[s.pending++] = s.bi_buf & 0xff;
    s.bi_buf >>= 8;
    s.bi_valid -= 8;
  }
}


/* ===========================================================================
 * Compute the optimal bit lengths for a tree and update the total bit length
 * for the current block.
 * IN assertion: the fields freq and dad are set, heap[heap_max] and
 *    above are the tree nodes sorted by increasing frequency.
 * OUT assertions: the field len is set to the optimal bit length, the
 *     array bl_count contains the frequencies for each bit length.
 *     The length opt_len is updated; static_len is also updated if stree is
 *     not null.
 */
function gen_bitlen(s, desc)
//    deflate_state *s;
//    tree_desc *desc;    /* the tree descriptor */
{
  var tree            = desc.dyn_tree;
  var max_code        = desc.max_code;
  var stree           = desc.stat_desc.static_tree;
  var has_stree       = desc.stat_desc.has_stree;
  var extra           = desc.stat_desc.extra_bits;
  var base            = desc.stat_desc.extra_base;
  var max_length      = desc.stat_desc.max_length;
  var h;              /* heap index */
  var n, m;           /* iterate over the tree elements */
  var bits;           /* bit length */
  var xbits;          /* extra bits */
  var f;              /* frequency */
  var overflow = 0;   /* number of elements with bit length too large */

  for (bits = 0; bits <= MAX_BITS; bits++) {
    s.bl_count[bits] = 0;
  }

  /* In a first pass, compute the optimal bit lengths (which may
   * overflow in the case of the bit length tree).
   */
  tree[s.heap[s.heap_max] * 2 + 1]/*.Len*/ = 0; /* root of the heap */

  for (h = s.heap_max + 1; h < HEAP_SIZE; h++) {
    n = s.heap[h];
    bits = tree[tree[n * 2 + 1]/*.Dad*/ * 2 + 1]/*.Len*/ + 1;
    if (bits > max_length) {
      bits = max_length;
      overflow++;
    }
    tree[n * 2 + 1]/*.Len*/ = bits;
    /* We overwrite tree[n].Dad which is no longer needed */

    if (n > max_code) { continue; } /* not a leaf node */

    s.bl_count[bits]++;
    xbits = 0;
    if (n >= base) {
      xbits = extra[n - base];
    }
    f = tree[n * 2]/*.Freq*/;
    s.opt_len += f * (bits + xbits);
    if (has_stree) {
      s.static_len += f * (stree[n * 2 + 1]/*.Len*/ + xbits);
    }
  }
  if (overflow === 0) { return; }

  // Trace((stderr,"\nbit length overflow\n"));
  /* This happens for example on obj2 and pic of the Calgary corpus */

  /* Find the first bit length which could increase: */
  do {
    bits = max_length - 1;
    while (s.bl_count[bits] === 0) { bits--; }
    s.bl_count[bits]--;      /* move one leaf down the tree */
    s.bl_count[bits + 1] += 2; /* move one overflow item as its brother */
    s.bl_count[max_length]--;
    /* The brother of the overflow item also moves one step up,
     * but this does not affect bl_count[max_length]
     */
    overflow -= 2;
  } while (overflow > 0);

  /* Now recompute all bit lengths, scanning in increasing frequency.
   * h is still equal to HEAP_SIZE. (It is simpler to reconstruct all
   * lengths instead of fixing only the wrong ones. This idea is taken
   * from 'ar' written by Haruhiko Okumura.)
   */
  for (bits = max_length; bits !== 0; bits--) {
    n = s.bl_count[bits];
    while (n !== 0) {
      m = s.heap[--h];
      if (m > max_code) { continue; }
      if (tree[m * 2 + 1]/*.Len*/ !== bits) {
        // Trace((stderr,"code %d bits %d->%d\n", m, tree[m].Len, bits));
        s.opt_len += (bits - tree[m * 2 + 1]/*.Len*/) * tree[m * 2]/*.Freq*/;
        tree[m * 2 + 1]/*.Len*/ = bits;
      }
      n--;
    }
  }
}


/* ===========================================================================
 * Generate the codes for a given tree and bit counts (which need not be
 * optimal).
 * IN assertion: the array bl_count contains the bit length statistics for
 * the given tree and the field len is set for all tree elements.
 * OUT assertion: the field code is set for all tree elements of non
 *     zero code length.
 */
function gen_codes(tree, max_code, bl_count)
//    ct_data *tree;             /* the tree to decorate */
//    int max_code;              /* largest code with non zero frequency */
//    ushf *bl_count;            /* number of codes at each bit length */
{
  var next_code = new Array(MAX_BITS + 1); /* next code value for each bit length */
  var code = 0;              /* running code value */
  var bits;                  /* bit index */
  var n;                     /* code index */

  /* The distribution counts are first used to generate the code values
   * without bit reversal.
   */
  for (bits = 1; bits <= MAX_BITS; bits++) {
    next_code[bits] = code = (code + bl_count[bits - 1]) << 1;
  }
  /* Check that the bit counts in bl_count are consistent. The last code
   * must be all ones.
   */
  //Assert (code + bl_count[MAX_BITS]-1 == (1<<MAX_BITS)-1,
  //        "inconsistent bit counts");
  //Tracev((stderr,"\ngen_codes: max_code %d ", max_code));

  for (n = 0;  n <= max_code; n++) {
    var len = tree[n * 2 + 1]/*.Len*/;
    if (len === 0) { continue; }
    /* Now reverse the bits */
    tree[n * 2]/*.Code*/ = bi_reverse(next_code[len]++, len);

    //Tracecv(tree != static_ltree, (stderr,"\nn %3d %c l %2d c %4x (%x) ",
    //     n, (isgraph(n) ? n : ' '), len, tree[n].Code, next_code[len]-1));
  }
}


/* ===========================================================================
 * Initialize the various 'constant' tables.
 */
function tr_static_init() {
  var n;        /* iterates over tree elements */
  var bits;     /* bit counter */
  var length;   /* length value */
  var code;     /* code value */
  var dist;     /* distance index */
  var bl_count = new Array(MAX_BITS + 1);
  /* number of codes at each bit length for an optimal tree */

  // do check in _tr_init()
  //if (static_init_done) return;

  /* For some embedded targets, global variables are not initialized: */
/*#ifdef NO_INIT_GLOBAL_POINTERS
  static_l_desc.static_tree = static_ltree;
  static_l_desc.extra_bits = extra_lbits;
  static_d_desc.static_tree = static_dtree;
  static_d_desc.extra_bits = extra_dbits;
  static_bl_desc.extra_bits = extra_blbits;
#endif*/

  /* Initialize the mapping length (0..255) -> length code (0..28) */
  length = 0;
  for (code = 0; code < LENGTH_CODES - 1; code++) {
    base_length[code] = length;
    for (n = 0; n < (1 << extra_lbits[code]); n++) {
      _length_code[length++] = code;
    }
  }
  //Assert (length == 256, "tr_static_init: length != 256");
  /* Note that the length 255 (match length 258) can be represented
   * in two different ways: code 284 + 5 bits or code 285, so we
   * overwrite length_code[255] to use the best encoding:
   */
  _length_code[length - 1] = code;

  /* Initialize the mapping dist (0..32K) -> dist code (0..29) */
  dist = 0;
  for (code = 0; code < 16; code++) {
    base_dist[code] = dist;
    for (n = 0; n < (1 << extra_dbits[code]); n++) {
      _dist_code[dist++] = code;
    }
  }
  //Assert (dist == 256, "tr_static_init: dist != 256");
  dist >>= 7; /* from now on, all distances are divided by 128 */
  for (; code < D_CODES; code++) {
    base_dist[code] = dist << 7;
    for (n = 0; n < (1 << (extra_dbits[code] - 7)); n++) {
      _dist_code[256 + dist++] = code;
    }
  }
  //Assert (dist == 256, "tr_static_init: 256+dist != 512");

  /* Construct the codes of the static literal tree */
  for (bits = 0; bits <= MAX_BITS; bits++) {
    bl_count[bits] = 0;
  }

  n = 0;
  while (n <= 143) {
    static_ltree[n * 2 + 1]/*.Len*/ = 8;
    n++;
    bl_count[8]++;
  }
  while (n <= 255) {
    static_ltree[n * 2 + 1]/*.Len*/ = 9;
    n++;
    bl_count[9]++;
  }
  while (n <= 279) {
    static_ltree[n * 2 + 1]/*.Len*/ = 7;
    n++;
    bl_count[7]++;
  }
  while (n <= 287) {
    static_ltree[n * 2 + 1]/*.Len*/ = 8;
    n++;
    bl_count[8]++;
  }
  /* Codes 286 and 287 do not exist, but we must include them in the
   * tree construction to get a canonical Huffman tree (longest code
   * all ones)
   */
  gen_codes(static_ltree, L_CODES + 1, bl_count);

  /* The static distance tree is trivial: */
  for (n = 0; n < D_CODES; n++) {
    static_dtree[n * 2 + 1]/*.Len*/ = 5;
    static_dtree[n * 2]/*.Code*/ = bi_reverse(n, 5);
  }

  // Now data ready and we can init static trees
  static_l_desc = new StaticTreeDesc(static_ltree, extra_lbits, LITERALS + 1, L_CODES, MAX_BITS);
  static_d_desc = new StaticTreeDesc(static_dtree, extra_dbits, 0,          D_CODES, MAX_BITS);
  static_bl_desc = new StaticTreeDesc(new Array(0), extra_blbits, 0,         BL_CODES, MAX_BL_BITS);

  //static_init_done = true;
}


/* ===========================================================================
 * Initialize a new block.
 */
function init_block(s) {
  var n; /* iterates over tree elements */

  /* Initialize the trees. */
  for (n = 0; n < L_CODES;  n++) { s.dyn_ltree[n * 2]/*.Freq*/ = 0; }
  for (n = 0; n < D_CODES;  n++) { s.dyn_dtree[n * 2]/*.Freq*/ = 0; }
  for (n = 0; n < BL_CODES; n++) { s.bl_tree[n * 2]/*.Freq*/ = 0; }

  s.dyn_ltree[END_BLOCK * 2]/*.Freq*/ = 1;
  s.opt_len = s.static_len = 0;
  s.last_lit = s.matches = 0;
}


/* ===========================================================================
 * Flush the bit buffer and align the output on a byte boundary
 */
function bi_windup(s)
{
  if (s.bi_valid > 8) {
    put_short(s, s.bi_buf);
  } else if (s.bi_valid > 0) {
    //put_byte(s, (Byte)s->bi_buf);
    s.pending_buf[s.pending++] = s.bi_buf;
  }
  s.bi_buf = 0;
  s.bi_valid = 0;
}

/* ===========================================================================
 * Copy a stored block, storing first the length and its
 * one's complement if requested.
 */
function copy_block(s, buf, len, header)
//DeflateState *s;
//charf    *buf;    /* the input data */
//unsigned len;     /* its length */
//int      header;  /* true if block header must be written */
{
  bi_windup(s);        /* align on byte boundary */

  if (header) {
    put_short(s, len);
    put_short(s, ~len);
  }
//  while (len--) {
//    put_byte(s, *buf++);
//  }
  utils.arraySet(s.pending_buf, s.window, buf, len, s.pending);
  s.pending += len;
}

/* ===========================================================================
 * Compares to subtrees, using the tree depth as tie breaker when
 * the subtrees have equal frequency. This minimizes the worst case length.
 */
function smaller(tree, n, m, depth) {
  var _n2 = n * 2;
  var _m2 = m * 2;
  return (tree[_n2]/*.Freq*/ < tree[_m2]/*.Freq*/ ||
         (tree[_n2]/*.Freq*/ === tree[_m2]/*.Freq*/ && depth[n] <= depth[m]));
}

/* ===========================================================================
 * Restore the heap property by moving down the tree starting at node k,
 * exchanging a node with the smallest of its two sons if necessary, stopping
 * when the heap property is re-established (each father smaller than its
 * two sons).
 */
function pqdownheap(s, tree, k)
//    deflate_state *s;
//    ct_data *tree;  /* the tree to restore */
//    int k;               /* node to move down */
{
  var v = s.heap[k];
  var j = k << 1;  /* left son of k */
  while (j <= s.heap_len) {
    /* Set j to the smallest of the two sons: */
    if (j < s.heap_len &&
      smaller(tree, s.heap[j + 1], s.heap[j], s.depth)) {
      j++;
    }
    /* Exit if v is smaller than both sons */
    if (smaller(tree, v, s.heap[j], s.depth)) { break; }

    /* Exchange v with the smallest son */
    s.heap[k] = s.heap[j];
    k = j;

    /* And continue down the tree, setting j to the left son of k */
    j <<= 1;
  }
  s.heap[k] = v;
}


// inlined manually
// var SMALLEST = 1;

/* ===========================================================================
 * Send the block data compressed using the given Huffman trees
 */
function compress_block(s, ltree, dtree)
//    deflate_state *s;
//    const ct_data *ltree; /* literal tree */
//    const ct_data *dtree; /* distance tree */
{
  var dist;           /* distance of matched string */
  var lc;             /* match length or unmatched char (if dist == 0) */
  var lx = 0;         /* running index in l_buf */
  var code;           /* the code to send */
  var extra;          /* number of extra bits to send */

  if (s.last_lit !== 0) {
    do {
      dist = (s.pending_buf[s.d_buf + lx * 2] << 8) | (s.pending_buf[s.d_buf + lx * 2 + 1]);
      lc = s.pending_buf[s.l_buf + lx];
      lx++;

      if (dist === 0) {
        send_code(s, lc, ltree); /* send a literal byte */
        //Tracecv(isgraph(lc), (stderr," '%c' ", lc));
      } else {
        /* Here, lc is the match length - MIN_MATCH */
        code = _length_code[lc];
        send_code(s, code + LITERALS + 1, ltree); /* send the length code */
        extra = extra_lbits[code];
        if (extra !== 0) {
          lc -= base_length[code];
          send_bits(s, lc, extra);       /* send the extra length bits */
        }
        dist--; /* dist is now the match distance - 1 */
        code = d_code(dist);
        //Assert (code < D_CODES, "bad d_code");

        send_code(s, code, dtree);       /* send the distance code */
        extra = extra_dbits[code];
        if (extra !== 0) {
          dist -= base_dist[code];
          send_bits(s, dist, extra);   /* send the extra distance bits */
        }
      } /* literal or match pair ? */

      /* Check that the overlay between pending_buf and d_buf+l_buf is ok: */
      //Assert((uInt)(s->pending) < s->lit_bufsize + 2*lx,
      //       "pendingBuf overflow");

    } while (lx < s.last_lit);
  }

  send_code(s, END_BLOCK, ltree);
}


/* ===========================================================================
 * Construct one Huffman tree and assigns the code bit strings and lengths.
 * Update the total bit length for the current block.
 * IN assertion: the field freq is set for all tree elements.
 * OUT assertions: the fields len and code are set to the optimal bit length
 *     and corresponding code. The length opt_len is updated; static_len is
 *     also updated if stree is not null. The field max_code is set.
 */
function build_tree(s, desc)
//    deflate_state *s;
//    tree_desc *desc; /* the tree descriptor */
{
  var tree     = desc.dyn_tree;
  var stree    = desc.stat_desc.static_tree;
  var has_stree = desc.stat_desc.has_stree;
  var elems    = desc.stat_desc.elems;
  var n, m;          /* iterate over heap elements */
  var max_code = -1; /* largest code with non zero frequency */
  var node;          /* new node being created */

  /* Construct the initial heap, with least frequent element in
   * heap[SMALLEST]. The sons of heap[n] are heap[2*n] and heap[2*n+1].
   * heap[0] is not used.
   */
  s.heap_len = 0;
  s.heap_max = HEAP_SIZE;

  for (n = 0; n < elems; n++) {
    if (tree[n * 2]/*.Freq*/ !== 0) {
      s.heap[++s.heap_len] = max_code = n;
      s.depth[n] = 0;

    } else {
      tree[n * 2 + 1]/*.Len*/ = 0;
    }
  }

  /* The pkzip format requires that at least one distance code exists,
   * and that at least one bit should be sent even if there is only one
   * possible code. So to avoid special checks later on we force at least
   * two codes of non zero frequency.
   */
  while (s.heap_len < 2) {
    node = s.heap[++s.heap_len] = (max_code < 2 ? ++max_code : 0);
    tree[node * 2]/*.Freq*/ = 1;
    s.depth[node] = 0;
    s.opt_len--;

    if (has_stree) {
      s.static_len -= stree[node * 2 + 1]/*.Len*/;
    }
    /* node is 0 or 1 so it does not have extra bits */
  }
  desc.max_code = max_code;

  /* The elements heap[heap_len/2+1 .. heap_len] are leaves of the tree,
   * establish sub-heaps of increasing lengths:
   */
  for (n = (s.heap_len >> 1/*int /2*/); n >= 1; n--) { pqdownheap(s, tree, n); }

  /* Construct the Huffman tree by repeatedly combining the least two
   * frequent nodes.
   */
  node = elems;              /* next internal node of the tree */
  do {
    //pqremove(s, tree, n);  /* n = node of least frequency */
    /*** pqremove ***/
    n = s.heap[1/*SMALLEST*/];
    s.heap[1/*SMALLEST*/] = s.heap[s.heap_len--];
    pqdownheap(s, tree, 1/*SMALLEST*/);
    /***/

    m = s.heap[1/*SMALLEST*/]; /* m = node of next least frequency */

    s.heap[--s.heap_max] = n; /* keep the nodes sorted by frequency */
    s.heap[--s.heap_max] = m;

    /* Create a new node father of n and m */
    tree[node * 2]/*.Freq*/ = tree[n * 2]/*.Freq*/ + tree[m * 2]/*.Freq*/;
    s.depth[node] = (s.depth[n] >= s.depth[m] ? s.depth[n] : s.depth[m]) + 1;
    tree[n * 2 + 1]/*.Dad*/ = tree[m * 2 + 1]/*.Dad*/ = node;

    /* and insert the new node in the heap */
    s.heap[1/*SMALLEST*/] = node++;
    pqdownheap(s, tree, 1/*SMALLEST*/);

  } while (s.heap_len >= 2);

  s.heap[--s.heap_max] = s.heap[1/*SMALLEST*/];

  /* At this point, the fields freq and dad are set. We can now
   * generate the bit lengths.
   */
  gen_bitlen(s, desc);

  /* The field len is now set, we can generate the bit codes */
  gen_codes(tree, max_code, s.bl_count);
}


/* ===========================================================================
 * Scan a literal or distance tree to determine the frequencies of the codes
 * in the bit length tree.
 */
function scan_tree(s, tree, max_code)
//    deflate_state *s;
//    ct_data *tree;   /* the tree to be scanned */
//    int max_code;    /* and its largest code of non zero frequency */
{
  var n;                     /* iterates over all tree elements */
  var prevlen = -1;          /* last emitted length */
  var curlen;                /* length of current code */

  var nextlen = tree[0 * 2 + 1]/*.Len*/; /* length of next code */

  var count = 0;             /* repeat count of the current code */
  var max_count = 7;         /* max repeat count */
  var min_count = 4;         /* min repeat count */

  if (nextlen === 0) {
    max_count = 138;
    min_count = 3;
  }
  tree[(max_code + 1) * 2 + 1]/*.Len*/ = 0xffff; /* guard */

  for (n = 0; n <= max_code; n++) {
    curlen = nextlen;
    nextlen = tree[(n + 1) * 2 + 1]/*.Len*/;

    if (++count < max_count && curlen === nextlen) {
      continue;

    } else if (count < min_count) {
      s.bl_tree[curlen * 2]/*.Freq*/ += count;

    } else if (curlen !== 0) {

      if (curlen !== prevlen) { s.bl_tree[curlen * 2]/*.Freq*/++; }
      s.bl_tree[REP_3_6 * 2]/*.Freq*/++;

    } else if (count <= 10) {
      s.bl_tree[REPZ_3_10 * 2]/*.Freq*/++;

    } else {
      s.bl_tree[REPZ_11_138 * 2]/*.Freq*/++;
    }

    count = 0;
    prevlen = curlen;

    if (nextlen === 0) {
      max_count = 138;
      min_count = 3;

    } else if (curlen === nextlen) {
      max_count = 6;
      min_count = 3;

    } else {
      max_count = 7;
      min_count = 4;
    }
  }
}


/* ===========================================================================
 * Send a literal or distance tree in compressed form, using the codes in
 * bl_tree.
 */
function send_tree(s, tree, max_code)
//    deflate_state *s;
//    ct_data *tree; /* the tree to be scanned */
//    int max_code;       /* and its largest code of non zero frequency */
{
  var n;                     /* iterates over all tree elements */
  var prevlen = -1;          /* last emitted length */
  var curlen;                /* length of current code */

  var nextlen = tree[0 * 2 + 1]/*.Len*/; /* length of next code */

  var count = 0;             /* repeat count of the current code */
  var max_count = 7;         /* max repeat count */
  var min_count = 4;         /* min repeat count */

  /* tree[max_code+1].Len = -1; */  /* guard already set */
  if (nextlen === 0) {
    max_count = 138;
    min_count = 3;
  }

  for (n = 0; n <= max_code; n++) {
    curlen = nextlen;
    nextlen = tree[(n + 1) * 2 + 1]/*.Len*/;

    if (++count < max_count && curlen === nextlen) {
      continue;

    } else if (count < min_count) {
      do { send_code(s, curlen, s.bl_tree); } while (--count !== 0);

    } else if (curlen !== 0) {
      if (curlen !== prevlen) {
        send_code(s, curlen, s.bl_tree);
        count--;
      }
      //Assert(count >= 3 && count <= 6, " 3_6?");
      send_code(s, REP_3_6, s.bl_tree);
      send_bits(s, count - 3, 2);

    } else if (count <= 10) {
      send_code(s, REPZ_3_10, s.bl_tree);
      send_bits(s, count - 3, 3);

    } else {
      send_code(s, REPZ_11_138, s.bl_tree);
      send_bits(s, count - 11, 7);
    }

    count = 0;
    prevlen = curlen;
    if (nextlen === 0) {
      max_count = 138;
      min_count = 3;

    } else if (curlen === nextlen) {
      max_count = 6;
      min_count = 3;

    } else {
      max_count = 7;
      min_count = 4;
    }
  }
}


/* ===========================================================================
 * Construct the Huffman tree for the bit lengths and return the index in
 * bl_order of the last bit length code to send.
 */
function build_bl_tree(s) {
  var max_blindex;  /* index of last bit length code of non zero freq */

  /* Determine the bit length frequencies for literal and distance trees */
  scan_tree(s, s.dyn_ltree, s.l_desc.max_code);
  scan_tree(s, s.dyn_dtree, s.d_desc.max_code);

  /* Build the bit length tree: */
  build_tree(s, s.bl_desc);
  /* opt_len now includes the length of the tree representations, except
   * the lengths of the bit lengths codes and the 5+5+4 bits for the counts.
   */

  /* Determine the number of bit length codes to send. The pkzip format
   * requires that at least 4 bit length codes be sent. (appnote.txt says
   * 3 but the actual value used is 4.)
   */
  for (max_blindex = BL_CODES - 1; max_blindex >= 3; max_blindex--) {
    if (s.bl_tree[bl_order[max_blindex] * 2 + 1]/*.Len*/ !== 0) {
      break;
    }
  }
  /* Update opt_len to include the bit length tree and counts */
  s.opt_len += 3 * (max_blindex + 1) + 5 + 5 + 4;
  //Tracev((stderr, "\ndyn trees: dyn %ld, stat %ld",
  //        s->opt_len, s->static_len));

  return max_blindex;
}


/* ===========================================================================
 * Send the header for a block using dynamic Huffman trees: the counts, the
 * lengths of the bit length codes, the literal tree and the distance tree.
 * IN assertion: lcodes >= 257, dcodes >= 1, blcodes >= 4.
 */
function send_all_trees(s, lcodes, dcodes, blcodes)
//    deflate_state *s;
//    int lcodes, dcodes, blcodes; /* number of codes for each tree */
{
  var rank;                    /* index in bl_order */

  //Assert (lcodes >= 257 && dcodes >= 1 && blcodes >= 4, "not enough codes");
  //Assert (lcodes <= L_CODES && dcodes <= D_CODES && blcodes <= BL_CODES,
  //        "too many codes");
  //Tracev((stderr, "\nbl counts: "));
  send_bits(s, lcodes - 257, 5); /* not +255 as stated in appnote.txt */
  send_bits(s, dcodes - 1,   5);
  send_bits(s, blcodes - 4,  4); /* not -3 as stated in appnote.txt */
  for (rank = 0; rank < blcodes; rank++) {
    //Tracev((stderr, "\nbl code %2d ", bl_order[rank]));
    send_bits(s, s.bl_tree[bl_order[rank] * 2 + 1]/*.Len*/, 3);
  }
  //Tracev((stderr, "\nbl tree: sent %ld", s->bits_sent));

  send_tree(s, s.dyn_ltree, lcodes - 1); /* literal tree */
  //Tracev((stderr, "\nlit tree: sent %ld", s->bits_sent));

  send_tree(s, s.dyn_dtree, dcodes - 1); /* distance tree */
  //Tracev((stderr, "\ndist tree: sent %ld", s->bits_sent));
}


/* ===========================================================================
 * Check if the data type is TEXT or BINARY, using the following algorithm:
 * - TEXT if the two conditions below are satisfied:
 *    a) There are no non-portable control characters belonging to the
 *       "black list" (0..6, 14..25, 28..31).
 *    b) There is at least one printable character belonging to the
 *       "white list" (9 {TAB}, 10 {LF}, 13 {CR}, 32..255).
 * - BINARY otherwise.
 * - The following partially-portable control characters form a
 *   "gray list" that is ignored in this detection algorithm:
 *   (7 {BEL}, 8 {BS}, 11 {VT}, 12 {FF}, 26 {SUB}, 27 {ESC}).
 * IN assertion: the fields Freq of dyn_ltree are set.
 */
function detect_data_type(s) {
  /* black_mask is the bit mask of black-listed bytes
   * set bits 0..6, 14..25, and 28..31
   * 0xf3ffc07f = binary 11110011111111111100000001111111
   */
  var black_mask = 0xf3ffc07f;
  var n;

  /* Check for non-textual ("black-listed") bytes. */
  for (n = 0; n <= 31; n++, black_mask >>>= 1) {
    if ((black_mask & 1) && (s.dyn_ltree[n * 2]/*.Freq*/ !== 0)) {
      return Z_BINARY;
    }
  }

  /* Check for textual ("white-listed") bytes. */
  if (s.dyn_ltree[9 * 2]/*.Freq*/ !== 0 || s.dyn_ltree[10 * 2]/*.Freq*/ !== 0 ||
      s.dyn_ltree[13 * 2]/*.Freq*/ !== 0) {
    return Z_TEXT;
  }
  for (n = 32; n < LITERALS; n++) {
    if (s.dyn_ltree[n * 2]/*.Freq*/ !== 0) {
      return Z_TEXT;
    }
  }

  /* There are no "black-listed" or "white-listed" bytes:
   * this stream either is empty or has tolerated ("gray-listed") bytes only.
   */
  return Z_BINARY;
}


var static_init_done = false;

/* ===========================================================================
 * Initialize the tree data structures for a new zlib stream.
 */
function _tr_init(s)
{

  if (!static_init_done) {
    tr_static_init();
    static_init_done = true;
  }

  s.l_desc  = new TreeDesc(s.dyn_ltree, static_l_desc);
  s.d_desc  = new TreeDesc(s.dyn_dtree, static_d_desc);
  s.bl_desc = new TreeDesc(s.bl_tree, static_bl_desc);

  s.bi_buf = 0;
  s.bi_valid = 0;

  /* Initialize the first block of the first file: */
  init_block(s);
}


/* ===========================================================================
 * Send a stored block
 */
function _tr_stored_block(s, buf, stored_len, last)
//DeflateState *s;
//charf *buf;       /* input block */
//ulg stored_len;   /* length of input block */
//int last;         /* one if this is the last block for a file */
{
  send_bits(s, (STORED_BLOCK << 1) + (last ? 1 : 0), 3);    /* send block type */
  copy_block(s, buf, stored_len, true); /* with header */
}


/* ===========================================================================
 * Send one empty static block to give enough lookahead for inflate.
 * This takes 10 bits, of which 7 may remain in the bit buffer.
 */
function _tr_align(s) {
  send_bits(s, STATIC_TREES << 1, 3);
  send_code(s, END_BLOCK, static_ltree);
  bi_flush(s);
}


/* ===========================================================================
 * Determine the best encoding for the current block: dynamic trees, static
 * trees or store, and output the encoded block to the zip file.
 */
function _tr_flush_block(s, buf, stored_len, last)
//DeflateState *s;
//charf *buf;       /* input block, or NULL if too old */
//ulg stored_len;   /* length of input block */
//int last;         /* one if this is the last block for a file */
{
  var opt_lenb, static_lenb;  /* opt_len and static_len in bytes */
  var max_blindex = 0;        /* index of last bit length code of non zero freq */

  /* Build the Huffman trees unless a stored block is forced */
  if (s.level > 0) {

    /* Check if the file is binary or text */
    if (s.strm.data_type === Z_UNKNOWN) {
      s.strm.data_type = detect_data_type(s);
    }

    /* Construct the literal and distance trees */
    build_tree(s, s.l_desc);
    // Tracev((stderr, "\nlit data: dyn %ld, stat %ld", s->opt_len,
    //        s->static_len));

    build_tree(s, s.d_desc);
    // Tracev((stderr, "\ndist data: dyn %ld, stat %ld", s->opt_len,
    //        s->static_len));
    /* At this point, opt_len and static_len are the total bit lengths of
     * the compressed block data, excluding the tree representations.
     */

    /* Build the bit length tree for the above two trees, and get the index
     * in bl_order of the last bit length code to send.
     */
    max_blindex = build_bl_tree(s);

    /* Determine the best encoding. Compute the block lengths in bytes. */
    opt_lenb = (s.opt_len + 3 + 7) >>> 3;
    static_lenb = (s.static_len + 3 + 7) >>> 3;

    // Tracev((stderr, "\nopt %lu(%lu) stat %lu(%lu) stored %lu lit %u ",
    //        opt_lenb, s->opt_len, static_lenb, s->static_len, stored_len,
    //        s->last_lit));

    if (static_lenb <= opt_lenb) { opt_lenb = static_lenb; }

  } else {
    // Assert(buf != (char*)0, "lost buf");
    opt_lenb = static_lenb = stored_len + 5; /* force a stored block */
  }

  if ((stored_len + 4 <= opt_lenb) && (buf !== -1)) {
    /* 4: two words for the lengths */

    /* The test buf != NULL is only necessary if LIT_BUFSIZE > WSIZE.
     * Otherwise we can't have processed more than WSIZE input bytes since
     * the last block flush, because compression would have been
     * successful. If LIT_BUFSIZE <= WSIZE, it is never too late to
     * transform a block into a stored block.
     */
    _tr_stored_block(s, buf, stored_len, last);

  } else if (s.strategy === Z_FIXED || static_lenb === opt_lenb) {

    send_bits(s, (STATIC_TREES << 1) + (last ? 1 : 0), 3);
    compress_block(s, static_ltree, static_dtree);

  } else {
    send_bits(s, (DYN_TREES << 1) + (last ? 1 : 0), 3);
    send_all_trees(s, s.l_desc.max_code + 1, s.d_desc.max_code + 1, max_blindex + 1);
    compress_block(s, s.dyn_ltree, s.dyn_dtree);
  }
  // Assert (s->compressed_len == s->bits_sent, "bad compressed size");
  /* The above check is made mod 2^32, for files larger than 512 MB
   * and uLong implemented on 32 bits.
   */
  init_block(s);

  if (last) {
    bi_windup(s);
  }
  // Tracev((stderr,"\ncomprlen %lu(%lu) ", s->compressed_len>>3,
  //       s->compressed_len-7*last));
}

/* ===========================================================================
 * Save the match info and tally the frequency counts. Return true if
 * the current block must be flushed.
 */
function _tr_tally(s, dist, lc)
//    deflate_state *s;
//    unsigned dist;  /* distance of matched string */
//    unsigned lc;    /* match length-MIN_MATCH or unmatched char (if dist==0) */
{
  //var out_length, in_length, dcode;

  s.pending_buf[s.d_buf + s.last_lit * 2]     = (dist >>> 8) & 0xff;
  s.pending_buf[s.d_buf + s.last_lit * 2 + 1] = dist & 0xff;

  s.pending_buf[s.l_buf + s.last_lit] = lc & 0xff;
  s.last_lit++;

  if (dist === 0) {
    /* lc is the unmatched char */
    s.dyn_ltree[lc * 2]/*.Freq*/++;
  } else {
    s.matches++;
    /* Here, lc is the match length - MIN_MATCH */
    dist--;             /* dist = match distance - 1 */
    //Assert((ush)dist < (ush)MAX_DIST(s) &&
    //       (ush)lc <= (ush)(MAX_MATCH-MIN_MATCH) &&
    //       (ush)d_code(dist) < (ush)D_CODES,  "_tr_tally: bad match");

    s.dyn_ltree[(_length_code[lc] + LITERALS + 1) * 2]/*.Freq*/++;
    s.dyn_dtree[d_code(dist) * 2]/*.Freq*/++;
  }

// (!) This block is disabled in zlib defaults,
// don't enable it for binary compatibility

//#ifdef TRUNCATE_BLOCK
//  /* Try to guess if it is profitable to stop the current block here */
//  if ((s.last_lit & 0x1fff) === 0 && s.level > 2) {
//    /* Compute an upper bound for the compressed length */
//    out_length = s.last_lit*8;
//    in_length = s.strstart - s.block_start;
//
//    for (dcode = 0; dcode < D_CODES; dcode++) {
//      out_length += s.dyn_dtree[dcode*2]/*.Freq*/ * (5 + extra_dbits[dcode]);
//    }
//    out_length >>>= 3;
//    //Tracev((stderr,"\nlast_lit %u, in %ld, out ~%ld(%ld%%) ",
//    //       s->last_lit, in_length, out_length,
//    //       100L - out_length*100L/in_length));
//    if (s.matches < (s.last_lit>>1)/*int /2*/ && out_length < (in_length>>1)/*int /2*/) {
//      return true;
//    }
//  }
//#endif

  return (s.last_lit === s.lit_bufsize - 1);
  /* We avoid equality with lit_bufsize because of wraparound at 64K
   * on 16 bit machines and because stored blocks are restricted to
   * 64K-1 bytes.
   */
}

exports._tr_init  = _tr_init;
exports._tr_stored_block = _tr_stored_block;
exports._tr_flush_block  = _tr_flush_block;
exports._tr_tally = _tr_tally;
exports._tr_align = _tr_align;

},{"../utils/common":1}],8:[function(require,module,exports){
'use strict';

// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.

function ZStream() {
  /* next input byte */
  this.input = null; // JS specific, because we have no pointers
  this.next_in = 0;
  /* number of bytes available at input */
  this.avail_in = 0;
  /* total number of input bytes read so far */
  this.total_in = 0;
  /* next output byte should be put there */
  this.output = null; // JS specific, because we have no pointers
  this.next_out = 0;
  /* remaining free space at output */
  this.avail_out = 0;
  /* total number of bytes output so far */
  this.total_out = 0;
  /* last error message, NULL if no error */
  this.msg = ''/*Z_NULL*/;
  /* not visible by applications */
  this.state = null;
  /* best guess about the data type: binary or text */
  this.data_type = 2/*Z_UNKNOWN*/;
  /* adler32 value of the uncompressed data */
  this.adler = 0;
}

module.exports = ZStream;

},{}],"/lib/deflate.js":[function(require,module,exports){
'use strict';


var zlib_deflate = require('./zlib/deflate');
var utils        = require('./utils/common');
var strings      = require('./utils/strings');
var msg          = require('./zlib/messages');
var ZStream      = require('./zlib/zstream');

var toString = Object.prototype.toString;

/* Public constants ==========================================================*/
/* ===========================================================================*/

var Z_NO_FLUSH      = 0;
var Z_FINISH        = 4;

var Z_OK            = 0;
var Z_STREAM_END    = 1;
var Z_SYNC_FLUSH    = 2;

var Z_DEFAULT_COMPRESSION = -1;

var Z_DEFAULT_STRATEGY    = 0;

var Z_DEFLATED  = 8;

/* ===========================================================================*/


/**
 * class Deflate
 *
 * Generic JS-style wrapper for zlib calls. If you don't need
 * streaming behaviour - use more simple functions: [[deflate]],
 * [[deflateRaw]] and [[gzip]].
 **/

/* internal
 * Deflate.chunks -> Array
 *
 * Chunks of output data, if [[Deflate#onData]] not overridden.
 **/

/**
 * Deflate.result -> Uint8Array|Array
 *
 * Compressed result, generated by default [[Deflate#onData]]
 * and [[Deflate#onEnd]] handlers. Filled after you push last chunk
 * (call [[Deflate#push]] with `Z_FINISH` / `true` param)  or if you
 * push a chunk with explicit flush (call [[Deflate#push]] with
 * `Z_SYNC_FLUSH` param).
 **/

/**
 * Deflate.err -> Number
 *
 * Error code after deflate finished. 0 (Z_OK) on success.
 * You will not need it in real life, because deflate errors
 * are possible only on wrong options or bad `onData` / `onEnd`
 * custom handlers.
 **/

/**
 * Deflate.msg -> String
 *
 * Error message, if [[Deflate.err]] != 0
 **/


/**
 * new Deflate(options)
 * - options (Object): zlib deflate options.
 *
 * Creates new deflator instance with specified params. Throws exception
 * on bad params. Supported options:
 *
 * - `level`
 * - `windowBits`
 * - `memLevel`
 * - `strategy`
 * - `dictionary`
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information on these.
 *
 * Additional options, for internal needs:
 *
 * - `chunkSize` - size of generated data chunks (16K by default)
 * - `raw` (Boolean) - do raw deflate
 * - `gzip` (Boolean) - create gzip wrapper
 * - `to` (String) - if equal to 'string', then result will be "binary string"
 *    (each char code [0..255])
 * - `header` (Object) - custom header for gzip
 *   - `text` (Boolean) - true if compressed data believed to be text
 *   - `time` (Number) - modification time, unix timestamp
 *   - `os` (Number) - operation system code
 *   - `extra` (Array) - array of bytes with extra data (max 65536)
 *   - `name` (String) - file name (binary string)
 *   - `comment` (String) - comment (binary string)
 *   - `hcrc` (Boolean) - true if header crc should be added
 *
 * ##### Example:
 *
 * ```javascript
 * var pako = require('pako')
 *   , chunk1 = Uint8Array([1,2,3,4,5,6,7,8,9])
 *   , chunk2 = Uint8Array([10,11,12,13,14,15,16,17,18,19]);
 *
 * var deflate = new pako.Deflate({ level: 3});
 *
 * deflate.push(chunk1, false);
 * deflate.push(chunk2, true);  // true -> last chunk
 *
 * if (deflate.err) { throw new Error(deflate.err); }
 *
 * console.log(deflate.result);
 * ```
 **/
function Deflate(options) {
  if (!(this instanceof Deflate)) return new Deflate(options);

  this.options = utils.assign({
    level: Z_DEFAULT_COMPRESSION,
    method: Z_DEFLATED,
    chunkSize: 16384,
    windowBits: 15,
    memLevel: 8,
    strategy: Z_DEFAULT_STRATEGY,
    to: ''
  }, options || {});

  var opt = this.options;

  if (opt.raw && (opt.windowBits > 0)) {
    opt.windowBits = -opt.windowBits;
  }

  else if (opt.gzip && (opt.windowBits > 0) && (opt.windowBits < 16)) {
    opt.windowBits += 16;
  }

  this.err    = 0;      // error code, if happens (0 = Z_OK)
  this.msg    = '';     // error message
  this.ended  = false;  // used to avoid multiple onEnd() calls
  this.chunks = [];     // chunks of compressed data

  this.strm = new ZStream();
  this.strm.avail_out = 0;

  var status = zlib_deflate.deflateInit2(
    this.strm,
    opt.level,
    opt.method,
    opt.windowBits,
    opt.memLevel,
    opt.strategy
  );

  if (status !== Z_OK) {
    throw new Error(msg[status]);
  }

  if (opt.header) {
    zlib_deflate.deflateSetHeader(this.strm, opt.header);
  }

  if (opt.dictionary) {
    var dict;
    // Convert data if needed
    if (typeof opt.dictionary === 'string') {
      // If we need to compress text, change encoding to utf8.
      dict = strings.string2buf(opt.dictionary);
    } else if (toString.call(opt.dictionary) === '[object ArrayBuffer]') {
      dict = new Uint8Array(opt.dictionary);
    } else {
      dict = opt.dictionary;
    }

    status = zlib_deflate.deflateSetDictionary(this.strm, dict);

    if (status !== Z_OK) {
      throw new Error(msg[status]);
    }

    this._dict_set = true;
  }
}

/**
 * Deflate#push(data[, mode]) -> Boolean
 * - data (Uint8Array|Array|ArrayBuffer|String): input data. Strings will be
 *   converted to utf8 byte sequence.
 * - mode (Number|Boolean): 0..6 for corresponding Z_NO_FLUSH..Z_TREE modes.
 *   See constants. Skipped or `false` means Z_NO_FLUSH, `true` means Z_FINISH.
 *
 * Sends input data to deflate pipe, generating [[Deflate#onData]] calls with
 * new compressed chunks. Returns `true` on success. The last data block must have
 * mode Z_FINISH (or `true`). That will flush internal pending buffers and call
 * [[Deflate#onEnd]]. For interim explicit flushes (without ending the stream) you
 * can use mode Z_SYNC_FLUSH, keeping the compression context.
 *
 * On fail call [[Deflate#onEnd]] with error code and return false.
 *
 * We strongly recommend to use `Uint8Array` on input for best speed (output
 * array format is detected automatically). Also, don't skip last param and always
 * use the same type in your code (boolean or number). That will improve JS speed.
 *
 * For regular `Array`-s make sure all elements are [0..255].
 *
 * ##### Example
 *
 * ```javascript
 * push(chunk, false); // push one of data chunks
 * ...
 * push(chunk, true);  // push last chunk
 * ```
 **/
Deflate.prototype.push = function (data, mode) {
  var strm = this.strm;
  var chunkSize = this.options.chunkSize;
  var status, _mode;

  if (this.ended) { return false; }

  _mode = (mode === ~~mode) ? mode : ((mode === true) ? Z_FINISH : Z_NO_FLUSH);

  // Convert data if needed
  if (typeof data === 'string') {
    // If we need to compress text, change encoding to utf8.
    strm.input = strings.string2buf(data);
  } else if (toString.call(data) === '[object ArrayBuffer]') {
    strm.input = new Uint8Array(data);
  } else {
    strm.input = data;
  }

  strm.next_in = 0;
  strm.avail_in = strm.input.length;

  do {
    if (strm.avail_out === 0) {
      strm.output = new utils.Buf8(chunkSize);
      strm.next_out = 0;
      strm.avail_out = chunkSize;
    }
    status = zlib_deflate.deflate(strm, _mode);    /* no bad return value */

    if (status !== Z_STREAM_END && status !== Z_OK) {
      this.onEnd(status);
      this.ended = true;
      return false;
    }
    if (strm.avail_out === 0 || (strm.avail_in === 0 && (_mode === Z_FINISH || _mode === Z_SYNC_FLUSH))) {
      if (this.options.to === 'string') {
        this.onData(strings.buf2binstring(utils.shrinkBuf(strm.output, strm.next_out)));
      } else {
        this.onData(utils.shrinkBuf(strm.output, strm.next_out));
      }
    }
  } while ((strm.avail_in > 0 || strm.avail_out === 0) && status !== Z_STREAM_END);

  // Finalize on the last chunk.
  if (_mode === Z_FINISH) {
    status = zlib_deflate.deflateEnd(this.strm);
    this.onEnd(status);
    this.ended = true;
    return status === Z_OK;
  }

  // callback interim results if Z_SYNC_FLUSH.
  if (_mode === Z_SYNC_FLUSH) {
    this.onEnd(Z_OK);
    strm.avail_out = 0;
    return true;
  }

  return true;
};


/**
 * Deflate#onData(chunk) -> Void
 * - chunk (Uint8Array|Array|String): output data. Type of array depends
 *   on js engine support. When string output requested, each chunk
 *   will be string.
 *
 * By default, stores data blocks in `chunks[]` property and glue
 * those in `onEnd`. Override this handler, if you need another behaviour.
 **/
Deflate.prototype.onData = function (chunk) {
  this.chunks.push(chunk);
};


/**
 * Deflate#onEnd(status) -> Void
 * - status (Number): deflate status. 0 (Z_OK) on success,
 *   other if not.
 *
 * Called once after you tell deflate that the input stream is
 * complete (Z_FINISH) or should be flushed (Z_SYNC_FLUSH)
 * or if an error happened. By default - join collected chunks,
 * free memory and fill `results` / `err` properties.
 **/
Deflate.prototype.onEnd = function (status) {
  // On success - join
  if (status === Z_OK) {
    if (this.options.to === 'string') {
      this.result = this.chunks.join('');
    } else {
      this.result = utils.flattenChunks(this.chunks);
    }
  }
  this.chunks = [];
  this.err = status;
  this.msg = this.strm.msg;
};


/**
 * deflate(data[, options]) -> Uint8Array|Array|String
 * - data (Uint8Array|Array|String): input data to compress.
 * - options (Object): zlib deflate options.
 *
 * Compress `data` with deflate algorithm and `options`.
 *
 * Supported options are:
 *
 * - level
 * - windowBits
 * - memLevel
 * - strategy
 * - dictionary
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information on these.
 *
 * Sugar (options):
 *
 * - `raw` (Boolean) - say that we work with raw stream, if you don't wish to specify
 *   negative windowBits implicitly.
 * - `to` (String) - if equal to 'string', then result will be "binary string"
 *    (each char code [0..255])
 *
 * ##### Example:
 *
 * ```javascript
 * var pako = require('pako')
 *   , data = Uint8Array([1,2,3,4,5,6,7,8,9]);
 *
 * console.log(pako.deflate(data));
 * ```
 **/
function deflate(input, options) {
  var deflator = new Deflate(options);

  deflator.push(input, true);

  // That will never happens, if you don't cheat with options :)
  if (deflator.err) { throw deflator.msg || msg[deflator.err]; }

  return deflator.result;
}


/**
 * deflateRaw(data[, options]) -> Uint8Array|Array|String
 * - data (Uint8Array|Array|String): input data to compress.
 * - options (Object): zlib deflate options.
 *
 * The same as [[deflate]], but creates raw data, without wrapper
 * (header and adler32 crc).
 **/
function deflateRaw(input, options) {
  options = options || {};
  options.raw = true;
  return deflate(input, options);
}


/**
 * gzip(data[, options]) -> Uint8Array|Array|String
 * - data (Uint8Array|Array|String): input data to compress.
 * - options (Object): zlib deflate options.
 *
 * The same as [[deflate]], but create gzip wrapper instead of
 * deflate one.
 **/
function gzip(input, options) {
  options = options || {};
  options.gzip = true;
  return deflate(input, options);
}


exports.Deflate = Deflate;
exports.deflate = deflate;
exports.deflateRaw = deflateRaw;
exports.gzip = gzip;

},{"./utils/common":1,"./utils/strings":2,"./zlib/deflate":5,"./zlib/messages":6,"./zlib/zstream":8}]},{},[])("/lib/deflate.js")
});


/***/ }),
/* 2582 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return exportPDF; });
/* unused harmony export saveAs */
/* unused harmony export toDataURL */
/* unused harmony export toBlob */
/* unused harmony export render */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core__ = __webpack_require__(682);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__drawing__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__geometry__ = __webpack_require__(121);
/* eslint-disable no-multi-spaces, key-spacing, indent, camelcase, space-before-blocks, eqeqeq, brace-style */
/* eslint-disable space-infix-ops, space-before-function-paren, array-bracket-spacing, object-curly-spacing */
/* eslint-disable no-nested-ternary, max-params, default-case, no-else-return, no-empty */
/* eslint-disable no-param-reassign, no-var, block-scoped-var */







var TEXT_RENDERING_MODE = __WEBPACK_IMPORTED_MODULE_2__core__["b" /* TEXT_RENDERING_MODE */];

var DASH_PATTERNS = {
    dash           : [ 4 ],
    dashDot        : [ 4, 2, 1, 2 ],
    dot            : [ 1, 2 ],
    longDash       : [ 8, 2 ],
    longDashDot    : [ 8, 2, 1, 2 ],
    longDashDotDot : [ 8, 2, 1, 2, 1, 2 ],
    solid          : []
};

var LINE_CAP = {
    butt   : 0,
    round  : 1,
    square : 2
};

var LINE_JOIN = {
    miter : 0,
    round : 1,
    bevel : 2
};

function render(group, callback) {
    var fonts = [], images = {}, options = group.options;

    function getOption(name, defval, hash) {
        if (!hash) {
            hash = options;
        }
        if (hash.pdf && hash.pdf[name] != null) {
            return hash.pdf[name];
        }
        return defval;
    }

    var multiPage = getOption("multiPage");
    var imgDPI = getOption("imgDPI");

    if (imgDPI) {
        __WEBPACK_IMPORTED_MODULE_2__core__["c" /* clearImageCache */]();
    }

    group.traverse(function(element){
        dispatch({
            Image: function(element) {
                var url = element.src();
                if (imgDPI) {
                    var box = element.bbox().size;
                    var prev = images[url];
                    box = {
                        width: Math.ceil(box.width * imgDPI / 72),
                        height: Math.ceil(box.height * imgDPI / 72)
                    };
                    if (prev) {
                        box.width = Math.max(prev.width, box.width);
                        box.height = Math.max(prev.height, box.height);
                    }
                    images[url] = box;
                } else {
                    images[url] = null;
                }
            },
            Text: function(element) {
                var style = __WEBPACK_IMPORTED_MODULE_2__core__["i" /* parseFontDef */](element.options.font);
                var url = __WEBPACK_IMPORTED_MODULE_2__core__["e" /* getFontURL */](style);
                if (fonts.indexOf(url) < 0) {
                    fonts.push(url);
                }
            }
        }, element);
    });

    function doIt() {
        if (--count > 0) {
            return;
        }

        var pdf = new (__WEBPACK_IMPORTED_MODULE_2__core__["a" /* Document */])({
            producer  : getOption("producer"),
            title     : getOption("title"),
            author    : getOption("author"),
            subject   : getOption("subject"),
            keywords  : getOption("keywords"),
            creator   : getOption("creator"),
            date      : getOption("date"),

            autoPrint : getOption("autoPrint")
        });

        function drawPage(group) {
            var options = group.options;

            var tmp = optimize(group);
            var bbox = tmp.bbox;
            group = tmp.root;
            // var tmp, bbox;

            var paperSize = getOption("paperSize", getOption("paperSize", "auto"), options), addMargin = false;
            if (paperSize == "auto") {
                if (bbox) {
                    var size = bbox.getSize();
                    paperSize = [ size.width, size.height ];
                    addMargin = true;
                    var origin = bbox.getOrigin();
                    tmp = new __WEBPACK_IMPORTED_MODULE_3__drawing__["c" /* Group */]();
                    tmp.transform(new __WEBPACK_IMPORTED_MODULE_4__geometry__["c" /* Matrix */](1, 0, 0, 1, -origin.x, -origin.y));
                    tmp.append(group);
                    group = tmp;
                }
                else {
                    paperSize = "A4";
                }
            }

            var page;
            page = pdf.addPage({
                paperSize : paperSize,
                margin    : getOption("margin", getOption("margin"), options),
                addMargin : addMargin,
                landscape : getOption("landscape", getOption("landscape", false), options)
            });
            drawElement(group, page, pdf);
        }

        if (multiPage) {
            group.children.forEach(drawPage);
        } else {
            drawPage(group);
        }

        callback(pdf.render(), pdf);
    }

    var count = 2;
    __WEBPACK_IMPORTED_MODULE_2__core__["g" /* loadFonts */](fonts, doIt);
    __WEBPACK_IMPORTED_MODULE_2__core__["h" /* loadImages */](images, doIt);
}

function toDataURL(group, callback) {
    render(group, function(data){
        callback("data:application/pdf;base64," + data.base64());
    });
}

function toBlob(group, callback) {
    render(group, function(data){
        callback(new window.Blob([ data.get() ], { type: "application/pdf" }));
    });
}

function saveAs(group, filename, proxy, callback) {
    // XXX: Safari has Blob, but does not support the download attribute
    //      so we'd end up converting to dataURL and using the proxy anyway.
    if (window.Blob && !__WEBPACK_IMPORTED_MODULE_1__common__["h" /* support */].browser.safari) {
        toBlob(group, function(blob){
            Object(__WEBPACK_IMPORTED_MODULE_1__common__["g" /* saveAs */])({ dataURI: blob, fileName: filename });
            if (callback) {
                callback(blob);
            }
        });
    } else {
        toDataURL(group, function(dataURL){
            Object(__WEBPACK_IMPORTED_MODULE_1__common__["g" /* saveAs */])({ dataURI: dataURL, fileName: filename, proxyURL: proxy });
            if (callback) {
                callback(dataURL);
            }
        });
    }
}

function dispatch(handlers, element) {
    var handler = handlers[element.nodeType];
    if (handler) {
        return handler.call.apply(handler, arguments);
    }
    return element;
}

function drawElement(element, page, pdf) {
    if (element.options._pdfDebug) {
        page.comment("BEGIN: " + element.options._pdfDebug);
    }

    var transform = element.transform();
    var opacity = element.opacity();

    page.save();

    if (opacity != null && opacity < 1) {
        page.setOpacity(opacity);
    }

    setStrokeOptions(element, page, pdf);
    setFillOptions(element, page, pdf);

    if (transform) {
        var m = transform.matrix();
        page.transform(m.a, m.b, m.c, m.d, m.e, m.f);
    }

    setClipping(element, page, pdf);

    dispatch({
        Path      : drawPath,
        MultiPath : drawMultiPath,
        Circle    : drawCircle,
        Arc       : drawArc,
        Text      : drawText,
        Image     : drawImage,
        Group     : drawGroup,
        Rect      : drawRect
    }, element, page, pdf);

    page.restore();

    if (element.options._pdfDebug) {
        page.comment("END: " + element.options._pdfDebug);
    }
}

function setStrokeOptions(element, page) {
    var stroke = element.stroke && element.stroke();
    if (!stroke) {
        return;
    }

    var color = stroke.color;
    if (color) {
        color = parseColor(color);
        if (color == null) {
            return; // no stroke
        }
        page.setStrokeColor(color.r, color.g, color.b);
        if (color.a != 1) {
            page.setStrokeOpacity(color.a);
        }
    }

    var width = stroke.width;
    if (width != null) {
        if (width === 0) {
            return; // no stroke
        }
        page.setLineWidth(width);
    }

    var dashType = stroke.dashType;
    if (dashType) {
        page.setDashPattern(DASH_PATTERNS[dashType], 0);
    }

    var lineCap = stroke.lineCap;
    if (lineCap) {
        page.setLineCap(LINE_CAP[lineCap]);
    }

    var lineJoin = stroke.lineJoin;
    if (lineJoin) {
        page.setLineJoin(LINE_JOIN[lineJoin]);
    }

    var opacity = stroke.opacity;
    if (opacity != null) {
        page.setStrokeOpacity(opacity);
    }
}

function setFillOptions(element, page) {
    var fill = element.fill && element.fill();
    if (!fill) {
        return;
    }

    if (fill instanceof __WEBPACK_IMPORTED_MODULE_3__drawing__["b" /* Gradient */]) {
        return;
    }

    var color = fill.color;
    if (color) {
        color = parseColor(color);
        if (color == null) {
            return; // no fill
        }
        page.setFillColor(color.r, color.g, color.b);
        if (color.a != 1) {
            page.setFillOpacity(color.a);
        }
    }

    var opacity = fill.opacity;
    if (opacity != null) {
        page.setFillOpacity(opacity);
    }
}

function setClipping(element, page, pdf) {
    // XXX: only Path supported at the moment.
    var clip = element.clip();
    if (clip) {
        _drawPath(clip, page, pdf);
        page.clip();
        // page.setStrokeColor(Math.random(), Math.random(), Math.random());
        // page.setLineWidth(1);
        // page.stroke();
    }
}

function shouldDraw(thing) {
    return (thing &&
            (thing instanceof __WEBPACK_IMPORTED_MODULE_3__drawing__["b" /* Gradient */] ||
             (thing.color && !/^(none|transparent)$/i.test(thing.color) &&
              (thing.width == null || thing.width > 0) &&
              (thing.opacity == null || thing.opacity > 0))));
}

function maybeGradient(element, page, pdf, stroke) {
    var fill = element.fill();
    if (fill instanceof __WEBPACK_IMPORTED_MODULE_3__drawing__["b" /* Gradient */]) {
        if (stroke) {
            page.clipStroke();
        } else {
            page.clip();
        }
        var isRadial = fill instanceof __WEBPACK_IMPORTED_MODULE_3__drawing__["h" /* RadialGradient */];
        var start, end;
        if (isRadial) {
            start = { x: fill.center().x , y: fill.center().y , r: 0 };
            end   = { x: fill.center().x , y: fill.center().y , r: fill.radius() };
        } else {
            start = { x: fill.start().x , y: fill.start().y };
            end   = { x: fill.end().x   , y: fill.end().y   };
        }

        var stops = fill.stops.elements().map(function(stop){
            var offset = stop.offset();
            if (/%$/.test(offset)) {
                offset = parseFloat(offset) / 100;
            } else {
                offset = parseFloat(offset);
            }
            var color = parseColor(stop.color());
            color.a *= stop.opacity();
            return {
                offset: offset,
                color: color
            };
        });

        // Duplicats first and last stop to fix
        // https://github.com/telerik/kendo-ui-core/issues/1782
        stops.unshift(stops[0]);
        stops.push(stops[stops.length - 1]);

        var gradient = {
            userSpace : fill.userSpace(),
            type      : isRadial ? "radial" : "linear",
            start     : start,
            end       : end,
            stops     : stops
        };
        var box = element.rawBBox();
        var tl = box.topLeft(), size = box.getSize();
        box = {
            left   : tl.x,
            top    : tl.y,
            width  : size.width,
            height : size.height
        };
        page.gradient(gradient, box);
        return true;
    }
}

function maybeFillStroke(element, page, pdf) {
    if (shouldDraw(element.fill()) && shouldDraw(element.stroke())) {
        if (!maybeGradient(element, page, pdf, true)) {
            page.fillStroke();
        }
    } else if (shouldDraw(element.fill())) {
        if (!maybeGradient(element, page, pdf, false)) {
            page.fill();
        }
    } else if (shouldDraw(element.stroke())) {
        page.stroke();
    } else {
        // we should not get here; the path should have been
        // optimized away.  but let's be prepared.
        page.nop();
    }
}

function maybeDrawRect(path, page) {
    var segments = path.segments;
    if (segments.length == 4 && path.options.closed) {
        // detect if this path looks like a rectangle parallel to the axis
        var a = [];
        for (var i = 0; i < segments.length; ++i) {
            if (segments[i].controlIn()) { // has curve?
                return false;
            }
            a[i] = segments[i].anchor();
        }
        // it's a rectangle if the y/x/y/x or x/y/x/y coords of
        // consecutive points are the same.
        var isRect = (
            a[0].y == a[1].y && a[1].x == a[2].x && a[2].y == a[3].y && a[3].x == a[0].x
        ) || (
            a[0].x == a[1].x && a[1].y == a[2].y && a[2].x == a[3].x && a[3].y == a[0].y
        );
        if (isRect) {
            // this saves a bunch of instructions in PDF:
            // moveTo, lineTo, lineTo, lineTo, close -> rect.
            page.rect(a[0].x, a[0].y,
                      a[2].x - a[0].x /*width*/,
                      a[2].y - a[0].y /*height*/);
            return true;
        }
    }
}

function _drawPath(element, page, pdf) {
    var segments = element.segments;
    if (segments.length === 0) {
        return;
    }
    if (!maybeDrawRect(element, page, pdf)) {
        for (var prev, i = 0; i < segments.length; ++i) {
            var seg = segments[i];
            var anchor = seg.anchor();
            if (!prev) {
                page.moveTo(anchor.x, anchor.y);
            } else {
                var prevOut = prev.controlOut();
                var controlIn = seg.controlIn();
                if (prevOut && controlIn) {
                    page.bezier(
                        prevOut.x   , prevOut.y,
                        controlIn.x , controlIn.y,
                        anchor.x    , anchor.y
                    );
                } else {
                    page.lineTo(anchor.x, anchor.y);
                }
            }
            prev = seg;
        }
        if (element.options.closed) {
            page.close();
        }
    }
}

function drawPath(element, page, pdf) {
    _drawPath(element, page, pdf);
    maybeFillStroke(element, page, pdf);
}

function drawMultiPath(element, page, pdf) {
    var paths = element.paths;
    for (var i = 0; i < paths.length; ++i) {
        _drawPath(paths[i], page, pdf);
    }
    maybeFillStroke(element, page, pdf);
}

function drawCircle(element, page, pdf) {
    var g = element.geometry();
    page.circle(g.center.x, g.center.y, g.radius);
    maybeFillStroke(element, page, pdf);
}

function drawArc(element, page, pdf) {
    var points = element.geometry().curvePoints();
    page.moveTo(points[0].x, points[0].y);
    for (var i = 1; i < points.length;) {
        page.bezier(
            points[i].x, points[i++].y,
            points[i].x, points[i++].y,
            points[i].x, points[i++].y
        );
    }
    maybeFillStroke(element, page, pdf);
}

function drawText(element, page) {
    var style = __WEBPACK_IMPORTED_MODULE_2__core__["i" /* parseFontDef */](element.options.font);
    var pos = element._position;
    var mode;
    if (element.fill() && element.stroke()) {
        mode = TEXT_RENDERING_MODE.fillAndStroke;
    } else if (element.fill()) {
        mode = TEXT_RENDERING_MODE.fill;
    } else if (element.stroke()) {
        mode = TEXT_RENDERING_MODE.stroke;
    }

    page.transform(1, 0, 0, -1, pos.x, pos.y + style.fontSize);
    page.beginText();
    page.setFont(__WEBPACK_IMPORTED_MODULE_2__core__["e" /* getFontURL */](style), style.fontSize);
    page.setTextRenderingMode(mode);
    page.showText(element.content(), element._pdfRect ? element._pdfRect.width() : null);
    page.endText();
}

function drawGroup(element, page, pdf) {
    if (element._pdfLink) {
        page.addLink(element._pdfLink.url, element._pdfLink);
    }
    var children = element.children;
    for (var i = 0; i < children.length; ++i) {
        drawElement(children[i], page, pdf);
    }
}

function drawImage(element, page) {
    var url = element.src();
    if (!url) {
        return;
    }

    var rect = element.rect();
    var tl = rect.getOrigin();
    var sz = rect.getSize();
    page.transform(sz.width, 0, 0, -sz.height, tl.x, tl.y + sz.height);
    page.drawImage(url);
}

function drawRect(element, page, pdf) {
    var geometry = element.geometry();
    page.rect(geometry.origin.x, geometry.origin.y, geometry.size.width, geometry.size.height);
    maybeFillStroke(element, page, pdf);
}

function parseColor(value) {
    var color = Object(__WEBPACK_IMPORTED_MODULE_1__common__["f" /* parseColor */])(value, true);
    return color ? color.toRGB() : null;
}

function optimize(root) {
    var clipbox = false;
    var matrix = __WEBPACK_IMPORTED_MODULE_4__geometry__["c" /* Matrix */].unit();
    var currentBox = null;
    var changed;
    do {
        changed = false;
        root = opt(root);
    } while (root && changed);
    return { root: root, bbox: currentBox };

    function change(newShape) {
        changed = true;
        return newShape;
    }

    function visible(shape) {
        return (shape.visible() && shape.opacity() > 0 &&
                ( shouldDraw(shape.fill()) ||
                  shouldDraw(shape.stroke()) ));
    }

    function optArray(a) {
        var b = [];
        for (var i = 0; i < a.length; ++i) {
            var el = opt(a[i]);
            if (el != null) {
                b.push(el);
            }
        }
        return b;
    }

    function withClipping(shape, f) {
        var saveclipbox = clipbox;
        var savematrix = matrix;

        if (shape.transform()) {
            matrix = matrix.multiplyCopy(shape.transform().matrix());
        }

        var clip = shape.clip();
        if (clip) {
            clip = clip.bbox();
            if (clip) {
                clip = clip.bbox(matrix);
                clipbox = clipbox ? __WEBPACK_IMPORTED_MODULE_4__geometry__["d" /* Rect */].intersect(clipbox, clip) : clip;
            }
        }

        try {
            return f();
        }
        finally {
            clipbox = saveclipbox;
            matrix = savematrix;
        }
    }

    function inClipbox(shape) {
        if (clipbox == null) {
            return false;
        }
        var box = shape.rawBBox().bbox(matrix);
        if (clipbox && box) {
            box = __WEBPACK_IMPORTED_MODULE_4__geometry__["d" /* Rect */].intersect(box, clipbox);
        }
        return box;
    }

    function opt(shape) {
        return withClipping(shape, function(){
            if (!(shape instanceof __WEBPACK_IMPORTED_MODULE_3__drawing__["c" /* Group */] || shape instanceof __WEBPACK_IMPORTED_MODULE_3__drawing__["f" /* MultiPath */])) {
                var box = inClipbox(shape);
                if (!box) {
                    return change(null);
                }
                currentBox = currentBox ? __WEBPACK_IMPORTED_MODULE_4__geometry__["d" /* Rect */].union(currentBox, box) : box;
            }
            return dispatch({
                Path: function(shape) {
                    if (shape.segments.length === 0 || !visible(shape)) {
                        return change(null);
                    }
                    return shape;
                },
                MultiPath: function(shape) {
                    if (!visible(shape)) {
                        return change(null);
                    }
                    var el = new __WEBPACK_IMPORTED_MODULE_3__drawing__["f" /* MultiPath */](shape.options);
                    el.paths = optArray(shape.paths);
                    if (el.paths.length === 0) {
                        return change(null);
                    }
                    return el;
                },
                Circle: function(shape) {
                    if (!visible(shape)) {
                        return change(null);
                    }
                    return shape;
                },
                Arc: function(shape) {
                    if (!visible(shape)) {
                        return change(null);
                    }
                    return shape;
                },
                Text: function(shape) {
                    if (!/\S/.test(shape.content()) || !visible(shape)) {
                        return change(null);
                    }
                    return shape;
                },
                Image: function(shape) {
                    if (!(shape.visible() && shape.opacity() > 0)) {
                        return change(null);
                    }
                    return shape;
                },
                Group: function(shape) {
                    var el = new __WEBPACK_IMPORTED_MODULE_3__drawing__["c" /* Group */](shape.options);
                    el.children = optArray(shape.children);
                    el._pdfLink = shape._pdfLink;
                    if (shape !== root && el.children.length === 0 && !shape._pdfLink) {
                        return change(null);
                    }
                    return el;
                },
                Rect: function(shape) {
                    if (!visible(shape)) {
                        return change(null);
                    }
                    return shape;
                }
            }, shape);
        });
    }
}

function exportPDF(group, options) {
    var promise = Object(__WEBPACK_IMPORTED_MODULE_0__util__["f" /* createPromise */])();

    for (var i in options) {
        if (i == "margin" && group.options.pdf && group.options.pdf._ignoreMargin) {
            // This hackish option is set by the page breaking code in drawDOM.  The idea is
            // that margin is already taken into account there (that's required to do proper
            // page breaking) and we don't want to set it again here, as it would double the
            // top-left margin, and truncate the content on bottom/right.
            continue;
        }
        group.options.set("pdf." + i, options[i]);
    }

    toDataURL(group, promise.resolve);

    return promise;
}




/***/ }),
/* 2583 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__html_core__ = __webpack_require__(2584);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__html_core__["a"]; });



/***/ }),
/* 2584 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return drawDOM; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__geometry__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__pdf__ = __webpack_require__(412);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__drawing__ = __webpack_require__(198);
/* eslint-disable no-multi-spaces, key-spacing, indent, camelcase, space-before-blocks, eqeqeq, brace-style */
/* eslint-disable space-infix-ops, space-before-function-paren, array-bracket-spacing, object-curly-spacing */
/* eslint-disable no-nested-ternary, max-params, default-case, no-else-return, no-empty, yoda */
/* eslint-disable no-param-reassign, no-var, block-scoped-var */







var browser = __WEBPACK_IMPORTED_MODULE_3__common__["h" /* support */].browser;
/*

  XXX: to test:

  - cloneNodes function:
    - drawing document containing canvas with page breaking
    - drawing document with named radio <input>-s (should not clear selection)
    - IE9/IE10 don't support el.dataset; do they copy user data?

  - repeating table headers/footers on page breaking

  - forceBreak, keepTogether

  - avoidLinks

 */

/* -----[ local vars ]----- */

function slice(thing) {
    return Array.prototype.slice.call(thing);
}

var KENDO_PSEUDO_ELEMENT = "KENDO-PSEUDO-ELEMENT";

var IMAGE_CACHE = {};

var nodeInfo = {};
nodeInfo._root = nodeInfo;

/* -----[ Custom Text node to speed up rendering in PDF ]----- */

var inBrowser = typeof window !== 'undefined';
var microsoft = inBrowser ? browser.msie || browser.edge : false;

var TextRect = (function (Text) {
  function TextRect(str, rect, options) {
        Text.call(this, str, rect.getOrigin(), options);
        this._pdfRect = rect;
    }

  if ( Text ) TextRect.__proto__ = Text;
  TextRect.prototype = Object.create( Text && Text.prototype );
  TextRect.prototype.constructor = TextRect;
    TextRect.prototype.rect = function rect () {
        // this is the crux of it: we can avoid a call to
        // measure(), which is what the base class does, since we
        // already know the rect.  measure() is s-l-o-w.
        return this._pdfRect;
    };
    TextRect.prototype.rawBBox = function rawBBox () {
        // also let's avoid creating a new rectangle.
        return this._pdfRect;
    };

  return TextRect;
}(__WEBPACK_IMPORTED_MODULE_4__drawing__["i" /* Text */]));

function addClass(el, cls) {
    if (el.classList) {
        el.classList.add(cls);
    } else {
        el.className += " " + cls;
    }
}

function removeClass(el, cls) {
    if (el.classList) {
        el.classList.remove(cls);
    } else {
        el.className = el.className.split(/\s+/).reduce(function(a, word){
            if (word != cls) {
                a.push(word);
            }
            return a;
        }, []).join(" ");
    }
}

function setCSS(el, styles) {
    Object.keys(styles).forEach(function(key){
        el.style[key] = styles[key];
    });
}

var matches = typeof Element !== "undefined" && Element.prototype && (function(p){
    if (p.matches) {
        return function(el, selector) { return el.matches(selector); };
    }
    if (p.webkitMatchesSelector) {
        return function(el, selector) { return el.webkitMatchesSelector(selector); };
    }
    if (p.mozMatchesSelector) {
        return function(el, selector) { return el.mozMatchesSelector(selector); };
    }
    if (p.msMatchesSelector) {
        return function(el, selector) { return el.msMatchesSelector(selector); };
    }
    return function(s) {
	return [].indexOf.call(document.querySelectorAll(s), this) !== -1;
    };
})(Element.prototype);

function closest(el, selector) {
    if (el.closest) {
        return el.closest(selector);
    }
    // IE: stringifying rather than simply comparing with `document`,
    // which is not iframe-proof and fails in editor export —
    // https://github.com/telerik/kendo/issues/6721
    while (el && !/^\[object (?:HTML)?Document\]$/.test(String(el))) {
        if (el.nodeType == 1 /* Element */ && matches(el, selector)) {
            return el;
        }
        el = el.parentNode;
    }
}

// clone nodes ourselves, so that we redraw <canvas> (DOM or
// jQuery clone will not)
var cloneNodes = (function($){
    if ($) {
        // if we have Kendo and jQuery, use this version as it will
        // maintain proper links between cloned element and Kendo
        // widgets (i.e. it clones jQuery data(), which isn't the same
        // as element's data attributes).
        // https://github.com/telerik/kendo-ui-core/issues/2750
        return function cloneNodes(el) {
            var clone = el.cloneNode(false);
            if (el.nodeType == 1 /* Element */) {
                var $el = $(el), $clone = $(clone), i;
                var data = $el.data();
                for (i in data) {
                    $clone.data(i, data[i]);
                }
                if (/^canvas$/i.test(el.tagName)) {
                    clone.getContext("2d").drawImage(el, 0, 0);
                } else if (/^(?:input|select|textarea|option)$/i.test(el.tagName)) {
                    // drop the name attributes so that we don't affect the selection of the
                    // original nodes (i.e. checked status of radio buttons) when we insert our copy
                    // into the DOM.  https://github.com/telerik/kendo/issues/5409
                    clone.removeAttribute("id");
                    clone.removeAttribute("name");
                    clone.value = el.value;
                    clone.checked = el.checked;
                    clone.selected = el.selected;
                }
                for (i = el.firstChild; i; i = i.nextSibling) {
                    clone.appendChild(cloneNodes(i));
                }
            }
            return clone;
        };
    } else {
        // the no-jQuery version
        return function cloneNodes(el) {
            var clone = (function dive(node){
                var clone = node.cloneNode(false);
                if (node._kendoExportVisual) {
                    clone._kendoExportVisual = node._kendoExportVisual;
                }
                for (var i = node.firstChild; i; i = i.nextSibling) {
                    clone.appendChild(dive(i));
                }
                return clone;
            })(el);

            // re-draw canvases - https://github.com/telerik/kendo/issues/4872
            var canvases = el.querySelectorAll("canvas");
            if (canvases.length) {
                slice(clone.querySelectorAll("canvas")).forEach(function (canvas, i) {
                    canvas.getContext("2d").drawImage(canvases[i], 0, 0);
                });
            }

            // remove "name" attributes from <input> elements -
            // https://github.com/telerik/kendo/issues/5409
            var orig = el.querySelectorAll("input, select, textarea, option");
            slice(clone.querySelectorAll("input, select, textarea, option")).forEach(function (el, i) {
                el.removeAttribute("id");
                el.removeAttribute("name");
                el.value = orig[i].value;
                el.checked = orig[i].checked;
                el.selected = orig[i].selected;
            });

            return clone;
        };
    }
})(typeof window !== "undefined" && window.kendo && window.kendo.jQuery);

function getXY(thing) {
    if (typeof thing == "number") {
        return { x: thing, y: thing };
    }
    if (Array.isArray(thing)) {
        return { x: thing[0], y: thing[1] };
    }
    return { x: thing.x, y: thing.y };
}

function drawDOM(element, options) {
    if (!options) {
        options = {};
    }
    var promise = Object(__WEBPACK_IMPORTED_MODULE_2__util__["f" /* createPromise */])();

    if (!element) {
        return promise.reject("No element to export");
    }

    if (typeof window.getComputedStyle != "function") {
        throw new Error("window.getComputedStyle is missing.  You are using an unsupported browser, or running in IE8 compatibility mode.  Drawing HTML is supported in Chrome, Firefox, Safari and IE9+.");
    }

    __WEBPACK_IMPORTED_MODULE_1__pdf__["a" /* defineFont */](getFontFaces(element.ownerDocument));

    var scale = getXY(options.scale || 1);

    function doOne(element) {
        var group = new __WEBPACK_IMPORTED_MODULE_4__drawing__["c" /* Group */]();

        // translate to start of page
        var pos = element.getBoundingClientRect();
        setTransform(group, [
            scale.x,
            0,
            0,
            scale.y,
            (-pos.left * scale.x),
            (-pos.top * scale.y)
        ]);

        nodeInfo._clipbox = false;
        nodeInfo._matrix = __WEBPACK_IMPORTED_MODULE_0__geometry__["c" /* Matrix */].unit();
        nodeInfo._stackingContext = {
            element: element,
            group: group
        };

        if (options.avoidLinks === true) {
            nodeInfo._avoidLinks = "a";
        } else {
            nodeInfo._avoidLinks = options.avoidLinks;
        }

        addClass(element, "k-pdf-export");
        renderElement(element, group);
        removeClass(element, "k-pdf-export");

        return group;
    }

    cacheImages(element, function(){
        var forceBreak = options && options.forcePageBreak;
        var hasPaperSize = options && options.paperSize && options.paperSize != "auto";
        var paperOptions = __WEBPACK_IMPORTED_MODULE_1__pdf__["c" /* getPaperOptions */](function(key, def){
            if (key == "paperSize") {
                // PDF.getPaperOptions croaks on "auto", just pass dummy A4 as we might
                // still be interested in margins.
                return hasPaperSize ? options[key] : "A4";
            }
            return key in options ? options[key] : def;
        });
        var pageWidth = hasPaperSize && paperOptions.paperSize[0];
        var pageHeight = hasPaperSize && paperOptions.paperSize[1];
        var margin = options.margin && paperOptions.margin;
        var hasMargin = Boolean(margin);
        if (forceBreak || pageHeight) {
            if (!margin) {
                margin = { left: 0, top: 0, right: 0, bottom: 0 };
            }

            // we want paper size and margin to be unaffected by
            // scaling in the output, so we have to reverse-scale
            // before our calculations begin.
            if (pageWidth)  { pageWidth  /= scale.x; }
            if (pageHeight) { pageHeight /= scale.y; }
            margin.left   /= scale.x;
            margin.right  /= scale.x;
            margin.top    /= scale.y;
            margin.bottom /= scale.y;

            var group = new __WEBPACK_IMPORTED_MODULE_4__drawing__["c" /* Group */]({
                pdf: {
                    multiPage     : true,
                    paperSize     : hasPaperSize ? paperOptions.paperSize : "auto",
                    _ignoreMargin : hasMargin // HACK!  see exportPDF in pdf/drawing.js
                }
            });
            handlePageBreaks(
                function(x) {
                    if (options.progress) {
                        var canceled = false, pageNum = 0;
                        (function next(){
                            if (pageNum < x.pages.length) {
                                var page = doOne(x.pages[pageNum]);
                                group.append(page);
                                options.progress({
                                    page: page,
                                    pageNum: ++pageNum,
                                    totalPages: x.pages.length,
                                    cancel: function() {
                                        canceled = true;
                                    }
                                });
                                if (!canceled) {
                                    setTimeout(next);
                                } else {
                                    // XXX: should we also fail() the deferred object?
                                    x.container.parentNode.removeChild(x.container);
                                }
                            } else {
                                x.container.parentNode.removeChild(x.container);
                                promise.resolve(group);
                            }
                        })();
                    } else {
                        x.pages.forEach(function(page){
                            group.append(doOne(page));
                        });
                        x.container.parentNode.removeChild(x.container);
                        promise.resolve(group);
                    }
                },
                element,
                forceBreak,
                pageWidth ? pageWidth - margin.left - margin.right : null,
                pageHeight ? pageHeight - margin.top - margin.bottom : null,
                margin,
                options
            );
        } else {
            promise.resolve(doOne(element));
        }
    });

    function makeTemplate(template) {
        if (template != null) {
            if (typeof template == "string") {
                template = Object(__WEBPACK_IMPORTED_MODULE_3__common__["i" /* template */])(template.replace(/^\s+|\s+$/g, ""));
            }
            if (typeof template == "function") {
                return function(data) {
                    var el = template(data);
                    if (el && typeof el == "string") {
                        var div = document.createElement("div");
                        div.innerHTML = el;
                        el = div.firstElementChild;
                    }
                    return el;
                };
            }
            // assumed DOM element
            return function() {
                return template.cloneNode(true);
            };
        }
    }

    function handlePageBreaks(callback, element, forceBreak, pageWidth, pageHeight, margin, options) {
        var template = makeTemplate(options.template);
        var doc = element.ownerDocument;
        var pages = [];
        var copy = options._destructive ? element : cloneNodes(element);
        var container = doc.createElement("KENDO-PDF-DOCUMENT");
        var adjust = 0;

        // make sure <tfoot> elements are at the end (Grid widget
        // places TFOOT before TBODY, tricking our algorithm to
        // insert a page break right after the header).
        // https://github.com/telerik/kendo/issues/4699
        slice(copy.querySelectorAll("tfoot")).forEach(function(tfoot){
            tfoot.parentNode.appendChild(tfoot);
        });

        // remember the index of each LI from an ordered list.
        // we'll use it to reconstruct the proper numbering.
        slice(copy.querySelectorAll("ol")).forEach(function(ol){
            slice(ol.children).forEach(function(li, index){
                li.setAttribute("kendo-split-index", index);
            });
        });

        setCSS(container, {
            display   : "block",
            position  : "absolute",
            boxSizing : "content-box",
            left      : "-10000px",
            top       : "-10000px"
        });

        if (pageWidth) {
            // subtle: if we don't set the width *and* margins here, the layout in this
            // container will be different from the one in our final page elements, and we'll
            // split at the wrong places.
            setCSS(container, {
                width        : pageWidth + "px",
                paddingLeft  : margin.left + "px",
                paddingRight : margin.right + "px"
            });

            // when the first element has a margin-top (i.e. a <h1>) the page will be
            // inadvertently enlarged by that number (the browser will report the container's
            // bounding box top to start at the element's top, rather than including its
            // margin).  Adding overflow: hidden seems to fix it.
            //
            // to understand the difference, try the following snippets in your browser:
            //
            // 1. <div style="background: yellow">
            //      <h1 style="margin: 3em">Foo</h1>
            //    </div>
            //
            // 2. <div style="background: yellow; overflow: hidden">
            //      <h1 style="margin: 3em">Foo</h1>
            //    </div>
            //
            // this detail is not important when automatic page breaking is not requested, hence
            // doing it only if pageWidth is defined.
            setCSS(copy, { overflow: "hidden" });
        }

        element.parentNode.insertBefore(container, element);
        container.appendChild(copy);

        // we need the timeouts here, so that images dimensions are
        // properly computed in DOM when we start our thing.
        if (options.beforePageBreak) {
            setTimeout(function(){
                options.beforePageBreak(container, doPageBreak);
            }, 15);
        } else {
            setTimeout(doPageBreak, 15);
        }

        function doPageBreak() {
            if (forceBreak != "-" || pageHeight) {
                splitElement(copy);
            }

            {
                var page = makePage();
                copy.parentNode.insertBefore(page, copy);
                page.appendChild(copy);
            }

            if (template) {
                pages.forEach(function(page, i){
                    var el = template({
                        element    : page,
                        pageNum    : i + 1,
                        totalPages : pages.length
                    });
                    if (el) {
                        page.appendChild(el);
                    }
                });
            }

            cacheImages(pages, function() {
                // Even though we already cached images, they simply won't be available
                // immediately in the newly created DOM.  Previously we'd allow a 10ms timeout,
                // but that's arbitrary and clearly not working in all cases
                // (https://github.com/telerik/kendo/issues/5399), so this function will wait
                // for their .complete attribute.
                whenImagesAreActuallyLoaded(pages, function(){
                    callback({ pages: pages, container: container });
                });
            });
        }

        function keepTogether(el) {
            if (options.keepTogether && matches(el, options.keepTogether) && el.offsetHeight <= pageHeight - adjust) {
                return true;
            }

            var tag = el.tagName;
            if (/^h[1-6]$/i.test(tag) && el.offsetHeight >= pageHeight - adjust) {
                return false;
            }

            return (el.getAttribute("data-kendo-chart") ||
                    /^(?:img|tr|thead|th|tfoot|iframe|svg|object|canvas|input|textarea|select|video|h[1-6])/i.test(el.tagName));
        }

        function splitElement(element) {
            if (element.tagName == "TABLE") {
                setCSS(element, { tableLayout: "fixed" });
            }
            if (keepTogether(element)) {
                return;
            }
            var style = getComputedStyle(element);
            var bottomPadding = parseFloat(getPropertyValue(style, "padding-bottom"));
            var bottomBorder = parseFloat(getPropertyValue(style, "border-bottom-width"));
            var saveAdjust = adjust;
            adjust += bottomPadding + bottomBorder;
            var isFirst = true;
            for (var el = element.firstChild; el; el = el.nextSibling) {
                if (el.nodeType == 1 /* Element */) {
                    isFirst = false;
                    if (matches(el, forceBreak)) {
                        breakAtElement(el);
                        continue;
                    }
                    if (!pageHeight) {
                        // we're in "manual breaks mode"
                        splitElement(el);
                        continue;
                    }
                    if (!/^(?:static|relative)$/.test(getPropertyValue(getComputedStyle(el), "position"))) {
                        continue;
                    }
                    var fall = fallsOnMargin(el);
                    if (fall == 1) {
                        // element starts on next page, break before anyway.
                        breakAtElement(el);
                    }
                    else if (fall) {
                        // elements ends up on next page, or possibly doesn't fit on a page at
                        // all.  break before it anyway if it's an <img> or <tr>, otherwise
                        // attempt to split.
                        if (keepTogether(el)) {
                            breakAtElement(el);
                        } else {
                            splitElement(el);
                        }
                    }
                    else {
                        splitElement(el);
                    }
                }
                else if (el.nodeType == 3 /* Text */ && pageHeight) {
                    splitText(el, isFirst);
                    isFirst = false;
                }
            }
            adjust = saveAdjust;
        }

        function firstInParent(el) {
            var p = el.parentNode, first = p.firstChild;
            if (el === first) {
                return true;
            }
            if (el === p.children[0]) {
                if (first.nodeType == 7 /* comment */ ||
                    first.nodeType == 8 /* processing instruction */) {
                    return true;
                }
                if (first.nodeType == 3 /* text */) {
                    // if whitespace only we can probably consider it's first
                    return !/\S/.test(first.data);
                }
            }
            return false;
        }

        function breakAtElement(el) {
            if (el.nodeType == 1 && el !== copy && firstInParent(el)) {
                return breakAtElement(el.parentNode);
            }
            var table, colgroup, thead, grid, gridHead;
            table = closest(el, "table");
            colgroup = table && table.querySelector("colgroup");
            if (options.repeatHeaders) {
                thead = table && table.querySelector("thead");

                // If we break page in a Kendo Grid, repeat its header.  This ugly hack is
                // necessary because a scrollable grid will keep the header in a separate
                // <table> element from its content.
                //
                // XXX: This is likely to break as soon as the widget HTML is modified.
                grid = closest(el, ".k-grid.k-widget");
                if (grid && grid.querySelector(".k-auto-scrollable")) {
                    gridHead = grid.querySelector(".k-grid-header");
                }
            }
            var page = makePage();
            var range = doc.createRange();
            range.setStartBefore(copy);
            range.setEndBefore(el);
            page.appendChild(range.extractContents());
            copy.parentNode.insertBefore(page, copy);
            preventBulletOnListItem(el.parentNode);
            if (table) {
                table = closest(el, "table"); // that's the <table> on next page!
                if (options.repeatHeaders && thead) {
                    table.insertBefore(thead.cloneNode(true), table.firstChild);
                }
                if (colgroup) {
                    table.insertBefore(colgroup.cloneNode(true), table.firstChild);
                }
            }
            if (options.repeatHeaders && gridHead) {
                grid = closest(el, ".k-grid.k-widget");
                grid.insertBefore(gridHead.cloneNode(true), grid.firstChild);
            }
        }

        function makePage() {
            var page = doc.createElement("KENDO-PDF-PAGE");
            setCSS(page, {
                display  : "block",
                boxSizing: "content-box",
                width    : pageWidth ? (pageWidth + "px") : "auto",
                padding  : (margin.top + "px " +
                            margin.right + "px " +
                            margin.bottom + "px " +
                            margin.left + "px"),

                // allow absolutely positioned elements to be relative to current page
                position : "relative",

                // without the following we might affect layout of subsequent pages
                height   : pageHeight ? (pageHeight + "px") : "auto",
                overflow : pageHeight || pageWidth ? "hidden" : "visible",
                clear    : "both"
            });

            // debug
            // $("<div>").css({
            //     position  : "absolute",
            //     left      : margin.left,
            //     top       : margin.top,
            //     width     : pageWidth,
            //     height    : pageHeight,
            //     boxSizing : "border-box",
            //     background: "rgba(255, 255, 0, 0.5)"
            //     //border    : "1px solid red"
            // }).appendTo(page);

            if (options && options.pageClassName) {
                page.className = options.pageClassName;
            }
            pages.push(page);
            return page;
        }

        function fallsOnMargin(thing) {
            var box = thing.getBoundingClientRect();
            if (box.width === 0 || box.height === 0) {
                // I'd say an element with dimensions zero fits on current page.
                return 0;
            }
            var top = copy.getBoundingClientRect().top;
            var available = pageHeight - adjust;
            return (box.height > available) ? 3
                : (box.top - top > available) ? 1
                : (box.bottom - top > available) ? 2
                : 0;
        }

        function splitText(node, isFirst) {
            if (!/\S/.test(node.data)) {
                return;
            }

            var len = node.data.length;
            var range = doc.createRange();
            range.selectNodeContents(node);
            var fall = fallsOnMargin(range);
            if (!fall) {
                return;     // the whole text fits on current page
            }

            var nextnode = node;
            if (fall == 1) {
                // starts on next page, break before anyway.
                if (isFirst) {
                    // avoid leaving an empty <p>, <li>, etc. on previous page.
                    breakAtElement(node.parentNode);
                } else {
                    breakAtElement(node);
                }
            }
            else {
                (function findEOP(min, pos, max) {
                    range.setEnd(node, pos);
                    if (min == pos || pos == max) {
                        return pos;
                    }
                    if (fallsOnMargin(range)) {
                        return findEOP(min, (min + pos) >> 1, pos);
                    } else {
                        return findEOP(pos, (pos + max) >> 1, max);
                    }
                })(0, len >> 1, len);

                if (!/\S/.test(range.toString()) && isFirst) {
                    // avoid leaving an empty <p>, <li>, etc. on previous page.
                    breakAtElement(node.parentNode);
                } else {
                    // This is only needed for IE, but it feels cleaner to do it anyway.  Without
                    // it, IE will truncate a very long text (playground/pdf-long-text-2.html).
                    nextnode = node.splitText(range.endOffset);

                    var page = makePage();
                    range.setStartBefore(copy);
                    page.appendChild(range.extractContents());
                    copy.parentNode.insertBefore(page, copy);
                    preventBulletOnListItem(nextnode.parentNode);
                }
            }

            splitText(nextnode);
        }

        function preventBulletOnListItem(el) {
            // set a hint on continued LI elements, to tell the
            // renderer not to draw the bullet again.
            // https://github.com/telerik/kendo-ui-core/issues/2732
            var li = closest(el, "li");
            if (li) {
                li.setAttribute("kendo-no-bullet", "1");
                preventBulletOnListItem(li.parentNode);
            }
        }
    }

    return promise;
}

drawDOM.getFontFaces = getFontFaces;

// This is needed for the Spreadsheet print functionality.  Since
// there we only need to draw text, this cuts through the ceremony
// of drawDOM/renderElement and renders the text node directly.
drawDOM.drawText = function(element) {
    var group = new __WEBPACK_IMPORTED_MODULE_4__drawing__["c" /* Group */]();
    nodeInfo._clipbox = false;
    nodeInfo._matrix = __WEBPACK_IMPORTED_MODULE_0__geometry__["c" /* Matrix */].unit();
    nodeInfo._stackingContext = {
        element: element,
        group: group
    };
    pushNodeInfo(element, getComputedStyle(element), group);
    if (element.firstChild.nodeType == 3 /* Text */) {
        // avoid the penalty of renderElement
        renderText(element, element.firstChild, group);
    } else {
        _renderElement(element, group);
    }
    popNodeInfo();
    return group;
};

var parseBackgroundImage = (function(){
    var tok_linear_gradient  = /^((-webkit-|-moz-|-o-|-ms-)?linear-gradient\s*)\(/;
    //var tok_radial_gradient  = /^((-webkit-|-moz-|-o-|-ms-)?radial-gradient\s*)\(/;
    var tok_percent          = /^([-0-9.]+%)/;
    var tok_length           = /^([-0-9.]+px)/;
    var tok_keyword          = /^(left|right|top|bottom|to|center)\W/;
    var tok_angle            = /^([-0-9.]+(deg|grad|rad|turn))/;
    var tok_whitespace       = /^(\s+)/;
    var tok_popen            = /^(\()/;
    var tok_pclose           = /^(\))/;
    var tok_comma            = /^(,)/;
    var tok_url              = /^(url)\(/;
    var tok_content          = /^(.*?)\)/;

    var cache1 = {}, cache2 = {};

    function parse(input) {
        var orig = input;
        if (hasOwnProperty(cache1, orig)) {
            return cache1[orig];
        }
        function skip_ws() {
            var m = tok_whitespace.exec(input);
            if (m) {
                input = input.substr(m[1].length);
            }
        }
        function read(token) {
            skip_ws();
            var m = token.exec(input);
            if (m) {
                input = input.substr(m[1].length);
                return m[1];
            }
        }

        function read_stop() {
            var color = Object(__WEBPACK_IMPORTED_MODULE_3__common__["f" /* parseColor */])(input, true);
            var length, percent;
            if (color) {
                var match =
                    /^#[0-9a-f]+/i.exec(input) ||
                    /^rgba?\(.*?\)/i.exec(input) ||
                    /^..*?\b/.exec(input); // maybe named color
                input = input.substr(match[0].length);
                color = color.toRGB();
                if (!(length = read(tok_length))) {
                    percent = read(tok_percent);
                }
                return { color: color, length: length, percent: percent };
            }
        }

        function read_linear_gradient(propName) {
            var angle;
            var to1, to2;
            var stops = [];
            var reverse = false;

            if (read(tok_popen)) {
                // 1. [ <angle> || to <side-or-corner>, ]?
                angle = read(tok_angle);
                if (angle) {
                    angle = parseAngle(angle);
                    read(tok_comma);
                }
                else {
                    to1 = read(tok_keyword);
                    if (to1 == "to") {
                        to1 = read(tok_keyword);
                    } else if (to1 && /^-/.test(propName)) {
                        reverse = true;
                    }
                    to2 = read(tok_keyword);
                    read(tok_comma);
                }

                if (/-moz-/.test(propName) && angle == null && to1 == null) {
                    var x = read(tok_percent), y = read(tok_percent);
                    reverse = true;
                    if (x == "0%") {
                        to1 = "left";
                    } else if (x == "100%") {
                        to1 = "right";
                    }
                    if (y == "0%") {
                        to2 = "top";
                    } else if (y == "100%") {
                        to2 = "bottom";
                    }
                    read(tok_comma);
                }

                // 2. color stops
                while (input && !read(tok_pclose)) {
                    var stop = read_stop();
                    if (!stop) {
                        break;
                    }
                    stops.push(stop);
                    read(tok_comma);
                }

                return {
                    type    : "linear",
                    angle   : angle,
                    to      : to1 && to2 ? to1 + " " + to2 : to1 ? to1 : to2 ? to2 : null,
                    stops   : stops,
                    reverse : reverse
                };
            }
        }

        function read_url() {
            if (read(tok_popen)) {
                var url = read(tok_content);
                url = url.replace(/^['"]+|["']+$/g, "");
                read(tok_pclose);
                return { type: "url", url: url };
            }
        }

        var tok;

        if ((tok = read(tok_linear_gradient))) {
            tok = read_linear_gradient(tok);
        }
        else if ((tok = read(tok_url))) {
            tok = read_url();
        }

        return (cache1[orig] = tok || { type: "none" });
    }

    return function(input) {
        if (hasOwnProperty(cache2, input)) {
            return cache2[input];
        }
        return (cache2[input] = splitProperty(input).map(parse));
    };
})();

var splitProperty = (function(){
    var cache = {};
    return function(input, separator) {
        if (!separator) {
            separator = /^\s*,\s*/;
        }

        var cacheKey = input + separator;

        if (hasOwnProperty(cache, cacheKey)) {
            return cache[cacheKey];
        }

        var ret = [];
        var last = 0, pos = 0;
        var in_paren = 0;
        var in_string = false;
        var m;

        function looking_at(rx) {
            return (m = rx.exec(input.substr(pos)));
        }

        function trim(str) {
            return str.replace(/^\s+|\s+$/g, "");
        }

        while (pos < input.length) {
            if (!in_string && looking_at(/^[\(\[\{]/)) {
                in_paren++;
                pos++;
            }
            else if (!in_string && looking_at(/^[\)\]\}]/)) {
                in_paren--;
                pos++;
            }
            else if (!in_string && looking_at(/^[\"\']/)) {
                in_string = m[0];
                pos++;
            }
            else if (in_string == "'" && looking_at(/^\\\'/)) {
                pos += 2;
            }
            else if (in_string == '"' && looking_at(/^\\\"/)) {
                pos += 2;
            }
            else if (in_string == "'" && looking_at(/^\'/)) {
                in_string = false;
                pos++;
            }
            else if (in_string == '"' && looking_at(/^\"/)) {
                in_string = false;
                pos++;
            }
            else if (looking_at(separator)) {
                if (!in_string && !in_paren && pos > last) {
                    ret.push(trim(input.substring(last, pos)));
                    last = pos + m[0].length;
                }
                pos += m[0].length;
            }
            else {
                pos++;
            }
        }
        if (last < pos) {
            ret.push(trim(input.substring(last, pos)));
        }
        return (cache[cacheKey] = ret);
    };
})();

var getFontURL = (function(cache){
    return function(el){
        // XXX: for IE we get here the whole cssText of the rule,
        // because the computedStyle.src is empty.  Next time we need
        // to fix these regexps we better write a CSS parser. :-\
        var url = cache[el];
        if (!url) {
            var m;
            if ((m = /url\((['"]?)([^'")]*?)\1\)\s+format\((['"]?)truetype\3\)/.exec(el))) {
                url = cache[el] = m[2];
            } else if ((m = /url\((['"]?)([^'")]*?\.ttf)\1\)/.exec(el))) {
                url = cache[el] = m[2];
            }
        }
        return url;
    };
})(Object.create(null));

var getFontHeight = (function(cache){
    return function(font) {
        var height = cache[font];
        if (height == null) {
            height = cache[font] = Object(__WEBPACK_IMPORTED_MODULE_2__util__["s" /* measureText */])("Mapq", { font: font }).height;
        }
        return height;
    };
})(Object.create(null));

function getFontFaces(doc) {
    if (doc == null) {
        doc = document;
    }
    var result = {};
    for (var i = 0; i < doc.styleSheets.length; ++i) {
        doStylesheet(doc.styleSheets[i]);
    }
    return result;
    function doStylesheet(ss) {
        if (ss) {
            var rules = null;
            try {
                rules = ss.cssRules;
            } catch (ex) {}
            if (rules) {
                addRules(ss, rules);
            }
        }
    }
    function findFonts(rule) {
        var src = getPropertyValue(rule.style, "src");
        if (src) {
            return splitProperty(src).reduce(function(a, el){
                var font = getFontURL(el);
                if (font) {
                    a.push(font);
                }
                return a;
            }, []);
        } else {
            // Internet Explorer
            // XXX: this is gross.  should work though for valid CSS.
            var font = getFontURL(rule.cssText);
            return font ? [ font ] : [];
        }
    }
    function addRules(styleSheet, rules) {
        for (var i = 0; i < rules.length; ++i) {
            var r = rules[i];
            switch (r.type) {
              case 3:       // CSSImportRule
                doStylesheet(r.styleSheet);
                break;
              case 5:       // CSSFontFaceRule
                var style  = r.style;
                var family = splitProperty(getPropertyValue(style, "font-family"));
                var bold   = /^([56789]00|bold)$/i.test(getPropertyValue(style, "font-weight"));
                var italic = "italic" == getPropertyValue(style, "font-style");
                var src    = findFonts(r);
                if (src.length > 0) {
                    addRule(styleSheet, family, bold, italic, src[0]);
                }
            }
        }
    }
    function addRule(styleSheet, names, bold, italic, url) {
        // We get full resolved absolute URLs in Chrome, but sadly
        // not in Firefox.
        if (!(/^data:/i.test(url))) {
            if (!(/^[^\/:]+:\/\//.test(url) || /^\//.test(url))) {
                url = String(styleSheet.href).replace(/[^\/]*$/, "") + url;
            }
        }
        names.forEach(function(name){
            name = name.replace(/^(['"]?)(.*?)\1$/, "$2"); // it's quoted
            if (bold) {
                name += "|bold";
            }
            if (italic) {
                name += "|italic";
            }
            result[name] = url;
        });
    }
}

function hasOwnProperty(obj, key) {
    return Object.prototype.hasOwnProperty.call(obj, key);
}

function getCounter(name) {
    name = "_counter_" + name;
    return nodeInfo[name];
}

function getAllCounters(name) {
    var values = [], p = nodeInfo;
    name = "_counter_" + name;
    while (p) {
        if (hasOwnProperty(p, name)) {
            values.push(p[name]);
        }
        p = Object.getPrototypeOf(p);
    }
    return values.reverse();
}

function incCounter(name, inc) {
    var p = nodeInfo;
    name = "_counter_" + name;
    while (p && !hasOwnProperty(p, name)) {
        p = Object.getPrototypeOf(p);
    }
    if (!p) {
        p = nodeInfo._root;
    }
    p[name] = (p[name] || 0) + (inc == null ? 1 : inc);
}

function resetCounter(name, val) {
    name = "_counter_" + name;
    nodeInfo[name] = val == null ? 0 : val;
}

function doCounters(a, f, def) {
    for (var i = 0; i < a.length;) {
        var name = a[i++];
        var val = parseFloat(a[i]);
        if (isNaN(val)) {
            f(name, def);
        } else {
            f(name, val);
            ++i;
        }
    }
}

function updateCounters(style) {
    var counterReset = getPropertyValue(style, "counter-reset");
    if (counterReset) {
        doCounters(splitProperty(counterReset, /^\s+/), resetCounter, 0);
    }
    var counterIncrement = getPropertyValue(style, "counter-increment");
    if (counterIncrement) {
        doCounters(splitProperty(counterIncrement, /^\s+/), incCounter, 1);
    }
}

function parseColor(str, css) {
    var color = Object(__WEBPACK_IMPORTED_MODULE_3__common__["f" /* parseColor */])(str, true);
    if (color) {
        color = color.toRGB();
        if (css) {
            color = color.toCssRgba();
        } else if (color.a === 0) {
            color = null;
        }
    }
    return color;
}

function whenImagesAreActuallyLoaded(elements, callback) {
    var pending = 0;
    elements.forEach(function(el){
        var images = el.querySelectorAll("img");
        for (var i = 0; i < images.length; ++i) {
            var img = images[i];
            if (!img.complete) {
                pending++;
                img.onload = img.onerror = next;
            }
        }
    });
    if (!pending) {
        next();
    }
    function next() {
        if (--pending <= 0) {
            callback();
        }
    }
}

function cacheImages(element, callback) {
    var urls = [];
    function add(url) {
        if (!IMAGE_CACHE[url]) {
            IMAGE_CACHE[url] = true;
            urls.push(url);
        }
    }
    function dive(element){
        if (/^img$/i.test(element.tagName)) {
            add(element.src);
        }
        parseBackgroundImage(
            getPropertyValue(
                getComputedStyle(element), "background-image"
            )
        ).forEach(function(bg){
            if (bg.type == "url") {
                add(bg.url);
            }
        });

        if (element.children) {
            slice(element.children).forEach(dive);
        }
    }

    if (Array.isArray(element)) {
        element.forEach(dive);
    } else {
        dive(element);
    }

    var count = urls.length;
    function next() {
        if (--count <= 0) {
            callback();
        }
    }
    if (count === 0) {
        next();
    }
    urls.forEach(function(url){
        var img = IMAGE_CACHE[url] = new window.Image();
        if (!(/^data:/i.test(url))) {
            img.crossOrigin = "Anonymous";
        }
        img.src = url;
        if (img.complete) {
            next();
        } else {
            img.onload = next;
            img.onerror = function() {
                IMAGE_CACHE[url] = null;
                next();
            };
        }
    });
}

function alphaNumeral(n) {
    var result = "";
    do {
        var r = n % 26;
        result = String.fromCharCode(97 + r) + result;
        n = Math.floor(n / 26);
    } while (n > 0);
    return result;
}

function pushNodeInfo(element, style, group) {
    nodeInfo = Object.create(nodeInfo);
    nodeInfo[element.tagName.toLowerCase()] = {
        element: element,
        style: style
    };
    var decoration = getPropertyValue(style, "text-decoration");
    if (decoration && decoration != "none") {
        var color = getPropertyValue(style, "color");
        decoration.split(/\s+/g).forEach(function(name){
            if (!nodeInfo[name]) {
                nodeInfo[name] = color;
            }
        });
    }

    if (createsStackingContext(style)) {
        nodeInfo._stackingContext = {
            element: element,
            group: group
        };
    }
}

function popNodeInfo() {
    nodeInfo = Object.getPrototypeOf(nodeInfo);
}

function updateClipbox(path) {
    if (nodeInfo._clipbox != null) {
        var box = path.bbox(nodeInfo._matrix);
        if (nodeInfo._clipbox) {
            nodeInfo._clipbox = __WEBPACK_IMPORTED_MODULE_0__geometry__["d" /* Rect */].intersect(nodeInfo._clipbox, box);
        } else {
            nodeInfo._clipbox = box;
        }
    }
}

function emptyClipbox() {
    var cb = nodeInfo._clipbox;
    if (cb == null) {
        return true;
    }
    if (cb) {
        return cb.width() === 0 || cb.height() === 0;
    }
}

function createsStackingContext(style) {
    function prop(name) { return getPropertyValue(style, name); }
    if (prop("transform") != "none" ||
        prop("position") != "static" ||
        prop("z-index") != "auto" ||
        prop("opacity") < 1) {
        return true;
    }
}

function getComputedStyle(element, pseudoElt) {
    return window.getComputedStyle(element, pseudoElt || null);
}

function getPropertyValue(style, prop, defa) {
    var val = style.getPropertyValue(prop);
    if (val == null || val === "") {
        if (browser.webkit) {
            val = style.getPropertyValue("-webkit-" + prop );
        } else if (browser.mozilla) {
            val = style.getPropertyValue("-moz-" + prop );
        } else if (browser.opera) {
            val = style.getPropertyValue("-o-" + prop);
        } else if (microsoft) {
            val = style.getPropertyValue("-ms-" + prop);
        }
    }
    if (arguments.length > 2 && (val == null || val === "")) {
        return defa;
    } else {
        return val;
    }
}

function pleaseSetPropertyValue(style, prop, value, important) {
    style.setProperty(prop, value, important);
    if (browser.webkit) {
        style.setProperty("-webkit-" + prop, value, important);
    } else if (browser.mozilla) {
        style.setProperty("-moz-" + prop, value, important);
    } else if (browser.opera) {
        style.setProperty("-o-" + prop, value, important);
    } else if (microsoft) {
        style.setProperty("-ms-" + prop, value, important);
        prop = "ms" + prop.replace(/(^|-)([a-z])/g, function(s, p1, p2){
            return p1 + p2.toUpperCase();
        });
        style[prop] = value;
    }
}

function getBorder(style, side) {
    side = "border-" + side;
    return {
        width: parseFloat(getPropertyValue(style, side + "-width")),
        style: getPropertyValue(style, side + "-style"),
        color: parseColor(getPropertyValue(style, side + "-color"), true)
    };
}

function saveStyle(element, func) {
    var prev = element.style.cssText;
    var result = func();
    element.style.cssText = prev;
    return result;
}

function getBorderRadius(style, side) {
    var r = getPropertyValue(style, "border-" + side + "-radius").split(/\s+/g).map(parseFloat);
    if (r.length == 1) {
        r.push(r[0]);
    }
    return sanitizeRadius({ x: r[0], y: r[1] });
}

function getContentBox(element) {
    var box = element.getBoundingClientRect();
    box = innerBox(box, "border-*-width", element);
    box = innerBox(box, "padding-*", element);
    return box;
}

function innerBox(box, prop, element) {
    var style, wt, wr, wb, wl;
    if (typeof prop == "string") {
        style = getComputedStyle(element);
        wt = parseFloat(getPropertyValue(style, prop.replace("*", "top")));
        wr = parseFloat(getPropertyValue(style, prop.replace("*", "right")));
        wb = parseFloat(getPropertyValue(style, prop.replace("*", "bottom")));
        wl = parseFloat(getPropertyValue(style, prop.replace("*", "left")));
    }
    else if (typeof prop == "number") {
        wt = wr = wb = wl = prop;
    }
    return {
        top    : box.top + wt,
        right  : box.right - wr,
        bottom : box.bottom - wb,
        left   : box.left + wl,
        width  : box.right - box.left - wr - wl,
        height : box.bottom - box.top - wb - wt
    };
}

function getTransform(style) {
    var transform = getPropertyValue(style, "transform");
    if (transform == "none") {
        return null;
    }
    var matrix = /^\s*matrix\(\s*(.*?)\s*\)\s*$/.exec(transform);
    if (matrix) {
        var origin = getPropertyValue(style, "transform-origin");
        matrix = matrix[1].split(/\s*,\s*/g).map(parseFloat);
        origin = origin.split(/\s+/g).map(parseFloat);
        return {
            matrix: matrix,
            origin: origin
        };
    }
}

function radiansToDegrees(radians) {
    return ((180 * radians) / Math.PI) % 360;
}

function parseAngle(angle) {
    var num = parseFloat(angle);
    if (/grad$/.test(angle)) {
        return Math.PI * num / 200;
    }
    else if (/rad$/.test(angle)) {
        return num;
    }
    else if (/turn$/.test(angle)) {
        return Math.PI * num * 2;
    }
    else if (/deg$/.test(angle)) {
        return Math.PI * num / 180;
    }
}

function setTransform(shape, m) {
    m = new __WEBPACK_IMPORTED_MODULE_0__geometry__["c" /* Matrix */](m[0], m[1], m[2], m[3], m[4], m[5]);
    shape.transform(m);
    return m;
}

function setClipping(shape, clipPath) {
    shape.clip(clipPath);
}

function addArcToPath(path, x, y, options) {
    var points = new __WEBPACK_IMPORTED_MODULE_0__geometry__["a" /* Arc */]([ x, y ], options).curvePoints(), i = 1;
    while (i < points.length) {
        path.curveTo(points[i++], points[i++], points[i++]);
    }
}

function sanitizeRadius(r) {
    if (r.x <= 0 || r.y <= 0) {
        r.x = r.y = 0;
    }
    return r;
}

function adjustBorderRadiusForBox(box, rTL, rTR, rBR, rBL) {
    // adjust border radiuses such that the sum of adjacent
    // radiuses is not bigger than the length of the side.
    // seems the correct algorithm is variant (3) from here:
    // http://www.w3.org/Style/CSS/Tracker/issues/29?changelog
    var tl_x = Math.max(0, rTL.x), tl_y = Math.max(0, rTL.y);
    var tr_x = Math.max(0, rTR.x), tr_y = Math.max(0, rTR.y);
    var br_x = Math.max(0, rBR.x), br_y = Math.max(0, rBR.y);
    var bl_x = Math.max(0, rBL.x), bl_y = Math.max(0, rBL.y);

    var f = Math.min(
        box.width / (tl_x + tr_x),
        box.height / (tr_y + br_y),
        box.width / (br_x + bl_x),
        box.height / (bl_y + tl_y)
    );

    if (f < 1) {
        tl_x *= f; tl_y *= f;
        tr_x *= f; tr_y *= f;
        br_x *= f; br_y *= f;
        bl_x *= f; bl_y *= f;
    }

    return {
        tl: { x: tl_x, y: tl_y },
        tr: { x: tr_x, y: tr_y },
        br: { x: br_x, y: br_y },
        bl: { x: bl_x, y: bl_y }
    };
}

function elementRoundBox(element, box, type) {
    var style = getComputedStyle(element);

    var rTL = getBorderRadius(style, "top-left");
    var rTR = getBorderRadius(style, "top-right");
    var rBL = getBorderRadius(style, "bottom-left");
    var rBR = getBorderRadius(style, "bottom-right");

    if (type == "padding" || type == "content") {
        var bt = getBorder(style, "top");
        var br = getBorder(style, "right");
        var bb = getBorder(style, "bottom");
        var bl = getBorder(style, "left");
        rTL.x -= bl.width; rTL.y -= bt.width;
        rTR.x -= br.width; rTR.y -= bt.width;
        rBR.x -= br.width; rBR.y -= bb.width;
        rBL.x -= bl.width; rBL.y -= bb.width;
        if (type == "content") {
            var pt = parseFloat(getPropertyValue(style, "padding-top"));
            var pr = parseFloat(getPropertyValue(style, "padding-right"));
            var pb = parseFloat(getPropertyValue(style, "padding-bottom"));
            var pl = parseFloat(getPropertyValue(style, "padding-left"));
            rTL.x -= pl; rTL.y -= pt;
            rTR.x -= pr; rTR.y -= pt;
            rBR.x -= pr; rBR.y -= pb;
            rBL.x -= pl; rBL.y -= pb;
        }
    }

    if (typeof type == "number") {
        rTL.x -= type; rTL.y -= type;
        rTR.x -= type; rTR.y -= type;
        rBR.x -= type; rBR.y -= type;
        rBL.x -= type; rBL.y -= type;
    }

    return roundBox(box, rTL, rTR, rBR, rBL);
}

// Create a drawing.Path for a rounded rectangle.  Receives the
// bounding box and the border-radiuses in CSS order (top-left,
// top-right, bottom-right, bottom-left).  The radiuses must be
// objects containing x (horiz. radius) and y (vertical radius).
function roundBox(box, rTL0, rTR0, rBR0, rBL0) {
    var tmp = adjustBorderRadiusForBox(box, rTL0, rTR0, rBR0, rBL0);
    var rTL = tmp.tl;
    var rTR = tmp.tr;
    var rBR = tmp.br;
    var rBL = tmp.bl;
    var path = new __WEBPACK_IMPORTED_MODULE_4__drawing__["g" /* Path */]({ fill: null, stroke: null });
    path.moveTo(box.left, box.top + rTL.y);
    if (rTL.x) {
        addArcToPath(path, box.left + rTL.x, box.top + rTL.y, {
            startAngle: -180,
            endAngle: -90,
            radiusX: rTL.x,
            radiusY: rTL.y
        });
    }
    path.lineTo(box.right - rTR.x, box.top);
    if (rTR.x) {
        addArcToPath(path, box.right - rTR.x, box.top + rTR.y, {
            startAngle: -90,
            endAngle: 0,
            radiusX: rTR.x,
            radiusY: rTR.y
        });
    }
    path.lineTo(box.right, box.bottom - rBR.y);
    if (rBR.x) {
        addArcToPath(path, box.right - rBR.x, box.bottom - rBR.y, {
            startAngle: 0,
            endAngle: 90,
            radiusX: rBR.x,
            radiusY: rBR.y
        });
    }
    path.lineTo(box.left + rBL.x, box.bottom);
    if (rBL.x) {
        addArcToPath(path, box.left + rBL.x, box.bottom - rBL.y, {
            startAngle: 90,
            endAngle: 180,
            radiusX: rBL.x,
            radiusY: rBL.y
        });
    }
    return path.close();
}

function formatCounter(val, style) {
    var str = String(parseFloat(val));
    switch (style) {
      case "decimal-leading-zero":
        if (str.length < 2) {
            str = "0" + str;
        }
        return str;
      case "lower-roman":
        return Object(__WEBPACK_IMPORTED_MODULE_2__util__["d" /* arabicToRoman */])(val).toLowerCase();
      case "upper-roman":
        return Object(__WEBPACK_IMPORTED_MODULE_2__util__["d" /* arabicToRoman */])(val).toUpperCase();
      case "lower-latin":
      case "lower-alpha":
        return alphaNumeral(val - 1);
      case "upper-latin":
      case "upper-alpha":
        return alphaNumeral(val - 1).toUpperCase();
      default:
        return str;
    }
}

function evalPseudoElementContent(element, content) {
    function displayCounter(name, style, separator) {
        if (!separator) {
            return formatCounter(getCounter(name) || 0, style);
        }
        separator = separator.replace(/^\s*(["'])(.*)\1\s*$/, "$2");
        return getAllCounters(name).map(function(val){
            return formatCounter(val, style);
        }).join(separator);
    }
    var a = splitProperty(content, /^\s+/);
    var result = [], m;
    a.forEach(function(el){
        var tmp;
        if ((m = /^\s*(["'])(.*)\1\s*$/.exec(el))) {
            result.push(m[2].replace(/\\([0-9a-f]{4})/gi, function(s, p){
                return String.fromCharCode(parseInt(p, 16));
            }));
        }
        else if ((m = /^\s*counter\((.*?)\)\s*$/.exec(el))) {
            tmp = splitProperty(m[1]);
            result.push(displayCounter(tmp[0], tmp[1]));
        }
        else if ((m = /^\s*counters\((.*?)\)\s*$/.exec(el))) {
            tmp = splitProperty(m[1]);
            result.push(displayCounter(tmp[0], tmp[2], tmp[1]));
        }
        else if ((m = /^\s*attr\((.*?)\)\s*$/.exec(el))) {
            result.push(element.getAttribute(m[1]) || "");
        }
        else {
            result.push(el);
        }
    });
    return result.join("");
}

function getCssText(style) {
    if (style.cssText) {
        return style.cssText;
    }
    // Status: NEW.  Report year: 2002.  Current year: 2014.
    // Nice played, Mozillians.
    // https://bugzilla.mozilla.org/show_bug.cgi?id=137687
    var result = [];
    for (var i = 0; i < style.length; ++i) {
        result.push(style[i] + ": " + getPropertyValue(style, style[i]));
    }
    return result.join(";\n");
}

function _renderWithPseudoElements(element, group) {
    if (element.tagName == KENDO_PSEUDO_ELEMENT) {
        _renderElement(element, group);
        return;
    }
    var fake = [];
    function pseudo(kind, place) {
        var style = getComputedStyle(element, kind), content = style.content;
        updateCounters(style);
        if (content && content != "normal" && content != "none" && style.width != "0px") {
            var psel = element.ownerDocument.createElement(KENDO_PSEUDO_ELEMENT);
            psel.style.cssText = getCssText(style);
            psel.textContent = evalPseudoElementContent(element, content);
            element.insertBefore(psel, place);
            fake.push(psel);
        }
    }
    pseudo(":before", element.firstChild);
    pseudo(":after", null);
    if (fake.length > 0) {
        var saveClass = element.className;
        element.className += " kendo-pdf-hide-pseudo-elements";
        _renderElement(element, group);
        element.className = saveClass;
        fake.forEach(function(el){ element.removeChild(el); });
    } else {
        _renderElement(element, group);
    }
}

function _renderElement(element, group) {
    var style = getComputedStyle(element);

    var top = getBorder(style, "top");
    var right = getBorder(style, "right");
    var bottom = getBorder(style, "bottom");
    var left = getBorder(style, "left");

    var rTL0 = getBorderRadius(style, "top-left");
    var rTR0 = getBorderRadius(style, "top-right");
    var rBL0 = getBorderRadius(style, "bottom-left");
    var rBR0 = getBorderRadius(style, "bottom-right");

    var dir = getPropertyValue(style, "direction");

    var backgroundColor = getPropertyValue(style, "background-color");
    backgroundColor = parseColor(backgroundColor);

    var backgroundImage = parseBackgroundImage( getPropertyValue(style, "background-image") );
    var backgroundRepeat = splitProperty( getPropertyValue(style, "background-repeat") );
    var backgroundPosition = splitProperty( getPropertyValue(style, "background-position") );
    var backgroundOrigin = splitProperty( getPropertyValue(style, "background-origin") );
    var backgroundSize = splitProperty( getPropertyValue(style, "background-size") );

    if (browser.msie && browser.version < 10) {
        // IE9 hacks.  getPropertyValue won't return the correct
        // value.  Sucks that we have to do it here, I'd prefer to
        // move it in getPropertyValue, but we don't have the
        // element.
        backgroundPosition = splitProperty(element.currentStyle.backgroundPosition);
    }

    var innerbox = innerBox(element.getBoundingClientRect(), "border-*-width", element);

    // CSS "clip" property - if present, replace the group with a
    // new one which is clipped.  This must happen before drawing
    // the borders and background.
    (function(){
        var clip = getPropertyValue(style, "clip");
        var m = /^\s*rect\((.*)\)\s*$/.exec(clip);
        if (m) {
            var a = m[1].split(/[ ,]+/g);
            var top = a[0] == "auto" ? innerbox.top : parseFloat(a[0]) + innerbox.top;
            var right = a[1] == "auto" ? innerbox.right : parseFloat(a[1]) + innerbox.left;
            var bottom = a[2] == "auto" ? innerbox.bottom : parseFloat(a[2]) + innerbox.top;
            var left = a[3] == "auto" ? innerbox.left : parseFloat(a[3]) + innerbox.left;
            var tmp = new __WEBPACK_IMPORTED_MODULE_4__drawing__["c" /* Group */]();
            var clipPath = new __WEBPACK_IMPORTED_MODULE_4__drawing__["g" /* Path */]()
                .moveTo(left, top)
                .lineTo(right, top)
                .lineTo(right, bottom)
                .lineTo(left, bottom)
                .close();
            setClipping(tmp, clipPath);
            group.append(tmp);
            group = tmp;
            updateClipbox(clipPath);
        }
    })();

    var boxes, i, cells;
    var display = getPropertyValue(style, "display");

    if (display == "table-row") {
        // because of rowspan/colspan, we shouldn't draw background of table row elements on the
        // box given by its getBoundingClientRect, because if we do we risk overwritting a
        // previously rendered cell.  https://github.com/telerik/kendo/issues/4881
        boxes = [];
        for (i = 0, cells = element.children; i < cells.length; ++i) {
            boxes.push(cells[i].getBoundingClientRect());
        }
    } else {
        boxes = element.getClientRects();
        if (boxes.length == 1) {
            // Workaround the missing borders in Chrome!  getClientRects() boxes contains values
            // rounded to integer.  getBoundingClientRect() appears to work fine.  We still need
            // getClientRects() to support cases where there are more boxes (continued inline
            // elements that might have border/background).
            boxes = [ element.getBoundingClientRect() ];
        }
    }

    // This function workarounds another Chrome bug, where boxes returned for a table with
    // border-collapse: collapse will overlap the table border.  Our rendering is not perfect in
    // such case anyway, but with this is better than without it.
    boxes = adjustBoxes(boxes);

    for (i = 0; i < boxes.length; ++i) {
        drawOneBox(boxes[i], i === 0, i == boxes.length - 1);
    }

    // Render links as separate groups.  We can't use boxes returned by element's getClientRects
    // because if display type is "inline" (default for <a>), boxes will not include the height of
    // images inside.  https://github.com/telerik/kendo-ui-core/issues/3359
    if (element.tagName == "A" && element.href && !/^#?$/.test(element.getAttribute("href"))) {
        if (!nodeInfo._avoidLinks || !matches(element, nodeInfo._avoidLinks)) {
            var r = document.createRange();
            r.selectNodeContents(element);
            slice(r.getClientRects()).forEach(function(box){
                var g = new __WEBPACK_IMPORTED_MODULE_4__drawing__["c" /* Group */]();
                g._pdfLink = {
                    url    : element.href,
                    top    : box.top,
                    right  : box.right,
                    bottom : box.bottom,
                    left   : box.left
                };
                group.append(g);
            });
        }
    }

    if (boxes.length > 0 && display == "list-item" && !element.getAttribute("kendo-no-bullet")) {
        drawBullet(boxes[0]);
    }

    // overflow: hidden/auto - if present, replace the group with
    // a new one clipped by the inner box.
    (function(){
        function clipit() {
            var clipPath = elementRoundBox(element, innerbox, "padding");
            var tmp = new __WEBPACK_IMPORTED_MODULE_4__drawing__["c" /* Group */]();
            setClipping(tmp, clipPath);
            group.append(tmp);
            group = tmp;
            updateClipbox(clipPath);
        }
        if (isFormField(element)) {
            clipit();
        } else if (/^(hidden|auto|scroll)/.test(getPropertyValue(style, "overflow"))) {
            clipit();
        } else if (/^(hidden|auto|scroll)/.test(getPropertyValue(style, "overflow-x"))) {
            clipit();
        } else if (/^(hidden|auto|scroll)/.test(getPropertyValue(style, "overflow-y"))) {
            clipit();
        }
    })();

    if (!maybeRenderWidget(element, group)) {
        renderContents(element, group);
    }

    return group; // only utility functions after this line.

    function adjustBoxes(boxes) {
        if (/^td$/i.test(element.tagName)) {
            var table = nodeInfo.table;
            if (table && getPropertyValue(table.style, "border-collapse") == "collapse") {
                var tableBorderLeft = getBorder(table.style, "left").width;
                var tableBorderTop = getBorder(table.style, "top").width;
                // check if we need to adjust
                if (tableBorderLeft === 0 && tableBorderTop === 0) {
                    return boxes; // nope
                }
                var tableBox = table.element.getBoundingClientRect();
                var firstCell = table.element.rows[0].cells[0];
                var firstCellBox = firstCell.getBoundingClientRect();
                if (firstCellBox.top == tableBox.top || firstCellBox.left == tableBox.left) {
                    return slice(boxes).map(function(box){
                        return {
                            left   : box.left + tableBorderLeft,
                            top    : box.top + tableBorderTop,
                            right  : box.right + tableBorderLeft,
                            bottom : box.bottom + tableBorderTop,
                            height : box.height,
                            width  : box.width
                        };
                    });
                }
            }
        }
        return boxes;
    }

    // this function will be called to draw each border.  it
    // draws starting at origin and the resulted path must be
    // translated/rotated to be placed in the proper position.
    //
    // arguments are named as if it draws the top border:
    //
    //    - `len` the length of the edge
    //    - `Wtop` the width of the edge (i.e. border-top-width)
    //    - `Wleft` the width of the left edge (border-left-width)
    //    - `Wright` the width of the right edge
    //    - `rl` and `rl` -- the border radius on the left and right
    //      (objects containing x and y, for horiz/vertical radius)
    //    - `transform` -- transformation to apply
    //
    function drawEdge(color, len, Wtop, Wleft, Wright, rl, rr, transform) {
        if (Wtop <= 0) {
            return;
        }

        var path, edge = new __WEBPACK_IMPORTED_MODULE_4__drawing__["c" /* Group */]();
        setTransform(edge, transform);
        group.append(edge);

        sanitizeRadius(rl);
        sanitizeRadius(rr);

        // draw main border.  this is the area without the rounded corners
        path = new __WEBPACK_IMPORTED_MODULE_4__drawing__["g" /* Path */]({
            fill: { color: color },
            stroke: null
        });
        edge.append(path);
        path.moveTo(rl.x ? Math.max(rl.x, Wleft) : 0, 0)
            .lineTo(len - (rr.x ? Math.max(rr.x, Wright) : 0), 0)
            .lineTo(len - Math.max(rr.x, Wright), Wtop)
            .lineTo(Math.max(rl.x, Wleft), Wtop)
            .close();

        if (rl.x) {
            drawRoundCorner(Wleft, rl, [ -1, 0, 0, 1, rl.x, 0 ]);
        }

        if (rr.x) {
            drawRoundCorner(Wright, rr, [ 1, 0, 0, 1, len - rr.x, 0 ]);
        }

        // draws one round corner, starting at origin (needs to be
        // translated/rotated to be placed properly).
        function drawRoundCorner(Wright, r, transform) {
            var angle = Math.PI/2 * Wright / (Wright + Wtop);

            // not sanitizing this one, because negative values
            // are useful to fill the box correctly.
            var ri = {
                x: r.x - Wright,
                y: r.y - Wtop
            };

            var path = new __WEBPACK_IMPORTED_MODULE_4__drawing__["g" /* Path */]({
                fill: { color: color },
                stroke: null
            }).moveTo(0, 0);

            setTransform(path, transform);

            addArcToPath(path, 0, r.y, {
                startAngle: -90,
                endAngle: -radiansToDegrees(angle),
                radiusX: r.x,
                radiusY: r.y
            });

            if (ri.x > 0 && ri.y > 0) {
                path.lineTo(ri.x * Math.cos(angle), r.y - ri.y * Math.sin(angle));
                addArcToPath(path, 0, r.y, {
                    startAngle: -radiansToDegrees(angle),
                    endAngle: -90,
                    radiusX: ri.x,
                    radiusY: ri.y,
                    anticlockwise: true
                });
            }
            else if (ri.x > 0) {
                path.lineTo(ri.x, Wtop)
                    .lineTo(0, Wtop);
            }
            else {
                path.lineTo(ri.x, Wtop)
                    .lineTo(ri.x, 0);
            }

            edge.append(path.close());
        }
    }

    function drawBackground(box) {
        var background = new __WEBPACK_IMPORTED_MODULE_4__drawing__["c" /* Group */]();
        setClipping(background, roundBox(box, rTL0, rTR0, rBR0, rBL0));
        group.append(background);

        if (backgroundColor) {
            var path = new __WEBPACK_IMPORTED_MODULE_4__drawing__["g" /* Path */]({
                fill: { color: backgroundColor.toCssRgba() },
                stroke: null
            });
            path.moveTo(box.left, box.top)
                .lineTo(box.right, box.top)
                .lineTo(box.right, box.bottom)
                .lineTo(box.left, box.bottom)
                .close();
            background.append(path);
        }

        for (var i = backgroundImage.length; --i >= 0;) {
            drawOneBackground(
                background, box,
                backgroundImage[i],
                backgroundRepeat[i % backgroundRepeat.length],
                backgroundPosition[i % backgroundPosition.length],
                backgroundOrigin[i % backgroundOrigin.length],
                backgroundSize[i % backgroundSize.length]
            );
        }
    }

    function drawOneBackground(group, box, background, backgroundRepeat, backgroundPosition, backgroundOrigin, backgroundSize) {
        if (!background || (background == "none")) {
            return;
        }

        if (background.type == "url") {
            // SVG taints the canvas, can't draw it.
            if (/^url\(\"data:image\/svg/i.test(background.url)) {
                return;
            }
            var img = IMAGE_CACHE[background.url];
            if (img && img.width > 0 && img.height > 0) {
                drawBackgroundImage(group, box, img.width, img.height, function(group, rect){
                    group.append(new __WEBPACK_IMPORTED_MODULE_4__drawing__["d" /* Image */](background.url, rect));
                });
            }
        } else if (background.type == "linear") {
            drawBackgroundImage(group, box, box.width, box.height, gradientRenderer(background));
        } else {
            return;
        }

        function drawBackgroundImage(group, box, img_width, img_height, renderBG) {
            var aspect_ratio = img_width / img_height, f;

            // for background-origin: border-box the box is already appropriate
            var orgBox = box;
            if (backgroundOrigin == "content-box") {
                orgBox = innerBox(orgBox, "border-*-width", element);
                orgBox = innerBox(orgBox, "padding-*", element);
            } else if (backgroundOrigin == "padding-box") {
                orgBox = innerBox(orgBox, "border-*-width", element);
            }

            if (!/^\s*auto(\s+auto)?\s*$/.test(backgroundSize)) {
                if (backgroundSize == "contain") {
                    f = Math.min(orgBox.width / img_width,
                                 orgBox.height / img_height);
                    img_width *= f;
                    img_height *= f;
                }
                else if (backgroundSize == "cover") {
                    f = Math.max(orgBox.width / img_width,
                                 orgBox.height / img_height);
                    img_width *= f;
                    img_height *= f;
                }
                else {
                    var size = backgroundSize.split(/\s+/g);
                    // compute width
                    if (/%$/.test(size[0])) {
                        img_width = orgBox.width * parseFloat(size[0]) / 100;
                    } else {
                        img_width = parseFloat(size[0]);
                    }
                    // compute height
                    if (size.length == 1 || size[1] == "auto") {
                        img_height = img_width / aspect_ratio;
                    } else if (/%$/.test(size[1])) {
                        img_height = orgBox.height * parseFloat(size[1]) / 100;
                    } else {
                        img_height = parseFloat(size[1]);
                    }
                }
            }

            var pos = String(backgroundPosition);

            // IE sometimes reports single-word positions
            // https://github.com/telerik/kendo-ui-core/issues/2786
            //
            // it seems to switch to percentages when the horizontal
            // position is not "center", therefore we don't handle
            // multi-word cases here.  All other browsers return
            // percentages or pixels instead of keywords.  At least
            // for now...
            switch (pos) {
              case "bottom" : pos = "50% 100%"; break;
              case "top"    : pos = "50% 0"; break;
              case "left"   : pos = "0 50%"; break;
              case "right"  : pos = "100% 50%"; break;
              case "center" : pos = "50% 50%"; break;
            }

            pos = pos.split(/\s+/);
            if (pos.length == 1) {
                pos[1] = "50%";
            }

            if (/%$/.test(pos[0])) {
                pos[0] = parseFloat(pos[0]) / 100 * (orgBox.width - img_width);
            } else {
                pos[0] = parseFloat(pos[0]);
            }
            if (/%$/.test(pos[1])) {
                pos[1] = parseFloat(pos[1]) / 100 * (orgBox.height - img_height);
            } else {
                pos[1] = parseFloat(pos[1]);
            }

            var rect = new __WEBPACK_IMPORTED_MODULE_0__geometry__["d" /* Rect */]([ orgBox.left + pos[0], orgBox.top + pos[1] ], [ img_width, img_height ]);

            // XXX: background-repeat could be implemented more
            //      efficiently as a fill pattern (at least for PDF
            //      output, probably SVG too).

            function rewX() {
                while (rect.origin.x > box.left) {
                    rect.origin.x -= img_width;
                }
            }

            function rewY() {
                while (rect.origin.y > box.top) {
                    rect.origin.y -= img_height;
                }
            }

            function repeatX() {
                while (rect.origin.x < box.right) {
                    renderBG(group, rect.clone());
                    rect.origin.x += img_width;
                }
            }

            if (backgroundRepeat == "no-repeat") {
                renderBG(group, rect);
            }
            else if (backgroundRepeat == "repeat-x") {
                rewX();
                repeatX();
            }
            else if (backgroundRepeat == "repeat-y") {
                rewY();
                while (rect.origin.y < box.bottom) {
                    renderBG(group, rect.clone());
                    rect.origin.y += img_height;
                }
            }
            else if (backgroundRepeat == "repeat") {
                rewX();
                rewY();
                var origin = rect.origin.clone();
                while (rect.origin.y < box.bottom) {
                    rect.origin.x = origin.x;
                    repeatX();
                    rect.origin.y += img_height;
                }
            }
        }
    }

    function drawBullet() {
        var listStyleType = getPropertyValue(style, "list-style-type");
        if (listStyleType == "none") {
            return;
        }
        var listStylePosition = getPropertyValue(style, "list-style-position");

        function _drawBullet(f) {
            saveStyle(element, function(){
                element.style.position = "relative";
                var bullet = element.ownerDocument.createElement(KENDO_PSEUDO_ELEMENT);
                bullet.style.position = "absolute";
                bullet.style.boxSizing = "border-box";
                if (listStylePosition == "outside") {
                    bullet.style.width = "6em";
                    bullet.style.left = "-6.8em";
                    bullet.style.textAlign = "right";
                } else {
                    bullet.style.left = "0px";
                }
                f(bullet);
                element.insertBefore(bullet, element.firstChild);
                renderElement(bullet, group);
                element.removeChild(bullet);
            });
        }

        function elementIndex(f) {
            var a = element.parentNode.children;
            var k = element.getAttribute("kendo-split-index");
            if (k != null) {
                return f(k|0, a.length);
            }
            for (var i = 0; i < a.length; ++i) {
                if (a[i] === element) {
                    return f(i, a.length);
                }
            }
        }

        switch (listStyleType) {
          case "circle":
          case "disc":
          case "square":
            _drawBullet(function(bullet){
                // XXX: the science behind these values is called "trial and error".
                bullet.style.fontSize = "60%";
                bullet.style.lineHeight = "200%";
                bullet.style.paddingRight = "0.5em";
                bullet.style.fontFamily = "DejaVu Serif";
                bullet.innerHTML = {
                    "disc"   : "\u25cf",
                    "circle" : "\u25ef",
                    "square" : "\u25a0"
                }[listStyleType];
            });
            break;

          case "decimal":
          case "decimal-leading-zero":
            _drawBullet(function(bullet){
                elementIndex(function(idx){
                    ++idx;
                    if (listStyleType == "decimal-leading-zero" && idx < 10) {
                        idx = "0" + idx;
                    }
                    bullet.innerHTML = idx + ".";
                });
            });
            break;

          case "lower-roman":
          case "upper-roman":
            _drawBullet(function(bullet){
                elementIndex(function(idx){
                    idx = Object(__WEBPACK_IMPORTED_MODULE_2__util__["d" /* arabicToRoman */])(idx + 1);
                    if (listStyleType == "upper-roman") {
                        idx = idx.toUpperCase();
                    }
                    bullet.innerHTML = idx + ".";
                });
            });
            break;

          case "lower-latin":
          case "lower-alpha":
          case "upper-latin":
          case "upper-alpha":
            _drawBullet(function(bullet){
                elementIndex(function(idx){
                    idx = alphaNumeral(idx);
                    if (/^upper/i.test(listStyleType)) {
                        idx = idx.toUpperCase();
                    }
                    bullet.innerHTML = idx + ".";
                });
            });
            break;
        }
    }

    // draws a single border box
    function drawOneBox(box, isFirst, isLast) {
        if (box.width === 0 || box.height === 0) {
            return;
        }

        drawBackground(box);

        var shouldDrawLeft = (left.width > 0 && ((isFirst && dir == "ltr") || (isLast && dir == "rtl")));
        var shouldDrawRight = (right.width > 0 && ((isLast && dir == "ltr") || (isFirst && dir == "rtl")));

        // The most general case is that the 4 borders have different widths and border
        // radiuses.  The way that is handled is by drawing 3 Paths for each border: the
        // straight line, and two round corners which represent half of the entire rounded
        // corner.  To simplify code those shapes are drawed at origin (by the drawEdge
        // function), then translated/rotated into the right position.
        //
        // However, this leads to poor results due to rounding in the simpler cases where
        // borders are straight lines.  Therefore we handle a few such cases separately with
        // straight lines. C^wC^wC^w -- nope, scratch that.  poor rendering was because of a bug
        // in Chrome (getClientRects() returns rounded integer values rather than exact floats.
        // web dev is still a ghetto.)

        // first, just in case there is no border...
        if (top.width === 0 && left.width === 0 && right.width === 0 && bottom.width === 0) {
            return;
        }

        // START paint borders
        // if all borders have equal colors...
        if (top.color == right.color && top.color == bottom.color && top.color == left.color) {

            // if same widths too, we can draw the whole border by stroking a single path.
            if (top.width == right.width && top.width == bottom.width && top.width == left.width)
            {
                if (shouldDrawLeft && shouldDrawRight) {
                    // reduce box by half the border width, so we can draw it by stroking.
                    box = innerBox(box, top.width/2);

                    // adjust the border radiuses, again by top.width/2, and make the path element.
                    var path = elementRoundBox(element, box, top.width/2);
                    path.options.stroke = {
                        color: top.color,
                        width: top.width
                    };
                    group.append(path);
                    return;
                }
            }
        }

        // if border radiuses are zero and widths are at most one pixel, we can again use simple
        // paths.
        if (rTL0.x === 0 && rTR0.x === 0 && rBR0.x === 0 && rBL0.x === 0) {
            // alright, 1.9px will do as well.  the difference in color blending should not be
            // noticeable.
            if (top.width < 2 && left.width < 2 && right.width < 2 && bottom.width < 2) {
                // top border
                if (top.width > 0) {
                    group.append(
                        new __WEBPACK_IMPORTED_MODULE_4__drawing__["g" /* Path */]({
                            stroke: { width: top.width, color: top.color }
                        })
                            .moveTo(box.left, box.top + top.width/2)
                            .lineTo(box.right, box.top + top.width/2)
                    );
                }

                // bottom border
                if (bottom.width > 0) {
                    group.append(
                        new __WEBPACK_IMPORTED_MODULE_4__drawing__["g" /* Path */]({
                            stroke: { width: bottom.width, color: bottom.color }
                        })
                            .moveTo(box.left, box.bottom - bottom.width/2)
                            .lineTo(box.right, box.bottom - bottom.width/2)
                    );
                }

                // left border
                if (shouldDrawLeft) {
                    group.append(
                        new __WEBPACK_IMPORTED_MODULE_4__drawing__["g" /* Path */]({
                            stroke: { width: left.width, color: left.color }
                        })
                            .moveTo(box.left + left.width/2, box.top)
                            .lineTo(box.left + left.width/2, box.bottom)
                    );
                }

                // right border
                if (shouldDrawRight) {
                    group.append(
                        new __WEBPACK_IMPORTED_MODULE_4__drawing__["g" /* Path */]({
                            stroke: { width: right.width, color: right.color }
                        })
                            .moveTo(box.right - right.width/2, box.top)
                            .lineTo(box.right - right.width/2, box.bottom)
                    );
                }

                return;
            }
        }
        // END paint borders

        var tmp = adjustBorderRadiusForBox(box, rTL0, rTR0, rBR0, rBL0);
        var rTL = tmp.tl;
        var rTR = tmp.tr;
        var rBR = tmp.br;
        var rBL = tmp.bl;

        // top border
        drawEdge(top.color,
                 box.width, top.width, left.width, right.width,
                 rTL, rTR,
                 [ 1, 0, 0, 1, box.left, box.top ]);

        // bottom border
        drawEdge(bottom.color,
                 box.width, bottom.width, right.width, left.width,
                 rBR, rBL,
                 [ -1, 0, 0, -1, box.right, box.bottom ]);

        // for left/right borders we need to invert the border-radiuses
        function inv(p) {
            return { x: p.y, y: p.x };
        }

        // left border
        drawEdge(left.color,
                 box.height, left.width, bottom.width, top.width,
                 inv(rBL), inv(rTL),
                 [ 0, -1, 1, 0, box.left, box.bottom ]);

        // right border
        drawEdge(right.color,
                 box.height, right.width, top.width, bottom.width,
                 inv(rTR), inv(rBR),
                 [ 0, 1, -1, 0, box.right, box.top ]);
    }
}

function gradientRenderer(gradient) {
    return function(group, rect) {
        var width = rect.width(), height = rect.height();

        switch (gradient.type) {
          case "linear":

            // figure out the angle.
            var angle = gradient.angle != null ? gradient.angle : Math.PI;
            switch (gradient.to) {
              case "top":
                angle = 0;
                break;
              case "left":
                angle = -Math.PI / 2;
                break;
              case "bottom":
                angle = Math.PI;
                break;
              case "right":
                angle = Math.PI / 2;
                break;
              case "top left": case "left top":
                angle = -Math.atan2(height, width);
                break;
              case "top right": case "right top":
                angle = Math.atan2(height, width);
                break;
              case "bottom left": case "left bottom":
                angle = Math.PI + Math.atan2(height, width);
                break;
              case "bottom right": case "right bottom":
                angle = Math.PI - Math.atan2(height, width);
                break;
            }

            if (gradient.reverse) {
                angle -= Math.PI;
            }

            // limit the angle between 0..2PI
            angle %= 2 * Math.PI;
            if (angle < 0) {
                angle += 2 * Math.PI;
            }

            // compute gradient's start/end points.  here len is the length of the gradient line
            // and x,y is the end point relative to the center of the rectangle in conventional
            // (math) axis direction.

            // this is the original (unscaled) length of the gradient line.  needed to deal with
            // absolutely positioned color stops.  formula from the CSS spec:
            // http://dev.w3.org/csswg/css-images-3/#linear-gradient-syntax
            var pxlen = Math.abs(width * Math.sin(angle)) + Math.abs(height * Math.cos(angle));

            // The math below is pretty simple, but it took a while to figure out.  We compute x
            // and y, the *end* of the gradient line.  However, we want to transform them into
            // element-based coordinates (SVG's gradientUnits="objectBoundingBox").  That means,
            // x=0 is the left edge, x=1 is the right edge, y=0 is the top edge and y=1 is the
            // bottom edge.
            //
            // A naive approach would use the original angle for these calculations.  Say we'd
            // like to draw a gradient angled at 45deg in a 100x400 box.  When we use
            // objectBoundingBox, the renderer will draw it in a 1x1 *square* box, and then
            // scale that to the desired dimensions.  The 45deg angle will look more like 70deg
            // after scaling.  SVG (http://www.w3.org/TR/SVG/pservers.html#LinearGradients) says
            // the following:
            //
            //     When gradientUnits="objectBoundingBox" and 'gradientTransform' is the
            //     identity matrix, the normal of the linear gradient is perpendicular to the
            //     gradient vector in object bounding box space (i.e., the abstract coordinate
            //     system where (0,0) is at the top/left of the object bounding box and (1,1) is
            //     at the bottom/right of the object bounding box). When the object's bounding
            //     box is not square, the gradient normal which is initially perpendicular to
            //     the gradient vector within object bounding box space may render
            //     non-perpendicular relative to the gradient vector in user space. If the
            //     gradient vector is parallel to one of the axes of the bounding box, the
            //     gradient normal will remain perpendicular. This transformation is due to
            //     application of the non-uniform scaling transformation from bounding box space
            //     to user space.
            //
            // which is an extremely long and confusing way to tell what I just said above.
            //
            // For this reason we need to apply the reverse scaling to the original angle, so
            // that when it'll finally be rendered it'll actually be at the desired slope.  Now
            // I'll let you figure out the math yourself.

            var scaledAngle = Math.atan(width * Math.tan(angle) / height);
            var sin = Math.sin(scaledAngle), cos = Math.cos(scaledAngle);
            var len = Math.abs(sin) + Math.abs(cos);
            var x = len/2 * sin;
            var y = len/2 * cos;

            // Because of the arctangent, our scaledAngle ends up between -PI/2..PI/2, possibly
            // losing the intended direction of the gradient.  The following fixes it.
            if (angle > Math.PI/2 && angle <= 3*Math.PI/2) {
                x = -x;
                y = -y;
            }

            // compute the color stops.
            var implicit = [], right = 0;
            var stops = gradient.stops.map(function(s, i){
                var offset = s.percent;
                if (offset) {
                    offset = parseFloat(offset) / 100;
                } else if (s.length) {
                    offset = parseFloat(s.length) / pxlen;
                } else if (i === 0) {
                    offset = 0;
                } else if (i == gradient.stops.length - 1) {
                    offset = 1;
                }
                var stop = {
                    color: s.color.toCssRgba(),
                    offset: offset
                };
                if (offset != null) {
                    right = offset;
                    // fix implicit offsets
                    implicit.forEach(function(s, i){
                        var stop = s.stop;
                        stop.offset = s.left + (right - s.left) * (i + 1) / (implicit.length + 1);
                    });
                    implicit = [];
                } else {
                    implicit.push({ left: right, stop: stop });
                }
                return stop;
            });

            var start = [ 0.5 - x, 0.5 + y ];
            var end = [ 0.5 + x, 0.5 - y ];

            // finally, draw it.
            group.append(
                __WEBPACK_IMPORTED_MODULE_4__drawing__["g" /* Path */].fromRect(rect)
                    .stroke(null)
                    .fill(new __WEBPACK_IMPORTED_MODULE_4__drawing__["e" /* LinearGradient */]({
                        start     : start,
                        end       : end,
                        stops     : stops,
                        userSpace : false
                    }))
            );
            break;
          case "radial":
            // XXX:
            if (window.console && window.console.log) {
                window.console.log("Radial gradients are not yet supported in HTML renderer");
            }
            break;
        }
    };
}

function maybeRenderWidget(element, group) {
    var visual;

    if (element._kendoExportVisual) {
        visual = element._kendoExportVisual();
    } else if (window.kendo && window.kendo.jQuery && element.getAttribute(window.kendo.attr("role"))) {
        var widget = window.kendo.widgetInstance(window.kendo.jQuery(element));
        if (widget && (widget.exportDOMVisual || widget.exportVisual)) {
            if (widget.exportDOMVisual) {
                visual = widget.exportDOMVisual();
            } else {
                visual = widget.exportVisual();
            }
        }
    }

    if (!visual) {
        return false;
    }

    var wrap = new __WEBPACK_IMPORTED_MODULE_4__drawing__["c" /* Group */]();
    wrap.children.push(visual);

    var bbox = element.getBoundingClientRect();
    wrap.transform(__WEBPACK_IMPORTED_MODULE_0__geometry__["e" /* transform */]().translate(bbox.left, bbox.top));

    group.append(wrap);

    return true;
}

function renderImage(element, url, group) {
    var box = getContentBox(element);
    var rect = new __WEBPACK_IMPORTED_MODULE_0__geometry__["d" /* Rect */]([ box.left, box.top ], [ box.width, box.height ]);
    var image = new __WEBPACK_IMPORTED_MODULE_4__drawing__["d" /* Image */](url, rect);
    setClipping(image, elementRoundBox(element, box, "content"));
    group.append(image);
}

function zIndexSort(a, b) {
    var sa = getComputedStyle(a);
    var sb = getComputedStyle(b);
    var za = parseFloat(getPropertyValue(sa, "z-index"));
    var zb = parseFloat(getPropertyValue(sb, "z-index"));
    var pa = getPropertyValue(sa, "position");
    var pb = getPropertyValue(sb, "position");
    if (isNaN(za) && isNaN(zb)) {
        if ((/static|absolute/.test(pa)) && (/static|absolute/.test(pb))) {
            return 0;
        }
        if (pa == "static") {
            return -1;
        }
        if (pb == "static") {
            return 1;
        }
        return 0;
    }
    if (isNaN(za)) {
        return zb === 0 ? 0 : zb > 0 ? -1 : 1;
    }
    if (isNaN(zb)) {
        return za === 0 ? 0 : za > 0 ? 1 : -1;
    }
    return parseFloat(za) - parseFloat(zb);
}

function isFormField(element) {
    return /^(?:textarea|select|input)$/i.test(element.tagName);
}

function getSelectedOption(element) {
    if (element.selectedOptions && element.selectedOptions.length > 0) {
        return element.selectedOptions[0];
    }
    return element.options[element.selectedIndex];
}

function renderCheckbox(element, group) {
    var style = getComputedStyle(element);
    var color = getPropertyValue(style, "color");
    var box = element.getBoundingClientRect();
    if (element.type == "checkbox") {
        group.append(
            __WEBPACK_IMPORTED_MODULE_4__drawing__["g" /* Path */].fromRect(
                new __WEBPACK_IMPORTED_MODULE_0__geometry__["d" /* Rect */]([ box.left+1, box.top+1 ],
                             [ box.width-2, box.height-2 ])
            ).stroke(color, 1)
        );
        if (element.checked) {
            // fill a rectangle inside?  looks kinda ugly.
            // group.append(
            //     Path.fromRect(
            //         new geo.Rect([ box.left+4, box.top+4 ],
            //                      [ box.width-8, box.height-8])
            //     ).fill(color).stroke(null)
            // );

            // let's draw a checkmark instead.  artistic, eh?
            group.append(
                new __WEBPACK_IMPORTED_MODULE_4__drawing__["g" /* Path */]()
                    .stroke(color, 1.2)
                    .moveTo(box.left + 0.22 * box.width,
                            box.top + 0.55 * box.height)
                    .lineTo(box.left + 0.45 * box.width,
                            box.top + 0.75 * box.height)
                    .lineTo(box.left + 0.78 * box.width,
                            box.top + 0.22 * box.width)
            );
        }
    } else {
        group.append(
            new __WEBPACK_IMPORTED_MODULE_4__drawing__["a" /* Circle */](
                new __WEBPACK_IMPORTED_MODULE_0__geometry__["b" /* Circle */]([
                    (box.left + box.right) / 2,
                    (box.top + box.bottom) / 2
                ], Math.min(box.width-2, box.height-2) / 2)
            ).stroke(color, 1)
        );
        if (element.checked) {
            group.append(
                new __WEBPACK_IMPORTED_MODULE_4__drawing__["a" /* Circle */](
                    new __WEBPACK_IMPORTED_MODULE_0__geometry__["b" /* Circle */]([
                        (box.left + box.right) / 2,
                        (box.top + box.bottom) / 2
                    ], Math.min(box.width-8, box.height-8) / 2)
                ).fill(color).stroke(null)
            );
        }
    }
}

function renderFormField(element, group) {
    var tag = element.tagName.toLowerCase();
    if (tag == "input" && (element.type == "checkbox" || element.type == "radio")) {
        return renderCheckbox(element, group);
    }
    var p = element.parentNode;
    var doc = element.ownerDocument;
    var el = doc.createElement(KENDO_PSEUDO_ELEMENT);
    var option;
    el.style.cssText = getCssText(getComputedStyle(element));
    if (tag == "input") {
        el.style.whiteSpace = "pre";
    }
    if (tag == "select" || tag == "textarea") {
        el.style.overflow = "auto";
    }
    if (tag == "select") {
        if (element.multiple) {
            for (var i = 0; i < element.options.length; ++i) {
                option = doc.createElement(KENDO_PSEUDO_ELEMENT);
                option.style.cssText = getCssText(getComputedStyle(element.options[i]));
                option.style.display = "block"; // IE9 messes up without this
                option.textContent = element.options[i].textContent;
                el.appendChild(option);
            }
        } else {
            option = getSelectedOption(element);
            if (option) {
                el.textContent = option.textContent;
            }
        }
    } else {
        el.textContent = element.value;
    }
    p.insertBefore(el, element);
    el.scrollLeft = element.scrollLeft;
    el.scrollTop = element.scrollTop;

    // must temporarily hide the original element, otherwise it
    // may affect layout of the fake element we want to render.
    element.style.display = "none";

    renderContents(el, group);
    element.style.display = "";
    p.removeChild(el);
}

function renderContents(element, group) {
    if (nodeInfo._stackingContext.element === element) {
        // the group that was set in pushNodeInfo might have
        // changed due to clipping/transforms, update it here.
        nodeInfo._stackingContext.group = group;
    }
    switch (element.tagName.toLowerCase()) {
      case "img":
        renderImage(element, element.src, group);
        break;

      case "canvas":
        try {
            renderImage(element, element.toDataURL("image/png"), group);
        } catch (ex) {
            // tainted; can't draw it, ignore.
        }
        break;

      case "textarea":
      case "input":
      case "select":
        renderFormField(element, group);
        break;

      default:
        var children = [], floats = [], positioned = [];
        for (var i = element.firstChild; i; i = i.nextSibling) {
            switch (i.nodeType) {
              case 3:         // Text
                if (/\S/.test(i.data)) {
                    renderText(element, i, group);
                }
                break;
              case 1:         // Element
                var style = getComputedStyle(i);
                var floating = getPropertyValue(style, "float");
                var position = getPropertyValue(style, "position");
                if (position != "static") {
                    positioned.push(i);
                }
                else if (floating != "none") {
                    floats.push(i);
                } else {
                    children.push(i);
                }
                break;
            }
        }

        Object(__WEBPACK_IMPORTED_MODULE_2__util__["t" /* mergeSort */])(children, zIndexSort).forEach(function(el){ renderElement(el, group); });
        Object(__WEBPACK_IMPORTED_MODULE_2__util__["t" /* mergeSort */])(floats, zIndexSort).forEach(function(el){ renderElement(el, group); });
        Object(__WEBPACK_IMPORTED_MODULE_2__util__["t" /* mergeSort */])(positioned, zIndexSort).forEach(function(el){ renderElement(el, group); });
    }
}

function renderText(element, node, group) {
    if (emptyClipbox()) {
        return;
    }
    var style = getComputedStyle(element);

    if (parseFloat(getPropertyValue(style, "text-indent")) < -500) {
        // assume it should not be displayed.  the slider's
        // draggable handle displays a Drag text for some reason,
        // having text-indent: -3333px.
        return;
    }

    var text = node.data;
    var start = 0;
    var end = text.search(/\S\s*$/) + 1;

    if (!end) {
        return; // whitespace-only node
    }

    var fontSize = getPropertyValue(style, "font-size");
    var lineHeight = getPropertyValue(style, "line-height");

    // simply getPropertyValue("font") doesn't work in Firefox :-\
    var font = [
        getPropertyValue(style, "font-style"),
        getPropertyValue(style, "font-variant"),
        getPropertyValue(style, "font-weight"),
        fontSize, // no need for line height here; it breaks layout in FF
        getPropertyValue(style, "font-family")
    ].join(" ");

    fontSize = parseFloat(fontSize);
    lineHeight = parseFloat(lineHeight);

    if (fontSize === 0) {
        return;
    }

    var color = getPropertyValue(style, "color");
    var range = element.ownerDocument.createRange();
    var align = getPropertyValue(style, "text-align");
    var isJustified = align == "justify";
    var columnCount = getPropertyValue(style, "column-count", 1);
    var whiteSpace = getPropertyValue(style, "white-space");
    var textTransform = getPropertyValue(style, "text-transform");

    // IE shrinks the text with text-overflow: ellipsis,
    // apparently because the returned bounding box for the range
    // is limited to the visible area minus space for the dots,
    // instead of being the full width of the text.
    //
    // https://github.com/telerik/kendo/issues/5232
    var textOverflow, saveTextOverflow;
    if (microsoft) {
        textOverflow = style.textOverflow;             // computed style
        if (textOverflow == "ellipsis") {
            saveTextOverflow = element.style.textOverflow; // own style.
            element.style.textOverflow = "clip";
        }
    }

    // A line of 500px, with a font of 12px, contains an average of 80 characters, but since we
    // err, we'd like to guess a bigger number rather than a smaller one.  Multiplying by 5
    // seems to be a good option.
    var estimateLineLength = element.getBoundingClientRect().width / fontSize * 5;
    if (estimateLineLength === 0) {
        estimateLineLength = 500;
    }

    // we'll maintain this so we can workaround bugs in Chrome's Range.getClientRects
    // https://github.com/telerik/kendo/issues/5740
    var prevLineBottom = null;

    var underline = nodeInfo["underline"];
    var lineThrough = nodeInfo["line-through"];
    var overline = nodeInfo["overline"];
    var hasDecoration = underline || lineThrough || overline;

    // doChunk returns true when all text has been rendered
    while (!doChunk()) {}

    if (microsoft && textOverflow == "ellipsis") {
        element.style.textOverflow = saveTextOverflow;
    }

    if (hasDecoration) {
        range.selectNode(node);
        slice(range.getClientRects()).forEach(decorate);
    }

    return;                 // only function declarations after this line

    function actuallyGetRangeBoundingRect(range) {
        // XXX: to be revised when this Chrome bug is fixed:
        // https://bugs.chromium.org/p/chromium/issues/detail?id=612459
        if (microsoft || browser.chrome) {
            // Workaround browser bugs: IE and Chrome would sometimes
            // return 0 or 1-width rectangles before or after the main
            // one.  https://github.com/telerik/kendo/issues/4674

            // Actually Chrome 50 got worse, since the rectangles can now have the width of a
            // full character, making it hard to tell whether it's a bogus rectangle or valid
            // selection location.  The workaround is to ignore rectangles that fall on the
            // previous line.  https://github.com/telerik/kendo/issues/5740
            var rectangles = range.getClientRects(), box = {
                top    :  Infinity,
                right  : -Infinity,
                bottom : -Infinity,
                left   :  Infinity
            }, done = false;
            for (var i = 0; i < rectangles.length; ++i) {
                var b = rectangles[i];
                if (b.width <= 1 || b.bottom === prevLineBottom) {
                    continue;   // bogus rectangle
                }
                box.left   = Math.min(b.left   , box.left);
                box.top    = Math.min(b.top    , box.top);
                box.right  = Math.max(b.right  , box.right);
                box.bottom = Math.max(b.bottom , box.bottom);
                done = true;
            }
            if (!done) {
                return range.getBoundingClientRect();
            }
            box.width = box.right - box.left;
            box.height = box.bottom - box.top;
            return box;
        }
        return range.getBoundingClientRect();
    }

    // Render a chunk of text, typically one line (but for justified text we render each word as
    // a separate Text object, because spacing is variable).  Returns true when it finished the
    // current node.  After each chunk it updates `start` to just after the last rendered
    // character.
    function doChunk() {
        var origStart = start;
        var box, pos = text.substr(start).search(/\S/);
        start += pos;
        if (pos < 0 || start >= end) {
            return true;
        }

        // Select a single character to determine the height of a line of text.  The box.bottom
        // will be essential for us to figure out where the next line begins.
        range.setStart(node, start);
        range.setEnd(node, start + 1);
        box = actuallyGetRangeBoundingRect(range);

        // for justified text we must split at each space, because space has variable width.
        var found = false;
        if (isJustified || columnCount > 1) {
            pos = text.substr(start).search(/\s/);
            if (pos >= 0) {
                // we can only split there if it's on the same line, otherwise we'll fall back
                // to the default mechanism (see findEOL below).
                range.setEnd(node, start + pos);
                var r = actuallyGetRangeBoundingRect(range);
                if (r.bottom == box.bottom) {
                    box = r;
                    found = true;
                    start += pos;
                }
            }
        }

        if (!found) {
            // This code does three things: (1) it selects one line of text in `range`, (2) it
            // leaves the bounding rect of that line in `box` and (3) it returns the position
            // just after the EOL.  We know where the line starts (`start`) but we don't know
            // where it ends.  To figure this out, we select a piece of text and look at the
            // bottom of the bounding box.  If it changes, we have more than one line selected
            // and should retry with a smaller selection.
            //
            // To speed things up, we first try to select all text in the node (`start` ->
            // `end`).  If there's more than one line there, then select only half of it.  And
            // so on.  When we find a value for `end` that fits in one line, we try increasing
            // it (also in halves) until we get to the next line.  The algorithm stops when the
            // right side of the bounding box does not change.
            //
            // One more thing to note is that everything happens in a single Text DOM node.
            // There's no other tags inside it, therefore the left/top coordinates of the
            // bounding box will not change.
            pos = (function findEOL(min, eol, max){
                range.setEnd(node, eol);
                var r = actuallyGetRangeBoundingRect(range);
                if (r.bottom != box.bottom && min < eol) {
                    return findEOL(min, (min + eol) >> 1, eol);
                } else if (r.right != box.right) {
                    box = r;
                    if (eol < max) {
                        return findEOL(eol, (eol + max) >> 1, max);
                    } else {
                        return eol;
                    }
                } else {
                    return eol;
                }
            })(start, Math.min(end, start + estimateLineLength), end);

            if (pos == start) {
                // if EOL is at the start, then no more text fits on this line.  Skip the
                // remainder of this node entirely to avoid a stack overflow.
                return true;
            }
            start = pos;

            pos = range.toString().search(/\s+$/);
            if (pos === 0) {
                return false; // whitespace only; we should not get here.
            }
            if (pos > 0) {
                // eliminate trailing whitespace
                range.setEnd(node, range.startOffset + pos);
                box = actuallyGetRangeBoundingRect(range);
            }
        }

        // another workaround for IE: if we rely on getBoundingClientRect() we'll overlap with the bullet for LI
        // elements.  Calling getClientRects() and using the *first* rect appears to give us the correct location.
        // Note: not to be used in Chrome as it randomly returns a zero-width rectangle from the previous line.
        if (microsoft) {
            box = range.getClientRects()[0];
        }

        var str = range.toString();
        if (!/^(?:pre|pre-wrap)$/i.test(whiteSpace)) {
            // node with non-significant space -- collapse whitespace.
            str = str.replace(/\s+/g, " ");
        }
        else if (/\t/.test(str)) {
            // with significant whitespace we need to do something about literal TAB characters.
            // There's no TAB glyph in a font so they would be rendered in PDF as an empty box,
            // and the whole text will stretch to fill the original width.  The core PDF lib
            // does not have sufficient context to deal with it.

            // calculate the starting column here, since we initially discarded any whitespace.
            var cc = 0;
            for (pos = origStart; pos < range.startOffset; ++pos) {
                var code = text.charCodeAt(pos);
                if (code == 9) {
                    // when we meet a TAB we must round up to the next tab stop.
                    // in all browsers TABs seem to be 8 characters.
                    cc += 8 - cc % 8;
                } else if (code == 10 || code == 13) {
                    // just in case we meet a newline we must restart.
                    cc = 0;
                } else {
                    // ordinary character --> advance one column
                    cc++;
                }
            }

            // based on starting column, replace any TAB characters in the string we actually
            // have to display with spaces so that they align to columns multiple of 8.
            while ((pos = str.search("\t")) >= 0) {
                var indent = "        ".substr(0, 8 - (cc + pos) % 8);
                str = str.substr(0, pos) + indent + str.substr(pos + 1);
            }
        }

        if (!found) {
            prevLineBottom = box.bottom;
        }
        drawText(str, box);
    }

    function drawText(str, box) {
        // In IE the box height will be approximately lineHeight, while in
        // other browsers it'll (correctly) be the height of the bounding
        // box for the current text/font.  Which is to say, IE sucks again.
        // The only good solution I can think of is to measure the text
        // ourselves and center the bounding box.
        if (microsoft && !isNaN(lineHeight)) {
            var height = getFontHeight(font);
            var top = (box.top + box.bottom - height) / 2;
            box = {
                top    : top,
                right  : box.right,
                bottom : top + height,
                left   : box.left,
                height : height,
                width  : box.right - box.left
            };
        }

        // var path = new Path({ stroke: { color: "red" }});
        // path.moveTo(box.left, box.top)
        //     .lineTo(box.right, box.top)
        //     .lineTo(box.right, box.bottom)
        //     .lineTo(box.left, box.bottom)
        //     .close();
        // group.append(path);

        switch (textTransform) {
          case "uppercase":
            str = str.toUpperCase();
            break;
          case "lowercase":
            str = str.toLowerCase();
            break;
          case "capitalize":
            str = str.replace(/(?:^|\s)\S/g, function (l) { return l.toUpperCase(); });
            break;
        }

        var text = new TextRect(
            str, new __WEBPACK_IMPORTED_MODULE_0__geometry__["d" /* Rect */]([ box.left, box.top ],
                              [ box.width, box.height ]),
            {
                font: font,
                fill: { color: color }
            }
        );
        group.append(text);
    }

    function decorate(box) {
        line(underline, box.bottom);
        line(lineThrough, box.bottom - box.height / 2.7);
        line(overline, box.top);
        function line(color, ypos) {
            if (color) {
                var width = fontSize / 12;
                var path = new __WEBPACK_IMPORTED_MODULE_4__drawing__["g" /* Path */]({ stroke: {
                    width: width,
                    color: color
                }});

                ypos -= width;
                path.moveTo(box.left, ypos)
                    .lineTo(box.right, ypos);
                group.append(path);
            }
        }
    }
}

function groupInStackingContext(element, group, zIndex) {
    var main;
    if (zIndex != "auto") {
        // use the current stacking context
        main = nodeInfo._stackingContext.group;
        zIndex = parseFloat(zIndex);
    } else {
        // normal flow — use given container.  we still have to
        // figure out where should we insert this element with the
        // assumption that its z-index is zero, as the group might
        // already contain elements with higher z-index.
        main = group;
        zIndex = 0;
    }
    var a = main.children;
    for (var i = 0; i < a.length; ++i) {
        if (a[i]._dom_zIndex != null && a[i]._dom_zIndex > zIndex) {
            break;
        }
    }

    var tmp = new __WEBPACK_IMPORTED_MODULE_4__drawing__["c" /* Group */]();
    main.insert(i, tmp);
    tmp._dom_zIndex = zIndex;

    if (main !== group) {
        // console.log("Placing", element, "in", nodeInfo._stackingContext.element, "at position", i, " / ", a.length);
        // console.log(a.slice(i+1));

        // if (nodeInfo._matrix) {
        //     tmp.transform(nodeInfo._matrix);
        // }
        if (nodeInfo._clipbox) {
            var m = nodeInfo._matrix.invert();
            var r = nodeInfo._clipbox.transformCopy(m);
            setClipping(tmp, __WEBPACK_IMPORTED_MODULE_4__drawing__["g" /* Path */].fromRect(r));
            // console.log(r);
            // tmp.append(Path.fromRect(r));
            // tmp.append(new Text(element.className || element.id, r.topLeft()));
        }
    }

    return tmp;
}

function renderElement(element, container) {
    var style = getComputedStyle(element);

    updateCounters(style);

    if (/^(style|script|link|meta|iframe|svg|col|colgroup)$/i.test(element.tagName)) {
        return;
    }

    if (nodeInfo._clipbox == null) {
        return;
    }

    var opacity = parseFloat(getPropertyValue(style, "opacity"));
    var visibility = getPropertyValue(style, "visibility");
    var display = getPropertyValue(style, "display");

    if (opacity === 0 || visibility == "hidden" || display == "none") {
        return;
    }

    var tr = getTransform(style);
    var group;

    var zIndex = getPropertyValue(style, "z-index");
    if ((tr || opacity < 1) && zIndex == "auto") {
        zIndex = 0;
    }
    group = groupInStackingContext(element, container, zIndex);

    // XXX: remove at some point
    // group._pdfElement = element;
    // group.options._pdfDebug = "";
    // if (element.id) {
    //     group.options._pdfDebug = "#" + element.id;
    // }
    // if (element.className) {
    //     group.options._pdfDebug += "." + element.className.split(" ").join(".");
    // }

    if (opacity < 1) {
        group.opacity(opacity * group.opacity());
    }

    pushNodeInfo(element, style, group);

    if (!tr) {
        _renderWithPseudoElements(element, group);
    }
    else {
        saveStyle(element, function(){
            // must clear transform, so getBoundingClientRect returns correct values.
            pleaseSetPropertyValue(element.style, "transform", "none", "important");

            // must also clear transitions, so correct values are returned *immediately*
            pleaseSetPropertyValue(element.style, "transition", "none", "important");

            // the presence of any transform makes it behave like it had position: relative,
            // because why not.
            // http://meyerweb.com/eric/thoughts/2011/09/12/un-fixing-fixed-elements-with-css-transforms/
            if (getPropertyValue(style, "position") == "static") {
                // but only if it's not already positioned. :-/
                pleaseSetPropertyValue(element.style, "position", "relative", "important");
            }

            // must translate to origin before applying the CSS
            // transformation, then translate back.
            var bbox = element.getBoundingClientRect();
            var x = bbox.left + tr.origin[0];
            var y = bbox.top + tr.origin[1];
            var m = [ 1, 0, 0, 1, -x, -y ];
            m = mmul(m, tr.matrix);
            m = mmul(m, [ 1, 0, 0, 1, x, y ]);
            m = setTransform(group, m);

            nodeInfo._matrix = nodeInfo._matrix.multiplyCopy(m);

            _renderWithPseudoElements(element, group);
        });
    }

    popNodeInfo();

    //drawDebugBox(element.getBoundingClientRect(), container);
}

// function drawDebugBox(box, group, color) {
//     var path = Path.fromRect(new geo.Rect([ box.left, box.top ], [ box.width, box.height ]));
//     if (color) {
//         path.stroke(color);
//     }
//     group.append(path);
// }

// function dumpTextNode(node) {
//     var txt = node.data.replace(/^\s+/, "");
//     if (txt.length < 100) {
//         console.log(node.data.length + ": |" + txt);
//     } else {
//         console.log(node.data.length + ": |" + txt.substr(0, 50) + "|...|" + txt.substr(-50));
//     }
// }

function mmul(a, b) {
    var a1 = a[0], b1 = a[1], c1 = a[2], d1 = a[3], e1 = a[4], f1 = a[5];
    var a2 = b[0], b2 = b[1], c2 = b[2], d2 = b[3], e2 = b[4], f2 = b[5];
    return [
        a1*a2 + b1*c2,          a1*b2 + b1*d2,
        c1*a2 + d1*c2,          c1*b2 + d1*d2,
        e1*a2 + f1*c2 + e2,     e1*b2 + f1*d2 + f2
    ];
}





/***/ }),
/* 2585 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = saveAs;
function saveAs(data, fileName, options) {
  if ( options === void 0 ) options = {};

  var save = postToProxy;

  if (options.forceProxy && !options.proxyURL) {
    throw new Error('No proxyURL is set, but forceProxy is true');
  }

  if (!options.forceProxy) {
    if (canDownload()) {
      save = saveAsDataURI;
    }

    if (navigator.msSaveBlob) {
      save = saveAsBlob;
    }
  }

  save(data, fileName, options);
}

var anchor = function () { return document.createElement('a'); };
var canDownload = function () { return 'download' in anchor(); };

function saveAsBlob(data, fileName) {
  var blob = data; // could be a Blob object

  if (typeof data === 'string') {
    var parts = data.split(';base64,');
    var contentType = parts[0];
    var base64 = atob(parts[1]);
    var array = new Uint8Array(base64.length);

    for (var idx = 0; idx < base64.length; idx++) {
      array[idx] = base64.charCodeAt(idx);
    }

    blob = new Blob([ array.buffer ], { type: contentType });
  }

  navigator.msSaveBlob(blob, fileName);
}

function saveAsDataURI(data, fileName) {
  var dataURI = data;
  if (window.Blob && data instanceof Blob) {
    dataURI = URL.createObjectURL(data);
  }

  var fileSaver = anchor();
  fileSaver.download = fileName;
  fileSaver.href = dataURI;

  var e = document.createEvent('MouseEvents');
  e.initMouseEvent('click', true, false, window,
  0, 0, 0, 0, 0, false, false, false, false, 0, null);

  fileSaver.dispatchEvent(e);
  setTimeout(function () { return URL.revokeObjectURL(dataURI); });
}

function postToProxy(dataURI, fileName, options) {
  if (!options.proxyURL) {
    return;
  }

  var form = document.createElement('form');
  form.setAttribute('action', options.proxyURL);
  form.setAttribute('method', 'POST');
  form.setAttribute('target', options.proxyTarget || '_self');

  var formData = options.proxyData || {};
  formData.fileName = fileName;

  var parts = dataURI.split(";base64,");
  formData.contentType = parts[0].replace("data:", "");
  formData.base64 = parts[1];

  for (var name in formData) {
    if (formData.hasOwnProperty(name)) {
      var input = document.createElement('input');
      input.setAttribute('type', 'hidden');
      input.setAttribute('name', name);
      input.setAttribute('value', formData[name]);

      form.appendChild(input);
    }
  }

  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
}



/***/ }),
/* 2586 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export encodeBase64 */
var KEY_STR = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
var fromCharCode = String.fromCharCode;

function encodeBase64(plainText) {
  var input = encodeUTF8(plainText);
  var output = "";
  var chr1, chr2, chr3, enc1, enc2, enc3, enc4;
  var i = 0;

  while (i < input.length) {
    chr1 = input.charCodeAt(i++);
    chr2 = input.charCodeAt(i++);
    chr3 = input.charCodeAt(i++);

    enc1 = chr1 >> 2;
    enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
    enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
    enc4 = chr3 & 63;

    if (isNaN(chr2)) {
      enc3 = enc4 = 64;
    } else if (isNaN(chr3)) {
      enc4 = 64;
    }

    output = output +
      KEY_STR.charAt(enc1) + KEY_STR.charAt(enc2) +
      KEY_STR.charAt(enc3) + KEY_STR.charAt(enc4);
  }

  return output;
}

function encodeUTF8(input) {
  var output = "";

  for (var i = 0; i < input.length; i++) {
    var c = input.charCodeAt(i);

    if (c < 0x80) {
      // One byte
      output += fromCharCode(c);
    } else if (c < 0x800) {
      // Two bytes
      output += fromCharCode(0xC0 | (c >>> 6));
      output += fromCharCode(0x80 | (c & 0x3f));
    } else if (c < 0x10000) {
      // Three bytes
      output += fromCharCode(0xE0 | (c >>> 12));
      output += fromCharCode(0x80 | (c >>> 6 & 0x3f));
      output += fromCharCode(0x80 | (c & 0x3f));
    }
  }

  return output;
}


/***/ }),
/* 2587 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export GridPDFExport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getPageMargin__ = __webpack_require__(413);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__savePDF__ = __webpack_require__(687);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__provideSaveGridPDF__ = __webpack_require__(2588);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





/**
 * A React component which facilitates the PDF export of the Grid.
 */
var GridPDFExport = /** @class */ (function (_super) {
    __extends(GridPDFExport, _super);
    function GridPDFExport(props) {
        var _this = _super.call(this, props) || this;
        _this.saveGridPDF = Object(__WEBPACK_IMPORTED_MODULE_4__provideSaveGridPDF__["a" /* provideSaveGridPDF */])(_this.getSavePDF());
        return _this;
    }
    /**
     * @hidden
     */
    GridPDFExport.prototype.render = function () {
        return null;
    };
    // tslint:disable:max-line-length
    /**
     * Saves the content of the Grid as a PDF file.
     *
     * @param data - The data can be different from the currently displayed data in the Grid. Can be used to export all Grid pages.
     * @param callback - The callback that will be executed after the PDF is saved.
     */
    // tslint:enable:max-line-length
    GridPDFExport.prototype.save = function (data, callback) {
        this.saveGridPDF(this.getGrid(), Object.assign({}, this.props, { margin: Object(__WEBPACK_IMPORTED_MODULE_2__getPageMargin__["a" /* getPageMargin */])(this.props) }), callback, data, this.getCustomColumns());
    };
    GridPDFExport.prototype.getSavePDF = function () {
        return __WEBPACK_IMPORTED_MODULE_3__savePDF__["a" /* savePDF */];
    };
    GridPDFExport.prototype.getGrid = function () {
        return __WEBPACK_IMPORTED_MODULE_0_react__["Children"]
            .toArray(this.props.children)
            .find(function (child) { return child &&
            child.type.displayName === 'KendoReactGrid'; });
    };
    GridPDFExport.prototype.getCustomColumns = function () {
        return __WEBPACK_IMPORTED_MODULE_0_react__["Children"]
            .toArray(this.props.children)
            .filter(function (child) { return child &&
            child.type.displayName === 'KendoReactGridColumn'; });
    };
    /**
     * @hidden
     */
    GridPDFExport.propTypes = {
        author: __WEBPACK_IMPORTED_MODULE_1_prop_types__["string"],
        avoidLinks: __WEBPACK_IMPORTED_MODULE_1_prop_types__["oneOfType"]([__WEBPACK_IMPORTED_MODULE_1_prop_types__["bool"], __WEBPACK_IMPORTED_MODULE_1_prop_types__["string"]]),
        forcePageBreak: __WEBPACK_IMPORTED_MODULE_1_prop_types__["string"],
        keepTogether: __WEBPACK_IMPORTED_MODULE_1_prop_types__["string"],
        creator: __WEBPACK_IMPORTED_MODULE_1_prop_types__["string"],
        date: __WEBPACK_IMPORTED_MODULE_1_prop_types__["instanceOf"](Date),
        imageResolution: __WEBPACK_IMPORTED_MODULE_1_prop_types__["number"],
        fileName: __WEBPACK_IMPORTED_MODULE_1_prop_types__["string"],
        forceProxy: __WEBPACK_IMPORTED_MODULE_1_prop_types__["bool"],
        keywords: __WEBPACK_IMPORTED_MODULE_1_prop_types__["string"],
        landscape: __WEBPACK_IMPORTED_MODULE_1_prop_types__["bool"],
        margin: __WEBPACK_IMPORTED_MODULE_1_prop_types__["oneOfType"]([__WEBPACK_IMPORTED_MODULE_1_prop_types__["string"], __WEBPACK_IMPORTED_MODULE_1_prop_types__["number"], __WEBPACK_IMPORTED_MODULE_1_prop_types__["shape"]({
                left: __WEBPACK_IMPORTED_MODULE_1_prop_types__["oneOfType"]([__WEBPACK_IMPORTED_MODULE_1_prop_types__["number"], __WEBPACK_IMPORTED_MODULE_1_prop_types__["string"]]),
                top: __WEBPACK_IMPORTED_MODULE_1_prop_types__["oneOfType"]([__WEBPACK_IMPORTED_MODULE_1_prop_types__["number"], __WEBPACK_IMPORTED_MODULE_1_prop_types__["string"]]),
                right: __WEBPACK_IMPORTED_MODULE_1_prop_types__["oneOfType"]([__WEBPACK_IMPORTED_MODULE_1_prop_types__["number"], __WEBPACK_IMPORTED_MODULE_1_prop_types__["string"]]),
                bottom: __WEBPACK_IMPORTED_MODULE_1_prop_types__["oneOfType"]([__WEBPACK_IMPORTED_MODULE_1_prop_types__["number"], __WEBPACK_IMPORTED_MODULE_1_prop_types__["string"]])
            })]),
        pageTemplate: __WEBPACK_IMPORTED_MODULE_1_prop_types__["any"],
        paperSize: __WEBPACK_IMPORTED_MODULE_1_prop_types__["any"],
        repeatHeaders: __WEBPACK_IMPORTED_MODULE_1_prop_types__["bool"],
        scale: __WEBPACK_IMPORTED_MODULE_1_prop_types__["number"],
        proxyData: __WEBPACK_IMPORTED_MODULE_1_prop_types__["any"],
        proxyURL: __WEBPACK_IMPORTED_MODULE_1_prop_types__["string"],
        proxyTarget: __WEBPACK_IMPORTED_MODULE_1_prop_types__["string"],
        producer: __WEBPACK_IMPORTED_MODULE_1_prop_types__["string"],
        subject: __WEBPACK_IMPORTED_MODULE_1_prop_types__["string"],
        title: __WEBPACK_IMPORTED_MODULE_1_prop_types__["string"]
    };
    return GridPDFExport;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));

//# sourceMappingURL=GridPDFExport.js.map

/***/ }),
/* 2588 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = provideSaveGridPDF;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_dom__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__export_element__ = __webpack_require__(2589);



/**
 * @hidden
 */
function provideSaveGridPDF(savePDF) {
    return function (grid, pdfExportOptions, callback, data, columns) {
        if (pdfExportOptions === void 0) { pdfExportOptions = {}; }
        return saveGridPDF(savePDF, grid, pdfExportOptions, callback, data, columns);
    };
}
function saveGridPDF(savePDF, grid, pdfExportOptions, callback, data, columns) {
    if (pdfExportOptions === void 0) { pdfExportOptions = {}; }
    renderGrid();
    var gridOuterWrapper;
    var gridInnerWrapper;
    var finalContainer;
    function renderGrid() {
        gridOuterWrapper = document.createElement('div');
        gridOuterWrapper.setAttribute('style', 'position:absolute; left: -5000px; top: 0px;');
        gridInnerWrapper = document.createElement('div');
        gridOuterWrapper.appendChild(gridInnerWrapper);
        document.body.appendChild(gridOuterWrapper);
        __WEBPACK_IMPORTED_MODULE_0_react_dom__["render"](prepareRawGridForExport(), gridInnerWrapper, onGridRendered);
    }
    function onGridRendered() {
        savePDF(prepareFinalElementForExport(), pdfExportOptions, cleanUpAndInvokeCallback);
    }
    function cleanUpAndInvokeCallback() {
        document.body.removeChild(gridOuterWrapper);
        document.body.removeChild(finalContainer);
        gridOuterWrapper = finalContainer = undefined;
        if (callback) {
            callback();
        }
    }
    function prepareFinalElementForExport() {
        /* Ultimatelly, there is no need for double DOM-copying of the grid.
        The one in this method is a copied Angular implementation
        that has been plugged almost seemlessly. */
        finalContainer = document.createElement('div');
        finalContainer.className = 'k-grid-pdf-export-element';
        var result = Object(__WEBPACK_IMPORTED_MODULE_2__export_element__["a" /* exportElement */])(gridInnerWrapper);
        finalContainer.appendChild(result);
        document.body.appendChild(finalContainer);
        return result;
    }
    function prepareRawGridForExport() {
        var customDataProps = data && { data: data, total: data.length, pageSize: data.length, skip: 0 };
        // A custom width is needed because otherwise when all pages are exported,
        // the "hidden" PDF grid will be visible.
        var customStyleProp = { style: Object.assign({}, grid.props.style, { width: '1000px' }) };
        var customProps = Object.assign({}, customDataProps, customStyleProp);
        if (columns && columns.length > 0) {
            var notColumnChildren = getGridNotColumnChildren(grid);
            return __WEBPACK_IMPORTED_MODULE_1_react__["cloneElement"](grid, customProps, columns.concat(notColumnChildren));
        }
        else {
            return __WEBPACK_IMPORTED_MODULE_1_react__["cloneElement"](grid, customProps);
        }
    }
}
function getGridNotColumnChildren(grid) {
    return __WEBPACK_IMPORTED_MODULE_1_react__["Children"]
        .toArray(grid.props.children)
        .filter(function (child) { return child &&
        child.type.displayName !== 'KendoReactGridColumn'; });
}
//# sourceMappingURL=provideSaveGridPDF.js.map

/***/ }),
/* 2589 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return exportElement; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__grid_query__ = __webpack_require__(2590);

var FIRST_CLASS = 'k-first';
var appendNodes = function (element, nodes) {
    var length = nodes.length;
    for (var idx = 0; idx < length; idx++) {
        element.appendChild(nodes[idx].cloneNode(true));
    }
};
var wrapTable = function (table) {
    var wrapper = document.createElement('div');
    wrapper.className = 'k-widget k-grid';
    wrapper.appendChild(table);
    return wrapper;
};
var createTableElement = function (sources) {
    var sourceCount = sources.length;
    var element = sources[0].cloneNode(true);
    var rowsCount = element.rows.length;
    if (sourceCount > 1) {
        for (var rowIdx = 0; rowIdx < rowsCount; rowIdx++) {
            for (var sourceIdx = 1; sourceIdx < sourceCount; sourceIdx++) {
                appendNodes(element.rows[rowIdx], sources[sourceIdx].rows[rowIdx].cells);
            }
        }
    }
    return element;
};
var setFirstCellClass = function (header, headers) {
    if (headers.length > 1 && header.rows.length > 1) {
        for (var idx = 1; idx < header.rows.length; idx++) {
            var firstCellIndex = headers[0].rows[idx].cells.length;
            var cell = header.rows[idx].cells[firstCellIndex];
            if (String(cell.className).indexOf(FIRST_CLASS) === -1) {
                cell.className += " " + FIRST_CLASS;
            }
        }
    }
};
var createTable = function (colGroups, headers, bodies, footers) {
    var table = document.createElement('table');
    var colGroup = colGroups[0].cloneNode(true);
    for (var idx = 1; idx < colGroups.length; idx++) {
        appendNodes(colGroup, colGroups[idx].querySelectorAll('col'));
    }
    var header = createTableElement(headers);
    var body = createTableElement(bodies);
    header.className = __WEBPACK_IMPORTED_MODULE_0__grid_query__["c" /* HEADER_CLASS */];
    setFirstCellClass(header, headers);
    table.appendChild(colGroup);
    table.appendChild(header);
    table.appendChild(body);
    if (footers.length) {
        var footer = createTableElement(footers);
        footer.className = __WEBPACK_IMPORTED_MODULE_0__grid_query__["a" /* FOOTER_CLASS */];
        table.appendChild(footer);
    }
    return wrapTable(table);
};
/**
 * @hidden
 */
var exportElement = function (wrapper) {
    var query = new __WEBPACK_IMPORTED_MODULE_0__grid_query__["b" /* GridQuery */](wrapper);
    var content = query.content();
    var result;
    if (content) {
        var colGroups = [content.querySelector('colgroup')];
        var headers = [query.header().querySelector('thead')];
        var bodies = [content.querySelector('tbody')];
        var footer = query.footer();
        var footers = footer ? [footer.querySelector('tfoot')] : [];
        result = createTable(colGroups, headers, bodies, footers);
    }
    else {
        result = wrapTable(query.table().cloneNode(true));
    }
    return result;
};
//# sourceMappingURL=export-element.js.map

/***/ }),
/* 2590 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return HEADER_CLASS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FOOTER_CLASS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return GridQuery; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dom_queries__ = __webpack_require__(2591);

/**
 * @hidden
 */
var HEADER_CLASS = 'k-grid-header';
/**
 * @hidden
 */
var FOOTER_CLASS = 'k-grid-footer';
var TABLE = 'TABLE';
var matchesTable = Object(__WEBPACK_IMPORTED_MODULE_0__dom_queries__["c" /* matchesNodeName */])(TABLE);
var suffix = function (locked) { return locked ? 'locked' : 'wrap'; };
/**
 * @hidden
 */
var GridQuery = /** @class */ (function () {
    function GridQuery(element) {
        this.element = element;
        this.list = Object(__WEBPACK_IMPORTED_MODULE_0__dom_queries__["a" /* findElement */])(element, Object(__WEBPACK_IMPORTED_MODULE_0__dom_queries__["b" /* matchesClasses */])("k-grid-container"));
    }
    GridQuery.prototype.content = function (locked) {
        return Object(__WEBPACK_IMPORTED_MODULE_0__dom_queries__["a" /* findElement */])(this.list, Object(__WEBPACK_IMPORTED_MODULE_0__dom_queries__["b" /* matchesClasses */])("k-grid-content" + (locked ? '-locked' : '')));
    };
    GridQuery.prototype.header = function (locked) {
        this.headerWrap = this.headerWrap || Object(__WEBPACK_IMPORTED_MODULE_0__dom_queries__["a" /* findElement */])(this.element, Object(__WEBPACK_IMPORTED_MODULE_0__dom_queries__["b" /* matchesClasses */])(HEADER_CLASS));
        return Object(__WEBPACK_IMPORTED_MODULE_0__dom_queries__["a" /* findElement */])(this.headerWrap, Object(__WEBPACK_IMPORTED_MODULE_0__dom_queries__["b" /* matchesClasses */])(HEADER_CLASS + "-" + suffix(locked)));
    };
    GridQuery.prototype.footer = function (locked) {
        this.footerWrap = this.footerWrap || Object(__WEBPACK_IMPORTED_MODULE_0__dom_queries__["a" /* findElement */])(this.element, Object(__WEBPACK_IMPORTED_MODULE_0__dom_queries__["b" /* matchesClasses */])(FOOTER_CLASS));
        return Object(__WEBPACK_IMPORTED_MODULE_0__dom_queries__["a" /* findElement */])(this.footerWrap, Object(__WEBPACK_IMPORTED_MODULE_0__dom_queries__["b" /* matchesClasses */])(FOOTER_CLASS + "-" + suffix(locked)));
    };
    GridQuery.prototype.table = function () {
        return Object(__WEBPACK_IMPORTED_MODULE_0__dom_queries__["a" /* findElement */])(this.element, matchesTable);
    };
    return GridQuery;
}());

//# sourceMappingURL=grid-query.js.map

/***/ }),
/* 2591 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export hasClasses */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return matchesClasses; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return matchesNodeName; });
/* unused harmony export closest */
/* unused harmony export closestInScope */
/* unused harmony export contains */
/* unused harmony export isVisible */
/* unused harmony export isFocusable */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return findElement; });
/* unused harmony export findFocusable */
/* unused harmony export findFocusableChild */
var focusableRegex = /^(?:a|input|select|option|textarea|button|object)$/i;
var NODE_NAME_PREDICATES = {};
var toClassList = function (classNames) { return String(classNames).trim().split(' '); };
/**
 * @hidden
 */
var hasClasses = function (element, classNames) {
    var namesList = toClassList(classNames);
    return Boolean(toClassList(element.className).find(function (className) { return namesList.indexOf(className) >= 0; }));
};
/**
 * @hidden
 */
var matchesClasses = function (classNames) {
    return function (element) { return hasClasses(element, classNames); };
};
/**
 * @hidden
 */
var matchesNodeName = function (nodeName) {
    if (!NODE_NAME_PREDICATES[nodeName]) {
        NODE_NAME_PREDICATES[nodeName] = function (element) {
            return String(element.nodeName).toLowerCase() === nodeName.toLowerCase();
        };
    }
    return NODE_NAME_PREDICATES[nodeName];
};
/**
 * @hidden
 */
var closest = function (node, predicate) {
    while (node && !predicate(node)) {
        node = node.parentNode;
    }
    return node;
};
/**
 * @hidden
 */
var closestInScope = function (node, predicate, scope) {
    while (node && node !== scope && !predicate(node)) {
        node = node.parentNode;
    }
    if (node !== scope) {
        return node;
    }
};
/**
 * @hidden
 */
var contains = function (parent, node, matchSelf) {
    if (matchSelf === void 0) { matchSelf = false; }
    var outside = !closest(node, function (child) { return child === parent; });
    if (outside) {
        return false;
    }
    var el = closest(node, function (child) { return child === node; });
    return el && (matchSelf || el !== parent);
};
/**
 * @hidden
 */
var isVisible = function (element) {
    var rect = element.getBoundingClientRect();
    var hasSize = rect.width > 0 && rect.height > 0;
    var hasPosition = rect.x !== 0 && rect.y !== 0;
    // Elements can have zero size due to styling, but they still count as visible.
    // For example, the selection checkbox has no size, but is made visible through styling.
    return (hasSize || hasPosition) && window.getComputedStyle(element).visibility !== 'hidden';
};
/**
 * @hidden
 */
var isFocusable = function (element, checkVisibility) {
    if (checkVisibility === void 0) { checkVisibility = true; }
    if (element.tagName) {
        var tagName = element.tagName.toLowerCase();
        var tabIndex = element.getAttribute('tabIndex');
        var skipTab = tabIndex === '-1';
        var focusable = tabIndex !== null && !skipTab;
        if (focusableRegex.test(tagName)) {
            focusable = !element.disabled && !skipTab;
        }
        return focusable && (!checkVisibility || isVisible(element));
    }
    return false;
};
/**
 * @hidden
 */
var findElement = function (node, predicate, matchSelf) {
    if (matchSelf === void 0) { matchSelf = true; }
    if (!node) {
        return;
    }
    if (matchSelf && predicate(node)) {
        return node;
    }
    node = node.firstChild;
    while (node) {
        if (node.nodeType === 1) {
            var element = findElement(node, predicate);
            if (element) {
                return element;
            }
        }
        node = node.nextSibling;
    }
};
/**
 * @hidden
 */
var findFocusable = function (element, checkVisibility) {
    if (checkVisibility === void 0) { checkVisibility = true; }
    return findElement(element, function (node) { return isFocusable(node, checkVisibility); });
};
/**
 * @hidden
 */
var findFocusableChild = function (element, checkVisibility) {
    if (checkVisibility === void 0) { checkVisibility = true; }
    return findElement(element, function (node) { return isFocusable(node, checkVisibility); }, false);
};
//# sourceMappingURL=dom-queries.js.map

/***/ }),
/* 2592 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_core__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
var grandSeperator=function grandSeperator(val){if(!val){return"0";}val=val.toString().replace(/,/g,'').replace(/ /g,'');var parsed=parseInt(val);if(!isNaN(parsed)){return parsed.toLocaleString().replace(/,/g,' ');}else{return val;}};var EmptyRow=function EmptyRow(props){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:12},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{paddingTop:'5px',color:'white'}},'R'));};var customRow=function customRow(firstCol,secondCol,thirdCol){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{item:true,xs:12,sm:12,md:12},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{container:true},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:3,sm:3,md:3},firstCol),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:2,sm:2,md:2},secondCol),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:2,sm:2,md:2},thirdCol),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:5,sm:5,md:5}))));};var Accrual=function Accrual(props){var accrual=props.state.result.accrual;return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{container:true,className:'fnaGridHeading'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:6,sm:6,md:6},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{variant:'subheading'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('strong',null,'Accrual'))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:3,sm:3,md:3},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{variant:'subheading'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('strong',null,'Client'))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{item:true,xs:3,sm:3,md:3},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{variant:'subheading'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('strong',null,'Spouse')))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{direction:'column',className:'fnaGridBody'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{item:true,xs:12,sm:12,md:12},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{container:true,className:'fnaGridBodyRow'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:12},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{wordWrap:'break-word',paddingTop:'5px'}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('strong',null,'Current:'))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:6,sm:6,md:6},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{wordWrap:'break-word',paddingTop:'5px'}},'Current value of assets')),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:3,sm:3,md:3},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{paddingTop:'5px'}},'R',' ',grandSeperator(accrual.current.valueOfAssets.client.toString()))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:3,sm:3,md:3},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{paddingTop:'5px'}},'R',' ',grandSeperator(accrual.current.valueOfAssets.spouse.toString()))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:6,sm:6,md:6},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{wordWrap:'break-word',paddingTop:'5px'}},'Plus Policies to estate')),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:3,sm:3,md:3},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{paddingTop:'5px'}},'R',' ',grandSeperator(accrual.current.valueOfPolicies.toString()))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:3,sm:3,md:3},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{paddingTop:'5px'}})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:6,sm:6,md:6},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{wordWrap:'break-word',paddingTop:'5px'}},'Minus Liabilities')),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:3,sm:3,md:3},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{paddingTop:'5px'}},'R',' ',grandSeperator(accrual.current.minusLiabilities.client.toString()))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:3,sm:3,md:3},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{paddingTop:'5px'}},'R',' ',grandSeperator(accrual.current.minusLiabilities.spouse.toString()))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:6,sm:6,md:6},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{wordWrap:'break-word',paddingTop:'5px'}},'Nett value')),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:3,sm:3,md:3},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{paddingTop:'5px'}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('strong',null,'R',' ',grandSeperator(accrual.current.netValue.client.toString())))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:3,sm:3,md:3},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{paddingTop:'5px'}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('strong',null,'R',' ',grandSeperator(accrual.current.netValue.spouse.toString())))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(EmptyRow,null),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:6,sm:6,md:6},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{wordWrap:'break-word',paddingTop:'5px'}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('strong',null,'Asset value excluded from accrual'))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:3,sm:3,md:3},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{paddingTop:'5px'}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('strong',null,'R',' ',grandSeperator(accrual.assetValueExcluded.client.toString())))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:3,sm:3,md:3},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{paddingTop:'5px'}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('strong',null,'R',' ',grandSeperator(accrual.assetValueExcluded.spouse.toString())))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(EmptyRow,null),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:12},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{wordWrap:'break-word',paddingTop:'5px'}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('strong',null,'At marriage:'))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:6,sm:6,md:6},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{wordWrap:'break-word',paddingTop:'5px'}},'Value according to ANC')),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:3,sm:3,md:3},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{paddingTop:'5px'}},'R',' ',grandSeperator(accrual.atMarriage.valueANC.client.toString()))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:3,sm:3,md:3},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{paddingTop:'5px'}},'R',' ',grandSeperator(accrual.atMarriage.valueANC.spouse.toString()))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:6,sm:6,md:6},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{wordWrap:'break-word',paddingTop:'5px'}},'Current value (CPI adjusted)')),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:3,sm:3,md:3},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{paddingTop:'5px'}},'R',' ','N/A')),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:3,sm:3,md:3},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{paddingTop:'5px'}},'R',' ','N/A')),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(EmptyRow,null),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:6,sm:6,md:6},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{wordWrap:'break-word',paddingTop:'5px'}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('strong',null,'Accrual'))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:3,sm:3,md:3},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{paddingTop:'5px'}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('strong',null,'R ',grandSeperator(accrual.netAccrual.client.toString())))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:3,sm:3,md:3},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{paddingTop:'5px'}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('strong',null,'R ',grandSeperator(accrual.netAccrual.spouse.toString()))))))),customRow(__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{wordWrap:"break-word",paddingTop:"25px"}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('strong',null,'Claim against spouse')),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{paddingTop:"25px"}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('strong',null,'R',' ',grandSeperator(accrual.claimAgainstSpouse.toString()))),null),customRow(__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{wordWrap:"break-word",paddingTop:"5px"}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('strong',null,'Claim by spouse')),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{paddingTop:"5px"}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('strong',null,'R',' ',grandSeperator(accrual.clainBySpouse.toString()))),null));};/* harmony default export */ __webpack_exports__["a"] = (Accrual);

/***/ }),
/* 2593 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_core__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__steps_objects_assetItems__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__steps_objects_otherLiabilityItems__ = __webpack_require__(396);
var grandSeperator=function grandSeperator(val){if(!val){return"0";}val=val.toString().replace(/,/g,"").replace(/ /g,"");var parsed=parseInt(val);if(!isNaN(parsed)){return parsed.toLocaleString().replace(/,/g," ");}else{return val;}};var BalanceSheet=function BalanceSheet(props){var balance_sheet=props.state.result.balanceSheet;return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{container:true,className:"fnaGridHeading"},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:6,sm:6,md:6},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{variant:"subheading"},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("strong",null,"Assets"))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:3,sm:3,md:3},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{variant:"subheading"},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("strong",null,"Client"))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{item:true,xs:3,sm:3,md:3},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{variant:"subheading"},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("strong",null,"Spouse")))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{direction:"column",className:"fnaGridBody"},balance_sheet.assets.map(function(assetType,i){var mappedAsset=assetType.description;var assetName=mappedAsset;return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{item:true,xs:12,sm:12,md:12,className:i%2===0?"":"disabledRow"},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{container:true,className:"fnaGridBodyRow"},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:6,sm:6,md:6},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{wordWrap:"break-word",paddingTop:"5px"}},assetName)),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:3,sm:3,md:3},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{paddingTop:"5px"}},"R ",grandSeperator(assetType.ownershipClient.toString()))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:3,sm:3,md:3},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{paddingTop:"5px"}},"R ",grandSeperator(assetType.ownershipSpouse)))));}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{item:true,xs:12,sm:12,md:12,style:{}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{container:true,className:"fnaGridBodyRow"},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:6,sm:6,md:6},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{paddingTop:"20px"}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("strong",null,"Total"))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:3,sm:3,md:3},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{paddingTop:"20px"}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("b",null,"R ",grandSeperator(balance_sheet.netAssetsClient)))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:3,sm:3,md:3},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{paddingTop:"20px"}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("b",null," R ",grandSeperator(balance_sheet.netAssetsSpouse))))))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{container:true,className:"fnaGridHeading"},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:6,sm:6,md:6},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{variant:"subheading"},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("strong",null,"Cash values of policies"))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:3,sm:3,md:3},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{variant:"subheading"},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("strong",null,"Client"))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{item:true,xs:3,sm:3,md:3},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{variant:"subheading"},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("strong",null,"Spouse")))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{direction:"column",className:"fnaGridBody"},balance_sheet.policies.map(function(policy,i){var mappedLiability={};var policyName=policy.description;return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{item:true,xs:12,sm:12,md:12,className:i%2===0?"":"disabledRow"},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{container:true,className:"fnaGridBodyRow"},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:6,sm:6,md:6},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{wordWrap:"break-word",paddingTop:"5px"}},policyName)),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:3,sm:3,md:3},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{paddingTop:"5px"}},"R ",grandSeperator(policy.amountClient))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:3,sm:3,md:3},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{paddingTop:"5px"}},"R ",grandSeperator(policy.amountSpouse)))));}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{item:true,xs:12,sm:12,md:12,style:{}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{container:true,className:"fnaGridBodyRow"},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:6,sm:6,md:6},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{paddingTop:"20px"}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("strong",null,"Total"))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:3,sm:3,md:3},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{paddingTop:"20px"}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("b",null,"R"," ",grandSeperator(balance_sheet.netPoliciesClient)))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:3,sm:3,md:3},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{paddingTop:"20px"}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("b",null,"R"," ",grandSeperator(balance_sheet.netPoliciesSpouse))))))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{container:true,className:"fnaGridHeading"},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:6,sm:6,md:6},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{variant:"subheading"},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("strong",null,"Liabilities"))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:3,sm:3,md:3},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{variant:"subheading"},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("strong",null,"Client"))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{item:true,xs:3,sm:3,md:3},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{variant:"subheading"},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("strong",null,"Spouse")))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{direction:"column",className:"fnaGridBody"},balance_sheet.liabilities.map(function(liabilityType,i){var mappedLiability={};var liabilityName=liabilityType.description;return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{item:true,xs:12,sm:12,md:12,className:i%2===0?"":"disabledRow"},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{container:true,className:"fnaGridBodyRow"},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:6,sm:6,md:6},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{wordWrap:"break-word",paddingTop:"5px"}},liabilityName)),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:3,sm:3,md:3},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{paddingTop:"5px"}},"R ",grandSeperator(liabilityType.amountClient))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:3,sm:3,md:3},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{paddingTop:"5px"}},"R ",grandSeperator(liabilityType.amountSpouse)))));}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{item:true,xs:12,sm:12,md:12,style:{}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{container:true,className:"fnaGridBodyRow"},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:6,sm:6,md:6},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{paddingTop:"20px"}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("strong",null,"Total"))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:3,sm:3,md:3},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{paddingTop:"20px"}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("b",null,"R"," ",grandSeperator(balance_sheet.netLiabilitiesClient)))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:3,sm:3,md:3},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{paddingTop:"20px"}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("b",null," R"," ",grandSeperator(balance_sheet.netLiabilitiesSpouse))))))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{container:true,style:{marginTop:"25px"}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:6,sm:6,md:6,style:{borderRight:"1px solid #e2e2e2"}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{variant:"subheading"},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("strong",null,"Net Asset Value: "))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:3,sm:3,md:3,style:{borderRight:"1px solid #e2e2e2"}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{variant:"caption"},"Client"),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("b",null,"R"," ",grandSeperator(balance_sheet.netTotalAssetsClient))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:3,sm:3,md:3},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{variant:"caption"},"Spouse"),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("b",null,"R"," ",grandSeperator(balance_sheet.netTotalAssetsSpouse)))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{container:true,style:{marginTop:"25px"}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:6,sm:6,md:6},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{variant:"subheading"},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("strong",null,"Policies Payable to Estate: "))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:3,sm:3,md:3},"R"," ",grandSeperator(props.state.result.executorFees.pToEstate)),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:3,sm:3,md:3})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{container:true,style:{}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:6,sm:6,md:6},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{variant:"subheading"},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("strong",null,"Percentage applicable: "))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:3,sm:3,md:3},props.state.result.executorFees.percentageApplicable,"%"),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:3,sm:3,md:3})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{container:true,style:{}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:6,sm:6,md:6},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{variant:"subheading"},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("strong",null,"VAT: "))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:3,sm:3,md:3},grandSeperator(props.state.result.executorFees.vat),"%"),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:3,sm:3,md:3})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{container:true,style:{marginTop:"25px"}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:6,sm:6,md:6},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{variant:"subheading"},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("strong",null,"Executor fees: "))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:3,sm:3,md:3},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("b",null,"R"," ",grandSeperator(props.state.result.executorFees.executorFee))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:3,sm:3,md:3})));};/* harmony default export */ __webpack_exports__["a"] = (BalanceSheet);

/***/ }),
/* 2594 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_core__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__steps_objects_assetItems__ = __webpack_require__(273);
var grandSeperator=function grandSeperator(val){if(!val){return"0";}val=val.toString().replace(/,/g,"").replace(/ /g,"");var parsed=parseInt(val);if(!isNaN(parsed)){return parsed.toLocaleString().replace(/,/g," ");}else{return val;}};var customRow=function customRow(firstCol,secondCol,thirdCol){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{item:true,xs:12,sm:12,md:12},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{container:true},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:3,sm:3,md:3},firstCol),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:2,sm:2,md:2},secondCol),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:2,sm:2,md:2},thirdCol),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:5,sm:5,md:5}))));};var CGT=function CGT(props){var cgt_data=props.state.result.cgt;return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{container:true,className:"fnaGridHeading"},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:3,sm:3,md:3},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{variant:"subheading"},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("strong",null,"Assets"))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:3,sm:3,md:3},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{variant:"subheading"},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("strong",null,"Description"))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:2,sm:2,md:2},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{variant:"subheading"},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("strong",null,"Market Value of client's share"))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{item:true,xs:2,sm:2,md:2},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{variant:"subheading"},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("strong",null,"Client's base cost"))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{item:true,xs:2,sm:2,md:2},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{variant:"subheading"},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("strong",null,"Client's Capital Gain")))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{direction:"column",className:"fnaGridBody"},cgt_data.cgtAssets.map(function(assetType,i){var assetName=assetType.description;return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{item:true,xs:12,sm:12,md:12,className:i%2===0?"":"disabledRow"},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{container:true,className:"fnaGridBodyRow"},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:3,sm:3,md:3},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{wordWrap:"break-word",paddingTop:"5px"}},assetType.category)),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:3,sm:3,md:3},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{wordWrap:"break-word",paddingTop:"5px"}},assetName)),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:2,sm:2,md:2},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{paddingTop:"5px"}},"R ",grandSeperator(assetType.marketValue.toString()))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:2,sm:2,md:2},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{paddingTop:"5px"}},"R ",grandSeperator(assetType.baseCost))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:2,sm:2,md:2},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{paddingTop:"5px"}},"R ",grandSeperator(assetType.capitalGain)))));}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{item:true,xs:12,sm:12,md:12,style:{}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{container:true,className:"fnaGridBodyRow"},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:6,sm:6,md:6},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{paddingTop:"20px"}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("strong",null,"Total"))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:2,sm:2,md:2},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{paddingTop:"20px"}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("b",null,"R"," ",grandSeperator(cgt_data.netCgtMarketValue)))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:2,sm:2,md:2},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{paddingTop:"20px"}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("b",null,"R"," ",grandSeperator(cgt_data.netClientsBaseCost)))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:2,sm:2,md:2},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{paddingTop:"20px"}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("b",null,"R"," ",grandSeperator(cgt_data.netClientsCapitalGain))))))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{direction:"column",style:{marginTop:"20px",marginBottom:"20px"}},customRow(__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{wordWrap:"break-word",paddingTop:"5px"}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("strong",null,"Capital Gain: ")),null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{paddingTop:"5px"}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("b",null," R ",grandSeperator(cgt_data.netClientsCapitalGainDisplay)))),customRow(__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{wordWrap:"break-word",paddingTop:"5px"}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("strong",null,"Minus: Spouse's Roll Over")),null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{paddingTop:"5px"}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("b",null,"R ",grandSeperator(cgt_data.minusspouseRollOver.netRollOver)))),customRow(__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{wordWrap:"break-word",paddingTop:"5px"}},"Portion bequethed to Spouse"),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{paddingTop:"5px"}},"R"," ",grandSeperator(cgt_data.minusspouseRollOver.portionBequethedTospouse)),null),customRow(__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{wordWrap:"break-word",paddingTop:"5px"}},"Portion to Spouse as part of residue"),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{paddingTop:"5px"}},"R"," ",grandSeperator(cgt_data.minusspouseRollOver.portionResidueTospouse)),null),customRow(null,null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{paddingTop:"5px",textDecorationLine:'overline'}}," ",__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("b",null,"R ",grandSeperator(cgt_data.netMinusRollOver)))),customRow(__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{wordWrap:"break-word",paddingTop:"5px"}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("strong",null,"Minus: Previous loss carried over")),null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{paddingTop:"5px"}},"R ",grandSeperator(cgt_data.minusPreviousLoss))),customRow(null,null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{paddingTop:"5px",textDecorationLine:'overline'}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("b",null,"R"," ",grandSeperator(cgt_data.netMinusPreviousLoss)))),customRow(__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{wordWrap:"break-word",paddingTop:"5px"}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("strong",null,"Minus: Exclusion at death")),null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{paddingTop:"5px"}},"R ",grandSeperator(cgt_data.minusExclusionAtDeath))),customRow(__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{wordWrap:"break-word",paddingTop:"5px"}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("strong",null,"Net Capital Gain")),null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{paddingTop:"5px",textDecorationLine:'overline'}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("b",null,"R ",grandSeperator(cgt_data.netCgt)))),customRow(__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{wordWrap:"break-word",paddingTop:"5px"}},"Inclusion rate"),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{paddingTop:"5px"}},cgt_data.inclusionRate,"%"),null),customRow(__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{wordWrap:"break-word",paddingTop:"5px"}},"Marginal tax rate"),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{paddingTop:"5px"}},cgt_data.marginalTax,"%"),null),customRow(__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{wordWrap:"break-word",paddingTop:"25px"}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("strong",null,"CGT payable")),null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{paddingTop:"25px",textDecorationLine:'overline'}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("b",null,"R ",grandSeperator(cgt_data.cgtPayable))))));};/* harmony default export */ __webpack_exports__["a"] = (CGT);

/***/ }),
/* 2595 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_core__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
var grandSeperator=function grandSeperator(val){if(!val){return"0";}val=val.toString().replace(/,/g,'').replace(/ /g,'');var parsed=parseInt(val);if(!isNaN(parsed)){return parsed.toLocaleString().replace(/,/g,' ');}else{return val;}};var customRow=function customRow(firstCol,secondCol,thirdCol){return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{item:true,xs:12,sm:12,md:12},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{container:true},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:3,sm:3,md:3},firstCol),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:2,sm:2,md:2},secondCol),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:2,sm:2,md:2},thirdCol),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:5,sm:5,md:5}))));};var EstateDuty=function EstateDuty(props){var estateDuty=props.state.result.estateDuty;return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{direction:'column',style:{marginTop:'20px',marginBottom:'20px'}},customRow(__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{wordWrap:'break-word',paddingTop:'5px'}},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('strong',null,'Assets: ')),null,__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{paddingTop:'5px'}},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('b',null,'R ',grandSeperator(estateDuty.assets.netEstateAssets)))),customRow(__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{wordWrap:'break-word',paddingTop:'5px'}},'Assets from balance sheet'),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{paddingTop:'5px'}},'R ',grandSeperator(estateDuty.assets.netAssets)),null),customRow(__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{wordWrap:'break-word',paddingTop:'5px'}},'Farms'),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{paddingTop:'5px'}},'R ',grandSeperator(estateDuty.assets.netFarms)),null),customRow(__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{wordWrap:'break-word',paddingTop:'5px'}},'Deemed Assets'),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{paddingTop:'5px'}},'R ',grandSeperator(estateDuty.assets.netDeemedAssets)),null),customRow(__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{wordWrap:'break-word',paddingTop:'5px'}},'Policies On Your Life'),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{paddingTop:'5px'}},'R ',grandSeperator(estateDuty.assets.netPoliciesOnLife)),null),customRow(__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{wordWrap:'break-word',paddingTop:'5px'}},'Policies with a cash value (Client owner, not life assured)'),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{paddingTop:'5px'}},'R ',grandSeperator(estateDuty.assets.netPoliciesWithChash)),null),customRow(__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{wordWrap:'break-word',paddingTop:'5px'}},'Accrual claim against surviving spouse'),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{paddingTop:'5px'}},'R',' ',grandSeperator(estateDuty.assets.claimAgainstSpouse)),null),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{style:{marginTop:'20px'}}),customRow(__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{wordWrap:'break-word',paddingTop:'5px'}},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('strong',null,'Deductions:')),null,__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{paddingTop:'5px'}},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('b',null,'R ',grandSeperator(Object(__WEBPACK_IMPORTED_MODULE_2_lodash__["toInteger"])(estateDuty.deductions.netDeductions))))),customRow(__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{wordWrap:'break-word',paddingTop:'5px'}},'Liabilities'),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{paddingTop:'5px'}},'R ',grandSeperator(estateDuty.deductions.netLiabilities)),null),customRow(__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{wordWrap:'break-word',paddingTop:'5px'}},'Administration'),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{paddingTop:'5px'}},'R ',grandSeperator(estateDuty.deductions.netAdministration)),null),customRow(__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{wordWrap:'break-word',paddingTop:'5px'}},'Funeral'),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{paddingTop:'5px'}},'R ',grandSeperator(estateDuty.deductions.netFuneral)),null),customRow(__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{wordWrap:'break-word',paddingTop:'5px'}},'Masters Fees'),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{paddingTop:'5px'}},'R ',grandSeperator(estateDuty.deductions.netMastersFee)),null),customRow(__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{wordWrap:'break-word',paddingTop:'5px'}},'Executors Fees'),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{paddingTop:'5px'}},'R ',grandSeperator(Object(__WEBPACK_IMPORTED_MODULE_2_lodash__["toInteger"])(estateDuty.deductions.netExectutorsFee))),null),customRow(__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{wordWrap:'break-word',paddingTop:'5px'}},'Capital Gains Tax'),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{paddingTop:'5px'}},'R ',grandSeperator(estateDuty.deductions.netCapitalGainTax)),null),customRow(__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{wordWrap:'break-word',paddingTop:'5px'}},'Transfer Costs'),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{paddingTop:'5px'}},'R ',grandSeperator(estateDuty.deductions.netTransferCosts)),null),customRow(__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{wordWrap:'break-word',paddingTop:'5px'}},'Value of assets bequethed to surviving spouse'),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{paddingTop:'5px'}},'R',' ',grandSeperator(Object(__WEBPACK_IMPORTED_MODULE_2_lodash__["toInteger"])(estateDuty.deductions.netBequethedAssets))),null),customRow(__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{wordWrap:'break-word',paddingTop:'5px'}},'Cash bequests to spouse'),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{paddingTop:'5px'}},'R ',grandSeperator(estateDuty.deductions.netCashBequestTospouse)),null),customRow(__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{wordWrap:'break-word',paddingTop:'5px'}},'Residue to surviving spouse'),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{paddingTop:'5px'}},'R ',grandSeperator(Object(__WEBPACK_IMPORTED_MODULE_2_lodash__["toInteger"])(estateDuty.deductions.netResidueTospouse))),null),customRow(__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{wordWrap:'break-word',paddingTop:'5px'}},'Policies to surviving spouse'),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{paddingTop:'5px'}},'R ',grandSeperator(estateDuty.deductions.netPoliciesToSpouse)),null),customRow(__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{wordWrap:'break-word',paddingTop:'5px'}},'Bequests to charities'),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{paddingTop:'5px'}},'R ',grandSeperator(estateDuty.deductions.bequestsToCharities)),null),customRow(__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{wordWrap:'break-word',paddingTop:'5px'}},'Cash bequests to charity'),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{paddingTop:'5px'}},'R ',grandSeperator(estateDuty.deductions.netCashBequestToCharity)),null),customRow(__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{wordWrap:'break-word',paddingTop:'5px'}},'Accrual claim'),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{paddingTop:'5px'}},'R ',grandSeperator(estateDuty.deductions.netAccrualClaim)),null),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{style:{marginTop:'20px'}}),customRow(__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{wordWrap:'break-word',paddingTop:'5px'}},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('strong',null,'Nett Estate:')),null,__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{paddingTop:'5px'}},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('b',null,'R ',grandSeperator(Object(__WEBPACK_IMPORTED_MODULE_2_lodash__["toInteger"])(estateDuty.netEstate))))),customRow(__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{wordWrap:'break-word',paddingTop:'5px'}},'Minus: Rebate'),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{paddingTop:'5px'}},'R ',grandSeperator(estateDuty.minusRebate)),null),customRow(__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{wordWrap:'break-word',paddingTop:'5px'}},'Minus: Rebate carried from previous spouse'),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{paddingTop:'5px'}},'R',' ',props.state.spouseDeath&&grandSeperator(estateDuty.minusRebate-estateDuty.minusRebateFromPreviousSpouse),!props.state.spouseDeath&&grandSeperator(0.00)),null),customRow(__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{wordWrap:'break-word',paddingTop:'5px'}},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('strong',null,'Taxable Estate')),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{paddingTop:'5px'}},'R ',grandSeperator(estateDuty.taxableEstate)),null),customRow(__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{wordWrap:'break-word',paddingTop:'5px'}},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('strong',null,'Estate Duty payable')),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{paddingTop:'5px'}},'R ',grandSeperator(estateDuty.estateDutyPayable)),null),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{style:{marginTop:'20px'}}),customRow(__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{wordWrap:'break-word',paddingTop:'5px'}},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('strong',null,'Apportionment of Estate duty:')),null,null),customRow(__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{wordWrap:'break-word',paddingTop:'5px'}},'Payable By Others'),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{paddingTop:'5px'}},'R',' ',grandSeperator(Object(__WEBPACK_IMPORTED_MODULE_2_lodash__["toInteger"])(estateDuty.payableByOther))),null),customRow(__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{wordWrap:'break-word',paddingTop:'5px'}},'Payable By Estate'),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{paddingTop:'5px'}},'R',' ',grandSeperator(Object(__WEBPACK_IMPORTED_MODULE_2_lodash__["toInteger"])(estateDuty.payableByEstate))),null)));};/* harmony default export */ __webpack_exports__["a"] = (EstateDuty);

/***/ }),
/* 2596 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_core__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
var grandSeperator=function grandSeperator(val){if(!val){return"0";}val=val.toString().replace(/,/g,"").replace(/ /g,"");var parsed=parseFloat(val);if(!isNaN(parsed)){return parsed.toLocaleString().replace(/,/g," ");}else{return val;}};var customRow=function customRow(firstCol,secondCol,thirdCol){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{item:true,xs:12,sm:12,md:12},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{container:true},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:6,sm:6,md:6},firstCol),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:3,sm:3,md:3},secondCol),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:3,sm:3,md:3},thirdCol))));};var ExecutorsFees=function ExecutorsFees(props){var executorsFees=props.executorsFees;return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{direction:"column",style:{marginTop:"20px",marginBottom:"20px"}},customRow(__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{wordWrap:"break-word",paddingTop:"5px"}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("strong",null,"Net Asset Value: ")),null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{paddingTop:"5px"}},"R ",grandSeperator(executorsFees.assetTotal))),customRow(__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{wordWrap:"break-word",paddingTop:"5px"}},"Percentage applicable:"),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{paddingTop:"5px"}},executorsFees.percentageApplicable,"%"),null),customRow(__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{wordWrap:"break-word",paddingTop:"5px"}},"VAT:"),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{paddingTop:"5px"}},executorsFees.VAT,"%"),null),customRow(__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{wordWrap:"break-word",paddingTop:"5px"}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("strong",null,"Executor fees: ")),null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{paddingTop:"5px"}},"R ",grandSeperator(executorsFees.executorsFees)))));};/* unused harmony default export */ var _unused_webpack_default_export = (ExecutorsFees);

/***/ }),
/* 2597 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_core__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
var grandSeperator=function grandSeperator(val){if(!val){return"0";}val=val.toString().replace(/,/g,'').replace(/ /g,'');var parsed=parseInt(val);if(!isNaN(parsed)){return parsed.toLocaleString().replace(/,/g,' ');}else{return val;}};var customRow=function customRow(firstCol,secondCol,thirdCol){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{item:true,xs:12,sm:12,md:12},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{container:true},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:3,sm:3,md:3},firstCol),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:2,sm:2,md:2},secondCol),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:2,sm:2,md:2},thirdCol),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:5,sm:5,md:5}))));};var Liquidity=function Liquidity(props){var liquidity=props.state.result.liquidity;return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{direction:'column',style:{marginTop:'20px',marginBottom:'20px'}},customRow(__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{wordWrap:'break-word',paddingTop:'5px'}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('strong',null,'Cash needed to wind up estate: ')),null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{paddingTop:'5px'}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('strong',null,'R ',grandSeperator(parseFloat(liquidity.cashNeeded.netCashNeeded).toFixed(2))))),customRow(__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{wordWrap:'break-word',paddingTop:'5px'}},'CGT'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{paddingTop:'5px'}},'R ',grandSeperator(liquidity.cashNeeded.netCgt)),null),customRow(__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{wordWrap:'break-word',paddingTop:'5px'}},'Liabilities'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{paddingTop:'5px'}},'R ',grandSeperator(liquidity.cashNeeded.netLiabilities)),null),customRow(__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{wordWrap:'break-word',paddingTop:'5px'}},'Executors Fees'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{paddingTop:'5px'}},'R ',grandSeperator(liquidity.cashNeeded.netExectutorsFee)),null),customRow(__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{wordWrap:'break-word',paddingTop:'5px'}},'Estate Duty'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{paddingTop:'5px'}},'R ',grandSeperator(liquidity.cashNeeded.netEstateDuty)),null),customRow(__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{wordWrap:'break-word',paddingTop:'5px'}},'Other Costs'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{paddingTop:'5px'}},'R ',grandSeperator(liquidity.cashNeeded.netOtherCosts)),null),customRow(__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{wordWrap:'break-word',paddingTop:'5px'}},'Liquid Assets bequethed'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{paddingTop:'5px'}},'R',' ',grandSeperator(liquidity.cashNeeded.netBequethedLiquidAssets)),null),customRow(__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{wordWrap:'break-word',paddingTop:'5px'}},'Cash bequests'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{paddingTop:'5px'}},'R ',grandSeperator(liquidity.cashNeeded.netCashBequests)),null),customRow(__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{wordWrap:'break-word',paddingTop:'5px'}},'Accrual claim'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{paddingTop:'5px'}},'R ',grandSeperator(liquidity.cashNeeded.netAccrualClaim)),null),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{style:{marginTop:'20px'}}),customRow(__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{wordWrap:'break-word',paddingTop:'5px'}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('strong',null,'Cash available:')),null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{paddingTop:'5px'}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('strong',null,'R ',grandSeperator(liquidity.cashAvailable.netCashAvailable)))),customRow(__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{wordWrap:'break-word',paddingTop:'5px'}},'Cash'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{paddingTop:'5px'}},'R ',grandSeperator(liquidity.cashAvailable.cash)),null),customRow(__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{wordWrap:'break-word',paddingTop:'5px'}},'Liquid Investments'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{paddingTop:'5px'}},'R ',grandSeperator(liquidity.cashAvailable.netLiquidInvestments)),null),customRow(__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{wordWrap:'break-word',paddingTop:'5px'}},'Assets converted to cash'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{paddingTop:'5px'}},'R ',grandSeperator(liquidity.cashAvailable.netCashAssets)),null),customRow(__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{wordWrap:'break-word',paddingTop:'5px'}},'Policies'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{paddingTop:'5px'}},'R ',grandSeperator(liquidity.cashAvailable.netPolicies)),null),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{style:{marginTop:'20px'}}),customRow(__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{wordWrap:'break-word',paddingTop:'5px'}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('strong',null,'Cash surplus/deficit:')),null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{paddingTop:'5px'}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('strong',null,' R ',grandSeperator(parseFloat(liquidity.cash).toFixed(2)))))));};/* harmony default export */ __webpack_exports__["a"] = (Liquidity);

/***/ }),
/* 2598 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_core__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
var grandSeperator=function grandSeperator(val){if(!val){return"0";}val=val.toString().replace(/,/g,'').replace(/ /g,'');var parsed=parseInt(val);if(!isNaN(parsed)){return parsed.toLocaleString().replace(/,/g,' ');}else{return val;}};var customRow=function customRow(firstCol,secondCol,thirdCol){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{item:true,xs:12,sm:12,md:12},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{container:true},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:3,sm:3,md:3},firstCol),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:2,sm:2,md:2},secondCol),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:2,sm:2,md:2},thirdCol),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:5,sm:5,md:5}))));};var Residue=function Residue(props){var residue=props.state.result.residue;return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{direction:'column',style:{marginTop:'20px',marginBottom:'20px'}},customRow(__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{wordWrap:'break-word',paddingTop:'5px'}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('strong',null,'Total assets and deemed assets: ')),null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{paddingTop:'5px'}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('strong',null,'R ',grandSeperator(residue.totalAssets)))),customRow(__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{wordWrap:'break-word',paddingTop:'5px'}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('strong',null,'Minus: ')),null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{paddingTop:'5px'}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('strong',null,'R ',grandSeperator(residue.minus)))),customRow(__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{wordWrap:'break-word',paddingTop:'5px'}},'Policies not payable to estate'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{paddingTop:'5px'}},'R ',grandSeperator(residue.policies)),null),customRow(__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{wordWrap:'break-word',paddingTop:'5px'}},'Bequests to other'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{paddingTop:'5px'}},'R ',grandSeperator(residue.bequestsToOther)),null),customRow(__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{wordWrap:'break-word',paddingTop:'5px'}},'Cash bequests to other'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{paddingTop:'5px'}},'R ',grandSeperator(residue.cashBequestsToOther)),null),customRow(__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{wordWrap:'break-word',paddingTop:'5px'}},'Bequests to spouse'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{paddingTop:'5px'}},'R ',grandSeperator(residue.bequestsToSpouse)),null),customRow(__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{wordWrap:'break-word',paddingTop:'5px'}},'Cash bequests to spouse'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{paddingTop:'5px'}},'R ',grandSeperator(residue.cashBequestsToSpouse)),null),customRow(__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{wordWrap:'break-word',paddingTop:'5px'}},'Liabilities'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{paddingTop:'5px'}},'R ',grandSeperator(residue.liabilities)),null),customRow(__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{wordWrap:'break-word',paddingTop:'5px'}},'Costs'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{paddingTop:'5px'}},'R ',grandSeperator(residue.costs)),null),customRow(__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{wordWrap:'break-word',paddingTop:'5px'}},'Accrual claim by spouse'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{paddingTop:'5px'}},'R ',grandSeperator(residue.accrualClaimBySpouse)),null),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{style:{marginTop:'20px'}}),customRow(__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{wordWrap:'break-word',paddingTop:'5px'}},'Residue before Estate Duty'),null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{paddingTop:'5px'}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('strong',null,'R ',grandSeperator(residue.residueBeforeEstateDuty)))),customRow(__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{wordWrap:'break-word',paddingTop:'5px'}},'Minus Estate duty by estate'),null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{paddingTop:'5px'}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('strong',null,'R ',grandSeperator(residue.minusEstateDuty)))),customRow(__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{wordWrap:'break-word',paddingTop:'5px'}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('strong',null,'Residue')),null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{paddingTop:'5px'}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('strong',null,'R ',grandSeperator(residue.residue))))));};/* harmony default export */ __webpack_exports__["a"] = (Residue);

/***/ }),
/* 2599 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_core__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
var grandSeperator=function grandSeperator(val){if(!val){return"0";}val=val.toString().replace(/,/g,'').replace(/ /g,'');var parsed=parseInt(val);if(!isNaN(parsed)){return parsed.toLocaleString().replace(/,/g,' ');}else{return val;}};var customRow=function customRow(firstCol,secondCol,thirdCol){return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{item:true,xs:12,sm:12,md:12},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{container:true},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:3,sm:3,md:3},firstCol),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:2,sm:2,md:2},secondCol),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:2,sm:2,md:2},thirdCol),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:5,sm:5,md:5}))));};var ProvisionDeath=function ProvisionDeath(props){var provision=props.state.result.deathProvision;return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{direction:'column',style:{marginTop:'20px',marginBottom:'20px'}},customRow(__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{wordWrap:'break-word',paddingTop:'5px'}},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('strong',null,'Provision for dependants: ')),null,__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{paddingTop:'5px'}},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('strong',null,'R ',grandSeperator(provision.provision.capitalLiquidity)))),customRow(__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{wordWrap:'break-word',paddingTop:'5px'}},'Surplus/deficit'),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{paddingTop:'5px'}},'R ',grandSeperator(provision.liquidity)),null),customRow(__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{wordWrap:'break-word',paddingTop:'5px'}},'- Surplus to other'),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{paddingTop:'5px'}},'R ',grandSeperator(provision.surplusToOther)),null),customRow(__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{wordWrap:'break-word',paddingTop:'5px'}},'- Capital Need'),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{paddingTop:'5px'}},'R ',grandSeperator(provision.capitalNeed)),null),customRow(__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{wordWrap:'break-word',paddingTop:'5px'}},'+ Policy to spouse or dependants'),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{paddingTop:'5px'}},'R ',grandSeperator(provision.provision.policies)),null),customRow(__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{wordWrap:'break-word',paddingTop:'5px'}},'+ Cash to spouse or dependants'),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{paddingTop:'5px'}},'R ',grandSeperator(provision.provision.cashToSpouse)),null),customRow(__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{paddingTop:'5px'}},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('strong',null," ")),null,null),customRow(__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{wordWrap:'break-word',paddingTop:'5px'}},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('strong',null,'Months Provisioned For: ')),null,__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{paddingTop:'5px'}},String(props.state.result.deathProvision.monthsProvisioned).includes(">")==false&&__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('strong',null,Object(__WEBPACK_IMPORTED_MODULE_2_lodash__["floor"])(props.state.result.deathProvision.monthsProvisioned/12),' years and ',props.state.result.deathProvision.monthsProvisioned%12,' '," ",'  Months'),String(props.state.result.deathProvision.monthsProvisioned).includes(">")==true&&__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('strong',null,'More than 60 Years')))),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{container:true,className:'fnaGridHeading'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:3,sm:3,md:3},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{variant:'subheading'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('strong',null,'Income Need At Death'))),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:3,sm:3,md:3},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{variant:'subheading'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('strong',null,'Monthly Amount'))),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{item:true,xs:3,sm:3,md:3},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{variant:'subheading'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('strong',null,'Anual Increase'))),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{item:true,xs:3,sm:3,md:3},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{variant:'subheading'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('strong',null,'Years Needed')))),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{direction:'column',className:'fnaGridBody'},props.state.needs.incomeNeeds.map(function(e,i){return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{item:true,xs:12,sm:12,md:12,className:i%2===0?"":"disabledRow"},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{container:true,className:'fnaGridBodyRow'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:3,sm:3,md:3},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{wordWrap:"break-word",paddingTop:"5px"}},e.incomeStream)),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:3,sm:3,md:3},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{paddingTop:"5px"}},'R ',grandSeperator(e.mounthlyAmount.toString()))),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:3,sm:3,md:3},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{paddingTop:"5px"}},e.annualIncrease,'%')),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:3,sm:3,md:3},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{paddingTop:"5px"}},e.yearsPayable,' Years'))));})),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{container:true,className:'fnaGridHeading'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:3,sm:3,md:3},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{variant:'subheading'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('strong',null,'Income Provision'))),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:3,sm:3,md:3},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{variant:'subheading'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('strong',null,'Monthly Amount'))),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{item:true,xs:3,sm:3,md:3},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{variant:'subheading'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('strong',null,'Anual Increase'))),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{item:true,xs:3,sm:3,md:3},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{variant:'subheading'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('strong',null,'Years Receivable')))),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{direction:'column',className:'fnaGridBody'},props.state.needs.incomeStreams.map(function(e,i){return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{item:true,xs:12,sm:12,md:12,className:i%2===0?"":"disabledRow"},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{container:true,className:'fnaGridBodyRow'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:3,sm:3,md:3},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{wordWrap:"break-word",paddingTop:"5px"}},e.incomeStream)),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:3,sm:3,md:3},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{paddingTop:"5px"}},'R ',grandSeperator(e.mounthlyAmount.toString()))),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:3,sm:3,md:3},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{paddingTop:"5px"}},e.annualIncrease,'%')),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:3,sm:3,md:3},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{paddingTop:"5px"}},e.yearsPayable,' Years'))));})));};/* harmony default export */ __webpack_exports__["a"] = (ProvisionDeath);

/***/ }),
/* 2600 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_core__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_assets_img_sure_quote_website_logo_png__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_assets_img_sure_quote_website_logo_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_assets_img_sure_quote_website_logo_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
var ResultsPdf=function ResultsPdf(props){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'a4Page',style:{padding:'20px'}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{style:{textAlign:'center'}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('img',{style:{width:'250px',margin:'0px auto 15px auto'},src:__WEBPACK_IMPORTED_MODULE_1_assets_img_sure_quote_website_logo_png___default.a,alt:'sqLogo'}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{variant:'title',style:{margin:'15px 0px'}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('strong',null,'Financial Needs Analysis')),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{variant:'subheading',style:{margin:'15px 0px'}},'Description : ',props.fnaDetails.description),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{variant:'subheading',style:{margin:'15px 0px'}},'Client : ',props.fnaDetails.clientFullName),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{variant:'subheading',style:{margin:'15px 0px'}},'Date : ',props.fnaDetails.date_created))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'page-break'}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'a4Page',style:{padding:'20px'}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{variant:'title'},'Balance Sheet'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'scale08'},props.balanceSheet)),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'page-break'}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'a4Page',style:{padding:'20px'}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{variant:'title'},'CGT'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'scale08'},props.CgtSheet)),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'page-break'}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'a4Page',style:{padding:'20px'}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{variant:'title'},'Executor Fees'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'scale08'},props.ExecutorsFeesSheet)),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'page-break'}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'a4Page',style:{padding:'20px'}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{variant:'title'},'Estate Duty'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'scale08'},props.EstateDutySheet)));};/* unused harmony default export */ var _unused_webpack_default_export = (ResultsPdf);

/***/ }),
/* 2601 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_core__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_helpers_UriReader__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_helpers_UserHelper__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_queries_fna_queries__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_apollo__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_json_view__ = __webpack_require__(2602);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_json_view___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_json_view__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_router__ = __webpack_require__(33);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var FnaResultsJson=function(_React$Component){_inherits(FnaResultsJson,_React$Component);function FnaResultsJson(){_classCallCheck(this,FnaResultsJson);return _possibleConstructorReturn(this,(FnaResultsJson.__proto__||Object.getPrototypeOf(FnaResultsJson)).apply(this,arguments));}_createClass(FnaResultsJson,[{key:'render',value:function render(){var params=Object(__WEBPACK_IMPORTED_MODULE_2_helpers_UriReader__["a" /* ParseUriParams */])(this.props.location.search);var fnaId=params.fnaId;return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_apollo__["Query"],{query:__WEBPACK_IMPORTED_MODULE_4_queries_fna_queries__["b" /* FnaResults */],variables:{fnaId:fnaId,token:Object(__WEBPACK_IMPORTED_MODULE_3_helpers_UserHelper__["c" /* GetUserToken */])()},fetchPolicy:'cache-and-network'},function(_ref){var loading=_ref.loading,error=_ref.error,data=_ref.data,refetch=_ref.refetch;if(loading){return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["B" /* LinearProgress */],null));}if(error&&error.message&&error.message==='GraphQL error: invalid token'){Object(__WEBPACK_IMPORTED_MODULE_3_helpers_UserHelper__["d" /* Logout */])();return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_router__["a" /* Redirect */],{to:'/app/portal/login'});}console.log('data',data.FnaResults);return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{container:true},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:10,style:{margin:'auto'}},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["e" /* Card */],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["f" /* CardContent */],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_json_view___default.a,{name:'Fna Results',src:data.FnaResults.FnaResultObj,displayObjectSize:false,displayDataTypes:false})))));});}}]);return FnaResultsJson;}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (FnaResultsJson);

/***/ }),
/* 2602 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t(__webpack_require__(0)):"function"==typeof define&&define.amd?define(["react"],t):"object"==typeof exports?exports.reactJsonView=t(require("react")):e.reactJsonView=t(e.React)}("undefined"!=typeof self?self:this,function(e){return function(e){function t(r){if(n[r])return n[r].exports;var a=n[r]={i:r,l:!1,exports:{}};return e[r].call(a.exports,a,a.exports,t),a.l=!0,a.exports}var n={};return t.m=e,t.c=n,t.d=function(e,n,r){t.o(e,n)||Object.defineProperty(e,n,{configurable:!1,enumerable:!0,get:r})},t.n=function(e){var n=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(n,"a",n),n},t.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},t.p="",t(t.s=60)}([function(t,n){t.exports=e},function(e,t,n){"use strict";function r(e,t,n){return e||console.error("theme has not been set"),f(e)(t,n)}Object.defineProperty(t,"__esModule",{value:!0});var a=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e};t.default=r;var o=n(64),i=n(65),s=function(e){return e&&e.__esModule?e:{default:e}}(i),u=n(66),l=function(e){return{backgroundColor:e.base00,ellipsisColor:e.base09,braceColor:e.base07,expandedIcon:e.base0D,collapsedIcon:e.base0E,keyColor:e.base07,arrayKeyColor:e.base0C,objectSize:e.base04,copyToClipboard:e.base0F,copyToClipboardCheck:e.base0D,objectBorder:e.base02,dataTypes:{boolean:e.base0E,date:e.base0D,float:e.base0B,function:e.base0D,integer:e.base0F,string:e.base09,nan:e.base08,null:e.base0A,undefined:e.base05,regexp:e.base0A,background:e.base02},editVariable:{editIcon:e.base0E,cancelIcon:e.base09,removeIcon:e.base09,addIcon:e.base0E,checkIcon:e.base0E,background:e.base01,color:e.base0A,border:e.base07},addKeyModal:{background:e.base05,border:e.base04,color:e.base0A,labelColor:e.base01},validationFailure:{background:e.base09,iconColor:e.base01,fontColor:e.base01}}},c=function(e){var t=l(e);return{"app-container":{fontFamily:s.default.globalFontFamily,cursor:s.default.globalCursor,backgroundColor:t.backgroundColor,position:"relative"},ellipsis:{display:"inline-block",color:t.ellipsisColor,fontSize:s.default.ellipsisFontSize,lineHeight:s.default.ellipsisLineHeight,cursor:s.default.ellipsisCursor},"brace-row":{display:"inline-block",cursor:"pointer"},brace:{display:"inline-block",cursor:s.default.braceCursor,fontWeight:s.default.braceFontWeight,color:t.braceColor},"expanded-icon":{color:t.expandedIcon},"collapsed-icon":{color:t.collapsedIcon},colon:{display:"inline-block",margin:s.default.keyMargin,color:t.keyColor,verticalAlign:"top"},objectKeyVal:function(e,n){return{style:a({paddingTop:s.default.keyValPaddingTop,paddingRight:s.default.keyValPaddingRight,paddingBottom:s.default.keyValPaddingBottom,borderLeft:s.default.keyValBorderLeft+" "+t.objectBorder,":hover":{paddingLeft:n.paddingLeft-1+"px",borderLeft:s.default.keyValBorderHover+" "+t.objectBorder}},n)}},"object-key-val-no-border":{padding:s.default.keyValPadding},"pushed-content":{marginLeft:s.default.pushedContentMarginLeft},variableValue:function(e,t){return{style:a({display:"inline-block",paddingRight:s.default.variableValuePaddingRight,position:"relative"},t)}},"object-name":{display:"inline-block",color:t.keyColor,letterSpacing:s.default.keyLetterSpacing,fontStyle:s.default.keyFontStyle,verticalAlign:s.default.keyVerticalAlign,opacity:s.default.keyOpacity,":hover":{opacity:s.default.keyOpacityHover}},"array-key":{display:"inline-block",color:t.arrayKeyColor,letterSpacing:s.default.keyLetterSpacing,fontStyle:s.default.keyFontStyle,verticalAlign:s.default.keyVerticalAlign,opacity:s.default.keyOpacity,":hover":{opacity:s.default.keyOpacityHover}},"object-size":{color:t.objectSize,borderRadius:s.default.objectSizeBorderRadius,fontStyle:s.default.objectSizeFontStyle,margin:s.default.objectSizeMargin,cursor:"default"},"data-type-label":{fontSize:s.default.dataTypeFontSize,marginRight:s.default.dataTypeMarginRight,opacity:s.default.datatypeOpacity},boolean:{display:"inline-block",color:t.dataTypes.boolean},date:{display:"inline-block",color:t.dataTypes.date},"date-value":{marginLeft:s.default.dateValueMarginLeft},float:{display:"inline-block",color:t.dataTypes.float},function:{display:"inline-block",color:t.dataTypes.function,cursor:"pointer",whiteSpace:"pre-line"},"function-value":{fontStyle:"italic"},integer:{display:"inline-block",color:t.dataTypes.integer},string:{display:"inline-block",color:t.dataTypes.string},nan:{display:"inline-block",color:t.dataTypes.nan,fontSize:s.default.nanFontSize,fontWeight:s.default.nanFontWeight,backgroundColor:t.dataTypes.background,padding:s.default.nanPadding,borderRadius:s.default.nanBorderRadius},null:{display:"inline-block",color:t.dataTypes.null,fontSize:s.default.nullFontSize,fontWeight:s.default.nullFontWeight,backgroundColor:t.dataTypes.background,padding:s.default.nullPadding,borderRadius:s.default.nullBorderRadius},undefined:{display:"inline-block",color:t.dataTypes.undefined,fontSize:s.default.undefinedFontSize,padding:s.default.undefinedPadding,borderRadius:s.default.undefinedBorderRadius,backgroundColor:t.dataTypes.background},regexp:{display:"inline-block",color:t.dataTypes.regexp},"copy-to-clipboard":{cursor:s.default.clipboardCursor},"copy-icon":{color:t.copyToClipboard,fontSize:s.default.iconFontSize,marginRight:s.default.iconMarginRight,verticalAlign:"top"},"copy-icon-copied":{color:t.copyToClipboardCheck,marginLeft:s.default.clipboardCheckMarginLeft},"array-group-meta-data":{display:"inline-block",padding:s.default.arrayGroupMetaPadding},"object-meta-data":{display:"inline-block",padding:s.default.metaDataPadding},"icon-container":{display:"inline-block",width:s.default.iconContainerWidth},tooltip:{padding:s.default.tooltipPadding},removeVarIcon:{verticalAlign:"top",display:"inline-block",color:t.editVariable.removeIcon,cursor:s.default.iconCursor,fontSize:s.default.iconFontSize,marginRight:s.default.iconMarginRight},addVarIcon:{verticalAlign:"top",display:"inline-block",color:t.editVariable.addIcon,cursor:s.default.iconCursor,fontSize:s.default.iconFontSize,marginRight:s.default.iconMarginRight},editVarIcon:{verticalAlign:"top",display:"inline-block",color:t.editVariable.editIcon,cursor:s.default.iconCursor,fontSize:s.default.iconFontSize,marginRight:s.default.iconMarginRight},"edit-icon-container":{display:"inline-block",verticalAlign:"top"},"check-icon":{display:"inline-block",cursor:s.default.iconCursor,color:t.editVariable.checkIcon,fontSize:s.default.iconFontSize,paddingRight:s.default.iconPaddingRight},"cancel-icon":{display:"inline-block",cursor:s.default.iconCursor,color:t.editVariable.cancelIcon,fontSize:s.default.iconFontSize,paddingRight:s.default.iconPaddingRight},"edit-input":{display:"inline-block",minHeight:s.default.editInputHeight,minWidth:s.default.editInputMinWidth,borderRadius:s.default.editInputBorderRadius,backgroundColor:t.editVariable.background,color:t.editVariable.color,padding:s.default.editInputPadding,marginRight:s.default.editInputMarginRight,fontFamily:s.default.editInputFontFamily},"detected-row":{paddingTop:s.default.detectedRowPaddingTop},"key-modal-request":{position:s.default.addKeyCoverPosition,top:s.default.addKeyCoverPositionPx,left:s.default.addKeyCoverPositionPx,right:s.default.addKeyCoverPositionPx,bottom:s.default.addKeyCoverPositionPx,backgroundColor:s.default.addKeyCoverBackground},"key-modal":{width:s.default.addKeyModalWidth,backgroundColor:t.addKeyModal.background,marginLeft:s.default.addKeyModalMargin,marginRight:s.default.addKeyModalMargin,padding:s.default.addKeyModalPadding,borderRadius:s.default.addKeyModalRadius,marginTop:"15px",position:"relative"},"key-modal-label":{color:t.addKeyModal.labelColor,marginLeft:"2px",marginBottom:"5px",fontSize:"11px"},"key-modal-input-container":{overflow:"hidden"},"key-modal-input":{width:"100%",padding:"3px 6px",fontFamily:"monospace",color:t.addKeyModal.color,border:"none",boxSizing:"border-box",borderRadius:"2px"},"key-modal-cancel":{backgroundColor:t.editVariable.removeIcon,position:"absolute",top:"0px",right:"0px",borderRadius:"0px 3px 0px 3px",cursor:"pointer"},"key-modal-cancel-icon":{color:t.addKeyModal.labelColor,fontSize:s.default.iconFontSize,transform:"rotate(45deg)"},"key-modal-submit":{color:t.editVariable.addIcon,fontSize:s.default.iconFontSize,position:"absolute",right:"2px",top:"3px",cursor:"pointer"},"function-ellipsis":{display:"inline-block",color:t.ellipsisColor,fontSize:s.default.ellipsisFontSize,lineHeight:s.default.ellipsisLineHeight,cursor:s.default.ellipsisCursor},"validation-failure":{float:"right",padding:"3px 6px",borderRadius:"2px",cursor:"pointer",color:t.validationFailure.fontColor,backgroundColor:t.validationFailure.background},"validation-failure-label":{marginRight:"6px"},"validation-failure-clear":{position:"relative",verticalAlign:"top",cursor:"pointer",color:t.validationFailure.iconColor,fontSize:s.default.iconFontSize,transform:"rotate(45deg)"}}},f=function(e){var t=o.rjv_default;return!1!==e&&"none"!==e||(t=o.rjv_grey),(0,u.createStyling)(c,{defaultBase16:t})(e)}},function(e,t){var n=e.exports={version:"2.5.7"};"number"==typeof __e&&(__e=n)},function(e,t,n){var r=n(32)("wks"),a=n(23),o=n(5).Symbol,i="function"==typeof o;(e.exports=function(e){return r[e]||(r[e]=i&&o[e]||(i?o:a)("Symbol."+e))}).store=r},function(e,t,n){"use strict";function r(e){var t=a(e);return"number"===t&&(t=isNaN(e)?"nan":(0|e)!=e?"float":"integer"),t}function a(e){return{}.toString.call(e).match(/\s([a-zA-Z]+)/)[1].toLowerCase()}function o(e){var t=["base00","base01","base02","base03","base04","base05","base06","base07","base08","base09","base0A","base0B","base0C","base0D","base0E","base0F"];if("object"===r(e)){for(var n=0;n<t.length;n++)if(!(t[n]in e))return!1;return!0}return!1}Object.defineProperty(t,"__esModule",{value:!0}),t.toType=r,t.isTheme=o},function(e,t){var n=e.exports="undefined"!=typeof window&&window.Math==Math?window:"undefined"!=typeof self&&self.Math==Math?self:Function("return this")();"number"==typeof __g&&(__g=n)},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function a(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function o(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function i(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var s=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},u=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),l=n(0),c=r(l),f=n(1),d=r(f),p=function(e){function t(){return a(this,t),o(this,(t.__proto__||Object.getPrototypeOf(t)).apply(this,arguments))}return i(t,e),u(t,[{key:"render",value:function(){var e=this.props,t=(e.rjvId,e.type_name),n=e.displayDataTypes,r=e.theme;return n?c.default.createElement("span",s({className:"data-type-label"},(0,d.default)(r,"data-type-label")),t):null}}]),t}(c.default.PureComponent);t.default=p},function(e,t){var n={}.hasOwnProperty;e.exports=function(e,t){return n.call(e,t)}},function(e,t,n){var r=n(9),a=n(22);e.exports=n(10)?function(e,t,n){return r.f(e,t,a(1,n))}:function(e,t,n){return e[t]=n,e}},function(e,t,n){var r=n(16),a=n(44),o=n(29),i=Object.defineProperty;t.f=n(10)?Object.defineProperty:function(e,t,n){if(r(e),t=o(t,!0),r(n),a)try{return i(e,t,n)}catch(e){}if("get"in n||"set"in n)throw TypeError("Accessors not supported!");return"value"in n&&(e[t]=n.value),e}},function(e,t,n){e.exports=!n(11)(function(){return 7!=Object.defineProperty({},"a",{get:function(){return 7}}).a})},function(e,t){e.exports=function(e){try{return!!e()}catch(e){return!0}}},function(e,t,n){var r=n(49),a=n(28);e.exports=function(e){return r(a(e))}},function(e,t,n){"use strict";function r(e){if(Array.isArray(e)){for(var t=0,n=Array(e.length);t<e.length;t++)n[t]=e[t];return n}return Array.from(e)}function a(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function o(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function i(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var s=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},u=n(161),l=n(14),c=function(e){return e&&e.__esModule?e:{default:e}}(l),f=n(4),d=function(e){function t(){var e,n,i,u;a(this,t);for(var l=arguments.length,c=Array(l),d=0;d<l;d++)c[d]=arguments[d];return n=i=o(this,(e=t.__proto__||Object.getPrototypeOf(t)).call.apply(e,[this].concat(c))),i.objects={},i.set=function(e,t,n,r){void 0===i.objects[e]&&(i.objects[e]={}),void 0===i.objects[e][t]&&(i.objects[e][t]={}),i.objects[e][t][n]=r},i.get=function(e,t,n,r){return void 0===i.objects[e]||void 0===i.objects[e][t]||void 0==i.objects[e][t][n]?r:i.objects[e][t][n]},i.handleAction=function(e){var t=e.rjvId,n=e.data;switch(e.name){case"RESET":i.emit("reset-"+t);break;case"VARIABLE_UPDATED":e.data.updated_src=i.updateSrc(t,n),i.set(t,"action","variable-update",s({},n,{type:"variable-edited"})),i.emit("variable-update-"+t);break;case"VARIABLE_REMOVED":e.data.updated_src=i.updateSrc(t,n),i.set(t,"action","variable-update",s({},n,{type:"variable-removed"})),i.emit("variable-update-"+t);break;case"VARIABLE_ADDED":e.data.updated_src=i.updateSrc(t,n),i.set(t,"action","variable-update",s({},n,{type:"variable-added"})),i.emit("variable-update-"+t);break;case"ADD_VARIABLE_KEY_REQUEST":i.set(t,"action","new-key-request",n),i.emit("add-key-request-"+t)}},i.updateSrc=function(e,t){var n=t.name,a=t.namespace,o=t.new_value,s=(t.existing_value,t.variable_removed);a.shift();var u=i.get(e,"global","src"),l=i.deepCopy(u,[].concat(r(a))),c=l,d=!0,p=!1,b=void 0;try{for(var h,y=a[Symbol.iterator]();!(d=(h=y.next()).done);d=!0)c=c[h.value]}catch(e){p=!0,b=e}finally{try{!d&&y.return&&y.return()}finally{if(p)throw b}}return s?"array"==(0,f.toType)(c)?c.splice(n,1):delete c[n]:null!==n?c[n]=o:l=o,i.set(e,"global","src",l),l},i.deepCopy=function(e,t){var n=(0,f.toType)(e),a=void 0,o=t.shift();return"array"==n?a=[].concat(r(e)):"object"==n&&(a=s({},e)),void 0!==o&&(a[o]=i.deepCopy(e[o],t)),a},u=n,o(i,u)}return i(t,e),t}(u.EventEmitter),p=new d;c.default.register(p.handleAction.bind(p)),t.default=p},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var r=n(162),a=new r.Dispatcher;t.default=a},function(e,t,n){"use strict";function r(e,t){var n={};for(var r in e)t.indexOf(r)>=0||Object.prototype.hasOwnProperty.call(e,r)&&(n[r]=e[r]);return n}function a(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function o(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function i(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}function s(e){return e||(e={}),{style:u({verticalAlign:"middle"},e,{color:e.color?e.color:d,height:"1em",width:"1em"})}}Object.defineProperty(t,"__esModule",{value:!0}),t.CheckCircle=t.Edit=t.Add=t.AddCircle=t.RemoveCircle=t.Clippy=t.ArrowDown=t.ArrowRight=t.SquarePlus=t.SquareMinus=t.CirclePlus=t.CircleMinus=void 0;var u=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},l=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),c=n(0),f=function(e){return e&&e.__esModule?e:{default:e}}(c),d="#000000";t.CircleMinus=function(e){function t(){return a(this,t),o(this,(t.__proto__||Object.getPrototypeOf(t)).apply(this,arguments))}return i(t,e),l(t,[{key:"render",value:function(){var e=this.props,t=e.style,n=r(e,["style"]);return f.default.createElement("span",n,f.default.createElement("svg",u({},s(t),{viewBox:"0 0 24 24",fill:"currentColor",preserveAspectRatio:"xMidYMid meet"}),f.default.createElement("path",{d:"M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20,12C20,16.41 16.41,20 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M7,13H17V11H7"})))}}]),t}(f.default.PureComponent),t.CirclePlus=function(e){function t(){return a(this,t),o(this,(t.__proto__||Object.getPrototypeOf(t)).apply(this,arguments))}return i(t,e),l(t,[{key:"render",value:function(){var e=this.props,t=e.style,n=r(e,["style"]);return f.default.createElement("span",n,f.default.createElement("svg",u({},s(t),{viewBox:"0 0 24 24",fill:"currentColor",preserveAspectRatio:"xMidYMid meet"}),f.default.createElement("path",{d:"M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20,12C20,16.41 16.41,20 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M13,7H11V11H7V13H11V17H13V13H17V11H13V7Z"})))}}]),t}(f.default.PureComponent),t.SquareMinus=function(e){function t(){return a(this,t),o(this,(t.__proto__||Object.getPrototypeOf(t)).apply(this,arguments))}return i(t,e),l(t,[{key:"render",value:function(){var e=this.props,t=e.style,n=r(e,["style"]),a=s(t).style;return f.default.createElement("span",n,f.default.createElement("svg",{fill:a.color,width:a.height,height:a.width,style:a,viewBox:"0 0 1792 1792"},f.default.createElement("path",{d:"M1344 800v64q0 14-9 23t-23 9h-832q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h832q14 0 23 9t9 23zm128 448v-832q0-66-47-113t-113-47h-832q-66 0-113 47t-47 113v832q0 66 47 113t113 47h832q66 0 113-47t47-113zm128-832v832q0 119-84.5 203.5t-203.5 84.5h-832q-119 0-203.5-84.5t-84.5-203.5v-832q0-119 84.5-203.5t203.5-84.5h832q119 0 203.5 84.5t84.5 203.5z"})))}}]),t}(f.default.PureComponent),t.SquarePlus=function(e){function t(){return a(this,t),o(this,(t.__proto__||Object.getPrototypeOf(t)).apply(this,arguments))}return i(t,e),l(t,[{key:"render",value:function(){var e=this.props,t=e.style,n=r(e,["style"]),a=s(t).style;return f.default.createElement("span",n,f.default.createElement("svg",{fill:a.color,width:a.height,height:a.width,style:a,viewBox:"0 0 1792 1792"},f.default.createElement("path",{d:"M1344 800v64q0 14-9 23t-23 9h-352v352q0 14-9 23t-23 9h-64q-14 0-23-9t-9-23v-352h-352q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h352v-352q0-14 9-23t23-9h64q14 0 23 9t9 23v352h352q14 0 23 9t9 23zm128 448v-832q0-66-47-113t-113-47h-832q-66 0-113 47t-47 113v832q0 66 47 113t113 47h832q66 0 113-47t47-113zm128-832v832q0 119-84.5 203.5t-203.5 84.5h-832q-119 0-203.5-84.5t-84.5-203.5v-832q0-119 84.5-203.5t203.5-84.5h832q119 0 203.5 84.5t84.5 203.5z"})))}}]),t}(f.default.PureComponent),t.ArrowRight=function(e){function t(){return a(this,t),o(this,(t.__proto__||Object.getPrototypeOf(t)).apply(this,arguments))}return i(t,e),l(t,[{key:"render",value:function(){var e=this.props,t=e.style,n=r(e,["style"]);return f.default.createElement("span",n,f.default.createElement("svg",{style:u({},s(t).style,{paddingLeft:"2px",verticalAlign:"top"}),viewBox:"0 0 15 15",fill:"currentColor"},f.default.createElement("path",{d:"M0 14l6-6-6-6z"})))}}]),t}(f.default.PureComponent),t.ArrowDown=function(e){function t(){return a(this,t),o(this,(t.__proto__||Object.getPrototypeOf(t)).apply(this,arguments))}return i(t,e),l(t,[{key:"render",value:function(){var e=this.props,t=e.style,n=r(e,["style"]);return f.default.createElement("span",n,f.default.createElement("svg",{style:u({},s(t).style,{paddingLeft:"2px",verticalAlign:"top"}),viewBox:"0 0 15 15",fill:"currentColor"},f.default.createElement("path",{d:"M0 5l6 6 6-6z"})))}}]),t}(f.default.PureComponent),t.Clippy=function(e){function t(){return a(this,t),o(this,(t.__proto__||Object.getPrototypeOf(t)).apply(this,arguments))}return i(t,e),l(t,[{key:"render",value:function(){var e=this.props,t=e.style,n=r(e,["style"]);return f.default.createElement("span",n,f.default.createElement("svg",u({},s(t),{viewBox:"0 0 40 40",fill:"currentColor",preserveAspectRatio:"xMidYMid meet"}),f.default.createElement("g",null,f.default.createElement("path",{d:"m30 35h-25v-22.5h25v7.5h2.5v-12.5c0-1.4-1.1-2.5-2.5-2.5h-7.5c0-2.8-2.2-5-5-5s-5 2.2-5 5h-7.5c-1.4 0-2.5 1.1-2.5 2.5v27.5c0 1.4 1.1 2.5 2.5 2.5h25c1.4 0 2.5-1.1 2.5-2.5v-5h-2.5v5z m-20-27.5h2.5s2.5-1.1 2.5-2.5 1.1-2.5 2.5-2.5 2.5 1.1 2.5 2.5 1.3 2.5 2.5 2.5h2.5s2.5 1.1 2.5 2.5h-20c0-1.5 1.1-2.5 2.5-2.5z m-2.5 20h5v-2.5h-5v2.5z m17.5-5v-5l-10 7.5 10 7.5v-5h12.5v-5h-12.5z m-17.5 10h7.5v-2.5h-7.5v2.5z m12.5-17.5h-12.5v2.5h12.5v-2.5z m-7.5 5h-5v2.5h5v-2.5z"}))))}}]),t}(f.default.PureComponent),t.RemoveCircle=function(e){function t(){return a(this,t),o(this,(t.__proto__||Object.getPrototypeOf(t)).apply(this,arguments))}return i(t,e),l(t,[{key:"render",value:function(){var e=this.props,t=e.style,n=r(e,["style"]);return f.default.createElement("span",n,f.default.createElement("svg",u({},s(t),{viewBox:"0 0 40 40",fill:"currentColor",preserveAspectRatio:"xMidYMid meet"}),f.default.createElement("g",null,f.default.createElement("path",{d:"m28.6 25q0-0.5-0.4-1l-4-4 4-4q0.4-0.5 0.4-1 0-0.6-0.4-1.1l-2-2q-0.4-0.4-1-0.4-0.6 0-1 0.4l-4.1 4.1-4-4.1q-0.4-0.4-1-0.4-0.6 0-1 0.4l-2 2q-0.5 0.5-0.5 1.1 0 0.5 0.5 1l4 4-4 4q-0.5 0.5-0.5 1 0 0.7 0.5 1.1l2 2q0.4 0.4 1 0.4 0.6 0 1-0.4l4-4.1 4.1 4.1q0.4 0.4 1 0.4 0.6 0 1-0.4l2-2q0.4-0.4 0.4-1z m8.7-5q0 4.7-2.3 8.6t-6.3 6.2-8.6 2.3-8.6-2.3-6.2-6.2-2.3-8.6 2.3-8.6 6.2-6.2 8.6-2.3 8.6 2.3 6.3 6.2 2.3 8.6z"}))))}}]),t}(f.default.PureComponent),t.AddCircle=function(e){function t(){return a(this,t),o(this,(t.__proto__||Object.getPrototypeOf(t)).apply(this,arguments))}return i(t,e),l(t,[{key:"render",value:function(){var e=this.props,t=e.style,n=r(e,["style"]);return f.default.createElement("span",n,f.default.createElement("svg",u({},s(t),{viewBox:"0 0 40 40",fill:"currentColor",preserveAspectRatio:"xMidYMid meet"}),f.default.createElement("g",null,f.default.createElement("path",{d:"m30.1 21.4v-2.8q0-0.6-0.4-1t-1-0.5h-5.7v-5.7q0-0.6-0.4-1t-1-0.4h-2.9q-0.6 0-1 0.4t-0.4 1v5.7h-5.7q-0.6 0-1 0.5t-0.5 1v2.8q0 0.6 0.5 1t1 0.5h5.7v5.7q0 0.5 0.4 1t1 0.4h2.9q0.6 0 1-0.4t0.4-1v-5.7h5.7q0.6 0 1-0.5t0.4-1z m7.2-1.4q0 4.7-2.3 8.6t-6.3 6.2-8.6 2.3-8.6-2.3-6.2-6.2-2.3-8.6 2.3-8.6 6.2-6.2 8.6-2.3 8.6 2.3 6.3 6.2 2.3 8.6z"}))))}}]),t}(f.default.PureComponent),t.Add=function(e){function t(){return a(this,t),o(this,(t.__proto__||Object.getPrototypeOf(t)).apply(this,arguments))}return i(t,e),l(t,[{key:"render",value:function(){var e=this.props,t=e.style,n=r(e,["style"]);return f.default.createElement("span",n,f.default.createElement("svg",u({},s(t),{viewBox:"0 0 40 40",fill:"currentColor",preserveAspectRatio:"xMidYMid meet"}),f.default.createElement("g",null,f.default.createElement("path",{d:"m31.6 21.6h-10v10h-3.2v-10h-10v-3.2h10v-10h3.2v10h10v3.2z"}))))}}]),t}(f.default.PureComponent),t.Edit=function(e){function t(){return a(this,t),o(this,(t.__proto__||Object.getPrototypeOf(t)).apply(this,arguments))}return i(t,e),l(t,[{key:"render",value:function(){var e=this.props,t=e.style,n=r(e,["style"]);return f.default.createElement("span",n,f.default.createElement("svg",u({},s(t),{viewBox:"0 0 40 40",fill:"currentColor",preserveAspectRatio:"xMidYMid meet"}),f.default.createElement("g",null,f.default.createElement("path",{d:"m19.8 26.4l2.6-2.6-3.4-3.4-2.6 2.6v1.3h2.2v2.1h1.2z m9.8-16q-0.3-0.4-0.7 0l-7.8 7.8q-0.4 0.4 0 0.7t0.7 0l7.8-7.8q0.4-0.4 0-0.7z m1.8 13.2v4.3q0 2.6-1.9 4.5t-4.5 1.9h-18.6q-2.6 0-4.5-1.9t-1.9-4.5v-18.6q0-2.7 1.9-4.6t4.5-1.8h18.6q1.4 0 2.6 0.5 0.3 0.2 0.4 0.5 0.1 0.4-0.2 0.7l-1.1 1.1q-0.3 0.3-0.7 0.1-0.5-0.1-1-0.1h-18.6q-1.4 0-2.5 1.1t-1 2.5v18.6q0 1.4 1 2.5t2.5 1h18.6q1.5 0 2.5-1t1.1-2.5v-2.9q0-0.2 0.2-0.4l1.4-1.5q0.3-0.3 0.8-0.1t0.4 0.6z m-2.1-16.5l6.4 6.5-15 15h-6.4v-6.5z m9.9 3l-2.1 2-6.4-6.4 2.1-2q0.6-0.7 1.5-0.7t1.5 0.7l3.4 3.4q0.6 0.6 0.6 1.5t-0.6 1.5z"}))))}}]),t}(f.default.PureComponent),t.CheckCircle=function(e){function t(){return a(this,t),o(this,(t.__proto__||Object.getPrototypeOf(t)).apply(this,arguments))}return i(t,e),l(t,[{key:"render",value:function(){var e=this.props,t=e.style,n=r(e,["style"]);return f.default.createElement("span",n,f.default.createElement("svg",u({},s(t),{viewBox:"0 0 40 40",fill:"currentColor",preserveAspectRatio:"xMidYMid meet"}),f.default.createElement("g",null,f.default.createElement("path",{d:"m31.7 16.4q0-0.6-0.4-1l-2.1-2.1q-0.4-0.4-1-0.4t-1 0.4l-9.1 9.1-5-5q-0.5-0.4-1-0.4t-1 0.4l-2.1 2q-0.4 0.4-0.4 1 0 0.6 0.4 1l8.1 8.1q0.4 0.4 1 0.4 0.6 0 1-0.4l12.2-12.1q0.4-0.4 0.4-1z m5.6 3.6q0 4.7-2.3 8.6t-6.3 6.2-8.6 2.3-8.6-2.3-6.2-6.2-2.3-8.6 2.3-8.6 6.2-6.2 8.6-2.3 8.6 2.3 6.3 6.2 2.3 8.6z"}))))}}]),t}(f.default.PureComponent)},function(e,t,n){var r=n(17);e.exports=function(e){if(!r(e))throw TypeError(e+" is not an object!");return e}},function(e,t){e.exports=function(e){return"object"==typeof e?null!==e:"function"==typeof e}},function(e,t){e.exports={}},function(e,t,n){var r=n(48),a=n(33);e.exports=Object.keys||function(e){return r(e,a)}},function(e,t){e.exports=!0},function(e,t,n){var r=n(5),a=n(2),o=n(71),i=n(8),s=n(7),u=function(e,t,n){var l,c,f,d=e&u.F,p=e&u.G,b=e&u.S,h=e&u.P,y=e&u.B,v=e&u.W,m=p?a:a[t]||(a[t]={}),g=m.prototype,_=p?r:b?r[t]:(r[t]||{}).prototype;p&&(n=t);for(l in n)(c=!d&&_&&void 0!==_[l])&&s(m,l)||(f=c?_[l]:n[l],m[l]=p&&"function"!=typeof _[l]?n[l]:y&&c?o(f,r):v&&_[l]==f?function(e){var t=function(t,n,r){if(this instanceof e){switch(arguments.length){case 0:return new e;case 1:return new e(t);case 2:return new e(t,n)}return new e(t,n,r)}return e.apply(this,arguments)};return t.prototype=e.prototype,t}(f):h&&"function"==typeof f?o(Function.call,f):f,h&&((m.virtual||(m.virtual={}))[l]=f,e&u.R&&g&&!g[l]&&i(g,l,f)))};u.F=1,u.G=2,u.S=4,u.P=8,u.B=16,u.W=32,u.U=64,u.R=128,e.exports=u},function(e,t){e.exports=function(e,t){return{enumerable:!(1&e),configurable:!(2&e),writable:!(4&e),value:t}}},function(e,t){var n=0,r=Math.random();e.exports=function(e){return"Symbol(".concat(void 0===e?"":e,")_",(++n+r).toString(36))}},function(e,t){t.f={}.propertyIsEnumerable},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function a(e,t){var n={};for(var r in e)t.indexOf(r)>=0||Object.prototype.hasOwnProperty.call(e,r)&&(n[r]=e[r]);return n}function o(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function i(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function s(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var u=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},l=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),c=n(0),f=r(c),d=n(41),p=n(4),b=n(42),h=n(171),y=r(h),v=n(56),m=r(v),g=n(57),_=r(g),j=n(58),O=r(j),E=n(13),w=r(E),x=n(59),C=n(1),k=r(C),P=function(e){function t(e){o(this,t);var n=i(this,(t.__proto__||Object.getPrototypeOf(t)).call(this,e));S.call(n);var r=t.getState(e);return n.state=u({},r,{prevProps:{}}),n}return s(t,e),l(t,[{key:"getBraceStart",value:function(e,t){var n=this,r=this.props,a=r.src,o=r.theme,i=r.iconStyle;if("array_group"===r.parent_type)return f.default.createElement("span",null,f.default.createElement("span",(0,k.default)(o,"brace"),"array"===e?"[":"{"),t?this.getObjectMetaData(a):null);var s=t?x.ExpandedIcon:x.CollapsedIcon;return f.default.createElement("span",null,f.default.createElement("span",u({onClick:function(e){n.toggleCollapsed()}},(0,k.default)(o,"brace-row")),f.default.createElement("div",u({className:"icon-container"},(0,k.default)(o,"icon-container")),f.default.createElement(s,{theme:o,iconStyle:i})),f.default.createElement(O.default,this.props),f.default.createElement("span",(0,k.default)(o,"brace"),"array"===e?"[":"{")),t?this.getObjectMetaData(a):null)}},{key:"render",value:function(){var e=this.props,t=e.depth,n=e.src,r=(e.namespace,e.name,e.type,e.parent_type),o=e.theme,i=e.jsvRoot,s=e.iconStyle,l=a(e,["depth","src","namespace","name","type","parent_type","theme","jsvRoot","iconStyle"]),c=this.state,d=c.object_type,p=c.expanded,b={};return i||"array_group"===r?"array_group"===r&&(b.borderLeft=0,b.display="inline"):b.paddingLeft=5*this.props.indentWidth,f.default.createElement("div",u({className:"object-key-val"},(0,k.default)(o,i?"jsv-root":"objectKeyVal",b)),this.getBraceStart(d,p),p?this.getObjectContent(t,n,u({theme:o,iconStyle:s},l)):this.getEllipsis(),f.default.createElement("span",{className:"brace-row"},f.default.createElement("span",{style:u({},(0,k.default)(o,"brace").style,{paddingLeft:p?"3px":"0px"})},"array"===d?"]":"}"),p?null:this.getObjectMetaData(n)))}}],[{key:"getDerivedStateFromProps",value:function(e,n){var r=n.prevProps;if(e.src!==r.src||e.collapsed!==r.collapsed||e.name!==r.name||e.namespace!==r.namespace||e.rjvId!==r.rjvId){var a=t.getState(e);return u({},a,{prevProps:e})}return null}}]),t}(f.default.PureComponent);P.getState=function(e){var t=Object.keys(e.src).length,n=(!1===e.collapsed||!0!==e.collapsed&&e.collapsed>e.depth)&&(!e.shouldCollapse||!1===e.shouldCollapse({name:e.name,src:e.src,type:(0,p.toType)(e.src),namespace:e.namespace}))&&0!==t;return{expanded:w.default.get(e.rjvId,e.namespace,"expanded",n),object_type:"array"===e.type?"array":"object",parent_type:"array"===e.type?"array":"object",size:t}};var S=function(){var e=this;this.toggleCollapsed=function(){e.setState({expanded:!e.state.expanded},function(){w.default.set(e.props.rjvId,e.props.namespace,"expanded",e.state.expanded)})},this.getObjectContent=function(t,n,r){return f.default.createElement("div",{className:"pushed-content object-container"},f.default.createElement("div",u({className:"object-content"},(0,k.default)(e.props.theme,"pushed-content")),e.renderObjectContents(n,r)))},this.getEllipsis=function(){return 0===e.state.size?null:f.default.createElement("div",u({},(0,k.default)(e.props.theme,"ellipsis"),{className:"node-ellipsis",onClick:e.toggleCollapsed}),"...")},this.getObjectMetaData=function(t){var n=e.props,r=(n.rjvId,n.theme,e.state.size);return f.default.createElement(m.default,u({size:r},e.props))},this.renderObjectContents=function(t,n){var r=e.props,a=r.depth,o=r.parent_type,i=r.index_offset,s=r.groupArraysAfterLength,l=r.namespace,c=e.state.object_type,d=(n.theme,[]),p=void 0,h=Object.keys(t||{});return e.props.sortKeys&&(h=h.sort()),h.forEach(function(r){if(p=new M(r,t[r]),"array_group"===o&&i&&(p.name=parseInt(p.name)+i),t.hasOwnProperty(r))if("object"===p.type)d.push(f.default.createElement(b.JsonObject,u({key:p.name,depth:a+1,name:p.name,src:p.value,namespace:l.concat(p.name),parent_type:c},n)));else if("array"===p.type){var h=b.JsonObject;s&&p.value.length>s&&(h=_.default),d.push(f.default.createElement(h,u({key:p.name,depth:a+1,name:p.name,src:p.value,namespace:l.concat(p.name),type:"array",parent_type:c},n)))}else d.push(f.default.createElement(y.default,u({key:p.name+"_"+l,variable:p,singleIndent:5,namespace:l,type:e.props.type},n)))}),d}},M=function e(t,n){o(this,e),this.name=t,this.value=n,this.type=(0,p.toType)(n)};(0,d.polyfill)(P),t.default=P},function(e,t,n){"use strict";var r=n(70)(!0);n(43)(String,"String",function(e){this._t=String(e),this._i=0},function(){var e,t=this._t,n=this._i;return n>=t.length?{value:void 0,done:!0}:(e=r(t,n),this._i+=e.length,{value:e,done:!1})})},function(e,t){var n=Math.ceil,r=Math.floor;e.exports=function(e){return isNaN(e=+e)?0:(e>0?r:n)(e)}},function(e,t){e.exports=function(e){if(void 0==e)throw TypeError("Can't call method on  "+e);return e}},function(e,t,n){var r=n(17);e.exports=function(e,t){if(!r(e))return e;var n,a;if(t&&"function"==typeof(n=e.toString)&&!r(a=n.call(e)))return a;if("function"==typeof(n=e.valueOf)&&!r(a=n.call(e)))return a;if(!t&&"function"==typeof(n=e.toString)&&!r(a=n.call(e)))return a;throw TypeError("Can't convert object to primitive value")}},function(e,t){var n={}.toString;e.exports=function(e){return n.call(e).slice(8,-1)}},function(e,t,n){var r=n(32)("keys"),a=n(23);e.exports=function(e){return r[e]||(r[e]=a(e))}},function(e,t,n){var r=n(2),a=n(5),o=a["__core-js_shared__"]||(a["__core-js_shared__"]={});(e.exports=function(e,t){return o[e]||(o[e]=void 0!==t?t:{})})("versions",[]).push({version:r.version,mode:n(20)?"pure":"global",copyright:"© 2018 Denis Pushkarev (zloirock.ru)"})},function(e,t){e.exports="constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf".split(",")},function(e,t,n){var r=n(9).f,a=n(7),o=n(3)("toStringTag");e.exports=function(e,t,n){e&&!a(e=n?e:e.prototype,o)&&r(e,o,{configurable:!0,value:t})}},function(e,t,n){var r=n(28);e.exports=function(e){return Object(r(e))}},function(e,t,n){n(80);for(var r=n(5),a=n(8),o=n(18),i=n(3)("toStringTag"),s="CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,TextTrackList,TouchList".split(","),u=0;u<s.length;u++){var l=s[u],c=r[l],f=c&&c.prototype;f&&!f[i]&&a(f,i,l),o[l]=o.Array}},function(e,t,n){t.f=n(3)},function(e,t,n){var r=n(5),a=n(2),o=n(20),i=n(37),s=n(9).f;e.exports=function(e){var t=a.Symbol||(a.Symbol=o?{}:r.Symbol||{});"_"==e.charAt(0)||e in t||s(t,e,{value:i.f(e)})}},function(e,t){t.f=Object.getOwnPropertySymbols},function(e,t){function n(e,t,n){return Math.min(Math.max(e,t),n)}e.exports=n},function(e,t,n){"use strict";function r(){var e=this.constructor.getDerivedStateFromProps(this.props,this.state);null!==e&&void 0!==e&&this.setState(e)}function a(e){function t(t){var n=this.constructor.getDerivedStateFromProps(e,t);return null!==n&&void 0!==n?n:null}this.setState(t.bind(this))}function o(e,t){try{var n=this.props,r=this.state;this.props=e,this.state=t,this.__reactInternalSnapshotFlag=!0,this.__reactInternalSnapshot=this.getSnapshotBeforeUpdate(n,r)}finally{this.props=n,this.state=r}}function i(e){var t=e.prototype;if(!t||!t.isReactComponent)throw new Error("Can only polyfill class components");if("function"!=typeof e.getDerivedStateFromProps&&"function"!=typeof t.getSnapshotBeforeUpdate)return e;var n=null,i=null,s=null;if("function"==typeof t.componentWillMount?n="componentWillMount":"function"==typeof t.UNSAFE_componentWillMount&&(n="UNSAFE_componentWillMount"),"function"==typeof t.componentWillReceiveProps?i="componentWillReceiveProps":"function"==typeof t.UNSAFE_componentWillReceiveProps&&(i="UNSAFE_componentWillReceiveProps"),"function"==typeof t.componentWillUpdate?s="componentWillUpdate":"function"==typeof t.UNSAFE_componentWillUpdate&&(s="UNSAFE_componentWillUpdate"),null!==n||null!==i||null!==s){var u=e.displayName||e.name,l="function"==typeof e.getDerivedStateFromProps?"getDerivedStateFromProps()":"getSnapshotBeforeUpdate()";throw Error("Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n"+u+" uses "+l+" but also contains the following legacy lifecycles:"+(null!==n?"\n  "+n:"")+(null!==i?"\n  "+i:"")+(null!==s?"\n  "+s:"")+"\n\nThe above lifecycles should be removed. Learn more about this warning here:\nhttps://fb.me/react-async-component-lifecycle-hooks")}if("function"==typeof e.getDerivedStateFromProps&&(t.componentWillMount=r,t.componentWillReceiveProps=a),"function"==typeof t.getSnapshotBeforeUpdate){if("function"!=typeof t.componentDidUpdate)throw new Error("Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype");t.componentWillUpdate=o;var c=t.componentDidUpdate;t.componentDidUpdate=function(e,t,n){var r=this.__reactInternalSnapshotFlag?this.__reactInternalSnapshot:n;c.call(this,e,t,r)}}return e}Object.defineProperty(t,"__esModule",{value:!0}),n.d(t,"polyfill",function(){return i}),r.__suppressDeprecationWarning=!0,a.__suppressDeprecationWarning=!0,o.__suppressDeprecationWarning=!0},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var a=n(63);Object.defineProperty(t,"JsonBoolean",{enumerable:!0,get:function(){return r(a).default}});var o=n(158);Object.defineProperty(t,"JsonDate",{enumerable:!0,get:function(){return r(o).default}});var i=n(159);Object.defineProperty(t,"JsonFloat",{enumerable:!0,get:function(){return r(i).default}});var s=n(160);Object.defineProperty(t,"JsonFunction",{enumerable:!0,get:function(){return r(s).default}});var u=n(165);Object.defineProperty(t,"JsonNan",{enumerable:!0,get:function(){return r(u).default}});var l=n(166);Object.defineProperty(t,"JsonNull",{enumerable:!0,get:function(){return r(l).default}});var c=n(167);Object.defineProperty(t,"JsonInteger",{enumerable:!0,get:function(){return r(c).default}});var f=n(25);Object.defineProperty(t,"JsonObject",{enumerable:!0,get:function(){return r(f).default}});var d=n(168);Object.defineProperty(t,"JsonRegexp",{enumerable:!0,get:function(){return r(d).default}});var p=n(169);Object.defineProperty(t,"JsonString",{enumerable:!0,get:function(){return r(p).default}});var b=n(170);Object.defineProperty(t,"JsonUndefined",{enumerable:!0,get:function(){return r(b).default}})},function(e,t,n){"use strict";var r=n(20),a=n(21),o=n(46),i=n(8),s=n(18),u=n(73),l=n(34),c=n(79),f=n(3)("iterator"),d=!([].keys&&"next"in[].keys()),p=function(){return this};e.exports=function(e,t,n,b,h,y,v){u(n,t,b);var m,g,_,j=function(e){if(!d&&e in x)return x[e];switch(e){case"keys":case"values":return function(){return new n(this,e)}}return function(){return new n(this,e)}},O=t+" Iterator",E="values"==h,w=!1,x=e.prototype,C=x[f]||x["@@iterator"]||h&&x[h],k=C||j(h),P=h?E?j("entries"):k:void 0,S="Array"==t?x.entries||C:C;if(S&&(_=c(S.call(new e)))!==Object.prototype&&_.next&&(l(_,O,!0),r||"function"==typeof _[f]||i(_,f,p)),E&&C&&"values"!==C.name&&(w=!0,k=function(){return C.call(this)}),r&&!v||!d&&!w&&x[f]||i(x,f,k),s[t]=k,s[O]=p,h)if(m={values:E?k:j("values"),keys:y?k:j("keys"),entries:P},v)for(g in m)g in x||o(x,g,m[g]);else a(a.P+a.F*(d||w),t,m);return m}},function(e,t,n){e.exports=!n(10)&&!n(11)(function(){return 7!=Object.defineProperty(n(45)("div"),"a",{get:function(){return 7}}).a})},function(e,t,n){var r=n(17),a=n(5).document,o=r(a)&&r(a.createElement);e.exports=function(e){return o?a.createElement(e):{}}},function(e,t,n){e.exports=n(8)},function(e,t,n){var r=n(16),a=n(74),o=n(33),i=n(31)("IE_PROTO"),s=function(){},u=function(){var e,t=n(45)("iframe"),r=o.length;for(t.style.display="none",n(78).appendChild(t),t.src="javascript:",e=t.contentWindow.document,e.open(),e.write("<script>document.F=Object<\/script>"),e.close(),u=e.F;r--;)delete u.prototype[o[r]];return u()};e.exports=Object.create||function(e,t){var n;return null!==e?(s.prototype=r(e),n=new s,s.prototype=null,n[i]=e):n=u(),void 0===t?n:a(n,t)}},function(e,t,n){var r=n(7),a=n(12),o=n(75)(!1),i=n(31)("IE_PROTO");e.exports=function(e,t){var n,s=a(e),u=0,l=[];for(n in s)n!=i&&r(s,n)&&l.push(n);for(;t.length>u;)r(s,n=t[u++])&&(~o(l,n)||l.push(n));return l}},function(e,t,n){var r=n(30);e.exports=Object("z").propertyIsEnumerable(0)?Object:function(e){return"String"==r(e)?e.split(""):Object(e)}},function(e,t,n){var r=n(48),a=n(33).concat("length","prototype");t.f=Object.getOwnPropertyNames||function(e){return r(e,a)}},function(e,t,n){var r=n(30),a=n(3)("toStringTag"),o="Arguments"==r(function(){return arguments}()),i=function(e,t){try{return e[t]}catch(e){}};e.exports=function(e){var t,n,s;return void 0===e?"Undefined":null===e?"Null":"string"==typeof(n=i(t=Object(e),a))?n:o?r(t):"Object"==(s=r(t))&&"function"==typeof t.callee?"Arguments":s}},function(e,t){var n;n=function(){return this}();try{n=n||Function("return this")()||(0,eval)("this")}catch(e){"object"==typeof window&&(n=window)}e.exports=n},function(e,t){function n(e){return e.match(r)}var r=/-?\d+(\.\d+)?%?/g;e.exports=n},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var r=n(4);t.default=function(e){var t=(0,r.toType)(e),n=void 0;switch(t){case"undefined":n="undefined";break;case"nan":n="NaN";break;case"string":n=e;break;case"date":case"function":case"regexp":n=e.toString();break;default:try{n=JSON.stringify(e,null,"  ")}catch(e){n=""}}return n}},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function a(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function o(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function i(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var s=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},u=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),l=n(0),c=r(l),f=n(4),d=n(54),p=(r(d),n(15)),b=n(1),h=r(b),y=function(e){function t(e){a(this,t);var n=o(this,(t.__proto__||Object.getPrototypeOf(t)).call(this,e));return n.copiedTimer=null,n.handleCopy=function(){var e=document.createElement("textarea"),t=n.props,r=t.clickCallback,a=t.src,o=t.namespace;e.innerHTML=JSON.stringify(n.clipboardValue(a),null,"  "),document.body.appendChild(e),e.select(),document.execCommand("copy"),document.body.removeChild(e),n.copiedTimer=setTimeout(function(){n.setState({copied:!1})},5500),n.setState({copied:!0},function(){"function"==typeof r&&r({src:a,namespace:o,name:o[o.length-1]})})},n.getClippyIcon=function(){var e=n.props.theme;return n.state.copied?c.default.createElement("span",null,c.default.createElement(p.Clippy,s({className:"copy-icon"},(0,h.default)(e,"copy-icon"))),c.default.createElement("span",(0,h.default)(e,"copy-icon-copied"),"✔")):c.default.createElement(p.Clippy,s({className:"copy-icon"},(0,h.default)(e,"copy-icon")))},n.clipboardValue=function(e){switch((0,f.toType)(e)){case"function":case"regexp":return e.toString();default:return e}},n.state={copied:!1},n}return i(t,e),u(t,[{key:"componentWillUnmount",value:function(){this.copiedTimer&&(clearTimeout(this.copiedTimer),this.copiedTimer=null)}},{key:"render",value:function(){var e=this.props,t=(e.src,e.theme),n=e.hidden,r=(0,h.default)(t,"copy-to-clipboard").style,a="inline";return n&&(a="none"),c.default.createElement("span",{className:"copy-to-clipboard-container"},c.default.createElement("span",{style:s({},r,{display:a}),onClick:this.handleCopy},this.getClippyIcon()))}}]),t}(c.default.PureComponent);t.default=y},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function a(e){if(Array.isArray(e)){for(var t=0,n=Array(e.length);t<e.length;t++)n[t]=e[t];return n}return Array.from(e)}function o(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function i(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function s(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var u=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},l=n(0),c=r(l),f=n(14),d=r(f),p=n(55),b=r(p),h=n(4),y=n(15),v=n(1),m=r(v),g=function(e){function t(){var e,n,r,s;o(this,t);for(var l=arguments.length,f=Array(l),p=0;p<l;p++)f[p]=arguments[p];return n=r=i(this,(e=t.__proto__||Object.getPrototypeOf(t)).call.apply(e,[this].concat(f))),r.getObjectSize=function(){var e=r.props,t=e.size,n=e.theme;if(e.displayObjectSize)return c.default.createElement("span",u({className:"object-size"},(0,m.default)(n,"object-size")),t," item",1===t?"":"s")},r.getAddAttribute=function(){var e=r.props,t=e.theme,n=e.namespace,o=e.name,i=e.src,s=e.rjvId,l=e.depth;return c.default.createElement("span",{className:"click-to-add",style:{verticalAlign:"top"}},c.default.createElement(y.AddCircle,u({className:"click-to-add-icon"},(0,m.default)(t,"addVarIcon"),{onClick:function(){var e={name:l>0?o:null,namespace:n.splice(0,n.length-1),existing_value:i,variable_removed:!1,key_name:null};"object"===(0,h.toType)(i)?d.default.dispatch({name:"ADD_VARIABLE_KEY_REQUEST",rjvId:s,data:e}):d.default.dispatch({name:"VARIABLE_ADDED",rjvId:s,data:u({},e,{new_value:[].concat(a(i),[null])})})}})))},r.getRemoveObject=function(){var e=r.props,t=e.theme,n=(e.hover,e.namespace),a=e.name,o=e.src,i=e.rjvId;if(1!==n.length)return c.default.createElement("span",{className:"click-to-remove"},c.default.createElement(y.RemoveCircle,u({className:"click-to-remove-icon"},(0,m.default)(t,"removeVarIcon"),{onClick:function(){d.default.dispatch({name:"VARIABLE_REMOVED",rjvId:i,data:{name:a,namespace:n.splice(0,n.length-1),existing_value:o,variable_removed:!0}})}})))},r.render=function(){var e=r.props,t=e.theme,n=e.onDelete,a=e.onAdd,o=e.enableClipboard,i=e.src,s=e.namespace;return c.default.createElement("div",u({},(0,m.default)(t,"object-meta-data"),{className:"object-meta-data",onClick:function(e){e.stopPropagation()}}),r.getObjectSize(),o?c.default.createElement(b.default,u({clickCallback:o},{src:i,theme:t,namespace:s})):null,!1!==a?r.getAddAttribute():null,!1!==n?r.getRemoveObject():null)},s=n,i(r,s)}return s(t,e),t}(c.default.PureComponent);t.default=g},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function a(e){if(Array.isArray(e)){for(var t=0,n=Array(e.length);t<e.length;t++)n[t]=e[t];return n}return Array.from(e)}function o(e,t){var n={};for(var r in e)t.indexOf(r)>=0||Object.prototype.hasOwnProperty.call(e,r)&&(n[r]=e[r]);return n}function i(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function s(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function u(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var l=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},c=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),f=n(0),d=r(f),p=n(1),b=r(p),h=n(56),y=r(h),v=n(58),m=r(v),g=n(25),_=r(g),j=n(59),O=function(e){function t(e){i(this,t);var n=s(this,(t.__proto__||Object.getPrototypeOf(t)).call(this,e));return n.toggleCollapsed=function(e){var t=[];for(var r in n.state.expanded)t.push(n.state.expanded[r]);t[e]=!t[e],n.setState({expanded:t})},n.state={expanded:[]},n}return u(t,e),c(t,[{key:"getExpandedIcon",value:function(e){var t=this.props,n=t.theme,r=t.iconStyle;return this.state.expanded[e]?d.default.createElement(j.ExpandedIcon,{theme:n,iconStyle:r}):d.default.createElement(j.CollapsedIcon,{theme:n,iconStyle:r})}},{key:"render",value:function(){var e=this,t=this.props,n=t.src,r=t.groupArraysAfterLength,i=(t.depth,t.name),s=t.theme,u=t.jsvRoot,c=t.namespace,f=(t.parent_type,o(t,["src","groupArraysAfterLength","depth","name","theme","jsvRoot","namespace","parent_type"])),p=0,h=5*this.props.indentWidth;u||(p=5*this.props.indentWidth);var v=r,g=Math.ceil(n.length/v);return d.default.createElement("div",l({className:"object-key-val"},(0,b.default)(s,u?"jsv-root":"objectKeyVal",{paddingLeft:p})),d.default.createElement(m.default,this.props),d.default.createElement("span",null,d.default.createElement(y.default,l({size:n.length},this.props))),[].concat(a(Array(g))).map(function(t,r){return d.default.createElement("div",l({key:r,className:"object-key-val array-group"},(0,b.default)(s,"objectKeyVal",{marginLeft:6,paddingLeft:h})),d.default.createElement("span",(0,b.default)(s,"brace-row"),d.default.createElement("div",l({className:"icon-container"},(0,b.default)(s,"icon-container"),{onClick:function(t){e.toggleCollapsed(r)}}),e.getExpandedIcon(r)),e.state.expanded[r]?d.default.createElement(_.default,l({key:i+r,depth:0,name:!1,collapsed:!1,groupArraysAfterLength:v,index_offset:r*v,src:n.slice(r*v,r*v+v),namespace:c,type:"array",parent_type:"array_group",theme:s},f)):d.default.createElement("span",l({},(0,b.default)(s,"brace"),{onClick:function(t){e.toggleCollapsed(r)},className:"array-group-brace"}),"[",d.default.createElement("div",l({},(0,b.default)(s,"array-group-meta-data"),{className:"array-group-meta-data"}),d.default.createElement("span",l({className:"object-size"},(0,b.default)(s,"object-size")),r*v," - ",r*v+v>n.length?n.length:r*v+v)),"]")))}))}}]),t}(d.default.PureComponent);t.default=O},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function a(e){var t=e.parent_type,n=e.namespace,r=e.theme,a=e.jsvRoot,i=e.name,u=e.name?e.name:"";return!a||!1!==i&&null!==i?"array"==t?s.default.createElement("span",o({},(0,l.default)(r,"array-key"),{key:n}),s.default.createElement("span",{className:"array-key"},u),s.default.createElement("span",(0,l.default)(r,"colon"),":")):s.default.createElement("span",o({},(0,l.default)(r,"object-name"),{key:n}),s.default.createElement("span",{className:"object-key"},s.default.createElement("span",{style:{verticalAlign:"top"}},'"'),s.default.createElement("span",null,u),s.default.createElement("span",{style:{verticalAlign:"top"}},'"')),s.default.createElement("span",(0,l.default)(r,"colon"),":")):s.default.createElement("span",null)}Object.defineProperty(t,"__esModule",{value:!0});var o=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e};t.default=a;var i=n(0),s=r(i),u=n(1),l=r(u)},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function a(e){var t=e.theme;switch(e.iconStyle){case"triangle":return u.default.createElement(f.ArrowDown,i({},(0,c.default)(t,"expanded-icon"),{className:"expanded-icon"}));case"square":return u.default.createElement(f.SquareMinus,i({},(0,c.default)(t,"expanded-icon"),{className:"expanded-icon"}));default:return u.default.createElement(f.CircleMinus,i({},(0,c.default)(t,"expanded-icon"),{className:"expanded-icon"}))}}function o(e){var t=e.theme;switch(e.iconStyle){case"triangle":return u.default.createElement(f.ArrowRight,i({},(0,c.default)(t,"collapsed-icon"),{className:"collapsed-icon"}));case"square":return u.default.createElement(f.SquarePlus,i({},(0,c.default)(t,"collapsed-icon"),{className:"collapsed-icon"}));default:return u.default.createElement(f.CirclePlus,i({},(0,c.default)(t,"collapsed-icon"),{className:"collapsed-icon"}))}}Object.defineProperty(t,"__esModule",{value:!0});var i=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e};t.ExpandedIcon=a,t.CollapsedIcon=o;var s=n(0),u=r(s),l=n(1),c=r(l),f=n(15)},function(e,t,n){e.exports=n(61)},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function a(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function o(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function i(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var s=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},u=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),l=n(0),c=r(l),f=n(41),d=n(62),p=r(d),b=n(177),h=r(b),y=n(179),v=r(y),m=n(4),g=n(13),_=r(g),j=n(1),O=r(j);n(180);var E=function(e){function t(e){a(this,t);var n=o(this,(t.__proto__||Object.getPrototypeOf(t)).call(this,e));return n.rjvId=Date.now().toString(),n.getListeners=function(){return{reset:n.resetState,"variable-update":n.updateSrc,"add-key-request":n.addKeyRequest}},n.updateSrc=function(){var e=_.default.get(n.rjvId,"action","variable-update"),t=e.name,r=e.namespace,a=e.new_value,o=e.existing_value,i=(e.variable_removed,e.updated_src),s=e.type,u=n.props,l=u.onEdit,c=u.onDelete,f=u.onAdd,d=n.state.src,p=void 0,b={existing_src:d,new_value:a,updated_src:i,name:t,namespace:r,existing_value:o};switch(s){case"variable-added":p=f(b);break;case"variable-edited":p=l(b);break;case"variable-removed":p=c(b)}!1!==p?(_.default.set(n.rjvId,"global","src",i),n.setState({src:i})):n.setState({validationFailure:!0})},n.addKeyRequest=function(){n.setState({addKeyRequest:!0})},n.resetState=function(){n.setState({validationFailure:!1,addKeyRequest:!1})},n.state={addKeyRequest:!1,editKeyRequest:!1,validationFailure:!1,src:t.defaultProps.src,name:t.defaultProps.name,theme:t.defaultProps.theme,validationMessage:t.defaultProps.validationMessage,prevSrc:t.defaultProps.src,prevName:t.defaultProps.name,prevTheme:t.defaultProps.theme},n}return i(t,e),u(t,[{key:"componentDidMount",value:function(){_.default.set(this.rjvId,"global","src",this.state.src);var e=this.getListeners();for(var t in e)_.default.on(t+"-"+this.rjvId,e[t]);this.setState({addKeyRequest:!1,editKeyRequest:!1})}},{key:"componentDidUpdate",value:function(e,t){!1!==t.addKeyRequest&&this.setState({addKeyRequest:!1}),!1!==t.editKeyRequest&&this.setState({editKeyRequest:!1}),e.src!==this.state.src&&_.default.set(this.rjvId,"global","src",this.state.src)}},{key:"componentWillUnmount",value:function(){var e=this.getListeners();for(var t in e)_.default.removeListener(t+"-"+this.rjvId,e[t])}},{key:"render",value:function(){var e=this.state,t=e.validationFailure,n=e.validationMessage,r=e.addKeyRequest,a=e.theme,o=e.src,i=e.name,u=this.props,l=u.style,f=u.defaultValue;return c.default.createElement("div",{className:"react-json-view",style:s({},(0,O.default)(a,"app-container").style,l)},c.default.createElement(v.default,{message:n,active:t,theme:a,rjvId:this.rjvId}),c.default.createElement(p.default,s({},this.props,{src:o,name:i,theme:a,type:(0,m.toType)(o),rjvId:this.rjvId})),c.default.createElement(h.default,{active:r,theme:a,rjvId:this.rjvId,defaultValue:f}))}}],[{key:"getDerivedStateFromProps",value:function(e,n){if(e.src!==n.prevSrc||e.name!==n.prevName||e.theme!==n.prevTheme){var r={src:e.src,name:e.name,theme:e.theme,validationMessage:e.validationMessage,prevSrc:e.src,prevName:e.name,prevTheme:e.theme};return t.validateState(r)}return null}}]),t}(c.default.PureComponent);E.defaultProps={src:{},name:"root",theme:"rjv-default",collapsed:!1,collapseStringsAfterLength:!1,shouldCollapse:!1,sortKeys:!1,groupArraysAfterLength:100,indentWidth:4,enableClipboard:!0,displayObjectSize:!0,displayDataTypes:!0,onEdit:!1,onDelete:!1,onAdd:!1,onSelect:!1,iconStyle:"triangle",style:{},validationMessage:"Validation Error",defaultValue:null},E.validateState=function(e){var t={};return"object"!==(0,m.toType)(e.theme)||(0,m.isTheme)(e.theme)||(console.error("react-json-view error:","theme prop must be a theme name or valid base-16 theme object.",'defaulting to "rjv-default" theme'),t.theme="rjv-default"),"object"!==(0,m.toType)(e.src)&&"array"!==(0,m.toType)(e.src)&&(console.error("react-json-view error:","src property must be a valid json object"),t.name="ERROR",t.src={message:"src property must be a valid json object"}),s({},e,t)},(0,f.polyfill)(E),t.default=E},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function a(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function o(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function i(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var s=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},u=n(0),l=r(u),c=n(25),f=r(c),d=n(57),p=r(d),b=function(e){function t(){var e,n,r,i;a(this,t);for(var u=arguments.length,c=Array(u),d=0;d<u;d++)c[d]=arguments[d];return n=r=o(this,(e=t.__proto__||Object.getPrototypeOf(t)).call.apply(e,[this].concat(c))),r.render=function(){var e=r,t=e.props,n=[t.name],a=f.default;return t.groupArraysAfterLength&&t.src.length>t.groupArraysAfterLength&&(a=p.default),l.default.createElement("div",{className:"pretty-json-container object-container"},l.default.createElement("div",{className:"object-content"},l.default.createElement(a,s({namespace:n,depth:0,jsvRoot:!0},t))))},i=n,o(r,i)}return i(t,e),t}(l.default.PureComponent);t.default=b},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function a(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function o(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function i(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var s=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},u=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),l=n(0),c=r(l),f=n(6),d=r(f),p=n(1),b=r(p),h=function(e){function t(){return a(this,t),o(this,(t.__proto__||Object.getPrototypeOf(t)).apply(this,arguments))}return i(t,e),u(t,[{key:"render",value:function(){var e=this.props;return c.default.createElement("div",(0,b.default)(e.theme,"boolean"),c.default.createElement(d.default,s({type_name:"bool"},e)),e.value?"true":"false")}}]),t}(c.default.PureComponent);t.default=h},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.rjv_default={scheme:"rjv-default",author:"mac gainor",base00:"rgba(0, 0, 0, 0)",base01:"rgb(245, 245, 245)",base02:"rgb(235, 235, 235)",base03:"#93a1a1",base04:"rgba(0, 0, 0, 0.3)",base05:"#586e75",base06:"#073642",base07:"#002b36",base08:"#d33682",base09:"#cb4b16",base0A:"#dc322f",base0B:"#859900",base0C:"#6c71c4",base0D:"#586e75",base0E:"#2aa198",base0F:"#268bd2"},t.rjv_grey={scheme:"rjv-grey",author:"mac gainor",base00:"rgba(1, 1, 1, 0)",base01:"rgba(1, 1, 1, 0.1)",base02:"rgba(0, 0, 0, 0.2)",base03:"rgba(1, 1, 1, 0.3)",base04:"rgba(0, 0, 0, 0.4)",base05:"rgba(1, 1, 1, 0.5)",base06:"rgba(1, 1, 1, 0.6)",base07:"rgba(1, 1, 1, 0.7)",base08:"rgba(1, 1, 1, 0.8)",base09:"rgba(1, 1, 1, 0.8)",base0A:"rgba(1, 1, 1, 0.8)",base0B:"rgba(1, 1, 1, 0.8)",base0C:"rgba(1, 1, 1, 0.8)",base0D:"rgba(1, 1, 1, 0.8)",base0E:"rgba(1, 1, 1, 0.8)",base0F:"rgba(1, 1, 1, 0.8)"}},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.default={white:"#fff",black:"#000",transparent:"rgba(1, 1, 1, 0)",globalFontFamily:"monospace",globalCursor:"default",indentBlockWidth:"5px",braceFontWeight:"bold",braceCursor:"pointer",ellipsisFontSize:"18px",ellipsisLineHeight:"10px",ellipsisCursor:"pointer",keyMargin:"0px 5px",keyLetterSpacing:"0.5px",keyFontStyle:"none",keyBorderRadius:"3px",keyColonWeight:"bold",keyVerticalAlign:"top",keyOpacity:"0.85",keyOpacityHover:"1",keyValPaddingTop:"3px",keyValPaddingBottom:"3px",keyValPaddingRight:"5px",keyValBorderLeft:"1px solid",keyValBorderHover:"2px solid",keyValPaddingHover:"3px 5px 3px 4px",pushedContentMarginLeft:"6px",variableValuePaddingRight:"6px",nullFontSize:"11px",nullFontWeight:"bold",nullPadding:"1px 2px",nullBorderRadius:"3px",nanFontSize:"11px",nanFontWeight:"bold",nanPadding:"1px 2px",nanBorderRadius:"3px",undefinedFontSize:"11px",undefinedFontWeight:"bold",undefinedPadding:"1px 2px",undefinedBorderRadius:"3px",dataTypeFontSize:"11px",dataTypeMarginRight:"4px",datatypeOpacity:"0.8",objectSizeBorderRadius:"3px",objectSizeFontStyle:"italic",objectSizeMargin:"0px 6px 0px 0px",clipboardCursor:"pointer",clipboardCheckMarginLeft:"-12px",metaDataPadding:"0px 0px 0px 10px",arrayGroupMetaPadding:"0px 0px 0px 4px",iconContainerWidth:"17px",tooltipPadding:"4px",editInputHeight:"25px",editInputMinWidth:"130px",editInputBorderRadius:"2px",editInputPadding:"5px",editInputMarginRight:"4px",editInputFontFamily:"monospace",iconCursor:"pointer",iconFontSize:"15px",iconPaddingRight:"1px",dateValueMarginLeft:"2px",iconMarginRight:"3px",detectedRowPaddingTop:"3px",addKeyCoverBackground:"rgba(255, 255, 255, 0.3)",addKeyCoverPosition:"absolute",addKeyCoverPositionPx:"0px",addKeyModalWidth:"200px",addKeyModalMargin:"auto",addKeyModalPadding:"10px",addKeyModalRadius:"3px"}},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0}),t.getBase16Theme=t.createStyling=t.invertTheme=void 0;var a=n(67),o=r(a),i=n(94),s=r(i),u=n(99),l=r(u),c=n(107),f=r(c),d=n(111),p=r(d),b=n(112),h=function(e){if(e&&e.__esModule)return e;var t={};if(null!=e)for(var n in e)Object.prototype.hasOwnProperty.call(e,n)&&(t[n]=e[n]);return t.default=e,t}(b),y=n(150),v=r(y),m=n(151),g=r(m),_=n(156),j=r(_),O=n(157),E=h.default,w=(0,f.default)(E),x=function(e){return e<.25?1:e<.5?.9-e:1.1-e},C=(0,j.default)(g.default,O.rgb2yuv,function(e){var t=(0,l.default)(e,3),n=t[0],r=t[1],a=t[2];return[x(n),r,a]},O.yuv2rgb,v.default),k=function(e){return function(t){return{className:[t.className,e.className].filter(Boolean).join(" "),style:(0,s.default)({},t.style||{},e.style||{})}}},P=function(e,t){if(void 0===e)return t;if(void 0===t)return e;var n=void 0===e?"undefined":(0,o.default)(e),r=void 0===t?"undefined":(0,o.default)(t);switch(n){case"string":switch(r){case"string":return[t,e].filter(Boolean).join(" ");case"object":return k({className:e,style:t});case"function":return function(n){for(var r=arguments.length,a=Array(r>1?r-1:0),o=1;o<r;o++)a[o-1]=arguments[o];return k({className:e})(t.apply(void 0,[n].concat(a)))}}case"object":switch(r){case"string":return k({className:t,style:e});case"object":return(0,s.default)({},t,e);case"function":return function(n){for(var r=arguments.length,a=Array(r>1?r-1:0),o=1;o<r;o++)a[o-1]=arguments[o];return k({style:e})(t.apply(void 0,[n].concat(a)))}}case"function":switch(r){case"string":return function(n){for(var r=arguments.length,a=Array(r>1?r-1:0),o=1;o<r;o++)a[o-1]=arguments[o];return e.apply(void 0,[k(n)({className:t})].concat(a))};case"object":return function(n){for(var r=arguments.length,a=Array(r>1?r-1:0),o=1;o<r;o++)a[o-1]=arguments[o];return e.apply(void 0,[k(n)({style:t})].concat(a))};case"function":return function(n){for(var r=arguments.length,a=Array(r>1?r-1:0),o=1;o<r;o++)a[o-1]=arguments[o];return e.apply(void 0,[t.apply(void 0,[n].concat(a))].concat(a))}}}},S=function(e,t){var n=(0,f.default)(t);for(var r in e)-1===n.indexOf(r)&&n.push(r);return n.reduce(function(n,r){return n[r]=P(e[r],t[r]),n},{})},M=function(e,t){for(var n=arguments.length,r=Array(n>2?n-2:0),a=2;a<n;a++)r[a-2]=arguments[a];if(null===t)return e;Array.isArray(t)||(t=[t]);var i=t.map(function(t){return e[t]}).filter(Boolean),u=i.reduce(function(e,t){return"string"==typeof t?e.className=[e.className,t].filter(Boolean).join(" "):"object"===(void 0===t?"undefined":(0,o.default)(t))?e.style=(0,s.default)({},e.style,t):"function"==typeof t&&(e=(0,s.default)({},e,t.apply(void 0,[e].concat(r)))),e},{className:"",style:{}});return u.className||delete u.className,0===(0,f.default)(u.style).length&&delete u.style,u},A=t.invertTheme=function(e){return(0,f.default)(e).reduce(function(t,n){return t[n]=/^base/.test(n)?C(e[n]):"scheme"===n?e[n]+":inverted":e[n],t},{})},R=(t.createStyling=(0,p.default)(function(e){for(var t=arguments.length,n=Array(t>3?t-3:0),r=3;r<t;r++)n[r-3]=arguments[r];var a=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},o=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{},i=a.defaultBase16,u=void 0===i?E:i,l=a.base16Themes,c=void 0===l?null:l,d=R(o,c);d&&(o=(0,s.default)({},d,o));var b=w.reduce(function(e,t){return e[t]=o[t]||u[t],e},{}),h=(0,f.default)(o).reduce(function(e,t){return-1===w.indexOf(t)?(e[t]=o[t],e):e},{}),y=e(b),v=S(h,y);return(0,p.default)(M,2).apply(void 0,[v].concat(n))},3),t.getBase16Theme=function(e,t){if(e&&e.extend&&(e=e.extend),"string"==typeof e){var n=e.split(":"),r=(0,l.default)(n,2),a=r[0],o=r[1];e=(t||{})[a]||h[a],"inverted"===o&&(e=A(e))}return e&&e.hasOwnProperty("base00")?e:void 0})},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}t.__esModule=!0;var a=n(68),o=r(a),i=n(83),s=r(i),u="function"==typeof s.default&&"symbol"==typeof o.default?function(e){return typeof e}:function(e){return e&&"function"==typeof s.default&&e.constructor===s.default&&e!==s.default.prototype?"symbol":typeof e};t.default="function"==typeof s.default&&"symbol"===u(o.default)?function(e){return void 0===e?"undefined":u(e)}:function(e){return e&&"function"==typeof s.default&&e.constructor===s.default&&e!==s.default.prototype?"symbol":void 0===e?"undefined":u(e)}},function(e,t,n){e.exports={default:n(69),__esModule:!0}},function(e,t,n){n(26),n(36),e.exports=n(37).f("iterator")},function(e,t,n){var r=n(27),a=n(28);e.exports=function(e){return function(t,n){var o,i,s=String(a(t)),u=r(n),l=s.length;return u<0||u>=l?e?"":void 0:(o=s.charCodeAt(u),o<55296||o>56319||u+1===l||(i=s.charCodeAt(u+1))<56320||i>57343?e?s.charAt(u):o:e?s.slice(u,u+2):i-56320+(o-55296<<10)+65536)}}},function(e,t,n){var r=n(72);e.exports=function(e,t,n){if(r(e),void 0===t)return e;switch(n){case 1:return function(n){return e.call(t,n)};case 2:return function(n,r){return e.call(t,n,r)};case 3:return function(n,r,a){return e.call(t,n,r,a)}}return function(){return e.apply(t,arguments)}}},function(e,t){e.exports=function(e){if("function"!=typeof e)throw TypeError(e+" is not a function!");return e}},function(e,t,n){"use strict";var r=n(47),a=n(22),o=n(34),i={};n(8)(i,n(3)("iterator"),function(){return this}),e.exports=function(e,t,n){e.prototype=r(i,{next:a(1,n)}),o(e,t+" Iterator")}},function(e,t,n){var r=n(9),a=n(16),o=n(19);e.exports=n(10)?Object.defineProperties:function(e,t){a(e);for(var n,i=o(t),s=i.length,u=0;s>u;)r.f(e,n=i[u++],t[n]);return e}},function(e,t,n){var r=n(12),a=n(76),o=n(77);e.exports=function(e){return function(t,n,i){var s,u=r(t),l=a(u.length),c=o(i,l);if(e&&n!=n){for(;l>c;)if((s=u[c++])!=s)return!0}else for(;l>c;c++)if((e||c in u)&&u[c]===n)return e||c||0;return!e&&-1}}},function(e,t,n){var r=n(27),a=Math.min;e.exports=function(e){return e>0?a(r(e),9007199254740991):0}},function(e,t,n){var r=n(27),a=Math.max,o=Math.min;e.exports=function(e,t){return e=r(e),e<0?a(e+t,0):o(e,t)}},function(e,t,n){var r=n(5).document;e.exports=r&&r.documentElement},function(e,t,n){var r=n(7),a=n(35),o=n(31)("IE_PROTO"),i=Object.prototype;e.exports=Object.getPrototypeOf||function(e){return e=a(e),r(e,o)?e[o]:"function"==typeof e.constructor&&e instanceof e.constructor?e.constructor.prototype:e instanceof Object?i:null}},function(e,t,n){"use strict";var r=n(81),a=n(82),o=n(18),i=n(12);e.exports=n(43)(Array,"Array",function(e,t){this._t=i(e),this._i=0,this._k=t},function(){var e=this._t,t=this._k,n=this._i++;return!e||n>=e.length?(this._t=void 0,a(1)):"keys"==t?a(0,n):"values"==t?a(0,e[n]):a(0,[n,e[n]])},"values"),o.Arguments=o.Array,r("keys"),r("values"),r("entries")},function(e,t){e.exports=function(){}},function(e,t){e.exports=function(e,t){return{value:t,done:!!e}}},function(e,t,n){e.exports={default:n(84),__esModule:!0}},function(e,t,n){n(85),n(91),n(92),n(93),e.exports=n(2).Symbol},function(e,t,n){"use strict";var r=n(5),a=n(7),o=n(10),i=n(21),s=n(46),u=n(86).KEY,l=n(11),c=n(32),f=n(34),d=n(23),p=n(3),b=n(37),h=n(38),y=n(87),v=n(88),m=n(16),g=n(17),_=n(12),j=n(29),O=n(22),E=n(47),w=n(89),x=n(90),C=n(9),k=n(19),P=x.f,S=C.f,M=w.f,A=r.Symbol,R=r.JSON,F=R&&R.stringify,D=p("_hidden"),T=p("toPrimitive"),I={}.propertyIsEnumerable,L=c("symbol-registry"),B=c("symbols"),N=c("op-symbols"),z=Object.prototype,q="function"==typeof A,V=r.QObject,U=!V||!V.prototype||!V.prototype.findChild,K=o&&l(function(){return 7!=E(S({},"a",{get:function(){return S(this,"a",{value:7}).a}})).a})?function(e,t,n){var r=P(z,t);r&&delete z[t],S(e,t,n),r&&e!==z&&S(z,t,r)}:S,W=function(e){var t=B[e]=E(A.prototype);return t._k=e,t},H=q&&"symbol"==typeof A.iterator?function(e){return"symbol"==typeof e}:function(e){return e instanceof A},J=function(e,t,n){return e===z&&J(N,t,n),m(e),t=j(t,!0),m(n),a(B,t)?(n.enumerable?(a(e,D)&&e[D][t]&&(e[D][t]=!1),n=E(n,{enumerable:O(0,!1)})):(a(e,D)||S(e,D,O(1,{})),e[D][t]=!0),K(e,t,n)):S(e,t,n)},G=function(e,t){m(e);for(var n,r=y(t=_(t)),a=0,o=r.length;o>a;)J(e,n=r[a++],t[n]);return e},$=function(e,t){return void 0===t?E(e):G(E(e),t)},Y=function(e){var t=I.call(this,e=j(e,!0));return!(this===z&&a(B,e)&&!a(N,e))&&(!(t||!a(this,e)||!a(B,e)||a(this,D)&&this[D][e])||t)},Q=function(e,t){if(e=_(e),t=j(t,!0),e!==z||!a(B,t)||a(N,t)){var n=P(e,t);return!n||!a(B,t)||a(e,D)&&e[D][t]||(n.enumerable=!0),n}},Z=function(e){for(var t,n=M(_(e)),r=[],o=0;n.length>o;)a(B,t=n[o++])||t==D||t==u||r.push(t);return r},X=function(e){for(var t,n=e===z,r=M(n?N:_(e)),o=[],i=0;r.length>i;)!a(B,t=r[i++])||n&&!a(z,t)||o.push(B[t]);return o};q||(A=function(){if(this instanceof A)throw TypeError("Symbol is not a constructor!");var e=d(arguments.length>0?arguments[0]:void 0),t=function(n){this===z&&t.call(N,n),a(this,D)&&a(this[D],e)&&(this[D][e]=!1),K(this,e,O(1,n))};return o&&U&&K(z,e,{configurable:!0,set:t}),W(e)},s(A.prototype,"toString",function(){return this._k}),x.f=Q,C.f=J,n(50).f=w.f=Z,n(24).f=Y,n(39).f=X,o&&!n(20)&&s(z,"propertyIsEnumerable",Y,!0),b.f=function(e){return W(p(e))}),i(i.G+i.W+i.F*!q,{Symbol:A});for(var ee="hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables".split(","),te=0;ee.length>te;)p(ee[te++]);for(var ne=k(p.store),re=0;ne.length>re;)h(ne[re++]);i(i.S+i.F*!q,"Symbol",{for:function(e){return a(L,e+="")?L[e]:L[e]=A(e)},keyFor:function(e){if(!H(e))throw TypeError(e+" is not a symbol!");for(var t in L)if(L[t]===e)return t},useSetter:function(){U=!0},useSimple:function(){U=!1}}),i(i.S+i.F*!q,"Object",{create:$,defineProperty:J,defineProperties:G,getOwnPropertyDescriptor:Q,getOwnPropertyNames:Z,getOwnPropertySymbols:X}),R&&i(i.S+i.F*(!q||l(function(){var e=A();return"[null]"!=F([e])||"{}"!=F({a:e})||"{}"!=F(Object(e))})),"JSON",{stringify:function(e){for(var t,n,r=[e],a=1;arguments.length>a;)r.push(arguments[a++]);if(n=t=r[1],(g(t)||void 0!==e)&&!H(e))return v(t)||(t=function(e,t){if("function"==typeof n&&(t=n.call(this,e,t)),!H(t))return t}),r[1]=t,F.apply(R,r)}}),A.prototype[T]||n(8)(A.prototype,T,A.prototype.valueOf),f(A,"Symbol"),f(Math,"Math",!0),f(r.JSON,"JSON",!0)},function(e,t,n){var r=n(23)("meta"),a=n(17),o=n(7),i=n(9).f,s=0,u=Object.isExtensible||function(){return!0},l=!n(11)(function(){return u(Object.preventExtensions({}))}),c=function(e){i(e,r,{value:{i:"O"+ ++s,w:{}}})},f=function(e,t){if(!a(e))return"symbol"==typeof e?e:("string"==typeof e?"S":"P")+e;if(!o(e,r)){if(!u(e))return"F";if(!t)return"E";c(e)}return e[r].i},d=function(e,t){if(!o(e,r)){if(!u(e))return!0;if(!t)return!1;c(e)}return e[r].w},p=function(e){return l&&b.NEED&&u(e)&&!o(e,r)&&c(e),e},b=e.exports={KEY:r,NEED:!1,fastKey:f,getWeak:d,onFreeze:p}},function(e,t,n){var r=n(19),a=n(39),o=n(24);e.exports=function(e){var t=r(e),n=a.f;if(n)for(var i,s=n(e),u=o.f,l=0;s.length>l;)u.call(e,i=s[l++])&&t.push(i);return t}},function(e,t,n){var r=n(30);e.exports=Array.isArray||function(e){return"Array"==r(e)}},function(e,t,n){var r=n(12),a=n(50).f,o={}.toString,i="object"==typeof window&&window&&Object.getOwnPropertyNames?Object.getOwnPropertyNames(window):[],s=function(e){try{return a(e)}catch(e){return i.slice()}};e.exports.f=function(e){return i&&"[object Window]"==o.call(e)?s(e):a(r(e))}},function(e,t,n){var r=n(24),a=n(22),o=n(12),i=n(29),s=n(7),u=n(44),l=Object.getOwnPropertyDescriptor;t.f=n(10)?l:function(e,t){if(e=o(e),t=i(t,!0),u)try{return l(e,t)}catch(e){}if(s(e,t))return a(!r.f.call(e,t),e[t])}},function(e,t){},function(e,t,n){n(38)("asyncIterator")},function(e,t,n){n(38)("observable")},function(e,t,n){"use strict";t.__esModule=!0;var r=n(95),a=function(e){return e&&e.__esModule?e:{default:e}}(r);t.default=a.default||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e}},function(e,t,n){e.exports={default:n(96),__esModule:!0}},function(e,t,n){n(97),e.exports=n(2).Object.assign},function(e,t,n){var r=n(21);r(r.S+r.F,"Object",{assign:n(98)})},function(e,t,n){"use strict";var r=n(19),a=n(39),o=n(24),i=n(35),s=n(49),u=Object.assign;e.exports=!u||n(11)(function(){var e={},t={},n=Symbol(),r="abcdefghijklmnopqrst";return e[n]=7,r.split("").forEach(function(e){t[e]=e}),7!=u({},e)[n]||Object.keys(u({},t)).join("")!=r})?function(e,t){for(var n=i(e),u=arguments.length,l=1,c=a.f,f=o.f;u>l;)for(var d,p=s(arguments[l++]),b=c?r(p).concat(c(p)):r(p),h=b.length,y=0;h>y;)f.call(p,d=b[y++])&&(n[d]=p[d]);return n}:u},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}t.__esModule=!0;var a=n(100),o=r(a),i=n(103),s=r(i);t.default=function(){function e(e,t){var n=[],r=!0,a=!1,o=void 0;try{for(var i,u=(0,s.default)(e);!(r=(i=u.next()).done)&&(n.push(i.value),!t||n.length!==t);r=!0);}catch(e){a=!0,o=e}finally{try{!r&&u.return&&u.return()}finally{if(a)throw o}}return n}return function(t,n){if(Array.isArray(t))return t;if((0,o.default)(Object(t)))return e(t,n);throw new TypeError("Invalid attempt to destructure non-iterable instance")}}()},function(e,t,n){e.exports={default:n(101),__esModule:!0}},function(e,t,n){n(36),n(26),e.exports=n(102)},function(e,t,n){var r=n(51),a=n(3)("iterator"),o=n(18);e.exports=n(2).isIterable=function(e){var t=Object(e);return void 0!==t[a]||"@@iterator"in t||o.hasOwnProperty(r(t))}},function(e,t,n){e.exports={default:n(104),__esModule:!0}},function(e,t,n){n(36),n(26),e.exports=n(105)},function(e,t,n){var r=n(16),a=n(106);e.exports=n(2).getIterator=function(e){var t=a(e);if("function"!=typeof t)throw TypeError(e+" is not iterable!");return r(t.call(e))}},function(e,t,n){var r=n(51),a=n(3)("iterator"),o=n(18);e.exports=n(2).getIteratorMethod=function(e){if(void 0!=e)return e[a]||e["@@iterator"]||o[r(e)]}},function(e,t,n){e.exports={default:n(108),__esModule:!0}},function(e,t,n){n(109),e.exports=n(2).Object.keys},function(e,t,n){var r=n(35),a=n(19);n(110)("keys",function(){return function(e){return a(r(e))}})},function(e,t,n){var r=n(21),a=n(2),o=n(11);e.exports=function(e,t){var n=(a.Object||{})[e]||Object[e],i={};i[e]=t(n),r(r.S+r.F*o(function(){n(1)}),"Object",i)}},function(e,t,n){(function(t){function n(e,t,n){switch(n.length){case 0:return e.call(t);case 1:return e.call(t,n[0]);case 2:return e.call(t,n[0],n[1]);case 3:return e.call(t,n[0],n[1],n[2])}return e.apply(t,n)}function r(e,t){for(var n=-1,r=e?e.length:0;++n<r&&!1!==t(e[n],n,e););return e}function a(e,t){return!!(e?e.length:0)&&i(e,t,0)>-1}function o(e,t,n,r){for(var a=e.length,o=n+(r?1:-1);r?o--:++o<a;)if(t(e[o],o,e))return o;return-1}function i(e,t,n){if(t!==t)return o(e,s,n);for(var r=n-1,a=e.length;++r<a;)if(e[r]===t)return r;return-1}function s(e){return e!==e}function u(e,t){for(var n=e.length,r=0;n--;)e[n]===t&&r++;return r}function l(e,t){return null==e?void 0:e[t]}function c(e){var t=!1;if(null!=e&&"function"!=typeof e.toString)try{t=!!(e+"")}catch(e){}return t}function f(e,t){for(var n=-1,r=e.length,a=0,o=[];++n<r;){var i=e[n];i!==t&&i!==K||(e[n]=K,o[a++]=n)}return o}function d(e){return T(e)?Me(e):{}}function p(e){return!(!T(e)||S(e))&&(D(e)||c(e)?Se:he).test(A(e))}function b(e,t,n,r){for(var a=-1,o=e.length,i=n.length,s=-1,u=t.length,l=Ae(o-i,0),c=Array(u+l),f=!r;++s<u;)c[s]=t[s];for(;++a<i;)(f||a<o)&&(c[n[a]]=e[a]);for(;l--;)c[s++]=e[a++];return c}function h(e,t,n,r){for(var a=-1,o=e.length,i=-1,s=n.length,u=-1,l=t.length,c=Ae(o-s,0),f=Array(c+l),d=!r;++a<c;)f[a]=e[a];for(var p=a;++u<l;)f[p+u]=t[u];for(;++i<s;)(d||a<o)&&(f[p+n[i]]=e[a++]);return f}function y(e,t){var n=-1,r=e.length;for(t||(t=Array(r));++n<r;)t[n]=e[n];return t}function v(e,t,n){function r(){return(this&&this!==je&&this instanceof r?o:e).apply(a?n:this,arguments)}var a=t&W,o=m(e);return r}function m(e){return function(){var t=arguments;switch(t.length){case 0:return new e;case 1:return new e(t[0]);case 2:return new e(t[0],t[1]);case 3:return new e(t[0],t[1],t[2]);case 4:return new e(t[0],t[1],t[2],t[3]);case 5:return new e(t[0],t[1],t[2],t[3],t[4]);case 6:return new e(t[0],t[1],t[2],t[3],t[4],t[5]);case 7:return new e(t[0],t[1],t[2],t[3],t[4],t[5],t[6])}var n=d(e.prototype),r=e.apply(n,t);return T(r)?r:n}}function g(e,t,r){function a(){for(var i=arguments.length,s=Array(i),u=i,l=w(a);u--;)s[u]=arguments[u];var c=i<3&&s[0]!==l&&s[i-1]!==l?[]:f(s,l);return(i-=c.length)<r?O(e,t,_,a.placeholder,void 0,s,c,void 0,void 0,r-i):n(this&&this!==je&&this instanceof a?o:e,this,s)}var o=m(e);return a}function _(e,t,n,r,a,o,i,s,l,c){function d(){for(var x=arguments.length,C=Array(x),k=x;k--;)C[k]=arguments[k];if(g)var P=w(d),S=u(C,P);if(r&&(C=b(C,r,a,g)),o&&(C=h(C,o,i,g)),x-=S,g&&x<c){var A=f(C,P);return O(e,t,_,d.placeholder,n,C,A,s,l,c-x)}var R=y?n:this,F=v?R[e]:e;return x=C.length,s?C=M(C,s):j&&x>1&&C.reverse(),p&&l<x&&(C.length=l),this&&this!==je&&this instanceof d&&(F=E||m(F)),F.apply(R,C)}var p=t&Z,y=t&W,v=t&H,g=t&(G|$),j=t&X,E=v?void 0:m(e);return d}function j(e,t,r,a){function o(){for(var t=-1,u=arguments.length,l=-1,c=a.length,f=Array(c+u),d=this&&this!==je&&this instanceof o?s:e;++l<c;)f[l]=a[l];for(;u--;)f[l++]=arguments[++t];return n(d,i?r:this,f)}var i=t&W,s=m(e);return o}function O(e,t,n,r,a,o,i,s,u,l){var c=t&G,f=c?i:void 0,d=c?void 0:i,p=c?o:void 0,b=c?void 0:o;t|=c?Y:Q,(t&=~(c?Q:Y))&J||(t&=~(W|H));var h=n(e,t,a,p,f,b,d,s,u,l);return h.placeholder=r,De(h,e,t)}function E(e,t,n,r,a,o,i,s){var u=t&H;if(!u&&"function"!=typeof e)throw new TypeError(U);var l=r?r.length:0;if(l||(t&=~(Y|Q),r=a=void 0),i=void 0===i?i:Ae(N(i),0),s=void 0===s?s:N(s),l-=a?a.length:0,t&Q){var c=r,f=a;r=a=void 0}var d=[e,t,n,r,a,c,f,o,i,s];if(e=d[0],t=d[1],n=d[2],r=d[3],a=d[4],s=d[9]=null==d[9]?u?0:e.length:Ae(d[9]-l,0),!s&&t&(G|$)&&(t&=~(G|$)),t&&t!=W)p=t==G||t==$?g(e,t,s):t!=Y&&t!=(W|Y)||a.length?_.apply(void 0,d):j(e,t,n,r);else var p=v(e,t,n);return De(p,e,t)}function w(e){return e.placeholder}function x(e,t){var n=l(e,t);return p(n)?n:void 0}function C(e){var t=e.match(fe);return t?t[1].split(de):[]}function k(e,t){var n=t.length,r=n-1;return t[r]=(n>1?"& ":"")+t[r],t=t.join(n>2?", ":" "),e.replace(ce,"{\n/* [wrapped with "+t+"] */\n")}function P(e,t){return!!(t=null==t?te:t)&&("number"==typeof e||ve.test(e))&&e>-1&&e%1==0&&e<t}function S(e){return!!xe&&xe in e}function M(e,t){for(var n=e.length,r=Re(t.length,n),a=y(e);r--;){var o=t[r];e[r]=P(o,n)?a[o]:void 0}return e}function A(e){if(null!=e){try{return Ce.call(e)}catch(e){}try{return e+""}catch(e){}}return""}function R(e,t){return r(ae,function(n){var r="_."+n[0];t&n[1]&&!a(e,r)&&e.push(r)}),e.sort()}function F(e,t,n){t=n?void 0:t;var r=E(e,G,void 0,void 0,void 0,void 0,void 0,t);return r.placeholder=F.placeholder,r}function D(e){var t=T(e)?Pe.call(e):"";return t==oe||t==ie}function T(e){var t=typeof e;return!!e&&("object"==t||"function"==t)}function I(e){return!!e&&"object"==typeof e}function L(e){return"symbol"==typeof e||I(e)&&Pe.call(e)==se}function B(e){return e?(e=z(e))===ee||e===-ee?(e<0?-1:1)*ne:e===e?e:0:0===e?e:0}function N(e){var t=B(e),n=t%1;return t===t?n?t-n:t:0}function z(e){if("number"==typeof e)return e;if(L(e))return re;if(T(e)){var t="function"==typeof e.valueOf?e.valueOf():e;e=T(t)?t+"":t}if("string"!=typeof e)return 0===e?e:+e;e=e.replace(le,"");var n=be.test(e);return n||ye.test(e)?me(e.slice(2),n?2:8):pe.test(e)?re:+e}function q(e){return function(){return e}}function V(e){return e}var U="Expected a function",K="__lodash_placeholder__",W=1,H=2,J=4,G=8,$=16,Y=32,Q=64,Z=128,X=512,ee=1/0,te=9007199254740991,ne=1.7976931348623157e308,re=NaN,ae=[["ary",Z],["bind",W],["bindKey",H],["curry",G],["curryRight",$],["flip",X],["partial",Y],["partialRight",Q],["rearg",256]],oe="[object Function]",ie="[object GeneratorFunction]",se="[object Symbol]",ue=/[\\^$.*+?()[\]{}|]/g,le=/^\s+|\s+$/g,ce=/\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,fe=/\{\n\/\* \[wrapped with (.+)\] \*/,de=/,? & /,pe=/^[-+]0x[0-9a-f]+$/i,be=/^0b[01]+$/i,he=/^\[object .+?Constructor\]$/,ye=/^0o[0-7]+$/i,ve=/^(?:0|[1-9]\d*)$/,me=parseInt,ge="object"==typeof t&&t&&t.Object===Object&&t,_e="object"==typeof self&&self&&self.Object===Object&&self,je=ge||_e||Function("return this")(),Oe=Function.prototype,Ee=Object.prototype,we=je["__core-js_shared__"],xe=function(){var e=/[^.]+$/.exec(we&&we.keys&&we.keys.IE_PROTO||"");return e?"Symbol(src)_1."+e:""}(),Ce=Oe.toString,ke=Ee.hasOwnProperty,Pe=Ee.toString,Se=RegExp("^"+Ce.call(ke).replace(ue,"\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g,"$1.*?")+"$"),Me=Object.create,Ae=Math.max,Re=Math.min,Fe=function(){var e=x(Object,"defineProperty"),t=x.name;return t&&t.length>2?e:void 0}(),De=Fe?function(e,t,n){var r=t+"";return Fe(e,"toString",{configurable:!0,enumerable:!1,value:q(k(r,R(C(r),n)))})}:V;F.placeholder={},e.exports=F}).call(t,n(52))},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e.default:e}t.__esModule=!0;var a=n(113);t.threezerotwofour=r(a);var o=n(114);t.apathy=r(o);var i=n(115);t.ashes=r(i);var s=n(116);t.atelierDune=r(s);var u=n(117);t.atelierForest=r(u);var l=n(118);t.atelierHeath=r(l);var c=n(119);t.atelierLakeside=r(c);var f=n(120);t.atelierSeaside=r(f);var d=n(121);t.bespin=r(d);var p=n(122);t.brewer=r(p);var b=n(123);t.bright=r(b);var h=n(124);t.chalk=r(h);var y=n(125);t.codeschool=r(y);var v=n(126);t.colors=r(v);var m=n(127);t.default=r(m);var g=n(128);t.eighties=r(g);var _=n(129);t.embers=r(_);var j=n(130);t.flat=r(j);var O=n(131);t.google=r(O);var E=n(132);t.grayscale=r(E);var w=n(133);t.greenscreen=r(w);var x=n(134);t.harmonic=r(x);var C=n(135);t.hopscotch=r(C);var k=n(136);t.isotope=r(k);var P=n(137);t.marrakesh=r(P);var S=n(138);t.mocha=r(S);var M=n(139);t.monokai=r(M);var A=n(140);t.ocean=r(A);var R=n(141);t.paraiso=r(R);var F=n(142);t.pop=r(F);var D=n(143);t.railscasts=r(D);var T=n(144);t.shapeshifter=r(T);var I=n(145);t.solarized=r(I);var L=n(146);t.summerfruit=r(L);var B=n(147);t.tomorrow=r(B);var N=n(148);t.tube=r(N);var z=n(149);t.twilight=r(z)},function(e,t,n){"use strict";t.__esModule=!0,t.default={scheme:"threezerotwofour",author:"jan t. sott (http://github.com/idleberg)",base00:"#090300",base01:"#3a3432",base02:"#4a4543",base03:"#5c5855",base04:"#807d7c",base05:"#a5a2a2",base06:"#d6d5d4",base07:"#f7f7f7",base08:"#db2d20",base09:"#e8bbd0",base0A:"#fded02",base0B:"#01a252",base0C:"#b5e4f4",base0D:"#01a0e4",base0E:"#a16a94",base0F:"#cdab53"},e.exports=t.default},function(e,t,n){"use strict";t.__esModule=!0,t.default={scheme:"apathy",author:"jannik siebert (https://github.com/janniks)",base00:"#031A16",base01:"#0B342D",base02:"#184E45",base03:"#2B685E",base04:"#5F9C92",base05:"#81B5AC",base06:"#A7CEC8",base07:"#D2E7E4",base08:"#3E9688",base09:"#3E7996",base0A:"#3E4C96",base0B:"#883E96",base0C:"#963E4C",base0D:"#96883E",base0E:"#4C963E",base0F:"#3E965B"},e.exports=t.default},function(e,t,n){"use strict";t.__esModule=!0,t.default={scheme:"ashes",author:"jannik siebert (https://github.com/janniks)",base00:"#1C2023",base01:"#393F45",base02:"#565E65",base03:"#747C84",base04:"#ADB3BA",base05:"#C7CCD1",base06:"#DFE2E5",base07:"#F3F4F5",base08:"#C7AE95",base09:"#C7C795",base0A:"#AEC795",base0B:"#95C7AE",base0C:"#95AEC7",base0D:"#AE95C7",base0E:"#C795AE",base0F:"#C79595"},e.exports=t.default},function(e,t,n){"use strict";t.__esModule=!0,t.default={scheme:"atelier dune",author:"bram de haan (http://atelierbram.github.io/syntax-highlighting/atelier-schemes/dune)",base00:"#20201d",base01:"#292824",base02:"#6e6b5e",base03:"#7d7a68",base04:"#999580",base05:"#a6a28c",base06:"#e8e4cf",base07:"#fefbec",base08:"#d73737",base09:"#b65611",base0A:"#cfb017",base0B:"#60ac39",base0C:"#1fad83",base0D:"#6684e1",base0E:"#b854d4",base0F:"#d43552"},e.exports=t.default},function(e,t,n){"use strict";t.__esModule=!0,t.default={scheme:"atelier forest",author:"bram de haan (http://atelierbram.github.io/syntax-highlighting/atelier-schemes/forest)",base00:"#1b1918",base01:"#2c2421",base02:"#68615e",base03:"#766e6b",base04:"#9c9491",base05:"#a8a19f",base06:"#e6e2e0",base07:"#f1efee",base08:"#f22c40",base09:"#df5320",base0A:"#d5911a",base0B:"#5ab738",base0C:"#00ad9c",base0D:"#407ee7",base0E:"#6666ea",base0F:"#c33ff3"},e.exports=t.default},function(e,t,n){"use strict";t.__esModule=!0,t.default={scheme:"atelier heath",author:"bram de haan (http://atelierbram.github.io/syntax-highlighting/atelier-schemes/heath)",base00:"#1b181b",base01:"#292329",base02:"#695d69",base03:"#776977",base04:"#9e8f9e",base05:"#ab9bab",base06:"#d8cad8",base07:"#f7f3f7",base08:"#ca402b",base09:"#a65926",base0A:"#bb8a35",base0B:"#379a37",base0C:"#159393",base0D:"#516aec",base0E:"#7b59c0",base0F:"#cc33cc"},e.exports=t.default},function(e,t,n){"use strict";t.__esModule=!0,t.default={scheme:"atelier lakeside",author:"bram de haan (http://atelierbram.github.io/syntax-highlighting/atelier-schemes/lakeside/)",base00:"#161b1d",base01:"#1f292e",base02:"#516d7b",base03:"#5a7b8c",base04:"#7195a8",base05:"#7ea2b4",base06:"#c1e4f6",base07:"#ebf8ff",base08:"#d22d72",base09:"#935c25",base0A:"#8a8a0f",base0B:"#568c3b",base0C:"#2d8f6f",base0D:"#257fad",base0E:"#5d5db1",base0F:"#b72dd2"},e.exports=t.default},function(e,t,n){"use strict";t.__esModule=!0,t.default={scheme:"atelier seaside",author:"bram de haan (http://atelierbram.github.io/syntax-highlighting/atelier-schemes/seaside/)",base00:"#131513",base01:"#242924",base02:"#5e6e5e",base03:"#687d68",base04:"#809980",base05:"#8ca68c",base06:"#cfe8cf",base07:"#f0fff0",base08:"#e6193c",base09:"#87711d",base0A:"#c3c322",base0B:"#29a329",base0C:"#1999b3",base0D:"#3d62f5",base0E:"#ad2bee",base0F:"#e619c3"},e.exports=t.default},function(e,t,n){"use strict";t.__esModule=!0,t.default={scheme:"bespin",author:"jan t. sott",base00:"#28211c",base01:"#36312e",base02:"#5e5d5c",base03:"#666666",base04:"#797977",base05:"#8a8986",base06:"#9d9b97",base07:"#baae9e",base08:"#cf6a4c",base09:"#cf7d34",base0A:"#f9ee98",base0B:"#54be0d",base0C:"#afc4db",base0D:"#5ea6ea",base0E:"#9b859d",base0F:"#937121"},e.exports=t.default},function(e,t,n){"use strict";t.__esModule=!0,t.default={scheme:"brewer",author:"timothée poisot (http://github.com/tpoisot)",base00:"#0c0d0e",base01:"#2e2f30",base02:"#515253",base03:"#737475",base04:"#959697",base05:"#b7b8b9",base06:"#dadbdc",base07:"#fcfdfe",base08:"#e31a1c",base09:"#e6550d",base0A:"#dca060",base0B:"#31a354",base0C:"#80b1d3",base0D:"#3182bd",base0E:"#756bb1",base0F:"#b15928"},e.exports=t.default},function(e,t,n){"use strict";t.__esModule=!0,t.default={scheme:"bright",author:"chris kempson (http://chriskempson.com)",base00:"#000000",base01:"#303030",base02:"#505050",base03:"#b0b0b0",base04:"#d0d0d0",base05:"#e0e0e0",base06:"#f5f5f5",base07:"#ffffff",base08:"#fb0120",base09:"#fc6d24",base0A:"#fda331",base0B:"#a1c659",base0C:"#76c7b7",base0D:"#6fb3d2",base0E:"#d381c3",base0F:"#be643c"},e.exports=t.default},function(e,t,n){"use strict";t.__esModule=!0,t.default={scheme:"chalk",author:"chris kempson (http://chriskempson.com)",base00:"#151515",base01:"#202020",base02:"#303030",base03:"#505050",base04:"#b0b0b0",base05:"#d0d0d0",base06:"#e0e0e0",base07:"#f5f5f5",base08:"#fb9fb1",base09:"#eda987",base0A:"#ddb26f",base0B:"#acc267",base0C:"#12cfc0",base0D:"#6fc2ef",base0E:"#e1a3ee",base0F:"#deaf8f"},e.exports=t.default},function(e,t,n){"use strict";t.__esModule=!0,t.default={scheme:"codeschool",author:"brettof86",base00:"#232c31",base01:"#1c3657",base02:"#2a343a",base03:"#3f4944",base04:"#84898c",base05:"#9ea7a6",base06:"#a7cfa3",base07:"#b5d8f6",base08:"#2a5491",base09:"#43820d",base0A:"#a03b1e",base0B:"#237986",base0C:"#b02f30",base0D:"#484d79",base0E:"#c59820",base0F:"#c98344"},e.exports=t.default},function(e,t,n){"use strict";t.__esModule=!0,t.default={scheme:"colors",author:"mrmrs (http://clrs.cc)",base00:"#111111",base01:"#333333",base02:"#555555",base03:"#777777",base04:"#999999",base05:"#bbbbbb",base06:"#dddddd",base07:"#ffffff",base08:"#ff4136",base09:"#ff851b",base0A:"#ffdc00",base0B:"#2ecc40",base0C:"#7fdbff",base0D:"#0074d9",base0E:"#b10dc9",base0F:"#85144b"},e.exports=t.default},function(e,t,n){"use strict";t.__esModule=!0,t.default={scheme:"default",author:"chris kempson (http://chriskempson.com)",base00:"#181818",base01:"#282828",base02:"#383838",base03:"#585858",base04:"#b8b8b8",base05:"#d8d8d8",base06:"#e8e8e8",base07:"#f8f8f8",base08:"#ab4642",base09:"#dc9656",base0A:"#f7ca88",base0B:"#a1b56c",base0C:"#86c1b9",base0D:"#7cafc2",base0E:"#ba8baf",base0F:"#a16946"},e.exports=t.default},function(e,t,n){"use strict";t.__esModule=!0,t.default={scheme:"eighties",author:"chris kempson (http://chriskempson.com)",base00:"#2d2d2d",base01:"#393939",base02:"#515151",base03:"#747369",base04:"#a09f93",base05:"#d3d0c8",base06:"#e8e6df",base07:"#f2f0ec",base08:"#f2777a",base09:"#f99157",base0A:"#ffcc66",base0B:"#99cc99",base0C:"#66cccc",base0D:"#6699cc",base0E:"#cc99cc",base0F:"#d27b53"},e.exports=t.default},function(e,t,n){"use strict";t.__esModule=!0,t.default={scheme:"embers",author:"jannik siebert (https://github.com/janniks)",base00:"#16130F",base01:"#2C2620",base02:"#433B32",base03:"#5A5047",base04:"#8A8075",base05:"#A39A90",base06:"#BEB6AE",base07:"#DBD6D1",base08:"#826D57",base09:"#828257",base0A:"#6D8257",base0B:"#57826D",base0C:"#576D82",base0D:"#6D5782",base0E:"#82576D",base0F:"#825757"},e.exports=t.default},function(e,t,n){"use strict";t.__esModule=!0,t.default={scheme:"flat",author:"chris kempson (http://chriskempson.com)",base00:"#2C3E50",base01:"#34495E",base02:"#7F8C8D",base03:"#95A5A6",base04:"#BDC3C7",base05:"#e0e0e0",base06:"#f5f5f5",base07:"#ECF0F1",base08:"#E74C3C",base09:"#E67E22",base0A:"#F1C40F",base0B:"#2ECC71",base0C:"#1ABC9C",base0D:"#3498DB",base0E:"#9B59B6",base0F:"#be643c"},e.exports=t.default},function(e,t,n){"use strict";t.__esModule=!0,t.default={scheme:"google",author:"seth wright (http://sethawright.com)",base00:"#1d1f21",base01:"#282a2e",base02:"#373b41",base03:"#969896",base04:"#b4b7b4",base05:"#c5c8c6",base06:"#e0e0e0",base07:"#ffffff",base08:"#CC342B",base09:"#F96A38",base0A:"#FBA922",base0B:"#198844",base0C:"#3971ED",base0D:"#3971ED",base0E:"#A36AC7",base0F:"#3971ED"},e.exports=t.default},function(e,t,n){"use strict";t.__esModule=!0,t.default={scheme:"grayscale",author:"alexandre gavioli (https://github.com/alexx2/)",base00:"#101010",base01:"#252525",base02:"#464646",base03:"#525252",base04:"#ababab",base05:"#b9b9b9",base06:"#e3e3e3",base07:"#f7f7f7",base08:"#7c7c7c",base09:"#999999",base0A:"#a0a0a0",base0B:"#8e8e8e",base0C:"#868686",base0D:"#686868",base0E:"#747474",base0F:"#5e5e5e"},e.exports=t.default},function(e,t,n){"use strict";t.__esModule=!0,t.default={scheme:"green screen",author:"chris kempson (http://chriskempson.com)",base00:"#001100",base01:"#003300",base02:"#005500",base03:"#007700",base04:"#009900",base05:"#00bb00",base06:"#00dd00",base07:"#00ff00",base08:"#007700",base09:"#009900",base0A:"#007700",base0B:"#00bb00",base0C:"#005500",base0D:"#009900",base0E:"#00bb00",base0F:"#005500"},e.exports=t.default},function(e,t,n){"use strict";t.__esModule=!0,t.default={scheme:"harmonic16",author:"jannik siebert (https://github.com/janniks)",base00:"#0b1c2c",base01:"#223b54",base02:"#405c79",base03:"#627e99",base04:"#aabcce",base05:"#cbd6e2",base06:"#e5ebf1",base07:"#f7f9fb",base08:"#bf8b56",base09:"#bfbf56",base0A:"#8bbf56",base0B:"#56bf8b",base0C:"#568bbf",base0D:"#8b56bf",base0E:"#bf568b",base0F:"#bf5656"},e.exports=t.default},function(e,t,n){"use strict";t.__esModule=!0,t.default={scheme:"hopscotch",author:"jan t. sott",base00:"#322931",base01:"#433b42",base02:"#5c545b",base03:"#797379",base04:"#989498",base05:"#b9b5b8",base06:"#d5d3d5",base07:"#ffffff",base08:"#dd464c",base09:"#fd8b19",base0A:"#fdcc59",base0B:"#8fc13e",base0C:"#149b93",base0D:"#1290bf",base0E:"#c85e7c",base0F:"#b33508"},e.exports=t.default},function(e,t,n){"use strict";t.__esModule=!0,t.default={scheme:"isotope",author:"jan t. sott",base00:"#000000",base01:"#404040",base02:"#606060",base03:"#808080",base04:"#c0c0c0",base05:"#d0d0d0",base06:"#e0e0e0",base07:"#ffffff",base08:"#ff0000",base09:"#ff9900",base0A:"#ff0099",base0B:"#33ff00",base0C:"#00ffff",base0D:"#0066ff",base0E:"#cc00ff",base0F:"#3300ff"},e.exports=t.default},function(e,t,n){"use strict";t.__esModule=!0,t.default={scheme:"marrakesh",author:"alexandre gavioli (http://github.com/alexx2/)",base00:"#201602",base01:"#302e00",base02:"#5f5b17",base03:"#6c6823",base04:"#86813b",base05:"#948e48",base06:"#ccc37a",base07:"#faf0a5",base08:"#c35359",base09:"#b36144",base0A:"#a88339",base0B:"#18974e",base0C:"#75a738",base0D:"#477ca1",base0E:"#8868b3",base0F:"#b3588e"},e.exports=t.default},function(e,t,n){"use strict";t.__esModule=!0,t.default={scheme:"mocha",author:"chris kempson (http://chriskempson.com)",base00:"#3B3228",base01:"#534636",base02:"#645240",base03:"#7e705a",base04:"#b8afad",base05:"#d0c8c6",base06:"#e9e1dd",base07:"#f5eeeb",base08:"#cb6077",base09:"#d28b71",base0A:"#f4bc87",base0B:"#beb55b",base0C:"#7bbda4",base0D:"#8ab3b5",base0E:"#a89bb9",base0F:"#bb9584"},e.exports=t.default},function(e,t,n){"use strict";t.__esModule=!0,t.default={scheme:"monokai",author:"wimer hazenberg (http://www.monokai.nl)",base00:"#272822",base01:"#383830",base02:"#49483e",base03:"#75715e",base04:"#a59f85",base05:"#f8f8f2",base06:"#f5f4f1",base07:"#f9f8f5",base08:"#f92672",base09:"#fd971f",base0A:"#f4bf75",base0B:"#a6e22e",base0C:"#a1efe4",base0D:"#66d9ef",base0E:"#ae81ff",base0F:"#cc6633"},e.exports=t.default},function(e,t,n){"use strict";t.__esModule=!0,t.default={scheme:"ocean",author:"chris kempson (http://chriskempson.com)",base00:"#2b303b",base01:"#343d46",base02:"#4f5b66",base03:"#65737e",base04:"#a7adba",base05:"#c0c5ce",base06:"#dfe1e8",base07:"#eff1f5",base08:"#bf616a",base09:"#d08770",base0A:"#ebcb8b",base0B:"#a3be8c",base0C:"#96b5b4",base0D:"#8fa1b3",base0E:"#b48ead",base0F:"#ab7967"},e.exports=t.default},function(e,t,n){"use strict";t.__esModule=!0,t.default={scheme:"paraiso",author:"jan t. sott",base00:"#2f1e2e",base01:"#41323f",base02:"#4f424c",base03:"#776e71",base04:"#8d8687",base05:"#a39e9b",base06:"#b9b6b0",base07:"#e7e9db",base08:"#ef6155",base09:"#f99b15",base0A:"#fec418",base0B:"#48b685",base0C:"#5bc4bf",base0D:"#06b6ef",base0E:"#815ba4",base0F:"#e96ba8"},e.exports=t.default},function(e,t,n){"use strict";t.__esModule=!0,t.default={scheme:"pop",author:"chris kempson (http://chriskempson.com)",base00:"#000000",base01:"#202020",base02:"#303030",base03:"#505050",base04:"#b0b0b0",base05:"#d0d0d0",base06:"#e0e0e0",base07:"#ffffff",base08:"#eb008a",base09:"#f29333",base0A:"#f8ca12",base0B:"#37b349",base0C:"#00aabb",base0D:"#0e5a94",base0E:"#b31e8d",base0F:"#7a2d00"},e.exports=t.default},function(e,t,n){"use strict";t.__esModule=!0,t.default={scheme:"railscasts",author:"ryan bates (http://railscasts.com)",base00:"#2b2b2b",base01:"#272935",base02:"#3a4055",base03:"#5a647e",base04:"#d4cfc9",base05:"#e6e1dc",base06:"#f4f1ed",base07:"#f9f7f3",base08:"#da4939",base09:"#cc7833",base0A:"#ffc66d",base0B:"#a5c261",base0C:"#519f50",base0D:"#6d9cbe",base0E:"#b6b3eb",base0F:"#bc9458"},e.exports=t.default},function(e,t,n){"use strict";t.__esModule=!0,t.default={scheme:"shapeshifter",author:"tyler benziger (http://tybenz.com)",base00:"#000000",base01:"#040404",base02:"#102015",base03:"#343434",base04:"#555555",base05:"#ababab",base06:"#e0e0e0",base07:"#f9f9f9",base08:"#e92f2f",base09:"#e09448",base0A:"#dddd13",base0B:"#0ed839",base0C:"#23edda",base0D:"#3b48e3",base0E:"#f996e2",base0F:"#69542d"},e.exports=t.default},function(e,t,n){"use strict";t.__esModule=!0,t.default={scheme:"solarized",author:"ethan schoonover (http://ethanschoonover.com/solarized)",base00:"#002b36",base01:"#073642",base02:"#586e75",base03:"#657b83",base04:"#839496",base05:"#93a1a1",base06:"#eee8d5",base07:"#fdf6e3",base08:"#dc322f",base09:"#cb4b16",base0A:"#b58900",base0B:"#859900",base0C:"#2aa198",base0D:"#268bd2",base0E:"#6c71c4",base0F:"#d33682"},e.exports=t.default},function(e,t,n){"use strict";t.__esModule=!0,t.default={scheme:"summerfruit",author:"christopher corley (http://cscorley.github.io/)",base00:"#151515",base01:"#202020",base02:"#303030",base03:"#505050",base04:"#B0B0B0",base05:"#D0D0D0",base06:"#E0E0E0",base07:"#FFFFFF",base08:"#FF0086",base09:"#FD8900",base0A:"#ABA800",base0B:"#00C918",base0C:"#1faaaa",base0D:"#3777E6",base0E:"#AD00A1",base0F:"#cc6633"},e.exports=t.default},function(e,t,n){"use strict";t.__esModule=!0,t.default={scheme:"tomorrow",author:"chris kempson (http://chriskempson.com)",base00:"#1d1f21",base01:"#282a2e",base02:"#373b41",base03:"#969896",base04:"#b4b7b4",base05:"#c5c8c6",base06:"#e0e0e0",base07:"#ffffff",base08:"#cc6666",base09:"#de935f",base0A:"#f0c674",base0B:"#b5bd68",base0C:"#8abeb7",base0D:"#81a2be",base0E:"#b294bb",base0F:"#a3685a"},e.exports=t.default},function(e,t,n){"use strict";t.__esModule=!0,t.default={scheme:"london tube",author:"jan t. sott",base00:"#231f20",base01:"#1c3f95",base02:"#5a5758",base03:"#737171",base04:"#959ca1",base05:"#d9d8d8",base06:"#e7e7e8",base07:"#ffffff",base08:"#ee2e24",base09:"#f386a1",base0A:"#ffd204",base0B:"#00853e",base0C:"#85cebc",base0D:"#009ddc",base0E:"#98005d",base0F:"#b06110"},e.exports=t.default},function(e,t,n){"use strict";t.__esModule=!0,t.default={scheme:"twilight",author:"david hart (http://hart-dev.com)",base00:"#1e1e1e",base01:"#323537",base02:"#464b50",base03:"#5f5a60",base04:"#838184",base05:"#a7a7a7",base06:"#c3c3c3",base07:"#ffffff",base08:"#cf6a4c",base09:"#cda869",base0A:"#f9ee98",base0B:"#8f9d6a",base0C:"#afc4db",base0D:"#7587a6",base0E:"#9b859d",base0F:"#9b703f"},e.exports=t.default},function(e,t,n){function r(e){var t=Math.round(o(e,0,255)),n=t.toString(16);return 1==n.length?"0"+n:n}function a(e){var t=4===e.length?r(255*e[3]):"";return"#"+r(e[0])+r(e[1])+r(e[2])+t}var o=n(40);e.exports=a},function(e,t,n){function r(e){var t=o(e),n=u(t);return 4===t.length&&n.push(t[3]),n}function a(e){for(var t in l)if(0===e.indexOf(t))return l[t](e)}var o=n(152),i=n(153),s=n(154),u=n(155),l={"#":i,hsl:r,rgb:s};a.rgb=s,a.hsl=o,a.hex=i,e.exports=a},function(e,t,n){function r(e,t){switch(e=parseFloat(e),t){case 0:return i(e,0,360);case 1:case 2:return i(e,0,100);case 3:return i(e,0,1)}}function a(e){return o(e).map(r)}var o=n(53),i=n(40);e.exports=a},function(e,t){function n(e){for(var t="#",n=1;n<e.length;n++){var r=e.charAt(n);t+=r+r}return t}function r(e){4!==e.length&&5!==e.length||(e=n(e));var t=[parseInt(e.substring(1,3),16),parseInt(e.substring(3,5),16),parseInt(e.substring(5,7),16)];if(9===e.length){var r=parseFloat((parseInt(e.substring(7,9),16)/255).toFixed(2));t.push(r)}return t}e.exports=r},function(e,t,n){function r(e,t){return t<3?-1!=e.indexOf("%")?Math.round(255*i(parseInt(e,10),0,100)/100):i(parseInt(e,10),0,255):i(parseFloat(e),0,1)}function a(e){return o(e).map(r)}var o=n(53),i=n(40);e.exports=a},function(e,t){function n(e){var t,n,r,a,o,i=e[0]/360,s=e[1]/100,u=e[2]/100;if(0==s)return o=255*u,[o,o,o];n=u<.5?u*(1+s):u+s-u*s,t=2*u-n,a=[0,0,0];for(var l=0;l<3;l++)r=i+1/3*-(l-1),r<0&&r++,r>1&&r--,o=6*r<1?t+6*(n-t)*r:2*r<1?n:3*r<2?t+(n-t)*(2/3-r)*6:t,a[l]=255*o;return a}e.exports=n},function(e,t,n){(function(t){function n(e,t,n){switch(n.length){case 0:return e.call(t);case 1:return e.call(t,n[0]);case 2:return e.call(t,n[0],n[1]);case 3:return e.call(t,n[0],n[1],n[2])}return e.apply(t,n)}function r(e,t){for(var n=-1,r=t.length,a=e.length;++n<r;)e[a+n]=t[n];return e}function a(e,t,n,o,s){var u=-1,l=e.length;for(n||(n=i),s||(s=[]);++u<l;){var c=e[u];t>0&&n(c)?t>1?a(c,t-1,n,o,s):r(s,c):o||(s[s.length]=c)}return s}function o(e,t){return t=k(void 0===t?e.length-1:t,0),function(){for(var r=arguments,a=-1,o=k(r.length-t,0),i=Array(o);++a<o;)i[a]=r[t+a];a=-1;for(var s=Array(t+1);++a<t;)s[a]=r[a];return s[t]=i,n(e,this,s)}}function i(e){return P(e)||s(e)||!!(C&&e&&e[C])}function s(e){return l(e)&&O.call(e,"callee")&&(!x.call(e,"callee")||E.call(e)==h)}function u(e){return null!=e&&f(e.length)&&!c(e)}function l(e){return p(e)&&u(e)}function c(e){var t=d(e)?E.call(e):"";return t==y||t==v}function f(e){return"number"==typeof e&&e>-1&&e%1==0&&e<=b}function d(e){var t=typeof e;return!!e&&("object"==t||"function"==t)}function p(e){return!!e&&"object"==typeof e}var b=9007199254740991,h="[object Arguments]",y="[object Function]",v="[object GeneratorFunction]",m="object"==typeof t&&t&&t.Object===Object&&t,g="object"==typeof self&&self&&self.Object===Object&&self,_=m||g||Function("return this")(),j=Object.prototype,O=j.hasOwnProperty,E=j.toString,w=_.Symbol,x=j.propertyIsEnumerable,C=w?w.isConcatSpreadable:void 0,k=Math.max,P=Array.isArray,S=function(e){return o(function(e){e=a(e,1);var t=e.length,n=t;for(void 0;n--;)if("function"!=typeof e[n])throw new TypeError("Expected a function");return function(){for(var n=0,r=t?e[n].apply(this,arguments):arguments[0];++n<t;)r=e[n].call(this,r);return r}})}();e.exports=S}).call(t,n(52))},function(e,t,n){"use strict";function r(e){var t,n,r,a=e[0],o=e[1],i=e[2];return t=1*a+0*o+1.13983*i,n=1*a+-.39465*o+-.5806*i,r=1*a+2.02311*o+0*i,t=Math.min(Math.max(0,t),1),n=Math.min(Math.max(0,n),1),r=Math.min(Math.max(0,r),1),[255*t,255*n,255*r]}function a(e){var t=e[0]/255,n=e[1]/255,r=e[2]/255;return[.299*t+.587*n+.114*r,-.14713*t+-.28886*n+.436*r,.615*t+-.51499*n+-.10001*r]}Object.defineProperty(t,"__esModule",{value:!0}),t.yuv2rgb=r,t.rgb2yuv=a},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function a(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function o(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function i(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var s=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},u=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),l=n(0),c=r(l),f=n(6),d=r(f),p=n(1),b=r(p),h=function(e){function t(){return a(this,t),o(this,(t.__proto__||Object.getPrototypeOf(t)).apply(this,arguments))}return i(t,e),u(t,[{key:"render",value:function(){var e=this.props,t={weekday:"short",year:"numeric",month:"short",day:"numeric",hour:"2-digit",minute:"2-digit"};return c.default.createElement("div",(0,b.default)(e.theme,"date"),c.default.createElement(d.default,s({type_name:"date"},e)),c.default.createElement("span",s({className:"date-value"},(0,b.default)(e.theme,"date-value")),e.value.toLocaleTimeString("en-us",t)))}}]),t}(c.default.PureComponent);t.default=h},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function a(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function o(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function i(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var s=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},u=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),l=n(0),c=r(l),f=n(6),d=r(f),p=n(1),b=r(p),h=function(e){function t(){return a(this,t),o(this,(t.__proto__||Object.getPrototypeOf(t)).apply(this,arguments))}return i(t,e),u(t,[{key:"render",value:function(){var e=this.props;return c.default.createElement("div",(0,b.default)(e.theme,"float"),c.default.createElement(d.default,s({type_name:"float"},e)),this.props.value)}}]),t}(c.default.PureComponent);t.default=h},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function a(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function o(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function i(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var s=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},u=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),l=n(0),c=r(l),f=n(6),d=r(f),p=n(1),b=r(p),h=n(13),y=r(h),v=function(e){function t(e){a(this,t);var n=o(this,(t.__proto__||Object.getPrototypeOf(t)).call(this,e));return m.call(n),n.state={collapsed:y.default.get(e.rjvId,e.namespace,"collapsed",!0)},n}return i(t,e),u(t,[{key:"render",value:function(){var e=this.props,t=this.state.collapsed;return c.default.createElement("div",(0,b.default)(e.theme,"function"),c.default.createElement(d.default,s({type_name:"function"},e)),c.default.createElement("span",s({},(0,b.default)(e.theme,"function-value"),{className:"rjv-function-container",onClick:this.toggleCollapsed}),this.getFunctionDisplay(t)))}}]),t}(c.default.PureComponent),m=function(){var e=this;this.toggleCollapsed=function(){e.setState({collapsed:!e.state.collapsed},function(){y.default.set(e.props.rjvId,e.props.namespace,"collapsed",e.state.collapsed)})},this.getFunctionDisplay=function(t){var n=e.props;return t?c.default.createElement("span",null,e.props.value.toString().slice(9,-1).replace(/\{[\s\S]+/,""),c.default.createElement("span",{className:"function-collapsed",style:{fontWeight:"bold"}},c.default.createElement("span",null,"{"),c.default.createElement("span",(0,b.default)(n.theme,"ellipsis"),"..."),c.default.createElement("span",null,"}"))):e.props.value.toString().slice(9,-1)}};t.default=v},function(e,t){function n(){this._events=this._events||{},this._maxListeners=this._maxListeners||void 0}function r(e){return"function"==typeof e}function a(e){return"number"==typeof e}function o(e){return"object"==typeof e&&null!==e}function i(e){return void 0===e}e.exports=n,n.EventEmitter=n,n.prototype._events=void 0,n.prototype._maxListeners=void 0,n.defaultMaxListeners=10,n.prototype.setMaxListeners=function(e){if(!a(e)||e<0||isNaN(e))throw TypeError("n must be a positive number");return this._maxListeners=e,this},n.prototype.emit=function(e){var t,n,a,s,u,l;if(this._events||(this._events={}),"error"===e&&(!this._events.error||o(this._events.error)&&!this._events.error.length)){if((t=arguments[1])instanceof Error)throw t;var c=new Error('Uncaught, unspecified "error" event. ('+t+")");throw c.context=t,c}if(n=this._events[e],i(n))return!1;if(r(n))switch(arguments.length){case 1:n.call(this);break;case 2:n.call(this,arguments[1]);break;case 3:n.call(this,arguments[1],arguments[2]);break;default:s=Array.prototype.slice.call(arguments,1),n.apply(this,s)}else if(o(n))for(s=Array.prototype.slice.call(arguments,1),l=n.slice(),a=l.length,u=0;u<a;u++)l[u].apply(this,s);return!0},n.prototype.addListener=function(e,t){var a;if(!r(t))throw TypeError("listener must be a function");return this._events||(this._events={}),this._events.newListener&&this.emit("newListener",e,r(t.listener)?t.listener:t),this._events[e]?o(this._events[e])?this._events[e].push(t):this._events[e]=[this._events[e],t]:this._events[e]=t,o(this._events[e])&&!this._events[e].warned&&(a=i(this._maxListeners)?n.defaultMaxListeners:this._maxListeners)&&a>0&&this._events[e].length>a&&(this._events[e].warned=!0,console.error("(node) warning: possible EventEmitter memory leak detected. %d listeners added. Use emitter.setMaxListeners() to increase limit.",this._events[e].length),"function"==typeof console.trace&&console.trace()),this},n.prototype.on=n.prototype.addListener,n.prototype.once=function(e,t){function n(){this.removeListener(e,n),a||(a=!0,t.apply(this,arguments))}if(!r(t))throw TypeError("listener must be a function");var a=!1;return n.listener=t,this.on(e,n),this},n.prototype.removeListener=function(e,t){var n,a,i,s;if(!r(t))throw TypeError("listener must be a function");if(!this._events||!this._events[e])return this;if(n=this._events[e],i=n.length,a=-1,n===t||r(n.listener)&&n.listener===t)delete this._events[e],this._events.removeListener&&this.emit("removeListener",e,t);else if(o(n)){for(s=i;s-- >0;)if(n[s]===t||n[s].listener&&n[s].listener===t){a=s;break}if(a<0)return this;1===n.length?(n.length=0,delete this._events[e]):n.splice(a,1),this._events.removeListener&&this.emit("removeListener",e,t)}return this},n.prototype.removeAllListeners=function(e){var t,n;if(!this._events)return this;if(!this._events.removeListener)return 0===arguments.length?this._events={}:this._events[e]&&delete this._events[e],this;if(0===arguments.length){for(t in this._events)"removeListener"!==t&&this.removeAllListeners(t);return this.removeAllListeners("removeListener"),this._events={},this}if(n=this._events[e],r(n))this.removeListener(e,n);else if(n)for(;n.length;)this.removeListener(e,n[n.length-1]);return delete this._events[e],this},n.prototype.listeners=function(e){return this._events&&this._events[e]?r(this._events[e])?[this._events[e]]:this._events[e].slice():[]},n.prototype.listenerCount=function(e){if(this._events){var t=this._events[e];if(r(t))return 1;if(t)return t.length}return 0},n.listenerCount=function(e,t){return e.listenerCount(t)}},function(e,t,n){e.exports.Dispatcher=n(163)},function(e,t,n){"use strict";function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}t.__esModule=!0;var a=n(164),o=function(){function e(){r(this,e),this._callbacks={},this._isDispatching=!1,this._isHandled={},this._isPending={},this._lastID=1}return e.prototype.register=function(e){var t="ID_"+this._lastID++;return this._callbacks[t]=e,t},e.prototype.unregister=function(e){this._callbacks[e]||a(!1),delete this._callbacks[e]},e.prototype.waitFor=function(e){this._isDispatching||a(!1);for(var t=0;t<e.length;t++){var n=e[t];this._isPending[n]?this._isHandled[n]||a(!1):(this._callbacks[n]||a(!1),this._invokeCallback(n))}},e.prototype.dispatch=function(e){this._isDispatching&&a(!1),this._startDispatching(e);try{for(var t in this._callbacks)this._isPending[t]||this._invokeCallback(t)}finally{this._stopDispatching()}},e.prototype.isDispatching=function(){return this._isDispatching},e.prototype._invokeCallback=function(e){this._isPending[e]=!0,this._callbacks[e](this._pendingPayload),this._isHandled[e]=!0},e.prototype._startDispatching=function(e){for(var t in this._callbacks)this._isPending[t]=!1,this._isHandled[t]=!1;this._pendingPayload=e,this._isDispatching=!0},e.prototype._stopDispatching=function(){delete this._pendingPayload,this._isDispatching=!1},e}();e.exports=o},function(e,t,n){"use strict";function r(e,t,n,r,o,i,s,u){if(a(t),!e){var l;if(void 0===t)l=new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else{var c=[n,r,o,i,s,u],f=0;l=new Error(t.replace(/%s/g,function(){return c[f++]})),l.name="Invariant Violation"}throw l.framesToPop=1,l}}var a=function(e){};e.exports=r},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function a(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function o(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function i(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var s=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),u=n(0),l=r(u),c=n(1),f=r(c),d=function(e){function t(){return a(this,t),o(this,(t.__proto__||Object.getPrototypeOf(t)).apply(this,arguments))}return i(t,e),s(t,[{key:"render",value:function(){return l.default.createElement("div",(0,f.default)(this.props.theme,"nan"),"NaN")}}]),t}(l.default.PureComponent);t.default=d},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function a(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function o(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function i(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var s=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),u=n(0),l=r(u),c=n(1),f=r(c),d=function(e){function t(){return a(this,t),o(this,(t.__proto__||Object.getPrototypeOf(t)).apply(this,arguments))}return i(t,e),s(t,[{key:"render",value:function(){return l.default.createElement("div",(0,f.default)(this.props.theme,"null"),"NULL")}}]),t}(l.default.PureComponent);t.default=d},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function a(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function o(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function i(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var s=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},u=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),l=n(0),c=r(l),f=n(6),d=r(f),p=n(1),b=r(p),h=function(e){function t(){return a(this,t),o(this,(t.__proto__||Object.getPrototypeOf(t)).apply(this,arguments))}return i(t,e),u(t,[{key:"render",value:function(){var e=this.props;return c.default.createElement("div",(0,b.default)(e.theme,"integer"),c.default.createElement(d.default,s({type_name:"int"},e)),this.props.value)}}]),t}(c.default.PureComponent);t.default=h},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function a(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function o(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function i(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var s=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},u=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),l=n(0),c=r(l),f=n(6),d=r(f),p=n(1),b=r(p),h=function(e){function t(){return a(this,t),o(this,(t.__proto__||Object.getPrototypeOf(t)).apply(this,arguments))}return i(t,e),u(t,[{key:"render",value:function(){var e=this.props;return c.default.createElement("div",(0,b.default)(e.theme,"regexp"),c.default.createElement(d.default,s({type_name:"regexp"},e)),this.props.value.toString())}}]),t}(c.default.PureComponent);t.default=h},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function a(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function o(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function i(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var s=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},u=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),l=n(0),c=r(l),f=n(6),d=r(f),p=n(4),b=n(1),h=r(b),y=n(13),v=r(y),m=function(e){function t(e){a(this,t);var n=o(this,(t.__proto__||Object.getPrototypeOf(t)).call(this,e));return n.toggleCollapsed=function(){n.setState({collapsed:!n.state.collapsed},function(){v.default.set(n.props.rjvId,n.props.namespace,"collapsed",n.state.collapsed)})},n.state={collapsed:v.default.get(e.rjvId,e.namespace,"collapsed",!0)},n}return i(t,e),u(t,[{key:"render",value:function(){var e=(this.state.collapsed,this.props),t=e.collapseStringsAfterLength,n=e.theme,r=e.value,a="integer"===(0,p.toType)(t),o={style:{cursor:"default"}};return a&&r.length>t&&(o.style.cursor="pointer",this.state.collapsed&&(r=c.default.createElement("span",null,r.substring(0,t),c.default.createElement("span",(0,h.default)(n,"ellipsis")," ...")))),c.default.createElement("div",(0,h.default)(n,"string"),c.default.createElement(d.default,s({type_name:"string"},e)),c.default.createElement("span",s({className:"string-value"},o,{onClick:this.toggleCollapsed}),'"',r,'"'))}}]),t}(c.default.PureComponent);t.default=m},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function a(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function o(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function i(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var s=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),u=n(0),l=r(u),c=n(1),f=r(c),d=function(e){function t(){return a(this,t),o(this,(t.__proto__||Object.getPrototypeOf(t)).apply(this,arguments))}return i(t,e),s(t,[{key:"render",value:function(){return l.default.createElement("div",(0,f.default)(this.props.theme,"undefined"),"undefined")}}]),t}(l.default.PureComponent);t.default=d},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function a(e){if(Array.isArray(e)){for(var t=0,n=Array(e.length);t<e.length;t++)n[t]=e[t];return n}return Array.from(e)}function o(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function i(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function s(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var u=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},l=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),c=n(0),f=r(c),d=n(172),p=r(d),b=(n(4),n(14)),h=r(b),y=n(176),v=r(y),m=n(54),g=r(m),_=n(55),j=r(_),O=n(42),E=n(15),w=n(1),x=r(w),C=function(e){function t(e){o(this,t);var n=i(this,(t.__proto__||Object.getPrototypeOf(t)).call(this,e));return k.call(n),n.state={editMode:!1,editValue:"",renameKey:!1,parsedInput:{type:!1,value:null}},n}return s(t,e),l(t,[{key:"render",value:function(){var e=this,t=this.props,n=t.variable,r=(t.src,t.singleIndent),o=t.type,i=t.theme,s=t.namespace,l=t.indentWidth,c=t.enableClipboard,d=t.onEdit,p=t.onDelete,b=t.onSelect,h=(t.rjvId,this.state.editMode);return f.default.createElement("div",u({},(0,x.default)(i,"objectKeyVal",{paddingLeft:l*r}),{className:"variable-row",key:n.name}),"array"==o?f.default.createElement("span",u({},(0,x.default)(i,"array-key"),{key:n.name+"_"+s}),n.name,f.default.createElement("div",(0,x.default)(i,"colon"),":")):f.default.createElement("span",null,f.default.createElement("span",u({},(0,x.default)(i,"object-name"),{className:"object-key",key:n.name+"_"+s}),f.default.createElement("span",{style:{verticalAlign:"top"}},'"'),f.default.createElement("span",{style:{display:"inline-block"}},n.name),f.default.createElement("span",{style:{verticalAlign:"top"}},'"')),f.default.createElement("span",(0,x.default)(i,"colon"),":")),f.default.createElement("div",u({className:"variable-value",onClick:!1===b&&!1===d?null:function(t){var r=[].concat(a(s));(t.ctrlKey||t.metaKey)&&!1!==d?e.prepopInput(n):!1!==b&&(r.shift(),b(u({},n,{namespace:r})))}},(0,x.default)(i,"variableValue",{cursor:!1===b?"default":"pointer"})),this.getValue(n,h)),c?f.default.createElement(j.default,u({hidden:h,src:n.value,clickCallback:c},{theme:i,namespace:s})):null,!1!==d&&0==h?this.getEditIcon():null,!1!==p&&0==h?this.getRemoveIcon():null)}}]),t}(f.default.PureComponent),k=function(){var e=this;this.getEditIcon=function(){var t=e.props,n=t.variable,r=t.theme;return f.default.createElement("div",{className:"click-to-edit",style:{verticalAlign:"top"}},f.default.createElement(E.Edit,u({className:"click-to-edit-icon"},(0,x.default)(r,"editVarIcon"),{onClick:function(){e.prepopInput(n)}})))},this.prepopInput=function(t){if(!1!==e.props.onEdit){var n=(0,g.default)(t.value),r=(0,v.default)(n);e.setState({editMode:!0,editValue:n,parsedInput:{type:r.type,value:r.value}})}},this.getRemoveIcon=function(){var t=e.props,n=t.variable,r=t.namespace,a=t.theme,o=t.rjvId;return f.default.createElement("div",{className:"click-to-remove",style:{verticalAlign:"top"}},f.default.createElement(E.RemoveCircle,u({className:"click-to-remove-icon"},(0,x.default)(a,"removeVarIcon"),{onClick:function(){h.default.dispatch({name:"VARIABLE_REMOVED",rjvId:o,data:{name:n.name,namespace:r,existing_value:n.value,variable_removed:!0}})}})))},this.getValue=function(t,n){var r=!n&&t.type,a=e.props;switch(r){case!1:return e.getEditInput();case"string":return f.default.createElement(O.JsonString,u({value:t.value},a));case"integer":return f.default.createElement(O.JsonInteger,u({value:t.value},a));case"float":return f.default.createElement(O.JsonFloat,u({value:t.value},a));case"boolean":return f.default.createElement(O.JsonBoolean,u({value:t.value},a));case"function":return f.default.createElement(O.JsonFunction,u({value:t.value},a));case"null":return f.default.createElement(O.JsonNull,a);case"nan":return f.default.createElement(O.JsonNan,a);case"undefined":return f.default.createElement(O.JsonUndefined,a);case"date":return f.default.createElement(O.JsonDate,u({value:t.value},a));case"regexp":return f.default.createElement(O.JsonRegexp,u({value:t.value},a));default:return f.default.createElement("div",{className:"object-value"},JSON.stringify(t.value))}},this.getEditInput=function(){var t=e.props.theme,n=e.state.editValue;return f.default.createElement("div",null,f.default.createElement(p.default,u({type:"text",inputRef:function(e){return e&&e.focus()},value:n,className:"variable-editor",onChange:function(t){var n=t.target.value,r=(0,v.default)(n);e.setState({editValue:n,parsedInput:{type:r.type,value:r.value}})},onKeyDown:function(t){switch(t.key){case"Escape":e.setState({editMode:!1,editValue:""});break;case"Enter":(t.ctrlKey||t.metaKey)&&e.submitEdit(!0)}t.stopPropagation()},placeholder:"update this value"},(0,x.default)(t,"edit-input"))),f.default.createElement("div",(0,x.default)(t,"edit-icon-container"),f.default.createElement(E.RemoveCircle,u({className:"edit-cancel"},(0,x.default)(t,"cancel-icon"),{onClick:function(){e.setState({editMode:!1,editValue:""})}})),f.default.createElement(E.CheckCircle,u({className:"edit-check string-value"},(0,x.default)(t,"check-icon"),{onClick:function(){e.submitEdit()}})),f.default.createElement("div",null,e.showDetected())))},this.submitEdit=function(t){var n=e.props,r=n.variable,a=n.namespace,o=n.rjvId,i=e.state,s=i.editValue,u=i.parsedInput,l=s;t&&u.type&&(l=u.value),e.setState({editMode:!1}),h.default.dispatch({name:"VARIABLE_UPDATED",rjvId:o,data:{name:r.name,namespace:a,existing_value:r.value,new_value:l,variable_removed:!1}})},this.showDetected=function(){var t=e.props,n=t.theme,r=(t.variable,t.namespace,t.rjvId,e.state.parsedInput),a=(r.type,r.value,e.getDetectedInput());if(a)return f.default.createElement("div",null,f.default.createElement("div",(0,x.default)(n,"detected-row"),a,f.default.createElement(E.CheckCircle,{className:"edit-check detected",style:u({verticalAlign:"top",paddingLeft:"3px"},(0,x.default)(n,"check-icon").style),onClick:function(){e.submitEdit(!0)}})))},this.getDetectedInput=function(){var t=e.state.parsedInput,n=t.type,r=t.value,a=e.props,o=a.theme;if(!1!==n)switch(n.toLowerCase()){case"object":return f.default.createElement("span",null,f.default.createElement("span",{style:u({},(0,x.default)(o,"brace").style,{cursor:"default"})},"{"),f.default.createElement("span",{style:u({},(0,x.default)(o,"ellipsis").style,{cursor:"default"})},"..."),f.default.createElement("span",{style:u({},(0,x.default)(o,"brace").style,{cursor:"default"})},"}"));case"array":return f.default.createElement("span",null,f.default.createElement("span",{style:u({},(0,x.default)(o,"brace").style,{cursor:"default"})},"["),f.default.createElement("span",{style:u({},(0,x.default)(o,"ellipsis").style,{cursor:"default"})},"..."),f.default.createElement("span",{style:u({},(0,x.default)(o,"brace").style,{cursor:"default"})},"]"));case"string":return f.default.createElement(O.JsonString,u({value:r},a));case"integer":return f.default.createElement(O.JsonInteger,u({value:r},a));case"float":return f.default.createElement(O.JsonFloat,u({value:r},a));case"boolean":return f.default.createElement(O.JsonBoolean,u({value:r},a));case"function":return f.default.createElement(O.JsonFunction,u({value:r},a));case"null":return f.default.createElement(O.JsonNull,a);case"nan":return f.default.createElement(O.JsonNan,a);case"undefined":return f.default.createElement(O.JsonUndefined,a);case"date":return f.default.createElement(O.JsonDate,u({value:new Date(r)},a))}}};t.default=C},function(e,t,n){"use strict";function r(){return r=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},r.apply(this,arguments)}function a(e,t){e.prototype=Object.create(t.prototype),e.prototype.constructor=e,e.__proto__=t}function o(e,t){if(null==e)return{};var n,r,a={},o=Object.keys(e);for(r=0;r<o.length;r++)n=o[r],t.indexOf(n)>=0||(a[n]=e[n]);if(Object.getOwnPropertySymbols){var i=Object.getOwnPropertySymbols(e);for(r=0;r<i.length;r++)n=i[r],t.indexOf(n)>=0||Object.prototype.propertyIsEnumerable.call(e,n)&&(a[n]=e[n])}return a}function i(e,t,n,r,a){void 0===n&&(n=!1),void 0===r&&(r=null),void 0===a&&(a=null),null===v.parentNode&&document.body.appendChild(v);var o=s(e,t,n);if(null===o)return null;var i=o.paddingSize,u=o.borderSize,l=o.boxSizing,c=o.sizingStyle;Object.keys(c).forEach(function(e){v.style[e]=c[e]}),m(v),v.value=e.value||e.placeholder||"x";var f=-1/0,d=1/0,p=v.scrollHeight;"border-box"===l?p+=u:"content-box"===l&&(p-=i),v.value="x";var b=v.scrollHeight-i;return null===r&&null===a||(null!==r&&(f=b*r,"border-box"===l&&(f=f+i+u),p=Math.max(f,p)),null!==a&&(d=b*a,"border-box"===l&&(d=d+i+u),p=Math.min(d,p))),{height:p,minHeight:f,maxHeight:d,rowCount:Math.floor(p/b)}}function s(e,t,n){if(void 0===n&&(n=!1),n&&y[t])return y[t];var r=window.getComputedStyle(e);if(null===r)return null;var a=h.reduce(function(e,t){return e[t]=r.getPropertyValue(t),e},{}),o=a["box-sizing"];if(""===o)return null;p&&"border-box"===o&&(a.width=parseFloat(a.width)+parseFloat(r["border-right-width"])+parseFloat(r["border-left-width"])+parseFloat(r["padding-right"])+parseFloat(r["padding-left"])+"px");var i=parseFloat(a["padding-bottom"])+parseFloat(a["padding-top"]),s=parseFloat(a["border-bottom-width"])+parseFloat(a["border-top-width"]),u={sizingStyle:a,paddingSize:i,borderSize:s,boxSizing:o};return n&&(y[t]=u),u}Object.defineProperty(t,"__esModule",{value:!0});var u=n(0),l=n.n(u),c=n(173),f=n.n(c),d=(Object.setPrototypeOf,"object"==typeof Reflect&&Reflect.construct,"undefined"!=typeof window&&"undefined"!=typeof document),p=!!d&&!!document.documentElement.currentStyle,b={"min-height":"0","max-height":"none",height:"0",visibility:"hidden",overflow:"hidden",position:"absolute","z-index":"-1000",top:"0",right:"0"},h=["letter-spacing","line-height","font-family","font-weight","font-size","font-style","tab-size","text-rendering","text-transform","width","text-indent","padding-top","padding-right","padding-bottom","padding-left","border-top-width","border-right-width","border-bottom-width","border-left-width","box-sizing"],y={},v=d&&document.createElement("textarea"),m=function(e){Object.keys(b).forEach(function(t){e.style.setProperty(t,b[t],"important")})};d&&m(v);var g=function(e){return delete y[e]},_=function(e){return void 0===e&&(e=0),function(){return++e}}(),j=function(){},O=d&&window.requestAnimationFrame?[window.requestAnimationFrame,window.cancelAnimationFrame]:[setTimeout,clearTimeout],E=O[0],w=O[1],x=function(e){function t(t){var n;return n=e.call(this,t)||this,n._resizeLock=!1,n._onRootDOMNode=function(e){n._rootDOMNode=e,n.props.inputRef(e)},n._onChange=function(e){n._controlled||n._resizeComponent(),n.props.onChange(e)},n._resizeComponent=function(e){if(void 0===e&&(e=j),void 0===n._rootDOMNode)return void e();var t=i(n._rootDOMNode,n._uid,n.props.useCacheForDOMMeasurements,n.props.minRows,n.props.maxRows);if(null===t)return void e();var r=t.height,a=t.minHeight,o=t.maxHeight,s=t.rowCount;if(n.rowCount=s,n.state.height!==r||n.state.minHeight!==a||n.state.maxHeight!==o)return void n.setState({height:r,minHeight:a,maxHeight:o},e);e()},n.state={height:t.style&&t.style.height||0,minHeight:-1/0,maxHeight:1/0},n._uid=_(),n._controlled="string"==typeof t.value,n}a(t,e);var n=t.prototype;return n.render=function(){var e=this.props,t=(e.inputRef,e.maxRows,e.minRows,e.onHeightChange,e.useCacheForDOMMeasurements,o(e,["inputRef","maxRows","minRows","onHeightChange","useCacheForDOMMeasurements"]));return t.style=r({},t.style,{height:this.state.height}),Math.max(t.style.maxHeight||1/0,this.state.maxHeight)<this.state.height&&(t.style.overflow="hidden"),l.a.createElement("textarea",r({},t,{onChange:this._onChange,ref:this._onRootDOMNode}))},n.componentDidMount=function(){var e=this;this._resizeComponent(),this._resizeListener=function(){e._resizeLock||(e._resizeLock=!0,e._resizeComponent(function(){return e._resizeLock=!1}))},window.addEventListener("resize",this._resizeListener)},n.componentDidUpdate=function(e,t){var n=this;e!==this.props&&(this._clearNextFrame(),this._onNextFrameActionId=E(function(){return n._resizeComponent()})),this.state.height!==t.height&&this.props.onHeightChange(this.state.height,this)},n.componentWillUnmount=function(){this._clearNextFrame(),window.removeEventListener("resize",this._resizeListener),g(this._uid)},n._clearNextFrame=function(){w(this._onNextFrameActionId)},t}(l.a.Component);x.propTypes={inputRef:f.a.func,maxRows:f.a.number,minRows:f.a.number,onChange:f.a.func,onHeightChange:f.a.func,useCacheForDOMMeasurements:f.a.bool,value:f.a.string},x.defaultProps={inputRef:j,onChange:j,onHeightChange:j,useCacheForDOMMeasurements:!1},t.default=x},function(e,t,n){e.exports=n(174)()},function(e,t,n){"use strict";function r(){}var a=n(175);e.exports=function(){function e(e,t,n,r,o,i){if(i!==a){var s=new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");throw s.name="Invariant Violation",s}}function t(){return e}e.isRequired=e;var n={array:e,bool:e,func:e,number:e,object:e,string:e,symbol:e,any:e,arrayOf:t,element:e,instanceOf:t,node:e,objectOf:t,oneOf:t,oneOfType:t,shape:t,exact:t};return n.checkPropTypes=r,n.PropTypes=n,n}},function(e,t,n){"use strict";e.exports="SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED"},function(e,t,n){"use strict";function r(e){e=e.trim();try{if(e=JSON.stringify(JSON.parse(e)),"["===e[0])return a("array",JSON.parse(e));if("{"===e[0])return a("object",JSON.parse(e));if(e.match(/\-?\d+\.\d+/)&&e.match(/\-?\d+\.\d+/)[0]===e)return a("float",parseFloat(e));if(e.match(/\-?\d+/)&&e.match(/\-?\d+/)[0]===e)return a("integer",parseInt(e))}catch(e){}switch(e=e.toLowerCase()){case"undefined":return a("undefined",void 0);case"nan":return a("nan",NaN);case"null":return a("null",null);case"true":return a("boolean",!0);case"false":return a("boolean",!1);default:if(e=Date.parse(e))return a("date",new Date(e))}return a(!1,null)}function a(e,t){return{type:e,value:t}}Object.defineProperty(t,"__esModule",{value:!0}),t.default=r},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function a(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function o(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function i(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var s=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},u=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),l=n(0),c=r(l),f=n(14),d=r(f),p=n(13),b=r(p),h=n(178),y=r(h),v=n(1),m=(r(v),function(e){function t(){var e,n,r,i;a(this,t);for(var u=arguments.length,l=Array(u),c=0;c<u;c++)l[c]=arguments[c];return n=r=o(this,(e=t.__proto__||Object.getPrototypeOf(t)).call.apply(e,[this].concat(l))),r.isValid=function(e){var t=r.props.rjvId,n=b.default.get(t,"action","new-key-request");return""!=e&&-1===Object.keys(n.existing_value).indexOf(e)},r.submit=function(e){var t=r.props.rjvId,n=b.default.get(t,"action","new-key-request");n.new_value=s({},n.existing_value),n.new_value[e]=r.props.defaultValue,d.default.dispatch({name:"VARIABLE_ADDED",rjvId:t,data:n})},i=n,o(r,i)}return i(t,e),u(t,[{key:"render",value:function(){var e=this.props,t=e.active,n=e.theme,r=e.rjvId;return t?c.default.createElement(y.default,{rjvId:r,theme:n,isValid:this.isValid,submit:this.submit}):null}}]),t}(c.default.PureComponent));t.default=m},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function a(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function o(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function i(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var s=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},u=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),l=n(0),c=r(l),f=n(14),d=r(f),p=n(15),b=n(1),h=r(b),y=function(e){function t(e){a(this,t);var n=o(this,(t.__proto__||Object.getPrototypeOf(t)).call(this,e));return n.closeModal=function(){d.default.dispatch({rjvId:n.props.rjvId,name:"RESET"})},n.submit=function(){n.props.submit(n.state.input)},n.state={input:e.input?e.input:""},n}return i(t,e),u(t,[{key:"render",value:function(){var e=this,t=this.props,n=t.theme,r=t.rjvId,a=t.isValid,o=this.state.input,i=a(o);return c.default.createElement("div",s({className:"key-modal-request"},(0,h.default)(n,"key-modal-request"),{onClick:this.closeModal}),c.default.createElement("div",s({},(0,h.default)(n,"key-modal"),{onClick:function(e){e.stopPropagation()}}),c.default.createElement("div",(0,h.default)(n,"key-modal-label"),"Key Name:"),c.default.createElement("div",{style:{position:"relative"}},c.default.createElement("input",s({},(0,h.default)(n,"key-modal-input"),{className:"key-modal-input",ref:function(e){return e&&e.focus()},spellCheck:!1,value:o,placeholder:"...",onChange:function(t){e.setState({input:t.target.value})},onKeyPress:function(t){i&&"Enter"===t.key?e.submit():"Escape"===t.key&&e.closeModal()}})),i?c.default.createElement(p.CheckCircle,s({},(0,h.default)(n,"key-modal-submit"),{className:"key-modal-submit",onClick:function(t){return e.submit()}})):null),c.default.createElement("span",(0,h.default)(n,"key-modal-cancel"),c.default.createElement(p.Add,s({},(0,h.default)(n,"key-modal-cancel-icon"),{className:"key-modal-cancel",onClick:function(){d.default.dispatch({rjvId:r,name:"RESET"})}})))))}}]),t}(c.default.PureComponent);t.default=y},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function a(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function o(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function i(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var s=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},u=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),l=n(0),c=r(l),f=n(14),d=r(f),p=n(13),b=(r(p),n(15)),h=n(1),y=r(h),v=function(e){function t(){return a(this,t),o(this,(t.__proto__||Object.getPrototypeOf(t)).apply(this,arguments))}return i(t,e),u(t,[{key:"render",value:function(){var e=this.props,t=e.message,n=e.active,r=e.theme,a=e.rjvId;return n?c.default.createElement("div",s({className:"validation-failure"},(0,y.default)(r,"validation-failure"),{onClick:function(){d.default.dispatch({rjvId:a,name:"RESET"})}}),c.default.createElement("span",(0,y.default)(r,"validation-failure-label"),t),c.default.createElement(b.Add,(0,y.default)(r,"validation-failure-clear"))):null}}]),t}(c.default.PureComponent);t.default=v},function(e,t,n){var r=n(181);"string"==typeof r&&(r=[[e.i,r,""]]);var a={};a.transform=void 0,n(183)(r,a),r.locals&&(e.exports=r.locals)},function(e,t,n){t=e.exports=n(182)(!1),t.push([e.i,".react-json-view .copy-to-clipboard-container{vertical-align:top;display:none}.react-json-view .click-to-add,.react-json-view .click-to-edit,.react-json-view .click-to-remove{display:none}.react-json-view .object-content .variable-row:hover .click-to-edit,.react-json-view .object-content .variable-row:hover .click-to-remove,.react-json-view .object-key-val:hover>span>.object-meta-data>.click-to-add,.react-json-view .object-key-val:hover>span>.object-meta-data>.click-to-remove,.react-json-view .object-key-val:hover>span>.object-meta-data>.copy-to-clipboard-container,.react-json-view .variable-row:hover .copy-to-clipboard-container{display:inline-block}",""])},function(e,t){function n(e,t){var n=e[1]||"",a=e[3];if(!a)return n;if(t&&"function"==typeof btoa){var o=r(a);return[n].concat(a.sources.map(function(e){return"/*# sourceURL="+a.sourceRoot+e+" */"})).concat([o]).join("\n")}return[n].join("\n")}function r(e){return"/*# sourceMappingURL=data:application/json;charset=utf-8;base64,"+btoa(unescape(encodeURIComponent(JSON.stringify(e))))+" */"}e.exports=function(e){var t=[];return t.toString=function(){return this.map(function(t){var r=n(t,e);return t[2]?"@media "+t[2]+"{"+r+"}":r}).join("")},t.i=function(e,n){"string"==typeof e&&(e=[[null,e,""]]);for(var r={},a=0;a<this.length;a++){var o=this[a][0];"number"==typeof o&&(r[o]=!0)}for(a=0;a<e.length;a++){var i=e[a];"number"==typeof i[0]&&r[i[0]]||(n&&!i[2]?i[2]=n:n&&(i[2]="("+i[2]+") and ("+n+")"),t.push(i))}},t}},function(e,t,n){function r(e,t){for(var n=0;n<e.length;n++){var r=e[n],a=b[r.id];if(a){a.refs++;for(var o=0;o<a.parts.length;o++)a.parts[o](r.parts[o]);for(;o<r.parts.length;o++)a.parts.push(c(r.parts[o],t))}else{for(var i=[],o=0;o<r.parts.length;o++)i.push(c(r.parts[o],t));b[r.id]={id:r.id,refs:1,parts:i}}}}function a(e,t){for(var n=[],r={},a=0;a<e.length;a++){var o=e[a],i=t.base?o[0]+t.base:o[0],s=o[1],u=o[2],l=o[3],c={css:s,media:u,sourceMap:l};r[i]?r[i].parts.push(c):n.push(r[i]={id:i,parts:[c]})}return n}function o(e,t){var n=y(e.insertInto);if(!n)throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");var r=g[g.length-1];if("top"===e.insertAt)r?r.nextSibling?n.insertBefore(t,r.nextSibling):n.appendChild(t):n.insertBefore(t,n.firstChild),g.push(t);else{if("bottom"!==e.insertAt)throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");n.appendChild(t)}}function i(e){if(null===e.parentNode)return!1;e.parentNode.removeChild(e);var t=g.indexOf(e);t>=0&&g.splice(t,1)}function s(e){var t=document.createElement("style");return e.attrs.type="text/css",l(t,e.attrs),o(e,t),t}function u(e){var t=document.createElement("link");return e.attrs.type="text/css",e.attrs.rel="stylesheet",l(t,e.attrs),o(e,t),t}function l(e,t){Object.keys(t).forEach(function(n){e.setAttribute(n,t[n])})}function c(e,t){var n,r,a,o;if(t.transform&&e.css){if(!(o=t.transform(e.css)))return function(){};e.css=o}if(t.singleton){var l=m++;n=v||(v=s(t)),r=f.bind(null,n,l,!1),a=f.bind(null,n,l,!0)}else e.sourceMap&&"function"==typeof URL&&"function"==typeof URL.createObjectURL&&"function"==typeof URL.revokeObjectURL&&"function"==typeof Blob&&"function"==typeof btoa?(n=u(t),r=p.bind(null,n,t),a=function(){i(n),n.href&&URL.revokeObjectURL(n.href)}):(n=s(t),r=d.bind(null,n),a=function(){i(n)});return r(e),function(t){if(t){if(t.css===e.css&&t.media===e.media&&t.sourceMap===e.sourceMap)return;r(e=t)}else a()}}function f(e,t,n,r){var a=n?"":r.css;if(e.styleSheet)e.styleSheet.cssText=j(t,a);else{var o=document.createTextNode(a),i=e.childNodes;i[t]&&e.removeChild(i[t]),i.length?e.insertBefore(o,i[t]):e.appendChild(o)}}function d(e,t){var n=t.css,r=t.media;if(r&&e.setAttribute("media",r),e.styleSheet)e.styleSheet.cssText=n;else{for(;e.firstChild;)e.removeChild(e.firstChild);e.appendChild(document.createTextNode(n))}}function p(e,t,n){var r=n.css,a=n.sourceMap,o=void 0===t.convertToAbsoluteUrls&&a;(t.convertToAbsoluteUrls||o)&&(r=_(r)),a&&(r+="\n/*# sourceMappingURL=data:application/json;base64,"+btoa(unescape(encodeURIComponent(JSON.stringify(a))))+" */");var i=new Blob([r],{type:"text/css"}),s=e.href;e.href=URL.createObjectURL(i),s&&URL.revokeObjectURL(s)}var b={},h=function(e){var t;return function(){return void 0===t&&(t=e.apply(this,arguments)),t}}(function(){return window&&document&&document.all&&!window.atob}),y=function(e){var t={};return function(n){return void 0===t[n]&&(t[n]=e.call(this,n)),t[n]}}(function(e){return document.querySelector(e)}),v=null,m=0,g=[],_=n(184);e.exports=function(e,t){if("undefined"!=typeof DEBUG&&DEBUG&&"object"!=typeof document)throw new Error("The style-loader cannot be used in a non-browser environment");t=t||{},t.attrs="object"==typeof t.attrs?t.attrs:{},t.singleton||(t.singleton=h()),t.insertInto||(t.insertInto="head"),t.insertAt||(t.insertAt="bottom");var n=a(e,t);return r(n,t),function(e){for(var o=[],i=0;i<n.length;i++){var s=n[i],u=b[s.id];u.refs--,o.push(u)}e&&r(a(e,t),t);for(var i=0;i<o.length;i++){var u=o[i];if(0===u.refs){for(var l=0;l<u.parts.length;l++)u.parts[l]();delete b[u.id]}}}};var j=function(){var e=[];return function(t,n){return e[t]=n,e.filter(Boolean).join("\n")}}()},function(e,t){e.exports=function(e){var t="undefined"!=typeof window&&window.location;if(!t)throw new Error("fixUrls requires window.location");if(!e||"string"!=typeof e)return e;var n=t.protocol+"//"+t.host,r=n+t.pathname.replace(/\/[^\/]*$/,"/");return e.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi,function(e,t){var a=t.trim().replace(/^"(.*)"$/,function(e,t){return t}).replace(/^'(.*)'$/,function(e,t){return t});if(/^(#|data:|http:\/\/|https:\/\/|file:\/\/\/)/i.test(a))return e;var o;return o=0===a.indexOf("//")?a:0===a.indexOf("/")?n+a:r+a.replace(/^\.\//,""),"url("+JSON.stringify(o)+")"})}}])});

/***/ }),
/* 2603 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_core__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_helpers_DateHelpers__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_helpers_UserHelper__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_queries_fna_queries__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_apollo__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__containers_FnaHistoryContainer_jsx__ = __webpack_require__(2604);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_Table_EmptyBody_jsx__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_helpers_UriReader__ = __webpack_require__(41);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var columnData=[{id:'description',numeric:false,disablePadding:true,label:'Description'},{id:'clientFullName',numeric:false,disablePadding:true,label:'Client Name'},{id:'date_created_raw',numeric:false,disablePadding:true,label:'Date Created'}];var FnaHistory=function(_Component){_inherits(FnaHistory,_Component);function FnaHistory(){var _ref;var _temp,_this,_ret;_classCallCheck(this,FnaHistory);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=FnaHistory.__proto__||Object.getPrototypeOf(FnaHistory)).call.apply(_ref,[this].concat(args))),_this),_this.state={page:0,rowsPerPage:5,order:'desc',orderBy:'date_created_raw',searchTerm:'',selectedFna:null,anchorTop:0,anchorLeft:0,popoverOpen:false,assistantActive:false},_this.handleSearch=function(event,refetch){_this.setState({searchTerm:event.target.value});_this.handleClose();refetch();},_this.handleChangePage=function(page,refetch){_this.setState({page:page});_this.handleClose();refetch();},_this.handleChangeRowsPerPage=function(event,refetch){_this.setState({rowsPerPage:event.target.value});_this.handleClose();refetch();},_this.handleRequestSort=function(event,property,refetch){var orderBy=property;var order='desc';if(_this.state.orderBy===property&&_this.state.order==='desc'){order='asc';}_this.handleClose();_this.setState({order:order,orderBy:orderBy});refetch();},_this.handleNewFna=function(){_this.props.history.push('/app/clientforfna');},_this.handleClose=function(){_this.setState({popoverOpen:false,selectedFna:null});},_this.handleOpen=function(event,fna){_this.setState({anchorTop:event.clientY,anchorLeft:event.clientX,popoverOpen:true,selectedFna:fna});},_this.getBrokerId=function(){var brokerId=Object(__WEBPACK_IMPORTED_MODULE_2_helpers_UserHelper__["a" /* GetUserId */])();if(_this.checkAssistantActive()){brokerId=sessionStorage.getItem('ActiveBrokerId');}return brokerId;},_this.getBrokerName=function(){return sessionStorage.getItem('ActiveBrokerName');},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(FnaHistory,[{key:'handleEdit',value:function handleEdit(fna){this.props.history.push({pathname:'/app/newfna',search:'clientId='+fna.client_id+'&id='+fna.id});}},{key:'handleView',value:function handleView(fna){this.props.history.push({pathname:'/app/fnaresults',search:'fnaId='+fna.id});}},{key:'handleViewJson',value:function handleViewJson(fna){this.props.history.push({pathname:'/app/fnaresultsjson',search:'fnaId='+fna.id});}},{key:'checkAssistantActive',value:function checkAssistantActive(){if(Object(__WEBPACK_IMPORTED_MODULE_2_helpers_UserHelper__["b" /* GetUserKey */])('userType')==='6'){if(!this.state.assistantActive){this.setState({assistantActive:true});}return true;}return false;}},{key:'render',value:function render(){var _this2=this;var colSpan=Object.keys(columnData).length;var params=Object(__WEBPACK_IMPORTED_MODULE_8_helpers_UriReader__["a" /* ParseUriParams */])(this.props.location.search);var clientId=params.clientId,clientName=params.clientName;return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_apollo__["Query"],{query:__WEBPACK_IMPORTED_MODULE_3_queries_fna_queries__["c" /* GetFnaHistory */],variables:{brokerId:this.getBrokerId(),token:Object(__WEBPACK_IMPORTED_MODULE_2_helpers_UserHelper__["c" /* GetUserToken */])(),limit:this.state.rowsPerPage,page:this.state.page,orderBy:this.state.orderBy,direction:this.state.order,search:this.state.searchTerm,clientId:clientId},fetchPolicy:'network-only'},function(_ref2){var loading=_ref2.loading,error=_ref2.error,data=_ref2.data,refetch=_ref2.refetch;if(loading){return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__containers_FnaHistoryContainer_jsx__["a" /* default */],Object.assign({},_this2.state,{addClicked:_this2.handleNewFna,brokerName:_this2.getBrokerName(),handleSearch:function handleSearch(e){return _this2.handleSearch(e,refetch);},handleRequestSort:function handleRequestSort(event,property){return _this2.handleRequestSort(event,property,refetch);},clientName:clientName,columnData:columnData,tableBody:__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_Table_EmptyBody_jsx__["a" /* default */],{colSpan:colSpan,rowSpan:_this2.state.rowsPerPage,placeHolder:__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["j" /* CircularProgress */],null)})}));}if(error)return'Error! '+error.message;var items=data.FnaHistory.Results;var count=data.FnaHistory.Count;return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__containers_FnaHistoryContainer_jsx__["a" /* default */],Object.assign({},_this2.state,{addClicked:_this2.handleNewFna,brokerName:_this2.getBrokerName(),handleSearch:function handleSearch(e){return _this2.handleSearch(e,refetch);},handleRequestSort:function handleRequestSort(event,property){return _this2.handleRequestSort(event,property,refetch);},clientName:clientName,columnData:columnData,tableBody:__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Fragment,null,items.length<1&&_this2.state.searchTerm!==''?__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_Table_EmptyBody_jsx__["a" /* default */],{colSpan:colSpan,rowSpan:_this2.state.rowsPerPage,placeHolder:__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{variant:'subheading'},_this2.state.searchTerm!==''?'No results found':'No FNAs created yet. Click on Create FNA')}):__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Fragment,null,items.map(function(fna){return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],{className:'sqDataTable',key:fna.id,onClick:function onClick(e){return _this2.state.popoverOpen===false?_this2.handleOpen(e,fna):null;},style:_this2.state.selectedFna&&_this2.state.selectedFna.id===fna.id?{backgroundColor:'#dedede'}:{}},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,fna.description),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,fna.clientFullName),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,Object(__WEBPACK_IMPORTED_MODULE_1_helpers_DateHelpers__["a" /* DateTimeFormatter */])(fna.date_created)));}),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["J" /* Popover */],{open:_this2.state.popoverOpen,anchorReference:'anchorPosition',anchorPosition:{left:_this2.state.anchorLeft,top:_this2.state.anchorTop},onClose:function onClose(){return _this2.handleClose();}},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["C" /* List */],{component:'nav'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["D" /* ListItem */],{button:true,onClick:function onClick(){return _this2.handleView(_this2.state.selectedFna);}},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["E" /* ListItemText */],{primary:'View Results'})),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["p" /* Divider */],null),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["D" /* ListItem */],{button:true,divider:true,onClick:function onClick(){return _this2.handleEdit(_this2.state.selectedFna);}},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["E" /* ListItemText */],{primary:'Edit Fna'})),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["D" /* ListItem */],{button:true,divider:true,onClick:function onClick(){return _this2.handleViewJson(_this2.state.selectedFna);}},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["E" /* ListItemText */],{primary:'JSON RESULTS'})))),[].concat(_toConsumableArray(Array(_this2.state.rowsPerPage-items.length))).map(function(i){return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],{key:i,colSpan:colSpan});})),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["U" /* TablePagination */],{count:count,rowsPerPage:_this2.state.rowsPerPage,page:_this2.state.page,backIconButtonProps:{'aria-label':'Previous Page'},nextIconButtonProps:{'aria-label':'Next Page'},onChangePage:function onChangePage(event,page){return _this2.handleChangePage(page,refetch);},onChangeRowsPerPage:function onChangeRowsPerPage(event){return _this2.handleChangeRowsPerPage(event,refetch);}})))}));});}}]);return FnaHistory;}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (FnaHistory);

/***/ }),
/* 2604 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_core__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_icons__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Grid_GridItem_jsx__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Table_EnhancedTableHead_jsx__ = __webpack_require__(2605);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
var FnaHistoryContainer=function FnaHistoryContainer(props){return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{container:true},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:10,style:{flexBasis:"100%",maxWidth:"100%",margin:'auto'}},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["e" /* Card */],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["f" /* CardContent */],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{variant:"headline",className:"centerCell"},props.clientName?props.clientName+"'s FNAs":"Manage FNAs"),props.assistantActive?__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{variant:"caption",className:"centerCell",gutterBottom:true},props.brokerName):null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("div",{style:{borderBottom:"1px solid #cccccc69",margin:"5px auto",width:"25%",marginBottom:"20px"}}),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["I" /* Paper */],{style:{overflowX:"auto"}},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{container:true},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{item:true,xs:6,sm:4,md:3,style:{margin:"25px auto 0px auto"}},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["i" /* Chip */],{avatar:__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["b" /* Avatar */],{style:{backgroundColor:"#6c5cab",color:"white"}},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["w" /* Icon */],null,"add")),className:"customChip",variant:"outlined",label:__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{color:"white"}},"Create FNA"),color:"secondary",style:{backgroundColor:"#4239d659",color:"white",width:"100%"},onClick:props.addClicked}))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{container:true},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{item:true,xs:10,sm:10,md:10,style:{margin:"0 auto",display:"flex"}},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["X" /* TextField */],{id:"input-with-icon-textfield",fullWidth:true,style:{marginBottom:"30px"},placeholder:"Description, Client or Date Created(DD/MM/YYYY)",value:props.searchTerm,onChange:props.handleSearch,label:"Search",InputProps:{startAdornment:__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["z" /* InputAdornment */],{position:"start"},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_icons__["n" /* Search */],null))}}),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["d" /* Button */],null,"Search"))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Q" /* Table */],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Table_EnhancedTableHead_jsx__["a" /* default */],{order:props.order,orderBy:props.orderBy,onRequestSort:function onRequestSort(event,property){return props.handleRequestSort(event,property);},rowCount:props.items?props.items.length:0,columnData:props.columnData}),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["R" /* TableBody */],null,props.tableBody)))))));};/* harmony default export */ __webpack_exports__["a"] = (FnaHistoryContainer);

/***/ }),
/* 2605 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_core_TableCell__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_core_TableCell___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__material_ui_core_TableCell__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_TableHead__ = __webpack_require__(330);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_TableHead___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_TableHead__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_TableRow__ = __webpack_require__(332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_TableRow___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_TableRow__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_TableSortLabel__ = __webpack_require__(333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_TableSortLabel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_TableSortLabel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Tooltip__ = __webpack_require__(334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var EnhancedTableHead=function(_React$Component){_inherits(EnhancedTableHead,_React$Component);function EnhancedTableHead(){var _ref;var _temp,_this,_ret;_classCallCheck(this,EnhancedTableHead);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=EnhancedTableHead.__proto__||Object.getPrototypeOf(EnhancedTableHead)).call.apply(_ref,[this].concat(args))),_this),_this.createSortHandler=function(property){return function(event){_this.props.onRequestSort(event,property);};},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(EnhancedTableHead,[{key:"render",value:function render(){var _this2=this;var _props=this.props,order=_props.order,orderBy=_props.orderBy;return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_TableHead___default.a,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_TableRow___default.a,null,this.props.columnData.map(function(column){return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core_TableCell___default.a,{key:column.id,numeric:column.numeric,padding:column.disablePadding?"none":"default",sortDirection:orderBy===column.id?order:false,style:{padding:"4px 56px 4px 24px"}},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Tooltip___default.a,{title:"Sort",placement:column.numeric?"bottom-end":"bottom-start",enterDelay:300},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_TableSortLabel___default.a,{active:orderBy===column.id,direction:order,onClick:_this2.createSortHandler(column.id)},column.label)));},this)));}}]);return EnhancedTableHead;}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);EnhancedTableHead.propTypes={onRequestSort:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func.isRequired,order:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string.isRequired,orderBy:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string.isRequired,rowCount:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number.isRequired};/* harmony default export */ __webpack_exports__["a"] = (EnhancedTableHead);

/***/ }),
/* 2606 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_core__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles_withStyles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_icons__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_assets_jss_material_dashboard_pro_react_views_sweetAlertStyle_jsx__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_Grid_GridItem_jsx__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_helpers_DateHelpers__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_helpers_Search__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_helpers_UserHelper__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_queries_clientsByBroker__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_apollo__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_redux__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_router__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_components_EnhancedTableHead_EnhancedTableHead_jsx__ = __webpack_require__(44);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var columnData=[{id:"scd_name",numeric:false,disablePadding:true,label:"Name"},{id:"scd_email",numeric:false,disablePadding:true,label:"Email"},{id:"date_modified",numeric:false,disablePadding:true,label:"Date Created / Modified"}];var ClientForFna=function(_Component){_inherits(ClientForFna,_Component);function ClientForFna(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ClientForFna);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ClientForFna.__proto__||Object.getPrototypeOf(ClientForFna)).call.apply(_ref,[this].concat(args))),_this),_this.state={page:0,rowsPerPage:5,order:"desc",orderBy:"date_modified",searchTerm:"",loadingSearch:false,searchData:[],assistantActive:false,invalidFields:[],selectedClient:{}},_this.handleSearch=function(event){_this.setState({searchTerm:event.target.value});var values=event.target.value.split(" ");var data=_this.props.data.getClientsByBroker;var inc=["scd_name","scd_surname","scd_email","date_created"];var filteredData=Object(__WEBPACK_IMPORTED_MODULE_7_helpers_Search__["a" /* SearchDataSet */])(data,values,inc);_this.setState({searchData:filteredData});},_this.handleChangePage=function(event,page){_this.setState({page:page});},_this.handleChangeRowsPerPage=function(event){_this.setState({rowsPerPage:event.target.value});},_this.handleRequestSort=function(event,property){var orderBy=property;var order="desc";if(_this.state.orderBy===property&&_this.state.order==="desc"){order="asc";}_this.setState({order:order,orderBy:orderBy});},_this.handleEditClient=function(id){_this.props.history.push({pathname:"/app/newfna",search:"clientId="+atob(id).split(":")[1]});},_this.getBrokerId=function(){var brokerId=Object(__WEBPACK_IMPORTED_MODULE_8_helpers_UserHelper__["a" /* GetUserId */])();if(_this.checkAssistantActive()){brokerId=sessionStorage.getItem("ActiveBrokerId");}return brokerId;},_this.getBrokerName=function(){return sessionStorage.getItem("ActiveBrokerName");},_this.sortDateDesc=function(a,b){return new Date(b.date_modified)-new Date(a.date_modified);},_this.sortDateAsc=function(a,b){return new Date(a.date_modified)-new Date(b.date_modified);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ClientForFna,[{key:"componentDidMount",value:function componentDidMount(){this.props.scrollMeBar();}},{key:"getSorting",value:function getSorting(order,orderBy){return order==="desc"?function(a,b){return b[orderBy]<a[orderBy]?-1:1;}:function(a,b){return a[orderBy]<b[orderBy]?-1:1;};}},{key:"checkAssistantActive",value:function checkAssistantActive(){if(Object(__WEBPACK_IMPORTED_MODULE_8_helpers_UserHelper__["b" /* GetUserKey */])("userType")==="6"){if(!this.state.assistantActive){this.setState({assistantActive:true});}return true;}return false;}},{key:"render",value:function render(){var _this2=this;this.checkAssistantActive();if(this.props.data.loading){return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["B" /* LinearProgress */],null);}if(this.props.data.error&&this.props.data.error.message&&this.props.data.error.message==="GraphQL error: invalid token"){Object(__WEBPACK_IMPORTED_MODULE_8_helpers_UserHelper__["d" /* Logout */])();return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_react_router__["a" /* Redirect */],{to:"/app/portal/login"});}var data=[];if(this.state.searchData.length>0&&this.state.searchTerm!==""){data=this.state.searchData.slice();}else{data=this.props.data.getClientsByBroker.slice();}if(this.state.orderBy==="date_modified"){data.sort(this.state.order==="desc"?this.sortDateDesc:this.sortDateAsc);}else{data.sort(this.getSorting(this.state.order,this.state.orderBy));}return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{container:true},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:10,style:{flexBasis:"100%",maxWidth:"100%",margin:'auto'}},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["e" /* Card */],null,__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["f" /* CardContent */],null,__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{container:true,justify:"space-between",style:{marginBottom:"15px"}},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{item:true,xs:12,sm:12,md:12},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{variant:"headline"},"Choose Client for FNA"),this.state.assistantActive?__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{variant:"caption",gutterBottom:true},this.getBrokerName()):null)),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["X" /* TextField */],{id:"input-with-icon-textfield",fullWidth:true,style:{marginBottom:"3vh"},placeholder:"Search Client by Name, Surname,Email or Date Created(YYYY/MM/DD)",onChange:this.handleSearch,label:"Search",InputProps:{startAdornment:__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["z" /* InputAdornment */],{position:"start"},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_icons__["n" /* Search */],null))}}),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["I" /* Paper */],{style:{overflowX:"auto"}},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Q" /* Table */],null,__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_EnhancedTableHead_EnhancedTableHead_jsx__["a" /* default */],{order:this.state.order,orderBy:this.state.orderBy,onRequestSort:this.handleRequestSort,rowCount:this.state.searchData.length<1&&this.state.searchTerm!==""?this.state.searchData.length:data.length,columnData:columnData}),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["R" /* TableBody */],null,this.state.searchData.length<1&&this.state.searchTerm!==""?__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("h3",null,"No results found"))):data.slice(this.state.page*this.state.rowsPerPage,this.state.page*this.state.rowsPerPage+this.state.rowsPerPage).map(function(client){return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],{key:client.id,className:"sqDataTable",onClick:function onClick(){return _this2.handleEditClient(client.id);}},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,client.scd_name," ",client.scd_surname),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,client.scd_email),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,Object(__WEBPACK_IMPORTED_MODULE_6_helpers_DateHelpers__["a" /* DateTimeFormatter */])(client.date_modified)));}),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["U" /* TablePagination */],{count:this.state.searchData.length<1&&this.state.searchTerm!==""?this.state.searchData.length:data.length,rowsPerPage:this.state.rowsPerPage,page:this.state.page,backIconButtonProps:{"aria-label":"Previous Page"},nextIconButtonProps:{"aria-label":"Next Page"},onChangePage:this.handleChangePage,onChangeRowsPerPage:this.handleChangeRowsPerPage})))))))));}}]);return ClientForFna;}(__WEBPACK_IMPORTED_MODULE_10_react__["Component"]);ClientForFna=Object(__WEBPACK_IMPORTED_MODULE_11_react_apollo__["graphql"])(__WEBPACK_IMPORTED_MODULE_9_queries_clientsByBroker__["a" /* getClientsByBroker */],{options:function options(){return{fetchPolicy:"cache-and-network"};},props:function props(_props){if(_props.data.error){}return Object.assign({},_props);}})(ClientForFna);ClientForFna=Object(__WEBPACK_IMPORTED_MODULE_12_react_redux__["b" /* connect */])(function(state){return{brokerId:Object(__WEBPACK_IMPORTED_MODULE_8_helpers_UserHelper__["b" /* GetUserKey */])("userType")==="6"?sessionStorage.getItem("ActiveBrokerId"):Object(__WEBPACK_IMPORTED_MODULE_8_helpers_UserHelper__["a" /* GetUserId */])(),token:Object(__WEBPACK_IMPORTED_MODULE_8_helpers_UserHelper__["c" /* GetUserToken */])(),status:"own",userType:Object(__WEBPACK_IMPORTED_MODULE_8_helpers_UserHelper__["b" /* GetUserKey */])("userType")};})(ClientForFna);/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles_withStyles___default()(__WEBPACK_IMPORTED_MODULE_4_assets_jss_material_dashboard_pro_react_views_sweetAlertStyle_jsx__["a" /* default */])(ClientForFna));

/***/ }),
/* 2607 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_core__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_form__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__steps_PersonalDetail__ = __webpack_require__(2608);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__steps_BuySell__ = __webpack_require__(2610);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_store__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_reducers_NotificationReducer__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_helpers_ReduxHelpers__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__bna_init__ = __webpack_require__(2612);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_queries_fna_mutations__ = __webpack_require__(633);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_queries_fna_queries__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_apollo__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_helpers_UserHelper__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_helpers_UriReader__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_components_Wrappers_materialUIWrappers_components_FormCheckbox_jsx__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_helpers_DateHelpers__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_moment__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__steps_objects_bnaClasses_jsx__ = __webpack_require__(2613);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/*eslint-disable*/var tabs=['BNA Details','Buy and Sell'];var tabStyle={color:'#6c5cab',borderBottom:'2px solid'};var checkItem=function checkItem(label,name,changeFunc){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:4,sm:4,md:2},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["t" /* FormControl */],{style:{marginBottom:"-30px",paddingBottom:"-30px"}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_16_components_Wrappers_materialUIWrappers_components_FormCheckbox_jsx__["a" /* default */],name:name,onChange:function onChange(e,f,g,h){changeFunc(h,f);}})));};var BNAWizard=function(_React$Component){_inherits(BNAWizard,_React$Component);function BNAWizard(){var _ref;var _temp,_this,_ret;_classCallCheck(this,BNAWizard);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=BNAWizard.__proto__||Object.getPrototypeOf(BNAWizard)).call.apply(_ref,[this].concat(args))),_this),_this.state={messageShown1:false,checkValidation:false,editMode:false,clientId:null,client:null,entityType:"",marketValue:"0.00",buySell:"traditional",page:0,businessOwners:[],heirs:[],keyPersons:[],sureties:[]},_this.update=function(){_this.forceUpdate();},_this.handleChangeTab=function(event,value){if(_this.validationErrors()){return;}else{_this.state.page=value;_this.forceUpdate();}},_this.changeHeir=function(value,name){var classN=name.split(".")[0];var classO=name.split(".")[1].split("-")[0];var i=name.split("-")[1];_this.state[classN][i][classO]=value;_this.state.businessOwners.map(function(e,i){var owner=e.name;var ownerNumber=i;e.minusInheritance=0.00;_this.state.heirs.map(function(e,i){if(e.to==owner){_this.state.businessOwners[ownerNumber].minusInheritance=1*_this.state.businessOwners[ownerNumber].minusInheritance+1*e.inherit;e.perantOwnership=_this.state.businessOwners[ownerNumber].ownership;}});});},_this.changePersonal=function(value,name){if(name.split(".").length>2){var classN=name.split(".")[0];var classO=name.split(".")[1];var classO2=name.split(".")[2].split("-")[0];var classI=name.split("-")[1];if(name.split("-").length>2){var classI2=name.split("-")[2];_this.state[classN][classI][classO][classI2][classO2]=value;}else{_this.state[classN][classI][classO][classO2]=value;}_this.forceUpdate();}else if(name.split(".").length>1){var classN=name.split(".")[0];var classO=name.split(".")[1].split("-")[0];var classI=name.split("-")[1];console.log(classN);console.log(classO);console.log(classI);_this.state[classN][classI][classO]=value;console.log(name);console.log(value);_this.forceUpdate();}else{if(name.split("-").length>1){var classN=name.split("-")[0];var classI=name.split("-")[1];_this.state[classN][classI]=value;_this.forceUpdate();}else{_this.state[name]=value;_this.forceUpdate();}}},_this.changeEstateDuty=function(value,name){_this.changePersonal(value,name);console.log("DUTYCHANGE "+classN+" . "+classI);var classN=name.split(".")[0];var classO=name.split(".")[1].split("-")[0];var classI=name.split("-")[1];if(value==false){_this.state[classN][classI]["taxAmountPrev"]=_this.state[classN][classI]["taxAmount"];_this.state[classN][classI]["taxAmount"]=0;_this.forceUpdate();}else{_this.state[classN][classI]["taxAmount"]=_this.state[classN][classI]["taxAmountPrev"];_this.forceUpdate();}},_this.changeTab=function(){_this.forceUpdate();},_this.whoof=function(){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{color:'white'}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("h4",null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("b",null,"Please note the following changes that might affect the BNA:")," ")),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{color:'white'}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("br",null)," ",__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("b",null,"New changes:")),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{color:'white'}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("br",null)," - Default values has been implemented."),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{color:'white'}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("h4",null,"NOTE: PLEASE CREATE A NEW BNA OR REFILL ALL THE DEFAULT FIELDS. ALL DEFAULT VALUES WILL TAKE EFFECT AS SOON AS CHANGES HAS BEEN ACCEPTED!")),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{color:'white'}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("br",null)," ",__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("b",null,"Previous Changes: ")),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{color:'white'}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("br",null)," - Spouse spelling was corrected, all fields related will have invalid data"),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{color:'white'}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("br",null)," - Death is now the first option"));},_this.showChanges=function(){if(!_this.state.changes1&&!_this.state.messageShown1){__WEBPACK_IMPORTED_MODULE_6_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_7_reducers_NotificationReducer__["d" /* showSnack */])({message:_this.whoof(),color:"danger",timeout:"1"}));_this.state.messageShown1=true;}},_this.validationErrors=function(){if(Object(__WEBPACK_IMPORTED_MODULE_8_helpers_ReduxHelpers__["a" /* FormHasErrors */])("newbna",_this.state.ignoreItems)){__WEBPACK_IMPORTED_MODULE_6_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_7_reducers_NotificationReducer__["d" /* showSnack */])({message:"Invalid Information",color:"danger"}));_this.setState({checkValidation:true});return true;}if(!_this.state.changes1){__WEBPACK_IMPORTED_MODULE_6_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_7_reducers_NotificationReducer__["d" /* showSnack */])({message:"Please accept that You acknowledge the changes.",color:"danger"}));_this.setState({checkValidation:true});return true;}_this.setState({checkValidation:false});return false;},_this.nextPage=function(){if(_this.validationErrors())return;_this.state.pageCount=8;//This must be taken out. Only for testing!!!!
var nextPage=_this.state.page+1;_this.setState({page:nextPage,checkValidation:false});_this.forceUpdate();},_this.previousPage=function(){if(_this.validationErrors())return;//this.setState({ checkValidation: false });
var prevPage=_this.state.page-1;_this.setState({page:prevPage,checkValidation:false});_this.forceUpdate();},_this.setStepItems=function(name,items){_this.setState({stepItems:Object.assign({},_this.state.stepItems,_defineProperty({},name,items))});},_this.initializeForm=function(){var data=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;var editMode=arguments[1];if(data){if(!editMode){_this.props.initialize(Object.assign({},data,__WEBPACK_IMPORTED_MODULE_9__bna_init__["a" /* DefaultInit */]));}else{_this.setState(data.state);_this.props.initialize(data);}}else{_this.props.initialize(__WEBPACK_IMPORTED_MODULE_9__bna_init__["a" /* DefaultInit */]);}if(data.client.dob){_this.clientDobChanged(data.client.dob);}if(!editMode)_this.setState({changes1:true});_this.setState({formInitiazed:true,editMode:data?true:false});},_this.getBrokerId=function(){var brokerId=Object(__WEBPACK_IMPORTED_MODULE_14_helpers_UserHelper__["a" /* GetUserId */])();if(_this.checkAssistantActive()){brokerId=sessionStorage.getItem("ActiveBrokerId");}return brokerId;},_this.clientDobChanged=function(val){try{if(val.length!==10)throw"Too short";var dob=Object(__WEBPACK_IMPORTED_MODULE_17_helpers_DateHelpers__["b" /* ParseDMYwSlashes */])(val);var age=__WEBPACK_IMPORTED_MODULE_18_moment___default()().diff(dob,"years");__WEBPACK_IMPORTED_MODULE_6_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_redux_form__["b" /* change */])("newbna","client.age",age));}catch(error){__WEBPACK_IMPORTED_MODULE_6_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_redux_form__["b" /* change */])("newbna","client.age",""));}_this.forceUpdate();return;},_this.submit=function(){var formValues=Object(__WEBPACK_IMPORTED_MODULE_13_lodash__["get"])(__WEBPACK_IMPORTED_MODULE_6_store__["a" /* default */].getState().form,"newbna.values",{});formValues.state=_this.state;if(_this.validationErrors())return;var input={description:Object(__WEBPACK_IMPORTED_MODULE_13_lodash__["get"])(__WEBPACK_IMPORTED_MODULE_6_store__["a" /* default */].getState().form,"newbna.values.description","Description"),formData:JSON.stringify(Object(__WEBPACK_IMPORTED_MODULE_13_lodash__["get"])(__WEBPACK_IMPORTED_MODULE_6_store__["a" /* default */].getState().form,"newbna.values",{})),brokerId:_this.getBrokerId(),clientId:_this.state.clientId,token:Object(__WEBPACK_IMPORTED_MODULE_14_helpers_UserHelper__["c" /* GetUserToken */])()};_this.props.SubmitBna({variables:{input:input}}).then(function(resp){console.log("resp",resp);__WEBPACK_IMPORTED_MODULE_6_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_7_reducers_NotificationReducer__["e" /* successWarning */])({open:true,title:"BNA Submitted!"/* onConfirm: () =>
            
              this.props.history.push({
                pathname: "/app/fnaresults",
                search: `fnaId=${resp.data.SubmitFna.id}`
              })*/}));_this.nextPage();}).catch(function(error){console.log("err",error);});},_this.update=function(){_this.forceUpdate();},_this.initializeDynamicField=function(initializor,fields){if(!_this.state.changes1)return;/* field object: 
        
        fields = [] // list of fields to place default values
        field = 
        {
          field: "",      // the list that needs to be iterated. IE. the list that dictates the amount of dynamic fields to be initialized.
          fieldName: "",  // the field name that has to have a default value
          fieldVar: "",   // the variable that needs the default value
          value: "",      // the default value
          conditions: []  // optional list of conditions
        }
    *//* Condition object:
      conditions = [] // list of condition objects
      condition = 
      {
        condition: "", // the variable that needs to be compared
        param: ""      // the value to campare with
        falseValue: "" // optional value should comparison be false
      }
      */fields.map(function(e0,i0){e0.field.replace("-","");if(String(e0.field).split(".").length>1){console.log(e0.field.split(".")[0]);console.log(e0.field.split(".")[1]);console.log(_this.state[e0.field.split(".")[0]]);console.log(_this.state[e0.field.split(".")[0]][e0.field.split(".")[1]]);}else{console.log("WHOOF---"+e0.field);}if(e0.field.split(".").length>1)_this.state[e0.field.split(".")[0]][e0.field.split(".")[1]].map(function(e,i){var fieldName=e0.fieldName+i;if(!e[initializor])e[initializor]=[];if(!e[initializor][i0]){if(e0.conditions==null){_this.props.change(fieldName,e0.value);e[e0.fieldVar]=e0.value;}else{var conditional=false;e0.conditions.map(function(e1,i1){if(e[e1.condition]==e1.param){_this.props.change(fieldName,e0.value);e[e0.fieldVar]=e0.value;conditional=true;return;}if(e1.falseValue!=null&&!conditional){_this.props.change(fieldName,e1.falseValue);e[e0.fieldVar]=e1.falseValue;}});_this.forceUpdate();}e[initializor][i0]=true;}});else _this.state[e0.field].map(function(e,i){var fieldName=e0.fieldName+i;if(!e[initializor])e[initializor]=[];if(!e[initializor][i0]){if(e0.conditions==null){_this.props.change(fieldName,e0.value);e[e0.fieldVar]=e0.value;console.log(fieldName+" ----- "+e0.value+" >>> "+i0);}else{var conditional=false;e0.conditions.map(function(e1,i1){if(e[e1.condition]==e1.param){_this.props.change(fieldName,e0.value);e[e0.fieldVar]=e0.value;conditional=true;return;}if(e1.falseValue!=null&&!conditional){_this.props.change(fieldName,e1.falseValue);e[e0.fieldVar]=e1.falseValue;}});_this.forceUpdate();}e[initializor][i0]=true;}});});},_temp),_possibleConstructorReturn(_this,_ret);}//Many of the defult values are set here, but only for the state object. The form fields' default values are set using the bna_init.js file.
//Some changes will need to be made so as not to have to change the value twice for every default.
//Also aware that this is not strictly the correct way of handling the form, But using the redux store is a pain and overly complex.
//whoof is just a temporary function for alerting changes that might break older BNA's when editing.
_createClass(BNAWizard,[{key:"checkAssistantActive",value:function checkAssistantActive(){if(Object(__WEBPACK_IMPORTED_MODULE_14_helpers_UserHelper__["b" /* GetUserKey */])("userType")==="6"){if(!this.state.assistantActive){this.setState({assistantActive:true});}return true;}return false;}},{key:"addOwner",value:function addOwner(){var owners=this.state.businessOwners;var newOwner=new __WEBPACK_IMPORTED_MODULE_19__steps_objects_bnaClasses_jsx__["e" /* businessOwner */]();owners.map(function(e,i){var newPurchaser=new __WEBPACK_IMPORTED_MODULE_19__steps_objects_bnaClasses_jsx__["c" /* Purchaser */]();newPurchaser.ownerRef=e;newPurchaser.purchaseFrom=newOwner;newOwner.saleOnDeath.push(newPurchaser);var newPurchaserOwner=new __WEBPACK_IMPORTED_MODULE_19__steps_objects_bnaClasses_jsx__["c" /* Purchaser */]();newPurchaserOwner.ownerRef=newOwner;newPurchaserOwner.purchaseFrom=e;e.saleOnDeath.push(newPurchaserOwner);});owners.push(newOwner);this.setState({businessOwners:owners});}},{key:"addPurchaser",value:function addPurchaser(){var owners=this.state.businessOwners;var newOwner=new __WEBPACK_IMPORTED_MODULE_19__steps_objects_bnaClasses_jsx__["e" /* businessOwner */]();newOwner.isOwner=false;owners.map(function(e,i){var newPurchaser=new __WEBPACK_IMPORTED_MODULE_19__steps_objects_bnaClasses_jsx__["c" /* Purchaser */]();newPurchaser.ownerRef=e;newPurchaser.purchaseFrom=newOwner;newOwner.saleOnDeath.push(newPurchaser);var newPurchaserOwner=new __WEBPACK_IMPORTED_MODULE_19__steps_objects_bnaClasses_jsx__["c" /* Purchaser */]();newPurchaserOwner.ownerRef=newOwner;newPurchaserOwner.purchaseFrom=e;e.saleOnDeath.push(newPurchaserOwner);});owners.push(newOwner);this.setState({businessOwners:owners});}},{key:"addHeir",value:function addHeir(){var heirs=this.state.heirs;heirs.push(new __WEBPACK_IMPORTED_MODULE_19__steps_objects_bnaClasses_jsx__["a" /* Heir */]());this.setState({heirs:heirs});}},{key:"addKeyPerson",value:function addKeyPerson(){var keyPersons=this.state.keyPersons;keyPersons.push(new __WEBPACK_IMPORTED_MODULE_19__steps_objects_bnaClasses_jsx__["b" /* KeyPerson */]());this.setState({keyPersons:keyPersons});}},{key:"addSurety",value:function addSurety(){var sureties=this.state.sureties;sureties.push(new __WEBPACK_IMPORTED_MODULE_19__steps_objects_bnaClasses_jsx__["d" /* Surety */]());this.setState({sureties:sureties});}},{key:"removeEntity",value:function removeEntity(n,item){var entity=this.state[item];var newEntity=[];var node=n.target;while(node.nodeName!="BUTTON"&&node.parentNode!=null){node=node.parentNode;}var i=node.name.replace("remove","");console.log(JSON.stringify(entity));entity.map(function(e,k){if(e!=entity[i])newEntity[k]=e;if(e==entity[i]){entity[i].deleted=true;}});this.state[item]=newEntity;this.forceUpdate();//this.setState({businessOwners: newOwner})
}},{key:"removeOwner",value:function removeOwner(n){var owners=this.state.businessOwners;var newOwner=[];var node=n.target;while(node.nodeName!="BUTTON"&&node.parentNode!=null){node=node.parentNode;}var i=node.name.replace("remove","");console.log(owners);owners.map(function(e,k){console.log(e+" --- "+owners[i]);if(e!=owners[i])newOwner[k]=e;if(e==owners[i]){owners[i].deleted=true;}});this.setState({businessOwners:newOwner});this.cleanOwners();this.forceUpdate();}},{key:"cleanOwners",value:function cleanOwners(){var _this2=this;this.state.businessOwners.map(function(e,i){e.saleOnDeath.map(function(e,i){console.log(e.ownerRef);if(e.ownerRef.deleted)e.purchaseFrom.saleOnDeath.splice(i,1);});});this.state.businessOwners.map(function(e,i){if(e.deleted)_this2.state.businessOwners.splice(i,1);});}},{key:"render",value:function render(){var _this3=this;var params=Object(__WEBPACK_IMPORTED_MODULE_15_helpers_UriReader__["a" /* ParseUriParams */])(this.props.location.search);this.state.params=params;var id=params.id,clientId=params.clientId;var page=this.state.page;if(!this.state.changes1&&this.state.formInitiazed){this.showChanges();}return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react_apollo__["Query"],{query:__WEBPACK_IMPORTED_MODULE_11_queries_fna_queries__["a" /* FnaById */],variables:{clientId:35,fnaId:id?id:null},fetchPolicy:"network-only"},function(_ref2){var loading=_ref2.loading,error=_ref2.error,data=_ref2.data;if(loading)return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["B" /* LinearProgress */],null));if(error)return"Error! "+error.message;var form_data=__WEBPACK_IMPORTED_MODULE_13_lodash___default.a.get(data,"FnaById.form_data",null);var editMode=__WEBPACK_IMPORTED_MODULE_13_lodash___default.a.get(data,"FnaById.editMode",false);var formData=form_data?JSON.parse(form_data):null;if(formData)_this3.client=formData.client;console.log(_this3.client);if(!_this3.state.formInitiazed){_this3.initializeForm(formData,editMode);_this3.setState({clientId:clientId});_this3.setState({client:formData.client});}return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{container:true},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:10,style:{margin:"auto",width:"100%"}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div",{className:"fixedStepper"},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{container:true},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:10,style:{flexBasis:"100%",maxWidth:"100%",margin:'auto'}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div",{className:"stepperDiv"},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["G" /* MobileStepper */],{type:"progress",steps:_this3.state.pageCount,position:"static",activeStep:_this3.state.page,nextButton:__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div",{style:{display:"flex"}},_this3.state.page===_this3.state.pageCount-1?__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["d" /* Button */],{variant:"outlined",className:"outlinedButton",color:"secondary",style:{marginRight:"10px"},onClick:function onClick(){return _this3.submit();}},"Submit"):__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div",null),_this3.state.page===_this3.state.pageCount-1?null:__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["d" /* Button */],{variant:"outlined",className:"outlinedButton",color:"secondary",style:{marginRight:"10px"},onClick:function onClick(){return _this3.nextPage();}},"Next")),backButton:__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["d" /* Button */],{variant:"outlined",className:"outlinedButton",color:"secondary",style:{marginLeft:"10px"},onClick:function onClick(){return _this3.previousPage();},disabled:_this3.state.page===0?true:false},"Back")}))))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("br",null),!_this3.state.changes1&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:24,sm:24,md:6,style:{marginBottom:'25px'}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{container:true},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:6,sm:6,md:10,style:{marginBottom:'0px'}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px'}},"Changes to the BNA has been made. Please confirm that all information is correct.")),checkItem("","changes1",_this3.changePersonal))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["a" /* AppBar */],{position:"static",color:"default",style:{marginBottom:'-20px',marginTop:'10px',marginLeft:"25px"}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["W" /* Tabs */],{tab:_this3.state.page,onChange:_this3.handleChangeTab,indicatorColor:"primary",textColor:"secondary",scrollable:true,scrollButtons:"auto"},tabs.map(function(t,i){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["P" /* Tab */],{label:t,style:i===_this3.state.page?tabStyle:{marginRight:"-15px"}});}))),page===0&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__steps_PersonalDetail__["a" /* default */],{checkValidation:_this3.state.checkValidation,scrollMeBar:_this3.props.scrollMeBar,changePersonal:_this3.changePersonal.bind(_this3),changeHeir:_this3.changeHeir.bind(_this3),addOwner:_this3.addOwner.bind(_this3),addPurchaser:_this3.addPurchaser.bind(_this3),addHeir:_this3.addHeir.bind(_this3),addKeyPerson:_this3.addKeyPerson.bind(_this3),addSurety:_this3.addSurety.bind(_this3),removeOwner:_this3.removeOwner.bind(_this3),removeEntity:_this3.removeEntity.bind(_this3),update:_this3.update.bind(_this3),state:_this3.state}),page===1&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__steps_BuySell__["a" /* default */],{checkValidation:_this3.state.checkValidation,scrollMeBar:_this3.props.scrollMeBar,initializeDynamicField:_this3.initializeDynamicField.bind(_this3),changePersonal:_this3.changePersonal.bind(_this3),changeEstateDuty:_this3.changeEstateDuty.bind(_this3),addOwner:_this3.addOwner.bind(_this3),addPurchaser:_this3.addPurchaser.bind(_this3),addHeir:_this3.addHeir.bind(_this3),addKeyPerson:_this3.addKeyPerson.bind(_this3),addSurety:_this3.addSurety.bind(_this3),removeOwner:_this3.removeOwner.bind(_this3),removeEntity:_this3.removeEntity.bind(_this3),update:_this3.update.bind(_this3),state:_this3.state})));});}}]);return BNAWizard;}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);BNAWizard=Object(__WEBPACK_IMPORTED_MODULE_3_redux_form__["e" /* reduxForm */])({form:"newbna",destroyOnUnmount:true})(BNAWizard);BNAWizard=Object(__WEBPACK_IMPORTED_MODULE_12_react_apollo__["compose"])(Object(__WEBPACK_IMPORTED_MODULE_12_react_apollo__["graphql"])(__WEBPACK_IMPORTED_MODULE_10_queries_fna_mutations__["a" /* SubmitFna */],{name:"SubmitBna"}))(BNAWizard);/* harmony default export */ __webpack_exports__["a"] = (BNAWizard);

/***/ }),
/* 2608 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_core__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_Wrappers_materialUIWrappers_components_FormCheckbox_jsx__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Wrappers_materialUIWrappers_components_FormDropDown__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Wrappers_materialUIWrappers_components_FormInput__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_redux_form__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_store__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_CustomCardHeading__ = __webpack_require__(688);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_Wrappers_materialUIWrappers_components_NumberInput__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_helpers_ValidationHelpers__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_helpers_DateHelpers__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_helpers_GetIdInformation__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_moment__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_DescriptiveCell_jsx__ = __webpack_require__(689);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__PersonalDetail_css__ = __webpack_require__(2609);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__PersonalDetail_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__PersonalDetail_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/*eslint-disable*/var required=function required(value){return value?undefined:"Required";};var colwidth=function colwidth(value){return{width:value,minWidth:value,maxWidth:value};};var CustomFieldMed=function CustomFieldMed(props){return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:6,sm:6,md:6,style:{marginTop:'25px'}},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["t" /* FormControl */],{fullWidth:true},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_redux_form__["a" /* Field */],props)));};var CustomField2=function CustomField2(props){return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:6,sm:6,md:6,style:{marginTop:'25px'}},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["t" /* FormControl */],{fullWidth:true},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_redux_form__["a" /* Field */],props)));};var CustomFieldFullWidth=function CustomFieldFullWidth(props){return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:12,style:{marginBottom:'25px'}},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["t" /* FormControl */],{fullWidth:true},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_redux_form__["a" /* Field */],props)));};var CustomFieldN=function CustomFieldN(props){return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["t" /* FormControl */],{fullWidth:true},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_redux_form__["a" /* Field */],props));};var checkItem=function checkItem(label,name,changeFunc){return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:4,sm:4,md:2},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["t" /* FormControl */],{style:{marginBottom:"-27px",paddingBottom:"-27px"}},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_2_components_Wrappers_materialUIWrappers_components_FormCheckbox_jsx__["a" /* default */],name:name,onChange:function onChange(e,f,g,h){changeFunc(h,f);}})));};var PersonalDetail=function(_React$Component){_inherits(PersonalDetail,_React$Component);function PersonalDetail(){_classCallCheck(this,PersonalDetail);return _possibleConstructorReturn(this,(PersonalDetail.__proto__||Object.getPrototypeOf(PersonalDetail)).apply(this,arguments));}_createClass(PersonalDetail,[{key:"componentDidMount",value:function componentDidMount(){this.props.scrollMeBar();}},{key:"changeReason",value:function changeReason(name){var reasons=this.props.fnaReasons;reasons[name]=!reasons[name];console.log(reasons);this.props.changePersonal("fnaReasons",reasons);}},{key:"render",value:function render(){var _this2=this;var clientD="";/* if(this.props.state.client)
      clientD = this.props.state.client.first_name + " " + this.props.state.client.surname*/return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement("div",{className:"contentWithStepper"},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["e" /* Card */],{style:{width:"120%",marginLeft:"-10%"}},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["f" /* CardContent */],null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_CustomCardHeading__["a" /* default */],{subheading:"Business Needs Analysis",caption:clientD,headline:"Business Details"}),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{container:true},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(CustomFieldMed,{name:'description',component:__WEBPACK_IMPORTED_MODULE_4_components_Wrappers_materialUIWrappers_components_FormInput__["a" /* default */],checkValidation:this.props.checkValidation,label:'Business Needs Analysis for: ',isrequired:true//validate={[required]}
})),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{container:true},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(CustomFieldMed,{name:'companyName',component:__WEBPACK_IMPORTED_MODULE_4_components_Wrappers_materialUIWrappers_components_FormInput__["a" /* default */],checkValidation:this.props.checkValidation,label:'Registered Name',isrequired:true//validate={[required]}
,onChange:function onChange(e,f,g,h){_this2.props.changePersonal(h,f);}}),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(CustomFieldMed,{name:'companyRegNr',component:__WEBPACK_IMPORTED_MODULE_4_components_Wrappers_materialUIWrappers_components_FormInput__["a" /* default */],checkValidation:this.props.checkValidation,label:'Registration Number',isrequired:true//validate={[required]}
,onChange:function onChange(e,f,g,h){_this2.props.changePersonal(h,f);}}),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(CustomField2,{name:"entityType",component:__WEBPACK_IMPORTED_MODULE_3_components_Wrappers_materialUIWrappers_components_FormDropDown__["a" /* default */],checkValidation:this.props.checkValidation,label:'Entity Type',isrequired:true//validate={[required]}
,options:[{displayValue:"Company",value:"company",limit:1},{displayValue:"Closed Corporation",value:"cc",limit:1},{displayValue:"Trust",value:"trust",limit:1},{displayValue:"Partnership",value:"partnership",limit:1},{displayValue:"Sole Proprietor",value:"soleProtrietor",limit:1},{displayValue:"Individual",value:"individual",limit:1}],onChange:function onChange(e,value,t,name){return _this2.changePersonal(value,name);}}),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(CustomFieldMed,{name:'marketValue',prefix:"R",component:__WEBPACK_IMPORTED_MODULE_10_components_Wrappers_materialUIWrappers_components_NumberInput__["a" /* default */],checkValidation:this.props.checkValidation,label:'Company Market Value',isrequired:true//validate={[required]}
,onChange:function onChange(e,value,t,name){return _this2.props.changePersonal(value,name);}}),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{container:true},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(CustomField2,{name:"buySell",component:__WEBPACK_IMPORTED_MODULE_3_components_Wrappers_materialUIWrappers_components_FormDropDown__["a" /* default */],checkValidation:this.props.checkValidation,label:'Buy and Sell',isrequired:true//validate={[required]}
,options:[{displayValue:"Traditional",value:"traditional",limit:1},{displayValue:"Alternative",value:"alterantive",limit:1},{displayValue:"Share Buy Back",value:"shareBuyBack",limit:1}],onChange:function onChange(e,value,t,name){return _this2.props.changePersonal(value,name);}})),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:24,sm:24,md:6,style:{marginBottom:'25px'}},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{container:true}))),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["q" /* ExpansionPanel */],{defaultExpanded:0===1,key:101},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["s" /* ExpansionPanelSummary */],{expandIcon:__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["w" /* Icon */],null,"expand_more")},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',fontWeight:"420"}},"Business Owner/s:")),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["r" /* ExpansionPanelDetails */],{onClick:function onClick(event){event.stopPropagation();}},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{container:true,spacing:24},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Q" /* Table */],{className:"customTable1"},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["T" /* TableHead */],{className:"fixedHead"},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingTiny",style:colwidth("6em"),rowSpan:2},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center"}},"Type Of Entity")),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall",style:colwidth("6em"),rowSpan:2},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px'}},"Full names and surname / Entity Name")),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingTiny",style:colwidth("6em"),rowSpan:2},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center",verticalAlign:'bottom'}},"ID number/Reg.no.")),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall",style:colwidth("6em"),rowSpan:2},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center"}},"Percentage ownership")),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall",style:colwidth("6em"),rowSpan:2},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center"}},"Loan Account")),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingTiny",style:colwidth("12em"),colSpan:2,rowSpan:1},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center"}},"Insured Life"))),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingTiny",id:"doubleLine",style:{colwidth:"6em"}},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center"}},"Full names and surname")),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingTiny",style:colwidth("6em")},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center"}},"ID number")))),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["R" /* TableBody */],null,this.props.state.businessOwners.map(function(e,i){console.log(e);if(e.isOwner===true)return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{style:{paddingRight:'0px'}},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["d" /* Button */],{name:"remove"+i,key:"remove"+i,variant:"fab",mini:true,className:"minifab",color:"primary",style:{left:"-20px",top:"0px"},onClick:function onClick(e){e.stopPropagation();_this2.props.removeOwner(e);}},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["w" /* Icon */],{style:{color:"white"}},"remove")),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(CustomFieldN,{name:"businessOwners.type-"+i,component:__WEBPACK_IMPORTED_MODULE_3_components_Wrappers_materialUIWrappers_components_FormDropDown__["a" /* default */],checkValidation:_this2.props.checkValidation,label:'',isrequired:true//validate={[required]}
,options:[{displayValue:"Company",value:"company",limit:1},{displayValue:"Closed Corporation",value:"cc",limit:1},{displayValue:"Trust",value:"trust",limit:1},{displayValue:"Partnership",value:"partnership",limit:1},{displayValue:"Sole Proprietor",value:"soleProtrietor",limit:1},{displayValue:"Individual",value:"individual",limit:1}],onChange:function onChange(e,value,t,name){return _this2.props.changePersonal(value,name);}})),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{style:{padding:'5px',paddingTop:"27px",paddingBottom:"5px"}},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(CustomFieldN,{name:'businessOwners.name-'+i,component:__WEBPACK_IMPORTED_MODULE_4_components_Wrappers_materialUIWrappers_components_FormInput__["a" /* default */],checkValidation:_this2.props.checkValidation,label:'Name',isrequired:false,onChange:function onChange(e,value,t,name){return _this2.props.changePersonal(value,name);}})),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{style:{padding:'5px',paddingTop:"27px",paddingBottom:"5px"}},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(CustomFieldN,{name:'businessOwners.id-'+i,component:__WEBPACK_IMPORTED_MODULE_4_components_Wrappers_materialUIWrappers_components_FormInput__["a" /* default */],checkValidation:_this2.props.checkValidation,label:'ID',isrequired:false,onChange:function onChange(e,value,t,name){return _this2.props.changePersonal(value,name);}})),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{style:{padding:'5px',paddingTop:"27px",paddingBottom:"5px"}},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(CustomFieldN,{name:'businessOwners.ownership-'+i,suffix:"%",component:__WEBPACK_IMPORTED_MODULE_10_components_Wrappers_materialUIWrappers_components_NumberInput__["a" /* default */],checkValidation:_this2.props.checkValidation,label:'%',isrequired:false,onChange:function onChange(e,value,t,name){return _this2.props.changePersonal(value,name);}})),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{style:{padding:'5px',paddingTop:"27px",paddingBottom:"5px"}},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(CustomFieldN,{name:'businessOwners.loan-'+i,component:__WEBPACK_IMPORTED_MODULE_10_components_Wrappers_materialUIWrappers_components_NumberInput__["a" /* default */],checkValidation:_this2.props.checkValidation,label:'R',isrequired:false,prefix:"R",onChange:function onChange(e,value,t,name){return _this2.props.changePersonal(value,name);}})),e.type!=="individual"&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{style:{padding:'5px',paddingTop:"27px",paddingBottom:"5px"}},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(CustomFieldN,{name:'businessOwners.insuredName-'+i,component:__WEBPACK_IMPORTED_MODULE_4_components_Wrappers_materialUIWrappers_components_FormInput__["a" /* default */],checkValidation:_this2.props.checkValidation,label:'Name',isrequired:false,onChange:function onChange(e,value,t,name){return _this2.props.changePersonal(value,name);}})),e.type!=="individual"&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{style:{padding:'5px',paddingTop:"27px",paddingBottom:"5px"}},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(CustomFieldN,{name:'businessOwners.insuredId-'+i,component:__WEBPACK_IMPORTED_MODULE_4_components_Wrappers_materialUIWrappers_components_FormInput__["a" /* default */],checkValidation:_this2.props.checkValidation,label:'ID',isrequired:false,onChange:function onChange(e,value,t,name){return _this2.props.changePersonal(value,name);}})));}),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{colSpan:2},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__components_DescriptiveCell_jsx__["a" /* default */],{width:"150em",description:"Add Owner",add:function add(){return _this2.props.addOwner();}})))))))),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["q" /* ExpansionPanel */],{defaultExpanded:0===1,key:102},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["s" /* ExpansionPanelSummary */],{expandIcon:__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["w" /* Icon */],null,"expand_more")},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',fontWeight:"420"}},"Other Purchaser/s:")),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["r" /* ExpansionPanelDetails */],{onClick:function onClick(event){event.stopPropagation();}},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{container:true,spacing:24},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Q" /* Table */],{className:"customTable1"},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["T" /* TableHead */],{className:"fixedHead"},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall",style:colwidth("48em")},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px'}},"Full names and surname / Entity Name")),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingTiny",style:colwidth("48em")},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center"}},"ID number/Regno")))),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["R" /* TableBody */],null,this.props.state.businessOwners.map(function(e,i){if(!e.isOwner)return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{style:{paddingRight:'0px'}},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["d" /* Button */],{name:"remove"+i,key:"remove"+i,variant:"fab",mini:true,className:"minifab",color:"primary",style:{left:"-20px",top:"0px"},onClick:function onClick(e){e.stopPropagation();_this2.props.removeOwner(e);}},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["w" /* Icon */],{style:{color:"white"}},"remove")),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(CustomFieldN,{name:'businessOwners.name-'+i,component:__WEBPACK_IMPORTED_MODULE_4_components_Wrappers_materialUIWrappers_components_FormInput__["a" /* default */],checkValidation:_this2.props.checkValidation,label:'Name',isrequired:false,onChange:function onChange(e,value,t,name){return _this2.props.changePersonal(value,name);}})),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{style:{padding:'5px',paddingTop:"27px",paddingBottom:"5px"}},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(CustomFieldN,{name:'businessOwners.id-'+i,component:__WEBPACK_IMPORTED_MODULE_4_components_Wrappers_materialUIWrappers_components_FormInput__["a" /* default */],checkValidation:_this2.props.checkValidation,label:'ID/Regno',isrequired:false,onChange:function onChange(e,value,t,name){return _this2.props.changePersonal(value,name);}})));}),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{width:"12em"},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{variant:"title"},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__components_DescriptiveCell_jsx__["a" /* default */],{width:"12em",description:"Add Purchaser",add:function add(){return _this2.props.addPurchaser();}}))))))))),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["q" /* ExpansionPanel */],{defaultExpanded:0===1,key:103},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["s" /* ExpansionPanelSummary */],{expandIcon:__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["w" /* Icon */],null,"expand_more")},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',fontWeight:"420"}},"Heir/s:")),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["r" /* ExpansionPanelDetails */],{onClick:function onClick(event){event.stopPropagation();}},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{container:true,spacing:24},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Q" /* Table */],{className:"customTable1"},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["T" /* TableHead */],{className:"fixedHead"},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall",style:colwidth("48em")},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px'}},"Full names and surname / Entity Name")),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingTiny",style:colwidth("48em")},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center"}},"ID number/Regno")),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center"}},"Heir to")),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center"}},"Inherit Amount")))),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["R" /* TableBody */],null,this.props.state.heirs.map(function(e,i){var owners=[{displayValue:"Please Select",value:"",limit:1}];_this2.props.state.businessOwners.map(function(e,i){owners.push({displayValue:e.name,value:e.name,limit:1});});return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{style:{paddingRight:'0px'}},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["d" /* Button */],{name:"remove"+i,key:"remove"+i,variant:"fab",mini:true,className:"minifab",color:"primary",style:{left:"-20px",top:"0px"},onClick:function onClick(e){e.stopPropagation();_this2.props.removeEntity(e,"heirs");}},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["w" /* Icon */],{style:{color:"white"}},"remove")),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(CustomFieldN,{name:'heirs.name-'+i,component:__WEBPACK_IMPORTED_MODULE_4_components_Wrappers_materialUIWrappers_components_FormInput__["a" /* default */],checkValidation:_this2.props.checkValidation,label:'Name',isrequired:false,onChange:function onChange(e,value,t,name){return _this2.props.changeHeir(value,name);}})),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{style:{padding:'5px',paddingTop:"27px",paddingBottom:"5px"}},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(CustomFieldN,{name:'heirs.id-'+i,component:__WEBPACK_IMPORTED_MODULE_4_components_Wrappers_materialUIWrappers_components_FormInput__["a" /* default */],checkValidation:_this2.props.checkValidation,label:'ID/Regno',isrequired:false,onChange:function onChange(e,value,t,name){return _this2.props.changeHeir(value,name);}})),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{style:{padding:'5px',paddingTop:"27px",paddingBottom:"5px"}},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(CustomFieldN,{name:"heirs.to-"+i,component:__WEBPACK_IMPORTED_MODULE_3_components_Wrappers_materialUIWrappers_components_FormDropDown__["a" /* default */],checkValidation:_this2.props.checkValidation,label:'',isrequired:true//validate={[required]}
,options:owners,onChange:function onChange(e,value,t,name){return _this2.props.changeHeir(value,name);}})),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{style:{padding:'5px',paddingTop:"27px",paddingBottom:"5px"}},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(CustomFieldN,{name:'heirs.inherit-'+i,suffix:"%",component:__WEBPACK_IMPORTED_MODULE_10_components_Wrappers_materialUIWrappers_components_NumberInput__["a" /* default */],checkValidation:_this2.props.checkValidation,label:'%',isrequired:false,onChange:function onChange(e,value,t,name){return _this2.props.changeHeir(value,name);}})));}),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{width:"12em"},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{variant:"title"},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__components_DescriptiveCell_jsx__["a" /* default */],{width:"12em",description:"Add Heir",add:function add(){return _this2.props.addHeir();}}))))))))),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["q" /* ExpansionPanel */],{defaultExpanded:0===1,key:104},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["s" /* ExpansionPanelSummary */],{expandIcon:__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["w" /* Icon */],null,"expand_more")},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',fontWeight:"420"}},"Key persons:")),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["r" /* ExpansionPanelDetails */],{onClick:function onClick(event){event.stopPropagation();}},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{container:true,spacing:24},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Q" /* Table */],{className:"customTable1"},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["T" /* TableHead */],{className:"fixedHead"},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall",style:colwidth("48em")},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px'}},"Full names and surname / Entity Name")),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingTiny",style:colwidth("48em")},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center"}},"ID number/Regno")))),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["R" /* TableBody */],null,this.props.state.keyPersons.map(function(e,i){return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{style:{paddingRight:'0px'}},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["d" /* Button */],{name:"remove"+i,key:"remove"+i,variant:"fab",mini:true,className:"minifab",color:"primary",style:{left:"-20px",top:"0px"},onClick:function onClick(e){e.stopPropagation();_this2.props.removeEntity(e,"keyPersons");}},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["w" /* Icon */],{style:{color:"white"}},"remove")),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(CustomFieldN,{name:'keyPersons.name'+i,component:__WEBPACK_IMPORTED_MODULE_4_components_Wrappers_materialUIWrappers_components_FormInput__["a" /* default */],checkValidation:_this2.props.checkValidation,label:'Name',isrequired:false,onChange:function onChange(e,value,t,name){return _this2.props.changePersonal(value,name);}})),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{style:{padding:'5px',paddingTop:"27px",paddingBottom:"5px"}},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(CustomFieldN,{name:'keyPersons.id'+i,component:__WEBPACK_IMPORTED_MODULE_4_components_Wrappers_materialUIWrappers_components_FormInput__["a" /* default */],checkValidation:_this2.props.checkValidation,label:'ID/Regno',isrequired:false,onChange:function onChange(e,value,t,name){return _this2.props.changePersonal(value,name);}})));}),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{width:"12em"},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{variant:"title"},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__components_DescriptiveCell_jsx__["a" /* default */],{width:"12em",description:"Add Key Person",add:function add(){return _this2.props.addKeyPerson();}}))))))))),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["q" /* ExpansionPanel */],{defaultExpanded:0===1,key:105},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["s" /* ExpansionPanelSummary */],{expandIcon:__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["w" /* Icon */],null,"expand_more")},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',fontWeight:"420"}},"Surety:")),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["r" /* ExpansionPanelDetails */],{onClick:function onClick(event){event.stopPropagation();}},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{container:true,spacing:24},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Q" /* Table */],{className:"customTable1"},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["T" /* TableHead */],{className:"fixedHead"},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingSmall",style:colwidth("48em")},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px'}},"Full names and surname / Entity Name")),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingTiny",style:colwidth("48em")},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center"}},"ID number/Regno")))),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["R" /* TableBody */],null,this.props.state.sureties.map(function(e,i){return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{style:{paddingRight:'0px'}},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["d" /* Button */],{name:"remove"+i,key:"remove"+i,variant:"fab",mini:true,className:"minifab",color:"primary",style:{left:"-20px",top:"0px"},onClick:function onClick(e){e.stopPropagation();_this2.props.removeEntity(e,"sureties");}},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["w" /* Icon */],{style:{color:"white"}},"remove")),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(CustomFieldN,{name:'sureties.name'+i,component:__WEBPACK_IMPORTED_MODULE_4_components_Wrappers_materialUIWrappers_components_FormInput__["a" /* default */],checkValidation:_this2.props.checkValidation,label:'Name',isrequired:false,onChange:function onChange(e,value,t,name){return _this2.props.changePersonal(value,name);}})),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{style:{padding:'5px',paddingTop:"27px",paddingBottom:"5px"}},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(CustomFieldN,{name:'sureties.id'+i,component:__WEBPACK_IMPORTED_MODULE_4_components_Wrappers_materialUIWrappers_components_FormInput__["a" /* default */],checkValidation:_this2.props.checkValidation,label:'ID/Regno',isrequired:false,onChange:function onChange(e,value,t,name){return _this2.props.changePersonal(value,name);}})));}),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{width:"12em"},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{variant:"title"},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__components_DescriptiveCell_jsx__["a" /* default */],{width:"12em",description:"Add Surety",add:function add(){return _this2.props.addSurety();}}))))))))))));}}]);return PersonalDetail;}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (PersonalDetail);

/***/ }),
/* 2609 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2610 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_core__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_Wrappers_materialUIWrappers_components_FormCheckbox_jsx__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Wrappers_materialUIWrappers_components_FormDropDown__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Wrappers_materialUIWrappers_components_FormInput__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_redux_form__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_store__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_CustomCardHeading__ = __webpack_require__(688);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_Wrappers_materialUIWrappers_components_NumberInput__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_helpers_ValidationHelpers__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_helpers_DateHelpers__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_helpers_GetIdInformation__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_moment__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_DescriptiveCell_jsx__ = __webpack_require__(689);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__BuySell_css__ = __webpack_require__(2611);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__BuySell_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__BuySell_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/*eslint-disable*/var required=function required(value){return value?undefined:"Required";};var colwidth=function colwidth(value){return{width:value,minWidth:value,maxWidth:value};};var CustomFieldMed=function CustomFieldMed(props){return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:6,sm:6,md:6,style:{marginTop:'25px'}},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["t" /* FormControl */],{fullWidth:true},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_redux_form__["a" /* Field */],props)));};var CustomField2=function CustomField2(props){return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:6,sm:6,md:6,style:{marginTop:'25px'}},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["t" /* FormControl */],{fullWidth:true},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_redux_form__["a" /* Field */],props)));};var CustomFieldFullWidth=function CustomFieldFullWidth(props){return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:12,style:{marginBottom:'25px'}},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["t" /* FormControl */],{fullWidth:true},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_redux_form__["a" /* Field */],props)));};var CustomFieldN=function CustomFieldN(props){return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["t" /* FormControl */],{fullWidth:true},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_redux_form__["a" /* Field */],props));};var CustomFieldN2=function CustomFieldN2(props){return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["t" /* FormControl */],{fullWidth:true,className:"rightAlign"},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_redux_form__["a" /* Field */],props));};var checkItem=function checkItem(label,name,changeFunc){return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:4,sm:4,md:2},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["t" /* FormControl */],{style:{marginBottom:"-27px",paddingBottom:"-27px"}},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_2_components_Wrappers_materialUIWrappers_components_FormCheckbox_jsx__["a" /* default */],name:name,onChange:function onChange(e,f,g,h){changeFunc(f,h);}})));};var BuySell=function(_React$Component){_inherits(BuySell,_React$Component);function BuySell(){_classCallCheck(this,BuySell);return _possibleConstructorReturn(this,(BuySell.__proto__||Object.getPrototypeOf(BuySell)).apply(this,arguments));}_createClass(BuySell,[{key:"componentDidMount",value:function componentDidMount(){var _this2=this;this.props.state.businessOwners.map(function(e,i){e.saleOnDeath.map(function(e,i){e.standardPurchase=e.ownerRef.ownership*1/((100-e.purchaseFrom.ownership*1)/100);e.customPurchase=e.ownerRef.ownership*1/((100-e.purchaseFrom.ownership*1)/100);});});this.props.scrollMeBar();this.props.state.businessOwners.map(function(e,i){var taxables=[{field:"businessOwners",fieldName:"businessOwners.tax-",fieldVar:"tax",value:false,conditions:[{condition:"type",param:"individual",falseValue:true}]}];_this2.props.initializeDynamicField("taxablesInit",taxables);});var duties=[{field:"businessOwners",fieldName:"businessOwners.taxAmount-",fieldVar:"taxAmount",value:"20"}];this.props.initializeDynamicField("dutiesInit",duties);console.log(this.props.state);}},{key:"changeReason",value:function changeReason(name){var reasons=this.props.fnaReasons;reasons[name]=!reasons[name];console.log(reasons);this.props.changePersonal("fnaReasons",reasons);}},{key:"render",value:function render(){var _this3=this;var clientD="";/* if(this.props.state.client)
      clientD = this.props.state.client.first_name + " " + this.props.state.client.surname*/return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement("div",{className:"contentWithStepper"},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["e" /* Card */],{style:{width:"120%",marginLeft:"-10%"}},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["f" /* CardContent */],null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_CustomCardHeading__["a" /* default */],{subheading:"Business Needs Analysis",caption:clientD,headline:"Buy and Sell"}),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement("h4",null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement("b",null,"Sale on death of:")),this.props.state.businessOwners.map(function(e,i){var owner=e;var ownerI=i;if(e.isOwner)return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["q" /* ExpansionPanel */],{defaultExpanded:1===0,key:101},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["s" /* ExpansionPanelSummary */],{expandIcon:__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["w" /* Icon */],null,"expand_more")},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{container:true,direction:"row",justifyContent:"flex-end",alignItems:"center"},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:2,sm:2,md:2,style:{marginTop:'25px'}},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'21px',fontWeight:"420"}},e.name)),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:2,sm:2,md:2,style:{marginTop:'25px'}},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',fontWeight:"410"}},"Current Ownership"," "," ",e.ownership,"%")),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:2,sm:2,md:2,style:{marginTop:'25px'}},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',fontWeight:"410"}},"Going To Heirs"," "," ",e.minusInheritance,"%")),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:3,sm:3,md:3,style:{marginTop:'25px'}},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',fontWeight:"410"}},"Value to be sold"," "," R",((e.ownership/100-e.ownership*(e.minusInheritance/100)/100)*(_this3.props.state.marketValue*1)).toFixed(2))),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:2,sm:2,md:2,style:{marginTop:'25px'}},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',fontWeight:"410"}},"Loan amount"," "," R",e.loan)),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:12,style:{margin:'0px',padding:"0px"}},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement("hr",{style:{height:"1px",backgroundColor:"gray",borderColor:"gray"}})))),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["r" /* ExpansionPanelDetails */],{onClick:function onClick(event){event.stopPropagation();}},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Q" /* Table */],{className:"customTable1"},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["T" /* TableHead */],{className:"fixedHead"},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingTiny",style:colwidth("3em"),colSpan:2},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px'}})),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingTiny",style:colwidth("3em"),colSpan:2},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center"}},"Existing")),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingTiny",style:colwidth("3em"),colSpan:2},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center"}},"Nett Need"))),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingTiny",style:colwidth("6em")},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center"}},"Estate Duty")),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingTiny",style:colwidth("6em")},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center"}},"%")),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingTiny",style:colwidth("6em")},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center"}},"Death")),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingTiny",style:colwidth("6em")},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center"}},"Disability")),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingTiny",style:colwidth("6em")},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center"}},"Death")),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{className:"cellPaddingTiny",style:colwidth("6em")},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center"}},"Disability")))),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["R" /* TableBody */],null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{style:{padding:'5px',paddingTop:"27px",paddingBottom:"5px",textAlign:"center"}},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{container:true,direction:"row",justifyContent:"flex-end",alignItems:"center"},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:3,sm:3,md:3,style:{}}),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:9,sm:9,md:9,style:{}},checkItem("","businessOwners.tax-"+i,_this3.props.changeEstateDuty)))),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{style:{padding:'5px',paddingTop:"27px",paddingBottom:"5px"}},_this3.props.state.businessOwners[i].tax===true&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(CustomFieldN,{name:'businessOwners.taxAmount-'+i,suffix:"%",component:__WEBPACK_IMPORTED_MODULE_10_components_Wrappers_materialUIWrappers_components_NumberInput__["a" /* default */],checkValidation:_this3.props.checkValidation,label:'% Estate Duty',isrequired:false,onChange:function onChange(e,value,t,name){return _this3.props.changePersonal(value,name);}})),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{style:{padding:'5px',paddingTop:"27px",paddingBottom:"5px"}},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(CustomFieldN,{name:'businessOwners.deathExisting-'+i,prefix:"R",component:__WEBPACK_IMPORTED_MODULE_10_components_Wrappers_materialUIWrappers_components_NumberInput__["a" /* default */],checkValidation:_this3.props.checkValidation,label:'R',isrequired:true//validate={[required]}
,onChange:function onChange(e,f,g,h){_this3.props.changePersonal(f,h);}})),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{style:{padding:'5px',paddingTop:"27px",paddingBottom:"5px"}},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(CustomFieldN,{name:'businessOwners.disabilityExisting-'+i,prefix:"R",component:__WEBPACK_IMPORTED_MODULE_10_components_Wrappers_materialUIWrappers_components_NumberInput__["a" /* default */],checkValidation:_this3.props.checkValidation,label:'R',isrequired:true//validate={[required]}
,onChange:function onChange(e,f,g,h){_this3.props.changePersonal(f,h);}})),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{style:{padding:'5px',paddingTop:"27px",paddingBottom:"5px"}},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center"}},(e.ownership/100*_this3.props.state.marketValue+1*e.loan)/(1-e.taxAmount/100)-e.deathExisting)),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{style:{padding:'5px',paddingTop:"27px",paddingBottom:"5px"}},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',textAlign:"center"}},e.ownership/100*_this3.props.state.marketValue+1*e.loan-e.disabilityExisting))),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{colSpan:6},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{container:true},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:12,style:{margin:'0px',padding:"0px"}},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement("hr",{style:{height:"1px",backgroundColor:"gray",borderColor:"gray"}})))))))),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["r" /* ExpansionPanelDetails */],{onClick:function onClick(event){event.stopPropagation();}},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{container:true,spacing:24},e.saleOnDeath.map(function(e,i){{return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["q" /* ExpansionPanel */],{defaultExpanded:1===0,key:111},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["s" /* ExpansionPanelSummary */],{expandIcon:__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["w" /* Icon */],null,"expand_more")},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{container:true,spacing:24},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:2,sm:2,md:2,style:{marginTop:'25px'}},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',fontWeight:"410"}},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement("h5",null,"Purchaser: "," "," ",e.ownerRef.name))),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:2,sm:2,md:2,style:{marginTop:'25px'}},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',fontWeight:"410"}},"Current Ownership: "," "," ",e.ownerRef.ownership,"%")),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:2,sm:2,md:2,style:{marginTop:'25px'}},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',fontWeight:"410"}},"Traditionally Bought: "," "," ",e.standardPurchase.toFixed(2),"%")),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:2,sm:2,md:2,style:{marginTop:'25px'}},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{fontSize:'16px',fontWeight:"410"}},"Position After Sale: "," "," ",(e.customPurchase/100*(e.purchaseFrom.ownership*1-e.purchaseFrom.minusInheritance/100*e.purchaseFrom.ownership*1)+e.ownerRef.ownership*1).toFixed(2),"%")),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:12,style:{margin:'0px',padding:"0px"}},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement("hr",{style:{height:"1px",backgroundColor:"gray",borderColor:"gray"}})))),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["r" /* ExpansionPanelDetails */],{onClick:function onClick(event){event.stopPropagation();}},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{container:true,spacing:24},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:4,sm:4,md:4,style:{margin:'0px',padding:"0px"}},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(CustomFieldN,{name:'businessOwners.saleOnDeath.customPurchase-'+ownerI+"-"+i,suffix:"%",component:__WEBPACK_IMPORTED_MODULE_10_components_Wrappers_materialUIWrappers_components_NumberInput__["a" /* default */],checkValidation:_this3.props.checkValidation,label:'Bought %',isrequired:true//validate={[required]}
,onChange:function onChange(e,f,g,h){_this3.props.changePersonal(f,h);}})),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:12,style:{marginTop:'25px'}},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Q" /* Table */],{className:"customTable1"},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["T" /* TableHead */],{className:"fixedHead"},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null)),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["R" /* TableBody */],null))))));}}))));}))));}}]);return BuySell;}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (BuySell);

/***/ }),
/* 2611 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2612 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DefaultInit; });
var DefaultInit={//Remember that this only initializes the field values and not the object value. The object values still needs to be initialized in FNA wizzard.
//This should be changed in further updates to simplify the process should a default value change.
marginalTax:45,execFee:3.5,execTax:true,spouseAccrual:true};

/***/ }),
/* 2613 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return businessOwner; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Purchaser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Heir; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return KeyPerson; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return Surety; });
function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var businessOwner=function businessOwner(){_classCallCheck(this,businessOwner);this.isOwner=true;this.type="company";this.name="";this.id="";this.ownership=0.00;this.loan=0.00;this.insuredName="";this.insuredId="";this.tax=true;this.taxAmount=20;this.deathExisting=0.00;this.disabilityExisting=0.00;this.deathNeeded=0.00;this.disabilityNeeded=0.00;this.minusInheritance=0.00;this.saleOnDeath=[];};var Purchaser=function Purchaser(){_classCallCheck(this,Purchaser);this.ownerRef=null;this.purchaseFrom=null;this.standardPurchase=0.00;this.customPurchase=0.00;this.policyNeeded=true;};var Heir=function Heir(){_classCallCheck(this,Heir);this.name="";this.id="";this.to="";this.inherit=0.00;this.perantOwnership=0.00;};var KeyPerson=function KeyPerson(){_classCallCheck(this,KeyPerson);this.name="";this.id="";};var Surety=function Surety(){_classCallCheck(this,Surety);this.name="";this.id="";};

/***/ }),
/* 2614 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_Grid_GridItem_jsx__ = __webpack_require__(12);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var chatCard=function(_React$Component){_inherits(chatCard,_React$Component);function chatCard(){_classCallCheck(this,chatCard);return _possibleConstructorReturn(this,(chatCard.__proto__||Object.getPrototypeOf(chatCard)).apply(this,arguments));}_createClass(chatCard,[{key:"componentDidMount",value:function componentDidMount(){this.props.updatePs();}},{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:10,md:6,style:this.props.ownMessage?{float:"right",marginBottom:"25px",width:"100%"}:{marginBottom:"25px",width:"100%"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["e" /* Card */],{style:this.props.ownMessage?{backgroundColor:"#EDEBF5"}:{backgroundColor:"#EBEAEE"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["f" /* CardContent */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:{display:"flex",paddingBottom:"15px",borderBottom:"1px solid #bbbbbb80",position:"relative"}},this.props.addTodo?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["x" /* IconButton */],{style:{position:"absolute",right:"-25px",top:"-25px"},onClick:this.props.addTodo},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["w" /* Icon */],{fontSize:"small"},"playlist_add"))):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{className:"avatarImg",src:this.props.avatarPath,alt:"...",style:{width:"30px",height:"30px",margin:"0px",marginRight:"15px"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["Z" /* Typography */],{variant:"body2"},this.props.name),this.props.date?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["Z" /* Typography */],{variant:"caption",style:{position:"absolute",right:"0px",bottom:"5px"}},this.props.date):null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:{marginTop:"10px"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["Z" /* Typography */],{variant:"body1"},this.props.text)))));}}]);return chatCard;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (chatCard);

/***/ }),
/* 2615 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SetClientMessageRead; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_graphql_tag__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_graphql_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_graphql_tag__);
var _templateObject=_taggedTemplateLiteral(["\n  mutation setClientMessageRead($input: SetClientMessageReadInput!) {\n    SetClientMessageRead(input: $input) {\n      clientMutationId\n    }\n  }\n"],["\n  mutation setClientMessageRead($input: SetClientMessageReadInput!) {\n    SetClientMessageRead(input: $input) {\n      clientMutationId\n    }\n  }\n"]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var SetClientMessageRead=__WEBPACK_IMPORTED_MODULE_0_graphql_tag___default()(_templateObject);

/***/ }),
/* 2616 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export subscribeToTimer */
/* harmony export (immutable) */ __webpack_exports__["d"] = subscribeToClientMessaging;
/* harmony export (immutable) */ __webpack_exports__["c"] = sendClientMessage;
/* harmony export (immutable) */ __webpack_exports__["b"] = listenToClientMessages;
/* harmony export (immutable) */ __webpack_exports__["a"] = RemoveMessageListeners;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_socket_io_client__ = __webpack_require__(2617);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_socket_io_client___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_socket_io_client__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_constants_js__ = __webpack_require__(48);
var socket=__WEBPACK_IMPORTED_MODULE_0_socket_io_client___default()(__WEBPACK_IMPORTED_MODULE_1_constants_js__["e" /* messagePath */],{path:"/message/",// or "/message/" if your server expects trailing slash
transports:["websocket"]// optional but enforces WebSocket-only
});function subscribeToTimer(cb){socket.on("timer",function(timestamp){return cb(null,timestamp);});socket.emit("subscribeToTimer",1000);}function subscribeToClientMessaging(brokerId,clientId,token){socket.on("JOINED",function(data){socket.emit("subscribe/client_messaging/"+brokerId+"+"+clientId);});socket.emit("subscribe/client_messaging",{brokerId:brokerId,clientId:clientId,token:token});}function sendClientMessage(message,senderId,comboRoute){socket.emit(comboRoute+"/message",message,senderId);}function listenToClientMessages(comboRoute,callBack){socket.on(comboRoute+"/message",function(data){callBack(data);});}function RemoveMessageListeners(comboRoute){socket.removeAllListeners(""+comboRoute);socket.removeAllListeners(comboRoute+"/message");socket.removeAllListeners("JOINED");socket.emit("removeMessageListeners",comboRoute);}

/***/ }),
/* 2617 */
/***/ (function(module, exports, __webpack_require__) {


/**
 * Module dependencies.
 */

var url = __webpack_require__(2618);
var parser = __webpack_require__(414);
var Manager = __webpack_require__(696);
var debug = __webpack_require__(88)('socket.io-client');

/**
 * Module exports.
 */

module.exports = exports = lookup;

/**
 * Managers cache.
 */

var cache = exports.managers = {};

/**
 * Looks up an existing `Manager` for multiplexing.
 * If the user summons:
 *
 *   `io('http://localhost/a');`
 *   `io('http://localhost/b');`
 *
 * We reuse the existing instance based on same scheme/port/host,
 * and we initialize sockets for each namespace.
 *
 * @api public
 */

function lookup (uri, opts) {
  if (typeof uri === 'object') {
    opts = uri;
    uri = undefined;
  }

  opts = opts || {};

  var parsed = url(uri);
  var source = parsed.source;
  var id = parsed.id;
  var path = parsed.path;
  var sameNamespace = cache[id] && path in cache[id].nsps;
  var newConnection = opts.forceNew || opts['force new connection'] ||
                      false === opts.multiplex || sameNamespace;

  var io;

  if (newConnection) {
    debug('ignoring socket cache for %s', source);
    io = Manager(source, opts);
  } else {
    if (!cache[id]) {
      debug('new io instance for %s', source);
      cache[id] = Manager(source, opts);
    }
    io = cache[id];
  }
  if (parsed.query && !opts.query) {
    opts.query = parsed.query;
  }
  return io.socket(parsed.path, opts);
}

/**
 * Protocol version.
 *
 * @api public
 */

exports.protocol = parser.protocol;

/**
 * `connect`.
 *
 * @param {String} uri
 * @api public
 */

exports.connect = lookup;

/**
 * Expose constructors for standalone build.
 *
 * @api public
 */

exports.Manager = __webpack_require__(696);
exports.Socket = __webpack_require__(702);


/***/ }),
/* 2618 */
/***/ (function(module, exports, __webpack_require__) {


/**
 * Module dependencies.
 */

var parseuri = __webpack_require__(692);
var debug = __webpack_require__(88)('socket.io-client:url');

/**
 * Module exports.
 */

module.exports = url;

/**
 * URL parser.
 *
 * @param {String} url
 * @param {Object} An object meant to mimic window.location.
 *                 Defaults to window.location.
 * @api public
 */

function url (uri, loc) {
  var obj = uri;

  // default to window.location
  loc = loc || (typeof location !== 'undefined' && location);
  if (null == uri) uri = loc.protocol + '//' + loc.host;

  // relative path support
  if ('string' === typeof uri) {
    if ('/' === uri.charAt(0)) {
      if ('/' === uri.charAt(1)) {
        uri = loc.protocol + uri;
      } else {
        uri = loc.host + uri;
      }
    }

    if (!/^(https?|wss?):\/\//.test(uri)) {
      debug('protocol-less url %s', uri);
      if ('undefined' !== typeof loc) {
        uri = loc.protocol + '//' + uri;
      } else {
        uri = 'https://' + uri;
      }
    }

    // parse
    debug('parse %s', uri);
    obj = parseuri(uri);
  }

  // make sure we treat `localhost:80` and `localhost` equally
  if (!obj.port) {
    if (/^(http|ws)$/.test(obj.protocol)) {
      obj.port = '80';
    } else if (/^(http|ws)s$/.test(obj.protocol)) {
      obj.port = '443';
    }
  }

  obj.path = obj.path || '/';

  var ipv6 = obj.host.indexOf(':') !== -1;
  var host = ipv6 ? '[' + obj.host + ']' : obj.host;

  // define unique id
  obj.id = obj.protocol + '://' + host + ':' + obj.port;
  // define href
  obj.href = obj.protocol + '://' + host + (loc && loc.port === obj.port ? '' : (':' + obj.port));

  return obj;
}


/***/ }),
/* 2619 */
/***/ (function(module, exports, __webpack_require__) {


/**
 * This is the common logic for both the Node.js and web browser
 * implementations of `debug()`.
 *
 * Expose `debug()` as the module.
 */

exports = module.exports = createDebug.debug = createDebug['default'] = createDebug;
exports.coerce = coerce;
exports.disable = disable;
exports.enable = enable;
exports.enabled = enabled;
exports.humanize = __webpack_require__(2620);

/**
 * Active `debug` instances.
 */
exports.instances = [];

/**
 * The currently active debug mode names, and names to skip.
 */

exports.names = [];
exports.skips = [];

/**
 * Map of special "%n" handling functions, for the debug "format" argument.
 *
 * Valid key names are a single, lower or upper-case letter, i.e. "n" and "N".
 */

exports.formatters = {};

/**
 * Select a color.
 * @param {String} namespace
 * @return {Number}
 * @api private
 */

function selectColor(namespace) {
  var hash = 0, i;

  for (i in namespace) {
    hash  = ((hash << 5) - hash) + namespace.charCodeAt(i);
    hash |= 0; // Convert to 32bit integer
  }

  return exports.colors[Math.abs(hash) % exports.colors.length];
}

/**
 * Create a debugger with the given `namespace`.
 *
 * @param {String} namespace
 * @return {Function}
 * @api public
 */

function createDebug(namespace) {

  var prevTime;

  function debug() {
    // disabled?
    if (!debug.enabled) return;

    var self = debug;

    // set `diff` timestamp
    var curr = +new Date();
    var ms = curr - (prevTime || curr);
    self.diff = ms;
    self.prev = prevTime;
    self.curr = curr;
    prevTime = curr;

    // turn the `arguments` into a proper Array
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }

    args[0] = exports.coerce(args[0]);

    if ('string' !== typeof args[0]) {
      // anything else let's inspect with %O
      args.unshift('%O');
    }

    // apply any `formatters` transformations
    var index = 0;
    args[0] = args[0].replace(/%([a-zA-Z%])/g, function(match, format) {
      // if we encounter an escaped % then don't increase the array index
      if (match === '%%') return match;
      index++;
      var formatter = exports.formatters[format];
      if ('function' === typeof formatter) {
        var val = args[index];
        match = formatter.call(self, val);

        // now we need to remove `args[index]` since it's inlined in the `format`
        args.splice(index, 1);
        index--;
      }
      return match;
    });

    // apply env-specific formatting (colors, etc.)
    exports.formatArgs.call(self, args);

    var logFn = debug.log || exports.log || console.log.bind(console);
    logFn.apply(self, args);
  }

  debug.namespace = namespace;
  debug.enabled = exports.enabled(namespace);
  debug.useColors = exports.useColors();
  debug.color = selectColor(namespace);
  debug.destroy = destroy;

  // env-specific initialization logic for debug instances
  if ('function' === typeof exports.init) {
    exports.init(debug);
  }

  exports.instances.push(debug);

  return debug;
}

function destroy () {
  var index = exports.instances.indexOf(this);
  if (index !== -1) {
    exports.instances.splice(index, 1);
    return true;
  } else {
    return false;
  }
}

/**
 * Enables a debug mode by namespaces. This can include modes
 * separated by a colon and wildcards.
 *
 * @param {String} namespaces
 * @api public
 */

function enable(namespaces) {
  exports.save(namespaces);

  exports.names = [];
  exports.skips = [];

  var i;
  var split = (typeof namespaces === 'string' ? namespaces : '').split(/[\s,]+/);
  var len = split.length;

  for (i = 0; i < len; i++) {
    if (!split[i]) continue; // ignore empty strings
    namespaces = split[i].replace(/\*/g, '.*?');
    if (namespaces[0] === '-') {
      exports.skips.push(new RegExp('^' + namespaces.substr(1) + '$'));
    } else {
      exports.names.push(new RegExp('^' + namespaces + '$'));
    }
  }

  for (i = 0; i < exports.instances.length; i++) {
    var instance = exports.instances[i];
    instance.enabled = exports.enabled(instance.namespace);
  }
}

/**
 * Disable debug output.
 *
 * @api public
 */

function disable() {
  exports.enable('');
}

/**
 * Returns true if the given mode name is enabled, false otherwise.
 *
 * @param {String} name
 * @return {Boolean}
 * @api public
 */

function enabled(name) {
  if (name[name.length - 1] === '*') {
    return true;
  }
  var i, len;
  for (i = 0, len = exports.skips.length; i < len; i++) {
    if (exports.skips[i].test(name)) {
      return false;
    }
  }
  for (i = 0, len = exports.names.length; i < len; i++) {
    if (exports.names[i].test(name)) {
      return true;
    }
  }
  return false;
}

/**
 * Coerce `val`.
 *
 * @param {Mixed} val
 * @return {Mixed}
 * @api private
 */

function coerce(val) {
  if (val instanceof Error) return val.stack || val.message;
  return val;
}


/***/ }),
/* 2620 */
/***/ (function(module, exports) {

/**
 * Helpers.
 */

var s = 1000;
var m = s * 60;
var h = m * 60;
var d = h * 24;
var y = d * 365.25;

/**
 * Parse or format the given `val`.
 *
 * Options:
 *
 *  - `long` verbose formatting [false]
 *
 * @param {String|Number} val
 * @param {Object} [options]
 * @throws {Error} throw an error if val is not a non-empty string or a number
 * @return {String|Number}
 * @api public
 */

module.exports = function(val, options) {
  options = options || {};
  var type = typeof val;
  if (type === 'string' && val.length > 0) {
    return parse(val);
  } else if (type === 'number' && isNaN(val) === false) {
    return options.long ? fmtLong(val) : fmtShort(val);
  }
  throw new Error(
    'val is not a non-empty string or a valid number. val=' +
      JSON.stringify(val)
  );
};

/**
 * Parse the given `str` and return milliseconds.
 *
 * @param {String} str
 * @return {Number}
 * @api private
 */

function parse(str) {
  str = String(str);
  if (str.length > 100) {
    return;
  }
  var match = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(
    str
  );
  if (!match) {
    return;
  }
  var n = parseFloat(match[1]);
  var type = (match[2] || 'ms').toLowerCase();
  switch (type) {
    case 'years':
    case 'year':
    case 'yrs':
    case 'yr':
    case 'y':
      return n * y;
    case 'days':
    case 'day':
    case 'd':
      return n * d;
    case 'hours':
    case 'hour':
    case 'hrs':
    case 'hr':
    case 'h':
      return n * h;
    case 'minutes':
    case 'minute':
    case 'mins':
    case 'min':
    case 'm':
      return n * m;
    case 'seconds':
    case 'second':
    case 'secs':
    case 'sec':
    case 's':
      return n * s;
    case 'milliseconds':
    case 'millisecond':
    case 'msecs':
    case 'msec':
    case 'ms':
      return n;
    default:
      return undefined;
  }
}

/**
 * Short format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function fmtShort(ms) {
  if (ms >= d) {
    return Math.round(ms / d) + 'd';
  }
  if (ms >= h) {
    return Math.round(ms / h) + 'h';
  }
  if (ms >= m) {
    return Math.round(ms / m) + 'm';
  }
  if (ms >= s) {
    return Math.round(ms / s) + 's';
  }
  return ms + 'ms';
}

/**
 * Long format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function fmtLong(ms) {
  return plural(ms, d, 'day') ||
    plural(ms, h, 'hour') ||
    plural(ms, m, 'minute') ||
    plural(ms, s, 'second') ||
    ms + ' ms';
}

/**
 * Pluralization helper.
 */

function plural(ms, n, name) {
  if (ms < n) {
    return;
  }
  if (ms < n * 1.5) {
    return Math.floor(ms / n) + ' ' + name;
  }
  return Math.ceil(ms / n) + ' ' + name + 's';
}


/***/ }),
/* 2621 */
/***/ (function(module, exports, __webpack_require__) {

/*global Blob,File*/

/**
 * Module requirements
 */

var isArray = __webpack_require__(693);
var isBuf = __webpack_require__(694);
var toString = Object.prototype.toString;
var withNativeBlob = typeof Blob === 'function' || (typeof Blob !== 'undefined' && toString.call(Blob) === '[object BlobConstructor]');
var withNativeFile = typeof File === 'function' || (typeof File !== 'undefined' && toString.call(File) === '[object FileConstructor]');

/**
 * Replaces every Buffer | ArrayBuffer in packet with a numbered placeholder.
 * Anything with blobs or files should be fed through removeBlobs before coming
 * here.
 *
 * @param {Object} packet - socket.io event packet
 * @return {Object} with deconstructed packet and list of buffers
 * @api public
 */

exports.deconstructPacket = function(packet) {
  var buffers = [];
  var packetData = packet.data;
  var pack = packet;
  pack.data = _deconstructPacket(packetData, buffers);
  pack.attachments = buffers.length; // number of binary 'attachments'
  return {packet: pack, buffers: buffers};
};

function _deconstructPacket(data, buffers) {
  if (!data) return data;

  if (isBuf(data)) {
    var placeholder = { _placeholder: true, num: buffers.length };
    buffers.push(data);
    return placeholder;
  } else if (isArray(data)) {
    var newData = new Array(data.length);
    for (var i = 0; i < data.length; i++) {
      newData[i] = _deconstructPacket(data[i], buffers);
    }
    return newData;
  } else if (typeof data === 'object' && !(data instanceof Date)) {
    var newData = {};
    for (var key in data) {
      newData[key] = _deconstructPacket(data[key], buffers);
    }
    return newData;
  }
  return data;
}

/**
 * Reconstructs a binary packet from its placeholder packet and buffers
 *
 * @param {Object} packet - event packet with placeholders
 * @param {Array} buffers - binary buffers to put in placeholder positions
 * @return {Object} reconstructed packet
 * @api public
 */

exports.reconstructPacket = function(packet, buffers) {
  packet.data = _reconstructPacket(packet.data, buffers);
  packet.attachments = undefined; // no longer useful
  return packet;
};

function _reconstructPacket(data, buffers) {
  if (!data) return data;

  if (data && data._placeholder) {
    return buffers[data.num]; // appropriate buffer (should be natural order anyway)
  } else if (isArray(data)) {
    for (var i = 0; i < data.length; i++) {
      data[i] = _reconstructPacket(data[i], buffers);
    }
  } else if (typeof data === 'object') {
    for (var key in data) {
      data[key] = _reconstructPacket(data[key], buffers);
    }
  }

  return data;
}

/**
 * Asynchronously removes Blobs or Files from data via
 * FileReader's readAsArrayBuffer method. Used before encoding
 * data as msgpack. Calls callback with the blobless data.
 *
 * @param {Object} data
 * @param {Function} callback
 * @api private
 */

exports.removeBlobs = function(data, callback) {
  function _removeBlobs(obj, curKey, containingObject) {
    if (!obj) return obj;

    // convert any blob
    if ((withNativeBlob && obj instanceof Blob) ||
        (withNativeFile && obj instanceof File)) {
      pendingBlobs++;

      // async filereader
      var fileReader = new FileReader();
      fileReader.onload = function() { // this.result == arraybuffer
        if (containingObject) {
          containingObject[curKey] = this.result;
        }
        else {
          bloblessData = this.result;
        }

        // if nothing pending its callback time
        if(! --pendingBlobs) {
          callback(bloblessData);
        }
      };

      fileReader.readAsArrayBuffer(obj); // blob -> arraybuffer
    } else if (isArray(obj)) { // handle array
      for (var i = 0; i < obj.length; i++) {
        _removeBlobs(obj[i], i, obj);
      }
    } else if (typeof obj === 'object' && !isBuf(obj)) { // and object
      for (var key in obj) {
        _removeBlobs(obj[key], key, obj);
      }
    }
  }

  var pendingBlobs = 0;
  var bloblessData = data;
  _removeBlobs(bloblessData);
  if (!pendingBlobs) {
    callback(bloblessData);
  }
};


/***/ }),
/* 2622 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.byteLength = byteLength
exports.toByteArray = toByteArray
exports.fromByteArray = fromByteArray

var lookup = []
var revLookup = []
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array

var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i]
  revLookup[code.charCodeAt(i)] = i
}

// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup['-'.charCodeAt(0)] = 62
revLookup['_'.charCodeAt(0)] = 63

function getLens (b64) {
  var len = b64.length

  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4')
  }

  // Trim off extra bytes after placeholder bytes are found
  // See: https://github.com/beatgammit/base64-js/issues/42
  var validLen = b64.indexOf('=')
  if (validLen === -1) validLen = len

  var placeHoldersLen = validLen === len
    ? 0
    : 4 - (validLen % 4)

  return [validLen, placeHoldersLen]
}

// base64 is 4/3 + up to two characters of the original data
function byteLength (b64) {
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function _byteLength (b64, validLen, placeHoldersLen) {
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function toByteArray (b64) {
  var tmp
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]

  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))

  var curByte = 0

  // if there are placeholders, only get up to the last complete 4 chars
  var len = placeHoldersLen > 0
    ? validLen - 4
    : validLen

  for (var i = 0; i < len; i += 4) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 18) |
      (revLookup[b64.charCodeAt(i + 1)] << 12) |
      (revLookup[b64.charCodeAt(i + 2)] << 6) |
      revLookup[b64.charCodeAt(i + 3)]
    arr[curByte++] = (tmp >> 16) & 0xFF
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 2) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 2) |
      (revLookup[b64.charCodeAt(i + 1)] >> 4)
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 1) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 10) |
      (revLookup[b64.charCodeAt(i + 1)] << 4) |
      (revLookup[b64.charCodeAt(i + 2)] >> 2)
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  return arr
}

function tripletToBase64 (num) {
  return lookup[num >> 18 & 0x3F] +
    lookup[num >> 12 & 0x3F] +
    lookup[num >> 6 & 0x3F] +
    lookup[num & 0x3F]
}

function encodeChunk (uint8, start, end) {
  var tmp
  var output = []
  for (var i = start; i < end; i += 3) {
    tmp =
      ((uint8[i] << 16) & 0xFF0000) +
      ((uint8[i + 1] << 8) & 0xFF00) +
      (uint8[i + 2] & 0xFF)
    output.push(tripletToBase64(tmp))
  }
  return output.join('')
}

function fromByteArray (uint8) {
  var tmp
  var len = uint8.length
  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
  var parts = []
  var maxChunkLength = 16383 // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(
      uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)
    ))
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1]
    parts.push(
      lookup[tmp >> 2] +
      lookup[(tmp << 4) & 0x3F] +
      '=='
    )
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
    parts.push(
      lookup[tmp >> 10] +
      lookup[(tmp >> 4) & 0x3F] +
      lookup[(tmp << 2) & 0x3F] +
      '='
    )
  }

  return parts.join('')
}


/***/ }),
/* 2623 */
/***/ (function(module, exports) {

exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var nBits = -7
  var i = isLE ? (nBytes - 1) : 0
  var d = isLE ? -1 : 1
  var s = buffer[offset + i]

  i += d

  e = s & ((1 << (-nBits)) - 1)
  s >>= (-nBits)
  nBits += eLen
  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1)
  e >>= (-nBits)
  nBits += mLen
  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen)
    e = e - eBias
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
  var i = isLE ? 0 : (nBytes - 1)
  var d = isLE ? 1 : -1
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

  value = Math.abs(value)

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0
    e = eMax
  } else {
    e = Math.floor(Math.log(value) / Math.LN2)
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--
      c *= 2
    }
    if (e + eBias >= 1) {
      value += rt / c
    } else {
      value += rt * Math.pow(2, 1 - eBias)
    }
    if (value * c >= 2) {
      e++
      c /= 2
    }

    if (e + eBias >= eMax) {
      m = 0
      e = eMax
    } else if (e + eBias >= 1) {
      m = ((value * c) - 1) * Math.pow(2, mLen)
      e = e + eBias
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
      e = 0
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m
  eLen += mLen
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128
}


/***/ }),
/* 2624 */
/***/ (function(module, exports, __webpack_require__) {


module.exports = __webpack_require__(2625);

/**
 * Exports parser
 *
 * @api public
 *
 */
module.exports.parser = __webpack_require__(153);


/***/ }),
/* 2625 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Module dependencies.
 */

var transports = __webpack_require__(697);
var Emitter = __webpack_require__(152);
var debug = __webpack_require__(88)('engine.io-client:socket');
var index = __webpack_require__(701);
var parser = __webpack_require__(153);
var parseuri = __webpack_require__(692);
var parseqs = __webpack_require__(284);

/**
 * Module exports.
 */

module.exports = Socket;

/**
 * Socket constructor.
 *
 * @param {String|Object} uri or options
 * @param {Object} options
 * @api public
 */

function Socket (uri, opts) {
  if (!(this instanceof Socket)) return new Socket(uri, opts);

  opts = opts || {};

  if (uri && 'object' === typeof uri) {
    opts = uri;
    uri = null;
  }

  if (uri) {
    uri = parseuri(uri);
    opts.hostname = uri.host;
    opts.secure = uri.protocol === 'https' || uri.protocol === 'wss';
    opts.port = uri.port;
    if (uri.query) opts.query = uri.query;
  } else if (opts.host) {
    opts.hostname = parseuri(opts.host).host;
  }

  this.secure = null != opts.secure ? opts.secure
    : (typeof location !== 'undefined' && 'https:' === location.protocol);

  if (opts.hostname && !opts.port) {
    // if no port is specified manually, use the protocol default
    opts.port = this.secure ? '443' : '80';
  }

  this.agent = opts.agent || false;
  this.hostname = opts.hostname ||
    (typeof location !== 'undefined' ? location.hostname : 'localhost');
  this.port = opts.port || (typeof location !== 'undefined' && location.port
      ? location.port
      : (this.secure ? 443 : 80));
  this.query = opts.query || {};
  if ('string' === typeof this.query) this.query = parseqs.decode(this.query);
  this.upgrade = false !== opts.upgrade;
  this.path = (opts.path || '/engine.io').replace(/\/$/, '') + '/';
  this.forceJSONP = !!opts.forceJSONP;
  this.jsonp = false !== opts.jsonp;
  this.forceBase64 = !!opts.forceBase64;
  this.enablesXDR = !!opts.enablesXDR;
  this.timestampParam = opts.timestampParam || 't';
  this.timestampRequests = opts.timestampRequests;
  this.transports = opts.transports || ['polling', 'websocket'];
  this.transportOptions = opts.transportOptions || {};
  this.readyState = '';
  this.writeBuffer = [];
  this.prevBufferLen = 0;
  this.policyPort = opts.policyPort || 843;
  this.rememberUpgrade = opts.rememberUpgrade || false;
  this.binaryType = null;
  this.onlyBinaryUpgrades = opts.onlyBinaryUpgrades;
  this.perMessageDeflate = false !== opts.perMessageDeflate ? (opts.perMessageDeflate || {}) : false;

  if (true === this.perMessageDeflate) this.perMessageDeflate = {};
  if (this.perMessageDeflate && null == this.perMessageDeflate.threshold) {
    this.perMessageDeflate.threshold = 1024;
  }

  // SSL options for Node.js client
  this.pfx = opts.pfx || null;
  this.key = opts.key || null;
  this.passphrase = opts.passphrase || null;
  this.cert = opts.cert || null;
  this.ca = opts.ca || null;
  this.ciphers = opts.ciphers || null;
  this.rejectUnauthorized = opts.rejectUnauthorized === undefined ? true : opts.rejectUnauthorized;
  this.forceNode = !!opts.forceNode;

  // detect ReactNative environment
  this.isReactNative = (typeof navigator !== 'undefined' && typeof navigator.product === 'string' && navigator.product.toLowerCase() === 'reactnative');

  // other options for Node.js or ReactNative client
  if (typeof self === 'undefined' || this.isReactNative) {
    if (opts.extraHeaders && Object.keys(opts.extraHeaders).length > 0) {
      this.extraHeaders = opts.extraHeaders;
    }

    if (opts.localAddress) {
      this.localAddress = opts.localAddress;
    }
  }

  // set on handshake
  this.id = null;
  this.upgrades = null;
  this.pingInterval = null;
  this.pingTimeout = null;

  // set on heartbeat
  this.pingIntervalTimer = null;
  this.pingTimeoutTimer = null;

  this.open();
}

Socket.priorWebsocketSuccess = false;

/**
 * Mix in `Emitter`.
 */

Emitter(Socket.prototype);

/**
 * Protocol version.
 *
 * @api public
 */

Socket.protocol = parser.protocol; // this is an int

/**
 * Expose deps for legacy compatibility
 * and standalone browser access.
 */

Socket.Socket = Socket;
Socket.Transport = __webpack_require__(416);
Socket.transports = __webpack_require__(697);
Socket.parser = __webpack_require__(153);

/**
 * Creates transport of the given type.
 *
 * @param {String} transport name
 * @return {Transport}
 * @api private
 */

Socket.prototype.createTransport = function (name) {
  debug('creating transport "%s"', name);
  var query = clone(this.query);

  // append engine.io protocol identifier
  query.EIO = parser.protocol;

  // transport name
  query.transport = name;

  // per-transport options
  var options = this.transportOptions[name] || {};

  // session id if we already have one
  if (this.id) query.sid = this.id;

  var transport = new transports[name]({
    query: query,
    socket: this,
    agent: options.agent || this.agent,
    hostname: options.hostname || this.hostname,
    port: options.port || this.port,
    secure: options.secure || this.secure,
    path: options.path || this.path,
    forceJSONP: options.forceJSONP || this.forceJSONP,
    jsonp: options.jsonp || this.jsonp,
    forceBase64: options.forceBase64 || this.forceBase64,
    enablesXDR: options.enablesXDR || this.enablesXDR,
    timestampRequests: options.timestampRequests || this.timestampRequests,
    timestampParam: options.timestampParam || this.timestampParam,
    policyPort: options.policyPort || this.policyPort,
    pfx: options.pfx || this.pfx,
    key: options.key || this.key,
    passphrase: options.passphrase || this.passphrase,
    cert: options.cert || this.cert,
    ca: options.ca || this.ca,
    ciphers: options.ciphers || this.ciphers,
    rejectUnauthorized: options.rejectUnauthorized || this.rejectUnauthorized,
    perMessageDeflate: options.perMessageDeflate || this.perMessageDeflate,
    extraHeaders: options.extraHeaders || this.extraHeaders,
    forceNode: options.forceNode || this.forceNode,
    localAddress: options.localAddress || this.localAddress,
    requestTimeout: options.requestTimeout || this.requestTimeout,
    protocols: options.protocols || void (0),
    isReactNative: this.isReactNative
  });

  return transport;
};

function clone (obj) {
  var o = {};
  for (var i in obj) {
    if (obj.hasOwnProperty(i)) {
      o[i] = obj[i];
    }
  }
  return o;
}

/**
 * Initializes transport to use and starts probe.
 *
 * @api private
 */
Socket.prototype.open = function () {
  var transport;
  if (this.rememberUpgrade && Socket.priorWebsocketSuccess && this.transports.indexOf('websocket') !== -1) {
    transport = 'websocket';
  } else if (0 === this.transports.length) {
    // Emit error on next tick so it can be listened to
    var self = this;
    setTimeout(function () {
      self.emit('error', 'No transports available');
    }, 0);
    return;
  } else {
    transport = this.transports[0];
  }
  this.readyState = 'opening';

  // Retry with the next transport if the transport is disabled (jsonp: false)
  try {
    transport = this.createTransport(transport);
  } catch (e) {
    this.transports.shift();
    this.open();
    return;
  }

  transport.open();
  this.setTransport(transport);
};

/**
 * Sets the current transport. Disables the existing one (if any).
 *
 * @api private
 */

Socket.prototype.setTransport = function (transport) {
  debug('setting transport %s', transport.name);
  var self = this;

  if (this.transport) {
    debug('clearing existing transport %s', this.transport.name);
    this.transport.removeAllListeners();
  }

  // set up transport
  this.transport = transport;

  // set up transport listeners
  transport
  .on('drain', function () {
    self.onDrain();
  })
  .on('packet', function (packet) {
    self.onPacket(packet);
  })
  .on('error', function (e) {
    self.onError(e);
  })
  .on('close', function () {
    self.onClose('transport close');
  });
};

/**
 * Probes a transport.
 *
 * @param {String} transport name
 * @api private
 */

Socket.prototype.probe = function (name) {
  debug('probing transport "%s"', name);
  var transport = this.createTransport(name, { probe: 1 });
  var failed = false;
  var self = this;

  Socket.priorWebsocketSuccess = false;

  function onTransportOpen () {
    if (self.onlyBinaryUpgrades) {
      var upgradeLosesBinary = !this.supportsBinary && self.transport.supportsBinary;
      failed = failed || upgradeLosesBinary;
    }
    if (failed) return;

    debug('probe transport "%s" opened', name);
    transport.send([{ type: 'ping', data: 'probe' }]);
    transport.once('packet', function (msg) {
      if (failed) return;
      if ('pong' === msg.type && 'probe' === msg.data) {
        debug('probe transport "%s" pong', name);
        self.upgrading = true;
        self.emit('upgrading', transport);
        if (!transport) return;
        Socket.priorWebsocketSuccess = 'websocket' === transport.name;

        debug('pausing current transport "%s"', self.transport.name);
        self.transport.pause(function () {
          if (failed) return;
          if ('closed' === self.readyState) return;
          debug('changing transport and sending upgrade packet');

          cleanup();

          self.setTransport(transport);
          transport.send([{ type: 'upgrade' }]);
          self.emit('upgrade', transport);
          transport = null;
          self.upgrading = false;
          self.flush();
        });
      } else {
        debug('probe transport "%s" failed', name);
        var err = new Error('probe error');
        err.transport = transport.name;
        self.emit('upgradeError', err);
      }
    });
  }

  function freezeTransport () {
    if (failed) return;

    // Any callback called by transport should be ignored since now
    failed = true;

    cleanup();

    transport.close();
    transport = null;
  }

  // Handle any error that happens while probing
  function onerror (err) {
    var error = new Error('probe error: ' + err);
    error.transport = transport.name;

    freezeTransport();

    debug('probe transport "%s" failed because of error: %s', name, err);

    self.emit('upgradeError', error);
  }

  function onTransportClose () {
    onerror('transport closed');
  }

  // When the socket is closed while we're probing
  function onclose () {
    onerror('socket closed');
  }

  // When the socket is upgraded while we're probing
  function onupgrade (to) {
    if (transport && to.name !== transport.name) {
      debug('"%s" works - aborting "%s"', to.name, transport.name);
      freezeTransport();
    }
  }

  // Remove all listeners on the transport and on self
  function cleanup () {
    transport.removeListener('open', onTransportOpen);
    transport.removeListener('error', onerror);
    transport.removeListener('close', onTransportClose);
    self.removeListener('close', onclose);
    self.removeListener('upgrading', onupgrade);
  }

  transport.once('open', onTransportOpen);
  transport.once('error', onerror);
  transport.once('close', onTransportClose);

  this.once('close', onclose);
  this.once('upgrading', onupgrade);

  transport.open();
};

/**
 * Called when connection is deemed open.
 *
 * @api public
 */

Socket.prototype.onOpen = function () {
  debug('socket open');
  this.readyState = 'open';
  Socket.priorWebsocketSuccess = 'websocket' === this.transport.name;
  this.emit('open');
  this.flush();

  // we check for `readyState` in case an `open`
  // listener already closed the socket
  if ('open' === this.readyState && this.upgrade && this.transport.pause) {
    debug('starting upgrade probes');
    for (var i = 0, l = this.upgrades.length; i < l; i++) {
      this.probe(this.upgrades[i]);
    }
  }
};

/**
 * Handles a packet.
 *
 * @api private
 */

Socket.prototype.onPacket = function (packet) {
  if ('opening' === this.readyState || 'open' === this.readyState ||
      'closing' === this.readyState) {
    debug('socket receive: type "%s", data "%s"', packet.type, packet.data);

    this.emit('packet', packet);

    // Socket is live - any packet counts
    this.emit('heartbeat');

    switch (packet.type) {
      case 'open':
        this.onHandshake(JSON.parse(packet.data));
        break;

      case 'pong':
        this.setPing();
        this.emit('pong');
        break;

      case 'error':
        var err = new Error('server error');
        err.code = packet.data;
        this.onError(err);
        break;

      case 'message':
        this.emit('data', packet.data);
        this.emit('message', packet.data);
        break;
    }
  } else {
    debug('packet received with socket readyState "%s"', this.readyState);
  }
};

/**
 * Called upon handshake completion.
 *
 * @param {Object} handshake obj
 * @api private
 */

Socket.prototype.onHandshake = function (data) {
  this.emit('handshake', data);
  this.id = data.sid;
  this.transport.query.sid = data.sid;
  this.upgrades = this.filterUpgrades(data.upgrades);
  this.pingInterval = data.pingInterval;
  this.pingTimeout = data.pingTimeout;
  this.onOpen();
  // In case open handler closes socket
  if ('closed' === this.readyState) return;
  this.setPing();

  // Prolong liveness of socket on heartbeat
  this.removeListener('heartbeat', this.onHeartbeat);
  this.on('heartbeat', this.onHeartbeat);
};

/**
 * Resets ping timeout.
 *
 * @api private
 */

Socket.prototype.onHeartbeat = function (timeout) {
  clearTimeout(this.pingTimeoutTimer);
  var self = this;
  self.pingTimeoutTimer = setTimeout(function () {
    if ('closed' === self.readyState) return;
    self.onClose('ping timeout');
  }, timeout || (self.pingInterval + self.pingTimeout));
};

/**
 * Pings server every `this.pingInterval` and expects response
 * within `this.pingTimeout` or closes connection.
 *
 * @api private
 */

Socket.prototype.setPing = function () {
  var self = this;
  clearTimeout(self.pingIntervalTimer);
  self.pingIntervalTimer = setTimeout(function () {
    debug('writing ping packet - expecting pong within %sms', self.pingTimeout);
    self.ping();
    self.onHeartbeat(self.pingTimeout);
  }, self.pingInterval);
};

/**
* Sends a ping packet.
*
* @api private
*/

Socket.prototype.ping = function () {
  var self = this;
  this.sendPacket('ping', function () {
    self.emit('ping');
  });
};

/**
 * Called on `drain` event
 *
 * @api private
 */

Socket.prototype.onDrain = function () {
  this.writeBuffer.splice(0, this.prevBufferLen);

  // setting prevBufferLen = 0 is very important
  // for example, when upgrading, upgrade packet is sent over,
  // and a nonzero prevBufferLen could cause problems on `drain`
  this.prevBufferLen = 0;

  if (0 === this.writeBuffer.length) {
    this.emit('drain');
  } else {
    this.flush();
  }
};

/**
 * Flush write buffers.
 *
 * @api private
 */

Socket.prototype.flush = function () {
  if ('closed' !== this.readyState && this.transport.writable &&
    !this.upgrading && this.writeBuffer.length) {
    debug('flushing %d packets in socket', this.writeBuffer.length);
    this.transport.send(this.writeBuffer);
    // keep track of current length of writeBuffer
    // splice writeBuffer and callbackBuffer on `drain`
    this.prevBufferLen = this.writeBuffer.length;
    this.emit('flush');
  }
};

/**
 * Sends a message.
 *
 * @param {String} message.
 * @param {Function} callback function.
 * @param {Object} options.
 * @return {Socket} for chaining.
 * @api public
 */

Socket.prototype.write =
Socket.prototype.send = function (msg, options, fn) {
  this.sendPacket('message', msg, options, fn);
  return this;
};

/**
 * Sends a packet.
 *
 * @param {String} packet type.
 * @param {String} data.
 * @param {Object} options.
 * @param {Function} callback function.
 * @api private
 */

Socket.prototype.sendPacket = function (type, data, options, fn) {
  if ('function' === typeof data) {
    fn = data;
    data = undefined;
  }

  if ('function' === typeof options) {
    fn = options;
    options = null;
  }

  if ('closing' === this.readyState || 'closed' === this.readyState) {
    return;
  }

  options = options || {};
  options.compress = false !== options.compress;

  var packet = {
    type: type,
    data: data,
    options: options
  };
  this.emit('packetCreate', packet);
  this.writeBuffer.push(packet);
  if (fn) this.once('flush', fn);
  this.flush();
};

/**
 * Closes the connection.
 *
 * @api private
 */

Socket.prototype.close = function () {
  if ('opening' === this.readyState || 'open' === this.readyState) {
    this.readyState = 'closing';

    var self = this;

    if (this.writeBuffer.length) {
      this.once('drain', function () {
        if (this.upgrading) {
          waitForUpgrade();
        } else {
          close();
        }
      });
    } else if (this.upgrading) {
      waitForUpgrade();
    } else {
      close();
    }
  }

  function close () {
    self.onClose('forced close');
    debug('socket closing - telling transport to close');
    self.transport.close();
  }

  function cleanupAndClose () {
    self.removeListener('upgrade', cleanupAndClose);
    self.removeListener('upgradeError', cleanupAndClose);
    close();
  }

  function waitForUpgrade () {
    // wait for upgrade to finish since we can't send packets while pausing a transport
    self.once('upgrade', cleanupAndClose);
    self.once('upgradeError', cleanupAndClose);
  }

  return this;
};

/**
 * Called upon transport error
 *
 * @api private
 */

Socket.prototype.onError = function (err) {
  debug('socket error %j', err);
  Socket.priorWebsocketSuccess = false;
  this.emit('error', err);
  this.onClose('transport error', err);
};

/**
 * Called upon transport close.
 *
 * @api private
 */

Socket.prototype.onClose = function (reason, desc) {
  if ('opening' === this.readyState || 'open' === this.readyState || 'closing' === this.readyState) {
    debug('socket close with reason: "%s"', reason);
    var self = this;

    // clear timers
    clearTimeout(this.pingIntervalTimer);
    clearTimeout(this.pingTimeoutTimer);

    // stop event from firing again for transport
    this.transport.removeAllListeners('close');

    // ensure transport won't stay open
    this.transport.close();

    // ignore further transport communication
    this.transport.removeAllListeners();

    // set ready state
    this.readyState = 'closed';

    // clear session id
    this.id = null;

    // emit close event
    this.emit('close', reason, desc);

    // clean buffers after, so users can still
    // grab the buffers on `close` event
    self.writeBuffer = [];
    self.prevBufferLen = 0;
  }
};

/**
 * Filters upgrades, returning only those matching client transports.
 *
 * @param {Array} server upgrades
 * @api private
 *
 */

Socket.prototype.filterUpgrades = function (upgrades) {
  var filteredUpgrades = [];
  for (var i = 0, j = upgrades.length; i < j; i++) {
    if (~index(this.transports, upgrades[i])) filteredUpgrades.push(upgrades[i]);
  }
  return filteredUpgrades;
};


/***/ }),
/* 2626 */
/***/ (function(module, exports) {


/**
 * Module exports.
 *
 * Logic borrowed from Modernizr:
 *
 *   - https://github.com/Modernizr/Modernizr/blob/master/feature-detects/cors.js
 */

try {
  module.exports = typeof XMLHttpRequest !== 'undefined' &&
    'withCredentials' in new XMLHttpRequest();
} catch (err) {
  // if XMLHttp support is disabled in IE then it will throw
  // when trying to create
  module.exports = false;
}


/***/ }),
/* 2627 */
/***/ (function(module, exports, __webpack_require__) {

/* global attachEvent */

/**
 * Module requirements.
 */

var XMLHttpRequest = __webpack_require__(415);
var Polling = __webpack_require__(698);
var Emitter = __webpack_require__(152);
var inherit = __webpack_require__(285);
var debug = __webpack_require__(88)('engine.io-client:polling-xhr');

/**
 * Module exports.
 */

module.exports = XHR;
module.exports.Request = Request;

/**
 * Empty function
 */

function empty () {}

/**
 * XHR Polling constructor.
 *
 * @param {Object} opts
 * @api public
 */

function XHR (opts) {
  Polling.call(this, opts);
  this.requestTimeout = opts.requestTimeout;
  this.extraHeaders = opts.extraHeaders;

  if (typeof location !== 'undefined') {
    var isSSL = 'https:' === location.protocol;
    var port = location.port;

    // some user agents have empty `location.port`
    if (!port) {
      port = isSSL ? 443 : 80;
    }

    this.xd = (typeof location !== 'undefined' && opts.hostname !== location.hostname) ||
      port !== opts.port;
    this.xs = opts.secure !== isSSL;
  }
}

/**
 * Inherits from Polling.
 */

inherit(XHR, Polling);

/**
 * XHR supports binary
 */

XHR.prototype.supportsBinary = true;

/**
 * Creates a request.
 *
 * @param {String} method
 * @api private
 */

XHR.prototype.request = function (opts) {
  opts = opts || {};
  opts.uri = this.uri();
  opts.xd = this.xd;
  opts.xs = this.xs;
  opts.agent = this.agent || false;
  opts.supportsBinary = this.supportsBinary;
  opts.enablesXDR = this.enablesXDR;

  // SSL options for Node.js client
  opts.pfx = this.pfx;
  opts.key = this.key;
  opts.passphrase = this.passphrase;
  opts.cert = this.cert;
  opts.ca = this.ca;
  opts.ciphers = this.ciphers;
  opts.rejectUnauthorized = this.rejectUnauthorized;
  opts.requestTimeout = this.requestTimeout;

  // other options for Node.js client
  opts.extraHeaders = this.extraHeaders;

  return new Request(opts);
};

/**
 * Sends data.
 *
 * @param {String} data to send.
 * @param {Function} called upon flush.
 * @api private
 */

XHR.prototype.doWrite = function (data, fn) {
  var isBinary = typeof data !== 'string' && data !== undefined;
  var req = this.request({ method: 'POST', data: data, isBinary: isBinary });
  var self = this;
  req.on('success', fn);
  req.on('error', function (err) {
    self.onError('xhr post error', err);
  });
  this.sendXhr = req;
};

/**
 * Starts a poll cycle.
 *
 * @api private
 */

XHR.prototype.doPoll = function () {
  debug('xhr poll');
  var req = this.request();
  var self = this;
  req.on('data', function (data) {
    self.onData(data);
  });
  req.on('error', function (err) {
    self.onError('xhr poll error', err);
  });
  this.pollXhr = req;
};

/**
 * Request constructor
 *
 * @param {Object} options
 * @api public
 */

function Request (opts) {
  this.method = opts.method || 'GET';
  this.uri = opts.uri;
  this.xd = !!opts.xd;
  this.xs = !!opts.xs;
  this.async = false !== opts.async;
  this.data = undefined !== opts.data ? opts.data : null;
  this.agent = opts.agent;
  this.isBinary = opts.isBinary;
  this.supportsBinary = opts.supportsBinary;
  this.enablesXDR = opts.enablesXDR;
  this.requestTimeout = opts.requestTimeout;

  // SSL options for Node.js client
  this.pfx = opts.pfx;
  this.key = opts.key;
  this.passphrase = opts.passphrase;
  this.cert = opts.cert;
  this.ca = opts.ca;
  this.ciphers = opts.ciphers;
  this.rejectUnauthorized = opts.rejectUnauthorized;

  // other options for Node.js client
  this.extraHeaders = opts.extraHeaders;

  this.create();
}

/**
 * Mix in `Emitter`.
 */

Emitter(Request.prototype);

/**
 * Creates the XHR object and sends the request.
 *
 * @api private
 */

Request.prototype.create = function () {
  var opts = { agent: this.agent, xdomain: this.xd, xscheme: this.xs, enablesXDR: this.enablesXDR };

  // SSL options for Node.js client
  opts.pfx = this.pfx;
  opts.key = this.key;
  opts.passphrase = this.passphrase;
  opts.cert = this.cert;
  opts.ca = this.ca;
  opts.ciphers = this.ciphers;
  opts.rejectUnauthorized = this.rejectUnauthorized;

  var xhr = this.xhr = new XMLHttpRequest(opts);
  var self = this;

  try {
    debug('xhr open %s: %s', this.method, this.uri);
    xhr.open(this.method, this.uri, this.async);
    try {
      if (this.extraHeaders) {
        xhr.setDisableHeaderCheck && xhr.setDisableHeaderCheck(true);
        for (var i in this.extraHeaders) {
          if (this.extraHeaders.hasOwnProperty(i)) {
            xhr.setRequestHeader(i, this.extraHeaders[i]);
          }
        }
      }
    } catch (e) {}

    if ('POST' === this.method) {
      try {
        if (this.isBinary) {
          xhr.setRequestHeader('Content-type', 'application/octet-stream');
        } else {
          xhr.setRequestHeader('Content-type', 'text/plain;charset=UTF-8');
        }
      } catch (e) {}
    }

    try {
      xhr.setRequestHeader('Accept', '*/*');
    } catch (e) {}

    // ie6 check
    if ('withCredentials' in xhr) {
      xhr.withCredentials = true;
    }

    if (this.requestTimeout) {
      xhr.timeout = this.requestTimeout;
    }

    if (this.hasXDR()) {
      xhr.onload = function () {
        self.onLoad();
      };
      xhr.onerror = function () {
        self.onError(xhr.responseText);
      };
    } else {
      xhr.onreadystatechange = function () {
        if (xhr.readyState === 2) {
          try {
            var contentType = xhr.getResponseHeader('Content-Type');
            if (self.supportsBinary && contentType === 'application/octet-stream') {
              xhr.responseType = 'arraybuffer';
            }
          } catch (e) {}
        }
        if (4 !== xhr.readyState) return;
        if (200 === xhr.status || 1223 === xhr.status) {
          self.onLoad();
        } else {
          // make sure the `error` event handler that's user-set
          // does not throw in the same tick and gets caught here
          setTimeout(function () {
            self.onError(xhr.status);
          }, 0);
        }
      };
    }

    debug('xhr data %s', this.data);
    xhr.send(this.data);
  } catch (e) {
    // Need to defer since .create() is called directly fhrom the constructor
    // and thus the 'error' event can only be only bound *after* this exception
    // occurs.  Therefore, also, we cannot throw here at all.
    setTimeout(function () {
      self.onError(e);
    }, 0);
    return;
  }

  if (typeof document !== 'undefined') {
    this.index = Request.requestsCount++;
    Request.requests[this.index] = this;
  }
};

/**
 * Called upon successful response.
 *
 * @api private
 */

Request.prototype.onSuccess = function () {
  this.emit('success');
  this.cleanup();
};

/**
 * Called if we have data.
 *
 * @api private
 */

Request.prototype.onData = function (data) {
  this.emit('data', data);
  this.onSuccess();
};

/**
 * Called upon error.
 *
 * @api private
 */

Request.prototype.onError = function (err) {
  this.emit('error', err);
  this.cleanup(true);
};

/**
 * Cleans up house.
 *
 * @api private
 */

Request.prototype.cleanup = function (fromError) {
  if ('undefined' === typeof this.xhr || null === this.xhr) {
    return;
  }
  // xmlhttprequest
  if (this.hasXDR()) {
    this.xhr.onload = this.xhr.onerror = empty;
  } else {
    this.xhr.onreadystatechange = empty;
  }

  if (fromError) {
    try {
      this.xhr.abort();
    } catch (e) {}
  }

  if (typeof document !== 'undefined') {
    delete Request.requests[this.index];
  }

  this.xhr = null;
};

/**
 * Called upon load.
 *
 * @api private
 */

Request.prototype.onLoad = function () {
  var data;
  try {
    var contentType;
    try {
      contentType = this.xhr.getResponseHeader('Content-Type');
    } catch (e) {}
    if (contentType === 'application/octet-stream') {
      data = this.xhr.response || this.xhr.responseText;
    } else {
      data = this.xhr.responseText;
    }
  } catch (e) {
    this.onError(e);
  }
  if (null != data) {
    this.onData(data);
  }
};

/**
 * Check if it has XDomainRequest.
 *
 * @api private
 */

Request.prototype.hasXDR = function () {
  return typeof XDomainRequest !== 'undefined' && !this.xs && this.enablesXDR;
};

/**
 * Aborts the request.
 *
 * @api public
 */

Request.prototype.abort = function () {
  this.cleanup();
};

/**
 * Aborts pending requests when unloading the window. This is needed to prevent
 * memory leaks (e.g. when using IE) and to ensure that no spurious error is
 * emitted.
 */

Request.requestsCount = 0;
Request.requests = {};

if (typeof document !== 'undefined') {
  if (typeof attachEvent === 'function') {
    attachEvent('onunload', unloadHandler);
  } else if (typeof addEventListener === 'function') {
    var terminationEvent = 'onpagehide' in self ? 'pagehide' : 'unload';
    addEventListener(terminationEvent, unloadHandler, false);
  }
}

function unloadHandler () {
  for (var i in Request.requests) {
    if (Request.requests.hasOwnProperty(i)) {
      Request.requests[i].abort();
    }
  }
}


/***/ }),
/* 2628 */
/***/ (function(module, exports) {


/**
 * Gets the keys for an object.
 *
 * @return {Array} keys
 * @api private
 */

module.exports = Object.keys || function keys (obj){
  var arr = [];
  var has = Object.prototype.hasOwnProperty;

  for (var i in obj) {
    if (has.call(obj, i)) {
      arr.push(i);
    }
  }
  return arr;
};


/***/ }),
/* 2629 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};


/***/ }),
/* 2630 */
/***/ (function(module, exports) {

/**
 * An abstraction for slicing an arraybuffer even when
 * ArrayBuffer.prototype.slice is not supported
 *
 * @api public
 */

module.exports = function(arraybuffer, start, end) {
  var bytes = arraybuffer.byteLength;
  start = start || 0;
  end = end || bytes;

  if (arraybuffer.slice) { return arraybuffer.slice(start, end); }

  if (start < 0) { start += bytes; }
  if (end < 0) { end += bytes; }
  if (end > bytes) { end = bytes; }

  if (start >= bytes || start >= end || bytes === 0) {
    return new ArrayBuffer(0);
  }

  var abv = new Uint8Array(arraybuffer);
  var result = new Uint8Array(end - start);
  for (var i = start, ii = 0; i < end; i++, ii++) {
    result[ii] = abv[i];
  }
  return result.buffer;
};


/***/ }),
/* 2631 */
/***/ (function(module, exports) {

module.exports = after

function after(count, callback, err_cb) {
    var bail = false
    err_cb = err_cb || noop
    proxy.count = count

    return (count === 0) ? callback() : proxy

    function proxy(err, result) {
        if (proxy.count <= 0) {
            throw new Error('after called too many times')
        }
        --proxy.count

        // after first error, rest are passed to err_cb
        if (err) {
            bail = true
            callback(err)
            // future error callbacks will go to error handler
            callback = err_cb
        } else if (proxy.count === 0 && !bail) {
            callback(null, result)
        }
    }
}

function noop() {}


/***/ }),
/* 2632 */
/***/ (function(module, exports) {

/*! https://mths.be/utf8js v2.1.2 by @mathias */

var stringFromCharCode = String.fromCharCode;

// Taken from https://mths.be/punycode
function ucs2decode(string) {
	var output = [];
	var counter = 0;
	var length = string.length;
	var value;
	var extra;
	while (counter < length) {
		value = string.charCodeAt(counter++);
		if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
			// high surrogate, and there is a next character
			extra = string.charCodeAt(counter++);
			if ((extra & 0xFC00) == 0xDC00) { // low surrogate
				output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
			} else {
				// unmatched surrogate; only append this code unit, in case the next
				// code unit is the high surrogate of a surrogate pair
				output.push(value);
				counter--;
			}
		} else {
			output.push(value);
		}
	}
	return output;
}

// Taken from https://mths.be/punycode
function ucs2encode(array) {
	var length = array.length;
	var index = -1;
	var value;
	var output = '';
	while (++index < length) {
		value = array[index];
		if (value > 0xFFFF) {
			value -= 0x10000;
			output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
			value = 0xDC00 | value & 0x3FF;
		}
		output += stringFromCharCode(value);
	}
	return output;
}

function checkScalarValue(codePoint, strict) {
	if (codePoint >= 0xD800 && codePoint <= 0xDFFF) {
		if (strict) {
			throw Error(
				'Lone surrogate U+' + codePoint.toString(16).toUpperCase() +
				' is not a scalar value'
			);
		}
		return false;
	}
	return true;
}
/*--------------------------------------------------------------------------*/

function createByte(codePoint, shift) {
	return stringFromCharCode(((codePoint >> shift) & 0x3F) | 0x80);
}

function encodeCodePoint(codePoint, strict) {
	if ((codePoint & 0xFFFFFF80) == 0) { // 1-byte sequence
		return stringFromCharCode(codePoint);
	}
	var symbol = '';
	if ((codePoint & 0xFFFFF800) == 0) { // 2-byte sequence
		symbol = stringFromCharCode(((codePoint >> 6) & 0x1F) | 0xC0);
	}
	else if ((codePoint & 0xFFFF0000) == 0) { // 3-byte sequence
		if (!checkScalarValue(codePoint, strict)) {
			codePoint = 0xFFFD;
		}
		symbol = stringFromCharCode(((codePoint >> 12) & 0x0F) | 0xE0);
		symbol += createByte(codePoint, 6);
	}
	else if ((codePoint & 0xFFE00000) == 0) { // 4-byte sequence
		symbol = stringFromCharCode(((codePoint >> 18) & 0x07) | 0xF0);
		symbol += createByte(codePoint, 12);
		symbol += createByte(codePoint, 6);
	}
	symbol += stringFromCharCode((codePoint & 0x3F) | 0x80);
	return symbol;
}

function utf8encode(string, opts) {
	opts = opts || {};
	var strict = false !== opts.strict;

	var codePoints = ucs2decode(string);
	var length = codePoints.length;
	var index = -1;
	var codePoint;
	var byteString = '';
	while (++index < length) {
		codePoint = codePoints[index];
		byteString += encodeCodePoint(codePoint, strict);
	}
	return byteString;
}

/*--------------------------------------------------------------------------*/

function readContinuationByte() {
	if (byteIndex >= byteCount) {
		throw Error('Invalid byte index');
	}

	var continuationByte = byteArray[byteIndex] & 0xFF;
	byteIndex++;

	if ((continuationByte & 0xC0) == 0x80) {
		return continuationByte & 0x3F;
	}

	// If we end up here, it’s not a continuation byte
	throw Error('Invalid continuation byte');
}

function decodeSymbol(strict) {
	var byte1;
	var byte2;
	var byte3;
	var byte4;
	var codePoint;

	if (byteIndex > byteCount) {
		throw Error('Invalid byte index');
	}

	if (byteIndex == byteCount) {
		return false;
	}

	// Read first byte
	byte1 = byteArray[byteIndex] & 0xFF;
	byteIndex++;

	// 1-byte sequence (no continuation bytes)
	if ((byte1 & 0x80) == 0) {
		return byte1;
	}

	// 2-byte sequence
	if ((byte1 & 0xE0) == 0xC0) {
		byte2 = readContinuationByte();
		codePoint = ((byte1 & 0x1F) << 6) | byte2;
		if (codePoint >= 0x80) {
			return codePoint;
		} else {
			throw Error('Invalid continuation byte');
		}
	}

	// 3-byte sequence (may include unpaired surrogates)
	if ((byte1 & 0xF0) == 0xE0) {
		byte2 = readContinuationByte();
		byte3 = readContinuationByte();
		codePoint = ((byte1 & 0x0F) << 12) | (byte2 << 6) | byte3;
		if (codePoint >= 0x0800) {
			return checkScalarValue(codePoint, strict) ? codePoint : 0xFFFD;
		} else {
			throw Error('Invalid continuation byte');
		}
	}

	// 4-byte sequence
	if ((byte1 & 0xF8) == 0xF0) {
		byte2 = readContinuationByte();
		byte3 = readContinuationByte();
		byte4 = readContinuationByte();
		codePoint = ((byte1 & 0x07) << 0x12) | (byte2 << 0x0C) |
			(byte3 << 0x06) | byte4;
		if (codePoint >= 0x010000 && codePoint <= 0x10FFFF) {
			return codePoint;
		}
	}

	throw Error('Invalid UTF-8 detected');
}

var byteArray;
var byteCount;
var byteIndex;
function utf8decode(byteString, opts) {
	opts = opts || {};
	var strict = false !== opts.strict;

	byteArray = ucs2decode(byteString);
	byteCount = byteArray.length;
	byteIndex = 0;
	var codePoints = [];
	var tmp;
	while ((tmp = decodeSymbol(strict)) !== false) {
		codePoints.push(tmp);
	}
	return ucs2encode(codePoints);
}

module.exports = {
	version: '2.1.2',
	encode: utf8encode,
	decode: utf8decode
};


/***/ }),
/* 2633 */
/***/ (function(module, exports) {

/*
 * base64-arraybuffer
 * https://github.com/niklasvh/base64-arraybuffer
 *
 * Copyright (c) 2012 Niklas von Hertzen
 * Licensed under the MIT license.
 */
(function(){
  "use strict";

  var chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";

  // Use a lookup table to find the index.
  var lookup = new Uint8Array(256);
  for (var i = 0; i < chars.length; i++) {
    lookup[chars.charCodeAt(i)] = i;
  }

  exports.encode = function(arraybuffer) {
    var bytes = new Uint8Array(arraybuffer),
    i, len = bytes.length, base64 = "";

    for (i = 0; i < len; i+=3) {
      base64 += chars[bytes[i] >> 2];
      base64 += chars[((bytes[i] & 3) << 4) | (bytes[i + 1] >> 4)];
      base64 += chars[((bytes[i + 1] & 15) << 2) | (bytes[i + 2] >> 6)];
      base64 += chars[bytes[i + 2] & 63];
    }

    if ((len % 3) === 2) {
      base64 = base64.substring(0, base64.length - 1) + "=";
    } else if (len % 3 === 1) {
      base64 = base64.substring(0, base64.length - 2) + "==";
    }

    return base64;
  };

  exports.decode =  function(base64) {
    var bufferLength = base64.length * 0.75,
    len = base64.length, i, p = 0,
    encoded1, encoded2, encoded3, encoded4;

    if (base64[base64.length - 1] === "=") {
      bufferLength--;
      if (base64[base64.length - 2] === "=") {
        bufferLength--;
      }
    }

    var arraybuffer = new ArrayBuffer(bufferLength),
    bytes = new Uint8Array(arraybuffer);

    for (i = 0; i < len; i+=4) {
      encoded1 = lookup[base64.charCodeAt(i)];
      encoded2 = lookup[base64.charCodeAt(i+1)];
      encoded3 = lookup[base64.charCodeAt(i+2)];
      encoded4 = lookup[base64.charCodeAt(i+3)];

      bytes[p++] = (encoded1 << 2) | (encoded2 >> 4);
      bytes[p++] = ((encoded2 & 15) << 4) | (encoded3 >> 2);
      bytes[p++] = ((encoded3 & 3) << 6) | (encoded4 & 63);
    }

    return arraybuffer;
  };
})();


/***/ }),
/* 2634 */
/***/ (function(module, exports) {

/**
 * Create a blob builder even when vendor prefixes exist
 */

var BlobBuilder = typeof BlobBuilder !== 'undefined' ? BlobBuilder :
  typeof WebKitBlobBuilder !== 'undefined' ? WebKitBlobBuilder :
  typeof MSBlobBuilder !== 'undefined' ? MSBlobBuilder :
  typeof MozBlobBuilder !== 'undefined' ? MozBlobBuilder : 
  false;

/**
 * Check if Blob constructor is supported
 */

var blobSupported = (function() {
  try {
    var a = new Blob(['hi']);
    return a.size === 2;
  } catch(e) {
    return false;
  }
})();

/**
 * Check if Blob constructor supports ArrayBufferViews
 * Fails in Safari 6, so we need to map to ArrayBuffers there.
 */

var blobSupportsArrayBufferView = blobSupported && (function() {
  try {
    var b = new Blob([new Uint8Array([1,2])]);
    return b.size === 2;
  } catch(e) {
    return false;
  }
})();

/**
 * Check if BlobBuilder is supported
 */

var blobBuilderSupported = BlobBuilder
  && BlobBuilder.prototype.append
  && BlobBuilder.prototype.getBlob;

/**
 * Helper function that maps ArrayBufferViews to ArrayBuffers
 * Used by BlobBuilder constructor and old browsers that didn't
 * support it in the Blob constructor.
 */

function mapArrayBufferViews(ary) {
  return ary.map(function(chunk) {
    if (chunk.buffer instanceof ArrayBuffer) {
      var buf = chunk.buffer;

      // if this is a subarray, make a copy so we only
      // include the subarray region from the underlying buffer
      if (chunk.byteLength !== buf.byteLength) {
        var copy = new Uint8Array(chunk.byteLength);
        copy.set(new Uint8Array(buf, chunk.byteOffset, chunk.byteLength));
        buf = copy.buffer;
      }

      return buf;
    }

    return chunk;
  });
}

function BlobBuilderConstructor(ary, options) {
  options = options || {};

  var bb = new BlobBuilder();
  mapArrayBufferViews(ary).forEach(function(part) {
    bb.append(part);
  });

  return (options.type) ? bb.getBlob(options.type) : bb.getBlob();
};

function BlobConstructor(ary, options) {
  return new Blob(mapArrayBufferViews(ary), options || {});
};

if (typeof Blob !== 'undefined') {
  BlobBuilderConstructor.prototype = Blob.prototype;
  BlobConstructor.prototype = Blob.prototype;
}

module.exports = (function() {
  if (blobSupported) {
    return blobSupportsArrayBufferView ? Blob : BlobConstructor;
  } else if (blobBuilderSupported) {
    return BlobBuilderConstructor;
  } else {
    return undefined;
  }
})();


/***/ }),
/* 2635 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * Module requirements.
 */

var Polling = __webpack_require__(698);
var inherit = __webpack_require__(285);

/**
 * Module exports.
 */

module.exports = JSONPPolling;

/**
 * Cached regular expressions.
 */

var rNewline = /\n/g;
var rEscapedNewline = /\\n/g;

/**
 * Global JSONP callbacks.
 */

var callbacks;

/**
 * Noop.
 */

function empty () { }

/**
 * Until https://github.com/tc39/proposal-global is shipped.
 */
function glob () {
  return typeof self !== 'undefined' ? self
      : typeof window !== 'undefined' ? window
      : typeof global !== 'undefined' ? global : {};
}

/**
 * JSONP Polling constructor.
 *
 * @param {Object} opts.
 * @api public
 */

function JSONPPolling (opts) {
  Polling.call(this, opts);

  this.query = this.query || {};

  // define global callbacks array if not present
  // we do this here (lazily) to avoid unneeded global pollution
  if (!callbacks) {
    // we need to consider multiple engines in the same page
    var global = glob();
    callbacks = global.___eio = (global.___eio || []);
  }

  // callback identifier
  this.index = callbacks.length;

  // add callback to jsonp global
  var self = this;
  callbacks.push(function (msg) {
    self.onData(msg);
  });

  // append to query string
  this.query.j = this.index;

  // prevent spurious errors from being emitted when the window is unloaded
  if (typeof addEventListener === 'function') {
    addEventListener('beforeunload', function () {
      if (self.script) self.script.onerror = empty;
    }, false);
  }
}

/**
 * Inherits from Polling.
 */

inherit(JSONPPolling, Polling);

/*
 * JSONP only supports binary as base64 encoded strings
 */

JSONPPolling.prototype.supportsBinary = false;

/**
 * Closes the socket.
 *
 * @api private
 */

JSONPPolling.prototype.doClose = function () {
  if (this.script) {
    this.script.parentNode.removeChild(this.script);
    this.script = null;
  }

  if (this.form) {
    this.form.parentNode.removeChild(this.form);
    this.form = null;
    this.iframe = null;
  }

  Polling.prototype.doClose.call(this);
};

/**
 * Starts a poll cycle.
 *
 * @api private
 */

JSONPPolling.prototype.doPoll = function () {
  var self = this;
  var script = document.createElement('script');

  if (this.script) {
    this.script.parentNode.removeChild(this.script);
    this.script = null;
  }

  script.async = true;
  script.src = this.uri();
  script.onerror = function (e) {
    self.onError('jsonp poll error', e);
  };

  var insertAt = document.getElementsByTagName('script')[0];
  if (insertAt) {
    insertAt.parentNode.insertBefore(script, insertAt);
  } else {
    (document.head || document.body).appendChild(script);
  }
  this.script = script;

  var isUAgecko = 'undefined' !== typeof navigator && /gecko/i.test(navigator.userAgent);

  if (isUAgecko) {
    setTimeout(function () {
      var iframe = document.createElement('iframe');
      document.body.appendChild(iframe);
      document.body.removeChild(iframe);
    }, 100);
  }
};

/**
 * Writes with a hidden iframe.
 *
 * @param {String} data to send
 * @param {Function} called upon flush.
 * @api private
 */

JSONPPolling.prototype.doWrite = function (data, fn) {
  var self = this;

  if (!this.form) {
    var form = document.createElement('form');
    var area = document.createElement('textarea');
    var id = this.iframeId = 'eio_iframe_' + this.index;
    var iframe;

    form.className = 'socketio';
    form.style.position = 'absolute';
    form.style.top = '-1000px';
    form.style.left = '-1000px';
    form.target = id;
    form.method = 'POST';
    form.setAttribute('accept-charset', 'utf-8');
    area.name = 'd';
    form.appendChild(area);
    document.body.appendChild(form);

    this.form = form;
    this.area = area;
  }

  this.form.action = this.uri();

  function complete () {
    initIframe();
    fn();
  }

  function initIframe () {
    if (self.iframe) {
      try {
        self.form.removeChild(self.iframe);
      } catch (e) {
        self.onError('jsonp polling iframe removal error', e);
      }
    }

    try {
      // ie6 dynamic iframes with target="" support (thanks Chris Lambacher)
      var html = '<iframe src="javascript:0" name="' + self.iframeId + '">';
      iframe = document.createElement(html);
    } catch (e) {
      iframe = document.createElement('iframe');
      iframe.name = self.iframeId;
      iframe.src = 'javascript:0';
    }

    iframe.id = self.iframeId;

    self.form.appendChild(iframe);
    self.iframe = iframe;
  }

  initIframe();

  // escape \n to prevent it from being converted into \r\n by some UAs
  // double escaping is required for escaped new lines because unescaping of new lines can be done safely on server-side
  data = data.replace(rEscapedNewline, '\\\n');
  this.area.value = data.replace(rNewline, '\\n');

  try {
    this.form.submit();
  } catch (e) {}

  if (this.iframe.attachEvent) {
    this.iframe.onreadystatechange = function () {
      if (self.iframe.readyState === 'complete') {
        complete();
      }
    };
  } else {
    this.iframe.onload = complete;
  }
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(26)))

/***/ }),
/* 2636 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {/**
 * Module dependencies.
 */

var Transport = __webpack_require__(416);
var parser = __webpack_require__(153);
var parseqs = __webpack_require__(284);
var inherit = __webpack_require__(285);
var yeast = __webpack_require__(700);
var debug = __webpack_require__(88)('engine.io-client:websocket');
var BrowserWebSocket, NodeWebSocket;
if (typeof self === 'undefined') {
  try {
    NodeWebSocket = __webpack_require__(2637);
  } catch (e) { }
} else {
  BrowserWebSocket = self.WebSocket || self.MozWebSocket;
}

/**
 * Get either the `WebSocket` or `MozWebSocket` globals
 * in the browser or try to resolve WebSocket-compatible
 * interface exposed by `ws` for Node-like environment.
 */

var WebSocket = BrowserWebSocket || NodeWebSocket;

/**
 * Module exports.
 */

module.exports = WS;

/**
 * WebSocket transport constructor.
 *
 * @api {Object} connection options
 * @api public
 */

function WS (opts) {
  var forceBase64 = (opts && opts.forceBase64);
  if (forceBase64) {
    this.supportsBinary = false;
  }
  this.perMessageDeflate = opts.perMessageDeflate;
  this.usingBrowserWebSocket = BrowserWebSocket && !opts.forceNode;
  this.protocols = opts.protocols;
  if (!this.usingBrowserWebSocket) {
    WebSocket = NodeWebSocket;
  }
  Transport.call(this, opts);
}

/**
 * Inherits from Transport.
 */

inherit(WS, Transport);

/**
 * Transport name.
 *
 * @api public
 */

WS.prototype.name = 'websocket';

/*
 * WebSockets support binary
 */

WS.prototype.supportsBinary = true;

/**
 * Opens socket.
 *
 * @api private
 */

WS.prototype.doOpen = function () {
  if (!this.check()) {
    // let probe timeout
    return;
  }

  var uri = this.uri();
  var protocols = this.protocols;
  var opts = {
    agent: this.agent,
    perMessageDeflate: this.perMessageDeflate
  };

  // SSL options for Node.js client
  opts.pfx = this.pfx;
  opts.key = this.key;
  opts.passphrase = this.passphrase;
  opts.cert = this.cert;
  opts.ca = this.ca;
  opts.ciphers = this.ciphers;
  opts.rejectUnauthorized = this.rejectUnauthorized;
  if (this.extraHeaders) {
    opts.headers = this.extraHeaders;
  }
  if (this.localAddress) {
    opts.localAddress = this.localAddress;
  }

  try {
    this.ws = this.usingBrowserWebSocket && !this.isReactNative ? (protocols ? new WebSocket(uri, protocols) : new WebSocket(uri)) : new WebSocket(uri, protocols, opts);
  } catch (err) {
    return this.emit('error', err);
  }

  if (this.ws.binaryType === undefined) {
    this.supportsBinary = false;
  }

  if (this.ws.supports && this.ws.supports.binary) {
    this.supportsBinary = true;
    this.ws.binaryType = 'nodebuffer';
  } else {
    this.ws.binaryType = 'arraybuffer';
  }

  this.addEventListeners();
};

/**
 * Adds event listeners to the socket
 *
 * @api private
 */

WS.prototype.addEventListeners = function () {
  var self = this;

  this.ws.onopen = function () {
    self.onOpen();
  };
  this.ws.onclose = function () {
    self.onClose();
  };
  this.ws.onmessage = function (ev) {
    self.onData(ev.data);
  };
  this.ws.onerror = function (e) {
    self.onError('websocket error', e);
  };
};

/**
 * Writes data to socket.
 *
 * @param {Array} array of packets.
 * @api private
 */

WS.prototype.write = function (packets) {
  var self = this;
  this.writable = false;

  // encodePacket efficient as it uses WS framing
  // no need for encodePayload
  var total = packets.length;
  for (var i = 0, l = total; i < l; i++) {
    (function (packet) {
      parser.encodePacket(packet, self.supportsBinary, function (data) {
        if (!self.usingBrowserWebSocket) {
          // always create a new object (GH-437)
          var opts = {};
          if (packet.options) {
            opts.compress = packet.options.compress;
          }

          if (self.perMessageDeflate) {
            var len = 'string' === typeof data ? Buffer.byteLength(data) : data.length;
            if (len < self.perMessageDeflate.threshold) {
              opts.compress = false;
            }
          }
        }

        // Sometimes the websocket has already been closed but the browser didn't
        // have a chance of informing us about it yet, in that case send will
        // throw an error
        try {
          if (self.usingBrowserWebSocket) {
            // TypeError is thrown when passing the second argument on Safari
            self.ws.send(data);
          } else {
            self.ws.send(data, opts);
          }
        } catch (e) {
          debug('websocket closed before onclose event');
        }

        --total || done();
      });
    })(packets[i]);
  }

  function done () {
    self.emit('flush');

    // fake drain
    // defer to next tick to allow Socket to clear writeBuffer
    setTimeout(function () {
      self.writable = true;
      self.emit('drain');
    }, 0);
  }
};

/**
 * Called upon close
 *
 * @api private
 */

WS.prototype.onClose = function () {
  Transport.prototype.onClose.call(this);
};

/**
 * Closes socket.
 *
 * @api private
 */

WS.prototype.doClose = function () {
  if (typeof this.ws !== 'undefined') {
    this.ws.close();
  }
};

/**
 * Generates uri for connection.
 *
 * @api private
 */

WS.prototype.uri = function () {
  var query = this.query || {};
  var schema = this.secure ? 'wss' : 'ws';
  var port = '';

  // avoid port if default for schema
  if (this.port && (('wss' === schema && Number(this.port) !== 443) ||
    ('ws' === schema && Number(this.port) !== 80))) {
    port = ':' + this.port;
  }

  // append timestamp to URI
  if (this.timestampRequests) {
    query[this.timestampParam] = yeast();
  }

  // communicate binary support capabilities
  if (!this.supportsBinary) {
    query.b64 = 1;
  }

  query = parseqs.encode(query);

  // prepend ? to query
  if (query.length) {
    query = '?' + query;
  }

  var ipv6 = this.hostname.indexOf(':') !== -1;
  return schema + '://' + (ipv6 ? '[' + this.hostname + ']' : this.hostname) + port + this.path + query;
};

/**
 * Feature detection for WebSocket.
 *
 * @return {Boolean} whether this transport is available.
 * @api public
 */

WS.prototype.check = function () {
  return !!WebSocket && !('__initialize' in WebSocket && this.name === WS.prototype.name);
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(123).Buffer))

/***/ }),
/* 2637 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 2638 */
/***/ (function(module, exports) {

module.exports = toArray

function toArray(list, index) {
    var array = []

    index = index || 0

    for (var i = index || 0; i < list.length; i++) {
        array[i - index] = list[i]
    }

    return array
}


/***/ }),
/* 2639 */
/***/ (function(module, exports) {


/**
 * Expose `Backoff`.
 */

module.exports = Backoff;

/**
 * Initialize backoff timer with `opts`.
 *
 * - `min` initial timeout in milliseconds [100]
 * - `max` max timeout [10000]
 * - `jitter` [0]
 * - `factor` [2]
 *
 * @param {Object} opts
 * @api public
 */

function Backoff(opts) {
  opts = opts || {};
  this.ms = opts.min || 100;
  this.max = opts.max || 10000;
  this.factor = opts.factor || 2;
  this.jitter = opts.jitter > 0 && opts.jitter <= 1 ? opts.jitter : 0;
  this.attempts = 0;
}

/**
 * Return the backoff duration.
 *
 * @return {Number}
 * @api public
 */

Backoff.prototype.duration = function(){
  var ms = this.ms * Math.pow(this.factor, this.attempts++);
  if (this.jitter) {
    var rand =  Math.random();
    var deviation = Math.floor(rand * this.jitter * ms);
    ms = (Math.floor(rand * 10) & 1) == 0  ? ms - deviation : ms + deviation;
  }
  return Math.min(ms, this.max) | 0;
};

/**
 * Reset the number of attempts.
 *
 * @api public
 */

Backoff.prototype.reset = function(){
  this.attempts = 0;
};

/**
 * Set the minimum duration
 *
 * @api public
 */

Backoff.prototype.setMin = function(min){
  this.ms = min;
};

/**
 * Set the maximum duration
 *
 * @api public
 */

Backoff.prototype.setMax = function(max){
  this.max = max;
};

/**
 * Set the jitter
 *
 * @api public
 */

Backoff.prototype.setJitter = function(jitter){
  this.jitter = jitter;
};



/***/ }),
/* 2640 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AssistantsSearch; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_graphql_tag__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_graphql_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_graphql_tag__);
var _templateObject=_taggedTemplateLiteral(["\n  query AssistantsSearch($brokerId: String!, $search: String!) {\n    AssistantsSearch(brokerId: $brokerId, search: $search) {\n      id\n      full_name\n      email\n    }\n  }\n"],["\n  query AssistantsSearch($brokerId: String!, $search: String!) {\n    AssistantsSearch(brokerId: $brokerId, search: $search) {\n      id\n      full_name\n      email\n    }\n  }\n"]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var AssistantsSearch=__WEBPACK_IMPORTED_MODULE_0_graphql_tag___default()(_templateObject);

/***/ }),
/* 2641 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_core__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/*eslint-disable*/var styles=function styles(theme){return{textField:{width:'100%',marginTop:0,marginBottom:0}};};var chars='0123456789/';var FormInputClass=function(_React$Component){_inherits(FormInputClass,_React$Component);function FormInputClass(props){_classCallCheck(this,FormInputClass);var _this=_possibleConstructorReturn(this,(FormInputClass.__proto__||Object.getPrototypeOf(FormInputClass)).call(this,props));_this.handleChange=function(event,value){event.preventDefault();var length=event.target.value.length;if(length==2&&value.length<3){event.target.value=event.target.value+'/';}if(length==5&&value.length<6){event.target.value=event.target.value+'/';}if(_this.props.input.onChange){_this.props.input.onChange(event);_this.props.input.onBlur(event);}};return _this;}_createClass(FormInputClass,[{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps){var _this2=this;var comparedState=false;Object.keys(this.props).map(function(s){if(_this2.props[s]!==nextProps[s]){comparedState=true;}return s;});return comparedState;}},{key:'render',value:function render(){var _this3=this;this.props.meta.valid=false;var trySubmit=this.props.checkValidation?true:false;var _props$meta=this.props.meta,touched=_props$meta.touched,error=_props$meta.error,warning=_props$meta.warning;var lValue=this.props.fixedValue?this.props.fixedValue:this.props.input.value;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["X" /* TextField */],{onChange:function onChange(e){return _this3.handleChange(e,lValue);},id:this.props.input.name,value:lValue?lValue:'',label:this.props.label,className:this.props.classes.textField,margin:'normal',error:error&&error.length>0&&(touched||this.props.fixedValue)?true:error&&error.length>0&&trySubmit?true:false,helperText:error&&(touched||this.props.fixedValue)||error&&trySubmit?error:null,InputProps:{readOnly:this.props.readOnly?true:false},placeholder:this.props.placeholder});}}]);return FormInputClass;}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["_1" /* withStyles */])(styles)(FormInputClass));

/***/ }),
/* 2642 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_core__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_Table_EmptyBody_jsx__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_helpers_UserHelper__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_queries_messaging_queries_js__ = __webpack_require__(691);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_apollo__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__containers_CMHContainer__ = __webpack_require__(2643);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var columnData=[{id:"edit",numeric:false,disablePadding:true,label:"",noSort:true,width:"30px"},{id:"unread",numeric:false,disablePadding:true,label:"Unread",noSort:true},{id:"c.scd_surname",numeric:false,disablePadding:true,label:"Client Name"},{id:"m.date_sent",numeric:false,disablePadding:true,label:"Latest Message"}];var ClientMessageHistory=function(_React$Component){_inherits(ClientMessageHistory,_React$Component);function ClientMessageHistory(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ClientMessageHistory);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ClientMessageHistory.__proto__||Object.getPrototypeOf(ClientMessageHistory)).call.apply(_ref,[this].concat(args))),_this),_this.state={page:0,rowsPerPage:5,order:"desc",orderBy:"m.date_sent",searchTerm:"",loadingSearch:false,searchData:[],openMenus:[],anchorTop:0,anchorLeft:0,popoverOpen:false,assistantActive:false,clientFound:false},_this.handleSearch=function(event,refetch){_this.setState({searchTerm:event.target.value});refetch();},_this.handleChangePage=function(page,refetch){_this.setState({page:page});refetch();},_this.handleChangeRowsPerPage=function(event,refetch){_this.setState({rowsPerPage:event.target.value});refetch();},_this.handleRequestSort=function(event,property,refetch){var orderBy=property;var order="desc";if(_this.state.orderBy===property&&_this.state.order==="desc"){order="asc";}_this.setState({order:order,orderBy:orderBy});refetch();},_this.getBrokerId=function(){var brokerId=Object(__WEBPACK_IMPORTED_MODULE_2_helpers_UserHelper__["a" /* GetUserId */])();if(_this.checkAssistantActive()){brokerId=sessionStorage.getItem("ActiveBrokerId");}return brokerId;},_this.getBrokerName=function(){return sessionStorage.getItem("ActiveBrokerName");},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ClientMessageHistory,[{key:"handleClick",value:function handleClick(client){this.props.history.push({pathname:"/app/clientmessages",search:"clientId="+client.id+"&clientName="+client.clientFullName});}},{key:"checkAssistantActive",value:function checkAssistantActive(){if(Object(__WEBPACK_IMPORTED_MODULE_2_helpers_UserHelper__["b" /* GetUserKey */])("userType")==="6"){if(!this.state.assistantActive){this.setState({assistantActive:true});}return true;}return false;}},{key:"render",value:function render(){var _this2=this;var colSpan=Object.keys(columnData).length;return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_apollo__["Query"],{query:__WEBPACK_IMPORTED_MODULE_3_queries_messaging_queries_js__["a" /* GetClientMessageHistory */],variables:{brokerId:this.getBrokerId(),token:Object(__WEBPACK_IMPORTED_MODULE_2_helpers_UserHelper__["c" /* GetUserToken */])(),limit:this.state.rowsPerPage,page:this.state.page,orderBy:this.state.orderBy,direction:this.state.order,search:this.state.searchTerm},fetchPolicy:"network-only"},function(_ref2){var loading=_ref2.loading,error=_ref2.error,data=_ref2.data,refetch=_ref2.refetch;if(loading){return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__containers_CMHContainer__["a" /* default */],Object.assign({},_this2.state,{brokerName:_this2.getBrokerName(),handleSearch:function handleSearch(e){return _this2.handleSearch(e,refetch);},handleRequestSort:function handleRequestSort(event,property){return _this2.handleRequestSort(event,property,refetch);},columnData:columnData,tableBody:__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Table_EmptyBody_jsx__["a" /* default */],{colSpan:colSpan,rowSpan:_this2.state.rowsPerPage,placeHolder:__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["j" /* CircularProgress */],null)})}));}if(error)return"Error! "+error.message;var items=data.ClientMessageHistory.Results;var count=data.ClientMessageHistory.Count;return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__containers_CMHContainer__["a" /* default */],Object.assign({},_this2.state,{brokerName:_this2.getBrokerName(),handleSearch:function handleSearch(e){return _this2.handleSearch(e,refetch);},handleRequestSort:function handleRequestSort(event,property){return _this2.handleRequestSort(event,property,refetch);},columnData:columnData,tableBody:__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Fragment,null,items.length<1&&_this2.state.searchTerm!==""?__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Table_EmptyBody_jsx__["a" /* default */],{colSpan:colSpan,rowSpan:_this2.state.rowsPerPage,placeHolder:__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{variant:"subheading"},_this2.state.searchTerm!==""?"No results found":"No FNAs created yet. Click on Create FNA")}):__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Fragment,null,items.map(function(item){return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],{className:"sqDataTable",key:item.id,onClick:function onClick(){return _this2.handleClick(item);}},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{style:{padding:"0px",borderRight:"1px solid #e0e0e0",backgroundColor:"white"}},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["x" /* IconButton */],null,__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["w" /* Icon */],null,"more_vert"))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{style:{borderTop:"1px solid rgba(224, 224, 224, 1)",width:"35px"}},item.unread_messages>0?__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["c" /* Badge */],{color:"primary",badgeContent:__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("strong",null,item.unread_messages)}):__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{variant:"caption",className:"centerCell"},"0")),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,item.clientFullName),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,item.latest_message_date));}),[].concat(_toConsumableArray(Array(_this2.state.rowsPerPage-items.length))).map(function(a,i){return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],{key:i,colSpan:colSpan});})),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["U" /* TablePagination */],{count:count,rowsPerPage:_this2.state.rowsPerPage,page:_this2.state.page,backIconButtonProps:{"aria-label":"Previous Page"},nextIconButtonProps:{"aria-label":"Next Page"},onChangePage:function onChangePage(event,page){return _this2.handleChangePage(page,refetch);},onChangeRowsPerPage:function onChangeRowsPerPage(event){return _this2.handleChangeRowsPerPage(event,refetch);}})))}));});}}]);return ClientMessageHistory;}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (ClientMessageHistory);

/***/ }),
/* 2643 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_core__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_icons__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Grid_GridItem_jsx__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_EnhancedTableHead_EnhancedTableHead_jsx__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
var CMHContainer=function CMHContainer(props){return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{container:true},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:10,style:{flexBasis:"100%",maxWidth:"100%",margin:"auto"}},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["e" /* Card */],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["f" /* CardContent */],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("div",null,props.assistantActive?__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{variant:"headline",className:"centerCell"},props.brokerName,"'s Client Messages"):__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{variant:"headline",className:"centerCell"},"Client Messages"),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("div",{style:{borderBottom:"1px solid #cccccc69",margin:"5px auto",width:"25%",marginBottom:"20px"}})),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["I" /* Paper */],{style:{overflowX:"auto"}},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{container:true},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{item:true,xs:10,sm:10,md:10,style:{margin:"0 auto",display:"flex",marginTop:"20px"}},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["X" /* TextField */],{id:"input-with-icon-textfield",fullWidth:true,style:{marginBottom:"30px"},placeholder:"Client or Date Created(DD/MM/YYYY)",value:props.searchTerm,onChange:props.handleSearch,label:"Search",InputProps:{startAdornment:__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["z" /* InputAdornment */],{position:"start"},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_icons__["n" /* Search */],null))}}))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Q" /* Table */],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_EnhancedTableHead_EnhancedTableHead_jsx__["a" /* default */],{order:props.order,orderBy:props.orderBy,onRequestSort:function onRequestSort(event,property){return props.handleRequestSort(event,property);},rowCount:props.items?props.items.length:0,columnData:props.columnData}),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["R" /* TableBody */],null,props.tableBody)))))));};/* harmony default export */ __webpack_exports__["a"] = (CMHContainer);

/***/ }),
/* 2644 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_core__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_CustomChip_CustomChip_jsx__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_Grid_GridItem_jsx__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_helpers_UserHelper__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_queries_todo_mutations__ = __webpack_require__(706);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_queries_todo_queries__ = __webpack_require__(2645);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_apollo__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_reducers_NotificationReducer__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_store__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_TodoDialog_jsx__ = __webpack_require__(705);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_UserTodosCurrent_jsx__ = __webpack_require__(2646);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_UserTodosDone_jsx__ = __webpack_require__(2647);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_UserTodosAssigned_jsx__ = __webpack_require__(2648);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var tabStyle={color:"#6c5cab",borderBottom:"2px solid"};var UserTodos=function(_React$Component){_inherits(UserTodos,_React$Component);function UserTodos(){var _ref;var _temp,_this,_ret;_classCallCheck(this,UserTodos);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=UserTodos.__proto__||Object.getPrototypeOf(UserTodos)).call.apply(_ref,[this].concat(args))),_this),_this.state={tab:0,todosInitiated:false,currentTodos:[],doneTodos:[],assignedTodos:[],openTodoDialog:false,selectedTodo:null},_this.tabs=["Own","Done"],_this.handelCloseTodoDialog=function(){_this.setState({openTodoDialog:false,selectedTodo:null});},_this.handelOpenTodoDialog=function(){var todo=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;_this.setState({selectedTodo:todo,openTodoDialog:true});},_this.handleChangeTab=function(event,value){_this.setState({tab:value});},_this.handleTodoDoneClick=function(id){var currentTodos=[].concat(_toConsumableArray(_this.state.currentTodos));var doneTodos=[].concat(_toConsumableArray(_this.state.doneTodos));var todo=currentTodos.find(function(t){return t.id===id;});var todoIndex=currentTodos.findIndex(function(t){return t.id===id;});if(todo){currentTodos[todoIndex].loadingAction=true;_this.setState({currentTodos:currentTodos});_this.ExecuteTodoMutation(todo,1,function(resp){__WEBPACK_IMPORTED_MODULE_9_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_8_reducers_NotificationReducer__["d" /* showSnack */])({message:"Todo Marked as done",color:"success"}));todo.loadingAction=false;doneTodos.unshift(todo);currentTodos=currentTodos.filter(function(t){return t.id!==id;});_this.setState({currentTodos:currentTodos,doneTodos:doneTodos});});}},_this.handleTodoMoveToCurrent=function(id){var currentTodos=[].concat(_toConsumableArray(_this.state.currentTodos));var doneTodos=[].concat(_toConsumableArray(_this.state.doneTodos));var todo=doneTodos.find(function(t){return t.id===id;});var todoIndex=doneTodos.findIndex(function(t){return t.id===id;});if(todo){doneTodos[todoIndex].loadingAction=true;_this.setState({doneTodos:doneTodos});_this.ExecuteTodoMutation(todo,0,function(resp){__WEBPACK_IMPORTED_MODULE_9_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_8_reducers_NotificationReducer__["d" /* showSnack */])({message:"Todo Marked as not done",color:"success"}));todo.loadingAction=false;currentTodos.unshift(todo);doneTodos=doneTodos.filter(function(t){return t.id!==id;});_this.setState({currentTodos:currentTodos,doneTodos:doneTodos});});}},_this.handleTodoAssignedDone=function(id){var assignedTodos=[].concat(_toConsumableArray(_this.state.assignedTodos));var todo=assignedTodos.find(function(t){return t.id===id;});var todoIndex=assignedTodos.findIndex(function(t){return t.id===id;});if(todo){assignedTodos[todoIndex].loadingAction=true;_this.setState({assignedTodos:assignedTodos});_this.ExecuteTodoMutation(todo,2,function(resp){__WEBPACK_IMPORTED_MODULE_9_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_8_reducers_NotificationReducer__["d" /* showSnack */])({message:"Assigned To Do Marked as done",color:"success"}));todo.loadingAction=false;assignedTodos=assignedTodos.filter(function(t){return t.id!==id;});_this.setState({assignedTodos:assignedTodos});});}},_this.todoAdded=function(todo){var currentTodos=[].concat(_toConsumableArray(_this.state.currentTodos));currentTodos.unshift(Object.assign({},todo,{loadingAction:false}));_this.setState({currentTodos:currentTodos});},_this.todoEdited=function(todo){var currentTodos=[].concat(_toConsumableArray(_this.state.currentTodos));var todoIndex=currentTodos.findIndex(function(t){return t.id===todo.id;});currentTodos[todoIndex]=todo;_this.setState({currentTodos:currentTodos});},_this.deleteTodo=function(id,type){var todos=[].concat(_toConsumableArray(_this.state[type]));var todo=todos.find(function(t){return t.id===id;});var todoIndex=todos.findIndex(function(t){return t.id===id;});if(todo){todos[todoIndex].loadingAction=true;_this.setState(_defineProperty({},type,todos));_this.props.DeleteTodo({variables:{input:{todoId:todo.id,userId:Object(__WEBPACK_IMPORTED_MODULE_3_helpers_UserHelper__["a" /* GetUserId */])(),token:Object(__WEBPACK_IMPORTED_MODULE_3_helpers_UserHelper__["c" /* GetUserToken */])()}}}).then(function(resp){__WEBPACK_IMPORTED_MODULE_9_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_8_reducers_NotificationReducer__["d" /* showSnack */])({message:"Todo Delete",color:"danger"}));todos=todos.filter(function(t){return t.id!==id;});_this.setState(_defineProperty({},type,todos));}).catch(function(error){console.log("err",error);});}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(UserTodos,[{key:"checkAssistantActive",value:function checkAssistantActive(){return Object(__WEBPACK_IMPORTED_MODULE_3_helpers_UserHelper__["b" /* GetUserKey */])("userType")==="6"?true:false;}},{key:"componentDidMount",value:function componentDidMount(){if(this.checkAssistantActive()){this.tabs.unshift("Assigned to you");}}},{key:"ExecuteTodoMutation",value:function ExecuteTodoMutation(todo,done,callback){var input={todoId:todo.id,userId:Object(__WEBPACK_IMPORTED_MODULE_3_helpers_UserHelper__["a" /* GetUserId */])(),token:Object(__WEBPACK_IMPORTED_MODULE_3_helpers_UserHelper__["c" /* GetUserToken */])(),title:todo.title,desc:todo.description,assistantId:todo.assigned_userId,clientId:todo.client_id,done:done};this.props.Todo({variables:{input:input}}).then(function(resp){callback(resp);}).catch(function(error){console.log("err",error);});}},{key:"render",value:function render(){var _this2=this;var tab=this.state.tab;return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{container:true},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:10,style:{flexBasis:"100%",maxWidth:"100%",margin:'auto'}},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["e" /* Card */],null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["f" /* CardContent */],null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement("div",{style:{marginBottom:"35px"}},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{variant:"headline",className:"centerCell"},"To Do"),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement("div",{style:{borderBottom:"1px solid #cccccc69",margin:"5px auto",width:"25%"}})),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_apollo__["Query"],{query:__WEBPACK_IMPORTED_MODULE_5_queries_todo_queries__["a" /* GetUserTodos */],variables:{userId:Object(__WEBPACK_IMPORTED_MODULE_3_helpers_UserHelper__["a" /* GetUserId */])(),token:Object(__WEBPACK_IMPORTED_MODULE_3_helpers_UserHelper__["c" /* GetUserToken */])(),done:0},fetchPolicy:"network-only"},function(_ref2){var loading=_ref2.loading,error=_ref2.error,data=_ref2.data,refetch=_ref2.refetch;if(loading){return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["B" /* LinearProgress */],null);}if(!_this2.state.todosInitiated){var _UserTodos=[].concat(_toConsumableArray(data.UserTodos));var doneTodos=_UserTodos.filter(function(u){return u.done===true&&u.assigned_userId!==parseInt(Object(__WEBPACK_IMPORTED_MODULE_3_helpers_UserHelper__["a" /* GetUserId */])(),10);});doneTodos=doneTodos.map(function(u){return Object.assign({},u,{loadingAction:false});});var currentTodos=_UserTodos.filter(function(u){return u.done===false&&u.assigned_userId!==parseInt(Object(__WEBPACK_IMPORTED_MODULE_3_helpers_UserHelper__["a" /* GetUserId */])(),10);});currentTodos=currentTodos.map(function(u){return Object.assign({},u,{loadingAction:false});});var assignedTodos=_UserTodos.filter(function(u){return u.assigned_userId===parseInt(Object(__WEBPACK_IMPORTED_MODULE_3_helpers_UserHelper__["a" /* GetUserId */])(),10)&&!u.todo_assigned_done;});assignedTodos=assignedTodos.map(function(u){return Object.assign({},u,{loadingAction:false});});_this2.setState({currentTodos:currentTodos,doneTodos:doneTodos,assignedTodos:assignedTodos,todosInitiated:true});}return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["a" /* AppBar */],{position:"static",color:"default",style:{marginBottom:"20px"}},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["W" /* Tabs */],{tab:tab,onChange:_this2.handleChangeTab,indicatorColor:"primary",textColor:"secondary",scrollable:true,scrollButtons:"auto"},_this2.tabs.map(function(t,i){return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["P" /* Tab */],{label:t,style:i===tab?tabStyle:{},key:t});}))),tab===0&&_this2.checkAssistantActive()?__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__components_UserTodosAssigned_jsx__["a" /* default */],{todos:_this2.state.assignedTodos,handleDoneToggle:_this2.handleTodoAssignedDone}):null,tab===0&&!_this2.checkAssistantActive()||tab===1&&_this2.checkAssistantActive()?__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_CustomChip_CustomChip_jsx__["a" /* default */],{text:"Add Todo",icon:"add",clicked:_this2.handelOpenTodoDialog,style:{marginBottom:"25px"}}),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_UserTodosCurrent_jsx__["a" /* default */],{todos:_this2.state.currentTodos,handleDoneToggle:_this2.handleTodoDoneClick,handleDelete:function handleDelete(id){return _this2.deleteTodo(id,"currentTodos");},handleEdit:function handleEdit(todo){return _this2.handelOpenTodoDialog(todo);}})):null,tab===1&&!_this2.checkAssistantActive()||tab===2&&_this2.checkAssistantActive()?__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_UserTodosDone_jsx__["a" /* default */],{todos:_this2.state.doneTodos,handleDoneToggle:_this2.handleTodoMoveToCurrent,handleDelete:function handleDelete(id){return _this2.deleteTodo(id,"doneTodos");}}):null);})))),this.state.openTodoDialog?__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_TodoDialog_jsx__["a" /* default */],{open:true,closeDialog:this.handelCloseTodoDialog,todoAdded:function todoAdded(resp){return _this2.todoAdded(resp);},todoEdited:function todoEdited(resp){return _this2.todoEdited(resp);},todo:this.state.selectedTodo}):null);}}]);return UserTodos;}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);UserTodos=Object(__WEBPACK_IMPORTED_MODULE_7_react_apollo__["compose"])(Object(__WEBPACK_IMPORTED_MODULE_7_react_apollo__["graphql"])(__WEBPACK_IMPORTED_MODULE_4_queries_todo_mutations__["b" /* Todo */],{name:"Todo"}),Object(__WEBPACK_IMPORTED_MODULE_7_react_apollo__["graphql"])(__WEBPACK_IMPORTED_MODULE_4_queries_todo_mutations__["a" /* DeleteTodo */],{name:"DeleteTodo"}))(UserTodos);/* harmony default export */ __webpack_exports__["a"] = (UserTodos);

/***/ }),
/* 2645 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GetUserTodos; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_graphql_tag__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_graphql_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_graphql_tag__);
var _templateObject=_taggedTemplateLiteral(["\n  query userTodos($userId: String!, $token: String!, $done: Int!) {\n    UserTodos(userId: $userId, token: $token, done: $done) {\n      id\n      title\n      desc\n      done\n      date_created\n      assigned_userId\n      assigned_user_fullname\n      client_id\n      client_fullname\n      todo_assigned_done\n      owner_fullname\n      due_date\n    }\n  }\n"],["\n  query userTodos($userId: String!, $token: String!, $done: Int!) {\n    UserTodos(userId: $userId, token: $token, done: $done) {\n      id\n      title\n      desc\n      done\n      date_created\n      assigned_userId\n      assigned_user_fullname\n      client_id\n      client_fullname\n      todo_assigned_done\n      owner_fullname\n      due_date\n    }\n  }\n"]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var GetUserTodos=__WEBPACK_IMPORTED_MODULE_0_graphql_tag___default()(_templateObject);

/***/ }),
/* 2646 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_core__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TodoCard__ = __webpack_require__(707);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var UserTodosCurrent=function(_React$Component){_inherits(UserTodosCurrent,_React$Component);function UserTodosCurrent(){_classCallCheck(this,UserTodosCurrent);return _possibleConstructorReturn(this,(UserTodosCurrent.__proto__||Object.getPrototypeOf(UserTodosCurrent)).apply(this,arguments));}_createClass(UserTodosCurrent,[{key:"render",value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{container:true},this.props.todos.map(function(todo){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:6,style:{marginBottom:"35px"},key:todo.id},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__TodoCard__["a" /* default */],{title:todo.title,desc:todo.desc,date_created:todo.date_created,assigned_user_fullname:todo.assigned_user_fullname,todo_assigned_done:todo.todo_assigned_done,client_fullname:todo.client_fullname,doneToggle:function doneToggle(){return _this2.props.handleDoneToggle(todo.id);},handleDelete:function handleDelete(){return _this2.props.handleDelete(todo.id);},handleEdit:function handleEdit(){return _this2.props.handleEdit(todo);},loadingAction:todo.loadingAction,due_date:todo.due_date}));}));}}]);return UserTodosCurrent;}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (UserTodosCurrent);

/***/ }),
/* 2647 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_core__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TodoCard__ = __webpack_require__(707);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var UserTodosDone=function(_React$Component){_inherits(UserTodosDone,_React$Component);function UserTodosDone(){_classCallCheck(this,UserTodosDone);return _possibleConstructorReturn(this,(UserTodosDone.__proto__||Object.getPrototypeOf(UserTodosDone)).apply(this,arguments));}_createClass(UserTodosDone,[{key:"render",value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{container:true},this.props.todos.map(function(todo){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:6,style:{marginBottom:"35px"},key:todo.id},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__TodoCard__["a" /* default */],{done:true,title:todo.title,desc:todo.desc,date_created:todo.date_created,assigned_user_fullname:todo.assigned_user_fullname,client_fullname:todo.client_fullname,doneToggle:function doneToggle(){return _this2.props.handleDoneToggle(todo.id);},handleDelete:function handleDelete(){return _this2.props.handleDelete(todo.id);},todo_assigned_done:todo.todo_assigned_done,due_date:todo.due_date}));})));}}]);return UserTodosDone;}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (UserTodosDone);

/***/ }),
/* 2648 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_core__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AssignedTodoCard_jsx__ = __webpack_require__(2649);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var UserTodosAssigned=function(_React$Component){_inherits(UserTodosAssigned,_React$Component);function UserTodosAssigned(){_classCallCheck(this,UserTodosAssigned);return _possibleConstructorReturn(this,(UserTodosAssigned.__proto__||Object.getPrototypeOf(UserTodosAssigned)).apply(this,arguments));}_createClass(UserTodosAssigned,[{key:"render",value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{container:true},this.props.todos.map(function(todo){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:6,style:{marginBottom:"35px"},key:todo.id},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__AssignedTodoCard_jsx__["a" /* default */],{title:todo.title,desc:todo.desc,date_created:todo.date_created,client_fullname:todo.client_fullname,doneToggle:function doneToggle(){return _this2.props.handleDoneToggle(todo.id);},loadingAction:todo.loadingAction,from_user:todo.owner_fullname,due_date:todo.due_date}));}));}}]);return UserTodosAssigned;}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (UserTodosAssigned);

/***/ }),
/* 2649 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core__ = __webpack_require__(4);
function isEmptyOrSpaces(str){return str===undefined||str===null||str.toString().match(/^ *$/)!==null;}var AssignedTodoCard=function AssignedTodoCard(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["e" /* Card */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["v" /* Grid */],{container:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["v" /* Grid */],{item:true,xs:9,sm:9,md:10,style:{borderRight:"1px solid #cccccc69"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["f" /* CardContent */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["Z" /* Typography */],{variant:"subheading"},props.title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:{borderBottom:"1px solid #cccccc69",margin:"5px auto",width:"100%"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["Z" /* Typography */],{variant:"body2",className:"todoDesc"},props.desc),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:{borderBottom:"1px solid #cccccc69",margin:"5px auto",width:"100%"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["Z" /* Typography */],{variant:"caption"},"Created: ",props.date_created),props.due_date?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["Z" /* Typography */],{variant:"caption"},"Due: ",props.due_date):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["Z" /* Typography */],{variant:"caption",style:{marginTop:"15px"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"Assigned To:")," You"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["Z" /* Typography */],{variant:"caption"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"From:")," ",props.from_user),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["Z" /* Typography */],{variant:"caption"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"Client:")," ",!isEmptyOrSpaces(props.client_fullname)?props.client_fullname:"None"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["v" /* Grid */],{item:true,xs:3,sm:3,md:2,style:{textAlign:"center"}},props.loadingAction?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:{marginTop:"10px"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["j" /* CircularProgress */],{size:20})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["v" /* Grid */],{container:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["v" /* Grid */],{item:true,xs:12,sm:12,md:12,style:{marginTop:"10px"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["Y" /* Tooltip */],{title:"Mark as done"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["d" /* Button */],{variant:"fab",mini:true,color:"secondary","aria-label":"Edit",className:"semiSmallFab",onClick:props.doneToggle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["w" /* Icon */],{style:{color:"white"}},"check"))))))));};/* harmony default export */ __webpack_exports__["a"] = (AssignedTodoCard);

/***/ }),
/* 2650 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var PaymentPlayground=function(_React$Component){_inherits(PaymentPlayground,_React$Component);function PaymentPlayground(){_classCallCheck(this,PaymentPlayground);return _possibleConstructorReturn(this,(PaymentPlayground.__proto__||Object.getPrototypeOf(PaymentPlayground)).apply(this,arguments));}_createClass(PaymentPlayground,[{key:"render",value:function render(){var Mode="0";var MerchantID="F3CCB041-2AEB-4289-86A2-A3329DBDDED7";var ApplicationID="BBA6CF97-C116-4536-A3B2-0D32861912C6";var Price="10.00";var Currency="ZAR";var MerchantReference="SUREQUOTEUSER:14";var RedirectSuccess="http://localhost:8080/payment/process";var RedirectFailed="http://localhost:8080/payment/process";var Title="Node.JS Virtual 3D Secure";return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h1",null,Title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("form",{name:"PostTest",action:"https://virtual.mygateglobal.com/PaymentPage.cfm",method:"post"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",{width:"800",border:"0",cellpadding:"0",cellspacing:"0",bordercolor:"#f8f9e8"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",{valign:"top"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{height:"500"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",{border:"0"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{rowspan:"2"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{align:"left"},"Payment Amount:"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{width:"5"},"\xA0"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,Price)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{align:"left"},"Payment For:"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{width:"5"},"\xA0"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"Leon van der Walt")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{width:"5"},"\xA0"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{align:"left"},"Merchant Reference :"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{width:"5"},"\xA0"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"text",id:"txtMerchantReference",name:"txtMerchantReference",value:MerchantReference})))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"hidden",id:"Recipient",name:"Recipient",value:"Someone"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"hidden",id:"Mode",name:"Mode",value:Mode}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"hidden",name:"MerchantID",value:MerchantID}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"hidden",name:"ApplicationID",value:ApplicationID}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"hidden",name:"Price",value:Price}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"hidden",name:"Amount",value:Price}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"hidden",name:"CurrencyCode",value:Currency}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"hidden",name:"RedirectSuccessfulURL",value:RedirectSuccess}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"hidden",name:"RedirectFailedURL",value:RedirectFailed}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"hidden",name:"DISCOUNT",value:"0"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"hidden",name:"ITEMAMOUNT1",value:"0"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"hidden",name:"ITEMDESCR1",value:"desc 1"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"hidden",name:"ITEMREF1",value:"Item Ref 15784 - 018179"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"hidden",name:"QTY1",value:"1"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"hidden",name:"RECIPIENT",value:"Sure Quote"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"hidden",name:"SHIPPINGADDRESS1",value:"410 Lynnwood Road"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"hidden",name:"SHIPPINGADDRESS2",value:"Lynnwood"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"hidden",name:"SHIPPINGADDRESS3",value:"Pretoria"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"hidden",name:"SHIPPINGADDRESS4",value:"South Africa"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"hidden",name:"SHIPPINGADDRESS5",value:"0081"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"hidden",name:"SHIPPINGCOST",value:"0"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,"I Have carefully read the above terms and conditions, and agree to abide by them"),":",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),"I agree"," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"radio",name:"tc[]",value:"1",checked:"true"})," I do not agree ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"radio",name:"tc[]",value:"0"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"submit",value:"Continue",onClick:"return chkParms(this.form)"}))));}}]);return PaymentPlayground;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (PaymentPlayground);

/***/ }),
/* 2651 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core__ = __webpack_require__(4);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var PaymentSuccess=function(_React$Component){_inherits(PaymentSuccess,_React$Component);function PaymentSuccess(){_classCallCheck(this,PaymentSuccess);return _possibleConstructorReturn(this,(PaymentSuccess.__proto__||Object.getPrototypeOf(PaymentSuccess)).apply(this,arguments));}_createClass(PaymentSuccess,[{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["e" /* Card */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["f" /* CardContent */],null,"Payment was successfull"));}}]);return PaymentSuccess;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (PaymentSuccess);

/***/ }),
/* 2652 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core__ = __webpack_require__(4);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var PaymentFailed=function(_React$Component){_inherits(PaymentFailed,_React$Component);function PaymentFailed(){_classCallCheck(this,PaymentFailed);return _possibleConstructorReturn(this,(PaymentFailed.__proto__||Object.getPrototypeOf(PaymentFailed)).apply(this,arguments));}_createClass(PaymentFailed,[{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["e" /* Card */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["f" /* CardContent */],null,"Payment failed"));}}]);return PaymentFailed;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (PaymentFailed);

/***/ }),
/* 2653 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_core__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_AppBar__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_AppBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_AppBar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_Tab__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_Tab___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Tab__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_Tabs__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_Tabs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Tabs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Grid_GridItem_jsx__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_helpers_UriReader__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Documents_ClientDocuments_jsx__ = __webpack_require__(2654);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Messaging_ClientMessages_jsx__ = __webpack_require__(690);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_ClientDetailCard__ = __webpack_require__(2660);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__tabs_quotes_QuotesTab_jsx__ = __webpack_require__(2662);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var tabStyle={color:"white",borderBottom:"2px solid",opacity:"1"};var tabs=["Quotes","Documents","Messages"];var ClientDetailView=function(_React$Component){_inherits(ClientDetailView,_React$Component);function ClientDetailView(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ClientDetailView);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ClientDetailView.__proto__||Object.getPrototypeOf(ClientDetailView)).call.apply(_ref,[this].concat(args))),_this),_this.state={tab:0},_this.handleChangeTab=function(event,value){_this.setState({tab:value});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ClientDetailView,[{key:"componentDidMount",value:function componentDidMount(){var params=Object(__WEBPACK_IMPORTED_MODULE_5_helpers_UriReader__["a" /* ParseUriParams */])(this.props.location.search);var tab=params.tab;if(tab){var tabIndex=tabs.findIndex(function(t){return t.toLowerCase()===tab.toLowerCase();});if(tabIndex){this.setState({tab:tabIndex});}}}},{key:"render",value:function render(){var params=Object(__WEBPACK_IMPORTED_MODULE_5_helpers_UriReader__["a" /* ParseUriParams */])(this.props.location.search);var clientId=params.clientId,clientName=params.clientName;var tab=this.state.tab;return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{container:true},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:5,lg:4,style:{marginBottom:"10px"}},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_ClientDetailCard__["a" /* default */],Object.assign({clientId:clientId},this.props))),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:7,lg:8},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["e" /* Card */],null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["f" /* CardContent */],null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_AppBar___default.a,{position:"static",color:"primary",style:{marginBottom:"20px"}},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Tabs___default.a,{tab:tab,onChange:this.handleChangeTab,scrollable:true,scrollButtons:"auto"},tabs.map(function(t,i){return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Tab___default.a,{label:t,style:i===tab?tabStyle:{},key:t});}))),tab===0&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__tabs_quotes_QuotesTab_jsx__["a" /* default */],Object.assign({clientId:clientId,clientName:clientName},this.props)),tab===1&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Documents_ClientDocuments_jsx__["a" /* default */],Object.assign({clientId:clientId,clientName:clientName},this.props)),tab===2&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Messaging_ClientMessages_jsx__["a" /* default */],Object.assign({clientId:clientId,clientName:clientName},this.props)))))));}}]);return ClientDetailView;}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (ClientDetailView);

/***/ }),
/* 2654 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Grid_GridItem_jsx__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Grid_GridContainer_jsx__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_queries_ClientDocuments__ = __webpack_require__(2655);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_apollo__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_redux__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_helpers_UserHelper__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_router__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_icons_ExpandMore__ = __webpack_require__(576);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_icons_ExpandMore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__material_ui_icons_ExpandMore__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__UploadModal_jsx__ = __webpack_require__(2656);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__FileCard_jsx__ = __webpack_require__(2657);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_graphql_tag__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_graphql_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_graphql_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_assets_jss_material_dashboard_pro_react_views_sweetAlertStyle_jsx__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__material_ui_core_styles_withStyles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__material_ui_core_styles_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__material_ui_core_styles_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react_bootstrap_sweetalert__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react_bootstrap_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_react_bootstrap_sweetalert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_helpers_Documents_js__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__QuoteCard_jsx__ = __webpack_require__(2658);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_helpers_Search__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_queries_document_mutations__ = __webpack_require__(2659);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_helpers_ErrorHelper__ = __webpack_require__(391);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_helpers_UriReader__ = __webpack_require__(41);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n\tmutation deleteClientDocument($input: DeleteClientDocumentInput!) {\n\t\tDeleteClientDocument(input: $input) {\n\t\t\tclientMutationId\n\t\t}\n\t}\n'],['\n\tmutation deleteClientDocument($input: DeleteClientDocumentInput!) {\n\t\tDeleteClientDocument(input: $input) {\n\t\t\tclientMutationId\n\t\t}\n\t}\n']);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}/*eslint-disable*/var deleteMutation=__WEBPACK_IMPORTED_MODULE_13_graphql_tag___default()(_templateObject);var Wrapper=function Wrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["e" /* Card */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["f" /* CardContent */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{container:true,style:{marginBottom:'15px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:12,sm:12,md:10,style:{textAlign:'center',margin:'0px auto'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["Z" /* Typography */],{variant:'headline',gutterBottom:true},'Documents'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{borderBottom:'1px solid #cccccc69',margin:'5px auto',width:'15%',marginBottom:'20px'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["Z" /* Typography */],{variant:'subheading',gutterBottom:true},props.scd_name,' ',props.scd_surname)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:12,sm:12,md:10,style:{margin:'auto'}},props.children))));};var NoWrapper=function NoWrapper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{container:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:12,sm:12,md:12,style:{margin:'auto'}},props.children));};var ClientDocuments=function(_React$Component){_inherits(ClientDocuments,_React$Component);function ClientDocuments(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ClientDocuments);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ClientDocuments.__proto__||Object.getPrototypeOf(ClientDocuments)).call.apply(_ref,[this].concat(args))),_this),_this.state={openUploadDialog:false,alert:null,chosenFolderId:'',chosenFolderName:'',documentsUpdated:false,deleteDialogOpen:false,selectedDocumentForDeletion:{},panels:{},searchTerm:'',loadingDelete:false,errorDialogOpen:false,errorDialogMessage:'',savedQuotesOpen:true,quotesSearchTerm:'',savedQuotes:[],filteredQuotes:[],removeQuoteDialog:false,selectedSavedQuote:{}},_this.handelOpenUploadDialog=function(f){_this.setState({chosenFolderId:f.folder_Id,chosenFolderName:f.folder_Name,openUploadDialog:true});},_this.handelCloseUploadDialog=function(updateDocuments){_this.setState({openUploadDialog:false,chosenFolderId:'',chosenFolderName:'',documentsUpdated:updateDocuments});},_this.downloadFile=function(path){window.open(path,'_blank');},_this.togglePanel=function(id){var panels=Object.assign({},_this.state.panels);Object.keys(panels).map(function(key){if(parseInt(key)===id){panels[key].open=!panels[key].open;}else{panels[key].open=false;}});_this.setState({panels:panels});},_this.handleSearch=function(event,id){var panels=Object.assign({},_this.state.panels);panels[id].searchTerm=event.target.value;_this.setState({panels:panels});},_this.getopen=function(id){return _this.state.panels[id]&&_this.state.panels[id].open?true:false;},_this.successDelete=function(){_this.setState({alert:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_react_bootstrap_sweetalert___default.a,{success:true,title:'Deleted!',onConfirm:function onConfirm(){return _this.hideAlert();},onCancel:function onCancel(){return _this.hideAlert();},confirmBtnCssClass:_this.props.classes.button+' '+_this.props.classes.success},'File deleted successfully')});},_this.successAdd=function(){_this.setState({alert:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_react_bootstrap_sweetalert___default.a,{success:true,title:'File Uploaded!',onConfirm:function onConfirm(){return _this.hideAlert();},onCancel:function onCancel(){return _this.hideAlert();},confirmBtnCssClass:_this.props.classes.button+' '+_this.props.classes.success})});},_this.hideAlert=function(){_this.setState({alert:null});},_this.handleSearchSavedQuote=function(){var event=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;var values=_this.state.quotesSearchTerm.split(' ');if(event){_this.setState({quotesSearchTerm:event.target.value});values=event.target.value.split(' ');}var docData=_this.state.savedQuotes;var inc=['description','date_saved'];var filteredData=Object(__WEBPACK_IMPORTED_MODULE_19_helpers_Search__["a" /* SearchDataSet */])(docData,values,inc);_this.setState({filteredQuotes:filteredData});},_this.handleQuoteView=function(taskguid){sessionStorage.setItem('QuoteresultId',taskguid);_this.props.history.push({pathname:'/app/quoteresult',search:'guid='+taskguid});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ClientDocuments,[{key:'render',value:function render(){var _this2=this;var clientId=null;if(this.props.clientId){clientId=this.props.clientId;}else{var params=Object(__WEBPACK_IMPORTED_MODULE_22_helpers_UriReader__["a" /* ParseUriParams */])(this.props.location.search);clientId=params.clientId;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_apollo__["Query"],{query:__WEBPACK_IMPORTED_MODULE_5_queries_ClientDocuments__["a" /* getClientDocuments */],variables:{id:clientId,token:Object(__WEBPACK_IMPORTED_MODULE_8_helpers_UserHelper__["c" /* GetUserToken */])()},fetchPolicy:'network-only'},function(_ref2){var loading=_ref2.loading,error=_ref2.error,data=_ref2.data,refetch=_ref2.refetch;if(loading){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["B" /* LinearProgress */],null);}if(error&&error.message&&error.message==='GraphQL error: invalid token'){Object(__WEBPACK_IMPORTED_MODULE_8_helpers_UserHelper__["d" /* Logout */])();return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_router__["a" /* Redirect */],{to:'/app/portal/login'});}if(error)return'Error! '+error.message;if(_this2.state.documentsUpdated){_this2.setState({documentsUpdated:false});refetch();}var docData=data.ClientDocuments;var panels=Object.assign({},_this2.state.panels);if(Object.keys(_this2.state.panels).length<1){docData.folders.map(function(f,i){if(!panels[f.folder_Id]){panels[f.folder_Id]={open:i===0,searchTerm:''};}});_this2.setState({panels:panels});}if(_this2.state.savedQuotes.length!==docData.saved_quotes.length){_this2.setState({savedQuotes:docData.saved_quotes.slice()});}var savedQuotesData=[];if(_this2.state.quotesSearchTerm!==''){savedQuotesData=_this2.state.filteredQuotes.slice();}else{savedQuotesData=docData.saved_quotes.slice();}var body=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_apollo__["Mutation"],{mutation:deleteMutation,onCompleted:function onCompleted(docData){_this2.successDelete();_this2.setState({deleteDialogOpen:false,selectedDocumentForDeletion:{},loadingDelete:false});refetch();},onError:function onError(error){_this2.setState({errorDialogOpen:true,errorDialogMessage:Object(__WEBPACK_IMPORTED_MODULE_21_helpers_ErrorHelper__["a" /* ParseGraphqlError */])(error),loadingDelete:false});}},function(mutate){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["q" /* ExpansionPanel */],{expanded:_this2.state.savedQuotesOpen,onChange:function onChange(){var open=_this2.state.savedQuotesOpen;_this2.setState({savedQuotesOpen:!open});},style:{margin:'16px 0px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["s" /* ExpansionPanelSummary */],{expandIcon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_icons_ExpandMore___default.a,null)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["Z" /* Typography */],null,'Saved Quotes')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["r" /* ExpansionPanelDetails */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Grid_GridContainer_jsx__["a" /* default */],{style:{maxHeight:'35vh',overflowY:'auto'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:10,style:{margin:'auto',marginBottom:'2vh'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["X" /* TextField */],{fullWidth:true,style:{margin:'auto'},placeholder:'Search',onChange:function onChange(e){return _this2.handleSearchSavedQuote(e);},InputProps:{startAdornment:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["z" /* InputAdornment */],{position:'start'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["w" /* Icon */],null,'search'))}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:12},_this2.state.quotesSearchTerm!==''&&savedQuotesData.length===0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["Z" /* Typography */],{gutterBottom:true,variant:'caption'},'No results'):null,_this2.state.quotesSearchTerm===''&&_this2.state.savedQuotes.length===0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["Z" /* Typography */],{gutterBottom:true,variant:'caption'},'No saved quotes for this client yet.'):null),savedQuotesData.map(function(q,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:6,md:4,key:i},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__QuoteCard_jsx__["a" /* default */],{title:q.description,desc:q.date_saved.split(' ')[0],history:_this2.props.history,handleView:function handleView(){return _this2.handleQuoteView(q.fk_sq_taskguid);},handleRemove:function handleRemove(){_this2.setState({removeQuoteDialog:true,selectedSavedQuote:q});}}));})))),docData.folders.map(function(f,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["q" /* ExpansionPanel */],{expanded:_this2.getopen(f.folder_Id),key:i,onChange:function onChange(){return _this2.togglePanel(f.folder_Id);},style:{margin:'16px 0px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["s" /* ExpansionPanelSummary */],{expandIcon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_icons_ExpandMore___default.a,null)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["Z" /* Typography */],null,f.folder_Name)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["r" /* ExpansionPanelDetails */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Grid_GridContainer_jsx__["a" /* default */],{style:{maxHeight:'35vh',overflowY:'auto'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:10,style:{margin:'auto',marginBottom:'2vh'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["X" /* TextField */],{fullWidth:true,style:{margin:'auto'},placeholder:'Search',onChange:function onChange(e){return _this2.handleSearch(e,f.folder_Id);},InputProps:{startAdornment:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["z" /* InputAdornment */],{position:'start'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["w" /* Icon */],null,'search'))}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:12,style:{margin:'auto',textAlign:'center',marginBottom:'2vh'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["i" /* Chip */],{avatar:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["b" /* Avatar */],{style:{backgroundColor:'#6c5cab',color:'white'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["w" /* Icon */],null,'add')),className:'customChip',variant:'outlined',label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["Z" /* Typography */],{style:{color:'white'}},'Upload File'),color:'secondary',style:{backgroundColor:'#4239d659',color:'white'},onClick:function onClick(){return _this2.handelOpenUploadDialog(f);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:12},_this2.state.panels[f.folder_Id]&&_this2.state.panels[f.folder_Id].searchTerm!==''&&f.documents.filter(function(x){return x.cdoc_title.includes(_this2.state.panels[f.folder_Id].searchTerm);}).length===0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["Z" /* Typography */],{gutterBottom:true,variant:'caption'},'No results'):null,f.documents.length===0&&_this2.state.panels[f.folder_Id]&&_this2.state.panels[f.folder_Id].searchTerm===''?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["Z" /* Typography */],{gutterBottom:true,variant:'caption'},'There are no documents in this folder yet'):null),(_this2.state.panels[f.folder_Id]&&_this2.state.panels[f.folder_Id].searchTerm!==''?f.documents.filter(function(x){return x.cdoc_title.includes(_this2.state.panels[f.folder_Id].searchTerm);}):f.documents).map(function(d,di){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:6,md:4,key:di},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__FileCard_jsx__["a" /* default */],{imgSrc:'/assets/logo/file_types/'+Object(__WEBPACK_IMPORTED_MODULE_17_helpers_Documents_js__["b" /* getExtension */])(d.cdoc_path).replace('.','')+'.png',title:d.cdoc_title,desc:d.cdoc_desc,dateCreated:d.cdoc_datecreated,docPath:d.cdoc_path,downloadFile:_this2.downloadFile,deleteFile:function deleteFile(){_this2.setState({deleteDialogOpen:true,selectedDocumentForDeletion:d});}}));}))));}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__UploadModal_jsx__["a" /* default */],{open:_this2.state.openUploadDialog,closeDialog:_this2.handelCloseUploadDialog,clientId:clientId,name:docData.scd_name,surname:docData.scd_surname,folderName:_this2.state.chosenFolderName,folderId:_this2.state.chosenFolderId,added:_this2.successAdd}),_this2.state.deleteDialogOpen?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_react_bootstrap_sweetalert___default.a,{warning:true,style:{wordWrap:'break-word'},title:'Delete file: '+_this2.state.selectedDocumentForDeletion.cdoc_title+'?',onConfirm:function onConfirm(){mutate({variables:{input:{documentId:_this2.state.selectedDocumentForDeletion.id,documentPath:_this2.state.selectedDocumentForDeletion.cdoc_path,token:Object(__WEBPACK_IMPORTED_MODULE_8_helpers_UserHelper__["c" /* GetUserToken */])()}}});_this2.setState({loadingDelete:true});},onCancel:function onCancel(){_this2.setState({deleteDialogOpen:false,selectedDocumentForDeletion:{}});},confirmBtnCssClass:_this2.props.classes.button+' '+_this2.props.classes.success,cancelBtnCssClass:_this2.props.classes.button+' '+_this2.props.classes.danger,confirmBtnText:'Delete',cancelBtnText:'Cancel',showCancel:!_this2.state.loadingDelete,showConfirm:!_this2.state.loadingDelete},_this2.state.loadingDelete?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{textAlign:'center'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["j" /* CircularProgress */],{color:'secondary',size:30})):'You will not be able to recover this file!'):null,_this2.state.removeQuoteDialog?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_apollo__["Mutation"],{mutation:__WEBPACK_IMPORTED_MODULE_20_queries_document_mutations__["a" /* RemoveSavedQuote */],onCompleted:function onCompleted(data){_this2.successDelete();_this2.setState({removeQuoteDialog:false,selectedSavedQuote:{},loadingDelete:false});refetch();_this2.handleSearchSavedQuote();},onError:function onError(error){var msg=error.toString().replace('Error: ','').replace('GraphQL error: ','');_this2.setState({errorDialogOpen:true,errorDialogMessage:msg,loadingDelete:false});}},function(removeQuote){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_react_bootstrap_sweetalert___default.a,{warning:true,style:{wordWrap:'break-word'},title:'Remove Quote: '+_this2.state.selectedSavedQuote.description+'?',onConfirm:function onConfirm(){removeQuote({variables:{input:{id:_this2.state.selectedSavedQuote.id,token:Object(__WEBPACK_IMPORTED_MODULE_8_helpers_UserHelper__["c" /* GetUserToken */])()}}});_this2.setState({loadingDelete:true});},onCancel:function onCancel(){_this2.setState({removeQuoteDialog:false,selectedSavedQuote:{}});},confirmBtnCssClass:_this2.props.classes.button+' '+_this2.props.classes.success,cancelBtnCssClass:_this2.props.classes.button+' '+_this2.props.classes.danger,confirmBtnText:'Delete',cancelBtnText:'Cancel',showCancel:!_this2.state.loadingDelete,showConfirm:!_this2.state.loadingDelete},_this2.state.loadingDelete?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{textAlign:'center'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["j" /* CircularProgress */],{color:'secondary',size:30})):'This quote will be removed from your saved quotes, but you will still be able to view it in quote history.');}):null,_this2.state.alert,_this2.state.errorDialogOpen?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_react_bootstrap_sweetalert___default.a,{danger:true,title:'An error has occurred',onConfirm:function onConfirm(){_this2.setState({errorDialogOpen:false,errorDialogMessage:''});},onCancel:function onCancel(){_this2.setState({errorDialogOpen:false,errorDialogMessage:''});},confirmBtnCssClass:_this2.props.classes.button+' '+_this2.props.classes.info,confirmBtnText:'Ok'},_this2.state.errorDialogMessage):null);});if(_this2.props.clientId){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(NoWrapper,null,body);}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Wrapper,{scd_name:docData.scd_name,scd_surname:docData.scd_surname},body);});}}]);return ClientDocuments;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_15__material_ui_core_styles_withStyles___default()(__WEBPACK_IMPORTED_MODULE_14_assets_jss_material_dashboard_pro_react_views_sweetAlertStyle_jsx__["a" /* default */])(ClientDocuments));

/***/ }),
/* 2655 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getClientDocuments; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_graphql_tag__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_graphql_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_graphql_tag__);
var _templateObject=_taggedTemplateLiteral(["\n  query clientDocuments($id: String!, $token: String!) {\n    ClientDocuments(id: $id, token: $token) {\n      id\n      scd_name\n      scd_surname\n      folders {\n        folder_Id\n        folder_Name\n        documents {\n          id\n          cdoc_title\n          cdoc_desc\n          cdoc_path\n          cdoc_datecreated\n        }\n      },\n      saved_quotes{\n        id,\n        description,\n        fk_sq_taskguid,\n        fk_client_id,\n        date_saved\n      }\n    }\n  }\n"],["\n  query clientDocuments($id: String!, $token: String!) {\n    ClientDocuments(id: $id, token: $token) {\n      id\n      scd_name\n      scd_surname\n      folders {\n        folder_Id\n        folder_Name\n        documents {\n          id\n          cdoc_title\n          cdoc_desc\n          cdoc_path\n          cdoc_datecreated\n        }\n      },\n      saved_quotes{\n        id,\n        description,\n        fk_sq_taskguid,\n        fk_client_id,\n        date_saved\n      }\n    }\n  }\n"]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var getClientDocuments=__WEBPACK_IMPORTED_MODULE_0_graphql_tag___default()(_templateObject);

/***/ }),
/* 2656 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_form__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Wrappers_materialUIWrappers_components_FormInput__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_apollo__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_apollo_client__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dropzone__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_apollo_cache_inmemory__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_apollo_upload_client__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_graphql_tag__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_graphql_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_graphql_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_constants_js__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_helpers_Documents_js__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_store__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_Snackbar_Snackbar_jsx__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_assets_jss_material_dashboard_pro_react_views_sweetAlertStyle_jsx__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__material_ui_core_styles_withStyles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__material_ui_core_styles_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__material_ui_core_styles_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react_bootstrap_sweetalert__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react_bootstrap_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_react_bootstrap_sweetalert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_lodash__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_lodash__);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n\tmutation(\n\t\t$file: Upload!\n\t\t$id: String!\n\t\t$folder_name: String!\n\t\t$folder_id: String!\n\t\t$title: String!\n\t\t$description: String!\n\t) {\n\t\tuploadClientDocument(\n\t\t\tfile: $file\n\t\t\tid: $id\n\t\t\tfolder_name: $folder_name\n\t\t\tfolder_id: $folder_id\n\t\t\ttitle: $title\n\t\t\tdescription: $description\n\t\t)\n\t}\n'],['\n\tmutation(\n\t\t$file: Upload!\n\t\t$id: String!\n\t\t$folder_name: String!\n\t\t$folder_id: String!\n\t\t$title: String!\n\t\t$description: String!\n\t) {\n\t\tuploadClientDocument(\n\t\t\tfile: $file\n\t\t\tid: $id\n\t\t\tfolder_name: $folder_name\n\t\t\tfolder_id: $folder_id\n\t\t\ttitle: $title\n\t\t\tdescription: $description\n\t\t)\n\t}\n']);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var required=function required(value){return value?undefined:'Required';};var max25=function max25(value){return!value?undefined:value.length<26?undefined:'Max 25 characters';};var max55=function max55(value){return!value?undefined:value.length<56?undefined:'Max 55 characters';};var client=new __WEBPACK_IMPORTED_MODULE_5_apollo_client__["ApolloClient"]({link:Object(__WEBPACK_IMPORTED_MODULE_8_apollo_upload_client__["a" /* createUploadLink */])({uri:__WEBPACK_IMPORTED_MODULE_10_constants_js__["d" /* fileUploadServerPath */]}),cache:new __WEBPACK_IMPORTED_MODULE_7_apollo_cache_inmemory__["a" /* InMemoryCache */]()});var uploadFileMutation=__WEBPACK_IMPORTED_MODULE_9_graphql_tag___default()(_templateObject);var UploadModal=function(_React$Component){_inherits(UploadModal,_React$Component);function UploadModal(){var _ref;var _temp,_this,_ret;_classCallCheck(this,UploadModal);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=UploadModal.__proto__||Object.getPrototypeOf(UploadModal)).call.apply(_ref,[this].concat(args))),_this),_this.state={file:{},fileExtension:'',br:false,errorMessage:'',checkValidation:false,loading:false,errorDialogOpen:false,errorDialogMessage:''},_this.showNotification=function(place){if(!_this.state[place]){var x=[];x[place]=true;_this.setState(x);setTimeout(function(){x[place]=false;this.setState(x);this.setState({errorMessage:''});}.bind(_this),2000);}},_this.closeDialog=function(){_this.props.closeDialog(false);_this.setState({file:{},fileExtension:'',checkValidation:false,loading:false});__WEBPACK_IMPORTED_MODULE_12_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_2_redux_form__["c" /* destroy */])('upload'));},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(UploadModal,[{key:'componentDidMount',value:function componentDidMount(){this.setState({file:{},fileExtension:''});}},{key:'validateDocument',value:function validateDocument(file){var valid=Object(__WEBPACK_IMPORTED_MODULE_11_helpers_Documents_js__["d" /* validateFile */])(file.name,__WEBPACK_IMPORTED_MODULE_11_helpers_Documents_js__["a" /* documentTypes */]);var ext=Object(__WEBPACK_IMPORTED_MODULE_11_helpers_Documents_js__["b" /* getExtension */])(file.name);if(!valid){this.showNotification('br');this.setState({errorMessage:'Invalid file type'});}else{this.setState({file:file,fileExtension:ext});}}},{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_apollo__["Mutation"],{client:client,mutation:uploadFileMutation,onCompleted:function onCompleted(data){_this2.props.closeDialog(true);_this2.setState({file:{},fileExtension:'',checkValidation:false,loading:false});__WEBPACK_IMPORTED_MODULE_12_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_2_redux_form__["c" /* destroy */])('upload'));_this2.props.added();},onError:function onError(error){var msg=error.toString().replace('Error: ','').replace('GraphQL error: ','');_this2.setState({errorDialogOpen:true,errorDialogMessage:msg,loading:false});}},function(mutate){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["k" /* Dialog */],{open:_this2.props.open,onClose:function onClose(){return _this2.closeDialog();},className:'centerFixedDialog'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["o" /* DialogTitle */],{id:'form-dialog-title',style:{textAlign:'center'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["Z" /* Typography */],{variant:'title'},'Add document for ',_this2.props.name,' ',_this2.props.surname),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["Z" /* Typography */],{variant:'subheading'},'Folder: ',_this2.props.folderName)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["m" /* DialogContent */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["v" /* Grid */],{container:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["v" /* Grid */],{item:true,xs:12,sm:8,style:{margin:'auto'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{width:'100%',textAlign:'center'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_dropzone__["a" /* default */],{style:{height:'fit-content',border:'none',width:'100%',textAlign:'center'},onDrop:function onDrop(_ref2){var _ref3=_slicedToArray(_ref2,1),file=_ref3[0];_this2.validateDocument(file);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{border:'1px solid #b1b1b1',textAlign:'center',borderRadius:'15px',cursor:'pointer',display:'block',padding:'20px 60px'}},_this2.state.file.name&&_this2.state.fileExtension?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'/assets/logo/file_types/'+_this2.state.fileExtension.replace('.','')+'.png',alt:_this2.state.fileExtension,style:{width:'50px',height:'50px',marginBottom:'10px'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["Z" /* Typography */],null,_this2.state.file.name)):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["w" /* Icon */],{color:'primary',style:{fontSize:'70px'}},'cloud_upload'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["Z" /* Typography */],null,'Click to Choose File'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["Z" /* Typography */],null,'Or Drag Here')))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["v" /* Grid */],{item:true,xs:12,sm:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["t" /* FormControl */],{fullWidth:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_3_components_Wrappers_materialUIWrappers_components_FormInput__["a" /* default */],name:'title',label:'Title',isrequired:true,validate:[required,max25],checkValidation:_this2.state.checkValidation}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["v" /* Grid */],{item:true,xs:12,sm:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["t" /* FormControl */],{fullWidth:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_3_components_Wrappers_materialUIWrappers_components_FormInput__["a" /* default */],name:'description',label:'Description',isrequired:true,validate:[max55],checkValidation:_this2.state.checkValidation}))),_this2.state.loading?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["v" /* Grid */],{item:true,xs:12,sm:12,style:{textAlign:'center',margin:'40px 0px 0px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["j" /* CircularProgress */],{color:'secondary',size:30})):null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["l" /* DialogActions */],null,!_this2.state.loading?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["d" /* Button */],{color:'primary',onClick:function onClick(){return _this2.closeDialog();}},'Cancel'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["d" /* Button */],{color:'primary',onClick:function onClick(){var invalid=false;if(__WEBPACK_IMPORTED_MODULE_12_store__["a" /* default */].getState().form.upload.syncErrors){_this2.setState({checkValidation:true});invalid=true;}if(Object.keys(_this2.state.file).length<1){_this2.showNotification('br');_this2.setState({errorMessage:'No file selected'});invalid=true;}if(invalid)return;mutate({variables:{file:_this2.state.file,id:_this2.props.clientId,folder_name:_this2.props.folderName,folder_id:_this2.props.folderId.toString(),title:__WEBPACK_IMPORTED_MODULE_12_store__["a" /* default */].getState().form.upload.values.title,description:__WEBPACK_IMPORTED_MODULE_17_lodash___default.a.get(__WEBPACK_IMPORTED_MODULE_12_store__["a" /* default */].getState().form.upload,'values.description','')}});_this2.setState({loading:true});}},'Add')):null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_Snackbar_Snackbar_jsx__["a" /* default */],{place:'br',color:'danger',message:_this2.state.errorMessage,open:_this2.state.br,closeNotification:function closeNotification(){return _this2.setState({br:false});},close:true}));}),this.state.errorDialogOpen?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_react_bootstrap_sweetalert___default.a,{danger:true,title:'An error has occurred',onConfirm:function onConfirm(){_this2.setState({errorDialogOpen:false,errorDialogMessage:''});},onCancel:function onCancel(){_this2.setState({errorDialogOpen:false,errorDialogMessage:''});},confirmBtnCssClass:this.props.classes.button+' '+this.props.classes.info,confirmBtnText:'Ok'},this.state.errorDialogMessage):null);}}]);return UploadModal;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);UploadModal=Object(__WEBPACK_IMPORTED_MODULE_2_redux_form__["e" /* reduxForm */])({form:'upload',destroyOnUnmount:true})(UploadModal);/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_15__material_ui_core_styles_withStyles___default()(__WEBPACK_IMPORTED_MODULE_14_assets_jss_material_dashboard_pro_react_views_sweetAlertStyle_jsx__["a" /* default */])(UploadModal));

/***/ }),
/* 2657 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_core__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
var fileCard=function fileCard(props){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["e" /* Card */],{style:{padding:"10px 0px",margin:"10px 0px"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["f" /* CardContent */],{style:{paddingLeft:"10px",paddingBottom:"0px",position:"relative"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{gutterBottom:true,variant:"caption",style:{position:"absolute",top:"0px",right:"10px"}},props.dateCreated.split("T")[0]),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{style:{display:"flex"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img",{src:props.imgSrc,alt:"fileType",style:{width:"45px",height:"45px"}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{style:{marginLeft:"15px",width:"70%"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{gutterBottom:true,style:{wordWrap:"break-word"}},props.title),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{gutterBottom:true,variant:"caption",style:{wordWrap:"break-word"}},props.desc))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{style:{display:"flex",marginTop:"15px"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{container:true,justify:"space-between"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{item:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["d" /* Button */],{size:"small",mini:true,onClick:function onClick(){return props.downloadFile(props.docPath);},color:"secondary"},"Download")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{item:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["d" /* Button */],{size:"small",mini:true,onClick:function onClick(){return props.deleteFile();},style:{color:"red"}},"Delete"))))));};/* harmony default export */ __webpack_exports__["a"] = (fileCard);

/***/ }),
/* 2658 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_core__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
var QuoteCard=function QuoteCard(props){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["e" /* Card */],{style:{padding:"10px 0px",margin:"10px 0px"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["f" /* CardContent */],{style:{paddingLeft:"10px",paddingBottom:"0px"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{style:{display:"flex"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["w" /* Icon */],{style:{width:"40px",height:"40px",fontSize:"40px"}},"assignment"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{style:{marginLeft:"15px",width:"70%"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{gutterBottom:true,style:{wordWrap:"break-word"}},props.title),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{gutterBottom:true,variant:"caption",style:{wordWrap:"break-word"}},props.desc))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{style:{display:"flex",marginTop:"15px"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{container:true,justify:"space-between"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{item:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["d" /* Button */],{size:"small",mini:true,color:"secondary",onClick:props.handleView},"View")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{item:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["d" /* Button */],{size:"small",mini:true,style:{color:"red"},onClick:props.handleRemove},"Remove"))))));};/* harmony default export */ __webpack_exports__["a"] = (QuoteCard);

/***/ }),
/* 2659 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RemoveSavedQuote; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_graphql_tag__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_graphql_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_graphql_tag__);
var _templateObject=_taggedTemplateLiteral(["\nmutation removeSavedQuote($input: RemoveSavedQuoteInput!) {\n    RemoveSavedQuote(input: $input) {\n      clientMutationId\n    }\n  }\n  "],["\nmutation removeSavedQuote($input: RemoveSavedQuoteInput!) {\n    RemoveSavedQuote(input: $input) {\n      clientMutationId\n    }\n  }\n  "]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var RemoveSavedQuote=__WEBPACK_IMPORTED_MODULE_0_graphql_tag___default()(_templateObject);

/***/ }),
/* 2660 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_core__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_assets_img_faces_avatar1_jpg__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_assets_img_faces_avatar1_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_assets_img_faces_avatar1_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_Grid_GridItem_jsx__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_helpers_UserHelper__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_queries_clients_queries__ = __webpack_require__(417);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_apollo__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__maps_QuoteFieldMap__ = __webpack_require__(2661);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var LeftRight=function LeftRight(props){return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_Grid_GridItem_jsx__["a" /* default */],{xs:6,sm:6,md:6,style:props.style},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{variant:"body1",style:{textAlign:"right",fontWeight:"500",color:"rgba(0, 0, 0, 0.54)"}},props.left)),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_Grid_GridItem_jsx__["a" /* default */],{xs:6,sm:6,md:6,style:props.style},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{variant:"body2",style:{textAlign:"left",wordBreak:"break-word"}},props.right)));};var LeftLeft=function LeftLeft(props){return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{container:true,style:{marginBottom:"10px"}},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{item:true,xs:4,sm:4,md:4,style:Object.assign({},props.style,{paddingRight:"5px"})},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{variant:"body1",style:{textAlign:"Left",fontWeight:"500",color:"rgba(0, 0, 0, 0.54)"}},props.left)),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{item:true,xs:8,sm:8,md:8,style:Object.assign({},props.style,{paddingLeft:"5px"})},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{variant:"body2",style:{textAlign:"left",wordBreak:"break-word"}},getMappedOrDefault(props.right)?getMappedOrDefault(props.right):"N/A")));};var getMappedOrDefault=function getMappedOrDefault(value){if(!value)return null;var mapped=__WEBPACK_IMPORTED_MODULE_7__maps_QuoteFieldMap__["a" /* default */][value];if(mapped)return mapped;return value;};var ClientDetailCard=function(_React$Component){_inherits(ClientDetailCard,_React$Component);function ClientDetailCard(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ClientDetailCard);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ClientDetailCard.__proto__||Object.getPrototypeOf(ClientDetailCard)).call.apply(_ref,[this].concat(args))),_this),_this.state={showQuoteDetails:false},_this.toggleShowQuoteDetails=function(){_this.setState(function(prevState){return{showQuoteDetails:!prevState.showQuoteDetails};});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ClientDetailCard,[{key:"render",value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_apollo__["Query"],{query:__WEBPACK_IMPORTED_MODULE_4_queries_clients_queries__["b" /* ClientProfileSummary */],variables:{id:this.props.clientId,token:Object(__WEBPACK_IMPORTED_MODULE_3_helpers_UserHelper__["c" /* GetUserToken */])()},fetchPolicy:"network-only"},function(_ref2){var loading=_ref2.loading,error=_ref2.error,data=_ref2.data,refetch=_ref2.refetch;if(loading){return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["e" /* Card */],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["f" /* CardContent */],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["B" /* LinearProgress */],null)," "));}var client=data.ClientProfileSummary;return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["e" /* Card */],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["f" /* CardContent */],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{variant:"title",style:{textAlign:"center",margin:"auto"}},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("span",{style:{textTransform:"capitalize"}},client.scd_title?client.scd_title.toLowerCase():""),". ",client.scd_name," ",client.scd_surname),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("div",{style:{marginTop:"15px",width:"100%",textAlign:"center",display:"block"}},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("img",{className:"avatarImg",src:client.scd_pp_path&&client.scd_pp_path.trim!==""?client.scd_pp_path:__WEBPACK_IMPORTED_MODULE_1_assets_img_faces_avatar1_jpg___default.a,alt:"...",style:{margin:"0px auto",width:"100px",height:"100px",objectFit:"cover"}})),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{container:true,style:{marginTop:"30px"}},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(LeftRight,{left:"Name",right:client.scd_name}),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(LeftRight,{left:"Surname",right:client.scd_surname}),client.scd_initials?__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(LeftRight,{left:"Initials",right:client.scd_initials}):null,client.scd_email?__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(LeftRight,{left:"Email",right:client.scd_email}):null,client.scd_cellNumber?__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(LeftRight,{left:"Cell Number",right:client.scd_cellNumber}):null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(LeftRight,{style:{marginTop:"15px"},left:"Active/Prospect",right:client.scd_clientType==="active"?__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],null,"Active"):client.scd_clientType==="prospect"?__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],null,"Prospect"):__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],null,"N/A")}),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(LeftRight,{left:"App Status",right:client.app_active===1?__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],null,"Active"):client.invite_sent===1?__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],null,"Invite Sent"):__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],null,"Not Active")})),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("div",{style:{textAlign:"center",marginTop:"15px",display:"block"}},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["d" /* Button */],{fullWidth:true,variant:"contained",color:"secondary",style:{margin:"10px auto 10px auto",width:"65%"},onClick:function onClick(){return _this2.props.history.push({pathname:"/app/EditClient",search:"clientId="+_this2.props.clientId});}},"Edit Client"),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["d" /* Button */],{fullWidth:true,variant:"outlined",color:"primary",style:{margin:"10px auto 10px auto",width:"65%"},onClick:_this2.toggleShowQuoteDetails},(!_this2.state.showQuoteDetails?"Show":"Hide")+" Quote Related Fields")))),!_this2.state.showQuoteDetails?null:__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["e" /* Card */],{style:{margin:"10px auto 10px auto"}},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["f" /* CardContent */],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{variant:"subheading",className:"centerCell",style:{marginBottom:"15px"}},"Other Quoting Related Fields"),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(LeftLeft,{left:"Date of birth",right:client.scd_dateOfBirth}),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(LeftLeft,{left:"Gender",right:client.scd_gender}),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(LeftLeft,{left:"Smoker",right:client.scd_smoker}),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(LeftLeft,{left:"Marital Status",right:client.scd_maritalStatus}),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(LeftLeft,{left:"Occupation",right:client.scd_occupation}),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(LeftLeft,{left:"Highest qualification",right:client.scd_qualification}),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(LeftLeft,{left:"Self Employed",right:client.scd_selfEmployed}),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(LeftLeft,{left:"Commission or Fixed Salary",right:client.scd_salaryType}),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(LeftLeft,{left:"Monthly income",right:client.scd_monthlyIncome?"R"+client.scd_monthlyIncome:null}),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(LeftLeft,{left:"Tax dispensation",right:client.scd_taxDispensation}),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(LeftLeft,{left:"Spouse Monthly Income",right:client.scd_spouseIncome?"R"+client.scd_spouseIncome:null}),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(LeftLeft,{left:"Admin",right:client.scd_pAdmin?client.scd_pAdmin+"%":null}),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(LeftLeft,{left:"Travel",right:client.scd_pTravel?client.scd_pTravel+"%":null}),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(LeftLeft,{left:"Manual Labour",right:client.scd_pManual?client.scd_pManual+"%":null}),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(LeftLeft,{left:"Supervision",right:client.scd_pSupervision?client.scd_pSupervision+"%":null}))));});}}]);return ClientDetailCard;}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (ClientDetailCard);

/***/ }),
/* 2661 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({M:"Male",F:"Female",Y:"Yes",N:"No",LessThanMatric:"Less than matric",Matric:"Matric","3-yearDiploma":"3-year diploma","3-yearDegreeOr4-yearDiploma":"3-year degree / 4-year diploma","4-yearDegreeOrProfessional":"4-year degree / Professional",commission:"Commission",fixed:"Fixed",NaturalPerson:"Natural person",TaxPayingInstitution:"Tax-paying institution",TaxExemptInstitution:"Tax-exempt institution",Trust:"Trust"});

/***/ }),
/* 2662 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_core__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_Divider__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_Divider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Divider__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_List__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_List___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_List__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_ListItem__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_ListItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_ListItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_ListItemText__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_ListItemText___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_ListItemText__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_EnhancedTableHead_EnhancedTableHead_jsx__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_Table_EmptyBody_jsx__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_helpers_UserHelper__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_queries_quotes_queries__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_apollo__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_router__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_CustomChip_CustomChip_jsx__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_queries_QuoteEligibility__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__material_ui_core_Grid__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__material_ui_core_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__material_ui_core_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react_bootstrap_sweetalert__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react_bootstrap_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_react_bootstrap_sweetalert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_assets_jss_material_dashboard_pro_react_views_sweetAlertStyle_jsx__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__material_ui_core_styles_withStyles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__material_ui_core_styles_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__material_ui_core_styles_withStyles__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var columnData=[{id:'edit',numeric:false,disablePadding:true,label:'',noSort:true,width:'30px'},{id:'description',numeric:false,disablePadding:true,label:'Description',noSort:true},{id:'t.date_created',numeric:false,disablePadding:true,label:'Date Created',noSort:true}];var QuotesTab=function(_React$Component){_inherits(QuotesTab,_React$Component);function QuotesTab(){var _ref;var _temp,_this,_ret;_classCallCheck(this,QuotesTab);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=QuotesTab.__proto__||Object.getPrototypeOf(QuotesTab)).call.apply(_ref,[this].concat(args))),_this),_this.state={openMenus:[],openMenusPage:0,anchorTop:0,anchorLeft:0,popoverOpen:false,assistantActive:false,eligibilityDialogOpen:false,invalidFields:[],selectedClient:{}},_this.handleClick=function(event,id){_this.setState({anchorTop:event.clientY,anchorLeft:event.clientX});var openMenus=_this.state.openMenus.slice();openMenus.filter(function(x){return x.id===id;})[0].open=true;_this.setState({openMenus:openMenus,popoverOpen:true});},_this.handleClose=function(id){var openMenus=_this.state.openMenus.slice();openMenus.filter(function(x){return x.id===id;})[0].open=false;_this.setState({openMenus:openMenus,popoverOpen:false});},_this.handleCloseAll=function(){var openMenus=_this.state.openMenus.slice();openMenus=openMenus.map(function(x){return x.open===false;});_this.setState({openMenus:openMenus,popoverOpen:false});},_this.getBrokerId=function(){var brokerId=Object(__WEBPACK_IMPORTED_MODULE_7_helpers_UserHelper__["a" /* GetUserId */])();if(_this.checkAssistantActive()){brokerId=sessionStorage.getItem('ActiveBrokerId');}return brokerId;},_this.getBrokerName=function(){return sessionStorage.getItem('ActiveBrokerName');},_this.handleNewQuote=function(clientId){_this.props.history.push({pathname:'/app/quote/',search:'clientId='+clientId});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(QuotesTab,[{key:'handleView',value:function handleView(quote){this.props.history.push({pathname:'/app/quoteresult',search:'guid='+quote.sq_taskguid});}},{key:'handleEdit',value:function handleEdit(clientId,guid){this.props.history.push({pathname:'/app/quote/',search:'clientId='+clientId+'&guid='+guid});}},{key:'checkAssistantActive',value:function checkAssistantActive(){if(Object(__WEBPACK_IMPORTED_MODULE_7_helpers_UserHelper__["b" /* GetUserKey */])('userType')==='6'){if(!this.state.assistantActive){this.setState({assistantActive:true});}return true;}return false;}},{key:'render',value:function render(){var _this2=this;var colSpan=Object.keys(columnData).length;var _props=this.props,clientId=_props.clientId,clientName=_props.clientName;return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react_apollo__["Query"],{query:__WEBPACK_IMPORTED_MODULE_8_queries_quotes_queries__["c" /* GetQuoteHistory */],variables:{brokerId:this.getBrokerId(),token:Object(__WEBPACK_IMPORTED_MODULE_7_helpers_UserHelper__["c" /* GetUserToken */])(),limit:7,page:0,clientId:clientId},fetchPolicy:'network-only'},function(_ref2){var loading=_ref2.loading,error=_ref2.error,data=_ref2.data,refetch=_ref2.refetch;if(loading){return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["B" /* LinearProgress */],null);}if(error&&error.message&&error.message==='GraphQL error: invalid token'){Object(__WEBPACK_IMPORTED_MODULE_7_helpers_UserHelper__["d" /* Logout */])();return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_router__["a" /* Redirect */],{to:'/app/portal/login'});}if(error)return'Error! '+error.message;var items=data.QuoteHistory.Results;if(items&&_this2.state.openMenus.length!==items.length){var openMenus=[];items.map(function(q){openMenus.push({open:false,id:q.sq_taskguid});return q;});_this2.setState({openMenus:openMenus});}return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react_apollo__["Mutation"],{mutation:__WEBPACK_IMPORTED_MODULE_13_queries_QuoteEligibility__["a" /* QuoteEligibility */],onCompleted:function onCompleted(data){var quoteEligibility=data.QuoteEligibility;if(!quoteEligibility.valid){var invalidFields=quoteEligibility.invalidFields.split(',');_this2.setState({eligibilityDialogOpen:true,invalidFields:invalidFields,selectedClient:_this2.props.clientName});}else{_this2.handleNewQuote(clientId);}}},function(mutate){return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_CustomChip_CustomChip_jsx__["a" /* default */],{text:'Create Quote',icon:'add',clicked:function clicked(){return mutate({variables:{input:{clientId:clientId}}});},style:{margin:'25px auto 15px auto'}});}),__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["I" /* Paper */],{style:{overflowX:'auto'}},__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Q" /* Table */],null,__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_EnhancedTableHead_EnhancedTableHead_jsx__["a" /* default */],{order:_this2.props.order,orderBy:_this2.props.orderBy,onRequestSort:function onRequestSort(event,property){return _this2.props.handleRequestSort(event,property);},rowCount:_this2.props.items?_this2.props.items.length:0,columnData:columnData}),__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["R" /* TableBody */],null,' ',__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react___default.a.Fragment,null,items.length<1?__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Table_EmptyBody_jsx__["a" /* default */],{colSpan:colSpan,rowSpan:3,placeHolder:__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{variant:'subheading'},'No Quotes created yet. Click on Create Quote')}):__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react___default.a.Fragment,null,items.map(function(quote){var openMenus=_this2.state.openMenus.length>0;var openMenu=null;if(openMenus){openMenu=_this2.state.openMenus.find(function(m){return m.id===quote.sq_taskguid;});}return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],{className:'sqDataTable',key:quote.id,onClick:function onClick(e){return _this2.state.popoverOpen===false?_this2.handleClick(e,quote.sq_taskguid):null;},style:openMenu&&openMenu.open?{backgroundColor:'#dedede'}:{}},__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{style:{padding:'0px',borderRight:'1px solid #e0e0e0',backgroundColor:'white'}},__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["x" /* IconButton */],{onClick:function onClick(e){return _this2.state.popoverOpen===false?_this2.handleClick(e,quote.sq_taskguid):null;}},__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["w" /* Icon */],null,'more_vert'))),__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,quote.description),__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,quote.date_created),__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["J" /* Popover */],{open:openMenu?openMenu.open:false,anchorReference:'anchorPosition',anchorPosition:{left:_this2.state.anchorLeft,top:_this2.state.anchorTop},onClose:function onClose(){return _this2.handleClose(quote.sq_taskguid);}},__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_List___default.a,{component:'nav'},__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_ListItem___default.a,{button:true,onClick:function onClick(){return _this2.handleView(quote);}},__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_ListItemText___default.a,{primary:'View Results'})),__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Divider___default.a,null),__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react_apollo__["Mutation"],{mutation:__WEBPACK_IMPORTED_MODULE_13_queries_QuoteEligibility__["a" /* QuoteEligibility */],onCompleted:function onCompleted(data){var quoteEligibility=data.QuoteEligibility;if(!quoteEligibility.valid){var invalidFields=quoteEligibility.invalidFields.split(',');_this2.setState({eligibilityDialogOpen:true,invalidFields:invalidFields,selectedClient:quote.fullName});}else{_this2.handleEdit(quote.fk_clientID,quote.sq_taskguid);}}},function(mutate){return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_ListItem___default.a,{button:true,divider:true,onClick:function onClick(){return mutate({variables:{input:{clientId:quote.fk_clientID}}});}},__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_ListItemText___default.a,{primary:'Edit Quote'}));}))));})))))),__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{variant:'subheading',style:{color:'#0000008a',marginTop:'15px'},className:'typographyLinkBasic',onClick:function onClick(){_this2.props.history.push({pathname:'/app/history',search:'clientId='+clientId+'&clientName='+clientName});}},'View all Quotes'),_this2.state.eligibilityDialogOpen?__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_react_bootstrap_sweetalert___default.a,{warning:true,style:{wordWrap:'break-word',top:'40%'},title:'Ineligible',confirmBtnCssClass:_this2.props.classes.button+' '+_this2.props.classes.success,cancelBtnCssClass:_this2.props.classes.button+' '+_this2.props.classes.danger,confirmBtnText:'Edit Client',cancelBtnText:'Close',onConfirm:function onConfirm(){_this2.handleEditClient();},onCancel:function onCancel(){_this2.setState({eligibilityDialogOpen:false});},showCancel:!_this2.state.loadingDelete,showConfirm:!_this2.state.loadingDelete},__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],null,_this2.state.selectedClient,'is ineligible for a quote.'),__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],null,'Please update the following fields: '),__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__material_ui_core_Grid___default.a,{container:true,className:'invalidListBlock'},_this2.state.invalidFields.map(function(i){return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__material_ui_core_Grid___default.a,{item:true,xs:12,sm:6,md:6},__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],null,i));}))):null);});}}]);return QuotesTab;}(__WEBPACK_IMPORTED_MODULE_9_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_17__material_ui_core_styles_withStyles___default()(__WEBPACK_IMPORTED_MODULE_16_assets_jss_material_dashboard_pro_react_views_sweetAlertStyle_jsx__["a" /* default */])(QuotesTab));

/***/ }),
/* 2663 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_core__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_Typography__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_Typography___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Typography__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_Card_Card_jsx__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Card_CardHeader_jsx__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_EasyRange_EasyRange_jsx__ = __webpack_require__(2664);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_Grid_GridContainer_jsx__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_Grid_GridItem_jsx__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_SpaceDisplay_SpaceDisplay_jsx__ = __webpack_require__(626);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_helpers_DateHelpers__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_helpers_UserHelper__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_queries_Subscription_queries__ = __webpack_require__(627);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_apollo__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_react_apollo__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/*eslint-disable*/// core components
var pricePlans={Basic:["CRM Tool","Client App","Free Assistant User"],Standard:["All Basic package features","Quoting Platform","Astute Integration"],Premium:["All Basic + Standard package features","FNA, BNA & Will Generation","Invoice Management"]};var PricePlanMap={1:"Basic",2:"Standard",3:"Premium",4:"Trial"};var priceTableFirst12={level1:{basic:395,standard:545,premium:695},level2:{basic:345,standard:495,premium:625},level3:{basic:275,standard:415,premium:545}};var priceTableAfter12={level1:{basic:595,standard:795,premium:995},level2:{basic:495,standard:695,premium:895},level3:{basic:395,standard:595,premium:795}};var EditSubscription=function(_Component){_inherits(EditSubscription,_Component);function EditSubscription(){var _ref;var _temp,_this,_ret;_classCallCheck(this,EditSubscription);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=EditSubscription.__proto__||Object.getPrototypeOf(EditSubscription)).call.apply(_ref,[this].concat(args))),_this),_this.state={subscriptionInfoInitiated:false,priceplanItem:"Standard",brokerAmount:0,subscription:{currentLevel:1,brokers:{basic:0,standard:0,premium:0},amounts:{basic:0,standard:0,premium:0},freeAssistants:0,extraAssistants:0,userPlan:"basic",totalPrice:0.0,totalPriceAfter12:0.0,payment:{next:"N/A"},within_twelve_month_period:true,twelth_month_date:""},currentSubscription:{currentLevel:1,brokers:{basic:0,standard:0,premium:0},amounts:{basic:0,standard:0,premium:0},freeAssistants:0,extraAssistants:0,userPlan:"basic",totalPrice:0.0,totalPriceAfter12:0.0,payment:{next:"N/A"},within_twelve_month_period:true,twelth_month_date:""}},_this.getTotalBrokersForcurrentSubscription=function(){var total=0;Object.keys(_this.state.currentSubscription.brokers).map(function(b){total+=_this.state.currentSubscription.brokers[b];});return total;},_this.calculatePackage=function(packageName,subscription){var brokerCount=0;Object.keys(subscription.brokers).map(function(b){brokerCount+=subscription.brokers[b];});if(brokerCount<3){subscription.currentLevel=1;}else if(brokerCount<51){subscription.currentLevel=2;}else{subscription.currentLevel=3;}var count=subscription.brokers[packageName];var am=null;if(subscription.within_twelve_month_period){am=priceTableFirst12["level"+subscription.currentLevel][packageName];}else{am=priceTableAfter12["level"+subscription.currentLevel][packageName];}subscription.amounts[packageName]=count*am;return subscription;},_this.calculateAmounts=function(subscription){//Free Assistants calculation
var total=0;Object.keys(subscription.brokers).map(function(b){total+=subscription.brokers[b];});subscription.freeAssistants=total;//GrandTotal Calculation
var before12Total=0.0;var after12Total=0.0;Object.keys(subscription.brokers).map(function(a){before12Total+=priceTableFirst12["level"+subscription.currentLevel][a]*subscription.brokers[a];after12Total+=priceTableAfter12["level"+subscription.currentLevel][a]*subscription.brokers[a];});var extraAssistantsTotal=subscription.extraAssistants*200.0;subscription.totalPrice=before12Total+extraAssistantsTotal;subscription.totalPriceAfter12=after12Total+extraAssistantsTotal;return subscription;},_this.brokerAmountChange=function(event,packageName){if(!isNaN(event.target.value)&&event.target.value!==""){var subscription=Object.assign({},_this.state.subscription);subscription.brokers[packageName]=parseInt(event.target.value);subscription=_this.calculatePackage(packageName,subscription);subscription=_this.calculateAmounts(subscription);_this.setState({subscription:subscription});}},_this.brokerPlus=function(packageName){var subscription=Object.assign(_this.state.subscription);subscription.brokers[packageName]=subscription.brokers[packageName]+1;subscription=_this.calculatePackage(packageName,subscription);subscription=_this.calculateAmounts(subscription);_this.setState({subscription:subscription});},_this.brokerMinus=function(packageName){var subscription=Object.assign({},_this.state.subscription);subscription.brokers[packageName]=subscription.brokers[packageName]!==0?subscription.brokers[packageName]-1:0;subscription=_this.calculatePackage(packageName,subscription);subscription=_this.calculateAmounts(subscription);_this.setState({subscription:subscription});},_this.extraAssistantAmountChange=function(event){if(!isNaN(event.target.value)&&event.target.value!==""){var subscription=Object.assign({},_this.state.subscription);subscription.extraAssistants=parseInt(event.target.value);subscription=_this.calculateAmounts(subscription);_this.setState({subscription:subscription});}},_this.extraAssistantsPlus=function(){var subscription=Object.assign({},_this.state.subscription);subscription.extraAssistants=subscription.extraAssistants+1;subscription=_this.calculateAmounts(subscription);_this.setState({subscription:subscription});},_this.extraAssistantsMinus=function(){var subscription=Object.assign({},_this.state.subscription);if(subscription.extraAssistants===0)return;subscription.extraAssistants=subscription.extraAssistants-1;subscription=_this.calculateAmounts(subscription);_this.setState({subscription:subscription});},_this.getNextDebitOrderAmount=function(){var totalPrice=_this.state.subscription.totalPrice;if(_this.state.subscription.payment.next){var nextPaymentDate=new Date(_this.state.subscription.payment.next);var now=new Date();var diffInDays=Object(__WEBPACK_IMPORTED_MODULE_8_helpers_DateHelpers__["d" /* calcDiffInDays */])(nextPaymentDate,now);var restMonthAmount=totalPrice*(diffInDays/30);return restMonthAmount.toFixed(2);}else{return totalPrice;}},_this.buildSubscriptionObj=function(subscriptionInfo){var level=_this.getLevel(subscriptionInfo);var amounts=_this.getPackageAmounts(subscriptionInfo,level);var subscriptionObj={currentLevel:level,brokers:{basic:subscriptionInfo.sd_basic_brokers,standard:subscriptionInfo.sd_standard_brokers,premium:subscriptionInfo.sd_premium_brokers},amounts:amounts,freeAssistants:subscriptionInfo.sd_free_assistants,extraAssistants:subscriptionInfo.sd_extra_assistants,userPlan:PricePlanMap[subscriptionInfo.sd_brokerage_user_plan],totalPrice:subscriptionInfo.sd_price_pm,totalPriceAfter12:0.0,payment:{next:subscriptionInfo.sd_next_payment},within_twelve_month_period:true,twelth_month_date:subscriptionInfo.sd_twelth_month_end};subscriptionObj=_this.calculateAmounts(subscriptionObj);return subscriptionObj;},_this.differenceExists=function(){return _this.state.subscription.brokers.basic!==_this.state.currentSubscription.brokers.basic||_this.state.subscription.brokers.standard!==_this.state.currentSubscription.brokers.standard||_this.state.subscription.extraAssistants!==_this.state.currentSubscription.extraAssistants;},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(EditSubscription,[{key:"getLevel",value:function getLevel(subscriptionInfo){var brokerCount=subscriptionInfo.sd_basic_brokers+subscriptionInfo.sd_standard_brokers+subscriptionInfo.sd_premium_brokers;if(brokerCount<3){return 1;}else if(brokerCount<51){return 2;}else{return 3;}}},{key:"getPackageAmounts",value:function getPackageAmounts(subscriptionInfo,level){var amounts={basic:priceTableFirst12["level"+level].basic*subscriptionInfo.sd_basic_brokers,standard:priceTableFirst12["level"+level].standard*subscriptionInfo.sd_standard_brokers,premium:priceTableFirst12["level"+level].premium*subscriptionInfo.sd_premium_brokers};return amounts;}},{key:"render",value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react_apollo__["Query"],{query:__WEBPACK_IMPORTED_MODULE_10_queries_Subscription_queries__["a" /* SubscriptionInfo */],variables:{userId:Object(__WEBPACK_IMPORTED_MODULE_9_helpers_UserHelper__["a" /* GetUserId */])(),token:Object(__WEBPACK_IMPORTED_MODULE_9_helpers_UserHelper__["c" /* GetUserToken */])()},fetchPolicy:"network-only"},function(_ref2){var loading=_ref2.loading,error=_ref2.error,data=_ref2.data,refetch=_ref2.refetch;if(loading){return __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["B" /* LinearProgress */],null);}if(!_this2.state.subscriptionInfoInitiated){var subscriptionInfo=data.SubscriptionInfo;_this2.setState({subscription:Object.assign({},_this2.buildSubscriptionObj(subscriptionInfo)),currentSubscription:Object.assign({},_this2.buildSubscriptionObj(subscriptionInfo)),subscriptionInfoInitiated:true});}return __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Grid_GridContainer_jsx__["a" /* default */],{style:{maxHeight:"45vh",overflowY:"auto",borderBottom:"1px solid #e2e2e2",boxShadow:"0px 8px 8px -5px rgba(0, 0, 0, 0.14)"}},__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:4,style:{height:"90%"}},__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_Card_Card_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Card_CardHeader_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_SpaceDisplay_SpaceDisplay_jsx__["a" /* default */],{left:__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Typography___default.a,{variant:"subheading",gutterBottom:true},"Basic"),right:__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Typography___default.a,{variant:"caption",gutterBottom:true},"R",priceTableFirst12["level"+_this2.state.subscription.currentLevel]["basic"]," ","p/m")})),__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["f" /* CardContent */],null,__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement("div",{style:{display:"block"}},__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_SpaceDisplay_SpaceDisplay_jsx__["a" /* default */],{style:{borderBottom:"1px solid #cccccc69",paddingBottom:"12px",marginBottom:"10px"},left:__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Typography___default.a,{style:{position:"relative",top:"5px"}},"Amount of brokers:"),right:__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_EasyRange_EasyRange_jsx__["a" /* default */],{number:_this2.state.subscription.brokers.basic,change:function change(e){return _this2.brokerAmountChange(e,"basic");},plus:function plus(){return _this2.brokerPlus("basic");},minus:function minus(){return _this2.brokerMinus("basic");}})}),__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Typography___default.a,{variant:"body2",gutterBottom:true},"Includes:"),__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Typography___default.a,null,pricePlans.Basic.slice(0,3).map(function(p){return __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement("span",null,p,__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement("br",null));})),pricePlans.Basic.length>3?__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Typography___default.a,{className:"typographyLink",onClick:function onClick(){_this2.setState({priceplanItem:"Basic"});_this2.handleClickOpenDialog("priceplanDetailDialog");}},"View All Features..."):null,__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement("div",{style:{borderBottom:"1px solid #cccccc69",paddingBottom:"12px",marginBottom:"10px"}}),__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement("div",{style:{display:"grid"}},__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Typography___default.a,null,__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement("span",{style:{float:"left"}},_this2.state.subscription.brokers.basic===_this2.state.currentSubscription.brokers.basic?"Current Price:":"Updated Price:"),__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement("span",{style:{float:"right"}},__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement("strong",null,"R",_this2.state.subscription.amounts.basic))),_this2.state.subscription.brokers.basic<_this2.state.currentSubscription.brokers.basic?__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Typography___default.a,{style:{color:"orange"}},"*NB: Selected changes will take effect after next Debit Order Date"):null))))),__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:4,style:{height:"88%"}},__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_Card_Card_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Card_CardHeader_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_SpaceDisplay_SpaceDisplay_jsx__["a" /* default */],{left:__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Typography___default.a,{variant:"subheading",gutterBottom:true},"Standard"),right:__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Typography___default.a,{variant:"caption",gutterBottom:true},"R",priceTableFirst12["level"+_this2.state.subscription.currentLevel].standard," ","p/m")})),__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["f" /* CardContent */],null,__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement("div",{style:{display:"block"}},__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_SpaceDisplay_SpaceDisplay_jsx__["a" /* default */],{style:{borderBottom:"1px solid #cccccc69",paddingBottom:"12px",marginBottom:"10px"},left:__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Typography___default.a,{style:{position:"relative",top:"5px"}},"Amount of brokers:"),right:__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_EasyRange_EasyRange_jsx__["a" /* default */],{number:_this2.state.subscription.brokers.standard,change:function change(e){return _this2.brokerAmountChange(e,"standard");},plus:function plus(){return _this2.brokerPlus("standard");},minus:function minus(){return _this2.brokerMinus("standard");}})}),__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Typography___default.a,{variant:"body2",gutterBottom:true},"Includes:"),__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Typography___default.a,null,pricePlans.Standard.slice(0,3).map(function(p){return __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement("span",null,p,__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement("br",null));})),pricePlans.Standard.length>3?__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Typography___default.a,{className:"typographyLink",onClick:function onClick(){_this2.setState({priceplanItem:"Standard"});_this2.handleClickOpenDialog("priceplanDetailDialog");}},"View All Features..."):null,__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement("div",{style:{borderBottom:"1px solid #cccccc69",paddingBottom:"12px",marginBottom:"10px"}}),__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement("div",{style:{display:"grid"}},__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Typography___default.a,null,__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement("span",{style:{float:"left"}},_this2.state.subscription.brokers.standard===_this2.state.currentSubscription.brokers.standard?"Current Price:":"Updated Price:"),__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement("span",{style:{float:"right"}},__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement("strong",null,"R",_this2.state.subscription.amounts.standard))),_this2.state.subscription.brokers.standard<_this2.state.currentSubscription.brokers.standard?__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Typography___default.a,{style:{color:"orange"}},"*NB: Selected changes will take effect after next Debit Order Date"):null))))),__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:4,style:{height:"88%"}},__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_Card_Card_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Card_CardHeader_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_SpaceDisplay_SpaceDisplay_jsx__["a" /* default */],{left:__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Typography___default.a,{variant:"subheading",gutterBottom:true},"Premium"),right:__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Typography___default.a,{variant:"caption",gutterBottom:true},"R",priceTableFirst12["level"+_this2.state.subscription.currentLevel].premium," ","p/m")})),__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["f" /* CardContent */],null,__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement("div",{style:{display:"block"}},__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Typography___default.a,null,"Coming Soon!"),__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement("div",{style:{borderBottom:"1px solid #cccccc69",paddingBottom:"12px",marginBottom:"10px",paddingTop:"18px"}}),__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Typography___default.a,{variant:"body2",gutterBottom:true},"Includes:"),__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Typography___default.a,null,pricePlans.Premium.slice(0,3).map(function(p){return __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement("span",null,p,__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement("br",null));})),pricePlans.Premium.length>3?__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Typography___default.a,{className:"typographyLink",onClick:function onClick(){_this2.setState({priceplanItem:"Premium"});_this2.handleClickOpenDialog("priceplanDetailDialog");}},"View All Features..."):null,__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement("div",{style:{borderBottom:"1px solid #cccccc69",paddingBottom:"12px",marginBottom:"10px"}}),__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement("div",{style:{display:"grid"}},__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Typography___default.a,null,__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement("span",{style:{float:"left"}},"Current Price:"),__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement("span",{style:{float:"right"}},__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement("strong",null," ","R",_this2.state.subscription.amounts.premium))))))))),__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Grid_GridContainer_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:12},__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_Card_Card_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["f" /* CardContent */],null,__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Grid_GridContainer_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:12},__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement("div",{style:{display:"grid",marginBottom:"10px"}},__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Typography___default.a,null,__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement("span",{style:{float:"left"}},"Free Assistants:"),__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement("span",{style:{float:"right",marginRight:"50px",fontSize:"1rem"}},_this2.state.subscription.freeAssistants))),__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_SpaceDisplay_SpaceDisplay_jsx__["a" /* default */],{style:{borderBottom:"1px solid #cccccc69",paddingBottom:"12px",marginBottom:"10px"},left:__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Typography___default.a,{style:{position:"relative",top:"5px"}},"Extra Assistants:"),right:__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_EasyRange_EasyRange_jsx__["a" /* default */],{number:_this2.state.subscription.extraAssistants,change:function change(e){return _this2.extraAssistantAmountChange(e);},plus:function plus(){return _this2.extraAssistantsPlus();},minus:function minus(){return _this2.extraAssistantsMinus();}})}),__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_SpaceDisplay_SpaceDisplay_jsx__["a" /* default */],{left:__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Typography___default.a,null,"Grand Total:"),right:__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Typography___default.a,{style:{marginRight:"25px"}},__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement("strong",{style:{fontSize:"1rem"}},"R",_this2.state.subscription.totalPrice," "),"P/M")}),_this2.state.subscription.within_twelve_month_period?__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_SpaceDisplay_SpaceDisplay_jsx__["a" /* default */],{left:__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Typography___default.a,null),right:__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Typography___default.a,{style:{marginRight:"25px"}},__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement("span",{style:{marginRight:"15px"}},"After"," ",_this2.state.subscription.twelth_month_date," ",":"),__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement("strong",{style:{fontSize:"1rem"}},"R",_this2.state.subscription.totalPriceAfter12," "),"P/M")}):null,_this2.state.subscription.payment.next&&_this2.state.subscription.totalPrice>_this2.state.currentSubscription.totalPrice?__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_SpaceDisplay_SpaceDisplay_jsx__["a" /* default */],{left:__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Typography___default.a,null),right:__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Typography___default.a,{style:{marginRight:"25px"}},__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement("span",{style:{marginRight:"15px"}},"Next Debit Order Amount:"),__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement("strong",{style:{fontSize:"1rem"}},"R",_this2.getNextDebitOrderAmount()," "))}):null),__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:12}))))),__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:12,style:{textAlign:"center"}},_this2.differenceExists()?__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["d" /* Button */],{variant:"contained",color:"secondary"},"CONFIRM CHANGES"):null)),__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["k" /* Dialog */],{open:_this2.state.priceplanDetailDialog,onClose:function onClose(){return _this2.handleCloseDialog("priceplanDetailDialog");},"aria-labelledby":"form-dialog-title"},__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["o" /* DialogTitle */],{id:"form-dialog-title"},_this2.state.priceplanItem," Package Features"),__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["m" /* DialogContent */],null,__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Typography___default.a,null,pricePlans[_this2.state.priceplanItem].map(function(p){return __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement("span",null,p,__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement("br",null));}))),__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["l" /* DialogActions */],null,__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["d" /* Button */],{onClick:function onClick(){return _this2.handleCloseDialog("priceplanDetailDialog");},color:"primary"},"Close"))));});}}]);return EditSubscription;}(__WEBPACK_IMPORTED_MODULE_11_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (EditSubscription);

/***/ }),
/* 2664 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__EasyRange_css__ = __webpack_require__(2665);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__EasyRange_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__EasyRange_css__);
var easyRange=function easyRange(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:{display:"flex"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["d" /* Button */],{variant:"fab",mini:true,className:"EasyRangeFab",onClick:props.minus},"-"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["y" /* Input */],{value:props.number,style:{width:"50px",margin:'0px 10px'},className:"EasyInput",onChange:function onChange(e){return props.change(e);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["d" /* Button */],{variant:"fab",mini:true,className:"EasyRangeFab",onClick:props.plus},"+"));};/* harmony default export */ __webpack_exports__["a"] = (easyRange);

/***/ }),
/* 2665 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2666 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_core__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_helpers_DrivingHoursConverter__ = __webpack_require__(708);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_helpers_UriReader__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_helpers_UserHelper__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_queries_quotes_queries_js__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_queries_Submit__ = __webpack_require__(392);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_apollo__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_router__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_reducers_NotificationReducer__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_reducers_TasksReducer__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_redux_form__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_store__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__steps_BenefitDetails_jsx__ = __webpack_require__(2667);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__steps_BenefitSelection_jsx__ = __webpack_require__(2674);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__steps_CompanySelection_jsx__ = __webpack_require__(2675);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__steps_CompanySpecific_jsx__ = __webpack_require__(2676);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__steps_QuoteDetails_jsx__ = __webpack_require__(2681);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__steps_BenefitMapping__ = __webpack_require__(2774);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var QuoteWizard=function(_Component){_inherits(QuoteWizard,_Component);function QuoteWizard(props){_classCallCheck(this,QuoteWizard);var _this=_possibleConstructorReturn(this,(QuoteWizard.__proto__||Object.getPrototypeOf(QuoteWizard)).call(this,props));_this.checkSelectedTarget=function(id,checked){var selectedTargets=[].concat(_toConsumableArray(_this.state.selectedTargets));if(checked){selectedTargets.push(id);}else{selectedTargets=selectedTargets.filter(function(t){return t!==id;});}_this.setState({selectedTargets:selectedTargets});};_this.toggleAllTargets=function(targets,checked){var selectedTargets=[].concat(_toConsumableArray(_this.state.selectedTargets));if(checked){targets.map(function(t){if(!selectedTargets.includes(t.id)){selectedTargets.push(t.id);}return t;});}else{selectedTargets=[];}_this.setState({selectedTargets:selectedTargets});};_this.checkSelectedBenefit=function(id,checked){var selectedBenefits=[].concat(_toConsumableArray(_this.state.selectedBenefits));if(checked){selectedBenefits.push(id);}else{selectedBenefits=selectedBenefits.filter(function(t){return t!==id;});}_this.setState({selectedBenefits:selectedBenefits});};_this.toggleAllBenefits=function(benefits,checked){var selectedBenefits=[].concat(_toConsumableArray(_this.state.selectedBenefits));if(checked){benefits.map(function(b){if(!selectedBenefits.includes(b.id)){selectedBenefits.push(b.id);}return b;});}else{selectedBenefits=[];}_this.setState({selectedBenefits:selectedBenefits});};_this.pushNextPage=function(){_this.setState({page:_this.state.page+1});_this.setState({checkValidation:false});};_this.getBrokerId=function(){var brokerId=Object(__WEBPACK_IMPORTED_MODULE_4_helpers_UserHelper__["a" /* GetUserId */])();if(_this.checkAssistantActive()){brokerId=sessionStorage.getItem('ActiveBrokerId');}return brokerId;};_this.nextPage=_this.nextPage.bind(_this);_this.previousPage=_this.previousPage.bind(_this);_this.state={page:0,pageCount:6,checkValidation:false,formInitiazed:false,benefitsInitialized:false,br:false,mat100:0,mat75:0,clientId:null,guid:null,selectedTargets:[],selectedBenefits:[],clientAge:null};return _this;}_createClass(QuoteWizard,[{key:'componentDidMount',value:function componentDidMount(){var params=Object(__WEBPACK_IMPORTED_MODULE_3_helpers_UriReader__["a" /* ParseUriParams */])(this.props.location.search);var clientId=params.clientId,guid=params.guid;this.setState({clientId:clientId,guid:guid});}},{key:'initializeForm',value:function initializeForm(data){var defaultInit={//Fields you can't see
Admin:data.scd_pAdmin,Travel:data.scd_pTravel,ManualLabour:data.scd_pManual,Supervision:data.scd_pSupervision,spouseIncome:data.scd_spouseIncome,title:data.scd_title,name:data.scd_name,surname:data.scd_surname,dateOfBirth:data.scd_dateOfBirth,gender:data.scd_gender,smoker:data.scd_smoker,qualification:data.scd_qualification,occupation:data.scd_occupation,selfEmployed:data.scd_selfEmployed,income:data.scd_monthlyIncome,salaryType:data.scd_salaryType,maritalStatus:data.scd_maritalStatus,TaxDispensation:data.scd_taxDispensation,calculatedMonthlyIncomeAT:data.scd_calculatedMonthlyIncomeAT?data.scd_calculatedMonthlyIncomeAT:'0',actualMonthlyIncomeAT:data.scd_actualMonthlyIncomeAT?data.scd_actualMonthlyIncomeAT:'0',ID:data.scd_saID,//Fields you can see
comission:'100',percentageUpfronCommission:'100',PAAWCommission:'0',language:'English'};var editData={};if(this.state.guid){//Auto Populate targets
var selectedTargets=this.state.selectedTargets;var editTargets=data.targets.split(',').map(function(t){return parseInt(t,10);});var availTargets=data.AvailTargetsForBroker.map(function(t){return parseInt(t.id,10);});editTargets.map(function(t){if(availTargets.includes(t)){selectedTargets.push(t);}return t;});this.setState({selectedTargets:selectedTargets});editData=JSON.parse(data.formValues);if(editData.occupation!==data.scd_occupation){delete editData.occupation;delete editData.occupationalQs;}editData=this.deleteClientFields(editData);}this.props.initialize(Object.assign({},editData,defaultInit));if(data.scd_calculatedMonthlyIncomeAT){var calcAt=parseFloat(data.scd_calculatedMonthlyIncomeAT);if(data.scd_actualMonthlyIncomeAT){var acAt=parseFloat(data.scd_actualMonthlyIncomeAT);var value=Math.max(calcAt,acAt);this.setState({mat75:value*0.75,mat100:value});}else{this.setState({mat75:calcAt*0.75,mat100:calcAt});}}var age=__WEBPACK_IMPORTED_MODULE_5_moment___default()().diff(data.scd_dateOfBirth,'years');this.setState({formInitiazed:true,clientAge:age});}},{key:'deleteClientFields',value:function deleteClientFields(editData){delete editData.Admin;delete editData.Travel;delete editData.ManualLabour;delete editData.Supervision;delete editData.spouseIncome;delete editData.title;delete editData.name;delete editData.surname;delete editData.dateOfBirth;delete editData.gender;delete editData.smoker;delete editData.qualification;delete editData.occupation;delete editData.selfEmployed;delete editData.income;delete editData.salaryType;delete editData.maritalStatus;delete editData.TaxDispensation;delete editData.calculatedMonthlyIncomeAT;delete editData.actualMonthlyIncomeAT;delete editData.comission;delete editData.percentageUpfronCommission;delete editData.PAAWCommission;delete editData.language;delete editData.startDate;return editData;}},{key:'checkCommision',value:function checkCommision(){var values=__WEBPACK_IMPORTED_MODULE_14_store__["a" /* default */].getState().form.quotev2.values;if(!values)return true;var total=parseInt(values['percentageUpfronCommission'],10)+parseInt(values['PAAWCommission'],10);if(total!==parseInt(values['comission'],10)){return false;}return true;}},{key:'nextPage',value:function nextPage(){if(this.state.page===0||this.state.page===2){this.pushNextPage();this.forceUpdate();return;}var comErr=this.state.page===1&&!this.checkCommision();if(__WEBPACK_IMPORTED_MODULE_14_store__["a" /* default */].getState().form.quotev2.syncErrors||comErr){comErr?this.showDangerSnack('Upfront commission and As-and-when commission do not add up to total commission percentage'):this.showDangerSnack('Invalid Information');this.setState({checkValidation:true});}else{this.pushNextPage();}this.forceUpdate();}},{key:'previousPage',value:function previousPage(){this.setState({checkValidation:false,page:this.state.page-1});}},{key:'showDangerSnack',value:function showDangerSnack(message){__WEBPACK_IMPORTED_MODULE_14_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_11_reducers_NotificationReducer__["d" /* showSnack */])({message:message,color:'danger'}));}},{key:'checkAssistantActive',value:function checkAssistantActive(){return Object(__WEBPACK_IMPORTED_MODULE_4_helpers_UserHelper__["b" /* GetUserKey */])('userType')==='6'?true:false;}},{key:'submit',value:function submit(){if(__WEBPACK_IMPORTED_MODULE_14_store__["a" /* default */].getState().form.quotev2.syncErrors){this.setState({checkValidation:true});__WEBPACK_IMPORTED_MODULE_14_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_11_reducers_NotificationReducer__["d" /* showSnack */])({message:'Invalid Information',color:'danger'}));}else{this.setState({checkValidation:false});var fieldValuesRaw=Object.assign({},__WEBPACK_IMPORTED_MODULE_14_store__["a" /* default */].getState().form.quotev2.values);var pTravel=__WEBPACK_IMPORTED_MODULE_14_store__["a" /* default */].getState().form.quotev2.values.Travel;fieldValuesRaw.drivingHours=Object(__WEBPACK_IMPORTED_MODULE_2_helpers_DrivingHoursConverter__["a" /* calculateDrivingHours */])(pTravel);fieldValuesRaw['medicalSecondOpinion']='Y';var params=Object(__WEBPACK_IMPORTED_MODULE_3_helpers_UriReader__["a" /* ParseUriParams */])(this.props.location.search);var clientId=params.clientId;var input={token:Object(__WEBPACK_IMPORTED_MODULE_4_helpers_UserHelper__["c" /* GetUserToken */])(),userId:this.getBrokerId(),clientId:clientId,benefits:this.state.selectedBenefits,assistantId:Object(__WEBPACK_IMPORTED_MODULE_4_helpers_UserHelper__["b" /* GetUserKey */])('userType')==='6'?Object(__WEBPACK_IMPORTED_MODULE_4_helpers_UserHelper__["a" /* GetUserId */])():null,targets:this.state.selectedTargets,data:fieldValuesRaw};this.props.mutate({variables:{input:input}}).then(function(resp){console.log('resp: ',resp);__WEBPACK_IMPORTED_MODULE_14_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_11_reducers_NotificationReducer__["e" /* successWarning */])({open:true,title:'Quote Submitted!'}));__WEBPACK_IMPORTED_MODULE_14_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_12_reducers_TasksReducer__["f" /* openProgress */])());__WEBPACK_IMPORTED_MODULE_14_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_12_reducers_TasksReducer__["a" /* addPendingTask */])({task:{description:fieldValuesRaw.description,guid:resp.data.newQuote.guid,client:fieldValuesRaw.name+' '+fieldValuesRaw.surname}}));}).catch(function(error){__WEBPACK_IMPORTED_MODULE_14_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_11_reducers_NotificationReducer__["d" /* showSnack */])({message:'There was an error creating your new broker profile : '+error,color:'danger'}));});}return false;}},{key:'render',value:function render(){var _this2=this;var page=this.state.page;var params=Object(__WEBPACK_IMPORTED_MODULE_3_helpers_UriReader__["a" /* ParseUriParams */])(this.props.location.search);var clientId=params.clientId,guid=params.guid;return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_apollo__["Query"],{query:__WEBPACK_IMPORTED_MODULE_6_queries_quotes_queries_js__["a" /* ClientQuoteInfo */],variables:{brokerId:this.getBrokerId(),clientId:clientId,guid:guid,token:Object(__WEBPACK_IMPORTED_MODULE_4_helpers_UserHelper__["c" /* GetUserToken */])()},fetchPolicy:'network-only'},function(_ref){var loading=_ref.loading,error=_ref.error,data=_ref.data;if(loading)return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["B" /* LinearProgress */],null));if(error&&error.message&&error.message==='GraphQL error: invalid token'){Object(__WEBPACK_IMPORTED_MODULE_4_helpers_UserHelper__["d" /* Logout */])();return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react_router__["a" /* Redirect */],{to:'/app/portal/login'});}if(error)return'Error! '+error.message;if(!_this2.state.formInitiazed){_this2.initializeForm(data.ClientQuoteInfo);}var clientFullname=data.ClientQuoteInfo.scd_title+' '+data.ClientQuoteInfo.scd_name+' '+data.ClientQuoteInfo.scd_surname;return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{container:true},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:10,style:{flexBasis:"100%",maxWidth:"100%",margin:"auto"}},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('div',{className:'fixedStepper'},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{container:true},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:10,style:{margin:'auto'}},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('div',{className:'stepperDiv'},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["G" /* MobileStepper */],{type:'progress',steps:_this2.state.pageCount,position:'static',activeStep:_this2.state.page,nextButton:__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('div',{style:{display:'flex'}},_this2.state.page===_this2.state.pageCount-1?__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["d" /* Button */],{variant:'outlined',className:'outlinedButton',color:'secondary',style:{marginRight:'10px'},onClick:function onClick(){return _this2.submit();}},'Submit'):__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["d" /* Button */],{disabled:_this2.state.selectedTargets.length<1||_this2.state.page===2&&_this2.state.selectedBenefits.length<1,variant:'outlined',className:'outlinedButton',color:'secondary',style:{marginRight:'10px'},onClick:function onClick(){return _this2.nextPage();}},'Next')),backButton:__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["d" /* Button */],{variant:'outlined',className:'outlinedButton',color:'secondary',style:{marginLeft:'10px'},onClick:function onClick(){return _this2.previousPage();},disabled:_this2.state.page===0?true:false},'Back')}))))),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('br',null),page===0&&__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('div',{style:{color:'black'}},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__steps_CompanySelection_jsx__["a" /* default */],Object.assign({},_this2.props,{checkSelectedTarget:_this2.checkSelectedTarget,selectedTargets:_this2.state.selectedTargets,toggleAllTargets:_this2.toggleAllTargets,AvailTargetsForBroker:data.ClientQuoteInfo.AvailTargetsForBroker,clientFullname:clientFullname,autoPopulatedCompanies:data.ClientQuoteInfo.targets}))),page===1&&__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__steps_QuoteDetails_jsx__["a" /* default */],Object.assign({},_this2.props,{targets:_this2.state.selectedTargets,checkValidation:_this2.state.checkValidation,clientFullname:clientFullname})),page===2&&__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__steps_BenefitSelection_jsx__["a" /* default */],Object.assign({},_this2.props,{checkSelectedBenefit:_this2.checkSelectedBenefit,selectedBenefits:_this2.state.selectedBenefits,toggleAllBenefits:_this2.toggleAllBenefits,clientAge:_this2.state.clientAge,doesNotQualifyForIP:data.ClientQuoteInfo.doesNotQualifyForIP,clientFullname:clientFullname,autoPopulatedBenefits:data.ClientQuoteInfo.benefits,benefitsInitialized:_this2.state.benefitsInitialized,setBenefitsInitialized:function setBenefitsInitialized(benefits){return _this2.setState({benefitsInitialized:true,selectedBenefits:benefits});}})),page===3&&__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__steps_BenefitMapping__["a" /* default */],Object.assign({},_this2.props,{checkValidation:_this2.state.checkValidation,selectedBenefits:_this2.state.selectedBenefits,selectedTargets:_this2.state.selectedTargets,clientFullname:clientFullname})),page===4&&__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__steps_BenefitDetails_jsx__["a" /* default */],Object.assign({},_this2.props,{checkValidation:_this2.state.checkValidation,mat100:_this2.state.mat100,mat75:_this2.state.mat75,selectedBenefits:_this2.state.selectedBenefits,selectedTargets:_this2.state.selectedTargets,disOnlyImpairment:data.ClientQuoteInfo.disOnlyImpairment,clientFullname:clientFullname,clientAge:parseInt(data.ClientQuoteInfo.scd_age,10),clientAnualSalary:parseInt(data.ClientQuoteInfo.scd_monthlyIncome,10)*12,occupation:data.ClientQuoteInfo.scd_occupation,qualification:data.ClientQuoteInfo.scd_qualification,AvailTargetsForBroker:data.ClientQuoteInfo.AvailTargetsForBroker})),page===5&&__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__steps_CompanySpecific_jsx__["a" /* default */],Object.assign({},_this2.props,{checkValidation:_this2.state.checkValidation,client:data.ClientQuoteInfo,selectedTargets:_this2.state.selectedTargets,clientFullname:clientFullname})))));});}}]);return QuoteWizard;}(__WEBPACK_IMPORTED_MODULE_8_react__["Component"]);QuoteWizard=Object(__WEBPACK_IMPORTED_MODULE_13_redux_form__["e" /* reduxForm */])({form:'quotev2',destroyOnUnmount:true})(QuoteWizard);QuoteWizard=Object(__WEBPACK_IMPORTED_MODULE_9_react_apollo__["graphql"])(__WEBPACK_IMPORTED_MODULE_7_queries_Submit__["a" /* newQuoteMutation */])(QuoteWizard);/* harmony default export */ __webpack_exports__["a"] = (QuoteWizard);

/***/ }),
/* 2667 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__BenefitQuestions_LifeCover_jsx__ = __webpack_require__(2668);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__BenefitQuestions_CriticalIllness_jsx__ = __webpack_require__(2669);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__BenefitQuestions_DisabilityLumpsum_jsx__ = __webpack_require__(2670);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__BenefitQuestions_ExtIncomeProtector_jsx__ = __webpack_require__(2671);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__BenefitQuestions_TempIncomeProtector_jsx__ = __webpack_require__(2672);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__BenefitQuestions_DeathIncomeProtector_jsx__ = __webpack_require__(2673);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_CustomCardHeading_CustomCardHeading_jsx__ = __webpack_require__(56);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var BenefitDetails=function(_React$Component){_inherits(BenefitDetails,_React$Component);function BenefitDetails(){var _ref;var _temp,_this,_ret;_classCallCheck(this,BenefitDetails);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=BenefitDetails.__proto__||Object.getPrototypeOf(BenefitDetails)).call.apply(_ref,[this].concat(args))),_this),_this.state={benefitValidity:{3:true,5:true,55:true,56:true,57:true,58:true}},_this.setBenefitValidity=function(benefitId,valid){if(_this.state.benefitValidity[benefitId]===valid)return;var benefitValidity=Object.assign({},_this.state.benefitValidity);benefitValidity[benefitId]=valid;_this.setState({benefitValidity:benefitValidity});},_this.benefitComponents=[{id:3,name:'Life Cover',component:function component(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__BenefitQuestions_LifeCover_jsx__["a" /* default */],Object.assign({},props,{setBenefitValidity:function setBenefitValidity(valid){return _this.setBenefitValidity(3,valid);}}));}},{id:5,name:'Critical Illness',component:function component(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__BenefitQuestions_CriticalIllness_jsx__["a" /* default */],Object.assign({},props,{setBenefitValidity:function setBenefitValidity(valid){return _this.setBenefitValidity(5,valid);}}));}},{id:55,name:'Disability Lumpsum',component:function component(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__BenefitQuestions_DisabilityLumpsum_jsx__["a" /* default */],Object.assign({},props,{setBenefitValidity:function setBenefitValidity(valid){return _this.setBenefitValidity(55,valid);}}));}},{id:56,name:'Temporary Income Protector',component:function component(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__BenefitQuestions_TempIncomeProtector_jsx__["a" /* default */],Object.assign({},props,{setBenefitValidity:function setBenefitValidity(valid){return _this.setBenefitValidity(56,valid);}}));}},{id:57,name:'Extended Income Protector',component:function component(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__BenefitQuestions_ExtIncomeProtector_jsx__["a" /* default */],Object.assign({},props,{setBenefitValidity:function setBenefitValidity(valid){return _this.setBenefitValidity(57,valid);}}));}},{id:58,name:'Death Income Protector (Beta)',component:function component(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__BenefitQuestions_DeathIncomeProtector_jsx__["a" /* default */],Object.assign({},props,{setBenefitValidity:function setBenefitValidity(valid){return _this.setBenefitValidity(58,valid);}}));}}],_temp),_possibleConstructorReturn(_this,_ret);}_createClass(BenefitDetails,[{key:'componentDidMount',value:function componentDidMount(){this.props.scrollMeBar();}},{key:'render',value:function render(){var _this2=this;var filteredBenefit=this.benefitComponents.filter(function(b){return _this2.props.selectedBenefits.includes(b.id);});var benefitValidity=Object.assign({},this.state.benefitValidity);var invalidBenefits=false;for(var key in benefitValidity){if(!benefitValidity[key]){invalidBenefits=true;break;}}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'contentWithStepper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["e" /* Card */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["f" /* CardContent */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_CustomCardHeading_CustomCardHeading_jsx__["a" /* default */],{subheading:'Quote Generation',caption:this.props.clientFullname,headline:'Benefit Details'}),invalidBenefits?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["Z" /* Typography */],{style:{color:'red'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Please Note: '),'You have invalid benefit details for certain companies. Continuing might cause quotation errors.'):null,filteredBenefit.map(function(benefit,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["q" /* ExpansionPanel */],{defaultExpanded:i===0,key:i},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["s" /* ExpansionPanelSummary */],{expandIcon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["w" /* Icon */],null,'expand_more')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["Z" /* Typography */],null,benefit.name)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["r" /* ExpansionPanelDetails */],null,benefit.component(_this2.props)));}))));}}]);return BenefitDetails;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (BenefitDetails);

/***/ }),
/* 2668 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_Wrappers_materialUIWrappers_components_NumberInput__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_CustomFields_CustomFields_jsx__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__BenifitCompanyValidation__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_store__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_CompanyErrorBlock__ = __webpack_require__(155);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var required=function required(value){return value?undefined:'Required';};var min100k=function min100k(value){if(value===undefined)return undefined;if(parseInt(value,10)<100000.0){return'Must be greater than R100 000';}return undefined;};var LifeCover=function(_React$PureComponent){_inherits(LifeCover,_React$PureComponent);function LifeCover(){var _ref;var _temp,_this,_ret;_classCallCheck(this,LifeCover);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=LifeCover.__proto__||Object.getPrototypeOf(LifeCover)).call.apply(_ref,[this].concat(args))),_this),_this.state={companyCriteria:null},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(LifeCover,[{key:'componentDidMount',value:function componentDidMount(){var premiumPattern=__WEBPACK_IMPORTED_MODULE_5_store__["a" /* default */].getState().form.quotev2.values.premiumPattern;var companyCriteria=Object(__WEBPACK_IMPORTED_MODULE_4__BenifitCompanyValidation__["i" /* getValidationCriteria */])({benefitValidationObj:__WEBPACK_IMPORTED_MODULE_4__BenifitCompanyValidation__["f" /* Life */],targets:this.props.AvailTargetsForBroker,selectedTargets:this.props.selectedTargets,occupation:this.props.occupation,qualification:this.props.qualification,premiumPattern:premiumPattern,age:this.props.clientAge,anualSalary:this.props.clientAnualSalary,toAge:'WholeLife'});this.setState({companyCriteria:companyCriteria});}},{key:'render',value:function render(){var _this2=this;var companyErrors={};if(this.state.companyCriteria){var companyCriteria=Object.assign({},this.state.companyCriteria);var lumpSumCover=Object(__WEBPACK_IMPORTED_MODULE_6_lodash__["get"])(__WEBPACK_IMPORTED_MODULE_5_store__["a" /* default */].getState().form.quotev2,'values.lumpSumCover',0);companyErrors=Object(__WEBPACK_IMPORTED_MODULE_4__BenifitCompanyValidation__["j" /* validateCriteria */])(companyCriteria,{amount:lumpSumCover,age:this.props.clientAge},100000.0);}var benefitValid=Object.keys(companyErrors).length<1;this.props.setBenefitValidity(benefitValid);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["v" /* Grid */],{container:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_CustomFields_CustomFields_jsx__["a" /* FullField */],{name:'lumpSumCover',component:__WEBPACK_IMPORTED_MODULE_2_components_Wrappers_materialUIWrappers_components_NumberInput__["a" /* default */],onChange:function onChange(){return _this2.forceUpdate();},prefix:'R',seperator:' ',checkValidation:this.props.checkValidation,label:'Whole Life Cover Amount *',isrequired:true,validate:[required,min100k]}),!benefitValid?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["v" /* Grid */],{item:true,xs:12,sm:12,md:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_CompanyErrorBlock__["a" /* default */],{companyErrors:companyErrors})):null);}}]);return LifeCover;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);/* harmony default export */ __webpack_exports__["a"] = (LifeCover);

/***/ }),
/* 2669 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_CustomFields_CustomFields_jsx__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Wrappers_materialUIWrappers_components_NumberInput__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Wrappers_materialUIWrappers_components_FormDropDown__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_helpers_ValidationHelpers__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__BenifitCompanyValidation__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_CompanyErrorBlock__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_store__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var min100k=function min100k(value){if(value===undefined)return undefined;if(parseInt(value,10)<100000.0){return'Must be greater than R100 000';}return undefined;};var CriticalIllness=function(_React$PureComponent){_inherits(CriticalIllness,_React$PureComponent);function CriticalIllness(){var _ref;var _temp,_this,_ret;_classCallCheck(this,CriticalIllness);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=CriticalIllness.__proto__||Object.getPrototypeOf(CriticalIllness)).call.apply(_ref,[this].concat(args))),_this),_this.state={companyCriteria:null,toAge:null},_this.validateCoverAccelerator=function(value){var accelerator=Object(__WEBPACK_IMPORTED_MODULE_9_lodash__["get"])(__WEBPACK_IMPORTED_MODULE_8_store__["a" /* default */].getState().form.quotev2.values,'standaloneOrAccelerator',null);var lifeCoverAmount=Object(__WEBPACK_IMPORTED_MODULE_9_lodash__["get"])(__WEBPACK_IMPORTED_MODULE_8_store__["a" /* default */].getState().form.quotev2.values,'lumpSumCover',null);if(!value||!_this.props.selectedBenefits.includes(3)){if(accelerator=='2')return"Life cover must be selected to be able to select accelerated benefits.";else return undefined;}if(!accelerator||accelerator!=='2')return undefined;if(!lifeCoverAmount)return undefined;if(parseFloat(value)>parseFloat(lifeCoverAmount)){return'Cannot be more than Whole Life Cover Amount';}return undefined;},_this.standaloneOptions=function(){var options=[{value:'validationError',displayValue:'Please select'},{value:'1',displayValue:'Standalone'}];if(_this.props.selectedBenefits.includes(3))options.push({value:'2',displayValue:'Accelerator'});return options;},_this.setValidationCriteria=function(){var premiumPattern=__WEBPACK_IMPORTED_MODULE_8_store__["a" /* default */].getState().form.quotev2.values.premiumPattern;var toAge=_this.getToAge();var companyCriteria=Object(__WEBPACK_IMPORTED_MODULE_6__BenifitCompanyValidation__["i" /* getValidationCriteria */])({benefitValidationObj:__WEBPACK_IMPORTED_MODULE_6__BenifitCompanyValidation__["b" /* CritIllness */],targets:_this.props.AvailTargetsForBroker,selectedTargets:_this.props.selectedTargets,occupation:_this.props.occupation,qualification:_this.props.qualification,premiumPattern:premiumPattern,age:_this.props.clientAge,anualSalary:_this.props.clientAnualSalary,toAge:toAge});_this.setState({companyCriteria:companyCriteria,toAge:toAge});return companyCriteria;},_this.getToAge=function(){var toAge=Object(__WEBPACK_IMPORTED_MODULE_9_lodash__["get"])(__WEBPACK_IMPORTED_MODULE_8_store__["a" /* default */].getState().form.quotev2.values,'cCeaseAge','validationError');if(toAge==='validationError'||toAge==='75'){toAge='WholeLife';}return toAge;},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(CriticalIllness,[{key:'componentDidMount',value:function componentDidMount(){this.setValidationCriteria();}},{key:'render',value:function render(){var _this2=this;var companyErrors={};if(this.state.companyCriteria){var companyCriteria=Object.assign({},this.state.companyCriteria);if(this.getToAge()!==this.state.toAge){companyCriteria=this.setValidationCriteria();}var lumpSumCover=Object(__WEBPACK_IMPORTED_MODULE_9_lodash__["get"])(__WEBPACK_IMPORTED_MODULE_8_store__["a" /* default */].getState().form.quotev2,'values.coverAmount',0);companyErrors=Object(__WEBPACK_IMPORTED_MODULE_6__BenifitCompanyValidation__["j" /* validateCriteria */])(companyCriteria,{amount:lumpSumCover,age:this.props.clientAge},100000.0);}var benefitValid=Object.keys(companyErrors).length<1;this.props.setBenefitValidity(benefitValid);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["v" /* Grid */],{container:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_CustomFields_CustomFields_jsx__["a" /* FullField */],{name:'standaloneOrAccelerator',label:'Standalone/Accelerator *',component:__WEBPACK_IMPORTED_MODULE_4_components_Wrappers_materialUIWrappers_components_FormDropDown__["a" /* default */],onChange:function onChange(){return _this2.forceUpdate();},checkValidation:this.props.checkValidation,isrequired:true,validate:[__WEBPACK_IMPORTED_MODULE_5_helpers_ValidationHelpers__["h" /* requiredDropdown */]],options:this.standaloneOptions()}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_CustomFields_CustomFields_jsx__["a" /* FullField */],{name:'coverAmount',label:'Lumpsum cover *',onChange:function onChange(){return _this2.forceUpdate();},component:__WEBPACK_IMPORTED_MODULE_3_components_Wrappers_materialUIWrappers_components_NumberInput__["a" /* default */],prefix:'R',seperator:' ',checkValidation:this.props.checkValidation,isrequired:true,validate:[__WEBPACK_IMPORTED_MODULE_5_helpers_ValidationHelpers__["g" /* required */],min100k,this.validateCoverAccelerator]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_CustomFields_CustomFields_jsx__["a" /* FullField */],{name:'enhancedOption',label:'Enhanced / Standard *',component:__WEBPACK_IMPORTED_MODULE_4_components_Wrappers_materialUIWrappers_components_FormDropDown__["a" /* default */],checkValidation:this.props.checkValidation,isrequired:true,validate:[__WEBPACK_IMPORTED_MODULE_5_helpers_ValidationHelpers__["h" /* requiredDropdown */]],options:[{value:'validationError',displayValue:'Please select'},{value:'enhanced',displayValue:'Enhanced'},{value:'complete',displayValue:'Standard'}]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_CustomFields_CustomFields_jsx__["a" /* FullField */],{name:'cCeaseAge',label:'Cease age *',component:__WEBPACK_IMPORTED_MODULE_4_components_Wrappers_materialUIWrappers_components_FormDropDown__["a" /* default */],checkValidation:this.props.checkValidation,onChange:function onChange(){return _this2.forceUpdate();},isrequired:true,validate:[__WEBPACK_IMPORTED_MODULE_5_helpers_ValidationHelpers__["h" /* requiredDropdown */]],options:[{value:'validationError',displayValue:'Please select'},{value:'65',displayValue:'65'},{value:'75',displayValue:'Whole life'}]}),!benefitValid?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["v" /* Grid */],{item:true,xs:12,sm:12,md:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_CompanyErrorBlock__["a" /* default */],{companyErrors:companyErrors})):null);}}]);return CriticalIllness;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);/* harmony default export */ __webpack_exports__["a"] = (CriticalIllness);

/***/ }),
/* 2670 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_CustomFields_CustomFields_jsx__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Wrappers_materialUIWrappers_components_NumberInput__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Wrappers_materialUIWrappers_components_FormDropDown__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_helpers_ValidationHelpers__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__BenifitCompanyValidation__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_CompanyErrorBlock__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_store__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var min100k=function min100k(value){if(value===undefined)return undefined;if(parseInt(value,10)<100000.0){return'Must be greater than R100 000';}return undefined;};var DisabilityLumpsum=function(_React$PureComponent){_inherits(DisabilityLumpsum,_React$PureComponent);function DisabilityLumpsum(){var _ref;var _temp,_this,_ret;_classCallCheck(this,DisabilityLumpsum);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=DisabilityLumpsum.__proto__||Object.getPrototypeOf(DisabilityLumpsum)).call.apply(_ref,[this].concat(args))),_this),_this.state={companyCriteria:null,toAge:null},_this.validateCoverAccelerator=function(value){var accelerator=Object(__WEBPACK_IMPORTED_MODULE_9_lodash__["get"])(__WEBPACK_IMPORTED_MODULE_8_store__["a" /* default */].getState().form.quotev2.values,'disabilityAccelerator',null);var lifeCoverAmount=Object(__WEBPACK_IMPORTED_MODULE_9_lodash__["get"])(__WEBPACK_IMPORTED_MODULE_8_store__["a" /* default */].getState().form.quotev2.values,'lumpSumCover',null);if(!value||!_this.props.selectedBenefits.includes(3)){if(accelerator=='2')return"Life cover must be selected to be able to select accelerated benefits.";else return undefined;}if(!accelerator||accelerator!=='2')return undefined;if(!lifeCoverAmount)return undefined;if(parseFloat(value)>parseFloat(lifeCoverAmount)){return'Cannot be more than Whole Life Cover Amount';}return undefined;},_this.setValidationCriteria=function(){var premiumPattern=__WEBPACK_IMPORTED_MODULE_8_store__["a" /* default */].getState().form.quotev2.values.premiumPattern;var toAge=_this.getToAge();var disabilityOption=Object(__WEBPACK_IMPORTED_MODULE_9_lodash__["get"])(__WEBPACK_IMPORTED_MODULE_8_store__["a" /* default */].getState().form.quotev2.values,'disabilityOption','validationError');var benefitValidationObj=__WEBPACK_IMPORTED_MODULE_6__BenifitCompanyValidation__["a" /* ComprehensiveDisability */];switch(disabilityOption){case'Occupational':benefitValidationObj=__WEBPACK_IMPORTED_MODULE_6__BenifitCompanyValidation__["g" /* OwnOccupationDis */];break;case'Impairment':benefitValidationObj=__WEBPACK_IMPORTED_MODULE_6__BenifitCompanyValidation__["e" /* Impairment */];break;default:break;}var companyCriteria=Object(__WEBPACK_IMPORTED_MODULE_6__BenifitCompanyValidation__["i" /* getValidationCriteria */])({benefitValidationObj:benefitValidationObj,targets:_this.props.AvailTargetsForBroker,selectedTargets:_this.props.selectedTargets,occupation:_this.props.occupation,qualification:_this.props.qualification,premiumPattern:premiumPattern,age:_this.props.clientAge,anualSalary:_this.props.clientAnualSalary,toAge:toAge});_this.setState({companyCriteria:companyCriteria,toAge:toAge});return companyCriteria;},_this.getToAge=function(){var toAge=Object(__WEBPACK_IMPORTED_MODULE_9_lodash__["get"])(__WEBPACK_IMPORTED_MODULE_8_store__["a" /* default */].getState().form.quotev2.values,'dCeaseAge','validationError');if(toAge==='validationError')toAge='70';return toAge;},_this.standaloneOptions=function(){var options=[{value:'validationError',displayValue:'Please select'},{value:'1',displayValue:'Standalone'}];if(_this.props.selectedBenefits.includes(3))options.push({value:'2',displayValue:'Accelerator'});return options;},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(DisabilityLumpsum,[{key:'componentDidMount',value:function componentDidMount(){this.setValidationCriteria();}},{key:'render',value:function render(){var _this2=this;var disabilityOptions=[{value:'validationError',displayValue:'Please select'},{value:'OccupationalC',displayValue:'Comprehensive Own Occupation'},{value:'Occupational',displayValue:'Own Occupation'},{value:'OccupationalOC',displayValue:'Comprehensive  Own/ Similar Occupation'},{value:'OccupationalO',displayValue:'Own/ Similar Occupation'},{value:'Impairment',displayValue:'Impairment'}];if(this.props.disOnlyImpairment){disabilityOptions=disabilityOptions.filter(function(o){return o.value==='Impairment'||o.value==='validationError';});}var companyErrors={};if(this.state.companyCriteria){var companyCriteria=Object.assign({},this.state.companyCriteria);if(this.getToAge()!==this.state.toAge){companyCriteria=this.setValidationCriteria();}var lumpSumCover=Object(__WEBPACK_IMPORTED_MODULE_9_lodash__["get"])(__WEBPACK_IMPORTED_MODULE_8_store__["a" /* default */].getState().form.quotev2,'values.disabilityLumpsumCover',0);companyErrors=Object(__WEBPACK_IMPORTED_MODULE_6__BenifitCompanyValidation__["j" /* validateCriteria */])(companyCriteria,{amount:lumpSumCover,age:this.props.clientAge},100000.0);}var benefitValid=Object.keys(companyErrors).length<1;this.props.setBenefitValidity(benefitValid);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["v" /* Grid */],{container:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_CustomFields_CustomFields_jsx__["a" /* FullField */],{name:'disabilityLumpsumCover',label:'Lumpsum cover *',component:__WEBPACK_IMPORTED_MODULE_3_components_Wrappers_materialUIWrappers_components_NumberInput__["a" /* default */],onChange:function onChange(){return _this2.forceUpdate();},prefix:'R',seperator:' ',checkValidation:this.props.checkValidation,isrequired:true,validate:[__WEBPACK_IMPORTED_MODULE_5_helpers_ValidationHelpers__["g" /* required */],min100k,this.validateCoverAccelerator]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_CustomFields_CustomFields_jsx__["a" /* FullField */],{name:'disabilityAccelerator',label:'Standalone or Accelerated *',component:__WEBPACK_IMPORTED_MODULE_4_components_Wrappers_materialUIWrappers_components_FormDropDown__["a" /* default */],onChange:function onChange(){return _this2.forceUpdate();},checkValidation:this.props.checkValidation,isrequired:true,validate:[__WEBPACK_IMPORTED_MODULE_5_helpers_ValidationHelpers__["h" /* requiredDropdown */]],options:this.standaloneOptions()}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_CustomFields_CustomFields_jsx__["a" /* FullField */],{name:'disabilityTapering',label:'Tapering/Non Tapering *',component:__WEBPACK_IMPORTED_MODULE_4_components_Wrappers_materialUIWrappers_components_FormDropDown__["a" /* default */],checkValidation:this.props.checkValidation,isrequired:true,validate:[__WEBPACK_IMPORTED_MODULE_5_helpers_ValidationHelpers__["h" /* requiredDropdown */]],options:[{value:'validationError',displayValue:'Please select'},{value:'Y',displayValue:'Tapering'},{value:'N',displayValue:'Non Tapering'}]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_CustomFields_CustomFields_jsx__["a" /* FullField */],{name:'dCeaseAge',label:'Cease age *',component:__WEBPACK_IMPORTED_MODULE_4_components_Wrappers_materialUIWrappers_components_FormDropDown__["a" /* default */],onChange:function onChange(){return _this2.forceUpdate();},checkValidation:this.props.checkValidation,isrequired:true,validate:[__WEBPACK_IMPORTED_MODULE_5_helpers_ValidationHelpers__["h" /* requiredDropdown */]],options:[{value:'validationError',displayValue:'Please select'},{value:'65',displayValue:'65'},{value:'70',displayValue:'70'}]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_CustomFields_CustomFields_jsx__["a" /* FullField */],{name:'disabilityOption',label:'Disability option *',component:__WEBPACK_IMPORTED_MODULE_4_components_Wrappers_materialUIWrappers_components_FormDropDown__["a" /* default */],onChange:function onChange(){return _this2.forceUpdate();},checkValidation:this.props.checkValidation,isrequired:true,validate:[__WEBPACK_IMPORTED_MODULE_5_helpers_ValidationHelpers__["h" /* requiredDropdown */]],options:disabilityOptions}),!benefitValid?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["v" /* Grid */],{item:true,xs:12,sm:12,md:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_CompanyErrorBlock__["a" /* default */],{companyErrors:companyErrors})):null);}}]);return DisabilityLumpsum;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);/* harmony default export */ __webpack_exports__["a"] = (DisabilityLumpsum);

/***/ }),
/* 2671 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_CustomFields_CustomFields_jsx__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Wrappers_materialUIWrappers_components_NumberInput__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Wrappers_materialUIWrappers_components_FormDropDown__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_helpers_ValidationHelpers__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_store__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__BenifitCompanyValidation__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_CompanyErrorBlock__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var min2k=function min2k(value){if(value===undefined)return undefined;if(parseInt(value,10)<2000.0){return'Must be greater than R2 000';}return undefined;};var ExtIncomeProtector=function(_React$PureComponent){_inherits(ExtIncomeProtector,_React$PureComponent);function ExtIncomeProtector(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ExtIncomeProtector);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ExtIncomeProtector.__proto__||Object.getPrototypeOf(ExtIncomeProtector)).call.apply(_ref,[this].concat(args))),_this),_this.state={companyCriteria:null,toAge:null},_this.setValidationCriteria=function(){var premiumPattern=__WEBPACK_IMPORTED_MODULE_6_store__["a" /* default */].getState().form.quotev2.values.premiumPattern;var toAge=_this.getToAge();var companyCriteria=Object(__WEBPACK_IMPORTED_MODULE_7__BenifitCompanyValidation__["i" /* getValidationCriteria */])({benefitValidationObj:__WEBPACK_IMPORTED_MODULE_7__BenifitCompanyValidation__["d" /* ExtendedIncomeProtector */],targets:_this.props.AvailTargetsForBroker,selectedTargets:_this.props.selectedTargets,occupation:_this.props.occupation,qualification:_this.props.qualification,premiumPattern:premiumPattern,age:_this.props.clientAge,anualSalary:_this.props.clientAnualSalary,toAge:toAge});_this.setState({companyCriteria:companyCriteria,toAge:toAge});return companyCriteria;},_this.getToAge=function(){var toAge=Object(__WEBPACK_IMPORTED_MODULE_9_lodash__["get"])(__WEBPACK_IMPORTED_MODULE_6_store__["a" /* default */].getState().form.quotev2.values,'iExCeaseAge','validationError');if(toAge==='validationError')toAge='70';return toAge;},_this.mat75Validate=function(value){if(_this.props.mat75&&_this.props.mat100>0){if(parseFloat(value)>_this.props.mat100){return'Higher than max available';}}if(value===undefined)return undefined;return isNaN(Number(value))?'Must be a number':undefined;},_this.exCeaseAgeValidate=function(value){if(value===undefined)return undefined;var theValue=value;if(_this.props.selectedBenefits.includes(56)){var tempCeaseAge=__WEBPACK_IMPORTED_MODULE_6_store__["a" /* default */].getState().form.quotev2.values.iTempCeaseAge;if(!tempCeaseAge)return undefined;if(theValue!==tempCeaseAge)return'Cease age for Income Protector Benefits must be the same';}return undefined;},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ExtIncomeProtector,[{key:'componentDidMount',value:function componentDidMount(){this.setValidationCriteria();}},{key:'render',value:function render(){var _this2=this;var companyErrors={};if(this.state.companyCriteria){var companyCriteria=Object.assign({},this.state.companyCriteria);if(this.getToAge()!==this.state.toAge){companyCriteria=this.setValidationCriteria();}var coverAmount=Object(__WEBPACK_IMPORTED_MODULE_9_lodash__["get"])(__WEBPACK_IMPORTED_MODULE_6_store__["a" /* default */].getState().form.quotev2,'values.incomeExMonthlyCover',0);companyErrors=Object(__WEBPACK_IMPORTED_MODULE_7__BenifitCompanyValidation__["j" /* validateCriteria */])(companyCriteria,{amount:coverAmount,age:this.props.clientAge},2000.0,this.props.mat75);}var benefitValid=Object.keys(companyErrors).length<1;this.props.setBenefitValidity(benefitValid);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["v" /* Grid */],{container:true},this.props.mat75&&this.props.mat75>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["v" /* Grid */],{item:true,xs:12,sm:12,md:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Max available: R',parseFloat(this.props.mat100).toFixed(2))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_CustomFields_CustomFields_jsx__["a" /* FullField */],{name:'incomeExMonthlyCover',label:'Monthly Cover *',component:__WEBPACK_IMPORTED_MODULE_3_components_Wrappers_materialUIWrappers_components_NumberInput__["a" /* default */],onChange:function onChange(){return _this2.forceUpdate();},prefix:'R',seperator:' ',checkValidation:this.props.checkValidation,isrequired:true,validate:[__WEBPACK_IMPORTED_MODULE_5_helpers_ValidationHelpers__["g" /* required */],this.mat75Validate,min2k]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_CustomFields_CustomFields_jsx__["a" /* FullField */],{name:'iExCeaseAge',label:'Cease age *',component:__WEBPACK_IMPORTED_MODULE_4_components_Wrappers_materialUIWrappers_components_FormDropDown__["a" /* default */],onChange:function onChange(){return _this2.forceUpdate();},checkValidation:this.props.checkValidation,isrequired:true,validate:[__WEBPACK_IMPORTED_MODULE_5_helpers_ValidationHelpers__["h" /* requiredDropdown */],this.exCeaseAgeValidate],options:[{value:'validationError',displayValue:'Please select'},{value:'60',displayValue:'60'},{value:'65',displayValue:'65'},{value:'70',displayValue:'70'}]}),!benefitValid?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["v" /* Grid */],{item:true,xs:12,sm:12,md:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_CompanyErrorBlock__["a" /* default */],{companyErrors:companyErrors})):null);}}]);return ExtIncomeProtector;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);/* harmony default export */ __webpack_exports__["a"] = (ExtIncomeProtector);

/***/ }),
/* 2672 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_CustomFields_CustomFields_jsx__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Wrappers_materialUIWrappers_components_NumberInput__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Wrappers_materialUIWrappers_components_FormDropDown__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_helpers_ValidationHelpers__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_store__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__BenifitCompanyValidation__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_CompanyErrorBlock__ = __webpack_require__(155);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var min2k=function min2k(value){if(value===undefined)return undefined;if(parseInt(value,10)<2000.0){return'Must be greater than R2 000';}return undefined;};var sevenDayValidate=function sevenDayValidate(companyErrors,targets,selectedTargets,selfEmployed,qualification){var selfEmplProfTargets=[1,3];var message='Does not support 7 days waiting\n\tperiod for self-employed persons without professional\n\tqualifications';var _iteratorNormalCompletion=true;var _didIteratorError=false;var _iteratorError=undefined;try{for(var _iterator=targets[Symbol.iterator](),_step;!(_iteratorNormalCompletion=(_step=_iterator.next()).done);_iteratorNormalCompletion=true){var target=_step.value;if(selectedTargets.includes(parseInt(target.id))&&selfEmplProfTargets.includes(target.id)&&selfEmployed==='Y'&&qualification!=='4-yearDegreeOrProfessional'){companyErrors[target.name]=Object.assign({},companyErrors[target.name],{messages:companyErrors[target.name]?[].concat(_toConsumableArray(companyErrors[target.name].messages),[message]):[message]});}}}catch(err){_didIteratorError=true;_iteratorError=err;}finally{try{if(!_iteratorNormalCompletion&&_iterator.return){_iterator.return();}}finally{if(_didIteratorError){throw _iteratorError;}}}return companyErrors;};var TempIncomeProtector=function(_React$PureComponent){_inherits(TempIncomeProtector,_React$PureComponent);function TempIncomeProtector(){var _ref;var _temp,_this,_ret;_classCallCheck(this,TempIncomeProtector);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=TempIncomeProtector.__proto__||Object.getPrototypeOf(TempIncomeProtector)).call.apply(_ref,[this].concat(args))),_this),_this.state={companyCriteria:null,toAge:null},_this.setValidationCriteria=function(){var premiumPattern=__WEBPACK_IMPORTED_MODULE_6_store__["a" /* default */].getState().form.quotev2.values.premiumPattern;var toAge=_this.getToAge();var companyCriteria=Object(__WEBPACK_IMPORTED_MODULE_8__BenifitCompanyValidation__["i" /* getValidationCriteria */])({benefitValidationObj:__WEBPACK_IMPORTED_MODULE_8__BenifitCompanyValidation__["h" /* TemporaryIncomeProtector */],targets:_this.props.AvailTargetsForBroker,selectedTargets:_this.props.selectedTargets,occupation:_this.props.occupation,qualification:_this.props.qualification,premiumPattern:premiumPattern,age:_this.props.clientAge,anualSalary:_this.props.clientAnualSalary,toAge:toAge});_this.setState({companyCriteria:companyCriteria,toAge:toAge});return companyCriteria;},_this.getToAge=function(){var toAge=Object(__WEBPACK_IMPORTED_MODULE_7_lodash__["get"])(__WEBPACK_IMPORTED_MODULE_6_store__["a" /* default */].getState().form.quotev2.values,'iTempCeaseAge','validationError');if(toAge==='validationError')toAge='70';return toAge;},_this.mat100Validate=function(value){if(_this.props.mat100&&_this.props.mat100>0){if(parseFloat(value)>_this.props.mat100){return'Higher than max available';}}if(value===undefined)return undefined;return isNaN(Number(value))?'Must be a number':undefined;},_this.tempCeaseAgeValidate=function(value){if(value===undefined)return undefined;var theValue=value;if(_this.props.selectedBenefits.includes(57)){var exCeaseAge=__WEBPACK_IMPORTED_MODULE_6_store__["a" /* default */].getState().form.quotev2.values.iExCeaseAge;if(!exCeaseAge)return undefined;if(theValue!==exCeaseAge)return'Cease age for Income Protector Benefits must be the same';}return undefined;},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(TempIncomeProtector,[{key:'componentDidMount',value:function componentDidMount(){this.setValidationCriteria();}},{key:'render',value:function render(){var _this2=this;var companyErrors={};if(this.state.companyCriteria){var companyCriteria=Object.assign({},this.state.companyCriteria);if(this.getToAge()!==this.state.toAge){companyCriteria=this.setValidationCriteria();}var coverAmount=Object(__WEBPACK_IMPORTED_MODULE_7_lodash__["get"])(__WEBPACK_IMPORTED_MODULE_6_store__["a" /* default */].getState().form.quotev2,'values.incomeTempMonthlyCover',0);companyErrors=Object(__WEBPACK_IMPORTED_MODULE_8__BenifitCompanyValidation__["j" /* validateCriteria */])(companyCriteria,{amount:coverAmount,age:this.props.clientAge},2000.0,this.props.mat100);var selfEmployed=Object(__WEBPACK_IMPORTED_MODULE_7_lodash__["get"])(__WEBPACK_IMPORTED_MODULE_6_store__["a" /* default */].getState().form.quotev2,'values.selfEmployed','');var incomeTempWaitingPeriod=Object(__WEBPACK_IMPORTED_MODULE_7_lodash__["get"])(__WEBPACK_IMPORTED_MODULE_6_store__["a" /* default */].getState().form.quotev2,'values.incomeTempWaitingPeriod','');if(incomeTempWaitingPeriod==='7'){companyErrors=sevenDayValidate(companyErrors,this.props.AvailTargetsForBroker,this.props.selectedTargets,selfEmployed,this.props.qualification);}}var benefitValid=Object.keys(companyErrors).length<1;this.props.setBenefitValidity(benefitValid);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["v" /* Grid */],{container:true},this.props.mat100&&this.props.mat100>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["v" /* Grid */],{item:true,xs:12,sm:12,md:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Max available: R',parseFloat(this.props.mat100).toFixed(2))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_CustomFields_CustomFields_jsx__["a" /* FullField */],{name:'incomeTempMonthlyCover',label:'Monthly Cover *',component:__WEBPACK_IMPORTED_MODULE_3_components_Wrappers_materialUIWrappers_components_NumberInput__["a" /* default */],onChange:function onChange(){return _this2.forceUpdate();},prefix:'R',seperator:' ',checkValidation:this.props.checkValidation,isrequired:true,validate:[__WEBPACK_IMPORTED_MODULE_5_helpers_ValidationHelpers__["g" /* required */],this.mat100Validate,min2k]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_CustomFields_CustomFields_jsx__["a" /* FullField */],{name:'incomeTempWaitingPeriod',label:'Waiting Period *',component:__WEBPACK_IMPORTED_MODULE_4_components_Wrappers_materialUIWrappers_components_FormDropDown__["a" /* default */],onChange:function onChange(){return _this2.forceUpdate();},checkValidation:this.props.checkValidation,isrequired:true,validate:[__WEBPACK_IMPORTED_MODULE_5_helpers_ValidationHelpers__["h" /* requiredDropdown */]],options:[{value:'validationError',displayValue:'Please select'},{value:'7',displayValue:'7 days'},{value:'30',displayValue:'1 month / 30 days'},{value:'90',displayValue:'3 months'}]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_CustomFields_CustomFields_jsx__["a" /* FullField */],{name:'iTempCeaseAge',label:'Cease age *',component:__WEBPACK_IMPORTED_MODULE_4_components_Wrappers_materialUIWrappers_components_FormDropDown__["a" /* default */],onChange:function onChange(){return _this2.forceUpdate();},checkValidation:this.props.checkValidation,isrequired:true,validate:[__WEBPACK_IMPORTED_MODULE_5_helpers_ValidationHelpers__["h" /* requiredDropdown */],this.tempCeaseAgeValidate],options:[{value:'validationError',displayValue:'Please select'},{value:'60',displayValue:'60'},{value:'65',displayValue:'65'},{value:'70',displayValue:'70'}]}),!benefitValid?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["v" /* Grid */],{item:true,xs:12,sm:12,md:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_CompanyErrorBlock__["a" /* default */],{companyErrors:companyErrors})):null);}}]);return TempIncomeProtector;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);/* harmony default export */ __webpack_exports__["a"] = (TempIncomeProtector);

/***/ }),
/* 2673 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_CustomFields_CustomFields_jsx__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Wrappers_materialUIWrappers_components_NumberInput__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Wrappers_materialUIWrappers_components_FormDropDown__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_helpers_ValidationHelpers__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_store__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__BenifitCompanyValidation__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_CompanyErrorBlock__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var min2k=function min2k(value){if(value===undefined)return undefined;if(parseInt(value,10)<2000.0){return'Must be greater than R2 000';}return undefined;};var DeathIncomeProtector=function(_React$PureComponent){_inherits(DeathIncomeProtector,_React$PureComponent);function DeathIncomeProtector(){var _ref;var _temp,_this,_ret;_classCallCheck(this,DeathIncomeProtector);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=DeathIncomeProtector.__proto__||Object.getPrototypeOf(DeathIncomeProtector)).call.apply(_ref,[this].concat(args))),_this),_this.state={companyCriteria:null,toAge:null},_this.setValidationCriteria=function(){var premiumPattern=__WEBPACK_IMPORTED_MODULE_6_store__["a" /* default */].getState().form.quotev2.values.premiumPattern;var toAge=_this.getToAge();var companyCriteria=Object(__WEBPACK_IMPORTED_MODULE_7__BenifitCompanyValidation__["i" /* getValidationCriteria */])({benefitValidationObj:__WEBPACK_IMPORTED_MODULE_7__BenifitCompanyValidation__["c" /* DIncomeProtector */],targets:_this.props.AvailTargetsForBroker,selectedTargets:_this.props.selectedTargets,occupation:_this.props.occupation,qualification:_this.props.qualification,premiumPattern:premiumPattern,age:_this.props.clientAge,anualSalary:_this.props.clientAnualSalary,toAge:toAge});_this.setState({companyCriteria:companyCriteria,toAge:toAge});return companyCriteria;},_this.getToAge=function(){var toAge=Object(__WEBPACK_IMPORTED_MODULE_9_lodash__["get"])(__WEBPACK_IMPORTED_MODULE_6_store__["a" /* default */].getState().form.quotev2.values,'DeathCeaseAge','validationError');if(toAge==='validationError')toAge='70';return toAge;},_this.mat75Validate=function(value){if(_this.props.mat75&&_this.props.mat100>0){if(parseFloat(value)>_this.props.mat100){return'Higher than max available';}}if(value===undefined)return undefined;return isNaN(Number(value))?'Must be a number':undefined;},_this.deathCeaseAgeValidate=function(value){if(value===undefined)return undefined;var theValue=value;return undefined;},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(DeathIncomeProtector,[{key:'componentDidMount',value:function componentDidMount(){this.setValidationCriteria();}},{key:'render',value:function render(){var _this2=this;var companyErrors={};if(this.state.companyCriteria){var companyCriteria=Object.assign({},this.state.companyCriteria);if(this.getToAge()!==this.state.toAge){companyCriteria=this.setValidationCriteria();}var coverAmount=Object(__WEBPACK_IMPORTED_MODULE_9_lodash__["get"])(__WEBPACK_IMPORTED_MODULE_6_store__["a" /* default */].getState().form.quotev2,'values.deathIncomeCover',0);companyErrors=Object(__WEBPACK_IMPORTED_MODULE_7__BenifitCompanyValidation__["j" /* validateCriteria */])(companyCriteria,{amount:coverAmount,age:this.props.clientAge},2000.0,this.props.mat100);}var benefitValid=Object.keys(companyErrors).length<1;this.props.setBenefitValidity(benefitValid);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["v" /* Grid */],{container:true},this.props.mat100&&this.props.mat100>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["v" /* Grid */],{item:true,xs:12,sm:12,md:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Max available: R',parseFloat(this.props.mat100).toFixed(2))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_CustomFields_CustomFields_jsx__["a" /* FullField */],{name:'deathIncomeCover',label:'Monthly Cover *',component:__WEBPACK_IMPORTED_MODULE_3_components_Wrappers_materialUIWrappers_components_NumberInput__["a" /* default */],onChange:function onChange(){return _this2.forceUpdate();},prefix:'R',seperator:' ',checkValidation:this.props.checkValidation,isrequired:true,validate:[__WEBPACK_IMPORTED_MODULE_5_helpers_ValidationHelpers__["g" /* required */],this.mat75Validate,min2k]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_CustomFields_CustomFields_jsx__["a" /* FullField */],{name:'deathIncomeCeaseAge',label:'Cease age *',component:__WEBPACK_IMPORTED_MODULE_4_components_Wrappers_materialUIWrappers_components_FormDropDown__["a" /* default */],onChange:function onChange(){return _this2.forceUpdate();},checkValidation:this.props.checkValidation,isrequired:true,validate:[__WEBPACK_IMPORTED_MODULE_5_helpers_ValidationHelpers__["h" /* requiredDropdown */]],options:[{value:'validationError',displayValue:'Please select'},{value:'60',displayValue:'60'},{value:'65',displayValue:'65'},{value:'70',displayValue:'70'}]}),!benefitValid?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["v" /* Grid */],{item:true,xs:12,sm:12,md:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_CompanyErrorBlock__["a" /* default */],{companyErrors:companyErrors})):null);}}]);return DeathIncomeProtector;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);/* harmony default export */ __webpack_exports__["a"] = (DeathIncomeProtector);

/***/ }),
/* 2674 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_CustomCardHeading_CustomCardHeading_jsx__ = __webpack_require__(56);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var BenefitSelection=function(_React$Component){_inherits(BenefitSelection,_React$Component);function BenefitSelection(){var _ref;var _temp,_this,_ret;_classCallCheck(this,BenefitSelection);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=BenefitSelection.__proto__||Object.getPrototypeOf(BenefitSelection)).call.apply(_ref,[this].concat(args))),_this),_this.state={benefits:[{id:3,name:'Life Cover',minAge:20,maxAge:80,disabled:false,messages:[],compValidation:{}},{minAge:20,maxAge:70,id:5,name:'Critical Illness',disabled:false,messages:[]},{minAge:20,maxAge:60,id:55,name:'Disability Lumpsum',disabled:false,messages:[]},{minAge:20,maxAge:60,id:56,name:'Temporary Income Protector',disabled:_this.props.doesNotQualifyForIP,messages:[_this.props.doesNotQualifyForIP?"Client's occupation does not qualify for this benefit":'']},{minAge:20,maxAge:60,id:57,name:'Extended Income Protector',disabled:_this.props.doesNotQualifyForIP,messages:[_this.props.doesNotQualifyForIP?"Client's occupation does not qualify for this benefit":'']/*,
			{
				minAge: 20,
				maxAge: 60,
				id: 58,
				name: 'Death Income Protector (Beta)',
				disabled: this.props.doesNotQualifyForIP,
				messages: [
					this.props.doesNotQualifyForIP
						? "Client's occupation does not qualify for this benefit"
						: ''
				]
			}*/}]},_this.handleCheck=function(id){if(_this.props.selectedBenefits.find(function(t){return t===id;})){_this.props.checkSelectedBenefit(id,false);}else{_this.props.checkSelectedBenefit(id,true);}_this.forceUpdate();},_this.checkAll=function(){if(_this.props.selectedBenefits.length!==_this.enabledBenefits().length){_this.props.toggleAllBenefits(_this.enabledBenefits(),true);}else{_this.props.toggleAllBenefits(_this.enabledBenefits(),false);}_this.forceUpdate();},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(BenefitSelection,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;this.props.scrollMeBar();var benefits=this.state.benefits;benefits.map(function(benefit){if(_this2.props.clientAge){if(_this2.props.clientAge>benefit.maxAge){benefit.disabled=true;benefit.messages.push('Client is too old to qualify for this benefit');}if(_this2.props.clientAge<benefit.minAge){benefit.disabled=true;benefit.messages.push('Client is too young to qualify for this benefit');}}return benefit;});if(!this.props.benefitsInitialized&&this.props.autoPopulatedBenefits){var editBenefits=this.props.autoPopulatedBenefits.split(',').map(function(t){return parseInt(t,10);});var autoPopBenefits=[];benefits.map(function(ben){if(editBenefits.includes(ben.id)){autoPopBenefits.push(ben.id);}return ben;});this.props.setBenefitsInitialized(autoPopBenefits);}this.setState({benefits:benefits});}},{key:'enabledBenefits',value:function enabledBenefits(){var benefits=this.state.benefits;return benefits.filter(function(benefit){return!benefit.disabled;});}},{key:'render',value:function render(){var _this3=this;var allSelected=this.props.selectedBenefits.length===this.enabledBenefits().length;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'contentWithStepper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["e" /* Card */],{className:this.classes},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["f" /* CardContent */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_CustomCardHeading_CustomCardHeading_jsx__["a" /* default */],{subheading:'Quote Generation',caption:this.props.clientFullname,headline:'Benefit Selection'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{display:'block',width:'100%',marginTop:'15px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{display:'flex'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["h" /* Checkbox */],{checked:allSelected,onChange:this.checkAll}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'checkBoxText',style:{fontSize:'15px',color:'#6f6d6d'}},'Select All')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{width:'100%'}},this.state.benefits.map(function(benefit){var isSelected=false;if(_this3.props.selectedBenefits.find(function(t){return t===benefit.id;})){isSelected=true;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:benefit.id,className:'checkboxContainer'+(benefit.disabled?' disabledRow':''),style:isSelected?{backgroundColor:'#f5f5f5'}:{cursor:benefit.disabled?'not-allowed':'pointer'},onClick:function onClick(){return benefit.disabled?{}:_this3.handleCheck(benefit.id);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["h" /* Checkbox */],{checked:isSelected}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'checkBoxText'},benefit.name),benefit.disabled&&benefit.messages.length>0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'checkBoxText',style:{display:'block',paddingTop:'5px'}},benefit.messages.map(function(message,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["Z" /* Typography */],{key:i,variant:'caption',style:{color:'red'}},message);})):null);}))))));}}]);return BenefitSelection;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (BenefitSelection);

/***/ }),
/* 2675 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_core__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_CustomCardHeading_CustomCardHeading_jsx__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CompanySelection=function(_React$Component){_inherits(CompanySelection,_React$Component);function CompanySelection(){var _ref;var _temp,_this,_ret;_classCallCheck(this,CompanySelection);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=CompanySelection.__proto__||Object.getPrototypeOf(CompanySelection)).call.apply(_ref,[this].concat(args))),_this),_this.state={availTargets:[]},_this.handleCheck=function(id){if(_this.props.selectedTargets.find(function(t){return t===id;})){_this.props.checkSelectedTarget(id,false);}else{_this.props.checkSelectedTarget(id,true);}_this.forceUpdate();},_this.checkAll=function(){if(_this.props.selectedTargets.length!==_this.props.AvailTargetsForBroker.length){_this.props.toggleAllTargets(_this.props.AvailTargetsForBroker,true);}else{_this.props.toggleAllTargets(_this.props.AvailTargetsForBroker,false);}_this.forceUpdate();},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(CompanySelection,[{key:'componentDidMount',value:function componentDidMount(){this.props.scrollMeBar();}},{key:'render',value:function render(){var _this2=this;var targets=this.props.AvailTargetsForBroker;var allSelected=this.props.selectedTargets.length===targets.length;return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'contentWithStepper'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["e" /* Card */],{className:this.classes},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["f" /* CardContent */],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_CustomCardHeading_CustomCardHeading_jsx__["a" /* default */],{subheading:'Quote Generation',caption:this.props.clientFullname,headline:'Company Selection'}),targets.length>0?__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{style:{display:'block',width:'100%',marginTop:'15px'}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{style:{display:'flex'}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["h" /* Checkbox */],{checked:allSelected,onChange:this.checkAll}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('p',{className:'checkBoxText',style:{fontSize:'15px',color:'#6f6d6d'}},'Select All')),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{style:{width:'100%'}},targets.map(function(target){var imgSrc='/assets/logo/'+target.logo;var selected=_this2.props.selectedTargets.find(function(s){return s===target.id;})?true:false;return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{key:target.id,className:'checkboxContainer',style:selected?{backgroundColor:'#f5f5f5'}:{},onClick:function onClick(){return _this2.handleCheck(target.id);}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["h" /* Checkbox */],{checked:selected}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('img',{src:imgSrc,alt:target.name,className:'targetAffiliationLogo',style:{marginLeft:'20px'}}));}))):__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{marginTop:'25px'}},'You currently have no active FSP details.'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{style:{marginTop:'25px'}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],null,'You can set your FSP login details',' ',__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span',{className:'typographyLink',onClick:function onClick(){return _this2.props.history.push({pathname:'/app/companylogindetails'});}},'HERE'))))));}}]);return CompanySelection;}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (CompanySelection);

/***/ }),
/* 2676 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_core__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_CustomCardHeading_CustomCardHeading_jsx__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CompanySpecificQuestions_occupation_questions__ = __webpack_require__(2677);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CompanySpecificQuestions_fmi_jsx__ = __webpack_require__(2678);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__CompanySpecificQuestions_momentum_jsx__ = __webpack_require__(2679);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__CompanySpecificQuestions_sanlam_jsx__ = __webpack_require__(2680);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CompanySpecific=function(_React$Component){_inherits(CompanySpecific,_React$Component);function CompanySpecific(){var _ref;var _temp,_this,_ret;_classCallCheck(this,CompanySpecific);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=CompanySpecific.__proto__||Object.getPrototypeOf(CompanySpecific)).call.apply(_ref,[this].concat(args))),_this),_this.companyComponents=[{id:1,name:'Momentum',component:function component(props){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__CompanySpecificQuestions_momentum_jsx__["a" /* default */],Object.assign({},props,{forceUpdate:function forceUpdate(){return _this.forceUpdate();}}));}},{id:3,name:'Sanlam',logo:'sanlam.png',component:function component(props){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__CompanySpecificQuestions_sanlam_jsx__["a" /* default */],Object.assign({},props,{occupationQuestions:__WEBPACK_IMPORTED_MODULE_3__CompanySpecificQuestions_occupation_questions__["a" /* default */].filter(function(q){return q.oq_targetId==='3'&&q.oq_occupation===_this.getOccupation('sanlam');})}));}},{id:10,name:'Bidvest',component:function component(props){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__CompanySpecificQuestions_fmi_jsx__["a" /* default */],Object.assign({},props,{occupationQuestions:__WEBPACK_IMPORTED_MODULE_3__CompanySpecificQuestions_occupation_questions__["a" /* default */].filter(function(q){return q.oq_targetId==='10'&&q.oq_occupation===_this.getOccupation('fmi');})}));}}],_temp),_possibleConstructorReturn(_this,_ret);}_createClass(CompanySpecific,[{key:'getOccupation',value:function getOccupation(targetName){var occupation=this.props.client[targetName+'Occupation'];if(!occupation)return this.props.client.occupation;return occupation;}},{key:'componentDidMount',value:function componentDidMount(){this.props.scrollMeBar();}},{key:'render',value:function render(){var _this2=this;var filteredCompanies=this.companyComponents.filter(function(c){return _this2.props.selectedTargets.includes(c.id);});return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'contentWithStepper'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["e" /* Card */],{className:this.classes},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["f" /* CardContent */],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_CustomCardHeading_CustomCardHeading_jsx__["a" /* default */],{subheading:'Quote Generation',caption:this.props.clientFullname,headline:'Company Specific Questions'}),filteredCompanies.length<1?__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],null,'There are no Company Specific Questions'):null,filteredCompanies.map(function(company){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["q" /* ExpansionPanel */],{defaultExpanded:true,key:company.id},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["s" /* ExpansionPanelSummary */],{expandIcon:__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["w" /* Icon */],null,'expand_more')},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],null,company.name)),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["r" /* ExpansionPanelDetails */],null,company.component(_this2.props)));}))));}}]);return CompanySpecific;}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (CompanySpecific);

/***/ }),
/* 2677 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{"oq_Id":1,"oq_targetId":"10","oq_occupation":"Actor","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":631,"oq_targetId":"10","oq_occupation":"Animator","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":2,"oq_targetId":"10","oq_occupation":"Actress","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":3,"oq_targetId":"10","oq_occupation":"Announcer","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":4,"oq_targetId":"10","oq_occupation":"Astrologer","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":5,"oq_targetId":"10","oq_occupation":"Author","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":6,"oq_targetId":"10","oq_occupation":"Biographer","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":7,"oq_targetId":"10","oq_occupation":"Book illustrator","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":8,"oq_targetId":"10","oq_occupation":"Broadcaster","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":9,"oq_targetId":"10","oq_occupation":"Business Owner","oq_questions":"[{\"question\":\"Does your occupation involve performing manual work, or overseeing/managing people performing manual work?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Is working with hand held machinery, tools or equipment a requirement for performing all or part of your occupation?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Is working with heavy machinery, tools or equipment a requirement for performing all or part of your occupation?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Is climbing ladders or installations a requirement for performing all or part of your occupation?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Is holding, restraining or manipulating another person or animal a requirement for performing all or part of your occupation?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Is working with or driving motorised machinery a requirement for performing all or part of your occupation?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Is lifting objects weighing more than 10kg a requirement for performing all or part of your occupation?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Is physical interaction or inspection of a production, manufacturing, construction or similar environment for more than 5 hours per week a requirement for performing all or part of your occupation?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":10,"oq_targetId":"10","oq_occupation":"Cartoon artist","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":11,"oq_targetId":"10","oq_occupation":"Catering staff on oil/gas rig","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":12,"oq_targetId":"10","oq_occupation":"Ceramicist","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":13,"oq_targetId":"10","oq_occupation":"Chemist on oil/gas rigs","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":14,"oq_targetId":"10","oq_occupation":"Chief Executive Officer","oq_questions":"[{\"question\":\"Does your occupation involve performing manual work, or overseeing/managing people performing manual work?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Is working with hand held machinery, tools or equipment a requirement for performing all or part of your occupation?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Is working with heavy machinery, tools or equipment a requirement for performing all or part of your occupation?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Is climbing ladders or installations a requirement for performing all or part of your occupation?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Is holding, restraining or manipulating another person or animal a requirement for performing all or part of your occupation?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Is working with or driving motorised machinery a requirement for performing all or part of your occupation?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Is lifting objects weighing more than 10kg a requirement for performing all or part of your occupation?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Is physical interaction or inspection of a production, manufacturing, construction or similar environment for more than 5 hours per week a requirement for performing all or part of your occupation?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":15,"oq_targetId":"10","oq_occupation":"Child Sport's instructor","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":16,"oq_targetId":"10","oq_occupation":"Comedian","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":17,"oq_targetId":"10","oq_occupation":"Commentator","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":18,"oq_targetId":"10","oq_occupation":"Company Chairman","oq_questions":"[{\"question\":\"Does your occupation involve performing manual work, or overseeing/managing people performing manual work?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Is working with hand held machinery, tools or equipment a requirement for performing all or part of your occupation?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Is working with heavy machinery, tools or equipment a requirement for performing all or part of your occupation?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Is climbing ladders or installations a requirement for performing all or part of your occupation?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Is holding, restraining or manipulating another person or animal a requirement for performing all or part of your occupation?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Is working with or driving motorised machinery a requirement for performing all or part of your occupation?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Is lifting objects weighing more than 10kg a requirement for performing all or part of your occupation?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Is physical interaction or inspection of a production, manufacturing, construction or similar environment for more than 5 hours per week a requirement for performing all or part of your occupation?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":19,"oq_targetId":"10","oq_occupation":"Company Director","oq_questions":"[{\"question\":\"Does your occupation involve performing manual work, or overseeing/managing people performing manual work?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Is working with hand held machinery, tools or equipment a requirement for performing all or part of your occupation?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Is working with heavy machinery, tools or equipment a requirement for performing all or part of your occupation?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Is climbing ladders or installations a requirement for performing all or part of your occupation?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Is holding, restraining or manipulating another person or animal a requirement for performing all or part of your occupation?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Is working with or driving motorised machinery a requirement for performing all or part of your occupation?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Is lifting objects weighing more than 10kg a requirement for performing all or part of your occupation?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Is physical interaction or inspection of a production, manufacturing, construction or similar environment for more than 5 hours per week a requirement for performing all or part of your occupation?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":20,"oq_targetId":"10","oq_occupation":"Company Secretary","oq_questions":"[{\"question\":\"Does your occupation involve performing manual work, or overseeing/managing people performing manual work?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Is working with hand held machinery, tools or equipment a requirement for performing all or part of your occupation?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Is working with heavy machinery, tools or equipment a requirement for performing all or part of your occupation?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Is climbing ladders or installations a requirement for performing all or part of your occupation?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Is holding, restraining or manipulating another person or animal a requirement for performing all or part of your occupation?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Is working with or driving motorised machinery a requirement for performing all or part of your occupation?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Is lifting objects weighing more than 10kg a requirement for performing all or part of your occupation?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Is physical interaction or inspection of a production, manufacturing, construction or similar environment for more than 5 hours per week a requirement for performing all or part of your occupation?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":21,"oq_targetId":"10","oq_occupation":"Composer","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":22,"oq_targetId":"10","oq_occupation":"Conjurer","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":23,"oq_targetId":"10","oq_occupation":"Crane operator on oil/gas rigs","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":24,"oq_targetId":"10","oq_occupation":"Executive Chairman","oq_questions":"[{\"question\":\"Does your occupation involve performing manual work, or overseeing/managing people performing manual work?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Is working with hand held machinery, tools or equipment a requirement for performing all or part of your occupation?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Is working with heavy machinery, tools or equipment a requirement for performing all or part of your occupation?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Is climbing ladders or installations a requirement for performing all or part of your occupation?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Is holding, restraining or manipulating another person or animal a requirement for performing all or part of your occupation?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Is working with or driving motorised machinery a requirement for performing all or part of your occupation?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Is lifting objects weighing more than 10kg a requirement for performing all or part of your occupation?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Is physical interaction or inspection of a production, manufacturing, construction or similar environment for more than 5 hours per week a requirement for performing all or part of your occupation?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":25,"oq_targetId":"10","oq_occupation":"Executive Director","oq_questions":"[{\"question\":\"Does your occupation involve performing manual work, or overseeing/managing people performing manual work?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Is working with hand held machinery, tools or equipment a requirement for performing all or part of your occupation?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Is working with heavy machinery, tools or equipment a requirement for performing all or part of your occupation?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Is climbing ladders or installations a requirement for performing all or part of your occupation?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Is holding, restraining or manipulating another person or animal a requirement for performing all or part of your occupation?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Is working with or driving motorised machinery a requirement for performing all or part of your occupation?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Is lifting objects weighing more than 10kg a requirement for performing all or part of your occupation?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Is physical interaction or inspection of a production, manufacturing, construction or similar environment for more than 5 hours per week a requirement for performing all or part of your occupation?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":26,"oq_targetId":"10","oq_occupation":"Faith healer","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":27,"oq_targetId":"10","oq_occupation":"Fashion model","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":28,"oq_targetId":"10","oq_occupation":"Flight Engineer","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":29,"oq_targetId":"10","oq_occupation":"Floral artist","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":30,"oq_targetId":"10","oq_occupation":"Flower arranger","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":31,"oq_targetId":"10","oq_occupation":"Fortune teller","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":32,"oq_targetId":"10","oq_occupation":"Geologist on oil/gas rigs","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":33,"oq_targetId":"10","oq_occupation":"Geophysicist on oil/gas rig","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":34,"oq_targetId":"10","oq_occupation":"Herbalist","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":35,"oq_targetId":"10","oq_occupation":"Holistic healer","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":36,"oq_targetId":"10","oq_occupation":"Homemaker","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":37,"oq_targetId":"10","oq_occupation":"Illusionist","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":38,"oq_targetId":"10","oq_occupation":"Book illustratorImaam","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":39,"oq_targetId":"10","oq_occupation":"Impersonator","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":40,"oq_targetId":"10","oq_occupation":"Impressionist","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":41,"oq_targetId":"10","oq_occupation":"Interpreter","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":42,"oq_targetId":"10","oq_occupation":"Juggler","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":43,"oq_targetId":"10","oq_occupation":"Landscape painter","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":44,"oq_targetId":"10","oq_occupation":"Male model","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":45,"oq_targetId":"10","oq_occupation":"Managing Member","oq_questions":"[{\"question\":\"Does your occupation involve performing manual work, or overseeing/managing people performing manual work?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Is working with hand held machinery, tools or equipment a requirement for performing all or part of your occupation?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Is working with heavy machinery, tools or equipment a requirement for performing all or part of your occupation?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Is climbing ladders or installations a requirement for performing all or part of your occupation?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Is holding, restraining or manipulating another person or animal a requirement for performing all or part of your occupation?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Is working with or driving motorised machinery a requirement for performing all or part of your occupation?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Is lifting objects weighing more than 10kg a requirement for performing all or part of your occupation?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Is physical interaction or inspection of a production, manufacturing, construction or similar environment for more than 5 hours per week a requirement for performing all or part of your occupation?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":46,"oq_targetId":"10","oq_occupation":"Fashion modelModel Agency Director","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":47,"oq_targetId":"10","oq_occupation":"Music Teacher","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":48,"oq_targetId":"10","oq_occupation":"News commentator","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":49,"oq_targetId":"10","oq_occupation":"Newscaster","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":50,"oq_targetId":"10","oq_occupation":"Newsreader","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":51,"oq_targetId":"10","oq_occupation":"Novelist","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":52,"oq_targetId":"10","oq_occupation":"Palmist","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":53,"oq_targetId":"10","oq_occupation":"Pilot (commercial) - Public passenger","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":54,"oq_targetId":"10","oq_occupation":"Playwright","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":55,"oq_targetId":"10","oq_occupation":"Poet","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":56,"oq_targetId":"10","oq_occupation":"Portrait painter","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":57,"oq_targetId":"10","oq_occupation":"Professional Athlete (track and field)","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":58,"oq_targetId":"10","oq_occupation":"Professional Badminton player","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":59,"oq_targetId":"10","oq_occupation":"Professional Billiards player","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":60,"oq_targetId":"10","oq_occupation":"Professional BMX Cyclist","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":61,"oq_targetId":"10","oq_occupation":"Professional Bowls player","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":62,"oq_targetId":"10","oq_occupation":"Professional Cyclist","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":63,"oq_targetId":"10","oq_occupation":"Professional Darts player","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":64,"oq_targetId":"10","oq_occupation":"Professional engineer on oil/gas rig","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":65,"oq_targetId":"10","oq_occupation":"Professional golfer","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":66,"oq_targetId":"10","oq_occupation":"Professional Ice skater","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":67,"oq_targetId":"10","oq_occupation":"Professional Motorcross cyclist","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":68,"oq_targetId":"10","oq_occupation":"Professional Mountain-Biker","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":69,"oq_targetId":"10","oq_occupation":"Professional Netball player","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":70,"oq_targetId":"10","oq_occupation":"Professional Pool player","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":71,"oq_targetId":"10","oq_occupation":"Professional Rower","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":72,"oq_targetId":"10","oq_occupation":"Professional Runner (Marathon, Tri-athlon)","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":73,"oq_targetId":"10","oq_occupation":"Professional Skateboarder","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":74,"oq_targetId":"10","oq_occupation":"Professional Snooker player","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":75,"oq_targetId":"10","oq_occupation":"Professional Squash player","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":76,"oq_targetId":"10","oq_occupation":"Professional Surfer","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":77,"oq_targetId":"10","oq_occupation":"Professional Swimmer","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":78,"oq_targetId":"10","oq_occupation":"Professional Table tennis player","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":79,"oq_targetId":"10","oq_occupation":"Professional Target shooter","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":80,"oq_targetId":"10","oq_occupation":"Professional Tennis player","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":81,"oq_targetId":"10","oq_occupation":"Professional Waterpolo player","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":82,"oq_targetId":"10","oq_occupation":"Professional Windsurfer","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":83,"oq_targetId":"10","oq_occupation":"Professional Yachtsperson","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":84,"oq_targetId":"10","oq_occupation":"Project Manager","oq_questions":"[{\"question\":\"Does your occupation involve performing manual work, or overseeing/managing people performing manual work?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Is working with hand held machinery, tools or equipment a requirement for performing all or part of your occupation?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Is working with heavy machinery, tools or equipment a requirement for performing all or part of your occupation?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Is climbing ladders or installations a requirement for performing all or part of your occupation?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Is holding, restraining or manipulating another person or animal a requirement for performing all or part of your occupation?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Is working with or driving motorised machinery a requirement for performing all or part of your occupation?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Is lifting objects weighing more than 10kg a requirement for performing all or part of your occupation?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Is physical interaction or inspection of a production, manufacturing, construction or similar environment for more than 5 hours per week a requirement for performing all or part of your occupation?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":85,"oq_targetId":"10","oq_occupation":"Radio announcer","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":86,"oq_targetId":"10","oq_occupation":"Radio presenter","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":87,"oq_targetId":"10","oq_occupation":"Radiographer on oil/gas rig","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":88,"oq_targetId":"10","oq_occupation":"Referee","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":89,"oq_targetId":"10","oq_occupation":"Rig electrician on oil/gas rigs","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":90,"oq_targetId":"10","oq_occupation":"Rig mechanic on oil/gas rig","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":91,"oq_targetId":"10","oq_occupation":"SAPS - Railway Policeman","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":92,"oq_targetId":"10","oq_occupation":"Script writer","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":93,"oq_targetId":"10","oq_occupation":"Songwriter","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":94,"oq_targetId":"10","oq_occupation":"Spiritualist","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":95,"oq_targetId":"10","oq_occupation":"Sports Coach - Athletics (track and Field)","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":96,"oq_targetId":"10","oq_occupation":"Sports Coach - Baseball","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":97,"oq_targetId":"10","oq_occupation":"Sports Coach - Basketball","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":98,"oq_targetId":"10","oq_occupation":"Sports Coach - BMX Cycling","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":99,"oq_targetId":"10","oq_occupation":"Sports Coach - Bowls","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":100,"oq_targetId":"10","oq_occupation":"Sports Coach - Cricket","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":101,"oq_targetId":"10","oq_occupation":"Sports Coach - Cycling","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":102,"oq_targetId":"10","oq_occupation":"Sports Coach - Football","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":103,"oq_targetId":"10","oq_occupation":"Sports Coach - Gymnastics","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":104,"oq_targetId":"10","oq_occupation":"Sports Coach - Hockey","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":105,"oq_targetId":"10","oq_occupation":"Sports Coach - Ice skating","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":106,"oq_targetId":"10","oq_occupation":"Sports Coach - Mountain-Biking","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":107,"oq_targetId":"10","oq_occupation":"Sports Coach - Netball","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":108,"oq_targetId":"10","oq_occupation":"Sports Coach - Rowing","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":109,"oq_targetId":"10","oq_occupation":"Sports Coach - Rugby","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":110,"oq_targetId":"10","oq_occupation":"Sports Coach - Running (Marathon, Tri-athlon)","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":111,"oq_targetId":"10","oq_occupation":"Sports Coach - Skateboarding","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":112,"oq_targetId":"10","oq_occupation":"Sports Coach - Squash","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":113,"oq_targetId":"10","oq_occupation":"Sports Coach - Surfing","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":114,"oq_targetId":"10","oq_occupation":"Sports Coach - Swimming","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":115,"oq_targetId":"10","oq_occupation":"Sports Coach - Target shooting","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":116,"oq_targetId":"10","oq_occupation":"Sports Coach - Tennis","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":117,"oq_targetId":"10","oq_occupation":"Sports Coach - Waterpolo","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":118,"oq_targetId":"10","oq_occupation":"Sports Coach - Windsurfing","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":119,"oq_targetId":"10","oq_occupation":"Sports Coach - Yachting","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":120,"oq_targetId":"10","oq_occupation":"Sports Martial arts instructor (Non contact or competition)","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":121,"oq_targetId":"10","oq_occupation":"Storekeeper on oil/gas rig","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":122,"oq_targetId":"10","oq_occupation":"Student - High School","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":123,"oq_targetId":"10","oq_occupation":"Student of tertiary education (full time)","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":124,"oq_targetId":"10","oq_occupation":"Technical artist","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":125,"oq_targetId":"10","oq_occupation":"Technical illustrator","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":126,"oq_targetId":"10","oq_occupation":"Television presenter","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":127,"oq_targetId":"10","oq_occupation":"Theatrical Agent","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":128,"oq_targetId":"10","oq_occupation":"Tv announcer","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":129,"oq_targetId":"10","oq_occupation":"Umpire","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":130,"oq_targetId":"10","oq_occupation":"Ventriloquist","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":261,"oq_targetId":"3","oq_occupation":"Accountant","oq_questions":"[{\"question\":\"Did you successfully complete the SAIPA Professional Evaluation(PE)?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":262,"oq_targetId":"3","oq_occupation":"Accounting Official","oq_questions":"[{\"question\":\"Did you successfully complete the SAIPA Professional Evaluation(PE)?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":263,"oq_targetId":"3","oq_occupation":"Actor \\ Actress","oq_questions":"[{\"question\":\"Are you required to, or do you perform any stunts during the course of your acting duties?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":272,"oq_targetId":"3","oq_occupation":"Air Host \\ Hostess","oq_questions":"[{\"question\":\"For which airline do you work as part of a crew?\",\"answers\":[\"1 eskader (scheduled)\",\"1time\",\"Air Afrique\",\"Air Austral\",\"Air Botswana\",\"Air France\",\"Air Gabon (aviation gsa)\",\"Air Madagascar(travel directions (pty) ltd)\",\"Air Malawi\",\"Air Mauritius\",\"Air Namibia (Pty) Ltd\",\"Air Portugal - tap\",\"Air Quarius contracts (pty) ltd\",\"Air Seychelles\",\"Air Tanzania corporation\",\"Air Zimbabwe\",\"Alitalia\",\"Alliance Express\",\"Angola Airlines (TAAG)\",\"Austrian Airlines\",\"Auto Spares\",\"Automal Pty Ltd\",\"Automall\",\"British Airways plc\",\"Cameroon Airlines\",\"Cargolux\",\"Cathay Pacific Airways Ltd\",\"Comair\",\"East African Airlines\",\"Egyptair\",\"El Al Israel Airlines\",\"Emirates\",\"Ethiopean Airlines\",\"Executive Aerospace\",\"Federal Air\",\"Ghana Airways Corporation\",\"Hydro Air\",\"Hewa Bora Airways\",\"Iberia Airlines of Spain\",\"Inter Air\",\"Interlink Airlines\",\"K.L.M\",\"Kenya Airways\",\"Khalifa Airways\",\"Kulula.com\",\"Lam-linhas Aereas De Mocambiqu\",\"Lufthansa German Airlines\",\"Malaysian Airlines\",\"Mango\",\"Martinair Holland\",\"Mrs Vliegdienste\",\"Nationwide\",\"Ncd and Partners\",\"Nel Air\",\"Olympic Airways\",\"Pelican Air Services\",\"Precision Air\",\"Quantas Airways Ltd\",\"Qatar Airways\",\"Regional Air\",\"Royal Air Maroc\",\"Rwandair Express\",\"S.A. Express\",\"SA Airlink\",\"Sabena Belgian World Airlines\",\"Safair\",\"Saudi Arabian Airlines\",\"Singapore Airlines\",\"Sobelair\",\"South African Airways\",\"Strato Air Services\",\"Swiss International Air lines (LX)\",\"Trans Air Congo\",\"TTA\",\"Turkish Airlines\",\"Varig\",\"Virgin Atlantic Airways Ltd\",\"Yemen Airways\",\"None of the above\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":273,"oq_targetId":"3","oq_occupation":"Aircraft : Crew Members Commercial Airlines","oq_questions":"[{\"question\":\"For which airline do you work as part of a crew?\",\"answers\":[\"1 eskader (scheduled)\",\"1time\",\"Air Afrique\",\"Air Austral\",\"Air Botswana\",\"Air France\",\"Air Gabon (aviation gsa)\",\"Air Madagascar(travel directions (pty) ltd)\",\"Air Malawi\",\"Air Mauritius\",\"Air Namibia (Pty) Ltd\",\"Air Portugal - tap\",\"Air Quarius contracts (pty) ltd\",\"Air Seychelles\",\"Air Tanzania corporation\",\"Air Zimbabwe\",\"Alitalia\",\"Alliance Express\",\"Angola Airlines (TAAG)\",\"Austrian Airlines\",\"Auto Spares\",\"Automal Pty Ltd\",\"Automall\",\"British Airways plc\",\"Cameroon Airlines\",\"Cargolux\",\"Cathay Pacific Airways Ltd\",\"Comair\",\"East African Airlines\",\"Egyptair\",\"El Al Israel Airlines\",\"Emirates\",\"Ethiopean Airlines\",\"Executive Aerospace\",\"Federal Air\",\"Ghana Airways Corporation\",\"Hydro Air\",\"Hewa Bora Airways\",\"Iberia Airlines of Spain\",\"Inter Air\",\"Interlink Airlines\",\"K.L.M\",\"Kenya Airways\",\"Khalifa Airways\",\"Kulula.com\",\"Lam-linhas Aereas De Mocambiqu\",\"Lufthansa German Airlines\",\"Malaysian Airlines\",\"Mango\",\"Martinair Holland\",\"Mrs Vliegdienste\",\"Nationwide\",\"Ncd and Partners\",\"Nel Air\",\"Olympic Airways\",\"Pelican Air Services\",\"Precision Air\",\"Quantas Airways Ltd\",\"Qatar Airways\",\"Regional Air\",\"Royal Air Maroc\",\"Rwandair Express\",\"S.A. Express\",\"SA Airlink\",\"Sabena Belgian World Airlines\",\"Safair\",\"Saudi Arabian Airlines\",\"Singapore Airlines\",\"Sobelair\",\"South African Airways\",\"Strato Air Services\",\"Swiss International Air lines (LX)\",\"Trans Air Congo\",\"TTA\",\"Turkish Airlines\",\"Varig\",\"Virgin Atlantic Airways Ltd\",\"Yemen Airways\",\"None of the above\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":274,"oq_targetId":"3","oq_occupation":"Aircraft Fitter","oq_questions":"[{\"question\":\"Are you involved in any type of aviation or flying in your normal occupation?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":275,"oq_targetId":"3","oq_occupation":"Aircraft Joiner","oq_questions":"[{\"question\":\"Are you involved in any type of aviation or flying in your normal occupation?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":276,"oq_targetId":"3","oq_occupation":"Aircraft Maintenance Technician","oq_questions":"[{\"question\":\"Are you involved in any type of aviation or flying in your normal occupation?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":280,"oq_targetId":"3","oq_occupation":"Antiques Dealer","oq_questions":"[{\"question\":\"Do you perform any restoration work?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":282,"oq_targetId":"3","oq_occupation":"Armed Guard","oq_questions":"[{\"question\":\"Are you required to carry a firearm, handle cash or work in a bank as part of your occupational duties?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":283,"oq_targetId":"3","oq_occupation":"Armed Response Officer","oq_questions":"[{\"question\":\"Are you required to carry a firearm, handle cash or work in a bank as part of your occupational duties?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":284,"oq_targetId":"3","oq_occupation":"Audit Clerk","oq_questions":"[{\"question\":\"Did you successfully complete any of the following certifications of The Institute of Internal Auditors (IIA): Certified Internal Auditor (CIA), Control self-assessment (CSA), Certified Government Auditing Professional® (CGAP®) or Certified Financial Services Auditor (CFSA)?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":285,"oq_targetId":"3","oq_occupation":"Audit Manager","oq_questions":"[{\"question\":\"Did you successfully complete any of the following certifications of The Institute of Internal Auditors (IIA): Certified Internal Auditor (CIA), Control self-assessment (CSA), Certified Government Auditing Professional® (CGAP®) or Certified Financial Services Auditor (CFSA)?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":286,"oq_targetId":"3","oq_occupation":"Auditor","oq_questions":"[{\"question\":\"Did you successfully complete any of the following certifications of The Institute of Internal Auditors (IIA): Certified Internal Auditor (CIA), Control self-assessment (CSA), Certified Government Auditing Professional® (CGAP®) or Certified Financial Services Auditor (CFSA)?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":288,"oq_targetId":"3","oq_occupation":"Aviation : Cabin Crew (Commercial \\ Private Airline)","oq_questions":"[{\"question\":\"For which airline do you work as part of a crew?\",\"answers\":[\"1 eskader (scheduled)\",\"1time\",\"Air Afrique\",\"Air Austral\",\"Air Botswana\",\"Air France\",\"Air Gabon (aviation gsa)\",\"Air Madagascar(travel directions (pty) ltd)\",\"Air Malawi\",\"Air Mauritius\",\"Air Namibia (Pty) Ltd\",\"Air Portugal - tap\",\"Air Quarius contracts (pty) ltd\",\"Air Seychelles\",\"Air Tanzania corporation\",\"Air Zimbabwe\",\"Alitalia\",\"Alliance Express\",\"Angola Airlines (TAAG)\",\"Austrian Airlines\",\"Auto Spares\",\"Automal Pty Ltd\",\"Automall\",\"British Airways plc\",\"Cameroon Airlines\",\"Cargolux\",\"Cathay Pacific Airways Ltd\",\"Comair\",\"East African Airlines\",\"Egyptair\",\"El Al Israel Airlines\",\"Emirates\",\"Ethiopean Airlines\",\"Executive Aerospace\",\"Federal Air\",\"Ghana Airways Corporation\",\"Hydro Air\",\"Hewa Bora Airways\",\"Iberia Airlines of Spain\",\"Inter Air\",\"Interlink Airlines\",\"K.L.M\",\"Kenya Airways\",\"Khalifa Airways\",\"Kulula.com\",\"Lam-linhas Aereas De Mocambiqu\",\"Lufthansa German Airlines\",\"Malaysian Airlines\",\"Mango\",\"Martinair Holland\",\"Mrs Vliegdienste\",\"Nationwide\",\"Ncd and Partners\",\"Nel Air\",\"Olympic Airways\",\"Pelican Air Services\",\"Precision Air\",\"Quantas Airways Ltd\",\"Qatar Airways\",\"Regional Air\",\"Royal Air Maroc\",\"Rwandair Express\",\"S.A. Express\",\"SA Airlink\",\"Sabena Belgian World Airlines\",\"Safair\",\"Saudi Arabian Airlines\",\"Singapore Airlines\",\"Sobelair\",\"South African Airways\",\"Strato Air Services\",\"Swiss International Air lines (LX)\",\"Trans Air Congo\",\"TTA\",\"Turkish Airlines\",\"Varig\",\"Virgin Atlantic Airways Ltd\",\"Yemen Airways\",\"None of the above\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":289,"oq_targetId":"3","oq_occupation":"Aviation : Commercial Instructor","oq_questions":"[{\"question\":\"Do you ONLY participate in standard flights between registered airports?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":290,"oq_targetId":"3","oq_occupation":"Aviation : Engineer (Commercial \\ Private)","oq_questions":"[{\"question\":\"For which airline do you work as part of a crew?\",\"answers\":[\"1 eskader (scheduled)\",\"1time\",\"Air Afrique\",\"Air Austral\",\"Air Botswana\",\"Air France\",\"Air Gabon (aviation gsa)\",\"Air Madagascar(travel directions (pty) ltd)\",\"Air Malawi\",\"Air Mauritius\",\"Air Namibia (Pty) Ltd\",\"Air Portugal - tap\",\"Air Quarius contracts (pty) ltd\",\"Air Seychelles\",\"Air Tanzania corporation\",\"Air Zimbabwe\",\"Alitalia\",\"Alliance Express\",\"Angola Airlines (TAAG)\",\"Austrian Airlines\",\"Auto Spares\",\"Automal Pty Ltd\",\"Automall\",\"British Airways plc\",\"Cameroon Airlines\",\"Cargolux\",\"Cathay Pacific Airways Ltd\",\"Comair\",\"East African Airlines\",\"Egyptair\",\"El Al Israel Airlines\",\"Emirates\",\"Ethiopean Airlines\",\"Executive Aerospace\",\"Federal Air\",\"Ghana Airways Corporation\",\"Hydro Air\",\"Hewa Bora Airways\",\"Iberia Airlines of Spain\",\"Inter Air\",\"Interlink Airlines\",\"K.L.M\",\"Kenya Airways\",\"Khalifa Airways\",\"Kulula.com\",\"Lam-linhas Aereas De Mocambiqu\",\"Lufthansa German Airlines\",\"Malaysian Airlines\",\"Mango\",\"Martinair Holland\",\"Mrs Vliegdienste\",\"Nationwide\",\"Ncd and Partners\",\"Nel Air\",\"Olympic Airways\",\"Pelican Air Services\",\"Precision Air\",\"Quantas Airways Ltd\",\"Qatar Airways\",\"Regional Air\",\"Royal Air Maroc\",\"Rwandair Express\",\"S.A. Express\",\"SA Airlink\",\"Sabena Belgian World Airlines\",\"Safair\",\"Saudi Arabian Airlines\",\"Singapore Airlines\",\"Sobelair\",\"South African Airways\",\"Strato Air Services\",\"Swiss International Air lines (LX)\",\"Trans Air Congo\",\"TTA\",\"Turkish Airlines\",\"Varig\",\"Virgin Atlantic Airways Ltd\",\"Yemen Airways\",\"None of the above\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":291,"oq_targetId":"3","oq_occupation":"Aviation : Pilot (Commercial \\ Private)","oq_questions":"[{\"question\":\"Do you ONLY participate in standard flights between registered airports?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":294,"oq_targetId":"3","oq_occupation":"Bank Security Guard","oq_questions":"[{\"question\":\"Are you required to carry a firearm, handle cash or work in a bank as part of your occupational duties?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":297,"oq_targetId":"3","oq_occupation":"Chief Executive Officer Of Company","oq_questions":"[{\"question\":\"Which industry/business are you involved in?\",\"answers\":[\"Debt collecting business\",\"Mining industry\",\"Micro lending business\",\"Security business\",\"Shebeen business\",\"Taxi industry\",\"Not one of the above\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":298,"oq_targetId":"3","oq_occupation":"Chief Shunter","oq_questions":"[{\"question\":\"Are you qualified as a leader or higher?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":302,"oq_targetId":"3","oq_occupation":"City Treasurer","oq_questions":"[{\"question\":\"Did you successfully complete the SAIPA Professional Evaluation(PE)?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":309,"oq_targetId":"3","oq_occupation":"Columnist","oq_questions":"[{\"question\":\"Is it expected of you to visit conflict areas outside the RSA borders, as a result of your responsibilities?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":310,"oq_targetId":"3","oq_occupation":"Commercial Diver","oq_questions":"[{\"question\":\"The system is about to ask you a number of questions and is likely to reach a decision. Should you not answer the questions now, the case will be referred to underwriting with further requirements. Do you wish to continue?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":311,"oq_targetId":"3","oq_occupation":"Commercial Pilot","oq_questions":"[{\"question\":\"Do you ONLY participate in standard flights between registered airports?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":317,"oq_targetId":"3","oq_occupation":"Driving School Instructor \\ Owner","oq_questions":"[{\"question\":\"Are you personally involved in the physical operations of the business?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":320,"oq_targetId":"3","oq_occupation":"Electrician (< 1000 Volts)","oq_questions":"[{\"question\":\"Do you ever work with current exceeding normal domestic voltages?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":321,"oq_targetId":"3","oq_occupation":"Electrician (> 10000 Volts)","oq_questions":"[{\"question\":\"Do you work in the mining industry?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":322,"oq_targetId":"3","oq_occupation":"Electrician (Between 1000 And 10000 Volts)","oq_questions":"[{\"question\":\"Do you ever work on overhead high tension cables or pylons?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":323,"oq_targetId":"3","oq_occupation":"Electrician Contractor","oq_questions":"[{\"question\":\"Are you personally involved in the physical operations of the business?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":324,"oq_targetId":"3","oq_occupation":"Electricians Handyman","oq_questions":"[{\"question\":\"Do you ever work on overhead high tension cables or pylons?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":328,"oq_targetId":"3","oq_occupation":"Engine-Driver \\ Operator","oq_questions":"[{\"question\":\"Do you ever have to spend time in a mine beneath the surface?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":329,"oq_targetId":"3","oq_occupation":"Engineer : Marine","oq_questions":"[{\"question\":\"Do you dive as part of your occupational duties?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":330,"oq_targetId":"3","oq_occupation":"Expedition Guide","oq_questions":"[{\"question\":\"Does your occupation require you to perform duties outside the borders of South Africa?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":336,"oq_targetId":"3","oq_occupation":"Farm Manager","oq_questions":"[{\"question\":\"Does your participation in the physical activities on the farm, including the operation or driving of agricultural implements, or the handling of livestock, but excluding the driving of light delivery vehicles, on average exceed half a day’s work per week?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":337,"oq_targetId":"3","oq_occupation":"Farmer","oq_questions":"[{\"question\":\"Does your participation in the physical activities on the farm, including the operation or driving of agricultural implements, or the handling of livestock, but excluding the driving of light delivery vehicles, on average exceed half a day’s work per week?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":338,"oq_targetId":"3","oq_occupation":"Fitter","oq_questions":"[{\"question\":\"Do you work in the mining industry?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":339,"oq_targetId":"3","oq_occupation":"Fitter And Turner","oq_questions":"[{\"question\":\"Do you work in the mining industry?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":340,"oq_targetId":"3","oq_occupation":"Flight Engineer (Commercial \\ Private Airline)","oq_questions":"[{\"question\":\"For which airline do you work as part of a crew?\",\"answers\":[\"1 eskader (scheduled)\",\"1time\",\"Air Afrique\",\"Air Austral\",\"Air Botswana\",\"Air France\",\"Air Gabon (aviation gsa)\",\"Air Madagascar(travel directions (pty) ltd)\",\"Air Malawi\",\"Air Mauritius\",\"Air Namibia (Pty) Ltd\",\"Air Portugal - tap\",\"Air Quarius contracts (pty) ltd\",\"Air Seychelles\",\"Air Tanzania corporation\",\"Air Zimbabwe\",\"Alitalia\",\"Alliance Express\",\"Angola Airlines (TAAG)\",\"Austrian Airlines\",\"Auto Spares\",\"Automal Pty Ltd\",\"Automall\",\"British Airways plc\",\"Cameroon Airlines\",\"Cargolux\",\"Cathay Pacific Airways Ltd\",\"Comair\",\"East African Airlines\",\"Egyptair\",\"El Al Israel Airlines\",\"Emirates\",\"Ethiopean Airlines\",\"Executive Aerospace\",\"Federal Air\",\"Ghana Airways Corporation\",\"Hydro Air\",\"Hewa Bora Airways\",\"Iberia Airlines of Spain\",\"Inter Air\",\"Interlink Airlines\",\"K.L.M\",\"Kenya Airways\",\"Khalifa Airways\",\"Kulula.com\",\"Lam-linhas Aereas De Mocambiqu\",\"Lufthansa German Airlines\",\"Malaysian Airlines\",\"Mango\",\"Martinair Holland\",\"Mrs Vliegdienste\",\"Nationwide\",\"Ncd and Partners\",\"Nel Air\",\"Olympic Airways\",\"Pelican Air Services\",\"Precision Air\",\"Quantas Airways Ltd\",\"Qatar Airways\",\"Regional Air\",\"Royal Air Maroc\",\"Rwandair Express\",\"S.A. Express\",\"SA Airlink\",\"Sabena Belgian World Airlines\",\"Safair\",\"Saudi Arabian Airlines\",\"Singapore Airlines\",\"Sobelair\",\"South African Airways\",\"Strato Air Services\",\"Swiss International Air lines (LX)\",\"Trans Air Congo\",\"TTA\",\"Turkish Airlines\",\"Varig\",\"Virgin Atlantic Airways Ltd\",\"Yemen Airways\",\"None of the above\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":341,"oq_targetId":"3","oq_occupation":"Flight Navigator (Commercial \\ Private Airline)","oq_questions":"[{\"question\":\"For which airline do you work as part of a crew?\",\"answers\":[\"1 eskader (scheduled)\",\"1time\",\"Air Afrique\",\"Air Austral\",\"Air Botswana\",\"Air France\",\"Air Gabon (aviation gsa)\",\"Air Madagascar(travel directions (pty) ltd)\",\"Air Malawi\",\"Air Mauritius\",\"Air Namibia (Pty) Ltd\",\"Air Portugal - tap\",\"Air Quarius contracts (pty) ltd\",\"Air Seychelles\",\"Air Tanzania corporation\",\"Air Zimbabwe\",\"Alitalia\",\"Alliance Express\",\"Angola Airlines (TAAG)\",\"Austrian Airlines\",\"Auto Spares\",\"Automal Pty Ltd\",\"Automall\",\"British Airways plc\",\"Cameroon Airlines\",\"Cargolux\",\"Cathay Pacific Airways Ltd\",\"Comair\",\"East African Airlines\",\"Egyptair\",\"El Al Israel Airlines\",\"Emirates\",\"Ethiopean Airlines\",\"Executive Aerospace\",\"Federal Air\",\"Ghana Airways Corporation\",\"Hydro Air\",\"Hewa Bora Airways\",\"Iberia Airlines of Spain\",\"Inter Air\",\"Interlink Airlines\",\"K.L.M\",\"Kenya Airways\",\"Khalifa Airways\",\"Kulula.com\",\"Lam-linhas Aereas De Mocambiqu\",\"Lufthansa German Airlines\",\"Malaysian Airlines\",\"Mango\",\"Martinair Holland\",\"Mrs Vliegdienste\",\"Nationwide\",\"Ncd and Partners\",\"Nel Air\",\"Olympic Airways\",\"Pelican Air Services\",\"Precision Air\",\"Quantas Airways Ltd\",\"Qatar Airways\",\"Regional Air\",\"Royal Air Maroc\",\"Rwandair Express\",\"S.A. Express\",\"SA Airlink\",\"Sabena Belgian World Airlines\",\"Safair\",\"Saudi Arabian Airlines\",\"Singapore Airlines\",\"Sobelair\",\"South African Airways\",\"Strato Air Services\",\"Swiss International Air lines (LX)\",\"Trans Air Congo\",\"TTA\",\"Turkish Airlines\",\"Varig\",\"Virgin Atlantic Airways Ltd\",\"Yemen Airways\",\"None of the above\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":344,"oq_targetId":"3","oq_occupation":"Foreign Correspondent \\ Columnist \\ Reporter","oq_questions":"[{\"question\":\"Is it expected of you to visit conflict areas outside the RSA borders, as a result of your responsibilities?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":351,"oq_targetId":"3","oq_occupation":"Hawks : All Other Ranks Lower Than Officer","oq_questions":"[{\"question\":\"What rank do you currently hold?\",\"answers\":[\"Constable\",\"Sergeant\",\"Warrant Officer\",\"Lieutenant\",\"Captain\",\"Lieutenant Colonel\",\"Colonel\",\"Brigadier\",\"Major General\",\"Lieutenant General\",\"General\",\"Administrative only personnel\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":352,"oq_targetId":"3","oq_occupation":"Hawks : Officer","oq_questions":"[{\"question\":\"What rank do you currently hold?\",\"answers\":[\"Constable\",\"Sergeant\",\"Warrant Officer\",\"Lieutenant\",\"Captain\",\"Lieutenant Colonel\",\"Colonel\",\"Brigadier\",\"Major General\",\"Lieutenant General\",\"General\",\"Administrative only personnel\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":353,"oq_targetId":"3","oq_occupation":"Helicopter Crew (Commercial \\ Private)","oq_questions":"[{\"question\":\"For which airline do you work as part of a crew?\",\"answers\":[\"1 eskader (scheduled)\",\"1time\",\"Air Afrique\",\"Air Austral\",\"Air Botswana\",\"Air France\",\"Air Gabon (aviation gsa)\",\"Air Madagascar(travel directions (pty) ltd)\",\"Air Malawi\",\"Air Mauritius\",\"Air Namibia (Pty) Ltd\",\"Air Portugal - tap\",\"Air Quarius contracts (pty) ltd\",\"Air Seychelles\",\"Air Tanzania corporation\",\"Air Zimbabwe\",\"Alitalia\",\"Alliance Express\",\"Angola Airlines (TAAG)\",\"Austrian Airlines\",\"Auto Spares\",\"Automal Pty Ltd\",\"Automall\",\"British Airways plc\",\"Cameroon Airlines\",\"Cargolux\",\"Cathay Pacific Airways Ltd\",\"Comair\",\"East African Airlines\",\"Egyptair\",\"El Al Israel Airlines\",\"Emirates\",\"Ethiopean Airlines\",\"Executive Aerospace\",\"Federal Air\",\"Ghana Airways Corporation\",\"Hydro Air\",\"Hewa Bora Airways\",\"Iberia Airlines of Spain\",\"Inter Air\",\"Interlink Airlines\",\"K.L.M\",\"Kenya Airways\",\"Khalifa Airways\",\"Kulula.com\",\"Lam-linhas Aereas De Mocambiqu\",\"Lufthansa German Airlines\",\"Malaysian Airlines\",\"Mango\",\"Martinair Holland\",\"Mrs Vliegdienste\",\"Nationwide\",\"Ncd and Partners\",\"Nel Air\",\"Olympic Airways\",\"Pelican Air Services\",\"Precision Air\",\"Quantas Airways Ltd\",\"Qatar Airways\",\"Regional Air\",\"Royal Air Maroc\",\"Rwandair Express\",\"S.A. Express\",\"SA Airlink\",\"Sabena Belgian World Airlines\",\"Safair\",\"Saudi Arabian Airlines\",\"Singapore Airlines\",\"Sobelair\",\"South African Airways\",\"Strato Air Services\",\"Swiss International Air lines (LX)\",\"Trans Air Congo\",\"TTA\",\"Turkish Airlines\",\"Varig\",\"Virgin Atlantic Airways Ltd\",\"Yemen Airways\",\"None of the above\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":355,"oq_targetId":"3","oq_occupation":"Homeopath","oq_questions":"[{\"question\":\"Are you a registered member of the Allied Health Professions Council of South Africa (AHPCSA)?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":361,"oq_targetId":"3","oq_occupation":"Hydrologist","oq_questions":"[{\"question\":\"Do you dive as part of your occupational duties?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":366,"oq_targetId":"3","oq_occupation":"Inspector Of Mines","oq_questions":"[{\"question\":\"Are you working in an open cast mine only?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":371,"oq_targetId":"3","oq_occupation":"Joiner","oq_questions":"[{\"question\":\"Do you work in the mining industry?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":372,"oq_targetId":"3","oq_occupation":"Journalist","oq_questions":"[{\"question\":\"Is it expected of you to visit conflict areas outside the RSA borders, as a result of your responsibilities?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":373,"oq_targetId":"3","oq_occupation":"Journalist - Tv \\ Media","oq_questions":"[{\"question\":\"Is it expected of you to visit conflict areas outside the RSA borders, as a result of your responsibilities?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":374,"oq_targetId":"3","oq_occupation":"Journalist : Free-Lance","oq_questions":"[{\"question\":\"Is it expected of you to visit conflict areas outside the RSA borders, as a result of your responsibilities?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":382,"oq_targetId":"3","oq_occupation":"Lineworker Electrician","oq_questions":"[{\"question\":\"Do you ever work on overhead high tension cables or pylons?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":384,"oq_targetId":"3","oq_occupation":"Loan Shark","oq_questions":"[{\"question\":\"Is your business registered with the MFRC (Micro Finance Regulatory Council) AND are you a member of MFSA (MicroFinance South Africa)?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":385,"oq_targetId":"3","oq_occupation":"Machine Operator \\ Supervisor","oq_questions":"[{\"question\":\"Do you ever have to spend time in a mine beneath the surface?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":386,"oq_targetId":"3","oq_occupation":"Machine Tool Setter","oq_questions":"[{\"question\":\"Do you work in the mining industry?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":388,"oq_targetId":"3","oq_occupation":"Managing Director Of Company","oq_questions":"[{\"question\":\"Which industry/business are you involved in?\",\"answers\":[\"Debt collecting business\",\"Mining industry\",\"Micro lending business\",\"Security business\",\"Shebeen business\",\"Taxi industry\",\"Not one of the above\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":389,"oq_targetId":"3","oq_occupation":"Marine Biologist","oq_questions":"[{\"question\":\"Do you dive as part of your occupational duties?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":390,"oq_targetId":"3","oq_occupation":"Marine Engineer","oq_questions":"[{\"question\":\"Do you dive as part of your occupational duties?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":391,"oq_targetId":"3","oq_occupation":"Marine Geologist","oq_questions":"[{\"question\":\"Do you dive as part of your occupational duties?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":392,"oq_targetId":"3","oq_occupation":"Masseuse \\ Masseur","oq_questions":"[{\"question\":\"Are you a registered member of the Allied Health Professions Council of South Africa (AHPCSA)?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":396,"oq_targetId":"3","oq_occupation":"Messenger (Office)","oq_questions":"[{\"question\":\"Do you use a motorcycle to perform your daily duties.\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":397,"oq_targetId":"3","oq_occupation":"Micro Lender","oq_questions":"[{\"question\":\"Is your business registered with the MFRC (Micro Finance Regulatory Council) AND are you a member of MFSA (MicroFinance South Africa)?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":398,"oq_targetId":"3","oq_occupation":"Micro Lender Employee","oq_questions":"[{\"question\":\"Is the business registered with the MFRC (Micro Finance Regulatory Council) AND is the owner a member of MFSA (MicroFinance South Africa)?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":399,"oq_targetId":"3","oq_occupation":"Military Adviser","oq_questions":"[{\"question\":\"Are you a member of the Special Forces and/or Reconnaissance Commando?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":402,"oq_targetId":"3","oq_occupation":"Mining : Banksman","oq_questions":"[{\"question\":\"Are you working in an open cast mine only?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":403,"oq_targetId":"3","oq_occupation":"Mining : Boilermaker","oq_questions":"[{\"question\":\"Are you working in an open cast mine only?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":404,"oq_targetId":"3","oq_occupation":"Mining : Construction Carpenter","oq_questions":"[{\"question\":\"Are you working in an open cast mine only?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":405,"oq_targetId":"3","oq_occupation":"Mining : Diesel Fitter","oq_questions":"[{\"question\":\"Are you working in an open cast mine only?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":406,"oq_targetId":"3","oq_occupation":"Mining : Diesel Mechanic","oq_questions":"[{\"question\":\"Are you working in an open cast mine only?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":407,"oq_targetId":"3","oq_occupation":"Mining : Electrician","oq_questions":"[{\"question\":\"Are you working in an open cast mine only?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":408,"oq_targetId":"3","oq_occupation":"Mining : Engineer","oq_questions":"[{\"question\":\"Are you working in an open cast mine only?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":409,"oq_targetId":"3","oq_occupation":"Mining : Fitter","oq_questions":"[{\"question\":\"Are you working in an open cast mine only?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":410,"oq_targetId":"3","oq_occupation":"Mining : Handyman Underground","oq_questions":"[{\"question\":\"Are you working in an open cast mine only?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":411,"oq_targetId":"3","oq_occupation":"Mining : Mason (Underground)","oq_questions":"[{\"question\":\"Are you working in an open cast mine only?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":412,"oq_targetId":"3","oq_occupation":"Mining : Master Shaft-Sinker","oq_questions":"[{\"question\":\"Are you working in an open cast mine only?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":414,"oq_targetId":"3","oq_occupation":"Mining : Mine Inspector","oq_questions":"[{\"question\":\"Are you working in an open cast mine only?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":416,"oq_targetId":"3","oq_occupation":"Mining : Pipeman","oq_questions":"[{\"question\":\"Are you working in an open cast mine only?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":417,"oq_targetId":"3","oq_occupation":"Mining : Plate Layer","oq_questions":"[{\"question\":\"Are you working in an open cast mine only?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":418,"oq_targetId":"3","oq_occupation":"Mining : Pumpsman","oq_questions":"[{\"question\":\"Are you working in an open cast mine only?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":419,"oq_targetId":"3","oq_occupation":"Mining : Sampler","oq_questions":"[{\"question\":\"Are you working in an open cast mine only?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":420,"oq_targetId":"3","oq_occupation":"Mining : Shaft-Foreman","oq_questions":"[{\"question\":\"Are you working in an open cast mine only?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":422,"oq_targetId":"3","oq_occupation":"Mining : Skip Man","oq_questions":"[{\"question\":\"Are you working in an open cast mine only?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":424,"oq_targetId":"3","oq_occupation":"Mining : Surveyor Underground","oq_questions":"[{\"question\":\"Are you working in an open cast mine only?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":425,"oq_targetId":"3","oq_occupation":"Mining : Trainee Official Underground","oq_questions":"[{\"question\":\"Are you working in an open cast mine only?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":426,"oq_targetId":"3","oq_occupation":"Mining : Underground Ventilation Inspector","oq_questions":"[{\"question\":\"Are you working in an open cast mine only?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":427,"oq_targetId":"3","oq_occupation":"Mining : Welder (Underground)","oq_questions":"[{\"question\":\"Are you working in an open cast mine only?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":428,"oq_targetId":"3","oq_occupation":"Mining Officer","oq_questions":"[{\"question\":\"Are you working in an open cast mine only?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":429,"oq_targetId":"3","oq_occupation":"Mining Surveyor","oq_questions":"[{\"question\":\"Are you working in an open cast mine only?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":430,"oq_targetId":"3","oq_occupation":"Missionary","oq_questions":"[{\"question\":\"Does your occupation require you to perform duties outside the borders of South Africa?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":431,"oq_targetId":"3","oq_occupation":"Money Lender","oq_questions":"[{\"question\":\"Is your business registered with the MFRC (Micro Finance Regulatory Council) AND are you a member of MFSA (MicroFinance South Africa)?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":433,"oq_targetId":"3","oq_occupation":"Motor Racing Driver","oq_questions":"[{\"question\":\"The system is about to ask you a number of questions and is likely to reach a decision. Should you not answer the questions now, the case will be referred to underwriting with further requirements. Do you wish to continue?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":435,"oq_targetId":"3","oq_occupation":"Motorcycle Racing Driver","oq_questions":"[{\"question\":\"The system is about to ask you a number of questions and is likely to reach a decision. Should you not answer the questions now, the case will be referred to underwriting with further requirements. Do you wish to continue?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":437,"oq_targetId":"3","oq_occupation":"News : Interviewer","oq_questions":"[{\"question\":\"Is it expected of you to visit conflict areas outside the RSA borders, as a result of your responsibilities?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":438,"oq_targetId":"3","oq_occupation":"News : Journalist \\ Writer","oq_questions":"[{\"question\":\"Is it expected of you to visit conflict areas outside the RSA borders, as a result of your responsibilities?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":439,"oq_targetId":"3","oq_occupation":"News : Photographer","oq_questions":"[{\"question\":\"Is it expected of you to visit conflict areas outside the RSA borders, as a result of your responsibilities?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":440,"oq_targetId":"3","oq_occupation":"News : Reporter","oq_questions":"[{\"question\":\"Is it expected of you to visit conflict areas outside the RSA borders, as a result of your responsibilities?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":441,"oq_targetId":"3","oq_occupation":"News Agency Manager \\ Owner","oq_questions":"[{\"question\":\"Is it expected of you to visit conflict areas outside the RSA borders, as a result of your responsibilities?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":442,"oq_targetId":"3","oq_occupation":"Newspaper : Columnist","oq_questions":"[{\"question\":\"Is it expected of you to visit conflict areas outside the RSA borders, as a result of your responsibilities?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":443,"oq_targetId":"3","oq_occupation":"Newspaper : Journalist","oq_questions":"[{\"question\":\"Is it expected of you to visit conflict areas outside the RSA borders, as a result of your responsibilities?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":444,"oq_targetId":"3","oq_occupation":"Newspaper : Reporter","oq_questions":"[{\"question\":\"Is it expected of you to visit conflict areas outside the RSA borders, as a result of your responsibilities?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":445,"oq_targetId":"3","oq_occupation":"Newspaper : Writer","oq_questions":"[{\"question\":\"Is it expected of you to visit conflict areas outside the RSA borders, as a result of your responsibilities?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":448,"oq_targetId":"3","oq_occupation":"Oceanographer","oq_questions":"[{\"question\":\"Do you dive as part of your occupational duties?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":449,"oq_targetId":"3","oq_occupation":"Oceanographic Researcher","oq_questions":"[{\"question\":\"Do you dive as part of your occupational duties?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":452,"oq_targetId":"3","oq_occupation":"Office Messenger","oq_questions":"[{\"question\":\"Do you use a motorcycle to perform your daily duties.\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":453,"oq_targetId":"3","oq_occupation":"Oil Rig : Catering Staff","oq_questions":"[{\"question\":\"Do you dive as part of your occupational duties?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":454,"oq_targetId":"3","oq_occupation":"Oil Rig : Chemical Engineer","oq_questions":"[{\"question\":\"Do you dive as part of your occupational duties?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":455,"oq_targetId":"3","oq_occupation":"Oil Rig : Chemist","oq_questions":"[{\"question\":\"Do you dive as part of your occupational duties?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":456,"oq_targetId":"3","oq_occupation":"Oil Rig : Driller","oq_questions":"[{\"question\":\"Do you dive as part of your occupational duties?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":457,"oq_targetId":"3","oq_occupation":"Oil Rig : Engineer","oq_questions":"[{\"question\":\"Do you dive as part of your occupational duties?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":458,"oq_targetId":"3","oq_occupation":"Oil Rig : Fitter","oq_questions":"[{\"question\":\"Do you dive as part of your occupational duties?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":459,"oq_targetId":"3","oq_occupation":"Oil Rig : Fusing-Burner","oq_questions":"[{\"question\":\"Do you dive as part of your occupational duties?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":460,"oq_targetId":"3","oq_occupation":"Oil Rig : Geologist","oq_questions":"[{\"question\":\"Do you dive as part of your occupational duties?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":461,"oq_targetId":"3","oq_occupation":"Oil Rig : Geophysicist","oq_questions":"[{\"question\":\"Do you dive as part of your occupational duties?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":462,"oq_targetId":"3","oq_occupation":"Oil Rig : Maintenance Technician","oq_questions":"[{\"question\":\"Do you dive as part of your occupational duties?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":463,"oq_targetId":"3","oq_occupation":"Oil Rig : Mechanic","oq_questions":"[{\"question\":\"Do you dive as part of your occupational duties?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":464,"oq_targetId":"3","oq_occupation":"Oil Rig : Medic","oq_questions":"[{\"question\":\"Do you dive as part of your occupational duties?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":465,"oq_targetId":"3","oq_occupation":"Oil Rig : Operator","oq_questions":"[{\"question\":\"Do you dive as part of your occupational duties?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":466,"oq_targetId":"3","oq_occupation":"Oil Rig : Pipe-Fitter","oq_questions":"[{\"question\":\"Do you dive as part of your occupational duties?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":467,"oq_targetId":"3","oq_occupation":"Oil Rig : Radiographer","oq_questions":"[{\"question\":\"Do you dive as part of your occupational duties?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":468,"oq_targetId":"3","oq_occupation":"Oil Rig : Rigger","oq_questions":"[{\"question\":\"Do you dive as part of your occupational duties?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":469,"oq_targetId":"3","oq_occupation":"Oil Rig : Safety Personnel","oq_questions":"[{\"question\":\"Do you dive as part of your occupational duties?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":470,"oq_targetId":"3","oq_occupation":"Oil Rig : Seismologist","oq_questions":"[{\"question\":\"Do you dive as part of your occupational duties?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":471,"oq_targetId":"3","oq_occupation":"Oil Rig : Storekeeper","oq_questions":"[{\"question\":\"Do you dive as part of your occupational duties?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":472,"oq_targetId":"3","oq_occupation":"Oil Rig : Supervisor","oq_questions":"[{\"question\":\"Do you dive as part of your occupational duties?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":473,"oq_targetId":"3","oq_occupation":"Oil Rig : Technician","oq_questions":"[{\"question\":\"Do you dive as part of your occupational duties?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":474,"oq_targetId":"3","oq_occupation":"Oil Rig : Valveman","oq_questions":"[{\"question\":\"Do you dive as part of your occupational duties?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":475,"oq_targetId":"3","oq_occupation":"Oil Rig : Welder","oq_questions":"[{\"question\":\"Do you dive as part of your occupational duties?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":476,"oq_targetId":"3","oq_occupation":"Oil Rig : Worker","oq_questions":"[{\"question\":\"Do you dive as part of your occupational duties?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":478,"oq_targetId":"3","oq_occupation":"Orthotist","oq_questions":"[{\"question\":\"Are you a registered member of the Allied Health Professions Council of South Africa (AHPCSA)?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":482,"oq_targetId":"3","oq_occupation":"Owner : Diamond Mine","oq_questions":"[{\"question\":\"Are you personally involved in collecting the diamond bearing gravel?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":497,"oq_targetId":"3","oq_occupation":"Parachutist","oq_questions":"[{\"question\":\"Do you do parachuting exclusively as a part of military or citizen force duties?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":502,"oq_targetId":"3","oq_occupation":"Photographer : Advertising","oq_questions":"[{\"question\":\"Is it expected of you to visit conflict areas outside the RSA borders, as a result of your responsibilities?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":503,"oq_targetId":"3","oq_occupation":"Photographer : Commercial","oq_questions":"[{\"question\":\"Is it expected of you to visit conflict areas outside the RSA borders, as a result of your responsibilities?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":504,"oq_targetId":"3","oq_occupation":"Photographer : Fashion","oq_questions":"[{\"question\":\"Is it expected of you to visit conflict areas outside the RSA borders, as a result of your responsibilities?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":505,"oq_targetId":"3","oq_occupation":"Photographer : Street","oq_questions":"[{\"question\":\"Is it expected of you to visit conflict areas outside the RSA borders, as a result of your responsibilities?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":506,"oq_targetId":"3","oq_occupation":"Photographer : Studio","oq_questions":"[{\"question\":\"Is it expected of you to visit conflict areas outside the RSA borders, as a result of your responsibilities?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":507,"oq_targetId":"3","oq_occupation":"Photographer : Wedding","oq_questions":"[{\"question\":\"Is it expected of you to visit conflict areas outside the RSA borders, as a result of your responsibilities?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":508,"oq_targetId":"3","oq_occupation":"Photographic Artist","oq_questions":"[{\"question\":\"Is it expected of you to visit conflict areas outside the RSA borders, as a result of your responsibilities?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":510,"oq_targetId":"3","oq_occupation":"Platelayer","oq_questions":"[{\"question\":\"Do you work in the mining industry?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":511,"oq_targetId":"3","oq_occupation":"Plumber","oq_questions":"[{\"question\":\"Are you personally involved in the physical operations of the business?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":512,"oq_targetId":"3","oq_occupation":"Plumbing Contractor","oq_questions":"[{\"question\":\"Are you personally involved in the physical operations of the business?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":513,"oq_targetId":"3","oq_occupation":"Podiatrist","oq_questions":"[{\"question\":\"Are you a registered member of the Allied Health Professions Council of South Africa (AHPCSA)?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":514,"oq_targetId":"3","oq_occupation":"Political Commentator","oq_questions":"[{\"question\":\"Is it expected of you to visit conflict areas outside the RSA borders, as a result of your responsibilities?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":515,"oq_targetId":"3","oq_occupation":"Political Interviewer","oq_questions":"[{\"question\":\"Is it expected of you to visit conflict areas outside the RSA borders, as a result of your responsibilities?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":516,"oq_targetId":"3","oq_occupation":"Political Journalist \\ Reporter \\ Writer","oq_questions":"[{\"question\":\"Is it expected of you to visit conflict areas outside the RSA borders, as a result of your responsibilities?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":518,"oq_targetId":"3","oq_occupation":"Poultry-Farmer","oq_questions":"[{\"question\":\"Does your participation in the physical activities on the farm, including the operation or driving of agricultural implements, or the handling of livestock, but excluding the driving of light delivery vehicles, on average exceed half a day’s work per week?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":519,"oq_targetId":"3","oq_occupation":"Power Line Worker","oq_questions":"[{\"question\":\"Do you work in the mining industry?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":527,"oq_targetId":"3","oq_occupation":"Prosthetist","oq_questions":"[{\"question\":\"Are you a registered member of the Allied Health Professions Council of South Africa (AHPCSA)?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":533,"oq_targetId":"3","oq_occupation":"Racing Driver","oq_questions":"[{\"question\":\"The system is about to ask you a number of questions and is likely to reach a decision. Should you not answer the questions now, the case will be referred to underwriting with further requirements. Do you wish to continue?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":535,"oq_targetId":"3","oq_occupation":"Radio Reporter","oq_questions":"[{\"question\":\"Is it expected of you to visit conflict areas outside the RSA borders, as a result of your responsibilities?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":536,"oq_targetId":"3","oq_occupation":"Railworker","oq_questions":"[{\"question\":\"Do you work in the mining industry?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":538,"oq_targetId":"3","oq_occupation":"Reflexologist","oq_questions":"[{\"question\":\"Are you a registered member of the Allied Health Professions Council of South Africa (AHPCSA)?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":539,"oq_targetId":"3","oq_occupation":"Relief Worker","oq_questions":"[{\"question\":\"Does your occupation require you to perform duties outside the borders of South Africa?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":541,"oq_targetId":"3","oq_occupation":"Reporter","oq_questions":"[{\"question\":\"Is it expected of you to visit conflict areas outside the RSA borders, as a result of your responsibilities?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":550,"oq_targetId":"3","oq_occupation":"Salvage Worker","oq_questions":"[{\"question\":\"Do you dive as part of your occupational duties?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":554,"oq_targetId":"3","oq_occupation":"Scholar","oq_questions":"[{\"question\":\"Are you presently engaged in studies at a tertiary education provider, e.g. university, technikon or college?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":555,"oq_targetId":"3","oq_occupation":"Search And Rescue Worker","oq_questions":"[{\"question\":\"Do you dive as part of your occupational duties?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":557,"oq_targetId":"3","oq_occupation":"Security Forces : Aircraft Joiner","oq_questions":"[{\"question\":\"Are you involved in any type of aviation or flying in your normal occupation?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":558,"oq_targetId":"3","oq_occupation":"Security Forces : Airforce","oq_questions":"[{\"question\":\"In which of the following divisions of the Airforce are you involved in?\",\"answers\":[\"Pilots\",\"Aircrew\",\"Trainee pilots\",\"Air traffic controller\",\"Ground crew technical work\",\"Ground crew administrative work\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":559,"oq_targetId":"3","oq_occupation":"Security Forces : Army","oq_questions":"[{\"question\":\"What rank do you currently hold?\",\"answers\":[\"Serviceman\",\"Lance Corporal\",\"Corporal\",\"Sergeant\",\"Staff Sergeant\",\"Warrant Officer\",\"Sergeant-Major\",\"Candidate Officer\",\"Lieutenant\",\"Captain\",\"Major\",\"Commandant\",\"Lieutenant-Colonel\",\"Colonel\",\"Brigadier\",\"General\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":560,"oq_targetId":"3","oq_occupation":"Security Forces : Correctional Services","oq_questions":"[{\"question\":\"What rank do you currently hold?\",\"answers\":[\"Correctional officer grade II and lower\",\"Correctional officer grade I and higher\",\"Administrative Personnel (without rank)\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":561,"oq_targetId":"3","oq_occupation":"Security Forces : Medical Health Services","oq_questions":"[{\"question\":\"What rank do you currently hold?\",\"answers\":[\"Serviceman\",\"Lance Corporal\",\"Corporal\",\"Sergeant\",\"Staff Sergeant\",\"Warrant Officer\",\"Sergeant-Major\",\"Candidate Officer\",\"Lieutenant\",\"Captain\",\"Major\",\"Commandant\",\"Lieutenant-Colonel\",\"Colonel\",\"Brigadier\",\"General\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":562,"oq_targetId":"3","oq_occupation":"Security Forces : Navy","oq_questions":"[{\"question\":\"What rank do you currently hold?\",\"answers\":[\"Seaman\",\"Leading Seaman\",\"Petty Officer\",\"Chief Petty Officer\",\"Warrant Officer\",\"Master at Arms / Coxswain\",\"Shipman\",\"Ensign\",\"Lieutenant\",\"Commander\",\"Captain\",\"Commodore\",\"Admiral\",\"Ableseaman\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":563,"oq_targetId":"3","oq_occupation":"Security Forces : Police","oq_questions":"[{\"question\":\"What rank do you currently hold?\",\"answers\":[\"Constable\",\"Sergeant\",\"Warrant Officer\",\"Lieutenant\",\"Captain\",\"Lieutenant Colonel\",\"Colonel\",\"Brigadier\",\"Major General\",\"Lieutenant General\",\"General\",\"Administrative only personnel\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":564,"oq_targetId":"3","oq_occupation":"Security Guard \\ Patrolman \\ Worker","oq_questions":"[{\"question\":\"Are you required to carry a firearm, handle cash or work in a bank as part of your occupational duties?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":565,"oq_targetId":"3","oq_occupation":"Security Officer \\ Supervisor","oq_questions":"[{\"question\":\"Are you required to carry a firearm, handle cash or work in a bank as part of your occupational duties?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":567,"oq_targetId":"3","oq_occupation":"Seismologist","oq_questions":"[{\"question\":\"Do you work in the mining industry?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":571,"oq_targetId":"3","oq_occupation":"Shipbuilder \\ Repairer","oq_questions":"[{\"question\":\"Do you dive as part of your occupational duties?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":574,"oq_targetId":"3","oq_occupation":"Shipyard Worker","oq_questions":"[{\"question\":\"Do you dive as part of your occupational duties?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":575,"oq_targetId":"3","oq_occupation":"Shop Designer","oq_questions":"[{\"question\":\"Which of these options best fits your daily duties?\",\"answers\":[\"Only installation of shop fittings etc.\",\"Only designing of shop fittings and layout\",\"Designing and Installation of shop fittings and layout\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":576,"oq_targetId":"3","oq_occupation":"Shop Fitter","oq_questions":"[{\"question\":\"Which of these options best fits your daily duties?\",\"answers\":[\"Only installation of shop fittings etc.\",\"Only designing of shop fittings and layout\",\"Designing and Installation of shop fittings and layout\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":587,"oq_targetId":"3","oq_occupation":"Student","oq_questions":"[{\"question\":\"Are you a full-time student at a University, in at least your 4th academic year, following a 4 year or longer course, or Honours degree or higher qualification?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":598,"oq_targetId":"3","oq_occupation":"Tool Fitter \\ Maker \\ Setter","oq_questions":"[{\"question\":\"Do you work in the mining industry?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":605,"oq_targetId":"3","oq_occupation":"Transport Vehicle Owner","oq_questions":"[{\"question\":\"Are you personally involved in the physical operations of the business?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":606,"oq_targetId":"3","oq_occupation":"Treasurer","oq_questions":"[{\"question\":\"Did you successfully complete the SAIPA Professional Evaluation(PE)?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":608,"oq_targetId":"3","oq_occupation":"Tunnel Worker","oq_questions":"[{\"question\":\"Do you ever have to spend time in a mine beneath the surface?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":610,"oq_targetId":"3","oq_occupation":"Vehicle Recovery Company : Member Of Recovery Unit","oq_questions":"[{\"question\":\"Are you required to carry a firearm, handle cash or work in a bank as part of your occupational duties?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":613,"oq_targetId":"3","oq_occupation":"Vineyard Manager","oq_questions":"[{\"question\":\"Does your participation in the physical activities on the farm, including the operation or driving of agricultural implements, or the handling of livestock, but excluding the driving of light delivery vehicles, on average exceed half a day’s work per week?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":619,"oq_targetId":"3","oq_occupation":"Well Sinker","oq_questions":"[{\"question\":\"Are you personally involved in the physical operations of the business?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":629,"oq_targetId":"3","oq_occupation":"Business Owner","oq_questions":"[{\"question\":\"Which industry/business are you involved in?\",\"answers\":[\"Debt collecting business\",\"Mining industry\",\"Micro lending business\",\"Security business\",\"Shebeen business\",\"Taxi industry\",\"None of the above\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":630,"oq_targetId":"3","oq_occupation":"Director Of Company","oq_questions":"[{\"question\":\"Which industry/business are you involved in?\",\"answers\":[\"Debt collecting business\",\"Mining industry\",\"Micro lending business\",\"Security business\",\"Shebeen business\",\"Taxi industry\",\"None of the above\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":631,"oq_targetId":"10","oq_occupation":"Journalist","oq_questions":"[{\"question\":\"On average, for how many hours per week do you actively engage in duties in the field (i.e. outside of an office environment?\",\"answers\":[\"Less Than 10 Hours\",\"More Than 10 Hours\"],\"questionType\":\"dropdown\"}]"}]);

/***/ }),
/* 2678 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_core__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_Wrappers_materialUIWrappers_components_FormDropDown__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_helpers_ValidationHelpers__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_CustomFields_CustomFields_jsx__ = __webpack_require__(38);
var fmi=function fmi(props){var occupationalQuestions=[];if(props.occupationQuestions&&props.occupationQuestions.length>0){props.occupationQuestions.map(function(o){var parsedQs=JSON.parse(o.oq_questions);parsedQs.map(function(q,i){occupationalQuestions.push({id:o.oq_Id+"q"+i,question:q});return q;});return o;});}return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{container:true},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_CustomFields_CustomFields_jsx__["a" /* FullField */],{name:"workOutsideBorder",label:"Does your job require you to work outside of the borders of R.S.A? *",component:__WEBPACK_IMPORTED_MODULE_2_components_Wrappers_materialUIWrappers_components_FormDropDown__["a" /* default */],checkValidation:props.checkValidation,isrequired:true,validate:[__WEBPACK_IMPORTED_MODULE_3_helpers_ValidationHelpers__["h" /* requiredDropdown */]],options:[{value:"validationError",displayValue:"Please select"},{value:"Y",displayValue:"Yes"},{value:"N",displayValue:"No"}]}),occupationalQuestions.map(function(o){var answersOptions=[{value:"validationError",displayValue:"Please select"}];o.question.answers.map(function(a){answersOptions.push({value:a,displayValue:a});return a;});return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:12},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{variant:"caption"},o.question.question)),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_CustomFields_CustomFields_jsx__["a" /* FullField */],{name:"occupationalQs.target10."+o.id,component:__WEBPACK_IMPORTED_MODULE_2_components_Wrappers_materialUIWrappers_components_FormDropDown__["a" /* default */],checkValidation:props.checkValidation,isrequired:true,validate:[__WEBPACK_IMPORTED_MODULE_3_helpers_ValidationHelpers__["h" /* requiredDropdown */]],options:answersOptions}));}));};/* harmony default export */ __webpack_exports__["a"] = (fmi);

/***/ }),
/* 2679 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_core__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_Wrappers_materialUIWrappers_components_FormDropDown__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_helpers_ValidationHelpers__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_store__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_CustomFields_CustomFields_jsx__ = __webpack_require__(38);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Momentum=function(_React$Component){_inherits(Momentum,_React$Component);function Momentum(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Momentum);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Momentum.__proto__||Object.getPrototypeOf(Momentum)).call.apply(_ref,[this].concat(args))),_this),_this.multiplyMemberValidate=function(value){return!_this.isMultiplyMember()?undefined:Object(__WEBPACK_IMPORTED_MODULE_2_helpers_ValidationHelpers__["h" /* requiredDropdown */])(value);},_this.heartScoreValidate=function(value){return!_this.isMultiplyMember()?undefined:Object(__WEBPACK_IMPORTED_MODULE_2_helpers_ValidationHelpers__["h" /* requiredDropdown */])(value);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Momentum,[{key:'isMultiplyMember',value:function isMultiplyMember(){var multiplyMembership=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(__WEBPACK_IMPORTED_MODULE_5_store__["a" /* default */].getState().form.quotev2,'values.multiplyMembership',null);return multiplyMembership==='2'||multiplyMembership==='3'?multiplyMembership:false;}},{key:'render',value:function render(){var _this2=this;var multiplyMember=this.isMultiplyMember();return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{container:true},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_CustomFields_CustomFields_jsx__["a" /* FullField */],{name:'momentumInteractive',label:'Momentum interactive *',component:__WEBPACK_IMPORTED_MODULE_1_components_Wrappers_materialUIWrappers_components_FormDropDown__["a" /* default */],checkValidation:this.props.checkValidation,isrequired:true,validate:[__WEBPACK_IMPORTED_MODULE_2_helpers_ValidationHelpers__["h" /* requiredDropdown */]],options:[{value:'validationError',displayValue:'Please select'},{value:'A',displayValue:'Yes'},{value:'N',displayValue:'No'}]}),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_CustomFields_CustomFields_jsx__["a" /* FullField */],{name:'multiplyMembership',label:'Multiply membership *',component:__WEBPACK_IMPORTED_MODULE_1_components_Wrappers_materialUIWrappers_components_FormDropDown__["a" /* default */],checkValidation:this.props.checkValidation,isrequired:true,validate:[__WEBPACK_IMPORTED_MODULE_2_helpers_ValidationHelpers__["h" /* requiredDropdown */]],onChange:function onChange(){return _this2.props.forceUpdate();},options:[{value:'validationError',displayValue:'Please select'},{value:'1',displayValue:'Not a Multiply member'},{value:'2',displayValue:'Current Multiply member'},{value:'3',displayValue:'New application - main member'}]}),!multiplyMember||multiplyMember==3?null:__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_CustomFields_CustomFields_jsx__["a" /* FullField */],{name:'multiplyStatus',label:'Multiply member status *',component:__WEBPACK_IMPORTED_MODULE_1_components_Wrappers_materialUIWrappers_components_FormDropDown__["a" /* default */],checkValidation:this.props.checkValidation,isrequired:true,validate:[this.multiplyMemberValidate],options:[{value:'validationError',displayValue:'Please select'},{value:'B',displayValue:'Bronze'},{value:'G',displayValue:'Gold'},{value:'P',displayValue:'Platinum'},{value:'C',displayValue:'Private Club'},{value:'S',displayValue:'Silver'}]}),!multiplyMember||multiplyMember!=3?null:__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_CustomFields_CustomFields_jsx__["a" /* FullField */],{name:'multiplyStatus',label:'Multiply member status *',component:__WEBPACK_IMPORTED_MODULE_1_components_Wrappers_materialUIWrappers_components_FormDropDown__["a" /* default */],checkValidation:this.props.checkValidation,isrequired:true,validate:[this.multiplyMemberValidate],options:[{value:'B',displayValue:'Bronze'}]}),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_CustomFields_CustomFields_jsx__["a" /* FullField */],{name:'MSTIDriver',label:'MSTI Driver *',component:__WEBPACK_IMPORTED_MODULE_1_components_Wrappers_materialUIWrappers_components_FormDropDown__["a" /* default */],checkValidation:this.props.checkValidation,isrequired:true,validate:[__WEBPACK_IMPORTED_MODULE_2_helpers_ValidationHelpers__["h" /* requiredDropdown */]],options:[{value:'validationError',displayValue:'Please select'},{value:'N',displayValue:'No'},{value:'Y',displayValue:'Yes'}]}),!multiplyMember?null:__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_CustomFields_CustomFields_jsx__["a" /* FullField */],{name:'heartScore',label:'Healthy heart score *',component:__WEBPACK_IMPORTED_MODULE_1_components_Wrappers_materialUIWrappers_components_FormDropDown__["a" /* default */],checkValidation:this.props.checkValidation,isrequired:true,validate:[this.heartScoreValidate],options:[{value:'validationError',displayValue:'Please select'},{value:'R',displayValue:'Red'},{value:'A',displayValue:'Amber'},{value:'G',displayValue:'Green'}]}));}}]);return Momentum;}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Momentum);

/***/ }),
/* 2680 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_core__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_Wrappers_materialUIWrappers_components_FormDropDown__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_helpers_ValidationHelpers__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_CustomFields_CustomFields_jsx__ = __webpack_require__(38);
var sanlam=function sanlam(props){var occupationalQuestions=[];if(props.occupationQuestions&&props.occupationQuestions.length>0){props.occupationQuestions.map(function(o){var parsedQs=JSON.parse(o.oq_questions);parsedQs.map(function(q,i){occupationalQuestions.push({id:o.oq_Id+"q"+i,question:q});return q;});return o;});}return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{container:true},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_CustomFields_CustomFields_jsx__["a" /* FullField */],{name:"ProductOption",label:"Product option *",component:__WEBPACK_IMPORTED_MODULE_2_components_Wrappers_materialUIWrappers_components_FormDropDown__["a" /* default */],checkValidation:props.checkValidation,isrequired:true,validate:[__WEBPACK_IMPORTED_MODULE_3_helpers_ValidationHelpers__["h" /* requiredDropdown */]],options:[{value:"validationError",displayValue:"Please select"},//{ value: "Comprehensive", displayValue: "Premier" },
{value:"Classic",displayValue:"Classic"}]}),occupationalQuestions.map(function(o){var answersOptions=[{value:"validationError",displayValue:"Please select"}];o.question.answers.map(function(a){answersOptions.push({value:a,displayValue:a});return a;});return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:12},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{variant:"caption"},o.question.question)),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_CustomFields_CustomFields_jsx__["a" /* FullField */],{name:"occupationalQs.target3."+o.id,component:__WEBPACK_IMPORTED_MODULE_2_components_Wrappers_materialUIWrappers_components_FormDropDown__["a" /* default */],checkValidation:props.checkValidation,isrequired:true,validate:[__WEBPACK_IMPORTED_MODULE_3_helpers_ValidationHelpers__["h" /* requiredDropdown */]],options:answersOptions}));}));};/* harmony default export */ __webpack_exports__["a"] = (sanlam);

/***/ }),
/* 2681 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_core__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_CustomCardHeading_CustomCardHeading_jsx__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_Grid_GridItem_jsx__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Wrappers_materialUIWrappers_components_FormDropDown__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Wrappers_materialUIWrappers_components_FormInput__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_Wrappers_materialUIWrappers_components_NumberInput__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_helpers_ValidationHelpers__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_redux_form__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_date_fns__ = __webpack_require__(418);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_date_fns___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_date_fns__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var required=function required(value){return value?undefined:'Required';};var dates=function dates(){var options=[];var today=new Date();for(var i=0;i<2;i++){var monthX=Object(__WEBPACK_IMPORTED_MODULE_9_date_fns__["addMonths"])(today,i+2);var month=monthX.getMonth();if(month<1)month=12;if(month<10){var item='01/0'+month+'/'+monthX.getFullYear();if(item.includes("/00/"))item.replace("/00/","/12/");options.push(item);}else{var item='01/'+month+'/'+today.getFullYear();if(item.includes("/00/"))item.replace("/00/","/12/");options.push(item);}}return options;};var makeOptions=function makeOptions(values){var options=[{value:'validationError',displayValue:'Please select'}];var _iteratorNormalCompletion=true;var _didIteratorError=false;var _iteratorError=undefined;try{for(var _iterator=values[Symbol.iterator](),_step;!(_iteratorNormalCompletion=(_step=_iterator.next()).done);_iteratorNormalCompletion=true){var value=_step.value;if((typeof value==='undefined'?'undefined':_typeof(value))==='object'){options.push(value);}else{options.push(value);}}}catch(err){_didIteratorError=true;_iteratorError=err;}finally{try{if(!_iteratorNormalCompletion&&_iterator.return){_iterator.return();}}finally{if(_didIteratorError){throw _iteratorError;}}}return options;};var CustomField=function CustomField(props){return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:6,style:{marginBottom:'25px'}},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["t" /* FormControl */],{fullWidth:true},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_redux_form__["a" /* Field */],props)));};var QuoteDetailsPage=function(_React$Component){_inherits(QuoteDetailsPage,_React$Component);function QuoteDetailsPage(){_classCallCheck(this,QuoteDetailsPage);return _possibleConstructorReturn(this,(QuoteDetailsPage.__proto__||Object.getPrototypeOf(QuoteDetailsPage)).apply(this,arguments));}_createClass(QuoteDetailsPage,[{key:'componentDidMount',value:function componentDidMount(){this.props.scrollMeBar();}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('div',{className:'contentWithStepper'},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["e" /* Card */],null,__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["f" /* CardContent */],null,__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_CustomCardHeading_CustomCardHeading_jsx__["a" /* default */],{subheading:'Quote Generation',caption:this.props.clientFullname,headline:'General Quote Details'}),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{container:true},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(CustomField,{name:'description',component:__WEBPACK_IMPORTED_MODULE_4_components_Wrappers_materialUIWrappers_components_FormInput__["a" /* default */],checkValidation:this.props.checkValidation,label:'Quote Description *',isrequired:true,validate:[required]}),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(CustomField,{name:'language',component:__WEBPACK_IMPORTED_MODULE_3_components_Wrappers_materialUIWrappers_components_FormDropDown__["a" /* default */],checkValidation:this.props.checkValidation,label:'Language *',isrequired:true,validate:[required],options:[{value:'English',displayValue:'English'},{value:'Afrikaans',displayValue:'Afrikaans'}]}),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(CustomField,{name:'startDate',component:__WEBPACK_IMPORTED_MODULE_3_components_Wrappers_materialUIWrappers_components_FormDropDown__["a" /* default */],checkValidation:this.props.checkValidation,label:'Start Date *',isrequired:true,validate:[required],options:makeOptions(dates())}),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(CustomField,{name:'premiumPattern',component:__WEBPACK_IMPORTED_MODULE_3_components_Wrappers_materialUIWrappers_components_FormDropDown__["a" /* default */],checkValidation:this.props.checkValidation,label:'Premium Pattern *',isrequired:true,validate:[required],options:makeOptions([{value:'Level',displayValue:'Level'},{value:'Compulsory',displayValue:'5% Compulsory'},{value:'AgeRated',displayValue:'Age rated'}])}),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(CustomField,{name:'annualIncrease',component:__WEBPACK_IMPORTED_MODULE_3_components_Wrappers_materialUIWrappers_components_FormDropDown__["a" /* default */],checkValidation:this.props.checkValidation,label:'Cover Annual Increase *',isrequired:true,validate:[required],options:makeOptions([{value:'0',displayValue:'0% p.a.'},{value:'5',displayValue:'5.0% p.a.'},{value:'75',displayValue:'7.5% p.a. (Not available at all FSPs)'},{value:'10',displayValue:'10% p.a. (Not available at all FSPs)'},{value:'CPI',displayValue:'CPI'}])}),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(CustomField,{name:'Frequency',component:__WEBPACK_IMPORTED_MODULE_3_components_Wrappers_materialUIWrappers_components_FormDropDown__["a" /* default */],checkValidation:this.props.checkValidation,label:'Premium Frequency *',isrequired:true,validate:[required],options:makeOptions([{value:'12',displayValue:'Monthly'},{value:'1',displayValue:'Annually'}])}),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(CustomField,{name:'comission',component:__WEBPACK_IMPORTED_MODULE_5_components_Wrappers_materialUIWrappers_components_NumberInput__["a" /* default */],suffix:'%',checkValidation:this.props.checkValidation,label:'Comission % *',isrequired:true,validate:[required,__WEBPACK_IMPORTED_MODULE_6_helpers_ValidationHelpers__["f" /* percentage */]]}),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(CustomField,{name:'percentageUpfronCommission',component:__WEBPACK_IMPORTED_MODULE_5_components_Wrappers_materialUIWrappers_components_NumberInput__["a" /* default */],suffix:'%',checkValidation:this.props.checkValidation,label:'Upfront commission % *',isrequired:true,validate:[required,__WEBPACK_IMPORTED_MODULE_6_helpers_ValidationHelpers__["f" /* percentage */]]}),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(CustomField,{name:'PAAWCommission',component:__WEBPACK_IMPORTED_MODULE_5_components_Wrappers_materialUIWrappers_components_NumberInput__["a" /* default */],suffix:'%',checkValidation:this.props.checkValidation,label:'As-and-when commission % *',isrequired:true,validate:[required,__WEBPACK_IMPORTED_MODULE_6_helpers_ValidationHelpers__["f" /* percentage */]]})))));}}]);return QuoteDetailsPage;}(__WEBPACK_IMPORTED_MODULE_7_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (QuoteDetailsPage);

/***/ }),
/* 2682 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(9)

/**
 * @category Range Helpers
 * @summary Is the given date range overlapping with another date range?
 *
 * @description
 * Is the given date range overlapping with another date range?
 *
 * @param {Date|String|Number} initialRangeStartDate - the start of the initial range
 * @param {Date|String|Number} initialRangeEndDate - the end of the initial range
 * @param {Date|String|Number} comparedRangeStartDate - the start of the range to compare it with
 * @param {Date|String|Number} comparedRangeEndDate - the end of the range to compare it with
 * @returns {Boolean} whether the date ranges are overlapping
 * @throws {Error} startDate of a date range cannot be after its endDate
 *
 * @example
 * // For overlapping date ranges:
 * areRangesOverlapping(
 *   new Date(2014, 0, 10), new Date(2014, 0, 20), new Date(2014, 0, 17), new Date(2014, 0, 21)
 * )
 * //=> true
 *
 * @example
 * // For non-overlapping date ranges:
 * areRangesOverlapping(
 *   new Date(2014, 0, 10), new Date(2014, 0, 20), new Date(2014, 0, 21), new Date(2014, 0, 22)
 * )
 * //=> false
 */
function areRangesOverlapping (dirtyInitialRangeStartDate, dirtyInitialRangeEndDate, dirtyComparedRangeStartDate, dirtyComparedRangeEndDate) {
  var initialStartTime = parse(dirtyInitialRangeStartDate).getTime()
  var initialEndTime = parse(dirtyInitialRangeEndDate).getTime()
  var comparedStartTime = parse(dirtyComparedRangeStartDate).getTime()
  var comparedEndTime = parse(dirtyComparedRangeEndDate).getTime()

  if (initialStartTime > initialEndTime || comparedStartTime > comparedEndTime) {
    throw new Error('The start of the range cannot be after the end of the range')
  }

  return initialStartTime < comparedEndTime && comparedStartTime < initialEndTime
}

module.exports = areRangesOverlapping


/***/ }),
/* 2683 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(9)

/**
 * @category Common Helpers
 * @summary Return an index of the closest date from the array comparing to the given date.
 *
 * @description
 * Return an index of the closest date from the array comparing to the given date.
 *
 * @param {Date|String|Number} dateToCompare - the date to compare with
 * @param {Date[]|String[]|Number[]} datesArray - the array to search
 * @returns {Number} an index of the date closest to the given date
 * @throws {TypeError} the second argument must be an instance of Array
 *
 * @example
 * // Which date is closer to 6 September 2015?
 * var dateToCompare = new Date(2015, 8, 6)
 * var datesArray = [
 *   new Date(2015, 0, 1),
 *   new Date(2016, 0, 1),
 *   new Date(2017, 0, 1)
 * ]
 * var result = closestIndexTo(dateToCompare, datesArray)
 * //=> 1
 */
function closestIndexTo (dirtyDateToCompare, dirtyDatesArray) {
  if (!(dirtyDatesArray instanceof Array)) {
    throw new TypeError(toString.call(dirtyDatesArray) + ' is not an instance of Array')
  }

  var dateToCompare = parse(dirtyDateToCompare)
  var timeToCompare = dateToCompare.getTime()

  var result
  var minDistance

  dirtyDatesArray.forEach(function (dirtyDate, index) {
    var currentDate = parse(dirtyDate)
    var distance = Math.abs(timeToCompare - currentDate.getTime())
    if (result === undefined || distance < minDistance) {
      result = index
      minDistance = distance
    }
  })

  return result
}

module.exports = closestIndexTo


/***/ }),
/* 2684 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(9)

/**
 * @category Common Helpers
 * @summary Return a date from the array closest to the given date.
 *
 * @description
 * Return a date from the array closest to the given date.
 *
 * @param {Date|String|Number} dateToCompare - the date to compare with
 * @param {Date[]|String[]|Number[]} datesArray - the array to search
 * @returns {Date} the date from the array closest to the given date
 * @throws {TypeError} the second argument must be an instance of Array
 *
 * @example
 * // Which date is closer to 6 September 2015: 1 January 2000 or 1 January 2030?
 * var dateToCompare = new Date(2015, 8, 6)
 * var result = closestTo(dateToCompare, [
 *   new Date(2000, 0, 1),
 *   new Date(2030, 0, 1)
 * ])
 * //=> Tue Jan 01 2030 00:00:00
 */
function closestTo (dirtyDateToCompare, dirtyDatesArray) {
  if (!(dirtyDatesArray instanceof Array)) {
    throw new TypeError(toString.call(dirtyDatesArray) + ' is not an instance of Array')
  }

  var dateToCompare = parse(dirtyDateToCompare)
  var timeToCompare = dateToCompare.getTime()

  var result
  var minDistance

  dirtyDatesArray.forEach(function (dirtyDate) {
    var currentDate = parse(dirtyDate)
    var distance = Math.abs(timeToCompare - currentDate.getTime())
    if (result === undefined || distance < minDistance) {
      result = currentDate
      minDistance = distance
    }
  })

  return result
}

module.exports = closestTo


/***/ }),
/* 2685 */
/***/ (function(module, exports, __webpack_require__) {

var startOfISOWeek = __webpack_require__(113)

var MILLISECONDS_IN_MINUTE = 60000
var MILLISECONDS_IN_WEEK = 604800000

/**
 * @category ISO Week Helpers
 * @summary Get the number of calendar ISO weeks between the given dates.
 *
 * @description
 * Get the number of calendar ISO weeks between the given dates.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @returns {Number} the number of calendar ISO weeks
 *
 * @example
 * // How many calendar ISO weeks are between 6 July 2014 and 21 July 2014?
 * var result = differenceInCalendarISOWeeks(
 *   new Date(2014, 6, 21),
 *   new Date(2014, 6, 6)
 * )
 * //=> 3
 */
function differenceInCalendarISOWeeks (dirtyDateLeft, dirtyDateRight) {
  var startOfISOWeekLeft = startOfISOWeek(dirtyDateLeft)
  var startOfISOWeekRight = startOfISOWeek(dirtyDateRight)

  var timestampLeft = startOfISOWeekLeft.getTime() -
    startOfISOWeekLeft.getTimezoneOffset() * MILLISECONDS_IN_MINUTE
  var timestampRight = startOfISOWeekRight.getTime() -
    startOfISOWeekRight.getTimezoneOffset() * MILLISECONDS_IN_MINUTE

  // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)
  return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_WEEK)
}

module.exports = differenceInCalendarISOWeeks


/***/ }),
/* 2686 */
/***/ (function(module, exports, __webpack_require__) {

var getQuarter = __webpack_require__(718)
var parse = __webpack_require__(9)

/**
 * @category Quarter Helpers
 * @summary Get the number of calendar quarters between the given dates.
 *
 * @description
 * Get the number of calendar quarters between the given dates.
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @returns {Number} the number of calendar quarters
 *
 * @example
 * // How many calendar quarters are between 31 December 2013 and 2 July 2014?
 * var result = differenceInCalendarQuarters(
 *   new Date(2014, 6, 2),
 *   new Date(2013, 11, 31)
 * )
 * //=> 3
 */
function differenceInCalendarQuarters (dirtyDateLeft, dirtyDateRight) {
  var dateLeft = parse(dirtyDateLeft)
  var dateRight = parse(dirtyDateRight)

  var yearDiff = dateLeft.getFullYear() - dateRight.getFullYear()
  var quarterDiff = getQuarter(dateLeft) - getQuarter(dateRight)

  return yearDiff * 4 + quarterDiff
}

module.exports = differenceInCalendarQuarters


/***/ }),
/* 2687 */
/***/ (function(module, exports, __webpack_require__) {

var startOfWeek = __webpack_require__(262)

var MILLISECONDS_IN_MINUTE = 60000
var MILLISECONDS_IN_WEEK = 604800000

/**
 * @category Week Helpers
 * @summary Get the number of calendar weeks between the given dates.
 *
 * @description
 * Get the number of calendar weeks between the given dates.
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @param {Object} [options] - the object with options
 * @param {Number} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @returns {Number} the number of calendar weeks
 *
 * @example
 * // How many calendar weeks are between 5 July 2014 and 20 July 2014?
 * var result = differenceInCalendarWeeks(
 *   new Date(2014, 6, 20),
 *   new Date(2014, 6, 5)
 * )
 * //=> 3
 *
 * @example
 * // If the week starts on Monday,
 * // how many calendar weeks are between 5 July 2014 and 20 July 2014?
 * var result = differenceInCalendarWeeks(
 *   new Date(2014, 6, 20),
 *   new Date(2014, 6, 5),
 *   {weekStartsOn: 1}
 * )
 * //=> 2
 */
function differenceInCalendarWeeks (dirtyDateLeft, dirtyDateRight, dirtyOptions) {
  var startOfWeekLeft = startOfWeek(dirtyDateLeft, dirtyOptions)
  var startOfWeekRight = startOfWeek(dirtyDateRight, dirtyOptions)

  var timestampLeft = startOfWeekLeft.getTime() -
    startOfWeekLeft.getTimezoneOffset() * MILLISECONDS_IN_MINUTE
  var timestampRight = startOfWeekRight.getTime() -
    startOfWeekRight.getTimezoneOffset() * MILLISECONDS_IN_MINUTE

  // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)
  return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_WEEK)
}

module.exports = differenceInCalendarWeeks


/***/ }),
/* 2688 */
/***/ (function(module, exports, __webpack_require__) {

var differenceInMilliseconds = __webpack_require__(287)

var MILLISECONDS_IN_HOUR = 3600000

/**
 * @category Hour Helpers
 * @summary Get the number of hours between the given dates.
 *
 * @description
 * Get the number of hours between the given dates.
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @returns {Number} the number of hours
 *
 * @example
 * // How many hours are between 2 July 2014 06:50:00 and 2 July 2014 19:00:00?
 * var result = differenceInHours(
 *   new Date(2014, 6, 2, 19, 0),
 *   new Date(2014, 6, 2, 6, 50)
 * )
 * //=> 12
 */
function differenceInHours (dirtyDateLeft, dirtyDateRight) {
  var diff = differenceInMilliseconds(dirtyDateLeft, dirtyDateRight) / MILLISECONDS_IN_HOUR
  return diff > 0 ? Math.floor(diff) : Math.ceil(diff)
}

module.exports = differenceInHours


/***/ }),
/* 2689 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(9)
var differenceInCalendarISOYears = __webpack_require__(716)
var compareAsc = __webpack_require__(207)
var subISOYears = __webpack_require__(721)

/**
 * @category ISO Week-Numbering Year Helpers
 * @summary Get the number of full ISO week-numbering years between the given dates.
 *
 * @description
 * Get the number of full ISO week-numbering years between the given dates.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @returns {Number} the number of full ISO week-numbering years
 *
 * @example
 * // How many full ISO week-numbering years are between 1 January 2010 and 1 January 2012?
 * var result = differenceInISOYears(
 *   new Date(2012, 0, 1),
 *   new Date(2010, 0, 1)
 * )
 * //=> 1
 */
function differenceInISOYears (dirtyDateLeft, dirtyDateRight) {
  var dateLeft = parse(dirtyDateLeft)
  var dateRight = parse(dirtyDateRight)

  var sign = compareAsc(dateLeft, dateRight)
  var difference = Math.abs(differenceInCalendarISOYears(dateLeft, dateRight))
  dateLeft = subISOYears(dateLeft, sign * difference)

  // Math.abs(diff in full ISO years - diff in calendar ISO years) === 1
  // if last calendar ISO year is not full
  // If so, result must be decreased by 1 in absolute value
  var isLastISOYearNotFull = compareAsc(dateLeft, dateRight) === -sign
  return sign * (difference - isLastISOYearNotFull)
}

module.exports = differenceInISOYears


/***/ }),
/* 2690 */
/***/ (function(module, exports, __webpack_require__) {

var differenceInMilliseconds = __webpack_require__(287)

var MILLISECONDS_IN_MINUTE = 60000

/**
 * @category Minute Helpers
 * @summary Get the number of minutes between the given dates.
 *
 * @description
 * Get the number of minutes between the given dates.
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @returns {Number} the number of minutes
 *
 * @example
 * // How many minutes are between 2 July 2014 12:07:59 and 2 July 2014 12:20:00?
 * var result = differenceInMinutes(
 *   new Date(2014, 6, 2, 12, 20, 0),
 *   new Date(2014, 6, 2, 12, 7, 59)
 * )
 * //=> 12
 */
function differenceInMinutes (dirtyDateLeft, dirtyDateRight) {
  var diff = differenceInMilliseconds(dirtyDateLeft, dirtyDateRight) / MILLISECONDS_IN_MINUTE
  return diff > 0 ? Math.floor(diff) : Math.ceil(diff)
}

module.exports = differenceInMinutes


/***/ }),
/* 2691 */
/***/ (function(module, exports, __webpack_require__) {

var differenceInMonths = __webpack_require__(421)

/**
 * @category Quarter Helpers
 * @summary Get the number of full quarters between the given dates.
 *
 * @description
 * Get the number of full quarters between the given dates.
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @returns {Number} the number of full quarters
 *
 * @example
 * // How many full quarters are between 31 December 2013 and 2 July 2014?
 * var result = differenceInQuarters(
 *   new Date(2014, 6, 2),
 *   new Date(2013, 11, 31)
 * )
 * //=> 2
 */
function differenceInQuarters (dirtyDateLeft, dirtyDateRight) {
  var diff = differenceInMonths(dirtyDateLeft, dirtyDateRight) / 3
  return diff > 0 ? Math.floor(diff) : Math.ceil(diff)
}

module.exports = differenceInQuarters


/***/ }),
/* 2692 */
/***/ (function(module, exports, __webpack_require__) {

var differenceInDays = __webpack_require__(720)

/**
 * @category Week Helpers
 * @summary Get the number of full weeks between the given dates.
 *
 * @description
 * Get the number of full weeks between the given dates.
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @returns {Number} the number of full weeks
 *
 * @example
 * // How many full weeks are between 5 July 2014 and 20 July 2014?
 * var result = differenceInWeeks(
 *   new Date(2014, 6, 20),
 *   new Date(2014, 6, 5)
 * )
 * //=> 2
 */
function differenceInWeeks (dirtyDateLeft, dirtyDateRight) {
  var diff = differenceInDays(dirtyDateLeft, dirtyDateRight) / 7
  return diff > 0 ? Math.floor(diff) : Math.ceil(diff)
}

module.exports = differenceInWeeks


/***/ }),
/* 2693 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(9)
var differenceInCalendarYears = __webpack_require__(719)
var compareAsc = __webpack_require__(207)

/**
 * @category Year Helpers
 * @summary Get the number of full years between the given dates.
 *
 * @description
 * Get the number of full years between the given dates.
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @returns {Number} the number of full years
 *
 * @example
 * // How many full years are between 31 December 2013 and 11 February 2015?
 * var result = differenceInYears(
 *   new Date(2015, 1, 11),
 *   new Date(2013, 11, 31)
 * )
 * //=> 1
 */
function differenceInYears (dirtyDateLeft, dirtyDateRight) {
  var dateLeft = parse(dirtyDateLeft)
  var dateRight = parse(dirtyDateRight)

  var sign = compareAsc(dateLeft, dateRight)
  var difference = Math.abs(differenceInCalendarYears(dateLeft, dateRight))
  dateLeft.setFullYear(dateLeft.getFullYear() - sign * difference)

  // Math.abs(diff in full years - diff in calendar years) === 1 if last calendar year is not full
  // If so, result must be decreased by 1 in absolute value
  var isLastYearNotFull = compareAsc(dateLeft, dateRight) === -sign
  return sign * (difference - isLastYearNotFull)
}

module.exports = differenceInYears


/***/ }),
/* 2694 */
/***/ (function(module, exports, __webpack_require__) {

var compareDesc = __webpack_require__(420)
var parse = __webpack_require__(9)
var differenceInSeconds = __webpack_require__(422)
var enLocale = __webpack_require__(387)

var MINUTES_IN_DAY = 1440
var MINUTES_IN_MONTH = 43200
var MINUTES_IN_YEAR = 525600

/**
 * @category Common Helpers
 * @summary Return the distance between the given dates in words.
 *
 * @description
 * Return the distance between the given dates in words, using strict units.
 * This is like `distanceInWords`, but does not use helpers like 'almost', 'over',
 * 'less than' and the like.
 *
 * | Distance between dates | Result              |
 * |------------------------|---------------------|
 * | 0 ... 59 secs          | [0..59] seconds     |
 * | 1 ... 59 mins          | [1..59] minutes     |
 * | 1 ... 23 hrs           | [1..23] hours       |
 * | 1 ... 29 days          | [1..29] days        |
 * | 1 ... 11 months        | [1..11] months      |
 * | 1 ... N years          | [1..N]  years       |
 *
 * @param {Date|String|Number} dateToCompare - the date to compare with
 * @param {Date|String|Number} date - the other date
 * @param {Object} [options] - the object with options
 * @param {Boolean} [options.addSuffix=false] - result indicates if the second date is earlier or later than the first
 * @param {'s'|'m'|'h'|'d'|'M'|'Y'} [options.unit] - if specified, will force a unit
 * @param {'floor'|'ceil'|'round'} [options.partialMethod='floor'] - which way to round partial units
 * @param {Object} [options.locale=enLocale] - the locale object
 * @returns {String} the distance in words
 *
 * @example
 * // What is the distance between 2 July 2014 and 1 January 2015?
 * var result = distanceInWordsStrict(
 *   new Date(2014, 6, 2),
 *   new Date(2015, 0, 2)
 * )
 * //=> '6 months'
 *
 * @example
 * // What is the distance between 1 January 2015 00:00:15
 * // and 1 January 2015 00:00:00?
 * var result = distanceInWordsStrict(
 *   new Date(2015, 0, 1, 0, 0, 15),
 *   new Date(2015, 0, 1, 0, 0, 0),
 * )
 * //=> '15 seconds'
 *
 * @example
 * // What is the distance from 1 January 2016
 * // to 1 January 2015, with a suffix?
 * var result = distanceInWordsStrict(
 *   new Date(2016, 0, 1),
 *   new Date(2015, 0, 1),
 *   {addSuffix: true}
 * )
 * //=> '1 year ago'
 *
 * @example
 * // What is the distance from 1 January 2016
 * // to 1 January 2015, in minutes?
 * var result = distanceInWordsStrict(
 *   new Date(2016, 0, 1),
 *   new Date(2015, 0, 1),
 *   {unit: 'm'}
 * )
 * //=> '525600 minutes'
 *
 * @example
 * // What is the distance from 1 January 2016
 * // to 28 January 2015, in months, rounded up?
 * var result = distanceInWordsStrict(
 *   new Date(2015, 0, 28),
 *   new Date(2015, 0, 1),
 *   {unit: 'M', partialMethod: 'ceil'}
 * )
 * //=> '1 month'
 *
 * @example
 * // What is the distance between 1 August 2016 and 1 January 2015 in Esperanto?
 * var eoLocale = require('date-fns/locale/eo')
 * var result = distanceInWordsStrict(
 *   new Date(2016, 7, 1),
 *   new Date(2015, 0, 1),
 *   {locale: eoLocale}
 * )
 * //=> '1 jaro'
 */
function distanceInWordsStrict (dirtyDateToCompare, dirtyDate, dirtyOptions) {
  var options = dirtyOptions || {}

  var comparison = compareDesc(dirtyDateToCompare, dirtyDate)

  var locale = options.locale
  var localize = enLocale.distanceInWords.localize
  if (locale && locale.distanceInWords && locale.distanceInWords.localize) {
    localize = locale.distanceInWords.localize
  }

  var localizeOptions = {
    addSuffix: Boolean(options.addSuffix),
    comparison: comparison
  }

  var dateLeft, dateRight
  if (comparison > 0) {
    dateLeft = parse(dirtyDateToCompare)
    dateRight = parse(dirtyDate)
  } else {
    dateLeft = parse(dirtyDate)
    dateRight = parse(dirtyDateToCompare)
  }

  var unit
  var mathPartial = Math[options.partialMethod ? String(options.partialMethod) : 'floor']
  var seconds = differenceInSeconds(dateRight, dateLeft)
  var offset = dateRight.getTimezoneOffset() - dateLeft.getTimezoneOffset()
  var minutes = mathPartial(seconds / 60) - offset
  var hours, days, months, years

  if (options.unit) {
    unit = String(options.unit)
  } else {
    if (minutes < 1) {
      unit = 's'
    } else if (minutes < 60) {
      unit = 'm'
    } else if (minutes < MINUTES_IN_DAY) {
      unit = 'h'
    } else if (minutes < MINUTES_IN_MONTH) {
      unit = 'd'
    } else if (minutes < MINUTES_IN_YEAR) {
      unit = 'M'
    } else {
      unit = 'Y'
    }
  }

  // 0 up to 60 seconds
  if (unit === 's') {
    return localize('xSeconds', seconds, localizeOptions)

  // 1 up to 60 mins
  } else if (unit === 'm') {
    return localize('xMinutes', minutes, localizeOptions)

  // 1 up to 24 hours
  } else if (unit === 'h') {
    hours = mathPartial(minutes / 60)
    return localize('xHours', hours, localizeOptions)

  // 1 up to 30 days
  } else if (unit === 'd') {
    days = mathPartial(minutes / MINUTES_IN_DAY)
    return localize('xDays', days, localizeOptions)

  // 1 up to 12 months
  } else if (unit === 'M') {
    months = mathPartial(minutes / MINUTES_IN_MONTH)
    return localize('xMonths', months, localizeOptions)

  // 1 year up to max Date
  } else if (unit === 'Y') {
    years = mathPartial(minutes / MINUTES_IN_YEAR)
    return localize('xYears', years, localizeOptions)
  }

  throw new Error('Unknown unit: ' + unit)
}

module.exports = distanceInWordsStrict


/***/ }),
/* 2695 */
/***/ (function(module, exports, __webpack_require__) {

var distanceInWords = __webpack_require__(722)

/**
 * @category Common Helpers
 * @summary Return the distance between the given date and now in words.
 *
 * @description
 * Return the distance between the given date and now in words.
 *
 * | Distance to now                                                   | Result              |
 * |-------------------------------------------------------------------|---------------------|
 * | 0 ... 30 secs                                                     | less than a minute  |
 * | 30 secs ... 1 min 30 secs                                         | 1 minute            |
 * | 1 min 30 secs ... 44 mins 30 secs                                 | [2..44] minutes     |
 * | 44 mins ... 30 secs ... 89 mins 30 secs                           | about 1 hour        |
 * | 89 mins 30 secs ... 23 hrs 59 mins 30 secs                        | about [2..24] hours |
 * | 23 hrs 59 mins 30 secs ... 41 hrs 59 mins 30 secs                 | 1 day               |
 * | 41 hrs 59 mins 30 secs ... 29 days 23 hrs 59 mins 30 secs         | [2..30] days        |
 * | 29 days 23 hrs 59 mins 30 secs ... 44 days 23 hrs 59 mins 30 secs | about 1 month       |
 * | 44 days 23 hrs 59 mins 30 secs ... 59 days 23 hrs 59 mins 30 secs | about 2 months      |
 * | 59 days 23 hrs 59 mins 30 secs ... 1 yr                           | [2..12] months      |
 * | 1 yr ... 1 yr 3 months                                            | about 1 year        |
 * | 1 yr 3 months ... 1 yr 9 month s                                  | over 1 year         |
 * | 1 yr 9 months ... 2 yrs                                           | almost 2 years      |
 * | N yrs ... N yrs 3 months                                          | about N years       |
 * | N yrs 3 months ... N yrs 9 months                                 | over N years        |
 * | N yrs 9 months ... N+1 yrs                                        | almost N+1 years    |
 *
 * With `options.includeSeconds == true`:
 * | Distance to now     | Result               |
 * |---------------------|----------------------|
 * | 0 secs ... 5 secs   | less than 5 seconds  |
 * | 5 secs ... 10 secs  | less than 10 seconds |
 * | 10 secs ... 20 secs | less than 20 seconds |
 * | 20 secs ... 40 secs | half a minute        |
 * | 40 secs ... 60 secs | less than a minute   |
 * | 60 secs ... 90 secs | 1 minute             |
 *
 * @param {Date|String|Number} date - the given date
 * @param {Object} [options] - the object with options
 * @param {Boolean} [options.includeSeconds=false] - distances less than a minute are more detailed
 * @param {Boolean} [options.addSuffix=false] - result specifies if the second date is earlier or later than the first
 * @param {Object} [options.locale=enLocale] - the locale object
 * @returns {String} the distance in words
 *
 * @example
 * // If today is 1 January 2015, what is the distance to 2 July 2014?
 * var result = distanceInWordsToNow(
 *   new Date(2014, 6, 2)
 * )
 * //=> '6 months'
 *
 * @example
 * // If now is 1 January 2015 00:00:00,
 * // what is the distance to 1 January 2015 00:00:15, including seconds?
 * var result = distanceInWordsToNow(
 *   new Date(2015, 0, 1, 0, 0, 15),
 *   {includeSeconds: true}
 * )
 * //=> 'less than 20 seconds'
 *
 * @example
 * // If today is 1 January 2015,
 * // what is the distance to 1 January 2016, with a suffix?
 * var result = distanceInWordsToNow(
 *   new Date(2016, 0, 1),
 *   {addSuffix: true}
 * )
 * //=> 'in about 1 year'
 *
 * @example
 * // If today is 1 January 2015,
 * // what is the distance to 1 August 2016 in Esperanto?
 * var eoLocale = require('date-fns/locale/eo')
 * var result = distanceInWordsToNow(
 *   new Date(2016, 7, 1),
 *   {locale: eoLocale}
 * )
 * //=> 'pli ol 1 jaro'
 */
function distanceInWordsToNow (dirtyDate, dirtyOptions) {
  return distanceInWords(Date.now(), dirtyDate, dirtyOptions)
}

module.exports = distanceInWordsToNow


/***/ }),
/* 2696 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(9)

/**
 * @category Day Helpers
 * @summary Return the array of dates within the specified range.
 *
 * @description
 * Return the array of dates within the specified range.
 *
 * @param {Date|String|Number} startDate - the first date
 * @param {Date|String|Number} endDate - the last date
 * @param {Number} [step=1] - the step between each day
 * @returns {Date[]} the array with starts of days from the day of startDate to the day of endDate
 * @throws {Error} startDate cannot be after endDate
 *
 * @example
 * // Each day between 6 October 2014 and 10 October 2014:
 * var result = eachDay(
 *   new Date(2014, 9, 6),
 *   new Date(2014, 9, 10)
 * )
 * //=> [
 * //   Mon Oct 06 2014 00:00:00,
 * //   Tue Oct 07 2014 00:00:00,
 * //   Wed Oct 08 2014 00:00:00,
 * //   Thu Oct 09 2014 00:00:00,
 * //   Fri Oct 10 2014 00:00:00
 * // ]
 */
function eachDay (dirtyStartDate, dirtyEndDate, dirtyStep) {
  var startDate = parse(dirtyStartDate)
  var endDate = parse(dirtyEndDate)
  var step = dirtyStep !== undefined ? dirtyStep : 1

  var endTime = endDate.getTime()

  if (startDate.getTime() > endTime) {
    throw new Error('The first date cannot be after the second date')
  }

  var dates = []

  var currentDate = startDate
  currentDate.setHours(0, 0, 0, 0)

  while (currentDate.getTime() <= endTime) {
    dates.push(parse(currentDate))
    currentDate.setDate(currentDate.getDate() + step)
  }

  return dates
}

module.exports = eachDay


/***/ }),
/* 2697 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(9)

/**
 * @category Hour Helpers
 * @summary Return the end of an hour for the given date.
 *
 * @description
 * Return the end of an hour for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the end of an hour
 *
 * @example
 * // The end of an hour for 2 September 2014 11:55:00:
 * var result = endOfHour(new Date(2014, 8, 2, 11, 55))
 * //=> Tue Sep 02 2014 11:59:59.999
 */
function endOfHour (dirtyDate) {
  var date = parse(dirtyDate)
  date.setMinutes(59, 59, 999)
  return date
}

module.exports = endOfHour


/***/ }),
/* 2698 */
/***/ (function(module, exports, __webpack_require__) {

var endOfWeek = __webpack_require__(723)

/**
 * @category ISO Week Helpers
 * @summary Return the end of an ISO week for the given date.
 *
 * @description
 * Return the end of an ISO week for the given date.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the end of an ISO week
 *
 * @example
 * // The end of an ISO week for 2 September 2014 11:55:00:
 * var result = endOfISOWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sun Sep 07 2014 23:59:59.999
 */
function endOfISOWeek (dirtyDate) {
  return endOfWeek(dirtyDate, {weekStartsOn: 1})
}

module.exports = endOfISOWeek


/***/ }),
/* 2699 */
/***/ (function(module, exports, __webpack_require__) {

var getISOYear = __webpack_require__(114)
var startOfISOWeek = __webpack_require__(113)

/**
 * @category ISO Week-Numbering Year Helpers
 * @summary Return the end of an ISO week-numbering year for the given date.
 *
 * @description
 * Return the end of an ISO week-numbering year,
 * which always starts 3 days before the year's first Thursday.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the end of an ISO week-numbering year
 *
 * @example
 * // The end of an ISO week-numbering year for 2 July 2005:
 * var result = endOfISOYear(new Date(2005, 6, 2))
 * //=> Sun Jan 01 2006 23:59:59.999
 */
function endOfISOYear (dirtyDate) {
  var year = getISOYear(dirtyDate)
  var fourthOfJanuaryOfNextYear = new Date(0)
  fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4)
  fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0)
  var date = startOfISOWeek(fourthOfJanuaryOfNextYear)
  date.setMilliseconds(date.getMilliseconds() - 1)
  return date
}

module.exports = endOfISOYear


/***/ }),
/* 2700 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(9)

/**
 * @category Minute Helpers
 * @summary Return the end of a minute for the given date.
 *
 * @description
 * Return the end of a minute for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the end of a minute
 *
 * @example
 * // The end of a minute for 1 December 2014 22:15:45.400:
 * var result = endOfMinute(new Date(2014, 11, 1, 22, 15, 45, 400))
 * //=> Mon Dec 01 2014 22:15:59.999
 */
function endOfMinute (dirtyDate) {
  var date = parse(dirtyDate)
  date.setSeconds(59, 999)
  return date
}

module.exports = endOfMinute


/***/ }),
/* 2701 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(9)

/**
 * @category Quarter Helpers
 * @summary Return the end of a year quarter for the given date.
 *
 * @description
 * Return the end of a year quarter for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the end of a quarter
 *
 * @example
 * // The end of a quarter for 2 September 2014 11:55:00:
 * var result = endOfQuarter(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 30 2014 23:59:59.999
 */
function endOfQuarter (dirtyDate) {
  var date = parse(dirtyDate)
  var currentMonth = date.getMonth()
  var month = currentMonth - currentMonth % 3 + 3
  date.setMonth(month, 0)
  date.setHours(23, 59, 59, 999)
  return date
}

module.exports = endOfQuarter


/***/ }),
/* 2702 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(9)

/**
 * @category Second Helpers
 * @summary Return the end of a second for the given date.
 *
 * @description
 * Return the end of a second for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the end of a second
 *
 * @example
 * // The end of a second for 1 December 2014 22:15:45.400:
 * var result = endOfSecond(new Date(2014, 11, 1, 22, 15, 45, 400))
 * //=> Mon Dec 01 2014 22:15:45.999
 */
function endOfSecond (dirtyDate) {
  var date = parse(dirtyDate)
  date.setMilliseconds(999)
  return date
}

module.exports = endOfSecond


/***/ }),
/* 2703 */
/***/ (function(module, exports, __webpack_require__) {

var endOfDay = __webpack_require__(260)

/**
 * @category Day Helpers
 * @summary Return the end of today.
 *
 * @description
 * Return the end of today.
 *
 * @returns {Date} the end of today
 *
 * @example
 * // If today is 6 October 2014:
 * var result = endOfToday()
 * //=> Mon Oct 6 2014 23:59:59.999
 */
function endOfToday () {
  return endOfDay(new Date())
}

module.exports = endOfToday


/***/ }),
/* 2704 */
/***/ (function(module, exports) {

/**
 * @category Day Helpers
 * @summary Return the end of tomorrow.
 *
 * @description
 * Return the end of tomorrow.
 *
 * @returns {Date} the end of tomorrow
 *
 * @example
 * // If today is 6 October 2014:
 * var result = endOfTomorrow()
 * //=> Tue Oct 7 2014 23:59:59.999
 */
function endOfTomorrow () {
  var now = new Date()
  var year = now.getFullYear()
  var month = now.getMonth()
  var day = now.getDate()

  var date = new Date(0)
  date.setFullYear(year, month, day + 1)
  date.setHours(23, 59, 59, 999)
  return date
}

module.exports = endOfTomorrow


/***/ }),
/* 2705 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(9)

/**
 * @category Year Helpers
 * @summary Return the end of a year for the given date.
 *
 * @description
 * Return the end of a year for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the end of a year
 *
 * @example
 * // The end of a year for 2 September 2014 11:55:00:
 * var result = endOfYear(new Date(2014, 8, 2, 11, 55, 00))
 * //=> Wed Dec 31 2014 23:59:59.999
 */
function endOfYear (dirtyDate) {
  var date = parse(dirtyDate)
  var year = date.getFullYear()
  date.setFullYear(year + 1, 0, 0)
  date.setHours(23, 59, 59, 999)
  return date
}

module.exports = endOfYear


/***/ }),
/* 2706 */
/***/ (function(module, exports) {

/**
 * @category Day Helpers
 * @summary Return the end of yesterday.
 *
 * @description
 * Return the end of yesterday.
 *
 * @returns {Date} the end of yesterday
 *
 * @example
 * // If today is 6 October 2014:
 * var result = endOfYesterday()
 * //=> Sun Oct 5 2014 23:59:59.999
 */
function endOfYesterday () {
  var now = new Date()
  var year = now.getFullYear()
  var month = now.getMonth()
  var day = now.getDate()

  var date = new Date(0)
  date.setFullYear(year, month, day - 1)
  date.setHours(23, 59, 59, 999)
  return date
}

module.exports = endOfYesterday


/***/ }),
/* 2707 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(9)

/**
 * @category Day Helpers
 * @summary Get the day of the month of the given date.
 *
 * @description
 * Get the day of the month of the given date.
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the day of month
 *
 * @example
 * // Which day of the month is 29 February 2012?
 * var result = getDate(new Date(2012, 1, 29))
 * //=> 29
 */
function getDate (dirtyDate) {
  var date = parse(dirtyDate)
  var dayOfMonth = date.getDate()
  return dayOfMonth
}

module.exports = getDate


/***/ }),
/* 2708 */
/***/ (function(module, exports, __webpack_require__) {

var isLeapYear = __webpack_require__(725)

/**
 * @category Year Helpers
 * @summary Get the number of days in a year of the given date.
 *
 * @description
 * Get the number of days in a year of the given date.
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the number of days in a year
 *
 * @example
 * // How many days are in 2012?
 * var result = getDaysInYear(new Date(2012, 0, 1))
 * //=> 366
 */
function getDaysInYear (dirtyDate) {
  return isLeapYear(dirtyDate) ? 366 : 365
}

module.exports = getDaysInYear


/***/ }),
/* 2709 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(9)

/**
 * @category Hour Helpers
 * @summary Get the hours of the given date.
 *
 * @description
 * Get the hours of the given date.
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the hours
 *
 * @example
 * // Get the hours of 29 February 2012 11:45:00:
 * var result = getHours(new Date(2012, 1, 29, 11, 45))
 * //=> 11
 */
function getHours (dirtyDate) {
  var date = parse(dirtyDate)
  var hours = date.getHours()
  return hours
}

module.exports = getHours


/***/ }),
/* 2710 */
/***/ (function(module, exports, __webpack_require__) {

var startOfISOYear = __webpack_require__(192)
var addWeeks = __webpack_require__(419)

var MILLISECONDS_IN_WEEK = 604800000

/**
 * @category ISO Week-Numbering Year Helpers
 * @summary Get the number of weeks in an ISO week-numbering year of the given date.
 *
 * @description
 * Get the number of weeks in an ISO week-numbering year of the given date.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the number of ISO weeks in a year
 *
 * @example
 * // How many weeks are in ISO week-numbering year 2015?
 * var result = getISOWeeksInYear(new Date(2015, 1, 11))
 * //=> 53
 */
function getISOWeeksInYear (dirtyDate) {
  var thisYear = startOfISOYear(dirtyDate)
  var nextYear = startOfISOYear(addWeeks(thisYear, 60))
  var diff = nextYear.valueOf() - thisYear.valueOf()
  // Round the number of weeks to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)
  return Math.round(diff / MILLISECONDS_IN_WEEK)
}

module.exports = getISOWeeksInYear


/***/ }),
/* 2711 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(9)

/**
 * @category Millisecond Helpers
 * @summary Get the milliseconds of the given date.
 *
 * @description
 * Get the milliseconds of the given date.
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the milliseconds
 *
 * @example
 * // Get the milliseconds of 29 February 2012 11:45:05.123:
 * var result = getMilliseconds(new Date(2012, 1, 29, 11, 45, 5, 123))
 * //=> 123
 */
function getMilliseconds (dirtyDate) {
  var date = parse(dirtyDate)
  var milliseconds = date.getMilliseconds()
  return milliseconds
}

module.exports = getMilliseconds


/***/ }),
/* 2712 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(9)

/**
 * @category Minute Helpers
 * @summary Get the minutes of the given date.
 *
 * @description
 * Get the minutes of the given date.
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the minutes
 *
 * @example
 * // Get the minutes of 29 February 2012 11:45:05:
 * var result = getMinutes(new Date(2012, 1, 29, 11, 45, 5))
 * //=> 45
 */
function getMinutes (dirtyDate) {
  var date = parse(dirtyDate)
  var minutes = date.getMinutes()
  return minutes
}

module.exports = getMinutes


/***/ }),
/* 2713 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(9)

/**
 * @category Month Helpers
 * @summary Get the month of the given date.
 *
 * @description
 * Get the month of the given date.
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the month
 *
 * @example
 * // Which month is 29 February 2012?
 * var result = getMonth(new Date(2012, 1, 29))
 * //=> 1
 */
function getMonth (dirtyDate) {
  var date = parse(dirtyDate)
  var month = date.getMonth()
  return month
}

module.exports = getMonth


/***/ }),
/* 2714 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(9)

var MILLISECONDS_IN_DAY = 24 * 60 * 60 * 1000

/**
 * @category Range Helpers
 * @summary Get the number of days that overlap in two date ranges
 *
 * @description
 * Get the number of days that overlap in two date ranges
 *
 * @param {Date|String|Number} initialRangeStartDate - the start of the initial range
 * @param {Date|String|Number} initialRangeEndDate - the end of the initial range
 * @param {Date|String|Number} comparedRangeStartDate - the start of the range to compare it with
 * @param {Date|String|Number} comparedRangeEndDate - the end of the range to compare it with
 * @returns {Number} the number of days that overlap in two date ranges
 * @throws {Error} startDate of a date range cannot be after its endDate
 *
 * @example
 * // For overlapping date ranges adds 1 for each started overlapping day:
 * getOverlappingDaysInRanges(
 *   new Date(2014, 0, 10), new Date(2014, 0, 20), new Date(2014, 0, 17), new Date(2014, 0, 21)
 * )
 * //=> 3
 *
 * @example
 * // For non-overlapping date ranges returns 0:
 * getOverlappingDaysInRanges(
 *   new Date(2014, 0, 10), new Date(2014, 0, 20), new Date(2014, 0, 21), new Date(2014, 0, 22)
 * )
 * //=> 0
 */
function getOverlappingDaysInRanges (dirtyInitialRangeStartDate, dirtyInitialRangeEndDate, dirtyComparedRangeStartDate, dirtyComparedRangeEndDate) {
  var initialStartTime = parse(dirtyInitialRangeStartDate).getTime()
  var initialEndTime = parse(dirtyInitialRangeEndDate).getTime()
  var comparedStartTime = parse(dirtyComparedRangeStartDate).getTime()
  var comparedEndTime = parse(dirtyComparedRangeEndDate).getTime()

  if (initialStartTime > initialEndTime || comparedStartTime > comparedEndTime) {
    throw new Error('The start of the range cannot be after the end of the range')
  }

  var isOverlapping = initialStartTime < comparedEndTime && comparedStartTime < initialEndTime

  if (!isOverlapping) {
    return 0
  }

  var overlapStartDate = comparedStartTime < initialStartTime
    ? initialStartTime
    : comparedStartTime

  var overlapEndDate = comparedEndTime > initialEndTime
    ? initialEndTime
    : comparedEndTime

  var differenceInMs = overlapEndDate - overlapStartDate

  return Math.ceil(differenceInMs / MILLISECONDS_IN_DAY)
}

module.exports = getOverlappingDaysInRanges


/***/ }),
/* 2715 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(9)

/**
 * @category Second Helpers
 * @summary Get the seconds of the given date.
 *
 * @description
 * Get the seconds of the given date.
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the seconds
 *
 * @example
 * // Get the seconds of 29 February 2012 11:45:05.123:
 * var result = getSeconds(new Date(2012, 1, 29, 11, 45, 5, 123))
 * //=> 5
 */
function getSeconds (dirtyDate) {
  var date = parse(dirtyDate)
  var seconds = date.getSeconds()
  return seconds
}

module.exports = getSeconds


/***/ }),
/* 2716 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(9)

/**
 * @category Timestamp Helpers
 * @summary Get the milliseconds timestamp of the given date.
 *
 * @description
 * Get the milliseconds timestamp of the given date.
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the timestamp
 *
 * @example
 * // Get the timestamp of 29 February 2012 11:45:05.123:
 * var result = getTime(new Date(2012, 1, 29, 11, 45, 5, 123))
 * //=> 1330515905123
 */
function getTime (dirtyDate) {
  var date = parse(dirtyDate)
  var timestamp = date.getTime()
  return timestamp
}

module.exports = getTime


/***/ }),
/* 2717 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(9)

/**
 * @category Year Helpers
 * @summary Get the year of the given date.
 *
 * @description
 * Get the year of the given date.
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the year
 *
 * @example
 * // Which year is 2 July 2014?
 * var result = getYear(new Date(2014, 6, 2))
 * //=> 2014
 */
function getYear (dirtyDate) {
  var date = parse(dirtyDate)
  var year = date.getFullYear()
  return year
}

module.exports = getYear


/***/ }),
/* 2718 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(9)

/**
 * @category Common Helpers
 * @summary Are the given dates equal?
 *
 * @description
 * Are the given dates equal?
 *
 * @param {Date|String|Number} dateLeft - the first date to compare
 * @param {Date|String|Number} dateRight - the second date to compare
 * @returns {Boolean} the dates are equal
 *
 * @example
 * // Are 2 July 2014 06:30:45.000 and 2 July 2014 06:30:45.500 equal?
 * var result = isEqual(
 *   new Date(2014, 6, 2, 6, 30, 45, 0)
 *   new Date(2014, 6, 2, 6, 30, 45, 500)
 * )
 * //=> false
 */
function isEqual (dirtyLeftDate, dirtyRightDate) {
  var dateLeft = parse(dirtyLeftDate)
  var dateRight = parse(dirtyRightDate)
  return dateLeft.getTime() === dateRight.getTime()
}

module.exports = isEqual


/***/ }),
/* 2719 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(9)

/**
 * @category Month Helpers
 * @summary Is the given date the first day of a month?
 *
 * @description
 * Is the given date the first day of a month?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is the first day of a month
 *
 * @example
 * // Is 1 September 2014 the first day of a month?
 * var result = isFirstDayOfMonth(new Date(2014, 8, 1))
 * //=> true
 */
function isFirstDayOfMonth (dirtyDate) {
  return parse(dirtyDate).getDate() === 1
}

module.exports = isFirstDayOfMonth


/***/ }),
/* 2720 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(9)

/**
 * @category Weekday Helpers
 * @summary Is the given date Friday?
 *
 * @description
 * Is the given date Friday?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is Friday
 *
 * @example
 * // Is 26 September 2014 Friday?
 * var result = isFriday(new Date(2014, 8, 26))
 * //=> true
 */
function isFriday (dirtyDate) {
  return parse(dirtyDate).getDay() === 5
}

module.exports = isFriday


/***/ }),
/* 2721 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(9)

/**
 * @category Common Helpers
 * @summary Is the given date in the future?
 *
 * @description
 * Is the given date in the future?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is in the future
 *
 * @example
 * // If today is 6 October 2014, is 31 December 2014 in the future?
 * var result = isFuture(new Date(2014, 11, 31))
 * //=> true
 */
function isFuture (dirtyDate) {
  return parse(dirtyDate).getTime() > new Date().getTime()
}

module.exports = isFuture


/***/ }),
/* 2722 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(9)
var endOfDay = __webpack_require__(260)
var endOfMonth = __webpack_require__(724)

/**
 * @category Month Helpers
 * @summary Is the given date the last day of a month?
 *
 * @description
 * Is the given date the last day of a month?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is the last day of a month
 *
 * @example
 * // Is 28 February 2014 the last day of a month?
 * var result = isLastDayOfMonth(new Date(2014, 1, 28))
 * //=> true
 */
function isLastDayOfMonth (dirtyDate) {
  var date = parse(dirtyDate)
  return endOfDay(date).getTime() === endOfMonth(date).getTime()
}

module.exports = isLastDayOfMonth


/***/ }),
/* 2723 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(9)

/**
 * @category Weekday Helpers
 * @summary Is the given date Monday?
 *
 * @description
 * Is the given date Monday?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is Monday
 *
 * @example
 * // Is 22 September 2014 Monday?
 * var result = isMonday(new Date(2014, 8, 22))
 * //=> true
 */
function isMonday (dirtyDate) {
  return parse(dirtyDate).getDay() === 1
}

module.exports = isMonday


/***/ }),
/* 2724 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(9)

/**
 * @category Common Helpers
 * @summary Is the given date in the past?
 *
 * @description
 * Is the given date in the past?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is in the past
 *
 * @example
 * // If today is 6 October 2014, is 2 July 2014 in the past?
 * var result = isPast(new Date(2014, 6, 2))
 * //=> true
 */
function isPast (dirtyDate) {
  return parse(dirtyDate).getTime() < new Date().getTime()
}

module.exports = isPast


/***/ }),
/* 2725 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(9)

/**
 * @category Weekday Helpers
 * @summary Is the given date Saturday?
 *
 * @description
 * Is the given date Saturday?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is Saturday
 *
 * @example
 * // Is 27 September 2014 Saturday?
 * var result = isSaturday(new Date(2014, 8, 27))
 * //=> true
 */
function isSaturday (dirtyDate) {
  return parse(dirtyDate).getDay() === 6
}

module.exports = isSaturday


/***/ }),
/* 2726 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(9)

/**
 * @category Weekday Helpers
 * @summary Is the given date Sunday?
 *
 * @description
 * Is the given date Sunday?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is Sunday
 *
 * @example
 * // Is 21 September 2014 Sunday?
 * var result = isSunday(new Date(2014, 8, 21))
 * //=> true
 */
function isSunday (dirtyDate) {
  return parse(dirtyDate).getDay() === 0
}

module.exports = isSunday


/***/ }),
/* 2727 */
/***/ (function(module, exports, __webpack_require__) {

var isSameHour = __webpack_require__(727)

/**
 * @category Hour Helpers
 * @summary Is the given date in the same hour as the current date?
 *
 * @description
 * Is the given date in the same hour as the current date?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is in this hour
 *
 * @example
 * // If now is 25 September 2014 18:30:15.500,
 * // is 25 September 2014 18:00:00 in this hour?
 * var result = isThisHour(new Date(2014, 8, 25, 18))
 * //=> true
 */
function isThisHour (dirtyDate) {
  return isSameHour(new Date(), dirtyDate)
}

module.exports = isThisHour


/***/ }),
/* 2728 */
/***/ (function(module, exports, __webpack_require__) {

var isSameISOWeek = __webpack_require__(729)

/**
 * @category ISO Week Helpers
 * @summary Is the given date in the same ISO week as the current date?
 *
 * @description
 * Is the given date in the same ISO week as the current date?
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is in this ISO week
 *
 * @example
 * // If today is 25 September 2014, is 22 September 2014 in this ISO week?
 * var result = isThisISOWeek(new Date(2014, 8, 22))
 * //=> true
 */
function isThisISOWeek (dirtyDate) {
  return isSameISOWeek(new Date(), dirtyDate)
}

module.exports = isThisISOWeek


/***/ }),
/* 2729 */
/***/ (function(module, exports, __webpack_require__) {

var isSameISOYear = __webpack_require__(730)

/**
 * @category ISO Week-Numbering Year Helpers
 * @summary Is the given date in the same ISO week-numbering year as the current date?
 *
 * @description
 * Is the given date in the same ISO week-numbering year as the current date?
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is in this ISO week-numbering year
 *
 * @example
 * // If today is 25 September 2014,
 * // is 30 December 2013 in this ISO week-numbering year?
 * var result = isThisISOYear(new Date(2013, 11, 30))
 * //=> true
 */
function isThisISOYear (dirtyDate) {
  return isSameISOYear(new Date(), dirtyDate)
}

module.exports = isThisISOYear


/***/ }),
/* 2730 */
/***/ (function(module, exports, __webpack_require__) {

var isSameMinute = __webpack_require__(731)

/**
 * @category Minute Helpers
 * @summary Is the given date in the same minute as the current date?
 *
 * @description
 * Is the given date in the same minute as the current date?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is in this minute
 *
 * @example
 * // If now is 25 September 2014 18:30:15.500,
 * // is 25 September 2014 18:30:00 in this minute?
 * var result = isThisMinute(new Date(2014, 8, 25, 18, 30))
 * //=> true
 */
function isThisMinute (dirtyDate) {
  return isSameMinute(new Date(), dirtyDate)
}

module.exports = isThisMinute


/***/ }),
/* 2731 */
/***/ (function(module, exports, __webpack_require__) {

var isSameMonth = __webpack_require__(389)

/**
 * @category Month Helpers
 * @summary Is the given date in the same month as the current date?
 *
 * @description
 * Is the given date in the same month as the current date?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is in this month
 *
 * @example
 * // If today is 25 September 2014, is 15 September 2014 in this month?
 * var result = isThisMonth(new Date(2014, 8, 15))
 * //=> true
 */
function isThisMonth (dirtyDate) {
  return isSameMonth(new Date(), dirtyDate)
}

module.exports = isThisMonth


/***/ }),
/* 2732 */
/***/ (function(module, exports, __webpack_require__) {

var isSameQuarter = __webpack_require__(733)

/**
 * @category Quarter Helpers
 * @summary Is the given date in the same quarter as the current date?
 *
 * @description
 * Is the given date in the same quarter as the current date?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is in this quarter
 *
 * @example
 * // If today is 25 September 2014, is 2 July 2014 in this quarter?
 * var result = isThisQuarter(new Date(2014, 6, 2))
 * //=> true
 */
function isThisQuarter (dirtyDate) {
  return isSameQuarter(new Date(), dirtyDate)
}

module.exports = isThisQuarter


/***/ }),
/* 2733 */
/***/ (function(module, exports, __webpack_require__) {

var isSameSecond = __webpack_require__(735)

/**
 * @category Second Helpers
 * @summary Is the given date in the same second as the current date?
 *
 * @description
 * Is the given date in the same second as the current date?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is in this second
 *
 * @example
 * // If now is 25 September 2014 18:30:15.500,
 * // is 25 September 2014 18:30:15.000 in this second?
 * var result = isThisSecond(new Date(2014, 8, 25, 18, 30, 15))
 * //=> true
 */
function isThisSecond (dirtyDate) {
  return isSameSecond(new Date(), dirtyDate)
}

module.exports = isThisSecond


/***/ }),
/* 2734 */
/***/ (function(module, exports, __webpack_require__) {

var isSameWeek = __webpack_require__(423)

/**
 * @category Week Helpers
 * @summary Is the given date in the same week as the current date?
 *
 * @description
 * Is the given date in the same week as the current date?
 *
 * @param {Date|String|Number} date - the date to check
 * @param {Object} [options] - the object with options
 * @param {Number} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @returns {Boolean} the date is in this week
 *
 * @example
 * // If today is 25 September 2014, is 21 September 2014 in this week?
 * var result = isThisWeek(new Date(2014, 8, 21))
 * //=> true
 *
 * @example
 * // If today is 25 September 2014 and week starts with Monday
 * // is 21 September 2014 in this week?
 * var result = isThisWeek(new Date(2014, 8, 21), {weekStartsOn: 1})
 * //=> false
 */
function isThisWeek (dirtyDate, dirtyOptions) {
  return isSameWeek(new Date(), dirtyDate, dirtyOptions)
}

module.exports = isThisWeek


/***/ }),
/* 2735 */
/***/ (function(module, exports, __webpack_require__) {

var isSameYear = __webpack_require__(388)

/**
 * @category Year Helpers
 * @summary Is the given date in the same year as the current date?
 *
 * @description
 * Is the given date in the same year as the current date?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is in this year
 *
 * @example
 * // If today is 25 September 2014, is 2 July 2014 in this year?
 * var result = isThisYear(new Date(2014, 6, 2))
 * //=> true
 */
function isThisYear (dirtyDate) {
  return isSameYear(new Date(), dirtyDate)
}

module.exports = isThisYear


/***/ }),
/* 2736 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(9)

/**
 * @category Weekday Helpers
 * @summary Is the given date Thursday?
 *
 * @description
 * Is the given date Thursday?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is Thursday
 *
 * @example
 * // Is 25 September 2014 Thursday?
 * var result = isThursday(new Date(2014, 8, 25))
 * //=> true
 */
function isThursday (dirtyDate) {
  return parse(dirtyDate).getDay() === 4
}

module.exports = isThursday


/***/ }),
/* 2737 */
/***/ (function(module, exports, __webpack_require__) {

var startOfDay = __webpack_require__(82)

/**
 * @category Day Helpers
 * @summary Is the given date today?
 *
 * @description
 * Is the given date today?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is today
 *
 * @example
 * // If today is 6 October 2014, is 6 October 14:00:00 today?
 * var result = isToday(new Date(2014, 9, 6, 14, 0))
 * //=> true
 */
function isToday (dirtyDate) {
  return startOfDay(dirtyDate).getTime() === startOfDay(new Date()).getTime()
}

module.exports = isToday


/***/ }),
/* 2738 */
/***/ (function(module, exports, __webpack_require__) {

var startOfDay = __webpack_require__(82)

/**
 * @category Day Helpers
 * @summary Is the given date tomorrow?
 *
 * @description
 * Is the given date tomorrow?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is tomorrow
 *
 * @example
 * // If today is 6 October 2014, is 7 October 14:00:00 tomorrow?
 * var result = isTomorrow(new Date(2014, 9, 7, 14, 0))
 * //=> true
 */
function isTomorrow (dirtyDate) {
  var tomorrow = new Date()
  tomorrow.setDate(tomorrow.getDate() + 1)
  return startOfDay(dirtyDate).getTime() === startOfDay(tomorrow).getTime()
}

module.exports = isTomorrow


/***/ }),
/* 2739 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(9)

/**
 * @category Weekday Helpers
 * @summary Is the given date Tuesday?
 *
 * @description
 * Is the given date Tuesday?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is Tuesday
 *
 * @example
 * // Is 23 September 2014 Tuesday?
 * var result = isTuesday(new Date(2014, 8, 23))
 * //=> true
 */
function isTuesday (dirtyDate) {
  return parse(dirtyDate).getDay() === 2
}

module.exports = isTuesday


/***/ }),
/* 2740 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(9)

/**
 * @category Weekday Helpers
 * @summary Is the given date Wednesday?
 *
 * @description
 * Is the given date Wednesday?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is Wednesday
 *
 * @example
 * // Is 24 September 2014 Wednesday?
 * var result = isWednesday(new Date(2014, 8, 24))
 * //=> true
 */
function isWednesday (dirtyDate) {
  return parse(dirtyDate).getDay() === 3
}

module.exports = isWednesday


/***/ }),
/* 2741 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(9)

/**
 * @category Weekday Helpers
 * @summary Does the given date fall on a weekend?
 *
 * @description
 * Does the given date fall on a weekend?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date falls on a weekend
 *
 * @example
 * // Does 5 October 2014 fall on a weekend?
 * var result = isWeekend(new Date(2014, 9, 5))
 * //=> true
 */
function isWeekend (dirtyDate) {
  var date = parse(dirtyDate)
  var day = date.getDay()
  return day === 0 || day === 6
}

module.exports = isWeekend


/***/ }),
/* 2742 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(9)

/**
 * @category Range Helpers
 * @summary Is the given date within the range?
 *
 * @description
 * Is the given date within the range?
 *
 * @param {Date|String|Number} date - the date to check
 * @param {Date|String|Number} startDate - the start of range
 * @param {Date|String|Number} endDate - the end of range
 * @returns {Boolean} the date is within the range
 * @throws {Error} startDate cannot be after endDate
 *
 * @example
 * // For the date within the range:
 * isWithinRange(
 *   new Date(2014, 0, 3), new Date(2014, 0, 1), new Date(2014, 0, 7)
 * )
 * //=> true
 *
 * @example
 * // For the date outside of the range:
 * isWithinRange(
 *   new Date(2014, 0, 10), new Date(2014, 0, 1), new Date(2014, 0, 7)
 * )
 * //=> false
 */
function isWithinRange (dirtyDate, dirtyStartDate, dirtyEndDate) {
  var time = parse(dirtyDate).getTime()
  var startTime = parse(dirtyStartDate).getTime()
  var endTime = parse(dirtyEndDate).getTime()

  if (startTime > endTime) {
    throw new Error('The start of the range cannot be after the end of the range')
  }

  return time >= startTime && time <= endTime
}

module.exports = isWithinRange


/***/ }),
/* 2743 */
/***/ (function(module, exports, __webpack_require__) {

var startOfDay = __webpack_require__(82)

/**
 * @category Day Helpers
 * @summary Is the given date yesterday?
 *
 * @description
 * Is the given date yesterday?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is yesterday
 *
 * @example
 * // If today is 6 October 2014, is 5 October 14:00:00 yesterday?
 * var result = isYesterday(new Date(2014, 9, 5, 14, 0))
 * //=> true
 */
function isYesterday (dirtyDate) {
  var yesterday = new Date()
  yesterday.setDate(yesterday.getDate() - 1)
  return startOfDay(dirtyDate).getTime() === startOfDay(yesterday).getTime()
}

module.exports = isYesterday


/***/ }),
/* 2744 */
/***/ (function(module, exports, __webpack_require__) {

var lastDayOfWeek = __webpack_require__(737)

/**
 * @category ISO Week Helpers
 * @summary Return the last day of an ISO week for the given date.
 *
 * @description
 * Return the last day of an ISO week for the given date.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the last day of an ISO week
 *
 * @example
 * // The last day of an ISO week for 2 September 2014 11:55:00:
 * var result = lastDayOfISOWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sun Sep 07 2014 00:00:00
 */
function lastDayOfISOWeek (dirtyDate) {
  return lastDayOfWeek(dirtyDate, {weekStartsOn: 1})
}

module.exports = lastDayOfISOWeek


/***/ }),
/* 2745 */
/***/ (function(module, exports, __webpack_require__) {

var getISOYear = __webpack_require__(114)
var startOfISOWeek = __webpack_require__(113)

/**
 * @category ISO Week-Numbering Year Helpers
 * @summary Return the last day of an ISO week-numbering year for the given date.
 *
 * @description
 * Return the last day of an ISO week-numbering year,
 * which always starts 3 days before the year's first Thursday.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the end of an ISO week-numbering year
 *
 * @example
 * // The last day of an ISO week-numbering year for 2 July 2005:
 * var result = lastDayOfISOYear(new Date(2005, 6, 2))
 * //=> Sun Jan 01 2006 00:00:00
 */
function lastDayOfISOYear (dirtyDate) {
  var year = getISOYear(dirtyDate)
  var fourthOfJanuary = new Date(0)
  fourthOfJanuary.setFullYear(year + 1, 0, 4)
  fourthOfJanuary.setHours(0, 0, 0, 0)
  var date = startOfISOWeek(fourthOfJanuary)
  date.setDate(date.getDate() - 1)
  return date
}

module.exports = lastDayOfISOYear


/***/ }),
/* 2746 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(9)

/**
 * @category Month Helpers
 * @summary Return the last day of a month for the given date.
 *
 * @description
 * Return the last day of a month for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the last day of a month
 *
 * @example
 * // The last day of a month for 2 September 2014 11:55:00:
 * var result = lastDayOfMonth(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 30 2014 00:00:00
 */
function lastDayOfMonth (dirtyDate) {
  var date = parse(dirtyDate)
  var month = date.getMonth()
  date.setFullYear(date.getFullYear(), month + 1, 0)
  date.setHours(0, 0, 0, 0)
  return date
}

module.exports = lastDayOfMonth


/***/ }),
/* 2747 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(9)

/**
 * @category Quarter Helpers
 * @summary Return the last day of a year quarter for the given date.
 *
 * @description
 * Return the last day of a year quarter for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the last day of a quarter
 *
 * @example
 * // The last day of a quarter for 2 September 2014 11:55:00:
 * var result = lastDayOfQuarter(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 30 2014 00:00:00
 */
function lastDayOfQuarter (dirtyDate) {
  var date = parse(dirtyDate)
  var currentMonth = date.getMonth()
  var month = currentMonth - currentMonth % 3 + 3
  date.setMonth(month, 0)
  date.setHours(0, 0, 0, 0)
  return date
}

module.exports = lastDayOfQuarter


/***/ }),
/* 2748 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(9)

/**
 * @category Year Helpers
 * @summary Return the last day of a year for the given date.
 *
 * @description
 * Return the last day of a year for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the last day of a year
 *
 * @example
 * // The last day of a year for 2 September 2014 11:55:00:
 * var result = lastDayOfYear(new Date(2014, 8, 2, 11, 55, 00))
 * //=> Wed Dec 31 2014 00:00:00
 */
function lastDayOfYear (dirtyDate) {
  var date = parse(dirtyDate)
  var year = date.getFullYear()
  date.setFullYear(year + 1, 0, 0)
  date.setHours(0, 0, 0, 0)
  return date
}

module.exports = lastDayOfYear


/***/ }),
/* 2749 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(9)

/**
 * @category Common Helpers
 * @summary Return the latest of the given dates.
 *
 * @description
 * Return the latest of the given dates.
 *
 * @param {...(Date|String|Number)} dates - the dates to compare
 * @returns {Date} the latest of the dates
 *
 * @example
 * // Which of these dates is the latest?
 * var result = max(
 *   new Date(1989, 6, 10),
 *   new Date(1987, 1, 11),
 *   new Date(1995, 6, 2),
 *   new Date(1990, 0, 1)
 * )
 * //=> Sun Jul 02 1995 00:00:00
 */
function max () {
  var dirtyDates = Array.prototype.slice.call(arguments)
  var dates = dirtyDates.map(function (dirtyDate) {
    return parse(dirtyDate)
  })
  var latestTimestamp = Math.max.apply(null, dates)
  return new Date(latestTimestamp)
}

module.exports = max


/***/ }),
/* 2750 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(9)

/**
 * @category Common Helpers
 * @summary Return the earliest of the given dates.
 *
 * @description
 * Return the earliest of the given dates.
 *
 * @param {...(Date|String|Number)} dates - the dates to compare
 * @returns {Date} the earliest of the dates
 *
 * @example
 * // Which of these dates is the earliest?
 * var result = min(
 *   new Date(1989, 6, 10),
 *   new Date(1987, 1, 11),
 *   new Date(1995, 6, 2),
 *   new Date(1990, 0, 1)
 * )
 * //=> Wed Feb 11 1987 00:00:00
 */
function min () {
  var dirtyDates = Array.prototype.slice.call(arguments)
  var dates = dirtyDates.map(function (dirtyDate) {
    return parse(dirtyDate)
  })
  var earliestTimestamp = Math.min.apply(null, dates)
  return new Date(earliestTimestamp)
}

module.exports = min


/***/ }),
/* 2751 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(9)

/**
 * @category Day Helpers
 * @summary Set the day of the month to the given date.
 *
 * @description
 * Set the day of the month to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} dayOfMonth - the day of the month of the new date
 * @returns {Date} the new date with the day of the month setted
 *
 * @example
 * // Set the 30th day of the month to 1 September 2014:
 * var result = setDate(new Date(2014, 8, 1), 30)
 * //=> Tue Sep 30 2014 00:00:00
 */
function setDate (dirtyDate, dirtyDayOfMonth) {
  var date = parse(dirtyDate)
  var dayOfMonth = Number(dirtyDayOfMonth)
  date.setDate(dayOfMonth)
  return date
}

module.exports = setDate


/***/ }),
/* 2752 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(9)
var addDays = __webpack_require__(148)

/**
 * @category Weekday Helpers
 * @summary Set the day of the week to the given date.
 *
 * @description
 * Set the day of the week to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} day - the day of the week of the new date
 * @param {Object} [options] - the object with options
 * @param {Number} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @returns {Date} the new date with the day of the week setted
 *
 * @example
 * // Set Sunday to 1 September 2014:
 * var result = setDay(new Date(2014, 8, 1), 0)
 * //=> Sun Aug 31 2014 00:00:00
 *
 * @example
 * // If week starts with Monday, set Sunday to 1 September 2014:
 * var result = setDay(new Date(2014, 8, 1), 0, {weekStartsOn: 1})
 * //=> Sun Sep 07 2014 00:00:00
 */
function setDay (dirtyDate, dirtyDay, dirtyOptions) {
  var weekStartsOn = dirtyOptions ? (Number(dirtyOptions.weekStartsOn) || 0) : 0
  var date = parse(dirtyDate)
  var day = Number(dirtyDay)
  var currentDay = date.getDay()

  var remainder = day % 7
  var dayIndex = (remainder + 7) % 7

  var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay
  return addDays(date, diff)
}

module.exports = setDay


/***/ }),
/* 2753 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(9)

/**
 * @category Day Helpers
 * @summary Set the day of the year to the given date.
 *
 * @description
 * Set the day of the year to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} dayOfYear - the day of the year of the new date
 * @returns {Date} the new date with the day of the year setted
 *
 * @example
 * // Set the 2nd day of the year to 2 July 2014:
 * var result = setDayOfYear(new Date(2014, 6, 2), 2)
 * //=> Thu Jan 02 2014 00:00:00
 */
function setDayOfYear (dirtyDate, dirtyDayOfYear) {
  var date = parse(dirtyDate)
  var dayOfYear = Number(dirtyDayOfYear)
  date.setMonth(0)
  date.setDate(dayOfYear)
  return date
}

module.exports = setDayOfYear


/***/ }),
/* 2754 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(9)

/**
 * @category Hour Helpers
 * @summary Set the hours to the given date.
 *
 * @description
 * Set the hours to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} hours - the hours of the new date
 * @returns {Date} the new date with the hours setted
 *
 * @example
 * // Set 4 hours to 1 September 2014 11:30:00:
 * var result = setHours(new Date(2014, 8, 1, 11, 30), 4)
 * //=> Mon Sep 01 2014 04:30:00
 */
function setHours (dirtyDate, dirtyHours) {
  var date = parse(dirtyDate)
  var hours = Number(dirtyHours)
  date.setHours(hours)
  return date
}

module.exports = setHours


/***/ }),
/* 2755 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(9)
var addDays = __webpack_require__(148)
var getISODay = __webpack_require__(726)

/**
 * @category Weekday Helpers
 * @summary Set the day of the ISO week to the given date.
 *
 * @description
 * Set the day of the ISO week to the given date.
 * ISO week starts with Monday.
 * 7 is the index of Sunday, 1 is the index of Monday etc.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} day - the day of the ISO week of the new date
 * @returns {Date} the new date with the day of the ISO week setted
 *
 * @example
 * // Set Sunday to 1 September 2014:
 * var result = setISODay(new Date(2014, 8, 1), 7)
 * //=> Sun Sep 07 2014 00:00:00
 */
function setISODay (dirtyDate, dirtyDay) {
  var date = parse(dirtyDate)
  var day = Number(dirtyDay)
  var currentDay = getISODay(date)
  var diff = day - currentDay
  return addDays(date, diff)
}

module.exports = setISODay


/***/ }),
/* 2756 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(9)
var getISOWeek = __webpack_require__(386)

/**
 * @category ISO Week Helpers
 * @summary Set the ISO week to the given date.
 *
 * @description
 * Set the ISO week to the given date, saving the weekday number.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} isoWeek - the ISO week of the new date
 * @returns {Date} the new date with the ISO week setted
 *
 * @example
 * // Set the 53rd ISO week to 7 August 2004:
 * var result = setISOWeek(new Date(2004, 7, 7), 53)
 * //=> Sat Jan 01 2005 00:00:00
 */
function setISOWeek (dirtyDate, dirtyISOWeek) {
  var date = parse(dirtyDate)
  var isoWeek = Number(dirtyISOWeek)
  var diff = getISOWeek(date) - isoWeek
  date.setDate(date.getDate() - diff * 7)
  return date
}

module.exports = setISOWeek


/***/ }),
/* 2757 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(9)

/**
 * @category Millisecond Helpers
 * @summary Set the milliseconds to the given date.
 *
 * @description
 * Set the milliseconds to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} milliseconds - the milliseconds of the new date
 * @returns {Date} the new date with the milliseconds setted
 *
 * @example
 * // Set 300 milliseconds to 1 September 2014 11:30:40.500:
 * var result = setMilliseconds(new Date(2014, 8, 1, 11, 30, 40, 500), 300)
 * //=> Mon Sep 01 2014 11:30:40.300
 */
function setMilliseconds (dirtyDate, dirtyMilliseconds) {
  var date = parse(dirtyDate)
  var milliseconds = Number(dirtyMilliseconds)
  date.setMilliseconds(milliseconds)
  return date
}

module.exports = setMilliseconds


/***/ }),
/* 2758 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(9)

/**
 * @category Minute Helpers
 * @summary Set the minutes to the given date.
 *
 * @description
 * Set the minutes to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} minutes - the minutes of the new date
 * @returns {Date} the new date with the minutes setted
 *
 * @example
 * // Set 45 minutes to 1 September 2014 11:30:40:
 * var result = setMinutes(new Date(2014, 8, 1, 11, 30, 40), 45)
 * //=> Mon Sep 01 2014 11:45:40
 */
function setMinutes (dirtyDate, dirtyMinutes) {
  var date = parse(dirtyDate)
  var minutes = Number(dirtyMinutes)
  date.setMinutes(minutes)
  return date
}

module.exports = setMinutes


/***/ }),
/* 2759 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(9)
var setMonth = __webpack_require__(738)

/**
 * @category Quarter Helpers
 * @summary Set the year quarter to the given date.
 *
 * @description
 * Set the year quarter to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} quarter - the quarter of the new date
 * @returns {Date} the new date with the quarter setted
 *
 * @example
 * // Set the 2nd quarter to 2 July 2014:
 * var result = setQuarter(new Date(2014, 6, 2), 2)
 * //=> Wed Apr 02 2014 00:00:00
 */
function setQuarter (dirtyDate, dirtyQuarter) {
  var date = parse(dirtyDate)
  var quarter = Number(dirtyQuarter)
  var oldQuarter = Math.floor(date.getMonth() / 3) + 1
  var diff = quarter - oldQuarter
  return setMonth(date, date.getMonth() + diff * 3)
}

module.exports = setQuarter


/***/ }),
/* 2760 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(9)

/**
 * @category Second Helpers
 * @summary Set the seconds to the given date.
 *
 * @description
 * Set the seconds to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} seconds - the seconds of the new date
 * @returns {Date} the new date with the seconds setted
 *
 * @example
 * // Set 45 seconds to 1 September 2014 11:30:40:
 * var result = setSeconds(new Date(2014, 8, 1, 11, 30, 40), 45)
 * //=> Mon Sep 01 2014 11:30:45
 */
function setSeconds (dirtyDate, dirtySeconds) {
  var date = parse(dirtyDate)
  var seconds = Number(dirtySeconds)
  date.setSeconds(seconds)
  return date
}

module.exports = setSeconds


/***/ }),
/* 2761 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(9)

/**
 * @category Year Helpers
 * @summary Set the year to the given date.
 *
 * @description
 * Set the year to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} year - the year of the new date
 * @returns {Date} the new date with the year setted
 *
 * @example
 * // Set year 2013 to 1 September 2014:
 * var result = setYear(new Date(2014, 8, 1), 2013)
 * //=> Sun Sep 01 2013 00:00:00
 */
function setYear (dirtyDate, dirtyYear) {
  var date = parse(dirtyDate)
  var year = Number(dirtyYear)
  date.setFullYear(year)
  return date
}

module.exports = setYear


/***/ }),
/* 2762 */
/***/ (function(module, exports, __webpack_require__) {

var startOfDay = __webpack_require__(82)

/**
 * @category Day Helpers
 * @summary Return the start of today.
 *
 * @description
 * Return the start of today.
 *
 * @returns {Date} the start of today
 *
 * @example
 * // If today is 6 October 2014:
 * var result = startOfToday()
 * //=> Mon Oct 6 2014 00:00:00
 */
function startOfToday () {
  return startOfDay(new Date())
}

module.exports = startOfToday


/***/ }),
/* 2763 */
/***/ (function(module, exports) {

/**
 * @category Day Helpers
 * @summary Return the start of tomorrow.
 *
 * @description
 * Return the start of tomorrow.
 *
 * @returns {Date} the start of tomorrow
 *
 * @example
 * // If today is 6 October 2014:
 * var result = startOfTomorrow()
 * //=> Tue Oct 7 2014 00:00:00
 */
function startOfTomorrow () {
  var now = new Date()
  var year = now.getFullYear()
  var month = now.getMonth()
  var day = now.getDate()

  var date = new Date(0)
  date.setFullYear(year, month, day + 1)
  date.setHours(0, 0, 0, 0)
  return date
}

module.exports = startOfTomorrow


/***/ }),
/* 2764 */
/***/ (function(module, exports) {

/**
 * @category Day Helpers
 * @summary Return the start of yesterday.
 *
 * @description
 * Return the start of yesterday.
 *
 * @returns {Date} the start of yesterday
 *
 * @example
 * // If today is 6 October 2014:
 * var result = startOfYesterday()
 * //=> Sun Oct 5 2014 00:00:00
 */
function startOfYesterday () {
  var now = new Date()
  var year = now.getFullYear()
  var month = now.getMonth()
  var day = now.getDate()

  var date = new Date(0)
  date.setFullYear(year, month, day - 1)
  date.setHours(0, 0, 0, 0)
  return date
}

module.exports = startOfYesterday


/***/ }),
/* 2765 */
/***/ (function(module, exports, __webpack_require__) {

var addDays = __webpack_require__(148)

/**
 * @category Day Helpers
 * @summary Subtract the specified number of days from the given date.
 *
 * @description
 * Subtract the specified number of days from the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of days to be subtracted
 * @returns {Date} the new date with the days subtracted
 *
 * @example
 * // Subtract 10 days from 1 September 2014:
 * var result = subDays(new Date(2014, 8, 1), 10)
 * //=> Fri Aug 22 2014 00:00:00
 */
function subDays (dirtyDate, dirtyAmount) {
  var amount = Number(dirtyAmount)
  return addDays(dirtyDate, -amount)
}

module.exports = subDays


/***/ }),
/* 2766 */
/***/ (function(module, exports, __webpack_require__) {

var addHours = __webpack_require__(709)

/**
 * @category Hour Helpers
 * @summary Subtract the specified number of hours from the given date.
 *
 * @description
 * Subtract the specified number of hours from the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of hours to be subtracted
 * @returns {Date} the new date with the hours subtracted
 *
 * @example
 * // Subtract 2 hours from 11 July 2014 01:00:00:
 * var result = subHours(new Date(2014, 6, 11, 1, 0), 2)
 * //=> Thu Jul 10 2014 23:00:00
 */
function subHours (dirtyDate, dirtyAmount) {
  var amount = Number(dirtyAmount)
  return addHours(dirtyDate, -amount)
}

module.exports = subHours


/***/ }),
/* 2767 */
/***/ (function(module, exports, __webpack_require__) {

var addMilliseconds = __webpack_require__(206)

/**
 * @category Millisecond Helpers
 * @summary Subtract the specified number of milliseconds from the given date.
 *
 * @description
 * Subtract the specified number of milliseconds from the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be subtracted
 * @returns {Date} the new date with the milliseconds subtracted
 *
 * @example
 * // Subtract 750 milliseconds from 10 July 2014 12:45:30.000:
 * var result = subMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:29.250
 */
function subMilliseconds (dirtyDate, dirtyAmount) {
  var amount = Number(dirtyAmount)
  return addMilliseconds(dirtyDate, -amount)
}

module.exports = subMilliseconds


/***/ }),
/* 2768 */
/***/ (function(module, exports, __webpack_require__) {

var addMinutes = __webpack_require__(712)

/**
 * @category Minute Helpers
 * @summary Subtract the specified number of minutes from the given date.
 *
 * @description
 * Subtract the specified number of minutes from the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of minutes to be subtracted
 * @returns {Date} the new date with the mintues subtracted
 *
 * @example
 * // Subtract 30 minutes from 10 July 2014 12:00:00:
 * var result = subMinutes(new Date(2014, 6, 10, 12, 0), 30)
 * //=> Thu Jul 10 2014 11:30:00
 */
function subMinutes (dirtyDate, dirtyAmount) {
  var amount = Number(dirtyAmount)
  return addMinutes(dirtyDate, -amount)
}

module.exports = subMinutes


/***/ }),
/* 2769 */
/***/ (function(module, exports, __webpack_require__) {

var addMonths = __webpack_require__(286)

/**
 * @category Month Helpers
 * @summary Subtract the specified number of months from the given date.
 *
 * @description
 * Subtract the specified number of months from the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of months to be subtracted
 * @returns {Date} the new date with the months subtracted
 *
 * @example
 * // Subtract 5 months from 1 February 2015:
 * var result = subMonths(new Date(2015, 1, 1), 5)
 * //=> Mon Sep 01 2014 00:00:00
 */
function subMonths (dirtyDate, dirtyAmount) {
  var amount = Number(dirtyAmount)
  return addMonths(dirtyDate, -amount)
}

module.exports = subMonths


/***/ }),
/* 2770 */
/***/ (function(module, exports, __webpack_require__) {

var addQuarters = __webpack_require__(713)

/**
 * @category Quarter Helpers
 * @summary Subtract the specified number of year quarters from the given date.
 *
 * @description
 * Subtract the specified number of year quarters from the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of quarters to be subtracted
 * @returns {Date} the new date with the quarters subtracted
 *
 * @example
 * // Subtract 3 quarters from 1 September 2014:
 * var result = subQuarters(new Date(2014, 8, 1), 3)
 * //=> Sun Dec 01 2013 00:00:00
 */
function subQuarters (dirtyDate, dirtyAmount) {
  var amount = Number(dirtyAmount)
  return addQuarters(dirtyDate, -amount)
}

module.exports = subQuarters


/***/ }),
/* 2771 */
/***/ (function(module, exports, __webpack_require__) {

var addSeconds = __webpack_require__(714)

/**
 * @category Second Helpers
 * @summary Subtract the specified number of seconds from the given date.
 *
 * @description
 * Subtract the specified number of seconds from the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of seconds to be subtracted
 * @returns {Date} the new date with the seconds subtracted
 *
 * @example
 * // Subtract 30 seconds from 10 July 2014 12:45:00:
 * var result = subSeconds(new Date(2014, 6, 10, 12, 45, 0), 30)
 * //=> Thu Jul 10 2014 12:44:30
 */
function subSeconds (dirtyDate, dirtyAmount) {
  var amount = Number(dirtyAmount)
  return addSeconds(dirtyDate, -amount)
}

module.exports = subSeconds


/***/ }),
/* 2772 */
/***/ (function(module, exports, __webpack_require__) {

var addWeeks = __webpack_require__(419)

/**
 * @category Week Helpers
 * @summary Subtract the specified number of weeks from the given date.
 *
 * @description
 * Subtract the specified number of weeks from the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of weeks to be subtracted
 * @returns {Date} the new date with the weeks subtracted
 *
 * @example
 * // Subtract 4 weeks from 1 September 2014:
 * var result = subWeeks(new Date(2014, 8, 1), 4)
 * //=> Mon Aug 04 2014 00:00:00
 */
function subWeeks (dirtyDate, dirtyAmount) {
  var amount = Number(dirtyAmount)
  return addWeeks(dirtyDate, -amount)
}

module.exports = subWeeks


/***/ }),
/* 2773 */
/***/ (function(module, exports, __webpack_require__) {

var addYears = __webpack_require__(715)

/**
 * @category Year Helpers
 * @summary Subtract the specified number of years from the given date.
 *
 * @description
 * Subtract the specified number of years from the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of years to be subtracted
 * @returns {Date} the new date with the years subtracted
 *
 * @example
 * // Subtract 5 years from 1 September 2014:
 * var result = subYears(new Date(2014, 8, 1), 5)
 * //=> Tue Sep 01 2009 00:00:00
 */
function subYears (dirtyDate, dirtyAmount) {
  var amount = Number(dirtyAmount)
  return addYears(dirtyDate, -amount)
}

module.exports = subYears


/***/ }),
/* 2774 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_core__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_CustomCardHeading_CustomCardHeading_jsx__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var disabilityBenefits=[{name:'Comprehensive Own Occupation Disability',desc:'Comprehensive Own Occupational Disability (Combination of occupational disability and impairment with tiered pay-outs)',fmi:'Disability Lump Sum - Comprehensive',hollard:'Comprehensive Disabilty Benefit - Own Occupation',liberty:'Absolute Protector (OOD) (Plus)',momentum:'Comprehensive Disability Benefit',sanlam:'Functional Impairment plus Disability for Regular Occupation (CAR) CSR)'},{name:'Comprehensive Own or Similar Occupation Disability',desc:'Comprehensive Own or Similar Occupational Disability (Combination of occupational disability and impairment with tiered pay-outs)',fmi:'Disability Lump Sum - Comprehensive',hollard:'Comprehensive Disabilty Benefit - Own/Similar Occupation',liberty:'Absolute Protector (OD) (Plus)',momentum:'Comprehensive ADW Disability Benefit',sanlam:'Functional Impairment plus Disability for Regular and Reasonable Alternative Occupation (CAS) (CSS)'},{name:'Own Occupation Disability',desc:'Own Occupational Disability (Only 100% claim - no tiered payments)',fmi:'Disability Lump Sum - Occupational',hollard:'Core Disability Benefit - Own Occupation',liberty:'Capital Disability (OOD) (Plus)',momentum:'Own Occupation Disability Benefit ',sanlam:'Disability for Regular Occupation (OAR) (OSR)'},{name:'Own/Similar occupation ',desc:'Own or Similar Occupational Disability (Only 100% claim - no tiered payments)',fmi:'Disability Lump Sum - Occupational',hollard:'Core Disability Benefit - Own/Similar Occupation',liberty:'Capital disability (OD) (Plus)',momentum:'ADW Disability Benefit',sanlam:'Disability for Regular and Reasonable Alternative Occupation (OAS) (OSS)'},{name:'Impairment',desc:'Impairment',fmi:'Disability Lump Sum - Occupational',hollard:'Comprehensive Impairment',liberty:'Impairment (Plus)',momentum:'Functional Impairment',sanlam:'Functional impairment (OAF) (OSF)'}];var criticalIllnessBenefits=[{name:'Enhanced',desc:'Most comprehensive critical illness on offer',fmi:'Critical illness -Include Top-up',hollard:'Comprehensive Critical Illness (Max)',liberty:'Living Livestyle with Top up and Extended Options (Plus)',momentum:'Complete Enhanced Critical Illness',sanlam:'Comprehensive Severe Illness Plus (TAW4) (TSW4)'},{name:'Standard',desc:'Critical Illness without SCIDEP claims 100%',fmi:'Critical illness -Include Extender',hollard:'Comprehensive Severe Illness (Severity based)',liberty:'Living Livestyle with Extended Option (Plus)',momentum:'Complete Critical Illness Benefit',sanlam:'Comprehensive Severe Illness (TAW3) (TSW3)'}];var temporaryIncomeBenefit=[{name:'Temporary income protector',desc:'24 months payment',fmi:'Temporary Income Protector',hollard:'Compehensive Disability Income Benefit',liberty:'Absolute Income Protector Benefit',momentum:'Temporary Income Protector Benefit',sanlam:'Temporary Disability Income Benefit (OIT3)'}];var extendedIncomeBenefit=[{name:'Extended income protector',desc:'24 months waiting period',fmi:'Extended Income Protector',hollard:'Compehensive Disability Income Benefit',liberty:'Extended Absolute Income Protector Benefit',momentum:'Income Protector Benefit',sanlam:'Extended Disability Income Benefit (OIO3)'}];var BenefitMapping=function(_React$Component){_inherits(BenefitMapping,_React$Component);function BenefitMapping(){_classCallCheck(this,BenefitMapping);return _possibleConstructorReturn(this,(BenefitMapping.__proto__||Object.getPrototypeOf(BenefitMapping)).apply(this,arguments));}_createClass(BenefitMapping,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'contentWithStepper'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["e" /* Card */],{className:this.classes},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["f" /* CardContent */],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_CustomCardHeading_CustomCardHeading_jsx__["a" /* default */],{subheading:'Quote Generation',caption:this.props.clientFullname,headline:'Benefit Mapping'}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{style:{maxHeight:600,overflowY:'auto'}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Q" /* Table */],{className:'customTable1'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["T" /* TableHead */],{className:'fixedHead'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,'Sure-Quote'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,'Bidvest'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,'Hollard'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,'Liberty'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,'Momentum'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,'Sanlam'))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["R" /* TableBody */],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('strong',null,'Death Benefits')),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null),Array(4).fill('').map(function(x){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null);})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],null,'Life cover'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Y" /* Tooltip */],{title:'Life cover'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["w" /* Icon */],{style:{color:'#95acbd'}},'info'))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],null,'Life Lump Sum')),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],null,'Life Cover Benefit')),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],null,'Life Cover')),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],null,'Death Benefit')),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],null,'Death (DS)'))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('strong',null,'Disability benefits')),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null),Array(4).fill('').map(function(x){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null);})),disabilityBenefits.map(function(ben){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],null,ben.name),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Y" /* Tooltip */],{title:ben.desc},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["w" /* Icon */],{style:{color:'#95acbd'}},'info'))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],null,ben.fmi)),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],null,ben.hollard)),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],null,' ',ben.liberty)),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],null,ben.momentum)),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],null,ben.sanlam)));}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('strong',null,'Critical illness benefits')),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null),Array(4).fill('').map(function(x){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null);})),criticalIllnessBenefits.map(function(ben){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],null,ben.name),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Y" /* Tooltip */],{title:ben.desc},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["w" /* Icon */],{style:{color:'#95acbd'}},'info'))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],null,ben.fmi)),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],null,ben.hollard)),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],null,' ',ben.liberty)),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],null,ben.momentum)),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],null,ben.sanlam)));}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('strong',null,'Temporary income benefits')),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null),Array(4).fill('').map(function(x){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null);})),temporaryIncomeBenefit.map(function(ben){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],null,ben.name),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Y" /* Tooltip */],{title:ben.desc},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["w" /* Icon */],{style:{color:'#95acbd'}},'info'))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],null,ben.fmi)),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],null,ben.hollard)),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],null,' ',ben.liberty)),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],null,ben.momentum)),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],null,ben.sanlam)));}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('strong',null,'Extended income benefits')),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null),Array(4).fill('').map(function(x){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null);})),extendedIncomeBenefit.map(function(ben){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],null,ben.name),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Y" /* Tooltip */],{title:ben.desc},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["w" /* Icon */],{style:{color:'#95acbd'}},'info'))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],null,ben.fmi)),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],null,ben.hollard)),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],null,' ',ben.liberty)),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],null,ben.momentum)),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],null,ben.sanlam)));})))))));}}]);return BenefitMapping;}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (BenefitMapping);

/***/ }),
/* 2775 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(625);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_apollo__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Grid_GridItem_jsx__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_helpers_DrivingHoursConverter__ = __webpack_require__(708);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_helpers_UriReader__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_helpers_UserHelper__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_queries_quotes_queries_js__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_queries_SubmitMedical__ = __webpack_require__(2776);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_router__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_reducers_NotificationReducer__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_reducers_TasksReducer__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_redux_form__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_store__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__steps_BenefitDetails_jsx__ = __webpack_require__(2777);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__steps_BenefitSelection_jsx__ = __webpack_require__(2784);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__steps_CompanySelection_jsx__ = __webpack_require__(2785);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__steps_CompanySpecific_jsx__ = __webpack_require__(2829);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__steps_QuoteDetails_jsx__ = __webpack_require__(2834);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__steps_BenefitMapping__ = __webpack_require__(2835);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__objects_syncErrorHelper__ = __webpack_require__(2837);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__steps_MedicalFsp_jsx__ = __webpack_require__(2838);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_graphql_tag__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_graphql_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_graphql_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_constants_js__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_xml_js__ = __webpack_require__(2839);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_xml_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26_xml_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_lodash__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27_lodash__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n\tquery result($path: String!, $content: String!) {\n\t\tResultPdfMedical(path: $path, content: $content) {\n\t\t\tfilename\n\t\t}\n\t}\n'],['\n\tquery result($path: String!, $content: String!) {\n\t\tResultPdfMedical(path: $path, content: $content) {\n\t\t\tfilename\n\t\t}\n\t}\n']);function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var getResultPdf=__WEBPACK_IMPORTED_MODULE_24_graphql_tag___default()(_templateObject);var QuoteWizardMedical=function(_Component){_inherits(QuoteWizardMedical,_Component);function QuoteWizardMedical(props){var _this2=this,_this$state;_classCallCheck(this,QuoteWizardMedical);var _this=_possibleConstructorReturn(this,(QuoteWizardMedical.__proto__||Object.getPrototypeOf(QuoteWizardMedical)).call(this,props));_this.checkSelectedTarget=function(id,checked){var selectedTargets=[].concat(_toConsumableArray(_this.state.selectedTargets));if(checked){selectedTargets.push(id);}else{selectedTargets=selectedTargets.filter(function(t){return t!==id;});}_this.setState({selectedTargets:selectedTargets});};_this.checkSelectedTargetGap=function(id,checked){var selectedTargets=[].concat(_toConsumableArray(_this.state.selectedTargetsGap));if(checked){selectedTargets.push(id);}else{selectedTargets=selectedTargets.filter(function(t){return t!==id;});}_this.setState({selectedTargetsGap:selectedTargets});_this.setState({selectedBenefits:selectedTargets});};_this.checkSelectedTargetLoyalty=function(id,checked){var selectedTargets=[].concat(_toConsumableArray(_this.state.selectedTargetsLoyalty));if(checked){selectedTargets.push(id);}else{selectedTargets=selectedTargets.filter(function(t){return t!==id;});}_this.setState({selectedTargetsLoyalty:selectedTargets});};_this.toggleAllTargets=function(targets,checked){var selectedTargets=[].concat(_toConsumableArray(_this.state.selectedTargets));if(checked){targets.map(function(t){if(!selectedTargets.includes(t.id)){selectedTargets.push(t.id);}return t;});}else{selectedTargets=[];}_this.setState({selectedTargets:selectedTargets});};_this.toggleAllTargetsGap=function(targets,checked){var selectedTargets=[].concat(_toConsumableArray(_this.state.selectedTargetsGap));if(checked){targets.map(function(t){if(!selectedTargets.includes(t.id)){selectedTargets.push(t.id);}return t;});}else{selectedTargets=[];}_this.setState({selectedTargetsGap:selectedTargets});};_this.toggleAllTargetsLoyalty=function(targets,checked){var selectedTargets=[].concat(_toConsumableArray(_this.state.selectedTargetsLoyalty));if(checked){targets.map(function(t){if(!selectedTargets.includes(t.id)){selectedTargets.push(t.id);}return t;});}else{selectedTargets=[];}_this.setState({selectedTargetsLoyalty:selectedTargets});};_this.checkSelectedBenefit=function(id,checked){var selectedBenefits=[].concat(_toConsumableArray(_this.state.selectedBenefits));if(checked){selectedBenefits.push(id);}else{selectedBenefits=selectedBenefits.filter(function(t){return t!==id;});}_this.setState({selectedBenefits:selectedBenefits});};_this.checkSelectedMiscBenefit=function(id,checked){var targets=arguments.length>2&&arguments[2]!==undefined?arguments[2]:[];var selectedMiscBenefits=Object.assign({},_this.state.selectedMiscBenefits);if(checked){selectedMiscBenefits['misc'+id]=targets;}else{delete selectedMiscBenefits['misc'+id];}_this.setState({selectedMiscBenefits:selectedMiscBenefits});_this.forceUpdate();};_this.checkMiscBenefitTarget=function(id,checked,targetId){var selectedMiscBenefits=Object.assign({},_this.state.selectedMiscBenefits);if(!selectedMiscBenefits['misc'+id])return;var selectedTargets=[].concat(_toConsumableArray(selectedMiscBenefits['misc'+id]));if(checked){selectedTargets=[].concat(_toConsumableArray(selectedTargets),[targetId]);}else{selectedTargets=selectedTargets.filter(function(t){return t!==targetId;});}_this.setState({selectedMiscBenefits:Object.assign({},selectedMiscBenefits,_defineProperty({},'misc'+id,selectedTargets))});_this.forceUpdate();};_this.toggleAllBenefits=function(benefits,checked){var selectedBenefits=[].concat(_toConsumableArray(_this.state.selectedBenefits));if(checked){benefits.map(function(b){if(!selectedBenefits.includes(b.id)){selectedBenefits.push(b.id);}return b;});}else{selectedBenefits=[];}_this.setState({selectedBenefits:selectedBenefits});};_this.pushNextPage=function(){_this.setState({page:_this.state.page+1});_this.setState({checkValidation:false});};_this.getBrokerId=function(){var brokerId=Object(__WEBPACK_IMPORTED_MODULE_6_helpers_UserHelper__["a" /* GetUserId */])();if(_this.checkAssistantActive()){brokerId=sessionStorage.getItem('ActiveBrokerId');}return brokerId;};_this.handleAddDependentAdult=function(value){var n=_this.state.dependentsAdult;var adult=n.length;if(n[n.length-1])adult=n[n.length-1].id+1;n.push({id:adult,dob:"01/01/0001",withoutMed:0,prevMeds:[]});_this.setState({dependentsAdult:n});};_this.handleRemoveDependentAdult=function(e){var i=e.currentTarget.id.replace("adultDepRemove","");var n=_this.state.dependentsAdult;var n2=[];for(var k=0;k<n.length;k++){if(i!=n[k].id){n2.push(n[k]);}else console.log("");}_this.setState({dependentsAdult:n2});};_this.changechildDob=function(e,i,dob){i=e.target.id.replace("childDepDateOfBirth","");var n=_this.state.dependentsChild;n[i].dob=dob;_this.setState({dependentsChild:n});};_this.handleAddDependentChild=function(value){var n=_this.state.dependentsChild;var child=n.length;if(n[n.length-1])child=n[n.length-1].id+1;n.push({id:child,dob:0});// console.log(child)
_this.setState({dependentsChild:n});};_this.handleRemoveDependentChild=function(e){var i=e.currentTarget.id.replace("childDepRemove","");var n=_this.state.dependentsChild;var n2=[];//console.log(i)
for(var k=0;k<n.length;k++){if(i!=n[k].id){n2.push(n[k]);}else console.log("");}_this.setState({dependentsChild:n2});};_this.changeGap=function(n){//console.log(n)
_this.setState({gapCover:n});};_this.changeLoyalty=function(n){_this.setState({loyalty:n});};_this.changeHospitalOnly=function(n){_this.setState({hospitalOnly:n});};_this.changePlanType=function(n){var value="";for(var k=0;k<Object.keys(n).length-1;k++){value+=n[k];}_this.setState({planType:value});};_this.changeCoverLevel=function(n){var value="";for(var k=0;k<Object.keys(n).length-1;k++){value+=n[k];}_this.setState({coverLevel:value});};_this.changeHospitalLevel=function(n){var value="";for(var k=0;k<Object.keys(n).length-1;k++){value+=n[k];}_this.setState({hospitalLevel:value});};_this.changeChronicLevel=function(n){var value="";for(var k=0;k<Object.keys(n).length-1;k++){value+=n[k];}_this.setState({chronicProvider:value});};_this.changeServiceLevel=function(n){var value="";for(var k=0;k<Object.keys(n).length-1;k++){value+=n[k];}_this.setState({serviceProvider:value});};_this.changeDependentDob=function(n){var id=n.target.id.replace("adultDepDateOfBirth","");var value=n.target.value;var dependents=_this.state.dependentsAdult;dependents[id].dob=value;//console.log("This is SPARTA");
//console.log(dependents);
_this.setState({dependentsAdult:dependents});};_this.changeDependentDob=function(n){var id=n.target.id.replace("adultDepDateOfBirth","");var value=n.target.value;var dependents=_this.state.dependentsAdult;dependents[id].dob=value;//console.log("This is SPARTA");
//console.log(dependents);
_this.setState({dependentsAdult:dependents});};_this.changeDependentWithoutMed=function(n){var id=n.target.id.replace("yearsWithoutM","");var value=n.target.value;var dependents=_this.state.dependentsAdult;dependents[id].withoutMed=value;//console.log("This is SPARTA");
//console.log(dependents);
_this.setState({dependentsAdult:dependents});};_this.changeWithoutMed=function(n){var value=n.target.value;_this.setState({withoutMed:value});};_this.changeBrokerFee=function(n){//console.log(this.state)
var value="";for(var k=0;k<Object.keys(n).length-1;k++){value+=n[k];}_this.setState({brokerFee:value});};_this.changeDToD=function(n){var value="";for(var k=0;k<Object.keys(n).length-1;k++){value+=n[k];}_this.setState({dToD:value});};_this.changeSubsidy=function(n){var value="";for(var k=0;k<Object.keys(n).length-1;k++){value+=n[k];}_this.setState({subsidy:value});};_this.changeStartDate=function(n){//console.log(n)
var value="";for(var k=0;k<Object.keys(n).length-1;k++){value+=n[k];}_this.setState({startDate:value});};_this.changeGapLevel=function(n){//console.log(n)
var value=n[0];_this.setState({gapLevel:value});};_this.changeCoPay=function(n){var value=n[0];_this.setState({coPay:value});};_this.changeHSaverOption=function(n){var value=n[0];_this.setState({hSaverOption:value});};_this.handlePopoverClose=function(){_this.setState({popoverOpen:false});};_this.handlePopoverOpen=function(event){_this.setState({anchorTop:event.clientY,anchorLeft:event.clientX,popoverOpen:true});};_this.handleResultPdf=function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(e,path,client){var _ref2,data,errors,results;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_this.setState({loadingPdf:true});_context.next=3;return client.query({query:getResultPdf,variables:{path:path,content:document.getElementById('resultTable').innerHTML.toString().replace(/"/g,"'")}});case 3:_ref2=_context.sent;data=_ref2.data;errors=_ref2.errors;results={data:data,errors:errors};return _context.abrupt('return',results);case 8:case'end':return _context.stop();}}},_callee,_this2);}));return function(_x2,_x3,_x4){return _ref.apply(this,arguments);};}();_this.onPdfGet=function(data){var url=__WEBPACK_IMPORTED_MODULE_25_constants_js__["a" /* QuotePdfUri */]+_this.state.pdfUrl+'.pdf';window.open(url,'_blank');};_this.nextPage=_this.nextPage.bind(_this);_this.previousPage=_this.previousPage.bind(_this);_this.state=(_this$state={page:0,pageCount:3,checkValidation:false,formInitiazed:false,benefitsInitialized:false,br:false,mat100:0,mat75:0,clientId:null,guid:null,selectedTargets:[],selectedTargetsGap:[],selectedTargetsLoyalty:[],selectedBenefits:[],selectedMiscBenefits:{},clientAge:null,income:0,dependentsChild:[],dependentsAdult:[],dependentMedicalAmount:{},medicalAmount:0,hospitalOnly:false,planType:"",coverLevel:"",hospitalLevel:"",chronicProvider:"",serviceProvider:"",gapCover:0,gapLevel:0,coPay:false,loyalty:false,brokerFee:0,subsidy:0,withoutMed:0,startDate:"",hSaverOption:0,dToD:0,loadingPdf:false,resultsSet:false,popoverText:'',dialogTitle:'',dialogOpen:false},_defineProperty(_this$state,'loadingPdf',false),_defineProperty(_this$state,'downloadEl',null),_defineProperty(_this$state,'anchorTop',0),_defineProperty(_this$state,'anchorLeft',0),_defineProperty(_this$state,'popoverOpen',false),_this$state);return _this;}_createClass(QuoteWizardMedical,[{key:'componentDidMount',value:function componentDidMount(){var params=Object(__WEBPACK_IMPORTED_MODULE_5_helpers_UriReader__["a" /* ParseUriParams */])(this.props.location.search);var clientId=params.clientId,guid=params.guid,page=params.page;this.setState({clientId:clientId,guid:guid});if(page){this.setState({page:Object(__WEBPACK_IMPORTED_MODULE_27_lodash__["toNumber"])(page)});console.log("THIS IS PAAAAGE!!! "+page);}}},{key:'initializeForm',value:function initializeForm(data){var defaultInit={//Fields you can't see
Admin:data.scd_pAdmin,Travel:data.scd_pTravel,ManualLabour:data.scd_pManual,Supervision:data.scd_pSupervision,spouseIncome:data.scd_spouseIncome,title:data.scd_title,name:data.scd_name,surname:data.scd_surname,dateOfBirth:data.scd_dateOfBirth,gender:data.scd_gender,smoker:data.scd_smoker,qualification:data.scd_qualification,occupation:data.scd_occupation,selfEmployed:data.scd_selfEmployed,income:data.scd_monthlyIncome,salaryType:data.scd_salaryType,maritalStatus:data.scd_maritalStatus,TaxDispensation:data.scd_taxDispensation,calculatedMonthlyIncomeAT:data.scd_calculatedMonthlyIncomeAT?data.scd_calculatedMonthlyIncomeAT:'0',actualMonthlyIncomeAT:data.scd_actualMonthlyIncomeAT?data.scd_actualMonthlyIncomeAT:'0',//Fields you can see
comission:'100',percentageUpfronCommission:'100',PAAWCommission:'0',language:'English',brokerFee:'0',subsidy:'0',url:""};var editData={};if(this.state.guid){//Auto Populate targets
var selectedTargets=this.state.selectedTargets;var editTargets=data.targets.split(',').map(function(t){return parseInt(t,10);});var availTargets=__WEBPACK_IMPORTED_MODULE_23__steps_MedicalFsp_jsx__["a" /* MedicalFsp */].map(function(t){return parseInt(t.id,10);});this.state.selectedTargets=data.targets.split(',');var selectedTargetsLoyalty=this.state.selectedTargetsLoyalty;var editTargetsLoyalty=data.targets.split(',').map(function(t){return parseInt(t,10);});var availTargetsLoyalty=__WEBPACK_IMPORTED_MODULE_23__steps_MedicalFsp_jsx__["c" /* MedicalLoyaltyFsp */].map(function(t){return parseInt(t.id,10);});editTargets.map(function(t){if(availTargets.includes(t)){selectedTargets.push(t);}return t;});//console.log("[][][][][][][][][][][]" + data.benefits)
editTargetsLoyalty.map(function(t){if(availTargets.includes(t)){selectedTargets.push(t);}return t;});var miscBenefits={};try{if(data.misc_benefits)miscBenefits=JSON.parse(data.misc_benefits);}catch(e){}this.setState({selectedTargets:selectedTargets,selectedMiscBenefits:miscBenefits});editData=JSON.parse(data.formValues);var adults=[];var children=[];for(var element in editData){if(element.includes("childDepDateOfBirth")){var n=this.state.dependentsChild;var child=n.length;if(n[n.length-1])child=n[n.length-1].id+1;n.push({id:child,dob:editData[element]});this.setState({dependentsChild:n});}if(element.includes("adultDepDateOfBirth")){var n=this.state.dependentsAdult;var adult=n.length;var wm=0;if(editData["yearsWithoutM"+adult])wm=editData["yearsWithoutM"+adult];if(n[n.length-1])adult=n[n.length-1].id+1;n.push({id:adult,dob:editData[element],withoutMed:wm,prevMeds:[]});this.setState({dependentsAdult:n});}}var targetsGap=[];targetsGap.push(data.benefits);//This.setState for some reason does not set the state. Expicitly setting state values. Need to find out what is happening. Perhaps need to redo the medicaWizard initialization.
this.setState({hospitalLevel:editData.hospitalType,serviceProvider:editData.serviceType,chronicProvider:editData.chronicType,coverLevel:editData.coverType,subsidy:editData.subsidy,selectedTargets:data.targets.split(","),gapCover:editData.gapCover,loyalty:editData.loyalty,gapLevel:editData.gapCoverLevel,coPay:editData.paymentCover,hSaverOption:editData.hSaver,dToD:editData.dayToDay,selectedBenefits:targetsGap,selectedTargetsGap:targetsGap,startDate:editData.startDate});this.state.planType=editData.planType;this.state.hospitalLevel=editData.hospitalType;this.state.serviceProvider=editData.serviceType;this.state.chronicProvider=editData.chronicType;this.state.coverLevel=editData.coverType;this.state.subsidy=editData.subsidy;this.state.selectedTargets=data.targets.split(",");this.state.gapCover=editData.gapCover;this.state.loyalty=editData.loyalty;this.state.gapLevel=editData.gapCoverLevel;this.state.coPay=editData.paymentCover;this.state.hSaverOption=editData.hSaver;this.state.dToD=editData.dayToDay;this.state.selectedBenefits=targetsGap;this.state.selectedTargetsGap=targetsGap;this.state.startDate=editData.startDate;if(editData.occupation!==data.scd_occupation){delete editData.occupation;delete editData.occupationalQs;}editData=this.deleteClientFields(editData);}this.props.initialize(Object.assign({},editData,defaultInit));if(data.scd_calculatedMonthlyIncomeAT){var calcAt=parseFloat(data.scd_calculatedMonthlyIncomeAT);if(data.scd_actualMonthlyIncomeAT){var acAt=parseFloat(data.scd_actualMonthlyIncomeAT);var value=Math.max(calcAt,acAt);this.setState({mat75:value*0.75,mat100:value});}else{this.setState({mat75:calcAt*0.75,mat100:calcAt});}}var age=__WEBPACK_IMPORTED_MODULE_7_moment___default()().diff(data.scd_dateOfBirth,'years');this.setState({formInitiazed:true,clientAge:age,income:defaultInit.calculatedMonthlyIncomeAT});}},{key:'deleteClientFields',value:function deleteClientFields(editData){delete editData.Admin;delete editData.Travel;delete editData.ManualLabour;delete editData.Supervision;delete editData.spouseIncome;delete editData.title;delete editData.name;delete editData.surname;delete editData.dateOfBirth;delete editData.gender;delete editData.smoker;delete editData.qualification;delete editData.occupation;delete editData.selfEmployed;delete editData.income;delete editData.salaryType;delete editData.maritalStatus;delete editData.TaxDispensation;delete editData.calculatedMonthlyIncomeAT;delete editData.actualMonthlyIncomeAT;delete editData.comission;delete editData.percentageUpfronCommission;delete editData.PAAWCommission;delete editData.language;delete editData.startDate;return editData;}},{key:'checkCommision',value:function checkCommision(){var values=__WEBPACK_IMPORTED_MODULE_15_store__["a" /* default */].getState().form.quotev2.values;if(!values)return true;var total=parseInt(values['percentageUpfronCommission'],10)+parseInt(values['PAAWCommission'],10);if(total!==parseInt(values['comission'],10)){return false;}return true;}},{key:'nextPage',value:function nextPage(){if(this.state.page===0||this.state.page===20){this.pushNextPage();this.forceUpdate();return;}var comErr=this.state.page===1&&!this.checkCommision();var syncErrors=Object.assign({},__WEBPACK_IMPORTED_MODULE_15_store__["a" /* default */].getState().form.quotev2.syncErrors);syncErrors=syncErrors?Object(__WEBPACK_IMPORTED_MODULE_22__objects_syncErrorHelper__["a" /* subFieldsPagesSyncErrors */])(syncErrors,this.state.page):null;if(syncErrors&&Object.keys(syncErrors).length>0||comErr){comErr?this.showDangerSnack('Upfront commission and As-and-when commission do not add up to total commission percentage'):this.showDangerSnack('Invalid Information');this.setState({checkValidation:true});}else{this.pushNextPage();}this.forceUpdate();}},{key:'previousPage',value:function previousPage(){this.setState({checkValidation:false,page:this.state.page-1});}},{key:'showDangerSnack',value:function showDangerSnack(message){__WEBPACK_IMPORTED_MODULE_15_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_12_reducers_NotificationReducer__["d" /* showSnack */])({message:message,color:'danger'}));}},{key:'checkAssistantActive',value:function checkAssistantActive(){return Object(__WEBPACK_IMPORTED_MODULE_6_helpers_UserHelper__["b" /* GetUserKey */])('userType')==='6'?true:false;}},{key:'submit',value:function submit(){var _this3=this;var syncErrors=Object.assign({},__WEBPACK_IMPORTED_MODULE_15_store__["a" /* default */].getState().form.quotev2.syncErrors);syncErrors=syncErrors?Object(__WEBPACK_IMPORTED_MODULE_22__objects_syncErrorHelper__["a" /* subFieldsPagesSyncErrors */])(syncErrors,this.state.page):null;if(syncErrors&&Object.keys(syncErrors).length>0){this.setState({checkValidation:true});__WEBPACK_IMPORTED_MODULE_15_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_12_reducers_NotificationReducer__["d" /* showSnack */])({message:'Invalid Information',color:'danger'}));}else{this.setState({checkValidation:false});var fieldValuesRaw=Object.assign({},__WEBPACK_IMPORTED_MODULE_15_store__["a" /* default */].getState().form.quotev2.values);var pTravel=__WEBPACK_IMPORTED_MODULE_15_store__["a" /* default */].getState().form.quotev2.values.Travel;fieldValuesRaw.drivingHours=Object(__WEBPACK_IMPORTED_MODULE_4_helpers_DrivingHoursConverter__["a" /* calculateDrivingHours */])(pTravel);fieldValuesRaw['medicalSecondOpinion']='Y';var params=Object(__WEBPACK_IMPORTED_MODULE_5_helpers_UriReader__["a" /* ParseUriParams */])(this.props.location.search);var clientId=params.clientId;var input={token:Object(__WEBPACK_IMPORTED_MODULE_6_helpers_UserHelper__["c" /* GetUserToken */])(),userId:this.getBrokerId(),clientId:clientId,benefits:[].concat(_toConsumableArray(this.state.selectedBenefits)),misc_benefits:Object.assign({},this.state.selectedMiscBenefits),assistantId:Object(__WEBPACK_IMPORTED_MODULE_6_helpers_UserHelper__["b" /* GetUserKey */])('userType')==='6'?Object(__WEBPACK_IMPORTED_MODULE_6_helpers_UserHelper__["a" /* GetUserId */])():null,targets:this.state.selectedTargets,data:fieldValuesRaw};this.props.mutate({variables:{input:input}}).then(function(resp){__WEBPACK_IMPORTED_MODULE_15_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_12_reducers_NotificationReducer__["e" /* successWarning */])({open:true,title:'Quote Submitted!'}));__WEBPACK_IMPORTED_MODULE_15_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_13_reducers_TasksReducer__["f" /* openProgress */])());_this3.setState({guid:resp.data.newQuoteMedical.guid});_this3.setState({page:3});}).catch(function(error){__WEBPACK_IMPORTED_MODULE_15_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_12_reducers_NotificationReducer__["d" /* showSnack */])({message:'There was an error submitting your quote : '+error,color:'danger'}));});}return false;}},{key:'handleChangeM',value:function handleChangeM(x,y){//console.log(y)
var z="";z+=y[0];if(y[1])z+=y[1];var n=this.state.medicalAmount;n=z;this.setState({medicalAmount:n});}},{key:'handleChangeDM',value:function handleChangeDM(e,y){var i="";var value="";var endOfId=false;for(var k=0;k<999;k++){if(!e[k])break;if(e[k]==":"){endOfId=true;k++;}if(!endOfId){i+=e[k];}else value+=e[k];}//.log(i)
// console.log(value)
var n=this.state.dependentsAdult;if(value>n[i].prevMeds.length)for(var k=n[i].prevMeds.length;k<value;k++){n[i].prevMeds.push({name:"",startDate:"",endDate:""});}else{for(var k=n[i].prevMeds.length;k>value;k--){n[i].prevMeds.pop();}}this.setState({dependentMedicalAmount:n});}},{key:'makeDownloadLinks',value:function makeDownloadLinks(){var _this4=this;var res=this.state.results;var col=[];col.push(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["S" /* TableCell */],{key:res,style:{paddingRight:'0px'}},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_apollo__["ApolloConsumer"],null,function(client){return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["d" /* Button */],{id:'printButton',variant:'outlined',className:'outlinedButton',style:{color:'#55526f',borderRadius:'50px',marginTop:'10px',marginBottom:'10px'},onClick:function onClick(e){return!_this4.state.loadingPdf?_this4.handlePopoverOpen(e,'downloadEl'):{};}},_this4.state.loadingPdf?__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["j" /* CircularProgress */],{color:'secondary',size:20}):'Print version'),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["J" /* Popover */],{open:_this4.state.popoverOpen,onClose:function onClose(){return _this4.handlePopoverClose();},anchorReference:'anchorPosition',anchorPosition:{left:_this4.state.anchorLeft,top:_this4.state.anchorTop}},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["C" /* List */],{component:'nav'},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["D" /* ListItem */],{button:true,onClick:_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(){var pdfUrls,_ref4,data,errors;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_this4.setState({loadingPdf:true});//var pdfUrls = " Medical_Quote " + new Date().toISOString().replace(".","").replace(/:/g, "_");
//console.log("+++++++++++++++++----------------------" + this.state.guid)
pdfUrls=_this4.state.guid;console.log(_this4.state.guid);_this4.setState({pdfUrl:pdfUrls});_context2.next=6;return client.query({query:getResultPdf,variables:{path:pdfUrls,content:document.getElementById('resultTable').outerHTML.toString().replace(/"/g,"'")}});case 6:_ref4=_context2.sent;data=_ref4.data;errors=_ref4.errors;if(errors){__WEBPACK_IMPORTED_MODULE_15_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_12_reducers_NotificationReducer__["d" /* showSnack */])({message:'Error generating the PDF : '+errors,color:'danger'}));}else{_this4.onPdfGet(data);}_this4.setState({loadingPdf:false});_this4.handlePopoverClose();case 12:case'end':return _context2.stop();}}},_callee2,_this4);}))},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["Z" /* Typography */],{variant:'subheading',style:{marginLeft:'10px',marginRight:'10px'}},'Print Version')),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["p" /* Divider */],null))));})));col.push(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["S" /* TableCell */],{key:'makeDownloadLinksBlank',style:{padding:'0px'}},' '));return col;}},{key:'render',value:function render(){var _this5=this;var page=this.state.page;var params=Object(__WEBPACK_IMPORTED_MODULE_5_helpers_UriReader__["a" /* ParseUriParams */])(this.props.location.search);var clientId=params.clientId,guid=params.guid;return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_apollo__["Query"],{query:__WEBPACK_IMPORTED_MODULE_8_queries_quotes_queries_js__["b" /* ClientQuoteInfoMedical */],variables:{brokerId:this.getBrokerId(),clientId:clientId,guid:guid,token:Object(__WEBPACK_IMPORTED_MODULE_6_helpers_UserHelper__["c" /* GetUserToken */])()},fetchPolicy:'network-only'},function(_ref5){var _Object$assign2;var loading=_ref5.loading,error=_ref5.error,data=_ref5.data;if(loading)return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["B" /* LinearProgress */],null));if(error&&error.message&&error.message==='GraphQL error: invalid token'){Object(__WEBPACK_IMPORTED_MODULE_6_helpers_UserHelper__["d" /* Logout */])();return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_router__["a" /* Redirect */],{to:'/app/portal/login'});}if(error)return'Error! '+error.message;if(!_this5.state.formInitiazed){_this5.initializeForm(data.ClientQuoteInfoMedical);}var clientFullname=data.ClientQuoteInfoMedical.scd_title+' '+data.ClientQuoteInfoMedical.scd_name+' '+data.ClientQuoteInfoMedical.scd_surname;//console.log(data.ClientQuoteInfoMedical.AvailTargetsForBroker)
//Change the targets to Medical aid instead of insurance.
//data.ClientQuoteInfoMedical.AvailTargetsForBroker = MedicalFsp
//console.log(data.ClientQuoteInfoMedical.AvailTargetsForBroker)
return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["v" /* Grid */],{container:true},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:12,style:{margin:'auto'}},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div',{className:'fixedStepper'},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["v" /* Grid */],{container:true},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:10,style:{margin:'auto'}},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div',{className:'stepperDiv'},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["G" /* MobileStepper */],{type:'progress',steps:_this5.state.pageCount,position:'static',activeStep:_this5.state.page,nextButton:__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div',{style:{display:'flex'}},_this5.state.page===_this5.state.pageCount-1?__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["d" /* Button */],{variant:'outlined',className:'outlinedButton',color:'secondary',style:{marginRight:'10px'},onClick:function onClick(){return _this5.submit();}},'Submit'):_this5.state.page<_this5.state.pageCount?__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["d" /* Button */],{variant:'outlined',className:'outlinedButton',color:'secondary',style:{marginRight:'10px'},onClick:function onClick(){return _this5.nextPage();}},'Next'):__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div',null)),backButton:__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["d" /* Button */],{variant:'outlined',className:'outlinedButton',color:'secondary',style:{marginLeft:'10px'},onClick:function onClick(){return _this5.previousPage();},disabled:_this5.state.page===0?true:false},'Back')}))))),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('br',null),page===0&&__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__steps_QuoteDetails_jsx__["a" /* default */],Object.assign({},_this5.props,{targets:_this5.state.selectedTargets,checkValidation:_this5.state.checkValidation,clientFullname:clientFullname,clientAge:_this5.state.clientAge,handleAddDependentChild:_this5.handleAddDependentChild.bind(_this5),handleRemoveDependentChild:_this5.handleRemoveDependentChild.bind(_this5),changechildDob:_this5.changechildDob.bind(_this5),dependentsChild:_this5.state.dependentsChild,handleAddDependentAdult:_this5.handleAddDependentAdult.bind(_this5),handleRemoveDependentAdult:_this5.handleRemoveDependentAdult.bind(_this5),dependentsAdult:_this5.state.dependentsAdult,medicalAmount:_this5.state.medicalAmount,dependentMedicalAmount:_this5.state.dependentMedicalAmount,handleMedicalAmountChange:_this5.handleChangeM.bind(_this5),handleMedicalAmountChangeD:_this5.handleChangeDM.bind(_this5),changeDependentDob:_this5.changeDependentDob.bind(_this5),changeDependentWithoutMed:_this5.changeDependentWithoutMed.bind(_this5),changeWithoutMed:_this5.changeWithoutMed.bind(_this5),changeStartDate:_this5.changeStartDate.bind(_this5),changeHSaverOption:_this5.changeHSaverOption.bind(_this5)})),page===1&&__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__steps_BenefitSelection_jsx__["a" /* default */],Object.assign({},_this5.props,{checkSelectedBenefit:_this5.checkSelectedBenefit,selectedBenefits:_this5.state.selectedBenefits,toggleAllBenefits:_this5.toggleAllBenefits,changeGap:_this5.changeGap.bind(_this5),changeLoyalty:_this5.changeLoyalty.bind(_this5),changeHospitalOnly:_this5.changeHospitalOnly.bind(_this5),changeCoverLevel:_this5.changeCoverLevel.bind(_this5),changePlanType:_this5.changePlanType.bind(_this5),changeHospitalLevel:_this5.changeHospitalLevel.bind(_this5),changeChronicLevel:_this5.changeChronicLevel.bind(_this5),changeServiceLevel:_this5.changeServiceLevel.bind(_this5),changeBrokerFee:_this5.changeBrokerFee.bind(_this5),changeSubsidy:_this5.changeSubsidy.bind(_this5),changeGapLevel:_this5.changeGapLevel.bind(_this5),changeCoPay:_this5.changeCoPay.bind(_this5),changeDToD:_this5.changeDToD.bind(_this5),loyalty:_this5.state.loyalty,gapCover:_this5.state.gapCover,hospitalOnly:_this5.state.hospitalOnly,clientAge:_this5.state.clientAge,doesNotQualifyForIP:data.ClientQuoteInfoMedical.doesNotQualifyForIP,clientFullname:clientFullname,autoPopulatedBenefits:data.ClientQuoteInfoMedical.benefits,benefitsInitialized:_this5.state.benefitsInitialized,state:_this5.state})),page===2&&__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('div',{style:{color:'black'}},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__steps_CompanySelection_jsx__["a" /* default */],Object.assign({},_this5.props,(_Object$assign2={planType:_this5.state.planType,coverLevel:_this5.state.coverLevel,hospitalLevel:_this5.state.hospitalLevel,chronicProvider:_this5.state.chronicProvider,serviceProvider:_this5.state.serviceProvider,checkSelectedTarget:_this5.checkSelectedTarget,checkSelectedTargetGap:_this5.checkSelectedTargetGap,checkSelectedTargetLoyalty:_this5.checkSelectedTargetLoyalty,selectedTargets:_this5.state.selectedTargets,selectedTargetsGap:_this5.state.selectedTargetsGap,selectedTargetsLoyalty:_this5.state.selectedTargetsLoyalty,toggleAllTargets:_this5.toggleAllTargets,toggleAllTargetsGap:_this5.toggleAllTargetsGap,toggleAllTargetsLoyalty:_this5.toggleAllTargetsLoyalty,state:_this5.state,gapCover:_this5.state.gapCover,loyalty:_this5.state.loyalty},_defineProperty(_Object$assign2,'state',_this5.state),_defineProperty(_Object$assign2,'AvailTargetsForBroker',__WEBPACK_IMPORTED_MODULE_23__steps_MedicalFsp_jsx__["a" /* MedicalFsp */]),_defineProperty(_Object$assign2,'AvailTargetsForBrokerGap',__WEBPACK_IMPORTED_MODULE_23__steps_MedicalFsp_jsx__["b" /* MedicalGapFsp */]),_defineProperty(_Object$assign2,'AvailTargetsForBrokerLoyalty',__WEBPACK_IMPORTED_MODULE_23__steps_MedicalFsp_jsx__["c" /* MedicalLoyaltyFsp */]),_defineProperty(_Object$assign2,'clientFullname',clientFullname),_defineProperty(_Object$assign2,'autoPopulatedCompanies',data.ClientQuoteInfoMedical.targets),_Object$assign2)))),page===3&&__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__steps_BenefitMapping__["a" /* default */],Object.assign({},_this5.props,{checkValidation:_this5.state.checkValidation,selectedBenefits:_this5.state.selectedBenefits,selectedTargets:_this5.state.selectedTargets,clientFullname:clientFullname,state:_this5.state,handlePopoverClose:_this5.handlePopoverClose.bind(_this5),handlePopoverOpen:_this5.handlePopoverOpen.bind(_this5),handleResultPdf:_this5.handleResultPdf.bind(_this5),onPdfGet:_this5.onPdfGet.bind(_this5),makeDownloadLinks:_this5.makeDownloadLinks()})))));});}}]);return QuoteWizardMedical;}(__WEBPACK_IMPORTED_MODULE_10_react__["Component"]);QuoteWizardMedical=Object(__WEBPACK_IMPORTED_MODULE_14_redux_form__["e" /* reduxForm */])({form:'quotev2',destroyOnUnmount:true})(QuoteWizardMedical);QuoteWizardMedical=Object(__WEBPACK_IMPORTED_MODULE_2_react_apollo__["graphql"])(__WEBPACK_IMPORTED_MODULE_9_queries_SubmitMedical__["a" /* newQuoteMutationMedical */])(QuoteWizardMedical);/* harmony default export */ __webpack_exports__["a"] = (QuoteWizardMedical);

/***/ }),
/* 2776 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return newQuoteMutationMedical; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_graphql_tag__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_graphql_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_graphql_tag__);
var _templateObject=_taggedTemplateLiteral(['\n\tmutation newQuoteMedical($input: NewQuoteMedicalInput!) {\n\t\tnewQuoteMedical(input: $input) {\n\t\t\tguid\n\t\t}\n\t}\n'],['\n\tmutation newQuoteMedical($input: NewQuoteMedicalInput!) {\n\t\tnewQuoteMedical(input: $input) {\n\t\t\tguid\n\t\t}\n\t}\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var newQuoteMutationMedical=__WEBPACK_IMPORTED_MODULE_0_graphql_tag___default()(_templateObject);

/***/ }),
/* 2777 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__BenefitQuestions_LifeCover_jsx__ = __webpack_require__(2778);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__BenefitQuestions_CriticalIllness_jsx__ = __webpack_require__(2779);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__BenefitQuestions_DisabilityLumpsum_jsx__ = __webpack_require__(2780);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__BenefitQuestions_ExtIncomeProtector_jsx__ = __webpack_require__(2781);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__BenefitQuestions_TempIncomeProtector_jsx__ = __webpack_require__(2782);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__BenefitQuestions_DeathIncomeProtector_jsx__ = __webpack_require__(2783);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_CustomCardHeading_CustomCardHeading_jsx__ = __webpack_require__(56);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var BenefitDetails=function(_React$Component){_inherits(BenefitDetails,_React$Component);function BenefitDetails(){var _ref;var _temp,_this,_ret;_classCallCheck(this,BenefitDetails);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=BenefitDetails.__proto__||Object.getPrototypeOf(BenefitDetails)).call.apply(_ref,[this].concat(args))),_this),_this.state={},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(BenefitDetails,[{key:'componentDidMount',value:function componentDidMount(){this.props.scrollMeBar();}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'contentWithStepper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["e" /* Card */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["f" /* CardContent */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_CustomCardHeading_CustomCardHeading_jsx__["a" /* default */],{subheading:'Quote Generation',caption:this.props.clientFullname,headline:'Benefit Details'}))));}}]);return BenefitDetails;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* unused harmony default export */ var _unused_webpack_default_export = (BenefitDetails);/*

{filteredBenefit.map((benefit, i) => {
							return (
								<ExpansionPanel defaultExpanded={i === 0} key={i}>
									<ExpansionPanelSummary expandIcon={<Icon>expand_more</Icon>}>
										<Typography
											variant="subheading"
											style={{ fontWeight: 'normal' }}
										>
											{benefit.name}
										</Typography>
									</ExpansionPanelSummary>
									<ExpansionPanelDetails>
										{benefit.component(this.props)}
									</ExpansionPanelDetails>
								</ExpansionPanel>
							);
						})}

						*/

/***/ }),
/* 2778 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_Wrappers_materialUIWrappers_components_NumberInput__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_CustomFields_CustomFields_jsx__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__BenifitCompanyValidation__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_store__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_CompanyErrorBlock__ = __webpack_require__(157);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var required=function required(value){return value?undefined:'Required';};var min100k=function min100k(value){if(value===undefined)return undefined;if(parseInt(value,10)<100000.0){return'Must be greater than R100 000';}return undefined;};var LifeCover=function(_React$PureComponent){_inherits(LifeCover,_React$PureComponent);function LifeCover(){var _ref;var _temp,_this,_ret;_classCallCheck(this,LifeCover);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=LifeCover.__proto__||Object.getPrototypeOf(LifeCover)).call.apply(_ref,[this].concat(args))),_this),_this.state={companyCriteria:null},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(LifeCover,[{key:'componentDidMount',value:function componentDidMount(){var premiumPattern=__WEBPACK_IMPORTED_MODULE_5_store__["a" /* default */].getState().form.quotev2.values.premiumPattern;var companyCriteria=Object(__WEBPACK_IMPORTED_MODULE_4__BenifitCompanyValidation__["i" /* getValidationCriteria */])({benefitValidationObj:__WEBPACK_IMPORTED_MODULE_4__BenifitCompanyValidation__["f" /* Life */],targets:this.props.AvailTargetsForBroker,selectedTargets:this.props.selectedTargets,occupation:this.props.occupation,qualification:this.props.qualification,premiumPattern:premiumPattern,age:this.props.clientAge,anualSalary:this.props.clientAnualSalary,toAge:'WholeLife'});this.setState({companyCriteria:companyCriteria});}},{key:'render',value:function render(){var _this2=this;var companyErrors={};if(this.state.companyCriteria){var companyCriteria=Object.assign({},this.state.companyCriteria);var lumpSumCover=Object(__WEBPACK_IMPORTED_MODULE_6_lodash__["get"])(__WEBPACK_IMPORTED_MODULE_5_store__["a" /* default */].getState().form.quotev2,'values.lumpSumCover',0);companyErrors=Object(__WEBPACK_IMPORTED_MODULE_4__BenifitCompanyValidation__["j" /* validateCriteria */])(companyCriteria,{amount:lumpSumCover,age:this.props.clientAge},100000.0);}var benefitValid=Object.keys(companyErrors).length<1;this.props.setBenefitValidity(benefitValid);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["v" /* Grid */],{container:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_CustomFields_CustomFields_jsx__["a" /* FullField */],{name:'lumpSumCover',component:__WEBPACK_IMPORTED_MODULE_2_components_Wrappers_materialUIWrappers_components_NumberInput__["a" /* default */],onChange:function onChange(){return _this2.forceUpdate();},prefix:'R',seperator:' ',checkValidation:this.props.checkValidation,label:'Whole Life Cover Amount *',isrequired:true,validate:[required,min100k]}),!benefitValid?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["v" /* Grid */],{item:true,xs:12,sm:12,md:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_CompanyErrorBlock__["a" /* default */],{companyErrors:companyErrors})):null);}}]);return LifeCover;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);/* unused harmony default export */ var _unused_webpack_default_export = (LifeCover);

/***/ }),
/* 2779 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_CustomFields_CustomFields_jsx__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Wrappers_materialUIWrappers_components_NumberInput__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Wrappers_materialUIWrappers_components_FormDropDown__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_helpers_ValidationHelpers__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__BenifitCompanyValidation__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_CompanyErrorBlock__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_store__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var min100k=function min100k(value){if(value===undefined)return undefined;if(parseInt(value,10)<100000.0){return'Must be greater than R100 000';}return undefined;};var CriticalIllness=function(_React$PureComponent){_inherits(CriticalIllness,_React$PureComponent);function CriticalIllness(){var _ref;var _temp,_this,_ret;_classCallCheck(this,CriticalIllness);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=CriticalIllness.__proto__||Object.getPrototypeOf(CriticalIllness)).call.apply(_ref,[this].concat(args))),_this),_this.state={companyCriteria:null,toAge:null},_this.validateCoverAccelerator=function(value){var accelerator=Object(__WEBPACK_IMPORTED_MODULE_9_lodash__["get"])(__WEBPACK_IMPORTED_MODULE_8_store__["a" /* default */].getState().form.quotev2.values,'standaloneOrAccelerator',null);var lifeCoverAmount=Object(__WEBPACK_IMPORTED_MODULE_9_lodash__["get"])(__WEBPACK_IMPORTED_MODULE_8_store__["a" /* default */].getState().form.quotev2.values,'lumpSumCover',null);if(!value||!_this.props.selectedBenefits.includes(3)){if(accelerator=='2')return"Life cover must be selected to be able to select accelerated benefits.";else return undefined;}if(!accelerator||accelerator!=='2')return undefined;if(!lifeCoverAmount)return undefined;if(parseFloat(value)>parseFloat(lifeCoverAmount)){return'Cannot be more than Whole Life Cover Amount';}return undefined;},_this.setValidationCriteria=function(){var premiumPattern=__WEBPACK_IMPORTED_MODULE_8_store__["a" /* default */].getState().form.quotev2.values.premiumPattern;var toAge=_this.getToAge();var companyCriteria=Object(__WEBPACK_IMPORTED_MODULE_6__BenifitCompanyValidation__["i" /* getValidationCriteria */])({benefitValidationObj:__WEBPACK_IMPORTED_MODULE_6__BenifitCompanyValidation__["b" /* CritIllness */],targets:_this.props.AvailTargetsForBroker,selectedTargets:_this.props.selectedTargets,occupation:_this.props.occupation,qualification:_this.props.qualification,premiumPattern:premiumPattern,age:_this.props.clientAge,anualSalary:_this.props.clientAnualSalary,toAge:toAge});_this.setState({companyCriteria:companyCriteria,toAge:toAge});return companyCriteria;},_this.getToAge=function(){var toAge=Object(__WEBPACK_IMPORTED_MODULE_9_lodash__["get"])(__WEBPACK_IMPORTED_MODULE_8_store__["a" /* default */].getState().form.quotev2.values,'cCeaseAge','validationError');if(toAge==='validationError'||toAge==='75'){toAge='WholeLife';}return toAge;},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(CriticalIllness,[{key:'componentDidMount',value:function componentDidMount(){this.setValidationCriteria();}},{key:'render',value:function render(){var _this2=this;var companyErrors={};if(this.state.companyCriteria){var companyCriteria=Object.assign({},this.state.companyCriteria);if(this.getToAge()!==this.state.toAge){companyCriteria=this.setValidationCriteria();}var lumpSumCover=Object(__WEBPACK_IMPORTED_MODULE_9_lodash__["get"])(__WEBPACK_IMPORTED_MODULE_8_store__["a" /* default */].getState().form.quotev2,'values.coverAmount',0);companyErrors=Object(__WEBPACK_IMPORTED_MODULE_6__BenifitCompanyValidation__["j" /* validateCriteria */])(companyCriteria,{amount:lumpSumCover,age:this.props.clientAge},100000.0);}var benefitValid=Object.keys(companyErrors).length<1;this.props.setBenefitValidity(benefitValid);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["v" /* Grid */],{container:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_CustomFields_CustomFields_jsx__["a" /* FullField */],{name:'standaloneOrAccelerator',label:'Standalone/Accelerator *',component:__WEBPACK_IMPORTED_MODULE_4_components_Wrappers_materialUIWrappers_components_FormDropDown__["a" /* default */],onChange:function onChange(){return _this2.forceUpdate();},checkValidation:this.props.checkValidation,isrequired:true,validate:[__WEBPACK_IMPORTED_MODULE_5_helpers_ValidationHelpers__["h" /* requiredDropdown */]],options:[{value:'validationError',displayValue:'Please select'},{value:'1',displayValue:'Standalone'},{value:'2',displayValue:'Accelerator'}]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_CustomFields_CustomFields_jsx__["a" /* FullField */],{name:'coverAmount',label:'Lumpsum cover *',onChange:function onChange(){return _this2.forceUpdate();},component:__WEBPACK_IMPORTED_MODULE_3_components_Wrappers_materialUIWrappers_components_NumberInput__["a" /* default */],prefix:'R',seperator:' ',checkValidation:this.props.checkValidation,isrequired:true,validate:[__WEBPACK_IMPORTED_MODULE_5_helpers_ValidationHelpers__["g" /* required */],min100k,this.validateCoverAccelerator]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_CustomFields_CustomFields_jsx__["a" /* FullField */],{name:'enhancedOption',label:'Enhanced / Standard *',component:__WEBPACK_IMPORTED_MODULE_4_components_Wrappers_materialUIWrappers_components_FormDropDown__["a" /* default */],checkValidation:this.props.checkValidation,isrequired:true,validate:[__WEBPACK_IMPORTED_MODULE_5_helpers_ValidationHelpers__["h" /* requiredDropdown */]],options:[{value:'validationError',displayValue:'Please select'},{value:'enhanced',displayValue:'Enhanced'},{value:'complete',displayValue:'Standard'}]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_CustomFields_CustomFields_jsx__["a" /* FullField */],{name:'cCeaseAge',label:'Cease age *',component:__WEBPACK_IMPORTED_MODULE_4_components_Wrappers_materialUIWrappers_components_FormDropDown__["a" /* default */],checkValidation:this.props.checkValidation,onChange:function onChange(){return _this2.forceUpdate();},isrequired:true,validate:[__WEBPACK_IMPORTED_MODULE_5_helpers_ValidationHelpers__["h" /* requiredDropdown */]],options:[{value:'validationError',displayValue:'Please select'},{value:'65',displayValue:'65'},{value:'75',displayValue:'Whole life'}]}),!benefitValid?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["v" /* Grid */],{item:true,xs:12,sm:12,md:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_CompanyErrorBlock__["a" /* default */],{companyErrors:companyErrors})):null);}}]);return CriticalIllness;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);/* unused harmony default export */ var _unused_webpack_default_export = (CriticalIllness);

/***/ }),
/* 2780 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_CustomFields_CustomFields_jsx__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Wrappers_materialUIWrappers_components_NumberInput__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Wrappers_materialUIWrappers_components_FormDropDown__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_helpers_ValidationHelpers__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__BenifitCompanyValidation__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_CompanyErrorBlock__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_store__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var min100k=function min100k(value){if(value===undefined)return undefined;if(parseInt(value,10)<100000.0){return'Must be greater than R100 000';}return undefined;};var DisabilityLumpsum=function(_React$PureComponent){_inherits(DisabilityLumpsum,_React$PureComponent);function DisabilityLumpsum(){var _ref;var _temp,_this,_ret;_classCallCheck(this,DisabilityLumpsum);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=DisabilityLumpsum.__proto__||Object.getPrototypeOf(DisabilityLumpsum)).call.apply(_ref,[this].concat(args))),_this),_this.state={companyCriteria:null,toAge:null},_this.validateCoverAccelerator=function(value){var accelerator=Object(__WEBPACK_IMPORTED_MODULE_9_lodash__["get"])(__WEBPACK_IMPORTED_MODULE_8_store__["a" /* default */].getState().form.quotev2.values,'disabilityAccelerator',null);var lifeCoverAmount=Object(__WEBPACK_IMPORTED_MODULE_9_lodash__["get"])(__WEBPACK_IMPORTED_MODULE_8_store__["a" /* default */].getState().form.quotev2.values,'lumpSumCover',null);if(!value||!_this.props.selectedBenefits.includes(3)){if(accelerator=='2')return"Life cover must be selected to be able to select accelerated benefits.";else return undefined;}if(!accelerator||accelerator!=='2')return undefined;if(!lifeCoverAmount)return undefined;if(parseFloat(value)>parseFloat(lifeCoverAmount)){return'Cannot be more than Whole Life Cover Amount';}return undefined;},_this.setValidationCriteria=function(){var premiumPattern=__WEBPACK_IMPORTED_MODULE_8_store__["a" /* default */].getState().form.quotev2.values.premiumPattern;var toAge=_this.getToAge();var disabilityOption=Object(__WEBPACK_IMPORTED_MODULE_9_lodash__["get"])(__WEBPACK_IMPORTED_MODULE_8_store__["a" /* default */].getState().form.quotev2.values,'disabilityOption','validationError');var benefitValidationObj=__WEBPACK_IMPORTED_MODULE_6__BenifitCompanyValidation__["a" /* ComprehensiveDisability */];switch(disabilityOption){case'Occupational':benefitValidationObj=__WEBPACK_IMPORTED_MODULE_6__BenifitCompanyValidation__["g" /* OwnOccupationDis */];break;case'Impairment':benefitValidationObj=__WEBPACK_IMPORTED_MODULE_6__BenifitCompanyValidation__["e" /* Impairment */];break;default:break;}var companyCriteria=Object(__WEBPACK_IMPORTED_MODULE_6__BenifitCompanyValidation__["i" /* getValidationCriteria */])({benefitValidationObj:benefitValidationObj,targets:_this.props.AvailTargetsForBroker,selectedTargets:_this.props.selectedTargets,occupation:_this.props.occupation,qualification:_this.props.qualification,premiumPattern:premiumPattern,age:_this.props.clientAge,anualSalary:_this.props.clientAnualSalary,toAge:toAge});_this.setState({companyCriteria:companyCriteria,toAge:toAge});return companyCriteria;},_this.getToAge=function(){var toAge=Object(__WEBPACK_IMPORTED_MODULE_9_lodash__["get"])(__WEBPACK_IMPORTED_MODULE_8_store__["a" /* default */].getState().form.quotev2.values,'dCeaseAge','validationError');if(toAge==='validationError')toAge='70';return toAge;},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(DisabilityLumpsum,[{key:'componentDidMount',value:function componentDidMount(){this.setValidationCriteria();}},{key:'render',value:function render(){var _this2=this;var disabilityOptions=[{value:'validationError',displayValue:'Please select'},{value:'OccupationalC',displayValue:'Comprehensive Own Occupation'},{value:'Occupational',displayValue:'Own Occupation'},{value:'OccupationalOC',displayValue:'Comprehensive  Own/ Similar Occupation'},{value:'OccupationalO',displayValue:'Own/ Similar Occupation'},{value:'Impairment',displayValue:'Impairment'}];if(this.props.disOnlyImpairment){disabilityOptions=disabilityOptions.filter(function(o){return o.value==='Impairment'||o.value==='validationError';});}var companyErrors={};if(this.state.companyCriteria){var companyCriteria=Object.assign({},this.state.companyCriteria);if(this.getToAge()!==this.state.toAge){companyCriteria=this.setValidationCriteria();}var lumpSumCover=Object(__WEBPACK_IMPORTED_MODULE_9_lodash__["get"])(__WEBPACK_IMPORTED_MODULE_8_store__["a" /* default */].getState().form.quotev2,'values.disabilityLumpsumCover',0);companyErrors=Object(__WEBPACK_IMPORTED_MODULE_6__BenifitCompanyValidation__["j" /* validateCriteria */])(companyCriteria,{amount:lumpSumCover,age:this.props.clientAge},100000.0);}var benefitValid=Object.keys(companyErrors).length<1;this.props.setBenefitValidity(benefitValid);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["v" /* Grid */],{container:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_CustomFields_CustomFields_jsx__["a" /* FullField */],{name:'disabilityLumpsumCover',label:'Lumpsum cover *',component:__WEBPACK_IMPORTED_MODULE_3_components_Wrappers_materialUIWrappers_components_NumberInput__["a" /* default */],onChange:function onChange(){return _this2.forceUpdate();},prefix:'R',seperator:' ',checkValidation:this.props.checkValidation,isrequired:true,validate:[__WEBPACK_IMPORTED_MODULE_5_helpers_ValidationHelpers__["g" /* required */],min100k,this.validateCoverAccelerator]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_CustomFields_CustomFields_jsx__["a" /* FullField */],{name:'disabilityAccelerator',label:'Standalone or Accelerated *',component:__WEBPACK_IMPORTED_MODULE_4_components_Wrappers_materialUIWrappers_components_FormDropDown__["a" /* default */],onChange:function onChange(){return _this2.forceUpdate();},checkValidation:this.props.checkValidation,isrequired:true,validate:[__WEBPACK_IMPORTED_MODULE_5_helpers_ValidationHelpers__["h" /* requiredDropdown */]],options:[{value:'validationError',displayValue:'Please select'},{value:'1',displayValue:'Standalone'},{value:'2',displayValue:'Accelerator'}]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_CustomFields_CustomFields_jsx__["a" /* FullField */],{name:'disabilityTapering',label:'Tapering/Non Tapering *',component:__WEBPACK_IMPORTED_MODULE_4_components_Wrappers_materialUIWrappers_components_FormDropDown__["a" /* default */],checkValidation:this.props.checkValidation,isrequired:true,validate:[__WEBPACK_IMPORTED_MODULE_5_helpers_ValidationHelpers__["h" /* requiredDropdown */]],options:[{value:'validationError',displayValue:'Please select'},{value:'Y',displayValue:'Tapering'},{value:'N',displayValue:'Non Tapering'}]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_CustomFields_CustomFields_jsx__["a" /* FullField */],{name:'dCeaseAge',label:'Cease age *',component:__WEBPACK_IMPORTED_MODULE_4_components_Wrappers_materialUIWrappers_components_FormDropDown__["a" /* default */],onChange:function onChange(){return _this2.forceUpdate();},checkValidation:this.props.checkValidation,isrequired:true,validate:[__WEBPACK_IMPORTED_MODULE_5_helpers_ValidationHelpers__["h" /* requiredDropdown */]],options:[{value:'validationError',displayValue:'Please select'},{value:'65',displayValue:'65'},{value:'70',displayValue:'70'}]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_CustomFields_CustomFields_jsx__["a" /* FullField */],{name:'disabilityOption',label:'Disability option *',component:__WEBPACK_IMPORTED_MODULE_4_components_Wrappers_materialUIWrappers_components_FormDropDown__["a" /* default */],onChange:function onChange(){return _this2.forceUpdate();},checkValidation:this.props.checkValidation,isrequired:true,validate:[__WEBPACK_IMPORTED_MODULE_5_helpers_ValidationHelpers__["h" /* requiredDropdown */]],options:disabilityOptions}),!benefitValid?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["v" /* Grid */],{item:true,xs:12,sm:12,md:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_CompanyErrorBlock__["a" /* default */],{companyErrors:companyErrors})):null);}}]);return DisabilityLumpsum;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);/* unused harmony default export */ var _unused_webpack_default_export = (DisabilityLumpsum);

/***/ }),
/* 2781 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_CustomFields_CustomFields_jsx__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Wrappers_materialUIWrappers_components_NumberInput__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Wrappers_materialUIWrappers_components_FormDropDown__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_helpers_ValidationHelpers__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_store__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__BenifitCompanyValidation__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_CompanyErrorBlock__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var min2k=function min2k(value){if(value===undefined)return undefined;if(parseInt(value,10)<2000.0){return'Must be greater than R2 000';}return undefined;};var ExtIncomeProtector=function(_React$PureComponent){_inherits(ExtIncomeProtector,_React$PureComponent);function ExtIncomeProtector(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ExtIncomeProtector);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ExtIncomeProtector.__proto__||Object.getPrototypeOf(ExtIncomeProtector)).call.apply(_ref,[this].concat(args))),_this),_this.state={companyCriteria:null,toAge:null},_this.setValidationCriteria=function(){var premiumPattern=__WEBPACK_IMPORTED_MODULE_6_store__["a" /* default */].getState().form.quotev2.values.premiumPattern;var toAge=_this.getToAge();var companyCriteria=Object(__WEBPACK_IMPORTED_MODULE_7__BenifitCompanyValidation__["i" /* getValidationCriteria */])({benefitValidationObj:__WEBPACK_IMPORTED_MODULE_7__BenifitCompanyValidation__["d" /* ExtendedIncomeProtector */],targets:_this.props.AvailTargetsForBroker,selectedTargets:_this.props.selectedTargets,occupation:_this.props.occupation,qualification:_this.props.qualification,premiumPattern:premiumPattern,age:_this.props.clientAge,anualSalary:_this.props.clientAnualSalary,toAge:toAge});_this.setState({companyCriteria:companyCriteria,toAge:toAge});return companyCriteria;},_this.getToAge=function(){var toAge=Object(__WEBPACK_IMPORTED_MODULE_9_lodash__["get"])(__WEBPACK_IMPORTED_MODULE_6_store__["a" /* default */].getState().form.quotev2.values,'iExCeaseAge','validationError');if(toAge==='validationError')toAge='70';return toAge;},_this.mat75Validate=function(value){if(_this.props.mat75&&_this.props.mat75>0){if(parseFloat(value)>_this.props.mat75){return'Higher than max available';}}if(value===undefined)return undefined;return isNaN(Number(value))?'Must be a number':undefined;},_this.exCeaseAgeValidate=function(value){if(value===undefined)return undefined;var theValue=value;if(_this.props.selectedBenefits.includes(56)){var tempCeaseAge=__WEBPACK_IMPORTED_MODULE_6_store__["a" /* default */].getState().form.quotev2.values.iTempCeaseAge;if(!tempCeaseAge)return undefined;if(theValue!==tempCeaseAge)return'Cease age for Income Protector Benefits must be the same';}return undefined;},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ExtIncomeProtector,[{key:'componentDidMount',value:function componentDidMount(){this.setValidationCriteria();}},{key:'render',value:function render(){var _this2=this;var companyErrors={};if(this.state.companyCriteria){var companyCriteria=Object.assign({},this.state.companyCriteria);if(this.getToAge()!==this.state.toAge){companyCriteria=this.setValidationCriteria();}var coverAmount=Object(__WEBPACK_IMPORTED_MODULE_9_lodash__["get"])(__WEBPACK_IMPORTED_MODULE_6_store__["a" /* default */].getState().form.quotev2,'values.incomeExMonthlyCover',0);companyErrors=Object(__WEBPACK_IMPORTED_MODULE_7__BenifitCompanyValidation__["j" /* validateCriteria */])(companyCriteria,{amount:coverAmount,age:this.props.clientAge},2000.0,this.props.mat75);}var benefitValid=Object.keys(companyErrors).length<1;this.props.setBenefitValidity(benefitValid);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["v" /* Grid */],{container:true},this.props.mat75&&this.props.mat75>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["v" /* Grid */],{item:true,xs:12,sm:12,md:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Max available: R',parseFloat(this.props.mat75).toFixed(2))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_CustomFields_CustomFields_jsx__["a" /* FullField */],{name:'incomeExMonthlyCover',label:'Monthly Cover *',component:__WEBPACK_IMPORTED_MODULE_3_components_Wrappers_materialUIWrappers_components_NumberInput__["a" /* default */],onChange:function onChange(){return _this2.forceUpdate();},prefix:'R',seperator:' ',checkValidation:this.props.checkValidation,isrequired:true,validate:[__WEBPACK_IMPORTED_MODULE_5_helpers_ValidationHelpers__["g" /* required */],this.mat75Validate,min2k]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_CustomFields_CustomFields_jsx__["a" /* FullField */],{name:'iExCeaseAge',label:'Cease age *',component:__WEBPACK_IMPORTED_MODULE_4_components_Wrappers_materialUIWrappers_components_FormDropDown__["a" /* default */],onChange:function onChange(){return _this2.forceUpdate();},checkValidation:this.props.checkValidation,isrequired:true,validate:[__WEBPACK_IMPORTED_MODULE_5_helpers_ValidationHelpers__["h" /* requiredDropdown */],this.exCeaseAgeValidate],options:[{value:'validationError',displayValue:'Please select'},{value:'60',displayValue:'60'},{value:'65',displayValue:'65'},{value:'70',displayValue:'70'}]}),!benefitValid?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["v" /* Grid */],{item:true,xs:12,sm:12,md:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_CompanyErrorBlock__["a" /* default */],{companyErrors:companyErrors})):null);}}]);return ExtIncomeProtector;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);/* unused harmony default export */ var _unused_webpack_default_export = (ExtIncomeProtector);

/***/ }),
/* 2782 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_CustomFields_CustomFields_jsx__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Wrappers_materialUIWrappers_components_NumberInput__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Wrappers_materialUIWrappers_components_FormDropDown__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_helpers_ValidationHelpers__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_store__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__BenifitCompanyValidation__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_CompanyErrorBlock__ = __webpack_require__(157);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var min2k=function min2k(value){if(value===undefined)return undefined;if(parseInt(value,10)<2000.0){return'Must be greater than R2 000';}return undefined;};var sevenDayValidate=function sevenDayValidate(companyErrors,targets,selectedTargets,selfEmployed,qualification){var selfEmplProfTargets=[1,3];var message='Does not support 7 days waiting\n\tperiod for self-employed persons without professional\n\tqualifications';var _iteratorNormalCompletion=true;var _didIteratorError=false;var _iteratorError=undefined;try{for(var _iterator=targets[Symbol.iterator](),_step;!(_iteratorNormalCompletion=(_step=_iterator.next()).done);_iteratorNormalCompletion=true){var target=_step.value;if(selectedTargets.includes(parseInt(target.id))&&selfEmplProfTargets.includes(target.id)&&selfEmployed==='Y'&&qualification!=='4-yearDegreeOrProfessional'){companyErrors[target.name]=Object.assign({},companyErrors[target.name],{messages:companyErrors[target.name]?[].concat(_toConsumableArray(companyErrors[target.name].messages),[message]):[message]});}}}catch(err){_didIteratorError=true;_iteratorError=err;}finally{try{if(!_iteratorNormalCompletion&&_iterator.return){_iterator.return();}}finally{if(_didIteratorError){throw _iteratorError;}}}return companyErrors;};var TempIncomeProtector=function(_React$PureComponent){_inherits(TempIncomeProtector,_React$PureComponent);function TempIncomeProtector(){var _ref;var _temp,_this,_ret;_classCallCheck(this,TempIncomeProtector);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=TempIncomeProtector.__proto__||Object.getPrototypeOf(TempIncomeProtector)).call.apply(_ref,[this].concat(args))),_this),_this.state={companyCriteria:null,toAge:null},_this.setValidationCriteria=function(){var premiumPattern=__WEBPACK_IMPORTED_MODULE_6_store__["a" /* default */].getState().form.quotev2.values.premiumPattern;var toAge=_this.getToAge();var companyCriteria=Object(__WEBPACK_IMPORTED_MODULE_8__BenifitCompanyValidation__["i" /* getValidationCriteria */])({benefitValidationObj:__WEBPACK_IMPORTED_MODULE_8__BenifitCompanyValidation__["h" /* TemporaryIncomeProtector */],targets:_this.props.AvailTargetsForBroker,selectedTargets:_this.props.selectedTargets,occupation:_this.props.occupation,qualification:_this.props.qualification,premiumPattern:premiumPattern,age:_this.props.clientAge,anualSalary:_this.props.clientAnualSalary,toAge:toAge});_this.setState({companyCriteria:companyCriteria,toAge:toAge});return companyCriteria;},_this.getToAge=function(){var toAge=Object(__WEBPACK_IMPORTED_MODULE_7_lodash__["get"])(__WEBPACK_IMPORTED_MODULE_6_store__["a" /* default */].getState().form.quotev2.values,'iTempCeaseAge','validationError');if(toAge==='validationError')toAge='70';return toAge;},_this.mat100Validate=function(value){if(_this.props.mat100&&_this.props.mat100>0){if(parseFloat(value)>_this.props.mat100){return'Higher than max available';}}if(value===undefined)return undefined;return isNaN(Number(value))?'Must be a number':undefined;},_this.tempCeaseAgeValidate=function(value){if(value===undefined)return undefined;var theValue=value;if(_this.props.selectedBenefits.includes(57)){var exCeaseAge=__WEBPACK_IMPORTED_MODULE_6_store__["a" /* default */].getState().form.quotev2.values.iExCeaseAge;if(!exCeaseAge)return undefined;if(theValue!==exCeaseAge)return'Cease age for Income Protector Benefits must be the same';}return undefined;},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(TempIncomeProtector,[{key:'componentDidMount',value:function componentDidMount(){this.setValidationCriteria();}},{key:'render',value:function render(){var _this2=this;var companyErrors={};if(this.state.companyCriteria){var companyCriteria=Object.assign({},this.state.companyCriteria);if(this.getToAge()!==this.state.toAge){companyCriteria=this.setValidationCriteria();}var coverAmount=Object(__WEBPACK_IMPORTED_MODULE_7_lodash__["get"])(__WEBPACK_IMPORTED_MODULE_6_store__["a" /* default */].getState().form.quotev2,'values.incomeTempMonthlyCover',0);companyErrors=Object(__WEBPACK_IMPORTED_MODULE_8__BenifitCompanyValidation__["j" /* validateCriteria */])(companyCriteria,{amount:coverAmount,age:this.props.clientAge},2000.0,this.props.mat100);var selfEmployed=Object(__WEBPACK_IMPORTED_MODULE_7_lodash__["get"])(__WEBPACK_IMPORTED_MODULE_6_store__["a" /* default */].getState().form.quotev2,'values.selfEmployed','');var incomeTempWaitingPeriod=Object(__WEBPACK_IMPORTED_MODULE_7_lodash__["get"])(__WEBPACK_IMPORTED_MODULE_6_store__["a" /* default */].getState().form.quotev2,'values.incomeTempWaitingPeriod','');if(incomeTempWaitingPeriod==='7'){companyErrors=sevenDayValidate(companyErrors,this.props.AvailTargetsForBroker,this.props.selectedTargets,selfEmployed,this.props.qualification);}}var benefitValid=Object.keys(companyErrors).length<1;this.props.setBenefitValidity(benefitValid);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["v" /* Grid */],{container:true},this.props.mat100&&this.props.mat100>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["v" /* Grid */],{item:true,xs:12,sm:12,md:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Max available: R',parseFloat(this.props.mat100).toFixed(2))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_CustomFields_CustomFields_jsx__["a" /* FullField */],{name:'incomeTempMonthlyCover',label:'Monthly Cover *',component:__WEBPACK_IMPORTED_MODULE_3_components_Wrappers_materialUIWrappers_components_NumberInput__["a" /* default */],onChange:function onChange(){return _this2.forceUpdate();},prefix:'R',seperator:' ',checkValidation:this.props.checkValidation,isrequired:true,validate:[__WEBPACK_IMPORTED_MODULE_5_helpers_ValidationHelpers__["g" /* required */],this.mat100Validate,min2k]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_CustomFields_CustomFields_jsx__["a" /* FullField */],{name:'incomeTempWaitingPeriod',label:'Waiting Period *',component:__WEBPACK_IMPORTED_MODULE_4_components_Wrappers_materialUIWrappers_components_FormDropDown__["a" /* default */],onChange:function onChange(){return _this2.forceUpdate();},checkValidation:this.props.checkValidation,isrequired:true,validate:[__WEBPACK_IMPORTED_MODULE_5_helpers_ValidationHelpers__["h" /* requiredDropdown */]],options:[{value:'validationError',displayValue:'Please select'},{value:'7',displayValue:'7 days'},{value:'30',displayValue:'1 month / 30 days'},{value:'90',displayValue:'3 months'}]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_CustomFields_CustomFields_jsx__["a" /* FullField */],{name:'iTempCeaseAge',label:'Cease age *',component:__WEBPACK_IMPORTED_MODULE_4_components_Wrappers_materialUIWrappers_components_FormDropDown__["a" /* default */],onChange:function onChange(){return _this2.forceUpdate();},checkValidation:this.props.checkValidation,isrequired:true,validate:[__WEBPACK_IMPORTED_MODULE_5_helpers_ValidationHelpers__["h" /* requiredDropdown */],this.tempCeaseAgeValidate],options:[{value:'validationError',displayValue:'Please select'},{value:'60',displayValue:'60'},{value:'65',displayValue:'65'},{value:'70',displayValue:'70'}]}),!benefitValid?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["v" /* Grid */],{item:true,xs:12,sm:12,md:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_CompanyErrorBlock__["a" /* default */],{companyErrors:companyErrors})):null);}}]);return TempIncomeProtector;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);/* unused harmony default export */ var _unused_webpack_default_export = (TempIncomeProtector);

/***/ }),
/* 2783 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_CustomFields_CustomFields_jsx__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Wrappers_materialUIWrappers_components_NumberInput__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Wrappers_materialUIWrappers_components_FormDropDown__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_helpers_ValidationHelpers__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_store__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__BenifitCompanyValidation__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_CompanyErrorBlock__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var min2k=function min2k(value){if(value===undefined)return undefined;if(parseInt(value,10)<2000.0){return'Must be greater than R2 000';}return undefined;};var DeathIncomeProtector=function(_React$PureComponent){_inherits(DeathIncomeProtector,_React$PureComponent);function DeathIncomeProtector(){var _ref;var _temp,_this,_ret;_classCallCheck(this,DeathIncomeProtector);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=DeathIncomeProtector.__proto__||Object.getPrototypeOf(DeathIncomeProtector)).call.apply(_ref,[this].concat(args))),_this),_this.state={companyCriteria:null,toAge:null},_this.setValidationCriteria=function(){var premiumPattern=__WEBPACK_IMPORTED_MODULE_6_store__["a" /* default */].getState().form.quotev2.values.premiumPattern;var toAge=_this.getToAge();var companyCriteria=Object(__WEBPACK_IMPORTED_MODULE_7__BenifitCompanyValidation__["i" /* getValidationCriteria */])({benefitValidationObj:__WEBPACK_IMPORTED_MODULE_7__BenifitCompanyValidation__["c" /* DIncomeProtector */],targets:_this.props.AvailTargetsForBroker,selectedTargets:_this.props.selectedTargets,occupation:_this.props.occupation,qualification:_this.props.qualification,premiumPattern:premiumPattern,age:_this.props.clientAge,anualSalary:_this.props.clientAnualSalary,toAge:toAge});_this.setState({companyCriteria:companyCriteria,toAge:toAge});return companyCriteria;},_this.getToAge=function(){var toAge=Object(__WEBPACK_IMPORTED_MODULE_9_lodash__["get"])(__WEBPACK_IMPORTED_MODULE_6_store__["a" /* default */].getState().form.quotev2.values,'DeathCeaseAge','validationError');if(toAge==='validationError')toAge='70';return toAge;},_this.mat75Validate=function(value){if(_this.props.mat75&&_this.props.mat100>0){if(parseFloat(value)>_this.props.mat100){return'Higher than max available';}}if(value===undefined)return undefined;return isNaN(Number(value))?'Must be a number':undefined;},_this.deathCeaseAgeValidate=function(value){if(value===undefined)return undefined;var theValue=value;return undefined;},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(DeathIncomeProtector,[{key:'componentDidMount',value:function componentDidMount(){this.setValidationCriteria();}},{key:'render',value:function render(){var _this2=this;var companyErrors={};if(this.state.companyCriteria){var companyCriteria=Object.assign({},this.state.companyCriteria);if(this.getToAge()!==this.state.toAge){companyCriteria=this.setValidationCriteria();}var coverAmount=Object(__WEBPACK_IMPORTED_MODULE_9_lodash__["get"])(__WEBPACK_IMPORTED_MODULE_6_store__["a" /* default */].getState().form.quotev2,'values.deathIncomeCover',0);companyErrors=Object(__WEBPACK_IMPORTED_MODULE_7__BenifitCompanyValidation__["j" /* validateCriteria */])(companyCriteria,{amount:coverAmount,age:this.props.clientAge},2000.0,this.props.mat100);}var benefitValid=Object.keys(companyErrors).length<1;this.props.setBenefitValidity(benefitValid);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["v" /* Grid */],{container:true},this.props.mat100&&this.props.mat100>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["v" /* Grid */],{item:true,xs:12,sm:12,md:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Max available: R',parseFloat(this.props.mat100).toFixed(2))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_CustomFields_CustomFields_jsx__["a" /* FullField */],{name:'deathIncomeCover',label:'Monthly Cover *',component:__WEBPACK_IMPORTED_MODULE_3_components_Wrappers_materialUIWrappers_components_NumberInput__["a" /* default */],onChange:function onChange(){return _this2.forceUpdate();},prefix:'R',seperator:' ',checkValidation:this.props.checkValidation,isrequired:true,validate:[__WEBPACK_IMPORTED_MODULE_5_helpers_ValidationHelpers__["g" /* required */],this.mat75Validate,min2k]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_CustomFields_CustomFields_jsx__["a" /* FullField */],{name:'deathIncomeCeaseAge',label:'Cease age *',component:__WEBPACK_IMPORTED_MODULE_4_components_Wrappers_materialUIWrappers_components_FormDropDown__["a" /* default */],onChange:function onChange(){return _this2.forceUpdate();},checkValidation:this.props.checkValidation,isrequired:true,validate:[__WEBPACK_IMPORTED_MODULE_5_helpers_ValidationHelpers__["h" /* requiredDropdown */]],options:[{value:'validationError',displayValue:'Please select'},{value:'60',displayValue:'60'},{value:'65',displayValue:'65'},{value:'70',displayValue:'70'}]}),!benefitValid?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["v" /* Grid */],{item:true,xs:12,sm:12,md:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_CompanyErrorBlock__["a" /* default */],{companyErrors:companyErrors})):null);}}]);return DeathIncomeProtector;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);/* unused harmony default export */ var _unused_webpack_default_export = (DeathIncomeProtector);

/***/ }),
/* 2784 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_core__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_CustomCardHeading_CustomCardHeading_jsx__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_CustomCardHeading_CustomCardSubHeading_jsx__ = __webpack_require__(739);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Grid_GridItem_jsx__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Wrappers_materialUIWrappers_components_FormDropDown__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_Wrappers_materialUIWrappers_components_FormInput__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_Wrappers_materialUIWrappers_components_NumberInput__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_helpers_ValidationHelpers__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_redux_form__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_date_fns__ = __webpack_require__(418);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_date_fns___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_date_fns__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_CustomChip_CustomChipLeft_jsx__ = __webpack_require__(740);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_CustomChip_CustomChipLeftReversed__ = __webpack_require__(741);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var required=function required(value){return value?undefined:'Required';};var CustomField=function CustomField(props){return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:6,style:{marginBottom:'25px'}},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["t" /* FormControl */],{fullWidth:true},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_redux_form__["a" /* Field */],props)));};var BenefitSelection=function(_React$Component){_inherits(BenefitSelection,_React$Component);function BenefitSelection(){var _ref;var _temp,_this,_ret;_classCallCheck(this,BenefitSelection);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=BenefitSelection.__proto__||Object.getPrototypeOf(BenefitSelection)).call.apply(_ref,[this].concat(args))),_this),_this.state={},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(BenefitSelection,[{key:'componentDidMount',value:function componentDidMount(){this.props.scrollMeBar();/*let { benefits } = this.state;
		benefits.map(benefit => {
			if (this.props.clientAge) {
				if (this.props.clientAge > benefit.maxAge) {
					benefit.disabled = true;
					benefit.messages.push(
						'Client is too old to qualify for this benefit'
					);
				}
				if (this.props.clientAge < benefit.minAge) {
					benefit.disabled = true;
					benefit.messages.push(
						'Client is too young to qualify for this benefit'
					);
				}
			}
			return benefit;
		});

		if (!this.props.benefitsInitialized && this.props.autoPopulatedBenefits) {
			let editBenefits = this.props.autoPopulatedBenefits
				.split(',')
				.map(t => parseInt(t, 10));
			let autoPopBenefits = [];

			benefits.map(ben => {
				if (editBenefits.includes(ben.id)) {
					autoPopBenefits.push(ben.id);
				}
				return ben;
			});

			this.props.setBenefitsInitialized(autoPopBenefits);
		}

		this.setState({ benefits: benefits });*/}/*
	handleCheck = id => {
		if (this.props.selectedBenefits.find(t => t === id)) {
			this.props.checkSelectedBenefit(id, false);
		} else {
			this.props.checkSelectedBenefit(id, true);
		}
		this.forceUpdate();
	};

	enabledBenefits() {
		const { benefits } = this.state;
		return benefits.filter(benefit => !benefit.disabled);
	}

	checkAll = () => {
		if (this.props.selectedBenefits.length !== this.enabledBenefits().length) {
			this.props.toggleAllBenefits(this.enabledBenefits(), true);
		} else {
			this.props.toggleAllBenefits(this.enabledBenefits(), false);
		}
		this.forceUpdate();
	};
*/},{key:'render',value:function render(){var _this2=this;/*const allSelected =
			this.props.selectedBenefits.length === this.enabledBenefits().length;*/var gapCoverOptions=[];if(this.props.gapCover==1){gapCoverOptions=__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{container:true},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(CustomField,{name:'gapCoverLevel',component:__WEBPACK_IMPORTED_MODULE_4_components_Wrappers_materialUIWrappers_components_FormDropDown__["a" /* default */],checkValidation:this.props.checkValidation,label:'Level of Gap Cover',isrequired:true,onChange:function onChange(e){return _this2.props.changeGapLevel(e);}//validate={[required]}
,options:[{value:" ",displayValue:'Please select'},{value:'1',displayValue:'200% - 300%'},{value:'2',displayValue:'301% - 500%'},{value:'3',displayValue:'500% +'}]}),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(CustomField,{name:'paymentCover',component:__WEBPACK_IMPORTED_MODULE_4_components_Wrappers_materialUIWrappers_components_FormDropDown__["a" /* default */],checkValidation:this.props.checkValidation,label:'Gap + Co-Payment Cover',onChange:function onChange(e){return _this2.props.changeCoPay(e);},isrequired:true//validate={[required]}
,options:[{value:" ",displayValue:'Please select'},{value:'1',displayValue:'Yes'},{value:'0',displayValue:'No'}]}));}return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('div',{className:'contentWithStepper'},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["e" /* Card */],{className:this.classes},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["f" /* CardContent */],null,__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_CustomCardHeading_CustomCardHeading_jsx__["a" /* default */],{subheading:'Quote Generation',caption:this.props.clientFullname,headline:'Cover Selection'}),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{container:true},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:12,style:{marginBottom:'25px'}}),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(CustomField,{name:'planType',component:__WEBPACK_IMPORTED_MODULE_4_components_Wrappers_materialUIWrappers_components_FormDropDown__["a" /* default */],checkValidation:this.props.checkValidation,label:'Plan Type',isrequired:true,onChange:function onChange(e){return _this2.props.changePlanType(e);},validate:[required],options:[{value:" ",displayValue:'Please select'},{value:'capitation',displayValue:'Capitation'},{value:'hospital plan',displayValue:'Hospital plan'},{value:'hybrid',displayValue:'Hybrid'},{value:'new generation',displayValue:'New generation'},{value:'threshold',displayValue:'Threshold'},{value:'traditional',displayValue:'Traditional'},{value:'all',displayValue:'All'}]}),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(CustomField,{name:'coverType',component:__WEBPACK_IMPORTED_MODULE_4_components_Wrappers_materialUIWrappers_components_FormDropDown__["a" /* default */],checkValidation:this.props.checkValidation,label:'Cover Type',isrequired:true,onChange:function onChange(e){return _this2.props.changeCoverLevel(e);},validate:[required],options:[{value:" ",displayValue:'Please select'},{value:'high',displayValue:'High'},{value:'medium',displayValue:'Medium'},{value:'low',displayValue:'Low'},{value:'all',displayValue:'All'}]}),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(CustomField,{name:'hospitalType',component:__WEBPACK_IMPORTED_MODULE_4_components_Wrappers_materialUIWrappers_components_FormDropDown__["a" /* default */],checkValidation:this.props.checkValidation,label:'Hospital preference',isrequired:true,onChange:function onChange(e){return _this2.props.changeHospitalLevel(e);},validate:[required],options:[{value:" ",displayValue:'Please select'},{value:'state',displayValue:'State'},{value:'network',displayValue:'Network'},{value:'any',displayValue:'Any'},{value:'all',displayValue:'All'}]}),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(CustomField,{name:'serviceType',component:__WEBPACK_IMPORTED_MODULE_4_components_Wrappers_materialUIWrappers_components_FormDropDown__["a" /* default */],checkValidation:this.props.checkValidation,label:'Service provider (daty to day)',isrequired:true,onChange:function onChange(e){return _this2.props.changeServiceLevel(e);},validate:[required],options:[{value:" ",displayValue:'Please select'},{value:'network',displayValue:'Network'},{value:'any',displayValue:'Any'},{value:'all',displayValue:'All'}]}),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(CustomField,{name:'chronicType',component:__WEBPACK_IMPORTED_MODULE_4_components_Wrappers_materialUIWrappers_components_FormDropDown__["a" /* default */],checkValidation:this.props.checkValidation,label:'Chronic provider',isrequired:true,onChange:function onChange(e){return _this2.props.changeChronicLevel(e);},validate:[required],options:[{value:" ",displayValue:'Please select'},{value:'state',displayValue:'State'},{value:'network',displayValue:'Network'},{value:'any',displayValue:'Any'},{value:'all',displayValue:'All'}]}),this.props.state.hSaverOption==1&&__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(CustomField,{name:'dayToDay',component:__WEBPACK_IMPORTED_MODULE_6_components_Wrappers_materialUIWrappers_components_NumberInput__["a" /* default */],checkValidation:this.props.checkValidation,label:'How much cover per annum needed for day to day?',isrequired:true,onChange:function onChange(e){return _this2.props.changeDToD(e);},validate:[required]}),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(CustomField,{name:'brokerFee',component:__WEBPACK_IMPORTED_MODULE_6_components_Wrappers_materialUIWrappers_components_NumberInput__["a" /* default */],checkValidation:this.props.checkValidation,label:'Broker fee',isrequired:true,onChange:function onChange(e){return _this2.props.changeBrokerFee(e);},validate:[required],prefix:'R',initialValues:123}),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(CustomField,{name:'subsidy',component:__WEBPACK_IMPORTED_MODULE_6_components_Wrappers_materialUIWrappers_components_NumberInput__["a" /* default */],checkValidation:this.props.checkValidation,label:'Monthly Subsidy',isrequired:true,onChange:function onChange(e){return _this2.props.changeSubsidy(e);},validate:[required],prefix:'R'})))),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["e" /* Card */],{style:{marginTop:'25px'}},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["q" /* ExpansionPanel */],{defaultExpanded:false},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["s" /* ExpansionPanelSummary */],{expandIcon:__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["w" /* Icon */],null,'expand_more')},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{variant:'subheading',style:{fontWeight:'normal'}},'Gap Cover')),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["r" /* ExpansionPanelDetails */],null,__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{container:true},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:12,style:{marginTop:'25px'}},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(CustomField,{name:'gapCover',component:__WEBPACK_IMPORTED_MODULE_4_components_Wrappers_materialUIWrappers_components_FormDropDown__["a" /* default */],checkValidation:this.props.checkValidation,label:'Include Gap cover',isrequired:true//validate={[required]}
,onChange:function onChange(e){return _this2.props.changeGap(e[0]);},options:[{value:" ",displayValue:'Please select'},{value:'1',displayValue:'Yes'},{value:'0',displayValue:'No'}]})),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:12,style:{marginTop:'25px'}},gapCoverOptions))))),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["e" /* Card */],{style:{marginTop:'25px'}},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["q" /* ExpansionPanel */],{defaultExpanded:false},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["s" /* ExpansionPanelSummary */],{expandIcon:__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["w" /* Icon */],null,'expand_more')},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{variant:'subheading',style:{fontWeight:'normal'}},'Loyalty Program')),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["r" /* ExpansionPanelDetails */],null,__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(CustomField,{name:'loyalty',component:__WEBPACK_IMPORTED_MODULE_4_components_Wrappers_materialUIWrappers_components_FormDropDown__["a" /* default */],checkValidation:this.props.checkValidation,label:'Add Loyalty Program',isrequired:true,onChange:function onChange(e){return _this2.props.changeLoyalty(e[0]);}//validate={[required]}
,options:[{value:" ",displayValue:'Please select'},{value:'1',displayValue:'Yes'},{value:'0',displayValue:'No'}]})))));}}]);return BenefitSelection;}(__WEBPACK_IMPORTED_MODULE_8_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (BenefitSelection);

/***/ }),
/* 2785 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_core__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_CustomCardHeading_CustomCardHeading_jsx__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_Wrappers_materialUIWrappers_components_FormInput__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Grid_GridItem_jsx__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__CompanyLevels_jsx__ = __webpack_require__(2786);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__planDetails_jsx__ = __webpack_require__(742);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_assets_img_logo_medihelp_jpg__ = __webpack_require__(743);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_assets_img_logo_medihelp_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_assets_img_logo_medihelp_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__GapDetails_jsx__ = __webpack_require__(744);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_redux_form__ = __webpack_require__(15);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CustomFieldFullWidth=function CustomFieldFullWidth(props){return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:12,style:{marginBottom:'25px'}},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["t" /* FormControl */],{fullWidth:true},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_redux_form__["a" /* Field */],props)));};var CompanySelection=function(_React$Component){_inherits(CompanySelection,_React$Component);function CompanySelection(){var _ref;var _temp,_this,_ret;_classCallCheck(this,CompanySelection);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=CompanySelection.__proto__||Object.getPrototypeOf(CompanySelection)).call.apply(_ref,[this].concat(args))),_this),_this.state={availTargets:[],gapTargets:[]},_this.handleCheck=function(id){if(_this.props.selectedTargets.find(function(t){return t===id;})){_this.props.checkSelectedTarget(id,false);}else{if(_this.props.selectedTargets.length<4)_this.props.checkSelectedTarget(id,true);}_this.forceUpdate();},_this.handleCheckGap=function(id){//console.log("HELLO ==" + id)
if(_this.props.selectedTargetsGap.find(function(t){return t===id;})){_this.props.checkSelectedTargetGap(id,false);}else{if(_this.props.selectedTargetsGap.length<1)_this.props.checkSelectedTargetGap(id,true);}_this.forceUpdate();},_this.handleCheckLoyalty=function(id){if(_this.props.selectedTargetsLoyalty.find(function(t){return t===id;})){_this.props.checkSelectedTargetLoyalty(id,false);}else{_this.props.checkSelectedTargetLoyalty(id,true);}_this.forceUpdate();},_this.checkAll=function(){if(_this.props.selectedTargets.length!==_this.props.AvailTargetsForBroker.length){_this.props.toggleAllTargets(_this.props.AvailTargetsForBroker,true);}else{_this.props.toggleAllTargets(_this.props.AvailTargetsForBroker,false);}_this.forceUpdate();},_this.checkAllGap=function(){if(_this.props.selectedTargetsGap.length!==_this.props.AvailTargetsForBrokerGap.length){_this.props.toggleAllTargetsGap(_this.props.AvailTargetsForBrokerGap,true);}else{_this.props.toggleAllTargetsGap(_this.props.AvailTargetsForBrokerGap,false);}_this.forceUpdate();},_this.checkAllLoyalty=function(){if(_this.props.selectedTargetsLoyalty.length!==_this.props.AvailTargetsForBrokerLoyalty.length){_this.props.toggleAllTargetsLoyalty(_this.props.AvailTargetsForBrokerLoyalty,true);}else{_this.props.toggleAllTargetsLoyalty(_this.props.AvailTargetsForBrokerLoyalty,false);}_this.forceUpdate();},_this.populateCompany=function(targets){var current="";var result=[];var trg=targets;//trg.sort(function(a, b){ return a.planType.localeCompare(b.planType)});
//console.log("??????????" + JSON.stringify( targets))
//console.log("??????????" + JSON.stringify( trg))
targets.forEach(function(target){if(current==target.company){if(!result[target.company][target.planType])result[target.company][target.planType]=[];result[target.company][target.planType].push(target);//result[target.company].sort(function(a, b){ return a.planType.localeCompare(b.planType)});
}else{current=target.company;result[target.company]=[];result[target.company][target.planType]=[];result[target.company][target.planType].push(target);}});//Sorting each companies plans according to keys
Object.keys(result).forEach(function(e){result[e]=Object.keys(result[e]).sort().reduce(function(acc,key){acc[key]=result[e][key];return acc;},{});});return result;},_this.ageCheck=function(ageC){var person=ageC.split(",")[0];var opperator=ageC.split(",")[1];var age=ageC.split(",")[2];var eldest=_this.props.state.clientAge;_this.props.state.dependentsAdult.forEach(function(e){if(new Date().getFullYear()-new Date(e.dob).getFullYear()>eldest)eldest=new Date().getFullYear()-new Date(e.dob).getFullYear();});if(person=="p"){if(opperator==">"){if(_this.props.state.clientAge>age)return true;else return false;}else{if(_this.props.state.clientAge<age){if(age<64){if(_this.props.state.clientAge>44)return true;else return false;}else{return true;}}else return false;}}else{if(opperator==">"){if(eldest>age)return true;else return false;}else{if(eldest<age){if(age<64){if(eldest>44)return true;else return false;}else return true;}else return false;}}},_this.populateGap=function(targets){var current="";var result=[];targets.forEach(function(target){if(current==target.company){result[target.company].push(target);}else{current=target.company;result[target.company]=[];result[target.company].push(target);}});return result;},_this.incomeCondition=function(plan){var income=parseFloat(_this.props.state.income);var planIncome=plan.familyIncome;if(planIncome==""||planIncome=="N/A")return true;var planIncomeHigh=0;var planIncomeLow=0;var opperator="";planIncome=planIncome.replace(/R/g,"");planIncome=planIncome.replace(/ /g,"");if(planIncome.includes(">")){opperator=">";planIncome=planIncome.replace(/>/g,"");}if(planIncome.includes("<")){opperator="<";planIncome=planIncome.replace(/</g,"");}if(planIncome.includes("+")){opperator=">";planIncome=planIncome.replace("+","");}planIncome=planIncome.split("-");if(planIncome.length>1){planIncomeHigh=planIncome[1];planIncomeLow=planIncome[0];}else{planIncomeLow=planIncome[0];}if(opperator!=""){if(income>planIncomeLow){return true;}}else if(income>planIncomeLow&&income<planIncomeHigh){return true;}return false;},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(CompanySelection,[{key:'componentDidMount',value:function componentDidMount(){this.props.scrollMeBar();}},{key:'render',value:function render(){var _this2=this;var targets=this.props.AvailTargetsForBroker;var targetsGap=__WEBPACK_IMPORTED_MODULE_8__GapDetails_jsx__["a" /* gapDetails */];var targetsLoyalty=this.props.AvailTargetsForBrokerLoyalty;var allSelected=this.props.selectedTargets.length===targets.length;var allSelectedGap=this.props.selectedTargetsGap.length===targetsGap.length;var allSelectedLoyalty=this.props.selectedTargetsLoyalty.length===targetsLoyalty.length;var planType=this.props.planType;var coverLevel=this.props.coverLevel;var hospitalLevel=this.props.hospitalLevel;var chronicProvider=this.props.chronicProvider;var serviceProvider=this.props.serviceProvider;var coverOptions=[];var targetsToRender=[];var targetsToRenderGap=[];var targetsOptionsGap=[];targets=[];var currentCompany="";__WEBPACK_IMPORTED_MODULE_6__planDetails_jsx__["a" /* planDetails */].forEach(function(element){//console.log(element)
//console.log(coverLevel," ", hospitalLevel, " ", chronicProvider, " ", serviceProvider)
if(planType==element.planType.toLocaleLowerCase()||planType=="all")if(coverLevel==element.coverLevel.toLocaleLowerCase()||coverLevel=="all")if(hospitalLevel==element.hospital.toLocaleLowerCase()||hospitalLevel=="all")if(chronicProvider==element.chronic.toLocaleLowerCase()||chronicProvider=="all")if(serviceProvider==element.serviceType.toLocaleLowerCase()||serviceProvider=="all"){//console.log(":::::::::::" + this.props.state.income)
if(_this2.incomeCondition(element)){element.id=element.name;targets.push(element);}}});//console.log("->"+JSON.stringify(targets))
//var targets2 = targets.sort(function(a, b){ return a.planType.localeCompare(b.planType)});
//console.log("--->"+JSON.stringify(targets2))
targets=this.populateCompany(targets);targetsGap.forEach(function(e){if(_this2.ageCheck(e.age)){if(_this2.props.state.coPay==1&&e.coPay=="Gap + co"){if(_this2.props.state.gapLevel==1){if(e.level<=300){targetsOptionsGap.push(e);}}else if(_this2.props.state.gapLevel==2){if(e.level<=500&&e.level>300){targetsOptionsGap.push(e);}}else if(_this2.props.state.gapLevel==3){if(e.level>500){targetsOptionsGap.push(e);}}}else{if(_this2.props.state.coPay==0&&e.coPay=="Gap"){if(_this2.props.state.gapLevel==1){if(e.level<=300){targetsOptionsGap.push(e);}}else if(_this2.props.state.gapLevel==2){if(e.level<=500&&e.level>300){targetsOptionsGap.push(e);}}else if(_this2.props.state.gapLevel==3){if(e.level>500){targetsOptionsGap.push(e);}}}}}});var tempTargets=[];Object.keys(targets).forEach(function(element){tempTargets=[];//console.log("----)"+Object.keys(targets[element])[0])
var imgSrc=__webpack_require__(424)("./"+targets[element][Object.keys(targets[element])[0]][0].logo);targetsToRender.push(__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:2,style:{marginBottom:'25px'}},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('img',{src:imgSrc,alt:targets[element][Object.keys(targets[element])[0]][0].name,className:'targetAffiliationLogoMedical',style:{marginLeft:'20px'}}),Object.keys(targets[element]).forEach(function(el){//console.log(">>>>>>>>>>>" + el)
tempTargets.push(__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('h6',null,targets[element][el][0].planType));targets[element][el].forEach(function(e){var selected=_this2.props.selectedTargets.find(function(s){return s===e.id;})?true:false;tempTargets.push(__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{key:e.id,className:'checkboxContainerMedical',style:selected?{backgroundColor:'#f5f5f5'}:{},onClick:function onClick(){return _this2.handleCheck(e.name);}},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["h" /* Checkbox */],{checked:selected}),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{marginTop:'auto',marginBottom:"auto"}},e.name)));});}),tempTargets));});targetsOptionsGap=this.populateGap(targetsOptionsGap);Object.keys(targetsOptionsGap).forEach(function(element){tempTargets=[];//console.log(element)
var imgSrc=__webpack_require__(424)("./"+targetsOptionsGap[element][0].logo);targetsToRenderGap.push(__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:2,style:{marginBottom:'25px'}},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('img',{src:imgSrc,alt:targetsOptionsGap[element][0].company,className:'targetAffiliationLogoMedical',style:{marginLeft:'20px'}}),targetsOptionsGap[element].forEach(function(e){var selected=_this2.props.selectedTargetsGap.find(function(s){return s===e.plan;})?true:false;tempTargets.push(__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{key:e.plan,className:'checkboxContainerMedical',style:selected?{backgroundColor:'#f5f5f5'}:{},onClick:function onClick(){return _this2.handleCheckGap(e.plan);}},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["h" /* Checkbox */],{checked:selected}),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{marginTop:'auto',marginBottom:"auto"}},e.plan)));}),tempTargets));});//console.log(targets)
//console.log(targetsToRender)
return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'contentWithStepper'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["e" /* Card */],{className:this.classes},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["f" /* CardContent */],null,__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_CustomCardHeading_CustomCardHeading_jsx__["a" /* default */],{subheading:'Quote Generation',caption:this.props.clientFullname,headline:'Plan Selection'}),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{container:true},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:12,style:{marginBottom:'25px'}},targetsToRender.length>0?__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{style:{display:'block',width:'100%',marginTop:'15px'}},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{container:true},targetsToRender)):__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{marginTop:'25px'}},'No available plans for your specific options.'))))),this.props.state.gapCover==1&&__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["e" /* Card */],{className:this.classes},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["f" /* CardContent */],null,__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_CustomCardHeading_CustomCardHeading_jsx__["a" /* default */],{headline:'Gap Cover Selection'}),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{container:true},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:12,style:{marginBottom:'25px'}},targetsToRenderGap.length>0?__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{style:{display:'block',width:'100%',marginTop:'15px'}},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{container:true},targetsToRenderGap)):__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{marginTop:'25px'}},'No available plans for your specific options.'))))));}}]);return CompanySelection;}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (CompanySelection);

/***/ }),
/* 2786 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export CompanyLevels */
var CompanyLevels=[{criteria:{coverLevel:"high",hospitalLevel:"any",chronicProvider:"any",serviceProvider:"any"},plans:[{id:"Pace 4",logo:"bestmed.jpg",company:"Bestmed",name:"Pace 4"},{id:"Pinnacle",logo:"compcare.jpg",company:"Compcare",name:"Pinnacle"},{id:"Dynamix",logo:"compcare.jpg",company:"Compcare",name:"Dynamix"},{id:"Plus",logo:"medihelp.jpg",company:"Medihelp",name:"Plus"},{id:"Summit",logo:"momentumMed.png",company:"Momentum",name:"Summit"},{id:"Extender",logo:"momentumMed.png",company:"Momentum",name:"Extender"}]},{criteria:{coverLevel:"high",hospitalLevel:"any",chronicProvider:"network",serviceProvider:"any"},plans:[{id:"BonComprehensive",logo:"bonitas.jpg",company:"Bonitas",name:"BonComprehensive"},{id:"Essential comprehensive",logo:"Discovery.png",company:"Discovery",name:"Essential comprehensive"},{id:"Classic comprehensive",logo:"Discovery.png",company:"Discovery",name:"Classic comprehensive"},{id:"Executive plan",logo:"Discovery.png",company:"Discovery",name:"Executive plan"},{id:"Maxima exec",logo:"fedhealth.jpg",company:"Fedhealth",name:"Maxima exec"},{id:"Maxima plus",logo:"fedhealth.jpg",company:"Fedhealth",name:"Maxima plus"},{id:"Platinum",logo:"keyhealth.png",company:"Key Health",name:"Platinum"},{id:"Premium plus",logo:"medshield.png",company:"Medshield",name:"Premium plus"},{id:"Extender",logo:"momentumMed.png",company:"Momentum",name:"Extender"}]},{criteria:{coverLevel:"high",hospitalLevel:"network",chronicProvider:"any",serviceProvider:"any"},plans:[{id:"Extender",logo:"momentumMed.png",company:"Momentum",name:"Extender"}]},{criteria:{coverLevel:"high",hospitalLevel:"network",chronicProvider:"network",serviceProvider:"any"},plans:[{id:"Pinnacle ED",logo:"compcare.jpg",company:"Compcare",name:"Pinnacle ED"},{id:"Dynamix ED",logo:"compcare.jpg",company:"Compcare",name:"Dynamix ED"},{id:"Essential Delta Comprehensive",logo:"Discovery.png",company:"Discovery",name:"Essential Delta Comprehensive"},{id:"Classic Smart Comprehensive",logo:"Discovery.png",company:"Discovery",name:"Classic Smart Comprehensive"},{id:"Classic Delta Comprehensive",logo:"Discovery.png",company:"Discovery",name:"Classic Delta Comprehensive"},{id:"Maxima exec grid",logo:"fedhealth.jpg",company:"Fedhealth",name:"Maxima exec grid"},{id:"Extender",logo:"momentumMed.png",company:"Momentum",name:"Extender"}]},{criteria:{coverLevel:"high",hospitalLevel:"network",chronicProvider:"state",serviceProvider:"any"},plans:[{id:"Pinnacle ED",logo:"compcare.jpg",company:"Compcare",name:"Pinnacle ED"},{id:"Dynamix ED",logo:"compcare.jpg",company:"Compcare",name:"Dynamix ED"},{id:"Essential Delta Comprehensive",logo:"Discovery.png",company:"Discovery",name:"Essential Delta Comprehensive"},{id:"Classic Smart Comprehensive",logo:"Discovery.png",company:"Discovery",name:"Classic Smart Comprehensive"},{id:"Classic Delta Comprehensive",logo:"Discovery.png",company:"Discovery",name:"Classic Delta Comprehensive"},{id:"Maxima exec grid",logo:"fedhealth.jpg",company:"Fedhealth",name:"Maxima exec grid"},{id:"Extender",logo:"momentumMed.png",company:"Momentum",name:"Extender"}]},{criteria:{coverLevel:"high",hospitalLevel:"any",chronicProvider:"state",serviceProvider:"any"},plans:[{id:"BonComprehensive",logo:"bonitas.jpg",company:"Bonitas",name:"BonComprehensive"},{id:"Essential comprehensive",logo:"Discovery.png",company:"Discovery",name:"Essential comprehensive"},{id:"Classic comprehensive",logo:"Discovery.png",company:"Discovery",name:"Classic comprehensive"},{id:"Executive plan",logo:"Discovery.png",company:"Discovery",name:"Executive plan"},{id:"Maxima exec",logo:"fedhealth.jpg",company:"Fedhealth",name:"Maxima exec"},{id:"Maxima plus",logo:"fedhealth.jpg",company:"Fedhealth",name:"Maxima plus"},{id:"Platinum",logo:"keyhealth.png",company:"Key Health",name:"Platinum"},{id:"Premium plus",logo:"medshield.png",company:"Medshield",name:"Premium plus"},{id:"Extender",logo:"momentumMed.png",company:"Momentum",name:"Extender"}]},{criteria:{coverLevel:"medium",hospitalLevel:"any",chronicProvider:"any",serviceProvider:"any"},plans:[{id:"Beat 4",logo:"bestmed.jpg",company:"Bestmed",name:"Beat 4"},{id:"Beat 3",logo:"bestmed.jpg",company:"Bestmed",name:"Beat 3"},{id:"Beat 2",logo:"bestmed.jpg",company:"Bestmed",name:"Beat 2"},{id:"Beat 1",logo:"bestmed.jpg",company:"Bestmed",name:"Beat 1"},{id:"Symmetry",logo:"compcare.jpg",company:"Compcare",name:"Symmetry"},{id:"Mumed",logo:"compcare.jpg",company:"Compcare",name:"Mumed"},{id:"Unisave",logo:"compcare.jpg",company:"Compcare",name:"Unisave"},{id:"MEDX",logo:"compcare.jpg",company:"Compcare",name:"MEDX"},{id:"Private choice",logo:"Health Squared.jpg",company:"Health Squared",name:"Private choice"},{id:"Private",logo:"Health Squared.jpg",company:"Health Squared",name:"Private"},{id:"Private plus",logo:"Health Squared.jpg",company:"Health Squared",name:"Private plus"},{id:"Private comprehensive",logo:"Health Squared.jpg",company:"Health Squared",name:"Private comprehensive"},{id:"Unify",logo:"medihelp.jpg",company:"Medihelp",name:"Unify"},{id:"Elite",logo:"medihelp.jpg",company:"Medihelp",name:"Elite"},{id:"Custom",logo:"momentumMed.png",company:"Momentum",name:"Custom"},{id:"Incentive",logo:"momentumMed.png",company:"Momentum",name:"Incentive"}]},{criteria:{coverLevel:"medium",hospitalLevel:"any",chronicProvider:"network",serviceProvider:"any"},plans:[{id:"Pace 3",logo:"bestmed.jpg",company:"Bestmed",name:"Pace 3"},{id:"Pace 2",logo:"bestmed.jpg",company:"Bestmed",name:"Pace 2"},{id:"Pace 1",logo:"bestmed.jpg",company:"Bestmed",name:"Pace 1"},{id:"BonComplete",logo:"bonitas.jpg",company:"Bonitas",name:"BonComplete"},{id:"BonClassic",logo:"bonitas.jpg",company:"Bonitas",name:"BonClassic"},{id:"BonSave",logo:"bonitas.jpg",company:"Bonitas",name:"BonSave"},{id:"Coastal saver",logo:"Discovery.png",company:"Discovery",name:"Coastal saver"},{id:"Essential saver",logo:"Discovery.png",company:"Discovery",name:"Essential saver"},{id:"Classic saver",logo:"Discovery.png",company:"Discovery",name:"Classic saver"},{id:"Essensial priority",logo:"Discovery.png",company:"Discovery",name:"Essensial priority"},{id:"Classic priority",logo:"Discovery.png",company:"Discovery",name:"Classic priority"},{id:"flexiFED 2",logo:"fedhealth.jpg",company:"Fedhealth",name:"flexiFED 2"},{id:"flexiFED 3",logo:"fedhealth.jpg",company:"Fedhealth",name:"flexiFED 3"},{id:"flexiFED 4",logo:"fedhealth.jpg",company:"Fedhealth",name:"flexiFED 4"},{id:"Hosmed plus",logo:"hosmed.jpg",company:"Hosmed",name:"Hosmed plus"},{id:"Hosmed value",logo:"hosmed.jpg",company:"Hosmed",name:"Hosmed value"},{id:"Prime 2",logo:"medihelp.jpg",company:"Medihelp",name:"Prime 2"},{id:"Prime 3",logo:"medihelp.jpg",company:"Medihelp",name:"Prime 3"},{id:"MediBonus",logo:"medshield.png",company:"Medshield",name:"MediBonus"},{id:"Custom",logo:"momentumMed.png",company:"Momentum",name:"Custom"},{id:"Incentive",logo:"momentumMed.png",company:"Momentum",name:"Incentive"},{id:"Platinum enhanced",logo:"Sizwe.jpg",company:"Siswe",name:"Platinum enhanced"},{id:"Platinum enhanced EDO",logo:"Sizwe.jpg",company:"Siswe",name:"Platinum enhanced EDO"},{id:"Titanium executive",logo:"Sizwe.jpg",company:"Siswe",name:"Titanium executive"}]},{criteria:{coverLevel:"medium",hospitalLevel:"any",chronicProvider:"any",serviceProvider:"network"},plans:[{id:"Standard",logo:"bonitas.jpg",company:"Bonitas",name:"Standard"}]},{criteria:{coverLevel:"medium",hospitalLevel:"any",chronicProvider:"network",serviceProvider:"network"},plans:[{id:"Standard",logo:"bonitas.jpg",company:"Bonitas",name:"Standard"}]},{criteria:{coverLevel:"medium",hospitalLevel:"any",chronicProvider:"network",serviceProvider:"any"},plans:[{id:"Pace 3",logo:"bestmed.jpg",company:"Bestmed",name:"Pace 3"},{id:"Pace 2",logo:"bestmed.jpg",company:"Bestmed",name:"Pace 2"},{id:"Pace 1",logo:"bestmed.jpg",company:"Bestmed",name:"Pace 1"},{id:"BonComplete",logo:"bonitas.jpg",company:"Bonitas",name:"BonComplete"},{id:"BonClassic",logo:"bonitas.jpg",company:"Bonitas",name:"BonClassic"},{id:"BonSave",logo:"bonitas.jpg",company:"Bonitas",name:"BonSave"},{id:"Coastal saver",logo:"Discovery.png",company:"Discovery",name:"Coastal saver"},{id:"Essential saver",logo:"Discovery.png",company:"Discovery",name:"Essential saver"},{id:"Classic saver",logo:"Discovery.png",company:"Discovery",name:"Classic saver"},{id:"Essensial priority",logo:"Discovery.png",company:"Discovery",name:"Essensial priority"},{id:"Classic priority",logo:"Discovery.png",company:"Discovery",name:"Classic priority"},{id:"flexiFED 2",logo:"fedhealth.jpg",company:"Fedhealth",name:"flexiFED 2"},{id:"flexiFED 3",logo:"fedhealth.jpg",company:"Fedhealth",name:"flexiFED 3"},{id:"flexiFED 4",logo:"fedhealth.jpg",company:"Fedhealth",name:"flexiFED 4"},{id:"Hosmed plus",logo:"hosmed.jpg",company:"Hosmed",name:"Hosmed plus"},{id:"Hosmed value",logo:"hosmed.jpg",company:"Hosmed",name:"Hosmed value"},{id:"Prime 2",logo:"medihelp.jpg",company:"Medihelp",name:"Prime 2"},{id:"Prime 3",logo:"medihelp.jpg",company:"Medihelp",name:"Prime 3"},{id:"MediBonus",logo:"medshield.png",company:"Medshield",name:"MediBonus"},{id:"Custom",logo:"momentumMed.png",company:"Momentum",name:"Custom"},{id:"Incentive",logo:"momentumMed.png",company:"Momentum",name:"Incentive"},{id:"Platinum enhanced",logo:"Sizwe.jpg",company:"Siswe",name:"Platinum enhanced"},{id:"Platinum enhanced EDO",logo:"Sizwe.jpg",company:"Siswe",name:"Platinum enhanced EDO"},{id:"Titanium executive",logo:"Sizwe.jpg",company:"Siswe",name:"Titanium executive"}]},{criteria:{coverLevel:"medium",hospitalLevel:"network",chronicProvider:"any",serviceProvider:"network"},plans:[{id:"Pulse 2",logo:"bestmed.jpg",company:"Bestmed",name:"Pulse 2"},{id:"Beat 3 Network",logo:"bestmed.jpg",company:"Bestmed",name:"Beat 3 Network"},{id:"Beat 2 Network",logo:"bestmed.jpg",company:"Bestmed",name:"Beat 2 Network"},{id:"Beat 1 Network",logo:"bestmed.jpg",company:"Bestmed",name:"Beat 1 Network"},{id:"Standard select",logo:"bonitas.jpg",company:"Bonitas",name:"Standard select"},{id:"BonEssencial select",logo:"bonitas.jpg",company:"Bonitas",name:"BonEssencial select"},{id:"flexiFED 2 grid",logo:"fedhealth.jpg",company:"Fedhealth",name:"flexiFED 2 grid"},{id:"flexiFED 2 elect",logo:"fedhealth.jpg",company:"Fedhealth",name:"flexiFED 2 elect"},{id:"flexiFED 3 grid",logo:"fedhealth.jpg",company:"Fedhealth",name:"flexiFED 3 grid"},{id:"flexiFED 3 elect",logo:"fedhealth.jpg",company:"Fedhealth",name:"flexiFED 3 elect"},{id:"flexiFED 4 grid",logo:"fedhealth.jpg",company:"Fedhealth",name:"flexiFED 4 grid"},{id:"flexiFED 4 elect",logo:"fedhealth.jpg",company:"Fedhealth",name:"flexiFED 4 elect"}]},{criteria:{coverLevel:"medium",hospitalLevel:"network",chronicProvider:"state",serviceProvider:"any"},plans:[{id:"Symmetry ED",logo:"compcare.jpg",company:"Compcare",name:"Symmetry ED"},{id:"Selfsure",logo:"compcare.jpg",company:"Compcare",name:"Selfsure"},{id:"Mumed ED",logo:"compcare.jpg",company:"Compcare",name:"Mumed ED"},{id:"MEDEX ED",logo:"compcare.jpg",company:"Compcare",name:"MEDEX ED"},{id:"BonFit select",logo:"bonitas.jpg",company:"Bonitas",name:"BonFit select"},{id:"Essential delta saver",logo:"Discovery.png",company:"Discovery",name:"Essential delta saver"},{id:"Classic delta saver",logo:"Discovery.png",company:"Discovery",name:"Classic delta saver"},{id:"Essential smart",logo:"Discovery.png",company:"Discovery",name:"Essential smart"},{id:"Classic smart",logo:"Discovery.png",company:"Discovery",name:"Classic smart"},{id:"Hosmed value core",logo:"hosmed.jpg",company:"Hosmed",name:"Hosmed value core"},{id:"Essence",logo:"keyhealth.png",company:"Key Health",name:"Essence"},{id:"Origin",logo:"keyhealth.png",company:"Key Health",name:"Origin"},{id:"Equilibrium",logo:"keyhealth.png",company:"Key Health",name:"Equilibrium"},{id:"Silver",logo:"keyhealth.png",company:"Key Health",name:"Silver"},{id:"Gold",logo:"keyhealth.png",company:"Key Health",name:"Gold"},{id:"Prime 1 network",logo:"medihelp.jpg",company:"Medihelp",name:"Prime 1 network"},{id:"Prime 1",logo:"medihelp.jpg",company:"Medihelp",name:"Prime 1"},{id:"Prime 2 network",logo:"medihelp.jpg",company:"Medihelp",name:"Prime 2 network"},{id:"Prime 3 network",logo:"medihelp.jpg",company:"Medihelp",name:"Prime 3 network"},{id:"MediValue prime",logo:"medshield.png",company:"Medshield",name:"MediValue prime"},{id:"MediValue compact",logo:"medshield.png",company:"Medshield",name:"MediValue compact"},{id:"MediCore",logo:"medshield.png",company:"Medshield",name:"MediCore"},{id:"MediPlus prime",logo:"medshield.png",company:"Medshield",name:"MediPlus prime"},{id:"MediSaver",logo:"medshield.png",company:"Medshield",name:"MediSaver"},{id:"Incentive",logo:"momentumMed.png",company:"Momentum",name:"Incentive"},{id:"Silver saver",logo:"Sizwe.jpg",company:"Siswe",name:"Silver saver"}]},{criteria:{coverLevel:"medium",hospitalLevel:"network",chronicProvider:"network",serviceProvider:"any"},plans:[{id:"Symmetry ED",logo:"compcare.jpg",company:"Compcare",name:"Symmetry ED"},{id:"Selfsure",logo:"compcare.jpg",company:"Compcare",name:"Selfsure"},{id:"Mumed ED",logo:"compcare.jpg",company:"Compcare",name:"Mumed ED"},{id:"MEDEX ED",logo:"compcare.jpg",company:"Compcare",name:"MEDEX ED"},{id:"BonFit select",logo:"bonitas.jpg",company:"Bonitas",name:"BonFit select"},{id:"Essential delta saver",logo:"Discovery.png",company:"Discovery",name:"Essential delta saver"},{id:"Classic delta saver",logo:"Discovery.png",company:"Discovery",name:"Classic delta saver"},{id:"Essential smart",logo:"Discovery.png",company:"Discovery",name:"Essential smart"},{id:"Classic smart",logo:"Discovery.png",company:"Discovery",name:"Classic smart"},{id:"Hosmed value core",logo:"hosmed.jpg",company:"Hosmed",name:"Hosmed value core"},{id:"Essence",logo:"keyhealth.png",company:"Key Health",name:"Essence"},{id:"Origin",logo:"keyhealth.png",company:"Key Health",name:"Origin"},{id:"Equilibrium",logo:"keyhealth.png",company:"Key Health",name:"Equilibrium"},{id:"Silver",logo:"keyhealth.png",company:"Key Health",name:"Silver"},{id:"Gold",logo:"keyhealth.png",company:"Key Health",name:"Gold"},{id:"Prime 1 network",logo:"medihelp.jpg",company:"Medihelp",name:"Prime 1 network"},{id:"Prime 1",logo:"medihelp.jpg",company:"Medihelp",name:"Prime 1"},{id:"Prime 2 network",logo:"medihelp.jpg",company:"Medihelp",name:"Prime 2 network"},{id:"Prime 3 network",logo:"medihelp.jpg",company:"Medihelp",name:"Prime 3 network"},{id:"MediValue prime",logo:"medshield.png",company:"Medshield",name:"MediValue prime"},{id:"MediValue compact",logo:"medshield.png",company:"Medshield",name:"MediValue compact"},{id:"MediCore",logo:"medshield.png",company:"Medshield",name:"MediCore"},{id:"MediPlus prime",logo:"medshield.png",company:"Medshield",name:"MediPlus prime"},{id:"MediSaver",logo:"medshield.png",company:"Medshield",name:"MediSaver"},{id:"Incentive",logo:"momentumMed.png",company:"Momentum",name:"Incentive"},{id:"Silver saver",logo:"Sizwe.jpg",company:"Siswe",name:"Silver saver"}]},{criteria:{coverLevel:"low",hospitalLevel:"any",chronicProvider:"network",serviceProvider:"any"},plans:[{id:"Gold ascend",logo:"Sizwe.jpg",company:"Siswe",name:"Gold ascend"},{id:"Gold ascend EDO",logo:"Sizwe.jpg",company:"Siswe",name:"Gold ascend EDO"},{id:"Access",logo:"hosmed.jpg",company:"Hosmed",name:"Access"}]},{criteria:{coverLevel:"low",hospitalLevel:"any",chronicProvider:"network",serviceProvider:"any"},plans:[{id:"Primary",logo:"bonitas.jpg",company:"Bonitas",name:"Primary"},{id:"Ingwe",logo:"momentumMed.png",company:"Momentum",name:"Ingwe"}]},{criteria:{coverLevel:"low",hospitalLevel:"network",chronicProvider:"network",serviceProvider:"network"},plans:[{id:"Pulse 1",logo:"bestmed.jpg",company:"Bestmed",name:"Pulse 1"},{id:"BonCap",logo:"bonitas.jpg",company:"Bonitas",name:"BonCap"},{id:"Primary select",logo:"bonitas.jpg",company:"Bonitas",name:"Primary select"},{id:"NetworX",logo:"compcare.jpg",company:"Compcare",name:"NetworX"},{id:"NetworX ED",logo:"compcare.jpg",company:"Compcare",name:"NetworX ED"},{id:"Selfnet",logo:"compcare.jpg",company:"Compcare",name:"Selfnet"},{id:"KeyCare plus",logo:"Discovery.png",company:"Discovery",name:"KeyCare plus"},{id:"myFED",logo:"fedhealth.jpg",company:"Fedhealth",name:"myFED"},{id:"flexiFED 1",logo:"fedhealth.jpg",company:"Fedhealth",name:"flexiFED 1"},{id:"Essential",logo:"hosmed.jpg",company:"Hosmed",name:"Essential"},{id:"Medihelp",logo:"hosmed.jpg",company:"Hosmed",name:"Medihelp"},{id:"Necesse",logo:"hosmed.jpg",company:"Hosmed",name:"Necesse"},{id:"Necesse1",logo:"medihelp.jpg",company:"Medihelp",name:"Necesse"},{id:"MediPhila",logo:"medihelp.jpg",company:"Medihelp",name:"MediPhila"},{id:"Ingwe",logo:"momentumMed.png",company:"Momentum",name:"Ingwe"},{id:"Coper core",logo:"Sizwe.jpg",company:"Siswe",name:"Coper core"}]},{criteria:{coverLevel:"low",hospitalLevel:"network",chronicProvider:"state",serviceProvider:"network"},plans:[{id:"KeyCare start",logo:"Discovery.png",company:"Discovery",name:"KeyCare start"},{id:"Ingwe",logo:"momentumMed.png",company:"Momentum",name:"Ingwe"}]},{criteria:{coverLevel:"low",hospitalLevel:"state",chronicProvider:"network",serviceProvider:"network"},plans:[{id:"Ingwe",logo:"momentumMed.png",company:"Momentum",name:"Ingwe"}]}];

/***/ }),
/* 2787 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/1.315ed3bf.png";

/***/ }),
/* 2788 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 2789 */
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 2790 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/PPS.559211dd.jpg";

/***/ }),
/* 2791 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/Sizwe.744e6059.jpg";

/***/ }),
/* 2792 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/agility.15b77d71.png";

/***/ }),
/* 2793 */
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 2794 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 2795 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 2796 */
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 2797 */
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 2798 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/curemed.99514610.png";

/***/ }),
/* 2799 */
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 2800 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 2801 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/fmi-small0.605656a8.png";

/***/ }),
/* 2802 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 2803 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEsAAAAeCAYAAABkDeOuAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAA3XAAAN1wFCKJt4AAAAB3RJTUUH4QseEC4jY5yoFAAACfJJREFUaN7Nmm1QVNcZx3/n7l1YFcSFgAvssjVUgi/xpS0mji+RJjZtNVajnYlm4sRMShKsk9F+ajNjq5NMxsmHdpKpY2ZKJ86gmGkarBJjiRMmimlCFGOkYGUSZFcCyBVxed+9955+WLhwXfAFJfGZ2WHP295z/s/z/5/n3IOQUkpu0yQgRqkHOdAmrEoJCHHz8fe6qbcPlAQpLUgkIKVEmCZGfxjCYWRvL5gShEBMiMeMc6HGORGqgkQghAAEEokQ0d8UKPc8gLcNFqYkclmj88uz6F/+l3Dd/zC/aSDybQviylVkfx+KjEIpEZgCcMYh3Ek4PFNRp/lxPPBDnHNmM+lHc4n3ZSIcDoS49+NNjETDoSqJlGD2R+j8rIq+D8vpq6jEPF+PM6IDJgKBObBMAdHvQgxEHygSpBikZTSGBiExHAqm34dr6SJcP/8pk/OX4picONBDDtBV2Ch8z4FlSgmmpOdcDR17D9B/8DBq8+WBJUBEVRBTp6JO+wFqViZmehoT0tJgyhQcCRNh0gRQlChKvb0YXd2IayF62zSUlhaMYBP9DUFE8FsUPYwqo4CHkyYx4Rc/I2HjUyQuWYRwKAgxSNt7ACxTSmn5UYI0DK6Vf0zoz3/FOPk5puLAkZNNXN6Pcf5kLq7ZM5mQOx3H5MmgKNHoQV4v61b5+pK1CZhg9vbSU/8N/TW1hM+cJfx5NXptLY6+fmTuAyRs+Q3J69ehuOKj0SbE90pUYZpSDop21xen0X6/A+NiIxMfy8e1PJ9Jix4iburUaKQMUGI8JmxKiZQS81qIUNUX9H1UQd/RCkxFkvynP+D+1S8RiuN7jTILrNZ/ldFbdhT3U78mcdHDCFfcgA4Nkk8BIa2au202nSTqERnR6T5bw7X9/8DITCdr62YURbkHNEtK7hklHRnNUecXdbcc6ANCKOPiUit1iOg6TU1NtzwwIyODuLg4pJQ0NTWh6zpCCLKyskalimmaBINBpJSoqorX643po2kaXV1dMfWpqal0dHSQlJSEqqq4XC5bhqt396D99W08215GOIaA1XWdoqIiCgoK2LdvH08//TTvvfceTqeT1atXjw0swzA4cuQIJSX7bx6OQlBaepCUlBQMw2DjxmeIRCIA7Nmzh1mzZo847quvvmLLls2AID4+nvLyj2Jo1dbWxs6dO7h06ZJVt3TpUrZt+x2hUIjq6mqEEKxcuXKQG0gpCF9qpmvXX5AvFUBigi3qmpubAfD5fNY6n3vuOTo6OigtLWXBggXMmjXrpuu2Zupyudi0aRMOhxIV8Rt8EhISSE5OBqClpYVIJGy1vf/+P0elSmnp+wOpAPT393H58uWYfjNmzODRRx+1PW/9+vWkpKTg9XpZvHgxCxcuHEVTGJGqg5F+7NgxHA4HPp+PvLw8ioqKSE9PZ/fu3dzKqc+WwTsc9t3G5/ORn59vG9Dc3ExT07dWubHxom3MJ598wubN7RaYg3blyhUqK0/YFhAINOLxeEZd3CDIqhqdZmJi4pg3j8F8TQiBoig4nU46OzvRNI1ly5ZZfcZ83MnKyuL55wtiHlxZWTkMrEZbezgc5oMPynjmmY22+sOHD1lUHbSLFy+yYMFDN6X8GE6vlrw7HA4URUHTNDweD1JKy0Fr165l//79ZGdnI4TgrbfeYsuWLXfvbCiEYMmSJVY5GAzG9Dl06BDr12+wIkLXdcrKDsf0G2ns3TZFUdi+fTsAhYWFALz44osAPPjgg7z++utW32efffbWNGusdn1kAbS2tvDZZ/+xypWVJ2hra4vpFwg0MoY3RDdz55iThpvR/I7AiqYCgRHbSktLhwl76Yh9AoHAOIA1sum6Tmtr651F6Y0au7q6OH/+vO1TX19vtYdCIUKhkAXK3LnzrLZTp74gGAzQ0NDAmTNnrPq5c+daALW3t9Pd3f2dgNXZ2UlxcfFtniZuQ7POnj1LQcHztjqfL4vi4n0Du9lQZDidTgoLC3nhhQLrgQcPHhwQdWnpXWHhb3nppRcwTdOKzJkzZ40rUK+++ird3d2kpqbS2dnJzp07kVLyyiuv8Omnn1JRUYFpmuzatYuamhreffddvF4vmzdvtm0wt03D4Rl6IDBEwfvuu4/c3BnMnz/fqvvwwyOUl//bKuflLSA3Nxe3O9kCbyTNu9v06+vrY+vWrVZivGTJEpYvX86ZM2fo7e1lw4YN+P1+NE2jvLwcr9fL6dOnY3bvG0aWz5fFY48tt9Xl5uZaOUkg0DgMRD8Aa9astWh3/bFlzZo1APj9WVy5olkiP967YXt7O1VVVQC43W6OHz9OfHw8y5Yto729HafTae3cbrebzMxMcnJycDqdtwOWj02bNt3STuj3+xFCsHjxYtLS0mKyc48nnYcfXogQAr/fT3V1dUx0jhdYBQUFtLS08MgjjzBjxgw0TUPXdebPn09iYiJut5tFixaRmJjIxo0bOXr0KOnp6TE5nnrjnOrGExm+E2ZlZUV/UFV54olVFBX9zdZ31apVOBwOWxR+F2ABzJs3z5ahL1261GqbPn26JSODNtoBe8ypQ39/Py0tLTFgAaxYsRJVHQrhuLg4VqxYGUPZwbNlOBwe/3dRd+H105jBampqsgRQSonfPwRASkqKzXv5+flMmTLFRtnhoN9p/nMzgT9y5Mio7ZqmEQqFCIfDtjcddxWsQCBgeSspKYmkpCk2L65Z86SVUa9e/aTNs8nJySQkJIwTFSXyupzp5MmTVFVVWRH89ddfc+HCBQDKysqoqKigvr6ePXv2YBgGmqZx6tQpDMOgt7eXuro6qqur7wysQcvM9Fp6NGhz5szh/vuzycnJYebMmXahVFUyMjJveGS6mzaYGBcXFxMMBtm7dy8lJSXU1tbaHCyEwDRN3njjDWpqajhw4ADNzc28+eabtLW12cEyDIPhyauuG6NO4OLFhhFpNfzhO3bsZPv2P46oF0MaJ2y/FT1G2S9cdV2/4VkQYQ4LJcH1VyrZ2dmsW7eOjo4OGhsbuXr1Ki6XC8MwcLvdeDwe3G43aWlp6LpOMBhE0zQr+vPy8nj88ceHwOrr6+Wdd/6OYei2N5vHjx+Pmd65c+c4efKkVb506dKIC/L7/TbhH774oVfYkhMnjlNXV4uUkrq6Wj7++JiV9UspKSkpQdO0UUgHYuAyz7pbue60cuHCBV577TVycnKYPXs2qqrS3d2N1+slOTmZqqoqEhISqK2txeFwkJubS09PDxkZGbbNwbqwiEQiI9IhLi7OtmApJW1tbYRC12wenDZtWgwVRzPDMGhoaGD4v4gkJSWRmppKa2srnZ2dMWM8Ho9N54aDhZQY3d207n6b9G0vI1R16J5SSnRdJxKJMHHiRMtZuq4THx9vlVVVtf4C9PT0MGnSJKSUGIaBqqr8H4NdgKKZfyo1AAAAAElFTkSuQmCC"

/***/ }),
/* 2804 */
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 2805 */
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 2806 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 2807 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/liberty-small.5b530929.jpg";

/***/ }),
/* 2808 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 2809 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/madgap.4691154b.png";

/***/ }),
/* 2810 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/medgap.4691154b.png";

/***/ }),
/* 2811 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 2812 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/momentum-small.f89a93cd.jpg";

/***/ }),
/* 2813 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/momentum.315ed3bf.png";

/***/ }),
/* 2814 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/momentumMed.4923f309.png";

/***/ }),
/* 2815 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/old mutual.1b749edb.jpg";

/***/ }),
/* 2816 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 2817 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 2818 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/pps.a780c1b2.png";

/***/ }),
/* 2819 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/profmed.af4f51c4.jpg";

/***/ }),
/* 2820 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/sanlam-small.f5577731.png";

/***/ }),
/* 2821 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 2822 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 2823 */
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD//gAfQ29tcHJlc3NlZCBieSBqcGVnLXJlY29tcHJlc3P/2wCEAAwMDAwNDA4QEA4UFRMVFB0bGBgbHSwfIh8iHyxCKTApKTApQjtHOjY6RztpU0lJU2l6ZmFmepOEhJO6sLrz8/8BDAwMDA0MDhAQDhQVExUUHRsYGBsdLB8iHyIfLEIpMCkpMClCO0c6NjpHO2lTSUlTaXpmYWZ6k4SEk7qwuvPz///CABEIAKIBcQMBIgACEQEDEQH/xAAbAAEAAgMBAQAAAAAAAAAAAAAABQcBAwYEAv/aAAgBAQAAAAC1QAAAAAAAAAAAAAAAAAAAABiDiNnSewAAAAAAHP6PuT5btNwAAAAAAcVKQkk9s6AYr/73ynRgAAAHF9Fz0x5PbMgHLwFjiobZ2sA0VXbjGWM4+Mbfj52xUB6/TD9r9gEPV3fdB61NeqyeNheun4aBl+woPtLEp251Q23SvV+3mpCZ56zvND7pvYAEByHOS9sU7bfprjo+kxD+esrpp+5VK3Up23aYuxTVwbay7KbAAD5rDq+CuNXHUz1UdbP0/dNQ3ApW6lO27Td0qcuNW3XTYAAK56Svrg+646mcqC4VLXFUlxKUutTtv0zdKnLjVt102AA8XO/cbF2fysBYPB9TPVr65eubtrX391wuzfAWfS90qduHNbddNgAMDJgZPjORnHi9ucZYZwyAAAANHj9XpDyaJIAAAAADmuh+vL8aPqS5rpPHo9G/R5t+mVyAAAAOdlfDmN37ZiC6TnPZG79cvzXWekAAAAOckIfZ8fP30fOTEX9SnNSufqV3gAAABj4zn553pM4+fr42Yz85zkAAAAAYyAAAAAAAAAAAAAAAAAAAf//EABkBAQEBAQEBAAAAAAAAAAAAAAABAgMEBf/aAAgBAhAAAAAAAAAAADx8PV6QhQAPmc+30QzbmgA8vH1dwSKRqJrNUCAihc1QAGNVjYAAHk3x7Zkr1gAHDHL05ldOgAAAAAAAAP/EABkBAQEAAwEAAAAAAAAAAAAAAAABAgMEBf/aAAgBAxAAAAAAAAAAADt38vKCwAB6uenzQsZRKhR17uXnBQEpKgAoEpKgABnjGeAAAHXhu0Z5JeMAA357uW5ya9YAAAAAAAAP/8QASxAAAgEDAQMGCAoHBAsAAAAAAQIDAAQFEQYQEhMhMTVxshQyQUJRYXORFSIjMEBScnSCsRYgUFNigcIkNENkJTM2REVgcJKTocH/2gAIAQEAAT8A/wCgd9nILYlIxyjj3ChmcrLzxxDT+FCajz91E+k8I7pq0vYLxOKN+0eUfsvOX7W8YijOjvWKw6BFmuF4mPOFNZ25mthAIX4NdeilhhvrSEzIG4owfeKuIZsPeq8ZJQ9Hr9VQTLNCki9DAEfsq+HhGcEbdAdR/LpqTP20UjJyTnhOlZXJRX3JcCMvBr01bZ+3hghjMTngRVq9vYMlj5yikNEVPPWAkLWOh8yQj5p3VFLMQABqTWR2vuXmMGNT1B9NSahxO190nHJfPF6uPSv0e2pH/Fn/APK1WGHzNpcpJdZmWUDzA7EH6ZlNbXLpN5CVb3V4Bj5/lTAjcfPrWetLe2MHJRhNeKrPG2L2sDNbqWaNSazAtrOzMMSBDKegVg4WisEJ88lvmtrrloMSQh0MrhDWxFrC9xc3TjUxBQna36ufuJ0zd2qzOBxjmB9VQHW3h9PJr+W4lR5a5qLr6RQINagb74MMdeuPJA/5Vs3PO+bs1aZyNX5if4Dv4l9I38S+kbuJfSKeaGPnkkRe0gVFcW0p0WdG7GB3NLFENXdVHrOlR3FpKdFuoifQG3ZXHi9g5tBIvOtWGVlsCbe4Q8I961kmtMisTR3cScP1zpT5eys4EjR+VZUCjT1VbwXOXuuVl5ox0n/4KVQoAHQB81tNjTe4mWOLnlQiQCsTl7vD3LSRAHXmdDVntpjZNOXjeI+8Vb5LH3KjkLmN2PoO/aPru9+2KxWNzeSXiiuZI4vrs7VhrGfG2zxSXbTln4ixrbl3jv7UIxUCCsXHmsrpbw3LrEnS3FoBSbGxqPl8lcM3qq0wsFlazxRXEoEnnk6tUux2q8fwrda1f4nPYhTNBfPNEnSQTWzu1Ml4/gl1pyh8Q+RqyvVt77B/ypHdGDIxVvIRzGrDZ/N3SCSa+kgU+lizVBEYYY42cuUUDU+WpZpfhpxyj6eGHy/x79pZpRm7wCRgNU7oqyk0xtkAec28fdq/uJ0yFyVlcaTNpz+usXsu17Ct1kJpCXGoTWrzYyERGSylkSUdGpqDabL2UM1sz8R6AX6UNYnA3OaTwy+uZOAn4vparjYywaP5CWSN/ISasM3kcJem1u3d40bRlJ109a1G6SIrowKsAQR5QaurC1uh8rGCfTT7Nw+bO4qHZ+0jOrs0lJGkahUUADoA+cy+y2Ov2Mykwy+lehqudi8lHqYXSUVc43IWJ1mt5IwPO8lYjaW8sZFSZzLB6D0rUU0U0CSRkMrqGB9RraLry9+2KsYY4LK1iQAKsSH3jdt31lbewrZSFI8LAR0uzsdxIA1NT5/EW50a7TX0L8av0twPAw43JP8ABUDouVjeA6J4T8Ts4qvlAxl6fTbyd2tnIY583YpINV4+6Nd8vXb/AH09/ftP15e9qdwVZMBjbIf5ePu1OgkzLo3Q11of5tQ3bRqq5q9A+uD7xWL4IcVYKvkt4+7u24jC5aIgAcUC1s23FhLEnp4D9CZQwII1B6Qa2txEFhPDNbjSKbXm9YrYyblcQVf/AAZSBW0R1zt77QVbf3aD2a/lu276ytvYVsx1HafjonSstmLvM3gtrcsIS/AiDz6x2yeOto1NwvLSevxa+DccqlUsLcD2a0wC5p1UaAXZ0H46vwFxl793k7tbK9f2Pa3cO+Xrt/vp7+/afry97U7gqyYfBtkP8vF3RT9eH73/AFb9pevL37S90VjOrbH7vH3d23fWsHsK2a6isex+99D22u1ee2tQeePV3rZCE2mHUsNGmcvW0YK5u8J+uKsZkewt2VuYxru286ytvYVsx1Hafjq+jIsLzhGrchJp28NbMMi52xL9HGffpvk68k++N36vYnewu9PLC4HurZp1jztizHzyPep33HyeamL83DeNr/30N20zB87ekfXXuirLVMfaL5wgj7tP14fvf9W/aXry9+0vdFYzq2x+7x93dt31rB7CtmuorHsfvfP3+RtsdBytw2ik6DQa6mjtvjgNBDNR27x56baWr7bdpFKWVrwt0BnrF7PX2SufCL0OsZbVi/jPSqqKqqNABoBW02zzZH+12o0lXmKfWrGZ7J4NPBru2kMIPYVrE5a2yVoZokYAPw6NW3nWVt7CtmOo7T8e7N7L3tndNcWS8cZbiAXpQ1abYTQARX9q/GPOFJtrighHBKPw0JVmy3Kr4r3PEOwtuzmzF3a3Tz2SFo+Li4R4yVZbZSwKkV/avxLUUyywoy6gMoPvranZyczm9tU4uPx0FYfbCGG3W3vlcOg046v9sbCOEi0DSyVhcDd5C7F3eKRFx8Z4umQ7n68P3v8Aq37S9eXv2l7orG9W2X3ePu7tu+tIPYVs11FY9j9759kVhzqD21yMP7tPcK5GH92nuFCOMc6oo7B+qFVRooA7KMcb87KD2ilAUaAaDeyqw+MoNGOI/wCEnuFGODzYlH8t7KrDQgEb5sbj7wcU9nC58hKAmosZjIDxQ2MKN5CF3mKPXXk17dN5iiJ1Ma+6ujc8aN4yKe0UAANANB9NmnhgXilcKPXXwtY/vfcDUF1DcKTG2unT+tNfWsB0klVT6KXKWTEDlf8A0f2NcoJ85FFINUWPXQ0I0A0CigAOgAVPdcgQORkf7I1q2yFtcsURiHHShGho5WLlpYlikdkOh4RUeWtmkEbh42PQHGlE8xrCRpPNdzSDicP0muBfqirq/htiqNqzt0IOc0MqiuqzQyRcR0Bap76KCeGJ9dZOYGp5kgheV/FUamhfwC1W5Y8KEa89fCmicobWYR/W0qXI28VqLjXVD6Kjysc3PFDK49IWlPEinQjUdB+mt/tCnsquIbuRgYrkIPRw61Y3s/hU9rOwYxjUPS5KW5kdbWHjVel2Oi1Nyy5i0MiIrH6tYzrXIdp/OtoUXwNG05xIKhJNshP7sflWz3++e03RANtBLr5sfNWbUHHyeog1eoz4iznHjRKh1rK3InsrWJPGnYVl0CDHweZxgEVd3ltbRHjYa8PMvlNS28sGFPGNOOUMB6BVoipbRKo0AQfTr4S22Tiu+TLx8PC3DQy1iRry1W2lzk70odVeMgNWLuFsUe3uFMbBiQdOY1czxXGXsmiYMBVncw2+UvjK/CCx099ZO5F+sdvbIznjBLac1RpwxIh8igVZSHF3FxFcIwV21Dgc1DKWJIAmqbissv4RIDyUi6cXorKXkV1b8hbtyjuR4tJa/wCjxbOdfkuA+6sUks17Esg5rZWrOW0kqQyIhfk21KirSbEroyqEf+IfGrP/ANw/GtW/+oj+yPp/Jx/UFBFXoAFFVPSNa5NAdQorHKGyt/qAec/nQUDoAG4gHpFCNPIi0VBGhFLFGnioB2DcFUEkADdwLrrwiiAw0I/Ymg/52//EAC0RAAICAQIDBgUFAAAAAAAAAAECAxEAEjEQE0EEICEiQFEUMFBhoSNDUnGB/9oACAECAQE/APpUs0jycqHcbt7YFmMjos7a1rfbIJi5ZHFOu/pohLrnCMA2vxv2xF7T8RKA66qFnI9fxYsgsE8xHe69+8J718JoGLiSJqf8HAva9bERqrNu15BBygbNsdz36wYOuHBwOHpwGHD04Drh+VfE7YM2w4eJw8B1w4Pnl0XwLAYCCLHEyIDWoX6SL946bOs5zkKijRJIqsE8jMF2OuicR31ujUaFg52UDkKfe85khSRwQNJND+sM7ASX/EFf9zmuS4LhdAF/c5HJLI9eC+UE+gEbozFGFE3RGL2cqQwbzWfzjxusiHULZ72+2JGVZmZrLYkTxjSrDT9xhganUN5WNnH7OGaM3WnDD+oXFWfcXgSpGe9wB9X/AP/EACoRAAICAQIEBQQDAAAAAAAAAAECAxEAEjEEEBMhFCBAQVEiMFBhMlKB/9oACAEDAQE/APxUMMSRdaa6P8VHvjPAI0duGXQ9jse4rOIgWPS6G422Pnr78xhEfDmRWZOnQr5yRuE8LCTG+izQvJNHgjpBCmX6QfMNvPWDyAcqysh4hAhilXUnt8jC3B6FUyuyrstZxE5mIoaUXsq+e8OHYYu+HkMHI4MHI7DB9qsOb4N+W+DBzGDkdhg9AscjC1QnCCDRFHmIpCLCMR6SbaAaqHTGdBwxsWAAbuhRwwRKrPuOmGAv91jonTjkUEWSCM4wnxDC9qwRRh4oyCS4BJva8HDqTFX9ir/5nSQLGQhbWTX6AOSxQxpdFjrIBvtQ9AZUdUDqbUVYONxIcFSn0kKN+/bElR45BRpY637748oZERVpVx5Y5DqZDq96OCdbjYodSCh8Gsj4kokq1Zf3+ME9xLG10LqjWGS4lStiTf5f/9k="

/***/ }),
/* 2824 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 2825 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 2826 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/tra.4d44a81c.svg";

/***/ }),
/* 2827 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/turnberry.6ab705f1.png";

/***/ }),
/* 2828 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/zest.02b5675d.jpg";

/***/ }),
/* 2829 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_core__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_CustomCardHeading_CustomCardHeading_jsx__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CompanySpecificQuestions_occupation_questions__ = __webpack_require__(2830);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CompanySpecificQuestions_fmi_jsx__ = __webpack_require__(2831);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__CompanySpecificQuestions_momentum_jsx__ = __webpack_require__(2832);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__CompanySpecificQuestions_sanlam_jsx__ = __webpack_require__(2833);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CompanySpecific=function(_React$Component){_inherits(CompanySpecific,_React$Component);function CompanySpecific(){var _ref;var _temp,_this,_ret;_classCallCheck(this,CompanySpecific);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=CompanySpecific.__proto__||Object.getPrototypeOf(CompanySpecific)).call.apply(_ref,[this].concat(args))),_this),_this.companyComponents=[{id:1,name:'Momentum',component:function component(props){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__CompanySpecificQuestions_momentum_jsx__["a" /* default */],Object.assign({},props,{forceUpdate:function forceUpdate(){return _this.forceUpdate();}}));}},{id:3,name:'Sanlam',logo:'sanlam.png',component:function component(props){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__CompanySpecificQuestions_sanlam_jsx__["a" /* default */],Object.assign({},props,{occupationQuestions:__WEBPACK_IMPORTED_MODULE_3__CompanySpecificQuestions_occupation_questions__["a" /* default */].filter(function(q){return q.oq_targetId==='3'&&q.oq_occupation===_this.getOccupation('sanlam');})}));}},{id:10,name:'Bidvest',component:function component(props){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__CompanySpecificQuestions_fmi_jsx__["a" /* default */],Object.assign({},props,{occupationQuestions:__WEBPACK_IMPORTED_MODULE_3__CompanySpecificQuestions_occupation_questions__["a" /* default */].filter(function(q){return q.oq_targetId==='10'&&q.oq_occupation===_this.getOccupation('fmi');})}));}}],_temp),_possibleConstructorReturn(_this,_ret);}_createClass(CompanySpecific,[{key:'getOccupation',value:function getOccupation(targetName){var occupation=this.props.client[targetName+'Occupation'];if(!occupation)return this.props.client.occupation;return occupation;}},{key:'componentDidMount',value:function componentDidMount(){this.props.scrollMeBar();}},{key:'render',value:function render(){var _this2=this;var filteredCompanies=this.companyComponents.filter(function(c){return _this2.props.selectedTargets.includes(c.id);});return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'contentWithStepper'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["e" /* Card */],{className:this.classes},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["f" /* CardContent */],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_CustomCardHeading_CustomCardHeading_jsx__["a" /* default */],{subheading:'Quote Generation',caption:this.props.clientFullname,headline:'Company Specific Questions'}),filteredCompanies.length<1?__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],null,'There are no Company Specific Questions'):null,filteredCompanies.map(function(company){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["q" /* ExpansionPanel */],{defaultExpanded:true,key:company.id},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["s" /* ExpansionPanelSummary */],{expandIcon:__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["w" /* Icon */],null,'expand_more')},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],null,company.name)),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["r" /* ExpansionPanelDetails */],null,company.component(_this2.props)));}))));}}]);return CompanySpecific;}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);/* unused harmony default export */ var _unused_webpack_default_export = (CompanySpecific);

/***/ }),
/* 2830 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{"oq_Id":1,"oq_targetId":"10","oq_occupation":"Actor","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":631,"oq_targetId":"10","oq_occupation":"Animator","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":2,"oq_targetId":"10","oq_occupation":"Actress","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":3,"oq_targetId":"10","oq_occupation":"Announcer","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":4,"oq_targetId":"10","oq_occupation":"Astrologer","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":5,"oq_targetId":"10","oq_occupation":"Author","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":6,"oq_targetId":"10","oq_occupation":"Biographer","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":7,"oq_targetId":"10","oq_occupation":"Book illustrator","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":8,"oq_targetId":"10","oq_occupation":"Broadcaster","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":9,"oq_targetId":"10","oq_occupation":"Business Owner","oq_questions":"[{\"question\":\"Does your occupation involve performing manual work, or overseeing/managing people performing manual work?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Is working with hand held machinery, tools or equipment a requirement for performing all or part of your occupation?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Is working with heavy machinery, tools or equipment a requirement for performing all or part of your occupation?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Is climbing ladders or installations a requirement for performing all or part of your occupation?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Is holding, restraining or manipulating another person or animal a requirement for performing all or part of your occupation?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Is working with or driving motorised machinery a requirement for performing all or part of your occupation?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Is lifting objects weighing more than 10kg a requirement for performing all or part of your occupation?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Is physical interaction or inspection of a production, manufacturing, construction or similar environment for more than 5 hours per week a requirement for performing all or part of your occupation?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":10,"oq_targetId":"10","oq_occupation":"Cartoon artist","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":11,"oq_targetId":"10","oq_occupation":"Catering staff on oil/gas rig","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":12,"oq_targetId":"10","oq_occupation":"Ceramicist","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":13,"oq_targetId":"10","oq_occupation":"Chemist on oil/gas rigs","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":14,"oq_targetId":"10","oq_occupation":"Chief Executive Officer","oq_questions":"[{\"question\":\"Does your occupation involve performing manual work, or overseeing/managing people performing manual work?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Is working with hand held machinery, tools or equipment a requirement for performing all or part of your occupation?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Is working with heavy machinery, tools or equipment a requirement for performing all or part of your occupation?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Is climbing ladders or installations a requirement for performing all or part of your occupation?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Is holding, restraining or manipulating another person or animal a requirement for performing all or part of your occupation?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Is working with or driving motorised machinery a requirement for performing all or part of your occupation?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Is lifting objects weighing more than 10kg a requirement for performing all or part of your occupation?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Is physical interaction or inspection of a production, manufacturing, construction or similar environment for more than 5 hours per week a requirement for performing all or part of your occupation?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":15,"oq_targetId":"10","oq_occupation":"Child Sport's instructor","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":16,"oq_targetId":"10","oq_occupation":"Comedian","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":17,"oq_targetId":"10","oq_occupation":"Commentator","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":18,"oq_targetId":"10","oq_occupation":"Company Chairman","oq_questions":"[{\"question\":\"Does your occupation involve performing manual work, or overseeing/managing people performing manual work?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Is working with hand held machinery, tools or equipment a requirement for performing all or part of your occupation?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Is working with heavy machinery, tools or equipment a requirement for performing all or part of your occupation?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Is climbing ladders or installations a requirement for performing all or part of your occupation?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Is holding, restraining or manipulating another person or animal a requirement for performing all or part of your occupation?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Is working with or driving motorised machinery a requirement for performing all or part of your occupation?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Is lifting objects weighing more than 10kg a requirement for performing all or part of your occupation?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Is physical interaction or inspection of a production, manufacturing, construction or similar environment for more than 5 hours per week a requirement for performing all or part of your occupation?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":19,"oq_targetId":"10","oq_occupation":"Company Director","oq_questions":"[{\"question\":\"Does your occupation involve performing manual work, or overseeing/managing people performing manual work?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Is working with hand held machinery, tools or equipment a requirement for performing all or part of your occupation?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Is working with heavy machinery, tools or equipment a requirement for performing all or part of your occupation?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Is climbing ladders or installations a requirement for performing all or part of your occupation?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Is holding, restraining or manipulating another person or animal a requirement for performing all or part of your occupation?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Is working with or driving motorised machinery a requirement for performing all or part of your occupation?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Is lifting objects weighing more than 10kg a requirement for performing all or part of your occupation?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Is physical interaction or inspection of a production, manufacturing, construction or similar environment for more than 5 hours per week a requirement for performing all or part of your occupation?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":20,"oq_targetId":"10","oq_occupation":"Company Secretary","oq_questions":"[{\"question\":\"Does your occupation involve performing manual work, or overseeing/managing people performing manual work?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Is working with hand held machinery, tools or equipment a requirement for performing all or part of your occupation?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Is working with heavy machinery, tools or equipment a requirement for performing all or part of your occupation?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Is climbing ladders or installations a requirement for performing all or part of your occupation?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Is holding, restraining or manipulating another person or animal a requirement for performing all or part of your occupation?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Is working with or driving motorised machinery a requirement for performing all or part of your occupation?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Is lifting objects weighing more than 10kg a requirement for performing all or part of your occupation?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Is physical interaction or inspection of a production, manufacturing, construction or similar environment for more than 5 hours per week a requirement for performing all or part of your occupation?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":21,"oq_targetId":"10","oq_occupation":"Composer","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":22,"oq_targetId":"10","oq_occupation":"Conjurer","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":23,"oq_targetId":"10","oq_occupation":"Crane operator on oil/gas rigs","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":24,"oq_targetId":"10","oq_occupation":"Executive Chairman","oq_questions":"[{\"question\":\"Does your occupation involve performing manual work, or overseeing/managing people performing manual work?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Is working with hand held machinery, tools or equipment a requirement for performing all or part of your occupation?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Is working with heavy machinery, tools or equipment a requirement for performing all or part of your occupation?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Is climbing ladders or installations a requirement for performing all or part of your occupation?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Is holding, restraining or manipulating another person or animal a requirement for performing all or part of your occupation?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Is working with or driving motorised machinery a requirement for performing all or part of your occupation?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Is lifting objects weighing more than 10kg a requirement for performing all or part of your occupation?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Is physical interaction or inspection of a production, manufacturing, construction or similar environment for more than 5 hours per week a requirement for performing all or part of your occupation?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":25,"oq_targetId":"10","oq_occupation":"Executive Director","oq_questions":"[{\"question\":\"Does your occupation involve performing manual work, or overseeing/managing people performing manual work?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Is working with hand held machinery, tools or equipment a requirement for performing all or part of your occupation?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Is working with heavy machinery, tools or equipment a requirement for performing all or part of your occupation?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Is climbing ladders or installations a requirement for performing all or part of your occupation?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Is holding, restraining or manipulating another person or animal a requirement for performing all or part of your occupation?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Is working with or driving motorised machinery a requirement for performing all or part of your occupation?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Is lifting objects weighing more than 10kg a requirement for performing all or part of your occupation?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Is physical interaction or inspection of a production, manufacturing, construction or similar environment for more than 5 hours per week a requirement for performing all or part of your occupation?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":26,"oq_targetId":"10","oq_occupation":"Faith healer","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":27,"oq_targetId":"10","oq_occupation":"Fashion model","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":28,"oq_targetId":"10","oq_occupation":"Flight Engineer","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":29,"oq_targetId":"10","oq_occupation":"Floral artist","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":30,"oq_targetId":"10","oq_occupation":"Flower arranger","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":31,"oq_targetId":"10","oq_occupation":"Fortune teller","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":32,"oq_targetId":"10","oq_occupation":"Geologist on oil/gas rigs","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":33,"oq_targetId":"10","oq_occupation":"Geophysicist on oil/gas rig","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":34,"oq_targetId":"10","oq_occupation":"Herbalist","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":35,"oq_targetId":"10","oq_occupation":"Holistic healer","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":36,"oq_targetId":"10","oq_occupation":"Homemaker","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":37,"oq_targetId":"10","oq_occupation":"Illusionist","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":38,"oq_targetId":"10","oq_occupation":"Book illustratorImaam","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":39,"oq_targetId":"10","oq_occupation":"Impersonator","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":40,"oq_targetId":"10","oq_occupation":"Impressionist","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":41,"oq_targetId":"10","oq_occupation":"Interpreter","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":42,"oq_targetId":"10","oq_occupation":"Juggler","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":43,"oq_targetId":"10","oq_occupation":"Landscape painter","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":44,"oq_targetId":"10","oq_occupation":"Male model","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":45,"oq_targetId":"10","oq_occupation":"Managing Member","oq_questions":"[{\"question\":\"Does your occupation involve performing manual work, or overseeing/managing people performing manual work?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Is working with hand held machinery, tools or equipment a requirement for performing all or part of your occupation?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Is working with heavy machinery, tools or equipment a requirement for performing all or part of your occupation?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Is climbing ladders or installations a requirement for performing all or part of your occupation?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Is holding, restraining or manipulating another person or animal a requirement for performing all or part of your occupation?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Is working with or driving motorised machinery a requirement for performing all or part of your occupation?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Is lifting objects weighing more than 10kg a requirement for performing all or part of your occupation?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Is physical interaction or inspection of a production, manufacturing, construction or similar environment for more than 5 hours per week a requirement for performing all or part of your occupation?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":46,"oq_targetId":"10","oq_occupation":"Fashion modelModel Agency Director","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":47,"oq_targetId":"10","oq_occupation":"Music Teacher","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":48,"oq_targetId":"10","oq_occupation":"News commentator","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":49,"oq_targetId":"10","oq_occupation":"Newscaster","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":50,"oq_targetId":"10","oq_occupation":"Newsreader","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":51,"oq_targetId":"10","oq_occupation":"Novelist","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":52,"oq_targetId":"10","oq_occupation":"Palmist","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":53,"oq_targetId":"10","oq_occupation":"Pilot (commercial) - Public passenger","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":54,"oq_targetId":"10","oq_occupation":"Playwright","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":55,"oq_targetId":"10","oq_occupation":"Poet","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":56,"oq_targetId":"10","oq_occupation":"Portrait painter","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":57,"oq_targetId":"10","oq_occupation":"Professional Athlete (track and field)","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":58,"oq_targetId":"10","oq_occupation":"Professional Badminton player","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":59,"oq_targetId":"10","oq_occupation":"Professional Billiards player","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":60,"oq_targetId":"10","oq_occupation":"Professional BMX Cyclist","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":61,"oq_targetId":"10","oq_occupation":"Professional Bowls player","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":62,"oq_targetId":"10","oq_occupation":"Professional Cyclist","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":63,"oq_targetId":"10","oq_occupation":"Professional Darts player","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":64,"oq_targetId":"10","oq_occupation":"Professional engineer on oil/gas rig","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":65,"oq_targetId":"10","oq_occupation":"Professional golfer","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":66,"oq_targetId":"10","oq_occupation":"Professional Ice skater","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":67,"oq_targetId":"10","oq_occupation":"Professional Motorcross cyclist","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":68,"oq_targetId":"10","oq_occupation":"Professional Mountain-Biker","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":69,"oq_targetId":"10","oq_occupation":"Professional Netball player","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":70,"oq_targetId":"10","oq_occupation":"Professional Pool player","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":71,"oq_targetId":"10","oq_occupation":"Professional Rower","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":72,"oq_targetId":"10","oq_occupation":"Professional Runner (Marathon, Tri-athlon)","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":73,"oq_targetId":"10","oq_occupation":"Professional Skateboarder","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":74,"oq_targetId":"10","oq_occupation":"Professional Snooker player","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":75,"oq_targetId":"10","oq_occupation":"Professional Squash player","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":76,"oq_targetId":"10","oq_occupation":"Professional Surfer","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":77,"oq_targetId":"10","oq_occupation":"Professional Swimmer","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":78,"oq_targetId":"10","oq_occupation":"Professional Table tennis player","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":79,"oq_targetId":"10","oq_occupation":"Professional Target shooter","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":80,"oq_targetId":"10","oq_occupation":"Professional Tennis player","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":81,"oq_targetId":"10","oq_occupation":"Professional Waterpolo player","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":82,"oq_targetId":"10","oq_occupation":"Professional Windsurfer","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":83,"oq_targetId":"10","oq_occupation":"Professional Yachtsperson","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":84,"oq_targetId":"10","oq_occupation":"Project Manager","oq_questions":"[{\"question\":\"Does your occupation involve performing manual work, or overseeing/managing people performing manual work?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Is working with hand held machinery, tools or equipment a requirement for performing all or part of your occupation?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Is working with heavy machinery, tools or equipment a requirement for performing all or part of your occupation?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Is climbing ladders or installations a requirement for performing all or part of your occupation?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Is holding, restraining or manipulating another person or animal a requirement for performing all or part of your occupation?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Is working with or driving motorised machinery a requirement for performing all or part of your occupation?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Is lifting objects weighing more than 10kg a requirement for performing all or part of your occupation?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Is physical interaction or inspection of a production, manufacturing, construction or similar environment for more than 5 hours per week a requirement for performing all or part of your occupation?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":85,"oq_targetId":"10","oq_occupation":"Radio announcer","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":86,"oq_targetId":"10","oq_occupation":"Radio presenter","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":87,"oq_targetId":"10","oq_occupation":"Radiographer on oil/gas rig","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":88,"oq_targetId":"10","oq_occupation":"Referee","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":89,"oq_targetId":"10","oq_occupation":"Rig electrician on oil/gas rigs","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":90,"oq_targetId":"10","oq_occupation":"Rig mechanic on oil/gas rig","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":91,"oq_targetId":"10","oq_occupation":"SAPS - Railway Policeman","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":92,"oq_targetId":"10","oq_occupation":"Script writer","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":93,"oq_targetId":"10","oq_occupation":"Songwriter","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":94,"oq_targetId":"10","oq_occupation":"Spiritualist","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":95,"oq_targetId":"10","oq_occupation":"Sports Coach - Athletics (track and Field)","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":96,"oq_targetId":"10","oq_occupation":"Sports Coach - Baseball","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":97,"oq_targetId":"10","oq_occupation":"Sports Coach - Basketball","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":98,"oq_targetId":"10","oq_occupation":"Sports Coach - BMX Cycling","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":99,"oq_targetId":"10","oq_occupation":"Sports Coach - Bowls","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":100,"oq_targetId":"10","oq_occupation":"Sports Coach - Cricket","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":101,"oq_targetId":"10","oq_occupation":"Sports Coach - Cycling","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":102,"oq_targetId":"10","oq_occupation":"Sports Coach - Football","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":103,"oq_targetId":"10","oq_occupation":"Sports Coach - Gymnastics","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":104,"oq_targetId":"10","oq_occupation":"Sports Coach - Hockey","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":105,"oq_targetId":"10","oq_occupation":"Sports Coach - Ice skating","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":106,"oq_targetId":"10","oq_occupation":"Sports Coach - Mountain-Biking","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":107,"oq_targetId":"10","oq_occupation":"Sports Coach - Netball","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":108,"oq_targetId":"10","oq_occupation":"Sports Coach - Rowing","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":109,"oq_targetId":"10","oq_occupation":"Sports Coach - Rugby","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":110,"oq_targetId":"10","oq_occupation":"Sports Coach - Running (Marathon, Tri-athlon)","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":111,"oq_targetId":"10","oq_occupation":"Sports Coach - Skateboarding","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":112,"oq_targetId":"10","oq_occupation":"Sports Coach - Squash","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":113,"oq_targetId":"10","oq_occupation":"Sports Coach - Surfing","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":114,"oq_targetId":"10","oq_occupation":"Sports Coach - Swimming","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":115,"oq_targetId":"10","oq_occupation":"Sports Coach - Target shooting","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":116,"oq_targetId":"10","oq_occupation":"Sports Coach - Tennis","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":117,"oq_targetId":"10","oq_occupation":"Sports Coach - Waterpolo","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":118,"oq_targetId":"10","oq_occupation":"Sports Coach - Windsurfing","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":119,"oq_targetId":"10","oq_occupation":"Sports Coach - Yachting","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":120,"oq_targetId":"10","oq_occupation":"Sports Martial arts instructor (Non contact or competition)","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":121,"oq_targetId":"10","oq_occupation":"Storekeeper on oil/gas rig","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":122,"oq_targetId":"10","oq_occupation":"Student - High School","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":123,"oq_targetId":"10","oq_occupation":"Student of tertiary education (full time)","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":124,"oq_targetId":"10","oq_occupation":"Technical artist","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":125,"oq_targetId":"10","oq_occupation":"Technical illustrator","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":126,"oq_targetId":"10","oq_occupation":"Television presenter","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":127,"oq_targetId":"10","oq_occupation":"Theatrical Agent","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":128,"oq_targetId":"10","oq_occupation":"Tv announcer","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":129,"oq_targetId":"10","oq_occupation":"Umpire","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":130,"oq_targetId":"10","oq_occupation":"Ventriloquist","oq_questions":"[{\"question\":\"Does your occupation require you to operate any equipment or handle and manipulate tools or instruments?This includes anything from large industrial tools e.g. a drill or jackhammer to small handheld instruments such as tweezers and needles. (Computers, calculators, writing equipment and stationary do not qualify as equipment, tools or instruments)\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to operate a vehicle to transport passengers or goods?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"},{\"question\":\"Does your occupation require you to run, jump, or regularly lift objects heavier than 5 kilograms?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":261,"oq_targetId":"3","oq_occupation":"Accountant","oq_questions":"[{\"question\":\"Did you successfully complete the SAIPA Professional Evaluation(PE)?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":262,"oq_targetId":"3","oq_occupation":"Accounting Official","oq_questions":"[{\"question\":\"Did you successfully complete the SAIPA Professional Evaluation(PE)?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":263,"oq_targetId":"3","oq_occupation":"Actor \\ Actress","oq_questions":"[{\"question\":\"Are you required to, or do you perform any stunts during the course of your acting duties?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":272,"oq_targetId":"3","oq_occupation":"Air Host \\ Hostess","oq_questions":"[{\"question\":\"For which airline do you work as part of a crew?\",\"answers\":[\"1 eskader (scheduled)\",\"1time\",\"Air Afrique\",\"Air Austral\",\"Air Botswana\",\"Air France\",\"Air Gabon (aviation gsa)\",\"Air Madagascar(travel directions (pty) ltd)\",\"Air Malawi\",\"Air Mauritius\",\"Air Namibia (Pty) Ltd\",\"Air Portugal - tap\",\"Air Quarius contracts (pty) ltd\",\"Air Seychelles\",\"Air Tanzania corporation\",\"Air Zimbabwe\",\"Alitalia\",\"Alliance Express\",\"Angola Airlines (TAAG)\",\"Austrian Airlines\",\"Auto Spares\",\"Automal Pty Ltd\",\"Automall\",\"British Airways plc\",\"Cameroon Airlines\",\"Cargolux\",\"Cathay Pacific Airways Ltd\",\"Comair\",\"East African Airlines\",\"Egyptair\",\"El Al Israel Airlines\",\"Emirates\",\"Ethiopean Airlines\",\"Executive Aerospace\",\"Federal Air\",\"Ghana Airways Corporation\",\"Hydro Air\",\"Hewa Bora Airways\",\"Iberia Airlines of Spain\",\"Inter Air\",\"Interlink Airlines\",\"K.L.M\",\"Kenya Airways\",\"Khalifa Airways\",\"Kulula.com\",\"Lam-linhas Aereas De Mocambiqu\",\"Lufthansa German Airlines\",\"Malaysian Airlines\",\"Mango\",\"Martinair Holland\",\"Mrs Vliegdienste\",\"Nationwide\",\"Ncd and Partners\",\"Nel Air\",\"Olympic Airways\",\"Pelican Air Services\",\"Precision Air\",\"Quantas Airways Ltd\",\"Qatar Airways\",\"Regional Air\",\"Royal Air Maroc\",\"Rwandair Express\",\"S.A. Express\",\"SA Airlink\",\"Sabena Belgian World Airlines\",\"Safair\",\"Saudi Arabian Airlines\",\"Singapore Airlines\",\"Sobelair\",\"South African Airways\",\"Strato Air Services\",\"Swiss International Air lines (LX)\",\"Trans Air Congo\",\"TTA\",\"Turkish Airlines\",\"Varig\",\"Virgin Atlantic Airways Ltd\",\"Yemen Airways\",\"None of the above\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":273,"oq_targetId":"3","oq_occupation":"Aircraft : Crew Members Commercial Airlines","oq_questions":"[{\"question\":\"For which airline do you work as part of a crew?\",\"answers\":[\"1 eskader (scheduled)\",\"1time\",\"Air Afrique\",\"Air Austral\",\"Air Botswana\",\"Air France\",\"Air Gabon (aviation gsa)\",\"Air Madagascar(travel directions (pty) ltd)\",\"Air Malawi\",\"Air Mauritius\",\"Air Namibia (Pty) Ltd\",\"Air Portugal - tap\",\"Air Quarius contracts (pty) ltd\",\"Air Seychelles\",\"Air Tanzania corporation\",\"Air Zimbabwe\",\"Alitalia\",\"Alliance Express\",\"Angola Airlines (TAAG)\",\"Austrian Airlines\",\"Auto Spares\",\"Automal Pty Ltd\",\"Automall\",\"British Airways plc\",\"Cameroon Airlines\",\"Cargolux\",\"Cathay Pacific Airways Ltd\",\"Comair\",\"East African Airlines\",\"Egyptair\",\"El Al Israel Airlines\",\"Emirates\",\"Ethiopean Airlines\",\"Executive Aerospace\",\"Federal Air\",\"Ghana Airways Corporation\",\"Hydro Air\",\"Hewa Bora Airways\",\"Iberia Airlines of Spain\",\"Inter Air\",\"Interlink Airlines\",\"K.L.M\",\"Kenya Airways\",\"Khalifa Airways\",\"Kulula.com\",\"Lam-linhas Aereas De Mocambiqu\",\"Lufthansa German Airlines\",\"Malaysian Airlines\",\"Mango\",\"Martinair Holland\",\"Mrs Vliegdienste\",\"Nationwide\",\"Ncd and Partners\",\"Nel Air\",\"Olympic Airways\",\"Pelican Air Services\",\"Precision Air\",\"Quantas Airways Ltd\",\"Qatar Airways\",\"Regional Air\",\"Royal Air Maroc\",\"Rwandair Express\",\"S.A. Express\",\"SA Airlink\",\"Sabena Belgian World Airlines\",\"Safair\",\"Saudi Arabian Airlines\",\"Singapore Airlines\",\"Sobelair\",\"South African Airways\",\"Strato Air Services\",\"Swiss International Air lines (LX)\",\"Trans Air Congo\",\"TTA\",\"Turkish Airlines\",\"Varig\",\"Virgin Atlantic Airways Ltd\",\"Yemen Airways\",\"None of the above\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":274,"oq_targetId":"3","oq_occupation":"Aircraft Fitter","oq_questions":"[{\"question\":\"Are you involved in any type of aviation or flying in your normal occupation?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":275,"oq_targetId":"3","oq_occupation":"Aircraft Joiner","oq_questions":"[{\"question\":\"Are you involved in any type of aviation or flying in your normal occupation?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":276,"oq_targetId":"3","oq_occupation":"Aircraft Maintenance Technician","oq_questions":"[{\"question\":\"Are you involved in any type of aviation or flying in your normal occupation?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":280,"oq_targetId":"3","oq_occupation":"Antiques Dealer","oq_questions":"[{\"question\":\"Do you perform any restoration work?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":282,"oq_targetId":"3","oq_occupation":"Armed Guard","oq_questions":"[{\"question\":\"Are you required to carry a firearm, handle cash or work in a bank as part of your occupational duties?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":283,"oq_targetId":"3","oq_occupation":"Armed Response Officer","oq_questions":"[{\"question\":\"Are you required to carry a firearm, handle cash or work in a bank as part of your occupational duties?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":284,"oq_targetId":"3","oq_occupation":"Audit Clerk","oq_questions":"[{\"question\":\"Did you successfully complete any of the following certifications of The Institute of Internal Auditors (IIA): Certified Internal Auditor (CIA), Control self-assessment (CSA), Certified Government Auditing Professional® (CGAP®) or Certified Financial Services Auditor (CFSA)?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":285,"oq_targetId":"3","oq_occupation":"Audit Manager","oq_questions":"[{\"question\":\"Did you successfully complete any of the following certifications of The Institute of Internal Auditors (IIA): Certified Internal Auditor (CIA), Control self-assessment (CSA), Certified Government Auditing Professional® (CGAP®) or Certified Financial Services Auditor (CFSA)?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":286,"oq_targetId":"3","oq_occupation":"Auditor","oq_questions":"[{\"question\":\"Did you successfully complete any of the following certifications of The Institute of Internal Auditors (IIA): Certified Internal Auditor (CIA), Control self-assessment (CSA), Certified Government Auditing Professional® (CGAP®) or Certified Financial Services Auditor (CFSA)?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":288,"oq_targetId":"3","oq_occupation":"Aviation : Cabin Crew (Commercial \\ Private Airline)","oq_questions":"[{\"question\":\"For which airline do you work as part of a crew?\",\"answers\":[\"1 eskader (scheduled)\",\"1time\",\"Air Afrique\",\"Air Austral\",\"Air Botswana\",\"Air France\",\"Air Gabon (aviation gsa)\",\"Air Madagascar(travel directions (pty) ltd)\",\"Air Malawi\",\"Air Mauritius\",\"Air Namibia (Pty) Ltd\",\"Air Portugal - tap\",\"Air Quarius contracts (pty) ltd\",\"Air Seychelles\",\"Air Tanzania corporation\",\"Air Zimbabwe\",\"Alitalia\",\"Alliance Express\",\"Angola Airlines (TAAG)\",\"Austrian Airlines\",\"Auto Spares\",\"Automal Pty Ltd\",\"Automall\",\"British Airways plc\",\"Cameroon Airlines\",\"Cargolux\",\"Cathay Pacific Airways Ltd\",\"Comair\",\"East African Airlines\",\"Egyptair\",\"El Al Israel Airlines\",\"Emirates\",\"Ethiopean Airlines\",\"Executive Aerospace\",\"Federal Air\",\"Ghana Airways Corporation\",\"Hydro Air\",\"Hewa Bora Airways\",\"Iberia Airlines of Spain\",\"Inter Air\",\"Interlink Airlines\",\"K.L.M\",\"Kenya Airways\",\"Khalifa Airways\",\"Kulula.com\",\"Lam-linhas Aereas De Mocambiqu\",\"Lufthansa German Airlines\",\"Malaysian Airlines\",\"Mango\",\"Martinair Holland\",\"Mrs Vliegdienste\",\"Nationwide\",\"Ncd and Partners\",\"Nel Air\",\"Olympic Airways\",\"Pelican Air Services\",\"Precision Air\",\"Quantas Airways Ltd\",\"Qatar Airways\",\"Regional Air\",\"Royal Air Maroc\",\"Rwandair Express\",\"S.A. Express\",\"SA Airlink\",\"Sabena Belgian World Airlines\",\"Safair\",\"Saudi Arabian Airlines\",\"Singapore Airlines\",\"Sobelair\",\"South African Airways\",\"Strato Air Services\",\"Swiss International Air lines (LX)\",\"Trans Air Congo\",\"TTA\",\"Turkish Airlines\",\"Varig\",\"Virgin Atlantic Airways Ltd\",\"Yemen Airways\",\"None of the above\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":289,"oq_targetId":"3","oq_occupation":"Aviation : Commercial Instructor","oq_questions":"[{\"question\":\"Do you ONLY participate in standard flights between registered airports?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":290,"oq_targetId":"3","oq_occupation":"Aviation : Engineer (Commercial \\ Private)","oq_questions":"[{\"question\":\"For which airline do you work as part of a crew?\",\"answers\":[\"1 eskader (scheduled)\",\"1time\",\"Air Afrique\",\"Air Austral\",\"Air Botswana\",\"Air France\",\"Air Gabon (aviation gsa)\",\"Air Madagascar(travel directions (pty) ltd)\",\"Air Malawi\",\"Air Mauritius\",\"Air Namibia (Pty) Ltd\",\"Air Portugal - tap\",\"Air Quarius contracts (pty) ltd\",\"Air Seychelles\",\"Air Tanzania corporation\",\"Air Zimbabwe\",\"Alitalia\",\"Alliance Express\",\"Angola Airlines (TAAG)\",\"Austrian Airlines\",\"Auto Spares\",\"Automal Pty Ltd\",\"Automall\",\"British Airways plc\",\"Cameroon Airlines\",\"Cargolux\",\"Cathay Pacific Airways Ltd\",\"Comair\",\"East African Airlines\",\"Egyptair\",\"El Al Israel Airlines\",\"Emirates\",\"Ethiopean Airlines\",\"Executive Aerospace\",\"Federal Air\",\"Ghana Airways Corporation\",\"Hydro Air\",\"Hewa Bora Airways\",\"Iberia Airlines of Spain\",\"Inter Air\",\"Interlink Airlines\",\"K.L.M\",\"Kenya Airways\",\"Khalifa Airways\",\"Kulula.com\",\"Lam-linhas Aereas De Mocambiqu\",\"Lufthansa German Airlines\",\"Malaysian Airlines\",\"Mango\",\"Martinair Holland\",\"Mrs Vliegdienste\",\"Nationwide\",\"Ncd and Partners\",\"Nel Air\",\"Olympic Airways\",\"Pelican Air Services\",\"Precision Air\",\"Quantas Airways Ltd\",\"Qatar Airways\",\"Regional Air\",\"Royal Air Maroc\",\"Rwandair Express\",\"S.A. Express\",\"SA Airlink\",\"Sabena Belgian World Airlines\",\"Safair\",\"Saudi Arabian Airlines\",\"Singapore Airlines\",\"Sobelair\",\"South African Airways\",\"Strato Air Services\",\"Swiss International Air lines (LX)\",\"Trans Air Congo\",\"TTA\",\"Turkish Airlines\",\"Varig\",\"Virgin Atlantic Airways Ltd\",\"Yemen Airways\",\"None of the above\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":291,"oq_targetId":"3","oq_occupation":"Aviation : Pilot (Commercial \\ Private)","oq_questions":"[{\"question\":\"Do you ONLY participate in standard flights between registered airports?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":294,"oq_targetId":"3","oq_occupation":"Bank Security Guard","oq_questions":"[{\"question\":\"Are you required to carry a firearm, handle cash or work in a bank as part of your occupational duties?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":297,"oq_targetId":"3","oq_occupation":"Chief Executive Officer Of Company","oq_questions":"[{\"question\":\"Which industry/business are you involved in?\",\"answers\":[\"Debt collecting business\",\"Mining industry\",\"Micro lending business\",\"Security business\",\"Shebeen business\",\"Taxi industry\",\"Not one of the above\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":298,"oq_targetId":"3","oq_occupation":"Chief Shunter","oq_questions":"[{\"question\":\"Are you qualified as a leader or higher?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":302,"oq_targetId":"3","oq_occupation":"City Treasurer","oq_questions":"[{\"question\":\"Did you successfully complete the SAIPA Professional Evaluation(PE)?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":309,"oq_targetId":"3","oq_occupation":"Columnist","oq_questions":"[{\"question\":\"Is it expected of you to visit conflict areas outside the RSA borders, as a result of your responsibilities?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":310,"oq_targetId":"3","oq_occupation":"Commercial Diver","oq_questions":"[{\"question\":\"The system is about to ask you a number of questions and is likely to reach a decision. Should you not answer the questions now, the case will be referred to underwriting with further requirements. Do you wish to continue?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":311,"oq_targetId":"3","oq_occupation":"Commercial Pilot","oq_questions":"[{\"question\":\"Do you ONLY participate in standard flights between registered airports?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":317,"oq_targetId":"3","oq_occupation":"Driving School Instructor \\ Owner","oq_questions":"[{\"question\":\"Are you personally involved in the physical operations of the business?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":320,"oq_targetId":"3","oq_occupation":"Electrician (< 1000 Volts)","oq_questions":"[{\"question\":\"Do you ever work with current exceeding normal domestic voltages?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":321,"oq_targetId":"3","oq_occupation":"Electrician (> 10000 Volts)","oq_questions":"[{\"question\":\"Do you work in the mining industry?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":322,"oq_targetId":"3","oq_occupation":"Electrician (Between 1000 And 10000 Volts)","oq_questions":"[{\"question\":\"Do you ever work on overhead high tension cables or pylons?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":323,"oq_targetId":"3","oq_occupation":"Electrician Contractor","oq_questions":"[{\"question\":\"Are you personally involved in the physical operations of the business?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":324,"oq_targetId":"3","oq_occupation":"Electricians Handyman","oq_questions":"[{\"question\":\"Do you ever work on overhead high tension cables or pylons?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":328,"oq_targetId":"3","oq_occupation":"Engine-Driver \\ Operator","oq_questions":"[{\"question\":\"Do you ever have to spend time in a mine beneath the surface?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":329,"oq_targetId":"3","oq_occupation":"Engineer : Marine","oq_questions":"[{\"question\":\"Do you dive as part of your occupational duties?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":330,"oq_targetId":"3","oq_occupation":"Expedition Guide","oq_questions":"[{\"question\":\"Does your occupation require you to perform duties outside the borders of South Africa?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":336,"oq_targetId":"3","oq_occupation":"Farm Manager","oq_questions":"[{\"question\":\"Does your participation in the physical activities on the farm, including the operation or driving of agricultural implements, or the handling of livestock, but excluding the driving of light delivery vehicles, on average exceed half a day’s work per week?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":337,"oq_targetId":"3","oq_occupation":"Farmer","oq_questions":"[{\"question\":\"Does your participation in the physical activities on the farm, including the operation or driving of agricultural implements, or the handling of livestock, but excluding the driving of light delivery vehicles, on average exceed half a day’s work per week?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":338,"oq_targetId":"3","oq_occupation":"Fitter","oq_questions":"[{\"question\":\"Do you work in the mining industry?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":339,"oq_targetId":"3","oq_occupation":"Fitter And Turner","oq_questions":"[{\"question\":\"Do you work in the mining industry?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":340,"oq_targetId":"3","oq_occupation":"Flight Engineer (Commercial \\ Private Airline)","oq_questions":"[{\"question\":\"For which airline do you work as part of a crew?\",\"answers\":[\"1 eskader (scheduled)\",\"1time\",\"Air Afrique\",\"Air Austral\",\"Air Botswana\",\"Air France\",\"Air Gabon (aviation gsa)\",\"Air Madagascar(travel directions (pty) ltd)\",\"Air Malawi\",\"Air Mauritius\",\"Air Namibia (Pty) Ltd\",\"Air Portugal - tap\",\"Air Quarius contracts (pty) ltd\",\"Air Seychelles\",\"Air Tanzania corporation\",\"Air Zimbabwe\",\"Alitalia\",\"Alliance Express\",\"Angola Airlines (TAAG)\",\"Austrian Airlines\",\"Auto Spares\",\"Automal Pty Ltd\",\"Automall\",\"British Airways plc\",\"Cameroon Airlines\",\"Cargolux\",\"Cathay Pacific Airways Ltd\",\"Comair\",\"East African Airlines\",\"Egyptair\",\"El Al Israel Airlines\",\"Emirates\",\"Ethiopean Airlines\",\"Executive Aerospace\",\"Federal Air\",\"Ghana Airways Corporation\",\"Hydro Air\",\"Hewa Bora Airways\",\"Iberia Airlines of Spain\",\"Inter Air\",\"Interlink Airlines\",\"K.L.M\",\"Kenya Airways\",\"Khalifa Airways\",\"Kulula.com\",\"Lam-linhas Aereas De Mocambiqu\",\"Lufthansa German Airlines\",\"Malaysian Airlines\",\"Mango\",\"Martinair Holland\",\"Mrs Vliegdienste\",\"Nationwide\",\"Ncd and Partners\",\"Nel Air\",\"Olympic Airways\",\"Pelican Air Services\",\"Precision Air\",\"Quantas Airways Ltd\",\"Qatar Airways\",\"Regional Air\",\"Royal Air Maroc\",\"Rwandair Express\",\"S.A. Express\",\"SA Airlink\",\"Sabena Belgian World Airlines\",\"Safair\",\"Saudi Arabian Airlines\",\"Singapore Airlines\",\"Sobelair\",\"South African Airways\",\"Strato Air Services\",\"Swiss International Air lines (LX)\",\"Trans Air Congo\",\"TTA\",\"Turkish Airlines\",\"Varig\",\"Virgin Atlantic Airways Ltd\",\"Yemen Airways\",\"None of the above\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":341,"oq_targetId":"3","oq_occupation":"Flight Navigator (Commercial \\ Private Airline)","oq_questions":"[{\"question\":\"For which airline do you work as part of a crew?\",\"answers\":[\"1 eskader (scheduled)\",\"1time\",\"Air Afrique\",\"Air Austral\",\"Air Botswana\",\"Air France\",\"Air Gabon (aviation gsa)\",\"Air Madagascar(travel directions (pty) ltd)\",\"Air Malawi\",\"Air Mauritius\",\"Air Namibia (Pty) Ltd\",\"Air Portugal - tap\",\"Air Quarius contracts (pty) ltd\",\"Air Seychelles\",\"Air Tanzania corporation\",\"Air Zimbabwe\",\"Alitalia\",\"Alliance Express\",\"Angola Airlines (TAAG)\",\"Austrian Airlines\",\"Auto Spares\",\"Automal Pty Ltd\",\"Automall\",\"British Airways plc\",\"Cameroon Airlines\",\"Cargolux\",\"Cathay Pacific Airways Ltd\",\"Comair\",\"East African Airlines\",\"Egyptair\",\"El Al Israel Airlines\",\"Emirates\",\"Ethiopean Airlines\",\"Executive Aerospace\",\"Federal Air\",\"Ghana Airways Corporation\",\"Hydro Air\",\"Hewa Bora Airways\",\"Iberia Airlines of Spain\",\"Inter Air\",\"Interlink Airlines\",\"K.L.M\",\"Kenya Airways\",\"Khalifa Airways\",\"Kulula.com\",\"Lam-linhas Aereas De Mocambiqu\",\"Lufthansa German Airlines\",\"Malaysian Airlines\",\"Mango\",\"Martinair Holland\",\"Mrs Vliegdienste\",\"Nationwide\",\"Ncd and Partners\",\"Nel Air\",\"Olympic Airways\",\"Pelican Air Services\",\"Precision Air\",\"Quantas Airways Ltd\",\"Qatar Airways\",\"Regional Air\",\"Royal Air Maroc\",\"Rwandair Express\",\"S.A. Express\",\"SA Airlink\",\"Sabena Belgian World Airlines\",\"Safair\",\"Saudi Arabian Airlines\",\"Singapore Airlines\",\"Sobelair\",\"South African Airways\",\"Strato Air Services\",\"Swiss International Air lines (LX)\",\"Trans Air Congo\",\"TTA\",\"Turkish Airlines\",\"Varig\",\"Virgin Atlantic Airways Ltd\",\"Yemen Airways\",\"None of the above\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":344,"oq_targetId":"3","oq_occupation":"Foreign Correspondent \\ Columnist \\ Reporter","oq_questions":"[{\"question\":\"Is it expected of you to visit conflict areas outside the RSA borders, as a result of your responsibilities?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":351,"oq_targetId":"3","oq_occupation":"Hawks : All Other Ranks Lower Than Officer","oq_questions":"[{\"question\":\"What rank do you currently hold?\",\"answers\":[\"Constable\",\"Sergeant\",\"Warrant Officer\",\"Lieutenant\",\"Captain\",\"Lieutenant Colonel\",\"Colonel\",\"Brigadier\",\"Major General\",\"Lieutenant General\",\"General\",\"Administrative only personnel\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":352,"oq_targetId":"3","oq_occupation":"Hawks : Officer","oq_questions":"[{\"question\":\"What rank do you currently hold?\",\"answers\":[\"Constable\",\"Sergeant\",\"Warrant Officer\",\"Lieutenant\",\"Captain\",\"Lieutenant Colonel\",\"Colonel\",\"Brigadier\",\"Major General\",\"Lieutenant General\",\"General\",\"Administrative only personnel\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":353,"oq_targetId":"3","oq_occupation":"Helicopter Crew (Commercial \\ Private)","oq_questions":"[{\"question\":\"For which airline do you work as part of a crew?\",\"answers\":[\"1 eskader (scheduled)\",\"1time\",\"Air Afrique\",\"Air Austral\",\"Air Botswana\",\"Air France\",\"Air Gabon (aviation gsa)\",\"Air Madagascar(travel directions (pty) ltd)\",\"Air Malawi\",\"Air Mauritius\",\"Air Namibia (Pty) Ltd\",\"Air Portugal - tap\",\"Air Quarius contracts (pty) ltd\",\"Air Seychelles\",\"Air Tanzania corporation\",\"Air Zimbabwe\",\"Alitalia\",\"Alliance Express\",\"Angola Airlines (TAAG)\",\"Austrian Airlines\",\"Auto Spares\",\"Automal Pty Ltd\",\"Automall\",\"British Airways plc\",\"Cameroon Airlines\",\"Cargolux\",\"Cathay Pacific Airways Ltd\",\"Comair\",\"East African Airlines\",\"Egyptair\",\"El Al Israel Airlines\",\"Emirates\",\"Ethiopean Airlines\",\"Executive Aerospace\",\"Federal Air\",\"Ghana Airways Corporation\",\"Hydro Air\",\"Hewa Bora Airways\",\"Iberia Airlines of Spain\",\"Inter Air\",\"Interlink Airlines\",\"K.L.M\",\"Kenya Airways\",\"Khalifa Airways\",\"Kulula.com\",\"Lam-linhas Aereas De Mocambiqu\",\"Lufthansa German Airlines\",\"Malaysian Airlines\",\"Mango\",\"Martinair Holland\",\"Mrs Vliegdienste\",\"Nationwide\",\"Ncd and Partners\",\"Nel Air\",\"Olympic Airways\",\"Pelican Air Services\",\"Precision Air\",\"Quantas Airways Ltd\",\"Qatar Airways\",\"Regional Air\",\"Royal Air Maroc\",\"Rwandair Express\",\"S.A. Express\",\"SA Airlink\",\"Sabena Belgian World Airlines\",\"Safair\",\"Saudi Arabian Airlines\",\"Singapore Airlines\",\"Sobelair\",\"South African Airways\",\"Strato Air Services\",\"Swiss International Air lines (LX)\",\"Trans Air Congo\",\"TTA\",\"Turkish Airlines\",\"Varig\",\"Virgin Atlantic Airways Ltd\",\"Yemen Airways\",\"None of the above\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":355,"oq_targetId":"3","oq_occupation":"Homeopath","oq_questions":"[{\"question\":\"Are you a registered member of the Allied Health Professions Council of South Africa (AHPCSA)?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":361,"oq_targetId":"3","oq_occupation":"Hydrologist","oq_questions":"[{\"question\":\"Do you dive as part of your occupational duties?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":366,"oq_targetId":"3","oq_occupation":"Inspector Of Mines","oq_questions":"[{\"question\":\"Are you working in an open cast mine only?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":371,"oq_targetId":"3","oq_occupation":"Joiner","oq_questions":"[{\"question\":\"Do you work in the mining industry?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":372,"oq_targetId":"3","oq_occupation":"Journalist","oq_questions":"[{\"question\":\"Is it expected of you to visit conflict areas outside the RSA borders, as a result of your responsibilities?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":373,"oq_targetId":"3","oq_occupation":"Journalist - Tv \\ Media","oq_questions":"[{\"question\":\"Is it expected of you to visit conflict areas outside the RSA borders, as a result of your responsibilities?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":374,"oq_targetId":"3","oq_occupation":"Journalist : Free-Lance","oq_questions":"[{\"question\":\"Is it expected of you to visit conflict areas outside the RSA borders, as a result of your responsibilities?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":382,"oq_targetId":"3","oq_occupation":"Lineworker Electrician","oq_questions":"[{\"question\":\"Do you ever work on overhead high tension cables or pylons?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":384,"oq_targetId":"3","oq_occupation":"Loan Shark","oq_questions":"[{\"question\":\"Is your business registered with the MFRC (Micro Finance Regulatory Council) AND are you a member of MFSA (MicroFinance South Africa)?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":385,"oq_targetId":"3","oq_occupation":"Machine Operator \\ Supervisor","oq_questions":"[{\"question\":\"Do you ever have to spend time in a mine beneath the surface?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":386,"oq_targetId":"3","oq_occupation":"Machine Tool Setter","oq_questions":"[{\"question\":\"Do you work in the mining industry?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":388,"oq_targetId":"3","oq_occupation":"Managing Director Of Company","oq_questions":"[{\"question\":\"Which industry/business are you involved in?\",\"answers\":[\"Debt collecting business\",\"Mining industry\",\"Micro lending business\",\"Security business\",\"Shebeen business\",\"Taxi industry\",\"Not one of the above\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":389,"oq_targetId":"3","oq_occupation":"Marine Biologist","oq_questions":"[{\"question\":\"Do you dive as part of your occupational duties?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":390,"oq_targetId":"3","oq_occupation":"Marine Engineer","oq_questions":"[{\"question\":\"Do you dive as part of your occupational duties?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":391,"oq_targetId":"3","oq_occupation":"Marine Geologist","oq_questions":"[{\"question\":\"Do you dive as part of your occupational duties?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":392,"oq_targetId":"3","oq_occupation":"Masseuse \\ Masseur","oq_questions":"[{\"question\":\"Are you a registered member of the Allied Health Professions Council of South Africa (AHPCSA)?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":396,"oq_targetId":"3","oq_occupation":"Messenger (Office)","oq_questions":"[{\"question\":\"Do you use a motorcycle to perform your daily duties.\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":397,"oq_targetId":"3","oq_occupation":"Micro Lender","oq_questions":"[{\"question\":\"Is your business registered with the MFRC (Micro Finance Regulatory Council) AND are you a member of MFSA (MicroFinance South Africa)?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":398,"oq_targetId":"3","oq_occupation":"Micro Lender Employee","oq_questions":"[{\"question\":\"Is the business registered with the MFRC (Micro Finance Regulatory Council) AND is the owner a member of MFSA (MicroFinance South Africa)?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":399,"oq_targetId":"3","oq_occupation":"Military Adviser","oq_questions":"[{\"question\":\"Are you a member of the Special Forces and/or Reconnaissance Commando?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":402,"oq_targetId":"3","oq_occupation":"Mining : Banksman","oq_questions":"[{\"question\":\"Are you working in an open cast mine only?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":403,"oq_targetId":"3","oq_occupation":"Mining : Boilermaker","oq_questions":"[{\"question\":\"Are you working in an open cast mine only?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":404,"oq_targetId":"3","oq_occupation":"Mining : Construction Carpenter","oq_questions":"[{\"question\":\"Are you working in an open cast mine only?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":405,"oq_targetId":"3","oq_occupation":"Mining : Diesel Fitter","oq_questions":"[{\"question\":\"Are you working in an open cast mine only?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":406,"oq_targetId":"3","oq_occupation":"Mining : Diesel Mechanic","oq_questions":"[{\"question\":\"Are you working in an open cast mine only?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":407,"oq_targetId":"3","oq_occupation":"Mining : Electrician","oq_questions":"[{\"question\":\"Are you working in an open cast mine only?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":408,"oq_targetId":"3","oq_occupation":"Mining : Engineer","oq_questions":"[{\"question\":\"Are you working in an open cast mine only?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":409,"oq_targetId":"3","oq_occupation":"Mining : Fitter","oq_questions":"[{\"question\":\"Are you working in an open cast mine only?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":410,"oq_targetId":"3","oq_occupation":"Mining : Handyman Underground","oq_questions":"[{\"question\":\"Are you working in an open cast mine only?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":411,"oq_targetId":"3","oq_occupation":"Mining : Mason (Underground)","oq_questions":"[{\"question\":\"Are you working in an open cast mine only?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":412,"oq_targetId":"3","oq_occupation":"Mining : Master Shaft-Sinker","oq_questions":"[{\"question\":\"Are you working in an open cast mine only?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":414,"oq_targetId":"3","oq_occupation":"Mining : Mine Inspector","oq_questions":"[{\"question\":\"Are you working in an open cast mine only?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":416,"oq_targetId":"3","oq_occupation":"Mining : Pipeman","oq_questions":"[{\"question\":\"Are you working in an open cast mine only?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":417,"oq_targetId":"3","oq_occupation":"Mining : Plate Layer","oq_questions":"[{\"question\":\"Are you working in an open cast mine only?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":418,"oq_targetId":"3","oq_occupation":"Mining : Pumpsman","oq_questions":"[{\"question\":\"Are you working in an open cast mine only?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":419,"oq_targetId":"3","oq_occupation":"Mining : Sampler","oq_questions":"[{\"question\":\"Are you working in an open cast mine only?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":420,"oq_targetId":"3","oq_occupation":"Mining : Shaft-Foreman","oq_questions":"[{\"question\":\"Are you working in an open cast mine only?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":422,"oq_targetId":"3","oq_occupation":"Mining : Skip Man","oq_questions":"[{\"question\":\"Are you working in an open cast mine only?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":424,"oq_targetId":"3","oq_occupation":"Mining : Surveyor Underground","oq_questions":"[{\"question\":\"Are you working in an open cast mine only?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":425,"oq_targetId":"3","oq_occupation":"Mining : Trainee Official Underground","oq_questions":"[{\"question\":\"Are you working in an open cast mine only?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":426,"oq_targetId":"3","oq_occupation":"Mining : Underground Ventilation Inspector","oq_questions":"[{\"question\":\"Are you working in an open cast mine only?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":427,"oq_targetId":"3","oq_occupation":"Mining : Welder (Underground)","oq_questions":"[{\"question\":\"Are you working in an open cast mine only?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":428,"oq_targetId":"3","oq_occupation":"Mining Officer","oq_questions":"[{\"question\":\"Are you working in an open cast mine only?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":429,"oq_targetId":"3","oq_occupation":"Mining Surveyor","oq_questions":"[{\"question\":\"Are you working in an open cast mine only?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":430,"oq_targetId":"3","oq_occupation":"Missionary","oq_questions":"[{\"question\":\"Does your occupation require you to perform duties outside the borders of South Africa?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":431,"oq_targetId":"3","oq_occupation":"Money Lender","oq_questions":"[{\"question\":\"Is your business registered with the MFRC (Micro Finance Regulatory Council) AND are you a member of MFSA (MicroFinance South Africa)?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":433,"oq_targetId":"3","oq_occupation":"Motor Racing Driver","oq_questions":"[{\"question\":\"The system is about to ask you a number of questions and is likely to reach a decision. Should you not answer the questions now, the case will be referred to underwriting with further requirements. Do you wish to continue?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":435,"oq_targetId":"3","oq_occupation":"Motorcycle Racing Driver","oq_questions":"[{\"question\":\"The system is about to ask you a number of questions and is likely to reach a decision. Should you not answer the questions now, the case will be referred to underwriting with further requirements. Do you wish to continue?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":437,"oq_targetId":"3","oq_occupation":"News : Interviewer","oq_questions":"[{\"question\":\"Is it expected of you to visit conflict areas outside the RSA borders, as a result of your responsibilities?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":438,"oq_targetId":"3","oq_occupation":"News : Journalist \\ Writer","oq_questions":"[{\"question\":\"Is it expected of you to visit conflict areas outside the RSA borders, as a result of your responsibilities?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":439,"oq_targetId":"3","oq_occupation":"News : Photographer","oq_questions":"[{\"question\":\"Is it expected of you to visit conflict areas outside the RSA borders, as a result of your responsibilities?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":440,"oq_targetId":"3","oq_occupation":"News : Reporter","oq_questions":"[{\"question\":\"Is it expected of you to visit conflict areas outside the RSA borders, as a result of your responsibilities?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":441,"oq_targetId":"3","oq_occupation":"News Agency Manager \\ Owner","oq_questions":"[{\"question\":\"Is it expected of you to visit conflict areas outside the RSA borders, as a result of your responsibilities?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":442,"oq_targetId":"3","oq_occupation":"Newspaper : Columnist","oq_questions":"[{\"question\":\"Is it expected of you to visit conflict areas outside the RSA borders, as a result of your responsibilities?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":443,"oq_targetId":"3","oq_occupation":"Newspaper : Journalist","oq_questions":"[{\"question\":\"Is it expected of you to visit conflict areas outside the RSA borders, as a result of your responsibilities?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":444,"oq_targetId":"3","oq_occupation":"Newspaper : Reporter","oq_questions":"[{\"question\":\"Is it expected of you to visit conflict areas outside the RSA borders, as a result of your responsibilities?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":445,"oq_targetId":"3","oq_occupation":"Newspaper : Writer","oq_questions":"[{\"question\":\"Is it expected of you to visit conflict areas outside the RSA borders, as a result of your responsibilities?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":448,"oq_targetId":"3","oq_occupation":"Oceanographer","oq_questions":"[{\"question\":\"Do you dive as part of your occupational duties?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":449,"oq_targetId":"3","oq_occupation":"Oceanographic Researcher","oq_questions":"[{\"question\":\"Do you dive as part of your occupational duties?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":452,"oq_targetId":"3","oq_occupation":"Office Messenger","oq_questions":"[{\"question\":\"Do you use a motorcycle to perform your daily duties.\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":453,"oq_targetId":"3","oq_occupation":"Oil Rig : Catering Staff","oq_questions":"[{\"question\":\"Do you dive as part of your occupational duties?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":454,"oq_targetId":"3","oq_occupation":"Oil Rig : Chemical Engineer","oq_questions":"[{\"question\":\"Do you dive as part of your occupational duties?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":455,"oq_targetId":"3","oq_occupation":"Oil Rig : Chemist","oq_questions":"[{\"question\":\"Do you dive as part of your occupational duties?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":456,"oq_targetId":"3","oq_occupation":"Oil Rig : Driller","oq_questions":"[{\"question\":\"Do you dive as part of your occupational duties?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":457,"oq_targetId":"3","oq_occupation":"Oil Rig : Engineer","oq_questions":"[{\"question\":\"Do you dive as part of your occupational duties?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":458,"oq_targetId":"3","oq_occupation":"Oil Rig : Fitter","oq_questions":"[{\"question\":\"Do you dive as part of your occupational duties?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":459,"oq_targetId":"3","oq_occupation":"Oil Rig : Fusing-Burner","oq_questions":"[{\"question\":\"Do you dive as part of your occupational duties?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":460,"oq_targetId":"3","oq_occupation":"Oil Rig : Geologist","oq_questions":"[{\"question\":\"Do you dive as part of your occupational duties?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":461,"oq_targetId":"3","oq_occupation":"Oil Rig : Geophysicist","oq_questions":"[{\"question\":\"Do you dive as part of your occupational duties?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":462,"oq_targetId":"3","oq_occupation":"Oil Rig : Maintenance Technician","oq_questions":"[{\"question\":\"Do you dive as part of your occupational duties?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":463,"oq_targetId":"3","oq_occupation":"Oil Rig : Mechanic","oq_questions":"[{\"question\":\"Do you dive as part of your occupational duties?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":464,"oq_targetId":"3","oq_occupation":"Oil Rig : Medic","oq_questions":"[{\"question\":\"Do you dive as part of your occupational duties?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":465,"oq_targetId":"3","oq_occupation":"Oil Rig : Operator","oq_questions":"[{\"question\":\"Do you dive as part of your occupational duties?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":466,"oq_targetId":"3","oq_occupation":"Oil Rig : Pipe-Fitter","oq_questions":"[{\"question\":\"Do you dive as part of your occupational duties?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":467,"oq_targetId":"3","oq_occupation":"Oil Rig : Radiographer","oq_questions":"[{\"question\":\"Do you dive as part of your occupational duties?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":468,"oq_targetId":"3","oq_occupation":"Oil Rig : Rigger","oq_questions":"[{\"question\":\"Do you dive as part of your occupational duties?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":469,"oq_targetId":"3","oq_occupation":"Oil Rig : Safety Personnel","oq_questions":"[{\"question\":\"Do you dive as part of your occupational duties?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":470,"oq_targetId":"3","oq_occupation":"Oil Rig : Seismologist","oq_questions":"[{\"question\":\"Do you dive as part of your occupational duties?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":471,"oq_targetId":"3","oq_occupation":"Oil Rig : Storekeeper","oq_questions":"[{\"question\":\"Do you dive as part of your occupational duties?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":472,"oq_targetId":"3","oq_occupation":"Oil Rig : Supervisor","oq_questions":"[{\"question\":\"Do you dive as part of your occupational duties?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":473,"oq_targetId":"3","oq_occupation":"Oil Rig : Technician","oq_questions":"[{\"question\":\"Do you dive as part of your occupational duties?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":474,"oq_targetId":"3","oq_occupation":"Oil Rig : Valveman","oq_questions":"[{\"question\":\"Do you dive as part of your occupational duties?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":475,"oq_targetId":"3","oq_occupation":"Oil Rig : Welder","oq_questions":"[{\"question\":\"Do you dive as part of your occupational duties?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":476,"oq_targetId":"3","oq_occupation":"Oil Rig : Worker","oq_questions":"[{\"question\":\"Do you dive as part of your occupational duties?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":478,"oq_targetId":"3","oq_occupation":"Orthotist","oq_questions":"[{\"question\":\"Are you a registered member of the Allied Health Professions Council of South Africa (AHPCSA)?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":482,"oq_targetId":"3","oq_occupation":"Owner : Diamond Mine","oq_questions":"[{\"question\":\"Are you personally involved in collecting the diamond bearing gravel?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":497,"oq_targetId":"3","oq_occupation":"Parachutist","oq_questions":"[{\"question\":\"Do you do parachuting exclusively as a part of military or citizen force duties?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":502,"oq_targetId":"3","oq_occupation":"Photographer : Advertising","oq_questions":"[{\"question\":\"Is it expected of you to visit conflict areas outside the RSA borders, as a result of your responsibilities?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":503,"oq_targetId":"3","oq_occupation":"Photographer : Commercial","oq_questions":"[{\"question\":\"Is it expected of you to visit conflict areas outside the RSA borders, as a result of your responsibilities?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":504,"oq_targetId":"3","oq_occupation":"Photographer : Fashion","oq_questions":"[{\"question\":\"Is it expected of you to visit conflict areas outside the RSA borders, as a result of your responsibilities?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":505,"oq_targetId":"3","oq_occupation":"Photographer : Street","oq_questions":"[{\"question\":\"Is it expected of you to visit conflict areas outside the RSA borders, as a result of your responsibilities?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":506,"oq_targetId":"3","oq_occupation":"Photographer : Studio","oq_questions":"[{\"question\":\"Is it expected of you to visit conflict areas outside the RSA borders, as a result of your responsibilities?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":507,"oq_targetId":"3","oq_occupation":"Photographer : Wedding","oq_questions":"[{\"question\":\"Is it expected of you to visit conflict areas outside the RSA borders, as a result of your responsibilities?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":508,"oq_targetId":"3","oq_occupation":"Photographic Artist","oq_questions":"[{\"question\":\"Is it expected of you to visit conflict areas outside the RSA borders, as a result of your responsibilities?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":510,"oq_targetId":"3","oq_occupation":"Platelayer","oq_questions":"[{\"question\":\"Do you work in the mining industry?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":511,"oq_targetId":"3","oq_occupation":"Plumber","oq_questions":"[{\"question\":\"Are you personally involved in the physical operations of the business?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":512,"oq_targetId":"3","oq_occupation":"Plumbing Contractor","oq_questions":"[{\"question\":\"Are you personally involved in the physical operations of the business?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":513,"oq_targetId":"3","oq_occupation":"Podiatrist","oq_questions":"[{\"question\":\"Are you a registered member of the Allied Health Professions Council of South Africa (AHPCSA)?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":514,"oq_targetId":"3","oq_occupation":"Political Commentator","oq_questions":"[{\"question\":\"Is it expected of you to visit conflict areas outside the RSA borders, as a result of your responsibilities?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":515,"oq_targetId":"3","oq_occupation":"Political Interviewer","oq_questions":"[{\"question\":\"Is it expected of you to visit conflict areas outside the RSA borders, as a result of your responsibilities?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":516,"oq_targetId":"3","oq_occupation":"Political Journalist \\ Reporter \\ Writer","oq_questions":"[{\"question\":\"Is it expected of you to visit conflict areas outside the RSA borders, as a result of your responsibilities?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":518,"oq_targetId":"3","oq_occupation":"Poultry-Farmer","oq_questions":"[{\"question\":\"Does your participation in the physical activities on the farm, including the operation or driving of agricultural implements, or the handling of livestock, but excluding the driving of light delivery vehicles, on average exceed half a day’s work per week?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":519,"oq_targetId":"3","oq_occupation":"Power Line Worker","oq_questions":"[{\"question\":\"Do you work in the mining industry?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":527,"oq_targetId":"3","oq_occupation":"Prosthetist","oq_questions":"[{\"question\":\"Are you a registered member of the Allied Health Professions Council of South Africa (AHPCSA)?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":533,"oq_targetId":"3","oq_occupation":"Racing Driver","oq_questions":"[{\"question\":\"The system is about to ask you a number of questions and is likely to reach a decision. Should you not answer the questions now, the case will be referred to underwriting with further requirements. Do you wish to continue?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":535,"oq_targetId":"3","oq_occupation":"Radio Reporter","oq_questions":"[{\"question\":\"Is it expected of you to visit conflict areas outside the RSA borders, as a result of your responsibilities?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":536,"oq_targetId":"3","oq_occupation":"Railworker","oq_questions":"[{\"question\":\"Do you work in the mining industry?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":538,"oq_targetId":"3","oq_occupation":"Reflexologist","oq_questions":"[{\"question\":\"Are you a registered member of the Allied Health Professions Council of South Africa (AHPCSA)?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":539,"oq_targetId":"3","oq_occupation":"Relief Worker","oq_questions":"[{\"question\":\"Does your occupation require you to perform duties outside the borders of South Africa?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":541,"oq_targetId":"3","oq_occupation":"Reporter","oq_questions":"[{\"question\":\"Is it expected of you to visit conflict areas outside the RSA borders, as a result of your responsibilities?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":550,"oq_targetId":"3","oq_occupation":"Salvage Worker","oq_questions":"[{\"question\":\"Do you dive as part of your occupational duties?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":554,"oq_targetId":"3","oq_occupation":"Scholar","oq_questions":"[{\"question\":\"Are you presently engaged in studies at a tertiary education provider, e.g. university, technikon or college?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":555,"oq_targetId":"3","oq_occupation":"Search And Rescue Worker","oq_questions":"[{\"question\":\"Do you dive as part of your occupational duties?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":557,"oq_targetId":"3","oq_occupation":"Security Forces : Aircraft Joiner","oq_questions":"[{\"question\":\"Are you involved in any type of aviation or flying in your normal occupation?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":558,"oq_targetId":"3","oq_occupation":"Security Forces : Airforce","oq_questions":"[{\"question\":\"In which of the following divisions of the Airforce are you involved in?\",\"answers\":[\"Pilots\",\"Aircrew\",\"Trainee pilots\",\"Air traffic controller\",\"Ground crew technical work\",\"Ground crew administrative work\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":559,"oq_targetId":"3","oq_occupation":"Security Forces : Army","oq_questions":"[{\"question\":\"What rank do you currently hold?\",\"answers\":[\"Serviceman\",\"Lance Corporal\",\"Corporal\",\"Sergeant\",\"Staff Sergeant\",\"Warrant Officer\",\"Sergeant-Major\",\"Candidate Officer\",\"Lieutenant\",\"Captain\",\"Major\",\"Commandant\",\"Lieutenant-Colonel\",\"Colonel\",\"Brigadier\",\"General\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":560,"oq_targetId":"3","oq_occupation":"Security Forces : Correctional Services","oq_questions":"[{\"question\":\"What rank do you currently hold?\",\"answers\":[\"Correctional officer grade II and lower\",\"Correctional officer grade I and higher\",\"Administrative Personnel (without rank)\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":561,"oq_targetId":"3","oq_occupation":"Security Forces : Medical Health Services","oq_questions":"[{\"question\":\"What rank do you currently hold?\",\"answers\":[\"Serviceman\",\"Lance Corporal\",\"Corporal\",\"Sergeant\",\"Staff Sergeant\",\"Warrant Officer\",\"Sergeant-Major\",\"Candidate Officer\",\"Lieutenant\",\"Captain\",\"Major\",\"Commandant\",\"Lieutenant-Colonel\",\"Colonel\",\"Brigadier\",\"General\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":562,"oq_targetId":"3","oq_occupation":"Security Forces : Navy","oq_questions":"[{\"question\":\"What rank do you currently hold?\",\"answers\":[\"Seaman\",\"Leading Seaman\",\"Petty Officer\",\"Chief Petty Officer\",\"Warrant Officer\",\"Master at Arms / Coxswain\",\"Shipman\",\"Ensign\",\"Lieutenant\",\"Commander\",\"Captain\",\"Commodore\",\"Admiral\",\"Ableseaman\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":563,"oq_targetId":"3","oq_occupation":"Security Forces : Police","oq_questions":"[{\"question\":\"What rank do you currently hold?\",\"answers\":[\"Constable\",\"Sergeant\",\"Warrant Officer\",\"Lieutenant\",\"Captain\",\"Lieutenant Colonel\",\"Colonel\",\"Brigadier\",\"Major General\",\"Lieutenant General\",\"General\",\"Administrative only personnel\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":564,"oq_targetId":"3","oq_occupation":"Security Guard \\ Patrolman \\ Worker","oq_questions":"[{\"question\":\"Are you required to carry a firearm, handle cash or work in a bank as part of your occupational duties?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":565,"oq_targetId":"3","oq_occupation":"Security Officer \\ Supervisor","oq_questions":"[{\"question\":\"Are you required to carry a firearm, handle cash or work in a bank as part of your occupational duties?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":567,"oq_targetId":"3","oq_occupation":"Seismologist","oq_questions":"[{\"question\":\"Do you work in the mining industry?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":571,"oq_targetId":"3","oq_occupation":"Shipbuilder \\ Repairer","oq_questions":"[{\"question\":\"Do you dive as part of your occupational duties?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":574,"oq_targetId":"3","oq_occupation":"Shipyard Worker","oq_questions":"[{\"question\":\"Do you dive as part of your occupational duties?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":575,"oq_targetId":"3","oq_occupation":"Shop Designer","oq_questions":"[{\"question\":\"Which of these options best fits your daily duties?\",\"answers\":[\"Only installation of shop fittings etc.\",\"Only designing of shop fittings and layout\",\"Designing and Installation of shop fittings and layout\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":576,"oq_targetId":"3","oq_occupation":"Shop Fitter","oq_questions":"[{\"question\":\"Which of these options best fits your daily duties?\",\"answers\":[\"Only installation of shop fittings etc.\",\"Only designing of shop fittings and layout\",\"Designing and Installation of shop fittings and layout\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":587,"oq_targetId":"3","oq_occupation":"Student","oq_questions":"[{\"question\":\"Are you a full-time student at a University, in at least your 4th academic year, following a 4 year or longer course, or Honours degree or higher qualification?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":598,"oq_targetId":"3","oq_occupation":"Tool Fitter \\ Maker \\ Setter","oq_questions":"[{\"question\":\"Do you work in the mining industry?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":605,"oq_targetId":"3","oq_occupation":"Transport Vehicle Owner","oq_questions":"[{\"question\":\"Are you personally involved in the physical operations of the business?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":606,"oq_targetId":"3","oq_occupation":"Treasurer","oq_questions":"[{\"question\":\"Did you successfully complete the SAIPA Professional Evaluation(PE)?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":608,"oq_targetId":"3","oq_occupation":"Tunnel Worker","oq_questions":"[{\"question\":\"Do you ever have to spend time in a mine beneath the surface?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":610,"oq_targetId":"3","oq_occupation":"Vehicle Recovery Company : Member Of Recovery Unit","oq_questions":"[{\"question\":\"Are you required to carry a firearm, handle cash or work in a bank as part of your occupational duties?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":613,"oq_targetId":"3","oq_occupation":"Vineyard Manager","oq_questions":"[{\"question\":\"Does your participation in the physical activities on the farm, including the operation or driving of agricultural implements, or the handling of livestock, but excluding the driving of light delivery vehicles, on average exceed half a day’s work per week?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":619,"oq_targetId":"3","oq_occupation":"Well Sinker","oq_questions":"[{\"question\":\"Are you personally involved in the physical operations of the business?\",\"answers\":[\"Yes\",\"No\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":629,"oq_targetId":"3","oq_occupation":"Business Owner","oq_questions":"[{\"question\":\"Which industry/business are you involved in?\",\"answers\":[\"Debt collecting business\",\"Mining industry\",\"Micro lending business\",\"Security business\",\"Shebeen business\",\"Taxi industry\",\"None of the above\"],\"questionType\":\"dropdown\"}]"},{"oq_Id":630,"oq_targetId":"3","oq_occupation":"Director Of Company","oq_questions":"[{\"question\":\"Which industry/business are you involved in?\",\"answers\":[\"Debt collecting business\",\"Mining industry\",\"Micro lending business\",\"Security business\",\"Shebeen business\",\"Taxi industry\",\"None of the above\"],\"questionType\":\"dropdown\"}]"}]);

/***/ }),
/* 2831 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_core__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_Wrappers_materialUIWrappers_components_FormDropDown__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_helpers_ValidationHelpers__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_CustomFields_CustomFields_jsx__ = __webpack_require__(38);
var fmi=function fmi(props){var occupationalQuestions=[];if(props.occupationQuestions&&props.occupationQuestions.length>0){props.occupationQuestions.map(function(o){var parsedQs=JSON.parse(o.oq_questions);parsedQs.map(function(q,i){occupationalQuestions.push({id:o.oq_Id+'q'+i,question:q});return q;});return o;});}return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{container:true},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_CustomFields_CustomFields_jsx__["a" /* FullField */],{name:'workOutsideBorder',label:'Does your job require you to work outside of the borders of R.S.A? *',component:__WEBPACK_IMPORTED_MODULE_2_components_Wrappers_materialUIWrappers_components_FormDropDown__["a" /* default */],checkValidation:props.checkValidation,isrequired:true,validate:[__WEBPACK_IMPORTED_MODULE_3_helpers_ValidationHelpers__["h" /* requiredDropdown */]],options:[{value:'validationError',displayValue:'Please select'},{value:'Y',displayValue:'Yes'},{value:'N',displayValue:'No'}]}),occupationalQuestions.map(function(o){var answersOptions=[{value:'validationError',displayValue:'Please select'}];o.question.answers.map(function(a){answersOptions.push({value:a,displayValue:a});return a;});return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Fragment,{key:o.id},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:12},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{variant:'caption'},o.question.question)),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_CustomFields_CustomFields_jsx__["a" /* FullField */],{name:'occupationalQs.target10.'+o.id,component:__WEBPACK_IMPORTED_MODULE_2_components_Wrappers_materialUIWrappers_components_FormDropDown__["a" /* default */],checkValidation:props.checkValidation,isrequired:true,validate:[__WEBPACK_IMPORTED_MODULE_3_helpers_ValidationHelpers__["h" /* requiredDropdown */]],options:answersOptions}));}));};/* harmony default export */ __webpack_exports__["a"] = (fmi);

/***/ }),
/* 2832 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_core__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_Wrappers_materialUIWrappers_components_FormDropDown__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_helpers_ValidationHelpers__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_store__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_CustomFields_CustomFields_jsx__ = __webpack_require__(38);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Momentum=function(_React$Component){_inherits(Momentum,_React$Component);function Momentum(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Momentum);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Momentum.__proto__||Object.getPrototypeOf(Momentum)).call.apply(_ref,[this].concat(args))),_this),_this.multiplyMemberValidate=function(value){return!_this.isMultiplyMember()?undefined:Object(__WEBPACK_IMPORTED_MODULE_2_helpers_ValidationHelpers__["h" /* requiredDropdown */])(value);},_this.heartScoreValidate=function(value){return!_this.isMultiplyMember()?undefined:Object(__WEBPACK_IMPORTED_MODULE_2_helpers_ValidationHelpers__["h" /* requiredDropdown */])(value);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Momentum,[{key:'isMultiplyMember',value:function isMultiplyMember(){var multiplyMembership=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(__WEBPACK_IMPORTED_MODULE_5_store__["a" /* default */].getState().form.quotev2,'values.multiplyMembership',null);return multiplyMembership?multiplyMembership==='2'||multiplyMembership==='3':false;}},{key:'render',value:function render(){var _this2=this;var multiplyMember=this.isMultiplyMember();return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{container:true},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_CustomFields_CustomFields_jsx__["a" /* FullField */],{name:'momentumInteractive',label:'Momentum interactive *',component:__WEBPACK_IMPORTED_MODULE_1_components_Wrappers_materialUIWrappers_components_FormDropDown__["a" /* default */],checkValidation:this.props.checkValidation,isrequired:true,validate:[__WEBPACK_IMPORTED_MODULE_2_helpers_ValidationHelpers__["h" /* requiredDropdown */]],options:[{value:'validationError',displayValue:'Please select'},{value:'A',displayValue:'Yes'},{value:'N',displayValue:'No'}]}),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_CustomFields_CustomFields_jsx__["a" /* FullField */],{name:'multiplyMembership',label:'Multiply membership *',component:__WEBPACK_IMPORTED_MODULE_1_components_Wrappers_materialUIWrappers_components_FormDropDown__["a" /* default */],checkValidation:this.props.checkValidation,isrequired:true,validate:[__WEBPACK_IMPORTED_MODULE_2_helpers_ValidationHelpers__["h" /* requiredDropdown */]],onChange:function onChange(){return _this2.props.forceUpdate();},options:[{value:'validationError',displayValue:'Please select'},{value:'1',displayValue:'Not a Multiply member'},{value:'2',displayValue:'Current Multiply member'},{value:'3',displayValue:'New application - main member'}]}),!multiplyMember?null:__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_CustomFields_CustomFields_jsx__["a" /* FullField */],{name:'multiplyStatus',label:'Multiply member status *',component:__WEBPACK_IMPORTED_MODULE_1_components_Wrappers_materialUIWrappers_components_FormDropDown__["a" /* default */],checkValidation:this.props.checkValidation,isrequired:true,validate:[this.multiplyMemberValidate],options:[{value:'validationError',displayValue:'Please select'},{value:'B',displayValue:'Bronze'},{value:'G',displayValue:'Gold'},{value:'P',displayValue:'Platinum'},{value:'C',displayValue:'Private Club'},{value:'S',displayValue:'Silver'}]}),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_CustomFields_CustomFields_jsx__["a" /* FullField */],{name:'MSTIDriver',label:'MSTI Driver *',component:__WEBPACK_IMPORTED_MODULE_1_components_Wrappers_materialUIWrappers_components_FormDropDown__["a" /* default */],checkValidation:this.props.checkValidation,isrequired:true,validate:[__WEBPACK_IMPORTED_MODULE_2_helpers_ValidationHelpers__["h" /* requiredDropdown */]],options:[{value:'validationError',displayValue:'Please select'},{value:'N',displayValue:'No'},{value:'Y',displayValue:'Yes'}]}),!multiplyMember?null:__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_CustomFields_CustomFields_jsx__["a" /* FullField */],{name:'heartScore',label:'Healthy heart score *',component:__WEBPACK_IMPORTED_MODULE_1_components_Wrappers_materialUIWrappers_components_FormDropDown__["a" /* default */],checkValidation:this.props.checkValidation,isrequired:true,validate:[this.heartScoreValidate],options:[{value:'validationError',displayValue:'Please select'},{value:'N',displayValue:'None'},{value:'R',displayValue:'Red'},{value:'A',displayValue:'Amber'},{value:'G',displayValue:'Green'}]}));}}]);return Momentum;}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Momentum);

/***/ }),
/* 2833 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_core__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_Wrappers_materialUIWrappers_components_FormDropDown__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_helpers_ValidationHelpers__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_CustomFields_CustomFields_jsx__ = __webpack_require__(38);
var sanlam=function sanlam(props){var occupationalQuestions=[];if(props.occupationQuestions&&props.occupationQuestions.length>0){props.occupationQuestions.map(function(o){var parsedQs=JSON.parse(o.oq_questions);parsedQs.map(function(q,i){occupationalQuestions.push({id:o.oq_Id+'q'+i,question:q});return q;});return o;});}return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{container:true},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_CustomFields_CustomFields_jsx__["a" /* FullField */],{name:'ProductOption',label:'Product option *',component:__WEBPACK_IMPORTED_MODULE_2_components_Wrappers_materialUIWrappers_components_FormDropDown__["a" /* default */],checkValidation:props.checkValidation,isrequired:true,validate:[__WEBPACK_IMPORTED_MODULE_3_helpers_ValidationHelpers__["h" /* requiredDropdown */]],options:[{value:'validationError',displayValue:'Please select'},{value:'Comprehensive',displayValue:'Premier'},{value:'Classic',displayValue:'Classic'}]}),occupationalQuestions.map(function(o){var answersOptions=[{value:'validationError',displayValue:'Please select'}];o.question.answers.map(function(a){answersOptions.push({value:a,displayValue:a});return a;});return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Fragment,{key:o.id},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:12},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{variant:'caption'},o.question.question)),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_CustomFields_CustomFields_jsx__["a" /* FullField */],{name:'occupationalQs.target3.'+o.id,component:__WEBPACK_IMPORTED_MODULE_2_components_Wrappers_materialUIWrappers_components_FormDropDown__["a" /* default */],checkValidation:props.checkValidation,isrequired:true,validate:[__WEBPACK_IMPORTED_MODULE_3_helpers_ValidationHelpers__["h" /* requiredDropdown */]],options:answersOptions}));}));};/* harmony default export */ __webpack_exports__["a"] = (sanlam);

/***/ }),
/* 2834 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_core__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_CustomCardHeading_CustomCardHeading_jsx__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_CustomCardHeading_CustomCardSubHeading_jsx__ = __webpack_require__(739);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Grid_GridItem_jsx__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Wrappers_materialUIWrappers_components_FormDropDown__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_Wrappers_materialUIWrappers_components_FormInput__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_Wrappers_materialUIWrappers_components_NumberInput__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_helpers_ValidationHelpers__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_redux_form__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_date_fns__ = __webpack_require__(418);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_date_fns___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_date_fns__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_CustomChip_CustomChipLeft_jsx__ = __webpack_require__(740);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_CustomChip_CustomChipLeftReversed__ = __webpack_require__(741);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var required=function required(value){return value?undefined:'Required';};var dates=function dates(){var options=[];var today=new Date();for(var i=0;i<2;i++){var monthX=Object(__WEBPACK_IMPORTED_MODULE_10_date_fns__["addMonths"])(today,i+2);var month=monthX.getMonth();if(month<1)month=12;if(month<10){var item='01/0'+month+'/'+today.getFullYear();if(item.includes("/00/"))item.replace("/00/","/12/");options.push(item);}else{var item='01/'+month+'/'+today.getFullYear();if(item.includes("/00/"))item.replace("/00/","/12/");options.push(item);}}return options;};var makeOptions=function makeOptions(values){var options=[{value:'validationError',displayValue:'Please select'}];var _iteratorNormalCompletion=true;var _didIteratorError=false;var _iteratorError=undefined;try{for(var _iterator=values[Symbol.iterator](),_step;!(_iteratorNormalCompletion=(_step=_iterator.next()).done);_iteratorNormalCompletion=true){var value=_step.value;if((typeof value==='undefined'?'undefined':_typeof(value))==='object'){options.push(value);}else{options.push(value);}}}catch(err){_didIteratorError=true;_iteratorError=err;}finally{try{if(!_iteratorNormalCompletion&&_iterator.return){_iterator.return();}}finally{if(_didIteratorError){throw _iteratorError;}}}return options;};var CustomField=function CustomField(props){return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:6,style:{marginBottom:'25px'}},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["t" /* FormControl */],{fullWidth:true},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_redux_form__["a" /* Field */],props)));};var CustomFieldFullWidth=function CustomFieldFullWidth(props){return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:12,style:{marginBottom:'25px'}},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["t" /* FormControl */],{fullWidth:true},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_redux_form__["a" /* Field */],props)));};(function(props){return 0;});var QuoteDetailsPage=function(_React$Component){_inherits(QuoteDetailsPage,_React$Component);function QuoteDetailsPage(){_classCallCheck(this,QuoteDetailsPage);return _possibleConstructorReturn(this,(QuoteDetailsPage.__proto__||Object.getPrototypeOf(QuoteDetailsPage)).apply(this,arguments));}_createClass(QuoteDetailsPage,[{key:'componentDidMount',value:function componentDidMount(){this.props.scrollMeBar();}},{key:'render',value:function render(){var _this2=this;var dependentsAdult=[];var dependentsChild=[];var dMAmount=[];var dMAmountMain=[];for(var k=0;k<this.props.medicalAmount;k++){//alert(this.props.dependentMedicalAmount[i])
if(false)//This is removed for now. To render it again, remove this if statement.
dMAmountMain[k]=React.createElement(Grid,{container:true},React.createElement(GridItem,{xs:12,sm:12,md:4,style:{marginBottom:'25px'}},React.createElement(CustomFieldFullWidth,{name:'previousMedicalName'+k,component:FormDropdown,checkValidation:this.props.checkValidation,label:'Previous medical aid name',isrequired:true//validate={[required]}
,options:[{value:'English',displayValue:'English'},{value:'Afrikaans',displayValue:'Afrikaans'}]})),React.createElement(GridItem,{xs:12,sm:12,md:4,style:{marginBottom:'25px'}},React.createElement(CustomFieldFullWidth,{label:'Start Date',name:'pMedicalStart'+k,component:FormInput,placeholder:'DD/MM/YYYY',validate:[dateValid]})),React.createElement(GridItem,{xs:12,sm:12,md:4,style:{marginBottom:'25px'}},React.createElement(CustomFieldFullWidth,{label:'End Date',name:'pMedicalEnd'+k,component:FormInput,placeholder:'DD/MM/YYYY',validate:[dateValid]})));}for(var i=0;i<this.props.dependentsAdult.length;i++){var z=this.props.dependentsAdult[i].id;var AmountMedical=[];for(var k=0;k<this.props.dependentsAdult[i].prevMeds.length;k++){//alert(this.props.dependentMedicalAmount[i])
if(false)//This is removed for now. To render it again, remove this if statement.
AmountMedical.push(React.createElement(Grid,{container:true},React.createElement(GridItem,{xs:12,sm:12,md:4,style:{marginBottom:'25px'}},React.createElement(CustomFieldFullWidth,{name:'previousMedicalName'+z,component:FormDropdown,checkValidation:this.props.checkValidation,label:'Previous medical aid name',isrequired:true//validate={[required]}
,options:[{value:'English',displayValue:'English'},{value:'Afrikaans',displayValue:'Afrikaans'}]})),React.createElement(GridItem,{xs:12,sm:12,md:4,style:{marginBottom:'25px'}},React.createElement(CustomFieldFullWidth,{label:'Start Date',name:'pMedicalStart'+z+":"+k,component:FormInput,placeholder:'DD/MM/YYYY',validate:[dateValid]})),React.createElement(GridItem,{xs:12,sm:12,md:4,style:{marginBottom:'25px'}},React.createElement(CustomFieldFullWidth,{label:'End Date',name:'pMedicalEnd'+z+":"+k,component:FormInput,placeholder:'DD/MM/YYYY',validate:[dateValid]}))));}dMAmount[i]=AmountMedical;console.log(this.props.dependentsAdult.length);console.log(this.props.dependentsAdult[i].prevMeds.length);console.log(AmountMedical);console.log(dMAmount[i]);dependentsAdult[i]=__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{container:true},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_CustomChip_CustomChipLeftReversed__["a" /* default */],{text:'',name:'adultDepRemove'+z,icon:'remove',clicked:function clicked(e){return _this2.props.handleRemoveDependentAdult(e);},style:{margin:"0px 0px 0px 0px"}}),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:6,style:{marginBottom:'25px'}},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_CustomCardHeading_CustomCardSubHeading_jsx__["a" /* default */],{subheading:"Adult Member"+(i+1)+":"}),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(CustomFieldFullWidth,{label:'Date of birth',name:'adultDepDateOfBirth'+i,component:__WEBPACK_IMPORTED_MODULE_5_components_Wrappers_materialUIWrappers_components_FormInput__["a" /* default */],placeholder:'DD/MM/YYYY',validate:[__WEBPACK_IMPORTED_MODULE_7_helpers_ValidationHelpers__["a" /* dateValid */]],onChange:function onChange(e){return _this2.props.changeDependentDob(e);}})),new Date().getFullYear()-new Date(this.props.dependentsAdult[i].dob.split("/")[1]+"/"+this.props.dependentsAdult[i].dob.split("/")[0]+"/"+this.props.dependentsAdult[i].dob.split("/")[2]).getFullYear()>34&&new Date().getFullYear()-new Date(this.props.dependentsAdult[i].dob.split("/")[1]+"/"+this.props.dependentsAdult[i].dob.split("/")[0]+"/"+this.props.dependentsAdult[i].dob.split("/")[2]).getFullYear()<150&&__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:6,style:{marginBottom:'25px'}},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(CustomFieldFullWidth,{name:'yearsWithoutM'+i,component:__WEBPACK_IMPORTED_MODULE_5_components_Wrappers_materialUIWrappers_components_FormInput__["a" /* default */],checkValidation:this.props.checkValidation,label:'Years covered by medical aid',isrequired:true,onChange:function onChange(e){return _this2.props.changeDependentWithoutMed(e);}//validate={[required]}
})),new Date().getFullYear()-new Date(this.props.dependentsAdult[i].dob.split("/")[1]+"/"+this.props.dependentsAdult[i].dob.split("/")[0]+"/"+this.props.dependentsAdult[i].dob.split("/")[2]).getFullYear()>34&&new Date().getFullYear()-new Date(this.props.dependentsAdult[i].dob.split("/")[1]+"/"+this.props.dependentsAdult[i].dob.split("/")[0]+"/"+this.props.dependentsAdult[i].dob.split("/")[2]).getFullYear()<150&&__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:6,style:{marginBottom:'25px'}},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(CustomFieldFullWidth,{name:'previousMedicalAmount'+z,component:__WEBPACK_IMPORTED_MODULE_4_components_Wrappers_materialUIWrappers_components_FormDropDown__["a" /* default */],checkValidation:this.props.checkValidation,label:'How many previous medical aids',isrequired:true//validate={[required]}
,onChange:function onChange(e){return _this2.props.handleMedicalAmountChangeD(e);},options:makeOptions([{value:" ",displayValue:'Please select'},{value:z+':1',displayValue:'1'},{value:z+':2',displayValue:'2'},{value:z+':3',displayValue:'3'},{value:z+':4',displayValue:'4'},{value:z+':5',displayValue:'5'},{value:z+':6',displayValue:'6'},{value:z+':7',displayValue:'7'},{value:z+':8',displayValue:'8'},{value:z+':9',displayValue:'9'},{value:z+':10',displayValue:'10'}])}),dMAmount[i]));}for(var i=0;i<this.props.dependentsChild.length;i++){var z=this.props.dependentsChild[i].id;dependentsChild[i]=__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('div',{key:i},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:3,style:{marginBottom:'25px'}},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_CustomChip_CustomChipLeftReversed__["a" /* default */],{text:'',name:'childDepRemove'+z,icon:'remove',clicked:function clicked(e){return _this2.props.handleRemoveDependentChild(e);},style:{margin:"0px 0px 0px 0px"}})),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:12,style:{marginBottom:'25px'}},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_CustomCardHeading_CustomCardSubHeading_jsx__["a" /* default */],{subheading:"Child Member"+(i+1)+":"}),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(CustomFieldFullWidth,{label:'Date of birth',name:'childDepDateOfBirth'+z,component:__WEBPACK_IMPORTED_MODULE_5_components_Wrappers_materialUIWrappers_components_FormInput__["a" /* default */],placeholder:'DD/MM/YYYY',validate:[__WEBPACK_IMPORTED_MODULE_7_helpers_ValidationHelpers__["a" /* dateValid */]],value:this.props.dependentsChild[i],onChange:function onChange(e){return _this2.props.changechildDob(e,i,e.target.value);}})));}return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('div',{className:'contentWithStepper'},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["e" /* Card */],null,__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["f" /* CardContent */],null,__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_CustomCardHeading_CustomCardHeading_jsx__["a" /* default */],{subheading:'Quote Generation',caption:this.props.clientFullname,headline:'General Quote Details'}),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{container:true},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(CustomFieldFullWidth,{name:'description',component:__WEBPACK_IMPORTED_MODULE_5_components_Wrappers_materialUIWrappers_components_FormInput__["a" /* default */],checkValidation:this.props.checkValidation,label:'Quote Description *',isrequired:true,validate:[required]}),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(CustomField,{name:'language',component:__WEBPACK_IMPORTED_MODULE_4_components_Wrappers_materialUIWrappers_components_FormDropDown__["a" /* default */],checkValidation:this.props.checkValidation,label:'Language *',isrequired:true,validate:[required],options:[{value:'English',displayValue:'English'},{value:'Afrikaans',displayValue:'Afrikaans'}]}),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(CustomField,{name:'startDate',component:__WEBPACK_IMPORTED_MODULE_4_components_Wrappers_materialUIWrappers_components_FormDropDown__["a" /* default */],checkValidation:this.props.checkValidation,label:'Start Date *',isrequired:true,validate:[required],onChange:function onChange(e){return _this2.props.changeStartDate(e);},options:makeOptions(dates())}),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(CustomField,{name:'student',component:__WEBPACK_IMPORTED_MODULE_4_components_Wrappers_materialUIWrappers_components_FormDropDown__["a" /* default */],checkValidation:this.props.checkValidation,label:'Is the main member a student?',isrequired:true,validate:[required],options:makeOptions([{value:'Y',displayValue:'Yes'},{value:'N',displayValue:'No'}])}),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(CustomField,{name:'hSaver',component:__WEBPACK_IMPORTED_MODULE_4_components_Wrappers_materialUIWrappers_components_FormDropDown__["a" /* default */],checkValidation:this.props.checkValidation,label:'Would you like to add extra savings?',isrequired:true,onChange:function onChange(e){return _this2.props.changeHSaverOption(e);},validate:[required],options:makeOptions([{value:"1",displayValue:'Yes'},{value:"0",displayValue:'No'}])})),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["f" /* CardContent */],null,__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{container:true},this.props.clientAge>34&&__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:12,style:{marginBottom:'25px'}},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_CustomCardHeading_CustomCardSubHeading_jsx__["a" /* default */],{subheading:'Main Member:'})),this.props.clientAge>34&&__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:6,style:{marginBottom:'25px'}},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(CustomFieldFullWidth,{name:'yearsWithoutM',component:__WEBPACK_IMPORTED_MODULE_5_components_Wrappers_materialUIWrappers_components_FormInput__["a" /* default */],checkValidation:this.props.checkValidation,label:'Years covered by medical aid',isrequired:true,onChange:function onChange(e){return _this2.props.changeWithoutMed(e);},validate:[required]})),this.props.clientAge>34&&__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:6,style:{marginBottom:'25px'}},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(CustomFieldFullWidth,{name:'previousMedicalAmount',component:__WEBPACK_IMPORTED_MODULE_4_components_Wrappers_materialUIWrappers_components_FormDropDown__["a" /* default */],checkValidation:this.props.checkValidation,label:'How many previous medical aids',isrequired:true//validate={[required]}
,onChange:function onChange(e){return _this2.props.handleMedicalAmountChange(0,e);},options:makeOptions([{value:'1',displayValue:'1'},{value:'2',displayValue:'2'},{value:'3',displayValue:'3'},{value:'4',displayValue:'4'},{value:'5',displayValue:'5'},{value:'6',displayValue:'6'},{value:'7',displayValue:'7'},{value:'8',displayValue:'8'},{value:'9',displayValue:'9'},{value:'10',displayValue:'10'}])})),dMAmountMain,__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{container:true},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:2,style:{marginBottom:'25px'}},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_CustomChip_CustomChipLeft_jsx__["a" /* default */],{text:'Add Adult dependant',icon:'add',clicked:function clicked(e){return _this2.props.handleAddDependentAdult(e);}})),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:10,style:{marginBottom:'25px'}}),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:2,style:{marginBottom:'25px'}},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_CustomChip_CustomChipLeft_jsx__["a" /* default */],{text:'Add Child dependant',icon:'add',clicked:function clicked(e){return _this2.props.handleAddDependentChild(e);}})),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:10,style:{marginBottom:'25px'}})),dependentsAdult,dependentsChild)))));}}]);return QuoteDetailsPage;}(__WEBPACK_IMPORTED_MODULE_8_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (QuoteDetailsPage);

/***/ }),
/* 2835 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_core__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_CustomCardHeading_CustomCardHeading_jsx__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__planDetails_jsx__ = __webpack_require__(742);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__GapDetails_jsx__ = __webpack_require__(744);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__LoyaltyDetails_jsx__ = __webpack_require__(2836);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_graphql_tag__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_graphql_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_graphql_tag__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n\tquery result($path: String!, $content: String!) {\n\t\tResultPdf(path: $path, content: $content) {\n\t\t\tfilename\n\t\t}\n\t}\n'],['\n\tquery result($path: String!, $content: String!) {\n\t\tResultPdf(path: $path, content: $content) {\n\t\t\tfilename\n\t\t}\n\t}\n']);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var getResultPdf=__WEBPACK_IMPORTED_MODULE_6_graphql_tag___default()(_templateObject);function makeRisk(){var risk={empty:true,company:"",plan:"Example Plan",planType:"Example Type",contribution:{risk:[0.00],savings:[0.00],ljp:[0.00]},subTotalM:[0.00,0.00,0.00],totalM:0.00,gap:"0.00",hSaver:"0.00",loyalty:"0.00",brokerFee:"0.00",subsidy:"R0.00",totalB:0.00,threshold:"0",selfGap:"0",savingsCom:"0",dToD:"0",pdf:"",details:{}};return risk;}var BenefitMapping=function(_React$Component){_inherits(BenefitMapping,_React$Component);function BenefitMapping(){var _ref;var _temp,_this,_ret;_classCallCheck(this,BenefitMapping);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=BenefitMapping.__proto__||Object.getPrototypeOf(BenefitMapping)).call.apply(_ref,[this].concat(args))),_this),_this.incomeCondition=function(plan){var income=parseFloat(_this.props.state.income);var planIncome=plan.familyIncome;if(planIncome==""||planIncome=="N/A")return true;var planIncomeHigh=0;var planIncomeLow=0;var opperator="";planIncome=planIncome.replace(/R/g,"");planIncome=planIncome.replace(/ /g,"");if(planIncome.includes(">")){opperator=">";planIncome=planIncome.replace(/>/g,"");}if(planIncome.includes("<")){opperator="<";planIncome=planIncome.replace(/</g,"");}if(planIncome.includes("+")){opperator=">";planIncome=planIncome.replace("+","");}planIncome=planIncome.split("-");if(planIncome.length>1){planIncomeHigh=planIncome[1];planIncomeLow=planIncome[0];}else{planIncomeLow=planIncome[0];}if(opperator!=""){if(income>planIncomeLow){return true;}}else if(income>planIncomeLow&&income<planIncomeHigh){return true;}return false;},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(BenefitMapping,[{key:'componentDidMount',value:function componentDidMount(){this.props.scrollMeBar();}},{key:'render',value:function render(){var _this2=this;var riskPenalty=function riskPenalty(n){if(n<=0)return 0.00;if(n>0&&n<5)return 0.05;if(n>4&&n<15)return 0.25;if(n>14&&n<25)return 0.5;if(n>24)return 0.75;};console.log(this.props);var risks=[makeRisk(),makeRisk(),makeRisk(),makeRisk()];var setPlanNumber=0;__WEBPACK_IMPORTED_MODULE_3__planDetails_jsx__["a" /* planDetails */].map(function(plan){_this2.props.selectedTargets.map(function(chosen,i){if(chosen==plan.name&&_this2.incomeCondition(plan)){risks[i].company=__webpack_require__(424)("./"+plan.logo);risks[i].plan=plan.name;risks[i].planType=plan.planType;risks[i].contribution.risk[0]="R"+parseFloat(plan.mainContribution.replace("R","").replace("N/A",0)).toFixed(2);if(plan.mainCompSavings!="")risks[i].contribution.savings[0]="R"+parseFloat(plan.mainCompSavings.replace("R","").replace("N/A",0)).toFixed(2);else risks[i].contribution.savings[0]="R0.00";risks[i].contribution.ljp[0]="R"+(parseFloat(riskPenalty(_this2.props.state.clientAge-_this2.props.state.withoutMed-35))*parseFloat(plan.mainContribution.replace("R","").replace("N/A",0))).toFixed(2);console.log("-----"+riskPenalty(_this2.props.state.clientAge-_this2.props.state.withoutMed-35));console.log("***"+" --- "+parseFloat(plan.mainContribution.replace("R","").replace("N/A",0)).toFixed(2));_this2.props.state.dependentsAdult.map(function(e,k){risks[i].contribution.risk[k+1]="R"+parseFloat(plan.dependendContributionAdult.replace("R","").replace("N/A",0)).toFixed(2);if(plan.dependentCompSavingsAdult!="")risks[i].contribution.savings[k+1]="R"+parseFloat(plan.dependentCompSavingsAdult.replace("R","").replace("N/A",0)).toFixed(2);else risks[i].contribution.savings[k+1]="R0.00";var tempDate=_this2.props.state.dependentsAdult[k].dob.split("/");var dateProcessed=tempDate[1]+"/"+tempDate[0]+"/"+tempDate[2];console.log(">>>>>>>>>>>>"+new Date(dateProcessed).getFullYear());risks[i].contribution.ljp[k+1]="R"+(riskPenalty(new Date().getFullYear()-new Date(dateProcessed).getFullYear()-e.withoutMed-35)*parseFloat(plan.dependentTotalAdult.replace("R","").replace("N/A",0))).toFixed(2);});_this2.props.state.dependentsChild.map(function(e,k){risks[i].contribution.risk[k+1+_this2.props.state.dependentsAdult.length]="R"+parseFloat(plan.dependendContributionChild.replace("R","").replace("N/A",0)).toFixed(2);if(plan.dependentCompSavingsChild!="")risks[i].contribution.savings[k+1+_this2.props.state.dependentsAdult.length]="R"+parseFloat(plan.dependentCompSavingsChild.replace("R","").replace("N/A",0)).toFixed(2);else risks[i].contribution.savings[k+1+_this2.props.state.dependentsAdult.length]="R0.00";if(plan.maxChildContribution!=""&&k+1>plan.maxChildContribution){risks[i].contribution.risk[k+1+_this2.props.state.dependentsAdult.length]="R0.00";risks[i].contribution.savings[k+1+_this2.props.state.dependentsAdult.length]="R0.00";}});var subTotalRisk=0;risks[i].contribution.risk.forEach(function(e){subTotalRisk+=parseFloat(e.replace("R","").replace("N/A",0));console.log(subTotalRisk);});var subTotalSavings=0;risks[i].contribution.savings.forEach(function(e){subTotalSavings+=parseFloat(e.replace("R","").replace("N/A",0));});var subTotalLjp=0;risks[i].contribution.ljp.forEach(function(e){subTotalLjp+=parseFloat(e.toString().replace("R","").replace("N/A",0));});risks[i].subTotalM[0]="R"+parseFloat(subTotalRisk).toFixed(2);risks[i].subTotalM[1]="R"+parseFloat(subTotalSavings).toFixed(2);risks[i].subTotalM[2]="R"+parseFloat(subTotalLjp).toFixed(2);risks[i].totalM="R"+(parseFloat(subTotalRisk)+parseFloat(subTotalSavings)+parseFloat(subTotalLjp)).toFixed(2);if(_this2.props.state.gapCover==1){__WEBPACK_IMPORTED_MODULE_4__GapDetails_jsx__["a" /* gapDetails */].forEach(function(e){if(e.plan==_this2.props.state.selectedTargetsGap[0]){if(_this2.props.state.dependentsAdult.length+_this2.props.state.dependentsChild.length>0){risks[i].gap="R"+parseFloat(e.family.replace("R","")).toFixed(2);}else risks[i].gap="R"+parseFloat(e.single.replace("R","")).toFixed(2);}});}if(_this2.props.state.hSaverOption==1&&plan.planType!="Traditional"){risks[i].hSaver="R"+((_this2.props.state.dToD-subTotalSavings*12)/12).toFixed(2);if(parseFloat(risks[i].hSaver.replace("R",""))<0)risks[i].hSaver="R0.00";}if(_this2.props.state.hSaverOption==1&&plan.planType=="Traditional"){risks[i].hSaver="N/A";}if(_this2.props.state.loyalty==1){__WEBPACK_IMPORTED_MODULE_5__LoyaltyDetails_jsx__["a" /* loyaltyDetails */].forEach(function(e){if(e.company==plan.company){if(_this2.props.state.dependentsAdult.length+_this2.props.state.dependentsChild.length==0){risks[i].loyalty=e.member+".00";}if(_this2.props.state.dependentsAdult.length+_this2.props.state.dependentsChild.length==1){risks[i].loyalty=e.memberPlus+".00";}if(_this2.props.state.dependentsAdult.length+_this2.props.state.dependentsChild.length>1){risks[i].loyalty=e.family+".00";}}});}if(risks[i].loyalty=="0.00"){risks[i].loyalty="N/A";}risks[i].brokerFee="R"+parseFloat(_this2.props.state.brokerFee).toFixed(2);risks[i].subsidy="R"+parseFloat(_this2.props.state.subsidy).toFixed(2);risks[i].totalB="R"+(parseFloat(risks[i].totalM.replace("R",""))+parseFloat(risks[i].brokerFee.replace("R",""))-parseFloat(risks[i].subsidy.replace("R",""))+parseFloat(risks[i].gap.replace("R",""))+parseFloat(risks[i].hSaver.replace("R","").replace("N/A","0"))+parseFloat(risks[i].loyalty.replace("R","").replace("N/A","0"))).toFixed(2);if(parseFloat(risks[i].totalB.replace("R",""))<0)risks[i].totalB="R0.00";risks[i].selfGap="R";/*"R" + (parseFloat(plan.mainGapSelfPayment.replace("R", "").replace("", "0")) + parseFloat(plan.dependentGapSelfPaymentAdult.replace("R", "").replace("", "0")) * this.props.state.dependentsAdult.length 
                                + parseFloat(plan.dependentGapSelfPaymentChild.replace("R", "").replace("", "0")) * this.props.state.dependentsChild.length).toFixed(2)*/if(plan.maxChildContribution!=""&&_this2.props.state.dependentsChild.length>plan.maxChildContribution){//Self Gap paypent was excluded in later data sets.
/*
                risks[i].selfGap = "R" + (parseFloat(plan.mainGapSelfPayment.replace("R", "").replace("", "0")) + parseFloat(plan.dependentGapSelfPaymentAdult.replace("R", "").replace("", "0")) * this.props.state.dependentsAdult.length 
                + parseFloat(plan.dependentGapSelfPaymentChild.replace("R", "").replace("", "0")) * plan.maxChildContribution).toFixed(2)*/}risks[i].threshold="R"+(parseFloat(plan.mainThreshold.replace("R","").replace("","0"))+parseFloat(plan.dependentThresholdAdult.replace("R","").replace("","0"))*_this2.props.state.dependentsAdult.length+parseFloat(plan.dependentThresholdChild.replace("R","").replace("","0"))*_this2.props.state.dependentsChild.length).toFixed(2);if(plan.maxChildContribution!=""&&_this2.props.state.dependentsChild.length>plan.maxChildContribution){risks[i].threshold="R"+(parseFloat(plan.mainThreshold.replace("R","").replace("","0"))+parseFloat(plan.dependentThresholdAdult.replace("R","").replace("","0"))*_this2.props.state.dependentsAdult.length+parseFloat(plan.dependentThresholdChild.replace("R","").replace("","0"))*plan.maxChildContribution).toFixed(2);}risks[i].savingsCom="R"+(subTotalSavings*12+parseFloat(risks[i].hSaver.replace("R","").replace("N/A","0"))*12).toFixed(2);var mounth=12-parseInt(_this2.props.state.startDate.split("/")[1]-1);risks[i].dToD="R"+((subTotalSavings+parseFloat(risks[i].hSaver.replace("R","").replace("N/A","0")))*mounth).toFixed(2);risks[i].empty=false;/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
/*                                                           Plan details for PDF                                                              *//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
risks[i].details.preferedHospitalProvider=plan.preferedHospitalProvider;risks[i].details.overallLimit=plan.overallLimit;risks[i].details.coPayment=plan.coPayment;risks[i].details.rate=plan.rate;risks[i].details.generalMedicin=plan.generalMedicin;risks[i].details.specialist=plan.specialist;risks[i].details.dentistSurgical=plan.dentistSurgical;risks[i].details.mentalHealth=plan.mentalHealth;risks[i].details.radiology=plan.radiology;risks[i].details.pathology=plan.pathology;risks[i].details.maternityBenefit=plan.maternityBenefit;risks[i].details.dialysis=plan.dialysis;risks[i].details.cancer=plan.cancer;risks[i].details.transplant=plan.transplant;risks[i].details.mri=plan.mri;risks[i].details.prosthesisInternal=plan.prosthesisInternal;risks[i].details.prosthesisExternal=plan.prosthesisExternal;risks[i].details.rehab=plan.rehab;risks[i].details.designatedServiceProvider=plan.designatedServiceProvider;risks[i].details.conditionsCovered=plan.conditionsCovered;risks[i].details.formulary=plan.formulary;risks[i].details.adChronic=plan.adChronic;risks[i].details.preferredProvider=plan.preferredProvider;risks[i].details.routineBenefit=plan.routineBenefit;risks[i].details.overallAnualLimit=plan.overallAnualLimit;risks[i].details.medicationOverCounter=plan.medicationOverCounter;risks[i].details.medicationPrescribed=plan.medicationPrescribed;risks[i].details.practitionersGeneral=plan.practitionersGeneral;risks[i].details.specialistsCover=plan.specialistsCover;risks[i].details.dentistryCover=plan.dentistryCover;risks[i].details.dentistryCoverSpecial=plan.dentistryCoverSpecial;risks[i].details.optical=plan.optical;risks[i].details.ambulance=plan.ambulance;risks[i].details.international=plan.international;risks[i].details.hospitalCoverAids=plan.hospitalCoverAids;risks[i].details.artTtreatment=plan.artTtreatment;risks[i].details.preventative=plan.preventative;risks[i].details.trauma=plan.trauma;}});});console.log(this.props.state);var rows=[];var rowCount=0;var rowCounter=0;var rowsH=[];var rowCountH=0;var rowCounterH=0;var rowsC=[];var rowCountC=0;var rowCounterC=0;var rowsD=[];var rowCountD=0;var rowCounterD=0;//companies
rows[rowCount]=[];risks.forEach(function(e){if(!e.empty){rows[rowCount].push(e.company);}else rows[rowCount].push(" ");rows[rowCount].push(" ");});//plans
rowCount++;rows[rowCount]=[];risks.forEach(function(e){if(!e.empty){rows[rowCount].push(e.plan);rows[rowCount].push(" ");}});//Plan Type
rowCount++;rows[rowCount]=[];risks.forEach(function(e){if(!e.empty){rows[rowCount].push(e.planType);rows[rowCount].push(" ");}});//Contributions
//headings
rowCount++;rows[rowCount]=[];risks.forEach(function(e){if(!e.empty){rows[rowCount].push("Risk");rows[rowCount].push("Savings");rows[rowCount].push("LJP");rows[rowCount].push(" ");}});//Main member
rowCount++;rows[rowCount]=[];risks.forEach(function(e){if(!e.empty){rows[rowCount].push(e.contribution.risk[0]);rows[rowCount].push(e.contribution.savings[0]);rows[rowCount].push(e.contribution.ljp[0]);rows[rowCount].push(" ");}});//Adult dependants
for(var i=0;i<this.props.state.dependentsAdult.length;i++){rowCount++;rows[rowCount]=[];rows[rowCount].push("Adult "+(i+1));risks.forEach(function(e){if(!e.empty){rows[rowCount].push(e.contribution.risk[1+i]);rows[rowCount].push(e.contribution.savings[1+i]);rows[rowCount].push(e.contribution.ljp[1+i]);rows[rowCount].push(" ");}});}//Child dependants
for(var i=0;i<this.props.state.dependentsChild.length;i++){rowCount++;rows[rowCount]=[];rows[rowCount].push("Child "+(i+1));risks.forEach(function(e){if(!e.empty){rows[rowCount].push(e.contribution.risk[1+_this2.props.state.dependentsAdult.length+i]);rows[rowCount].push(e.contribution.savings[1+_this2.props.state.dependentsAdult.length+i]);rows[rowCount].push(e.contribution.ljp[1+_this2.props.state.dependentsAdult.length+i]);rows[rowCount].push(" ");}});}//SubTotal medical
rowCount++;rows[rowCount]=[];risks.forEach(function(e){if(!e.empty){rows[rowCount].push(e.subTotalM[0]);rows[rowCount].push(e.subTotalM[1]);rows[rowCount].push(e.subTotalM[2]);rows[rowCount].push(" ");}});//Total medical
rowCount++;rows[rowCount]=[];risks.forEach(function(e){if(!e.empty)rows[rowCount].push(e.totalM);});//Table seperator
rowCount++;rows[rowCount]=[];risks.forEach(function(e){if(!e.empty)rows[rowCount].push(" ");});//gap cover
if(this.props.state.gapCover==1){rowCount++;rows[rowCount]=[];risks.forEach(function(e){if(!e.empty)rows[rowCount].push(e.gap);});}//Health saver
if(this.props.state.hSaverOption==1){rowCount++;rows[rowCount]=[];risks.forEach(function(e){if(!e.empty)rows[rowCount].push(e.hSaver);});}//Loyalty Program
if(this.props.state.loyalty==1){rowCount++;rows[rowCount]=[];risks.forEach(function(e){if(!e.empty)rows[rowCount].push(e.loyalty);});}//Broker Fee
rowCount++;rows[rowCount]=[];risks.forEach(function(e){if(!e.empty)rows[rowCount].push(e.brokerFee);});//Monthly subsidy 
rowCount++;rows[rowCount]=[];risks.forEach(function(e){if(!e.empty)rows[rowCount].push(e.subsidy);});//Total mounthly contribution 
rowCount++;rows[rowCount]=[];risks.forEach(function(e){if(!e.empty)rows[rowCount].push(e.totalB);});//Table seperator
rowCount++;rows[rowCount]=[];risks.forEach(function(e){if(!e.empty)rows[rowCount].push(" ");});//Threshold
rowCount++;rows[rowCount]=[];risks.forEach(function(e){if(!e.empty)rows[rowCount].push(e.threshold);});//Self payment gap
/*rowCount++;
      rows[rowCount] = [];

      risks.forEach(e => 
      {
        if(!e.empty)
          rows[rowCount].push(e.selfGap)
      });*///Annual savings
rowCount++;rows[rowCount]=[];risks.forEach(function(e){if(!e.empty)rows[rowCount].push(e.savingsCom);});//Day to Day
rowCount++;rows[rowCount]=[];risks.forEach(function(e){if(!e.empty)rows[rowCount].push(e.dToD);});//pdf button
rowCount++;rows[rowCount]=[];risks.forEach(function(e){if(!e.empty)rows[rowCount].push(e.pdf);});/*************************************************************************************************************************************** *///NEW TABLE
/*Hospital Benefits*/rowsH[rowCountH]=[];risks.forEach(function(e){rowsH[rowCountH].push(e.company);});//prefered hospital provider
rowCountH++;rowsH[rowCountH]=[];risks.forEach(function(e){rowsH[rowCountH].push(e.details.preferedHospitalProvider);});//overall limit
rowCountH++;rowsH[rowCountH]=[];risks.forEach(function(e){rowsH[rowCountH].push(e.details.overallLimit);});//Co payment
rowCountH++;rowsH[rowCountH]=[];risks.forEach(function(e){rowsH[rowCountH].push(e.details.coPayment);});//Rate
rowCountH++;rowsH[rowCountH]=[];risks.forEach(function(e){rowsH[rowCountH].push(e.details.rate);});//Medicin general
rowCountH++;rowsH[rowCountH]=[];risks.forEach(function(e){rowsH[rowCountH].push(e.details.generalMedicin);});//specialist
rowCountH++;rowsH[rowCountH]=[];risks.forEach(function(e){rowsH[rowCountH].push(e.details.specialist);});//Dentistry surgical
rowCountH++;rowsH[rowCountH]=[];risks.forEach(function(e){rowsH[rowCountH].push(e.details.dentistSurgical);});//Mental Health
rowCountH++;rowsH[rowCountH]=[];risks.forEach(function(e){rowsH[rowCountH].push(e.details.mentalHealth);});//radiology
rowCountH++;rowsH[rowCountH]=[];risks.forEach(function(e){rowsH[rowCountH].push(e.details.radiology);});//pathology
rowCountH++;rowsH[rowCountH]=[];risks.forEach(function(e){rowsH[rowCountH].push(e.details.pathology);});//Metirnety
rowCountH++;rowsH[rowCountH]=[];risks.forEach(function(e){rowsH[rowCountH].push(e.details.maternityBenefit);});//dialysis
rowCountH++;rowsH[rowCountH]=[];risks.forEach(function(e){rowsH[rowCountH].push(e.details.dialysis);});//cancer
rowCountH++;rowsH[rowCountH]=[];risks.forEach(function(e){rowsH[rowCountH].push(e.details.cancer);});//transplant
rowCountH++;rowsH[rowCountH]=[];risks.forEach(function(e){rowsH[rowCountH].push(e.details.transplant);});//mri
rowCountH++;rowsH[rowCountH]=[];risks.forEach(function(e){rowsH[rowCountH].push(e.details.mri);});//prosthesisInternal
rowCountH++;rowsH[rowCountH]=[];risks.forEach(function(e){rowsH[rowCountH].push(e.details.prosthesisInternal);});//prosthesisExternal
rowCountH++;rowsH[rowCountH]=[];risks.forEach(function(e){rowsH[rowCountH].push(e.details.prosthesisExternal);});//rehab
rowCountH++;rowsH[rowCountH]=[];risks.forEach(function(e){rowsH[rowCountH].push(e.details.rehab);});/*********************************************************************************************************************** *///NEW TABLE
/*Chronic*/rowsC[rowCountC]=[];risks.forEach(function(e){rowsC[rowCountC].push(e.company);});//Chronic provider
rowCountC++;rowsC[rowCountC]=[];risks.forEach(function(e){rowsC[rowCountC].push(e.details.designatedServiceProvider);});//Conditions
rowCountC++;rowsC[rowCountC]=[];risks.forEach(function(e){rowsC[rowCountC].push(e.details.conditionsCovered);});//formulary
rowCountC++;rowsC[rowCountC]=[];risks.forEach(function(e){rowsC[rowCountC].push(e.details.formulary);});//Additional chronic conditions
rowCountC++;rowsC[rowCountC]=[];risks.forEach(function(e){rowsC[rowCountC].push(e.details.adChronic);});/********************************************************************************************************************************* *///NEW TABLE
/*Day To Day*/rowsD[rowCountD]=[];risks.forEach(function(e){rowsD[rowCountD].push(e.company);});//Day to Day service provider
rowCountD++;rowsD[rowCountD]=[];risks.forEach(function(e){rowsD[rowCountD].push(e.details.preferredProvider);});//Routine benefits
rowCountD++;rowsD[rowCountD]=[];risks.forEach(function(e){rowsD[rowCountD].push(e.details.routineBenefit);});//Anual limit
rowCountD++;rowsD[rowCountD]=[];risks.forEach(function(e){rowsD[rowCountD].push(e.details.overallAnualLimit);});//OTC Medication
rowCountD++;rowsD[rowCountD]=[];risks.forEach(function(e){rowsD[rowCountD].push(e.details.medicationOverCounter);});//Perscribed Medication
rowCountD++;rowsD[rowCountD]=[];risks.forEach(function(e){rowsD[rowCountD].push(e.details.medicationPrescribed);});//General practitionar
rowCountD++;rowsD[rowCountD]=[];risks.forEach(function(e){rowsD[rowCountD].push(e.details.practitionersGeneral);});//Specialist
rowCountD++;rowsD[rowCountD]=[];risks.forEach(function(e){rowsD[rowCountD].push(e.details.specialistsCover);});//Dentistry
rowCountD++;rowsD[rowCountD]=[];risks.forEach(function(e){rowsD[rowCountD].push(e.details.dentistryCover);});//Dentistry Special
rowCountD++;rowsD[rowCountD]=[];risks.forEach(function(e){rowsD[rowCountD].push(e.details.dentistryCoverSpecial);});//optical
rowCountD++;rowsD[rowCountD]=[];risks.forEach(function(e){rowsD[rowCountD].push(e.details.optical);});//ambulance
rowCountD++;rowsD[rowCountD]=[];risks.forEach(function(e){rowsD[rowCountD].push(e.details.ambulance);});//international
rowCountD++;rowsD[rowCountD]=[];risks.forEach(function(e){rowsD[rowCountD].push(e.details.international);});//Aids hospital
rowCountD++;rowsD[rowCountD]=[];risks.forEach(function(e){rowsD[rowCountD].push(e.details.hospitalCoverAids);});//ART treatment
rowCountD++;rowsD[rowCountD]=[];risks.forEach(function(e){rowsD[rowCountD].push(e.details.artTtreatment);});//preventative
rowCountD++;rowsD[rowCountD]=[];risks.forEach(function(e){rowsD[rowCountD].push(e.details.preventative);});//trauma
/*    rowCountD++;
         rowsD[rowCountD] = [];
  
         risks.forEach(e => 
         {
           rowsD[rowCountD].push(e.details.trauma)
         });*/return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'contentWithStepper'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["e" /* Card */],{className:this.classes,style:{}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_CustomCardHeading_CustomCardHeading_jsx__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["f" /* CardContent */],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["e" /* Card */],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_CustomCardHeading_CustomCardHeading_jsx__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["f" /* CardContent */],{id:'resultTable'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Q" /* Table */],{size:'small'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,'                                                          ',__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{width:'7%'},' '),rows[rowCounter++].map(function(cell){if(cell!=" ")return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{colSpan:3,padding:'dense',style:{textAlign:"center"}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('img',{src:cell,alt:cell,className:'targetAffiliationLogo'}));else return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{padding:'none'});})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["R" /* TableBody */],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,'                                                          ',__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,' '),rows[rowCounter++].map(function(cell){if(cell!=" ")return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{colSpan:3,padding:'dense',style:{textAlign:"center"}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('strong',null,cell));else return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{padding:'none'});})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,'                                                          ',__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,' '),rows[rowCounter++].map(function(cell){if(cell!=" ")return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{colSpan:3,padding:'dense',style:{textAlign:"center"}},cell);else return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{padding:'none'});})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,'                              ',__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{width:'10%'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('strong',null,'Member')),rows[rowCounter++].map(function(cell){if(cell!=" ")return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{padding:'none',width:'5%',style:{borderLeft:"1px solid #fcfcfc",textAlign:"center"}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('strong',null,cell));else return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{padding:'none',width:'1%',style:{borderLeft:"1px solid #fcfcfc",textAlign:"center"}});})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,'                                ',__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,'Principal'),rows[rowCounter++].map(function(cell){if(cell!=" ")return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{padding:'none',width:'5%',style:{borderLeft:"1px solid #fcfcfc",textAlign:"center"}},cell);else return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{padding:'none',width:'1%',style:{borderLeft:"1px solid #fcfcfc",textAlign:"center"}});})),this.props.state.dependentsAdult.map(function(row){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,'                            ',rows[rowCounter++].map(function(cell){if(cell!=" "&&cell){if(cell)if(typeof cell=="string"&&cell.indexOf("Adult")>-1)return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{width:'5%'},cell);return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{padding:'none',width:'5%',style:{borderLeft:"1px solid #fcfcfc",textAlign:"center"}},cell);}else return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{padding:'none',width:'1%',style:{borderLeft:"1px solid #fcfcfc",textAlign:"center"}});}));}),this.props.state.dependentsChild.map(function(row){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,'                            ',rows[rowCounter++].map(function(cell){if(cell!=" "){if(cell)if(cell.includes("Child"))return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{width:'5%'},cell);return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{padding:'none',width:'5%',style:{borderLeft:"1px solid #fcfcfc",textAlign:"center"}},cell);}else return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{padding:'none',width:'1%',style:{borderLeft:"1px solid #fcfcfc",textAlign:"center"}});}));}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,'                                                           ',__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,'Total'),rows[rowCounter++].map(function(cell){if(cell!=" ")return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{padding:'none',width:'5%',style:{borderLeft:"1px solid #fcfcfc",textAlign:"center"}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('strong',null,cell));else return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{padding:'none',width:'1%',style:{borderLeft:"1px solid #fcfcfc",textAlign:"center"}});})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,'                                                           ',__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{padding:'dense'},'Total medical aid contribution'),rows[rowCounter++].map(function(cell){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{colSpan:3,padding:'dense',style:{textAlign:"center"}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('i',null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('strong',null,cell))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{colSpan:1,padding:'dense'}));})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,'                                                           ',__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{padding:'dense'}),rows[rowCounter++].map(function(cell){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{colSpan:3,padding:'dense',style:{textAlign:"center"}},cell),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{colSpan:1,padding:'dense'}));})),this.props.state.gapCover==1&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,'                                                     ',__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{padding:'dense'},'Gap cover'),rows[rowCounter++].map(function(cell){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{colSpan:3,padding:'dense',style:{textAlign:"center"}},cell),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{colSpan:1,padding:'dense'}));})),this.props.state.hSaverOption==1&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,'                                                     ',__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{padding:'dense'},'Savings Topup'),rows[rowCounter++].map(function(cell){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{colSpan:3,padding:'dense',style:{textAlign:"center"}},cell),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{colSpan:1,padding:'dense'}));})),this.props.state.loyalty==1&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,'                                                     ',__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{padding:'dense'},'Loyalty Program'),rows[rowCounter++].map(function(cell){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{colSpan:3,padding:'dense',style:{textAlign:"center"}},cell),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{colSpan:1,padding:'dense'}));})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,'                                                           ',__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{padding:'dense'},'Broker Fee'),rows[rowCounter++].map(function(cell){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{colSpan:3,padding:'dense',style:{textAlign:"center"}},cell),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{colSpan:1,padding:'dense'}));})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,'                                                           ',__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{padding:'dense'},'Monthly Subsidy'),rows[rowCounter++].map(function(cell){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{colSpan:3,padding:'dense',style:{textAlign:"center"}},cell),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{colSpan:1,padding:'dense'}));})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,'                                                           ',__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{padding:'dense'},'Total monthly contribution'),rows[rowCounter++].map(function(cell){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{colSpan:3,padding:'dense',style:{textAlign:"center"}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('strong',null,cell)),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{colSpan:1,padding:'dense'}));})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,'                                                           ',__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{colSpan:1,padding:'dense'}),rows[rowCounter++].map(function(cell){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{colSpan:3,padding:'dense',style:{textAlign:"center"}},cell),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{colSpan:1,padding:'dense'}));})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,'                                                           ',__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{padding:'dense'},'Threshold'),rows[rowCounter++].map(function(cell){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{colSpan:3,padding:'dense',style:{textAlign:"center"}},cell),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{colSpan:1,padding:'dense'}));})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,'                                                           ',__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{padding:'dense'},'Annual combined savings'),rows[rowCounter++].map(function(cell){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{colSpan:3,padding:'dense',style:{textAlign:"center"}},cell),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{colSpan:1,padding:'dense'}));})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,'                                                           ',__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{padding:'dense'},'Prorata day to day'),rows[rowCounter++].map(function(cell){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{colSpan:3,padding:'dense',style:{textAlign:"center"}},cell),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{colSpan:1,padding:'dense'}));})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,'                                                           ',__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null),rows[rowCounter++].map(function(cell){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{colSpan:3,className:'centerCell',key:cell,style:{padding:'0px'}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('a',{href:cell,target:'_blank'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["d" /* Button */],{variant:'outlined',className:'outlinedButton',style:{color:'#55526f',borderRadius:'50px',marginTop:'10px',marginBottom:'10px'}},'View PDF'))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{colSpan:1,padding:'dense'}));})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],{style:{borderTop:'double'},key:Math.random()},this.props.makeDownloadLinks))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{style:{display:"none"}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('h3',{className:'head4'},'Benefits'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('h4',null,'In Hospital')),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Q" /* Table */],{style:{display:"none"},size:'small'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,'                                                          ',__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{width:'7%'},' '),rowsH[rowCounterH++].map(function(cell){if(cell!=" ")return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{padding:'dense',style:{textAlign:"center"}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('img',{src:cell,alt:'',className:'targetAffiliationLogo'}));else return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{padding:'none'});})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,'                                                          ',__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{width:'7%',padding:'dense'},'Preferred provider'),rowsH[rowCounterH++].map(function(cell){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{width:'15%',colSpan:1,padding:'dense',style:{textAlign:"center"}},cell));})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,'                                                          ',__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{padding:'dense'},'Overall limit'),rowsH[rowCounterH++].map(function(cell){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{colSpan:1,padding:'dense',style:{textAlign:"center"}},cell));})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,'                                                          ',__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{padding:'dense'},'Co-payment'),rowsH[rowCounterH++].map(function(cell){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{colSpan:1,padding:'dense',style:{textAlign:"center"}},cell));})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,'                                                          ',__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{padding:'dense'},'Rate'),rowsH[rowCounterH++].map(function(cell){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{colSpan:1,padding:'dense',style:{textAlign:"center"}},cell));})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,'                                                          ',__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{padding:'dense'},'Take out medicine'),rowsH[rowCounterH++].map(function(cell){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{colSpan:1,padding:'dense',style:{textAlign:"center"}},cell));})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,'                                                          ',__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{padding:'dense'},'GP\u2019s and specialists'),rowsH[rowCounterH++].map(function(cell){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{colSpan:1,padding:'dense',style:{textAlign:"center"}},cell));})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,'                                                          ',__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{padding:'dense'},'Surgical dentistry'),rowsH[rowCounterH++].map(function(cell){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{colSpan:1,padding:'dense',style:{textAlign:"center"}},cell));})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,'                                                          ',__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{padding:'dense'},'Mental health'),rowsH[rowCounterH++].map(function(cell){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{colSpan:1,padding:'dense',style:{textAlign:"center"}},cell));})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,'                                                          ',__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{padding:'dense'},'Radiology'),rowsH[rowCounterH++].map(function(cell){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{colSpan:1,padding:'dense',style:{textAlign:"center"}},cell));})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,'                                                          ',__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{padding:'dense'},'Pathology'),rowsH[rowCounterH++].map(function(cell){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{colSpan:1,padding:'dense',style:{textAlign:"center"}},cell));})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,'                                                          ',__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{padding:'dense'},'Maternity benefit'),rowsH[rowCounterH++].map(function(cell){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{colSpan:1,padding:'dense',style:{textAlign:"center"}},cell));})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,'                                                          ',__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{padding:'dense'},'Dialysis'),rowsH[rowCounterH++].map(function(cell){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{colSpan:1,padding:'dense',style:{textAlign:"center"}},cell));})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,'                                                          ',__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{padding:'dense'},'Oncology (Cancer)'),rowsH[rowCounterH++].map(function(cell){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{colSpan:1,padding:'dense',style:{textAlign:"center"}},cell));})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,'                                                          ',__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{padding:'dense'},'Preferred provider'),rowsH[rowCounterH++].map(function(cell){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{colSpan:1,padding:'dense',style:{textAlign:"center"}},cell));})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,'                                                          ',__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{padding:'dense'},'MRI CAT MRPY & PET scans'),rowsH[rowCounterH++].map(function(cell){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{colSpan:1,padding:'dense',style:{textAlign:"center"}},cell));})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,'                                                          ',__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{padding:'dense'},'Internal prosthesis'),rowsH[rowCounterH++].map(function(cell){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{colSpan:1,padding:'dense',style:{textAlign:"center"}},cell));})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,'                                                          ',__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{padding:'dense'},'Internal prosthesis'),rowsH[rowCounterH++].map(function(cell){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{colSpan:1,padding:'dense',style:{textAlign:"center"}},cell));})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,'                                                          ',__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{padding:'dense'},'Rehabilitation, hospice, private nursing & stepdown'),rowsH[rowCounterH++].map(function(cell){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{colSpan:1,padding:'dense',style:{textAlign:"center"}},cell));}))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{style:{display:"none"}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('h4',null,'Chronic')),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Q" /* Table */],{style:{display:"none"},size:'small'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,'                                                          ',__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{width:'7%'},' '),rowsC[rowCounterC++].map(function(cell){if(cell!=" ")return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{padding:'dense',style:{textAlign:"center"}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('img',{src:cell,alt:'',className:'targetAffiliationLogo'}));else return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{padding:'none'});})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,'                                                          ',__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{width:'7%',padding:'dense'},'Designated service provider'),rowsC[rowCounterC++].map(function(cell){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{width:'15%',colSpan:1,padding:'dense',style:{textAlign:"center"}},cell));})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,'                                                          ',__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{padding:'dense'},'Conditions covered'),rowsC[rowCounterC++].map(function(cell){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{colSpan:1,padding:'dense',style:{textAlign:"center"}},cell));})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,'                                                          ',__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{padding:'dense'},'Formulary'),rowsC[rowCounterC++].map(function(cell){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{colSpan:1,padding:'dense',style:{textAlign:"center"}},cell));})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,'                                                          ',__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{padding:'dense'},'Additional chronic conditions/Co-payments'),rowsC[rowCounterC++].map(function(cell){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{colSpan:1,padding:'dense',style:{textAlign:"center"}},cell));}))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{style:{display:"none"}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('h4',null,'Day to day')),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Q" /* Table */],{style:{display:"none"},size:'small'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,'                                                          ',__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{width:'7%'},' '),rowsD[rowCounterD++].map(function(cell){if(cell!=" ")return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{padding:'dense',style:{textAlign:"center"}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('img',{src:cell,alt:'',className:'targetAffiliationLogo'}));else return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{padding:'none'});})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,'                                                          ',__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{width:'7%',padding:'dense'},'Preferred provider'),rowsD[rowCounterD++].map(function(cell){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{width:'15%',colSpan:1,padding:'dense',style:{textAlign:"center"}},cell));})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,'                                                          ',__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{width:'7%',padding:'dense'},'Routine benefit'),rowsD[rowCounterD++].map(function(cell){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{width:'15%',colSpan:1,padding:'dense',style:{textAlign:"center"}},cell));})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,'                                                          ',__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{width:'7%',padding:'dense'},'Overall annual limit'),rowsD[rowCounterD++].map(function(cell){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{width:'15%',colSpan:1,padding:'dense',style:{textAlign:"center"}},cell));})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,'                                                          ',__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{width:'7%',padding:'dense'},'Over the counter medicine'),rowsD[rowCounterD++].map(function(cell){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{width:'15%',colSpan:1,padding:'dense',style:{textAlign:"center"}},cell));})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,'                                                          ',__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{width:'7%',padding:'dense'},'Prescribed medicine'),rowsD[rowCounterD++].map(function(cell){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{width:'15%',colSpan:1,padding:'dense',style:{textAlign:"center"}},cell));})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,'                                                          ',__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{width:'7%',padding:'dense'},'General practitioners'),rowsD[rowCounterD++].map(function(cell){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{width:'15%',colSpan:1,padding:'dense',style:{textAlign:"center"}},cell));})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,'                                                          ',__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{width:'7%',padding:'dense'},'Specialists'),rowsD[rowCounterD++].map(function(cell){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{width:'15%',colSpan:1,padding:'dense',style:{textAlign:"center"}},cell));})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,'                                                          ',__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{width:'7%',padding:'dense'},'Conservative dentistry'),rowsD[rowCounterD++].map(function(cell){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{width:'15%',colSpan:1,padding:'dense',style:{textAlign:"center"}},cell));})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,'                                                          ',__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{width:'7%',padding:'dense'},'Specialised dentistry'),rowsD[rowCounterD++].map(function(cell){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{width:'15%',colSpan:1,padding:'dense',style:{textAlign:"center"}},cell));})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,'                                                          ',__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{width:'7%',padding:'dense'},'Optical (glasses etc.)'),rowsD[rowCounterD++].map(function(cell){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{width:'15%',colSpan:1,padding:'dense',style:{textAlign:"center"}},cell));})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,'                                                          ',__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{width:'7%',padding:'dense'},'Ambulance services'),rowsD[rowCounterD++].map(function(cell){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{width:'15%',colSpan:1,padding:'dense',style:{textAlign:"center"}},cell));})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,'                                                          ',__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{width:'7%',padding:'dense'},'International'),rowsD[rowCounterD++].map(function(cell){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{width:'15%',colSpan:1,padding:'dense',style:{textAlign:"center"}},cell));})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,'                                                          ',__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{width:'7%',padding:'dense'},'Hospitalisation for AIDS'),rowsD[rowCounterD++].map(function(cell){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{width:'15%',colSpan:1,padding:'dense',style:{textAlign:"center"}},cell));})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,'                                                          ',__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{width:'7%',padding:'dense'},'ART treatment'),rowsD[rowCounterD++].map(function(cell){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{width:'15%',colSpan:1,padding:'dense',style:{textAlign:"center"}},cell));})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,'                                                          ',__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{width:'7%',padding:'dense'},'Preventative care'),rowsD[rowCounterD++].map(function(cell){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{width:'15%',colSpan:1,padding:'dense',style:{textAlign:"center"}},cell));}))))))));}}]);return BenefitMapping;}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (BenefitMapping);

/***/ }),
/* 2836 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return loyaltyDetails; });
var loyaltyDetails=[{"company":"Bonitas","plan":"Reality core","member":"R70","memberPlus":"R100","family":"R100"},{"company":"Bonitas","plan":"Reality health","member":"R160","memberPlus":"R200","family":"R200"},{"company":"Discovery","plan":"Vitality","member":"R280","memberPlus":"R340","family":"R395"},{"company":"Fedhealth","plan":"Sanlam reality","member":"R215","memberPlus":"R275","family":"R275"},{"company":"Health Squared","plan":"Agility rewards platinum","member":"R228","memberPlus":"R264","family":"R307"},{"company":"Hosmed","plan":"Sanlam reality","member":"R215","memberPlus":"R275","family":"R275"},{"company":"Medshield","plan":"Just rewards premium","member":"R149","memberPlus":"R149","family":"R149"},{"company":"Momentum","plan":"Multiply premium","member":"R238","memberPlus":"R328","family":"R358"}];

/***/ }),
/* 2837 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return subFieldsPagesSyncErrors; });
var subFieldsPages={epChildrenDeath:3,epChildrenDeathDisablity:3,epChildrenDeathImpairment:3};var ignoreSubFields=['dummyField'];var subFieldsPagesSyncErrors=function subFieldsPagesSyncErrors(syncErrors,page){Object.keys(subFieldsPages).forEach(function(f){if(syncErrors[f]&&page===subFieldsPages[f]&&Array.isArray(syncErrors[f])){syncErrors[f].forEach(function(a,i){ignoreSubFields.forEach(function(ignore){if(a[ignore]){delete syncErrors[f][i][ignore];}});});var emptyIndexes=0;syncErrors[f].forEach(function(a){if(Object.keys(a).length<1)emptyIndexes++;});if(emptyIndexes===syncErrors[f].length)delete syncErrors[f];}else{delete syncErrors[f];}});return syncErrors;};

/***/ }),
/* 2838 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MedicalFsp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return MedicalGapFsp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return MedicalLoyaltyFsp; });
var MedicalFsp=[{id:"1",name:"Bestmed",logo:""},{id:"2",name:"Bonitas",logo:""},{id:"3",name:"Compcare",logo:""},{id:"4",name:"Discovery",logo:""},{id:"5",name:"Fedhealth",logo:""},{id:"6",name:"Health Squared",logo:""},{id:"7",name:"Hosmed",logo:""},{id:"8",name:"Key Health",logo:""},{id:"9",name:"Medihelp",logo:""},{id:"10",name:"Medshield",logo:""},{id:"11",name:"Momentum",logo:""},{id:"12",name:"Siswe",logo:""}];var MedicalGapFsp=[{id:"1",name:"Agility (Health Squared)",logo:""},{id:"2",name:"Medcap (bonitas)",logo:""},{id:"3",name:"Curemed",logo:""},{id:"4",name:"Discovery",logo:""},{id:"5",name:"Liberty (Zest)",logo:""},{id:"6",name:"Momentum",logo:""},{id:"7",name:"Sirago",logo:""},{id:"8",name:"Stratum",logo:""},{id:"9",name:"TRA (Total risk administrators)",logo:""},{id:"10",name:"Turnberry",logo:""}];var MedicalLoyaltyFsp=[{id:"1",name:"Agility (Health Squared)",logo:""},{id:"2",name:"Healthprint (Medihelp)",logo:""},{id:"3",name:"Medshield",logo:""},{id:"4",name:"Multiply (Momentum)",logo:""},{id:"5",name:"Reality (Bonitas)",logo:""},{id:"6",name:"Reality (Fedhealth)",logo:""},{id:"7",name:"Vitality (Discovery)",logo:""}];

/***/ }),
/* 2839 */
/***/ (function(module, exports, __webpack_require__) {

/*jslint node:true */

var xml2js = __webpack_require__(745);
var xml2json = __webpack_require__(2853);
var js2xml = __webpack_require__(750);
var json2xml = __webpack_require__(2854);

module.exports = {
  xml2js: xml2js,
  xml2json: xml2json,
  js2xml: js2xml,
  json2xml: json2xml
};


/***/ }),
/* 2840 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {;(function (sax) { // wrapper for non-node envs
  sax.parser = function (strict, opt) { return new SAXParser(strict, opt) }
  sax.SAXParser = SAXParser
  sax.SAXStream = SAXStream
  sax.createStream = createStream

  // When we pass the MAX_BUFFER_LENGTH position, start checking for buffer overruns.
  // When we check, schedule the next check for MAX_BUFFER_LENGTH - (max(buffer lengths)),
  // since that's the earliest that a buffer overrun could occur.  This way, checks are
  // as rare as required, but as often as necessary to ensure never crossing this bound.
  // Furthermore, buffers are only tested at most once per write(), so passing a very
  // large string into write() might have undesirable effects, but this is manageable by
  // the caller, so it is assumed to be safe.  Thus, a call to write() may, in the extreme
  // edge case, result in creating at most one complete copy of the string passed in.
  // Set to Infinity to have unlimited buffers.
  sax.MAX_BUFFER_LENGTH = 64 * 1024

  var buffers = [
    'comment', 'sgmlDecl', 'textNode', 'tagName', 'doctype',
    'procInstName', 'procInstBody', 'entity', 'attribName',
    'attribValue', 'cdata', 'script'
  ]

  sax.EVENTS = [
    'text',
    'processinginstruction',
    'sgmldeclaration',
    'doctype',
    'comment',
    'opentagstart',
    'attribute',
    'opentag',
    'closetag',
    'opencdata',
    'cdata',
    'closecdata',
    'error',
    'end',
    'ready',
    'script',
    'opennamespace',
    'closenamespace'
  ]

  function SAXParser (strict, opt) {
    if (!(this instanceof SAXParser)) {
      return new SAXParser(strict, opt)
    }

    var parser = this
    clearBuffers(parser)
    parser.q = parser.c = ''
    parser.bufferCheckPosition = sax.MAX_BUFFER_LENGTH
    parser.opt = opt || {}
    parser.opt.lowercase = parser.opt.lowercase || parser.opt.lowercasetags
    parser.looseCase = parser.opt.lowercase ? 'toLowerCase' : 'toUpperCase'
    parser.tags = []
    parser.closed = parser.closedRoot = parser.sawRoot = false
    parser.tag = parser.error = null
    parser.strict = !!strict
    parser.noscript = !!(strict || parser.opt.noscript)
    parser.state = S.BEGIN
    parser.strictEntities = parser.opt.strictEntities
    parser.ENTITIES = parser.strictEntities ? Object.create(sax.XML_ENTITIES) : Object.create(sax.ENTITIES)
    parser.attribList = []

    // namespaces form a prototype chain.
    // it always points at the current tag,
    // which protos to its parent tag.
    if (parser.opt.xmlns) {
      parser.ns = Object.create(rootNS)
    }

    // mostly just for error reporting
    parser.trackPosition = parser.opt.position !== false
    if (parser.trackPosition) {
      parser.position = parser.line = parser.column = 0
    }
    emit(parser, 'onready')
  }

  if (!Object.create) {
    Object.create = function (o) {
      function F () {}
      F.prototype = o
      var newf = new F()
      return newf
    }
  }

  if (!Object.keys) {
    Object.keys = function (o) {
      var a = []
      for (var i in o) if (o.hasOwnProperty(i)) a.push(i)
      return a
    }
  }

  function checkBufferLength (parser) {
    var maxAllowed = Math.max(sax.MAX_BUFFER_LENGTH, 10)
    var maxActual = 0
    for (var i = 0, l = buffers.length; i < l; i++) {
      var len = parser[buffers[i]].length
      if (len > maxAllowed) {
        // Text/cdata nodes can get big, and since they're buffered,
        // we can get here under normal conditions.
        // Avoid issues by emitting the text node now,
        // so at least it won't get any bigger.
        switch (buffers[i]) {
          case 'textNode':
            closeText(parser)
            break

          case 'cdata':
            emitNode(parser, 'oncdata', parser.cdata)
            parser.cdata = ''
            break

          case 'script':
            emitNode(parser, 'onscript', parser.script)
            parser.script = ''
            break

          default:
            error(parser, 'Max buffer length exceeded: ' + buffers[i])
        }
      }
      maxActual = Math.max(maxActual, len)
    }
    // schedule the next check for the earliest possible buffer overrun.
    var m = sax.MAX_BUFFER_LENGTH - maxActual
    parser.bufferCheckPosition = m + parser.position
  }

  function clearBuffers (parser) {
    for (var i = 0, l = buffers.length; i < l; i++) {
      parser[buffers[i]] = ''
    }
  }

  function flushBuffers (parser) {
    closeText(parser)
    if (parser.cdata !== '') {
      emitNode(parser, 'oncdata', parser.cdata)
      parser.cdata = ''
    }
    if (parser.script !== '') {
      emitNode(parser, 'onscript', parser.script)
      parser.script = ''
    }
  }

  SAXParser.prototype = {
    end: function () { end(this) },
    write: write,
    resume: function () { this.error = null; return this },
    close: function () { return this.write(null) },
    flush: function () { flushBuffers(this) }
  }

  var Stream
  try {
    Stream = __webpack_require__(2841).Stream
  } catch (ex) {
    Stream = function () {}
  }

  var streamWraps = sax.EVENTS.filter(function (ev) {
    return ev !== 'error' && ev !== 'end'
  })

  function createStream (strict, opt) {
    return new SAXStream(strict, opt)
  }

  function SAXStream (strict, opt) {
    if (!(this instanceof SAXStream)) {
      return new SAXStream(strict, opt)
    }

    Stream.apply(this)

    this._parser = new SAXParser(strict, opt)
    this.writable = true
    this.readable = true

    var me = this

    this._parser.onend = function () {
      me.emit('end')
    }

    this._parser.onerror = function (er) {
      me.emit('error', er)

      // if didn't throw, then means error was handled.
      // go ahead and clear error, so we can write again.
      me._parser.error = null
    }

    this._decoder = null

    streamWraps.forEach(function (ev) {
      Object.defineProperty(me, 'on' + ev, {
        get: function () {
          return me._parser['on' + ev]
        },
        set: function (h) {
          if (!h) {
            me.removeAllListeners(ev)
            me._parser['on' + ev] = h
            return h
          }
          me.on(ev, h)
        },
        enumerable: true,
        configurable: false
      })
    })
  }

  SAXStream.prototype = Object.create(Stream.prototype, {
    constructor: {
      value: SAXStream
    }
  })

  SAXStream.prototype.write = function (data) {
    if (typeof Buffer === 'function' &&
      typeof Buffer.isBuffer === 'function' &&
      Buffer.isBuffer(data)) {
      if (!this._decoder) {
        var SD = __webpack_require__(428).StringDecoder
        this._decoder = new SD('utf8')
      }
      data = this._decoder.write(data)
    }

    this._parser.write(data.toString())
    this.emit('data', data)
    return true
  }

  SAXStream.prototype.end = function (chunk) {
    if (chunk && chunk.length) {
      this.write(chunk)
    }
    this._parser.end()
    return true
  }

  SAXStream.prototype.on = function (ev, handler) {
    var me = this
    if (!me._parser['on' + ev] && streamWraps.indexOf(ev) !== -1) {
      me._parser['on' + ev] = function () {
        var args = arguments.length === 1 ? [arguments[0]] : Array.apply(null, arguments)
        args.splice(0, 0, ev)
        me.emit.apply(me, args)
      }
    }

    return Stream.prototype.on.call(me, ev, handler)
  }

  // this really needs to be replaced with character classes.
  // XML allows all manner of ridiculous numbers and digits.
  var CDATA = '[CDATA['
  var DOCTYPE = 'DOCTYPE'
  var XML_NAMESPACE = 'http://www.w3.org/XML/1998/namespace'
  var XMLNS_NAMESPACE = 'http://www.w3.org/2000/xmlns/'
  var rootNS = { xml: XML_NAMESPACE, xmlns: XMLNS_NAMESPACE }

  // http://www.w3.org/TR/REC-xml/#NT-NameStartChar
  // This implementation works on strings, a single character at a time
  // as such, it cannot ever support astral-plane characters (10000-EFFFF)
  // without a significant breaking change to either this  parser, or the
  // JavaScript language.  Implementation of an emoji-capable xml parser
  // is left as an exercise for the reader.
  var nameStart = /[:_A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]/

  var nameBody = /[:_A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\u00B7\u0300-\u036F\u203F-\u2040.\d-]/

  var entityStart = /[#:_A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]/
  var entityBody = /[#:_A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\u00B7\u0300-\u036F\u203F-\u2040.\d-]/

  function isWhitespace (c) {
    return c === ' ' || c === '\n' || c === '\r' || c === '\t'
  }

  function isQuote (c) {
    return c === '"' || c === '\''
  }

  function isAttribEnd (c) {
    return c === '>' || isWhitespace(c)
  }

  function isMatch (regex, c) {
    return regex.test(c)
  }

  function notMatch (regex, c) {
    return !isMatch(regex, c)
  }

  var S = 0
  sax.STATE = {
    BEGIN: S++, // leading byte order mark or whitespace
    BEGIN_WHITESPACE: S++, // leading whitespace
    TEXT: S++, // general stuff
    TEXT_ENTITY: S++, // &amp and such.
    OPEN_WAKA: S++, // <
    SGML_DECL: S++, // <!BLARG
    SGML_DECL_QUOTED: S++, // <!BLARG foo "bar
    DOCTYPE: S++, // <!DOCTYPE
    DOCTYPE_QUOTED: S++, // <!DOCTYPE "//blah
    DOCTYPE_DTD: S++, // <!DOCTYPE "//blah" [ ...
    DOCTYPE_DTD_QUOTED: S++, // <!DOCTYPE "//blah" [ "foo
    COMMENT_STARTING: S++, // <!-
    COMMENT: S++, // <!--
    COMMENT_ENDING: S++, // <!-- blah -
    COMMENT_ENDED: S++, // <!-- blah --
    CDATA: S++, // <![CDATA[ something
    CDATA_ENDING: S++, // ]
    CDATA_ENDING_2: S++, // ]]
    PROC_INST: S++, // <?hi
    PROC_INST_BODY: S++, // <?hi there
    PROC_INST_ENDING: S++, // <?hi "there" ?
    OPEN_TAG: S++, // <strong
    OPEN_TAG_SLASH: S++, // <strong /
    ATTRIB: S++, // <a
    ATTRIB_NAME: S++, // <a foo
    ATTRIB_NAME_SAW_WHITE: S++, // <a foo _
    ATTRIB_VALUE: S++, // <a foo=
    ATTRIB_VALUE_QUOTED: S++, // <a foo="bar
    ATTRIB_VALUE_CLOSED: S++, // <a foo="bar"
    ATTRIB_VALUE_UNQUOTED: S++, // <a foo=bar
    ATTRIB_VALUE_ENTITY_Q: S++, // <foo bar="&quot;"
    ATTRIB_VALUE_ENTITY_U: S++, // <foo bar=&quot
    CLOSE_TAG: S++, // </a
    CLOSE_TAG_SAW_WHITE: S++, // </a   >
    SCRIPT: S++, // <script> ...
    SCRIPT_ENDING: S++ // <script> ... <
  }

  sax.XML_ENTITIES = {
    'amp': '&',
    'gt': '>',
    'lt': '<',
    'quot': '"',
    'apos': "'"
  }

  sax.ENTITIES = {
    'amp': '&',
    'gt': '>',
    'lt': '<',
    'quot': '"',
    'apos': "'",
    'AElig': 198,
    'Aacute': 193,
    'Acirc': 194,
    'Agrave': 192,
    'Aring': 197,
    'Atilde': 195,
    'Auml': 196,
    'Ccedil': 199,
    'ETH': 208,
    'Eacute': 201,
    'Ecirc': 202,
    'Egrave': 200,
    'Euml': 203,
    'Iacute': 205,
    'Icirc': 206,
    'Igrave': 204,
    'Iuml': 207,
    'Ntilde': 209,
    'Oacute': 211,
    'Ocirc': 212,
    'Ograve': 210,
    'Oslash': 216,
    'Otilde': 213,
    'Ouml': 214,
    'THORN': 222,
    'Uacute': 218,
    'Ucirc': 219,
    'Ugrave': 217,
    'Uuml': 220,
    'Yacute': 221,
    'aacute': 225,
    'acirc': 226,
    'aelig': 230,
    'agrave': 224,
    'aring': 229,
    'atilde': 227,
    'auml': 228,
    'ccedil': 231,
    'eacute': 233,
    'ecirc': 234,
    'egrave': 232,
    'eth': 240,
    'euml': 235,
    'iacute': 237,
    'icirc': 238,
    'igrave': 236,
    'iuml': 239,
    'ntilde': 241,
    'oacute': 243,
    'ocirc': 244,
    'ograve': 242,
    'oslash': 248,
    'otilde': 245,
    'ouml': 246,
    'szlig': 223,
    'thorn': 254,
    'uacute': 250,
    'ucirc': 251,
    'ugrave': 249,
    'uuml': 252,
    'yacute': 253,
    'yuml': 255,
    'copy': 169,
    'reg': 174,
    'nbsp': 160,
    'iexcl': 161,
    'cent': 162,
    'pound': 163,
    'curren': 164,
    'yen': 165,
    'brvbar': 166,
    'sect': 167,
    'uml': 168,
    'ordf': 170,
    'laquo': 171,
    'not': 172,
    'shy': 173,
    'macr': 175,
    'deg': 176,
    'plusmn': 177,
    'sup1': 185,
    'sup2': 178,
    'sup3': 179,
    'acute': 180,
    'micro': 181,
    'para': 182,
    'middot': 183,
    'cedil': 184,
    'ordm': 186,
    'raquo': 187,
    'frac14': 188,
    'frac12': 189,
    'frac34': 190,
    'iquest': 191,
    'times': 215,
    'divide': 247,
    'OElig': 338,
    'oelig': 339,
    'Scaron': 352,
    'scaron': 353,
    'Yuml': 376,
    'fnof': 402,
    'circ': 710,
    'tilde': 732,
    'Alpha': 913,
    'Beta': 914,
    'Gamma': 915,
    'Delta': 916,
    'Epsilon': 917,
    'Zeta': 918,
    'Eta': 919,
    'Theta': 920,
    'Iota': 921,
    'Kappa': 922,
    'Lambda': 923,
    'Mu': 924,
    'Nu': 925,
    'Xi': 926,
    'Omicron': 927,
    'Pi': 928,
    'Rho': 929,
    'Sigma': 931,
    'Tau': 932,
    'Upsilon': 933,
    'Phi': 934,
    'Chi': 935,
    'Psi': 936,
    'Omega': 937,
    'alpha': 945,
    'beta': 946,
    'gamma': 947,
    'delta': 948,
    'epsilon': 949,
    'zeta': 950,
    'eta': 951,
    'theta': 952,
    'iota': 953,
    'kappa': 954,
    'lambda': 955,
    'mu': 956,
    'nu': 957,
    'xi': 958,
    'omicron': 959,
    'pi': 960,
    'rho': 961,
    'sigmaf': 962,
    'sigma': 963,
    'tau': 964,
    'upsilon': 965,
    'phi': 966,
    'chi': 967,
    'psi': 968,
    'omega': 969,
    'thetasym': 977,
    'upsih': 978,
    'piv': 982,
    'ensp': 8194,
    'emsp': 8195,
    'thinsp': 8201,
    'zwnj': 8204,
    'zwj': 8205,
    'lrm': 8206,
    'rlm': 8207,
    'ndash': 8211,
    'mdash': 8212,
    'lsquo': 8216,
    'rsquo': 8217,
    'sbquo': 8218,
    'ldquo': 8220,
    'rdquo': 8221,
    'bdquo': 8222,
    'dagger': 8224,
    'Dagger': 8225,
    'bull': 8226,
    'hellip': 8230,
    'permil': 8240,
    'prime': 8242,
    'Prime': 8243,
    'lsaquo': 8249,
    'rsaquo': 8250,
    'oline': 8254,
    'frasl': 8260,
    'euro': 8364,
    'image': 8465,
    'weierp': 8472,
    'real': 8476,
    'trade': 8482,
    'alefsym': 8501,
    'larr': 8592,
    'uarr': 8593,
    'rarr': 8594,
    'darr': 8595,
    'harr': 8596,
    'crarr': 8629,
    'lArr': 8656,
    'uArr': 8657,
    'rArr': 8658,
    'dArr': 8659,
    'hArr': 8660,
    'forall': 8704,
    'part': 8706,
    'exist': 8707,
    'empty': 8709,
    'nabla': 8711,
    'isin': 8712,
    'notin': 8713,
    'ni': 8715,
    'prod': 8719,
    'sum': 8721,
    'minus': 8722,
    'lowast': 8727,
    'radic': 8730,
    'prop': 8733,
    'infin': 8734,
    'ang': 8736,
    'and': 8743,
    'or': 8744,
    'cap': 8745,
    'cup': 8746,
    'int': 8747,
    'there4': 8756,
    'sim': 8764,
    'cong': 8773,
    'asymp': 8776,
    'ne': 8800,
    'equiv': 8801,
    'le': 8804,
    'ge': 8805,
    'sub': 8834,
    'sup': 8835,
    'nsub': 8836,
    'sube': 8838,
    'supe': 8839,
    'oplus': 8853,
    'otimes': 8855,
    'perp': 8869,
    'sdot': 8901,
    'lceil': 8968,
    'rceil': 8969,
    'lfloor': 8970,
    'rfloor': 8971,
    'lang': 9001,
    'rang': 9002,
    'loz': 9674,
    'spades': 9824,
    'clubs': 9827,
    'hearts': 9829,
    'diams': 9830
  }

  Object.keys(sax.ENTITIES).forEach(function (key) {
    var e = sax.ENTITIES[key]
    var s = typeof e === 'number' ? String.fromCharCode(e) : e
    sax.ENTITIES[key] = s
  })

  for (var s in sax.STATE) {
    sax.STATE[sax.STATE[s]] = s
  }

  // shorthand
  S = sax.STATE

  function emit (parser, event, data) {
    parser[event] && parser[event](data)
  }

  function emitNode (parser, nodeType, data) {
    if (parser.textNode) closeText(parser)
    emit(parser, nodeType, data)
  }

  function closeText (parser) {
    parser.textNode = textopts(parser.opt, parser.textNode)
    if (parser.textNode) emit(parser, 'ontext', parser.textNode)
    parser.textNode = ''
  }

  function textopts (opt, text) {
    if (opt.trim) text = text.trim()
    if (opt.normalize) text = text.replace(/\s+/g, ' ')
    return text
  }

  function error (parser, er) {
    closeText(parser)
    if (parser.trackPosition) {
      er += '\nLine: ' + parser.line +
        '\nColumn: ' + parser.column +
        '\nChar: ' + parser.c
    }
    er = new Error(er)
    parser.error = er
    emit(parser, 'onerror', er)
    return parser
  }

  function end (parser) {
    if (parser.sawRoot && !parser.closedRoot) strictFail(parser, 'Unclosed root tag')
    if ((parser.state !== S.BEGIN) &&
      (parser.state !== S.BEGIN_WHITESPACE) &&
      (parser.state !== S.TEXT)) {
      error(parser, 'Unexpected end')
    }
    closeText(parser)
    parser.c = ''
    parser.closed = true
    emit(parser, 'onend')
    SAXParser.call(parser, parser.strict, parser.opt)
    return parser
  }

  function strictFail (parser, message) {
    if (typeof parser !== 'object' || !(parser instanceof SAXParser)) {
      throw new Error('bad call to strictFail')
    }
    if (parser.strict) {
      error(parser, message)
    }
  }

  function newTag (parser) {
    if (!parser.strict) parser.tagName = parser.tagName[parser.looseCase]()
    var parent = parser.tags[parser.tags.length - 1] || parser
    var tag = parser.tag = { name: parser.tagName, attributes: {} }

    // will be overridden if tag contails an xmlns="foo" or xmlns:foo="bar"
    if (parser.opt.xmlns) {
      tag.ns = parent.ns
    }
    parser.attribList.length = 0
    emitNode(parser, 'onopentagstart', tag)
  }

  function qname (name, attribute) {
    var i = name.indexOf(':')
    var qualName = i < 0 ? [ '', name ] : name.split(':')
    var prefix = qualName[0]
    var local = qualName[1]

    // <x "xmlns"="http://foo">
    if (attribute && name === 'xmlns') {
      prefix = 'xmlns'
      local = ''
    }

    return { prefix: prefix, local: local }
  }

  function attrib (parser) {
    if (!parser.strict) {
      parser.attribName = parser.attribName[parser.looseCase]()
    }

    if (parser.attribList.indexOf(parser.attribName) !== -1 ||
      parser.tag.attributes.hasOwnProperty(parser.attribName)) {
      parser.attribName = parser.attribValue = ''
      return
    }

    if (parser.opt.xmlns) {
      var qn = qname(parser.attribName, true)
      var prefix = qn.prefix
      var local = qn.local

      if (prefix === 'xmlns') {
        // namespace binding attribute. push the binding into scope
        if (local === 'xml' && parser.attribValue !== XML_NAMESPACE) {
          strictFail(parser,
            'xml: prefix must be bound to ' + XML_NAMESPACE + '\n' +
            'Actual: ' + parser.attribValue)
        } else if (local === 'xmlns' && parser.attribValue !== XMLNS_NAMESPACE) {
          strictFail(parser,
            'xmlns: prefix must be bound to ' + XMLNS_NAMESPACE + '\n' +
            'Actual: ' + parser.attribValue)
        } else {
          var tag = parser.tag
          var parent = parser.tags[parser.tags.length - 1] || parser
          if (tag.ns === parent.ns) {
            tag.ns = Object.create(parent.ns)
          }
          tag.ns[local] = parser.attribValue
        }
      }

      // defer onattribute events until all attributes have been seen
      // so any new bindings can take effect. preserve attribute order
      // so deferred events can be emitted in document order
      parser.attribList.push([parser.attribName, parser.attribValue])
    } else {
      // in non-xmlns mode, we can emit the event right away
      parser.tag.attributes[parser.attribName] = parser.attribValue
      emitNode(parser, 'onattribute', {
        name: parser.attribName,
        value: parser.attribValue
      })
    }

    parser.attribName = parser.attribValue = ''
  }

  function openTag (parser, selfClosing) {
    if (parser.opt.xmlns) {
      // emit namespace binding events
      var tag = parser.tag

      // add namespace info to tag
      var qn = qname(parser.tagName)
      tag.prefix = qn.prefix
      tag.local = qn.local
      tag.uri = tag.ns[qn.prefix] || ''

      if (tag.prefix && !tag.uri) {
        strictFail(parser, 'Unbound namespace prefix: ' +
          JSON.stringify(parser.tagName))
        tag.uri = qn.prefix
      }

      var parent = parser.tags[parser.tags.length - 1] || parser
      if (tag.ns && parent.ns !== tag.ns) {
        Object.keys(tag.ns).forEach(function (p) {
          emitNode(parser, 'onopennamespace', {
            prefix: p,
            uri: tag.ns[p]
          })
        })
      }

      // handle deferred onattribute events
      // Note: do not apply default ns to attributes:
      //   http://www.w3.org/TR/REC-xml-names/#defaulting
      for (var i = 0, l = parser.attribList.length; i < l; i++) {
        var nv = parser.attribList[i]
        var name = nv[0]
        var value = nv[1]
        var qualName = qname(name, true)
        var prefix = qualName.prefix
        var local = qualName.local
        var uri = prefix === '' ? '' : (tag.ns[prefix] || '')
        var a = {
          name: name,
          value: value,
          prefix: prefix,
          local: local,
          uri: uri
        }

        // if there's any attributes with an undefined namespace,
        // then fail on them now.
        if (prefix && prefix !== 'xmlns' && !uri) {
          strictFail(parser, 'Unbound namespace prefix: ' +
            JSON.stringify(prefix))
          a.uri = prefix
        }
        parser.tag.attributes[name] = a
        emitNode(parser, 'onattribute', a)
      }
      parser.attribList.length = 0
    }

    parser.tag.isSelfClosing = !!selfClosing

    // process the tag
    parser.sawRoot = true
    parser.tags.push(parser.tag)
    emitNode(parser, 'onopentag', parser.tag)
    if (!selfClosing) {
      // special case for <script> in non-strict mode.
      if (!parser.noscript && parser.tagName.toLowerCase() === 'script') {
        parser.state = S.SCRIPT
      } else {
        parser.state = S.TEXT
      }
      parser.tag = null
      parser.tagName = ''
    }
    parser.attribName = parser.attribValue = ''
    parser.attribList.length = 0
  }

  function closeTag (parser) {
    if (!parser.tagName) {
      strictFail(parser, 'Weird empty close tag.')
      parser.textNode += '</>'
      parser.state = S.TEXT
      return
    }

    if (parser.script) {
      if (parser.tagName !== 'script') {
        parser.script += '</' + parser.tagName + '>'
        parser.tagName = ''
        parser.state = S.SCRIPT
        return
      }
      emitNode(parser, 'onscript', parser.script)
      parser.script = ''
    }

    // first make sure that the closing tag actually exists.
    // <a><b></c></b></a> will close everything, otherwise.
    var t = parser.tags.length
    var tagName = parser.tagName
    if (!parser.strict) {
      tagName = tagName[parser.looseCase]()
    }
    var closeTo = tagName
    while (t--) {
      var close = parser.tags[t]
      if (close.name !== closeTo) {
        // fail the first time in strict mode
        strictFail(parser, 'Unexpected close tag')
      } else {
        break
      }
    }

    // didn't find it.  we already failed for strict, so just abort.
    if (t < 0) {
      strictFail(parser, 'Unmatched closing tag: ' + parser.tagName)
      parser.textNode += '</' + parser.tagName + '>'
      parser.state = S.TEXT
      return
    }
    parser.tagName = tagName
    var s = parser.tags.length
    while (s-- > t) {
      var tag = parser.tag = parser.tags.pop()
      parser.tagName = parser.tag.name
      emitNode(parser, 'onclosetag', parser.tagName)

      var x = {}
      for (var i in tag.ns) {
        x[i] = tag.ns[i]
      }

      var parent = parser.tags[parser.tags.length - 1] || parser
      if (parser.opt.xmlns && tag.ns !== parent.ns) {
        // remove namespace bindings introduced by tag
        Object.keys(tag.ns).forEach(function (p) {
          var n = tag.ns[p]
          emitNode(parser, 'onclosenamespace', { prefix: p, uri: n })
        })
      }
    }
    if (t === 0) parser.closedRoot = true
    parser.tagName = parser.attribValue = parser.attribName = ''
    parser.attribList.length = 0
    parser.state = S.TEXT
  }

  function parseEntity (parser) {
    var entity = parser.entity
    var entityLC = entity.toLowerCase()
    var num
    var numStr = ''

    if (parser.ENTITIES[entity]) {
      return parser.ENTITIES[entity]
    }
    if (parser.ENTITIES[entityLC]) {
      return parser.ENTITIES[entityLC]
    }
    entity = entityLC
    if (entity.charAt(0) === '#') {
      if (entity.charAt(1) === 'x') {
        entity = entity.slice(2)
        num = parseInt(entity, 16)
        numStr = num.toString(16)
      } else {
        entity = entity.slice(1)
        num = parseInt(entity, 10)
        numStr = num.toString(10)
      }
    }
    entity = entity.replace(/^0+/, '')
    if (isNaN(num) || numStr.toLowerCase() !== entity) {
      strictFail(parser, 'Invalid character entity')
      return '&' + parser.entity + ';'
    }

    return String.fromCodePoint(num)
  }

  function beginWhiteSpace (parser, c) {
    if (c === '<') {
      parser.state = S.OPEN_WAKA
      parser.startTagPosition = parser.position
    } else if (!isWhitespace(c)) {
      // have to process this as a text node.
      // weird, but happens.
      strictFail(parser, 'Non-whitespace before first tag.')
      parser.textNode = c
      parser.state = S.TEXT
    }
  }

  function charAt (chunk, i) {
    var result = ''
    if (i < chunk.length) {
      result = chunk.charAt(i)
    }
    return result
  }

  function write (chunk) {
    var parser = this
    if (this.error) {
      throw this.error
    }
    if (parser.closed) {
      return error(parser,
        'Cannot write after close. Assign an onready handler.')
    }
    if (chunk === null) {
      return end(parser)
    }
    if (typeof chunk === 'object') {
      chunk = chunk.toString()
    }
    var i = 0
    var c = ''
    while (true) {
      c = charAt(chunk, i++)
      parser.c = c

      if (!c) {
        break
      }

      if (parser.trackPosition) {
        parser.position++
        if (c === '\n') {
          parser.line++
          parser.column = 0
        } else {
          parser.column++
        }
      }

      switch (parser.state) {
        case S.BEGIN:
          parser.state = S.BEGIN_WHITESPACE
          if (c === '\uFEFF') {
            continue
          }
          beginWhiteSpace(parser, c)
          continue

        case S.BEGIN_WHITESPACE:
          beginWhiteSpace(parser, c)
          continue

        case S.TEXT:
          if (parser.sawRoot && !parser.closedRoot) {
            var starti = i - 1
            while (c && c !== '<' && c !== '&') {
              c = charAt(chunk, i++)
              if (c && parser.trackPosition) {
                parser.position++
                if (c === '\n') {
                  parser.line++
                  parser.column = 0
                } else {
                  parser.column++
                }
              }
            }
            parser.textNode += chunk.substring(starti, i - 1)
          }
          if (c === '<' && !(parser.sawRoot && parser.closedRoot && !parser.strict)) {
            parser.state = S.OPEN_WAKA
            parser.startTagPosition = parser.position
          } else {
            if (!isWhitespace(c) && (!parser.sawRoot || parser.closedRoot)) {
              strictFail(parser, 'Text data outside of root node.')
            }
            if (c === '&') {
              parser.state = S.TEXT_ENTITY
            } else {
              parser.textNode += c
            }
          }
          continue

        case S.SCRIPT:
          // only non-strict
          if (c === '<') {
            parser.state = S.SCRIPT_ENDING
          } else {
            parser.script += c
          }
          continue

        case S.SCRIPT_ENDING:
          if (c === '/') {
            parser.state = S.CLOSE_TAG
          } else {
            parser.script += '<' + c
            parser.state = S.SCRIPT
          }
          continue

        case S.OPEN_WAKA:
          // either a /, ?, !, or text is coming next.
          if (c === '!') {
            parser.state = S.SGML_DECL
            parser.sgmlDecl = ''
          } else if (isWhitespace(c)) {
            // wait for it...
          } else if (isMatch(nameStart, c)) {
            parser.state = S.OPEN_TAG
            parser.tagName = c
          } else if (c === '/') {
            parser.state = S.CLOSE_TAG
            parser.tagName = ''
          } else if (c === '?') {
            parser.state = S.PROC_INST
            parser.procInstName = parser.procInstBody = ''
          } else {
            strictFail(parser, 'Unencoded <')
            // if there was some whitespace, then add that in.
            if (parser.startTagPosition + 1 < parser.position) {
              var pad = parser.position - parser.startTagPosition
              c = new Array(pad).join(' ') + c
            }
            parser.textNode += '<' + c
            parser.state = S.TEXT
          }
          continue

        case S.SGML_DECL:
          if ((parser.sgmlDecl + c).toUpperCase() === CDATA) {
            emitNode(parser, 'onopencdata')
            parser.state = S.CDATA
            parser.sgmlDecl = ''
            parser.cdata = ''
          } else if (parser.sgmlDecl + c === '--') {
            parser.state = S.COMMENT
            parser.comment = ''
            parser.sgmlDecl = ''
          } else if ((parser.sgmlDecl + c).toUpperCase() === DOCTYPE) {
            parser.state = S.DOCTYPE
            if (parser.doctype || parser.sawRoot) {
              strictFail(parser,
                'Inappropriately located doctype declaration')
            }
            parser.doctype = ''
            parser.sgmlDecl = ''
          } else if (c === '>') {
            emitNode(parser, 'onsgmldeclaration', parser.sgmlDecl)
            parser.sgmlDecl = ''
            parser.state = S.TEXT
          } else if (isQuote(c)) {
            parser.state = S.SGML_DECL_QUOTED
            parser.sgmlDecl += c
          } else {
            parser.sgmlDecl += c
          }
          continue

        case S.SGML_DECL_QUOTED:
          if (c === parser.q) {
            parser.state = S.SGML_DECL
            parser.q = ''
          }
          parser.sgmlDecl += c
          continue

        case S.DOCTYPE:
          if (c === '>') {
            parser.state = S.TEXT
            emitNode(parser, 'ondoctype', parser.doctype)
            parser.doctype = true // just remember that we saw it.
          } else {
            parser.doctype += c
            if (c === '[') {
              parser.state = S.DOCTYPE_DTD
            } else if (isQuote(c)) {
              parser.state = S.DOCTYPE_QUOTED
              parser.q = c
            }
          }
          continue

        case S.DOCTYPE_QUOTED:
          parser.doctype += c
          if (c === parser.q) {
            parser.q = ''
            parser.state = S.DOCTYPE
          }
          continue

        case S.DOCTYPE_DTD:
          parser.doctype += c
          if (c === ']') {
            parser.state = S.DOCTYPE
          } else if (isQuote(c)) {
            parser.state = S.DOCTYPE_DTD_QUOTED
            parser.q = c
          }
          continue

        case S.DOCTYPE_DTD_QUOTED:
          parser.doctype += c
          if (c === parser.q) {
            parser.state = S.DOCTYPE_DTD
            parser.q = ''
          }
          continue

        case S.COMMENT:
          if (c === '-') {
            parser.state = S.COMMENT_ENDING
          } else {
            parser.comment += c
          }
          continue

        case S.COMMENT_ENDING:
          if (c === '-') {
            parser.state = S.COMMENT_ENDED
            parser.comment = textopts(parser.opt, parser.comment)
            if (parser.comment) {
              emitNode(parser, 'oncomment', parser.comment)
            }
            parser.comment = ''
          } else {
            parser.comment += '-' + c
            parser.state = S.COMMENT
          }
          continue

        case S.COMMENT_ENDED:
          if (c !== '>') {
            strictFail(parser, 'Malformed comment')
            // allow <!-- blah -- bloo --> in non-strict mode,
            // which is a comment of " blah -- bloo "
            parser.comment += '--' + c
            parser.state = S.COMMENT
          } else {
            parser.state = S.TEXT
          }
          continue

        case S.CDATA:
          if (c === ']') {
            parser.state = S.CDATA_ENDING
          } else {
            parser.cdata += c
          }
          continue

        case S.CDATA_ENDING:
          if (c === ']') {
            parser.state = S.CDATA_ENDING_2
          } else {
            parser.cdata += ']' + c
            parser.state = S.CDATA
          }
          continue

        case S.CDATA_ENDING_2:
          if (c === '>') {
            if (parser.cdata) {
              emitNode(parser, 'oncdata', parser.cdata)
            }
            emitNode(parser, 'onclosecdata')
            parser.cdata = ''
            parser.state = S.TEXT
          } else if (c === ']') {
            parser.cdata += ']'
          } else {
            parser.cdata += ']]' + c
            parser.state = S.CDATA
          }
          continue

        case S.PROC_INST:
          if (c === '?') {
            parser.state = S.PROC_INST_ENDING
          } else if (isWhitespace(c)) {
            parser.state = S.PROC_INST_BODY
          } else {
            parser.procInstName += c
          }
          continue

        case S.PROC_INST_BODY:
          if (!parser.procInstBody && isWhitespace(c)) {
            continue
          } else if (c === '?') {
            parser.state = S.PROC_INST_ENDING
          } else {
            parser.procInstBody += c
          }
          continue

        case S.PROC_INST_ENDING:
          if (c === '>') {
            emitNode(parser, 'onprocessinginstruction', {
              name: parser.procInstName,
              body: parser.procInstBody
            })
            parser.procInstName = parser.procInstBody = ''
            parser.state = S.TEXT
          } else {
            parser.procInstBody += '?' + c
            parser.state = S.PROC_INST_BODY
          }
          continue

        case S.OPEN_TAG:
          if (isMatch(nameBody, c)) {
            parser.tagName += c
          } else {
            newTag(parser)
            if (c === '>') {
              openTag(parser)
            } else if (c === '/') {
              parser.state = S.OPEN_TAG_SLASH
            } else {
              if (!isWhitespace(c)) {
                strictFail(parser, 'Invalid character in tag name')
              }
              parser.state = S.ATTRIB
            }
          }
          continue

        case S.OPEN_TAG_SLASH:
          if (c === '>') {
            openTag(parser, true)
            closeTag(parser)
          } else {
            strictFail(parser, 'Forward-slash in opening tag not followed by >')
            parser.state = S.ATTRIB
          }
          continue

        case S.ATTRIB:
          // haven't read the attribute name yet.
          if (isWhitespace(c)) {
            continue
          } else if (c === '>') {
            openTag(parser)
          } else if (c === '/') {
            parser.state = S.OPEN_TAG_SLASH
          } else if (isMatch(nameStart, c)) {
            parser.attribName = c
            parser.attribValue = ''
            parser.state = S.ATTRIB_NAME
          } else {
            strictFail(parser, 'Invalid attribute name')
          }
          continue

        case S.ATTRIB_NAME:
          if (c === '=') {
            parser.state = S.ATTRIB_VALUE
          } else if (c === '>') {
            strictFail(parser, 'Attribute without value')
            parser.attribValue = parser.attribName
            attrib(parser)
            openTag(parser)
          } else if (isWhitespace(c)) {
            parser.state = S.ATTRIB_NAME_SAW_WHITE
          } else if (isMatch(nameBody, c)) {
            parser.attribName += c
          } else {
            strictFail(parser, 'Invalid attribute name')
          }
          continue

        case S.ATTRIB_NAME_SAW_WHITE:
          if (c === '=') {
            parser.state = S.ATTRIB_VALUE
          } else if (isWhitespace(c)) {
            continue
          } else {
            strictFail(parser, 'Attribute without value')
            parser.tag.attributes[parser.attribName] = ''
            parser.attribValue = ''
            emitNode(parser, 'onattribute', {
              name: parser.attribName,
              value: ''
            })
            parser.attribName = ''
            if (c === '>') {
              openTag(parser)
            } else if (isMatch(nameStart, c)) {
              parser.attribName = c
              parser.state = S.ATTRIB_NAME
            } else {
              strictFail(parser, 'Invalid attribute name')
              parser.state = S.ATTRIB
            }
          }
          continue

        case S.ATTRIB_VALUE:
          if (isWhitespace(c)) {
            continue
          } else if (isQuote(c)) {
            parser.q = c
            parser.state = S.ATTRIB_VALUE_QUOTED
          } else {
            strictFail(parser, 'Unquoted attribute value')
            parser.state = S.ATTRIB_VALUE_UNQUOTED
            parser.attribValue = c
          }
          continue

        case S.ATTRIB_VALUE_QUOTED:
          if (c !== parser.q) {
            if (c === '&') {
              parser.state = S.ATTRIB_VALUE_ENTITY_Q
            } else {
              parser.attribValue += c
            }
            continue
          }
          attrib(parser)
          parser.q = ''
          parser.state = S.ATTRIB_VALUE_CLOSED
          continue

        case S.ATTRIB_VALUE_CLOSED:
          if (isWhitespace(c)) {
            parser.state = S.ATTRIB
          } else if (c === '>') {
            openTag(parser)
          } else if (c === '/') {
            parser.state = S.OPEN_TAG_SLASH
          } else if (isMatch(nameStart, c)) {
            strictFail(parser, 'No whitespace between attributes')
            parser.attribName = c
            parser.attribValue = ''
            parser.state = S.ATTRIB_NAME
          } else {
            strictFail(parser, 'Invalid attribute name')
          }
          continue

        case S.ATTRIB_VALUE_UNQUOTED:
          if (!isAttribEnd(c)) {
            if (c === '&') {
              parser.state = S.ATTRIB_VALUE_ENTITY_U
            } else {
              parser.attribValue += c
            }
            continue
          }
          attrib(parser)
          if (c === '>') {
            openTag(parser)
          } else {
            parser.state = S.ATTRIB
          }
          continue

        case S.CLOSE_TAG:
          if (!parser.tagName) {
            if (isWhitespace(c)) {
              continue
            } else if (notMatch(nameStart, c)) {
              if (parser.script) {
                parser.script += '</' + c
                parser.state = S.SCRIPT
              } else {
                strictFail(parser, 'Invalid tagname in closing tag.')
              }
            } else {
              parser.tagName = c
            }
          } else if (c === '>') {
            closeTag(parser)
          } else if (isMatch(nameBody, c)) {
            parser.tagName += c
          } else if (parser.script) {
            parser.script += '</' + parser.tagName
            parser.tagName = ''
            parser.state = S.SCRIPT
          } else {
            if (!isWhitespace(c)) {
              strictFail(parser, 'Invalid tagname in closing tag')
            }
            parser.state = S.CLOSE_TAG_SAW_WHITE
          }
          continue

        case S.CLOSE_TAG_SAW_WHITE:
          if (isWhitespace(c)) {
            continue
          }
          if (c === '>') {
            closeTag(parser)
          } else {
            strictFail(parser, 'Invalid characters in closing tag')
          }
          continue

        case S.TEXT_ENTITY:
        case S.ATTRIB_VALUE_ENTITY_Q:
        case S.ATTRIB_VALUE_ENTITY_U:
          var returnState
          var buffer
          switch (parser.state) {
            case S.TEXT_ENTITY:
              returnState = S.TEXT
              buffer = 'textNode'
              break

            case S.ATTRIB_VALUE_ENTITY_Q:
              returnState = S.ATTRIB_VALUE_QUOTED
              buffer = 'attribValue'
              break

            case S.ATTRIB_VALUE_ENTITY_U:
              returnState = S.ATTRIB_VALUE_UNQUOTED
              buffer = 'attribValue'
              break
          }

          if (c === ';') {
            parser[buffer] += parseEntity(parser)
            parser.entity = ''
            parser.state = returnState
          } else if (isMatch(parser.entity.length ? entityBody : entityStart, c)) {
            parser.entity += c
          } else {
            strictFail(parser, 'Invalid character in entity name')
            parser[buffer] += '&' + parser.entity + c
            parser.entity = ''
            parser.state = returnState
          }

          continue

        default:
          throw new Error(parser, 'Unknown state: ' + parser.state)
      }
    } // while

    if (parser.position >= parser.bufferCheckPosition) {
      checkBufferLength(parser)
    }
    return parser
  }

  /*! http://mths.be/fromcodepoint v0.1.0 by @mathias */
  /* istanbul ignore next */
  if (!String.fromCodePoint) {
    (function () {
      var stringFromCharCode = String.fromCharCode
      var floor = Math.floor
      var fromCodePoint = function () {
        var MAX_SIZE = 0x4000
        var codeUnits = []
        var highSurrogate
        var lowSurrogate
        var index = -1
        var length = arguments.length
        if (!length) {
          return ''
        }
        var result = ''
        while (++index < length) {
          var codePoint = Number(arguments[index])
          if (
            !isFinite(codePoint) || // `NaN`, `+Infinity`, or `-Infinity`
            codePoint < 0 || // not a valid Unicode code point
            codePoint > 0x10FFFF || // not a valid Unicode code point
            floor(codePoint) !== codePoint // not an integer
          ) {
            throw RangeError('Invalid code point: ' + codePoint)
          }
          if (codePoint <= 0xFFFF) { // BMP code point
            codeUnits.push(codePoint)
          } else { // Astral code point; split in surrogate halves
            // http://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
            codePoint -= 0x10000
            highSurrogate = (codePoint >> 10) + 0xD800
            lowSurrogate = (codePoint % 0x400) + 0xDC00
            codeUnits.push(highSurrogate, lowSurrogate)
          }
          if (index + 1 === length || codeUnits.length > MAX_SIZE) {
            result += stringFromCharCode.apply(null, codeUnits)
            codeUnits.length = 0
          }
        }
        return result
      }
      /* istanbul ignore next */
      if (Object.defineProperty) {
        Object.defineProperty(String, 'fromCodePoint', {
          value: fromCodePoint,
          configurable: true,
          writable: true
        })
      } else {
        String.fromCodePoint = fromCodePoint
      }
    }())
  }
})( false ? this.sax = {} : exports)

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(123).Buffer))

/***/ }),
/* 2841 */
/***/ (function(module, exports, __webpack_require__) {

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

module.exports = Stream;

var EE = __webpack_require__(425).EventEmitter;
var inherits = __webpack_require__(118);

inherits(Stream, EE);
Stream.Readable = __webpack_require__(426);
Stream.Writable = __webpack_require__(2849);
Stream.Duplex = __webpack_require__(2850);
Stream.Transform = __webpack_require__(2851);
Stream.PassThrough = __webpack_require__(2852);

// Backwards-compat with node 0.4.x
Stream.Stream = Stream;



// old-style streams.  Note that the pipe method (the only relevant
// part of this class) is overridden in the Readable class.

function Stream() {
  EE.call(this);
}

Stream.prototype.pipe = function(dest, options) {
  var source = this;

  function ondata(chunk) {
    if (dest.writable) {
      if (false === dest.write(chunk) && source.pause) {
        source.pause();
      }
    }
  }

  source.on('data', ondata);

  function ondrain() {
    if (source.readable && source.resume) {
      source.resume();
    }
  }

  dest.on('drain', ondrain);

  // If the 'end' option is not supplied, dest.end() will be called when
  // source gets the 'end' or 'close' events.  Only dest.end() once.
  if (!dest._isStdio && (!options || options.end !== false)) {
    source.on('end', onend);
    source.on('close', onclose);
  }

  var didOnEnd = false;
  function onend() {
    if (didOnEnd) return;
    didOnEnd = true;

    dest.end();
  }


  function onclose() {
    if (didOnEnd) return;
    didOnEnd = true;

    if (typeof dest.destroy === 'function') dest.destroy();
  }

  // don't leave dangling pipes when there are errors.
  function onerror(er) {
    cleanup();
    if (EE.listenerCount(this, 'error') === 0) {
      throw er; // Unhandled stream error in pipe.
    }
  }

  source.on('error', onerror);
  dest.on('error', onerror);

  // remove all the event listeners that were added.
  function cleanup() {
    source.removeListener('data', ondata);
    dest.removeListener('drain', ondrain);

    source.removeListener('end', onend);
    source.removeListener('close', onclose);

    source.removeListener('error', onerror);
    dest.removeListener('error', onerror);

    source.removeListener('end', cleanup);
    source.removeListener('close', cleanup);

    dest.removeListener('close', cleanup);
  }

  source.on('end', cleanup);
  source.on('close', cleanup);

  dest.on('close', cleanup);

  dest.emit('pipe', source);

  // Allow for unix-like usage: A.pipe(B).pipe(C)
  return dest;
};


/***/ }),
/* 2842 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 2843 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Buffer = __webpack_require__(289).Buffer;
var util = __webpack_require__(2844);

function copyBuffer(src, target, offset) {
  src.copy(target, offset);
}

module.exports = function () {
  function BufferList() {
    _classCallCheck(this, BufferList);

    this.head = null;
    this.tail = null;
    this.length = 0;
  }

  BufferList.prototype.push = function push(v) {
    var entry = { data: v, next: null };
    if (this.length > 0) this.tail.next = entry;else this.head = entry;
    this.tail = entry;
    ++this.length;
  };

  BufferList.prototype.unshift = function unshift(v) {
    var entry = { data: v, next: this.head };
    if (this.length === 0) this.tail = entry;
    this.head = entry;
    ++this.length;
  };

  BufferList.prototype.shift = function shift() {
    if (this.length === 0) return;
    var ret = this.head.data;
    if (this.length === 1) this.head = this.tail = null;else this.head = this.head.next;
    --this.length;
    return ret;
  };

  BufferList.prototype.clear = function clear() {
    this.head = this.tail = null;
    this.length = 0;
  };

  BufferList.prototype.join = function join(s) {
    if (this.length === 0) return '';
    var p = this.head;
    var ret = '' + p.data;
    while (p = p.next) {
      ret += s + p.data;
    }return ret;
  };

  BufferList.prototype.concat = function concat(n) {
    if (this.length === 0) return Buffer.alloc(0);
    if (this.length === 1) return this.head.data;
    var ret = Buffer.allocUnsafe(n >>> 0);
    var p = this.head;
    var i = 0;
    while (p) {
      copyBuffer(p.data, ret, i);
      i += p.data.length;
      p = p.next;
    }
    return ret;
  };

  return BufferList;
}();

if (util && util.inspect && util.inspect.custom) {
  module.exports.prototype[util.inspect.custom] = function () {
    var obj = util.inspect({ length: this.length });
    return this.constructor.name + ' ' + obj;
  };
}

/***/ }),
/* 2844 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 2845 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
            (typeof self !== "undefined" && self) ||
            window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(2846);
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
                       (typeof global !== "undefined" && global.setImmediate) ||
                       (this && this.setImmediate);
exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
                         (typeof global !== "undefined" && global.clearImmediate) ||
                         (this && this.clearImmediate);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(26)))

/***/ }),
/* 2846 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(26), __webpack_require__(74)))

/***/ }),
/* 2847 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {
/**
 * Module exports.
 */

module.exports = deprecate;

/**
 * Mark that a method should not be used.
 * Returns a modified function which warns once by default.
 *
 * If `localStorage.noDeprecation = true` is set, then it is a no-op.
 *
 * If `localStorage.throwDeprecation = true` is set, then deprecated functions
 * will throw an Error when invoked.
 *
 * If `localStorage.traceDeprecation = true` is set, then deprecated functions
 * will invoke `console.trace()` instead of `console.error()`.
 *
 * @param {Function} fn - the function to deprecate
 * @param {String} msg - the string to print to the console when `fn` is invoked
 * @returns {Function} a new "deprecated" version of `fn`
 * @api public
 */

function deprecate (fn, msg) {
  if (config('noDeprecation')) {
    return fn;
  }

  var warned = false;
  function deprecated() {
    if (!warned) {
      if (config('throwDeprecation')) {
        throw new Error(msg);
      } else if (config('traceDeprecation')) {
        console.trace(msg);
      } else {
        console.warn(msg);
      }
      warned = true;
    }
    return fn.apply(this, arguments);
  }

  return deprecated;
}

/**
 * Checks `localStorage` for boolean values for the given `name`.
 *
 * @param {String} name
 * @returns {Boolean}
 * @api private
 */

function config (name) {
  // accessing global.localStorage can trigger a DOMException in sandboxed iframes
  try {
    if (!global.localStorage) return false;
  } catch (_) {
    return false;
  }
  var val = global.localStorage[name];
  if (null == val) return false;
  return String(val).toLowerCase() === 'true';
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(26)))

/***/ }),
/* 2848 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.



module.exports = PassThrough;

var Transform = __webpack_require__(749);

/*<replacement>*/
var util = __webpack_require__(208);
util.inherits = __webpack_require__(118);
/*</replacement>*/

util.inherits(PassThrough, Transform);

function PassThrough(options) {
  if (!(this instanceof PassThrough)) return new PassThrough(options);

  Transform.call(this, options);
}

PassThrough.prototype._transform = function (chunk, encoding, cb) {
  cb(null, chunk);
};

/***/ }),
/* 2849 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(427);


/***/ }),
/* 2850 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(124);


/***/ }),
/* 2851 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(426).Transform


/***/ }),
/* 2852 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(426).PassThrough


/***/ }),
/* 2853 */
/***/ (function(module, exports, __webpack_require__) {

var helper = __webpack_require__(429);
var xml2js = __webpack_require__(745);

function validateOptions (userOptions) {
  var options = helper.copyOptions(userOptions);
  helper.ensureSpacesExists(options);
  return options;
}

module.exports = function(xml, userOptions) {
  var options, js, json, parentKey;
  options = validateOptions(userOptions);
  js = xml2js(xml, options);
  parentKey = 'compact' in options && options.compact ? '_parent' : 'parent';
  // parentKey = ptions.compact ? '_parent' : 'parent'; // consider this
  if ('addParent' in options && options.addParent) {
    json = JSON.stringify(js, function (k, v) { return k === parentKey? '_' : v; }, options.spaces);
  } else {
    json = JSON.stringify(js, null, options.spaces);
  }
  return json.replace(/\u2028/g, '\\u2028').replace(/\u2029/g, '\\u2029');
};


/***/ }),
/* 2854 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {var js2xml = __webpack_require__(750);

module.exports = function (json, options) {
  if (json instanceof Buffer) {
    json = json.toString();
  }
  var js = null;
  if (typeof (json) === 'string') {
    try {
      js = JSON.parse(json);
    } catch (e) {
      throw new Error('The JSON structure is invalid');
    }
  } else {
    js = json;
  }
  return js2xml(js, options);
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(123).Buffer))

/***/ }),
/* 2855 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_core__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles_withStyles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_icons__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_assets_jss_material_dashboard_pro_react_views_sweetAlertStyle_jsx__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_EnhancedTableHead_EnhancedTableHead_jsx__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_Grid_GridItem_jsx__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_graphql_tag__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_graphql_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_graphql_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_helpers_DateHelpers__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_helpers_ErrorHelper__ = __webpack_require__(391);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_helpers_Search__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_helpers_UserHelper__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_queries_clients_mutations__ = __webpack_require__(619);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_queries_clients_queries__ = __webpack_require__(417);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_queries_QuoteEligibility__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_queries_Submit__ = __webpack_require__(392);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react_apollo__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_react_bootstrap_sweetalert__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_react_bootstrap_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_react_bootstrap_sweetalert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_react_router__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_reducers_NotificationReducer__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_reducers_TasksReducer__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_store__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_helpers_UriReader__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__progress_kendo_react_pdf__ = __webpack_require__(635);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__SearchedPdf_jsx__ = __webpack_require__(2856);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__SelectFieldsDialog_jsx__ = __webpack_require__(2857);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__objects__ = __webpack_require__(431);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(["\n  mutation updateClientStatus($input: UpdateClientStatusInput!) {\n    UpdateClientStatus(input: $input) {\n      clientMutationId\n    }\n  }\n"],["\n  mutation updateClientStatus($input: UpdateClientStatusInput!) {\n    UpdateClientStatus(input: $input) {\n      clientMutationId\n    }\n  }\n"]),_templateObject2=_taggedTemplateLiteral(["\n  mutation deleteClient($input: DeleteClientInput!) {\n    DeleteClient(input: $input) {\n      clientMutationId\n    }\n  }\n"],["\n  mutation deleteClient($input: DeleteClientInput!) {\n    DeleteClient(input: $input) {\n      clientMutationId\n    }\n  }\n"]),_templateObject3=_taggedTemplateLiteral(["\n  mutation advSearchExport($input: AdvSearchExportInput!) {\n    AdvSearchExport(input: $input) {\n      error\n      path\n      clientMutationId\n    }\n  }\n"],["\n  mutation advSearchExport($input: AdvSearchExportInput!) {\n    AdvSearchExport(input: $input) {\n      error\n      path\n      clientMutationId\n    }\n  }\n"]);function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}/*eslint-disable*/var columnData=[{id:"edit",numeric:false,disablePadding:true,label:"",noSort:true,width:"30px"},{id:"scd_name",numeric:false,disablePadding:true,label:"Name"},{id:"scd_email",numeric:false,disablePadding:true,label:"Email"},{id:"date_modified",numeric:false,disablePadding:true,label:"Date Created / Modified"}];var isEmptyOrSpaces=function isEmptyOrSpaces(str){return str===undefined||str===null||str.match(/^ *$/)!==null;};var updateClientStatus=__WEBPACK_IMPORTED_MODULE_7_graphql_tag___default()(_templateObject);var deleteClient=__WEBPACK_IMPORTED_MODULE_7_graphql_tag___default()(_templateObject2);var exportClients=__WEBPACK_IMPORTED_MODULE_7_graphql_tag___default()(_templateObject3);var AdvancedSearch=function(_React$Component){_inherits(AdvancedSearch,_React$Component);function AdvancedSearch(){var _ref;var _temp,_this,_ret;_classCallCheck(this,AdvancedSearch);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=AdvancedSearch.__proto__||Object.getPrototypeOf(AdvancedSearch)).call.apply(_ref,[this].concat(args))),_this),_this.state={loading:true,page:0,rowsPerPage:5,order:"desc",orderBy:"date_modified",searchTerm:"",loadingSearch:false,searchData:[],openActions:false,statusEl:null,actionsEl:null,legendEl:null,handleStatusEl:null,openLoadingSnack:false,loadingSnackText:"",openMenus:[],anchorTop:0,anchorLeft:0,popoverOpen:false,clientStatus:"own",data:[],openDialog:false,assistantActive:false,alert:false,eligibilityDialogOpen:false,invalidFields:[],selectedClient:{},savingPdf:false,showPdfPreview:false,selectFieldsDialogOpen:false,selectedFields:__WEBPACK_IMPORTED_MODULE_27__objects__["a" /* fields */]},_this.handleSearch=function(event){_this.setState({searchTerm:event.target.value});var values=event.target.value.split(" ");var brokers=_this.state.data;var inc=["scd_name","scd_surname","scd_email","date_created"];var filteredData=Object(__WEBPACK_IMPORTED_MODULE_10_helpers_Search__["a" /* SearchDataSet */])(brokers,values,inc);_this.setState({searchData:filteredData});},_this.handleChangePage=function(event,page){_this.setState({page:page});},_this.handleChangeRowsPerPage=function(event){_this.setState({rowsPerPage:event.target.value});},_this.handleRequestSort=function(event,property){if(property==="clientType")return;var orderBy=property;var order="desc";if(_this.state.orderBy===property&&_this.state.order==="desc"){order="asc";}_this.setState({order:order,orderBy:orderBy});},_this.handlePopoverOpen=function(event,name){_this.setState(_defineProperty({},name,event.currentTarget));},_this.handlePopoverClose=function(name){_this.setState(_defineProperty({},name,null));},_this.loadingSnack=function(open,text){_this.setState({openLoadingSnack:open,loadingSnackText:text});},_this.handleClick=function(event,id){_this.setState({anchorTop:event.clientY,anchorLeft:event.clientX});var openMenus=_this.state.openMenus.slice();openMenus.filter(function(x){return x.id===id;})[0].open=true;_this.setState({openMenus:openMenus,popoverOpen:true});},_this.handleClose=function(id){var openMenus=_this.state.openMenus.slice();openMenus.filter(function(x){return x.id===id;})[0].open=false;_this.setState({openMenus:openMenus,popoverOpen:false});},_this.handleImport=function(){_this.setState({openDialog:true});},_this.handleCloseClientImport=function(){_this.setState({openDialog:false});},_this.getBrokerId=function(){var brokerId=Object(__WEBPACK_IMPORTED_MODULE_11_helpers_UserHelper__["a" /* GetUserId */])();if(_this.checkAssistantActive()){brokerId=sessionStorage.getItem("ActiveBrokerId");}return brokerId;},_this.getBrokerName=function(){return sessionStorage.getItem("ActiveBrokerName");},_this.sortDateDesc=function(a,b){return new Date(b.date_modified)-new Date(a.date_modified);},_this.sortDateAsc=function(a,b){return new Date(a.date_modified)-new Date(b.date_modified);},_this.handleNewQuote=function(id){_this.props.history.push({pathname:"/app/quote",search:"clientId="+atob(id).split(":")[1]});},_this.handleViewQuote=function(client){var clientId=atob(client.id).split(":")[1];var clientFullName=client.scd_name+" "+client.scd_surname;_this.props.history.push({pathname:"/app/history",search:"clientId="+clientId+"&clientName="+clientFullName});},_this.handleSendMessage=function(id){alert("Send a message to a client with id : "+id);alert("THIS DOES NOTHING YET!");},_this.handleSendAppInvite=function(id,email,refetch){if(isEmptyOrSpaces(email)){__WEBPACK_IMPORTED_MODULE_22_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_20_reducers_NotificationReducer__["d" /* showSnack */])({message:"Client must have email address",color:"danger"}));return;}var input={clientId:atob(id).split(":")[1],clientEmail:email,brokerId:_this.getBrokerId(),token:Object(__WEBPACK_IMPORTED_MODULE_11_helpers_UserHelper__["c" /* GetUserToken */])()};_this.props.SendAppInvite({variables:{input:input}}).then(function(resp){refetch();__WEBPACK_IMPORTED_MODULE_22_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_20_reducers_NotificationReducer__["d" /* showSnack */])({message:"Invite Sent!",color:"success"}));}).catch(function(error){__WEBPACK_IMPORTED_MODULE_22_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_20_reducers_NotificationReducer__["d" /* showSnack */])({message:"Error: "+Object(__WEBPACK_IMPORTED_MODULE_9_helpers_ErrorHelper__["a" /* ParseGraphqlError */])(error),color:"danger"}));});},_this.handleRequestAstute=function(id){var input={token:Object(__WEBPACK_IMPORTED_MODULE_11_helpers_UserHelper__["c" /* GetUserToken */])(),userId:_this.getBrokerId(),clientId:atob(id).split(":")[1],benefits:[3],assistantId:Object(__WEBPACK_IMPORTED_MODULE_11_helpers_UserHelper__["b" /* GetUserKey */])("userType")==="6"?Object(__WEBPACK_IMPORTED_MODULE_11_helpers_UserHelper__["a" /* GetUserId */])():null,targets:[7],data:{},requestAstute:true,astuteData:{}};_this.props.newQuoteMutation({variables:{input:input}}).then(function(resp){__WEBPACK_IMPORTED_MODULE_22_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_20_reducers_NotificationReducer__["e" /* successWarning */])({open:true,title:"Astute Requested"}));__WEBPACK_IMPORTED_MODULE_22_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_21_reducers_TasksReducer__["f" /* openProgress */])());}).catch(function(error){__WEBPACK_IMPORTED_MODULE_22_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_20_reducers_NotificationReducer__["d" /* showSnack */])({message:"There was an error requesting Astute for this client: "+Object(__WEBPACK_IMPORTED_MODULE_9_helpers_ErrorHelper__["a" /* ParseGraphqlError */])(error),color:"danger"}));});},_this.exportPDF=function(){_this.setState({savingPdf:true});_this.pdf.save(function(){_this.setState({savingPdf:false,selectFieldsDialogOpen:false});});},_this.handleFieldCheck=function(name){return function(event){var fields=[].concat(_toConsumableArray(_this.state.selectedFields));if(fields.includes(name)){fields=fields.filter(function(f){return f!==name;});}else{fields.push(name);}_this.setState({selectedFields:fields});};},_this.mappedQueryData=function(data){console.log("data",data);return data;},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(AdvancedSearch,[{key:"shouldComponentUpdate",value:function shouldComponentUpdate(nextProps,newState){var _this2=this;var comparedState=false;Object.keys(this.state).map(function(s){if(_this2.state[s]!==newState[s]){comparedState=true;}return s;});return comparedState;}},{key:"getSorting",value:function getSorting(order,orderBy){return order==="desc"?function(a,b){return b[orderBy]<a[orderBy]?-1:1;}:function(a,b){return a[orderBy]<b[orderBy]?-1:1;};}},{key:"handleEdit",value:function handleEdit(client){var tab=arguments.length>1&&arguments[1]!==undefined?arguments[1]:null;this.props.history.push({pathname:"/app/clientdetail",search:"clientId="+atob(client.id).split(":")[1]+"&clientName="+((client.scd_name?client.scd_name:"")+" "+(client.scd_surname?client.scd_surname:""))+(tab?"&tab="+tab:"")});}},{key:"checkAssistantActive",value:function checkAssistantActive(){if(Object(__WEBPACK_IMPORTED_MODULE_11_helpers_UserHelper__["b" /* GetUserKey */])("userType")==="6"){if(!this.state.assistantActive){this.setState({assistantActive:true});}return true;}return false;}},{key:"render",value:function render(){var _this3=this;var brokerId=this.getBrokerId();var params=Object(__WEBPACK_IMPORTED_MODULE_23_helpers_UriReader__["a" /* ParseUriParams */])(this.props.location.search);var occupation=params.occupation,title=params.title,language=params.language,smoker=params.smoker,birthdayFrom=params.birthdayFrom,birthdayTo=params.birthdayTo,anneversaryFrom=params.anneversaryFrom,anneversaryTo=params.anneversaryTo,incomeFrom=params.incomeFrom,incomeTo=params.incomeTo,ageFrom=params.ageFrom,ageTo=params.ageTo;return __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_react_apollo__["Query"],{query:__WEBPACK_IMPORTED_MODULE_13_queries_clients_queries__["a" /* ClientAdvSearch */],variables:{brokerId:brokerId,token:Object(__WEBPACK_IMPORTED_MODULE_11_helpers_UserHelper__["b" /* GetUserKey */])("token"),occupation:occupation,title:title,language:language,smoker:smoker,birthdayFrom:birthdayFrom,birthdayTo:birthdayTo,anneversaryFrom:anneversaryFrom,anneversaryTo:anneversaryTo,incomeFrom:incomeFrom,incomeTo:incomeTo,ageFrom:ageFrom,ageTo:ageTo},fetchPolicy:"cache-and-network"},function(_ref2){var loading=_ref2.loading,error=_ref2.error,data=_ref2.data,refetch=_ref2.refetch;if(loading){return __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["B" /* LinearProgress */],null);}else{if(_this3.state.loading)_this3.setState({loading:false});}if(error&&error.message&&error.message==="GraphQL error: invalid token"){Object(__WEBPACK_IMPORTED_MODULE_11_helpers_UserHelper__["d" /* Logout */])();return __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19_react_router__["a" /* Redirect */],{to:"/app/portal/login"});}if(_this3.state.data.length!==data.ClientAdvSearch.length){_this3.setState({data:data.ClientAdvSearch});}var qData=[];if(_this3.state.searchData.length>0&&_this3.state.searchTerm!==""){qData=_this3.state.searchData.slice();}else{qData=data.ClientAdvSearch.slice();}if(_this3.state.orderBy==="date_modified"){qData.sort(_this3.state.order==="desc"?_this3.sortDateDesc:_this3.sortDateAsc);}else{qData.sort(_this3.getSorting(_this3.state.order,_this3.state.orderBy));}if(qData&&_this3.state.openMenus.length!==qData.length){var openMenus=[];qData.map(function(c){openMenus.push({open:false,id:c.id});return cancelAnimationFrame;});_this3.setState({openMenus:openMenus});}return __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{container:true},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:10,style:{flexBasis:"100%",maxWidth:"100%",margin:"auto"}},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["e" /* Card */],null,__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["f" /* CardContent */],null,__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",null,_this3.checkAssistantActive()?__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{variant:"headline",className:"centerCell"},"Advanced Search on",_this3.getBrokerName(),"'s Clients"):__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{variant:"headline",className:"centerCell"},"Advanced Search"),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{style:{borderBottom:"1px solid #cccccc69",margin:"5px auto",width:"25%",marginBottom:"20px"}})),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["I" /* Paper */],{style:{overflowX:"auto"}},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{container:true},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{item:true,xs:12,sm:12,md:10,style:{margin:"0 auto"}},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["X" /* TextField */],{id:"input-with-icon-textfield",fullWidth:true,style:{padding:"30px 0px 0px 0px"},placeholder:"Search Client by Name, Surname,Email or Date Created(YYYY/MM/DD)",onChange:_this3.handleSearch,InputProps:{startAdornment:__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["z" /* InputAdornment */],{position:"start"},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_icons__["n" /* Search */],null))}}))),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Q" /* Table */],null,__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_EnhancedTableHead_EnhancedTableHead_jsx__["a" /* default */],{order:_this3.state.order,orderBy:_this3.state.orderBy,onRequestSort:_this3.handleRequestSort,rowCount:_this3.state.searchData.length<1&&_this3.state.searchTerm!==""?_this3.state.searchData.length:qData.length,columnData:columnData}),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["R" /* TableBody */],null,_this3.state.searchData.length<1&&_this3.state.searchTerm!==""?__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("h3",null,"No results found"))):qData.slice(_this3.state.page*_this3.state.rowsPerPage,_this3.state.page*_this3.state.rowsPerPage+_this3.state.rowsPerPage).map(function(client){return(//Hierso moet die mutation begin
__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],{key:client.id,className:"sqDataTable",onClick:function onClick(e){return _this3.state.popoverOpen===false?_this3.handleClick(e,client.id):null;},style:_this3.state.openMenus.length>0&&_this3.state.openMenus.filter(function(m){return m.id===client.id;})[0]&&_this3.state.openMenus.filter(function(m){return m.id===client.id;})[0].open?{backgroundColor:"#dedede"}:{}},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],{style:{padding:"0px",borderRight:"1px solid #e0e0e0",backgroundColor:"white"}},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["x" /* IconButton */],{onClick:function onClick(e){return _this3.state.popoverOpen===false?_this3.handleClick(e,client.id):null;}},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["w" /* Icon */],null,"more_vert"))),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,client.scd_name," ",client.scd_surname),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,client.scd_email),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["S" /* TableCell */],null,Object(__WEBPACK_IMPORTED_MODULE_8_helpers_DateHelpers__["a" /* DateTimeFormatter */])(client.date_modified)),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["J" /* Popover */],{open:_this3.state.openMenus.length>0&&_this3.state.openMenus.filter(function(m){return m.id===client.id;})[0]?_this3.state.openMenus.filter(function(m){return m.id===client.id;})[0].open:false,anchorReference:"anchorPosition",anchorPosition:{left:_this3.state.anchorLeft,top:_this3.state.anchorTop},onClose:function onClose(){return _this3.handleClose(client.id);}},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["C" /* List */],{component:"nav"},_this3.state.clientStatus==="own"?__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["D" /* ListItem */],{button:true,onClick:function onClick(){return _this3.handleEdit(client);}},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["E" /* ListItemText */],{primary:"View/Edit Client"})),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["p" /* Divider */],null),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["D" /* ListItem */],{button:true,onClick:function onClick(){_this3.handleSendAppInvite(client.id,client.scd_email,refetch);_this3.handleClose(client.id);}},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["E" /* ListItemText */],{primary:"Send App Invite"})),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["p" /* Divider */],null),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["D" /* ListItem */],{button:true,onClick:function onClick(){return _this3.handleEdit(client,"documents");}},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["E" /* ListItemText */],{primary:"View/Add Documents"})),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["p" /* Divider */],null),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_react_apollo__["Mutation"],{mutation:__WEBPACK_IMPORTED_MODULE_14_queries_QuoteEligibility__["a" /* QuoteEligibility */],onCompleted:function onCompleted(data){var quoteEligibility=data.QuoteEligibility;if(!quoteEligibility.valid){var invalidFields=quoteEligibility.invalidFields.split(",");_this3.setState({eligibilityDialogOpen:true,invalidFields:invalidFields,selectedClient:client});}else{_this3.handleNewQuote(client.id);}},onError:function onError(error){}},function(mutate){return __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["D" /* ListItem */],{button:true,onClick:function onClick(){return mutate({variables:{input:{clientId:atob(client.id).split(":")[1]}}});}},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["E" /* ListItemText */],{primary:"New Quote"}));}),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["p" /* Divider */],null),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["D" /* ListItem */],{button:true,onClick:function onClick(){return _this3.handleViewQuote(client);}},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["E" /* ListItemText */],{primary:"View Previous Quotes"})),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["p" /* Divider */],null),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["D" /* ListItem */],{button:true,onClick:function onClick(){return _this3.handleRequestAstute(client.id);}},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["E" /* ListItemText */],{primary:"Request Astute"})),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["p" /* Divider */],null),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_react_apollo__["Mutation"],{mutation:updateClientStatus,onCompleted:function onCompleted(data){__WEBPACK_IMPORTED_MODULE_22_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_20_reducers_NotificationReducer__["e" /* successWarning */])({open:true,title:"Client Deleted."})),refetch();},onError:function onError(error){__WEBPACK_IMPORTED_MODULE_22_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_20_reducers_NotificationReducer__["d" /* showSnack */])({message:"There was an error deleting the client."+error,color:"danger"}));}},function(statusMutation){return __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["D" /* ListItem */],{button:true,onClick:function onClick(){_this3.handleClose(client.id);statusMutation({variables:{input:{brokerId:Object(__WEBPACK_IMPORTED_MODULE_11_helpers_UserHelper__["a" /* GetUserId */])(),token:Object(__WEBPACK_IMPORTED_MODULE_11_helpers_UserHelper__["c" /* GetUserToken */])(),clientId:atob(client.id).split(":")[1],status:"deleted"}}});}},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["E" /* ListItemText */],{primary:"Delete Client"}));})):_this3.state.clientStatus==="shared"?__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_react_apollo__["Mutation"],{mutation:updateClientStatus,onCompleted:function onCompleted(data){__WEBPACK_IMPORTED_MODULE_22_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_20_reducers_NotificationReducer__["e" /* successWarning */])({open:true,title:"Client Claimed."})),refetch();},onError:function onError(error){__WEBPACK_IMPORTED_MODULE_22_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_20_reducers_NotificationReducer__["d" /* showSnack */])({message:"There was an error claiming this client."+error,color:"danger"}));}},function(statusMutation){return __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["D" /* ListItem */],{button:true,onClick:function onClick(){_this3.handleClose(client.id);statusMutation({variables:{input:{brokerId:Object(__WEBPACK_IMPORTED_MODULE_11_helpers_UserHelper__["a" /* GetUserId */])(),token:Object(__WEBPACK_IMPORTED_MODULE_11_helpers_UserHelper__["c" /* GetUserToken */])(),clientId:atob(client.id).split(":")[1],status:"own"}}});}},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["E" /* ListItemText */],{primary:"Claim Client"}));}):__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_react_apollo__["Mutation"],{mutation:updateClientStatus,onCompleted:function onCompleted(data){__WEBPACK_IMPORTED_MODULE_22_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_20_reducers_NotificationReducer__["e" /* successWarning */])({open:true,title:"Client Reclaimed."})),refetch();},onError:function onError(error){__WEBPACK_IMPORTED_MODULE_22_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_20_reducers_NotificationReducer__["d" /* showSnack */])({message:"There was an error reclaiming this client."+error,color:"danger"}));}},function(statusMutation){return __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["D" /* ListItem */],{button:true,onClick:function onClick(){_this3.handleClose(client.id);statusMutation({variables:{input:{brokerId:Object(__WEBPACK_IMPORTED_MODULE_11_helpers_UserHelper__["a" /* GetUserId */])(),token:Object(__WEBPACK_IMPORTED_MODULE_11_helpers_UserHelper__["c" /* GetUserToken */])(),clientId:atob(client.id).split(":")[1],status:"own"}}});}},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["E" /* ListItemText */],{primary:"Reclaim Client"}));}),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["p" /* Divider */],null),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_react_apollo__["Mutation"],{mutation:deleteClient,onCompleted:function onCompleted(data){__WEBPACK_IMPORTED_MODULE_22_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_20_reducers_NotificationReducer__["e" /* successWarning */])({open:true,title:"Client Permanently Deleted."})),refetch();},onError:function onError(error){__WEBPACK_IMPORTED_MODULE_22_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_20_reducers_NotificationReducer__["d" /* showSnack */])({message:"There was an error permanently deleting this client."+error,color:"danger"}));}},function(deleteClientMutation){return __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["D" /* ListItem */],{button:true,onClick:function onClick(){_this3.handleClose(client.id);deleteClientMutation({variables:{input:{token:Object(__WEBPACK_IMPORTED_MODULE_11_helpers_UserHelper__["c" /* GetUserToken */])(),clientId:atob(client.id).split(":")[1]}}});}},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["E" /* ListItemText */],{primary:"Permanently Delete Client"}));}))))));}),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["V" /* TableRow */],null,__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["U" /* TablePagination */],{count:_this3.state.searchData.length<1&&_this3.state.searchTerm!==""?_this3.state.searchData.length:qData.length,rowsPerPage:_this3.state.rowsPerPage,page:_this3.state.page,backIconButtonProps:{"aria-label":"Previous Page"},nextIconButtonProps:{"aria-label":"Next Page"},onChangePage:_this3.handleChangePage,onChangeRowsPerPage:_this3.handleChangeRowsPerPage}))))),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["d" /* Button */],{onClick:function onClick(){return _this3.state.savingPdf?{}:_this3.setState({selectFieldsDialogOpen:true});}// this.exportPDF()
,style:{margin:"25px auto 0px auto"},variant:"outlined",color:"primary"},_this3.state.savingPdf?__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["j" /* CircularProgress */],{size:20}):"Download PDF"),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_react_apollo__["Mutation"],{mutation:exportClients,onCompleted:function onCompleted(data){window.open(data.AdvSearchExport.path,"_blank");},onError:function onError(error){__WEBPACK_IMPORTED_MODULE_22_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_20_reducers_NotificationReducer__["d" /* showSnack */])({message:"An error has occured : "+error,color:"danger"}));}},function(exportMutation){return __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["d" /* Button */],{style:{margin:"25px auto 0px 10px"},variant:"outlined",color:"primary",onClick:function onClick(e){exportMutation({variables:{input:{brokerId:brokerId,token:Object(__WEBPACK_IMPORTED_MODULE_11_helpers_UserHelper__["b" /* GetUserKey */])("token"),occupation:occupation,title:title,language:language,smoker:smoker,birthdayFrom:birthdayFrom,birthdayTo:birthdayTo,anneversaryFrom:anneversaryFrom,anneversaryTo:anneversaryTo,incomeFrom:incomeFrom,incomeTo:incomeTo,ageFrom:ageFrom,ageTo:ageTo}}});}},"Download Excel");})))),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{style:{position:"fixed",right:"-200vw",top:"0"}},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__progress_kendo_react_pdf__["a" /* PDFExport */],{paperSize:"Letter",fileName:"ClientsSearch.pdf",title:"",subject:"",keywords:"",forcePageBreak:".page-break",ref:function ref(r){return _this3.pdf=r;}},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{className:"a4Page"},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__SearchedPdf_jsx__["a" /* default */],{clients:qData,selectedProperties:_this3.state.selectedFields}))))),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["N" /* Snackbar */],{anchorOrigin:{vertical:"bottom",horizontal:"right"},open:_this3.state.openLoadingSnack,ContentProps:{"aria-describedby":"message-id"},message:__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["j" /* CircularProgress */],{color:"secondary",size:20,style:{marginRight:"15px",position:"relative",top:"5px"}}),_this3.state.loadingSnackText)}),_this3.state.eligibilityDialogOpen?__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_react_bootstrap_sweetalert___default.a,{warning:true,style:{wordWrap:"break-word",top:"40%"},title:"Ineligible",confirmBtnCssClass:_this3.props.classes.button+" "+_this3.props.classes.success,cancelBtnCssClass:_this3.props.classes.button+" "+_this3.props.classes.danger,confirmBtnText:"Edit Client",cancelBtnText:"Close",onConfirm:function onConfirm(){_this3.handleEdit(_this3.state.selectedClient.id);},onCancel:function onCancel(){_this3.setState({eligibilityDialogOpen:false});},showCancel:!_this3.state.loadingDelete,showConfirm:!_this3.state.loadingDelete},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],null,_this3.state.selectedClient.scd_name+" "+_this3.state.selectedClient.scd_surname+" ","is ineligible for a quote."),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],null,"Please update the following fields: "),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{container:true,className:"invalidListBlock"},_this3.state.invalidFields.map(function(i){return __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{item:true,xs:12,sm:6,md:6},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],null,i));}))):null,_this3.state.selectFieldsDialogOpen?__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__SelectFieldsDialog_jsx__["a" /* default */],{open:true,selectedFields:_this3.state.selectedFields,closeDialog:function closeDialog(){return _this3.setState({selectFieldsDialogOpen:false});},handleFieldCheck:_this3.handleFieldCheck,exportPDF:_this3.exportPDF,savingPdf:_this3.state.savingPdf}):null);});}}]);return AdvancedSearch;}(__WEBPACK_IMPORTED_MODULE_16_react___default.a.Component);AdvancedSearch=Object(__WEBPACK_IMPORTED_MODULE_17_react_apollo__["compose"])(Object(__WEBPACK_IMPORTED_MODULE_17_react_apollo__["graphql"])(__WEBPACK_IMPORTED_MODULE_12_queries_clients_mutations__["a" /* SendAppInvite */],{name:"SendAppInvite"}),Object(__WEBPACK_IMPORTED_MODULE_17_react_apollo__["graphql"])(__WEBPACK_IMPORTED_MODULE_15_queries_Submit__["a" /* newQuoteMutation */],{name:"newQuoteMutation"}))(AdvancedSearch);/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles_withStyles___default()(__WEBPACK_IMPORTED_MODULE_4_assets_jss_material_dashboard_pro_react_views_sweetAlertStyle_jsx__["a" /* default */])(AdvancedSearch));

/***/ }),
/* 2856 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_Grid_GridItem_jsx__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_assets_img_sure_quote_website_logo_png__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_assets_img_sure_quote_website_logo_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_assets_img_sure_quote_website_logo_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__objects__ = __webpack_require__(431);
var SearchedPdf=function SearchedPdf(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{margin:'20px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{textAlign:'center'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{style:{width:'250px',margin:'0px auto'},src:__WEBPACK_IMPORTED_MODULE_3_assets_img_sure_quote_website_logo_png___default.a,alt:'sqLogo'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["Z" /* Typography */],{variant:'headline',className:'centerCell',style:{marginBottom:'15px'}},'Client Search'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["v" /* Grid */],{container:true},props.clients.map(function(client){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:12,style:{marginBottom:'15px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["e" /* Card */],{key:client.id,style:{boxShadow:'none',border:'1px solid #afafaf'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["f" /* CardContent */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["v" /* Grid */],{container:true},Object.keys(__WEBPACK_IMPORTED_MODULE_4__objects__["b" /* propertyMapping */]).map(function(key){if(!props.selectedProperties.includes(key)){return null;}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,{key:key},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_Grid_GridItem_jsx__["a" /* default */],{xs:6,sm:6,md:6,style:{marginBottom:'5px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["Z" /* Typography */],{style:{textAlign:'left',wordBreak:'break-word'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,key+'  :'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_Grid_GridItem_jsx__["a" /* default */],{xs:6,sm:6,md:6,style:{marginBottom:'5px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["Z" /* Typography */],{key:key,style:{textAlign:'left',wordBreak:'break-word'}},client[__WEBPACK_IMPORTED_MODULE_4__objects__["b" /* propertyMapping */][key]]?client[__WEBPACK_IMPORTED_MODULE_4__objects__["b" /* propertyMapping */][key]]:'N/A')));}})))));})));};/* harmony default export */ __webpack_exports__["a"] = (SearchedPdf);

/***/ }),
/* 2857 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_core__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__objects__ = __webpack_require__(431);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SelectFieldsDialog=function(_React$Component){_inherits(SelectFieldsDialog,_React$Component);function SelectFieldsDialog(){var _ref;var _temp,_this,_ret;_classCallCheck(this,SelectFieldsDialog);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=SelectFieldsDialog.__proto__||Object.getPrototypeOf(SelectFieldsDialog)).call.apply(_ref,[this].concat(args))),_this),_this.onSubmit=function(){_this.props.exportPDF();},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(SelectFieldsDialog,[{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["k" /* Dialog */],{open:this.props.open,onClose:this.props.closeDialog,className:'selectFieldsDialog',style:{maxWidth:'70%'}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["o" /* DialogTitle */],{id:'form-dialog-title',style:{textAlign:'center'}},'Download Pdf'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["m" /* DialogContent */],{style:{paddingTop:'20px'}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{style:{textAlign:'center'}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{marginBottom:'15px'}},'Select fields which you would like to include')),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["v" /* Grid */],{container:true},__WEBPACK_IMPORTED_MODULE_3__objects__["a" /* fields */].map(function(field){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridItem_jsx__["a" /* default */],{xs:6,sm:4,md:3,key:field,style:{display:'flex',marginBottom:'10px'}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["Z" /* Typography */],{style:{position:'relative',top:'13px',maxWidth:'95px'}},field),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["h" /* Checkbox */],{checked:_this2.props.selectedFields.includes(field),onChange:_this2.props.handleFieldCheck(field)}));}))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["l" /* DialogActions */],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["d" /* Button */],{color:'primary',onClick:this.props.closeDialog},'Cancel'),this.props.savingPdf?__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["j" /* CircularProgress */],{color:'secondary',size:20,style:{position:'relative',left:'10px'}})):__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["d" /* Button */],{color:'primary',onClick:this.onSubmit},'Download')));}}]);return SelectFieldsDialog;}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (SelectFieldsDialog);

/***/ }),
/* 2858 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__ = __webpack_require__(65);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}// ##############################
// // // App styles
// #############################
var appStyle=function appStyle(theme){var _Object$assign;return{wrapper:{position:"relative",top:"0",height:"100vh","&:after":{display:"table",clear:"both",content:'" "'}},mainPanel:Object.assign((_Object$assign={transitionProperty:"top, bottom, width",transitionDuration:".2s, .2s, .35s",transitionTimingFunction:"linear, linear, ease"},_defineProperty(_Object$assign,theme.breakpoints.up("md"),{width:"calc(100% - "+__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["l" /* drawerWidth */]+"px)"}),_defineProperty(_Object$assign,"overflow","auto"),_defineProperty(_Object$assign,"position","relative"),_defineProperty(_Object$assign,"float","right"),_Object$assign),__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["F" /* transition */],{maxHeight:"100%",width:"100%",overflowScrolling:"touch"}),content:{padding:"0px 15px",marginTop:"92px",minHeight:"calc(100vh - 123px)"},container:Object.assign({},__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["d" /* containerFluid */]),map:{marginTop:"70px"},mainPanelSidebarMini:_defineProperty({},theme.breakpoints.up("md"),{width:"calc(100% - "+__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["k" /* drawerMiniWidth */]+"px)"}),mainPanelWithPerfectScrollbar:{overflow:"hidden !important"}};};/* harmony default export */ __webpack_exports__["a"] = (appStyle);

/***/ }),
/* 2859 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 2860 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__httpLink__ = __webpack_require__(2861);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__httpLink__["a"]; });

//# sourceMappingURL=index.js.map

/***/ }),
/* 2861 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createHttpLink; });
/* unused harmony export HttpLink */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_apollo_link__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_apollo_link_http_common__ = __webpack_require__(380);
/* tslint:disable */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};


var createHttpLink = function (linkOptions) {
    if (linkOptions === void 0) { linkOptions = {}; }
    var _a = linkOptions.uri, uri = _a === void 0 ? '/graphql' : _a, 
    // use default global fetch is nothing passed in
    fetcher = linkOptions.fetch, includeExtensions = linkOptions.includeExtensions, useGETForQueries = linkOptions.useGETForQueries, requestOptions = __rest(linkOptions, ["uri", "fetch", "includeExtensions", "useGETForQueries"]);
    // dev warnings to ensure fetch is present
    Object(__WEBPACK_IMPORTED_MODULE_1_apollo_link_http_common__["checkFetcher"])(fetcher);
    //fetcher is set here rather than the destructuring to ensure fetch is
    //declared before referencing it. Reference in the destructuring would cause
    //a ReferenceError
    if (!fetcher) {
        fetcher = fetch;
    }
    var linkConfig = {
        http: { includeExtensions: includeExtensions },
        options: requestOptions.fetchOptions,
        credentials: requestOptions.credentials,
        headers: requestOptions.headers,
    };
    return new __WEBPACK_IMPORTED_MODULE_0_apollo_link__["ApolloLink"](function (operation) {
        var chosenURI = Object(__WEBPACK_IMPORTED_MODULE_1_apollo_link_http_common__["selectURI"])(operation, uri);
        var context = operation.getContext();
        // `apollographql-client-*` headers are automatically set if a
        // `clientAwareness` object is found in the context. These headers are
        // set first, followed by the rest of the headers pulled from
        // `context.headers`. If desired, `apollographql-client-*` headers set by
        // the `clientAwareness` object can be overridden by
        // `apollographql-client-*` headers set in `context.headers`.
        var clientAwarenessHeaders = {};
        if (context.clientAwareness) {
            var _a = context.clientAwareness, name_1 = _a.name, version = _a.version;
            if (name_1) {
                clientAwarenessHeaders['apollographql-client-name'] = name_1;
            }
            if (version) {
                clientAwarenessHeaders['apollographql-client-version'] = version;
            }
        }
        var contextHeaders = __assign({}, clientAwarenessHeaders, context.headers);
        var contextConfig = {
            http: context.http,
            options: context.fetchOptions,
            credentials: context.credentials,
            headers: contextHeaders,
        };
        //uses fallback, link, and then context to build options
        var _b = Object(__WEBPACK_IMPORTED_MODULE_1_apollo_link_http_common__["selectHttpOptionsAndBody"])(operation, __WEBPACK_IMPORTED_MODULE_1_apollo_link_http_common__["fallbackHttpConfig"], linkConfig, contextConfig), options = _b.options, body = _b.body;
        var controller;
        if (!options.signal) {
            var _c = Object(__WEBPACK_IMPORTED_MODULE_1_apollo_link_http_common__["createSignalIfSupported"])(), _controller = _c.controller, signal = _c.signal;
            controller = _controller;
            if (controller)
                options.signal = signal;
        }
        // If requested, set method to GET if there are no mutations.
        var definitionIsMutation = function (d) {
            return d.kind === 'OperationDefinition' && d.operation === 'mutation';
        };
        if (useGETForQueries &&
            !operation.query.definitions.some(definitionIsMutation)) {
            options.method = 'GET';
        }
        if (options.method === 'GET') {
            var _d = rewriteURIForGET(chosenURI, body), newURI = _d.newURI, parseError = _d.parseError;
            if (parseError) {
                return Object(__WEBPACK_IMPORTED_MODULE_0_apollo_link__["fromError"])(parseError);
            }
            chosenURI = newURI;
        }
        else {
            try {
                options.body = Object(__WEBPACK_IMPORTED_MODULE_1_apollo_link_http_common__["serializeFetchParameter"])(body, 'Payload');
            }
            catch (parseError) {
                return Object(__WEBPACK_IMPORTED_MODULE_0_apollo_link__["fromError"])(parseError);
            }
        }
        return new __WEBPACK_IMPORTED_MODULE_0_apollo_link__["Observable"](function (observer) {
            fetcher(chosenURI, options)
                .then(function (response) {
                operation.setContext({ response: response });
                return response;
            })
                .then(Object(__WEBPACK_IMPORTED_MODULE_1_apollo_link_http_common__["parseAndCheckHttpResponse"])(operation))
                .then(function (result) {
                // we have data and can send it to back up the link chain
                observer.next(result);
                observer.complete();
                return result;
            })
                .catch(function (err) {
                // fetch was cancelled so its already been cleaned up in the unsubscribe
                if (err.name === 'AbortError')
                    return;
                // if it is a network error, BUT there is graphql result info
                // fire the next observer before calling error
                // this gives apollo-client (and react-apollo) the `graphqlErrors` and `networErrors`
                // to pass to UI
                // this should only happen if we *also* have data as part of the response key per
                // the spec
                if (err.result && err.result.errors && err.result.data) {
                    // if we dont' call next, the UI can only show networkError because AC didn't
                    // get andy graphqlErrors
                    // this is graphql execution result info (i.e errors and possibly data)
                    // this is because there is no formal spec how errors should translate to
                    // http status codes. So an auth error (401) could have both data
                    // from a public field, errors from a private field, and a status of 401
                    // {
                    //  user { // this will have errors
                    //    firstName
                    //  }
                    //  products { // this is public so will have data
                    //    cost
                    //  }
                    // }
                    //
                    // the result of above *could* look like this:
                    // {
                    //   data: { products: [{ cost: "$10" }] },
                    //   errors: [{
                    //      message: 'your session has timed out',
                    //      path: []
                    //   }]
                    // }
                    // status code of above would be a 401
                    // in the UI you want to show data where you can, errors as data where you can
                    // and use correct http status codes
                    observer.next(err.result);
                }
                observer.error(err);
            });
            return function () {
                // XXX support canceling this request
                // https://developers.google.com/web/updates/2017/09/abortable-fetch
                if (controller)
                    controller.abort();
            };
        });
    });
};
// For GET operations, returns the given URI rewritten with parameters, or a
// parse error.
function rewriteURIForGET(chosenURI, body) {
    // Implement the standard HTTP GET serialization, plus 'extensions'. Note
    // the extra level of JSON serialization!
    var queryParams = [];
    var addQueryParam = function (key, value) {
        queryParams.push(key + "=" + encodeURIComponent(value));
    };
    if ('query' in body) {
        addQueryParam('query', body.query);
    }
    if (body.operationName) {
        addQueryParam('operationName', body.operationName);
    }
    if (body.variables) {
        var serializedVariables = void 0;
        try {
            serializedVariables = Object(__WEBPACK_IMPORTED_MODULE_1_apollo_link_http_common__["serializeFetchParameter"])(body.variables, 'Variables map');
        }
        catch (parseError) {
            return { parseError: parseError };
        }
        addQueryParam('variables', serializedVariables);
    }
    if (body.extensions) {
        var serializedExtensions = void 0;
        try {
            serializedExtensions = Object(__WEBPACK_IMPORTED_MODULE_1_apollo_link_http_common__["serializeFetchParameter"])(body.extensions, 'Extensions map');
        }
        catch (parseError) {
            return { parseError: parseError };
        }
        addQueryParam('extensions', serializedExtensions);
    }
    // Reconstruct the URI with added query params.
    // XXX This assumes that the URI is well-formed and that it doesn't
    //     already contain any of these query params. We could instead use the
    //     URL API and take a polyfill (whatwg-url@6) for older browsers that
    //     don't support URLSearchParams. Note that some browsers (and
    //     versions of whatwg-url) support URL but not URLSearchParams!
    var fragment = '', preFragment = chosenURI;
    var fragmentStart = chosenURI.indexOf('#');
    if (fragmentStart !== -1) {
        fragment = chosenURI.substr(fragmentStart);
        preFragment = chosenURI.substr(0, fragmentStart);
    }
    var queryParamsPrefix = preFragment.indexOf('?') === -1 ? '?' : '&';
    var newURI = preFragment + queryParamsPrefix + queryParams.join('&') + fragment;
    return { newURI: newURI };
}
var HttpLink = /** @class */ (function (_super) {
    __extends(HttpLink, _super);
    function HttpLink(opts) {
        return _super.call(this, createHttpLink(opts).request) || this;
    }
    return HttpLink;
}(__WEBPACK_IMPORTED_MODULE_0_apollo_link__["ApolloLink"]));

//# sourceMappingURL=httpLink.js.map

/***/ }),
/* 2862 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2863 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2864 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return onError; });
/* unused harmony export ErrorLink */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_apollo_link__ = __webpack_require__(95);
/* tslint:disable */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var onError = function (errorHandler) {
    return new __WEBPACK_IMPORTED_MODULE_0_apollo_link__["ApolloLink"](function (operation, forward) {
        return new __WEBPACK_IMPORTED_MODULE_0_apollo_link__["Observable"](function (observer) {
            var sub;
            var retriedSub;
            var retriedResult;
            try {
                sub = forward(operation).subscribe({
                    next: function (result) {
                        if (result.errors) {
                            retriedResult = errorHandler({
                                graphQLErrors: result.errors,
                                response: result,
                                operation: operation,
                                forward: forward,
                            });
                            if (retriedResult) {
                                retriedSub = retriedResult.subscribe({
                                    next: observer.next.bind(observer),
                                    error: observer.error.bind(observer),
                                    complete: observer.complete.bind(observer),
                                });
                                return;
                            }
                        }
                        observer.next(result);
                    },
                    error: function (networkError) {
                        retriedResult = errorHandler({
                            operation: operation,
                            networkError: networkError,
                            //Network errors can return GraphQL errors on for example a 403
                            graphQLErrors: networkError.result && networkError.result.errors,
                            forward: forward,
                        });
                        if (retriedResult) {
                            retriedSub = retriedResult.subscribe({
                                next: observer.next.bind(observer),
                                error: observer.error.bind(observer),
                                complete: observer.complete.bind(observer),
                            });
                            return;
                        }
                        observer.error(networkError);
                    },
                    complete: function () {
                        // disable the previous sub from calling complete on observable
                        // if retry is in flight.
                        if (!retriedResult) {
                            observer.complete.bind(observer)();
                        }
                    },
                });
            }
            catch (e) {
                errorHandler({ networkError: e, operation: operation, forward: forward });
                observer.error(e);
            }
            return function () {
                if (sub)
                    sub.unsubscribe();
                if (retriedSub)
                    sub.unsubscribe();
            };
        });
    });
};
var ErrorLink = /** @class */ (function (_super) {
    __extends(ErrorLink, _super);
    function ErrorLink(errorHandler) {
        var _this = _super.call(this) || this;
        _this.link = onError(errorHandler);
        return _this;
    }
    ErrorLink.prototype.request = function (operation, forward) {
        return this.link.request(operation, forward);
    };
    return ErrorLink;
}(__WEBPACK_IMPORTED_MODULE_0_apollo_link__["ApolloLink"]));

//# sourceMappingURL=index.js.map

/***/ }),
/* 2865 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, process) {

Object.defineProperty(exports, '__esModule', { value: true });

var tslib_1 = __webpack_require__(43);
var core = __webpack_require__(2866);

var commonjsGlobal = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function unwrapExports (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x.default : x;
}

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var dist = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });
/** JSDoc */
var Severity;
(function (Severity) {
    /** JSDoc */
    Severity["Fatal"] = "fatal";
    /** JSDoc */
    Severity["Error"] = "error";
    /** JSDoc */
    Severity["Warning"] = "warning";
    /** JSDoc */
    Severity["Log"] = "log";
    /** JSDoc */
    Severity["Info"] = "info";
    /** JSDoc */
    Severity["Debug"] = "debug";
    /** JSDoc */
    Severity["Critical"] = "critical";
})(Severity = exports.Severity || (exports.Severity = {}));
// tslint:disable:no-unnecessary-qualifier no-namespace
(function (Severity) {
    /**
     * Converts a string-based level into a {@link Severity}.
     *
     * @param level string representation of Severity
     * @returns Severity
     */
    function fromString(level) {
        switch (level) {
            case 'debug':
                return Severity.Debug;
            case 'info':
                return Severity.Info;
            case 'warn':
            case 'warning':
                return Severity.Warning;
            case 'error':
                return Severity.Error;
            case 'fatal':
                return Severity.Fatal;
            case 'critical':
                return Severity.Critical;
            case 'log':
            default:
                return Severity.Log;
        }
    }
    Severity.fromString = fromString;
})(Severity = exports.Severity || (exports.Severity = {}));
/** The status of an event. */
var Status;
(function (Status) {
    /** The status could not be determined. */
    Status["Unknown"] = "unknown";
    /** The event was skipped due to configuration or callbacks. */
    Status["Skipped"] = "skipped";
    /** The event was sent to Sentry successfully. */
    Status["Success"] = "success";
    /** The client is currently rate limited and will try again later. */
    Status["RateLimit"] = "rate_limit";
    /** The event could not be processed. */
    Status["Invalid"] = "invalid";
    /** A server-side error ocurred during submission. */
    Status["Failed"] = "failed";
})(Status = exports.Status || (exports.Status = {}));
// tslint:disable:no-unnecessary-qualifier no-namespace
(function (Status) {
    /**
     * Converts a HTTP status code into a {@link Status}.
     *
     * @param code The HTTP response status code.
     * @returns The send status or {@link Status.Unknown}.
     */
    function fromHttpCode(code) {
        if (code >= 200 && code < 300) {
            return Status.Success;
        }
        if (code === 429) {
            return Status.RateLimit;
        }
        if (code >= 400 && code < 500) {
            return Status.Invalid;
        }
        if (code >= 500) {
            return Status.Failed;
        }
        return Status.Unknown;
    }
    Status.fromHttpCode = fromHttpCode;
})(Status = exports.Status || (exports.Status = {}));

});

unwrapExports(dist);
var dist_1 = dist.Severity;
var dist_2 = dist.Status;

var is = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Checks whether given value's type is one of a few Error or Error-like
 * {@link isError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isError(wat) {
    switch (Object.prototype.toString.call(wat)) {
        case '[object Error]':
            return true;
        case '[object Exception]':
            return true;
        case '[object DOMException]':
            return true;
        default:
            return wat instanceof Error;
    }
}
exports.isError = isError;
/**
 * Checks whether given value's type is ErrorEvent
 * {@link isErrorEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isErrorEvent(wat) {
    return Object.prototype.toString.call(wat) === '[object ErrorEvent]';
}
exports.isErrorEvent = isErrorEvent;
/**
 * Checks whether given value's type is DOMError
 * {@link isDOMError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isDOMError(wat) {
    return Object.prototype.toString.call(wat) === '[object DOMError]';
}
exports.isDOMError = isDOMError;
/**
 * Checks whether given value's type is DOMException
 * {@link isDOMException}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isDOMException(wat) {
    return Object.prototype.toString.call(wat) === '[object DOMException]';
}
exports.isDOMException = isDOMException;
/**
 * Checks whether given value's type is an undefined
 * {@link isUndefined}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isUndefined(wat) {
    return wat === void 0;
}
exports.isUndefined = isUndefined;
/**
 * Checks whether given value's type is a function
 * {@link isFunction}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isFunction(wat) {
    return typeof wat === 'function';
}
exports.isFunction = isFunction;
/**
 * Checks whether given value's type is a string
 * {@link isString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isString(wat) {
    return Object.prototype.toString.call(wat) === '[object String]';
}
exports.isString = isString;
/**
 * Checks whether given value's is a primitive (undefined, null, number, boolean, string)
 * {@link isPrimitive}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isPrimitive(wat) {
    return wat === null || (typeof wat !== 'object' && typeof wat !== 'function');
}
exports.isPrimitive = isPrimitive;
/**
 * Checks whether given value's type is an array
 * {@link isArray}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isArray(wat) {
    return Object.prototype.toString.call(wat) === '[object Array]';
}
exports.isArray = isArray;
/**
 * Checks whether given value's type is an object literal
 * {@link isPlainObject}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isPlainObject(wat) {
    return Object.prototype.toString.call(wat) === '[object Object]';
}
exports.isPlainObject = isPlainObject;
/**
 * Checks whether given value's type is an regexp
 * {@link isRegExp}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isRegExp(wat) {
    return Object.prototype.toString.call(wat) === '[object RegExp]';
}
exports.isRegExp = isRegExp;
/**
 * Checks whether given value's type is a NaN
 * {@link isNaN}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isNaN(wat) {
    return wat !== wat;
}
exports.isNaN = isNaN;

});

unwrapExports(is);
var is_1 = is.isError;
var is_2 = is.isErrorEvent;
var is_3 = is.isDOMError;
var is_4 = is.isDOMException;
var is_5 = is.isUndefined;
var is_6 = is.isFunction;
var is_7 = is.isString;
var is_8 = is.isPrimitive;
var is_9 = is.isArray;
var is_10 = is.isPlainObject;
var is_11 = is.isRegExp;
var is_12 = is.isNaN;

var misc = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });

/**
 * Requires a module which is protected against bundler minification.
 *
 * @param request The module path to resolve
 */
function dynamicRequire(mod, request) {
    return mod.require(request);
}
exports.dynamicRequire = dynamicRequire;
/**
 * Checks whether we're in the Node.js or Browser environment
 *
 * @returns Answer to given question
 */
function isNodeEnv() {
    // tslint:disable:strict-type-predicates
    return Object.prototype.toString.call(typeof process !== 'undefined' ? process : 0) === '[object process]';
}
exports.isNodeEnv = isNodeEnv;
/**
 * Safely get global scope object
 *
 * @returns Global scope object
 */
// tslint:disable:strict-type-predicates
function getGlobalObject() {
    return isNodeEnv() ? commonjsGlobal : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {};
}
exports.getGlobalObject = getGlobalObject;
/**
 * UUID4 generator
 *
 * @returns string Generated UUID4.
 */
function uuid4() {
    var global = getGlobalObject();
    var crypto = global.crypto || global.msCrypto;
    if (!(crypto === void 0) && crypto.getRandomValues) {
        // Use window.crypto API if available
        var arr = new Uint16Array(8);
        crypto.getRandomValues(arr);
        // set 4 in byte 7
        // tslint:disable-next-line:no-bitwise
        arr[3] = (arr[3] & 0xfff) | 0x4000;
        // set 2 most significant bits of byte 9 to '10'
        // tslint:disable-next-line:no-bitwise
        arr[4] = (arr[4] & 0x3fff) | 0x8000;
        var pad = function (num) {
            var v = num.toString(16);
            while (v.length < 4) {
                v = "0" + v;
            }
            return v;
        };
        return (pad(arr[0]) + pad(arr[1]) + pad(arr[2]) + pad(arr[3]) + pad(arr[4]) + pad(arr[5]) + pad(arr[6]) + pad(arr[7]));
    }
    else {
        // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
        return 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            // tslint:disable-next-line:no-bitwise
            var r = (Math.random() * 16) | 0;
            // tslint:disable-next-line:no-bitwise
            var v = c === 'x' ? r : (r & 0x3) | 0x8;
            return v.toString(16);
        });
    }
}
exports.uuid4 = uuid4;
/**
 * Given a child DOM element, returns a query-selector statement describing that
 * and its ancestors
 * e.g. [HTMLElement] => body > div > input#foo.btn[name=baz]
 * @returns generated DOM path
 */
function htmlTreeAsString(elem) {
    var currentElem = elem;
    var MAX_TRAVERSE_HEIGHT = 5;
    var MAX_OUTPUT_LEN = 80;
    var out = [];
    var height = 0;
    var len = 0;
    var separator = ' > ';
    var sepLength = separator.length;
    var nextStr;
    while (currentElem && height++ < MAX_TRAVERSE_HEIGHT) {
        nextStr = htmlElementAsString(currentElem);
        // bail out if
        // - nextStr is the 'html' element
        // - the length of the string that would be created exceeds MAX_OUTPUT_LEN
        //   (ignore this limit if we are on the first iteration)
        if (nextStr === 'html' || (height > 1 && len + out.length * sepLength + nextStr.length >= MAX_OUTPUT_LEN)) {
            break;
        }
        out.push(nextStr);
        len += nextStr.length;
        currentElem = currentElem.parentNode;
    }
    return out.reverse().join(separator);
}
exports.htmlTreeAsString = htmlTreeAsString;
/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @returns generated DOM path
 */
function htmlElementAsString(elem) {
    var out = [];
    var className;
    var classes;
    var key;
    var attr;
    var i;
    if (!elem || !elem.tagName) {
        return '';
    }
    out.push(elem.tagName.toLowerCase());
    if (elem.id) {
        out.push("#" + elem.id);
    }
    className = elem.className;
    if (className && is.isString(className)) {
        classes = className.split(/\s+/);
        for (i = 0; i < classes.length; i++) {
            out.push("." + classes[i]);
        }
    }
    var attrWhitelist = ['type', 'name', 'title', 'alt'];
    for (i = 0; i < attrWhitelist.length; i++) {
        key = attrWhitelist[i];
        attr = elem.getAttribute(key);
        if (attr) {
            out.push("[" + key + "=\"" + attr + "\"]");
        }
    }
    return out.join('');
}
exports.htmlElementAsString = htmlElementAsString;
/**
 * Parses string form of URL into an object
 * // borrowed from https://tools.ietf.org/html/rfc3986#appendix-B
 * // intentionally using regex and not <a/> href parsing trick because React Native and other
 * // environments where DOM might not be available
 * @returns parsed URL object
 */
function parseUrl(url) {
    if (!url) {
        return {};
    }
    var match = url.match(/^(([^:\/?#]+):)?(\/\/([^\/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
    if (!match) {
        return {};
    }
    // coerce to undefined values to empty string so we don't get 'undefined'
    var query = match[6] || '';
    var fragment = match[8] || '';
    return {
        host: match[4],
        path: match[5],
        protocol: match[2],
        relative: match[5] + query + fragment,
    };
}
exports.parseUrl = parseUrl;
/**
 * Extracts either message or type+value from an event that can be used for user-facing logs
 * @returns event's description
 */
function getEventDescription(event) {
    if (event.message) {
        return event.message;
    }
    else if (event.exception && event.exception.values && event.exception.values[0]) {
        var exception = event.exception.values[0];
        if (exception.type && exception.value) {
            return exception.type + ": " + exception.value;
        }
        else {
            return exception.type || exception.value || event.event_id || '<unknown>';
        }
    }
    else {
        return event.event_id || '<unknown>';
    }
}
exports.getEventDescription = getEventDescription;
/** JSDoc */
function consoleSandbox(callback) {
    var global = getGlobalObject();
    var levels = ['debug', 'info', 'warn', 'error', 'log'];
    if (!('console' in global)) {
        return callback();
    }
    var originalConsole = global.console;
    var wrappedLevels = {};
    // Restore all wrapped console methods
    levels.forEach(function (level) {
        if (level in global.console && originalConsole[level].__sentry__) {
            wrappedLevels[level] = originalConsole[level].__sentry_wrapped__;
            originalConsole[level] = originalConsole[level].__sentry_original__;
        }
    });
    // Perform callback manipulations
    var result = callback();
    // Revert restoration to wrapped state
    Object.keys(wrappedLevels).forEach(function (level) {
        originalConsole[level] = wrappedLevels[level];
    });
    return result;
}
exports.consoleSandbox = consoleSandbox;

});

unwrapExports(misc);
var misc_1 = misc.dynamicRequire;
var misc_2 = misc.isNodeEnv;
var misc_3 = misc.getGlobalObject;
var misc_4 = misc.uuid4;
var misc_5 = misc.htmlTreeAsString;
var misc_6 = misc.htmlElementAsString;
var misc_7 = misc.parseUrl;
var misc_8 = misc.getEventDescription;
var misc_9 = misc.consoleSandbox;

var supports = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });

/**
 * Tells whether current environment supports ErrorEvent objects
 * {@link supportsErrorEvent}.
 *
 * @returns Answer to the given question.
 */
function supportsErrorEvent() {
    try {
        // tslint:disable:no-unused-expression
        new ErrorEvent('');
        return true;
    }
    catch (e) {
        return false;
    }
}
exports.supportsErrorEvent = supportsErrorEvent;
/**
 * Tells whether current environment supports DOMError objects
 * {@link supportsDOMError}.
 *
 * @returns Answer to the given question.
 */
function supportsDOMError() {
    try {
        // It really needs 1 argument, not 0.
        // Chrome: VM89:1 Uncaught TypeError: Failed to construct 'DOMError':
        // 1 argument required, but only 0 present.
        // @ts-ignore
        // tslint:disable:no-unused-expression
        new DOMError('');
        return true;
    }
    catch (e) {
        return false;
    }
}
exports.supportsDOMError = supportsDOMError;
/**
 * Tells whether current environment supports DOMException objects
 * {@link supportsDOMException}.
 *
 * @returns Answer to the given question.
 */
function supportsDOMException() {
    try {
        // tslint:disable:no-unused-expression
        new DOMException('');
        return true;
    }
    catch (e) {
        return false;
    }
}
exports.supportsDOMException = supportsDOMException;
/**
 * Tells whether current environment supports Fetch API
 * {@link supportsFetch}.
 *
 * @returns Answer to the given question.
 */
function supportsFetch() {
    if (!('fetch' in misc.getGlobalObject())) {
        return false;
    }
    try {
        // tslint:disable-next-line:no-unused-expression
        new Headers();
        // tslint:disable-next-line:no-unused-expression
        new Request('');
        // tslint:disable-next-line:no-unused-expression
        new Response();
        return true;
    }
    catch (e) {
        return false;
    }
}
exports.supportsFetch = supportsFetch;
/**
 * Tells whether current environment supports Fetch API natively
 * {@link supportsNativeFetch}.
 *
 * @returns Answer to the given question.
 */
function supportsNativeFetch() {
    if (!supportsFetch()) {
        return false;
    }
    var global = misc.getGlobalObject();
    var fetch = global.fetch;
    // tslint:disable-next-line:no-unsafe-any
    return fetch.toString().indexOf('native') !== -1;
}
exports.supportsNativeFetch = supportsNativeFetch;
/**
 * Tells whether current environment supports sendBeacon API
 * {@link supportsBeacon}.
 *
 * @returns Answer to the given question.
 */
function supportsBeacon() {
    var global = misc.getGlobalObject();
    return 'navigator' in global && 'sendBeacon' in global.navigator;
}
exports.supportsBeacon = supportsBeacon;
/**
 * Tells whether current environment supports ReportingObserver API
 * {@link supportsReportingObserver}.
 *
 * @returns Answer to the given question.
 */
function supportsReportingObserver() {
    return 'ReportingObserver' in misc.getGlobalObject();
}
exports.supportsReportingObserver = supportsReportingObserver;
/**
 * Tells whether current environment supports Referrer Policy API
 * {@link supportsReferrerPolicy}.
 *
 * @returns Answer to the given question.
 */
function supportsReferrerPolicy() {
    // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default
    // https://caniuse.com/#feat=referrer-policy
    // It doesn't. And it throw exception instead of ignoring this parameter...
    // REF: https://github.com/getsentry/raven-js/issues/1233
    if (!supportsFetch()) {
        return false;
    }
    try {
        // tslint:disable:no-unused-expression
        new Request('pickleRick', {
            referrerPolicy: 'origin',
        });
        return true;
    }
    catch (e) {
        return false;
    }
}
exports.supportsReferrerPolicy = supportsReferrerPolicy;
/**
 * Tells whether current environment supports History API
 * {@link supportsHistory}.
 *
 * @returns Answer to the given question.
 */
function supportsHistory() {
    // NOTE: in Chrome App environment, touching history.pushState, *even inside
    //       a try/catch block*, will cause Chrome to output an error to console.error
    // borrowed from: https://github.com/angular/angular.js/pull/13945/files
    var global = misc.getGlobalObject();
    var chrome = global.chrome;
    // tslint:disable-next-line:no-unsafe-any
    var isChromePackagedApp = chrome && chrome.app && chrome.app.runtime;
    var hasHistoryApi = 'history' in global && !!global.history.pushState && !!global.history.replaceState;
    return !isChromePackagedApp && hasHistoryApi;
}
exports.supportsHistory = supportsHistory;

});

unwrapExports(supports);
var supports_1 = supports.supportsErrorEvent;
var supports_2 = supports.supportsDOMError;
var supports_3 = supports.supportsDOMException;
var supports_4 = supports.supportsFetch;
var supports_5 = supports.supportsNativeFetch;
var supports_6 = supports.supportsBeacon;
var supports_7 = supports.supportsReportingObserver;
var supports_8 = supports.supportsReferrerPolicy;
var supports_9 = supports.supportsHistory;

var string = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });

/**
 * Truncates given string to the maximum characters count
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string
 * @returns string Encoded
 */
function truncate(str, max) {
    if (max === void 0) { max = 0; }
    if (max === 0 || !is.isString(str)) {
        return str;
    }
    return str.length <= max ? str : str.substr(0, max) + "...";
}
exports.truncate = truncate;
/**
 * This is basically just `trim_line` from
 * https://github.com/getsentry/sentry/blob/master/src/sentry/lang/javascript/processor.py#L67
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string
 * @returns string Encoded
 */
function snipLine(line, colno) {
    var newLine = line;
    var ll = newLine.length;
    if (ll <= 150) {
        return newLine;
    }
    if (colno > ll) {
        colno = ll; // tslint:disable-line:no-parameter-reassignment
    }
    var start = Math.max(colno - 60, 0);
    if (start < 5) {
        start = 0;
    }
    var end = Math.min(start + 140, ll);
    if (end > ll - 5) {
        end = ll;
    }
    if (end === ll) {
        start = Math.max(end - 140, 0);
    }
    newLine = newLine.slice(start, end);
    if (start > 0) {
        newLine = "'{snip} " + newLine;
    }
    if (end < ll) {
        newLine += ' {snip}';
    }
    return newLine;
}
exports.snipLine = snipLine;
/**
 * Join values in array
 * @param input array of values to be joined together
 * @param delimiter string to be placed in-between values
 * @returns Joined values
 */
function safeJoin(input, delimiter) {
    if (!Array.isArray(input)) {
        return '';
    }
    var output = [];
    // tslint:disable-next-line
    for (var i = 0; i < input.length; i++) {
        var value = input[i];
        try {
            output.push(String(value));
        }
        catch (e) {
            output.push('[value cannot be serialized]');
        }
    }
    return output.join(delimiter);
}
exports.safeJoin = safeJoin;
/**
 * Checks if given value is included in the target
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/includes#Polyfill
 * @param target source string
 * @param search string to be looked for
 * @returns An answer
 */
function includes(target, search) {
    if (search.length > target.length) {
        return false;
    }
    else {
        return target.indexOf(search) !== -1;
    }
}
exports.includes = includes;

});

unwrapExports(string);
var string_1 = string.truncate;
var string_2 = string.snipLine;
var string_3 = string.safeJoin;
var string_4 = string.includes;

var object = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });


/**
 * Serializes the given object into a string.
 * Like JSON.stringify, but doesn't throw on circular references.
 *
 * @param object A JSON-serializable object.
 * @returns A string containing the serialized object.
 */
function serialize(object) {
    return JSON.stringify(object, serializer({ normalize: false }));
}
exports.serialize = serialize;
/**
 * Deserializes an object from a string previously serialized with
 * {@link serialize}.
 *
 * @param str A serialized object.
 * @returns The deserialized object.
 */
function deserialize(str) {
    return JSON.parse(str);
}
exports.deserialize = deserialize;
/**
 * Creates a deep copy of the given object.
 *
 * The object must be serializable, i.e.:
 *  - It must not contain any cycles
 *  - Only primitive types are allowed (object, array, number, string, boolean)
 *  - Its depth should be considerably low for performance reasons
 *
 * @param object A JSON-serializable object.
 * @returns The object clone.
 */
function clone(object) {
    return deserialize(serialize(object));
}
exports.clone = clone;
/**
 * Wrap a given object method with a higher-order function
 *
 * @param source An object that contains a method to be wrapped.
 * @param name A name of method to be wrapped.
 * @param replacement A function that should be used to wrap a given method.
 * @returns void
 */
function fill(source, name, replacement) {
    if (!(name in source) || source[name].__sentry__) {
        return;
    }
    var original = source[name];
    var wrapped = replacement(original);
    wrapped.__sentry__ = true;
    wrapped.__sentry_original__ = original;
    wrapped.__sentry_wrapped__ = wrapped;
    source[name] = wrapped;
}
exports.fill = fill;
/**
 * Encodes given object into url-friendly format
 *
 * @param object An object that contains serializable values
 * @returns string Encoded
 */
function urlEncode(object) {
    return Object.keys(object)
        .map(
    // tslint:disable-next-line:no-unsafe-any
    function (key) { return encodeURIComponent(key) + "=" + encodeURIComponent(object[key]); })
        .join('&');
}
exports.urlEncode = urlEncode;
// Default Node.js REPL depth
var MAX_SERIALIZE_EXCEPTION_DEPTH = 3;
// 100kB, as 200kB is max payload size, so half sounds reasonable
var MAX_SERIALIZE_EXCEPTION_SIZE = 100 * 1024;
var MAX_SERIALIZE_KEYS_LENGTH = 40;
/** JSDoc */
function utf8Length(value) {
    // tslint:disable-next-line:no-bitwise
    return ~-encodeURI(value).split(/%..|./).length;
}
/** JSDoc */
function jsonSize(value) {
    return utf8Length(JSON.stringify(value));
}
/** JSDoc */
function serializeValue(value) {
    var type = Object.prototype.toString.call(value);
    if (typeof value === 'string') {
        return string.truncate(value, 40);
    }
    else if (type === '[object Object]') {
        // Node.js REPL notation
        return '[Object]';
    }
    else if (type === '[object Array]') {
        // Node.js REPL notation
        return '[Array]';
    }
    else {
        return normalizeValue(value);
    }
}
/** JSDoc */
function serializeObject(value, depth) {
    if (depth === 0) {
        return serializeValue(value);
    }
    if (is.isPlainObject(value)) {
        var serialized_1 = {};
        var val_1 = value;
        Object.keys(val_1).forEach(function (key) {
            serialized_1[key] = serializeObject(val_1[key], depth - 1);
        });
        return serialized_1;
    }
    else if (Array.isArray(value)) {
        var val = value;
        return val.map(function (v) { return serializeObject(v, depth - 1); });
    }
    return serializeValue(value);
}
exports.serializeObject = serializeObject;
/** JSDoc */
function limitObjectDepthToSize(object, depth, maxSize) {
    if (depth === void 0) { depth = MAX_SERIALIZE_EXCEPTION_DEPTH; }
    if (maxSize === void 0) { maxSize = MAX_SERIALIZE_EXCEPTION_SIZE; }
    var serialized = serializeObject(object, depth);
    if (jsonSize(serialize(serialized)) > maxSize) {
        return limitObjectDepthToSize(object, depth - 1);
    }
    return serialized;
}
exports.limitObjectDepthToSize = limitObjectDepthToSize;
/** JSDoc */
function serializeKeysToEventMessage(keys, maxLength) {
    if (maxLength === void 0) { maxLength = MAX_SERIALIZE_KEYS_LENGTH; }
    if (!keys.length) {
        return '[object has no keys]';
    }
    if (keys[0].length >= maxLength) {
        return string.truncate(keys[0], maxLength);
    }
    for (var includedKeys = keys.length; includedKeys > 0; includedKeys--) {
        var serialized = keys.slice(0, includedKeys).join(', ');
        if (serialized.length > maxLength) {
            continue;
        }
        if (includedKeys === keys.length) {
            return serialized;
        }
        return string.truncate(serialized, maxLength);
    }
    return '';
}
exports.serializeKeysToEventMessage = serializeKeysToEventMessage;
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/assign#Polyfill
/** JSDoc */
function assign(target) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    if (target === null || target === undefined) {
        throw new TypeError('Cannot convert undefined or null to object');
    }
    var to = Object(target);
    // tslint:disable-next-line
    for (var i = 0; i < args.length; i++) {
        var source = args[i];
        if (source !== null) {
            for (var nextKey in source) {
                if (Object.prototype.hasOwnProperty.call(source, nextKey)) {
                    to[nextKey] = source[nextKey];
                }
            }
        }
    }
    return to;
}
exports.assign = assign;
/**
 * Transforms Error object into an object literal with all it's attributes
 * attached to it.
 *
 * Based on: https://github.com/ftlabs/js-abbreviate/blob/fa709e5f139e7770a71827b1893f22418097fbda/index.js#L95-L106
 *
 * @param error An Error containing all relevant information
 * @returns An object with all error properties
 */
function objectifyError(error) {
    // These properties are implemented as magical getters and don't show up in `for-in` loop
    var err = {
        message: error.message,
        name: error.name,
        stack: error.stack,
    };
    for (var i in error) {
        if (Object.prototype.hasOwnProperty.call(error, i)) {
            err[i] = error[i];
        }
    }
    return err;
}
/**
 * normalizeValue()
 *
 * Takes unserializable input and make it serializable friendly
 *
 * - translates undefined/NaN values to "[undefined]"/"[NaN]" respectively,
 * - serializes Error objects
 * - filter global objects
 */
function normalizeValue(value, key) {
    if (key === 'domain' && typeof value === 'object' && value._events) {
        return '[Domain]';
    }
    if (key === 'domainEmitter') {
        return '[DomainEmitter]';
    }
    if (typeof commonjsGlobal !== 'undefined' && value === commonjsGlobal) {
        return '[Global]';
    }
    if (typeof window !== 'undefined' && value === window) {
        return '[Window]';
    }
    if (typeof document !== 'undefined' && value === document) {
        return '[Document]';
    }
    if (value instanceof Date) {
        return "[Date] " + value;
    }
    if (value instanceof Error) {
        return objectifyError(value);
    }
    if (is.isNaN(value)) {
        return '[NaN]';
    }
    if (is.isUndefined(value)) {
        return '[undefined]';
    }
    if (typeof value === 'function') {
        return "[Function: " + (value.name || '<unknown-function-name>') + "]";
    }
    return value;
}
/**
 * serializer()
 *
 * Remove circular references,
 * translates undefined/NaN values to "[undefined]"/"[NaN]" respectively,
 * and takes care of Error objects serialization
 */
function serializer(options) {
    if (options === void 0) { options = { normalize: true }; }
    var stack = [];
    var keys = [];
    /** recursive */
    function cycleserializer(_key, value) {
        if (stack[0] === value) {
            return '[Circular ~]';
        }
        return "[Circular ~." + keys.slice(0, stack.indexOf(value)).join('.') + "]";
    }
    return function (key, value) {
        if (stack.length > 0) {
            var thisPos = stack.indexOf(this);
            if (thisPos === -1) {
                stack.push(this);
                keys.push(key);
            }
            else {
                stack.splice(thisPos + 1);
                keys.splice(thisPos, Infinity, key);
            }
            if (stack.indexOf(value) !== -1) {
                // tslint:disable-next-line:no-parameter-reassignment
                value = cycleserializer.call(this, key, value);
            }
        }
        else {
            stack.push(value);
        }
        return options.normalize ? normalizeValue(value, key) : value;
    };
}
/**
 * safeNormalize()
 *
 * Creates a copy of the input by applying serializer function on it and parsing it back to unify the data
 */
function safeNormalize(input) {
    try {
        return JSON.parse(JSON.stringify(input, serializer({ normalize: true })));
    }
    catch (_oO) {
        return '**non-serializable**';
    }
}
exports.safeNormalize = safeNormalize;

});

unwrapExports(object);
var object_1 = object.serialize;
var object_2 = object.deserialize;
var object_3 = object.clone;
var object_4 = object.fill;
var object_5 = object.urlEncode;
var object_6 = object.serializeObject;
var object_7 = object.limitObjectDepthToSize;
var object_8 = object.serializeKeysToEventMessage;
var object_9 = object.assign;
var object_10 = object.safeNormalize;

// tslint:disable
/*
 * JavaScript MD5
 * https://github.com/blueimp/JavaScript-MD5
 *
 * Copyright 2011, Sebastian Tschan
 * https://blueimp.net
 *
 * Licensed under the MIT license:
 * https://opensource.org/licenses/MIT
 *
 * Based on
 * A JavaScript implementation of the RSA Data Security, Inc. MD5 Message
 * Digest Algorithm, as defined in RFC 1321.
 * Version 2.2 Copyright (C) Paul Johnston 1999 - 2009
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 * Distributed under the BSD License
 * See http://pajhome.org.uk/crypt/md5 for more info.
 */
/**
 * Add integers, wrapping at 2^32. This uses 16-bit operations internally
 * to work around bugs in some JS interpreters.
 */
function safeAdd(x, y) {
    var lsw = (x & 0xffff) + (y & 0xffff);
    var msw = (x >> 16) + (y >> 16) + (lsw >> 16);
    return (msw << 16) | (lsw & 0xffff);
}
/**
 * Bitwise rotate a 32-bit number to the left.
 */
function bitRotateLeft(num, cnt) {
    return (num << cnt) | (num >>> (32 - cnt));
}
/**
 * These functions implement the four basic operations the algorithm uses.
 */
function md5cmn(q, a, b, x, s, t) {
    return safeAdd(bitRotateLeft(safeAdd(safeAdd(a, q), safeAdd(x, t)), s), b);
}
function md5ff(a, b, c, d, x, s, t) {
    return md5cmn((b & c) | (~b & d), a, b, x, s, t);
}
function md5gg(a, b, c, d, x, s, t) {
    return md5cmn((b & d) | (c & ~d), a, b, x, s, t);
}
function md5hh(a, b, c, d, x, s, t) {
    return md5cmn(b ^ c ^ d, a, b, x, s, t);
}
function md5ii(a, b, c, d, x, s, t) {
    return md5cmn(c ^ (b | ~d), a, b, x, s, t);
}
/**
 * Calculate the MD5 of an array of little-endian words, and a bit length.
 */
function binlMD5(x, len) {
    /** append padding */
    x[len >> 5] |= 0x80 << len % 32;
    x[(((len + 64) >>> 9) << 4) + 14] = len;
    var i;
    var olda;
    var oldb;
    var oldc;
    var oldd;
    var a = 1732584193;
    var b = -271733879;
    var c = -1732584194;
    var d = 271733878;
    for (i = 0; i < x.length; i += 16) {
        olda = a;
        oldb = b;
        oldc = c;
        oldd = d;
        a = md5ff(a, b, c, d, x[i], 7, -680876936);
        d = md5ff(d, a, b, c, x[i + 1], 12, -389564586);
        c = md5ff(c, d, a, b, x[i + 2], 17, 606105819);
        b = md5ff(b, c, d, a, x[i + 3], 22, -1044525330);
        a = md5ff(a, b, c, d, x[i + 4], 7, -176418897);
        d = md5ff(d, a, b, c, x[i + 5], 12, 1200080426);
        c = md5ff(c, d, a, b, x[i + 6], 17, -1473231341);
        b = md5ff(b, c, d, a, x[i + 7], 22, -45705983);
        a = md5ff(a, b, c, d, x[i + 8], 7, 1770035416);
        d = md5ff(d, a, b, c, x[i + 9], 12, -1958414417);
        c = md5ff(c, d, a, b, x[i + 10], 17, -42063);
        b = md5ff(b, c, d, a, x[i + 11], 22, -1990404162);
        a = md5ff(a, b, c, d, x[i + 12], 7, 1804603682);
        d = md5ff(d, a, b, c, x[i + 13], 12, -40341101);
        c = md5ff(c, d, a, b, x[i + 14], 17, -1502002290);
        b = md5ff(b, c, d, a, x[i + 15], 22, 1236535329);
        a = md5gg(a, b, c, d, x[i + 1], 5, -165796510);
        d = md5gg(d, a, b, c, x[i + 6], 9, -1069501632);
        c = md5gg(c, d, a, b, x[i + 11], 14, 643717713);
        b = md5gg(b, c, d, a, x[i], 20, -373897302);
        a = md5gg(a, b, c, d, x[i + 5], 5, -701558691);
        d = md5gg(d, a, b, c, x[i + 10], 9, 38016083);
        c = md5gg(c, d, a, b, x[i + 15], 14, -660478335);
        b = md5gg(b, c, d, a, x[i + 4], 20, -405537848);
        a = md5gg(a, b, c, d, x[i + 9], 5, 568446438);
        d = md5gg(d, a, b, c, x[i + 14], 9, -1019803690);
        c = md5gg(c, d, a, b, x[i + 3], 14, -187363961);
        b = md5gg(b, c, d, a, x[i + 8], 20, 1163531501);
        a = md5gg(a, b, c, d, x[i + 13], 5, -1444681467);
        d = md5gg(d, a, b, c, x[i + 2], 9, -51403784);
        c = md5gg(c, d, a, b, x[i + 7], 14, 1735328473);
        b = md5gg(b, c, d, a, x[i + 12], 20, -1926607734);
        a = md5hh(a, b, c, d, x[i + 5], 4, -378558);
        d = md5hh(d, a, b, c, x[i + 8], 11, -2022574463);
        c = md5hh(c, d, a, b, x[i + 11], 16, 1839030562);
        b = md5hh(b, c, d, a, x[i + 14], 23, -35309556);
        a = md5hh(a, b, c, d, x[i + 1], 4, -1530992060);
        d = md5hh(d, a, b, c, x[i + 4], 11, 1272893353);
        c = md5hh(c, d, a, b, x[i + 7], 16, -155497632);
        b = md5hh(b, c, d, a, x[i + 10], 23, -1094730640);
        a = md5hh(a, b, c, d, x[i + 13], 4, 681279174);
        d = md5hh(d, a, b, c, x[i], 11, -358537222);
        c = md5hh(c, d, a, b, x[i + 3], 16, -722521979);
        b = md5hh(b, c, d, a, x[i + 6], 23, 76029189);
        a = md5hh(a, b, c, d, x[i + 9], 4, -640364487);
        d = md5hh(d, a, b, c, x[i + 12], 11, -421815835);
        c = md5hh(c, d, a, b, x[i + 15], 16, 530742520);
        b = md5hh(b, c, d, a, x[i + 2], 23, -995338651);
        a = md5ii(a, b, c, d, x[i], 6, -198630844);
        d = md5ii(d, a, b, c, x[i + 7], 10, 1126891415);
        c = md5ii(c, d, a, b, x[i + 14], 15, -1416354905);
        b = md5ii(b, c, d, a, x[i + 5], 21, -57434055);
        a = md5ii(a, b, c, d, x[i + 12], 6, 1700485571);
        d = md5ii(d, a, b, c, x[i + 3], 10, -1894986606);
        c = md5ii(c, d, a, b, x[i + 10], 15, -1051523);
        b = md5ii(b, c, d, a, x[i + 1], 21, -2054922799);
        a = md5ii(a, b, c, d, x[i + 8], 6, 1873313359);
        d = md5ii(d, a, b, c, x[i + 15], 10, -30611744);
        c = md5ii(c, d, a, b, x[i + 6], 15, -1560198380);
        b = md5ii(b, c, d, a, x[i + 13], 21, 1309151649);
        a = md5ii(a, b, c, d, x[i + 4], 6, -145523070);
        d = md5ii(d, a, b, c, x[i + 11], 10, -1120210379);
        c = md5ii(c, d, a, b, x[i + 2], 15, 718787259);
        b = md5ii(b, c, d, a, x[i + 9], 21, -343485551);
        a = safeAdd(a, olda);
        b = safeAdd(b, oldb);
        c = safeAdd(c, oldc);
        d = safeAdd(d, oldd);
    }
    return [a, b, c, d];
}
/**
 * Convert an array of little-endian words to a string
 */
function binl2rstr(input) {
    var i;
    var output = '';
    var length32 = input.length * 32;
    for (i = 0; i < length32; i += 8) {
        output += String.fromCharCode((input[i >> 5] >>> i % 32) & 0xff);
    }
    return output;
}
/**
 * Convert a raw string to an array of little-endian words
 * Characters >255 have their high-byte silently ignored.
 */
function rstr2binl(input) {
    var i;
    var output = [];
    output[(input.length >> 2) - 1] = undefined;
    for (i = 0; i < output.length; i += 1) {
        output[i] = 0;
    }
    var length8 = input.length * 8;
    for (i = 0; i < length8; i += 8) {
        output[i >> 5] |= (input.charCodeAt(i / 8) & 0xff) << i % 32;
    }
    return output;
}
/**
 * Calculate the MD5 of a raw string
 */
function rstrMD5(s) {
    return binl2rstr(binlMD5(rstr2binl(s), s.length * 8));
}
/**
 * Calculate the HMAC-MD5, of a key and some data (raw strings)
 */
function rstrHMACMD5(key, data) {
    var i;
    var bkey = rstr2binl(key);
    var ipad = [];
    var opad = [];
    var hash;
    ipad[15] = opad[15] = undefined;
    if (bkey.length > 16) {
        bkey = binlMD5(bkey, key.length * 8);
    }
    for (i = 0; i < 16; i += 1) {
        ipad[i] = bkey[i] ^ 0x36363636;
        opad[i] = bkey[i] ^ 0x5c5c5c5c;
    }
    hash = binlMD5(ipad.concat(rstr2binl(data)), 512 + data.length * 8);
    return binl2rstr(binlMD5(opad.concat(hash), 512 + 128));
}
/**
 * Convert a raw string to a hex string
 */
function rstr2hex(input) {
    var hexTab = '0123456789abcdef';
    var output = '';
    var x;
    var i;
    for (i = 0; i < input.length; i += 1) {
        x = input.charCodeAt(i);
        output += hexTab.charAt((x >>> 4) & 0x0f) + hexTab.charAt(x & 0x0f);
    }
    return output;
}
/**
 * Encode a string as utf-8
 */
function str2rstrUTF8(input) {
    return unescape(encodeURIComponent(input));
}
/*
 * Take string arguments and return either raw or hex encoded strings
 */
function rawMD5(s) {
    return rstrMD5(str2rstrUTF8(s));
}
function hexMD5(s) {
    return rstr2hex(rawMD5(s));
}
function rawHMACMD5(k, d) {
    return rstrHMACMD5(str2rstrUTF8(k), str2rstrUTF8(d));
}
function hexHMACMD5(k, d) {
    return rstr2hex(rawHMACMD5(k, d));
}
function md5(string, key, raw) {
    if (!key) {
        if (!raw) {
            return hexMD5(string);
        }
        return rawMD5(string);
    }
    if (!raw) {
        return hexHMACMD5(key, string);
    }
    return rawHMACMD5(key, string);
}

// tslint:disable
/**
 * TraceKit - Cross brower stack traces
 *
 * This was originally forked from github.com/occ/TraceKit, but has since been
 * largely modified and is now maintained as part of Sentry JS SDK.
 *
 * NOTE: Last merge with upstream repository
 * Jul 11,2018 - #f03357c
 *
 * https://github.com/csnover/TraceKit
 * @license MIT
 * @namespace TraceKit
 */
var window$1 = misc_3();
var TraceKit = {
    wrap: function () { return function () { }; },
    report: false,
    collectWindowErrors: false,
    computeStackTrace: false,
    remoteFetching: false,
    linesOfContext: false,
    extendToAsynchronousCallbacks: false,
};
// var TraceKit: TraceKitInterface = {};
// var TraceKit = {};
// global reference to slice
var _slice = [].slice;
var UNKNOWN_FUNCTION = '?';
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error#Error_types
var ERROR_TYPES_RE = /^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?(.*)$/;
/**
 * A better form of hasOwnProperty<br/>
 * Example: `_has(MainHostObject, property) === true/false`
 *
 * @param {Object} object to check property
 * @param {string} key to check
 * @return {Boolean} true if the object has the key and it is not inherited
 */
function _has(object, key) {
    return Object.prototype.hasOwnProperty.call(object, key);
}
/**
 * A safe form of location.href<br/>
 *
 * @return {string} location.href
 */
function getLocationHref() {
    if (typeof document === 'undefined' || document.location == null)
        return '';
    return document.location.href;
}
/**
 * A safe form of location.origin<br/>
 *
 * @return {string} location.origin
 */
function getLocationOrigin() {
    if (typeof document === 'undefined' || document.location == null)
        return '';
    // Oh dear IE10...
    if (!document.location.origin) {
        return (document.location.protocol +
            '//' +
            document.location.hostname +
            (document.location.port ? ':' + document.location.port : ''));
    }
    return document.location.origin;
}
/**
 * Wrap any function in a TraceKit reporter<br/>
 * Example: `func = TraceKit.wrap(func);`
 *
 * @param {Function} func Function to be wrapped
 * @return {Function} The wrapped func
 * @memberof TraceKit
 */
TraceKit.wrap = function traceKitWrapper(func) {
    function wrapped() {
        try {
            // @ts-ignore
            return func.apply(this, arguments);
        }
        catch (e) {
            TraceKit.report(e);
            throw e;
        }
    }
    return wrapped;
};
/**
 * Cross-browser processing of unhandled exceptions
 *
 * Syntax:
 * ```js
 *   TraceKit.report.subscribe(function(stackInfo) { ... })
 *   TraceKit.report.unsubscribe(function(stackInfo) { ... })
 *   TraceKit.report(exception)
 *   try { ...code... } catch(ex) { TraceKit.report(ex); }
 * ```
 *
 * Supports:
 *   - Firefox: full stack trace with line numbers, plus column number
 *     on top frame; column number is not guaranteed
 *   - Opera: full stack trace with line and column numbers
 *   - Chrome: full stack trace with line and column numbers
 *   - Safari: line and column number for the top frame only; some frames
 *     may be missing, and column number is not guaranteed
 *   - IE: line and column number for the top frame only; some frames
 *     may be missing, and column number is not guaranteed
 *
 * In theory, TraceKit should work on all of the following versions:
 *   - IE5.5+ (only 8.0 tested)
 *   - Firefox 0.9+ (only 3.5+ tested)
 *   - Opera 7+ (only 10.50 tested; versions 9 and earlier may require
 *     Exceptions Have Stacktrace to be enabled in opera:config)
 *   - Safari 3+ (only 4+ tested)
 *   - Chrome 1+ (only 5+ tested)
 *   - Konqueror 3.5+ (untested)
 *
 * Requires TraceKit.computeStackTrace.
 *
 * Tries to catch all unhandled exceptions and report them to the
 * subscribed handlers. Please note that TraceKit.report will rethrow the
 * exception. This is REQUIRED in order to get a useful stack trace in IE.
 * If the exception does not reach the top of the browser, you will only
 * get a stack trace from the point where TraceKit.report was called.
 *
 * Handlers receive a TraceKit.StackTrace object as described in the
 * TraceKit.computeStackTrace docs.
 *
 * @memberof TraceKit
 * @namespace
 */
TraceKit.report = (function reportModuleWrapper() {
    var handlers = [], lastException = null, lastExceptionStack = null;
    /**
     * Add a crash handler.
     * @param {Function} handler
     * @memberof TraceKit.report
     */
    function subscribe(handler) {
        // NOTE: We call both handlers manually in browser/integrations/globalhandler.ts
        // So user can choose which one he wants to attach
        // installGlobalHandler();
        // installGlobalUnhandledRejectionHandler();
        handlers.push(handler);
    }
    /**
     * Remove a crash handler.
     * @param {Function} handler
     * @memberof TraceKit.report
     */
    function unsubscribe(handler) {
        for (var i = handlers.length - 1; i >= 0; --i) {
            if (handlers[i] === handler) {
                handlers.splice(i, 1);
            }
        }
        if (handlers.length === 0) {
            uninstallGlobalHandler();
            uninstallGlobalUnhandledRejectionHandler();
        }
    }
    /**
     * Dispatch stack information to all handlers.
     * @param {TraceKit.StackTrace} stack
     * @param {boolean} isWindowError Is this a top-level window error?
     * @param {Error=} error The error that's being handled (if available, null otherwise)
     * @memberof TraceKit.report
     * @throws An exception if an error occurs while calling an handler.
     */
    function notifyHandlers(stack, isWindowError, error) {
        var exception = null;
        if (isWindowError && !TraceKit.collectWindowErrors) {
            return;
        }
        for (var i in handlers) {
            if (_has(handlers, i)) {
                try {
                    handlers[i](stack, isWindowError, error);
                }
                catch (inner) {
                    exception = inner;
                }
            }
        }
        if (exception) {
            throw exception;
        }
    }
    var _oldOnerrorHandler, _onErrorHandlerInstalled;
    var _oldOnunhandledrejectionHandler, _onUnhandledRejectionHandlerInstalled;
    /**
     * Ensures all global unhandled exceptions are recorded.
     * Supported by Gecko and IE.
     * @param {string} message Error message.
     * @param {string} url URL of script that generated the exception.
     * @param {(number|string)} lineNo The line number at which the error occurred.
     * @param {(number|string)=} columnNo The column number at which the error occurred.
     * @param {Error=} errorObj The actual Error object.
     * @memberof TraceKit.report
     */
    function traceKitWindowOnError(message, url, lineNo, columnNo, errorObj) {
        var stack = null;
        // If 'errorObj' is ErrorEvent, get real Error from inside
        errorObj = is_2(errorObj) ? errorObj.error : errorObj;
        // If 'message' is ErrorEvent, get real message from inside
        message = is_2(message) ? message.message : message;
        if (lastExceptionStack) {
            TraceKit.computeStackTrace.augmentStackTraceWithInitialElement(lastExceptionStack, url, lineNo, message);
            processLastException();
        }
        else if (errorObj && is_1(errorObj)) {
            stack = TraceKit.computeStackTrace(errorObj);
            stack.mechanism = 'onerror';
            notifyHandlers(stack, true, errorObj);
        }
        else {
            var location = {
                url: url,
                line: lineNo,
                column: columnNo,
            };
            var name;
            var msg = message; // must be new var or will modify original `arguments`
            if ({}.toString.call(message) === '[object String]') {
                var groups = message.match(ERROR_TYPES_RE);
                if (groups) {
                    name = groups[1];
                    msg = groups[2];
                }
            }
            location.func = TraceKit.computeStackTrace.guessFunctionName(location.url, location.line);
            location.context = TraceKit.computeStackTrace.gatherContext(location.url, location.line);
            stack = {
                name: name,
                message: msg,
                mode: 'onerror',
                mechanism: 'onerror',
                stack: [
                    tslib_1.__assign({}, location, { 
                        // Firefox sometimes doesn't return url correctly and this is an old behavior
                        // that I prefer to port here as well.
                        // It can be altered only here, as previously it's using `location.url` for other things — Kamil
                        url: location.url || getLocationHref() }),
                ],
            };
            notifyHandlers(stack, true, null);
        }
        if (_oldOnerrorHandler) {
            // @ts-ignore
            return _oldOnerrorHandler.apply(this, arguments);
        }
        return false;
    }
    /**
     * Ensures all unhandled rejections are recorded.
     * @param {PromiseRejectionEvent} e event.
     * @memberof TraceKit.report
     * @see https://developer.mozilla.org/en-US/docs/Web/API/WindowEventHandlers/onunhandledrejection
     * @see https://developer.mozilla.org/en-US/docs/Web/API/PromiseRejectionEvent
     */
    function traceKitWindowOnUnhandledRejection(e) {
        var err = (e && (e.detail ? e.detail.reason : e.reason)) || e;
        var stack = TraceKit.computeStackTrace(err);
        stack.mechanism = 'onunhandledrejection';
        notifyHandlers(stack, true, err);
    }
    /**
     * Install a global onerror handler
     * @memberof TraceKit.report
     */
    function installGlobalHandler() {
        if (_onErrorHandlerInstalled === true) {
            return;
        }
        _oldOnerrorHandler = window$1.onerror;
        window$1.onerror = traceKitWindowOnError;
        _onErrorHandlerInstalled = true;
    }
    /**
     * Uninstall the global onerror handler
     * @memberof TraceKit.report
     */
    function uninstallGlobalHandler() {
        if (_onErrorHandlerInstalled) {
            window$1.onerror = _oldOnerrorHandler;
            _onErrorHandlerInstalled = false;
        }
    }
    /**
     * Install a global onunhandledrejection handler
     * @memberof TraceKit.report
     */
    function installGlobalUnhandledRejectionHandler() {
        if (_onUnhandledRejectionHandlerInstalled === true) {
            return;
        }
        _oldOnunhandledrejectionHandler = window$1.onunhandledrejection;
        window$1.onunhandledrejection = traceKitWindowOnUnhandledRejection;
        _onUnhandledRejectionHandlerInstalled = true;
    }
    /**
     * Uninstall the global onunhandledrejection handler
     * @memberof TraceKit.report
     */
    function uninstallGlobalUnhandledRejectionHandler() {
        if (_onUnhandledRejectionHandlerInstalled) {
            window$1.onunhandledrejection = _oldOnunhandledrejectionHandler;
            _onUnhandledRejectionHandlerInstalled = false;
        }
    }
    /**
     * Process the most recent exception
     * @memberof TraceKit.report
     */
    function processLastException() {
        var _lastExceptionStack = lastExceptionStack, _lastException = lastException;
        lastExceptionStack = null;
        lastException = null;
        notifyHandlers(_lastExceptionStack, false, _lastException);
    }
    /**
     * Reports an unhandled Error to TraceKit.
     * @param {Error} ex
     * @memberof TraceKit.report
     * @throws An exception if an incomplete stack trace is detected (old IE browsers).
     */
    function report(ex) {
        if (lastExceptionStack) {
            if (lastException === ex) {
                return; // already caught by an inner catch block, ignore
            }
            else {
                processLastException();
            }
        }
        var stack = TraceKit.computeStackTrace(ex);
        lastExceptionStack = stack;
        lastException = ex;
        // If the stack trace is incomplete, wait for 2 seconds for
        // slow slow IE to see if onerror occurs or not before reporting
        // this exception; otherwise, we will end up with an incomplete
        // stack trace
        setTimeout(function () {
            if (lastException === ex) {
                processLastException();
            }
        }, stack.incomplete ? 2000 : 0);
        throw ex; // re-throw to propagate to the top level (and cause window.onerror)
    }
    report.subscribe = subscribe;
    report.unsubscribe = unsubscribe;
    report.installGlobalHandler = installGlobalHandler;
    report.installGlobalUnhandledRejectionHandler = installGlobalUnhandledRejectionHandler;
    return report;
})();
/**
 * An object representing a single stack frame.
 * @typedef {Object} StackFrame
 * @property {string} url The JavaScript or HTML file URL.
 * @property {string} func The function name, or empty for anonymous functions (if guessing did not work).
 * @property {string[]?} args The arguments passed to the function, if known.
 * @property {number=} line The line number, if known.
 * @property {number=} column The column number, if known.
 * @property {string[]} context An array of source code lines; the middle element corresponds to the correct line#.
 * @memberof TraceKit
 */
/**
 * An object representing a JavaScript stack trace.
 * @typedef {Object} StackTrace
 * @property {string} name The name of the thrown exception.
 * @property {string} message The exception error message.
 * @property {TraceKit.StackFrame[]} stack An array of stack frames.
 * @property {string} mode 'stack', 'stacktrace', 'multiline', 'callers', 'onerror', or 'failed' -- method used to collect the stack trace.
 * @memberof TraceKit
 */
/**
 * TraceKit.computeStackTrace: cross-browser stack traces in JavaScript
 *
 * Syntax:
 *   ```js
 *   s = TraceKit.computeStackTrace.ofCaller([depth])
 *   s = TraceKit.computeStackTrace(exception) // consider using TraceKit.report instead (see below)
 *   ```
 *
 * Supports:
 *   - Firefox:  full stack trace with line numbers and unreliable column
 *               number on top frame
 *   - Opera 10: full stack trace with line and column numbers
 *   - Opera 9-: full stack trace with line numbers
 *   - Chrome:   full stack trace with line and column numbers
 *   - Safari:   line and column number for the topmost stacktrace element
 *               only
 *   - IE:       no line numbers whatsoever
 *
 * Tries to guess names of anonymous functions by looking for assignments
 * in the source code. In IE and Safari, we have to guess source file names
 * by searching for function bodies inside all page scripts. This will not
 * work for scripts that are loaded cross-domain.
 * Here be dragons: some function names may be guessed incorrectly, and
 * duplicate functions may be mismatched.
 *
 * TraceKit.computeStackTrace should only be used for tracing purposes.
 * Logging of unhandled exceptions should be done with TraceKit.report,
 * which builds on top of TraceKit.computeStackTrace and provides better
 * IE support by utilizing the window.onerror event to retrieve information
 * about the top of the stack.
 *
 * Note: In IE and Safari, no stack trace is recorded on the Error object,
 * so computeStackTrace instead walks its *own* chain of callers.
 * This means that:
 *  * in Safari, some methods may be missing from the stack trace;
 *  * in IE, the topmost function in the stack trace will always be the
 *    caller of computeStackTrace.
 *
 * This is okay for tracing (because you are likely to be calling
 * computeStackTrace from the function you want to be the topmost element
 * of the stack trace anyway), but not okay for logging unhandled
 * exceptions (because your catch block will likely be far away from the
 * inner function that actually caused the exception).
 *
 * Tracing example:
 *  ```js
 *     function trace(message) {
 *         var stackInfo = TraceKit.computeStackTrace.ofCaller();
 *         var data = message + "\n";
 *         for(var i in stackInfo.stack) {
 *             var item = stackInfo.stack[i];
 *             data += (item.func || '[anonymous]') + "() in " + item.url + ":" + (item.line || '0') + "\n";
 *         }
 *         if (window.console)
 *             console.info(data);
 *         else
 *             alert(data);
 *     }
 * ```
 * @memberof TraceKit
 * @namespace
 */
TraceKit.computeStackTrace = (function computeStackTraceWrapper() {
    var debug = false, sourceCache = {};
    /**
     * Attempts to retrieve source code via XMLHttpRequest, which is used
     * to look up anonymous function names.
     * @param {string} url URL of source code.
     * @return {string} Source contents.
     * @memberof TraceKit.computeStackTrace
     */
    function loadSource(url) {
        if (!TraceKit.remoteFetching) {
            //Only attempt request if remoteFetching is on.
            return '';
        }
        try {
            var getXHR = function () {
                try {
                    return new window$1.XMLHttpRequest();
                }
                catch (e) {
                    // explicitly bubble up the exception if not found
                    return new window$1.ActiveXObject('Microsoft.XMLHTTP');
                }
            };
            var request = getXHR();
            request.open('GET', url, false);
            request.send('');
            return request.responseText;
        }
        catch (e) {
            return '';
        }
    }
    /**
     * Retrieves source code from the source code cache.
     * @param {string} url URL of source code.
     * @return {Array.<string>} Source contents.
     * @memberof TraceKit.computeStackTrace
     */
    function getSource(url) {
        if (typeof url !== 'string') {
            return [];
        }
        if (!_has(sourceCache, url)) {
            // URL needs to be able to fetched within the acceptable domain.  Otherwise,
            // cross-domain errors will be triggered.
            /*
                        Regex matches:
                        0 - Full Url
                        1 - Protocol
                        2 - Domain
                        3 - Port (Useful for internal applications)
                        4 - Path
                    */
            var source = '';
            var domain = '';
            try {
                domain = window$1.document.domain;
            }
            catch (e) { }
            var match = /(.*)\:\/\/([^:\/]+)([:\d]*)\/{0,1}([\s\S]*)/.exec(url);
            if (match && match[2] === domain) {
                source = loadSource(url);
            }
            sourceCache[url] = source ? source.split('\n') : [];
        }
        return sourceCache[url];
    }
    /**
     * Tries to use an externally loaded copy of source code to determine
     * the name of a function by looking at the name of the variable it was
     * assigned to, if any.
     * @param {string} url URL of source code.
     * @param {(string|number)} lineNo Line number in source code.
     * @return {string} The function name, if discoverable.
     * @memberof TraceKit.computeStackTrace
     */
    function guessFunctionName(url, lineNo) {
        var reFunctionArgNames = /function ([^(]*)\(([^)]*)\)/, reGuessFunction = /['"]?([0-9A-Za-z$_]+)['"]?\s*[:=]\s*(function|eval|new Function)/, line = '', maxLines = 10, source = getSource(url), m;
        if (!source.length) {
            return UNKNOWN_FUNCTION;
        }
        // Walk backwards from the first line in the function until we find the line which
        // matches the pattern above, which is the function definition
        for (var i = 0; i < maxLines; ++i) {
            line = source[lineNo - i] + line;
            if (!is_5(line)) {
                if ((m = reGuessFunction.exec(line))) {
                    return m[1];
                }
                else if ((m = reFunctionArgNames.exec(line))) {
                    return m[1];
                }
            }
        }
        return UNKNOWN_FUNCTION;
    }
    /**
     * Retrieves the surrounding lines from where an exception occurred.
     * @param {string} url URL of source code.
     * @param {(string|number)} line Line number in source code to center around for context.
     * @return {?Array.<string>} Lines of source code.
     * @memberof TraceKit.computeStackTrace
     */
    function gatherContext(url, line) {
        var source = getSource(url);
        if (!source.length) {
            return null;
        }
        var context = [], 
        // linesBefore & linesAfter are inclusive with the offending line.
        // if linesOfContext is even, there will be one extra line
        //   *before* the offending line.
        linesBefore = Math.floor(TraceKit.linesOfContext / 2), 
        // Add one extra line if linesOfContext is odd
        linesAfter = linesBefore + (TraceKit.linesOfContext % 2), start = Math.max(0, line - linesBefore - 1), end = Math.min(source.length, line + linesAfter - 1);
        line -= 1; // convert to 0-based index
        for (var i = start; i < end; ++i) {
            if (!is_5(source[i])) {
                context.push(source[i]);
            }
        }
        return context.length > 0 ? context : null;
    }
    /**
     * Escapes special characters, except for whitespace, in a string to be
     * used inside a regular expression as a string literal.
     * @param {string} text The string.
     * @return {string} The escaped string literal.
     * @memberof TraceKit.computeStackTrace
     */
    function escapeRegExp(text) {
        return text.replace(/[\-\[\]{}()*+?.,\\\^$|#]/g, '\\$&');
    }
    /**
     * Escapes special characters in a string to be used inside a regular
     * expression as a string literal. Also ensures that HTML entities will
     * be matched the same as their literal friends.
     * @param {string} body The string.
     * @return {string} The escaped string.
     * @memberof TraceKit.computeStackTrace
     */
    function escapeCodeAsRegExpForMatchingInsideHTML(body) {
        return escapeRegExp(body)
            .replace('<', '(?:<|&lt;)')
            .replace('>', '(?:>|&gt;)')
            .replace('&', '(?:&|&amp;)')
            .replace('"', '(?:"|&quot;)')
            .replace(/\s+/g, '\\s+');
    }
    /**
     * Determines where a code fragment occurs in the source code.
     * @param {RegExp} re The function definition.
     * @param {Array.<string>} urls A list of URLs to search.
     * @return {?Object.<string, (string|number)>} An object containing
     * the url, line, and column number of the defined function.
     * @memberof TraceKit.computeStackTrace
     */
    function findSourceInUrls(re, urls) {
        var source, m;
        for (var i = 0, j = urls.length; i < j; ++i) {
            if ((source = getSource(urls[i])).length) {
                source = source.join('\n');
                if ((m = re.exec(source))) {
                    return {
                        url: urls[i],
                        line: source.substring(0, m.index).split('\n').length,
                        column: m.index - source.lastIndexOf('\n', m.index) - 1,
                    };
                }
            }
        }
        return null;
    }
    /**
     * Determines at which column a code fragment occurs on a line of the
     * source code.
     * @param {string} fragment The code fragment.
     * @param {string} url The URL to search.
     * @param {(string|number)} line The line number to examine.
     * @return {?number} The column number.
     * @memberof TraceKit.computeStackTrace
     */
    function findSourceInLine(fragment, url, line) {
        var source = getSource(url), re = new RegExp('\\b' + escapeRegExp(fragment) + '\\b'), m;
        line -= 1;
        if (source && source.length > line && (m = re.exec(source[line]))) {
            return m.index;
        }
        return null;
    }
    /**
     * Determines where a function was defined within the source code.
     * @param {(Function|string)} func A function reference or serialized
     * function definition.
     * @return {?Object.<string, (string|number)>} An object containing
     * the url, line, and column number of the defined function.
     * @memberof TraceKit.computeStackTrace
     */
    function findSourceByFunctionBody(func) {
        if (is_5(window$1 && window$1.document)) {
            return;
        }
        var urls = [getLocationHref()], scripts = window$1.document.getElementsByTagName('script'), body, code = '' + func, codeRE = /^function(?:\s+([\w$]+))?\s*\(([\w\s,]*)\)\s*\{\s*(\S[\s\S]*\S)\s*\}\s*$/, eventRE = /^function on([\w$]+)\s*\(event\)\s*\{\s*(\S[\s\S]*\S)\s*\}\s*$/, re, parts, result;
        for (var i = 0; i < scripts.length; ++i) {
            var script = scripts[i];
            if (script.src) {
                urls.push(script.src);
            }
        }
        if (!(parts = codeRE.exec(code))) {
            re = new RegExp(escapeRegExp(code).replace(/\s+/g, '\\s+'));
        }
        // not sure if this is really necessary, but I don’t have a test
        // corpus large enough to confirm that and it was in the original.
        else {
            var name = parts[1] ? '\\s+' + parts[1] : '', args = parts[2].split(',').join('\\s*,\\s*');
            body = escapeRegExp(parts[3]).replace(/;$/, ';?'); // semicolon is inserted if the function ends with a comment.replace(/\s+/g, '\\s+');
            re = new RegExp('function' + name + '\\s*\\(\\s*' + args + '\\s*\\)\\s*{\\s*' + body + '\\s*}');
        }
        // look for a normal function definition
        if ((result = findSourceInUrls(re, urls))) {
            return result;
        }
        // look for an old-school event handler function
        if ((parts = eventRE.exec(code))) {
            var event = parts[1];
            body = escapeCodeAsRegExpForMatchingInsideHTML(parts[2]);
            // look for a function defined in HTML as an onXXX handler
            re = new RegExp('on' + event + '=[\\\'"]\\s*' + body + '\\s*[\\\'"]', 'i');
            if ((result = findSourceInUrls(re, urls[0]))) {
                return result;
            }
            // look for ???
            re = new RegExp(body);
            if ((result = findSourceInUrls(re, urls))) {
                return result;
            }
        }
        return null;
    }
    // Contents of Exception in various browsers.
    //
    // SAFARI:
    // ex.message = Can't find variable: qq
    // ex.line = 59
    // ex.sourceId = 580238192
    // ex.sourceURL = http://...
    // ex.expressionBeginOffset = 96
    // ex.expressionCaretOffset = 98
    // ex.expressionEndOffset = 98
    // ex.name = ReferenceError
    //
    // FIREFOX:
    // ex.message = qq is not defined
    // ex.fileName = http://...
    // ex.lineNumber = 59
    // ex.columnNumber = 69
    // ex.stack = ...stack trace... (see the example below)
    // ex.name = ReferenceError
    //
    // CHROME:
    // ex.message = qq is not defined
    // ex.name = ReferenceError
    // ex.type = not_defined
    // ex.arguments = ['aa']
    // ex.stack = ...stack trace...
    //
    // INTERNET EXPLORER:
    // ex.message = ...
    // ex.name = ReferenceError
    //
    // OPERA:
    // ex.message = ...message... (see the example below)
    // ex.name = ReferenceError
    // ex.opera#sourceloc = 11  (pretty much useless, duplicates the info in ex.message)
    // ex.stacktrace = n/a; see 'opera:config#UserPrefs|Exceptions Have Stacktrace'
    /**
     * Computes stack trace information from the stack property.
     * Chrome and Gecko use this property.
     * @param {Error} ex
     * @return {?TraceKit.StackTrace} Stack trace information.
     * @memberof TraceKit.computeStackTrace
     */
    function computeStackTraceFromStackProp(ex) {
        if (!ex.stack) {
            return null;
        }
        var chrome = /^\s*at (?:(.*?) ?\()?((?:file|https?|blob|chrome-extension|native|eval|webpack|<anonymous>|[a-z]:|\/).*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i, gecko = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)((?:file|https?|blob|chrome|webpack|resource|moz-extension).*?:\/.*?|\[native code\]|[^@]*bundle)(?::(\d+))?(?::(\d+))?\s*$/i, winjs = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:file|ms-appx|https?|webpack|blob):.*?):(\d+)(?::(\d+))?\)?\s*$/i, 
        // Used to additionally parse URL/line/column from eval frames
        isEval, geckoEval = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i, chromeEval = /\((\S*)(?::(\d+))(?::(\d+))\)/, lines = ex.stack.split('\n'), stack = [], submatch, parts, element, reference = /^(.*) is undefined$/.exec(ex.message);
        for (var i = 0, j = lines.length; i < j; ++i) {
            if ((parts = chrome.exec(lines[i]))) {
                var isNative = parts[2] && parts[2].indexOf('native') === 0; // start of line
                isEval = parts[2] && parts[2].indexOf('eval') === 0; // start of line
                if (isEval && (submatch = chromeEval.exec(parts[2]))) {
                    // throw out eval line/column and use top-most line/column number
                    parts[2] = submatch[1]; // url
                    // NOTE: It's messing out our integration tests in Karma, let's see if we can live with it – Kamil
                    // parts[3] = submatch[2]; // line
                    // parts[4] = submatch[3]; // column
                }
                element = {
                    url: !isNative ? parts[2] : null,
                    func: parts[1] || UNKNOWN_FUNCTION,
                    args: isNative ? [parts[2]] : [],
                    line: parts[3] ? +parts[3] : null,
                    column: parts[4] ? +parts[4] : null,
                };
            }
            else if ((parts = winjs.exec(lines[i]))) {
                element = {
                    url: parts[2],
                    func: parts[1] || UNKNOWN_FUNCTION,
                    args: [],
                    line: +parts[3],
                    column: parts[4] ? +parts[4] : null,
                };
            }
            else if ((parts = gecko.exec(lines[i]))) {
                isEval = parts[3] && parts[3].indexOf(' > eval') > -1;
                if (isEval && (submatch = geckoEval.exec(parts[3]))) {
                    // throw out eval line/column and use top-most line number
                    parts[3] = submatch[1];
                    // NOTE: It's messing out our integration tests in Karma, let's see if we can live with it – Kamil
                    // parts[4] = submatch[2];
                    // parts[5] = null; // no column when eval
                }
                else if (i === 0 && !parts[5] && !is_5(ex.columnNumber)) {
                    // FireFox uses this awesome columnNumber property for its top frame
                    // Also note, Firefox's column number is 0-based and everything else expects 1-based,
                    // so adding 1
                    // NOTE: this hack doesn't work if top-most frame is eval
                    stack[0].column = ex.columnNumber + 1;
                }
                element = {
                    url: parts[3],
                    func: parts[1] || UNKNOWN_FUNCTION,
                    args: parts[2] ? parts[2].split(',') : [],
                    line: parts[4] ? +parts[4] : null,
                    column: parts[5] ? +parts[5] : null,
                };
            }
            else {
                continue;
            }
            if (!element.func && element.line) {
                element.func = guessFunctionName(element.url, element.line);
            }
            if (TraceKit.remoteFetching && element.url && element.url.substr(0, 5) === 'blob:') {
                // Special case for handling JavaScript loaded into a blob.
                // We use a synchronous AJAX request here as a blob is already in
                // memory - it's not making a network request.  This will generate a warning
                // in the browser console, but there has already been an error so that's not
                // that much of an issue.
                var xhr = new XMLHttpRequest();
                xhr.open('GET', element.url, false);
                xhr.send('');
                // If we failed to download the source, skip this patch
                if (xhr.status === 200) {
                    var source = xhr.responseText || '';
                    // We trim the source down to the last 300 characters as sourceMappingURL is always at the end of the file.
                    // Why 300? To be in line with: https://github.com/getsentry/sentry/blob/4af29e8f2350e20c28a6933354e4f42437b4ba42/src/sentry/lang/javascript/processor.py#L164-L175
                    source = source.slice(-300);
                    // Now we dig out the source map URL
                    var sourceMaps = source.match(/\/\/# sourceMappingURL=(.*)$/);
                    // If we don't find a source map comment or we find more than one, continue on to the next element.
                    if (sourceMaps) {
                        var sourceMapAddress = sourceMaps[1];
                        // Now we check to see if it's a relative URL.
                        // If it is, convert it to an absolute one.
                        if (sourceMapAddress.charAt(0) === '~') {
                            sourceMapAddress = getLocationOrigin() + sourceMapAddress.slice(1);
                        }
                        // Now we strip the '.map' off of the end of the URL and update the
                        // element so that Sentry can match the map to the blob.
                        element.url = sourceMapAddress.slice(0, -4);
                    }
                }
            }
            element.context = element.line ? gatherContext(element.url, element.line) : null;
            stack.push(element);
        }
        if (!stack.length) {
            return null;
        }
        if (stack[0] && stack[0].line && !stack[0].column && reference) {
            stack[0].column = findSourceInLine(reference[1], stack[0].url, stack[0].line);
        }
        return {
            mode: 'stack',
            name: ex.name,
            message: ex.message,
            stack: stack,
        };
    }
    /**
     * Computes stack trace information from the stacktrace property.
     * Opera 10+ uses this property.
     * @param {Error} ex
     * @return {?TraceKit.StackTrace} Stack trace information.
     * @memberof TraceKit.computeStackTrace
     */
    function computeStackTraceFromStacktraceProp(ex) {
        // Access and store the stacktrace property before doing ANYTHING
        // else to it because Opera is not very good at providing it
        // reliably in other circumstances.
        var stacktrace = ex.stacktrace;
        if (!stacktrace) {
            return;
        }
        var opera10Regex = / line (\d+).*script (?:in )?(\S+)(?:: in function (\S+))?$/i, opera11Regex = / line (\d+), column (\d+)\s*(?:in (?:<anonymous function: ([^>]+)>|([^\)]+))\((.*)\))? in (.*):\s*$/i, lines = stacktrace.split('\n'), stack = [], parts;
        for (var line = 0; line < lines.length; line += 2) {
            var element = null;
            if ((parts = opera10Regex.exec(lines[line]))) {
                element = {
                    url: parts[2],
                    line: +parts[1],
                    column: null,
                    func: parts[3],
                    args: [],
                };
            }
            else if ((parts = opera11Regex.exec(lines[line]))) {
                element = {
                    url: parts[6],
                    line: +parts[1],
                    column: +parts[2],
                    func: parts[3] || parts[4],
                    args: parts[5] ? parts[5].split(',') : [],
                };
            }
            if (element) {
                if (!element.func && element.line) {
                    element.func = guessFunctionName(element.url, element.line);
                }
                if (element.line) {
                    try {
                        element.context = gatherContext(element.url, element.line);
                    }
                    catch (exc) { }
                }
                if (!element.context) {
                    element.context = [lines[line + 1]];
                }
                stack.push(element);
            }
        }
        if (!stack.length) {
            return null;
        }
        return {
            mode: 'stacktrace',
            name: ex.name,
            message: ex.message,
            stack: stack,
        };
    }
    /**
     * NOT TESTED.
     * Computes stack trace information from an error message that includes
     * the stack trace.
     * Opera 9 and earlier use this method if the option to show stack
     * traces is turned on in opera:config.
     * @param {Error} ex
     * @return {?TraceKit.StackTrace} Stack information.
     * @memberof TraceKit.computeStackTrace
     */
    function computeStackTraceFromOperaMultiLineMessage(ex) {
        // TODO: Clean this function up
        // Opera includes a stack trace into the exception message. An example is:
        //
        // Statement on line 3: Undefined variable: undefinedFunc
        // Backtrace:
        //   Line 3 of linked script file://localhost/Users/andreyvit/Projects/TraceKit/javascript-client/sample.js: In function zzz
        //         undefinedFunc(a);
        //   Line 7 of inline#1 script in file://localhost/Users/andreyvit/Projects/TraceKit/javascript-client/sample.html: In function yyy
        //           zzz(x, y, z);
        //   Line 3 of inline#1 script in file://localhost/Users/andreyvit/Projects/TraceKit/javascript-client/sample.html: In function xxx
        //           yyy(a, a, a);
        //   Line 1 of function script
        //     try { xxx('hi'); return false; } catch(ex) { TraceKit.report(ex); }
        //   ...
        var lines = ex.message.split('\n');
        if (lines.length < 4) {
            return null;
        }
        var lineRE1 = /^\s*Line (\d+) of linked script ((?:file|https?|blob)\S+)(?:: in function (\S+))?\s*$/i, lineRE2 = /^\s*Line (\d+) of inline#(\d+) script in ((?:file|https?|blob)\S+)(?:: in function (\S+))?\s*$/i, lineRE3 = /^\s*Line (\d+) of function script\s*$/i, stack = [], scripts = window$1 && window$1.document && window$1.document.getElementsByTagName('script'), inlineScriptBlocks = [], parts;
        for (var s in scripts) {
            if (_has(scripts, s) && !scripts[s].src) {
                inlineScriptBlocks.push(scripts[s]);
            }
        }
        for (var line = 2; line < lines.length; line += 2) {
            var item = null;
            if ((parts = lineRE1.exec(lines[line]))) {
                item = {
                    url: parts[2],
                    func: parts[3],
                    args: [],
                    line: +parts[1],
                    column: null,
                };
            }
            else if ((parts = lineRE2.exec(lines[line]))) {
                item = {
                    url: parts[3],
                    func: parts[4],
                    args: [],
                    line: +parts[1],
                    column: null,
                };
                var relativeLine = +parts[1]; // relative to the start of the <SCRIPT> block
                var script = inlineScriptBlocks[parts[2] - 1];
                if (script) {
                    var source = getSource(item.url);
                    if (source) {
                        source = source.join('\n');
                        var pos = source.indexOf(script.innerText);
                        if (pos >= 0) {
                            item.line = relativeLine + source.substring(0, pos).split('\n').length;
                        }
                    }
                }
            }
            else if ((parts = lineRE3.exec(lines[line]))) {
                var url = getLocationHref().replace(/#.*$/, '');
                var re = new RegExp(escapeCodeAsRegExpForMatchingInsideHTML(lines[line + 1]));
                var src = findSourceInUrls(re, [url]);
                item = {
                    url: url,
                    func: '',
                    args: [],
                    line: src ? src.line : parts[1],
                    column: null,
                };
            }
            if (item) {
                if (!item.func) {
                    item.func = guessFunctionName(item.url, item.line);
                }
                var context = gatherContext(item.url, item.line);
                var midline = context ? context[Math.floor(context.length / 2)] : null;
                if (context && midline.replace(/^\s*/, '') === lines[line + 1].replace(/^\s*/, '')) {
                    item.context = context;
                }
                else {
                    // if (context) alert("Context mismatch. Correct midline:\n" + lines[i+1] + "\n\nMidline:\n" + midline + "\n\nContext:\n" + context.join("\n") + "\n\nURL:\n" + item.url);
                    item.context = [lines[line + 1]];
                }
                stack.push(item);
            }
        }
        if (!stack.length) {
            return null; // could not parse multiline exception message as Opera stack trace
        }
        return {
            mode: 'multiline',
            name: ex.name,
            message: lines[0],
            stack: stack,
        };
    }
    /**
     * Adds information about the first frame to incomplete stack traces.
     * Safari and IE require this to get complete data on the first frame.
     * @param {TraceKit.StackTrace} stackInfo Stack trace information from
     * one of the compute* methods.
     * @param {string} url The URL of the script that caused an error.
     * @param {(number|string)} lineNo The line number of the script that
     * caused an error.
     * @param {string=} message The error generated by the browser, which
     * hopefully contains the name of the object that caused the error.
     * @return {boolean} Whether or not the stack information was
     * augmented.
     * @memberof TraceKit.computeStackTrace
     */
    function augmentStackTraceWithInitialElement(stackInfo, url, lineNo, message) {
        var initial = {
            url: url,
            line: lineNo,
        };
        if (initial.url && initial.line) {
            stackInfo.incomplete = false;
            if (!initial.func) {
                initial.func = guessFunctionName(initial.url, initial.line);
            }
            if (!initial.context) {
                initial.context = gatherContext(initial.url, initial.line);
            }
            var reference = / '([^']+)' /.exec(message);
            if (reference) {
                initial.column = findSourceInLine(reference[1], initial.url, initial.line);
            }
            if (stackInfo.stack.length > 0) {
                if (stackInfo.stack[0].url === initial.url) {
                    if (stackInfo.stack[0].line === initial.line) {
                        return false; // already in stack trace
                    }
                    else if (!stackInfo.stack[0].line && stackInfo.stack[0].func === initial.func) {
                        stackInfo.stack[0].line = initial.line;
                        stackInfo.stack[0].context = initial.context;
                        return false;
                    }
                }
            }
            stackInfo.stack.unshift(initial);
            stackInfo.partial = true;
            return true;
        }
        else {
            stackInfo.incomplete = true;
        }
        return false;
    }
    /**
     * Computes stack trace information by walking the arguments.caller
     * chain at the time the exception occurred. This will cause earlier
     * frames to be missed but is the only way to get any stack trace in
     * Safari and IE. The top frame is restored by
     * {@link augmentStackTraceWithInitialElement}.
     * @param {Error} ex
     * @return {TraceKit.StackTrace=} Stack trace information.
     * @memberof TraceKit.computeStackTrace
     */
    function computeStackTraceByWalkingCallerChain(ex, depth) {
        var functionName = /function\s+([_$a-zA-Z\xA0-\uFFFF][_$a-zA-Z0-9\xA0-\uFFFF]*)?\s*\(/i, stack = [], funcs = {}, recursion = false, parts, item, source;
        for (var curr = computeStackTraceByWalkingCallerChain.caller; curr && !recursion; curr = curr.caller) {
            if (curr === computeStackTrace || curr === TraceKit.report) {
                continue;
            }
            item = {
                url: null,
                func: UNKNOWN_FUNCTION,
                args: [],
                line: null,
                column: null,
            };
            if (curr.name) {
                item.func = curr.name;
            }
            else if ((parts = functionName.exec(curr.toString()))) {
                item.func = parts[1];
            }
            if (typeof item.func === 'undefined') {
                try {
                    item.func = parts.input.substring(0, parts.input.indexOf('{'));
                }
                catch (e) { }
            }
            if ((source = findSourceByFunctionBody(curr))) {
                item.url = source.url;
                item.line = source.line;
                if (item.func === UNKNOWN_FUNCTION) {
                    item.func = guessFunctionName(item.url, item.line);
                }
                var reference = / '([^']+)' /.exec(ex.message || ex.description);
                if (reference) {
                    item.column = findSourceInLine(reference[1], source.url, source.line);
                }
            }
            if (funcs['' + curr]) {
                recursion = true;
            }
            else {
                funcs['' + curr] = true;
            }
            stack.push(item);
        }
        if (depth) {
            stack.splice(0, depth);
        }
        var result = {
            mode: 'callers',
            name: ex.name,
            message: ex.message,
            stack: stack,
        };
        augmentStackTraceWithInitialElement(result, ex.sourceURL || ex.fileName, ex.line || ex.lineNumber, ex.message || ex.description);
        return result;
    }
    /**
     * Computes a stack trace for an exception.
     * @param {Error} ex
     * @param {(string|number)=} depth
     * @memberof TraceKit.computeStackTrace
     */
    function computeStackTrace(ex, depth) {
        var stack = null;
        depth = depth == null ? 0 : +depth;
        try {
            // This must be tried first because Opera 10 *destroys*
            // its stacktrace property if you try to access the stack
            // property first!!
            stack = computeStackTraceFromStacktraceProp(ex);
            if (stack) {
                return stack;
            }
        }
        catch (e) {
            if (debug) {
                throw e;
            }
        }
        try {
            stack = computeStackTraceFromStackProp(ex);
            if (stack) {
                return stack;
            }
        }
        catch (e) {
            if (debug) {
                throw e;
            }
        }
        try {
            stack = computeStackTraceFromOperaMultiLineMessage(ex);
            if (stack) {
                return stack;
            }
        }
        catch (e) {
            if (debug) {
                throw e;
            }
        }
        try {
            stack = computeStackTraceByWalkingCallerChain(ex, depth + 1);
            if (stack) {
                return stack;
            }
        }
        catch (e) {
            if (debug) {
                throw e;
            }
        }
        return {
            name: ex.name,
            message: ex.message,
            mode: 'failed',
        };
    }
    /**
     * Logs a stacktrace starting from the previous call and working down.
     * @param {(number|string)=} depth How many frames deep to trace.
     * @return {TraceKit.StackTrace} Stack trace information.
     * @memberof TraceKit.computeStackTrace
     */
    function computeStackTraceOfCaller(depth) {
        depth = (depth == null ? 0 : +depth) + 1; // "+ 1" because "ofCaller" should drop one frame
        try {
            throw new Error();
        }
        catch (ex) {
            return computeStackTrace(ex, depth + 1);
        }
    }
    computeStackTrace.augmentStackTraceWithInitialElement = augmentStackTraceWithInitialElement;
    computeStackTrace.computeStackTraceFromStackProp = computeStackTraceFromStackProp;
    computeStackTrace.guessFunctionName = guessFunctionName;
    computeStackTrace.gatherContext = gatherContext;
    computeStackTrace.ofCaller = computeStackTraceOfCaller;
    computeStackTrace.getSource = getSource;
    return computeStackTrace;
})();
/**
 * Extends support for global error handling for asynchronous browser
 * functions. Adopted from Closure Library's errorhandler.js
 * @memberof TraceKit
 */
TraceKit.extendToAsynchronousCallbacks = function () {
    var _helper = function _helper(fnName) {
        var originalFn = window$1[fnName];
        window$1[fnName] = function traceKitAsyncExtension() {
            // Make a copy of the arguments
            var args = _slice.call(arguments);
            var originalCallback = args[0];
            if (typeof originalCallback === 'function') {
                args[0] = TraceKit.wrap(originalCallback);
            }
            // IE < 9 doesn't support .call/.apply on setInterval/setTimeout, but it
            // also only supports 2 argument and doesn't care what "this" is, so we
            // can just call the original function directly.
            if (originalFn.apply) {
                return originalFn.apply(this, args);
            }
            else {
                return originalFn(args[0], args[1]);
            }
        };
    };
    _helper('setTimeout');
    _helper('setInterval');
};
TraceKit.remoteFetching = false;
TraceKit.collectWindowErrors = true;
TraceKit.linesOfContext = 11;
var subscribe = TraceKit.report.subscribe;
var installGlobalHandler = TraceKit.report.installGlobalHandler;
var installGlobalUnhandledRejectionHandler = TraceKit.report.installGlobalUnhandledRejectionHandler;
var computeStackTrace = TraceKit.computeStackTrace;

var STACKTRACE_LIMIT = 50;
/** JSDoc */
function exceptionFromStacktrace(stacktrace) {
    var frames = prepareFramesForEvent(stacktrace.stack);
    var exception = {
        stacktrace: { frames: frames },
        type: stacktrace.name,
        value: stacktrace.message,
    };
    // tslint:disable-next-line:strict-type-predicates
    if (exception.type === undefined && exception.value === '') {
        exception.value = 'Unrecoverable error caught';
    }
    return exception;
}
/** JSDoc */
function eventFromPlainObject(exception, syntheticException) {
    var exceptionKeys = Object.keys(exception).sort();
    var event = {
        extra: {
            __serialized__: object_7(exception),
        },
        fingerprint: [md5(exceptionKeys.join(''))],
        message: "Non-Error exception captured with keys: " + object_8(exceptionKeys),
    };
    if (syntheticException) {
        var stacktrace = computeStackTrace(syntheticException);
        var frames_1 = prepareFramesForEvent(stacktrace.stack);
        event.stacktrace = {
            frames: frames_1,
        };
    }
    return event;
}
/** JSDoc */
function eventFromStacktrace(stacktrace) {
    var exception = exceptionFromStacktrace(stacktrace);
    return {
        exception: {
            values: [exception],
        },
    };
}
/** JSDoc */
function prepareFramesForEvent(stack) {
    if (!stack || !stack.length) {
        return [];
    }
    var localStack = stack;
    var firstFrameFunction = localStack[0].func || '';
    var lastFrameFunction = localStack[localStack.length - 1].func || '';
    // If stack starts with one of our API calls, remove it (starts, meaning it's the top of the stack - aka last call)
    if (string_4(firstFrameFunction, 'captureMessage') || string_4(firstFrameFunction, 'captureException')) {
        localStack = localStack.slice(1);
    }
    // If stack ends with one of our internal API calls, remove it (ends, meaning it's the bottom of the stack - aka top-most call)
    if (string_4(lastFrameFunction, 'sentryWrapped')) {
        localStack = localStack.slice(0, -1);
    }
    // The frame where the crash happened, should be the last entry in the array
    return localStack
        .map(function (frame) { return ({
        colno: frame.column,
        filename: frame.url || localStack[0].url,
        function: frame.func || '?',
        in_app: true,
        lineno: frame.line,
    }); })
        .slice(0, STACKTRACE_LIMIT)
        .reverse();
}
/**
 * Adds exception values, type and value to an synthetic Exception.
 * @param event The event to modify.
 * @param message Message to be added.
 */
function addExceptionTypeValue(event, message) {
    event.exception = event.exception || {};
    event.exception.values = event.exception.values || [];
    event.exception.values[0] = event.exception.values[0] || {};
    event.exception.values[0].value = event.exception.values[0].value || message;
    event.exception.values[0].type = event.exception.values[0].type || 'Error';
}

/** Base Transport class implementation */
var BaseTransport = /** @class */ (function () {
    function BaseTransport(options) {
        this.options = options;
        /** A simple buffer holding all requests. */
        this.buffer = new core.PromiseBuffer(30);
        this.url = new core.API(this.options.dsn).getStoreEndpointWithUrlEncodedAuth();
    }
    /**
     * @inheritDoc
     */
    BaseTransport.prototype.sendEvent = function (_) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                throw new core.SentryError('Transport Class has to implement `sendEvent` method');
            });
        });
    };
    /**
     * @inheritDoc
     */
    BaseTransport.prototype.close = function (timeout) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, this.buffer.drain(timeout)];
            });
        });
    };
    return BaseTransport;
}());

var global$1 = misc_3();
/** `fetch` based transport */
var FetchTransport = /** @class */ (function (_super) {
    tslib_1.__extends(FetchTransport, _super);
    function FetchTransport() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @inheritDoc
     */
    FetchTransport.prototype.sendEvent = function (body) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var defaultOptions;
            return tslib_1.__generator(this, function (_a) {
                defaultOptions = {
                    body: body,
                    method: 'POST',
                    // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default
                    // https://caniuse.com/#feat=referrer-policy
                    // It doesn't. And it throw exception instead of ignoring this parameter...
                    // REF: https://github.com/getsentry/raven-js/issues/1233
                    referrerPolicy: (supports_8() ? 'origin' : ''),
                };
                return [2 /*return*/, this.buffer.add(global$1.fetch(this.url, defaultOptions).then(function (response) { return ({
                        status: dist_2.fromHttpCode(response.status),
                    }); }))];
            });
        });
    };
    return FetchTransport;
}(BaseTransport));

/** `XHR` based transport */
var XHRTransport = /** @class */ (function (_super) {
    tslib_1.__extends(XHRTransport, _super);
    function XHRTransport() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @inheritDoc
     */
    XHRTransport.prototype.sendEvent = function (body) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, this.buffer.add(new Promise(function (resolve, reject) {
                        var request = new XMLHttpRequest();
                        request.onreadystatechange = function () {
                            if (request.readyState !== 4) {
                                return;
                            }
                            if (request.status === 200) {
                                resolve({
                                    status: dist_2.fromHttpCode(request.status),
                                });
                            }
                            reject(request);
                        };
                        request.open('POST', _this.url);
                        request.send(body);
                    }))];
            });
        });
    };
    return XHRTransport;
}(BaseTransport));

var global$2 = misc_3();
/** `sendBeacon` based transport */
var BeaconTransport = /** @class */ (function (_super) {
    tslib_1.__extends(BeaconTransport, _super);
    function BeaconTransport() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @inheritDoc
     */
    BeaconTransport.prototype.sendEvent = function (body) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var result;
            return tslib_1.__generator(this, function (_a) {
                result = global$2.navigator.sendBeacon(this.url, body);
                return [2 /*return*/, this.buffer.add(Promise.resolve({
                        status: result ? dist_2.Success : dist_2.Failed,
                    }))];
            });
        });
    };
    return BeaconTransport;
}(BaseTransport));



var index$1 = /*#__PURE__*/Object.freeze({
	BaseTransport: BaseTransport,
	FetchTransport: FetchTransport,
	XHRTransport: XHRTransport,
	BeaconTransport: BeaconTransport
});

/** The Sentry Browser SDK Backend. */
var BrowserBackend = /** @class */ (function (_super) {
    tslib_1.__extends(BrowserBackend, _super);
    function BrowserBackend() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @inheritDoc
     */
    BrowserBackend.prototype.install = function () {
        // We are only called by the client if the SDK is enabled and a valid Dsn
        // has been configured. If no Dsn is present, this indicates a programming
        // error.
        var dsn = this.options.dsn;
        if (!dsn) {
            throw new core.SentryError('Invariant exception: install() must not be called when disabled');
        }
        Error.stackTraceLimit = 50;
        return true;
    };
    /**
     * @inheritdoc
     */
    BrowserBackend.prototype.setupTransport = function () {
        if (!this.options.dsn) {
            // We return the noop transport here in case there is no Dsn.
            return _super.prototype.setupTransport.call(this);
        }
        var transportOptions = this.options.transportOptions ? this.options.transportOptions : { dsn: this.options.dsn };
        if (this.options.transport) {
            return new this.options.transport(transportOptions);
        }
        else if (supports_6()) {
            return new BeaconTransport(transportOptions);
        }
        else if (supports_4()) {
            return new FetchTransport(transportOptions);
        }
        return new XHRTransport(transportOptions);
    };
    /**
     * @inheritDoc
     */
    BrowserBackend.prototype.eventFromException = function (exception, hint) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var event, ex, ex, name_1, message, ex, ex;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(is_2(exception) && exception.error)) return [3 /*break*/, 1];
                        ex = exception;
                        exception = ex.error; // tslint:disable-line:no-parameter-reassignment
                        event = eventFromStacktrace(computeStackTrace(exception));
                        return [3 /*break*/, 7];
                    case 1:
                        if (!(is_3(exception) || is_4(exception))) return [3 /*break*/, 3];
                        ex = exception;
                        name_1 = ex.name || (is_3(ex) ? 'DOMError' : 'DOMException');
                        message = ex.message ? name_1 + ": " + ex.message : name_1;
                        return [4 /*yield*/, this.eventFromMessage(message, undefined, hint)];
                    case 2:
                        event = _a.sent();
                        addExceptionTypeValue(event, message);
                        return [3 /*break*/, 7];
                    case 3:
                        if (!is_1(exception)) return [3 /*break*/, 4];
                        // we have a real Error object, do nothing
                        event = eventFromStacktrace(computeStackTrace(exception));
                        return [3 /*break*/, 7];
                    case 4:
                        if (!(is_10(exception) && hint && hint.syntheticException)) return [3 /*break*/, 5];
                        ex = exception;
                        event = eventFromPlainObject(ex, hint.syntheticException);
                        addExceptionTypeValue(event, 'Custom Object');
                        return [3 /*break*/, 7];
                    case 5:
                        ex = exception;
                        return [4 /*yield*/, this.eventFromMessage(ex, undefined, hint)];
                    case 6:
                        event = _a.sent();
                        addExceptionTypeValue(event, "" + ex);
                        _a.label = 7;
                    case 7:
                        event = tslib_1.__assign({}, event, { event_id: hint && hint.event_id, exception: tslib_1.__assign({}, event.exception, { mechanism: {
                                    handled: true,
                                    type: 'generic',
                                } }) });
                        return [2 /*return*/, event];
                }
            });
        });
    };
    /**
     * @inheritDoc
     */
    BrowserBackend.prototype.eventFromMessage = function (message, level, hint) {
        if (level === void 0) { level = dist_1.Info; }
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var event, stacktrace, frames_1;
            return tslib_1.__generator(this, function (_a) {
                event = {
                    event_id: hint && hint.event_id,
                    level: level,
                    message: message,
                };
                if (this.options.attachStacktrace && hint && hint.syntheticException) {
                    stacktrace = computeStackTrace(hint.syntheticException);
                    frames_1 = prepareFramesForEvent(stacktrace.stack);
                    event.stacktrace = {
                        frames: frames_1,
                    };
                }
                return [2 /*return*/, event];
            });
        });
    };
    return BrowserBackend;
}(core.BaseBackend));

var SDK_NAME = 'sentry.javascript.browser';
var SDK_VERSION = '4.5.1';

/**
 * The Sentry Browser SDK Client.
 *
 * @see BrowserOptions for documentation on configuration options.
 * @see SentryClient for usage documentation.
 */
var BrowserClient = /** @class */ (function (_super) {
    tslib_1.__extends(BrowserClient, _super);
    /**
     * Creates a new Browser SDK instance.
     *
     * @param options Configuration options for this SDK.
     */
    function BrowserClient(options) {
        return _super.call(this, BrowserBackend, options) || this;
    }
    /**
     * @inheritDoc
     */
    BrowserClient.prototype.prepareEvent = function (event, scope, hint) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                event.platform = event.platform || 'javascript';
                event.sdk = tslib_1.__assign({}, event.sdk, { name: SDK_NAME, packages: tslib_1.__spread(((event.sdk && event.sdk.packages) || []), [
                        {
                            name: 'npm:@sentry/browser',
                            version: SDK_VERSION,
                        },
                    ]), version: SDK_VERSION });
                return [2 /*return*/, _super.prototype.prepareEvent.call(this, event, scope, hint)];
            });
        });
    };
    /**
     * Show a report dialog to the user to send feedback to a specific event.
     *
     * @param options Set individual options for the dialog
     */
    BrowserClient.prototype.showReportDialog = function (options) {
        if (options === void 0) { options = {}; }
        // doesn't work without a document (React Native)
        var document = misc_3().document;
        if (!document) {
            return;
        }
        var dsn = options.dsn || this.getDsn();
        if (!options.eventId) {
            throw new core.SentryError('Missing `eventId` option in showReportDialog call');
        }
        if (!dsn) {
            throw new core.SentryError('Missing `Dsn` option in showReportDialog call');
        }
        var script = document.createElement('script');
        script.async = true;
        script.src = new core.API(dsn).getReportDialogEndpoint(options);
        (document.head || document.body).appendChild(script);
    };
    return BrowserClient;
}(core.BaseClient));

var logger_1 = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });

// TODO: Implement different loggers for different environments
var global = misc.getGlobalObject();
/** JSDoc */
var Logger = /** @class */ (function () {
    /** JSDoc */
    function Logger() {
        this.enabled = false;
    }
    /** JSDoc */
    Logger.prototype.disable = function () {
        this.enabled = false;
    };
    /** JSDoc */
    Logger.prototype.enable = function () {
        this.enabled = true;
    };
    /** JSDoc */
    Logger.prototype.log = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (!this.enabled) {
            return;
        }
        misc.consoleSandbox(function () {
            global.console.log("Sentry Logger [Log]: " + args.join(' ')); // tslint:disable-line:no-console
        });
    };
    /** JSDoc */
    Logger.prototype.warn = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (!this.enabled) {
            return;
        }
        misc.consoleSandbox(function () {
            global.console.warn("Sentry Logger [Warn]: " + args.join(' ')); // tslint:disable-line:no-console
        });
    };
    /** JSDoc */
    Logger.prototype.error = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (!this.enabled) {
            return;
        }
        misc.consoleSandbox(function () {
            global.console.error("Sentry Logger [Error]: " + args.join(' ')); // tslint:disable-line:no-console
        });
    };
    return Logger;
}());
var logger = new Logger();
exports.logger = logger;

});

unwrapExports(logger_1);
var logger_2 = logger_1.logger;

var debounceDuration = 1000;
var keypressTimeout;
var lastCapturedEvent;
var ignoreOnError = 0;
/** JSDoc */
function shouldIgnoreOnError() {
    return ignoreOnError > 0;
}
/** JSDoc */
function ignoreNextOnError() {
    // onerror should trigger before setTimeout
    ignoreOnError += 1;
    setTimeout(function () {
        ignoreOnError -= 1;
    });
}
/**
 * Instruments the given function and sends an event to Sentry every time the
 * function throws an exception.
 *
 * @param fn A function to wrap.
 * @returns The wrapped function.
 */
function wrap(fn, options, before) {
    if (options === void 0) { options = {}; }
    if (!is_6(fn)) {
        return fn;
    }
    try {
        // We don't wanna wrap it twice
        if (fn.__sentry__) {
            return fn;
        }
        // If this has already been wrapped in the past, return that wrapped function
        if (fn.__sentry_wrapped__) {
            return fn.__sentry_wrapped__;
        }
    }
    catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        // Bail on wrapping and return the function as-is (defers to window.onerror).
        return fn;
    }
    var sentryWrapped = function () {
        var _this = this;
        if (before && is_6(before)) {
            before.apply(this, arguments);
        }
        var args = Array.prototype.slice.call(arguments);
        try {
            // Attempt to invoke user-land function
            // NOTE: If you are a Sentry user, and you are seeing this stack frame, it
            //       means Raven caught an error invoking your application code. This is
            //       expected behavior and NOT indicative of a bug with Raven.js.
            var wrappedArguments = args.map(function (arg) { return wrap(arg, options); });
            if (fn.handleEvent) {
                return fn.handleEvent.apply(this, wrappedArguments);
            }
            else {
                return fn.apply(this, wrappedArguments);
            }
        }
        catch (ex) {
            ignoreNextOnError();
            core.withScope(function (scope) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var _this = this;
                return tslib_1.__generator(this, function (_a) {
                    scope.addEventProcessor(function (event) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                        var processedEvent;
                        return tslib_1.__generator(this, function (_a) {
                            processedEvent = tslib_1.__assign({}, event);
                            if (options.mechanism) {
                                processedEvent.exception = processedEvent.exception || {};
                                processedEvent.exception.mechanism = options.mechanism;
                            }
                            processedEvent.extra = tslib_1.__assign({}, processedEvent.extra, { arguments: object_6(args, 2) });
                            return [2 /*return*/, processedEvent];
                        });
                    }); });
                    core.captureException(ex);
                    return [2 /*return*/];
                });
            }); });
            throw ex;
        }
    };
    // Accessing some objects may throw
    // ref: https://github.com/getsentry/sentry-javascript/issues/1168
    try {
        for (var property in fn) {
            if (Object.prototype.hasOwnProperty.call(fn, property)) {
                sentryWrapped[property] = fn[property];
            }
        }
    }
    catch (_oO) { } // tslint:disable-line:no-empty
    sentryWrapped.prototype = fn.prototype;
    fn.__sentry_wrapped__ = sentryWrapped;
    // Signal that this function has been wrapped/filled already
    // for both debugging and to prevent it to being wrapped/filled twice
    sentryWrapped.__sentry__ = true;
    sentryWrapped.__sentry_original__ = fn;
    return sentryWrapped;
}
/**
 * Wraps addEventListener to capture UI breadcrumbs
 * @param eventName the event name (e.g. "click")
 * @returns wrapped breadcrumb events handler
 */
function breadcrumbEventHandler(eventName) {
    return function (event) {
        // reset keypress timeout; e.g. triggering a 'click' after
        // a 'keypress' will reset the keypress debounce so that a new
        // set of keypresses can be recorded
        keypressTimeout = undefined;
        // It's possible this handler might trigger multiple times for the same
        // event (e.g. event propagation through node ancestors). Ignore if we've
        // already captured the event.
        if (lastCapturedEvent === event) {
            return;
        }
        lastCapturedEvent = event;
        // try/catch both:
        // - accessing event.target (see getsentry/raven-js#838, #768)
        // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
        //   can throw an exception in some circumstances.
        var target;
        try {
            target = misc_5(event.target);
        }
        catch (e) {
            target = '<unknown>';
        }
        core.getCurrentHub().addBreadcrumb({
            category: "ui." + eventName,
            message: target,
        }, {
            event: event,
            name: eventName,
        });
    };
}
/**
 * Wraps addEventListener to capture keypress UI events
 * @returns wrapped keypress events handler
 */
function keypressEventHandler() {
    // TODO: if somehow user switches keypress target before
    //       debounce timeout is triggered, we will only capture
    //       a single breadcrumb from the FIRST target (acceptable?)
    return function (event) {
        var target;
        try {
            target = event.target;
        }
        catch (e) {
            // just accessing event properties can throw an exception in some rare circumstances
            // see: https://github.com/getsentry/raven-js/issues/838
            return;
        }
        var tagName = target && target.tagName;
        // only consider keypress events on actual input elements
        // this will disregard keypresses targeting body (e.g. tabbing
        // through elements, hotkeys, etc)
        if (!tagName || (tagName !== 'INPUT' && tagName !== 'TEXTAREA' && !target.isContentEditable)) {
            return;
        }
        // record first keypress in a series, but ignore subsequent
        // keypresses until debounce clears
        if (!keypressTimeout) {
            breadcrumbEventHandler('input')(event);
        }
        clearTimeout(keypressTimeout);
        keypressTimeout = setTimeout(function () {
            keypressTimeout = undefined;
        }, debounceDuration);
    };
}

/** Global handlers */
var GlobalHandlers = /** @class */ (function () {
    /** JSDoc */
    function GlobalHandlers(options) {
        /**
         * @inheritDoc
         */
        this.name = GlobalHandlers.id;
        this.options = tslib_1.__assign({ onerror: true, onunhandledrejection: true }, options);
    }
    /**
     * @inheritDoc
     */
    GlobalHandlers.prototype.setupOnce = function () {
        subscribe(function (stack, _, error) {
            // TODO: use stack.context to get a valuable information from TraceKit, eg.
            // [
            //   0: "  })"
            //   1: ""
            //   2: "  function foo () {"
            //   3: "    Sentry.captureException('some error')"
            //   4: "    Sentry.captureMessage('some message')"
            //   5: "    throw 'foo'"
            //   6: "  }"
            //   7: ""
            //   8: "  function bar () {"
            //   9: "    foo();"
            //   10: "  }"
            // ]
            if (shouldIgnoreOnError()) {
                return;
            }
            var self = core.getCurrentHub().getIntegration(GlobalHandlers);
            if (self) {
                core.getCurrentHub().captureEvent(self.eventFromGlobalHandler(stack), { originalException: error, data: { stack: stack } });
            }
        });
        if (this.options.onerror) {
            logger_2.log('Global Handler attached: onerror');
            installGlobalHandler();
        }
        if (this.options.onunhandledrejection) {
            logger_2.log('Global Handler attached: onunhandledrejection');
            installGlobalUnhandledRejectionHandler();
        }
    };
    /** JSDoc */
    GlobalHandlers.prototype.eventFromGlobalHandler = function (stacktrace) {
        var event = eventFromStacktrace(stacktrace);
        return tslib_1.__assign({}, event, { exception: tslib_1.__assign({}, event.exception, { mechanism: {
                    data: {
                        mode: stacktrace.mode,
                    },
                    handled: false,
                    type: stacktrace.mechanism,
                } }) });
    };
    /**
     * @inheritDoc
     */
    GlobalHandlers.id = 'GlobalHandlers';
    return GlobalHandlers;
}());

/** Wrap timer functions and event targets to catch errors and provide better meta data */
var TryCatch = /** @class */ (function () {
    function TryCatch() {
        /** JSDoc */
        this.ignoreOnError = 0;
        /**
         * @inheritDoc
         */
        this.name = TryCatch.id;
    }
    /** JSDoc */
    TryCatch.prototype.wrapTimeFunction = function (original) {
        return function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var originalCallback = args[0];
            args[0] = wrap(originalCallback, {
                mechanism: {
                    data: { function: getFunctionName(original) },
                    handled: true,
                    type: 'instrument',
                },
            });
            return original.apply(this, args);
        };
    };
    /** JSDoc */
    TryCatch.prototype.wrapRAF = function (original) {
        return function (callback) {
            return original(wrap(callback, {
                mechanism: {
                    data: {
                        function: 'requestAnimationFrame',
                        handler: getFunctionName(original),
                    },
                    handled: true,
                    type: 'instrument',
                },
            }));
        };
    };
    /** JSDoc */
    TryCatch.prototype.wrapEventTarget = function (target) {
        var global = misc_3();
        var proto = global[target] && global[target].prototype;
        if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty('addEventListener')) {
            return;
        }
        object_4(proto, 'addEventListener', function (original) {
            return function (eventName, fn, options) {
                try {
                    fn.handleEvent = wrap(fn.handleEvent.bind(fn), {
                        mechanism: {
                            data: {
                                function: 'handleEvent',
                                handler: getFunctionName(fn),
                                target: target,
                            },
                            handled: true,
                            type: 'instrument',
                        },
                    });
                }
                catch (err) {
                    // can sometimes get 'Permission denied to access property "handle Event'
                }
                // More breadcrumb DOM capture ... done here and not in `_instrumentBreadcrumbs`
                // so that we don't have more than one wrapper function
                var before;
                var clickHandler;
                var keypressHandler;
                if (target === 'EventTarget' || target === 'Node') {
                    // NOTE: generating multiple handlers per addEventListener invocation, should
                    //       revisit and verify we can just use one (almost certainly)
                    clickHandler = breadcrumbEventHandler('click');
                    keypressHandler = keypressEventHandler();
                    before = function (event) {
                        // need to intercept every DOM event in `before` argument, in case that
                        // same wrapped method is re-used for different events (e.g. mousemove THEN click)
                        // see #724
                        if (!event) {
                            return;
                        }
                        var eventType;
                        try {
                            eventType = event.type;
                        }
                        catch (e) {
                            // just accessing event properties can throw an exception in some rare circumstances
                            // see: https://github.com/getsentry/raven-js/issues/838
                            return;
                        }
                        if (eventType === 'click') {
                            return clickHandler(event);
                        }
                        else if (eventType === 'keypress') {
                            return keypressHandler(event);
                        }
                    };
                }
                return original.call(this, eventName, wrap(fn, {
                    mechanism: {
                        data: {
                            function: 'addEventListener',
                            handler: getFunctionName(fn),
                            target: target,
                        },
                        handled: true,
                        type: 'instrument',
                    },
                }, before), options);
            };
        });
        object_4(proto, 'removeEventListener', function (original) {
            return function (eventName, fn, options) {
                var callback = fn;
                try {
                    callback = callback && (callback.__sentry_wrapped__ || callback);
                }
                catch (e) {
                    // ignore, accessing __sentry_wrapped__ will throw in some Selenium environments
                }
                return original.call(this, eventName, callback, options);
            };
        });
    };
    /**
     * Wrap timer functions and event targets to catch errors
     * and provide better metadata.
     */
    TryCatch.prototype.setupOnce = function () {
        this.ignoreOnError = this.ignoreOnError;
        var global = misc_3();
        object_4(global, 'setTimeout', this.wrapTimeFunction.bind(this));
        object_4(global, 'setInterval', this.wrapTimeFunction.bind(this));
        object_4(global, 'requestAnimationFrame', this.wrapRAF.bind(this));
        [
            'EventTarget',
            'Window',
            'Node',
            'ApplicationCache',
            'AudioTrackList',
            'ChannelMergerNode',
            'CryptoOperation',
            'EventSource',
            'FileReader',
            'HTMLUnknownElement',
            'IDBDatabase',
            'IDBRequest',
            'IDBTransaction',
            'KeyOperation',
            'MediaController',
            'MessagePort',
            'ModalWindow',
            'Notification',
            'SVGElementInstance',
            'Screen',
            'TextTrack',
            'TextTrackCue',
            'TextTrackList',
            'WebSocket',
            'WebSocketWorker',
            'Worker',
            'XMLHttpRequest',
            'XMLHttpRequestEventTarget',
            'XMLHttpRequestUpload',
        ].forEach(this.wrapEventTarget.bind(this));
    };
    /**
     * @inheritDoc
     */
    TryCatch.id = 'TryCatch';
    return TryCatch;
}());
/**
 * Safely extract function name from itself
 */
function getFunctionName(fn) {
    try {
        return (fn && fn.name) || '<anonymous>';
    }
    catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        return '<anonymous>';
    }
}

var global$3 = misc_3();
var lastHref;
/** Default Breadcrumbs instrumentations */
var Breadcrumbs = /** @class */ (function () {
    /**
     * @inheritDoc
     */
    function Breadcrumbs(options) {
        /**
         * @inheritDoc
         */
        this.name = Breadcrumbs.id;
        this.options = tslib_1.__assign({ beacon: true, console: true, dom: true, fetch: true, history: true, sentry: true, xhr: true }, options);
    }
    /** JSDoc */
    Breadcrumbs.prototype.instrumentBeacon = function () {
        if (!supports_6()) {
            return;
        }
        /** JSDoc */
        function beaconReplacementFunction(originalBeaconFunction) {
            return function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                var url = args[0];
                var data = args[1];
                // If the browser successfully queues the request for delivery, the method returns "true" and returns "false" otherwise.
                // https://developer.mozilla.org/en-US/docs/Web/API/Beacon_API/Using_the_Beacon_API
                var result = originalBeaconFunction.apply(this, args);
                var client = core.getCurrentHub().getClient();
                var dsn = client && client.getDsn();
                if (dsn) {
                    var filterUrl = new core.API(dsn).getStoreEndpoint();
                    // if Sentry key appears in URL, don't capture it as a request
                    // but rather as our own 'sentry' type breadcrumb
                    if (filterUrl && string_4(url, filterUrl)) {
                        addSentryBreadcrumb(data);
                        return result;
                    }
                }
                // What is wrong with you TypeScript...
                var breadcrumbData = {
                    category: 'beacon',
                    data: data,
                    type: 'http',
                };
                if (!result) {
                    breadcrumbData.level = dist_1.Error;
                }
                Breadcrumbs.addBreadcrumb(breadcrumbData, {
                    input: args,
                    result: result,
                });
                return result;
            };
        }
        object_4(global$3.navigator, 'sendBeacon', beaconReplacementFunction);
    };
    /** JSDoc */
    Breadcrumbs.prototype.instrumentConsole = function () {
        if (!('console' in global$3)) {
            return;
        }
        ['debug', 'info', 'warn', 'error', 'log'].forEach(function (level) {
            if (!(level in global$3.console)) {
                return;
            }
            object_4(global$3.console, level, function (originalConsoleLevel) {
                return function () {
                    var args = [];
                    for (var _i = 0; _i < arguments.length; _i++) {
                        args[_i] = arguments[_i];
                    }
                    var breadcrumbData = {
                        category: 'console',
                        data: {
                            extra: {
                                arguments: object_6(args, 2),
                            },
                            logger: 'console',
                        },
                        level: dist_1.fromString(level),
                        message: string_3(args, ' '),
                    };
                    if (level === 'assert') {
                        if (args[0] === false) {
                            breadcrumbData.message = "Assertion failed: " + (string_3(args.slice(1), ' ') || 'console.assert');
                            breadcrumbData.data.extra.arguments = object_6(args.slice(1), 2);
                        }
                    }
                    Breadcrumbs.addBreadcrumb(breadcrumbData, {
                        input: args,
                        level: level,
                    });
                    // this fails for some browsers. :(
                    if (originalConsoleLevel) {
                        Function.prototype.apply.call(originalConsoleLevel, global$3.console, args);
                    }
                };
            });
        });
    };
    /** JSDoc */
    Breadcrumbs.prototype.instrumentDOM = function () {
        if (!('document' in global$3)) {
            return;
        }
        // Capture breadcrumbs from any click that is unhandled / bubbled up all the way
        // to the document. Do this before we instrument addEventListener.
        global$3.document.addEventListener('click', breadcrumbEventHandler('click'), false);
        global$3.document.addEventListener('keypress', keypressEventHandler(), false);
    };
    /** JSDoc */
    Breadcrumbs.prototype.instrumentFetch = function () {
        if (!supports_5()) {
            return;
        }
        object_4(global$3, 'fetch', function (originalFetch) {
            return function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                var fetchInput = args[0];
                var method = 'GET';
                var url;
                if (typeof fetchInput === 'string') {
                    url = fetchInput;
                }
                else if ('Request' in global$3 && fetchInput instanceof Request) {
                    url = fetchInput.url;
                    if (fetchInput.method) {
                        method = fetchInput.method;
                    }
                }
                else {
                    url = String(fetchInput);
                }
                if (args[1] && args[1].method) {
                    method = args[1].method;
                }
                var client = core.getCurrentHub().getClient();
                var dsn = client && client.getDsn();
                if (dsn) {
                    var filterUrl = new core.API(dsn).getStoreEndpoint();
                    // if Sentry key appears in URL, don't capture it as a request
                    // but rather as our own 'sentry' type breadcrumb
                    if (filterUrl && string_4(url, filterUrl)) {
                        if (method === 'POST' && args[1] && args[1].body) {
                            addSentryBreadcrumb(args[1].body);
                        }
                        return originalFetch.apply(global$3, args);
                    }
                }
                var fetchData = {
                    method: method,
                    url: url,
                };
                return originalFetch
                    .apply(global$3, args)
                    .then(function (response) {
                    fetchData.status_code = response.status;
                    Breadcrumbs.addBreadcrumb({
                        category: 'fetch',
                        data: fetchData,
                        type: 'http',
                    }, {
                        input: args,
                        response: response,
                    });
                    return response;
                })
                    .catch(function (error) {
                    Breadcrumbs.addBreadcrumb({
                        category: 'fetch',
                        data: fetchData,
                        level: dist_1.Error,
                        type: 'http',
                    }, {
                        error: error,
                        input: args,
                    });
                    throw error;
                });
            };
        });
    };
    /** JSDoc */
    Breadcrumbs.prototype.instrumentHistory = function () {
        var _this = this;
        if (!supports_9()) {
            return;
        }
        var captureUrlChange = function (from, to) {
            var parsedLoc = misc_7(global$3.location.href);
            var parsedTo = misc_7(to);
            var parsedFrom = misc_7(from);
            // Initial pushState doesn't provide `from` information
            if (!parsedFrom.path) {
                parsedFrom = parsedLoc;
            }
            // because onpopstate only tells you the "new" (to) value of location.href, and
            // not the previous (from) value, we need to track the value of the current URL
            // state ourselves
            lastHref = to;
            // Use only the path component of the URL if the URL matches the current
            // document (almost all the time when using pushState)
            if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host) {
                // tslint:disable-next-line:no-parameter-reassignment
                to = parsedTo.relative;
            }
            if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host) {
                // tslint:disable-next-line:no-parameter-reassignment
                from = parsedFrom.relative;
            }
            Breadcrumbs.addBreadcrumb({
                category: 'navigation',
                data: {
                    from: from,
                    to: to,
                },
            });
        };
        // record navigation (URL) changes
        var oldOnPopState = global$3.onpopstate;
        global$3.onpopstate = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var currentHref = global$3.location.href;
            captureUrlChange(lastHref, currentHref);
            if (oldOnPopState) {
                return oldOnPopState.apply(_this, args);
            }
        };
        /** JSDoc */
        function historyReplacementFunction(originalHistoryFunction) {
            // note history.pushState.length is 0; intentionally not declaring
            // params to preserve 0 arity
            return function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                var url = args.length > 2 ? args[2] : undefined;
                // url argument is optional
                if (url) {
                    // coerce to string (this is what pushState does)
                    captureUrlChange(lastHref, String(url));
                }
                return originalHistoryFunction.apply(this, args);
            };
        }
        object_4(global$3.history, 'pushState', historyReplacementFunction);
        object_4(global$3.history, 'replaceState', historyReplacementFunction);
    };
    /** JSDoc */
    Breadcrumbs.prototype.instrumentXHR = function () {
        if (!('XMLHttpRequest' in global$3)) {
            return;
        }
        /** JSDoc */
        function wrapProp(prop, xhr) {
            // TODO: Fix XHR types
            if (prop in xhr && is_6(xhr[prop])) {
                object_4(xhr, prop, function (original) {
                    return wrap(original, {
                        mechanism: {
                            data: {
                                function: prop,
                                handler: (original && original.name) || '<anonymous>',
                            },
                            handled: true,
                            type: 'instrument',
                        },
                    });
                });
            }
        }
        var xhrproto = XMLHttpRequest.prototype;
        object_4(xhrproto, 'open', function (originalOpen) {
            return function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                var url = args[1];
                this.__sentry_xhr__ = {
                    method: args[0],
                    url: args[1],
                };
                var client = core.getCurrentHub().getClient();
                var dsn = client && client.getDsn();
                if (dsn) {
                    var filterUrl = new core.API(dsn).getStoreEndpoint();
                    // if Sentry key appears in URL, don't capture it as a request
                    // but rather as our own 'sentry' type breadcrumb
                    if (is_7(url) && (filterUrl && string_4(url, filterUrl))) {
                        this.__sentry_own_request__ = true;
                    }
                }
                return originalOpen.apply(this, args);
            };
        });
        object_4(xhrproto, 'send', function (originalSend) {
            return function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                var xhr = this; // tslint:disable-line:no-this-assignment
                if (xhr.__sentry_own_request__) {
                    addSentryBreadcrumb(args[0]);
                }
                /** JSDoc */
                function onreadystatechangeHandler() {
                    if (xhr.readyState === 4) {
                        if (xhr.__sentry_own_request__) {
                            return;
                        }
                        try {
                            // touching statusCode in some platforms throws
                            // an exception
                            if (xhr.__sentry_xhr__) {
                                xhr.__sentry_xhr__.status_code = xhr.status;
                            }
                        }
                        catch (e) {
                            /* do nothing */
                        }
                        Breadcrumbs.addBreadcrumb({
                            category: 'xhr',
                            data: xhr.__sentry_xhr__,
                            type: 'http',
                        }, {
                            xhr: xhr,
                        });
                    }
                }
                ['onload', 'onerror', 'onprogress'].forEach(function (prop) {
                    wrapProp(prop, xhr);
                });
                if ('onreadystatechange' in xhr && is_6(xhr.onreadystatechange)) {
                    object_4(xhr, 'onreadystatechange', function (original) {
                        return wrap(original, {
                            mechanism: {
                                data: {
                                    function: 'onreadystatechange',
                                    handler: (original && original.name) || '<anonymous>',
                                },
                                handled: true,
                                type: 'instrument',
                            },
                        }, onreadystatechangeHandler);
                    });
                }
                else {
                    // if onreadystatechange wasn't actually set by the page on this xhr, we
                    // are free to set our own and capture the breadcrumb
                    xhr.onreadystatechange = onreadystatechangeHandler;
                }
                return originalSend.apply(this, args);
            };
        });
    };
    /**
     * Helper that checks if integration is enabled on the client.
     * @param breadcrumb Breadcrumb
     * @param hint SentryBreadcrumbHint
     */
    Breadcrumbs.addBreadcrumb = function (breadcrumb, hint) {
        if (core.getCurrentHub().getIntegration(Breadcrumbs)) {
            core.getCurrentHub().addBreadcrumb(breadcrumb, hint);
        }
    };
    /**
     * Instrument browser built-ins w/ breadcrumb capturing
     *  - Console API
     *  - DOM API (click/typing)
     *  - XMLHttpRequest API
     *  - Fetch API
     *  - History API
     */
    Breadcrumbs.prototype.setupOnce = function () {
        if (this.options.console) {
            this.instrumentConsole();
        }
        if (this.options.dom) {
            this.instrumentDOM();
        }
        if (this.options.xhr) {
            this.instrumentXHR();
        }
        if (this.options.fetch) {
            this.instrumentFetch();
        }
        if (this.options.beacon) {
            this.instrumentBeacon();
        }
        if (this.options.history) {
            this.instrumentHistory();
        }
    };
    /**
     * @inheritDoc
     */
    Breadcrumbs.id = 'Breadcrumbs';
    return Breadcrumbs;
}());
/** JSDoc */
function addSentryBreadcrumb(serializedData) {
    // There's always something that can go wrong with deserialization...
    try {
        var event_1 = object_2(serializedData);
        Breadcrumbs.addBreadcrumb({
            category: 'sentry',
            event_id: event_1.event_id,
            level: event_1.level || dist_1.fromString('error'),
            message: misc_8(event_1),
        }, {
            event: event_1,
        });
    }
    catch (_oO) {
        logger_2.error('Error while adding sentry type breadcrumb');
    }
}

var DEFAULT_KEY = 'cause';
var DEFAULT_LIMIT = 5;
/** Adds SDK info to an event. */
var LinkedErrors = /** @class */ (function () {
    /**
     * @inheritDoc
     */
    function LinkedErrors(options) {
        if (options === void 0) { options = {}; }
        /**
         * @inheritDoc
         */
        this.name = LinkedErrors.id;
        this.key = options.key || DEFAULT_KEY;
        this.limit = options.limit || DEFAULT_LIMIT;
    }
    /**
     * @inheritDoc
     */
    LinkedErrors.prototype.setupOnce = function () {
        var _this = this;
        core.addGlobalEventProcessor(function (event, hint) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var self;
            return tslib_1.__generator(this, function (_a) {
                self = core.getCurrentHub().getIntegration(LinkedErrors);
                if (self) {
                    return [2 /*return*/, self.handler(event, hint)];
                }
                return [2 /*return*/, event];
            });
        }); });
    };
    /**
     * @inheritDoc
     */
    LinkedErrors.prototype.handler = function (event, hint) {
        if (!event.exception || !event.exception.values || !hint || !(hint.originalException instanceof Error)) {
            return event;
        }
        var linkedErrors = this.walkErrorTree(hint.originalException, this.key);
        event.exception.values = tslib_1.__spread(linkedErrors, event.exception.values);
        return event;
    };
    /**
     * @inheritDoc
     */
    LinkedErrors.prototype.walkErrorTree = function (error, key, stack) {
        if (stack === void 0) { stack = []; }
        if (!(error[key] instanceof Error) || stack.length + 1 >= this.limit) {
            return stack;
        }
        var stacktrace = computeStackTrace(error[key]);
        var exception = exceptionFromStacktrace(stacktrace);
        return this.walkErrorTree(error[key], key, tslib_1.__spread([exception], stack));
    };
    /**
     * @inheritDoc
     */
    LinkedErrors.id = 'LinkedErrors';
    return LinkedErrors;
}());

var global$4 = misc_3();
/** UserAgent */
var UserAgent = /** @class */ (function () {
    function UserAgent() {
        /**
         * @inheritDoc
         */
        this.name = UserAgent.id;
    }
    /**
     * @inheritDoc
     */
    UserAgent.prototype.setupOnce = function () {
        var _this = this;
        core.addGlobalEventProcessor(function (event) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var request;
            return tslib_1.__generator(this, function (_a) {
                if (core.getCurrentHub().getIntegration(UserAgent)) {
                    if (!global$4.navigator || !global$4.location) {
                        return [2 /*return*/, event];
                    }
                    request = event.request || {};
                    request.url = request.url || global$4.location.href;
                    request.headers = request.headers || {};
                    request.headers['User-Agent'] = global$4.navigator.userAgent;
                    return [2 /*return*/, tslib_1.__assign({}, event, { request: request })];
                }
                return [2 /*return*/, event];
            });
        }); });
    };
    /**
     * @inheritDoc
     */
    UserAgent.id = 'UserAgent';
    return UserAgent;
}());

/** JSDoc */
var Ember = /** @class */ (function () {
    /**
     * @inheritDoc
     */
    function Ember(options) {
        if (options === void 0) { options = {}; }
        /**
         * @inheritDoc
         */
        this.name = Ember.id;
        this.Ember =
            options.Ember ||
                misc_3().Ember;
    }
    /**
     * @inheritDoc
     */
    Ember.prototype.setupOnce = function () {
        var _this = this;
        if (!this.Ember) {
            return;
        }
        var oldOnError = this.Ember.onerror;
        this.Ember.onerror = function (error) {
            if (core.getCurrentHub().getIntegration(Ember)) {
                core.withScope(function (scope) {
                    _this.addIntegrationToSdkInfo(scope);
                    core.captureException(error);
                });
            }
            if (typeof oldOnError === 'function') {
                oldOnError.call(_this.Ember, error);
            }
            else if (_this.Ember.testing) {
                throw error;
            }
        };
        this.Ember.RSVP.on('error', function (reason) {
            if (core.getCurrentHub().getIntegration(Ember)) {
                core.withScope(function (scope) {
                    if (reason instanceof Error) {
                        scope.setExtra('context', 'Unhandled Promise error detected');
                        _this.addIntegrationToSdkInfo(scope);
                        core.captureException(reason);
                    }
                    else {
                        scope.setExtra('reason', reason);
                        _this.addIntegrationToSdkInfo(scope);
                        core.captureMessage('Unhandled Promise error detected');
                    }
                });
            }
        });
    };
    /**
     * Appends SDK integrations
     * @param scope The scope currently used.
     */
    Ember.prototype.addIntegrationToSdkInfo = function (scope) {
        var _this = this;
        scope.addEventProcessor(function (event) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var integrations;
            return tslib_1.__generator(this, function (_a) {
                if (event.sdk) {
                    integrations = event.sdk.integrations || [];
                    event.sdk = tslib_1.__assign({}, event.sdk, { integrations: tslib_1.__spread(integrations, ['ember']) });
                }
                return [2 /*return*/, event];
            });
        }); });
    };
    /**
     * @inheritDoc
     */
    Ember.id = 'Ember';
    return Ember;
}());

/** JSDoc */
var Vue = /** @class */ (function () {
    /**
     * @inheritDoc
     */
    function Vue(options) {
        if (options === void 0) { options = {}; }
        /**
         * @inheritDoc
         */
        this.name = Vue.id;
        this.Vue =
            options.Vue ||
                misc_3().Vue;
    }
    /** JSDoc */
    Vue.prototype.formatComponentName = function (vm) {
        if (vm.$root === vm) {
            return 'root instance';
        }
        var name = vm._isVue ? vm.$options.name || vm.$options._componentTag : vm.name;
        return ((name ? "component <" + name + ">" : 'anonymous component') +
            (vm._isVue && vm.$options.__file ? " at " + vm.$options.__file : ''));
    };
    /**
     * @inheritDoc
     */
    Vue.prototype.setupOnce = function () {
        var _this = this;
        if (!this.Vue || !this.Vue.config) {
            return;
        }
        var oldOnError = this.Vue.config.errorHandler;
        this.Vue.config.errorHandler = function (error, vm, info) {
            var metadata = {};
            if (is_10(vm)) {
                metadata.componentName = _this.formatComponentName(vm);
                metadata.propsData = vm.$options.propsData;
            }
            if (!is_5(info)) {
                metadata.lifecycleHook = info;
            }
            if (core.getCurrentHub().getIntegration(Vue)) {
                core.withScope(function (scope) {
                    Object.keys(metadata).forEach(function (key) {
                        scope.setExtra(key, metadata[key]);
                    });
                    scope.addEventProcessor(function (event) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                        var integrations;
                        return tslib_1.__generator(this, function (_a) {
                            if (event.sdk) {
                                integrations = event.sdk.integrations || [];
                                event.sdk = tslib_1.__assign({}, event.sdk, { integrations: tslib_1.__spread(integrations, ['vue']) });
                            }
                            return [2 /*return*/, event];
                        });
                    }); });
                    core.captureException(error);
                });
            }
            if (typeof oldOnError === 'function') {
                oldOnError.call(_this.Vue, error, vm, info);
            }
        };
    };
    /**
     * @inheritDoc
     */
    Vue.id = 'Vue';
    return Vue;
}());

/** JSDoc */
var ReportTypes;
(function (ReportTypes) {
    /** JSDoc */
    ReportTypes["Crash"] = "crash";
    /** JSDoc */
    ReportTypes["Deprecation"] = "deprecation";
    /** JSDoc */
    ReportTypes["Intervention"] = "intervention";
})(ReportTypes || (ReportTypes = {}));
/** Reporting API integration - https://w3c.github.io/reporting/ */
var ReportingObserver = /** @class */ (function () {
    /**
     * @inheritDoc
     */
    function ReportingObserver(options) {
        if (options === void 0) { options = {
            types: [ReportTypes.Crash, ReportTypes.Deprecation, ReportTypes.Intervention],
        }; }
        this.options = options;
        /**
         * @inheritDoc
         */
        this.name = ReportingObserver.id;
    }
    /**
     * @inheritDoc
     */
    ReportingObserver.prototype.setupOnce = function () {
        if (!supports_7()) {
            return;
        }
        var observer = new (misc_3().ReportingObserver)(this.handler.bind(this), {
            buffered: true,
            types: this.options.types,
        });
        observer.observe();
    };
    /**
     * @inheritDoc
     */
    ReportingObserver.prototype.handler = function (reports) {
        var e_1, _a;
        if (!core.getCurrentHub().getIntegration(ReportingObserver)) {
            return;
        }
        var _loop_1 = function (report) {
            core.withScope(function (scope) {
                scope.setExtra('url', report.url);
                var label = "ReportingObserver [" + report.type + "]";
                var details = 'No details available';
                if (report.body) {
                    // Object.keys doesn't work on ReportBody, as all properties are inheirted
                    var plainBody = {};
                    // tslint:disable-next-line:forin
                    for (var prop in report.body) {
                        plainBody[prop] = report.body[prop];
                    }
                    scope.setExtra('body', plainBody);
                    if (report.type === ReportTypes.Crash) {
                        var body = report.body;
                        // A fancy way to create a message out of crashId OR reason OR both OR fallback
                        details = [body.crashId || '', body.reason || ''].join(' ').trim() || details;
                    }
                    else {
                        var body = report.body;
                        details = body.message || details;
                    }
                }
                core.captureMessage(label + ": " + details);
            });
        };
        try {
            for (var reports_1 = tslib_1.__values(reports), reports_1_1 = reports_1.next(); !reports_1_1.done; reports_1_1 = reports_1.next()) {
                var report = reports_1_1.value;
                _loop_1(report);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (reports_1_1 && !reports_1_1.done && (_a = reports_1.return)) _a.call(reports_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
    };
    /**
     * @inheritDoc
     */
    ReportingObserver.id = 'ReportingObserver';
    return ReportingObserver;
}());



var BrowserIntegrations = /*#__PURE__*/Object.freeze({
	GlobalHandlers: GlobalHandlers,
	TryCatch: TryCatch,
	Breadcrumbs: Breadcrumbs,
	LinkedErrors: LinkedErrors,
	UserAgent: UserAgent,
	Ember: Ember,
	Vue: Vue,
	ReportingObserver: ReportingObserver
});

var defaultIntegrations = [
    // Common
    new core.Integrations.Dedupe(),
    new core.Integrations.InboundFilters(),
    new core.Integrations.FunctionToString(),
    new core.Integrations.ExtraErrorData(),
    // Native Wrappers
    new TryCatch(),
    new Breadcrumbs(),
    // Global Handlers
    new GlobalHandlers(),
    // Misc
    new LinkedErrors(),
    new UserAgent(),
];
/**
 * The Sentry Browser SDK Client.
 *
 * To use this SDK, call the {@link init} function as early as possible when
 * loading the web page. To set context information or send manual events, use
 * the provided methods.
 *
 * @example
 * import { init } from '@sentry/browser';
 *
 * init({
 *   dsn: '__DSN__',
 *   // ...
 * });
 *
 * @example
 * import { configureScope } from '@sentry/browser';
 * configureScope((scope: Scope) => {
 *   scope.setExtra({ battery: 0.7 });
 *   scope.setTag({ user_mode: 'admin' });
 *   scope.setUser({ id: '4711' });
 * });
 *
 * @example
 * import { addBreadcrumb } from '@sentry/browser';
 * addBreadcrumb({
 *   message: 'My Breadcrumb',
 *   // ...
 * });
 *
 * @example
 * import * as Sentry from '@sentry/browser';
 * Sentry.captureMessage('Hello, world!');
 * Sentry.captureException(new Error('Good bye'));
 * Sentry.captureEvent({
 *   message: 'Manual',
 *   stacktrace: [
 *     // ...
 *   ],
 * });
 *
 * @see BrowserOptions for documentation on configuration options.
 */
function init(options) {
    if (options === void 0) { options = {}; }
    if (options.defaultIntegrations === undefined) {
        options.defaultIntegrations = defaultIntegrations;
    }
    core.initAndBind(BrowserClient, options);
}
/**
 * Present the user with a report dialog.
 *
 * @param options Everything is optional, we try to fetch all info need from the global scope.
 */
function showReportDialog(options) {
    if (options === void 0) { options = {}; }
    if (!options.eventId) {
        options.eventId = core.getCurrentHub().lastEventId();
    }
    core.getCurrentHub().getClient().showReportDialog(options);
}
/**
 * This is the getter for lastEventId.
 *
 * @returns The last event id of a captured event.
 */
function lastEventId() {
    return core.getCurrentHub().lastEventId();
}
/**
 * This function is here to be API compatible with the loader
 */
function forceLoad() {
    // Noop
}
/**
 * This function is here to be API compatible with the loader
 */
function onLoad(callback) {
    callback();
}

var INTEGRATIONS = tslib_1.__assign({}, core.Integrations, BrowserIntegrations);

exports.addGlobalEventProcessor = core.addGlobalEventProcessor;
exports.addBreadcrumb = core.addBreadcrumb;
exports.captureException = core.captureException;
exports.captureEvent = core.captureEvent;
exports.captureMessage = core.captureMessage;
exports.configureScope = core.configureScope;
exports.withScope = core.withScope;
exports.getHubFromCarrier = core.getHubFromCarrier;
exports.getCurrentHub = core.getCurrentHub;
exports.Hub = core.Hub;
exports.Scope = core.Scope;
exports.Integrations = INTEGRATIONS;
exports.Transports = index$1;
exports.Severity = dist_1;
exports.Status = dist_2;
exports.BrowserBackend = BrowserBackend;
exports.BrowserClient = BrowserClient;
exports.defaultIntegrations = defaultIntegrations;
exports.forceLoad = forceLoad;
exports.init = init;
exports.lastEventId = lastEventId;
exports.onLoad = onLoad;
exports.showReportDialog = showReportDialog;
exports.SDK_NAME = SDK_NAME;
exports.SDK_VERSION = SDK_VERSION;
//# sourceMappingURL=index.js.map

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(26), __webpack_require__(74)))

/***/ }),
/* 2866 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var minimal_1 = __webpack_require__(2867);
exports.addBreadcrumb = minimal_1.addBreadcrumb;
exports.captureException = minimal_1.captureException;
exports.captureEvent = minimal_1.captureEvent;
exports.captureMessage = minimal_1.captureMessage;
exports.configureScope = minimal_1.configureScope;
exports.withScope = minimal_1.withScope;
var hub_1 = __webpack_require__(102);
exports.addGlobalEventProcessor = hub_1.addGlobalEventProcessor;
exports.getCurrentHub = hub_1.getCurrentHub;
exports.Hub = hub_1.Hub;
exports.getHubFromCarrier = hub_1.getHubFromCarrier;
exports.Scope = hub_1.Scope;
var api_1 = __webpack_require__(2869);
exports.API = api_1.API;
var baseclient_1 = __webpack_require__(2870);
exports.BaseClient = baseclient_1.BaseClient;
var basebackend_1 = __webpack_require__(2873);
exports.BaseBackend = basebackend_1.BaseBackend;
var dsn_1 = __webpack_require__(433);
exports.Dsn = dsn_1.Dsn;
var error_1 = __webpack_require__(291);
exports.SentryError = error_1.SentryError;
var promisebuffer_1 = __webpack_require__(753);
exports.PromiseBuffer = promisebuffer_1.PromiseBuffer;
var interfaces_1 = __webpack_require__(2874);
exports.LogLevel = interfaces_1.LogLevel;
var sdk_1 = __webpack_require__(2875);
exports.initAndBind = sdk_1.initAndBind;
var noop_1 = __webpack_require__(754);
exports.NoopTransport = noop_1.NoopTransport;
var Integrations = __webpack_require__(2876);
exports.Integrations = Integrations;
//# sourceMappingURL=index.js.map

/***/ }),
/* 2867 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(43);
var hub_1 = __webpack_require__(102);
/**
 * This calls a function on the current hub.
 * @param method function to call on hub.
 * @param args to pass to function.
 */
function callOnHub(method) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    var hub = hub_1.getCurrentHub();
    if (hub && hub[method]) {
        // tslint:disable-next-line:no-unsafe-any
        return hub[method].apply(hub, tslib_1.__spread(args));
    }
    throw new Error("No hub defined or " + method + " was not found on the hub, please open a bug report.");
}
/**
 * Captures an exception event and sends it to Sentry.
 *
 * @param exception An exception-like object.
 * @returns The generated eventId.
 */
function captureException(exception) {
    var syntheticException;
    try {
        throw new Error('Sentry syntheticException');
    }
    catch (exception) {
        syntheticException = exception;
    }
    return callOnHub('captureException', exception, {
        originalException: exception,
        syntheticException: syntheticException,
    });
}
exports.captureException = captureException;
/**
 * Captures a message event and sends it to Sentry.
 *
 * @param message The message to send to Sentry.
 * @param level Define the level of the message.
 * @returns The generated eventId.
 */
function captureMessage(message, level) {
    var syntheticException;
    try {
        throw new Error(message);
    }
    catch (exception) {
        syntheticException = exception;
    }
    return callOnHub('captureMessage', message, level, {
        originalException: message,
        syntheticException: syntheticException,
    });
}
exports.captureMessage = captureMessage;
/**
 * Captures a manually created event and sends it to Sentry.
 *
 * @param event The event to send to Sentry.
 * @returns The generated eventId.
 */
function captureEvent(event) {
    return callOnHub('captureEvent', event);
}
exports.captureEvent = captureEvent;
/**
 * Records a new breadcrumb which will be attached to future events.
 *
 * Breadcrumbs will be added to subsequent events to provide more context on
 * user's actions prior to an error or crash.
 *
 * @param breadcrumb The breadcrumb to record.
 */
function addBreadcrumb(breadcrumb) {
    callOnHub('addBreadcrumb', breadcrumb);
}
exports.addBreadcrumb = addBreadcrumb;
/**
 * Callback to set context information onto the scope.
 * @param callback Callback function that receives Scope.
 */
function configureScope(callback) {
    callOnHub('configureScope', callback);
}
exports.configureScope = configureScope;
/**
 * Creates a new scope with and executes the given operation within.
 * The scope is automatically removed once the operation
 * finishes or throws.
 *
 * This is essentially a convenience function for:
 *
 *     pushScope();
 *     callback();
 *     popScope();
 *
 * @param callback that will be enclosed into push/popScope.
 */
function withScope(callback) {
    callOnHub('withScope', callback);
}
exports.withScope = withScope;
/**
 * Calls a function on the latest client. Use this with caution, it's meant as
 * in "internal" helper so we don't need to expose every possible function in
 * the shim. It is not guaranteed that the client actually implements the
 * function.
 *
 * @param method The method to call on the client/client.
 * @param args Arguments to pass to the client/fontend.
 */
function _callOnClient(method) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    callOnHub.apply(void 0, tslib_1.__spread(['invokeClient', method], args));
}
exports._callOnClient = _callOnClient;
//# sourceMappingURL=index.js.map

/***/ }),
/* 2868 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(43);
var logger_1 = __webpack_require__(89);
var misc_1 = __webpack_require__(158);
var scope_1 = __webpack_require__(751);
/**
 * API compatibility version of this hub.
 *
 * WARNING: This number should only be incresed when the global interface
 * changes a and new methods are introduced.
 */
exports.API_VERSION = 3;
/**
 * Internal class used to make sure we always have the latest internal functions
 * working in case we have a version conflict.
 */
var Hub = /** @class */ (function () {
    /**
     * Creates a new instance of the hub, will push one {@link Layer} into the
     * internal stack on creation.
     *
     * @param client bound to the hub.
     * @param scope bound to the hub.
     * @param version number, higher number means higher priority.
     */
    function Hub(client, scope, version) {
        if (scope === void 0) { scope = new scope_1.Scope(); }
        if (version === void 0) { version = exports.API_VERSION; }
        this.version = version;
        /** Is a {@link Layer}[] containing the client and scope */
        this.stack = [];
        this.stack.push({ client: client, scope: scope });
    }
    /**
     * Internal helper function to call a method on the top client if it exists.
     *
     * @param method The method to call on the client/client.
     * @param args Arguments to pass to the client/frontend.
     */
    Hub.prototype.invokeClient = function (method) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        var _a;
        var top = this.getStackTop();
        if (top && top.client && top.client[method]) {
            (_a = top.client)[method].apply(_a, tslib_1.__spread(args, [top.scope]));
        }
    };
    /**
     * Internal helper function to call an async method on the top client if it
     * exists.
     *
     * @param method The method to call on the client/client.
     * @param args Arguments to pass to the client/frontend.
     */
    Hub.prototype.invokeClientAsync = function (method) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        var _a;
        var top = this.getStackTop();
        if (top && top.client && top.client[method]) {
            (_a = top.client)[method].apply(_a, tslib_1.__spread(args, [top.scope])).catch(function (err) {
                logger_1.logger.error(err);
            });
        }
    };
    /**
     * Checks if this hub's version is older than the given version.
     *
     * @param version A version number to compare to.
     * @return True if the given version is newer; otherwise false.
     */
    Hub.prototype.isOlderThan = function (version) {
        return this.version < version;
    };
    /**
     * This binds the given client to the current scope.
     * @param client An SDK client (client) instance.
     */
    Hub.prototype.bindClient = function (client) {
        var top = this.getStackTop();
        top.client = client;
        if (top && top.scope && client) {
            top.scope.addScopeListener(function (s) {
                if (client.getBackend) {
                    try {
                        client.getBackend().storeScope(s);
                    }
                    catch (_a) {
                        // Do nothing
                    }
                }
            });
        }
    };
    /**
     * Create a new scope to store context information.
     *
     * The scope will be layered on top of the current one. It is isolated, i.e. all
     * breadcrumbs and context information added to this scope will be removed once
     * the scope ends. Be sure to always remove this scope with {@link this.popScope}
     * when the operation finishes or throws.
     *
     * @returns Scope, the new cloned scope
     */
    Hub.prototype.pushScope = function () {
        // We want to clone the content of prev scope
        var stack = this.getStack();
        var parentScope = stack.length > 0 ? stack[stack.length - 1].scope : undefined;
        var scope = scope_1.Scope.clone(parentScope);
        this.getStack().push({
            client: this.getClient(),
            scope: scope,
        });
        return scope;
    };
    /**
     * Removes a previously pushed scope from the stack.
     *
     * This restores the state before the scope was pushed. All breadcrumbs and
     * context information added since the last call to {@link this.pushScope} are
     * discarded.
     */
    Hub.prototype.popScope = function () {
        return this.getStack().pop() !== undefined;
    };
    /**
     * Creates a new scope with and executes the given operation within.
     * The scope is automatically removed once the operation
     * finishes or throws.
     *
     * This is essentially a convenience function for:
     *
     *     pushScope();
     *     callback();
     *     popScope();
     *
     * @param callback that will be enclosed into push/popScope.
     */
    Hub.prototype.withScope = function (callback) {
        var scope = this.pushScope();
        try {
            callback(scope);
        }
        finally {
            this.popScope();
        }
    };
    /** Returns the client of the top stack. */
    Hub.prototype.getClient = function () {
        return this.getStackTop().client;
    };
    /** Returns the scope of the top stack. */
    Hub.prototype.getScope = function () {
        return this.getStackTop().scope;
    };
    /** Returns the scope stack for domains or the process. */
    Hub.prototype.getStack = function () {
        return this.stack;
    };
    /** Returns the topmost scope layer in the order domain > local > process. */
    Hub.prototype.getStackTop = function () {
        return this.stack[this.stack.length - 1];
    };
    /**
     * Captures an exception event and sends it to Sentry.
     *
     * @param exception An exception-like object.
     * @param hint May contain additional information about the original exception.
     * @returns The generated eventId.
     */
    Hub.prototype.captureException = function (exception, hint) {
        var eventId = (this._lastEventId = misc_1.uuid4());
        this.invokeClientAsync('captureException', exception, tslib_1.__assign({}, hint, { event_id: eventId }));
        return eventId;
    };
    /**
     * Captures a message event and sends it to Sentry.
     *
     * @param message The message to send to Sentry.
     * @param level Define the level of the message.
     * @param hint May contain additional information about the original exception.
     * @returns The generated eventId.
     */
    Hub.prototype.captureMessage = function (message, level, hint) {
        var eventId = (this._lastEventId = misc_1.uuid4());
        this.invokeClientAsync('captureMessage', message, level, tslib_1.__assign({}, hint, { event_id: eventId }));
        return eventId;
    };
    /**
     * Captures a manually created event and sends it to Sentry.
     *
     * @param event The event to send to Sentry.
     * @param hint May contain additional information about the original exception.
     */
    Hub.prototype.captureEvent = function (event, hint) {
        var eventId = (this._lastEventId = misc_1.uuid4());
        this.invokeClientAsync('captureEvent', event, tslib_1.__assign({}, hint, { event_id: eventId }));
        return eventId;
    };
    /**
     * This is the getter for lastEventId.
     *
     * @returns The last event id of a captured event.
     */
    Hub.prototype.lastEventId = function () {
        return this._lastEventId;
    };
    /**
     * Records a new breadcrumb which will be attached to future events.
     *
     * Breadcrumbs will be added to subsequent events to provide more context on
     * user's actions prior to an error or crash.
     *
     * @param breadcrumb The breadcrumb to record.
     * @param hint May contain additional information about the original breadcrumb.
     */
    Hub.prototype.addBreadcrumb = function (breadcrumb, hint) {
        this.invokeClient('addBreadcrumb', breadcrumb, tslib_1.__assign({}, hint));
    };
    /**
     * Callback to set context information onto the scope.
     *
     * @param callback Callback function that receives Scope.
     */
    Hub.prototype.configureScope = function (callback) {
        var top = this.getStackTop();
        if (top.scope && top.client) {
            // TODO: freeze flag
            callback(top.scope);
        }
    };
    /**
     * For the duraction of the callback, this hub will be set as the global current Hub.
     * This function is useful if you want to run your own client and hook into an already initialized one
     * e.g.: Reporting issues to your own sentry when running in your component while still using the users configuration.
     */
    Hub.prototype.run = function (callback) {
        var oldHub = makeMain(this);
        try {
            callback(this);
        }
        finally {
            makeMain(oldHub);
        }
    };
    /** Returns the integration if installed on the current client. */
    Hub.prototype.getIntegration = function (integration) {
        try {
            return this.getClient().getIntegration(integration);
        }
        catch (_oO) {
            logger_1.logger.warn("Cannot retrieve integration " + integration.id + " from the current Hub");
            return null;
        }
    };
    return Hub;
}());
exports.Hub = Hub;
/** Returns the global shim registry. */
function getMainCarrier() {
    var carrier = misc_1.getGlobalObject();
    carrier.__SENTRY__ = carrier.__SENTRY__ || {
        hub: undefined,
    };
    return carrier;
}
exports.getMainCarrier = getMainCarrier;
/**
 * Replaces the current main hub with the passed one on the global object
 *
 * @returns The old replaced hub
 */
function makeMain(hub) {
    var registry = getMainCarrier();
    var oldHub = getHubFromCarrier(registry);
    setHubOnCarrier(registry, hub);
    return oldHub;
}
exports.makeMain = makeMain;
/**
 * Returns the default hub instance.
 *
 * If a hub is already registered in the global carrier but this module
 * contains a more recent version, it replaces the registered version.
 * Otherwise, the currently registered hub will be returned.
 */
function getCurrentHub() {
    // Get main carrier (global for every environment)
    var registry = getMainCarrier();
    // If there's no hub, or its an old API, assign a new one
    if (!hasHubOnCarrier(registry) || getHubFromCarrier(registry).isOlderThan(exports.API_VERSION)) {
        setHubOnCarrier(registry, new Hub());
    }
    // Prefer domains over global if they are there
    try {
        // We need to use `dynamicRequire` because `require` on it's own will be optimized by webpack.
        // We do not want this to happen, we need to try to `require` the domain node module and fail if we are in browser
        // for example so we do not have to shim it and use `getCurrentHub` universally.
        var domain = misc_1.dynamicRequire(module, 'domain');
        var activeDomain = domain.active;
        // If there no active domain, just return global hub
        if (!activeDomain) {
            return getHubFromCarrier(registry);
        }
        // If there's no hub on current domain, or its an old API, assign a new one
        if (!hasHubOnCarrier(activeDomain) || getHubFromCarrier(activeDomain).isOlderThan(exports.API_VERSION)) {
            var registryHubTopStack = getHubFromCarrier(registry).getStackTop();
            setHubOnCarrier(activeDomain, new Hub(registryHubTopStack.client, scope_1.Scope.clone(registryHubTopStack.scope)));
        }
        // Return hub that lives on a domain
        return getHubFromCarrier(activeDomain);
    }
    catch (_Oo) {
        // Return hub that lives on a global object
        return getHubFromCarrier(registry);
    }
}
exports.getCurrentHub = getCurrentHub;
/**
 * This will tell whether a carrier has a hub on it or not
 * @param carrier object
 */
function hasHubOnCarrier(carrier) {
    if (carrier && carrier.__SENTRY__ && carrier.__SENTRY__.hub) {
        return true;
    }
    else {
        return false;
    }
}
exports.hasHubOnCarrier = hasHubOnCarrier;
/**
 * This will create a new {@link Hub} and add to the passed object on
 * __SENTRY__.hub.
 * @param carrier object
 */
function getHubFromCarrier(carrier) {
    if (carrier && carrier.__SENTRY__ && carrier.__SENTRY__.hub) {
        return carrier.__SENTRY__.hub;
    }
    else {
        carrier.__SENTRY__ = {};
        carrier.__SENTRY__.hub = new Hub();
        return carrier.__SENTRY__.hub;
    }
}
exports.getHubFromCarrier = getHubFromCarrier;
/**
 * This will set passed {@link Hub} on the passed object's __SENTRY__.hub attribute
 * @param carrier object
 * @param hub Hub
 */
function setHubOnCarrier(carrier, hub) {
    if (!carrier) {
        return false;
    }
    carrier.__SENTRY__ = carrier.__SENTRY__ || {};
    carrier.__SENTRY__.hub = hub;
    return true;
}
exports.setHubOnCarrier = setHubOnCarrier;
//# sourceMappingURL=hub.js.map
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(248)(module)))

/***/ }),
/* 2869 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var object_1 = __webpack_require__(290);
var dsn_1 = __webpack_require__(433);
var SENTRY_API_VERSION = '7';
/** Helper class to provide urls to different Sentry endpoints. */
var API = /** @class */ (function () {
    /** Create a new instance of API */
    function API(dsn) {
        this.dsn = dsn;
        this.dsnObject = new dsn_1.Dsn(dsn);
    }
    /** Returns the Dsn object. */
    API.prototype.getDsn = function () {
        return this.dsnObject;
    };
    /** Returns a string with auth headers in the url to the store endpoint. */
    API.prototype.getStoreEndpoint = function () {
        return "" + this.getBaseUrl() + this.getStoreEndpointPath();
    };
    /** Returns the store endpoint with auth added in url encoded. */
    API.prototype.getStoreEndpointWithUrlEncodedAuth = function () {
        var dsn = this.dsnObject;
        var auth = {
            sentry_key: dsn.user,
            sentry_version: SENTRY_API_VERSION,
        };
        // Auth is intentionally sent as part of query string (NOT as custom HTTP header)
        // to avoid preflight CORS requests
        return this.getStoreEndpoint() + "?" + object_1.urlEncode(auth);
    };
    /** Returns the base path of the url including the port. */
    API.prototype.getBaseUrl = function () {
        var dsn = this.dsnObject;
        var protocol = dsn.protocol ? dsn.protocol + ":" : '';
        var port = dsn.port ? ":" + dsn.port : '';
        return protocol + "//" + dsn.host + port;
    };
    /** Returns only the path component for the store endpoint. */
    API.prototype.getStoreEndpointPath = function () {
        var dsn = this.dsnObject;
        return (dsn.path ? "/" + dsn.path : '') + "/api/" + dsn.projectId + "/store/";
    };
    /** Returns an object that can be used in request headers. */
    API.prototype.getRequestHeaders = function (clientName, clientVersion) {
        var dsn = this.dsnObject;
        var header = ["Sentry sentry_version=" + SENTRY_API_VERSION];
        header.push("sentry_timestamp=" + new Date().getTime());
        header.push("sentry_client=" + clientName + "/" + clientVersion);
        header.push("sentry_key=" + dsn.user);
        if (dsn.pass) {
            header.push("sentry_secret=" + dsn.pass);
        }
        return {
            'Content-Type': 'application/json',
            'X-Sentry-Auth': header.join(', '),
        };
    };
    /** Returns the url to the report dialog endpoint. */
    API.prototype.getReportDialogEndpoint = function (dialogOptions) {
        if (dialogOptions === void 0) { dialogOptions = {}; }
        var dsn = this.dsnObject;
        var endpoint = "" + this.getBaseUrl() + (dsn.path ? "/" + dsn.path : '') + "/api/embed/error-page/";
        var encodedOptions = [];
        encodedOptions.push("dsn=" + dsn.toString());
        for (var key in dialogOptions) {
            if (key === 'user') {
                if (!dialogOptions.user) {
                    continue;
                }
                if (dialogOptions.user.name) {
                    encodedOptions.push("name=" + encodeURIComponent(dialogOptions.user.name));
                }
                if (dialogOptions.user.email) {
                    encodedOptions.push("email=" + encodeURIComponent(dialogOptions.user.email));
                }
            }
            else {
                encodedOptions.push(encodeURIComponent(key) + "=" + encodeURIComponent(dialogOptions[key]));
            }
        }
        if (encodedOptions.length) {
            return endpoint + "?" + encodedOptions.join('&');
        }
        return endpoint;
    };
    return API;
}());
exports.API = API;
//# sourceMappingURL=api.js.map

/***/ }),
/* 2870 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(43);
var types_1 = __webpack_require__(752);
var async_1 = __webpack_require__(2871);
var is_1 = __webpack_require__(125);
var logger_1 = __webpack_require__(89);
var misc_1 = __webpack_require__(158);
var string_1 = __webpack_require__(432);
var dsn_1 = __webpack_require__(433);
var integration_1 = __webpack_require__(2872);
var promisebuffer_1 = __webpack_require__(753);
/**
 * Default maximum number of breadcrumbs added to an event. Can be overwritten
 * with {@link Options.maxBreadcrumbs}.
 */
var DEFAULT_BREADCRUMBS = 30;
/**
 * Absolute maximum number of breadcrumbs added to an event. The
 * `maxBreadcrumbs` option cannot be higher than this value.
 */
var MAX_BREADCRUMBS = 100;
/**
 * By default, truncates URL values to 250 chars
 */
var MAX_URL_LENGTH = 250;
/**
 * Base implementation for all JavaScript SDK clients.
 *
 * Call the constructor with the corresponding backend constructor and options
 * specific to the client subclass. To access these options later, use
 * {@link Client.getOptions}. Also, the Backend instance is available via
 * {@link Client.getBackend}.
 *
 * If a Dsn is specified in the options, it will be parsed and stored. Use
 * {@link Client.getDsn} to retrieve the Dsn at any moment. In case the Dsn is
 * invalid, the constructor will throw a {@link SentryException}. Note that
 * without a valid Dsn, the SDK will not send any events to Sentry.
 *
 * Before sending an event via the backend, it is passed through
 * {@link BaseClient.prepareEvent} to add SDK information and scope data
 * (breadcrumbs and context). To add more custom information, override this
 * method and extend the resulting prepared event.
 *
 * To issue automatically created events (e.g. via instrumentation), use
 * {@link Client.captureEvent}. It will prepare the event and pass it through
 * the callback lifecycle. To issue auto-breadcrumbs, use
 * {@link Client.addBreadcrumb}.
 *
 * @example
 * class NodeClient extends BaseClient<NodeBackend, NodeOptions> {
 *   public constructor(options: NodeOptions) {
 *     super(NodeBackend, options);
 *   }
 *
 *   // ...
 * }
 */
var BaseClient = /** @class */ (function () {
    /**
     * Initializes this client instance.
     *
     * @param backendClass A constructor function to create the backend.
     * @param options Options for the client.
     */
    function BaseClient(backendClass, options) {
        /** A simple buffer holding all requests. */
        this.buffer = new promisebuffer_1.PromiseBuffer();
        this.backend = new backendClass(options);
        this.options = options;
        if (options.dsn) {
            this.dsn = new dsn_1.Dsn(options.dsn);
        }
        // We have to setup the integrations in the constructor since we do not want
        // that anyone needs to call client.install();
        this.integrations = integration_1.setupIntegrations(this.options);
    }
    /**
     * @inheritDoc
     */
    BaseClient.prototype.install = function () {
        if (!this.isEnabled()) {
            return (this.installed = false);
        }
        var backend = this.getBackend();
        if (!this.installed && backend.install) {
            backend.install();
        }
        return (this.installed = true);
    };
    /**
     * @inheritDoc
     */
    BaseClient.prototype.captureException = function (exception, hint, scope) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, this.buffer.add((function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                        var event;
                        return tslib_1.__generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, this.getBackend().eventFromException(exception, hint)];
                                case 1:
                                    event = _a.sent();
                                    return [2 /*return*/, this.captureEvent(event, hint, scope)];
                            }
                        });
                    }); })())];
            });
        });
    };
    /**
     * @inheritDoc
     */
    BaseClient.prototype.captureMessage = function (message, level, hint, scope) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, this.buffer.add((function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                        var event, _a;
                        return tslib_1.__generator(this, function (_b) {
                            switch (_b.label) {
                                case 0:
                                    if (!is_1.isPrimitive(message)) return [3 /*break*/, 2];
                                    return [4 /*yield*/, this.getBackend().eventFromMessage("" + message, level, hint)];
                                case 1:
                                    _a = _b.sent();
                                    return [3 /*break*/, 4];
                                case 2: return [4 /*yield*/, this.getBackend().eventFromException(message, hint)];
                                case 3:
                                    _a = _b.sent();
                                    _b.label = 4;
                                case 4:
                                    event = _a;
                                    return [2 /*return*/, this.captureEvent(event, hint, scope)];
                            }
                        });
                    }); })())];
            });
        });
    };
    /**
     * @inheritDoc
     */
    BaseClient.prototype.captureEvent = function (event, hint, scope) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                // Adding this here is technically not correct since if you call captureMessage/captureException it's already
                // buffered. But since we not really need the count and we only need to know if the buffer is full or not,
                // This is fine...
                return [2 /*return*/, this.buffer.add((function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                        var _this = this;
                        return tslib_1.__generator(this, function (_a) {
                            return [2 /*return*/, this.processEvent(event, function (finalEvent) { return tslib_1.__awaiter(_this, void 0, void 0, function () { return tslib_1.__generator(this, function (_a) {
                                    return [2 /*return*/, this.getBackend().sendEvent(finalEvent)];
                                }); }); }, hint, scope)];
                        });
                    }); })())];
            });
        });
    };
    /**
     * @inheritDoc
     */
    BaseClient.prototype.addBreadcrumb = function (breadcrumb, hint, scope) {
        var _a = this.getOptions(), beforeBreadcrumb = _a.beforeBreadcrumb, _b = _a.maxBreadcrumbs, maxBreadcrumbs = _b === void 0 ? DEFAULT_BREADCRUMBS : _b;
        if (maxBreadcrumbs <= 0) {
            return;
        }
        var timestamp = new Date().getTime() / 1000;
        var mergedBreadcrumb = tslib_1.__assign({ timestamp: timestamp }, breadcrumb);
        var finalBreadcrumb = beforeBreadcrumb
            ? misc_1.consoleSandbox(function () { return beforeBreadcrumb(mergedBreadcrumb, hint); })
            : mergedBreadcrumb;
        if (finalBreadcrumb === null) {
            return;
        }
        if (this.getBackend().storeBreadcrumb(finalBreadcrumb) && scope) {
            scope.addBreadcrumb(finalBreadcrumb, Math.min(maxBreadcrumbs, MAX_BREADCRUMBS));
        }
    };
    /**
     * @inheritDoc
     */
    BaseClient.prototype.getDsn = function () {
        return this.dsn;
    };
    /**
     * @inheritDoc
     */
    BaseClient.prototype.getOptions = function () {
        return this.options;
    };
    /** Returns the current backend. */
    BaseClient.prototype.getBackend = function () {
        return this.backend;
    };
    /** Determines whether this SDK is enabled and a valid Dsn is present. */
    BaseClient.prototype.isEnabled = function () {
        return this.getOptions().enabled !== false && this.dsn !== undefined;
    };
    /**
     * Adds common information to events.
     *
     * The information includes release and environment from `options`,
     * breadcrumbs and context (extra, tags and user) from the scope.
     *
     * Information that is already present in the event is never overwritten. For
     * nested objects, such as the context, keys are merged.
     *
     * @param event The original event.
     * @param hint May contain additional informartion about the original exception.
     * @param scope A scope containing event metadata.
     * @returns A new event with more information.
     */
    BaseClient.prototype.prepareEvent = function (event, scope, hint) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, environment, _b, maxBreadcrumbs, release, dist, prepared, exception, request;
            return tslib_1.__generator(this, function (_c) {
                _a = this.getOptions(), environment = _a.environment, _b = _a.maxBreadcrumbs, maxBreadcrumbs = _b === void 0 ? DEFAULT_BREADCRUMBS : _b, release = _a.release, dist = _a.dist;
                prepared = tslib_1.__assign({}, event);
                if (prepared.environment === undefined && environment !== undefined) {
                    prepared.environment = environment;
                }
                if (prepared.release === undefined && release !== undefined) {
                    prepared.release = release;
                }
                if (prepared.dist === undefined && dist !== undefined) {
                    prepared.dist = dist;
                }
                if (prepared.message) {
                    prepared.message = string_1.truncate(prepared.message, MAX_URL_LENGTH);
                }
                exception = prepared.exception && prepared.exception.values && prepared.exception.values[0];
                if (exception && exception.value) {
                    exception.value = string_1.truncate(exception.value, MAX_URL_LENGTH);
                }
                request = prepared.request;
                if (request && request.url) {
                    request.url = string_1.truncate(request.url, MAX_URL_LENGTH);
                }
                if (prepared.event_id === undefined) {
                    prepared.event_id = misc_1.uuid4();
                }
                // This should be the last thing called, since we want that
                // {@link Hub.addEventProcessor} gets the finished prepared event.
                if (scope) {
                    return [2 /*return*/, scope.applyToEvent(prepared, hint, Math.min(maxBreadcrumbs, MAX_BREADCRUMBS))];
                }
                return [2 /*return*/, prepared];
            });
        });
    };
    /**
     * Processes an event (either error or message) and sends it to Sentry.
     *
     * This also adds breadcrumbs and context information to the event. However,
     * platform specific meta data (such as the User's IP address) must be added
     * by the SDK implementor.
     *
     * The returned event status offers clues to whether the event was sent to
     * Sentry and accepted there. If the {@link Options.shouldSend} hook returns
     * `false`, the status will be {@link SendStatus.Skipped}. If the rate limit
     * was exceeded, the status will be {@link SendStatus.RateLimit}.
     *
     * @param event The event to send to Sentry.
     * @param send A function to actually send the event.
     * @param scope A scope containing event metadata.
     * @param hint May contain additional informartion about the original exception.
     * @returns A Promise that resolves with the event status.
     */
    BaseClient.prototype.processEvent = function (event, send, hint, scope) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, beforeSend, sampleRate, prepared, finalEvent, isInternalException, exception_1, response, error_1;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!this.isEnabled()) {
                            return [2 /*return*/, {
                                    status: types_1.Status.Skipped,
                                }];
                        }
                        _a = this.getOptions(), beforeSend = _a.beforeSend, sampleRate = _a.sampleRate;
                        // 1.0 === 100% events are sent
                        // 0.0 === 0% events are sent
                        if (typeof sampleRate === 'number' && Math.random() > sampleRate) {
                            return [2 /*return*/, {
                                    status: types_1.Status.Skipped,
                                }];
                        }
                        return [4 /*yield*/, this.prepareEvent(event, scope, hint)];
                    case 1:
                        prepared = _b.sent();
                        if (prepared === null) {
                            return [2 /*return*/, {
                                    status: types_1.Status.Skipped,
                                }];
                        }
                        finalEvent = prepared;
                        _b.label = 2;
                    case 2:
                        _b.trys.push([2, 5, , 6]);
                        isInternalException = hint && hint.data && hint.data.__sentry__ === true;
                        if (!(!isInternalException && beforeSend)) return [3 /*break*/, 4];
                        return [4 /*yield*/, beforeSend(prepared, hint)];
                    case 3:
                        finalEvent = _b.sent();
                        if (typeof finalEvent === 'undefined') {
                            logger_1.logger.error('`beforeSend` method has to return `null` or a valid event');
                        }
                        _b.label = 4;
                    case 4: return [3 /*break*/, 6];
                    case 5:
                        exception_1 = _b.sent();
                        async_1.forget(this.captureException(exception_1, {
                            data: {
                                __sentry__: true,
                            },
                            originalException: exception_1,
                        }));
                        return [2 /*return*/, {
                                reason: 'Event processing in beforeSend method threw an exception',
                                status: types_1.Status.Invalid,
                            }];
                    case 6:
                        if (finalEvent === null) {
                            return [2 /*return*/, {
                                    reason: 'Event dropped due to being discarded by beforeSend method',
                                    status: types_1.Status.Skipped,
                                }];
                        }
                        _b.label = 7;
                    case 7:
                        _b.trys.push([7, 9, , 10]);
                        return [4 /*yield*/, send(finalEvent)];
                    case 8:
                        response = _b.sent();
                        response.event = finalEvent;
                        if (response.status === types_1.Status.RateLimit) {
                            // TODO: Handle rate limits and maintain a queue. For now, we require SDK
                            // implementors to override this method and handle it themselves.
                        }
                        return [2 /*return*/, response];
                    case 9:
                        error_1 = _b.sent();
                        // We have a catch here since the transport can reject the request internally.
                        // If we do not catch this here, we will run into an endless loop.
                        logger_1.logger.error("" + error_1);
                        return [2 /*return*/, {
                                reason: "" + error_1,
                                status: types_1.Status.Failed,
                            }];
                    case 10: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * @inheritDoc
     */
    BaseClient.prototype.close = function (timeout) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, Promise.all([
                            this.getBackend()
                                .getTransport()
                                .close(timeout),
                            this.buffer.drain(timeout),
                        ])];
                    case 1: return [2 /*return*/, (_a.sent()).reduce(function (prev, current) { return prev && current; })];
                }
            });
        });
    };
    /**
     * @inheritDoc
     */
    BaseClient.prototype.getIntegrations = function () {
        return this.integrations || {};
    };
    /**
     * @inheritDoc
     */
    BaseClient.prototype.getIntegration = function (integration) {
        try {
            return this.integrations[integration.id] || null;
        }
        catch (_oO) {
            logger_1.logger.warn("Cannot retrieve integration " + integration.id + " from the current Client");
            return null;
        }
    };
    return BaseClient;
}());
exports.BaseClient = BaseClient;
//# sourceMappingURL=baseclient.js.map

/***/ }),
/* 2871 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(43);
/**
 * Consumes the promise and logs the error when it rejects.
 * @param promise A promise to forget.
 */
function forget(promise) {
    promise.catch(function (e) {
        // TODO: Use a better logging mechanism
        console.error(e);
    });
}
exports.forget = forget;
/**
 * Helper to filter an array with asynchronous callbacks.
 *
 * @param array An array containing items to filter.
 * @param predicate An async predicate evaluated on every item.
 * @param thisArg Optional value passed as "this" into the callback.
 * @returns An array containing only values where the callback returned true.
 */
function filterAsync(array, predicate, thisArg) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var verdicts;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, Promise.all(array.map(predicate, thisArg))];
                case 1:
                    verdicts = _a.sent();
                    return [2 /*return*/, array.filter(function (_, index) { return verdicts[index]; })];
            }
        });
    });
}
exports.filterAsync = filterAsync;
//# sourceMappingURL=async.js.map

/***/ }),
/* 2872 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(43);
var logger_1 = __webpack_require__(89);
exports.installedIntegrations = [];
/** Gets integration to install */
function getIntegrationsToSetup(options) {
    var e_1, _a, e_2, _b;
    var defaultIntegrations = (options.defaultIntegrations && tslib_1.__spread(options.defaultIntegrations)) || [];
    var userIntegrations = options.integrations;
    var integrations = [];
    if (Array.isArray(userIntegrations)) {
        var userIntegrationsNames = userIntegrations.map(function (i) { return i.name; });
        var pickedIntegrationsNames = [];
        try {
            // Leave only unique default integrations, that were not overridden with provided user integrations
            for (var defaultIntegrations_1 = tslib_1.__values(defaultIntegrations), defaultIntegrations_1_1 = defaultIntegrations_1.next(); !defaultIntegrations_1_1.done; defaultIntegrations_1_1 = defaultIntegrations_1.next()) {
                var defaultIntegration = defaultIntegrations_1_1.value;
                if (userIntegrationsNames.indexOf(getIntegrationName(defaultIntegration)) === -1 &&
                    pickedIntegrationsNames.indexOf(getIntegrationName(defaultIntegration)) === -1) {
                    integrations.push(defaultIntegration);
                    pickedIntegrationsNames.push(getIntegrationName(defaultIntegration));
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (defaultIntegrations_1_1 && !defaultIntegrations_1_1.done && (_a = defaultIntegrations_1.return)) _a.call(defaultIntegrations_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        try {
            // Don't add same user integration twice
            for (var userIntegrations_1 = tslib_1.__values(userIntegrations), userIntegrations_1_1 = userIntegrations_1.next(); !userIntegrations_1_1.done; userIntegrations_1_1 = userIntegrations_1.next()) {
                var userIntegration = userIntegrations_1_1.value;
                if (pickedIntegrationsNames.indexOf(getIntegrationName(userIntegration)) === -1) {
                    integrations.push(userIntegration);
                    pickedIntegrationsNames.push(getIntegrationName(userIntegration));
                }
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (userIntegrations_1_1 && !userIntegrations_1_1.done && (_b = userIntegrations_1.return)) _b.call(userIntegrations_1);
            }
            finally { if (e_2) throw e_2.error; }
        }
    }
    else if (typeof userIntegrations === 'function') {
        integrations = userIntegrations(defaultIntegrations);
        integrations = Array.isArray(integrations) ? integrations : [integrations];
    }
    else {
        return tslib_1.__spread(defaultIntegrations);
    }
    return integrations;
}
exports.getIntegrationsToSetup = getIntegrationsToSetup;
/** Setup given integration */
function setupIntegration(integration, options) {
    if (exports.installedIntegrations.indexOf(getIntegrationName(integration)) !== -1) {
        return;
    }
    try {
        integration.setupOnce();
    }
    catch (_Oo) {
        /** @deprecated */
        // TODO: Remove in v5
        // tslint:disable:deprecation
        if (integration.install) {
            logger_1.logger.warn("Integration " + getIntegrationName(integration) + ": The install method is deprecated. Use \"setupOnce\".");
            integration.install(options);
        }
        // tslint:enable:deprecation
    }
    exports.installedIntegrations.push(getIntegrationName(integration));
    logger_1.logger.log("Integration installed: " + getIntegrationName(integration));
}
exports.setupIntegration = setupIntegration;
/**
 * Given a list of integration instances this installs them all. When `withDefaults` is set to `true` then all default
 * integrations are added unless they were already provided before.
 * @param integrations array of integration instances
 * @param withDefault should enable default integrations
 */
function setupIntegrations(options) {
    var integrations = {};
    getIntegrationsToSetup(options).forEach(function (integration) {
        integrations[getIntegrationName(integration)] = integration;
        setupIntegration(integration, options);
    });
    return integrations;
}
exports.setupIntegrations = setupIntegrations;
/**
 * Returns the integration static id.
 * @param integration Integration to retrieve id
 */
function getIntegrationName(integration) {
    /**
     * @depracted
     */
    // tslint:disable-next-line:no-unsafe-any
    return integration.constructor.id || integration.name;
}
//# sourceMappingURL=integration.js.map

/***/ }),
/* 2873 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(43);
var logger_1 = __webpack_require__(89);
var object_1 = __webpack_require__(290);
var error_1 = __webpack_require__(291);
var noop_1 = __webpack_require__(754);
/**
 * This is the base implemention of a Backend.
 */
var BaseBackend = /** @class */ (function () {
    /** Creates a new browser backend instance. */
    function BaseBackend(options) {
        this.options = options;
        if (!this.options.dsn) {
            logger_1.logger.warn('No DSN provided, backend will not do anything.');
        }
        this.transport = this.setupTransport();
    }
    /**
     * Sets up the transport so it can be used later to send requests.
     */
    BaseBackend.prototype.setupTransport = function () {
        return new noop_1.NoopTransport();
    };
    /**
     * @inheritDoc
     */
    BaseBackend.prototype.eventFromException = function (_exception, _hint) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                throw new error_1.SentryError('Backend has to implement `eventFromException` method');
            });
        });
    };
    /**
     * @inheritDoc
     */
    BaseBackend.prototype.eventFromMessage = function (_message, _level, _hint) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                throw new error_1.SentryError('Backend has to implement `eventFromMessage` method');
            });
        });
    };
    /**
     * @inheritDoc
     */
    BaseBackend.prototype.sendEvent = function (event) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                // TODO: Remove with v5
                // tslint:disable-next-line
                if (this.transport.captureEvent) {
                    // tslint:disable-next-line
                    return [2 /*return*/, this.transport.captureEvent(event)];
                }
                // --------------------
                return [2 /*return*/, this.transport.sendEvent(object_1.serialize(event))];
            });
        });
    };
    /**
     * @inheritDoc
     */
    BaseBackend.prototype.storeBreadcrumb = function (_) {
        return true;
    };
    /**
     * @inheritDoc
     */
    BaseBackend.prototype.storeScope = function (_) {
        // Noop
    };
    /**
     * @inheritDoc
     */
    BaseBackend.prototype.getTransport = function () {
        return this.transport;
    };
    return BaseBackend;
}());
exports.BaseBackend = BaseBackend;
//# sourceMappingURL=basebackend.js.map

/***/ }),
/* 2874 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/** Console logging verbosity for the SDK. */
var LogLevel;
(function (LogLevel) {
    /** No logs will be generated. */
    LogLevel[LogLevel["None"] = 0] = "None";
    /** Only SDK internal errors will be logged. */
    LogLevel[LogLevel["Error"] = 1] = "Error";
    /** Information useful for debugging the SDK will be logged. */
    LogLevel[LogLevel["Debug"] = 2] = "Debug";
    /** All SDK actions will be logged. */
    LogLevel[LogLevel["Verbose"] = 3] = "Verbose";
})(LogLevel = exports.LogLevel || (exports.LogLevel = {}));
//# sourceMappingURL=interfaces.js.map

/***/ }),
/* 2875 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var hub_1 = __webpack_require__(102);
var logger_1 = __webpack_require__(89);
/**
 * Internal function to create a new SDK client instance. The client is
 * installed and then bound to the current scope.
 *
 * @param clientClass The client class to instanciate.
 * @param options Options to pass to the client.
 * @returns The installed and bound client instance.
 */
function initAndBind(clientClass, options) {
    if (options.debug === true) {
        logger_1.logger.enable();
    }
    if (hub_1.getCurrentHub().getClient()) {
        return;
    }
    var client = new clientClass(options);
    hub_1.getCurrentHub().bindClient(client);
    client.install();
}
exports.initAndBind = initAndBind;
//# sourceMappingURL=sdk.js.map

/***/ }),
/* 2876 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var dedupe_1 = __webpack_require__(2877);
exports.Dedupe = dedupe_1.Dedupe;
var functiontostring_1 = __webpack_require__(2878);
exports.FunctionToString = functiontostring_1.FunctionToString;
var sdkinformation_1 = __webpack_require__(2879);
exports.SDKInformation = sdkinformation_1.SDKInformation;
var inboundfilters_1 = __webpack_require__(2880);
exports.InboundFilters = inboundfilters_1.InboundFilters;
var extraerrordata_1 = __webpack_require__(2881);
exports.ExtraErrorData = extraerrordata_1.ExtraErrorData;
var debug_1 = __webpack_require__(2882);
exports.Debug = debug_1.Debug;
var rewriteframes_1 = __webpack_require__(2883);
exports.RewriteFrames = rewriteframes_1.RewriteFrames;
//# sourceMappingURL=index.js.map

/***/ }),
/* 2877 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(43);
var hub_1 = __webpack_require__(102);
var logger_1 = __webpack_require__(89);
var misc_1 = __webpack_require__(158);
/** Deduplication filter */
var Dedupe = /** @class */ (function () {
    function Dedupe() {
        /**
         * @inheritDoc
         */
        this.name = Dedupe.id;
    }
    /**
     * @inheritDoc
     */
    Dedupe.prototype.setupOnce = function () {
        var _this = this;
        hub_1.addGlobalEventProcessor(function (currentEvent) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var self;
            return tslib_1.__generator(this, function (_a) {
                self = hub_1.getCurrentHub().getIntegration(Dedupe);
                if (self) {
                    // Juuust in case something goes wrong
                    try {
                        if (self.shouldDropEvent(currentEvent, self.previousEvent)) {
                            return [2 /*return*/, null];
                        }
                    }
                    catch (_oO) {
                        return [2 /*return*/, (self.previousEvent = currentEvent)];
                    }
                    return [2 /*return*/, (self.previousEvent = currentEvent)];
                }
                return [2 /*return*/, currentEvent];
            });
        }); });
    };
    /** JSDoc */
    Dedupe.prototype.shouldDropEvent = function (currentEvent, previousEvent) {
        if (!previousEvent) {
            return false;
        }
        if (this.isSameMessageEvent(currentEvent, previousEvent)) {
            logger_1.logger.warn("Event dropped due to being a duplicate of previous event (same message).\nEvent: " + misc_1.getEventDescription(currentEvent));
            return true;
        }
        if (this.isSameExceptionEvent(currentEvent, previousEvent)) {
            logger_1.logger.warn("Event dropped due to being a duplicate of previous event (same exception).\nEvent: " + misc_1.getEventDescription(currentEvent));
            return true;
        }
        return false;
    };
    /** JSDoc */
    Dedupe.prototype.isSameMessageEvent = function (currentEvent, previousEvent) {
        var currentMessage = currentEvent.message;
        var previousMessage = previousEvent.message;
        // If no event has a message, they were both exceptions, so bail out
        if (!currentMessage && !previousMessage) {
            return false;
        }
        // If only one event has a stacktrace, but not the other one, they are not the same
        if ((currentMessage && !previousMessage) || (!currentMessage && previousMessage)) {
            return false;
        }
        if (currentMessage !== previousMessage) {
            return false;
        }
        if (!this.isSameFingerprint(currentEvent, previousEvent)) {
            return false;
        }
        if (!this.isSameStacktrace(currentEvent, previousEvent)) {
            return false;
        }
        return true;
    };
    /** JSDoc */
    Dedupe.prototype.getFramesFromEvent = function (event) {
        var exception = event.exception;
        if (exception) {
            try {
                // @ts-ignore
                return exception.values[0].stacktrace.frames;
            }
            catch (_oO) {
                return undefined;
            }
        }
        else if (event.stacktrace) {
            return event.stacktrace.frames;
        }
        else {
            return undefined;
        }
    };
    /** JSDoc */
    Dedupe.prototype.isSameStacktrace = function (currentEvent, previousEvent) {
        var currentFrames = this.getFramesFromEvent(currentEvent);
        var previousFrames = this.getFramesFromEvent(previousEvent);
        // If no event has a fingerprint, they are assumed to be the same
        if (!currentFrames && !previousFrames) {
            return true;
        }
        // If only one event has a stacktrace, but not the other one, they are not the same
        if ((currentFrames && !previousFrames) || (!currentFrames && previousFrames)) {
            return false;
        }
        currentFrames = currentFrames;
        previousFrames = previousFrames;
        // If number of frames differ, they are not the same
        if (previousFrames.length !== currentFrames.length) {
            return false;
        }
        // Otherwise, compare the two
        for (var i = 0; i < previousFrames.length; i++) {
            var frameA = previousFrames[i];
            var frameB = currentFrames[i];
            if (frameA.filename !== frameB.filename ||
                frameA.lineno !== frameB.lineno ||
                frameA.colno !== frameB.colno ||
                frameA.function !== frameB.function) {
                return false;
            }
        }
        return true;
    };
    /** JSDoc */
    Dedupe.prototype.getExceptionFromEvent = function (event) {
        return event.exception && event.exception.values && event.exception.values[0];
    };
    /** JSDoc */
    Dedupe.prototype.isSameExceptionEvent = function (currentEvent, previousEvent) {
        var previousException = this.getExceptionFromEvent(previousEvent);
        var currentException = this.getExceptionFromEvent(currentEvent);
        if (!previousException || !currentException) {
            return false;
        }
        if (previousException.type !== currentException.type || previousException.value !== currentException.value) {
            return false;
        }
        if (!this.isSameFingerprint(currentEvent, previousEvent)) {
            return false;
        }
        if (!this.isSameStacktrace(currentEvent, previousEvent)) {
            return false;
        }
        return true;
    };
    /** JSDoc */
    Dedupe.prototype.isSameFingerprint = function (currentEvent, previousEvent) {
        var currentFingerprint = currentEvent.fingerprint;
        var previousFingerprint = previousEvent.fingerprint;
        // If no event has a fingerprint, they are assumed to be the same
        if (!currentFingerprint && !previousFingerprint) {
            return true;
        }
        // If only one event has a fingerprint, but not the other one, they are not the same
        if ((currentFingerprint && !previousFingerprint) || (!currentFingerprint && previousFingerprint)) {
            return false;
        }
        currentFingerprint = currentFingerprint;
        previousFingerprint = previousFingerprint;
        // Otherwise, compare the two
        try {
            return !!(currentFingerprint.join('') === previousFingerprint.join(''));
        }
        catch (_oO) {
            return false;
        }
    };
    /**
     * @inheritDoc
     */
    Dedupe.id = 'Dedupe';
    return Dedupe;
}());
exports.Dedupe = Dedupe;
//# sourceMappingURL=dedupe.js.map

/***/ }),
/* 2878 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var originalFunctionToString;
/** Patch toString calls to return proper name for wrapped functions */
var FunctionToString = /** @class */ (function () {
    function FunctionToString() {
        /**
         * @inheritDoc
         */
        this.name = FunctionToString.id;
    }
    /**
     * @inheritDoc
     */
    FunctionToString.prototype.setupOnce = function () {
        originalFunctionToString = Function.prototype.toString;
        Function.prototype.toString = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var context = this.__sentry__ ? this.__sentry_original__ : this;
            // tslint:disable-next-line:no-unsafe-any
            return originalFunctionToString.apply(context, args);
        };
    };
    /**
     * @inheritDoc
     */
    FunctionToString.id = 'FunctionToString';
    return FunctionToString;
}());
exports.FunctionToString = FunctionToString;
//# sourceMappingURL=functiontostring.js.map

/***/ }),
/* 2879 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var logger_1 = __webpack_require__(89);
/**
 * @deprecated
 * This file can be safely removed in the next major bump
 */
/** Adds SDK info to an event. */
var SDKInformation = /** @class */ (function () {
    function SDKInformation() {
        /**
         * @inheritDoc
         */
        this.name = 'SDKInformation';
    }
    /**
     * @inheritDoc
     */
    SDKInformation.prototype.setupOnce = function () {
        logger_1.logger.warn("SDKInformation Integration is deprecated and can be safely removed. It's functionality has been merged into the SDK's core.");
    };
    return SDKInformation;
}());
exports.SDKInformation = SDKInformation;
//# sourceMappingURL=sdkinformation.js.map

/***/ }),
/* 2880 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(43);
var hub_1 = __webpack_require__(102);
var is_1 = __webpack_require__(125);
var logger_1 = __webpack_require__(89);
var misc_1 = __webpack_require__(158);
var string_1 = __webpack_require__(432);
// "Script error." is hard coded into browsers for errors that it can't read.
// this is the result of a script being pulled in from an external domain and CORS.
var DEFAULT_IGNORE_ERRORS = [/^Script error\.?$/, /^Javascript error: Script error\.? on line 0$/];
/** Inbound filters configurable by the user */
var InboundFilters = /** @class */ (function () {
    function InboundFilters(options) {
        if (options === void 0) { options = {}; }
        this.options = options;
        /**
         * @inheritDoc
         */
        this.name = InboundFilters.id;
    }
    /**
     * @inheritDoc
     */
    InboundFilters.prototype.setupOnce = function () {
        var _this = this;
        hub_1.addGlobalEventProcessor(function (event) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var hub, self, client, clientOptions, options;
            return tslib_1.__generator(this, function (_a) {
                hub = hub_1.getCurrentHub();
                if (!hub) {
                    return [2 /*return*/, event];
                }
                self = hub.getIntegration(InboundFilters);
                if (self) {
                    client = hub.getClient();
                    clientOptions = client ? client.getOptions() : {};
                    options = self.mergeOptions(clientOptions);
                    if (self.shouldDropEvent(event, options)) {
                        return [2 /*return*/, null];
                    }
                }
                return [2 /*return*/, event];
            });
        }); });
    };
    /** JSDoc */
    InboundFilters.prototype.shouldDropEvent = function (event, options) {
        if (this.isSentryError(event, options)) {
            logger_1.logger.warn("Event dropped due to being internal Sentry Error.\nEvent: " + misc_1.getEventDescription(event));
            return true;
        }
        if (this.isIgnoredError(event, options)) {
            logger_1.logger.warn("Event dropped due to being matched by `ignoreErrors` option.\nEvent: " + misc_1.getEventDescription(event));
            return true;
        }
        if (this.isBlacklistedUrl(event, options)) {
            logger_1.logger.warn("Event dropped due to being matched by `blacklistUrls` option.\nEvent: " + misc_1.getEventDescription(event) + ".\nUrl: " + this.getEventFilterUrl(event));
            return true;
        }
        if (!this.isWhitelistedUrl(event, options)) {
            logger_1.logger.warn("Event dropped due to not being matched by `whitelistUrls` option.\nEvent: " + misc_1.getEventDescription(event) + ".\nUrl: " + this.getEventFilterUrl(event));
            return true;
        }
        return false;
    };
    /** JSDoc */
    InboundFilters.prototype.isSentryError = function (event, options) {
        if (options === void 0) { options = {}; }
        if (!options.ignoreInternal) {
            return false;
        }
        try {
            // tslint:disable-next-line:no-unsafe-any
            return event.exception.values[0].type === 'SentryError';
        }
        catch (_oO) {
            return false;
        }
    };
    /** JSDoc */
    InboundFilters.prototype.isIgnoredError = function (event, options) {
        var _this = this;
        if (options === void 0) { options = {}; }
        if (!options.ignoreErrors || !options.ignoreErrors.length) {
            return false;
        }
        return this.getPossibleEventMessages(event).some(function (message) {
            // Not sure why TypeScript complains here...
            return options.ignoreErrors.some(function (pattern) { return _this.isMatchingPattern(message, pattern); });
        });
    };
    /** JSDoc */
    InboundFilters.prototype.isBlacklistedUrl = function (event, options) {
        var _this = this;
        if (options === void 0) { options = {}; }
        // TODO: Use Glob instead?
        if (!options.blacklistUrls || !options.blacklistUrls.length) {
            return false;
        }
        var url = this.getEventFilterUrl(event);
        return !url ? false : options.blacklistUrls.some(function (pattern) { return _this.isMatchingPattern(url, pattern); });
    };
    /** JSDoc */
    InboundFilters.prototype.isWhitelistedUrl = function (event, options) {
        var _this = this;
        if (options === void 0) { options = {}; }
        // TODO: Use Glob instead?
        if (!options.whitelistUrls || !options.whitelistUrls.length) {
            return true;
        }
        var url = this.getEventFilterUrl(event);
        return !url ? true : options.whitelistUrls.some(function (pattern) { return _this.isMatchingPattern(url, pattern); });
    };
    /** JSDoc */
    InboundFilters.prototype.mergeOptions = function (clientOptions) {
        if (clientOptions === void 0) { clientOptions = {}; }
        return {
            blacklistUrls: tslib_1.__spread((this.options.blacklistUrls || []), (clientOptions.blacklistUrls || [])),
            ignoreErrors: tslib_1.__spread((this.options.ignoreErrors || []), (clientOptions.ignoreErrors || []), DEFAULT_IGNORE_ERRORS),
            ignoreInternal: typeof this.options.ignoreInternal !== 'undefined' ? this.options.ignoreInternal : true,
            whitelistUrls: tslib_1.__spread((this.options.whitelistUrls || []), (clientOptions.whitelistUrls || [])),
        };
    };
    /** JSDoc */
    InboundFilters.prototype.isMatchingPattern = function (value, pattern) {
        if (is_1.isRegExp(pattern)) {
            return pattern.test(value);
        }
        else if (typeof pattern === 'string') {
            return string_1.includes(value, pattern);
        }
        else {
            return false;
        }
    };
    /** JSDoc */
    InboundFilters.prototype.getPossibleEventMessages = function (event) {
        if (event.message) {
            return [event.message];
        }
        else if (event.exception) {
            try {
                // tslint:disable-next-line:no-unsafe-any
                var _a = event.exception.values[0], type = _a.type, value = _a.value;
                return ["" + value, type + ": " + value];
            }
            catch (oO) {
                logger_1.logger.error("Cannot extract message for event " + misc_1.getEventDescription(event));
                return [];
            }
        }
        else {
            return [];
        }
    };
    /** JSDoc */
    InboundFilters.prototype.getEventFilterUrl = function (event) {
        try {
            if (event.stacktrace) {
                // tslint:disable-next-line:no-unsafe-any
                return event.stacktrace.frames[0].filename;
            }
            else if (event.exception) {
                // tslint:disable-next-line:no-unsafe-any
                return event.exception.values[0].stacktrace.frames[0].filename;
            }
            else {
                return null;
            }
        }
        catch (oO) {
            logger_1.logger.error("Cannot extract url for event " + misc_1.getEventDescription(event));
            return null;
        }
    };
    /**
     * @inheritDoc
     */
    InboundFilters.id = 'InboundFilters';
    return InboundFilters;
}());
exports.InboundFilters = InboundFilters;
//# sourceMappingURL=inboundfilters.js.map

/***/ }),
/* 2881 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(43);
var hub_1 = __webpack_require__(102);
var is_1 = __webpack_require__(125);
var logger_1 = __webpack_require__(89);
/** Patch toString calls to return proper name for wrapped functions */
var ExtraErrorData = /** @class */ (function () {
    function ExtraErrorData() {
        /**
         * @inheritDoc
         */
        this.name = ExtraErrorData.id;
    }
    /**
     * @inheritDoc
     */
    ExtraErrorData.prototype.setupOnce = function () {
        var _this = this;
        hub_1.addGlobalEventProcessor(function (event, hint) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var self;
            return tslib_1.__generator(this, function (_a) {
                self = hub_1.getCurrentHub().getIntegration(ExtraErrorData);
                if (!self) {
                    return [2 /*return*/, event];
                }
                return [2 /*return*/, self.enhanceEventWithErrorData(event, hint)];
            });
        }); });
    };
    /**
     * Attaches extracted information from the Error object to extra field in the SentryEvent
     */
    ExtraErrorData.prototype.enhanceEventWithErrorData = function (event, hint) {
        if (!hint || !hint.originalException || !is_1.isError(hint.originalException)) {
            return event;
        }
        var errorData = this.extractErrorData(hint.originalException);
        if (errorData) {
            return tslib_1.__assign({}, event, { extra: tslib_1.__assign({}, event.extra, errorData) });
        }
        return event;
    };
    /**
     * Extract extra information from the Error object
     */
    ExtraErrorData.prototype.extractErrorData = function (error) {
        var e_1, _a, _b;
        // We are trying to enhance already existing event, so no harm done if it won't succeed
        try {
            var nativeKeys_1 = ['name', 'message', 'stack', 'line', 'column', 'fileName', 'lineNumber', 'columnNumber'];
            var name_1 = error.name || error.constructor.name;
            var errorKeys = Object.getOwnPropertyNames(error).filter(function (key) { return nativeKeys_1.indexOf(key) === -1; });
            if (errorKeys.length) {
                var extraErrorInfo = {};
                try {
                    for (var errorKeys_1 = tslib_1.__values(errorKeys), errorKeys_1_1 = errorKeys_1.next(); !errorKeys_1_1.done; errorKeys_1_1 = errorKeys_1.next()) {
                        var key = errorKeys_1_1.value;
                        var value = error[key];
                        if (is_1.isError(value)) {
                            value = value.name || value.constructor.name;
                        }
                        extraErrorInfo[key] = value;
                    }
                }
                catch (e_1_1) { e_1 = { error: e_1_1 }; }
                finally {
                    try {
                        if (errorKeys_1_1 && !errorKeys_1_1.done && (_a = errorKeys_1.return)) _a.call(errorKeys_1);
                    }
                    finally { if (e_1) throw e_1.error; }
                }
                return _b = {},
                    _b[name_1] = extraErrorInfo,
                    _b;
            }
            return null;
        }
        catch (oO) {
            logger_1.logger.error('Unable to extract extra data from the Error object:', oO);
            return null;
        }
    };
    /**
     * @inheritDoc
     */
    ExtraErrorData.id = 'ExtraErrorData';
    return ExtraErrorData;
}());
exports.ExtraErrorData = ExtraErrorData;
//# sourceMappingURL=extraerrordata.js.map

/***/ }),
/* 2882 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(43);
var hub_1 = __webpack_require__(102);
/** JSDoc */
var Debug = /** @class */ (function () {
    /**
     * @inheritDoc
     */
    function Debug(options) {
        /**
         * @inheritDoc
         */
        this.name = Debug.id;
        this.options = tslib_1.__assign({ debugger: false, stringify: false }, options);
    }
    /**
     * @inheritDoc
     */
    Debug.prototype.setupOnce = function () {
        var _this = this;
        hub_1.addGlobalEventProcessor(function (event, hint) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var self;
            return tslib_1.__generator(this, function (_a) {
                self = hub_1.getCurrentHub().getIntegration(Debug);
                if (self) {
                    // tslint:disable:no-console
                    // tslint:disable:no-debugger
                    if (self.options.debugger) {
                        debugger;
                    }
                    if (self.options.stringify) {
                        console.log(JSON.stringify(event, null, 2));
                        if (hint) {
                            console.log(JSON.stringify(hint, null, 2));
                        }
                    }
                    else {
                        console.log(event);
                        if (hint) {
                            console.log(hint);
                        }
                    }
                }
                return [2 /*return*/, event];
            });
        }); });
    };
    /**
     * @inheritDoc
     */
    Debug.id = 'Debug';
    return Debug;
}());
exports.Debug = Debug;
//# sourceMappingURL=debug.js.map

/***/ }),
/* 2883 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(43);
var hub_1 = __webpack_require__(102);
var path_1 = __webpack_require__(2884);
/** Rewrite event frames paths */
var RewriteFrames = /** @class */ (function () {
    /**
     * @inheritDoc
     */
    function RewriteFrames(options) {
        if (options === void 0) { options = {}; }
        var _this = this;
        /**
         * @inheritDoc
         */
        this.name = RewriteFrames.id;
        /**
         * @inheritDoc
         */
        this.iteratee = function (frame) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var base;
            return tslib_1.__generator(this, function (_a) {
                if (frame.filename && frame.filename.startsWith('/')) {
                    base = this.root ? path_1.relative(this.root, frame.filename) : path_1.basename(frame.filename);
                    frame.filename = "app:///" + base;
                }
                return [2 /*return*/, frame];
            });
        }); };
        if (options.root) {
            this.root = options.root;
        }
        if (options.iteratee) {
            this.iteratee = options.iteratee;
        }
    }
    /**
     * @inheritDoc
     */
    RewriteFrames.prototype.setupOnce = function () {
        var _this = this;
        hub_1.addGlobalEventProcessor(function (event) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var self;
            return tslib_1.__generator(this, function (_a) {
                self = hub_1.getCurrentHub().getIntegration(RewriteFrames);
                if (self) {
                    return [2 /*return*/, self.process(event)];
                }
                return [2 /*return*/, event];
            });
        }); });
    };
    /** JSDoc */
    RewriteFrames.prototype.process = function (event) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var frames, _a, _b, _i, i, _c, _d;
            return tslib_1.__generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        frames = this.getFramesFromEvent(event);
                        if (!frames) return [3 /*break*/, 4];
                        _a = [];
                        for (_b in frames)
                            _a.push(_b);
                        _i = 0;
                        _e.label = 1;
                    case 1:
                        if (!(_i < _a.length)) return [3 /*break*/, 4];
                        i = _a[_i];
                        // tslint:disable-next-line
                        _c = frames;
                        _d = i;
                        return [4 /*yield*/, this.iteratee(frames[i])];
                    case 2:
                        // tslint:disable-next-line
                        _c[_d] = _e.sent();
                        _e.label = 3;
                    case 3:
                        _i++;
                        return [3 /*break*/, 1];
                    case 4: return [2 /*return*/, event];
                }
            });
        });
    };
    /** JSDoc */
    RewriteFrames.prototype.getFramesFromEvent = function (event) {
        var exception = event.exception;
        if (exception) {
            try {
                // tslint:disable-next-line:no-unsafe-any
                return exception.values[0].stacktrace.frames;
            }
            catch (_oO) {
                return undefined;
            }
        }
        else if (event.stacktrace) {
            return event.stacktrace.frames;
        }
        else {
            return undefined;
        }
    };
    /**
     * @inheritDoc
     */
    RewriteFrames.id = 'RewriteFrames';
    return RewriteFrames;
}());
exports.RewriteFrames = RewriteFrames;
//# sourceMappingURL=rewriteframes.js.map

/***/ }),
/* 2884 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// Slightly modified (no IE8 support, ES6) and transcribed to TypeScript
// https://raw.githubusercontent.com/calvinmetcalf/rollup-plugin-node-builtins/master/src/es6/path.js
Object.defineProperty(exports, "__esModule", { value: true });
/** JSDoc */
function normalizeArray(parts, allowAboveRoot) {
    // if the path tries to go above the root, `up` ends up > 0
    var up = 0;
    for (var i = parts.length - 1; i >= 0; i--) {
        var last = parts[i];
        if (last === '.') {
            parts.splice(i, 1);
        }
        else if (last === '..') {
            parts.splice(i, 1);
            up++;
        }
        else if (up) {
            parts.splice(i, 1);
            up--;
        }
    }
    // if the path is allowed to go above the root, restore leading ..s
    if (allowAboveRoot) {
        for (; up--; up) {
            parts.unshift('..');
        }
    }
    return parts;
}
// Split a filename into [root, dir, basename, ext], unix version
// 'root' is just a slash, or nothing.
var splitPathRe = /^(\/?|)([\s\S]*?)((?:\.{1,2}|[^\/]+?|)(\.[^.\/]*|))(?:[\/]*)$/;
/** JSDoc */
function splitPath(filename) {
    var parts = splitPathRe.exec(filename);
    return parts ? parts.slice(1) : [];
}
// path.resolve([from ...], to)
// posix version
/** JSDoc */
function resolve() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var resolvedPath = '';
    var resolvedAbsolute = false;
    for (var i = args.length - 1; i >= -1 && !resolvedAbsolute; i--) {
        var path = i >= 0 ? args[i] : '/';
        // Skip empty entries
        if (!path) {
            continue;
        }
        resolvedPath = path + "/" + resolvedPath;
        resolvedAbsolute = path.charAt(0) === '/';
    }
    // At this point the path should be resolved to a full absolute path, but
    // handle relative paths to be safe (might happen when process.cwd() fails)
    // Normalize the path
    resolvedPath = normalizeArray(resolvedPath.split('/').filter(function (p) { return !!p; }), !resolvedAbsolute).join('/');
    return (resolvedAbsolute ? '/' : '') + resolvedPath || '.';
}
exports.resolve = resolve;
/** JSDoc */
function trim(arr) {
    var start = 0;
    for (; start < arr.length; start++) {
        if (arr[start] !== '') {
            break;
        }
    }
    var end = arr.length - 1;
    for (; end >= 0; end--) {
        if (arr[end] !== '') {
            break;
        }
    }
    if (start > end) {
        return [];
    }
    return arr.slice(start, end - start + 1);
}
// path.relative(from, to)
// posix version
/** JSDoc */
function relative(from, to) {
    // tslint:disable:no-parameter-reassignment
    from = resolve(from).substr(1);
    to = resolve(to).substr(1);
    var fromParts = trim(from.split('/'));
    var toParts = trim(to.split('/'));
    var length = Math.min(fromParts.length, toParts.length);
    var samePartsLength = length;
    for (var i = 0; i < length; i++) {
        if (fromParts[i] !== toParts[i]) {
            samePartsLength = i;
            break;
        }
    }
    var outputParts = [];
    for (var i = samePartsLength; i < fromParts.length; i++) {
        outputParts.push('..');
    }
    outputParts = outputParts.concat(toParts.slice(samePartsLength));
    return outputParts.join('/');
}
exports.relative = relative;
// path.normalize(path)
// posix version
/** JSDoc */
function normalize(path) {
    var isPathAbsolute = isAbsolute(path);
    var trailingSlash = path.substr(-1) === '/';
    // Normalize the path
    var normalizedPath = normalizeArray(path.split('/').filter(function (p) { return !!p; }), !isPathAbsolute).join('/');
    if (!normalizedPath && !isPathAbsolute) {
        normalizedPath = '.';
    }
    if (normalizedPath && trailingSlash) {
        normalizedPath += '/';
    }
    return (isPathAbsolute ? '/' : '') + normalizedPath;
}
exports.normalize = normalize;
// posix version
/** JSDoc */
function isAbsolute(path) {
    return path.charAt(0) === '/';
}
exports.isAbsolute = isAbsolute;
// posix version
/** JSDoc */
function join() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return normalize(args.join('/'));
}
exports.join = join;
/** JSDoc */
function dirname(path) {
    var result = splitPath(path);
    var root = result[0];
    var dir = result[1];
    if (!root && !dir) {
        // No dirname whatsoever
        return '.';
    }
    if (dir) {
        // It has a dirname, strip trailing slash
        dir = dir.substr(0, dir.length - 1);
    }
    return root + dir;
}
exports.dirname = dirname;
/** JSDoc */
function basename(path, ext) {
    var f = splitPath(path)[2];
    if (ext && f.substr(ext.length * -1) === ext) {
        f = f.substr(0, f.length - ext.length);
    }
    return f;
}
exports.basename = basename;
//# sourceMappingURL=path.js.map

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// static/js/main.60a83b61.js